(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2888],{

/***/ 56811:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "UH": function() { return /* reexport */ Replay; },
  "S1": function() { return /* reexport */ client_init; },
  "av": function() { return /* reexport */ setUser; }
});

// UNUSED EXPORTS: Breadcrumbs, BrowserClient, BrowserTracing, Dedupe, ErrorBoundary, FunctionToString, GlobalHandlers, HttpContext, Hub, InboundFilters, Integrations, LinkedErrors, Profiler, SDK_VERSION, Scope, TryCatch, WINDOW, addBreadcrumb, addGlobalEventProcessor, captureEvent, captureException, captureMessage, chromeStackLineParser, close, configureScope, createReduxEnhancer, createTransport, defaultIntegrations, defaultStackLineParsers, defaultStackParser, eventFromException, eventFromMessage, flush, forceLoad, geckoStackLineParser, getCurrentHub, getHubFromCarrier, lastEventId, makeFetchTransport, makeMain, makeXHRTransport, nextRouterInstrumentation, onLoad, opera10StackLineParser, opera11StackLineParser, reactRouterV3Instrumentation, reactRouterV4Instrumentation, reactRouterV5Instrumentation, reactRouterV6Instrumentation, setContext, setExtra, setExtras, setTag, setTags, showReportDialog, startTransaction, useProfiler, winjsStackLineParser, withErrorBoundary, withProfiler, withScope, withSentryReactRouterV6Routing, withSentryRouting, wrap, wrapCreateBrowserRouter, wrapUseRoutes

// NAMESPACE OBJECT: ../../.yarn/cache/@sentry-core-npm-7.32.1-f8255c7634-74ce787414.zip/node_modules/@sentry/core/esm/integrations/index.js
var integrations_namespaceObject = {};
__webpack_require__.r(integrations_namespaceObject);
__webpack_require__.d(integrations_namespaceObject, {
  "FunctionToString": function() { return FunctionToString; },
  "InboundFilters": function() { return InboundFilters; }
});

// NAMESPACE OBJECT: ../../.yarn/cache/@sentry-browser-npm-7.32.1-b5270a3b99-279b2bfb32.zip/node_modules/@sentry/browser/esm/integrations/index.js
var esm_integrations_namespaceObject = {};
__webpack_require__.r(esm_integrations_namespaceObject);
__webpack_require__.d(esm_integrations_namespaceObject, {
  "Breadcrumbs": function() { return Breadcrumbs; },
  "Dedupe": function() { return Dedupe; },
  "GlobalHandlers": function() { return GlobalHandlers; },
  "HttpContext": function() { return HttpContext; },
  "LinkedErrors": function() { return LinkedErrors; },
  "TryCatch": function() { return TryCatch; }
});

;// CONCATENATED MODULE: ../../.yarn/cache/@sentry-utils-npm-7.32.1-c99d3811fa-1b0d82cbcc.zip/node_modules/@sentry/utils/esm/buildPolyfills/_optionalChain.js
/**
 * Polyfill for the optional chain operator, `?.`, given previous conversion of the expression into an array of values,
 * descriptors, and functions.
 *
 * Adapted from Sucrase (https://github.com/alangpierce/sucrase)
 * See https://github.com/alangpierce/sucrase/blob/265887868966917f3b924ce38dfad01fbab1329f/src/transformers/OptionalChainingNullishTransformer.ts#L15
 *
 * @param ops Array result of expression conversion
 * @returns The value of the expression
 */
function _optionalChain(ops) {
  let lastAccessLHS = undefined;
  let value = ops[0];
  let i = 1;
  while (i < ops.length) {
    const op = ops[i] ;
    const fn = ops[i + 1] ;
    i += 2;
    // by checking for loose equality to `null`, we catch both `null` and `undefined`
    if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) {
      // really we're meaning to return `undefined` as an actual value here, but it saves bytes not to write it
      return;
    }
    if (op === 'access' || op === 'optionalAccess') {
      lastAccessLHS = value;
      value = fn(value);
    } else if (op === 'call' || op === 'optionalCall') {
      value = fn((...args) => (value ).call(lastAccessLHS, ...args));
      lastAccessLHS = undefined;
    }
  }
  return value;
}

// Sucrase version
// function _optionalChain(ops) {
//   let lastAccessLHS = undefined;
//   let value = ops[0];
//   let i = 1;
//   while (i < ops.length) {
//     const op = ops[i];
//     const fn = ops[i + 1];
//     i += 2;
//     if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) {
//       return undefined;
//     }
//     if (op === 'access' || op === 'optionalAccess') {
//       lastAccessLHS = value;
//       value = fn(value);
//     } else if (op === 'call' || op === 'optionalCall') {
//       value = fn((...args) => value.call(lastAccessLHS, ...args));
//       lastAccessLHS = undefined;
//     }
//   }
//   return value;
// }


//# sourceMappingURL=_optionalChain.js.map

;// CONCATENATED MODULE: ../../.yarn/cache/@sentry-utils-npm-7.32.1-c99d3811fa-1b0d82cbcc.zip/node_modules/@sentry/utils/esm/path.js
// Slightly modified (no IE8 support, ES6) and transcribed to TypeScript
// https://raw.githubusercontent.com/calvinmetcalf/rollup-plugin-node-builtins/master/src/es6/path.js

/** JSDoc */
function normalizeArray(parts, allowAboveRoot) {
  // if the path tries to go above the root, `up` ends up > 0
  let up = 0;
  for (let i = parts.length - 1; i >= 0; i--) {
    const last = parts[i];
    if (last === '.') {
      parts.splice(i, 1);
    } else if (last === '..') {
      parts.splice(i, 1);
      up++;
    } else if (up) {
      parts.splice(i, 1);
      up--;
    }
  }

  // if the path is allowed to go above the root, restore leading ..s
  if (allowAboveRoot) {
    for (; up--; up) {
      parts.unshift('..');
    }
  }

  return parts;
}

// Split a filename into [root, dir, basename, ext], unix version
// 'root' is just a slash, or nothing.
const splitPathRe = /^(\/?|)([\s\S]*?)((?:\.{1,2}|[^/]+?|)(\.[^./]*|))(?:[/]*)$/;
/** JSDoc */
function splitPath(filename) {
  const parts = splitPathRe.exec(filename);
  return parts ? parts.slice(1) : [];
}

// path.resolve([from ...], to)
// posix version
/** JSDoc */
function resolve(...args) {
  let resolvedPath = '';
  let resolvedAbsolute = false;

  for (let i = args.length - 1; i >= -1 && !resolvedAbsolute; i--) {
    const path = i >= 0 ? args[i] : '/';

    // Skip empty entries
    if (!path) {
      continue;
    }

    resolvedPath = `${path}/${resolvedPath}`;
    resolvedAbsolute = path.charAt(0) === '/';
  }

  // At this point the path should be resolved to a full absolute path, but
  // handle relative paths to be safe (might happen when process.cwd() fails)

  // Normalize the path
  resolvedPath = normalizeArray(
    resolvedPath.split('/').filter(p => !!p),
    !resolvedAbsolute,
  ).join('/');

  return (resolvedAbsolute ? '/' : '') + resolvedPath || '.';
}

/** JSDoc */
function trim(arr) {
  let start = 0;
  for (; start < arr.length; start++) {
    if (arr[start] !== '') {
      break;
    }
  }

  let end = arr.length - 1;
  for (; end >= 0; end--) {
    if (arr[end] !== '') {
      break;
    }
  }

  if (start > end) {
    return [];
  }
  return arr.slice(start, end - start + 1);
}

// path.relative(from, to)
// posix version
/** JSDoc */
function relative(from, to) {
  /* eslint-disable no-param-reassign */
  from = resolve(from).slice(1);
  to = resolve(to).slice(1);
  /* eslint-enable no-param-reassign */

  const fromParts = trim(from.split('/'));
  const toParts = trim(to.split('/'));

  const length = Math.min(fromParts.length, toParts.length);
  let samePartsLength = length;
  for (let i = 0; i < length; i++) {
    if (fromParts[i] !== toParts[i]) {
      samePartsLength = i;
      break;
    }
  }

  let outputParts = [];
  for (let i = samePartsLength; i < fromParts.length; i++) {
    outputParts.push('..');
  }

  outputParts = outputParts.concat(toParts.slice(samePartsLength));

  return outputParts.join('/');
}

// path.normalize(path)
// posix version
/** JSDoc */
function normalizePath(path) {
  const isPathAbsolute = isAbsolute(path);
  const trailingSlash = path.slice(-1) === '/';

  // Normalize the path
  let normalizedPath = normalizeArray(
    path.split('/').filter(p => !!p),
    !isPathAbsolute,
  ).join('/');

  if (!normalizedPath && !isPathAbsolute) {
    normalizedPath = '.';
  }
  if (normalizedPath && trailingSlash) {
    normalizedPath += '/';
  }

  return (isPathAbsolute ? '/' : '') + normalizedPath;
}

// posix version
/** JSDoc */
function isAbsolute(path) {
  return path.charAt(0) === '/';
}

// posix version
/** JSDoc */
function join(...args) {
  return normalizePath(args.join('/'));
}

/** JSDoc */
function dirname(path) {
  const result = splitPath(path);
  const root = result[0];
  let dir = result[1];

  if (!root && !dir) {
    // No dirname whatsoever
    return '.';
  }

  if (dir) {
    // It has a dirname, strip trailing slash
    dir = dir.slice(0, dir.length - 1);
  }

  return root + dir;
}

/** JSDoc */
function basename(path, ext) {
  let f = splitPath(path)[2];
  if (ext && f.slice(ext.length * -1) === ext) {
    f = f.slice(0, f.length - ext.length);
  }
  return f;
}


//# sourceMappingURL=path.js.map

;// CONCATENATED MODULE: ../../.yarn/cache/@sentry-integrations-npm-7.32.1-7220f5fb15-8cd7071f74.zip/node_modules/@sentry/integrations/esm/rewriteframes.js


/** Rewrite event frames paths */
class RewriteFrames  {
  /**
   * @inheritDoc
   */
   static __initStatic() {this.id = 'RewriteFrames';}

  /**
   * @inheritDoc
   */
   __init() {this.name = RewriteFrames.id;}

  /**
   * @inheritDoc
   */

  /**
   * @inheritDoc
   */
    __init2() {this._prefix = 'app:///';}

  /**
   * @inheritDoc
   */
   constructor(options = {}) {RewriteFrames.prototype.__init.call(this);RewriteFrames.prototype.__init2.call(this);RewriteFrames.prototype.__init3.call(this);
    if (options.root) {
      this._root = options.root;
    }
    if (options.prefix) {
      this._prefix = options.prefix;
    }
    if (options.iteratee) {
      this._iteratee = options.iteratee;
    }
  }

  /**
   * @inheritDoc
   */
   setupOnce(addGlobalEventProcessor, getCurrentHub) {
    addGlobalEventProcessor(event => {
      const self = getCurrentHub().getIntegration(RewriteFrames);
      if (self) {
        return self.process(event);
      }
      return event;
    });
  }

  /** JSDoc */
   process(originalEvent) {
    let processedEvent = originalEvent;

    if (originalEvent.exception && Array.isArray(originalEvent.exception.values)) {
      processedEvent = this._processExceptionsEvent(processedEvent);
    }

    return processedEvent;
  }

  /**
   * @inheritDoc
   */
    __init3() {this._iteratee = (frame) => {
    if (!frame.filename) {
      return frame;
    }
    // Check if the frame filename begins with `/` or a Windows-style prefix such as `C:\`
    const isWindowsFrame = /^[A-Z]:\\/.test(frame.filename);
    const startsWithSlash = /^\//.test(frame.filename);
    if (isWindowsFrame || startsWithSlash) {
      const filename = isWindowsFrame
        ? frame.filename
            .replace(/^[A-Z]:/, '') // remove Windows-style prefix
            .replace(/\\/g, '/') // replace all `\\` instances with `/`
        : frame.filename;
      const base = this._root ? relative(this._root, filename) : basename(filename);
      frame.filename = `${this._prefix}${base}`;
    }
    return frame;
  };}

  /** JSDoc */
   _processExceptionsEvent(event) {
    try {
      return {
        ...event,
        exception: {
          ...event.exception,
          // The check for this is performed inside `process` call itself, safe to skip here
          // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
          values: event.exception.values.map(value => ({
            ...value,
            ...(value.stacktrace && { stacktrace: this._processStacktrace(value.stacktrace) }),
          })),
        },
      };
    } catch (_oO) {
      return event;
    }
  }

  /** JSDoc */
   _processStacktrace(stacktrace) {
    return {
      ...stacktrace,
      frames: stacktrace && stacktrace.frames && stacktrace.frames.map(f => this._iteratee(f)),
    };
  }
} RewriteFrames.__initStatic();


//# sourceMappingURL=rewriteframes.js.map

;// CONCATENATED MODULE: ../../.yarn/cache/@sentry-core-npm-7.32.1-f8255c7634-74ce787414.zip/node_modules/@sentry/core/esm/version.js
const SDK_VERSION = '7.32.1';


//# sourceMappingURL=version.js.map

// EXTERNAL MODULE: ../../.yarn/cache/@sentry-utils-npm-7.32.1-c99d3811fa-1b0d82cbcc.zip/node_modules/@sentry/utils/esm/logger.js
var esm_logger = __webpack_require__(23680);
// EXTERNAL MODULE: ../../.yarn/cache/@sentry-utils-npm-7.32.1-c99d3811fa-1b0d82cbcc.zip/node_modules/@sentry/utils/esm/misc.js
var misc = __webpack_require__(3528);
// EXTERNAL MODULE: ../../.yarn/cache/@sentry-utils-npm-7.32.1-c99d3811fa-1b0d82cbcc.zip/node_modules/@sentry/utils/esm/string.js
var string = __webpack_require__(58298);
;// CONCATENATED MODULE: ../../.yarn/cache/@sentry-core-npm-7.32.1-f8255c7634-74ce787414.zip/node_modules/@sentry/core/esm/integrations/inboundfilters.js


// "Script error." is hard coded into browsers for errors that it can't read.
// this is the result of a script being pulled in from an external domain and CORS.
const DEFAULT_IGNORE_ERRORS = [/^Script error\.?$/, /^Javascript error: Script error\.? on line 0$/];

/** Options for the InboundFilters integration */

/** Inbound filters configurable by the user */
class InboundFilters  {
  /**
   * @inheritDoc
   */
   static __initStatic() {this.id = 'InboundFilters';}

  /**
   * @inheritDoc
   */
   __init() {this.name = InboundFilters.id;}

   constructor(  _options = {}) {this._options = _options;InboundFilters.prototype.__init.call(this);}

  /**
   * @inheritDoc
   */
   setupOnce(addGlobalEventProcessor, getCurrentHub) {
    const eventProcess = (event) => {
      const hub = getCurrentHub();
      if (hub) {
        const self = hub.getIntegration(InboundFilters);
        if (self) {
          const client = hub.getClient();
          const clientOptions = client ? client.getOptions() : {};
          const options = _mergeOptions(self._options, clientOptions);
          return _shouldDropEvent(event, options) ? null : event;
        }
      }
      return event;
    };

    eventProcess.id = this.name;
    addGlobalEventProcessor(eventProcess);
  }
} InboundFilters.__initStatic();

/** JSDoc */
function _mergeOptions(
  internalOptions = {},
  clientOptions = {},
) {
  return {
    allowUrls: [...(internalOptions.allowUrls || []), ...(clientOptions.allowUrls || [])],
    denyUrls: [...(internalOptions.denyUrls || []), ...(clientOptions.denyUrls || [])],
    ignoreErrors: [
      ...(internalOptions.ignoreErrors || []),
      ...(clientOptions.ignoreErrors || []),
      ...DEFAULT_IGNORE_ERRORS,
    ],
    ignoreInternal: internalOptions.ignoreInternal !== undefined ? internalOptions.ignoreInternal : true,
  };
}

/** JSDoc */
function _shouldDropEvent(event, options) {
  if (options.ignoreInternal && _isSentryError(event)) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
      esm_logger/* logger.warn */.kg.warn(`Event dropped due to being internal Sentry Error.\nEvent: ${(0,misc/* getEventDescription */.jH)(event)}`);
    return true;
  }
  if (_isIgnoredError(event, options.ignoreErrors)) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
      esm_logger/* logger.warn */.kg.warn(
        `Event dropped due to being matched by \`ignoreErrors\` option.\nEvent: ${(0,misc/* getEventDescription */.jH)(event)}`,
      );
    return true;
  }
  if (_isDeniedUrl(event, options.denyUrls)) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
      esm_logger/* logger.warn */.kg.warn(
        `Event dropped due to being matched by \`denyUrls\` option.\nEvent: ${(0,misc/* getEventDescription */.jH)(
          event,
        )}.\nUrl: ${_getEventFilterUrl(event)}`,
      );
    return true;
  }
  if (!_isAllowedUrl(event, options.allowUrls)) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
      esm_logger/* logger.warn */.kg.warn(
        `Event dropped due to not being matched by \`allowUrls\` option.\nEvent: ${(0,misc/* getEventDescription */.jH)(
          event,
        )}.\nUrl: ${_getEventFilterUrl(event)}`,
      );
    return true;
  }
  return false;
}

function _isIgnoredError(event, ignoreErrors) {
  if (!ignoreErrors || !ignoreErrors.length) {
    return false;
  }

  return _getPossibleEventMessages(event).some(message => (0,string/* stringMatchesSomePattern */.U0)(message, ignoreErrors));
}

function _isDeniedUrl(event, denyUrls) {
  // TODO: Use Glob instead?
  if (!denyUrls || !denyUrls.length) {
    return false;
  }
  const url = _getEventFilterUrl(event);
  return !url ? false : (0,string/* stringMatchesSomePattern */.U0)(url, denyUrls);
}

function _isAllowedUrl(event, allowUrls) {
  // TODO: Use Glob instead?
  if (!allowUrls || !allowUrls.length) {
    return true;
  }
  const url = _getEventFilterUrl(event);
  return !url ? true : (0,string/* stringMatchesSomePattern */.U0)(url, allowUrls);
}

function _getPossibleEventMessages(event) {
  if (event.message) {
    return [event.message];
  }
  if (event.exception) {
    try {
      const { type = '', value = '' } = (event.exception.values && event.exception.values[0]) || {};
      return [`${value}`, `${type}: ${value}`];
    } catch (oO) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.error */.kg.error(`Cannot extract message for event ${(0,misc/* getEventDescription */.jH)(event)}`);
      return [];
    }
  }
  return [];
}

function _isSentryError(event) {
  try {
    // @ts-ignore can't be a sentry error if undefined
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return event.exception.values[0].type === 'SentryError';
  } catch (e) {
    // ignore
  }
  return false;
}

function _getLastValidUrl(frames = []) {
  for (let i = frames.length - 1; i >= 0; i--) {
    const frame = frames[i];

    if (frame && frame.filename !== '<anonymous>' && frame.filename !== '[native code]') {
      return frame.filename || null;
    }
  }

  return null;
}

function _getEventFilterUrl(event) {
  try {
    let frames;
    try {
      // @ts-ignore we only care about frames if the whole thing here is defined
      frames = event.exception.values[0].stacktrace.frames;
    } catch (e) {
      // ignore
    }
    return frames ? _getLastValidUrl(frames) : null;
  } catch (oO) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.error */.kg.error(`Cannot extract url for event ${(0,misc/* getEventDescription */.jH)(event)}`);
    return null;
  }
}


//# sourceMappingURL=inboundfilters.js.map

// EXTERNAL MODULE: ../../.yarn/cache/@sentry-utils-npm-7.32.1-c99d3811fa-1b0d82cbcc.zip/node_modules/@sentry/utils/esm/object.js
var object = __webpack_require__(71086);
;// CONCATENATED MODULE: ../../.yarn/cache/@sentry-core-npm-7.32.1-f8255c7634-74ce787414.zip/node_modules/@sentry/core/esm/integrations/functiontostring.js


let originalFunctionToString;

/** Patch toString calls to return proper name for wrapped functions */
class FunctionToString  {constructor() { FunctionToString.prototype.__init.call(this); }
  /**
   * @inheritDoc
   */
   static __initStatic() {this.id = 'FunctionToString';}

  /**
   * @inheritDoc
   */
   __init() {this.name = FunctionToString.id;}

  /**
   * @inheritDoc
   */
   setupOnce() {
    // eslint-disable-next-line @typescript-eslint/unbound-method
    originalFunctionToString = Function.prototype.toString;

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Function.prototype.toString = function ( ...args) {
      const context = (0,object/* getOriginalFunction */.HK)(this) || this;
      return originalFunctionToString.apply(context, args);
    };
  }
} FunctionToString.__initStatic();


//# sourceMappingURL=functiontostring.js.map

// EXTERNAL MODULE: ../../.yarn/cache/@sentry-core-npm-7.32.1-f8255c7634-74ce787414.zip/node_modules/@sentry/core/esm/hub.js
var esm_hub = __webpack_require__(90936);
// EXTERNAL MODULE: ../../.yarn/cache/@sentry-core-npm-7.32.1-f8255c7634-74ce787414.zip/node_modules/@sentry/core/esm/scope.js
var esm_scope = __webpack_require__(12584);
;// CONCATENATED MODULE: ../../.yarn/cache/@sentry-core-npm-7.32.1-f8255c7634-74ce787414.zip/node_modules/@sentry/core/esm/integration.js




const installedIntegrations = [];

/** Map of integrations assigned to a client */

/**
 * Remove duplicates from the given array, preferring the last instance of any duplicate. Not guaranteed to
 * preseve the order of integrations in the array.
 *
 * @private
 */
function filterDuplicates(integrations) {
  const integrationsByName = {};

  integrations.forEach(currentInstance => {
    const { name } = currentInstance;

    const existingInstance = integrationsByName[name];

    // We want integrations later in the array to overwrite earlier ones of the same type, except that we never want a
    // default instance to overwrite an existing user instance
    if (existingInstance && !existingInstance.isDefaultInstance && currentInstance.isDefaultInstance) {
      return;
    }

    integrationsByName[name] = currentInstance;
  });

  return Object.values(integrationsByName);
}

/** Gets integrations to install */
function getIntegrationsToSetup(options) {
  const defaultIntegrations = options.defaultIntegrations || [];
  const userIntegrations = options.integrations;

  // We flag default instances, so that later we can tell them apart from any user-created instances of the same class
  defaultIntegrations.forEach(integration => {
    integration.isDefaultInstance = true;
  });

  let integrations;

  if (Array.isArray(userIntegrations)) {
    integrations = [...defaultIntegrations, ...userIntegrations];
  } else if (typeof userIntegrations === 'function') {
    integrations = (0,misc/* arrayify */.lE)(userIntegrations(defaultIntegrations));
  } else {
    integrations = defaultIntegrations;
  }

  const finalIntegrations = filterDuplicates(integrations);

  // The `Debug` integration prints copies of the `event` and `hint` which will be passed to `beforeSend` or
  // `beforeSendTransaction`. It therefore has to run after all other integrations, so that the changes of all event
  // processors will be reflected in the printed values. For lack of a more elegant way to guarantee that, we therefore
  // locate it and, assuming it exists, pop it out of its current spot and shove it onto the end of the array.
  const debugIndex = finalIntegrations.findIndex(integration => integration.name === 'Debug');
  if (debugIndex !== -1) {
    const [debugInstance] = finalIntegrations.splice(debugIndex, 1);
    finalIntegrations.push(debugInstance);
  }

  return finalIntegrations;
}

/**
 * Given a list of integration instances this installs them all. When `withDefaults` is set to `true` then all default
 * integrations are added unless they were already provided before.
 * @param integrations array of integration instances
 * @param withDefault should enable default integrations
 */
function setupIntegrations(integrations) {
  const integrationIndex = {};

  integrations.forEach(integration => {
    setupIntegration(integration, integrationIndex);
  });

  return integrationIndex;
}

/** Setup a single integration.  */
function setupIntegration(integration, integrationIndex) {
  integrationIndex[integration.name] = integration;

  if (installedIntegrations.indexOf(integration.name) === -1) {
    integration.setupOnce(esm_scope/* addGlobalEventProcessor */.c, esm_hub/* getCurrentHub */.Gd);
    installedIntegrations.push(integration.name);
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.log */.kg.log(`Integration installed: ${integration.name}`);
  }
}


//# sourceMappingURL=integration.js.map

;// CONCATENATED MODULE: ../../.yarn/cache/@sentry-core-npm-7.32.1-f8255c7634-74ce787414.zip/node_modules/@sentry/core/esm/sdk.js



/** A class object that can instantiate Client objects. */

/**
 * Internal function to create a new SDK client instance. The client is
 * installed and then bound to the current scope.
 *
 * @param clientClass The client class to instantiate.
 * @param options Options to pass to the client.
 */
function initAndBind(
  clientClass,
  options,
) {
  if (options.debug === true) {
    if ((typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__)) {
      esm_logger/* logger.enable */.kg.enable();
    } else {
      // use `console.warn` rather than `logger.warn` since by non-debug bundles have all `logger.x` statements stripped
      // eslint-disable-next-line no-console
      console.warn('[Sentry] Cannot initialize SDK with `debug` option using a non-debug bundle.');
    }
  }
  const hub = (0,esm_hub/* getCurrentHub */.Gd)();
  const scope = hub.getScope();
  if (scope) {
    scope.update(options.initialScope);
  }

  const client = new clientClass(options);
  hub.bindClient(client);
}


//# sourceMappingURL=sdk.js.map

// EXTERNAL MODULE: ../../.yarn/cache/@sentry-utils-npm-7.32.1-c99d3811fa-1b0d82cbcc.zip/node_modules/@sentry/utils/esm/stacktrace.js
var stacktrace = __webpack_require__(15635);
// EXTERNAL MODULE: ../../.yarn/cache/@sentry-utils-npm-7.32.1-c99d3811fa-1b0d82cbcc.zip/node_modules/@sentry/utils/esm/supports.js
var supports = __webpack_require__(13081);
// EXTERNAL MODULE: ../../.yarn/cache/@sentry-utils-npm-7.32.1-c99d3811fa-1b0d82cbcc.zip/node_modules/@sentry/utils/esm/instrument.js
var instrument = __webpack_require__(49398);
;// CONCATENATED MODULE: ../../.yarn/cache/@sentry-utils-npm-7.32.1-c99d3811fa-1b0d82cbcc.zip/node_modules/@sentry/utils/esm/error.js
/** An error emitted by Sentry SDKs and related utilities. */
class SentryError extends Error {
  /** Display name of this error instance. */

   constructor( message, logLevel = 'warn') {
    super(message);this.message = message;
    this.name = new.target.prototype.constructor.name;
    // This sets the prototype to be `Error`, not `SentryError`. It's unclear why we do this, but commenting this line
    // out causes various (seemingly totally unrelated) playwright tests consistently time out. FYI, this makes
    // instances of `SentryError` fail `obj instanceof SentryError` checks.
    Object.setPrototypeOf(this, new.target.prototype);
    this.logLevel = logLevel;
  }
}


//# sourceMappingURL=error.js.map

;// CONCATENATED MODULE: ../../.yarn/cache/@sentry-utils-npm-7.32.1-c99d3811fa-1b0d82cbcc.zip/node_modules/@sentry/utils/esm/dsn.js


/** Regular expression used to parse a Dsn. */
const DSN_REGEX = /^(?:(\w+):)\/\/(?:(\w+)(?::(\w+)?)?@)([\w.-]+)(?::(\d+))?\/(.+)/;

function isValidProtocol(protocol) {
  return protocol === 'http' || protocol === 'https';
}

/**
 * Renders the string representation of this Dsn.
 *
 * By default, this will render the public representation without the password
 * component. To get the deprecated private representation, set `withPassword`
 * to true.
 *
 * @param withPassword When set to true, the password will be included.
 */
function dsn_dsnToString(dsn, withPassword = false) {
  const { host, path, pass, port, projectId, protocol, publicKey } = dsn;
  return (
    `${protocol}://${publicKey}${withPassword && pass ? `:${pass}` : ''}` +
    `@${host}${port ? `:${port}` : ''}/${path ? `${path}/` : path}${projectId}`
  );
}

/**
 * Parses a Dsn from a given string.
 *
 * @param str A Dsn as string
 * @returns Dsn as DsnComponents
 */
function dsnFromString(str) {
  const match = DSN_REGEX.exec(str);

  if (!match) {
    throw new SentryError(`Invalid Sentry Dsn: ${str}`);
  }

  const [protocol, publicKey, pass = '', host, port = '', lastPath] = match.slice(1);
  let path = '';
  let projectId = lastPath;

  const split = projectId.split('/');
  if (split.length > 1) {
    path = split.slice(0, -1).join('/');
    projectId = split.pop() ;
  }

  if (projectId) {
    const projectMatch = projectId.match(/^\d+/);
    if (projectMatch) {
      projectId = projectMatch[0];
    }
  }

  return dsnFromComponents({ host, pass, path, projectId, port, protocol: protocol , publicKey });
}

function dsnFromComponents(components) {
  return {
    protocol: components.protocol,
    publicKey: components.publicKey || '',
    pass: components.pass || '',
    host: components.host,
    port: components.port || '',
    path: components.path || '',
    projectId: components.projectId,
  };
}

function validateDsn(dsn) {
  if (!(typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__)) {
    return;
  }

  const { port, projectId, protocol } = dsn;

  const requiredComponents = ['protocol', 'publicKey', 'host', 'projectId'];
  requiredComponents.forEach(component => {
    if (!dsn[component]) {
      throw new SentryError(`Invalid Sentry Dsn: ${component} missing`);
    }
  });

  if (!projectId.match(/^\d+$/)) {
    throw new SentryError(`Invalid Sentry Dsn: Invalid projectId ${projectId}`);
  }

  if (!isValidProtocol(protocol)) {
    throw new SentryError(`Invalid Sentry Dsn: Invalid protocol ${protocol}`);
  }

  if (port && isNaN(parseInt(port, 10))) {
    throw new SentryError(`Invalid Sentry Dsn: Invalid port ${port}`);
  }

  return true;
}

/** The Sentry Dsn, identifying a Sentry instance and project. */
function dsn_makeDsn(from) {
  const components = typeof from === 'string' ? dsnFromString(from) : dsnFromComponents(from);
  validateDsn(components);
  return components;
}


//# sourceMappingURL=dsn.js.map

// EXTERNAL MODULE: ../../.yarn/cache/@sentry-utils-npm-7.32.1-c99d3811fa-1b0d82cbcc.zip/node_modules/@sentry/utils/esm/is.js
var is = __webpack_require__(33816);
// EXTERNAL MODULE: ../../.yarn/cache/@sentry-utils-npm-7.32.1-c99d3811fa-1b0d82cbcc.zip/node_modules/@sentry/utils/esm/syncpromise.js
var syncpromise = __webpack_require__(31647);
;// CONCATENATED MODULE: ../../.yarn/cache/@sentry-utils-npm-7.32.1-c99d3811fa-1b0d82cbcc.zip/node_modules/@sentry/utils/esm/memo.js
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-explicit-any */

/**
 * Helper to decycle json objects
 */
function memoBuilder() {
  const hasWeakSet = typeof WeakSet === 'function';
  const inner = hasWeakSet ? new WeakSet() : [];
  function memoize(obj) {
    if (hasWeakSet) {
      if (inner.has(obj)) {
        return true;
      }
      inner.add(obj);
      return false;
    }
    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for (let i = 0; i < inner.length; i++) {
      const value = inner[i];
      if (value === obj) {
        return true;
      }
    }
    inner.push(obj);
    return false;
  }

  function unmemoize(obj) {
    if (hasWeakSet) {
      inner.delete(obj);
    } else {
      for (let i = 0; i < inner.length; i++) {
        if (inner[i] === obj) {
          inner.splice(i, 1);
          break;
        }
      }
    }
  }
  return [memoize, unmemoize];
}


//# sourceMappingURL=memo.js.map

;// CONCATENATED MODULE: ../../.yarn/cache/@sentry-utils-npm-7.32.1-c99d3811fa-1b0d82cbcc.zip/node_modules/@sentry/utils/esm/normalize.js





/**
 * Recursively normalizes the given object.
 *
 * - Creates a copy to prevent original input mutation
 * - Skips non-enumerable properties
 * - When stringifying, calls `toJSON` if implemented
 * - Removes circular references
 * - Translates non-serializable values (`undefined`/`NaN`/functions) to serializable format
 * - Translates known global objects/classes to a string representations
 * - Takes care of `Error` object serialization
 * - Optionally limits depth of final output
 * - Optionally limits number of properties/elements included in any single object/array
 *
 * @param input The object to be normalized.
 * @param depth The max depth to which to normalize the object. (Anything deeper stringified whole.)
 * @param maxProperties The max number of elements or properties to be included in any single array or
 * object in the normallized output.
 * @returns A normalized version of the object, or `"**non-serializable**"` if any errors are thrown during normalization.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function normalize(input, depth = +Infinity, maxProperties = +Infinity) {
  try {
    // since we're at the outermost level, we don't provide a key
    return visit('', input, depth, maxProperties);
  } catch (err) {
    return { ERROR: `**non-serializable** (${err})` };
  }
}

/** JSDoc */
function normalizeToSize(
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  object,
  // Default Node.js REPL depth
  depth = 3,
  // 100kB, as 200kB is max payload size, so half sounds reasonable
  maxSize = 100 * 1024,
) {
  const normalized = normalize(object, depth);

  if (jsonSize(normalized) > maxSize) {
    return normalizeToSize(object, depth - 1, maxSize);
  }

  return normalized ;
}

/**
 * Visits a node to perform normalization on it
 *
 * @param key The key corresponding to the given node
 * @param value The node to be visited
 * @param depth Optional number indicating the maximum recursion depth
 * @param maxProperties Optional maximum number of properties/elements included in any single object/array
 * @param memo Optional Memo class handling decycling
 */
function visit(
  key,
  value,
  depth = +Infinity,
  maxProperties = +Infinity,
  memo = memoBuilder(),
) {
  const [memoize, unmemoize] = memo;

  // Get the simple cases out of the way first
  if (value === null || (['number', 'boolean', 'string'].includes(typeof value) && !(0,is/* isNaN */.i2)(value))) {
    return value ;
  }

  const stringified = stringifyValue(key, value);

  // Anything we could potentially dig into more (objects or arrays) will have come back as `"[object XXXX]"`.
  // Everything else will have already been serialized, so if we don't see that pattern, we're done.
  if (!stringified.startsWith('[object ')) {
    return stringified;
  }

  // From here on, we can assert that `value` is either an object or an array.

  // Do not normalize objects that we know have already been normalized. As a general rule, the
  // "__sentry_skip_normalization__" property should only be used sparingly and only should only be set on objects that
  // have already been normalized.
  if ((value )['__sentry_skip_normalization__']) {
    return value ;
  }

  // We're also done if we've reached the max depth
  if (depth === 0) {
    // At this point we know `serialized` is a string of the form `"[object XXXX]"`. Clean it up so it's just `"[XXXX]"`.
    return stringified.replace('object ', '');
  }

  // If we've already visited this branch, bail out, as it's circular reference. If not, note that we're seeing it now.
  if (memoize(value)) {
    return '[Circular ~]';
  }

  // If the value has a `toJSON` method, we call it to extract more information
  const valueWithToJSON = value ;
  if (valueWithToJSON && typeof valueWithToJSON.toJSON === 'function') {
    try {
      const jsonValue = valueWithToJSON.toJSON();
      // We need to normalize the return value of `.toJSON()` in case it has circular references
      return visit('', jsonValue, depth - 1, maxProperties, memo);
    } catch (err) {
      // pass (The built-in `toJSON` failed, but we can still try to do it ourselves)
    }
  }

  // At this point we know we either have an object or an array, we haven't seen it before, and we're going to recurse
  // because we haven't yet reached the max depth. Create an accumulator to hold the results of visiting each
  // property/entry, and keep track of the number of items we add to it.
  const normalized = (Array.isArray(value) ? [] : {}) ;
  let numAdded = 0;

  // Before we begin, convert`Error` and`Event` instances into plain objects, since some of each of their relevant
  // properties are non-enumerable and otherwise would get missed.
  const visitable = (0,object/* convertToPlainObject */.Sh)(value );

  for (const visitKey in visitable) {
    // Avoid iterating over fields in the prototype if they've somehow been exposed to enumeration.
    if (!Object.prototype.hasOwnProperty.call(visitable, visitKey)) {
      continue;
    }

    if (numAdded >= maxProperties) {
      normalized[visitKey] = '[MaxProperties ~]';
      break;
    }

    // Recursively visit all the child nodes
    const visitValue = visitable[visitKey];
    normalized[visitKey] = visit(visitKey, visitValue, depth - 1, maxProperties, memo);

    numAdded++;
  }

  // Once we've visited all the branches, remove the parent from memo storage
  unmemoize(value);

  // Return accumulated values
  return normalized;
}

/**
 * Stringify the given value. Handles various known special values and types.
 *
 * Not meant to be used on simple primitives which already have a string representation, as it will, for example, turn
 * the number 1231 into "[Object Number]", nor on `null`, as it will throw.
 *
 * @param value The value to stringify
 * @returns A stringified representation of the given value
 */
function stringifyValue(
  key,
  // this type is a tiny bit of a cheat, since this function does handle NaN (which is technically a number), but for
  // our internal use, it'll do
  value,
) {
  try {
    if (key === 'domain' && value && typeof value === 'object' && (value )._events) {
      return '[Domain]';
    }

    if (key === 'domainEmitter') {
      return '[DomainEmitter]';
    }

    // It's safe to use `global`, `window`, and `document` here in this manner, as we are asserting using `typeof` first
    // which won't throw if they are not present.

    if (typeof __webpack_require__.g !== 'undefined' && value === __webpack_require__.g) {
      return '[Global]';
    }

    // eslint-disable-next-line no-restricted-globals
    if (typeof window !== 'undefined' && value === window) {
      return '[Window]';
    }

    // eslint-disable-next-line no-restricted-globals
    if (typeof document !== 'undefined' && value === document) {
      return '[Document]';
    }

    // React's SyntheticEvent thingy
    if ((0,is/* isSyntheticEvent */.Cy)(value)) {
      return '[SyntheticEvent]';
    }

    if (typeof value === 'number' && value !== value) {
      return '[NaN]';
    }

    // this catches `undefined` (but not `null`, which is a primitive and can be serialized on its own)
    if (value === void 0) {
      return '[undefined]';
    }

    if (typeof value === 'function') {
      return `[Function: ${(0,stacktrace/* getFunctionName */.$P)(value)}]`;
    }

    if (typeof value === 'symbol') {
      return `[${String(value)}]`;
    }

    // stringified BigInts are indistinguishable from regular numbers, so we need to label them to avoid confusion
    if (typeof value === 'bigint') {
      return `[BigInt: ${String(value)}]`;
    }

    // Now that we've knocked out all the special cases and the primitives, all we have left are objects. Simply casting
    // them to strings means that instances of classes which haven't defined their `toStringTag` will just come out as
    // `"[object Object]"`. If we instead look at the constructor's name (which is the same as the name of the class),
    // we can make sure that only plain objects come out that way.
    return `[object ${(Object.getPrototypeOf(value) ).constructor.name}]`;
  } catch (err) {
    return `**non-serializable** (${err})`;
  }
}

/** Calculates bytes size of input string */
function utf8Length(value) {
  // eslint-disable-next-line no-bitwise
  return ~-encodeURI(value).split(/%..|./).length;
}

/** Calculates bytes size of input object */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function jsonSize(value) {
  return utf8Length(JSON.stringify(value));
}


//# sourceMappingURL=normalize.js.map

;// CONCATENATED MODULE: ../../.yarn/cache/@sentry-utils-npm-7.32.1-c99d3811fa-1b0d82cbcc.zip/node_modules/@sentry/utils/esm/envelope.js




/**
 * Creates an envelope.
 * Make sure to always explicitly provide the generic to this function
 * so that the envelope types resolve correctly.
 */
function createEnvelope(headers, items = []) {
  return [headers, items] ;
}

/**
 * Add an item to an envelope.
 * Make sure to always explicitly provide the generic to this function
 * so that the envelope types resolve correctly.
 */
function addItemToEnvelope(envelope, newItem) {
  const [headers, items] = envelope;
  return [headers, [...items, newItem]] ;
}

/**
 * Convenience function to loop through the items and item types of an envelope.
 * (This function was mostly created because working with envelope types is painful at the moment)
 */
function forEachEnvelopeItem(
  envelope,
  callback,
) {
  const envelopeItems = envelope[1];
  envelopeItems.forEach((envelopeItem) => {
    const envelopeItemType = envelopeItem[0].type;
    callback(envelopeItem, envelopeItemType);
  });
}

/**
 * Encode a string to UTF8.
 */
function encodeUTF8(input, textEncoder) {
  const utf8 = textEncoder || new TextEncoder();
  return utf8.encode(input);
}

/**
 * Serializes an envelope.
 */
function serializeEnvelope(envelope, textEncoder) {
  const [envHeaders, items] = envelope;

  // Initially we construct our envelope as a string and only convert to binary chunks if we encounter binary data
  let parts = JSON.stringify(envHeaders);

  function append(next) {
    if (typeof parts === 'string') {
      parts = typeof next === 'string' ? parts + next : [encodeUTF8(parts, textEncoder), next];
    } else {
      parts.push(typeof next === 'string' ? encodeUTF8(next, textEncoder) : next);
    }
  }

  for (const item of items) {
    const [itemHeaders, payload] = item;

    append(`\n${JSON.stringify(itemHeaders)}\n`);

    if (typeof payload === 'string' || payload instanceof Uint8Array) {
      append(payload);
    } else {
      let stringifiedPayload;
      try {
        stringifiedPayload = JSON.stringify(payload);
      } catch (e) {
        // In case, despite all our efforts to keep `payload` circular-dependency-free, `JSON.strinify()` still
        // fails, we try again after normalizing it again with infinite normalization depth. This of course has a
        // performance impact but in this case a performance hit is better than throwing.
        stringifiedPayload = JSON.stringify(normalize(payload));
      }
      append(stringifiedPayload);
    }
  }

  return typeof parts === 'string' ? parts : concatBuffers(parts);
}

function concatBuffers(buffers) {
  const totalLength = buffers.reduce((acc, buf) => acc + buf.length, 0);

  const merged = new Uint8Array(totalLength);
  let offset = 0;
  for (const buffer of buffers) {
    merged.set(buffer, offset);
    offset += buffer.length;
  }

  return merged;
}

/**
 * Parses an envelope
 */
function parseEnvelope(
  env,
  textEncoder,
  textDecoder,
) {
  let buffer = typeof env === 'string' ? textEncoder.encode(env) : env;

  function readBinary(length) {
    const bin = buffer.subarray(0, length);
    // Replace the buffer with the remaining data excluding trailing newline
    buffer = buffer.subarray(length + 1);
    return bin;
  }

  function readJson() {
    let i = buffer.indexOf(0xa);
    // If we couldn't find a newline, we must have found the end of the buffer
    if (i < 0) {
      i = buffer.length;
    }

    return JSON.parse(textDecoder.decode(readBinary(i))) ;
  }

  const envelopeHeader = readJson();
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const items = [];

  while (buffer.length) {
    const itemHeader = readJson();
    const binaryLength = typeof itemHeader.length === 'number' ? itemHeader.length : undefined;

    items.push([itemHeader, binaryLength ? readBinary(binaryLength) : readJson()]);
  }

  return [envelopeHeader, items];
}

/**
 * Creates attachment envelope items
 */
function createAttachmentEnvelopeItem(
  attachment,
  textEncoder,
) {
  const buffer = typeof attachment.data === 'string' ? encodeUTF8(attachment.data, textEncoder) : attachment.data;

  return [
    (0,object/* dropUndefinedKeys */.Jr)({
      type: 'attachment',
      length: buffer.length,
      filename: attachment.filename,
      content_type: attachment.contentType,
      attachment_type: attachment.attachmentType,
    }),
    buffer,
  ];
}

const ITEM_TYPE_TO_DATA_CATEGORY_MAP = {
  session: 'session',
  sessions: 'session',
  attachment: 'attachment',
  transaction: 'transaction',
  event: 'error',
  client_report: 'internal',
  user_report: 'default',
  profile: 'profile',
  replay_event: 'replay',
  replay_recording: 'replay',
};

/**
 * Maps the type of an envelope item to a data category.
 */
function envelopeItemTypeToDataCategory(type) {
  return ITEM_TYPE_TO_DATA_CATEGORY_MAP[type];
}

/** Extracts the minimal SDK info from from the metadata or an events */
function getSdkMetadataForEnvelopeHeader(metadataOrEvent) {
  if (!metadataOrEvent || !metadataOrEvent.sdk) {
    return;
  }
  const { name, version } = metadataOrEvent.sdk;
  return { name, version };
}

/**
 * Creates event envelope headers, based on event, sdk info and tunnel
 * Note: This function was extracted from the core package to make it available in Replay
 */
function createEventEnvelopeHeaders(
  event,
  sdkInfo,
  tunnel,
  dsn,
) {
  const dynamicSamplingContext = event.sdkProcessingMetadata && event.sdkProcessingMetadata.dynamicSamplingContext;

  return {
    event_id: event.event_id ,
    sent_at: new Date().toISOString(),
    ...(sdkInfo && { sdk: sdkInfo }),
    ...(!!tunnel && { dsn: dsn_dsnToString(dsn) }),
    ...(event.type === 'transaction' &&
      dynamicSamplingContext && {
        trace: (0,object/* dropUndefinedKeys */.Jr)({ ...dynamicSamplingContext }),
      }),
  };
}


//# sourceMappingURL=envelope.js.map

;// CONCATENATED MODULE: ../../.yarn/cache/@sentry-core-npm-7.32.1-f8255c7634-74ce787414.zip/node_modules/@sentry/core/esm/api.js


const SENTRY_API_VERSION = '7';

/** Returns the prefix to construct Sentry ingestion API endpoints. */
function getBaseApiEndpoint(dsn) {
  const protocol = dsn.protocol ? `${dsn.protocol}:` : '';
  const port = dsn.port ? `:${dsn.port}` : '';
  return `${protocol}//${dsn.host}${port}${dsn.path ? `/${dsn.path}` : ''}/api/`;
}

/** Returns the ingest API endpoint for target. */
function _getIngestEndpoint(dsn) {
  return `${getBaseApiEndpoint(dsn)}${dsn.projectId}/envelope/`;
}

/** Returns a URL-encoded string with auth config suitable for a query string. */
function _encodedAuth(dsn, sdkInfo) {
  return (0,object/* urlEncode */._j)({
    // We send only the minimum set of required information. See
    // https://github.com/getsentry/sentry-javascript/issues/2572.
    sentry_key: dsn.publicKey,
    sentry_version: SENTRY_API_VERSION,
    ...(sdkInfo && { sentry_client: `${sdkInfo.name}/${sdkInfo.version}` }),
  });
}

/**
 * Returns the envelope endpoint URL with auth in the query string.
 *
 * Sending auth as part of the query string and not as custom HTTP headers avoids CORS preflight requests.
 */
function getEnvelopeEndpointWithUrlEncodedAuth(
  dsn,
  // TODO (v8): Remove `tunnelOrOptions` in favor of `options`, and use the substitute code below
  // options: ClientOptions = {} as ClientOptions,
  tunnelOrOptions = {} ,
) {
  // TODO (v8): Use this code instead
  // const { tunnel, _metadata = {} } = options;
  // return tunnel ? tunnel : `${_getIngestEndpoint(dsn)}?${_encodedAuth(dsn, _metadata.sdk)}`;

  const tunnel = typeof tunnelOrOptions === 'string' ? tunnelOrOptions : tunnelOrOptions.tunnel;
  const sdkInfo =
    typeof tunnelOrOptions === 'string' || !tunnelOrOptions._metadata ? undefined : tunnelOrOptions._metadata.sdk;

  return tunnel ? tunnel : `${_getIngestEndpoint(dsn)}?${_encodedAuth(dsn, sdkInfo)}`;
}

/** Returns the url to the report dialog endpoint. */
function api_getReportDialogEndpoint(
  dsnLike,
  dialogOptions

,
) {
  const dsn = makeDsn(dsnLike);
  const endpoint = `${getBaseApiEndpoint(dsn)}embed/error-page/`;

  let encodedOptions = `dsn=${dsnToString(dsn)}`;
  for (const key in dialogOptions) {
    if (key === 'dsn') {
      continue;
    }

    if (key === 'user') {
      const user = dialogOptions.user;
      if (!user) {
        continue;
      }
      if (user.name) {
        encodedOptions += `&name=${encodeURIComponent(user.name)}`;
      }
      if (user.email) {
        encodedOptions += `&email=${encodeURIComponent(user.email)}`;
      }
    } else {
      encodedOptions += `&${encodeURIComponent(key)}=${encodeURIComponent(dialogOptions[key] )}`;
    }
  }

  return `${endpoint}?${encodedOptions}`;
}


//# sourceMappingURL=api.js.map

;// CONCATENATED MODULE: ../../.yarn/cache/@sentry-core-npm-7.32.1-f8255c7634-74ce787414.zip/node_modules/@sentry/core/esm/envelope.js


/**
 * Apply SdkInfo (name, version, packages, integrations) to the corresponding event key.
 * Merge with existing data if any.
 **/
function enhanceEventWithSdkInfo(event, sdkInfo) {
  if (!sdkInfo) {
    return event;
  }
  event.sdk = event.sdk || {};
  event.sdk.name = event.sdk.name || sdkInfo.name;
  event.sdk.version = event.sdk.version || sdkInfo.version;
  event.sdk.integrations = [...(event.sdk.integrations || []), ...(sdkInfo.integrations || [])];
  event.sdk.packages = [...(event.sdk.packages || []), ...(sdkInfo.packages || [])];
  return event;
}

/** Creates an envelope from a Session */
function createSessionEnvelope(
  session,
  dsn,
  metadata,
  tunnel,
) {
  const sdkInfo = getSdkMetadataForEnvelopeHeader(metadata);
  const envelopeHeaders = {
    sent_at: new Date().toISOString(),
    ...(sdkInfo && { sdk: sdkInfo }),
    ...(!!tunnel && { dsn: dsn_dsnToString(dsn) }),
  };

  const envelopeItem =
    'aggregates' in session ? [{ type: 'sessions' }, session] : [{ type: 'session' }, session];

  return createEnvelope(envelopeHeaders, [envelopeItem]);
}

/**
 * Create an Envelope from an event.
 */
function createEventEnvelope(
  event,
  dsn,
  metadata,
  tunnel,
) {
  const sdkInfo = getSdkMetadataForEnvelopeHeader(metadata);

  /*
    Note: Due to TS, event.type may be `replay_event`, theoretically.
    In practice, we never call `createEventEnvelope` with `replay_event` type,
    and we'd have to adjut a looot of types to make this work properly.
    We want to avoid casting this around, as that could lead to bugs (e.g. when we add another type)
    So the safe choice is to really guard against the replay_event type here.
  */
  const eventType = event.type && event.type !== 'replay_event' ? event.type : 'event';

  enhanceEventWithSdkInfo(event, metadata && metadata.sdk);

  const envelopeHeaders = createEventEnvelopeHeaders(event, sdkInfo, tunnel, dsn);

  // Prevent this data (which, if it exists, was used in earlier steps in the processing pipeline) from being sent to
  // sentry. (Note: Our use of this property comes and goes with whatever we might be debugging, whatever hacks we may
  // have temporarily added, etc. Even if we don't happen to be using it at some point in the future, let's not get rid
  // of this `delete`, lest we miss putting it back in the next time the property is in use.)
  delete event.sdkProcessingMetadata;

  const eventItem = [{ type: eventType }, event];
  return createEnvelope(envelopeHeaders, [eventItem]);
}


//# sourceMappingURL=envelope.js.map

// EXTERNAL MODULE: ../../.yarn/cache/@sentry-core-npm-7.32.1-f8255c7634-74ce787414.zip/node_modules/@sentry/core/esm/session.js
var esm_session = __webpack_require__(87943);
// EXTERNAL MODULE: ../../.yarn/cache/@sentry-utils-npm-7.32.1-c99d3811fa-1b0d82cbcc.zip/node_modules/@sentry/utils/esm/time.js
var esm_time = __webpack_require__(27447);
;// CONCATENATED MODULE: ../../.yarn/cache/@sentry-core-npm-7.32.1-f8255c7634-74ce787414.zip/node_modules/@sentry/core/esm/utils/prepareEvent.js



/**
 * Adds common information to events.
 *
 * The information includes release and environment from `options`,
 * breadcrumbs and context (extra, tags and user) from the scope.
 *
 * Information that is already present in the event is never overwritten. For
 * nested objects, such as the context, keys are merged.
 *
 * Note: This also triggers callbacks for `addGlobalEventProcessor`, but not `beforeSend`.
 *
 * @param event The original event.
 * @param hint May contain additional information about the original exception.
 * @param scope A scope containing event metadata.
 * @returns A new event with more information.
 * @hidden
 */
function prepareEvent(
  options,
  event,
  hint,
  scope,
) {
  const { normalizeDepth = 3, normalizeMaxBreadth = 1000 } = options;
  const prepared = {
    ...event,
    event_id: event.event_id || hint.event_id || (0,misc/* uuid4 */.DM)(),
    timestamp: event.timestamp || (0,esm_time/* dateTimestampInSeconds */.yW)(),
  };

  applyClientOptions(prepared, options);
  applyIntegrationsMetadata(
    prepared,
    options.integrations.map(i => i.name),
  );

  // If we have scope given to us, use it as the base for further modifications.
  // This allows us to prevent unnecessary copying of data if `captureContext` is not provided.
  let finalScope = scope;
  if (hint.captureContext) {
    finalScope = esm_scope/* Scope.clone */.s.clone(finalScope).update(hint.captureContext);
  }

  // We prepare the result here with a resolved Event.
  let result = (0,syncpromise/* resolvedSyncPromise */.WD)(prepared);

  // This should be the last thing called, since we want that
  // {@link Hub.addEventProcessor} gets the finished prepared event.
  //
  // We need to check for the existence of `finalScope.getAttachments`
  // because `getAttachments` can be undefined if users are using an older version
  // of `@sentry/core` that does not have the `getAttachments` method.
  // See: https://github.com/getsentry/sentry-javascript/issues/5229
  if (finalScope) {
    // Collect attachments from the hint and scope
    if (finalScope.getAttachments) {
      const attachments = [...(hint.attachments || []), ...finalScope.getAttachments()];

      if (attachments.length) {
        hint.attachments = attachments;
      }
    }

    // In case we have a hub we reassign it.
    result = finalScope.applyToEvent(prepared, hint);
  }

  return result.then(evt => {
    if (typeof normalizeDepth === 'number' && normalizeDepth > 0) {
      return normalizeEvent(evt, normalizeDepth, normalizeMaxBreadth);
    }
    return evt;
  });
}

/**
 *  Enhances event using the client configuration.
 *  It takes care of all "static" values like environment, release and `dist`,
 *  as well as truncating overly long values.
 * @param event event instance to be enhanced
 */
function applyClientOptions(event, options) {
  const { environment, release, dist, maxValueLength = 250 } = options;

  if (!('environment' in event)) {
    event.environment = 'environment' in options ? environment : 'production';
  }

  if (event.release === undefined && release !== undefined) {
    event.release = release;
  }

  if (event.dist === undefined && dist !== undefined) {
    event.dist = dist;
  }

  if (event.message) {
    event.message = (0,string/* truncate */.$G)(event.message, maxValueLength);
  }

  const exception = event.exception && event.exception.values && event.exception.values[0];
  if (exception && exception.value) {
    exception.value = (0,string/* truncate */.$G)(exception.value, maxValueLength);
  }

  const request = event.request;
  if (request && request.url) {
    request.url = (0,string/* truncate */.$G)(request.url, maxValueLength);
  }
}

/**
 * This function adds all used integrations to the SDK info in the event.
 * @param event The event that will be filled with all integrations.
 */
function applyIntegrationsMetadata(event, integrationNames) {
  if (integrationNames.length > 0) {
    event.sdk = event.sdk || {};
    event.sdk.integrations = [...(event.sdk.integrations || []), ...integrationNames];
  }
}

/**
 * Applies `normalize` function on necessary `Event` attributes to make them safe for serialization.
 * Normalized keys:
 * - `breadcrumbs.data`
 * - `user`
 * - `contexts`
 * - `extra`
 * @param event Event
 * @returns Normalized event
 */
function normalizeEvent(event, depth, maxBreadth) {
  if (!event) {
    return null;
  }

  const normalized = {
    ...event,
    ...(event.breadcrumbs && {
      breadcrumbs: event.breadcrumbs.map(b => ({
        ...b,
        ...(b.data && {
          data: normalize(b.data, depth, maxBreadth),
        }),
      })),
    }),
    ...(event.user && {
      user: normalize(event.user, depth, maxBreadth),
    }),
    ...(event.contexts && {
      contexts: normalize(event.contexts, depth, maxBreadth),
    }),
    ...(event.extra && {
      extra: normalize(event.extra, depth, maxBreadth),
    }),
  };

  // event.contexts.trace stores information about a Transaction. Similarly,
  // event.spans[] stores information about child Spans. Given that a
  // Transaction is conceptually a Span, normalization should apply to both
  // Transactions and Spans consistently.
  // For now the decision is to skip normalization of Transactions and Spans,
  // so this block overwrites the normalized event to add back the original
  // Transaction information prior to normalization.
  if (event.contexts && event.contexts.trace && normalized.contexts) {
    normalized.contexts.trace = event.contexts.trace;

    // event.contexts.trace.data may contain circular/dangerous data so we need to normalize it
    if (event.contexts.trace.data) {
      normalized.contexts.trace.data = normalize(event.contexts.trace.data, depth, maxBreadth);
    }
  }

  // event.spans[].data may contain circular/dangerous data so we need to normalize it
  if (event.spans) {
    normalized.spans = event.spans.map(span => {
      // We cannot use the spread operator here because `toJSON` on `span` is non-enumerable
      if (span.data) {
        span.data = normalize(span.data, depth, maxBreadth);
      }
      return span;
    });
  }

  return normalized;
}


//# sourceMappingURL=prepareEvent.js.map

;// CONCATENATED MODULE: ../../.yarn/cache/@sentry-core-npm-7.32.1-f8255c7634-74ce787414.zip/node_modules/@sentry/core/esm/baseclient.js







const ALREADY_SEEN_ERROR = "Not capturing exception because it's already been captured.";

/**
 * Base implementation for all JavaScript SDK clients.
 *
 * Call the constructor with the corresponding options
 * specific to the client subclass. To access these options later, use
 * {@link Client.getOptions}.
 *
 * If a Dsn is specified in the options, it will be parsed and stored. Use
 * {@link Client.getDsn} to retrieve the Dsn at any moment. In case the Dsn is
 * invalid, the constructor will throw a {@link SentryException}. Note that
 * without a valid Dsn, the SDK will not send any events to Sentry.
 *
 * Before sending an event, it is passed through
 * {@link BaseClient._prepareEvent} to add SDK information and scope data
 * (breadcrumbs and context). To add more custom information, override this
 * method and extend the resulting prepared event.
 *
 * To issue automatically created events (e.g. via instrumentation), use
 * {@link Client.captureEvent}. It will prepare the event and pass it through
 * the callback lifecycle. To issue auto-breadcrumbs, use
 * {@link Client.addBreadcrumb}.
 *
 * @example
 * class NodeClient extends BaseClient<NodeOptions> {
 *   public constructor(options: NodeOptions) {
 *     super(options);
 *   }
 *
 *   // ...
 * }
 */
class BaseClient {
  /** Options passed to the SDK. */

  /** The client Dsn, if specified in options. Without this Dsn, the SDK will be disabled. */

  /** Array of set up integrations. */
   __init() {this._integrations = {};}

  /** Indicates whether this client's integrations have been set up. */
   __init2() {this._integrationsInitialized = false;}

  /** Number of calls being processed */
   __init3() {this._numProcessing = 0;}

  /** Holds flushable  */
   __init4() {this._outcomes = {};}

  /**
   * Initializes this client instance.
   *
   * @param options Options for the client.
   */
   constructor(options) {BaseClient.prototype.__init.call(this);BaseClient.prototype.__init2.call(this);BaseClient.prototype.__init3.call(this);BaseClient.prototype.__init4.call(this);
    this._options = options;
    if (options.dsn) {
      this._dsn = dsn_makeDsn(options.dsn);
      const url = getEnvelopeEndpointWithUrlEncodedAuth(this._dsn, options);
      this._transport = options.transport({
        recordDroppedEvent: this.recordDroppedEvent.bind(this),
        ...options.transportOptions,
        url,
      });
    } else {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.warn */.kg.warn('No DSN provided, client will not do anything.');
    }
  }

  /**
   * @inheritDoc
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
   captureException(exception, hint, scope) {
    // ensure we haven't captured this very object before
    if ((0,misc/* checkOrSetAlreadyCaught */.YO)(exception)) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.log */.kg.log(ALREADY_SEEN_ERROR);
      return;
    }

    let eventId = hint && hint.event_id;

    this._process(
      this.eventFromException(exception, hint)
        .then(event => this._captureEvent(event, hint, scope))
        .then(result => {
          eventId = result;
        }),
    );

    return eventId;
  }

  /**
   * @inheritDoc
   */
   captureMessage(
    message,
    // eslint-disable-next-line deprecation/deprecation
    level,
    hint,
    scope,
  ) {
    let eventId = hint && hint.event_id;

    const promisedEvent = (0,is/* isPrimitive */.pt)(message)
      ? this.eventFromMessage(String(message), level, hint)
      : this.eventFromException(message, hint);

    this._process(
      promisedEvent
        .then(event => this._captureEvent(event, hint, scope))
        .then(result => {
          eventId = result;
        }),
    );

    return eventId;
  }

  /**
   * @inheritDoc
   */
   captureEvent(event, hint, scope) {
    // ensure we haven't captured this very object before
    if (hint && hint.originalException && (0,misc/* checkOrSetAlreadyCaught */.YO)(hint.originalException)) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.log */.kg.log(ALREADY_SEEN_ERROR);
      return;
    }

    let eventId = hint && hint.event_id;

    this._process(
      this._captureEvent(event, hint, scope).then(result => {
        eventId = result;
      }),
    );

    return eventId;
  }

  /**
   * @inheritDoc
   */
   captureSession(session) {
    if (!this._isEnabled()) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.warn */.kg.warn('SDK not enabled, will not capture session.');
      return;
    }

    if (!(typeof session.release === 'string')) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.warn */.kg.warn('Discarded session because of missing or non-string release');
    } else {
      this.sendSession(session);
      // After sending, we set init false to indicate it's not the first occurrence
      (0,esm_session/* updateSession */.CT)(session, { init: false });
    }
  }

  /**
   * @inheritDoc
   */
   getDsn() {
    return this._dsn;
  }

  /**
   * @inheritDoc
   */
   getOptions() {
    return this._options;
  }

  /**
   * @see SdkMetadata in @sentry/types
   *
   * @return The metadata of the SDK
   */
   getSdkMetadata() {
    return this._options._metadata;
  }

  /**
   * @inheritDoc
   */
   getTransport() {
    return this._transport;
  }

  /**
   * @inheritDoc
   */
   flush(timeout) {
    const transport = this._transport;
    if (transport) {
      return this._isClientDoneProcessing(timeout).then(clientFinished => {
        return transport.flush(timeout).then(transportFlushed => clientFinished && transportFlushed);
      });
    } else {
      return (0,syncpromise/* resolvedSyncPromise */.WD)(true);
    }
  }

  /**
   * @inheritDoc
   */
   close(timeout) {
    return this.flush(timeout).then(result => {
      this.getOptions().enabled = false;
      return result;
    });
  }

  /**
   * Sets up the integrations
   */
   setupIntegrations() {
    if (this._isEnabled() && !this._integrationsInitialized) {
      this._integrations = setupIntegrations(this._options.integrations);
      this._integrationsInitialized = true;
    }
  }

  /**
   * Gets an installed integration by its `id`.
   *
   * @returns The installed integration or `undefined` if no integration with that `id` was installed.
   */
   getIntegrationById(integrationId) {
    return this._integrations[integrationId];
  }

  /**
   * @inheritDoc
   */
   getIntegration(integration) {
    try {
      return (this._integrations[integration.id] ) || null;
    } catch (_oO) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.warn */.kg.warn(`Cannot retrieve integration ${integration.id} from the current Client`);
      return null;
    }
  }

  /**
   * @inheritDoc
   */
   addIntegration(integration) {
    setupIntegration(integration, this._integrations);
  }

  /**
   * @inheritDoc
   */
   sendEvent(event, hint = {}) {
    if (this._dsn) {
      let env = createEventEnvelope(event, this._dsn, this._options._metadata, this._options.tunnel);

      for (const attachment of hint.attachments || []) {
        env = addItemToEnvelope(
          env,
          createAttachmentEnvelopeItem(
            attachment,
            this._options.transportOptions && this._options.transportOptions.textEncoder,
          ),
        );
      }

      this._sendEnvelope(env);
    }
  }

  /**
   * @inheritDoc
   */
   sendSession(session) {
    if (this._dsn) {
      const env = createSessionEnvelope(session, this._dsn, this._options._metadata, this._options.tunnel);
      this._sendEnvelope(env);
    }
  }

  /**
   * @inheritDoc
   */
   recordDroppedEvent(reason, category, _event) {
    // Note: we use `event` in replay, where we overwrite this hook.

    if (this._options.sendClientReports) {
      // We want to track each category (error, transaction, session, replay_event) separately
      // but still keep the distinction between different type of outcomes.
      // We could use nested maps, but it's much easier to read and type this way.
      // A correct type for map-based implementation if we want to go that route
      // would be `Partial<Record<SentryRequestType, Partial<Record<Outcome, number>>>>`
      // With typescript 4.1 we could even use template literal types
      const key = `${reason}:${category}`;
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.log */.kg.log(`Adding outcome: "${key}"`);

      // The following works because undefined + 1 === NaN and NaN is falsy
      this._outcomes[key] = this._outcomes[key] + 1 || 1;
    }
  }

  /** Updates existing session based on the provided event */
   _updateSessionFromEvent(session, event) {
    let crashed = false;
    let errored = false;
    const exceptions = event.exception && event.exception.values;

    if (exceptions) {
      errored = true;

      for (const ex of exceptions) {
        const mechanism = ex.mechanism;
        if (mechanism && mechanism.handled === false) {
          crashed = true;
          break;
        }
      }
    }

    // A session is updated and that session update is sent in only one of the two following scenarios:
    // 1. Session with non terminal status and 0 errors + an error occurred -> Will set error count to 1 and send update
    // 2. Session with non terminal status and 1 error + a crash occurred -> Will set status crashed and send update
    const sessionNonTerminal = session.status === 'ok';
    const shouldUpdateAndSend = (sessionNonTerminal && session.errors === 0) || (sessionNonTerminal && crashed);

    if (shouldUpdateAndSend) {
      (0,esm_session/* updateSession */.CT)(session, {
        ...(crashed && { status: 'crashed' }),
        errors: session.errors || Number(errored || crashed),
      });
      this.captureSession(session);
    }
  }

  /**
   * Determine if the client is finished processing. Returns a promise because it will wait `timeout` ms before saying
   * "no" (resolving to `false`) in order to give the client a chance to potentially finish first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the client is still busy. Passing `0` (or not
   * passing anything) will make the promise wait as long as it takes for processing to finish before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if processing is already done or finishes before the timeout, and
   * `false` otherwise
   */
   _isClientDoneProcessing(timeout) {
    return new syncpromise/* SyncPromise */.cW(resolve => {
      let ticked = 0;
      const tick = 1;

      const interval = setInterval(() => {
        if (this._numProcessing == 0) {
          clearInterval(interval);
          resolve(true);
        } else {
          ticked += tick;
          if (timeout && ticked >= timeout) {
            clearInterval(interval);
            resolve(false);
          }
        }
      }, tick);
    });
  }

  /** Determines whether this SDK is enabled and a valid Dsn is present. */
   _isEnabled() {
    return this.getOptions().enabled !== false && this._dsn !== undefined;
  }

  /**
   * Adds common information to events.
   *
   * The information includes release and environment from `options`,
   * breadcrumbs and context (extra, tags and user) from the scope.
   *
   * Information that is already present in the event is never overwritten. For
   * nested objects, such as the context, keys are merged.
   *
   * @param event The original event.
   * @param hint May contain additional information about the original exception.
   * @param scope A scope containing event metadata.
   * @returns A new event with more information.
   */
   _prepareEvent(event, hint, scope) {
    const options = this.getOptions();
    return prepareEvent(options, event, hint, scope);
  }

  /**
   * Processes the event and logs an error in case of rejection
   * @param event
   * @param hint
   * @param scope
   */
   _captureEvent(event, hint = {}, scope) {
    return this._processEvent(event, hint, scope).then(
      finalEvent => {
        return finalEvent.event_id;
      },
      reason => {
        if ((typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__)) {
          // If something's gone wrong, log the error as a warning. If it's just us having used a `SentryError` for
          // control flow, log just the message (no stack) as a log-level log.
          const sentryError = reason ;
          if (sentryError.logLevel === 'log') {
            esm_logger/* logger.log */.kg.log(sentryError.message);
          } else {
            esm_logger/* logger.warn */.kg.warn(sentryError);
          }
        }
        return undefined;
      },
    );
  }

  /**
   * Processes an event (either error or message) and sends it to Sentry.
   *
   * This also adds breadcrumbs and context information to the event. However,
   * platform specific meta data (such as the User's IP address) must be added
   * by the SDK implementor.
   *
   *
   * @param event The event to send to Sentry.
   * @param hint May contain additional information about the original exception.
   * @param scope A scope containing event metadata.
   * @returns A SyncPromise that resolves with the event or rejects in case event was/will not be send.
   */
   _processEvent(event, hint, scope) {
    const options = this.getOptions();
    const { sampleRate } = options;

    if (!this._isEnabled()) {
      return (0,syncpromise/* rejectedSyncPromise */.$2)(new SentryError('SDK not enabled, will not capture event.', 'log'));
    }

    const isTransaction = isTransactionEvent(event);
    const isError = isErrorEvent(event);
    const eventType = event.type || 'error';
    const beforeSendLabel = `before send for type \`${eventType}\``;

    // 1.0 === 100% events are sent
    // 0.0 === 0% events are sent
    // Sampling for transaction happens somewhere else
    if (isError && typeof sampleRate === 'number' && Math.random() > sampleRate) {
      this.recordDroppedEvent('sample_rate', 'error', event);
      return (0,syncpromise/* rejectedSyncPromise */.$2)(
        new SentryError(
          `Discarding event because it's not included in the random sample (sampling rate = ${sampleRate})`,
          'log',
        ),
      );
    }

    const dataCategory = eventType === 'replay_event' ? 'replay' : eventType;

    return this._prepareEvent(event, hint, scope)
      .then(prepared => {
        if (prepared === null) {
          this.recordDroppedEvent('event_processor', dataCategory, event);
          throw new SentryError('An event processor returned `null`, will not send event.', 'log');
        }

        const isInternalException = hint.data && (hint.data ).__sentry__ === true;
        if (isInternalException) {
          return prepared;
        }

        const result = processBeforeSend(options, prepared, hint);
        return _validateBeforeSendResult(result, beforeSendLabel);
      })
      .then(processedEvent => {
        if (processedEvent === null) {
          this.recordDroppedEvent('before_send', dataCategory, event);
          throw new SentryError(`${beforeSendLabel} returned \`null\`, will not send event.`, 'log');
        }

        const session = scope && scope.getSession();
        if (!isTransaction && session) {
          this._updateSessionFromEvent(session, processedEvent);
        }

        // None of the Sentry built event processor will update transaction name,
        // so if the transaction name has been changed by an event processor, we know
        // it has to come from custom event processor added by a user
        const transactionInfo = processedEvent.transaction_info;
        if (isTransaction && transactionInfo && processedEvent.transaction !== event.transaction) {
          const source = 'custom';
          processedEvent.transaction_info = {
            ...transactionInfo,
            source,
            changes: [
              ...transactionInfo.changes,
              {
                source,
                // use the same timestamp as the processed event.
                timestamp: processedEvent.timestamp ,
                propagations: transactionInfo.propagations,
              },
            ],
          };
        }

        this.sendEvent(processedEvent, hint);
        return processedEvent;
      })
      .then(null, reason => {
        if (reason instanceof SentryError) {
          throw reason;
        }

        this.captureException(reason, {
          data: {
            __sentry__: true,
          },
          originalException: reason ,
        });
        throw new SentryError(
          `Event processing pipeline threw an error, original event will not be sent. Details have been sent as a new event.\nReason: ${reason}`,
        );
      });
  }

  /**
   * Occupies the client with processing and event
   */
   _process(promise) {
    this._numProcessing++;
    void promise.then(
      value => {
        this._numProcessing--;
        return value;
      },
      reason => {
        this._numProcessing--;
        return reason;
      },
    );
  }

  /**
   * @inheritdoc
   */
   _sendEnvelope(envelope) {
    if (this._transport && this._dsn) {
      this._transport.send(envelope).then(null, reason => {
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.error */.kg.error('Error while sending event:', reason);
      });
    } else {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.error */.kg.error('Transport disabled');
    }
  }

  /**
   * Clears outcomes on this client and returns them.
   */
   _clearOutcomes() {
    const outcomes = this._outcomes;
    this._outcomes = {};
    return Object.keys(outcomes).map(key => {
      const [reason, category] = key.split(':') ;
      return {
        reason,
        category,
        quantity: outcomes[key],
      };
    });
  }

  /**
   * @inheritDoc
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types

}

/**
 * Verifies that return value of configured `beforeSend` or `beforeSendTransaction` is of expected type, and returns the value if so.
 */
function _validateBeforeSendResult(
  beforeSendResult,
  beforeSendLabel,
) {
  const invalidValueError = `${beforeSendLabel} must return \`null\` or a valid event.`;
  if ((0,is/* isThenable */.J8)(beforeSendResult)) {
    return beforeSendResult.then(
      event => {
        if (!(0,is/* isPlainObject */.PO)(event) && event !== null) {
          throw new SentryError(invalidValueError);
        }
        return event;
      },
      e => {
        throw new SentryError(`${beforeSendLabel} rejected with ${e}`);
      },
    );
  } else if (!(0,is/* isPlainObject */.PO)(beforeSendResult) && beforeSendResult !== null) {
    throw new SentryError(invalidValueError);
  }
  return beforeSendResult;
}

/**
 * Process the matching `beforeSendXXX` callback.
 */
function processBeforeSend(
  options,
  event,
  hint,
) {
  const { beforeSend, beforeSendTransaction } = options;

  if (isErrorEvent(event) && beforeSend) {
    return beforeSend(event, hint);
  }

  if (isTransactionEvent(event) && beforeSendTransaction) {
    return beforeSendTransaction(event, hint);
  }

  return event;
}

function isErrorEvent(event) {
  return event.type === undefined;
}

function isTransactionEvent(event) {
  return event.type === 'transaction';
}


//# sourceMappingURL=baseclient.js.map

;// CONCATENATED MODULE: ../../.yarn/cache/@sentry-utils-npm-7.32.1-c99d3811fa-1b0d82cbcc.zip/node_modules/@sentry/utils/esm/clientreport.js



/**
 * Creates client report envelope
 * @param discarded_events An array of discard events
 * @param dsn A DSN that can be set on the header. Optional.
 */
function createClientReportEnvelope(
  discarded_events,
  dsn,
  timestamp,
) {
  const clientReportItem = [
    { type: 'client_report' },
    {
      timestamp: timestamp || (0,esm_time/* dateTimestampInSeconds */.yW)(),
      discarded_events,
    },
  ];
  return createEnvelope(dsn ? { dsn } : {}, [clientReportItem]);
}


//# sourceMappingURL=clientreport.js.map

;// CONCATENATED MODULE: ../../.yarn/cache/@sentry-browser-npm-7.32.1-b5270a3b99-279b2bfb32.zip/node_modules/@sentry/browser/esm/eventbuilder.js



/**
 * This function creates an exception from a JavaScript Error
 */
function exceptionFromError(stackParser, ex) {
  // Get the frames first since Opera can lose the stack if we touch anything else first
  const frames = parseStackFrames(stackParser, ex);

  const exception = {
    type: ex && ex.name,
    value: extractMessage(ex),
  };

  if (frames.length) {
    exception.stacktrace = { frames };
  }

  if (exception.type === undefined && exception.value === '') {
    exception.value = 'Unrecoverable error caught';
  }

  return exception;
}

/**
 * @hidden
 */
function eventFromPlainObject(
  stackParser,
  exception,
  syntheticException,
  isUnhandledRejection,
) {
  const hub = (0,esm_hub/* getCurrentHub */.Gd)();
  const client = hub.getClient();
  const normalizeDepth = client && client.getOptions().normalizeDepth;

  const event = {
    exception: {
      values: [
        {
          type: (0,is/* isEvent */.cO)(exception) ? exception.constructor.name : isUnhandledRejection ? 'UnhandledRejection' : 'Error',
          value: `Non-Error ${
            isUnhandledRejection ? 'promise rejection' : 'exception'
          } captured with keys: ${(0,object/* extractExceptionKeysForMessage */.zf)(exception)}`,
        },
      ],
    },
    extra: {
      __serialized__: normalizeToSize(exception, normalizeDepth),
    },
  };

  if (syntheticException) {
    const frames = parseStackFrames(stackParser, syntheticException);
    if (frames.length) {
      // event.exception.values[0] has been set above
      (event.exception ).values[0].stacktrace = { frames };
    }
  }

  return event;
}

/**
 * @hidden
 */
function eventFromError(stackParser, ex) {
  return {
    exception: {
      values: [exceptionFromError(stackParser, ex)],
    },
  };
}

/** Parses stack frames from an error */
function parseStackFrames(
  stackParser,
  ex,
) {
  // Access and store the stacktrace property before doing ANYTHING
  // else to it because Opera is not very good at providing it
  // reliably in other circumstances.
  const stacktrace = ex.stacktrace || ex.stack || '';

  const popSize = getPopSize(ex);

  try {
    return stackParser(stacktrace, popSize);
  } catch (e) {
    // no-empty
  }

  return [];
}

// Based on our own mapping pattern - https://github.com/getsentry/sentry/blob/9f08305e09866c8bd6d0c24f5b0aabdd7dd6c59c/src/sentry/lang/javascript/errormapping.py#L83-L108
const reactMinifiedRegexp = /Minified React error #\d+;/i;

function getPopSize(ex) {
  if (ex) {
    if (typeof ex.framesToPop === 'number') {
      return ex.framesToPop;
    }

    if (reactMinifiedRegexp.test(ex.message)) {
      return 1;
    }
  }

  return 0;
}

/**
 * There are cases where stacktrace.message is an Event object
 * https://github.com/getsentry/sentry-javascript/issues/1949
 * In this specific case we try to extract stacktrace.message.error.message
 */
function extractMessage(ex) {
  const message = ex && ex.message;
  if (!message) {
    return 'No error message';
  }
  if (message.error && typeof message.error.message === 'string') {
    return message.error.message;
  }
  return message;
}

/**
 * Creates an {@link Event} from all inputs to `captureException` and non-primitive inputs to `captureMessage`.
 * @hidden
 */
function eventFromException(
  stackParser,
  exception,
  hint,
  attachStacktrace,
) {
  const syntheticException = (hint && hint.syntheticException) || undefined;
  const event = eventFromUnknownInput(stackParser, exception, syntheticException, attachStacktrace);
  (0,misc/* addExceptionMechanism */.EG)(event); // defaults to { type: 'generic', handled: true }
  event.level = 'error';
  if (hint && hint.event_id) {
    event.event_id = hint.event_id;
  }
  return (0,syncpromise/* resolvedSyncPromise */.WD)(event);
}

/**
 * Builds and Event from a Message
 * @hidden
 */
function eventFromMessage(
  stackParser,
  message,
  // eslint-disable-next-line deprecation/deprecation
  level = 'info',
  hint,
  attachStacktrace,
) {
  const syntheticException = (hint && hint.syntheticException) || undefined;
  const event = eventFromString(stackParser, message, syntheticException, attachStacktrace);
  event.level = level;
  if (hint && hint.event_id) {
    event.event_id = hint.event_id;
  }
  return (0,syncpromise/* resolvedSyncPromise */.WD)(event);
}

/**
 * @hidden
 */
function eventFromUnknownInput(
  stackParser,
  exception,
  syntheticException,
  attachStacktrace,
  isUnhandledRejection,
) {
  let event;

  if ((0,is/* isErrorEvent */.VW)(exception ) && (exception ).error) {
    // If it is an ErrorEvent with `error` property, extract it to get actual Error
    const errorEvent = exception ;
    return eventFromError(stackParser, errorEvent.error );
  }

  // If it is a `DOMError` (which is a legacy API, but still supported in some browsers) then we just extract the name
  // and message, as it doesn't provide anything else. According to the spec, all `DOMExceptions` should also be
  // `Error`s, but that's not the case in IE11, so in that case we treat it the same as we do a `DOMError`.
  //
  // https://developer.mozilla.org/en-US/docs/Web/API/DOMError
  // https://developer.mozilla.org/en-US/docs/Web/API/DOMException
  // https://webidl.spec.whatwg.org/#es-DOMException-specialness
  if ((0,is/* isDOMError */.TX)(exception ) || (0,is/* isDOMException */.fm)(exception )) {
    const domException = exception ;

    if ('stack' in (exception )) {
      event = eventFromError(stackParser, exception );
    } else {
      const name = domException.name || ((0,is/* isDOMError */.TX)(domException) ? 'DOMError' : 'DOMException');
      const message = domException.message ? `${name}: ${domException.message}` : name;
      event = eventFromString(stackParser, message, syntheticException, attachStacktrace);
      (0,misc/* addExceptionTypeValue */.Db)(event, message);
    }
    if ('code' in domException) {
      event.tags = { ...event.tags, 'DOMException.code': `${domException.code}` };
    }

    return event;
  }
  if ((0,is/* isError */.VZ)(exception)) {
    // we have a real Error object, do nothing
    return eventFromError(stackParser, exception);
  }
  if ((0,is/* isPlainObject */.PO)(exception) || (0,is/* isEvent */.cO)(exception)) {
    // If it's a plain object or an instance of `Event` (the built-in JS kind, not this SDK's `Event` type), serialize
    // it manually. This will allow us to group events based on top-level keys which is much better than creating a new
    // group on any key/value change.
    const objectException = exception ;
    event = eventFromPlainObject(stackParser, objectException, syntheticException, isUnhandledRejection);
    (0,misc/* addExceptionMechanism */.EG)(event, {
      synthetic: true,
    });
    return event;
  }

  // If none of previous checks were valid, then it means that it's not:
  // - an instance of DOMError
  // - an instance of DOMException
  // - an instance of Event
  // - an instance of Error
  // - a valid ErrorEvent (one with an error property)
  // - a plain Object
  //
  // So bail out and capture it as a simple message:
  event = eventFromString(stackParser, exception , syntheticException, attachStacktrace);
  (0,misc/* addExceptionTypeValue */.Db)(event, `${exception}`, undefined);
  (0,misc/* addExceptionMechanism */.EG)(event, {
    synthetic: true,
  });

  return event;
}

/**
 * @hidden
 */
function eventFromString(
  stackParser,
  input,
  syntheticException,
  attachStacktrace,
) {
  const event = {
    message: input,
  };

  if (attachStacktrace && syntheticException) {
    const frames = parseStackFrames(stackParser, syntheticException);
    if (frames.length) {
      event.exception = {
        values: [{ value: input, stacktrace: { frames } }],
      };
    }
  }

  return event;
}


//# sourceMappingURL=eventbuilder.js.map

;// CONCATENATED MODULE: ../../.yarn/cache/@sentry-core-npm-7.32.1-f8255c7634-74ce787414.zip/node_modules/@sentry/core/esm/exports.js


// Note: All functions in this file are typed with a return value of `ReturnType<Hub[HUB_FUNCTION]>`,
// where HUB_FUNCTION is some method on the Hub class.
//
// This is done to make sure the top level SDK methods stay in sync with the hub methods.
// Although every method here has an explicit return type, some of them (that map to void returns) do not
// contain `return` keywords. This is done to save on bundle size, as `return` is not minifiable.

/**
 * Captures an exception event and sends it to Sentry.
 *
 * @param exception An exception-like object.
 * @param captureContext Additional scope data to apply to exception event.
 * @returns The generated eventId.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
function captureException(exception, captureContext) {
  return (0,esm_hub/* getCurrentHub */.Gd)().captureException(exception, { captureContext });
}

/**
 * Captures a message event and sends it to Sentry.
 *
 * @param message The message to send to Sentry.
 * @param Severity Define the level of the message.
 * @returns The generated eventId.
 */
function captureMessage(
  message,
  // eslint-disable-next-line deprecation/deprecation
  captureContext,
) {
  // This is necessary to provide explicit scopes upgrade, without changing the original
  // arity of the `captureMessage(message, level)` method.
  const level = typeof captureContext === 'string' ? captureContext : undefined;
  const context = typeof captureContext !== 'string' ? { captureContext } : undefined;
  return getCurrentHub().captureMessage(message, level, context);
}

/**
 * Captures a manually created event and sends it to Sentry.
 *
 * @param event The event to send to Sentry.
 * @returns The generated eventId.
 */
function captureEvent(event, hint) {
  return getCurrentHub().captureEvent(event, hint);
}

/**
 * Callback to set context information onto the scope.
 * @param callback Callback function that receives Scope.
 */
function configureScope(callback) {
  (0,esm_hub/* getCurrentHub */.Gd)().configureScope(callback);
}

/**
 * Records a new breadcrumb which will be attached to future events.
 *
 * Breadcrumbs will be added to subsequent events to provide more context on
 * user's actions prior to an error or crash.
 *
 * @param breadcrumb The breadcrumb to record.
 */
function addBreadcrumb(breadcrumb) {
  (0,esm_hub/* getCurrentHub */.Gd)().addBreadcrumb(breadcrumb);
}

/**
 * Sets context data with the given name.
 * @param name of the context
 * @param context Any kind of data. This data will be normalized.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function setContext(name, context) {
  (0,esm_hub/* getCurrentHub */.Gd)().setContext(name, context);
}

/**
 * Set an object that will be merged sent as extra data with the event.
 * @param extras Extras object to merge into current context.
 */
function setExtras(extras) {
  getCurrentHub().setExtras(extras);
}

/**
 * Set key:value that will be sent as extra data with the event.
 * @param key String of extra
 * @param extra Any kind of data. This data will be normalized.
 */
function setExtra(key, extra) {
  getCurrentHub().setExtra(key, extra);
}

/**
 * Set an object that will be merged sent as tags data with the event.
 * @param tags Tags context object to merge into current context.
 */
function setTags(tags) {
  getCurrentHub().setTags(tags);
}

/**
 * Set key:value that will be sent as tags data with the event.
 *
 * Can also be used to unset a tag, by passing `undefined`.
 *
 * @param key String key of tag
 * @param value Value of tag
 */
function setTag(key, value) {
  getCurrentHub().setTag(key, value);
}

/**
 * Updates user context information for future events.
 *
 * @param user User context object to be set in the current context. Pass `null` to unset the user.
 */
function setUser(user) {
  (0,esm_hub/* getCurrentHub */.Gd)().setUser(user);
}

/**
 * Creates a new scope with and executes the given operation within.
 * The scope is automatically removed once the operation
 * finishes or throws.
 *
 * This is essentially a convenience function for:
 *
 *     pushScope();
 *     callback();
 *     popScope();
 *
 * @param callback that will be enclosed into push/popScope.
 */
function withScope(callback) {
  (0,esm_hub/* getCurrentHub */.Gd)().withScope(callback);
}

/**
 * Starts a new `Transaction` and returns it. This is the entry point to manual tracing instrumentation.
 *
 * A tree structure can be built by adding child spans to the transaction, and child spans to other spans. To start a
 * new child span within the transaction or any span, call the respective `.startChild()` method.
 *
 * Every child span must be finished before the transaction is finished, otherwise the unfinished spans are discarded.
 *
 * The transaction must be finished with a call to its `.finish()` method, at which point the transaction with all its
 * finished child spans will be sent to Sentry.
 *
 * NOTE: This function should only be used for *manual* instrumentation. Auto-instrumentation should call
 * `startTransaction` directly on the hub.
 *
 * @param context Properties of the new `Transaction`.
 * @param customSamplingContext Information given to the transaction sampling function (along with context-dependent
 * default values). See {@link Options.tracesSampler}.
 *
 * @returns The transaction which was just started
 */
function startTransaction(
  context,
  customSamplingContext,
) {
  return getCurrentHub().startTransaction({ ...context }, customSamplingContext);
}


//# sourceMappingURL=exports.js.map

// EXTERNAL MODULE: ../../.yarn/cache/@sentry-utils-npm-7.32.1-c99d3811fa-1b0d82cbcc.zip/node_modules/@sentry/utils/esm/worldwide.js
var worldwide = __webpack_require__(62000);
;// CONCATENATED MODULE: ../../.yarn/cache/@sentry-browser-npm-7.32.1-b5270a3b99-279b2bfb32.zip/node_modules/@sentry/browser/esm/helpers.js



const helpers_WINDOW = worldwide/* GLOBAL_OBJ */.n2 ;

let ignoreOnError = 0;

/**
 * @hidden
 */
function shouldIgnoreOnError() {
  return ignoreOnError > 0;
}

/**
 * @hidden
 */
function ignoreNextOnError() {
  // onerror should trigger before setTimeout
  ignoreOnError++;
  setTimeout(() => {
    ignoreOnError--;
  });
}

/**
 * Instruments the given function and sends an event to Sentry every time the
 * function throws an exception.
 *
 * @param fn A function to wrap. It is generally safe to pass an unbound function, because the returned wrapper always
 * has a correct `this` context.
 * @returns The wrapped function.
 * @hidden
 */
function wrap(
  fn,
  options

 = {},
  before,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
) {
  // for future readers what this does is wrap a function and then create
  // a bi-directional wrapping between them.
  //
  // example: wrapped = wrap(original);
  //  original.__sentry_wrapped__ -> wrapped
  //  wrapped.__sentry_original__ -> original

  if (typeof fn !== 'function') {
    return fn;
  }

  try {
    // if we're dealing with a function that was previously wrapped, return
    // the original wrapper.
    const wrapper = fn.__sentry_wrapped__;
    if (wrapper) {
      return wrapper;
    }

    // We don't wanna wrap it twice
    if ((0,object/* getOriginalFunction */.HK)(fn)) {
      return fn;
    }
  } catch (e) {
    // Just accessing custom props in some Selenium environments
    // can cause a "Permission denied" exception (see raven-js#495).
    // Bail on wrapping and return the function as-is (defers to window.onerror).
    return fn;
  }

  /* eslint-disable prefer-rest-params */
  // It is important that `sentryWrapped` is not an arrow function to preserve the context of `this`
  const sentryWrapped = function () {
    const args = Array.prototype.slice.call(arguments);

    try {
      if (before && typeof before === 'function') {
        before.apply(this, arguments);
      }

      // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access
      const wrappedArguments = args.map((arg) => wrap(arg, options));

      // Attempt to invoke user-land function
      // NOTE: If you are a Sentry user, and you are seeing this stack frame, it
      //       means the sentry.javascript SDK caught an error invoking your application code. This
      //       is expected behavior and NOT indicative of a bug with sentry.javascript.
      return fn.apply(this, wrappedArguments);
    } catch (ex) {
      ignoreNextOnError();

      withScope((scope) => {
        scope.addEventProcessor((event) => {
          if (options.mechanism) {
            (0,misc/* addExceptionTypeValue */.Db)(event, undefined, undefined);
            (0,misc/* addExceptionMechanism */.EG)(event, options.mechanism);
          }

          event.extra = {
            ...event.extra,
            arguments: args,
          };

          return event;
        });

        captureException(ex);
      });

      throw ex;
    }
  };
  /* eslint-enable prefer-rest-params */

  // Accessing some objects may throw
  // ref: https://github.com/getsentry/sentry-javascript/issues/1168
  try {
    for (const property in fn) {
      if (Object.prototype.hasOwnProperty.call(fn, property)) {
        sentryWrapped[property] = fn[property];
      }
    }
  } catch (_oO) {} // eslint-disable-line no-empty

  // Signal that this function has been wrapped/filled already
  // for both debugging and to prevent it to being wrapped/filled twice
  (0,object/* markFunctionWrapped */.$Q)(sentryWrapped, fn);

  (0,object/* addNonEnumerableProperty */.xp)(fn, '__sentry_wrapped__', sentryWrapped);

  // Restore original function name (not all browsers allow that)
  try {
    const descriptor = Object.getOwnPropertyDescriptor(sentryWrapped, 'name') ;
    if (descriptor.configurable) {
      Object.defineProperty(sentryWrapped, 'name', {
        get() {
          return fn.name;
        },
      });
    }
    // eslint-disable-next-line no-empty
  } catch (_oO) {}

  return sentryWrapped;
}

/**
 * All properties the report dialog supports
 */


//# sourceMappingURL=helpers.js.map

// EXTERNAL MODULE: ../../.yarn/cache/@sentry-utils-npm-7.32.1-c99d3811fa-1b0d82cbcc.zip/node_modules/@sentry/utils/esm/browser.js
var browser = __webpack_require__(53287);
;// CONCATENATED MODULE: ../../.yarn/cache/@sentry-utils-npm-7.32.1-c99d3811fa-1b0d82cbcc.zip/node_modules/@sentry/utils/esm/severity.js
// Note: Ideally the `SeverityLevel` type would be derived from `validSeverityLevels`, but that would mean either
//
// a) moving `validSeverityLevels` to `@sentry/types`,
// b) moving the`SeverityLevel` type here, or
// c) importing `validSeverityLevels` from here into `@sentry/types`.
//
// Option A would make `@sentry/types` a runtime dependency of `@sentry/utils` (not good), and options B and C would
// create a circular dependency between `@sentry/types` and `@sentry/utils` (also not good). So a TODO accompanying the
// type, reminding anyone who changes it to change this list also, will have to do.

const validSeverityLevels = ['fatal', 'error', 'warning', 'log', 'info', 'debug'];

/**
 * Converts a string-based level into a member of the deprecated {@link Severity} enum.
 *
 * @deprecated `severityFromString` is deprecated. Please use `severityLevelFromString` instead.
 *
 * @param level String representation of Severity
 * @returns Severity
 */
function severityFromString(level) {
  return severityLevelFromString(level) ;
}

/**
 * Converts a string-based level into a `SeverityLevel`, normalizing it along the way.
 *
 * @param level String representation of desired `SeverityLevel`.
 * @returns The `SeverityLevel` corresponding to the given string, or 'log' if the string isn't a valid level.
 */
function severityLevelFromString(level) {
  return (level === 'warn' ? 'warning' : validSeverityLevels.includes(level) ? level : 'log') ;
}


//# sourceMappingURL=severity.js.map

;// CONCATENATED MODULE: ../../.yarn/cache/@sentry-utils-npm-7.32.1-c99d3811fa-1b0d82cbcc.zip/node_modules/@sentry/utils/esm/url.js
/**
 * Parses string form of URL into an object
 * // borrowed from https://tools.ietf.org/html/rfc3986#appendix-B
 * // intentionally using regex and not <a/> href parsing trick because React Native and other
 * // environments where DOM might not be available
 * @returns parsed URL object
 */
function parseUrl(url)

 {
  if (!url) {
    return {};
  }

  const match = url.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);

  if (!match) {
    return {};
  }

  // coerce to undefined values to empty string so we don't get 'undefined'
  const query = match[6] || '';
  const fragment = match[8] || '';
  return {
    host: match[4],
    path: match[5],
    protocol: match[2],
    relative: match[5] + query + fragment, // everything minus origin
  };
}

/**
 * Strip the query string and fragment off of a given URL or path (if present)
 *
 * @param urlPath Full URL or path, including possible query string and/or fragment
 * @returns URL or path without query string or fragment
 */
function stripUrlQueryAndFragment(urlPath) {
  // eslint-disable-next-line no-useless-escape
  return urlPath.split(/[\?#]/, 1)[0];
}

/**
 * Returns number of URL segments of a passed string URL.
 */
function getNumberOfUrlSegments(url) {
  // split at '/' or at '\/' to split regex urls correctly
  return url.split(/\\?\//).filter(s => s.length > 0 && s !== ',').length;
}


//# sourceMappingURL=url.js.map

;// CONCATENATED MODULE: ../../.yarn/cache/@sentry-browser-npm-7.32.1-b5270a3b99-279b2bfb32.zip/node_modules/@sentry/browser/esm/integrations/breadcrumbs.js




/* eslint-disable @typescript-eslint/no-unsafe-member-access */

/** JSDoc */

/** maxStringLength gets capped to prevent 100 breadcrumbs exceeding 1MB event payload size */
const MAX_ALLOWED_STRING_LENGTH = 1024;

const BREADCRUMB_INTEGRATION_ID = 'Breadcrumbs';

/**
 * Default Breadcrumbs instrumentations
 * TODO: Deprecated - with v6, this will be renamed to `Instrument`
 */
class Breadcrumbs  {
  /**
   * @inheritDoc
   */
   static __initStatic() {this.id = BREADCRUMB_INTEGRATION_ID;}

  /**
   * @inheritDoc
   */
   __init() {this.name = Breadcrumbs.id;}

  /**
   * Options of the breadcrumbs integration.
   */
  // This field is public, because we use it in the browser client to check if the `sentry` option is enabled.

  /**
   * @inheritDoc
   */
   constructor(options) {Breadcrumbs.prototype.__init.call(this);
    this.options = {
      console: true,
      dom: true,
      fetch: true,
      history: true,
      sentry: true,
      xhr: true,
      ...options,
    };
  }

  /**
   * Instrument browser built-ins w/ breadcrumb capturing
   *  - Console API
   *  - DOM API (click/typing)
   *  - XMLHttpRequest API
   *  - Fetch API
   *  - History API
   */
   setupOnce() {
    if (this.options.console) {
      (0,instrument/* addInstrumentationHandler */.o)('console', _consoleBreadcrumb);
    }
    if (this.options.dom) {
      (0,instrument/* addInstrumentationHandler */.o)('dom', _domBreadcrumb(this.options.dom));
    }
    if (this.options.xhr) {
      (0,instrument/* addInstrumentationHandler */.o)('xhr', _xhrBreadcrumb);
    }
    if (this.options.fetch) {
      (0,instrument/* addInstrumentationHandler */.o)('fetch', _fetchBreadcrumb);
    }
    if (this.options.history) {
      (0,instrument/* addInstrumentationHandler */.o)('history', _historyBreadcrumb);
    }
  }

  /**
   * Adds a breadcrumb for Sentry events or transactions if this option is enabled.
   */
   addSentryBreadcrumb(event) {
    if (this.options.sentry) {
      (0,esm_hub/* getCurrentHub */.Gd)().addBreadcrumb(
        {
          category: `sentry.${event.type === 'transaction' ? 'transaction' : 'event'}`,
          event_id: event.event_id,
          level: event.level,
          message: (0,misc/* getEventDescription */.jH)(event),
        },
        {
          event,
        },
      );
    }
  }
} Breadcrumbs.__initStatic();

/**
 * A HOC that creaes a function that creates breadcrumbs from DOM API calls.
 * This is a HOC so that we get access to dom options in the closure.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function _domBreadcrumb(dom) {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  function _innerDomBreadcrumb(handlerData) {
    let target;
    let keyAttrs = typeof dom === 'object' ? dom.serializeAttribute : undefined;

    let maxStringLength =
      typeof dom === 'object' && typeof dom.maxStringLength === 'number' ? dom.maxStringLength : undefined;
    if (maxStringLength && maxStringLength > MAX_ALLOWED_STRING_LENGTH) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
        esm_logger/* logger.warn */.kg.warn(
          `\`dom.maxStringLength\` cannot exceed ${MAX_ALLOWED_STRING_LENGTH}, but a value of ${maxStringLength} was configured. Sentry will use ${MAX_ALLOWED_STRING_LENGTH} instead.`,
        );
      maxStringLength = MAX_ALLOWED_STRING_LENGTH;
    }

    if (typeof keyAttrs === 'string') {
      keyAttrs = [keyAttrs];
    }

    // Accessing event.target can throw (see getsentry/raven-js#838, #768)
    try {
      target = handlerData.event.target
        ? (0,browser/* htmlTreeAsString */.Rt)(handlerData.event.target , { keyAttrs, maxStringLength })
        : (0,browser/* htmlTreeAsString */.Rt)(handlerData.event , { keyAttrs, maxStringLength });
    } catch (e) {
      target = '<unknown>';
    }

    if (target.length === 0) {
      return;
    }

    (0,esm_hub/* getCurrentHub */.Gd)().addBreadcrumb(
      {
        category: `ui.${handlerData.name}`,
        message: target,
      },
      {
        event: handlerData.event,
        name: handlerData.name,
        global: handlerData.global,
      },
    );
  }

  return _innerDomBreadcrumb;
}

/**
 * Creates breadcrumbs from console API calls
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function _consoleBreadcrumb(handlerData) {
  // This is a hack to fix a Vue3-specific bug that causes an infinite loop of
  // console warnings. This happens when a Vue template is rendered with
  // an undeclared variable, which we try to stringify, ultimately causing
  // Vue to issue another warning which repeats indefinitely.
  // see: https://github.com/getsentry/sentry-javascript/pull/6010
  // see: https://github.com/getsentry/sentry-javascript/issues/5916
  for (let i = 0; i < handlerData.args.length; i++) {
    if (handlerData.args[i] === 'ref=Ref<') {
      handlerData.args[i + 1] = 'viewRef';
      break;
    }
  }
  const breadcrumb = {
    category: 'console',
    data: {
      arguments: handlerData.args,
      logger: 'console',
    },
    level: severityLevelFromString(handlerData.level),
    message: (0,string/* safeJoin */.nK)(handlerData.args, ' '),
  };

  if (handlerData.level === 'assert') {
    if (handlerData.args[0] === false) {
      breadcrumb.message = `Assertion failed: ${(0,string/* safeJoin */.nK)(handlerData.args.slice(1), ' ') || 'console.assert'}`;
      breadcrumb.data.arguments = handlerData.args.slice(1);
    } else {
      // Don't capture a breadcrumb for passed assertions
      return;
    }
  }

  (0,esm_hub/* getCurrentHub */.Gd)().addBreadcrumb(breadcrumb, {
    input: handlerData.args,
    level: handlerData.level,
  });
}

/**
 * Creates breadcrumbs from XHR API calls
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function _xhrBreadcrumb(handlerData) {
  if (handlerData.endTimestamp) {
    // We only capture complete, non-sentry requests
    if (handlerData.xhr.__sentry_own_request__) {
      return;
    }

    const { method, url, status_code, body } = handlerData.xhr.__sentry_xhr__ || {};

    (0,esm_hub/* getCurrentHub */.Gd)().addBreadcrumb(
      {
        category: 'xhr',
        data: {
          method,
          url,
          status_code,
        },
        type: 'http',
      },
      {
        xhr: handlerData.xhr,
        input: body,
      },
    );

    return;
  }
}

/**
 * Creates breadcrumbs from fetch API calls
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function _fetchBreadcrumb(handlerData) {
  // We only capture complete fetch requests
  if (!handlerData.endTimestamp) {
    return;
  }

  if (handlerData.fetchData.url.match(/sentry_key/) && handlerData.fetchData.method === 'POST') {
    // We will not create breadcrumbs for fetch requests that contain `sentry_key` (internal sentry requests)
    return;
  }

  if (handlerData.error) {
    (0,esm_hub/* getCurrentHub */.Gd)().addBreadcrumb(
      {
        category: 'fetch',
        data: handlerData.fetchData,
        level: 'error',
        type: 'http',
      },
      {
        data: handlerData.error,
        input: handlerData.args,
      },
    );
  } else {
    (0,esm_hub/* getCurrentHub */.Gd)().addBreadcrumb(
      {
        category: 'fetch',
        data: {
          ...handlerData.fetchData,
          status_code: handlerData.response.status,
        },
        type: 'http',
      },
      {
        input: handlerData.args,
        response: handlerData.response,
      },
    );
  }
}

/**
 * Creates breadcrumbs from history API calls
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function _historyBreadcrumb(handlerData) {
  let from = handlerData.from;
  let to = handlerData.to;
  const parsedLoc = parseUrl(helpers_WINDOW.location.href);
  let parsedFrom = parseUrl(from);
  const parsedTo = parseUrl(to);

  // Initial pushState doesn't provide `from` information
  if (!parsedFrom.path) {
    parsedFrom = parsedLoc;
  }

  // Use only the path component of the URL if the URL matches the current
  // document (almost all the time when using pushState)
  if (parsedLoc.protocol === parsedTo.protocol && parsedLoc.host === parsedTo.host) {
    to = parsedTo.relative;
  }
  if (parsedLoc.protocol === parsedFrom.protocol && parsedLoc.host === parsedFrom.host) {
    from = parsedFrom.relative;
  }

  (0,esm_hub/* getCurrentHub */.Gd)().addBreadcrumb({
    category: 'navigation',
    data: {
      from,
      to,
    },
  });
}


//# sourceMappingURL=breadcrumbs.js.map

;// CONCATENATED MODULE: ../../.yarn/cache/@sentry-browser-npm-7.32.1-b5270a3b99-279b2bfb32.zip/node_modules/@sentry/browser/esm/client.js






/**
 * Configuration options for the Sentry Browser SDK.
 * @see @sentry/types Options for more information.
 */

/**
 * The Sentry Browser SDK Client.
 *
 * @see BrowserOptions for documentation on configuration options.
 * @see SentryClient for usage documentation.
 */
class BrowserClient extends BaseClient {
  /**
   * Creates a new Browser SDK instance.
   *
   * @param options Configuration options for this SDK.
   */
   constructor(options) {
    options._metadata = options._metadata || {};
    options._metadata.sdk = options._metadata.sdk || {
      name: 'sentry.javascript.browser',
      packages: [
        {
          name: 'npm:@sentry/browser',
          version: SDK_VERSION,
        },
      ],
      version: SDK_VERSION,
    };

    super(options);

    if (options.sendClientReports && helpers_WINDOW.document) {
      helpers_WINDOW.document.addEventListener('visibilitychange', () => {
        if (helpers_WINDOW.document.visibilityState === 'hidden') {
          this._flushOutcomes();
        }
      });
    }
  }

  /**
   * @inheritDoc
   */
   eventFromException(exception, hint) {
    return eventFromException(this._options.stackParser, exception, hint, this._options.attachStacktrace);
  }

  /**
   * @inheritDoc
   */
   eventFromMessage(
    message,
    // eslint-disable-next-line deprecation/deprecation
    level = 'info',
    hint,
  ) {
    return eventFromMessage(this._options.stackParser, message, level, hint, this._options.attachStacktrace);
  }

  /**
   * @inheritDoc
   */
   sendEvent(event, hint) {
    // We only want to add the sentry event breadcrumb when the user has the breadcrumb integration installed and
    // activated its `sentry` option.
    // We also do not want to use the `Breadcrumbs` class here directly, because we do not want it to be included in
    // bundles, if it is not used by the SDK.
    // This all sadly is a bit ugly, but we currently don't have a "pre-send" hook on the integrations so we do it this
    // way for now.
    const breadcrumbIntegration = this.getIntegrationById(BREADCRUMB_INTEGRATION_ID) ;
    // We check for definedness of `addSentryBreadcrumb` in case users provided their own integration with id
    // "Breadcrumbs" that does not have this function.
    if (breadcrumbIntegration && breadcrumbIntegration.addSentryBreadcrumb) {
      breadcrumbIntegration.addSentryBreadcrumb(event);
    }

    super.sendEvent(event, hint);
  }

  /**
   * @inheritDoc
   */
   _prepareEvent(event, hint, scope) {
    event.platform = event.platform || 'javascript';
    return super._prepareEvent(event, hint, scope);
  }

  /**
   * Sends client reports as an envelope.
   */
   _flushOutcomes() {
    const outcomes = this._clearOutcomes();

    if (outcomes.length === 0) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.log */.kg.log('No outcomes to send');
      return;
    }

    if (!this._dsn) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.log */.kg.log('No dsn provided, will not send outcomes');
      return;
    }

    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.log */.kg.log('Sending outcomes:', outcomes);

    const url = getEnvelopeEndpointWithUrlEncodedAuth(this._dsn, this._options);
    const envelope = createClientReportEnvelope(outcomes, this._options.tunnel && dsn_dsnToString(this._dsn));

    try {
      const isRealNavigator = Object.prototype.toString.call(helpers_WINDOW && helpers_WINDOW.navigator) === '[object Navigator]';
      const hasSendBeacon = isRealNavigator && typeof helpers_WINDOW.navigator.sendBeacon === 'function';
      // Make sure beacon is not used if user configures custom transport options
      if (hasSendBeacon && !this._options.transportOptions) {
        // Prevent illegal invocations - https://xgwang.me/posts/you-may-not-know-beacon/#it-may-throw-error%2C-be-sure-to-catch
        const sendBeacon = helpers_WINDOW.navigator.sendBeacon.bind(helpers_WINDOW.navigator);
        sendBeacon(url, serializeEnvelope(envelope));
      } else {
        // If beacon is not supported or if they are using the tunnel option
        // use our regular transport to send client reports to Sentry.
        this._sendEnvelope(envelope);
      }
    } catch (e) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.error */.kg.error(e);
    }
  }
}


//# sourceMappingURL=client.js.map

;// CONCATENATED MODULE: ../../.yarn/cache/@sentry-browser-npm-7.32.1-b5270a3b99-279b2bfb32.zip/node_modules/@sentry/browser/esm/integrations/globalhandlers.js





/* eslint-disable @typescript-eslint/no-unsafe-member-access */

/** Global handlers */
class GlobalHandlers  {
  /**
   * @inheritDoc
   */
   static __initStatic() {this.id = 'GlobalHandlers';}

  /**
   * @inheritDoc
   */
   __init() {this.name = GlobalHandlers.id;}

  /** JSDoc */

  /**
   * Stores references functions to installing handlers. Will set to undefined
   * after they have been run so that they are not used twice.
   */
   __init2() {this._installFunc = {
    onerror: _installGlobalOnErrorHandler,
    onunhandledrejection: _installGlobalOnUnhandledRejectionHandler,
  };}

  /** JSDoc */
   constructor(options) {GlobalHandlers.prototype.__init.call(this);GlobalHandlers.prototype.__init2.call(this);
    this._options = {
      onerror: true,
      onunhandledrejection: true,
      ...options,
    };
  }
  /**
   * @inheritDoc
   */
   setupOnce() {
    Error.stackTraceLimit = 50;
    const options = this._options;

    // We can disable guard-for-in as we construct the options object above + do checks against
    // `this._installFunc` for the property.
    // eslint-disable-next-line guard-for-in
    for (const key in options) {
      const installFunc = this._installFunc[key ];
      if (installFunc && options[key ]) {
        globalHandlerLog(key);
        installFunc();
        this._installFunc[key ] = undefined;
      }
    }
  }
} GlobalHandlers.__initStatic();

/** JSDoc */
function _installGlobalOnErrorHandler() {
  (0,instrument/* addInstrumentationHandler */.o)(
    'error',
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (data) => {
      const [hub, stackParser, attachStacktrace] = getHubAndOptions();
      if (!hub.getIntegration(GlobalHandlers)) {
        return;
      }
      const { msg, url, line, column, error } = data;
      if (shouldIgnoreOnError() || (error && error.__sentry_own_request__)) {
        return;
      }

      const event =
        error === undefined && (0,is/* isString */.HD)(msg)
          ? _eventFromIncompleteOnError(msg, url, line, column)
          : _enhanceEventWithInitialFrame(
              eventFromUnknownInput(stackParser, error || msg, undefined, attachStacktrace, false),
              url,
              line,
              column,
            );

      event.level = 'error';

      addMechanismAndCapture(hub, error, event, 'onerror');
    },
  );
}

/** JSDoc */
function _installGlobalOnUnhandledRejectionHandler() {
  (0,instrument/* addInstrumentationHandler */.o)(
    'unhandledrejection',
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (e) => {
      const [hub, stackParser, attachStacktrace] = getHubAndOptions();
      if (!hub.getIntegration(GlobalHandlers)) {
        return;
      }
      let error = e;

      // dig the object of the rejection out of known event types
      try {
        // PromiseRejectionEvents store the object of the rejection under 'reason'
        // see https://developer.mozilla.org/en-US/docs/Web/API/PromiseRejectionEvent
        if ('reason' in e) {
          error = e.reason;
        }
        // something, somewhere, (likely a browser extension) effectively casts PromiseRejectionEvents
        // to CustomEvents, moving the `promise` and `reason` attributes of the PRE into
        // the CustomEvent's `detail` attribute, since they're not part of CustomEvent's spec
        // see https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent and
        // https://github.com/getsentry/sentry-javascript/issues/2380
        else if ('detail' in e && 'reason' in e.detail) {
          error = e.detail.reason;
        }
      } catch (_oO) {
        // no-empty
      }

      if (shouldIgnoreOnError() || (error && error.__sentry_own_request__)) {
        return true;
      }

      const event = (0,is/* isPrimitive */.pt)(error)
        ? _eventFromRejectionWithPrimitive(error)
        : eventFromUnknownInput(stackParser, error, undefined, attachStacktrace, true);

      event.level = 'error';

      addMechanismAndCapture(hub, error, event, 'onunhandledrejection');
      return;
    },
  );
}

/**
 * Create an event from a promise rejection where the `reason` is a primitive.
 *
 * @param reason: The `reason` property of the promise rejection
 * @returns An Event object with an appropriate `exception` value
 */
function _eventFromRejectionWithPrimitive(reason) {
  return {
    exception: {
      values: [
        {
          type: 'UnhandledRejection',
          // String() is needed because the Primitive type includes symbols (which can't be automatically stringified)
          value: `Non-Error promise rejection captured with value: ${String(reason)}`,
        },
      ],
    },
  };
}

/**
 * This function creates a stack from an old, error-less onerror handler.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function _eventFromIncompleteOnError(msg, url, line, column) {
  const ERROR_TYPES_RE =
    /^(?:[Uu]ncaught (?:exception: )?)?(?:((?:Eval|Internal|Range|Reference|Syntax|Type|URI|)Error): )?(.*)$/i;

  // If 'message' is ErrorEvent, get real message from inside
  let message = (0,is/* isErrorEvent */.VW)(msg) ? msg.message : msg;
  let name = 'Error';

  const groups = message.match(ERROR_TYPES_RE);
  if (groups) {
    name = groups[1];
    message = groups[2];
  }

  const event = {
    exception: {
      values: [
        {
          type: name,
          value: message,
        },
      ],
    },
  };

  return _enhanceEventWithInitialFrame(event, url, line, column);
}

/** JSDoc */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function _enhanceEventWithInitialFrame(event, url, line, column) {
  // event.exception
  const e = (event.exception = event.exception || {});
  // event.exception.values
  const ev = (e.values = e.values || []);
  // event.exception.values[0]
  const ev0 = (ev[0] = ev[0] || {});
  // event.exception.values[0].stacktrace
  const ev0s = (ev0.stacktrace = ev0.stacktrace || {});
  // event.exception.values[0].stacktrace.frames
  const ev0sf = (ev0s.frames = ev0s.frames || []);

  const colno = isNaN(parseInt(column, 10)) ? undefined : column;
  const lineno = isNaN(parseInt(line, 10)) ? undefined : line;
  const filename = (0,is/* isString */.HD)(url) && url.length > 0 ? url : (0,browser/* getLocationHref */.l4)();

  // event.exception.values[0].stacktrace.frames
  if (ev0sf.length === 0) {
    ev0sf.push({
      colno,
      filename,
      function: '?',
      in_app: true,
      lineno,
    });
  }

  return event;
}

function globalHandlerLog(type) {
  (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.log */.kg.log(`Global Handler attached: ${type}`);
}

function addMechanismAndCapture(hub, error, event, type) {
  (0,misc/* addExceptionMechanism */.EG)(event, {
    handled: false,
    type,
  });
  hub.captureEvent(event, {
    originalException: error,
  });
}

function getHubAndOptions() {
  const hub = (0,esm_hub/* getCurrentHub */.Gd)();
  const client = hub.getClient();
  const options = (client && client.getOptions()) || {
    stackParser: () => [],
    attachStacktrace: false,
  };
  return [hub, options.stackParser, options.attachStacktrace];
}


//# sourceMappingURL=globalhandlers.js.map

;// CONCATENATED MODULE: ../../.yarn/cache/@sentry-browser-npm-7.32.1-b5270a3b99-279b2bfb32.zip/node_modules/@sentry/browser/esm/integrations/trycatch.js



const DEFAULT_EVENT_TARGET = [
  'EventTarget',
  'Window',
  'Node',
  'ApplicationCache',
  'AudioTrackList',
  'ChannelMergerNode',
  'CryptoOperation',
  'EventSource',
  'FileReader',
  'HTMLUnknownElement',
  'IDBDatabase',
  'IDBRequest',
  'IDBTransaction',
  'KeyOperation',
  'MediaController',
  'MessagePort',
  'ModalWindow',
  'Notification',
  'SVGElementInstance',
  'Screen',
  'TextTrack',
  'TextTrackCue',
  'TextTrackList',
  'WebSocket',
  'WebSocketWorker',
  'Worker',
  'XMLHttpRequest',
  'XMLHttpRequestEventTarget',
  'XMLHttpRequestUpload',
];

/** Wrap timer functions and event targets to catch errors and provide better meta data */
class TryCatch  {
  /**
   * @inheritDoc
   */
   static __initStatic() {this.id = 'TryCatch';}

  /**
   * @inheritDoc
   */
   __init() {this.name = TryCatch.id;}

  /** JSDoc */

  /**
   * @inheritDoc
   */
   constructor(options) {TryCatch.prototype.__init.call(this);
    this._options = {
      XMLHttpRequest: true,
      eventTarget: true,
      requestAnimationFrame: true,
      setInterval: true,
      setTimeout: true,
      ...options,
    };
  }

  /**
   * Wrap timer functions and event targets to catch errors
   * and provide better metadata.
   */
   setupOnce() {
    if (this._options.setTimeout) {
      (0,object/* fill */.hl)(helpers_WINDOW, 'setTimeout', _wrapTimeFunction);
    }

    if (this._options.setInterval) {
      (0,object/* fill */.hl)(helpers_WINDOW, 'setInterval', _wrapTimeFunction);
    }

    if (this._options.requestAnimationFrame) {
      (0,object/* fill */.hl)(helpers_WINDOW, 'requestAnimationFrame', _wrapRAF);
    }

    if (this._options.XMLHttpRequest && "XMLHttpRequest" in helpers_WINDOW) {
      (0,object/* fill */.hl)(XMLHttpRequest.prototype, 'send', _wrapXHR);
    }

    const eventTargetOption = this._options.eventTarget;
    if (eventTargetOption) {
      const eventTarget = Array.isArray(eventTargetOption) ? eventTargetOption : DEFAULT_EVENT_TARGET;
      eventTarget.forEach(_wrapEventTarget);
    }
  }
} TryCatch.__initStatic();

/** JSDoc */
function _wrapTimeFunction(original) {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return function ( ...args) {
    const originalCallback = args[0];
    args[0] = wrap(originalCallback, {
      mechanism: {
        data: { function: (0,stacktrace/* getFunctionName */.$P)(original) },
        handled: true,
        type: 'instrument',
      },
    });
    return original.apply(this, args);
  };
}

/** JSDoc */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function _wrapRAF(original) {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return function ( callback) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return original.apply(this, [
      wrap(callback, {
        mechanism: {
          data: {
            function: 'requestAnimationFrame',
            handler: (0,stacktrace/* getFunctionName */.$P)(original),
          },
          handled: true,
          type: 'instrument',
        },
      }),
    ]);
  };
}

/** JSDoc */
function _wrapXHR(originalSend) {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return function ( ...args) {
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const xhr = this;
    const xmlHttpRequestProps = ['onload', 'onerror', 'onprogress', 'onreadystatechange'];

    xmlHttpRequestProps.forEach(prop => {
      if (prop in xhr && typeof xhr[prop] === 'function') {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (0,object/* fill */.hl)(xhr, prop, function (original) {
          const wrapOptions = {
            mechanism: {
              data: {
                function: prop,
                handler: (0,stacktrace/* getFunctionName */.$P)(original),
              },
              handled: true,
              type: 'instrument',
            },
          };

          // If Instrument integration has been called before TryCatch, get the name of original function
          const originalFunction = (0,object/* getOriginalFunction */.HK)(original);
          if (originalFunction) {
            wrapOptions.mechanism.data.handler = (0,stacktrace/* getFunctionName */.$P)(originalFunction);
          }

          // Otherwise wrap directly
          return wrap(original, wrapOptions);
        });
      }
    });

    return originalSend.apply(this, args);
  };
}

/** JSDoc */
function _wrapEventTarget(target) {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const globalObject = helpers_WINDOW ;
  // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
  const proto = globalObject[target] && globalObject[target].prototype;

  // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, no-prototype-builtins
  if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty('addEventListener')) {
    return;
  }

  (0,object/* fill */.hl)(proto, 'addEventListener', function (original)

 {
    return function (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any

      eventName,
      fn,
      options,
    ) {
      try {
        if (typeof fn.handleEvent === 'function') {
          // ESlint disable explanation:
          //  First, it is generally safe to call `wrap` with an unbound function. Furthermore, using `.bind()` would
          //  introduce a bug here, because bind returns a new function that doesn't have our
          //  flags(like __sentry_original__) attached. `wrap` checks for those flags to avoid unnecessary wrapping.
          //  Without those flags, every call to addEventListener wraps the function again, causing a memory leak.
          // eslint-disable-next-line @typescript-eslint/unbound-method
          fn.handleEvent = wrap(fn.handleEvent, {
            mechanism: {
              data: {
                function: 'handleEvent',
                handler: (0,stacktrace/* getFunctionName */.$P)(fn),
                target,
              },
              handled: true,
              type: 'instrument',
            },
          });
        }
      } catch (err) {
        // can sometimes get 'Permission denied to access property "handle Event'
      }

      return original.apply(this, [
        eventName,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        wrap(fn , {
          mechanism: {
            data: {
              function: 'addEventListener',
              handler: (0,stacktrace/* getFunctionName */.$P)(fn),
              target,
            },
            handled: true,
            type: 'instrument',
          },
        }),
        options,
      ]);
    };
  });

  (0,object/* fill */.hl)(
    proto,
    'removeEventListener',
    function (
      originalRemoveEventListener,
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
    ) {
      return function (
        // eslint-disable-next-line @typescript-eslint/no-explicit-any

        eventName,
        fn,
        options,
      ) {
        /**
         * There are 2 possible scenarios here:
         *
         * 1. Someone passes a callback, which was attached prior to Sentry initialization, or by using unmodified
         * method, eg. `document.addEventListener.call(el, name, handler). In this case, we treat this function
         * as a pass-through, and call original `removeEventListener` with it.
         *
         * 2. Someone passes a callback, which was attached after Sentry was initialized, which means that it was using
         * our wrapped version of `addEventListener`, which internally calls `wrap` helper.
         * This helper "wraps" whole callback inside a try/catch statement, and attached appropriate metadata to it,
         * in order for us to make a distinction between wrapped/non-wrapped functions possible.
         * If a function was wrapped, it has additional property of `__sentry_wrapped__`, holding the handler.
         *
         * When someone adds a handler prior to initialization, and then do it again, but after,
         * then we have to detach both of them. Otherwise, if we'd detach only wrapped one, it'd be impossible
         * to get rid of the initial handler and it'd stick there forever.
         */
        const wrappedEventHandler = fn ;
        try {
          const originalEventHandler = wrappedEventHandler && wrappedEventHandler.__sentry_wrapped__;
          if (originalEventHandler) {
            originalRemoveEventListener.call(this, eventName, originalEventHandler, options);
          }
        } catch (e) {
          // ignore, accessing __sentry_wrapped__ will throw in some Selenium environments
        }
        return originalRemoveEventListener.call(this, eventName, wrappedEventHandler, options);
      };
    },
  );
}


//# sourceMappingURL=trycatch.js.map

;// CONCATENATED MODULE: ../../.yarn/cache/@sentry-browser-npm-7.32.1-b5270a3b99-279b2bfb32.zip/node_modules/@sentry/browser/esm/integrations/linkederrors.js




const DEFAULT_KEY = 'cause';
const DEFAULT_LIMIT = 5;

/** Adds SDK info to an event. */
class LinkedErrors  {
  /**
   * @inheritDoc
   */
   static __initStatic() {this.id = 'LinkedErrors';}

  /**
   * @inheritDoc
   */
    __init() {this.name = LinkedErrors.id;}

  /**
   * @inheritDoc
   */

  /**
   * @inheritDoc
   */

  /**
   * @inheritDoc
   */
   constructor(options = {}) {LinkedErrors.prototype.__init.call(this);
    this._key = options.key || DEFAULT_KEY;
    this._limit = options.limit || DEFAULT_LIMIT;
  }

  /**
   * @inheritDoc
   */
   setupOnce() {
    const client = (0,esm_hub/* getCurrentHub */.Gd)().getClient();
    if (!client) {
      return;
    }
    (0,esm_scope/* addGlobalEventProcessor */.c)((event, hint) => {
      const self = (0,esm_hub/* getCurrentHub */.Gd)().getIntegration(LinkedErrors);
      return self ? _handler(client.getOptions().stackParser, self._key, self._limit, event, hint) : event;
    });
  }
} LinkedErrors.__initStatic();

/**
 * @inheritDoc
 */
function _handler(
  parser,
  key,
  limit,
  event,
  hint,
) {
  if (!event.exception || !event.exception.values || !hint || !(0,is/* isInstanceOf */.V9)(hint.originalException, Error)) {
    return event;
  }
  const linkedErrors = _walkErrorTree(parser, limit, hint.originalException , key);
  event.exception.values = [...linkedErrors, ...event.exception.values];
  return event;
}

/**
 * JSDOC
 */
function _walkErrorTree(
  parser,
  limit,
  error,
  key,
  stack = [],
) {
  if (!(0,is/* isInstanceOf */.V9)(error[key], Error) || stack.length + 1 >= limit) {
    return stack;
  }
  const exception = exceptionFromError(parser, error[key]);
  return _walkErrorTree(parser, limit, error[key], key, [exception, ...stack]);
}


//# sourceMappingURL=linkederrors.js.map

;// CONCATENATED MODULE: ../../.yarn/cache/@sentry-browser-npm-7.32.1-b5270a3b99-279b2bfb32.zip/node_modules/@sentry/browser/esm/integrations/httpcontext.js



/** HttpContext integration collects information about HTTP request headers */
class HttpContext  {constructor() { HttpContext.prototype.__init.call(this); }
  /**
   * @inheritDoc
   */
   static __initStatic() {this.id = 'HttpContext';}

  /**
   * @inheritDoc
   */
   __init() {this.name = HttpContext.id;}

  /**
   * @inheritDoc
   */
   setupOnce() {
    (0,esm_scope/* addGlobalEventProcessor */.c)((event) => {
      if ((0,esm_hub/* getCurrentHub */.Gd)().getIntegration(HttpContext)) {
        // if none of the information we want exists, don't bother
        if (!helpers_WINDOW.navigator && !helpers_WINDOW.location && !helpers_WINDOW.document) {
          return event;
        }

        // grab as much info as exists and add it to the event
        const url = (event.request && event.request.url) || (helpers_WINDOW.location && helpers_WINDOW.location.href);
        const { referrer } = helpers_WINDOW.document || {};
        const { userAgent } = helpers_WINDOW.navigator || {};

        const headers = {
          ...(event.request && event.request.headers),
          ...(referrer && { Referer: referrer }),
          ...(userAgent && { 'User-Agent': userAgent }),
        };
        const request = { ...event.request, ...(url && { url }), headers };

        return { ...event, request };
      }
      return event;
    });
  }
} HttpContext.__initStatic();


//# sourceMappingURL=httpcontext.js.map

;// CONCATENATED MODULE: ../../.yarn/cache/@sentry-browser-npm-7.32.1-b5270a3b99-279b2bfb32.zip/node_modules/@sentry/browser/esm/integrations/dedupe.js


/** Deduplication filter */
class Dedupe  {constructor() { Dedupe.prototype.__init.call(this); }
  /**
   * @inheritDoc
   */
   static __initStatic() {this.id = 'Dedupe';}

  /**
   * @inheritDoc
   */
   __init() {this.name = Dedupe.id;}

  /**
   * @inheritDoc
   */

  /**
   * @inheritDoc
   */
   setupOnce(addGlobalEventProcessor, getCurrentHub) {
    const eventProcessor = currentEvent => {
      const self = getCurrentHub().getIntegration(Dedupe);
      if (self) {
        // Juuust in case something goes wrong
        try {
          if (dedupe_shouldDropEvent(currentEvent, self._previousEvent)) {
            (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.warn */.kg.warn('Event dropped due to being a duplicate of previously captured event.');
            return null;
          }
        } catch (_oO) {
          return (self._previousEvent = currentEvent);
        }

        return (self._previousEvent = currentEvent);
      }
      return currentEvent;
    };

    eventProcessor.id = this.name;
    addGlobalEventProcessor(eventProcessor);
  }
} Dedupe.__initStatic();

/** JSDoc */
function dedupe_shouldDropEvent(currentEvent, previousEvent) {
  if (!previousEvent) {
    return false;
  }

  if (_isSameMessageEvent(currentEvent, previousEvent)) {
    return true;
  }

  if (_isSameExceptionEvent(currentEvent, previousEvent)) {
    return true;
  }

  return false;
}

/** JSDoc */
function _isSameMessageEvent(currentEvent, previousEvent) {
  const currentMessage = currentEvent.message;
  const previousMessage = previousEvent.message;

  // If neither event has a message property, they were both exceptions, so bail out
  if (!currentMessage && !previousMessage) {
    return false;
  }

  // If only one event has a stacktrace, but not the other one, they are not the same
  if ((currentMessage && !previousMessage) || (!currentMessage && previousMessage)) {
    return false;
  }

  if (currentMessage !== previousMessage) {
    return false;
  }

  if (!_isSameFingerprint(currentEvent, previousEvent)) {
    return false;
  }

  if (!_isSameStacktrace(currentEvent, previousEvent)) {
    return false;
  }

  return true;
}

/** JSDoc */
function _isSameExceptionEvent(currentEvent, previousEvent) {
  const previousException = _getExceptionFromEvent(previousEvent);
  const currentException = _getExceptionFromEvent(currentEvent);

  if (!previousException || !currentException) {
    return false;
  }

  if (previousException.type !== currentException.type || previousException.value !== currentException.value) {
    return false;
  }

  if (!_isSameFingerprint(currentEvent, previousEvent)) {
    return false;
  }

  if (!_isSameStacktrace(currentEvent, previousEvent)) {
    return false;
  }

  return true;
}

/** JSDoc */
function _isSameStacktrace(currentEvent, previousEvent) {
  let currentFrames = _getFramesFromEvent(currentEvent);
  let previousFrames = _getFramesFromEvent(previousEvent);

  // If neither event has a stacktrace, they are assumed to be the same
  if (!currentFrames && !previousFrames) {
    return true;
  }

  // If only one event has a stacktrace, but not the other one, they are not the same
  if ((currentFrames && !previousFrames) || (!currentFrames && previousFrames)) {
    return false;
  }

  currentFrames = currentFrames ;
  previousFrames = previousFrames ;

  // If number of frames differ, they are not the same
  if (previousFrames.length !== currentFrames.length) {
    return false;
  }

  // Otherwise, compare the two
  for (let i = 0; i < previousFrames.length; i++) {
    const frameA = previousFrames[i];
    const frameB = currentFrames[i];

    if (
      frameA.filename !== frameB.filename ||
      frameA.lineno !== frameB.lineno ||
      frameA.colno !== frameB.colno ||
      frameA.function !== frameB.function
    ) {
      return false;
    }
  }

  return true;
}

/** JSDoc */
function _isSameFingerprint(currentEvent, previousEvent) {
  let currentFingerprint = currentEvent.fingerprint;
  let previousFingerprint = previousEvent.fingerprint;

  // If neither event has a fingerprint, they are assumed to be the same
  if (!currentFingerprint && !previousFingerprint) {
    return true;
  }

  // If only one event has a fingerprint, but not the other one, they are not the same
  if ((currentFingerprint && !previousFingerprint) || (!currentFingerprint && previousFingerprint)) {
    return false;
  }

  currentFingerprint = currentFingerprint ;
  previousFingerprint = previousFingerprint ;

  // Otherwise, compare the two
  try {
    return !!(currentFingerprint.join('') === previousFingerprint.join(''));
  } catch (_oO) {
    return false;
  }
}

/** JSDoc */
function _getExceptionFromEvent(event) {
  return event.exception && event.exception.values && event.exception.values[0];
}

/** JSDoc */
function _getFramesFromEvent(event) {
  const exception = event.exception;

  if (exception) {
    try {
      // @ts-ignore Object could be undefined
      return exception.values[0].stacktrace.frames;
    } catch (_oO) {
      return undefined;
    }
  }
  return undefined;
}


//# sourceMappingURL=dedupe.js.map

;// CONCATENATED MODULE: ../../.yarn/cache/@sentry-browser-npm-7.32.1-b5270a3b99-279b2bfb32.zip/node_modules/@sentry/browser/esm/stack-parsers.js


// global reference to slice
const UNKNOWN_FUNCTION = '?';

const OPERA10_PRIORITY = 10;
const OPERA11_PRIORITY = 20;
const CHROME_PRIORITY = 30;
const WINJS_PRIORITY = 40;
const GECKO_PRIORITY = 50;

function createFrame(filename, func, lineno, colno) {
  const frame = {
    filename,
    function: func,
    // All browser frames are considered in_app
    in_app: true,
  };

  if (lineno !== undefined) {
    frame.lineno = lineno;
  }

  if (colno !== undefined) {
    frame.colno = colno;
  }

  return frame;
}

// Chromium based browsers: Chrome, Brave, new Opera, new Edge
const chromeRegex =
  /^\s*at (?:(.*\).*?|.*?) ?\((?:address at )?)?((?:file|https?|blob|chrome-extension|address|native|eval|webpack|<anonymous>|[-a-z]+:|.*bundle|\/)?.*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i;
const chromeEvalRegex = /\((\S*)(?::(\d+))(?::(\d+))\)/;

const chrome = line => {
  const parts = chromeRegex.exec(line);

  if (parts) {
    const isEval = parts[2] && parts[2].indexOf('eval') === 0; // start of line

    if (isEval) {
      const subMatch = chromeEvalRegex.exec(parts[2]);

      if (subMatch) {
        // throw out eval line/column and use top-most line/column number
        parts[2] = subMatch[1]; // url
        parts[3] = subMatch[2]; // line
        parts[4] = subMatch[3]; // column
      }
    }

    // Kamil: One more hack won't hurt us right? Understanding and adding more rules on top of these regexps right now
    // would be way too time consuming. (TODO: Rewrite whole RegExp to be more readable)
    const [func, filename] = extractSafariExtensionDetails(parts[1] || UNKNOWN_FUNCTION, parts[2]);

    return createFrame(filename, func, parts[3] ? +parts[3] : undefined, parts[4] ? +parts[4] : undefined);
  }

  return;
};

const chromeStackLineParser = [CHROME_PRIORITY, chrome];

// gecko regex: `(?:bundle|\d+\.js)`: `bundle` is for react native, `\d+\.js` also but specifically for ram bundles because it
// generates filenames without a prefix like `file://` the filenames in the stacktrace are just 42.js
// We need this specific case for now because we want no other regex to match.
const geckoREgex =
  /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:file|https?|blob|chrome|webpack|resource|moz-extension|safari-extension|safari-web-extension|capacitor)?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js)|\/[\w\-. /=]+)(?::(\d+))?(?::(\d+))?\s*$/i;
const geckoEvalRegex = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;

const gecko = line => {
  const parts = geckoREgex.exec(line);

  if (parts) {
    const isEval = parts[3] && parts[3].indexOf(' > eval') > -1;
    if (isEval) {
      const subMatch = geckoEvalRegex.exec(parts[3]);

      if (subMatch) {
        // throw out eval line/column and use top-most line number
        parts[1] = parts[1] || 'eval';
        parts[3] = subMatch[1];
        parts[4] = subMatch[2];
        parts[5] = ''; // no column when eval
      }
    }

    let filename = parts[3];
    let func = parts[1] || UNKNOWN_FUNCTION;
    [func, filename] = extractSafariExtensionDetails(func, filename);

    return createFrame(filename, func, parts[4] ? +parts[4] : undefined, parts[5] ? +parts[5] : undefined);
  }

  return;
};

const geckoStackLineParser = [GECKO_PRIORITY, gecko];

const winjsRegex =
  /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:file|ms-appx|https?|webpack|blob):.*?):(\d+)(?::(\d+))?\)?\s*$/i;

const winjs = line => {
  const parts = winjsRegex.exec(line);

  return parts
    ? createFrame(parts[2], parts[1] || UNKNOWN_FUNCTION, +parts[3], parts[4] ? +parts[4] : undefined)
    : undefined;
};

const winjsStackLineParser = [WINJS_PRIORITY, winjs];

const opera10Regex = / line (\d+).*script (?:in )?(\S+)(?:: in function (\S+))?$/i;

const opera10 = line => {
  const parts = opera10Regex.exec(line);
  return parts ? createFrame(parts[2], parts[3] || UNKNOWN_FUNCTION, +parts[1]) : undefined;
};

const opera10StackLineParser = [OPERA10_PRIORITY, opera10];

const opera11Regex =
  / line (\d+), column (\d+)\s*(?:in (?:<anonymous function: ([^>]+)>|([^)]+))\(.*\))? in (.*):\s*$/i;

const opera11 = line => {
  const parts = opera11Regex.exec(line);
  return parts ? createFrame(parts[5], parts[3] || parts[4] || UNKNOWN_FUNCTION, +parts[1], +parts[2]) : undefined;
};

const opera11StackLineParser = [OPERA11_PRIORITY, opera11];

const defaultStackLineParsers = [chromeStackLineParser, geckoStackLineParser, winjsStackLineParser];

const defaultStackParser = (0,stacktrace/* createStackParser */.pE)(...defaultStackLineParsers);

/**
 * Safari web extensions, starting version unknown, can produce "frames-only" stacktraces.
 * What it means, is that instead of format like:
 *
 * Error: wat
 *   at function@url:row:col
 *   at function@url:row:col
 *   at function@url:row:col
 *
 * it produces something like:
 *
 *   function@url:row:col
 *   function@url:row:col
 *   function@url:row:col
 *
 * Because of that, it won't be captured by `chrome` RegExp and will fall into `Gecko` branch.
 * This function is extracted so that we can use it in both places without duplicating the logic.
 * Unfortunately "just" changing RegExp is too complicated now and making it pass all tests
 * and fix this case seems like an impossible, or at least way too time-consuming task.
 */
const extractSafariExtensionDetails = (func, filename) => {
  const isSafariExtension = func.indexOf('safari-extension') !== -1;
  const isSafariWebExtension = func.indexOf('safari-web-extension') !== -1;

  return isSafariExtension || isSafariWebExtension
    ? [
        func.indexOf('@') !== -1 ? func.split('@')[0] : UNKNOWN_FUNCTION,
        isSafariExtension ? `safari-extension:${filename}` : `safari-web-extension:${filename}`,
      ]
    : [func, filename];
};


//# sourceMappingURL=stack-parsers.js.map

;// CONCATENATED MODULE: ../../.yarn/cache/@sentry-utils-npm-7.32.1-c99d3811fa-1b0d82cbcc.zip/node_modules/@sentry/utils/esm/promisebuffer.js



/**
 * Creates an new PromiseBuffer object with the specified limit
 * @param limit max number of promises that can be stored in the buffer
 */
function makePromiseBuffer(limit) {
  const buffer = [];

  function isReady() {
    return limit === undefined || buffer.length < limit;
  }

  /**
   * Remove a promise from the queue.
   *
   * @param task Can be any PromiseLike<T>
   * @returns Removed promise.
   */
  function remove(task) {
    return buffer.splice(buffer.indexOf(task), 1)[0];
  }

  /**
   * Add a promise (representing an in-flight action) to the queue, and set it to remove itself on fulfillment.
   *
   * @param taskProducer A function producing any PromiseLike<T>; In previous versions this used to be `task:
   *        PromiseLike<T>`, but under that model, Promises were instantly created on the call-site and their executor
   *        functions therefore ran immediately. Thus, even if the buffer was full, the action still happened. By
   *        requiring the promise to be wrapped in a function, we can defer promise creation until after the buffer
   *        limit check.
   * @returns The original promise.
   */
  function add(taskProducer) {
    if (!isReady()) {
      return (0,syncpromise/* rejectedSyncPromise */.$2)(new SentryError('Not adding Promise because buffer limit was reached.'));
    }

    // start the task and add its promise to the queue
    const task = taskProducer();
    if (buffer.indexOf(task) === -1) {
      buffer.push(task);
    }
    void task
      .then(() => remove(task))
      // Use `then(null, rejectionHandler)` rather than `catch(rejectionHandler)` so that we can use `PromiseLike`
      // rather than `Promise`. `PromiseLike` doesn't have a `.catch` method, making its polyfill smaller. (ES5 didn't
      // have promises, so TS has to polyfill when down-compiling.)
      .then(null, () =>
        remove(task).then(null, () => {
          // We have to add another catch here because `remove()` starts a new promise chain.
        }),
      );
    return task;
  }

  /**
   * Wait for all promises in the queue to resolve or for timeout to expire, whichever comes first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the queue is still non-empty. Passing `0` (or
   * not passing anything) will make the promise wait as long as it takes for the queue to drain before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if the queue is already empty or drains before the timeout, and
   * `false` otherwise
   */
  function drain(timeout) {
    return new syncpromise/* SyncPromise */.cW((resolve, reject) => {
      let counter = buffer.length;

      if (!counter) {
        return resolve(true);
      }

      // wait for `timeout` ms and then resolve to `false` (if not cancelled first)
      const capturedSetTimeout = setTimeout(() => {
        if (timeout && timeout > 0) {
          resolve(false);
        }
      }, timeout);

      // if all promises resolve in time, cancel the timer and resolve to `true`
      buffer.forEach(item => {
        void (0,syncpromise/* resolvedSyncPromise */.WD)(item).then(() => {
          if (!--counter) {
            clearTimeout(capturedSetTimeout);
            resolve(true);
          }
        }, reject);
      });
    });
  }

  return {
    $: buffer,
    add,
    drain,
  };
}


//# sourceMappingURL=promisebuffer.js.map

;// CONCATENATED MODULE: ../../.yarn/cache/@sentry-utils-npm-7.32.1-c99d3811fa-1b0d82cbcc.zip/node_modules/@sentry/utils/esm/ratelimit.js
// Intentionally keeping the key broad, as we don't know for sure what rate limit headers get returned from backend

const DEFAULT_RETRY_AFTER = 60 * 1000; // 60 seconds

/**
 * Extracts Retry-After value from the request header or returns default value
 * @param header string representation of 'Retry-After' header
 * @param now current unix timestamp
 *
 */
function parseRetryAfterHeader(header, now = Date.now()) {
  const headerDelay = parseInt(`${header}`, 10);
  if (!isNaN(headerDelay)) {
    return headerDelay * 1000;
  }

  const headerDate = Date.parse(`${header}`);
  if (!isNaN(headerDate)) {
    return headerDate - now;
  }

  return DEFAULT_RETRY_AFTER;
}

/**
 * Gets the time that the given category is disabled until for rate limiting.
 * In case no category-specific limit is set but a general rate limit across all categories is active,
 * that time is returned.
 *
 * @return the time in ms that the category is disabled until or 0 if there's no active rate limit.
 */
function disabledUntil(limits, category) {
  return limits[category] || limits.all || 0;
}

/**
 * Checks if a category is rate limited
 */
function isRateLimited(limits, category, now = Date.now()) {
  return disabledUntil(limits, category) > now;
}

/**
 * Update ratelimits from incoming headers.
 *
 * @return the updated RateLimits object.
 */
function updateRateLimits(
  limits,
  { statusCode, headers },
  now = Date.now(),
) {
  const updatedRateLimits = {
    ...limits,
  };

  // "The name is case-insensitive."
  // https://developer.mozilla.org/en-US/docs/Web/API/Headers/get
  const rateLimitHeader = headers && headers['x-sentry-rate-limits'];
  const retryAfterHeader = headers && headers['retry-after'];

  if (rateLimitHeader) {
    /**
     * rate limit headers are of the form
     *     <header>,<header>,..
     * where each <header> is of the form
     *     <retry_after>: <categories>: <scope>: <reason_code>
     * where
     *     <retry_after> is a delay in seconds
     *     <categories> is the event type(s) (error, transaction, etc) being rate limited and is of the form
     *         <category>;<category>;...
     *     <scope> is what's being limited (org, project, or key) - ignored by SDK
     *     <reason_code> is an arbitrary string like "org_quota" - ignored by SDK
     */
    for (const limit of rateLimitHeader.trim().split(',')) {
      const [retryAfter, categories] = limit.split(':', 2);
      const headerDelay = parseInt(retryAfter, 10);
      const delay = (!isNaN(headerDelay) ? headerDelay : 60) * 1000; // 60sec default
      if (!categories) {
        updatedRateLimits.all = now + delay;
      } else {
        for (const category of categories.split(';')) {
          updatedRateLimits[category] = now + delay;
        }
      }
    }
  } else if (retryAfterHeader) {
    updatedRateLimits.all = now + parseRetryAfterHeader(retryAfterHeader, now);
  } else if (statusCode === 429) {
    updatedRateLimits.all = now + 60 * 1000;
  }

  return updatedRateLimits;
}


//# sourceMappingURL=ratelimit.js.map

;// CONCATENATED MODULE: ../../.yarn/cache/@sentry-core-npm-7.32.1-f8255c7634-74ce787414.zip/node_modules/@sentry/core/esm/transports/base.js


const DEFAULT_TRANSPORT_BUFFER_SIZE = 30;

/**
 * Creates an instance of a Sentry `Transport`
 *
 * @param options
 * @param makeRequest
 */
function createTransport(
  options,
  makeRequest,
  buffer = makePromiseBuffer(
    options.bufferSize || DEFAULT_TRANSPORT_BUFFER_SIZE,
  ),
) {
  let rateLimits = {};

  const flush = (timeout) => buffer.drain(timeout);

  function send(envelope) {
    const filteredEnvelopeItems = [];

    // Drop rate limited items from envelope
    forEachEnvelopeItem(envelope, (item, type) => {
      const envelopeItemDataCategory = envelopeItemTypeToDataCategory(type);
      if (isRateLimited(rateLimits, envelopeItemDataCategory)) {
        const event = getEventForEnvelopeItem(item, type);
        options.recordDroppedEvent('ratelimit_backoff', envelopeItemDataCategory, event);
      } else {
        filteredEnvelopeItems.push(item);
      }
    });

    // Skip sending if envelope is empty after filtering out rate limited events
    if (filteredEnvelopeItems.length === 0) {
      return (0,syncpromise/* resolvedSyncPromise */.WD)();
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const filteredEnvelope = createEnvelope(envelope[0], filteredEnvelopeItems );

    // Creates client report for each item in an envelope
    const recordEnvelopeLoss = (reason) => {
      forEachEnvelopeItem(filteredEnvelope, (item, type) => {
        const event = getEventForEnvelopeItem(item, type);
        options.recordDroppedEvent(reason, envelopeItemTypeToDataCategory(type), event);
      });
    };

    const requestTask = () =>
      makeRequest({ body: serializeEnvelope(filteredEnvelope, options.textEncoder) }).then(
        response => {
          // We don't want to throw on NOK responses, but we want to at least log them
          if (response.statusCode !== undefined && (response.statusCode < 200 || response.statusCode >= 300)) {
            (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.warn */.kg.warn(`Sentry responded with status code ${response.statusCode} to sent event.`);
          }

          rateLimits = updateRateLimits(rateLimits, response);
          return response;
        },
        error => {
          recordEnvelopeLoss('network_error');
          throw error;
        },
      );

    return buffer.add(requestTask).then(
      result => result,
      error => {
        if (error instanceof SentryError) {
          (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.error */.kg.error('Skipped sending event because buffer is full.');
          recordEnvelopeLoss('queue_overflow');
          return (0,syncpromise/* resolvedSyncPromise */.WD)();
        } else {
          throw error;
        }
      },
    );
  }

  return {
    send,
    flush,
  };
}

function getEventForEnvelopeItem(item, type) {
  if (type !== 'event' && type !== 'transaction') {
    return undefined;
  }

  return Array.isArray(item) ? (item )[1] : undefined;
}


//# sourceMappingURL=base.js.map

;// CONCATENATED MODULE: ../../.yarn/cache/@sentry-browser-npm-7.32.1-b5270a3b99-279b2bfb32.zip/node_modules/@sentry/browser/esm/transports/utils.js



let cachedFetchImpl = undefined;

/**
 * A special usecase for incorrectly wrapped Fetch APIs in conjunction with ad-blockers.
 * Whenever someone wraps the Fetch API and returns the wrong promise chain,
 * this chain becomes orphaned and there is no possible way to capture it's rejections
 * other than allowing it bubble up to this very handler. eg.
 *
 * const f = window.fetch;
 * window.fetch = function () {
 *   const p = f.apply(this, arguments);
 *
 *   p.then(function() {
 *     console.log('hi.');
 *   });
 *
 *   return p;
 * }
 *
 * `p.then(function () { ... })` is producing a completely separate promise chain,
 * however, what's returned is `p` - the result of original `fetch` call.
 *
 * This mean, that whenever we use the Fetch API to send our own requests, _and_
 * some ad-blocker blocks it, this orphaned chain will _always_ reject,
 * effectively causing another event to be captured.
 * This makes a whole process become an infinite loop, which we need to somehow
 * deal with, and break it in one way or another.
 *
 * To deal with this issue, we are making sure that we _always_ use the real
 * browser Fetch API, instead of relying on what `window.fetch` exposes.
 * The only downside to this would be missing our own requests as breadcrumbs,
 * but because we are already not doing this, it should be just fine.
 *
 * Possible failed fetch error messages per-browser:
 *
 * Chrome:  Failed to fetch
 * Edge:    Failed to Fetch
 * Firefox: NetworkError when attempting to fetch resource
 * Safari:  resource blocked by content blocker
 */
function getNativeFetchImplementation() {
  if (cachedFetchImpl) {
    return cachedFetchImpl;
  }

  /* eslint-disable @typescript-eslint/unbound-method */

  // Fast path to avoid DOM I/O
  if ((0,supports/* isNativeFetch */.Du)(helpers_WINDOW.fetch)) {
    return (cachedFetchImpl = helpers_WINDOW.fetch.bind(helpers_WINDOW));
  }

  const document = helpers_WINDOW.document;
  let fetchImpl = helpers_WINDOW.fetch;
  // eslint-disable-next-line deprecation/deprecation
  if (document && typeof document.createElement === 'function') {
    try {
      const sandbox = document.createElement('iframe');
      sandbox.hidden = true;
      document.head.appendChild(sandbox);
      const contentWindow = sandbox.contentWindow;
      if (contentWindow && contentWindow.fetch) {
        fetchImpl = contentWindow.fetch;
      }
      document.head.removeChild(sandbox);
    } catch (e) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
        esm_logger/* logger.warn */.kg.warn('Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ', e);
    }
  }

  return (cachedFetchImpl = fetchImpl.bind(helpers_WINDOW));
  /* eslint-enable @typescript-eslint/unbound-method */
}

/** Clears cached fetch impl */
function clearCachedFetchImplementation() {
  cachedFetchImpl = undefined;
}


//# sourceMappingURL=utils.js.map

;// CONCATENATED MODULE: ../../.yarn/cache/@sentry-browser-npm-7.32.1-b5270a3b99-279b2bfb32.zip/node_modules/@sentry/browser/esm/transports/fetch.js




/**
 * Creates a Transport that uses the Fetch API to send events to Sentry.
 */
function makeFetchTransport(
  options,
  nativeFetch = getNativeFetchImplementation(),
) {
  function makeRequest(request) {
    const requestOptions = {
      body: request.body,
      method: 'POST',
      referrerPolicy: 'origin',
      headers: options.headers,
      // Outgoing requests are usually cancelled when navigating to a different page, causing a "TypeError: Failed to
      // fetch" error and sending a "network_error" client-outcome - in Chrome, the request status shows "(cancelled)".
      // The `keepalive` flag keeps outgoing requests alive, even when switching pages. We want this since we're
      // frequently sending events right before the user is switching pages (eg. whenfinishing navigation transactions).
      // Gotchas:
      // - `keepalive` isn't supported by Firefox
      // - As per spec (https://fetch.spec.whatwg.org/#http-network-or-cache-fetch), a request with `keepalive: true`
      //   and a content length of > 64 kibibytes returns a network error. We will therefore only activate the flag when
      //   we're below that limit.
      keepalive: request.body.length <= 65536,
      ...options.fetchOptions,
    };

    try {
      return nativeFetch(options.url, requestOptions).then(response => ({
        statusCode: response.status,
        headers: {
          'x-sentry-rate-limits': response.headers.get('X-Sentry-Rate-Limits'),
          'retry-after': response.headers.get('Retry-After'),
        },
      }));
    } catch (e) {
      clearCachedFetchImplementation();
      return (0,syncpromise/* rejectedSyncPromise */.$2)(e);
    }
  }

  return createTransport(options, makeRequest);
}


//# sourceMappingURL=fetch.js.map

;// CONCATENATED MODULE: ../../.yarn/cache/@sentry-browser-npm-7.32.1-b5270a3b99-279b2bfb32.zip/node_modules/@sentry/browser/esm/transports/xhr.js



/**
 * The DONE ready state for XmlHttpRequest
 *
 * Defining it here as a constant b/c XMLHttpRequest.DONE is not always defined
 * (e.g. during testing, it is `undefined`)
 *
 * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/readyState}
 */
const XHR_READYSTATE_DONE = 4;

/**
 * Creates a Transport that uses the XMLHttpRequest API to send events to Sentry.
 */
function makeXHRTransport(options) {
  function makeRequest(request) {
    return new syncpromise/* SyncPromise */.cW((resolve, reject) => {
      const xhr = new XMLHttpRequest();

      xhr.onerror = reject;

      xhr.onreadystatechange = () => {
        if (xhr.readyState === XHR_READYSTATE_DONE) {
          resolve({
            statusCode: xhr.status,
            headers: {
              'x-sentry-rate-limits': xhr.getResponseHeader('X-Sentry-Rate-Limits'),
              'retry-after': xhr.getResponseHeader('Retry-After'),
            },
          });
        }
      };

      xhr.open('POST', options.url);

      for (const header in options.headers) {
        if (Object.prototype.hasOwnProperty.call(options.headers, header)) {
          xhr.setRequestHeader(header, options.headers[header]);
        }
      }

      xhr.send(request.body);
    });
  }

  return createTransport(options, makeRequest);
}


//# sourceMappingURL=xhr.js.map

;// CONCATENATED MODULE: ../../.yarn/cache/@sentry-browser-npm-7.32.1-b5270a3b99-279b2bfb32.zip/node_modules/@sentry/browser/esm/sdk.js














const defaultIntegrations = [
  new InboundFilters(),
  new FunctionToString(),
  new TryCatch(),
  new Breadcrumbs(),
  new GlobalHandlers(),
  new LinkedErrors(),
  new Dedupe(),
  new HttpContext(),
];

/**
 * A magic string that build tooling can leverage in order to inject a release value into the SDK.
 */

/**
 * The Sentry Browser SDK Client.
 *
 * To use this SDK, call the {@link init} function as early as possible when
 * loading the web page. To set context information or send manual events, use
 * the provided methods.
 *
 * @example
 *
 * ```
 *
 * import { init } from '@sentry/browser';
 *
 * init({
 *   dsn: '__DSN__',
 *   // ...
 * });
 * ```
 *
 * @example
 * ```
 *
 * import { configureScope } from '@sentry/browser';
 * configureScope((scope: Scope) => {
 *   scope.setExtra({ battery: 0.7 });
 *   scope.setTag({ user_mode: 'admin' });
 *   scope.setUser({ id: '4711' });
 * });
 * ```
 *
 * @example
 * ```
 *
 * import { addBreadcrumb } from '@sentry/browser';
 * addBreadcrumb({
 *   message: 'My Breadcrumb',
 *   // ...
 * });
 * ```
 *
 * @example
 *
 * ```
 *
 * import * as Sentry from '@sentry/browser';
 * Sentry.captureMessage('Hello, world!');
 * Sentry.captureException(new Error('Good bye'));
 * Sentry.captureEvent({
 *   message: 'Manual',
 *   stacktrace: [
 *     // ...
 *   ],
 * });
 * ```
 *
 * @see {@link BrowserOptions} for documentation on configuration options.
 */
function init(options = {}) {
  if (options.defaultIntegrations === undefined) {
    options.defaultIntegrations = defaultIntegrations;
  }
  if (options.release === undefined) {
    // This allows build tooling to find-and-replace __SENTRY_RELEASE__ to inject a release value
    if (typeof __SENTRY_RELEASE__ === 'string') {
      options.release = __SENTRY_RELEASE__;
    }

    // This supports the variable that sentry-webpack-plugin injects
    if (helpers_WINDOW.SENTRY_RELEASE && helpers_WINDOW.SENTRY_RELEASE.id) {
      options.release = helpers_WINDOW.SENTRY_RELEASE.id;
    }
  }
  if (options.autoSessionTracking === undefined) {
    options.autoSessionTracking = true;
  }
  if (options.sendClientReports === undefined) {
    options.sendClientReports = true;
  }

  const clientOptions = {
    ...options,
    stackParser: (0,stacktrace/* stackParserFromStackParserOptions */.Sq)(options.stackParser || defaultStackParser),
    integrations: getIntegrationsToSetup(options),
    transport: options.transport || ((0,supports/* supportsFetch */.Ak)() ? makeFetchTransport : makeXHRTransport),
  };

  initAndBind(BrowserClient, clientOptions);

  if (options.autoSessionTracking) {
    startSessionTracking();
  }
}

/**
 * Present the user with a report dialog.
 *
 * @param options Everything is optional, we try to fetch all info need from the global scope.
 */
function showReportDialog(options = {}, hub = getCurrentHub()) {
  // doesn't work without a document (React Native)
  if (!WINDOW.document) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger.error('Global document not defined in showReportDialog call');
    return;
  }

  const { client, scope } = hub.getStackTop();
  const dsn = options.dsn || (client && client.getDsn());
  if (!dsn) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger.error('DSN not configured for showReportDialog call');
    return;
  }

  if (scope) {
    options.user = {
      ...scope.getUser(),
      ...options.user,
    };
  }

  if (!options.eventId) {
    options.eventId = hub.lastEventId();
  }

  const script = WINDOW.document.createElement('script');
  script.async = true;
  script.src = getReportDialogEndpoint(dsn, options);

  if (options.onLoad) {
    script.onload = options.onLoad;
  }

  const injectionPoint = WINDOW.document.head || WINDOW.document.body;
  if (injectionPoint) {
    injectionPoint.appendChild(script);
  } else {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger.error('Not injecting report dialog. No injection point found in HTML');
  }
}

/**
 * This is the getter for lastEventId.
 *
 * @returns The last event id of a captured event.
 */
function lastEventId() {
  return getCurrentHub().lastEventId();
}

/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */
function forceLoad() {
  // Noop
}

/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */
function onLoad(callback) {
  callback();
}

/**
 * Call `flush()` on the current client, if there is one. See {@link Client.flush}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue. Omitting this parameter will cause
 * the client to wait until all events are sent before resolving the promise.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */
function flush(timeout) {
  const client = getCurrentHub().getClient();
  if (client) {
    return client.flush(timeout);
  }
  (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger.warn('Cannot flush events. No client defined.');
  return resolvedSyncPromise(false);
}

/**
 * Call `close()` on the current client, if there is one. See {@link Client.close}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue before shutting down. Omitting this
 * parameter will cause the client to wait until all events are sent before disabling itself.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */
function sdk_close(timeout) {
  const client = getCurrentHub().getClient();
  if (client) {
    return client.close(timeout);
  }
  (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger.warn('Cannot flush events and disable SDK. No client defined.');
  return resolvedSyncPromise(false);
}

/**
 * Wrap code within a try/catch block so the SDK is able to capture errors.
 *
 * @param fn A function to wrap.
 *
 * @returns The result of wrapped function call.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function sdk_wrap(fn) {
  return wrap$1(fn)();
}

function startSessionOnHub(hub) {
  hub.startSession({ ignoreDuration: true });
  hub.captureSession();
}

/**
 * Enable automatic Session Tracking for the initial page load.
 */
function startSessionTracking() {
  if (typeof helpers_WINDOW.document === 'undefined') {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
      esm_logger/* logger.warn */.kg.warn('Session tracking in non-browser environment with @sentry/browser is not supported.');
    return;
  }

  const hub = (0,esm_hub/* getCurrentHub */.Gd)();

  // The only way for this to be false is for there to be a version mismatch between @sentry/browser (>= 6.0.0) and
  // @sentry/hub (< 5.27.0). In the simple case, there won't ever be such a mismatch, because the two packages are
  // pinned at the same version in package.json, but there are edge cases where it's possible. See
  // https://github.com/getsentry/sentry-javascript/issues/3207 and
  // https://github.com/getsentry/sentry-javascript/issues/3234 and
  // https://github.com/getsentry/sentry-javascript/issues/3278.
  if (!hub.captureSession) {
    return;
  }

  // The session duration for browser sessions does not track a meaningful
  // concept that can be used as a metric.
  // Automatically captured sessions are akin to page views, and thus we
  // discard their duration.
  startSessionOnHub(hub);

  // We want to create a session for every navigation as well
  (0,instrument/* addInstrumentationHandler */.o)('history', ({ from, to }) => {
    // Don't create an additional session for the initial route or if the location did not change
    if (!(from === undefined || from === to)) {
      startSessionOnHub((0,esm_hub/* getCurrentHub */.Gd)());
    }
  });
}


//# sourceMappingURL=sdk.js.map

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@sentry-react-virtual-3e0200223d/0/cache/@sentry-react-npm-7.32.1-bc2e0ddf02-3e67b9b9c9.zip/node_modules/@sentry/react/esm/sdk.js


/**
 * Inits the React SDK
 */
function sdk_init(options) {
  options._metadata = options._metadata || {};
  options._metadata.sdk = options._metadata.sdk || {
    name: 'sentry.javascript.react',
    packages: [
      {
        name: 'npm:@sentry/react',
        version: SDK_VERSION,
      },
    ],
    version: SDK_VERSION,
  };
  init(options);
}


//# sourceMappingURL=sdk.js.map

;// CONCATENATED MODULE: ../../.yarn/cache/@sentry-core-npm-7.32.1-f8255c7634-74ce787414.zip/node_modules/@sentry/core/esm/integrations/index.js


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ../../.yarn/cache/@sentry-browser-npm-7.32.1-b5270a3b99-279b2bfb32.zip/node_modules/@sentry/browser/esm/integrations/index.js






//# sourceMappingURL=index.js.map

// EXTERNAL MODULE: ../../.yarn/cache/@sentry-utils-npm-7.32.1-c99d3811fa-1b0d82cbcc.zip/node_modules/@sentry/utils/esm/node.js + 1 modules
var node = __webpack_require__(70302);
;// CONCATENATED MODULE: ../../.yarn/cache/@sentry-replay-npm-7.32.1-4814063d84-0df5b054a1.zip/node_modules/@sentry/replay/esm/index.js
/* provided dependency */ var process = __webpack_require__(97441);



// exporting a separate copy of `WINDOW` rather than exporting the one from `@sentry/browser`
// prevents the browser package from being bundled in the CDN bundle, and avoids a
// circular dependency between the browser and replay packages should `@sentry/browser` import
// from `@sentry/replay` in the future
const esm_WINDOW = worldwide/* GLOBAL_OBJ */.n2 ;

const REPLAY_SESSION_KEY = 'sentryReplaySession';
const REPLAY_EVENT_NAME = 'replay_event';
const UNABLE_TO_SEND_REPLAY = 'Unable to send Replay';

// The idle limit for a session
const SESSION_IDLE_DURATION = 300000; // 5 minutes in ms

// Grace period to keep a session when a user changes tabs or hides window
const VISIBILITY_CHANGE_TIMEOUT = SESSION_IDLE_DURATION;

// The maximum length of a session
const MAX_SESSION_LIFE = 3600000; // 60 minutes

/**
 * Defaults for sampling rates
 */
const DEFAULT_SESSION_SAMPLE_RATE = 0.1;
const DEFAULT_ERROR_SAMPLE_RATE = 1.0;

/** The select to use for the `maskAllText` option  */
const MASK_ALL_TEXT_SELECTOR = 'body *:not(style), body *:not(script)';

/** Default flush delays */
const DEFAULT_FLUSH_MIN_DELAY = 5000;
const DEFAULT_FLUSH_MAX_DELAY = 5000;

const RETRY_BASE_INTERVAL = 5000;
const RETRY_MAX_COUNT = 3;

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

var NodeType;
(function (NodeType) {
    NodeType[NodeType["Document"] = 0] = "Document";
    NodeType[NodeType["DocumentType"] = 1] = "DocumentType";
    NodeType[NodeType["Element"] = 2] = "Element";
    NodeType[NodeType["Text"] = 3] = "Text";
    NodeType[NodeType["CDATA"] = 4] = "CDATA";
    NodeType[NodeType["Comment"] = 5] = "Comment";
})(NodeType || (NodeType = {}));

function isElement(n) {
    return n.nodeType === n.ELEMENT_NODE;
}
function isShadowRoot(n) {
    var _a;
    var host = (_a = n) === null || _a === void 0 ? void 0 : _a.host;
    return Boolean(host && host.shadowRoot && host.shadowRoot === n);
}
function maskInputValue(_a) {
    var maskInputOptions = _a.maskInputOptions, tagName = _a.tagName, type = _a.type, value = _a.value, maskInputFn = _a.maskInputFn;
    var text = value || '';
    if (maskInputOptions[tagName.toLowerCase()] ||
        maskInputOptions[type]) {
        if (maskInputFn) {
            text = maskInputFn(text);
        }
        else {
            text = '*'.repeat(text.length);
        }
    }
    return text;
}
var ORIGINAL_ATTRIBUTE_NAME = '__rrweb_original__';
function is2DCanvasBlank(canvas) {
    var ctx = canvas.getContext('2d');
    if (!ctx)
        return true;
    var chunkSize = 50;
    for (var x = 0; x < canvas.width; x += chunkSize) {
        for (var y = 0; y < canvas.height; y += chunkSize) {
            var getImageData = ctx.getImageData;
            var originalGetImageData = ORIGINAL_ATTRIBUTE_NAME in getImageData
                ? getImageData[ORIGINAL_ATTRIBUTE_NAME]
                : getImageData;
            var pixelBuffer = new Uint32Array(originalGetImageData.call(ctx, x, y, Math.min(chunkSize, canvas.width - x), Math.min(chunkSize, canvas.height - y)).data.buffer);
            if (pixelBuffer.some(function (pixel) { return pixel !== 0; }))
                return false;
        }
    }
    return true;
}

var _id = 1;
var tagNameRegex = new RegExp('[^a-z0-9-_:]');
var IGNORED_NODE = -2;
function genId() {
    return _id++;
}
function getValidTagName(element) {
    if (element instanceof HTMLFormElement) {
        return 'form';
    }
    var processedTagName = element.tagName.toLowerCase().trim();
    if (tagNameRegex.test(processedTagName)) {
        return 'div';
    }
    return processedTagName;
}
function getCssRulesString(s) {
    try {
        var rules = s.rules || s.cssRules;
        return rules ? Array.from(rules).map(getCssRuleString).join('') : null;
    }
    catch (error) {
        return null;
    }
}
function getCssRuleString(rule) {
    var cssStringified = rule.cssText;
    if (isCSSImportRule(rule)) {
        try {
            cssStringified = getCssRulesString(rule.styleSheet) || cssStringified;
        }
        catch (_a) {
        }
    }
    return cssStringified;
}
function isCSSImportRule(rule) {
    return 'styleSheet' in rule;
}
function stringifyStyleSheet(sheet) {
    return sheet.cssRules
        ? Array.from(sheet.cssRules)
            .map(function (rule) { return rule.cssText || ''; })
            .join('')
        : '';
}
function extractOrigin(url) {
    var origin = '';
    if (url.indexOf('//') > -1) {
        origin = url.split('/').slice(0, 3).join('/');
    }
    else {
        origin = url.split('/')[0];
    }
    origin = origin.split('?')[0];
    return origin;
}
var canvasService;
var canvasCtx;
var URL_IN_CSS_REF = /url\((?:(')([^']*)'|(")(.*?)"|([^)]*))\)/gm;
var RELATIVE_PATH = /^(?!www\.|(?:http|ftp)s?:\/\/|[A-Za-z]:\\|\/\/|#).*/;
var DATA_URI = /^(data:)([^,]*),(.*)/i;
function absoluteToStylesheet(cssText, href) {
    return (cssText || '').replace(URL_IN_CSS_REF, function (origin, quote1, path1, quote2, path2, path3) {
        var filePath = path1 || path2 || path3;
        var maybeQuote = quote1 || quote2 || '';
        if (!filePath) {
            return origin;
        }
        if (!RELATIVE_PATH.test(filePath)) {
            return "url(" + maybeQuote + filePath + maybeQuote + ")";
        }
        if (DATA_URI.test(filePath)) {
            return "url(" + maybeQuote + filePath + maybeQuote + ")";
        }
        if (filePath[0] === '/') {
            return "url(" + maybeQuote + (extractOrigin(href) + filePath) + maybeQuote + ")";
        }
        var stack = href.split('/');
        var parts = filePath.split('/');
        stack.pop();
        for (var _i = 0, parts_1 = parts; _i < parts_1.length; _i++) {
            var part = parts_1[_i];
            if (part === '.') {
                continue;
            }
            else if (part === '..') {
                stack.pop();
            }
            else {
                stack.push(part);
            }
        }
        return "url(" + maybeQuote + stack.join('/') + maybeQuote + ")";
    });
}
var SRCSET_NOT_SPACES = /^[^ \t\n\r\u000c]+/;
var SRCSET_COMMAS_OR_SPACES = /^[, \t\n\r\u000c]+/;
function getAbsoluteSrcsetString(doc, attributeValue) {
    if (attributeValue.trim() === '') {
        return attributeValue;
    }
    var pos = 0;
    function collectCharacters(regEx) {
        var chars;
        var match = regEx.exec(attributeValue.substring(pos));
        if (match) {
            chars = match[0];
            pos += chars.length;
            return chars;
        }
        return '';
    }
    var output = [];
    while (true) {
        collectCharacters(SRCSET_COMMAS_OR_SPACES);
        if (pos >= attributeValue.length) {
            break;
        }
        var url = collectCharacters(SRCSET_NOT_SPACES);
        if (url.slice(-1) === ',') {
            url = absoluteToDoc(doc, url.substring(0, url.length - 1));
            output.push(url);
        }
        else {
            var descriptorsStr = '';
            url = absoluteToDoc(doc, url);
            var inParens = false;
            while (true) {
                var c = attributeValue.charAt(pos);
                if (c === '') {
                    output.push((url + descriptorsStr).trim());
                    break;
                }
                else if (!inParens) {
                    if (c === ',') {
                        pos += 1;
                        output.push((url + descriptorsStr).trim());
                        break;
                    }
                    else if (c === '(') {
                        inParens = true;
                    }
                }
                else {
                    if (c === ')') {
                        inParens = false;
                    }
                }
                descriptorsStr += c;
                pos += 1;
            }
        }
    }
    return output.join(', ');
}
function absoluteToDoc(doc, attributeValue) {
    if (!attributeValue || attributeValue.trim() === '') {
        return attributeValue;
    }
    var a = doc.createElement('a');
    a.href = attributeValue;
    return a.href;
}
function isSVGElement(el) {
    return Boolean(el.tagName === 'svg' || el.ownerSVGElement);
}
function getHref() {
    var a = document.createElement('a');
    a.href = '';
    return a.href;
}
function transformAttribute(doc, tagName, name, value) {
    if (name === 'src' || (name === 'href' && value)) {
        return absoluteToDoc(doc, value);
    }
    else if (name === 'xlink:href' && value && value[0] !== '#') {
        return absoluteToDoc(doc, value);
    }
    else if (name === 'background' &&
        value &&
        (tagName === 'table' || tagName === 'td' || tagName === 'th')) {
        return absoluteToDoc(doc, value);
    }
    else if (name === 'srcset' && value) {
        return getAbsoluteSrcsetString(doc, value);
    }
    else if (name === 'style' && value) {
        return absoluteToStylesheet(value, getHref());
    }
    else if (tagName === 'object' && name === 'data' && value) {
        return absoluteToDoc(doc, value);
    }
    else {
        return value;
    }
}
function _isBlockedElement(element, blockClass, blockSelector) {
    if (typeof blockClass === 'string') {
        if (element.classList.contains(blockClass)) {
            return true;
        }
    }
    else {
        for (var eIndex = 0; eIndex < element.classList.length; eIndex++) {
            var className = element.classList[eIndex];
            if (blockClass.test(className)) {
                return true;
            }
        }
    }
    if (blockSelector) {
        return element.matches(blockSelector);
    }
    return false;
}
function needMaskingText(node, maskTextClass, maskTextSelector) {
    if (!node) {
        return false;
    }
    if (node.nodeType === node.ELEMENT_NODE) {
        if (typeof maskTextClass === 'string') {
            if (node.classList.contains(maskTextClass)) {
                return true;
            }
        }
        else {
            for (var eIndex = 0; eIndex < node.classList.length; eIndex++) {
                var className = node.classList[eIndex];
                if (maskTextClass.test(className)) {
                    return true;
                }
            }
        }
        if (maskTextSelector) {
            if (node.matches(maskTextSelector)) {
                return true;
            }
        }
        return needMaskingText(node.parentNode, maskTextClass, maskTextSelector);
    }
    if (node.nodeType === node.TEXT_NODE) {
        return needMaskingText(node.parentNode, maskTextClass, maskTextSelector);
    }
    return needMaskingText(node.parentNode, maskTextClass, maskTextSelector);
}
function onceIframeLoaded(iframeEl, listener, iframeLoadTimeout) {
    var win = iframeEl.contentWindow;
    if (!win) {
        return;
    }
    var fired = false;
    var readyState;
    try {
        readyState = win.document.readyState;
    }
    catch (error) {
        return;
    }
    if (readyState !== 'complete') {
        var timer_1 = setTimeout(function () {
            if (!fired) {
                listener();
                fired = true;
            }
        }, iframeLoadTimeout);
        iframeEl.addEventListener('load', function () {
            clearTimeout(timer_1);
            fired = true;
            listener();
        });
        return;
    }
    var blankUrl = 'about:blank';
    if (win.location.href !== blankUrl ||
        iframeEl.src === blankUrl ||
        iframeEl.src === '') {
        setTimeout(listener, 0);
        return;
    }
    iframeEl.addEventListener('load', listener);
}
function serializeNode(n, options) {
    var _a;
    var doc = options.doc, blockClass = options.blockClass, blockSelector = options.blockSelector, maskTextClass = options.maskTextClass, maskTextSelector = options.maskTextSelector, inlineStylesheet = options.inlineStylesheet, _b = options.maskInputOptions, maskInputOptions = _b === void 0 ? {} : _b, maskTextFn = options.maskTextFn, maskInputFn = options.maskInputFn, _c = options.dataURLOptions, dataURLOptions = _c === void 0 ? {} : _c, inlineImages = options.inlineImages, recordCanvas = options.recordCanvas, keepIframeSrcFn = options.keepIframeSrcFn;
    var rootId;
    if (doc.__sn) {
        var docId = doc.__sn.id;
        rootId = docId === 1 ? undefined : docId;
    }
    switch (n.nodeType) {
        case n.DOCUMENT_NODE:
            if (n.compatMode !== 'CSS1Compat') {
                return {
                    type: NodeType.Document,
                    childNodes: [],
                    compatMode: n.compatMode,
                    rootId: rootId
                };
            }
            else {
                return {
                    type: NodeType.Document,
                    childNodes: [],
                    rootId: rootId
                };
            }
        case n.DOCUMENT_TYPE_NODE:
            return {
                type: NodeType.DocumentType,
                name: n.name,
                publicId: n.publicId,
                systemId: n.systemId,
                rootId: rootId
            };
        case n.ELEMENT_NODE:
            var needBlock = _isBlockedElement(n, blockClass, blockSelector);
            var tagName = getValidTagName(n);
            var attributes_1 = {};
            for (var _i = 0, _d = Array.from(n.attributes); _i < _d.length; _i++) {
                var _e = _d[_i], name_1 = _e.name, value = _e.value;
                attributes_1[name_1] = transformAttribute(doc, tagName, name_1, value);
            }
            if (tagName === 'link' && inlineStylesheet) {
                var stylesheet = Array.from(doc.styleSheets).find(function (s) {
                    return s.href === n.href;
                });
                var cssText = null;
                if (stylesheet) {
                    cssText = getCssRulesString(stylesheet);
                }
                if (cssText) {
                    delete attributes_1.rel;
                    delete attributes_1.href;
                    attributes_1._cssText = absoluteToStylesheet(cssText, stylesheet.href);
                }
            }
            if (tagName === 'style' &&
                n.sheet &&
                !(n.innerText ||
                    n.textContent ||
                    '').trim().length) {
                var cssText = getCssRulesString(n.sheet);
                if (cssText) {
                    attributes_1._cssText = absoluteToStylesheet(cssText, getHref());
                }
            }
            if (tagName === 'input' ||
                tagName === 'textarea' ||
                tagName === 'select') {
                var value = n.value;
                if (attributes_1.type !== 'radio' &&
                    attributes_1.type !== 'checkbox' &&
                    attributes_1.type !== 'submit' &&
                    attributes_1.type !== 'button' &&
                    value) {
                    attributes_1.value = maskInputValue({
                        type: attributes_1.type,
                        tagName: tagName,
                        value: value,
                        maskInputOptions: maskInputOptions,
                        maskInputFn: maskInputFn
                    });
                }
                else if (n.checked) {
                    attributes_1.checked = n.checked;
                }
            }
            if (tagName === 'option') {
                if (n.selected && !maskInputOptions['select']) {
                    attributes_1.selected = true;
                }
                else {
                    delete attributes_1.selected;
                }
            }
            if (tagName === 'canvas' && recordCanvas) {
                if (n.__context === '2d') {
                    if (!is2DCanvasBlank(n)) {
                        attributes_1.rr_dataURL = n.toDataURL(dataURLOptions.type, dataURLOptions.quality);
                    }
                }
                else if (!('__context' in n)) {
                    var canvasDataURL = n.toDataURL(dataURLOptions.type, dataURLOptions.quality);
                    var blankCanvas = document.createElement('canvas');
                    blankCanvas.width = n.width;
                    blankCanvas.height = n.height;
                    var blankCanvasDataURL = blankCanvas.toDataURL(dataURLOptions.type, dataURLOptions.quality);
                    if (canvasDataURL !== blankCanvasDataURL) {
                        attributes_1.rr_dataURL = canvasDataURL;
                    }
                }
            }
            if (tagName === 'img' && inlineImages) {
                if (!canvasService) {
                    canvasService = doc.createElement('canvas');
                    canvasCtx = canvasService.getContext('2d');
                }
                var image_1 = n;
                var oldValue_1 = image_1.crossOrigin;
                image_1.crossOrigin = 'anonymous';
                var recordInlineImage = function () {
                    try {
                        canvasService.width = image_1.naturalWidth;
                        canvasService.height = image_1.naturalHeight;
                        canvasCtx.drawImage(image_1, 0, 0);
                        attributes_1.rr_dataURL = canvasService.toDataURL(dataURLOptions.type, dataURLOptions.quality);
                    }
                    catch (err) {
                        console.warn("Cannot inline img src=" + image_1.currentSrc + "! Error: " + err);
                    }
                    oldValue_1
                        ? (attributes_1.crossOrigin = oldValue_1)
                        : delete attributes_1.crossOrigin;
                };
                if (image_1.complete && image_1.naturalWidth !== 0)
                    recordInlineImage();
                else
                    image_1.onload = recordInlineImage;
            }
            if (tagName === 'audio' || tagName === 'video') {
                attributes_1.rr_mediaState = n.paused
                    ? 'paused'
                    : 'played';
                attributes_1.rr_mediaCurrentTime = n.currentTime;
            }
            if (n.scrollLeft) {
                attributes_1.rr_scrollLeft = n.scrollLeft;
            }
            if (n.scrollTop) {
                attributes_1.rr_scrollTop = n.scrollTop;
            }
            if (needBlock) {
                var _f = n.getBoundingClientRect(), width = _f.width, height = _f.height;
                attributes_1 = {
                    "class": attributes_1["class"],
                    rr_width: width + "px",
                    rr_height: height + "px"
                };
            }
            if (tagName === 'iframe' && !keepIframeSrcFn(attributes_1.src)) {
                if (!n.contentDocument) {
                    attributes_1.rr_src = attributes_1.src;
                }
                delete attributes_1.src;
            }
            return {
                type: NodeType.Element,
                tagName: tagName,
                attributes: attributes_1,
                childNodes: [],
                isSVG: isSVGElement(n) || undefined,
                needBlock: needBlock,
                rootId: rootId
            };
        case n.TEXT_NODE:
            var parentTagName = n.parentNode && n.parentNode.tagName;
            var textContent = n.textContent;
            var isStyle = parentTagName === 'STYLE' ? true : undefined;
            var isScript = parentTagName === 'SCRIPT' ? true : undefined;
            if (isStyle && textContent) {
                try {
                    if (n.nextSibling || n.previousSibling) {
                    }
                    else if ((_a = n.parentNode.sheet) === null || _a === void 0 ? void 0 : _a.cssRules) {
                        textContent = stringifyStyleSheet(n.parentNode.sheet);
                    }
                }
                catch (err) {
                    console.warn("Cannot get CSS styles from text's parentNode. Error: " + err, n);
                }
                textContent = absoluteToStylesheet(textContent, getHref());
            }
            if (isScript) {
                textContent = 'SCRIPT_PLACEHOLDER';
            }
            if (!isStyle &&
                !isScript &&
                needMaskingText(n, maskTextClass, maskTextSelector) &&
                textContent) {
                textContent = maskTextFn
                    ? maskTextFn(textContent)
                    : textContent.replace(/[\S]/g, '*');
            }
            return {
                type: NodeType.Text,
                textContent: textContent || '',
                isStyle: isStyle,
                rootId: rootId
            };
        case n.CDATA_SECTION_NODE:
            return {
                type: NodeType.CDATA,
                textContent: '',
                rootId: rootId
            };
        case n.COMMENT_NODE:
            return {
                type: NodeType.Comment,
                textContent: n.textContent || '',
                rootId: rootId
            };
        default:
            return false;
    }
}
function lowerIfExists(maybeAttr) {
    if (maybeAttr === undefined) {
        return '';
    }
    else {
        return maybeAttr.toLowerCase();
    }
}
function slimDOMExcluded(sn, slimDOMOptions) {
    if (slimDOMOptions.comment && sn.type === NodeType.Comment) {
        return true;
    }
    else if (sn.type === NodeType.Element) {
        if (slimDOMOptions.script &&
            (sn.tagName === 'script' ||
                (sn.tagName === 'link' &&
                    sn.attributes.rel === 'preload' &&
                    sn.attributes.as === 'script') ||
                (sn.tagName === 'link' &&
                    sn.attributes.rel === 'prefetch' &&
                    typeof sn.attributes.href === 'string' &&
                    sn.attributes.href.endsWith('.js')))) {
            return true;
        }
        else if (slimDOMOptions.headFavicon &&
            ((sn.tagName === 'link' && sn.attributes.rel === 'shortcut icon') ||
                (sn.tagName === 'meta' &&
                    (lowerIfExists(sn.attributes.name).match(/^msapplication-tile(image|color)$/) ||
                        lowerIfExists(sn.attributes.name) === 'application-name' ||
                        lowerIfExists(sn.attributes.rel) === 'icon' ||
                        lowerIfExists(sn.attributes.rel) === 'apple-touch-icon' ||
                        lowerIfExists(sn.attributes.rel) === 'shortcut icon')))) {
            return true;
        }
        else if (sn.tagName === 'meta') {
            if (slimDOMOptions.headMetaDescKeywords &&
                lowerIfExists(sn.attributes.name).match(/^description|keywords$/)) {
                return true;
            }
            else if (slimDOMOptions.headMetaSocial &&
                (lowerIfExists(sn.attributes.property).match(/^(og|twitter|fb):/) ||
                    lowerIfExists(sn.attributes.name).match(/^(og|twitter):/) ||
                    lowerIfExists(sn.attributes.name) === 'pinterest')) {
                return true;
            }
            else if (slimDOMOptions.headMetaRobots &&
                (lowerIfExists(sn.attributes.name) === 'robots' ||
                    lowerIfExists(sn.attributes.name) === 'googlebot' ||
                    lowerIfExists(sn.attributes.name) === 'bingbot')) {
                return true;
            }
            else if (slimDOMOptions.headMetaHttpEquiv &&
                sn.attributes['http-equiv'] !== undefined) {
                return true;
            }
            else if (slimDOMOptions.headMetaAuthorship &&
                (lowerIfExists(sn.attributes.name) === 'author' ||
                    lowerIfExists(sn.attributes.name) === 'generator' ||
                    lowerIfExists(sn.attributes.name) === 'framework' ||
                    lowerIfExists(sn.attributes.name) === 'publisher' ||
                    lowerIfExists(sn.attributes.name) === 'progid' ||
                    lowerIfExists(sn.attributes.property).match(/^article:/) ||
                    lowerIfExists(sn.attributes.property).match(/^product:/))) {
                return true;
            }
            else if (slimDOMOptions.headMetaVerification &&
                (lowerIfExists(sn.attributes.name) === 'google-site-verification' ||
                    lowerIfExists(sn.attributes.name) === 'yandex-verification' ||
                    lowerIfExists(sn.attributes.name) === 'csrf-token' ||
                    lowerIfExists(sn.attributes.name) === 'p:domain_verify' ||
                    lowerIfExists(sn.attributes.name) === 'verify-v1' ||
                    lowerIfExists(sn.attributes.name) === 'verification' ||
                    lowerIfExists(sn.attributes.name) === 'shopify-checkout-api-token')) {
                return true;
            }
        }
    }
    return false;
}
function serializeNodeWithId(n, options) {
    var doc = options.doc, map = options.map, blockClass = options.blockClass, blockSelector = options.blockSelector, maskTextClass = options.maskTextClass, maskTextSelector = options.maskTextSelector, _a = options.skipChild, skipChild = _a === void 0 ? false : _a, _b = options.inlineStylesheet, inlineStylesheet = _b === void 0 ? true : _b, _c = options.maskInputOptions, maskInputOptions = _c === void 0 ? {} : _c, maskTextFn = options.maskTextFn, maskInputFn = options.maskInputFn, slimDOMOptions = options.slimDOMOptions, _d = options.dataURLOptions, dataURLOptions = _d === void 0 ? {} : _d, _e = options.inlineImages, inlineImages = _e === void 0 ? false : _e, _f = options.recordCanvas, recordCanvas = _f === void 0 ? false : _f, onSerialize = options.onSerialize, onIframeLoad = options.onIframeLoad, _g = options.iframeLoadTimeout, iframeLoadTimeout = _g === void 0 ? 5000 : _g, _h = options.keepIframeSrcFn, keepIframeSrcFn = _h === void 0 ? function () { return false; } : _h;
    var _j = options.preserveWhiteSpace, preserveWhiteSpace = _j === void 0 ? true : _j;
    var _serializedNode = serializeNode(n, {
        doc: doc,
        blockClass: blockClass,
        blockSelector: blockSelector,
        maskTextClass: maskTextClass,
        maskTextSelector: maskTextSelector,
        inlineStylesheet: inlineStylesheet,
        maskInputOptions: maskInputOptions,
        maskTextFn: maskTextFn,
        maskInputFn: maskInputFn,
        dataURLOptions: dataURLOptions,
        inlineImages: inlineImages,
        recordCanvas: recordCanvas,
        keepIframeSrcFn: keepIframeSrcFn
    });
    if (!_serializedNode) {
        console.warn(n, 'not serialized');
        return null;
    }
    var id;
    if ('__sn' in n) {
        id = n.__sn.id;
    }
    else if (slimDOMExcluded(_serializedNode, slimDOMOptions) ||
        (!preserveWhiteSpace &&
            _serializedNode.type === NodeType.Text &&
            !_serializedNode.isStyle &&
            !_serializedNode.textContent.replace(/^\s+|\s+$/gm, '').length)) {
        id = IGNORED_NODE;
    }
    else {
        id = genId();
    }
    var serializedNode = Object.assign(_serializedNode, { id: id });
    n.__sn = serializedNode;
    if (id === IGNORED_NODE) {
        return null;
    }
    map[id] = n;
    if (onSerialize) {
        onSerialize(n);
    }
    var recordChild = !skipChild;
    if (serializedNode.type === NodeType.Element) {
        recordChild = recordChild && !serializedNode.needBlock;
        delete serializedNode.needBlock;
        if (n.shadowRoot)
            serializedNode.isShadowHost = true;
    }
    if ((serializedNode.type === NodeType.Document ||
        serializedNode.type === NodeType.Element) &&
        recordChild) {
        if (slimDOMOptions.headWhitespace &&
            _serializedNode.type === NodeType.Element &&
            _serializedNode.tagName === 'head') {
            preserveWhiteSpace = false;
        }
        var bypassOptions = {
            doc: doc,
            map: map,
            blockClass: blockClass,
            blockSelector: blockSelector,
            maskTextClass: maskTextClass,
            maskTextSelector: maskTextSelector,
            skipChild: skipChild,
            inlineStylesheet: inlineStylesheet,
            maskInputOptions: maskInputOptions,
            maskTextFn: maskTextFn,
            maskInputFn: maskInputFn,
            slimDOMOptions: slimDOMOptions,
            dataURLOptions: dataURLOptions,
            inlineImages: inlineImages,
            recordCanvas: recordCanvas,
            preserveWhiteSpace: preserveWhiteSpace,
            onSerialize: onSerialize,
            onIframeLoad: onIframeLoad,
            iframeLoadTimeout: iframeLoadTimeout,
            keepIframeSrcFn: keepIframeSrcFn
        };
        for (var _i = 0, _k = Array.from(n.childNodes); _i < _k.length; _i++) {
            var childN = _k[_i];
            var serializedChildNode = serializeNodeWithId(childN, bypassOptions);
            if (serializedChildNode) {
                serializedNode.childNodes.push(serializedChildNode);
            }
        }
        if (isElement(n) && n.shadowRoot) {
            for (var _l = 0, _m = Array.from(n.shadowRoot.childNodes); _l < _m.length; _l++) {
                var childN = _m[_l];
                var serializedChildNode = serializeNodeWithId(childN, bypassOptions);
                if (serializedChildNode) {
                    serializedChildNode.isShadow = true;
                    serializedNode.childNodes.push(serializedChildNode);
                }
            }
        }
    }
    if (n.parentNode && isShadowRoot(n.parentNode)) {
        serializedNode.isShadow = true;
    }
    if (serializedNode.type === NodeType.Element &&
        serializedNode.tagName === 'iframe') {
        onceIframeLoaded(n, function () {
            var iframeDoc = n.contentDocument;
            if (iframeDoc && onIframeLoad) {
                var serializedIframeNode = serializeNodeWithId(iframeDoc, {
                    doc: iframeDoc,
                    map: map,
                    blockClass: blockClass,
                    blockSelector: blockSelector,
                    maskTextClass: maskTextClass,
                    maskTextSelector: maskTextSelector,
                    skipChild: false,
                    inlineStylesheet: inlineStylesheet,
                    maskInputOptions: maskInputOptions,
                    maskTextFn: maskTextFn,
                    maskInputFn: maskInputFn,
                    slimDOMOptions: slimDOMOptions,
                    dataURLOptions: dataURLOptions,
                    inlineImages: inlineImages,
                    recordCanvas: recordCanvas,
                    preserveWhiteSpace: preserveWhiteSpace,
                    onSerialize: onSerialize,
                    onIframeLoad: onIframeLoad,
                    iframeLoadTimeout: iframeLoadTimeout,
                    keepIframeSrcFn: keepIframeSrcFn
                });
                if (serializedIframeNode) {
                    onIframeLoad(n, serializedIframeNode);
                }
            }
        }, iframeLoadTimeout);
    }
    return serializedNode;
}
function snapshot(n, options) {
    var _a = options || {}, _b = _a.blockClass, blockClass = _b === void 0 ? 'rr-block' : _b, _c = _a.blockSelector, blockSelector = _c === void 0 ? null : _c, _d = _a.maskTextClass, maskTextClass = _d === void 0 ? 'rr-mask' : _d, _e = _a.maskTextSelector, maskTextSelector = _e === void 0 ? null : _e, _f = _a.inlineStylesheet, inlineStylesheet = _f === void 0 ? true : _f, _g = _a.inlineImages, inlineImages = _g === void 0 ? false : _g, _h = _a.recordCanvas, recordCanvas = _h === void 0 ? false : _h, _j = _a.maskAllInputs, maskAllInputs = _j === void 0 ? false : _j, maskTextFn = _a.maskTextFn, maskInputFn = _a.maskInputFn, _k = _a.slimDOM, slimDOM = _k === void 0 ? false : _k, dataURLOptions = _a.dataURLOptions, preserveWhiteSpace = _a.preserveWhiteSpace, onSerialize = _a.onSerialize, onIframeLoad = _a.onIframeLoad, iframeLoadTimeout = _a.iframeLoadTimeout, _l = _a.keepIframeSrcFn, keepIframeSrcFn = _l === void 0 ? function () { return false; } : _l;
    var idNodeMap = {};
    var maskInputOptions = maskAllInputs === true
        ? {
            color: true,
            date: true,
            'datetime-local': true,
            email: true,
            month: true,
            number: true,
            range: true,
            search: true,
            tel: true,
            text: true,
            time: true,
            url: true,
            week: true,
            textarea: true,
            select: true,
            password: true
        }
        : maskAllInputs === false
            ? {
                password: true
            }
            : maskAllInputs;
    var slimDOMOptions = slimDOM === true || slimDOM === 'all'
        ?
            {
                script: true,
                comment: true,
                headFavicon: true,
                headWhitespace: true,
                headMetaDescKeywords: slimDOM === 'all',
                headMetaSocial: true,
                headMetaRobots: true,
                headMetaHttpEquiv: true,
                headMetaAuthorship: true,
                headMetaVerification: true
            }
        : slimDOM === false
            ? {}
            : slimDOM;
    return [
        serializeNodeWithId(n, {
            doc: n,
            map: idNodeMap,
            blockClass: blockClass,
            blockSelector: blockSelector,
            maskTextClass: maskTextClass,
            maskTextSelector: maskTextSelector,
            skipChild: false,
            inlineStylesheet: inlineStylesheet,
            maskInputOptions: maskInputOptions,
            maskTextFn: maskTextFn,
            maskInputFn: maskInputFn,
            slimDOMOptions: slimDOMOptions,
            dataURLOptions: dataURLOptions,
            inlineImages: inlineImages,
            recordCanvas: recordCanvas,
            preserveWhiteSpace: preserveWhiteSpace,
            onSerialize: onSerialize,
            onIframeLoad: onIframeLoad,
            iframeLoadTimeout: iframeLoadTimeout,
            keepIframeSrcFn: keepIframeSrcFn
        }),
        idNodeMap,
    ];
}

var EventType;
(function (EventType) {
    EventType[EventType["DomContentLoaded"] = 0] = "DomContentLoaded";
    EventType[EventType["Load"] = 1] = "Load";
    EventType[EventType["FullSnapshot"] = 2] = "FullSnapshot";
    EventType[EventType["IncrementalSnapshot"] = 3] = "IncrementalSnapshot";
    EventType[EventType["Meta"] = 4] = "Meta";
    EventType[EventType["Custom"] = 5] = "Custom";
    EventType[EventType["Plugin"] = 6] = "Plugin";
})(EventType || (EventType = {}));
var IncrementalSource;
(function (IncrementalSource) {
    IncrementalSource[IncrementalSource["Mutation"] = 0] = "Mutation";
    IncrementalSource[IncrementalSource["MouseMove"] = 1] = "MouseMove";
    IncrementalSource[IncrementalSource["MouseInteraction"] = 2] = "MouseInteraction";
    IncrementalSource[IncrementalSource["Scroll"] = 3] = "Scroll";
    IncrementalSource[IncrementalSource["ViewportResize"] = 4] = "ViewportResize";
    IncrementalSource[IncrementalSource["Input"] = 5] = "Input";
    IncrementalSource[IncrementalSource["TouchMove"] = 6] = "TouchMove";
    IncrementalSource[IncrementalSource["MediaInteraction"] = 7] = "MediaInteraction";
    IncrementalSource[IncrementalSource["StyleSheetRule"] = 8] = "StyleSheetRule";
    IncrementalSource[IncrementalSource["CanvasMutation"] = 9] = "CanvasMutation";
    IncrementalSource[IncrementalSource["Font"] = 10] = "Font";
    IncrementalSource[IncrementalSource["Log"] = 11] = "Log";
    IncrementalSource[IncrementalSource["Drag"] = 12] = "Drag";
    IncrementalSource[IncrementalSource["StyleDeclaration"] = 13] = "StyleDeclaration";
})(IncrementalSource || (IncrementalSource = {}));
var MouseInteractions;
(function (MouseInteractions) {
    MouseInteractions[MouseInteractions["MouseUp"] = 0] = "MouseUp";
    MouseInteractions[MouseInteractions["MouseDown"] = 1] = "MouseDown";
    MouseInteractions[MouseInteractions["Click"] = 2] = "Click";
    MouseInteractions[MouseInteractions["ContextMenu"] = 3] = "ContextMenu";
    MouseInteractions[MouseInteractions["DblClick"] = 4] = "DblClick";
    MouseInteractions[MouseInteractions["Focus"] = 5] = "Focus";
    MouseInteractions[MouseInteractions["Blur"] = 6] = "Blur";
    MouseInteractions[MouseInteractions["TouchStart"] = 7] = "TouchStart";
    MouseInteractions[MouseInteractions["TouchMove_Departed"] = 8] = "TouchMove_Departed";
    MouseInteractions[MouseInteractions["TouchEnd"] = 9] = "TouchEnd";
    MouseInteractions[MouseInteractions["TouchCancel"] = 10] = "TouchCancel";
})(MouseInteractions || (MouseInteractions = {}));
var CanvasContext;
(function (CanvasContext) {
    CanvasContext[CanvasContext["2D"] = 0] = "2D";
    CanvasContext[CanvasContext["WebGL"] = 1] = "WebGL";
    CanvasContext[CanvasContext["WebGL2"] = 2] = "WebGL2";
})(CanvasContext || (CanvasContext = {}));
var MediaInteractions;
(function (MediaInteractions) {
    MediaInteractions[MediaInteractions["Play"] = 0] = "Play";
    MediaInteractions[MediaInteractions["Pause"] = 1] = "Pause";
    MediaInteractions[MediaInteractions["Seeked"] = 2] = "Seeked";
    MediaInteractions[MediaInteractions["VolumeChange"] = 3] = "VolumeChange";
})(MediaInteractions || (MediaInteractions = {}));
var ReplayerEvents;
(function (ReplayerEvents) {
    ReplayerEvents["Start"] = "start";
    ReplayerEvents["Pause"] = "pause";
    ReplayerEvents["Resume"] = "resume";
    ReplayerEvents["Resize"] = "resize";
    ReplayerEvents["Finish"] = "finish";
    ReplayerEvents["FullsnapshotRebuilded"] = "fullsnapshot-rebuilded";
    ReplayerEvents["LoadStylesheetStart"] = "load-stylesheet-start";
    ReplayerEvents["LoadStylesheetEnd"] = "load-stylesheet-end";
    ReplayerEvents["SkipStart"] = "skip-start";
    ReplayerEvents["SkipEnd"] = "skip-end";
    ReplayerEvents["MouseInteraction"] = "mouse-interaction";
    ReplayerEvents["EventCast"] = "event-cast";
    ReplayerEvents["CustomEvent"] = "custom-event";
    ReplayerEvents["Flush"] = "flush";
    ReplayerEvents["StateChange"] = "state-change";
    ReplayerEvents["PlayBack"] = "play-back";
})(ReplayerEvents || (ReplayerEvents = {}));

function on(type, fn, target) {
    if (target === void 0) { target = document; }
    var options = { capture: true, passive: true };
    target.addEventListener(type, fn, options);
    return function () { return target.removeEventListener(type, fn, options); };
}
function createMirror() {
    return {
        map: {},
        getId: function (n) {
            if (!n || !n.__sn) {
                return -1;
            }
            return n.__sn.id;
        },
        getNode: function (id) {
            return this.map[id] || null;
        },
        removeNodeFromMap: function (n) {
            var _this = this;
            var id = n.__sn && n.__sn.id;
            delete this.map[id];
            if (n.childNodes) {
                n.childNodes.forEach(function (child) {
                    return _this.removeNodeFromMap(child);
                });
            }
        },
        has: function (id) {
            return this.map.hasOwnProperty(id);
        },
        reset: function () {
            this.map = {};
        },
    };
}
var DEPARTED_MIRROR_ACCESS_WARNING = 'Please stop import mirror directly. Instead of that,' +
    '\r\n' +
    'now you can use replayer.getMirror() to access the mirror instance of a replayer,' +
    '\r\n' +
    'or you can use record.mirror to access the mirror instance during recording.';
var _mirror = {
    map: {},
    getId: function () {
        console.error(DEPARTED_MIRROR_ACCESS_WARNING);
        return -1;
    },
    getNode: function () {
        console.error(DEPARTED_MIRROR_ACCESS_WARNING);
        return null;
    },
    removeNodeFromMap: function () {
        console.error(DEPARTED_MIRROR_ACCESS_WARNING);
    },
    has: function () {
        console.error(DEPARTED_MIRROR_ACCESS_WARNING);
        return false;
    },
    reset: function () {
        console.error(DEPARTED_MIRROR_ACCESS_WARNING);
    },
};
if (typeof window !== 'undefined' && window.Proxy && window.Reflect) {
    _mirror = new Proxy(_mirror, {
        get: function (target, prop, receiver) {
            if (prop === 'map') {
                console.error(DEPARTED_MIRROR_ACCESS_WARNING);
            }
            return Reflect.get(target, prop, receiver);
        },
    });
}
function throttle(func, wait, options) {
    if (options === void 0) { options = {}; }
    var timeout = null;
    var previous = 0;
    return function (arg) {
        var now = Date.now();
        if (!previous && options.leading === false) {
            previous = now;
        }
        var remaining = wait - (now - previous);
        var context = this;
        var args = arguments;
        if (remaining <= 0 || remaining > wait) {
            if (timeout) {
                clearTimeout(timeout);
                timeout = null;
            }
            previous = now;
            func.apply(context, args);
        }
        else if (!timeout && options.trailing !== false) {
            timeout = setTimeout(function () {
                previous = options.leading === false ? 0 : Date.now();
                timeout = null;
                func.apply(context, args);
            }, remaining);
        }
    };
}
function hookSetter(target, key, d, isRevoked, win) {
    if (win === void 0) { win = window; }
    var original = win.Object.getOwnPropertyDescriptor(target, key);
    win.Object.defineProperty(target, key, isRevoked
        ? d
        : {
            set: function (value) {
                var _this = this;
                setTimeout(function () {
                    d.set.call(_this, value);
                }, 0);
                if (original && original.set) {
                    original.set.call(this, value);
                }
            },
        });
    return function () { return hookSetter(target, key, original || {}, true); };
}
function patch(source, name, replacement) {
    try {
        if (!(name in source)) {
            return function () { };
        }
        var original_1 = source[name];
        var wrapped = replacement(original_1);
        if (typeof wrapped === 'function') {
            wrapped.prototype = wrapped.prototype || {};
            Object.defineProperties(wrapped, {
                __rrweb_original__: {
                    enumerable: false,
                    value: original_1,
                },
            });
        }
        source[name] = wrapped;
        return function () {
            source[name] = original_1;
        };
    }
    catch (_a) {
        return function () { };
    }
}
function getWindowHeight() {
    return (window.innerHeight ||
        (document.documentElement && document.documentElement.clientHeight) ||
        (document.body && document.body.clientHeight));
}
function getWindowWidth() {
    return (window.innerWidth ||
        (document.documentElement && document.documentElement.clientWidth) ||
        (document.body && document.body.clientWidth));
}
function isBlocked(node, blockClass) {
    if (!node) {
        return false;
    }
    if (node.nodeType === node.ELEMENT_NODE) {
        var needBlock_1 = false;
        if (typeof blockClass === 'string') {
            if (node.closest !== undefined) {
                return node.closest('.' + blockClass) !== null;
            }
            else {
                needBlock_1 = node.classList.contains(blockClass);
            }
        }
        else {
            node.classList.forEach(function (className) {
                if (blockClass.test(className)) {
                    needBlock_1 = true;
                }
            });
        }
        return needBlock_1 || isBlocked(node.parentNode, blockClass);
    }
    if (node.nodeType === node.TEXT_NODE) {
        return isBlocked(node.parentNode, blockClass);
    }
    return isBlocked(node.parentNode, blockClass);
}
function isIgnored(n) {
    if ('__sn' in n) {
        return n.__sn.id === IGNORED_NODE;
    }
    return false;
}
function isAncestorRemoved(target, mirror) {
    if (isShadowRoot(target)) {
        return false;
    }
    var id = mirror.getId(target);
    if (!mirror.has(id)) {
        return true;
    }
    if (target.parentNode &&
        target.parentNode.nodeType === target.DOCUMENT_NODE) {
        return false;
    }
    if (!target.parentNode) {
        return true;
    }
    return isAncestorRemoved(target.parentNode, mirror);
}
function isTouchEvent(event) {
    return Boolean(event.changedTouches);
}
function polyfill(win) {
    if (win === void 0) { win = window; }
    if ('NodeList' in win && !win.NodeList.prototype.forEach) {
        win.NodeList.prototype.forEach = Array.prototype
            .forEach;
    }
    if ('DOMTokenList' in win && !win.DOMTokenList.prototype.forEach) {
        win.DOMTokenList.prototype.forEach = Array.prototype
            .forEach;
    }
    if (!Node.prototype.contains) {
        Node.prototype.contains = function contains(node) {
            if (!(0 in arguments)) {
                throw new TypeError('1 argument is required');
            }
            do {
                if (this === node) {
                    return true;
                }
            } while ((node = node && node.parentNode));
            return false;
        };
    }
}
function isIframeINode(node) {
    if ('__sn' in node) {
        return (node.__sn.type === NodeType.Element && node.__sn.tagName === 'iframe');
    }
    return false;
}
function hasShadowRoot(n) {
    return Boolean(n === null || n === void 0 ? void 0 : n.shadowRoot);
}

function isNodeInLinkedList(n) {
    return '__ln' in n;
}
var DoubleLinkedList = (function () {
    function DoubleLinkedList() {
        this.length = 0;
        this.head = null;
    }
    DoubleLinkedList.prototype.get = function (position) {
        if (position >= this.length) {
            throw new Error('Position outside of list range');
        }
        var current = this.head;
        for (var index = 0; index < position; index++) {
            current = (current === null || current === void 0 ? void 0 : current.next) || null;
        }
        return current;
    };
    DoubleLinkedList.prototype.addNode = function (n) {
        var node = {
            value: n,
            previous: null,
            next: null,
        };
        n.__ln = node;
        if (n.previousSibling && isNodeInLinkedList(n.previousSibling)) {
            var current = n.previousSibling.__ln.next;
            node.next = current;
            node.previous = n.previousSibling.__ln;
            n.previousSibling.__ln.next = node;
            if (current) {
                current.previous = node;
            }
        }
        else if (n.nextSibling &&
            isNodeInLinkedList(n.nextSibling) &&
            n.nextSibling.__ln.previous) {
            var current = n.nextSibling.__ln.previous;
            node.previous = current;
            node.next = n.nextSibling.__ln;
            n.nextSibling.__ln.previous = node;
            if (current) {
                current.next = node;
            }
        }
        else {
            if (this.head) {
                this.head.previous = node;
            }
            node.next = this.head;
            this.head = node;
        }
        this.length++;
    };
    DoubleLinkedList.prototype.removeNode = function (n) {
        var current = n.__ln;
        if (!this.head) {
            return;
        }
        if (!current.previous) {
            this.head = current.next;
            if (this.head) {
                this.head.previous = null;
            }
        }
        else {
            current.previous.next = current.next;
            if (current.next) {
                current.next.previous = current.previous;
            }
        }
        if (n.__ln) {
            delete n.__ln;
        }
        this.length--;
    };
    return DoubleLinkedList;
}());
var moveKey = function (id, parentId) { return "".concat(id, "@").concat(parentId); };
function isINode(n) {
    return '__sn' in n;
}
var MutationBuffer = (function () {
    function MutationBuffer() {
        var _this = this;
        this.frozen = false;
        this.locked = false;
        this.texts = [];
        this.attributes = [];
        this.removes = [];
        this.mapRemoves = [];
        this.movedMap = {};
        this.addedSet = new Set();
        this.movedSet = new Set();
        this.droppedSet = new Set();
        this.processMutations = function (mutations) {
            mutations.forEach(_this.processMutation);
            _this.emit();
        };
        this.emit = function () {
            var e_1, _a, e_2, _b;
            if (_this.frozen || _this.locked) {
                return;
            }
            var adds = [];
            var addList = new DoubleLinkedList();
            var getNextId = function (n) {
                var ns = n;
                var nextId = IGNORED_NODE;
                while (nextId === IGNORED_NODE) {
                    ns = ns && ns.nextSibling;
                    nextId = ns && _this.mirror.getId(ns);
                }
                return nextId;
            };
            var pushAdd = function (n) {
                var _a, _b, _c, _d, _e;
                var shadowHost = n.getRootNode
                    ? (_a = n.getRootNode()) === null || _a === void 0 ? void 0 : _a.host
                    : null;
                var rootShadowHost = shadowHost;
                while ((_c = (_b = rootShadowHost === null || rootShadowHost === void 0 ? void 0 : rootShadowHost.getRootNode) === null || _b === void 0 ? void 0 : _b.call(rootShadowHost)) === null || _c === void 0 ? void 0 : _c.host)
                    rootShadowHost =
                        ((_e = (_d = rootShadowHost === null || rootShadowHost === void 0 ? void 0 : rootShadowHost.getRootNode) === null || _d === void 0 ? void 0 : _d.call(rootShadowHost)) === null || _e === void 0 ? void 0 : _e.host) ||
                            null;
                var notInDoc = !_this.doc.contains(n) &&
                    (rootShadowHost === null || !_this.doc.contains(rootShadowHost));
                if (!n.parentNode || notInDoc) {
                    return;
                }
                var parentId = isShadowRoot(n.parentNode)
                    ? _this.mirror.getId(shadowHost)
                    : _this.mirror.getId(n.parentNode);
                var nextId = getNextId(n);
                if (parentId === -1 || nextId === -1) {
                    return addList.addNode(n);
                }
                var sn = serializeNodeWithId(n, {
                    doc: _this.doc,
                    map: _this.mirror.map,
                    blockClass: _this.blockClass,
                    blockSelector: _this.blockSelector,
                    maskTextClass: _this.maskTextClass,
                    maskTextSelector: _this.maskTextSelector,
                    skipChild: true,
                    inlineStylesheet: _this.inlineStylesheet,
                    maskInputOptions: _this.maskInputOptions,
                    maskTextFn: _this.maskTextFn,
                    maskInputFn: _this.maskInputFn,
                    slimDOMOptions: _this.slimDOMOptions,
                    recordCanvas: _this.recordCanvas,
                    inlineImages: _this.inlineImages,
                    onSerialize: function (currentN) {
                        if (isIframeINode(currentN)) {
                            _this.iframeManager.addIframe(currentN);
                        }
                        if (hasShadowRoot(n)) {
                            _this.shadowDomManager.addShadowRoot(n.shadowRoot, document);
                        }
                    },
                    onIframeLoad: function (iframe, childSn) {
                        _this.iframeManager.attachIframe(iframe, childSn);
                        _this.shadowDomManager.observeAttachShadow(iframe);
                    },
                });
                if (sn) {
                    adds.push({
                        parentId: parentId,
                        nextId: nextId,
                        node: sn,
                    });
                }
            };
            while (_this.mapRemoves.length) {
                _this.mirror.removeNodeFromMap(_this.mapRemoves.shift());
            }
            try {
                for (var _c = __values(_this.movedSet), _d = _c.next(); !_d.done; _d = _c.next()) {
                    var n = _d.value;
                    if (isParentRemoved(_this.removes, n, _this.mirror) &&
                        !_this.movedSet.has(n.parentNode)) {
                        continue;
                    }
                    pushAdd(n);
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
                }
                finally { if (e_1) throw e_1.error; }
            }
            try {
                for (var _e = __values(_this.addedSet), _f = _e.next(); !_f.done; _f = _e.next()) {
                    var n = _f.value;
                    if (!isAncestorInSet(_this.droppedSet, n) &&
                        !isParentRemoved(_this.removes, n, _this.mirror)) {
                        pushAdd(n);
                    }
                    else if (isAncestorInSet(_this.movedSet, n)) {
                        pushAdd(n);
                    }
                    else {
                        _this.droppedSet.add(n);
                    }
                }
            }
            catch (e_2_1) { e_2 = { error: e_2_1 }; }
            finally {
                try {
                    if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
                }
                finally { if (e_2) throw e_2.error; }
            }
            var candidate = null;
            while (addList.length) {
                var node = null;
                if (candidate) {
                    var parentId = _this.mirror.getId(candidate.value.parentNode);
                    var nextId = getNextId(candidate.value);
                    if (parentId !== -1 && nextId !== -1) {
                        node = candidate;
                    }
                }
                if (!node) {
                    for (var index = addList.length - 1; index >= 0; index--) {
                        var _node = addList.get(index);
                        if (_node) {
                            var parentId = _this.mirror.getId(_node.value.parentNode);
                            var nextId = getNextId(_node.value);
                            if (parentId !== -1 && nextId !== -1) {
                                node = _node;
                                break;
                            }
                        }
                    }
                }
                if (!node) {
                    while (addList.head) {
                        addList.removeNode(addList.head.value);
                    }
                    break;
                }
                candidate = node.previous;
                addList.removeNode(node.value);
                pushAdd(node.value);
            }
            var payload = {
                texts: _this.texts
                    .map(function (text) { return ({
                    id: _this.mirror.getId(text.node),
                    value: text.value,
                }); })
                    .filter(function (text) { return _this.mirror.has(text.id); }),
                attributes: _this.attributes
                    .map(function (attribute) { return ({
                    id: _this.mirror.getId(attribute.node),
                    attributes: attribute.attributes,
                }); })
                    .filter(function (attribute) { return _this.mirror.has(attribute.id); }),
                removes: _this.removes,
                adds: adds,
            };
            if (!payload.texts.length &&
                !payload.attributes.length &&
                !payload.removes.length &&
                !payload.adds.length) {
                return;
            }
            _this.texts = [];
            _this.attributes = [];
            _this.removes = [];
            _this.addedSet = new Set();
            _this.movedSet = new Set();
            _this.droppedSet = new Set();
            _this.movedMap = {};
            _this.mutationCb(payload);
        };
        this.processMutation = function (m) {
            var e_3, _a, e_4, _b;
            if (isIgnored(m.target)) {
                return;
            }
            switch (m.type) {
                case 'characterData': {
                    var value = m.target.textContent;
                    if (!isBlocked(m.target, _this.blockClass) && value !== m.oldValue) {
                        _this.texts.push({
                            value: needMaskingText(m.target, _this.maskTextClass, _this.maskTextSelector) && value
                                ? _this.maskTextFn
                                    ? _this.maskTextFn(value)
                                    : value.replace(/[\S]/g, '*')
                                : value,
                            node: m.target,
                        });
                    }
                    break;
                }
                case 'attributes': {
                    var target = m.target;
                    var value = m.target.getAttribute(m.attributeName);
                    if (m.attributeName === 'value') {
                        value = maskInputValue({
                            maskInputOptions: _this.maskInputOptions,
                            tagName: m.target.tagName,
                            type: m.target.getAttribute('type'),
                            value: value,
                            maskInputFn: _this.maskInputFn,
                        });
                    }
                    if (isBlocked(m.target, _this.blockClass) || value === m.oldValue) {
                        return;
                    }
                    var item = _this.attributes.find(function (a) { return a.node === m.target; });
                    if (!item) {
                        item = {
                            node: m.target,
                            attributes: {},
                        };
                        _this.attributes.push(item);
                    }
                    if (m.attributeName === 'style') {
                        var old = _this.doc.createElement('span');
                        if (m.oldValue) {
                            old.setAttribute('style', m.oldValue);
                        }
                        if (item.attributes.style === undefined ||
                            item.attributes.style === null) {
                            item.attributes.style = {};
                        }
                        var styleObj = item.attributes.style;
                        try {
                            for (var _c = __values(Array.from(target.style)), _d = _c.next(); !_d.done; _d = _c.next()) {
                                var pname = _d.value;
                                var newValue = target.style.getPropertyValue(pname);
                                var newPriority = target.style.getPropertyPriority(pname);
                                if (newValue !== old.style.getPropertyValue(pname) ||
                                    newPriority !== old.style.getPropertyPriority(pname)) {
                                    if (newPriority === '') {
                                        styleObj[pname] = newValue;
                                    }
                                    else {
                                        styleObj[pname] = [newValue, newPriority];
                                    }
                                }
                            }
                        }
                        catch (e_3_1) { e_3 = { error: e_3_1 }; }
                        finally {
                            try {
                                if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
                            }
                            finally { if (e_3) throw e_3.error; }
                        }
                        try {
                            for (var _e = __values(Array.from(old.style)), _f = _e.next(); !_f.done; _f = _e.next()) {
                                var pname = _f.value;
                                if (target.style.getPropertyValue(pname) === '') {
                                    styleObj[pname] = false;
                                }
                            }
                        }
                        catch (e_4_1) { e_4 = { error: e_4_1 }; }
                        finally {
                            try {
                                if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
                            }
                            finally { if (e_4) throw e_4.error; }
                        }
                    }
                    else {
                        item.attributes[m.attributeName] = transformAttribute(_this.doc, m.target.tagName, m.attributeName, value);
                    }
                    break;
                }
                case 'childList': {
                    m.addedNodes.forEach(function (n) { return _this.genAdds(n, m.target); });
                    m.removedNodes.forEach(function (n) {
                        var nodeId = _this.mirror.getId(n);
                        var parentId = isShadowRoot(m.target)
                            ? _this.mirror.getId(m.target.host)
                            : _this.mirror.getId(m.target);
                        if (isBlocked(m.target, _this.blockClass) || isIgnored(n)) {
                            return;
                        }
                        if (_this.addedSet.has(n)) {
                            deepDelete(_this.addedSet, n);
                            _this.droppedSet.add(n);
                        }
                        else if (_this.addedSet.has(m.target) && nodeId === -1) ;
                        else if (isAncestorRemoved(m.target, _this.mirror)) ;
                        else if (_this.movedSet.has(n) &&
                            _this.movedMap[moveKey(nodeId, parentId)]) {
                            deepDelete(_this.movedSet, n);
                        }
                        else {
                            _this.removes.push({
                                parentId: parentId,
                                id: nodeId,
                                isShadow: isShadowRoot(m.target) ? true : undefined,
                            });
                        }
                        _this.mapRemoves.push(n);
                    });
                    break;
                }
            }
        };
        this.genAdds = function (n, target) {
            if (target && isBlocked(target, _this.blockClass)) {
                return;
            }
            if (isINode(n)) {
                if (isIgnored(n)) {
                    return;
                }
                _this.movedSet.add(n);
                var targetId = null;
                if (target && isINode(target)) {
                    targetId = target.__sn.id;
                }
                if (targetId) {
                    _this.movedMap[moveKey(n.__sn.id, targetId)] = true;
                }
            }
            else {
                _this.addedSet.add(n);
                _this.droppedSet.delete(n);
            }
            if (!isBlocked(n, _this.blockClass))
                n.childNodes.forEach(function (childN) { return _this.genAdds(childN); });
        };
    }
    MutationBuffer.prototype.init = function (options) {
        var _this = this;
        [
            'mutationCb',
            'blockClass',
            'blockSelector',
            'maskTextClass',
            'maskTextSelector',
            'inlineStylesheet',
            'maskInputOptions',
            'maskTextFn',
            'maskInputFn',
            'recordCanvas',
            'inlineImages',
            'slimDOMOptions',
            'doc',
            'mirror',
            'iframeManager',
            'shadowDomManager',
            'canvasManager',
        ].forEach(function (key) {
            _this[key] = options[key];
        });
    };
    MutationBuffer.prototype.freeze = function () {
        this.frozen = true;
        this.canvasManager.freeze();
    };
    MutationBuffer.prototype.unfreeze = function () {
        this.frozen = false;
        this.canvasManager.unfreeze();
        this.emit();
    };
    MutationBuffer.prototype.isFrozen = function () {
        return this.frozen;
    };
    MutationBuffer.prototype.lock = function () {
        this.locked = true;
        this.canvasManager.lock();
    };
    MutationBuffer.prototype.unlock = function () {
        this.locked = false;
        this.canvasManager.unlock();
        this.emit();
    };
    MutationBuffer.prototype.reset = function () {
        this.shadowDomManager.reset();
        this.canvasManager.reset();
    };
    return MutationBuffer;
}());
function deepDelete(addsSet, n) {
    addsSet.delete(n);
    n.childNodes.forEach(function (childN) { return deepDelete(addsSet, childN); });
}
function isParentRemoved(removes, n, mirror) {
    var parentNode = n.parentNode;
    if (!parentNode) {
        return false;
    }
    var parentId = mirror.getId(parentNode);
    if (removes.some(function (r) { return r.id === parentId; })) {
        return true;
    }
    return isParentRemoved(removes, parentNode, mirror);
}
function isAncestorInSet(set, n) {
    var parentNode = n.parentNode;
    if (!parentNode) {
        return false;
    }
    if (set.has(parentNode)) {
        return true;
    }
    return isAncestorInSet(set, parentNode);
}

const MutationBuffer$1 = MutationBuffer;

var mutationBuffers = [];
var isCSSGroupingRuleSupported = typeof CSSGroupingRule !== 'undefined';
var isCSSMediaRuleSupported = typeof CSSMediaRule !== 'undefined';
var isCSSSupportsRuleSupported = typeof CSSSupportsRule !== 'undefined';
var isCSSConditionRuleSupported = typeof CSSConditionRule !== 'undefined';
function getEventTarget(event) {
    try {
        if ('composedPath' in event) {
            var path = event.composedPath();
            if (path.length) {
                return path[0];
            }
        }
        else if ('path' in event && event.path.length) {
            return event.path[0];
        }
        return event.target;
    }
    catch (_a) {
        return event.target;
    }
}
function initMutationObserver(options, rootEl) {
    var _a, _b;
    var mutationBuffer = new MutationBuffer$1();
    mutationBuffers.push(mutationBuffer);
    mutationBuffer.init(options);
    var mutationObserverCtor = window.MutationObserver ||
        window.__rrMutationObserver;
    var angularZoneSymbol = (_b = (_a = window === null || window === void 0 ? void 0 : window.Zone) === null || _a === void 0 ? void 0 : _a.__symbol__) === null || _b === void 0 ? void 0 : _b.call(_a, 'MutationObserver');
    if (angularZoneSymbol &&
        window[angularZoneSymbol]) {
        mutationObserverCtor = window[angularZoneSymbol];
    }
    var observer = new mutationObserverCtor(mutationBuffer.processMutations.bind(mutationBuffer));
    observer.observe(rootEl, {
        attributes: true,
        attributeOldValue: true,
        characterData: true,
        characterDataOldValue: true,
        childList: true,
        subtree: true,
    });
    return observer;
}
function initMoveObserver(_a) {
    var mousemoveCb = _a.mousemoveCb, sampling = _a.sampling, doc = _a.doc, mirror = _a.mirror;
    if (sampling.mousemove === false) {
        return function () { };
    }
    var threshold = typeof sampling.mousemove === 'number' ? sampling.mousemove : 50;
    var callbackThreshold = typeof sampling.mousemoveCallback === 'number'
        ? sampling.mousemoveCallback
        : 500;
    var positions = [];
    var timeBaseline;
    var wrappedCb = throttle(function (source) {
        var totalOffset = Date.now() - timeBaseline;
        mousemoveCb(positions.map(function (p) {
            p.timeOffset -= totalOffset;
            return p;
        }), source);
        positions = [];
        timeBaseline = null;
    }, callbackThreshold);
    var updatePosition = throttle(function (evt) {
        var target = getEventTarget(evt);
        var _a = isTouchEvent(evt)
            ? evt.changedTouches[0]
            : evt, clientX = _a.clientX, clientY = _a.clientY;
        if (!timeBaseline) {
            timeBaseline = Date.now();
        }
        positions.push({
            x: clientX,
            y: clientY,
            id: mirror.getId(target),
            timeOffset: Date.now() - timeBaseline,
        });
        wrappedCb(typeof DragEvent !== 'undefined' && evt instanceof DragEvent
            ? IncrementalSource.Drag
            : evt instanceof MouseEvent
                ? IncrementalSource.MouseMove
                : IncrementalSource.TouchMove);
    }, threshold, {
        trailing: false,
    });
    var handlers = [
        on('mousemove', updatePosition, doc),
        on('touchmove', updatePosition, doc),
        on('drag', updatePosition, doc),
    ];
    return function () {
        handlers.forEach(function (h) { return h(); });
    };
}
function initMouseInteractionObserver(_a) {
    var mouseInteractionCb = _a.mouseInteractionCb, doc = _a.doc, mirror = _a.mirror, blockClass = _a.blockClass, sampling = _a.sampling;
    if (sampling.mouseInteraction === false) {
        return function () { };
    }
    var disableMap = sampling.mouseInteraction === true ||
        sampling.mouseInteraction === undefined
        ? {}
        : sampling.mouseInteraction;
    var handlers = [];
    var getHandler = function (eventKey) {
        return function (event) {
            var target = getEventTarget(event);
            if (isBlocked(target, blockClass)) {
                return;
            }
            var e = isTouchEvent(event) ? event.changedTouches[0] : event;
            if (!e) {
                return;
            }
            var id = mirror.getId(target);
            var clientX = e.clientX, clientY = e.clientY;
            mouseInteractionCb({
                type: MouseInteractions[eventKey],
                id: id,
                x: clientX,
                y: clientY,
            });
        };
    };
    Object.keys(MouseInteractions)
        .filter(function (key) {
        return Number.isNaN(Number(key)) &&
            !key.endsWith('_Departed') &&
            disableMap[key] !== false;
    })
        .forEach(function (eventKey) {
        var eventName = eventKey.toLowerCase();
        var handler = getHandler(eventKey);
        handlers.push(on(eventName, handler, doc));
    });
    return function () {
        handlers.forEach(function (h) { return h(); });
    };
}
function initScrollObserver(_a) {
    var scrollCb = _a.scrollCb, doc = _a.doc, mirror = _a.mirror, blockClass = _a.blockClass, sampling = _a.sampling;
    var updatePosition = throttle(function (evt) {
        var target = getEventTarget(evt);
        if (!target || isBlocked(target, blockClass)) {
            return;
        }
        var id = mirror.getId(target);
        if (target === doc) {
            var scrollEl = (doc.scrollingElement || doc.documentElement);
            scrollCb({
                id: id,
                x: scrollEl.scrollLeft,
                y: scrollEl.scrollTop,
            });
        }
        else {
            scrollCb({
                id: id,
                x: target.scrollLeft,
                y: target.scrollTop,
            });
        }
    }, sampling.scroll || 100);
    return on('scroll', updatePosition, doc);
}
function initViewportResizeObserver(_a) {
    var viewportResizeCb = _a.viewportResizeCb;
    var lastH = -1;
    var lastW = -1;
    var updateDimension = throttle(function () {
        var height = getWindowHeight();
        var width = getWindowWidth();
        if (lastH !== height || lastW !== width) {
            viewportResizeCb({
                width: Number(width),
                height: Number(height),
            });
            lastH = height;
            lastW = width;
        }
    }, 200);
    return on('resize', updateDimension, window);
}
function wrapEventWithUserTriggeredFlag(v, enable) {
    var value = __assign({}, v);
    if (!enable)
        delete value.userTriggered;
    return value;
}
var INPUT_TAGS = ['INPUT', 'TEXTAREA', 'SELECT'];
var lastInputValueMap = new WeakMap();
function initInputObserver(_a) {
    var inputCb = _a.inputCb, doc = _a.doc, mirror = _a.mirror, blockClass = _a.blockClass, ignoreClass = _a.ignoreClass, maskInputOptions = _a.maskInputOptions, maskInputFn = _a.maskInputFn, sampling = _a.sampling, userTriggeredOnInput = _a.userTriggeredOnInput;
    function eventHandler(event) {
        var target = getEventTarget(event);
        var userTriggered = event.isTrusted;
        if (target && target.tagName === 'OPTION')
            target = target.parentElement;
        if (!target ||
            !target.tagName ||
            INPUT_TAGS.indexOf(target.tagName) < 0 ||
            isBlocked(target, blockClass)) {
            return;
        }
        var type = target.type;
        if (target.classList.contains(ignoreClass)) {
            return;
        }
        var text = target.value;
        var isChecked = false;
        if (type === 'radio' || type === 'checkbox') {
            isChecked = target.checked;
        }
        else if (maskInputOptions[target.tagName.toLowerCase()] ||
            maskInputOptions[type]) {
            text = maskInputValue({
                maskInputOptions: maskInputOptions,
                tagName: target.tagName,
                type: type,
                value: text,
                maskInputFn: maskInputFn,
            });
        }
        cbWithDedup(target, wrapEventWithUserTriggeredFlag({ text: text, isChecked: isChecked, userTriggered: userTriggered }, userTriggeredOnInput));
        var name = target.name;
        if (type === 'radio' && name && isChecked) {
            doc
                .querySelectorAll("input[type=\"radio\"][name=\"".concat(name, "\"]"))
                .forEach(function (el) {
                if (el !== target) {
                    cbWithDedup(el, wrapEventWithUserTriggeredFlag({
                        text: el.value,
                        isChecked: !isChecked,
                        userTriggered: false,
                    }, userTriggeredOnInput));
                }
            });
        }
    }
    function cbWithDedup(target, v) {
        var lastInputValue = lastInputValueMap.get(target);
        if (!lastInputValue ||
            lastInputValue.text !== v.text ||
            lastInputValue.isChecked !== v.isChecked) {
            lastInputValueMap.set(target, v);
            var id = mirror.getId(target);
            inputCb(__assign(__assign({}, v), { id: id }));
        }
    }
    var events = sampling.input === 'last' ? ['change'] : ['input', 'change'];
    var handlers = events.map(function (eventName) { return on(eventName, eventHandler, doc); });
    var propertyDescriptor = Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, 'value');
    var hookProperties = [
        [HTMLInputElement.prototype, 'value'],
        [HTMLInputElement.prototype, 'checked'],
        [HTMLSelectElement.prototype, 'value'],
        [HTMLTextAreaElement.prototype, 'value'],
        [HTMLSelectElement.prototype, 'selectedIndex'],
        [HTMLOptionElement.prototype, 'selected'],
    ];
    if (propertyDescriptor && propertyDescriptor.set) {
        handlers.push.apply(handlers, __spreadArray([], __read(hookProperties.map(function (p) {
            return hookSetter(p[0], p[1], {
                set: function () {
                    eventHandler({ target: this });
                },
            });
        })), false));
    }
    return function () {
        handlers.forEach(function (h) { return h(); });
    };
}
function getNestedCSSRulePositions(rule) {
    var positions = [];
    function recurse(childRule, pos) {
        if ((isCSSGroupingRuleSupported &&
            childRule.parentRule instanceof CSSGroupingRule) ||
            (isCSSMediaRuleSupported &&
                childRule.parentRule instanceof CSSMediaRule) ||
            (isCSSSupportsRuleSupported &&
                childRule.parentRule instanceof CSSSupportsRule) ||
            (isCSSConditionRuleSupported &&
                childRule.parentRule instanceof CSSConditionRule)) {
            var rules = Array.from(childRule.parentRule.cssRules);
            var index = rules.indexOf(childRule);
            pos.unshift(index);
        }
        else {
            var rules = Array.from(childRule.parentStyleSheet.cssRules);
            var index = rules.indexOf(childRule);
            pos.unshift(index);
        }
        return pos;
    }
    return recurse(rule, positions);
}
function initStyleSheetObserver(_a, _b) {
    var styleSheetRuleCb = _a.styleSheetRuleCb, mirror = _a.mirror;
    var win = _b.win;
    var insertRule = win.CSSStyleSheet.prototype.insertRule;
    win.CSSStyleSheet.prototype.insertRule = function (rule, index) {
        var id = mirror.getId(this.ownerNode);
        if (id !== -1) {
            styleSheetRuleCb({
                id: id,
                adds: [{ rule: rule, index: index }],
            });
        }
        return insertRule.apply(this, arguments);
    };
    var deleteRule = win.CSSStyleSheet.prototype.deleteRule;
    win.CSSStyleSheet.prototype.deleteRule = function (index) {
        var id = mirror.getId(this.ownerNode);
        if (id !== -1) {
            styleSheetRuleCb({
                id: id,
                removes: [{ index: index }],
            });
        }
        return deleteRule.apply(this, arguments);
    };
    var supportedNestedCSSRuleTypes = {};
    if (isCSSGroupingRuleSupported) {
        supportedNestedCSSRuleTypes.CSSGroupingRule = win.CSSGroupingRule;
    }
    else {
        if (isCSSMediaRuleSupported) {
            supportedNestedCSSRuleTypes.CSSMediaRule = win.CSSMediaRule;
        }
        if (isCSSConditionRuleSupported) {
            supportedNestedCSSRuleTypes.CSSConditionRule = win.CSSConditionRule;
        }
        if (isCSSSupportsRuleSupported) {
            supportedNestedCSSRuleTypes.CSSSupportsRule = win.CSSSupportsRule;
        }
    }
    var unmodifiedFunctions = {};
    Object.entries(supportedNestedCSSRuleTypes).forEach(function (_a) {
        var _b = __read(_a, 2), typeKey = _b[0], type = _b[1];
        unmodifiedFunctions[typeKey] = {
            insertRule: type.prototype.insertRule,
            deleteRule: type.prototype.deleteRule,
        };
        type.prototype.insertRule = function (rule, index) {
            var id = mirror.getId(this.parentStyleSheet.ownerNode);
            if (id !== -1) {
                styleSheetRuleCb({
                    id: id,
                    adds: [
                        {
                            rule: rule,
                            index: __spreadArray(__spreadArray([], __read(getNestedCSSRulePositions(this)), false), [
                                index || 0,
                            ], false),
                        },
                    ],
                });
            }
            return unmodifiedFunctions[typeKey].insertRule.apply(this, arguments);
        };
        type.prototype.deleteRule = function (index) {
            var id = mirror.getId(this.parentStyleSheet.ownerNode);
            if (id !== -1) {
                styleSheetRuleCb({
                    id: id,
                    removes: [{ index: __spreadArray(__spreadArray([], __read(getNestedCSSRulePositions(this)), false), [index], false) }],
                });
            }
            return unmodifiedFunctions[typeKey].deleteRule.apply(this, arguments);
        };
    });
    return function () {
        win.CSSStyleSheet.prototype.insertRule = insertRule;
        win.CSSStyleSheet.prototype.deleteRule = deleteRule;
        Object.entries(supportedNestedCSSRuleTypes).forEach(function (_a) {
            var _b = __read(_a, 2), typeKey = _b[0], type = _b[1];
            type.prototype.insertRule = unmodifiedFunctions[typeKey].insertRule;
            type.prototype.deleteRule = unmodifiedFunctions[typeKey].deleteRule;
        });
    };
}
function initStyleDeclarationObserver(_a, _b) {
    var styleDeclarationCb = _a.styleDeclarationCb, mirror = _a.mirror;
    var win = _b.win;
    var setProperty = win.CSSStyleDeclaration.prototype.setProperty;
    win.CSSStyleDeclaration.prototype.setProperty = function (property, value, priority) {
        var _a, _b;
        var id = mirror.getId((_b = (_a = this.parentRule) === null || _a === void 0 ? void 0 : _a.parentStyleSheet) === null || _b === void 0 ? void 0 : _b.ownerNode);
        if (id !== -1) {
            styleDeclarationCb({
                id: id,
                set: {
                    property: property,
                    value: value,
                    priority: priority,
                },
                index: getNestedCSSRulePositions(this.parentRule),
            });
        }
        return setProperty.apply(this, arguments);
    };
    var removeProperty = win.CSSStyleDeclaration.prototype.removeProperty;
    win.CSSStyleDeclaration.prototype.removeProperty = function (property) {
        var _a, _b;
        var id = mirror.getId((_b = (_a = this.parentRule) === null || _a === void 0 ? void 0 : _a.parentStyleSheet) === null || _b === void 0 ? void 0 : _b.ownerNode);
        if (id !== -1) {
            styleDeclarationCb({
                id: id,
                remove: {
                    property: property,
                },
                index: getNestedCSSRulePositions(this.parentRule),
            });
        }
        return removeProperty.apply(this, arguments);
    };
    return function () {
        win.CSSStyleDeclaration.prototype.setProperty = setProperty;
        win.CSSStyleDeclaration.prototype.removeProperty = removeProperty;
    };
}
function initMediaInteractionObserver(_a) {
    var mediaInteractionCb = _a.mediaInteractionCb, blockClass = _a.blockClass, mirror = _a.mirror, sampling = _a.sampling;
    var handler = function (type) {
        return throttle(function (event) {
            var target = getEventTarget(event);
            if (!target || isBlocked(target, blockClass)) {
                return;
            }
            var _a = target, currentTime = _a.currentTime, volume = _a.volume, muted = _a.muted;
            mediaInteractionCb({
                type: type,
                id: mirror.getId(target),
                currentTime: currentTime,
                volume: volume,
                muted: muted,
            });
        }, sampling.media || 500);
    };
    var handlers = [
        on('play', handler(0)),
        on('pause', handler(1)),
        on('seeked', handler(2)),
        on('volumechange', handler(3)),
    ];
    return function () {
        handlers.forEach(function (h) { return h(); });
    };
}
function initFontObserver(_a) {
    var fontCb = _a.fontCb, doc = _a.doc;
    var win = doc.defaultView;
    if (!win) {
        return function () { };
    }
    var handlers = [];
    var fontMap = new WeakMap();
    var originalFontFace = win.FontFace;
    win.FontFace = function FontFace(family, source, descriptors) {
        var fontFace = new originalFontFace(family, source, descriptors);
        fontMap.set(fontFace, {
            family: family,
            buffer: typeof source !== 'string',
            descriptors: descriptors,
            fontSource: typeof source === 'string'
                ? source
                :
                    JSON.stringify(Array.from(new Uint8Array(source))),
        });
        return fontFace;
    };
    var restoreHandler = patch(doc.fonts, 'add', function (original) {
        return function (fontFace) {
            setTimeout(function () {
                var p = fontMap.get(fontFace);
                if (p) {
                    fontCb(p);
                    fontMap.delete(fontFace);
                }
            }, 0);
            return original.apply(this, [fontFace]);
        };
    });
    handlers.push(function () {
        win.FontFace = originalFontFace;
    });
    handlers.push(restoreHandler);
    return function () {
        handlers.forEach(function (h) { return h(); });
    };
}
function mergeHooks(o, hooks) {
    var mutationCb = o.mutationCb, mousemoveCb = o.mousemoveCb, mouseInteractionCb = o.mouseInteractionCb, scrollCb = o.scrollCb, viewportResizeCb = o.viewportResizeCb, inputCb = o.inputCb, mediaInteractionCb = o.mediaInteractionCb, styleSheetRuleCb = o.styleSheetRuleCb, styleDeclarationCb = o.styleDeclarationCb, canvasMutationCb = o.canvasMutationCb, fontCb = o.fontCb;
    o.mutationCb = function () {
        var p = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            p[_i] = arguments[_i];
        }
        if (hooks.mutation) {
            hooks.mutation.apply(hooks, __spreadArray([], __read(p), false));
        }
        mutationCb.apply(void 0, __spreadArray([], __read(p), false));
    };
    o.mousemoveCb = function () {
        var p = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            p[_i] = arguments[_i];
        }
        if (hooks.mousemove) {
            hooks.mousemove.apply(hooks, __spreadArray([], __read(p), false));
        }
        mousemoveCb.apply(void 0, __spreadArray([], __read(p), false));
    };
    o.mouseInteractionCb = function () {
        var p = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            p[_i] = arguments[_i];
        }
        if (hooks.mouseInteraction) {
            hooks.mouseInteraction.apply(hooks, __spreadArray([], __read(p), false));
        }
        mouseInteractionCb.apply(void 0, __spreadArray([], __read(p), false));
    };
    o.scrollCb = function () {
        var p = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            p[_i] = arguments[_i];
        }
        if (hooks.scroll) {
            hooks.scroll.apply(hooks, __spreadArray([], __read(p), false));
        }
        scrollCb.apply(void 0, __spreadArray([], __read(p), false));
    };
    o.viewportResizeCb = function () {
        var p = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            p[_i] = arguments[_i];
        }
        if (hooks.viewportResize) {
            hooks.viewportResize.apply(hooks, __spreadArray([], __read(p), false));
        }
        viewportResizeCb.apply(void 0, __spreadArray([], __read(p), false));
    };
    o.inputCb = function () {
        var p = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            p[_i] = arguments[_i];
        }
        if (hooks.input) {
            hooks.input.apply(hooks, __spreadArray([], __read(p), false));
        }
        inputCb.apply(void 0, __spreadArray([], __read(p), false));
    };
    o.mediaInteractionCb = function () {
        var p = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            p[_i] = arguments[_i];
        }
        if (hooks.mediaInteaction) {
            hooks.mediaInteaction.apply(hooks, __spreadArray([], __read(p), false));
        }
        mediaInteractionCb.apply(void 0, __spreadArray([], __read(p), false));
    };
    o.styleSheetRuleCb = function () {
        var p = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            p[_i] = arguments[_i];
        }
        if (hooks.styleSheetRule) {
            hooks.styleSheetRule.apply(hooks, __spreadArray([], __read(p), false));
        }
        styleSheetRuleCb.apply(void 0, __spreadArray([], __read(p), false));
    };
    o.styleDeclarationCb = function () {
        var p = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            p[_i] = arguments[_i];
        }
        if (hooks.styleDeclaration) {
            hooks.styleDeclaration.apply(hooks, __spreadArray([], __read(p), false));
        }
        styleDeclarationCb.apply(void 0, __spreadArray([], __read(p), false));
    };
    o.canvasMutationCb = function () {
        var p = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            p[_i] = arguments[_i];
        }
        if (hooks.canvasMutation) {
            hooks.canvasMutation.apply(hooks, __spreadArray([], __read(p), false));
        }
        canvasMutationCb.apply(void 0, __spreadArray([], __read(p), false));
    };
    o.fontCb = function () {
        var p = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            p[_i] = arguments[_i];
        }
        if (hooks.font) {
            hooks.font.apply(hooks, __spreadArray([], __read(p), false));
        }
        fontCb.apply(void 0, __spreadArray([], __read(p), false));
    };
}
function initObservers(o, hooks) {
    var e_1, _a;
    if (hooks === void 0) { hooks = {}; }
    var currentWindow = o.doc.defaultView;
    if (!currentWindow) {
        return function () { };
    }
    mergeHooks(o, hooks);
    var mutationObserver = initMutationObserver(o, o.doc);
    var mousemoveHandler = initMoveObserver(o);
    var mouseInteractionHandler = initMouseInteractionObserver(o);
    var scrollHandler = initScrollObserver(o);
    var viewportResizeHandler = initViewportResizeObserver(o);
    var inputHandler = initInputObserver(o);
    var mediaInteractionHandler = initMediaInteractionObserver(o);
    var styleSheetObserver = initStyleSheetObserver(o, { win: currentWindow });
    var styleDeclarationObserver = initStyleDeclarationObserver(o, {
        win: currentWindow,
    });
    var fontObserver = o.collectFonts ? initFontObserver(o) : function () { };
    var pluginHandlers = [];
    try {
        for (var _b = __values(o.plugins), _c = _b.next(); !_c.done; _c = _b.next()) {
            var plugin = _c.value;
            pluginHandlers.push(plugin.observer(plugin.callback, currentWindow, plugin.options));
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return function () {
        mutationBuffers.forEach(function (b) { return b.reset(); });
        mutationObserver.disconnect();
        mousemoveHandler();
        mouseInteractionHandler();
        scrollHandler();
        viewportResizeHandler();
        inputHandler();
        mediaInteractionHandler();
        styleSheetObserver();
        styleDeclarationObserver();
        fontObserver();
        pluginHandlers.forEach(function (h) { return h(); });
    };
}

var IframeManager = (function () {
    function IframeManager(options) {
        this.iframes = new WeakMap();
        this.mutationCb = options.mutationCb;
    }
    IframeManager.prototype.addIframe = function (iframeEl) {
        this.iframes.set(iframeEl, true);
    };
    IframeManager.prototype.addLoadListener = function (cb) {
        this.loadListener = cb;
    };
    IframeManager.prototype.attachIframe = function (iframeEl, childSn) {
        var _a;
        this.mutationCb({
            adds: [
                {
                    parentId: iframeEl.__sn.id,
                    nextId: null,
                    node: childSn,
                },
            ],
            removes: [],
            texts: [],
            attributes: [],
            isAttachIframe: true,
        });
        (_a = this.loadListener) === null || _a === void 0 ? void 0 : _a.call(this, iframeEl);
    };
    return IframeManager;
}());

var ShadowDomManager = (function () {
    function ShadowDomManager(options) {
        this.restorePatches = [];
        this.mutationCb = options.mutationCb;
        this.scrollCb = options.scrollCb;
        this.bypassOptions = options.bypassOptions;
        this.mirror = options.mirror;
        var manager = this;
        this.restorePatches.push(patch(HTMLElement.prototype, 'attachShadow', function (original) {
            return function () {
                var shadowRoot = original.apply(this, arguments);
                if (this.shadowRoot)
                    manager.addShadowRoot(this.shadowRoot, this.ownerDocument);
                return shadowRoot;
            };
        }));
    }
    ShadowDomManager.prototype.addShadowRoot = function (shadowRoot, doc) {
        initMutationObserver(__assign(__assign({}, this.bypassOptions), { doc: doc, mutationCb: this.mutationCb, mirror: this.mirror, shadowDomManager: this }), shadowRoot);
        initScrollObserver(__assign(__assign({}, this.bypassOptions), { scrollCb: this.scrollCb, doc: shadowRoot, mirror: this.mirror }));
    };
    ShadowDomManager.prototype.observeAttachShadow = function (iframeElement) {
        if (iframeElement.contentWindow) {
            var manager_1 = this;
            this.restorePatches.push(patch(iframeElement.contentWindow.HTMLElement.prototype, 'attachShadow', function (original) {
                return function () {
                    var shadowRoot = original.apply(this, arguments);
                    if (this.shadowRoot)
                        manager_1.addShadowRoot(this.shadowRoot, iframeElement.contentDocument);
                    return shadowRoot;
                };
            }));
        }
    };
    ShadowDomManager.prototype.reset = function () {
        this.restorePatches.forEach(function (restorePatch) { return restorePatch(); });
    };
    return ShadowDomManager;
}());

function initCanvas2DMutationObserver(cb, win, blockClass, mirror) {
    var e_1, _a;
    var handlers = [];
    var props2D = Object.getOwnPropertyNames(win.CanvasRenderingContext2D.prototype);
    var _loop_1 = function (prop) {
        try {
            if (typeof win.CanvasRenderingContext2D.prototype[prop] !== 'function') {
                return "continue";
            }
            var restoreHandler = patch(win.CanvasRenderingContext2D.prototype, prop, function (original) {
                return function () {
                    var _this = this;
                    var args = [];
                    for (var _i = 0; _i < arguments.length; _i++) {
                        args[_i] = arguments[_i];
                    }
                    if (!isBlocked(this.canvas, blockClass)) {
                        setTimeout(function () {
                            var recordArgs = __spreadArray([], __read(args), false);
                            if (prop === 'drawImage') {
                                if (recordArgs[0] &&
                                    recordArgs[0] instanceof HTMLCanvasElement) {
                                    var canvas = recordArgs[0];
                                    var ctx = canvas.getContext('2d');
                                    var imgd = ctx === null || ctx === void 0 ? void 0 : ctx.getImageData(0, 0, canvas.width, canvas.height);
                                    var pix = imgd === null || imgd === void 0 ? void 0 : imgd.data;
                                    recordArgs[0] = JSON.stringify(pix);
                                }
                            }
                            cb(_this.canvas, {
                                type: CanvasContext['2D'],
                                property: prop,
                                args: recordArgs,
                            });
                        }, 0);
                    }
                    return original.apply(this, args);
                };
            });
            handlers.push(restoreHandler);
        }
        catch (_b) {
            var hookHandler = hookSetter(win.CanvasRenderingContext2D.prototype, prop, {
                set: function (v) {
                    cb(this.canvas, {
                        type: CanvasContext['2D'],
                        property: prop,
                        args: [v],
                        setter: true,
                    });
                },
            });
            handlers.push(hookHandler);
        }
    };
    try {
        for (var props2D_1 = __values(props2D), props2D_1_1 = props2D_1.next(); !props2D_1_1.done; props2D_1_1 = props2D_1.next()) {
            var prop = props2D_1_1.value;
            _loop_1(prop);
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (props2D_1_1 && !props2D_1_1.done && (_a = props2D_1.return)) _a.call(props2D_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return function () {
        handlers.forEach(function (h) { return h(); });
    };
}

function initCanvasContextObserver(win, blockClass) {
    var handlers = [];
    try {
        var restoreHandler = patch(win.HTMLCanvasElement.prototype, 'getContext', function (original) {
            return function (contextType) {
                var args = [];
                for (var _i = 1; _i < arguments.length; _i++) {
                    args[_i - 1] = arguments[_i];
                }
                if (!isBlocked(this, blockClass)) {
                    if (!('__context' in this))
                        this.__context = contextType;
                }
                return original.apply(this, __spreadArray([contextType], __read(args), false));
            };
        });
        handlers.push(restoreHandler);
    }
    catch (_a) {
        console.error('failed to patch HTMLCanvasElement.prototype.getContext');
    }
    return function () {
        handlers.forEach(function (h) { return h(); });
    };
}

/*
 * base64-arraybuffer 1.0.1 <https://github.com/niklasvh/base64-arraybuffer>
 * Copyright (c) 2021 Niklas von Hertzen <https://hertzen.com>
 * Released under MIT License
 */
var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
// Use a lookup table to find the index.
var lookup = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
for (var i = 0; i < chars.length; i++) {
    lookup[chars.charCodeAt(i)] = i;
}
var encode = function (arraybuffer) {
    var bytes = new Uint8Array(arraybuffer), i, len = bytes.length, base64 = '';
    for (i = 0; i < len; i += 3) {
        base64 += chars[bytes[i] >> 2];
        base64 += chars[((bytes[i] & 3) << 4) | (bytes[i + 1] >> 4)];
        base64 += chars[((bytes[i + 1] & 15) << 2) | (bytes[i + 2] >> 6)];
        base64 += chars[bytes[i + 2] & 63];
    }
    if (len % 3 === 2) {
        base64 = base64.substring(0, base64.length - 1) + '=';
    }
    else if (len % 3 === 1) {
        base64 = base64.substring(0, base64.length - 2) + '==';
    }
    return base64;
};

var webGLVarMap = new Map();
function variableListFor(ctx, ctor) {
    var contextMap = webGLVarMap.get(ctx);
    if (!contextMap) {
        contextMap = new Map();
        webGLVarMap.set(ctx, contextMap);
    }
    if (!contextMap.has(ctor)) {
        contextMap.set(ctor, []);
    }
    return contextMap.get(ctor);
}
var saveWebGLVar = function (value, win, ctx) {
    if (!value ||
        !(isInstanceOfWebGLObject(value, win) || typeof value === 'object'))
        return;
    var name = value.constructor.name;
    var list = variableListFor(ctx, name);
    var index = list.indexOf(value);
    if (index === -1) {
        index = list.length;
        list.push(value);
    }
    return index;
};
function serializeArg(value, win, ctx) {
    if (value instanceof Array) {
        return value.map(function (arg) { return serializeArg(arg, win, ctx); });
    }
    else if (value === null) {
        return value;
    }
    else if (value instanceof Float32Array ||
        value instanceof Float64Array ||
        value instanceof Int32Array ||
        value instanceof Uint32Array ||
        value instanceof Uint8Array ||
        value instanceof Uint16Array ||
        value instanceof Int16Array ||
        value instanceof Int8Array ||
        value instanceof Uint8ClampedArray) {
        var name_1 = value.constructor.name;
        return {
            rr_type: name_1,
            args: [Object.values(value)],
        };
    }
    else if (value instanceof ArrayBuffer) {
        var name_2 = value.constructor.name;
        var base64 = encode(value);
        return {
            rr_type: name_2,
            base64: base64,
        };
    }
    else if (value instanceof DataView) {
        var name_3 = value.constructor.name;
        return {
            rr_type: name_3,
            args: [
                serializeArg(value.buffer, win, ctx),
                value.byteOffset,
                value.byteLength,
            ],
        };
    }
    else if (value instanceof HTMLImageElement) {
        var name_4 = value.constructor.name;
        var src = value.src;
        return {
            rr_type: name_4,
            src: src,
        };
    }
    else if (value instanceof ImageData) {
        var name_5 = value.constructor.name;
        return {
            rr_type: name_5,
            args: [serializeArg(value.data, win, ctx), value.width, value.height],
        };
    }
    else if (isInstanceOfWebGLObject(value, win) || typeof value === 'object') {
        var name_6 = value.constructor.name;
        var index = saveWebGLVar(value, win, ctx);
        return {
            rr_type: name_6,
            index: index,
        };
    }
    return value;
}
var serializeArgs = function (args, win, ctx) {
    return __spreadArray([], __read(args), false).map(function (arg) { return serializeArg(arg, win, ctx); });
};
var isInstanceOfWebGLObject = function (value, win) {
    var webGLConstructorNames = [
        'WebGLActiveInfo',
        'WebGLBuffer',
        'WebGLFramebuffer',
        'WebGLProgram',
        'WebGLRenderbuffer',
        'WebGLShader',
        'WebGLShaderPrecisionFormat',
        'WebGLTexture',
        'WebGLUniformLocation',
        'WebGLVertexArrayObject',
        'WebGLVertexArrayObjectOES',
    ];
    var supportedWebGLConstructorNames = webGLConstructorNames.filter(function (name) { return typeof win[name] === 'function'; });
    return Boolean(supportedWebGLConstructorNames.find(function (name) { return value instanceof win[name]; }));
};

function patchGLPrototype(prototype, type, cb, blockClass, mirror, win) {
    var e_1, _a;
    var handlers = [];
    var props = Object.getOwnPropertyNames(prototype);
    var _loop_1 = function (prop) {
        try {
            if (typeof prototype[prop] !== 'function') {
                return "continue";
            }
            var restoreHandler = patch(prototype, prop, function (original) {
                return function () {
                    var args = [];
                    for (var _i = 0; _i < arguments.length; _i++) {
                        args[_i] = arguments[_i];
                    }
                    var result = original.apply(this, args);
                    saveWebGLVar(result, win, prototype);
                    if (!isBlocked(this.canvas, blockClass)) {
                        var id = mirror.getId(this.canvas);
                        var recordArgs = serializeArgs(__spreadArray([], __read(args), false), win, prototype);
                        var mutation = {
                            type: type,
                            property: prop,
                            args: recordArgs,
                        };
                        cb(this.canvas, mutation);
                    }
                    return result;
                };
            });
            handlers.push(restoreHandler);
        }
        catch (_b) {
            var hookHandler = hookSetter(prototype, prop, {
                set: function (v) {
                    cb(this.canvas, {
                        type: type,
                        property: prop,
                        args: [v],
                        setter: true,
                    });
                },
            });
            handlers.push(hookHandler);
        }
    };
    try {
        for (var props_1 = __values(props), props_1_1 = props_1.next(); !props_1_1.done; props_1_1 = props_1.next()) {
            var prop = props_1_1.value;
            _loop_1(prop);
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (props_1_1 && !props_1_1.done && (_a = props_1.return)) _a.call(props_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return handlers;
}
function initCanvasWebGLMutationObserver(cb, win, blockClass, mirror) {
    var handlers = [];
    handlers.push.apply(handlers, __spreadArray([], __read(patchGLPrototype(win.WebGLRenderingContext.prototype, CanvasContext.WebGL, cb, blockClass, mirror, win)), false));
    if (typeof win.WebGL2RenderingContext !== 'undefined') {
        handlers.push.apply(handlers, __spreadArray([], __read(patchGLPrototype(win.WebGL2RenderingContext.prototype, CanvasContext.WebGL2, cb, blockClass, mirror, win)), false));
    }
    return function () {
        handlers.forEach(function (h) { return h(); });
    };
}

var CanvasManager = (function () {
    function CanvasManager(options) {
        this.pendingCanvasMutations = new Map();
        this.rafStamps = { latestId: 0, invokeId: null };
        this.frozen = false;
        this.locked = false;
        this.processMutation = function (target, mutation) {
            var newFrame = this.rafStamps.invokeId &&
                this.rafStamps.latestId !== this.rafStamps.invokeId;
            if (newFrame || !this.rafStamps.invokeId)
                this.rafStamps.invokeId = this.rafStamps.latestId;
            if (!this.pendingCanvasMutations.has(target)) {
                this.pendingCanvasMutations.set(target, []);
            }
            this.pendingCanvasMutations.get(target).push(mutation);
        };
        this.mutationCb = options.mutationCb;
        this.mirror = options.mirror;
        if (options.recordCanvas === true)
            this.initCanvasMutationObserver(options.win, options.blockClass);
    }
    CanvasManager.prototype.reset = function () {
        this.pendingCanvasMutations.clear();
        this.resetObservers && this.resetObservers();
    };
    CanvasManager.prototype.freeze = function () {
        this.frozen = true;
    };
    CanvasManager.prototype.unfreeze = function () {
        this.frozen = false;
    };
    CanvasManager.prototype.lock = function () {
        this.locked = true;
    };
    CanvasManager.prototype.unlock = function () {
        this.locked = false;
    };
    CanvasManager.prototype.initCanvasMutationObserver = function (win, blockClass) {
        this.startRAFTimestamping();
        this.startPendingCanvasMutationFlusher();
        var canvasContextReset = initCanvasContextObserver(win, blockClass);
        var canvas2DReset = initCanvas2DMutationObserver(this.processMutation.bind(this), win, blockClass, this.mirror);
        var canvasWebGL1and2Reset = initCanvasWebGLMutationObserver(this.processMutation.bind(this), win, blockClass, this.mirror);
        this.resetObservers = function () {
            canvasContextReset();
            canvas2DReset();
            canvasWebGL1and2Reset();
        };
    };
    CanvasManager.prototype.startPendingCanvasMutationFlusher = function () {
        var _this = this;
        requestAnimationFrame(function () { return _this.flushPendingCanvasMutations(); });
    };
    CanvasManager.prototype.startRAFTimestamping = function () {
        var _this = this;
        var setLatestRAFTimestamp = function (timestamp) {
            _this.rafStamps.latestId = timestamp;
            requestAnimationFrame(setLatestRAFTimestamp);
        };
        requestAnimationFrame(setLatestRAFTimestamp);
    };
    CanvasManager.prototype.flushPendingCanvasMutations = function () {
        var _this = this;
        this.pendingCanvasMutations.forEach(function (values, canvas) {
            var id = _this.mirror.getId(canvas);
            _this.flushPendingCanvasMutationFor(canvas, id);
        });
        requestAnimationFrame(function () { return _this.flushPendingCanvasMutations(); });
    };
    CanvasManager.prototype.flushPendingCanvasMutationFor = function (canvas, id) {
        if (this.frozen || this.locked) {
            return;
        }
        var valuesWithType = this.pendingCanvasMutations.get(canvas);
        if (!valuesWithType || id === -1)
            return;
        var values = valuesWithType.map(function (value) {
            value.type; var rest = __rest(value, ["type"]);
            return rest;
        });
        var type = valuesWithType[0].type;
        this.mutationCb({ id: id, type: type, commands: values });
        this.pendingCanvasMutations.delete(canvas);
    };
    return CanvasManager;
}());

function wrapEvent(e) {
    return __assign(__assign({}, e), { timestamp: Date.now() });
}
var wrappedEmit;
var takeFullSnapshot;
var mirror = createMirror();
function record(options) {
    if (options === void 0) { options = {}; }
    var emit = options.emit, checkoutEveryNms = options.checkoutEveryNms, checkoutEveryNth = options.checkoutEveryNth, _a = options.blockClass, blockClass = _a === void 0 ? 'rr-block' : _a, _b = options.blockSelector, blockSelector = _b === void 0 ? null : _b, _c = options.ignoreClass, ignoreClass = _c === void 0 ? 'rr-ignore' : _c, _d = options.maskTextClass, maskTextClass = _d === void 0 ? 'rr-mask' : _d, _e = options.maskTextSelector, maskTextSelector = _e === void 0 ? null : _e, _f = options.inlineStylesheet, inlineStylesheet = _f === void 0 ? true : _f, maskAllInputs = options.maskAllInputs, _maskInputOptions = options.maskInputOptions, _slimDOMOptions = options.slimDOMOptions, maskInputFn = options.maskInputFn, maskTextFn = options.maskTextFn, hooks = options.hooks, packFn = options.packFn, _g = options.sampling, sampling = _g === void 0 ? {} : _g, mousemoveWait = options.mousemoveWait, _h = options.recordCanvas, recordCanvas = _h === void 0 ? false : _h, _j = options.userTriggeredOnInput, userTriggeredOnInput = _j === void 0 ? false : _j, _k = options.collectFonts, collectFonts = _k === void 0 ? false : _k, _l = options.inlineImages, inlineImages = _l === void 0 ? false : _l, plugins = options.plugins, _m = options.keepIframeSrcFn, keepIframeSrcFn = _m === void 0 ? function () { return false; } : _m;
    if (!emit) {
        throw new Error('emit function is required');
    }
    if (mousemoveWait !== undefined && sampling.mousemove === undefined) {
        sampling.mousemove = mousemoveWait;
    }
    var maskInputOptions = maskAllInputs === true
        ? {
            color: true,
            date: true,
            'datetime-local': true,
            email: true,
            month: true,
            number: true,
            range: true,
            search: true,
            tel: true,
            text: true,
            time: true,
            url: true,
            week: true,
            textarea: true,
            select: true,
            password: true,
        }
        : _maskInputOptions !== undefined
            ? _maskInputOptions
            : { password: true };
    var slimDOMOptions = _slimDOMOptions === true || _slimDOMOptions === 'all'
        ? {
            script: true,
            comment: true,
            headFavicon: true,
            headWhitespace: true,
            headMetaSocial: true,
            headMetaRobots: true,
            headMetaHttpEquiv: true,
            headMetaVerification: true,
            headMetaAuthorship: _slimDOMOptions === 'all',
            headMetaDescKeywords: _slimDOMOptions === 'all',
        }
        : _slimDOMOptions
            ? _slimDOMOptions
            : {};
    polyfill();
    var lastFullSnapshotEvent;
    var incrementalSnapshotCount = 0;
    var eventProcessor = function (e) {
        var e_1, _a;
        try {
            for (var _b = __values(plugins || []), _c = _b.next(); !_c.done; _c = _b.next()) {
                var plugin = _c.value;
                if (plugin.eventProcessor) {
                    e = plugin.eventProcessor(e);
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
        if (packFn) {
            e = packFn(e);
        }
        return e;
    };
    wrappedEmit = function (e, isCheckout) {
        var _a;
        if (((_a = mutationBuffers[0]) === null || _a === void 0 ? void 0 : _a.isFrozen()) &&
            e.type !== EventType.FullSnapshot &&
            !(e.type === EventType.IncrementalSnapshot &&
                e.data.source === IncrementalSource.Mutation)) {
            mutationBuffers.forEach(function (buf) { return buf.unfreeze(); });
        }
        emit(eventProcessor(e), isCheckout);
        if (e.type === EventType.FullSnapshot) {
            lastFullSnapshotEvent = e;
            incrementalSnapshotCount = 0;
        }
        else if (e.type === EventType.IncrementalSnapshot) {
            if (e.data.source === IncrementalSource.Mutation &&
                e.data.isAttachIframe) {
                return;
            }
            incrementalSnapshotCount++;
            var exceedCount = checkoutEveryNth && incrementalSnapshotCount >= checkoutEveryNth;
            var exceedTime = checkoutEveryNms &&
                e.timestamp - lastFullSnapshotEvent.timestamp > checkoutEveryNms;
            if (exceedCount || exceedTime) {
                takeFullSnapshot(true);
            }
        }
    };
    var wrappedMutationEmit = function (m) {
        wrappedEmit(wrapEvent({
            type: EventType.IncrementalSnapshot,
            data: __assign({ source: IncrementalSource.Mutation }, m),
        }));
    };
    var wrappedScrollEmit = function (p) {
        return wrappedEmit(wrapEvent({
            type: EventType.IncrementalSnapshot,
            data: __assign({ source: IncrementalSource.Scroll }, p),
        }));
    };
    var wrappedCanvasMutationEmit = function (p) {
        return wrappedEmit(wrapEvent({
            type: EventType.IncrementalSnapshot,
            data: __assign({ source: IncrementalSource.CanvasMutation }, p),
        }));
    };
    var iframeManager = new IframeManager({
        mutationCb: wrappedMutationEmit,
    });
    var canvasManager = new CanvasManager({
        recordCanvas: recordCanvas,
        mutationCb: wrappedCanvasMutationEmit,
        win: window,
        blockClass: blockClass,
        mirror: mirror,
    });
    var shadowDomManager = new ShadowDomManager({
        mutationCb: wrappedMutationEmit,
        scrollCb: wrappedScrollEmit,
        bypassOptions: {
            blockClass: blockClass,
            blockSelector: blockSelector,
            maskTextClass: maskTextClass,
            maskTextSelector: maskTextSelector,
            inlineStylesheet: inlineStylesheet,
            maskInputOptions: maskInputOptions,
            maskTextFn: maskTextFn,
            maskInputFn: maskInputFn,
            recordCanvas: recordCanvas,
            inlineImages: inlineImages,
            sampling: sampling,
            slimDOMOptions: slimDOMOptions,
            iframeManager: iframeManager,
            canvasManager: canvasManager,
        },
        mirror: mirror,
    });
    takeFullSnapshot = function (isCheckout) {
        var _a, _b, _c, _d;
        if (isCheckout === void 0) { isCheckout = false; }
        wrappedEmit(wrapEvent({
            type: EventType.Meta,
            data: {
                href: window.location.href,
                width: getWindowWidth(),
                height: getWindowHeight(),
            },
        }), isCheckout);
        mutationBuffers.forEach(function (buf) { return buf.lock(); });
        var _e = __read(snapshot(document, {
            blockClass: blockClass,
            blockSelector: blockSelector,
            maskTextClass: maskTextClass,
            maskTextSelector: maskTextSelector,
            inlineStylesheet: inlineStylesheet,
            maskAllInputs: maskInputOptions,
            maskTextFn: maskTextFn,
            slimDOM: slimDOMOptions,
            recordCanvas: recordCanvas,
            inlineImages: inlineImages,
            onSerialize: function (n) {
                if (isIframeINode(n)) {
                    iframeManager.addIframe(n);
                }
                if (hasShadowRoot(n)) {
                    shadowDomManager.addShadowRoot(n.shadowRoot, document);
                }
            },
            onIframeLoad: function (iframe, childSn) {
                iframeManager.attachIframe(iframe, childSn);
                shadowDomManager.observeAttachShadow(iframe);
            },
            keepIframeSrcFn: keepIframeSrcFn,
        }), 2), node = _e[0], idNodeMap = _e[1];
        if (!node) {
            return console.warn('Failed to snapshot the document');
        }
        mirror.map = idNodeMap;
        wrappedEmit(wrapEvent({
            type: EventType.FullSnapshot,
            data: {
                node: node,
                initialOffset: {
                    left: window.pageXOffset !== undefined
                        ? window.pageXOffset
                        : (document === null || document === void 0 ? void 0 : document.documentElement.scrollLeft) ||
                            ((_b = (_a = document === null || document === void 0 ? void 0 : document.body) === null || _a === void 0 ? void 0 : _a.parentElement) === null || _b === void 0 ? void 0 : _b.scrollLeft) ||
                            (document === null || document === void 0 ? void 0 : document.body.scrollLeft) ||
                            0,
                    top: window.pageYOffset !== undefined
                        ? window.pageYOffset
                        : (document === null || document === void 0 ? void 0 : document.documentElement.scrollTop) ||
                            ((_d = (_c = document === null || document === void 0 ? void 0 : document.body) === null || _c === void 0 ? void 0 : _c.parentElement) === null || _d === void 0 ? void 0 : _d.scrollTop) ||
                            (document === null || document === void 0 ? void 0 : document.body.scrollTop) ||
                            0,
                },
            },
        }));
        mutationBuffers.forEach(function (buf) { return buf.unlock(); });
    };
    try {
        var handlers_1 = [];
        handlers_1.push(on('DOMContentLoaded', function () {
            wrappedEmit(wrapEvent({
                type: EventType.DomContentLoaded,
                data: {},
            }));
        }));
        var observe_1 = function (doc) {
            var _a;
            return initObservers({
                mutationCb: wrappedMutationEmit,
                mousemoveCb: function (positions, source) {
                    return wrappedEmit(wrapEvent({
                        type: EventType.IncrementalSnapshot,
                        data: {
                            source: source,
                            positions: positions,
                        },
                    }));
                },
                mouseInteractionCb: function (d) {
                    return wrappedEmit(wrapEvent({
                        type: EventType.IncrementalSnapshot,
                        data: __assign({ source: IncrementalSource.MouseInteraction }, d),
                    }));
                },
                scrollCb: wrappedScrollEmit,
                viewportResizeCb: function (d) {
                    return wrappedEmit(wrapEvent({
                        type: EventType.IncrementalSnapshot,
                        data: __assign({ source: IncrementalSource.ViewportResize }, d),
                    }));
                },
                inputCb: function (v) {
                    return wrappedEmit(wrapEvent({
                        type: EventType.IncrementalSnapshot,
                        data: __assign({ source: IncrementalSource.Input }, v),
                    }));
                },
                mediaInteractionCb: function (p) {
                    return wrappedEmit(wrapEvent({
                        type: EventType.IncrementalSnapshot,
                        data: __assign({ source: IncrementalSource.MediaInteraction }, p),
                    }));
                },
                styleSheetRuleCb: function (r) {
                    return wrappedEmit(wrapEvent({
                        type: EventType.IncrementalSnapshot,
                        data: __assign({ source: IncrementalSource.StyleSheetRule }, r),
                    }));
                },
                styleDeclarationCb: function (r) {
                    return wrappedEmit(wrapEvent({
                        type: EventType.IncrementalSnapshot,
                        data: __assign({ source: IncrementalSource.StyleDeclaration }, r),
                    }));
                },
                canvasMutationCb: wrappedCanvasMutationEmit,
                fontCb: function (p) {
                    return wrappedEmit(wrapEvent({
                        type: EventType.IncrementalSnapshot,
                        data: __assign({ source: IncrementalSource.Font }, p),
                    }));
                },
                blockClass: blockClass,
                ignoreClass: ignoreClass,
                maskTextClass: maskTextClass,
                maskTextSelector: maskTextSelector,
                maskInputOptions: maskInputOptions,
                inlineStylesheet: inlineStylesheet,
                sampling: sampling,
                recordCanvas: recordCanvas,
                inlineImages: inlineImages,
                userTriggeredOnInput: userTriggeredOnInput,
                collectFonts: collectFonts,
                doc: doc,
                maskInputFn: maskInputFn,
                maskTextFn: maskTextFn,
                blockSelector: blockSelector,
                slimDOMOptions: slimDOMOptions,
                mirror: mirror,
                iframeManager: iframeManager,
                shadowDomManager: shadowDomManager,
                canvasManager: canvasManager,
                plugins: ((_a = plugins === null || plugins === void 0 ? void 0 : plugins.filter(function (p) { return p.observer; })) === null || _a === void 0 ? void 0 : _a.map(function (p) { return ({
                    observer: p.observer,
                    options: p.options,
                    callback: function (payload) {
                        return wrappedEmit(wrapEvent({
                            type: EventType.Plugin,
                            data: {
                                plugin: p.name,
                                payload: payload,
                            },
                        }));
                    },
                }); })) || [],
            }, hooks);
        };
        iframeManager.addLoadListener(function (iframeEl) {
            try {
                handlers_1.push(observe_1(iframeEl.contentDocument));
            } catch (error) {
                console.warn('error in rrweb iframe observer', error);
            }
        });
        var init_1 = function () {
            takeFullSnapshot();
            handlers_1.push(observe_1(document));
        };
        if (document.readyState === 'interactive' ||
            document.readyState === 'complete') {
            init_1();
        }
        else {
            handlers_1.push(on('load', function () {
                wrappedEmit(wrapEvent({
                    type: EventType.Load,
                    data: {},
                }));
                init_1();
            }, window));
        }
        return function () {
            handlers_1.forEach(function (h) { return h(); });
        };
    }
    catch (error) {
        console.warn(error);
    }
}
record.addCustomEvent = function (tag, payload) {
    if (!wrappedEmit) {
        throw new Error('please add custom event after start recording');
    }
    wrappedEmit(wrapEvent({
        type: EventType.Custom,
        data: {
            tag: tag,
            payload: payload,
        },
    }));
};
record.freezePage = function () {
    mutationBuffers.forEach(function (buf) { return buf.freeze(); });
};
record.takeFullSnapshot = function (isCheckout) {
    if (!takeFullSnapshot) {
        throw new Error('please take full snapshot after start recording');
    }
    takeFullSnapshot(isCheckout);
};
record.mirror = mirror;

/**
 * Create a breadcrumb for a replay.
 */
function createBreadcrumb(
  breadcrumb,
) {
  return {
    timestamp: new Date().getTime() / 1000,
    type: 'default',
    ...breadcrumb,
  };
}

/**
 * An event handler to react to DOM events.
 */
function handleDom(handlerData) {
  // Taken from https://github.com/getsentry/sentry-javascript/blob/master/packages/browser/src/integrations/breadcrumbs.ts#L112
  let target;
  let targetNode;

  // Accessing event.target can throw (see getsentry/raven-js#838, #768)
  try {
    targetNode = getTargetNode(handlerData);
    target = (0,browser/* htmlTreeAsString */.Rt)(targetNode);
  } catch (e) {
    target = '<unknown>';
  }

  if (target.length === 0) {
    return null;
  }

  return createBreadcrumb({
    category: `ui.${handlerData.name}`,
    message: target,
    data: {
      // Not sure why this errors, Node should be correct (Argument of type 'Node' is not assignable to parameter of type 'INode')
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      ...(targetNode ? { nodeId: record.mirror.getId(targetNode ) } : {}),
    },
  });
}

function getTargetNode(handlerData) {
  if (isEventWithTarget(handlerData.event)) {
    return handlerData.event.target;
  }

  return handlerData.event;
}

function isEventWithTarget(event) {
  return !!(event ).target;
}

let _LAST_BREADCRUMB = null;

/**
 * An event handler to handle scope changes.
 */
function handleScope(scope) {
  const newBreadcrumb = scope.getLastBreadcrumb();

  // Listener can be called when breadcrumbs have not changed, so we store the
  // reference to the last crumb and only return a crumb if it has changed
  if (_LAST_BREADCRUMB === newBreadcrumb || !newBreadcrumb) {
    return null;
  }

  _LAST_BREADCRUMB = newBreadcrumb;

  if (
    newBreadcrumb.category &&
    (['fetch', 'xhr', 'sentry.event', 'sentry.transaction'].includes(newBreadcrumb.category) ||
      newBreadcrumb.category.startsWith('ui.'))
  ) {
    return null;
  }

  return createBreadcrumb(newBreadcrumb);
}

/**
 * An event handler to react to breadcrumbs.
 */
function breadcrumbHandler(type, handlerData) {
  if (type === 'scope') {
    return handleScope(handlerData );
  }

  return handleDom(handlerData );
}

/**
 * Add an event to the event buffer
 */
async function addEvent(
  replay,
  event,
  isCheckout,
) {
  if (!replay.eventBuffer) {
    // This implies that `_isEnabled` is false
    return null;
  }

  if (replay.isPaused()) {
    // Do not add to event buffer when recording is paused
    return null;
  }

  // TODO: sadness -- we will want to normalize timestamps to be in ms -
  // requires coordination with frontend
  const isMs = event.timestamp > 9999999999;
  const timestampInMs = isMs ? event.timestamp : event.timestamp * 1000;

  // Throw out events that happen more than 5 minutes ago. This can happen if
  // page has been left open and idle for a long period of time and user
  // comes back to trigger a new session. The performance entries rely on
  // `performance.timeOrigin`, which is when the page first opened.
  if (timestampInMs + SESSION_IDLE_DURATION < new Date().getTime()) {
    return null;
  }

  // Only record earliest event if a new session was created, otherwise it
  // shouldn't be relevant
  const earliestEvent = replay.getContext().earliestEvent;
  if (replay.session && replay.session.segmentId === 0 && (!earliestEvent || timestampInMs < earliestEvent)) {
    replay.getContext().earliestEvent = timestampInMs;
  }

  return replay.eventBuffer.addEvent(event, isCheckout);
}

/**
 * Create a "span" for each performance entry. The parent transaction is `this.replayEvent`.
 */
function createPerformanceSpans(
  replay,
  entries,
) {
  return entries.map(({ type, start, end, name, data }) =>
    addEvent(replay, {
      type: EventType.Custom,
      timestamp: start,
      data: {
        tag: 'performanceSpan',
        payload: {
          op: type,
          description: name,
          startTimestamp: start,
          endTimestamp: end,
          data,
        },
      },
    }),
  );
}

/**
 * Check whether a given request URL should be filtered out.
 */
function shouldFilterRequest(replay, url) {
  // If we enabled the `traceInternals` experiment, we want to trace everything
  if ((typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && replay.getOptions()._experiments.traceInternals) {
    return false;
  }

  return !_isSentryRequest(url);
}

/**
 * Checks wether a given URL belongs to the configured Sentry DSN.
 */
function _isSentryRequest(url) {
  const client = (0,esm_hub/* getCurrentHub */.Gd)().getClient();
  const dsn = client && client.getDsn();
  return dsn ? url.includes(dsn.host) : false;
}

/** only exported for tests */
function handleFetch(handlerData) {
  if (!handlerData.endTimestamp) {
    return null;
  }

  const { startTimestamp, endTimestamp, fetchData, response } = handlerData;

  return {
    type: 'resource.fetch',
    start: startTimestamp / 1000,
    end: endTimestamp / 1000,
    name: fetchData.url,
    data: {
      method: fetchData.method,
      statusCode: response.status,
    },
  };
}

/**
 * Returns a listener to be added to `addInstrumentationHandler('fetch', listener)`.
 */
function handleFetchSpanListener(replay) {
  return (handlerData) => {
    if (!replay.isEnabled()) {
      return;
    }

    const result = handleFetch(handlerData);

    if (result === null) {
      return;
    }

    if (shouldFilterRequest(replay, result.name)) {
      return;
    }

    replay.addUpdate(() => {
      createPerformanceSpans(replay, [result]);
      // Returning true will cause `addUpdate` to not flush
      // We do not want network requests to cause a flush. This will prevent
      // recurring/polling requests from keeping the replay session alive.
      return true;
    });
  };
}

/**
 * Returns true if we think the given event is an error originating inside of rrweb.
 */
function isRrwebError(event) {
  if (event.type || !event.exception || !event.exception.values || !event.exception.values.length) {
    return false;
  }

  // Check if any exception originates from rrweb
  return event.exception.values.some(exception => {
    if (!exception.stacktrace || !exception.stacktrace.frames || !exception.stacktrace.frames.length) {
      return false;
    }

    return exception.stacktrace.frames.some(frame => frame.filename && frame.filename.includes('/rrweb/src/'));
  });
}

/**
 * Returns a listener to be added to `addGlobalEventProcessor(listener)`.
 */
function handleGlobalEventListener(replay) {
  return (event) => {
    // Do not apply replayId to the root event
    if (event.type === REPLAY_EVENT_NAME) {
      // Replays have separate set of breadcrumbs, do not include breadcrumbs
      // from core SDK
      delete event.breadcrumbs;
      return event;
    }

    // Unless `captureExceptions` is enabled, we want to ignore errors coming from rrweb
    // As there can be a bunch of stuff going wrong in internals there, that we don't want to bubble up to users
    if (isRrwebError(event) && !replay.getOptions()._experiments.captureExceptions) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.log */.kg.log('[Replay] Ignoring error from rrweb internals', event);
      return null;
    }

    // Only tag transactions with replayId if not waiting for an error
    // @ts-ignore private
    if (!event.type || replay.recordingMode === 'session') {
      event.tags = { ...event.tags, replayId: replay.getSessionId() };
    }

    // Collect traceIds in _context regardless of `recordingMode` - if it's true,
    // _context gets cleared on every checkout
    if (event.type === 'transaction' && event.contexts && event.contexts.trace && event.contexts.trace.trace_id) {
      replay.getContext().traceIds.add(event.contexts.trace.trace_id );
      return event;
    }

    // no event type means error
    if (!event.type) {
      replay.getContext().errorIds.add(event.event_id );
    }

    if ((typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && replay.getOptions()._experiments.traceInternals) {
      const exc = getEventExceptionValues(event);
      addInternalBreadcrumb({
        message: `Tagging event (${event.event_id}) - ${event.message} - ${exc.type}: ${exc.value}`,
      });
    }

    // Need to be very careful that this does not cause an infinite loop
    if (
      replay.recordingMode === 'error' &&
      event.exception &&
      event.message !== UNABLE_TO_SEND_REPLAY // ignore this error because otherwise we could loop indefinitely with trying to capture replay and failing
    ) {
      setTimeout(async () => {
        // Allow flush to complete before resuming as a session recording, otherwise
        // the checkout from `startRecording` may be included in the payload.
        // Prefer to keep the error replay as a separate (and smaller) segment
        // than the session replay.
        await replay.flushImmediate();

        if (replay.stopRecording()) {
          // Reset all "capture on error" configuration before
          // starting a new recording
          replay.recordingMode = 'session';
          replay.startRecording();
        }
      });
    }

    return event;
  };
}

function addInternalBreadcrumb(arg) {
  const { category, level, message, ...rest } = arg;

  addBreadcrumb({
    category: category || 'console',
    level: level || 'debug',
    message: `[debug]: ${message}`,
    ...rest,
  });
}

function getEventExceptionValues(event) {
  return {
    type: 'Unknown',
    value: 'n/a',
    ...(event.exception && event.exception.values && event.exception.values[0]),
  };
}

function handleHistory(handlerData) {
  const { from, to } = handlerData;

  const now = new Date().getTime() / 1000;

  return {
    type: 'navigation.push',
    start: now,
    end: now,
    name: to,
    data: {
      previous: from,
    },
  };
}

/**
 * Returns a listener to be added to `addInstrumentationHandler('history', listener)`.
 */
function handleHistorySpanListener(replay) {
  return (handlerData) => {
    if (!replay.isEnabled()) {
      return;
    }

    const result = handleHistory(handlerData);

    if (result === null) {
      return;
    }

    // Need to collect visited URLs
    replay.getContext().urls.push(result.name);
    replay.triggerUserActivity();

    replay.addUpdate(() => {
      createPerformanceSpans(replay, [result]);
      // Returning false to flush
      return false;
    });
  };
}

// From sentry-javascript
// e.g. https://github.com/getsentry/sentry-javascript/blob/c7fc025bf9fa8c073fdb56351808ce53909fbe45/packages/utils/src/instrument.ts#L180

function handleXhr(handlerData) {
  if (handlerData.xhr.__sentry_own_request__) {
    // Taken from sentry-javascript
    // Only capture non-sentry requests
    return null;
  }

  if (handlerData.startTimestamp) {
    // TODO: See if this is still needed
    handlerData.xhr.__sentry_xhr__ = handlerData.xhr.__sentry_xhr__ || {};
    handlerData.xhr.__sentry_xhr__.startTimestamp = handlerData.startTimestamp;
  }

  if (!handlerData.endTimestamp) {
    return null;
  }

  const { method, url, status_code: statusCode } = handlerData.xhr.__sentry_xhr__ || {};

  if (url === undefined) {
    return null;
  }

  const timestamp = handlerData.xhr.__sentry_xhr__
    ? handlerData.xhr.__sentry_xhr__.startTimestamp || 0
    : handlerData.endTimestamp;

  return {
    type: 'resource.xhr',
    name: url,
    start: timestamp / 1000,
    end: handlerData.endTimestamp / 1000,
    data: {
      method,
      statusCode,
    },
  };
}

/**
 * Returns a listener to be added to `addInstrumentationHandler('xhr', listener)`.
 */
function handleXhrSpanListener(replay) {
  return (handlerData) => {
    if (!replay.isEnabled()) {
      return;
    }

    const result = handleXhr(handlerData);

    if (result === null) {
      return;
    }

    if (shouldFilterRequest(replay, result.name)) {
      return;
    }

    replay.addUpdate(() => {
      createPerformanceSpans(replay, [result]);
      // Returning true will cause `addUpdate` to not flush
      // We do not want network requests to cause a flush. This will prevent
      // recurring/polling requests from keeping the replay session alive.
      return true;
    });
  };
}

const NAVIGATION_ENTRY_KEYS = [
  'name',
  'type',
  'startTime',
  'transferSize',
  'duration',
];

function isNavigationEntryEqual(a) {
  return function (b) {
    return NAVIGATION_ENTRY_KEYS.every(key => a[key] === b[key]);
  };
}

/**
 * There are some difficulties diagnosing why there are duplicate navigation
 * entries. We've witnessed several intermittent results:
 * - duplicate entries have duration = 0
 * - duplicate entries are the same object reference
 * - none of the above
 *
 * Compare the values of several keys to determine if the entries are duplicates or not.
 */
// TODO (high-prio): Figure out wth is returned here
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
function dedupePerformanceEntries(
  currentList,
  newList,
) {
  // Partition `currentList` into 3 different lists based on entryType
  const [existingNavigationEntries, existingLcpEntries, existingEntries] = currentList.reduce(
    (acc, entry) => {
      if (entry.entryType === 'navigation') {
        acc[0].push(entry );
      } else if (entry.entryType === 'largest-contentful-paint') {
        acc[1].push(entry );
      } else {
        acc[2].push(entry);
      }
      return acc;
    },
    [[], [], []],
  );

  const newEntries = [];
  const newNavigationEntries = [];
  let newLcpEntry = existingLcpEntries.length
    ? existingLcpEntries[existingLcpEntries.length - 1] // Take the last element as list is sorted
    : undefined;

  newList.forEach(entry => {
    if (entry.entryType === 'largest-contentful-paint') {
      // We want the latest LCP event only
      if (!newLcpEntry || newLcpEntry.startTime < entry.startTime) {
        newLcpEntry = entry;
      }
      return;
    }

    if (entry.entryType === 'navigation') {
      const navigationEntry = entry ;

      // Check if the navigation entry is contained in currentList or newList
      if (
        // Ignore any navigation entries with duration 0, as they are likely duplicates
        entry.duration > 0 &&
        // Ensure new entry does not already exist in existing entries
        !existingNavigationEntries.find(isNavigationEntryEqual(navigationEntry)) &&
        // Ensure new entry does not already exist in new list of navigation entries
        !newNavigationEntries.find(isNavigationEntryEqual(navigationEntry))
      ) {
        newNavigationEntries.push(navigationEntry);
      }

      // Otherwise this navigation entry is considered a duplicate and is thrown away
      return;
    }

    newEntries.push(entry);
  });

  // Re-combine and sort by startTime
  return [
    ...(newLcpEntry ? [newLcpEntry] : []),
    ...existingNavigationEntries,
    ...existingEntries,
    ...newEntries,
    ...newNavigationEntries,
  ].sort((a, b) => a.startTime - b.startTime);
}

/**
 * Sets up a PerformanceObserver to listen to all performance entry types.
 */
function setupPerformanceObserver(replay) {
  const performanceObserverHandler = (list) => {
    // For whatever reason the observer was returning duplicate navigation
    // entries (the other entry types were not duplicated).
    const newPerformanceEntries = dedupePerformanceEntries(
      replay.performanceEvents,
      list.getEntries() ,
    );
    replay.performanceEvents = newPerformanceEntries;
  };

  const performanceObserver = new PerformanceObserver(performanceObserverHandler);

  [
    'element',
    'event',
    'first-input',
    'largest-contentful-paint',
    'layout-shift',
    'longtask',
    'navigation',
    'paint',
    'resource',
  ].forEach(type => {
    try {
      performanceObserver.observe({
        type,
        buffered: true,
      });
    } catch (e) {
      // This can throw if an entry type is not supported in the browser.
      // Ignore these errors.
    }
  });

  return performanceObserver;
}

const workerString = `/*! pako 2.1.0 https://github.com/nodeca/pako @license (MIT AND Zlib) */
function t(t){let e=t.length;for(;--e>=0;)t[e]=0}const e=new Uint8Array([0,0,0,0,0,0,0,0,1,1,1,1,2,2,2,2,3,3,3,3,4,4,4,4,5,5,5,5,0]),a=new Uint8Array([0,0,0,0,1,1,2,2,3,3,4,4,5,5,6,6,7,7,8,8,9,9,10,10,11,11,12,12,13,13]),i=new Uint8Array([0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2,3,7]),n=new Uint8Array([16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15]),s=new Array(576);t(s);const r=new Array(60);t(r);const o=new Array(512);t(o);const l=new Array(256);t(l);const h=new Array(29);t(h);const d=new Array(30);function _(t,e,a,i,n){this.static_tree=t,this.extra_bits=e,this.extra_base=a,this.elems=i,this.max_length=n,this.has_stree=t&&t.length}let f,c,u;function w(t,e){this.dyn_tree=t,this.max_code=0,this.stat_desc=e}t(d);const m=t=>t<256?o[t]:o[256+(t>>>7)],b=(t,e)=>{t.pending_buf[t.pending++]=255&e,t.pending_buf[t.pending++]=e>>>8&255},g=(t,e,a)=>{t.bi_valid>16-a?(t.bi_buf|=e<<t.bi_valid&65535,b(t,t.bi_buf),t.bi_buf=e>>16-t.bi_valid,t.bi_valid+=a-16):(t.bi_buf|=e<<t.bi_valid&65535,t.bi_valid+=a)},p=(t,e,a)=>{g(t,a[2*e],a[2*e+1])},k=(t,e)=>{let a=0;do{a|=1&t,t>>>=1,a<<=1}while(--e>0);return a>>>1},v=(t,e,a)=>{const i=new Array(16);let n,s,r=0;for(n=1;n<=15;n++)r=r+a[n-1]<<1,i[n]=r;for(s=0;s<=e;s++){let e=t[2*s+1];0!==e&&(t[2*s]=k(i[e]++,e))}},y=t=>{let e;for(e=0;e<286;e++)t.dyn_ltree[2*e]=0;for(e=0;e<30;e++)t.dyn_dtree[2*e]=0;for(e=0;e<19;e++)t.bl_tree[2*e]=0;t.dyn_ltree[512]=1,t.opt_len=t.static_len=0,t.sym_next=t.matches=0},x=t=>{t.bi_valid>8?b(t,t.bi_buf):t.bi_valid>0&&(t.pending_buf[t.pending++]=t.bi_buf),t.bi_buf=0,t.bi_valid=0},z=(t,e,a,i)=>{const n=2*e,s=2*a;return t[n]<t[s]||t[n]===t[s]&&i[e]<=i[a]},A=(t,e,a)=>{const i=t.heap[a];let n=a<<1;for(;n<=t.heap_len&&(n<t.heap_len&&z(e,t.heap[n+1],t.heap[n],t.depth)&&n++,!z(e,i,t.heap[n],t.depth));)t.heap[a]=t.heap[n],a=n,n<<=1;t.heap[a]=i},E=(t,i,n)=>{let s,r,o,_,f=0;if(0!==t.sym_next)do{s=255&t.pending_buf[t.sym_buf+f++],s+=(255&t.pending_buf[t.sym_buf+f++])<<8,r=t.pending_buf[t.sym_buf+f++],0===s?p(t,r,i):(o=l[r],p(t,o+256+1,i),_=e[o],0!==_&&(r-=h[o],g(t,r,_)),s--,o=m(s),p(t,o,n),_=a[o],0!==_&&(s-=d[o],g(t,s,_)))}while(f<t.sym_next);p(t,256,i)},R=(t,e)=>{const a=e.dyn_tree,i=e.stat_desc.static_tree,n=e.stat_desc.has_stree,s=e.stat_desc.elems;let r,o,l,h=-1;for(t.heap_len=0,t.heap_max=573,r=0;r<s;r++)0!==a[2*r]?(t.heap[++t.heap_len]=h=r,t.depth[r]=0):a[2*r+1]=0;for(;t.heap_len<2;)l=t.heap[++t.heap_len]=h<2?++h:0,a[2*l]=1,t.depth[l]=0,t.opt_len--,n&&(t.static_len-=i[2*l+1]);for(e.max_code=h,r=t.heap_len>>1;r>=1;r--)A(t,a,r);l=s;do{r=t.heap[1],t.heap[1]=t.heap[t.heap_len--],A(t,a,1),o=t.heap[1],t.heap[--t.heap_max]=r,t.heap[--t.heap_max]=o,a[2*l]=a[2*r]+a[2*o],t.depth[l]=(t.depth[r]>=t.depth[o]?t.depth[r]:t.depth[o])+1,a[2*r+1]=a[2*o+1]=l,t.heap[1]=l++,A(t,a,1)}while(t.heap_len>=2);t.heap[--t.heap_max]=t.heap[1],((t,e)=>{const a=e.dyn_tree,i=e.max_code,n=e.stat_desc.static_tree,s=e.stat_desc.has_stree,r=e.stat_desc.extra_bits,o=e.stat_desc.extra_base,l=e.stat_desc.max_length;let h,d,_,f,c,u,w=0;for(f=0;f<=15;f++)t.bl_count[f]=0;for(a[2*t.heap[t.heap_max]+1]=0,h=t.heap_max+1;h<573;h++)d=t.heap[h],f=a[2*a[2*d+1]+1]+1,f>l&&(f=l,w++),a[2*d+1]=f,d>i||(t.bl_count[f]++,c=0,d>=o&&(c=r[d-o]),u=a[2*d],t.opt_len+=u*(f+c),s&&(t.static_len+=u*(n[2*d+1]+c)));if(0!==w){do{for(f=l-1;0===t.bl_count[f];)f--;t.bl_count[f]--,t.bl_count[f+1]+=2,t.bl_count[l]--,w-=2}while(w>0);for(f=l;0!==f;f--)for(d=t.bl_count[f];0!==d;)_=t.heap[--h],_>i||(a[2*_+1]!==f&&(t.opt_len+=(f-a[2*_+1])*a[2*_],a[2*_+1]=f),d--)}})(t,e),v(a,h,t.bl_count)},Z=(t,e,a)=>{let i,n,s=-1,r=e[1],o=0,l=7,h=4;for(0===r&&(l=138,h=3),e[2*(a+1)+1]=65535,i=0;i<=a;i++)n=r,r=e[2*(i+1)+1],++o<l&&n===r||(o<h?t.bl_tree[2*n]+=o:0!==n?(n!==s&&t.bl_tree[2*n]++,t.bl_tree[32]++):o<=10?t.bl_tree[34]++:t.bl_tree[36]++,o=0,s=n,0===r?(l=138,h=3):n===r?(l=6,h=3):(l=7,h=4))},S=(t,e,a)=>{let i,n,s=-1,r=e[1],o=0,l=7,h=4;for(0===r&&(l=138,h=3),i=0;i<=a;i++)if(n=r,r=e[2*(i+1)+1],!(++o<l&&n===r)){if(o<h)do{p(t,n,t.bl_tree)}while(0!=--o);else 0!==n?(n!==s&&(p(t,n,t.bl_tree),o--),p(t,16,t.bl_tree),g(t,o-3,2)):o<=10?(p(t,17,t.bl_tree),g(t,o-3,3)):(p(t,18,t.bl_tree),g(t,o-11,7));o=0,s=n,0===r?(l=138,h=3):n===r?(l=6,h=3):(l=7,h=4)}};let U=!1;const D=(t,e,a,i)=>{g(t,0+(i?1:0),3),x(t),b(t,a),b(t,~a),a&&t.pending_buf.set(t.window.subarray(e,e+a),t.pending),t.pending+=a};var O=(t,e,a,i)=>{let o,l,h=0;t.level>0?(2===t.strm.data_type&&(t.strm.data_type=(t=>{let e,a=4093624447;for(e=0;e<=31;e++,a>>>=1)if(1&a&&0!==t.dyn_ltree[2*e])return 0;if(0!==t.dyn_ltree[18]||0!==t.dyn_ltree[20]||0!==t.dyn_ltree[26])return 1;for(e=32;e<256;e++)if(0!==t.dyn_ltree[2*e])return 1;return 0})(t)),R(t,t.l_desc),R(t,t.d_desc),h=(t=>{let e;for(Z(t,t.dyn_ltree,t.l_desc.max_code),Z(t,t.dyn_dtree,t.d_desc.max_code),R(t,t.bl_desc),e=18;e>=3&&0===t.bl_tree[2*n[e]+1];e--);return t.opt_len+=3*(e+1)+5+5+4,e})(t),o=t.opt_len+3+7>>>3,l=t.static_len+3+7>>>3,l<=o&&(o=l)):o=l=a+5,a+4<=o&&-1!==e?D(t,e,a,i):4===t.strategy||l===o?(g(t,2+(i?1:0),3),E(t,s,r)):(g(t,4+(i?1:0),3),((t,e,a,i)=>{let s;for(g(t,e-257,5),g(t,a-1,5),g(t,i-4,4),s=0;s<i;s++)g(t,t.bl_tree[2*n[s]+1],3);S(t,t.dyn_ltree,e-1),S(t,t.dyn_dtree,a-1)})(t,t.l_desc.max_code+1,t.d_desc.max_code+1,h+1),E(t,t.dyn_ltree,t.dyn_dtree)),y(t),i&&x(t)},T={_tr_init:t=>{U||((()=>{let t,n,w,m,b;const g=new Array(16);for(w=0,m=0;m<28;m++)for(h[m]=w,t=0;t<1<<e[m];t++)l[w++]=m;for(l[w-1]=m,b=0,m=0;m<16;m++)for(d[m]=b,t=0;t<1<<a[m];t++)o[b++]=m;for(b>>=7;m<30;m++)for(d[m]=b<<7,t=0;t<1<<a[m]-7;t++)o[256+b++]=m;for(n=0;n<=15;n++)g[n]=0;for(t=0;t<=143;)s[2*t+1]=8,t++,g[8]++;for(;t<=255;)s[2*t+1]=9,t++,g[9]++;for(;t<=279;)s[2*t+1]=7,t++,g[7]++;for(;t<=287;)s[2*t+1]=8,t++,g[8]++;for(v(s,287,g),t=0;t<30;t++)r[2*t+1]=5,r[2*t]=k(t,5);f=new _(s,e,257,286,15),c=new _(r,a,0,30,15),u=new _(new Array(0),i,0,19,7)})(),U=!0),t.l_desc=new w(t.dyn_ltree,f),t.d_desc=new w(t.dyn_dtree,c),t.bl_desc=new w(t.bl_tree,u),t.bi_buf=0,t.bi_valid=0,y(t)},_tr_stored_block:D,_tr_flush_block:O,_tr_tally:(t,e,a)=>(t.pending_buf[t.sym_buf+t.sym_next++]=e,t.pending_buf[t.sym_buf+t.sym_next++]=e>>8,t.pending_buf[t.sym_buf+t.sym_next++]=a,0===e?t.dyn_ltree[2*a]++:(t.matches++,e--,t.dyn_ltree[2*(l[a]+256+1)]++,t.dyn_dtree[2*m(e)]++),t.sym_next===t.sym_end),_tr_align:t=>{g(t,2,3),p(t,256,s),(t=>{16===t.bi_valid?(b(t,t.bi_buf),t.bi_buf=0,t.bi_valid=0):t.bi_valid>=8&&(t.pending_buf[t.pending++]=255&t.bi_buf,t.bi_buf>>=8,t.bi_valid-=8)})(t)}};var N=(t,e,a,i)=>{let n=65535&t|0,s=t>>>16&65535|0,r=0;for(;0!==a;){r=a>2e3?2e3:a,a-=r;do{n=n+e[i++]|0,s=s+n|0}while(--r);n%=65521,s%=65521}return n|s<<16|0};const F=new Uint32Array((()=>{let t,e=[];for(var a=0;a<256;a++){t=a;for(var i=0;i<8;i++)t=1&t?3988292384^t>>>1:t>>>1;e[a]=t}return e})());var L=(t,e,a,i)=>{const n=F,s=i+a;t^=-1;for(let a=i;a<s;a++)t=t>>>8^n[255&(t^e[a])];return-1^t},I={2:"need dictionary",1:"stream end",0:"","-1":"file error","-2":"stream error","-3":"data error","-4":"insufficient memory","-5":"buffer error","-6":"incompatible version"},B={Z_NO_FLUSH:0,Z_PARTIAL_FLUSH:1,Z_SYNC_FLUSH:2,Z_FULL_FLUSH:3,Z_FINISH:4,Z_BLOCK:5,Z_TREES:6,Z_OK:0,Z_STREAM_END:1,Z_NEED_DICT:2,Z_ERRNO:-1,Z_STREAM_ERROR:-2,Z_DATA_ERROR:-3,Z_MEM_ERROR:-4,Z_BUF_ERROR:-5,Z_NO_COMPRESSION:0,Z_BEST_SPEED:1,Z_BEST_COMPRESSION:9,Z_DEFAULT_COMPRESSION:-1,Z_FILTERED:1,Z_HUFFMAN_ONLY:2,Z_RLE:3,Z_FIXED:4,Z_DEFAULT_STRATEGY:0,Z_BINARY:0,Z_TEXT:1,Z_UNKNOWN:2,Z_DEFLATED:8};const{_tr_init:C,_tr_stored_block:H,_tr_flush_block:M,_tr_tally:j,_tr_align:K}=T,{Z_NO_FLUSH:P,Z_PARTIAL_FLUSH:Y,Z_FULL_FLUSH:G,Z_FINISH:X,Z_BLOCK:J,Z_OK:W,Z_STREAM_END:q,Z_STREAM_ERROR:Q,Z_DATA_ERROR:V,Z_BUF_ERROR:$,Z_DEFAULT_COMPRESSION:tt,Z_FILTERED:et,Z_HUFFMAN_ONLY:at,Z_RLE:it,Z_FIXED:nt,Z_DEFAULT_STRATEGY:st,Z_UNKNOWN:rt,Z_DEFLATED:ot}=B,lt=(t,e)=>(t.msg=I[e],e),ht=t=>2*t-(t>4?9:0),dt=t=>{let e=t.length;for(;--e>=0;)t[e]=0},_t=t=>{let e,a,i,n=t.w_size;e=t.hash_size,i=e;do{a=t.head[--i],t.head[i]=a>=n?a-n:0}while(--e);e=n,i=e;do{a=t.prev[--i],t.prev[i]=a>=n?a-n:0}while(--e)};let ft=(t,e,a)=>(e<<t.hash_shift^a)&t.hash_mask;const ct=t=>{const e=t.state;let a=e.pending;a>t.avail_out&&(a=t.avail_out),0!==a&&(t.output.set(e.pending_buf.subarray(e.pending_out,e.pending_out+a),t.next_out),t.next_out+=a,e.pending_out+=a,t.total_out+=a,t.avail_out-=a,e.pending-=a,0===e.pending&&(e.pending_out=0))},ut=(t,e)=>{M(t,t.block_start>=0?t.block_start:-1,t.strstart-t.block_start,e),t.block_start=t.strstart,ct(t.strm)},wt=(t,e)=>{t.pending_buf[t.pending++]=e},mt=(t,e)=>{t.pending_buf[t.pending++]=e>>>8&255,t.pending_buf[t.pending++]=255&e},bt=(t,e,a,i)=>{let n=t.avail_in;return n>i&&(n=i),0===n?0:(t.avail_in-=n,e.set(t.input.subarray(t.next_in,t.next_in+n),a),1===t.state.wrap?t.adler=N(t.adler,e,n,a):2===t.state.wrap&&(t.adler=L(t.adler,e,n,a)),t.next_in+=n,t.total_in+=n,n)},gt=(t,e)=>{let a,i,n=t.max_chain_length,s=t.strstart,r=t.prev_length,o=t.nice_match;const l=t.strstart>t.w_size-262?t.strstart-(t.w_size-262):0,h=t.window,d=t.w_mask,_=t.prev,f=t.strstart+258;let c=h[s+r-1],u=h[s+r];t.prev_length>=t.good_match&&(n>>=2),o>t.lookahead&&(o=t.lookahead);do{if(a=e,h[a+r]===u&&h[a+r-1]===c&&h[a]===h[s]&&h[++a]===h[s+1]){s+=2,a++;do{}while(h[++s]===h[++a]&&h[++s]===h[++a]&&h[++s]===h[++a]&&h[++s]===h[++a]&&h[++s]===h[++a]&&h[++s]===h[++a]&&h[++s]===h[++a]&&h[++s]===h[++a]&&s<f);if(i=258-(f-s),s=f-258,i>r){if(t.match_start=e,r=i,i>=o)break;c=h[s+r-1],u=h[s+r]}}}while((e=_[e&d])>l&&0!=--n);return r<=t.lookahead?r:t.lookahead},pt=t=>{const e=t.w_size;let a,i,n;do{if(i=t.window_size-t.lookahead-t.strstart,t.strstart>=e+(e-262)&&(t.window.set(t.window.subarray(e,e+e-i),0),t.match_start-=e,t.strstart-=e,t.block_start-=e,t.insert>t.strstart&&(t.insert=t.strstart),_t(t),i+=e),0===t.strm.avail_in)break;if(a=bt(t.strm,t.window,t.strstart+t.lookahead,i),t.lookahead+=a,t.lookahead+t.insert>=3)for(n=t.strstart-t.insert,t.ins_h=t.window[n],t.ins_h=ft(t,t.ins_h,t.window[n+1]);t.insert&&(t.ins_h=ft(t,t.ins_h,t.window[n+3-1]),t.prev[n&t.w_mask]=t.head[t.ins_h],t.head[t.ins_h]=n,n++,t.insert--,!(t.lookahead+t.insert<3)););}while(t.lookahead<262&&0!==t.strm.avail_in)},kt=(t,e)=>{let a,i,n,s=t.pending_buf_size-5>t.w_size?t.w_size:t.pending_buf_size-5,r=0,o=t.strm.avail_in;do{if(a=65535,n=t.bi_valid+42>>3,t.strm.avail_out<n)break;if(n=t.strm.avail_out-n,i=t.strstart-t.block_start,a>i+t.strm.avail_in&&(a=i+t.strm.avail_in),a>n&&(a=n),a<s&&(0===a&&e!==X||e===P||a!==i+t.strm.avail_in))break;r=e===X&&a===i+t.strm.avail_in?1:0,H(t,0,0,r),t.pending_buf[t.pending-4]=a,t.pending_buf[t.pending-3]=a>>8,t.pending_buf[t.pending-2]=~a,t.pending_buf[t.pending-1]=~a>>8,ct(t.strm),i&&(i>a&&(i=a),t.strm.output.set(t.window.subarray(t.block_start,t.block_start+i),t.strm.next_out),t.strm.next_out+=i,t.strm.avail_out-=i,t.strm.total_out+=i,t.block_start+=i,a-=i),a&&(bt(t.strm,t.strm.output,t.strm.next_out,a),t.strm.next_out+=a,t.strm.avail_out-=a,t.strm.total_out+=a)}while(0===r);return o-=t.strm.avail_in,o&&(o>=t.w_size?(t.matches=2,t.window.set(t.strm.input.subarray(t.strm.next_in-t.w_size,t.strm.next_in),0),t.strstart=t.w_size,t.insert=t.strstart):(t.window_size-t.strstart<=o&&(t.strstart-=t.w_size,t.window.set(t.window.subarray(t.w_size,t.w_size+t.strstart),0),t.matches<2&&t.matches++,t.insert>t.strstart&&(t.insert=t.strstart)),t.window.set(t.strm.input.subarray(t.strm.next_in-o,t.strm.next_in),t.strstart),t.strstart+=o,t.insert+=o>t.w_size-t.insert?t.w_size-t.insert:o),t.block_start=t.strstart),t.high_water<t.strstart&&(t.high_water=t.strstart),r?4:e!==P&&e!==X&&0===t.strm.avail_in&&t.strstart===t.block_start?2:(n=t.window_size-t.strstart,t.strm.avail_in>n&&t.block_start>=t.w_size&&(t.block_start-=t.w_size,t.strstart-=t.w_size,t.window.set(t.window.subarray(t.w_size,t.w_size+t.strstart),0),t.matches<2&&t.matches++,n+=t.w_size,t.insert>t.strstart&&(t.insert=t.strstart)),n>t.strm.avail_in&&(n=t.strm.avail_in),n&&(bt(t.strm,t.window,t.strstart,n),t.strstart+=n,t.insert+=n>t.w_size-t.insert?t.w_size-t.insert:n),t.high_water<t.strstart&&(t.high_water=t.strstart),n=t.bi_valid+42>>3,n=t.pending_buf_size-n>65535?65535:t.pending_buf_size-n,s=n>t.w_size?t.w_size:n,i=t.strstart-t.block_start,(i>=s||(i||e===X)&&e!==P&&0===t.strm.avail_in&&i<=n)&&(a=i>n?n:i,r=e===X&&0===t.strm.avail_in&&a===i?1:0,H(t,t.block_start,a,r),t.block_start+=a,ct(t.strm)),r?3:1)},vt=(t,e)=>{let a,i;for(;;){if(t.lookahead<262){if(pt(t),t.lookahead<262&&e===P)return 1;if(0===t.lookahead)break}if(a=0,t.lookahead>=3&&(t.ins_h=ft(t,t.ins_h,t.window[t.strstart+3-1]),a=t.prev[t.strstart&t.w_mask]=t.head[t.ins_h],t.head[t.ins_h]=t.strstart),0!==a&&t.strstart-a<=t.w_size-262&&(t.match_length=gt(t,a)),t.match_length>=3)if(i=j(t,t.strstart-t.match_start,t.match_length-3),t.lookahead-=t.match_length,t.match_length<=t.max_lazy_match&&t.lookahead>=3){t.match_length--;do{t.strstart++,t.ins_h=ft(t,t.ins_h,t.window[t.strstart+3-1]),a=t.prev[t.strstart&t.w_mask]=t.head[t.ins_h],t.head[t.ins_h]=t.strstart}while(0!=--t.match_length);t.strstart++}else t.strstart+=t.match_length,t.match_length=0,t.ins_h=t.window[t.strstart],t.ins_h=ft(t,t.ins_h,t.window[t.strstart+1]);else i=j(t,0,t.window[t.strstart]),t.lookahead--,t.strstart++;if(i&&(ut(t,!1),0===t.strm.avail_out))return 1}return t.insert=t.strstart<2?t.strstart:2,e===X?(ut(t,!0),0===t.strm.avail_out?3:4):t.sym_next&&(ut(t,!1),0===t.strm.avail_out)?1:2},yt=(t,e)=>{let a,i,n;for(;;){if(t.lookahead<262){if(pt(t),t.lookahead<262&&e===P)return 1;if(0===t.lookahead)break}if(a=0,t.lookahead>=3&&(t.ins_h=ft(t,t.ins_h,t.window[t.strstart+3-1]),a=t.prev[t.strstart&t.w_mask]=t.head[t.ins_h],t.head[t.ins_h]=t.strstart),t.prev_length=t.match_length,t.prev_match=t.match_start,t.match_length=2,0!==a&&t.prev_length<t.max_lazy_match&&t.strstart-a<=t.w_size-262&&(t.match_length=gt(t,a),t.match_length<=5&&(t.strategy===et||3===t.match_length&&t.strstart-t.match_start>4096)&&(t.match_length=2)),t.prev_length>=3&&t.match_length<=t.prev_length){n=t.strstart+t.lookahead-3,i=j(t,t.strstart-1-t.prev_match,t.prev_length-3),t.lookahead-=t.prev_length-1,t.prev_length-=2;do{++t.strstart<=n&&(t.ins_h=ft(t,t.ins_h,t.window[t.strstart+3-1]),a=t.prev[t.strstart&t.w_mask]=t.head[t.ins_h],t.head[t.ins_h]=t.strstart)}while(0!=--t.prev_length);if(t.match_available=0,t.match_length=2,t.strstart++,i&&(ut(t,!1),0===t.strm.avail_out))return 1}else if(t.match_available){if(i=j(t,0,t.window[t.strstart-1]),i&&ut(t,!1),t.strstart++,t.lookahead--,0===t.strm.avail_out)return 1}else t.match_available=1,t.strstart++,t.lookahead--}return t.match_available&&(i=j(t,0,t.window[t.strstart-1]),t.match_available=0),t.insert=t.strstart<2?t.strstart:2,e===X?(ut(t,!0),0===t.strm.avail_out?3:4):t.sym_next&&(ut(t,!1),0===t.strm.avail_out)?1:2};function xt(t,e,a,i,n){this.good_length=t,this.max_lazy=e,this.nice_length=a,this.max_chain=i,this.func=n}const zt=[new xt(0,0,0,0,kt),new xt(4,4,8,4,vt),new xt(4,5,16,8,vt),new xt(4,6,32,32,vt),new xt(4,4,16,16,yt),new xt(8,16,32,32,yt),new xt(8,16,128,128,yt),new xt(8,32,128,256,yt),new xt(32,128,258,1024,yt),new xt(32,258,258,4096,yt)];function At(){this.strm=null,this.status=0,this.pending_buf=null,this.pending_buf_size=0,this.pending_out=0,this.pending=0,this.wrap=0,this.gzhead=null,this.gzindex=0,this.method=ot,this.last_flush=-1,this.w_size=0,this.w_bits=0,this.w_mask=0,this.window=null,this.window_size=0,this.prev=null,this.head=null,this.ins_h=0,this.hash_size=0,this.hash_bits=0,this.hash_mask=0,this.hash_shift=0,this.block_start=0,this.match_length=0,this.prev_match=0,this.match_available=0,this.strstart=0,this.match_start=0,this.lookahead=0,this.prev_length=0,this.max_chain_length=0,this.max_lazy_match=0,this.level=0,this.strategy=0,this.good_match=0,this.nice_match=0,this.dyn_ltree=new Uint16Array(1146),this.dyn_dtree=new Uint16Array(122),this.bl_tree=new Uint16Array(78),dt(this.dyn_ltree),dt(this.dyn_dtree),dt(this.bl_tree),this.l_desc=null,this.d_desc=null,this.bl_desc=null,this.bl_count=new Uint16Array(16),this.heap=new Uint16Array(573),dt(this.heap),this.heap_len=0,this.heap_max=0,this.depth=new Uint16Array(573),dt(this.depth),this.sym_buf=0,this.lit_bufsize=0,this.sym_next=0,this.sym_end=0,this.opt_len=0,this.static_len=0,this.matches=0,this.insert=0,this.bi_buf=0,this.bi_valid=0}const Et=t=>{if(!t)return 1;const e=t.state;return!e||e.strm!==t||42!==e.status&&57!==e.status&&69!==e.status&&73!==e.status&&91!==e.status&&103!==e.status&&113!==e.status&&666!==e.status?1:0},Rt=t=>{if(Et(t))return lt(t,Q);t.total_in=t.total_out=0,t.data_type=rt;const e=t.state;return e.pending=0,e.pending_out=0,e.wrap<0&&(e.wrap=-e.wrap),e.status=2===e.wrap?57:e.wrap?42:113,t.adler=2===e.wrap?0:1,e.last_flush=-2,C(e),W},Zt=t=>{const e=Rt(t);var a;return e===W&&((a=t.state).window_size=2*a.w_size,dt(a.head),a.max_lazy_match=zt[a.level].max_lazy,a.good_match=zt[a.level].good_length,a.nice_match=zt[a.level].nice_length,a.max_chain_length=zt[a.level].max_chain,a.strstart=0,a.block_start=0,a.lookahead=0,a.insert=0,a.match_length=a.prev_length=2,a.match_available=0,a.ins_h=0),e},St=(t,e,a,i,n,s)=>{if(!t)return Q;let r=1;if(e===tt&&(e=6),i<0?(r=0,i=-i):i>15&&(r=2,i-=16),n<1||n>9||a!==ot||i<8||i>15||e<0||e>9||s<0||s>nt||8===i&&1!==r)return lt(t,Q);8===i&&(i=9);const o=new At;return t.state=o,o.strm=t,o.status=42,o.wrap=r,o.gzhead=null,o.w_bits=i,o.w_size=1<<o.w_bits,o.w_mask=o.w_size-1,o.hash_bits=n+7,o.hash_size=1<<o.hash_bits,o.hash_mask=o.hash_size-1,o.hash_shift=~~((o.hash_bits+3-1)/3),o.window=new Uint8Array(2*o.w_size),o.head=new Uint16Array(o.hash_size),o.prev=new Uint16Array(o.w_size),o.lit_bufsize=1<<n+6,o.pending_buf_size=4*o.lit_bufsize,o.pending_buf=new Uint8Array(o.pending_buf_size),o.sym_buf=o.lit_bufsize,o.sym_end=3*(o.lit_bufsize-1),o.level=e,o.strategy=s,o.method=a,Zt(t)};var Ut={deflateInit:(t,e)=>St(t,e,ot,15,8,st),deflateInit2:St,deflateReset:Zt,deflateResetKeep:Rt,deflateSetHeader:(t,e)=>Et(t)||2!==t.state.wrap?Q:(t.state.gzhead=e,W),deflate:(t,e)=>{if(Et(t)||e>J||e<0)return t?lt(t,Q):Q;const a=t.state;if(!t.output||0!==t.avail_in&&!t.input||666===a.status&&e!==X)return lt(t,0===t.avail_out?$:Q);const i=a.last_flush;if(a.last_flush=e,0!==a.pending){if(ct(t),0===t.avail_out)return a.last_flush=-1,W}else if(0===t.avail_in&&ht(e)<=ht(i)&&e!==X)return lt(t,$);if(666===a.status&&0!==t.avail_in)return lt(t,$);if(42===a.status&&0===a.wrap&&(a.status=113),42===a.status){let e=ot+(a.w_bits-8<<4)<<8,i=-1;if(i=a.strategy>=at||a.level<2?0:a.level<6?1:6===a.level?2:3,e|=i<<6,0!==a.strstart&&(e|=32),e+=31-e%31,mt(a,e),0!==a.strstart&&(mt(a,t.adler>>>16),mt(a,65535&t.adler)),t.adler=1,a.status=113,ct(t),0!==a.pending)return a.last_flush=-1,W}if(57===a.status)if(t.adler=0,wt(a,31),wt(a,139),wt(a,8),a.gzhead)wt(a,(a.gzhead.text?1:0)+(a.gzhead.hcrc?2:0)+(a.gzhead.extra?4:0)+(a.gzhead.name?8:0)+(a.gzhead.comment?16:0)),wt(a,255&a.gzhead.time),wt(a,a.gzhead.time>>8&255),wt(a,a.gzhead.time>>16&255),wt(a,a.gzhead.time>>24&255),wt(a,9===a.level?2:a.strategy>=at||a.level<2?4:0),wt(a,255&a.gzhead.os),a.gzhead.extra&&a.gzhead.extra.length&&(wt(a,255&a.gzhead.extra.length),wt(a,a.gzhead.extra.length>>8&255)),a.gzhead.hcrc&&(t.adler=L(t.adler,a.pending_buf,a.pending,0)),a.gzindex=0,a.status=69;else if(wt(a,0),wt(a,0),wt(a,0),wt(a,0),wt(a,0),wt(a,9===a.level?2:a.strategy>=at||a.level<2?4:0),wt(a,3),a.status=113,ct(t),0!==a.pending)return a.last_flush=-1,W;if(69===a.status){if(a.gzhead.extra){let e=a.pending,i=(65535&a.gzhead.extra.length)-a.gzindex;for(;a.pending+i>a.pending_buf_size;){let n=a.pending_buf_size-a.pending;if(a.pending_buf.set(a.gzhead.extra.subarray(a.gzindex,a.gzindex+n),a.pending),a.pending=a.pending_buf_size,a.gzhead.hcrc&&a.pending>e&&(t.adler=L(t.adler,a.pending_buf,a.pending-e,e)),a.gzindex+=n,ct(t),0!==a.pending)return a.last_flush=-1,W;e=0,i-=n}let n=new Uint8Array(a.gzhead.extra);a.pending_buf.set(n.subarray(a.gzindex,a.gzindex+i),a.pending),a.pending+=i,a.gzhead.hcrc&&a.pending>e&&(t.adler=L(t.adler,a.pending_buf,a.pending-e,e)),a.gzindex=0}a.status=73}if(73===a.status){if(a.gzhead.name){let e,i=a.pending;do{if(a.pending===a.pending_buf_size){if(a.gzhead.hcrc&&a.pending>i&&(t.adler=L(t.adler,a.pending_buf,a.pending-i,i)),ct(t),0!==a.pending)return a.last_flush=-1,W;i=0}e=a.gzindex<a.gzhead.name.length?255&a.gzhead.name.charCodeAt(a.gzindex++):0,wt(a,e)}while(0!==e);a.gzhead.hcrc&&a.pending>i&&(t.adler=L(t.adler,a.pending_buf,a.pending-i,i)),a.gzindex=0}a.status=91}if(91===a.status){if(a.gzhead.comment){let e,i=a.pending;do{if(a.pending===a.pending_buf_size){if(a.gzhead.hcrc&&a.pending>i&&(t.adler=L(t.adler,a.pending_buf,a.pending-i,i)),ct(t),0!==a.pending)return a.last_flush=-1,W;i=0}e=a.gzindex<a.gzhead.comment.length?255&a.gzhead.comment.charCodeAt(a.gzindex++):0,wt(a,e)}while(0!==e);a.gzhead.hcrc&&a.pending>i&&(t.adler=L(t.adler,a.pending_buf,a.pending-i,i))}a.status=103}if(103===a.status){if(a.gzhead.hcrc){if(a.pending+2>a.pending_buf_size&&(ct(t),0!==a.pending))return a.last_flush=-1,W;wt(a,255&t.adler),wt(a,t.adler>>8&255),t.adler=0}if(a.status=113,ct(t),0!==a.pending)return a.last_flush=-1,W}if(0!==t.avail_in||0!==a.lookahead||e!==P&&666!==a.status){let i=0===a.level?kt(a,e):a.strategy===at?((t,e)=>{let a;for(;;){if(0===t.lookahead&&(pt(t),0===t.lookahead)){if(e===P)return 1;break}if(t.match_length=0,a=j(t,0,t.window[t.strstart]),t.lookahead--,t.strstart++,a&&(ut(t,!1),0===t.strm.avail_out))return 1}return t.insert=0,e===X?(ut(t,!0),0===t.strm.avail_out?3:4):t.sym_next&&(ut(t,!1),0===t.strm.avail_out)?1:2})(a,e):a.strategy===it?((t,e)=>{let a,i,n,s;const r=t.window;for(;;){if(t.lookahead<=258){if(pt(t),t.lookahead<=258&&e===P)return 1;if(0===t.lookahead)break}if(t.match_length=0,t.lookahead>=3&&t.strstart>0&&(n=t.strstart-1,i=r[n],i===r[++n]&&i===r[++n]&&i===r[++n])){s=t.strstart+258;do{}while(i===r[++n]&&i===r[++n]&&i===r[++n]&&i===r[++n]&&i===r[++n]&&i===r[++n]&&i===r[++n]&&i===r[++n]&&n<s);t.match_length=258-(s-n),t.match_length>t.lookahead&&(t.match_length=t.lookahead)}if(t.match_length>=3?(a=j(t,1,t.match_length-3),t.lookahead-=t.match_length,t.strstart+=t.match_length,t.match_length=0):(a=j(t,0,t.window[t.strstart]),t.lookahead--,t.strstart++),a&&(ut(t,!1),0===t.strm.avail_out))return 1}return t.insert=0,e===X?(ut(t,!0),0===t.strm.avail_out?3:4):t.sym_next&&(ut(t,!1),0===t.strm.avail_out)?1:2})(a,e):zt[a.level].func(a,e);if(3!==i&&4!==i||(a.status=666),1===i||3===i)return 0===t.avail_out&&(a.last_flush=-1),W;if(2===i&&(e===Y?K(a):e!==J&&(H(a,0,0,!1),e===G&&(dt(a.head),0===a.lookahead&&(a.strstart=0,a.block_start=0,a.insert=0))),ct(t),0===t.avail_out))return a.last_flush=-1,W}return e!==X?W:a.wrap<=0?q:(2===a.wrap?(wt(a,255&t.adler),wt(a,t.adler>>8&255),wt(a,t.adler>>16&255),wt(a,t.adler>>24&255),wt(a,255&t.total_in),wt(a,t.total_in>>8&255),wt(a,t.total_in>>16&255),wt(a,t.total_in>>24&255)):(mt(a,t.adler>>>16),mt(a,65535&t.adler)),ct(t),a.wrap>0&&(a.wrap=-a.wrap),0!==a.pending?W:q)},deflateEnd:t=>{if(Et(t))return Q;const e=t.state.status;return t.state=null,113===e?lt(t,V):W},deflateSetDictionary:(t,e)=>{let a=e.length;if(Et(t))return Q;const i=t.state,n=i.wrap;if(2===n||1===n&&42!==i.status||i.lookahead)return Q;if(1===n&&(t.adler=N(t.adler,e,a,0)),i.wrap=0,a>=i.w_size){0===n&&(dt(i.head),i.strstart=0,i.block_start=0,i.insert=0);let t=new Uint8Array(i.w_size);t.set(e.subarray(a-i.w_size,a),0),e=t,a=i.w_size}const s=t.avail_in,r=t.next_in,o=t.input;for(t.avail_in=a,t.next_in=0,t.input=e,pt(i);i.lookahead>=3;){let t=i.strstart,e=i.lookahead-2;do{i.ins_h=ft(i,i.ins_h,i.window[t+3-1]),i.prev[t&i.w_mask]=i.head[i.ins_h],i.head[i.ins_h]=t,t++}while(--e);i.strstart=t,i.lookahead=2,pt(i)}return i.strstart+=i.lookahead,i.block_start=i.strstart,i.insert=i.lookahead,i.lookahead=0,i.match_length=i.prev_length=2,i.match_available=0,t.next_in=r,t.input=o,t.avail_in=s,i.wrap=n,W},deflateInfo:"pako deflate (from Nodeca project)"};const Dt=(t,e)=>Object.prototype.hasOwnProperty.call(t,e);var Ot=function(t){const e=Array.prototype.slice.call(arguments,1);for(;e.length;){const a=e.shift();if(a){if("object"!=typeof a)throw new TypeError(a+"must be non-object");for(const e in a)Dt(a,e)&&(t[e]=a[e])}}return t},Tt=t=>{let e=0;for(let a=0,i=t.length;a<i;a++)e+=t[a].length;const a=new Uint8Array(e);for(let e=0,i=0,n=t.length;e<n;e++){let n=t[e];a.set(n,i),i+=n.length}return a};let Nt=!0;try{String.fromCharCode.apply(null,new Uint8Array(1))}catch(t){Nt=!1}const Ft=new Uint8Array(256);for(let t=0;t<256;t++)Ft[t]=t>=252?6:t>=248?5:t>=240?4:t>=224?3:t>=192?2:1;Ft[254]=Ft[254]=1;var Lt=t=>{if("function"==typeof TextEncoder&&TextEncoder.prototype.encode)return(new TextEncoder).encode(t);let e,a,i,n,s,r=t.length,o=0;for(n=0;n<r;n++)a=t.charCodeAt(n),55296==(64512&a)&&n+1<r&&(i=t.charCodeAt(n+1),56320==(64512&i)&&(a=65536+(a-55296<<10)+(i-56320),n++)),o+=a<128?1:a<2048?2:a<65536?3:4;for(e=new Uint8Array(o),s=0,n=0;s<o;n++)a=t.charCodeAt(n),55296==(64512&a)&&n+1<r&&(i=t.charCodeAt(n+1),56320==(64512&i)&&(a=65536+(a-55296<<10)+(i-56320),n++)),a<128?e[s++]=a:a<2048?(e[s++]=192|a>>>6,e[s++]=128|63&a):a<65536?(e[s++]=224|a>>>12,e[s++]=128|a>>>6&63,e[s++]=128|63&a):(e[s++]=240|a>>>18,e[s++]=128|a>>>12&63,e[s++]=128|a>>>6&63,e[s++]=128|63&a);return e},It=(t,e)=>{const a=e||t.length;if("function"==typeof TextDecoder&&TextDecoder.prototype.decode)return(new TextDecoder).decode(t.subarray(0,e));let i,n;const s=new Array(2*a);for(n=0,i=0;i<a;){let e=t[i++];if(e<128){s[n++]=e;continue}let r=Ft[e];if(r>4)s[n++]=65533,i+=r-1;else{for(e&=2===r?31:3===r?15:7;r>1&&i<a;)e=e<<6|63&t[i++],r--;r>1?s[n++]=65533:e<65536?s[n++]=e:(e-=65536,s[n++]=55296|e>>10&1023,s[n++]=56320|1023&e)}}return((t,e)=>{if(e<65534&&t.subarray&&Nt)return String.fromCharCode.apply(null,t.length===e?t:t.subarray(0,e));let a="";for(let i=0;i<e;i++)a+=String.fromCharCode(t[i]);return a})(s,n)},Bt=(t,e)=>{(e=e||t.length)>t.length&&(e=t.length);let a=e-1;for(;a>=0&&128==(192&t[a]);)a--;return a<0||0===a?e:a+Ft[t[a]]>e?a:e};var Ct=function(){this.input=null,this.next_in=0,this.avail_in=0,this.total_in=0,this.output=null,this.next_out=0,this.avail_out=0,this.total_out=0,this.msg="",this.state=null,this.data_type=2,this.adler=0};const Ht=Object.prototype.toString,{Z_NO_FLUSH:Mt,Z_SYNC_FLUSH:jt,Z_FULL_FLUSH:Kt,Z_FINISH:Pt,Z_OK:Yt,Z_STREAM_END:Gt,Z_DEFAULT_COMPRESSION:Xt,Z_DEFAULT_STRATEGY:Jt,Z_DEFLATED:Wt}=B;function qt(t){this.options=Ot({level:Xt,method:Wt,chunkSize:16384,windowBits:15,memLevel:8,strategy:Jt},t||{});let e=this.options;e.raw&&e.windowBits>0?e.windowBits=-e.windowBits:e.gzip&&e.windowBits>0&&e.windowBits<16&&(e.windowBits+=16),this.err=0,this.msg="",this.ended=!1,this.chunks=[],this.strm=new Ct,this.strm.avail_out=0;let a=Ut.deflateInit2(this.strm,e.level,e.method,e.windowBits,e.memLevel,e.strategy);if(a!==Yt)throw new Error(I[a]);if(e.header&&Ut.deflateSetHeader(this.strm,e.header),e.dictionary){let t;if(t="string"==typeof e.dictionary?Lt(e.dictionary):"[object ArrayBuffer]"===Ht.call(e.dictionary)?new Uint8Array(e.dictionary):e.dictionary,a=Ut.deflateSetDictionary(this.strm,t),a!==Yt)throw new Error(I[a]);this._dict_set=!0}}function Qt(t,e){const a=new qt(e);if(a.push(t,!0),a.err)throw a.msg||I[a.err];return a.result}qt.prototype.push=function(t,e){const a=this.strm,i=this.options.chunkSize;let n,s;if(this.ended)return!1;for(s=e===~~e?e:!0===e?Pt:Mt,"string"==typeof t?a.input=Lt(t):"[object ArrayBuffer]"===Ht.call(t)?a.input=new Uint8Array(t):a.input=t,a.next_in=0,a.avail_in=a.input.length;;)if(0===a.avail_out&&(a.output=new Uint8Array(i),a.next_out=0,a.avail_out=i),(s===jt||s===Kt)&&a.avail_out<=6)this.onData(a.output.subarray(0,a.next_out)),a.avail_out=0;else{if(n=Ut.deflate(a,s),n===Gt)return a.next_out>0&&this.onData(a.output.subarray(0,a.next_out)),n=Ut.deflateEnd(this.strm),this.onEnd(n),this.ended=!0,n===Yt;if(0!==a.avail_out){if(s>0&&a.next_out>0)this.onData(a.output.subarray(0,a.next_out)),a.avail_out=0;else if(0===a.avail_in)break}else this.onData(a.output)}return!0},qt.prototype.onData=function(t){this.chunks.push(t)},qt.prototype.onEnd=function(t){t===Yt&&(this.result=Tt(this.chunks)),this.chunks=[],this.err=t,this.msg=this.strm.msg};var Vt={Deflate:qt,deflate:Qt,deflateRaw:function(t,e){return(e=e||{}).raw=!0,Qt(t,e)},gzip:function(t,e){return(e=e||{}).gzip=!0,Qt(t,e)},constants:B};var $t=function(t,e){let a,i,n,s,r,o,l,h,d,_,f,c,u,w,m,b,g,p,k,v,y,x,z,A;const E=t.state;a=t.next_in,z=t.input,i=a+(t.avail_in-5),n=t.next_out,A=t.output,s=n-(e-t.avail_out),r=n+(t.avail_out-257),o=E.dmax,l=E.wsize,h=E.whave,d=E.wnext,_=E.window,f=E.hold,c=E.bits,u=E.lencode,w=E.distcode,m=(1<<E.lenbits)-1,b=(1<<E.distbits)-1;t:do{c<15&&(f+=z[a++]<<c,c+=8,f+=z[a++]<<c,c+=8),g=u[f&m];e:for(;;){if(p=g>>>24,f>>>=p,c-=p,p=g>>>16&255,0===p)A[n++]=65535&g;else{if(!(16&p)){if(0==(64&p)){g=u[(65535&g)+(f&(1<<p)-1)];continue e}if(32&p){E.mode=16191;break t}t.msg="invalid literal/length code",E.mode=16209;break t}k=65535&g,p&=15,p&&(c<p&&(f+=z[a++]<<c,c+=8),k+=f&(1<<p)-1,f>>>=p,c-=p),c<15&&(f+=z[a++]<<c,c+=8,f+=z[a++]<<c,c+=8),g=w[f&b];a:for(;;){if(p=g>>>24,f>>>=p,c-=p,p=g>>>16&255,!(16&p)){if(0==(64&p)){g=w[(65535&g)+(f&(1<<p)-1)];continue a}t.msg="invalid distance code",E.mode=16209;break t}if(v=65535&g,p&=15,c<p&&(f+=z[a++]<<c,c+=8,c<p&&(f+=z[a++]<<c,c+=8)),v+=f&(1<<p)-1,v>o){t.msg="invalid distance too far back",E.mode=16209;break t}if(f>>>=p,c-=p,p=n-s,v>p){if(p=v-p,p>h&&E.sane){t.msg="invalid distance too far back",E.mode=16209;break t}if(y=0,x=_,0===d){if(y+=l-p,p<k){k-=p;do{A[n++]=_[y++]}while(--p);y=n-v,x=A}}else if(d<p){if(y+=l+d-p,p-=d,p<k){k-=p;do{A[n++]=_[y++]}while(--p);if(y=0,d<k){p=d,k-=p;do{A[n++]=_[y++]}while(--p);y=n-v,x=A}}}else if(y+=d-p,p<k){k-=p;do{A[n++]=_[y++]}while(--p);y=n-v,x=A}for(;k>2;)A[n++]=x[y++],A[n++]=x[y++],A[n++]=x[y++],k-=3;k&&(A[n++]=x[y++],k>1&&(A[n++]=x[y++]))}else{y=n-v;do{A[n++]=A[y++],A[n++]=A[y++],A[n++]=A[y++],k-=3}while(k>2);k&&(A[n++]=A[y++],k>1&&(A[n++]=A[y++]))}break}}break}}while(a<i&&n<r);k=c>>3,a-=k,c-=k<<3,f&=(1<<c)-1,t.next_in=a,t.next_out=n,t.avail_in=a<i?i-a+5:5-(a-i),t.avail_out=n<r?r-n+257:257-(n-r),E.hold=f,E.bits=c};const te=new Uint16Array([3,4,5,6,7,8,9,10,11,13,15,17,19,23,27,31,35,43,51,59,67,83,99,115,131,163,195,227,258,0,0]),ee=new Uint8Array([16,16,16,16,16,16,16,16,17,17,17,17,18,18,18,18,19,19,19,19,20,20,20,20,21,21,21,21,16,72,78]),ae=new Uint16Array([1,2,3,4,5,7,9,13,17,25,33,49,65,97,129,193,257,385,513,769,1025,1537,2049,3073,4097,6145,8193,12289,16385,24577,0,0]),ie=new Uint8Array([16,16,16,16,17,17,18,18,19,19,20,20,21,21,22,22,23,23,24,24,25,25,26,26,27,27,28,28,29,29,64,64]);var ne=(t,e,a,i,n,s,r,o)=>{const l=o.bits;let h,d,_,f,c,u,w=0,m=0,b=0,g=0,p=0,k=0,v=0,y=0,x=0,z=0,A=null;const E=new Uint16Array(16),R=new Uint16Array(16);let Z,S,U,D=null;for(w=0;w<=15;w++)E[w]=0;for(m=0;m<i;m++)E[e[a+m]]++;for(p=l,g=15;g>=1&&0===E[g];g--);if(p>g&&(p=g),0===g)return n[s++]=20971520,n[s++]=20971520,o.bits=1,0;for(b=1;b<g&&0===E[b];b++);for(p<b&&(p=b),y=1,w=1;w<=15;w++)if(y<<=1,y-=E[w],y<0)return-1;if(y>0&&(0===t||1!==g))return-1;for(R[1]=0,w=1;w<15;w++)R[w+1]=R[w]+E[w];for(m=0;m<i;m++)0!==e[a+m]&&(r[R[e[a+m]]++]=m);if(0===t?(A=D=r,u=20):1===t?(A=te,D=ee,u=257):(A=ae,D=ie,u=0),z=0,m=0,w=b,c=s,k=p,v=0,_=-1,x=1<<p,f=x-1,1===t&&x>852||2===t&&x>592)return 1;for(;;){Z=w-v,r[m]+1<u?(S=0,U=r[m]):r[m]>=u?(S=D[r[m]-u],U=A[r[m]-u]):(S=96,U=0),h=1<<w-v,d=1<<k,b=d;do{d-=h,n[c+(z>>v)+d]=Z<<24|S<<16|U|0}while(0!==d);for(h=1<<w-1;z&h;)h>>=1;if(0!==h?(z&=h-1,z+=h):z=0,m++,0==--E[w]){if(w===g)break;w=e[a+r[m]]}if(w>p&&(z&f)!==_){for(0===v&&(v=p),c+=b,k=w-v,y=1<<k;k+v<g&&(y-=E[k+v],!(y<=0));)k++,y<<=1;if(x+=1<<k,1===t&&x>852||2===t&&x>592)return 1;_=z&f,n[_]=p<<24|k<<16|c-s|0}}return 0!==z&&(n[c+z]=w-v<<24|64<<16|0),o.bits=p,0};const{Z_FINISH:se,Z_BLOCK:re,Z_TREES:oe,Z_OK:le,Z_STREAM_END:he,Z_NEED_DICT:de,Z_STREAM_ERROR:_e,Z_DATA_ERROR:fe,Z_MEM_ERROR:ce,Z_BUF_ERROR:ue,Z_DEFLATED:we}=B,me=16209,be=t=>(t>>>24&255)+(t>>>8&65280)+((65280&t)<<8)+((255&t)<<24);function ge(){this.strm=null,this.mode=0,this.last=!1,this.wrap=0,this.havedict=!1,this.flags=0,this.dmax=0,this.check=0,this.total=0,this.head=null,this.wbits=0,this.wsize=0,this.whave=0,this.wnext=0,this.window=null,this.hold=0,this.bits=0,this.length=0,this.offset=0,this.extra=0,this.lencode=null,this.distcode=null,this.lenbits=0,this.distbits=0,this.ncode=0,this.nlen=0,this.ndist=0,this.have=0,this.next=null,this.lens=new Uint16Array(320),this.work=new Uint16Array(288),this.lendyn=null,this.distdyn=null,this.sane=0,this.back=0,this.was=0}const pe=t=>{if(!t)return 1;const e=t.state;return!e||e.strm!==t||e.mode<16180||e.mode>16211?1:0},ke=t=>{if(pe(t))return _e;const e=t.state;return t.total_in=t.total_out=e.total=0,t.msg="",e.wrap&&(t.adler=1&e.wrap),e.mode=16180,e.last=0,e.havedict=0,e.flags=-1,e.dmax=32768,e.head=null,e.hold=0,e.bits=0,e.lencode=e.lendyn=new Int32Array(852),e.distcode=e.distdyn=new Int32Array(592),e.sane=1,e.back=-1,le},ve=t=>{if(pe(t))return _e;const e=t.state;return e.wsize=0,e.whave=0,e.wnext=0,ke(t)},ye=(t,e)=>{let a;if(pe(t))return _e;const i=t.state;return e<0?(a=0,e=-e):(a=5+(e>>4),e<48&&(e&=15)),e&&(e<8||e>15)?_e:(null!==i.window&&i.wbits!==e&&(i.window=null),i.wrap=a,i.wbits=e,ve(t))},xe=(t,e)=>{if(!t)return _e;const a=new ge;t.state=a,a.strm=t,a.window=null,a.mode=16180;const i=ye(t,e);return i!==le&&(t.state=null),i};let ze,Ae,Ee=!0;const Re=t=>{if(Ee){ze=new Int32Array(512),Ae=new Int32Array(32);let e=0;for(;e<144;)t.lens[e++]=8;for(;e<256;)t.lens[e++]=9;for(;e<280;)t.lens[e++]=7;for(;e<288;)t.lens[e++]=8;for(ne(1,t.lens,0,288,ze,0,t.work,{bits:9}),e=0;e<32;)t.lens[e++]=5;ne(2,t.lens,0,32,Ae,0,t.work,{bits:5}),Ee=!1}t.lencode=ze,t.lenbits=9,t.distcode=Ae,t.distbits=5},Ze=(t,e,a,i)=>{let n;const s=t.state;return null===s.window&&(s.wsize=1<<s.wbits,s.wnext=0,s.whave=0,s.window=new Uint8Array(s.wsize)),i>=s.wsize?(s.window.set(e.subarray(a-s.wsize,a),0),s.wnext=0,s.whave=s.wsize):(n=s.wsize-s.wnext,n>i&&(n=i),s.window.set(e.subarray(a-i,a-i+n),s.wnext),(i-=n)?(s.window.set(e.subarray(a-i,a),0),s.wnext=i,s.whave=s.wsize):(s.wnext+=n,s.wnext===s.wsize&&(s.wnext=0),s.whave<s.wsize&&(s.whave+=n))),0};var Se={inflateReset:ve,inflateReset2:ye,inflateResetKeep:ke,inflateInit:t=>xe(t,15),inflateInit2:xe,inflate:(t,e)=>{let a,i,n,s,r,o,l,h,d,_,f,c,u,w,m,b,g,p,k,v,y,x,z=0;const A=new Uint8Array(4);let E,R;const Z=new Uint8Array([16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15]);if(pe(t)||!t.output||!t.input&&0!==t.avail_in)return _e;a=t.state,16191===a.mode&&(a.mode=16192),r=t.next_out,n=t.output,l=t.avail_out,s=t.next_in,i=t.input,o=t.avail_in,h=a.hold,d=a.bits,_=o,f=l,x=le;t:for(;;)switch(a.mode){case 16180:if(0===a.wrap){a.mode=16192;break}for(;d<16;){if(0===o)break t;o--,h+=i[s++]<<d,d+=8}if(2&a.wrap&&35615===h){0===a.wbits&&(a.wbits=15),a.check=0,A[0]=255&h,A[1]=h>>>8&255,a.check=L(a.check,A,2,0),h=0,d=0,a.mode=16181;break}if(a.head&&(a.head.done=!1),!(1&a.wrap)||(((255&h)<<8)+(h>>8))%31){t.msg="incorrect header check",a.mode=me;break}if((15&h)!==we){t.msg="unknown compression method",a.mode=me;break}if(h>>>=4,d-=4,y=8+(15&h),0===a.wbits&&(a.wbits=y),y>15||y>a.wbits){t.msg="invalid window size",a.mode=me;break}a.dmax=1<<a.wbits,a.flags=0,t.adler=a.check=1,a.mode=512&h?16189:16191,h=0,d=0;break;case 16181:for(;d<16;){if(0===o)break t;o--,h+=i[s++]<<d,d+=8}if(a.flags=h,(255&a.flags)!==we){t.msg="unknown compression method",a.mode=me;break}if(57344&a.flags){t.msg="unknown header flags set",a.mode=me;break}a.head&&(a.head.text=h>>8&1),512&a.flags&&4&a.wrap&&(A[0]=255&h,A[1]=h>>>8&255,a.check=L(a.check,A,2,0)),h=0,d=0,a.mode=16182;case 16182:for(;d<32;){if(0===o)break t;o--,h+=i[s++]<<d,d+=8}a.head&&(a.head.time=h),512&a.flags&&4&a.wrap&&(A[0]=255&h,A[1]=h>>>8&255,A[2]=h>>>16&255,A[3]=h>>>24&255,a.check=L(a.check,A,4,0)),h=0,d=0,a.mode=16183;case 16183:for(;d<16;){if(0===o)break t;o--,h+=i[s++]<<d,d+=8}a.head&&(a.head.xflags=255&h,a.head.os=h>>8),512&a.flags&&4&a.wrap&&(A[0]=255&h,A[1]=h>>>8&255,a.check=L(a.check,A,2,0)),h=0,d=0,a.mode=16184;case 16184:if(1024&a.flags){for(;d<16;){if(0===o)break t;o--,h+=i[s++]<<d,d+=8}a.length=h,a.head&&(a.head.extra_len=h),512&a.flags&&4&a.wrap&&(A[0]=255&h,A[1]=h>>>8&255,a.check=L(a.check,A,2,0)),h=0,d=0}else a.head&&(a.head.extra=null);a.mode=16185;case 16185:if(1024&a.flags&&(c=a.length,c>o&&(c=o),c&&(a.head&&(y=a.head.extra_len-a.length,a.head.extra||(a.head.extra=new Uint8Array(a.head.extra_len)),a.head.extra.set(i.subarray(s,s+c),y)),512&a.flags&&4&a.wrap&&(a.check=L(a.check,i,c,s)),o-=c,s+=c,a.length-=c),a.length))break t;a.length=0,a.mode=16186;case 16186:if(2048&a.flags){if(0===o)break t;c=0;do{y=i[s+c++],a.head&&y&&a.length<65536&&(a.head.name+=String.fromCharCode(y))}while(y&&c<o);if(512&a.flags&&4&a.wrap&&(a.check=L(a.check,i,c,s)),o-=c,s+=c,y)break t}else a.head&&(a.head.name=null);a.length=0,a.mode=16187;case 16187:if(4096&a.flags){if(0===o)break t;c=0;do{y=i[s+c++],a.head&&y&&a.length<65536&&(a.head.comment+=String.fromCharCode(y))}while(y&&c<o);if(512&a.flags&&4&a.wrap&&(a.check=L(a.check,i,c,s)),o-=c,s+=c,y)break t}else a.head&&(a.head.comment=null);a.mode=16188;case 16188:if(512&a.flags){for(;d<16;){if(0===o)break t;o--,h+=i[s++]<<d,d+=8}if(4&a.wrap&&h!==(65535&a.check)){t.msg="header crc mismatch",a.mode=me;break}h=0,d=0}a.head&&(a.head.hcrc=a.flags>>9&1,a.head.done=!0),t.adler=a.check=0,a.mode=16191;break;case 16189:for(;d<32;){if(0===o)break t;o--,h+=i[s++]<<d,d+=8}t.adler=a.check=be(h),h=0,d=0,a.mode=16190;case 16190:if(0===a.havedict)return t.next_out=r,t.avail_out=l,t.next_in=s,t.avail_in=o,a.hold=h,a.bits=d,de;t.adler=a.check=1,a.mode=16191;case 16191:if(e===re||e===oe)break t;case 16192:if(a.last){h>>>=7&d,d-=7&d,a.mode=16206;break}for(;d<3;){if(0===o)break t;o--,h+=i[s++]<<d,d+=8}switch(a.last=1&h,h>>>=1,d-=1,3&h){case 0:a.mode=16193;break;case 1:if(Re(a),a.mode=16199,e===oe){h>>>=2,d-=2;break t}break;case 2:a.mode=16196;break;case 3:t.msg="invalid block type",a.mode=me}h>>>=2,d-=2;break;case 16193:for(h>>>=7&d,d-=7&d;d<32;){if(0===o)break t;o--,h+=i[s++]<<d,d+=8}if((65535&h)!=(h>>>16^65535)){t.msg="invalid stored block lengths",a.mode=me;break}if(a.length=65535&h,h=0,d=0,a.mode=16194,e===oe)break t;case 16194:a.mode=16195;case 16195:if(c=a.length,c){if(c>o&&(c=o),c>l&&(c=l),0===c)break t;n.set(i.subarray(s,s+c),r),o-=c,s+=c,l-=c,r+=c,a.length-=c;break}a.mode=16191;break;case 16196:for(;d<14;){if(0===o)break t;o--,h+=i[s++]<<d,d+=8}if(a.nlen=257+(31&h),h>>>=5,d-=5,a.ndist=1+(31&h),h>>>=5,d-=5,a.ncode=4+(15&h),h>>>=4,d-=4,a.nlen>286||a.ndist>30){t.msg="too many length or distance symbols",a.mode=me;break}a.have=0,a.mode=16197;case 16197:for(;a.have<a.ncode;){for(;d<3;){if(0===o)break t;o--,h+=i[s++]<<d,d+=8}a.lens[Z[a.have++]]=7&h,h>>>=3,d-=3}for(;a.have<19;)a.lens[Z[a.have++]]=0;if(a.lencode=a.lendyn,a.lenbits=7,E={bits:a.lenbits},x=ne(0,a.lens,0,19,a.lencode,0,a.work,E),a.lenbits=E.bits,x){t.msg="invalid code lengths set",a.mode=me;break}a.have=0,a.mode=16198;case 16198:for(;a.have<a.nlen+a.ndist;){for(;z=a.lencode[h&(1<<a.lenbits)-1],m=z>>>24,b=z>>>16&255,g=65535&z,!(m<=d);){if(0===o)break t;o--,h+=i[s++]<<d,d+=8}if(g<16)h>>>=m,d-=m,a.lens[a.have++]=g;else{if(16===g){for(R=m+2;d<R;){if(0===o)break t;o--,h+=i[s++]<<d,d+=8}if(h>>>=m,d-=m,0===a.have){t.msg="invalid bit length repeat",a.mode=me;break}y=a.lens[a.have-1],c=3+(3&h),h>>>=2,d-=2}else if(17===g){for(R=m+3;d<R;){if(0===o)break t;o--,h+=i[s++]<<d,d+=8}h>>>=m,d-=m,y=0,c=3+(7&h),h>>>=3,d-=3}else{for(R=m+7;d<R;){if(0===o)break t;o--,h+=i[s++]<<d,d+=8}h>>>=m,d-=m,y=0,c=11+(127&h),h>>>=7,d-=7}if(a.have+c>a.nlen+a.ndist){t.msg="invalid bit length repeat",a.mode=me;break}for(;c--;)a.lens[a.have++]=y}}if(a.mode===me)break;if(0===a.lens[256]){t.msg="invalid code -- missing end-of-block",a.mode=me;break}if(a.lenbits=9,E={bits:a.lenbits},x=ne(1,a.lens,0,a.nlen,a.lencode,0,a.work,E),a.lenbits=E.bits,x){t.msg="invalid literal/lengths set",a.mode=me;break}if(a.distbits=6,a.distcode=a.distdyn,E={bits:a.distbits},x=ne(2,a.lens,a.nlen,a.ndist,a.distcode,0,a.work,E),a.distbits=E.bits,x){t.msg="invalid distances set",a.mode=me;break}if(a.mode=16199,e===oe)break t;case 16199:a.mode=16200;case 16200:if(o>=6&&l>=258){t.next_out=r,t.avail_out=l,t.next_in=s,t.avail_in=o,a.hold=h,a.bits=d,$t(t,f),r=t.next_out,n=t.output,l=t.avail_out,s=t.next_in,i=t.input,o=t.avail_in,h=a.hold,d=a.bits,16191===a.mode&&(a.back=-1);break}for(a.back=0;z=a.lencode[h&(1<<a.lenbits)-1],m=z>>>24,b=z>>>16&255,g=65535&z,!(m<=d);){if(0===o)break t;o--,h+=i[s++]<<d,d+=8}if(b&&0==(240&b)){for(p=m,k=b,v=g;z=a.lencode[v+((h&(1<<p+k)-1)>>p)],m=z>>>24,b=z>>>16&255,g=65535&z,!(p+m<=d);){if(0===o)break t;o--,h+=i[s++]<<d,d+=8}h>>>=p,d-=p,a.back+=p}if(h>>>=m,d-=m,a.back+=m,a.length=g,0===b){a.mode=16205;break}if(32&b){a.back=-1,a.mode=16191;break}if(64&b){t.msg="invalid literal/length code",a.mode=me;break}a.extra=15&b,a.mode=16201;case 16201:if(a.extra){for(R=a.extra;d<R;){if(0===o)break t;o--,h+=i[s++]<<d,d+=8}a.length+=h&(1<<a.extra)-1,h>>>=a.extra,d-=a.extra,a.back+=a.extra}a.was=a.length,a.mode=16202;case 16202:for(;z=a.distcode[h&(1<<a.distbits)-1],m=z>>>24,b=z>>>16&255,g=65535&z,!(m<=d);){if(0===o)break t;o--,h+=i[s++]<<d,d+=8}if(0==(240&b)){for(p=m,k=b,v=g;z=a.distcode[v+((h&(1<<p+k)-1)>>p)],m=z>>>24,b=z>>>16&255,g=65535&z,!(p+m<=d);){if(0===o)break t;o--,h+=i[s++]<<d,d+=8}h>>>=p,d-=p,a.back+=p}if(h>>>=m,d-=m,a.back+=m,64&b){t.msg="invalid distance code",a.mode=me;break}a.offset=g,a.extra=15&b,a.mode=16203;case 16203:if(a.extra){for(R=a.extra;d<R;){if(0===o)break t;o--,h+=i[s++]<<d,d+=8}a.offset+=h&(1<<a.extra)-1,h>>>=a.extra,d-=a.extra,a.back+=a.extra}if(a.offset>a.dmax){t.msg="invalid distance too far back",a.mode=me;break}a.mode=16204;case 16204:if(0===l)break t;if(c=f-l,a.offset>c){if(c=a.offset-c,c>a.whave&&a.sane){t.msg="invalid distance too far back",a.mode=me;break}c>a.wnext?(c-=a.wnext,u=a.wsize-c):u=a.wnext-c,c>a.length&&(c=a.length),w=a.window}else w=n,u=r-a.offset,c=a.length;c>l&&(c=l),l-=c,a.length-=c;do{n[r++]=w[u++]}while(--c);0===a.length&&(a.mode=16200);break;case 16205:if(0===l)break t;n[r++]=a.length,l--,a.mode=16200;break;case 16206:if(a.wrap){for(;d<32;){if(0===o)break t;o--,h|=i[s++]<<d,d+=8}if(f-=l,t.total_out+=f,a.total+=f,4&a.wrap&&f&&(t.adler=a.check=a.flags?L(a.check,n,f,r-f):N(a.check,n,f,r-f)),f=l,4&a.wrap&&(a.flags?h:be(h))!==a.check){t.msg="incorrect data check",a.mode=me;break}h=0,d=0}a.mode=16207;case 16207:if(a.wrap&&a.flags){for(;d<32;){if(0===o)break t;o--,h+=i[s++]<<d,d+=8}if(4&a.wrap&&h!==(4294967295&a.total)){t.msg="incorrect length check",a.mode=me;break}h=0,d=0}a.mode=16208;case 16208:x=he;break t;case me:x=fe;break t;case 16210:return ce;default:return _e}return t.next_out=r,t.avail_out=l,t.next_in=s,t.avail_in=o,a.hold=h,a.bits=d,(a.wsize||f!==t.avail_out&&a.mode<me&&(a.mode<16206||e!==se))&&Ze(t,t.output,t.next_out,f-t.avail_out),_-=t.avail_in,f-=t.avail_out,t.total_in+=_,t.total_out+=f,a.total+=f,4&a.wrap&&f&&(t.adler=a.check=a.flags?L(a.check,n,f,t.next_out-f):N(a.check,n,f,t.next_out-f)),t.data_type=a.bits+(a.last?64:0)+(16191===a.mode?128:0)+(16199===a.mode||16194===a.mode?256:0),(0===_&&0===f||e===se)&&x===le&&(x=ue),x},inflateEnd:t=>{if(pe(t))return _e;let e=t.state;return e.window&&(e.window=null),t.state=null,le},inflateGetHeader:(t,e)=>{if(pe(t))return _e;const a=t.state;return 0==(2&a.wrap)?_e:(a.head=e,e.done=!1,le)},inflateSetDictionary:(t,e)=>{const a=e.length;let i,n,s;return pe(t)?_e:(i=t.state,0!==i.wrap&&16190!==i.mode?_e:16190===i.mode&&(n=1,n=N(n,e,a,0),n!==i.check)?fe:(s=Ze(t,e,a,a),s?(i.mode=16210,ce):(i.havedict=1,le)))},inflateInfo:"pako inflate (from Nodeca project)"};var Ue=function(){this.text=0,this.time=0,this.xflags=0,this.os=0,this.extra=null,this.extra_len=0,this.name="",this.comment="",this.hcrc=0,this.done=!1};const De=Object.prototype.toString,{Z_NO_FLUSH:Oe,Z_FINISH:Te,Z_OK:Ne,Z_STREAM_END:Fe,Z_NEED_DICT:Le,Z_STREAM_ERROR:Ie,Z_DATA_ERROR:Be,Z_MEM_ERROR:Ce}=B;function He(t){this.options=Ot({chunkSize:65536,windowBits:15,to:""},t||{});const e=this.options;e.raw&&e.windowBits>=0&&e.windowBits<16&&(e.windowBits=-e.windowBits,0===e.windowBits&&(e.windowBits=-15)),!(e.windowBits>=0&&e.windowBits<16)||t&&t.windowBits||(e.windowBits+=32),e.windowBits>15&&e.windowBits<48&&0==(15&e.windowBits)&&(e.windowBits|=15),this.err=0,this.msg="",this.ended=!1,this.chunks=[],this.strm=new Ct,this.strm.avail_out=0;let a=Se.inflateInit2(this.strm,e.windowBits);if(a!==Ne)throw new Error(I[a]);if(this.header=new Ue,Se.inflateGetHeader(this.strm,this.header),e.dictionary&&("string"==typeof e.dictionary?e.dictionary=Lt(e.dictionary):"[object ArrayBuffer]"===De.call(e.dictionary)&&(e.dictionary=new Uint8Array(e.dictionary)),e.raw&&(a=Se.inflateSetDictionary(this.strm,e.dictionary),a!==Ne)))throw new Error(I[a])}He.prototype.push=function(t,e){const a=this.strm,i=this.options.chunkSize,n=this.options.dictionary;let s,r,o;if(this.ended)return!1;for(r=e===~~e?e:!0===e?Te:Oe,"[object ArrayBuffer]"===De.call(t)?a.input=new Uint8Array(t):a.input=t,a.next_in=0,a.avail_in=a.input.length;;){for(0===a.avail_out&&(a.output=new Uint8Array(i),a.next_out=0,a.avail_out=i),s=Se.inflate(a,r),s===Le&&n&&(s=Se.inflateSetDictionary(a,n),s===Ne?s=Se.inflate(a,r):s===Be&&(s=Le));a.avail_in>0&&s===Fe&&a.state.wrap>0&&0!==t[a.next_in];)Se.inflateReset(a),s=Se.inflate(a,r);switch(s){case Ie:case Be:case Le:case Ce:return this.onEnd(s),this.ended=!0,!1}if(o=a.avail_out,a.next_out&&(0===a.avail_out||s===Fe))if("string"===this.options.to){let t=Bt(a.output,a.next_out),e=a.next_out-t,n=It(a.output,t);a.next_out=e,a.avail_out=i-e,e&&a.output.set(a.output.subarray(t,t+e),0),this.onData(n)}else this.onData(a.output.length===a.next_out?a.output:a.output.subarray(0,a.next_out));if(s!==Ne||0!==o){if(s===Fe)return s=Se.inflateEnd(this.strm),this.onEnd(s),this.ended=!0,!0;if(0===a.avail_in)break}}return!0},He.prototype.onData=function(t){this.chunks.push(t)},He.prototype.onEnd=function(t){t===Ne&&("string"===this.options.to?this.result=this.chunks.join(""):this.result=Tt(this.chunks)),this.chunks=[],this.err=t,this.msg=this.strm.msg};const{Deflate:Me,deflate:je,deflateRaw:Ke,gzip:Pe}=Vt;var Ye=Me,Ge=B;const Xe=new class{constructor(){this.added=0,this.init()}init(){this.added=0,this.deflate=new Ye,this.deflate.push("[",Ge.Z_NO_FLUSH)}addEvent(t){if(!t)throw new Error("Adding invalid event");const e=this.added>0?",":"";this.deflate.push(e+JSON.stringify(t),Ge.Z_SYNC_FLUSH),this.added++}finish(){if(this.deflate.push("]",Ge.Z_FINISH),this.deflate.err)throw this.deflate.err;const t=this.deflate.result;return this.init(),t}},Je={init:()=>(Xe.init(),""),addEvent:t=>Xe.addEvent(t),finish:()=>Xe.finish()};addEventListener("message",(function(t){const e=t.data.method,a=t.data.id,[i]=t.data.args?JSON.parse(t.data.args):[];if(e in Je&&"function"==typeof Je[e])try{const t=Je[e](i);postMessage({id:a,method:e,success:!0,response:t})}catch(t){postMessage({id:a,method:e,success:!1,response:t.message}),console.error(t)}})),postMessage({id:void 0,method:"init",success:!0,response:void 0});`;

/**
 * Create an event buffer for replays.
 */
function createEventBuffer({ useCompression }) {
  // eslint-disable-next-line no-restricted-globals
  if (useCompression && window.Worker) {
    const workerBlob = new Blob([workerString]);
    const workerUrl = URL.createObjectURL(workerBlob);

    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.log */.kg.log('[Replay] Using compression worker');
    const worker = new Worker(workerUrl);
    return new EventBufferProxy(worker);
  }

  (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.log */.kg.log('[Replay] Using simple buffer');
  return new EventBufferArray();
}

/**
 * This proxy will try to use the compression worker, and fall back to use the simple buffer if an error occurs there.
 * This can happen e.g. if the worker cannot be loaded.
 * Exported only for testing.
 */
class EventBufferProxy  {

   constructor(worker) {
    this._fallback = new EventBufferArray();
    this._compression = new EventBufferCompressionWorker(worker);
    this._used = this._fallback;

    void this._ensureWorkerIsLoaded();
  }

  /** @inheritDoc */
   get pendingLength() {
    return this._used.pendingLength;
  }

  /** @inheritDoc */
   get pendingEvents() {
    return this._used.pendingEvents;
  }

  /** @inheritDoc */
   destroy() {
    this._fallback.destroy();
    this._compression.destroy();
  }

  /**
   * Add an event to the event buffer.
   *
   * Returns true if event was successfully added.
   */
   addEvent(event, isCheckout) {
    return this._used.addEvent(event, isCheckout);
  }

  /** @inheritDoc */
   finish() {
    return this._used.finish();
  }

  /** Ensure the worker has loaded. */
   async _ensureWorkerIsLoaded() {
    try {
      await this._compression.ensureReady();
    } catch (error) {
      // If the worker fails to load, we fall back to the simple buffer.
      // Nothing more to do from our side here
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.log */.kg.log('[Replay] Failed to load the compression worker, falling back to simple buffer');
      return;
    }

    // Compression worker is ready, we can use it
    // Now we need to switch over the array buffer to the compression worker
    const addEventPromises = [];
    for (const event of this._fallback.pendingEvents) {
      addEventPromises.push(this._compression.addEvent(event));
    }

    // We switch over to the compression buffer immediately - any further events will be added
    // after the previously buffered ones
    this._used = this._compression;

    // Wait for original events to be re-added before resolving
    await Promise.all(addEventPromises);
  }
}

class EventBufferArray  {

   constructor() {
    this._events = [];
  }

   get pendingLength() {
    return this._events.length;
  }

  /**
   * Returns the raw events that are buffered. In `EventBufferArray`, this is the
   * same as `this._events`.
   */
   get pendingEvents() {
    return this._events;
  }

   destroy() {
    this._events = [];
  }

   async addEvent(event, isCheckout) {
    if (isCheckout) {
      this._events = [event];
      return;
    }

    this._events.push(event);
    return;
  }

   finish() {
    return new Promise(resolve => {
      // Make a copy of the events array reference and immediately clear the
      // events member so that we do not lose new events while uploading
      // attachment.
      const eventsRet = this._events;
      this._events = [];
      resolve(JSON.stringify(eventsRet));
    });
  }
}

/**
 * Event buffer that uses a web worker to compress events.
 * Exported only for testing.
 */
class EventBufferCompressionWorker  {
  /**
   * Keeps track of the list of events since the last flush that have not been compressed.
   * For example, page is reloaded and a flush attempt is made, but
   * `finish()` (and thus the flush), does not complete.
   */
   __init() {this._pendingEvents = [];}

   __init2() {this._eventBufferItemLength = 0;}
   __init3() {this._id = 0;}

   constructor(worker) {EventBufferCompressionWorker.prototype.__init.call(this);EventBufferCompressionWorker.prototype.__init2.call(this);EventBufferCompressionWorker.prototype.__init3.call(this);
    this._worker = worker;
  }

  /**
   * The number of raw events that are buffered. This may not be the same as
   * the number of events that have been compresed in the worker because
   * `addEvent` is async.
   */
   get pendingLength() {
    return this._eventBufferItemLength;
  }

  /**
   * Returns a list of the raw recording events that are being compressed.
   */
   get pendingEvents() {
    return this._pendingEvents;
  }

  /**
   * Ensure the worker is ready (or not).
   * This will either resolve when the worker is ready, or reject if an error occured.
   */
   ensureReady() {
    return new Promise((resolve, reject) => {
      this._worker.addEventListener(
        'message',
        ({ data }) => {
          if (data.success) {
            resolve();
          } else {
            reject();
          }
        },
        { once: true },
      );

      this._worker.addEventListener(
        'error',
        error => {
          reject(error);
        },
        { once: true },
      );
    });
  }

  /**
   * Destroy the event buffer.
   */
   destroy() {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.log */.kg.log('[Replay] Destroying compression worker');
    this._worker.terminate();
  }

  /**
   * Add an event to the event buffer.
   *
   * Returns true if event was successfuly received and processed by worker.
   */
   async addEvent(event, isCheckout) {
    if (isCheckout) {
      // This event is a checkout, make sure worker buffer is cleared before
      // proceeding.
      await this._postMessage({
        id: this._getAndIncrementId(),
        method: 'init',
        args: [],
      });
    }

    // Don't store checkout events in `_pendingEvents` because they are too large
    if (!isCheckout) {
      this._pendingEvents.push(event);
    }

    return this._sendEventToWorker(event);
  }

  /**
   * Finish the event buffer and return the compressed data.
   */
   finish() {
    return this._finishRequest(this._getAndIncrementId());
  }

  /**
   * Post message to worker and wait for response before resolving promise.
   */
   _postMessage({ id, method, args }) {
    return new Promise((resolve, reject) => {
      // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
      const listener = ({ data }) => {
        if (data.method !== method) {
          return;
        }

        // There can be multiple listeners for a single method, the id ensures
        // that the response matches the caller.
        if (data.id !== id) {
          return;
        }

        // At this point, we'll always want to remove listener regardless of result status
        this._worker.removeEventListener('message', listener);

        if (!data.success) {
          // TODO: Do some error handling, not sure what
          (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.error */.kg.error('[Replay]', data.response);

          reject(new Error('Error in compression worker'));
          return;
        }

        resolve(data.response);
      };

      let stringifiedArgs;
      try {
        stringifiedArgs = JSON.stringify(args);
      } catch (err) {
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.error */.kg.error('[Replay] Error when trying to stringify args', err);
        stringifiedArgs = '[]';
      }

      // Note: we can't use `once` option because it's possible it needs to
      // listen to multiple messages
      this._worker.addEventListener('message', listener);
      this._worker.postMessage({ id, method, args: stringifiedArgs });
    });
  }

  /**
   * Send the event to the worker.
   */
   async _sendEventToWorker(event) {
    const promise = this._postMessage({
      id: this._getAndIncrementId(),
      method: 'addEvent',
      args: [event],
    });

    // XXX: See note in `get length()`
    this._eventBufferItemLength++;

    return promise;
  }

  /**
   * Finish the request and return the compressed data from the worker.
   */
   async _finishRequest(id) {
    const promise = this._postMessage({ id, method: 'finish', args: [] });

    // XXX: See note in `get length()`
    this._eventBufferItemLength = 0;

    await promise;

    this._pendingEvents = [];

    return promise;
  }

  /** Get the current ID and increment it for the next call. */
   _getAndIncrementId() {
    return this._id++;
  }
}

/**
 * Given an initial timestamp and an expiry duration, checks to see if current
 * time should be considered as expired.
 */
function isExpired(
  initialTime,
  expiry,
  targetTime = +new Date(),
) {
  // Always expired if < 0
  if (initialTime === null || expiry === undefined || expiry < 0) {
    return true;
  }

  // Never expires if == 0
  if (expiry === 0) {
    return false;
  }

  return initialTime + expiry <= targetTime;
}

/**
 * Checks to see if session is expired
 */
function isSessionExpired(session, idleTimeout, targetTime = +new Date()) {
  return (
    // First, check that maximum session length has not been exceeded
    isExpired(session.started, MAX_SESSION_LIFE, targetTime) ||
    // check that the idle timeout has not been exceeded (i.e. user has
    // performed an action within the last `idleTimeout` ms)
    isExpired(session.lastActivity, idleTimeout, targetTime)
  );
}

/**
 * Save a session to session storage.
 */
function saveSession(session) {
  const hasSessionStorage = 'sessionStorage' in esm_WINDOW;
  if (!hasSessionStorage) {
    return;
  }

  try {
    esm_WINDOW.sessionStorage.setItem(REPLAY_SESSION_KEY, JSON.stringify(session));
  } catch (e) {
    // Ignore potential SecurityError exceptions
  }
}

/**
 * Given a sample rate, returns true if replay should be sampled.
 *
 * 1.0 = 100% sampling
 * 0.0 = 0% sampling
 */
function isSampled(sampleRate) {
  if (sampleRate === undefined) {
    return false;
  }

  // Math.random() returns a number in range of 0 to 1 (inclusive of 0, but not 1)
  return Math.random() < sampleRate;
}

/**
 * Get a session with defaults & applied sampling.
 */
function makeSession(session) {
  const now = new Date().getTime();
  const id = session.id || (0,misc/* uuid4 */.DM)();
  // Note that this means we cannot set a started/lastActivity of `0`, but this should not be relevant outside of tests.
  const started = session.started || now;
  const lastActivity = session.lastActivity || now;
  const segmentId = session.segmentId || 0;
  const sampled = session.sampled;

  return {
    id,
    started,
    lastActivity,
    segmentId,
    sampled,
  };
}

/**
 * Get the sampled status for a session based on sample rates & current sampled status.
 */
function getSessionSampleType(sessionSampleRate, errorSampleRate) {
  return isSampled(sessionSampleRate) ? 'session' : isSampled(errorSampleRate) ? 'error' : false;
}

/**
 * Create a new session, which in its current implementation is a Sentry event
 * that all replays will be saved to as attachments. Currently, we only expect
 * one of these Sentry events per "replay session".
 */
function createSession({ sessionSampleRate, errorSampleRate, stickySession = false }) {
  const sampled = getSessionSampleType(sessionSampleRate, errorSampleRate);
  const session = makeSession({
    sampled,
  });

  (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.log */.kg.log(`[Replay] Creating new session: ${session.id}`);

  if (stickySession) {
    saveSession(session);
  }

  return session;
}

/**
 * Fetches a session from storage
 */
function fetchSession() {
  const hasSessionStorage = 'sessionStorage' in esm_WINDOW;

  if (!hasSessionStorage) {
    return null;
  }

  try {
    // This can throw if cookies are disabled
    const sessionStringFromStorage = esm_WINDOW.sessionStorage.getItem(REPLAY_SESSION_KEY);

    if (!sessionStringFromStorage) {
      return null;
    }

    const sessionObj = JSON.parse(sessionStringFromStorage) ;

    return makeSession(sessionObj);
  } catch (e) {
    return null;
  }
}

/**
 * Get or create a session
 */
function getSession({
  expiry,
  currentSession,
  stickySession,
  sessionSampleRate,
  errorSampleRate,
}) {
  // If session exists and is passed, use it instead of always hitting session storage
  const session = currentSession || (stickySession && fetchSession());

  if (session) {
    // If there is a session, check if it is valid (e.g. "last activity" time
    // should be within the "session idle time", and "session started" time is
    // within "max session time").
    const isExpired = isSessionExpired(session, expiry);

    if (!isExpired) {
      return { type: 'saved', session };
    } else {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.log */.kg.log('[Replay] Session has expired');
    }
    // Otherwise continue to create a new session
  }

  const newSession = createSession({
    stickySession,
    sessionSampleRate,
    errorSampleRate,
  });

  return { type: 'new', session: newSession };
}

/**
 * Create a "span" for the total amount of memory being used by JS objects
 * (including v8 internal objects).
 */
async function addMemoryEntry(replay) {
  // window.performance.memory is a non-standard API and doesn't work on all browsers, so we try-catch this
  try {
    return Promise.all(
      createPerformanceSpans(replay, [
        // @ts-ignore memory doesn't exist on type Performance as the API is non-standard (we check that it exists above)
        createMemoryEntry(esm_WINDOW.performance.memory),
      ]),
    );
  } catch (error) {
    // Do nothing
    return [];
  }
}

function createMemoryEntry(memoryEntry) {
  const { jsHeapSizeLimit, totalJSHeapSize, usedJSHeapSize } = memoryEntry;
  // we don't want to use `getAbsoluteTime` because it adds the event time to the
  // time origin, so we get the current timestamp instead
  const time = new Date().getTime() / 1000;
  return {
    type: 'memory',
    name: 'memory',
    start: time,
    end: time,
    data: {
      memory: {
        jsHeapSizeLimit,
        totalJSHeapSize,
        usedJSHeapSize,
      },
    },
  };
}

// Map entryType -> function to normalize data for event
// @ts-ignore TODO: entry type does not fit the create* functions entry type
const ENTRY_TYPES = {
  // @ts-ignore TODO: entry type does not fit the create* functions entry type
  resource: createResourceEntry,
  paint: createPaintEntry,
  // @ts-ignore TODO: entry type does not fit the create* functions entry type
  navigation: createNavigationEntry,
  // @ts-ignore TODO: entry type does not fit the create* functions entry type
  ['largest-contentful-paint']: createLargestContentfulPaint,
};

/**
 * Create replay performance entries from the browser performance entries.
 */
function createPerformanceEntries(entries) {
  return entries.map(createPerformanceEntry).filter(Boolean) ;
}

function createPerformanceEntry(entry) {
  if (ENTRY_TYPES[entry.entryType] === undefined) {
    return null;
  }

  return ENTRY_TYPES[entry.entryType](entry);
}

function getAbsoluteTime(time) {
  // browserPerformanceTimeOrigin can be undefined if `performance` or
  // `performance.now` doesn't exist, but this is already checked by this integration
  return ((esm_time/* browserPerformanceTimeOrigin */.Z1 || esm_WINDOW.performance.timeOrigin) + time) / 1000;
}

// TODO: type definition!
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
function createPaintEntry(entry) {
  const { duration, entryType, name, startTime } = entry;

  const start = getAbsoluteTime(startTime);
  return {
    type: entryType,
    name,
    start,
    end: start + duration,
  };
}

// TODO: type definition!
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
function createNavigationEntry(entry) {
  // TODO: There looks to be some more interesting bits in here (domComplete, domContentLoaded)
  const { entryType, name, duration, domComplete, startTime, transferSize, type } = entry;

  // Ignore entries with no duration, they do not seem to be useful and cause dupes
  if (duration === 0) {
    return null;
  }

  return {
    type: `${entryType}.${type}`,
    start: getAbsoluteTime(startTime),
    end: getAbsoluteTime(domComplete),
    name,
    data: {
      size: transferSize,
      duration,
    },
  };
}

// TODO: type definition!
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
function createResourceEntry(entry) {
  const { entryType, initiatorType, name, responseEnd, startTime, encodedBodySize, transferSize } = entry;

  // Core SDK handles these
  if (['fetch', 'xmlhttprequest'].includes(initiatorType)) {
    return null;
  }

  return {
    type: `${entryType}.${initiatorType}`,
    start: getAbsoluteTime(startTime),
    end: getAbsoluteTime(responseEnd),
    name,
    data: {
      size: transferSize,
      encodedBodySize,
    },
  };
}

// TODO: type definition!
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
function createLargestContentfulPaint(entry) {
  const { duration, entryType, startTime, size } = entry;

  const start = getAbsoluteTime(startTime);

  return {
    type: entryType,
    name: entryType,
    start,
    end: start + duration,
    data: {
      duration,
      size,
      // Not sure why this errors, Node should be correct (Argument of type 'Node' is not assignable to parameter of type 'INode')
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      nodeId: record.mirror.getId(entry.element ),
    },
  };
}

/**
 * Heavily simplified debounce function based on lodash.debounce.
 *
 * This function takes a callback function (@param fun) and delays its invocation
 * by @param wait milliseconds. Optionally, a maxWait can be specified in @param options,
 * which ensures that the callback is invoked at least once after the specified max. wait time.
 *
 * @param func the function whose invocation is to be debounced
 * @param wait the minimum time until the function is invoked after it was called once
 * @param options the options object, which can contain the `maxWait` property
 *
 * @returns the debounced version of the function, which needs to be called at least once to start the
 *          debouncing process. Subsequent calls will reset the debouncing timer and, in case @paramfunc
 *          was already invoked in the meantime, return @param func's return value.
 *          The debounced function has two additional properties:
 *          - `flush`: Invokes the debounced function immediately and returns its return value
 *          - `cancel`: Cancels the debouncing process and resets the debouncing timer
 */
function debounce(func, wait, options) {
  let callbackReturnValue;

  let timerId;
  let maxTimerId;

  const maxWait = options && options.maxWait ? Math.max(options.maxWait, wait) : 0;

  function invokeFunc() {
    cancelTimers();
    callbackReturnValue = func();
    return callbackReturnValue;
  }

  function cancelTimers() {
    timerId !== undefined && clearTimeout(timerId);
    maxTimerId !== undefined && clearTimeout(maxTimerId);
    timerId = maxTimerId = undefined;
  }

  function flush() {
    if (timerId !== undefined || maxTimerId !== undefined) {
      return invokeFunc();
    }
    return callbackReturnValue;
  }

  function debounced() {
    if (timerId) {
      clearTimeout(timerId);
    }
    timerId = setTimeout(invokeFunc, wait);

    if (maxWait && maxTimerId === undefined && maxWait !== wait) {
      maxTimerId = setTimeout(invokeFunc, maxWait);
    }

    return callbackReturnValue;
  }

  debounced.cancel = cancelTimers;
  debounced.flush = flush;
  return debounced;
}

let _originalRecordDroppedEvent;

/**
 * Overwrite the `recordDroppedEvent` method on the client, so we can find out which events were dropped.
 * */
function overwriteRecordDroppedEvent(errorIds) {
  const client = (0,esm_hub/* getCurrentHub */.Gd)().getClient();

  if (!client) {
    return;
  }

  const _originalCallback = client.recordDroppedEvent.bind(client);

  const recordDroppedEvent = (
    reason,
    category,
    event,
  ) => {
    if (event && !event.type && event.event_id) {
      errorIds.delete(event.event_id);
    }

    return _originalCallback(reason, category, event);
  };

  client.recordDroppedEvent = recordDroppedEvent;
  _originalRecordDroppedEvent = _originalCallback;
}

/**
 * Restore the original method.
 * */
function restoreRecordDroppedEvent() {
  const client = (0,esm_hub/* getCurrentHub */.Gd)().getClient();

  if (!client || !_originalRecordDroppedEvent) {
    return;
  }

  client.recordDroppedEvent = _originalRecordDroppedEvent;
}

/**
 * Create a replay envelope ready to be sent.
 * This includes both the replay event, as well as the recording data.
 */
function createReplayEnvelope(
  replayEvent,
  recordingData,
  dsn,
  tunnel,
) {
  return createEnvelope(
    createEventEnvelopeHeaders(replayEvent, getSdkMetadataForEnvelopeHeader(replayEvent), tunnel, dsn),
    [
      [{ type: 'replay_event' }, replayEvent],
      [
        {
          type: 'replay_recording',
          // If string then we need to encode to UTF8, otherwise will have
          // wrong size. TextEncoder has similar browser support to
          // MutationObserver, although it does not accept IE11.
          length:
            typeof recordingData === 'string' ? new TextEncoder().encode(recordingData).length : recordingData.length,
        },
        recordingData,
      ],
    ],
  );
}

/**
 * Prepare the recording data ready to be sent.
 */
function prepareRecordingData({
  recordingData,
  headers,
}

) {
  let payloadWithSequence;

  // XXX: newline is needed to separate sequence id from events
  const replayHeaders = `${JSON.stringify(headers)}
`;

  if (typeof recordingData === 'string') {
    payloadWithSequence = `${replayHeaders}${recordingData}`;
  } else {
    const enc = new TextEncoder();
    // XXX: newline is needed to separate sequence id from events
    const sequence = enc.encode(replayHeaders);
    // Merge the two Uint8Arrays
    payloadWithSequence = new Uint8Array(sequence.length + recordingData.length);
    payloadWithSequence.set(sequence);
    payloadWithSequence.set(recordingData, sequence.length);
  }

  return payloadWithSequence;
}

/**
 * Prepare a replay event & enrich it with the SDK metadata.
 */
async function prepareReplayEvent({
  client,
  scope,
  replayId: event_id,
  event,
}

) {
  const preparedEvent = (await prepareEvent(client.getOptions(), event, { event_id }, scope)) ;

  // If e.g. a global event processor returned null
  if (!preparedEvent) {
    return null;
  }

  // This normally happens in browser client "_prepareEvent"
  // but since we do not use this private method from the client, but rather the plain import
  // we need to do this manually.
  preparedEvent.platform = preparedEvent.platform || 'javascript';

  // extract the SDK name because `client._prepareEvent` doesn't add it to the event
  const metadata = client.getSdkMetadata && client.getSdkMetadata();
  const { name, version } = (metadata && metadata.sdk) || {};

  preparedEvent.sdk = {
    ...preparedEvent.sdk,
    name: name || 'sentry.javascript.unknown',
    version: version || '0.0.0',
  };

  return preparedEvent;
}

/**
 * Send replay attachment using `fetch()`
 */
async function sendReplayRequest({
  recordingData,
  replayId,
  segmentId: segment_id,
  includeReplayStartTimestamp,
  eventContext,
  timestamp,
  session,
  options,
}) {
  const preparedRecordingData = prepareRecordingData({
    recordingData,
    headers: {
      segment_id,
    },
  });

  const { urls, errorIds, traceIds, initialTimestamp } = eventContext;

  const hub = (0,esm_hub/* getCurrentHub */.Gd)();
  const client = hub.getClient();
  const scope = hub.getScope();
  const transport = client && client.getTransport();
  const dsn = client && client.getDsn();

  if (!client || !scope || !transport || !dsn || !session.sampled) {
    return;
  }

  const baseEvent = {
    // @ts-ignore private api
    type: REPLAY_EVENT_NAME,
    ...(includeReplayStartTimestamp ? { replay_start_timestamp: initialTimestamp / 1000 } : {}),
    timestamp: timestamp / 1000,
    error_ids: errorIds,
    trace_ids: traceIds,
    urls,
    replay_id: replayId,
    segment_id,
    replay_type: session.sampled,
  };

  const replayEvent = await prepareReplayEvent({ scope, client, replayId, event: baseEvent });

  if (!replayEvent) {
    // Taken from baseclient's `_processEvent` method, where this is handled for errors/transactions
    client.recordDroppedEvent('event_processor', 'replay', baseEvent);
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.log */.kg.log('An event processor returned `null`, will not send event.');
    return;
  }

  replayEvent.tags = {
    ...replayEvent.tags,
    sessionSampleRate: options.sessionSampleRate,
    errorSampleRate: options.errorSampleRate,
  };

  /*
  For reference, the fully built event looks something like this:
  {
      "type": "replay_event",
      "timestamp": 1670837008.634,
      "error_ids": [
          "errorId"
      ],
      "trace_ids": [
          "traceId"
      ],
      "urls": [
          "https://example.com"
      ],
      "replay_id": "eventId",
      "segment_id": 3,
      "replay_type": "error",
      "platform": "javascript",
      "event_id": "eventId",
      "environment": "production",
      "sdk": {
          "integrations": [
              "BrowserTracing",
              "Replay"
          ],
          "name": "sentry.javascript.browser",
          "version": "7.25.0"
      },
      "sdkProcessingMetadata": {},
      "tags": {
          "sessionSampleRate": 1,
          "errorSampleRate": 0,
      }
  }
  */

  const envelope = createReplayEnvelope(replayEvent, preparedRecordingData, dsn, client.getOptions().tunnel);

  let response;

  try {
    response = await transport.send(envelope);
  } catch (e) {
    throw new Error(UNABLE_TO_SEND_REPLAY);
  }

  // TODO (v8): we can remove this guard once transport.send's type signature doesn't include void anymore
  if (!response) {
    return response;
  }

  const rateLimits = updateRateLimits({}, response);
  if (isRateLimited(rateLimits, 'replay')) {
    throw new RateLimitError(rateLimits);
  }

  // If the status code is invalid, we want to immediately stop & not retry
  if (typeof response.statusCode === 'number' && (response.statusCode < 200 || response.statusCode >= 300)) {
    throw new TransportStatusCodeError(response.statusCode);
  }

  return response;
}

/**
 * This error indicates that we hit a rate limit API error.
 */
class RateLimitError extends Error {

   constructor(rateLimits) {
    super('Rate limit hit');
    this.rateLimits = rateLimits;
  }
}

/**
 * This error indicates that the transport returned an invalid status code.
 */
class TransportStatusCodeError extends Error {
   constructor(statusCode) {
    super(`Transport returned status code ${statusCode}`);
  }
}

/**
 * Finalize and send the current replay event to Sentry
 */
async function sendReplay(
  replayData,
  retryConfig = {
    count: 0,
    interval: RETRY_BASE_INTERVAL,
  },
) {
  const { recordingData, options } = replayData;

  // short circuit if there's no events to upload (this shouldn't happen as _runFlush makes this check)
  if (!recordingData.length) {
    return;
  }

  try {
    await sendReplayRequest(replayData);
    return true;
  } catch (err) {
    if (err instanceof RateLimitError || err instanceof TransportStatusCodeError) {
      throw err;
    }

    // Capture error for every failed replay
    setContext('Replays', {
      _retryCount: retryConfig.count,
    });

    if ((typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && options._experiments && options._experiments.captureExceptions) {
      captureException(err);
    }

    // If an error happened here, it's likely that uploading the attachment
    // failed, we'll can retry with the same events payload
    if (retryConfig.count >= RETRY_MAX_COUNT) {
      throw new Error(`${UNABLE_TO_SEND_REPLAY} - max retries exceeded`);
    }

    // will retry in intervals of 5, 10, 30
    retryConfig.interval *= ++retryConfig.count;

    return await new Promise((resolve, reject) => {
      setTimeout(async () => {
        try {
          await sendReplay(replayData, retryConfig);
          resolve(true);
        } catch (err) {
          reject(err);
        }
      }, retryConfig.interval);
    });
  }
}

/* eslint-disable max-lines */ // TODO: We might want to split this file up

/**
 * The main replay container class, which holds all the state and methods for recording and sending replays.
 */
class ReplayContainer  {
   __init() {this.eventBuffer = null;}

  /**
   * List of PerformanceEntry from PerformanceObserver
   */
   __init2() {this.performanceEvents = [];}

  /**
   * Recording can happen in one of two modes:
   * * session: Record the whole session, sending it continuously
   * * error: Always keep the last 60s of recording, and when an error occurs, send it immediately
   */
   __init3() {this.recordingMode = 'session';}

  /**
   * Options to pass to `rrweb.record()`
   */

   __init4() {this._performanceObserver = null;}

   __init5() {this._flushLock = null;}

  /**
   * Timestamp of the last user activity. This lives across sessions.
   */
   __init6() {this._lastActivity = new Date().getTime();}

  /**
   * Is the integration currently active?
   */
   __init7() {this._isEnabled = false;}

  /**
   * Paused is a state where:
   * - DOM Recording is not listening at all
   * - Nothing will be added to event buffer (e.g. core SDK events)
   */
   __init8() {this._isPaused = false;}

  /**
   * Have we attached listeners to the core SDK?
   * Note we have to track this as there is no way to remove instrumentation handlers.
   */
   __init9() {this._hasInitializedCoreListeners = false;}

  /**
   * Function to stop recording
   */
   __init10() {this._stopRecording = null;}

   __init11() {this._context = {
    errorIds: new Set(),
    traceIds: new Set(),
    urls: [],
    earliestEvent: null,
    initialTimestamp: new Date().getTime(),
    initialUrl: '',
  };}

   constructor({
    options,
    recordingOptions,
  }

) {ReplayContainer.prototype.__init.call(this);ReplayContainer.prototype.__init2.call(this);ReplayContainer.prototype.__init3.call(this);ReplayContainer.prototype.__init4.call(this);ReplayContainer.prototype.__init5.call(this);ReplayContainer.prototype.__init6.call(this);ReplayContainer.prototype.__init7.call(this);ReplayContainer.prototype.__init8.call(this);ReplayContainer.prototype.__init9.call(this);ReplayContainer.prototype.__init10.call(this);ReplayContainer.prototype.__init11.call(this);ReplayContainer.prototype.__init12.call(this);ReplayContainer.prototype.__init13.call(this);ReplayContainer.prototype.__init14.call(this);ReplayContainer.prototype.__init15.call(this);ReplayContainer.prototype.__init16.call(this);ReplayContainer.prototype.__init17.call(this);
    this._recordingOptions = recordingOptions;
    this._options = options;

    this._debouncedFlush = debounce(() => this._flush(), this._options.flushMinDelay, {
      maxWait: this._options.flushMaxDelay,
    });
  }

  /** Get the event context. */
   getContext() {
    return this._context;
  }

  /** If recording is currently enabled. */
   isEnabled() {
    return this._isEnabled;
  }

  /** If recording is currently paused. */
   isPaused() {
    return this._isPaused;
  }

  /** Get the replay integration options. */
   getOptions() {
    return this._options;
  }

  /**
   * Initializes the plugin.
   *
   * Creates or loads a session, attaches listeners to varying events (DOM,
   * _performanceObserver, Recording, Sentry SDK, etc)
   */
   start() {
    this._setInitialState();

    this._loadSession({ expiry: SESSION_IDLE_DURATION });

    // If there is no session, then something bad has happened - can't continue
    if (!this.session) {
      this._handleException(new Error('No session found'));
      return;
    }

    if (!this.session.sampled) {
      // If session was not sampled, then we do not initialize the integration at all.
      return;
    }

    // If session is sampled for errors, then we need to set the recordingMode
    // to 'error', which will configure recording with different options.
    if (this.session.sampled === 'error') {
      this.recordingMode = 'error';
    }

    // setup() is generally called on page load or manually - in both cases we
    // should treat it as an activity
    this._updateSessionActivity();

    this.eventBuffer = createEventBuffer({
      useCompression: this._options.useCompression,
    });

    this._addListeners();

    // Need to set as enabled before we start recording, as `record()` can trigger a flush with a new checkout
    this._isEnabled = true;

    this.startRecording();
  }

  /**
   * Start recording.
   *
   * Note that this will cause a new DOM checkout
   */
   startRecording() {
    try {
      this._stopRecording = record({
        ...this._recordingOptions,
        // When running in error sampling mode, we need to overwrite `checkoutEveryNms`
        // Without this, it would record forever, until an error happens, which we don't want
        // instead, we'll always keep the last 60 seconds of replay before an error happened
        ...(this.recordingMode === 'error' && { checkoutEveryNms: 60000 }),
        emit: this._handleRecordingEmit,
      });
    } catch (err) {
      this._handleException(err);
    }
  }

  /**
   * Stops the recording, if it was running.
   * Returns true if it was stopped, else false.
   */
   stopRecording() {
    if (this._stopRecording) {
      this._stopRecording();
      return true;
    }

    return false;
  }

  /**
   * Currently, this needs to be manually called (e.g. for tests). Sentry SDK
   * does not support a teardown
   */
   stop() {
    try {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.log */.kg.log('[Replay] Stopping Replays');
      this._isEnabled = false;
      this._removeListeners();
      this._stopRecording && this._stopRecording();
      this.eventBuffer && this.eventBuffer.destroy();
      this.eventBuffer = null;
      this._debouncedFlush.cancel();
    } catch (err) {
      this._handleException(err);
    }
  }

  /**
   * Pause some replay functionality. See comments for `_isPaused`.
   * This differs from stop as this only stops DOM recording, it is
   * not as thorough of a shutdown as `stop()`.
   */
   pause() {
    this._isPaused = true;
    try {
      if (this._stopRecording) {
        this._stopRecording();
        this._stopRecording = undefined;
      }
    } catch (err) {
      this._handleException(err);
    }
  }

  /**
   * Resumes recording, see notes for `pause().
   *
   * Note that calling `startRecording()` here will cause a
   * new DOM checkout.`
   */
   resume() {
    this._isPaused = false;
    this.startRecording();
  }

  /**
   * We want to batch uploads of replay events. Save events only if
   * `<flushMinDelay>` milliseconds have elapsed since the last event
   * *OR* if `<flushMaxDelay>` milliseconds have elapsed.
   *
   * Accepts a callback to perform side-effects and returns true to stop batch
   * processing and hand back control to caller.
   */
   addUpdate(cb) {
    // We need to always run `cb` (e.g. in the case of `this.recordingMode == 'error'`)
    const cbResult = cb();

    // If this option is turned on then we will only want to call `flush`
    // explicitly
    if (this.recordingMode === 'error') {
      return;
    }

    // If callback is true, we do not want to continue with flushing -- the
    // caller will need to handle it.
    if (cbResult === true) {
      return;
    }

    // addUpdate is called quite frequently - use _debouncedFlush so that it
    // respects the flush delays and does not flush immediately
    this._debouncedFlush();
  }

  /**
   * Updates the user activity timestamp and resumes recording. This should be
   * called in an event handler for a user action that we consider as the user
   * being "active" (e.g. a mouse click).
   */
   triggerUserActivity() {
    this._updateUserActivity();

    // This case means that recording was once stopped due to inactivity.
    // Ensure that recording is resumed.
    if (!this._stopRecording) {
      // Create a new session, otherwise when the user action is flushed, it
      // will get rejected due to an expired session.
      this._loadSession({ expiry: SESSION_IDLE_DURATION });

      // Note: This will cause a new DOM checkout
      this.resume();
      return;
    }

    // Otherwise... recording was never suspended, continue as normalish
    this._checkAndHandleExpiredSession();

    this._updateSessionActivity();
  }

  /**
   *
   * Always flush via `_debouncedFlush` so that we do not have flushes triggered
   * from calling both `flush` and `_debouncedFlush`. Otherwise, there could be
   * cases of mulitple flushes happening closely together.
   */
   flushImmediate() {
    this._debouncedFlush();
    // `.flush` is provided by the debounced function, analogously to lodash.debounce
    return this._debouncedFlush.flush() ;
  }

  /** Get the current sesion (=replay) ID */
   getSessionId() {
    return this.session && this.session.id;
  }

  /** A wrapper to conditionally capture exceptions. */
   _handleException(error) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.error */.kg.error('[Replay]', error);

    if ((typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && this._options._experiments && this._options._experiments.captureExceptions) {
      captureException(error);
    }
  }

  /**
   * Loads a session from storage, or creates a new one if it does not exist or
   * is expired.
   */
   _loadSession({ expiry }) {
    const { type, session } = getSession({
      expiry,
      stickySession: Boolean(this._options.stickySession),
      currentSession: this.session,
      sessionSampleRate: this._options.sessionSampleRate,
      errorSampleRate: this._options.errorSampleRate,
    });

    // If session was newly created (i.e. was not loaded from storage), then
    // enable flag to create the root replay
    if (type === 'new') {
      this._setInitialState();
    }

    const currentSessionId = this.getSessionId();
    if (session.id !== currentSessionId) {
      session.previousSessionId = currentSessionId;
    }

    this.session = session;
  }

  /**
   * Capture some initial state that can change throughout the lifespan of the
   * replay. This is required because otherwise they would be captured at the
   * first flush.
   */
   _setInitialState() {
    const urlPath = `${esm_WINDOW.location.pathname}${esm_WINDOW.location.hash}${esm_WINDOW.location.search}`;
    const url = `${esm_WINDOW.location.origin}${urlPath}`;

    this.performanceEvents = [];

    // Reset _context as well
    this._clearContext();

    this._context.initialUrl = url;
    this._context.initialTimestamp = new Date().getTime();
    this._context.urls.push(url);
  }

  /**
   * Adds listeners to record events for the replay
   */
   _addListeners() {
    try {
      esm_WINDOW.document.addEventListener('visibilitychange', this._handleVisibilityChange);
      esm_WINDOW.addEventListener('blur', this._handleWindowBlur);
      esm_WINDOW.addEventListener('focus', this._handleWindowFocus);

      // We need to filter out dropped events captured by `addGlobalEventProcessor(this.handleGlobalEvent)` below
      overwriteRecordDroppedEvent(this._context.errorIds);

      // There is no way to remove these listeners, so ensure they are only added once
      if (!this._hasInitializedCoreListeners) {
        // Listeners from core SDK //
        const scope = (0,esm_hub/* getCurrentHub */.Gd)().getScope();
        if (scope) {
          scope.addScopeListener(this._handleCoreBreadcrumbListener('scope'));
        }
        (0,instrument/* addInstrumentationHandler */.o)('dom', this._handleCoreBreadcrumbListener('dom'));
        (0,instrument/* addInstrumentationHandler */.o)('fetch', handleFetchSpanListener(this));
        (0,instrument/* addInstrumentationHandler */.o)('xhr', handleXhrSpanListener(this));
        (0,instrument/* addInstrumentationHandler */.o)('history', handleHistorySpanListener(this));

        // Tag all (non replay) events that get sent to Sentry with the current
        // replay ID so that we can reference them later in the UI
        (0,esm_scope/* addGlobalEventProcessor */.c)(handleGlobalEventListener(this));

        this._hasInitializedCoreListeners = true;
      }
    } catch (err) {
      this._handleException(err);
    }

    // _performanceObserver //
    if (!('_performanceObserver' in esm_WINDOW)) {
      return;
    }

    this._performanceObserver = setupPerformanceObserver(this);
  }

  /**
   * Cleans up listeners that were created in `_addListeners`
   */
   _removeListeners() {
    try {
      esm_WINDOW.document.removeEventListener('visibilitychange', this._handleVisibilityChange);

      esm_WINDOW.removeEventListener('blur', this._handleWindowBlur);
      esm_WINDOW.removeEventListener('focus', this._handleWindowFocus);

      restoreRecordDroppedEvent();

      if (this._performanceObserver) {
        this._performanceObserver.disconnect();
        this._performanceObserver = null;
      }
    } catch (err) {
      this._handleException(err);
    }
  }

  /**
   * Handler for recording events.
   *
   * Adds to event buffer, and has varying flushing behaviors if the event was a checkout.
   */
   __init12() {this._handleRecordingEmit = (
    event,
    isCheckout,
  ) => {
    // If this is false, it means session is expired, create and a new session and wait for checkout
    if (!this._checkAndHandleExpiredSession()) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.error */.kg.error('[Replay] Received replay event after session expired.');

      return;
    }

    this.addUpdate(() => {
      // The session is always started immediately on pageload/init, but for
      // error-only replays, it should reflect the most recent checkout
      // when an error occurs. Clear any state that happens before this current
      // checkout. This needs to happen before `addEvent()` which updates state
      // dependent on this reset.
      if (this.recordingMode === 'error' && event.type === 2) {
        this._setInitialState();
      }

      // We need to clear existing events on a checkout, otherwise they are
      // incremental event updates and should be appended
      void addEvent(this, event, isCheckout);

      // Different behavior for full snapshots (type=2), ignore other event types
      // See https://github.com/rrweb-io/rrweb/blob/d8f9290ca496712aa1e7d472549480c4e7876594/packages/rrweb/src/types.ts#L16
      if (event.type !== 2) {
        return false;
      }

      // If there is a previousSessionId after a full snapshot occurs, then
      // the replay session was started due to session expiration. The new session
      // is started before triggering a new checkout and contains the id
      // of the previous session. Do not immediately flush in this case
      // to avoid capturing only the checkout and instead the replay will
      // be captured if they perform any follow-up actions.
      if (this.session && this.session.previousSessionId) {
        return true;
      }

      // See note above re: session start needs to reflect the most recent
      // checkout.
      if (this.recordingMode === 'error' && this.session && this._context.earliestEvent) {
        this.session.started = this._context.earliestEvent;
        this._maybeSaveSession();
      }

      // Flush immediately so that we do not miss the first segment, otherwise
      // it can prevent loading on the UI. This will cause an increase in short
      // replays (e.g. opening and closing a tab quickly), but these can be
      // filtered on the UI.
      if (this.recordingMode === 'session') {
        void this.flushImmediate();
      }

      return true;
    });
  };}

  /**
   * Handle when visibility of the page content changes. Opening a new tab will
   * cause the state to change to hidden because of content of current page will
   * be hidden. Likewise, moving a different window to cover the contents of the
   * page will also trigger a change to a hidden state.
   */
   __init13() {this._handleVisibilityChange = () => {
    if (esm_WINDOW.document.visibilityState === 'visible') {
      this._doChangeToForegroundTasks();
    } else {
      this._doChangeToBackgroundTasks();
    }
  };}

  /**
   * Handle when page is blurred
   */
   __init14() {this._handleWindowBlur = () => {
    const breadcrumb = createBreadcrumb({
      category: 'ui.blur',
    });

    // Do not count blur as a user action -- it's part of the process of them
    // leaving the page
    this._doChangeToBackgroundTasks(breadcrumb);
  };}

  /**
   * Handle when page is focused
   */
   __init15() {this._handleWindowFocus = () => {
    const breadcrumb = createBreadcrumb({
      category: 'ui.focus',
    });

    // Do not count focus as a user action -- instead wait until they focus and
    // interactive with page
    this._doChangeToForegroundTasks(breadcrumb);
  };}

  /**
   * Handler for Sentry Core SDK events.
   *
   * These events will create breadcrumb-like objects in the recording.
   */
   __init16() {this._handleCoreBreadcrumbListener =
    (type) =>
    (handlerData) => {
      if (!this._isEnabled) {
        return;
      }

      const result = breadcrumbHandler(type, handlerData);

      if (result === null) {
        return;
      }

      if (result.category === 'sentry.transaction') {
        return;
      }

      if (result.category === 'ui.click') {
        this.triggerUserActivity();
      } else {
        this._checkAndHandleExpiredSession();
      }

      this.addUpdate(() => {
        void addEvent(this, {
          type: EventType.Custom,
          // TODO: We were converting from ms to seconds for breadcrumbs, spans,
          // but maybe we should just keep them as milliseconds
          timestamp: (result.timestamp || 0) * 1000,
          data: {
            tag: 'breadcrumb',
            payload: result,
          },
        });

        // Do not flush after console log messages
        return result.category === 'console';
      });
    };}

  /**
   * Tasks to run when we consider a page to be hidden (via blurring and/or visibility)
   */
   _doChangeToBackgroundTasks(breadcrumb) {
    if (!this.session) {
      return;
    }

    const expired = isSessionExpired(this.session, VISIBILITY_CHANGE_TIMEOUT);

    if (breadcrumb && !expired) {
      this._createCustomBreadcrumb(breadcrumb);
    }

    // Send replay when the page/tab becomes hidden. There is no reason to send
    // replay if it becomes visible, since no actions we care about were done
    // while it was hidden
    this._conditionalFlush();
  }

  /**
   * Tasks to run when we consider a page to be visible (via focus and/or visibility)
   */
   _doChangeToForegroundTasks(breadcrumb) {
    if (!this.session) {
      return;
    }

    const isSessionActive = this._checkAndHandleExpiredSession({
      expiry: VISIBILITY_CHANGE_TIMEOUT,
    });

    if (!isSessionActive) {
      // If the user has come back to the page within VISIBILITY_CHANGE_TIMEOUT
      // ms, we will re-use the existing session, otherwise create a new
      // session
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.log */.kg.log('[Replay] Document has become active, but session has expired');
      return;
    }

    if (breadcrumb) {
      this._createCustomBreadcrumb(breadcrumb);
    }
  }

  /**
   * Trigger rrweb to take a full snapshot which will cause this plugin to
   * create a new Replay event.
   */
   _triggerFullSnapshot() {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.log */.kg.log('[Replay] Taking full rrweb snapshot');
    record.takeFullSnapshot(true);
  }

  /**
   * Update user activity (across session lifespans)
   */
   _updateUserActivity(_lastActivity = new Date().getTime()) {
    this._lastActivity = _lastActivity;
  }

  /**
   * Updates the session's last activity timestamp
   */
   _updateSessionActivity(_lastActivity = new Date().getTime()) {
    if (this.session) {
      this.session.lastActivity = _lastActivity;
      this._maybeSaveSession();
    }
  }

  /**
   * Helper to create (and buffer) a replay breadcrumb from a core SDK breadcrumb
   */
   _createCustomBreadcrumb(breadcrumb) {
    this.addUpdate(() => {
      void addEvent(this, {
        type: EventType.Custom,
        timestamp: breadcrumb.timestamp || 0,
        data: {
          tag: 'breadcrumb',
          payload: breadcrumb,
        },
      });
    });
  }

  /**
   * Observed performance events are added to `this.performanceEvents`. These
   * are included in the replay event before it is finished and sent to Sentry.
   */
   _addPerformanceEntries() {
    // Copy and reset entries before processing
    const entries = [...this.performanceEvents];
    this.performanceEvents = [];

    return Promise.all(createPerformanceSpans(this, createPerformanceEntries(entries)));
  }

  /**
   * Checks if recording should be stopped due to user inactivity. Otherwise
   * check if session is expired and create a new session if so. Triggers a new
   * full snapshot on new session.
   *
   * Returns true if session is not expired, false otherwise.
   */
   _checkAndHandleExpiredSession({ expiry = SESSION_IDLE_DURATION } = {}) {
    const oldSessionId = this.getSessionId();

    // Prevent starting a new session if the last user activity is older than
    // MAX_SESSION_LIFE. Otherwise non-user activity can trigger a new
    // session+recording. This creates noisy replays that do not have much
    // content in them.
    if (this._lastActivity && isExpired(this._lastActivity, MAX_SESSION_LIFE)) {
      // Pause recording
      this.pause();
      return;
    }

    // --- There is recent user activity --- //
    // This will create a new session if expired, based on expiry length
    this._loadSession({ expiry });

    // Session was expired if session ids do not match
    const expired = oldSessionId !== this.getSessionId();

    if (!expired) {
      return true;
    }

    // Session is expired, trigger a full snapshot (which will create a new session)
    this._triggerFullSnapshot();

    return false;
  }

  /**
   * Only flush if `this.recordingMode === 'session'`
   */
   _conditionalFlush() {
    if (this.recordingMode === 'error') {
      return;
    }

    void this.flushImmediate();
  }

  /**
   * Clear _context
   */
   _clearContext() {
    // XXX: `initialTimestamp` and `initialUrl` do not get cleared
    this._context.errorIds.clear();
    this._context.traceIds.clear();
    this._context.urls = [];
    this._context.earliestEvent = null;
  }

  /**
   * Return and clear _context
   */
   _popEventContext() {
    if (this._context.earliestEvent && this._context.earliestEvent < this._context.initialTimestamp) {
      this._context.initialTimestamp = this._context.earliestEvent;
    }

    const _context = {
      initialTimestamp: this._context.initialTimestamp,
      initialUrl: this._context.initialUrl,
      errorIds: Array.from(this._context.errorIds).filter(Boolean),
      traceIds: Array.from(this._context.traceIds).filter(Boolean),
      urls: this._context.urls,
    };

    this._clearContext();

    return _context;
  }

  /**
   * Flushes replay event buffer to Sentry.
   *
   * Performance events are only added right before flushing - this is
   * due to the buffered performance observer events.
   *
   * Should never be called directly, only by `flush`
   */
   async _runFlush() {
    if (!this.session || !this.eventBuffer) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.error */.kg.error('[Replay] No session or eventBuffer found to flush.');
      return;
    }

    await this._addPerformanceEntries();

    // Check eventBuffer again, as it could have been stopped in the meanwhile
    if (!this.eventBuffer || !this.eventBuffer.pendingLength) {
      return;
    }

    // Only attach memory event if eventBuffer is not empty
    await addMemoryEntry(this);

    // Check eventBuffer again, as it could have been stopped in the meanwhile
    if (!this.eventBuffer) {
      return;
    }

    try {
      // Note this empties the event buffer regardless of outcome of sending replay
      const recordingData = await this.eventBuffer.finish();

      // NOTE: Copy values from instance members, as it's possible they could
      // change before the flush finishes.
      const replayId = this.session.id;
      const eventContext = this._popEventContext();
      // Always increment segmentId regardless of outcome of sending replay
      const segmentId = this.session.segmentId++;
      this._maybeSaveSession();

      await sendReplay({
        replayId,
        recordingData,
        segmentId,
        includeReplayStartTimestamp: segmentId === 0,
        eventContext,
        session: this.session,
        options: this.getOptions(),
        timestamp: new Date().getTime(),
      });
    } catch (err) {
      this._handleException(err);

      if (err instanceof RateLimitError) {
        this._handleRateLimit(err.rateLimits);
        return;
      }

      // This means we retried 3 times, and all of them failed
      // In this case, we want to completely stop the replay - otherwise, we may get inconsistent segments
      this.stop();
    }
  }

  /**
   * Flush recording data to Sentry. Creates a lock so that only a single flush
   * can be active at a time. Do not call this directly.
   */
   __init17() {this._flush = async () => {
    if (!this._isEnabled) {
      // This can happen if e.g. the replay was stopped because of exceeding the retry limit
      return;
    }

    if (!this._checkAndHandleExpiredSession()) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.error */.kg.error('[Replay] Attempting to finish replay event after session expired.');
      return;
    }

    if (!this.session) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.error */.kg.error('[Replay] No session found to flush.');
      return;
    }

    // A flush is about to happen, cancel any queued flushes
    this._debouncedFlush.cancel();

    // this._flushLock acts as a lock so that future calls to `_flush()`
    // will be blocked until this promise resolves
    if (!this._flushLock) {
      this._flushLock = this._runFlush();
      await this._flushLock;
      this._flushLock = null;
      return;
    }

    // Wait for previous flush to finish, then call the debounced `_flush()`.
    // It's possible there are other flush requests queued and waiting for it
    // to resolve. We want to reduce all outstanding requests (as well as any
    // new flush requests that occur within a second of the locked flush
    // completing) into a single flush.

    try {
      await this._flushLock;
    } catch (err) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.error */.kg.error(err);
    } finally {
      this._debouncedFlush();
    }
  };}

  /** Save the session, if it is sticky */
   _maybeSaveSession() {
    if (this.session && this._options.stickySession) {
      saveSession(this.session);
    }
  }

  /**
   * Pauses the replay and resumes it after the rate-limit duration is over.
   */
   _handleRateLimit(rateLimits) {
    // in case recording is already paused, we don't need to do anything, as we might have already paused because of a
    // rate limit
    if (this.isPaused()) {
      return;
    }

    const rateLimitEnd = disabledUntil(rateLimits, 'replay');
    const rateLimitDuration = rateLimitEnd - Date.now();

    if (rateLimitDuration > 0) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.warn */.kg.warn('[Replay]', `Rate limit hit, pausing replay for ${rateLimitDuration}ms`);
      this.pause();
      this._debouncedFlush.cancel();

      setTimeout(() => {
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.info */.kg.info('[Replay]', 'Resuming replay after rate limit');
        this.resume();
      }, rateLimitDuration);
    }
  }
}

/**
 * Returns true if we are in the browser.
 */
function isBrowser() {
  // eslint-disable-next-line no-restricted-globals
  return typeof window !== 'undefined' && (!(0,node/* isNodeEnv */.KV)() || isElectronNodeRenderer());
}

// Electron renderers with nodeIntegration enabled are detected as Node.js so we specifically test for them
function isElectronNodeRenderer() {
  return typeof process !== 'undefined' && (process ).type === 'renderer';
}

const MEDIA_SELECTORS = 'img,image,svg,path,rect,area,video,object,picture,embed,map,audio';

let _initialized = false;

/**
 * The main replay integration class, to be passed to `init({  integrations: [] })`.
 */
class Replay  {
  /**
   * @inheritDoc
   */
   static __initStatic() {this.id = 'Replay';}

  /**
   * @inheritDoc
   */
   __init() {this.name = Replay.id;}

  /**
   * Options to pass to `rrweb.record()`
   */

   constructor({
    flushMinDelay = DEFAULT_FLUSH_MIN_DELAY,
    flushMaxDelay = DEFAULT_FLUSH_MAX_DELAY,
    stickySession = true,
    useCompression = true,
    sessionSampleRate,
    errorSampleRate,
    maskAllText,
    maskTextSelector,
    maskAllInputs = true,
    blockAllMedia = true,
    _experiments = {},
    blockClass = 'sentry-block',
    ignoreClass = 'sentry-ignore',
    maskTextClass = 'sentry-mask',
    blockSelector = '[data-sentry-block]',
    ..._recordingOptions
  } = {}) {Replay.prototype.__init.call(this);
    this._recordingOptions = {
      maskAllInputs,
      blockClass,
      ignoreClass,
      maskTextClass,
      maskTextSelector,
      blockSelector,
      ..._recordingOptions,
    };

    this._options = {
      flushMinDelay,
      flushMaxDelay,
      stickySession,
      sessionSampleRate: DEFAULT_SESSION_SAMPLE_RATE,
      errorSampleRate: DEFAULT_ERROR_SAMPLE_RATE,
      useCompression,
      maskAllText: typeof maskAllText === 'boolean' ? maskAllText : !maskTextSelector,
      blockAllMedia,
      _experiments,
    };

    if (typeof sessionSampleRate === 'number') {
      // eslint-disable-next-line
      console.warn(
        `[Replay] You are passing \`sessionSampleRate\` to the Replay integration.
This option is deprecated and will be removed soon.
Instead, configure \`replaysSessionSampleRate\` directly in the SDK init options, e.g.:
Sentry.init({ replaysSessionSampleRate: ${sessionSampleRate} })`,
      );

      this._options.sessionSampleRate = sessionSampleRate;
    }

    if (typeof errorSampleRate === 'number') {
      // eslint-disable-next-line
      console.warn(
        `[Replay] You are passing \`errorSampleRate\` to the Replay integration.
This option is deprecated and will be removed soon.
Instead, configure \`replaysOnErrorSampleRate\` directly in the SDK init options, e.g.:
Sentry.init({ replaysOnErrorSampleRate: ${errorSampleRate} })`,
      );

      this._options.errorSampleRate = errorSampleRate;
    }

    if (this._options.maskAllText) {
      // `maskAllText` is a more user friendly option to configure
      // `maskTextSelector`. This means that all nodes will have their text
      // content masked.
      this._recordingOptions.maskTextSelector = MASK_ALL_TEXT_SELECTOR;
    }

    if (this._options.blockAllMedia) {
      // `blockAllMedia` is a more user friendly option to configure blocking
      // embedded media elements
      this._recordingOptions.blockSelector = !this._recordingOptions.blockSelector
        ? MEDIA_SELECTORS
        : `${this._recordingOptions.blockSelector},${MEDIA_SELECTORS}`;
    }

    if (this._isInitialized && isBrowser()) {
      throw new Error('Multiple Sentry Session Replay instances are not supported');
    }

    this._isInitialized = true;
  }

  /** If replay has already been initialized */
   get _isInitialized() {
    return _initialized;
  }

  /** Update _isInitialized */
   set _isInitialized(value) {
    _initialized = value;
  }

  /**
   * We previously used to create a transaction in `setupOnce` and it would
   * potentially create a transaction before some native SDK integrations have run
   * and applied their own global event processor. An example is:
   * https://github.com/getsentry/sentry-javascript/blob/b47ceafbdac7f8b99093ce6023726ad4687edc48/packages/browser/src/integrations/useragent.ts
   *
   * So we call `replay.setup` in next event loop as a workaround to wait for other
   * global event processors to finish. This is no longer needed, but keeping it
   * here to avoid any future issues.
   */
   setupOnce() {
    if (!isBrowser()) {
      return;
    }

    this._setup();

    // XXX: See method comments above
    setTimeout(() => this.start());
  }

  /**
   * Initializes the plugin.
   *
   * Creates or loads a session, attaches listeners to varying events (DOM,
   * PerformanceObserver, Recording, Sentry SDK, etc)
   */
   start() {
    if (!this._replay) {
      return;
    }

    this._replay.start();
  }

  /**
   * Currently, this needs to be manually called (e.g. for tests). Sentry SDK
   * does not support a teardown
   */
   stop() {
    if (!this._replay) {
      return;
    }

    this._replay.stop();
  }

  /**
   * Immediately send all pending events.
   */
   flush() {
    if (!this._replay || !this._replay.isEnabled()) {
      return;
    }

    return this._replay.flushImmediate();
  }

  /** Setup the integration. */
   _setup() {
    // Client is not available in constructor, so we need to wait until setupOnce
    this._loadReplayOptionsFromClient();

    this._replay = new ReplayContainer({
      options: this._options,
      recordingOptions: this._recordingOptions,
    });
  }

  /** Parse Replay-related options from SDK options */
   _loadReplayOptionsFromClient() {
    const client = (0,esm_hub/* getCurrentHub */.Gd)().getClient();
    const opt = client && (client.getOptions() );

    if (opt && typeof opt.replaysSessionSampleRate === 'number') {
      this._options.sessionSampleRate = opt.replaysSessionSampleRate;
    }

    if (opt && typeof opt.replaysOnErrorSampleRate === 'number') {
      this._options.errorSampleRate = opt.replaysOnErrorSampleRate;
    }
  }
} Replay.__initStatic();


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ../../.yarn/cache/@sentry-browser-npm-7.32.1-b5270a3b99-279b2bfb32.zip/node_modules/@sentry/browser/esm/index.js



















let windowIntegrations = {};

// This block is needed to add compatibility with the integrations packages when used with a CDN
if (helpers_WINDOW.Sentry && helpers_WINDOW.Sentry.Integrations) {
  windowIntegrations = helpers_WINDOW.Sentry.Integrations;
}

const INTEGRATIONS = {
  ...windowIntegrations,
  ...integrations_namespaceObject,
  ...esm_integrations_namespaceObject,
};
// __ROLLUP_EXCLUDE_FROM_BUNDLES_END__


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@sentry-react-virtual-3e0200223d/0/cache/@sentry-react-npm-7.32.1-bc2e0ddf02-3e67b9b9c9.zip/node_modules/@sentry/react/esm/index.js








//# sourceMappingURL=index.js.map

// EXTERNAL MODULE: ../../.yarn/cache/@sentry-tracing-npm-7.32.1-60cc6371d2-b62b9cc4d4.zip/node_modules/@sentry/tracing/esm/hubextensions.js + 1 modules
var hubextensions = __webpack_require__(43157);
;// CONCATENATED MODULE: ../../.yarn/cache/@sentry-utils-npm-7.32.1-c99d3811fa-1b0d82cbcc.zip/node_modules/@sentry/utils/esm/tracing.js
const TRACEPARENT_REGEXP = new RegExp(
  '^[ \\t]*' + // whitespace
    '([0-9a-f]{32})?' + // trace_id
    '-?([0-9a-f]{16})?' + // span_id
    '-?([01])?' + // sampled
    '[ \\t]*$', // whitespace
);

/**
 * Extract transaction context data from a `sentry-trace` header.
 *
 * @param traceparent Traceparent string
 *
 * @returns Object containing data from the header, or undefined if traceparent string is malformed
 */
function extractTraceparentData(traceparent) {
  const matches = traceparent.match(TRACEPARENT_REGEXP);

  if (!traceparent || !matches) {
    // empty string or no matches is invalid traceparent data
    return undefined;
  }

  let parentSampled;
  if (matches[3] === '1') {
    parentSampled = true;
  } else if (matches[3] === '0') {
    parentSampled = false;
  }

  return {
    traceId: matches[1],
    parentSampled,
    parentSpanId: matches[2],
  };
}


//# sourceMappingURL=tracing.js.map

;// CONCATENATED MODULE: ../../.yarn/cache/@sentry-utils-npm-7.32.1-c99d3811fa-1b0d82cbcc.zip/node_modules/@sentry/utils/esm/baggage.js



const BAGGAGE_HEADER_NAME = 'baggage';

const SENTRY_BAGGAGE_KEY_PREFIX = 'sentry-';

const SENTRY_BAGGAGE_KEY_PREFIX_REGEX = /^sentry-/;

/**
 * Max length of a serialized baggage string
 *
 * https://www.w3.org/TR/baggage/#limits
 */
const MAX_BAGGAGE_STRING_LENGTH = 8192;

/**
 * Takes a baggage header and turns it into Dynamic Sampling Context, by extracting all the "sentry-" prefixed values
 * from it.
 *
 * @param baggageHeader A very bread definition of a baggage header as it might appear in various frameworks.
 * @returns The Dynamic Sampling Context that was found on `baggageHeader`, if there was any, `undefined` otherwise.
 */
function baggageHeaderToDynamicSamplingContext(
  // Very liberal definition of what any incoming header might look like
  baggageHeader,
) {
  if (!(0,is/* isString */.HD)(baggageHeader) && !Array.isArray(baggageHeader)) {
    return undefined;
  }

  // Intermediary object to store baggage key value pairs of incoming baggage headers on.
  // It is later used to read Sentry-DSC-values from.
  let baggageObject = {};

  if (Array.isArray(baggageHeader)) {
    // Combine all baggage headers into one object containing the baggage values so we can later read the Sentry-DSC-values from it
    baggageObject = baggageHeader.reduce((acc, curr) => {
      const currBaggageObject = baggageHeaderToObject(curr);
      return {
        ...acc,
        ...currBaggageObject,
      };
    }, {});
  } else {
    // Return undefined if baggage header is an empty string (technically an empty baggage header is not spec conform but
    // this is how we choose to handle it)
    if (!baggageHeader) {
      return undefined;
    }

    baggageObject = baggageHeaderToObject(baggageHeader);
  }

  // Read all "sentry-" prefixed values out of the baggage object and put it onto a dynamic sampling context object.
  const dynamicSamplingContext = Object.entries(baggageObject).reduce((acc, [key, value]) => {
    if (key.match(SENTRY_BAGGAGE_KEY_PREFIX_REGEX)) {
      const nonPrefixedKey = key.slice(SENTRY_BAGGAGE_KEY_PREFIX.length);
      acc[nonPrefixedKey] = value;
    }
    return acc;
  }, {});

  // Only return a dynamic sampling context object if there are keys in it.
  // A keyless object means there were no sentry values on the header, which means that there is no DSC.
  if (Object.keys(dynamicSamplingContext).length > 0) {
    return dynamicSamplingContext ;
  } else {
    return undefined;
  }
}

/**
 * Turns a Dynamic Sampling Object into a baggage header by prefixing all the keys on the object with "sentry-".
 *
 * @param dynamicSamplingContext The Dynamic Sampling Context to turn into a header. For convenience and compatibility
 * with the `getDynamicSamplingContext` method on the Transaction class ,this argument can also be `undefined`. If it is
 * `undefined` the function will return `undefined`.
 * @returns a baggage header, created from `dynamicSamplingContext`, or `undefined` either if `dynamicSamplingContext`
 * was `undefined`, or if `dynamicSamplingContext` didn't contain any values.
 */
function dynamicSamplingContextToSentryBaggageHeader(
  // this also takes undefined for convenience and bundle size in other places
  dynamicSamplingContext,
) {
  // Prefix all DSC keys with "sentry-" and put them into a new object
  const sentryPrefixedDSC = Object.entries(dynamicSamplingContext).reduce(
    (acc, [dscKey, dscValue]) => {
      if (dscValue) {
        acc[`${SENTRY_BAGGAGE_KEY_PREFIX}${dscKey}`] = dscValue;
      }
      return acc;
    },
    {},
  );

  return objectToBaggageHeader(sentryPrefixedDSC);
}

/**
 * Will parse a baggage header, which is a simple key-value map, into a flat object.
 *
 * @param baggageHeader The baggage header to parse.
 * @returns a flat object containing all the key-value pairs from `baggageHeader`.
 */
function baggageHeaderToObject(baggageHeader) {
  return baggageHeader
    .split(',')
    .map(baggageEntry => baggageEntry.split('=').map(keyOrValue => decodeURIComponent(keyOrValue.trim())))
    .reduce((acc, [key, value]) => {
      acc[key] = value;
      return acc;
    }, {});
}

/**
 * Turns a flat object (key-value pairs) into a baggage header, which is also just key-value pairs.
 *
 * @param object The object to turn into a baggage header.
 * @returns a baggage header string, or `undefined` if the object didn't have any values, since an empty baggage header
 * is not spec compliant.
 */
function objectToBaggageHeader(object) {
  if (Object.keys(object).length === 0) {
    // An empty baggage header is not spec compliant: We return undefined.
    return undefined;
  }

  return Object.entries(object).reduce((baggageHeader, [objectKey, objectValue], currentIndex) => {
    const baggageEntry = `${encodeURIComponent(objectKey)}=${encodeURIComponent(objectValue)}`;
    const newBaggageHeader = currentIndex === 0 ? baggageEntry : `${baggageHeader},${baggageEntry}`;
    if (newBaggageHeader.length > MAX_BAGGAGE_STRING_LENGTH) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
        esm_logger/* logger.warn */.kg.warn(
          `Not adding key: ${objectKey} with val: ${objectValue} to baggage header due to exceeding baggage size limits.`,
        );
      return baggageHeader;
    } else {
      return newBaggageHeader;
    }
  }, '');
}


//# sourceMappingURL=baggage.js.map

// EXTERNAL MODULE: ../../.yarn/cache/@sentry-tracing-npm-7.32.1-60cc6371d2-b62b9cc4d4.zip/node_modules/@sentry/tracing/esm/idletransaction.js
var idletransaction = __webpack_require__(23511);
// EXTERNAL MODULE: ../../.yarn/cache/@sentry-tracing-npm-7.32.1-60cc6371d2-b62b9cc4d4.zip/node_modules/@sentry/tracing/esm/utils.js
var utils = __webpack_require__(25808);
;// CONCATENATED MODULE: ../../.yarn/cache/@sentry-tracing-npm-7.32.1-60cc6371d2-b62b9cc4d4.zip/node_modules/@sentry/tracing/esm/browser/types.js


const types_WINDOW = worldwide/* GLOBAL_OBJ */.n2 ;


//# sourceMappingURL=types.js.map

;// CONCATENATED MODULE: ../../.yarn/cache/@sentry-tracing-npm-7.32.1-60cc6371d2-b62b9cc4d4.zip/node_modules/@sentry/tracing/esm/browser/backgroundtab.js




/**
 * Add a listener that cancels and finishes a transaction when the global
 * document is hidden.
 */
function registerBackgroundTabDetection() {
  if (types_WINDOW && types_WINDOW.document) {
    types_WINDOW.document.addEventListener('visibilitychange', () => {
      const activeTransaction = (0,utils/* getActiveTransaction */.x1)() ;
      if (types_WINDOW.document.hidden && activeTransaction) {
        const statusType = 'cancelled';

        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
          esm_logger/* logger.log */.kg.log(
            `[Tracing] Transaction: ${statusType} -> since tab moved to the background, op: ${activeTransaction.op}`,
          );
        // We should not set status if it is already set, this prevent important statuses like
        // error or data loss from being overwritten on transaction.
        if (!activeTransaction.status) {
          activeTransaction.setStatus(statusType);
        }
        activeTransaction.setTag('visibilitychange', 'document.hidden');
        activeTransaction.finish();
      }
    });
  } else {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
      esm_logger/* logger.warn */.kg.warn('[Tracing] Could not set up background tab detection due to lack of global document');
  }
}


//# sourceMappingURL=backgroundtab.js.map

;// CONCATENATED MODULE: ../../.yarn/cache/@sentry-tracing-npm-7.32.1-60cc6371d2-b62b9cc4d4.zip/node_modules/@sentry/tracing/esm/browser/web-vitals/lib/bindReporter.js
const bindReporter = (
  callback,
  metric,
  reportAllChanges,
) => {
  let prevValue;
  let delta;
  return (forceReport) => {
    if (metric.value >= 0) {
      if (forceReport || reportAllChanges) {
        delta = metric.value - (prevValue || 0);

        // Report the metric if there's a non-zero delta or if no previous
        // value exists (which can happen in the case of the document becoming
        // hidden when the metric value is 0).
        // See: https://github.com/GoogleChrome/web-vitals/issues/14
        if (delta || prevValue === undefined) {
          prevValue = metric.value;
          metric.delta = delta;
          callback(metric);
        }
      }
    }
  };
};


//# sourceMappingURL=bindReporter.js.map

;// CONCATENATED MODULE: ../../.yarn/cache/@sentry-tracing-npm-7.32.1-60cc6371d2-b62b9cc4d4.zip/node_modules/@sentry/tracing/esm/browser/web-vitals/lib/generateUniqueID.js
/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * Performantly generate a unique, 30-char string by combining a version
 * number, the current timestamp with a 13-digit number integer.
 * @return {string}
 */
const generateUniqueID = () => {
  return `v3-${Date.now()}-${Math.floor(Math.random() * (9e12 - 1)) + 1e12}`;
};


//# sourceMappingURL=generateUniqueID.js.map

;// CONCATENATED MODULE: ../../.yarn/cache/@sentry-tracing-npm-7.32.1-60cc6371d2-b62b9cc4d4.zip/node_modules/@sentry/tracing/esm/browser/web-vitals/lib/getNavigationEntry.js


/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

const getNavigationEntryFromPerformanceTiming = () => {
  // eslint-disable-next-line deprecation/deprecation
  const timing = types_WINDOW.performance.timing;
  // eslint-disable-next-line deprecation/deprecation
  const type = types_WINDOW.performance.navigation.type;

  const navigationEntry = {
    entryType: 'navigation',
    startTime: 0,
    type: type == 2 ? 'back_forward' : type === 1 ? 'reload' : 'navigate',
  };

  for (const key in timing) {
    if (key !== 'navigationStart' && key !== 'toJSON') {
      navigationEntry[key] = Math.max((timing[key ] ) - timing.navigationStart, 0);
    }
  }
  return navigationEntry ;
};

const getNavigationEntry = () => {
  if (types_WINDOW.__WEB_VITALS_POLYFILL__) {
    return (
      types_WINDOW.performance &&
      ((performance.getEntriesByType && performance.getEntriesByType('navigation')[0]) ||
        getNavigationEntryFromPerformanceTiming())
    );
  } else {
    return types_WINDOW.performance && performance.getEntriesByType && performance.getEntriesByType('navigation')[0];
  }
};


//# sourceMappingURL=getNavigationEntry.js.map

;// CONCATENATED MODULE: ../../.yarn/cache/@sentry-tracing-npm-7.32.1-60cc6371d2-b62b9cc4d4.zip/node_modules/@sentry/tracing/esm/browser/web-vitals/lib/getActivationStart.js


/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

const getActivationStart = () => {
  const navEntry = getNavigationEntry();
  return (navEntry && navEntry.activationStart) || 0;
};


//# sourceMappingURL=getActivationStart.js.map

;// CONCATENATED MODULE: ../../.yarn/cache/@sentry-tracing-npm-7.32.1-60cc6371d2-b62b9cc4d4.zip/node_modules/@sentry/tracing/esm/browser/web-vitals/lib/initMetric.js





/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

const initMetric = (name, value) => {
  const navEntry = getNavigationEntry();
  let navigationType = 'navigate';

  if (navEntry) {
    if (types_WINDOW.document.prerendering || getActivationStart() > 0) {
      navigationType = 'prerender';
    } else {
      navigationType = navEntry.type.replace(/_/g, '-') ;
    }
  }

  return {
    name,
    value: typeof value === 'undefined' ? -1 : value,
    rating: 'good', // Will be updated if the value changes.
    delta: 0,
    entries: [],
    id: generateUniqueID(),
    navigationType,
  };
};


//# sourceMappingURL=initMetric.js.map

;// CONCATENATED MODULE: ../../.yarn/cache/@sentry-tracing-npm-7.32.1-60cc6371d2-b62b9cc4d4.zip/node_modules/@sentry/tracing/esm/browser/web-vitals/lib/observe.js
/**
 * Takes a performance entry type and a callback function, and creates a
 * `PerformanceObserver` instance that will observe the specified entry type
 * with buffering enabled and call the callback _for each entry_.
 *
 * This function also feature-detects entry support and wraps the logic in a
 * try/catch to avoid errors in unsupporting browsers.
 */
const observe = (
  type,
  callback,
  opts,
) => {
  try {
    if (PerformanceObserver.supportedEntryTypes.includes(type)) {
      const po = new PerformanceObserver(list => {
        callback(list.getEntries() );
      });
      po.observe(
        Object.assign(
          {
            type,
            buffered: true,
          },
          opts || {},
        ) ,
      );
      return po;
    }
  } catch (e) {
    // Do nothing.
  }
  return;
};


//# sourceMappingURL=observe.js.map

;// CONCATENATED MODULE: ../../.yarn/cache/@sentry-tracing-npm-7.32.1-60cc6371d2-b62b9cc4d4.zip/node_modules/@sentry/tracing/esm/browser/web-vitals/lib/onHidden.js


/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

const onHidden = (cb, once) => {
  const onHiddenOrPageHide = (event) => {
    if (event.type === 'pagehide' || types_WINDOW.document.visibilityState === 'hidden') {
      cb(event);
      if (once) {
        removeEventListener('visibilitychange', onHiddenOrPageHide, true);
        removeEventListener('pagehide', onHiddenOrPageHide, true);
      }
    }
  };
  addEventListener('visibilitychange', onHiddenOrPageHide, true);
  // Some browsers have buggy implementations of visibilitychange,
  // so we use pagehide in addition, just to be safe.
  addEventListener('pagehide', onHiddenOrPageHide, true);
};


//# sourceMappingURL=onHidden.js.map

;// CONCATENATED MODULE: ../../.yarn/cache/@sentry-tracing-npm-7.32.1-60cc6371d2-b62b9cc4d4.zip/node_modules/@sentry/tracing/esm/browser/web-vitals/getCLS.js





/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * Calculates the [CLS](https://web.dev/cls/) value for the current page and
 * calls the `callback` function once the value is ready to be reported, along
 * with all `layout-shift` performance entries that were used in the metric
 * value calculation. The reported value is a `double` (corresponding to a
 * [layout shift score](https://web.dev/cls/#layout-shift-score)).
 *
 * If the `reportAllChanges` configuration option is set to `true`, the
 * `callback` function will be called as soon as the value is initially
 * determined as well as any time the value changes throughout the page
 * lifespan.
 *
 * _**Important:** CLS should be continually monitored for changes throughout
 * the entire lifespan of a page—including if the user returns to the page after
 * it's been hidden/backgrounded. However, since browsers often [will not fire
 * additional callbacks once the user has backgrounded a
 * page](https://developer.chrome.com/blog/page-lifecycle-api/#advice-hidden),
 * `callback` is always called when the page's visibility state changes to
 * hidden. As a result, the `callback` function might be called multiple times
 * during the same page load._
 */
const onCLS = (onReport) => {
  const metric = initMetric('CLS', 0);
  let report;

  let sessionValue = 0;
  let sessionEntries = [];

  // const handleEntries = (entries: Metric['entries']) => {
  const handleEntries = (entries) => {
    entries.forEach(entry => {
      // Only count layout shifts without recent user input.
      if (!entry.hadRecentInput) {
        const firstSessionEntry = sessionEntries[0];
        const lastSessionEntry = sessionEntries[sessionEntries.length - 1];

        // If the entry occurred less than 1 second after the previous entry and
        // less than 5 seconds after the first entry in the session, include the
        // entry in the current session. Otherwise, start a new session.
        if (
          sessionValue &&
          sessionEntries.length !== 0 &&
          entry.startTime - lastSessionEntry.startTime < 1000 &&
          entry.startTime - firstSessionEntry.startTime < 5000
        ) {
          sessionValue += entry.value;
          sessionEntries.push(entry);
        } else {
          sessionValue = entry.value;
          sessionEntries = [entry];
        }

        // If the current session value is larger than the current CLS value,
        // update CLS and the entries contributing to it.
        if (sessionValue > metric.value) {
          metric.value = sessionValue;
          metric.entries = sessionEntries;
          if (report) {
            report();
          }
        }
      }
    });
  };

  const po = observe('layout-shift', handleEntries);
  if (po) {
    report = bindReporter(onReport, metric);

    onHidden(() => {
      handleEntries(po.takeRecords() );
      report(true);
    });
  }
};


//# sourceMappingURL=getCLS.js.map

;// CONCATENATED MODULE: ../../.yarn/cache/@sentry-tracing-npm-7.32.1-60cc6371d2-b62b9cc4d4.zip/node_modules/@sentry/tracing/esm/browser/web-vitals/lib/getVisibilityWatcher.js



/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

let firstHiddenTime = -1;

const initHiddenTime = () => {
  // If the document is hidden and not prerendering, assume it was always
  // hidden and the page was loaded in the background.
  return types_WINDOW.document.visibilityState === 'hidden' && !types_WINDOW.document.prerendering ? 0 : Infinity;
};

const trackChanges = () => {
  // Update the time if/when the document becomes hidden.
  onHidden(({ timeStamp }) => {
    firstHiddenTime = timeStamp;
  }, true);
};

const getVisibilityWatcher = (

) => {
  if (firstHiddenTime < 0) {
    // If the document is hidden when this code runs, assume it was hidden
    // since navigation start. This isn't a perfect heuristic, but it's the
    // best we can do until an API is available to support querying past
    // visibilityState.
    firstHiddenTime = initHiddenTime();
    trackChanges();
  }
  return {
    get firstHiddenTime() {
      return firstHiddenTime;
    },
  };
};


//# sourceMappingURL=getVisibilityWatcher.js.map

;// CONCATENATED MODULE: ../../.yarn/cache/@sentry-tracing-npm-7.32.1-60cc6371d2-b62b9cc4d4.zip/node_modules/@sentry/tracing/esm/browser/web-vitals/getFID.js






/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * Calculates the [FID](https://web.dev/fid/) value for the current page and
 * calls the `callback` function once the value is ready, along with the
 * relevant `first-input` performance entry used to determine the value. The
 * reported value is a `DOMHighResTimeStamp`.
 *
 * _**Important:** since FID is only reported after the user interacts with the
 * page, it's possible that it will not be reported for some page loads._
 */
const onFID = (onReport) => {
  const visibilityWatcher = getVisibilityWatcher();
  const metric = initMetric('FID');
  // eslint-disable-next-line prefer-const
  let report;

  const handleEntry = (entry) => {
    // Only report if the page wasn't hidden prior to the first input.
    if (entry.startTime < visibilityWatcher.firstHiddenTime) {
      metric.value = entry.processingStart - entry.startTime;
      metric.entries.push(entry);
      report(true);
    }
  };

  const handleEntries = (entries) => {
    (entries ).forEach(handleEntry);
  };

  const po = observe('first-input', handleEntries);
  report = bindReporter(onReport, metric);

  if (po) {
    onHidden(() => {
      handleEntries(po.takeRecords() );
      po.disconnect();
    }, true);
  }
};


//# sourceMappingURL=getFID.js.map

;// CONCATENATED MODULE: ../../.yarn/cache/@sentry-tracing-npm-7.32.1-60cc6371d2-b62b9cc4d4.zip/node_modules/@sentry/tracing/esm/browser/web-vitals/getLCP.js







/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

const reportedMetricIDs = {};

/**
 * Calculates the [LCP](https://web.dev/lcp/) value for the current page and
 * calls the `callback` function once the value is ready (along with the
 * relevant `largest-contentful-paint` performance entry used to determine the
 * value). The reported value is a `DOMHighResTimeStamp`.
 */
const onLCP = (onReport) => {
  const visibilityWatcher = getVisibilityWatcher();
  const metric = initMetric('LCP');
  let report;

  const handleEntries = (entries) => {
    const lastEntry = entries[entries.length - 1] ;
    if (lastEntry) {
      // The startTime attribute returns the value of the renderTime if it is
      // not 0, and the value of the loadTime otherwise. The activationStart
      // reference is used because LCP should be relative to page activation
      // rather than navigation start if the page was prerendered.
      const value = Math.max(lastEntry.startTime - getActivationStart(), 0);

      // Only report if the page wasn't hidden prior to LCP.
      if (value < visibilityWatcher.firstHiddenTime) {
        metric.value = value;
        metric.entries = [lastEntry];
        report();
      }
    }
  };

  const po = observe('largest-contentful-paint', handleEntries);

  if (po) {
    report = bindReporter(onReport, metric);

    const stopListening = () => {
      if (!reportedMetricIDs[metric.id]) {
        handleEntries(po.takeRecords() );
        po.disconnect();
        reportedMetricIDs[metric.id] = true;
        report(true);
      }
    };

    // Stop listening after input. Note: while scrolling is an input that
    // stop LCP observation, it's unreliable since it can be programmatically
    // generated. See: https://github.com/GoogleChrome/web-vitals/issues/75
    ['keydown', 'click'].forEach(type => {
      addEventListener(type, stopListening, { once: true, capture: true });
    });

    onHidden(stopListening, true);
  }
};


//# sourceMappingURL=getLCP.js.map

;// CONCATENATED MODULE: ../../.yarn/cache/@sentry-tracing-npm-7.32.1-60cc6371d2-b62b9cc4d4.zip/node_modules/@sentry/tracing/esm/browser/metrics/utils.js
/**
 * Checks if a given value is a valid measurement value.
 */
function isMeasurementValue(value) {
  return typeof value === 'number' && isFinite(value);
}

/**
 * Helper function to start child on transactions. This function will make sure that the transaction will
 * use the start timestamp of the created child span if it is earlier than the transactions actual
 * start timestamp.
 */
function _startChild(transaction, { startTimestamp, ...ctx }) {
  if (startTimestamp && transaction.startTimestamp > startTimestamp) {
    transaction.startTimestamp = startTimestamp;
  }

  return transaction.startChild({
    startTimestamp,
    ...ctx,
  });
}


//# sourceMappingURL=utils.js.map

;// CONCATENATED MODULE: ../../.yarn/cache/@sentry-tracing-npm-7.32.1-60cc6371d2-b62b9cc4d4.zip/node_modules/@sentry/tracing/esm/browser/metrics/index.js










function getBrowserPerformanceAPI() {
  return types_WINDOW && types_WINDOW.addEventListener && types_WINDOW.performance;
}

let _performanceCursor = 0;

let _measurements = {};
let _lcpEntry;
let _clsEntry;

/**
 * Start tracking web vitals
 */
function startTrackingWebVitals() {
  const performance = getBrowserPerformanceAPI();
  if (performance && esm_time/* browserPerformanceTimeOrigin */.Z1) {
    if (performance.mark) {
      types_WINDOW.performance.mark('sentry-tracing-init');
    }
    _trackCLS();
    _trackLCP();
    _trackFID();
  }
}

/**
 * Start tracking long tasks.
 */
function startTrackingLongTasks() {
  const entryHandler = (entries) => {
    for (const entry of entries) {
      const transaction = (0,utils/* getActiveTransaction */.x1)() ;
      if (!transaction) {
        return;
      }
      const startTime = (0,utils/* msToSec */.XL)((esm_time/* browserPerformanceTimeOrigin */.Z1 ) + entry.startTime);
      const duration = (0,utils/* msToSec */.XL)(entry.duration);

      transaction.startChild({
        description: 'Main UI thread blocked',
        op: 'ui.long-task',
        startTimestamp: startTime,
        endTimestamp: startTime + duration,
      });
    }
  };

  observe('longtask', entryHandler);
}

/** Starts tracking the Cumulative Layout Shift on the current page. */
function _trackCLS() {
  // See:
  // https://web.dev/evolving-cls/
  // https://web.dev/cls-web-tooling/
  onCLS(metric => {
    const entry = metric.entries.pop();
    if (!entry) {
      return;
    }

    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.log */.kg.log('[Measurements] Adding CLS');
    _measurements['cls'] = { value: metric.value, unit: '' };
    _clsEntry = entry ;
  });
}

/** Starts tracking the Largest Contentful Paint on the current page. */
function _trackLCP() {
  onLCP(metric => {
    const entry = metric.entries.pop();
    if (!entry) {
      return;
    }

    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.log */.kg.log('[Measurements] Adding LCP');
    _measurements['lcp'] = { value: metric.value, unit: 'millisecond' };
    _lcpEntry = entry ;
  });
}

/** Starts tracking the First Input Delay on the current page. */
function _trackFID() {
  onFID(metric => {
    const entry = metric.entries.pop();
    if (!entry) {
      return;
    }

    const timeOrigin = (0,utils/* msToSec */.XL)(esm_time/* browserPerformanceTimeOrigin */.Z1 );
    const startTime = (0,utils/* msToSec */.XL)(entry.startTime);
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.log */.kg.log('[Measurements] Adding FID');
    _measurements['fid'] = { value: metric.value, unit: 'millisecond' };
    _measurements['mark.fid'] = { value: timeOrigin + startTime, unit: 'second' };
  });
}

/** Add performance related spans to a transaction */
function addPerformanceEntries(transaction) {
  const performance = getBrowserPerformanceAPI();
  if (!performance || !types_WINDOW.performance.getEntries || !esm_time/* browserPerformanceTimeOrigin */.Z1) {
    // Gatekeeper if performance API not available
    return;
  }

  (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.log */.kg.log('[Tracing] Adding & adjusting spans using Performance API');
  const timeOrigin = (0,utils/* msToSec */.XL)(esm_time/* browserPerformanceTimeOrigin */.Z1);

  const performanceEntries = performance.getEntries();

  let responseStartTimestamp;
  let requestStartTimestamp;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  performanceEntries.slice(_performanceCursor).forEach((entry) => {
    const startTime = (0,utils/* msToSec */.XL)(entry.startTime);
    const duration = (0,utils/* msToSec */.XL)(entry.duration);

    if (transaction.op === 'navigation' && timeOrigin + startTime < transaction.startTimestamp) {
      return;
    }

    switch (entry.entryType) {
      case 'navigation': {
        _addNavigationSpans(transaction, entry, timeOrigin);
        responseStartTimestamp = timeOrigin + (0,utils/* msToSec */.XL)(entry.responseStart);
        requestStartTimestamp = timeOrigin + (0,utils/* msToSec */.XL)(entry.requestStart);
        break;
      }
      case 'mark':
      case 'paint':
      case 'measure': {
        _addMeasureSpans(transaction, entry, startTime, duration, timeOrigin);

        // capture web vitals
        const firstHidden = getVisibilityWatcher();
        // Only report if the page wasn't hidden prior to the web vital.
        const shouldRecord = entry.startTime < firstHidden.firstHiddenTime;

        if (entry.name === 'first-paint' && shouldRecord) {
          (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.log */.kg.log('[Measurements] Adding FP');
          _measurements['fp'] = { value: entry.startTime, unit: 'millisecond' };
        }
        if (entry.name === 'first-contentful-paint' && shouldRecord) {
          (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.log */.kg.log('[Measurements] Adding FCP');
          _measurements['fcp'] = { value: entry.startTime, unit: 'millisecond' };
        }
        break;
      }
      case 'resource': {
        const resourceName = (entry.name ).replace(types_WINDOW.location.origin, '');
        _addResourceSpans(transaction, entry, resourceName, startTime, duration, timeOrigin);
        break;
      }
      // Ignore other entry types.
    }
  });

  _performanceCursor = Math.max(performanceEntries.length - 1, 0);

  _trackNavigator(transaction);

  // Measurements are only available for pageload transactions
  if (transaction.op === 'pageload') {
    // Generate TTFB (Time to First Byte), which measured as the time between the beginning of the transaction and the
    // start of the response in milliseconds
    if (typeof responseStartTimestamp === 'number') {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.log */.kg.log('[Measurements] Adding TTFB');
      _measurements['ttfb'] = {
        value: (responseStartTimestamp - transaction.startTimestamp) * 1000,
        unit: 'millisecond',
      };

      if (typeof requestStartTimestamp === 'number' && requestStartTimestamp <= responseStartTimestamp) {
        // Capture the time spent making the request and receiving the first byte of the response.
        // This is the time between the start of the request and the start of the response in milliseconds.
        _measurements['ttfb.requestTime'] = {
          value: (responseStartTimestamp - requestStartTimestamp) * 1000,
          unit: 'millisecond',
        };
      }
    }

    ['fcp', 'fp', 'lcp'].forEach(name => {
      if (!_measurements[name] || timeOrigin >= transaction.startTimestamp) {
        return;
      }
      // The web vitals, fcp, fp, lcp, and ttfb, all measure relative to timeOrigin.
      // Unfortunately, timeOrigin is not captured within the transaction span data, so these web vitals will need
      // to be adjusted to be relative to transaction.startTimestamp.
      const oldValue = _measurements[name].value;
      const measurementTimestamp = timeOrigin + (0,utils/* msToSec */.XL)(oldValue);

      // normalizedValue should be in milliseconds
      const normalizedValue = Math.abs((measurementTimestamp - transaction.startTimestamp) * 1000);
      const delta = normalizedValue - oldValue;

      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
        esm_logger/* logger.log */.kg.log(`[Measurements] Normalized ${name} from ${oldValue} to ${normalizedValue} (${delta})`);
      _measurements[name].value = normalizedValue;
    });

    const fidMark = _measurements['mark.fid'];
    if (fidMark && _measurements['fid']) {
      // create span for FID
      _startChild(transaction, {
        description: 'first input delay',
        endTimestamp: fidMark.value + (0,utils/* msToSec */.XL)(_measurements['fid'].value),
        op: 'ui.action',
        startTimestamp: fidMark.value,
      });

      // Delete mark.fid as we don't want it to be part of final payload
      delete _measurements['mark.fid'];
    }

    // If FCP is not recorded we should not record the cls value
    // according to the new definition of CLS.
    if (!('fcp' in _measurements)) {
      delete _measurements.cls;
    }

    Object.keys(_measurements).forEach(measurementName => {
      transaction.setMeasurement(
        measurementName,
        _measurements[measurementName].value,
        _measurements[measurementName].unit,
      );
    });

    _tagMetricInfo(transaction);
  }

  _lcpEntry = undefined;
  _clsEntry = undefined;
  _measurements = {};
}

/** Create measure related spans */
function _addMeasureSpans(
  transaction,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  entry,
  startTime,
  duration,
  timeOrigin,
) {
  const measureStartTimestamp = timeOrigin + startTime;
  const measureEndTimestamp = measureStartTimestamp + duration;

  _startChild(transaction, {
    description: entry.name ,
    endTimestamp: measureEndTimestamp,
    op: entry.entryType ,
    startTimestamp: measureStartTimestamp,
  });

  return measureStartTimestamp;
}

/** Instrument navigation entries */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function _addNavigationSpans(transaction, entry, timeOrigin) {
  ['unloadEvent', 'redirect', 'domContentLoadedEvent', 'loadEvent', 'connect'].forEach(event => {
    _addPerformanceNavigationTiming(transaction, entry, event, timeOrigin);
  });
  _addPerformanceNavigationTiming(transaction, entry, 'secureConnection', timeOrigin, 'TLS/SSL', 'connectEnd');
  _addPerformanceNavigationTiming(transaction, entry, 'fetch', timeOrigin, 'cache', 'domainLookupStart');
  _addPerformanceNavigationTiming(transaction, entry, 'domainLookup', timeOrigin, 'DNS');
  _addRequest(transaction, entry, timeOrigin);
}

/** Create performance navigation related spans */
function _addPerformanceNavigationTiming(
  transaction,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  entry,
  event,
  timeOrigin,
  description,
  eventEnd,
) {
  const end = eventEnd ? (entry[eventEnd] ) : (entry[`${event}End`] );
  const start = entry[`${event}Start`] ;
  if (!start || !end) {
    return;
  }
  _startChild(transaction, {
    op: 'browser',
    description: description || event,
    startTimestamp: timeOrigin + (0,utils/* msToSec */.XL)(start),
    endTimestamp: timeOrigin + (0,utils/* msToSec */.XL)(end),
  });
}

/** Create request and response related spans */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function _addRequest(transaction, entry, timeOrigin) {
  _startChild(transaction, {
    op: 'browser',
    description: 'request',
    startTimestamp: timeOrigin + (0,utils/* msToSec */.XL)(entry.requestStart ),
    endTimestamp: timeOrigin + (0,utils/* msToSec */.XL)(entry.responseEnd ),
  });

  _startChild(transaction, {
    op: 'browser',
    description: 'response',
    startTimestamp: timeOrigin + (0,utils/* msToSec */.XL)(entry.responseStart ),
    endTimestamp: timeOrigin + (0,utils/* msToSec */.XL)(entry.responseEnd ),
  });
}

/** Create resource-related spans */
function _addResourceSpans(
  transaction,
  entry,
  resourceName,
  startTime,
  duration,
  timeOrigin,
) {
  // we already instrument based on fetch and xhr, so we don't need to
  // duplicate spans here.
  if (entry.initiatorType === 'xmlhttprequest' || entry.initiatorType === 'fetch') {
    return;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const data = {};
  if ('transferSize' in entry) {
    data['Transfer Size'] = entry.transferSize;
  }
  if ('encodedBodySize' in entry) {
    data['Encoded Body Size'] = entry.encodedBodySize;
  }
  if ('decodedBodySize' in entry) {
    data['Decoded Body Size'] = entry.decodedBodySize;
  }

  const startTimestamp = timeOrigin + startTime;
  const endTimestamp = startTimestamp + duration;

  _startChild(transaction, {
    description: resourceName,
    endTimestamp,
    op: entry.initiatorType ? `resource.${entry.initiatorType}` : 'resource.other',
    startTimestamp,
    data,
  });
}

/**
 * Capture the information of the user agent.
 */
function _trackNavigator(transaction) {
  const navigator = types_WINDOW.navigator ;
  if (!navigator) {
    return;
  }

  // track network connectivity
  const connection = navigator.connection;
  if (connection) {
    if (connection.effectiveType) {
      transaction.setTag('effectiveConnectionType', connection.effectiveType);
    }

    if (connection.type) {
      transaction.setTag('connectionType', connection.type);
    }

    if (isMeasurementValue(connection.rtt)) {
      _measurements['connection.rtt'] = { value: connection.rtt, unit: 'millisecond' };
    }
  }

  if (isMeasurementValue(navigator.deviceMemory)) {
    transaction.setTag('deviceMemory', `${navigator.deviceMemory} GB`);
  }

  if (isMeasurementValue(navigator.hardwareConcurrency)) {
    transaction.setTag('hardwareConcurrency', String(navigator.hardwareConcurrency));
  }
}

/** Add LCP / CLS data to transaction to allow debugging */
function _tagMetricInfo(transaction) {
  if (_lcpEntry) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.log */.kg.log('[Measurements] Adding LCP Data');

    // Capture Properties of the LCP element that contributes to the LCP.

    if (_lcpEntry.element) {
      transaction.setTag('lcp.element', (0,browser/* htmlTreeAsString */.Rt)(_lcpEntry.element));
    }

    if (_lcpEntry.id) {
      transaction.setTag('lcp.id', _lcpEntry.id);
    }

    if (_lcpEntry.url) {
      // Trim URL to the first 200 characters.
      transaction.setTag('lcp.url', _lcpEntry.url.trim().slice(0, 200));
    }

    transaction.setTag('lcp.size', _lcpEntry.size);
  }

  // See: https://developer.mozilla.org/en-US/docs/Web/API/LayoutShift
  if (_clsEntry && _clsEntry.sources) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.log */.kg.log('[Measurements] Adding CLS Data');
    _clsEntry.sources.forEach((source, index) =>
      transaction.setTag(`cls.source.${index + 1}`, (0,browser/* htmlTreeAsString */.Rt)(source.node)),
    );
  }
}


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ../../.yarn/cache/@sentry-tracing-npm-7.32.1-60cc6371d2-b62b9cc4d4.zip/node_modules/@sentry/tracing/esm/browser/request.js




/* eslint-disable max-lines */

const DEFAULT_TRACE_PROPAGATION_TARGETS = ['localhost', /^\//];

/** Options for Request Instrumentation */

const defaultRequestInstrumentationOptions = {
  traceFetch: true,
  traceXHR: true,
  // TODO (v8): Remove this property
  tracingOrigins: DEFAULT_TRACE_PROPAGATION_TARGETS,
  tracePropagationTargets: DEFAULT_TRACE_PROPAGATION_TARGETS,
};

/** Registers span creators for xhr and fetch requests  */
function instrumentOutgoingRequests(_options) {
  // eslint-disable-next-line deprecation/deprecation
  const { traceFetch, traceXHR, tracePropagationTargets, tracingOrigins, shouldCreateSpanForRequest } = {
    traceFetch: defaultRequestInstrumentationOptions.traceFetch,
    traceXHR: defaultRequestInstrumentationOptions.traceXHR,
    ..._options,
  };

  const shouldCreateSpan =
    typeof shouldCreateSpanForRequest === 'function' ? shouldCreateSpanForRequest : (_) => true;

  // TODO(v8) Remove tracingOrigins here
  // The only reason we're passing it in here is because this instrumentOutgoingRequests function is publicly exported
  // and we don't want to break the API. We can remove it in v8.
  const shouldAttachHeadersWithTargets = (url) =>
    shouldAttachHeaders(url, tracePropagationTargets || tracingOrigins);

  const spans = {};

  if (traceFetch) {
    (0,instrument/* addInstrumentationHandler */.o)('fetch', (handlerData) => {
      fetchCallback(handlerData, shouldCreateSpan, shouldAttachHeadersWithTargets, spans);
    });
  }

  if (traceXHR) {
    (0,instrument/* addInstrumentationHandler */.o)('xhr', (handlerData) => {
      xhrCallback(handlerData, shouldCreateSpan, shouldAttachHeadersWithTargets, spans);
    });
  }
}

/**
 * A function that determines whether to attach tracing headers to a request.
 * This was extracted from `instrumentOutgoingRequests` to make it easier to test shouldAttachHeaders.
 * We only export this fuction for testing purposes.
 */
function shouldAttachHeaders(url, tracePropagationTargets) {
  return (0,string/* stringMatchesSomePattern */.U0)(url, tracePropagationTargets || DEFAULT_TRACE_PROPAGATION_TARGETS);
}

/**
 * Create and track fetch request spans
 */
function fetchCallback(
  handlerData,
  shouldCreateSpan,
  shouldAttachHeaders,
  spans,
) {
  if (!(0,utils/* hasTracingEnabled */.zu)() || !(handlerData.fetchData && shouldCreateSpan(handlerData.fetchData.url))) {
    return;
  }

  if (handlerData.endTimestamp) {
    const spanId = handlerData.fetchData.__span;
    if (!spanId) return;

    const span = spans[spanId];
    if (span) {
      if (handlerData.response) {
        // TODO (kmclb) remove this once types PR goes through
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        span.setHttpStatus(handlerData.response.status);
      } else if (handlerData.error) {
        span.setStatus('internal_error');
      }
      span.finish();

      // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
      delete spans[spanId];
    }
    return;
  }

  const currentScope = (0,esm_hub/* getCurrentHub */.Gd)().getScope();
  const currentSpan = currentScope && currentScope.getSpan();
  const activeTransaction = currentSpan && currentSpan.transaction;

  if (currentSpan && activeTransaction) {
    const span = currentSpan.startChild({
      data: {
        ...handlerData.fetchData,
        type: 'fetch',
      },
      description: `${handlerData.fetchData.method} ${handlerData.fetchData.url}`,
      op: 'http.client',
    });

    handlerData.fetchData.__span = span.spanId;
    spans[span.spanId] = span;

    const request = handlerData.args[0];

    // In case the user hasn't set the second argument of a fetch call we default it to `{}`.
    handlerData.args[1] = handlerData.args[1] || {};

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const options = handlerData.args[1];

    if (shouldAttachHeaders(handlerData.fetchData.url)) {
      options.headers = addTracingHeadersToFetchRequest(
        request,
        activeTransaction.getDynamicSamplingContext(),
        span,
        options,
      );

      activeTransaction.metadata.propagations++;
    }
  }
}

function addTracingHeadersToFetchRequest(
  request,
  dynamicSamplingContext,
  span,
  options

,
) {
  const sentryBaggageHeader = dynamicSamplingContextToSentryBaggageHeader(dynamicSamplingContext);
  const sentryTraceHeader = span.toTraceparent();

  const headers =
    typeof Request !== 'undefined' && (0,is/* isInstanceOf */.V9)(request, Request) ? (request ).headers : options.headers;

  if (!headers) {
    return { 'sentry-trace': sentryTraceHeader, baggage: sentryBaggageHeader };
  } else if (typeof Headers !== 'undefined' && (0,is/* isInstanceOf */.V9)(headers, Headers)) {
    const newHeaders = new Headers(headers );

    newHeaders.append('sentry-trace', sentryTraceHeader);

    if (sentryBaggageHeader) {
      // If the same header is appended miultiple times the browser will merge the values into a single request header.
      // Its therefore safe to simply push a "baggage" entry, even though there might already be another baggage header.
      newHeaders.append(BAGGAGE_HEADER_NAME, sentryBaggageHeader);
    }

    return newHeaders ;
  } else if (Array.isArray(headers)) {
    const newHeaders = [...headers, ['sentry-trace', sentryTraceHeader]];

    if (sentryBaggageHeader) {
      // If there are multiple entries with the same key, the browser will merge the values into a single request header.
      // Its therefore safe to simply push a "baggage" entry, even though there might already be another baggage header.
      newHeaders.push([BAGGAGE_HEADER_NAME, sentryBaggageHeader]);
    }

    return newHeaders;
  } else {
    const existingBaggageHeader = 'baggage' in headers ? headers.baggage : undefined;
    const newBaggageHeaders = [];

    if (Array.isArray(existingBaggageHeader)) {
      newBaggageHeaders.push(...existingBaggageHeader);
    } else if (existingBaggageHeader) {
      newBaggageHeaders.push(existingBaggageHeader);
    }

    if (sentryBaggageHeader) {
      newBaggageHeaders.push(sentryBaggageHeader);
    }

    return {
      ...(headers ),
      'sentry-trace': sentryTraceHeader,
      baggage: newBaggageHeaders.length > 0 ? newBaggageHeaders.join(',') : undefined,
    };
  }
}

/**
 * Create and track xhr request spans
 */
function xhrCallback(
  handlerData,
  shouldCreateSpan,
  shouldAttachHeaders,
  spans,
) {
  if (
    !(0,utils/* hasTracingEnabled */.zu)() ||
    (handlerData.xhr && handlerData.xhr.__sentry_own_request__) ||
    !(handlerData.xhr && handlerData.xhr.__sentry_xhr__ && shouldCreateSpan(handlerData.xhr.__sentry_xhr__.url))
  ) {
    return;
  }

  const xhr = handlerData.xhr.__sentry_xhr__;

  // check first if the request has finished and is tracked by an existing span which should now end
  if (handlerData.endTimestamp) {
    const spanId = handlerData.xhr.__sentry_xhr_span_id__;
    if (!spanId) return;

    const span = spans[spanId];
    if (span) {
      span.setHttpStatus(xhr.status_code);
      span.finish();

      // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
      delete spans[spanId];
    }
    return;
  }

  const currentScope = (0,esm_hub/* getCurrentHub */.Gd)().getScope();
  const currentSpan = currentScope && currentScope.getSpan();
  const activeTransaction = currentSpan && currentSpan.transaction;

  if (currentSpan && activeTransaction) {
    const span = currentSpan.startChild({
      data: {
        ...xhr.data,
        type: 'xhr',
        method: xhr.method,
        url: xhr.url,
      },
      description: `${xhr.method} ${xhr.url}`,
      op: 'http.client',
    });

    handlerData.xhr.__sentry_xhr_span_id__ = span.spanId;
    spans[handlerData.xhr.__sentry_xhr_span_id__] = span;

    if (handlerData.xhr.setRequestHeader && shouldAttachHeaders(handlerData.xhr.__sentry_xhr__.url)) {
      try {
        handlerData.xhr.setRequestHeader('sentry-trace', span.toTraceparent());

        const dynamicSamplingContext = activeTransaction.getDynamicSamplingContext();
        const sentryBaggageHeader = dynamicSamplingContextToSentryBaggageHeader(dynamicSamplingContext);

        if (sentryBaggageHeader) {
          // From MDN: "If this method is called several times with the same header, the values are merged into one single request header."
          // We can therefore simply set a baggage header without checking what was there before
          // https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/setRequestHeader
          handlerData.xhr.setRequestHeader(BAGGAGE_HEADER_NAME, sentryBaggageHeader);
        }

        activeTransaction.metadata.propagations++;
      } catch (_) {
        // Error: InvalidStateError: Failed to execute 'setRequestHeader' on 'XMLHttpRequest': The object's state must be OPENED.
      }
    }
  }
}


//# sourceMappingURL=request.js.map

;// CONCATENATED MODULE: ../../.yarn/cache/@sentry-tracing-npm-7.32.1-60cc6371d2-b62b9cc4d4.zip/node_modules/@sentry/tracing/esm/browser/router.js



/**
 * Default function implementing pageload and navigation transactions
 */
function instrumentRoutingWithDefaults(
  customStartTransaction,
  startTransactionOnPageLoad = true,
  startTransactionOnLocationChange = true,
) {
  if (!types_WINDOW || !types_WINDOW.location) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.warn */.kg.warn('Could not initialize routing instrumentation due to invalid location');
    return;
  }

  let startingUrl = types_WINDOW.location.href;

  let activeTransaction;
  if (startTransactionOnPageLoad) {
    activeTransaction = customStartTransaction({
      name: types_WINDOW.location.pathname,
      op: 'pageload',
      metadata: { source: 'url' },
    });
  }

  if (startTransactionOnLocationChange) {
    (0,instrument/* addInstrumentationHandler */.o)('history', ({ to, from }) => {
      /**
       * This early return is there to account for some cases where a navigation transaction starts right after
       * long-running pageload. We make sure that if `from` is undefined and a valid `startingURL` exists, we don't
       * create an uneccessary navigation transaction.
       *
       * This was hard to duplicate, but this behavior stopped as soon as this fix was applied. This issue might also
       * only be caused in certain development environments where the usage of a hot module reloader is causing
       * errors.
       */
      if (from === undefined && startingUrl && startingUrl.indexOf(to) !== -1) {
        startingUrl = undefined;
        return;
      }

      if (from !== to) {
        startingUrl = undefined;
        if (activeTransaction) {
          (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.log */.kg.log(`[Tracing] Finishing current transaction with op: ${activeTransaction.op}`);
          // If there's an open transaction on the scope, we need to finish it before creating an new one.
          activeTransaction.finish();
        }
        activeTransaction = customStartTransaction({
          name: types_WINDOW.location.pathname,
          op: 'navigation',
          metadata: { source: 'url' },
        });
      }
    });
  }
}


//# sourceMappingURL=router.js.map

;// CONCATENATED MODULE: ../../.yarn/cache/@sentry-tracing-npm-7.32.1-60cc6371d2-b62b9cc4d4.zip/node_modules/@sentry/tracing/esm/browser/browsertracing.js










const BROWSER_TRACING_INTEGRATION_ID = 'BrowserTracing';

/** Options for Browser Tracing integration */

const DEFAULT_BROWSER_TRACING_OPTIONS = {
  idleTimeout: idletransaction/* DEFAULT_IDLE_TIMEOUT */.nT,
  finalTimeout: idletransaction/* DEFAULT_FINAL_TIMEOUT */.mg,
  heartbeatInterval: idletransaction/* DEFAULT_HEARTBEAT_INTERVAL */.hd,
  markBackgroundTransactions: true,
  routingInstrumentation: instrumentRoutingWithDefaults,
  startTransactionOnLocationChange: true,
  startTransactionOnPageLoad: true,
  enableLongTask: true,
  _experiments: {},
  ...defaultRequestInstrumentationOptions,
};

/**
 * The Browser Tracing integration automatically instruments browser pageload/navigation
 * actions as transactions, and captures requests, metrics and errors as spans.
 *
 * The integration can be configured with a variety of options, and can be extended to use
 * any routing library. This integration uses {@see IdleTransaction} to create transactions.
 */
class BrowserTracing  {
  // This class currently doesn't have a static `id` field like the other integration classes, because it prevented
  // @sentry/tracing from being treeshaken. Tree shakers do not like static fields, because they behave like side effects.
  // TODO: Come up with a better plan, than using static fields on integration classes, and use that plan on all
  // integrations.

  /** Browser Tracing integration options */

  /**
   * @inheritDoc
   */
   __init() {this.name = BROWSER_TRACING_INTEGRATION_ID;}

   constructor(_options) {BrowserTracing.prototype.__init.call(this);
    this.options = {
      ...DEFAULT_BROWSER_TRACING_OPTIONS,
      ..._options,
    };

    // Special case: enableLongTask can be set in _experiments
    // TODO (v8): Remove this in v8
    if (this.options._experiments.enableLongTask !== undefined) {
      this.options.enableLongTask = this.options._experiments.enableLongTask;
    }

    // TODO (v8): remove this block after tracingOrigins is removed
    // Set tracePropagationTargets to tracingOrigins if specified by the user
    // In case both are specified, tracePropagationTargets takes precedence
    // eslint-disable-next-line deprecation/deprecation
    if (_options && !_options.tracePropagationTargets && _options.tracingOrigins) {
      // eslint-disable-next-line deprecation/deprecation
      this.options.tracePropagationTargets = _options.tracingOrigins;
    }

    startTrackingWebVitals();
    if (this.options.enableLongTask) {
      startTrackingLongTasks();
    }
  }

  /**
   * @inheritDoc
   */
   setupOnce(_, getCurrentHub) {
    this._getCurrentHub = getCurrentHub;

    const {
      routingInstrumentation: instrumentRouting,
      startTransactionOnLocationChange,
      startTransactionOnPageLoad,
      markBackgroundTransactions,
      traceFetch,
      traceXHR,
      tracePropagationTargets,
      shouldCreateSpanForRequest,
      _experiments,
    } = this.options;

    instrumentRouting(
      (context) => this._createRouteTransaction(context),
      startTransactionOnPageLoad,
      startTransactionOnLocationChange,
    );

    if (markBackgroundTransactions) {
      registerBackgroundTabDetection();
    }

    if (_experiments.enableInteractions) {
      this._registerInteractionListener();
    }

    instrumentOutgoingRequests({
      traceFetch,
      traceXHR,
      tracePropagationTargets,
      shouldCreateSpanForRequest,
    });
  }

  /** Create routing idle transaction. */
   _createRouteTransaction(context) {
    if (!this._getCurrentHub) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
        esm_logger/* logger.warn */.kg.warn(`[Tracing] Did not create ${context.op} transaction because _getCurrentHub is invalid.`);
      return undefined;
    }

    const { beforeNavigate, idleTimeout, finalTimeout, heartbeatInterval } = this.options;

    const isPageloadTransaction = context.op === 'pageload';

    const sentryTraceMetaTagValue = isPageloadTransaction ? getMetaContent('sentry-trace') : null;
    const baggageMetaTagValue = isPageloadTransaction ? getMetaContent('baggage') : null;

    const traceParentData = sentryTraceMetaTagValue ? extractTraceparentData(sentryTraceMetaTagValue) : undefined;
    const dynamicSamplingContext = baggageMetaTagValue
      ? baggageHeaderToDynamicSamplingContext(baggageMetaTagValue)
      : undefined;

    const expandedContext = {
      ...context,
      ...traceParentData,
      metadata: {
        ...context.metadata,
        dynamicSamplingContext: traceParentData && !dynamicSamplingContext ? {} : dynamicSamplingContext,
      },
      trimEnd: true,
    };

    const modifiedContext = typeof beforeNavigate === 'function' ? beforeNavigate(expandedContext) : expandedContext;

    // For backwards compatibility reasons, beforeNavigate can return undefined to "drop" the transaction (prevent it
    // from being sent to Sentry).
    const finalContext = modifiedContext === undefined ? { ...expandedContext, sampled: false } : modifiedContext;

    // If `beforeNavigate` set a custom name, record that fact
    finalContext.metadata =
      finalContext.name !== expandedContext.name
        ? { ...finalContext.metadata, source: 'custom' }
        : finalContext.metadata;

    this._latestRouteName = finalContext.name;
    this._latestRouteSource = finalContext.metadata && finalContext.metadata.source;

    if (finalContext.sampled === false) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
        esm_logger/* logger.log */.kg.log(`[Tracing] Will not send ${finalContext.op} transaction because of beforeNavigate.`);
    }

    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.log */.kg.log(`[Tracing] Starting ${finalContext.op} transaction on scope`);

    const hub = this._getCurrentHub();
    const { location } = types_WINDOW;

    const idleTransaction = (0,hubextensions/* startIdleTransaction */.lb)(
      hub,
      finalContext,
      idleTimeout,
      finalTimeout,
      true,
      { location }, // for use in the tracesSampler
      heartbeatInterval,
    );
    idleTransaction.registerBeforeFinishCallback(transaction => {
      addPerformanceEntries(transaction);
    });

    return idleTransaction ;
  }

  /** Start listener for interaction transactions */
   _registerInteractionListener() {
    let inflightInteractionTransaction;
    const registerInteractionTransaction = () => {
      const { idleTimeout, finalTimeout, heartbeatInterval } = this.options;

      const op = 'ui.action.click';
      if (inflightInteractionTransaction) {
        inflightInteractionTransaction.finish();
        inflightInteractionTransaction = undefined;
      }

      if (!this._getCurrentHub) {
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.warn */.kg.warn(`[Tracing] Did not create ${op} transaction because _getCurrentHub is invalid.`);
        return undefined;
      }

      if (!this._latestRouteName) {
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
          esm_logger/* logger.warn */.kg.warn(`[Tracing] Did not create ${op} transaction because _latestRouteName is missing.`);
        return undefined;
      }

      const hub = this._getCurrentHub();
      const { location } = types_WINDOW;

      const context = {
        name: this._latestRouteName,
        op,
        trimEnd: true,
        metadata: {
          source: this._latestRouteSource || 'url',
        },
      };

      inflightInteractionTransaction = (0,hubextensions/* startIdleTransaction */.lb)(
        hub,
        context,
        idleTimeout,
        finalTimeout,
        true,
        { location }, // for use in the tracesSampler
        heartbeatInterval,
      );
    };

    ['click'].forEach(type => {
      addEventListener(type, registerInteractionTransaction, { once: false, capture: true });
    });
  }
}

/** Returns the value of a meta tag */
function getMetaContent(metaName) {
  // Can't specify generic to `getDomElement` because tracing can be used
  // in a variety of environments, have to disable `no-unsafe-member-access`
  // as a result.
  const metaTag = (0,browser/* getDomElement */.qT)(`meta[name=${metaName}]`);
  // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
  return metaTag ? metaTag.getAttribute('content') : null;
}


//# sourceMappingURL=browsertracing.js.map

;// CONCATENATED MODULE: ../../.yarn/cache/@sentry-tracing-npm-7.32.1-60cc6371d2-b62b9cc4d4.zip/node_modules/@sentry/tracing/esm/index.js













// Treeshakable guard to remove all code related to tracing

// Guard for tree
if (typeof __SENTRY_TRACING__ === 'undefined' || __SENTRY_TRACING__) {
  // We are patching the global object with our hub extension methods
  (0,hubextensions/* addExtensionMethods */.ro)();
}
//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@sentry-nextjs-virtual-cec61ebd1a/0/cache/@sentry-nextjs-npm-7.32.1-0e41610603-6cf9140fad.zip/node_modules/@sentry/nextjs/esm/common/metadata.js


const PACKAGE_NAME_PREFIX = 'npm:@sentry/';

/**
 * A builder for the SDK metadata in the options for the SDK initialization.
 * @param options sdk options object that gets mutated
 * @param names list of package names
 */
function buildMetadata(options, names) {
  options._metadata = options._metadata || {};
  options._metadata.sdk =
    options._metadata.sdk ||
    ({
      name: 'sentry.javascript.nextjs',
      packages: names.map(name => ({
        name: `${PACKAGE_NAME_PREFIX}${name}`,
        version: SDK_VERSION,
      })),
      version: SDK_VERSION,
    } );
}


//# sourceMappingURL=metadata.js.map

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@sentry-nextjs-virtual-cec61ebd1a/0/cache/@sentry-nextjs-npm-7.32.1-0e41610603-6cf9140fad.zip/node_modules/@sentry/nextjs/esm/common/userIntegrations.js
/**
 * Recursively traverses an object to update an existing nested key.
 * Note: The provided key path must include existing properties,
 * the function will not create objects while traversing.
 *
 * @param obj An object to update
 * @param value The value to update the nested key with
 * @param keyPath The path to the key to update ex. fizz.buzz.foo
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function setNestedKey(obj, keyPath, value) {
  // Ex. foo.bar.zoop will extract foo and bar.zoop
  const match = keyPath.match(/([a-z_]+)\.(.*)/i);
  // The match will be null when there's no more recursing to do, i.e., when we've reached the right level of the object
  if (match === null) {
    obj[keyPath] = value;
  } else {
    // `match[1]` is the initial segment of the path, and `match[2]` is the remainder of the path
    const innerObj = obj[match[1]];
    setNestedKey(innerObj, match[2], value);
  }
}

/**
 * Enforces inclusion of a given integration with specified options in an integration array originally determined by the
 * user, by either including the given default instance or by patching an existing user instance with the given options.
 *
 * Ideally this would happen when integrations are set up, but there isn't currently a mechanism there for merging
 * options from a default integration instance with those from a user-provided instance of the same integration, only
 * for allowing the user to override a default instance entirely. (TODO: Fix that.)
 *
 * @param defaultIntegrationInstance An instance of the integration with the correct options already set
 * @param userIntegrations Integrations defined by the user.
 * @param forcedOptions Options with which to patch an existing user-derived instance on the integration.
 * @returns A final integrations array.
 */
function addOrUpdateIntegration(
  defaultIntegrationInstance,
  userIntegrations,
  forcedOptions = {},
) {
  return (
    Array.isArray(userIntegrations)
      ? addOrUpdateIntegrationInArray(defaultIntegrationInstance, userIntegrations, forcedOptions)
      : addOrUpdateIntegrationInFunction(
          defaultIntegrationInstance,
          // Somehow TS can't figure out that not being an array makes this necessarily a function
          userIntegrations ,
          forcedOptions,
        )
  ) ;
}

function addOrUpdateIntegrationInArray(
  defaultIntegrationInstance,
  userIntegrations,
  forcedOptions,
) {
  const userInstance = userIntegrations.find(integration => integration.name === defaultIntegrationInstance.name);

  if (userInstance) {
    for (const [keyPath, value] of Object.entries(forcedOptions)) {
      setNestedKey(userInstance, keyPath, value);
    }

    return userIntegrations;
  }

  return [...userIntegrations, defaultIntegrationInstance];
}

function addOrUpdateIntegrationInFunction(
  defaultIntegrationInstance,
  userIntegrationsFunc,
  forcedOptions,
) {
  const wrapper = defaultIntegrations => {
    const userFinalIntegrations = userIntegrationsFunc(defaultIntegrations);

    // There are instances where we want the user to be able to prevent an integration from appearing at all, which they
    // would do by providing a function which filters out the integration in question. If that's happened in one of
    // those cases, don't add our default back in.
    if (defaultIntegrationInstance.allowExclusionByUser) {
      const userFinalInstance = userFinalIntegrations.find(
        integration => integration.name === defaultIntegrationInstance.name,
      );
      if (!userFinalInstance) {
        return userFinalIntegrations;
      }
    }

    return addOrUpdateIntegrationInArray(defaultIntegrationInstance, userFinalIntegrations, forcedOptions);
  };

  return wrapper;
}


//# sourceMappingURL=userIntegrations.js.map

// EXTERNAL MODULE: ../../.yarn/__virtual__/next-virtual-cff1f1d108/0/cache/next-npm-13.0.0-0d765f7d5e-7b5c847287.zip/node_modules/next/router.js
var router = __webpack_require__(87347);
var router_default = /*#__PURE__*/__webpack_require__.n(router);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@sentry-nextjs-virtual-cec61ebd1a/0/cache/@sentry-nextjs-npm-7.32.1-0e41610603-6cf9140fad.zip/node_modules/@sentry/nextjs/esm/client/performance.js





const globalObject = helpers_WINDOW

;

/**
 * Every Next.js page (static and dynamic ones) comes with a script tag with the id "__NEXT_DATA__". This script tag
 * contains a JSON object with data that was either generated at build time for static pages (`getStaticProps`), or at
 * runtime with data fetchers like `getServerSideProps.`.
 *
 * We can use this information to:
 * - Always get the parameterized route we're in when loading a page.
 * - Send trace information (trace-id, baggage) from the server to the client.
 *
 * This function extracts this information.
 */
function extractNextDataTagInformation() {
  let nextData;
  // Let's be on the safe side and actually check first if there is really a __NEXT_DATA__ script tag on the page.
  // Theoretically this should always be the case though.
  const nextDataTag = globalObject.document.getElementById('__NEXT_DATA__');
  if (nextDataTag && nextDataTag.innerHTML) {
    try {
      nextData = JSON.parse(nextDataTag.innerHTML);
    } catch (e) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.warn */.kg.warn('Could not extract __NEXT_DATA__');
    }
  }

  if (!nextData) {
    return {};
  }

  const nextDataTagInfo = {};

  const { page, query, props } = nextData;

  // `nextData.page` always contains the parameterized route - except for when an error occurs in a data fetching
  // function, then it is "/_error", but that isn't a problem since users know which route threw by looking at the
  // parent transaction
  // TODO: Actually this is a problem (even though it is not that big), because the DSC and the transaction payload will contain
  // a different transaction name. Maybe we can fix this. Idea: Also send transaction name via pageProps when available.
  nextDataTagInfo.route = page;
  nextDataTagInfo.params = query;

  if (props && props.pageProps) {
    if (props.pageProps._sentryBaggage) {
      nextDataTagInfo.baggage = props.pageProps._sentryBaggage;
    }

    if (props.pageProps._sentryTraceData) {
      nextDataTagInfo.traceParentData = extractTraceparentData(props.pageProps._sentryTraceData);
    }
  }

  return nextDataTagInfo;
}

const DEFAULT_TAGS = {
  'routing.instrumentation': 'next-router',
} ;

// We keep track of the active transaction so we can finish it when we start a navigation transaction.
let activeTransaction = undefined;

// We keep track of the previous location name so we can set the `from` field on navigation transactions.
// This is either a route or a pathname.
let prevLocationName = undefined;

const client = (0,esm_hub/* getCurrentHub */.Gd)().getClient();

/**
 * Creates routing instrumention for Next Router. Only supported for
 * client side routing. Works for Next >= 10.
 *
 * Leverages the SingletonRouter from the `next/router` to
 * generate pageload/navigation transactions and parameterize
 * transaction names.
 */
function nextRouterInstrumentation(
  startTransactionCb,
  startTransactionOnPageLoad = true,
  startTransactionOnLocationChange = true,
) {
  const { route, traceParentData, baggage, params } = extractNextDataTagInformation();
  prevLocationName = route || globalObject.location.pathname;

  if (startTransactionOnPageLoad) {
    const source = route ? 'route' : 'url';
    const dynamicSamplingContext = baggageHeaderToDynamicSamplingContext(baggage);

    activeTransaction = startTransactionCb({
      name: prevLocationName,
      op: 'pageload',
      tags: DEFAULT_TAGS,
      ...(params && client && client.getOptions().sendDefaultPii && { data: params }),
      ...traceParentData,
      metadata: {
        source,
        dynamicSamplingContext: traceParentData && !dynamicSamplingContext ? {} : dynamicSamplingContext,
      },
    });
  }

  if (startTransactionOnLocationChange) {
    router_default().events.on('routeChangeStart', (navigationTarget) => {
      const matchedRoute = getNextRouteFromPathname(stripUrlQueryAndFragment(navigationTarget));

      let transactionName;
      let transactionSource;

      if (matchedRoute) {
        transactionName = matchedRoute;
        transactionSource = 'route';
      } else {
        transactionName = navigationTarget;
        transactionSource = 'url';
      }

      const tags = {
        ...DEFAULT_TAGS,
        from: prevLocationName,
      };

      prevLocationName = transactionName;

      if (activeTransaction) {
        activeTransaction.finish();
      }

      const navigationTransaction = startTransactionCb({
        name: transactionName,
        op: 'navigation',
        tags,
        metadata: { source: transactionSource },
      });

      if (navigationTransaction) {
        // In addition to the navigation transaction we're also starting a span to mark Next.js's `routeChangeStart`
        // and `routeChangeComplete` events.
        // We don't want to finish the navigation transaction on `routeChangeComplete`, since users might want to attach
        // spans to that transaction even after `routeChangeComplete` is fired (eg. HTTP requests in some useEffect
        // hooks). Instead, we'll simply let the navigation transaction finish itself (it's an `IdleTransaction`).
        const nextRouteChangeSpan = navigationTransaction.startChild({
          op: 'ui.nextjs.route-change',
          description: 'Next.js Route Change',
        });

        const finishRouteChangeSpan = () => {
          nextRouteChangeSpan.finish();
          router_default().events.off('routeChangeComplete', finishRouteChangeSpan);
        };

        router_default().events.on('routeChangeComplete', finishRouteChangeSpan);
      }
    });
  }
}

function getNextRouteFromPathname(pathname) {
  const pageRoutes = (globalObject.__BUILD_MANIFEST || {}).sortedPages;

  // Page route should in 99.999% of the cases be defined by now but just to be sure we make a check here
  if (!pageRoutes) {
    return;
  }

  return pageRoutes.find(route => {
    const routeRegExp = convertNextRouteToRegExp(route);
    return pathname.match(routeRegExp);
  });
}

/**
 * Converts a Next.js style route to a regular expression that matches on pathnames (no query params or URL fragments).
 *
 * In general this involves replacing any instances of square brackets in a route with a wildcard:
 * e.g. "/users/[id]/info" becomes /\/users\/([^/]+?)\/info/
 *
 * Some additional edgecases need to be considered:
 * - All routes have an optional slash at the end, meaning users can navigate to "/users/[id]/info" or
 *   "/users/[id]/info/" - both will be resolved to "/users/[id]/info".
 * - Non-optional "catchall"s at the end of a route must be considered when matching (e.g. "/users/[...params]").
 * - Optional "catchall"s at the end of a route must be considered when matching (e.g. "/users/[[...params]]").
 *
 * @param route A Next.js style route as it is found in `global.__BUILD_MANIFEST.sortedPages`
 */
function convertNextRouteToRegExp(route) {
  // We can assume a route is at least "/".
  const routeParts = route.split('/');

  let optionalCatchallWildcardRegex = '';
  if (routeParts[routeParts.length - 1].match(/^\[\[\.\.\..+\]\]$/)) {
    // If last route part has pattern "[[...xyz]]" we pop the latest route part to get rid of the required trailing
    // slash that would come before it if we didn't pop it.
    routeParts.pop();
    optionalCatchallWildcardRegex = '(?:/(.+?))?';
  }

  const rejoinedRouteParts = routeParts
    .map(
      routePart =>
        routePart
          .replace(/^\[\.\.\..+\]$/, '(.+?)') // Replace catch all wildcard with regex wildcard
          .replace(/^\[.*\]$/, '([^/]+?)'), // Replace route wildcards with lazy regex wildcards
    )
    .join('/');

  return new RegExp(
    `^${rejoinedRouteParts}${optionalCatchallWildcardRegex}(?:/)?$`, // optional slash at the end
  );
}


//# sourceMappingURL=performance.js.map

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@sentry-nextjs-virtual-cec61ebd1a/0/cache/@sentry-nextjs-npm-7.32.1-0e41610603-6cf9140fad.zip/node_modules/@sentry/nextjs/esm/client/tunnelRoute.js


const globalWithInjectedValues = __webpack_require__.g

;

/**
 * Applies the `tunnel` option to the Next.js SDK options based on `withSentryConfig`'s `tunnelRoute` option.
 */
function applyTunnelRouteOption(options) {
  const tunnelRouteOption = globalWithInjectedValues.__sentryRewritesTunnelPath__;
  if (tunnelRouteOption && options.dsn) {
    const dsnComponents = dsnFromString(options.dsn);
    const sentrySaasDsnMatch = dsnComponents.host.match(/^o(\d+)\.ingest\.sentry\.io$/);
    if (sentrySaasDsnMatch) {
      const orgId = sentrySaasDsnMatch[1];
      const tunnelPath = `${tunnelRouteOption}?o=${orgId}&p=${dsnComponents.projectId}`;
      options.tunnel = tunnelPath;
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.info */.kg.info(`Tunneling events to "${tunnelPath}"`);
    } else {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.warn */.kg.warn('Provided DSN is not a Sentry SaaS DSN. Will not tunnel events.');
    }
  }
}


//# sourceMappingURL=tunnelRoute.js.map

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@sentry-nextjs-virtual-cec61ebd1a/0/cache/@sentry-nextjs-npm-7.32.1-0e41610603-6cf9140fad.zip/node_modules/@sentry/nextjs/esm/client/index.js















// Treeshakable guard to remove all code related to tracing

const client_globalWithInjectedValues = __webpack_require__.g

;

/** Inits the Sentry NextJS SDK on the browser with the React SDK. */
function client_init(options) {
  applyTunnelRouteOption(options);
  buildMetadata(options, ['nextjs', 'react']);
  options.environment = options.environment || "production";
  addClientIntegrations(options);

  sdk_init(options);

  configureScope(scope => {
    scope.setTag('runtime', 'browser');
    const filterTransactions = event =>
      event.type === 'transaction' && event.transaction === '/404' ? null : event;
    filterTransactions.id = 'NextClient404Filter';
    scope.addEventProcessor(filterTransactions);
  });
}

function addClientIntegrations(options) {
  let integrations = options.integrations || [];

  // This value is injected at build time, based on the output directory specified in the build config. Though a default
  // is set there, we set it here as well, just in case something has gone wrong with the injection.
  const assetPrefixPath = client_globalWithInjectedValues.__rewriteFramesAssetPrefixPath__ || '';

  const defaultRewriteFramesIntegration = new RewriteFrames({
    // Turn `<origin>/<path>/_next/static/...` into `app:///_next/static/...`
    iteratee: frame => {
      try {
        const { origin } = new URL(frame.filename );
        frame.filename = _optionalChain([frame, 'access', _ => _.filename, 'optionalAccess', _2 => _2.replace, 'call', _3 => _3(origin, 'app://'), 'access', _4 => _4.replace, 'call', _5 => _5(assetPrefixPath, '')]);
      } catch (err) {
        // Filename wasn't a properly formed URL, so there's nothing we can do
      }

      return frame;
    },
  });
  integrations = addOrUpdateIntegration(defaultRewriteFramesIntegration, integrations);

  // This evaluates to true unless __SENTRY_TRACING__ is text-replaced with "false", in which case everything inside
  // will get treeshaken away
  if (typeof __SENTRY_TRACING__ === 'undefined' || __SENTRY_TRACING__) {
    if ((0,utils/* hasTracingEnabled */.zu)(options)) {
      const defaultBrowserTracingIntegration = new BrowserTracing({
        // eslint-disable-next-line deprecation/deprecation
        tracingOrigins: [...defaultRequestInstrumentationOptions.tracingOrigins, /^(api\/)/],
        routingInstrumentation: nextRouterInstrumentation,
      });

      integrations = addOrUpdateIntegration(defaultBrowserTracingIntegration, integrations, {
        'options.routingInstrumentation': nextRouterInstrumentation,
      });
    }
  }

  options.integrations = integrations;
}


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@sentry-nextjs-virtual-cec61ebd1a/0/cache/@sentry-nextjs-npm-7.32.1-0e41610603-6cf9140fad.zip/node_modules/@sentry/nextjs/esm/index.client.js


/***/ }),

/***/ 66667:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var AlgoliaSearchHelper = __webpack_require__(68765);

var SearchParameters = __webpack_require__(63264);
var SearchResults = __webpack_require__(97968);

/**
 * The algoliasearchHelper module is the function that will let its
 * contains everything needed to use the Algoliasearch
 * Helper. It is a also a function that instanciate the helper.
 * To use the helper, you also need the Algolia JS client v3.
 * @example
 * //using the UMD build
 * var client = algoliasearch('latency', '6be0576ff61c053d5f9a3225e2a90f76');
 * var helper = algoliasearchHelper(client, 'bestbuy', {
 *   facets: ['shipping'],
 *   disjunctiveFacets: ['category']
 * });
 * helper.on('result', function(event) {
 *   console.log(event.results);
 * });
 * helper
 *   .toggleFacetRefinement('category', 'Movies & TV Shows')
 *   .toggleFacetRefinement('shipping', 'Free shipping')
 *   .search();
 * @example
 * // The helper is an event emitter using the node API
 * helper.on('result', updateTheResults);
 * helper.once('result', updateTheResults);
 * helper.removeListener('result', updateTheResults);
 * helper.removeAllListeners('result');
 * @module algoliasearchHelper
 * @param  {AlgoliaSearch} client an AlgoliaSearch client
 * @param  {string} index the name of the index to query
 * @param  {SearchParameters|object} opts an object defining the initial config of the search. It doesn't have to be a {SearchParameters}, just an object containing the properties you need from it.
 * @return {AlgoliaSearchHelper}
 */
function algoliasearchHelper(client, index, opts) {
  return new AlgoliaSearchHelper(client, index, opts);
}

/**
 * The version currently used
 * @member module:algoliasearchHelper.version
 * @type {number}
 */
algoliasearchHelper.version = __webpack_require__(33836);

/**
 * Constructor for the Helper.
 * @member module:algoliasearchHelper.AlgoliaSearchHelper
 * @type {AlgoliaSearchHelper}
 */
algoliasearchHelper.AlgoliaSearchHelper = AlgoliaSearchHelper;

/**
 * Constructor for the object containing all the parameters of the search.
 * @member module:algoliasearchHelper.SearchParameters
 * @type {SearchParameters}
 */
algoliasearchHelper.SearchParameters = SearchParameters;

/**
 * Constructor for the object containing the results of the search.
 * @member module:algoliasearchHelper.SearchResults
 * @type {SearchResults}
 */
algoliasearchHelper.SearchResults = SearchResults;

module.exports = algoliasearchHelper;


/***/ }),

/***/ 29333:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var EventEmitter = __webpack_require__(73592);
var inherits = __webpack_require__(37224);

/**
 * A DerivedHelper is a way to create sub requests to
 * Algolia from a main helper.
 * @class
 * @classdesc The DerivedHelper provides an event based interface for search callbacks:
 *  - search: when a search is triggered using the `search()` method.
 *  - result: when the response is retrieved from Algolia and is processed.
 *    This event contains a {@link SearchResults} object and the
 *    {@link SearchParameters} corresponding to this answer.
 */
function DerivedHelper(mainHelper, fn) {
  this.main = mainHelper;
  this.fn = fn;
  this.lastResults = null;
}

inherits(DerivedHelper, EventEmitter);

/**
 * Detach this helper from the main helper
 * @return {undefined}
 * @throws Error if the derived helper is already detached
 */
DerivedHelper.prototype.detach = function() {
  this.removeAllListeners();
  this.main.detachDerivedHelper(this);
};

DerivedHelper.prototype.getModifiedState = function(parameters) {
  return this.fn(parameters);
};

module.exports = DerivedHelper;


/***/ }),

/***/ 6909:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


/**
 * Functions to manipulate refinement lists
 *
 * The RefinementList is not formally defined through a prototype but is based
 * on a specific structure.
 *
 * @module SearchParameters.refinementList
 *
 * @typedef {string[]} SearchParameters.refinementList.Refinements
 * @typedef {Object.<string, SearchParameters.refinementList.Refinements>} SearchParameters.refinementList.RefinementList
 */

var defaultsPure = __webpack_require__(67955);
var omit = __webpack_require__(25279);
var objectHasKeys = __webpack_require__(68711);

var lib = {
  /**
   * Adds a refinement to a RefinementList
   * @param {RefinementList} refinementList the initial list
   * @param {string} attribute the attribute to refine
   * @param {string} value the value of the refinement, if the value is not a string it will be converted
   * @return {RefinementList} a new and updated refinement list
   */
  addRefinement: function addRefinement(refinementList, attribute, value) {
    if (lib.isRefined(refinementList, attribute, value)) {
      return refinementList;
    }

    var valueAsString = '' + value;

    var facetRefinement = !refinementList[attribute] ?
      [valueAsString] :
      refinementList[attribute].concat(valueAsString);

    var mod = {};

    mod[attribute] = facetRefinement;

    return defaultsPure({}, mod, refinementList);
  },
  /**
   * Removes refinement(s) for an attribute:
   *  - if the value is specified removes the refinement for the value on the attribute
   *  - if no value is specified removes all the refinements for this attribute
   * @param {RefinementList} refinementList the initial list
   * @param {string} attribute the attribute to refine
   * @param {string} [value] the value of the refinement
   * @return {RefinementList} a new and updated refinement lst
   */
  removeRefinement: function removeRefinement(refinementList, attribute, value) {
    if (value === undefined) {
      // we use the "filter" form of clearRefinement, since it leaves empty values as-is
      // the form with a string will remove the attribute completely
      return lib.clearRefinement(refinementList, function(v, f) {
        return attribute === f;
      });
    }

    var valueAsString = '' + value;

    return lib.clearRefinement(refinementList, function(v, f) {
      return attribute === f && valueAsString === v;
    });
  },
  /**
   * Toggles the refinement value for an attribute.
   * @param {RefinementList} refinementList the initial list
   * @param {string} attribute the attribute to refine
   * @param {string} value the value of the refinement
   * @return {RefinementList} a new and updated list
   */
  toggleRefinement: function toggleRefinement(refinementList, attribute, value) {
    if (value === undefined) throw new Error('toggleRefinement should be used with a value');

    if (lib.isRefined(refinementList, attribute, value)) {
      return lib.removeRefinement(refinementList, attribute, value);
    }

    return lib.addRefinement(refinementList, attribute, value);
  },
  /**
   * Clear all or parts of a RefinementList. Depending on the arguments, three
   * kinds of behavior can happen:
   *  - if no attribute is provided: clears the whole list
   *  - if an attribute is provided as a string: clears the list for the specific attribute
   *  - if an attribute is provided as a function: discards the elements for which the function returns true
   * @param {RefinementList} refinementList the initial list
   * @param {string} [attribute] the attribute or function to discard
   * @param {string} [refinementType] optional parameter to give more context to the attribute function
   * @return {RefinementList} a new and updated refinement list
   */
  clearRefinement: function clearRefinement(refinementList, attribute, refinementType) {
    if (attribute === undefined) {
      if (!objectHasKeys(refinementList)) {
        return refinementList;
      }
      return {};
    } else if (typeof attribute === 'string') {
      return omit(refinementList, [attribute]);
    } else if (typeof attribute === 'function') {
      var hasChanged = false;

      var newRefinementList = Object.keys(refinementList).reduce(function(memo, key) {
        var values = refinementList[key] || [];
        var facetList = values.filter(function(value) {
          return !attribute(value, key, refinementType);
        });

        if (facetList.length !== values.length) {
          hasChanged = true;
        }
        memo[key] = facetList;

        return memo;
      }, {});

      if (hasChanged) return newRefinementList;
      return refinementList;
    }
  },
  /**
   * Test if the refinement value is used for the attribute. If no refinement value
   * is provided, test if the refinementList contains any refinement for the
   * given attribute.
   * @param {RefinementList} refinementList the list of refinement
   * @param {string} attribute name of the attribute
   * @param {string} [refinementValue] value of the filter/refinement
   * @return {boolean}
   */
  isRefined: function isRefined(refinementList, attribute, refinementValue) {
    var containsRefinements = !!refinementList[attribute] &&
      refinementList[attribute].length > 0;

    if (refinementValue === undefined || !containsRefinements) {
      return containsRefinements;
    }

    var refinementValueAsString = '' + refinementValue;

    return refinementList[attribute].indexOf(refinementValueAsString) !== -1;
  }
};

module.exports = lib;


/***/ }),

/***/ 63264:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var merge = __webpack_require__(43600);
var defaultsPure = __webpack_require__(67955);
var intersection = __webpack_require__(47485);
var find = __webpack_require__(38901);
var valToNumber = __webpack_require__(30240);
var omit = __webpack_require__(25279);
var objectHasKeys = __webpack_require__(68711);
var isValidUserToken = __webpack_require__(9444);

var RefinementList = __webpack_require__(6909);

/**
 * isEqual, but only for numeric refinement values, possible values:
 * - 5
 * - [5]
 * - [[5]]
 * - [[5,5],[4]]
 */
function isEqualNumericRefinement(a, b) {
  if (Array.isArray(a) && Array.isArray(b)) {
    return (
      a.length === b.length &&
      a.every(function(el, i) {
        return isEqualNumericRefinement(b[i], el);
      })
    );
  }
  return a === b;
}

/**
 * like _.find but using deep equality to be able to use it
 * to find arrays.
 * @private
 * @param {any[]} array array to search into (elements are base or array of base)
 * @param {any} searchedValue the value we're looking for (base or array of base)
 * @return {any} the searched value or undefined
 */
function findArray(array, searchedValue) {
  return find(array, function(currentValue) {
    return isEqualNumericRefinement(currentValue, searchedValue);
  });
}

/**
 * The facet list is the structure used to store the list of values used to
 * filter a single attribute.
 * @typedef {string[]} SearchParameters.FacetList
 */

/**
 * Structure to store numeric filters with the operator as the key. The supported operators
 * are `=`, `>`, `<`, `>=`, `<=` and `!=`.
 * @typedef {Object.<string, Array.<number|number[]>>} SearchParameters.OperatorList
 */

/**
 * SearchParameters is the data structure that contains all the information
 * usable for making a search to Algolia API. It doesn't do the search itself,
 * nor does it contains logic about the parameters.
 * It is an immutable object, therefore it has been created in a way that each
 * changes does not change the object itself but returns a copy with the
 * modification.
 * This object should probably not be instantiated outside of the helper. It will
 * be provided when needed. This object is documented for reference as you'll
 * get it from events generated by the {@link AlgoliaSearchHelper}.
 * If need be, instantiate the Helper from the factory function {@link SearchParameters.make}
 * @constructor
 * @classdesc contains all the parameters of a search
 * @param {object|SearchParameters} newParameters existing parameters or partial object
 * for the properties of a new SearchParameters
 * @see SearchParameters.make
 * @example <caption>SearchParameters of the first query in
 *   <a href="http://demos.algolia.com/instant-search-demo/">the instant search demo</a></caption>
{
   "query": "",
   "disjunctiveFacets": [
      "customerReviewCount",
      "category",
      "salePrice_range",
      "manufacturer"
  ],
   "maxValuesPerFacet": 30,
   "page": 0,
   "hitsPerPage": 10,
   "facets": [
      "type",
      "shipping"
  ]
}
 */
function SearchParameters(newParameters) {
  var params = newParameters ? SearchParameters._parseNumbers(newParameters) : {};

  if (params.userToken !== undefined && !isValidUserToken(params.userToken)) {
    console.warn('[algoliasearch-helper] The `userToken` parameter is invalid. This can lead to wrong analytics.\n  - Format: [a-zA-Z0-9_-]{1,64}');
  }
  /**
   * This attribute contains the list of all the conjunctive facets
   * used. This list will be added to requested facets in the
   * [facets attribute](https://www.algolia.com/doc/rest-api/search#param-facets) sent to algolia.
   * @member {string[]}
   */
  this.facets = params.facets || [];
  /**
   * This attribute contains the list of all the disjunctive facets
   * used. This list will be added to requested facets in the
   * [facets attribute](https://www.algolia.com/doc/rest-api/search#param-facets) sent to algolia.
   * @member {string[]}
   */
  this.disjunctiveFacets = params.disjunctiveFacets || [];
  /**
   * This attribute contains the list of all the hierarchical facets
   * used. This list will be added to requested facets in the
   * [facets attribute](https://www.algolia.com/doc/rest-api/search#param-facets) sent to algolia.
   * Hierarchical facets are a sub type of disjunctive facets that
   * let you filter faceted attributes hierarchically.
   * @member {string[]|object[]}
   */
  this.hierarchicalFacets = params.hierarchicalFacets || [];

  // Refinements
  /**
   * This attribute contains all the filters that need to be
   * applied on the conjunctive facets. Each facet must be properly
   * defined in the `facets` attribute.
   *
   * The key is the name of the facet, and the `FacetList` contains all
   * filters selected for the associated facet name.
   *
   * When querying algolia, the values stored in this attribute will
   * be translated into the `facetFilters` attribute.
   * @member {Object.<string, SearchParameters.FacetList>}
   */
  this.facetsRefinements = params.facetsRefinements || {};
  /**
   * This attribute contains all the filters that need to be
   * excluded from the conjunctive facets. Each facet must be properly
   * defined in the `facets` attribute.
   *
   * The key is the name of the facet, and the `FacetList` contains all
   * filters excluded for the associated facet name.
   *
   * When querying algolia, the values stored in this attribute will
   * be translated into the `facetFilters` attribute.
   * @member {Object.<string, SearchParameters.FacetList>}
   */
  this.facetsExcludes = params.facetsExcludes || {};
  /**
   * This attribute contains all the filters that need to be
   * applied on the disjunctive facets. Each facet must be properly
   * defined in the `disjunctiveFacets` attribute.
   *
   * The key is the name of the facet, and the `FacetList` contains all
   * filters selected for the associated facet name.
   *
   * When querying algolia, the values stored in this attribute will
   * be translated into the `facetFilters` attribute.
   * @member {Object.<string, SearchParameters.FacetList>}
   */
  this.disjunctiveFacetsRefinements = params.disjunctiveFacetsRefinements || {};
  /**
   * This attribute contains all the filters that need to be
   * applied on the numeric attributes.
   *
   * The key is the name of the attribute, and the value is the
   * filters to apply to this attribute.
   *
   * When querying algolia, the values stored in this attribute will
   * be translated into the `numericFilters` attribute.
   * @member {Object.<string, SearchParameters.OperatorList>}
   */
  this.numericRefinements = params.numericRefinements || {};
  /**
   * This attribute contains all the tags used to refine the query.
   *
   * When querying algolia, the values stored in this attribute will
   * be translated into the `tagFilters` attribute.
   * @member {string[]}
   */
  this.tagRefinements = params.tagRefinements || [];
  /**
   * This attribute contains all the filters that need to be
   * applied on the hierarchical facets. Each facet must be properly
   * defined in the `hierarchicalFacets` attribute.
   *
   * The key is the name of the facet, and the `FacetList` contains all
   * filters selected for the associated facet name. The FacetList values
   * are structured as a string that contain the values for each level
   * separated by the configured separator.
   *
   * When querying algolia, the values stored in this attribute will
   * be translated into the `facetFilters` attribute.
   * @member {Object.<string, SearchParameters.FacetList>}
   */
  this.hierarchicalFacetsRefinements = params.hierarchicalFacetsRefinements || {};

  var self = this;
  Object.keys(params).forEach(function(paramName) {
    var isKeyKnown = SearchParameters.PARAMETERS.indexOf(paramName) !== -1;
    var isValueDefined = params[paramName] !== undefined;

    if (!isKeyKnown && isValueDefined) {
      self[paramName] = params[paramName];
    }
  });
}

/**
 * List all the properties in SearchParameters and therefore all the known Algolia properties
 * This doesn't contain any beta/hidden features.
 * @private
 */
SearchParameters.PARAMETERS = Object.keys(new SearchParameters());

/**
 * @private
 * @param {object} partialState full or part of a state
 * @return {object} a new object with the number keys as number
 */
SearchParameters._parseNumbers = function(partialState) {
  // Do not reparse numbers in SearchParameters, they ought to be parsed already
  if (partialState instanceof SearchParameters) return partialState;

  var numbers = {};

  var numberKeys = [
    'aroundPrecision',
    'aroundRadius',
    'getRankingInfo',
    'minWordSizefor2Typos',
    'minWordSizefor1Typo',
    'page',
    'maxValuesPerFacet',
    'distinct',
    'minimumAroundRadius',
    'hitsPerPage',
    'minProximity'
  ];

  numberKeys.forEach(function(k) {
    var value = partialState[k];
    if (typeof value === 'string') {
      var parsedValue = parseFloat(value);
      // global isNaN is ok to use here, value is only number or NaN
      numbers[k] = isNaN(parsedValue) ? value : parsedValue;
    }
  });

  // there's two formats of insideBoundingBox, we need to parse
  // the one which is an array of float geo rectangles
  if (Array.isArray(partialState.insideBoundingBox)) {
    numbers.insideBoundingBox = partialState.insideBoundingBox.map(function(geoRect) {
      if (Array.isArray(geoRect)) {
        return geoRect.map(function(value) {
          return parseFloat(value);
        });
      }
      return geoRect;
    });
  }

  if (partialState.numericRefinements) {
    var numericRefinements = {};
    Object.keys(partialState.numericRefinements).forEach(function(attribute) {
      var operators = partialState.numericRefinements[attribute] || {};
      numericRefinements[attribute] = {};
      Object.keys(operators).forEach(function(operator) {
        var values = operators[operator];
        var parsedValues = values.map(function(v) {
          if (Array.isArray(v)) {
            return v.map(function(vPrime) {
              if (typeof vPrime === 'string') {
                return parseFloat(vPrime);
              }
              return vPrime;
            });
          } else if (typeof v === 'string') {
            return parseFloat(v);
          }
          return v;
        });
        numericRefinements[attribute][operator] = parsedValues;
      });
    });
    numbers.numericRefinements = numericRefinements;
  }

  return merge({}, partialState, numbers);
};

/**
 * Factory for SearchParameters
 * @param {object|SearchParameters} newParameters existing parameters or partial
 * object for the properties of a new SearchParameters
 * @return {SearchParameters} frozen instance of SearchParameters
 */
SearchParameters.make = function makeSearchParameters(newParameters) {
  var instance = new SearchParameters(newParameters);

  var hierarchicalFacets = newParameters.hierarchicalFacets || [];
  hierarchicalFacets.forEach(function(facet) {
    if (facet.rootPath) {
      var currentRefinement = instance.getHierarchicalRefinement(facet.name);

      if (currentRefinement.length > 0 && currentRefinement[0].indexOf(facet.rootPath) !== 0) {
        instance = instance.clearRefinements(facet.name);
      }

      // get it again in case it has been cleared
      currentRefinement = instance.getHierarchicalRefinement(facet.name);
      if (currentRefinement.length === 0) {
        instance = instance.toggleHierarchicalFacetRefinement(facet.name, facet.rootPath);
      }
    }
  });

  return instance;
};

/**
 * Validates the new parameters based on the previous state
 * @param {SearchParameters} currentState the current state
 * @param {object|SearchParameters} parameters the new parameters to set
 * @return {Error|null} Error if the modification is invalid, null otherwise
 */
SearchParameters.validate = function(currentState, parameters) {
  var params = parameters || {};

  if (currentState.tagFilters && params.tagRefinements && params.tagRefinements.length > 0) {
    return new Error(
      '[Tags] Cannot switch from the managed tag API to the advanced API. It is probably ' +
      'an error, if it is really what you want, you should first clear the tags with clearTags method.');
  }

  if (currentState.tagRefinements.length > 0 && params.tagFilters) {
    return new Error(
      '[Tags] Cannot switch from the advanced tag API to the managed API. It is probably ' +
      'an error, if it is not, you should first clear the tags with clearTags method.');
  }

  if (
    currentState.numericFilters &&
    params.numericRefinements &&
    objectHasKeys(params.numericRefinements)
  ) {
    return new Error(
      "[Numeric filters] Can't switch from the advanced to the managed API. It" +
        ' is probably an error, if this is really what you want, you have to first' +
        ' clear the numeric filters.'
    );
  }

  if (objectHasKeys(currentState.numericRefinements) && params.numericFilters) {
    return new Error(
      "[Numeric filters] Can't switch from the managed API to the advanced. It" +
      ' is probably an error, if this is really what you want, you have to first' +
      ' clear the numeric filters.');
  }

  return null;
};

SearchParameters.prototype = {
  constructor: SearchParameters,

  /**
   * Remove all refinements (disjunctive + conjunctive + excludes + numeric filters)
   * @method
   * @param {undefined|string|SearchParameters.clearCallback} [attribute] optional string or function
   * - If not given, means to clear all the filters.
   * - If `string`, means to clear all refinements for the `attribute` named filter.
   * - If `function`, means to clear all the refinements that return truthy values.
   * @return {SearchParameters}
   */
  clearRefinements: function clearRefinements(attribute) {
    var patch = {
      numericRefinements: this._clearNumericRefinements(attribute),
      facetsRefinements: RefinementList.clearRefinement(
        this.facetsRefinements,
        attribute,
        'conjunctiveFacet'
      ),
      facetsExcludes: RefinementList.clearRefinement(
        this.facetsExcludes,
        attribute,
        'exclude'
      ),
      disjunctiveFacetsRefinements: RefinementList.clearRefinement(
        this.disjunctiveFacetsRefinements,
        attribute,
        'disjunctiveFacet'
      ),
      hierarchicalFacetsRefinements: RefinementList.clearRefinement(
        this.hierarchicalFacetsRefinements,
        attribute,
        'hierarchicalFacet'
      )
    };
    if (
      patch.numericRefinements === this.numericRefinements &&
      patch.facetsRefinements === this.facetsRefinements &&
      patch.facetsExcludes === this.facetsExcludes &&
      patch.disjunctiveFacetsRefinements === this.disjunctiveFacetsRefinements &&
      patch.hierarchicalFacetsRefinements === this.hierarchicalFacetsRefinements
    ) {
      return this;
    }
    return this.setQueryParameters(patch);
  },
  /**
   * Remove all the refined tags from the SearchParameters
   * @method
   * @return {SearchParameters}
   */
  clearTags: function clearTags() {
    if (this.tagFilters === undefined && this.tagRefinements.length === 0) return this;

    return this.setQueryParameters({
      tagFilters: undefined,
      tagRefinements: []
    });
  },
  /**
   * Set the index.
   * @method
   * @param {string} index the index name
   * @return {SearchParameters}
   */
  setIndex: function setIndex(index) {
    if (index === this.index) return this;

    return this.setQueryParameters({
      index: index
    });
  },
  /**
   * Query setter
   * @method
   * @param {string} newQuery value for the new query
   * @return {SearchParameters}
   */
  setQuery: function setQuery(newQuery) {
    if (newQuery === this.query) return this;

    return this.setQueryParameters({
      query: newQuery
    });
  },
  /**
   * Page setter
   * @method
   * @param {number} newPage new page number
   * @return {SearchParameters}
   */
  setPage: function setPage(newPage) {
    if (newPage === this.page) return this;

    return this.setQueryParameters({
      page: newPage
    });
  },
  /**
   * Facets setter
   * The facets are the simple facets, used for conjunctive (and) faceting.
   * @method
   * @param {string[]} facets all the attributes of the algolia records used for conjunctive faceting
   * @return {SearchParameters}
   */
  setFacets: function setFacets(facets) {
    return this.setQueryParameters({
      facets: facets
    });
  },
  /**
   * Disjunctive facets setter
   * Change the list of disjunctive (or) facets the helper chan handle.
   * @method
   * @param {string[]} facets all the attributes of the algolia records used for disjunctive faceting
   * @return {SearchParameters}
   */
  setDisjunctiveFacets: function setDisjunctiveFacets(facets) {
    return this.setQueryParameters({
      disjunctiveFacets: facets
    });
  },
  /**
   * HitsPerPage setter
   * Hits per page represents the number of hits retrieved for this query
   * @method
   * @param {number} n number of hits retrieved per page of results
   * @return {SearchParameters}
   */
  setHitsPerPage: function setHitsPerPage(n) {
    if (this.hitsPerPage === n) return this;

    return this.setQueryParameters({
      hitsPerPage: n
    });
  },
  /**
   * typoTolerance setter
   * Set the value of typoTolerance
   * @method
   * @param {string} typoTolerance new value of typoTolerance ("true", "false", "min" or "strict")
   * @return {SearchParameters}
   */
  setTypoTolerance: function setTypoTolerance(typoTolerance) {
    if (this.typoTolerance === typoTolerance) return this;

    return this.setQueryParameters({
      typoTolerance: typoTolerance
    });
  },
  /**
   * Add a numeric filter for a given attribute
   * When value is an array, they are combined with OR
   * When value is a single value, it will combined with AND
   * @method
   * @param {string} attribute attribute to set the filter on
   * @param {string} operator operator of the filter (possible values: =, >, >=, <, <=, !=)
   * @param {number | number[]} value value of the filter
   * @return {SearchParameters}
   * @example
   * // for price = 50 or 40
   * searchparameter.addNumericRefinement('price', '=', [50, 40]);
   * @example
   * // for size = 38 and 40
   * searchparameter.addNumericRefinement('size', '=', 38);
   * searchparameter.addNumericRefinement('size', '=', 40);
   */
  addNumericRefinement: function(attribute, operator, v) {
    var value = valToNumber(v);

    if (this.isNumericRefined(attribute, operator, value)) return this;

    var mod = merge({}, this.numericRefinements);

    mod[attribute] = merge({}, mod[attribute]);

    if (mod[attribute][operator]) {
      // Array copy
      mod[attribute][operator] = mod[attribute][operator].slice();
      // Add the element. Concat can't be used here because value can be an array.
      mod[attribute][operator].push(value);
    } else {
      mod[attribute][operator] = [value];
    }

    return this.setQueryParameters({
      numericRefinements: mod
    });
  },
  /**
   * Get the list of conjunctive refinements for a single facet
   * @param {string} facetName name of the attribute used for faceting
   * @return {string[]} list of refinements
   */
  getConjunctiveRefinements: function(facetName) {
    if (!this.isConjunctiveFacet(facetName)) {
      return [];
    }
    return this.facetsRefinements[facetName] || [];
  },
  /**
   * Get the list of disjunctive refinements for a single facet
   * @param {string} facetName name of the attribute used for faceting
   * @return {string[]} list of refinements
   */
  getDisjunctiveRefinements: function(facetName) {
    if (!this.isDisjunctiveFacet(facetName)) {
      return [];
    }
    return this.disjunctiveFacetsRefinements[facetName] || [];
  },
  /**
   * Get the list of hierarchical refinements for a single facet
   * @param {string} facetName name of the attribute used for faceting
   * @return {string[]} list of refinements
   */
  getHierarchicalRefinement: function(facetName) {
    // we send an array but we currently do not support multiple
    // hierarchicalRefinements for a hierarchicalFacet
    return this.hierarchicalFacetsRefinements[facetName] || [];
  },
  /**
   * Get the list of exclude refinements for a single facet
   * @param {string} facetName name of the attribute used for faceting
   * @return {string[]} list of refinements
   */
  getExcludeRefinements: function(facetName) {
    if (!this.isConjunctiveFacet(facetName)) {
      return [];
    }
    return this.facetsExcludes[facetName] || [];
  },

  /**
   * Remove all the numeric filter for a given (attribute, operator)
   * @method
   * @param {string} attribute attribute to set the filter on
   * @param {string} [operator] operator of the filter (possible values: =, >, >=, <, <=, !=)
   * @param {number} [number] the value to be removed
   * @return {SearchParameters}
   */
  removeNumericRefinement: function(attribute, operator, paramValue) {
    if (paramValue !== undefined) {
      if (!this.isNumericRefined(attribute, operator, paramValue)) {
        return this;
      }
      return this.setQueryParameters({
        numericRefinements: this._clearNumericRefinements(function(value, key) {
          return (
            key === attribute &&
            value.op === operator &&
            isEqualNumericRefinement(value.val, valToNumber(paramValue))
          );
        })
      });
    } else if (operator !== undefined) {
      if (!this.isNumericRefined(attribute, operator)) return this;
      return this.setQueryParameters({
        numericRefinements: this._clearNumericRefinements(function(value, key) {
          return key === attribute && value.op === operator;
        })
      });
    }

    if (!this.isNumericRefined(attribute)) return this;
    return this.setQueryParameters({
      numericRefinements: this._clearNumericRefinements(function(value, key) {
        return key === attribute;
      })
    });
  },
  /**
   * Get the list of numeric refinements for a single facet
   * @param {string} facetName name of the attribute used for faceting
   * @return {SearchParameters.OperatorList} list of refinements
   */
  getNumericRefinements: function(facetName) {
    return this.numericRefinements[facetName] || {};
  },
  /**
   * Return the current refinement for the (attribute, operator)
   * @param {string} attribute attribute in the record
   * @param {string} operator operator applied on the refined values
   * @return {Array.<number|number[]>} refined values
   */
  getNumericRefinement: function(attribute, operator) {
    return this.numericRefinements[attribute] && this.numericRefinements[attribute][operator];
  },
  /**
   * Clear numeric filters.
   * @method
   * @private
   * @param {string|SearchParameters.clearCallback} [attribute] optional string or function
   * - If not given, means to clear all the filters.
   * - If `string`, means to clear all refinements for the `attribute` named filter.
   * - If `function`, means to clear all the refinements that return truthy values.
   * @return {Object.<string, OperatorList>}
   */
  _clearNumericRefinements: function _clearNumericRefinements(attribute) {
    if (attribute === undefined) {
      if (!objectHasKeys(this.numericRefinements)) {
        return this.numericRefinements;
      }
      return {};
    } else if (typeof attribute === 'string') {
      return omit(this.numericRefinements, [attribute]);
    } else if (typeof attribute === 'function') {
      var hasChanged = false;
      var numericRefinements = this.numericRefinements;
      var newNumericRefinements = Object.keys(numericRefinements).reduce(function(memo, key) {
        var operators = numericRefinements[key];
        var operatorList = {};

        operators = operators || {};
        Object.keys(operators).forEach(function(operator) {
          var values = operators[operator] || [];
          var outValues = [];
          values.forEach(function(value) {
            var predicateResult = attribute({val: value, op: operator}, key, 'numeric');
            if (!predicateResult) outValues.push(value);
          });
          if (outValues.length !== values.length) {
            hasChanged = true;
          }
          operatorList[operator] = outValues;
        });

        memo[key] = operatorList;

        return memo;
      }, {});

      if (hasChanged) return newNumericRefinements;
      return this.numericRefinements;
    }
  },
  /**
   * Add a facet to the facets attribute of the helper configuration, if it
   * isn't already present.
   * @method
   * @param {string} facet facet name to add
   * @return {SearchParameters}
   */
  addFacet: function addFacet(facet) {
    if (this.isConjunctiveFacet(facet)) {
      return this;
    }

    return this.setQueryParameters({
      facets: this.facets.concat([facet])
    });
  },
  /**
   * Add a disjunctive facet to the disjunctiveFacets attribute of the helper
   * configuration, if it isn't already present.
   * @method
   * @param {string} facet disjunctive facet name to add
   * @return {SearchParameters}
   */
  addDisjunctiveFacet: function addDisjunctiveFacet(facet) {
    if (this.isDisjunctiveFacet(facet)) {
      return this;
    }

    return this.setQueryParameters({
      disjunctiveFacets: this.disjunctiveFacets.concat([facet])
    });
  },
  /**
   * Add a hierarchical facet to the hierarchicalFacets attribute of the helper
   * configuration.
   * @method
   * @param {object} hierarchicalFacet hierarchical facet to add
   * @return {SearchParameters}
   * @throws will throw an error if a hierarchical facet with the same name was already declared
   */
  addHierarchicalFacet: function addHierarchicalFacet(hierarchicalFacet) {
    if (this.isHierarchicalFacet(hierarchicalFacet.name)) {
      throw new Error(
        'Cannot declare two hierarchical facets with the same name: `' + hierarchicalFacet.name + '`');
    }

    return this.setQueryParameters({
      hierarchicalFacets: this.hierarchicalFacets.concat([hierarchicalFacet])
    });
  },
  /**
   * Add a refinement on a "normal" facet
   * @method
   * @param {string} facet attribute to apply the faceting on
   * @param {string} value value of the attribute (will be converted to string)
   * @return {SearchParameters}
   */
  addFacetRefinement: function addFacetRefinement(facet, value) {
    if (!this.isConjunctiveFacet(facet)) {
      throw new Error(facet + ' is not defined in the facets attribute of the helper configuration');
    }
    if (RefinementList.isRefined(this.facetsRefinements, facet, value)) return this;

    return this.setQueryParameters({
      facetsRefinements: RefinementList.addRefinement(this.facetsRefinements, facet, value)
    });
  },
  /**
   * Exclude a value from a "normal" facet
   * @method
   * @param {string} facet attribute to apply the exclusion on
   * @param {string} value value of the attribute (will be converted to string)
   * @return {SearchParameters}
   */
  addExcludeRefinement: function addExcludeRefinement(facet, value) {
    if (!this.isConjunctiveFacet(facet)) {
      throw new Error(facet + ' is not defined in the facets attribute of the helper configuration');
    }
    if (RefinementList.isRefined(this.facetsExcludes, facet, value)) return this;

    return this.setQueryParameters({
      facetsExcludes: RefinementList.addRefinement(this.facetsExcludes, facet, value)
    });
  },
  /**
   * Adds a refinement on a disjunctive facet.
   * @method
   * @param {string} facet attribute to apply the faceting on
   * @param {string} value value of the attribute (will be converted to string)
   * @return {SearchParameters}
   */
  addDisjunctiveFacetRefinement: function addDisjunctiveFacetRefinement(facet, value) {
    if (!this.isDisjunctiveFacet(facet)) {
      throw new Error(
        facet + ' is not defined in the disjunctiveFacets attribute of the helper configuration');
    }

    if (RefinementList.isRefined(this.disjunctiveFacetsRefinements, facet, value)) return this;

    return this.setQueryParameters({
      disjunctiveFacetsRefinements: RefinementList.addRefinement(
        this.disjunctiveFacetsRefinements, facet, value)
    });
  },
  /**
   * addTagRefinement adds a tag to the list used to filter the results
   * @param {string} tag tag to be added
   * @return {SearchParameters}
   */
  addTagRefinement: function addTagRefinement(tag) {
    if (this.isTagRefined(tag)) return this;

    var modification = {
      tagRefinements: this.tagRefinements.concat(tag)
    };

    return this.setQueryParameters(modification);
  },
  /**
   * Remove a facet from the facets attribute of the helper configuration, if it
   * is present.
   * @method
   * @param {string} facet facet name to remove
   * @return {SearchParameters}
   */
  removeFacet: function removeFacet(facet) {
    if (!this.isConjunctiveFacet(facet)) {
      return this;
    }

    return this.clearRefinements(facet).setQueryParameters({
      facets: this.facets.filter(function(f) {
        return f !== facet;
      })
    });
  },
  /**
   * Remove a disjunctive facet from the disjunctiveFacets attribute of the
   * helper configuration, if it is present.
   * @method
   * @param {string} facet disjunctive facet name to remove
   * @return {SearchParameters}
   */
  removeDisjunctiveFacet: function removeDisjunctiveFacet(facet) {
    if (!this.isDisjunctiveFacet(facet)) {
      return this;
    }

    return this.clearRefinements(facet).setQueryParameters({
      disjunctiveFacets: this.disjunctiveFacets.filter(function(f) {
        return f !== facet;
      })
    });
  },
  /**
   * Remove a hierarchical facet from the hierarchicalFacets attribute of the
   * helper configuration, if it is present.
   * @method
   * @param {string} facet hierarchical facet name to remove
   * @return {SearchParameters}
   */
  removeHierarchicalFacet: function removeHierarchicalFacet(facet) {
    if (!this.isHierarchicalFacet(facet)) {
      return this;
    }

    return this.clearRefinements(facet).setQueryParameters({
      hierarchicalFacets: this.hierarchicalFacets.filter(function(f) {
        return f.name !== facet;
      })
    });
  },
  /**
   * Remove a refinement set on facet. If a value is provided, it will clear the
   * refinement for the given value, otherwise it will clear all the refinement
   * values for the faceted attribute.
   * @method
   * @param {string} facet name of the attribute used for faceting
   * @param {string} [value] value used to filter
   * @return {SearchParameters}
   */
  removeFacetRefinement: function removeFacetRefinement(facet, value) {
    if (!this.isConjunctiveFacet(facet)) {
      throw new Error(facet + ' is not defined in the facets attribute of the helper configuration');
    }
    if (!RefinementList.isRefined(this.facetsRefinements, facet, value)) return this;

    return this.setQueryParameters({
      facetsRefinements: RefinementList.removeRefinement(this.facetsRefinements, facet, value)
    });
  },
  /**
   * Remove a negative refinement on a facet
   * @method
   * @param {string} facet name of the attribute used for faceting
   * @param {string} value value used to filter
   * @return {SearchParameters}
   */
  removeExcludeRefinement: function removeExcludeRefinement(facet, value) {
    if (!this.isConjunctiveFacet(facet)) {
      throw new Error(facet + ' is not defined in the facets attribute of the helper configuration');
    }
    if (!RefinementList.isRefined(this.facetsExcludes, facet, value)) return this;

    return this.setQueryParameters({
      facetsExcludes: RefinementList.removeRefinement(this.facetsExcludes, facet, value)
    });
  },
  /**
   * Remove a refinement on a disjunctive facet
   * @method
   * @param {string} facet name of the attribute used for faceting
   * @param {string} value value used to filter
   * @return {SearchParameters}
   */
  removeDisjunctiveFacetRefinement: function removeDisjunctiveFacetRefinement(facet, value) {
    if (!this.isDisjunctiveFacet(facet)) {
      throw new Error(
        facet + ' is not defined in the disjunctiveFacets attribute of the helper configuration');
    }
    if (!RefinementList.isRefined(this.disjunctiveFacetsRefinements, facet, value)) return this;

    return this.setQueryParameters({
      disjunctiveFacetsRefinements: RefinementList.removeRefinement(
        this.disjunctiveFacetsRefinements, facet, value)
    });
  },
  /**
   * Remove a tag from the list of tag refinements
   * @method
   * @param {string} tag the tag to remove
   * @return {SearchParameters}
   */
  removeTagRefinement: function removeTagRefinement(tag) {
    if (!this.isTagRefined(tag)) return this;

    var modification = {
      tagRefinements: this.tagRefinements.filter(function(t) {
        return t !== tag;
      })
    };

    return this.setQueryParameters(modification);
  },
  /**
   * Generic toggle refinement method to use with facet, disjunctive facets
   * and hierarchical facets
   * @param  {string} facet the facet to refine
   * @param  {string} value the associated value
   * @return {SearchParameters}
   * @throws will throw an error if the facet is not declared in the settings of the helper
   * @deprecated since version 2.19.0, see {@link SearchParameters#toggleFacetRefinement}
   */
  toggleRefinement: function toggleRefinement(facet, value) {
    return this.toggleFacetRefinement(facet, value);
  },
  /**
   * Generic toggle refinement method to use with facet, disjunctive facets
   * and hierarchical facets
   * @param  {string} facet the facet to refine
   * @param  {string} value the associated value
   * @return {SearchParameters}
   * @throws will throw an error if the facet is not declared in the settings of the helper
   */
  toggleFacetRefinement: function toggleFacetRefinement(facet, value) {
    if (this.isHierarchicalFacet(facet)) {
      return this.toggleHierarchicalFacetRefinement(facet, value);
    } else if (this.isConjunctiveFacet(facet)) {
      return this.toggleConjunctiveFacetRefinement(facet, value);
    } else if (this.isDisjunctiveFacet(facet)) {
      return this.toggleDisjunctiveFacetRefinement(facet, value);
    }

    throw new Error('Cannot refine the undeclared facet ' + facet +
      '; it should be added to the helper options facets, disjunctiveFacets or hierarchicalFacets');
  },
  /**
   * Switch the refinement applied over a facet/value
   * @method
   * @param {string} facet name of the attribute used for faceting
   * @param {value} value value used for filtering
   * @return {SearchParameters}
   */
  toggleConjunctiveFacetRefinement: function toggleConjunctiveFacetRefinement(facet, value) {
    if (!this.isConjunctiveFacet(facet)) {
      throw new Error(facet + ' is not defined in the facets attribute of the helper configuration');
    }

    return this.setQueryParameters({
      facetsRefinements: RefinementList.toggleRefinement(this.facetsRefinements, facet, value)
    });
  },
  /**
   * Switch the refinement applied over a facet/value
   * @method
   * @param {string} facet name of the attribute used for faceting
   * @param {value} value value used for filtering
   * @return {SearchParameters}
   */
  toggleExcludeFacetRefinement: function toggleExcludeFacetRefinement(facet, value) {
    if (!this.isConjunctiveFacet(facet)) {
      throw new Error(facet + ' is not defined in the facets attribute of the helper configuration');
    }

    return this.setQueryParameters({
      facetsExcludes: RefinementList.toggleRefinement(this.facetsExcludes, facet, value)
    });
  },
  /**
   * Switch the refinement applied over a facet/value
   * @method
   * @param {string} facet name of the attribute used for faceting
   * @param {value} value value used for filtering
   * @return {SearchParameters}
   */
  toggleDisjunctiveFacetRefinement: function toggleDisjunctiveFacetRefinement(facet, value) {
    if (!this.isDisjunctiveFacet(facet)) {
      throw new Error(
        facet + ' is not defined in the disjunctiveFacets attribute of the helper configuration');
    }

    return this.setQueryParameters({
      disjunctiveFacetsRefinements: RefinementList.toggleRefinement(
        this.disjunctiveFacetsRefinements, facet, value)
    });
  },
  /**
   * Switch the refinement applied over a facet/value
   * @method
   * @param {string} facet name of the attribute used for faceting
   * @param {value} value value used for filtering
   * @return {SearchParameters}
   */
  toggleHierarchicalFacetRefinement: function toggleHierarchicalFacetRefinement(facet, value) {
    if (!this.isHierarchicalFacet(facet)) {
      throw new Error(
        facet + ' is not defined in the hierarchicalFacets attribute of the helper configuration');
    }

    var separator = this._getHierarchicalFacetSeparator(this.getHierarchicalFacetByName(facet));

    var mod = {};

    var upOneOrMultipleLevel = this.hierarchicalFacetsRefinements[facet] !== undefined &&
      this.hierarchicalFacetsRefinements[facet].length > 0 && (
      // remove current refinement:
      // refinement was 'beer > IPA', call is toggleRefine('beer > IPA'), refinement should be `beer`
      this.hierarchicalFacetsRefinements[facet][0] === value ||
      // remove a parent refinement of the current refinement:
      //  - refinement was 'beer > IPA > Flying dog'
      //  - call is toggleRefine('beer > IPA')
      //  - refinement should be `beer`
      this.hierarchicalFacetsRefinements[facet][0].indexOf(value + separator) === 0
    );

    if (upOneOrMultipleLevel) {
      if (value.indexOf(separator) === -1) {
        // go back to root level
        mod[facet] = [];
      } else {
        mod[facet] = [value.slice(0, value.lastIndexOf(separator))];
      }
    } else {
      mod[facet] = [value];
    }

    return this.setQueryParameters({
      hierarchicalFacetsRefinements: defaultsPure({}, mod, this.hierarchicalFacetsRefinements)
    });
  },

  /**
   * Adds a refinement on a hierarchical facet.
   * @param {string} facet the facet name
   * @param {string} path the hierarchical facet path
   * @return {SearchParameter} the new state
   * @throws Error if the facet is not defined or if the facet is refined
   */
  addHierarchicalFacetRefinement: function(facet, path) {
    if (this.isHierarchicalFacetRefined(facet)) {
      throw new Error(facet + ' is already refined.');
    }
    if (!this.isHierarchicalFacet(facet)) {
      throw new Error(facet + ' is not defined in the hierarchicalFacets attribute of the helper configuration.');
    }
    var mod = {};
    mod[facet] = [path];
    return this.setQueryParameters({
      hierarchicalFacetsRefinements: defaultsPure({}, mod, this.hierarchicalFacetsRefinements)
    });
  },

  /**
   * Removes the refinement set on a hierarchical facet.
   * @param {string} facet the facet name
   * @return {SearchParameter} the new state
   * @throws Error if the facet is not defined or if the facet is not refined
   */
  removeHierarchicalFacetRefinement: function(facet) {
    if (!this.isHierarchicalFacetRefined(facet)) {
      return this;
    }
    var mod = {};
    mod[facet] = [];
    return this.setQueryParameters({
      hierarchicalFacetsRefinements: defaultsPure({}, mod, this.hierarchicalFacetsRefinements)
    });
  },
  /**
   * Switch the tag refinement
   * @method
   * @param {string} tag the tag to remove or add
   * @return {SearchParameters}
   */
  toggleTagRefinement: function toggleTagRefinement(tag) {
    if (this.isTagRefined(tag)) {
      return this.removeTagRefinement(tag);
    }

    return this.addTagRefinement(tag);
  },
  /**
   * Test if the facet name is from one of the disjunctive facets
   * @method
   * @param {string} facet facet name to test
   * @return {boolean}
   */
  isDisjunctiveFacet: function(facet) {
    return this.disjunctiveFacets.indexOf(facet) > -1;
  },
  /**
   * Test if the facet name is from one of the hierarchical facets
   * @method
   * @param {string} facetName facet name to test
   * @return {boolean}
   */
  isHierarchicalFacet: function(facetName) {
    return this.getHierarchicalFacetByName(facetName) !== undefined;
  },
  /**
   * Test if the facet name is from one of the conjunctive/normal facets
   * @method
   * @param {string} facet facet name to test
   * @return {boolean}
   */
  isConjunctiveFacet: function(facet) {
    return this.facets.indexOf(facet) > -1;
  },
  /**
   * Returns true if the facet is refined, either for a specific value or in
   * general.
   * @method
   * @param {string} facet name of the attribute for used for faceting
   * @param {string} value, optional value. If passed will test that this value
   * is filtering the given facet.
   * @return {boolean} returns true if refined
   */
  isFacetRefined: function isFacetRefined(facet, value) {
    if (!this.isConjunctiveFacet(facet)) {
      return false;
    }
    return RefinementList.isRefined(this.facetsRefinements, facet, value);
  },
  /**
   * Returns true if the facet contains exclusions or if a specific value is
   * excluded.
   *
   * @method
   * @param {string} facet name of the attribute for used for faceting
   * @param {string} [value] optional value. If passed will test that this value
   * is filtering the given facet.
   * @return {boolean} returns true if refined
   */
  isExcludeRefined: function isExcludeRefined(facet, value) {
    if (!this.isConjunctiveFacet(facet)) {
      return false;
    }
    return RefinementList.isRefined(this.facetsExcludes, facet, value);
  },
  /**
   * Returns true if the facet contains a refinement, or if a value passed is a
   * refinement for the facet.
   * @method
   * @param {string} facet name of the attribute for used for faceting
   * @param {string} value optional, will test if the value is used for refinement
   * if there is one, otherwise will test if the facet contains any refinement
   * @return {boolean}
   */
  isDisjunctiveFacetRefined: function isDisjunctiveFacetRefined(facet, value) {
    if (!this.isDisjunctiveFacet(facet)) {
      return false;
    }
    return RefinementList.isRefined(this.disjunctiveFacetsRefinements, facet, value);
  },
  /**
   * Returns true if the facet contains a refinement, or if a value passed is a
   * refinement for the facet.
   * @method
   * @param {string} facet name of the attribute for used for faceting
   * @param {string} value optional, will test if the value is used for refinement
   * if there is one, otherwise will test if the facet contains any refinement
   * @return {boolean}
   */
  isHierarchicalFacetRefined: function isHierarchicalFacetRefined(facet, value) {
    if (!this.isHierarchicalFacet(facet)) {
      return false;
    }

    var refinements = this.getHierarchicalRefinement(facet);

    if (!value) {
      return refinements.length > 0;
    }

    return refinements.indexOf(value) !== -1;
  },
  /**
   * Test if the triple (attribute, operator, value) is already refined.
   * If only the attribute and the operator are provided, it tests if the
   * contains any refinement value.
   * @method
   * @param {string} attribute attribute for which the refinement is applied
   * @param {string} [operator] operator of the refinement
   * @param {string} [value] value of the refinement
   * @return {boolean} true if it is refined
   */
  isNumericRefined: function isNumericRefined(attribute, operator, value) {
    if (value === undefined && operator === undefined) {
      return !!this.numericRefinements[attribute];
    }

    var isOperatorDefined =
      this.numericRefinements[attribute] &&
      this.numericRefinements[attribute][operator] !== undefined;

    if (value === undefined || !isOperatorDefined) {
      return isOperatorDefined;
    }

    var parsedValue = valToNumber(value);
    var isAttributeValueDefined =
      findArray(this.numericRefinements[attribute][operator], parsedValue) !==
      undefined;

    return isOperatorDefined && isAttributeValueDefined;
  },
  /**
   * Returns true if the tag refined, false otherwise
   * @method
   * @param {string} tag the tag to check
   * @return {boolean}
   */
  isTagRefined: function isTagRefined(tag) {
    return this.tagRefinements.indexOf(tag) !== -1;
  },
  /**
   * Returns the list of all disjunctive facets refined
   * @method
   * @param {string} facet name of the attribute used for faceting
   * @param {value} value value used for filtering
   * @return {string[]}
   */
  getRefinedDisjunctiveFacets: function getRefinedDisjunctiveFacets() {
    var self = this;

    // attributes used for numeric filter can also be disjunctive
    var disjunctiveNumericRefinedFacets = intersection(
      Object.keys(this.numericRefinements).filter(function(facet) {
        return Object.keys(self.numericRefinements[facet]).length > 0;
      }),
      this.disjunctiveFacets
    );

    return Object.keys(this.disjunctiveFacetsRefinements).filter(function(facet) {
      return self.disjunctiveFacetsRefinements[facet].length > 0;
    })
      .concat(disjunctiveNumericRefinedFacets)
      .concat(this.getRefinedHierarchicalFacets());
  },
  /**
   * Returns the list of all disjunctive facets refined
   * @method
   * @param {string} facet name of the attribute used for faceting
   * @param {value} value value used for filtering
   * @return {string[]}
   */
  getRefinedHierarchicalFacets: function getRefinedHierarchicalFacets() {
    var self = this;
    return intersection(
      // enforce the order between the two arrays,
      // so that refinement name index === hierarchical facet index
      this.hierarchicalFacets.map(function(facet) { return facet.name; }),
      Object.keys(this.hierarchicalFacetsRefinements).filter(function(facet) {
        return self.hierarchicalFacetsRefinements[facet].length > 0;
      })
    );
  },
  /**
   * Returned the list of all disjunctive facets not refined
   * @method
   * @return {string[]}
   */
  getUnrefinedDisjunctiveFacets: function() {
    var refinedFacets = this.getRefinedDisjunctiveFacets();

    return this.disjunctiveFacets.filter(function(f) {
      return refinedFacets.indexOf(f) === -1;
    });
  },

  managedParameters: [
    'index',

    'facets',
    'disjunctiveFacets',
    'facetsRefinements',
    'hierarchicalFacets',
    'facetsExcludes',

    'disjunctiveFacetsRefinements',
    'numericRefinements',
    'tagRefinements',
    'hierarchicalFacetsRefinements'
  ],
  getQueryParams: function getQueryParams() {
    var managedParameters = this.managedParameters;

    var queryParams = {};

    var self = this;
    Object.keys(this).forEach(function(paramName) {
      var paramValue = self[paramName];
      if (managedParameters.indexOf(paramName) === -1 && paramValue !== undefined) {
        queryParams[paramName] = paramValue;
      }
    });

    return queryParams;
  },
  /**
   * Let the user set a specific value for a given parameter. Will return the
   * same instance if the parameter is invalid or if the value is the same as the
   * previous one.
   * @method
   * @param {string} parameter the parameter name
   * @param {any} value the value to be set, must be compliant with the definition
   * of the attribute on the object
   * @return {SearchParameters} the updated state
   */
  setQueryParameter: function setParameter(parameter, value) {
    if (this[parameter] === value) return this;

    var modification = {};

    modification[parameter] = value;

    return this.setQueryParameters(modification);
  },
  /**
   * Let the user set any of the parameters with a plain object.
   * @method
   * @param {object} params all the keys and the values to be updated
   * @return {SearchParameters} a new updated instance
   */
  setQueryParameters: function setQueryParameters(params) {
    if (!params) return this;

    var error = SearchParameters.validate(this, params);

    if (error) {
      throw error;
    }

    var self = this;
    var nextWithNumbers = SearchParameters._parseNumbers(params);
    var previousPlainObject = Object.keys(this).reduce(function(acc, key) {
      acc[key] = self[key];
      return acc;
    }, {});

    var nextPlainObject = Object.keys(nextWithNumbers).reduce(
      function(previous, key) {
        var isPreviousValueDefined = previous[key] !== undefined;
        var isNextValueDefined = nextWithNumbers[key] !== undefined;

        if (isPreviousValueDefined && !isNextValueDefined) {
          return omit(previous, [key]);
        }

        if (isNextValueDefined) {
          previous[key] = nextWithNumbers[key];
        }

        return previous;
      },
      previousPlainObject
    );

    return new this.constructor(nextPlainObject);
  },

  /**
   * Returns a new instance with the page reset. Two scenarios possible:
   * the page is omitted -> return the given instance
   * the page is set -> return a new instance with a page of 0
   * @return {SearchParameters} a new updated instance
   */
  resetPage: function() {
    if (this.page === undefined) {
      return this;
    }

    return this.setPage(0);
  },

  /**
   * Helper function to get the hierarchicalFacet separator or the default one (`>`)
   * @param  {object} hierarchicalFacet
   * @return {string} returns the hierarchicalFacet.separator or `>` as default
   */
  _getHierarchicalFacetSortBy: function(hierarchicalFacet) {
    return hierarchicalFacet.sortBy || ['isRefined:desc', 'name:asc'];
  },

  /**
   * Helper function to get the hierarchicalFacet separator or the default one (`>`)
   * @private
   * @param  {object} hierarchicalFacet
   * @return {string} returns the hierarchicalFacet.separator or `>` as default
   */
  _getHierarchicalFacetSeparator: function(hierarchicalFacet) {
    return hierarchicalFacet.separator || ' > ';
  },

  /**
   * Helper function to get the hierarchicalFacet prefix path or null
   * @private
   * @param  {object} hierarchicalFacet
   * @return {string} returns the hierarchicalFacet.rootPath or null as default
   */
  _getHierarchicalRootPath: function(hierarchicalFacet) {
    return hierarchicalFacet.rootPath || null;
  },

  /**
   * Helper function to check if we show the parent level of the hierarchicalFacet
   * @private
   * @param  {object} hierarchicalFacet
   * @return {string} returns the hierarchicalFacet.showParentLevel or true as default
   */
  _getHierarchicalShowParentLevel: function(hierarchicalFacet) {
    if (typeof hierarchicalFacet.showParentLevel === 'boolean') {
      return hierarchicalFacet.showParentLevel;
    }
    return true;
  },

  /**
   * Helper function to get the hierarchicalFacet by it's name
   * @param  {string} hierarchicalFacetName
   * @return {object} a hierarchicalFacet
   */
  getHierarchicalFacetByName: function(hierarchicalFacetName) {
    return find(
      this.hierarchicalFacets,
      function(f) {
        return f.name === hierarchicalFacetName;
      }
    );
  },

  /**
   * Get the current breadcrumb for a hierarchical facet, as an array
   * @param  {string} facetName Hierarchical facet name
   * @return {array.<string>} the path as an array of string
   */
  getHierarchicalFacetBreadcrumb: function(facetName) {
    if (!this.isHierarchicalFacet(facetName)) {
      return [];
    }

    var refinement = this.getHierarchicalRefinement(facetName)[0];
    if (!refinement) return [];

    var separator = this._getHierarchicalFacetSeparator(
      this.getHierarchicalFacetByName(facetName)
    );
    var path = refinement.split(separator);
    return path.map(function(part) {
      return part.trim();
    });
  },

  toString: function() {
    return JSON.stringify(this, null, 2);
  }
};

/**
 * Callback used for clearRefinement method
 * @callback SearchParameters.clearCallback
 * @param {OperatorList|FacetList} value the value of the filter
 * @param {string} key the current attribute name
 * @param {string} type `numeric`, `disjunctiveFacet`, `conjunctiveFacet`, `hierarchicalFacet` or `exclude`
 * depending on the type of facet
 * @return {boolean} `true` if the element should be removed. `false` otherwise.
 */
module.exports = SearchParameters;


/***/ }),

/***/ 4308:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


module.exports = generateTrees;

var orderBy = __webpack_require__(71539);
var find = __webpack_require__(38901);
var prepareHierarchicalFacetSortBy = __webpack_require__(28441);
var fv = __webpack_require__(23433);
var escapeFacetValue = fv.escapeFacetValue;
var unescapeFacetValue = fv.unescapeFacetValue;

function generateTrees(state) {
  return function generate(hierarchicalFacetResult, hierarchicalFacetIndex) {
    var hierarchicalFacet = state.hierarchicalFacets[hierarchicalFacetIndex];
    var hierarchicalFacetRefinement =
      (state.hierarchicalFacetsRefinements[hierarchicalFacet.name] &&
        state.hierarchicalFacetsRefinements[hierarchicalFacet.name][0]) ||
      '';
    var hierarchicalSeparator = state._getHierarchicalFacetSeparator(
      hierarchicalFacet
    );
    var hierarchicalRootPath = state._getHierarchicalRootPath(
      hierarchicalFacet
    );
    var hierarchicalShowParentLevel = state._getHierarchicalShowParentLevel(
      hierarchicalFacet
    );
    var sortBy = prepareHierarchicalFacetSortBy(
      state._getHierarchicalFacetSortBy(hierarchicalFacet)
    );

    var rootExhaustive = hierarchicalFacetResult.every(function(facetResult) {
      return facetResult.exhaustive;
    });

    var generateTreeFn = generateHierarchicalTree(
      sortBy,
      hierarchicalSeparator,
      hierarchicalRootPath,
      hierarchicalShowParentLevel,
      hierarchicalFacetRefinement
    );

    var results = hierarchicalFacetResult;

    if (hierarchicalRootPath) {
      results = hierarchicalFacetResult.slice(
        hierarchicalRootPath.split(hierarchicalSeparator).length
      );
    }

    return results.reduce(generateTreeFn, {
      name: state.hierarchicalFacets[hierarchicalFacetIndex].name,
      count: null, // root level, no count
      isRefined: true, // root level, always refined
      path: null, // root level, no path
      escapedValue: null,
      exhaustive: rootExhaustive,
      data: null
    });
  };
}

function generateHierarchicalTree(
  sortBy,
  hierarchicalSeparator,
  hierarchicalRootPath,
  hierarchicalShowParentLevel,
  currentRefinement
) {
  return function generateTree(
    hierarchicalTree,
    hierarchicalFacetResult,
    currentHierarchicalLevel
  ) {
    var parent = hierarchicalTree;

    if (currentHierarchicalLevel > 0) {
      var level = 0;

      parent = hierarchicalTree;

      while (level < currentHierarchicalLevel) {
        /**
         * @type {object[]]} hierarchical data
         */
        var data = parent && Array.isArray(parent.data) ? parent.data : [];
        parent = find(data, function(subtree) {
          return subtree.isRefined;
        });
        level++;
      }
    }

    // we found a refined parent, let's add current level data under it
    if (parent) {
      // filter values in case an object has multiple categories:
      //   {
      //     categories: {
      //       level0: ['beers', 'bières'],
      //       level1: ['beers > IPA', 'bières > Belges']
      //     }
      //   }
      //
      // If parent refinement is `beers`, then we do not want to have `bières > Belges`
      // showing up

      var picked = Object.keys(hierarchicalFacetResult.data)
        .map(function(facetValue) {
          return [facetValue, hierarchicalFacetResult.data[facetValue]];
        })
        .filter(function(tuple) {
          var facetValue = tuple[0];
          return onlyMatchingTree(
            facetValue,
            parent.path || hierarchicalRootPath,
            currentRefinement,
            hierarchicalSeparator,
            hierarchicalRootPath,
            hierarchicalShowParentLevel
          );
        });

      parent.data = orderBy(
        picked.map(function(tuple) {
          var facetValue = tuple[0];
          var facetCount = tuple[1];

          return format(
            facetCount,
            facetValue,
            hierarchicalSeparator,
            unescapeFacetValue(currentRefinement),
            hierarchicalFacetResult.exhaustive
          );
        }),
        sortBy[0],
        sortBy[1]
      );
    }

    return hierarchicalTree;
  };
}

function onlyMatchingTree(
  facetValue,
  parentPath,
  currentRefinement,
  hierarchicalSeparator,
  hierarchicalRootPath,
  hierarchicalShowParentLevel
) {
  // we want the facetValue is a child of hierarchicalRootPath
  if (
    hierarchicalRootPath &&
    (facetValue.indexOf(hierarchicalRootPath) !== 0 ||
      hierarchicalRootPath === facetValue)
  ) {
    return false;
  }

  // we always want root levels (only when there is no prefix path)
  return (
    (!hierarchicalRootPath &&
      facetValue.indexOf(hierarchicalSeparator) === -1) ||
    // if there is a rootPath, being root level mean 1 level under rootPath
    (hierarchicalRootPath &&
      facetValue.split(hierarchicalSeparator).length -
        hierarchicalRootPath.split(hierarchicalSeparator).length ===
        1) ||
    // if current refinement is a root level and current facetValue is a root level,
    // keep the facetValue
    (facetValue.indexOf(hierarchicalSeparator) === -1 &&
      currentRefinement.indexOf(hierarchicalSeparator) === -1) ||
    // currentRefinement is a child of the facet value
    currentRefinement.indexOf(facetValue) === 0 ||
    // facetValue is a child of the current parent, add it
    (facetValue.indexOf(parentPath + hierarchicalSeparator) === 0 &&
      (hierarchicalShowParentLevel ||
        facetValue.indexOf(currentRefinement) === 0))
  );
}

function format(
  facetCount,
  facetValue,
  hierarchicalSeparator,
  currentRefinement,
  exhaustive
) {
  var parts = facetValue.split(hierarchicalSeparator);
  return {
    name: parts[parts.length - 1].trim(),
    path: facetValue,
    escapedValue: escapeFacetValue(facetValue),
    count: facetCount,
    isRefined:
      currentRefinement === facetValue ||
      currentRefinement.indexOf(facetValue + hierarchicalSeparator) === 0,
    exhaustive: exhaustive,
    data: null
  };
}


/***/ }),

/***/ 97968:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var merge = __webpack_require__(43600);
var defaultsPure = __webpack_require__(67955);
var orderBy = __webpack_require__(71539);
var compact = __webpack_require__(29241);
var find = __webpack_require__(38901);
var findIndex = __webpack_require__(84909);
var formatSort = __webpack_require__(28441);
var fv = __webpack_require__(23433);
var escapeFacetValue = fv.escapeFacetValue;
var unescapeFacetValue = fv.unescapeFacetValue;

var generateHierarchicalTree = __webpack_require__(4308);

/**
 * @typedef SearchResults.Facet
 * @type {object}
 * @property {string} name name of the attribute in the record
 * @property {object} data the faceting data: value, number of entries
 * @property {object} stats undefined unless facet_stats is retrieved from algolia
 */

/**
 * @typedef SearchResults.HierarchicalFacet
 * @type {object}
 * @property {string} name name of the current value given the hierarchical level, trimmed.
 * If root node, you get the facet name
 * @property {number} count number of objects matching this hierarchical value
 * @property {string} path the current hierarchical value full path
 * @property {boolean} isRefined `true` if the current value was refined, `false` otherwise
 * @property {HierarchicalFacet[]} data sub values for the current level
 */

/**
 * @typedef SearchResults.FacetValue
 * @type {object}
 * @property {string} name the facet value itself
 * @property {number} count times this facet appears in the results
 * @property {boolean} isRefined is the facet currently selected
 * @property {boolean} isExcluded is the facet currently excluded (only for conjunctive facets)
 */

/**
 * @typedef Refinement
 * @type {object}
 * @property {string} type the type of filter used:
 * `numeric`, `facet`, `exclude`, `disjunctive`, `hierarchical`
 * @property {string} attributeName name of the attribute used for filtering
 * @property {string} name the value of the filter
 * @property {number} numericValue the value as a number. Only for numeric filters.
 * @property {string} operator the operator used. Only for numeric filters.
 * @property {number} count the number of computed hits for this filter. Only on facets.
 * @property {boolean} exhaustive if the count is exhaustive
 */

/**
 * @param {string[]} attributes
 */
function getIndices(attributes) {
  var indices = {};

  attributes.forEach(function(val, idx) {
    indices[val] = idx;
  });

  return indices;
}

function assignFacetStats(dest, facetStats, key) {
  if (facetStats && facetStats[key]) {
    dest.stats = facetStats[key];
  }
}

/**
 * @typedef {Object} HierarchicalFacet
 * @property {string} name
 * @property {string[]} attributes
 */

/**
 * @param {HierarchicalFacet[]} hierarchicalFacets
 * @param {string} hierarchicalAttributeName
 */
function findMatchingHierarchicalFacetFromAttributeName(
  hierarchicalFacets,
  hierarchicalAttributeName
) {
  return find(hierarchicalFacets, function facetKeyMatchesAttribute(
    hierarchicalFacet
  ) {
    var facetNames = hierarchicalFacet.attributes || [];
    return facetNames.indexOf(hierarchicalAttributeName) > -1;
  });
}

/*eslint-disable */
/**
 * Constructor for SearchResults
 * @class
 * @classdesc SearchResults contains the results of a query to Algolia using the
 * {@link AlgoliaSearchHelper}.
 * @param {SearchParameters} state state that led to the response
 * @param {array.<object>} results the results from algolia client
 * @example <caption>SearchResults of the first query in
 * <a href="http://demos.algolia.com/instant-search-demo">the instant search demo</a></caption>
{
   "hitsPerPage": 10,
   "processingTimeMS": 2,
   "facets": [
      {
         "name": "type",
         "data": {
            "HardGood": 6627,
            "BlackTie": 550,
            "Music": 665,
            "Software": 131,
            "Game": 456,
            "Movie": 1571
         },
         "exhaustive": false
      },
      {
         "exhaustive": false,
         "data": {
            "Free shipping": 5507
         },
         "name": "shipping"
      }
  ],
   "hits": [
      {
         "thumbnailImage": "http://img.bbystatic.com/BestBuy_US/images/products/1688/1688832_54x108_s.gif",
         "_highlightResult": {
            "shortDescription": {
               "matchLevel": "none",
               "value": "Safeguard your PC, Mac, Android and iOS devices with comprehensive Internet protection",
               "matchedWords": []
            },
            "category": {
               "matchLevel": "none",
               "value": "Computer Security Software",
               "matchedWords": []
            },
            "manufacturer": {
               "matchedWords": [],
               "value": "Webroot",
               "matchLevel": "none"
            },
            "name": {
               "value": "Webroot SecureAnywhere Internet Security (3-Device) (1-Year Subscription) - Mac/Windows",
               "matchedWords": [],
               "matchLevel": "none"
            }
         },
         "image": "http://img.bbystatic.com/BestBuy_US/images/products/1688/1688832_105x210_sc.jpg",
         "shipping": "Free shipping",
         "bestSellingRank": 4,
         "shortDescription": "Safeguard your PC, Mac, Android and iOS devices with comprehensive Internet protection",
         "url": "http://www.bestbuy.com/site/webroot-secureanywhere-internet-security-3-devi…d=1219060687969&skuId=1688832&cmp=RMX&ky=2d3GfEmNIzjA0vkzveHdZEBgpPCyMnLTJ",
         "name": "Webroot SecureAnywhere Internet Security (3-Device) (1-Year Subscription) - Mac/Windows",
         "category": "Computer Security Software",
         "salePrice_range": "1 - 50",
         "objectID": "1688832",
         "type": "Software",
         "customerReviewCount": 5980,
         "salePrice": 49.99,
         "manufacturer": "Webroot"
      },
      ....
  ],
   "nbHits": 10000,
   "disjunctiveFacets": [
      {
         "exhaustive": false,
         "data": {
            "5": 183,
            "12": 112,
            "7": 149,
            ...
         },
         "name": "customerReviewCount",
         "stats": {
            "max": 7461,
            "avg": 157.939,
            "min": 1
         }
      },
      {
         "data": {
            "Printer Ink": 142,
            "Wireless Speakers": 60,
            "Point & Shoot Cameras": 48,
            ...
         },
         "name": "category",
         "exhaustive": false
      },
      {
         "exhaustive": false,
         "data": {
            "> 5000": 2,
            "1 - 50": 6524,
            "501 - 2000": 566,
            "201 - 500": 1501,
            "101 - 200": 1360,
            "2001 - 5000": 47
         },
         "name": "salePrice_range"
      },
      {
         "data": {
            "Dynex™": 202,
            "Insignia™": 230,
            "PNY": 72,
            ...
         },
         "name": "manufacturer",
         "exhaustive": false
      }
  ],
   "query": "",
   "nbPages": 100,
   "page": 0,
   "index": "bestbuy"
}
 **/
/*eslint-enable */
function SearchResults(state, results, options) {
  var mainSubResponse = results[0];

  this._rawResults = results;

  var self = this;

  // https://www.algolia.com/doc/api-reference/api-methods/search/#response
  Object.keys(mainSubResponse).forEach(function(key) {
    self[key] = mainSubResponse[key];
  });

  // Make every key of the result options reachable from the instance
  Object.keys(options || {}).forEach(function(key) {
    self[key] = options[key];
  });

  /**
   * query used to generate the results
   * @name query
   * @member {string}
   * @memberof SearchResults
   * @instance
   */
  /**
   * The query as parsed by the engine given all the rules.
   * @name parsedQuery
   * @member {string}
   * @memberof SearchResults
   * @instance
   */
  /**
   * all the records that match the search parameters. Each record is
   * augmented with a new attribute `_highlightResult`
   * which is an object keyed by attribute and with the following properties:
   *  - `value` : the value of the facet highlighted (html)
   *  - `matchLevel`: full, partial or none depending on how the query terms match
   * @name hits
   * @member {object[]}
   * @memberof SearchResults
   * @instance
   */
  /**
   * index where the results come from
   * @name index
   * @member {string}
   * @memberof SearchResults
   * @instance
   */
  /**
   * number of hits per page requested
   * @name hitsPerPage
   * @member {number}
   * @memberof SearchResults
   * @instance
   */
  /**
   * total number of hits of this query on the index
   * @name nbHits
   * @member {number}
   * @memberof SearchResults
   * @instance
   */
  /**
   * total number of pages with respect to the number of hits per page and the total number of hits
   * @name nbPages
   * @member {number}
   * @memberof SearchResults
   * @instance
   */
  /**
   * current page
   * @name page
   * @member {number}
   * @memberof SearchResults
   * @instance
   */
  /**
   * The position if the position was guessed by IP.
   * @name aroundLatLng
   * @member {string}
   * @memberof SearchResults
   * @instance
   * @example "48.8637,2.3615",
   */
  /**
   * The radius computed by Algolia.
   * @name automaticRadius
   * @member {string}
   * @memberof SearchResults
   * @instance
   * @example "126792922",
   */
  /**
   * String identifying the server used to serve this request.
   *
   * getRankingInfo needs to be set to `true` for this to be returned
   *
   * @name serverUsed
   * @member {string}
   * @memberof SearchResults
   * @instance
   * @example "c7-use-2.algolia.net",
   */
  /**
   * Boolean that indicates if the computation of the counts did time out.
   * @deprecated
   * @name timeoutCounts
   * @member {boolean}
   * @memberof SearchResults
   * @instance
   */
  /**
   * Boolean that indicates if the computation of the hits did time out.
   * @deprecated
   * @name timeoutHits
   * @member {boolean}
   * @memberof SearchResults
   * @instance
   */
  /**
   * True if the counts of the facets is exhaustive
   * @name exhaustiveFacetsCount
   * @member {boolean}
   * @memberof SearchResults
   * @instance
   */
  /**
   * True if the number of hits is exhaustive
   * @name exhaustiveNbHits
   * @member {boolean}
   * @memberof SearchResults
   * @instance
   */
  /**
   * Contains the userData if they are set by a [query rule](https://www.algolia.com/doc/guides/query-rules/query-rules-overview/).
   * @name userData
   * @member {object[]}
   * @memberof SearchResults
   * @instance
   */
  /**
   * queryID is the unique identifier of the query used to generate the current search results.
   * This value is only available if the `clickAnalytics` search parameter is set to `true`.
   * @name queryID
   * @member {string}
   * @memberof SearchResults
   * @instance
   */

  /**
   * sum of the processing time of all the queries
   * @member {number}
   */
  this.processingTimeMS = results.reduce(function(sum, result) {
    return result.processingTimeMS === undefined
      ? sum
      : sum + result.processingTimeMS;
  }, 0);

  /**
   * disjunctive facets results
   * @member {SearchResults.Facet[]}
   */
  this.disjunctiveFacets = [];
  /**
   * disjunctive facets results
   * @member {SearchResults.HierarchicalFacet[]}
   */
  this.hierarchicalFacets = state.hierarchicalFacets.map(function initFutureTree() {
    return [];
  });
  /**
   * other facets results
   * @member {SearchResults.Facet[]}
   */
  this.facets = [];

  var disjunctiveFacets = state.getRefinedDisjunctiveFacets();

  var facetsIndices = getIndices(state.facets);
  var disjunctiveFacetsIndices = getIndices(state.disjunctiveFacets);
  var nextDisjunctiveResult = 1;

  // Since we send request only for disjunctive facets that have been refined,
  // we get the facets information from the first, general, response.

  var mainFacets = mainSubResponse.facets || {};

  Object.keys(mainFacets).forEach(function(facetKey) {
    var facetValueObject = mainFacets[facetKey];

    var hierarchicalFacet = findMatchingHierarchicalFacetFromAttributeName(
      state.hierarchicalFacets,
      facetKey
    );

    if (hierarchicalFacet) {
      // Place the hierarchicalFacet data at the correct index depending on
      // the attributes order that was defined at the helper initialization
      var facetIndex = hierarchicalFacet.attributes.indexOf(facetKey);
      var idxAttributeName = findIndex(state.hierarchicalFacets, function(f) {
        return f.name === hierarchicalFacet.name;
      });
      self.hierarchicalFacets[idxAttributeName][facetIndex] = {
        attribute: facetKey,
        data: facetValueObject,
        exhaustive: mainSubResponse.exhaustiveFacetsCount
      };
    } else {
      var isFacetDisjunctive = state.disjunctiveFacets.indexOf(facetKey) !== -1;
      var isFacetConjunctive = state.facets.indexOf(facetKey) !== -1;
      var position;

      if (isFacetDisjunctive) {
        position = disjunctiveFacetsIndices[facetKey];
        self.disjunctiveFacets[position] = {
          name: facetKey,
          data: facetValueObject,
          exhaustive: mainSubResponse.exhaustiveFacetsCount
        };
        assignFacetStats(self.disjunctiveFacets[position], mainSubResponse.facets_stats, facetKey);
      }
      if (isFacetConjunctive) {
        position = facetsIndices[facetKey];
        self.facets[position] = {
          name: facetKey,
          data: facetValueObject,
          exhaustive: mainSubResponse.exhaustiveFacetsCount
        };
        assignFacetStats(self.facets[position], mainSubResponse.facets_stats, facetKey);
      }
    }
  });

  // Make sure we do not keep holes within the hierarchical facets
  this.hierarchicalFacets = compact(this.hierarchicalFacets);

  // aggregate the refined disjunctive facets
  disjunctiveFacets.forEach(function(disjunctiveFacet) {
    var result = results[nextDisjunctiveResult];
    var facets = result && result.facets ? result.facets : {};
    var hierarchicalFacet = state.getHierarchicalFacetByName(disjunctiveFacet);

    // There should be only item in facets.
    Object.keys(facets).forEach(function(dfacet) {
      var facetResults = facets[dfacet];

      var position;

      if (hierarchicalFacet) {
        position = findIndex(state.hierarchicalFacets, function(f) {
          return f.name === hierarchicalFacet.name;
        });
        var attributeIndex = findIndex(self.hierarchicalFacets[position], function(f) {
          return f.attribute === dfacet;
        });

        // previous refinements and no results so not able to find it
        if (attributeIndex === -1) {
          return;
        }

        self.hierarchicalFacets[position][attributeIndex].data = merge(
          {},
          self.hierarchicalFacets[position][attributeIndex].data,
          facetResults
        );
      } else {
        position = disjunctiveFacetsIndices[dfacet];

        var dataFromMainRequest = mainSubResponse.facets && mainSubResponse.facets[dfacet] || {};

        self.disjunctiveFacets[position] = {
          name: dfacet,
          data: defaultsPure({}, facetResults, dataFromMainRequest),
          exhaustive: result.exhaustiveFacetsCount
        };
        assignFacetStats(self.disjunctiveFacets[position], result.facets_stats, dfacet);

        if (state.disjunctiveFacetsRefinements[dfacet]) {
          state.disjunctiveFacetsRefinements[dfacet].forEach(function(refinementValue) {
            // add the disjunctive refinements if it is no more retrieved
            if (!self.disjunctiveFacets[position].data[refinementValue] &&
              state.disjunctiveFacetsRefinements[dfacet].indexOf(unescapeFacetValue(refinementValue)) > -1) {
              self.disjunctiveFacets[position].data[refinementValue] = 0;
            }
          });
        }
      }
    });
    nextDisjunctiveResult++;
  });

  // if we have some parent level values for hierarchical facets, merge them
  state.getRefinedHierarchicalFacets().forEach(function(refinedFacet) {
    var hierarchicalFacet = state.getHierarchicalFacetByName(refinedFacet);
    var separator = state._getHierarchicalFacetSeparator(hierarchicalFacet);

    var currentRefinement = state.getHierarchicalRefinement(refinedFacet);
    // if we are already at a root refinement (or no refinement at all), there is no
    // root level values request
    if (currentRefinement.length === 0 || currentRefinement[0].split(separator).length < 2) {
      return;
    }

    results.slice(nextDisjunctiveResult).forEach(function(result) {
      var facets = result && result.facets
        ? result.facets
        : {};

      Object.keys(facets).forEach(function(dfacet) {
        var facetResults = facets[dfacet];
        var position = findIndex(state.hierarchicalFacets, function(f) {
          return f.name === hierarchicalFacet.name;
        });
        var attributeIndex = findIndex(self.hierarchicalFacets[position], function(f) {
          return f.attribute === dfacet;
        });

        // previous refinements and no results so not able to find it
        if (attributeIndex === -1) {
          return;
        }

        // when we always get root levels, if the hits refinement is `beers > IPA` (count: 5),
        // then the disjunctive values will be `beers` (count: 100),
        // but we do not want to display
        //   | beers (100)
        //     > IPA (5)
        // We want
        //   | beers (5)
        //     > IPA (5)
        var defaultData = {};

        if (currentRefinement.length > 0) {
          var root = currentRefinement[0].split(separator)[0];
          defaultData[root] = self.hierarchicalFacets[position][attributeIndex].data[root];
        }

        self.hierarchicalFacets[position][attributeIndex].data = defaultsPure(
          defaultData,
          facetResults,
          self.hierarchicalFacets[position][attributeIndex].data
        );
      });

      nextDisjunctiveResult++;
    });
  });

  // add the excludes
  Object.keys(state.facetsExcludes).forEach(function(facetName) {
    var excludes = state.facetsExcludes[facetName];
    var position = facetsIndices[facetName];

    self.facets[position] = {
      name: facetName,
      data: mainSubResponse.facets[facetName],
      exhaustive: mainSubResponse.exhaustiveFacetsCount
    };
    excludes.forEach(function(facetValue) {
      self.facets[position] = self.facets[position] || {name: facetName};
      self.facets[position].data = self.facets[position].data || {};
      self.facets[position].data[facetValue] = 0;
    });
  });

  /**
   * @type {Array}
   */
  this.hierarchicalFacets = this.hierarchicalFacets.map(generateHierarchicalTree(state));

  /**
   * @type {Array}
   */
  this.facets = compact(this.facets);
  /**
   * @type {Array}
   */
  this.disjunctiveFacets = compact(this.disjunctiveFacets);

  this._state = state;
}

/**
 * Get a facet object with its name
 * @deprecated
 * @param {string} name name of the faceted attribute
 * @return {SearchResults.Facet} the facet object
 */
SearchResults.prototype.getFacetByName = function(name) {
  function predicate(facet) {
    return facet.name === name;
  }

  return find(this.facets, predicate) ||
    find(this.disjunctiveFacets, predicate) ||
    find(this.hierarchicalFacets, predicate);
};

/**
 * Get the facet values of a specified attribute from a SearchResults object.
 * @private
 * @param {SearchResults} results the search results to search in
 * @param {string} attribute name of the faceted attribute to search for
 * @return {array|object} facet values. For the hierarchical facets it is an object.
 */
function extractNormalizedFacetValues(results, attribute) {
  function predicate(facet) {
    return facet.name === attribute;
  }

  if (results._state.isConjunctiveFacet(attribute)) {
    var facet = find(results.facets, predicate);
    if (!facet) return [];

    return Object.keys(facet.data).map(function(name) {
      var value = escapeFacetValue(name);
      return {
        name: name,
        escapedValue: value,
        count: facet.data[name],
        isRefined: results._state.isFacetRefined(attribute, value),
        isExcluded: results._state.isExcludeRefined(attribute, name)
      };
    });
  } else if (results._state.isDisjunctiveFacet(attribute)) {
    var disjunctiveFacet = find(results.disjunctiveFacets, predicate);
    if (!disjunctiveFacet) return [];

    return Object.keys(disjunctiveFacet.data).map(function(name) {
      var value = escapeFacetValue(name);
      return {
        name: name,
        escapedValue: value,
        count: disjunctiveFacet.data[name],
        isRefined: results._state.isDisjunctiveFacetRefined(attribute, value)
      };
    });
  } else if (results._state.isHierarchicalFacet(attribute)) {
    return find(results.hierarchicalFacets, predicate);
  }
}

/**
 * Sort nodes of a hierarchical or disjunctive facet results
 * @private
 * @param {function} sortFn
 * @param {HierarchicalFacet|Array} node node upon which we want to apply the sort
 * @param {string[]} names attribute names
 * @param {number} [level=0] current index in the names array
 */
function recSort(sortFn, node, names, level) {
  level = level || 0;

  if (Array.isArray(node)) {
    return sortFn(node, names[level]);
  }

  if (!node.data || node.data.length === 0) {
    return node;
  }

  var children = node.data.map(function(childNode) {
    return recSort(sortFn, childNode, names, level + 1);
  });
  var sortedChildren = sortFn(children, names[level]);
  var newNode = defaultsPure({data: sortedChildren}, node);
  return newNode;
}

SearchResults.DEFAULT_SORT = ['isRefined:desc', 'count:desc', 'name:asc'];

function vanillaSortFn(order, data) {
  return data.sort(order);
}

/**
 * @typedef FacetOrdering
 * @type {Object}
 * @property {string[]} [order]
 * @property {'count' | 'alpha' | 'hidden'} [sortRemainingBy]
 */

/**
 * Sorts facet arrays via their facet ordering
 * @param {Array} facetValues the values
 * @param {FacetOrdering} facetOrdering the ordering
 * @returns {Array}
 */
function sortViaFacetOrdering(facetValues, facetOrdering) {
  var orderedFacets = [];
  var remainingFacets = [];

  var order = facetOrdering.order || [];
  /**
   * an object with the keys being the values in order, the values their index:
   * ['one', 'two'] -> { one: 0, two: 1 }
   */
  var reverseOrder = order.reduce(function(acc, name, i) {
    acc[name] = i;
    return acc;
  }, {});

  facetValues.forEach(function(item) {
    // hierarchical facets get sorted using their raw name
    var name = item.path || item.name;
    if (reverseOrder[name] !== undefined) {
      orderedFacets[reverseOrder[name]] = item;
    } else {
      remainingFacets.push(item);
    }
  });

  orderedFacets = orderedFacets.filter(function(facet) {
    return facet;
  });

  var sortRemainingBy = facetOrdering.sortRemainingBy;
  var ordering;
  if (sortRemainingBy === 'hidden') {
    return orderedFacets;
  } else if (sortRemainingBy === 'alpha') {
    ordering = [['path', 'name'], ['asc', 'asc']];
  } else {
    ordering = [['count'], ['desc']];
  }

  return orderedFacets.concat(
    orderBy(remainingFacets, ordering[0], ordering[1])
  );
}

/**
 * @param {SearchResults} results the search results class
 * @param {string} attribute the attribute to retrieve ordering of
 * @returns {FacetOrdering=}
 */
function getFacetOrdering(results, attribute) {
  return (
    results.renderingContent &&
    results.renderingContent.facetOrdering &&
    results.renderingContent.facetOrdering.values &&
    results.renderingContent.facetOrdering.values[attribute]
  );
}

/**
 * Get a the list of values for a given facet attribute. Those values are sorted
 * refinement first, descending count (bigger value on top), and name ascending
 * (alphabetical order). The sort formula can overridden using either string based
 * predicates or a function.
 *
 * This method will return all the values returned by the Algolia engine plus all
 * the values already refined. This means that it can happen that the
 * `maxValuesPerFacet` [configuration](https://www.algolia.com/doc/rest-api/search#param-maxValuesPerFacet)
 * might not be respected if you have facet values that are already refined.
 * @param {string} attribute attribute name
 * @param {object} opts configuration options.
 * @param {boolean} [opts.facetOrdering]
 * Force the use of facetOrdering from the result if a sortBy is present. If
 * sortBy isn't present, facetOrdering will be used automatically.
 * @param {Array.<string> | function} opts.sortBy
 * When using strings, it consists of
 * the name of the [FacetValue](#SearchResults.FacetValue) or the
 * [HierarchicalFacet](#SearchResults.HierarchicalFacet) attributes with the
 * order (`asc` or `desc`). For example to order the value by count, the
 * argument would be `['count:asc']`.
 *
 * If only the attribute name is specified, the ordering defaults to the one
 * specified in the default value for this attribute.
 *
 * When not specified, the order is
 * ascending.  This parameter can also be a function which takes two facet
 * values and should return a number, 0 if equal, 1 if the first argument is
 * bigger or -1 otherwise.
 *
 * The default value for this attribute `['isRefined:desc', 'count:desc', 'name:asc']`
 * @return {FacetValue[]|HierarchicalFacet|undefined} depending on the type of facet of
 * the attribute requested (hierarchical, disjunctive or conjunctive)
 * @example
 * helper.on('result', function(event){
 *   //get values ordered only by name ascending using the string predicate
 *   event.results.getFacetValues('city', {sortBy: ['name:asc']});
 *   //get values  ordered only by count ascending using a function
 *   event.results.getFacetValues('city', {
 *     // this is equivalent to ['count:asc']
 *     sortBy: function(a, b) {
 *       if (a.count === b.count) return 0;
 *       if (a.count > b.count)   return 1;
 *       if (b.count > a.count)   return -1;
 *     }
 *   });
 * });
 */
SearchResults.prototype.getFacetValues = function(attribute, opts) {
  var facetValues = extractNormalizedFacetValues(this, attribute);
  if (!facetValues) {
    return undefined;
  }

  var options = defaultsPure({}, opts, {
    sortBy: SearchResults.DEFAULT_SORT,
    // if no sortBy is given, attempt to sort based on facetOrdering
    // if it is given, we still allow to sort via facet ordering first
    facetOrdering: !(opts && opts.sortBy)
  });

  var results = this;
  var attributes;
  if (Array.isArray(facetValues)) {
    attributes = [attribute];
  } else {
    var config = results._state.getHierarchicalFacetByName(facetValues.name);
    attributes = config.attributes;
  }

  return recSort(function(data, facetName) {
    if (options.facetOrdering) {
      var facetOrdering = getFacetOrdering(results, facetName);
      if (Boolean(facetOrdering)) {
        return sortViaFacetOrdering(data, facetOrdering);
      }
    }

    if (Array.isArray(options.sortBy)) {
      var order = formatSort(options.sortBy, SearchResults.DEFAULT_SORT);
      return orderBy(data, order[0], order[1]);
    } else if (typeof options.sortBy === 'function') {
      return vanillaSortFn(options.sortBy, data);
    }
    throw new Error(
      'options.sortBy is optional but if defined it must be ' +
        'either an array of string (predicates) or a sorting function'
    );
  }, facetValues, attributes);
};

/**
 * Returns the facet stats if attribute is defined and the facet contains some.
 * Otherwise returns undefined.
 * @param {string} attribute name of the faceted attribute
 * @return {object} The stats of the facet
 */
SearchResults.prototype.getFacetStats = function(attribute) {
  if (this._state.isConjunctiveFacet(attribute)) {
    return getFacetStatsIfAvailable(this.facets, attribute);
  } else if (this._state.isDisjunctiveFacet(attribute)) {
    return getFacetStatsIfAvailable(this.disjunctiveFacets, attribute);
  }

  return undefined;
};

/**
 * @typedef {Object} FacetListItem
 * @property {string} name
 */

/**
 * @param {FacetListItem[]} facetList (has more items, but enough for here)
 * @param {string} facetName
 */
function getFacetStatsIfAvailable(facetList, facetName) {
  var data = find(facetList, function(facet) {
    return facet.name === facetName;
  });
  return data && data.stats;
}

/**
 * Returns all refinements for all filters + tags. It also provides
 * additional information: count and exhaustiveness for each filter.
 *
 * See the [refinement type](#Refinement) for an exhaustive view of the available
 * data.
 *
 * Note that for a numeric refinement, results are grouped per operator, this
 * means that it will return responses for operators which are empty.
 *
 * @return {Array.<Refinement>} all the refinements
 */
SearchResults.prototype.getRefinements = function() {
  var state = this._state;
  var results = this;
  var res = [];

  Object.keys(state.facetsRefinements).forEach(function(attributeName) {
    state.facetsRefinements[attributeName].forEach(function(name) {
      res.push(getRefinement(state, 'facet', attributeName, name, results.facets));
    });
  });

  Object.keys(state.facetsExcludes).forEach(function(attributeName) {
    state.facetsExcludes[attributeName].forEach(function(name) {
      res.push(getRefinement(state, 'exclude', attributeName, name, results.facets));
    });
  });

  Object.keys(state.disjunctiveFacetsRefinements).forEach(function(attributeName) {
    state.disjunctiveFacetsRefinements[attributeName].forEach(function(name) {
      res.push(getRefinement(state, 'disjunctive', attributeName, name, results.disjunctiveFacets));
    });
  });

  Object.keys(state.hierarchicalFacetsRefinements).forEach(function(attributeName) {
    state.hierarchicalFacetsRefinements[attributeName].forEach(function(name) {
      res.push(getHierarchicalRefinement(state, attributeName, name, results.hierarchicalFacets));
    });
  });


  Object.keys(state.numericRefinements).forEach(function(attributeName) {
    var operators = state.numericRefinements[attributeName];
    Object.keys(operators).forEach(function(operator) {
      operators[operator].forEach(function(value) {
        res.push({
          type: 'numeric',
          attributeName: attributeName,
          name: value,
          numericValue: value,
          operator: operator
        });
      });
    });
  });

  state.tagRefinements.forEach(function(name) {
    res.push({type: 'tag', attributeName: '_tags', name: name});
  });

  return res;
};

/**
 * @typedef {Object} Facet
 * @property {string} name
 * @property {Object} data
 * @property {boolean} exhaustive
 */

/**
 * @param {*} state
 * @param {*} type
 * @param {string} attributeName
 * @param {*} name
 * @param {Facet[]} resultsFacets
 */
function getRefinement(state, type, attributeName, name, resultsFacets) {
  var facet = find(resultsFacets, function(f) {
    return f.name === attributeName;
  });
  var count = facet && facet.data && facet.data[name] ? facet.data[name] : 0;
  var exhaustive = (facet && facet.exhaustive) || false;

  return {
    type: type,
    attributeName: attributeName,
    name: name,
    count: count,
    exhaustive: exhaustive
  };
}

/**
 * @param {*} state
 * @param {string} attributeName
 * @param {*} name
 * @param {Facet[]} resultsFacets
 */
function getHierarchicalRefinement(state, attributeName, name, resultsFacets) {
  var facetDeclaration = state.getHierarchicalFacetByName(attributeName);
  var separator = state._getHierarchicalFacetSeparator(facetDeclaration);
  var split = name.split(separator);
  var rootFacet = find(resultsFacets, function(facet) {
    return facet.name === attributeName;
  });

  var facet = split.reduce(function(intermediateFacet, part) {
    var newFacet =
      intermediateFacet && find(intermediateFacet.data, function(f) {
        return f.name === part;
      });
    return newFacet !== undefined ? newFacet : intermediateFacet;
  }, rootFacet);

  var count = (facet && facet.count) || 0;
  var exhaustive = (facet && facet.exhaustive) || false;
  var path = (facet && facet.path) || '';

  return {
    type: 'hierarchical',
    attributeName: attributeName,
    name: path,
    count: count,
    exhaustive: exhaustive
  };
}

module.exports = SearchResults;


/***/ }),

/***/ 68765:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var SearchParameters = __webpack_require__(63264);
var SearchResults = __webpack_require__(97968);
var DerivedHelper = __webpack_require__(29333);
var requestBuilder = __webpack_require__(84646);

var EventEmitter = __webpack_require__(73592);
var inherits = __webpack_require__(37224);
var objectHasKeys = __webpack_require__(68711);
var omit = __webpack_require__(25279);
var merge = __webpack_require__(43600);

var version = __webpack_require__(33836);
var escapeFacetValue = (__webpack_require__(23433).escapeFacetValue);

/**
 * Event triggered when a parameter is set or updated
 * @event AlgoliaSearchHelper#event:change
 * @property {object} event
 * @property {SearchParameters} event.state the current parameters with the latest changes applied
 * @property {SearchResults} event.results the previous results received from Algolia. `null` before the first request
 * @example
 * helper.on('change', function(event) {
 *   console.log('The parameters have changed');
 * });
 */

/**
 * Event triggered when a main search is sent to Algolia
 * @event AlgoliaSearchHelper#event:search
 * @property {object} event
 * @property {SearchParameters} event.state the parameters used for this search
 * @property {SearchResults} event.results the results from the previous search. `null` if it is the first search.
 * @example
 * helper.on('search', function(event) {
 *   console.log('Search sent');
 * });
 */

/**
 * Event triggered when a search using `searchForFacetValues` is sent to Algolia
 * @event AlgoliaSearchHelper#event:searchForFacetValues
 * @property {object} event
 * @property {SearchParameters} event.state the parameters used for this search it is the first search.
 * @property {string} event.facet the facet searched into
 * @property {string} event.query the query used to search in the facets
 * @example
 * helper.on('searchForFacetValues', function(event) {
 *   console.log('searchForFacetValues sent');
 * });
 */

/**
 * Event triggered when a search using `searchOnce` is sent to Algolia
 * @event AlgoliaSearchHelper#event:searchOnce
 * @property {object} event
 * @property {SearchParameters} event.state the parameters used for this search it is the first search.
 * @example
 * helper.on('searchOnce', function(event) {
 *   console.log('searchOnce sent');
 * });
 */

/**
 * Event triggered when the results are retrieved from Algolia
 * @event AlgoliaSearchHelper#event:result
 * @property {object} event
 * @property {SearchResults} event.results the results received from Algolia
 * @property {SearchParameters} event.state the parameters used to query Algolia. Those might be different from the one in the helper instance (for example if the network is unreliable).
 * @example
 * helper.on('result', function(event) {
 *   console.log('Search results received');
 * });
 */

/**
 * Event triggered when Algolia sends back an error. For example, if an unknown parameter is
 * used, the error can be caught using this event.
 * @event AlgoliaSearchHelper#event:error
 * @property {object} event
 * @property {Error} event.error the error returned by the Algolia.
 * @example
 * helper.on('error', function(event) {
 *   console.log('Houston we got a problem.');
 * });
 */

/**
 * Event triggered when the queue of queries have been depleted (with any result or outdated queries)
 * @event AlgoliaSearchHelper#event:searchQueueEmpty
 * @example
 * helper.on('searchQueueEmpty', function() {
 *   console.log('No more search pending');
 *   // This is received before the result event if we're not expecting new results
 * });
 *
 * helper.search();
 */

/**
 * Initialize a new AlgoliaSearchHelper
 * @class
 * @classdesc The AlgoliaSearchHelper is a class that ease the management of the
 * search. It provides an event based interface for search callbacks:
 *  - change: when the internal search state is changed.
 *    This event contains a {@link SearchParameters} object and the
 *    {@link SearchResults} of the last result if any.
 *  - search: when a search is triggered using the `search()` method.
 *  - result: when the response is retrieved from Algolia and is processed.
 *    This event contains a {@link SearchResults} object and the
 *    {@link SearchParameters} corresponding to this answer.
 *  - error: when the response is an error. This event contains the error returned by the server.
 * @param  {AlgoliaSearch} client an AlgoliaSearch client
 * @param  {string} index the index name to query
 * @param  {SearchParameters | object} options an object defining the initial
 * config of the search. It doesn't have to be a {SearchParameters},
 * just an object containing the properties you need from it.
 */
function AlgoliaSearchHelper(client, index, options) {
  if (typeof client.addAlgoliaAgent === 'function') {
    client.addAlgoliaAgent('JS Helper (' + version + ')');
  }

  this.setClient(client);
  var opts = options || {};
  opts.index = index;
  this.state = SearchParameters.make(opts);
  this.lastResults = null;
  this._queryId = 0;
  this._lastQueryIdReceived = -1;
  this.derivedHelpers = [];
  this._currentNbQueries = 0;
}

inherits(AlgoliaSearchHelper, EventEmitter);

/**
 * Start the search with the parameters set in the state. When the
 * method is called, it triggers a `search` event. The results will
 * be available through the `result` event. If an error occurs, an
 * `error` will be fired instead.
 * @return {AlgoliaSearchHelper}
 * @fires search
 * @fires result
 * @fires error
 * @chainable
 */
AlgoliaSearchHelper.prototype.search = function() {
  this._search({onlyWithDerivedHelpers: false});
  return this;
};

AlgoliaSearchHelper.prototype.searchOnlyWithDerivedHelpers = function() {
  this._search({onlyWithDerivedHelpers: true});
  return this;
};

/**
 * Gets the search query parameters that would be sent to the Algolia Client
 * for the hits
 * @return {object} Query Parameters
 */
AlgoliaSearchHelper.prototype.getQuery = function() {
  var state = this.state;
  return requestBuilder._getHitsSearchParams(state);
};

/**
 * Start a search using a modified version of the current state. This method does
 * not trigger the helper lifecycle and does not modify the state kept internally
 * by the helper. This second aspect means that the next search call will be the
 * same as a search call before calling searchOnce.
 * @param {object} options can contain all the parameters that can be set to SearchParameters
 * plus the index
 * @param {function} [callback] optional callback executed when the response from the
 * server is back.
 * @return {promise|undefined} if a callback is passed the method returns undefined
 * otherwise it returns a promise containing an object with two keys :
 *  - content with a SearchResults
 *  - state with the state used for the query as a SearchParameters
 * @example
 * // Changing the number of records returned per page to 1
 * // This example uses the callback API
 * var state = helper.searchOnce({hitsPerPage: 1},
 *   function(error, content, state) {
 *     // if an error occurred it will be passed in error, otherwise its value is null
 *     // content contains the results formatted as a SearchResults
 *     // state is the instance of SearchParameters used for this search
 *   });
 * @example
 * // Changing the number of records returned per page to 1
 * // This example uses the promise API
 * var state1 = helper.searchOnce({hitsPerPage: 1})
 *                 .then(promiseHandler);
 *
 * function promiseHandler(res) {
 *   // res contains
 *   // {
 *   //   content : SearchResults
 *   //   state   : SearchParameters (the one used for this specific search)
 *   // }
 * }
 */
AlgoliaSearchHelper.prototype.searchOnce = function(options, cb) {
  var tempState = !options ? this.state : this.state.setQueryParameters(options);
  var queries = requestBuilder._getQueries(tempState.index, tempState);
  var self = this;

  this._currentNbQueries++;

  this.emit('searchOnce', {
    state: tempState
  });

  if (cb) {
    this.client
      .search(queries)
      .then(function(content) {
        self._currentNbQueries--;
        if (self._currentNbQueries === 0) {
          self.emit('searchQueueEmpty');
        }

        cb(null, new SearchResults(tempState, content.results), tempState);
      })
      .catch(function(err) {
        self._currentNbQueries--;
        if (self._currentNbQueries === 0) {
          self.emit('searchQueueEmpty');
        }

        cb(err, null, tempState);
      });

    return undefined;
  }

  return this.client.search(queries).then(function(content) {
    self._currentNbQueries--;
    if (self._currentNbQueries === 0) self.emit('searchQueueEmpty');
    return {
      content: new SearchResults(tempState, content.results),
      state: tempState,
      _originalResponse: content
    };
  }, function(e) {
    self._currentNbQueries--;
    if (self._currentNbQueries === 0) self.emit('searchQueueEmpty');
    throw e;
  });
};

 /**
 * Start the search for answers with the parameters set in the state.
 * This method returns a promise.
 * @param {Object} options - the options for answers API call
 * @param {string[]} options.attributesForPrediction - Attributes to use for predictions. If empty, `searchableAttributes` is used instead.
 * @param {string[]} options.queryLanguages - The languages in the query. Currently only supports ['en'].
 * @param {number} options.nbHits - Maximum number of answers to retrieve from the Answers Engine. Cannot be greater than 1000.
 *
 * @return {promise} the answer results
 */
AlgoliaSearchHelper.prototype.findAnswers = function(options) {
  var state = this.state;
  var derivedHelper = this.derivedHelpers[0];
  if (!derivedHelper) {
    return Promise.resolve([]);
  }
  var derivedState = derivedHelper.getModifiedState(state);
  var data = merge(
    {
      attributesForPrediction: options.attributesForPrediction,
      nbHits: options.nbHits
    },
    {
      params: omit(requestBuilder._getHitsSearchParams(derivedState), [
        'attributesToSnippet',
        'hitsPerPage',
        'restrictSearchableAttributes',
        'snippetEllipsisText' // FIXME remove this line once the engine is fixed.
      ])
    }
  );

  var errorMessage = 'search for answers was called, but this client does not have a function client.initIndex(index).findAnswers';
  if (typeof this.client.initIndex !== 'function') {
    throw new Error(errorMessage);
  }
  var index = this.client.initIndex(derivedState.index);
  if (typeof index.findAnswers !== 'function') {
    throw new Error(errorMessage);
  }
  return index.findAnswers(derivedState.query, options.queryLanguages, data);
};

/**
 * Structure of each result when using
 * [`searchForFacetValues()`](reference.html#AlgoliaSearchHelper#searchForFacetValues)
 * @typedef FacetSearchHit
 * @type {object}
 * @property {string} value the facet value
 * @property {string} highlighted the facet value highlighted with the query string
 * @property {number} count number of occurrence of this facet value
 * @property {boolean} isRefined true if the value is already refined
 */

/**
 * Structure of the data resolved by the
 * [`searchForFacetValues()`](reference.html#AlgoliaSearchHelper#searchForFacetValues)
 * promise.
 * @typedef FacetSearchResult
 * @type {object}
 * @property {FacetSearchHit} facetHits the results for this search for facet values
 * @property {number} processingTimeMS time taken by the query inside the engine
 */

/**
 * Search for facet values based on an query and the name of a faceted attribute. This
 * triggers a search and will return a promise. On top of using the query, it also sends
 * the parameters from the state so that the search is narrowed down to only the possible values.
 *
 * See the description of [FacetSearchResult](reference.html#FacetSearchResult)
 * @param {string} facet the name of the faceted attribute
 * @param {string} query the string query for the search
 * @param {number} [maxFacetHits] the maximum number values returned. Should be > 0 and <= 100
 * @param {object} [userState] the set of custom parameters to use on top of the current state. Setting a property to `undefined` removes
 * it in the generated query.
 * @return {promise.<FacetSearchResult>} the results of the search
 */
AlgoliaSearchHelper.prototype.searchForFacetValues = function(facet, query, maxFacetHits, userState) {
  var clientHasSFFV = typeof this.client.searchForFacetValues === 'function';
  var clientHasInitIndex = typeof this.client.initIndex === 'function';
  if (
    !clientHasSFFV &&
    !clientHasInitIndex &&
    typeof this.client.search !== 'function'
  ) {
    throw new Error(
      'search for facet values (searchable) was called, but this client does not have a function client.searchForFacetValues or client.initIndex(index).searchForFacetValues'
    );
  }

  var state = this.state.setQueryParameters(userState || {});
  var isDisjunctive = state.isDisjunctiveFacet(facet);
  var algoliaQuery = requestBuilder.getSearchForFacetQuery(facet, query, maxFacetHits, state);

  this._currentNbQueries++;
  var self = this;
  var searchForFacetValuesPromise;
  // newer algoliasearch ^3.27.1 - ~4.0.0
  if (clientHasSFFV) {
    searchForFacetValuesPromise = this.client.searchForFacetValues([
      {indexName: state.index, params: algoliaQuery}
    ]);
    // algoliasearch < 3.27.1
  } else if (clientHasInitIndex) {
    searchForFacetValuesPromise = this.client
      .initIndex(state.index)
      .searchForFacetValues(algoliaQuery);
    // algoliasearch ~5.0.0
  } else {
    // @MAJOR only use client.search
    delete algoliaQuery.facetName;
    searchForFacetValuesPromise = this.client
      .search([
        {
          type: 'facet',
          facet: facet,
          indexName: state.index,
          params: algoliaQuery
        }
      ])
      .then(function processResponse(response) {
        return response.results[0];
      });
  }

  this.emit('searchForFacetValues', {
    state: state,
    facet: facet,
    query: query
  });

  return searchForFacetValuesPromise.then(function addIsRefined(content) {
    self._currentNbQueries--;
    if (self._currentNbQueries === 0) self.emit('searchQueueEmpty');

    content = Array.isArray(content) ? content[0] : content;

    content.facetHits.forEach(function(f) {
      f.escapedValue = escapeFacetValue(f.value);
      f.isRefined = isDisjunctive
        ? state.isDisjunctiveFacetRefined(facet, f.escapedValue)
        : state.isFacetRefined(facet, f.escapedValue);
    });

    return content;
  }, function(e) {
    self._currentNbQueries--;
    if (self._currentNbQueries === 0) self.emit('searchQueueEmpty');
    throw e;
  });
};

/**
 * Sets the text query used for the search.
 *
 * This method resets the current page to 0.
 * @param  {string} q the user query
 * @return {AlgoliaSearchHelper}
 * @fires change
 * @chainable
 */
AlgoliaSearchHelper.prototype.setQuery = function(q) {
  this._change({
    state: this.state.resetPage().setQuery(q),
    isPageReset: true
  });

  return this;
};

/**
 * Remove all the types of refinements except tags. A string can be provided to remove
 * only the refinements of a specific attribute. For more advanced use case, you can
 * provide a function instead. This function should follow the
 * [clearCallback definition](#SearchParameters.clearCallback).
 *
 * This method resets the current page to 0.
 * @param {string} [name] optional name of the facet / attribute on which we want to remove all refinements
 * @return {AlgoliaSearchHelper}
 * @fires change
 * @chainable
 * @example
 * // Removing all the refinements
 * helper.clearRefinements().search();
 * @example
 * // Removing all the filters on a the category attribute.
 * helper.clearRefinements('category').search();
 * @example
 * // Removing only the exclude filters on the category facet.
 * helper.clearRefinements(function(value, attribute, type) {
 *   return type === 'exclude' && attribute === 'category';
 * }).search();
 */
AlgoliaSearchHelper.prototype.clearRefinements = function(name) {
  this._change({
    state: this.state.resetPage().clearRefinements(name),
    isPageReset: true
  });

  return this;
};

/**
 * Remove all the tag filters.
 *
 * This method resets the current page to 0.
 * @return {AlgoliaSearchHelper}
 * @fires change
 * @chainable
 */
AlgoliaSearchHelper.prototype.clearTags = function() {
  this._change({
    state: this.state.resetPage().clearTags(),
    isPageReset: true
  });

  return this;
};

/**
 * Adds a disjunctive filter to a faceted attribute with the `value` provided. If the
 * filter is already set, it doesn't change the filters.
 *
 * This method resets the current page to 0.
 * @param  {string} facet the facet to refine
 * @param  {string} value the associated value (will be converted to string)
 * @return {AlgoliaSearchHelper}
 * @fires change
 * @chainable
 */
AlgoliaSearchHelper.prototype.addDisjunctiveFacetRefinement = function(facet, value) {
  this._change({
    state: this.state.resetPage().addDisjunctiveFacetRefinement(facet, value),
    isPageReset: true
  });

  return this;
};

/**
 * @deprecated since version 2.4.0, see {@link AlgoliaSearchHelper#addDisjunctiveFacetRefinement}
 */
AlgoliaSearchHelper.prototype.addDisjunctiveRefine = function() {
  return this.addDisjunctiveFacetRefinement.apply(this, arguments);
};

/**
 * Adds a refinement on a hierarchical facet. It will throw
 * an exception if the facet is not defined or if the facet
 * is already refined.
 *
 * This method resets the current page to 0.
 * @param {string} facet the facet name
 * @param {string} path the hierarchical facet path
 * @return {AlgoliaSearchHelper}
 * @throws Error if the facet is not defined or if the facet is refined
 * @chainable
 * @fires change
 */
AlgoliaSearchHelper.prototype.addHierarchicalFacetRefinement = function(facet, value) {
  this._change({
    state: this.state.resetPage().addHierarchicalFacetRefinement(facet, value),
    isPageReset: true
  });

  return this;
};

/**
 * Adds a an numeric filter to an attribute with the `operator` and `value` provided. If the
 * filter is already set, it doesn't change the filters.
 *
 * This method resets the current page to 0.
 * @param  {string} attribute the attribute on which the numeric filter applies
 * @param  {string} operator the operator of the filter
 * @param  {number} value the value of the filter
 * @return {AlgoliaSearchHelper}
 * @fires change
 * @chainable
 */
AlgoliaSearchHelper.prototype.addNumericRefinement = function(attribute, operator, value) {
  this._change({
    state: this.state.resetPage().addNumericRefinement(attribute, operator, value),
    isPageReset: true
  });

  return this;
};

/**
 * Adds a filter to a faceted attribute with the `value` provided. If the
 * filter is already set, it doesn't change the filters.
 *
 * This method resets the current page to 0.
 * @param  {string} facet the facet to refine
 * @param  {string} value the associated value (will be converted to string)
 * @return {AlgoliaSearchHelper}
 * @fires change
 * @chainable
 */
AlgoliaSearchHelper.prototype.addFacetRefinement = function(facet, value) {
  this._change({
    state: this.state.resetPage().addFacetRefinement(facet, value),
    isPageReset: true
  });

  return this;
};

/**
 * @deprecated since version 2.4.0, see {@link AlgoliaSearchHelper#addFacetRefinement}
 */
AlgoliaSearchHelper.prototype.addRefine = function() {
  return this.addFacetRefinement.apply(this, arguments);
};


/**
 * Adds a an exclusion filter to a faceted attribute with the `value` provided. If the
 * filter is already set, it doesn't change the filters.
 *
 * This method resets the current page to 0.
 * @param  {string} facet the facet to refine
 * @param  {string} value the associated value (will be converted to string)
 * @return {AlgoliaSearchHelper}
 * @fires change
 * @chainable
 */
AlgoliaSearchHelper.prototype.addFacetExclusion = function(facet, value) {
  this._change({
    state: this.state.resetPage().addExcludeRefinement(facet, value),
    isPageReset: true
  });

  return this;
};

/**
 * @deprecated since version 2.4.0, see {@link AlgoliaSearchHelper#addFacetExclusion}
 */
AlgoliaSearchHelper.prototype.addExclude = function() {
  return this.addFacetExclusion.apply(this, arguments);
};

/**
 * Adds a tag filter with the `tag` provided. If the
 * filter is already set, it doesn't change the filters.
 *
 * This method resets the current page to 0.
 * @param {string} tag the tag to add to the filter
 * @return {AlgoliaSearchHelper}
 * @fires change
 * @chainable
 */
AlgoliaSearchHelper.prototype.addTag = function(tag) {
  this._change({
    state: this.state.resetPage().addTagRefinement(tag),
    isPageReset: true
  });

  return this;
};

/**
 * Removes an numeric filter to an attribute with the `operator` and `value` provided. If the
 * filter is not set, it doesn't change the filters.
 *
 * Some parameters are optional, triggering different behavior:
 *  - if the value is not provided, then all the numeric value will be removed for the
 *  specified attribute/operator couple.
 *  - if the operator is not provided either, then all the numeric filter on this attribute
 *  will be removed.
 *
 * This method resets the current page to 0.
 * @param  {string} attribute the attribute on which the numeric filter applies
 * @param  {string} [operator] the operator of the filter
 * @param  {number} [value] the value of the filter
 * @return {AlgoliaSearchHelper}
 * @fires change
 * @chainable
 */
AlgoliaSearchHelper.prototype.removeNumericRefinement = function(attribute, operator, value) {
  this._change({
    state: this.state.resetPage().removeNumericRefinement(attribute, operator, value),
    isPageReset: true
  });

  return this;
};

/**
 * Removes a disjunctive filter to a faceted attribute with the `value` provided. If the
 * filter is not set, it doesn't change the filters.
 *
 * If the value is omitted, then this method will remove all the filters for the
 * attribute.
 *
 * This method resets the current page to 0.
 * @param  {string} facet the facet to refine
 * @param  {string} [value] the associated value
 * @return {AlgoliaSearchHelper}
 * @fires change
 * @chainable
 */
AlgoliaSearchHelper.prototype.removeDisjunctiveFacetRefinement = function(facet, value) {
  this._change({
    state: this.state.resetPage().removeDisjunctiveFacetRefinement(facet, value),
    isPageReset: true
  });

  return this;
};

/**
 * @deprecated since version 2.4.0, see {@link AlgoliaSearchHelper#removeDisjunctiveFacetRefinement}
 */
AlgoliaSearchHelper.prototype.removeDisjunctiveRefine = function() {
  return this.removeDisjunctiveFacetRefinement.apply(this, arguments);
};

/**
 * Removes the refinement set on a hierarchical facet.
 * @param {string} facet the facet name
 * @return {AlgoliaSearchHelper}
 * @throws Error if the facet is not defined or if the facet is not refined
 * @fires change
 * @chainable
 */
AlgoliaSearchHelper.prototype.removeHierarchicalFacetRefinement = function(facet) {
  this._change({
    state: this.state.resetPage().removeHierarchicalFacetRefinement(facet),
    isPageReset: true
  });

  return this;
};

/**
 * Removes a filter to a faceted attribute with the `value` provided. If the
 * filter is not set, it doesn't change the filters.
 *
 * If the value is omitted, then this method will remove all the filters for the
 * attribute.
 *
 * This method resets the current page to 0.
 * @param  {string} facet the facet to refine
 * @param  {string} [value] the associated value
 * @return {AlgoliaSearchHelper}
 * @fires change
 * @chainable
 */
AlgoliaSearchHelper.prototype.removeFacetRefinement = function(facet, value) {
  this._change({
    state: this.state.resetPage().removeFacetRefinement(facet, value),
    isPageReset: true
  });

  return this;
};

/**
 * @deprecated since version 2.4.0, see {@link AlgoliaSearchHelper#removeFacetRefinement}
 */
AlgoliaSearchHelper.prototype.removeRefine = function() {
  return this.removeFacetRefinement.apply(this, arguments);
};

/**
 * Removes an exclusion filter to a faceted attribute with the `value` provided. If the
 * filter is not set, it doesn't change the filters.
 *
 * If the value is omitted, then this method will remove all the filters for the
 * attribute.
 *
 * This method resets the current page to 0.
 * @param  {string} facet the facet to refine
 * @param  {string} [value] the associated value
 * @return {AlgoliaSearchHelper}
 * @fires change
 * @chainable
 */
AlgoliaSearchHelper.prototype.removeFacetExclusion = function(facet, value) {
  this._change({
    state: this.state.resetPage().removeExcludeRefinement(facet, value),
    isPageReset: true
  });

  return this;
};

/**
 * @deprecated since version 2.4.0, see {@link AlgoliaSearchHelper#removeFacetExclusion}
 */
AlgoliaSearchHelper.prototype.removeExclude = function() {
  return this.removeFacetExclusion.apply(this, arguments);
};

/**
 * Removes a tag filter with the `tag` provided. If the
 * filter is not set, it doesn't change the filters.
 *
 * This method resets the current page to 0.
 * @param {string} tag tag to remove from the filter
 * @return {AlgoliaSearchHelper}
 * @fires change
 * @chainable
 */
AlgoliaSearchHelper.prototype.removeTag = function(tag) {
  this._change({
    state: this.state.resetPage().removeTagRefinement(tag),
    isPageReset: true
  });

  return this;
};

/**
 * Adds or removes an exclusion filter to a faceted attribute with the `value` provided. If
 * the value is set then it removes it, otherwise it adds the filter.
 *
 * This method resets the current page to 0.
 * @param  {string} facet the facet to refine
 * @param  {string} value the associated value
 * @return {AlgoliaSearchHelper}
 * @fires change
 * @chainable
 */
AlgoliaSearchHelper.prototype.toggleFacetExclusion = function(facet, value) {
  this._change({
    state: this.state.resetPage().toggleExcludeFacetRefinement(facet, value),
    isPageReset: true
  });

  return this;
};

/**
 * @deprecated since version 2.4.0, see {@link AlgoliaSearchHelper#toggleFacetExclusion}
 */
AlgoliaSearchHelper.prototype.toggleExclude = function() {
  return this.toggleFacetExclusion.apply(this, arguments);
};

/**
 * Adds or removes a filter to a faceted attribute with the `value` provided. If
 * the value is set then it removes it, otherwise it adds the filter.
 *
 * This method can be used for conjunctive, disjunctive and hierarchical filters.
 *
 * This method resets the current page to 0.
 * @param  {string} facet the facet to refine
 * @param  {string} value the associated value
 * @return {AlgoliaSearchHelper}
 * @throws Error will throw an error if the facet is not declared in the settings of the helper
 * @fires change
 * @chainable
 * @deprecated since version 2.19.0, see {@link AlgoliaSearchHelper#toggleFacetRefinement}
 */
AlgoliaSearchHelper.prototype.toggleRefinement = function(facet, value) {
  return this.toggleFacetRefinement(facet, value);
};

/**
 * Adds or removes a filter to a faceted attribute with the `value` provided. If
 * the value is set then it removes it, otherwise it adds the filter.
 *
 * This method can be used for conjunctive, disjunctive and hierarchical filters.
 *
 * This method resets the current page to 0.
 * @param  {string} facet the facet to refine
 * @param  {string} value the associated value
 * @return {AlgoliaSearchHelper}
 * @throws Error will throw an error if the facet is not declared in the settings of the helper
 * @fires change
 * @chainable
 */
AlgoliaSearchHelper.prototype.toggleFacetRefinement = function(facet, value) {
  this._change({
    state: this.state.resetPage().toggleFacetRefinement(facet, value),
    isPageReset: true
  });

  return this;
};

/**
 * @deprecated since version 2.4.0, see {@link AlgoliaSearchHelper#toggleFacetRefinement}
 */
AlgoliaSearchHelper.prototype.toggleRefine = function() {
  return this.toggleFacetRefinement.apply(this, arguments);
};

/**
 * Adds or removes a tag filter with the `value` provided. If
 * the value is set then it removes it, otherwise it adds the filter.
 *
 * This method resets the current page to 0.
 * @param {string} tag tag to remove or add
 * @return {AlgoliaSearchHelper}
 * @fires change
 * @chainable
 */
AlgoliaSearchHelper.prototype.toggleTag = function(tag) {
  this._change({
    state: this.state.resetPage().toggleTagRefinement(tag),
    isPageReset: true
  });

  return this;
};

/**
 * Increments the page number by one.
 * @return {AlgoliaSearchHelper}
 * @fires change
 * @chainable
 * @example
 * helper.setPage(0).nextPage().getPage();
 * // returns 1
 */
AlgoliaSearchHelper.prototype.nextPage = function() {
  var page = this.state.page || 0;
  return this.setPage(page + 1);
};

/**
 * Decrements the page number by one.
 * @fires change
 * @return {AlgoliaSearchHelper}
 * @chainable
 * @example
 * helper.setPage(1).previousPage().getPage();
 * // returns 0
 */
AlgoliaSearchHelper.prototype.previousPage = function() {
  var page = this.state.page || 0;
  return this.setPage(page - 1);
};

/**
 * @private
 */
function setCurrentPage(page) {
  if (page < 0) throw new Error('Page requested below 0.');

  this._change({
    state: this.state.setPage(page),
    isPageReset: false
  });

  return this;
}

/**
 * Change the current page
 * @deprecated
 * @param  {number} page The page number
 * @return {AlgoliaSearchHelper}
 * @fires change
 * @chainable
 */
AlgoliaSearchHelper.prototype.setCurrentPage = setCurrentPage;

/**
 * Updates the current page.
 * @function
 * @param  {number} page The page number
 * @return {AlgoliaSearchHelper}
 * @fires change
 * @chainable
 */
AlgoliaSearchHelper.prototype.setPage = setCurrentPage;

/**
 * Updates the name of the index that will be targeted by the query.
 *
 * This method resets the current page to 0.
 * @param {string} name the index name
 * @return {AlgoliaSearchHelper}
 * @fires change
 * @chainable
 */
AlgoliaSearchHelper.prototype.setIndex = function(name) {
  this._change({
    state: this.state.resetPage().setIndex(name),
    isPageReset: true
  });

  return this;
};

/**
 * Update a parameter of the search. This method reset the page
 *
 * The complete list of parameters is available on the
 * [Algolia website](https://www.algolia.com/doc/rest#query-an-index).
 * The most commonly used parameters have their own [shortcuts](#query-parameters-shortcuts)
 * or benefit from higher-level APIs (all the kind of filters and facets have their own API)
 *
 * This method resets the current page to 0.
 * @param {string} parameter name of the parameter to update
 * @param {any} value new value of the parameter
 * @return {AlgoliaSearchHelper}
 * @fires change
 * @chainable
 * @example
 * helper.setQueryParameter('hitsPerPage', 20).search();
 */
AlgoliaSearchHelper.prototype.setQueryParameter = function(parameter, value) {
  this._change({
    state: this.state.resetPage().setQueryParameter(parameter, value),
    isPageReset: true
  });

  return this;
};

/**
 * Set the whole state (warning: will erase previous state)
 * @param {SearchParameters} newState the whole new state
 * @return {AlgoliaSearchHelper}
 * @fires change
 * @chainable
 */
AlgoliaSearchHelper.prototype.setState = function(newState) {
  this._change({
    state: SearchParameters.make(newState),
    isPageReset: false
  });

  return this;
};

/**
 * Override the current state without triggering a change event.
 * Do not use this method unless you know what you are doing. (see the example
 * for a legit use case)
 * @param {SearchParameters} newState the whole new state
 * @return {AlgoliaSearchHelper}
 * @example
 *  helper.on('change', function(state){
 *    // In this function you might want to find a way to store the state in the url/history
 *    updateYourURL(state)
 *  })
 *  window.onpopstate = function(event){
 *    // This is naive though as you should check if the state is really defined etc.
 *    helper.overrideStateWithoutTriggeringChangeEvent(event.state).search()
 *  }
 * @chainable
 */
AlgoliaSearchHelper.prototype.overrideStateWithoutTriggeringChangeEvent = function(newState) {
  this.state = new SearchParameters(newState);
  return this;
};

/**
 * Check if an attribute has any numeric, conjunctive, disjunctive or hierarchical filters.
 * @param {string} attribute the name of the attribute
 * @return {boolean} true if the attribute is filtered by at least one value
 * @example
 * // hasRefinements works with numeric, conjunctive, disjunctive and hierarchical filters
 * helper.hasRefinements('price'); // false
 * helper.addNumericRefinement('price', '>', 100);
 * helper.hasRefinements('price'); // true
 *
 * helper.hasRefinements('color'); // false
 * helper.addFacetRefinement('color', 'blue');
 * helper.hasRefinements('color'); // true
 *
 * helper.hasRefinements('material'); // false
 * helper.addDisjunctiveFacetRefinement('material', 'plastic');
 * helper.hasRefinements('material'); // true
 *
 * helper.hasRefinements('categories'); // false
 * helper.toggleFacetRefinement('categories', 'kitchen > knife');
 * helper.hasRefinements('categories'); // true
 *
 */
AlgoliaSearchHelper.prototype.hasRefinements = function(attribute) {
  if (objectHasKeys(this.state.getNumericRefinements(attribute))) {
    return true;
  } else if (this.state.isConjunctiveFacet(attribute)) {
    return this.state.isFacetRefined(attribute);
  } else if (this.state.isDisjunctiveFacet(attribute)) {
    return this.state.isDisjunctiveFacetRefined(attribute);
  } else if (this.state.isHierarchicalFacet(attribute)) {
    return this.state.isHierarchicalFacetRefined(attribute);
  }

  // there's currently no way to know that the user did call `addNumericRefinement` at some point
  // thus we cannot distinguish if there once was a numeric refinement that was cleared
  // so we will return false in every other situations to be consistent
  // while what we should do here is throw because we did not find the attribute in any type
  // of refinement
  return false;
};

/**
 * Check if a value is excluded for a specific faceted attribute. If the value
 * is omitted then the function checks if there is any excluding refinements.
 *
 * @param  {string}  facet name of the attribute for used for faceting
 * @param  {string}  [value] optional value. If passed will test that this value
   * is filtering the given facet.
 * @return {boolean} true if refined
 * @example
 * helper.isExcludeRefined('color'); // false
 * helper.isExcludeRefined('color', 'blue') // false
 * helper.isExcludeRefined('color', 'red') // false
 *
 * helper.addFacetExclusion('color', 'red');
 *
 * helper.isExcludeRefined('color'); // true
 * helper.isExcludeRefined('color', 'blue') // false
 * helper.isExcludeRefined('color', 'red') // true
 */
AlgoliaSearchHelper.prototype.isExcluded = function(facet, value) {
  return this.state.isExcludeRefined(facet, value);
};

/**
 * @deprecated since 2.4.0, see {@link AlgoliaSearchHelper#hasRefinements}
 */
AlgoliaSearchHelper.prototype.isDisjunctiveRefined = function(facet, value) {
  return this.state.isDisjunctiveFacetRefined(facet, value);
};

/**
 * Check if the string is a currently filtering tag.
 * @param {string} tag tag to check
 * @return {boolean}
 */
AlgoliaSearchHelper.prototype.hasTag = function(tag) {
  return this.state.isTagRefined(tag);
};

/**
 * @deprecated since 2.4.0, see {@link AlgoliaSearchHelper#hasTag}
 */
AlgoliaSearchHelper.prototype.isTagRefined = function() {
  return this.hasTagRefinements.apply(this, arguments);
};


/**
 * Get the name of the currently used index.
 * @return {string}
 * @example
 * helper.setIndex('highestPrice_products').getIndex();
 * // returns 'highestPrice_products'
 */
AlgoliaSearchHelper.prototype.getIndex = function() {
  return this.state.index;
};

function getCurrentPage() {
  return this.state.page;
}

/**
 * Get the currently selected page
 * @deprecated
 * @return {number} the current page
 */
AlgoliaSearchHelper.prototype.getCurrentPage = getCurrentPage;
/**
 * Get the currently selected page
 * @function
 * @return {number} the current page
 */
AlgoliaSearchHelper.prototype.getPage = getCurrentPage;

/**
 * Get all the tags currently set to filters the results.
 *
 * @return {string[]} The list of tags currently set.
 */
AlgoliaSearchHelper.prototype.getTags = function() {
  return this.state.tagRefinements;
};

/**
 * Get the list of refinements for a given attribute. This method works with
 * conjunctive, disjunctive, excluding and numerical filters.
 *
 * See also SearchResults#getRefinements
 *
 * @param {string} facetName attribute name used for faceting
 * @return {Array.<FacetRefinement|NumericRefinement>} All Refinement are objects that contain a value, and
 * a type. Numeric also contains an operator.
 * @example
 * helper.addNumericRefinement('price', '>', 100);
 * helper.getRefinements('price');
 * // [
 * //   {
 * //     "value": [
 * //       100
 * //     ],
 * //     "operator": ">",
 * //     "type": "numeric"
 * //   }
 * // ]
 * @example
 * helper.addFacetRefinement('color', 'blue');
 * helper.addFacetExclusion('color', 'red');
 * helper.getRefinements('color');
 * // [
 * //   {
 * //     "value": "blue",
 * //     "type": "conjunctive"
 * //   },
 * //   {
 * //     "value": "red",
 * //     "type": "exclude"
 * //   }
 * // ]
 * @example
 * helper.addDisjunctiveFacetRefinement('material', 'plastic');
 * // [
 * //   {
 * //     "value": "plastic",
 * //     "type": "disjunctive"
 * //   }
 * // ]
 */
AlgoliaSearchHelper.prototype.getRefinements = function(facetName) {
  var refinements = [];

  if (this.state.isConjunctiveFacet(facetName)) {
    var conjRefinements = this.state.getConjunctiveRefinements(facetName);

    conjRefinements.forEach(function(r) {
      refinements.push({
        value: r,
        type: 'conjunctive'
      });
    });

    var excludeRefinements = this.state.getExcludeRefinements(facetName);

    excludeRefinements.forEach(function(r) {
      refinements.push({
        value: r,
        type: 'exclude'
      });
    });
  } else if (this.state.isDisjunctiveFacet(facetName)) {
    var disjRefinements = this.state.getDisjunctiveRefinements(facetName);

    disjRefinements.forEach(function(r) {
      refinements.push({
        value: r,
        type: 'disjunctive'
      });
    });
  }

  var numericRefinements = this.state.getNumericRefinements(facetName);

  Object.keys(numericRefinements).forEach(function(operator) {
    var value = numericRefinements[operator];

    refinements.push({
      value: value,
      operator: operator,
      type: 'numeric'
    });
  });

  return refinements;
};

/**
 * Return the current refinement for the (attribute, operator)
 * @param {string} attribute attribute in the record
 * @param {string} operator operator applied on the refined values
 * @return {Array.<number|number[]>} refined values
 */
AlgoliaSearchHelper.prototype.getNumericRefinement = function(attribute, operator) {
  return this.state.getNumericRefinement(attribute, operator);
};

/**
 * Get the current breadcrumb for a hierarchical facet, as an array
 * @param  {string} facetName Hierarchical facet name
 * @return {array.<string>} the path as an array of string
 */
AlgoliaSearchHelper.prototype.getHierarchicalFacetBreadcrumb = function(facetName) {
  return this.state.getHierarchicalFacetBreadcrumb(facetName);
};

// /////////// PRIVATE

/**
 * Perform the underlying queries
 * @private
 * @return {undefined}
 * @fires search
 * @fires result
 * @fires error
 */
AlgoliaSearchHelper.prototype._search = function(options) {
  var state = this.state;
  var states = [];
  var mainQueries = [];

  if (!options.onlyWithDerivedHelpers) {
    mainQueries = requestBuilder._getQueries(state.index, state);

    states.push({
      state: state,
      queriesCount: mainQueries.length,
      helper: this
    });

    this.emit('search', {
      state: state,
      results: this.lastResults
    });
  }

  var derivedQueries = this.derivedHelpers.map(function(derivedHelper) {
    var derivedState = derivedHelper.getModifiedState(state);
    var derivedStateQueries = requestBuilder._getQueries(derivedState.index, derivedState);

    states.push({
      state: derivedState,
      queriesCount: derivedStateQueries.length,
      helper: derivedHelper
    });

    derivedHelper.emit('search', {
      state: derivedState,
      results: derivedHelper.lastResults
    });

    return derivedStateQueries;
  });

  var queries = Array.prototype.concat.apply(mainQueries, derivedQueries);
  var queryId = this._queryId++;

  this._currentNbQueries++;

  try {
    this.client.search(queries)
      .then(this._dispatchAlgoliaResponse.bind(this, states, queryId))
      .catch(this._dispatchAlgoliaError.bind(this, queryId));
  } catch (error) {
    // If we reach this part, we're in an internal error state
    this.emit('error', {
      error: error
    });
  }
};

/**
 * Transform the responses as sent by the server and transform them into a user
 * usable object that merge the results of all the batch requests. It will dispatch
 * over the different helper + derived helpers (when there are some).
 * @private
 * @param {array.<{SearchParameters, AlgoliaQueries, AlgoliaSearchHelper}>}
 *  state state used for to generate the request
 * @param {number} queryId id of the current request
 * @param {object} content content of the response
 * @return {undefined}
 */
AlgoliaSearchHelper.prototype._dispatchAlgoliaResponse = function(states, queryId, content) {
  // FIXME remove the number of outdated queries discarded instead of just one

  if (queryId < this._lastQueryIdReceived) {
    // Outdated answer
    return;
  }

  this._currentNbQueries -= (queryId - this._lastQueryIdReceived);
  this._lastQueryIdReceived = queryId;

  if (this._currentNbQueries === 0) this.emit('searchQueueEmpty');

  var results = content.results.slice();

  states.forEach(function(s) {
    var state = s.state;
    var queriesCount = s.queriesCount;
    var helper = s.helper;
    var specificResults = results.splice(0, queriesCount);

    var formattedResponse = helper.lastResults = new SearchResults(state, specificResults);

    helper.emit('result', {
      results: formattedResponse,
      state: state
    });
  });
};

AlgoliaSearchHelper.prototype._dispatchAlgoliaError = function(queryId, error) {
  if (queryId < this._lastQueryIdReceived) {
    // Outdated answer
    return;
  }

  this._currentNbQueries -= queryId - this._lastQueryIdReceived;
  this._lastQueryIdReceived = queryId;

  this.emit('error', {
    error: error
  });

  if (this._currentNbQueries === 0) this.emit('searchQueueEmpty');
};

AlgoliaSearchHelper.prototype.containsRefinement = function(query, facetFilters, numericFilters, tagFilters) {
  return query ||
    facetFilters.length !== 0 ||
    numericFilters.length !== 0 ||
    tagFilters.length !== 0;
};

/**
 * Test if there are some disjunctive refinements on the facet
 * @private
 * @param {string} facet the attribute to test
 * @return {boolean}
 */
AlgoliaSearchHelper.prototype._hasDisjunctiveRefinements = function(facet) {
  return this.state.disjunctiveRefinements[facet] &&
    this.state.disjunctiveRefinements[facet].length > 0;
};

AlgoliaSearchHelper.prototype._change = function(event) {
  var state = event.state;
  var isPageReset = event.isPageReset;

  if (state !== this.state) {
    this.state = state;

    this.emit('change', {
      state: this.state,
      results: this.lastResults,
      isPageReset: isPageReset
    });
  }
};

/**
 * Clears the cache of the underlying Algolia client.
 * @return {AlgoliaSearchHelper}
 */
AlgoliaSearchHelper.prototype.clearCache = function() {
  this.client.clearCache && this.client.clearCache();
  return this;
};

/**
 * Updates the internal client instance. If the reference of the clients
 * are equal then no update is actually done.
 * @param  {AlgoliaSearch} newClient an AlgoliaSearch client
 * @return {AlgoliaSearchHelper}
 */
AlgoliaSearchHelper.prototype.setClient = function(newClient) {
  if (this.client === newClient) return this;

  if (typeof newClient.addAlgoliaAgent === 'function') {
    newClient.addAlgoliaAgent('JS Helper (' + version + ')');
  }
  this.client = newClient;

  return this;
};

/**
 * Gets the instance of the currently used client.
 * @return {AlgoliaSearch}
 */
AlgoliaSearchHelper.prototype.getClient = function() {
  return this.client;
};

/**
 * Creates an derived instance of the Helper. A derived helper
 * is a way to request other indices synchronised with the lifecycle
 * of the main Helper. This mechanism uses the multiqueries feature
 * of Algolia to aggregate all the requests in a single network call.
 *
 * This method takes a function that is used to create a new SearchParameter
 * that will be used to create requests to Algolia. Those new requests
 * are created just before the `search` event. The signature of the function
 * is `SearchParameters -> SearchParameters`.
 *
 * This method returns a new DerivedHelper which is an EventEmitter
 * that fires the same `search`, `result` and `error` events. Those
 * events, however, will receive data specific to this DerivedHelper
 * and the SearchParameters that is returned by the call of the
 * parameter function.
 * @param {function} fn SearchParameters -> SearchParameters
 * @return {DerivedHelper}
 */
AlgoliaSearchHelper.prototype.derive = function(fn) {
  var derivedHelper = new DerivedHelper(this, fn);
  this.derivedHelpers.push(derivedHelper);
  return derivedHelper;
};

/**
 * This method detaches a derived Helper from the main one. Prefer using the one from the
 * derived helper itself, to remove the event listeners too.
 * @private
 * @return {undefined}
 * @throws Error
 */
AlgoliaSearchHelper.prototype.detachDerivedHelper = function(derivedHelper) {
  var pos = this.derivedHelpers.indexOf(derivedHelper);
  if (pos === -1) throw new Error('Derived helper already detached');
  this.derivedHelpers.splice(pos, 1);
};

/**
 * This method returns true if there is currently at least one on-going search.
 * @return {boolean} true if there is a search pending
 */
AlgoliaSearchHelper.prototype.hasPendingRequests = function() {
  return this._currentNbQueries > 0;
};

/**
 * @typedef AlgoliaSearchHelper.NumericRefinement
 * @type {object}
 * @property {number[]} value the numbers that are used for filtering this attribute with
 * the operator specified.
 * @property {string} operator the faceting data: value, number of entries
 * @property {string} type will be 'numeric'
 */

/**
 * @typedef AlgoliaSearchHelper.FacetRefinement
 * @type {object}
 * @property {string} value the string use to filter the attribute
 * @property {string} type the type of filter: 'conjunctive', 'disjunctive', 'exclude'
 */

module.exports = AlgoliaSearchHelper;


/***/ }),

/***/ 29241:
/***/ (function(module) {

"use strict";


module.exports = function compact(array) {
  if (!Array.isArray(array)) {
    return [];
  }

  return array.filter(Boolean);
};


/***/ }),

/***/ 67955:
/***/ (function(module) {

"use strict";


// NOTE: this behaves like lodash/defaults, but doesn't mutate the target
// it also preserve keys order
module.exports = function defaultsPure() {
  var sources = Array.prototype.slice.call(arguments);

  return sources.reduceRight(function(acc, source) {
    Object.keys(Object(source)).forEach(function(key) {
      if (source[key] === undefined) {
        return;
      }
      if (acc[key] !== undefined) {
        // remove if already added, so that we can add it in correct order
        delete acc[key];
      }
      acc[key] = source[key];
    });
    return acc;
  }, {});
};


/***/ }),

/***/ 23433:
/***/ (function(module) {

"use strict";


/**
 * Replaces a leading - with \-
 * @private
 * @param {any} value the facet value to replace
 * @returns any
 */
function escapeFacetValue(value) {
  if (typeof value !== 'string') return value;

  return String(value).replace(/^-/, '\\-');
}

/**
 * Replaces a leading \- with -
 * @private
 * @param {any} value the escaped facet value
 * @returns any
 */
function unescapeFacetValue(value) {
  if (typeof value !== 'string') return value;

  return value.replace(/^\\-/, '-');
}

module.exports = {
  escapeFacetValue: escapeFacetValue,
  unescapeFacetValue: unescapeFacetValue
};


/***/ }),

/***/ 38901:
/***/ (function(module) {

"use strict";


// @MAJOR can be replaced by native Array#find when we change support
module.exports = function find(array, comparator) {
  if (!Array.isArray(array)) {
    return undefined;
  }

  for (var i = 0; i < array.length; i++) {
    if (comparator(array[i])) {
      return array[i];
    }
  }
};


/***/ }),

/***/ 84909:
/***/ (function(module) {

"use strict";


// @MAJOR can be replaced by native Array#findIndex when we change support
module.exports = function find(array, comparator) {
  if (!Array.isArray(array)) {
    return -1;
  }

  for (var i = 0; i < array.length; i++) {
    if (comparator(array[i])) {
      return i;
    }
  }
  return -1;
};


/***/ }),

/***/ 28441:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var find = __webpack_require__(38901);

/**
 * Transform sort format from user friendly notation to lodash format
 * @param {string[]} sortBy array of predicate of the form "attribute:order"
 * @param {string[]} [defaults] array of predicate of the form "attribute:order"
 * @return {array.<string[]>} array containing 2 elements : attributes, orders
 */
module.exports = function formatSort(sortBy, defaults) {
  var defaultInstructions = (defaults || []).map(function(sort) {
    return sort.split(':');
  });

  return sortBy.reduce(
    function preparePredicate(out, sort) {
      var sortInstruction = sort.split(':');

      var matchingDefault = find(defaultInstructions, function(
        defaultInstruction
      ) {
        return defaultInstruction[0] === sortInstruction[0];
      });

      if (sortInstruction.length > 1 || !matchingDefault) {
        out[0].push(sortInstruction[0]);
        out[1].push(sortInstruction[1]);
        return out;
      }

      out[0].push(matchingDefault[0]);
      out[1].push(matchingDefault[1]);
      return out;
    },
    [[], []]
  );
};


/***/ }),

/***/ 37224:
/***/ (function(module) {

"use strict";


function inherits(ctor, superCtor) {
  ctor.prototype = Object.create(superCtor.prototype, {
    constructor: {
      value: ctor,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
}

module.exports = inherits;


/***/ }),

/***/ 47485:
/***/ (function(module) {

"use strict";


function intersection(arr1, arr2) {
  return arr1.filter(function(value, index) {
    return (
      arr2.indexOf(value) > -1 &&
      arr1.indexOf(value) === index /* skips duplicates */
    );
  });
}

module.exports = intersection;


/***/ }),

/***/ 43600:
/***/ (function(module) {

"use strict";


function clone(value) {
  if (typeof value === 'object' && value !== null) {
    return _merge(Array.isArray(value) ? [] : {}, value);
  }
  return value;
}

function isObjectOrArrayOrFunction(value) {
  return (
    typeof value === 'function' ||
    Array.isArray(value) ||
    Object.prototype.toString.call(value) === '[object Object]'
  );
}

function _merge(target, source) {
  if (target === source) {
    return target;
  }

  for (var key in source) {
    if (
      !Object.prototype.hasOwnProperty.call(source, key) ||
      key === '__proto__'
    ) {
      continue;
    }

    var sourceVal = source[key];
    var targetVal = target[key];

    if (typeof targetVal !== 'undefined' && typeof sourceVal === 'undefined') {
      continue;
    }

    if (
      isObjectOrArrayOrFunction(targetVal) &&
      isObjectOrArrayOrFunction(sourceVal)
    ) {
      target[key] = _merge(targetVal, sourceVal);
    } else {
      target[key] = clone(sourceVal);
    }
  }
  return target;
}

/**
 * This method is like Object.assign, but recursively merges own and inherited
 * enumerable keyed properties of source objects into the destination object.
 *
 * NOTE: this behaves like lodash/merge, but:
 * - does mutate functions if they are a source
 * - treats non-plain objects as plain
 * - does not work for circular objects
 * - treats sparse arrays as sparse
 * - does not convert Array-like objects (Arguments, NodeLists, etc.) to arrays
 *
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 */

function merge(target) {
  if (!isObjectOrArrayOrFunction(target)) {
    target = {};
  }

  for (var i = 1, l = arguments.length; i < l; i++) {
    var source = arguments[i];

    if (isObjectOrArrayOrFunction(source)) {
      _merge(target, source);
    }
  }
  return target;
}

module.exports = merge;


/***/ }),

/***/ 68711:
/***/ (function(module) {

"use strict";


function objectHasKeys(obj) {
  return obj && Object.keys(obj).length > 0;
}

module.exports = objectHasKeys;


/***/ }),

/***/ 25279:
/***/ (function(module) {

"use strict";


// https://github.com/babel/babel/blob/3aaafae053fa75febb3aa45d45b6f00646e30ba4/packages/babel-helpers/src/helpers.js#L604-L620
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source === null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key;
  var i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}

module.exports = _objectWithoutPropertiesLoose;


/***/ }),

/***/ 71539:
/***/ (function(module) {

"use strict";


function compareAscending(value, other) {
  if (value !== other) {
    var valIsDefined = value !== undefined;
    var valIsNull = value === null;

    var othIsDefined = other !== undefined;
    var othIsNull = other === null;

    if (
      (!othIsNull && value > other) ||
      (valIsNull && othIsDefined) ||
      !valIsDefined
    ) {
      return 1;
    }
    if (
      (!valIsNull && value < other) ||
      (othIsNull && valIsDefined) ||
      !othIsDefined
    ) {
      return -1;
    }
  }
  return 0;
}

/**
 * @param {Array<object>} collection object with keys in attributes
 * @param {Array<string>} iteratees attributes
 * @param {Array<string>} orders asc | desc
 */
function orderBy(collection, iteratees, orders) {
  if (!Array.isArray(collection)) {
    return [];
  }

  if (!Array.isArray(orders)) {
    orders = [];
  }

  var result = collection.map(function(value, index) {
    return {
      criteria: iteratees.map(function(iteratee) {
        return value[iteratee];
      }),
      index: index,
      value: value
    };
  });

  result.sort(function comparer(object, other) {
    var index = -1;

    while (++index < object.criteria.length) {
      var res = compareAscending(object.criteria[index], other.criteria[index]);
      if (res) {
        if (index >= orders.length) {
          return res;
        }
        if (orders[index] === 'desc') {
          return -res;
        }
        return res;
      }
    }

    // This ensures a stable sort in V8 and other engines.
    // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
    return object.index - other.index;
  });

  return result.map(function(res) {
    return res.value;
  });
}

module.exports = orderBy;


/***/ }),

/***/ 30240:
/***/ (function(module) {

"use strict";


function valToNumber(v) {
  if (typeof v === 'number') {
    return v;
  } else if (typeof v === 'string') {
    return parseFloat(v);
  } else if (Array.isArray(v)) {
    return v.map(valToNumber);
  }

  throw new Error('The value should be a number, a parsable string or an array of those.');
}

module.exports = valToNumber;


/***/ }),

/***/ 84646:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var merge = __webpack_require__(43600);

function sortObject(obj) {
  return Object.keys(obj)
    .sort(function(a, b) {
      return a.localeCompare(b);
    })
    .reduce(function(acc, curr) {
      acc[curr] = obj[curr];
      return acc;
    }, {});
}

var requestBuilder = {
  /**
   * Get all the queries to send to the client, those queries can used directly
   * with the Algolia client.
   * @private
   * @return {object[]} The queries
   */
  _getQueries: function getQueries(index, state) {
    var queries = [];

    // One query for the hits
    queries.push({
      indexName: index,
      params: requestBuilder._getHitsSearchParams(state)
    });

    // One for each disjunctive facets
    state.getRefinedDisjunctiveFacets().forEach(function(refinedFacet) {
      queries.push({
        indexName: index,
        params: requestBuilder._getDisjunctiveFacetSearchParams(state, refinedFacet)
      });
    });

    // More to get the parent levels of the hierarchical facets when refined
    state.getRefinedHierarchicalFacets().forEach(function(refinedFacet) {
      var hierarchicalFacet = state.getHierarchicalFacetByName(refinedFacet);
      var currentRefinement = state.getHierarchicalRefinement(refinedFacet);
      var separator = state._getHierarchicalFacetSeparator(hierarchicalFacet);

      // If we are deeper than level 0 (starting from `beer > IPA`)
      // we want to get all parent values
      if (currentRefinement.length > 0 && currentRefinement[0].split(separator).length > 1) {
        // We generate a map of the filters we will use for our facet values queries
        var filtersMap = currentRefinement[0].split(separator).slice(0, -1).reduce(
          function createFiltersMap(map, segment, level) {
            return map.concat({
              attribute: hierarchicalFacet.attributes[level],
              value: level === 0
                ? segment
                : [map[map.length - 1].value, segment].join(separator)
            });
          }
        , []);

        filtersMap.forEach(function(filter, level) {
          var params = requestBuilder._getDisjunctiveFacetSearchParams(
            state,
            filter.attribute,
            level === 0
          );

          // Keep facet filters unrelated to current hierarchical attributes
          function hasHierarchicalFacetFilter(value) {
            return hierarchicalFacet.attributes.some(function(attribute) {
              return attribute === value.split(':')[0];
            });
          }

          var filteredFacetFilters = (params.facetFilters || []).reduce(function(acc, facetFilter) {
            if (Array.isArray(facetFilter)) {
              var filtered = facetFilter.filter(function(filterValue) {
                return !hasHierarchicalFacetFilter(filterValue);
              });

              if (filtered.length > 0) {
                acc.push(filtered);
              }
            }

            if (typeof facetFilter === 'string' && !hasHierarchicalFacetFilter(facetFilter)) {
              acc.push(facetFilter);
            }

            return acc;
          }, []);

          var parent = filtersMap[level - 1];
          if (level > 0) {
            params.facetFilters = filteredFacetFilters.concat(parent.attribute + ':' + parent.value);
          } else {
            params.facetFilters = filteredFacetFilters.length > 0 ? filteredFacetFilters : undefined;
          }

          queries.push({indexName: index, params: params});
        });
      }
    });

    return queries;
  },

  /**
   * Build search parameters used to fetch hits
   * @private
   * @return {object.<string, any>}
   */
  _getHitsSearchParams: function(state) {
    var facets = state.facets
      .concat(state.disjunctiveFacets)
      .concat(requestBuilder._getHitsHierarchicalFacetsAttributes(state));


    var facetFilters = requestBuilder._getFacetFilters(state);
    var numericFilters = requestBuilder._getNumericFilters(state);
    var tagFilters = requestBuilder._getTagFilters(state);
    var additionalParams = {
      facets: facets.indexOf('*') > -1 ? ['*'] : facets,
      tagFilters: tagFilters
    };

    if (facetFilters.length > 0) {
      additionalParams.facetFilters = facetFilters;
    }

    if (numericFilters.length > 0) {
      additionalParams.numericFilters = numericFilters;
    }

    return sortObject(merge({}, state.getQueryParams(), additionalParams));
  },

  /**
   * Build search parameters used to fetch a disjunctive facet
   * @private
   * @param  {string} facet the associated facet name
   * @param  {boolean} hierarchicalRootLevel ?? FIXME
   * @return {object}
   */
  _getDisjunctiveFacetSearchParams: function(state, facet, hierarchicalRootLevel) {
    var facetFilters = requestBuilder._getFacetFilters(state, facet, hierarchicalRootLevel);
    var numericFilters = requestBuilder._getNumericFilters(state, facet);
    var tagFilters = requestBuilder._getTagFilters(state);
    var additionalParams = {
      hitsPerPage: 0,
      page: 0,
      analytics: false,
      clickAnalytics: false
    };

    if (tagFilters.length > 0) {
      additionalParams.tagFilters = tagFilters;
    }

    var hierarchicalFacet = state.getHierarchicalFacetByName(facet);

    if (hierarchicalFacet) {
      additionalParams.facets = requestBuilder._getDisjunctiveHierarchicalFacetAttribute(
        state,
        hierarchicalFacet,
        hierarchicalRootLevel
      );
    } else {
      additionalParams.facets = facet;
    }

    if (numericFilters.length > 0) {
      additionalParams.numericFilters = numericFilters;
    }

    if (facetFilters.length > 0) {
      additionalParams.facetFilters = facetFilters;
    }

    return sortObject(merge({}, state.getQueryParams(), additionalParams));
  },

  /**
   * Return the numeric filters in an algolia request fashion
   * @private
   * @param {string} [facetName] the name of the attribute for which the filters should be excluded
   * @return {string[]} the numeric filters in the algolia format
   */
  _getNumericFilters: function(state, facetName) {
    if (state.numericFilters) {
      return state.numericFilters;
    }

    var numericFilters = [];

    Object.keys(state.numericRefinements).forEach(function(attribute) {
      var operators = state.numericRefinements[attribute] || {};
      Object.keys(operators).forEach(function(operator) {
        var values = operators[operator] || [];
        if (facetName !== attribute) {
          values.forEach(function(value) {
            if (Array.isArray(value)) {
              var vs = value.map(function(v) {
                return attribute + operator + v;
              });
              numericFilters.push(vs);
            } else {
              numericFilters.push(attribute + operator + value);
            }
          });
        }
      });
    });

    return numericFilters;
  },

  /**
   * Return the tags filters depending
   * @private
   * @return {string}
   */
  _getTagFilters: function(state) {
    if (state.tagFilters) {
      return state.tagFilters;
    }

    return state.tagRefinements.join(',');
  },


  /**
   * Build facetFilters parameter based on current refinements. The array returned
   * contains strings representing the facet filters in the algolia format.
   * @private
   * @param  {string} [facet] if set, the current disjunctive facet
   * @return {array.<string>}
   */
  _getFacetFilters: function(state, facet, hierarchicalRootLevel) {
    var facetFilters = [];

    var facetsRefinements = state.facetsRefinements || {};
    Object.keys(facetsRefinements).forEach(function(facetName) {
      var facetValues = facetsRefinements[facetName] || [];
      facetValues.forEach(function(facetValue) {
        facetFilters.push(facetName + ':' + facetValue);
      });
    });

    var facetsExcludes = state.facetsExcludes || {};
    Object.keys(facetsExcludes).forEach(function(facetName) {
      var facetValues = facetsExcludes[facetName] || [];
      facetValues.forEach(function(facetValue) {
        facetFilters.push(facetName + ':-' + facetValue);
      });
    });

    var disjunctiveFacetsRefinements = state.disjunctiveFacetsRefinements || {};
    Object.keys(disjunctiveFacetsRefinements).forEach(function(facetName) {
      var facetValues = disjunctiveFacetsRefinements[facetName] || [];
      if (facetName === facet || !facetValues || facetValues.length === 0) {
        return;
      }
      var orFilters = [];

      facetValues.forEach(function(facetValue) {
        orFilters.push(facetName + ':' + facetValue);
      });

      facetFilters.push(orFilters);
    });

    var hierarchicalFacetsRefinements = state.hierarchicalFacetsRefinements || {};
    Object.keys(hierarchicalFacetsRefinements).forEach(function(facetName) {
      var facetValues = hierarchicalFacetsRefinements[facetName] || [];
      var facetValue = facetValues[0];

      if (facetValue === undefined) {
        return;
      }

      var hierarchicalFacet = state.getHierarchicalFacetByName(facetName);
      var separator = state._getHierarchicalFacetSeparator(hierarchicalFacet);
      var rootPath = state._getHierarchicalRootPath(hierarchicalFacet);
      var attributeToRefine;
      var attributesIndex;

      // we ask for parent facet values only when the `facet` is the current hierarchical facet
      if (facet === facetName) {
        // if we are at the root level already, no need to ask for facet values, we get them from
        // the hits query
        if (facetValue.indexOf(separator) === -1 || (!rootPath && hierarchicalRootLevel === true) ||
          (rootPath && rootPath.split(separator).length === facetValue.split(separator).length)) {
          return;
        }

        if (!rootPath) {
          attributesIndex = facetValue.split(separator).length - 2;
          facetValue = facetValue.slice(0, facetValue.lastIndexOf(separator));
        } else {
          attributesIndex = rootPath.split(separator).length - 1;
          facetValue = rootPath;
        }

        attributeToRefine = hierarchicalFacet.attributes[attributesIndex];
      } else {
        attributesIndex = facetValue.split(separator).length - 1;

        attributeToRefine = hierarchicalFacet.attributes[attributesIndex];
      }

      if (attributeToRefine) {
        facetFilters.push([attributeToRefine + ':' + facetValue]);
      }
    });

    return facetFilters;
  },

  _getHitsHierarchicalFacetsAttributes: function(state) {
    var out = [];

    return state.hierarchicalFacets.reduce(
      // ask for as much levels as there's hierarchical refinements
      function getHitsAttributesForHierarchicalFacet(allAttributes, hierarchicalFacet) {
        var hierarchicalRefinement = state.getHierarchicalRefinement(hierarchicalFacet.name)[0];

        // if no refinement, ask for root level
        if (!hierarchicalRefinement) {
          allAttributes.push(hierarchicalFacet.attributes[0]);
          return allAttributes;
        }

        var separator = state._getHierarchicalFacetSeparator(hierarchicalFacet);
        var level = hierarchicalRefinement.split(separator).length;
        var newAttributes = hierarchicalFacet.attributes.slice(0, level + 1);

        return allAttributes.concat(newAttributes);
      }, out);
  },

  _getDisjunctiveHierarchicalFacetAttribute: function(state, hierarchicalFacet, rootLevel) {
    var separator = state._getHierarchicalFacetSeparator(hierarchicalFacet);
    if (rootLevel === true) {
      var rootPath = state._getHierarchicalRootPath(hierarchicalFacet);
      var attributeIndex = 0;

      if (rootPath) {
        attributeIndex = rootPath.split(separator).length;
      }
      return [hierarchicalFacet.attributes[attributeIndex]];
    }

    var hierarchicalRefinement = state.getHierarchicalRefinement(hierarchicalFacet.name)[0] || '';
    // if refinement is 'beers > IPA > Flying dog',
    // then we want `facets: ['beers > IPA']` as disjunctive facet (parent level values)

    var parentLevel = hierarchicalRefinement.split(separator).length - 1;
    return hierarchicalFacet.attributes.slice(0, parentLevel + 1);
  },

  getSearchForFacetQuery: function(facetName, query, maxFacetHits, state) {
    var stateForSearchForFacetValues = state.isDisjunctiveFacet(facetName) ?
      state.clearRefinements(facetName) :
      state;
    var searchForFacetSearchParameters = {
      facetQuery: query,
      facetName: facetName
    };
    if (typeof maxFacetHits === 'number') {
      searchForFacetSearchParameters.maxFacetHits = maxFacetHits;
    }
    return sortObject(merge(
      {},
      requestBuilder._getHitsSearchParams(stateForSearchForFacetValues),
      searchForFacetSearchParameters
    ));
  }
};

module.exports = requestBuilder;


/***/ }),

/***/ 9444:
/***/ (function(module) {

"use strict";


module.exports = function isValidUserToken(userToken) {
  if (userToken === null) {
    return false;
  }
  return /^[a-zA-Z0-9_-]{1,64}$/.test(userToken);
};


/***/ }),

/***/ 33836:
/***/ (function(module) {

"use strict";


module.exports = '3.11.1';


/***/ }),

/***/ 4549:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;
function e(e){return e&&"object"==typeof e&&"default"in e?e.default:e}__webpack_unused_export__ = ({value:!0});var r=__webpack_require__(91987),t=e(__webpack_require__(7539)),n=e(__webpack_require__(11306)),i=e(__webpack_require__(13966)),a=e(__webpack_require__(88208)),o=e(__webpack_require__(94805)),u=e(__webpack_require__(91951)),s=e(__webpack_require__(26504)),l=e(__webpack_require__(72008));function c(){return(c=Object.assign||function(e){for(var r=1;r<arguments.length;r++){var t=arguments[r];for(var n in t)Object.prototype.hasOwnProperty.call(t,n)&&(e[n]=t[n])}return e}).apply(this,arguments)}function p(e,r){e.prototype=Object.create(r.prototype),e.prototype.constructor=e,e.__proto__=r}function d(e,r){if(null==e)return{};var t,n,i={},a=Object.keys(e);for(n=0;n<a.length;n++)r.indexOf(t=a[n])>=0||(i[t]=e[t]);return i}function f(e){if(void 0===e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return e}var v=function(e){return Array.isArray(e)&&0===e.length},h=function(e){return"function"==typeof e},m=function(e){return null!==e&&"object"==typeof e},y=function(e){return String(Math.floor(Number(e)))===e},E=function(e){return"[object String]"===Object.prototype.toString.call(e)},S=function(e){return 0===r.Children.count(e)},T=function(e){return m(e)&&h(e.then)};function g(e,r,t,n){void 0===n&&(n=0);for(var i=o(r);e&&n<i.length;)e=e[i[n++]];return void 0===e?t:e}function b(e,r,t){for(var n=a(e),i=n,u=0,s=o(r);u<s.length-1;u++){var l=s[u],c=g(e,s.slice(0,u+1));if(c&&(m(c)||Array.isArray(c)))i=i[l]=a(c);else{var p=s[u+1];i=i[l]=y(p)&&Number(p)>=0?[]:{}}}return(0===u?e:i)[s[u]]===t?e:(void 0===t?delete i[s[u]]:i[s[u]]=t,0===u&&void 0===t&&delete n[s[u]],n)}function F(e,r,t,n){void 0===t&&(t=new WeakMap),void 0===n&&(n={});for(var i=0,a=Object.keys(e);i<a.length;i++){var o=a[i],u=e[o];m(u)?t.get(u)||(t.set(u,!0),n[o]=Array.isArray(u)?[]:{},F(u,r,t,n[o])):n[o]=r}return n}var k=r.createContext(void 0);k.displayName="FormikContext";var O=k.Provider,_=k.Consumer;function R(){var e=r.useContext(k);return e||u(!1),e}function A(e,r){switch(r.type){case"SET_VALUES":return c({},e,{values:r.payload});case"SET_TOUCHED":return c({},e,{touched:r.payload});case"SET_ERRORS":return t(e.errors,r.payload)?e:c({},e,{errors:r.payload});case"SET_STATUS":return c({},e,{status:r.payload});case"SET_ISSUBMITTING":return c({},e,{isSubmitting:r.payload});case"SET_ISVALIDATING":return c({},e,{isValidating:r.payload});case"SET_FIELD_VALUE":return c({},e,{values:b(e.values,r.payload.field,r.payload.value)});case"SET_FIELD_TOUCHED":return c({},e,{touched:b(e.touched,r.payload.field,r.payload.value)});case"SET_FIELD_ERROR":return c({},e,{errors:b(e.errors,r.payload.field,r.payload.value)});case"RESET_FORM":return c({},e,r.payload);case"SET_FORMIK_STATE":return r.payload(e);case"SUBMIT_ATTEMPT":return c({},e,{touched:F(e.values,!0),isSubmitting:!0,submitCount:e.submitCount+1});case"SUBMIT_FAILURE":case"SUBMIT_SUCCESS":return c({},e,{isSubmitting:!1});default:return e}}var C={},I={};function P(e){var i=e.validateOnChange,a=void 0===i||i,o=e.validateOnBlur,u=void 0===o||o,s=e.validateOnMount,l=void 0!==s&&s,p=e.isInitialValid,f=e.enableReinitialize,v=void 0!==f&&f,y=e.onSubmit,S=d(e,["validateOnChange","validateOnBlur","validateOnMount","isInitialValid","enableReinitialize","onSubmit"]),F=c({validateOnChange:a,validateOnBlur:u,validateOnMount:l,onSubmit:y},S),k=r.useRef(F.initialValues),O=r.useRef(F.initialErrors||C),_=r.useRef(F.initialTouched||I),R=r.useRef(F.initialStatus),P=r.useRef(!1),x=r.useRef({});r.useEffect((function(){return P.current=!0,function(){P.current=!1}}),[]);var D=r.useReducer(A,{values:F.initialValues,errors:F.initialErrors||C,touched:F.initialTouched||I,status:F.initialStatus,isSubmitting:!1,isValidating:!1,submitCount:0}),w=D[0],j=D[1],N=r.useCallback((function(e,r){return new Promise((function(t,n){var i=F.validate(e,r);null==i?t(C):T(i)?i.then((function(e){t(e||C)}),(function(e){n(e)})):t(i)}))}),[F.validate]),B=r.useCallback((function(e,r){var t=F.validationSchema,n=h(t)?t(r):t,i=r&&n.validateAt?n.validateAt(r,e):V(e,n);return new Promise((function(e,r){i.then((function(){e(C)}),(function(t){"ValidationError"===t.name?e(U(t)):r(t)}))}))}),[F.validationSchema]),q=r.useCallback((function(e,r){return new Promise((function(t){return t(x.current[e].validate(r))}))}),[]),G=r.useCallback((function(e){var r=Object.keys(x.current).filter((function(e){return h(x.current[e].validate)})),t=r.length>0?r.map((function(r){return q(r,g(e,r))})):[Promise.resolve("DO_NOT_DELETE_YOU_WILL_BE_FIRED")];return Promise.all(t).then((function(e){return e.reduce((function(e,t,n){return"DO_NOT_DELETE_YOU_WILL_BE_FIRED"===t?e:(t&&(e=b(e,r[n],t)),e)}),{})}))}),[q]),H=r.useCallback((function(e){return Promise.all([G(e),F.validationSchema?B(e):{},F.validate?N(e):{}]).then((function(e){return n.all([e[0],e[1],e[2]],{arrayMerge:M})}))}),[F.validate,F.validationSchema,G,N,B]),W=L((function(e){return void 0===e&&(e=w.values),j({type:"SET_ISVALIDATING",payload:!0}),H(e).then((function(e){return P.current&&(j({type:"SET_ISVALIDATING",payload:!1}),j({type:"SET_ERRORS",payload:e})),e}))}));r.useEffect((function(){l&&!0===P.current&&t(k.current,F.initialValues)&&W(k.current)}),[l,W]);var K=r.useCallback((function(e){var r=e&&e.values?e.values:k.current,t=e&&e.errors?e.errors:O.current?O.current:F.initialErrors||{},n=e&&e.touched?e.touched:_.current?_.current:F.initialTouched||{},i=e&&e.status?e.status:R.current?R.current:F.initialStatus;k.current=r,O.current=t,_.current=n,R.current=i;var a=function(){j({type:"RESET_FORM",payload:{isSubmitting:!!e&&!!e.isSubmitting,errors:t,touched:n,status:i,values:r,isValidating:!!e&&!!e.isValidating,submitCount:e&&e.submitCount&&"number"==typeof e.submitCount?e.submitCount:0}})};if(F.onReset){var o=F.onReset(w.values,pe);T(o)?o.then(a):a()}else a()}),[F.initialErrors,F.initialStatus,F.initialTouched]);r.useEffect((function(){!0!==P.current||t(k.current,F.initialValues)||(v&&(k.current=F.initialValues,K()),l&&W(k.current))}),[v,F.initialValues,K,l,W]),r.useEffect((function(){v&&!0===P.current&&!t(O.current,F.initialErrors)&&(O.current=F.initialErrors||C,j({type:"SET_ERRORS",payload:F.initialErrors||C}))}),[v,F.initialErrors]),r.useEffect((function(){v&&!0===P.current&&!t(_.current,F.initialTouched)&&(_.current=F.initialTouched||I,j({type:"SET_TOUCHED",payload:F.initialTouched||I}))}),[v,F.initialTouched]),r.useEffect((function(){v&&!0===P.current&&!t(R.current,F.initialStatus)&&(R.current=F.initialStatus,j({type:"SET_STATUS",payload:F.initialStatus}))}),[v,F.initialStatus,F.initialTouched]);var Y=L((function(e){if(x.current[e]&&h(x.current[e].validate)){var r=g(w.values,e),t=x.current[e].validate(r);return T(t)?(j({type:"SET_ISVALIDATING",payload:!0}),t.then((function(e){return e})).then((function(r){j({type:"SET_FIELD_ERROR",payload:{field:e,value:r}}),j({type:"SET_ISVALIDATING",payload:!1})}))):(j({type:"SET_FIELD_ERROR",payload:{field:e,value:t}}),Promise.resolve(t))}return F.validationSchema?(j({type:"SET_ISVALIDATING",payload:!0}),B(w.values,e).then((function(e){return e})).then((function(r){j({type:"SET_FIELD_ERROR",payload:{field:e,value:r[e]}}),j({type:"SET_ISVALIDATING",payload:!1})}))):Promise.resolve()})),z=r.useCallback((function(e,r){x.current[e]={validate:r.validate}}),[]),J=r.useCallback((function(e){delete x.current[e]}),[]),Q=L((function(e,r){return j({type:"SET_TOUCHED",payload:e}),(void 0===r?u:r)?W(w.values):Promise.resolve()})),X=r.useCallback((function(e){j({type:"SET_ERRORS",payload:e})}),[]),Z=L((function(e,r){var t=h(e)?e(w.values):e;return j({type:"SET_VALUES",payload:t}),(void 0===r?a:r)?W(t):Promise.resolve()})),$=r.useCallback((function(e,r){j({type:"SET_FIELD_ERROR",payload:{field:e,value:r}})}),[]),ee=L((function(e,r,t){return j({type:"SET_FIELD_VALUE",payload:{field:e,value:r}}),(void 0===t?a:t)?W(b(w.values,e,r)):Promise.resolve()})),re=r.useCallback((function(e,r){var t,n=r,i=e;if(!E(e)){e.persist&&e.persist();var a=e.target?e.target:e.currentTarget,o=a.type,u=a.value,s=a.checked,l=a.options,c=a.multiple;n=r||a.name||a.id,i=/number|range/.test(o)?(t=parseFloat(u),isNaN(t)?"":t):/checkbox/.test(o)?function(e,r,t){if("boolean"==typeof e)return Boolean(r);var n=[],i=!1,a=-1;if(Array.isArray(e))n=e,i=(a=e.indexOf(t))>=0;else if(!t||"true"==t||"false"==t)return Boolean(r);return r&&t&&!i?n.concat(t):i?n.slice(0,a).concat(n.slice(a+1)):n}(g(w.values,n),s,u):l&&c?function(e){return Array.from(e).filter((function(e){return e.selected})).map((function(e){return e.value}))}(l):u}n&&ee(n,i)}),[ee,w.values]),te=L((function(e){if(E(e))return function(r){return re(r,e)};re(e)})),ne=L((function(e,r,t){return void 0===r&&(r=!0),j({type:"SET_FIELD_TOUCHED",payload:{field:e,value:r}}),(void 0===t?u:t)?W(w.values):Promise.resolve()})),ie=r.useCallback((function(e,r){e.persist&&e.persist();var t=e.target;ne(r||t.name||t.id,!0)}),[ne]),ae=L((function(e){if(E(e))return function(r){return ie(r,e)};ie(e)})),oe=r.useCallback((function(e){h(e)?j({type:"SET_FORMIK_STATE",payload:e}):j({type:"SET_FORMIK_STATE",payload:function(){return e}})}),[]),ue=r.useCallback((function(e){j({type:"SET_STATUS",payload:e})}),[]),se=r.useCallback((function(e){j({type:"SET_ISSUBMITTING",payload:e})}),[]),le=L((function(){return j({type:"SUBMIT_ATTEMPT"}),W().then((function(e){var r=e instanceof Error;if(!r&&0===Object.keys(e).length){var t;try{if(void 0===(t=de()))return}catch(e){throw e}return Promise.resolve(t).then((function(e){return P.current&&j({type:"SUBMIT_SUCCESS"}),e})).catch((function(e){if(P.current)throw j({type:"SUBMIT_FAILURE"}),e}))}if(P.current&&(j({type:"SUBMIT_FAILURE"}),r))throw e}))})),ce=L((function(e){e&&e.preventDefault&&h(e.preventDefault)&&e.preventDefault(),e&&e.stopPropagation&&h(e.stopPropagation)&&e.stopPropagation(),le().catch((function(e){console.warn("Warning: An unhandled error was caught from submitForm()",e)}))})),pe={resetForm:K,validateForm:W,validateField:Y,setErrors:X,setFieldError:$,setFieldTouched:ne,setFieldValue:ee,setStatus:ue,setSubmitting:se,setTouched:Q,setValues:Z,setFormikState:oe,submitForm:le},de=L((function(){return y(w.values,pe)})),fe=L((function(e){e&&e.preventDefault&&h(e.preventDefault)&&e.preventDefault(),e&&e.stopPropagation&&h(e.stopPropagation)&&e.stopPropagation(),K()})),ve=r.useCallback((function(e){return{value:g(w.values,e),error:g(w.errors,e),touched:!!g(w.touched,e),initialValue:g(k.current,e),initialTouched:!!g(_.current,e),initialError:g(O.current,e)}}),[w.errors,w.touched,w.values]),he=r.useCallback((function(e){return{setValue:function(r,t){return ee(e,r,t)},setTouched:function(r,t){return ne(e,r,t)},setError:function(r){return $(e,r)}}}),[ee,ne,$]),me=r.useCallback((function(e){var r=m(e),t=r?e.name:e,n=g(w.values,t),i={name:t,value:n,onChange:te,onBlur:ae};if(r){var a=e.type,o=e.value,u=e.as,s=e.multiple;"checkbox"===a?void 0===o?i.checked=!!n:(i.checked=!(!Array.isArray(n)||!~n.indexOf(o)),i.value=o):"radio"===a?(i.checked=n===o,i.value=o):"select"===u&&s&&(i.value=i.value||[],i.multiple=!0)}return i}),[ae,te,w.values]),ye=r.useMemo((function(){return!t(k.current,w.values)}),[k.current,w.values]),Ee=r.useMemo((function(){return void 0!==p?ye?w.errors&&0===Object.keys(w.errors).length:!1!==p&&h(p)?p(F):p:w.errors&&0===Object.keys(w.errors).length}),[p,ye,w.errors,F]);return c({},w,{initialValues:k.current,initialErrors:O.current,initialTouched:_.current,initialStatus:R.current,handleBlur:ae,handleChange:te,handleReset:fe,handleSubmit:ce,resetForm:K,setErrors:X,setFormikState:oe,setFieldTouched:ne,setFieldValue:ee,setFieldError:$,setStatus:ue,setSubmitting:se,setTouched:Q,setValues:Z,submitForm:le,validateForm:W,validateField:Y,isValid:Ee,dirty:ye,unregisterField:J,registerField:z,getFieldProps:me,getFieldMeta:ve,getFieldHelpers:he,validateOnBlur:u,validateOnChange:a,validateOnMount:l})}function x(e){var t=P(e),n=e.component,i=e.children,a=e.render;return r.useImperativeHandle(e.innerRef,(function(){return t})),r.createElement(O,{value:t},n?r.createElement(n,t):a?a(t):i?h(i)?i(t):S(i)?null:r.Children.only(i):null)}function U(e){var r={};if(e.inner){if(0===e.inner.length)return b(r,e.path,e.message);var t=e.inner,n=Array.isArray(t),i=0;for(t=n?t:t[Symbol.iterator]();;){var a;if(n){if(i>=t.length)break;a=t[i++]}else{if((i=t.next()).done)break;a=i.value}var o=a;g(r,o.path)||(r=b(r,o.path,o.message))}}return r}function V(e,r,t,n){void 0===t&&(t=!1),void 0===n&&(n={});var i=D(e);return r[t?"validateSync":"validate"](i,{abortEarly:!1,context:n})}function D(e){var r=Array.isArray(e)?[]:{};for(var t in e)if(Object.prototype.hasOwnProperty.call(e,t)){var n=String(t);r[n]=!0===Array.isArray(e[n])?e[n].map((function(e){return!0===Array.isArray(e)||i(e)?D(e):""!==e?e:void 0})):i(e[n])?D(e[n]):""!==e[n]?e[n]:void 0}return r}function M(e,r,t){var i=e.slice();return r.forEach((function(r,a){if(void 0===i[a]){var o=!1!==t.clone&&t.isMergeableObject(r);i[a]=o?n(Array.isArray(r)?[]:{},r,t):r}else t.isMergeableObject(r)?i[a]=n(e[a],r,t):-1===e.indexOf(r)&&i.push(r)})),i}var w="undefined"!=typeof window&&void 0!==window.document&&void 0!==window.document.createElement?r.useLayoutEffect:r.useEffect;function L(e){var t=r.useRef(e);return w((function(){t.current=e})),r.useCallback((function(){for(var e=arguments.length,r=new Array(e),n=0;n<e;n++)r[n]=arguments[n];return t.current.apply(void 0,r)}),[])}var j=r.forwardRef((function(e,t){var n=e.action,i=d(e,["action"]),a=null!=n?n:"#",o=R();return r.createElement("form",Object.assign({onSubmit:o.handleSubmit,ref:t,onReset:o.handleReset,action:a},i))}));function N(e){var t=function(t){return r.createElement(_,null,(function(n){return n||u(!1),r.createElement(e,Object.assign({},t,{formik:n}))}))},n=e.displayName||e.name||e.constructor&&e.constructor.name||"Component";return t.WrappedComponent=e,t.displayName="FormikConnect("+n+")",s(t,e)}j.displayName="Form";var B=function(e,r,t){var n=W(e),i=n[r];return n.splice(r,1),n.splice(t,0,i),n},q=function(e,r,t){var n=W(e),i=n[r];return n[r]=n[t],n[t]=i,n},G=function(e,r,t){var n=W(e);return n.splice(r,0,t),n},H=function(e,r,t){var n=W(e);return n[r]=t,n},W=function(e){if(e){if(Array.isArray(e))return[].concat(e);var r=Object.keys(e).map((function(e){return parseInt(e)})).reduce((function(e,r){return r>e?r:e}),0);return Array.from(c({},e,{length:r+1}))}return[]},K=function(e){function n(r){var t;return(t=e.call(this,r)||this).updateArrayField=function(e,r,n){var i=t.props,a=i.name;(0,i.formik.setFormikState)((function(t){var i="function"==typeof n?n:e,o="function"==typeof r?r:e,u=b(t.values,a,e(g(t.values,a))),s=n?i(g(t.errors,a)):void 0,l=r?o(g(t.touched,a)):void 0;return v(s)&&(s=void 0),v(l)&&(l=void 0),c({},t,{values:u,errors:n?b(t.errors,a,s):t.errors,touched:r?b(t.touched,a,l):t.touched})}))},t.push=function(e){return t.updateArrayField((function(r){return[].concat(W(r),[l(e)])}),!1,!1)},t.handlePush=function(e){return function(){return t.push(e)}},t.swap=function(e,r){return t.updateArrayField((function(t){return q(t,e,r)}),!0,!0)},t.handleSwap=function(e,r){return function(){return t.swap(e,r)}},t.move=function(e,r){return t.updateArrayField((function(t){return B(t,e,r)}),!0,!0)},t.handleMove=function(e,r){return function(){return t.move(e,r)}},t.insert=function(e,r){return t.updateArrayField((function(t){return G(t,e,r)}),(function(r){return G(r,e,null)}),(function(r){return G(r,e,null)}))},t.handleInsert=function(e,r){return function(){return t.insert(e,r)}},t.replace=function(e,r){return t.updateArrayField((function(t){return H(t,e,r)}),!1,!1)},t.handleReplace=function(e,r){return function(){return t.replace(e,r)}},t.unshift=function(e){var r=-1;return t.updateArrayField((function(t){var n=t?[e].concat(t):[e];return r<0&&(r=n.length),n}),(function(e){var t=e?[null].concat(e):[null];return r<0&&(r=t.length),t}),(function(e){var t=e?[null].concat(e):[null];return r<0&&(r=t.length),t})),r},t.handleUnshift=function(e){return function(){return t.unshift(e)}},t.handleRemove=function(e){return function(){return t.remove(e)}},t.handlePop=function(){return function(){return t.pop()}},t.remove=t.remove.bind(f(t)),t.pop=t.pop.bind(f(t)),t}p(n,e);var i=n.prototype;return i.componentDidUpdate=function(e){this.props.validateOnChange&&this.props.formik.validateOnChange&&!t(g(e.formik.values,e.name),g(this.props.formik.values,this.props.name))&&this.props.formik.validateForm(this.props.formik.values)},i.remove=function(e){var r;return this.updateArrayField((function(t){var n=t?W(t):[];return r||(r=n[e]),h(n.splice)&&n.splice(e,1),n}),!0,!0),r},i.pop=function(){var e;return this.updateArrayField((function(r){var t=r;return e||(e=t&&t.pop&&t.pop()),t}),!0,!0),e},i.render=function(){var e=this.props,t=e.component,n=e.render,i=e.children,a=e.name,o=c({},{push:this.push,pop:this.pop,swap:this.swap,move:this.move,insert:this.insert,replace:this.replace,unshift:this.unshift,remove:this.remove,handlePush:this.handlePush,handlePop:this.handlePop,handleSwap:this.handleSwap,handleMove:this.handleMove,handleInsert:this.handleInsert,handleReplace:this.handleReplace,handleUnshift:this.handleUnshift,handleRemove:this.handleRemove},{form:d(e.formik,["validate","validationSchema"]),name:a});return t?r.createElement(t,o):n?n(o):i?"function"==typeof i?i(o):S(i)?null:r.Children.only(i):null},n}(r.Component);K.defaultProps={validateOnChange:!0};var Y=N(K),z=N(function(e){function t(){return e.apply(this,arguments)||this}p(t,e);var n=t.prototype;return n.shouldComponentUpdate=function(e){return g(this.props.formik.errors,this.props.name)!==g(e.formik.errors,this.props.name)||g(this.props.formik.touched,this.props.name)!==g(e.formik.touched,this.props.name)||Object.keys(this.props).length!==Object.keys(e).length},n.render=function(){var e=this.props,t=e.component,n=e.formik,i=e.render,a=e.children,o=e.name,u=d(e,["component","formik","render","children","name"]),s=g(n.touched,o),l=g(n.errors,o);return s&&l?i?h(i)?i(l):null:a?h(a)?a(l):null:t?r.createElement(t,u,l):l:null},t}(r.Component)),J=N(function(e){function t(r){var t;t=e.call(this,r)||this;var n=r.render,i=r.children,a=r.component,o=r.as;return n&&u(!1),a&&n&&u(!1),o&&i&&h(i)&&u(!1),a&&i&&h(i)&&u(!1),n&&i&&!S(i)&&u(!1),t}p(t,e);var n=t.prototype;return n.shouldComponentUpdate=function(e){return this.props.shouldUpdate?this.props.shouldUpdate(e,this.props):e.name!==this.props.name||g(e.formik.values,this.props.name)!==g(this.props.formik.values,this.props.name)||g(e.formik.errors,this.props.name)!==g(this.props.formik.errors,this.props.name)||g(e.formik.touched,this.props.name)!==g(this.props.formik.touched,this.props.name)||Object.keys(this.props).length!==Object.keys(e).length||e.formik.isSubmitting!==this.props.formik.isSubmitting},n.componentDidMount=function(){this.props.formik.registerField(this.props.name,{validate:this.props.validate})},n.componentDidUpdate=function(e){this.props.name!==e.name&&(this.props.formik.unregisterField(e.name),this.props.formik.registerField(this.props.name,{validate:this.props.validate})),this.props.validate!==e.validate&&this.props.formik.registerField(this.props.name,{validate:this.props.validate})},n.componentWillUnmount=function(){this.props.formik.unregisterField(this.props.name)},n.render=function(){var e=this.props,t=e.name,n=e.render,i=e.as,a=e.children,o=e.component,u=e.formik,s=d(e,["validate","name","render","as","children","component","shouldUpdate","formik"]),l=d(u,["validate","validationSchema"]),p=u.getFieldProps(c({name:t},s)),f={field:p,meta:{value:g(u.values,t),error:g(u.errors,t),touched:!!g(u.touched,t),initialValue:g(u.initialValues,t),initialTouched:!!g(u.initialTouched,t),initialError:g(u.initialErrors,t)},form:l};if(n)return n(f);if(h(a))return a(f);if(o){if("string"==typeof o){var v=s.innerRef,m=d(s,["innerRef"]);return r.createElement(o,c({ref:v},p,m),a)}return r.createElement(o,c({field:p,form:u},s),a)}var y=i||"input";if("string"==typeof y){var E=s.innerRef,S=d(s,["innerRef"]);return r.createElement(y,c({ref:E},p,S),a)}return r.createElement(y,c({},p,s),a)},t}(r.Component));__webpack_unused_export__=z,__webpack_unused_export__=J,exports.Field=function(e){var t=e.validate,n=e.name,i=e.render,a=e.children,o=e.as,u=e.component,s=d(e,["validate","name","render","children","as","component"]),l=d(R(),["validate","validationSchema"]),p=l.registerField,f=l.unregisterField;r.useEffect((function(){return p(n,{validate:t}),function(){f(n)}}),[p,f,n,t]);var v=l.getFieldProps(c({name:n},s)),m=l.getFieldMeta(n),y={field:v,form:l};if(i)return i(c({},y,{meta:m}));if(h(a))return a(c({},y,{meta:m}));if(u){if("string"==typeof u){var E=s.innerRef,S=d(s,["innerRef"]);return r.createElement(u,c({ref:E},v,S),a)}return r.createElement(u,c({field:v,form:l},s),a)}var T=o||"input";if("string"==typeof T){var g=s.innerRef,b=d(s,["innerRef"]);return r.createElement(T,c({ref:g},v,b),a)}return r.createElement(T,c({},v,s),a)},__webpack_unused_export__=Y,exports.Form=j,exports.Formik=x,__webpack_unused_export__=_,__webpack_unused_export__=k,exports.FormikProvider=O,__webpack_unused_export__=N,__webpack_unused_export__=function(e){if(void 0===(e=e||("undefined"!=typeof document?document:void 0)))return null;try{return e.activeElement||e.body}catch(r){return e.body}},__webpack_unused_export__=g,__webpack_unused_export__=G,__webpack_unused_export__=v,__webpack_unused_export__=S,__webpack_unused_export__=h,__webpack_unused_export__=function(e){return e&&m(e)&&m(e.target)},__webpack_unused_export__=y,__webpack_unused_export__=function(e){return e!=e},__webpack_unused_export__=m,__webpack_unused_export__=T,__webpack_unused_export__=E,__webpack_unused_export__=B,__webpack_unused_export__=D,__webpack_unused_export__=H,__webpack_unused_export__=b,__webpack_unused_export__=F,__webpack_unused_export__=q,exports.useField=function(e){var t=R(),n=t.getFieldProps,i=t.getFieldMeta,a=t.getFieldHelpers,o=t.registerField,s=t.unregisterField,l=m(e)?e:{name:e},c=l.name,p=l.validate;return r.useEffect((function(){return c&&o(c,{validate:p}),function(){c&&s(c)}}),[o,s,c,p]),c||u(!1),[n(l),i(c),a(c)]},exports.useFormik=P,__webpack_unused_export__=R,__webpack_unused_export__=V,__webpack_unused_export__=function(e){var t=e.mapPropsToValues,n=void 0===t?function(e){var r={};for(var t in e)e.hasOwnProperty(t)&&"function"!=typeof e[t]&&(r[t]=e[t]);return r}:t,i=d(e,["mapPropsToValues"]);return function(e){var t=e.displayName||e.name||e.constructor&&e.constructor.name||"Component",a=function(t){function a(){var n;return(n=t.apply(this,arguments)||this).validate=function(e){return i.validate(e,n.props)},n.validationSchema=function(){return h(i.validationSchema)?i.validationSchema(n.props):i.validationSchema},n.handleSubmit=function(e,r){return i.handleSubmit(e,c({},r,{props:n.props}))},n.renderFormComponent=function(t){return r.createElement(e,Object.assign({},n.props,t))},n}return p(a,t),a.prototype.render=function(){var e=d(this.props,["children"]);return r.createElement(x,Object.assign({},e,i,{validate:i.validate&&this.validate,validationSchema:i.validationSchema&&this.validationSchema,initialValues:n(this.props),initialStatus:i.mapPropsToStatus&&i.mapPropsToStatus(this.props),initialErrors:i.mapPropsToErrors&&i.mapPropsToErrors(this.props),initialTouched:i.mapPropsToTouched&&i.mapPropsToTouched(this.props),onSubmit:this.handleSubmit,children:this.renderFormComponent}))},a}(r.Component);return a.displayName="WithFormik("+t+")",s(a,e)}},__webpack_unused_export__=U;
//# sourceMappingURL=formik.cjs.production.min.js.map


/***/ }),

/***/ 20097:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";



if (true) {
  module.exports = __webpack_require__(4549)
} else {}


/***/ }),

/***/ 86759:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ps": function() { return /* binding */ gql; }
/* harmony export */ });
/* unused harmony exports resetCaches, disableFragmentWarnings, enableExperimentalFragmentVariables, disableExperimentalFragmentVariables */
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99290);
/* harmony import */ var graphql__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85448);


var docCache = new Map();
var fragmentSourceMap = new Map();
var printFragmentWarnings = true;
var experimentalFragmentVariables = false;
function normalize(string) {
    return string.replace(/[\s,]+/g, ' ').trim();
}
function cacheKeyFromLoc(loc) {
    return normalize(loc.source.body.substring(loc.start, loc.end));
}
function processFragments(ast) {
    var seenKeys = new Set();
    var definitions = [];
    ast.definitions.forEach(function (fragmentDefinition) {
        if (fragmentDefinition.kind === 'FragmentDefinition') {
            var fragmentName = fragmentDefinition.name.value;
            var sourceKey = cacheKeyFromLoc(fragmentDefinition.loc);
            var sourceKeySet = fragmentSourceMap.get(fragmentName);
            if (sourceKeySet && !sourceKeySet.has(sourceKey)) {
                if (printFragmentWarnings) {
                    console.warn("Warning: fragment with name " + fragmentName + " already exists.\n"
                        + "graphql-tag enforces all fragment names across your application to be unique; read more about\n"
                        + "this in the docs: http://dev.apollodata.com/core/fragments.html#unique-names");
                }
            }
            else if (!sourceKeySet) {
                fragmentSourceMap.set(fragmentName, sourceKeySet = new Set);
            }
            sourceKeySet.add(sourceKey);
            if (!seenKeys.has(sourceKey)) {
                seenKeys.add(sourceKey);
                definitions.push(fragmentDefinition);
            }
        }
        else {
            definitions.push(fragmentDefinition);
        }
    });
    return (0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)((0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)({}, ast), { definitions: definitions });
}
function stripLoc(doc) {
    var workSet = new Set(doc.definitions);
    workSet.forEach(function (node) {
        if (node.loc)
            delete node.loc;
        Object.keys(node).forEach(function (key) {
            var value = node[key];
            if (value && typeof value === 'object') {
                workSet.add(value);
            }
        });
    });
    var loc = doc.loc;
    if (loc) {
        delete loc.startToken;
        delete loc.endToken;
    }
    return doc;
}
function parseDocument(source) {
    var cacheKey = normalize(source);
    if (!docCache.has(cacheKey)) {
        var parsed = (0,graphql__WEBPACK_IMPORTED_MODULE_1__/* .parse */ .Qc)(source, {
            experimentalFragmentVariables: experimentalFragmentVariables,
            allowLegacyFragmentVariables: experimentalFragmentVariables
        });
        if (!parsed || parsed.kind !== 'Document') {
            throw new Error('Not a valid GraphQL document.');
        }
        docCache.set(cacheKey, stripLoc(processFragments(parsed)));
    }
    return docCache.get(cacheKey);
}
function gql(literals) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    if (typeof literals === 'string') {
        literals = [literals];
    }
    var result = literals[0];
    args.forEach(function (arg, i) {
        if (arg && arg.kind === 'Document') {
            result += arg.loc.source.body;
        }
        else {
            result += arg;
        }
        result += literals[i + 1];
    });
    return parseDocument(result);
}
function resetCaches() {
    docCache.clear();
    fragmentSourceMap.clear();
}
function disableFragmentWarnings() {
    printFragmentWarnings = false;
}
function enableExperimentalFragmentVariables() {
    experimentalFragmentVariables = true;
}
function disableExperimentalFragmentVariables() {
    experimentalFragmentVariables = false;
}
var extras = {
    gql: gql,
    resetCaches: resetCaches,
    disableFragmentWarnings: disableFragmentWarnings,
    enableExperimentalFragmentVariables: enableExperimentalFragmentVariables,
    disableExperimentalFragmentVariables: disableExperimentalFragmentVariables
};
(function (gql_1) {
    gql_1.gql = extras.gql, gql_1.resetCaches = extras.resetCaches, gql_1.disableFragmentWarnings = extras.disableFragmentWarnings, gql_1.enableExperimentalFragmentVariables = extras.enableExperimentalFragmentVariables, gql_1.disableExperimentalFragmentVariables = extras.disableExperimentalFragmentVariables;
})(gql || (gql = {}));
gql["default"] = gql;
/* harmony default export */ __webpack_exports__["ZP"] = (gql);
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 79662:
/***/ (function(module) {

"use strict";

var assign = Object.assign.bind(Object);
module.exports = assign;
module.exports["default"] = module.exports;

//# sourceMappingURL=object-assign.js.map

/***/ }),

/***/ 97441:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var ref, ref1;
module.exports = ((ref = __webpack_require__.g.process) == null ? void 0 : ref.env) && typeof ((ref1 = __webpack_require__.g.process) == null ? void 0 : ref1.env) === "object" ? __webpack_require__.g.process : __webpack_require__(30383);

//# sourceMappingURL=process.js.map

/***/ }),

/***/ 56483:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/_app",
      function () {
        return __webpack_require__(17048);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 92022:
/***/ (function(__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _sentry_nextjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(56811);
/* harmony import */ var _byko_lib_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(65582);
var _sentryCollisionFreeGlobalObject =  false ? 0 : window;
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = undefined;
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "";
// This file configures the initialization of Sentry on the client.
// The config you add here will be used whenever a users loads a page in their browser.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/


const SENTRY_DSN = (0,_byko_lib_utils__WEBPACK_IMPORTED_MODULE_1__/* .getBykoConfig */ .Hp)("NEXT_PUBLIC_SENTRY_DSN");
const SENTRY_ENV = (0,_byko_lib_utils__WEBPACK_IMPORTED_MODULE_1__/* .getBykoConfig */ .Hp)("NEXT_PUBLIC_SENTRY_ENV");
if (SENTRY_DSN) {
    _sentry_nextjs__WEBPACK_IMPORTED_MODULE_0__/* .init */ .S1({
        dsn: SENTRY_DSN || "",
        environment: (SENTRY_ENV === null || SENTRY_ENV === void 0 ? void 0 : SENTRY_ENV.toLowerCase()) || "",
        // Add optional integrations for additional features
        integrations: [
            new _sentry_nextjs__WEBPACK_IMPORTED_MODULE_0__/* .Replay */ .UH({
                maskAllText: true,
                blockAllMedia: true
            })
        ],
        // Define how likely traces are sampled. Adjust this value in production, or use tracesSampler for greater control.
        tracesSampleRate: 0.1,
        // Define how likely Replay events are sampled.
        // This sets the sample rate to be 10%. You may want this to be 100% while
        // in development and sample at a lower rate in production
        replaysSessionSampleRate: 0.1,
        // Define how likely Replay events are sampled when an error occurs.
        replaysOnErrorSampleRate: 0.1,
        // Setting this option to true will print useful information to the console while you're setting up Sentry.
        debug: false,
        ignoreErrors: [
            "ResizeObserver loop completed with undelivered notifications",
            "ResizeObserver loop limit exceeded"
        ]
    });
}


/***/ }),

/***/ 6563:
/***/ (function(module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.getDomainLocale = getDomainLocale;
const basePath = (/* unused pure expression or super */ null && ( false || ""));
function getDomainLocale(path, locale, locales, domainLocales) {
    if (false) {} else {
        return false;
    }
}
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=get-domain-locale.js.map


/***/ }),

/***/ 44965:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

"use client";
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = void 0;
var _interop_require_default = (__webpack_require__(8896)/* ["default"] */ .Z);
var _object_without_properties_loose = (__webpack_require__(38745)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(91987));
var _router = __webpack_require__(47884);
var _addLocale = __webpack_require__(660);
var _routerContext = __webpack_require__(69162);
var _appRouterContext = __webpack_require__(98126);
var _useIntersection = __webpack_require__(21942);
var _getDomainLocale = __webpack_require__(6563);
var _addBasePath = __webpack_require__(36204);
"use client";
const prefetched = {};
function prefetch(router, href, as, options) {
    if ( false || !router) return;
    if (!(0, _router).isLocalURL(href)) return;
    // Prefetch the JSON page if asked (only in the client)
    // We need to handle a prefetch error here since we may be
    // loading with priority which can reject but we don't
    // want to force navigation since this is only a prefetch
    Promise.resolve(router.prefetch(href, as, options)).catch((err)=>{
        if (false) {}
    });
    const curLocale = options && typeof options.locale !== "undefined" ? options.locale : router && router.locale;
    // Join on an invalid URI character
    prefetched[href + "%" + as + (curLocale ? "%" + curLocale : "")] = true;
}
function isModifiedEvent(event) {
    const { target  } = event.currentTarget;
    return target && target !== "_self" || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.nativeEvent && event.nativeEvent.which === 2;
}
function linkClicked(e, router, href, as, replace, shallow, scroll, locale, isAppRouter, prefetchEnabled) {
    const { nodeName  } = e.currentTarget;
    // anchors inside an svg have a lowercase nodeName
    const isAnchorNodeName = nodeName.toUpperCase() === "A";
    if (isAnchorNodeName && (isModifiedEvent(e) || !(0, _router).isLocalURL(href))) {
        // ignore click for browser’s default behavior
        return;
    }
    e.preventDefault();
    const navigate = ()=>{
        // If the router is an NextRouter instance it will have `beforePopState`
        if ("beforePopState" in router) {
            router[replace ? "replace" : "push"](href, as, {
                shallow,
                locale,
                scroll
            });
        } else {
            // If `beforePopState` doesn't exist on the router it's the AppRouter.
            const method = replace ? "replace" : "push";
            // Apply `as` if it's provided.
            router[method](as || href, {
                forceOptimisticNavigation: !prefetchEnabled
            });
        }
    };
    if (isAppRouter) {
        // @ts-expect-error startTransition exists.
        _react.default.startTransition(navigate);
    } else {
        navigate();
    }
}
/**
 * React Component that enables client-side transitions between routes.
 */ const Link = /*#__PURE__*/ _react.default.forwardRef(function LinkComponent(props, forwardedRef) {
    if (false) {}
    let children;
    const { href: hrefProp , as: asProp , children: childrenProp , prefetch: prefetchProp , passHref , replace , shallow , scroll , locale , onClick , onMouseEnter , onTouchStart , legacyBehavior =Boolean(true) !== true  } = props, restProps = _object_without_properties_loose(props, [
        "href",
        "as",
        "children",
        "prefetch",
        "passHref",
        "replace",
        "shallow",
        "scroll",
        "locale",
        "onClick",
        "onMouseEnter",
        "onTouchStart",
        "legacyBehavior"
    ]);
    children = childrenProp;
    if (legacyBehavior && (typeof children === "string" || typeof children === "number")) {
        children = /*#__PURE__*/ _react.default.createElement("a", null, children);
    }
    const p = prefetchProp !== false;
    let router = _react.default.useContext(_routerContext.RouterContext);
    // TODO-APP: type error. Remove `as any`
    const appRouter = _react.default.useContext(_appRouterContext.AppRouterContext);
    if (appRouter) {
        router = appRouter;
    }
    const { href , as  } = _react.default.useMemo(()=>{
        const [resolvedHref, resolvedAs] = (0, _router).resolveHref(router, hrefProp, true);
        return {
            href: resolvedHref,
            as: asProp ? (0, _router).resolveHref(router, asProp) : resolvedAs || resolvedHref
        };
    }, [
        router,
        hrefProp,
        asProp
    ]);
    const previousHref = _react.default.useRef(href);
    const previousAs = _react.default.useRef(as);
    // This will return the first child, if multiple are provided it will throw an error
    let child;
    if (legacyBehavior) {
        if (false) {} else {
            child = _react.default.Children.only(children);
        }
    } else {
        if (false) { var ref; }
    }
    const childRef = legacyBehavior ? child && typeof child === "object" && child.ref : forwardedRef;
    const [setIntersectionRef, isVisible, resetVisible] = (0, _useIntersection).useIntersection({
        rootMargin: "200px"
    });
    const setRef = _react.default.useCallback((el)=>{
        // Before the link getting observed, check if visible state need to be reset
        if (previousAs.current !== as || previousHref.current !== href) {
            resetVisible();
            previousAs.current = as;
            previousHref.current = href;
        }
        setIntersectionRef(el);
        if (childRef) {
            if (typeof childRef === "function") childRef(el);
            else if (typeof childRef === "object") {
                childRef.current = el;
            }
        }
    }, [
        as,
        childRef,
        href,
        resetVisible,
        setIntersectionRef
    ]);
    _react.default.useEffect(()=>{
        const shouldPrefetch = isVisible && p && (0, _router).isLocalURL(href);
        const curLocale = typeof locale !== "undefined" ? locale : router && router.locale;
        const isPrefetched = prefetched[href + "%" + as + (curLocale ? "%" + curLocale : "")];
        if (shouldPrefetch && !isPrefetched) {
            prefetch(router, href, as, {
                locale: curLocale
            });
        }
    }, [
        as,
        href,
        isVisible,
        locale,
        p,
        router
    ]);
    const childProps = {
        ref: setRef,
        onClick: (e)=>{
            if (false) {}
            if (!legacyBehavior && typeof onClick === "function") {
                onClick(e);
            }
            if (legacyBehavior && child.props && typeof child.props.onClick === "function") {
                child.props.onClick(e);
            }
            if (!e.defaultPrevented) {
                linkClicked(e, router, href, as, replace, shallow, scroll, locale, Boolean(appRouter), p);
            }
        },
        onMouseEnter: (e)=>{
            if (!legacyBehavior && typeof onMouseEnter === "function") {
                onMouseEnter(e);
            }
            if (legacyBehavior && child.props && typeof child.props.onMouseEnter === "function") {
                child.props.onMouseEnter(e);
            }
            // Check for not prefetch disabled in page using appRouter
            if (!(!p && appRouter)) {
                if ((0, _router).isLocalURL(href)) {
                    prefetch(router, href, as, {
                        priority: true
                    });
                }
            }
        },
        onTouchStart: (e)=>{
            if (!legacyBehavior && typeof onTouchStart === "function") {
                onTouchStart(e);
            }
            if (legacyBehavior && child.props && typeof child.props.onTouchStart === "function") {
                child.props.onTouchStart(e);
            }
            // Check for not prefetch disabled in page using appRouter
            if (!(!p && appRouter)) {
                if ((0, _router).isLocalURL(href)) {
                    prefetch(router, href, as, {
                        priority: true
                    });
                }
            }
        }
    };
    // If child is an <a> tag and doesn't have a href attribute, or if the 'passHref' property is
    // defined, we specify the current 'href', so that repetition is not needed by the user
    if (!legacyBehavior || passHref || child.type === "a" && !("href" in child.props)) {
        const curLocale = typeof locale !== "undefined" ? locale : router && router.locale;
        // we only render domain locales if we are currently on a domain locale
        // so that locale links are still visitable in development/preview envs
        const localeDomain = router && router.isLocaleDomain && (0, _getDomainLocale).getDomainLocale(as, curLocale, router.locales, router.domainLocales);
        childProps.href = localeDomain || (0, _addBasePath).addBasePath((0, _addLocale).addLocale(as, curLocale, router && router.defaultLocale));
    }
    return legacyBehavior ? /*#__PURE__*/ _react.default.cloneElement(child, childProps) : /*#__PURE__*/ _react.default.createElement("a", Object.assign({}, restProps, childProps), children);
});
var _default = Link;
exports["default"] = _default;
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=link.js.map


/***/ }),

/***/ 21942:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.useIntersection = useIntersection;
var _react = __webpack_require__(91987);
var _requestIdleCallback = __webpack_require__(93952);
const hasIntersectionObserver = typeof IntersectionObserver === "function";
const observers = new Map();
const idList = [];
function createObserver(options) {
    const id = {
        root: options.root || null,
        margin: options.rootMargin || ""
    };
    const existing = idList.find((obj)=>obj.root === id.root && obj.margin === id.margin);
    let instance;
    if (existing) {
        instance = observers.get(existing);
        if (instance) {
            return instance;
        }
    }
    const elements = new Map();
    const observer = new IntersectionObserver((entries)=>{
        entries.forEach((entry)=>{
            const callback = elements.get(entry.target);
            const isVisible = entry.isIntersecting || entry.intersectionRatio > 0;
            if (callback && isVisible) {
                callback(isVisible);
            }
        });
    }, options);
    instance = {
        id,
        observer,
        elements
    };
    idList.push(id);
    observers.set(id, instance);
    return instance;
}
function observe(element, callback, options) {
    const { id , observer , elements  } = createObserver(options);
    elements.set(element, callback);
    observer.observe(element);
    return function unobserve() {
        elements.delete(element);
        observer.unobserve(element);
        // Destroy observer when there's nothing left to watch:
        if (elements.size === 0) {
            observer.disconnect();
            observers.delete(id);
            const index = idList.findIndex((obj)=>obj.root === id.root && obj.margin === id.margin);
            if (index > -1) {
                idList.splice(index, 1);
            }
        }
    };
}
function useIntersection(param) {
    let { rootRef , rootMargin , disabled  } = param;
    const isDisabled = disabled || !hasIntersectionObserver;
    const [visible, setVisible] = (0, _react).useState(false);
    const [element, setElement] = (0, _react).useState(null);
    (0, _react).useEffect(()=>{
        if (hasIntersectionObserver) {
            if (isDisabled || visible) return;
            if (element && element.tagName) {
                const unobserve = observe(element, (isVisible)=>isVisible && setVisible(isVisible), {
                    root: rootRef == null ? void 0 : rootRef.current,
                    rootMargin
                });
                return unobserve;
            }
        } else {
            if (!visible) {
                const idleCallback = (0, _requestIdleCallback).requestIdleCallback(()=>setVisible(true));
                return ()=>(0, _requestIdleCallback).cancelIdleCallback(idleCallback);
            }
        }
    }, [
        element,
        isDisabled,
        rootMargin,
        rootRef,
        visible
    ]);
    const resetVisible = (0, _react).useCallback(()=>{
        setVisible(false);
    }, []);
    return [
        setElement,
        visible,
        resetVisible
    ];
}
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=use-intersection.js.map


/***/ }),

/***/ 98126:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

"use client";
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.TemplateContext = exports.GlobalLayoutRouterContext = exports.LayoutRouterContext = exports.AppRouterContext = void 0;
var _interop_require_default = (__webpack_require__(8896)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(91987));
"use client";
const AppRouterContext = _react.default.createContext(null);
exports.AppRouterContext = AppRouterContext;
const LayoutRouterContext = _react.default.createContext(null);
exports.LayoutRouterContext = LayoutRouterContext;
const GlobalLayoutRouterContext = _react.default.createContext(null);
exports.GlobalLayoutRouterContext = GlobalLayoutRouterContext;
const TemplateContext = _react.default.createContext(null);
exports.TemplateContext = TemplateContext;
if (false) {} //# sourceMappingURL=app-router-context.js.map


/***/ }),

/***/ 2125:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = dynamic;
exports.noSSR = noSSR;
var _extends = (__webpack_require__(10685)/* ["default"] */ .Z);
var _interop_require_default = (__webpack_require__(8896)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(91987));
var _loadable = _interop_require_default(__webpack_require__(70906));
function dynamic(dynamicOptions, options) {
    let loadableFn = _loadable.default;
    let loadableOptions = (options == null ? void 0 : options.suspense) ? {} : {
        // A loading component is not required, so we default it
        loading: (param)=>{
            let { error , isLoading , pastDelay  } = param;
            if (!pastDelay) return null;
            if (false) {}
            return null;
        }
    };
    // Support for direct import(), eg: dynamic(import('../hello-world'))
    // Note that this is only kept for the edge case where someone is passing in a promise as first argument
    // The react-loadable babel plugin will turn dynamic(import('../hello-world')) into dynamic(() => import('../hello-world'))
    // To make sure we don't execute the import without rendering first
    if (dynamicOptions instanceof Promise) {
        loadableOptions.loader = ()=>dynamicOptions;
    // Support for having import as a function, eg: dynamic(() => import('../hello-world'))
    } else if (typeof dynamicOptions === "function") {
        loadableOptions.loader = dynamicOptions;
    // Support for having first argument being options, eg: dynamic({loader: import('../hello-world')})
    } else if (typeof dynamicOptions === "object") {
        loadableOptions = _extends({}, loadableOptions, dynamicOptions);
    }
    // Support for passing options, eg: dynamic(import('../hello-world'), {loading: () => <p>Loading something</p>})
    loadableOptions = _extends({}, loadableOptions, options);
    // Error if Fizz rendering is not enabled and `suspense` option is set to true
    if (false) {}
    if (loadableOptions.suspense) {
        if (false) {}
        delete loadableOptions.ssr;
        delete loadableOptions.loading;
    }
    // coming from build/babel/plugins/react-loadable-plugin.js
    if (loadableOptions.loadableGenerated) {
        loadableOptions = _extends({}, loadableOptions, loadableOptions.loadableGenerated);
        delete loadableOptions.loadableGenerated;
    }
    // support for disabling server side rendering, eg: dynamic(import('../hello-world'), {ssr: false}).
    // skip `ssr` for suspense mode and opt-in React.lazy directly
    if (typeof loadableOptions.ssr === "boolean" && !loadableOptions.suspense) {
        if (!loadableOptions.ssr) {
            delete loadableOptions.ssr;
            return noSSR(loadableFn, loadableOptions);
        }
        delete loadableOptions.ssr;
    }
    return loadableFn(loadableOptions);
}
const isServerSide = "object" === "undefined";
function noSSR(LoadableInitializer, loadableOptions) {
    // Removing webpack and modules means react-loadable won't try preloading
    delete loadableOptions.webpack;
    delete loadableOptions.modules;
    // This check is necessary to prevent react-loadable from initializing on the server
    if (!isServerSide) {
        return LoadableInitializer(loadableOptions);
    }
    const Loading = loadableOptions.loading;
    // This will only be rendered on the server side
    return ()=>/*#__PURE__*/ _react.default.createElement(Loading, {
            error: null,
            isLoading: true,
            pastDelay: false,
            timedOut: false
        });
}
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=dynamic.js.map


/***/ }),

/***/ 27709:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.LoadableContext = void 0;
var _interop_require_default = (__webpack_require__(8896)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(91987));
const LoadableContext = _react.default.createContext(null);
exports.LoadableContext = LoadableContext;
if (false) {} //# sourceMappingURL=loadable-context.js.map


/***/ }),

/***/ 70906:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = void 0;
var _extends = (__webpack_require__(10685)/* ["default"] */ .Z);
var _interop_require_default = (__webpack_require__(8896)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(91987));
var _loadableContext = __webpack_require__(27709);
const { useSyncExternalStore  } =  true ? __webpack_require__(91987) : 0;
const ALL_INITIALIZERS = [];
const READY_INITIALIZERS = [];
let initialized = false;
function load(loader) {
    let promise = loader();
    let state = {
        loading: true,
        loaded: null,
        error: null
    };
    state.promise = promise.then((loaded)=>{
        state.loading = false;
        state.loaded = loaded;
        return loaded;
    }).catch((err)=>{
        state.loading = false;
        state.error = err;
        throw err;
    });
    return state;
}
function resolve(obj) {
    return obj && obj.__esModule ? obj.default : obj;
}
function createLoadableComponent(loadFn, options) {
    let opts = Object.assign({
        loader: null,
        loading: null,
        delay: 200,
        timeout: null,
        webpack: null,
        modules: null,
        suspense: false
    }, options);
    if (opts.suspense) {
        opts.lazy = _react.default.lazy(opts.loader);
    }
    /** @type LoadableSubscription */ let subscription = null;
    function init() {
        if (!subscription) {
            const sub = new LoadableSubscription(loadFn, opts);
            subscription = {
                getCurrentValue: sub.getCurrentValue.bind(sub),
                subscribe: sub.subscribe.bind(sub),
                retry: sub.retry.bind(sub),
                promise: sub.promise.bind(sub)
            };
        }
        return subscription.promise();
    }
    // Server only
    if (false) {}
    // Client only
    if (!initialized && "object" !== "undefined") {
        // require.resolveWeak check is needed for environments that don't have it available like Jest
        const moduleIds = opts.webpack && "function" === "function" ? opts.webpack() : opts.modules;
        if (moduleIds) {
            READY_INITIALIZERS.push((ids)=>{
                for (const moduleId of moduleIds){
                    if (ids.indexOf(moduleId) !== -1) {
                        return init();
                    }
                }
            });
        }
    }
    function useLoadableModule() {
        init();
        const context = _react.default.useContext(_loadableContext.LoadableContext);
        if (context && Array.isArray(opts.modules)) {
            opts.modules.forEach((moduleName)=>{
                context(moduleName);
            });
        }
    }
    function LoadableImpl(props, ref) {
        useLoadableModule();
        const state = useSyncExternalStore(subscription.subscribe, subscription.getCurrentValue, subscription.getCurrentValue);
        _react.default.useImperativeHandle(ref, ()=>({
                retry: subscription.retry
            }), []);
        return _react.default.useMemo(()=>{
            if (state.loading || state.error) {
                return _react.default.createElement(opts.loading, {
                    isLoading: state.loading,
                    pastDelay: state.pastDelay,
                    timedOut: state.timedOut,
                    error: state.error,
                    retry: subscription.retry
                });
            } else if (state.loaded) {
                return _react.default.createElement(resolve(state.loaded), props);
            } else {
                return null;
            }
        }, [
            props,
            state
        ]);
    }
    function LazyImpl(props, ref) {
        useLoadableModule();
        return _react.default.createElement(opts.lazy, _extends({}, props, {
            ref
        }));
    }
    const LoadableComponent = opts.suspense ? LazyImpl : LoadableImpl;
    LoadableComponent.preload = ()=>init();
    LoadableComponent.displayName = "LoadableComponent";
    return _react.default.forwardRef(LoadableComponent);
}
class LoadableSubscription {
    promise() {
        return this._res.promise;
    }
    retry() {
        this._clearTimeouts();
        this._res = this._loadFn(this._opts.loader);
        this._state = {
            pastDelay: false,
            timedOut: false
        };
        const { _res: res , _opts: opts  } = this;
        if (res.loading) {
            if (typeof opts.delay === "number") {
                if (opts.delay === 0) {
                    this._state.pastDelay = true;
                } else {
                    this._delay = setTimeout(()=>{
                        this._update({
                            pastDelay: true
                        });
                    }, opts.delay);
                }
            }
            if (typeof opts.timeout === "number") {
                this._timeout = setTimeout(()=>{
                    this._update({
                        timedOut: true
                    });
                }, opts.timeout);
            }
        }
        this._res.promise.then(()=>{
            this._update({});
            this._clearTimeouts();
        }).catch((_err)=>{
            this._update({});
            this._clearTimeouts();
        });
        this._update({});
    }
    _update(partial) {
        this._state = _extends({}, this._state, {
            error: this._res.error,
            loaded: this._res.loaded,
            loading: this._res.loading
        }, partial);
        this._callbacks.forEach((callback)=>callback());
    }
    _clearTimeouts() {
        clearTimeout(this._delay);
        clearTimeout(this._timeout);
    }
    getCurrentValue() {
        return this._state;
    }
    subscribe(callback) {
        this._callbacks.add(callback);
        return ()=>{
            this._callbacks.delete(callback);
        };
    }
    constructor(loadFn, opts){
        this._loadFn = loadFn;
        this._opts = opts;
        this._callbacks = new Set();
        this._delay = null;
        this._timeout = null;
        this.retry();
    }
}
function Loadable(opts) {
    return createLoadableComponent(load, opts);
}
function flushInitializers(initializers, ids) {
    let promises = [];
    while(initializers.length){
        let init = initializers.pop();
        promises.push(init(ids));
    }
    return Promise.all(promises).then(()=>{
        if (initializers.length) {
            return flushInitializers(initializers, ids);
        }
    });
}
Loadable.preloadAll = ()=>{
    return new Promise((resolveInitializers, reject)=>{
        flushInitializers(ALL_INITIALIZERS).then(resolveInitializers, reject);
    });
};
Loadable.preloadReady = function() {
    let ids = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    return new Promise((resolvePreload)=>{
        const res = ()=>{
            initialized = true;
            return resolvePreload();
        };
        // We always will resolve, errors should be handled within loading UIs.
        flushInitializers(READY_INITIALIZERS, ids).then(res, res);
    });
};
if (true) {
    window.__NEXT_PRELOADREADY = Loadable.preloadReady;
}
var _default = Loadable;
exports["default"] = _default; //# sourceMappingURL=loadable.js.map


/***/ }),

/***/ 37107:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ useCommonContext; },
/* harmony export */   "k": function() { return /* binding */ CommonContext; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91987);
/* eslint-disable @typescript-eslint/explicit-function-return-type */ 
const CommonContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)({});
function useCommonContext() {
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(CommonContext);
}


/***/ }),

/***/ 78247:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "JI": function() { return /* reexport */ BetaBanner; },
  "ko": function() { return /* reexport */ common/* CommonContext */.k; },
  "L8": function() { return /* reexport */ conf/* DEFAULT_PAGE_SIZE */.L8; },
  "Yr": function() { return /* reexport */ ProductPageContent; },
  "ZR": function() { return /* reexport */ QuickSearchResults; },
  "y2": function() { return /* reexport */ buildCategoryReferenceMap; },
  "Vp": function() { return /* reexport */ api/* compileAlgoliaProductFilters */.Vp; },
  "Q1": function() { return /* reexport */ dropCategoryBreadCrumbs; },
  "tP": function() { return /* reexport */ dropProductBreadCrumbs; },
  "Vl": function() { return /* reexport */ dropRentalCategoryBreadCrumbs; },
  "Dk": function() { return /* reexport */ api/* fetchAlgoliaProducts */.Dk; }
});

// UNUSED EXPORTS: API_KEY, APP_ID, ClearButton, CountContainerMobile, FACET_NAME_OVERRIDES, FACET_UNIT_OVERRIDES, FacetAccordionBlock, Filter, FilterChip, FilterHeader, PRICE_PATH, PRODUCT_DEFAULT_SORTING, PRODUCT_SORT_OPTIONS, PRODUCT_SORT_OPTIONS_MAP, ProductContractDetail, ProductCustomDetail, ProductDisplayDetail, ProductImageAndDetail, ProductLimitedDetail, ProductRentDetail, ProductStandardDetail, RANGE_FACETS, SEARCH_INDEXES, TabsSection, TagWrapper, VideoSection, algoliaContentQueryFetcher, algoliaMultiQueryFetcher, algoliaProductsQueryFetcher, compileActiveFilters, compileFacets, contentSearchClient, envPrefix, facetComponentTypeMap, fetchAlgoliaContent, filterTopLevelCategories, prepareProductVariantSpecs, productHitCountState, productSearchClient, productSortOptionsMap, searchClient, sortFacetOptions, storage, traceCategoryAncestry, useAlgoliaContentQuery, useAlgoliaMultiQuery, useAlgoliaProductQuery, useCommonContext

// EXTERNAL MODULE: ../../.yarn/cache/lodash-npm-4.17.21-6382451519-eb835a2e51.zip/node_modules/lodash/lodash.js
var lodash = __webpack_require__(35735);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-lib-utils-virtual-08ae943915/1/packages/lib-utils/src/index.ts + 19 modules
var src = __webpack_require__(65582);
;// CONCATENATED MODULE: ./src/features/categories/categories.ts
/* eslint-disable @typescript-eslint/explicit-function-return-type */ 

function buildCategoryReferenceMap(categories) {
    const categoryPairs = categories.map((c)=>[
            c.id,
            {
                //
                ...c,
                parentNode: undefined,
                children: []
            }
        ]);
    const tree = new Map(categoryPairs);
    tree.forEach((item)=>{
        if (item.parent) {
            item.parentNode = tree.get(item.parent);
        }
    });
    tree.forEach((ref)=>{
        var ref1;
        (ref1 = ref.parentNode) === null || ref1 === void 0 ? void 0 : ref1.children.push(ref);
    });
    return tree;
}
function filterTopLevelCategories(catReferenceMap) {
    return Array.from(catReferenceMap.values()).filter((p)=>!p.parent);
}
function traceCategoryAncestry(category) {
    let cat = category;
    const ret = [];
    while(cat){
        ret.unshift(cat);
        cat = cat.parentNode;
    }
    return ret;
}
function dropProductBreadCrumbs(catReferenceMap, product, isRentalProduct) {
    const categoryPaths = product.categories.map((cid)=>traceCategoryAncestry(catReferenceMap.get(cid)));
    const longestPath = (0,src/* ensureList */.fL)((0,lodash.maxBy)(categoryPaths, (p)=>p.length));
    const rentalProduct = isRentalProduct !== null && isRentalProduct !== void 0 ? isRentalProduct : false;
    return [
        {
            title: "Fors\xed\xf0a",
            url: "/"
        },
        ...longestPath.map((c)=>({
                //
                title: c.name,
                url: "/".concat(rentalProduct ? "bykoleiga" : "voruflokkar", "/").concat(c.slug)
            })),
        {
            //
            title: product.name,
            url: "/".concat(rentalProduct ? "leiguvara" : "vara", "/").concat(product.slug)
        }
    ];
}
function dropCategoryBreadCrumbs(category) {
    return [
        {
            title: "Fors\xed\xf0a",
            url: "/"
        },
        ...traceCategoryAncestry(category).map((c)=>({
                title: c.name,
                url: "/voruflokkar/".concat(c.slug)
            }))
    ];
}
function dropRentalCategoryBreadCrumbs(category) {
    return [
        {
            title: "Fors\xed\xf0a",
            url: "/"
        },
        ...traceCategoryAncestry(category).map((c)=>({
                title: c.name,
                url: "/bykoleiga/".concat(c.slug)
            }))
    ];
}

;// CONCATENATED MODULE: ./src/features/categories/index.ts



// EXTERNAL MODULE: ./src/features/search/api.ts
var api = __webpack_require__(85101);
// EXTERNAL MODULE: ./src/features/search/conf.ts
var conf = __webpack_require__(56170);
// EXTERNAL MODULE: ./src/features/search/components/filters/facet-accordion/index.ts + 3 modules
var facet_accordion = __webpack_require__(87159);
// EXTERNAL MODULE: ./src/features/search/components/filters/facets/index.ts + 7 modules
var facets = __webpack_require__(244);
// EXTERNAL MODULE: ./src/features/search/components/filters/facets-bar.tsx
var facets_bar = __webpack_require__(83524);
// EXTERNAL MODULE: ./src/features/search/components/filters/filter-chip.tsx
var filter_chip = __webpack_require__(82571);
// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(61261);
// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(91987);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-component-page-container-virtual-6ffaf0ab98/1/packages/component-page-container/src/index.ts + 1 modules
var component_page_container_src = __webpack_require__(53000);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-component-pagination-virtual-3039b6f680/1/packages/component-pagination/src/index.ts + 5 modules
var component_pagination_src = __webpack_require__(48753);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-component-settings-virtual-b227c80e08/1/packages/lib-component-settings/src/context.tsx



const defaultProps = {
    platform: "desktop"
};
const Context = /*#__PURE__*/ (/* unused pure expression or super */ null && (createContext(defaultProps)));
const useComponentSettingsContext = ()=>useContext(Context);
const context_ComponentSettingsProvider = (param)=>{
    let { children , ...props } = param;
    const value = useMemo(()=>{
        return {
            ...defaultProps,
            ...props
        };
    }, [
        props
    ]);
    return /*#__PURE__*/ _jsx(Context.Provider, {
        value: value,
        children: children
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-component-settings-virtual-b227c80e08/1/packages/lib-component-settings/src/index.ts


// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-lib-styles-virtual-b3f1d479f2/1/packages/lib-styles/src/index.ts + 18 modules
var lib_styles_src = __webpack_require__(52203);
// EXTERNAL MODULE: ../../.yarn/__virtual__/styled-components-virtual-29066d9421/0/cache/styled-components-npm-5.3.5-88e3937b59-05a664dfe4.zip/node_modules/styled-components/dist/styled-components.browser.cjs.js
var styled_components_browser_cjs = __webpack_require__(33982);
;// CONCATENATED MODULE: ./src/features/search/components/filters/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    const data = _taggedTemplateLiteral([
        ""
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: space-between;\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = _taggedTemplateLiteral([
        "\n  display: flex;\n  width: 100%;\n  max-width: ",
        "px;\n  height: 100%;\n  flex-direction: column;\n  justify-content: center;\n  margin: auto;\n  gap: 20px;\n  @media screen and (max-width: 1438px) {\n    margin-top: 56px;\n  }\n"
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  min-height: 38px;\n  margin-top: 24px;\n  overflow-x: scroll;\n  overflow-x: -moz-scrollbars-none;\n  scrollbar-width: none;\n  ::-webkit-scrollbar {\n    display: none;\n  }\n  @media screen and (max-width: ",
        "px) {\n    margin-top: 20px;\n  }\n"
    ]);
    _templateObject3 = function() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = _taggedTemplateLiteral([
        "\n  width: 100%;\n"
    ]);
    _templateObject4 = function() {
        return data;
    };
    return data;
}
function _templateObject5() {
    const data = _taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: center;\n  margin-top: 36px;\n  gap: 40px;\n  @media (max-width: ",
        "px) {\n    gap: 20px;\n  }\n"
    ]);
    _templateObject5 = function() {
        return data;
    };
    return data;
}
function _templateObject6() {
    const data = _taggedTemplateLiteral([
        "\n  display: flex;\n  margin-bottom: 29px;\n  @media screen and (min-width: ",
        "px) {\n    min-height: 56px;\n  }\n"
    ]);
    _templateObject6 = function() {
        return data;
    };
    return data;
}
function _templateObject7() {
    const data = _taggedTemplateLiteral([
        "\n  .desktop-accordion-block {\n    width: 100%;\n    min-width: 260px;\n    max-width: 400px;\n  }\n  @media (max-width: ",
        "px) {\n    display: none;\n  }\n"
    ]);
    _templateObject7 = function() {
        return data;
    };
    return data;
}
function _templateObject8() {
    const data = _taggedTemplateLiteral([
        ""
    ]);
    _templateObject8 = function() {
        return data;
    };
    return data;
}
function _templateObject9() {
    const data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n"
    ]);
    _templateObject9 = function() {
        return data;
    };
    return data;
}
function _templateObject10() {
    const data = _taggedTemplateLiteral([
        "\n  position: relative;\n  display: flex;\n  flex-direction: row-reverse;\n  align-items: center;\n  justify-content: flex-end;\n  padding: 5px 0;\n  cursor: pointer;\n  user-select: none;\n"
    ]);
    _templateObject10 = function() {
        return data;
    };
    return data;
}
function _templateObject11() {
    const data = _taggedTemplateLiteral([
        "\n  margin-left: 16px;\n  color: ",
        ";\n  font-size: 1rem;\n  line-height: 1.1;\n"
    ]);
    _templateObject11 = function() {
        return data;
    };
    return data;
}
function _templateObject12() {
    const data = _taggedTemplateLiteral([
        "\n  margin-left: 4px;\n  color: ",
        ";\n  transition: opacity 0.15s;\n"
    ]);
    _templateObject12 = function() {
        return data;
    };
    return data;
}
function _templateObject13() {
    const data = _taggedTemplateLiteral([
        "\n  display: flex;\n  width: 16px;\n  min-width: 16px;\n  height: 16px;\n  min-height: 16px;\n  align-items: center;\n  justify-content: center;\n  border: 1px solid ",
        ";\n  background-color: transparent;\n  transition: background-color 0.15s, border-color 0.15s;\n"
    ]);
    _templateObject13 = function() {
        return data;
    };
    return data;
}
function _templateObject14() {
    const data = _taggedTemplateLiteral([
        "\n  position: absolute;\n  border-radius: 0;\n  opacity: 0;\n  pointer-events: none;\n\n  &:checked + ",
        " {\n    border-color: ",
        ";\n    background-color: ",
        ";\n  }\n\n  &:focus + ",
        " {\n    border-color: ",
        ";\n  }\n"
    ]);
    _templateObject14 = function() {
        return data;
    };
    return data;
}
function _templateObject15() {
    const data = _taggedTemplateLiteral([
        "\n  border-bottom: 1px solid ",
        ";\n  margin-bottom: 16px;\n  transition: border-color 0.15s;\n"
    ]);
    _templateObject15 = function() {
        return data;
    };
    return data;
}
function _templateObject16() {
    const data = _taggedTemplateLiteral([
        "\n  display: flex;\n  width: 100%;\n  align-items: center;\n  justify-content: space-between;\n  padding: 16px;\n  border: 0;\n  border-radius: 0;\n  border-top: 1px solid ",
        ";\n  background-color: transparent;\n  cursor: pointer;\n  transition: border-color 0.15s, background-color 0.15s;\n  &:hover {\n    background-color: ",
        ";\n  }\n"
    ]);
    _templateObject16 = function() {
        return data;
    };
    return data;
}
function _templateObject17() {
    const data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  padding-left: 16px;\n"
    ]);
    _templateObject17 = function() {
        return data;
    };
    return data;
}
function _templateObject18() {
    const data = _taggedTemplateLiteral([
        "\n  transform: rotate(-90deg);\n  transition: transform 0.2s ease-in-out;\n"
    ]);
    _templateObject18 = function() {
        return data;
    };
    return data;
}
function _templateObject19() {
    const data = _taggedTemplateLiteral([
        "\n  color: ",
        ";\n  font-size: 1.125rem;\n  font-weight: 500;\n  line-height: 1.1;\n  text-align: left;\n"
    ]);
    _templateObject19 = function() {
        return data;
    };
    return data;
}
function _templateObject20() {
    const data = _taggedTemplateLiteral([
        "\n  display: flex;\n  width: 24px;\n  height: 24px;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n  margin-right: 16px;\n  background-color: ",
        ";\n  color: ",
        ";\n  font-size: 0.875rem;\n  font-weight: 500;\n  line-height: 1;\n  transition: opacity 0.15s;\n"
    ]);
    _templateObject20 = function() {
        return data;
    };
    return data;
}
function _templateObject21() {
    const data = _taggedTemplateLiteral([
        "\n  padding: 8px 16px 24px 16px;\n"
    ]);
    _templateObject21 = function() {
        return data;
    };
    return data;
}



const styles_ResultsAndPaginationContiner = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-9b1ee62-0"
})(_templateObject());
const styles_PaginationContainer = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-9b1ee62-1"
})(_templateObject1());
const styles_Container = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-9b1ee62-2"
})(_templateObject2(), lib_styles_src/* gridTheme.maxContentWidth */.k.maxContentWidth);
const styles_TagsContainer = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-9b1ee62-3"
})(_templateObject3(), lib_styles_src/* gridTheme.breakpoints.sm */.k.breakpoints.sm);
const ResultgridWrapper = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-9b1ee62-4"
})(_templateObject4());
const styles_Flex = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-9b1ee62-5"
})(_templateObject5(), lib_styles_src/* gridTheme.breakpoints.md */.k.breakpoints.md - 1);
const styles_SortingContainer = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-9b1ee62-6"
})(_templateObject6(), lib_styles_src/* gridTheme.breakpoints.sm */.k.breakpoints.sm);
const styles_DesktopOnly = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-9b1ee62-7"
})(_templateObject7(), lib_styles_src/* gridTheme.breakpoints.sm */.k.breakpoints.sm - 1);
const FacetCheckboxWrapper = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-9b1ee62-8"
})(_templateObject8());
const Line = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-9b1ee62-9"
})(_templateObject9());
const Item = styled_components_browser_cjs["default"].label.withConfig({
    componentId: "sc-9b1ee62-10"
})(_templateObject10());
const Text = styled_components_browser_cjs["default"].span.withConfig({
    componentId: "sc-9b1ee62-11"
})(_templateObject11(), lib_styles_src/* theme.palette.blue.main */.rS.palette.blue.main);
const Count = styled_components_browser_cjs["default"].span.withConfig({
    componentId: "sc-9b1ee62-12"
})(_templateObject12(), lib_styles_src/* theme.palette.gray.30 */.rS.palette.gray[30]);
const Box = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-9b1ee62-13"
})(_templateObject13(), lib_styles_src/* theme.palette.gray.20 */.rS.palette.gray[20]);
const CheckboxInput = styled_components_browser_cjs["default"].input.withConfig({
    componentId: "sc-9b1ee62-14"
})(_templateObject14(), Box, lib_styles_src/* theme.palette.blue.main */.rS.palette.blue.main, lib_styles_src/* theme.palette.blue.main */.rS.palette.blue.main, Box, lib_styles_src/* theme.palette.blue.main */.rS.palette.blue.main);
const Wrapper = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-9b1ee62-15"
})(_templateObject15(), lib_styles_src/* theme.palette.gray.60 */.rS.palette.gray[60]);
const GroupBtn = styled_components_browser_cjs["default"].button.withConfig({
    componentId: "sc-9b1ee62-16"
})(_templateObject16(), lib_styles_src/* theme.palette.blue.dark */.rS.palette.blue.dark, lib_styles_src/* theme.palette.blue.main */.rS.palette.blue.main);
const BtnTail = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-9b1ee62-17"
})(_templateObject17());
const IconWrapper = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-9b1ee62-18"
})(_templateObject18());
const Label = styled_components_browser_cjs["default"].span.withConfig({
    componentId: "sc-9b1ee62-19"
})(_templateObject19(), lib_styles_src/* theme.palette.blue.main */.rS.palette.blue.main);
const FacetCount = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-9b1ee62-20"
})(_templateObject20(), lib_styles_src/* theme.palette.gray.10 */.rS.palette.gray[10], lib_styles_src/* theme.palette.blue.main */.rS.palette.blue.main);
const Content = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-9b1ee62-21"
})(_templateObject21());

// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-component-typography-virtual-537720fdd1/1/packages/component-typography/src/index.ts + 2 modules
var component_typography_src = __webpack_require__(91371);
;// CONCATENATED MODULE: ./src/features/search/components/filters/results-block/styles.ts
function styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function styles_templateObject() {
    const data = styles_taggedTemplateLiteral([
        "\n  display: flex;\n  width: 100%;\n  flex-direction: column;\n  gap: 10px;\n"
    ]);
    styles_templateObject = function() {
        return data;
    };
    return data;
}
function styles_templateObject1() {
    const data = styles_taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: baseline;\n  margin-bottom: 29px;\n  ",
        " {\n    width: 100%;\n  }\n  @media screen and (min-width: ",
        "px) {\n    min-height: 56px;\n  }\n"
    ]);
    styles_templateObject1 = function() {
        return data;
    };
    return data;
}
function styles_templateObject2() {
    const data = styles_taggedTemplateLiteral([
        "\n  display: grid;\n  gap: 20px;\n  grid-template-columns: repeat(4, 1fr);\n\n  .product-card {\n    width: unset;\n    min-width: 240px;\n  }\n  @media (max-width: ",
        "px) {\n    grid-template-columns: repeat(3, 1fr);\n  }\n  @media (max-width: ",
        "px) {\n    grid-template-columns: repeat(3, 1fr);\n    .product-card {\n      .eye-button {\n        display: none;\n      }\n    }\n  }\n  @media (max-width: ",
        "px) {\n    gap: 10px;\n    grid-template-columns: repeat(2, 1fr);\n  }\n  @media screen and (max-width: 580px) {\n    gap: 10px;\n    grid-template-columns: repeat(1, 1fr);\n    .product-card {\n      max-width: unset;\n    }\n  }\n"
    ]);
    styles_templateObject2 = function() {
        return data;
    };
    return data;
}



const styles_ResultGrid = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-7e942712-0"
})(styles_templateObject());
const results_block_styles_SortingContainer = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-7e942712-1"
})(styles_templateObject1(), component_typography_src/* EyebrowLarge */.Gp, lib_styles_src/* gridTheme.breakpoints.sm */.k.breakpoints.sm);
const styles_ProductCardGrid = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-7e942712-2"
})(styles_templateObject2(), lib_styles_src/* gridTheme.container.maxWidth.lg */.k.container.maxWidth.lg, lib_styles_src/* gridTheme.container.maxWidth.m */.k.container.maxWidth.m, lib_styles_src/* gridTheme.container.maxWidth.sm */.k.container.maxWidth.sm);

// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-lib-illustrations-virtual-f4c8d3dc38/1/packages/lib-illustrations/src/index.ts + 16 modules
var lib_illustrations_src = __webpack_require__(94845);
;// CONCATENATED MODULE: ./src/features/search/components/filters/results-count-block/styles.ts
function results_count_block_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function results_count_block_styles_templateObject() {
    const data = results_count_block_styles_taggedTemplateLiteral([
        "\n  position: absolute;\n  top: 0;\n  left: 50%;\n  display: flex;\n  width: 100%;\n  flex-direction: column;\n  justify-content: center;\n  gap: 20px;\n  transform: translateX(-50%);\n  .desktop-accordion-block {\n    min-width: 320px;\n    max-width: unset;\n  }\n  p {\n    text-transform: none;\n  }\n  @media screen and (max-width: ",
        "px) {\n    background-color: ",
        ";\n  }\n"
    ]);
    results_count_block_styles_templateObject = function() {
        return data;
    };
    return data;
}
function results_count_block_styles_templateObject1() {
    const data = results_count_block_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  padding-top: 80px;\n  gap: 80px;\n"
    ]);
    results_count_block_styles_templateObject1 = function() {
        return data;
    };
    return data;
}
function results_count_block_styles_templateObject2() {
    const data = results_count_block_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  width: 100%;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n"
    ]);
    results_count_block_styles_templateObject2 = function() {
        return data;
    };
    return data;
}


const results_count_block_styles_Container = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-f874672c-0"
})(results_count_block_styles_templateObject(), lib_styles_src/* gridTheme.breakpoints.xs */.k.breakpoints.xs, lib_styles_src/* theme.palette.white.main */.rS.palette.white.main);
const styles_ResultRows = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-f874672c-1"
})(results_count_block_styles_templateObject1());
const styles_NothingFoundContainer = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-f874672c-2"
})(results_count_block_styles_templateObject2());

;// CONCATENATED MODULE: ./src/features/search/components/filters/results-count-block/index.tsx
function results_count_block_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function results_count_block_templateObject() {
    const data = results_count_block_taggedTemplateLiteral([
        "\n  display: flex;\n  @media screen and (max-width: ",
        "px) {\n    display: none;\n  }\n"
    ]);
    results_count_block_templateObject = function() {
        return data;
    };
    return data;
}
function results_count_block_templateObject1() {
    const data = results_count_block_taggedTemplateLiteral([
        "\n  display: none;\n  @media screen and (max-width: ",
        "px) {\n    display: flex;\n  }\n"
    ]);
    results_count_block_templateObject1 = function() {
        return data;
    };
    return data;
}







const results_count_block_DesktopOnly = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-339b0462-0"
})(results_count_block_templateObject(), lib_styles_src/* gridTheme.breakpoints.s */.k.breakpoints.s);
const results_count_block_MobileOnly = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-339b0462-1"
})(results_count_block_templateObject1(), lib_styles_src/* gridTheme.breakpoints.s */.k.breakpoints.s);
const results_count_block_ResultsCountBlock = (param)=>{
    let { count  } = param;
    return /*#__PURE__*/ _jsx(EyebrowLarge, {
        lineHeight: "100%",
        textColor: theme.palette.blue.dark,
        children: count < 1 ? /*#__PURE__*/ _jsx(Container, {
            children: /*#__PURE__*/ _jsx(ResultRows, {
                children: /*#__PURE__*/ _jsxs(NothingFoundContainer, {
                    children: [
                        /*#__PURE__*/ _jsx(PMedium, {
                            children: "Ekkert fannst"
                        }),
                        /*#__PURE__*/ _jsx(results_count_block_DesktopOnly, {
                            children: /*#__PURE__*/ _jsx(AfreidslaIllustration, {
                                size: 468
                            })
                        }),
                        /*#__PURE__*/ _jsx(results_count_block_MobileOnly, {
                            children: /*#__PURE__*/ _jsx(AfreidslaIllustration, {
                                size: 300
                            })
                        })
                    ]
                })
            })
        }) : /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                count,
                " ",
                count === 1 ? "VARA FANNST" : "V\xd6RUR FUNDUST"
            ]
        })
    });
};

// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-component-select-virtual-f6511e8fae/1/packages/component-select/src/index.ts + 6 modules
var component_select_src = __webpack_require__(388);
;// CONCATENATED MODULE: ./src/features/search/components/filters/filter-dropdown-sorting-block/styles.ts
function filter_dropdown_sorting_block_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function filter_dropdown_sorting_block_styles_templateObject() {
    const data = filter_dropdown_sorting_block_styles_taggedTemplateLiteral([
        "\n  .select-container {\n    width: 100%;\n    min-width: 200px;\n    max-width: 320px;\n    outline: 1px solid ",
        ";\n\n    p {\n      color: ",
        ";\n    }\n  }\n"
    ]);
    filter_dropdown_sorting_block_styles_templateObject = function() {
        return data;
    };
    return data;
}
function filter_dropdown_sorting_block_styles_templateObject1() {
    const data = filter_dropdown_sorting_block_styles_taggedTemplateLiteral([
        "\n  position: relative;\n  top: 56px;\n  width: 100%;\n  margin-bottom: 56px;\n  @media screen and (min-width: 581px) {\n    display: none;\n  }\n"
    ]);
    filter_dropdown_sorting_block_styles_templateObject1 = function() {
        return data;
    };
    return data;
}
function filter_dropdown_sorting_block_styles_templateObject2() {
    const data = filter_dropdown_sorting_block_styles_taggedTemplateLiteral([
        "\n  position: relative;\n  display: flex;\n  .accordian-filter {\n    border-bottom: 4px solid ",
        ";\n    :hover {\n      box-shadow: ",
        ";\n    }\n  }\n  .sorting-button {\n    border-bottom: 4px solid ",
        ";\n    :hover {\n      box-shadow: ",
        ";\n    }\n  }\n"
    ]);
    filter_dropdown_sorting_block_styles_templateObject2 = function() {
        return data;
    };
    return data;
}


const styles_DropdownContainer = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-27f6dbd1-0"
})(filter_dropdown_sorting_block_styles_templateObject(), lib_styles_src/* theme.palette.gray.10 */.rS.palette.gray[10], lib_styles_src/* theme.palette.blue.dark */.rS.palette.blue.dark);
const styles_MobileSortingBlockContainer = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-27f6dbd1-1"
})(filter_dropdown_sorting_block_styles_templateObject1());
const styles_ButtonWrapper = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-27f6dbd1-2"
})(filter_dropdown_sorting_block_styles_templateObject2(), (props)=>props.openAccordianFilter ? " ".concat(lib_styles_src/* theme.palette.blue.main */.rS.palette.blue.main) : "none", (props)=>props.openAccordianFilter ? "none" : " drop-shadow(0px 4px 20px rgba(0, 0, 0, 0.1))", (props)=>props.openSorting ? " ".concat(lib_styles_src/* theme.palette.blue.main */.rS.palette.blue.main) : "none", (props)=>props.openSorting ? "none" : " drop-shadow(0px 4px 20px rgba(0, 0, 0, 0.1))");

;// CONCATENATED MODULE: ./src/features/search/components/filters/filter-dropdown-sorting-block/index.tsx




const filter_dropdown_sorting_block_DropdownSortingBlock = (param)=>{
    let { sortingOptions , handleClick  } = param;
    const activeItem = useMemo(()=>{
        return sortingOptions.find((item)=>{
            return item.active;
        });
    }, [
        sortingOptions
    ]);
    const handleDropdownSelect = useCallback((value)=>{
        if (!(value === null || value === void 0 ? void 0 : value.selectedItem)) {
            return;
        }
        if (handleClick) {
            handleClick(value.selectedItem.id);
        }
    }, [
        handleClick
    ]);
    var ref;
    const handleItemToString = useCallback((option)=>{
        return (ref = option === null || option === void 0 ? void 0 : option.label) !== null && ref !== void 0 ? ref : "";
    }, []);
    return /*#__PURE__*/ _jsx(DropdownContainer, {
        children: /*#__PURE__*/ _jsx(Select, {
            align: "left",
            fit: true,
            handleSelectedItemChange: handleDropdownSelect,
            hideValue: true,
            items: sortingOptions,
            itemToString: handleItemToString,
            placeholder: activeItem === null || activeItem === void 0 ? void 0 : activeItem.label,
            selectedItem: activeItem
        })
    });
};

;// CONCATENATED MODULE: ./src/features/search/components/filters/results-block/index.tsx






const results_block_ResultsBlock = (param)=>{
    let { children , count , handleSortClick , sortingOptions  } = param;
    const { width  } = useWindowSize();
    if (count === 0) return /*#__PURE__*/ _jsx(ResultsCountBlock, {
        count: count
    });
    return /*#__PURE__*/ _jsxs(ResultGrid, {
        className: "result-block",
        children: [
            /*#__PURE__*/ _jsxs(SortingContainer, {
                children: [
                    typeof count !== "undefined" ? /*#__PURE__*/ _jsx(ResultsCountBlock, {
                        count: count
                    }) : null,
                    width > 580 && /*#__PURE__*/ _jsx(_Fragment, {
                        children: /*#__PURE__*/ _jsx(DropdownSortingBlock, {
                            handleClick: handleSortClick,
                            sortingOptions: sortingOptions
                        })
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(ProductCardGrid, {
                children: children
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/features/search/components/filters/tags-block/styles.ts
function tags_block_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function tags_block_styles_templateObject() {
    const data = tags_block_styles_taggedTemplateLiteral([
        "\n  position: relative;\n  display: flex;\n  min-width: fit-content;\n  align-items: center;\n  padding: 10px 16px;\n  margin-bottom: 2px;\n  background-color: ",
        ";\n  gap: 8px;\n  outline: 1px solid ",
        ";\n  p {\n    margin-top: 4px;\n  }\n  @media screen and (min-width: ",
        "px) {\n    padding: 10px 16px;\n  }\n"
    ]);
    tags_block_styles_templateObject = function() {
        return data;
    };
    return data;
}
function tags_block_styles_templateObject1() {
    const data = tags_block_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  margin-top: 3px;\n  margin-left: 2px;\n  gap: 8px;\n"
    ]);
    tags_block_styles_templateObject1 = function() {
        return data;
    };
    return data;
}
function tags_block_styles_templateObject2() {
    const data = tags_block_styles_taggedTemplateLiteral([
        "\n  display: grid;\n  outline: none;\n  &:after {\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    width: 0%;\n    border-bottom: 2px solid ",
        ';\n    content: "";\n    transition: 300ms;\n  }\n  &:focus,\n  &:hover {\n    &:after {\n      width: 100%;\n    }\n  }\n'
    ]);
    tags_block_styles_templateObject2 = function() {
        return data;
    };
    return data;
}


const styles_TagWrapper = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-2b53214b-0"
})(tags_block_styles_templateObject(), lib_styles_src/* theme.palette.white.main */.rS.palette.white.main, lib_styles_src/* theme.palette.blue.light */.rS.palette.blue.light, lib_styles_src/* gridTheme.breakpoints.sm */.k.breakpoints.sm);
const styles_Tags = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-2b53214b-1"
})(tags_block_styles_templateObject1());
const styles_ClearButton = styled_components_browser_cjs["default"].button.withConfig({
    componentId: "sc-2b53214b-2"
})(tags_block_styles_templateObject2(), lib_styles_src/* theme.palette.blue.dark */.rS.palette.blue.dark);

// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-lib-icons-virtual-412b14e947/1/packages/lib-icons/src/index.ts + 181 modules
var lib_icons_src = __webpack_require__(45628);
;// CONCATENATED MODULE: ./src/features/search/components/filters/tags-block/tag-item.tsx






const tag_item_TagItem = (param)=>{
    let { tag , clearTag  } = param;
    const handleClearTag = useCallback(()=>{
        clearTag(tag);
    }, [
        clearTag,
        tag
    ]);
    return /*#__PURE__*/ _jsxs(TagWrapper, {
        children: [
            /*#__PURE__*/ _jsx(EyebrowSmall, {
                lineHeight: "100%",
                textColor: theme.palette.blue.dark,
                children: tag.label
            }),
            /*#__PURE__*/ _jsx(ClearButton, {
                type: "button",
                onClick: handleClearTag,
                children: /*#__PURE__*/ _jsx(CancelLargeIcons, {
                    iconColor: theme.palette.blue.dark,
                    size: 14
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/features/search/components/filters/tags-block/index.tsx




const tags_block_TagsBlock = (param)=>{
    let { tags , setTag  } = param;
    const clearTag = useCallback((tag)=>{
        if (!setTag) {
            return;
        }
        setTag(tag.id, false);
    }, [
        setTag
    ]);
    return /*#__PURE__*/ _jsx(Tags, {
        children: tags.map((tag)=>{
            return /*#__PURE__*/ _jsx(TagItem, {
                clearTag: clearTag,
                tag: tag
            }, tag.id);
        })
    });
};

// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-component-buttons-virtual-1a577fdc8c/1/packages/component-buttons/src/index.ts + 16 modules
var component_buttons_src = __webpack_require__(80620);
;// CONCATENATED MODULE: ./src/features/search/components/filters/filter-accordion-block/component/mobile/styles.ts
function mobile_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function mobile_styles_templateObject() {
    const data = mobile_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  max-height: ",
        ";\n  flex-wrap: wrap;\n  justify-content: space-between;\n  padding: ",
        ";\n  border-bottom: ",
        " solid\n    ",
        ";\n  opacity: ",
        ";\n  pointer-events: ",
        ";\n"
    ]);
    mobile_styles_templateObject = function() {
        return data;
    };
    return data;
}
function mobile_styles_templateObject1() {
    const data = mobile_styles_taggedTemplateLiteral([
        ""
    ]);
    mobile_styles_templateObject1 = function() {
        return data;
    };
    return data;
}
function mobile_styles_templateObject2() {
    const data = mobile_styles_taggedTemplateLiteral([
        "\n  width: 100%;\n  button {\n    padding: 10px 0;\n    border: none;\n    border-top: ",
        " solid\n      ",
        ";\n    box-shadow: none;\n  }\n  .accordion-button {\n    p {\n      color: ",
        ";\n    }\n  }\n  .accordion-button-sorting {\n    justify-content: flex-start;\n  }\n"
    ]);
    mobile_styles_templateObject2 = function() {
        return data;
    };
    return data;
}
function styles_templateObject3() {
    const data = mobile_styles_taggedTemplateLiteral([
        "\n  position: fixed;\n  z-index: 10;\n  display: flex;\n  width: 100%;\n  height: 100%;\n  max-height: calc(100% - 160px);\n  flex-direction: column;\n  padding: 0 16px;\n  background-color: ",
        ";\n  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.1);\n  overflow-y: auto;\n  ",
        "\n"
    ]);
    styles_templateObject3 = function() {
        return data;
    };
    return data;
}
function styles_templateObject4() {
    const data = mobile_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  height: 100%;\n  align-items: flex-end;\n  padding: 40px 0;\n"
    ]);
    styles_templateObject4 = function() {
        return data;
    };
    return data;
}



const styles_MobileAccordionContent = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-f85849df-0"
})(mobile_styles_templateObject(), (props)=>props.displayContent ? "100%" : "0px", (props)=>props.displayContent ? "10px 6px 30px 6px" : "0px 24px", (props)=>props.displayContent ? "2px" : "1px", (props)=>props.displayContent ? lib_styles_src/* theme.palette.blue.main */.rS.palette.blue.main : lib_styles_src/* theme.palette.gray.10 */.rS.palette.gray[10], (props)=>props.displayContent ? "1" : "0", (props)=>props.displayContent ? "initial" : "none");
const styles_MobileAccordionRowOuter = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-f85849df-1"
})(mobile_styles_templateObject1());
const styles_MobileAccordionRowWrapper = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-f85849df-2"
})(mobile_styles_templateObject2(), (props)=>props.active ? "2px" : "1px", (props)=>props.active ? lib_styles_src/* theme.palette.blue.main */.rS.palette.blue.main : lib_styles_src/* theme.palette.gray.10 */.rS.palette.gray[10], (props)=>props.active ? lib_styles_src/* theme.palette.blue.main */.rS.palette.blue.main : lib_styles_src/* theme.palette.blue.dark */.rS.palette.blue.dark);
const styles_MobileAccordionWrapper = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-f85849df-3"
})(styles_templateObject3(), lib_styles_src/* theme.palette.white.main */.rS.palette.white.main, (0,lib_styles_src/* scrollStyle */.vh)({
    color: "dark-blue"
}));
const styles_MobileAccordionButtons = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-f85849df-4"
})(styles_templateObject4());

;// CONCATENATED MODULE: ./src/features/search/components/filters/filter-accordion-block/component/mobile/mobile-accordion-row.tsx





const mobile_accordion_row_MobileAccordionRow = (param)=>{
    let { configuration , active , toggleActive  } = param;
    const handleClick = useCallback(()=>{
        if (typeof configuration.id === "undefined" || configuration.id == null) {
            return;
        }
        toggleActive(configuration.id);
    }, [
        configuration.id,
        toggleActive
    ]);
    return /*#__PURE__*/ _jsxs(MobileAccordionRowOuter, {
        children: [
            /*#__PURE__*/ _jsx(MobileAccordionRowWrapper, {
                active: active,
                children: /*#__PURE__*/ _jsx(Button, {
                    buttonColor: "whiteButton",
                    customClassName: "accordion-button",
                    icon: active ? SubtractIcons : AddIcons,
                    label: configuration.label,
                    stretch: true,
                    onClick: handleClick
                })
            }),
            /*#__PURE__*/ _jsx(MobileAccordionContent, {
                displayContent: active,
                children: configuration.content
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/features/search/components/filters/filter-accordion-block/component/mobile/mobile-accordion-block.tsx







const mobile_accordion_block_MobileAccordionBlock = (param)=>{
    let { configuration , handleReset , handleClose , handleSubmit  } = param;
    const [state, dispatch] = useReducer(reducer, {});
    const handleClick = useCallback(()=>{
        if (!handleReset) {
            return;
        }
        handleReset();
    }, [
        handleReset
    ]);
    const handleToggleActive = useCallback((id)=>{
        dispatch({
            type: "toggle",
            id
        });
    }, []);
    const handleSubmitClick = useCallback(()=>{
        handleSubmit === null || handleSubmit === void 0 ? void 0 : handleSubmit();
        handleClose === null || handleClose === void 0 ? void 0 : handleClose();
    }, [
        handleSubmit,
        handleClose
    ]);
    return /*#__PURE__*/ _jsxs(MobileAccordionWrapper, {
        children: [
            configuration.map((item)=>{
                var _id;
                const active = (_id = state[item.id]) !== null && _id !== void 0 ? _id : false;
                return /*#__PURE__*/ _jsx(_Fragment, {
                    children: /*#__PURE__*/ _jsx(MobileAccordionRow, {
                        active: active,
                        configuration: item,
                        toggleActive: handleToggleActive
                    }, item.id)
                });
            }),
            /*#__PURE__*/ _jsxs(MobileAccordionButtons, {
                children: [
                    /*#__PURE__*/ _jsx(Button, {
                        buttonColor: "whiteButton",
                        label: "Endurstilla s\xedur",
                        stretch: true,
                        onClick: handleClick
                    }),
                    /*#__PURE__*/ _jsx(Button, {
                        buttonColor: "blueButton",
                        icon: SearchIcons,
                        label: "Leita",
                        stretch: true,
                        onClick: handleSubmitClick
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/features/search/components/filters/filter-accordion-block/component/mobile/mobile-sorting-block.tsx




const mobile_sorting_block_MobileSortingBlock = (param)=>{
    let { sortingOptions  } = param;
    // TODO: onClick
    return /*#__PURE__*/ _jsx(MobileAccordionRowWrapper, {
        children: /*#__PURE__*/ _jsx(MobileAccordionWrapper, {
            children: sortingOptions === null || sortingOptions === void 0 ? void 0 : sortingOptions.map((item)=>/*#__PURE__*/ _jsx(Button, {
                    customClassName: "accordion-button-sorting",
                    label: item.label,
                    stretch: true
                }, item.id))
        })
    });
};

;// CONCATENATED MODULE: ./src/features/search/components/filters/filter-accordion-block/styles.ts
function filter_accordion_block_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function filter_accordion_block_styles_templateObject() {
    const data = filter_accordion_block_styles_taggedTemplateLiteral([
        "\n  width: 100%;\n  max-width: 320px;\n  max-height: ",
        ";\n  padding: ",
        ";\n  opacity: ",
        ";\n  pointer-events: ",
        ";\n"
    ]);
    filter_accordion_block_styles_templateObject = function() {
        return data;
    };
    return data;
}
function filter_accordion_block_styles_templateObject1() {
    const data = filter_accordion_block_styles_taggedTemplateLiteral([
        ""
    ]);
    filter_accordion_block_styles_templateObject1 = function() {
        return data;
    };
    return data;
}
function filter_accordion_block_styles_templateObject2() {
    const data = filter_accordion_block_styles_taggedTemplateLiteral([
        "\n  width: 100%;\n  .accordion-button {\n    border: none;\n    border-top: ",
        " solid\n      ",
        ";\n    :hover {\n      box-shadow: none;\n      p {\n        color: ",
        ";\n      }\n    }\n  }\n"
    ]);
    filter_accordion_block_styles_templateObject2 = function() {
        return data;
    };
    return data;
}
function filter_accordion_block_styles_templateObject3() {
    const data = filter_accordion_block_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  width: 100%;\n  height: fit-content;\n  flex-direction: column;\n  padding: 30px 24px;\n  background-color: ",
        ";\n  opacity: ",
        ";\n  outline: 1px solid ",
        ";\n  pointer-events: ",
        ";\n  .clear-filter-button {\n    border: none;\n    margin-top: 24px;\n    p {\n      color: ",
        ";\n    }\n  }\n  ",
        " {\n    &:last-of-type {\n      .accordion-button {\n        border-bottom: 1px solid ",
        ";\n      }\n    }\n  }\n"
    ]);
    filter_accordion_block_styles_templateObject3 = function() {
        return data;
    };
    return data;
}


const styles_AccordionContent = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-932603c1-0"
})(filter_accordion_block_styles_templateObject(), (props)=>props.displayContent ? "100%" : "0px", (props)=>props.displayContent ? "10px 24px 30px 24px" : "0px 24px", (props)=>props.displayContent ? "1" : "0", (props)=>props.displayContent ? "initial" : "none");
const styles_AccordionRowOuter = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-932603c1-1"
})(filter_accordion_block_styles_templateObject1());
const styles_AccordionRowWrapper = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-932603c1-2"
})(filter_accordion_block_styles_templateObject2(), (props)=>props.active ? "2px" : "1px", (props)=>props.active ? lib_styles_src/* theme.palette.blue.main */.rS.palette.blue.main : lib_styles_src/* theme.palette.gray.10 */.rS.palette.gray[10], lib_styles_src/* theme.palette.blue.main */.rS.palette.blue.main);
const styles_AccordionWrapper = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-932603c1-3"
})(filter_accordion_block_styles_templateObject3(), lib_styles_src/* theme.palette.white.main */.rS.palette.white.main, (param)=>{
    let { active  } = param;
    return active ? "1" : "0";
}, lib_styles_src/* theme.palette.gray.10 */.rS.palette.gray[10], (param)=>{
    let { active  } = param;
    return active ? "auto" : "none";
}, lib_styles_src/* theme.palette.blue.main */.rS.palette.blue.main, styles_AccordionRowWrapper, lib_styles_src/* theme.palette.gray.10 */.rS.palette.gray[10]);

;// CONCATENATED MODULE: ./src/features/search/components/filters/filter-accordion-block/component/accordion/accordion-row.tsx





const accordion_row_AccordionRow = (param)=>{
    let { configuration , toggleActive  } = param;
    const handleClick = useCallback(()=>{
        if (typeof configuration.id === "number") {
            toggleActive(configuration.id);
        }
    }, [
        configuration.id,
        toggleActive
    ]);
    var _active, _active1;
    return /*#__PURE__*/ _jsxs(AccordionRowOuter, {
        children: [
            /*#__PURE__*/ _jsx(AccordionRowWrapper, {
                active: (_active = configuration.active) !== null && _active !== void 0 ? _active : false,
                children: /*#__PURE__*/ _jsx(Button, {
                    buttonColor: "whiteButton",
                    customClassName: "accordion-button",
                    icon: configuration.active ? SubtractIcons : AddIcons,
                    label: configuration.label,
                    stretch: true,
                    onClick: handleClick
                })
            }),
            /*#__PURE__*/ _jsx(AccordionContent, {
                displayContent: (_active1 = configuration.active) !== null && _active1 !== void 0 ? _active1 : false,
                children: configuration.content
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/features/search/components/filters/filter-accordion-block/component/accordion/accordion-block-item.tsx



const accordion_block_item_AccordionBlockItem = (param)=>{
    let { state , handleToggleActive , item  } = param;
    const itemWithState = useMemo(()=>{
        var _id, ref;
        return {
            ...item,
            active: (ref = state[(_id = item.id) !== null && _id !== void 0 ? _id : item.label]) !== null && ref !== void 0 ? ref : false
        };
    }, [
        state,
        item
    ]);
    var _id, ref;
    return /*#__PURE__*/ _jsx(AccordionRow, {
        active: (ref = state[(_id = item.id) !== null && _id !== void 0 ? _id : item.label]) !== null && ref !== void 0 ? ref : false,
        configuration: itemWithState,
        toggleActive: handleToggleActive
    }, item.id);
};

;// CONCATENATED MODULE: ./src/features/search/components/filters/filter-accordion-block/component/index.ts





;// CONCATENATED MODULE: ./src/features/search/components/filters/filter-accordion-block/accordion-block.tsx






const AccordionBlockComponent = (param)=>{
    let { configuration , handleReset  } = param;
    const [state, dispatch] = useReducer(reducer, {});
    const handleClick = useCallback(()=>{
        if (!handleReset) {
            return;
        }
        handleReset();
    }, [
        handleReset
    ]);
    const handleToggleActive = useCallback((id)=>{
        dispatch({
            type: "toggle",
            id
        });
    }, []);
    return /*#__PURE__*/ _jsxs(AccordionWrapper, {
        active: configuration.length > 0,
        className: "desktop-accordion-block",
        children: [
            configuration.map((item)=>{
                var _id;
                return /*#__PURE__*/ _jsx(AccordionBlockItem, {
                    handleToggleActive: handleToggleActive,
                    item: item,
                    state: state
                }, (_id = item.id) !== null && _id !== void 0 ? _id : item.label);
            }),
            /*#__PURE__*/ _jsx(Button, {
                buttonColor: "whiteButton",
                customClassName: "clear-filter-button",
                label: "Endurstilla s\xedur",
                stretch: true,
                onClick: handleClick
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/features/search/components/filters/filter-accordion-block/index.ts



;// CONCATENATED MODULE: ./src/features/search/components/filters/filter-dropdown-sorting-block/mobile-sorting-block.tsx






const mobile_sorting_block_MobileSortingButtons = (param)=>{
    let { configuration , sortingOptions , handleSubmit , handleReset  } = param;
    const [openAccordianFilter, setOpenAccordianFillter] = useState(false);
    const [openSorting, setOpenSorting] = useState(false);
    const handleAccordianClick = useCallback(()=>{
        if (openSorting === true) {
            setOpenSorting(!openSorting);
        }
        setOpenAccordianFillter(!openAccordianFilter);
    }, [
        openAccordianFilter,
        openSorting
    ]);
    const handleSortingClick = useCallback(()=>{
        if (openAccordianFilter === true) {
            setOpenAccordianFillter(!openAccordianFilter);
        }
        setOpenSorting(!openSorting);
    }, [
        openAccordianFilter,
        openSorting
    ]);
    const handleClose = useCallback(()=>{
        setOpenAccordianFillter(false);
    }, []);
    useEffect(()=>{
        document.body.classList.toggle("no-scroll", openAccordianFilter || openSorting);
    }, [
        openAccordianFilter,
        openSorting
    ]);
    return /*#__PURE__*/ _jsxs(MobileSortingBlockContainer, {
        children: [
            /*#__PURE__*/ _jsxs(ButtonWrapper, {
                openAccordianFilter: openAccordianFilter,
                openSorting: openSorting,
                children: [
                    /*#__PURE__*/ _jsx(Button, {
                        customClassName: "sorting-button",
                        icon: ArrowDownIcons,
                        label: "R\xf6\xf0un",
                        stretch: true,
                        onClick: handleSortingClick
                    }),
                    /*#__PURE__*/ _jsx(Button, {
                        customClassName: "accordian-filter",
                        icon: FilterIcons,
                        label: "S\xedur",
                        stretch: true,
                        onClick: handleAccordianClick
                    })
                ]
            }),
            openSorting && /*#__PURE__*/ _jsx(MobileSortingBlock, {
                sortingOptions: sortingOptions
            }),
            openAccordianFilter && /*#__PURE__*/ _jsx(MobileAccordionBlock, {
                configuration: configuration,
                handleClose: handleClose,
                handleReset: handleReset,
                handleSubmit: handleSubmit
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/features/search/components/filters/filter.tsx
/* eslint-disable react-perf/jsx-no-new-array-as-prop */ 










const Filter = (param)=>{
    let { tags =[] , configuration =[] , setTag , sortingOptions =[] , children , count , totalPages , currentPage , handleMobileSubmit , handleReset , handleSortClick , handleSetPage  } = param;
    const { activeBreakPoint  } = useWindowSize();
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(ComponentSettingsProvider, {
                platform: "mobile",
                children: /*#__PURE__*/ _jsx(MobileSortingButtons, {
                    configuration: configuration,
                    handleReset: handleReset,
                    handleSubmit: handleMobileSubmit,
                    sortingOptions: sortingOptions
                })
            }),
            /*#__PURE__*/ _jsx(PageContainer, {
                flexDirection: "column",
                offsetNav: false,
                children: /*#__PURE__*/ _jsxs(Container, {
                    children: [
                        tags.length >= 1 && /*#__PURE__*/ _jsx(TagsContainer, {
                            children: /*#__PURE__*/ _jsx(TagsBlock, {
                                setTag: setTag,
                                tags: tags
                            })
                        }),
                        /*#__PURE__*/ _jsxs(Flex, {
                            children: [
                                /*#__PURE__*/ _jsxs(ResultsAndPaginationContiner, {
                                    children: [
                                        /*#__PURE__*/ _jsx(ResultsBlock, {
                                            count: count,
                                            handleSortClick: handleSortClick,
                                            sortingOptions: sortingOptions,
                                            children: children
                                        }),
                                        /*#__PURE__*/ _jsx(PaginationContainer, {
                                            children: /*#__PURE__*/ _jsx(Pagination, {
                                                align: [
                                                    "xs",
                                                    "s"
                                                ].includes(activeBreakPoint) ? "center" : "flex-end",
                                                pageIndex: currentPage,
                                                setPageIndex: handleSetPage,
                                                totalPages: totalPages
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsx(DesktopOnly, {
                                    children: /*#__PURE__*/ _jsx(AccordionBlock, {
                                        configuration: configuration,
                                        handleReset: handleReset
                                    })
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/features/search/components/filters/index.ts







// EXTERNAL MODULE: ../../.yarn/__virtual__/next-virtual-cff1f1d108/0/cache/next-npm-13.0.0-0d765f7d5e-7b5c847287.zip/node_modules/next/router.js
var router = __webpack_require__(87347);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-component-slider-virtual-0c239e2406/1/packages/component-slider/src/index.ts + 14 modules
var component_slider_src = __webpack_require__(46146);
;// CONCATENATED MODULE: ./src/features/search/components/overview-page/styles.ts
function overview_page_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function overview_page_styles_templateObject() {
    const data = overview_page_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  width: 100%;\n  flex-direction: column;\n  justify-content: center;\n  gap: 20px;\n  .desktop-accordion-block {\n    min-width: 320px;\n    max-width: unset;\n  }\n  @media screen and (max-width: ",
        "px) {\n    background-color: ",
        ";\n  }\n"
    ]);
    overview_page_styles_templateObject = function() {
        return data;
    };
    return data;
}
function overview_page_styles_templateObject1() {
    const data = overview_page_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  padding-top: 80px;\n  gap: 80px;\n"
    ]);
    overview_page_styles_templateObject1 = function() {
        return data;
    };
    return data;
}
function overview_page_styles_templateObject2() {
    const data = overview_page_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  width: 100%;\n  height: 56px;\n  flex-direction: row;\n  justify-content: space-evenly;\n  filter: drop-shadow(0px 4px 20px rgba(0, 0, 0, 0.1));\n"
    ]);
    overview_page_styles_templateObject2 = function() {
        return data;
    };
    return data;
}
function overview_page_styles_templateObject3() {
    const data = overview_page_styles_taggedTemplateLiteral([
        "\n  position: relative;\n  width: 100%;\n  &::after {\n    position: absolute;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    height: 2px;\n    background-color: ",
        ';\n    content: "";\n    transition: 300ms;\n  }\n'
    ]);
    overview_page_styles_templateObject3 = function() {
        return data;
    };
    return data;
}
function overview_page_styles_templateObject4() {
    const data = overview_page_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  width: 100%;\n  flex-direction: column;\n  gap: 25px;\n"
    ]);
    overview_page_styles_templateObject4 = function() {
        return data;
    };
    return data;
}
function styles_templateObject5() {
    const data = overview_page_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  width: 100%;\n  max-width: ",
        "px;\n  align-items: center;\n  justify-content: space-between;\n  margin-right: auto;\n  margin-left: auto;\n"
    ]);
    styles_templateObject5 = function() {
        return data;
    };
    return data;
}
function styles_templateObject6() {
    const data = overview_page_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  gap: 14px;\n  p {\n    line-height: 22px;\n  }\n"
    ]);
    styles_templateObject6 = function() {
        return data;
    };
    return data;
}
function styles_templateObject7() {
    const data = overview_page_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  width: 260px;\n  justify-content: flex-end;\n"
    ]);
    styles_templateObject7 = function() {
        return data;
    };
    return data;
}
function styles_templateObject8() {
    const data = overview_page_styles_taggedTemplateLiteral([
        "\n  width: 100%;\n  @media screen and (max-width: ",
        "px) {\n    width: 100%;\n  }\n  .swiper-slide {\n    width: 325px !important;\n  }\n  .product-card {\n    width: 100% !important;\n    flex: none;\n  }\n  @media screen and (max-width: 375px) {\n    .swiper-slide {\n      width: calc(100% - 48px) !important;\n    }\n  }\n  &.pages {\n    .swiper-slide {\n      width: 431px !important;\n    }\n    .product-card {\n      width: 100% !important;\n      flex: none;\n    }\n    @media screen and (max-width: 375px) {\n      .swiper-slide {\n        width: calc(100% - 48px) !important;\n      }\n    }\n  }\n"
    ]);
    styles_templateObject8 = function() {
        return data;
    };
    return data;
}
function styles_templateObject9() {
    const data = overview_page_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  width: 100%;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n"
    ]);
    styles_templateObject9 = function() {
        return data;
    };
    return data;
}
function styles_templateObject10() {
    const data = overview_page_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  @media screen and (max-width: ",
        "px) {\n    display: none;\n  }\n"
    ]);
    styles_templateObject10 = function() {
        return data;
    };
    return data;
}
function styles_templateObject11() {
    const data = overview_page_styles_taggedTemplateLiteral([
        "\n  display: none;\n  @media screen and (max-width: ",
        "px) {\n    display: flex;\n  }\n"
    ]);
    styles_templateObject11 = function() {
        return data;
    };
    return data;
}


const overview_page_styles_Container = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-95f89f0-0"
})(overview_page_styles_templateObject(), lib_styles_src/* gridTheme.breakpoints.xs */.k.breakpoints.xs, lib_styles_src/* theme.palette.white.main */.rS.palette.white.main);
const overview_page_styles_ResultRows = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-95f89f0-1"
})(overview_page_styles_templateObject1());
const ResultsContextWrapper = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-95f89f0-2"
})(overview_page_styles_templateObject2());
const ButtonContainer = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-95f89f0-3"
})(overview_page_styles_templateObject3(), (props)=>props.active ? lib_styles_src/* theme.palette.blue.main */.rS.palette.blue.main : lib_styles_src/* theme.palette.transparent.main */.rS.palette.transparent.main);
const styles_ResultsRowWrapper = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-95f89f0-4"
})(overview_page_styles_templateObject4());
const styles_ResultsRowHeader = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-95f89f0-5"
})(styles_templateObject5(), lib_styles_src/* gridTheme.maxContentWidth */.k.maxContentWidth);
const styles_ResultsRowHeaderTitle = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-95f89f0-6"
})(styles_templateObject6());
const styles_ResultsRowHeaderSeeAll = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-95f89f0-7"
})(styles_templateObject7());
const styles_ResultsRowSwiper = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-95f89f0-8"
})(styles_templateObject8(), lib_styles_src/* gridTheme.container.maxWidth.sm */.k.container.maxWidth.sm);
const overview_page_styles_NothingFoundContainer = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-95f89f0-9"
})(styles_templateObject9());
const overview_page_styles_DesktopOnly = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-95f89f0-10"
})(styles_templateObject10(), lib_styles_src/* gridTheme.breakpoints.s */.k.breakpoints.s);
const styles_MobileOnly = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-95f89f0-11"
})(styles_templateObject11(), lib_styles_src/* gridTheme.breakpoints.s */.k.breakpoints.s);

;// CONCATENATED MODULE: ./src/features/search/components/overview-page/results-row.tsx











const VARIANT_WIDTH = {
    products: 264,
    pages: 317,
    articles: 429,
    brands: 330
};
const results_row_ResultsRow = (param)=>{
    let { query , title , icon: Icon , sliderCollection , variant , hideShowAll =false  } = param;
    const router = useRouter();
    const { activeBreakPoint , width  } = useWindowSize();
    const breakpoints = useMemo(()=>{
        const sliderPerView = width / VARIANT_WIDTH[variant];
        return {
            [width]: {
                slidesPerView: sliderPerView,
                spaceBetween: 10
            }
        };
    }, [
        variant,
        width
    ]);
    const handleClick = useCallback(()=>{
        if (variant === "products") {
            router.push("/vorur?q=".concat(query));
        }
    }, [
        router,
        query,
        variant
    ]);
    const getSlidesPerView = useCallback(()=>{
        let perView = 1;
        for(let i = Object.keys(breakpoints).length - 1; i > 0; i--){
            if (window.innerWidth >= Number(Object.keys(breakpoints)[i])) {
                var ref;
                perView = Number((ref = breakpoints[Number(Object.keys(breakpoints)[i])]) === null || ref === void 0 ? void 0 : ref.slidesPerView);
                break;
            }
        }
        return perView;
    }, [
        breakpoints
    ]);
    const showSeeAll = useMemo(()=>{
        if (hideShowAll) {
            return false;
        }
        const slidesPerView = getSlidesPerView();
        return slidesPerView <= sliderCollection.length;
    }, [
        getSlidesPerView,
        hideShowAll,
        sliderCollection.length
    ]);
    if (sliderCollection.length === 0 || width === 0) {
        return null;
    }
    return /*#__PURE__*/ _jsxs(ResultsRowWrapper, {
        children: [
            /*#__PURE__*/ _jsx(PageContainer, {
                flexDirection: "column",
                offsetNav: false,
                children: /*#__PURE__*/ _jsxs(ResultsRowHeader, {
                    children: [
                        /*#__PURE__*/ _jsxs(ResultsRowHeaderTitle, {
                            children: [
                                /*#__PURE__*/ _jsx(Icon, {
                                    iconColor: theme.palette.blue.main,
                                    size: 22
                                }),
                                /*#__PURE__*/ _jsx(SubtitleBold, {
                                    textColor: theme.palette.blue.main,
                                    children: title
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsx(ResultsRowHeaderSeeAll, {
                            children: showSeeAll && /*#__PURE__*/ _jsxs(_Fragment, {
                                children: [
                                    [
                                        "sm",
                                        "md",
                                        "lg",
                                        "xl"
                                    ].includes(activeBreakPoint) && /*#__PURE__*/ _jsx(Button, {
                                        buttonColor: "blueButton",
                                        icon: LongArrowSideIcons,
                                        label: "S\xfdna allar ni\xf0urst\xf6\xf0ur",
                                        stretch: true,
                                        onClick: handleClick
                                    }),
                                    [
                                        "s",
                                        "xs"
                                    ].includes(activeBreakPoint) && /*#__PURE__*/ _jsx(Button, {
                                        buttonColor: "blueButton",
                                        icon: LongArrowSideIcons,
                                        label: "Sj\xe1 allt",
                                        stretch: false,
                                        onClick: handleClick
                                    })
                                ]
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ _jsx(PageContainer, {
                flexDirection: "column",
                noGutter: true,
                offsetNav: false,
                children: /*#__PURE__*/ _jsx(ResultsRowSwiper, {
                    className: title === "S\xed\xf0ur" ? "pages" : "",
                    children: /*#__PURE__*/ _jsx(Slider, {
                        autoPad: true,
                        paginationGutter: true,
                        resetCondition: query,
                        slideCollection: sliderCollection,
                        slideWidth: VARIANT_WIDTH[variant]
                    })
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/features/search/components/overview-page/index.tsx







function SearchOverview(param) {
    let { query , pages , isLoading  } = param;
    const notFound = !pages.length;
    if (isLoading) {
        return /*#__PURE__*/ _jsx(_Fragment, {});
    }
    if (notFound) {
        return /*#__PURE__*/ _jsx(Container, {
            children: /*#__PURE__*/ _jsx(ResultRows, {
                children: /*#__PURE__*/ _jsxs(NothingFoundContainer, {
                    children: [
                        /*#__PURE__*/ _jsx(PMedium, {
                            children: "Ekkert fannst"
                        }),
                        /*#__PURE__*/ _jsx(DesktopOnly, {
                            children: /*#__PURE__*/ _jsx(AfreidslaIllustration, {
                                size: 468
                            })
                        }),
                        /*#__PURE__*/ _jsx(MobileOnly, {
                            children: /*#__PURE__*/ _jsx(AfreidslaIllustration, {
                                size: 300
                            })
                        })
                    ]
                })
            })
        });
    }
    return /*#__PURE__*/ _jsx(Container, {
        children: /*#__PURE__*/ _jsx(ResultRows, {
            children: /*#__PURE__*/ _jsx(ResultsRow, {
                hideShowAll: true,
                icon: PagesIcons,
                query: query,
                sliderCollection: pages,
                title: "S\xed\xf0ur",
                variant: "pages"
            })
        })
    });
}

// EXTERNAL MODULE: ../../.yarn/__virtual__/next-virtual-cff1f1d108/0/cache/next-npm-13.0.0-0d765f7d5e-7b5c847287.zip/node_modules/next/link.js
var next_link = __webpack_require__(58804);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ../../.yarn/__virtual__/usehooks-ts-virtual-e376d4cf26/0/cache/usehooks-ts-npm-2.9.1-14c625587f-36f1e4142c.zip/node_modules/usehooks-ts/dist/esm/index.js + 36 modules
var esm = __webpack_require__(78420);
// EXTERNAL MODULE: ../../.yarn/__virtual__/react-use-virtual-6cd4a83c3e/0/cache/react-use-npm-17.4.0-0ef4521544-0889da919b.zip/node_modules/react-use/esm/useThrottle.js + 1 modules
var useThrottle = __webpack_require__(78159);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-lib-analytics-virtual-863cade9f6/1/packages/lib-analytics/src/index.ts + 2 modules
var lib_analytics_src = __webpack_require__(57910);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-lib-api-price-virtual-284954a275/1/packages/lib-api-price/src/index.ts + 2 modules
var lib_api_price_src = __webpack_require__(62681);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-lib-api-dato-client-virtual-fc2b9374fc/1/packages/lib-api-dato-client/src/index.ts + 45 modules
var lib_api_dato_client_src = __webpack_require__(42039);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-lib-algolia-virtual-7767b18cc0/1/packages/lib-algolia/src/index.ts + 7 modules
var lib_algolia_src = __webpack_require__(5283);
;// CONCATENATED MODULE: ./src/features/search/components/quick-search/styles.ts
function quick_search_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function quick_search_styles_templateObject() {
    const data = quick_search_styles_taggedTemplateLiteral([
        "\n  position: fixed;\n  z-index: 501;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  backdrop-filter: blur(4px) grayscale(0.4);\n"
    ]);
    quick_search_styles_templateObject = function() {
        return data;
    };
    return data;
}
function quick_search_styles_templateObject1() {
    const data = quick_search_styles_taggedTemplateLiteral([
        "\n  position: relative;\n  height: 100%;\n  background-color: red;\n"
    ]);
    quick_search_styles_templateObject1 = function() {
        return data;
    };
    return data;
}
function quick_search_styles_templateObject2() {
    const data = quick_search_styles_taggedTemplateLiteral([
        "\n  position: fixed;\n  z-index: 502;\n  top: 88px;\n  left: 392px;\n  display: flex;\n  width: 819px;\n  max-height: calc(100dvh - 110px);\n  flex-direction: column;\n  border-right: 1px solid ",
        ";\n  border-bottom: 1px solid ",
        ";\n  border-left: 1px solid ",
        ";\n  background-color: ",
        ";\n  overflow-y: auto;\n  padding-block: 16px;\n  padding-inline: 32px;\n  @media screen and (max-width: 1220px) {\n    width: calc(100vw - 392px);\n  }\n  @media screen and (max-width: 1078px) {\n    left: 0px;\n    width: 100%;\n    margin-top: 24px;\n  }\n\n  &.full-width {\n    z-index: 999999;\n    left: 0;\n    width: 100%;\n    max-height: calc(100dvh - 210px);\n    padding: 16px;\n  }\n"
    ]);
    quick_search_styles_templateObject2 = function() {
        return data;
    };
    return data;
}
function quick_search_styles_templateObject3() {
    const data = quick_search_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n"
    ]);
    quick_search_styles_templateObject3 = function() {
        return data;
    };
    return data;
}
function quick_search_styles_templateObject4() {
    const data = quick_search_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  width: 2px;\n  flex-grow: 1;\n  margin-top: 48px;\n  background-color: ",
        ";\n"
    ]);
    quick_search_styles_templateObject4 = function() {
        return data;
    };
    return data;
}
function quick_search_styles_templateObject5() {
    const data = quick_search_styles_taggedTemplateLiteral([
        "\n  padding-top: 6px;\n  background-color: ",
        ";\n  padding-inline: 8px;\n"
    ]);
    quick_search_styles_templateObject5 = function() {
        return data;
    };
    return data;
}
function quick_search_styles_templateObject6() {
    const data = quick_search_styles_taggedTemplateLiteral([
        "\n  display: grid;\n  width: 100%;\n  height: 100%;\n  gap: 20px;\n  grid-template-columns: 1fr 1fr 1fr;\n  .opening-hours-card {\n    &:last-child {\n      min-width: 100%;\n    }\n  }\n  @media screen and (max-width: 1500px) {\n    grid-template-columns: 1fr 1fr;\n  }\n  @media screen and (max-width: 768px) {\n    grid-template-columns: 1fr;\n  }\n"
    ]);
    quick_search_styles_templateObject6 = function() {
        return data;
    };
    return data;
}
function quick_search_styles_templateObject7() {
    const data = quick_search_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding-right: 11px;\n  padding-block: 8px;\n  img {\n    object-fit: contain;\n  }\n"
    ]);
    quick_search_styles_templateObject7 = function() {
        return data;
    };
    return data;
}
function quick_search_styles_templateObject8() {
    const data = quick_search_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  height: 40px;\n  flex-direction: column;\n  justify-content: center;\n  gap: 8px;\n"
    ]);
    quick_search_styles_templateObject8 = function() {
        return data;
    };
    return data;
}
function quick_search_styles_templateObject9() {
    const data = quick_search_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  padding-right: 48px;\n  padding-bottom: 11px;\n  gap: 8px;\n"
    ]);
    quick_search_styles_templateObject9 = function() {
        return data;
    };
    return data;
}
function quick_search_styles_templateObject10() {
    const data = quick_search_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 11px;\n"
    ]);
    quick_search_styles_templateObject10 = function() {
        return data;
    };
    return data;
}
function quick_search_styles_templateObject11() {
    const data = quick_search_styles_taggedTemplateLiteral([
        "\n  color: ",
        ";\n  font-size: 16px;\n  user-select: none;\n"
    ]);
    quick_search_styles_templateObject11 = function() {
        return data;
    };
    return data;
}
function styles_templateObject12() {
    const data = quick_search_styles_taggedTemplateLiteral([
        "\n  color: ",
        ";\n  font-size: 14px;\n  user-select: none;\n"
    ]);
    styles_templateObject12 = function() {
        return data;
    };
    return data;
}
function styles_templateObject13() {
    const data = quick_search_styles_taggedTemplateLiteral([
        "\n  margin: 0;\n  color: ",
        ";\n  font-size: 14px;\n  user-select: none;\n"
    ]);
    styles_templateObject13 = function() {
        return data;
    };
    return data;
}
function styles_templateObject14() {
    const data = quick_search_styles_taggedTemplateLiteral([
        "\n  position: relative;\n  display: flex;\n  border-bottom: 1px solid ",
        ";\n  transition: 300ms;\n  &:hover {\n    border-bottom: 1px solid ",
        ";\n    cursor: pointer;\n  }\n"
    ]);
    styles_templateObject14 = function() {
        return data;
    };
    return data;
}
function styles_templateObject15() {
    const data = quick_search_styles_taggedTemplateLiteral([
        "\n  position: absolute;\n  right: 24px;\n  display: flex;\n  height: 100%;\n  align-items: center;\n"
    ]);
    styles_templateObject15 = function() {
        return data;
    };
    return data;
}


const Overlay = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-8fb5a4fb-0"
})(quick_search_styles_templateObject());
const QuickSearchWrapper = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-8fb5a4fb-1"
})(quick_search_styles_templateObject1());
const QuickSearchContainer = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-8fb5a4fb-2"
})(quick_search_styles_templateObject2(), lib_styles_src/* theme.palette.gray.10 */.rS.palette.gray[10], lib_styles_src/* theme.palette.gray.10 */.rS.palette.gray[10], lib_styles_src/* theme.palette.gray.10 */.rS.palette.gray[10], lib_styles_src/* theme.palette.white.main */.rS.palette.white.main);
const Section = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-8fb5a4fb-3"
})(quick_search_styles_templateObject3());
const SectionDivider = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-8fb5a4fb-4"
})(quick_search_styles_templateObject4(), lib_styles_src/* theme.palette.gray.5 */.rS.palette.gray[5]);
const Heading = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-8fb5a4fb-5"
})(quick_search_styles_templateObject5(), lib_styles_src/* theme.palette.gray.5 */.rS.palette.gray[5]);
const CardWrapper = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-8fb5a4fb-6"
})(quick_search_styles_templateObject6());
const ImageContainer = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-8fb5a4fb-7"
})(quick_search_styles_templateObject7());
const SimpleListItem = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-8fb5a4fb-8"
})(quick_search_styles_templateObject8());
const ProductItem = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-8fb5a4fb-9"
})(quick_search_styles_templateObject9());
const ProductListContainer = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-8fb5a4fb-10"
})(quick_search_styles_templateObject10());
const styles_Text = styled_components_browser_cjs["default"].p.withConfig({
    componentId: "sc-8fb5a4fb-11"
})(quick_search_styles_templateObject11(), lib_styles_src/* theme.palette.blue.dark */.rS.palette.blue.dark);
const ProductPrice = styled_components_browser_cjs["default"].p.withConfig({
    componentId: "sc-8fb5a4fb-12"
})(styles_templateObject12(), lib_styles_src/* theme.palette.gray.50 */.rS.palette.gray[50]);
const ProductPriceLabel = styled_components_browser_cjs["default"].p.withConfig({
    componentId: "sc-8fb5a4fb-13"
})(styles_templateObject13(), lib_styles_src/* theme.palette.gray.50 */.rS.palette.gray[50]);
const ItemContainer = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-8fb5a4fb-14"
})(styles_templateObject14(), lib_styles_src/* theme.palette.gray.10 */.rS.palette.gray[10], lib_styles_src/* theme.palette.blue.main */.rS.palette.blue.main);
const IconContainer = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-8fb5a4fb-15"
})(styles_templateObject15());

// EXTERNAL MODULE: ./src/features/search-provider/index.tsx
var search_provider = __webpack_require__(18240);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-component-opening-hour-card-virtual-3bb15a4b9e/1/packages/component-opening-hour-card/src/index.ts + 2 modules
var component_opening_hour_card_src = __webpack_require__(15066);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-hooks-auth-next-virtual-a089da2ab7/1/packages/hooks-auth-next/src/index.ts + 14 modules
var hooks_auth_next_src = __webpack_require__(68814);
;// CONCATENATED MODULE: ./src/features/search/components/quick-search/index.tsx
/* eslint-disable @next/next/no-img-element */ /* eslint-disable react-perf/jsx-no-new-object-as-prop */ 
















const PLACEHOLDER_IMAGE = "https://www.datocms-assets.com/65892/1664464657-placeholder-do-not-remove.jpg";
const openingHoursQueries = [
    "opn",
    "opnu",
    "opnun",
    "opnuna",
    "opnunar",
    "opnunart",
    "opnunart\xed",
    "opnunarti",
    "opnunart\xedm",
    "opnunartim",
    "opnunart\xedmi",
    "opnunartimi",
    "opnunart\xedma",
    "opnunartima",
    "opnunartimar",
    "opnunart\xedmar",
    "afgrei\xf0slut\xedmi",
    "afgrei\xf0slut\xedma",
    "afgrei\xf0slutimar",
    "afgrei\xf0slut\xedmar",
    "afgreidslutimar",
    "breidd",
    "timburverslun",
    "lagnaverslun",
    "grandi",
    "akureyri",
    "selfoss",
    "su\xf0urnes",
    "sudurnes",
    "fagverslun",
    "leiga og fagverslun",
    "bakkinn",
    "voruhus",
    "voruh\xfas",
    "v\xf6ruh\xfas",
    "v\xf6ruhus",
    "skemmuvegi",
    "skemmuvegur",
    "fiskislod",
    "fiskisl\xf3\xf0",
    "s\xf6luf\xf3lk",
    "solufolk",
    "verslun",
    "verslanir",
    "selhella",
    "selhellu",
    "v\xf6ruh\xf3tel",
    "voruh\xf3tel",
    "v\xf6ruhotel",
    "voruhotel",
    "gr\xf3fv\xf6rulager",
    "grofvorulager"
];
const specifycOpeningHoursQueries = [
    "breidd",
    "timburverslun",
    "lagnaverslun",
    "grandi",
    "akureyri",
    "selfoss",
    "su\xf0urnes",
    "sudurnes",
    "fagverslun",
    "leiga og fagverslun",
    "bakkinn",
    "skemmuvegi",
    "skemmuvegur",
    "fiskislod",
    "fiskisl\xf3\xf0",
    "selhella",
    "v\xf6ruh\xf3tel",
    "voruh\xf3tel",
    "v\xf6ruhotel",
    "voruhotel",
    "gr\xf3fv\xf6rulager",
    "grofvorulager"
];
const ListProduct = (param)=>{
    let { product , listIndex , parameters , userHasContract  } = param;
    var ref;
    const setShowQuickSearch = (0,search_provider/* useSetShowQuickSearchResultsValue */.BW)();
    const { sendClickInsights  } = (0,lib_algolia_src/* useAlgoliaInsights */.HX)();
    var _salesAvailability;
    const salesAvailability = (_salesAvailability = product.salesAvailability) !== null && _salesAvailability !== void 0 ? _salesAvailability : "standard";
    /*
    "rental": rental products, not sold on web, no price display
    "custom": custom order, not sold on the web, no price display
    "limited": limited availability, not sold on the web, show price info
    "display": display only, not sold on the web, no price display
    "standard": standard products, display as is
  */ const isRentProduct = (0,react.useMemo)(()=>{
        try {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            return product.attributes.typeParent.includes("Leigumarka\xf0ur");
        } catch (e) {
            return false;
        }
    }, [
        product
    ]);
    const lowestPrice = (0,react.useMemo)(()=>{
        var ref;
        let price = 0;
        let hasVariationPrices = false;
        let hidePrice = false;
        let hidePriceLabel = false;
        if (isRentProduct || salesAvailability === "display" || salesAvailability === "custom") {
            return {
                availableSoon: false,
                hidePrice: true,
                isRentProduct,
                price: "N/A",
                label: "S\xe9rp\xf6ntun"
            };
        }
        product.variants.forEach((variant)=>{
            if (variant.price.gross != null) {
                if (price === 0 || variant.price.gross < price) {
                    price = variant.price.gross;
                }
                if (price !== 0 && variant.price.gross !== price) {
                    hasVariationPrices = true;
                }
            }
        });
        if (salesAvailability === "by_contract" && !userHasContract) {
            hidePrice = true;
            hidePriceLabel = true;
        }
        return {
            availableSoon: price === 0,
            isRentProduct,
            hidePrice,
            hidePriceLabel,
            price: (ref = (0,lib_api_price_src/* getPrice */.aS)(price)) === null || ref === void 0 ? void 0 : ref.humanReadable,
            label: hasVariationPrices ? "Ver\xf0 fr\xe1" : "Ver\xf0"
        };
    }, [
        isRentProduct,
        product.variants,
        salesAvailability
    ]);
    const handleClick = (0,react.useCallback)(()=>{
        setShowQuickSearch(false);
        var _price;
        lib_analytics_src/* analytics.addProductListClick */.c.addProductListClick(product, (_price = lowestPrice.price) !== null && _price !== void 0 ? _price : "", listIndex, "quick-search-results");
        sendClickInsights({
            eventName: "Click Product Quick Search",
            index: (parameters === null || parameters === void 0 ? void 0 : parameters.index) || "",
            queryID: (parameters === null || parameters === void 0 ? void 0 : parameters.queryID) || "",
            objectIDs: [
                product.id.toString() || ""
            ],
            positions: [
                parameters === null || parameters === void 0 ? void 0 : parameters.position
            ]
        });
    }, [
        listIndex,
        lowestPrice.price,
        product,
        parameters,
        setShowQuickSearch,
        sendClickInsights
    ]);
    const href = (0,react.useMemo)(()=>{
        if (isRentProduct) {
            return "/leiguvara/".concat(product.slug);
        }
        return "/vara/".concat(product.slug);
    }, [
        isRentProduct,
        product.slug
    ]);
    var _productList;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: href,
        passHref: true,
        onClick: handleClick,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ItemContainer, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageContainer, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        alt: product.name,
                        height: 54,
                        src: (_productList = (ref = product.firstImage) === null || ref === void 0 ? void 0 : ref.image.productList) !== null && _productList !== void 0 ? _productList : PLACEHOLDER_IMAGE,
                        width: 66
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(ProductItem, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_Text, {
                            children: product.name
                        }),
                        lowestPrice.isRentProduct && lowestPrice.hidePrice && !lowestPrice.availableSoon && /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductPrice, {
                            children: "Leiguvara"
                        }),
                        !lowestPrice.isRentProduct && !lowestPrice.hidePrice && lowestPrice.availableSoon && /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductPrice, {
                            children: "Vara v\xe6ntanleg"
                        }),
                        !lowestPrice.isRentProduct && !lowestPrice.hidePrice && !lowestPrice.availableSoon && /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductPrice, {
                            children: "".concat(lowestPrice.label, ": ").concat(lowestPrice.price)
                        }),
                        !lowestPrice.isRentProduct && lowestPrice.hidePrice && !lowestPrice.availableSoon && !lowestPrice.hidePriceLabel && /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductPrice, {
                            children: "".concat(lowestPrice.label)
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(IconContainer, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lib_icons_src.ArrowRightIcons, {
                        iconColor: lib_styles_src/* theme.palette.gray.30 */.rS.palette.gray[30],
                        size: 16
                    })
                })
            ]
        })
    });
};
const ListPage = (param)=>{
    let { page , parameters  } = param;
    const { sendClickInsights  } = (0,lib_algolia_src/* useAlgoliaInsights */.HX)();
    const handleClick = (0,react.useCallback)(()=>{
        sendClickInsights({
            eventName: "Click Content Quick Search",
            index: (parameters === null || parameters === void 0 ? void 0 : parameters.index) || "",
            queryID: (parameters === null || parameters === void 0 ? void 0 : parameters.queryID) || "",
            objectIDs: [
                page.objectID
            ],
            positions: [
                parameters.position
            ]
        });
    }, [
        page,
        parameters,
        sendClickInsights
    ]);
    const absoluteSlug = page.slug[0] === "/" ? page.slug : "/".concat(page.slug);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: absoluteSlug,
        passHref: true,
        onClick: handleClick,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ItemContainer, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(SimpleListItem, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_Text, {
                        children: page.title
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(IconContainer, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lib_icons_src.ArrowRightIcons, {
                        iconColor: lib_styles_src/* theme.palette.gray.30 */.rS.palette.gray[30],
                        size: 16
                    })
                })
            ]
        })
    });
};
const ListEmployee = (param)=>{
    let { employee , parameters  } = param;
    const { sendClickInsights  } = (0,lib_algolia_src/* useAlgoliaInsights */.HX)();
    const handleClick = (0,react.useCallback)(()=>{
        sendClickInsights({
            eventName: "Click Employee Quick Search",
            index: (parameters === null || parameters === void 0 ? void 0 : parameters.index) || "",
            queryID: (parameters === null || parameters === void 0 ? void 0 : parameters.queryID) || "",
            objectIDs: [
                employee.objectID
            ],
            positions: [
                parameters.position
            ]
        });
    }, [
        employee,
        parameters,
        sendClickInsights
    ]);
    const absoluteSlug = "/thjonusta/mannaudur/starfsfolk?employee=".concat(employee.name);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: absoluteSlug,
        passHref: true,
        onClick: handleClick,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ItemContainer, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(SimpleListItem, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_Text, {
                        children: employee.name
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(IconContainer, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lib_icons_src.ArrowRightIcons, {
                        iconColor: lib_styles_src/* theme.palette.gray.30 */.rS.palette.gray[30],
                        size: 16
                    })
                })
            ]
        })
    });
};
const QuickSearchResults = ()=>{
    var ref, ref1, ref2;
    const quickSearchRef = (0,react.useRef)(null);
    const { user , activeMembership  } = (0,hooks_auth_next_src/* useAuth */.aC)();
    const { data: openingHours  } = (0,lib_api_dato_client_src/* useOpeningHours */.DS)({});
    const { data  } = (0,lib_api_dato_client_src/* useMegaMenuData */.VT)();
    const searchValue = (0,search_provider/* useSearchValue */.Wp)();
    const setShowQuickSearch = (0,search_provider/* useSetShowQuickSearchResultsValue */.BW)();
    const showQuickSearch = (0,search_provider/* useShowQuickSearchResultsValue */.Wr)();
    const searchBarHasFocus = (0,search_provider/* useSearchBarHasFocusStore */.Nq)();
    const query = (0,useThrottle/* default */.Z)(searchValue, 1000);
    const { data: multiSearch  } = (0,api/* useAlgoliaMultiQuery */.yy)({
        query,
        pageSize: 5
    });
    const productQuery = multiSearch === null || multiSearch === void 0 ? void 0 : (ref = multiSearch.results) === null || ref === void 0 ? void 0 : ref[0];
    const contentQuery = multiSearch === null || multiSearch === void 0 ? void 0 : (ref1 = multiSearch.results) === null || ref1 === void 0 ? void 0 : ref1[1];
    const employeeQuery = multiSearch === null || multiSearch === void 0 ? void 0 : (ref2 = multiSearch.results) === null || ref2 === void 0 ? void 0 : ref2[2];
    const employeeHitsToDisplay = (employeeQuery === null || employeeQuery === void 0 ? void 0 : employeeQuery.hits.length) > 5 ? employeeQuery === null || employeeQuery === void 0 ? void 0 : employeeQuery.hits.slice(0, 5) : employeeQuery === null || employeeQuery === void 0 ? void 0 : employeeQuery.hits;
    const contentPages = (0,react.useMemo)(()=>{
        const collection = [];
        if (data) {
            var ref, ref1, ref2, ref3, ref4;
            var ref5;
            const adviceCollection = (ref5 = (ref = data.find((a)=>a.slug === "god-rad")) === null || ref === void 0 ? void 0 : ref.children) !== null && ref5 !== void 0 ? ref5 : [];
            var ref6;
            const specialService = (ref6 = (ref1 = data.find((a)=>a.slug === "serlausnir")) === null || ref1 === void 0 ? void 0 : ref1.children) !== null && ref6 !== void 0 ? ref6 : [];
            var ref7;
            const service = (ref7 = (ref2 = data.find((a)=>a.slug === "thjonusta")) === null || ref2 === void 0 ? void 0 : ref2.children) !== null && ref7 !== void 0 ? ref7 : [];
            var ref8;
            (ref8 = !!(contentQuery === null || contentQuery === void 0 ? void 0 : (ref3 = contentQuery.hits) === null || ref3 === void 0 ? void 0 : ref3.length) && (contentQuery === null || contentQuery === void 0 ? void 0 : (ref4 = contentQuery.hits) === null || ref4 === void 0 ? void 0 : ref4.forEach((article)=>{
                let matchingArticle;
                [
                    ...adviceCollection,
                    ...service,
                    ...specialService
                ].forEach((levelOneItem)=>{
                    if (article.slug === levelOneItem.slug && levelOneItem.children.length === 0) {
                        matchingArticle = levelOneItem;
                    } else {
                        levelOneItem.children.forEach((levelTwoItem)=>{
                            if (article.slug === levelTwoItem.slug && levelTwoItem.children.length === 0) {
                                matchingArticle = levelTwoItem;
                            } else {
                                levelTwoItem.children.forEach((levelThreeItem)=>{
                                    if (article.slug === levelThreeItem.slug && levelThreeItem.children.length === 0) {
                                        matchingArticle = levelThreeItem;
                                    }
                                });
                            }
                        });
                    }
                });
                if (matchingArticle == undefined || (matchingArticle === null || matchingArticle === void 0 ? void 0 : matchingArticle.url) == undefined) {
                    return;
                }
                if (collection.length === 5) {
                    return;
                }
                collection.push({
                    ...article,
                    slug: matchingArticle === null || matchingArticle === void 0 ? void 0 : matchingArticle.url
                });
            }))) !== null && ref8 !== void 0 ? ref8 : [];
        }
        return collection;
    }, [
        data,
        contentQuery === null || contentQuery === void 0 ? void 0 : contentQuery.hits
    ]);
    const closeMenu = (0,react.useCallback)(()=>{
        setShowQuickSearch(false);
    }, [
        setShowQuickSearch
    ]);
    (0,esm/* useOnClickOutside */.t$)(quickSearchRef, closeMenu);
    const isOpeningHoursQuery = (0,react.useMemo)(()=>{
        const normalizedQuery = normalizeString(query);
        const foundOpeningHoursQuery = openingHoursQueries.find((opening)=>{
            const norm = normalizeString(opening);
            return normalizedQuery === norm;
        });
        return foundOpeningHoursQuery != undefined;
    }, [
        query
    ]);
    const filteredOpeningHours = (0,react.useMemo)(()=>{
        const normalizedQuery = normalizeString(query);
        const foundSpecificQuery = specifycOpeningHoursQueries.find((specific)=>{
            const norm = normalizeString(specific);
            return normalizedQuery === norm;
        });
        if (normalizedQuery === "" || foundSpecificQuery == undefined) {
            return openingHours;
        }
        const filteredLocation = openingHours.location.filter((location)=>{
            const normalizedLocationName = normalizeString(location.locationName);
            const normalizedLocationAddress = normalizeString(location.locationAddress);
            const normalizedLocationType = normalizeString(location.locationType);
            return normalizedLocationName.includes(normalizedQuery) || normalizedLocationAddress.includes(normalizedQuery) || normalizedLocationType.includes(normalizedQuery);
        });
        return {
            ...openingHours,
            location: filteredLocation
        };
    }, [
        openingHours,
        query
    ]);
    (0,react.useEffect)(()=>{
        if (searchValue === "") {
            setBodyScroll(true);
        } else {
            setBodyScroll(!showQuickSearch);
        }
    }, [
        showQuickSearch,
        searchValue
    ]);
    const enableBodyScroll = (0,react.useCallback)(()=>{
        setShowQuickSearch(false);
    }, [
        setShowQuickSearch
    ]);
    if (showQuickSearch === false && searchBarHasFocus === false || searchValue === "") {
        return null;
    }
    if (isOpeningHoursQuery && openingHours) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Overlay, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(QuickSearchWrapper, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(QuickSearchContainer, {
                        ref: quickSearchRef,
                        className: "full-width",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Section, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: "/thjonusta/um-byko/verslanir",
                                        passHref: true,
                                        onClick: enableBodyScroll,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(component_typography_src/* PMediumBold */.zo, {
                                            textColor: lib_styles_src/* theme.palette.blue.dark */.rS.palette.blue.dark,
                                            children: [
                                                "Verslanir og afgrei\xf0slut\xedmi ",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(lib_icons_src.LongArrowSideIcons, {
                                                    iconColor: lib_styles_src/* theme.palette.blue.main */.rS.palette.blue.main,
                                                    size: 16
                                                })
                                            ]
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CardWrapper, {
                                        children: filteredOpeningHours.location.map((location)=>{
                                            return location.openingHours.map((hours)=>{
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(component_opening_hour_card_src/* OpeningHourCard */.P, {
                                                    id: hours.id,
                                                    openingTime: hours.hours,
                                                    storeLocation: location.locationAddress,
                                                    storeName: location.locationName,
                                                    storeType: location.locationType
                                                }, hours.id);
                                            });
                                        })
                                    })
                                })
                            ]
                        })
                    })
                })
            ]
        });
    }
    if (searchValue !== "" && ((productQuery === null || productQuery === void 0 ? void 0 : productQuery.hits.length) === 0 || productQuery == undefined) && contentPages.length === 0 && !(employeeHitsToDisplay === null || employeeHitsToDisplay === void 0 ? void 0 : employeeHitsToDisplay.length)) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(QuickSearchWrapper, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(QuickSearchContainer, {
                ref: quickSearchRef,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Section, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(component_typography_src/* PMediumBold */.zo, {
                            textColor: lib_styles_src/* theme.palette.blue.dark */.rS.palette.blue.dark,
                            children: "Ekkert fannst"
                        })
                    })
                })
            })
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(QuickSearchWrapper, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(QuickSearchContainer, {
            ref: quickSearchRef,
            children: [
                productQuery && (productQuery === null || productQuery === void 0 ? void 0 : productQuery.hits.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Section, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(component_typography_src/* PMediumBold */.zo, {
                                textColor: lib_styles_src/* theme.palette.blue.dark */.rS.palette.blue.dark,
                                children: "V\xd6RUR"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductListContainer, {
                            children: productQuery.hits.map((product, index)=>{
                                /*#__PURE__*/ return (0,jsx_runtime.jsx)(ListProduct, {
                                    listIndex: index + 1,
                                    parameters: {
                                        index: productQuery === null || productQuery === void 0 ? void 0 : productQuery.index,
                                        queryID: productQuery === null || productQuery === void 0 ? void 0 : productQuery.queryID,
                                        position: index + 1
                                    },
                                    product: product,
                                    userHasContract: !!(user && (activeMembership === null || activeMembership === void 0 ? void 0 : activeMembership.account.hasContract))
                                }, product.id);
                            })
                        })
                    ]
                }),
                contentPages.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        !!(productQuery === null || productQuery === void 0 ? void 0 : productQuery.hits.length) && /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionDivider, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Section, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(component_typography_src/* PMediumBold */.zo, {
                                        textColor: lib_styles_src/* theme.palette.blue.dark */.rS.palette.blue.dark,
                                        children: "S\xcd\xd0UR"
                                    })
                                }),
                                contentPages.map((page, index)=>{
                                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(ListPage, {
                                        page: page,
                                        parameters: {
                                            index: contentQuery === null || contentQuery === void 0 ? void 0 : contentQuery.index,
                                            queryID: contentQuery === null || contentQuery === void 0 ? void 0 : contentQuery.queryID,
                                            position: index + 1
                                        }
                                    }, page.objectID);
                                })
                            ]
                        })
                    ]
                }),
                !!(employeeHitsToDisplay === null || employeeHitsToDisplay === void 0 ? void 0 : employeeHitsToDisplay.length) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        (!!(productQuery === null || productQuery === void 0 ? void 0 : productQuery.hits.length) || !!contentPages.length) && /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionDivider, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Section, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(component_typography_src/* PMediumBold */.zo, {
                                        textColor: lib_styles_src/* theme.palette.blue.dark */.rS.palette.blue.dark,
                                        children: "STARFSF\xd3LK"
                                    })
                                }),
                                employeeHitsToDisplay === null || employeeHitsToDisplay === void 0 ? void 0 : employeeHitsToDisplay.map((employee, index)=>{
                                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(ListEmployee, {
                                        employee: employee,
                                        parameters: {
                                            index: employeeQuery === null || employeeQuery === void 0 ? void 0 : employeeQuery.index,
                                            queryID: employeeQuery === null || employeeQuery === void 0 ? void 0 : employeeQuery.queryID,
                                            position: index + 1
                                        }
                                    }, employee.objectID);
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
function setBodyScroll(on) {
    if (on) {
        // Re-enable scrolling and remove the added padding.
        document.body.style.overflow = "auto";
        document.body.style.paddingRight = "";
        const HTML = document.getElementsByTagName("html");
        const NAVBAR = document.getElementById("navbar");
        const CHATBUTTON = document.getElementById("chat-button");
        if (HTML[0]) {
            HTML[0].style.overflow = "initial";
            HTML[0].style.overflowX = "hidden";
        }
        if (NAVBAR) {
            NAVBAR.style.paddingRight = "25px";
        }
        if (CHATBUTTON) {
            CHATBUTTON.style.right = "32px";
        }
    } else {
        // Disable scrolling and compensate for the scrollbar width.
        const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
        document.body.style.overflow = "hidden";
        document.body.style.paddingRight = "".concat(scrollbarWidth, "px");
        const HTML1 = document.getElementsByTagName("html");
        const NAVBAR1 = document.getElementById("navbar");
        const CHATBUTTON1 = document.getElementById("chat-button");
        if (HTML1[0]) {
            HTML1[0].style.overflow = "hidden";
        }
        if (NAVBAR1) {
            NAVBAR1.style.paddingRight = "calc(25px + ".concat(scrollbarWidth, "px)");
        }
        if (CHATBUTTON1) {
            CHATBUTTON1.style.right = "calc(32px + ".concat(scrollbarWidth, "px)");
        }
    }
}
function normalizeString(str) {
    return str.toLowerCase().trim().replace(" ", "").replace(/ó/g, "o").replace(/ö/g, "o").replace(/á/g, "a").replace(/í/g, "i").replace(/ú/g, "u").replace(/é/g, "e").replace(/ð/g, "d").replace(/þ/g, "th").replace(/æ/g, "ae").replace(/[^a-zA-Z0-9]/g, "");
}

// EXTERNAL MODULE: ./src/features/search/components/filter-header.tsx
var filter_header = __webpack_require__(67077);
// EXTERNAL MODULE: ./src/features/search/components/pagination-menu.tsx
var pagination_menu = __webpack_require__(22772);
// EXTERNAL MODULE: ./src/features/search/components/product-search-results.tsx + 2 modules
var product_search_results = __webpack_require__(94157);
;// CONCATENATED MODULE: ./src/features/search/components/index.ts







;// CONCATENATED MODULE: ./src/features/search/index.ts





;// CONCATENATED MODULE: ./src/features/products/utils.ts

function prepareProductVariantSpecs(variant) {
    // This is slightly refactored code that is originally written by Andri
    const specs = variant.specs.map((param)=>{
        let { id , name , value , unit  } = param;
        // FIXME: The type defs for `name` and `value` seem to be wrong on the backend
        const translatedName = name;
        const translatedValue = value;
        if (translatedValue && translatedValue["is-IS"] && typeof translatedValue["is-IS"] === "string" && translatedValue["is-IS"].length) {
            return {
                id: id,
                key: translatedName["is-IS"],
                value: "".concat(translatedValue["is-IS"], " ").concat(unit)
            };
        }
        if (value && typeof value !== "object" && value.toString().length) {
            let stringValue = value.toString();
            if (stringValue === "false") {
                stringValue = "Nei";
            } else if (stringValue === "true") {
                stringValue = "J\xe1";
            }
            return {
                id: id,
                key: translatedName["is-IS"],
                value: "".concat(stringValue, " ").concat(unit)
            };
        }
        return undefined;
    });
    return (0,src/* ensureList */.fL)(specs);
}

// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-card-content-tabs-virtual-e08db396d4/1/packages/component-card-content-tabs/src/index.ts + 10 modules
var component_card_content_tabs_src = __webpack_require__(95967);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-component-product-slider-section-virtual-37024fa6cf/1/packages/component-product-slider-section/src/index.ts + 2 modules
var component_product_slider_section_src = __webpack_require__(36355);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-lib-api-products-virtual-81752d2989/1/packages/lib-api-products/src/index.ts + 130 modules
var lib_api_products_src = __webpack_require__(68825);
// EXTERNAL MODULE: ../../.yarn/cache/demoup-react-npm-0.3.0-1352729efd-10948c95cc.zip/node_modules/demoup-react/distribution/index.js
var distribution = __webpack_require__(78551);
var distribution_default = /*#__PURE__*/__webpack_require__.n(distribution);
// EXTERNAL MODULE: ./src/use-lightbox.tsx
var use_lightbox = __webpack_require__(52989);
// EXTERNAL MODULE: ../../.yarn/__virtual__/react-dom-virtual-60cbd4834f/0/cache/react-dom-npm-18.2.0-dd675bca1c-7d323310be.zip/node_modules/react-dom/index.js
var react_dom = __webpack_require__(13137);
;// CONCATENATED MODULE: ./src/features/products/components/product-page/component/modal.tsx
function modal_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function modal_templateObject() {
    const data = modal_taggedTemplateLiteral([
        "\n  position: fixed;\n  z-index: 4000;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 50px;\n  background-color: #fff;\n"
    ]);
    modal_templateObject = function() {
        return data;
    };
    return data;
}
function modal_templateObject1() {
    const data = modal_taggedTemplateLiteral([
        "\n  position: absolute;\n  top: 10px;\n  right: 10px;\n"
    ]);
    modal_templateObject1 = function() {
        return data;
    };
    return data;
}






const ModalStyle = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-a79f3c86-0"
})(modal_templateObject());
const modal_ButtonContainer = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-a79f3c86-1"
})(modal_templateObject1());
function Modal(param) {
    let { open , children , onClose  } = param;
    (0,react.useEffect)(()=>{
        const handleKeyDown = (event)=>{
            if (event.key === "Escape") {
                onClose();
            }
        };
        if (open) {
            window.addEventListener("keydown", handleKeyDown);
        }
        return ()=>{
            window.removeEventListener("keydown", handleKeyDown);
        };
    }, [
        open,
        onClose
    ]);
    if (!open) return null;
    return /*#__PURE__*/ react_dom.createPortal(/*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalStyle, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(modal_ButtonContainer, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(component_buttons_src/* IconButton */.hU, {
                        ariaLabel: "Close Modal",
                        icon: lib_icons_src.CancelLargeIcons,
                        onClick: onClose
                    })
                }),
                children
            ]
        })
    }), document.getElementById("portal"));
}

;// CONCATENATED MODULE: ./src/features/products/components/product-page/product-detail/styles.ts
function product_detail_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function product_detail_styles_templateObject() {
    const data = product_detail_styles_taggedTemplateLiteral([
        "\n  display: none;\n"
    ]);
    product_detail_styles_templateObject = function() {
        return data;
    };
    return data;
}
function product_detail_styles_templateObject1() {
    const data = product_detail_styles_taggedTemplateLiteral([
        "\n  width: 100%;\n  max-width: 544px;\n  background-color: ",
        ";\n  text-align: left;\n  transition: all 0.5s;\n"
    ]);
    product_detail_styles_templateObject1 = function() {
        return data;
    };
    return data;
}
function product_detail_styles_templateObject2() {
    const data = product_detail_styles_taggedTemplateLiteral([
        "\n  position: relative;\n  display: flex;\n  justify-content: space-between;\n  @media screen and (max-width: 920px) {\n    flex-direction: column;\n  }\n"
    ]);
    product_detail_styles_templateObject2 = function() {
        return data;
    };
    return data;
}
function product_detail_styles_templateObject3() {
    const data = product_detail_styles_taggedTemplateLiteral([
        "\n  font-weight: 700;\n  text-transform: uppercase;\n  @media screen and (max-width: ",
        "px) {\n    font-size: 14px;\n  }\n"
    ]);
    product_detail_styles_templateObject3 = function() {
        return data;
    };
    return data;
}
function product_detail_styles_templateObject4() {
    const data = product_detail_styles_taggedTemplateLiteral([
        "\n  color: ",
        ";\n  cursor: pointer;\n  text-transform: uppercase;\n\n  @media screen and (max-width: ",
        "px) {\n    font-size: 12px;\n  }\n"
    ]);
    product_detail_styles_templateObject4 = function() {
        return data;
    };
    return data;
}
function product_detail_styles_templateObject5() {
    const data = product_detail_styles_taggedTemplateLiteral([
        ""
    ]);
    product_detail_styles_templateObject5 = function() {
        return data;
    };
    return data;
}
function product_detail_styles_templateObject6() {
    const data = product_detail_styles_taggedTemplateLiteral([
        "\n  min-height: 98px;\n"
    ]);
    product_detail_styles_templateObject6 = function() {
        return data;
    };
    return data;
}
function product_detail_styles_templateObject7() {
    const data = product_detail_styles_taggedTemplateLiteral([
        "\n  color: ",
        ";\n  @media screen and (max-width: ",
        "px) {\n    font-size: 12px;\n  }\n"
    ]);
    product_detail_styles_templateObject7 = function() {
        return data;
    };
    return data;
}
function product_detail_styles_templateObject8() {
    const data = product_detail_styles_taggedTemplateLiteral([
        "\n  margin-bottom: 30px;\n  color: ",
        ";\n"
    ]);
    product_detail_styles_templateObject8 = function() {
        return data;
    };
    return data;
}
function product_detail_styles_templateObject9() {
    const data = product_detail_styles_taggedTemplateLiteral([
        "\n  margin-top: 0px;\n  color: ",
        ";\n  text-decoration: line-through;\n"
    ]);
    product_detail_styles_templateObject9 = function() {
        return data;
    };
    return data;
}
function product_detail_styles_templateObject10() {
    const data = product_detail_styles_taggedTemplateLiteral([
        "\n  color: ",
        ";\n  text-decoration: line-through;\n  @media screen and (max-width: ",
        "px) {\n    font-size: 16px;\n  }\n"
    ]);
    product_detail_styles_templateObject10 = function() {
        return data;
    };
    return data;
}
function product_detail_styles_templateObject11() {
    const data = product_detail_styles_taggedTemplateLiteral([
        "\n  margin-top: 40px;\n  font-size: 48px;\n  @media screen and (max-width: ",
        "px) {\n    margin-top: 10px;\n    font-size: 24px;\n  }\n"
    ]);
    product_detail_styles_templateObject11 = function() {
        return data;
    };
    return data;
}
function product_detail_styles_templateObject12() {
    const data = product_detail_styles_taggedTemplateLiteral([
        "\n  margin-top: 10px;\n  margin-bottom: 10px;\n  color: ",
        ";\n  @media screen and (max-width: ",
        "px) {\n    margin-top: 4px;\n    font-size: 16px;\n  }\n"
    ]);
    product_detail_styles_templateObject12 = function() {
        return data;
    };
    return data;
}
function product_detail_styles_templateObject13() {
    const data = product_detail_styles_taggedTemplateLiteral([
        "\n  ",
        "\n  overflow: hidden;\n  max-height: 210px;\n  padding: 10px 0;\n  margin-bottom: 30px;\n  color: ",
        ";\n  font-size: 18px;\n  transition: all 0.5s;\n  @media screen and (max-width: ",
        "px) {\n    border-top: none;\n  }\n\n  &.showMore {\n    overflow: visible;\n    max-height: none;\n  }\n"
    ]);
    product_detail_styles_templateObject13 = function() {
        return data;
    };
    return data;
}
function product_detail_styles_templateObject14() {
    const data = product_detail_styles_taggedTemplateLiteral([
        "\n  margin-bottom: 16px;\n"
    ]);
    product_detail_styles_templateObject14 = function() {
        return data;
    };
    return data;
}
function product_detail_styles_templateObject15() {
    const data = product_detail_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  width: 100%;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 10px;\n  @media screen and (max-width: ",
        "px) {\n    margin-bottom: 20px;\n  }\n"
    ]);
    product_detail_styles_templateObject15 = function() {
        return data;
    };
    return data;
}
function styles_templateObject16() {
    const data = product_detail_styles_taggedTemplateLiteral([
        "\n  width: 100%;\n  max-width: 544px;\n  padding: 20px 10px 10px 10px;\n  border-bottom: 1px solid ",
        ";\n  margin-top: -70px;\n  background: linear-gradient(0deg, #ffffff 43.5%, rgba(255, 255, 255, 0) 172.45%);\n  color: ",
        ";\n  font-size: 12px;\n  text-transform: uppercase;\n  svg {\n    margin-left: 10px;\n  }\n\n  &.showMore {\n    border-bottom: none;\n    margin-top: -20px;\n  }\n"
    ]);
    styles_templateObject16 = function() {
        return data;
    };
    return data;
}
function styles_templateObject17() {
    const data = product_detail_styles_taggedTemplateLiteral([
        "\n  &:before {\n    position: absolute;\n    bottom: 3px;\n    left: -16px;\n    color: ",
        ';\n    content: "=";\n  }\n  position: relative;\n  display: flex;\n  width: fit-content;\n  height: 24px;\n\n  align-items: center;\n  justify-content: center;\n  margin-left: 16px;\n  transform: translateY(-24px);\n  white-space: nowrap;\n'
    ]);
    styles_templateObject17 = function() {
        return data;
    };
    return data;
}
function styles_templateObject18() {
    const data = product_detail_styles_taggedTemplateLiteral([
        "\n  position: absolute;\n  top: 4px;\n  left: 64px;\n  &.short {\n    left: 40px;\n  }\n"
    ]);
    styles_templateObject18 = function() {
        return data;
    };
    return data;
}
function styles_templateObject19() {
    const data = product_detail_styles_taggedTemplateLiteral([
        "\n  max-height: 54px;\n  margin-top: 16px;\n"
    ]);
    styles_templateObject19 = function() {
        return data;
    };
    return data;
}
function styles_templateObject20() {
    const data = product_detail_styles_taggedTemplateLiteral([
        "\n  position: relative;\n  display: flex;\n  align-items: flex-end;\n  justify-content: evenly;\n  margin-bottom: 16px;\n  gap: 16px;\n\n  .desktop-button {\n    display: flex;\n    margin-bottom: 8px;\n  }\n  @media screen and (max-width: 1200px) {\n    .desktop-button {\n      display: none;\n    }\n  }\n"
    ]);
    styles_templateObject20 = function() {
        return data;
    };
    return data;
}
function styles_templateObject21() {
    const data = product_detail_styles_taggedTemplateLiteral([
        "\n  position: relative;\n  display: flex;\n  align-items: flex-end;\n  justify-content: evenly;\n  margin-bottom: 48px;\n  gap: 16px;\n\n  @media screen and (max-width: 1200px) {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 8px;\n  }\n\n  .mobile-button {\n    display: none;\n  }\n  @media screen and (max-width: 1200px) {\n    .mobile-button {\n      display: flex;\n    }\n  }\n"
    ]);
    styles_templateObject21 = function() {
        return data;
    };
    return data;
}
function _templateObject22() {
    const data = product_detail_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  gap: 16px;\n  @media screen and (max-width: ",
        "px) {\n    flex-direction: column;\n    gap: 8px;\n  }\n"
    ]);
    _templateObject22 = function() {
        return data;
    };
    return data;
}
function _templateObject23() {
    const data = product_detail_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n"
    ]);
    _templateObject23 = function() {
        return data;
    };
    return data;
}
function _templateObject24() {
    const data = product_detail_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  gap: 16px;\n  @media screen and (max-width: ",
        "px) {\n    gap: 8px;\n  }\n"
    ]);
    _templateObject24 = function() {
        return data;
    };
    return data;
}
function _templateObject25() {
    const data = product_detail_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-end;\n  margin-top: 16px;\n  gap: 16px;\n  &.limited-detail {\n    justify-content: flex-start;\n  }\n  .select-container {\n    max-width: calc(50% - 8px);\n    border: 1px solid ",
        ";\n  }\n  .button-container {\n    max-width: calc(50% - 8px);\n  }\n  @media screen and (max-width: 968px) {\n    flex-direction: column;\n    margin-top: 8px;\n    gap: 8px;\n    .select-container {\n      width: 100%;\n      max-width: unset;\n    }\n    .button-container {\n      width: 100%;\n      max-width: unset;\n    }\n  }\n"
    ]);
    _templateObject25 = function() {
        return data;
    };
    return data;
}
function _templateObject26() {
    const data = product_detail_styles_taggedTemplateLiteral([
        "\n  margin-top: 24px;\n"
    ]);
    _templateObject26 = function() {
        return data;
    };
    return data;
}
function _templateObject27() {
    const data = product_detail_styles_taggedTemplateLiteral([
        "\n  display: grid;\n  padding-bottom: 16px;\n  &.border-bottom {\n    border-bottom: 1px solid ",
        ";\n  }\n  margin-bottom: 16px;\n  column-gap: 16px;\n  grid-template-columns: 114px 1fr;\n"
    ]);
    _templateObject27 = function() {
        return data;
    };
    return data;
}
function _templateObject28() {
    const data = product_detail_styles_taggedTemplateLiteral([
        ""
    ]);
    _templateObject28 = function() {
        return data;
    };
    return data;
}
function _templateObject29() {
    const data = product_detail_styles_taggedTemplateLiteral([
        ""
    ]);
    _templateObject29 = function() {
        return data;
    };
    return data;
}
function _templateObject30() {
    const data = product_detail_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-wrap: wrap;\n  column-gap: 8px;\n  row-gap: 16px;\n"
    ]);
    _templateObject30 = function() {
        return data;
    };
    return data;
}
function _templateObject31() {
    const data = product_detail_styles_taggedTemplateLiteral([
        "\n  position: relative;\n  padding-right: 8px;\n  @media screen and (min-width: 453px) {\n    &:after {\n      position: absolute;\n      top: 0;\n      right: 0;\n      width: 1px;\n      height: 100%;\n      background-color: ",
        ';\n      content: "";\n    }\n  }\n'
    ]);
    _templateObject31 = function() {
        return data;
    };
    return data;
}
function _templateObject32() {
    const data = product_detail_styles_taggedTemplateLiteral([
        "\n  display: inline-flex;\n  width: 100%;\n  box-sizing: border-box;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  border: 1px solid #ffffff;\n  gap: 10px;\n  text-align: left;\n"
    ]);
    _templateObject32 = function() {
        return data;
    };
    return data;
}
function _templateObject33() {
    const data = product_detail_styles_taggedTemplateLiteral([
        "\n  margin-bottom: 32px;\n"
    ]);
    _templateObject33 = function() {
        return data;
    };
    return data;
}



const HiddenAttribute = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-ecdc9d29-0"
})(product_detail_styles_templateObject());
const ProductDetailContainer = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-ecdc9d29-1"
})(product_detail_styles_templateObject1(), lib_styles_src/* theme.palette.white.main */.rS.palette.white.main);
const FlexRow = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-ecdc9d29-2"
})(product_detail_styles_templateObject2());
const Brand = (0,styled_components_browser_cjs["default"])(component_typography_src/* EyebrowLarge */.Gp).withConfig({
    componentId: "sc-ecdc9d29-3"
})(product_detail_styles_templateObject3(), lib_styles_src/* gridTheme.container.maxWidth.s */.k.container.maxWidth.s);
const SkuNumber = (0,styled_components_browser_cjs["default"])(component_typography_src/* EyebrowMedium */.Bz).withConfig({
    componentId: "sc-ecdc9d29-4"
})(product_detail_styles_templateObject4(), lib_styles_src/* theme.palette.blue.dark */.rS.palette.blue.dark, lib_styles_src/* gridTheme.container.maxWidth.s */.k.container.maxWidth.s);
const LoadingWrapper = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-ecdc9d29-5"
})(product_detail_styles_templateObject5());
const PriceContainer = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-ecdc9d29-6"
})(product_detail_styles_templateObject6());
const PriceText = (0,styled_components_browser_cjs["default"])(component_typography_src/* EyebrowLarge */.Gp).withConfig({
    componentId: "sc-ecdc9d29-7"
})(product_detail_styles_templateObject7(), lib_styles_src/* theme.palette.gray.50 */.rS.palette.gray[50], lib_styles_src/* gridTheme.container.maxWidth.s */.k.container.maxWidth.s);
const Price = (0,styled_components_browser_cjs["default"])(component_typography_src.H6).withConfig({
    componentId: "sc-ecdc9d29-8"
})(product_detail_styles_templateObject8(), lib_styles_src/* theme.palette.blue.main */.rS.palette.blue.main);
const DiscountedPrice = (0,styled_components_browser_cjs["default"])(component_typography_src.H6).withConfig({
    componentId: "sc-ecdc9d29-9"
})(product_detail_styles_templateObject9(), lib_styles_src/* theme.palette.gray.30 */.rS.palette.gray[30]);
const OriginalPrice = (0,styled_components_browser_cjs["default"])(component_typography_src.H6).withConfig({
    componentId: "sc-ecdc9d29-10"
})(product_detail_styles_templateObject10(), lib_styles_src/* theme.palette.gray.50 */.rS.palette.gray[50], lib_styles_src/* gridTheme.container.maxWidth.s */.k.container.maxWidth.s);
const ProductName = (0,styled_components_browser_cjs["default"])(component_typography_src.H2).withConfig({
    componentId: "sc-ecdc9d29-11"
})(product_detail_styles_templateObject11(), lib_styles_src/* gridTheme.container.maxWidth.s */.k.container.maxWidth.s);
const ProductNumber = (0,styled_components_browser_cjs["default"])(component_typography_src/* Subtitle */.QE).withConfig({
    componentId: "sc-ecdc9d29-12"
})(product_detail_styles_templateObject12(), lib_styles_src/* theme.palette.gray.60 */.rS.palette.gray[60], lib_styles_src/* gridTheme.container.maxWidth.s */.k.container.maxWidth.s);
const Descriptions = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-ecdc9d29-13"
})(product_detail_styles_templateObject13(), component_typography_src/* paragraphStyles */.c, lib_styles_src/* theme.palette.blue.dark */.rS.palette.blue.dark, lib_styles_src/* gridTheme.container.maxWidth.s */.k.container.maxWidth.s);
const NoticeBlock = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-ecdc9d29-14"
})(product_detail_styles_templateObject14());
const ReadMoreContainer = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-ecdc9d29-15"
})(product_detail_styles_templateObject15(), lib_styles_src/* gridTheme.container.maxWidth.s */.k.container.maxWidth.s);
const ReadMoreButton = styled_components_browser_cjs["default"].button.withConfig({
    componentId: "sc-ecdc9d29-16"
})(styles_templateObject16(), lib_styles_src/* theme.palette.gray.20 */.rS.palette.gray[20], lib_styles_src/* theme.palette.gray.50 */.rS.palette.gray[50]);
const CrossInfoBlock = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-ecdc9d29-17"
})(styles_templateObject17(), lib_styles_src/* theme.palette.blue.main */.rS.palette.blue.main);
const TooltipContainer = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-ecdc9d29-18"
})(styles_templateObject18());
const CheckboxContainer = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-ecdc9d29-19"
})(styles_templateObject19());
const CalculatorRow = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-ecdc9d29-20"
})(styles_templateObject20());
const ActionRow = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-ecdc9d29-21"
})(styles_templateObject21());
const ButtonFlexRow = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-ecdc9d29-22"
})(_templateObject22(), lib_styles_src/* gridTheme.container.maxWidth.s */.k.container.maxWidth.s);
const FlexColumn = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-ecdc9d29-23"
})(_templateObject23());
const FavAndQtyButtons = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-ecdc9d29-24"
})(_templateObject24(), lib_styles_src/* gridTheme.container.maxWidth.s */.k.container.maxWidth.s);
const VariantSelectionOptions = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-ecdc9d29-25"
})(_templateObject25(), lib_styles_src/* theme.palette.gray.10 */.rS.palette.gray[10]);
const AvailabilityContainer = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-ecdc9d29-26"
})(_templateObject26());
const AvailabilityBlock = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-ecdc9d29-27"
})(_templateObject27(), lib_styles_src/* theme.palette.gray.10 */.rS.palette.gray[10]);
const AvailabilityLabel = (0,styled_components_browser_cjs["default"])(component_typography_src/* PSmallBold */.cZ).withConfig({
    componentId: "sc-ecdc9d29-28"
})(_templateObject28());
const SoldOutLabel = (0,styled_components_browser_cjs["default"])(component_typography_src/* PSmall */.zK).withConfig({
    componentId: "sc-ecdc9d29-29"
})(_templateObject29());
const LocationList = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-ecdc9d29-30"
})(_templateObject30());
const Location = (0,styled_components_browser_cjs["default"])(component_typography_src/* PSmall */.zK).withConfig({
    componentId: "sc-ecdc9d29-31"
})(_templateObject31(), lib_styles_src/* theme.palette.gray.20 */.rS.palette.gray[20]);
const ButtonLoadingWrapper = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-ecdc9d29-32"
})(_templateObject32());
const EnergyWrapper = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-ecdc9d29-33"
})(_templateObject33());

;// CONCATENATED MODULE: ./src/features/products/components/product-page/product-detail/product-custom-detail.tsx





const ProductCustomDetail = (param)=>{
    let { brand , product , activeVariant , EnergyLabel =null  } = param;
    var ref, ref1;
    const [firedAnalyticsImpression, setFiredAnalyticsImpression] = (0,react.useState)(false);
    var ref2;
    const descriptionHTML = (0,react.useMemo)(()=>{
        var ref;
        return {
            __html: (ref2 = product === null || product === void 0 ? void 0 : (ref = product.description) === null || ref === void 0 ? void 0 : ref.is) !== null && ref2 !== void 0 ? ref2 : ""
        };
    }, [
        product === null || product === void 0 ? void 0 : (ref = product.description) === null || ref === void 0 ? void 0 : ref.is
    ]);
    (0,react.useEffect)(()=>{
        if (!firedAnalyticsImpression) {
            setFiredAnalyticsImpression(true);
            let price = "0";
            try {
                var ref, ref1;
                var ref2;
                price = (ref2 = activeVariant === null || activeVariant === void 0 ? void 0 : (ref = activeVariant.price) === null || ref === void 0 ? void 0 : (ref1 = ref.gross) === null || ref1 === void 0 ? void 0 : ref1.toString()) !== null && ref2 !== void 0 ? ref2 : "0";
            } catch (e) {
            // silent
            }
            lib_analytics_src/* analytics.addProductPageViewImpression */.c.addProductPageViewImpression(product, price);
        }
    }, [
        activeVariant === null || activeVariant === void 0 ? void 0 : (ref1 = activeVariant.price) === null || ref1 === void 0 ? void 0 : ref1.gross,
        firedAnalyticsImpression,
        product
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ProductDetailContainer, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(FlexRow, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Brand, {
                        children: brand !== null && brand !== void 0 ? brand : ""
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(SkuNumber, {
                        children: [
                            "VNR. ",
                            activeVariant === null || activeVariant === void 0 ? void 0 : activeVariant.sku
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductName, {
                fontWeight: "400",
                maxFontSize: "48px",
                textColor: lib_styles_src/* theme.palette.blue.dark */.rS.palette.blue.dark,
                uppercase: true,
                children: product === null || product === void 0 ? void 0 : product.name
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Descriptions, {
                className: "showMore",
                dangerouslySetInnerHTML: descriptionHTML
            }),
            EnergyLabel && /*#__PURE__*/ (0,jsx_runtime.jsx)(EnergyWrapper, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(EnergyLabel, {})
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/features/products/components/product-page/product-detail/product-display-detail.tsx





const ProductDisplayDetail = (param)=>{
    let { brand , product , activeVariant , EnergyLabel =null  } = param;
    var ref, ref1;
    const [firedAnalyticsImpression, setFiredAnalyticsImpression] = (0,react.useState)(false);
    var ref2;
    const descriptionHTML = (0,react.useMemo)(()=>{
        var ref;
        return {
            __html: (ref2 = product === null || product === void 0 ? void 0 : (ref = product.description) === null || ref === void 0 ? void 0 : ref.is) !== null && ref2 !== void 0 ? ref2 : ""
        };
    }, [
        product === null || product === void 0 ? void 0 : (ref = product.description) === null || ref === void 0 ? void 0 : ref.is
    ]);
    (0,react.useEffect)(()=>{
        if (!firedAnalyticsImpression) {
            setFiredAnalyticsImpression(true);
            let price = "0";
            try {
                var ref, ref1;
                var ref2;
                price = (ref2 = activeVariant === null || activeVariant === void 0 ? void 0 : (ref = activeVariant.price) === null || ref === void 0 ? void 0 : (ref1 = ref.gross) === null || ref1 === void 0 ? void 0 : ref1.toString()) !== null && ref2 !== void 0 ? ref2 : "0";
            } catch (e) {
            // silent
            }
            lib_analytics_src/* analytics.addProductPageViewImpression */.c.addProductPageViewImpression(product, price);
        }
    }, [
        activeVariant === null || activeVariant === void 0 ? void 0 : (ref1 = activeVariant.price) === null || ref1 === void 0 ? void 0 : ref1.gross,
        firedAnalyticsImpression,
        product
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ProductDetailContainer, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(FlexRow, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Brand, {
                        children: brand !== null && brand !== void 0 ? brand : ""
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(SkuNumber, {
                        children: [
                            "VNR. ",
                            activeVariant === null || activeVariant === void 0 ? void 0 : activeVariant.sku
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductName, {
                fontWeight: "400",
                maxFontSize: "48px",
                textColor: lib_styles_src/* theme.palette.blue.dark */.rS.palette.blue.dark,
                uppercase: true,
                children: product === null || product === void 0 ? void 0 : product.name
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Descriptions, {
                className: "showMore",
                dangerouslySetInnerHTML: descriptionHTML
            }),
            EnergyLabel && /*#__PURE__*/ (0,jsx_runtime.jsx)(EnergyWrapper, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(EnergyLabel, {})
            })
        ]
    });
};

// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-component-loaders-virtual-61e12a86f6/1/packages/component-loaders/src/index.ts + 7 modules
var component_loaders_src = __webpack_require__(96360);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-hooks-product-variants-virtual-3d0a0bb929/1/packages/hooks-product-variants/src/index.ts + 3 modules
var hooks_product_variants_src = __webpack_require__(88596);
;// CONCATENATED MODULE: ./src/features/products/components/product-page/product-detail/product-limited-detail.tsx










const ProductLimitedDetail = (param)=>{
    let { brand , product , activeVariant , setActiveVariantSKU , skuPrices , EnergyLabel =null  } = param;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21, ref22, ref23, ref24, ref25, ref26, ref27, ref28, ref29, ref30;
    const { user  } = (0,hooks_auth_next_src/* useAuth */.aC)();
    const activeVariantSKU = (0,react.useMemo)(()=>{
        if (activeVariant) {
            return activeVariant.sku;
        } else {
            return "";
        }
    }, [
        activeVariant
    ]);
    const { activeColor , colorSelectionList , sizeSelectionList , activeSize , handleColorChange , handleSizeChange  } = (0,hooks_product_variants_src/* useProductVariants */.Rk)(product, activeVariantSKU, setActiveVariantSKU, null);
    const activeVariantPrice = skuPrices === null || skuPrices === void 0 ? void 0 : skuPrices[activeVariantSKU];
    const [firedAnalyticsImpression, setFiredAnalyticsImpression] = (0,react.useState)(false);
    const price = (0,react.useMemo)(()=>{
        if (activeVariantPrice && activeVariantPrice.discounted && activeVariantPrice.price) {
            var ref, ref1, ref2, ref3;
            var ref4, ref5, ref6, ref7;
            return {
                discounted: {
                    gross: (0,lib_api_price_src/* getPrice */.aS)((ref4 = activeVariantPrice === null || activeVariantPrice === void 0 ? void 0 : (ref = activeVariantPrice.discounted) === null || ref === void 0 ? void 0 : ref.gross) !== null && ref4 !== void 0 ? ref4 : 0),
                    net: (0,lib_api_price_src/* getPrice */.aS)((ref5 = activeVariantPrice === null || activeVariantPrice === void 0 ? void 0 : (ref1 = activeVariantPrice.discounted) === null || ref1 === void 0 ? void 0 : ref1.net) !== null && ref5 !== void 0 ? ref5 : 0)
                },
                price: {
                    gross: (0,lib_api_price_src/* getPrice */.aS)((ref6 = activeVariantPrice === null || activeVariantPrice === void 0 ? void 0 : (ref2 = activeVariantPrice.price) === null || ref2 === void 0 ? void 0 : ref2.gross) !== null && ref6 !== void 0 ? ref6 : 0),
                    net: (0,lib_api_price_src/* getPrice */.aS)((ref7 = activeVariantPrice === null || activeVariantPrice === void 0 ? void 0 : (ref3 = activeVariantPrice.price) === null || ref3 === void 0 ? void 0 : ref3.net) !== null && ref7 !== void 0 ? ref7 : 0)
                }
            };
        } else if (activeVariantPrice && activeVariantPrice.price) {
            var ref8, ref9;
            var ref10, ref11;
            return {
                discounted: null,
                price: {
                    gross: (0,lib_api_price_src/* getPrice */.aS)((ref10 = activeVariantPrice === null || activeVariantPrice === void 0 ? void 0 : (ref8 = activeVariantPrice.price) === null || ref8 === void 0 ? void 0 : ref8.gross) !== null && ref10 !== void 0 ? ref10 : 0),
                    net: (0,lib_api_price_src/* getPrice */.aS)((ref11 = activeVariantPrice === null || activeVariantPrice === void 0 ? void 0 : (ref9 = activeVariantPrice.price) === null || ref9 === void 0 ? void 0 : ref9.net) !== null && ref11 !== void 0 ? ref11 : 0)
                }
            };
        } else {
            return null;
        }
    }, [
        activeVariantPrice
    ]);
    const productNotAvailableYet = (0,react.useMemo)(()=>{
        return (activeVariantPrice === null || activeVariantPrice === void 0 ? void 0 : activeVariantPrice.price.gross) === 0;
    }, [
        activeVariantPrice === null || activeVariantPrice === void 0 ? void 0 : activeVariantPrice.price.gross
    ]);
    var ref31;
    const handleItemToString = (0,react.useCallback)((option)=>{
        return (ref31 = option === null || option === void 0 ? void 0 : option.label) !== null && ref31 !== void 0 ? ref31 : "";
    }, []);
    var ref32;
    const descriptionHTML = (0,react.useMemo)(()=>{
        var ref;
        return {
            __html: (ref32 = product === null || product === void 0 ? void 0 : (ref = product.description) === null || ref === void 0 ? void 0 : ref.is) !== null && ref32 !== void 0 ? ref32 : ""
        };
    }, [
        product === null || product === void 0 ? void 0 : (ref = product.description) === null || ref === void 0 ? void 0 : ref.is
    ]);
    (0,react.useEffect)(()=>{
        if (!firedAnalyticsImpression) {
            setFiredAnalyticsImpression(true);
            let analyticsPrice = "0";
            try {
                var ref, ref1;
                var ref2;
                analyticsPrice = (ref2 = activeVariant === null || activeVariant === void 0 ? void 0 : (ref = activeVariant.price) === null || ref === void 0 ? void 0 : (ref1 = ref.gross) === null || ref1 === void 0 ? void 0 : ref1.toString()) !== null && ref2 !== void 0 ? ref2 : "0";
            } catch (e) {
            // silent
            }
            lib_analytics_src/* analytics.addProductPageViewImpression */.c.addProductPageViewImpression(product, analyticsPrice);
        }
    }, [
        activeVariant === null || activeVariant === void 0 ? void 0 : (ref1 = activeVariant.price) === null || ref1 === void 0 ? void 0 : ref1.gross,
        firedAnalyticsImpression,
        product
    ]);
    const eanNumber = activeVariant === null || activeVariant === void 0 ? void 0 : activeVariant.attributes["eanNumber"];
    var ref33, ref34, ref35, ref36, ref37, ref38, ref39, ref40;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ProductDetailContainer, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HiddenAttribute, {
                id: "product-ean-numbers",
                children: eanNumber
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(FlexRow, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Brand, {
                        children: brand !== null && brand !== void 0 ? brand : ""
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(SkuNumber, {
                        children: [
                            "VNR. ",
                            activeVariant === null || activeVariant === void 0 ? void 0 : activeVariant.sku
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductName, {
                fontWeight: "400",
                maxFontSize: "48px",
                textColor: lib_styles_src/* theme.palette.blue.dark */.rS.palette.blue.dark,
                uppercase: true,
                children: product === null || product === void 0 ? void 0 : product.name
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Descriptions, {
                className: "showMore",
                dangerouslySetInnerHTML: descriptionHTML
            }),
            EnergyLabel && /*#__PURE__*/ (0,jsx_runtime.jsx)(EnergyWrapper, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(EnergyLabel, {})
            }),
            productNotAvailableYet ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Price, {
                maxFontSize: "24px",
                children: "Vara v\xe6ntanleg"
            }) : null,
            !productNotAvailableYet ? /*#__PURE__*/ (0,jsx_runtime.jsx)(PriceContainer, {
                children: price !== null ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(FlexRow, {
                    children: [
                        (activeVariantPrice === null || activeVariantPrice === void 0 ? void 0 : activeVariantPrice.isSqmProduct) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(FlexColumn, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(PriceText, {
                                    children: "Fermetraver\xf0"
                                }),
                                (activeVariantPrice === null || activeVariantPrice === void 0 ? void 0 : (ref2 = activeVariantPrice.discounted) === null || ref2 === void 0 ? void 0 : ref2.perSqm) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(DiscountedPrice, {
                                    maxFontSize: "16px",
                                    children: [
                                        (ref4 = (0,lib_api_price_src/* getPrice */.aS)((ref33 = activeVariantPrice === null || activeVariantPrice === void 0 ? void 0 : (ref3 = activeVariantPrice.price) === null || ref3 === void 0 ? void 0 : ref3.perSqm) !== null && ref33 !== void 0 ? ref33 : 0)) === null || ref4 === void 0 ? void 0 : ref4.humanReadable,
                                        " /m\xb2"
                                    ]
                                }) : null,
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Price, {
                                    maxFontSize: "36px",
                                    children: [
                                        (price === null || price === void 0 ? void 0 : (ref5 = price.discounted) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.gross) === null || ref6 === void 0 ? void 0 : ref6.original) ? (ref8 = (0,lib_api_price_src/* getPrice */.aS)((ref34 = activeVariantPrice === null || activeVariantPrice === void 0 ? void 0 : (ref7 = activeVariantPrice.discounted) === null || ref7 === void 0 ? void 0 : ref7.perSqm) !== null && ref34 !== void 0 ? ref34 : 0)) === null || ref8 === void 0 ? void 0 : ref8.humanReadable : (ref10 = (0,lib_api_price_src/* getPrice */.aS)((ref35 = activeVariantPrice === null || activeVariantPrice === void 0 ? void 0 : (ref9 = activeVariantPrice.price) === null || ref9 === void 0 ? void 0 : ref9.perSqm) !== null && ref35 !== void 0 ? ref35 : 0)) === null || ref10 === void 0 ? void 0 : ref10.humanReadable,
                                        " ",
                                        "/m\xb2"
                                    ]
                                })
                            ]
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(FlexColumn, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(PriceText, {
                                    children: user ? "MITT VER\xd0" : "VER\xd0"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Price, {
                                    maxFontSize: "36px",
                                    children: (ref36 = price === null || price === void 0 ? void 0 : (ref11 = price.discounted) === null || ref11 === void 0 ? void 0 : (ref12 = ref11.gross) === null || ref12 === void 0 ? void 0 : ref12.humanReadable) !== null && ref36 !== void 0 ? ref36 : price === null || price === void 0 ? void 0 : (ref13 = price.price) === null || ref13 === void 0 ? void 0 : (ref14 = ref13.gross) === null || ref14 === void 0 ? void 0 : ref14.humanReadable
                                })
                            ]
                        }),
                        (activeVariantPrice === null || activeVariantPrice === void 0 ? void 0 : activeVariantPrice.isSqmProduct) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(FlexColumn, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(PriceText, {
                                    children: user ? "MITT VER\xd0" : "VER\xd0"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(DiscountedPrice, {
                                    maxFontSize: "16px",
                                    children: (price === null || price === void 0 ? void 0 : (ref15 = price.discounted) === null || ref15 === void 0 ? void 0 : (ref16 = ref15.gross) === null || ref16 === void 0 ? void 0 : ref16.original) ? "".concat((ref19 = (0,lib_api_price_src/* getPrice */.aS)((ref37 = price === null || price === void 0 ? void 0 : (ref17 = price.price) === null || ref17 === void 0 ? void 0 : (ref18 = ref17.gross) === null || ref18 === void 0 ? void 0 : ref18.original) !== null && ref37 !== void 0 ? ref37 : 0)) === null || ref19 === void 0 ? void 0 : ref19.humanReadable, " /pk") : null
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Price, {
                                    maxFontSize: "36px",
                                    children: (price === null || price === void 0 ? void 0 : (ref20 = price.discounted) === null || ref20 === void 0 ? void 0 : (ref21 = ref20.gross) === null || ref21 === void 0 ? void 0 : ref21.original) ? "".concat((ref24 = (0,lib_api_price_src/* getPrice */.aS)(price === null || price === void 0 ? void 0 : (ref22 = price.discounted) === null || ref22 === void 0 ? void 0 : (ref23 = ref22.gross) === null || ref23 === void 0 ? void 0 : ref23.original)) === null || ref24 === void 0 ? void 0 : ref24.humanReadable, " /pk") : "".concat((ref27 = (0,lib_api_price_src/* getPrice */.aS)((ref38 = price === null || price === void 0 ? void 0 : (ref25 = price.price) === null || ref25 === void 0 ? void 0 : (ref26 = ref25.gross) === null || ref26 === void 0 ? void 0 : ref26.original) !== null && ref38 !== void 0 ? ref38 : 0)) === null || ref27 === void 0 ? void 0 : ref27.humanReadable, " /pk")
                                })
                            ]
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(FlexColumn, {
                            children: (price === null || price === void 0 ? void 0 : (ref28 = price.discounted) === null || ref28 === void 0 ? void 0 : (ref29 = ref28.gross) === null || ref29 === void 0 ? void 0 : ref29.humanReadable) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PriceText, {
                                        children: "Ver\xf0 \xe1\xf0ur"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(OriginalPrice, {
                                        maxFontSize: "36px",
                                        children: (ref30 = price === null || price === void 0 ? void 0 : price.price.gross) === null || ref30 === void 0 ? void 0 : ref30.humanReadable
                                    })
                                ]
                            }) : null
                        })
                    ]
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingWrapper, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(component_loaders_src.DotLoader, {
                        size: 84
                    })
                })
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(VariantSelectionOptions, {
                className: "limited-detail",
                children: [
                    colorSelectionList.length > 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)(component_select_src/* Select */.P, {
                        align: "left",
                        // disableInactive={true}  FIXME
                        fit: true,
                        handleSelectedItemChange: handleColorChange,
                        hideDefaultPlaceholder: true,
                        hideValue: true,
                        items: colorSelectionList,
                        itemToString: handleItemToString,
                        placeholder: (ref39 = activeColor === null || activeColor === void 0 ? void 0 : activeColor.label) !== null && ref39 !== void 0 ? ref39 : "Veldu lit",
                        selectedItem: activeColor,
                        textColor: (activeColor === null || activeColor === void 0 ? void 0 : activeColor.label) ? lib_styles_src/* theme.palette.blue.main */.rS.palette.blue.main : lib_styles_src/* theme.palette.gray.40 */.rS.palette.gray[40]
                    }),
                    sizeSelectionList.length > 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)(component_select_src/* Select */.P, {
                        align: "left",
                        // disableInactive={true}  FIXME
                        fit: true,
                        handleSelectedItemChange: handleSizeChange,
                        hideDefaultPlaceholder: true,
                        hideValue: true,
                        items: sizeSelectionList,
                        itemToString: handleItemToString,
                        placeholder: (ref40 = activeSize === null || activeSize === void 0 ? void 0 : activeSize.label) !== null && ref40 !== void 0 ? ref40 : "Veldu st\xe6r\xf0",
                        selectedItem: activeSize,
                        textColor: (activeSize === null || activeSize === void 0 ? void 0 : activeSize.label) ? lib_styles_src/* theme.palette.blue.main */.rS.palette.blue.main : lib_styles_src/* theme.palette.gray.40 */.rS.palette.gray[40]
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/features/products/components/product-page/product-detail/product-rent-detail.tsx





const ProductRentDetail = (param)=>{
    let { brand , product , activeVariant , EnergyLabel =null  } = param;
    var ref, ref1;
    const [firedAnalyticsImpression, setFiredAnalyticsImpression] = (0,react.useState)(false);
    var ref2;
    const descriptionHTML = (0,react.useMemo)(()=>{
        var ref;
        return {
            __html: (ref2 = product === null || product === void 0 ? void 0 : (ref = product.description) === null || ref === void 0 ? void 0 : ref.is) !== null && ref2 !== void 0 ? ref2 : ""
        };
    }, [
        product === null || product === void 0 ? void 0 : (ref = product.description) === null || ref === void 0 ? void 0 : ref.is
    ]);
    (0,react.useEffect)(()=>{
        if (!firedAnalyticsImpression) {
            setFiredAnalyticsImpression(true);
            let price = "0";
            try {
                var ref, ref1;
                var ref2;
                price = (ref2 = activeVariant === null || activeVariant === void 0 ? void 0 : (ref = activeVariant.price) === null || ref === void 0 ? void 0 : (ref1 = ref.gross) === null || ref1 === void 0 ? void 0 : ref1.toString()) !== null && ref2 !== void 0 ? ref2 : "0";
            } catch (e) {
            // silent
            }
            lib_analytics_src/* analytics.addProductPageViewImpression */.c.addProductPageViewImpression(product, price);
        }
    }, [
        activeVariant === null || activeVariant === void 0 ? void 0 : (ref1 = activeVariant.price) === null || ref1 === void 0 ? void 0 : ref1.gross,
        firedAnalyticsImpression,
        product
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ProductDetailContainer, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(FlexRow, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Brand, {
                        children: brand !== null && brand !== void 0 ? brand : ""
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(SkuNumber, {
                        children: [
                            "VNR. ",
                            activeVariant === null || activeVariant === void 0 ? void 0 : activeVariant.sku
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductName, {
                fontWeight: "400",
                maxFontSize: "48px",
                textColor: lib_styles_src/* theme.palette.blue.dark */.rS.palette.blue.dark,
                uppercase: true,
                children: product === null || product === void 0 ? void 0 : product.name
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Descriptions, {
                className: "showMore",
                dangerouslySetInnerHTML: descriptionHTML
            }),
            EnergyLabel && /*#__PURE__*/ (0,jsx_runtime.jsx)(EnergyWrapper, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(EnergyLabel, {})
            })
        ]
    });
};

// EXTERNAL MODULE: ../../.yarn/cache/classnames-npm-2.3.2-d2fdae468d-2c62199789.zip/node_modules/classnames/index.js
var classnames = __webpack_require__(38805);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-component-inputs-virtual-052bad3006/1/packages/component-inputs/src/index.ts + 11 modules
var component_inputs_src = __webpack_require__(45535);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-component-quantity-input-virtual-a245e83f98/1/packages/component-quantity-input/src/index.ts + 8 modules
var component_quantity_input_src = __webpack_require__(75290);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-component-selectors-virtual-9e0e678d5e/1/packages/component-selectors/src/index.ts + 10 modules
var component_selectors_src = __webpack_require__(60002);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-component-tooltip-virtual-e0488091c2/1/packages/component-tooltip/src/index.ts + 2 modules
var component_tooltip_src = __webpack_require__(63323);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-hooks-cart-virtual-97c767eaa3/1/packages/hooks-cart/src/index.ts + 8 modules
var hooks_cart_src = __webpack_require__(93784);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-hooks-compare-products-virtual-cdc2b75dbe/1/packages/hooks-compare-products/src/index.ts + 3 modules
var hooks_compare_products_src = __webpack_require__(11914);
// EXTERNAL MODULE: ./src/features/context/common.tsx
var common = __webpack_require__(37107);
;// CONCATENATED MODULE: ./src/features/context/index.ts


;// CONCATENATED MODULE: ./src/features/products/components/product-page/product-detail/stock-status.tsx







const StockStatus = (param)=>{
    let { activeVariantSKU , errorMessage , productSlug  } = param;
    const { warehouses  } = (0,common/* useCommonContext */.I)();
    const { availability  } = (0,hooks_product_variants_src/* useProductInventory */.cc)({
        productSlug,
        activeVariantSKU,
        warehouses
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(AvailabilityContainer, {
        children: [
            errorMessage && errorMessage.length && /*#__PURE__*/ (0,jsx_runtime.jsx)(component_typography_src/* PMedium */.aW, {
                textColor: lib_styles_src/* theme.palette.orange.dark */.rS.palette.orange.dark,
                children: errorMessage
            }),
            !errorMessage && availability.available.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(AvailabilityBlock, {
                className: "border-bottom",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AvailabilityLabel, {
                        textColor: lib_styles_src/* theme.palette.blue.main */.rS.palette.blue.main,
                        children: "Til \xe1 lager:"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LocationList, {
                        children: availability.available.map((param)=>{
                            let { name , slug  } = param;
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Location, {
                                textColor: lib_styles_src/* theme.palette.gray.80 */.rS.palette.gray[80],
                                children: name
                            }, slug);
                        })
                    })
                ]
            }),
            !errorMessage && availability.lowStock.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(AvailabilityBlock, {
                className: "border-bottom",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AvailabilityLabel, {
                        textColor: lib_styles_src/* theme.palette.blue.main */.rS.palette.blue.main,
                        children: "F\xe1 eint\xf6k:"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LocationList, {
                        children: availability.lowStock.map((param)=>{
                            let { name , slug  } = param;
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Location, {
                                textColor: lib_styles_src/* theme.palette.gray.80 */.rS.palette.gray[80],
                                children: name
                            }, slug);
                        })
                    })
                ]
            }),
            !errorMessage && availability.outOfStock.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(AvailabilityBlock, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SoldOutLabel, {
                        textColor: lib_styles_src/* theme.palette.blue.main */.rS.palette.blue.main,
                        children: "Uppselt:"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LocationList, {
                        children: availability.outOfStock.map((param)=>{
                            let { name , slug  } = param;
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Location, {
                                textColor: lib_styles_src/* theme.palette.gray.30 */.rS.palette.gray[30],
                                children: name
                            }, slug);
                        })
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/features/products/components/product-page/product-detail/product-standard-detail.tsx
























const squareMeterExplanation = // eslint-disable-next-line max-len
"Fj\xf6ldi pakka r\xe6\xf0st af \xfev\xed hversu marga fermetra \xfe\xfa \xfearft. Til a\xf0 vera viss um a\xf0 \xfe\xfa hafir n\xf3g vegna afskur\xf0ar getur \xfe\xfa haka\xf0 \xed b\xe6ta 10% vi\xf0 fermetrafj\xf6lda.";
const ProductStandardDetail = (param)=>{
    let { brand , product , activeVariant , setActiveVariantSKU , skuPrices , EnergyLabel =null  } = param;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21, ref22, ref23, ref24, ref25, ref26, ref27, ref28, ref29, ref30, ref31, ref32, ref33, ref34, ref35, ref36, ref37, ref38, ref39, ref40;
    const { addProduct , products  } = (0,hooks_compare_products_src/* useCompareProducts */.j)();
    const { user  } = (0,hooks_auth_next_src/* useAuth */.aC)();
    const activeVariantSKU = (0,react.useMemo)(()=>{
        if (activeVariant) {
            return activeVariant.sku;
        } else {
            return "";
        }
    }, [
        activeVariant
    ]);
    const { activeColor , colorSelectionList , permitPurchase , sizeSelectionList , activeSize , handleColorChange , handleSizeChange , errorMessage  } = (0,hooks_product_variants_src/* useProductVariants */.Rk)(product, activeVariantSKU, setActiveVariantSKU, null);
    const { setCartQuantity , isLoading  } = (0,hooks_cart_src/* useCart */.jD)();
    var ref41;
    const currentCount = (0,lib_api_products_src/* useCartItemCount */.PO)((ref41 = activeVariant === null || activeVariant === void 0 ? void 0 : activeVariant.id) !== null && ref41 !== void 0 ? ref41 : null);
    const [activeCalculation, setActiveCalculation] = (0,react.useState)("m2");
    const [packageInputValue, setPackageInputValue] = (0,react.useState)("1");
    const [m2InputValue, setM2InputValue] = (0,react.useState)("0");
    const [count, setCount] = (0,react.useState)(1);
    const [addTenPercent, setAddTenPercent] = (0,react.useState)(false);
    const activeVariantPrice = skuPrices === null || skuPrices === void 0 ? void 0 : skuPrices[activeVariantSKU];
    const [firedAnalyticsImpression, setFiredAnalyticsImpression] = (0,react.useState)(false);
    const { sendAddToCartInsights  } = (0,lib_algolia_src/* useAlgoliaInsights */.HX)();
    const { warehouses  } = (0,common/* useCommonContext */.I)();
    const { inventory , availability  } = (0,hooks_product_variants_src/* useProductInventory */.cc)({
        productSlug: product.slug,
        activeVariantSKU,
        warehouses
    });
    const quantityInM2 = (0,react.useMemo)(()=>{
        if (activeVariantPrice === null || activeVariantPrice === void 0 ? void 0 : activeVariantPrice.isSqmProduct) {
            if ((activeVariantPrice === null || activeVariantPrice === void 0 ? void 0 : activeVariantPrice.price.perSqm) && (activeVariantPrice === null || activeVariantPrice === void 0 ? void 0 : activeVariantPrice.packagingQuantity)) {
                const pricePerUnit = (activeVariantPrice === null || activeVariantPrice === void 0 ? void 0 : activeVariantPrice.price.gross) / (activeVariantPrice === null || activeVariantPrice === void 0 ? void 0 : activeVariantPrice.packagingQuantity);
                const quantityPerSqm = activeVariantPrice.price.perSqm / pricePerUnit;
                return quantityPerSqm.toString();
            }
        }
        return "0";
    }, [
        activeVariantPrice
    ]);
    const handleM2InputValueChange = (0,react.useCallback)((e)=>{
        const value = e.target.value;
        const regex = /^[0-9]*[.,]?[0-9]*$/;
        if (regex.test(value)) {
            const priceValue = activeVariantPrice === null || activeVariantPrice === void 0 ? void 0 : activeVariantPrice.packagingQuantity;
            if (priceValue != undefined) {
                const packageValue = parseFloat(value) * parseFloat(quantityInM2) / priceValue;
                setPackageInputValue(Math.ceil(packageValue).toString());
            }
            setM2InputValue(value);
        }
    }, [
        activeVariantPrice,
        quantityInM2
    ]);
    const handlePackageInputValueChange = (0,react.useCallback)((e)=>{
        const value = e.target.value;
        const regex = /^[0-9]*$/;
        if (regex.test(value)) {
            setPackageInputValue(value);
            const packagingQuantity = activeVariantPrice === null || activeVariantPrice === void 0 ? void 0 : activeVariantPrice.packagingQuantity;
            if (packagingQuantity) {
                const totalPieces = packagingQuantity * parseInt(value, 10);
                const sqm = totalPieces / parseFloat(quantityInM2);
                setM2InputValue(sqm.toFixed(2));
            }
        }
    }, [
        activeVariantPrice === null || activeVariantPrice === void 0 ? void 0 : activeVariantPrice.packagingQuantity,
        quantityInM2
    ]);
    const actualM2 = (0,react.useMemo)(()=>{
        const packagingQuantity = activeVariantPrice === null || activeVariantPrice === void 0 ? void 0 : activeVariantPrice.packagingQuantity;
        if (packagingQuantity) {
            const totalPieces = packagingQuantity * parseFloat(packageInputValue);
            const sqm = totalPieces / parseFloat(quantityInM2);
            return sqm.toFixed(2);
        }
        return 0;
    }, [
        activeVariantPrice === null || activeVariantPrice === void 0 ? void 0 : activeVariantPrice.packagingQuantity,
        packageInputValue,
        quantityInM2
    ]);
    (0,react.useEffect)(()=>{
        if (parseFloat(m2InputValue) === 0 || m2InputValue === "0") {
            setM2InputValue(actualM2.toString());
        }
    }, [
        actualM2,
        m2InputValue
    ]);
    const handleCalculationSwap = (0,react.useCallback)(()=>{
        if (m2InputValue === "NaN" || m2InputValue === "" || packageInputValue === "NaN" || packageInputValue === "") {
            setM2InputValue("1");
            setPackageInputValue("1");
        }
        if (activeCalculation === "m2") {
            setActiveCalculation("package");
        } else {
            setActiveCalculation("m2");
        }
    }, [
        activeCalculation,
        m2InputValue,
        packageInputValue
    ]);
    const price = (0,react.useMemo)(()=>{
        if (activeVariantPrice && activeVariantPrice.discounted && activeVariantPrice.price) {
            var ref, ref1, ref2, ref3;
            var ref4, ref5, ref6, ref7;
            return {
                discounted: {
                    gross: (0,lib_api_price_src/* getPrice */.aS)((ref4 = activeVariantPrice === null || activeVariantPrice === void 0 ? void 0 : (ref = activeVariantPrice.discounted) === null || ref === void 0 ? void 0 : ref.gross) !== null && ref4 !== void 0 ? ref4 : 0),
                    net: (0,lib_api_price_src/* getPrice */.aS)((ref5 = activeVariantPrice === null || activeVariantPrice === void 0 ? void 0 : (ref1 = activeVariantPrice.discounted) === null || ref1 === void 0 ? void 0 : ref1.net) !== null && ref5 !== void 0 ? ref5 : 0)
                },
                price: {
                    gross: (0,lib_api_price_src/* getPrice */.aS)((ref6 = activeVariantPrice === null || activeVariantPrice === void 0 ? void 0 : (ref2 = activeVariantPrice.price) === null || ref2 === void 0 ? void 0 : ref2.gross) !== null && ref6 !== void 0 ? ref6 : 0),
                    net: (0,lib_api_price_src/* getPrice */.aS)((ref7 = activeVariantPrice === null || activeVariantPrice === void 0 ? void 0 : (ref3 = activeVariantPrice.price) === null || ref3 === void 0 ? void 0 : ref3.net) !== null && ref7 !== void 0 ? ref7 : 0)
                }
            };
        } else if (activeVariantPrice && activeVariantPrice.price) {
            var ref8, ref9;
            var ref10, ref11;
            return {
                discounted: null,
                price: {
                    gross: (0,lib_api_price_src/* getPrice */.aS)((ref10 = activeVariantPrice === null || activeVariantPrice === void 0 ? void 0 : (ref8 = activeVariantPrice.price) === null || ref8 === void 0 ? void 0 : ref8.gross) !== null && ref10 !== void 0 ? ref10 : 0),
                    net: (0,lib_api_price_src/* getPrice */.aS)((ref11 = activeVariantPrice === null || activeVariantPrice === void 0 ? void 0 : (ref9 = activeVariantPrice.price) === null || ref9 === void 0 ? void 0 : ref9.net) !== null && ref11 !== void 0 ? ref11 : 0)
                }
            };
        } else {
            return null;
        }
    }, [
        activeVariantPrice
    ]);
    (0,react.useEffect)(()=>{
        if (activeVariantPrice === null || activeVariantPrice === void 0 ? void 0 : activeVariantPrice.isSqmProduct) {
            const sqmItemCount = parseInt(packageInputValue, 10);
            if (!isNaN(sqmItemCount)) {
                setCount(sqmItemCount);
            }
        }
    }, [
        activeVariantPrice === null || activeVariantPrice === void 0 ? void 0 : activeVariantPrice.isSqmProduct,
        packageInputValue
    ]);
    const handleCheckboxChange = (0,react.useCallback)(()=>{
        const value = parseFloat(m2InputValue);
        const priceValue = activeVariantPrice === null || activeVariantPrice === void 0 ? void 0 : activeVariantPrice.packagingQuantity;
        if (addTenPercent) {
            const result = parseFloat((value / 1.1).toFixed(2));
            setM2InputValue("".concat(result));
            if (priceValue != undefined) {
                const packageValueBefore = result * parseFloat(quantityInM2) / priceValue;
                const packageValue = (Math.floor(packageValueBefore * 100) / 100).toFixed(2);
                setPackageInputValue(Math.ceil(parseFloat(packageValue)).toString());
            }
        } else {
            const result1 = parseFloat((value * 1.1).toFixed(2));
            setM2InputValue("".concat(result1));
            if (priceValue != undefined) {
                const packageValue1 = result1 * parseFloat(quantityInM2) / priceValue;
                setPackageInputValue(Math.ceil(packageValue1).toString());
            }
        }
        setAddTenPercent(!addTenPercent);
    }, [
        activeVariantPrice === null || activeVariantPrice === void 0 ? void 0 : activeVariantPrice.packagingQuantity,
        addTenPercent,
        m2InputValue,
        quantityInM2
    ]);
    const productNotAvailableYet = (0,react.useMemo)(()=>{
        return (activeVariantPrice === null || activeVariantPrice === void 0 ? void 0 : activeVariantPrice.price.gross) === 0;
    }, [
        activeVariantPrice === null || activeVariantPrice === void 0 ? void 0 : activeVariantPrice.price.gross
    ]);
    const { width  } = (0,lib_styles_src/* useWindowSize */.iP)();
    const unitLabel = (0,react.useMemo)(()=>{
        if (activeVariant === null || activeVariant === void 0 ? void 0 : activeVariant.meta.unit) {
            return activeVariant === null || activeVariant === void 0 ? void 0 : activeVariant.meta.unit;
        } else {
            var ref;
            var ref1;
            const units = (ref1 = (ref = activeVariant === null || activeVariant === void 0 ? void 0 : activeVariant.attributes["unit"]) === null || ref === void 0 ? void 0 : ref.toString().split(";")) !== null && ref1 !== void 0 ? ref1 : [];
            if (units.length === 0) {
                return "";
            }
            return units[units.length - 1];
        }
    }, [
        activeVariant === null || activeVariant === void 0 ? void 0 : activeVariant.attributes,
        activeVariant === null || activeVariant === void 0 ? void 0 : activeVariant.meta.unit
    ]);
    var ref42;
    const handleItemToString = (0,react.useCallback)((option)=>{
        return (ref42 = option === null || option === void 0 ? void 0 : option.label) !== null && ref42 !== void 0 ? ref42 : "";
    }, []);
    const showReadMore = (product === null || product === void 0 ? void 0 : (ref = product.description) === null || ref === void 0 ? void 0 : (ref1 = ref.is) === null || ref1 === void 0 ? void 0 : ref1.length) > 500;
    const [_showMore, setShowMore] = (0,react.useState)(false);
    const showMore = _showMore || !showReadMore;
    const handleAddToCart = (0,react.useCallback)(()=>{
        var ref;
        setCartQuantity({
            variantId: activeVariant === null || activeVariant === void 0 ? void 0 : activeVariant.id,
            slug: (ref = product === null || product === void 0 ? void 0 : product.slug) !== null && ref !== void 0 ? ref : "",
            quantity: count + currentCount
        });
        sendAddToCartInsights({
            eventName: "Add to Cart",
            objectIDs: [
                (product === null || product === void 0 ? void 0 : product.id.toString()) || ""
            ]
        });
    }, [
        setCartQuantity,
        activeVariant === null || activeVariant === void 0 ? void 0 : activeVariant.id,
        product === null || product === void 0 ? void 0 : product.slug,
        product === null || product === void 0 ? void 0 : product.id,
        count,
        currentCount,
        sendAddToCartInsights
    ]);
    const handleReadMore = (0,react.useCallback)(()=>{
        setShowMore(!showMore);
    }, [
        showMore
    ]);
    var ref43;
    const descriptionHTML = (0,react.useMemo)(()=>{
        var ref;
        return {
            __html: (ref43 = product === null || product === void 0 ? void 0 : (ref = product.description) === null || ref === void 0 ? void 0 : ref.is) !== null && ref43 !== void 0 ? ref43 : ""
        };
    }, [
        product === null || product === void 0 ? void 0 : (ref2 = product.description) === null || ref2 === void 0 ? void 0 : ref2.is
    ]);
    const addToComparison = (0,react.useCallback)((e)=>{
        e.preventDefault();
        addProduct(product.slug);
    }, [
        addProduct,
        product.slug
    ]);
    (0,react.useEffect)(()=>{
        if (!firedAnalyticsImpression) {
            setFiredAnalyticsImpression(true);
            let analyticsPrice = "0";
            try {
                var ref, ref1;
                var ref2;
                analyticsPrice = (ref2 = activeVariant === null || activeVariant === void 0 ? void 0 : (ref = activeVariant.price) === null || ref === void 0 ? void 0 : (ref1 = ref.gross) === null || ref1 === void 0 ? void 0 : ref1.toString()) !== null && ref2 !== void 0 ? ref2 : "0";
            } catch (e) {
            // silent
            }
            lib_analytics_src/* analytics.addProductPageViewImpression */.c.addProductPageViewImpression(product, analyticsPrice);
        }
    }, [
        activeVariant === null || activeVariant === void 0 ? void 0 : (ref3 = activeVariant.price) === null || ref3 === void 0 ? void 0 : ref3.gross,
        firedAnalyticsImpression,
        product
    ]);
    const clickToCopy = (0,react.useCallback)((e)=>{
        e.preventDefault();
        if (!activeVariantSKU) {
            return;
        }
        var ref;
        const toCopy = (ref = activeVariantSKU.split(":")[0]) !== null && ref !== void 0 ? ref : activeVariantSKU;
        navigator.clipboard.writeText(toCopy);
        // TODO: Replace with a proper tooltip component
        // Also, consider using framer-motion for animations
        // and move to utils
        // Create and position tooltip
        const tooltip = document.createElement("div");
        tooltip.innerText = "Afrita\xf0!";
        tooltip.style.position = "fixed";
        tooltip.style.left = "".concat(e.clientX + 10, "px");
        tooltip.style.top = "".concat(e.clientY + 10, "px");
        tooltip.style.background = lib_styles_src/* theme.palette.blue.dark */.rS.palette.blue.dark;
        tooltip.style.color = "white";
        tooltip.style.padding = "4px 8px";
        tooltip.style.borderRadius = "4px";
        tooltip.style.fontSize = "12px";
        tooltip.style.pointerEvents = "none";
        tooltip.style.zIndex = "1000";
        document.body.appendChild(tooltip);
        // Remove tooltip after 1.5 seconds
        setTimeout(()=>{
            tooltip.remove();
        }, 1500);
    }, [
        activeVariantSKU
    ]);
    const eanNumber = activeVariant === null || activeVariant === void 0 ? void 0 : activeVariant.attributes["eanNumber"];
    var ref44, ref45, ref46, ref47, ref48, ref49, ref50, ref51, ref52, ref53;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ProductDetailContainer, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HiddenAttribute, {
                id: "product-ean-numbers",
                children: eanNumber
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(FlexRow, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Brand, {
                        children: brand !== null && brand !== void 0 ? brand : ""
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(SkuNumber, {
                        onClick: clickToCopy,
                        children: [
                            "VNR. ",
                            activeVariant === null || activeVariant === void 0 ? void 0 : activeVariant.sku
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductName, {
                fontWeight: "400",
                maxFontSize: "48px",
                textColor: lib_styles_src/* theme.palette.blue.dark */.rS.palette.blue.dark,
                uppercase: true,
                children: product === null || product === void 0 ? void 0 : product.name
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Descriptions, {
                className: classnames_default()({
                    showMore
                }),
                dangerouslySetInnerHTML: descriptionHTML
            }),
            EnergyLabel && /*#__PURE__*/ (0,jsx_runtime.jsx)(EnergyWrapper, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(EnergyLabel, {})
            }),
            showReadMore && /*#__PURE__*/ (0,jsx_runtime.jsx)(ReadMoreContainer, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ReadMoreButton, {
                    className: classnames_default()({
                        showMore
                    }),
                    onClick: handleReadMore,
                    children: [
                        showMore ? "Lesa minna " : "Lesa meira",
                        showMore ? /*#__PURE__*/ (0,jsx_runtime.jsx)(lib_icons_src.ArrowUpIcons, {
                            size: 16
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(lib_icons_src.ArrowDownIcons, {
                            size: 16
                        })
                    ]
                })
            }),
            productNotAvailableYet ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Price, {
                maxFontSize: "24px",
                children: "Vara v\xe6ntanleg"
            }) : null,
            !productNotAvailableYet ? /*#__PURE__*/ (0,jsx_runtime.jsx)(PriceContainer, {
                children: price !== null ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(FlexRow, {
                    children: [
                        (activeVariantPrice === null || activeVariantPrice === void 0 ? void 0 : activeVariantPrice.isSqmProduct) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(FlexColumn, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(PriceText, {
                                    children: "Fermetraver\xf0"
                                }),
                                (activeVariantPrice === null || activeVariantPrice === void 0 ? void 0 : (ref4 = activeVariantPrice.discounted) === null || ref4 === void 0 ? void 0 : ref4.perSqm) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(DiscountedPrice, {
                                    maxFontSize: "16px",
                                    children: [
                                        (ref6 = (0,lib_api_price_src/* getPrice */.aS)((ref44 = activeVariantPrice === null || activeVariantPrice === void 0 ? void 0 : (ref5 = activeVariantPrice.price) === null || ref5 === void 0 ? void 0 : ref5.perSqm) !== null && ref44 !== void 0 ? ref44 : 0)) === null || ref6 === void 0 ? void 0 : ref6.humanReadable,
                                        " /m\xb2"
                                    ]
                                }) : null,
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Price, {
                                    maxFontSize: "36px",
                                    children: [
                                        (price === null || price === void 0 ? void 0 : (ref7 = price.discounted) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.gross) === null || ref8 === void 0 ? void 0 : ref8.original) ? (ref10 = (0,lib_api_price_src/* getPrice */.aS)((ref45 = activeVariantPrice === null || activeVariantPrice === void 0 ? void 0 : (ref9 = activeVariantPrice.discounted) === null || ref9 === void 0 ? void 0 : ref9.perSqm) !== null && ref45 !== void 0 ? ref45 : 0)) === null || ref10 === void 0 ? void 0 : ref10.humanReadable : (ref12 = (0,lib_api_price_src/* getPrice */.aS)((ref46 = activeVariantPrice === null || activeVariantPrice === void 0 ? void 0 : (ref11 = activeVariantPrice.price) === null || ref11 === void 0 ? void 0 : ref11.perSqm) !== null && ref46 !== void 0 ? ref46 : 0)) === null || ref12 === void 0 ? void 0 : ref12.humanReadable,
                                        " ",
                                        "/m\xb2"
                                    ]
                                })
                            ]
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(FlexColumn, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(PriceText, {
                                    children: user ? "MITT VER\xd0" : "VER\xd0"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Price, {
                                    maxFontSize: "36px",
                                    children: (ref47 = price === null || price === void 0 ? void 0 : (ref13 = price.discounted) === null || ref13 === void 0 ? void 0 : (ref14 = ref13.gross) === null || ref14 === void 0 ? void 0 : ref14.humanReadable) !== null && ref47 !== void 0 ? ref47 : price === null || price === void 0 ? void 0 : (ref15 = price.price) === null || ref15 === void 0 ? void 0 : (ref16 = ref15.gross) === null || ref16 === void 0 ? void 0 : ref16.humanReadable
                                })
                            ]
                        }),
                        (activeVariantPrice === null || activeVariantPrice === void 0 ? void 0 : activeVariantPrice.isSqmProduct) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(FlexColumn, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(PriceText, {
                                    children: user ? "MITT VER\xd0" : "VER\xd0"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(DiscountedPrice, {
                                    maxFontSize: "16px",
                                    children: (price === null || price === void 0 ? void 0 : (ref17 = price.discounted) === null || ref17 === void 0 ? void 0 : (ref18 = ref17.gross) === null || ref18 === void 0 ? void 0 : ref18.original) ? "".concat((ref21 = (0,lib_api_price_src/* getPrice */.aS)((ref48 = price === null || price === void 0 ? void 0 : (ref19 = price.price) === null || ref19 === void 0 ? void 0 : (ref20 = ref19.gross) === null || ref20 === void 0 ? void 0 : ref20.original) !== null && ref48 !== void 0 ? ref48 : 0)) === null || ref21 === void 0 ? void 0 : ref21.humanReadable, " /pk") : null
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Price, {
                                    maxFontSize: "36px",
                                    children: (price === null || price === void 0 ? void 0 : (ref22 = price.discounted) === null || ref22 === void 0 ? void 0 : (ref23 = ref22.gross) === null || ref23 === void 0 ? void 0 : ref23.original) ? "".concat((ref26 = (0,lib_api_price_src/* getPrice */.aS)(price === null || price === void 0 ? void 0 : (ref24 = price.discounted) === null || ref24 === void 0 ? void 0 : (ref25 = ref24.gross) === null || ref25 === void 0 ? void 0 : ref25.original)) === null || ref26 === void 0 ? void 0 : ref26.humanReadable, " /pk") : "".concat((ref29 = (0,lib_api_price_src/* getPrice */.aS)((ref49 = price === null || price === void 0 ? void 0 : (ref27 = price.price) === null || ref27 === void 0 ? void 0 : (ref28 = ref27.gross) === null || ref28 === void 0 ? void 0 : ref28.original) !== null && ref49 !== void 0 ? ref49 : 0)) === null || ref29 === void 0 ? void 0 : ref29.humanReadable, " /pk")
                                })
                            ]
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(FlexColumn, {
                            children: (price === null || price === void 0 ? void 0 : (ref30 = price.discounted) === null || ref30 === void 0 ? void 0 : (ref31 = ref30.gross) === null || ref31 === void 0 ? void 0 : ref31.humanReadable) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PriceText, {
                                        children: "Ver\xf0 \xe1\xf0ur"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(OriginalPrice, {
                                        maxFontSize: "36px",
                                        children: (ref32 = price === null || price === void 0 ? void 0 : price.price.gross) === null || ref32 === void 0 ? void 0 : ref32.humanReadable
                                    })
                                ]
                            }) : null
                        })
                    ]
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingWrapper, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(component_loaders_src.DotLoader, {
                        size: 84
                    })
                })
            }) : null,
            (activeVariantPrice === null || activeVariantPrice === void 0 ? void 0 : activeVariantPrice.isSqmProduct) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(CalculatorRow, {
                        children: [
                            activeCalculation === "package" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TooltipContainer, {
                                        className: "short",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(component_tooltip_src/* Tooltip */.u, {
                                            arrowLocation: "left",
                                            content: squareMeterExplanation
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(component_inputs_src/* Input */.II, {
                                        label: "Pakkar",
                                        stretch: true,
                                        value: packageInputValue,
                                        onChange: handlePackageInputValueChange
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CrossInfoBlock, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(component_typography_src/* PSmallBold */.cZ, {
                                            textColor: lib_styles_src/* theme.palette.blue.dark */.rS.palette.blue.dark,
                                            children: [
                                                actualM2,
                                                " m2"
                                            ]
                                        })
                                    })
                                ]
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TooltipContainer, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(component_tooltip_src/* Tooltip */.u, {
                                            arrowLocation: "left",
                                            content: squareMeterExplanation
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(component_inputs_src/* Input */.II, {
                                        label: "Fermetrar",
                                        stretch: true,
                                        type: "number",
                                        value: m2InputValue,
                                        onChange: handleM2InputValueChange
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CrossInfoBlock, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(component_typography_src/* PSmallBold */.cZ, {
                                            textColor: lib_styles_src/* theme.palette.blue.dark */.rS.palette.blue.dark,
                                            children: [
                                                isNaN(parseInt(packageInputValue, 10)) ? 0 : packageInputValue,
                                                " pk"
                                            ]
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(component_buttons_src/* Button */.zx, {
                                className: "desktop-button",
                                icon: lib_icons_src.BeraSamanIcons,
                                label: activeCalculation === "package" ? "Breyta \xed fermetra" : "Breyta \xed pakka",
                                onClick: handleCalculationSwap
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ActionRow, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(component_buttons_src/* Button */.zx, {
                                className: "mobile-button",
                                icon: lib_icons_src.BeraSamanIcons,
                                label: activeCalculation === "package" ? "Breyta \xed fermetra" : "Breyta \xed pakka",
                                onClick: handleCalculationSwap
                            }),
                            activeCalculation !== "package" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckboxContainer, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(component_selectors_src/* Checkbox */.XZ, {
                                    checked: addTenPercent,
                                    disabled: isNaN(parseInt(packageInputValue, 10)) || packageInputValue === "0",
                                    label: "B\xe6ta 10% vi\xf0 fermetrat\xf6lu vegna afskur\xf0ar",
                                    smallBox: true,
                                    onChange: handleCheckboxChange
                                })
                            }) : null
                        ]
                    }),
                    isNaN(parseInt(packageInputValue, 10)) === false ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(FlexColumn, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(PriceText, {
                                children: "HEILDARVER\xd0"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Price, {
                                maxFontSize: "36px",
                                children: (price === null || price === void 0 ? void 0 : (ref33 = price.discounted) === null || ref33 === void 0 ? void 0 : (ref34 = ref33.gross) === null || ref34 === void 0 ? void 0 : ref34.original) ? "".concat((ref37 = (0,lib_api_price_src/* getPrice */.aS)(((ref50 = price === null || price === void 0 ? void 0 : (ref35 = price.discounted) === null || ref35 === void 0 ? void 0 : (ref36 = ref35.gross) === null || ref36 === void 0 ? void 0 : ref36.original) !== null && ref50 !== void 0 ? ref50 : 0) * parseInt(packageInputValue, 10))) === null || ref37 === void 0 ? void 0 : ref37.humanReadable) : "".concat((ref40 = (0,lib_api_price_src/* getPrice */.aS)(((ref51 = price === null || price === void 0 ? void 0 : (ref38 = price.price) === null || ref38 === void 0 ? void 0 : (ref39 = ref38.gross) === null || ref39 === void 0 ? void 0 : ref39.original) !== null && ref51 !== void 0 ? ref51 : 0) * parseInt(packageInputValue, 10))) === null || ref40 === void 0 ? void 0 : ref40.humanReadable)
                            })
                        ]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(FlexColumn, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(PriceText, {
                                children: "HEILDARVER\xd0"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Price, {
                                maxFontSize: "36px",
                                children: "0 kr."
                            })
                        ]
                    })
                ]
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ButtonFlexRow, {
                children: [
                    (activeVariantPrice === null || activeVariantPrice === void 0 ? void 0 : activeVariantPrice.isSqmProduct) !== true ? /*#__PURE__*/ (0,jsx_runtime.jsx)(FavAndQtyButtons, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(component_quantity_input_src/* QuantityInput */.F, {
                            quantity: count,
                            quantityUnit: unitLabel !== null && unitLabel !== void 0 ? unitLabel : "",
                            setQuantity: setCount,
                            stretch: width < lib_styles_src/* gridTheme.container.maxWidth.s */.k.container.maxWidth.s ? true : false
                        })
                    }) : null,
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                        children: isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonLoadingWrapper, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(component_loaders_src.MainLoader, {
                                size: 54
                            })
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(component_buttons_src/* Button */.zx, {
                            buttonColor: "blueButton",
                            disabled: productNotAvailableYet || availability.soldOutInWebstore || !permitPurchase || (activeVariantPrice === null || activeVariantPrice === void 0 ? void 0 : activeVariantPrice.isSqmProduct) && (isNaN(parseInt(packageInputValue, 10)) || packageInputValue === "0"),
                            icon: lib_icons_src.CartIcons,
                            label: availability.soldOutInWebstore && inventory && !productNotAvailableYet ? "Uppselt \xed vefverslun" : "B\xe6ta \xed k\xf6rfu",
                            stretch: true,
                            onClick: handleAddToCart
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(VariantSelectionOptions, {
                children: [
                    colorSelectionList.length > 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)(component_select_src/* Select */.P, {
                        align: "left",
                        // disableInactive={true}  FIXME
                        fit: true,
                        handleSelectedItemChange: handleColorChange,
                        hideDefaultPlaceholder: true,
                        hideValue: true,
                        items: colorSelectionList,
                        itemToString: handleItemToString,
                        placeholder: (ref52 = activeColor === null || activeColor === void 0 ? void 0 : activeColor.label) !== null && ref52 !== void 0 ? ref52 : "Veldu lit",
                        selectedItem: activeColor,
                        textColor: (activeColor === null || activeColor === void 0 ? void 0 : activeColor.label) ? lib_styles_src/* theme.palette.blue.main */.rS.palette.blue.main : lib_styles_src/* theme.palette.gray.40 */.rS.palette.gray[40]
                    }),
                    sizeSelectionList.length > 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)(component_select_src/* Select */.P, {
                        align: "left",
                        // disableInactive={true}  FIXME
                        fit: true,
                        handleSelectedItemChange: handleSizeChange,
                        hideDefaultPlaceholder: true,
                        hideValue: true,
                        items: sizeSelectionList,
                        itemToString: handleItemToString,
                        placeholder: (ref53 = activeSize === null || activeSize === void 0 ? void 0 : activeSize.label) !== null && ref53 !== void 0 ? ref53 : "Veldu st\xe6r\xf0",
                        selectedItem: activeSize,
                        textColor: (activeSize === null || activeSize === void 0 ? void 0 : activeSize.label) ? lib_styles_src/* theme.palette.blue.main */.rS.palette.blue.main : lib_styles_src/* theme.palette.gray.40 */.rS.palette.gray[40]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StockStatus, {
                activeVariantSKU: activeVariantSKU,
                errorMessage: errorMessage,
                productSlug: product.slug
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/features/products/components/product-page/product-detail/product-contract-detail.tsx






const ProductContractDetail = (param)=>{
    let { brand , product , activeVariant , EnergyLabel =null  } = param;
    var ref, ref1;
    const [firedAnalyticsImpression, setFiredAnalyticsImpression] = (0,react.useState)(false);
    const activeVariantSKU = (0,react.useMemo)(()=>{
        if (activeVariant) {
            return activeVariant.sku;
        } else {
            return "";
        }
    }, [
        activeVariant
    ]);
    var ref2;
    const descriptionHTML = (0,react.useMemo)(()=>{
        var ref;
        return {
            __html: (ref2 = product === null || product === void 0 ? void 0 : (ref = product.description) === null || ref === void 0 ? void 0 : ref.is) !== null && ref2 !== void 0 ? ref2 : ""
        };
    }, [
        product === null || product === void 0 ? void 0 : (ref = product.description) === null || ref === void 0 ? void 0 : ref.is
    ]);
    (0,react.useEffect)(()=>{
        if (!firedAnalyticsImpression) {
            setFiredAnalyticsImpression(true);
            let price = "0";
            try {
                var ref, ref1;
                var ref2;
                price = (ref2 = activeVariant === null || activeVariant === void 0 ? void 0 : (ref = activeVariant.price) === null || ref === void 0 ? void 0 : (ref1 = ref.gross) === null || ref1 === void 0 ? void 0 : ref1.toString()) !== null && ref2 !== void 0 ? ref2 : "0";
            } catch (e) {
            // silent
            }
            lib_analytics_src/* analytics.addProductPageViewImpression */.c.addProductPageViewImpression(product, price);
        }
    }, [
        activeVariant === null || activeVariant === void 0 ? void 0 : (ref1 = activeVariant.price) === null || ref1 === void 0 ? void 0 : ref1.gross,
        firedAnalyticsImpression,
        product
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ProductDetailContainer, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(FlexRow, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Brand, {
                        children: brand !== null && brand !== void 0 ? brand : ""
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(SkuNumber, {
                        children: [
                            "VNR. ",
                            activeVariant === null || activeVariant === void 0 ? void 0 : activeVariant.sku
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductName, {
                fontWeight: "400",
                maxFontSize: "48px",
                textColor: lib_styles_src/* theme.palette.blue.dark */.rS.palette.blue.dark,
                uppercase: true,
                children: product === null || product === void 0 ? void 0 : product.name
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Descriptions, {
                className: "showMore",
                dangerouslySetInnerHTML: descriptionHTML
            }),
            EnergyLabel && /*#__PURE__*/ (0,jsx_runtime.jsx)(EnergyWrapper, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(EnergyLabel, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StockStatus, {
                activeVariantSKU: activeVariantSKU,
                errorMessage: null,
                productSlug: product.slug
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/features/products/components/product-page/product-detail/index.ts







;// CONCATENATED MODULE: ./src/features/products/components/product-page/component/styles.ts
function component_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function component_styles_templateObject() {
    const data = component_styles_taggedTemplateLiteral([
        "\n  object-fit: contain;\n"
    ]);
    component_styles_templateObject = function() {
        return data;
    };
    return data;
}
function component_styles_templateObject1() {
    const data = component_styles_taggedTemplateLiteral([
        "\n  position: relative;\n  width: 100%;\n  height: 100%;\n"
    ]);
    component_styles_templateObject1 = function() {
        return data;
    };
    return data;
}
function component_styles_templateObject2() {
    const data = component_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  width: 100%;\n  max-width: 1616px;\n  align-items: flex-start;\n  justify-content: space-between;\n  margin-top: 50px;\n  margin-right: auto;\n  margin-bottom: 50px;\n  margin-left: auto;\n  gap: 50px;\n  grid-template-columns: 0.5fr 0.5fr;\n  transition: all 300ms;\n  @media screen and (max-width: ",
        "px) {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    padding: 0 20px;\n  }\n  @media screen and (max-width: ",
        "px) {\n    padding: 0px;\n  }\n  @media screen and (max-width: 1078px) {\n    margin-top: 16px;\n  }\n"
    ]);
    component_styles_templateObject2 = function() {
        return data;
    };
    return data;
}
function component_styles_templateObject3() {
    const data = component_styles_taggedTemplateLiteral([
        "\n  width: 100%;\n  max-width: 700px;\n  height: 100%;\n  max-height: 700px;\n  cursor: ",
        ";\n  object-fit: contain;\n"
    ]);
    component_styles_templateObject3 = function() {
        return data;
    };
    return data;
}
function component_styles_templateObject4() {
    const data = component_styles_taggedTemplateLiteral([
        "\n  position: relative;\n  display: flex;\n  width: 100%;\n  min-width: 200px;\n  height: 400px;\n  align-items: center;\n  justify-content: center;\n  padding-top: 48px;\n  padding-bottom: 48px;\n\n  .image-selection-button {\n    position: absolute;\n    top: 50%;\n    width: 40px;\n    height: 40px;\n    opacity: 0;\n    transform: translateY(-50%);\n    &.previous-image-button {\n      left: 8px;\n    }\n    &.next-image-button {\n      right: 8px;\n    }\n  }\n  &:hover {\n    .image-selection-button {\n      opacity: 1;\n    }\n  }\n  @media screen and (max-width: 699px) {\n    max-height: 20vh;\n    padding-top: unset;\n    padding-bottom: unset;\n  }\n"
    ]);
    component_styles_templateObject4 = function() {
        return data;
    };
    return data;
}
function component_styles_templateObject5() {
    const data = component_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  width: 50%;\n  flex-direction: column;\n  gap: 10px;\n  @media screen and (max-width: ",
        "px) {\n    width: 100%;\n  }\n"
    ]);
    component_styles_templateObject5 = function() {
        return data;
    };
    return data;
}
function component_styles_templateObject6() {
    const data = component_styles_taggedTemplateLiteral([
        "\n  position: relative;\n  min-width: 152px;\n  max-width: 152px;\n  height: 106px;\n  object-fit: contain;\n  transform: translate3d(-",
        "px, 0, 0);\n  transition: 400ms;\n"
    ]);
    component_styles_templateObject6 = function() {
        return data;
    };
    return data;
}
function component_styles_templateObject7() {
    const data = component_styles_taggedTemplateLiteral([
        "\n  position: relative;\n  overflow: hidden;\n  min-width: 152px;\n  max-width: 152px;\n  height: 106px;\n  border: 1px solid ",
        ";\n  transform: translate3d(-",
        "px, -2px, 0);\n  transition: 400ms;\n"
    ]);
    component_styles_templateObject7 = function() {
        return data;
    };
    return data;
}
function component_styles_templateObject8() {
    const data = component_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  width: 100%;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n"
    ]);
    component_styles_templateObject8 = function() {
        return data;
    };
    return data;
}
function component_styles_templateObject9() {
    const data = component_styles_taggedTemplateLiteral([
        "\n  position: relative;\n  width: calc(100% - 8px);\n  height: 1px;\n  background-color: ",
        ";\n  &::after {\n    position: absolute;\n    top: -1px;\n    left: ",
        ";\n    width: ",
        ";\n    height: 3px;\n    background-color: ",
        ';\n    content: "";\n    transition: 400ms;\n  }\n'
    ]);
    component_styles_templateObject9 = function() {
        return data;
    };
    return data;
}
function component_styles_templateObject10() {
    const data = component_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  margin-top: ",
        ";\n  &:focus {\n    box-shadow: none;\n    -webkit-user-drag: none;\n    * {\n      -webkit-user-drag: none;\n    }\n  }\n\n  .demoupUI-img {\n    object-fit: contain;\n    svg {\n      width: 48px;\n    }\n  }\n"
    ]);
    component_styles_templateObject10 = function() {
        return data;
    };
    return data;
}
function component_styles_templateObject11() {
    const data = component_styles_taggedTemplateLiteral([
        "\n  &:focus {\n    box-shadow: none;\n    -webkit-user-drag: none;\n    * {\n      -webkit-user-drag: none;\n    }\n  }\n"
    ]);
    component_styles_templateObject11 = function() {
        return data;
    };
    return data;
}
function component_styles_templateObject12() {
    const data = component_styles_taggedTemplateLiteral([
        "\n  display: none;\n  overflow: hidden;\n  width: 0;\n  height: 0;\n  pointer-events: none;\n"
    ]);
    component_styles_templateObject12 = function() {
        return data;
    };
    return data;
}
function component_styles_templateObject13() {
    const data = component_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  overflow: hidden;\n  width: 100%;\n  padding: 1rem 0;\n  margin-top: auto;\n  margin-bottom: 0.5rem;\n\n  gap: 1rem;\n  -ms-overflow-style: none;\n\n  overflow-x: auto;\n  scrollbar-width: none;\n\n  /* Smooth transitions */\n  transition: all 0.3s ease-in-out;\n  &::-webkit-scrollbar {\n    display: none;\n  }\n\n  /* Responsive design */\n  @media screen and (max-width: 699px) {\n    padding: 0.5rem 0;\n    margin-top: auto;\n    margin-bottom: 0.2rem;\n    gap: 0.5rem;\n  }\n\n  @media screen and (min-width: 700px) and (max-width: 1024px) {\n    padding: 0.75rem 0;\n    margin-top: auto;\n    margin-bottom: 0.2rem;\n    gap: 0.75rem;\n  }\n"
    ]);
    component_styles_templateObject13 = function() {
        return data;
    };
    return data;
}
function component_styles_templateObject14() {
    const data = component_styles_taggedTemplateLiteral([
        "\n  width: 100%;\n  max-width: ",
        "px;\n  margin: auto;\n  margin-top: 40px;\n"
    ]);
    component_styles_templateObject14 = function() {
        return data;
    };
    return data;
}
function component_styles_templateObject15() {
    const data = component_styles_taggedTemplateLiteral([
        "\n  width: 100%;\n  height: fit-content;\n  padding: 40px;\n  margin-top: 40px;\n  background-color: ",
        ";\n"
    ]);
    component_styles_templateObject15 = function() {
        return data;
    };
    return data;
}
function component_styles_templateObject16() {
    const data = component_styles_taggedTemplateLiteral([
        "\n  width: 100%;\n  max-width: ",
        "px;\n  margin-top: 24px;\n  margin-right: auto;\n  margin-left: auto;\n"
    ]);
    component_styles_templateObject16 = function() {
        return data;
    };
    return data;
}
function component_styles_templateObject17() {
    const data = component_styles_taggedTemplateLiteral([
        "\n  position: relative;\n  display: flex;\n  width: 100%;\n  height: 100%;\n  flex-direction: COLUMN;\n  align-items: center;\n  justify-content: center;\n\n  .image-selection-button {\n    position: absolute;\n    top: 50%;\n    width: 56px;\n    height: 56px;\n    opacity: 1;\n    transform: translateY(-50%);\n    &.previous-image-button {\n      left: -2.4rem;\n    }\n    &.next-image-button {\n      right: -2.4rem;\n    }\n  }\n\n  @media screen and (min-width: 768px) and (max-width: 1024px) and (orientation: portrait) {\n    .image-selection-button {\n      &.previous-image-button {\n        left: -2.6rem;\n      }\n      &.next-image-button {\n        right: -2.6rem;\n      }\n    }\n  }\n\n  @media screen and (max-width: 480px) {\n    .image-selection-button {\n      width: 45px;\n      height: 45px;\n      &.previous-image-button {\n        left: -2.9rem;\n      }\n      &.next-image-button {\n        right: -2.9rem;\n      }\n    }\n  }\n"
    ]);
    component_styles_templateObject17 = function() {
        return data;
    };
    return data;
}


const ElectronicImage = styled_components_browser_cjs["default"].img.withConfig({
    componentId: "sc-2a004201-0"
})(component_styles_templateObject());
const ElectronicImageContainer = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-2a004201-1"
})(component_styles_templateObject1());
const ProductWrapper = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-2a004201-2"
})(component_styles_templateObject2(), lib_styles_src/* gridTheme.container.maxWidth.s */.k.container.maxWidth.s, lib_styles_src/* gridTheme.container.maxWidth.xs */.k.container.maxWidth.xs);
const ProductImage = styled_components_browser_cjs["default"].img.withConfig({
    componentId: "sc-2a004201-3"
})(component_styles_templateObject3(), (props)=>props.clickable ? "pointer" : "default");
const ImageWrapper = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-2a004201-4"
})(component_styles_templateObject4());
const LeftWrapper = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-2a004201-5"
})(component_styles_templateObject5(), lib_styles_src/* gridTheme.container.maxWidth.s */.k.container.maxWidth.s);
const SliderImage = styled_components_browser_cjs["default"].img.withConfig({
    componentId: "sc-2a004201-6"
})(component_styles_templateObject6(), (props)=>props.transformValue.toString());
const SliderItem = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-2a004201-7"
})(component_styles_templateObject7(), lib_styles_src/* theme.palette.gray.10 */.rS.palette.gray[10], (props)=>props.transformValue.toString());
const component_styles_PaginationContainer = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-2a004201-8"
})(component_styles_templateObject8());
const ProgressBar = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-2a004201-9"
})(component_styles_templateObject9(), lib_styles_src/* theme.palette.gray.30 */.rS.palette.gray[30], (props)=>props.progress, (props)=>props.sliderSize, lib_styles_src/* theme.palette.blue.main */.rS.palette.blue.main);
const ClickableDemoupSlideWrapper = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-2a004201-10"
})(component_styles_templateObject10(), (props)=>props.marginTop ? "39px" : "0");
const ClickableSliderImageWrapper = styled_components_browser_cjs["default"].button.withConfig({
    componentId: "sc-2a004201-11"
})(component_styles_templateObject11());
const HiddenContainer = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-2a004201-12"
})(component_styles_templateObject12());
const ImageFlex = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-2a004201-13"
})(component_styles_templateObject13());
const TabsContainer = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-2a004201-14"
})(component_styles_templateObject14(), lib_styles_src/* gridTheme.maxContentWidth */.k.maxContentWidth);
const VideoSlideWrapper = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-2a004201-15"
})(component_styles_templateObject15(), lib_styles_src/* theme.palette.white.main */.rS.palette.white.main);
const TagContainer = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-2a004201-16"
})(component_styles_templateObject16(), lib_styles_src/* gridTheme.maxContentWidth */.k.maxContentWidth);
const ModalContainer = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-2a004201-17"
})(component_styles_templateObject17());

;// CONCATENATED MODULE: ./src/features/tags/styles.ts
function tags_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function tags_styles_templateObject() {
    const data = tags_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  column-gap: 8px;\n  text-transform: uppercase;\n  @media screen and (max-width: ",
        "px) {\n    flex-wrap: wrap;\n  }\n"
    ]);
    tags_styles_templateObject = function() {
        return data;
    };
    return data;
}
function tags_styles_templateObject1() {
    const data = tags_styles_taggedTemplateLiteral([
        "\n  position: relative;\n  display: flex;\n  overflow: hidden;\n  width: fit-content;\n  align-items: center;\n  padding: 16px 36px 16px 20px;\n  margin-right: 8px;\n  margin-bottom: 8px;\n  background-color: ",
        ";\n  color: ",
        ';\n  font-size: 18px;\n  -webkit-font-smoothing: antialiased;\n  font-style: italic;\n  font-weight: 900;\n  &:before {\n    position: absolute;\n    top: 0;\n    right: 0;\n    width: 26px;\n    height: 100%;\n    background-color: white;\n    content: "";\n    transform: rotate(45deg);\n    transform-origin: bottom left;\n  }\n  &:after {\n    position: absolute;\n    top: 0;\n    right: 0;\n    width: 26px;\n    height: 100%;\n    background-color: white;\n    content: "";\n    transform: rotate(-45deg);\n    transform-origin: top left;\n  }\n  @media screen and (max-width: ',
        "px) {\n    padding: 8px 36px 8px 8px;\n    margin-top: 10px;\n    margin-bottom: 1px;\n    font-size: 12px;\n  }\n"
    ]);
    tags_styles_templateObject1 = function() {
        return data;
    };
    return data;
}


const TagsWrapper = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-32500651-0"
})(tags_styles_templateObject(), lib_styles_src/* gridTheme.container.maxWidth.sm */.k.container.maxWidth.sm);
const Tag = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-32500651-1"
})(tags_styles_templateObject1(), (props)=>props.color === "blue" ? lib_styles_src/* theme.palette.blue.main */.rS.palette.blue.main : props.color === "green" ? lib_styles_src/* theme.palette.green.dark */.rS.palette.green.dark : lib_styles_src/* theme.palette.yellow.main */.rS.palette.yellow.main, (props)=>props.color === "yellow" ? lib_styles_src/* theme.palette.blue.dark */.rS.palette.blue.dark : lib_styles_src/* theme.palette.yellow.main */.rS.palette.yellow.main, lib_styles_src/* gridTheme.container.maxWidth.sm */.k.container.maxWidth.sm);

;// CONCATENATED MODULE: ./src/features/tags/index.tsx



const tags_Tags = (param)=>{
    let { tags  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TagsWrapper, {
        children: tags.map((param)=>/*#__PURE__*/ {
            let { label , color  } = param;
            return (0,jsx_runtime.jsx)(Tag, {
                color: color !== null && color !== void 0 ? color : "blue",
                children: label
            }, label);
        })
    });
};

// EXTERNAL MODULE: ./src/features/search/components/product-list.tsx
var product_list = __webpack_require__(63839);
;// CONCATENATED MODULE: ./src/features/products/components/product-page/component/energy-labels.tsx
/* eslint-disable max-len */ 
function EnergyA() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        fill: "none",
        height: "38",
        viewBox: "0 0 68 38",
        width: "68",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                clipPath: "url(#clip0_1_2)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M66.953 0.59761H52.7053V37.4086H66.953V0.59761Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M15.6213 0.597336H52.7542V37.4083H15.6213L0.671814 19.0028L15.6213 0.597336Z",
                        fill: "#06A64F"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M15.9896 0.327708H66.9602C67.0318 0.327708 67.1004 0.356143 67.1511 0.406758C67.2017 0.457373 67.2301 0.526022 67.2301 0.597602V37.4086C67.2301 37.4802 67.2017 37.5488 67.1511 37.5994C67.1004 37.65 67.0318 37.6785 66.9602 37.6785H15.9896C15.9526 37.6786 15.916 37.671 15.882 37.6563C15.848 37.6415 15.8174 37.62 15.7922 37.5929L0.842638 19.1611C0.795898 19.1111 0.769897 19.0452 0.769897 18.9768C0.769897 18.9083 0.795898 18.8424 0.842638 18.7924L15.7922 0.360622C15.8513 0.324737 15.922 0.312955 15.9896 0.327708Z",
                        stroke: "#231F20",
                        strokeLinejoin: "round",
                        strokeWidth: "0.539789"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M43.3475 28.4142C43.45 28.7264 43.5278 29.0461 43.5802 29.3705C43.6018 29.4622 43.6019 29.5578 43.5804 29.6496C43.559 29.7414 43.5166 29.827 43.4565 29.8997C43.2849 30.0391 43.0709 30.116 42.8497 30.1178C42.5594 30.1455 42.1616 30.1593 41.6531 30.1593C41.1254 30.1593 40.7129 30.1508 40.418 30.1347C40.1894 30.1284 39.9624 30.0943 39.7421 30.0333C39.6135 30.0009 39.4991 29.9272 39.4164 29.8236C39.3453 29.7155 39.2926 29.5964 39.2605 29.4711L37.9086 25.1083H30.3571L29.0828 29.3542C29.0486 29.493 28.9936 29.6259 28.9196 29.7482C28.8401 29.8642 28.726 29.9521 28.5936 29.9994C28.3885 30.0723 28.1738 30.1147 27.9564 30.1253C27.6818 30.1484 27.3218 30.1596 26.8765 30.1592C26.5028 30.1642 26.1291 30.1473 25.7574 30.1085C25.5466 30.1027 25.3461 30.0157 25.1979 29.8658C25.1432 29.7872 25.1054 29.6982 25.0867 29.6044C25.068 29.5106 25.0688 29.4139 25.0892 29.3204C25.1406 29.0011 25.2186 28.6866 25.3223 28.3802L31.5219 9.11489C31.5715 8.95129 31.6449 8.79588 31.7397 8.65363C31.8397 8.52402 31.9786 8.42992 32.1361 8.38519C32.381 8.31302 32.6343 8.27351 32.8896 8.26768C33.2106 8.25079 33.6354 8.24234 34.1638 8.24234C34.7748 8.24234 35.2617 8.25079 35.6243 8.26768C35.9105 8.27319 36.195 8.31273 36.4719 8.38545C36.6436 8.42711 36.7966 8.5245 36.907 8.66239C37.0093 8.81648 37.0853 8.98647 37.132 9.16545L43.3475 28.4142ZM34.1173 12.4881H34.1021L31.2583 21.7179H36.9606L34.1173 12.4881Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M41.6899 30.3766H40.4556C40.2078 30.3701 39.9617 30.3332 39.7228 30.2666C39.5527 30.2212 39.4018 30.1219 39.2927 29.9836C39.2029 29.8521 39.1366 29.706 39.0968 29.5519L37.7926 25.3358H30.5429L29.3133 29.4421C29.2731 29.5977 29.2102 29.7465 29.1266 29.8837C29.023 30.0392 28.873 30.158 28.698 30.2232C28.473 30.3031 28.2375 30.3497 27.999 30.3614H26.9114C26.5315 30.366 26.1517 30.3501 25.7735 30.3138C25.5123 30.306 25.2648 30.1953 25.0849 30.0058C25.0075 29.9026 24.9531 29.7842 24.925 29.6584C24.897 29.5326 24.8961 29.4023 24.9224 29.2761C24.9755 28.9472 25.0566 28.6235 25.1648 28.3084L31.2904 8.97986C31.3463 8.79642 31.429 8.62223 31.5358 8.46292C31.6635 8.29534 31.8409 8.17236 32.0426 8.11153C32.3167 8.03004 32.6008 7.98737 32.8867 7.98474H35.6258C35.9307 7.98934 36.234 8.03134 36.5287 8.10981C36.743 8.16201 36.9339 8.28403 37.0713 8.45666C37.1913 8.63177 37.2809 8.82588 37.3363 9.03081L43.5794 28.3588C43.6856 28.6818 43.767 29.0125 43.8229 29.348C43.8487 29.4692 43.8467 29.5946 43.817 29.7148C43.7874 29.8351 43.7309 29.9471 43.6518 30.0424C43.4404 30.2288 43.1693 30.3334 42.8875 30.3373C42.4895 30.3743 42.0895 30.3875 41.6899 30.3766ZM30.2326 24.9195H38.0999L39.4978 29.439C39.5246 29.5456 39.5693 29.6469 39.6299 29.7386C39.683 29.8005 39.7538 29.8447 39.8327 29.8653C40.0378 29.9221 40.249 29.954 40.4618 29.9605H41.6899C42.0798 29.9708 42.4699 29.9582 42.8582 29.9229C43.0401 29.9248 43.2169 29.8634 43.3585 29.7493C43.3888 29.7022 43.4093 29.6496 43.4188 29.5944C43.4283 29.5392 43.4266 29.4827 43.4138 29.4283C43.3613 29.1094 43.2842 28.7951 43.1834 28.4881L36.9346 9.14305C36.8932 8.98625 36.8259 8.83749 36.7354 8.70292C36.6555 8.60855 36.5473 8.54232 36.427 8.514C36.1643 8.44393 35.8941 8.40635 35.6224 8.40209H32.8887C32.6425 8.40418 32.3977 8.4409 32.1617 8.51117C32.0473 8.54514 31.9462 8.61386 31.8725 8.7078C31.7929 8.83055 31.7309 8.96382 31.6882 9.10375L25.5604 28.4387C25.4586 28.7364 25.3821 29.0422 25.3318 29.3528C25.3165 29.4193 25.3152 29.4883 25.3281 29.5553C25.3409 29.6224 25.3675 29.686 25.4063 29.7422C25.5128 29.8408 25.6521 29.8963 25.7973 29.8981C26.1665 29.9338 26.5374 29.9494 26.9083 29.9449H27.9887C28.1823 29.9341 28.3733 29.8956 28.5559 29.8305C28.6457 29.797 28.7229 29.7363 28.7767 29.6569C28.8373 29.5553 28.8827 29.4453 28.9115 29.3305L30.2326 24.9195ZM37.2457 21.8825H30.9789L34.0992 11.7256L37.2457 21.8825ZM31.5427 21.4662H36.6804L34.1008 13.1395L31.5427 21.4662Z",
                        fill: "#010101"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M63.9892 11.5115C64.036 11.6437 64.0717 11.7796 64.0959 11.9178C64.1055 11.957 64.1053 11.998 64.0954 12.0371C64.0854 12.0763 64.0659 12.1123 64.0387 12.1422C63.9584 12.202 63.8611 12.2344 63.761 12.2347C63.6279 12.2463 63.4451 12.2521 63.2126 12.252C62.9703 12.252 62.7819 12.2489 62.6465 12.2418C62.5419 12.2394 62.4379 12.2249 62.3367 12.1987C62.2786 12.1857 62.2261 12.1547 62.1868 12.11C62.1548 12.0645 62.1309 12.0138 62.1161 11.9602L61.4964 10.1082H58.0339L57.4502 11.9107C57.4343 11.97 57.4091 12.0264 57.3756 12.0779C57.3379 12.128 57.2856 12.1653 57.2258 12.1846C57.1314 12.2156 57.0332 12.2335 56.934 12.238C56.808 12.2476 56.643 12.2523 56.439 12.252C56.2677 12.2542 56.0965 12.2471 55.926 12.2308C55.8308 12.229 55.7395 12.1924 55.6693 12.128C55.6444 12.0954 55.627 12.0577 55.6183 12.0176C55.6097 11.9774 55.61 11.9359 55.6192 11.8959C55.6429 11.7601 55.6789 11.6267 55.7265 11.4974L58.5687 3.32031C58.5917 3.25025 58.6253 3.18412 58.6683 3.12421C58.7158 3.06845 58.7794 3.02873 58.8503 3.01046C58.9627 2.98009 59.0784 2.96347 59.1948 2.96095C59.3427 2.95385 59.5371 2.95003 59.7798 2.95003C60.0595 2.95003 60.2825 2.95367 60.449 2.96095C60.5797 2.9633 60.7096 2.9799 60.8366 3.01046C60.9141 3.02751 60.9841 3.0687 61.0366 3.12809C61.0833 3.19261 61.1184 3.26485 61.1401 3.34151L63.9892 11.5115ZM59.758 4.75174H59.7509L58.4475 8.66929H61.0613L59.758 4.75174Z",
                        fill: "#231D1E"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M62.4546 16.7022L60.3744 14.622C60.2372 14.4853 60.0514 14.4086 59.8576 14.4086C59.6639 14.4086 59.4781 14.4853 59.3409 14.622L57.2607 16.7022C57.1237 16.8393 57.0467 17.0251 57.0467 17.219C57.0467 17.4128 57.1237 17.5987 57.2607 17.7357C57.3978 17.8728 57.5837 17.9497 57.7775 17.9497C57.9713 17.9497 58.1572 17.8728 58.2942 17.7357L59.1265 16.9036V23.0256C59.1265 23.2194 59.2035 23.4053 59.3406 23.5424C59.4777 23.6795 59.6636 23.7565 59.8574 23.7565C60.0513 23.7565 60.2372 23.6795 60.3743 23.5424C60.5113 23.4053 60.5883 23.2194 60.5883 23.0256V16.9036L61.4207 17.7359C61.5577 17.873 61.7436 17.9499 61.9374 17.9499C62.1312 17.9499 62.3171 17.873 62.4542 17.7359C62.5912 17.5989 62.6682 17.413 62.6682 17.2192C62.6682 17.0253 62.5916 16.8393 62.4546 16.7022Z",
                        fill: "#211F11"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M63.4532 27.2642C63.4539 27.3814 63.4485 27.4986 63.4371 27.6152C63.4301 27.695 63.4148 27.7739 63.3915 27.8505C63.3791 27.8971 63.3545 27.9395 63.3201 27.9733C63.2918 27.9967 63.256 28.0093 63.2192 28.0087C63.1189 27.9902 63.0249 27.9466 62.946 27.882C62.7859 27.779 62.6187 27.6875 62.4457 27.6082C62.2048 27.4977 61.9557 27.4062 61.7006 27.3343C61.3733 27.2451 61.035 27.2027 60.6958 27.2083C60.3153 27.2027 59.9381 27.2804 59.5908 27.4359C59.2643 27.5857 58.9754 27.8067 58.7454 28.0826C58.5018 28.3789 58.3184 28.7201 58.2056 29.0867C58.0756 29.5061 58.012 29.9431 58.0172 30.3821C58.0091 30.8471 58.0739 31.3104 58.2094 31.7552C58.3194 32.119 58.5018 32.4569 58.7456 32.7484C58.9706 33.0124 59.2548 33.2195 59.575 33.3527C59.9142 33.4921 60.2781 33.5615 60.6448 33.5567C60.8355 33.5565 61.0254 33.533 61.2104 33.4867C61.3927 33.4415 61.5676 33.3706 61.7299 33.276V31.1685H60.137C60.0592 31.1685 59.9981 31.1164 59.9551 31.011C59.9024 30.8369 59.8805 30.6551 59.8902 30.4735C59.8888 30.3634 59.8944 30.2532 59.9069 30.1437C59.9139 30.0705 59.9301 29.9983 59.9551 29.9291C59.9715 29.884 59.9981 29.8433 60.0329 29.8101C60.0618 29.7851 60.0988 29.7714 60.137 29.7716H62.9782C63.0422 29.7704 63.1056 29.7836 63.1639 29.8101C63.2199 29.8373 63.2689 29.8769 63.3073 29.9259C63.35 29.9813 63.3819 30.0443 63.4012 30.1116C63.4239 30.1928 63.4347 30.2768 63.4333 30.361V33.9778C63.4364 34.104 63.4132 34.2296 63.3652 34.3464C63.308 34.4626 63.208 34.552 63.0861 34.5958C62.9447 34.6563 62.7701 34.7199 62.5628 34.7848C62.3556 34.8497 62.1386 34.907 61.9155 34.9539C61.6921 35.0008 61.4664 35.0358 61.2392 35.0587C61.0114 35.0826 60.7824 35.0946 60.5533 35.0947C59.9375 35.1045 59.3254 34.9983 58.7488 34.7816C58.2361 34.586 57.7747 34.2762 57.3994 33.8759C57.0185 33.4589 56.7303 32.9659 56.554 32.4294C56.3505 31.805 56.2517 31.1512 56.2615 30.4945C56.2515 29.8132 56.3572 29.1352 56.5741 28.4893C56.7622 27.9308 57.063 27.4169 57.4578 26.9795C57.8418 26.5635 58.3138 26.2384 58.8394 26.0281C59.4139 25.8017 60.0271 25.6897 60.6445 25.6983C60.9777 25.6955 61.3105 25.7224 61.639 25.7786C61.9047 25.8243 62.1665 25.89 62.4223 25.9753C62.6156 26.039 62.8017 26.1226 62.9778 26.2247C63.0912 26.2871 63.1953 26.365 63.2871 26.4562C63.3526 26.5363 63.3962 26.632 63.4138 26.7339C63.4447 26.9089 63.4579 27.0866 63.4532 27.2642Z",
                        fill: "#010101"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_1_2",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        fill: "white",
                        height: "38",
                        transform: "translate(0.5)",
                        width: "67"
                    })
                })
            })
        ]
    });
}
function EnergyB() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        fill: "none",
        height: "38",
        viewBox: "0 0 68 38",
        width: "68",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                clipPath: "url(#clip0_1_38)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M67.0022 0.59761H52.7545V37.4086H67.0022V0.59761Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M15.6213 0.597336H52.7542V37.4083H15.6213L0.671814 19.0028L15.6213 0.597336Z",
                        fill: "#51B848"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M15.9896 0.327708H66.9602C67.0318 0.327708 67.1004 0.356143 67.1511 0.406758C67.2017 0.457373 67.2301 0.526022 67.2301 0.597602V37.4086C67.2301 37.4802 67.2017 37.5488 67.1511 37.5994C67.1004 37.65 67.0318 37.6785 66.9602 37.6785H15.9896C15.9526 37.6785 15.916 37.671 15.882 37.6562C15.848 37.6415 15.8174 37.62 15.7922 37.5929L0.842638 19.1611C0.795898 19.1111 0.769897 19.0452 0.769897 18.9768C0.769897 18.9083 0.795898 18.8424 0.842638 18.7924L15.7922 0.360622C15.8513 0.324737 15.922 0.312955 15.9896 0.327708Z",
                        stroke: "#231F20",
                        strokeLinejoin: "round",
                        strokeWidth: "0.539789"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M63.9891 11.5115C64.036 11.6437 64.0717 11.7796 64.0959 11.9178C64.1055 11.957 64.1053 11.998 64.0953 12.0371C64.0853 12.0763 64.0659 12.1123 64.0386 12.1422C63.9584 12.202 63.8611 12.2344 63.761 12.2347C63.6279 12.2463 63.4451 12.2521 63.2126 12.252C62.9703 12.252 62.7819 12.2489 62.6465 12.2418C62.5419 12.2394 62.4379 12.2249 62.3367 12.1987C62.2786 12.1858 62.2261 12.1547 62.1869 12.11C62.1549 12.0645 62.131 12.0138 62.1161 11.9602L61.4962 10.1082H58.0336L57.4499 11.9107C57.434 11.97 57.4088 12.0264 57.3753 12.0779C57.3376 12.128 57.2853 12.1653 57.2255 12.1846C57.1311 12.2156 57.033 12.2335 56.9337 12.238C56.8077 12.2476 56.6427 12.2523 56.4387 12.252C56.2674 12.2542 56.0962 12.2471 55.9257 12.2308C55.8304 12.229 55.7391 12.1924 55.6689 12.128C55.644 12.0954 55.6266 12.0577 55.618 12.0176C55.6093 11.9774 55.6096 11.9359 55.6188 11.8959C55.6426 11.7601 55.6785 11.6268 55.7262 11.4974L58.5687 3.32031C58.5917 3.25024 58.6253 3.18411 58.6683 3.12421C58.7158 3.06847 58.7793 3.02875 58.8502 3.01046C58.9626 2.9801 59.0783 2.96348 59.1948 2.96095C59.3427 2.95385 59.5371 2.95003 59.7798 2.95003C60.0594 2.95003 60.2825 2.95367 60.449 2.96095C60.5796 2.9633 60.7096 2.9799 60.8366 3.01046C60.914 3.02752 60.984 3.06871 61.0366 3.12809C61.0833 3.19262 61.1183 3.26486 61.14 3.34151L63.9891 11.5115ZM59.7579 4.75174H59.7509L58.4475 8.66929H61.0617L59.7579 4.75174Z",
                        fill: "#231D1E"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M62.4545 16.7022L60.3743 14.6221C60.2371 14.4854 60.0513 14.4086 59.8576 14.4086C59.6639 14.4086 59.4781 14.4854 59.3408 14.6221L57.2607 16.7022C57.1928 16.7701 57.139 16.8506 57.1023 16.9393C57.0655 17.028 57.0466 17.123 57.0466 17.219C57.0466 17.3149 57.0655 17.41 57.1023 17.4986C57.139 17.5873 57.1928 17.6679 57.2607 17.7357C57.3285 17.8036 57.4091 17.8574 57.4978 17.8941C57.5864 17.9309 57.6815 17.9498 57.7774 17.9498C57.8734 17.9498 57.9684 17.9309 58.0571 17.8941C58.1458 17.8574 58.2263 17.8036 58.2942 17.7357L59.1264 16.9036V23.0256C59.1264 23.2194 59.2034 23.4053 59.3405 23.5424C59.4775 23.6795 59.6634 23.7565 59.8573 23.7565C60.0511 23.7565 60.2371 23.6795 60.3741 23.5424C60.5112 23.4053 60.5882 23.2194 60.5882 23.0256V16.9036L61.4207 17.736C61.5577 17.8731 61.7436 17.9501 61.9374 17.9501C62.1312 17.9501 62.3171 17.8731 62.4542 17.736C62.5912 17.599 62.6682 17.4131 62.6682 17.2193C62.6682 17.0255 62.5915 16.8393 62.4545 16.7022Z",
                        fill: "#211F11"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M63.4532 27.2642C63.4538 27.3814 63.4485 27.4986 63.4371 27.6152C63.4301 27.695 63.4148 27.7739 63.3915 27.8505C63.3791 27.8971 63.3545 27.9395 63.3201 27.9733C63.2917 27.9967 63.2559 28.0093 63.2191 28.0087C63.1189 27.9902 63.0249 27.9466 62.946 27.882C62.7859 27.779 62.6187 27.6875 62.4457 27.6082C62.2048 27.4977 61.9557 27.4062 61.7006 27.3343C61.3733 27.2452 61.035 27.2027 60.6958 27.2084C60.3153 27.2027 59.9381 27.2804 59.5908 27.4359C59.2643 27.5857 58.9754 27.8067 58.7454 28.0826C58.5018 28.379 58.3184 28.7201 58.2056 29.0868C58.0756 29.5061 58.0121 29.9431 58.0173 30.3821C58.0091 30.8471 58.074 31.3104 58.2095 31.7552C58.3194 32.119 58.5018 32.4569 58.7456 32.7484C58.9706 33.0124 59.2548 33.2195 59.575 33.3527C59.9142 33.4921 60.2781 33.5615 60.6447 33.5567C60.8355 33.5565 61.0254 33.533 61.2105 33.4867C61.3927 33.4415 61.5676 33.3706 61.7298 33.276V31.1685H60.1368C60.0591 31.1685 59.998 31.1164 59.9549 31.011C59.9022 30.837 59.8802 30.6551 59.89 30.4735C59.8886 30.3634 59.8942 30.2532 59.9067 30.1437C59.9137 30.0704 59.9299 29.9983 59.9549 29.9291C59.9714 29.884 59.998 29.8433 60.0327 29.8101C60.0616 29.7851 60.0986 29.7714 60.1368 29.7716H62.9782C63.0423 29.7704 63.1057 29.7836 63.164 29.8101C63.22 29.8373 63.269 29.8769 63.3073 29.9259C63.3501 29.9813 63.3819 30.0443 63.4012 30.1116C63.4239 30.1928 63.4347 30.2768 63.4333 30.361V33.9778C63.4364 34.104 63.4132 34.2296 63.3652 34.3464C63.3081 34.4626 63.2081 34.5521 63.0862 34.5958C62.9448 34.6563 62.7703 34.7199 62.563 34.7848C62.3557 34.8497 62.1386 34.907 61.9156 34.9539C61.6922 35.0009 61.4665 35.0359 61.2394 35.0589C61.0116 35.0829 60.7826 35.0949 60.5535 35.0949C59.9377 35.1047 59.3255 34.9985 58.749 34.7819C58.2363 34.5862 57.7749 34.2765 57.3996 33.8761C57.0186 33.4592 56.7305 32.9662 56.5542 32.4297C56.3507 31.8052 56.2519 31.1514 56.2617 30.4947C56.2515 29.8134 56.3571 29.1353 56.574 28.4893C56.7621 27.9307 57.063 27.4167 57.4579 26.9792C57.8419 26.5632 58.3139 26.2382 58.8394 26.0278C59.4139 25.8015 60.0271 25.6895 60.6445 25.698C60.9778 25.6953 61.3106 25.7221 61.639 25.7784C61.9048 25.824 62.1668 25.8897 62.4227 25.9751C62.6159 26.0388 62.8021 26.1224 62.9781 26.2245C63.0915 26.2869 63.1956 26.3648 63.2875 26.4559C63.3529 26.536 63.3965 26.6317 63.4141 26.7337C63.4449 26.9088 63.458 27.0865 63.4532 27.2642Z",
                        fill: "#010101"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M41.7473 23.5956C41.7563 24.3121 41.6559 25.0259 41.4497 25.7121C41.2669 26.3114 40.9891 26.8774 40.6268 27.3886C40.2793 27.8714 39.8555 28.2944 39.3721 28.641C38.8757 28.9968 38.3357 29.2872 37.7652 29.5052C37.1595 29.736 36.5315 29.9035 35.8912 30.0051C35.1572 30.1172 34.4154 30.1709 33.6728 30.1655H28.2794C27.9572 30.1741 27.6445 30.0555 27.409 29.8353C27.2795 29.69 27.1814 29.5195 27.1207 29.3346C27.0601 29.1496 27.0382 28.9542 27.0564 28.7604V9.65935C27.0381 9.46549 27.06 9.26995 27.1207 9.08493C27.1814 8.89992 27.2795 8.72938 27.409 8.58398C27.6445 8.36378 27.9571 8.24515 28.2794 8.25379H33.3745C34.4378 8.23363 35.4994 8.34741 36.5342 8.59247C37.3225 8.78322 38.0638 9.13178 38.7136 9.61708C39.3029 10.0739 39.7689 10.6705 40.0696 11.3528C40.3988 12.1345 40.5589 12.9771 40.5393 13.8251C40.5429 14.3307 40.48 14.8345 40.3522 15.3237C40.2342 15.7749 40.0492 16.2058 39.8035 16.6022C39.5633 16.9853 39.2642 17.3281 38.9172 17.6181C38.5577 17.9171 38.153 18.1571 37.7182 18.3291C38.278 18.4365 38.8158 18.6369 39.3093 18.922C39.7965 19.2046 40.2272 19.5749 40.5798 20.014C40.953 20.4829 41.2422 21.0128 41.4346 21.5803C41.6513 22.2297 41.757 22.911 41.7473 23.5956ZM36.4166 14.3669C36.4227 13.9639 36.3589 13.5628 36.2283 13.1815C36.1141 12.8491 35.9202 12.5497 35.6636 12.3096C35.39 12.0652 35.0666 11.8832 34.7157 11.776C34.2185 11.6368 33.7031 11.5741 33.187 11.5899H31.1014V17.2795H33.406C33.892 17.2982 34.377 17.2205 34.8328 17.0508C35.1712 16.9105 35.474 16.6964 35.7191 16.4242C35.9567 16.1536 36.1354 15.8365 36.2438 15.493C36.3604 15.1291 36.4187 14.749 36.4166 14.3669ZM37.4668 23.7474C37.4743 23.2825 37.3947 22.8203 37.2319 22.3847C37.085 21.999 36.8486 21.6537 36.5422 21.3772C36.2048 21.0875 35.809 20.8739 35.3816 20.751C34.7842 20.5878 34.1661 20.5136 33.5471 20.5309H31.1014V26.7622H34.0803C34.5709 26.7741 35.0603 26.7083 35.5303 26.5671C35.9057 26.4466 36.2526 26.2509 36.5499 25.992C36.8424 25.7299 37.0727 25.4058 37.2242 25.0434C37.392 24.6323 37.4745 24.1913 37.4668 23.7474Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M28.2408 30.3763C27.8772 30.3758 27.5276 30.2357 27.2643 29.9849C27.1112 29.8168 26.9948 29.6187 26.9223 29.4033C26.8497 29.1878 26.8227 28.9597 26.843 28.7333L26.8418 9.61057C26.8234 9.39002 26.8503 9.16802 26.9209 8.95827C26.9916 8.74852 27.1045 8.55547 27.2526 8.39104C27.5321 8.12693 27.9035 7.9821 28.288 7.98725H33.3536C34.4383 7.96654 35.5212 8.08319 36.5766 8.33443C37.3942 8.52945 38.1632 8.89016 38.8358 9.39426C39.4549 9.87334 39.9444 10.4997 40.2595 11.2163C40.6034 12.0269 40.7694 12.9019 40.7463 13.7821C40.748 14.3046 40.6816 14.8252 40.5488 15.3306C40.4262 15.8017 40.2334 16.2518 39.9768 16.6655C39.7264 17.0669 39.4147 17.4265 39.053 17.7312C38.8294 17.9175 38.5888 18.0826 38.3345 18.2242C38.71 18.3415 39.0711 18.5004 39.4111 18.6981C39.9204 18.9952 40.3707 19.3835 40.7395 19.8435C41.1313 20.3379 41.4335 20.8971 41.6323 21.4958L41.6346 21.5013C41.8413 22.1787 41.9327 22.8861 41.9051 23.5938C41.9138 24.3285 41.8119 25.0603 41.6028 25.7647C41.4233 26.3851 41.146 26.973 40.7813 27.5062C40.4205 28.0098 39.9796 28.451 39.4762 28.8121C38.9716 29.1766 38.4229 29.4757 37.8432 29.7026C37.2238 29.94 36.5811 30.1115 35.9258 30.2141C35.1793 30.3295 34.4246 30.3834 33.6692 30.3753H28.2819C28.2683 30.3763 28.2544 30.3763 28.2408 30.3763ZM28.2525 8.4077C27.9925 8.40617 27.742 8.50524 27.5534 8.68417C27.4458 8.80765 27.3644 8.9517 27.3142 9.10757C27.264 9.26344 27.2459 9.4279 27.2612 9.59095L27.2623 28.7526C27.2453 28.9216 27.2635 29.0923 27.3156 29.2539C27.3677 29.4156 27.4527 29.5647 27.5652 29.692C27.7597 29.8671 28.0138 29.9613 28.2755 29.9553H33.6707C34.4037 29.9584 35.1358 29.906 35.8609 29.7987C36.4864 29.7007 37.0998 29.5371 37.6909 29.3104C38.2372 29.0964 38.7544 28.8144 39.2301 28.4711C39.6952 28.1373 40.1028 27.73 40.4369 27.2652C40.7748 26.7694 41.032 26.2232 41.1987 25.6468C41.3968 24.9789 41.4932 24.285 41.4847 23.5884C41.5111 22.925 41.4257 22.2618 41.2321 21.6267C41.0493 21.0755 40.7712 20.5605 40.4106 20.1053C40.074 19.6862 39.6635 19.3324 39.1993 19.0614C38.7275 18.7878 38.2133 18.595 37.678 18.491L36.9766 18.3542L37.64 18.0891C38.0543 17.924 38.4399 17.6944 38.7824 17.4086C39.1102 17.1327 39.3927 16.807 39.6194 16.4433C39.8538 16.0653 40.0299 15.6542 40.1418 15.2238C40.2659 14.7518 40.3279 14.2656 40.3261 13.7776C40.3481 12.956 40.1938 12.1393 39.8735 11.3824C39.5872 10.7323 39.1431 10.164 38.5815 9.72913C37.9551 9.26062 37.2396 8.92526 36.4788 8.74368C35.4566 8.50079 34.4078 8.38799 33.3574 8.40796H28.282L28.2525 8.4077ZM34.1872 26.9724C34.1512 26.9724 34.1148 26.9716 34.0787 26.9708H30.8891V20.3048H33.5436C34.181 20.2874 34.8175 20.3648 35.4323 20.5342C35.8893 20.6659 36.3125 20.8946 36.6731 21.2046C37.0056 21.5045 37.2627 21.8787 37.4235 22.2966C37.5968 22.758 37.682 23.2477 37.6747 23.7405C37.6838 24.2093 37.5978 24.675 37.422 25.1097L37.4212 25.1113C37.2574 25.5039 37.0083 25.8552 36.6919 26.1397C36.3744 26.419 36.0034 26.6307 35.6015 26.7621C35.143 26.9014 34.6664 26.9722 34.1872 26.9724ZM31.3099 26.5507H34.0834C34.5543 26.5612 35.024 26.4972 35.4749 26.3609C35.8206 26.2479 36.1397 26.0657 36.4127 25.8253C36.6812 25.5833 36.8927 25.2847 37.032 24.9511C37.1872 24.567 37.2629 24.1554 37.2544 23.7413C37.261 23.2991 37.1847 22.8596 37.0296 22.4454C36.8939 22.0915 36.6764 21.7747 36.3949 21.5208C36.0818 21.2522 35.7147 21.054 35.3184 20.9396C34.7415 20.7855 34.1459 20.7133 33.549 20.7248H31.3099V26.5507ZM33.5196 17.4665C33.4691 17.4665 33.4192 17.4654 33.3688 17.4634L30.865 17.4638V11.3443H33.1624C33.6993 11.3291 34.2354 11.3961 34.752 11.5431C35.1349 11.6578 35.4881 11.8547 35.7871 12.1201C36.0694 12.3855 36.2829 12.7156 36.4094 13.0819C36.549 13.4875 36.6172 13.9143 36.611 14.3433C36.6168 14.7447 36.5603 15.1446 36.4435 15.5287L36.4412 15.5353C36.314 15.9086 36.1094 16.2507 35.8406 16.5393C35.5764 16.8329 35.2506 17.0644 34.8865 17.2173C34.4494 17.3819 33.9865 17.4664 33.5196 17.4665ZM31.2859 17.0429H33.3769C33.8385 17.0614 34.2992 16.9877 34.7321 16.8263C35.0367 16.697 35.3091 16.5023 35.5299 16.2559C35.7591 16.011 35.9337 15.7203 36.0423 15.403C36.1459 15.0597 36.1961 14.7025 36.191 14.3439C36.1965 13.9614 36.1356 13.5808 36.0113 13.2189C35.9082 12.9188 35.7337 12.6482 35.5028 12.4304C35.2518 12.2082 34.9555 12.0432 34.6344 11.9467C34.158 11.8116 33.6638 11.7501 33.1688 11.7646L31.2861 11.765L31.2859 17.0429Z",
                        fill: "#010101"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_1_38",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        fill: "white",
                        height: "38",
                        transform: "translate(0.5)",
                        width: "67"
                    })
                })
            })
        ]
    });
}
function EnergyC() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        fill: "none",
        height: "38",
        viewBox: "0 0 68 38",
        width: "68",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                clipPath: "url(#clip0_1_50)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M67.0022 0.59761H52.7545V37.4086H67.0022V0.59761Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M15.6213 0.597336H52.7542V37.4083H15.6213L0.671814 19.0028L15.6213 0.597336Z",
                        fill: "#BED731"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M15.9896 0.327708H66.9602C67.0318 0.327708 67.1004 0.356143 67.1511 0.406758C67.2017 0.457373 67.2301 0.526022 67.2301 0.597602V37.4086C67.2301 37.4802 67.2017 37.5488 67.1511 37.5994C67.1004 37.65 67.0318 37.6785 66.9602 37.6785H15.9896C15.9526 37.6785 15.916 37.671 15.882 37.6562C15.848 37.6415 15.8174 37.62 15.7922 37.5929L0.842638 19.1611C0.795898 19.1111 0.769897 19.0452 0.769897 18.9768C0.769897 18.9083 0.795898 18.8424 0.842638 18.7924L15.7922 0.360622C15.8513 0.324737 15.922 0.312955 15.9896 0.327708Z",
                        stroke: "#231F20",
                        strokeLinejoin: "round",
                        strokeWidth: "0.539789"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M63.9891 11.5115C64.036 11.6437 64.0717 11.7796 64.0959 11.9178C64.1055 11.957 64.1053 11.998 64.0953 12.0371C64.0853 12.0763 64.0659 12.1123 64.0386 12.1422C63.9584 12.202 63.8611 12.2344 63.761 12.2347C63.6279 12.2463 63.4451 12.2521 63.2126 12.252C62.9703 12.252 62.7819 12.2489 62.6465 12.2418C62.5419 12.2394 62.4379 12.2249 62.3367 12.1987C62.2786 12.1858 62.2261 12.1547 62.1869 12.11C62.1549 12.0645 62.131 12.0138 62.1161 11.9602L61.4962 10.1082H58.0336L57.4499 11.9107C57.434 11.97 57.4088 12.0264 57.3753 12.0779C57.3376 12.128 57.2853 12.1653 57.2255 12.1846C57.1311 12.2156 57.033 12.2335 56.9337 12.238C56.8077 12.2476 56.6427 12.2523 56.4387 12.252C56.2674 12.2542 56.0962 12.2471 55.9257 12.2308C55.8304 12.229 55.7391 12.1924 55.6689 12.128C55.644 12.0954 55.6266 12.0577 55.618 12.0176C55.6093 11.9774 55.6096 11.9359 55.6188 11.8959C55.6426 11.7601 55.6785 11.6268 55.7262 11.4974L58.5687 3.32031C58.5917 3.25024 58.6253 3.18411 58.6683 3.12421C58.7158 3.06847 58.7793 3.02875 58.8502 3.01046C58.9626 2.9801 59.0783 2.96348 59.1948 2.96095C59.3427 2.95385 59.5371 2.95003 59.7798 2.95003C60.0594 2.95003 60.2825 2.95367 60.449 2.96095C60.5796 2.9633 60.7096 2.9799 60.8366 3.01046C60.914 3.02752 60.984 3.06871 61.0366 3.12809C61.0833 3.19262 61.1183 3.26486 61.14 3.34151L63.9891 11.5115ZM59.7579 4.75174H59.7509L58.4475 8.66929H61.0617L59.7579 4.75174Z",
                        fill: "#231D1E"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M62.4545 16.7022L60.3743 14.6221C60.2371 14.4854 60.0513 14.4086 59.8576 14.4086C59.6639 14.4086 59.4781 14.4854 59.3408 14.6221L57.2607 16.7022C57.1928 16.7701 57.139 16.8506 57.1022 16.9393C57.0655 17.028 57.0466 17.123 57.0466 17.219C57.0466 17.3149 57.0655 17.41 57.1022 17.4986C57.139 17.5873 57.1928 17.6679 57.2607 17.7357C57.3285 17.8036 57.4091 17.8574 57.4977 17.8941C57.5864 17.9309 57.6814 17.9498 57.7774 17.9498C57.8734 17.9498 57.9684 17.9309 58.0571 17.8941C58.1457 17.8574 58.2263 17.8036 58.2942 17.7357L59.1264 16.9036V23.0256C59.1264 23.2194 59.2034 23.4053 59.3404 23.5424C59.4775 23.6795 59.6634 23.7565 59.8573 23.7565C60.0511 23.7565 60.237 23.6795 60.3741 23.5424C60.5112 23.4053 60.5882 23.2194 60.5882 23.0256V16.9036L61.4207 17.736C61.5577 17.8731 61.7436 17.9501 61.9374 17.9501C62.1312 17.9501 62.3171 17.8731 62.4542 17.736C62.5912 17.599 62.6682 17.4131 62.6682 17.2193C62.6682 17.0255 62.5915 16.8393 62.4545 16.7022Z",
                        fill: "#211F11"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M63.4532 27.2642C63.4538 27.3814 63.4485 27.4986 63.4371 27.6152C63.4301 27.695 63.4148 27.7739 63.3915 27.8505C63.3791 27.8971 63.3545 27.9395 63.3201 27.9733C63.2917 27.9967 63.2559 28.0093 63.2191 28.0087C63.1189 27.9902 63.0249 27.9466 62.946 27.882C62.7859 27.779 62.6187 27.6875 62.4457 27.6082C62.2048 27.4977 61.9557 27.4062 61.7006 27.3343C61.3733 27.2452 61.035 27.2027 60.6958 27.2084C60.3153 27.2027 59.9381 27.2804 59.5908 27.4359C59.2643 27.5857 58.9754 27.8067 58.7454 28.0826C58.5018 28.379 58.3184 28.7201 58.2056 29.0868C58.0756 29.5061 58.0121 29.9431 58.0173 30.3821C58.0091 30.8471 58.074 31.3104 58.2095 31.7552C58.3194 32.119 58.5018 32.4569 58.7456 32.7484C58.9706 33.0124 59.2548 33.2195 59.575 33.3527C59.9142 33.4921 60.2781 33.5615 60.6447 33.5567C60.8355 33.5565 61.0254 33.533 61.2105 33.4867C61.3927 33.4415 61.5676 33.3706 61.7298 33.276V31.1685H60.1368C60.0591 31.1685 59.998 31.1164 59.9549 31.011C59.9022 30.837 59.8802 30.6551 59.89 30.4735C59.8886 30.3634 59.8942 30.2532 59.9067 30.1437C59.9137 30.0704 59.9299 29.9983 59.9549 29.9291C59.9714 29.884 59.998 29.8433 60.0327 29.8101C60.0616 29.7851 60.0986 29.7714 60.1368 29.7716H62.9782C63.0423 29.7704 63.1057 29.7836 63.164 29.8101C63.22 29.8373 63.269 29.8769 63.3073 29.9259C63.3501 29.9813 63.3819 30.0443 63.4012 30.1116C63.4239 30.1928 63.4347 30.2768 63.4333 30.361V33.9778C63.4364 34.104 63.4132 34.2296 63.3652 34.3464C63.3081 34.4626 63.2081 34.5521 63.0862 34.5958C62.9448 34.6563 62.7703 34.7199 62.563 34.7848C62.3557 34.8497 62.1386 34.907 61.9156 34.9539C61.6922 35.0009 61.4665 35.0359 61.2394 35.0589C61.0116 35.0829 60.7826 35.0949 60.5535 35.0949C59.9377 35.1047 59.3255 34.9985 58.749 34.7819C58.2363 34.5862 57.7749 34.2765 57.3996 33.8761C57.0186 33.4592 56.7305 32.9662 56.5542 32.4297C56.3507 31.8052 56.2519 31.1514 56.2617 30.4947C56.2515 29.8134 56.3571 29.1353 56.574 28.4893C56.7621 27.9307 57.063 27.4167 57.4579 26.9792C57.8419 26.5632 58.3139 26.2382 58.8394 26.0278C59.4139 25.8015 60.0271 25.6895 60.6445 25.698C60.9778 25.6953 61.3106 25.7221 61.639 25.7784C61.9048 25.824 62.1668 25.8897 62.4227 25.9751C62.6159 26.0388 62.8021 26.1224 62.9781 26.2245C63.0915 26.2869 63.1956 26.3648 63.2875 26.4559C63.3529 26.536 63.3965 26.6317 63.4141 26.7337C63.4449 26.9088 63.458 27.0865 63.4532 27.2642Z",
                        fill: "#010101"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M41.2804 26.5989C41.2804 26.8725 41.2729 27.1058 41.2578 27.2967C41.2461 27.4624 41.223 27.6272 41.1887 27.7897C41.1635 27.9123 41.1226 28.031 41.0669 28.143C40.9997 28.2645 40.9182 28.3776 40.8242 28.4798C40.6305 28.6684 40.4132 28.8311 40.1777 28.9639C39.8051 29.1869 39.4135 29.3766 39.0074 29.5306C37.8878 29.9549 36.6995 30.1691 35.5022 30.1625C34.2531 30.181 33.0128 29.9522 31.8526 29.489C30.7819 29.0505 29.8327 28.3603 29.0854 27.4769C28.2776 26.496 27.6821 25.3581 27.3368 24.1351C26.9068 22.6189 26.7018 21.0478 26.7283 19.472C26.7028 17.8431 26.9285 16.22 27.3977 14.66C27.783 13.3716 28.4185 12.1718 29.2677 11.1292C30.0472 10.193 31.0336 9.45087 32.1491 8.96144C33.3181 8.45892 34.5794 8.20721 35.8517 8.22259C36.3825 8.22103 36.9122 8.27049 37.4335 8.37031C37.9118 8.46108 38.3821 8.59015 38.8398 8.75626C39.244 8.90239 39.6333 9.08661 40.0026 9.30645C40.2656 9.45243 40.5087 9.63181 40.7257 9.84011C40.8346 9.95088 40.9291 10.075 41.0068 10.2095C41.0642 10.3294 41.1052 10.4564 41.1285 10.5873C41.1619 10.7664 41.1845 10.9473 41.1962 11.1292C41.2112 11.3374 41.2195 11.5948 41.2195 11.9011C41.2195 12.2296 41.2092 12.5087 41.1887 12.7385C41.1763 12.9282 41.1407 13.1158 41.0827 13.2969C41.047 13.4137 40.9844 13.5205 40.9001 13.6088C40.835 13.6724 40.7475 13.7079 40.6565 13.7076C40.438 13.6771 40.2353 13.5763 40.0792 13.4204C39.7903 13.1894 39.4882 12.9756 39.1742 12.7801C38.7566 12.5212 38.3132 12.3064 37.8511 12.1393C37.2622 11.9354 36.6416 11.8382 36.0186 11.8521C35.2886 11.8396 34.5679 12.0178 33.9279 12.3693C33.2964 12.7313 32.7597 13.2378 32.3619 13.8474C31.9007 14.5582 31.5687 15.3448 31.3811 16.1711C31.147 17.1778 31.0347 18.2089 31.0466 19.2423C31.0287 20.3339 31.1488 21.4234 31.404 22.4849C31.5948 23.2964 31.9408 24.0634 32.4229 24.7436C32.8354 25.3114 33.3846 25.766 34.0196 26.0653C34.6811 26.3632 35.4002 26.5116 36.1257 26.4997C36.7498 26.5127 37.3717 26.4213 37.9656 26.2291C38.4279 26.0737 38.8735 25.8728 39.2961 25.6293C39.6659 25.4113 39.97 25.2144 40.2085 25.0385C40.3644 24.8995 40.557 24.8081 40.7633 24.7752C40.8493 24.7712 40.9345 24.7943 41.0068 24.841C41.0835 24.9109 41.1366 25.003 41.1587 25.1044C41.2076 25.2842 41.2383 25.4685 41.2504 25.6546C41.27 25.8899 41.2801 26.2047 41.2804 26.5989Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M35.3603 30.3766C34.1329 30.377 32.9168 30.1417 31.778 29.6836C30.6779 29.2296 29.7029 28.5182 28.935 27.6091C28.1082 26.6041 27.4995 25.4382 27.1475 24.1854C26.7122 22.6468 26.5047 21.0527 26.5316 19.4539C26.5059 17.8043 26.7348 16.1605 27.2099 14.5806C27.6097 13.2721 28.2634 12.0553 29.1338 10.9996C29.9335 10.0395 30.9443 9.27718 32.0873 8.77218C33.2785 8.24295 34.5691 7.97462 35.8724 7.98521C36.3951 7.9923 36.9159 8.04778 37.4283 8.15097C37.9171 8.24324 38.3977 8.37468 38.8654 8.54402C39.2814 8.69664 39.6823 8.88776 40.0628 9.11488C40.3396 9.27047 40.5953 9.46107 40.8234 9.68199C40.9463 9.80559 41.0534 9.94397 41.1422 10.0939C41.2114 10.2344 41.2614 10.3836 41.291 10.5374C41.3256 10.7234 41.3498 10.9112 41.3634 11.1V12.7228C41.3506 12.9349 41.3111 13.1447 41.2461 13.347C41.2012 13.495 41.1219 13.6302 41.0147 13.7416C40.905 13.8389 40.7657 13.8963 40.6193 13.9043C40.3481 13.8721 40.0952 13.7512 39.8999 13.5604C39.6212 13.3405 39.3301 13.1367 39.028 12.9502C38.6219 12.6994 38.1909 12.4913 37.742 12.3293C37.1774 12.1329 36.5819 12.0408 35.9844 12.0572C35.286 12.0412 34.5958 12.2104 33.984 12.5476C33.3926 12.8974 32.8907 13.3798 32.5178 13.9569C32.072 14.6434 31.7504 15.403 31.5678 16.2009C31.3388 17.1947 31.2295 18.2122 31.2424 19.2319C31.2254 20.31 31.345 21.3859 31.5982 22.4339C31.7865 23.2139 32.1231 23.9504 32.5897 24.6031C32.9809 25.1428 33.5015 25.5755 34.1037 25.8614C34.7381 26.1464 35.4271 26.2896 36.1226 26.2808C36.7261 26.293 37.3275 26.2054 37.9024 26.0215C38.3513 25.8695 38.7843 25.6742 39.1953 25.4382C39.5036 25.2604 39.8024 25.0668 40.0906 24.858C40.273 24.6992 40.4967 24.5955 40.7357 24.5588C40.8738 24.5487 41.0114 24.5844 41.1272 24.6603C41.247 24.7598 41.3309 24.8957 41.3662 25.0473C41.4182 25.2388 41.4507 25.4349 41.4632 25.6329V25.6457C41.4632 25.8832 41.4632 26.1974 41.4708 26.5882V27.2925C41.4585 27.4721 41.4341 27.6506 41.3978 27.8269C41.3679 27.9666 41.3207 28.1019 41.2573 28.2299C41.18 28.3691 41.0867 28.4988 40.9792 28.6162C40.7708 28.8211 40.5361 28.9975 40.2814 29.1408C39.9001 29.369 39.4997 29.5637 39.0848 29.7226C38.5591 29.9232 38.0172 30.0783 37.465 30.1863C36.8179 30.3118 36.1602 30.375 35.501 30.375C35.4546 30.3759 35.4073 30.3766 35.3603 30.3766ZM35.8264 8.39315C34.5954 8.39188 33.3778 8.64832 32.2519 9.14595C31.1668 9.62509 30.2072 10.3486 29.448 11.2599C28.612 12.2737 27.9842 13.4423 27.6004 14.699C27.1368 16.2408 26.9139 17.8449 26.9397 19.4546C26.913 21.0155 27.1152 22.5719 27.5399 24.0742C27.8765 25.2721 28.4585 26.3871 29.2488 27.3483C29.9735 28.2061 30.8936 28.8774 31.9317 29.3056C33.0647 29.763 34.278 29.9882 35.4996 29.9677C36.1328 29.9664 36.7646 29.9058 37.3865 29.7866C37.9159 29.6827 38.4354 29.5338 38.9394 29.3416C39.3341 29.1903 39.7148 29.005 40.0774 28.7877C40.2996 28.6634 40.5043 28.5102 40.6862 28.3322C40.7675 28.2431 40.8382 28.1451 40.8969 28.0398C40.9427 27.9453 40.977 27.8456 40.9991 27.7429C41.0308 27.5894 41.0524 27.434 41.0638 27.2777V26.5921C41.0563 26.2058 41.0563 25.8909 41.0563 25.6526C41.0444 25.4813 41.0158 25.3115 40.9707 25.1458C40.9582 25.0823 40.9255 25.0245 40.8775 24.9812C40.8456 24.9682 40.8112 24.9623 40.7767 24.9639C40.6174 24.9936 40.4692 25.0664 40.3483 25.1745C40.0439 25.3967 39.7277 25.6024 39.4013 25.7909C38.9657 26.0409 38.5068 26.2478 38.031 26.4087C37.4159 26.6127 36.7698 26.7073 36.122 26.6883C35.3674 26.7014 34.6195 26.5453 33.9332 26.2313C33.2672 25.9161 32.6914 25.4381 32.2589 24.8415C31.7617 24.146 31.4029 23.3613 31.2021 22.5303C30.9412 21.4505 30.8177 20.3421 30.8346 19.2314C30.8219 18.1812 30.9346 17.1333 31.1703 16.1098C31.3635 15.2656 31.7038 14.462 32.1756 13.7358C32.5842 13.1037 33.1344 12.5755 33.7826 12.1931C34.4577 11.8271 35.2152 11.6398 35.983 11.6493C36.6272 11.6345 37.2689 11.7347 37.878 11.945C38.3541 12.1169 38.8113 12.3375 39.2422 12.6033C39.5643 12.8024 39.8742 13.0205 40.1703 13.2564C40.2992 13.3869 40.467 13.4718 40.6484 13.4985C40.6767 13.4908 40.7026 13.4761 40.7236 13.4556C40.7853 13.3909 40.8309 13.3125 40.8566 13.2268C40.9109 13.0591 40.9442 12.8854 40.9558 12.7096V11.1145C40.9426 10.9462 40.9205 10.7787 40.8896 10.6127C40.8685 10.4995 40.8326 10.3896 40.7829 10.2858C40.7134 10.1721 40.6309 10.067 40.5371 9.97236C40.3336 9.77572 40.1055 9.60632 39.8584 9.46838C39.4985 9.25303 39.1193 9.07185 38.7257 8.92721C38.2779 8.76537 37.8178 8.6397 37.3499 8.5514C36.8621 8.45294 36.3663 8.40005 35.8687 8.39341C35.8549 8.39315 35.8406 8.39315 35.8264 8.39315Z",
                        fill: "#010101"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_1_50",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        fill: "white",
                        height: "38",
                        transform: "translate(0.5)",
                        width: "67"
                    })
                })
            })
        ]
    });
}
function EnergyD() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        fill: "none",
        height: "38",
        viewBox: "0 0 68 38",
        width: "68",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                clipPath: "url(#clip0_1_14)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M67.0022 0.597603H52.7545V37.4086H67.0022V0.597603Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M15.6213 0.597343H52.7542V37.4083H15.6213L0.671814 19.0028L15.6213 0.597343Z",
                        fill: "#FCEE23"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M15.9896 0.327708H66.9602C67.0318 0.327708 67.1004 0.356143 67.1511 0.406758C67.2017 0.457373 67.2301 0.526022 67.2301 0.597602V37.4086C67.2301 37.4802 67.2017 37.5488 67.1511 37.5994C67.1004 37.65 67.0318 37.6785 66.9602 37.6785H15.9896C15.9526 37.6785 15.916 37.671 15.882 37.6562C15.848 37.6415 15.8174 37.62 15.7922 37.5929L0.842638 19.1611C0.795898 19.1111 0.769897 19.0452 0.769897 18.9768C0.769897 18.9083 0.795898 18.8424 0.842638 18.7924L15.7922 0.360622C15.8513 0.324737 15.922 0.312955 15.9896 0.327708Z",
                        stroke: "#231F20",
                        strokeLinejoin: "round",
                        strokeWidth: "0.539789"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M63.9891 11.5115C64.036 11.6437 64.0717 11.7796 64.0959 11.9178C64.1055 11.957 64.1053 11.998 64.0953 12.0371C64.0853 12.0763 64.0659 12.1123 64.0386 12.1422C63.9584 12.202 63.8611 12.2344 63.761 12.2347C63.6279 12.2463 63.4451 12.2521 63.2126 12.252C62.9703 12.252 62.7819 12.2489 62.6465 12.2418C62.5419 12.2394 62.4379 12.2249 62.3367 12.1987C62.2786 12.1858 62.2261 12.1547 62.1869 12.11C62.1549 12.0645 62.131 12.0138 62.1161 11.9602L61.4962 10.1082H58.0336L57.4499 11.9107C57.434 11.97 57.4088 12.0264 57.3753 12.0779C57.3376 12.128 57.2853 12.1653 57.2255 12.1846C57.1311 12.2156 57.033 12.2335 56.9337 12.238C56.8077 12.2476 56.6427 12.2523 56.4387 12.252C56.2674 12.2542 56.0962 12.2471 55.9257 12.2308C55.8304 12.229 55.7391 12.1924 55.6689 12.128C55.644 12.0954 55.6266 12.0577 55.618 12.0176C55.6093 11.9774 55.6096 11.9359 55.6188 11.8959C55.6426 11.7601 55.6785 11.6268 55.7262 11.4974L58.5687 3.32031C58.5917 3.25024 58.6253 3.18411 58.6683 3.12421C58.7158 3.06847 58.7793 3.02875 58.8502 3.01046C58.9626 2.9801 59.0783 2.96348 59.1948 2.96095C59.3427 2.95385 59.5371 2.95003 59.7798 2.95003C60.0594 2.95003 60.2825 2.95367 60.449 2.96095C60.5796 2.9633 60.7096 2.9799 60.8366 3.01046C60.914 3.02752 60.984 3.06871 61.0366 3.12809C61.0833 3.19262 61.1183 3.26486 61.14 3.34151L63.9891 11.5115ZM59.7579 4.75174H59.7509L58.4475 8.66929H61.0617L59.7579 4.75174Z",
                        fill: "#231D1E"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M62.4545 16.7022L60.3743 14.6221C60.2371 14.4854 60.0513 14.4086 59.8576 14.4086C59.6639 14.4086 59.4781 14.4854 59.3408 14.6221L57.2607 16.7022C57.1928 16.7701 57.139 16.8506 57.1023 16.9393C57.0655 17.028 57.0466 17.123 57.0466 17.219C57.0466 17.3149 57.0655 17.41 57.1023 17.4986C57.139 17.5873 57.1928 17.6679 57.2607 17.7357C57.3285 17.8036 57.4091 17.8574 57.4978 17.8941C57.5864 17.9309 57.6815 17.9498 57.7774 17.9498C57.8734 17.9498 57.9684 17.9309 58.0571 17.8941C58.1458 17.8574 58.2263 17.8036 58.2942 17.7357L59.1264 16.9036V23.0256C59.1264 23.2194 59.2034 23.4053 59.3405 23.5424C59.4775 23.6795 59.6634 23.7565 59.8573 23.7565C60.0511 23.7565 60.2371 23.6795 60.3741 23.5424C60.5112 23.4053 60.5882 23.2194 60.5882 23.0256V16.9036L61.4207 17.736C61.5577 17.8731 61.7436 17.9501 61.9374 17.9501C62.1312 17.9501 62.3171 17.8731 62.4542 17.736C62.5912 17.599 62.6682 17.4131 62.6682 17.2193C62.6682 17.0255 62.5915 16.8393 62.4545 16.7022Z",
                        fill: "#211F11"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M63.4532 27.2642C63.4538 27.3814 63.4485 27.4986 63.4371 27.6152C63.4301 27.695 63.4148 27.7739 63.3915 27.8505C63.3791 27.8971 63.3545 27.9395 63.3201 27.9733C63.2917 27.9967 63.2559 28.0093 63.2191 28.0087C63.1189 27.9902 63.0249 27.9466 62.946 27.882C62.7859 27.779 62.6187 27.6875 62.4457 27.6082C62.2048 27.4977 61.9557 27.4062 61.7006 27.3343C61.3733 27.2452 61.035 27.2027 60.6958 27.2084C60.3153 27.2027 59.9381 27.2804 59.5908 27.4359C59.2643 27.5857 58.9754 27.8067 58.7454 28.0826C58.5018 28.379 58.3184 28.7201 58.2056 29.0868C58.0756 29.5061 58.0121 29.9431 58.0173 30.3821C58.0091 30.8471 58.074 31.3104 58.2095 31.7552C58.3194 32.119 58.5018 32.4569 58.7456 32.7484C58.9706 33.0124 59.2548 33.2195 59.575 33.3527C59.9142 33.4921 60.2781 33.5615 60.6447 33.5567C60.8355 33.5565 61.0254 33.533 61.2105 33.4867C61.3927 33.4415 61.5676 33.3706 61.7298 33.276V31.1685H60.1368C60.0591 31.1685 59.998 31.1164 59.9549 31.011C59.9022 30.837 59.8802 30.6551 59.89 30.4735C59.8886 30.3634 59.8942 30.2532 59.9067 30.1437C59.9137 30.0704 59.9299 29.9983 59.9549 29.9291C59.9714 29.884 59.998 29.8433 60.0327 29.8101C60.0616 29.7851 60.0986 29.7714 60.1368 29.7716H62.9782C63.0423 29.7704 63.1057 29.7836 63.164 29.8101C63.22 29.8373 63.269 29.8769 63.3073 29.9259C63.3501 29.9813 63.3819 30.0443 63.4012 30.1116C63.4239 30.1928 63.4347 30.2768 63.4333 30.361V33.9778C63.4364 34.104 63.4132 34.2296 63.3652 34.3464C63.3081 34.4626 63.2081 34.5521 63.0862 34.5958C62.9448 34.6563 62.7703 34.7199 62.563 34.7848C62.3557 34.8497 62.1386 34.907 61.9156 34.9539C61.6922 35.0009 61.4665 35.0359 61.2394 35.0589C61.0116 35.0829 60.7826 35.0949 60.5535 35.0949C59.9377 35.1047 59.3255 34.9985 58.749 34.7819C58.2363 34.5862 57.7749 34.2765 57.3996 33.8761C57.0186 33.4592 56.7305 32.9662 56.5542 32.4297C56.3507 31.8052 56.2519 31.1514 56.2617 30.4947C56.2515 29.8134 56.3571 29.1353 56.574 28.4893C56.7621 27.9307 57.063 27.4167 57.4579 26.9792C57.8419 26.5632 58.3139 26.2382 58.8394 26.0278C59.4139 25.8015 60.0271 25.6895 60.6445 25.698C60.9778 25.6953 61.3106 25.7221 61.639 25.7784C61.9048 25.824 62.1668 25.8897 62.4227 25.9751C62.6159 26.0388 62.8021 26.1224 62.9781 26.2245C63.0915 26.2869 63.1956 26.3648 63.2875 26.4559C63.3529 26.536 63.3965 26.6317 63.4141 26.7337C63.4449 26.9088 63.458 27.0865 63.4532 27.2642Z",
                        fill: "#010101"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M42.7967 18.856C42.8355 20.6014 42.5894 22.3415 42.068 24.0077C41.6529 25.3191 40.9369 26.5153 39.9773 27.5008C39.0462 28.417 37.9104 29.0986 36.6638 29.4892C35.1581 29.9412 33.5911 30.1552 32.0193 30.1234H27.1789C26.857 30.1321 26.5445 30.0136 26.3093 29.7935C26.18 29.6484 26.0819 29.4781 26.0213 29.2933C25.9607 29.1086 25.9388 28.9133 25.957 28.7197V9.63545C25.9387 9.44177 25.9606 9.24641 26.0213 9.06156C26.0819 8.87671 26.18 8.70634 26.3093 8.56107C26.5445 8.34102 26.857 8.22251 27.1789 8.23121H32.3793C33.9401 8.19296 35.4957 8.42479 36.9774 8.91648C38.1803 9.3377 39.2688 10.0328 40.1569 10.9468C41.0502 11.8959 41.7219 13.0313 42.1237 14.2711C42.5967 15.7524 42.8241 17.3012 42.7967 18.856ZM38.5354 19.0074C38.5431 18.033 38.4302 17.0615 38.1994 16.1148C37.9996 15.2771 37.6318 14.4887 37.1184 13.7972C36.6161 13.1383 35.9599 12.6125 35.2073 12.266C34.2383 11.8632 33.1934 11.6756 32.1448 11.7163H30.061V26.604H32.207C33.1791 26.6309 34.1472 26.4703 35.0585 26.1309C35.8148 25.8272 36.4808 25.3348 36.9928 24.7007C37.5419 23.9988 37.9368 23.1891 38.152 22.3243C38.4244 21.2403 38.5533 20.1249 38.5354 19.0074Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M32.3306 30.3766C32.2253 30.3766 32.12 30.3751 32.0147 30.3728H27.1816C26.9943 30.3828 26.8069 30.3532 26.6317 30.2859C26.4565 30.2187 26.2975 30.1153 26.1649 29.9825C26.0119 29.8145 25.8955 29.6166 25.823 29.4013C25.7505 29.186 25.7234 28.958 25.7436 28.7317L25.7425 9.61011C25.7241 9.3897 25.751 9.16786 25.8216 8.95825C25.8922 8.74864 26.0049 8.55569 26.1529 8.3913C26.2894 8.25812 26.4514 8.15379 26.6291 8.08454C26.8069 8.01529 26.9967 7.98254 27.1874 7.98824H32.3755C33.9586 7.95043 35.5365 8.18499 37.0402 8.68167C38.2716 9.1159 39.3862 9.82861 40.2971 10.7643C41.1762 11.702 41.8467 12.8153 42.2647 14.0308H42.274L42.3212 14.1772C42.8017 15.6823 43.0324 17.2559 43.0042 18.8356C43.0437 20.6046 42.7941 22.3681 42.2655 24.0566C41.8468 25.4158 41.116 26.6582 40.1314 27.6844C39.1747 28.6257 38.0083 29.3265 36.7281 29.7295C35.3016 30.1584 33.8202 30.3764 32.3306 30.3766ZM32.0186 29.953C33.5704 29.9818 35.1175 29.7709 36.605 29.3277C37.8187 28.9454 38.9246 28.2812 39.8322 27.3892C40.7696 26.4107 41.4653 25.2268 41.8641 23.9318C42.3794 22.2838 42.6226 20.5629 42.5842 18.8367C42.611 17.3439 42.4001 15.8564 41.9594 14.4299L41.9129 14.3056C41.5196 13.0939 40.8639 11.9838 39.9925 11.0545C39.1289 10.1671 38.0721 9.49107 36.9044 9.07914C35.4472 8.59339 33.9162 8.36657 32.3807 8.40894H27.1816C27.0478 8.40205 26.914 8.42299 26.7886 8.47044C26.6633 8.51789 26.5491 8.59082 26.4534 8.68463C26.3461 8.80816 26.2649 8.95217 26.2148 9.10796C26.1647 9.26374 26.1467 9.42807 26.1618 9.59102L26.163 28.7514C26.146 28.9202 26.1642 29.0908 26.2163 29.2523C26.2684 29.4138 26.3533 29.5628 26.4658 29.6899C26.6596 29.8662 26.9143 29.9606 27.1763 29.9532L32.0186 29.953ZM32.4092 26.8077C32.338 26.8077 32.2667 26.8069 32.1951 26.8046H29.8497V11.4695H32.1456C33.2217 11.4319 34.2932 11.6268 35.2871 12.0409C36.0733 12.4018 36.7591 12.9501 37.2841 13.6377C37.8137 14.3462 38.1933 15.1552 38.3999 16.0153C38.6451 16.9855 38.7694 17.9823 38.7701 18.983C38.779 20.1208 38.6384 21.2548 38.3519 22.356C38.1315 23.2504 37.7238 24.0879 37.1556 24.813C36.6203 25.4768 35.9248 25.9933 35.1347 26.3139C34.2633 26.6411 33.34 26.8084 32.4092 26.8077ZM30.2698 26.3849H32.2007C33.1489 26.4122 34.0934 26.2552 34.9817 25.9226C35.7026 25.6291 36.3372 25.1575 36.8262 24.5521C37.357 23.8738 37.738 23.0908 37.9444 22.2547V22.2524C38.2218 21.1855 38.3582 20.0869 38.3502 18.9847C38.3493 18.0173 38.2289 17.0538 37.9916 16.1161C37.7981 15.3112 37.443 14.5541 36.9478 13.8906C36.4666 13.2602 35.8383 12.7574 35.1178 12.426C34.18 12.0349 33.1686 11.8519 32.1532 11.8897L30.2696 11.8901L30.2698 26.3849Z",
                        fill: "#010101"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_1_14",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        fill: "white",
                        height: "38",
                        transform: "translate(0.5)",
                        width: "67"
                    })
                })
            })
        ]
    });
}
function EnergyE() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        fill: "none",
        height: "38",
        viewBox: "0 0 68 38",
        width: "68",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                clipPath: "url(#clip0_1_26)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M67.0022 0.597603H52.7545V37.4086H67.0022V0.597603Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M15.6213 0.597343H52.7542V37.4083H15.6213L0.671814 19.0028L15.6213 0.597343Z",
                        fill: "#FCB918"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M15.9896 0.327708H66.9602C67.0318 0.327708 67.1004 0.356143 67.1511 0.406758C67.2017 0.457373 67.2301 0.526022 67.2301 0.597602V37.4086C67.2301 37.4802 67.2017 37.5488 67.1511 37.5994C67.1004 37.65 67.0318 37.6785 66.9602 37.6785H15.9896C15.9526 37.6785 15.916 37.671 15.882 37.6562C15.848 37.6415 15.8174 37.62 15.7922 37.5929L0.842638 19.1611C0.795898 19.1111 0.769897 19.0452 0.769897 18.9768C0.769897 18.9083 0.795898 18.8424 0.842638 18.7924L15.7922 0.360622C15.8513 0.324737 15.922 0.312955 15.9896 0.327708Z",
                        stroke: "#231F20",
                        strokeLinejoin: "round",
                        strokeWidth: "0.539789"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M63.9891 11.5115C64.036 11.6437 64.0717 11.7796 64.0959 11.9178C64.1055 11.957 64.1053 11.998 64.0953 12.0371C64.0853 12.0763 64.0659 12.1123 64.0386 12.1422C63.9584 12.202 63.8611 12.2344 63.761 12.2347C63.6279 12.2463 63.4451 12.2521 63.2126 12.252C62.9703 12.252 62.7819 12.2489 62.6465 12.2418C62.5419 12.2394 62.4379 12.2249 62.3367 12.1987C62.2786 12.1858 62.2261 12.1547 62.1869 12.11C62.1549 12.0645 62.131 12.0138 62.1161 11.9602L61.4962 10.1082H58.0336L57.4499 11.9107C57.434 11.97 57.4088 12.0264 57.3753 12.0779C57.3376 12.128 57.2853 12.1653 57.2255 12.1846C57.1311 12.2156 57.033 12.2335 56.9337 12.238C56.8077 12.2476 56.6427 12.2523 56.4387 12.252C56.2674 12.2542 56.0962 12.2471 55.9257 12.2308C55.8304 12.229 55.7391 12.1924 55.6689 12.128C55.644 12.0954 55.6266 12.0577 55.618 12.0176C55.6093 11.9774 55.6096 11.9359 55.6188 11.8959C55.6426 11.7601 55.6785 11.6268 55.7262 11.4974L58.5687 3.32031C58.5917 3.25024 58.6253 3.18411 58.6683 3.12421C58.7158 3.06847 58.7793 3.02875 58.8502 3.01046C58.9626 2.9801 59.0783 2.96348 59.1948 2.96095C59.3427 2.95385 59.5371 2.95003 59.7798 2.95003C60.0594 2.95003 60.2825 2.95367 60.449 2.96095C60.5796 2.9633 60.7096 2.9799 60.8366 3.01046C60.914 3.02752 60.984 3.06871 61.0366 3.12809C61.0833 3.19262 61.1183 3.26486 61.14 3.34151L63.9891 11.5115ZM59.7579 4.75174H59.7509L58.4475 8.66929H61.0617L59.7579 4.75174Z",
                        fill: "#231D1E"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M62.4545 16.7022L60.3743 14.6221C60.2371 14.4854 60.0513 14.4086 59.8576 14.4086C59.6639 14.4086 59.4781 14.4854 59.3408 14.6221L57.2607 16.7022C57.1928 16.7701 57.139 16.8506 57.1023 16.9393C57.0655 17.028 57.0466 17.123 57.0466 17.219C57.0466 17.3149 57.0655 17.41 57.1023 17.4986C57.139 17.5873 57.1928 17.6679 57.2607 17.7357C57.3285 17.8036 57.4091 17.8574 57.4978 17.8941C57.5864 17.9309 57.6815 17.9498 57.7774 17.9498C57.8734 17.9498 57.9684 17.9309 58.0571 17.8941C58.1458 17.8574 58.2263 17.8036 58.2942 17.7357L59.1264 16.9036V23.0256C59.1264 23.2194 59.2034 23.4053 59.3405 23.5424C59.4775 23.6795 59.6634 23.7565 59.8573 23.7565C60.0511 23.7565 60.2371 23.6795 60.3741 23.5424C60.5112 23.4053 60.5882 23.2194 60.5882 23.0256V16.9036L61.4207 17.736C61.5577 17.8731 61.7436 17.9501 61.9374 17.9501C62.1312 17.9501 62.3171 17.8731 62.4542 17.736C62.5912 17.599 62.6682 17.4131 62.6682 17.2193C62.6682 17.0255 62.5915 16.8393 62.4545 16.7022Z",
                        fill: "#211F11"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M63.4532 27.2642C63.4538 27.3814 63.4485 27.4986 63.4371 27.6152C63.4301 27.695 63.4148 27.7739 63.3915 27.8505C63.3791 27.8971 63.3545 27.9395 63.3201 27.9733C63.2917 27.9967 63.2559 28.0093 63.2191 28.0087C63.1189 27.9902 63.0249 27.9466 62.946 27.882C62.7859 27.779 62.6187 27.6875 62.4457 27.6082C62.2048 27.4977 61.9557 27.4062 61.7006 27.3343C61.3733 27.2452 61.035 27.2027 60.6958 27.2084C60.3153 27.2027 59.9381 27.2804 59.5908 27.4359C59.2643 27.5857 58.9754 27.8067 58.7454 28.0826C58.5018 28.379 58.3184 28.7201 58.2056 29.0868C58.0756 29.5061 58.0121 29.9431 58.0173 30.3821C58.0091 30.8471 58.074 31.3104 58.2095 31.7552C58.3194 32.119 58.5018 32.4569 58.7456 32.7484C58.9706 33.0124 59.2548 33.2195 59.575 33.3527C59.9142 33.4921 60.2781 33.5615 60.6447 33.5567C60.8355 33.5565 61.0254 33.533 61.2105 33.4867C61.3927 33.4415 61.5676 33.3706 61.7298 33.276V31.1685H60.1368C60.0591 31.1685 59.998 31.1164 59.9549 31.011C59.9022 30.837 59.8802 30.6551 59.89 30.4735C59.8886 30.3634 59.8942 30.2532 59.9067 30.1437C59.9137 30.0704 59.9299 29.9983 59.9549 29.9291C59.9714 29.884 59.998 29.8433 60.0327 29.8101C60.0616 29.7851 60.0986 29.7714 60.1368 29.7716H62.9782C63.0423 29.7704 63.1057 29.7836 63.164 29.8101C63.22 29.8373 63.269 29.8769 63.3073 29.9259C63.3501 29.9813 63.3819 30.0443 63.4012 30.1116C63.4239 30.1928 63.4347 30.2768 63.4333 30.361V33.9778C63.4364 34.104 63.4132 34.2296 63.3652 34.3464C63.3081 34.4626 63.2081 34.5521 63.0862 34.5958C62.9448 34.6563 62.7703 34.7199 62.563 34.7848C62.3557 34.8497 62.1386 34.907 61.9156 34.9539C61.6922 35.0009 61.4665 35.0359 61.2394 35.0589C61.0116 35.0829 60.7826 35.0949 60.5535 35.0949C59.9377 35.1047 59.3255 34.9985 58.749 34.7819C58.2363 34.5862 57.7749 34.2765 57.3996 33.8761C57.0186 33.4592 56.7305 32.9662 56.5542 32.4297C56.3507 31.8052 56.2519 31.1514 56.2617 30.4947C56.2515 29.8134 56.3571 29.1353 56.574 28.4893C56.7621 27.9307 57.063 27.4167 57.4579 26.9792C57.8419 26.5632 58.3139 26.2382 58.8394 26.0278C59.4139 25.8015 60.0271 25.6895 60.6445 25.698C60.9778 25.6953 61.3106 25.7221 61.639 25.7784C61.9048 25.824 62.1668 25.8897 62.4227 25.9751C62.6159 26.0388 62.8021 26.1224 62.9781 26.2245C63.0915 26.2869 63.1956 26.3648 63.2875 26.4559C63.3529 26.536 63.3965 26.6317 63.4141 26.7337C63.4449 26.9088 63.458 27.0865 63.4532 27.2642Z",
                        fill: "#010101"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M40.0197 28.4119C40.0223 28.6865 40.0093 28.961 39.981 29.2341C39.9631 29.416 39.9235 29.5952 39.8631 29.7677C39.8249 29.8825 39.7569 29.985 39.666 30.0648C39.5934 30.125 39.5021 30.1579 39.4077 30.1579H29.208C28.8854 30.1666 28.5725 30.0479 28.3369 29.8274C28.2072 29.6819 28.109 29.5111 28.0483 29.3259C27.9875 29.1407 27.9657 28.9449 27.984 28.7508V9.63439C27.9657 9.44037 27.9876 9.24467 28.0483 9.0595C28.109 8.87432 28.2073 8.70364 28.3369 8.55811C28.5725 8.33773 28.8855 8.21904 29.208 8.22772H39.3451C39.4361 8.22661 39.5247 8.25656 39.5964 8.31264C39.6845 8.3928 39.7493 8.49529 39.7839 8.60926C39.8441 8.78483 39.8837 8.96679 39.9018 9.15148C39.9308 9.43012 39.9438 9.7102 39.9406 9.99033C39.9433 10.2591 39.9303 10.5278 39.9018 10.7951C39.8844 10.9773 39.8448 11.1566 39.7839 11.3292C39.7463 11.4419 39.6819 11.5437 39.5962 11.6259C39.5266 11.6866 39.4372 11.7197 39.3449 11.719H32.095V17.0742H38.231C38.3255 17.0747 38.4169 17.1075 38.4901 17.1673C38.5785 17.2454 38.6457 17.3445 38.6855 17.4555C38.7472 17.6249 38.7869 17.8015 38.8035 17.981C38.8552 18.5192 38.8552 19.0612 38.8035 19.5994C38.7864 19.776 38.7468 19.9496 38.6855 20.116C38.6476 20.2257 38.5799 20.3226 38.4901 20.3961C38.415 20.4513 38.3242 20.4809 38.231 20.4806H32.095V26.6659H39.4077C39.5021 26.6662 39.5935 26.6994 39.666 26.7597C39.7569 26.8392 39.8249 26.9414 39.8631 27.056C39.9235 27.2288 39.9631 27.4082 39.981 27.5904C40.0093 27.8633 40.0223 28.1375 40.0197 28.4119Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M29.1727 30.3766C28.8077 30.3768 28.4566 30.2365 28.1922 29.9849C28.0389 29.8167 27.9222 29.6186 27.8495 29.4029C27.7767 29.1873 27.7496 28.9589 27.7698 28.7322L27.7687 9.60918C27.7503 9.38836 27.7773 9.16612 27.8481 8.95614C27.9189 8.74616 28.0319 8.5529 28.1802 8.38827C28.4619 8.12701 28.8323 7.98266 29.2165 7.98448H39.3301C39.4692 7.98906 39.6037 8.03573 39.7157 8.11831C39.8368 8.22369 39.9267 8.36032 39.9755 8.51328C40.047 8.69786 40.0972 8.89001 40.1252 9.08598C40.156 9.37633 40.1703 9.6682 40.1679 9.96018C40.1694 10.2326 40.1556 10.5049 40.1268 10.7758C40.1067 10.9733 40.0632 11.1678 39.9972 11.3551C39.9468 11.4985 39.8628 11.6278 39.7521 11.7321C39.64 11.8279 39.4981 11.8818 39.3506 11.8849H32.3122V16.857H38.2334C38.379 16.8568 38.5201 16.9083 38.6313 17.0024C38.75 17.1025 38.8402 17.2321 38.8927 17.3783C38.9603 17.5633 39.0041 17.7561 39.023 17.9522C39.0742 18.4941 39.0742 19.0396 39.023 19.5815C39.0037 19.7761 38.9596 19.9674 38.8919 20.1509C38.8405 20.2974 38.7481 20.426 38.6258 20.5217C38.516 20.614 38.3751 20.6611 38.2318 20.6533H32.3122V26.4282H39.4015C39.5465 26.4289 39.6868 26.4796 39.7987 26.5717C39.918 26.676 40.0083 26.8093 40.0608 26.9588C40.1256 27.1432 40.1688 27.3346 40.1896 27.5289L40.195 27.5592C40.2511 28.1261 40.2522 28.6971 40.1981 29.2642C40.1783 29.4625 40.1348 29.6578 40.0686 29.8459C40.0171 29.994 39.9278 30.1261 39.8096 30.2291C39.6976 30.3237 39.5558 30.3756 39.4092 30.3757H29.2107C29.1979 30.3766 29.1851 30.3766 29.1727 30.3766ZM29.1812 8.40558C28.9211 8.40392 28.6704 8.503 28.4816 8.68206C28.3738 8.80565 28.2923 8.94986 28.242 9.10593C28.1916 9.26201 28.1735 9.42668 28.1888 9.58996L28.1899 28.7516C28.1729 28.9207 28.1911 29.0916 28.2433 29.2534C28.2956 29.4152 28.3808 29.5644 28.4936 29.6916C28.5889 29.7805 28.7008 29.8496 28.823 29.8949C28.9452 29.9402 29.0751 29.9608 29.2053 29.9554H39.4093C39.4557 29.9556 39.5006 29.9391 39.5358 29.9089C39.5978 29.8546 39.6445 29.785 39.6715 29.7072C39.7266 29.5507 39.7628 29.3882 39.7793 29.2231C39.8298 28.6899 39.8298 28.1531 39.7793 27.6198L39.981 27.5601L39.7716 27.5818C39.7546 27.4168 39.7185 27.2543 39.6637 27.0978C39.6359 27.0185 39.5881 26.9477 39.5249 26.8922C39.4892 26.8643 39.4452 26.849 39.3998 26.8488H31.891V20.2331H38.2349C38.2833 20.233 38.3304 20.2172 38.3691 20.1881C38.4276 20.1419 38.4712 20.0796 38.4948 20.0089C38.5511 19.8585 38.5878 19.7014 38.6041 19.5416C38.6522 19.0266 38.6522 18.5083 38.6041 17.9933C38.5881 17.8322 38.5519 17.6737 38.4963 17.5217C38.469 17.4448 38.4216 17.3766 38.359 17.3242C38.3238 17.2947 38.2793 17.2786 38.2334 17.2788H31.891V11.4637H39.3534C39.3744 11.4663 39.3956 11.4639 39.4154 11.4567C39.4353 11.4495 39.4531 11.4377 39.4674 11.4222C39.5272 11.3645 39.5727 11.2935 39.6001 11.2151C39.6552 11.0591 39.6914 10.8972 39.7079 10.7326C39.7359 10.4761 39.7491 10.2181 39.7474 9.96005C39.75 9.68582 39.7368 9.41168 39.7079 9.13897C39.6834 8.97272 39.6399 8.80982 39.5784 8.65343C39.5543 8.57145 39.5079 8.49783 39.4442 8.44087C39.4108 8.4192 39.3721 8.40714 39.3323 8.40598H29.2107L29.1812 8.40558Z",
                        fill: "#010101"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_1_26",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        fill: "white",
                        height: "38",
                        transform: "translate(0.5)",
                        width: "67"
                    })
                })
            })
        ]
    });
}
function EnergyF() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        fill: "none",
        height: "38",
        viewBox: "0 0 68 38",
        width: "68",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                clipPath: "url(#clip0_1_62)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M67.0022 0.597603H52.7545V37.4086H67.0022V0.597603Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M15.6213 0.597343H52.7542V37.4083H15.6213L0.671814 19.0028L15.6213 0.597343Z",
                        fill: "#F37124"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M15.9896 0.327708H66.9602C67.0318 0.327708 67.1004 0.356143 67.1511 0.406758C67.2017 0.457373 67.2301 0.526022 67.2301 0.597602V37.4086C67.2301 37.4802 67.2017 37.5488 67.1511 37.5994C67.1004 37.65 67.0318 37.6785 66.9602 37.6785H15.9896C15.9526 37.6785 15.916 37.671 15.882 37.6562C15.848 37.6415 15.8174 37.62 15.7922 37.5929L0.842638 19.1611C0.795898 19.1111 0.769897 19.0452 0.769897 18.9768C0.769897 18.9083 0.795898 18.8424 0.842638 18.7924L15.7922 0.360622C15.8513 0.324737 15.922 0.312955 15.9896 0.327708Z",
                        stroke: "#231F20",
                        strokeLinejoin: "round",
                        strokeWidth: "0.539789"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M63.9891 11.5115C64.036 11.6437 64.0717 11.7796 64.0959 11.9178C64.1055 11.957 64.1053 11.998 64.0953 12.0371C64.0853 12.0763 64.0659 12.1123 64.0386 12.1422C63.9584 12.202 63.8611 12.2344 63.761 12.2347C63.6279 12.2463 63.4451 12.2521 63.2126 12.252C62.9703 12.252 62.7819 12.2489 62.6465 12.2418C62.5419 12.2394 62.4379 12.2249 62.3367 12.1987C62.2786 12.1858 62.2261 12.1547 62.1869 12.11C62.1549 12.0645 62.131 12.0138 62.1161 11.9602L61.4962 10.1082H58.0336L57.4499 11.9107C57.434 11.97 57.4088 12.0264 57.3753 12.0779C57.3376 12.128 57.2853 12.1653 57.2255 12.1846C57.1311 12.2156 57.033 12.2335 56.9337 12.238C56.8077 12.2476 56.6427 12.2523 56.4387 12.252C56.2674 12.2542 56.0962 12.2471 55.9257 12.2308C55.8304 12.229 55.7391 12.1924 55.6689 12.128C55.644 12.0954 55.6266 12.0577 55.618 12.0176C55.6093 11.9774 55.6096 11.9359 55.6188 11.8959C55.6426 11.7601 55.6785 11.6268 55.7262 11.4974L58.5687 3.32031C58.5917 3.25024 58.6253 3.18411 58.6683 3.12421C58.7158 3.06847 58.7793 3.02875 58.8502 3.01046C58.9626 2.9801 59.0783 2.96348 59.1948 2.96095C59.3427 2.95385 59.5371 2.95003 59.7798 2.95003C60.0594 2.95003 60.2825 2.95367 60.449 2.96095C60.5796 2.9633 60.7096 2.9799 60.8366 3.01046C60.914 3.02752 60.984 3.06871 61.0366 3.12809C61.0833 3.19262 61.1183 3.26486 61.14 3.34151L63.9891 11.5115ZM59.7579 4.75174H59.7509L58.4475 8.66929H61.0617L59.7579 4.75174Z",
                        fill: "#231D1E"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M62.4545 16.7022L60.3743 14.6221C60.2371 14.4854 60.0513 14.4086 59.8576 14.4086C59.6639 14.4086 59.4781 14.4854 59.3408 14.6221L57.2607 16.7022C57.1928 16.7701 57.139 16.8506 57.1022 16.9393C57.0655 17.028 57.0466 17.123 57.0466 17.219C57.0466 17.3149 57.0655 17.41 57.1022 17.4986C57.139 17.5873 57.1928 17.6679 57.2607 17.7357C57.3285 17.8036 57.4091 17.8574 57.4977 17.8941C57.5864 17.9309 57.6814 17.9498 57.7774 17.9498C57.8734 17.9498 57.9684 17.9309 58.0571 17.8941C58.1457 17.8574 58.2263 17.8036 58.2942 17.7357L59.1264 16.9036V23.0256C59.1264 23.2194 59.2034 23.4053 59.3404 23.5424C59.4775 23.6795 59.6634 23.7565 59.8573 23.7565C60.0511 23.7565 60.237 23.6795 60.3741 23.5424C60.5112 23.4053 60.5882 23.2194 60.5882 23.0256V16.9036L61.4207 17.736C61.5577 17.8731 61.7436 17.9501 61.9374 17.9501C62.1312 17.9501 62.3171 17.8731 62.4542 17.736C62.5912 17.599 62.6682 17.4131 62.6682 17.2193C62.6682 17.0255 62.5915 16.8393 62.4545 16.7022Z",
                        fill: "#211F11"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M63.4532 27.2642C63.4538 27.3814 63.4485 27.4986 63.4371 27.6152C63.4301 27.695 63.4148 27.7739 63.3915 27.8505C63.3791 27.8971 63.3545 27.9395 63.3201 27.9733C63.2917 27.9967 63.2559 28.0093 63.2191 28.0087C63.1189 27.9902 63.0249 27.9466 62.946 27.882C62.7859 27.779 62.6187 27.6875 62.4457 27.6082C62.2048 27.4977 61.9557 27.4062 61.7006 27.3343C61.3733 27.2452 61.035 27.2027 60.6958 27.2084C60.3153 27.2027 59.9381 27.2804 59.5908 27.4359C59.2643 27.5857 58.9754 27.8067 58.7454 28.0826C58.5018 28.379 58.3184 28.7201 58.2056 29.0868C58.0756 29.5061 58.0121 29.9431 58.0173 30.3821C58.0091 30.8471 58.074 31.3104 58.2095 31.7552C58.3194 32.119 58.5018 32.4569 58.7456 32.7484C58.9706 33.0124 59.2548 33.2195 59.575 33.3527C59.9142 33.4921 60.2781 33.5615 60.6447 33.5567C60.8355 33.5565 61.0254 33.533 61.2105 33.4867C61.3927 33.4415 61.5676 33.3706 61.7298 33.276V31.1685H60.1368C60.0591 31.1685 59.998 31.1164 59.9549 31.011C59.9022 30.837 59.8802 30.6551 59.89 30.4735C59.8886 30.3634 59.8942 30.2532 59.9067 30.1437C59.9137 30.0704 59.9299 29.9983 59.9549 29.9291C59.9714 29.884 59.998 29.8433 60.0327 29.8101C60.0616 29.7851 60.0986 29.7714 60.1368 29.7716H62.9782C63.0423 29.7704 63.1057 29.7836 63.164 29.8101C63.22 29.8373 63.269 29.8769 63.3073 29.9259C63.3501 29.9813 63.3819 30.0443 63.4012 30.1116C63.4239 30.1928 63.4347 30.2768 63.4333 30.361V33.9778C63.4364 34.104 63.4132 34.2296 63.3652 34.3464C63.3081 34.4626 63.2081 34.5521 63.0862 34.5958C62.9448 34.6563 62.7703 34.7199 62.563 34.7848C62.3557 34.8497 62.1386 34.907 61.9156 34.9539C61.6922 35.0009 61.4665 35.0359 61.2394 35.0589C61.0116 35.0829 60.7826 35.0949 60.5535 35.0949C59.9377 35.1047 59.3255 34.9985 58.749 34.7819C58.2363 34.5862 57.7749 34.2765 57.3996 33.8761C57.0186 33.4592 56.7305 32.9662 56.5542 32.4297C56.3507 31.8052 56.2519 31.1514 56.2617 30.4947C56.2515 29.8134 56.3571 29.1353 56.574 28.4893C56.7621 27.9307 57.063 27.4167 57.4579 26.9792C57.8419 26.5632 58.3139 26.2382 58.8394 26.0278C59.4139 25.8015 60.0271 25.6895 60.6445 25.698C60.9778 25.6953 61.3106 25.7221 61.639 25.7784C61.9048 25.824 62.1668 25.8897 62.4227 25.9751C62.6159 26.0388 62.8021 26.1224 62.9781 26.2245C63.0915 26.2869 63.1956 26.3648 63.2875 26.4559C63.3529 26.536 63.3965 26.6317 63.4141 26.7337C63.4449 26.9088 63.458 27.0865 63.4532 27.2642Z",
                        fill: "#010101"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M39.661 10.0931C39.6632 10.3771 39.65 10.6609 39.6215 10.9434C39.6055 11.1308 39.5634 11.315 39.4965 11.4907C39.4529 11.6041 39.3865 11.7074 39.3014 11.7941C39.2346 11.8592 39.1449 11.8955 39.0517 11.8951H32.4559V17.7565H38.6468C38.7373 17.7553 38.8256 17.7849 38.897 17.8405C38.9846 17.9184 39.0516 18.0168 39.092 18.1269C39.1582 18.2999 39.2003 18.4813 39.217 18.6658C39.2695 19.2259 39.2695 19.7896 39.217 20.3497C39.1988 20.5398 39.1568 20.7267 39.092 20.9063C39.0524 21.0241 38.9856 21.1308 38.897 21.2177C38.8278 21.2783 38.7387 21.3112 38.6468 21.3103H32.4559V29.4285C32.4587 29.5422 32.4261 29.654 32.3626 29.7484C32.2755 29.8555 32.1587 29.9346 32.0269 29.9758C31.8225 30.0475 31.6104 30.0954 31.395 30.1184C30.7338 30.1862 30.0675 30.1862 29.4064 30.1184C29.191 30.0966 28.979 30.0487 28.7751 29.9758C28.6447 29.9318 28.5288 29.8532 28.4397 29.7484C28.3712 29.656 28.3355 29.5434 28.3384 29.4285V9.67185C28.3202 9.47904 28.342 9.28455 28.4023 9.10053C28.4627 8.9165 28.5603 8.74689 28.6891 8.60228C28.9233 8.38325 29.2343 8.26526 29.5548 8.27386H39.0523C39.1441 8.27316 39.233 8.30621 39.3021 8.36674C39.3896 8.45125 39.4564 8.5549 39.4971 8.66955C39.5637 8.85125 39.6058 9.04102 39.6222 9.23383C39.6503 9.51939 39.6632 9.80622 39.661 10.0931Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M30.4184 30.3766C30.0788 30.3767 29.7394 30.3589 29.4016 30.3235C29.1695 30.3007 28.9411 30.2491 28.7217 30.17C28.5567 30.1134 28.4105 30.0123 28.2993 29.8779C28.199 29.7451 28.1459 29.5826 28.1486 29.4162V9.59938C28.1293 9.3807 28.1549 9.1604 28.2238 8.95196C28.2926 8.74352 28.4033 8.55132 28.549 8.38715C28.8282 8.12604 29.197 7.98201 29.5793 7.98475H39.0484C39.1913 7.98523 39.3292 8.03724 39.4368 8.13122C39.5523 8.24153 39.6402 8.3774 39.6936 8.5279C39.7674 8.72724 39.8136 8.93577 39.8308 9.14767L39.8315 9.14997C39.8533 9.45446 39.8585 9.75992 39.847 10.065C39.8624 10.3501 39.8624 10.6359 39.847 10.9211C39.8303 11.1321 39.783 11.3396 39.7067 11.537C39.6517 11.6772 39.5682 11.8044 39.4615 11.9105C39.3553 12.0153 39.2122 12.0741 39.063 12.0743H32.6721V17.5206H38.6615C38.7997 17.5207 38.9339 17.5674 39.0423 17.6532C39.1592 17.7543 39.2495 17.8825 39.3052 18.0267C39.3788 18.2166 39.4255 18.4159 39.4439 18.6187C39.4986 19.1937 39.4986 19.7725 39.4439 20.3474C39.4245 20.5566 39.3781 20.7624 39.3057 20.9596C39.2536 21.1058 39.1683 21.238 39.0567 21.3458C38.9455 21.442 38.8043 21.4963 38.6574 21.4993H32.6795V29.4208C32.683 29.5777 32.6375 29.7319 32.5493 29.8618C32.4375 30.0082 32.2836 30.1169 32.1082 30.1732C31.8902 30.2491 31.6641 30.2996 31.4345 30.3236C31.0969 30.359 30.7578 30.3767 30.4184 30.3766ZM29.5443 8.40295C29.2858 8.40152 29.0369 8.49998 28.8493 8.67779C28.7437 8.80111 28.6642 8.94453 28.6156 9.09941C28.5669 9.2543 28.5502 9.41743 28.5663 9.57897L28.5674 29.4208C28.5648 29.4921 28.5864 29.5621 28.6287 29.6196C28.6906 29.6915 28.7708 29.7453 28.8607 29.7754C29.0489 29.8433 29.2448 29.8875 29.4439 29.907C30.0912 29.9741 30.7438 29.9741 31.3911 29.907C31.5903 29.8861 31.7864 29.8422 31.9755 29.776C32.0689 29.7474 32.1515 29.6912 32.2125 29.6149C32.2472 29.5582 32.2643 29.4925 32.2618 29.426V21.0813H38.6598C38.701 21.0781 38.7405 21.0634 38.7739 21.039C38.8362 20.9769 38.8836 20.9015 38.9126 20.8184C38.973 20.654 39.0119 20.4825 39.0282 20.3081C39.0799 19.7592 39.0799 19.2066 39.0282 18.6577C39.0131 18.493 38.975 18.3313 38.9149 18.1772C38.8855 18.0991 38.8373 18.0295 38.7747 17.9744C38.7415 17.951 38.7019 17.9387 38.6613 17.9393H32.2536V11.6557H39.0623C39.1016 11.6555 39.1393 11.6402 39.1677 11.6129C39.2324 11.5479 39.2832 11.4704 39.3172 11.3852C39.3774 11.2271 39.4153 11.0615 39.4297 10.893C39.4437 10.6183 39.4435 10.3431 39.429 10.0685C39.4399 9.77264 39.4347 9.47644 39.4135 9.18117C39.3992 9.00632 39.3611 8.83423 39.3002 8.66969C39.2696 8.58254 39.2192 8.50367 39.153 8.43929C39.123 8.41567 39.0858 8.40301 39.0477 8.40341H29.5736L29.5443 8.40295Z",
                        fill: "#010101"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_1_62",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        fill: "white",
                        height: "38",
                        transform: "translate(0.5)",
                        width: "67"
                    })
                })
            })
        ]
    });
}
function EnergyG() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        fill: "none",
        height: "38",
        viewBox: "0 0 68 38",
        width: "68",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                clipPath: "url(#clip0_1_74)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M67.0022 0.597603H52.7545V37.4086H67.0022V0.597603Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M15.6213 0.59734H52.7542V37.4083H15.6213L0.671814 19.0028L15.6213 0.59734Z",
                        fill: "#ED1C24"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M15.9896 0.327708H66.9602C67.0318 0.327708 67.1004 0.356143 67.1511 0.406758C67.2017 0.457373 67.2301 0.526022 67.2301 0.597602V37.4086C67.2301 37.4802 67.2017 37.5488 67.1511 37.5994C67.1004 37.65 67.0318 37.6785 66.9602 37.6785H15.9896C15.9526 37.6785 15.916 37.671 15.882 37.6562C15.848 37.6415 15.8174 37.62 15.7922 37.5929L0.842638 19.1611C0.795898 19.1111 0.769897 19.0452 0.769897 18.9768C0.769897 18.9083 0.795898 18.8424 0.842638 18.7924L15.7922 0.360622C15.8513 0.324737 15.922 0.312955 15.9896 0.327708Z",
                        stroke: "#231F20",
                        strokeLinejoin: "round",
                        strokeWidth: "0.539789"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M63.9891 11.5115C64.036 11.6437 64.0717 11.7796 64.0959 11.9178C64.1055 11.957 64.1053 11.998 64.0953 12.0371C64.0853 12.0763 64.0659 12.1123 64.0386 12.1422C63.9584 12.202 63.8611 12.2344 63.761 12.2347C63.6279 12.2463 63.4451 12.2521 63.2126 12.252C62.9703 12.252 62.7819 12.2489 62.6465 12.2418C62.5419 12.2394 62.4379 12.2249 62.3367 12.1987C62.2786 12.1858 62.2261 12.1547 62.1869 12.11C62.1549 12.0645 62.131 12.0138 62.1161 11.9602L61.4962 10.1082H58.0336L57.4499 11.9107C57.434 11.97 57.4088 12.0264 57.3753 12.0779C57.3376 12.128 57.2853 12.1653 57.2255 12.1846C57.1311 12.2156 57.033 12.2335 56.9337 12.238C56.8077 12.2476 56.6427 12.2523 56.4387 12.252C56.2674 12.2542 56.0962 12.2471 55.9257 12.2308C55.8304 12.229 55.7391 12.1924 55.6689 12.128C55.644 12.0954 55.6266 12.0577 55.618 12.0176C55.6093 11.9774 55.6096 11.9359 55.6188 11.8959C55.6426 11.7601 55.6785 11.6268 55.7262 11.4974L58.5687 3.32031C58.5917 3.25025 58.6253 3.18412 58.6683 3.12421C58.7158 3.06847 58.7793 3.02875 58.8502 3.01046C58.9626 2.9801 59.0783 2.96348 59.1948 2.96096C59.3427 2.95385 59.5371 2.95003 59.7798 2.95003C60.0594 2.95003 60.2825 2.95367 60.449 2.96096C60.5796 2.96331 60.7096 2.97991 60.8366 3.01046C60.914 3.02753 60.984 3.06871 61.0366 3.1281C61.0833 3.19262 61.1183 3.26486 61.14 3.34151L63.9891 11.5115ZM59.7579 4.75174H59.7509L58.4475 8.66929H61.0617L59.7579 4.75174Z",
                        fill: "#231D1E"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M62.4545 16.7022L60.3743 14.622C60.2371 14.4854 60.0513 14.4086 59.8576 14.4086C59.6639 14.4086 59.4781 14.4854 59.3408 14.622L57.2607 16.7022C57.1928 16.7701 57.139 16.8506 57.1023 16.9393C57.0655 17.028 57.0466 17.123 57.0466 17.219C57.0466 17.3149 57.0655 17.41 57.1023 17.4986C57.139 17.5873 57.1928 17.6678 57.2607 17.7357C57.3285 17.8036 57.4091 17.8574 57.4978 17.8941C57.5864 17.9308 57.6815 17.9498 57.7774 17.9498C57.8734 17.9498 57.9684 17.9308 58.0571 17.8941C58.1458 17.8574 58.2263 17.8036 58.2942 17.7357L59.1264 16.9036V23.0256C59.1264 23.2194 59.2034 23.4053 59.3405 23.5424C59.4775 23.6795 59.6634 23.7565 59.8573 23.7565C60.0511 23.7565 60.2371 23.6795 60.3741 23.5424C60.5112 23.4053 60.5882 23.2194 60.5882 23.0256V16.9036L61.4207 17.736C61.5577 17.8731 61.7436 17.9501 61.9374 17.9501C62.1312 17.9501 62.3171 17.8731 62.4542 17.736C62.5912 17.599 62.6682 17.4131 62.6682 17.2193C62.6682 17.0255 62.5915 16.8393 62.4545 16.7022Z",
                        fill: "#211F11"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M63.4532 27.2642C63.4538 27.3814 63.4485 27.4986 63.4371 27.6152C63.4301 27.695 63.4148 27.7739 63.3915 27.8505C63.3791 27.8971 63.3545 27.9395 63.3201 27.9733C63.2917 27.9967 63.2559 28.0093 63.2191 28.0087C63.1189 27.9902 63.0249 27.9466 62.946 27.882C62.7859 27.779 62.6187 27.6875 62.4457 27.6082C62.2048 27.4977 61.9557 27.4062 61.7006 27.3343C61.3733 27.2451 61.035 27.2027 60.6958 27.2083C60.3153 27.2027 59.9381 27.2804 59.5908 27.4359C59.2643 27.5857 58.9754 27.8067 58.7454 28.0826C58.5018 28.379 58.3184 28.7201 58.2056 29.0867C58.0756 29.5061 58.0121 29.9431 58.0173 30.3821C58.0091 30.8471 58.074 31.3104 58.2095 31.7552C58.3194 32.119 58.5018 32.4569 58.7456 32.7484C58.9706 33.0124 59.2548 33.2194 59.575 33.3527C59.9142 33.4921 60.2781 33.5615 60.6447 33.5567C60.8355 33.5565 61.0254 33.533 61.2105 33.4867C61.3927 33.4415 61.5676 33.3706 61.7298 33.276V31.1685H60.1368C60.0591 31.1685 59.998 31.1164 59.9549 31.011C59.9022 30.837 59.8802 30.6551 59.89 30.4735C59.8886 30.3634 59.8942 30.2532 59.9067 30.1437C59.9137 30.0704 59.9299 29.9983 59.9549 29.9291C59.9714 29.884 59.998 29.8433 60.0327 29.8101C60.0616 29.7851 60.0986 29.7714 60.1368 29.7716H62.9782C63.0423 29.7704 63.1057 29.7836 63.164 29.8101C63.22 29.8373 63.269 29.8769 63.3073 29.9259C63.3501 29.9813 63.3819 30.0443 63.4012 30.1116C63.4239 30.1928 63.4347 30.2768 63.4333 30.361V33.9778C63.4364 34.104 63.4132 34.2296 63.3652 34.3464C63.3081 34.4626 63.2081 34.5521 63.0862 34.5958C62.9448 34.6563 62.7703 34.7199 62.563 34.7848C62.3557 34.8497 62.1386 34.907 61.9156 34.9539C61.6922 35.0009 61.4665 35.0359 61.2394 35.0589C61.0116 35.0828 60.7826 35.0949 60.5535 35.0949C59.9377 35.1047 59.3255 34.9985 58.749 34.7819C58.2363 34.5862 57.7749 34.2765 57.3996 33.8761C57.0186 33.4592 56.7305 32.9662 56.5542 32.4297C56.3507 31.8052 56.2519 31.1514 56.2617 30.4947C56.2515 29.8134 56.3571 29.1353 56.574 28.4893C56.7621 27.9307 57.063 27.4167 57.4579 26.9792C57.8419 26.5632 58.3139 26.2382 58.8394 26.0278C59.4139 25.8015 60.0271 25.6895 60.6445 25.698C60.9778 25.6953 61.3106 25.7221 61.639 25.7784C61.9048 25.824 62.1668 25.8897 62.4227 25.9751C62.6159 26.0388 62.8021 26.1224 62.9781 26.2245C63.0915 26.2869 63.1956 26.3648 63.2875 26.4559C63.3529 26.536 63.3965 26.6317 63.4141 26.7337C63.4449 26.9088 63.458 27.0865 63.4532 27.2642Z",
                        fill: "#010101"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M42.3614 11.9467C42.3632 12.2202 42.3504 12.4935 42.3232 12.7656C42.3068 12.9516 42.2715 13.1355 42.2179 13.3143C42.1887 13.4231 42.131 13.5221 42.0507 13.601C41.9849 13.6556 41.9016 13.6846 41.8161 13.6827C41.5824 13.6396 41.3632 13.5382 41.179 13.3881C40.8057 13.1472 40.4154 12.9338 40.0111 12.7496C39.4497 12.4921 38.8692 12.2785 38.2748 12.1106C37.5116 11.9023 36.7229 11.8032 35.9319 11.816C35.0441 11.8031 34.1643 11.9847 33.3542 12.3482C32.5932 12.6975 31.9197 13.2123 31.3828 13.8548C30.8146 14.546 30.3871 15.3416 30.1243 16.1968C29.8212 17.1749 29.6728 18.1944 29.6847 19.2184C29.6661 20.3023 29.817 21.3824 30.1318 22.4198C30.3893 23.2683 30.8148 24.0565 31.3828 24.7374C31.9081 25.3518 32.5702 25.8342 33.316 26.1458C34.1073 26.47 34.9558 26.6313 35.8109 26.6203C36.2557 26.6205 36.6988 26.5656 37.1301 26.4569C37.5557 26.3513 37.964 26.1858 38.343 25.9652V21.0526H34.6278C34.4456 21.0526 34.304 20.9297 34.2031 20.6839C34.0799 20.2785 34.0286 19.8546 34.0517 19.4314C34.0492 19.1742 34.0619 18.917 34.0896 18.6612C34.1062 18.4906 34.1445 18.3227 34.2034 18.1617C34.241 18.0557 34.3034 17.9603 34.3853 17.8832C34.4526 17.8247 34.5389 17.7928 34.6281 17.7932H41.2541C41.4031 17.7909 41.5508 17.8216 41.6866 17.8832C41.8166 17.9467 41.9304 18.039 42.0194 18.1531C42.1199 18.2824 42.1947 18.4297 42.2398 18.5871C42.2928 18.7764 42.3183 18.9723 42.3155 19.1688V27.6033C42.3218 27.8978 42.2675 28.1904 42.1559 28.463C42.0228 28.7345 41.7887 28.9432 41.5038 29.0446C41.1048 29.2127 40.6975 29.3603 40.2835 29.4869C39.7986 29.6397 39.2957 29.7707 38.775 29.8796C38.2539 29.989 37.7275 30.0711 37.1979 30.1255C36.6664 30.1798 36.1325 30.207 35.5983 30.2072C34.1624 30.2304 32.735 29.9833 31.3906 29.4786C30.195 29.0221 29.119 28.2995 28.244 27.3655C27.3553 26.3936 26.6833 25.2438 26.2727 23.9925C25.7977 22.5364 25.5672 21.0118 25.5906 19.4804C25.5671 17.8919 25.8131 16.3109 26.3184 14.8047C26.7571 13.5022 27.4589 12.3038 28.3801 11.2838C29.2756 10.3135 30.3766 9.55531 31.6025 9.06472C32.9417 8.53654 34.3711 8.27504 35.8106 8.29493C36.5879 8.28904 37.3643 8.35213 38.1305 8.48346C38.7504 8.58925 39.3612 8.74249 39.9576 8.94182C40.4087 9.09053 40.8432 9.28531 41.2544 9.52308C41.5181 9.66949 41.7604 9.85133 41.9748 10.0635C42.1272 10.2502 42.2289 10.473 42.2701 10.7104C42.3415 11.1185 42.3721 11.5326 42.3614 11.9467Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M35.5209 30.4424C34.0886 30.443 32.6686 30.178 31.333 29.6606C30.1094 29.1894 29.008 28.4479 28.111 27.4914C27.2 26.4976 26.5123 25.3204 26.0939 24.0389C25.6107 22.5585 25.3763 21.0082 25.4002 19.4511C25.3767 17.8394 25.6268 16.2355 26.14 14.7075C26.5871 13.3769 27.3043 12.153 28.2465 11.1126C29.1634 10.1177 30.2903 9.33948 31.5454 8.83426C32.9084 8.2945 34.3644 8.02871 35.8303 8.05209C36.6126 8.04914 37.3937 8.11434 38.1648 8.24694C38.7945 8.35601 39.415 8.51249 40.0211 8.71504C40.4853 8.86938 40.9326 9.07044 41.3561 9.31513C41.6344 9.46946 41.8906 9.66069 42.1176 9.88362C42.2968 10.0996 42.417 10.3584 42.4665 10.6347C42.5521 11.0457 42.5973 11.4641 42.6015 11.8839C42.6031 12.1657 42.5899 12.4475 42.562 12.7279C42.5434 12.9281 42.505 13.1259 42.4473 13.3185C42.4073 13.4601 42.3305 13.5885 42.2247 13.6907C42.1165 13.7805 41.9807 13.8304 41.8402 13.832C41.5619 13.7874 41.3 13.6713 41.0801 13.4951C40.7205 13.2657 40.3453 13.0618 39.9572 12.8849C39.406 12.6321 38.8358 12.4227 38.2519 12.2586C37.5082 12.054 36.7393 11.9557 35.9681 11.9665C35.1076 11.954 34.2549 12.1312 33.4706 12.4856C32.7351 12.8308 32.0861 13.3361 31.5711 13.9645C31.0189 14.6342 30.6039 15.406 30.3498 16.236C30.0535 17.1951 29.9088 18.1946 29.921 19.1983C29.9005 20.2652 30.0478 21.3286 30.3573 22.3499C30.6079 23.1674 31.0202 23.9263 31.5697 24.5814C32.0745 25.1718 32.7104 25.6359 33.4267 25.9366C34.1937 26.2447 35.0133 26.4011 35.8399 26.3969C36.269 26.3942 36.6963 26.3421 37.1134 26.2417C37.4826 26.1502 37.8384 26.0116 38.1722 25.8295V21.231H34.6608C34.5194 21.2244 34.384 21.1727 34.2741 21.0836C34.1643 20.9944 34.0858 20.8725 34.0503 20.7356C33.9157 20.303 33.8588 19.85 33.882 19.3975C33.8669 19.1415 33.8669 18.8849 33.882 18.6289C33.9009 18.4385 33.9436 18.2513 34.009 18.0716C34.0591 17.9357 34.1407 17.8137 34.247 17.7155C34.352 17.6218 34.4878 17.5699 34.6285 17.5698H41.3075C41.4855 17.5664 41.6617 17.6044 41.8225 17.6807C41.9805 17.7584 42.1191 17.8706 42.228 18.009C42.3465 18.1593 42.4341 18.3316 42.4859 18.5158C42.5457 18.7245 42.5743 18.9408 42.5706 19.1579V27.5977C42.576 27.9184 42.516 28.237 42.3944 28.5339C42.2388 28.8589 41.9614 29.1096 41.6224 29.2316C41.2228 29.4118 40.8104 29.5621 40.3886 29.6814C39.8782 29.8268 39.3752 29.9662 38.8393 30.0771C38.3091 30.1981 37.773 30.2909 37.2331 30.3553C36.6643 30.4148 36.0927 30.4439 35.5209 30.4424ZM35.6675 8.45785C34.3079 8.45654 32.9603 8.71258 31.6959 9.21244C30.498 9.69434 29.4226 10.437 28.5476 11.3865C27.6431 12.385 26.9547 13.5596 26.5253 14.8366C26.0263 16.323 25.7835 17.8834 25.8072 19.4511C25.7831 20.9652 26.0106 22.4727 26.4803 23.9122C26.8806 25.1383 27.5385 26.2646 28.4097 27.2155C29.2643 28.1265 30.3135 28.8327 31.4792 29.2813C32.7981 29.7859 34.1991 30.0416 35.6112 30.0354C36.1379 30.0347 36.6642 30.0067 37.188 29.9515C37.714 29.8885 38.2363 29.7977 38.7527 29.6794C39.2793 29.5707 39.7747 29.4335 40.2777 29.2904C40.6858 29.1755 41.0848 29.0299 41.471 28.8548C41.7118 28.7708 41.9102 28.596 42.0239 28.3677C42.1211 28.1239 42.1687 27.8633 42.1641 27.6009V19.1549C42.1666 18.9765 42.1432 18.7987 42.0944 18.6272C42.0573 18.4936 41.9939 18.3688 41.9078 18.2602C41.8376 18.1708 41.7486 18.098 41.6469 18.047C41.5387 18.0057 41.4246 17.9819 41.3089 17.9766H34.63C34.6096 17.9739 34.5888 17.9763 34.5695 17.9835C34.5501 17.9907 34.5329 18.0024 34.5191 18.0178C34.4618 18.0714 34.418 18.1378 34.3913 18.2115C34.3382 18.3565 34.3033 18.5076 34.2875 18.6612C34.2739 18.9061 34.2742 19.1514 34.2882 19.3962C34.266 19.8028 34.315 20.21 34.4331 20.5997C34.4923 20.7428 34.5706 20.8246 34.6606 20.8246H38.5793V26.0648L38.4781 26.124C38.0824 26.3538 37.656 26.5262 37.2117 26.636C36.7698 26.7467 36.3159 26.8029 35.8603 26.8032C35.8299 26.8046 35.7944 26.8039 35.7602 26.8039C34.9062 26.8046 34.0604 26.6375 33.2709 26.3122C32.4947 25.9867 31.8057 25.4838 31.259 24.8438C30.674 24.1467 30.2351 23.3392 29.9683 22.4691C29.6468 21.4088 29.4935 20.3047 29.5141 19.1969C29.5023 18.1531 29.653 17.1139 29.9608 16.1165C30.2308 15.236 30.6712 14.4171 31.2569 13.7063C31.8111 13.0306 32.5094 12.4873 33.3006 12.1161C34.1382 11.7368 35.0492 11.5468 35.9686 11.5595C36.7762 11.552 37.581 11.6553 38.3605 11.8665C38.965 12.0364 39.5553 12.2532 40.1261 12.5149C40.5385 12.7028 40.9367 12.9204 41.3176 13.1659C41.4804 13.2994 41.6743 13.3896 41.8813 13.4283C41.9066 13.4187 41.9304 13.4054 41.9517 13.3888C42.0013 13.3377 42.0369 13.2747 42.0551 13.2059C42.1063 13.0374 42.1402 12.8641 42.1564 12.6887C42.1834 12.4224 42.1962 12.155 42.1946 11.8874C42.1902 11.4934 42.1476 11.1007 42.0672 10.715L42.0664 10.7084C42.0308 10.5065 41.945 10.3168 41.8168 10.1567C41.6186 9.96627 41.3963 9.8025 41.1557 9.66961C40.7551 9.43776 40.3319 9.24739 39.8927 9.10145C39.3058 8.90531 38.7049 8.75383 38.0952 8.64829C37.3472 8.51392 36.5881 8.45068 35.8282 8.45943C35.7746 8.45831 35.7211 8.45785 35.6675 8.45785Z",
                        fill: "black"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_1_74",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        fill: "white",
                        height: "38",
                        transform: "translate(0.5)",
                        width: "67"
                    })
                })
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/features/products/components/product-page/component/product-image-and-detail.tsx
/* eslint-disable react-perf/jsx-no-new-object-as-prop */ 









// Adjust the path if necessary






function DemoupComponent(param) {
    let { buttonwidth , buttonheight , onVideoAvailable  } = param;
    const { button: VideoButton  } = distribution_default()("byko.is");
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(VideoButton, {
        buttonheight: buttonheight,
        buttonwidth: buttonwidth,
        onVideoAvailable: onVideoAvailable
    });
}
const NO_TAGS = [];
const placeholderImg = "https://www.datocms-assets.com/65892/1664464657-placeholder-do-not-remove.jpg";
const placeholderImageHandler = (e)=>{
    /* eslint-disable @typescript-eslint/ban-ts-comment */ // @ts-ignore
    const target = e.target;
    target.src = placeholderImg;
};
const ProductImageAndDetail = (param)=>{
    let { product , tags , brand , activeVariant , setActiveVariantSKU , rental  } = param;
    var ref, ref1, ref2, ref3;
    const { user , activeMembership  } = (0,hooks_auth_next_src/* useAuth */.aC)();
    var _salesAvailability;
    const salesAvailability = (_salesAvailability = product.salesAvailability) !== null && _salesAvailability !== void 0 ? _salesAvailability : "standard";
    const [videoIsAvailable, setVideoIsAvailable] = (0,react.useState)(false);
    const [mediaIsAvailable, setMediaIsAvailable] = (0,react.useState)(false);
    const activeVariantSKU = (0,react.useMemo)(()=>{
        return activeVariant === null || activeVariant === void 0 ? void 0 : activeVariant.sku;
    }, [
        activeVariant === null || activeVariant === void 0 ? void 0 : activeVariant.sku
    ]);
    const [selectedImageIndex, setSelectedImageIndex] = (0,react.useState)(0);
    const { prices: skuPrices  } = (0,lib_api_products_src/* useProductPrices */.gv)((salesAvailability === "limited" || salesAvailability === "standard" || salesAvailability === "by_contract" && (activeMembership === null || activeMembership === void 0 ? void 0 : activeMembership.account.hasContract)) && !(0,product_list/* isRentalProduct */.o)(product) ? [
        product.id
    ] : []);
    const price = skuPrices === null || skuPrices === void 0 ? void 0 : skuPrices[activeVariantSKU];
    const handleSetSelectedImageIndex = (0,react.useCallback)((index)=>{
        setSelectedImageIndex(index);
    }, [
        setSelectedImageIndex
    ]);
    const availableMedia = (0,react.useMemo)(()=>{
        const media = [];
        const matchedIds = [];
        // product media sometimes contains duplicate entries from variants, so we need to filter them out
        product.media.forEach((productMedia)=>{
            var ref, ref1;
            if ((productMedia === null || productMedia === void 0 ? void 0 : (ref = productMedia.image) === null || ref === void 0 ? void 0 : ref.productGallery) && (productMedia === null || productMedia === void 0 ? void 0 : (ref1 = productMedia.image) === null || ref1 === void 0 ? void 0 : ref1.productList) && !matchedIds.includes(productMedia.id)) {
                media.push({
                    gallery: productMedia.image.productGallery,
                    list: productMedia.image.productList,
                    id: productMedia.id
                });
                matchedIds.push(productMedia.id);
            }
        });
        product.variants.forEach((variant)=>{
            variant.media.forEach((variantMedia)=>{
                var ref, ref1;
                if ((variantMedia === null || variantMedia === void 0 ? void 0 : (ref = variantMedia.image) === null || ref === void 0 ? void 0 : ref.productGallery) && (variantMedia === null || variantMedia === void 0 ? void 0 : (ref1 = variantMedia.image) === null || ref1 === void 0 ? void 0 : ref1.productList) && !matchedIds.includes(variantMedia.id)) {
                    media.push({
                        gallery: variantMedia.image.productGallery,
                        list: variantMedia.image.productList,
                        id: variantMedia.id
                    });
                    matchedIds.push(variantMedia.id);
                }
            });
        }, []);
        setMediaIsAvailable(media.length > 0);
        return media;
    }, [
        product.media,
        product.variants
    ]);
    (0,react.useEffect)(()=>{
        var ref, ref1;
        // reset selected image index when variant changes
        const activeVariantImageId = activeVariant === null || activeVariant === void 0 ? void 0 : (ref = activeVariant.media) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : ref1.id;
        if (activeVariantImageId != null) {
            const activeVariantImageIndex = availableMedia.findIndex((media)=>media.id === activeVariantImageId);
            setSelectedImageIndex(activeVariantImageIndex);
        }
    }, [
        activeVariant === null || activeVariant === void 0 ? void 0 : activeVariant.media,
        activeVariantSKU,
        availableMedia,
        product,
        product.variants.length
    ]);
    const selectedImage = (0,react.useMemo)(()=>{
        return availableMedia[selectedImageIndex];
    }, [
        availableMedia,
        selectedImageIndex
    ]);
    const localTags = (0,react.useMemo)(()=>{
        var ref, ref1;
        if (tags) {
            return tags;
        }
        const list = [];
        if ((price === null || price === void 0 ? void 0 : (ref = price.discounted) === null || ref === void 0 ? void 0 : ref.name) === "RETAIL") {
            var ref2;
            if (price === null || price === void 0 ? void 0 : (ref2 = price.discounted) === null || ref2 === void 0 ? void 0 : ref2.percentage) {
                var ref3;
                list.push({
                    label: "-".concat(price === null || price === void 0 ? void 0 : (ref3 = price.discounted) === null || ref3 === void 0 ? void 0 : ref3.percentage, "% afsl\xe1ttur"),
                    color: "yellow"
                });
            } else {
                list.push({
                    label: "Tilbo\xf0",
                    color: "yellow"
                });
            }
        }
        if (((ref1 = product.attributes["environmentalInfo"]) === null || ref1 === void 0 ? void 0 : ref1.length) > 0) {
            list.push({
                label: "Umhverfisv\xe6n vara",
                color: "green"
            });
        }
        return list;
    }, [
        price === null || price === void 0 ? void 0 : (ref = price.discounted) === null || ref === void 0 ? void 0 : ref.name,
        price === null || price === void 0 ? void 0 : (ref1 = price.discounted) === null || ref1 === void 0 ? void 0 : ref1.percentage,
        product,
        tags
    ]);
    const previousPicture = (0,react.useCallback)(()=>{
        if (selectedImageIndex === 0) {
            setSelectedImageIndex(availableMedia.length - 1);
        } else {
            setSelectedImageIndex(selectedImageIndex - 1);
        }
    }, [
        selectedImageIndex,
        availableMedia.length
    ]);
    const nextPicture = (0,react.useCallback)(()=>{
        if (selectedImageIndex === availableMedia.length - 1) {
            setSelectedImageIndex(0);
        } else {
            setSelectedImageIndex(selectedImageIndex + 1);
        }
    }, [
        selectedImageIndex,
        availableMedia.length
    ]);
    const sliderSize = (0,react.useMemo)(()=>{
        return "".concat(1 / product.media.length * 100, "%");
    }, [
        product.media.length
    ]);
    const progress = (0,react.useMemo)(()=>{
        return "".concat(selectedImageIndex / availableMedia.length * 100, "%");
    }, [
        selectedImageIndex,
        availableMedia.length
    ]);
    // toggle next or previous image in slider using the keyboard
    const handleKeyDown = (0,react.useCallback)((event)=>{
        if (event.key === "ArrowLeft") {
            previousPicture();
        } else if (event.key === "ArrowRight") {
            nextPicture();
        }
    }, [
        nextPicture,
        previousPicture
    ]);
    const onVideoAvailable = (0,react.useCallback)(()=>{
        setVideoIsAvailable(true);
    }, []);
    const { open  } = (0,use_lightbox/* default */.ZP)();
    const handleShowElectronicImage = (0,react.useCallback)(()=>{
        var ref, ref1;
        const image = product === null || product === void 0 ? void 0 : (ref = product.energyLabel) === null || ref === void 0 ? void 0 : (ref1 = ref.image) === null || ref1 === void 0 ? void 0 : ref1.productGallery;
        if (image) {
            open(/*#__PURE__*/ (0,jsx_runtime.jsx)(ElectronicImageContainer, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ElectronicImage, {
                    alt: "orkumerking",
                    src: image
                })
            }));
        }
    }, [
        open,
        product === null || product === void 0 ? void 0 : (ref2 = product.energyLabel) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.image) === null || ref3 === void 0 ? void 0 : ref3.productGallery
    ]);
    const EnergyLabel = (0,react.useMemo)(()=>{
        const energyTag = product === null || product === void 0 ? void 0 : product.attributes["energyTag"];
        if (!energyTag) {
            return null;
        }
        let Tag = null;
        if (energyTag["is-IS"] === "A" || energyTag["is-IS"] === "a") {
            Tag = /*#__PURE__*/ (0,jsx_runtime.jsx)(EnergyA, {});
        }
        if (energyTag["is-IS"] === "B" || energyTag["is-IS"] === "b") {
            Tag = /*#__PURE__*/ (0,jsx_runtime.jsx)(EnergyB, {});
        }
        if (energyTag["is-IS"] === "C" || energyTag["is-IS"] === "c") {
            Tag = /*#__PURE__*/ (0,jsx_runtime.jsx)(EnergyC, {});
        }
        if (energyTag["is-IS"] === "D" || energyTag["is-IS"] === "d") {
            Tag = /*#__PURE__*/ (0,jsx_runtime.jsx)(EnergyD, {});
        }
        if (energyTag["is-IS"] === "E" || energyTag["is-IS"] === "e") {
            Tag = /*#__PURE__*/ (0,jsx_runtime.jsx)(EnergyE, {});
        }
        if (energyTag["is-IS"] === "F" || energyTag["is-IS"] === "f") {
            Tag = /*#__PURE__*/ (0,jsx_runtime.jsx)(EnergyF, {});
        }
        if (energyTag["is-IS"] === "G" || energyTag["is-IS"] === "g") {
            Tag = /*#__PURE__*/ (0,jsx_runtime.jsx)(EnergyG, {});
        }
        if (Tag !== null) {
            return ()=>{
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                    type: "button",
                    onClick: handleShowElectronicImage,
                    children: Tag
                });
            };
        }
        return Tag;
    }, [
        handleShowElectronicImage,
        product === null || product === void 0 ? void 0 : product.attributes
    ]);
    const DetailComponent = (0,react.useMemo)(()=>{
        /*
      "rental": rental products, not sold on web, no price display
      "custom": custom order, not sold on the web, no price display
      "limited": limited availability, not sold on the web, show price info
      "display": display only, not sold on the web, no price display
      "standard": standard products, display as is
      "by_contract": contracted products, only users with contract see price info and can order
    */ if (rental) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductRentDetail, {
                activeVariant: activeVariant,
                brand: brand,
                EnergyLabel: EnergyLabel,
                product: product
            });
        } else if (salesAvailability === "by_contract") {
            if (user && (activeMembership === null || activeMembership === void 0 ? void 0 : activeMembership.account.hasContract)) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductStandardDetail, {
                    activeVariant: activeVariant,
                    brand: brand,
                    EnergyLabel: EnergyLabel,
                    product: product,
                    setActiveVariantSKU: setActiveVariantSKU,
                    skuPrices: skuPrices
                });
            } else {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductContractDetail, {
                    activeVariant: activeVariant,
                    brand: brand,
                    EnergyLabel: EnergyLabel,
                    product: product
                });
            }
        } else if (salesAvailability === "custom") {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductCustomDetail, {
                activeVariant: activeVariant,
                brand: brand,
                EnergyLabel: EnergyLabel,
                product: product
            });
        } else if (salesAvailability === "limited") {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductLimitedDetail, {
                activeVariant: activeVariant,
                brand: brand,
                EnergyLabel: EnergyLabel,
                product: product,
                setActiveVariantSKU: setActiveVariantSKU,
                skuPrices: skuPrices
            });
        } else if (salesAvailability === "display") {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductDisplayDetail, {
                activeVariant: activeVariant,
                brand: brand,
                EnergyLabel: EnergyLabel,
                product: product
            });
        }
        // "Standard" sales availability
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductStandardDetail, {
            activeVariant: activeVariant,
            brand: brand,
            EnergyLabel: EnergyLabel,
            product: product,
            setActiveVariantSKU: setActiveVariantSKU,
            skuPrices: skuPrices
        });
    }, [
        EnergyLabel,
        activeMembership === null || activeMembership === void 0 ? void 0 : activeMembership.account.hasContract,
        activeVariant,
        brand,
        product,
        rental,
        salesAvailability,
        setActiveVariantSKU,
        skuPrices,
        user
    ]);
    const [isOpen, setIsOpen] = (0,react.useState)(false);
    const handleOpenModal = (0,react.useCallback)(()=>{
        if (!mediaIsAvailable) return;
        setIsOpen(true);
    }, [
        mediaIsAvailable
    ]);
    const handleCloseModal = (0,react.useCallback)(()=>{
        setIsOpen(false);
    }, []);
    var ref4, ref5;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(component_page_container_src/* PageContainer */._, {
        backgroundColor: lib_styles_src/* theme.palette.white.main */.rS.palette.white.main,
        flexDirection: "column",
        justifyContent: "center",
        offsetNav: false,
        children: [
            localTags && localTags.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(TagContainer, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(tags_Tags, {
                    tags: localTags !== null && localTags !== void 0 ? localTags : NO_TAGS
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ProductWrapper, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(LeftWrapper, {
                        onKeyDown: handleKeyDown,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ImageWrapper, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductImage, {
                                        clickable: mediaIsAvailable,
                                        placeholder: "https://www.datocms-assets.com/65892/1664464657-placeholder-do-not-remove.jpg",
                                        src: (ref4 = selectedImage === null || selectedImage === void 0 ? void 0 : selectedImage.gallery) !== null && ref4 !== void 0 ? ref4 : "https://www.datocms-assets.com/65892/1664464657-placeholder-do-not-remove.jpg",
                                        onClick: handleOpenModal,
                                        onError: placeholderImageHandler
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal, {
                                        open: isOpen,
                                        onClose: handleCloseModal,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalContainer, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(component_buttons_src/* IconButton */.hU, {
                                                    ariaLabel: "flakka til baka \xed myndavali",
                                                    className: "image-selection-button previous-image-button",
                                                    icon: lib_icons_src.ArrowLeftIcons,
                                                    onClick: previousPicture
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductImage, {
                                                    placeholder: "https://www.datocms-assets.com/65892/1664464657-placeholder-do-not-remove.jpg",
                                                    src: (ref5 = selectedImage === null || selectedImage === void 0 ? void 0 : selectedImage.gallery) !== null && ref5 !== void 0 ? ref5 : "https://www.datocms-assets.com/65892/1664464657-placeholder-do-not-remove.jpg",
                                                    onError: placeholderImageHandler
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(component_buttons_src/* IconButton */.hU, {
                                                    ariaLabel: "flakka \xe1fram \xed myndavali",
                                                    className: "image-selection-button next-image-button",
                                                    icon: lib_icons_src.ArrowRightIcons,
                                                    onClick: nextPicture
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(ImageFlex, {
                                                    children: [
                                                        videoIsAvailable && /*#__PURE__*/ (0,jsx_runtime.jsx)(ClickableDemoupSlideWrapper, {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SliderItem, {
                                                                transformValue: selectedImageIndex * 168,
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DemoupComponent, {
                                                                    buttonheight: 106,
                                                                    buttonwidth: 152,
                                                                    trigger: false,
                                                                    onVideoAvailable: onVideoAvailable
                                                                })
                                                            })
                                                        }),
                                                        availableMedia.map((media, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(ClickableSliderImageWrapper, {
                                                                // eslint-disable-next-line react/jsx-no-bind, react-perf/jsx-no-new-function-as-prop
                                                                onClick: ()=>handleSetSelectedImageIndex(index),
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SliderImage, {
                                                                    src: media.list,
                                                                    transformValue: selectedImageIndex * 168,
                                                                    onError: placeholderImageHandler
                                                                })
                                                            }, media.list))
                                                    ]
                                                })
                                            ]
                                        })
                                    }),
                                    availableMedia.length > 1 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(component_buttons_src/* IconButton */.hU, {
                                                ariaLabel: "flakka til baka \xed myndavali",
                                                className: "image-selection-button previous-image-button",
                                                icon: lib_icons_src.ArrowLeftIcons,
                                                onClick: previousPicture
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(component_buttons_src/* IconButton */.hU, {
                                                ariaLabel: "flakka \xe1fram \xed myndavali",
                                                className: "image-selection-button next-image-button",
                                                icon: lib_icons_src.ArrowRightIcons,
                                                onClick: nextPicture
                                            })
                                        ]
                                    }) : null
                                ]
                            }),
                            availableMedia.length > 1 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ImageFlex, {
                                        children: [
                                            videoIsAvailable && /*#__PURE__*/ (0,jsx_runtime.jsx)(ClickableDemoupSlideWrapper, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SliderItem, {
                                                    transformValue: selectedImageIndex * 168,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DemoupComponent, {
                                                        buttonheight: 106,
                                                        buttonwidth: 152,
                                                        trigger: false,
                                                        onVideoAvailable: onVideoAvailable
                                                    })
                                                })
                                            }),
                                            availableMedia.map((media, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(ClickableSliderImageWrapper, {
                                                    // eslint-disable-next-line react/jsx-no-bind, react-perf/jsx-no-new-function-as-prop
                                                    onClick: ()=>handleSetSelectedImageIndex(index),
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SliderImage, {
                                                        src: media.list,
                                                        transformValue: selectedImageIndex * 168,
                                                        onError: placeholderImageHandler
                                                    })
                                                }, media.list))
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(component_styles_PaginationContainer, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProgressBar, {
                                                progress: progress,
                                                sliderSize: sliderSize
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(component_buttons_src/* IconButton */.hU, {
                                                ariaLabel: "flakka til baka \xed myndavali",
                                                icon: lib_icons_src.ArrowLeftIcons,
                                                onClick: previousPicture
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(component_buttons_src/* IconButton */.hU, {
                                                ariaLabel: "flakka \xe1fram \xed myndavali",
                                                icon: lib_icons_src.ArrowRightIcons,
                                                onClick: nextPicture
                                            })
                                        ]
                                    })
                                ]
                            }),
                            availableMedia.length <= 1 && videoIsAvailable && /*#__PURE__*/ (0,jsx_runtime.jsx)(ClickableDemoupSlideWrapper, {
                                marginTop: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SliderItem, {
                                    transformValue: selectedImageIndex * 168,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DemoupComponent, {
                                        buttonheight: 106,
                                        buttonwidth: 152,
                                        trigger: false,
                                        onVideoAvailable: onVideoAvailable
                                    })
                                })
                            })
                        ]
                    }),
                    DetailComponent
                ]
            }),
            !videoIsAvailable && /*#__PURE__*/ (0,jsx_runtime.jsx)(HiddenContainer, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DemoupComponent, {
                    buttonheight: 106,
                    buttonwidth: 152,
                    trigger: false,
                    onVideoAvailable: onVideoAvailable
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/features/products/components/product-page/component/tab-section.tsx




const TabsSection = (param)=>{
    let { tabCollection  } = param;
    if (tabCollection === null) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TabsContainer, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(component_card_content_tabs_src/* CardContentTabs */.e, {
            tabCollection: tabCollection
        })
    });
};

;// CONCATENATED MODULE: ./src/features/products/components/product-page/component/video-section.tsx





const videoSlideBreakpoints = {
    // when window width is >= 350px
    350: {
        slidesPerView: 1,
        spaceBetween: 10
    },
    // when window width is >= 450px
    450: {
        slidesPerView: 1.5,
        spaceBetween: 10
    },
    // when window width is >= 550px
    550: {
        slidesPerView: 2.3,
        spaceBetween: 20
    },
    // when window width is >= 950px
    950: {
        slidesPerView: 3,
        spaceBetween: 20
    },
    // when window width is >= 1200px
    1200: {
        slidesPerView: 4,
        spaceBetween: 20
    }
};
const VideoSection = (param)=>{
    let { videoHeading , videoSlide  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(VideoSlideWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(component_typography_src/* Subtitle */.QE, {
                children: videoHeading ? videoHeading : ""
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(component_slider_src/* Slider */.iR, {
                breakpoints: videoSlideBreakpoints,
                slideCollection: videoSlide
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/features/products/components/product-page/component/index.ts




;// CONCATENATED MODULE: ./src/features/products/components/product-page/styles.ts
function product_page_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function product_page_styles_templateObject() {
    const data = product_page_styles_taggedTemplateLiteral([
        "\n  background-color: ",
        ";\n"
    ]);
    product_page_styles_templateObject = function() {
        return data;
    };
    return data;
}
function product_page_styles_templateObject1() {
    const data = product_page_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  width: 100%;\n  margin-top: 40px;\n  gap: 50px;\n  @media screen and (max-width: ",
        "px) {\n    display: flex;\n    flex-direction: column-reverse;\n    gap: 30px;\n  }\n"
    ]);
    product_page_styles_templateObject1 = function() {
        return data;
    };
    return data;
}
function product_page_styles_templateObject2() {
    const data = product_page_styles_taggedTemplateLiteral([
        "\n  width: 70%;\n  @media screen and (max-width: ",
        "px) {\n    width: 100%;\n  }\n"
    ]);
    product_page_styles_templateObject2 = function() {
        return data;
    };
    return data;
}
function product_page_styles_templateObject3() {
    const data = product_page_styles_taggedTemplateLiteral([
        "\n  width: 30%;\n\n  @media screen and (min-width: ",
        "px) and (max-width: ",
        "px) {\n    padding-right: 56px;\n  }\n  @media screen and (min-width: ",
        "px) and (max-width: ",
        "px) {\n    padding-right: 56px;\n  }\n\n  @media screen and (min-width: ",
        "px) {\n    padding-right: 56px;\n  }\n  @media screen and (max-width: ",
        "px) {\n    width: 100%;\n  }\n"
    ]);
    product_page_styles_templateObject3 = function() {
        return data;
    };
    return data;
}
function product_page_styles_templateObject4() {
    const data = product_page_styles_taggedTemplateLiteral([
        "\n  position: relative;\n  display: flex;\n  margin-top: 40px;\n  gap: 70px;\n  img {\n    max-width: 800px;\n    max-height: 840px;\n  }\n  @media screen and (max-width: ",
        "px) {\n    display: flex;\n    flex-direction: column-reverse;\n    gap: 30px;\n  }\n  .text-block-variant-one {\n    @media screen and (min-width: ",
        "px) and (max-width: ",
        "px) {\n      padding-left: 56px;\n    }\n    @media screen and (min-width: ",
        "px) and (max-width: ",
        "px) {\n      padding-left: 56px;\n    }\n\n    @media screen and (min-width: ",
        "px) {\n      padding-left: 56px;\n    }\n    @media screen and (max-width: ",
        "px) {\n      width: 100%;\n    }\n  }\n"
    ]);
    product_page_styles_templateObject4 = function() {
        return data;
    };
    return data;
}
function product_page_styles_templateObject5() {
    const data = product_page_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  overflow: hidden;\n  margin-top: -10rem;\n  gap: 16px;\n  overflow-x: auto;\n"
    ]);
    product_page_styles_templateObject5 = function() {
        return data;
    };
    return data;
}
function product_page_styles_templateObject6() {
    const data = product_page_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  @media screen and (max-width: ",
        "px) {\n    display: none;\n  }\n"
    ]);
    product_page_styles_templateObject6 = function() {
        return data;
    };
    return data;
}
function product_page_styles_templateObject7() {
    const data = product_page_styles_taggedTemplateLiteral([
        "\n  display: none;\n  align-items: center;\n  justify-content: center;\n  padding-bottom: 8px;\n  padding-left: 16px;\n  border-bottom: 1px solid ",
        ";\n  gap: 60px;\n  .select-container {\n    z-index: 0;\n    border: 1px solid ",
        ";\n  }\n\n  @media screen and (max-width: ",
        "px) {\n    display: flex;\n  }\n  @media screen and (max-width: ",
        "px) {\n    flex-direction: column;\n    align-items: flex-start;\n    padding-left: 0px;\n    gap: 8px;\n  }\n"
    ]);
    product_page_styles_templateObject7 = function() {
        return data;
    };
    return data;
}
function product_page_styles_templateObject8() {
    const data = product_page_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  margin-bottom: 64px;\n  gap: 24px;\n  @media screen and (max-width: ",
        "px) {\n    flex-direction: column;\n  }\n"
    ]);
    product_page_styles_templateObject8 = function() {
        return data;
    };
    return data;
}
function product_page_styles_templateObject9() {
    const data = product_page_styles_taggedTemplateLiteral([
        "\n  margin-bottom: 24px;\n  color: ",
        ";\n  font-size: 32px;\n  @media screen and (max-width: ",
        "px) {\n    margin-bottom: 8px;\n  }\n"
    ]);
    product_page_styles_templateObject9 = function() {
        return data;
    };
    return data;
}
function product_page_styles_templateObject10() {
    const data = product_page_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  width: 100%;\n  align-items: center;\n  justify-content: flex-end;\n  padding-right: 32px;\n  div {\n    max-width: 300px;\n    img {\n      width: 100%;\n      height: auto;\n      object-fit: contain;\n    }\n  }\n  @media screen and (max-width: ",
        "px) {\n    display: none;\n  }\n"
    ]);
    product_page_styles_templateObject10 = function() {
        return data;
    };
    return data;
}
function product_page_styles_templateObject11() {
    const data = product_page_styles_taggedTemplateLiteral([
        "\n  display: none;\n  width: 100%;\n  align-items: center;\n  justify-content: center;\n  padding-right: 32px;\n  div {\n    max-width: 300px;\n    img {\n      width: 100%;\n      height: auto;\n      object-fit: contain;\n    }\n  }\n  @media screen and (max-width: ",
        "px) {\n    display: flex;\n  }\n"
    ]);
    product_page_styles_templateObject11 = function() {
        return data;
    };
    return data;
}
function product_page_styles_templateObject12() {
    const data = product_page_styles_taggedTemplateLiteral([
        "\n  max-width: 560px;\n"
    ]);
    product_page_styles_templateObject12 = function() {
        return data;
    };
    return data;
}


const Background = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-ae0dc992-0"
})(product_page_styles_templateObject(), lib_styles_src/* theme.palette.white.main */.rS.palette.white.main);
const ProducSliderContainer = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-ae0dc992-1"
})(product_page_styles_templateObject1(), lib_styles_src/* gridTheme.container.maxWidth.sm */.k.container.maxWidth.sm);
const ProducSliderWrapper = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-ae0dc992-2"
})(product_page_styles_templateObject2(), lib_styles_src/* gridTheme.container.maxWidth.sm */.k.container.maxWidth.sm);
const TextBlockWrapper = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-ae0dc992-3"
})(product_page_styles_templateObject3(), lib_styles_src/* gridTheme.container.minWidth.md */.k.container.minWidth.md, lib_styles_src/* gridTheme.container.maxWidth.md */.k.container.maxWidth.md, lib_styles_src/* gridTheme.container.minWidth.lg */.k.container.minWidth.lg, lib_styles_src/* gridTheme.container.maxWidth.lg */.k.container.maxWidth.lg, lib_styles_src/* gridTheme.container.minWidth.xl */.k.container.minWidth.xl, lib_styles_src/* gridTheme.container.maxWidth.sm */.k.container.maxWidth.sm);
const SectionContainer = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-ae0dc992-4"
})(product_page_styles_templateObject4(), lib_styles_src/* gridTheme.container.maxWidth.sm */.k.container.maxWidth.sm, lib_styles_src/* gridTheme.container.minWidth.md */.k.container.minWidth.md, lib_styles_src/* gridTheme.container.maxWidth.md */.k.container.maxWidth.md, lib_styles_src/* gridTheme.container.minWidth.lg */.k.container.minWidth.lg, lib_styles_src/* gridTheme.container.maxWidth.lg */.k.container.maxWidth.lg, lib_styles_src/* gridTheme.container.minWidth.xl */.k.container.minWidth.xl, lib_styles_src/* gridTheme.container.maxWidth.sm */.k.container.maxWidth.sm);
const BlockImageContainer = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-ae0dc992-5"
})(product_page_styles_templateObject5());
const styles_ButtonContainer = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-ae0dc992-6"
})(product_page_styles_templateObject6(), lib_styles_src/* gridTheme.container.maxWidth.md */.k.container.maxWidth.md);
const SelectionContainer = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-ae0dc992-7"
})(product_page_styles_templateObject7(), lib_styles_src/* theme.palette.gray.10 */.rS.palette.gray[10], lib_styles_src/* theme.palette.gray.10 */.rS.palette.gray[10], lib_styles_src/* gridTheme.container.maxWidth.md */.k.container.maxWidth.md, lib_styles_src/* gridTheme.container.maxWidth.sm */.k.container.maxWidth.sm);
const EnvironmentContainer = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-ae0dc992-8"
})(product_page_styles_templateObject8(), lib_styles_src/* gridTheme.container.maxWidth.md */.k.container.maxWidth.md);
const ActiveEvironmentHeader = styled_components_browser_cjs["default"].p.withConfig({
    componentId: "sc-ae0dc992-9"
})(product_page_styles_templateObject9(), lib_styles_src/* theme.palette.blue.main */.rS.palette.blue.main, lib_styles_src/* gridTheme.container.maxWidth.md */.k.container.maxWidth.md);
const EnvironmentImageContainer = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-ae0dc992-10"
})(product_page_styles_templateObject10(), lib_styles_src/* gridTheme.container.maxWidth.md */.k.container.maxWidth.md);
const EnvironmentImageContainerMobile = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-ae0dc992-11"
})(product_page_styles_templateObject11(), lib_styles_src/* gridTheme.container.maxWidth.md */.k.container.maxWidth.md);
const ActiveEnvironmentContent = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-ae0dc992-12"
})(product_page_styles_templateObject12());

// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-lib-dato-virtual-5a00219d6f/1/packages/lib-dato/src/index.ts + 25 modules
var lib_dato_src = __webpack_require__(39452);
;// CONCATENATED MODULE: ./src/features/products/components/product-page/product-page-content.tsx
/* eslint-disable @next/next/no-img-element */ function product_page_content_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function product_page_content_templateObject() {
    const data = product_page_content_taggedTemplateLiteral([
        "\n  margin-top: 48px;\n  margin-bottom: 48px;\n"
    ]);
    product_page_content_templateObject = function() {
        return data;
    };
    return data;
}

















const ProductSliderSectionWrapper = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-3333816a-0"
})(product_page_content_templateObject());
const ProductPageContent = (param)=>{
    let { additionalProducts , videoData , product , placeholderDetails , defaultVariant , rental  } = param;
    const { data: environmentData  } = lib_dato_src/* datoQueries.useGetEnvironmentalInformation */.t.useGetEnvironmentalInformation();
    const { algoliaInit , sendViewInsights  } = (0,lib_algolia_src/* useAlgoliaInsights */.HX)();
    var _sku;
    // FIXME: SKU should be required on the variant on the backend
    const [activeVariantSKU, setActiveVariantSKU] = (0,react.useState)((_sku = defaultVariant.sku) !== null && _sku !== void 0 ? _sku : "");
    (0,react.useEffect)(()=>{
        var _sku;
        setActiveVariantSKU((_sku = defaultVariant.sku) !== null && _sku !== void 0 ? _sku : "");
    }, [
        defaultVariant.sku
    ]);
    const activeVariant = (0,react.useMemo)(()=>{
        return product.variants.find((v)=>v.sku === activeVariantSKU);
    }, [
        activeVariantSKU,
        product.variants
    ]);
    (0,react.useEffect)(()=>{
        var _sku;
        setActiveVariantSKU((_sku = defaultVariant.sku) !== null && _sku !== void 0 ? _sku : "");
    }, [
        defaultVariant.sku
    ]);
    (0,react.useEffect)(()=>{
        sendViewInsights({
            eventName: "View Product Detail",
            objectIDs: [
                product.id.toString()
            ]
        });
    }, [
        algoliaInit,
        product.id,
        sendViewInsights
    ]);
    const specs = (0,react.useMemo)(()=>{
        if (!activeVariant) return [];
        return prepareProductVariantSpecs(activeVariant);
    }, [
        activeVariant
    ]);
    const tabCollection = (0,react.useMemo)(()=>{
        const environmentalAttributes = product.attributes["environmentalInfoType"];
        const tabs = [];
        if (specs.length) {
            tabs.push({
                icon: lib_icons_src.DrillIcons,
                label: "T\xe6knilegar uppl\xfdsingar",
                highlightColor: lib_styles_src/* theme.palette.blue.main */.rS.palette.blue.main,
                content: /*#__PURE__*/ (0,jsx_runtime.jsx)(component_card_content_tabs_src/* KeyValueFields */.U, {
                    collection: specs
                })
            });
        }
        if (environmentalAttributes.length) {
            tabs.push({
                icon: lib_icons_src.PlanetIcons,
                label: "Umhverfisvottun \xe1 v\xf6ru",
                highlightColor: lib_styles_src/* theme.palette.green.main */.rS.palette.green.main,
                content: /*#__PURE__*/ (0,jsx_runtime.jsx)(EnvironmentalInfo, {
                    additionalInformation: environmentData,
                    environmentalInformation: environmentalAttributes
                })
            });
        }
        if (product.resources.length) {
            tabs.push({
                icon: lib_icons_src.PdfIcons,
                label: "Fylgiskj\xf6l",
                highlightColor: lib_styles_src/* theme.palette.blue.main */.rS.palette.blue.main,
                content: /*#__PURE__*/ (0,jsx_runtime.jsx)(component_card_content_tabs_src/* KeyValueFields */.U, {
                    collection: product.resources
                })
            });
        }
        return tabs.length ? tabs : null;
    }, [
        environmentData,
        product.attributes,
        product.resources,
        specs
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(lib_styles_src/* MotionWrapper */.Lb, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductImageAndDetail, {
                activeVariant: activeVariant,
                brand: placeholderDetails === null || placeholderDetails === void 0 ? void 0 : placeholderDetails.brand,
                product: product,
                rental: rental,
                setActiveVariantSKU: setActiveVariantSKU,
                tags: placeholderDetails === null || placeholderDetails === void 0 ? void 0 : placeholderDetails.tags
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(component_page_container_src/* PageContainer */._, {
                backgroundColor: lib_styles_src/* theme.palette.gray.5 */.rS.palette.gray[5],
                flexDirection: "column",
                justifyContent: "center",
                offsetNav: false,
                children: [
                    tabCollection ? /*#__PURE__*/ (0,jsx_runtime.jsx)(TabsSection, {
                        tabCollection: tabCollection
                    }) : null,
                    videoData ? /*#__PURE__*/ (0,jsx_runtime.jsx)(VideoSection, {
                        videoHeading: videoData.videoHeading,
                        videoSlide: videoData.videoSlide
                    }) : null
                ]
            }),
            additionalProducts ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductSliderSectionWrapper, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(component_product_slider_section_src/* ProductSliderSection */.Z, {
                    collection: additionalProducts.productSliderSectionCollection,
                    heading: additionalProducts.productSliderSectionHeading,
                    paragraph: additionalProducts.productSliderSectionParagraph
                })
            }) : null
        ]
    });
};
var ref;
const handleItemToString = (option)=>{
    return (ref = option === null || option === void 0 ? void 0 : option.label) !== null && ref !== void 0 ? ref : "";
};
function EnvironmentalInfo(param) {
    let { environmentalInformation , additionalInformation  } = param;
    var ref, ref1, ref2, ref3, ref4;
    var ref5;
    const [active, setActive] = (0,react.useState)((ref5 = (ref = environmentalInformation[0]) === null || ref === void 0 ? void 0 : ref["is-IS"]) !== null && ref5 !== void 0 ? ref5 : "");
    var ref6;
    const activeDescription = (ref6 = (ref2 = additionalInformation === null || additionalInformation === void 0 ? void 0 : (ref1 = additionalInformation.allEnvironmentalInformations) === null || ref1 === void 0 ? void 0 : ref1.find((item)=>item.pimKey === active)) === null || ref2 === void 0 ? void 0 : ref2.description) !== null && ref6 !== void 0 ? ref6 : "";
    const activeLogo = (ref4 = additionalInformation === null || additionalInformation === void 0 ? void 0 : (ref3 = additionalInformation.allEnvironmentalInformations) === null || ref3 === void 0 ? void 0 : ref3.find((item)=>item.pimKey === active)) === null || ref4 === void 0 ? void 0 : ref4.logo;
    let imageUrl = "";
    if (activeLogo && activeLogo.responsiveImage) {
        imageUrl = activeLogo.responsiveImage.src;
    } else {
        var ref7;
        imageUrl = (ref7 = activeLogo === null || activeLogo === void 0 ? void 0 : activeLogo.url) !== null && ref7 !== void 0 ? ref7 : "";
    }
    const handleChange = (0,react.useCallback)((value)=>{
        if (!value || !value.selectedItem) {
            return;
        }
        const newItem = value.selectedItem;
        setActive(newItem.value);
    }, []);
    const availableItems = (0,react.useMemo)(()=>{
        return environmentalInformation.map((item, index)=>{
            return {
                label: item["is-IS"],
                value: item["is-IS"],
                id: index
            };
        });
    }, [
        environmentalInformation
    ]);
    const selectedItem = (0,react.useMemo)(()=>{
        return availableItems.find((item)=>item.value === active);
    }, [
        active,
        availableItems
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(EnvironmentContainer, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(SelectionContainer, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(component_typography_src/* EyebrowMedium */.Bz, {
                        children: "Merki"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(component_select_src/* Select */.P, {
                        align: "left",
                        fit: true,
                        handleSelectedItemChange: handleChange,
                        hideDefaultPlaceholder: true,
                        hideValue: true,
                        items: availableItems,
                        itemToString: handleItemToString,
                        placeholder: selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.value,
                        selectedItem: selectedItem,
                        textColor: lib_styles_src/* theme.palette.blue.dark */.rS.palette.blue.dark
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_ButtonContainer, {
                children: environmentalInformation.map((info)=>{
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(EnvironmentButton, {
                            active: active === info["is-IS"],
                            environmentalInformation: info,
                            setActive: setActive
                        })
                    }, info["is-IS"]);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(EnvironmentImageContainerMobile, {
                children: activeLogo != undefined && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        alt: active,
                        src: imageUrl
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ActiveEnvironmentContent, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ActiveEvironmentHeader, {
                        children: active
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(component_typography_src/* PSmall */.zK, {
                        textColor: "black",
                        children: activeDescription
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(EnvironmentImageContainer, {
                children: activeLogo != undefined && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        alt: active,
                        src: imageUrl
                    })
                })
            })
        ]
    });
}
function EnvironmentButton(param) {
    let { environmentalInformation , active , setActive  } = param;
    const handleSetActive = (0,react.useCallback)(()=>{
        setActive(environmentalInformation["is-IS"]);
    }, [
        environmentalInformation,
        setActive
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(component_buttons_src/* Button */.zx, {
        buttonColor: active ? "blueButton" : "whiteButton",
        icon: lib_icons_src.EyeOpenIcons,
        label: environmentalInformation["is-IS"],
        onClick: handleSetActive
    });
}

;// CONCATENATED MODULE: ./src/features/products/components/product-page/index.ts





;// CONCATENATED MODULE: ./src/features/products/components/index.ts


;// CONCATENATED MODULE: ./src/features/products/index.ts



;// CONCATENATED MODULE: ./src/features/beta-banner/components/styles.ts
function components_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function components_styles_templateObject() {
    const data = components_styles_taggedTemplateLiteral([
        "\n  position: relative;\n  z-index: 500;\n  top: 0;\n  width: 100%;\n  background-color: ",
        ";\n"
    ]);
    components_styles_templateObject = function() {
        return data;
    };
    return data;
}
function components_styles_templateObject1() {
    const data = components_styles_taggedTemplateLiteral([
        "\n  position: relative;\n  display: flex;\n  width: 100%;\n  min-height: 64px;\n  box-sizing: border-box;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 8px;\n  padding-right: 40px;\n  padding-left: 10px;\n  background: ",
        ";\n\n  p {\n    line-height: 24px;\n    text-align: center;\n  }\n  @media screen and (max-width: 1079px) {\n    padding-block: 16px;\n    padding-inline: 64px;\n  }\n"
    ]);
    components_styles_templateObject1 = function() {
        return data;
    };
    return data;
}
function components_styles_templateObject2() {
    const data = components_styles_taggedTemplateLiteral([
        "\n  text-decoration: underline;\n  &:focus {\n    border-bottom: 1px solid ",
        ";\n  }\n"
    ]);
    components_styles_templateObject2 = function() {
        return data;
    };
    return data;
}
function components_styles_templateObject3() {
    const data = components_styles_taggedTemplateLiteral([
        "\n  position: absolute;\n  top: 8px;\n  right: 8px;\n  @media screen and (max-width: ",
        "px) {\n    top: 16px;\n  }\n"
    ]);
    components_styles_templateObject3 = function() {
        return data;
    };
    return data;
}


const styles_Wrapper = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-3e31a819-0"
})(components_styles_templateObject(), lib_styles_src/* theme.palette.blue.dark */.rS.palette.blue.dark);
const Banner = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-3e31a819-1"
})(components_styles_templateObject1(), lib_styles_src/* theme.palette.yellow.main */.rS.palette.yellow.main);
const FormLink = styled_components_browser_cjs["default"].a.withConfig({
    componentId: "sc-3e31a819-2"
})(components_styles_templateObject2(), lib_styles_src/* theme.palette.gray.60 */.rS.palette.gray[60]);
const BannerCloseWrapper = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-3e31a819-3"
})(components_styles_templateObject3(), lib_styles_src/* gridTheme.container.maxWidth.s */.k.container.maxWidth.s);

;// CONCATENATED MODULE: ./src/features/beta-banner/components/beta-banner.tsx








const BetaBanner = ()=>{
    const { data: datoText  } = lib_dato_src/* datoQueries.useGetTextOnPage */.t.useGetTextOnPage();
    const [showBanner, setShowBanner] = (0,react.useState)(true);
    (0,react.useEffect)(()=>{
        if (true) {
            const showGlobalBanner = window.sessionStorage.getItem("showGlobalBanner");
            if (showGlobalBanner === "false") {
                setShowBanner(false);
            }
        }
    }, []);
    const handleCloseBanner = (0,react.useCallback)(()=>{
        window.sessionStorage.setItem("showGlobalBanner", "false");
        setShowBanner(false);
    }, []);
    if (showBanner === false || datoText == null || datoText.globalBannerText == null || datoText.globalBannerText === "") {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_Wrapper, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Banner, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(component_typography_src/* PMedium */.aW, {
                    textAlign: "center",
                    textColor: lib_styles_src/* theme.palette.blue.dark */.rS.palette.blue.dark,
                    children: datoText.globalBannerText
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(BannerCloseWrapper, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(component_buttons_src/* IconButton */.hU, {
                        ariaLabel: "loka tilkynningu",
                        buttonColor: "yellowButton",
                        icon: lib_icons_src.CancelLargeIcons,
                        small: true,
                        type: "button",
                        onClick: handleCloseBanner
                    })
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/features/beta-banner/components/index.ts


;// CONCATENATED MODULE: ./src/features/beta-banner/index.ts


;// CONCATENATED MODULE: ./src/features/index.ts







/***/ }),

/***/ 18240:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BW": function() { return /* binding */ useSetShowQuickSearchResultsValue; },
/* harmony export */   "Nq": function() { return /* binding */ useSearchBarHasFocusStore; },
/* harmony export */   "Wp": function() { return /* binding */ useSearchValue; },
/* harmony export */   "Wr": function() { return /* binding */ useShowQuickSearchResultsValue; },
/* harmony export */   "dv": function() { return /* binding */ useSetSearchBarHasFocusStore; },
/* harmony export */   "hp": function() { return /* binding */ useSetSearchValue; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91987);
/* harmony import */ var _byko_lib_recoil__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27105);


const key = (value)=>"byko-search".concat(value);
const searchStore = (0,_byko_lib_recoil__WEBPACK_IMPORTED_MODULE_1__/* .atom */ .cn)({
    key: key("value"),
    default: ""
});
const showQuickSearchResultsStore = (0,_byko_lib_recoil__WEBPACK_IMPORTED_MODULE_1__/* .atom */ .cn)({
    key: "showQuickSearchResults",
    default: false
});
const searchBarHasFocusStore = (0,_byko_lib_recoil__WEBPACK_IMPORTED_MODULE_1__/* .atom */ .cn)({
    key: "searchBarHasFocus",
    default: false
});
const useShowQuickSearchResultsValue = ()=>(0,_byko_lib_recoil__WEBPACK_IMPORTED_MODULE_1__/* .useRecoilValue */ .sJ)(showQuickSearchResultsStore);
const useSearchBarHasFocusStore = ()=>(0,_byko_lib_recoil__WEBPACK_IMPORTED_MODULE_1__/* .useRecoilValue */ .sJ)(searchBarHasFocusStore);
const useSearchValue = ()=>(0,_byko_lib_recoil__WEBPACK_IMPORTED_MODULE_1__/* .useRecoilValue */ .sJ)(searchStore);
const useSetShowQuickSearchResultsValue = ()=>{
    const setValue = (0,_byko_lib_recoil__WEBPACK_IMPORTED_MODULE_1__/* .useSetRecoilState */ .Zl)(showQuickSearchResultsStore);
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)((value)=>{
        setValue(value);
    }, [
        setValue
    ]);
};
const useSetSearchBarHasFocusStore = ()=>{
    const setValue = (0,_byko_lib_recoil__WEBPACK_IMPORTED_MODULE_1__/* .useSetRecoilState */ .Zl)(searchBarHasFocusStore);
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)((value)=>{
        setValue(value);
    }, [
        setValue
    ]);
};
const useSetSearchValue = ()=>{
    const setValue = (0,_byko_lib_recoil__WEBPACK_IMPORTED_MODULE_1__/* .useSetRecoilState */ .Zl)(searchStore);
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)((value)=>{
        setValue(value);
    }, [
        setValue
    ]);
};


/***/ }),

/***/ 85101:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Dk": function() { return /* binding */ fetchAlgoliaProducts; },
/* harmony export */   "Ke": function() { return /* binding */ compileActiveFilters; },
/* harmony export */   "NV": function() { return /* binding */ useAlgoliaContentQuery; },
/* harmony export */   "Vp": function() { return /* binding */ compileAlgoliaProductFilters; },
/* harmony export */   "i9": function() { return /* binding */ sortFacetOptions; },
/* harmony export */   "v4": function() { return /* binding */ compileFacets; },
/* harmony export */   "yy": function() { return /* binding */ useAlgoliaMultiQuery; },
/* harmony export */   "zC": function() { return /* binding */ useAlgoliaProductQuery; }
/* harmony export */ });
/* unused harmony exports searchClient, productSearchClient, contentSearchClient, productSortOptionsMap, algoliaMultiQueryFetcher, storage, algoliaProductsQueryFetcher, fetchAlgoliaContent, algoliaContentQueryFetcher */
/* harmony import */ var algoliasearch_helper__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(66667);
/* harmony import */ var algoliasearch_helper__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(algoliasearch_helper__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var algoliasearch__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(22873);
/* harmony import */ var algoliasearch__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(algoliasearch__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(48826);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(35735);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react_query__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85166);
/* harmony import */ var _byko_lib_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(65582);
/* harmony import */ var _conf__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(56170);
/* eslint-disable
  react/jsx-sort-props,
  react-perf/jsx-no-new-function-as-prop,
  react-perf/jsx-no-new-array-as-prop,
  react/jsx-no-bind,
  no-empty,
  @typescript-eslint/ban-ts-comment */ 






const searchClient = algoliasearch__WEBPACK_IMPORTED_MODULE_5___default()(_conf__WEBPACK_IMPORTED_MODULE_4__/* .APP_ID */ .AF, _conf__WEBPACK_IMPORTED_MODULE_4__/* .API_KEY */ .$h);
const productSearchClient = algoliasearch_helper__WEBPACK_IMPORTED_MODULE_0___default()(searchClient, _conf__WEBPACK_IMPORTED_MODULE_4__/* .SEARCH_INDEXES.products */ .h6.products);
const contentSearchClient = algoliasearch_helper__WEBPACK_IMPORTED_MODULE_0___default()(searchClient, _conf__WEBPACK_IMPORTED_MODULE_4__/* .SEARCH_INDEXES.content */ .h6.content);
const productSortOptionsMap = (0,lodash__WEBPACK_IMPORTED_MODULE_1__.fromPairs)(_conf__WEBPACK_IMPORTED_MODULE_4__/* .PRODUCT_SORT_OPTIONS.map */ .rs.map((o)=>[
        o.value,
        o
    ]));
function algoliaMultiQueryFetcher(query) {
    return searchClient.multipleQueries([
        {
            indexName: "".concat(_conf__WEBPACK_IMPORTED_MODULE_4__/* .SEARCH_INDEXES.products */ .h6.products, "_popular"),
            query,
            params: {
                hitsPerPage: 5,
                facets: [
                    _conf__WEBPACK_IMPORTED_MODULE_4__/* .PRICE_PATH */ .OX,
                    "categories",
                    "attributes.*"
                ],
                facetFilters: [
                    _conf__WEBPACK_IMPORTED_MODULE_4__/* .PRICE_PATH */ .OX,
                    "categories",
                    "attributes.*"
                ],
                maxFacetHits: 100,
                facetingAfterDistinct: true
            }
        },
        {
            indexName: _conf__WEBPACK_IMPORTED_MODULE_4__/* .SEARCH_INDEXES.content */ .h6.content,
            query,
            params: {
                facets: [
                    _conf__WEBPACK_IMPORTED_MODULE_4__/* .PRICE_PATH */ .OX,
                    "categories",
                    "attributes.*"
                ],
                facetFilters: [
                    _conf__WEBPACK_IMPORTED_MODULE_4__/* .PRICE_PATH */ .OX,
                    "categories",
                    "attributes.*"
                ],
                maxFacetHits: 10,
                facetingAfterDistinct: true
            }
        },
        {
            indexName: _conf__WEBPACK_IMPORTED_MODULE_4__/* .SEARCH_INDEXES.employees */ .h6.employees,
            query,
            params: {
                facets: [
                    "attributes.*"
                ],
                facetFilters: [
                    "attributes.*"
                ],
                maxFacetHits: 100,
                facetingAfterDistinct: true
            }
        }
    ], {
        strategy: "none"
    });
}
function useAlgoliaMultiQuery(props) {
    return (0,react_query__WEBPACK_IMPORTED_MODULE_2__.useQuery)([
        props.query,
        "algolia"
    ], ()=>algoliaMultiQueryFetcher(props.query || ""), {
        enabled: !!props.query,
        keepPreviousData: true,
        refetchOnWindowFocus: false
    });
}
// TODO: Create simple polymorghic localStorage/memory cache in utils
const storage = typeof sessionStorage == "undefined" ? {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    obj: {},
    get (key) {
        var _key;
        return (_key = this.obj[key]) !== null && _key !== void 0 ? _key : null;
    },
    set (key, data) {
        this.obj[key] = data;
    }
} : {
    get: (key)=>{
        try {
            var ref;
            return JSON.parse((ref = window.sessionStorage.getItem(key)) !== null && ref !== void 0 ? ref : "");
        } catch (e) {
            return null;
        }
    },
    set: (key, data)=>{
        sessionStorage.setItem(key, JSON.stringify(data));
    }
};
async function getAvailableFacetKeys(indexName) {
    var ref;
    let availableFacets = storage.get("availableFacets");
    const now = new Date();
    if (!(availableFacets === null || availableFacets === void 0 ? void 0 : (ref = availableFacets.keys) === null || ref === void 0 ? void 0 : ref.length) || now > new Date(availableFacets === null || availableFacets === void 0 ? void 0 : availableFacets.exp)) {
        var ref1;
        const { results  } = await searchClient.search([
            {
                indexName,
                params: {
                    hitsPerPage: 1,
                    analytics: false,
                    analyticsTags: [],
                    facets: [
                        _conf__WEBPACK_IMPORTED_MODULE_4__/* .PRICE_PATH */ .OX,
                        "categories",
                        "attributes.*"
                    ],
                    clickAnalytics: true
                }
            }
        ]);
        const facets = results === null || results === void 0 ? void 0 : (ref1 = results[0]) === null || ref1 === void 0 ? void 0 : ref1.facets;
        availableFacets = {
            keys: facets && Object.keys(facets),
            exp: (0,date_fns__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(now, 60)
        };
        storage.set("availableFacets", availableFacets);
    }
    return availableFacets.keys;
}
async function fetchAlgoliaProducts(param) {
    let { productIds , categoryId , sortBy , query , page =1 , pageSize =_conf__WEBPACK_IMPORTED_MODULE_4__/* .DEFAULT_PAGE_SIZE */ .L8 , filters  } = param;
    const indexName = "".concat(_conf__WEBPACK_IMPORTED_MODULE_4__/* .SEARCH_INDEXES.products */ .h6.products, "_").concat(sortBy || "popular");
    const strFilters = [];
    if (categoryId) {
        strFilters.push("categories:".concat(categoryId));
    }
    if (productIds && productIds.length > 0) {
        strFilters.push("objectID:".concat(productIds.join(" OR objectID:")));
    }
    var ref;
    // Do the actual search:
    const params = {
        query,
        index: indexName,
        disjunctiveFacets: (ref = await getAvailableFacetKeys(indexName)) !== null && ref !== void 0 ? ref : [],
        ...filters,
        filters: strFilters.join(" AND "),
        hitsPerPage: pageSize,
        page: page - 1,
        clickAnalytics: true
    };
    const res = await productSearchClient.searchOnce(params);
    const result = {
        ...res.content
    };
    // @ts-ignore
    delete result._state;
    // @ts-ignore
    delete result._rawResults;
    return result;
}
function algoliaProductsQueryFetcher(context) {
    return fetchAlgoliaProducts(context.queryKey[2]);
}
function useAlgoliaProductQuery(props, initialData) {
    return (0,react_query__WEBPACK_IMPORTED_MODULE_2__.useQuery)([
        "algolia",
        _conf__WEBPACK_IMPORTED_MODULE_4__/* .SEARCH_INDEXES.products */ .h6.products,
        props
    ], algoliaProductsQueryFetcher, {
        initialData,
        enabled: !!props.query || !!props.categoryId,
        keepPreviousData: true,
        refetchOnWindowFocus: false
    });
}
async function fetchAlgoliaContent(param) {
    let { //
    query , page =1 , pageSize =_conf__WEBPACK_IMPORTED_MODULE_4__/* .DEFAULT_PAGE_SIZE */ .L8  } = param;
    const params = {
        query,
        index: _conf__WEBPACK_IMPORTED_MODULE_4__/* .SEARCH_INDEXES.content */ .h6.content,
        hitsPerPage: pageSize,
        page: page - 1,
        clickAnalytics: true
    };
    const res = await contentSearchClient.searchOnce(params);
    const result = {
        ...res.content
    };
    // @ts-ignore
    delete result._state;
    // @ts-ignore
    delete result._rawResults;
    return result;
}
function algoliaContentQueryFetcher(context) {
    return fetchAlgoliaContent(context.queryKey[2]);
}
function useAlgoliaContentQuery(props) {
    return (0,react_query__WEBPACK_IMPORTED_MODULE_2__.useQuery)([
        "algolia",
        _conf__WEBPACK_IMPORTED_MODULE_4__/* .SEARCH_INDEXES.content */ .h6.content,
        props
    ], algoliaContentQueryFetcher, {
        enabled: !!props.query,
        keepPreviousData: true
    });
}
function compileAlgoliaProductFilters(q) {
    const query = (0,lodash__WEBPACK_IMPORTED_MODULE_1__.omit)(q, [
        "q",
        "slug",
        "sort",
        "page"
    ]);
    // Only use filtering params
    const filteredQuery = (0,lodash__WEBPACK_IMPORTED_MODULE_1__.pickBy)(query, (v, k)=>v && k.startsWith("specs.") || k.startsWith("attributes.") || k === "categories" || k === _conf__WEBPACK_IMPORTED_MODULE_4__/* .PRICE_PATH */ .OX);
    const numericRefinements = (0,lodash__WEBPACK_IMPORTED_MODULE_1__.mapValues)(//
    (0,lodash__WEBPACK_IMPORTED_MODULE_1__.pick)(filteredQuery, _conf__WEBPACK_IMPORTED_MODULE_4__/* .RANGE_FACETS */ .Zi), (v)=>{
        const [minV, maxV] = v.split("...");
        return {
            ">=": minV ? [
                parseInt(minV, 10)
            ] : [],
            "<=": maxV ? [
                parseInt(maxV, 10)
            ] : []
        };
    });
    const cleanQuery = (0,lodash__WEBPACK_IMPORTED_MODULE_1__.mapValues)(filteredQuery, (v)=>{
        return (0,_byko_lib_utils__WEBPACK_IMPORTED_MODULE_3__/* .ensureList */ .fL)(v === null || v === void 0 ? void 0 : v.split(",")).map((item)=>item.replace("_", ","));
    });
    const disjunctiveFacetsRefinements = (0,lodash__WEBPACK_IMPORTED_MODULE_1__.omit)(cleanQuery, _conf__WEBPACK_IMPORTED_MODULE_4__/* .RANGE_FACETS */ .Zi);
    return {
        disjunctiveFacetsRefinements,
        numericRefinements
    };
}
function sortFacetOptions(key, options, facetOrderValues) {
    var ref, ref1;
    if (!facetOrderValues) {
        return options;
    }
    const order = (ref = facetOrderValues[key]) === null || ref === void 0 ? void 0 : ref.order;
    const remainingOrder = (ref1 = facetOrderValues[key]) === null || ref1 === void 0 ? void 0 : ref1.sortRemainingBy;
    const sortOptionsMap = (0,lodash__WEBPACK_IMPORTED_MODULE_1__.fromPairs)(options.map((o)=>[
            o.label,
            o
        ]));
    const orderedOptions = (0,_byko_lib_utils__WEBPACK_IMPORTED_MODULE_3__/* .ensureList */ .fL)(order === null || order === void 0 ? void 0 : order.map((o)=>sortOptionsMap[o]));
    const remainingOptions = options === null || options === void 0 ? void 0 : options.filter((f)=>{
        return !(order === null || order === void 0 ? void 0 : order.includes(f.label));
    });
    if ((remainingOptions === null || remainingOptions === void 0 ? void 0 : remainingOptions.length) && remainingOrder === "alpha") {
        remainingOptions.sort((a, b)=>a.label.localeCompare(b.label));
    } else if ((remainingOptions === null || remainingOptions === void 0 ? void 0 : remainingOptions.length) && remainingOrder === "count") {
        remainingOptions.sort((a, b)=>b.count - a.count);
    }
    return [
        ...orderedOptions,
        ...remainingOptions
    ];
}
function compileFacets(results, allCategories, queryParams, attrNameMap, activeCategorySlug) {
    var ref;
    var ref1;
    const disjunctiveFacets = (0,lodash__WEBPACK_IMPORTED_MODULE_1__.fromPairs)((ref1 = results === null || results === void 0 ? void 0 : (ref = results.disjunctiveFacets) === null || ref === void 0 ? void 0 : ref.map((f)=>[
            f.name,
            f
        ])) !== null && ref1 !== void 0 ? ref1 : []);
    const catFacet = disjunctiveFacets["categories"];
    delete disjunctiveFacets["categories"];
    const categoryMap = (0,lodash__WEBPACK_IMPORTED_MODULE_1__.fromPairs)(allCategories.map((c)=>[
            c.id,
            c
        ]));
    const categories = (0,_byko_lib_utils__WEBPACK_IMPORTED_MODULE_3__/* .ensureList */ .fL)((0,lodash__WEBPACK_IMPORTED_MODULE_1__.toPairs)(catFacet === null || catFacet === void 0 ? void 0 : catFacet.data).map((param)=>{
        let [idStr, count] = param;
        const id = parseInt(idStr, 10);
        const cat = categoryMap[id];
        if (cat && cat.slug !== activeCategorySlug) {
            var ref;
            var ref1;
            return {
                value: id,
                label: cat === null || cat === void 0 ? void 0 : cat.name,
                count,
                active: (ref1 = (ref = queryParams["categories"]) === null || ref === void 0 ? void 0 : ref.includes(idStr)) !== null && ref1 !== void 0 ? ref1 : false,
                parent: cat.parent
            };
        }
        return null;
    }));
    const specs = (0,lodash__WEBPACK_IMPORTED_MODULE_1__.fromPairs)((0,lodash__WEBPACK_IMPORTED_MODULE_1__.toPairs)(disjunctiveFacets).filter((param)=>{
        let [k] = param;
        return k.indexOf("specs.") === 0 || k.indexOf("attributes.") === 0 || k === _conf__WEBPACK_IMPORTED_MODULE_4__/* .PRICE_PATH */ .OX;
    }).map((param)=>{
        let [attr, { data: valueCounts  }] = param;
        const isSpec = attr.indexOf("specs.") === 0;
        var _attr;
        const unit = (_attr = _conf__WEBPACK_IMPORTED_MODULE_4__/* .FACET_UNIT_OVERRIDES */ .PG[attr]) !== null && _attr !== void 0 ? _attr : isSpec ? attr.split("|")[1] : undefined;
        var _attr1;
        const facetLabel = (_attr1 = attrNameMap[attr]) !== null && _attr1 !== void 0 ? _attr1 : attr.replace("specs.", "").replace("attributes.", "").split("|")[0];
        if (_conf__WEBPACK_IMPORTED_MODULE_4__/* .RANGE_FACETS.includes */ .Zi.includes(attr)) {
            const _facet = disjunctiveFacets[attr];
            const stats = _facet === null || _facet === void 0 ? void 0 : _facet.stats;
            const data = _facet === null || _facet === void 0 ? void 0 : _facet.data;
            const val = queryParams[attr];
            const [minValue, maxValue] = ((val === null || val === void 0 ? void 0 : val[0]) || "").split("...");
            return [
                attr,
                {
                    type: "range",
                    label: facetLabel,
                    unit,
                    min: stats === null || stats === void 0 ? void 0 : stats.min,
                    max: stats === null || stats === void 0 ? void 0 : stats.max,
                    minValue: parseInt(minValue || "0", 10) || undefined,
                    maxValue: parseInt(maxValue || "0", 10) || undefined,
                    data
                }
            ];
        }
        const options = (0,lodash__WEBPACK_IMPORTED_MODULE_1__.toPairs)(valueCounts).map((param)=>{
            let [value, count] = param;
            var ref;
            const sanitizedValue = value.replace(",", "_");
            const label = unit ? "".concat(value, " ").concat(unit) : value;
            var ref1;
            return {
                value: sanitizedValue,
                label,
                count,
                active: (ref1 = (ref = queryParams[attr]) === null || ref === void 0 ? void 0 : ref.includes(sanitizedValue)) !== null && ref1 !== void 0 ? ref1 : false
            };
        });
        return [
            attr,
            {
                type: "choice",
                label: facetLabel,
                options
            }
        ];
    }));
    return {
        categories: {
            type: "hierarchical",
            label: "V\xf6ruflokkar",
            options: categories
        },
        ...specs
    };
}
function compileActiveFilters(facets) {
    return (0,lodash__WEBPACK_IMPORTED_MODULE_1__.toPairs)(facets).reduce((acc, param)=>{
        let [attr, facet] = param;
        return [
            ...acc,
            ...facet.type === "choice" || facet.type === "hierarchical" ? facet.options.filter((opt)=>opt.active).map((param)=>{
                let { value , label  } = param;
                return {
                    attr,
                    value,
                    label
                };
            }) : [],
            ...facet.type === "range" && (!!facet.minValue || !!facet.maxValue) ? [
                {
                    attr,
                    value: facet.label,
                    label: facet.label
                }
            ] : []
        ];
    }, []);
}


/***/ }),

/***/ 67077:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Y": function() { return /* binding */ FilterHeader; }
/* harmony export */ });
/* unused harmony export CountContainerMobile */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(61261);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(91987);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(33982);
/* harmony import */ var _byko_component_select__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(388);
/* harmony import */ var _byko_component_typography__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(91371);
/* harmony import */ var _byko_lib_icons__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(45628);
/* harmony import */ var _byko_lib_styles__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(52203);
/* harmony import */ var _conf__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(56170);
/* harmony import */ var _context__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(36430);
/* harmony import */ var _filters_facets_bar__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(83524);
/* harmony import */ var _filters_filter_chip__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(82571);
/* harmony import */ var _product_search_results__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(94157);
/* harmony import */ var recoil__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(30822);
/* eslint-disable react-perf/jsx-no-new-object-as-prop */ /* eslint-disable react-perf/jsx-no-new-function-as-prop */ /* eslint-disable react/jsx-no-bind */ function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    const data = _taggedTemplateLiteral([
        "\n  position: relative;\n  display: none;\n  @media screen and (min-width: 767px) {\n    display: block;\n  }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _taggedTemplateLiteral([
        "\n  display: flex;\n  width: 100%;\n  align-items: center;\n  justify-content: space-between;\n  grid-area: filter-header;\n  .select-container {\n    width: 328px;\n    & > div {\n      width: 332px;\n    }\n  }\n  @media screen and (max-width: 1179px) {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n  @media screen and (max-width: 895px) {\n    display: none;\n  }\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = _taggedTemplateLiteral([
        "\n  width: 100%;\n"
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = _taggedTemplateLiteral([
        "\n  position: relative;\n  display: flex;\n  width: 100%;\n  flex-wrap: wrap;\n  justify-content: space-evenly;\n  pointer-events: initial;\n  @media screen and (min-width: 895px) {\n    display: none;\n  }\n"
    ]);
    _templateObject3 = function() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = _taggedTemplateLiteral([
        "\n  z-index: 30;\n  inset: 0;\n  pointer-events: none;\n"
    ]);
    _templateObject4 = function() {
        return data;
    };
    return data;
}
function _templateObject5() {
    const data = _taggedTemplateLiteral([
        "\n  margin-bottom: 32px;\n"
    ]);
    _templateObject5 = function() {
        return data;
    };
    return data;
}
function _templateObject6() {
    const data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: flex-start;\n  margin-bottom: 16px;\n  gap: 8px;\n  grid-area: chip-row;\n  @media screen and (max-width: 895px) {\n    display: none;\n  }\n"
    ]);
    _templateObject6 = function() {
        return data;
    };
    return data;
}
function _templateObject7() {
    const data = _taggedTemplateLiteral([
        "\n  display: flex;\n  width: 100%;\n  border-top: 1px solid ",
        ";\n  border-right: 1px solid ",
        ";\n  border-left: 1px solid ",
        ";\n"
    ]);
    _templateObject7 = function() {
        return data;
    };
    return data;
}
function _templateObject8() {
    const data = _taggedTemplateLiteral([
        "\n  position: relative;\n  z-index: 2;\n  width: 50%;\n  button {\n    outline: 1px solid ",
        ";\n  }\n  @media screen and (max-width: 895px) {\n    button {\n      border-bottom: 1px solid ",
        ";\n      outline: unset;\n    }\n  }\n"
    ]);
    _templateObject8 = function() {
        return data;
    };
    return data;
}
function _templateObject9() {
    const data = _taggedTemplateLiteral([
        "\n  position: relative;\n  display: flex;\n  width: 50%;\n  align-items: center;\n  padding-left: 16px;\n  border: 0;\n  border-radius: 0;\n  border-bottom: 1px solid ",
        ";\n  border-left: 1px solid ",
        ";\n  background-color: ",
        ";\n  color: ",
        " !important;\n  cursor: pointer;\n  font-size: 1rem;\n  font-weight: 800 !important;\n  text-align: left;\n  transition: border-color 0.15s;\n  & > svg {\n    display: block;\n    margin-right: 8px;\n  }\n"
    ]);
    _templateObject9 = function() {
        return data;
    };
    return data;
}
function _templateObject10() {
    const data = _taggedTemplateLiteral([
        "\n  position: absolute;\n  top: calc(50% - 12px);\n  right: 16px;\n  display: flex;\n  width: 24px;\n  height: 24px;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n  margin-right: 16px;\n  background-color: ",
        ";\n  color: ",
        ";\n  font-size: 0.875rem;\n  font-weight: 500;\n  line-height: 1;\n  transition: opacity 0.15s;\n"
    ]);
    _templateObject10 = function() {
        return data;
    };
    return data;
}
function _templateObject11() {
    const data = _taggedTemplateLiteral([
        "\n  position: absolute;\n  top: calc(50% - 12px);\n  right: 16px;\n  display: flex;\n  width: 24px;\n  height: 24px;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n  margin-right: 16px;\n  background-color: ",
        ";\n  transition: opacity 0.15s;\n"
    ]);
    _templateObject11 = function() {
        return data;
    };
    return data;
}
function _templateObject12() {
    const data = _taggedTemplateLiteral([
        "\n  position: absolute;\n  z-index: 5;\n  top: 82px;\n  left: 0;\n  width: 100%;\n  padding: 2px;\n  border: none;\n  background-color: ",
        ";\n  opacity: 0;\n  pointer-events: none;\n  transition: opacity 0.15s;\n\n  &.isOpen {\n    opacity: 1;\n    pointer-events: unset;\n  }\n"
    ]);
    _templateObject12 = function() {
        return data;
    };
    return data;
}
function _templateObject13() {
    const data = _taggedTemplateLiteral([
        ""
    ]);
    _templateObject13 = function() {
        return data;
    };
    return data;
}













const ShowInDesktop = styled_components__WEBPACK_IMPORTED_MODULE_12__["default"].div.withConfig({
    componentId: "sc-df82ed36-0"
})(_templateObject());
const SubRow = styled_components__WEBPACK_IMPORTED_MODULE_12__["default"].div.withConfig({
    componentId: "sc-df82ed36-1"
})(_templateObject1());
const CountContainerMobile = styled_components__WEBPACK_IMPORTED_MODULE_12__["default"].div.withConfig({
    componentId: "sc-df82ed36-2"
})(_templateObject2());
const ShowInMobile = styled_components__WEBPACK_IMPORTED_MODULE_12__["default"].div.withConfig({
    componentId: "sc-df82ed36-3"
})(_templateObject3());
const OuterWrapper = styled_components__WEBPACK_IMPORTED_MODULE_12__["default"].div.withConfig({
    componentId: "sc-df82ed36-4"
})(_templateObject4());
const MainWrapper = styled_components__WEBPACK_IMPORTED_MODULE_12__["default"].div.withConfig({
    componentId: "sc-df82ed36-5"
})(_templateObject5());
const FilterChips = styled_components__WEBPACK_IMPORTED_MODULE_12__["default"].div.withConfig({
    componentId: "sc-df82ed36-6"
})(_templateObject6());
const FilterActionsBar = styled_components__WEBPACK_IMPORTED_MODULE_12__["default"].div.withConfig({
    componentId: "sc-df82ed36-7"
})(_templateObject7(), _byko_lib_styles__WEBPACK_IMPORTED_MODULE_5__/* .theme.palette.gray[10] */ .rS.palette.gray[10], _byko_lib_styles__WEBPACK_IMPORTED_MODULE_5__/* .theme.palette.gray[10] */ .rS.palette.gray[10], _byko_lib_styles__WEBPACK_IMPORTED_MODULE_5__/* .theme.palette.gray[10] */ .rS.palette.gray[10]);
const SortContainer = styled_components__WEBPACK_IMPORTED_MODULE_12__["default"].div.withConfig({
    componentId: "sc-df82ed36-8"
})(_templateObject8(), _byko_lib_styles__WEBPACK_IMPORTED_MODULE_5__/* .theme.palette.gray[10] */ .rS.palette.gray[10], _byko_lib_styles__WEBPACK_IMPORTED_MODULE_5__/* .theme.palette.gray[10] */ .rS.palette.gray[10]);
const FilterBtn = styled_components__WEBPACK_IMPORTED_MODULE_12__["default"].button.withConfig({
    componentId: "sc-df82ed36-9"
})(_templateObject9(), _byko_lib_styles__WEBPACK_IMPORTED_MODULE_5__/* .theme.palette.gray[10] */ .rS.palette.gray[10], _byko_lib_styles__WEBPACK_IMPORTED_MODULE_5__/* .theme.palette.gray[10] */ .rS.palette.gray[10], _byko_lib_styles__WEBPACK_IMPORTED_MODULE_5__/* .theme.palette.white.main */ .rS.palette.white.main, _byko_lib_styles__WEBPACK_IMPORTED_MODULE_5__/* .theme.palette.blue.main */ .rS.palette.blue.main);
const FilterCount = styled_components__WEBPACK_IMPORTED_MODULE_12__["default"].div.withConfig({
    componentId: "sc-df82ed36-10"
})(_templateObject10(), _byko_lib_styles__WEBPACK_IMPORTED_MODULE_5__/* .theme.palette.gray[10] */ .rS.palette.gray[10], _byko_lib_styles__WEBPACK_IMPORTED_MODULE_5__/* .theme.palette.blue.main */ .rS.palette.blue.main);
const FilterBtnClose = styled_components__WEBPACK_IMPORTED_MODULE_12__["default"].div.withConfig({
    componentId: "sc-df82ed36-11"
})(_templateObject11(), _byko_lib_styles__WEBPACK_IMPORTED_MODULE_5__/* .theme.palette.gray[10] */ .rS.palette.gray[10]);
const MobileFilterContainer = styled_components__WEBPACK_IMPORTED_MODULE_12__["default"].div.withConfig({
    componentId: "sc-df82ed36-12"
})(_templateObject12(), _byko_lib_styles__WEBPACK_IMPORTED_MODULE_5__/* .theme.palette.white.main */ .rS.palette.white.main);
const ProductCount = styled_components__WEBPACK_IMPORTED_MODULE_12__["default"].div.withConfig({
    componentId: "sc-df82ed36-13"
})(_templateObject13());
const FilterHeader = ()=>{
    var ref, ref1, ref2;
    const productCount = (0,recoil__WEBPACK_IMPORTED_MODULE_11__/* .useRecoilValue */ .sJ)(_product_search_results__WEBPACK_IMPORTED_MODULE_10__.productHitCountState);
    const { setSorting , activeFilters , queryParams , clearFilter , searchQuery  } = (0,_context__WEBPACK_IMPORTED_MODULE_7__/* .useProductSearch */ .ty)();
    const activeFilterCount = activeFilters === null || activeFilters === void 0 ? void 0 : activeFilters.length;
    const [showMobileFilters, setShowMobileFilters] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const getProductCountText = (count)=>{
        if (!searchQuery) return "".concat(count, " ").concat(count === 1 ? "ni\xf0ursta\xf0a" : "ni\xf0urst\xf6\xf0ur");
        return '"'.concat(searchQuery, '" - ').concat(count, " ").concat(count === 1 ? "ni\xf0ursta\xf0a" : "ni\xf0urst\xf6\xf0ur");
    };
    const handleSortChange = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)((changes)=>{
        var ref;
        if ((ref = changes.selectedItem) === null || ref === void 0 ? void 0 : ref.value) {
            var ref1;
            setSorting((ref1 = changes.selectedItem) === null || ref1 === void 0 ? void 0 : ref1.value);
        }
    }, [
        setSorting
    ]);
    const sortInput = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SortContainer, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_byko_component_select__WEBPACK_IMPORTED_MODULE_2__/* .Select */ .P, {
            handleSelectedItemChange: handleSortChange,
            hideValue: true,
            icon: _byko_lib_icons__WEBPACK_IMPORTED_MODULE_4__.ArrowDownIcons,
            items: _conf__WEBPACK_IMPORTED_MODULE_6__/* .PRODUCT_SORT_OPTIONS */ .rs,
            itemToString: (item)=>{
                return (item === null || item === void 0 ? void 0 : item.label) || "";
            },
            placeholder: (ref1 = _conf__WEBPACK_IMPORTED_MODULE_6__/* .PRODUCT_SORT_OPTIONS_MAP */ .Tt[((ref = queryParams["sort"]) === null || ref === void 0 ? void 0 : ref[0]) || ""]) === null || ref1 === void 0 ? void 0 : ref1.label,
            selectedItem: _conf__WEBPACK_IMPORTED_MODULE_6__/* .PRODUCT_SORT_OPTIONS_MAP */ .Tt[((ref2 = queryParams["sort"]) === null || ref2 === void 0 ? void 0 : ref2[0]) || ""]
        })
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(OuterWrapper, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(MainWrapper, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(ShowInMobile, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CountContainerMobile, {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_byko_component_typography__WEBPACK_IMPORTED_MODULE_3__/* .EyebrowMedium */ .Bz, {
                                    children: getProductCountText(productCount)
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(FilterActionsBar, {
                                children: [
                                    sortInput,
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(FilterBtn, {
                                        style: {
                                            fontWeight: activeFilterCount ? 500 : 400,
                                            color: activeFilterCount ? _byko_lib_styles__WEBPACK_IMPORTED_MODULE_5__/* .theme.palette.blue.main */ .rS.palette.blue.main : _byko_lib_styles__WEBPACK_IMPORTED_MODULE_5__/* .theme.palette.gray[50] */ .rS.palette.gray[50]
                                        },
                                        onClick: ()=>setShowMobileFilters(!showMobileFilters),
                                        children: [
                                            "S\xedur",
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FilterCount, {
                                                style: {
                                                    opacity: activeFilterCount ? "1" : "0"
                                                },
                                                children: activeFilterCount
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FilterBtnClose, {
                                                style: {
                                                    opacity: showMobileFilters ? "1" : "0"
                                                },
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_byko_lib_icons__WEBPACK_IMPORTED_MODULE_4__.CancelSmallIcons, {
                                                    iconColor: _byko_lib_styles__WEBPACK_IMPORTED_MODULE_5__/* .theme.palette.blue.main */ .rS.palette.blue.main,
                                                    size: 12
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(MobileFilterContainer, {
                                className: showMobileFilters ? "isOpen" : "",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_filters_facets_bar__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {})
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FilterChips, {
                children: activeFilters === null || activeFilters === void 0 ? void 0 : activeFilters.map((item)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_filters_filter_chip__WEBPACK_IMPORTED_MODULE_9__/* .FilterChip */ .GH, {
                        onClick: ()=>clearFilter(item),
                        children: item.label
                    }, item.value))
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(SubRow, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ProductCount, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_byko_component_typography__WEBPACK_IMPORTED_MODULE_3__/* .EyebrowLarge */ .Gp, {
                            children: getProductCountText(productCount)
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ShowInDesktop, {
                        children: sortInput
                    })
                ]
            })
        ]
    });
};


/***/ }),

/***/ 87159:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "f": function() { return /* reexport */ FacetAccordionBlock; }
});

// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(61261);
// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(91987);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-lib-icons-virtual-412b14e947/1/packages/lib-icons/src/index.ts + 181 modules
var src = __webpack_require__(45628);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-component-buttons-virtual-1a577fdc8c/1/packages/component-buttons/src/index.ts + 16 modules
var component_buttons_src = __webpack_require__(80620);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-component-typography-virtual-537720fdd1/1/packages/component-typography/src/index.ts + 2 modules
var component_typography_src = __webpack_require__(91371);
// EXTERNAL MODULE: ../../.yarn/__virtual__/styled-components-virtual-29066d9421/0/cache/styled-components-npm-5.3.5-88e3937b59-05a664dfe4.zip/node_modules/styled-components/dist/styled-components.browser.cjs.js
var styled_components_browser_cjs = __webpack_require__(33982);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-lib-styles-virtual-b3f1d479f2/1/packages/lib-styles/src/index.ts + 18 modules
var lib_styles_src = __webpack_require__(52203);
;// CONCATENATED MODULE: ./src/features/search/components/filters/facet-accordion/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    const data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  margin-bottom: 8px;\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _taggedTemplateLiteral([
        "\n  position: absolute;\n  top: 0;\n  right: 80px;\n  display: flex;\n  height: 100%;\n  align-items: center;\n  justify-content: center;\n\n  @media screen and (max-width: 375px) {\n    right: 40px;\n    p {\n      font-size: 14px !important;\n    }\n  }\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = _taggedTemplateLiteral([
        "\n  position: relative;\n  width: 100%;\n  .accordion-button {\n    padding: 0;\n    border: none;\n    p {\n      color: ",
        ";\n      font-size: 16px;\n    }\n    :hover {\n      box-shadow: none;\n    }\n  }\n"
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = _taggedTemplateLiteral([
        "\n  background-color: ",
        ";\n  @media screen and (max-width: 895px) {\n    min-width: unset;\n    padding: 12px 16px;\n    margin-bottom: 16px;\n  }\n"
    ]);
    _templateObject3 = function() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = _taggedTemplateLiteral([
        ""
    ]);
    _templateObject4 = function() {
        return data;
    };
    return data;
}
function _templateObject5() {
    const data = _taggedTemplateLiteral([
        "\n  display: flex;\n  width: 100%;\n  flex-direction: column;\n\n  ",
        " {\n    &:last-of-type {\n      .accordion-button {\n        border-bottom: 1px solid ",
        ";\n      }\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject5 = function() {
        return data;
    };
    return data;
}


const AccordionItemWrapper = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-8f1ace3b-0"
})(_templateObject());
const SecondLabelContainer = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-8f1ace3b-1"
})(_templateObject1());
const AccordionItemContainer = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-8f1ace3b-2"
})(_templateObject2(), lib_styles_src/* theme.palette.blue.main */.rS.palette.blue.main);
const AccordionChildren = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-8f1ace3b-3"
})(_templateObject3(), lib_styles_src/* theme.palette.white.main */.rS.palette.white.main);
const expandedCSS = (0,styled_components_browser_cjs.css)(_templateObject4());
const AccordionWrapper = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-8f1ace3b-4"
})(_templateObject5(), AccordionChildren, lib_styles_src/* theme.palette.gray.10 */.rS.palette.gray[10], (props)=>props.isOpen && expandedCSS);

;// CONCATENATED MODULE: ./src/features/search/components/filters/facet-accordion/facet-accordion-item.tsx





const FacetAccordionItem = (param)=>{
    let { label , secondLabel , children , icon , onClickOpen , underline  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(AccordionItemWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(AccordionItemContainer, {
                underline: underline,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(component_buttons_src/* Button */.zx, {
                        buttonColor: "whiteButton",
                        customClassName: "accordion-button",
                        icon: icon,
                        label: label,
                        small: true,
                        stretch: true,
                        onClick: onClickOpen
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SecondLabelContainer, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(component_typography_src/* PMediumBold */.zo, {
                            lineHeight: "100%",
                            children: secondLabel
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: children
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/features/search/components/filters/facet-accordion/facet-accordion.tsx





const FacetAccordionBlock = (param)=>{
    let { label , children , defaultOpen =false , openIcon =src.ArrowDownIcons , closeIcon =src.ArrowUpIcons , secondLabel , onClose  } = param;
    const [isOpen, setIsOpen] = (0,react.useState)(defaultOpen);
    const handleOpen = (0,react.useCallback)(()=>{
        if (isOpen && onClose) onClose();
        setIsOpen(!isOpen);
    }, [
        isOpen,
        onClose
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(AccordionWrapper, {
        className: "accordion-block",
        defaultOpen: defaultOpen,
        isOpen: isOpen,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FacetAccordionItem, {
            icon: isOpen ? closeIcon : openIcon,
            label: label,
            secondLabel: secondLabel !== null && secondLabel !== void 0 ? secondLabel : "",
            underline: isOpen ? true : false,
            onClickOpen: handleOpen,
            children: isOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)(AccordionChildren, {
                children: children
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/features/search/components/filters/facet-accordion/index.ts



/***/ }),

/***/ 83524:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(61261);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(35735);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(91987);
/* harmony import */ var src_features_search_context__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(36430);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(33982);
/* harmony import */ var _byko_component_buttons__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(80620);
/* harmony import */ var _byko_lib_styles__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(52203);
/* harmony import */ var _facets__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(244);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    const data = _taggedTemplateLiteral([
        "\n  width: 382px;\n  max-width: 100%;\n  padding: 32px;\n  border: 1px solid ",
        ";\n  background-color: ",
        ";\n  @media screen and (max-width: 895px) {\n    width: 100%;\n  }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 40px;\n  gap: 80px;\n  button {\n    p {\n      font-size: 16px;\n    }\n  }\n  @media screen and (max-width: 895px) {\n    margin-bottom: 8px;\n    gap: 16px;\n    button {\n      p {\n        font-size: 14px;\n      }\n    }\n  }\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  .remixicon-icon {\n    margin-right: 12px;\n  }\n"
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = _taggedTemplateLiteral([
        "\n  color: ",
        ";\n  font-size: 1.3rem;\n  font-weight: 500;\n  line-height: 1;\n  @media screen and (max-width: 895px) {\n    font-size: 16px;\n  }\n"
    ]);
    _templateObject3 = function() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = _taggedTemplateLiteral([
        "\n  margin-left: 4px;\n  font-size: 14px;\n"
    ]);
    _templateObject4 = function() {
        return data;
    };
    return data;
}








const Wrapper = styled_components__WEBPACK_IMPORTED_MODULE_7__["default"].div.withConfig({
    componentId: "sc-464f278b-0"
})(_templateObject(), _byko_lib_styles__WEBPACK_IMPORTED_MODULE_5__/* .theme.palette.gray[10] */ .rS.palette.gray[10], _byko_lib_styles__WEBPACK_IMPORTED_MODULE_5__/* .theme.palette.white.main */ .rS.palette.white.main);
const FacetsBarHead = styled_components__WEBPACK_IMPORTED_MODULE_7__["default"].div.withConfig({
    componentId: "sc-464f278b-1"
})(_templateObject1());
const FacetsBarHeadInner = styled_components__WEBPACK_IMPORTED_MODULE_7__["default"].div.withConfig({
    componentId: "sc-464f278b-2"
})(_templateObject2());
const Title = styled_components__WEBPACK_IMPORTED_MODULE_7__["default"].span.withConfig({
    componentId: "sc-464f278b-3"
})(_templateObject3(), _byko_lib_styles__WEBPACK_IMPORTED_MODULE_5__/* .theme.palette.blue.main */ .rS.palette.blue.main);
const TitleCount = styled_components__WEBPACK_IMPORTED_MODULE_7__["default"].span.withConfig({
    componentId: "sc-464f278b-4"
})(_templateObject4());
const FacetsBar = ()=>{
    const { facets , activeFilters , clearAllFilters: clearFilters , facetOrder  } = (0,src_features_search_context__WEBPACK_IMPORTED_MODULE_3__/* .useProductSearch */ .ty)();
    if (!facetOrder) {
        return null; // TODO: loader?
    }
    const sortedFacets = (0,lodash__WEBPACK_IMPORTED_MODULE_1__.sortBy)((0,lodash__WEBPACK_IMPORTED_MODULE_1__.toPairs)(facets), (param)=>{
        let [key, _] = param;
        return facetOrder.indexOf(key);
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Wrapper, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(FacetsBarHead, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FacetsBarHeadInner, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Title, {
                            children: [
                                "S\xedur",
                                !!(activeFilters === null || activeFilters === void 0 ? void 0 : activeFilters.length) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(TitleCount, {
                                    children: [
                                        "(",
                                        activeFilters === null || activeFilters === void 0 ? void 0 : activeFilters.length,
                                        ")"
                                    ]
                                })
                            ]
                        })
                    }),
                    !!(activeFilters === null || activeFilters === void 0 ? void 0 : activeFilters.length) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_byko_component_buttons__WEBPACK_IMPORTED_MODULE_4__/* .Button */ .zx, {
                        buttonColor: "whiteButton",
                        label: "Hreinsa s\xedu",
                        small: true,
                        stretch: true,
                        onClick: clearFilters
                    })
                ]
            }),
            sortedFacets.map((param)=>{
                let [k, facet] = param;
                const FacetComponent = _facets__WEBPACK_IMPORTED_MODULE_6__/* .facetComponentTypeMap */ .F[facet.type];
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FacetComponent, {
                    attr: k,
                    // It's impossible to transform intersection to union:
                    facet: facet
                }, k);
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (FacetsBar);


/***/ }),

/***/ 244:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "F": function() { return /* binding */ facetComponentTypeMap; }
});

// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(61261);
// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(91987);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-component-selectors-virtual-9e0e678d5e/1/packages/component-selectors/src/index.ts + 10 modules
var src = __webpack_require__(60002);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-lib-icons-virtual-412b14e947/1/packages/lib-icons/src/index.ts + 181 modules
var lib_icons_src = __webpack_require__(45628);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-lib-styles-virtual-b3f1d479f2/1/packages/lib-styles/src/index.ts + 18 modules
var lib_styles_src = __webpack_require__(52203);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-lib-algolia-virtual-7767b18cc0/1/packages/lib-algolia/src/index.ts + 7 modules
var lib_algolia_src = __webpack_require__(5283);
// EXTERNAL MODULE: ./src/features/search/components/filters/facet-accordion/index.ts + 3 modules
var facet_accordion = __webpack_require__(87159);
// EXTERNAL MODULE: ../../.yarn/__virtual__/styled-components-virtual-29066d9421/0/cache/styled-components-npm-5.3.5-88e3937b59-05a664dfe4.zip/node_modules/styled-components/dist/styled-components.browser.cjs.js
var styled_components_browser_cjs = __webpack_require__(33982);
// EXTERNAL MODULE: ../../.yarn/cache/styled-tools-npm-1.7.2-97a33384f1-00cc179608.zip/node_modules/styled-tools/dist/es/index.js + 3 modules
var es = __webpack_require__(25711);
;// CONCATENATED MODULE: ./src/features/search/components/filters/facets/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    const data = _taggedTemplateLiteral([
        "\n  padding-left: ",
        ";\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _taggedTemplateLiteral([
        "\n  position: absolute;\n  right: 0;\n  pointer-events: none;\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = _taggedTemplateLiteral([
        "\n  position: relative;\n  display: flex;\n  align-items: center;\n"
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = _taggedTemplateLiteral([
        "\n  position: relative;\n  display: flex;\n  width: 100%;\n  flex-direction: row-reverse;\n  align-items: center;\n  justify-content: flex-end;\n  padding: 8px 0;\n  cursor: pointer;\n  user-select: none;\n\n  @media screen and (max-width: 895px) {\n    margin-bottom: 16px;\n  }\n"
    ]);
    _templateObject3 = function() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = _taggedTemplateLiteral([
        ""
    ]);
    _templateObject4 = function() {
        return data;
    };
    return data;
}
function _templateObject5() {
    const data = _taggedTemplateLiteral([
        "\n  color: ",
        ";\n  font-size: 1rem;\n  line-height: 1.1;\n"
    ]);
    _templateObject5 = function() {
        return data;
    };
    return data;
}
function _templateObject6() {
    const data = _taggedTemplateLiteral([
        "\n  margin-left: 4px;\n  color: ",
        ";\n  font-size: 12px;\n  transition: opacity 0.15s;\n"
    ]);
    _templateObject6 = function() {
        return data;
    };
    return data;
}
function _templateObject7() {
    const data = _taggedTemplateLiteral([
        "\n  display: flex;\n  width: 16px;\n  min-width: 16px;\n  height: 16px;\n  min-height: 16px;\n  align-items: center;\n  justify-content: center;\n  border: 1px solid ",
        ";\n  background-color: transparent;\n  transition: background-color 0.15s, border-color 0.15s;\n"
    ]);
    _templateObject7 = function() {
        return data;
    };
    return data;
}
function _templateObject8() {
    const data = _taggedTemplateLiteral([
        "\n  border-bottom: 1px solid ",
        ";\n  transition: border-color 0.15s;\n"
    ]);
    _templateObject8 = function() {
        return data;
    };
    return data;
}
function _templateObject9() {
    const data = _taggedTemplateLiteral([
        "\n  transform: rotate(-90deg);\n  transition: transform 0.2s ease-in-out;\n"
    ]);
    _templateObject9 = function() {
        return data;
    };
    return data;
}
function _templateObject10() {
    const data = _taggedTemplateLiteral([
        "\n  color: ",
        ";\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 1.1;\n  text-align: left;\n"
    ]);
    _templateObject10 = function() {
        return data;
    };
    return data;
}
function _templateObject11() {
    const data = _taggedTemplateLiteral([
        "\n  display: flex;\n  width: 24px;\n  height: 24px;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n  margin-right: 16px;\n  background-color: ",
        ";\n  color: ",
        ";\n  font-size: 0.875rem;\n  font-weight: 500;\n  line-height: 1;\n  transition: opacity 0.15s;\n"
    ]);
    _templateObject11 = function() {
        return data;
    };
    return data;
}
function _templateObject12() {
    const data = _taggedTemplateLiteral([
        "\n  padding: 8px 16px 24px 16px;\n"
    ]);
    _templateObject12 = function() {
        return data;
    };
    return data;
}



const FacetCheckboxWrapper = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-a0f948f-0"
})(_templateObject(), (0,es/* ifProp */.fq)("padding", "16px", "0px"));
const IconContainer = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-a0f948f-1"
})(_templateObject1());
const Line = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-a0f948f-2"
})(_templateObject2());
const Item = styled_components_browser_cjs["default"].label.withConfig({
    componentId: "sc-a0f948f-3"
})(_templateObject3());
const CheckboxContainer = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-a0f948f-4"
})(_templateObject4());
const Text = styled_components_browser_cjs["default"].span.withConfig({
    componentId: "sc-a0f948f-5"
})(_templateObject5(), lib_styles_src/* theme.palette.blue.main */.rS.palette.blue.main);
const Count = styled_components_browser_cjs["default"].span.withConfig({
    componentId: "sc-a0f948f-6"
})(_templateObject6(), lib_styles_src/* theme.palette.gray.30 */.rS.palette.gray[30]);
const Box = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-a0f948f-7"
})(_templateObject7(), lib_styles_src/* theme.palette.gray.20 */.rS.palette.gray[20]);
const Wrapper = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-a0f948f-8"
})(_templateObject8(), lib_styles_src/* theme.palette.gray.60 */.rS.palette.gray[60]);
const IconWrapper = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-a0f948f-9"
})(_templateObject9());
const Label = styled_components_browser_cjs["default"].span.withConfig({
    componentId: "sc-a0f948f-10"
})(_templateObject10(), lib_styles_src/* theme.palette.blue.main */.rS.palette.blue.main);
const FacetCount = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-a0f948f-11"
})(_templateObject11(), lib_styles_src/* theme.palette.gray.10 */.rS.palette.gray[10], lib_styles_src/* theme.palette.blue.main */.rS.palette.blue.main);
const Content = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-a0f948f-12"
})(_templateObject12());

;// CONCATENATED MODULE: ./src/features/search/components/filters/facets/facet-layout.tsx



const FacetLayout = (param)=>{
    let { label , children , initiallyOpen =false  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Wrapper, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(facet_accordion/* FacetAccordionBlock */.f, {
            defaultOpen: initiallyOpen,
            label: label,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Content, {
                children: children
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/features/search/components/filters/facets/utils.ts
const flattenFacetTreeValues = (facetTreeValues)=>{
    var ref;
    return facetTreeValues ? facetTreeValues.reduce((result, item)=>{
        return [
            ...result,
            item,
            ...flattenFacetTreeValues((ref = item === null || item === void 0 ? void 0 : item.children) !== null && ref !== void 0 ? ref : [])
        ];
    }, []) : [];
};

// EXTERNAL MODULE: ./src/features/search/context.tsx
var context = __webpack_require__(36430);
// EXTERNAL MODULE: ./src/features/search/api.ts
var api = __webpack_require__(85101);
;// CONCATENATED MODULE: ./src/features/search/components/filters/facets/checkbox-facet.tsx
/* eslint-disable react-perf/jsx-no-new-object-as-prop */ 










const FacetCheckboxItem = (param)=>{
    let { count , children , onChange , checked , value  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Item, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text, {
                children: [
                    children,
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Count, {
                        style: {
                            opacity: count ? "1" : "0"
                        },
                        children: [
                            "(",
                            count,
                            ")"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckboxContainer, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* Checkbox */.XZ //
                , {
                    checked: checked !== null && checked !== void 0 ? checked : false,
                    smallBox: true,
                    value: value,
                    onChange: onChange
                })
            })
        ]
    });
};
const FacetCheckbox = (param)=>{
    let { option , onChange , level  } = param;
    const { value , count , active , label , children  } = option;
    if (children === undefined) {
        return null;
    }
    const childActive = flattenFacetTreeValues(children).some((child)=>child.active);
    const shouldBeActive = childActive || active;
    const nextLevel = level + 1;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(FacetCheckboxWrapper, {
        padding: level > 0,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Line, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FacetCheckboxItem //
                    , {
                        checked: shouldBeActive,
                        count: count,
                        value: value,
                        onChange: onChange,
                        children: label
                    }, value),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(IconContainer, {
                        children: (children === null || children === void 0 ? void 0 : children.length) > 0 && (!shouldBeActive ? /*#__PURE__*/ (0,jsx_runtime.jsx)(lib_icons_src.ArrowDownIcons, {
                            iconColor: lib_styles_src/* theme.palette.blue.main */.rS.palette.blue.main,
                            size: 16
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(lib_icons_src.ArrowUpIcons, {
                            iconColor: lib_styles_src/* theme.palette.blue.main */.rS.palette.blue.main,
                            size: 16
                        }))
                    })
                ]
            }),
            !!shouldBeActive && (children === null || children === void 0 ? void 0 : children.map((o)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(FacetCheckbox, {
                    level: nextLevel,
                    option: o,
                    onChange: onChange
                }, o.value)))
        ]
    });
};
const CheckboxFacet = (param)=>{
    let { attr , facet  } = param;
    const { updateChoiceFacet , facetOrderValues  } = (0,context/* useProductSearch */.ty)();
    const { sendFilterClickedEvent  } = (0,lib_algolia_src/* useAlgoliaInsights */.HX)();
    const sortedOptions = (0,api/* sortFacetOptions */.i9)(attr, facet.options, facetOrderValues);
    const onChange = (0,react.useCallback)((e)=>{
        updateChoiceFacet(facet, attr, {
            [e.target.value]: e.target.checked
        });
        if (e.target.checked) {
            sendFilterClickedEvent({
                eventName: "Filter clicked",
                filter: "".concat(attr, ":").concat(e.target.value)
            });
        }
    }, [
        ,
        facet,
        attr,
        updateChoiceFacet,
        sendFilterClickedEvent
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(FacetLayout, {
        label: facet.label,
        children: sortedOptions.map((o)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(FacetCheckboxItem, {
                checked: o.active,
                count: o.count,
                value: o.value,
                onChange: onChange,
                children: o.label
            }, o.value))
    });
};

;// CONCATENATED MODULE: ./src/features/search/components/filters/facets/hierarchical-checkbox-facet.tsx







const convertToFacetTree = (options)=>{
    const facetPairs = options.map((f)=>[
            f.value,
            {
                ...f,
                children: [],
                parents: []
            }
        ]);
    const tree = new Map(facetPairs);
    tree.forEach((ref)=>{
        var ref1, ref2;
        (ref1 = tree.get(ref.parent)) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.children) === null || ref2 === void 0 ? void 0 : ref2.push(ref);
    });
    tree.forEach((ref)=>{
        var ref1;
        (ref1 = ref.children) === null || ref1 === void 0 ? void 0 : ref1.forEach((child)=>{
            const parent = tree.get(child.parent);
            if (parent) {
                var ref;
                child === null || child === void 0 ? void 0 : (ref = child.parents) === null || ref === void 0 ? void 0 : ref.push(parent);
            }
        });
    });
    return tree;
};
const HierarchicalCheckboxFacet = (param)=>{
    let { attr , facet  } = param;
    const { updateChoiceFacet , facetOrderValues  } = (0,context/* useProductSearch */.ty)();
    const sortedOptions = (0,api/* sortFacetOptions */.i9)(attr, facet.options, facetOrderValues);
    const facetTree = convertToFacetTree(sortedOptions);
    const facetTreeValues = Array.from(facetTree.values()).filter((p)=>!p.parent);
    const facetTreeValuesFlat = flattenFacetTreeValues(facetTreeValues);
    const onChange = (0,react.useCallback)((e)=>{
        const value = e.target.value;
        const checked = e.target.checked;
        const filterUpdate = {
            [value]: checked
        };
        const selectedFacet = facetTreeValuesFlat.find((localFacet)=>localFacet.value.toString() === value);
        // if un-checking
        if (!checked && selectedFacet) {
            var ref, ref1;
            var ref2;
            // check if has children and uncheck them
            if ((ref2 = selectedFacet === null || selectedFacet === void 0 ? void 0 : (ref = selectedFacet.children) === null || ref === void 0 ? void 0 : ref.length) !== null && ref2 !== void 0 ? ref2 : 0 > 0) {
                var ref3;
                const selectedFacetChildrenFlat = flattenFacetTreeValues((ref3 = selectedFacet === null || selectedFacet === void 0 ? void 0 : selectedFacet.children) !== null && ref3 !== void 0 ? ref3 : []);
                selectedFacetChildrenFlat.forEach((localFacet)=>{
                    filterUpdate[localFacet.value] = checked;
                });
            }
            // check if all siblings are also un-checked
            const parent = facetTree.get(selectedFacet.parent);
            const noActiveChildren = !(parent === null || parent === void 0 ? void 0 : (ref1 = parent.children) === null || ref1 === void 0 ? void 0 : ref1.some((child)=>child !== selectedFacet && child.active));
            if (parent && noActiveChildren) {
                // if all parent children are un-checked, add parent facet
                filterUpdate[parent.value] = true;
            }
        }
        // if checking, check if has parent and remove parent facet
        if (checked && (selectedFacet === null || selectedFacet === void 0 ? void 0 : selectedFacet.parents)) {
            selectedFacet.parents.forEach((parent)=>{
                filterUpdate[parent.value] = false;
            });
        }
        updateChoiceFacet(facet, attr, filterUpdate);
    }, [
        updateChoiceFacet,
        facet,
        attr,
        facetTreeValuesFlat,
        facetTree
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(FacetLayout, {
        label: facet.label,
        children: facetTreeValues.map((o)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(FacetCheckbox, {
                level: 0,
                option: o,
                onChange: onChange
            }, o.value))
    });
};

// EXTERNAL MODULE: ../../.yarn/cache/lodash-npm-4.17.21-6382451519-eb835a2e51.zip/node_modules/lodash/lodash.js
var lodash = __webpack_require__(35735);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/react-slider-virtual-f977aa1dc9/0/cache/react-slider-npm-1.1.4-a31b38d90a-eb1753bfe2.zip/node_modules/react-slider/es/components/ReactSlider/ReactSlider.js
var _jsxFileName = "/Users/brians/git/react-slider/src/components/ReactSlider/ReactSlider.jsx";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }



/**
 * To prevent text selection while dragging.
 * http://stackoverflow.com/questions/5429827/how-can-i-prevent-text-element-selection-with-cursor-drag
 */

function pauseEvent(e) {
  if (e && e.stopPropagation) {
    e.stopPropagation();
  }

  if (e && e.preventDefault) {
    e.preventDefault();
  }

  return false;
}

function stopPropagation(e) {
  if (e.stopPropagation) {
    e.stopPropagation();
  }
}

function sanitizeInValue(x) {
  if (x == null) {
    return [];
  }

  return Array.isArray(x) ? x.slice() : [x];
}

function prepareOutValue(x) {
  return x !== null && x.length === 1 ? x[0] : x.slice();
}

function trimSucceeding(length, nextValue, minDistance, max) {
  for (var i = 0; i < length; i += 1) {
    var padding = max - i * minDistance;

    if (nextValue[length - 1 - i] > padding) {
      // eslint-disable-next-line no-param-reassign
      nextValue[length - 1 - i] = padding;
    }
  }
}

function trimPreceding(length, nextValue, minDistance, min) {
  for (var i = 0; i < length; i += 1) {
    var padding = min + i * minDistance;

    if (nextValue[i] < padding) {
      // eslint-disable-next-line no-param-reassign
      nextValue[i] = padding;
    }
  }
}

function addHandlers(eventMap) {
  Object.keys(eventMap).forEach(function (key) {
    if (typeof document !== 'undefined') {
      document.addEventListener(key, eventMap[key], false);
    }
  });
}

function removeHandlers(eventMap) {
  Object.keys(eventMap).forEach(function (key) {
    if (typeof document !== 'undefined') {
      document.removeEventListener(key, eventMap[key], false);
    }
  });
}

function trimAlignValue(val, props) {
  return alignValue(trimValue(val, props), props);
}

function alignValue(val, props) {
  var valModStep = (val - props.min) % props.step;
  var alignedValue = val - valModStep;

  if (Math.abs(valModStep) * 2 >= props.step) {
    alignedValue += valModStep > 0 ? props.step : -props.step;
  }

  return parseFloat(alignedValue.toFixed(5));
}

function trimValue(val, props) {
  var trimmed = val;

  if (trimmed <= props.min) {
    trimmed = props.min;
  }

  if (trimmed >= props.max) {
    trimmed = props.max;
  }

  return trimmed;
}

var ReactSlider = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(ReactSlider, _React$Component);

  function ReactSlider(_props) {
    var _this;

    _this = _React$Component.call(this, _props) || this;

    _this.onKeyUp = function () {
      _this.onEnd();
    };

    _this.onMouseUp = function () {
      _this.onEnd(_this.getMouseEventMap());
    };

    _this.onTouchEnd = function () {
      _this.onEnd(_this.getTouchEventMap());
    };

    _this.onBlur = function () {
      _this.setState({
        index: -1
      }, _this.onEnd(_this.getKeyDownEventMap()));
    };

    _this.onMouseMove = function (e) {
      // Prevent controlled updates from happening while mouse is moving
      _this.setState({
        pending: true
      });

      var position = _this.getMousePosition(e);

      var diffPosition = _this.getDiffPosition(position[0]);

      var newValue = _this.getValueFromPosition(diffPosition);

      _this.move(newValue);
    };

    _this.onTouchMove = function (e) {
      if (e.touches.length > 1) {
        return;
      } // Prevent controlled updates from happending while touch is moving


      _this.setState({
        pending: true
      });

      var position = _this.getTouchPosition(e);

      if (typeof _this.isScrolling === 'undefined') {
        var diffMainDir = position[0] - _this.startPosition[0];
        var diffScrollDir = position[1] - _this.startPosition[1];
        _this.isScrolling = Math.abs(diffScrollDir) > Math.abs(diffMainDir);
      }

      if (_this.isScrolling) {
        _this.setState({
          index: -1
        });

        return;
      }

      var diffPosition = _this.getDiffPosition(position[0]);

      var newValue = _this.getValueFromPosition(diffPosition);

      _this.move(newValue);
    };

    _this.onKeyDown = function (e) {
      if (e.ctrlKey || e.shiftKey || e.altKey) {
        return;
      } // Prevent controlled updates from happening while a key is pressed


      _this.setState({
        pending: true
      });

      switch (e.key) {
        case 'ArrowLeft':
        case 'ArrowDown':
        case 'Left':
        case 'Down':
          e.preventDefault();

          _this.moveDownByStep();

          break;

        case 'ArrowRight':
        case 'ArrowUp':
        case 'Right':
        case 'Up':
          e.preventDefault();

          _this.moveUpByStep();

          break;

        case 'Home':
          e.preventDefault();

          _this.move(_this.props.min);

          break;

        case 'End':
          e.preventDefault();

          _this.move(_this.props.max);

          break;

        case 'PageDown':
          e.preventDefault();

          _this.moveDownByStep(_this.props.pageFn(_this.props.step));

          break;

        case 'PageUp':
          e.preventDefault();

          _this.moveUpByStep(_this.props.pageFn(_this.props.step));

          break;

        default:
      }
    };

    _this.onSliderMouseDown = function (e) {
      // do nothing if disabled or right click
      if (_this.props.disabled || e.button === 2) {
        return;
      } // Prevent controlled updates from happening while mouse is moving


      _this.setState({
        pending: true
      });

      if (!_this.props.snapDragDisabled) {
        var position = _this.getMousePosition(e);

        _this.forceValueFromPosition(position[0], function (i) {
          _this.start(i, position[0]);

          addHandlers(_this.getMouseEventMap());
        });
      }

      pauseEvent(e);
    };

    _this.onSliderClick = function (e) {
      if (_this.props.disabled) {
        return;
      }

      if (_this.props.onSliderClick && !_this.hasMoved) {
        var position = _this.getMousePosition(e);

        var valueAtPos = trimAlignValue(_this.calcValue(_this.calcOffsetFromPosition(position[0])), _this.props);

        _this.props.onSliderClick(valueAtPos);
      }
    };

    _this.createOnKeyDown = function (i) {
      return function (e) {
        if (_this.props.disabled) {
          return;
        }

        _this.start(i);

        addHandlers(_this.getKeyDownEventMap());
        pauseEvent(e);
      };
    };

    _this.createOnMouseDown = function (i) {
      return function (e) {
        // do nothing if disabled or right click
        if (_this.props.disabled || e.button === 2) {
          return;
        } // Prevent controlled updates from happending while mouse is moving


        _this.setState({
          pending: true
        });

        var position = _this.getMousePosition(e);

        _this.start(i, position[0]);

        addHandlers(_this.getMouseEventMap());
        pauseEvent(e);
      };
    };

    _this.createOnTouchStart = function (i) {
      return function (e) {
        if (_this.props.disabled || e.touches.length > 1) {
          return;
        } // Prevent controlled updates from happending while touch is moving


        _this.setState({
          pending: true
        });

        var position = _this.getTouchPosition(e);

        _this.startPosition = position; // don't know yet if the user is trying to scroll

        _this.isScrolling = undefined;

        _this.start(i, position[0]);

        addHandlers(_this.getTouchEventMap());
        stopPropagation(e);
      };
    };

    _this.handleResize = function () {
      // setTimeout of 0 gives element enough time to have assumed its new size if
      // it is being resized
      var resizeTimeout = window.setTimeout(function () {
        // drop this timeout from pendingResizeTimeouts to reduce memory usage
        _this.pendingResizeTimeouts.shift();

        _this.resize();
      }, 0);

      _this.pendingResizeTimeouts.push(resizeTimeout);
    };

    _this.renderThumb = function (style, i) {
      var className = _this.props.thumbClassName + " " + _this.props.thumbClassName + "-" + i + " " + (_this.state.index === i ? _this.props.thumbActiveClassName : '');
      var props = {
        'ref': function ref(r) {
          _this["thumb" + i] = r;
        },
        'key': _this.props.thumbClassName + "-" + i,
        className: className,
        style: style,
        'onMouseDown': _this.createOnMouseDown(i),
        'onTouchStart': _this.createOnTouchStart(i),
        'onFocus': _this.createOnKeyDown(i),
        'tabIndex': 0,
        'role': 'slider',
        'aria-orientation': _this.props.orientation,
        'aria-valuenow': _this.state.value[i],
        'aria-valuemin': _this.props.min,
        'aria-valuemax': _this.props.max,
        'aria-label': Array.isArray(_this.props.ariaLabel) ? _this.props.ariaLabel[i] : _this.props.ariaLabel
      };
      var state = {
        index: i,
        value: prepareOutValue(_this.state.value),
        valueNow: _this.state.value[i]
      };

      if (_this.props.ariaValuetext) {
        props['aria-valuetext'] = typeof _this.props.ariaValuetext === 'string' ? _this.props.ariaValuetext : _this.props.ariaValuetext(state);
      }

      return _this.props.renderThumb(props, state);
    };

    _this.renderTrack = function (i, offsetFrom, offsetTo) {
      var props = {
        key: _this.props.trackClassName + "-" + i,
        className: _this.props.trackClassName + " " + _this.props.trackClassName + "-" + i,
        style: _this.buildTrackStyle(offsetFrom, _this.state.upperBound - offsetTo)
      };
      var state = {
        index: i,
        value: prepareOutValue(_this.state.value)
      };
      return _this.props.renderTrack(props, state);
    };

    var value = sanitizeInValue(_props.value);

    if (!value.length) {
      value = sanitizeInValue(_props.defaultValue);
    } // array for storing resize timeouts ids


    _this.pendingResizeTimeouts = [];
    var zIndices = [];

    for (var i = 0; i < value.length; i += 1) {
      value[i] = trimAlignValue(value[i], _props);
      zIndices.push(i);
    }

    _this.state = {
      index: -1,
      upperBound: 0,
      sliderLength: 0,
      value: value,
      zIndices: zIndices
    };
    return _this;
  }

  var _proto = ReactSlider.prototype;

  _proto.componentDidMount = function componentDidMount() {
    if (typeof window !== 'undefined') {
      window.addEventListener('resize', this.handleResize);
      this.resize();
    }
  } // Keep the internal `value` consistent with an outside `value` if present.
  // This basically allows the slider to be a controlled component.
  ;

  ReactSlider.getDerivedStateFromProps = function getDerivedStateFromProps(props, state) {
    var value = sanitizeInValue(props.value);

    if (!value.length) {
      return null;
    } // Do not allow controlled upates to happen while we have pending updates


    if (state.pending) {
      return null;
    }

    return {
      value: value.map(function (item) {
        return trimAlignValue(item, props);
      })
    };
  };

  _proto.componentDidUpdate = function componentDidUpdate() {
    // If an upperBound has not yet been determined (due to the component being hidden
    // during the mount event, or during the last resize), then calculate it now
    if (this.state.upperBound === 0) {
      this.resize();
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.clearPendingResizeTimeouts();

    if (typeof window !== 'undefined') {
      window.removeEventListener('resize', this.handleResize);
    }
  };

  _proto.onEnd = function onEnd(eventMap) {
    if (eventMap) {
      removeHandlers(eventMap);
    }

    if (this.hasMoved) {
      this.fireChangeEvent('onAfterChange');
    } // Allow controlled updates to continue


    this.setState({
      pending: false
    });
    this.hasMoved = false;
  };

  _proto.getValue = function getValue() {
    return prepareOutValue(this.state.value);
  };

  _proto.getClosestIndex = function getClosestIndex(pixelOffset) {
    var minDist = Number.MAX_VALUE;
    var closestIndex = -1;
    var value = this.state.value;
    var l = value.length;

    for (var i = 0; i < l; i += 1) {
      var offset = this.calcOffset(value[i]);
      var dist = Math.abs(pixelOffset - offset);

      if (dist < minDist) {
        minDist = dist;
        closestIndex = i;
      }
    }

    return closestIndex;
  };

  _proto.getMousePosition = function getMousePosition(e) {
    return [e["page" + this.axisKey()], e["page" + this.orthogonalAxisKey()]];
  };

  _proto.getTouchPosition = function getTouchPosition(e) {
    var touch = e.touches[0];
    return [touch["page" + this.axisKey()], touch["page" + this.orthogonalAxisKey()]];
  };

  _proto.getKeyDownEventMap = function getKeyDownEventMap() {
    return {
      keydown: this.onKeyDown,
      keyup: this.onKeyUp,
      focusout: this.onBlur
    };
  };

  _proto.getMouseEventMap = function getMouseEventMap() {
    return {
      mousemove: this.onMouseMove,
      mouseup: this.onMouseUp
    };
  };

  _proto.getTouchEventMap = function getTouchEventMap() {
    return {
      touchmove: this.onTouchMove,
      touchend: this.onTouchEnd
    };
  };

  _proto.getValueFromPosition = function getValueFromPosition(position) {
    var diffValue = position / (this.state.sliderLength - this.state.thumbSize) * (this.props.max - this.props.min);
    return trimAlignValue(this.state.startValue + diffValue, this.props);
  };

  _proto.getDiffPosition = function getDiffPosition(position) {
    var diffPosition = position - this.state.startPosition;

    if (this.props.invert) {
      diffPosition *= -1;
    }

    return diffPosition;
  } // create the `keydown` handler for the i-th thumb
  ;

  _proto.resize = function resize() {
    var slider = this.slider,
        thumb = this.thumb0;

    if (!slider || !thumb) {
      return;
    }

    var sizeKey = this.sizeKey(); // For the slider size, we want to use the client width/height, excluding any borders

    var sliderRect = slider.getBoundingClientRect();
    var sliderSize = slider[sizeKey];
    var sliderMax = sliderRect[this.posMaxKey()];
    var sliderMin = sliderRect[this.posMinKey()]; // For the thumb size, we want to use the outer width/height, including any borders

    var thumbRect = thumb.getBoundingClientRect();
    var thumbSize = thumbRect[sizeKey.replace('client', '').toLowerCase()];
    var upperBound = sliderSize - thumbSize;
    var sliderLength = Math.abs(sliderMax - sliderMin);

    if (this.state.upperBound !== upperBound || this.state.sliderLength !== sliderLength || this.state.thumbSize !== thumbSize) {
      this.setState({
        upperBound: upperBound,
        sliderLength: sliderLength,
        thumbSize: thumbSize
      });
    }
  } // calculates the offset of a thumb in pixels based on its value.
  ;

  _proto.calcOffset = function calcOffset(value) {
    var range = this.props.max - this.props.min;

    if (range === 0) {
      return 0;
    }

    var ratio = (value - this.props.min) / range;
    return ratio * this.state.upperBound;
  } // calculates the value corresponding to a given pixel offset, i.e. the inverse of `calcOffset`.
  ;

  _proto.calcValue = function calcValue(offset) {
    var ratio = offset / this.state.upperBound;
    return ratio * (this.props.max - this.props.min) + this.props.min;
  };

  _proto.calcOffsetFromPosition = function calcOffsetFromPosition(position) {
    var slider = this.slider;
    var sliderRect = slider.getBoundingClientRect();
    var sliderMax = sliderRect[this.posMaxKey()];
    var sliderMin = sliderRect[this.posMinKey()]; // The `position` value passed in is the mouse position based on the window height.
    // The slider bounding rect is based on the viewport, so we must add the window scroll
    // offset to normalize the values.

    var windowOffset = window["page" + this.axisKey() + "Offset"];
    var sliderStart = windowOffset + (this.props.invert ? sliderMax : sliderMin);
    var pixelOffset = position - sliderStart;

    if (this.props.invert) {
      pixelOffset = this.state.sliderLength - pixelOffset;
    }

    pixelOffset -= this.state.thumbSize / 2;
    return pixelOffset;
  } // Snaps the nearest thumb to the value corresponding to `position`
  // and calls `callback` with that thumb's index.
  ;

  _proto.forceValueFromPosition = function forceValueFromPosition(position, callback) {
    var _this2 = this;

    var pixelOffset = this.calcOffsetFromPosition(position);
    var closestIndex = this.getClosestIndex(pixelOffset);
    var nextValue = trimAlignValue(this.calcValue(pixelOffset), this.props); // Clone this.state.value since we'll modify it temporarily
    // eslint-disable-next-line zillow/react/no-access-state-in-setstate

    var value = this.state.value.slice();
    value[closestIndex] = nextValue; // Prevents the slider from shrinking below `props.minDistance`

    for (var i = 0; i < value.length - 1; i += 1) {
      if (value[i + 1] - value[i] < this.props.minDistance) {
        return;
      }
    }

    this.fireChangeEvent('onBeforeChange');
    this.hasMoved = true;
    this.setState({
      value: value
    }, function () {
      callback(closestIndex);

      _this2.fireChangeEvent('onChange');
    });
  } // clear all pending timeouts to avoid error messages after unmounting
  ;

  _proto.clearPendingResizeTimeouts = function clearPendingResizeTimeouts() {
    do {
      var nextTimeout = this.pendingResizeTimeouts.shift();
      clearTimeout(nextTimeout);
    } while (this.pendingResizeTimeouts.length);
  };

  _proto.start = function start(i, position) {
    var thumbRef = this["thumb" + i];

    if (thumbRef) {
      thumbRef.focus();
    }

    var zIndices = this.state.zIndices; // remove wherever the element is

    zIndices.splice(zIndices.indexOf(i), 1); // add to end

    zIndices.push(i);
    this.setState(function (prevState) {
      return {
        startValue: prevState.value[i],
        startPosition: position !== undefined ? position : prevState.startPosition,
        index: i,
        zIndices: zIndices
      };
    });
  };

  _proto.moveUpByStep = function moveUpByStep(step) {
    if (step === void 0) {
      step = this.props.step;
    }

    var oldValue = this.state.value[this.state.index];
    var newValue = trimAlignValue(oldValue + step, this.props);
    this.move(Math.min(newValue, this.props.max));
  };

  _proto.moveDownByStep = function moveDownByStep(step) {
    if (step === void 0) {
      step = this.props.step;
    }

    var oldValue = this.state.value[this.state.index];
    var newValue = trimAlignValue(oldValue - step, this.props);
    this.move(Math.max(newValue, this.props.min));
  };

  _proto.move = function move(newValue) {
    var _this$state = this.state,
        index = _this$state.index,
        value = _this$state.value;
    var length = value.length; // Short circuit if the value is not changing

    var oldValue = value[index];

    if (newValue === oldValue) {
      return;
    } // Trigger only before the first movement


    if (!this.hasMoved) {
      this.fireChangeEvent('onBeforeChange');
    }

    this.hasMoved = true; // if "pearling" (= thumbs pushing each other) is disabled,
    // prevent the thumb from getting closer than `minDistance` to the previous or next thumb.

    var _this$props = this.props,
        pearling = _this$props.pearling,
        max = _this$props.max,
        min = _this$props.min,
        minDistance = _this$props.minDistance;

    if (!pearling) {
      if (index > 0) {
        var valueBefore = value[index - 1];

        if (newValue < valueBefore + minDistance) {
          // eslint-disable-next-line no-param-reassign
          newValue = valueBefore + minDistance;
        }
      }

      if (index < length - 1) {
        var valueAfter = value[index + 1];

        if (newValue > valueAfter - minDistance) {
          // eslint-disable-next-line no-param-reassign
          newValue = valueAfter - minDistance;
        }
      }
    }

    value[index] = newValue; // if "pearling" is enabled, let the current thumb push the pre- and succeeding thumbs.

    if (pearling && length > 1) {
      if (newValue > oldValue) {
        this.pushSucceeding(value, minDistance, index);
        trimSucceeding(length, value, minDistance, max);
      } else if (newValue < oldValue) {
        this.pushPreceding(value, minDistance, index);
        trimPreceding(length, value, minDistance, min);
      }
    } // Normally you would use `shouldComponentUpdate`,
    // but since the slider is a low-level component,
    // the extra complexity might be worth the extra performance.


    this.setState({
      value: value
    }, this.fireChangeEvent.bind(this, 'onChange'));
  };

  _proto.pushSucceeding = function pushSucceeding(value, minDistance, index) {
    var i;
    var padding;

    for (i = index, padding = value[i] + minDistance; value[i + 1] !== null && padding > value[i + 1]; i += 1, padding = value[i] + minDistance) {
      // eslint-disable-next-line no-param-reassign
      value[i + 1] = alignValue(padding, this.props);
    }
  };

  _proto.pushPreceding = function pushPreceding(value, minDistance, index) {
    for (var i = index, padding = value[i] - minDistance; value[i - 1] !== null && padding < value[i - 1]; i -= 1, padding = value[i] - minDistance) {
      // eslint-disable-next-line no-param-reassign
      value[i - 1] = alignValue(padding, this.props);
    }
  };

  _proto.axisKey = function axisKey() {
    if (this.props.orientation === 'vertical') {
      return 'Y';
    } // Defaults to 'horizontal';


    return 'X';
  };

  _proto.orthogonalAxisKey = function orthogonalAxisKey() {
    if (this.props.orientation === 'vertical') {
      return 'X';
    } // Defaults to 'horizontal'


    return 'Y';
  };

  _proto.posMinKey = function posMinKey() {
    if (this.props.orientation === 'vertical') {
      return this.props.invert ? 'bottom' : 'top';
    } // Defaults to 'horizontal'


    return this.props.invert ? 'right' : 'left';
  };

  _proto.posMaxKey = function posMaxKey() {
    if (this.props.orientation === 'vertical') {
      return this.props.invert ? 'top' : 'bottom';
    } // Defaults to 'horizontal'


    return this.props.invert ? 'left' : 'right';
  };

  _proto.sizeKey = function sizeKey() {
    if (this.props.orientation === 'vertical') {
      return 'clientHeight';
    } // Defaults to 'horizontal'


    return 'clientWidth';
  };

  _proto.fireChangeEvent = function fireChangeEvent(event) {
    if (this.props[event]) {
      this.props[event](prepareOutValue(this.state.value));
    }
  };

  _proto.buildThumbStyle = function buildThumbStyle(offset, i) {
    var style = {
      position: 'absolute',
      touchAction: 'none',
      willChange: this.state.index >= 0 ? this.posMinKey() : '',
      zIndex: this.state.zIndices.indexOf(i) + 1
    };
    style[this.posMinKey()] = offset + "px";
    return style;
  };

  _proto.buildTrackStyle = function buildTrackStyle(min, max) {
    var obj = {
      position: 'absolute',
      willChange: this.state.index >= 0 ? this.posMinKey() + "," + this.posMaxKey() : ''
    };
    obj[this.posMinKey()] = min;
    obj[this.posMaxKey()] = max;
    return obj;
  };

  _proto.buildMarkStyle = function buildMarkStyle(offset) {
    var _ref;

    return _ref = {
      position: 'absolute'
    }, _ref[this.posMinKey()] = offset, _ref;
  };

  _proto.renderThumbs = function renderThumbs(offset) {
    var length = offset.length;
    var styles = [];

    for (var i = 0; i < length; i += 1) {
      styles[i] = this.buildThumbStyle(offset[i], i);
    }

    var res = [];

    for (var _i = 0; _i < length; _i += 1) {
      res[_i] = this.renderThumb(styles[_i], _i);
    }

    return res;
  };

  _proto.renderTracks = function renderTracks(offset) {
    var tracks = [];
    var lastIndex = offset.length - 1;
    tracks.push(this.renderTrack(0, 0, offset[0]));

    for (var i = 0; i < lastIndex; i += 1) {
      tracks.push(this.renderTrack(i + 1, offset[i], offset[i + 1]));
    }

    tracks.push(this.renderTrack(lastIndex + 1, offset[lastIndex], this.state.upperBound));
    return tracks;
  };

  _proto.renderMarks = function renderMarks() {
    var _this3 = this;

    var marks = this.props.marks;
    var range = this.props.max - this.props.min + 1;

    if (typeof marks === 'boolean') {
      marks = Array.from({
        length: range
      }).map(function (_, key) {
        return key;
      });
    } else if (typeof marks === 'number') {
      marks = Array.from({
        length: range
      }).map(function (_, key) {
        return key;
      }).filter(function (key) {
        return key % marks === 0;
      });
    }

    return marks.map(parseFloat).sort(function (a, b) {
      return a - b;
    }).map(function (mark) {
      var offset = _this3.calcOffset(mark);

      var props = {
        key: mark,
        className: _this3.props.markClassName,
        style: _this3.buildMarkStyle(offset)
      };
      return _this3.props.renderMark(props);
    });
  };

  _proto.render = function render() {
    var _this4 = this;

    var offset = [];
    var value = this.state.value;
    var l = value.length;

    for (var i = 0; i < l; i += 1) {
      offset[i] = this.calcOffset(value[i], i);
    }

    var tracks = this.props.withTracks ? this.renderTracks(offset) : null;
    var thumbs = this.renderThumbs(offset);
    var marks = this.props.marks ? this.renderMarks() : null;
    return /*#__PURE__*/react.createElement('div', {
      ref: function ref(r) {
        _this4.slider = r;
      },
      style: {
        position: 'relative'
      },
      className: this.props.className + (this.props.disabled ? ' disabled' : ''),
      onMouseDown: this.onSliderMouseDown,
      onClick: this.onSliderClick
    }, tracks, thumbs, marks);
  };

  return ReactSlider;
}(react.Component);

ReactSlider.displayName = 'ReactSlider';
ReactSlider.defaultProps = {
  min: 0,
  max: 100,
  step: 1,
  pageFn: function pageFn(step) {
    return step * 10;
  },
  minDistance: 0,
  defaultValue: 0,
  orientation: 'horizontal',
  className: 'slider',
  thumbClassName: 'thumb',
  thumbActiveClassName: 'active',
  trackClassName: 'track',
  markClassName: 'mark',
  withTracks: true,
  pearling: false,
  disabled: false,
  snapDragDisabled: false,
  invert: false,
  marks: [],
  renderThumb: function renderThumb(props) {
    return /*#__PURE__*/react.createElement("div", _extends({}, props, {
      __self: ReactSlider,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 340,
        columnNumber: 31
      }
    }));
  },
  renderTrack: function renderTrack(props) {
    return /*#__PURE__*/react.createElement("div", _extends({}, props, {
      __self: ReactSlider,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 341,
        columnNumber: 31
      }
    }));
  },
  renderMark: function renderMark(props) {
    return /*#__PURE__*/react.createElement("span", _extends({}, props, {
      __self: ReactSlider,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 342,
        columnNumber: 30
      }
    }));
  }
};
ReactSlider.propTypes =  false ? 0 : {};
/* harmony default export */ var ReactSlider_ReactSlider = (ReactSlider);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-lib-utils-virtual-08ae943915/1/packages/lib-utils/src/index.ts + 19 modules
var lib_utils_src = __webpack_require__(65582);
// EXTERNAL MODULE: ../../.yarn/__virtual__/use-debounce-virtual-d68bd84a4e/0/cache/use-debounce-npm-6.0.1-6203424700-9f81107565.zip/node_modules/use-debounce/esm/useDebouncedCallback.js
var useDebouncedCallback = __webpack_require__(99627);
;// CONCATENATED MODULE: ./src/features/search/components/filters/facets/range-facet.tsx
/* eslint-disable react-perf/jsx-no-new-array-as-prop */ /* eslint-disable @typescript-eslint/no-explicit-any */ /* eslint-disable react-perf/jsx-no-new-function-as-prop */ /* eslint-disable react/jsx-no-bind */ /* eslint-disable react-perf/jsx-no-new-object-as-prop */ function range_facet_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function range_facet_templateObject() {
    const data = range_facet_taggedTemplateLiteral([
        "\n  position: relative;\n  padding-top: 10px;\n"
    ]);
    range_facet_templateObject = function() {
        return data;
    };
    return data;
}
function range_facet_templateObject1() {
    const data = range_facet_taggedTemplateLiteral([
        "\n  width: 100%;\n  height: 6px;\n  cursor: move; /* fallback if grab cursor is unsupported */\n  cursor: grab;\n  &:active {\n    cursor: grabbing;\n  }\n  .track-1 {\n    background-color: ",
        ";\n    opacity: 0.1;\n  }\n"
    ]);
    range_facet_templateObject1 = function() {
        return data;
    };
    return data;
}
function range_facet_templateObject2() {
    const data = range_facet_taggedTemplateLiteral([
        "\n  height: 100%;\n  border-radius: 0;\n  background: ",
        ";\n  &.track-1 {\n    height: 100%;\n    border-color: 1px solid ",
        ";\n    background-color: ",
        ";\n    opacity: 1;\n  }\n"
    ]);
    range_facet_templateObject2 = function() {
        return data;
    };
    return data;
}
function range_facet_templateObject3() {
    const data = range_facet_taggedTemplateLiteral([
        "\n  position: absolute;\n  top: -3px;\n  left: -6px;\n  width: 12px;\n  height: 12px;\n  border: 0;\n  border-radius: 10px;\n  background-color: ",
        ";\n  cursor: grap;\n"
    ]);
    range_facet_templateObject3 = function() {
        return data;
    };
    return data;
}
function range_facet_templateObject4() {
    const data = range_facet_taggedTemplateLiteral([
        "\n  position: relative;\n  height: 100%;\n  &:focus {\n    outline: none;\n  }\n"
    ]);
    range_facet_templateObject4 = function() {
        return data;
    };
    return data;
}
function range_facet_templateObject5() {
    const data = range_facet_taggedTemplateLiteral([
        "\n  display: flex;\n  width: 100%;\n  align-items: flex-start;\n  justify-content: space-between;\n  padding-top: 4px;\n"
    ]);
    range_facet_templateObject5 = function() {
        return data;
    };
    return data;
}
function range_facet_templateObject6() {
    const data = range_facet_taggedTemplateLiteral([
        "\n  color: ",
        ";\n  font-size: 0.75rem;\n  font-weight: 400;\n  line-height: 1.2;\n"
    ]);
    range_facet_templateObject6 = function() {
        return data;
    };
    return data;
}
function range_facet_templateObject7() {
    const data = range_facet_taggedTemplateLiteral([
        "\n  height: 50px;\n"
    ]);
    range_facet_templateObject7 = function() {
        return data;
    };
    return data;
}
function range_facet_templateObject8() {
    const data = range_facet_taggedTemplateLiteral([
        "\n  display: inline-block;\n  justify-content: center;\n"
    ]);
    range_facet_templateObject8 = function() {
        return data;
    };
    return data;
}
function range_facet_templateObject9() {
    const data = range_facet_taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 20px;\n"
    ]);
    range_facet_templateObject9 = function() {
        return data;
    };
    return data;
}
function range_facet_templateObject10() {
    const data = range_facet_taggedTemplateLiteral([
        "\n  font-weight: bold;\n  margin-inline: 8px;\n"
    ]);
    range_facet_templateObject10 = function() {
        return data;
    };
    return data;
}
function range_facet_templateObject11() {
    const data = range_facet_taggedTemplateLiteral([
        "\n  color: ",
        ";\n  font-size: 1.125rem;\n  font-weight: 500;\n  letter-spacing: 0.4px;\n  line-height: 1;\n  text-align: left;\n"
    ]);
    range_facet_templateObject11 = function() {
        return data;
    };
    return data;
}










const formatNumber = (num)=>{
    if (typeof num === "string") {
        num = parseFloat(num);
    }
    num = Math.floor(num);
    return num.toLocaleString("de-DE");
};
const range_facet_Wrapper = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-891bfb2c-0"
})(range_facet_templateObject());
const Slider = (0,styled_components_browser_cjs["default"])(ReactSlider_ReactSlider).withConfig({
    componentId: "sc-891bfb2c-1"
})(range_facet_templateObject1(), lib_styles_src/* theme.palette.gray.80 */.rS.palette.gray[80]);
const SliderTrack = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-891bfb2c-2"
})(range_facet_templateObject2(), lib_styles_src/* theme.palette.blue.lightest */.rS.palette.blue.lightest, lib_styles_src/* theme.palette.blue.main */.rS.palette.blue.main, lib_styles_src/* theme.palette.blue.main */.rS.palette.blue.main);
const SliderStick = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-891bfb2c-3"
})(range_facet_templateObject3(), lib_styles_src/* theme.palette.blue.main */.rS.palette.blue.main);
const SliderStickWrapper = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-891bfb2c-4"
})(range_facet_templateObject4());
const RangeWrapper = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-891bfb2c-5"
})(range_facet_templateObject5());
const RangeLabel = styled_components_browser_cjs["default"].span.withConfig({
    componentId: "sc-891bfb2c-6"
})(range_facet_templateObject6(), lib_styles_src/* theme.palette.blue.main */.rS.palette.blue.main);
const PriceData = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-891bfb2c-7"
})(range_facet_templateObject7());
const PriceDataElement = styled_components_browser_cjs["default"].span.withConfig({
    componentId: "sc-891bfb2c-8"
})(range_facet_templateObject8());
const PriceRange = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-891bfb2c-9"
})(range_facet_templateObject9());
const PriceDelimiter = styled_components_browser_cjs["default"].span.withConfig({
    componentId: "sc-891bfb2c-10"
})(range_facet_templateObject10());
const Price = styled_components_browser_cjs["default"].span.withConfig({
    componentId: "sc-891bfb2c-11"
})(range_facet_templateObject11(), lib_styles_src/* theme.palette.blue.main */.rS.palette.blue.main);
const RangeSlider = (param)=>{
    let { facet , maxValue , minValue , onChange  } = param;
    const usedMin = facet.min || 0;
    const usedMax = facet.max || 260000;
    const steps = 100;
    const calcDist = (usedMax - usedMin) / steps;
    const priceArray = (0,lodash.toPairs)(facet.data);
    const priceSteps = priceArray.map((param)=>{
        let [step, count] = param;
        const stepPoint = (parseInt(step, 10) - usedMin) * (steps / (usedMax - usedMin));
        return {
            step: Math.min(Math.floor(stepPoint), steps - 1),
            count: parseInt(count, 10)
        };
    });
    const groupedByStep = (0,lodash.groupBy)(priceSteps, "step");
    const itemsPerStep = (0,lodash.mapValues)(groupedByStep, (g)=>(0,lodash.sumBy)(g, "count"));
    const maxCount = Math.max(...Object.values(itemsPerStep));
    const priceCountArray = (0,lodash.range)(steps).map((_, index)=>itemsPerStep[index] || 0);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(range_facet_Wrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(PriceRange, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Price, {
                        children: [
                            formatNumber(minValue !== null && minValue !== void 0 ? minValue : facet.min),
                            " ",
                            facet.unit
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PriceDelimiter, {
                        children: "-"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Price, {
                        children: [
                            formatNumber(maxValue !== null && maxValue !== void 0 ? maxValue : facet.max),
                            " ",
                            facet.unit
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PriceData, {
                children: priceCountArray.map((count, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(PriceDataElement, {
                        style: {
                            height: "".concat(count / maxCount * 100, "%"),
                            width: "".concat(100 / steps, "%"),
                            backgroundColor: lib_styles_src/* theme.palette.blue.light */.rS.palette.blue.light
                        }
                    }, index))
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Slider, {
                max: usedMax,
                min: usedMin,
                minDistance: calcDist * 5,
                pearling: true,
                renderThumb: (props)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(SliderStickWrapper, {
                        ...props,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SliderStick, {})
                    }),
                renderTrack: (props)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(SliderTrack, {
                        ...props
                    }),
                step: calcDist,
                value: [
                    minValue !== null && minValue !== void 0 ? minValue : facet.min,
                    maxValue !== null && maxValue !== void 0 ? maxValue : facet.max
                ],
                onChange: onChange
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(RangeWrapper, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(RangeLabel, {
                        children: [
                            formatNumber(usedMin),
                            " ",
                            facet.unit
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(RangeLabel, {
                        children: [
                            formatNumber(usedMax),
                            " ",
                            facet.unit
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var range_facet = ((/* unused pure expression or super */ null && (RangeSlider)));
const RangeFacet = (param)=>{
    let { attr , facet  } = param;
    const { updateRangeFacetValues  } = (0,context/* useProductSearch */.ty)();
    const [minValue, setMinValue] = (0,react.useState)(facet.minValue);
    const [maxValue, setMaxValue] = (0,react.useState)(facet.maxValue);
    const update = (0,useDebouncedCallback/* default */.Z)(()=>{
        updateRangeFacetValues(facet, attr, {
            min: minValue || null,
            max: maxValue || null
        });
    }, 200);
    const handleChange = (0,react.useCallback)((value)=>{
        const [from, to] = (0,lib_utils_src/* ensureList */.fL)(value);
        setMinValue(from);
        setMaxValue(to);
        update();
    }, [
        update
    ]);
    if (facet.min === facet.max) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(FacetLayout, {
        label: facet.label,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RangeSlider, {
            facet: facet,
            maxValue: maxValue !== null && maxValue !== void 0 ? maxValue : facet.maxValue,
            minValue: minValue !== null && minValue !== void 0 ? minValue : facet.minValue,
            onChange: handleChange
        })
    });
};

;// CONCATENATED MODULE: ./src/features/search/components/filters/facets/index.ts



const facetComponentTypeMap = {
    hierarchical: HierarchicalCheckboxFacet,
    choice: CheckboxFacet,
    range: RangeFacet
};



/***/ }),

/***/ 82571:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "GH": function() { return /* binding */ FilterChip; }
/* harmony export */ });
/* unused harmony exports TagWrapper, ClearButton */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(61261);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(91987);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(33982);
/* harmony import */ var _byko_component_typography__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(91371);
/* harmony import */ var _byko_lib_icons__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45628);
/* harmony import */ var _byko_lib_styles__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(52203);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    const data = _taggedTemplateLiteral([
        "\n  position: relative;\n  display: flex;\n  min-width: fit-content;\n  align-items: center;\n  padding: 10px 16px;\n  margin-bottom: 2px;\n  background-color: ",
        ";\n  gap: 8px;\n  outline: 1px solid ",
        ";\n  p {\n    margin-top: 4px;\n  }\n  @media screen and (min-width: ",
        "px) {\n    padding: 10px 16px;\n  }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _taggedTemplateLiteral([
        "\n  display: grid;\n  outline: none;\n  &:after {\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    width: 0%;\n    border-bottom: 2px solid ",
        ';\n    content: "";\n    transition: 300ms;\n  }\n  &:focus,\n  &:hover {\n    &:after {\n      width: 100%;\n    }\n  }\n'
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}






const TagWrapper = styled_components__WEBPACK_IMPORTED_MODULE_5__["default"].div.withConfig({
    componentId: "sc-19e2d9fc-0"
})(_templateObject(), _byko_lib_styles__WEBPACK_IMPORTED_MODULE_4__/* .theme.palette.white.main */ .rS.palette.white.main, _byko_lib_styles__WEBPACK_IMPORTED_MODULE_4__/* .theme.palette.blue.light */ .rS.palette.blue.light, _byko_lib_styles__WEBPACK_IMPORTED_MODULE_4__/* .gridTheme.breakpoints.sm */ .k.breakpoints.sm);
const ClearButton = styled_components__WEBPACK_IMPORTED_MODULE_5__["default"].button.withConfig({
    componentId: "sc-19e2d9fc-1"
})(_templateObject1(), _byko_lib_styles__WEBPACK_IMPORTED_MODULE_4__/* .theme.palette.blue.dark */ .rS.palette.blue.dark);
const FilterChip = (param)=>{
    let { children , ...props } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(TagWrapper, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_byko_component_typography__WEBPACK_IMPORTED_MODULE_2__/* .EyebrowSmall */ .xA, {
                lineHeight: "100%",
                textColor: _byko_lib_styles__WEBPACK_IMPORTED_MODULE_4__/* .theme.palette.blue.dark */ .rS.palette.blue.dark,
                children: children
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ClearButton, {
                type: "button",
                ...props,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_byko_lib_icons__WEBPACK_IMPORTED_MODULE_3__.CancelLargeIcons, {
                    iconColor: _byko_lib_styles__WEBPACK_IMPORTED_MODULE_4__/* .theme.palette.blue.dark */ .rS.palette.blue.dark,
                    size: 14
                })
            })
        ]
    });
};


/***/ }),

/***/ 22772:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ PaginationMenu; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(61261);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(38805);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(35735);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(58804);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(91987);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(33982);
/* harmony import */ var _byko_lib_styles__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(52203);
/* harmony import */ var _byko_lib_icons__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(45628);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    const data = _taggedTemplateLiteral([
        "\n  display: flex;\n  width: 100%;\n  height: 100%;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 4px;\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _taggedTemplateLiteral([
        "\n  display: flex;\n  width: 40px;\n  height: 36px;\n  align-items: center;\n  justify-content: center;\n  padding: 0;\n  margin: 0;\n  background-color: transparent;\n  cursor: pointer;\n  transition: background-color 0.15s;\n\n  &:disabled {\n    cursor: not-allowed;\n    opacity: 0.5;\n  }\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = _taggedTemplateLiteral([
        "\n  display: flex;\n  width: 36px;\n  height: 36px;\n  align-items: center;\n  justify-content: center;\n  padding: 0;\n  border: 1px solid ",
        ";\n  border-radius: 0;\n  margin: 0;\n  background-color: ",
        ";\n  color: ",
        ";\n  cursor: pointer;\n  font-size: 16px;\n  font-weight: 500;\n  transition: 150ms;\n\n  &:hover {\n    background-color: ",
        ";\n  }\n  &.selected {\n    background-color: ",
        ";\n    color: ",
        ";\n    pointer-events: none;\n  }\n"
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = _taggedTemplateLiteral([
        "\n  width: 2px;\n  height: 12px;\n  background-color: ",
        ";\n  margin-inline: 8px;\n"
    ]);
    _templateObject3 = function() {
        return data;
    };
    return data;
}








const Wrapper = styled_components__WEBPACK_IMPORTED_MODULE_7__["default"].div.withConfig({
    componentId: "sc-275baae4-0"
})(_templateObject());
const FlipLink = styled_components__WEBPACK_IMPORTED_MODULE_7__["default"].div.withConfig({
    componentId: "sc-275baae4-1"
})(_templateObject1());
const PageLink = styled_components__WEBPACK_IMPORTED_MODULE_7__["default"].span.withConfig({
    componentId: "sc-275baae4-2"
})(_templateObject2(), _byko_lib_styles__WEBPACK_IMPORTED_MODULE_5__/* .theme.palette.gray[10] */ .rS.palette.gray[10], _byko_lib_styles__WEBPACK_IMPORTED_MODULE_5__/* .theme.palette.white.main */ .rS.palette.white.main, _byko_lib_styles__WEBPACK_IMPORTED_MODULE_5__/* .theme.palette.blue.main */ .rS.palette.blue.main, _byko_lib_styles__WEBPACK_IMPORTED_MODULE_5__/* .theme.palette.gray[5] */ .rS.palette.gray[5], _byko_lib_styles__WEBPACK_IMPORTED_MODULE_5__/* .theme.palette.blue.main */ .rS.palette.blue.main, _byko_lib_styles__WEBPACK_IMPORTED_MODULE_5__/* .theme.palette.white.main */ .rS.palette.white.main);
const Spacer = styled_components__WEBPACK_IMPORTED_MODULE_7__["default"].div.withConfig({
    componentId: "sc-275baae4-3"
})(_templateObject3(), _byko_lib_styles__WEBPACK_IMPORTED_MODULE_5__/* .theme.palette.blue.main */ .rS.palette.blue.main);
function scrollTop() {
    if (true) {
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    }
}
function PaginationMenu(param) {
    let { page =1 , maxPage =1 , pageMargin =2 , pathname , query  } = param;
    const hasLess = page > 1;
    const hasMore = page < maxPage;
    const showMinEdge = page > pageMargin + 1;
    const showMaxEdge = page < maxPage - pageMargin;
    const min = Math.max(page - pageMargin, 1);
    const max = Math.min(page + pageMargin, maxPage);
    const linkProps = (p)=>({
            href: {
                pathname,
                query: {
                    ...query,
                    page: p
                }
            },
            shallow: true
        });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Wrapper, {
        children: [
            hasLess && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
                ...linkProps(page - 1),
                onClick: scrollTop,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FlipLink, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_byko_lib_icons__WEBPACK_IMPORTED_MODULE_6__.ArrowLeftIcons, {
                        iconColor: _byko_lib_styles__WEBPACK_IMPORTED_MODULE_5__/* .theme.palette.blue.main */ .rS.palette.blue.main,
                        size: 18
                    })
                })
            }),
            showMinEdge && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
                        ...linkProps(1),
                        onClick: scrollTop,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(PageLink, {
                            children: "1"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Spacer, {})
                ]
            }),
            (0,lodash__WEBPACK_IMPORTED_MODULE_2__.range)(min, max + 1).map((p)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
                    ...linkProps(p),
                    onClick: scrollTop,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(PageLink, {
                        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()({
                            selected: p === page
                        }),
                        children: p
                    })
                }, p)),
            showMaxEdge && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Spacer, {}),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
                        ...linkProps(maxPage),
                        onClick: scrollTop,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(PageLink, {
                            children: maxPage
                        })
                    })
                ]
            }),
            hasMore && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
                ...linkProps(page + 1),
                onClick: scrollTop,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FlipLink, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_byko_lib_icons__WEBPACK_IMPORTED_MODULE_6__.ArrowRightIcons, {
                        iconColor: _byko_lib_styles__WEBPACK_IMPORTED_MODULE_5__/* .theme.palette.blue.main */ .rS.palette.blue.main,
                        size: 18
                    })
                })
            })
        ]
    });
}


/***/ }),

/***/ 63839:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ ProductResultsList; },
/* harmony export */   "o": function() { return /* binding */ isRentalProduct; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(61261);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(91987);
/* harmony import */ var _byko_component_product_card__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(64549);
/* harmony import */ var _byko_hooks_auth_next__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(68814);
/* harmony import */ var _styles__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(71614);
/* eslint-disable react-perf/jsx-no-new-object-as-prop */ 




function ProductResultsList(param) {
    let { results , prices , rentals , products  } = param;
    const { activeMembership  } = (0,_byko_hooks_auth_next__WEBPACK_IMPORTED_MODULE_3__/* .useAuth */ .aC)();
    // rental page should only show rental products
    const ProductCardList = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(()=>{
        if (rentals) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styles__WEBPACK_IMPORTED_MODULE_4__/* .ProductContainer */ .EZ, {
                children: products.map((product, index)=>{
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_byko_component_product_card__WEBPACK_IMPORTED_MODULE_2__/* .ProductRentCard */ .iJ, {
                        addedLabel: "Leiguvara",
                        algoliaInsights: {
                            eventName: "Rent Card Clicked",
                            index: (results === null || results === void 0 ? void 0 : results.index) || "",
                            queryID: (results === null || results === void 0 ? void 0 : results.queryID) || "",
                            objectIDs: [
                                product.id.toString() || ""
                            ],
                            positions: [
                                index + 1
                            ]
                        },
                        listIndex: index,
                        product: product
                    }, product.id);
                })
            });
        }
        // mixed content
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styles__WEBPACK_IMPORTED_MODULE_4__/* .ProductContainer */ .EZ, {
            children: products.map((product, index)=>{
                var _salesAvailability;
                // for debug
                // const salesAvailability: SalesAvailability = "limited";
                const salesAvailability = (_salesAvailability = product.salesAvailability) !== null && _salesAvailability !== void 0 ? _salesAvailability : "standard";
                /*
            "rental": rental products, not sold on web, no price display
            "custom": custom order, not sold on the web, no price display
            "limited": limited availability, not sold on the web, show price info
            "display": display only, not sold on the web, no price display
            "standard": standard products, display as is
            "by_contract": contracted products, only users with contract see price info and can order
          */ if (isRentalProduct(product)) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_byko_component_product_card__WEBPACK_IMPORTED_MODULE_2__/* .ProductRentCard */ .iJ, {
                        addedLabel: "Leiguvara",
                        algoliaInsights: {
                            eventName: "Rent Card Clicked",
                            index: (results === null || results === void 0 ? void 0 : results.index) || "",
                            queryID: (results === null || results === void 0 ? void 0 : results.queryID) || "",
                            objectIDs: [
                                product.id.toString() || ""
                            ],
                            positions: [
                                index + 1
                            ]
                        },
                        listIndex: index,
                        product: product
                    }, product.id);
                } else if (salesAvailability === "by_contract") {
                    if (activeMembership === null || activeMembership === void 0 ? void 0 : activeMembership.account.hasContract) {
                        var ref, ref1;
                        var ref2;
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_byko_component_product_card__WEBPACK_IMPORTED_MODULE_2__/* .ProductStandardCard */ .ZL, {
                            algoliaInsights: {
                                eventName: "Product Card Clicked",
                                index: (results === null || results === void 0 ? void 0 : results.index) || "",
                                queryID: (results === null || results === void 0 ? void 0 : results.queryID) || "",
                                objectIDs: [
                                    ((ref = product.variants) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : ref1.sku) || ""
                                ],
                                positions: [
                                    index + 1
                                ]
                            },
                            analyticsSectionId: "filter-results",
                            listIndex: index,
                            lowestPriceSKU: (prices === null || prices === void 0 ? void 0 : prices[product.id]) !== undefined ? Object.keys((ref2 = prices === null || prices === void 0 ? void 0 : prices[product.id]) !== null && ref2 !== void 0 ? ref2 : {})[0] : undefined,
                            prices: prices === null || prices === void 0 ? void 0 : prices[product.id],
                            product: product
                        }, product.id);
                    } else {
                        var ref3, ref4;
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_byko_component_product_card__WEBPACK_IMPORTED_MODULE_2__/* .ProductDisplayCard */ .MS, {
                            algoliaInsights: {
                                eventName: "Product Card Clicked",
                                index: (results === null || results === void 0 ? void 0 : results.index) || "",
                                queryID: (results === null || results === void 0 ? void 0 : results.queryID) || "",
                                objectIDs: [
                                    ((ref3 = product.variants) === null || ref3 === void 0 ? void 0 : (ref4 = ref3[0]) === null || ref4 === void 0 ? void 0 : ref4.sku) || ""
                                ],
                                positions: [
                                    index + 1
                                ]
                            },
                            listIndex: index,
                            product: product
                        }, product.id);
                    }
                } else if (salesAvailability === "custom") {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_byko_component_product_card__WEBPACK_IMPORTED_MODULE_2__/* .ProductCustomCard */ .yM, {
                        addedLabel: "S\xe9rp\xf6ntun",
                        algoliaInsights: {
                            eventName: "Product Card Clicked",
                            index: (results === null || results === void 0 ? void 0 : results.index) || "",
                            queryID: (results === null || results === void 0 ? void 0 : results.queryID) || "",
                            objectIDs: [
                                product.id.toString() || ""
                            ],
                            positions: [
                                index + 1
                            ]
                        },
                        listIndex: index,
                        product: product
                    }, product.id);
                } else if (salesAvailability === "limited") {
                    var ref5;
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_byko_component_product_card__WEBPACK_IMPORTED_MODULE_2__/* .ProductLimitedCard */ .Md, {
                        algoliaInsights: {
                            eventName: "Product Card Clicked",
                            index: (results === null || results === void 0 ? void 0 : results.index) || "",
                            queryID: (results === null || results === void 0 ? void 0 : results.queryID) || "",
                            objectIDs: [
                                product.id.toString() || ""
                            ],
                            positions: [
                                index + 1
                            ]
                        },
                        analyticsSectionId: "filter-results",
                        listIndex: index,
                        lowestPriceSKU: (prices === null || prices === void 0 ? void 0 : prices[product.id]) !== undefined ? Object.keys((ref5 = prices === null || prices === void 0 ? void 0 : prices[product.id]) !== null && ref5 !== void 0 ? ref5 : {})[0] : undefined,
                        prices: prices === null || prices === void 0 ? void 0 : prices[product.id],
                        product: product
                    }, product.id);
                } else if (salesAvailability === "display") {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_byko_component_product_card__WEBPACK_IMPORTED_MODULE_2__/* .ProductDisplayCard */ .MS, {
                        algoliaInsights: {
                            eventName: "Product Card Clicked",
                            index: (results === null || results === void 0 ? void 0 : results.index) || "",
                            queryID: (results === null || results === void 0 ? void 0 : results.queryID) || "",
                            objectIDs: [
                                product.id.toString() || ""
                            ],
                            positions: [
                                index + 1
                            ]
                        },
                        listIndex: index,
                        product: product
                    }, product.id);
                // Standard product
                } else {
                    var ref6;
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_byko_component_product_card__WEBPACK_IMPORTED_MODULE_2__/* .ProductStandardCard */ .ZL, {
                        algoliaInsights: {
                            eventName: "Product Card Clicked",
                            index: (results === null || results === void 0 ? void 0 : results.index) || "",
                            queryID: (results === null || results === void 0 ? void 0 : results.queryID) || "",
                            objectIDs: [
                                product.id.toString() || ""
                            ],
                            positions: [
                                index + 1
                            ]
                        },
                        analyticsSectionId: "filter-results",
                        listIndex: index,
                        lowestPriceSKU: (prices === null || prices === void 0 ? void 0 : prices[product.id]) !== undefined ? Object.keys((ref6 = prices === null || prices === void 0 ? void 0 : prices[product.id]) !== null && ref6 !== void 0 ? ref6 : {})[0] : undefined,
                        prices: prices === null || prices === void 0 ? void 0 : prices[product.id],
                        product: product
                    }, product.id);
                }
            })
        });
    }, [
        activeMembership === null || activeMembership === void 0 ? void 0 : activeMembership.account.hasContract,
        prices,
        products,
        rentals,
        results === null || results === void 0 ? void 0 : results.index,
        results === null || results === void 0 ? void 0 : results.queryID
    ]);
    return ProductCardList;
}
function isRentalProduct(product) {
    let isRental = false;
    try {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        isRental = product.attributes.typeParent.includes("Leigumarka\xf0ur");
        if (!isRental) {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            isRental = product.attributes.typeParent[0]["is-IS"] === "Leigumarka\xf0ur";
        }
    } catch (e) {
    // silent
    }
    return isRental;
}


/***/ }),

/***/ 94157:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ product_search_results; },
  "productHitCountState": function() { return /* binding */ productHitCountState; }
});

// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(61261);
// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(91987);
// EXTERNAL MODULE: ../../.yarn/__virtual__/next-virtual-cff1f1d108/0/cache/next-npm-13.0.0-0d765f7d5e-7b5c847287.zip/node_modules/next/router.js
var next_router = __webpack_require__(87347);
// EXTERNAL MODULE: ../../.yarn/__virtual__/styled-components-virtual-29066d9421/0/cache/styled-components-npm-5.3.5-88e3937b59-05a664dfe4.zip/node_modules/styled-components/dist/styled-components.browser.cjs.js
var styled_components_browser_cjs = __webpack_require__(33982);
// EXTERNAL MODULE: ../../.yarn/cache/lodash-npm-4.17.21-6382451519-eb835a2e51.zip/node_modules/lodash/lodash.js
var lodash = __webpack_require__(35735);
// EXTERNAL MODULE: ../../.yarn/__virtual__/react-use-virtual-6cd4a83c3e/0/cache/react-use-npm-17.4.0-0ef4521544-0889da919b.zip/node_modules/react-use/esm/useThrottle.js + 1 modules
var useThrottle = __webpack_require__(78159);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/react-use-virtual-6cd4a83c3e/0/cache/react-use-npm-17.4.0-0ef4521544-0889da919b.zip/node_modules/react-use/esm/useFirstMountState.js

function useFirstMountState() {
    var isFirst = (0,react.useRef)(true);
    if (isFirst.current) {
        isFirst.current = false;
        return true;
    }
    return isFirst.current;
}

;// CONCATENATED MODULE: ../../.yarn/__virtual__/react-use-virtual-6cd4a83c3e/0/cache/react-use-npm-17.4.0-0ef4521544-0889da919b.zip/node_modules/react-use/esm/useUpdateEffect.js


var useUpdateEffect = function (effect, deps) {
    var isFirstMount = useFirstMountState();
    (0,react.useEffect)(function () {
        if (!isFirstMount) {
            return effect();
        }
    }, deps);
};
/* harmony default export */ var esm_useUpdateEffect = (useUpdateEffect);

// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-component-select-virtual-f6511e8fae/1/packages/component-select/src/index.ts + 6 modules
var src = __webpack_require__(388);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-lib-utils-virtual-08ae943915/1/packages/lib-utils/src/index.ts + 19 modules
var lib_utils_src = __webpack_require__(65582);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-lib-recoil-virtual-ff20ed22cf/1/packages/lib-recoil/src/index.js
var lib_recoil_src = __webpack_require__(27105);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-lib-api-products-virtual-81752d2989/1/packages/lib-api-products/src/index.ts + 130 modules
var lib_api_products_src = __webpack_require__(68825);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-lib-algolia-virtual-7767b18cc0/1/packages/lib-algolia/src/index.ts + 7 modules
var lib_algolia_src = __webpack_require__(5283);
// EXTERNAL MODULE: ./src/features/search/components/filters/facets-bar.tsx
var facets_bar = __webpack_require__(83524);
// EXTERNAL MODULE: ./src/features/search/components/pagination-menu.tsx
var pagination_menu = __webpack_require__(22772);
// EXTERNAL MODULE: ./src/features/search/components/filter-header.tsx
var filter_header = __webpack_require__(67077);
// EXTERNAL MODULE: ./src/features/search/context.tsx
var context = __webpack_require__(36430);
// EXTERNAL MODULE: ./src/features/search/api.ts
var api = __webpack_require__(85101);
// EXTERNAL MODULE: ./src/features/search/components/styles.ts
var styles = __webpack_require__(71614);
// EXTERNAL MODULE: ./src/features/search/conf.ts
var conf = __webpack_require__(56170);
// EXTERNAL MODULE: ./src/features/search/components/product-list.tsx
var product_list = __webpack_require__(63839);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-hooks-auth-next-virtual-a089da2ab7/1/packages/hooks-auth-next/src/index.ts + 14 modules
var hooks_auth_next_src = __webpack_require__(68814);
;// CONCATENATED MODULE: ./src/features/search/components/product-search-results.tsx
/* eslint-disable react-perf/jsx-no-new-object-as-prop */ function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    const data = _taggedTemplateLiteral([
        "\n  width: 296px;\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _taggedTemplateLiteral([
        "\n  width: fit-content;\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: space-between;\n  margin-top: 56px;\n  gap: 24px;\n"
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}




















const SelectContainer = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-8c3ff7f9-0"
})(_templateObject());
const PaginationContainer = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-8c3ff7f9-1"
})(_templateObject1());
const FooterWrapper = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-8c3ff7f9-2"
})(_templateObject2());
const productHitCountState = (0,lib_recoil_src/* atom */.cn)({
    key: "product-search-hit-count",
    default: 0
});
const resultsOptions = [
    {
        value: 24,
        label: "24 v\xf6rur \xe1 s\xed\xf0u"
    },
    {
        value: 48,
        label: "48 v\xf6rur \xe1 s\xed\xf0u"
    },
    {
        value: 96,
        label: "96 v\xf6rur \xe1 s\xed\xf0u"
    }
];
function ResultsFooter(param) {
    let { pathname , query  } = param;
    const { searchResults , page , pageSize , setPageSize  } = (0,context/* useProductSearch */.ty)();
    const resultsOptionsMap = (0,lodash.fromPairs)(resultsOptions.map((o)=>[
            o.value,
            o
        ]));
    const handlePageSizeChange = (0,react.useCallback)((changes)=>{
        var ref;
        setPageSize((ref = changes.selectedItem) === null || ref === void 0 ? void 0 : ref.value);
    }, [
        setPageSize
    ]);
    const itemToString = (0,react.useCallback)((item)=>{
        return (item === null || item === void 0 ? void 0 : item.label) || "";
    }, []);
    if (!searchResults || searchResults.nbHits <= pageSize) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(FooterWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectContainer, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* Select */.P, {
                    handleSelectedItemChange: handlePageSizeChange,
                    // icon={LayoutMasonryFillIcon}
                    items: resultsOptions,
                    itemToString: itemToString,
                    placeholder: "Fj\xf6ldi vara \xe1 s\xed\xf0u",
                    selectedItem: resultsOptionsMap[pageSize]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PaginationContainer, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(pagination_menu/* default */.Z, {
                    maxPage: searchResults === null || searchResults === void 0 ? void 0 : searchResults.nbPages,
                    page: page,
                    pathname: pathname,
                    query: query
                })
            })
        ]
    });
}
const ProductSearchResults = (param)=>{
    let { categoryId , initialData , query , pathname , rentals , disabled  } = param;
    var ref;
    const setProductHitCount = (0,lib_recoil_src/* useSetRecoilState */.Zl)(productHitCountState);
    const router = (0,next_router.useRouter)();
    const { setLastAlgoliaParamters  } = (0,lib_algolia_src/* useAlgoliaInsights */.HX)();
    const { activeMembership  } = (0,hooks_auth_next_src/* useAuth */.aC)();
    var ref1;
    /* prettier-ignore */ const q = (0,lodash.pickBy)((0,lodash.mapValues)((ref1 = router === null || router === void 0 ? void 0 : router.query) !== null && ref1 !== void 0 ? ref1 : query, (v)=>(0,lib_utils_src/* ensureList */.fL)(v).join(",")));
    const page = parseInt(q["page"] || "1", 10);
    const pageSize = parseInt(q["pageSize"] || "".concat(conf/* DEFAULT_PAGE_SIZE */.L8), 10);
    const value = (0,useThrottle/* default */.Z)(q["q"], 500);
    const { data: results , isLoading  } = (0,api/* useAlgoliaProductQuery */.zC)({
        categoryId,
        sortBy: q["sort"],
        query: value,
        page,
        pageSize,
        filters: (0,api/* compileAlgoliaProductFilters */.Vp)(q)
    }, initialData);
    const products = (0,lib_utils_src/* ensureList */.fL)(results === null || results === void 0 ? void 0 : results.hits.map(lib_api_products_src/* algoliaHitToProduct */.Qo));
    const pricedProducts = products === null || products === void 0 ? void 0 : products.filter((p)=>{
        return !(p.salesAvailability === "custom" || p.salesAvailability === "display" || (0,product_list/* isRentalProduct */.o)(p) || !(activeMembership === null || activeMembership === void 0 ? void 0 : activeMembership.account.hasContract) && p.salesAvailability === "by_contract");
    }).map((p)=>p.id);
    const { prices  } = (0,lib_api_products_src/* useProductLowestPrices */.BY)(rentals ? [] : pricedProducts);
    (0,react.useEffect)(()=>{
        var ref;
        setProductHitCount((ref = results === null || results === void 0 ? void 0 : results.nbHits) !== null && ref !== void 0 ? ref : 0);
    }, [
        results === null || results === void 0 ? void 0 : results.nbHits,
        setProductHitCount
    ]);
    esm_useUpdateEffect(()=>{
        var ref, ref1;
        setLastAlgoliaParamters({
            index: (ref = results === null || results === void 0 ? void 0 : results.index) !== null && ref !== void 0 ? ref : "",
            queryID: (ref1 = results === null || results === void 0 ? void 0 : results.queryID) !== null && ref1 !== void 0 ? ref1 : ""
        });
    }, [
        results === null || results === void 0 ? void 0 : results.index,
        results === null || results === void 0 ? void 0 : results.queryID
    ]);
    if (disabled) return null;
    var ref2, ref3;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(context/* ProductSearchProvider */.io, {
        query: query,
        results: results,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* SceneContainer */._9, {
            smallerTopPadding: true,
            flexDirection: "row",
            offsetNav: true,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(filter_header/* FilterHeader */.Y, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* ProductsContainer */.$6, {
                    children: [
                        !(results === null || results === void 0 ? void 0 : (ref = results.hits) === null || ref === void 0 ? void 0 : ref.length) && !isLoading && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                            children: "Engar v\xf6rur fundust"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(product_list/* ProductResultsList */.i, {
                            prices: prices,
                            products: products,
                            rentals: rentals,
                            results: results
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ResultsFooter, {
                            pathname: (ref2 = router === null || router === void 0 ? void 0 : router.pathname) !== null && ref2 !== void 0 ? ref2 : pathname,
                            query: (ref3 = router === null || router === void 0 ? void 0 : router.query) !== null && ref3 !== void 0 ? ref3 : query
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* FacetsContainer */.pV, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(facets_bar/* default */.Z, {})
                })
            ]
        })
    });
};
/* harmony default export */ var product_search_results = (ProductSearchResults);


/***/ }),

/***/ 71614:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$6": function() { return /* binding */ ProductsContainer; },
/* harmony export */   "EZ": function() { return /* binding */ ProductContainer; },
/* harmony export */   "_9": function() { return /* binding */ SceneContainer; },
/* harmony export */   "pV": function() { return /* binding */ FacetsContainer; }
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(33982);
/* harmony import */ var _byko_component_page_container__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(53000);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    const data = _taggedTemplateLiteral([
        "\n  display: grid;\n  width: 100%;\n  max-width: 1780px;\n  justify-content: center;\n  ",
        '\n  margin-right: auto;\n  margin-left: auto;\n  gap: 8px;\n  grid-template-areas:\n    "chip-row chip-row"\n    "filter-header filters"\n    "products filters";\n\n  grid-template-rows: auto auto 1fr;\n'
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _taggedTemplateLiteral([
        "\n  grid-area: products;\n  @media screen and (min-width: 896px) {\n  }\n  @media screen and (min-width: 1180px) {\n    width: 672px;\n  }\n  @media screen and (min-width: 1694px) {\n    width: 1016px;\n  }\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = _taggedTemplateLiteral([
        "\n  grid-area: filters;\n  @media screen and (max-width: 895px) {\n    display: none;\n  }\n"
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = _taggedTemplateLiteral([
        "\n  display: flex;\n  width: 100%;\n  flex-wrap: wrap;\n  gap: 16px;\n  @media screen and (max-width: 896px) {\n    justify-content: center;\n  }\n  @media screen and (min-width: 896px) {\n  }\n  @media screen and (min-width: 1180px) {\n  }\n  @media screen and (min-width: 1694px) {\n  }\n"
    ]);
    _templateObject3 = function() {
        return data;
    };
    return data;
}


const SceneContainer = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__["default"])(_byko_component_page_container__WEBPACK_IMPORTED_MODULE_0__/* .PageContainer */ ._).withConfig({
    componentId: "sc-f4af94d7-0"
})(_templateObject(), (param)=>{
    let { smallerTopPadding  } = param;
    return smallerTopPadding && "padding-top: 44px;";
});
const ProductsContainer = styled_components__WEBPACK_IMPORTED_MODULE_1__["default"].div.withConfig({
    componentId: "sc-f4af94d7-1"
})(_templateObject1());
const FacetsContainer = styled_components__WEBPACK_IMPORTED_MODULE_1__["default"].div.withConfig({
    componentId: "sc-f4af94d7-2"
})(_templateObject2());
const ProductContainer = styled_components__WEBPACK_IMPORTED_MODULE_1__["default"].div.withConfig({
    componentId: "sc-f4af94d7-3"
})(_templateObject3());


/***/ }),

/***/ 56170:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$h": function() { return /* binding */ API_KEY; },
/* harmony export */   "AF": function() { return /* binding */ APP_ID; },
/* harmony export */   "IV": function() { return /* binding */ FACET_NAME_OVERRIDES; },
/* harmony export */   "L8": function() { return /* binding */ DEFAULT_PAGE_SIZE; },
/* harmony export */   "OX": function() { return /* binding */ PRICE_PATH; },
/* harmony export */   "PG": function() { return /* binding */ FACET_UNIT_OVERRIDES; },
/* harmony export */   "Tt": function() { return /* binding */ PRODUCT_SORT_OPTIONS_MAP; },
/* harmony export */   "Zi": function() { return /* binding */ RANGE_FACETS; },
/* harmony export */   "h6": function() { return /* binding */ SEARCH_INDEXES; },
/* harmony export */   "rs": function() { return /* binding */ PRODUCT_SORT_OPTIONS; }
/* harmony export */ });
/* unused harmony exports envPrefix, PRODUCT_DEFAULT_SORTING */
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(35735);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _byko_lib_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(65582);


const envPrefix = (0,_byko_lib_utils__WEBPACK_IMPORTED_MODULE_1__/* .getBykoConfig */ .Hp)("ALGOLIA_ENV_PREFIX");
const APP_ID = (0,_byko_lib_utils__WEBPACK_IMPORTED_MODULE_1__/* .getBykoConfig */ .Hp)("ALGOLIA_APP_ID");
const API_KEY = (0,_byko_lib_utils__WEBPACK_IMPORTED_MODULE_1__/* .getBykoConfig */ .Hp)("ALGOLIA_API_KEY");
const PRODUCT_DEFAULT_SORTING = "new";
const PRODUCT_SORT_OPTIONS = [
    {
        value: "",
        label: "Ra\xf0a eftir"
    },
    {
        value: "popular",
        label: "Vins\xe6lt"
    },
    {
        value: "new",
        label: "N\xfdjast efst"
    },
    {
        value: "price_desc",
        label: "D\xfdrast efst"
    },
    {
        value: "price_asc",
        label: "\xd3d\xfdrast efst"
    },
    {
        value: "sku",
        label: "V\xf6run\xfamer"
    }
];
const PRODUCT_SORT_OPTIONS_MAP = (0,lodash__WEBPACK_IMPORTED_MODULE_0__.fromPairs)(PRODUCT_SORT_OPTIONS.map((o)=>[
        o.value,
        o
    ]));
const DEFAULT_PAGE_SIZE = 24;
const SEARCH_INDEXES = {
    products: "".concat(envPrefix, "_products"),
    content: "".concat(envPrefix, "_content"),
    employees: "".concat(envPrefix, "_employees")
};
const PRICE_PATH = "variants.price.gross";
const RANGE_FACETS = [
    PRICE_PATH
];
const FACET_NAME_OVERRIDES = {
    categories: "V\xf6ruflokkar",
    "attributes.brand": "V\xf6rumerki",
    "attributes.type": "Tegund",
    "attributes.typeParent": "Yfirtegund",
    "attributes.environmentalInfo": "Umhverfisuppl\xfdsingar",
    [PRICE_PATH]: "Ver\xf0bil"
};
const FACET_UNIT_OVERRIDES = {
    [PRICE_PATH]: "kr."
};


/***/ }),

/***/ 36430:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "io": function() { return /* binding */ ProductSearchProvider; },
/* harmony export */   "ty": function() { return /* binding */ useProductSearch; }
/* harmony export */ });
/* unused harmony export SearchContext */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(61261);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(35735);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87347);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var query_string__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(46757);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(91987);
/* harmony import */ var _byko_lib_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(65582);
/* harmony import */ var _context_common__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(37107);
/* harmony import */ var _api__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(85101);
/* harmony import */ var _conf__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(56170);
/* eslint-disable
  react/jsx-sort-props,
  react-perf/jsx-no-new-function-as-prop,
  react-perf/jsx-no-new-array-as-prop,
  react/jsx-no-bind,
  @typescript-eslint/ban-ts-comment,
  react-perf/jsx-no-new-object-as-prop */ 








const SearchContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_4__.createContext)({});
function ProductSearchProvider(param) {
    let { query , results , attrNameMap , children , activeCategorySlug  } = param;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8;
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    const { categories: allCategories  } = (0,_context_common__WEBPACK_IMPORTED_MODULE_6__/* .useCommonContext */ .I)();
    var ref9;
    /* prettier-ignore */ const queryParams = (0,lodash__WEBPACK_IMPORTED_MODULE_1__.pickBy)((0,lodash__WEBPACK_IMPORTED_MODULE_1__.mapValues)((ref9 = router === null || router === void 0 ? void 0 : router.query) !== null && ref9 !== void 0 ? ref9 : query, (v)=>(0,lodash__WEBPACK_IMPORTED_MODULE_1__.flatMap)((0,_byko_lib_utils__WEBPACK_IMPORTED_MODULE_5__/* .ensureList */ .fL)(v !== null && v !== void 0 ? v : ""), (i)=>i.split(","))));
    const facetNames = (0,react__WEBPACK_IMPORTED_MODULE_4__.useMemo)(()=>({
            ..._conf__WEBPACK_IMPORTED_MODULE_8__/* .FACET_NAME_OVERRIDES */ .IV,
            ...(0,lodash__WEBPACK_IMPORTED_MODULE_1__.mapKeys)(attrNameMap !== null && attrNameMap !== void 0 ? attrNameMap : {}, (_, k)=>"attributes.".concat(k))
        }), [
        attrNameMap
    ]);
    const facets = (0,_api__WEBPACK_IMPORTED_MODULE_7__/* .compileFacets */ .v4)(results, allCategories, queryParams, facetNames, activeCategorySlug);
    const facetOrder = results === null || results === void 0 ? void 0 : (ref = results.renderingContent) === null || ref === void 0 ? void 0 : (ref1 = ref.facetOrdering) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.facets) === null || ref2 === void 0 ? void 0 : ref2.order;
    const facetOrderValues = results === null || results === void 0 ? void 0 : (ref3 = results.renderingContent) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.facetOrdering) === null || ref4 === void 0 ? void 0 : ref4.values;
    if (((ref5 = facets.categories) === null || ref5 === void 0 ? void 0 : ref5.options.length) < 2) {
        // @ts-ignore
        delete facets.categories;
    }
    const activeFilters = (0,_api__WEBPACK_IMPORTED_MODULE_7__/* .compileActiveFilters */ .Ke)(facets);
    const page = parseInt(((ref6 = queryParams["page"]) === null || ref6 === void 0 ? void 0 : ref6[0]) || "1", 10);
    const pageSize = parseInt(((ref7 = queryParams["pageSize"]) === null || ref7 === void 0 ? void 0 : ref7[0]) || "".concat(_conf__WEBPACK_IMPORTED_MODULE_8__/* .DEFAULT_PAGE_SIZE */ .L8), 10);
    var ref10;
    const searchQuery = ((ref10 = queryParams === null || queryParams === void 0 ? void 0 : (ref8 = queryParams["q"]) === null || ref8 === void 0 ? void 0 : ref8["0"]) !== null && ref10 !== void 0 ? ref10 : "").toString();
    const commitFilterQueryParams = (0,react__WEBPACK_IMPORTED_MODULE_4__.useCallback)((filterParams)=>{
        const nextQueryParams = {
            ...queryParams,
            ...filterParams
        };
        delete nextQueryParams["page"];
        const q = (0,lodash__WEBPACK_IMPORTED_MODULE_1__.pickBy)((0,lodash__WEBPACK_IMPORTED_MODULE_1__.mapValues)(nextQueryParams, (v)=>v.join(",")));
        if (activeCategorySlug) {
            q["slug"] = activeCategorySlug;
        }
        router.replace({
            query: q
        }, undefined, {
            shallow: true
        });
    }, [
        activeCategorySlug,
        queryParams,
        router
    ]);
    const updateChoiceFacet = (0,react__WEBPACK_IMPORTED_MODULE_4__.useCallback)((//
    facet, attr, selected)=>{
        const optionValues = {};
        // Populate with current values:
        facet.options.forEach((opt)=>{
            optionValues["".concat(opt.value)] = opt.active;
        });
        // Override with new values:
        Object.assign(optionValues, (0,lodash__WEBPACK_IMPORTED_MODULE_1__.mapKeys)(selected, (_, k)=>"".concat(k)));
        // Only select keys where value is true:
        commitFilterQueryParams({
            [attr]: (0,lodash__WEBPACK_IMPORTED_MODULE_1__.keys)((0,lodash__WEBPACK_IMPORTED_MODULE_1__.pickBy)(optionValues))
        });
    }, [
        commitFilterQueryParams
    ]);
    const clearFilter = (0,react__WEBPACK_IMPORTED_MODULE_4__.useCallback)((activeFilter)=>{
        const optionValues = {};
        // Set the value we're looking for to false:
        activeFilters.map((filter)=>{
            if (filter.attr === activeFilter.attr) {
                optionValues[filter.value] = activeFilter.value !== filter.value;
            }
        });
        // Only select keys where value is true:
        commitFilterQueryParams({
            [activeFilter.attr]: (0,lodash__WEBPACK_IMPORTED_MODULE_1__.keys)((0,lodash__WEBPACK_IMPORTED_MODULE_1__.pickBy)(optionValues))
        });
    }, [
        activeFilters,
        commitFilterQueryParams
    ]);
    const updateRangeFacetValues = (0,react__WEBPACK_IMPORTED_MODULE_4__.useCallback)((facet, attr, param)=>{
        let { min , max  } = param;
        const minV = min === null || (min !== null && min !== void 0 ? min : 0) <= facet.min ? "" : "".concat(min === undefined ? facet.minValue : min);
        const maxV = max === null || facet.max <= (max !== null && max !== void 0 ? max : Infinity) ? "" : "".concat(max === undefined ? facet.maxValue : max);
        commitFilterQueryParams({
            [attr]: minV || maxV ? [
                "".concat(minV, "...").concat(maxV)
            ] : []
        });
    }, [
        commitFilterQueryParams
    ]);
    const updateQueryParams = (0,react__WEBPACK_IMPORTED_MODULE_4__.useCallback)((params)=>{
        if (activeCategorySlug) {
            params["slug"] = activeCategorySlug;
        }
        const search = query_string__WEBPACK_IMPORTED_MODULE_3__.stringify(params, {
            arrayFormat: "comma"
        });
        router.replace({
            search
        }, undefined, {
            shallow: true
        });
    }, [
        router,
        activeCategorySlug
    ]);
    const setSorting = (0,react__WEBPACK_IMPORTED_MODULE_4__.useCallback)((sort)=>{
        updateQueryParams({
            ...queryParams,
            sort
        });
    }, [
        updateQueryParams,
        queryParams
    ]);
    const setPageSize = (0,react__WEBPACK_IMPORTED_MODULE_4__.useCallback)((v)=>{
        delete queryParams["page"];
        updateQueryParams({
            ...queryParams,
            pageSize: v ? "".concat(v) : null
        });
    }, [
        updateQueryParams,
        queryParams
    ]);
    const getSearchQuery = ()=>{
        var ref;
        var ref1;
        return ((ref1 = queryParams === null || queryParams === void 0 ? void 0 : (ref = queryParams["q"]) === null || ref === void 0 ? void 0 : ref["0"]) !== null && ref1 !== void 0 ? ref1 : "").toString();
    };
    const clearAllFilters = (0,react__WEBPACK_IMPORTED_MODULE_4__.useCallback)(()=>{
        commitFilterQueryParams((0,lodash__WEBPACK_IMPORTED_MODULE_1__.fromPairs)(activeFilters.map((f)=>[
                f.attr,
                []
            ])));
    }, [
        commitFilterQueryParams,
        activeFilters
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SearchContext.Provider, {
        value: {
            searchResults: results,
            searchQuery,
            facets,
            activeFilters,
            queryParams,
            page,
            pageSize,
            updateChoiceFacet,
            updateRangeFacetValues,
            clearFilter,
            clearAllFilters,
            setSorting,
            setPageSize,
            facetOrder,
            facetOrderValues
        },
        children: children
    });
}
function useProductSearch() {
    return (0,react__WEBPACK_IMPORTED_MODULE_4__.useContext)(SearchContext);
}


/***/ }),

/***/ 17048:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ _app; }
});

// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(61261);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@apollo-client-virtual-e2a13f3a66/0/cache/@apollo-client-npm-3.7.1-a80032e019-95bb1f226f.zip/node_modules/@apollo/client/utilities/globals/index.js + 4 modules
var globals = __webpack_require__(94896);
// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(91987);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@apollo-client-virtual-e2a13f3a66/0/cache/@apollo-client-npm-3.7.1-a80032e019-95bb1f226f.zip/node_modules/@apollo/client/react/context/ApolloContext.js
var context_ApolloContext = __webpack_require__(26065);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@apollo-client-virtual-e2a13f3a66/0/cache/@apollo-client-npm-3.7.1-a80032e019-95bb1f226f.zip/node_modules/@apollo/client/react/context/ApolloProvider.js



var ApolloProvider = function (_a) {
    var client = _a.client, children = _a.children;
    var ApolloContext = (0,context_ApolloContext/* getApolloContext */.K)();
    return (react.createElement(ApolloContext.Consumer, null, function (context) {
        if (context === void 0) { context = {}; }
        if (client && context.client !== client) {
            context = Object.assign({}, context, { client: client });
        }
        __DEV__ ? (0,globals/* invariant */.kG)(context.client, 'ApolloProvider was not passed a client instance. Make ' +
            'sure you pass in your client via the "client" prop.') : (0,globals/* invariant */.kG)(context.client, 28);
        return (react.createElement(ApolloContext.Provider, { value: context }, children));
    }));
};
//# sourceMappingURL=ApolloProvider.js.map
// EXTERNAL MODULE: ../../.yarn/__virtual__/next-virtual-cff1f1d108/0/cache/next-npm-13.0.0-0d765f7d5e-7b5c847287.zip/node_modules/next/dynamic.js
var dynamic = __webpack_require__(89976);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./src/use-lightbox.tsx
var use_lightbox = __webpack_require__(52989);
;// CONCATENATED MODULE: ./src/lightbox.tsx


function LightboxRoot() {
    const { Lightbbox  } = (0,use_lightbox/* default */.ZP)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: Lightbbox
    });
}

// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-component-page-container-virtual-6ffaf0ab98/1/packages/component-page-container/src/index.ts + 1 modules
var src = __webpack_require__(53000);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-lib-api-dato-client-virtual-fc2b9374fc/1/packages/lib-api-dato-client/src/index.ts + 45 modules
var lib_api_dato_client_src = __webpack_require__(42039);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-lib-api-products-virtual-81752d2989/1/packages/lib-api-products/src/index.ts + 130 modules
var lib_api_products_src = __webpack_require__(68825);
// EXTERNAL MODULE: ../../.yarn/__virtual__/next-virtual-cff1f1d108/0/cache/next-npm-13.0.0-0d765f7d5e-7b5c847287.zip/node_modules/next/script.js
var next_script = __webpack_require__(43285);
var script_default = /*#__PURE__*/__webpack_require__.n(next_script);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-hooks-warehouses-virtual-36c76d8d9e/1/packages/hooks-warehouses/src/warehouses-provider.tsx



const WarehouseContext = /*#__PURE__*/ (0,react.createContext)(null);
const useWarehouses = ()=>{
    const data = useContext(WarehouseContext);
    if (!data) {
        throw new Error("Invalid usage of context");
    }
    return data;
};
const WarehousesProvider = (param)=>{
    let { warehouses , children  } = param;
    const script = (0,react.useMemo)(()=>{
        return {
            __html: "window.__BYKO_WAREHOUSES__ = JSON.parse(".concat(JSON.stringify(JSON.stringify(warehouses)), ")")
        };
    }, [
        warehouses
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                dangerouslySetInnerHTML: script,
                id: "byko-warehouses",
                strategy: "beforeInteractive"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(WarehouseContext.Provider, {
                value: warehouses,
                children: children
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-hooks-warehouses-virtual-36c76d8d9e/1/packages/hooks-warehouses/src/categories-provider.tsx




const CategoryContext = /*#__PURE__*/ (0,react.createContext)(null);
const useCategories = ()=>{
    const data = useContext(CategoryContext);
    if (!data) {
        throw new Error("Invalid usage of context");
    }
    return data;
};
const CategoriesProvider = (param)=>{
    let { categories , children  } = param;
    const script = (0,react.useMemo)(()=>{
        return {
            __html: "window.__BYKO_CATEGORIES__ = JSON.parse(".concat(JSON.stringify(JSON.stringify(categories)), ")")
        };
    }, [
        categories
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                dangerouslySetInnerHTML: script,
                id: "byko-categories",
                strategy: "beforeInteractive"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoryContext.Provider, {
                value: categories,
                children: children
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-hooks-warehouses-virtual-36c76d8d9e/1/packages/hooks-warehouses/src/index.ts



// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-lib-api-rest-virtual-a514398bdb/1/packages/lib-api-rest/src/index.ts + 4 modules
var lib_api_rest_src = __webpack_require__(97639);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-lib-recoil-virtual-ff20ed22cf/1/packages/lib-recoil/src/index.js
var lib_recoil_src = __webpack_require__(27105);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-lib-styles-virtual-b3f1d479f2/1/packages/lib-styles/src/index.ts + 18 modules
var lib_styles_src = __webpack_require__(52203);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-lib-algolia-virtual-7767b18cc0/1/packages/lib-algolia/src/index.ts + 7 modules
var lib_algolia_src = __webpack_require__(5283);
// EXTERNAL MODULE: ../../packages/types-utils/src/index.ts + 3 modules
var types_utils_src = __webpack_require__(71612);
// EXTERNAL MODULE: ./src/features/index.ts + 63 modules
var features = __webpack_require__(78247);
;// CONCATENATED MODULE: ./src/config-script.tsx



const ConfigScript = (param)=>{
    let { config  } = param;
    const script = (0,react.useMemo)(()=>{
        return {
            __html: "window.__APP__CONFIG__ = JSON.parse(".concat(JSON.stringify(JSON.stringify(config)), ")")
        };
    }, [
        config
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
        dangerouslySetInnerHTML: script,
        id: "app-settings",
        strategy: "beforeInteractive"
    });
};

;// CONCATENATED MODULE: ./src/const.ts
const SEARCH_ROUTES = [
    "/leit",
    "/vorur"
];

// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-lib-utils-virtual-08ae943915/1/packages/lib-utils/src/index.ts + 19 modules
var lib_utils_src = __webpack_require__(65582);
;// CONCATENATED MODULE: ./src/siteimprov.tsx



const Siteimprov = ()=>{
    const isProd = (0,lib_utils_src/* getBykoConfig */.Hp)("ENV") === "prod";
    const siteimprovKey = (0,lib_utils_src/* getBykoConfig */.Hp)("SITEIMPROV_KEY");
    if (!isProd || !siteimprovKey || siteimprovKey.length === 0) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
        async: true,
        src: "https://siteimproveanalytics.com/js/siteanalyze_".concat(siteimprovKey, ".js")
    });
};

// EXTERNAL MODULE: ./src/style.ts
var style = __webpack_require__(23392);
// EXTERNAL MODULE: ../../.yarn/__virtual__/next-virtual-cff1f1d108/0/cache/next-npm-13.0.0-0d765f7d5e-7b5c847287.zip/node_modules/next/router.js
var next_router = __webpack_require__(87347);
// EXTERNAL MODULE: ./src/features/search-provider/index.tsx
var search_provider = __webpack_require__(18240);
;// CONCATENATED MODULE: ./src/use-loader.ts




const ENABLE_LOADER = true;
const SHOW_LOADER_DELAY_MS = 200;
const HIDE_LOADER_DELAY_MS = 100;
const useLoader = (ref)=>{
    const router = (0,next_router.useRouter)();
    const handleHideLoaderRef = (0,react.useRef)(null);
    const handleShowLoaderRef = (0,react.useRef)(null);
    const previousUrl = (0,lib_utils_src/* usePrevious */.D9)(router === null || router === void 0 ? void 0 : router.pathname);
    const previousUrlRef = (0,react.useRef)(previousUrl);
    previousUrlRef.current = previousUrl;
    const showLoader = (0,react.useCallback)((url)=>{
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        if (window.HIDE_URL === url) {
            return;
        }
        if (previousUrlRef.current && previousUrlRef.current.startsWith("/mitt")) {
            return;
        }
        if (!ref.current || !ENABLE_LOADER) {
            return;
        }
        ref.current.style.opacity = "1";
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const hideLoader = (0,react.useCallback)((url)=>{
        var ref1;
        if (!ref.current || !ENABLE_LOADER) {
            return;
        }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        window.HIDE_URL = url;
        (ref1 = handleShowLoaderRef.current) === null || ref1 === void 0 ? void 0 : ref1.cancel();
        ref.current.style.opacity = "0";
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const handleShowLoader = (0,lib_utils_src/* useDebounce */.Nr)(showLoader, SHOW_LOADER_DELAY_MS);
    const handleHideLoader = (0,lib_utils_src/* useDebounce */.Nr)(hideLoader, HIDE_LOADER_DELAY_MS);
    handleShowLoaderRef.current = handleShowLoader;
    handleHideLoaderRef.current = handleHideLoader;
    (0,react.useEffect)(()=>{
        if (!(router === null || router === void 0 ? void 0 : router.events) || !router.isReady) {
            return ()=>{
            // Empty on purpose
            };
        }
        router.events.on("routeChangeComplete", handleHideLoader);
        router.events.on("routeChangeError", handleHideLoader);
        router.events.on("routeChangeStart", handleShowLoader);
        return ()=>{
            router.events.off("routeChangeComplete", handleHideLoader);
            router.events.off("routeChangeError", handleHideLoader);
            router.events.off("routeChangeStart", handleShowLoader);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
};
const useLoaderClearSearch = (param)=>{
    let { searchRoutes  } = param;
    const setSearch = (0,search_provider/* useSetSearchValue */.hp)();
    const handleClearSearch = (0,react.useCallback)((url)=>{
        for (const route of searchRoutes){
            if (url.startsWith(route)) {
                return;
            }
        }
        setSearch("");
    }, [
        searchRoutes,
        setSearch
    ]);
    const handleClearSearchRef = (0,react.useRef)(handleClearSearch);
    handleClearSearchRef.current = handleClearSearch;
    const router = (0,next_router.useRouter)();
    (0,react.useEffect)(()=>{
        if (!(router === null || router === void 0 ? void 0 : router.events) || !router.isReady) {
            return ()=>{
            // Empty on purpose
            };
        }
        router.events.on("routeChangeComplete", handleClearSearch);
        return ()=>{
            router.events.off("routeChangeComplete", handleClearSearch);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
};
const ClearSearchOnPageLoad = (param)=>{
    let { searchRoutes  } = param;
    useLoaderClearSearch({
        searchRoutes
    });
    return null;
};

// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-component-buttons-virtual-1a577fdc8c/1/packages/component-buttons/src/index.ts + 16 modules
var component_buttons_src = __webpack_require__(80620);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-component-typography-virtual-537720fdd1/1/packages/component-typography/src/index.ts + 2 modules
var component_typography_src = __webpack_require__(91371);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-lib-icons-virtual-412b14e947/1/packages/lib-icons/src/index.ts + 181 modules
var lib_icons_src = __webpack_require__(45628);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-lib-images-virtual-95769406cb/1/packages/lib-images/src/index.ts + 5 modules
var lib_images_src = __webpack_require__(63930);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-lib-dato-virtual-5a00219d6f/1/packages/lib-dato/src/index.ts + 25 modules
var lib_dato_src = __webpack_require__(39452);
// EXTERNAL MODULE: ../../.yarn/__virtual__/styled-components-virtual-29066d9421/0/cache/styled-components-npm-5.3.5-88e3937b59-05a664dfe4.zip/node_modules/styled-components/dist/styled-components.browser.cjs.js
var styled_components_browser_cjs = __webpack_require__(33982);
;// CONCATENATED MODULE: ./src/features/footer/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    const data = _taggedTemplateLiteral([
        "\n  display: grid;\n  width: 100%;\n  max-width: ",
        'px;\n  height: 352px;\n  justify-content: space-between;\n  padding: 80px 0;\n  margin: 0 auto;\n  gap: 20px;\n  grid-template-areas:\n    "logo openinghours social happyscale"\n    "logo openinghours links happyscale";\n  transition: all 0.5s;\n  p {\n    color: ',
        ";\n  }\n  @media screen and (max-width: ",
        'px) {\n    height: unset;\n    align-items: flex-start;\n    justify-content: center;\n    padding: 48px 5%;\n    grid-template-areas:\n      "logo"\n      "social"\n      "openinghours"\n      "links"\n      "happyscale";\n    row-gap: 57px;\n  }\n'
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _taggedTemplateLiteral([
        "\n  height: fit-content;\n  margin: 0 auto;\n  grid-area: logo;\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  grid-area: openinghours;\n  ",
        " {\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  gap: 27px;\n  h6 {\n    font-weight: 400;\n  }\n  @media screen and (max-width: ",
        "px) {\n    h6 {\n      font-size: 16px;\n    }\n  }\n  svg {\n    margin-bottom: 8px;\n  }\n"
    ]);
    _templateObject3 = function() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = _taggedTemplateLiteral([
        "\n  display: flex;\n  width: 100%;\n  align-items: center;\n  gap: 20px;\n  grid-area: social;\n"
    ]);
    _templateObject4 = function() {
        return data;
    };
    return data;
}
function _templateObject5() {
    const data = _taggedTemplateLiteral([
        ""
    ]);
    _templateObject5 = function() {
        return data;
    };
    return data;
}
function _templateObject6() {
    const data = _taggedTemplateLiteral([
        "\n  display: flex;\n  height: 100%;\n  flex-direction: column;\n  justify-content: flex-end;\n  color: inherit;\n  gap: 20px;\n  grid-area: links;\n"
    ]);
    _templateObject6 = function() {
        return data;
    };
    return data;
}
function _templateObject7() {
    const data = _taggedTemplateLiteral([
        "\n  margin: auto;\n  grid-area: happyscale;\n"
    ]);
    _templateObject7 = function() {
        return data;
    };
    return data;
}



const FooterContainer = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-4ce2559b-0"
})(_templateObject(), lib_styles_src/* gridTheme.container.minWidth.lg */.k.container.minWidth.lg, lib_styles_src/* theme.palette.white.main */.rS.palette.white.main, lib_styles_src/* gridTheme.container.maxWidth.sm */.k.container.maxWidth.sm);
const LogoWrapper = styled_components_browser_cjs["default"].a.withConfig({
    componentId: "sc-4ce2559b-1"
})(_templateObject1());
const LargeLinkWrapper = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-4ce2559b-2"
})(_templateObject2(), component_typography_src.H6, lib_styles_src/* theme.palette.white.main */.rS.palette.white.main);
const LargeLinks = styled_components_browser_cjs["default"].a.withConfig({
    componentId: "sc-4ce2559b-3"
})(_templateObject3(), lib_styles_src/* gridTheme.container.maxWidth.xs */.k.container.maxWidth.xs);
const SocialMediaIconWrapper = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-4ce2559b-4"
})(_templateObject4());
const SocialMediaIcon = styled_components_browser_cjs["default"].a.withConfig({
    componentId: "sc-4ce2559b-5"
})(_templateObject5());
const FooterLink = styled_components_browser_cjs["default"].span.withConfig({
    componentId: "sc-4ce2559b-6"
})(_templateObject6());
const HappyScaleWrapper = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-4ce2559b-7"
})(_templateObject7());

;// CONCATENATED MODULE: ./src/features/footer/footer-bottom/styles.ts
function styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function styles_templateObject() {
    const data = styles_taggedTemplateLiteral([
        "\n  display: flex;\n  width: 100%;\n  max-width: ",
        "px;\n  height: 80px;\n  align-items: center;\n  justify-content: space-between;\n  margin: 0 auto;\n  color: ",
        ";\n  gap: 100px;\n  @media screen and (max-width: ",
        "px) {\n    gap: 50px;\n  }\n  @media screen and (max-width: ",
        "px) {\n    height: 120px;\n  }\n"
    ]);
    styles_templateObject = function() {
        return data;
    };
    return data;
}
function styles_templateObject1() {
    const data = styles_taggedTemplateLiteral([
        "\n  display: flex;\n  min-width: 400px;\n  justify-content: space-between;\n  @media screen and (max-width: ",
        "px) {\n    width: fit-content;\n    min-width: unset;\n  }\n  @media screen and (max-width: ",
        "px) {\n    display: none;\n  }\n"
    ]);
    styles_templateObject1 = function() {
        return data;
    };
    return data;
}
function styles_templateObject2() {
    const data = styles_taggedTemplateLiteral([
        "\n  display: flex;\n  width: 100%;\n  justify-content: space-between;\n  font-size: 18px;\n  @media screen and (max-width: ",
        "px) {\n    font-size: 14px;\n  }\n  @media screen and (max-width: ",
        "px) {\n    flex-direction: column;\n    font-size: 16px;\n    gap: 20px;\n    text-align: left;\n  }\n"
    ]);
    styles_templateObject2 = function() {
        return data;
    };
    return data;
}
function styles_templateObject3() {
    const data = styles_taggedTemplateLiteral([
        "\n  &::selection {\n    background-color: ",
        ";\n  }\n"
    ]);
    styles_templateObject3 = function() {
        return data;
    };
    return data;
}
function styles_templateObject4() {
    const data = styles_taggedTemplateLiteral([
        "\n  display: flex;\n  width: 100%;\n  justify-content: space-around;\n  color: ",
        ";\n"
    ]);
    styles_templateObject4 = function() {
        return data;
    };
    return data;
}
function styles_templateObject5() {
    const data = styles_taggedTemplateLiteral([
        "\n  display: flex;\n  width: 100%;\n  justify-content: space-around;\n"
    ]);
    styles_templateObject5 = function() {
        return data;
    };
    return data;
}
function styles_templateObject6() {
    const data = styles_taggedTemplateLiteral([
        "\n  display: flex;\n  width: 1px;\n  height: 20px;\n  justify-content: center;\n  background-color: ",
        ";\n  @media screen and (min-width: ",
        "px) {\n    display: none;\n  }\n"
    ]);
    styles_templateObject6 = function() {
        return data;
    };
    return data;
}


const BottomFooter = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-844c5cab-0"
})(styles_templateObject(), lib_styles_src/* gridTheme.container.minWidth.lg */.k.container.minWidth.lg, lib_styles_src/* theme.palette.blue.main */.rS.palette.blue.main, lib_styles_src/* gridTheme.container.maxWidth.md */.k.container.maxWidth.md, lib_styles_src/* gridTheme.container.maxWidth.s */.k.container.maxWidth.s);
const ButtonWrapper = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-844c5cab-1"
})(styles_templateObject1(), lib_styles_src/* gridTheme.container.maxWidth.sm */.k.container.maxWidth.sm, lib_styles_src/* gridTheme.container.maxWidth.s */.k.container.maxWidth.s);
const InfoText = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-844c5cab-2"
})(styles_templateObject2(), lib_styles_src/* gridTheme.container.maxWidth.sm */.k.container.maxWidth.sm, lib_styles_src/* gridTheme.container.maxWidth.s */.k.container.maxWidth.s);
const InfoParagraph = styled_components_browser_cjs["default"].p.withConfig({
    componentId: "sc-844c5cab-3"
})(styles_templateObject3(), lib_styles_src/* theme.palette.yellow.main */.rS.palette.yellow.main);
const Location = styled_components_browser_cjs["default"].a.withConfig({
    componentId: "sc-844c5cab-4"
})(styles_templateObject4(), lib_styles_src/* theme.palette.blue.main */.rS.palette.blue.main);
const CompanyDetail = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-844c5cab-5"
})(styles_templateObject5());
const Divider = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-844c5cab-6"
})(styles_templateObject6(), lib_styles_src/* theme.palette.gray.30 */.rS.palette.gray[30], lib_styles_src/* gridTheme.container.maxWidth.s */.k.container.maxWidth.s);

;// CONCATENATED MODULE: ./src/features/footer/footer-bottom/index.tsx








const FooterBottom = ()=>{
    const { activeBreakPoint  } = (0,lib_styles_src/* useWindowSize */.iP)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* PageContainer */._, {
        backgroundColor: lib_styles_src/* theme.palette.white.main */.rS.palette.white.main,
        flexDirection: "row",
        offsetNav: false,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(BottomFooter, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonWrapper, {
                    children: [
                        "s",
                        "sm"
                    ].includes(activeBreakPoint) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(component_buttons_src/* IconButton */.hU, {
                                ariaLabel: "Mitt Byko",
                                icon: lib_icons_src.NotandiIcons
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(component_buttons_src/* IconButton */.hU, {
                                ariaLabel: "Leiga",
                                icon: lib_icons_src.DrillIcons
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(component_buttons_src/* IconButton */.hU, {
                                ariaLabel: "R\xe1\xf0gj\xf6f",
                                icon: lib_icons_src.AdviceIcons
                            })
                        ]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "https://mitt.byko.is/",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(component_buttons_src/* SecondaryButton */.kq, {
                                    blueLine: true,
                                    icon: lib_icons_src.NotandiIcons,
                                    label: "Mitt BYKO"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "https://byko.is/thjonusta/leiga",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(component_buttons_src/* SecondaryButton */.kq, {
                                    blueLine: true,
                                    icon: lib_icons_src.DrillIcons,
                                    label: "Leiga"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "https://byko.is/thjonusta/radgjof-og-thjonusta",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(component_buttons_src/* SecondaryButton */.kq, {
                                    blueLine: true,
                                    icon: lib_icons_src.AdviceIcons,
                                    label: "R\xe1\xf0gj\xf6f"
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(InfoText, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Location, {
                            href: "http://maps.google.com/?q=BYKO skemmuvegi 2a",
                            rel: "noreferrer",
                            target: "_blank",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoParagraph, {
                                    children: " Skemmuvegi 2a "
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider, {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoParagraph, {
                                    children: " 200 K\xf3pavogur "
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider, {})
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(CompanyDetail, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoParagraph, {
                                    children: "Kt. 460169-3219 "
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider, {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoParagraph, {
                                    children: "Vsk.nr. 03394"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider, {})
                            ]
                        })
                    ]
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/features/footer/index.tsx












const Footer = ()=>{
    var ref;
    const { width  } = (0,lib_styles_src/* useWindowSize */.iP)();
    const { data  } = lib_dato_src/* datoQueries.useGetFooterText */.t.useGetFooterText();
    // format phone number from 1234567 to 123 4567
    const formattedPhoneNumber = data === null || data === void 0 ? void 0 : (ref = data.telephoneNumber) === null || ref === void 0 ? void 0 : ref.replace(/(\d{3})(\d{4})/, "$1 $2");
    var ref1, ref2, ref3, ref4, ref5, ref6, ref7;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* PageContainer */._, {
                backgroundColor: lib_styles_src/* theme.palette.blue.main */.rS.palette.blue.main,
                flexDirection: "row",
                offsetNav: false,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(FooterContainer, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(LogoWrapper, {
                            href: "https://byko.is/",
                            rel: "noreferrer",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lib_icons_src.BykoMainLogo, {
                                width: width > lib_styles_src/* gridTheme.breakpoints.sm */.k.breakpoints.sm ? 136 : 220
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(LargeLinkWrapper, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(LargeLinks, {
                                    href: "/thjonusta/um-byko/verslanir-og-afgreidslutimi",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(lib_icons_src.ClockWhiteFilledDecorative, {
                                            size: width > lib_styles_src/* gridTheme.breakpoints.s */.k.breakpoints.s ? 46 : 30
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(component_typography_src.H6, {
                                            children: data === null || data === void 0 ? void 0 : data.labelForOpeningHoursAndStoresLink
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(LargeLinks, {
                                    href: "mailto:".concat((ref1 = data === null || data === void 0 ? void 0 : data.email) !== null && ref1 !== void 0 ? ref1 : "byko@byko.is"),
                                    target: "_blank",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(lib_icons_src.SendMessagesBlueFilledDecorative, {
                                            size: width > lib_styles_src/* gridTheme.breakpoints.s */.k.breakpoints.s ? 46 : 30
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(component_typography_src.H6, {
                                            children: (ref2 = data === null || data === void 0 ? void 0 : data.email) !== null && ref2 !== void 0 ? ref2 : "byko@byko.is"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(LargeLinks, {
                                    href: "tel:+354".concat((ref3 = data === null || data === void 0 ? void 0 : data.telephoneNumber) !== null && ref3 !== void 0 ? ref3 : "5154000"),
                                    target: "_blank",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(lib_icons_src.MobileWhiteFilledDecorative, {
                                            size: width > lib_styles_src/* gridTheme.breakpoints.s */.k.breakpoints.s ? 46 : 30
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(component_typography_src.H6, {
                                            children: formattedPhoneNumber
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(SocialMediaIconWrapper, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SocialMediaIcon, {
                                            href: (ref4 = data === null || data === void 0 ? void 0 : data.instagramLink) !== null && ref4 !== void 0 ? ref4 : "",
                                            target: "_blank",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lib_icons_src.InstagramLineIcons, {
                                                iconColor: lib_styles_src/* theme.palette.white.main */.rS.palette.white.main,
                                                size: 24
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SocialMediaIcon, {
                                            href: (ref5 = data === null || data === void 0 ? void 0 : data.facebookLink) !== null && ref5 !== void 0 ? ref5 : "",
                                            target: "_blank",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lib_icons_src.FacebookSimpleIcons, {
                                                iconColor: lib_styles_src/* theme.palette.white.main */.rS.palette.white.main,
                                                size: 24
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SocialMediaIcon, {
                                            href: (ref6 = data === null || data === void 0 ? void 0 : data.youtubeLink) !== null && ref6 !== void 0 ? ref6 : "",
                                            target: "_blank",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lib_icons_src.YoutubeIcons, {
                                                iconColor: lib_styles_src/* theme.palette.white.main */.rS.palette.white.main,
                                                size: 24
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterLink, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        href: "https://byko.is/skilmalar",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(component_buttons_src/* SecondaryButton */.kq, {
                                            label: (ref7 = data === null || data === void 0 ? void 0 : data.labelForTermsLink) !== null && ref7 !== void 0 ? ref7 : "Skilm\xe1lar"
                                        })
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(HappyScaleWrapper, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lib_images_src/* HappyScale */.jQ, {})
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterBottom, {})
        ]
    });
};

// EXTERNAL MODULE: ../../.yarn/__virtual__/next-virtual-cff1f1d108/0/cache/next-npm-13.0.0-0d765f7d5e-7b5c847287.zip/node_modules/next/link.js
var next_link = __webpack_require__(58804);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ../../.yarn/__virtual__/react-query-virtual-9ac5b1aaa1/0/cache/react-query-npm-3.39.1-7899b170b9-9273b7c2ad.zip/node_modules/react-query/es/index.js
var es = __webpack_require__(85166);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-component-drawer-virtual-d170d66b66/1/packages/component-drawer/src/index.ts + 6 modules
var component_drawer_src = __webpack_require__(58879);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-component-inputs-virtual-052bad3006/1/packages/component-inputs/src/index.ts + 11 modules
var component_inputs_src = __webpack_require__(45535);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-component-login-virtual-81673191b3/1/packages/component-login/src/index.ts + 50 modules
var component_login_src = __webpack_require__(59259);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-hooks-auth-next-virtual-a089da2ab7/1/packages/hooks-auth-next/src/index.ts + 14 modules
var hooks_auth_next_src = __webpack_require__(68814);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-hooks-cart-virtual-97c767eaa3/1/packages/hooks-cart/src/index.ts + 8 modules
var hooks_cart_src = __webpack_require__(93784);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-hooks-megamenu-virtual-38b771122b/1/packages/hooks-megamenu/src/store/open-state.ts

const isOpenState = (0,lib_recoil_src/* atom */.cn)({
    key: "megamenu-open-state",
    default: false
});

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-hooks-megamenu-virtual-38b771122b/1/packages/hooks-megamenu/src/store/menu-content-state.ts

const menuContentState = (0,lib_recoil_src/* atom */.cn)({
    key: "megamenu-content-state",
    // TODO: this hould be an empty array once we connect things
    // only used for demo purposes
    default: []
});

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-hooks-megamenu-virtual-38b771122b/1/packages/hooks-megamenu/src/store/index.ts



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-hooks-megamenu-virtual-38b771122b/1/packages/hooks-megamenu/src/use-megamenu.ts




const useMegamenu = ()=>{
    const [isOpen, setIsOpen] = (0,lib_recoil_src/* useRecoilState */.FV)(isOpenState);
    const { data  } = (0,lib_api_dato_client_src/* useMegaMenuData */.VT)();
    const menuContent = (0,react.useMemo)(()=>data != null ? data : [], [
        data
    ]);
    const filteredMenuContent = (0,react.useMemo)(()=>{
        return menuContent.filter((item)=>item.showInMegamenu);
    }, [
        menuContent
    ]);
    return {
        isOpen,
        setIsOpen,
        menuContent: filteredMenuContent
    };
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-hooks-megamenu-virtual-38b771122b/1/packages/hooks-megamenu/src/index.ts


// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-lib-analytics-virtual-863cade9f6/1/packages/lib-analytics/src/index.ts + 2 modules
var lib_analytics_src = __webpack_require__(57910);
// EXTERNAL MODULE: ../../.yarn/__virtual__/usehooks-ts-virtual-e376d4cf26/0/cache/usehooks-ts-npm-2.9.1-14c625587f-36f1e4142c.zip/node_modules/usehooks-ts/dist/esm/index.js + 36 modules
var esm = __webpack_require__(78420);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-hooks-mobile-burger-virtual-954416e043/1/packages/hooks-mobile-burger/src/store/menu-open.ts

const menuOpenState = (0,lib_recoil_src/* atom */.cn)({
    key: "menuOpenState",
    default: false
});

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-hooks-mobile-burger-virtual-954416e043/1/packages/hooks-mobile-burger/src/store/index.ts


;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-hooks-mobile-burger-virtual-954416e043/1/packages/hooks-mobile-burger/src/use-mobile-burger.ts


const useMobileBurger = ()=>{
    const setMenuOpen = (0,lib_recoil_src/* useSetRecoilState */.Zl)(menuOpenState);
    const menuOpen = (0,lib_recoil_src/* useRecoilValue */.sJ)(menuOpenState);
    return {
        setMenuOpen,
        menuOpen
    };
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-hooks-mobile-burger-virtual-954416e043/1/packages/hooks-mobile-burger/src/index.ts


;// CONCATENATED MODULE: ./src/features/header/components/dropdown-select/collapsed.ts

const collapsedState = (0,lib_recoil_src/* atom */.cn)({
    key: "collapsed",
    default: true
});

;// CONCATENATED MODULE: ./src/features/header/components/dropdown-select/styles.ts
function dropdown_select_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function dropdown_select_styles_templateObject() {
    const data = dropdown_select_styles_taggedTemplateLiteral([
        "\n  position: relative;\n  z-index: 30;\n  display: flex;\n  width: ",
        ";\n  flex-direction: column;\n  align-items: flex-end;\n"
    ]);
    dropdown_select_styles_templateObject = function() {
        return data;
    };
    return data;
}
function dropdown_select_styles_templateObject1() {
    const data = dropdown_select_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  width: 100%;\n  height: 56px;\n  box-sizing: border-box;\n  align-items: center;\n  justify-content: space-between;\n  padding-right: 24px;\n  padding-left: 24px;\n  background-color: ",
        ";\n  cursor: pointer;\n  outline: 1px solid ",
        ";\n  transition: 0.3s;\n  .active-name {\n    transition: 0.3s;\n  }\n  &:hover {\n    background-color: ",
        ";\n    .active-name {\n      color: ",
        ";\n    }\n  }\n  &:focus {\n    outline: 1px solid ",
        ";\n  }\n"
    ]);
    dropdown_select_styles_templateObject1 = function() {
        return data;
    };
    return data;
}
function dropdown_select_styles_templateObject2() {
    const data = dropdown_select_styles_taggedTemplateLiteral([
        "\n  color: ",
        ";\n  font-size: 16;\n  font-weight: 400;\n"
    ]);
    dropdown_select_styles_templateObject2 = function() {
        return data;
    };
    return data;
}
function dropdown_select_styles_templateObject3() {
    const data = dropdown_select_styles_taggedTemplateLiteral([
        "\n  display: grid;\n  width: 100%;\n  flex-direction: column;\n"
    ]);
    dropdown_select_styles_templateObject3 = function() {
        return data;
    };
    return data;
}
function dropdown_select_styles_templateObject4() {
    const data = dropdown_select_styles_taggedTemplateLiteral([
        "\n  display: grid;\n  width: 100%;\n  max-height: 254px;\n  flex-direction: column;\n  overflow-y: scroll;\n  ::-webkit-scrollbar {\n    width: 4px;\n  }\n\n  ::-webkit-scrollbar-track {\n    background-color: ",
        ";\n  }\n\n  ::-webkit-scrollbar-thumb {\n    background-color: ",
        ";\n  }\n"
    ]);
    dropdown_select_styles_templateObject4 = function() {
        return data;
    };
    return data;
}
function dropdown_select_styles_templateObject5() {
    const data = dropdown_select_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  width: 100%;\n  height: 56px;\n  box-sizing: border-box;\n  align-items: center;\n  justify-content: space-between;\n  padding-right: 24px;\n  padding-left: 24px;\n  &.logout {\n    border: 1px solid ",
        ";\n    background-color: ",
        ";\n    &:hover {\n      .logout-label {\n        color: ",
        ";\n      }\n    }\n  }\n  &.settings {\n    border: 1px solid ",
        ";\n    background-color: ",
        ";\n    &:hover {\n      .logout-label {\n        color: ",
        ";\n      }\n    }\n  }\n  cursor: pointer;\n  transition: 0.3s;\n  .logout-icon,\n  .logout-label {\n    transition: 0.3s;\n  }\n  &:hover {\n    .logout-icon {\n      transform: translate3d(-8px, 0px, 0px);\n    }\n  }\n  &:focus {\n    outline: 1px solid ",
        ";\n  }\n"
    ]);
    dropdown_select_styles_templateObject5 = function() {
        return data;
    };
    return data;
}
function dropdown_select_styles_templateObject6() {
    const data = dropdown_select_styles_taggedTemplateLiteral([
        "\n  position: absolute;\n  top: 56px;\n  right: 0px;\n  width: 100%;\n  min-width: 320px;\n  border: 1px solid ",
        ";\n  box-shadow: 0px 18px 45px rgba(0, 0, 0, 0.09);\n  opacity: ",
        ";\n  pointer-events: ",
        ";\n  transform: translate3d(0px, ",
        ", 0px);\n  transition: 0.2s;\n  @media screen and (max-width: 398px) {\n    width: 100vw;\n    transform: translateX(48px);\n  }\n"
    ]);
    dropdown_select_styles_templateObject6 = function() {
        return data;
    };
    return data;
}
function styles_templateObject7() {
    const data = dropdown_select_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  width: 100%;\n  height: 56px;\n  box-sizing: border-box;\n  align-items: center;\n  justify-content: space-between;\n  padding-right: 16px;\n  padding-left: 16px;\n  border-top: 1px solid ",
        ";\n  border-bottom: 1px solid ",
        ";\n  border-left: 1px solid ",
        ";\n  background-color: ",
        ";\n  transition: 0.3s;\n  .option-label {\n    transition: 0.3s;\n  }\n  &:hover {\n    background-color: ",
        ";\n    .option-label {\n      color: ",
        ";\n    }\n  }\n  &:focus {\n    border: 1px solid ",
        ";\n  }\n  p {\n    text-align: left;\n  }\n"
    ]);
    styles_templateObject7 = function() {
        return data;
    };
    return data;
}
function _templateObject8() {
    const data = dropdown_select_styles_taggedTemplateLiteral([
        "\n  color: ",
        ";\n  font-size: ",
        ";\n  font-weight: 400;\n"
    ]);
    _templateObject8 = function() {
        return data;
    };
    return data;
}


const DropdownSelectContainer = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-a3445f5d-0"
})(dropdown_select_styles_templateObject(), (p)=>p.fullWidth ? "100%" : "320px");
const DropdownSelectActiveContainer = styled_components_browser_cjs["default"].button.withConfig({
    componentId: "sc-a3445f5d-1"
})(dropdown_select_styles_templateObject1(), lib_styles_src/* theme.palette.white.main */.rS.palette.white.main, lib_styles_src/* theme.palette.gray.10 */.rS.palette.gray[10], lib_styles_src/* theme.palette.blue.main */.rS.palette.blue.main, lib_styles_src/* theme.palette.white.main */.rS.palette.white.main, lib_styles_src/* theme.palette.gray.10 */.rS.palette.gray[10]);
const DropdownSelectActiveLabel = styled_components_browser_cjs["default"].p.withConfig({
    componentId: "sc-a3445f5d-2"
})(dropdown_select_styles_templateObject2(), lib_styles_src/* theme.palette.blue.dark */.rS.palette.blue.dark);
const DropdownSelectOptionsInner = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-a3445f5d-3"
})(dropdown_select_styles_templateObject3());
const DropdownSelectOptionsWrapper = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-a3445f5d-4"
})(dropdown_select_styles_templateObject4(), lib_styles_src/* theme.palette.white.main */.rS.palette.white.main, lib_styles_src/* theme.palette.blue.main */.rS.palette.blue.main);
const DropdownSelectionOption = styled_components_browser_cjs["default"].button.withConfig({
    componentId: "sc-a3445f5d-5"
})(dropdown_select_styles_templateObject5(), lib_styles_src/* theme.palette.blue.main */.rS.palette.blue.main, lib_styles_src/* theme.palette.blue.main */.rS.palette.blue.main, lib_styles_src/* theme.palette.yellow.main */.rS.palette.yellow.main, lib_styles_src/* theme.palette.gray.40 */.rS.palette.gray[40], lib_styles_src/* theme.palette.white.main */.rS.palette.white.main, lib_styles_src/* theme.palette.blue.main */.rS.palette.blue.main, lib_styles_src/* theme.palette.gray.60 */.rS.palette.gray[60]);
const DropdownSelectOptionsContainer = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-a3445f5d-6"
})(dropdown_select_styles_templateObject6(), lib_styles_src/* theme.palette.gray.10 */.rS.palette.gray[10], (props)=>props.collapsed ? "0" : "1", (props)=>props.collapsed ? "none" : "initial", (props)=>props.collapsed ? "16px" : "0px");
const DropdownSelectOptionRow = styled_components_browser_cjs["default"].button.withConfig({
    componentId: "sc-a3445f5d-7"
})(styles_templateObject7(), lib_styles_src/* theme.palette.transparent.main */.rS.palette.transparent.main, lib_styles_src/* theme.palette.gray.10 */.rS.palette.gray[10], lib_styles_src/* theme.palette.transparent.main */.rS.palette.transparent.main, lib_styles_src/* theme.palette.white.main */.rS.palette.white.main, lib_styles_src/* theme.palette.blue.main */.rS.palette.blue.main, lib_styles_src/* theme.palette.white.main */.rS.palette.white.main, lib_styles_src/* theme.palette.gray.60 */.rS.palette.gray[60]);
const DropdownSelectOptionRowLabel = styled_components_browser_cjs["default"].p.withConfig({
    componentId: "sc-a3445f5d-8"
})(_templateObject8(), (props)=>props.color, (props)=>props.small ? "14px" : "16px");

;// CONCATENATED MODULE: ./src/features/header/components/dropdown-select/dropdown-select-list-item.tsx









const DropdownSelectOptionsItem = (param)=>{
    let { ssn , name , id  } = param;
    const collapseRef = (0,react.useRef)(null);
    const { switchAccount  } = (0,hooks_auth_next_src/* useAuth */.aC)();
    const setCollapsed = (0,lib_recoil_src/* useSetRecoilState */.Zl)(collapsedState);
    const collapseMenu = (0,react.useCallback)(()=>{
        setCollapsed(true);
    }, [
        setCollapsed
    ]);
    (0,esm/* useOnClickOutside */.t$)(collapseRef, collapseMenu);
    const handleItemClick = (0,react.useCallback)(async ()=>{
        await switchAccount(id);
        collapseMenu();
    }, [
        collapseMenu,
        switchAccount,
        id
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(DropdownSelectOptionRow, {
        onClick: handleItemClick,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DropdownSelectOptionRowLabel, {
                className: "option-label",
                color: lib_styles_src/* theme.palette.blue.dark */.rS.palette.blue.dark,
                children: name
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DropdownSelectOptionRowLabel, {
                className: "option-label",
                color: lib_styles_src/* theme.palette.gray.40 */.rS.palette.gray[40],
                small: true,
                children: ssn
            })
        ]
    }, ssn);
};

;// CONCATENATED MODULE: ./src/features/header/components/dropdown-select/dropdown-select-list.tsx




const DropdownSelectList = (param)=>{
    let { options  } = param;
    const handleOptionsItems = (0,react.useMemo)(()=>{
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: options.map((option)=>{
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(DropdownSelectOptionsItem, {
                    id: option.id,
                    name: option.account.name,
                    ssn: option.account.ssn
                }, option.id);
            })
        });
    }, [
        options
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: handleOptionsItems
    });
};

;// CONCATENATED MODULE: ./src/features/header/components/dropdown-select/dropdown-select-search.tsx





const DropdownSelectSearch = (param)=>{
    let { options  } = param;
    const [filteredAccounts, setFilteredAccounts] = (0,react.useState)(options.slice(0, 3));
    const [showSuggestions, setShowSuggestions] = (0,react.useState)(false);
    const [inputValue, setInputValue] = (0,react.useState)("");
    const handleInputChange = (0,react.useCallback)((e)=>{
        e.preventDefault();
        setInputValue(e.target.value);
        let unLinked = [];
        if (options) {
            unLinked = options.filter((option)=>(option.account.name || "").toLowerCase().indexOf(e.target.value.toLowerCase()) > -1 || option.account.ssn.indexOf(e.target.value.toLowerCase()) > -1);
        }
        setFilteredAccounts(unLinked);
        setShowSuggestions(true);
    }, [
        setInputValue,
        setFilteredAccounts,
        setShowSuggestions,
        options
    ]);
    const handleOnClick = (0,react.useCallback)(()=>{
        setInputValue("");
        setFilteredAccounts([]);
    }, [
        setInputValue,
        setFilteredAccounts
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(component_inputs_src/* SearchInput */.Mj, {
                isDirty: Boolean(inputValue),
                placeholder: "Sl\xe1\xf0u inn nafn e\xf0a kennit\xf6lu",
                type: "text",
                value: inputValue,
                onChange: handleInputChange,
                onClick: handleOnClick
            }),
            inputValue === "" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(DropdownSelectList, {
                options: options,
                setFilteredAccounts: setFilteredAccounts,
                setInputValue: setInputValue,
                setShowSuggestions: setShowSuggestions
            }) : null,
            showSuggestions && inputValue ? /*#__PURE__*/ (0,jsx_runtime.jsx)(DropdownSelectList, {
                options: filteredAccounts,
                setFilteredAccounts: setFilteredAccounts,
                setInputValue: setInputValue,
                setShowSuggestions: setShowSuggestions
            }) : null
        ]
    });
};

;// CONCATENATED MODULE: ./src/features/header/components/dropdown-select/dropdown-select.tsx













const DropdownSelect = (param)=>{
    let { active , options , fullWidth =false , onClick , icon: Icon = lib_icons_src.NotandiIcons , iconButton =false  } = param;
    var ref;
    const router = (0,next_router.useRouter)();
    const [collapsed, setCollapsed] = (0,lib_recoil_src/* useRecoilState */.FV)(collapsedState);
    const { logout , memberships  } = (0,hooks_auth_next_src/* useAuth */.aC)();
    const { fetchCheckoutData  } = (0,hooks_cart_src/* useCheckoutExtra */.Ol)();
    const sortedOptions = (0,react.useMemo)(()=>{
        const tmp = [
            ...options
        ];
        return tmp.sort((a, b)=>{
            if (a.account.name && b.account.name) {
                return a.account.name.localeCompare(b.account.name);
            }
            return 1;
        });
    }, [
        options
    ]);
    const handleGoToSettings = (0,react.useCallback)(()=>{
        setCollapsed(true);
        // eslint-disable-next-line no-console
        router.push("/mitt/stillingar");
    }, [
        router,
        setCollapsed
    ]);
    const handleGoToMyByko = (0,react.useCallback)(()=>{
        setCollapsed(true);
        // eslint-disable-next-line no-console
        router.push("/mitt/forsida");
    }, [
        router,
        setCollapsed
    ]);
    const handleLogOut = (0,react.useCallback)(async ()=>{
        setCollapsed(true);
        logout();
        await fetchCheckoutData();
    }, [
        logout,
        setCollapsed,
        fetchCheckoutData
    ]);
    const toggleCollapse = (0,react.useCallback)(()=>{
        setCollapsed((current)=>!current);
    }, [
        setCollapsed
    ]);
    if (!active) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(DropdownSelectContainer, {
        className: "drop-down",
        fullWidth: fullWidth,
        onClick: onClick,
        children: [
            iconButton && Icon ? /*#__PURE__*/ (0,jsx_runtime.jsx)(component_buttons_src/* IconButton */.hU, {
                ariaLabel: "valmynd",
                className: "drop-down-active-container",
                icon: collapsed ? Icon : lib_icons_src.CancelSmallIcons,
                onClick: toggleCollapse
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(DropdownSelectActiveContainer, {
                className: "drop-down-active-container",
                fullWidth: !!fullWidth,
                onClick: toggleCollapse,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DropdownSelectActiveLabel, {
                        className: "active-name",
                        children: active === null || active === void 0 ? void 0 : (ref = active.account) === null || ref === void 0 ? void 0 : ref.name
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(lib_icons_src.ArrowDownIcons, {
                        size: 32
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DropdownSelectOptionsContainer, {
                collapsed: collapsed,
                children: !collapsed ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(DropdownSelectOptionsWrapper, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DropdownSelectOptionsInner, {
                                children: memberships.length > 2 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(DropdownSelectSearch, {
                                    options: sortedOptions
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(DropdownSelectList, {
                                    options: sortedOptions
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(DropdownSelectionOption, {
                            className: "settings",
                            onClick: handleGoToMyByko,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(DropdownSelectOptionRowLabel, {
                                    className: "logout-label",
                                    color: lib_styles_src/* theme.palette.blue.dark */.rS.palette.blue.dark,
                                    children: "Mitt BYKO"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(lib_icons_src.NotandiIcons, {
                                    className: "logout-icon",
                                    iconColor: lib_styles_src/* theme.palette.blue.dark */.rS.palette.blue.dark,
                                    size: 18
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(DropdownSelectionOption, {
                            className: "settings",
                            onClick: handleGoToSettings,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(DropdownSelectOptionRowLabel, {
                                    className: "logout-label",
                                    color: lib_styles_src/* theme.palette.blue.dark */.rS.palette.blue.dark,
                                    children: "Stillingar"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(lib_icons_src.SettingsIcons, {
                                    className: "logout-icon",
                                    iconColor: lib_styles_src/* theme.palette.blue.dark */.rS.palette.blue.dark,
                                    size: 18
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(DropdownSelectionOption, {
                            className: "logout",
                            onClick: handleLogOut,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(DropdownSelectOptionRowLabel, {
                                    className: "logout-label",
                                    color: lib_styles_src/* theme.palette.white.main */.rS.palette.white.main,
                                    children: "Skr\xe1 \xfat"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(lib_icons_src.LogoutIcons, {
                                    className: "logout-icon",
                                    iconColor: lib_styles_src/* theme.palette.white.main */.rS.palette.white.main,
                                    size: 18
                                })
                            ]
                        })
                    ]
                }) : null
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/features/header/components/dropdown-select/index.ts


;// CONCATENATED MODULE: ./src/features/header/components/styles.ts
function components_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function components_styles_templateObject() {
    const data = components_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  width: 56px;\n  height: 56px;\n  align-items: center;\n  justify-content: center;\n  background-color: ",
        ";\n  @media screen and (min-width: ",
        "px) {\n    display: none;\n  }\n"
    ]);
    components_styles_templateObject = function() {
        return data;
    };
    return data;
}
function components_styles_templateObject1() {
    const data = components_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  width: 22px;\n  height: 16px;\n  flex-direction: column;\n  align-items: flex-end;\n  justify-content: space-between;\n"
    ]);
    components_styles_templateObject1 = function() {
        return data;
    };
    return data;
}
function components_styles_templateObject2() {
    const data = components_styles_taggedTemplateLiteral([
        "\n  width: 22px;\n  border: 1px solid ",
        ";\n  opacity: ",
        ";\n  transform: rotate(-",
        "deg);\n  transform-origin: center;\n  transition: 0.3s;\n"
    ]);
    components_styles_templateObject2 = function() {
        return data;
    };
    return data;
}
function components_styles_templateObject3() {
    const data = components_styles_taggedTemplateLiteral([
        "\n  width: 11px;\n  border: 1px solid ",
        ";\n  opacity: ",
        ";\n  transition: 0.3s;\n"
    ]);
    components_styles_templateObject3 = function() {
        return data;
    };
    return data;
}
function components_styles_templateObject4() {
    const data = components_styles_taggedTemplateLiteral([
        "\n  position: absolute;\n  top: 50%;\n  width: 22px;\n  border: 1px solid ",
        ";\n  background-color: ",
        ";\n  opacity: ",
        ";\n  transform: rotate(-",
        "deg);\n  transform-origin: center;\n  transition: 0.3s;\n"
    ]);
    components_styles_templateObject4 = function() {
        return data;
    };
    return data;
}
function components_styles_templateObject5() {
    const data = components_styles_taggedTemplateLiteral([
        "\n  position: absolute;\n  top: 50%;\n  width: 22px;\n  border: 1px solid ",
        ";\n  background-color: ",
        ";\n  opacity: ",
        ";\n  transform: rotate(",
        "deg);\n  transform-origin: center;\n  transition: 0.3s;\n"
    ]);
    components_styles_templateObject5 = function() {
        return data;
    };
    return data;
}
function components_styles_templateObject6() {
    const data = components_styles_taggedTemplateLiteral([
        "\n  position: fixed;\n  z-index: 20;\n  top: 0px;\n  right: 0px;\n  width: 100%;\n  max-width: 460px;\n  height: calc(100vh - 56px);\n  background-color: ",
        ";\n  transform: translate3d(",
        ", 56px, 0px);\n  transition: 0.3s;\n  @media screen and (min-width: ",
        "px) {\n    display: none;\n  }\n"
    ]);
    components_styles_templateObject6 = function() {
        return data;
    };
    return data;
}
function components_styles_templateObject7() {
    const data = components_styles_taggedTemplateLiteral([
        "\n  @media screen and (min-width: ",
        "px) {\n    display: none;\n  }\n"
    ]);
    components_styles_templateObject7 = function() {
        return data;
    };
    return data;
}
function styles_templateObject8() {
    const data = components_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: flex-end;\n  padding: 24px 16px;\n"
    ]);
    styles_templateObject8 = function() {
        return data;
    };
    return data;
}
function _templateObject9() {
    const data = components_styles_taggedTemplateLiteral([
        "\n  color: ",
        ";\n  font-size: 16px;\n  font-weight: bold;\n  transition: 0.3s;\n"
    ]);
    _templateObject9 = function() {
        return data;
    };
    return data;
}
function _templateObject10() {
    const data = components_styles_taggedTemplateLiteral([
        "\n  width: 12px;\n  height: 12px;\n  border-radius: 50%;\n  margin-left: 16px;\n  background-color: ",
        ";\n  transform: translate3d(0px, -1px, 0px);\n  transition: 0.3s;\n"
    ]);
    _templateObject10 = function() {
        return data;
    };
    return data;
}
function _templateObject11() {
    const data = components_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  &:hover ",
        " {\n    background-color: ",
        ";\n  }\n  &:hover ",
        " {\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject11 = function() {
        return data;
    };
    return data;
}



const BurgerContainer = styled_components_browser_cjs["default"].button.withConfig({
    componentId: "sc-cf2d7ea9-0"
})(components_styles_templateObject(), lib_styles_src/* theme.palette.yellow.main */.rS.palette.yellow.main, lib_styles_src/* gridTheme.breakpoints.sm */.k.breakpoints.sm);
const BurgerInner = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-cf2d7ea9-1"
})(components_styles_templateObject1());
const BurgerLineLong = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-cf2d7ea9-2"
})(components_styles_templateObject2(), lib_styles_src/* theme.palette.blue.main */.rS.palette.blue.main, (p)=>p.hide ? "0" : "1", (p)=>p.hide && p.rotateLine ? "45" : "0");
const BurgerLineShort = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-cf2d7ea9-3"
})(components_styles_templateObject3(), lib_styles_src/* theme.palette.blue.main */.rS.palette.blue.main, (p)=>p.hide ? "0" : "1");
const BurgerCrossTop = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-cf2d7ea9-4"
})(components_styles_templateObject4(), lib_styles_src/* theme.palette.blue.main */.rS.palette.blue.main, lib_styles_src/* theme.palette.blue.main */.rS.palette.blue.main, (p)=>p.hide ? "0" : "1", (p)=>p.hide ? "0" : "45");
const BurgerCrossBottom = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-cf2d7ea9-5"
})(components_styles_templateObject5(), lib_styles_src/* theme.palette.blue.main */.rS.palette.blue.main, lib_styles_src/* theme.palette.blue.main */.rS.palette.blue.main, (p)=>p.hide ? "0" : "1", (p)=>p.hide ? "0" : "45");
const MobileSelectionContainer = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-cf2d7ea9-6"
})(components_styles_templateObject6(), lib_styles_src/* theme.palette.blue.main */.rS.palette.blue.main, (p)=>p.active ? "0%" : "100%", lib_styles_src/* gridTheme.breakpoints.sm */.k.breakpoints.sm);
const MobileIconButton = (0,styled_components_browser_cjs["default"])(component_buttons_src/* IconButton */.hU).withConfig({
    componentId: "sc-cf2d7ea9-7"
})(components_styles_templateObject7(), lib_styles_src/* gridTheme.breakpoints.sm */.k.breakpoints.sm);
const MobileSelectionContentBlock = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-cf2d7ea9-8"
})(styles_templateObject8());
const LinkText = styled_components_browser_cjs["default"].p.withConfig({
    componentId: "sc-cf2d7ea9-9"
})(_templateObject9(), lib_styles_src/* theme.palette.white.main */.rS.palette.white.main);
const LinkTag = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-cf2d7ea9-10"
})(_templateObject10(), lib_styles_src/* theme.palette.white.main */.rS.palette.white.main);
const MobileNavLink = styled_components_browser_cjs["default"].a.withConfig({
    componentId: "sc-cf2d7ea9-11"
})(_templateObject11(), LinkTag, lib_styles_src/* theme.palette.yellow.main */.rS.palette.yellow.main, LinkText, lib_styles_src/* theme.palette.yellow.main */.rS.palette.yellow.main);

;// CONCATENATED MODULE: ./src/features/header/components/mobile-selection.tsx








const MobileSelection = (param)=>{
    let { mockMemberships  } = param;
    const collapseRef = (0,react.useRef)(null);
    const { menuOpen , setMenuOpen  } = useMobileBurger();
    const { activeMembership , memberships  } = (0,hooks_auth_next_src/* useAuth */.aC)();
    const collapseMenu = (0,react.useCallback)(()=>{
        setTimeout(()=>{
            if (menuOpen) {
                setMenuOpen(false);
            }
        }, 150);
    }, [
        setMenuOpen,
        menuOpen
    ]);
    (0,esm/* useOnClickOutside */.t$)(collapseRef, collapseMenu);
    const mockActiveMemberShip = (0,react.useMemo)(()=>{
        if (mockMemberships && mockMemberships.length !== 0) {
            return mockMemberships[0];
        }
        return null;
    }, [
        mockMemberships
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(MobileSelectionContainer, {
        ref: collapseRef,
        active: menuOpen,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(MobileSelectionContentBlock, {
                children: [
                    mockActiveMemberShip && /*#__PURE__*/ (0,jsx_runtime.jsx)(DropdownSelect, {
                        active: mockActiveMemberShip,
                        fullWidth: true,
                        options: mockMemberships || memberships
                    }),
                    activeMembership !== null && /*#__PURE__*/ (0,jsx_runtime.jsx)(DropdownSelect, {
                        active: activeMembership,
                        fullWidth: true,
                        options: mockMemberships || memberships
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileSelectionContentBlock, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(MobileNavLink, {
                    href: "/mitt",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkText, {
                            children: "Mitt BYKO"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkTag, {})
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileSelectionContentBlock, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(MobileNavLink, {
                    href: "https://byko.is/thjonusta/vidskiptakjor/reikningsvidskipti",
                    rel: "noreferrer",
                    target: "_blank",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkText, {
                            children: "Reikningsvi\xf0skipti"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkTag, {})
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileSelectionContentBlock, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(MobileNavLink, {
                    href: "https://byko.is/vidskiptaradgjof#panta",
                    rel: "noreferrer",
                    target: "_blank",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkText, {
                            children: "B\xf3ka r\xe1\xf0gj\xf6f"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkTag, {})
                    ]
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/features/header/components/burger.tsx





const Burger = ()=>{
    const { setIsOpen , isOpen  } = useMegamenu();
    const toggleActie = (0,react.useCallback)(()=>{
        setIsOpen((current)=>{
            return !current;
        });
    }, [
        setIsOpen
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BurgerContainer, {
        onClick: toggleActie,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(BurgerInner, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(BurgerCrossTop, {
                    hide: !isOpen
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(BurgerCrossBottom, {
                    hide: !isOpen
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(BurgerLineLong, {
                    hide: isOpen
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(BurgerLineLong, {
                    hide: isOpen,
                    rotateLine: true
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(BurgerLineShort, {
                    hide: isOpen
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/features/header/components/add-to-cart-toast/styles.ts
function add_to_cart_toast_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function add_to_cart_toast_styles_templateObject() {
    const data = add_to_cart_toast_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  width: 100%;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n"
    ]);
    add_to_cart_toast_styles_templateObject = function() {
        return data;
    };
    return data;
}
function add_to_cart_toast_styles_templateObject1() {
    const data = add_to_cart_toast_styles_taggedTemplateLiteral([
        "\n  width: 64px;\n  height: 64px;\n  object-fit: contain;\n"
    ]);
    add_to_cart_toast_styles_templateObject1 = function() {
        return data;
    };
    return data;
}
function add_to_cart_toast_styles_templateObject2() {
    const data = add_to_cart_toast_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  width: 100%;\n  height: fit-content;\n  flex-direction: column;\n  padding: 8px 16px;\n  border: 2px solid ",
        ";\n  background-color: ",
        ";\n  gap: 16px;\n  transform: translateX(160%);\n  transition: 600ms;\n  transition-timing-function: ease-in-out;\n  &.show {\n    transform: translateX(0);\n  }\n"
    ]);
    add_to_cart_toast_styles_templateObject2 = function() {
        return data;
    };
    return data;
}


const NotifyInner = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-b40a3f4a-0"
})(add_to_cart_toast_styles_templateObject());
const ProductImage = styled_components_browser_cjs["default"].img.withConfig({
    componentId: "sc-b40a3f4a-1"
})(add_to_cart_toast_styles_templateObject1());
const NotifyContainer = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-b40a3f4a-2"
})(add_to_cart_toast_styles_templateObject2(), lib_styles_src/* theme.palette.yellow.main */.rS.palette.yellow.main, lib_styles_src/* theme.palette.white.main */.rS.palette.white.main);

;// CONCATENATED MODULE: ./src/features/header/components/add-to-cart-toast/index.tsx




const placeholderImageHandler = (e)=>{
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    const target = e.target;
    target.src = "https://www.datocms-assets.com/65892/1664464657-placeholder-do-not-remove.jpg";
};
const AddToCartToast = (param)=>{
    let { variant  } = param;
    var ref, ref1;
    const [show, setShow] = (0,react.useState)(false);
    (0,react.useEffect)(()=>{
        setShow(true);
        const timeOutID = setTimeout(()=>{
            setShow(false);
        }, 3000);
        return ()=>{
            clearTimeout(timeOutID);
        };
    }, []);
    var _productList, ref2;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(NotifyContainer, {
        className: show ? "show" : "",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(component_typography_src/* PMedium */.aW, {
                children: "B\xe6tt vi\xf0 k\xf6rfu"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(NotifyInner, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductImage, {
                        alt: variant.name,
                        src: (ref2 = (_productList = (ref = variant.firstImage) === null || ref === void 0 ? void 0 : ref.image.productList) !== null && _productList !== void 0 ? _productList : (ref1 = variant.product.firstImage) === null || ref1 === void 0 ? void 0 : ref1.image.productList) !== null && ref2 !== void 0 ? ref2 : "https://www.datocms-assets.com/65892/1664464657-placeholder-do-not-remove.jpg",
                        onError: placeholderImageHandler
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(component_typography_src/* PSmall */.zK, {
                        children: variant.product.name
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/features/header/components/index.ts





;// CONCATENATED MODULE: ./src/features/header/styles.ts
function header_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function header_styles_templateObject() {
    const data = header_styles_taggedTemplateLiteral([
        "\n  position: relative;\n  display: flex;\n  width: 36px;\n  height: 20px;\n  align-items: center;\n  border: 2px solid ",
        ";\n  border-radius: 16px;\n  background-color: ",
        ";\n"
    ]);
    header_styles_templateObject = function() {
        return data;
    };
    return data;
}
function header_styles_templateObject1() {
    const data = header_styles_taggedTemplateLiteral([
        "\n  position: absolute;\n  width: 14px;\n  height: 14px;\n  border-radius: 50%;\n  background-color: ",
        ";\n  transform: translate3d(0, 0, 0);\n  transition: 250ms;\n  &.pro {\n    left: calc(100% - 2px);\n    transform: translate3d(-100%, 0, 0);\n  }\n  &.standard {\n    left: 2px;\n  }\n  &.none {\n    left: calc(50%);\n    transform: translate3d(-50%, 0, 0);\n  }\n"
    ]);
    header_styles_templateObject1 = function() {
        return data;
    };
    return data;
}
function header_styles_templateObject2() {
    const data = header_styles_taggedTemplateLiteral([
        "\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  width: fit-content;\n  padding-top: 2px;\n  border-radius: 4px;\n  background-color: ",
        ";\n  opacity: 0;\n  pointer-events: none;\n  transform: translate3d(50%, calc(100% + 16px), 0);\n  transition: 250ms;\n  &.common {\n    width: 148px;\n  }\n  &.pro {\n    width: 168px;\n  }\n"
    ]);
    header_styles_templateObject2 = function() {
        return data;
    };
    return data;
}
function header_styles_templateObject3() {
    const data = header_styles_taggedTemplateLiteral([
        "\n  position: relative;\n  &:hover {\n    ",
        " {\n      opacity: 1;\n    }\n  }\n"
    ]);
    header_styles_templateObject3 = function() {
        return data;
    };
    return data;
}
function header_styles_templateObject4() {
    const data = header_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  @media screen and (max-width: 1078px) {\n    display: none;\n  }\n"
    ]);
    header_styles_templateObject4 = function() {
        return data;
    };
    return data;
}
function header_styles_templateObject5() {
    const data = header_styles_taggedTemplateLiteral([
        "\n  display: none;\n  @media screen and (max-width: 1078px) {\n    display: block;\n  }\n"
    ]);
    header_styles_templateObject5 = function() {
        return data;
    };
    return data;
}
function header_styles_templateObject6() {
    const data = header_styles_taggedTemplateLiteral([
        ""
    ]);
    header_styles_templateObject6 = function() {
        return data;
    };
    return data;
}
function header_styles_templateObject7() {
    const data = header_styles_taggedTemplateLiteral([
        "\n  position: fixed;\n  z-index: 3000;\n  top: 104px;\n  right: 16px;\n  height: fit-content;\n  pointer-events: none;\n  @media screen and (max-width: 1078px) {\n    top: 132px;\n  }\n"
    ]);
    header_styles_templateObject7 = function() {
        return data;
    };
    return data;
}
function header_styles_templateObject8() {
    const data = header_styles_taggedTemplateLiteral([
        "\n  position: relative;\n  z-index: 300000;\n  display: none;\n  width: 100%;\n  @media screen and (max-width: 1078px) {\n    display: flex;\n    overflow: visible;\n    justify-content: flex-end;\n  }\n"
    ]);
    header_styles_templateObject8 = function() {
        return data;
    };
    return data;
}
function styles_templateObject9() {
    const data = header_styles_taggedTemplateLiteral([
        "\n  position: absolute;\n  top: 88px;\n  right: 0;\n  display: flex;\n  width: 100%;\n  justify-content: flex-end;\n  pointer-events: none;\n  @media screen and (max-width: 1078px) {\n    top: 58px;\n  }\n"
    ]);
    styles_templateObject9 = function() {
        return data;
    };
    return data;
}
function styles_templateObject10() {
    const data = header_styles_taggedTemplateLiteral([
        "\n  position: relative;\n  z-index: 3001;\n  padding-bottom: 88px;\n  margin-right: 88px;\n  pointer-events: none;\n"
    ]);
    styles_templateObject10 = function() {
        return data;
    };
    return data;
}
function styles_templateObject11() {
    const data = header_styles_taggedTemplateLiteral([
        "\n  position: fixed;\n  top: 0;\n  right: 0;\n  left: 0;\n  width: 100%;\n  pointer-events: all;\n  .search-input {\n    @media screen and (max-width: ",
        "px) {\n      box-shadow: 0px 18px 45px rgba(0, 0, 0, 0.09);\n    }\n  }\n"
    ]);
    styles_templateObject11 = function() {
        return data;
    };
    return data;
}
function _templateObject12() {
    const data = header_styles_taggedTemplateLiteral([
        "\n  position: relative;\n  z-index: 0;\n  display: none;\n  @media screen and (max-width: 1078px) {\n    display: block;\n  }\n  @media screen and (max-width: 1438px) {\n    border-bottom: 1px solid ",
        ";\n  }\n"
    ]);
    _templateObject12 = function() {
        return data;
    };
    return data;
}
function _templateObject13() {
    const data = header_styles_taggedTemplateLiteral([
        "\n  position: relative;\n  z-index: 1;\n  display: flex;\n  height: 88px;\n  justify-content: space-between;\n  padding-right: 25px;\n  border-bottom: 2px solid ",
        ";\n  background-color: ",
        ";\n  @media screen and (max-width: 1078px) {\n    height: 56px;\n    padding-right: 0 !important;\n  }\n"
    ]);
    _templateObject13 = function() {
        return data;
    };
    return data;
}
function _templateObject14() {
    const data = header_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  width: 100%;\n  height: 88px;\n  align-items: center;\n  justify-content: space-between;\n  border-bottom: 2px solid ",
        ";\n  background-color: ",
        ";\n  @media screen and (max-width: 1078px) {\n    height: 56px;\n  }\n"
    ]);
    _templateObject14 = function() {
        return data;
    };
    return data;
}
function _templateObject15() {
    const data = header_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  width: 100%;\n  align-items: center;\n  @media screen and (max-width: ",
        "px) {\n    display: none;\n  }\n"
    ]);
    _templateObject15 = function() {
        return data;
    };
    return data;
}
function _templateObject16() {
    const data = header_styles_taggedTemplateLiteral([
        "\n  width: 162px;\n  margin-right: 32px;\n  margin-left: 32px;\n  button {\n    margin-right: 10px;\n    margin-left: 10px;\n    p {\n      font-size: 18px;\n    }\n    @media screen and (max-width: ",
        "px) {\n      margin-right: 20px;\n      margin-left: 20px;\n    }\n  }\n"
    ]);
    _templateObject16 = function() {
        return data;
    };
    return data;
}
function _templateObject17() {
    const data = header_styles_taggedTemplateLiteral([
        "\n  position: relative;\n"
    ]);
    _templateObject17 = function() {
        return data;
    };
    return data;
}
function _templateObject18() {
    const data = header_styles_taggedTemplateLiteral([
        "\n  position: absolute;\n  right: 0px;\n  bottom: 0;\n  display: flex;\n  width: 28px;\n  height: 28px;\n  box-sizing: border-box;\n  align-items: center;\n  justify-content: center;\n  pointer-events: none;\n"
    ]);
    _templateObject18 = function() {
        return data;
    };
    return data;
}
function _templateObject19() {
    const data = header_styles_taggedTemplateLiteral([
        "\n  padding: unset;\n  margin: unset;\n  background-color: ",
        ";\n  color: ",
        ";\n  font-size: 16px;\n  font-weight: 400;\n  line-height: 24px;\n  transform: translateY(1px);\n"
    ]);
    _templateObject19 = function() {
        return data;
    };
    return data;
}
function _templateObject20() {
    const data = header_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  margin-right: 50px;\n  margin-left: 20px;\n  gap: 30px;\n  .icon-button {\n    border: none;\n  }\n  @media screen and (max-width: ",
        "px) {\n    margin-right: 0;\n    margin-left: 0;\n    gap: unset;\n  }\n"
    ]);
    _templateObject20 = function() {
        return data;
    };
    return data;
}
function _templateObject21() {
    const data = header_styles_taggedTemplateLiteral([
        "\n  @media screen and (max-width: ",
        "px) {\n    width: 1px;\n    height: 56px;\n    background-color: ",
        ";\n  }\n"
    ]);
    _templateObject21 = function() {
        return data;
    };
    return data;
}
function _templateObject22() {
    const data = header_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  padding-left: 25px;\n  font-size: 1rem;\n  font-weight: 500;\n  text-align: left;\n  & a {\n    color: ",
        ";\n    font-size: 18px;\n    &:focus {\n      border-bottom: 1px solid ",
        ";\n    }\n  }\n"
    ]);
    _templateObject22 = function() {
        return data;
    };
    return data;
}
function _templateObject23() {
    const data = header_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  color: ",
        ";\n  font-size: 1rem;\n  font-weight: 500;\n  text-align: left;\n  @media screen and (max-width: ",
        "px) {\n    display: none;\n  }\n  & a {\n    color: ",
        ";\n  }\n  .loginButton {\n    width: 210px;\n  }\n\n  .drop-down-active-container {\n    outline: 1px solid ",
        ";\n    &:hover {\n      outline: none;\n    }\n    svg {\n      path {\n        stroke: ",
        ";\n      }\n    }\n  }\n"
    ]);
    _templateObject23 = function() {
        return data;
    };
    return data;
}
function _templateObject24() {
    const data = header_styles_taggedTemplateLiteral([
        "\n  width: 100%;\n  @media screen and (max-width: 1078px) {\n    display: none;\n  }\n"
    ]);
    _templateObject24 = function() {
        return data;
    };
    return data;
}
function _templateObject25() {
    const data = header_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  height: 100%;\n  align-items: center;\n  justify-content: center;\n  padding-right: 32px;\n  padding-left: 32px;\n  background-color: ",
        ";\n  transition: 0.3s;\n  a {\n    display: flex;\n    overflow: hidden;\n    height: 100%;\n    align-items: center;\n  }\n  * {\n    transition: 0.3s;\n  }\n  svg {\n    height: fit-content;\n    box-sizing: border-box;\n  }\n  @media screen and (max-width: 1078px) {\n    overflow: hidden;\n    height: 100%;\n  }\n  @media screen and (max-width: 340px) {\n    padding-right: 8px;\n    padding-left: 8px;\n  }\n"
    ]);
    _templateObject25 = function() {
        return data;
    };
    return data;
}
function _templateObject26() {
    const data = header_styles_taggedTemplateLiteral([
        "\n  text-align: center;\n"
    ]);
    _templateObject26 = function() {
        return data;
    };
    return data;
}


const TogglerContainer = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-d4fd8c87-0"
})(header_styles_templateObject(), lib_styles_src/* theme.palette.blue.dark */.rS.palette.blue.dark, lib_styles_src/* theme.palette.blue.dark */.rS.palette.blue.dark);
const TogglerState = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-d4fd8c87-1"
})(header_styles_templateObject1(), lib_styles_src/* theme.palette.white.main */.rS.palette.white.main);
const ToggleButtonHoverLabel = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-d4fd8c87-2"
})(header_styles_templateObject2(), lib_styles_src/* theme.palette.blue.dark */.rS.palette.blue.dark);
const ToggleButton = styled_components_browser_cjs["default"].button.withConfig({
    componentId: "sc-d4fd8c87-3"
})(header_styles_templateObject3(), ToggleButtonHoverLabel);
const DesktopOnly = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-d4fd8c87-4"
})(header_styles_templateObject4());
const MobileOnly = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-d4fd8c87-5"
})(header_styles_templateObject5());
const ContentSwitcherWrapper = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-d4fd8c87-6"
})(header_styles_templateObject6());
const AddToCartNotifyWrapper = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-d4fd8c87-7"
})(header_styles_templateObject7());
const MobileIconButtonWrapper = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-d4fd8c87-8"
})(header_styles_templateObject8());
const PositionWrapper = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-d4fd8c87-9"
})(styles_templateObject9());
const Wrapper = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-d4fd8c87-10"
})(styles_templateObject10());
const NavBarWrapper = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-d4fd8c87-11"
})(styles_templateObject11(), lib_styles_src/* gridTheme.breakpoints.sm */.k.breakpoints.sm);
const MobileSearchContainer = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-d4fd8c87-12"
})(_templateObject12(), lib_styles_src/* theme.palette.gray.10 */.rS.palette.gray[10]);
const NavBar = styled_components_browser_cjs["default"].nav.withConfig({
    componentId: "sc-d4fd8c87-13"
})(_templateObject13(), lib_styles_src/* theme.palette.yellow.main */.rS.palette.yellow.main, lib_styles_src/* theme.palette.white.main */.rS.palette.white.main);
const Navigation = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-d4fd8c87-14"
})(_templateObject14(), lib_styles_src/* theme.palette.yellow.main */.rS.palette.yellow.main, lib_styles_src/* theme.palette.white.main */.rS.palette.white.main);
const FlexRow = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-d4fd8c87-15"
})(_templateObject15(), lib_styles_src/* gridTheme.breakpoints.sm */.k.breakpoints.sm - 1);
const MegaMenuTriggerWrapper = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-d4fd8c87-16"
})(_templateObject16(), lib_styles_src/* gridTheme.breakpoints.sm */.k.breakpoints.sm);
const IconButtonWrapper = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-d4fd8c87-17"
})(_templateObject17());
const CartCounterWrapper = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-d4fd8c87-18"
})(_templateObject18());
const CartCount = styled_components_browser_cjs["default"].p.withConfig({
    componentId: "sc-d4fd8c87-19"
})(_templateObject19(), lib_styles_src/* theme.palette.white.main */.rS.palette.white.main, lib_styles_src/* theme.palette.blue.dark */.rS.palette.blue.dark);
const Icons = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-d4fd8c87-20"
})(_templateObject20(), lib_styles_src/* gridTheme.container.maxWidth.sm */.k.container.maxWidth.sm);
const styles_Divider = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-d4fd8c87-21"
})(_templateObject21(), lib_styles_src/* gridTheme.container.maxWidth.sm */.k.container.maxWidth.sm, lib_styles_src/* theme.palette.gray.20 */.rS.palette.gray[20]);
const LinkWrapper = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-d4fd8c87-22"
})(_templateObject22(), lib_styles_src/* theme.palette.blue.main */.rS.palette.blue.main, lib_styles_src/* theme.palette.gray.60 */.rS.palette.gray[60]);
const LoginWrapper = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-d4fd8c87-23"
})(_templateObject23(), lib_styles_src/* theme.palette.white.main */.rS.palette.white.main, lib_styles_src/* gridTheme.breakpoints.sm */.k.breakpoints.sm - 1, lib_styles_src/* theme.palette.white.main */.rS.palette.white.main, lib_styles_src/* theme.palette.yellow.main */.rS.palette.yellow.main, lib_styles_src/* theme.palette.yellow.main */.rS.palette.yellow.main);
const SearchInputWrapper = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-d4fd8c87-24"
})(_templateObject24());
const styles_LogoWrapper = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-d4fd8c87-25"
})(_templateObject25(), lib_styles_src/* theme.palette.blue.main */.rS.palette.blue.main);
const SVGWrapper = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-d4fd8c87-26"
})(_templateObject26());

// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-lib-api-price-virtual-284954a275/1/packages/lib-api-price/src/index.ts + 2 modules
var lib_api_price_src = __webpack_require__(62681);
;// CONCATENATED MODULE: ./src/features/mini-cart/styles.ts
function mini_cart_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function mini_cart_styles_templateObject() {
    const data = mini_cart_styles_taggedTemplateLiteral([
        "\n  position: relative;\n  z-index: 1;\n  display: flex;\n  width: 696px;\n  height: 100%;\n  min-height: 100px;\n  max-height: 65vh;\n  flex-direction: column;\n  padding: 0 50px;\n  background-color: ",
        ";\n  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.1);\n  pointer-events: auto;\n  transition: all 0.5s;\n  @media screen and (max-width: 400px) {\n    min-width: 100%;\n  }\n\n  @media screen and (max-width: ",
        "px) {\n    max-height: 90%;\n    padding: 0 16px;\n  }\n  @media screen and (max-width: 699px) {\n    width: 100%;\n  }\n"
    ]);
    mini_cart_styles_templateObject = function() {
        return data;
    };
    return data;
}
function mini_cart_styles_templateObject1() {
    const data = mini_cart_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 24px 0;\n  p {\n    text-transform: uppercase;\n  }\n\n  @media screen and (max-width: ",
        "px) {\n    padding: 16px 0;\n    ",
        " {\n      font-size: 14px;\n    }\n  }\n"
    ]);
    mini_cart_styles_templateObject1 = function() {
        return data;
    };
    return data;
}
function mini_cart_styles_templateObject2() {
    const data = mini_cart_styles_taggedTemplateLiteral([
        "\n  max-height: 564px;\n  border-bottom: 2px solid ",
        ";\n  overflow-y: scroll;\n  ",
        "\n  @media screen and (min-width: ",
        "px) {\n    padding-right: 8px;\n  }\n  @media screen and (max-width: 699px) {\n    max-height: 240px;\n  }\n"
    ]);
    mini_cart_styles_templateObject2 = function() {
        return data;
    };
    return data;
}
function mini_cart_styles_templateObject3() {
    const data = mini_cart_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding-bottom: 24px;\n  gap: 16px;\n  @media screen and (max-width: ",
        "px) {\n    flex-direction: column;\n    padding-bottom: 16px;\n  }\n"
    ]);
    mini_cart_styles_templateObject3 = function() {
        return data;
    };
    return data;
}



const MiniCartContainer = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-1f0cebe8-0"
})(mini_cart_styles_templateObject(), lib_styles_src/* theme.palette.white.main */.rS.palette.white.main, lib_styles_src/* gridTheme.container.maxWidth.s */.k.container.maxWidth.s);
const SpaceBetween = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-1f0cebe8-1"
})(mini_cart_styles_templateObject1(), lib_styles_src/* gridTheme.container.maxWidth.s */.k.container.maxWidth.s, component_typography_src/* PMediumBold */.zo);
const CartCardWrapper = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-1f0cebe8-2"
})(mini_cart_styles_templateObject2(), lib_styles_src/* theme.palette.yellow.main */.rS.palette.yellow.main, (0,lib_styles_src/* scrollStyle */.vh)({
    color: "light-blue"
}), lib_styles_src/* gridTheme.container.maxWidth.s */.k.container.maxWidth.s);
const ButtonSpaceBetween = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-1f0cebe8-3"
})(mini_cart_styles_templateObject3(), lib_styles_src/* gridTheme.container.maxWidth.s */.k.container.maxWidth.s);

// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-component-loaders-virtual-61e12a86f6/1/packages/component-loaders/src/index.ts + 7 modules
var component_loaders_src = __webpack_require__(96360);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-component-quantity-input-virtual-a245e83f98/1/packages/component-quantity-input/src/index.ts + 8 modules
var component_quantity_input_src = __webpack_require__(75290);
// EXTERNAL MODULE: ../../.yarn/__virtual__/use-debounce-virtual-d68bd84a4e/0/cache/use-debounce-npm-6.0.1-6203424700-9f81107565.zip/node_modules/use-debounce/esm/useDebouncedCallback.js
var useDebouncedCallback = __webpack_require__(99627);
;// CONCATENATED MODULE: ./src/features/mini-cart/components/styles.ts
function mini_cart_components_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function mini_cart_components_styles_templateObject() {
    const data = mini_cart_components_styles_taggedTemplateLiteral([
        "\n  width: 40px;\n  height: 29px;\n"
    ]);
    mini_cart_components_styles_templateObject = function() {
        return data;
    };
    return data;
}
function mini_cart_components_styles_templateObject1() {
    const data = mini_cart_components_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  overflow: hidden;\n  width: 100%;\n  height: 143px;\n  align-items: center;\n  border-top: 1px solid ",
        ";\n  opacity: ",
        ";\n  pointer-events: auto;\n  transform: translateX(",
        ");\n  transition: 300ms;\n  button {\n    width: 40px;\n    height: 29px;\n  }\n  @media screen and (max-width: ",
        "px) {\n    height: 181px;\n    align-items: flex-start;\n    padding-top: 16px;\n  }\n"
    ]);
    mini_cart_components_styles_templateObject1 = function() {
        return data;
    };
    return data;
}
function mini_cart_components_styles_templateObject2() {
    const data = mini_cart_components_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  width: 100%;\n  align-items: center;\n  justify-content: space-between;\n  padding-right: 8px;\n  @media screen and (max-width: ",
        "px) {\n    flex-wrap: wrap;\n  }\n"
    ]);
    mini_cart_components_styles_templateObject2 = function() {
        return data;
    };
    return data;
}
function mini_cart_components_styles_templateObject3() {
    const data = mini_cart_components_styles_taggedTemplateLiteral([
        "\n  ",
        "\n  @media screen and (max-width: 570px) {\n    padding-top: 8px;\n  }\n"
    ]);
    mini_cart_components_styles_templateObject3 = function() {
        return data;
    };
    return data;
}
function mini_cart_components_styles_templateObject4() {
    const data = mini_cart_components_styles_taggedTemplateLiteral([
        "\n  img {\n    width: 80px;\n    height: 80px;\n    margin-right: 16px;\n    object-fit: contain;\n  }\n  @media screen and (max-width: ",
        "px) {\n    margin-right: 6px;\n  }\n"
    ]);
    mini_cart_components_styles_templateObject4 = function() {
        return data;
    };
    return data;
}
function mini_cart_components_styles_templateObject5() {
    const data = mini_cart_components_styles_taggedTemplateLiteral([
        "\n  width: 120px;\n  height: 90px;\n  object-fit: contain;\n  object-position: center;\n  @media screen and (max-width: ",
        "px) {\n    width: 80px;\n  }\n"
    ]);
    mini_cart_components_styles_templateObject5 = function() {
        return data;
    };
    return data;
}
function mini_cart_components_styles_templateObject6() {
    const data = mini_cart_components_styles_taggedTemplateLiteral([
        "\n  position: absolute;\n  display: flex;\n  width: fit-content;\n  align-items: center;\n  justify-content: center;\n  padding: 0px 16px;\n  border: 2px solid ",
        ";\n  border-radius: 4px;\n  background-color: ",
        ";\n  pointer-events: none;\n  transform: translateY(24px);\n"
    ]);
    mini_cart_components_styles_templateObject6 = function() {
        return data;
    };
    return data;
}
function mini_cart_components_styles_templateObject7() {
    const data = mini_cart_components_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n\n  margin-left: 16px;\n  ",
        " {\n    text-decoration: line-through;\n  }\n\n  .hidden {\n    width: 0;\n    height: 0;\n    user-select: none;\n    visibility: hidden;\n  }\n"
    ]);
    mini_cart_components_styles_templateObject7 = function() {
        return data;
    };
    return data;
}
function components_styles_templateObject8() {
    const data = mini_cart_components_styles_taggedTemplateLiteral([
        ""
    ]);
    components_styles_templateObject8 = function() {
        return data;
    };
    return data;
}




const LoaderContainer = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-8815c967-0"
})(mini_cart_components_styles_templateObject());
const CardContainer = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-8815c967-1"
})(mini_cart_components_styles_templateObject1(), lib_styles_src/* theme.palette.gray.10 */.rS.palette.gray[10], (props)=>props.isloading ? "0.65" : props.showAnim ? "1" : "0", (props)=>props.showAnim ? "0" : "8px", lib_styles_src/* gridTheme.container.maxWidth.s */.k.container.maxWidth.s);
const FlexWrapper = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-8815c967-2"
})(mini_cart_components_styles_templateObject2(), lib_styles_src/* gridTheme.container.maxWidth.s */.k.container.maxWidth.s);
const QuantityInputWrapper = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-8815c967-3"
})(mini_cart_components_styles_templateObject3(), (props)=>props.disableinput ? "pointer-events: none;" : "");
const ProdImageWrapper = (0,styled_components_browser_cjs["default"])((link_default())).withConfig({
    componentId: "sc-8815c967-4"
})(mini_cart_components_styles_templateObject4(), lib_styles_src/* gridTheme.container.maxWidth.xs */.k.container.maxWidth.xs);
const ProdImage = styled_components_browser_cjs["default"].img.withConfig({
    componentId: "sc-8815c967-5"
})(mini_cart_components_styles_templateObject5(), lib_styles_src/* gridTheme.container.maxWidth.xs */.k.container.maxWidth.xs);
const OutOfStockWrapper = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-8815c967-6"
})(mini_cart_components_styles_templateObject6(), lib_styles_src/* theme.palette.triggers.warning.main */.rS.palette.triggers.warning.main, lib_styles_src/* theme.palette.triggers.warning.lightest */.rS.palette.triggers.warning.lightest);
const ProdInfoWrapper = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-8815c967-7"
})(mini_cart_components_styles_templateObject7(), component_typography_src/* EyebrowSmall */.xA);
const LoadingWrapper = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-8815c967-8"
})(components_styles_templateObject8());

;// CONCATENATED MODULE: ./src/features/mini-cart/components/mini-cart-card.tsx
/* eslint-disable @next/next/link-passhref */ 















const mini_cart_card_placeholderImageHandler = (e)=>{
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    const target = e.target;
    target.src = "https://www.datocms-assets.com/65892/1664464657-placeholder-do-not-remove.jpg";
};
const MiniCartCard = (param)=>{
    let { cartItem  } = param;
    var ref, ref1, ref2, ref3;
    const variantId = cartItem.variant.id;
    const [showAnim, setShowAnim] = (0,react.useState)(false);
    const count = (0,lib_api_products_src/* useCartItemCount */.PO)(variantId);
    var _gross, ref4;
    const totalPrice = (0,lib_api_price_src/* getPrice */.aS)((ref4 = (_gross = cartItem === null || cartItem === void 0 ? void 0 : (ref = cartItem.totalPrice) === null || ref === void 0 ? void 0 : ref.discountedAmount.gross) !== null && _gross !== void 0 ? _gross : cartItem === null || cartItem === void 0 ? void 0 : (ref1 = cartItem.totalPrice) === null || ref1 === void 0 ? void 0 : ref1.amount.gross) !== null && ref4 !== void 0 ? ref4 : 0);
    const { setCartQuantity , removeFromCart , loadingVariantIdCollection  } = (0,hooks_cart_src/* useCart */.jD)();
    const { width  } = (0,lib_styles_src/* useWindowSize */.iP)();
    const displayName = (0,react.useMemo)(()=>{
        if (cartItem.variant.name && cartItem.variant.name.length) {
            return cartItem.variant.name;
        } else if (cartItem.variant.product.name && cartItem.variant.product.name.length) {
            return cartItem.variant.product.name;
        }
        // this should never happen
        return "";
    }, [
        cartItem.variant.name,
        cartItem.variant.product.name
    ]);
    const isloading = loadingVariantIdCollection.includes(variantId);
    (0,react.useEffect)(()=>{
        setShowAnim(true);
    }, []);
    const handleRemove = (0,react.useCallback)(()=>{
        removeFromCart({
            variantId
        });
    }, [
        removeFromCart,
        variantId
    ]);
    const setQuantity = (0,useDebouncedCallback/* default */.Z)((quantity)=>{
        if (isNaN(quantity)) {
            return;
        }
        setCartQuantity({
            variantId,
            quantity: quantity
        });
    }, 0);
    var _productList, ref5;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardContainer, {
        isloading: isloading,
        showAnim: showAnim,
        children: [
            isloading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(LoaderContainer, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(component_loaders_src.MainLoader, {
                    size: 24
                })
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(component_buttons_src/* IconButton */.hU, {
                ariaLabel: "Ey\xf0a \xfar k\xf6rfu",
                disabled: loadingVariantIdCollection.length > 0,
                icon: lib_icons_src.CancelSmallIcons,
                small: true,
                title: "Ey\xf0a \xfar k\xf6rfu",
                onClick: handleRemove
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ProdImageWrapper, {
                href: "/vara/".concat(cartItem.variant.product.slug),
                children: [
                    cartItem.variant.webstoreInStock === false && /*#__PURE__*/ (0,jsx_runtime.jsx)(OutOfStockWrapper, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(component_typography_src/* PSmallBold */.cZ, {
                            textColor: lib_styles_src/* theme.palette.triggers.warning.main */.rS.palette.triggers.warning.main,
                            children: "Uppselt"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ProdImage, {
                        alt: cartItem.variant.name,
                        src: (ref5 = (_productList = (ref2 = cartItem.variant.firstImage) === null || ref2 === void 0 ? void 0 : ref2.image.productList) !== null && _productList !== void 0 ? _productList : (ref3 = cartItem.variant.product.firstImage) === null || ref3 === void 0 ? void 0 : ref3.image.productList) !== null && ref5 !== void 0 ? ref5 : "https://www.datocms-assets.com/65892/1664464657-placeholder-do-not-remove.jpg",
                        onError: mini_cart_card_placeholderImageHandler
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(FlexWrapper, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ProdInfoWrapper, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: "/vara/".concat(cartItem.variant.product.slug),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(component_typography_src/* PSmall */.zK, {
                                    textColor: lib_styles_src/* theme.palette.blue.dark */.rS.palette.blue.dark,
                                    children: displayName
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(component_typography_src/* SubtitleBold */.zE, {
                                className: "minicart-price-item",
                                children: totalPrice === null || totalPrice === void 0 ? void 0 : totalPrice.humanReadable
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(component_typography_src/* SubtitleBold */.zE, {
                                className: "hidden minicart-price-item-quantity",
                                children: count
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(QuantityInputWrapper, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(component_quantity_input_src/* QuantityInput */.F, {
                            miniVersion: width < lib_styles_src/* gridTheme.container.maxWidth.s */.k.container.maxWidth.s ? true : false,
                            quantity: count,
                            setQuantity: setQuantity,
                            stretch: false
                        })
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/features/mini-cart/components/index.ts


;// CONCATENATED MODULE: ./src/features/mini-cart/index.tsx
















const MiniCart = ()=>{
    var ref;
    const miniCartRef = (0,react.useRef)(null);
    const { user , setShowAsGuestOption , activeMembership  } = (0,hooks_auth_next_src/* useAuth */.aC)();
    const [_open, setOpen] = (0,lib_recoil_src/* useRecoilState */.FV)(component_drawer_src/* drawerState */.Z$);
    const { width  } = (0,lib_styles_src/* useWindowSize */.iP)();
    const router = (0,next_router.useRouter)();
    const { toggleShowMinicart , showMinicart  } = (0,hooks_cart_src/* useCart */.jD)();
    const { checkoutData , fetchCheckoutData  } = (0,hooks_cart_src/* useCheckoutExtra */.Ol)();
    (0,es.useQuery)([
        activeMembership === null || activeMembership === void 0 ? void 0 : activeMembership.id,
        user === null || user === void 0 ? void 0 : user.id,
        "checkoutData"
    ], fetchCheckoutData, {
        enabled: !!showMinicart,
        refetchOnWindowFocus: false
    });
    const goToCartPage = (0,react.useCallback)(()=>{
        toggleShowMinicart();
        router.push("/karfa");
    }, [
        toggleShowMinicart,
        router
    ]);
    const goToCheckoutPage = (0,react.useCallback)(()=>{
        const prefersAnonymousCheckout = sessionStorage.getItem("prefers-anonymous-checkout");
        if (!user && !prefersAnonymousCheckout) {
            setShowAsGuestOption(false); // TODO: should be true - Andri
            setOpen(true);
            toggleShowMinicart();
        } else {
            toggleShowMinicart();
            router.push("/kaupferli");
        }
    }, [
        toggleShowMinicart,
        user,
        setShowAsGuestOption,
        setOpen,
        router
    ]);
    const handleToggleMinicart = (0,react.useCallback)(()=>{
        toggleShowMinicart();
    }, [
        toggleShowMinicart
    ]);
    const closeMinicart = (0,react.useCallback)(()=>{
        toggleShowMinicart(false);
    }, [
        toggleShowMinicart
    ]);
    (0,esm/* useOnClickOutside */.t$)(miniCartRef, closeMinicart);
    const hasSoldOutProduct = (0,react.useMemo)(()=>{
        const soldOutProduct = checkoutData === null || checkoutData === void 0 ? void 0 : checkoutData.lines.find((line)=>line.variant.webstoreInStock === false);
        return soldOutProduct != null;
    }, [
        checkoutData === null || checkoutData === void 0 ? void 0 : checkoutData.lines
    ]);
    if (!showMinicart) {
        return null;
    }
    if ((checkoutData === null || checkoutData === void 0 ? void 0 : checkoutData.quantity) === 0 || (checkoutData === null || checkoutData === void 0 ? void 0 : checkoutData.quantity) == null) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(MiniCartContainer, {
            ref: miniCartRef,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(SpaceBetween, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(component_typography_src/* PMediumBold */.zo, {
                        textColor: lib_styles_src/* theme.palette.gray.90 */.rS.palette.gray[90],
                        children: "Karfan \xfe\xedn er t\xf3m"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(component_buttons_src/* IconButton */.hU, {
                        ariaLabel: "",
                        icon: lib_icons_src.ArrowUpIcons,
                        small: true,
                        onClick: handleToggleMinicart
                    })
                ]
            })
        });
    }
    var ref1, _gross;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(MiniCartContainer, {
        ref: miniCartRef,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(SpaceBetween, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(component_typography_src/* PMediumBold */.zo, {
                        textColor: lib_styles_src/* theme.palette.gray.90 */.rS.palette.gray[90],
                        children: [
                            (ref1 = checkoutData === null || checkoutData === void 0 ? void 0 : checkoutData.quantity) !== null && ref1 !== void 0 ? ref1 : 0,
                            " ",
                            (checkoutData === null || checkoutData === void 0 ? void 0 : checkoutData.quantity) === 1 ? "Vara \xed k\xf6rfu" : "V\xf6rur \xed k\xf6rfu"
                        ]
                    }),
                    width > lib_styles_src/* gridTheme.container.maxWidth.s */.k.container.maxWidth.s && /*#__PURE__*/ (0,jsx_runtime.jsx)(component_buttons_src/* IconButton */.hU, {
                        ariaLabel: "",
                        icon: lib_icons_src.ArrowUpIcons,
                        small: true,
                        onClick: handleToggleMinicart
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CartCardWrapper, {
                children: checkoutData === null || checkoutData === void 0 ? void 0 : checkoutData.lines.map((cartItem)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(MiniCartCard, {
                        cartItem: cartItem
                    }, cartItem.variant.id))
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(SpaceBetween, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(component_typography_src/* PSmallBold */.cZ, {
                        textColor: lib_styles_src/* theme.palette.gray.90 */.rS.palette.gray[90],
                        children: "Ver\xf0 samtals"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(component_typography_src.H6, {
                        maxFontSize: "28px",
                        textColor: lib_styles_src/* theme.palette.blue.main */.rS.palette.blue.main,
                        children: (ref = (0,lib_api_price_src/* getPrice */.aS)((_gross = checkoutData === null || checkoutData === void 0 ? void 0 : checkoutData.subTotalPrice.gross) !== null && _gross !== void 0 ? _gross : 0)) === null || ref === void 0 ? void 0 : ref.humanReadable
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ButtonSpaceBetween, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(component_buttons_src/* Button */.zx, {
                        icon: lib_icons_src.CartIcons,
                        label: "Sko\xf0a k\xf6rfu",
                        stretch: true,
                        onClick: goToCartPage
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(component_buttons_src/* Button */.zx, {
                        buttonColor: "blueButton",
                        disabled: hasSoldOutProduct,
                        icon: lib_icons_src.LongArrowSideIcons,
                        label: "Ganga fr\xe1 kaupum",
                        stretch: true,
                        onClick: goToCheckoutPage
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/features/header/index.tsx





















const EMPTY = [];
const Header = (param)=>{
    let { mockMemberships  } = param;
    const { data  } = lib_dato_src/* datoQueries.useGetHeaderText */.t.useGetHeaderText();
    const router = (0,next_router.useRouter)();
    const { toggleShowMinicart , cartAdditionNotifications  } = (0,hooks_cart_src/* useCart */.jD)();
    const [blockOpen, setBlockOpen] = (0,react.useState)(false);
    const currentSearchInputValue = (0,search_provider/* useSearchValue */.Wp)();
    const setShowQuickSearch = (0,search_provider/* useSetShowQuickSearchResultsValue */.BW)();
    const setSearchBarHasFocus = (0,search_provider/* useSetSearchBarHasFocusStore */.dv)();
    const setCurrentSearchInputValue = (0,search_provider/* useSetSearchValue */.hp)();
    const [open, setOpen] = (0,lib_recoil_src/* useRecoilState */.FV)(component_drawer_src/* drawerState */.Z$);
    const { setIsOpen  } = useMegamenu();
    const { checkoutData , fetchCheckoutData , cartItemCount  } = (0,hooks_cart_src/* useCheckoutExtra */.Ol)();
    const { memberships , activeMembership , fetchUser , isAuthLoaded , user  } = (0,hooks_auth_next_src/* useAuth */.aC)();
    (0,es.useQuery)([
        activeMembership === null || activeMembership === void 0 ? void 0 : activeMembership.id,
        user === null || user === void 0 ? void 0 : user.id,
        "checkoutData"
    ], fetchCheckoutData, {
        enabled: isAuthLoaded,
        refetchOnWindowFocus: false
    });
    const addToCartNotifyList = (0,react.useMemo)(()=>{
        const items = [];
        checkoutData === null || checkoutData === void 0 ? void 0 : checkoutData.lines.forEach((item)=>{
            if (cartAdditionNotifications.includes(item.variant.id)) {
                lib_analytics_src/* analytics.addProductToCart */.c.addProductToCart(item, item.quantity);
                items.push(item);
            }
        });
        return items;
    }, [
        cartAdditionNotifications,
        checkoutData === null || checkoutData === void 0 ? void 0 : checkoutData.lines
    ]);
    const closeAllMenus = (0,react.useCallback)(()=>{
        setIsOpen(false);
        setOpen(false);
        toggleShowMinicart(false);
    }, [
        setIsOpen,
        setOpen,
        toggleShowMinicart
    ]);
    (0,react.useEffect)(()=>{
        setBlockOpen(true);
        const timeOutID = setTimeout(()=>{
            setBlockOpen(false);
        }, 400);
        return ()=>{
            clearTimeout(timeOutID);
        };
    }, [
        open
    ]);
    const doSearch = (0,react.useCallback)(()=>{
        if (!router.pathname.startsWith("/vorur")) {
            router.push("/leit?q=".concat(currentSearchInputValue));
            setCurrentSearchInputValue("");
            return;
        }
        setCurrentSearchInputValue("");
        router.push("/vorur?q=".concat(currentSearchInputValue));
    }, [
        currentSearchInputValue,
        router,
        setCurrentSearchInputValue
    ]);
    const handleSearchChange = (0,react.useCallback)((ev)=>{
        if (ev.key === "Enter") {
            setShowQuickSearch(false);
            if (!router.pathname.startsWith("/vorur")) {
                router.push("/leit?q=".concat(ev.target.value));
                setCurrentSearchInputValue("");
                return;
            }
            router.push("/vorur?q=".concat(ev.target.value));
            setCurrentSearchInputValue("");
        }
    }, [
        router,
        setCurrentSearchInputValue,
        setShowQuickSearch
    ]);
    const handleSetSearchValue = (0,react.useCallback)((value)=>{
        if (value.target.value === "") {
            setShowQuickSearch(false);
        } else {
            setShowQuickSearch(true);
        }
        var _value;
        setCurrentSearchInputValue((_value = value.target.value) !== null && _value !== void 0 ? _value : "");
    }, [
        setCurrentSearchInputValue,
        setShowQuickSearch
    ]);
    const toggleMegamenu = (0,react.useCallback)(()=>{
        setIsOpen((current)=>{
            return !current;
        });
        // login menu / minicart toggle
        setOpen(false);
        toggleShowMinicart(false);
    }, [
        setIsOpen,
        setOpen,
        toggleShowMinicart
    ]);
    (0,react.useEffect)(()=>{
        fetchUser().catch((err)=>console.error(err));
    }, [
        fetchUser
    ]);
    const mockActiveMemberShip = (0,react.useMemo)(()=>{
        if (mockMemberships && mockMemberships.length !== 0) {
            return mockMemberships[0];
        }
        return null;
    }, [
        mockMemberships
    ]);
    const closeDrawer = (0,react.useCallback)(()=>{
        setOpen(false);
    }, [
        setOpen
    ]);
    const toggleOpen = (0,react.useCallback)(()=>{
        if (!open && !blockOpen) {
            setOpen(true);
        }
        setIsOpen(false);
        toggleShowMinicart(false);
    }, [
        blockOpen,
        open,
        setIsOpen,
        setOpen,
        toggleShowMinicart
    ]);
    const handleToggleMinicart = (0,react.useCallback)(()=>{
        toggleShowMinicart();
        setIsOpen(false);
        setOpen(false);
    }, [
        setIsOpen,
        setOpen,
        toggleShowMinicart
    ]);
    const showQuickSearch = (0,react.useCallback)(()=>{
        closeAllMenus();
        setSearchBarHasFocus(true);
        setShowQuickSearch(true);
    }, [
        closeAllMenus,
        setSearchBarHasFocus,
        setShowQuickSearch
    ]);
    const onSearchInputBlur = (0,react.useCallback)(()=>{
        setSearchBarHasFocus(false);
    }, [
        setSearchBarHasFocus
    ]);
    var ref, ref1, ref2, ref3;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Wrapper, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(NavBarWrapper, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(NavBar, {
                            id: "navbar",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Navigation, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_LogoWrapper, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: "/",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lib_icons_src.BykoMainLogo, {
                                                    width: 100
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(FlexRow, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(MegaMenuTriggerWrapper, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(component_buttons_src/* Button */.zx, {
                                                        customClassName: "menuButton",
                                                        icon: lib_icons_src.MenuIcons,
                                                        label: (ref = data === null || data === void 0 ? void 0 : data.labelForMegamenuButton) !== null && ref !== void 0 ? ref : "Valmynd",
                                                        stretch: true,
                                                        onClick: toggleMegamenu
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchInputWrapper, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(component_inputs_src/* SearchInput */.Mj, {
                                                        border: true,
                                                        placeholder: (ref1 = data === null || data === void 0 ? void 0 : data.hintTextForSearchBarLargeScreens) !== null && ref1 !== void 0 ? ref1 : "Leita",
                                                        value: currentSearchInputValue,
                                                        onBlur: onSearchInputBlur,
                                                        onChange: handleSetSearchValue,
                                                        onFocus: showQuickSearch,
                                                        onIconClick: doSearch,
                                                        onKeyDown: handleSearchChange
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Icons, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(IconButtonWrapper, {
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(component_buttons_src/* IconButton */.hU, {
                                                                    ariaLabel: "karfa",
                                                                    icon: lib_icons_src.CartIcons,
                                                                    onClick: handleToggleMinicart
                                                                }),
                                                                cartItemCount >= 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)(CartCounterWrapper, {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CartCount, {
                                                                        children: cartItemCount
                                                                    })
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(PositionWrapper, {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MiniCart, {}, cartItemCount)
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileIconButtonWrapper, {
                                                    children: activeMembership !== null ? /*#__PURE__*/ (0,jsx_runtime.jsx)(DropdownSelect, {
                                                        active: activeMembership,
                                                        fullWidth: true,
                                                        iconButton: true,
                                                        options: memberships,
                                                        onClick: closeDrawer
                                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(component_buttons_src/* IconButton */.hU, {
                                                        ariaLabel: open ? "Loka" : "Innskr\xe1",
                                                        buttonColor: "whiteButton",
                                                        customClassName: "loginButton",
                                                        icon: open ? lib_icons_src.CancelLargeIcons : lib_icons_src.NotandiIcons,
                                                        onClick: toggleOpen
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(LoginWrapper, {
                                    children: [
                                        mockActiveMemberShip && /*#__PURE__*/ (0,jsx_runtime.jsx)(DropdownSelect, {
                                            active: mockActiveMemberShip,
                                            options: mockMemberships !== null && mockMemberships !== void 0 ? mockMemberships : EMPTY
                                        }),
                                        activeMembership === null ? /*#__PURE__*/ (0,jsx_runtime.jsx)(component_buttons_src/* Button */.zx, {
                                            buttonColor: "blueButton",
                                            customClassName: "loginButton",
                                            icon: open ? lib_icons_src.CancelLargeIcons : lib_icons_src.LongArrowSideIcons,
                                            label: open ? "Loka" : (ref2 = data === null || data === void 0 ? void 0 : data.labelForLoginButton) !== null && ref2 !== void 0 ? ref2 : "Innskr\xe1",
                                            stretch: true,
                                            onClick: toggleOpen
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(DropdownSelect, {
                                            active: activeMembership,
                                            options: memberships,
                                            onClick: closeDrawer
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Burger, {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileSelection, {
                                    mockMemberships: mockMemberships
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileSearchContainer, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(component_inputs_src/* SearchInput */.Mj, {
                                iconColor: lib_styles_src/* theme.palette.gray.20 */.rS.palette.gray[20],
                                placeholder: (ref3 = data === null || data === void 0 ? void 0 : data.hintTextForSearchBarSmallScreens) !== null && ref3 !== void 0 ? ref3 : "Leita",
                                value: currentSearchInputValue,
                                onBlur: onSearchInputBlur,
                                onChange: handleSetSearchValue,
                                onFocus: showQuickSearch,
                                onIconClick: doSearch,
                                onKeyDown: handleSearchChange
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AddToCartNotifyWrapper, {
                children: addToCartNotifyList.map((param)=>{
                    let { variant , id  } = param;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(AddToCartToast, {
                        variant: variant
                    }, id);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(component_drawer_src/* Drawer */.dy, {
                noCloseButton: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(component_login_src/* LoginSteps */.nL, {})
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/features/megamenu-container/components/styles.ts
function megamenu_container_components_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function megamenu_container_components_styles_templateObject() {
    const data = megamenu_container_components_styles_taggedTemplateLiteral([
        "\n  position: relative;\n  display: flex;\n  width: fit-content;\n  align-items: center;\n  padding-bottom: 2px;\n\n  h6 {\n    -webkit-font-smoothing: antialiased;\n    font-weight: 400;\n    transition: 200ms;\n    @media screen and (min-width: 1625px) {\n      font-size: 28px;\n    }\n  }\n  @media screen and (max-height: 640px) and (min-width: 1438px) {\n    h6 {\n      font-size: 24px;\n    }\n  }\n\n  &:after {\n    position: absolute;\n    bottom: 0;\n    width: ",
        ";\n    border-bottom: 2px solid ",
        ';\n    content: "";\n    transition: 300ms;\n    @media screen and (max-width: 599px) {\n      display: none;\n    }\n  }\n  &:focus,\n  &:hover {\n    h6 {\n      color: ',
        ";\n    }\n    &:after {\n      width: ",
        ";\n    }\n  }\n\n  @media screen and (max-width: 1200px) {\n    &:after {\n      bottom: -24px;\n    }\n  }\n"
    ]);
    megamenu_container_components_styles_templateObject = function() {
        return data;
    };
    return data;
}
function megamenu_container_components_styles_templateObject1() {
    const data = megamenu_container_components_styles_taggedTemplateLiteral([
        "\n  position: relative;\n  display: flex;\n  width: fit-content;\n  align-items: center;\n  transition: 300ms;\n  p {\n    text-align: left;\n    @media screen and (min-width: 468px) {\n      font-size: 24px !important;\n    }\n  }\n  &:after {\n    position: absolute;\n    bottom: -8px;\n    left: ",
        ";\n    width: ",
        ";\n    border-bottom: 2px solid ",
        ';\n    content: "";\n    transition: 300ms;\n    transition-delay: 120ms;\n  }\n  &:focus,\n  &:hover {\n    &:after {\n      width: ',
        ";\n      transition-delay: 0ms;\n    }\n  }\n"
    ]);
    megamenu_container_components_styles_templateObject1 = function() {
        return data;
    };
    return data;
}
function megamenu_container_components_styles_templateObject2() {
    const data = megamenu_container_components_styles_taggedTemplateLiteral([
        "\n  position: relative;\n  z-index: 3;\n  display: flex;\n  height: 100%;\n  flex-direction: column;\n  justify-content: flex-start;\n  padding-top: 58px;\n  padding-right: 64px;\n  padding-bottom: 64px;\n  padding-left: 48px;\n  border-right: ",
        " solid ",
        ";\n  background-color: ",
        ";\n  opacity: ",
        ";\n  overflow-y: scroll;\n  row-gap: 32px;\n  transform: translate3d(",
        ", 0, 0);\n  transition: 300ms;\n  @media screen and (max-width: 1438px) {\n    padding-top: 120px;\n  }\n  @media screen and (min-width: 1300px) {\n    row-gap: 40px;\n  }\n  @media screen and (max-width: 1200px) {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: calc(100vw + 2px);\n    padding-top: 131px;\n    transform: translate3d(",
        ", 0, 0);\n  }\n  ::-webkit-scrollbar {\n    width: 4px;\n  }\n\n  ::-webkit-scrollbar-track {\n    background-color: ",
        ";\n  }\n\n  ::-webkit-scrollbar-thumb {\n    background-color: ",
        ";\n  }\n"
    ]);
    megamenu_container_components_styles_templateObject2 = function() {
        return data;
    };
    return data;
}
function megamenu_container_components_styles_templateObject3() {
    const data = megamenu_container_components_styles_taggedTemplateLiteral([
        "\n  margin-bottom: 12px;\n"
    ]);
    megamenu_container_components_styles_templateObject3 = function() {
        return data;
    };
    return data;
}
function megamenu_container_components_styles_templateObject4() {
    const data = megamenu_container_components_styles_taggedTemplateLiteral([
        "\n  opacity: ",
        ";\n  transform: translate3d(",
        ", 0, 0);\n  transition: 300ms;\n"
    ]);
    megamenu_container_components_styles_templateObject4 = function() {
        return data;
    };
    return data;
}
function megamenu_container_components_styles_templateObject5() {
    const data = megamenu_container_components_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n"
    ]);
    megamenu_container_components_styles_templateObject5 = function() {
        return data;
    };
    return data;
}
function megamenu_container_components_styles_templateObject6() {
    const data = megamenu_container_components_styles_taggedTemplateLiteral([
        "\n  position: relative;\n  display: grid;\n  width: fit-content;\n  align-items: center;\n  grid-template-columns: auto auto;\n  svg {\n    transform: translate3d(4px, -7px, 0);\n  }\n  &:after {\n    position: absolute;\n    bottom: 6px;\n    width: 0px;\n    border-bottom: 2px solid ",
        ';\n    content: "";\n    transition: 300ms;\n  }\n'
    ]);
    megamenu_container_components_styles_templateObject6 = function() {
        return data;
    };
    return data;
}
function megamenu_container_components_styles_templateObject7() {
    const data = megamenu_container_components_styles_taggedTemplateLiteral([
        "\n  position: absolute;\n  z-index: 1;\n  display: block;\n  backdrop-filter: ",
        ";\n  cursor: default;\n  inset: 0;\n  opacity: ",
        ";\n  transition: 400ms;\n  transition-delay: 100ms;\n"
    ]);
    megamenu_container_components_styles_templateObject7 = function() {
        return data;
    };
    return data;
}



const NavigationOption = styled_components_browser_cjs["default"].button.withConfig({
    componentId: "sc-94df8bb2-0"
})(megamenu_container_components_styles_templateObject(), (props)=>props.active ? "100%" : "32px", lib_styles_src/* theme.palette.yellow.main */.rS.palette.yellow.main, (props)=>props.active ? lib_styles_src/* theme.palette.white.main */.rS.palette.white.main : lib_styles_src/* theme.palette.yellow.main */.rS.palette.yellow.main, (props)=>props.active ? "100%" : "64px");
const SubNavigationOption = styled_components_browser_cjs["default"].button.withConfig({
    componentId: "sc-94df8bb2-1"
})(megamenu_container_components_styles_templateObject1(), (props)=>props.isLink ? "24px" : "0", (props)=>props.active ? "calc(100% + 16px)" : "0px", (props)=>props.isLink ? lib_styles_src/* theme.palette.yellow.dark */.rS.palette.yellow.dark : lib_styles_src/* theme.palette.blue.main */.rS.palette.blue.main, (props)=>props.active || props.isLink ? "100%" : "32px");
const SubNavigationOptionsColumn = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-94df8bb2-2"
})(megamenu_container_components_styles_templateObject2(), (props)=>props.hideBorder ? "0px" : "2px", lib_styles_src/* theme.palette.blue.light */.rS.palette.blue.light, lib_styles_src/* theme.palette.white.main */.rS.palette.white.main, (props)=>props.entered ? "1" : "0", (props)=>props.entered ? "0px" : "-100px", (props)=>props.hasSelection ? "-101vw" : "0", lib_styles_src/* theme.palette.white.main */.rS.palette.white.main, lib_styles_src/* theme.palette.blue.main */.rS.palette.blue.main);
const SubContentHeader = (0,styled_components_browser_cjs["default"])(component_typography_src/* PLargeBold */.ej).withConfig({
    componentId: "sc-94df8bb2-3"
})(megamenu_container_components_styles_templateObject3());
const LinkIcon = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-94df8bb2-4"
})(megamenu_container_components_styles_templateObject4(), (props)=>props.showLinkIcon ? "1" : "0", (props)=>props.showLinkIcon ? "16px" : "8px");
const HeaderButton = styled_components_browser_cjs["default"].button.withConfig({
    componentId: "sc-94df8bb2-5"
})(megamenu_container_components_styles_templateObject5());
const HeaderRow = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-94df8bb2-6"
})(megamenu_container_components_styles_templateObject6(), lib_styles_src/* theme.palette.yellow.dark */.rS.palette.yellow.dark);
const ClickAwayBackdrop = styled_components_browser_cjs["default"].button.withConfig({
    componentId: "sc-94df8bb2-7"
})(megamenu_container_components_styles_templateObject7(), (props)=>props.blur ? "blur(4px) grayscale(0.4)" : "blur(4px) grayscale(0.4)", (props)=>props.blur ? "1" : "0");

;// CONCATENATED MODULE: ./src/features/megamenu-container/components/navigation-option-row.tsx






const NavigationOptionRow = (param)=>{
    let { active , index , setActive , label , isLink , tabIndex , goToPage  } = param;
    const setLocalActive = (0,react.useCallback)(()=>{
        setActive(index);
    }, [
        index,
        setActive
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(NavigationOption, {
        active: active,
        isLink: isLink,
        tabIndex: tabIndex,
        onClick: isLink ? goToPage : setLocalActive,
        children: [
            isLink === false && /*#__PURE__*/ (0,jsx_runtime.jsx)(lib_icons_src.ArrowRightIcons, {
                iconColor: lib_styles_src/* theme.palette.yellow.main */.rS.palette.yellow.main,
                size: 32
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(component_typography_src.H6, {
                maxFontSize: "28px",
                textColor: lib_styles_src/* theme.palette.white.main */.rS.palette.white.main,
                children: label
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/features/megamenu-container/components/sub-navigation-option-row.tsx






const SubNavigationOptionRow = (param)=>{
    let { active , index , setActive , label , isLink , goToPage  } = param;
    const [showLinkIcon, setShowLinkIcon] = (0,react.useState)(false);
    const handleHoverEnter = (0,react.useCallback)(()=>{
        setShowLinkIcon(true);
    }, []);
    const handleHoverExit = (0,react.useCallback)(()=>{
        setShowLinkIcon(false);
    }, []);
    const setLocalActive = (0,react.useCallback)(()=>{
        setActive(index);
    }, [
        index,
        setActive
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SubNavigationOption, {
        active: active,
        isLink: isLink,
        onClick: isLink ? goToPage : setLocalActive,
        onMouseOut: handleHoverExit,
        onMouseOver: handleHoverEnter,
        children: [
            isLink === false && /*#__PURE__*/ (0,jsx_runtime.jsx)(lib_icons_src.ArrowRightIcons, {
                iconColor: lib_styles_src/* theme.palette.blue.dark */.rS.palette.blue.dark,
                size: 24
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(component_typography_src/* PMedium */.aW, {
                left: isLink ? 30 : 6,
                lineHeight: "100%",
                textColor: lib_styles_src/* theme.palette.blue.dark */.rS.palette.blue.dark,
                children: label
            }),
            isLink === true && /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkIcon, {
                showLinkIcon: showLinkIcon,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lib_icons_src.LongArrowSideIcons, {
                    iconColor: lib_styles_src/* theme.palette.blue.dark */.rS.palette.blue.dark,
                    size: 24
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/features/megamenu-container/components/sub-navigation-options.tsx
/* eslint-disable react/jsx-no-bind */ /* eslint-disable react-perf/jsx-no-new-function-as-prop */ 





const SubNavigationOptions = (param)=>{
    let { menu , activeSubIndex , setActiveSubIndex , hideBorder , startingTabIndex , hideHeader , goToChildPage , navigatingProducts =false  } = param;
    const [entered, setEntered] = (0,react.useState)(false);
    (0,react.useEffect)(()=>{
        if (menu === null || menu.children === null || menu.children === undefined || menu.children.length === 0) {
            setEntered(false);
        } else {
            setEntered(true);
        }
    }, [
        menu
    ]);
    if (menu === null || menu.children === null || menu.children === undefined || menu.children.length === 0) {
        return null;
    }
    var ref;
    const isInitialProductCategory = (ref = navigatingProducts && menu.slug === "voruflokkar" || navigatingProducts && menu.slug === "bykoleiga") !== null && ref !== void 0 ? ref : false;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SubNavigationOptionsColumn, {
        entered: entered,
        hasSelection: typeof activeSubIndex === "number",
        hideBorder: hideBorder !== null && hideBorder !== void 0 ? hideBorder : false,
        children: [
            hideHeader !== true && /*#__PURE__*/ (0,jsx_runtime.jsxs)(HeaderRow, {
                children: [
                    (menu.canBeNavigatedToInMegamenu == false || isInitialProductCategory) && /*#__PURE__*/ (0,jsx_runtime.jsx)(SubContentHeader, {
                        lineHeight: "120%",
                        textAlign: "left",
                        textColor: lib_styles_src/* theme.palette.blue.dark */.rS.palette.blue.dark,
                        children: menu.title
                    }),
                    (navigatingProducts === true || menu.canBeNavigatedToInMegamenu == true) && isInitialProductCategory == false && /*#__PURE__*/ (0,jsx_runtime.jsxs)(HeaderButton, {
                        onClick: ()=>goToChildPage(menu.url),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SubContentHeader, {
                                lineHeight: "120%",
                                textAlign: "left",
                                textColor: lib_styles_src/* theme.palette.blue.dark */.rS.palette.blue.dark,
                                children: menu.title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(lib_icons_src.LongArrowSideIcons, {
                                iconColor: lib_styles_src/* theme.palette.blue.dark */.rS.palette.blue.dark,
                                size: 16
                            })
                        ]
                    })
                ]
            }),
            menu === null || menu === void 0 ? void 0 : menu.children.map((_menuItem, index)=>{
                var ref;
                const menuItem = _menuItem;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(SubNavigationOptionRow, {
                    active: activeSubIndex === index,
                    goToPage: ()=>goToChildPage(menuItem.url),
                    index: index,
                    isLink: !((ref = menuItem.children) === null || ref === void 0 ? void 0 : ref.length),
                    label: menuItem.title,
                    setActive: setActiveSubIndex,
                    tabIndex: startingTabIndex + index
                }, menuItem.slug);
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/features/megamenu-container/components/click-away.tsx



const ClickAway = (param)=>{
    let { toggleOpen  } = param;
    const [blur, setBlur] = (0,react.useState)(false);
    (0,react.useEffect)(()=>{
        setBlur(true);
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ClickAwayBackdrop, {
        blur: blur,
        onClick: toggleOpen
    });
};

;// CONCATENATED MODULE: ./src/features/megamenu-container/components/index.ts





;// CONCATENATED MODULE: ./src/features/megamenu-container/styles.ts
function megamenu_container_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function megamenu_container_styles_templateObject() {
    const data = megamenu_container_styles_taggedTemplateLiteral([
        "\n  position: relative;\n  z-index: 3;\n  display: flex;\n  width: 400px;\n  height: 100%;\n  flex-direction: column;\n  justify-content: flex-start;\n  padding-top: 36px;\n  padding-bottom: 32px;\n  background-color: ",
        ";\n  gap: 64px;\n  overflow-y: scroll;\n\n  ::-webkit-scrollbar {\n    width: 4px;\n  }\n\n  ::-webkit-scrollbar-track {\n    background-color: ",
        ";\n  }\n\n  ::-webkit-scrollbar-thumb {\n    background-color: ",
        ";\n  }\n  transform: translate3d(",
        ", 0, 0);\n  transition: 300ms;\n  @media screen and (max-width: 1200px) {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100vw;\n    height: 100%;\n    justify-content: center;\n  }\n  @media screen and (max-width: 1438px) {\n    padding-top: 16px;\n    padding-bottom: 64px;\n  }\n  @media screen and (max-height: 640px) and (min-width: 1438px) {\n    padding-top: 16px;\n    gap: 24px;\n  }\n  @media screen and (max-height: 480px) {\n    padding-top: 164px;\n    gap: 24px;\n  }\n"
    ]);
    megamenu_container_styles_templateObject = function() {
        return data;
    };
    return data;
}
function megamenu_container_styles_templateObject1() {
    const data = megamenu_container_styles_taggedTemplateLiteral([
        "\n  z-index: 4;\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  padding-right: 80px;\n  padding-left: 80px;\n  background-color: ",
        ";\n  transition: 300ms;\n  @media screen and (max-height: 640px) and (min-width: 1438px) {\n    padding-right: 40px;\n    padding-left: 40px;\n  }\n  @media screen and (max-width: 1200px) {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 64px;\n    justify-content: ",
        ";\n    padding-right: 24px;\n    padding-left: 24px;\n    border-bottom: 1px solid ",
        ";\n    gap: ",
        ";\n  }\n  @media screen and (min-width: 1300px) {\n    h5 {\n      font-size: 36px;\n    }\n  }\n  @media screen and (max-width: 599px) {\n    display: ",
        ";\n  }\n"
    ]);
    megamenu_container_styles_templateObject1 = function() {
        return data;
    };
    return data;
}
function megamenu_container_styles_templateObject2() {
    const data = megamenu_container_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  padding-left: 36px;\n  margin-right: 80px;\n  row-gap: 48px;\n  @media screen and (max-height: 640px) and (min-width: 1438px) {\n    padding-right: 24px;\n    padding-left: 24px;\n    row-gap: 36px;\n  }\n\n  @media screen and (max-width: 1200px) {\n    padding-left: 24px;\n    margin-right: 24px;\n    row-gap: 36px;\n  }\n  @media screen and (max-width: 480px) {\n    padding-left: 24px;\n    margin-right: 0px;\n    row-gap: 28px;\n  }\n"
    ]);
    megamenu_container_styles_templateObject2 = function() {
        return data;
    };
    return data;
}
function megamenu_container_styles_templateObject3() {
    const data = megamenu_container_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: center;\n  padding-right: 32px;\n  padding-left: 32px;\n"
    ]);
    megamenu_container_styles_templateObject3 = function() {
        return data;
    };
    return data;
}
function megamenu_container_styles_templateObject4() {
    const data = megamenu_container_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  width: 100%;\n  justify-content: center;\n  @media screen and (max-width: 1200px) {\n    display: none;\n  }\n  @media screen and (max-height: 929px) {\n    display: none;\n  }\n"
    ]);
    megamenu_container_styles_templateObject4 = function() {
        return data;
    };
    return data;
}
function megamenu_container_styles_templateObject5() {
    const data = megamenu_container_styles_taggedTemplateLiteral([
        "\n  position: relative;\n  &:after {\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    width: 0%;\n    border-bottom: 2px solid ",
        ';\n    content: "";\n    transition: 300ms;\n  }\n  &:focus,\n  &:hover {\n    &:after {\n      width: 100%;\n    }\n  }\n  @media screen and (max-width: 898px) {\n    display: none;\n  }\n'
    ]);
    megamenu_container_styles_templateObject5 = function() {
        return data;
    };
    return data;
}
function megamenu_container_styles_templateObject6() {
    const data = megamenu_container_styles_taggedTemplateLiteral([
        "\n  position: relative;\n  display: flex;\n  width: 100%;\n  height: 100%;\n  align-items: center;\n  transition: 300ms;\n"
    ]);
    megamenu_container_styles_templateObject6 = function() {
        return data;
    };
    return data;
}
function megamenu_container_styles_templateObject7() {
    const data = megamenu_container_styles_taggedTemplateLiteral([
        "\n  position: fixed;\n  top: 88px;\n  left: 0;\n  display: flex;\n  width: 100vw;\n  height: calc(100% - 88px);\n  flex-direction: row-reverse;\n  transform: translate3d(",
        ", 0, 0);\n  transition: ",
        ";\n  transition-delay: ",
        ";\n  transition-timing-function: ease-in-out;\n  ",
        " {\n    flex-direction: row-reverse;\n    opacity: ",
        ";\n    transition-delay: ",
        ";\n  }\n\n  @media screen and (max-width: 1200px) {\n    top: 144px;\n    height: calc(100% - 144px);\n    transition: 300ms;\n    transition-delay: 0ms;\n    ",
        " {\n      transition-delay: 0ms;\n    }\n  }\n  @media screen and (max-width: 1079px) {\n    top: 112px;\n    height: calc(100% - 112px);\n  }\n"
    ]);
    megamenu_container_styles_templateObject7 = function() {
        return data;
    };
    return data;
}
function megamenu_container_styles_templateObject8() {
    const data = megamenu_container_styles_taggedTemplateLiteral([
        "\n  position: absolute;\n  bottom: 0;\n  left: 100vw;\n  height: 192px;\n  transform: translate3d(-100%, 0, 0);\n  @media screen and (max-width: 1200px) {\n    height: 120px;\n    transform: translate3d(-100%, 24px, 0);\n  }\n"
    ]);
    megamenu_container_styles_templateObject8 = function() {
        return data;
    };
    return data;
}
function megamenu_container_styles_templateObject9() {
    const data = megamenu_container_styles_taggedTemplateLiteral([
        "\n  display: grid;\n  width: 100%;\n  height: 100%;\n  grid-template-columns: 1fr 1fr 1.1fr;\n  @media screen and (max-width: 1200px) {\n    display: block;\n  }\n"
    ]);
    megamenu_container_styles_templateObject9 = function() {
        return data;
    };
    return data;
}
function megamenu_container_styles_templateObject10() {
    const data = megamenu_container_styles_taggedTemplateLiteral([
        ""
    ]);
    megamenu_container_styles_templateObject10 = function() {
        return data;
    };
    return data;
}
function megamenu_container_styles_templateObject11() {
    const data = megamenu_container_styles_taggedTemplateLiteral([
        ""
    ]);
    megamenu_container_styles_templateObject11 = function() {
        return data;
    };
    return data;
}
function styles_templateObject12() {
    const data = megamenu_container_styles_taggedTemplateLiteral([
        "\n  position: relative;\n  z-index: 3000;\n  ",
        " {\n    display: initial;\n  }\n  ",
        " {\n    display: none;\n  }\n  @media screen and (max-width: 1200px) {\n    ",
        " {\n      display: none;\n    }\n    ",
        " {\n      display: initial;\n    }\n  }\n"
    ]);
    styles_templateObject12 = function() {
        return data;
    };
    return data;
}


const MainContent = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-4b420fa0-0"
})(megamenu_container_styles_templateObject(), lib_styles_src/* theme.palette.blue.dark */.rS.palette.blue.dark, lib_styles_src/* theme.palette.blue.dark */.rS.palette.blue.dark, lib_styles_src/* theme.palette.yellow.main */.rS.palette.yellow.main, (props)=>props.show ? "0" : "-100vw");
const Heading = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-4b420fa0-1"
})(megamenu_container_styles_templateObject1(), (props)=>props.darkBackdrop ? lib_styles_src/* theme.palette.blue.dark */.rS.palette.blue.dark : lib_styles_src/* theme.palette.white.main */.rS.palette.white.main, (props)=>props.darkBackdrop ? "space-between" : "flex-start", lib_styles_src/* theme.palette.yellow.main */.rS.palette.yellow.main, (props)=>props.darkBackdrop ? "0px" : "24px", (props)=>props.darkBackdrop ? "none" : "flex");
const NavigationOptions = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-4b420fa0-2"
})(megamenu_container_styles_templateObject2());
const CTABlock = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-4b420fa0-3"
})(megamenu_container_styles_templateObject3());
const CTABlockInner = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-4b420fa0-4"
})(megamenu_container_styles_templateObject4());
const CloseButtonWrapper = styled_components_browser_cjs["default"].button.withConfig({
    componentId: "sc-4b420fa0-5"
})(megamenu_container_styles_templateObject5(), lib_styles_src/* theme.palette.yellow.main */.rS.palette.yellow.main);
const SubContent = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-4b420fa0-6"
})(megamenu_container_styles_templateObject6());
const Container = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-4b420fa0-7"
})(megamenu_container_styles_templateObject7(), (props)=>props.open ? "0" : "-100%", (props)=>props.open ? "300ms" : "1000ms", (props)=>props.open ? "0" : "200ms", SubContent, (props)=>props.open ? "1" : "0", (props)=>props.open ? "300ms" : "0", SubContent);
const MegamenuBackdrop = styled_components_browser_cjs["default"].img.withConfig({
    componentId: "sc-4b420fa0-8"
})(megamenu_container_styles_templateObject8());
const ColumnContainer = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-4b420fa0-9"
})(megamenu_container_styles_templateObject9());
const MobileContainer = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-4b420fa0-10"
})(megamenu_container_styles_templateObject10());
const DesktopContainer = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-4b420fa0-11"
})(megamenu_container_styles_templateObject11());
const MainContainer = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-4b420fa0-12"
})(styles_templateObject12(), DesktopContainer, MobileContainer, DesktopContainer, MobileContainer);

;// CONCATENATED MODULE: ./src/features/megamenu-container/megamenu-mobile.tsx
/* eslint-disable react-perf/jsx-no-new-function-as-prop */ /* eslint-disable react/jsx-no-bind */ 








const DEFAULT_LABEL = "Valmynd";
const MegamenuMobile = (param)=>{
    let { open , toggleOpen , configuration  } = param;
    const router = (0,next_router.useRouter)();
    const [activeIndex, setActiveIndex] = (0,react.useState)(null);
    const [activeSubIndexOne, setActiveSubIndexOne] = (0,react.useState)(null);
    const [activeSubIndexTwo, setActiveSubIndexTwo] = (0,react.useState)(null);
    const [activeSubIndexThree, setActiveSubIndexThree] = (0,react.useState)(null);
    const stepBack = (0,react.useCallback)(()=>{
        if (typeof activeSubIndexTwo === "number") {
            setActiveSubIndexTwo(null);
        } else if (typeof activeSubIndexOne === "number") {
            setActiveSubIndexOne(null);
        } else if (typeof activeIndex === "number") {
            setActiveIndex(null);
        }
    }, [
        activeIndex,
        activeSubIndexOne,
        activeSubIndexTwo
    ]);
    (0,react.useEffect)(()=>{
        if (open === false) {
            setTimeout(()=>{
                // clearing open state after fadeout animation
                setActiveIndex(null);
                setActiveSubIndexOne(null);
                setActiveSubIndexTwo(null);
                setActiveSubIndexThree(null);
            }, 400);
        }
    }, [
        open
    ]);
    const subMenuOne = (0,react.useMemo)(()=>{
        const child = typeof activeIndex === "number" ? configuration[activeIndex] : null;
        if (child) {
            var ref;
            const filteredChildren = (ref = child.children) === null || ref === void 0 ? void 0 : ref.filter((item)=>{
                return item.showInMegamenu;
            });
            const sortedChildren = filteredChildren === null || filteredChildren === void 0 ? void 0 : filteredChildren.sort((a, b)=>{
                return a.menuWeight - b.menuWeight;
            });
            return {
                ...child,
                children: sortedChildren
            };
        }
        return null;
    }, [
        activeIndex,
        configuration
    ]);
    const subMenuTwo = (0,react.useMemo)(()=>{
        var ref;
        const child = typeof activeSubIndexOne === "number" ? subMenuOne === null || subMenuOne === void 0 ? void 0 : (ref = subMenuOne.children) === null || ref === void 0 ? void 0 : ref[activeSubIndexOne] : null;
        if (child) {
            var ref1;
            const filteredChildren = (ref1 = child.children) === null || ref1 === void 0 ? void 0 : ref1.filter((item)=>{
                return item.showInMegamenu;
            });
            const sortedChildren = filteredChildren === null || filteredChildren === void 0 ? void 0 : filteredChildren.sort((a, b)=>{
                return a.menuWeight - b.menuWeight;
            });
            return {
                ...child,
                children: sortedChildren
            };
        }
        return null;
    }, [
        activeSubIndexOne,
        subMenuOne === null || subMenuOne === void 0 ? void 0 : subMenuOne.children
    ]);
    const subMenuThree = (0,react.useMemo)(()=>{
        var ref;
        const child = typeof activeSubIndexTwo === "number" ? subMenuTwo === null || subMenuTwo === void 0 ? void 0 : (ref = subMenuTwo.children) === null || ref === void 0 ? void 0 : ref[activeSubIndexTwo] : null;
        if (child) {
            var ref1;
            const filteredChildren = (ref1 = child.children) === null || ref1 === void 0 ? void 0 : ref1.filter((item)=>{
                return item.showInMegamenu;
            });
            const sortedChildren = filteredChildren === null || filteredChildren === void 0 ? void 0 : filteredChildren.sort((a, b)=>{
                return a.menuWeight - b.menuWeight;
            });
            return {
                ...child,
                children: sortedChildren
            };
        }
        return null;
    }, [
        activeSubIndexTwo,
        subMenuTwo === null || subMenuTwo === void 0 ? void 0 : subMenuTwo.children
    ]);
    const subMenuTwoStartingTabIndex = (0,react.useMemo)(()=>{
        if (subMenuOne === null) {
            return -1;
        }
        return configuration.length + subMenuOne.children.length;
    }, [
        configuration.length,
        subMenuOne
    ]);
    const subMenuThreeStartingTabIndex = (0,react.useMemo)(()=>{
        if (subMenuOne === null || subMenuTwo === null) {
            return -1;
        }
        return configuration.length + subMenuOne.children.length;
    }, [
        configuration.length,
        subMenuOne,
        subMenuTwo
    ]);
    (0,react.useEffect)(()=>{
        setActiveSubIndexOne(null);
    }, [
        activeIndex
    ]);
    (0,react.useEffect)(()=>{
        setActiveSubIndexTwo(null);
    }, [
        activeSubIndexOne
    ]);
    const headingLabel = (0,react.useMemo)(()=>{
        return (subMenuThree === null || subMenuThree === void 0 ? void 0 : subMenuThree.title) || (subMenuTwo === null || subMenuTwo === void 0 ? void 0 : subMenuTwo.title) || (subMenuOne === null || subMenuOne === void 0 ? void 0 : subMenuOne.title) || DEFAULT_LABEL;
    }, [
        subMenuOne === null || subMenuOne === void 0 ? void 0 : subMenuOne.title,
        subMenuThree === null || subMenuThree === void 0 ? void 0 : subMenuThree.title,
        subMenuTwo === null || subMenuTwo === void 0 ? void 0 : subMenuTwo.title
    ]);
    const mainUrl = (0,react.useMemo)(()=>{
        return (subMenuThree === null || subMenuThree === void 0 ? void 0 : subMenuThree.url) || (subMenuTwo === null || subMenuTwo === void 0 ? void 0 : subMenuTwo.url) || (subMenuOne === null || subMenuOne === void 0 ? void 0 : subMenuOne.url) || null;
    }, [
        subMenuOne === null || subMenuOne === void 0 ? void 0 : subMenuOne.url,
        subMenuThree === null || subMenuThree === void 0 ? void 0 : subMenuThree.url,
        subMenuTwo === null || subMenuTwo === void 0 ? void 0 : subMenuTwo.url
    ]);
    const navigatingProducts = (0,react.useMemo)(()=>{
        return (subMenuOne === null || subMenuOne === void 0 ? void 0 : subMenuOne.slug) === "voruflokkar" || (subMenuOne === null || subMenuOne === void 0 ? void 0 : subMenuOne.slug) === "bykoleiga";
    }, [
        subMenuOne === null || subMenuOne === void 0 ? void 0 : subMenuOne.slug
    ]);
    const permitHeaderNavigation = (0,react.useMemo)(()=>{
        return navigatingProducts === true && (subMenuThree == null && subMenuTwo == null && subMenuOne != null) == false || (subMenuThree === null || subMenuThree === void 0 ? void 0 : subMenuThree.canBeNavigatedToInMegamenu) === true || (subMenuTwo === null || subMenuTwo === void 0 ? void 0 : subMenuTwo.canBeNavigatedToInMegamenu) === true || (subMenuOne === null || subMenuOne === void 0 ? void 0 : subMenuOne.canBeNavigatedToInMegamenu) === true;
    }, [
        navigatingProducts,
        subMenuOne,
        subMenuThree,
        subMenuTwo
    ]);
    const goToPage = (0,react.useCallback)((url)=>{
        // check if first character is not /, then add it
        if (url.charAt(0) !== "/") {
            url = "/".concat(url);
        }
        router.push(url);
        toggleOpen();
    }, [
        router,
        toggleOpen
    ]);
    const handleGoToMain = (0,react.useCallback)(()=>{
        if (mainUrl) {
            goToPage(mainUrl);
        }
    }, [
        goToPage,
        mainUrl
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container, {
        open: open,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MainContent, {
                show: typeof activeIndex !== "number",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NavigationOptions, {
                    children: configuration.map((menuItem, index)=>{
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(NavigationOptionRow, {
                            active: activeIndex === index,
                            goToPage: ()=>{
                                return (menuItem === null || menuItem === void 0 ? void 0 : menuItem.url) ? goToPage(menuItem.url) : void 0;
                            },
                            index: index,
                            isLink: menuItem && menuItem.children && menuItem.children.length === 0,
                            label: menuItem.title,
                            setActive: setActiveIndex,
                            tabIndex: index
                        }, menuItem.slug);
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SubContent, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ColumnContainer, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SubNavigationOptions, {
                            activeSubIndex: activeSubIndexThree,
                            goToChildPage: goToPage,
                            goToPage: ()=>{
                                return (subMenuThree === null || subMenuThree === void 0 ? void 0 : subMenuThree.url) ? goToPage(subMenuThree.url) : void 0;
                            },
                            hideHeader: true,
                            menu: subMenuThree,
                            navigatingProducts: navigatingProducts,
                            setActiveSubIndex: setActiveSubIndexThree,
                            startingTabIndex: subMenuThreeStartingTabIndex
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SubNavigationOptions, {
                            activeSubIndex: activeSubIndexTwo,
                            goToChildPage: goToPage,
                            goToPage: ()=>{
                                return (subMenuTwo === null || subMenuTwo === void 0 ? void 0 : subMenuTwo.url) ? goToPage(subMenuTwo.url) : void 0;
                            },
                            hideHeader: true,
                            menu: subMenuTwo,
                            navigatingProducts: navigatingProducts,
                            setActiveSubIndex: setActiveSubIndexTwo,
                            startingTabIndex: subMenuTwoStartingTabIndex
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SubNavigationOptions, {
                            activeSubIndex: activeSubIndexOne,
                            goToChildPage: goToPage,
                            goToPage: ()=>{
                                return (subMenuOne === null || subMenuOne === void 0 ? void 0 : subMenuOne.url) ? goToPage(subMenuOne.url) : void 0;
                            },
                            hideHeader: true,
                            menu: subMenuOne,
                            navigatingProducts: navigatingProducts,
                            setActiveSubIndex: setActiveSubIndexOne,
                            startingTabIndex: configuration.length
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Heading, {
                darkBackdrop: typeof activeIndex !== "number",
                children: [
                    typeof activeIndex === "number" && /*#__PURE__*/ (0,jsx_runtime.jsx)(component_buttons_src/* IconButton */.hU, {
                        ariaLabel: "Til baka",
                        icon: lib_icons_src.ArrowLeftIcons,
                        onClick: stepBack
                    }),
                    typeof activeIndex === "number" && permitHeaderNavigation && /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        type: "button",
                        onClick: handleGoToMain,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(component_typography_src/* PSmallBold */.cZ, {
                            textColor: lib_styles_src/* theme.palette.blue.dark */.rS.palette.blue.dark,
                            children: headingLabel
                        })
                    }),
                    typeof activeIndex === "number" && !permitHeaderNavigation && /*#__PURE__*/ (0,jsx_runtime.jsx)(component_typography_src/* PSmallBold */.cZ, {
                        textColor: lib_styles_src/* theme.palette.blue.dark */.rS.palette.blue.dark,
                        children: headingLabel
                    }),
                    typeof activeIndex !== "number" && /*#__PURE__*/ (0,jsx_runtime.jsx)(component_typography_src.H6, {
                        textColor: lib_styles_src/* theme.palette.white.main */.rS.palette.white.main,
                        children: headingLabel
                    }),
                    typeof activeIndex !== "number" && /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseButtonWrapper, {
                        onClick: toggleOpen,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lib_icons_src.CancelLargeIcons, {
                            iconColor: lib_styles_src/* theme.palette.yellow.main */.rS.palette.yellow.main,
                            size: 32
                        })
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/features/megamenu-container/megamenu.tsx
/* eslint-disable react/jsx-no-bind */ /* eslint-disable react-perf/jsx-no-new-function-as-prop */ 






const Megamenu = (param)=>{
    let { open , toggleOpen , configuration  } = param;
    const router = (0,next_router.useRouter)();
    const [activeIndex, setActiveIndex] = (0,react.useState)(null);
    const [activeSubIndexOne, setActiveSubIndexOne] = (0,react.useState)(null);
    const [activeSubIndexTwo, setActiveSubIndexTwo] = (0,react.useState)(null);
    const [activeSubIndexThree, setActiveSubIndexThree] = (0,react.useState)(null);
    (0,react.useEffect)(()=>{
        if (true) {
            const element = document.querySelector("body");
            if (open) {
                element === null || element === void 0 ? void 0 : element.classList.add("no-scroll");
            } else {
                element === null || element === void 0 ? void 0 : element.classList.remove("no-scroll");
            }
        }
        if (open === false) {
            setTimeout(()=>{
                // clearing open state after fadeout animation
                setActiveIndex(null);
                setActiveSubIndexOne(null);
                setActiveSubIndexTwo(null);
                setActiveSubIndexThree(null);
            }, 400);
        }
    }, [
        open
    ]);
    const subMenuOne = (0,react.useMemo)(()=>{
        const child = typeof activeIndex === "number" ? configuration[activeIndex] : null;
        if (child) {
            var ref;
            const filteredChildren = (ref = child.children) === null || ref === void 0 ? void 0 : ref.filter((item)=>{
                return item.showInMegamenu;
            });
            const sortedChildren = filteredChildren === null || filteredChildren === void 0 ? void 0 : filteredChildren.sort((a, b)=>{
                return a.menuWeight - b.menuWeight;
            });
            return {
                ...child,
                children: sortedChildren
            };
        }
        return null;
    }, [
        activeIndex,
        configuration
    ]);
    const subMenuTwo = (0,react.useMemo)(()=>{
        var ref;
        const child = typeof activeSubIndexOne === "number" ? subMenuOne === null || subMenuOne === void 0 ? void 0 : (ref = subMenuOne.children) === null || ref === void 0 ? void 0 : ref[activeSubIndexOne] : null;
        if (child) {
            var ref1;
            const filteredChildren = (ref1 = child.children) === null || ref1 === void 0 ? void 0 : ref1.filter((item)=>{
                return item.showInMegamenu;
            });
            const sortedChildren = filteredChildren === null || filteredChildren === void 0 ? void 0 : filteredChildren.sort((a, b)=>{
                return a.menuWeight - b.menuWeight;
            });
            return {
                ...child,
                children: sortedChildren
            };
        }
        return null;
    }, [
        activeSubIndexOne,
        subMenuOne === null || subMenuOne === void 0 ? void 0 : subMenuOne.children
    ]);
    const subMenuThree = (0,react.useMemo)(()=>{
        var ref;
        const child = typeof activeSubIndexTwo === "number" ? subMenuTwo === null || subMenuTwo === void 0 ? void 0 : (ref = subMenuTwo.children) === null || ref === void 0 ? void 0 : ref[activeSubIndexTwo] : null;
        if (child) {
            var ref1;
            const filteredChildren = (ref1 = child.children) === null || ref1 === void 0 ? void 0 : ref1.filter((item)=>{
                return item.showInMegamenu;
            });
            const sortedChildren = filteredChildren === null || filteredChildren === void 0 ? void 0 : filteredChildren.sort((a, b)=>{
                return a.menuWeight - b.menuWeight;
            });
            return {
                ...child,
                children: sortedChildren
            };
        }
        return null;
    }, [
        activeSubIndexTwo,
        subMenuTwo === null || subMenuTwo === void 0 ? void 0 : subMenuTwo.children
    ]);
    const subMenuTwoStartingTabIndex = (0,react.useMemo)(()=>{
        if (subMenuOne === null) {
            return -1;
        }
        return configuration.length + subMenuOne.children.length;
    }, [
        configuration.length,
        subMenuOne
    ]);
    const subMenuThreeStartingTabIndex = (0,react.useMemo)(()=>{
        if (subMenuOne === null || subMenuTwo === null) {
            return -1;
        }
        return configuration.length + subMenuOne.children.length;
    }, [
        configuration.length,
        subMenuOne,
        subMenuTwo
    ]);
    (0,react.useEffect)(()=>{
        setActiveSubIndexOne(null);
    }, [
        activeIndex
    ]);
    (0,react.useEffect)(()=>{
        setActiveSubIndexTwo(null);
    }, [
        activeSubIndexOne
    ]);
    const navigatingProducts = (subMenuOne === null || subMenuOne === void 0 ? void 0 : subMenuOne.slug) === "voruflokkar" || (subMenuOne === null || subMenuOne === void 0 ? void 0 : subMenuOne.slug) === "bykoleiga";
    const goToPage = (0,react.useCallback)((url)=>{
        // check if first character is not /, then add it
        if (url.charAt(0) !== "/") {
            url = "/".concat(url);
        }
        router.push(url);
        toggleOpen();
    }, [
        toggleOpen,
        router
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container, {
        open: open,
        children: [
            open && /*#__PURE__*/ (0,jsx_runtime.jsx)(ClickAway, {
                toggleOpen: toggleOpen
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SubContent, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ColumnContainer, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SubNavigationOptions, {
                            activeSubIndex: activeSubIndexOne,
                            goToChildPage: goToPage,
                            goToPage: ()=>{
                                return (subMenuOne === null || subMenuOne === void 0 ? void 0 : subMenuOne.url) ? goToPage(subMenuOne.url) : void 0;
                            },
                            menu: subMenuOne,
                            navigatingProducts: navigatingProducts,
                            setActiveSubIndex: setActiveSubIndexOne,
                            startingTabIndex: configuration.length
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SubNavigationOptions, {
                            activeSubIndex: activeSubIndexTwo,
                            goToChildPage: goToPage,
                            goToPage: ()=>{
                                return (subMenuTwo === null || subMenuTwo === void 0 ? void 0 : subMenuTwo.url) ? goToPage(subMenuTwo.url) : void 0;
                            },
                            menu: subMenuTwo,
                            navigatingProducts: navigatingProducts,
                            setActiveSubIndex: setActiveSubIndexTwo,
                            startingTabIndex: subMenuTwoStartingTabIndex
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SubNavigationOptions, {
                            activeSubIndex: activeSubIndexThree,
                            goToChildPage: goToPage,
                            goToPage: ()=>{
                                return (subMenuThree === null || subMenuThree === void 0 ? void 0 : subMenuThree.url) ? goToPage(subMenuThree.url) : void 0;
                            },
                            hideBorder: true,
                            menu: subMenuThree,
                            navigatingProducts: navigatingProducts,
                            setActiveSubIndex: setActiveSubIndexThree,
                            startingTabIndex: subMenuThreeStartingTabIndex
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(MainContent, {
                show: true,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading, {
                        darkBackdrop: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseButtonWrapper, {
                            onClick: toggleOpen,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lib_icons_src.CancelLargeIcons, {
                                iconColor: lib_styles_src/* theme.palette.yellow.main */.rS.palette.yellow.main,
                                size: 32
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(NavigationOptions, {
                        children: configuration.map((menuItem, index)=>{
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(NavigationOptionRow, {
                                active: activeIndex === index,
                                goToPage: ()=>{
                                    return (menuItem === null || menuItem === void 0 ? void 0 : menuItem.url) ? goToPage(menuItem.url) : void 0;
                                },
                                index: index,
                                isLink: menuItem && menuItem.children && menuItem.children.length === 0,
                                label: menuItem.title,
                                setActive: setActiveIndex,
                                tabIndex: index
                            }, menuItem.slug);
                        })
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/features/megamenu-container/index.tsx






const MegamenuContainer = (param)=>{
    let { startOpen , debug  } = param;
    const { isOpen , menuContent , setIsOpen  } = useMegamenu();
    (0,react.useEffect)(()=>{
        setIsOpen(startOpen !== null && startOpen !== void 0 ? startOpen : false);
    }, [
        setIsOpen,
        startOpen
    ]);
    const toggleOpen = (0,react.useCallback)(()=>{
        setIsOpen((current)=>{
            return !current;
        });
    }, [
        setIsOpen
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            Boolean(debug) === true && /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                type: "button",
                onClick: toggleOpen,
                children: "open menu"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(MainContainer, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileContainer, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MegamenuMobile, {
                            configuration: menuContent,
                            open: isOpen,
                            toggleOpen: toggleOpen
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DesktopContainer, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Megamenu, {
                            configuration: menuContent,
                            open: isOpen,
                            toggleOpen: toggleOpen
                        })
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/features/modal/styles.ts
function modal_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function modal_styles_templateObject() {
    const data = modal_styles_taggedTemplateLiteral([
        "\n  position: fixed;\n  width: 656px;\n  padding: 16px 80px 56px 112px;\n  background-color: ",
        ";\n  box-shadow: 0px 2px 20px ",
        ";\n  opacity: ",
        ";\n  transform: translate3d(0, ",
        ", 0);\n  transition: all 300ms;\n  &:before {\n    position: absolute;\n    width: 8px;\n    background-color: ",
        ';\n    content: "";\n    inset: 0 auto 0 0;\n  }\n\n  @media screen and (max-width: ',
        "px) {\n    width: auto;\n    width: 380px;\n    padding: 16px 80px 56px 64px;\n  }\n\n  @media screen and (max-width: ",
        "px) {\n    width: auto;\n    max-height: 400px;\n    padding: 40px 24px 32px 24px;\n    margin-top: auto;\n    margin-bottom: auto;\n    inset: 0;\n    &:before {\n      background-color: ",
        ';\n      content: "";\n    }\n  }\n'
    ]);
    modal_styles_templateObject = function() {
        return data;
    };
    return data;
}
function modal_styles_templateObject1() {
    const data = modal_styles_taggedTemplateLiteral([
        "\n  position: absolute;\n  inset: 16px 16px auto auto;\n"
    ]);
    modal_styles_templateObject1 = function() {
        return data;
    };
    return data;
}
function modal_styles_templateObject2() {
    const data = modal_styles_taggedTemplateLiteral([
        "\n  display: grid;\n  margin-top: 32px;\n  grid-row-gap: 8px;\n  grid-template-columns: 1fr;\n"
    ]);
    modal_styles_templateObject2 = function() {
        return data;
    };
    return data;
}
function modal_styles_templateObject3() {
    const data = modal_styles_taggedTemplateLiteral([
        "\n  position: fixed;\n  background-color: ",
        ";\n  inset: 0;\n  opacity: 0.5;\n"
    ]);
    modal_styles_templateObject3 = function() {
        return data;
    };
    return data;
}
function modal_styles_templateObject4() {
    const data = modal_styles_taggedTemplateLiteral([
        "\n  position: fixed;\n  z-index: 599;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  inset: 0;\n  opacity: ",
        ";\n  transition: opacity 300ms;\n"
    ]);
    modal_styles_templateObject4 = function() {
        return data;
    };
    return data;
}
function modal_styles_templateObject5() {
    const data = modal_styles_taggedTemplateLiteral([
        "\n  display: grid;\n  margin-top: 16px;\n  grid-column-gap: 16px;\n  grid-template-columns: 24px auto;\n"
    ]);
    modal_styles_templateObject5 = function() {
        return data;
    };
    return data;
}
function modal_styles_templateObject6() {
    const data = modal_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n"
    ]);
    modal_styles_templateObject6 = function() {
        return data;
    };
    return data;
}


const ModalContainer = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-a693a5aa-0"
})(modal_styles_templateObject(), lib_styles_src/* theme.palette.white.main */.rS.palette.white.main, lib_styles_src/* theme.palette.shadow.main */.rS.palette.shadow.main, (props)=>props.active ? "1" : "0", (props)=>props.active ? "0" : "-40px", lib_styles_src/* theme.palette.blue.main */.rS.palette.blue.main, lib_styles_src/* gridTheme.breakpoints.sm */.k.breakpoints.sm, lib_styles_src/* gridTheme.breakpoints.xs */.k.breakpoints.xs, lib_styles_src/* theme.palette.transparent.main */.rS.palette.transparent.main);
const CloseContainer = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-a693a5aa-1"
})(modal_styles_templateObject1());
const Actions = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-a693a5aa-2"
})(modal_styles_templateObject2());
const ModalBackdrop = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-a693a5aa-3"
})(modal_styles_templateObject3(), (props)=>props.backgroundColor);
const ViewContainer = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-a693a5aa-4"
})(modal_styles_templateObject4(), (props)=>props.active ? "1" : "0");
const InfoContainer = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-a693a5aa-5"
})(modal_styles_templateObject5());
const IconContainer = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-a693a5aa-6"
})(modal_styles_templateObject6());

;// CONCATENATED MODULE: ./src/features/modal/modal.tsx










const Modal = (param)=>{
    let { cancelLabel , confirmLabel , cancelIcon =lib_icons_src.LongArrowSideIcons , confirmIcon =lib_icons_src.LongArrowSideIcons , modalBackgroundColor =lib_styles_src/* theme.palette.blue.main */.rS.palette.blue.main , paragraph , info , title , confirmCallback , cancelCallback  } = param;
    const modalRef = (0,react.useRef)(null);
    const handleClickOutside = (0,react.useCallback)(()=>{
        if (cancelCallback !== undefined) {
            cancelCallback();
        }
    }, [
        cancelCallback
    ]);
    (0,esm/* useOnClickOutside */.t$)(modalRef, handleClickOutside);
    const { activeBreakPoint  } = (0,lib_styles_src/* useWindowSize */.iP)();
    const [active, setActive] = (0,react.useState)(false);
    (0,react.useEffect)(()=>{
        setActive(true);
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ViewContainer, {
        active: active,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalBackdrop, {
                backgroundColor: modalBackgroundColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalContainer, {
                ref: modalRef,
                active: active,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(component_typography_src.H6, {
                        bottom: 16,
                        textColor: lib_styles_src/* theme.palette.blue.dark */.rS.palette.blue.dark,
                        top: 40,
                        children: title
                    }),
                    [
                        "xl",
                        "lg",
                        "md"
                    ].includes(activeBreakPoint) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(component_typography_src/* PLarge */.cG, {
                                textColor: lib_styles_src/* theme.palette.blue.dark */.rS.palette.blue.dark,
                                children: paragraph
                            }),
                            info !== undefined && /*#__PURE__*/ (0,jsx_runtime.jsxs)(InfoContainer, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(IconContainer, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lib_icons_src.AttentionIcons, {
                                            iconColor: lib_styles_src/* theme.palette.triggers.attention.main */.rS.palette.triggers.attention.main,
                                            size: 24
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(component_typography_src/* PLarge */.cG, {
                                        textColor: lib_styles_src/* theme.palette.blue.dark */.rS.palette.blue.dark,
                                        children: info
                                    })
                                ]
                            })
                        ]
                    }),
                    [
                        "xs",
                        "sm",
                        "s"
                    ].includes(activeBreakPoint) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(component_typography_src/* PMedium */.aW, {
                                textColor: lib_styles_src/* theme.palette.blue.dark */.rS.palette.blue.dark,
                                children: paragraph
                            }),
                            info !== undefined && /*#__PURE__*/ (0,jsx_runtime.jsxs)(InfoContainer, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(IconContainer, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lib_icons_src.AttentionIcons, {
                                            iconColor: lib_styles_src/* theme.palette.triggers.attention.main */.rS.palette.triggers.attention.main,
                                            size: 24
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(component_typography_src/* PMedium */.aW, {
                                        textColor: lib_styles_src/* theme.palette.blue.dark */.rS.palette.blue.dark,
                                        children: info
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Actions, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(component_buttons_src/* Button */.zx, {
                                buttonColor: "blueButton",
                                icon: confirmIcon,
                                label: confirmLabel,
                                small: [
                                    "xs",
                                    "sm",
                                    "s"
                                ].includes(activeBreakPoint),
                                stretch: [
                                    "xs",
                                    "sm",
                                    "s"
                                ].includes(activeBreakPoint),
                                onClick: confirmCallback
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(component_buttons_src/* Button */.zx, {
                                buttonColor: "orangeButton",
                                icon: cancelIcon,
                                label: cancelLabel,
                                small: [
                                    "xs",
                                    "sm",
                                    "s"
                                ].includes(activeBreakPoint),
                                stretch: [
                                    "xs",
                                    "sm",
                                    "s"
                                ].includes(activeBreakPoint),
                                onClick: cancelCallback
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseContainer, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(component_buttons_src/* IconButton */.hU, {
                            ariaLabel: "loka glugga",
                            buttonColor: "blueButton",
                            icon: lib_icons_src.CancelLargeIcons,
                            small: true,
                            onClick: cancelCallback
                        })
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-hooks-modal-virtual-7ecc3a3b97/1/packages/hooks-modal/src/index.ts + 3 modules
var hooks_modal_src = __webpack_require__(6315);
;// CONCATENATED MODULE: ./src/features/modal/modal-handler.tsx





const ModalHandler = ()=>{
    const { hide , modalProps  } = (0,hooks_modal_src/* useModal */.d)();
    const cancel = (0,react.useCallback)(()=>{
        hide();
    }, [
        hide
    ]);
    if (modalProps === undefined) {
        return null;
    }
    var _cancelCallback;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal, {
        ...modalProps,
        cancelCallback: (_cancelCallback = modalProps.cancelCallback) !== null && _cancelCallback !== void 0 ? _cancelCallback : cancel
    });
};

;// CONCATENATED MODULE: ./src/features/modal/index.ts



// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-hooks-compare-products-virtual-cdc2b75dbe/1/packages/hooks-compare-products/src/index.ts + 3 modules
var hooks_compare_products_src = __webpack_require__(11914);
;// CONCATENATED MODULE: ./src/features/product-compare-section/compare-section-buttons/styles.ts
function compare_section_buttons_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function compare_section_buttons_styles_templateObject() {
    const data = compare_section_buttons_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  width: 100%;\n  justify-content: space-between;\n"
    ]);
    compare_section_buttons_styles_templateObject = function() {
        return data;
    };
    return data;
}
function compare_section_buttons_styles_templateObject1() {
    const data = compare_section_buttons_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  color: ",
        ";\n  text-align: right;\n  @media screen and (max-width: ",
        "px) {\n    display: none;\n  }\n"
    ]);
    compare_section_buttons_styles_templateObject1 = function() {
        return data;
    };
    return data;
}
function compare_section_buttons_styles_templateObject2() {
    const data = compare_section_buttons_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  margin-bottom: 6px;\n  color: ",
        ";\n  text-align: right;\n  @media screen and (min-width: ",
        "px) {\n    display: none;\n  }\n"
    ]);
    compare_section_buttons_styles_templateObject2 = function() {
        return data;
    };
    return data;
}


const Buttonflex = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-e7ab225e-0"
})(compare_section_buttons_styles_templateObject());
const ClearAllProductsButton = styled_components_browser_cjs["default"].button.withConfig({
    componentId: "sc-e7ab225e-1"
})(compare_section_buttons_styles_templateObject1(), lib_styles_src/* theme.palette.gray.40 */.rS.palette.gray[40], lib_styles_src/* gridTheme.container.maxWidth.sm */.k.container.maxWidth.sm);
const ClearAllProductsButtonMobile = styled_components_browser_cjs["default"].button.withConfig({
    componentId: "sc-e7ab225e-2"
})(compare_section_buttons_styles_templateObject2(), lib_styles_src/* theme.palette.gray.40 */.rS.palette.gray[40], lib_styles_src/* gridTheme.container.maxWidth.sm */.k.container.maxWidth.sm);

;// CONCATENATED MODULE: ./src/features/product-compare-section/compare-section-buttons/index.tsx






const CompareSectionButtons = (param)=>{
    let { onClickClearAll , prodLenght  } = param;
    const router = (0,next_router.useRouter)();
    const icelandic = prodLenght <= 1 ? "vara" : "v\xf6rur";
    const handleClick = (0,react.useCallback)(()=>{
        router.push("/samanburdur");
    }, [
        router
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Buttonflex, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(component_buttons_src/* SecondaryButton */.kq, {
                icon: lib_icons_src.ArrowRightIcons,
                label: "Sko\xf0a samanbur\xf0 - ".concat(prodLenght, " ").concat(icelandic, " af 4"),
                onClick: handleClick
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ClearAllProductsButton, {
                onClick: onClickClearAll,
                children: "Hreinsa allar v\xf6rur \xfar samanbur\xf0i"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ClearAllProductsButtonMobile, {
                onClick: onClickClearAll,
                children: "Hreinsa"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/features/product-compare-section/compare-section-card/styles.ts
function compare_section_card_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function compare_section_card_styles_templateObject() {
    const data = compare_section_card_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  width: 100%;\n  max-width: 400px;\n  height: 60px;\n  align-items: center;\n  padding: 10px;\n  border-radius: 4px;\n  background-color: ",
        ";\n  gap: 16px;\n  &:hover {\n    box-shadow: 0px 18px 45px rgba(0, 0, 0, 0.09);\n  }\n  p {\n    overflow: hidden;\n    max-width: 260px;\n    color: ",
        ";\n    font-weight: 400;\n    text-align: left;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    @media screen and (max-width: ",
        "px) {\n      max-width: 160px;\n    }\n  }\n"
    ]);
    compare_section_card_styles_templateObject = function() {
        return data;
    };
    return data;
}
function compare_section_card_styles_templateObject1() {
    const data = compare_section_card_styles_taggedTemplateLiteral([
        "\n  width: 60px;\n  height: 40px;\n  object-fit: contain;\n  @media screen and (max-width: ",
        "px) {\n    display: none;\n  }\n"
    ]);
    compare_section_card_styles_templateObject1 = function() {
        return data;
    };
    return data;
}
function compare_section_card_styles_templateObject2() {
    const data = compare_section_card_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: flex-end;\n  button {\n    border-radius: 100%;\n    margin-bottom: -20px;\n    &:hover {\n      width: 40px;\n      height: 40px;\n      box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.1);\n    }\n  }\n"
    ]);
    compare_section_card_styles_templateObject2 = function() {
        return data;
    };
    return data;
}



// -------- Compare section card
const ProductCompareSectionCard = (0,styled_components_browser_cjs["default"])((link_default())).withConfig({
    componentId: "sc-a1e61544-0"
})(compare_section_card_styles_templateObject(), lib_styles_src/* theme.palette.white.main */.rS.palette.white.main, lib_styles_src/* theme.palette.blue.dark */.rS.palette.blue.dark, lib_styles_src/* gridTheme.container.maxWidth.sm */.k.container.maxWidth.sm);
const styles_ProdImage = styled_components_browser_cjs["default"].img.withConfig({
    componentId: "sc-a1e61544-1"
})(compare_section_card_styles_templateObject1(), lib_styles_src/* gridTheme.container.maxWidth.sm */.k.container.maxWidth.sm);
const ProductCardDeletButton = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-a1e61544-2"
})(compare_section_card_styles_templateObject2());

;// CONCATENATED MODULE: ./src/features/product-compare-section/compare-section-card/index.tsx







const CompareSectionCard = (param)=>{
    let { prodId , prodSlug , prodImageAlt , prodUrl , prodName  } = param;
    const { removeProduct  } = (0,hooks_compare_products_src/* useCompareProducts */.j)();
    const onClickRemove = (0,react.useCallback)(()=>{
        removeProduct(prodSlug);
    }, [
        prodSlug,
        removeProduct
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductCardDeletButton, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(component_buttons_src/* IconButton */.hU, {
                    ariaLabel: "Ey\xf0a v\xf6ru \xfar samanbur\xf0i",
                    icon: lib_icons_src.CancelLargeIcons,
                    small: true,
                    onClick: onClickRemove
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ProductCompareSectionCard, {
                href: "/vara/".concat(prodSlug),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_ProdImage, {
                        alt: prodImageAlt,
                        src: prodUrl
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(component_typography_src/* PSmall */.zK, {
                        children: prodName
                    })
                ]
            })
        ]
    }, prodId);
};

;// CONCATENATED MODULE: ./src/features/product-compare-section/styles.ts
function product_compare_section_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function product_compare_section_styles_templateObject() {
    const data = product_compare_section_styles_taggedTemplateLiteral([
        "\n  position: fixed;\n  z-index: 300;\n  bottom: 0;\n  padding: 20px;\n  background-color: ",
        ";\n  filter: drop-shadow(14px 0px 35px rgba(13, 13, 13, 0.16));\n  inset-inline: 0px;\n"
    ]);
    product_compare_section_styles_templateObject = function() {
        return data;
    };
    return data;
}
function product_compare_section_styles_templateObject1() {
    const data = product_compare_section_styles_taggedTemplateLiteral([
        "\n  position: relative;\n  display: flex;\n  width: 100%;\n  max-width: ",
        "px;\n  flex-direction: column;\n  margin: 0 auto;\n  overflow-x: auto;\n  ",
        "\n  ::-webkit-scrollbar {\n    height: 2px;\n  }\n  ::-webkit-scrollbar-track {\n    border: none;\n    background: ",
        ";\n  }\n"
    ]);
    product_compare_section_styles_templateObject1 = function() {
        return data;
    };
    return data;
}
function product_compare_section_styles_templateObject2() {
    const data = product_compare_section_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  padding-bottom: 10px;\n  gap: 20px;\n  @media screen and (max-width: ",
        "px) {\n    gap: 8px;\n  }\n"
    ]);
    product_compare_section_styles_templateObject2 = function() {
        return data;
    };
    return data;
}


const ProductCompareSectionBackground = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-c7296dba-0"
})(product_compare_section_styles_templateObject(), lib_styles_src/* theme.palette.gray.5 */.rS.palette.gray[5]);
const ProductCompareSectionContainer = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-c7296dba-1"
})(product_compare_section_styles_templateObject1(), lib_styles_src/* gridTheme.maxContentWidth */.k.maxContentWidth, (0,lib_styles_src/* scrollStyle */.vh)({
    color: "dark-blue"
}), lib_styles_src/* theme.palette.gray.5 */.rS.palette.gray[5]);
const ProductList = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-c7296dba-2"
})(product_compare_section_styles_templateObject2(), lib_styles_src/* gridTheme.container.maxWidth.s */.k.container.maxWidth.s);

;// CONCATENATED MODULE: ./src/features/product-compare-section/index.tsx








const ProductCompareSection = ()=>{
    const { products , clearAllProducts  } = (0,hooks_compare_products_src/* useCompareProducts */.j)();
    const router = (0,next_router.useRouter)();
    if ((0,types_utils_src/* isSSR */.yF)()) {
        return null;
    }
    // no need to show this section on compare page
    if (products.length === 0 || router.pathname === "/samanburdur") {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductCompareSectionBackground, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ProductCompareSectionContainer, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(CompareSectionButtons, {
                    prodLenght: products.length,
                    onClickClearAll: clearAllProducts
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductList, {
                    children: products.map((product)=>{
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(CompareSectionCard, {
                            prodId: product.id,
                            prodImageAlt: product.thumbnail.alt,
                            prodName: product.name,
                            prodSlug: product.slug,
                            prodUrl: product.thumbnail.url
                        }, product.id);
                    })
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ../../.yarn/cache/clsx-npm-1.2.1-77792dc182-30befca801.zip/node_modules/clsx/dist/clsx.m.js
function r(e){var t,f,n="";if("string"==typeof e||"number"==typeof e)n+=e;else if("object"==typeof e)if(Array.isArray(e))for(t=0;t<e.length;t++)e[t]&&(f=r(e[t]))&&(n&&(n+=" "),n+=f);else for(t in e)e[t]&&(n&&(n+=" "),n+=t);return n}function clsx(){for(var e,t,f=0,n="";f<arguments.length;)(e=arguments[f++])&&(t=r(e))&&(n&&(n+=" "),n+=t);return n}/* harmony default export */ var clsx_m = (clsx);
// EXTERNAL MODULE: ../../.yarn/__virtual__/react-dom-virtual-60cbd4834f/0/cache/react-dom-npm-18.2.0-dd675bca1c-7d323310be.zip/node_modules/react-dom/index.js
var react_dom = __webpack_require__(13137);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/react-toastify-virtual-1c02bd8f6c/0/cache/react-toastify-npm-8.2.0-3f638b6659-670f1176fb.zip/node_modules/react-toastify/dist/react-toastify.esm.js




function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function isNum(v) {
  return typeof v === 'number' && !isNaN(v);
}
function isBool(v) {
  return typeof v === 'boolean';
}
function isStr(v) {
  return typeof v === 'string';
}
function isFn(v) {
  return typeof v === 'function';
}
function parseClassName(v) {
  return isStr(v) || isFn(v) ? v : null;
}
function isToastIdValid(toastId) {
  return toastId === 0 || toastId;
}
function getAutoCloseDelay(toastAutoClose, containerAutoClose) {
  return toastAutoClose === false || isNum(toastAutoClose) && toastAutoClose > 0 ? toastAutoClose : containerAutoClose;
}
var canUseDom = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
function canBeRendered(content) {
  return (0,react.isValidElement)(content) || isStr(content) || isFn(content) || isNum(content);
}

var POSITION = {
  TOP_LEFT: 'top-left',
  TOP_RIGHT: 'top-right',
  TOP_CENTER: 'top-center',
  BOTTOM_LEFT: 'bottom-left',
  BOTTOM_RIGHT: 'bottom-right',
  BOTTOM_CENTER: 'bottom-center'
};
var TYPE = {
  INFO: 'info',
  SUCCESS: 'success',
  WARNING: 'warning',
  ERROR: 'error',
  DEFAULT: 'default'
};

/**
 * Used to collapse toast after exit animation
 */
function collapseToast(node, done, duration
/* COLLAPSE_DURATION */
) {
  if (duration === void 0) {
    duration = 300;
  }

  var scrollHeight = node.scrollHeight,
      style = node.style;
  requestAnimationFrame(function () {
    style.minHeight = 'initial';
    style.height = scrollHeight + 'px';
    style.transition = "all " + duration + "ms";
    requestAnimationFrame(function () {
      style.height = '0';
      style.padding = '0';
      style.margin = '0';
      setTimeout(done, duration);
    });
  });
}

/**
 * Css animation that just work.
 * You could use animate.css for instance
 *
 *
 * ```
 * cssTransition({
 *   enter: "animate__animated animate__bounceIn",
 *   exit: "animate__animated animate__bounceOut"
 * })
 * ```
 *
 */

function cssTransition(_ref) {
  var enter = _ref.enter,
      exit = _ref.exit,
      _ref$appendPosition = _ref.appendPosition,
      appendPosition = _ref$appendPosition === void 0 ? false : _ref$appendPosition,
      _ref$collapse = _ref.collapse,
      collapse = _ref$collapse === void 0 ? true : _ref$collapse,
      _ref$collapseDuration = _ref.collapseDuration,
      collapseDuration = _ref$collapseDuration === void 0 ? 300 : _ref$collapseDuration;
  return function ToastTransition(_ref2) {
    var children = _ref2.children,
        position = _ref2.position,
        preventExitTransition = _ref2.preventExitTransition,
        done = _ref2.done,
        nodeRef = _ref2.nodeRef,
        isIn = _ref2.isIn;
    var enterClassName = appendPosition ? enter + "--" + position : enter;
    var exitClassName = appendPosition ? exit + "--" + position : exit;
    var baseClassName = (0,react.useRef)();
    var animationStep = (0,react.useRef)(0
    /* Enter */
    );
    (0,react.useLayoutEffect)(function () {
      onEnter();
    }, []);
    (0,react.useEffect)(function () {
      if (!isIn) preventExitTransition ? onExited() : onExit();
    }, [isIn]);

    function onEnter() {
      var node = nodeRef.current;
      baseClassName.current = node.className;
      node.className += " " + enterClassName;
      node.addEventListener('animationend', onEntered);
      node.addEventListener('animationcancel', onEntered);
    }

    function onEntered(e) {
      if (e.target !== nodeRef.current) return;
      var node = nodeRef.current;
      node.dispatchEvent(new Event("d"
      /* ENTRANCE_ANIMATION_END */
      ));
      node.removeEventListener('animationend', onEntered);
      node.removeEventListener('animationcancel', onEntered);

      if (animationStep.current === 0
      /* Enter */
      ) {
          node.className = baseClassName.current;
        }
    }

    function onExit() {
      animationStep.current = 1
      /* Exit */
      ;
      var node = nodeRef.current;
      node.className += " " + exitClassName;
      node.addEventListener('animationend', onExited);
    }

    function onExited() {
      var node = nodeRef.current;
      node.removeEventListener('animationend', onExited);
      collapse ? collapseToast(node, done, collapseDuration) : done();
    }

    return react.createElement(react.Fragment, null, children);
  };
}

var eventManager = {
  list: /*#__PURE__*/new Map(),
  emitQueue: /*#__PURE__*/new Map(),
  on: function on(event, callback) {
    this.list.has(event) || this.list.set(event, []);
    this.list.get(event).push(callback);
    return this;
  },
  off: function off(event, callback) {
    if (callback) {
      var cb = this.list.get(event).filter(function (cb) {
        return cb !== callback;
      });
      this.list.set(event, cb);
      return this;
    }

    this.list["delete"](event);
    return this;
  },
  cancelEmit: function cancelEmit(event) {
    var timers = this.emitQueue.get(event);

    if (timers) {
      timers.forEach(clearTimeout);
      this.emitQueue["delete"](event);
    }

    return this;
  },

  /**
   * Enqueue the event at the end of the call stack
   * Doing so let the user call toast as follow:
   * toast('1')
   * toast('2')
   * toast('3')
   * Without setTimemout the code above will not work
   */
  emit: function emit(event) {
    var _this = this;

    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    this.list.has(event) && this.list.get(event).forEach(function (callback) {
      var timer = setTimeout(function () {
        // @ts-ignore
        callback.apply(void 0, args);
      }, 0);
      _this.emitQueue.has(event) || _this.emitQueue.set(event, []);

      _this.emitQueue.get(event).push(timer);
    });
  }
};

var _excluded = ["delay", "staleId"];
function useToastContainer(props) {
  var _useReducer = (0,react.useReducer)(function (x) {
    return x + 1;
  }, 0),
      forceUpdate = _useReducer[1];

  var _useState = (0,react.useState)([]),
      toastIds = _useState[0],
      setToastIds = _useState[1];

  var containerRef = (0,react.useRef)(null);
  var toastToRender = (0,react.useRef)(new Map()).current;

  var isToastActive = function isToastActive(id) {
    return toastIds.indexOf(id) !== -1;
  };

  var instance = (0,react.useRef)({
    toastKey: 1,
    displayedToast: 0,
    count: 0,
    queue: [],
    props: props,
    containerId: null,
    isToastActive: isToastActive,
    getToast: function getToast(id) {
      return toastToRender.get(id);
    }
  }).current;
  (0,react.useEffect)(function () {
    instance.containerId = props.containerId;
    eventManager.cancelEmit(3
    /* WillUnmount */
    ).on(0
    /* Show */
    , buildToast).on(1
    /* Clear */
    , function (toastId) {
      return containerRef.current && removeToast(toastId);
    }).on(5
    /* ClearWaitingQueue */
    , clearWaitingQueue).emit(2
    /* DidMount */
    , instance);
    return function () {
      return eventManager.emit(3
      /* WillUnmount */
      , instance);
    };
  }, []);
  (0,react.useEffect)(function () {
    instance.isToastActive = isToastActive;
    instance.displayedToast = toastIds.length;
    eventManager.emit(4
    /* Change */
    , toastIds.length, props.containerId);
  }, [toastIds]);
  (0,react.useEffect)(function () {
    instance.props = props;
  });

  function clearWaitingQueue(_ref) {
    var containerId = _ref.containerId;
    var limit = instance.props.limit;

    if (limit && (!containerId || instance.containerId === containerId)) {
      instance.count -= instance.queue.length;
      instance.queue = [];
    }
  }

  function removeToast(toastId) {
    setToastIds(function (state) {
      return isToastIdValid(toastId) ? state.filter(function (id) {
        return id !== toastId;
      }) : [];
    });
  }

  function dequeueToast() {
    var _instance$queue$shift = instance.queue.shift(),
        toastContent = _instance$queue$shift.toastContent,
        toastProps = _instance$queue$shift.toastProps,
        staleId = _instance$queue$shift.staleId;

    appendToast(toastContent, toastProps, staleId);
  }
  /**
   * check if a container is attached to the dom
   * check for multi-container, build only if associated
   * check for duplicate toastId if no update
   */


  function isNotValid(options) {
    return !containerRef.current || instance.props.enableMultiContainer && options.containerId !== instance.props.containerId || toastToRender.has(options.toastId) && options.updateId == null;
  } // this function and all the function called inside needs to rely on refs


  function buildToast(content, _ref2) {
    var delay = _ref2.delay,
        staleId = _ref2.staleId,
        options = _objectWithoutPropertiesLoose(_ref2, _excluded);

    if (!canBeRendered(content) || isNotValid(options)) return;
    var toastId = options.toastId,
        updateId = options.updateId,
        data = options.data;
    var props = instance.props;

    var closeToast = function closeToast() {
      return removeToast(toastId);
    };

    var isNotAnUpdate = updateId == null;
    if (isNotAnUpdate) instance.count++;
    var toastProps = {
      toastId: toastId,
      updateId: updateId,
      isLoading: options.isLoading,
      theme: options.theme || props.theme,
      icon: options.icon != null ? options.icon : props.icon,
      isIn: false,
      key: options.key || instance.toastKey++,
      type: options.type,
      closeToast: closeToast,
      closeButton: options.closeButton,
      rtl: props.rtl,
      position: options.position || props.position,
      transition: options.transition || props.transition,
      className: parseClassName(options.className || props.toastClassName),
      bodyClassName: parseClassName(options.bodyClassName || props.bodyClassName),
      style: options.style || props.toastStyle,
      bodyStyle: options.bodyStyle || props.bodyStyle,
      onClick: options.onClick || props.onClick,
      pauseOnHover: isBool(options.pauseOnHover) ? options.pauseOnHover : props.pauseOnHover,
      pauseOnFocusLoss: isBool(options.pauseOnFocusLoss) ? options.pauseOnFocusLoss : props.pauseOnFocusLoss,
      draggable: isBool(options.draggable) ? options.draggable : props.draggable,
      draggablePercent: options.draggablePercent || props.draggablePercent,
      draggableDirection: options.draggableDirection || props.draggableDirection,
      closeOnClick: isBool(options.closeOnClick) ? options.closeOnClick : props.closeOnClick,
      progressClassName: parseClassName(options.progressClassName || props.progressClassName),
      progressStyle: options.progressStyle || props.progressStyle,
      autoClose: options.isLoading ? false : getAutoCloseDelay(options.autoClose, props.autoClose),
      hideProgressBar: isBool(options.hideProgressBar) ? options.hideProgressBar : props.hideProgressBar,
      progress: options.progress,
      role: options.role || props.role,
      deleteToast: function deleteToast() {
        toastToRender["delete"](toastId);
        var queueLen = instance.queue.length;
        instance.count = isToastIdValid(toastId) ? instance.count - 1 : instance.count - instance.displayedToast;
        if (instance.count < 0) instance.count = 0;

        if (queueLen > 0) {
          var freeSlot = isToastIdValid(toastId) ? 1 : instance.props.limit;

          if (queueLen === 1 || freeSlot === 1) {
            instance.displayedToast++;
            dequeueToast();
          } else {
            var toDequeue = freeSlot > queueLen ? queueLen : freeSlot;
            instance.displayedToast = toDequeue;

            for (var i = 0; i < toDequeue; i++) {
              dequeueToast();
            }
          }
        } else {
          forceUpdate();
        }
      }
    };
    if (isFn(options.onOpen)) toastProps.onOpen = options.onOpen;
    if (isFn(options.onClose)) toastProps.onClose = options.onClose;
    toastProps.closeButton = props.closeButton;

    if (options.closeButton === false || canBeRendered(options.closeButton)) {
      toastProps.closeButton = options.closeButton;
    } else if (options.closeButton === true) {
      toastProps.closeButton = canBeRendered(props.closeButton) ? props.closeButton : true;
    }

    var toastContent = content;

    if ((0,react.isValidElement)(content) && !isStr(content.type)) {
      toastContent = (0,react.cloneElement)(content, {
        closeToast: closeToast,
        toastProps: toastProps,
        data: data
      });
    } else if (isFn(content)) {
      toastContent = content({
        closeToast: closeToast,
        toastProps: toastProps,
        data: data
      });
    } // not handling limit + delay by design. Waiting for user feedback first


    if (props.limit && props.limit > 0 && instance.count > props.limit && isNotAnUpdate) {
      instance.queue.push({
        toastContent: toastContent,
        toastProps: toastProps,
        staleId: staleId
      });
    } else if (isNum(delay) && delay > 0) {
      setTimeout(function () {
        appendToast(toastContent, toastProps, staleId);
      }, delay);
    } else {
      appendToast(toastContent, toastProps, staleId);
    }
  }

  function appendToast(content, toastProps, staleId) {
    var toastId = toastProps.toastId;
    if (staleId) toastToRender["delete"](staleId);
    toastToRender.set(toastId, {
      content: content,
      props: toastProps
    });
    setToastIds(function (state) {
      return [].concat(state, [toastId]).filter(function (id) {
        return id !== staleId;
      });
    });
  }

  function getToastToRender(cb) {
    var toRender = new Map();
    var collection = Array.from(toastToRender.values());
    if (props.newestOnTop) collection.reverse();
    collection.forEach(function (toast) {
      var position = toast.props.position;
      toRender.has(position) || toRender.set(position, []);
      toRender.get(position).push(toast);
    });
    return Array.from(toRender, function (p) {
      return cb(p[0], p[1]);
    });
  }

  return {
    getToastToRender: getToastToRender,
    containerRef: containerRef,
    isToastActive: isToastActive
  };
}

function getX(e) {
  return e.targetTouches && e.targetTouches.length >= 1 ? e.targetTouches[0].clientX : e.clientX;
}

function getY(e) {
  return e.targetTouches && e.targetTouches.length >= 1 ? e.targetTouches[0].clientY : e.clientY;
}

function useToast(props) {
  var _useState = (0,react.useState)(false),
      isRunning = _useState[0],
      setIsRunning = _useState[1];

  var _useState2 = (0,react.useState)(false),
      preventExitTransition = _useState2[0],
      setPreventExitTransition = _useState2[1];

  var toastRef = (0,react.useRef)(null);
  var drag = (0,react.useRef)({
    start: 0,
    x: 0,
    y: 0,
    delta: 0,
    removalDistance: 0,
    canCloseOnClick: true,
    canDrag: false,
    boundingRect: null,
    didMove: false
  }).current;
  var syncProps = (0,react.useRef)(props);
  var autoClose = props.autoClose,
      pauseOnHover = props.pauseOnHover,
      closeToast = props.closeToast,
      onClick = props.onClick,
      closeOnClick = props.closeOnClick;
  (0,react.useEffect)(function () {
    syncProps.current = props;
  });
  (0,react.useEffect)(function () {
    if (toastRef.current) toastRef.current.addEventListener("d"
    /* ENTRANCE_ANIMATION_END */
    , playToast, {
      once: true
    });
    if (isFn(props.onOpen)) props.onOpen((0,react.isValidElement)(props.children) && props.children.props);
    return function () {
      var props = syncProps.current;
      if (isFn(props.onClose)) props.onClose((0,react.isValidElement)(props.children) && props.children.props);
    };
  }, []);
  (0,react.useEffect)(function () {
    props.pauseOnFocusLoss && bindFocusEvents();
    return function () {
      props.pauseOnFocusLoss && unbindFocusEvents();
    };
  }, [props.pauseOnFocusLoss]);

  function onDragStart(e) {
    if (props.draggable) {
      bindDragEvents();
      var toast = toastRef.current;
      drag.canCloseOnClick = true;
      drag.canDrag = true;
      drag.boundingRect = toast.getBoundingClientRect();
      toast.style.transition = '';
      drag.x = getX(e.nativeEvent);
      drag.y = getY(e.nativeEvent);

      if (props.draggableDirection === "x"
      /* X */
      ) {
          drag.start = drag.x;
          drag.removalDistance = toast.offsetWidth * (props.draggablePercent / 100);
        } else {
        drag.start = drag.y;
        drag.removalDistance = toast.offsetHeight * (props.draggablePercent === 80
        /* DRAGGABLE_PERCENT */
        ? props.draggablePercent * 1.5 : props.draggablePercent / 100);
      }
    }
  }

  function onDragTransitionEnd() {
    if (drag.boundingRect) {
      var _drag$boundingRect = drag.boundingRect,
          top = _drag$boundingRect.top,
          bottom = _drag$boundingRect.bottom,
          left = _drag$boundingRect.left,
          right = _drag$boundingRect.right;

      if (props.pauseOnHover && drag.x >= left && drag.x <= right && drag.y >= top && drag.y <= bottom) {
        pauseToast();
      } else {
        playToast();
      }
    }
  }

  function playToast() {
    setIsRunning(true);
  }

  function pauseToast() {
    setIsRunning(false);
  }

  function bindFocusEvents() {
    if (!document.hasFocus()) pauseToast();
    window.addEventListener('focus', playToast);
    window.addEventListener('blur', pauseToast);
  }

  function unbindFocusEvents() {
    window.removeEventListener('focus', playToast);
    window.removeEventListener('blur', pauseToast);
  }

  function bindDragEvents() {
    drag.didMove = false;
    document.addEventListener('mousemove', onDragMove);
    document.addEventListener('mouseup', onDragEnd);
    document.addEventListener('touchmove', onDragMove);
    document.addEventListener('touchend', onDragEnd);
  }

  function unbindDragEvents() {
    document.removeEventListener('mousemove', onDragMove);
    document.removeEventListener('mouseup', onDragEnd);
    document.removeEventListener('touchmove', onDragMove);
    document.removeEventListener('touchend', onDragEnd);
  }

  function onDragMove(e) {
    var toast = toastRef.current;

    if (drag.canDrag && toast) {
      drag.didMove = true;
      if (isRunning) pauseToast();
      drag.x = getX(e);
      drag.y = getY(e);

      if (props.draggableDirection === "x"
      /* X */
      ) {
          drag.delta = drag.x - drag.start;
        } else {
        drag.delta = drag.y - drag.start;
      } // prevent false positif during a toast click


      if (drag.start !== drag.x) drag.canCloseOnClick = false;
      toast.style.transform = "translate" + props.draggableDirection + "(" + drag.delta + "px)";
      toast.style.opacity = "" + (1 - Math.abs(drag.delta / drag.removalDistance));
    }
  }

  function onDragEnd() {
    unbindDragEvents();
    var toast = toastRef.current;

    if (drag.canDrag && drag.didMove && toast) {
      drag.canDrag = false;

      if (Math.abs(drag.delta) > drag.removalDistance) {
        setPreventExitTransition(true);
        props.closeToast();
        return;
      }

      toast.style.transition = 'transform 0.2s, opacity 0.2s';
      toast.style.transform = "translate" + props.draggableDirection + "(0)";
      toast.style.opacity = '1';
    }
  }

  var eventHandlers = {
    onMouseDown: onDragStart,
    onTouchStart: onDragStart,
    onMouseUp: onDragTransitionEnd,
    onTouchEnd: onDragTransitionEnd
  };

  if (autoClose && pauseOnHover) {
    eventHandlers.onMouseEnter = pauseToast;
    eventHandlers.onMouseLeave = playToast;
  } // prevent toast from closing when user drags the toast


  if (closeOnClick) {
    eventHandlers.onClick = function (e) {
      onClick && onClick(e);
      drag.canCloseOnClick && closeToast();
    };
  }

  return {
    playToast: playToast,
    pauseToast: pauseToast,
    isRunning: isRunning,
    preventExitTransition: preventExitTransition,
    toastRef: toastRef,
    eventHandlers: eventHandlers
  };
}

function CloseButton(_ref) {
  var closeToast = _ref.closeToast,
      theme = _ref.theme,
      _ref$ariaLabel = _ref.ariaLabel,
      ariaLabel = _ref$ariaLabel === void 0 ? 'close' : _ref$ariaLabel;
  return (0,react.createElement)("button", {
    className: "Toastify"
    /* CSS_NAMESPACE */
    + "__close-button " + "Toastify"
    /* CSS_NAMESPACE */
    + "__close-button--" + theme,
    type: "button",
    onClick: function onClick(e) {
      e.stopPropagation();
      closeToast(e);
    },
    "aria-label": ariaLabel
  }, (0,react.createElement)("svg", {
    "aria-hidden": "true",
    viewBox: "0 0 14 16"
  }, (0,react.createElement)("path", {
    fillRule: "evenodd",
    d: "M7.71 8.23l3.75 3.75-1.48 1.48-3.75-3.75-3.75 3.75L1 11.98l3.75-3.75L1 4.48 2.48 3l3.75 3.75L9.98 3l1.48 1.48-3.75 3.75z"
  })));
}

function ProgressBar(_ref) {
  var _cx, _animationEvent;

  var delay = _ref.delay,
      isRunning = _ref.isRunning,
      closeToast = _ref.closeToast,
      type = _ref.type,
      hide = _ref.hide,
      className = _ref.className,
      userStyle = _ref.style,
      controlledProgress = _ref.controlledProgress,
      progress = _ref.progress,
      rtl = _ref.rtl,
      isIn = _ref.isIn,
      theme = _ref.theme;

  var style = _extends({}, userStyle, {
    animationDuration: delay + "ms",
    animationPlayState: isRunning ? 'running' : 'paused',
    opacity: hide ? 0 : 1
  });

  if (controlledProgress) style.transform = "scaleX(" + progress + ")";
  var defaultClassName = clsx_m("Toastify"
  /* CSS_NAMESPACE */
  + "__progress-bar", controlledProgress ? "Toastify"
  /* CSS_NAMESPACE */
  + "__progress-bar--controlled" : "Toastify"
  /* CSS_NAMESPACE */
  + "__progress-bar--animated", "Toastify"
  /* CSS_NAMESPACE */
  + "__progress-bar-theme--" + theme, "Toastify"
  /* CSS_NAMESPACE */
  + "__progress-bar--" + type, (_cx = {}, _cx["Toastify"
  /* CSS_NAMESPACE */
  + "__progress-bar--rtl"] = rtl, _cx));
  var classNames = isFn(className) ? className({
    rtl: rtl,
    type: type,
    defaultClassName: defaultClassName
  }) : clsx_m(defaultClassName, className); // 🧐 controlledProgress is derived from progress
  // so if controlledProgress is set
  // it means that this is also the case for progress

  var animationEvent = (_animationEvent = {}, _animationEvent[controlledProgress && progress >= 1 ? 'onTransitionEnd' : 'onAnimationEnd'] = controlledProgress && progress < 1 ? null : function () {
    isIn && closeToast();
  }, _animationEvent); // TODO: add aria-valuenow, aria-valuemax, aria-valuemin

  return (0,react.createElement)("div", Object.assign({
    role: "progressbar",
    "aria-hidden": hide ? 'true' : 'false',
    "aria-label": "notification timer",
    className: classNames,
    style: style
  }, animationEvent));
}
ProgressBar.defaultProps = {
  type: TYPE.DEFAULT,
  hide: false
};

var _excluded$1 = ["theme", "type"];

var Svg = function Svg(_ref) {
  var theme = _ref.theme,
      type = _ref.type,
      rest = _objectWithoutPropertiesLoose(_ref, _excluded$1);

  return (0,react.createElement)("svg", Object.assign({
    viewBox: "0 0 24 24",
    width: "100%",
    height: "100%",
    fill: theme === 'colored' ? 'currentColor' : "var(--toastify-icon-color-" + type + ")"
  }, rest));
};

function Warning(props) {
  return (0,react.createElement)(Svg, Object.assign({}, props), (0,react.createElement)("path", {
    d: "M23.32 17.191L15.438 2.184C14.728.833 13.416 0 11.996 0c-1.42 0-2.733.833-3.443 2.184L.533 17.448a4.744 4.744 0 000 4.368C1.243 23.167 2.555 24 3.975 24h16.05C22.22 24 24 22.044 24 19.632c0-.904-.251-1.746-.68-2.44zm-9.622 1.46c0 1.033-.724 1.823-1.698 1.823s-1.698-.79-1.698-1.822v-.043c0-1.028.724-1.822 1.698-1.822s1.698.79 1.698 1.822v.043zm.039-12.285l-.84 8.06c-.057.581-.408.943-.897.943-.49 0-.84-.367-.896-.942l-.84-8.065c-.057-.624.25-1.095.779-1.095h1.91c.528.005.84.476.784 1.1z"
  }));
}

function Info(props) {
  return (0,react.createElement)(Svg, Object.assign({}, props), (0,react.createElement)("path", {
    d: "M12 0a12 12 0 1012 12A12.013 12.013 0 0012 0zm.25 5a1.5 1.5 0 11-1.5 1.5 1.5 1.5 0 011.5-1.5zm2.25 13.5h-4a1 1 0 010-2h.75a.25.25 0 00.25-.25v-4.5a.25.25 0 00-.25-.25h-.75a1 1 0 010-2h1a2 2 0 012 2v4.75a.25.25 0 00.25.25h.75a1 1 0 110 2z"
  }));
}

function Success(props) {
  return (0,react.createElement)(Svg, Object.assign({}, props), (0,react.createElement)("path", {
    d: "M12 0a12 12 0 1012 12A12.014 12.014 0 0012 0zm6.927 8.2l-6.845 9.289a1.011 1.011 0 01-1.43.188l-4.888-3.908a1 1 0 111.25-1.562l4.076 3.261 6.227-8.451a1 1 0 111.61 1.183z"
  }));
}

function react_toastify_esm_Error(props) {
  return (0,react.createElement)(Svg, Object.assign({}, props), (0,react.createElement)("path", {
    d: "M11.983 0a12.206 12.206 0 00-8.51 3.653A11.8 11.8 0 000 12.207 11.779 11.779 0 0011.8 24h.214A12.111 12.111 0 0024 11.791 11.766 11.766 0 0011.983 0zM10.5 16.542a1.476 1.476 0 011.449-1.53h.027a1.527 1.527 0 011.523 1.47 1.475 1.475 0 01-1.449 1.53h-.027a1.529 1.529 0 01-1.523-1.47zM11 12.5v-6a1 1 0 012 0v6a1 1 0 11-2 0z"
  }));
}

function Spinner() {
  return (0,react.createElement)("div", {
    className: "Toastify"
    /* CSS_NAMESPACE */
    + "__spinner"
  });
}

var react_toastify_esm_Icons = {
  info: Info,
  warning: Warning,
  success: Success,
  error: react_toastify_esm_Error,
  spinner: Spinner
};

var Toast = function Toast(props) {
  var _cx, _cx2;

  var _useToast = useToast(props),
      isRunning = _useToast.isRunning,
      preventExitTransition = _useToast.preventExitTransition,
      toastRef = _useToast.toastRef,
      eventHandlers = _useToast.eventHandlers;

  var closeButton = props.closeButton,
      children = props.children,
      autoClose = props.autoClose,
      onClick = props.onClick,
      type = props.type,
      hideProgressBar = props.hideProgressBar,
      closeToast = props.closeToast,
      Transition = props.transition,
      position = props.position,
      className = props.className,
      style = props.style,
      bodyClassName = props.bodyClassName,
      bodyStyle = props.bodyStyle,
      progressClassName = props.progressClassName,
      progressStyle = props.progressStyle,
      updateId = props.updateId,
      role = props.role,
      progress = props.progress,
      rtl = props.rtl,
      toastId = props.toastId,
      deleteToast = props.deleteToast,
      isIn = props.isIn,
      isLoading = props.isLoading,
      icon = props.icon,
      theme = props.theme;
  var defaultClassName = clsx_m("Toastify"
  /* CSS_NAMESPACE */
  + "__toast", "Toastify"
  /* CSS_NAMESPACE */
  + "__toast-theme--" + theme, "Toastify"
  /* CSS_NAMESPACE */
  + "__toast--" + type, (_cx = {}, _cx["Toastify"
  /* CSS_NAMESPACE */
  + "__toast--rtl"] = rtl, _cx));
  var cssClasses = isFn(className) ? className({
    rtl: rtl,
    position: position,
    type: type,
    defaultClassName: defaultClassName
  }) : clsx_m(defaultClassName, className);
  var isProgressControlled = !!progress;
  var maybeIcon = react_toastify_esm_Icons[type];
  var iconProps = {
    theme: theme,
    type: type
  };
  var Icon = maybeIcon && maybeIcon(iconProps);

  if (icon === false) {
    Icon = void 0;
  } else if (isFn(icon)) {
    Icon = icon(iconProps);
  } else if ((0,react.isValidElement)(icon)) {
    Icon = (0,react.cloneElement)(icon, iconProps);
  } else if (isStr(icon)) {
    Icon = icon;
  } else if (isLoading) {
    Icon = react_toastify_esm_Icons.spinner();
  }

  function renderCloseButton(closeButton) {
    if (!closeButton) return;
    var props = {
      closeToast: closeToast,
      type: type,
      theme: theme
    };
    if (isFn(closeButton)) return closeButton(props);
    if ((0,react.isValidElement)(closeButton)) return (0,react.cloneElement)(closeButton, props);
  }

  return (0,react.createElement)(Transition, {
    isIn: isIn,
    done: deleteToast,
    position: position,
    preventExitTransition: preventExitTransition,
    nodeRef: toastRef
  }, (0,react.createElement)("div", Object.assign({
    id: toastId,
    onClick: onClick,
    className: cssClasses
  }, eventHandlers, {
    style: style,
    ref: toastRef
  }), (0,react.createElement)("div", Object.assign({}, isIn && {
    role: role
  }, {
    className: isFn(bodyClassName) ? bodyClassName({
      type: type
    }) : clsx_m("Toastify"
    /* CSS_NAMESPACE */
    + "__toast-body", bodyClassName),
    style: bodyStyle
  }), Icon && (0,react.createElement)("div", {
    className: clsx_m("Toastify"
    /* CSS_NAMESPACE */
    + "__toast-icon", (_cx2 = {}, _cx2["Toastify"
    /* CSS_NAMESPACE */
    + "--animate-icon " + "Toastify"
    /* CSS_NAMESPACE */
    + "__zoom-enter"] = !isLoading, _cx2))
  }, Icon), (0,react.createElement)("div", null, children)), renderCloseButton(closeButton), (autoClose || isProgressControlled) && (0,react.createElement)(ProgressBar, Object.assign({}, updateId && !isProgressControlled ? {
    key: "pb-" + updateId
  } : {}, {
    rtl: rtl,
    theme: theme,
    delay: autoClose,
    isRunning: isRunning,
    isIn: isIn,
    closeToast: closeToast,
    hide: hideProgressBar,
    type: type,
    style: progressStyle,
    className: progressClassName,
    controlledProgress: isProgressControlled,
    progress: progress
  }))));
};

var Bounce = /*#__PURE__*/cssTransition({
  enter: "Toastify"
  /* CSS_NAMESPACE */
  + "--animate " + "Toastify"
  /* CSS_NAMESPACE */
  + "__bounce-enter",
  exit: "Toastify"
  /* CSS_NAMESPACE */
  + "--animate " + "Toastify"
  /* CSS_NAMESPACE */
  + "__bounce-exit",
  appendPosition: true
});
var Slide = /*#__PURE__*/cssTransition({
  enter: "Toastify"
  /* CSS_NAMESPACE */
  + "--animate " + "Toastify"
  /* CSS_NAMESPACE */
  + "__slide-enter",
  exit: "Toastify"
  /* CSS_NAMESPACE */
  + "--animate " + "Toastify"
  /* CSS_NAMESPACE */
  + "__slide-exit",
  appendPosition: true
});
var Zoom = /*#__PURE__*/cssTransition({
  enter: "Toastify"
  /* CSS_NAMESPACE */
  + "--animate " + "Toastify"
  /* CSS_NAMESPACE */
  + "__zoom-enter",
  exit: "Toastify"
  /* CSS_NAMESPACE */
  + "--animate " + "Toastify"
  /* CSS_NAMESPACE */
  + "__zoom-exit"
});
var Flip = /*#__PURE__*/cssTransition({
  enter: "Toastify"
  /* CSS_NAMESPACE */
  + "--animate " + "Toastify"
  /* CSS_NAMESPACE */
  + "__flip-enter",
  exit: "Toastify"
  /* CSS_NAMESPACE */
  + "--animate " + "Toastify"
  /* CSS_NAMESPACE */
  + "__flip-exit"
});

var ToastContainer = function ToastContainer(props) {
  var _useToastContainer = useToastContainer(props),
      getToastToRender = _useToastContainer.getToastToRender,
      containerRef = _useToastContainer.containerRef,
      isToastActive = _useToastContainer.isToastActive;

  var className = props.className,
      style = props.style,
      rtl = props.rtl,
      containerId = props.containerId;

  function getClassName(position) {
    var _cx;

    var defaultClassName = clsx_m("Toastify"
    /* CSS_NAMESPACE */
    + "__toast-container", "Toastify"
    /* CSS_NAMESPACE */
    + "__toast-container--" + position, (_cx = {}, _cx["Toastify"
    /* CSS_NAMESPACE */
    + "__toast-container--rtl"] = rtl, _cx));
    return isFn(className) ? className({
      position: position,
      rtl: rtl,
      defaultClassName: defaultClassName
    }) : clsx_m(defaultClassName, parseClassName(className));
  }

  return (0,react.createElement)("div", {
    ref: containerRef,
    className: "Toastify"
    /* CSS_NAMESPACE */
    ,
    id: containerId
  }, getToastToRender(function (position, toastList) {
    var containerStyle = !toastList.length ? _extends({}, style, {
      pointerEvents: 'none'
    }) : _extends({}, style);
    return (0,react.createElement)("div", {
      className: getClassName(position),
      style: containerStyle,
      key: "container-" + position
    }, toastList.map(function (_ref) {
      var content = _ref.content,
          toastProps = _ref.props;
      return (0,react.createElement)(Toast, Object.assign({}, toastProps, {
        isIn: isToastActive(toastProps.toastId),
        key: "toast-" + toastProps.key,
        closeButton: toastProps.closeButton === true ? CloseButton : toastProps.closeButton
      }), content);
    }));
  }));
};
ToastContainer.defaultProps = {
  position: POSITION.TOP_RIGHT,
  transition: Bounce,
  rtl: false,
  autoClose: 5000,
  hideProgressBar: false,
  closeButton: CloseButton,
  pauseOnHover: true,
  pauseOnFocusLoss: true,
  closeOnClick: true,
  newestOnTop: false,
  draggable: true,
  draggablePercent: 80
  /* DRAGGABLE_PERCENT */
  ,
  draggableDirection: "x"
  /* X */
  ,
  role: 'alert',
  theme: 'light'
};

var containers = /*#__PURE__*/new Map();
var latestInstance;
var containerDomNode;
var containerConfig;
var queue = [];
var lazy = false;
/**
 * Get the toast by id, given it's in the DOM, otherwise returns null
 */

function getToast(toastId, _ref) {
  var containerId = _ref.containerId;
  var container = containers.get(containerId || latestInstance);
  if (!container) return null;
  return container.getToast(toastId);
}
/**
 * Generate a random toastId
 */


function generateToastId() {
  return Math.random().toString(36).substring(2, 9);
}
/**
 * Generate a toastId or use the one provided
 */


function getToastId(options) {
  if (options && (isStr(options.toastId) || isNum(options.toastId))) {
    return options.toastId;
  }

  return generateToastId();
}
/**
 * If the container is not mounted, the toast is enqueued and
 * the container lazy mounted
 */


function dispatchToast(content, options) {
  if (containers.size > 0) {
    eventManager.emit(0
    /* Show */
    , content, options);
  } else {
    queue.push({
      content: content,
      options: options
    });

    if (lazy && canUseDom) {
      lazy = false;
      containerDomNode = document.createElement('div');
      document.body.appendChild(containerDomNode);
      (0,react_dom.render)((0,react.createElement)(ToastContainer, Object.assign({}, containerConfig)), containerDomNode);
    }
  }

  return options.toastId;
}
/**
 * Merge provided options with the defaults settings and generate the toastId
 */


function mergeOptions(type, options) {
  return _extends({}, options, {
    type: options && options.type || type,
    toastId: getToastId(options)
  });
}

function createToastByType(type) {
  return function (content, options) {
    return dispatchToast(content, mergeOptions(type, options));
  };
}

function toast(content, options) {
  return dispatchToast(content, mergeOptions(TYPE.DEFAULT, options));
}

toast.loading = function (content, options) {
  return dispatchToast(content, mergeOptions(TYPE.DEFAULT, _extends({
    isLoading: true,
    autoClose: false,
    closeOnClick: false,
    closeButton: false,
    draggable: false
  }, options)));
};

function handlePromise(promise, _ref2, options) {
  var pending = _ref2.pending,
      error = _ref2.error,
      success = _ref2.success;
  var id;

  if (pending) {
    id = isStr(pending) ? toast.loading(pending, options) : toast.loading(pending.render, _extends({}, options, pending));
  }

  var resetParams = {
    isLoading: null,
    autoClose: null,
    closeOnClick: null,
    closeButton: null,
    draggable: null
  };

  var resolver = function resolver(type, input, result) {
    // Remove the toast if the input has not been provided. This prevents the toast from hanging
    // in the pending state if a success/error toast has not been provided.
    if (input == null) {
      toast.dismiss(id);
      return;
    }

    var baseParams = _extends({
      type: type
    }, resetParams, options, {
      data: result
    });

    var params = isStr(input) ? {
      render: input
    } : input; // if the id is set we know that it's an update

    if (id) {
      toast.update(id, _extends({}, baseParams, params));
    } else {
      // using toast.promise without loading
      toast(params.render, _extends({}, baseParams, params));
    }

    return result;
  };

  var p = isFn(promise) ? promise() : promise; //call the resolvers only when needed

  p.then(function (result) {
    return resolver('success', success, result);
  })["catch"](function (err) {
    return resolver('error', error, err);
  });
  return p;
}

toast.promise = handlePromise;
toast.success = /*#__PURE__*/createToastByType(TYPE.SUCCESS);
toast.info = /*#__PURE__*/createToastByType(TYPE.INFO);
toast.error = /*#__PURE__*/createToastByType(TYPE.ERROR);
toast.warning = /*#__PURE__*/createToastByType(TYPE.WARNING);
toast.warn = toast.warning;

toast.dark = function (content, options) {
  return dispatchToast(content, mergeOptions(TYPE.DEFAULT, _extends({
    theme: 'dark'
  }, options)));
};
/**
 * Remove toast programmaticaly
 */


toast.dismiss = function (id) {
  return eventManager.emit(1
  /* Clear */
  , id);
};
/**
 * Clear waiting queue when limit is used
 */


toast.clearWaitingQueue = function (params) {
  if (params === void 0) {
    params = {};
  }

  return eventManager.emit(5
  /* ClearWaitingQueue */
  , params);
};
/**
 * return true if one container is displaying the toast
 */


toast.isActive = function (id) {
  var isToastActive = false;
  containers.forEach(function (container) {
    if (container.isToastActive && container.isToastActive(id)) {
      isToastActive = true;
    }
  });
  return isToastActive;
};

toast.update = function (toastId, options) {
  if (options === void 0) {
    options = {};
  }

  // if you call toast and toast.update directly nothing will be displayed
  // this is why I defered the update
  setTimeout(function () {
    var toast = getToast(toastId, options);

    if (toast) {
      var oldOptions = toast.props,
          oldContent = toast.content;

      var nextOptions = _extends({}, oldOptions, options, {
        toastId: options.toastId || toastId,
        updateId: generateToastId()
      });

      if (nextOptions.toastId !== toastId) nextOptions.staleId = toastId;
      var content = nextOptions.render || oldContent;
      delete nextOptions.render;
      dispatchToast(content, nextOptions);
    }
  }, 0);
};
/**
 * Used for controlled progress bar.
 */


toast.done = function (id) {
  toast.update(id, {
    progress: 1
  });
};
/**
 * @deprecated
 * API will change in the next major release
 *
 * Track changes. The callback get the number of toast displayed
 */


toast.onChange = function (callback) {
  if (isFn(callback)) {
    eventManager.on(4
    /* Change */
    , callback);
  }

  return function () {
    isFn(callback) && eventManager.off(4
    /* Change */
    , callback);
  };
};
/**
 * @deprecated
 * will be removed in the next major release
 *
 * Configure the ToastContainer when lazy mounted
 * Prefer ToastContainer over this one
 */


toast.configure = function (config) {
  if (config === void 0) {
    config = {};
  }

  lazy = true;
  containerConfig = config;
};

toast.POSITION = POSITION;
toast.TYPE = TYPE;
/**
 * Wait until the ToastContainer is mounted to dispatch the toast
 * and attach isActive method
 */

eventManager.on(2
/* DidMount */
, function (containerInstance) {
  latestInstance = containerInstance.containerId || containerInstance;
  containers.set(latestInstance, containerInstance);
  queue.forEach(function (item) {
    eventManager.emit(0
    /* Show */
    , item.content, item.options);
  });
  queue = [];
}).on(3
/* WillUnmount */
, function (containerInstance) {
  containers["delete"](containerInstance.containerId || containerInstance);

  if (containers.size === 0) {
    eventManager.off(0
    /* Show */
    ).off(1
    /* Clear */
    ).off(5
    /* ClearWaitingQueue */
    );
  }

  if (canUseDom && containerDomNode) {
    document.body.removeChild(containerDomNode);
  }
});


//# sourceMappingURL=react-toastify.esm.js.map

// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-hooks-toasts-virtual-f5251b1d06/1/packages/hooks-toasts/src/index.ts + 5 modules
var hooks_toasts_src = __webpack_require__(66746);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-component-toasts-virtual-d493a574be/1/packages/component-toasts/src/error-toast.tsx





const ErrorToast = ()=>{
    const { errorMessage , setErrorMessage , messagePosition  } = (0,hooks_toasts_src/* useToasts */.e)();
    (0,react.useEffect)(()=>{
        if (errorMessage.length) {
            toast.error(errorMessage);
            setErrorMessage("");
        }
        let interval;
        return ()=>{
            clearInterval(interval);
        };
    }, [
        errorMessage,
        setErrorMessage
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ToastContainer, {
        autoClose: 5000,
        closeOnClick: true,
        draggable: true,
        hideProgressBar: false,
        newestOnTop: false,
        pauseOnFocusLoss: false,
        pauseOnHover: true,
        position: messagePosition,
        rtl: false
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-component-toasts-virtual-d493a574be/1/packages/component-toasts/src/success-toast.tsx





const SuccessToast = ()=>{
    const { successMessage , setSuccessMessage , messagePosition  } = (0,hooks_toasts_src/* useToasts */.e)();
    (0,react.useEffect)(()=>{
        if (successMessage.length) {
            toast.success(successMessage);
            setSuccessMessage("");
        }
        let interval;
        return ()=>{
            clearInterval(interval);
        };
    }, [
        successMessage,
        setSuccessMessage
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ToastContainer, {
        autoClose: 5000,
        closeOnClick: true,
        containerId: "success-toast",
        draggable: true,
        hideProgressBar: false,
        newestOnTop: false,
        pauseOnFocusLoss: false,
        pauseOnHover: true,
        position: messagePosition,
        rtl: false
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-component-toasts-virtual-d493a574be/1/packages/component-toasts/src/index.ts



;// CONCATENATED MODULE: ./src/klaviyo.tsx



const Klaviyo = ()=>{
    const klaviyoPublicKey = (0,lib_utils_src/* getBykoConfig */.Hp)("KLAVIYO_PUBLIC_API_KEY");
    if (!klaviyoPublicKey || klaviyoPublicKey.length === 0) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
        async: true,
        src: "https://static.klaviyo.com/onsite/js/klaviyo.js?company_id=".concat(klaviyoPublicKey)
    });
};

// EXTERNAL MODULE: ../../.yarn/__virtual__/react-toastify-virtual-1c02bd8f6c/0/cache/react-toastify-npm-8.2.0-3f638b6659-670f1176fb.zip/node_modules/react-toastify/dist/ReactToastify.css
var ReactToastify = __webpack_require__(946);
;// CONCATENATED MODULE: ./src/pages/_app.tsx
/* provided dependency */ var process = __webpack_require__(97441);




























const LargeMainLoader = dynamic_default()(()=>Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 96360)).then((value)=>value.LargeMainLoader), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(96360)
            ]
    }
});
const GenesysChatWidget = dynamic_default()(()=>__webpack_require__.e(/* import() */ 4717).then(__webpack_require__.bind(__webpack_require__, 14717)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(14717)
            ]
    },
    ssr: false
});
const windowApolloState = {};
const MyApp = (props)=>{
    const { //
    pageProps , config , warehouses , categories , fieldTypes , categoriesRental  } = props;
    const Component = props.Component;
    const ref = (0,react.useRef)(null);
    useLoader(ref);
    const client = (0,lib_api_products_src/* useApollo */.Uk)(windowApolloState);
    (0,lib_api_dato_client_src/* useMegaMenuData */.VT)();
    const Layout = (0,react.useMemo)(()=>{
        var _getLayout;
        return (_getLayout = Component.getLayout) !== null && _getLayout !== void 0 ? _getLayout : (param)=>/*#__PURE__*/ {
            let { children  } = param;
            return (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: children
            });
        };
    }, [
        Component.getLayout
    ]);
    const skipHeader = (0,react.useMemo)(()=>{
        var ref;
        return (ref = Component === null || Component === void 0 ? void 0 : Component.skipHeader) !== null && ref !== void 0 ? ref : false;
    }, [
        Component === null || Component === void 0 ? void 0 : Component.skipHeader
    ]);
    const commonContext = (0,react.useMemo)(()=>({
            categories,
            warehouses,
            fieldTypes,
            config,
            categoriesRental
        }), [
        categories,
        warehouses,
        fieldTypes,
        config,
        categoriesRental
    ]);
    (0,react.useEffect)(()=>{
        if (true) {
            // TODO (Andri): Remove this after a few months
            localStorage.removeItem("preference");
        }
    }, []);
    const cmp = /*#__PURE__*/ (0,jsx_runtime.jsx)(WarehousesProvider, {
        warehouses: warehouses,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoriesProvider, {
            categories: categories,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lib_algolia_src/* AlgoliaInsightProvider */._E, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(lib_recoil_src/* RecoilRoot */.Wh, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Siteimprov, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Klaviyo, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ClearSearchOnPageLoad, {
                            searchRoutes: SEARCH_ROUTES
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ApolloProvider, {
                            client: client,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(lib_api_products_src/* CheckoutProvider */.oo, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ConfigScript, {
                                        config: config
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(lib_styles_src/* GlobalStyles */.nz, {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalHandler, {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            !skipHeader ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Header, {}) : null,
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(features/* QuickSearchResults */.ZR, {}),
                                            !skipHeader ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(src/* PageContent */.J, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(features/* BetaBanner */.JI, {}),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(style/* MainLoadingContainer */.h, {
                                                        ref: ref,
                                                        active: false,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LargeMainLoader, {})
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Layout, {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Component, {
                                                                ...pageProps
                                                            })
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MegamenuContainer, {}),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductCompareSection, {})
                                                ]
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Layout, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Component, {
                                                    ...pageProps
                                                })
                                            })
                                        ]
                                    }),
                                    !skipHeader ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer, {}) : null,
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorToast, {})
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SuccessToast, {})
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LightboxRoot, {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        id: "portal"
                                    })
                                ]
                            })
                        })
                    ]
                })
            })
        })
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(features/* CommonContext.Provider */.ko.Provider, {
        value: commonContext,
        children: [
            !skipHeader && /*#__PURE__*/ (0,jsx_runtime.jsx)(GenesysChatWidget, {}),
            " ",
            cmp
        ]
    });
};
const MyApp2 = (0,lib_api_dato_client_src/* withDato */.fg)()(MyApp);
MyApp2.getInitialProps = async (appContext)=>{
    const { Component  } = appContext;
    // We're stuck with this unless we make big alternations in architecture and deployment:
    const config = (0,types_utils_src/* isSSR */.yF)() ? {
        ENV: process.env["ENV"],
        SALEOR_GQL_URL: process.env["SALEOR_GQL_URL"],
        SALEOR_BASE_HOST: process.env["SALEOR_BASE_HOST"],
        CMS_API_URL: process.env["CMS_API_URL"],
        DATO_TOKEN_CMS: process.env["DATO_TOKEN_CMS"],
        IMAGES_API_URL: process.env["IMAGES_API_URL"],
        DATO_GRAPHQL_URL: process.env["DATO_GRAPHQL_URL"],
        ALGOLIA_APP_ID: process.env["ALGOLIA_APP_ID"],
        ALGOLIA_API_KEY: process.env["ALGOLIA_API_KEY"],
        ALGOLIA_ENV_PREFIX: process.env["ALGOLIA_ENV_PREFIX"],
        SITEIMPROV_KEY: process.env["SITEIMPROV_KEY"],
        BASE_URL: process.env["BASE_URL"],
        KLAVIYO_PUBLIC_API_KEY: process.env["KLAVIYO_PUBLIC_API_KEY"],
        SALT_PAY_TOKEN: process.env["SALT_PAY_TOKEN"],
        SALT_PAY_URL: process.env["SALT_PAY_URL"],
        NEXT_PUBLIC_SENTRY_DSN: process.env["NEXT_PUBLIC_SENTRY_DSN"],
        NEXT_PUBLIC_SENTRY_ENV: process.env["NEXT_PUBLIC_SENTRY_ENV"]
    } : window.__APP__CONFIG__;
    const [//
    { data: categories  }, { data: warehouses  }, { data: fieldTypes  }, { data: categoriesRental  }] = await Promise.all([
        //
        lib_api_rest_src/* restApi.categoriesList */._O.categoriesList(),
        lib_api_rest_src/* restApi.warehousesList */._O.warehousesList(),
        lib_api_rest_src/* restApi.fieldTypesList */._O.fieldTypesList(),
        lib_api_rest_src/* restApi.categoriesRentalList */._O.categoriesRentalList()
    ]);
    // FIXME: What is the point of setting these globals?
    //        We have context...
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const _global = (0,types_utils_src/* isSSR */.yF)() ? __webpack_require__.g : window;
    _global.__BYKO_CATEGORIES__ = categories;
    _global.__BYKO_WAREHOUSES__ = warehouses;
    const ctx = appContext.ctx;
    ctx.categories = categories;
    ctx.warehouses = warehouses;
    ctx.fieldTypes = fieldTypes;
    ctx.config = config;
    ctx.categoriesRental = categoriesRental;
    let pageProps = {};
    if (Component.getInitialProps) {
        pageProps = await Component.getInitialProps(appContext.ctx);
    }
    return {
        //
        pageProps,
        config,
        warehouses,
        categories,
        fieldTypes,
        categoriesRental
    };
};
/* harmony default export */ var _app = (MyApp2);


/***/ }),

/***/ 23392:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ MainLoadingContainer; },
/* harmony export */   "l": function() { return /* binding */ LoadingContainer; }
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(33982);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    const data = _taggedTemplateLiteral([
        "\n  position: absolute;\n  z-index: 2;\n  display: grid;\n  inset: 0;\n  opacity: ",
        ";\n  place-items: center;\n  pointer-events: none;\n  transition: opacity 0.3s ease-in-out;\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _taggedTemplateLiteral([
        "\n  position: fixed;\n  z-index: 100;\n  display: grid;\n  background-color: rgba(128, 179, 210, 0.4);\n  inset: 0;\n  opacity: ",
        ";\n  place-items: center;\n  pointer-events: none;\n  transition: 400ms;\n  transition-delay: ",
        ";\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}

const LoadingContainer = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    componentId: "sc-8e191b75-0"
})(_templateObject(), (param)=>{
    let { active  } = param;
    return active ? "1" : "0";
});
const MainLoadingContainer = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    componentId: "sc-8e191b75-1"
})(_templateObject1(), (param)=>{
    let { active  } = param;
    return active ? "1" : "0";
}, (props)=>props.active ? "400ms" : "0");


/***/ }),

/***/ 52989:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ZP": function() { return /* binding */ useLightbox; }
/* harmony export */ });
/* unused harmony exports lightboxContentState, showLightboxState */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(61261);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(33982);
/* harmony import */ var _byko_lib_recoil__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27105);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(91987);
/* harmony import */ var _byko_component_buttons__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(80620);
/* harmony import */ var _byko_lib_icons__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(45628);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    const data = _taggedTemplateLiteral([
        "\n  position: absolute;\n  top: 8px;\n  right: 8px;\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _taggedTemplateLiteral([
        "\n  position: relative;\n  display: flex;\n  overflow: auto;\n  max-width: 80%;\n  max-height: 100%;\n  flex-direction: column;\n  padding: 64px;\n  border-radius: 4px;\n  background-color: white;\n  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = _taggedTemplateLiteral([
        "\n  position: fixed;\n  z-index: 9999;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  backdrop-filter: blur(4px) grayscale(0.4);\n  inset: 0;\n  transition: opacity 0.3s ease-in-out;\n"
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}






const lightboxContentState = (0,_byko_lib_recoil__WEBPACK_IMPORTED_MODULE_1__/* .atom */ .cn)({
    key: "lightbox-contents-root",
    default: null
});
const showLightboxState = (0,_byko_lib_recoil__WEBPACK_IMPORTED_MODULE_1__/* .atom */ .cn)({
    key: "lightbox-show-root",
    default: true
});
function useLightbox() {
    const [Contents, setContents] = (0,_byko_lib_recoil__WEBPACK_IMPORTED_MODULE_1__/* .useRecoilState */ .FV)(lightboxContentState);
    const [showLightbox, setShowLightbox] = (0,_byko_lib_recoil__WEBPACK_IMPORTED_MODULE_1__/* .useRecoilState */ .FV)(showLightboxState);
    const close = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(()=>{
        setShowLightbox(false);
        setContents(null);
    }, [
        setContents,
        setShowLightbox
    ]);
    const open = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)((content)=>{
        setContents(content);
        setShowLightbox(true);
    }, [
        setContents,
        setShowLightbox
    ]);
    const Lightbbox = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(()=>{
        if (!showLightbox) return null;
        if (!Contents) return null;
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(LightboxContainer, {
            onClose: close,
            children: Contents
        });
    }, [
        Contents,
        close,
        showLightbox
    ]);
    return {
        open,
        close,
        Lightbbox
    };
}
function LightboxContainer(param) {
    let { onClose , children  } = param;
    const containerRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(null);
    const handleEsc = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)((ev)=>{
        if (ev.key === "Escape") {
            onClose();
        }
    }, [
        onClose
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(()=>{
        const container = containerRef.current;
        if (!container) return;
        container.focus();
    }, [
        containerRef
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Container, {
        ref: containerRef,
        tabIndex: 0,
        onClick: onClose,
        onKeyDown: handleEsc,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(ContentWrapper, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ButtonContainer, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_byko_component_buttons__WEBPACK_IMPORTED_MODULE_3__/* .IconButton */ .hU, {
                        ariaLabel: "Loka",
                        icon: _byko_lib_icons__WEBPACK_IMPORTED_MODULE_4__.CancelLargeIcons,
                        small: true,
                        onClick: onClose
                    })
                }),
                children
            ]
        })
    });
}
const ButtonContainer = styled_components__WEBPACK_IMPORTED_MODULE_5__["default"].div.withConfig({
    componentId: "sc-64b70770-0"
})(_templateObject());
const ContentWrapper = styled_components__WEBPACK_IMPORTED_MODULE_5__["default"].div.withConfig({
    componentId: "sc-64b70770-1"
})(_templateObject1());
const Container = styled_components__WEBPACK_IMPORTED_MODULE_5__["default"].div.withConfig({
    componentId: "sc-64b70770-2"
})(_templateObject2());


/***/ }),

/***/ 95967:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "e": function() { return /* reexport */ CardContentTabs; },
  "U": function() { return /* reexport */ KeyValueFields; }
});

// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(61261);
// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(91987);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-component-cards-virtual-43376672fa/1/packages/component-cards/src/index.ts + 3 modules
var src = __webpack_require__(71464);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-component-select-virtual-f6511e8fae/1/packages/component-select/src/index.ts + 6 modules
var component_select_src = __webpack_require__(388);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-lib-styles-virtual-b3f1d479f2/1/packages/lib-styles/src/index.ts + 18 modules
var lib_styles_src = __webpack_require__(52203);
// EXTERNAL MODULE: ../../.yarn/__virtual__/styled-components-virtual-29066d9421/0/cache/styled-components-npm-5.3.5-88e3937b59-05a664dfe4.zip/node_modules/styled-components/dist/styled-components.browser.cjs.js
var styled_components_browser_cjs = __webpack_require__(33982);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-component-typography-virtual-537720fdd1/1/packages/component-typography/src/index.ts + 2 modules
var component_typography_src = __webpack_require__(91371);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-card-content-tabs-virtual-e08db396d4/1/packages/component-card-content-tabs/src/components/tab/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    const data = _taggedTemplateLiteral([
        "\n  color: ",
        " !important;\n  transition: 200ms;\n  user-select: none;\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _taggedTemplateLiteral([
        "\n  display: flex;\n  width: fit-content;\n  height: 56px;\n  align-items: center;\n  padding-right: 24px;\n  padding-left: 24px;\n  border-bottom: 2px solid\n    ",
        ";\n  background-color: ",
        ";\n  cursor: pointer;\n  gap: 43px;\n  transition: 200ms;\n  ",
        " {\n    color: ",
        ";\n  }\n  &:hover {\n    background-color: ",
        ";\n    ",
        " {\n      color: ",
        ";\n    }\n  }\n  &:not(:first-of-type):not(:last-of-type) {\n    border-right: 1px solid ",
        ";\n    border-left: 1px solid ",
        ";\n  }\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}



const Label = (0,styled_components_browser_cjs["default"])(component_typography_src/* BtnText */.xh).withConfig({
    componentId: "sc-d20d4b89-0"
})(_templateObject(), (props)=>props.textColor);
const Container = styled_components_browser_cjs["default"].button.withConfig({
    componentId: "sc-d20d4b89-1"
})(_templateObject1(), (props)=>props.active ? lib_styles_src/* theme.palette.blue.main */.rS.palette.blue.main : lib_styles_src/* theme.palette.transparent.main */.rS.palette.transparent.main, (props)=>props.active ? lib_styles_src/* theme.palette.gray.5 */.rS.palette.gray[5] : lib_styles_src/* theme.palette.white.main */.rS.palette.white.main, Label, (props)=>props.active ? lib_styles_src/* theme.palette.blue.main */.rS.palette.blue.main : lib_styles_src/* theme.palette.blue.dark */.rS.palette.blue.dark, lib_styles_src/* theme.palette.gray.5 */.rS.palette.gray[5], Label, lib_styles_src/* theme.palette.blue.main */.rS.palette.blue.main, lib_styles_src/* theme.palette.gray.10 */.rS.palette.gray[10], lib_styles_src/* theme.palette.gray.10 */.rS.palette.gray[10]);

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-card-content-tabs-virtual-e08db396d4/1/packages/component-card-content-tabs/src/components/tab/tab.tsx



const Tab = (param)=>{
    let { label , icon: Icon , highlightColor , active , index , setActive  } = param;
    const handleClick = (0,react.useCallback)(()=>{
        setActive(index);
    }, [
        setActive,
        index
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container, {
        active: active,
        onClick: handleClick,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Label, {
                textColor: highlightColor,
                children: label
            }),
            Icon && /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon, {
                iconColor: highlightColor,
                size: 24
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-card-content-tabs-virtual-e08db396d4/1/packages/component-card-content-tabs/src/components/tab/index.ts


// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-component-buttons-virtual-1a577fdc8c/1/packages/component-buttons/src/index.ts + 16 modules
var component_buttons_src = __webpack_require__(80620);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-lib-icons-virtual-412b14e947/1/packages/lib-icons/src/index.ts + 181 modules
var lib_icons_src = __webpack_require__(45628);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-card-content-tabs-virtual-e08db396d4/1/packages/component-card-content-tabs/src/components/key-value-fields/styles.ts
function styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function styles_templateObject() {
    const data = styles_taggedTemplateLiteral([
        "\n  display: grid;\n  padding-bottom: 16px;\n  column-gap: 16px;\n  grid-template-columns: 1fr 1fr;\n  @media screen and (max-width: ",
        "px) {\n    grid-template-columns: 1fr;\n  }\n"
    ]);
    styles_templateObject = function() {
        return data;
    };
    return data;
}
function styles_templateObject1() {
    const data = styles_taggedTemplateLiteral([
        "\n  display: flex;\n  min-height: 56px;\n  flex-flow: row wrap;\n  align-items: center;\n  justify-content: space-between;\n  padding: 6px 16px;\n  border-bottom: 1px solid ",
        ";\n  gap: 16px;\n  button {\n    min-width: 187px;\n  }\n  @media screen and (max-width: ",
        "px) {\n    height: auto;\n    flex-direction: column;\n    align-items: flex-start;\n    padding: 8px 16px;\n    row-gap: 8px;\n  }\n"
    ]);
    styles_templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = styles_taggedTemplateLiteral([
        "\n  width: 189px;\n"
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}


const styles_Container = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-7f5f46e2-0"
})(styles_templateObject(), lib_styles_src/* gridTheme.breakpoints.s */.k.breakpoints.s);
const Item = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-7f5f46e2-1"
})(styles_templateObject1(), lib_styles_src/* theme.palette.gray.20 */.rS.palette.gray[20], lib_styles_src/* gridTheme.breakpoints.xs */.k.breakpoints.xs);
const ButtonContainer = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-7f5f46e2-2"
})(_templateObject2());

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-card-content-tabs-virtual-e08db396d4/1/packages/component-card-content-tabs/src/components/key-value-fields/key-value-field.tsx








const KeyValueField = (param)=>{
    let { item  } = param;
    const { activeBreakPoint  } = (0,lib_styles_src/* useWindowSize */.iP)();
    const isDownloadField = (0,react.useMemo)(()=>{
        return Boolean(item.url || item.filePath);
    }, [
        item.url,
        item.filePath
    ]);
    const handleDownload = (0,react.useCallback)(()=>{
        if (!item.url && !item.filePath) {
            return;
        }
        if (item.filePath) {
            window.open(item.filePath, "_blank");
            return;
        }
        window.open(item.url, "_blank");
    }, [
        item.filePath,
        item.url
    ]);
    if (!isDownloadField && !item.value) {
        return null;
    }
    const label = item.key ? item.key : item.fileName;
    const shortLabel = label && label.length > 20 ? "".concat(label.substring(0, 20), "...") : label;
    const value = item.value ? item.value : item.fileName;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Item, {
        children: [
            [
                "lg",
                "md",
                "sm"
            ].includes(activeBreakPoint) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(component_typography_src/* PLargeBold */.ej, {
                textColor: lib_styles_src/* theme.palette.blue.dark */.rS.palette.blue.dark,
                children: label
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(component_typography_src/* PMedium */.aW, {
                textColor: lib_styles_src/* theme.palette.blue.dark */.rS.palette.blue.dark,
                children: shortLabel
            }),
            isDownloadField && /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonContainer, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(component_buttons_src/* Button */.zx, {
                    icon: lib_icons_src.DownloadIcons,
                    label: "S\xe6kja skjal",
                    small: true,
                    stretch: true,
                    onClick: handleDownload
                })
            }),
            !isDownloadField && [
                "lg",
                "md",
                "sm"
            ].includes(activeBreakPoint) && /*#__PURE__*/ (0,jsx_runtime.jsx)(component_typography_src/* PLarge */.cG, {
                textColor: lib_styles_src/* theme.palette.blue.dark */.rS.palette.blue.dark,
                children: value
            }),
            !isDownloadField && [
                "s",
                "xs"
            ].includes(activeBreakPoint) && /*#__PURE__*/ (0,jsx_runtime.jsx)(component_typography_src/* PMedium */.aW, {
                textColor: lib_styles_src/* theme.palette.blue.dark */.rS.palette.blue.dark,
                children: value
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-card-content-tabs-virtual-e08db396d4/1/packages/component-card-content-tabs/src/components/key-value-fields/key-value-fields.tsx




const KeyValueFields = (param)=>{
    let { collection  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_Container, {
        children: collection.map((item)=>{
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(KeyValueField, {
                item: item
            }, item.id ? item.id : item.fileName);
        })
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-card-content-tabs-virtual-e08db396d4/1/packages/component-card-content-tabs/src/components/key-value-fields/index.ts



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-card-content-tabs-virtual-e08db396d4/1/packages/component-card-content-tabs/src/components/index.ts



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-card-content-tabs-virtual-e08db396d4/1/packages/component-card-content-tabs/src/styles.ts
function src_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function src_styles_templateObject() {
    const data = src_styles_taggedTemplateLiteral([
        "\n  position: relative;\n  width: 100%;\n"
    ]);
    src_styles_templateObject = function() {
        return data;
    };
    return data;
}
function src_styles_templateObject1() {
    const data = src_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  width: 100%;\n  border-bottom: 1px solid ",
        ";\n  margin-bottom: 24px;\n  @media screen and (max-width: ",
        "px) {\n    margin-bottom: 8px;\n  }\n"
    ]);
    src_styles_templateObject1 = function() {
        return data;
    };
    return data;
}
function styles_templateObject2() {
    const data = src_styles_taggedTemplateLiteral([
        "\n  width: 100%;\n"
    ]);
    styles_templateObject2 = function() {
        return data;
    };
    return data;
}


const src_styles_Container = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-d530e935-0"
})(src_styles_templateObject());
const Tabs = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-d530e935-1"
})(src_styles_templateObject1(), lib_styles_src/* theme.palette.gray.10 */.rS.palette.gray[10], lib_styles_src/* gridTheme.container.maxWidth.md */.k.container.maxWidth.md);
const Content = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-d530e935-2"
})(styles_templateObject2());

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-card-content-tabs-virtual-e08db396d4/1/packages/component-card-content-tabs/src/card-content-tabs.tsx








const CardContentTabs = (param)=>{
    let { tabCollection , defaultIndex  } = param;
    const { activeBreakPoint  } = (0,lib_styles_src/* useWindowSize */.iP)();
    const [activeTabIndex, setActiveTabIndex] = (0,react.useState)(defaultIndex !== null && defaultIndex !== void 0 ? defaultIndex : 0);
    const localTabCollection = (0,react.useMemo)(()=>{
        return tabCollection.map((tab, index)=>{
            return {
                ...tab,
                index,
                active: index === activeTabIndex
            };
        });
    }, [
        activeTabIndex,
        tabCollection
    ]);
    const activeItem = (0,react.useMemo)(()=>{
        return localTabCollection.find((item)=>{
            return item.active;
        });
    }, [
        localTabCollection
    ]);
    const activeContent = (0,react.useMemo)(()=>{
        var ref;
        return (ref = activeItem === null || activeItem === void 0 ? void 0 : activeItem.content) !== null && ref !== void 0 ? ref : null;
    }, [
        activeItem
    ]);
    const handleDropdownSelect = (0,react.useCallback)((value)=>{
        if (!value || !value.selectedItem) {
            return;
        }
        var _index;
        setActiveTabIndex((_index = value.selectedItem.index) !== null && _index !== void 0 ? _index : 0);
    }, []);
    var ref;
    const handleItemToString = (0,react.useCallback)((option)=>{
        return (ref = option === null || option === void 0 ? void 0 : option.label) !== null && ref !== void 0 ? ref : "";
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* Card */.Z, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(src_styles_Container, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Tabs, {
                    children: [
                        [
                            "lg",
                            "md",
                            "sm"
                        ].includes(activeBreakPoint) && localTabCollection.map((item)=>{
                            var _active, _highlightColor, _index;
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Tab, {
                                active: (_active = item.active) !== null && _active !== void 0 ? _active : false,
                                highlightColor: (_highlightColor = item.highlightColor) !== null && _highlightColor !== void 0 ? _highlightColor : lib_styles_src/* theme.palette.blue.main */.rS.palette.blue.main,
                                icon: item.icon,
                                index: (_index = item.index) !== null && _index !== void 0 ? _index : -1,
                                label: item.label,
                                setActive: setActiveTabIndex
                            }, item.label);
                        }),
                        [
                            "s",
                            "xs"
                        ].includes(activeBreakPoint) && /*#__PURE__*/ (0,jsx_runtime.jsx)(component_select_src/* Select */.P, {
                            align: "left",
                            fit: true,
                            handleSelectedItemChange: handleDropdownSelect,
                            items: localTabCollection,
                            itemToString: handleItemToString,
                            placeholder: activeItem === null || activeItem === void 0 ? void 0 : activeItem.label,
                            selectedItem: activeItem
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Content, {
                    children: activeContent
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-card-content-tabs-virtual-e08db396d4/1/packages/component-card-content-tabs/src/index.ts




/***/ }),

/***/ 6920:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "b": function() { return /* reexport */ Alert; }
});

// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(61261);
// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(91987);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-component-buttons-virtual-1a577fdc8c/1/packages/component-buttons/src/index.ts + 16 modules
var src = __webpack_require__(80620);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-component-tooltip-virtual-e0488091c2/1/packages/component-tooltip/src/index.ts + 2 modules
var component_tooltip_src = __webpack_require__(63323);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-component-typography-virtual-537720fdd1/1/packages/component-typography/src/index.ts + 2 modules
var component_typography_src = __webpack_require__(91371);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-lib-icons-virtual-412b14e947/1/packages/lib-icons/src/index.ts + 181 modules
var lib_icons_src = __webpack_require__(45628);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-lib-styles-virtual-b3f1d479f2/1/packages/lib-styles/src/index.ts + 18 modules
var lib_styles_src = __webpack_require__(52203);
// EXTERNAL MODULE: ../../.yarn/__virtual__/styled-components-virtual-29066d9421/0/cache/styled-components-npm-5.3.5-88e3937b59-05a664dfe4.zip/node_modules/styled-components/dist/styled-components.browser.cjs.js
var styled_components_browser_cjs = __webpack_require__(33982);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-component-alert-virtual-0012017e3d/1/packages/component-alert/src/styles.ts
/* stylelint-disable no-extra-semicolons */ /* stylelint-disable no-extra-semicolons */ function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    const data = _taggedTemplateLiteral([
        "\n  max-width: ",
        ";\n  min-height: ",
        ";\n  padding: ",
        ";\n  margin-top: ",
        ";\n  margin-bottom: ",
        ";\n  opacity: ",
        ";\n  pointer-events: none;\n  transition: all 0.3s;\n  ",
        ";\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _taggedTemplateLiteral([
        "\n  position: relative;\n  display: grid;\n  align-items: center;\n  gap: 15px;\n  grid-template-columns: 24px auto;\n  pointer-events: none;\n  p {\n    margin-top: 4px;\n  }\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = _taggedTemplateLiteral([
        "\n  pointer-events: initial;\n"
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = _taggedTemplateLiteral([
        "\n  position: absolute;\n  z-index: 30000000000;\n  right: 0px;\n  display: block;\n  pointer-events: initial;\n  .icon-button {\n    border: unset;\n    background-color: transparent;\n    outline: unset;\n    &:hover {\n      background-color: rgba(255, 255, 255, 0.4);\n    }\n  }\n"
    ]);
    _templateObject3 = function() {
        return data;
    };
    return data;
}


const handleColorType = (alertType)=>{
    switch(alertType){
        case "info":
            return "background-color: ".concat(lib_styles_src/* theme.palette.blue.lightest */.rS.palette.blue.lightest, ";\n              border-top: 1px solid ").concat(lib_styles_src/* theme.palette.blue.main */.rS.palette.blue.main, ";\n              border-bottom: 1px solid ").concat(lib_styles_src/* theme.palette.blue.main */.rS.palette.blue.main, "};\n              svg {path {stroke: ").concat(lib_styles_src/* theme.palette.blue.main */.rS.palette.blue.main, "}};");
        case "warning":
            return "background-color: ".concat(lib_styles_src/* theme.palette.triggers.warning.lightest */.rS.palette.triggers.warning.lightest, ";\n              border-top: 1px solid ").concat(lib_styles_src/* theme.palette.triggers.warning.main */.rS.palette.triggers.warning.main, ";\n              border-bottom: 1px solid ").concat(lib_styles_src/* theme.palette.triggers.warning.main */.rS.palette.triggers.warning.main, "};");
        case "success":
            return "background-color: ".concat(lib_styles_src/* theme.palette.triggers.success.lightest */.rS.palette.triggers.success.lightest, ";\n              border-top: 1px solid ").concat(lib_styles_src/* theme.palette.triggers.success.main */.rS.palette.triggers.success.main, ";\n              border-bottom: 1px solid ").concat(lib_styles_src/* theme.palette.triggers.success.main */.rS.palette.triggers.success.main, "};");
        case "attention":
            return "background-color: ".concat(lib_styles_src/* theme.palette.triggers.attention.lightest */.rS.palette.triggers.attention.lightest, ";\n              border-top: 1px solid ").concat(lib_styles_src/* theme.palette.triggers.attention.main */.rS.palette.triggers.attention.main, ";\n              border-bottom: 1px solid ").concat(lib_styles_src/* theme.palette.triggers.attention.main */.rS.palette.triggers.attention.main, "};");
        default:
            return "background-color: ".concat(lib_styles_src/* theme.palette.white.main */.rS.palette.white.main, ";");
    }
};
const AlertContainer = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-7d9e1543-0"
})(_templateObject(), (props)=>props.stretch ? "100%" : "556px", (props)=>props.showSuccess ? "56px" : "0", (props)=>props.showSuccess ? "17px" : "0", (p)=>p.showSuccess ? "".concat(p.top, "px") : "0", (p)=>p.showSuccess ? "".concat(p.bottom, "px") : "0", (props)=>props.showSuccess ? "1" : "0", (props)=>handleColorType(props.alertType));
const AlertContentContainer = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-7d9e1543-1"
})(_templateObject1());
const AlertTooltipContainer = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-7d9e1543-2"
})(_templateObject2());
const CloseIconContainer = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-7d9e1543-3"
})(_templateObject3());

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-component-alert-virtual-0012017e3d/1/packages/component-alert/src/alert.tsx








const Alert = (param)=>{
    let { text ="" , alertType ="info" , minWidth , stretch , showSuccess , setShowSuccess , top , bottom , tooltipText , hideClose =false  } = param;
    const [localShow, setLocalShow] = (0,react.useState)(showSuccess);
    const handleClose = (0,react.useCallback)(()=>{
        setShowSuccess && setShowSuccess(false);
        setLocalShow(false);
    }, [
        setShowSuccess
    ]);
    (0,react.useEffect)(()=>{
        setLocalShow(showSuccess);
    }, [
        showSuccess
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(AlertContainer, {
        alertType: alertType,
        bottom: bottom !== null && bottom !== void 0 ? bottom : "",
        minWidth: minWidth,
        showSuccess: !!localShow,
        stretch: !!stretch,
        text: text,
        top: top !== null && top !== void 0 ? top : "",
        children: localShow && /*#__PURE__*/ (0,jsx_runtime.jsxs)(AlertContentContainer, {
            children: [
                alertType === "info" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(lib_icons_src.InfoIcons, {
                    size: 24
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(lib_icons_src.AttentionIcons, {
                    iconColor: alertType === "attention" ? lib_styles_src/* theme.palette.triggers.attention.main */.rS.palette.triggers.attention.main : alertType === "warning" ? lib_styles_src/* theme.palette.triggers.warning.main */.rS.palette.triggers.warning.main : lib_styles_src/* theme.palette.triggers.success.main */.rS.palette.triggers.success.main,
                    size: 24
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(component_typography_src/* PMedium */.aW, {
                    textColor: lib_styles_src/* theme.palette.blue.dark */.rS.palette.blue.dark,
                    children: text
                }),
                tooltipText != undefined && /*#__PURE__*/ (0,jsx_runtime.jsx)(AlertTooltipContainer, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(component_tooltip_src/* Tooltip */.u, {
                        arrowLocation: "right",
                        // eslint-disable-next-line max-len
                        content: tooltipText
                    })
                }),
                !hideClose && /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseIconContainer, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* IconButton */.hU, {
                        ariaLabel: "Loka",
                        buttonColor: "whiteButton",
                        icon: lib_icons_src.CancelLargeIcons,
                        small: true,
                        onClick: handleClose
                    })
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-component-alert-virtual-0012017e3d/1/packages/component-alert/src/index.ts



/***/ }),

/***/ 80620:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "zx": function() { return /* reexport */ Button; },
  "hU": function() { return /* reexport */ IconButton; },
  "Wu": function() { return /* reexport */ NumericButton; },
  "kq": function() { return /* reexport */ SecondaryButton; }
});

// UNUSED EXPORTS: SimpleRadioButton

// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(61261);
// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(91987);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-lib-styles-virtual-b3f1d479f2/1/packages/lib-styles/src/index.ts + 18 modules
var src = __webpack_require__(52203);
// EXTERNAL MODULE: ../../.yarn/__virtual__/styled-components-virtual-29066d9421/0/cache/styled-components-npm-5.3.5-88e3937b59-05a664dfe4.zip/node_modules/styled-components/dist/styled-components.browser.cjs.js
var styled_components_browser_cjs = __webpack_require__(33982);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-component-buttons-virtual-1a577fdc8c/1/packages/component-buttons/src/icon-button/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    const data = _taggedTemplateLiteral([
        "\n  display: flex;\n  width: ",
        ";\n  height: ",
        ";\n  align-items: center;\n  justify-content: center;\n  border: ",
        ";\n  transition: all 0.5s;\n  svg {\n    * {\n      transition: all 0.5s;\n    }\n  }\n\n  &:disabled {\n    border: 1px solid ",
        ";\n    background-color: ",
        ";\n    pointer-events: none;\n    p {\n      color: ",
        ";\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}


const IconButtonContainer = styled_components_browser_cjs["default"].button.withConfig({
    componentId: "sc-df67ee6b-0"
})(_templateObject(), (props)=>props.small ? "40px" : "56px", (props)=>props.small ? "40px" : "54px", (props)=>props.buttonColor === "whiteButton" ? "1px solid ".concat(src/* theme.palette.gray.30 */.rS.palette.gray[30]) : "none", src/* theme.palette.gray.10 */.rS.palette.gray[10], src/* theme.palette.white.main */.rS.palette.white.main, src/* theme.palette.gray.30 */.rS.palette.gray[30], (props)=>props.buttonColor ? (0,src/* handleColorType */.AD)(props.buttonColor) : "");

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-component-buttons-virtual-1a577fdc8c/1/packages/component-buttons/src/icon-button/icon-button.tsx





const IconButton = (param)=>{
    let { icon: Icon , ariaLabel , className , onClick , disabled =false , small =false , buttonColor ="whiteButton" , customClassName ="icon-button"  } = param;
    const [isHovering, setIsHovering] = (0,react.useState)(false);
    const iconColor = (0,react.useMemo)(()=>{
        switch(buttonColor){
            case "blueButton":
                return src/* theme.palette.yellow.main */.rS.palette.yellow.main;
            case "greenButton":
                return src/* theme.palette.white.main */.rS.palette.white.main;
            case "orangeButton":
                return src/* theme.palette.white.main */.rS.palette.white.main;
            case "redButton":
                return isHovering ? src/* theme.palette.white.main */.rS.palette.white.main : src/* theme.palette.triggers.warning.main */.rS.palette.triggers.warning.main;
            case "whiteButton":
                return src/* theme.palette.blue.main */.rS.palette.blue.main;
            case "yellowButton":
                return src/* theme.palette.blue.main */.rS.palette.blue.main;
            default:
                return src/* theme.palette.blue.main */.rS.palette.blue.main;
        }
    }, [
        buttonColor,
        isHovering
    ]);
    const handleMouseOver = (0,react.useCallback)(()=>{
        setIsHovering(true);
    }, []);
    const handleMouseOut = (0,react.useCallback)(()=>{
        setIsHovering(false);
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButtonContainer, {
        "aria-label": ariaLabel !== null && ariaLabel !== void 0 ? ariaLabel : "",
        buttonColor: buttonColor,
        className: "".concat(customClassName !== null && customClassName !== void 0 ? customClassName : "").concat(customClassName ? " " : "").concat(className !== null && className !== void 0 ? className : ""),
        disabled: disabled,
        role: "button",
        small: small,
        title: ariaLabel,
        onClick: onClick,
        onMouseOut: handleMouseOut,
        onMouseOver: handleMouseOver,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon, {
            iconColor: disabled ? src/* theme.palette.gray.30 */.rS.palette.gray[30] : iconColor,
            size: small ? 16 : 24
        })
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-component-buttons-virtual-1a577fdc8c/1/packages/component-buttons/src/icon-button/index.ts


// EXTERNAL MODULE: ../../.yarn/__virtual__/next-virtual-cff1f1d108/0/cache/next-npm-13.0.0-0d765f7d5e-7b5c847287.zip/node_modules/next/link.js
var next_link = __webpack_require__(58804);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-component-typography-virtual-537720fdd1/1/packages/component-typography/src/index.ts + 2 modules
var component_typography_src = __webpack_require__(91371);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-component-buttons-virtual-1a577fdc8c/1/packages/component-buttons/src/button/styles.ts
function styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function styles_templateObject() {
    const data = styles_taggedTemplateLiteral([
        "\n  display: inline-flex;\n  width: ",
        ";\n  height: ",
        ";\n  box-sizing: border-box;\n  flex-direction: ",
        ";\n  align-items: center;\n  justify-content: ",
        ";\n  padding: 12px 24px;\n  border: 1px solid ",
        ";\n  gap: 10px;\n  text-align: left;\n  transition: color 0.5s, border-color 0.5s, background-color 0.5s, padding 0.3s;\n  p {\n    -webkit-font-smoothing: antialiased;\n    letter-spacing: 0.5px;\n    &::selection {\n      background-color: unset;\n    }\n  }\n\n  &:disabled {\n    border: 1px solid ",
        ";\n    background-color: ",
        ";\n    pointer-events: none;\n    p {\n      color: ",
        ";\n    }\n  }\n\n  ",
        ";\n\n  @media screen and (min-width: ",
        "px) {\n    &:hover {\n      padding: ",
        ";\n    }\n  }\n\n  @media screen and (max-width: ",
        "px) {\n    height: ",
        ";\n    padding: 10px 24px;\n    p {\n      font-size: 14px;\n    }\n    &:hover {\n      padding: 10px 24px;\n    }\n  }\n"
    ]);
    styles_templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = styles_taggedTemplateLiteral([
        "\n  display: inline-flex;\n  width: ",
        ";\n  height: ",
        ";\n  box-sizing: border-box;\n  flex-direction: ",
        ";\n  align-items: center;\n  justify-content: ",
        ";\n  padding: 12px 24px;\n  border: 1px solid ",
        ";\n  gap: 10px;\n  text-align: left;\n  transition: color 0.5s, border-color 0.5s, background-color 0.5s, padding 0.3s;\n  a,\n  p {\n    -webkit-font-smoothing: antialiased;\n    letter-spacing: 0.5px;\n    &::selection {\n      background-color: rgba(0, 0, 0, 0);\n    }\n  }\n\n  ",
        ";\n\n  @media screen and (min-width: ",
        "px) {\n    &:hover {\n      padding: ",
        ";\n    }\n  }\n\n  @media screen and (max-width: ",
        "px) {\n    height: ",
        ";\n    padding: 10px 24px;\n    p {\n      font-size: 14px;\n    }\n    &:hover {\n      padding: 10px 24px;\n    }\n  }\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}


const ButtonContainer = styled_components_browser_cjs["default"].button.withConfig({
    componentId: "sc-90db6ceb-0"
})(styles_templateObject(), (props)=>props.stretch ? "100%" : "245px", (p)=>p.small ? "40px" : p.height ? "".concat(p.height) : "56px", (p)=>p.iconLeftSide ? "row-reverse" : "row", (p)=>p.iconLeftSide ? "flex-end" : p.hasIcon ? "space-between" : "center", src/* theme.palette.white.main */.rS.palette.white.main, src/* theme.palette.gray.30 */.rS.palette.gray[30], src/* theme.palette.white.main */.rS.palette.white.main, src/* theme.palette.gray.30 */.rS.palette.gray[30], (props)=>(0,src/* handleColorType */.AD)(props.buttonColor), src/* gridTheme.container.minWidth.s */.k.container.minWidth.s, (p)=>p.hasIcon ? "12px 32px 12px 24px" : "12px 24px", src/* gridTheme.breakpoints.xs */.k.breakpoints.xs, (p)=>p.small ? "40px" : p.height ? "".concat(p.height) : "46px");
const HrefContainer = styled_components_browser_cjs["default"].a.withConfig({
    componentId: "sc-90db6ceb-1"
})(_templateObject1(), (props)=>props.stretch ? "100%" : "245px", (p)=>p.small ? "40px" : p.height ? "".concat(p.height) : "56px", (p)=>p.iconLeftSide ? "row-reverse" : "row", (p)=>p.iconLeftSide ? "flex-end" : p.hasIcon ? "space-between" : "center", src/* theme.palette.white.main */.rS.palette.white.main, (props)=>(0,src/* handleColorType */.AD)(props.buttonColor), src/* gridTheme.container.minWidth.s */.k.container.minWidth.s, (p)=>p.hasIcon ? "12px 32px 12px 24px" : "12px 24px", src/* gridTheme.breakpoints.xs */.k.breakpoints.xs, (p)=>p.small ? "40px" : p.height ? "".concat(p.height) : "46px");

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-component-buttons-virtual-1a577fdc8c/1/packages/component-buttons/src/button/button.tsx







const Button = (param)=>{
    let { label , onClick , icon: Icon , stretch =false , className , small =false , disabled =false , buttonColor ="whiteButton" , customClassName ="button-container" , as ="button" , href ="#" , hrefBehaviour ="internal" , type , ...props } = param;
    const iconColor = (0,react.useMemo)(()=>{
        switch(buttonColor){
            case "blueButton":
                return src/* theme.palette.yellow.main */.rS.palette.yellow.main;
            case "greenButton":
                return src/* theme.palette.white.main */.rS.palette.white.main;
            case "orangeButton":
                return src/* theme.palette.white.main */.rS.palette.white.main;
            case "redButton":
                return src/* theme.palette.triggers.warning.main */.rS.palette.triggers.warning.main;
            case "whiteButton":
                return src/* theme.palette.blue.main */.rS.palette.blue.main;
            case "yellowButton":
                return src/* theme.palette.blue.main */.rS.palette.blue.main;
            default:
                return src/* theme.palette.blue.main */.rS.palette.blue.main;
        }
    }, [
        buttonColor
    ]);
    const Parent = (0,react.useMemo)(()=>{
        if (hrefBehaviour === "internal") {
            return (param)=>/*#__PURE__*/ {
                let { children  } = param;
                return (0,jsx_runtime.jsx)((link_default()), {
                    href: href !== null && href !== void 0 ? href : "#",
                    legacyBehavior: true,
                    children: children
                });
            };
        }
        return (param)=>/*#__PURE__*/ {
            let { children  } = param;
            return (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: children
            });
        };
    }, [
        href,
        hrefBehaviour
    ]);
    if (as === "button") {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ButtonContainer, {
            "aria-label": label,
            buttonColor: buttonColor,
            className: "".concat(customClassName !== null && customClassName !== void 0 ? customClassName : "").concat(customClassName ? " " : "").concat(className !== null && className !== void 0 ? className : ""),
            disabled: !!disabled,
            hasIcon: Boolean(Icon),
            small: small,
            stretch: stretch,
            type: type !== null && type !== void 0 ? type : "button",
            onClick: onClick !== null && onClick !== void 0 ? onClick : undefined,
            ...props,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(component_typography_src/* PMedium */.aW, {
                    lineHeight: "100%",
                    children: label
                }),
                Icon && /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon, {
                    className: "button-icon",
                    iconColor: disabled ? src/* theme.palette.gray.30 */.rS.palette.gray[30] : iconColor,
                    size: small ? 16 : 24
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Parent, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(HrefContainer, {
            "aria-label": label,
            buttonColor: buttonColor,
            className: customClassName !== null && customClassName !== void 0 ? customClassName : undefined,
            hasIcon: Boolean(Icon),
            href: href !== null && href !== void 0 ? href : "#",
            small: small,
            stretch: stretch,
            target: hrefBehaviour === "internal" ? "_self" : "_blank",
            type: type !== null && type !== void 0 ? type : "button",
            ...props,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(component_typography_src/* PMedium */.aW, {
                    lineHeight: "100%",
                    children: label
                }),
                Icon && /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon, {
                    className: "button-icon",
                    iconColor: disabled ? src/* theme.palette.gray.30 */.rS.palette.gray[30] : iconColor,
                    size: small ? 16 : 24
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-component-buttons-virtual-1a577fdc8c/1/packages/component-buttons/src/button/index.ts


;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-component-buttons-virtual-1a577fdc8c/1/packages/component-buttons/src/secondary-button/styles.ts
function secondary_button_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function secondary_button_styles_templateObject() {
    const data = secondary_button_styles_taggedTemplateLiteral([
        "\n  width: fit-content;\n  @media screen and (max-width: ",
        "px) {\n    p {\n      font-size: 16px;\n    }\n  }\n"
    ]);
    secondary_button_styles_templateObject = function() {
        return data;
    };
    return data;
}
function styles_templateObject1() {
    const data = secondary_button_styles_taggedTemplateLiteral([
        "\n  z-index: 1;\n  display: flex;\n  width: ",
        ";\n  height: 1px;\n  margin-top: 5px;\n  margin-left: ",
        ";\n  background-color: ",
        ";\n  transition: width 0.3s ease-in-out;\n"
    ]);
    styles_templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = secondary_button_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  width: fit-content;\n  align-items: center;\n  gap: 20px;\n  white-space: nowrap;\n  svg {\n    margin-bottom: 4px;\n    margin-left: 4px;\n  }\n  &:hover + ",
        " {\n    width: 100%;\n  }\n  @media screen and (max-width: ",
        "px) {\n    gap: 10px;\n  }\n"
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}


const SecondaryButtonWrapper = styled_components_browser_cjs["default"].button.withConfig({
    componentId: "sc-e7b59a5d-0"
})(secondary_button_styles_templateObject(), src/* gridTheme.breakpoints.s */.k.breakpoints.s);
const FocusLine = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-e7b59a5d-1"
})(styles_templateObject1(), (p)=>p.smallIcon ? "22px" : p.noIcon ? "28px" : "9px", (p)=>p.noIcon ? "unset" : "-4px", (p)=>p.blueLine ? "".concat(src/* theme.palette.blue.main */.rS.palette.blue.main) : "".concat(src/* theme.palette.yellow.main */.rS.palette.yellow.main));
const TheSecondaryButton = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-e7b59a5d-2"
})(_templateObject2(), FocusLine, src/* gridTheme.breakpoints.s */.k.breakpoints.s);

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-component-buttons-virtual-1a577fdc8c/1/packages/component-buttons/src/secondary-button/secondary-button.tsx






const SecondaryButton = (param)=>{
    let { label ="" , ariaLabel =label , icon: Icon , smallIcon =false , darkBlueText =false , blueLine =false , iconColor =src/* theme.palette.blue.main */.rS.palette.blue.main , ...props } = param;
    const noIcon = (0,react.useMemo)(()=>{
        return Boolean(Icon);
    }, [
        Icon
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SecondaryButtonWrapper, {
        ...props,
        "aria-label": label ? label : ariaLabel,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(TheSecondaryButton, {
                darkBlueText: darkBlueText,
                children: [
                    Icon ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon, {
                        iconColor: iconColor ? iconColor : darkBlueText ? src/* theme.palette.blue.dark */.rS.palette.blue.dark : src/* theme.palette.blue.main */.rS.palette.blue.main,
                        size: smallIcon ? 16 : 24
                    }) : noIcon,
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(component_typography_src/* PLargeBold */.ej, {
                        textColor: darkBlueText ? src/* theme.palette.blue.dark */.rS.palette.blue.dark : src/* theme.palette.blue.main */.rS.palette.blue.main,
                        children: label
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FocusLine, {
                blueLine: blueLine,
                noIcon: noIcon,
                smallIcon: smallIcon
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-component-buttons-virtual-1a577fdc8c/1/packages/component-buttons/src/secondary-button/index.ts


;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-component-buttons-virtual-1a577fdc8c/1/packages/component-buttons/src/radio-buttons/simple-radio-button/styles.ts
function simple_radio_button_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function simple_radio_button_styles_templateObject() {
    const data = simple_radio_button_styles_taggedTemplateLiteral([
        "\n  position: absolute;\n  top: 50%;\n  left: ",
        ";\n  padding: 0px 24px;\n  color: ",
        ";\n  cursor: pointer;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: normal;\n  line-height: 170%;\n  opacity: ",
        ";\n  transform: ",
        ";\n"
    ]);
    simple_radio_button_styles_templateObject = function() {
        return data;
    };
    return data;
}
function simple_radio_button_styles_templateObject1() {
    const data = simple_radio_button_styles_taggedTemplateLiteral([
        "\n  position: relative;\n  display: flex;\n  width: 24px;\n  height: 24px;\n  justify-content: ",
        ";\n  border: 3px solid ",
        ";\n  border-radius: 50%;\n"
    ]);
    simple_radio_button_styles_templateObject1 = function() {
        return data;
    };
    return data;
}
function styles_templateObject2() {
    const data = simple_radio_button_styles_taggedTemplateLiteral([
        "\n  position: absolute;\n  top: 2px;\n  left: 2px;\n  width: 14px;\n  height: 14px;\n  align-self: center;\n  border-radius: 50%;\n  pointer-events: auto;\n"
    ]);
    styles_templateObject2 = function() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = simple_radio_button_styles_taggedTemplateLiteral([
        "\n  position: absolute;\n  z-index: 1;\n  top: 0;\n  left: 0;\n  width: ",
        ";\n  height: 24px;\n  margin-right: 10px;\n  cursor: pointer;\n  opacity: 0;\n  &:hover ~ ",
        " {\n    background: ",
        ";\n    &::after {\n      display: block;\n      width: 12px;\n      height: 12px;\n      margin: 4px;\n      color: ",
        ";\n    }\n  }\n  &:checked {\n    background: ",
        ";\n  }\n  &:checked + ",
        " {\n    background: ",
        ";\n    &::after {\n      display: block;\n      width: 12px;\n      height: 12px;\n      margin: 4px;\n      color: ",
        ";\n    }\n  }\n"
    ]);
    _templateObject3 = function() {
        return data;
    };
    return data;
}


const styles_LabelText = styled_components_browser_cjs["default"].p.withConfig({
    componentId: "sc-e155c1fe-0"
})(simple_radio_button_styles_templateObject(), (props)=>props.isSimple ? "0" : "-200px", (props)=>props.backgroundColor ? props.backgroundColor : src/* theme.palette.white.main */.rS.palette.white.main, (props)=>props.hasLabel ? "1" : "0", (props)=>props.isSimple ? "translate3d(0, -45%, 0)" : "translate3d(0, -50%, 0)");
const styles_SimpleRadioButtonWrapper = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-e155c1fe-1"
})(simple_radio_button_styles_templateObject1(), (props)=>props.hasLabel ? "end" : "center", (props)=>props.backgroundColor ? props.backgroundColor : src/* theme.palette.gray.20 */.rS.palette.gray[20]);
const styles_SimpleRadioButtonLabel = styled_components_browser_cjs["default"].label.withConfig({
    componentId: "sc-e155c1fe-2"
})(styles_templateObject2());
const styles_StyledSimpleRadioButton = styled_components_browser_cjs["default"].input.withConfig({
    componentId: "sc-e155c1fe-3"
})(_templateObject3(), (props)=>props.hasLabel ? "245px" : "56px", styles_SimpleRadioButtonLabel, (props)=>props.disabled ? "" : props.backgroundColor || "", src/* theme.palette.white.main */.rS.palette.white.main, (props)=>props.backgroundColor ? props.backgroundColor : src/* theme.palette.gray.20 */.rS.palette.gray[20], styles_SimpleRadioButtonLabel, (props)=>props.backgroundColor ? props.backgroundColor : src/* theme.palette.gray.20 */.rS.palette.gray[20], src/* theme.palette.white.main */.rS.palette.white.main);

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-component-buttons-virtual-1a577fdc8c/1/packages/component-buttons/src/radio-buttons/simple-radio-button/simple-radio-button.tsx




const SimpleRadioButton = (param)=>{
    let { id , name , disabled , hasLabel , backgroundColor , ...props } = param;
    return /*#__PURE__*/ _jsxs(SimpleRadioButtonWrapper, {
        backgroundColor: disabled ? theme.palette.gray[20] : backgroundColor || "",
        hasLabel: hasLabel,
        children: [
            /*#__PURE__*/ _jsx(StyledSimpleRadioButton, {
                backgroundColor: disabled ? theme.palette.gray[20] : backgroundColor || "",
                disabled: disabled,
                hasLabel: hasLabel,
                id: id || "radio-1",
                name: name || "radio",
                type: "radio",
                value: id || "radio-1"
            }),
            /*#__PURE__*/ _jsx(SimpleRadioButtonLabel, {
                htmlFor: id || "radio-1",
                children: /*#__PURE__*/ _jsx(LabelText, {
                    backgroundColor: disabled ? theme.palette.gray[20] : backgroundColor || "",
                    hasLabel: hasLabel,
                    isSimple: true,
                    children: props.label
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-component-buttons-virtual-1a577fdc8c/1/packages/component-buttons/src/radio-buttons/simple-radio-button/index.ts


;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-component-buttons-virtual-1a577fdc8c/1/packages/component-buttons/src/radio-buttons/index.ts


;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-component-buttons-virtual-1a577fdc8c/1/packages/component-buttons/src/numeric-button/styles.ts
function numeric_button_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function numeric_button_styles_templateObject() {
    const data = numeric_button_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  width: ",
        ";\n  height: ",
        ";\n  align-items: center;\n  justify-content: center;\n  border: ",
        ";\n  transition: all 0.5s;\n\n  &:disabled {\n    border: 1px solid ",
        ";\n    background-color: ",
        ";\n    pointer-events: none;\n    p {\n      color: ",
        ";\n    }\n  }\n\n  ",
        "\n"
    ]);
    numeric_button_styles_templateObject = function() {
        return data;
    };
    return data;
}


const NumericButtonContainer = styled_components_browser_cjs["default"].button.withConfig({
    componentId: "sc-feb82b75-0"
})(numeric_button_styles_templateObject(), (props)=>props.small ? "40px" : "56px", (props)=>props.small ? "40px" : "54px", (props)=>props.buttonColor === "whiteButton" ? "1px solid ".concat(src/* theme.palette.gray.30 */.rS.palette.gray[30]) : "none", src/* theme.palette.gray.30 */.rS.palette.gray[30], src/* theme.palette.white.main */.rS.palette.white.main, src/* theme.palette.gray.30 */.rS.palette.gray[30], (props)=>props.buttonColor ? (0,src/* handleColorType */.AD)(props.buttonColor) : "");

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-component-buttons-virtual-1a577fdc8c/1/packages/component-buttons/src/numeric-button/numeric-button.tsx






const NumericButton = (param)=>{
    let { number , ariaLabel , onClick , disabled =false , small =false , buttonColor ="whiteButton" , customClassName ="icon-button"  } = param;
    const [isHovering, setIsHovering] = (0,react.useState)(false);
    const textColor = (0,react.useMemo)(()=>{
        switch(buttonColor){
            case "blueButton":
                return src/* theme.palette.yellow.main */.rS.palette.yellow.main;
            case "greenButton":
                return src/* theme.palette.white.main */.rS.palette.white.main;
            case "orangeButton":
                return src/* theme.palette.white.main */.rS.palette.white.main;
            case "redButton":
                return isHovering ? src/* theme.palette.white.main */.rS.palette.white.main : src/* theme.palette.triggers.warning.main */.rS.palette.triggers.warning.main;
            case "whiteButton":
                return src/* theme.palette.blue.main */.rS.palette.blue.main;
            case "yellowButton":
                return src/* theme.palette.blue.main */.rS.palette.blue.main;
            default:
                return src/* theme.palette.blue.main */.rS.palette.blue.main;
        }
    }, [
        buttonColor,
        isHovering
    ]);
    const handleMouseOver = (0,react.useCallback)(()=>{
        setIsHovering(true);
    }, []);
    const handleMouseOut = (0,react.useCallback)(()=>{
        setIsHovering(false);
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(NumericButtonContainer, {
        "aria-label": ariaLabel !== null && ariaLabel !== void 0 ? ariaLabel : "",
        buttonColor: buttonColor,
        className: customClassName,
        disabled: disabled,
        role: "button",
        small: small,
        title: ariaLabel,
        onClick: onClick,
        onMouseOut: handleMouseOut,
        onMouseOver: handleMouseOver,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(component_typography_src/* Subtitle */.QE, {
            textColor: textColor,
            children: number
        })
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-component-buttons-virtual-1a577fdc8c/1/packages/component-buttons/src/numeric-button/index.ts


;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-component-buttons-virtual-1a577fdc8c/1/packages/component-buttons/src/index.ts







/***/ }),

/***/ 71464:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ Card; },
  "c": function() { return /* reexport */ TitleCard; }
});

// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(61261);
// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(91987);
// EXTERNAL MODULE: ../../.yarn/__virtual__/styled-components-virtual-29066d9421/0/cache/styled-components-npm-5.3.5-88e3937b59-05a664dfe4.zip/node_modules/styled-components/dist/styled-components.browser.cjs.js
var styled_components_browser_cjs = __webpack_require__(33982);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-lib-styles-virtual-b3f1d479f2/1/packages/lib-styles/src/index.ts + 18 modules
var src = __webpack_require__(52203);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-component-cards-virtual-43376672fa/1/packages/component-cards/src/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    const data = _taggedTemplateLiteral([
        "\n  padding: 24px 32px;\n  background-color: ",
        ";\n  box-shadow: 0px 18px 45px ",
        ";\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _taggedTemplateLiteral([
        "\n  padding-bottom: 16px;\n  border-bottom: 1px solid ",
        ";\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = _taggedTemplateLiteral([
        ""
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}


const CardContainer = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-e666de8d-0"
})(_templateObject(), src/* theme.palette.white.main */.rS.palette.white.main, src/* theme.palette.shadow.main */.rS.palette.shadow.main);
const CardHeadingContainer = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-e666de8d-1"
})(_templateObject1(), src/* theme.palette.gray.20 */.rS.palette.gray[20]);
const CardContentContainer = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-e666de8d-2"
})(_templateObject2());

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-component-cards-virtual-43376672fa/1/packages/component-cards/src/card.tsx



const Card = (param)=>{
    let { children  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CardContainer, {
        className: "card-container",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CardContentContainer, {
            children: children
        })
    });
};

// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-component-typography-virtual-537720fdd1/1/packages/component-typography/src/index.ts + 2 modules
var component_typography_src = __webpack_require__(91371);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-component-cards-virtual-43376672fa/1/packages/component-cards/src/title-card.tsx





const TitleCard = (param)=>{
    let { title , children  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardContainer, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CardHeadingContainer, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(component_typography_src/* PLargeBold */.ej, {
                    textColor: src/* theme.palette.blue.dark */.rS.palette.blue.dark,
                    children: title
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CardContentContainer, {
                children: children
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-component-cards-virtual-43376672fa/1/packages/component-cards/src/index.ts




/***/ }),

/***/ 58879:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "dy": function() { return /* reexport */ Drawer; },
  "i1": function() { return /* reexport */ backdropBlurState; },
  "tp": function() { return /* reexport */ blockDrawerClickOutsideState; },
  "Z$": function() { return /* reexport */ drawerState; },
  "tl": function() { return /* reexport */ drawerStateLoading; }
});

// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(61261);
// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(91987);
// EXTERNAL MODULE: ../../.yarn/__virtual__/usehooks-ts-virtual-e376d4cf26/0/cache/usehooks-ts-npm-2.9.1-14c625587f-36f1e4142c.zip/node_modules/usehooks-ts/dist/esm/index.js + 36 modules
var esm = __webpack_require__(78420);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-component-buttons-virtual-1a577fdc8c/1/packages/component-buttons/src/index.ts + 16 modules
var src = __webpack_require__(80620);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-lib-icons-virtual-412b14e947/1/packages/lib-icons/src/index.ts + 181 modules
var lib_icons_src = __webpack_require__(45628);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-lib-recoil-virtual-ff20ed22cf/1/packages/lib-recoil/src/index.js
var lib_recoil_src = __webpack_require__(27105);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-component-drawer-virtual-d170d66b66/1/packages/component-drawer/src/store/drawer-state.ts

const drawerState = (0,lib_recoil_src/* atom */.cn)({
    key: "drawerState",
    default: false
});
const drawerStateLoading = (0,lib_recoil_src/* atom */.cn)({
    key: "drawerStateLoading",
    default: false
});

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-component-drawer-virtual-d170d66b66/1/packages/component-drawer/src/store/blur-state.ts

const backdropBlurState = (0,lib_recoil_src/* atom */.cn)({
    key: "use-backdrop-blur",
    default: true
});

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-component-drawer-virtual-d170d66b66/1/packages/component-drawer/src/store/block-drawer-click-outside.ts

const blockDrawerClickOutsideState = (0,lib_recoil_src/* atom */.cn)({
    key: "block-drawer-click-outside-state",
    default: false
});

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-component-drawer-virtual-d170d66b66/1/packages/component-drawer/src/store/index.ts




// EXTERNAL MODULE: ../../.yarn/__virtual__/styled-components-virtual-29066d9421/0/cache/styled-components-npm-5.3.5-88e3937b59-05a664dfe4.zip/node_modules/styled-components/dist/styled-components.browser.cjs.js
var styled_components_browser_cjs = __webpack_require__(33982);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-lib-styles-virtual-b3f1d479f2/1/packages/lib-styles/src/index.ts + 18 modules
var lib_styles_src = __webpack_require__(52203);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-component-drawer-virtual-d170d66b66/1/packages/component-drawer/src/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    const data = _taggedTemplateLiteral([
        "\n  position: fixed;\n  z-index: 19;\n  backdrop-filter: ",
        ";\n  inset: 0;\n  pointer-events: ",
        ";\n  transition: 200ms;\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _taggedTemplateLiteral([
        "\n  position: fixed;\n  z-index: 3001;\n  right: 0;\n  bottom: 0;\n  width: 100vw;\n  max-width: 496px;\n  height: calc(100% - 88px);\n  padding: 24px 48px;\n  background-color: ",
        ";\n  box-shadow: ",
        ";\n  overflow-y: auto;\n  transform: translate3d(",
        ", 0, 0);\n  transition: ",
        ";\n  transition-delay: ",
        ";\n  transition-timing-function: ease-in;\n  @media screen and (max-width: ",
        "px) {\n    height: calc(100% - 56px);\n  }\n  @media screen and (max-width: ",
        "px) {\n    max-width: 100%;\n  }\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = _taggedTemplateLiteral([
        "\n  position: relative;\n  z-index: 3;\n  height: 100%;\n  transition: 300ms;\n  @media screen and (max-width: ",
        "px) {\n    position: absolute;\n    right: 0;\n    bottom: 0;\n    width: 100%;\n    padding-top: 0px;\n    margin: 0 auto;\n    transition: 300ms;\n    transition-delay: 0ms;\n  }\n"
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = _taggedTemplateLiteral([
        "\n  position: absolute;\n  right: 40px;\n  display: flex;\n  width: 100%;\n  height: 100px;\n  justify-content: flex-end;\n  padding-top: 12px;\n"
    ]);
    _templateObject3 = function() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = _taggedTemplateLiteral([
        "\n  display: flex;\n  height: 100%;\n  flex-direction: column;\n  justify-content: center;\n  padding-top: 20px;\n  ::-webkit-scrollbar {\n    display: none;\n  }\n  ::-webkit-scrollbar-thumb {\n    display: none;\n  }\n  @media screen and (max-width: ",
        "px) {\n    width: 100%;\n    max-width: 400px;\n    box-sizing: border-box;\n    padding-right: 16px;\n    padding-left: 16px;\n    margin: 0 auto;\n  }\n"
    ]);
    _templateObject4 = function() {
        return data;
    };
    return data;
}


const Overlay = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-2afe3353-0"
})(_templateObject(), (props)=>props.active ? "blur(4px) grayscale(0.4)" : "blur(0) grayscale(0)", (props)=>props.active ? "initial" : "none");
const DrawerContainer = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-2afe3353-1"
})(_templateObject1(), lib_styles_src/* theme.palette.white.main */.rS.palette.white.main, lib_styles_src/* theme.palette.boxShadow.input */.rS.palette.boxShadow.input, (props)=>props.open ? "0" : "100%", (props)=>props.open ? "300ms" : "150ms", (props)=>props.open ? "0" : "100ms", lib_styles_src/* gridTheme.breakpoints.sm */.k.breakpoints.sm, lib_styles_src/* gridTheme.container.maxWidth.s */.k.container.maxWidth.s);
const MainContent = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-2afe3353-2"
})(_templateObject2(), lib_styles_src/* gridTheme.container.maxWidth.s */.k.container.maxWidth.s);
const CloseButton = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-2afe3353-3"
})(_templateObject3());
const ChildrenContent = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-2afe3353-4"
})(_templateObject4(), lib_styles_src/* gridTheme.container.maxWidth.s */.k.container.maxWidth.s);

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-component-drawer-virtual-d170d66b66/1/packages/component-drawer/src/drawer.tsx








const Drawer = (param)=>{
    let { children , noCloseButton =false  } = param;
    const drawerRef = (0,react.useRef)(null);
    const [open, setOpen] = (0,lib_recoil_src/* useRecoilState */.FV)(drawerState);
    const blockClosing = (0,lib_recoil_src/* useRecoilValue */.sJ)(blockDrawerClickOutsideState);
    const showBackdrop = (0,lib_recoil_src/* useRecoilValue */.sJ)(backdropBlurState);
    (0,react.useEffect)(()=>{
        document.body.classList.toggle("no-scroll", open);
    }, [
        open
    ]);
    const toggleOpen = (0,react.useCallback)(()=>{
        setOpen(true);
    }, [
        setOpen
    ]);
    const handleClose = (0,react.useCallback)(()=>{
        if (blockClosing) {
            return;
        }
        setOpen(false);
    }, [
        blockClosing,
        setOpen
    ]);
    (0,esm/* useOnClickOutside */.t$)(drawerRef, handleClose);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            showBackdrop && /*#__PURE__*/ (0,jsx_runtime.jsx)(Overlay, {
                active: open || blockClosing
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DrawerContainer, {
                ref: drawerRef,
                open: open || blockClosing,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(MainContent, {
                    children: [
                        !noCloseButton && /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseButton, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* IconButton */.hU, {
                                ariaLabel: "Loka",
                                icon: lib_icons_src.CancelLargeIcons,
                                small: true,
                                onClick: toggleOpen
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ChildrenContent, {
                            children: children
                        })
                    ]
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-component-drawer-virtual-d170d66b66/1/packages/component-drawer/src/index.ts




/***/ }),

/***/ 1756:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "t": function() { return /* reexport */ IconStep; }
});

// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(61261);
// EXTERNAL MODULE: ../../.yarn/__virtual__/next-virtual-cff1f1d108/0/cache/next-npm-13.0.0-0d765f7d5e-7b5c847287.zip/node_modules/next/link.js
var next_link = __webpack_require__(58804);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(91987);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-lib-styles-virtual-b3f1d479f2/1/packages/lib-styles/src/index.ts + 18 modules
var src = __webpack_require__(52203);
// EXTERNAL MODULE: ../../.yarn/__virtual__/styled-components-virtual-29066d9421/0/cache/styled-components-npm-5.3.5-88e3937b59-05a664dfe4.zip/node_modules/styled-components/dist/styled-components.browser.cjs.js
var styled_components_browser_cjs = __webpack_require__(33982);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-component-typography-virtual-537720fdd1/1/packages/component-typography/src/index.ts + 2 modules
var component_typography_src = __webpack_require__(91371);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-component-icon-steps-virtual-215cd64f26/1/packages/component-icon-steps/src/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    const data = _taggedTemplateLiteral([
        "\n  display: flex;\n  width: 100%;\n  max-height: 200px;\n  align-items: center;\n  gap: 20px;\n  button {\n    width: 100%;\n    max-width: 120px;\n  }\n  @media screen and (max-width: ",
        "px) {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 20px;\n  }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _taggedTemplateLiteral([
        "\n  display: flex;\n  width: 100%;\n  max-width: 600px;\n  max-height: 160px;\n  align-items: center;\n  justify-content: space-between;\n  margin: 0 auto;\n\n  @media screen and (max-width: ",
        "px) {\n    height: 100px;\n    padding-left: 30px;\n    margin: unset;\n    margin-bottom: 40px;\n  }\n  @media screen and (max-width: ",
        "px) {\n    padding-left: 10px;\n    margin-bottom: 10px;\n  }\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = _taggedTemplateLiteral([
        "\n  z-index: 2;\n  display: flex;\n  width: 100%;\n  max-width: ",
        ";\n  height: 100%;\n  max-height: ",
        ";\n  align-items: center;\n  justify-content: center;\n  border-radius: ",
        ";\n  margin-top: 20px;\n  margin-bottom: 20px;\n  background-color: ",
        ";\n  transition: all 0.5s ease-in-out;\n  white-space: nowrap;\n  svg {\n    position: absolute;\n  }\n  p {\n    width: 100%;\n  }\n  @media screen and (max-width: ",
        "px) {\n    max-width: ",
        ";\n    max-height: ",
        ";\n    margin-bottom: 32px;\n    svg {\n      width: 18px;\n      visibility: ",
        ";\n    }\n  }\n"
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = _taggedTemplateLiteral([
        "\n  display: flex;\n  width: 100%;\n  justify-content: center;\n  margin-top: 100px;\n  color: ",
        ";\n  font-size: ",
        ";\n  transition: color 0.5s ease-in-out;\n  @media screen and (max-width: ",
        "px) {\n    font-size: 14px;\n    visibility: ",
        ";\n  }\n"
    ]);
    _templateObject3 = function() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = _taggedTemplateLiteral([
        "\n  z-index: 1;\n  display: flex;\n  width: 100%;\n  height: 4px;\n  margin-right: -2px;\n  margin-left: -2px;\n  background-color: ",
        ";\n  transition: all 0.5s ease-in-out;\n  @media screen and (max-width: ",
        "px) {\n    margin-bottom: 10px;\n  }\n"
    ]);
    _templateObject4 = function() {
        return data;
    };
    return data;
}



const StepContainer = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-a7dea9bc-0"
})(_templateObject(), src/* gridTheme.container.maxWidth.sm */.k.container.maxWidth.sm);
const StepWrapper = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-a7dea9bc-1"
})(_templateObject1(), src/* gridTheme.container.maxWidth.sm */.k.container.maxWidth.sm, src/* gridTheme.container.maxWidth.s */.k.container.maxWidth.s);
const Step = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-a7dea9bc-2"
})(_templateObject2(), (props)=>props.currentstep ? "64px" : "48px", (props)=>props.currentstep ? "64px" : "48px", (props)=>props.square ? "0" : "50%", (props)=>props.isfulfilled ? src/* theme.palette.blue.main */.rS.palette.blue.main : src/* theme.palette.gray.10 */.rS.palette.gray[10], src/* gridTheme.container.maxWidth.s */.k.container.maxWidth.s, (props)=>props.currentstep ? "40px" : "32px", (props)=>props.currentstep ? "40px" : "32px", (props)=>props.currentstep ? "visible" : "hidden");
const Label = (0,styled_components_browser_cjs["default"])(component_typography_src/* Subtitle */.QE).withConfig({
    componentId: "sc-a7dea9bc-3"
})(_templateObject3(), (props)=>props.isfulfilled ? src/* theme.palette.blue.main */.rS.palette.blue.main : src/* theme.palette.gray.10 */.rS.palette.gray[10], (props)=>props.currentstep ? "20px" : "16px", src/* gridTheme.container.maxWidth.s */.k.container.maxWidth.s, (props)=>props.currentstep ? "visible" : "hidden");
const Connector = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-a7dea9bc-4"
})(_templateObject4(), (props)=>props.isfulfilled ? src/* theme.palette.blue.main */.rS.palette.blue.main : src/* theme.palette.gray.10 */.rS.palette.gray[10], src/* gridTheme.container.maxWidth.s */.k.container.maxWidth.s);

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-component-icon-steps-virtual-215cd64f26/1/packages/component-icon-steps/src/icon-step.tsx





const IconStep = (param)=>{
    let { isfulfilled =false , label , icon: Icon , noConnectorLine =false , currentstep =false , url , square =false  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            !noConnectorLine ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Connector, {
                isfulfilled: isfulfilled ? "fulfilled" : undefined
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Step, {
                as: !!url && isfulfilled && !currentstep ? (link_default()) : "div",
                currentstep: currentstep ? "currentstep" : undefined,
                href: !!url && isfulfilled && !currentstep ? url : undefined,
                isfulfilled: isfulfilled ? "fulfilled" : undefined,
                square: square ? "square" : undefined,
                children: [
                    Icon && /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon, {
                        iconColor: src/* theme.palette.white.main */.rS.palette.white.main,
                        size: 24
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Label, {
                        currentstep: currentstep ? "currentstep" : undefined,
                        isfulfilled: isfulfilled ? "fulfilled" : undefined,
                        children: label
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-component-icon-steps-virtual-215cd64f26/1/packages/component-icon-steps/src/index.ts



/***/ }),

/***/ 45535:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "jc": function() { return /* reexport */ FormikInput; },
  "II": function() { return /* reexport */ Input; },
  "Mj": function() { return /* reexport */ SearchInput; },
  "yp": function() { return /* reexport */ showFormikError; }
});

// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(61261);
// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(91987);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-lib-styles-virtual-b3f1d479f2/1/packages/lib-styles/src/index.ts + 18 modules
var src = __webpack_require__(52203);
// EXTERNAL MODULE: ../../.yarn/__virtual__/styled-components-virtual-29066d9421/0/cache/styled-components-npm-5.3.5-88e3937b59-05a664dfe4.zip/node_modules/styled-components/dist/styled-components.browser.cjs.js
var styled_components_browser_cjs = __webpack_require__(33982);
// EXTERNAL MODULE: ../../.yarn/cache/styled-tools-npm-1.7.2-97a33384f1-00cc179608.zip/node_modules/styled-tools/dist/es/index.js + 3 modules
var es = __webpack_require__(25711);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-component-inputs-virtual-052bad3006/1/packages/component-inputs/src/input/input-sleave/input-sleave-styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    const data = _taggedTemplateLiteral([
        "\n  min-height: 19px;\n  margin-bottom: 16px;\n  color: ",
        ";\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _taggedTemplateLiteral([
        "\n  position: absolute;\n  z-index: 1;\n  top: 0;\n  right: 24px;\n  display: flex;\n  height: 100%;\n  align-items: center;\n  justify-content: center;\n  transition: transform 0.15s ease-out;\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = _taggedTemplateLiteral([
        "\n  position: absolute;\n  z-index: 1;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  display: flex;\n  width: 0;\n  height: 2px;\n  margin: 0 auto;\n  background-color: ",
        ";\n  transition: width 0.15s ease-out;\n"
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = _taggedTemplateLiteral([
        "\n  position: absolute;\n  top: 20px;\n  left: 24px;\n  color: ",
        ";\n  font-size: 1rem;\n  font-weight: 400;\n  line-height: 1;\n  pointer-events: none;\n  transform-origin: 0 50%;\n  transition: transform 0.15s ease-out, color 0.15s;\n"
    ]);
    _templateObject3 = function() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = _taggedTemplateLiteral([
        "\n  position: relative;\n  width: 100%;\n  max-width: ",
        ";\n  height: 56px;\n  .byko-icon {\n    stroke: ",
        ";\n    transition: transform 0.15s ease-out, fill 0.15s;\n  }\n  input {\n    &:focus {\n      outline: none;\n      & ~ ",
        " {\n        .byko-icon {\n          stroke: ",
        ";\n          transition: transform 0.15s ease-out, fill 0.15s;\n        }\n      }\n      & ~ ",
        " {\n        color: ",
        ";\n        font-weight: normal;\n        transform: scale(0.75) translateY(-18px);\n      }\n\n      & ~ ",
        " {\n        width: calc(100% - 2px);\n      }\n    }\n\n    &:not(:placeholder-shown) {\n      & ~ ",
        " {\n        color: ",
        ";\n        font-weight: normal;\n        transform: scale(0.75) translateY(-18px);\n      }\n    }\n\n    &::placeholder {\n      opacity: 0;\n    }\n  }\n  @media screen and (max-width: ",
        "px) {\n    max-width: ",
        ";\n  }\n"
    ]);
    _templateObject4 = function() {
        return data;
    };
    return data;
}
function _templateObject5() {
    const data = _taggedTemplateLiteral([
        "\n  padding-bottom: 8px;\n"
    ]);
    _templateObject5 = function() {
        return data;
    };
    return data;
}
function _templateObject6() {
    const data = _taggedTemplateLiteral([
        "\n  display: flex;\n  width: 100%;\n  max-width: ",
        ";\n  flex-direction: column;\n"
    ]);
    _templateObject6 = function() {
        return data;
    };
    return data;
}
function _templateObject7() {
    const data = _taggedTemplateLiteral([
        "\n  position: absolute;\n  padding-left: 24px;\n  margin-top: ",
        ";\n  margin-bottom: 20px;\n  color: ",
        ";\n  font-size: 14px;\n  line-height: 170%;\n  text-transform: uppercase;\n"
    ]);
    _templateObject7 = function() {
        return data;
    };
    return data;
}



const InputLabel = styled_components_browser_cjs["default"].label.withConfig({
    componentId: "sc-f7e8e6b2-0"
})(_templateObject(), src/* theme.palette.blue.dark */.rS.palette.blue.dark);
const PrefixIcon = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-f7e8e6b2-1"
})(_templateObject1());
const FocusLine = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-f7e8e6b2-2"
})(_templateObject2(), (0,es/* ifProp */.fq)({
    error: true
}, "".concat(src/* theme.palette.triggers.warning.main */.rS.palette.triggers.warning.main), "".concat(src/* theme.palette.blue.main */.rS.palette.blue.main)));
const Placeholder = styled_components_browser_cjs["default"].span.withConfig({
    componentId: "sc-f7e8e6b2-3"
})(_templateObject3(), (0,es/* ifProp */.fq)({
    error: true
}, "".concat(src/* theme.palette.triggers.warning.main */.rS.palette.triggers.warning.main), "".concat(src/* theme.palette.gray.60 */.rS.palette.gray[60])));
const InputContainer = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-f7e8e6b2-4"
})(_templateObject4(), (0,es/* ifProp */.fq)({
    stretch: true
}, "100%", "320px"), src/* theme.palette.gray.60 */.rS.palette.gray[60], PrefixIcon, (0,es/* ifProp */.fq)({
    error: true
}, "".concat(src/* theme.palette.triggers.warning.main */.rS.palette.triggers.warning.main), "".concat(src/* theme.palette.blue.main */.rS.palette.blue.main)), Placeholder, src/* theme.palette.gray.40 */.rS.palette.gray[40], FocusLine, Placeholder, src/* theme.palette.gray.40 */.rS.palette.gray[40], src/* gridTheme.breakpoints.s */.k.breakpoints.s, (0,es/* ifProp */.fq)({
    stretch: true
}, "100%", "260px"));
const InputWrapper = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-f7e8e6b2-5"
})(_templateObject5());
const InputOuterWrapper = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-f7e8e6b2-6"
})(_templateObject6(), (0,es/* ifProp */.fq)({
    stretch: true
}, "100%", "320px"));
const ErrorText = styled_components_browser_cjs["default"].p.withConfig({
    componentId: "sc-f7e8e6b2-7"
})(_templateObject7(), (0,es/* ifProp */.fq)({
    errorTextAboveInput: true
}, "-30px", "64px"), src/* theme.palette.triggers.warning.main */.rS.palette.triggers.warning.main);

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-component-inputs-virtual-052bad3006/1/packages/component-inputs/src/input/input-sleave/input-sleave.tsx




const InputSleave = (param)=>{
    let { icon: Icon , placeholder , children , errorText , error =false , stretch =false , errorTextAboveInput =false , iconColor =src/* theme.palette.blue.main */.rS.palette.blue.main , label , customClassName ="input-sleve"  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(InputOuterWrapper, {
        className: customClassName,
        stretch: stretch,
        children: [
            label && /*#__PURE__*/ (0,jsx_runtime.jsx)(InputLabel, {
                htmlFor: label,
                children: label
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(InputWrapper, {
                className: "input-wrapper",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(InputContainer, {
                    className: "input-container",
                    error: error,
                    stretch: stretch,
                    children: [
                        children,
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Placeholder, {
                            error: error,
                            children: placeholder
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(FocusLine, {
                            error: error
                        }),
                        Boolean(Icon) && /*#__PURE__*/ (0,jsx_runtime.jsx)(PrefixIcon, {
                            children: Icon && /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon, {
                                iconColor: error ? src/* theme.palette.triggers.warning.main */.rS.palette.triggers.warning.main : iconColor,
                                size: 22
                            })
                        })
                    ]
                })
            }),
            Boolean(errorText) && /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorText, {
                className: "input-error-text",
                errorTextAboveInput: errorTextAboveInput,
                children: errorText || "Villa"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-component-inputs-virtual-052bad3006/1/packages/component-inputs/src/input/input-sleave/index.ts


;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-component-inputs-virtual-052bad3006/1/packages/component-inputs/src/input/styles.ts
function styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function styles_templateObject() {
    const data = styles_taggedTemplateLiteral([
        "\n  box-sizing: border-box;\n  background-color: ",
        ";\n  caret-color: ",
        ";\n  font-size: 16px;\n  &:hover {\n    box-shadow: ",
        ";\n  }\n  &:first-letter {\n    text-transform: capitalize;\n  }\n  &:focus {\n    border: none;\n  }\n  &:disabled {\n    background-color: ",
        ";\n    color: ",
        ";\n    opacity: 0.5;\n    &:hover {\n      box-shadow: none;\n    }\n  }\n"
    ]);
    styles_templateObject = function() {
        return data;
    };
    return data;
}
function styles_templateObject1() {
    const data = styles_taggedTemplateLiteral([
        "\n  width: 100%;\n  height: 56px;\n  padding: 14px 24px 0px 24px;\n  border: 1px solid ",
        ";\n  color: ",
        ";\n  letter-spacing: 0.5px;\n  ",
        "\n"
    ]);
    styles_templateObject1 = function() {
        return data;
    };
    return data;
}
function styles_templateObject2() {
    const data = styles_taggedTemplateLiteral([
        "\n  position: relative;\n  width: 100%;\n  height: 100%;\n  min-height: 150px;\n  padding: 24px;\n  border: 1px solid ",
        ";\n  color: ",
        ";\n  resize: none;\n  &:focus {\n    outline: none;\n    & ~ ",
        " {\n      color: ",
        ";\n      font-weight: normal;\n      transform: scale(0.75) translateY(-18px);\n    }\n  }\n\n  &:not(:placeholder-shown) {\n    & ~ ",
        " {\n      color: ",
        ";\n      font-weight: normal;\n      transform: scale(0.75) translateY(-18px);\n    }\n  }\n\n  &::placeholder {\n    opacity: 0;\n  }\n\n  ",
        "\n"
    ]);
    styles_templateObject2 = function() {
        return data;
    };
    return data;
}




const InputCss = (0,styled_components_browser_cjs.css)(styles_templateObject(), src/* theme.palette.white.main */.rS.palette.white.main, src/* theme.palette.yellow.main */.rS.palette.yellow.main, src/* theme.palette.boxShadow.input */.rS.palette.boxShadow.input, src/* theme.palette.gray.10 */.rS.palette.gray[10], src/* theme.palette.gray.50 */.rS.palette.gray[50]);
const InputField = styled_components_browser_cjs["default"].input.withConfig({
    componentId: "sc-492dfd53-0"
})(styles_templateObject1(), (0,es/* ifProp */.fq)({
    error: true
}, "".concat(src/* theme.palette.triggers.warning.main */.rS.palette.triggers.warning.main), (p)=>p.borderColor), (0,es/* ifProp */.fq)({
    error: true
}, "".concat(src/* theme.palette.triggers.warning.main */.rS.palette.triggers.warning.main), "".concat(src/* theme.palette.blue.main */.rS.palette.blue.main)), InputCss);
const TextAreaField = styled_components_browser_cjs["default"].textarea.withConfig({
    componentId: "sc-492dfd53-1"
})(styles_templateObject2(), (0,es/* ifProp */.fq)({
    error: true
}, "".concat(src/* theme.palette.triggers.warning.main */.rS.palette.triggers.warning.main), (p)=>p.borderColor), (0,es/* ifProp */.fq)({
    error: true
}, "".concat(src/* theme.palette.triggers.warning.main */.rS.palette.triggers.warning.main), "".concat(src/* theme.palette.blue.main */.rS.palette.blue.main)), Placeholder, src/* theme.palette.gray.40 */.rS.palette.gray[40], Placeholder, src/* theme.palette.gray.40 */.rS.palette.gray[40], InputCss);

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-component-inputs-virtual-052bad3006/1/packages/component-inputs/src/input/input.tsx





const Input = (param)=>{
    let { icon: Icon , placeholder , error , errorTextAboveInput , errorText , stretch , forwardRef , autoComplete , label , fieldName , type , borderColor =src/* theme.palette.gray.10 */.rS.palette.gray[10] , iconColor =src/* theme.palette.blue.main */.rS.palette.blue.main , customClassName , ...props } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InputSleave, {
            customClassName: customClassName,
            error: error,
            errorText: errorText || undefined,
            errorTextAboveInput: !!errorTextAboveInput,
            icon: Icon,
            iconColor: iconColor,
            label: label,
            placeholder: placeholder,
            stretch: !!stretch,
            children: type === "textarea" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TextAreaField, {
                    autoCapitalize: "sentences",
                    borderColor: borderColor,
                    error: error,
                    placeholder: placeholder,
                    ...props
                })
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(InputField, {
                ref: forwardRef,
                autoComplete: autoComplete !== null && autoComplete !== void 0 ? autoComplete : "off",
                borderColor: borderColor,
                error: error,
                id: label,
                name: fieldName,
                placeholder: placeholder,
                ...props
            })
        })
    });
};

// EXTERNAL MODULE: ../../packages/lib-formik/src/index.ts
var lib_formik_src = __webpack_require__(8462);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-component-inputs-virtual-052bad3006/1/packages/component-inputs/src/input/formik-input.tsx




const FormikInput = (props)=>{
    // useField() returns [formik.getFieldProps(), formik.getFieldMeta()]
    // which we can spread on <input> and alse replace ErrorMessage entirely.
    const [field, meta] = (0,lib_formik_src/* useField */.U$)(props);
    const errorText = Boolean(meta.touched) && meta.error || false;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Input, {
        ...field,
        ...props,
        errorText: errorText
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-component-inputs-virtual-052bad3006/1/packages/component-inputs/src/input/index.ts



// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-lib-icons-virtual-412b14e947/1/packages/lib-icons/src/index.ts + 181 modules
var lib_icons_src = __webpack_require__(45628);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-component-inputs-virtual-052bad3006/1/packages/component-inputs/src/search-input/styles.ts
function search_input_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function search_input_styles_templateObject() {
    const data = search_input_styles_taggedTemplateLiteral([
        "\n  position: absolute;\n  display: flex;\n  width: 100%;\n  height: 56px;\n  padding-top: 16px;\n  padding-left: 16px;\n  border: none;\n  border: ",
        ";\n  background-color: ",
        ";\n  caret-color: ",
        ";\n  color: ",
        ";\n  font-size: 16px;\n  &:disabled {\n    opacity: 0.5;\n  }\n  &:focus {\n    border: none;\n  }\n  &:hover {\n    box-shadow: ",
        ";\n  }\n"
    ]);
    search_input_styles_templateObject = function() {
        return data;
    };
    return data;
}
function search_input_styles_templateObject1() {
    const data = search_input_styles_taggedTemplateLiteral([
        "\n  z-index: 1;\n  padding-right: 8px;\n  margin-bottom: -5px;\n  margin-left: auto;\n  transition: transform 0.15s ease-out;\n  button {\n    padding: 12px 12px 4px 12px;\n    margin-bottom: 6px;\n    transition: 300ms;\n  }\n"
    ]);
    search_input_styles_templateObject1 = function() {
        return data;
    };
    return data;
}
function search_input_styles_templateObject2() {
    const data = search_input_styles_taggedTemplateLiteral([
        ""
    ]);
    search_input_styles_templateObject2 = function() {
        return data;
    };
    return data;
}
function styles_templateObject3() {
    const data = search_input_styles_taggedTemplateLiteral([
        "\n  position: absolute;\n  z-index: 1;\n  bottom: 0;\n  left: 0;\n  display: block;\n  width: 0;\n  height: 1px;\n  background-color: ",
        ";\n  transition: width 0.15s ease-out;\n"
    ]);
    styles_templateObject3 = function() {
        return data;
    };
    return data;
}
function styles_templateObject4() {
    const data = search_input_styles_taggedTemplateLiteral([
        "\n  position: absolute;\n  left: 16px;\n  color: ",
        ";\n  font-size: 1rem;\n  font-weight: 400;\n  pointer-events: none;\n  pointer-events: none;\n  transform-origin: 0 50%;\n  transition: transform 0.15s ease-out, color 0.15s;\n  user-select: none;\n"
    ]);
    styles_templateObject4 = function() {
        return data;
    };
    return data;
}
function styles_templateObject5() {
    const data = search_input_styles_taggedTemplateLiteral([
        "\n  position: relative;\n  display: flex;\n  width: 100%;\n  height: 56px;\n  align-items: center;\n\n  .byko-icon {\n    stroke: ",
        ";\n    transition: transform 0.15s ease-out, fill 0.15s;\n  }\n  input {\n    &:focus {\n      outline: none;\n      & ~ ",
        " {\n        .byko-icon {\n          stroke: ",
        ";\n          transition: transform 0.15s ease-out, fill 0.15s;\n        }\n      }\n      & ~ ",
        " {\n        color: ",
        ";\n        font-weight: normal;\n        transform: scale(0.75) translateY(-18px);\n      }\n\n      & ~ ",
        " {\n        width: 100%;\n      }\n    }\n\n    &:not(:placeholder-shown) {\n      & ~ ",
        " {\n        color: ",
        ";\n        font-weight: normal;\n        transform: scale(0.75) translateY(-18px);\n      }\n    }\n\n    &::placeholder {\n      opacity: 0;\n    }\n  }\n"
    ]);
    styles_templateObject5 = function() {
        return data;
    };
    return data;
}


const SearchInputField = styled_components_browser_cjs["default"].input.withConfig({
    componentId: "sc-9a3713df-0"
})(search_input_styles_templateObject(), (p)=>p.border ? "1px solid ".concat(src/* theme.palette.gray.10 */.rS.palette.gray[10]) : "none", src/* theme.palette.white.main */.rS.palette.white.main, src/* theme.palette.blue.dark */.rS.palette.blue.dark, src/* theme.palette.blue.main */.rS.palette.blue.main, src/* theme.palette.boxShadow.input */.rS.palette.boxShadow.input);
const styles_PrefixIcon = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-9a3713df-1"
})(search_input_styles_templateObject1());
const ClearBtn = (0,styled_components_browser_cjs["default"])(styles_PrefixIcon).withConfig({
    componentId: "sc-9a3713df-2"
})(search_input_styles_templateObject2());
const styles_FocusLine = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-9a3713df-3"
})(styles_templateObject3(), src/* theme.palette.blue.main */.rS.palette.blue.main);
const styles_Placeholder = styled_components_browser_cjs["default"].span.withConfig({
    componentId: "sc-9a3713df-4"
})(styles_templateObject4(), src/* theme.palette.gray.60 */.rS.palette.gray[60]);
const styles_InputContainer = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-9a3713df-5"
})(styles_templateObject5(), src/* theme.palette.gray.40 */.rS.palette.gray[40], styles_PrefixIcon, src/* theme.palette.blue.main */.rS.palette.blue.main, styles_Placeholder, src/* theme.palette.gray.40 */.rS.palette.gray[40], styles_FocusLine, styles_Placeholder, src/* theme.palette.gray.40 */.rS.palette.gray[40]);

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-component-inputs-virtual-052bad3006/1/packages/component-inputs/src/search-input/search-input.tsx





const SearchInput = (param)=>{
    let { placeholder , onClick , isDirty , noIcon =false , iconColor , border =false , onIconClick , ...props } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles_InputContainer, {
        className: "search-input-container",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchInputField, {
                border: border,
                className: "search-input",
                placeholder: placeholder,
                ...props,
                "aria-label": "leit",
                type: "text"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_Placeholder, {
                children: placeholder ? placeholder : "Hva\xf0 viltu finna?"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_FocusLine, {}),
            isDirty ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ClearBtn, {
                onClick: onClick,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_PrefixIcon, {
                    children: !noIcon && /*#__PURE__*/ (0,jsx_runtime.jsx)(lib_icons_src.CancelSmallIcons, {
                        size: 22
                    })
                })
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles_PrefixIcon, {
                children: [
                    !noIcon && onIconClick && /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        type: "button",
                        onClick: onIconClick,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lib_icons_src.SearchIcons, {
                            iconColor: iconColor || src/* theme.palette.blue.main */.rS.palette.blue.main,
                            size: 24
                        })
                    }),
                    !noIcon && !onIconClick && /*#__PURE__*/ (0,jsx_runtime.jsx)(lib_icons_src.SearchIcons, {
                        iconColor: iconColor || src/* theme.palette.blue.main */.rS.palette.blue.main,
                        size: 24
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-component-inputs-virtual-052bad3006/1/packages/component-inputs/src/search-input/index.ts


;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-component-inputs-virtual-052bad3006/1/packages/component-inputs/src/show-formik-error.ts
const showFormikError = (formik, field)=>{
    const touched = formik.touched[field];
    const error = formik.errors[field];
    return Boolean(touched && error);
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-component-inputs-virtual-052bad3006/1/packages/component-inputs/src/index.ts





/***/ }),

/***/ 96360:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "DotLoader": function() { return /* reexport */ DotLoader; },
  "LargeMainLoader": function() { return /* reexport */ LargeMainLoader; },
  "MainLoader": function() { return /* reexport */ MainLoader; },
  "preloadLoader": function() { return /* reexport */ preloadLoader; }
});

// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(61261);
// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(91987);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-component-loaders-virtual-61e12a86f6/1/packages/component-loaders/src/loaders/utils.ts

const getAssets = async ()=>{
    if (false) {}
    const assets = await __webpack_require__.e(/* import() */ 3721).then(__webpack_require__.t.bind(__webpack_require__, 53721, 19));
    return assets;
};
const getLottie = async ()=>{
    if (false) {}
    const assets = (await Promise.all(/* import() */[__webpack_require__.e(5935), __webpack_require__.e(966)]).then(__webpack_require__.t.bind(__webpack_require__, 70966, 23))).default;
    return assets;
};
const useLoadAsset = (fn)=>{
    const [value, setValue] = (0,react.useState)(null);
    (0,react.useEffect)(()=>{
        fn().then(setValue);
    }, [
        fn
    ]);
    return value;
};
const useLottie = ()=>{
    return useLoadAsset(getLottie);
};
const useAssets = ()=>{
    return useLoadAsset(getAssets);
};
const preloadLoader = ()=>{
    if (false) {}
    const fn = ()=>{
        void getLottie();
        void getAssets();
    };
    requestIdleCallback(fn);
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-component-loaders-virtual-61e12a86f6/1/packages/component-loaders/src/loaders/main-loader.tsx




const MainLoader = (param)=>{
    let { size =64  } = param;
    const LOADER_STYLE = (0,react.useMemo)(()=>{
        return {
            width: size,
            height: size
        };
    }, [
        size
    ]);
    const animationData = useAssets();
    const LottieComponent = useLottie();
    if (!animationData || !LottieComponent) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(LottieComponent, {
        animationData: animationData,
        loop: true,
        play: true,
        style: LOADER_STYLE
    });
};

// EXTERNAL MODULE: ../../.yarn/__virtual__/styled-components-virtual-29066d9421/0/cache/styled-components-npm-5.3.5-88e3937b59-05a664dfe4.zip/node_modules/styled-components/dist/styled-components.browser.cjs.js
var styled_components_browser_cjs = __webpack_require__(33982);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-component-loaders-virtual-61e12a86f6/1/packages/component-loaders/src/loaders/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    const data = _taggedTemplateLiteral([
        "\n  display: flex;\n  height: 300px;\n  flex-direction: column;\n  align-items: center;\n  justify-content: space-between;\n  padding: 40px 0;\n  text-align: center;\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}

const LoadingComponentWrapper = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-d1b64589-0"
})(_templateObject());

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-component-loaders-virtual-61e12a86f6/1/packages/component-loaders/src/loaders/large-main-loader.tsx




const LargeMainLoader = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingComponentWrapper, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MainLoader, {
            size: 96
        })
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-component-loaders-virtual-61e12a86f6/1/packages/component-loaders/src/loaders/assets/dot-loader-config.json
var dot_loader_config_namespaceObject = JSON.parse('{"nm":"Dot_Loading","mn":"","layers":[{"ty":4,"nm":"right","mn":"","sr":1,"st":-62,"op":76,"ip":0,"hd":false,"cl":"","ln":"","ddd":0,"bm":0,"tt":0,"hasMask":false,"td":0,"ao":0,"ks":{"a":{"a":0,"k":[12.5,6,0],"ix":1},"s":{"a":0,"k":[764.558,764.558,100],"ix":6},"sk":{"a":0,"k":0},"p":{"a":1,"k":[{"o":{"x":0.6,"y":0},"i":{"x":0.4,"y":1},"s":[144,144,0],"t":5},{"o":{"x":0.6,"y":0},"i":{"x":0.4,"y":1},"s":[144,124,0],"t":17},{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.833},"s":[144,144,0],"t":29}],"ix":2},"sa":{"a":0,"k":0},"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10}},"ef":[],"shapes":[{"ty":"gr","bm":0,"cl":"","ln":"","hd":false,"mn":"ADBE Vector Group","nm":"Groupe 2","ix":1,"cix":2,"np":2,"it":[{"ty":"sh","bm":0,"cl":"","ln":"","hd":false,"mn":"ADBE Vector Shape - Group","nm":"Path 1","ix":1,"d":1,"ks":{"a":0,"k":{"c":true,"i":[[0,-0.828],[0.828,0],[0,0.828],[-0.828,0]],"o":[[0,0.828],[-0.828,0],[0,-0.828],[0.828,0]],"v":[[1.5,0],[0,1.5],[-1.5,0],[0,-1.5]]},"ix":2}},{"ty":"fl","bm":0,"cl":"","ln":"","hd":false,"mn":"ADBE Vector Graphic - Fill","nm":"Fond 1","c":{"a":0,"k":[0.0392,0.2275,0.3608],"ix":4},"r":1,"o":{"a":0,"k":100,"ix":5}},{"ty":"tr","a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"sk":{"a":0,"k":0,"ix":4},"p":{"a":0,"k":[12.333,5.833],"ix":2},"r":{"a":0,"k":0,"ix":6},"sa":{"a":0,"k":0,"ix":5},"o":{"a":0,"k":100,"ix":7}}]}],"ind":0},{"ty":4,"nm":"center","mn":"","sr":1,"st":-62,"op":76,"ip":0,"hd":false,"cl":"","ln":"","ddd":0,"bm":0,"tt":0,"hasMask":false,"td":0,"ao":0,"ks":{"a":{"a":0,"k":[12.5,6,0],"ix":1},"s":{"a":0,"k":[764.558,764.558,100],"ix":6},"sk":{"a":0,"k":0},"p":{"a":1,"k":[{"o":{"x":0.6,"y":0},"i":{"x":0.4,"y":1},"s":[144,144,0],"t":10},{"o":{"x":0.6,"y":0},"i":{"x":0.4,"y":1},"s":[144,124,0],"t":22},{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.833},"s":[144,144,0],"t":34}],"ix":2},"sa":{"a":0,"k":0},"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10}},"ef":[],"shapes":[{"ty":"gr","bm":0,"cl":"","ln":"","hd":false,"mn":"ADBE Vector Group","nm":"Groupe 1","ix":1,"cix":2,"np":2,"it":[{"ty":"sh","bm":0,"cl":"","ln":"","hd":false,"mn":"ADBE Vector Shape - Group","nm":"Path 1","ix":1,"d":1,"ks":{"a":0,"k":{"c":true,"i":[[0,-0.828],[0.828,0],[0,0.828],[-0.828,0]],"o":[[0,0.828],[-0.828,0],[0,-0.828],[0.828,0]],"v":[[1.5,0],[0,1.5],[-1.5,0],[0,-1.5]]},"ix":2}},{"ty":"fl","bm":0,"cl":"","ln":"","hd":false,"mn":"ADBE Vector Graphic - Fill","nm":"Fond 1","c":{"a":0,"k":[0.0392,0.2275,0.3608],"ix":4},"r":1,"o":{"a":0,"k":100,"ix":5}},{"ty":"tr","a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"sk":{"a":0,"k":0,"ix":4},"p":{"a":0,"k":[17.667,5.833],"ix":2},"r":{"a":0,"k":0,"ix":6},"sa":{"a":0,"k":0,"ix":5},"o":{"a":0,"k":100,"ix":7}}]}],"ind":1},{"ty":4,"nm":"left","mn":"","sr":1,"st":-62,"op":76,"ip":0,"hd":false,"cl":"","ln":"","ddd":0,"bm":0,"tt":0,"hasMask":false,"td":0,"ao":0,"ks":{"a":{"a":0,"k":[12.5,6,0],"ix":1},"s":{"a":0,"k":[764.558,764.558,100],"ix":6},"sk":{"a":0,"k":0},"p":{"a":1,"k":[{"o":{"x":0.6,"y":0},"i":{"x":0.4,"y":1},"s":[144,144,0],"t":0},{"o":{"x":0.6,"y":0},"i":{"x":0.4,"y":1},"s":[144,124,0],"t":12},{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.833},"s":[144,144,0],"t":24}],"ix":2},"sa":{"a":0,"k":0},"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10}},"ef":[],"shapes":[{"ty":"gr","bm":0,"cl":"","ln":"","hd":false,"mn":"ADBE Vector Group","nm":"Groupe 3","ix":1,"cix":2,"np":2,"it":[{"ty":"sh","bm":0,"cl":"","ln":"","hd":false,"mn":"ADBE Vector Shape - Group","nm":"Path 1","ix":1,"d":1,"ks":{"a":0,"k":{"c":true,"i":[[0,-0.828],[0.828,0],[0,0.828],[-0.828,0]],"o":[[0,0.828],[-0.828,0],[0,-0.828],[0.828,0]],"v":[[1.5,0],[0,1.5],[-1.5,0],[0,-1.5]]},"ix":2}},{"ty":"fl","bm":0,"cl":"","ln":"","hd":false,"mn":"ADBE Vector Graphic - Fill","nm":"Fond 1","c":{"a":0,"k":[0.0392,0.2275,0.3608],"ix":4},"r":1,"o":{"a":0,"k":100,"ix":5}},{"ty":"tr","a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"sk":{"a":0,"k":0,"ix":4},"p":{"a":0,"k":[7,5.833],"ix":2},"r":{"a":0,"k":0,"ix":6},"sa":{"a":0,"k":0,"ix":5},"o":{"a":0,"k":100,"ix":7}}]}],"ind":2}],"ddd":0,"h":300,"w":300,"meta":{"a":"","k":"","d":"","g":"@lottiefiles/toolkit-js 0.17.4","tc":"#ffffff"},"v":"5.7.3","fr":60,"op":65,"ip":0,"assets":[]}');
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-component-loaders-virtual-61e12a86f6/1/packages/component-loaders/src/loaders/dot-loader.tsx





const DotLoader = (param)=>{
    let { size =64  } = param;
    const LOADER_STYLE = (0,react.useMemo)(()=>{
        return {
            width: size,
            height: size
        };
    }, [
        size
    ]);
    const LottieComponent = useLottie();
    if (!dot_loader_config_namespaceObject || !LottieComponent) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(LottieComponent, {
        animationData: dot_loader_config_namespaceObject,
        loop: true,
        play: true,
        style: LOADER_STYLE
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-component-loaders-virtual-61e12a86f6/1/packages/component-loaders/src/loaders/index.ts





;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-component-loaders-virtual-61e12a86f6/1/packages/component-loaders/src/index.ts



/***/ }),

/***/ 59259:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "nL": function() { return /* reexport */ LoginSteps; },
  "Wm": function() { return /* reexport */ useLoginStateStore; }
});

// UNUSED EXPORTS: loginStateStore, useSetLoginStateStore

// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(61261);
// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(91987);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-component-drawer-virtual-d170d66b66/1/packages/component-drawer/src/index.ts + 6 modules
var src = __webpack_require__(58879);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-component-buttons-virtual-1a577fdc8c/1/packages/component-buttons/src/index.ts + 16 modules
var component_buttons_src = __webpack_require__(80620);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-component-typography-virtual-537720fdd1/1/packages/component-typography/src/index.ts + 2 modules
var component_typography_src = __webpack_require__(91371);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-hooks-auth-next-virtual-a089da2ab7/1/packages/hooks-auth-next/src/index.ts + 14 modules
var hooks_auth_next_src = __webpack_require__(68814);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-hooks-customer-account-membership-virtual-e9df779240/1/packages/hooks-customer-account-membership/src/index.ts + 6 modules
var hooks_customer_account_membership_src = __webpack_require__(22400);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-lib-icons-virtual-412b14e947/1/packages/lib-icons/src/index.ts + 181 modules
var lib_icons_src = __webpack_require__(45628);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-lib-recoil-virtual-ff20ed22cf/1/packages/lib-recoil/src/index.js
var lib_recoil_src = __webpack_require__(27105);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-lib-styles-virtual-b3f1d479f2/1/packages/lib-styles/src/index.ts + 18 modules
var lib_styles_src = __webpack_require__(52203);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-hooks-toasts-virtual-f5251b1d06/1/packages/hooks-toasts/src/index.ts + 5 modules
var hooks_toasts_src = __webpack_require__(66746);
// EXTERNAL MODULE: ../../.yarn/__virtual__/styled-components-virtual-29066d9421/0/cache/styled-components-npm-5.3.5-88e3937b59-05a664dfe4.zip/node_modules/styled-components/dist/styled-components.browser.cjs.js
var styled_components_browser_cjs = __webpack_require__(33982);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-component-handle-invitation-virtual-82ba2b957e/1/packages/component-handle-invitation/src/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    const data = _taggedTemplateLiteral([
        "\n  display: flex;\n  height: 100%;\n  flex-direction: column;\n  justify-content: space-between;\n  margin-top: 40px;\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _taggedTemplateLiteral([
        "\n  display: flex;\n  width: 100%;\n  flex-direction: column;\n  margin-bottom: 24px;\n  gap: 24px;\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = _taggedTemplateLiteral([
        "\n  display: flex;\n  height: 100%;\n  flex-direction: column;\n  justify-content: center;\n"
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}

const InvitationContainer = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-ac3d7d4b-0"
})(_templateObject());
const ButtonWrapper = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-ac3d7d4b-1"
})(_templateObject1());
const TextWrapper = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-ac3d7d4b-2"
})(_templateObject2());

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-component-handle-invitation-virtual-82ba2b957e/1/packages/component-handle-invitation/src/handle-invitation.tsx












const HandleInvitation = (param)=>{
    let { userName  } = param;
    const setOpen = (0,lib_recoil_src/* useSetRecoilState */.Zl)(src/* drawerState */.Z$);
    const { setSuccessMessage  } = (0,hooks_toasts_src/* useToasts */.e)();
    const { user , activeMembership , loading , setActiveMembership  } = (0,hooks_auth_next_src/* useAuth */.aC)();
    const { acceptInvite , fetchInviteDetails , inviteDetails , inviteDetailsLoading  } = (0,hooks_customer_account_membership_src/* useCustomerAccountMembership */.E)();
    const [declineInviteScreen, setDeclineInviteScreen] = (0,react.useState)(false);
    const handleClick = (0,react.useCallback)(()=>{
        setDeclineInviteScreen(!declineInviteScreen);
    }, [
        declineInviteScreen
    ]);
    (0,react.useEffect)(()=>{
        if (user && !loading && activeMembership && !inviteDetails) {
            const token = sessionStorage.getItem("invitationToken");
            if (token) {
                void fetchInviteDetails(token !== null && token !== void 0 ? token : "");
            }
        }
    }, [
        activeMembership,
        fetchInviteDetails,
        inviteDetails,
        loading,
        user
    ]);
    const handleClose = (0,react.useCallback)(()=>{
        setOpen(false);
    }, [
        setOpen
    ]);
    const handleAcceptInvitation = (0,react.useCallback)(async ()=>{
        const token = sessionStorage.getItem("invitationToken");
        await acceptInvite(token !== null && token !== void 0 ? token : "").then((res)=>{
            var ref, ref1;
            sessionStorage.removeItem("invitationToken");
            const membership = res === null || res === void 0 ? void 0 : (ref = res.user) === null || ref === void 0 ? void 0 : (ref1 = ref.memberships) === null || ref1 === void 0 ? void 0 : ref1.find((m)=>{
                return m.account.ssn === (inviteDetails === null || inviteDetails === void 0 ? void 0 : inviteDetails.account.ssn);
            });
            setActiveMembership(membership || null);
            setSuccessMessage("Bo\xf0i fr\xe1 ".concat(membership === null || membership === void 0 ? void 0 : membership.account.name, " hefur veri\xf0 sam\xfeykkt"));
            if (window.location.pathname === "/mitt") {
                window.location.reload();
            } else {
                window.location.replace("/mitt");
            }
        });
    }, [
        inviteDetails,
        acceptInvite,
        setSuccessMessage,
        setActiveMembership
    ]);
    const handleCancelInvitation = (0,react.useCallback)(()=>{
        sessionStorage.removeItem("invitationToken");
        window.location.reload();
    }, []);
    const revertDecline = (0,react.useCallback)(()=>{
        setDeclineInviteScreen(false);
    }, []);
    const message = (0,react.useMemo)(()=>{
        if (declineInviteScreen) {
            // eslint-disable-next-line max-len
            return "\xde\xfa \xe1tt bo\xf0 \xed fyrirt\xe6kjareikning hj\xe1: ".concat(inviteDetails === null || inviteDetails === void 0 ? void 0 : inviteDetails.account.name, ". Vinsamlegast sta\xf0festu a\xf0 \xfe\xfa viljir hafna bo\xf0inu.");
        }
        // eslint-disable-next-line max-len
        return "\xde\xfa \xe1tt bo\xf0 \xed fyrirt\xe6kjareikning hj\xe1: ".concat(inviteDetails === null || inviteDetails === void 0 ? void 0 : inviteDetails.account.name, ". Vinsamlegast sam\xfeykktu/hafna\xf0u \xfeessu bo\xf0i til \xfeess a\xf0 halda \xe1fram.");
    }, [
        declineInviteScreen,
        inviteDetails === null || inviteDetails === void 0 ? void 0 : inviteDetails.account.name
    ]);
    if (inviteDetailsLoading && user === null) {
        return null;
    }
    if (!inviteDetailsLoading && inviteDetails === null) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(InvitationContainer, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(component_typography_src/* PLarge */.cG, {
                    textColor: lib_styles_src/* theme.palette.blue.dark */.rS.palette.blue.dark,
                    children: "\xdea\xf0 er n\xfa \xfeegar b\xfai\xf0 a\xf0 sam\xfeykkja \xfeetta bo\xf0"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(component_buttons_src/* Button */.zx, {
                    buttonColor: "blueButton",
                    icon: lib_icons_src.LongArrowSideIcons,
                    label: "Loka",
                    stretch: true,
                    onClick: handleClose
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(InvitationContainer, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(TextWrapper, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(component_typography_src.H6, {
                        bottom: 8,
                        textColor: lib_styles_src/* theme.palette.blue.main */.rS.palette.blue.main,
                        children: declineInviteScreen ? "Ertu viss um a\xf0 \xfe\xfa viljir hafna bo\xf0inu?" : " H\xe6, ".concat(userName)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(component_typography_src/* PLarge */.cG, {
                        textColor: lib_styles_src/* theme.palette.blue.dark */.rS.palette.blue.dark,
                        children: message
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonWrapper, {
                children: declineInviteScreen ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(component_buttons_src/* Button */.zx, {
                            buttonColor: "redButton",
                            customClassName: "agree-to-decline-button",
                            icon: lib_icons_src.CancelLargeIcons,
                            label: "J\xe1, hafna bo\xf0i",
                            stretch: true,
                            onClick: handleCancelInvitation
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(component_buttons_src/* Button */.zx, {
                            buttonColor: "blueButton",
                            customClassName: "agree-to-decline-button",
                            icon: lib_icons_src.LongArrowLeftIcons,
                            label: "Nei, fara til baka",
                            stretch: true,
                            onClick: revertDecline
                        })
                    ]
                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(component_buttons_src/* Button */.zx, {
                            buttonColor: "redButton",
                            icon: lib_icons_src.CancelLargeIcons,
                            label: "Hafna",
                            stretch: true,
                            onClick: handleClick
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(component_buttons_src/* Button */.zx, {
                            buttonColor: "blueButton",
                            icon: lib_icons_src.CheckmarkIcons,
                            label: "Sam\xfeykkja",
                            stretch: true,
                            onClick: handleAcceptInvitation
                        })
                    ]
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-component-handle-invitation-virtual-82ba2b957e/1/packages/component-handle-invitation/src/index.ts


// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-component-icon-steps-virtual-215cd64f26/1/packages/component-icon-steps/src/index.ts + 2 modules
var component_icon_steps_src = __webpack_require__(1756);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-component-inputs-virtual-052bad3006/1/packages/component-inputs/src/index.ts + 11 modules
var component_inputs_src = __webpack_require__(45535);
// EXTERNAL MODULE: ../../.yarn/cache/styled-tools-npm-1.7.2-97a33384f1-00cc179608.zip/node_modules/styled-tools/dist/es/index.js + 3 modules
var es = __webpack_require__(25711);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-scene-account-picker-virtual-4aa6ab0445/1/packages/scene-account-picker/src/components/picker-search/picker-search-styles.ts
function picker_search_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function picker_search_styles_templateObject() {
    const data = picker_search_styles_taggedTemplateLiteral([
        "\n  position: absolute;\n  width: 100%;\n  max-height: 280px;\n  padding-left: 0;\n  border: 1px solid hsla(218, 100%, 42%, 0.5);\n  border-top-width: 0;\n  margin-top: 0;\n  background-color: ",
        ";\n  list-style: none;\n  overflow-y: auto;\n"
    ]);
    picker_search_styles_templateObject = function() {
        return data;
    };
    return data;
}
function picker_search_styles_templateObject1() {
    const data = picker_search_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  width: 100%;\n  height: 56px;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0 16px;\n  border-top: 1px solid ",
        ";\n  cursor: pointer;\n  font-weight: ",
        ";\n  text-align: left;\n  transition: border-color 0.15s, background-color 0.15s;\n  &:hover {\n    background-color: ",
        ";\n  }\n"
    ]);
    picker_search_styles_templateObject1 = function() {
        return data;
    };
    return data;
}
function picker_search_styles_templateObject2() {
    const data = picker_search_styles_taggedTemplateLiteral([
        "\n  border: 1px solid ",
        ";\n  margin-top: 40px;\n"
    ]);
    picker_search_styles_templateObject2 = function() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = picker_search_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  max-height: 30vh;\n  flex-direction: column;\n  gap: 8px;\n  overflow-y: auto;\n  ",
        "\n\n  button {\n    p {\n      font-weight: normal;\n    }\n    &:hover {\n      border: 1px solid ",
        ";\n      box-shadow: none;\n    }\n  }\n"
    ]);
    _templateObject3 = function() {
        return data;
    };
    return data;
}



const Suggestions = styled_components_browser_cjs["default"].ul.withConfig({
    componentId: "sc-be91703d-0"
})(picker_search_styles_templateObject(), lib_styles_src/* theme.palette.white.main */.rS.palette.white.main);
const Item = styled_components_browser_cjs["default"].li.withConfig({
    componentId: "sc-be91703d-1"
})(picker_search_styles_templateObject1(), lib_styles_src/* theme.palette.gray.10 */.rS.palette.gray[10], (0,es/* ifProp */.fq)({
    selected: true
}, "700", "400"), lib_styles_src/* theme.palette.gray.5 */.rS.palette.gray[5]);
const Border = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-be91703d-2"
})(picker_search_styles_templateObject2(), lib_styles_src/* theme.palette.gray.10 */.rS.palette.gray[10]);
const UserItemWrapper = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-be91703d-3"
})(_templateObject3(), (0,lib_styles_src/* scrollStyle */.vh)({
    color: "dark-blue"
}), lib_styles_src/* theme.palette.gray.20 */.rS.palette.gray[20]);

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-scene-account-picker-virtual-4aa6ab0445/1/packages/scene-account-picker/src/components/picker-search/store/filtered-accounts.ts

const filteredAccountsState = (0,lib_recoil_src/* atom */.cn)({
    key: "filteredAccountsState",
    default: []
});

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-scene-account-picker-virtual-4aa6ab0445/1/packages/scene-account-picker/src/components/picker-search/store/input-value.ts

const inputValueState = (0,lib_recoil_src/* atom */.cn)({
    key: "InputValueState",
    default: ""
});

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-scene-account-picker-virtual-4aa6ab0445/1/packages/scene-account-picker/src/components/picker-search/store/show-suggestions.ts

const showSuggestionsState = (0,lib_recoil_src/* atom */.cn)({
    key: "showSuggestionsState",
    default: false
});

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-scene-account-picker-virtual-4aa6ab0445/1/packages/scene-account-picker/src/components/picker-search/store/index.ts




;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-scene-account-picker-virtual-4aa6ab0445/1/packages/scene-account-picker/src/components/picker-search/suggested-item.tsx









const SuggestedItem = (param)=>{
    let { id , name , ssn  } = param;
    const setOpen = (0,lib_recoil_src/* useSetRecoilState */.Zl)(src/* drawerState */.Z$);
    const setInputValue = (0,lib_recoil_src/* useSetRecoilState */.Zl)(inputValueState);
    const setFilteredAccounts = (0,lib_recoil_src/* useSetRecoilState */.Zl)(filteredAccountsState);
    const setShowSuggestions = (0,lib_recoil_src/* useSetRecoilState */.Zl)(showSuggestionsState);
    const { switchAccount , setRequestSwitchAccount  } = (0,hooks_auth_next_src/* useAuth */.aC)();
    const handleItemClick = (0,react.useCallback)(async ()=>{
        setInputValue(name);
        await switchAccount(id);
        setRequestSwitchAccount(false);
        setFilteredAccounts([]);
        setShowSuggestions(false);
        setOpen(false);
    }, [
        setInputValue,
        name,
        switchAccount,
        id,
        setRequestSwitchAccount,
        setFilteredAccounts,
        setShowSuggestions,
        setOpen
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Item, {
        onClick: handleItemClick,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(component_typography_src/* PMedium */.aW, {
                children: name
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(component_typography_src/* PMedium */.aW, {
                children: ssn
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-scene-account-picker-virtual-4aa6ab0445/1/packages/scene-account-picker/src/components/picker-search/suggestions-list.tsx







const SuggestionsList = ()=>{
    const filteredAccounts = (0,lib_recoil_src/* useRecoilValue */.sJ)(filteredAccountsState);
    return filteredAccounts.length ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Suggestions, {
        children: filteredAccounts.map((item)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(SuggestedItem, {
                id: item.id,
                name: item.account.name || "",
                ssn: item.account.ssn
            }, item.id))
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Suggestions, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Item, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(component_typography_src/* PMedium */.aW, {
                children: "Ekkert fannst"
            })
        })
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-scene-account-picker-virtual-4aa6ab0445/1/packages/scene-account-picker/src/components/picker-search/picker-search.tsx









const PickerSearch = ()=>{
    const setFilteredAccounts = (0,lib_recoil_src/* useSetRecoilState */.Zl)(filteredAccountsState);
    const [showSuggestions, setShowSuggestions] = (0,lib_recoil_src/* useRecoilState */.FV)(showSuggestionsState);
    const [inputValue, setInputValue] = (0,lib_recoil_src/* useRecoilState */.FV)(inputValueState);
    const { memberships  } = (0,hooks_auth_next_src/* useAuth */.aC)();
    const handleInputChange = (0,react.useCallback)((e)=>{
        e.preventDefault();
        setInputValue(e.target.value);
        let unLinked = [];
        if (memberships) {
            unLinked = memberships.filter((membership)=>(membership.account.name || "").toLowerCase().indexOf(e.target.value.toLowerCase()) > -1 || membership.account.ssn.indexOf(e.target.value.toLowerCase()) > -1);
        }
        setFilteredAccounts(unLinked);
        setShowSuggestions(true);
    }, [
        setInputValue,
        setFilteredAccounts,
        setShowSuggestions,
        memberships
    ]);
    const handleOnClick = (0,react.useCallback)(()=>{
        setInputValue("");
        setFilteredAccounts([]);
    }, [
        setInputValue,
        setFilteredAccounts
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Border, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(component_inputs_src/* SearchInput */.Mj, {
                isDirty: Boolean(inputValue),
                placeholder: "Leita\xf0u eftir nafni e\xf0a kennit\xf6lu",
                type: "text",
                value: inputValue,
                onChange: handleInputChange,
                onClick: handleOnClick
            }),
            showSuggestions && inputValue && /*#__PURE__*/ (0,jsx_runtime.jsx)(SuggestionsList, {})
        ]
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-scene-account-picker-virtual-4aa6ab0445/1/packages/scene-account-picker/src/components/picker-search/index.tsx


;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-scene-account-picker-virtual-4aa6ab0445/1/packages/scene-account-picker/src/components/user-item/user-item.tsx








const UserItem = (param)=>{
    let { id , name  } = param;
    const setOpen = (0,lib_recoil_src/* useSetRecoilState */.Zl)(src/* drawerState */.Z$);
    const [loading, setLoading] = (0,react.useState)(false);
    const { switchAccount , setRequestSwitchAccount  } = (0,hooks_auth_next_src/* useAuth */.aC)();
    const setIsDrawerLoading = (0,lib_recoil_src/* useSetRecoilState */.Zl)(src/* drawerStateLoading */.tl);
    const handleClick = (0,react.useCallback)(async ()=>{
        setLoading(true);
        await switchAccount(id);
        setRequestSwitchAccount(false);
        setLoading(false);
        setIsDrawerLoading(false);
        setOpen(false);
    }, [
        switchAccount,
        id,
        setRequestSwitchAccount,
        setIsDrawerLoading,
        setOpen
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(component_buttons_src/* Button */.zx, {
        disabled: loading,
        icon: lib_icons_src.LongArrowSideIcons,
        label: name !== null && name !== void 0 ? name : "",
        stretch: true,
        onClick: handleClick
    }, id);
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-scene-account-picker-virtual-4aa6ab0445/1/packages/scene-account-picker/src/components/user-item/index.ts


;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-scene-account-picker-virtual-4aa6ab0445/1/packages/scene-account-picker/src/components/picker-recently-visited.tsx








const PickerRecentlyVisited = ()=>{
    const { memberships  } = (0,hooks_auth_next_src/* useAuth */.aC)();
    const [expanded, setExpanded] = (0,react.useState)(false);
    const itemsToShow = expanded ? memberships : memberships.slice(0, 4);
    const handleClick = (0,react.useCallback)(()=>{
        setExpanded(!expanded);
    }, [
        expanded
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(UserItemWrapper, {
                children: itemsToShow.map((item)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(UserItem, {
                        id: item.id,
                        name: item.account.name || ""
                    }, item.id))
            }),
            memberships.length > 5 && !expanded && /*#__PURE__*/ (0,jsx_runtime.jsx)(component_buttons_src/* Button */.zx, {
                icon: lib_icons_src.AddIcons,
                label: "Sj\xe1 fleiri",
                stretch: true,
                onClick: handleClick
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-scene-account-picker-virtual-4aa6ab0445/1/packages/scene-account-picker/src/components/index.ts



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-scene-account-picker-virtual-4aa6ab0445/1/packages/scene-account-picker/src/styles.ts
function styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function styles_templateObject() {
    const data = styles_taggedTemplateLiteral([
        "\n  display: flex;\n  height: 100%;\n  flex-direction: column;\n  justify-content: center;\n  margin-top: 40px;\n  gap: 8px;\n  .hideButton {\n    display: none;\n  }\n"
    ]);
    styles_templateObject = function() {
        return data;
    };
    return data;
}
function styles_templateObject1() {
    const data = styles_taggedTemplateLiteral([
        "\n  width: 100%;\n  height: 2px;\n  margin-top: 24px;\n  margin-bottom: 24px;\n  background-color: ",
        ";\n"
    ]);
    styles_templateObject1 = function() {
        return data;
    };
    return data;
}
function styles_templateObject2() {
    const data = styles_taggedTemplateLiteral([
        "\n  width: 100%;\n  height: 1px;\n  margin-top: 24px;\n  background-color: ",
        ";\n"
    ]);
    styles_templateObject2 = function() {
        return data;
    };
    return data;
}


const styles_Container = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-932ddfc6-0"
})(styles_templateObject());
const Line = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-932ddfc6-1"
})(styles_templateObject1(), lib_styles_src/* theme.palette.yellow.main */.rS.palette.yellow.main);
const BottomLine = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-932ddfc6-2"
})(styles_templateObject2(), lib_styles_src/* theme.palette.gray.10 */.rS.palette.gray[10]);

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-scene-account-picker-virtual-4aa6ab0445/1/packages/scene-account-picker/src/account-picker.tsx





const AccountPicker = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles_Container, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(component_typography_src.H6, {
                children: "Veldu a\xf0gang"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PickerSearch, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Line, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PickerRecentlyVisited, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BottomLine, {})
        ]
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-scene-account-picker-virtual-4aa6ab0445/1/packages/scene-account-picker/src/index.ts



// EXTERNAL MODULE: ../../packages/types-utils/src/index.ts + 3 modules
var types_utils_src = __webpack_require__(71612);
// EXTERNAL MODULE: ../../.yarn/cache/yup-npm-0.32.11-dbaff8ca9c-43a16786b4.zip/node_modules/yup/es/index.js + 25 modules
var yup_es = __webpack_require__(7007);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-component-alert-virtual-0012017e3d/1/packages/component-alert/src/index.ts + 2 modules
var component_alert_src = __webpack_require__(6920);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-lib-api-rest-virtual-a514398bdb/1/packages/lib-api-rest/src/index.ts + 4 modules
var lib_api_rest_src = __webpack_require__(97639);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-hooks-add-email-virtual-9c323688b5/1/packages/hooks-add-email/src/use-add-email.ts


const useAddEmail = ()=>{
    const checkEmailAvailability = (0,react.useCallback)(async (email)=>{
        try {
            const res = await lib_api_rest_src/* restApi.usersCheckEmailAvailabilityCreate */._O.usersCheckEmailAvailabilityCreate({
                email
            });
            return res.data.available;
        } catch (err) {
            console.error(err);
            return undefined;
        }
    }, []);
    return {
        checkEmailAvailability
    };
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-hooks-add-email-virtual-9c323688b5/1/packages/hooks-add-email/src/index.ts


// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-hooks-modal-virtual-7ecc3a3b97/1/packages/hooks-modal/src/index.ts + 3 modules
var hooks_modal_src = __webpack_require__(6315);
// EXTERNAL MODULE: ../../packages/lib-formik/src/index.ts
var lib_formik_src = __webpack_require__(8462);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-lib-utils-virtual-08ae943915/1/packages/lib-utils/src/index.ts + 19 modules
var lib_utils_src = __webpack_require__(65582);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-component-login-virtual-81673191b3/1/packages/component-login/src/interface.ts

var LoginStepState;
(function(LoginStepState) {
    LoginStepState["terms"] = "Skilm\xe1lar";
    LoginStepState["email"] = "Netfang";
    LoginStepState["welcome"] = "Velkomin";
})(LoginStepState || (LoginStepState = {}));
const loginState = (0,lib_recoil_src/* atom */.cn)({
    key: "loginState",
    default: LoginStepState.terms
});

// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-component-loaders-virtual-61e12a86f6/1/packages/component-loaders/src/index.ts + 7 modules
var component_loaders_src = __webpack_require__(96360);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-lib-illustrations-virtual-f4c8d3dc38/1/packages/lib-illustrations/src/index.ts + 16 modules
var lib_illustrations_src = __webpack_require__(94845);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-component-login-virtual-81673191b3/1/packages/component-login/src/component/loading/styles.ts
function loading_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function loading_styles_templateObject() {
    const data = loading_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  height: 100%;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n"
    ]);
    loading_styles_templateObject = function() {
        return data;
    };
    return data;
}
function loading_styles_templateObject1() {
    const data = loading_styles_taggedTemplateLiteral([
        "\n  svg {\n    width: 100%;\n    min-width: 250px;\n    max-width: 400px;\n    height: 100%;\n    max-height: 500px;\n  }\n"
    ]);
    loading_styles_templateObject1 = function() {
        return data;
    };
    return data;
}
function loading_styles_templateObject2() {
    const data = loading_styles_taggedTemplateLiteral([
        "\n  position: relative;\n  display: flex;\n  justify-content: center;\n"
    ]);
    loading_styles_templateObject2 = function() {
        return data;
    };
    return data;
}

const loading_styles_Container = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-c454e63b-0"
})(loading_styles_templateObject());
const IllustrationContainer = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-c454e63b-1"
})(loading_styles_templateObject1());
const LoaderContainer = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-c454e63b-2"
})(loading_styles_templateObject2());

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-component-login-virtual-81673191b3/1/packages/component-login/src/component/loading/loading.tsx






const Loading = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(loading_styles_Container, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(component_typography_src.H6, {
                children: "\xdeetta er allt \xed p\xedpunum"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LoaderContainer, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(component_loaders_src.MainLoader, {
                    size: 48
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(IllustrationContainer, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lib_illustrations_src/* PipulagnirIllustration */.Y8, {})
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-component-login-virtual-81673191b3/1/packages/component-login/src/component/loading/index.ts


;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-component-login-virtual-81673191b3/1/packages/component-login/src/component/email/steps.ts
const emailStepText = {
    head: "Hvert er netfangi\xf0 \xfeitt?",
    main: "Vinsamlegast skr\xe1\xf0u netfangi\xf0 \xfeitt svo h\xe6gt s\xe9 a\xf0 senda n\xf3tur, p\xf6ntunarsta\xf0festingar o.fl."
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-component-login-virtual-81673191b3/1/packages/component-login/src/component/email/styles.ts
function email_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function email_styles_templateObject() {
    const data = email_styles_taggedTemplateLiteral([
        ""
    ]);
    email_styles_templateObject = function() {
        return data;
    };
    return data;
}
function email_styles_templateObject1() {
    const data = email_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  height: 100%;\n  flex-direction: column;\n  justify-content: space-between;\n  padding-bottom: 40px;\n"
    ]);
    email_styles_templateObject1 = function() {
        return data;
    };
    return data;
}
function email_styles_templateObject2() {
    const data = email_styles_taggedTemplateLiteral([
        "\n  margin-top: 40px;\n"
    ]);
    email_styles_templateObject2 = function() {
        return data;
    };
    return data;
}
function styles_templateObject3() {
    const data = email_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  width: 100%;\n  flex-direction: column;\n  justify-content: flex-end;\n  row-gap: 8px;\n"
    ]);
    styles_templateObject3 = function() {
        return data;
    };
    return data;
}


const FormikProviderStyle = (0,styled_components_browser_cjs["default"])(lib_formik_src/* FormikProvider */.Hy).withConfig({
    componentId: "sc-8c3eaae7-0"
})(email_styles_templateObject());
const EmailFormWrapper = styled_components_browser_cjs["default"].form.withConfig({
    componentId: "sc-8c3eaae7-1"
})(email_styles_templateObject1());
const TextAndInput = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-8c3eaae7-2"
})(email_styles_templateObject2());
const styles_ButtonWrapper = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-8c3eaae7-3"
})(styles_templateObject3());

// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-component-selectors-virtual-9e0e678d5e/1/packages/component-selectors/src/index.ts + 10 modules
var component_selectors_src = __webpack_require__(60002);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-component-login-virtual-81673191b3/1/packages/component-login/src/component/email/email.tsx
function email_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function email_templateObject() {
    const data = email_taggedTemplateLiteral([
        "\n    margin-top: 20px;\n  "
    ]);
    email_templateObject = function() {
        return data;
    };
    return data;
}





















const Email = ()=>{
    const { addEmail , emailIsLoading , logout  } = (0,hooks_auth_next_src/* useAuth */.aC)();
    const { show , hide  } = (0,hooks_modal_src/* useModal */.d)();
    const { checkEmailAvailability  } = useAddEmail();
    const [errorMessagesState, setErrorMessagesState] = (0,react.useState)("Nau\xf0synlegt");
    const [steps, setSteps] = (0,lib_recoil_src/* useRecoilState */.FV)(loginState);
    const [showAlert, setShowAlert] = (0,react.useState)(false);
    const [showLoadingSplash, setShowLoadingSplash] = (0,react.useState)(false);
    (0,react.useEffect)(()=>{
        if (emailIsLoading) {
            setShowLoadingSplash(true);
        }
    }, [
        emailIsLoading
    ]);
    (0,react.useEffect)(()=>{
        if (showLoadingSplash) {
            setTimeout(()=>{
                setShowLoadingSplash(false);
                setSteps(LoginStepState.welcome);
            }, 3000);
        }
    }, [
        setSteps,
        showLoadingSplash,
        steps
    ]);
    (0,react.useEffect)(()=>{
        if (showAlert) {
            setTimeout(()=>{
                setShowAlert(false);
            }, 5000);
        }
    }, [
        showAlert,
        steps
    ]);
    const required = "Nau\xf0synlegt";
    const emailInUse = "Netfang er n\xfa \xfeegar \xed notkun";
    const emailNotValid = "Netfang ekki gilt";
    const somethingWentWrong = "Eitthva\xf0 f\xf3r \xfarskei\xf0is";
    const initialValues = {
        email: "",
        addPersonalExperience: false,
        addToPostList: false
    };
    const formik = (0,lib_formik_src/* useFormik */.TA)({
        initialValues,
        enableReinitialize: true,
        validateOnChange: false,
        validateOnMount: true,
        validationSchema: yup_es/* object */.Ry({
            email: yup_es/* string */.Z_().email(emailNotValid),
            addPersonalExperience: yup_es/* boolean */.O7().required(required),
            addToPostList: yup_es/* boolean */.O7().required(required)
        }),
        onSubmit: async (values)=>{
            await addEmail(values.email, values.addToPostList);
        }
    });
    const handleEmailClick = (0,react.useCallback)(async ()=>{
        const res = await checkEmailAvailability(formik.values.email);
        if (res === false) {
            setShowAlert(true);
            setErrorMessagesState(emailInUse);
        } else if (formik.values.email.match(lib_utils_src/* emailValidation */.D6) === null) {
            setErrorMessagesState(emailNotValid);
        } else {
            setErrorMessagesState(somethingWentWrong);
        }
    }, [
        checkEmailAvailability,
        formik
    ]);
    const handleLogout = (0,react.useCallback)(()=>{
        hide();
        logout();
    }, [
        hide,
        logout
    ]);
    const CheckboxContainer = styled_components_browser_cjs["default"].div.withConfig({
        componentId: "sc-de54f8ea-0"
    })(email_templateObject());
    const handleLogoutPrompt = (0,react.useCallback)(()=>{
        show({
            title: "Skr\xe1 \xfat",
            paragraph: "Ertu viss um a\xf0 \xfe\xfa viljir h\xe6tta vi\xf0 innskr\xe1ningu?",
            cancelLabel: "H\xe6tta vi\xf0",
            confirmCallback: handleLogout,
            cancelIcon: lib_icons_src.CancelLargeIcons,
            confirmLabel: "Sta\xf0festa"
        });
    }, [
        handleLogout,
        show
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: showLoadingSplash ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Loading, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(lib_formik_src/* FormikProvider */.Hy, {
            value: formik,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(EmailFormWrapper, {
                onSubmit: formik.handleSubmit,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(TextAndInput, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(component_typography_src.H6, {
                                bottom: 16,
                                children: emailStepText.head
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(component_typography_src/* PSmall */.zK, {
                                bottom: 32,
                                children: emailStepText.main
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(component_inputs_src/* FormikInput */.jc, {
                                error: (0,component_inputs_src/* showFormikError */.yp)(formik, "email"),
                                errorText: errorMessagesState,
                                id: "email",
                                name: "email",
                                placeholder: "Sl\xe1\xf0u inn netfang",
                                stretch: true,
                                type: "text",
                                onBlur: formik.handleBlur,
                                onChange: formik.handleChange
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckboxContainer, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(component_selectors_src/* FormikCheckbox */.ml, {
                                    checked: formik.values.addToPostList,
                                    id: "addToPostList",
                                    label: "\xc9g vil f\xe1 sendar uppl\xfdsingar um tilbo\xf0 og afsl\xe6tti",
                                    name: "addToPostList",
                                    smallBox: true,
                                    onChange: formik.handleChange
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(component_alert_src/* Alert */.b, {
                                alertType: "warning",
                                bottom: "10",
                                showSuccess: showAlert,
                                stretch: true,
                                text: errorMessagesState
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles_ButtonWrapper, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(component_buttons_src/* Button */.zx, {
                                buttonColor: "blueButton",
                                disabled: formik.isSubmitting || !formik.dirty || !formik.values.email,
                                icon: lib_icons_src.LongArrowSideIcons,
                                label: "\xc1fram",
                                stretch: true,
                                type: "submit",
                                onClick: handleEmailClick
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(component_buttons_src/* Button */.zx, {
                                buttonColor: "redButton",
                                icon: lib_icons_src.CancelLargeIcons,
                                label: "H\xe6tta vi\xf0",
                                stretch: true,
                                type: "button",
                                onClick: handleLogoutPrompt
                            })
                        ]
                    })
                ]
            })
        })
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-component-login-virtual-81673191b3/1/packages/component-login/src/component/email/index.ts


;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-component-login-virtual-81673191b3/1/packages/component-login/src/component/terms/steps.ts
const acceptTermsStepText = {
    head: "Sam\xfeykkja skilm\xe1la",
    main: "Vinsamlegast sam\xfeykktu notendaskilm\xe1la til \xfeess a\xf0 geta haldi\xf0 \xe1fram."
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-component-login-virtual-81673191b3/1/packages/component-login/src/component/terms/styles.ts
function terms_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function terms_styles_templateObject() {
    const data = terms_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  height: fit-content;\n  height: 100%;\n  flex-direction: column;\n  justify-content: center;\n  margin-top: 40px;\n"
    ]);
    terms_styles_templateObject = function() {
        return data;
    };
    return data;
}
function terms_styles_templateObject1() {
    const data = terms_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  height: 100%;\n  flex-direction: column;\n  justify-content: space-between;\n  padding-bottom: 40px;\n"
    ]);
    terms_styles_templateObject1 = function() {
        return data;
    };
    return data;
}
function terms_styles_templateObject2() {
    const data = terms_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  padding: 14px 14px 0 14px;\n  margin-top: 20px;\n  gap: 24px;\n"
    ]);
    terms_styles_templateObject2 = function() {
        return data;
    };
    return data;
}
function terms_styles_templateObject3() {
    const data = terms_styles_taggedTemplateLiteral([
        "\n  max-height: 250px;\n  padding: 24px 14px;\n  border: 1px solid ",
        ";\n  overflow-x: none;\n  overflow-y: scroll;\n  &::-webkit-scrollbar-track {\n    margin-top: 20px;\n    background-color: ",
        ";\n  }\n  &::-webkit-scrollbar {\n    width: 2px;\n  }\n  &::-webkit-scrollbar-thumb {\n    background: ",
        ";\n    &::-webkit-scrollbar {\n      width: 2px;\n    }\n  }\n"
    ]);
    terms_styles_templateObject3 = function() {
        return data;
    };
    return data;
}


const Content = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-c865e31e-0"
})(terms_styles_templateObject());
const DrawerContent = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-c865e31e-1"
})(terms_styles_templateObject1());
const CheckboxAndButton = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-c865e31e-2"
})(terms_styles_templateObject2());
// --- term-text.tsx --- //
const TermsWrapper = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-c865e31e-3"
})(terms_styles_templateObject3(), lib_styles_src/* theme.palette.gray.10 */.rS.palette.gray[10], lib_styles_src/* theme.palette.white.main */.rS.palette.white.main, lib_styles_src/* theme.palette.blue.main */.rS.palette.blue.main);

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-component-login-virtual-81673191b3/1/packages/component-login/src/component/terms/terms-text.tsx
/* eslint-disable max-len */ 




const TermsText = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(TermsWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(component_typography_src/* PMediumBold */.zo, {
                textColor: lib_styles_src/* theme.palette.blue.dark */.rS.palette.blue.dark,
                children: "Vi\xf0skiptaskilm\xe1lar BYKO"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(component_typography_src/* PMediumBold */.zo, {
                children: "Almennir \xe1byrg\xf0arskilm\xe1lar"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(component_typography_src/* PSmall */.zK, {
                textColor: lib_styles_src/* theme.palette.blue.dark */.rS.palette.blue.dark,
                children: "Allar v\xf6rur eru seldar me\xf0 fullri \xe1byrg\xf0 samkv\xe6mt l\xf6gum um neytendakaup nr. 48/2003. \xc1byrg\xf0 mi\xf0ast vi\xf0 dagsetningu kaupn\xf3tu. Kaupn\xf3ta er nau\xf0synleg \xfeegar sta\xf0festa \xfearf \xe1byrg\xf0. \xc1byrg\xf0 n\xe6r ekki til e\xf0lilegs slits. \xc1byrg\xf0in fellur \xfar gildi ef rekja m\xe1 bilun til illrar e\xf0a rangrar me\xf0fer\xf0ar."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(component_typography_src/* PMediumBold */.zo, {
                children: "Vi\xf0skiptaskilm\xe1lar"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(component_typography_src/* PSmall */.zK, {
                textColor: lib_styles_src/* theme.palette.blue.dark */.rS.palette.blue.dark,
                children: "Varan er eign BYKO \xfear til kaupver\xf0 hefur veri\xf0 a\xf0 fullu greitt. Ra\xf0grei\xf0slusamningar, reikningsvi\xf0skipti e\xf0a \xf6nnur l\xe1naform afnema ekki eignar\xe9tt BYKO fyrr en fullna\xf0argrei\xf0sla hefur veri\xf0 innt af hendi. Gjalddagi reiknings vegna reikningsvi\xf0skipta er 1. dag m\xe1na\xf0ar. Eindagi reiknings er 20. dag m\xe1na\xf0ar. Dr\xe1ttarvextir reiknast eftir eindaga fr\xe1 og me\xf0 gjalddaga reiknings."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(component_typography_src/* PMediumBold */.zo, {
                children: "Skilar\xe9ttur "
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(component_typography_src/* PSmall */.zK, {
                textColor: lib_styles_src/* theme.palette.blue.dark */.rS.palette.blue.dark,
                children: "Skilar\xe9ttur v\xf6ru er allt a\xf0 30 dagar gegn framv\xedsun reiknings. Athugi\xf0 a\xf0 \xfats\xf6luv\xf6rum er ekki h\xe6gt a\xf0 skila e\xf0a skipta. Vara er eign BYKO uns h\xfan hefur veri\xf0 a\xf0 fullu greidd. BYKO \xe1skilur s\xe9r r\xe9tt til a\xf0 taka 20% aff\xf6ll af upphaflegu ver\xf0i \xfeegar v\xf6rum er skila\xf0. Vi\xf0 v\xf6ruskil er \xfatgefin inneignarn\xf3ta sem gildir \xed \xf6llum verslunum BYKO \xed 1 \xe1r fr\xe1 \xfatg\xe1fudegi. Ekki er h\xe6gt a\xf0 skila lj\xf3saperum e\xf0a ni\xf0urm\xe6ldri v\xf6ru. Ekki er h\xe6gt a\xf0 skila s\xe9rp\xf6ntunarv\xf6ru."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(component_typography_src/* PMediumBold */.zo, {
                children: "Lagning g\xf3lfefna "
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(component_typography_src/* PMediumBold */.zo, {
                children: "Nokkur atri\xf0i sem \xfearf a\xf0 hafa \xed huga "
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(component_typography_src/* PSmall */.zK, {
                textColor: lib_styles_src/* theme.palette.blue.dark */.rS.palette.blue.dark,
                children: "A\xf0 uppg\xf6tva galla eftir a\xf0 g\xf3lfefni\xf0 hefur veri\xf0 lagt \xe1 g\xf3lf getur reynst kaupanda v\xf6runnar d\xfdrkeypt ef hann hefur ekki framfylgt faglegu eftirlitshlutverki vi\xf0 l\xf6gnina. Kaupandi v\xf6runnar m\xe1 b\xfaast vi\xf0 \xfev\xed a\xf0 \xfeurfa a\xf0 bera tj\xf3ni\xf0 sj\xe1lfur."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(component_typography_src/* PMediumBold */.zo, {
                children: "Parket og \xfeiljur, sj\xe1anlegir gallar"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(component_typography_src/* PSmall */.zK, {
                textColor: lib_styles_src/* theme.palette.blue.dark */.rS.palette.blue.dark,
                children: "Fylgjast \xfearf vel me\xf0 a\xf0 bor\xf0 falli vel saman og ekki s\xe9 h\xe6\xf0armismunur milli bor\xf0a. Sko\xf0a \xfearf hvert bor\xf0 vandlega \xe1\xf0ur en \xfea\xf0 er lagt og leggja \xfea\xf0 til hli\xf0ar ef eitthva\xf0 er athugavert. Mikilv\xe6gt er a\xf0 l\xfdsing s\xe9 g\xf3\xf0 \xfeannig a\xf0 almennir gallar e\xf0a glansmismunur milli einstakra bor\xf0a fari ekki framhj\xe1 lagningarmanni. Ef hafna \xfearf parketbor\xf0i skal \xfea\xf0 gert \xe1\xf0ur en \xfea\xf0 er lagt. Ganga \xfearf \xfar skugga um a\xf0 r\xe9tt v\xf6rutegund hafi veri\xf0 afhent \xe1\xf0ur en lagning hefst."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(component_typography_src/* PMediumBold */.zo, {
                children: "Fl\xedsar, st\xe6r\xf0ir og litir"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(component_typography_src/* PSmall */.zK, {
                textColor: lib_styles_src/* theme.palette.blue.dark */.rS.palette.blue.dark,
                children: "Fl\xedsar eru almennt framleiddar \xed lotum. Lita- og st\xe6r\xf0armunur er \xe1 milli framlei\xf0slulota. Framlei\xf0endur stimpla litan\xfamer \xe1 pakkana \xed samr\xe6mi vi\xf0 framlei\xf0slulotu. Mikilv\xe6gt er a\xf0 l\xfdsing s\xe9 g\xf3\xf0 \xfeannig a\xf0 almennir gallar eins og litamunur, st\xe6r\xf0armunur e\xf0a a\xf0rir sj\xe1anlegir gallar fari ekki framhj\xe1 lagningarmanni. Kaupandi \xfearf a\xf0 bera saman litan\xfameri\xf0 \xe1 k\xf6ssunum \xfev\xed \xfea\xf0 er mj\xf6g \xe1r\xed\xf0andi a\xf0 allar keyptar fl\xedsar s\xe9u \xfar s\xf6mu framlei\xf0slulotu. Ef hafna \xfearf fl\xedsum s\xf6kum litamunar, st\xe6r\xf0ar e\xf0a annarra athugasemda skal \xfea\xf0 gert \xe1\xf0ur en \xfe\xe6r eru lag\xf0ar. Ganga \xfearf \xfar skugga um a\xf0 r\xe9tt v\xf6rutegund hafi veri\xf0 afhent \xe1\xf0ur en lagning hefst. Ef s\xf6luhlutur er galla\xf0ur ber kaupanda a\xf0 tilkynna BYKO um a\xf0 hann muni bera gallann fyrir sig \xe1n \xe1st\xe6\xf0ulauss dr\xe1ttar fr\xe1 \xfev\xed a\xf0 hann var\xf0 galla var e\xf0a m\xe1tti ver\xf0a hans var."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(component_typography_src/* PMediumBold */.zo, {
                children: "Geymslugj\xf6ld s\xe9rpantana"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(component_typography_src/* PSmall */.zK, {
                textColor: lib_styles_src/* theme.palette.blue.dark */.rS.palette.blue.dark,
                children: "Geymslugjald reiknast 7 d\xf6gum eftir tilkynningu um komu v\xf6ru. Geymslugjald \xe1 einu EURO bretti: 500 kr \xe1 dag (Vnr. 095)."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(component_typography_src/* PMediumBold */.zo, {
                children: "G\xe1maleiga"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(component_typography_src/* PSmall */.zK, {
                textColor: lib_styles_src/* theme.palette.blue.dark */.rS.palette.blue.dark,
                children: "G\xe1maleiga reiknast 14 d\xf6gum eftir tilkynningu um komu g\xe1ms. G\xe1maleiga \xe1 40 feta g\xe1mi: 6.130 kr \xe1 dag (Vnr. 028). G\xe1maleiga \xe1 20 feta g\xe1mi: 4.595 kr \xe1 dag (Vnr. 027)."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(component_typography_src/* PMediumBold */.zo, {
                children: "Vi\xf0skiptaskilm\xe1lar vefverslunar BYKO"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(component_typography_src/* PSmall */.zK, {
                textColor: lib_styles_src/* theme.palette.blue.dark */.rS.palette.blue.dark,
                children: [
                    "\xdeessi skilm\xe1li gildir um s\xf6lu \xe1 v\xf6ru og \xfej\xf3nustu BYKO til neytenda. Skilm\xe1linn, sem sta\xf0festur er me\xf0 sta\xf0festingu \xe1 kaupum, er grunnurinn a\xf0 vi\xf0skiptunum. Skilm\xe1linn og a\xf0rar uppl\xfdsingar \xe1 BYKO.is eru einungis f\xe1anlegar \xe1 \xedslensku. Um neytendakaup \xfeessi er fjalla\xf0 \xed",
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: "https://www.althingi.is/dba-bin/unds.pl?txti=/wwwtext/html/lagasofn/131b/2003048.html&leito=neytanda#word1",
                        rel: "noreferrer",
                        target: "_blank",
                        children: "l\xf6gum um neytendakaup"
                    }),
                    ",",
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: "https://www.althingi.is/dba-bin/unds.pl?txti=/wwwtext/html/lagasofn/136b/1936007.html&leito=samningsgert%5C0samningsger%25F0%5C0samningsger%25F0a%5C0samningsger%25F0an%5C0samningsger%25F0anna%5C0samningsger%25F0ar%5C0samningsger%25F0ara%5C0samningsger%25F0ari%5C0samningsger%25F0arinnar%5C0samningsger%25F0ast%5C0samningsger%25F0asta%5C0samningsger%25F0astan%5C0samningsger%25F0astar%5C0samningsger%25F0asti%5C0samningsger%25F0astir%5C0samningsger%25F0astra%5C0samningsger%25F0astrar%5C0samningsger%25F0astri%5C0samningsger%25F0asts%5C0samningsger%25F0astur%5C0samningsger%25F0i%5C0samningsger%25F0in%5C0samningsger%25F0ina%5C0samningsger%25F0inni%5C0samningsger%25F0ir%5C0samningsger%25F0irnar%5C0samningsger%25F0ra%5C0samningsger%25F0rar%5C0samningsger%25F0ri%5C0samningsger%25F0s%5C0samningsger%25F0u%5C0samningsger%25F0um%5C0samningsger%25F0unum%5C0samningsger%25F0ur%5C0samningsger%25F0ust%5C0samningsger%25F0ustu%5C0samningsger%25F0ustum#word1",
                        rel: "noreferrer",
                        target: "_blank",
                        children: "l\xf6gum um samningsger\xf0"
                    }),
                    ",",
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: "https://www.althingi.is/dba-bin/unds.pl?txti=/wwwtext/html/lagasofn/131b/2002030.html&leito=vi%25F0skipti#word1",
                        rel: "noreferrer",
                        target: "_blank",
                        children: "l\xf6gum um rafr\xe6n vi\xf0skipti og a\xf0ra rafr\xe6na \xfej\xf3nustu"
                    }),
                    ",",
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: "https://www.althingi.is/dba-bin/unds.pl?txti=/wwwtext/html/lagasofn/132a/1997071.html&leito=fj%25E1rr%25E1tt%255C0fj%25E1rr%25E1%25F0%255C0fj%25E1rr%25E1%25F0a%255C0fj%25E1rr%25E1%25F0an%255C0fj%25E1rr%25E1%25F0anna%255C0fj%25E1rr%25E1%25F0ar%255C0fj%25E1rr%25E1%25F0ara%255C0fj%25E1rr%25E1%25F0ari%255C0fj%25E1rr%25E1%25F0ast%255C0fj%2525E",
                        rel: "noreferrer",
                        target: "_blank",
                        children: "l\xf6gr\xe6\xf0isl\xf6g"
                    }),
                    " ",
                    "og",
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: "https://www.althingi.is/dba-bin/unds.pl?txti=/wwwtext/html/lagasofn/131b/2000077.html&leito=vernd#word1",
                        rel: "noreferrer",
                        target: "_blank",
                        children: "l\xf6gum um pers\xf3nuvernd og me\xf0fer\xf0 pers\xf3nuuppl\xfdsinga."
                    }),
                    "Seljandi er BYKO , Skemmuvegi 2, 201 K\xf3pavogi, kennitala: 460169-3219, vir\xf0isaukaskattsn\xfamer 3394. Byko ehf. er skr\xe1\xf0 \xed Firmaskr\xe1 \xcdslands. Kaupandi er s\xe1 a\xf0ili sem er skr\xe1\xf0ur kaupandi \xe1 reikning. Kaupandi ver\xf0ur a\xf0 vera or\xf0inn a\xf0 minnsta kosti 16 \xe1ra til a\xf0 versla \xe1 www.BYKO.is P\xf6ntun er bindandi \xfeegar h\xfan er skr\xe1\xf0 \xe1 net\xfej\xf3n seljanda. \xdea\xf0 gerist \xfeegar kaupandi hefur sta\xf0fest p\xf6ntun \xed skrefi. 3. Seljandi er einnig bundinn til a\xf0 afgrei\xf0a p\xf6ntun kaupanda svo lengi sem h\xfan er \xed samr\xe6mi vi\xf0 v\xf6ru\xfarval og ver\xf0lagningu. Allar pantanir \xfear sem grunur um a\xf0 br\xf6g\xf0 s\xe9u \xed tafli og/e\xf0a \xfear sem hugb\xfana\xf0argalli hefur \xe1hrif eru afturkalla\xf0ar. Kaupandi hefur r\xe9tt \xe1 a\xf0 rifta kaupum samkv\xe6mt l\xf6gum um neytendakaup, sj\xe1 n\xe1nar \xed grein 11. Seljandi sendir kaupanda sta\xf0festingu \xfeegar p\xf6ntun er skr\xe1\xf0, \xfe\xf3 a\xf0eins ef kaupandi hefur skr\xe1\xf0 netfang sitt vi\xf0 kaupin. Kaupanda er bent \xe1 a\xf0 kynna s\xe9r gaumg\xe6filega p\xf6ntunarsta\xf0festingu \xfeegar h\xfan berst. Einnig \xe6tti a\xf0 ganga \xfar skugga um a\xf0 h\xfan s\xe9 \xed samr\xe6mi vi\xf0 fyrirhuga\xf0a p\xf6ntun. Fr\xe1vik fr\xe1 p\xf6ntun og p\xf6ntunarsta\xf0festingu skal t\xfalka\xf0 sem n\xfdtt tilbo\xf0 fr\xe1 seljanda sem a\xf0 h\xe6gt er a\xf0 af\xfeakka e\xf0a sam\xfeykkja. Kaupandi hefur einnig r\xe9tt til a\xf0 l\xe1ta upprunalega p\xf6ntun gilda svo lengi sem h\xfan er \xed samr\xe6mi vi\xf0 \xfea\xf0 sem seljandi bau\xf0 upp \xe1. Seljandi veitir uppl\xfdsingar um v\xf6rur eftir bestu vitund hverju sinni. Seljandi birtir allar uppl\xfdsingar me\xf0 fyrirvara um bilanir, v\xedrusa, prent-, birtingar- og innsl\xe1ttarvillur \xed texta, ver\xf0um og myndum. V\xf6ru\xfarval getur veri\xf0 mismunandi milli vefverslunar og verslana. Ennfremur \xe1skilur seljandi s\xe9r r\xe9tt til a\xf0 afl\xfdsa \xed heild e\xf0a a\xf0 hluta til p\xf6ntun kaupanda ef varan er uppseld. Undir \xfeeim kringumst\xe6\xf0um f\xe6r kaupandi tilkynningu \xe1samt uppl\xfdsingum um hva\xf0 g\xe6ti m\xf6gulega henta\xf0 \xed sta\xf0inn. Kaupandi f\xe6r \xfe\xe1 m\xf6guleika \xe1 a\xf0 sam\xfeykkja \xfe\xe1 till\xf6gu e\xf0a afl\xfdsa p\xf6ntun \xed heild sinni. Ver\xf0 eru st\xf6\xf0ugt a\xf0 breytast hj\xe1 seljanda vegna samkeppni og ver\xf0breytinga birgja. Ver\xf0h\xe6kkanir sem ver\xf0a eftir p\xf6ntun vi\xf0skiptavinar eru ekki afturkr\xe6far. \xdea\xf0 ver\xf0 gildir sem var \xed gildi \xfeegar p\xf6ntun var ger\xf0 og kemur fram \xe1 p\xf6ntunarsta\xf0festingu. Heildarkostna\xf0ur er tekinn fram \xe1\xf0ur en kaupandi sta\xf0festir p\xf6ntun endanlega(skref 3 \xed vefverslun). \xdear er tekinn fram allur kostna\xf0ur vi\xf0 p\xf6ntun s.s. \xfej\xf3nustu, sendingu o.s.frv. A\xf0eins s\xe9rtilfelli geta haft me\xf0 s\xe9r aukakostna\xf0 eftir p\xf6ntunarsta\xf0festingu. Sem d\xe6mi m\xe1 nefna eru bilanir, v\xedrusar, prent-, birtingar- og innsl\xe1ttarvillur \xed texta, ver\xf0um og myndum. H\xe6gt er a\xf0 inna grei\xf0slu af hendi me\xf0 bankamillif\xe6rslu e\xf0a grei\xf0slukorti. Ef greitt er me\xf0 grei\xf0slukorti er upph\xe6\xf0in skuldf\xe6r\xf0 vi\xf0 afgrei\xf0slu p\xf6ntunarinnar af lager. Ef grei\xf0sla berst ekki, \xe1skilur seljandi s\xe9r r\xe9tt til a\xf0 afl\xfdsa p\xf6ntuninni. Ef greitt er me\xf0 bankamillif\xe6rslu eru v\xf6rur fr\xe1teknar \xe1 lager \xfear til grei\xf0sla berst. V\xf6rur eru fr\xe1teknar \xed 1 dag me\xf0 tilliti til fr\xeddaga, ef millif\xe6rsla berst ekki innan \xfeess t\xedma er p\xf6ntun afl\xfdst. Afhending telst vera innan e\xf0lilegra t\xedmamarka fr\xe1 \xfatg\xe1fudegi reiknings. Teki\xf0 er fram \xed kaupferlinu hverju m\xe1 b\xfaast vi\xf0 mi\xf0a\xf0 vi\xf0 valda sendingarlei\xf0. Seljandi afhendir v\xf6rur einungis innan \xcdslands. Ef afhendingu seinkar mun seljandi tilkynna \xfea\xf0 til kaupanda \xe1samt uppl\xfdsingum um hven\xe6r p\xf6ntunin ver\xf0ur tilb\xfain til afhendingar e\xf0a bj\xf3\xf0a sta\xf0gengilsv\xf6rur ef varan er uppseld. Allar pantanir yfir kr. 20.000 krefst undirskriftar reikningseiganda gegn framv\xedsun pers\xf3nuskilr\xedkja \xfe.e. passa e\xf0a \xf6kusk\xedrteinis. Pantanir undir kr. 20.000 eru afhentar a\xf0ila \xe1 afhendingarsta\xf0. Ef a\xf0 enginn er vi\xf0 er p\xf6ntun stungi\xf0 inn um br\xe9fal\xfagu ef kostur er. Allar skemmdir \xe1 v\xf6rum af hendi flutningsa\xf0ila eru \xe1 \xfeeirra \xe1byrg\xf0 og a\xf0 fullu b\xe6tt gagnvart vi\xf0skiptavini. Skemmdir eftir a\xf0 vara hefur veri\xf0 afhent er \xe1 \xe1byrg\xf0 kaupanda. Ef a\xf0 afhending v\xf6ru \xed heimakstri reynist \xe1rangurslaus er h\xe6gt a\xf0 \xf3ska eftir n\xfdjum afhendingart\xedma. Ef a\xf0 afhending reynist \xe1rangurslaus \xed anna\xf0 skipti\xf0 er vara tekin \xed geymslu \xfear til h\xfan er s\xf3tt. Geymslut\xedmi mi\xf0ast vi\xf0 2 vikur og eftir \xfea\xf0 \xe1skilur BYKO s\xe9r r\xe9tt til a\xf0 rifta kaupum. Ef a\xf0st\xe6\xf0ur krefjast \xfeess a\xf0 varan s\xe9 geymd er krafist m\xe1na\xf0arlegs geymslugjalds sem nemur um 5% af upph\xe6\xf0 v\xf6runnar. Eftir a\xf0 kaupandi hefur m\xf3tteki\xf0 p\xf6ntunina \xfearf hann a\xf0 kanna hvort h\xfan s\xe9 \xed samr\xe6mi vi\xf0 p\xf6ntunarsta\xf0festinguna, hvort eitthva\xf0 hafi skemmst \xed flutningi og a\xf0 allar v\xf6rur s\xe9u samkv\xe6mt v\xf6rul\xfdsingu og \xf3galla\xf0ar. Skilm\xe1lar \xfeessir gera r\xe1\xf0 fyrir a\xf0 kaupandi hafi lesi\xf0 og kynnt s\xe9r lei\xf0beiningar og/e\xf0a handb\xf3k sem fylgja keyptri v\xf6ru vi\xf0 afhendingu. E\xf0lilegur athugunart\xedmi vi\xf0skiptavinar telst vera innan 30 daga. Eftir 30 daga \xe1skilur seljandi s\xe9r r\xe9tt til a\xf0 sannreyna sta\xf0h\xe6fingu kaupanda innan e\xf0lilegra t\xedmamarka \xe1\xf0ur en leyst er \xfar umkv\xf6rtunarefni kaupanda. \xcd flestum tilfellum felur \xfea\xf0 \xed s\xe9r athugun hj\xe1 vi\xf0urkenndum \xfej\xf3nustua\xf0ila. Ef a\xf0 varan er g\xf6llu\xf0 e\xf0a \xfea\xf0 vantar eitthva\xf0 \xed v\xf6runa er seljanda skylt a\xf0 bj\xf3\xf0a kaupanda vi\xf0ger\xf0, n\xfdja v\xf6ru, afsl\xe1tt e\xf0a afturk\xf6llun kaupa. \xdea\xf0 fer eftir atvikum hva\xf0a lei\xf0 er valin hverju sinni. Tilkynning \xe1 galla ver\xf0ur a\xf0 berast munnlega e\xf0a skriflega. M\xe6lt er me\xf0 a\xf0 tilkynningin berist innan 30 daga fr\xe1 \xfev\xed galli uppg\xf6tvast. Vegna skr\xe1ningargildis er m\xe6lt me\xf0 a\xf0 kaupandi sendi t\xf6lvup\xf3st um gallann og geymi afrit. Seljandi sendir sta\xf0festingu til baka um m\xf3tt\xf6ku t\xf6lvup\xf3stsins. R\xe9ttur til a\xf0 f\xe1 galla b\xe6ttan er \xed 2 \xe1r. R\xe9ttur til a\xf0 kvarta er 5 \xe1r, \xfe\xf3 a\xf0eins \xe1 v\xf6rum sem eru me\xf0 vi\xf0urkenndan me\xf0all\xedft\xedma umfram 2 \xe1r. Seljandi \xe1skilur s\xe9r r\xe9tt til a\xf0 sannreyna a\xf0 varan s\xe9 g\xf6llu\xf0, \xfe\xf3 innan e\xf0lilegra t\xedmamarka."
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-component-login-virtual-81673191b3/1/packages/component-login/src/component/terms/terms.tsx













const Terms = ()=>{
    const { acceptTerms , logout  } = (0,hooks_auth_next_src/* useAuth */.aC)();
    const { show , hide  } = (0,hooks_modal_src/* useModal */.d)();
    const [showAlert, setShowAlert] = (0,react.useState)(false);
    (0,react.useEffect)(()=>{
        if (showAlert) {
            setTimeout(()=>{
                setShowAlert(false);
            }, 5000);
        }
    }, [
        showAlert
    ]);
    const initialValues = {
        acceptTerms: false
    };
    const formik = (0,lib_formik_src/* useFormik */.TA)({
        initialValues,
        enableReinitialize: true,
        validateOnChange: true,
        validateOnMount: true,
        onSubmit: async ()=>{
            await acceptTerms();
        }
    });
    const handleLogout = (0,react.useCallback)(()=>{
        hide();
        logout();
    }, [
        hide,
        logout
    ]);
    const handleLogoutPrompt = (0,react.useCallback)(()=>{
        show({
            title: "Skr\xe1 \xfat",
            paragraph: "Ertu viss um a\xf0 \xfe\xfa viljir h\xe6tta vi\xf0 innskr\xe1ningu?",
            cancelLabel: "H\xe6tta vi\xf0",
            confirmCallback: handleLogout,
            cancelIcon: lib_icons_src.CancelLargeIcons,
            confirmLabel: "Sta\xf0festa"
        });
    }, [
        handleLogout,
        show
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(lib_formik_src/* FormikProvider */.Hy, {
        value: formik,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("form", {
            onSubmit: formik.handleSubmit,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(DrawerContent, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Content, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(component_typography_src.H6, {
                                bottom: 16,
                                children: acceptTermsStepText.head
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(component_typography_src/* PSmall */.zK, {
                                bottom: 32,
                                children: acceptTermsStepText.main
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TermsText, {})
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(CheckboxAndButton, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(component_selectors_src/* FormikCheckbox */.ml, {
                                checked: formik.values.acceptTerms,
                                id: "acceptTerms",
                                label: "Sam\xfeykkja skilm\xe1la BYKO",
                                name: "acceptTerms",
                                smallBox: true,
                                onBlur: formik.handleBlur,
                                onChange: formik.handleChange
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(component_buttons_src/* Button */.zx, {
                                buttonColor: "blueButton",
                                disabled: formik.isSubmitting || !formik.dirty || !formik.values.acceptTerms,
                                icon: lib_icons_src.LongArrowSideIcons,
                                label: "\xc1fram",
                                stretch: true,
                                type: "submit"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(component_buttons_src/* Button */.zx, {
                                buttonColor: "redButton",
                                icon: lib_icons_src.CancelLargeIcons,
                                label: "H\xe6tta vi\xf0",
                                stretch: true,
                                type: "button",
                                onClick: handleLogoutPrompt
                            })
                        ]
                    })
                ]
            })
        })
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-component-login-virtual-81673191b3/1/packages/component-login/src/component/terms/index.ts


// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-lib-dato-virtual-5a00219d6f/1/packages/lib-dato/src/index.ts + 25 modules
var lib_dato_src = __webpack_require__(39452);
// EXTERNAL MODULE: ../../.yarn/cache/classnames-npm-2.3.2-d2fdae468d-2c62199789.zip/node_modules/classnames/index.js
var classnames = __webpack_require__(38805);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-component-login-virtual-81673191b3/1/packages/component-login/src/component/tabs/styles.ts
function tabs_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function tabs_styles_templateObject() {
    const data = tabs_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  width: 100%;\n  align-items: center;\n  border-bottom: 1px solid ",
        ";\n  margin-bottom: 24px;\n"
    ]);
    tabs_styles_templateObject = function() {
        return data;
    };
    return data;
}
function tabs_styles_templateObject1() {
    const data = tabs_styles_taggedTemplateLiteral([
        "\n  position: relative;\n  width: fit-content;\n  height: 56px;\n  border: 0;\n  border-radius: 0;\n  background-color: ",
        ";\n  color: ",
        ";\n  cursor: pointer;\n  padding-inline: 24px;\n  transition: 200ms;\n  user-select: none;\n\n  &:after {\n    position: absolute;\n    right: 0;\n    bottom: -1px;\n    left: 0;\n    display: block;\n    height: 2px;\n    background-color: ",
        ';\n    content: "";\n    opacity: 0;\n    transition: opacity 200ms;\n  }\n\n  &:hover {\n    background-color: ',
        ";\n  }\n\n  &.isActive {\n    background: ",
        ";\n    cursor: default;\n\n    &:after {\n      opacity: 1;\n    }\n  }\n"
    ]);
    tabs_styles_templateObject1 = function() {
        return data;
    };
    return data;
}
function tabs_styles_templateObject2() {
    const data = tabs_styles_taggedTemplateLiteral([
        "\n  display: none;\n\n  &.isActive {\n    display: block;\n  }\n"
    ]);
    tabs_styles_templateObject2 = function() {
        return data;
    };
    return data;
}


const TabsWrapper = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-699c26cc-0"
})(tabs_styles_templateObject(), lib_styles_src/* theme.palette.gray.10 */.rS.palette.gray[10]);
const Tab = styled_components_browser_cjs["default"].button.withConfig({
    componentId: "sc-699c26cc-1"
})(tabs_styles_templateObject1(), lib_styles_src/* theme.palette.white.main */.rS.palette.white.main, lib_styles_src/* theme.palette.blue.main */.rS.palette.blue.main, lib_styles_src/* theme.palette.blue.main */.rS.palette.blue.main, lib_styles_src/* theme.palette.gray.5 */.rS.palette.gray[5], lib_styles_src/* theme.palette.gray.5 */.rS.palette.gray[5]);
const TabContent = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-699c26cc-2"
})(tabs_styles_templateObject2());

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-component-login-virtual-81673191b3/1/packages/component-login/src/component/tabs/tabs.tsx




const Tabs = (param)=>{
    let { tabs , activeTab , setActiveTab  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TabsWrapper, {
                children: tabs.map((param)=>/*#__PURE__*/ {
                    let { label , id  } = param;
                    return (0,jsx_runtime.jsx)(Tab, {
                        className: classnames_default()({
                            isActive: activeTab === id
                        }),
                        type: "button",
                        // eslint-disable-next-line react/jsx-no-bind, react-perf/jsx-no-new-function-as-prop
                        onClick: ()=>setActiveTab(id),
                        children: label
                    }, id);
                })
            }),
            tabs.map((param)=>/*#__PURE__*/ {
                let { content , id  } = param;
                return (0,jsx_runtime.jsx)(TabContent, {
                    className: classnames_default()({
                        isActive: activeTab === id
                    }),
                    children: content
                }, id);
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-component-login-virtual-81673191b3/1/packages/component-login/src/component/tabs/index.ts


;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-component-login-virtual-81673191b3/1/packages/component-login/src/component/login-form/styles.ts
function login_form_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function login_form_styles_templateObject() {
    const data = login_form_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  width: 100%;\n  align-items: center;\n  justify-content: space-between;\n  margin: 32px auto;\n"
    ]);
    login_form_styles_templateObject = function() {
        return data;
    };
    return data;
}
function login_form_styles_templateObject1() {
    const data = login_form_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  height: 100%;\n  flex-direction: column;\n  justify-content: space-between;\n  .input-error-text {\n    transform: translateY(32px);\n  }\n"
    ]);
    login_form_styles_templateObject1 = function() {
        return data;
    };
    return data;
}
function login_form_styles_templateObject2() {
    const data = login_form_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  height: fit-content;\n  height: 100%;\n  flex-direction: column;\n  justify-content: center;\n"
    ]);
    login_form_styles_templateObject2 = function() {
        return data;
    };
    return data;
}
function login_form_styles_templateObject3() {
    const data = login_form_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n"
    ]);
    login_form_styles_templateObject3 = function() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = login_form_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  height: 100%;\n  flex-direction: column;\n"
    ]);
    _templateObject4 = function() {
        return data;
    };
    return data;
}
function _templateObject5() {
    const data = login_form_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  width: 100%;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n"
    ]);
    _templateObject5 = function() {
        return data;
    };
    return data;
}
function _templateObject6() {
    const data = login_form_styles_taggedTemplateLiteral([
        "\n  display: grid;\n  grid-template-rows: 0fr;\n  transition: 200ms ease-in-out;\n\n  &.show {\n    grid-template-rows: 1fr;\n  }\n"
    ]);
    _templateObject6 = function() {
        return data;
    };
    return data;
}
function _templateObject7() {
    const data = login_form_styles_taggedTemplateLiteral([
        "\n  overflow: hidden;\n"
    ]);
    _templateObject7 = function() {
        return data;
    };
    return data;
}

const FlexRow = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-b45d1fea-0"
})(login_form_styles_templateObject());
const login_form_styles_Container = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-b45d1fea-1"
})(login_form_styles_templateObject1());
const Inputs = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-b45d1fea-2"
})(login_form_styles_templateObject2());
const Buttons = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-b45d1fea-3"
})(login_form_styles_templateObject3());
const Form = styled_components_browser_cjs["default"].form.withConfig({
    componentId: "sc-b45d1fea-4"
})(_templateObject4());
const LoadingWrapper = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-b45d1fea-5"
})(_templateObject5());
const SecurityCodeSectionWrapper = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-b45d1fea-6"
})(_templateObject6());
const SecurityCodeSectionContent = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-b45d1fea-7"
})(_templateObject7());

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-component-login-virtual-81673191b3/1/packages/component-login/src/component/login-form/login-form.tsx























const regex = /[^0-9]/g;
const LoginForm = ()=>{
    const { data  } = lib_dato_src/* datoQueries.useGetHeaderText */.t.useGetHeaderText();
    const [saveAuth, setSaveAuth] = (0,react.useState)(true);
    const [activeTab, setActiveTab] = (0,react.useState)(lib_api_rest_src/* PolledLoginMethodEnum.Sim */.GG.Sim);
    const setBlockDrawerClose = (0,lib_recoil_src/* useSetRecoilState */.Zl)(src/* blockDrawerClickOutsideState */.tp);
    const { login , loginError , loading , setError , handleSetPrefersAnonymousCheckout , showAsGuestOption , securityCode  } = (0,hooks_auth_next_src/* useAuth */.aC)();
    const [showSuccess, setShowSuccess] = (0,react.useState)(false);
    const isSim = activeTab === lib_api_rest_src/* PolledLoginMethodEnum.Sim */.GG.Sim;
    const authTypeName = isSim ? "phoneNumber" : "ssn";
    (0,react.useEffect)(()=>{
        const auth = localStorage.getItem(authTypeName);
        if (auth === undefined) {
            setSaveAuth(false);
        }
    }, [
        authTypeName
    ]);
    (0,react.useEffect)(()=>{
        if (showSuccess) {
            setTimeout(()=>{
                setShowSuccess(false);
            }, 5000);
        }
    }, [
        showSuccess
    ]);
    (0,react.useEffect)(()=>{
        if (!loginError) {
            setError("");
        } else {
            setShowSuccess(true);
        }
    }, [
        loginError,
        setError
    ]);
    const storedPhoneNumber = (0,types_utils_src/* isSSR */.yF)() ? undefined : localStorage.getItem("phoneNumber");
    const storedSsn = (0,types_utils_src/* isSSR */.yF)() ? undefined : localStorage.getItem("ssn");
    const initialValues = {
        phoneNumber: storedPhoneNumber ? storedPhoneNumber : "",
        ssn: storedSsn ? storedSsn : ""
    };
    const phoneSchema = yup_es/* object */.Ry({
        phoneNumber: yup_es/* string */.Z_().required("Nau\xf0synlegt").min(7, "L\xe1gmark 7 stafir").max(15, "A\xf0eins 15 t\xf6lustafir eru leyf\xf0ir")
    });
    const ssnSchema = yup_es/* object */.Ry({
        ssn: yup_es/* string */.Z_().required("Nau\xf0synlegt").min(10, "L\xe1gmark 10 stafir").max(10, "A\xf0eins 10 t\xf6lustafir eru leyf\xf0ir")
    });
    const formik = (0,lib_formik_src/* useFormik */.TA)({
        initialValues,
        validateOnChange: true,
        validateOnBlur: false,
        validateOnMount: false,
        validationSchema: isSim ? phoneSchema : ssnSchema,
        onSubmit: async (values)=>{
            setBlockDrawerClose(true);
            const value = isSim ? values.phoneNumber : values.ssn;
            const method = isSim ? lib_api_rest_src/* PolledLoginMethodEnum.Sim */.GG.Sim : lib_api_rest_src/* PolledLoginMethodEnum.App */.GG.App;
            if (saveAuth) {
                localStorage.setItem(authTypeName, value);
            }
            await login(value, method);
            setBlockDrawerClose(false);
        }
    });
    const handleCheckboxChange = (0,react.useCallback)(()=>{
        setSaveAuth((current)=>{
            return !current;
        });
    }, []);
    (0,react.useEffect)(()=>{
        if (saveAuth === false) {
            localStorage.removeItem(authTypeName);
        }
    }, [
        authTypeName,
        saveAuth
    ]);
    // only allow to write numbers
    const handleInputs = (0,react.useCallback)((e)=>{
        const value = e.target.value;
        void formik.setFieldValue(authTypeName, "".concat(value.replace(regex, "")));
    }, [
        authTypeName,
        formik
    ]);
    var _phoneNumber, ref, ref1, _ssn, ref2, ref3;
    const tabs = (0,react.useMemo)(()=>{
        return [
            {
                id: lib_api_rest_src/* PolledLoginMethodEnum.Sim */.GG.Sim,
                label: "Rafr\xe6n skilr\xedki",
                content: /*#__PURE__*/ (0,jsx_runtime.jsx)(component_inputs_src/* FormikInput */.jc, {
                    error: (0,component_inputs_src/* showFormikError */.yp)(formik, "phoneNumber"),
                    errorText: (_phoneNumber = formik.errors.phoneNumber) !== null && _phoneNumber !== void 0 ? _phoneNumber : false,
                    id: "phoneNumber",
                    inputMode: "tel",
                    label: (ref = data === null || data === void 0 ? void 0 : data.descriptionForLoginPopover) !== null && ref !== void 0 ? ref : "Skr\xe1\xf0u \xfeig inn me\xf0 rafr\xe6num skilr\xedkjum",
                    maxLength: 15,
                    pattern: "[0-9]*",
                    placeholder: (ref1 = data === null || data === void 0 ? void 0 : data.hintForPhoneNumberInput) !== null && ref1 !== void 0 ? ref1 : "Sl\xe1\xf0u inn s\xedman\xfamer",
                    type: "tel",
                    ...formik.getFieldProps("phoneNumber"),
                    stretch: true,
                    onChange: handleInputs
                })
            },
            {
                id: lib_api_rest_src/* PolledLoginMethodEnum.App */.GG.App,
                label: "Au\xf0kennisapp",
                content: /*#__PURE__*/ (0,jsx_runtime.jsx)(component_inputs_src/* FormikInput */.jc, {
                    error: (0,component_inputs_src/* showFormikError */.yp)(formik, "ssn"),
                    errorText: (_ssn = formik.errors.ssn) !== null && _ssn !== void 0 ? _ssn : false,
                    id: "ssn",
                    inputMode: "numeric",
                    label: (ref2 = data === null || data === void 0 ? void 0 : data.descriptionForAudkennisappLoginPopover) !== null && ref2 !== void 0 ? ref2 : "Skr\xe1\xf0u \xfeig inn me\xf0 au\xf0kennisappi",
                    maxLength: 10,
                    pattern: "[0-9]*",
                    placeholder: (ref3 = data === null || data === void 0 ? void 0 : data.hintForKennitalaInput) !== null && ref3 !== void 0 ? ref3 : "Sl\xe1\xf0u inn kennit\xf6lu",
                    type: "ssn",
                    ...formik.getFieldProps("ssn"),
                    stretch: true,
                    onChange: handleInputs
                })
            }
        ];
    }, [
        data === null || data === void 0 ? void 0 : data.descriptionForAudkennisappLoginPopover,
        data === null || data === void 0 ? void 0 : data.descriptionForLoginPopover,
        data === null || data === void 0 ? void 0 : data.hintForKennitalaInput,
        data === null || data === void 0 ? void 0 : data.hintForPhoneNumberInput,
        formik,
        handleInputs
    ]);
    var ref4, ref5, ref6, ref7, ref8, ref9;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: loading ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(LoadingWrapper, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(component_typography_src/* PMedium */.aW, {
                    textColor: lib_styles_src/* theme.palette.blue.dark */.rS.palette.blue.dark,
                    children: "Au\xf0kenning send, k\xedktu \xe1 s\xedmann \xfeinn. "
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(component_loaders_src.MainLoader, {
                    size: 48
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(SecurityCodeSectionWrapper, {
                    className: classnames_default()({
                        show: !!securityCode
                    }),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(SecurityCodeSectionContent, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(component_typography_src/* PMedium */.aW, {
                                lineHeight: "150%",
                                textAlign: "center",
                                top: 12,
                                children: [
                                    "A\xf0eins sta\xf0festa au\xf0kenninguna ef \xf6ryggistalan er s\xfa sama og birtist \xe1 s\xedmanum \xfe\xednum.",
                                    " "
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(component_typography_src/* PMediumBold */.zo, {
                                lineHeight: "150%",
                                textAlign: "center",
                                top: 12,
                                children: [
                                    "\xd6ryggistalan \xfe\xedn er: ",
                                    securityCode
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(component_typography_src/* PMedium */.aW, {
                                lineHeight: "150%",
                                textAlign: "center",
                                top: 12,
                                children: "ATH pinni\xf0 \xfeitt er ekki \xfea\xf0 sama og \xf6ryggistalan."
                            })
                        ]
                    })
                })
            ]
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lib_formik_src/* FormikProvider */.Hy, {
                value: formik,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Form, {
                    onSubmit: formik.handleSubmit,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(login_form_styles_Container, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Inputs, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(component_typography_src.H6, {
                                        bottom: 32,
                                        maxFontSize: "32px",
                                        children: (ref4 = data === null || data === void 0 ? void 0 : data.headingForLoginPopover) !== null && ref4 !== void 0 ? ref4 : "Innskr\xe1ning"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Tabs, {
                                        activeTab: activeTab,
                                        setActiveTab: setActiveTab,
                                        tabs: tabs
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(FlexRow, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(component_selectors_src/* Checkbox */.XZ, {
                                                checked: saveAuth,
                                                label: isSim ? (ref5 = data === null || data === void 0 ? void 0 : data.labelForRememberPhoneNumberCheckbox) !== null && ref5 !== void 0 ? ref5 : "Muna s\xedman\xfamer" : (ref6 = data === null || data === void 0 ? void 0 : data.labelForRememberKennitalaCheckbox) !== null && ref6 !== void 0 ? ref6 : "Muna kennit\xf6lu",
                                                smallBox: true,
                                                onChange: handleCheckboxChange
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                "aria-label": (ref7 = data === null || data === void 0 ? void 0 : data.labelForAssistanceWithElectronicIdLink) !== null && ref7 !== void 0 ? ref7 : "\xdearftu a\xf0sto\xf0 me\xf0 rafr\xe6n skilr\xedki?",
                                                href: "https://www.skilriki.is/",
                                                rel: "noreferrer",
                                                target: "_blank",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(component_typography_src/* EyebrowSmall */.xA, {
                                                    children: (ref8 = data === null || data === void 0 ? void 0 : data.labelForAssistanceWithElectronicIdLink) !== null && ref8 !== void 0 ? ref8 : "A\xf0sto\xf0 me\xf0 rafr\xe6n skilr\xedki?"
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Buttons, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(component_buttons_src/* Button */.zx, {
                                        buttonColor: "blueButton",
                                        disabled: formik.isSubmitting,
                                        icon: lib_icons_src.LongArrowSideIcons,
                                        label: (ref9 = data === null || data === void 0 ? void 0 : data.labelForLoginButton) !== null && ref9 !== void 0 ? ref9 : "Innskr\xe1",
                                        stretch: true,
                                        type: "submit"
                                    }),
                                    showAsGuestOption && /*#__PURE__*/ (0,jsx_runtime.jsx)(component_buttons_src/* Button */.zx, {
                                        buttonColor: "whiteButton",
                                        icon: lib_icons_src.LongArrowRightIcons,
                                        label: "Halda \xe1fram sem gestur",
                                        stretch: true,
                                        type: "submit",
                                        onClick: handleSetPrefersAnonymousCheckout
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(component_alert_src/* Alert */.b, {
                                        alertType: "warning",
                                        showSuccess: showSuccess,
                                        stretch: true,
                                        text: loginError || "Eitthva\xf0 f\xf3r \xfarskei\xf0is",
                                        top: "20"
                                    })
                                ]
                            })
                        ]
                    })
                })
            })
        })
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-component-login-virtual-81673191b3/1/packages/component-login/src/component/login-form/index.ts


;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-component-login-virtual-81673191b3/1/packages/component-login/src/component/welcome/styles.ts
function welcome_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function welcome_styles_templateObject() {
    const data = welcome_styles_taggedTemplateLiteral([
        "\n  display: grid;\n  height: 100%;\n  justify-content: space-between;\n  padding-bottom: 40px;\n  margin-top: 40px;\n  grid-template-rows: 1fr auto;\n"
    ]);
    welcome_styles_templateObject = function() {
        return data;
    };
    return data;
}
function welcome_styles_templateObject1() {
    const data = welcome_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  height: 100%;\n  flex-direction: column;\n  gap: 16px;\n"
    ]);
    welcome_styles_templateObject1 = function() {
        return data;
    };
    return data;
}

const welcome_styles_Container = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-d15fdda-0"
})(welcome_styles_templateObject());
const styles_TextContainer = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-d15fdda-1"
})(welcome_styles_templateObject1());

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-component-login-virtual-81673191b3/1/packages/component-login/src/component/welcome/welcome.tsx











const Welcome = (param)=>{
    let { userName  } = param;
    const setBlockClose = (0,lib_recoil_src/* useSetRecoilState */.Zl)(src/* blockDrawerClickOutsideState */.tp);
    const setOpen = (0,lib_recoil_src/* useSetRecoilState */.Zl)(src/* drawerState */.Z$);
    const { finalizeOnboarding  } = (0,hooks_auth_next_src/* useAuth */.aC)();
    const handleClose = (0,react.useCallback)(()=>{
        finalizeOnboarding();
        setBlockClose(false);
        setOpen(false);
        window.location.reload();
    }, [
        finalizeOnboarding,
        setBlockClose,
        setOpen
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(welcome_styles_Container, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles_TextContainer, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(component_typography_src.H6, {
                        children: [
                            "H\xe6 ",
                            userName
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(component_typography_src/* PLarge */.cG, {
                        textColor: lib_styles_src/* theme.palette.blue.dark */.rS.palette.blue.dark,
                        children: "A\xf0gangur hefur veri\xf0 stofna\xf0ur fyrir \xfeig. \xde\xfa getur n\xfa versla\xf0 \xe1 vefnum \xe1 \xfe\xednum kj\xf6rum og s\xe9\xf0 um stillingar fyrir \xfeinn reikning. \xc1 Mitt BYKO er h\xe6gt a\xf0 n\xe1lgast yfirlit yfir \xf6ll \xfe\xedn vi\xf0skipti."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(component_typography_src/* PLarge */.cG, {
                        textColor: lib_styles_src/* theme.palette.blue.dark */.rS.palette.blue.dark,
                        children: "Takk fyrir a\xf0 velja BYKO."
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(component_buttons_src/* Button */.zx, {
                buttonColor: "blueButton",
                icon: lib_icons_src.LongArrowSideIcons,
                label: "Loka",
                stretch: true,
                onClick: handleClose
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-component-login-virtual-81673191b3/1/packages/component-login/src/component/welcome/index.ts


;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-component-login-virtual-81673191b3/1/packages/component-login/src/component/guest/styles.ts
function guest_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function guest_styles_templateObject() {
    const data = guest_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  height: 100%;\n  flex-direction: column;\n  margin-top: 40px;\n"
    ]);
    guest_styles_templateObject = function() {
        return data;
    };
    return data;
}
function guest_styles_templateObject1() {
    const data = guest_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  height: 100%;\n  flex-direction: column;\n  justify-content: center;\n  gap: 16px;\n"
    ]);
    guest_styles_templateObject1 = function() {
        return data;
    };
    return data;
}

const guest_styles_Container = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-60249531-0"
})(guest_styles_templateObject());
const guest_styles_TextContainer = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-60249531-1"
})(guest_styles_templateObject1());

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-component-login-virtual-81673191b3/1/packages/component-login/src/component/guest/guest.tsx









const Guest = ()=>{
    const navigate = useNavigate();
    const handleClick = useCallback(()=>{
        navigate("/");
    }, [
        navigate
    ]);
    return /*#__PURE__*/ _jsxs(Container, {
        children: [
            /*#__PURE__*/ _jsxs(TextContainer, {
                children: [
                    /*#__PURE__*/ _jsx(H6, {
                        children: "Ertu viss um a\xf0 \xfe\xfa viljir halda \xe1fram sem gestur?"
                    }),
                    /*#__PURE__*/ _jsx(PLarge, {
                        textColor: theme.palette.blue.dark,
                        children: "Gestir f\xe1 ekki a\xf0gang a\xf0 afsl\xe1ttum, hinu \xfeessu og \xf6llu \xf6\xf0ru sem vi\xf0 h\xf6fum upp \xe1 a\xf0 bj\xf3\xf0a. Vinstamlegast sta\xf0festu a\xf0 \xfe\xfa viljir halda \xe1fram sem gestur."
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(Button, {
                buttonColor: "blueButton",
                icon: LongArrowSideIcons,
                label: "J\xe1 halda \xe1fram",
                stretch: true,
                onClick: handleClick
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-component-login-virtual-81673191b3/1/packages/component-login/src/component/guest/index.ts


;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-component-login-virtual-81673191b3/1/packages/component-login/src/component/index.ts







;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-component-login-virtual-81673191b3/1/packages/component-login/src/login-state.ts

const loginStateStore = (0,lib_recoil_src/* atom */.cn)({
    key: "login-component-login=state",
    default: null
});
const useLoginStateStore = ()=>(0,lib_recoil_src/* useRecoilValue */.sJ)(loginStateStore);
const useSetLoginStateStore = ()=>(0,lib_recoil_src/* useSetRecoilState */.Zl)(loginStateStore);

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-component-login-virtual-81673191b3/1/packages/component-login/src/styles.ts
function src_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function src_styles_templateObject() {
    const data = src_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  width: 100%;\n  max-height: 200px;\n  align-items: center;\n  justify-content: flex-start;\n  gap: 20px;\n  button {\n    width: 100%;\n    max-width: 120px;\n  }\n  @media screen and (max-width: ",
        "px) {\n    gap: 20px;\n  }\n  @media screen and (max-width: ",
        "px) {\n    max-height: 120px;\n    flex-direction: column;\n    align-items: flex-start;\n\n    button {\n      margin-bottom: 0px;\n    }\n  }\n"
    ]);
    src_styles_templateObject = function() {
        return data;
    };
    return data;
}
function src_styles_templateObject1() {
    const data = src_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  width: 100%;\n  align-items: center;\n  justify-content: space-between;\n"
    ]);
    src_styles_templateObject1 = function() {
        return data;
    };
    return data;
}
function src_styles_templateObject2() {
    const data = src_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  height: 100%;\n  flex-direction: column;\n  justify-content: space-between;\n"
    ]);
    src_styles_templateObject2 = function() {
        return data;
    };
    return data;
}
function src_styles_templateObject3() {
    const data = src_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  height: 100%;\n  flex-direction: column;\n  justify-content: space-between;\n"
    ]);
    src_styles_templateObject3 = function() {
        return data;
    };
    return data;
}


const StepContainer = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-3e97626f-0"
})(src_styles_templateObject(), lib_styles_src/* gridTheme.container.maxWidth.sm */.k.container.maxWidth.sm, lib_styles_src/* gridTheme.container.maxWidth.s */.k.container.maxWidth.s);
const StepWrapper = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-3e97626f-1"
})(src_styles_templateObject1());
const LoginStepsContainer = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-3e97626f-2"
})(src_styles_templateObject2());
const IconStepContent = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-3e97626f-3"
})(src_styles_templateObject3());

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-component-login-virtual-81673191b3/1/packages/component-login/src/login-steps.tsx


















const LoginSteps = ()=>{
    const setBlockClose = (0,lib_recoil_src/* useSetRecoilState */.Zl)(src/* blockDrawerClickOutsideState */.tp);
    const [steps, setSteps] = (0,lib_recoil_src/* useRecoilState */.FV)(loginState);
    const landingPage = (0,types_utils_src/* isSSR */.yF)() ? false : window.location.pathname === "/";
    const setOpen = (0,lib_recoil_src/* useSetRecoilState */.Zl)(src/* drawerState */.Z$);
    const isDrawerLoading = (0,lib_recoil_src/* useRecoilValue */.sJ)(src/* drawerStateLoading */.tl);
    const token = (0,types_utils_src/* isSSR */.yF)() ? undefined : localStorage.getItem("token");
    const handleSetLoginState = useSetLoginStateStore();
    const currentLoginState = useLoginStateStore();
    const { user , memberships , registrationStatus , isMembershipStateSet , requestSwitchAccount  } = (0,hooks_auth_next_src/* useAuth */.aC)();
    const _isOpen = (0,react.useMemo)(()=>{
        if (!user) {
            return true;
        }
        if (memberships.length === 1 && !registrationStatus.acceptedTerms || !registrationStatus.registeredEmail || registrationStatus.isOnboarding) {
            return true;
        }
        if (registrationStatus.hasInvite) {
            return true;
        }
        if (memberships.length > 1 && !isDrawerLoading) {
            return !isMembershipStateSet;
        }
        return false;
    }, [
        isDrawerLoading,
        isMembershipStateSet,
        memberships.length,
        registrationStatus.acceptedTerms,
        registrationStatus.hasInvite,
        registrationStatus.isOnboarding,
        registrationStatus.registeredEmail,
        user
    ]);
    const isOpen = (0,react.useDeferredValue)(_isOpen);
    (0,react.useEffect)(()=>{
        if (currentLoginState === null && !isOpen) {
            return;
        }
        handleSetLoginState(isOpen ? "in-progress" : "finished");
        if (!isOpen) {
            setOpen(false);
        }
    }, [
        currentLoginState,
        handleSetLoginState,
        isOpen,
        setOpen
    ]);
    (0,react.useEffect)(()=>{
        if (!registrationStatus.acceptedTerms) {
            setBlockClose(user != null);
            setSteps(LoginStepState.terms);
        } else if (!registrationStatus.registeredEmail) {
            setBlockClose(true);
            setSteps(LoginStepState.email);
        } else if (registrationStatus.isOnboarding) {
            setBlockClose(true);
            setSteps(LoginStepState.email);
        } else if (requestSwitchAccount) {
            setBlockClose(false);
            setOpen(true);
        } else if (registrationStatus.hasInvite) {
            setBlockClose(false);
            setOpen(true);
        } else if (memberships.length > 1 && !isMembershipStateSet && !isDrawerLoading) {
            setBlockClose(false);
            setOpen(true);
        } else {
            setBlockClose(false);
            setOpen(false);
        }
    }, [
        landingPage,
        isMembershipStateSet,
        memberships.length,
        registrationStatus,
        registrationStatus.acceptedTerms,
        registrationStatus.isOnboarding,
        registrationStatus.registeredEmail,
        setOpen,
        setSteps,
        token,
        user,
        isDrawerLoading,
        requestSwitchAccount,
        setBlockClose
    ]);
    if (!user) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(LoginForm, {});
    }
    if (memberships.length === 1 && !registrationStatus.acceptedTerms || !registrationStatus.registeredEmail || registrationStatus.isOnboarding) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(LoginStepsContainer, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(StepContainer, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StepWrapper, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(component_icon_steps_src/* IconStep */.t, {
                                currentstep: steps === LoginStepState.terms,
                                icon: lib_icons_src.CheckmarkIcons,
                                isfulfilled: true,
                                label: "",
                                noConnectorLine: true
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(component_icon_steps_src/* IconStep */.t, {
                                currentstep: steps === LoginStepState.email,
                                icon: lib_icons_src.CheckmarkIcons,
                                isfulfilled: steps === LoginStepState.email && registrationStatus.acceptedTerms || steps === LoginStepState.welcome && registrationStatus.acceptedTerms,
                                label: ""
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(component_icon_steps_src/* IconStep */.t, {
                                currentstep: steps === LoginStepState.welcome,
                                icon: lib_icons_src.CheckmarkIcons,
                                isfulfilled: steps === LoginStepState.welcome,
                                label: ""
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(IconStepContent, {
                    children: [
                        steps === LoginStepState.terms && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Terms, {})
                        }),
                        steps === LoginStepState.email && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Email, {})
                        }),
                        steps === LoginStepState.welcome && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Welcome, {
                                userName: user === null || user === void 0 ? void 0 : user.firstName
                            })
                        })
                    ]
                })
            ]
        });
    }
    if (registrationStatus.hasInvite) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(HandleInvitation, {
            userName: user === null || user === void 0 ? void 0 : user.firstName
        });
    }
    if (requestSwitchAccount || memberships.length > 1 && !isMembershipStateSet && !isDrawerLoading) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(AccountPicker, {});
    }
    return null;
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-component-login-virtual-81673191b3/1/packages/component-login/src/index.ts




/***/ }),

/***/ 15066:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "P": function() { return /* reexport */ OpeningHourCard; }
});

// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(61261);
// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(91987);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-component-typography-virtual-537720fdd1/1/packages/component-typography/src/index.ts + 2 modules
var src = __webpack_require__(91371);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-lib-icons-virtual-412b14e947/1/packages/lib-icons/src/index.ts + 181 modules
var lib_icons_src = __webpack_require__(45628);
// EXTERNAL MODULE: ../../.yarn/__virtual__/styled-components-virtual-29066d9421/0/cache/styled-components-npm-5.3.5-88e3937b59-05a664dfe4.zip/node_modules/styled-components/dist/styled-components.browser.cjs.js
var styled_components_browser_cjs = __webpack_require__(33982);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-lib-styles-virtual-b3f1d479f2/1/packages/lib-styles/src/index.ts + 18 modules
var lib_styles_src = __webpack_require__(52203);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-component-opening-hour-card-virtual-3bb15a4b9e/1/packages/component-opening-hour-card/src/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    const data = _taggedTemplateLiteral([
        "\n  display: flex;\n  min-width: 420px;\n  flex: calc(33.33% - 20px);\n  padding: 20px;\n  background-color: ",
        ";\n  gap: 20px;\n  :last-child {\n    max-width: calc(33.33% - 10px);\n  }\n  @media screen and (max-width: ",
        "px) {\n    width: 100%;\n    min-width: unset;\n    max-width: unset;\n    flex: calc(50% - 20px);\n    :last-child {\n      max-width: unset;\n    }\n  }\n  @media screen and (max-width: 1066px) {\n    flex-direction: column;\n  }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _taggedTemplateLiteral([
        "\n  display: flex;\n  width: 50%;\n  height: 100%;\n  flex-direction: column;\n  @media screen and (max-width: 1066px) {\n    width: 100%;\n  }\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  h6 {\n    color: ",
        ";\n  }\n  p {\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = _taggedTemplateLiteral([
        "\n  display: flex;\n  width: fit-content;\n  align-items: baseline;\n  gap: 10px;\n  p {\n    color: ",
        ";\n  }\n  svg {\n    transform: translateY(4px);\n    path {\n      stroke: ",
        ";\n    }\n  }\n"
    ]);
    _templateObject3 = function() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = _taggedTemplateLiteral([
        "\n  display: flex;\n  width: 40%;\n  flex-direction: column;\n  @media screen and (max-width: 1066px) {\n    width: 100%;\n  }\n"
    ]);
    _templateObject4 = function() {
        return data;
    };
    return data;
}
function _templateObject5() {
    const data = _taggedTemplateLiteral([
        "\n  display: flex;\n  width: 100%;\n  justify-content: space-between;\n  gap: 8px;\n  p {\n    color: ",
        ";\n    white-space: nowrap;\n  }\n"
    ]);
    _templateObject5 = function() {
        return data;
    };
    return data;
}


const CardContainer = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-152a8c88-0"
})(_templateObject(), lib_styles_src/* theme.palette.gray.5 */.rS.palette.gray[5], lib_styles_src/* gridTheme.breakpoints.s */.k.breakpoints.s);
const StoreInfoWrapper = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-152a8c88-1"
})(_templateObject1());
const StoreName = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-152a8c88-2"
})(_templateObject2(), lib_styles_src/* theme.palette.blue.dark */.rS.palette.blue.dark, lib_styles_src/* theme.palette.blue.dark */.rS.palette.blue.dark);
const Location = styled_components_browser_cjs["default"].a.withConfig({
    componentId: "sc-152a8c88-3"
})(_templateObject3(), lib_styles_src/* theme.palette.blue.dark */.rS.palette.blue.dark, lib_styles_src/* theme.palette.blue.dark */.rS.palette.blue.dark);
const StoreOpeningInfo = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-152a8c88-4"
})(_templateObject4());
const OpeningDetail = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-152a8c88-5"
})(_templateObject5(), lib_styles_src/* theme.palette.gray.90 */.rS.palette.gray[90]);

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-component-opening-hour-card-virtual-3bb15a4b9e/1/packages/component-opening-hour-card/src/opening-hour-card.tsx





const OpeningHourCard = (param)=>{
    let { id , openingTime , storeLocation , storeName , storeType  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardContainer, {
        className: "opening-hours-card",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StoreInfoWrapper, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(StoreName, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(src.H6, {
                                maxFontSize: "24px",
                                uppercase: true,
                                children: storeName
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* Subtitle */.QE, {
                                children: storeType
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Location, {
                        href: "http://maps.google.com/?q=BYKO ".concat(storeLocation),
                        rel: "noreferrer",
                        target: "_blank",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(lib_icons_src.LocationIcons, {
                                size: 20
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* Subtitle */.QE, {
                                children: storeLocation
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StoreOpeningInfo, {
                children: openingTime.map((item)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)(OpeningDetail, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* PMedium */.aW, {
                                children: item.dateName
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* PMedium */.aW, {
                                children: item.dateOpeningHours
                            })
                        ]
                    }, item.id))
            })
        ]
    }, id);
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-component-opening-hour-card-virtual-3bb15a4b9e/1/packages/component-opening-hour-card/src/index.ts



/***/ }),

/***/ 53000:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "_": function() { return /* reexport */ PageContainer; },
  "J": function() { return /* reexport */ PageContent; }
});

// EXTERNAL MODULE: ../../.yarn/__virtual__/styled-components-virtual-29066d9421/0/cache/styled-components-npm-5.3.5-88e3937b59-05a664dfe4.zip/node_modules/styled-components/dist/styled-components.browser.cjs.js
var styled_components_browser_cjs = __webpack_require__(33982);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-lib-styles-virtual-b3f1d479f2/1/packages/lib-styles/src/index.ts + 18 modules
var src = __webpack_require__(52203);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-component-page-container-virtual-6ffaf0ab98/1/packages/component-page-container/src/page-container.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    const data = _taggedTemplateLiteral([
        "\n  position: relative;\n  min-height: calc(100vh - 522px);\n  margin-bottom: 158px;\n  @media screen and (max-width: 1078px) {\n    margin-top: 24px;\n    margin-bottom: 56px;\n  }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _taggedTemplateLiteral([
        "\n  display: flex;\n  width: 100%;\n  min-width: 0;\n  flex-direction: ",
        ";\n  justify-content: ",
        ";\n  background-color: ",
        ";\n\n  @media screen and (min-width: ",
        "px) and (max-width: ",
        "px) {\n    padding-top: ",
        ";\n    padding-right: ",
        ";\n    padding-left: ",
        ";\n  }\n\n  @media screen and (min-width: ",
        "px) and (max-width: ",
        "px) {\n    padding-top: ",
        ";\n    padding-right: ",
        ";\n    padding-left: ",
        ";\n  }\n\n  @media screen and (min-width: ",
        "px) and (max-width: ",
        "px) {\n    padding-top: ",
        ";\n    padding-right: ",
        ";\n    padding-left: ",
        ";\n  }\n\n  @media screen and (min-width: ",
        "px) and (max-width: ",
        "px) {\n    padding-top: ",
        ";\n    padding-right: ",
        ";\n    padding-left: ",
        ";\n  }\n\n  @media screen and (min-width: ",
        "px) and (max-width: ",
        "px) {\n    padding-top: ",
        ";\n    padding-right: ",
        ";\n    padding-left: ",
        ";\n  }\n\n  @media screen and (min-width: ",
        "px) and (max-width: ",
        "px) {\n    padding-top: ",
        ";\n    padding-right: ",
        ";\n    padding-left: ",
        ";\n  }\n\n  @media screen and (min-width: ",
        "px) and (max-width: ",
        "px) {\n    padding-top: ",
        ";\n    padding-right: ",
        ";\n    padding-left: ",
        ";\n  }\n\n  @media screen and (min-width: ",
        "px) {\n    padding-top: ",
        ";\n    padding-right: ",
        ";\n    padding-left: ",
        ";\n  }\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}


const PageContent = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-81c781d3-0"
})(_templateObject());
const PageContainer = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-81c781d3-1"
})(_templateObject1(), (props)=>props.flexDirection === "column" ? "column" : "row", (props)=>{
    return (props === null || props === void 0 ? void 0 : props.justifyContent) || "space-between";
}, (props)=>props.backgroundColor ? props.backgroundColor : "transparent", src/* gridTheme.container.minWidth.xs */.k.container.minWidth.xs, src/* gridTheme.container.maxWidth.xs */.k.container.maxWidth.xs, (props)=>props.offsetNav ? "".concat(src/* gridTheme.container.navHeight.xs */.k.container.navHeight.xs, "px") : "initial", (props)=>props.noGutter || props.noGutterRight ? "0" : "24px", (props)=>props.noGutter || props.noGutterLeft ? "0" : "24px", src/* gridTheme.container.minWidth.s */.k.container.minWidth.s, src/* gridTheme.container.maxWidth.s */.k.container.maxWidth.s, (props)=>props.offsetNav ? "".concat(src/* gridTheme.container.navHeight.xs */.k.container.navHeight.xs, "px") : "initial", (props)=>props.noGutter || props.noGutterRight ? "0" : "24px", (props)=>props.noGutter || props.noGutterLeft ? "0" : "24px", src/* gridTheme.container.minWidth.sm */.k.container.minWidth.sm, src/* gridTheme.container.maxWidth.sm */.k.container.maxWidth.sm, (props)=>props.offsetNav ? "".concat(src/* gridTheme.container.navHeight.sm */.k.container.navHeight.sm, "px") : "initial", (props)=>props.noGutter || props.noGutterRight ? "0" : "48px", (props)=>props.noGutter || props.noGutterLeft ? "0" : "48px", src/* gridTheme.container.minWidth.m */.k.container.minWidth.m, src/* gridTheme.container.maxWidth.m */.k.container.maxWidth.m, (props)=>props.offsetNav ? "".concat(src/* gridTheme.container.navHeight.md */.k.container.navHeight.md, "px") : "initial", (props)=>props.noGutter || props.noGutterRight ? "0" : "48px", (props)=>props.noGutter || props.noGutterLeft ? "0" : "48px", src/* gridTheme.container.minWidth.mm */.k.container.minWidth.mm, src/* gridTheme.container.maxWidth.mm */.k.container.maxWidth.mm, (props)=>props.offsetNav ? "".concat(src/* gridTheme.container.navHeight.md */.k.container.navHeight.md, "px") : "initial", (props)=>props.noGutter || props.noGutterRight ? "0" : "48px", (props)=>props.noGutter || props.noGutterLeft ? "0" : "48px", src/* gridTheme.container.minWidth.md */.k.container.minWidth.md, src/* gridTheme.container.maxWidth.md */.k.container.maxWidth.md, (props)=>props.offsetNav ? "".concat(src/* gridTheme.container.navHeight.md */.k.container.navHeight.md, "px") : "initial", (props)=>props.noGutter || props.noGutterRight ? "0" : "56px", (props)=>props.noGutter || props.noGutterLeft ? "0" : "56px", src/* gridTheme.container.minWidth.lg */.k.container.minWidth.lg, src/* gridTheme.container.maxWidth.lg */.k.container.maxWidth.lg, (props)=>props.offsetNav ? "".concat(src/* gridTheme.container.navHeight.lg */.k.container.navHeight.lg, "px") : "initial", (props)=>props.noGutter || props.noGutterRight ? "0" : "calc(56px + 5vw)", (props)=>props.noGutter || props.noGutterLeft ? "0" : "calc(56px + 5vw)", src/* gridTheme.container.minWidth.xl */.k.container.minWidth.xl, (props)=>props.offsetNav ? "".concat(src/* gridTheme.container.navHeight.xl */.k.container.navHeight.xl, "px") : "initial", (props)=>props.noGutter || props.noGutterRight ? "0" : "calc(56px + 5vw)", (props)=>props.noGutter || props.noGutterLeft ? "0" : "calc(56px + 5vw)");

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-component-page-container-virtual-6ffaf0ab98/1/packages/component-page-container/src/index.ts



/***/ }),

/***/ 48753:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "t": function() { return /* reexport */ Pagination; }
});

// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(61261);
// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(91987);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-component-buttons-virtual-1a577fdc8c/1/packages/component-buttons/src/index.ts + 16 modules
var src = __webpack_require__(80620);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-lib-icons-virtual-412b14e947/1/packages/lib-icons/src/index.ts + 181 modules
var lib_icons_src = __webpack_require__(45628);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-lib-styles-virtual-b3f1d479f2/1/packages/lib-styles/src/index.ts + 18 modules
var lib_styles_src = __webpack_require__(52203);
// EXTERNAL MODULE: ../../.yarn/__virtual__/styled-components-virtual-29066d9421/0/cache/styled-components-npm-5.3.5-88e3937b59-05a664dfe4.zip/node_modules/styled-components/dist/styled-components.browser.cjs.js
var styled_components_browser_cjs = __webpack_require__(33982);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-component-pagination-virtual-3039b6f680/1/packages/component-pagination/src/components/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    const data = _taggedTemplateLiteral([
        "\n  @media screen and (max-width: ",
        "px) {\n    * {\n      transition: 0ms;\n    }\n    p {\n      font-size: 14px;\n    }\n  }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}


const Container = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-dfba01e6-0"
})(_templateObject(), lib_styles_src/* gridTheme.breakpoints.s */.k.breakpoints.s);

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-component-pagination-virtual-3039b6f680/1/packages/component-pagination/src/components/pagination-button.tsx





const PaginationButton = (param)=>{
    let { index , setPage , variant , aria  } = param;
    const { activeBreakPoint  } = (0,lib_styles_src/* useWindowSize */.iP)();
    const handleClick = (0,react.useCallback)(()=>{
        setPage(index);
    }, [
        index,
        setPage
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* NumericButton */.Wu, {
            ariaLabel: aria,
            buttonColor: variant,
            number: index + 1,
            small: [
                "s",
                "xs"
            ].includes(activeBreakPoint),
            onClick: handleClick
        })
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-component-pagination-virtual-3039b6f680/1/packages/component-pagination/src/components/index.ts


;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-component-pagination-virtual-3039b6f680/1/packages/component-pagination/src/styles.ts
function styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function styles_templateObject() {
    const data = styles_taggedTemplateLiteral([
        "\n  display: flex;\n  width: 100%;\n  align-items: center;\n  justify-content: center;\n  margin-top: 80px;\n"
    ]);
    styles_templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = styles_taggedTemplateLiteral([
        "\n  display: flex;\n  width: 100%;\n  align-items: center;\n  justify-content: ",
        ";\n  p {\n    user-select: none;\n  }\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}

const PaginationContainer = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-d6599040-0"
})(styles_templateObject());
const Wrapper = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-d6599040-1"
})(_templateObject1(), (props)=>props.align);

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-component-pagination-virtual-3039b6f680/1/packages/component-pagination/src/pagination.tsx







const Pagination = (param)=>{
    let { setPageIndex , pageIndex , totalPages , align  } = param;
    const { activeBreakPoint  } = (0,lib_styles_src/* useWindowSize */.iP)();
    const goToIndex = (0,react.useCallback)((index)=>{
        setPageIndex(index);
    }, [
        setPageIndex
    ]);
    const prevPage = (0,react.useCallback)(()=>{
        setPageIndex(pageIndex - 1);
    }, [
        setPageIndex,
        pageIndex
    ]);
    const nextPage = (0,react.useCallback)(()=>{
        if (pageIndex + 1 < totalPages) {
            setPageIndex(pageIndex + 1);
        }
    }, [
        pageIndex,
        setPageIndex,
        totalPages
    ]);
    if (totalPages <= 1) return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(PaginationContainer, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, {
            align: align !== null && align !== void 0 ? align : "center",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* IconButton */.hU, {
                    ariaLabel: "Til baka",
                    disabled: pageIndex === 0,
                    icon: lib_icons_src.ArrowLeftIcons,
                    small: [
                        "s",
                        "xs"
                    ].includes(activeBreakPoint),
                    onClick: prevPage
                }),
                pageIndex >= 2 && /*#__PURE__*/ (0,jsx_runtime.jsx)(PaginationButton, {
                    aria: "fara \xe1 fyrstu s\xed\xf0u",
                    index: 0,
                    setPage: goToIndex,
                    variant: "whiteButton"
                }),
                pageIndex > 2 && /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* IconButton */.hU, {
                    ariaLabel: "skraut",
                    buttonColor: "blueButton",
                    disabled: true,
                    icon: lib_icons_src.DotsIcons,
                    small: [
                        "s",
                        "xs"
                    ].includes(activeBreakPoint)
                }),
                [
                    ...Array(totalPages).keys()
                ].map((pageNumber)=>{
                    if (pageNumber - pageIndex <= ([
                        "xs"
                    ].includes(activeBreakPoint) ? 0 : 1) && pageNumber - pageIndex >= ([
                        "xs"
                    ].includes(activeBreakPoint) ? 0 : -1)) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(PaginationButton, {
                            aria: "fara \xe1 s\xed\xf0u ".concat(pageNumber + 1),
                            index: pageNumber,
                            setPage: goToIndex,
                            variant: pageIndex === pageNumber ? "blueButton" : "whiteButton"
                        }, pageNumber);
                    } else {
                        return null;
                    }
                }),
                pageIndex + 3 < totalPages && /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* IconButton */.hU, {
                    ariaLabel: "skraut",
                    buttonColor: "blueButton",
                    disabled: true,
                    icon: lib_icons_src.DotsIcons,
                    small: [
                        "s",
                        "xs"
                    ].includes(activeBreakPoint)
                }),
                pageIndex + 3 <= totalPages && /*#__PURE__*/ (0,jsx_runtime.jsx)(PaginationButton, {
                    aria: "fara \xe1 seinustu s\xed\xf0u",
                    index: totalPages - 1,
                    setPage: goToIndex,
                    variant: "whiteButton"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* IconButton */.hU, {
                    ariaLabel: "\xc1fram",
                    disabled: pageIndex === totalPages - 1,
                    icon: lib_icons_src.ArrowRightIcons,
                    small: [
                        "s",
                        "xs"
                    ].includes(activeBreakPoint),
                    onClick: nextPage
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-component-pagination-virtual-3039b6f680/1/packages/component-pagination/src/index.ts



/***/ }),

/***/ 64549:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "yM": function() { return /* reexport */ ProductCustomCard; },
  "MS": function() { return /* reexport */ ProductDisplayCard; },
  "Md": function() { return /* reexport */ ProductLimitedCard; },
  "iJ": function() { return /* reexport */ ProductRentCard; },
  "ZL": function() { return /* reexport */ ProductStandardCard; }
});

// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(61261);
// EXTERNAL MODULE: ../../.yarn/__virtual__/next-virtual-cff1f1d108/0/cache/next-npm-13.0.0-0d765f7d5e-7b5c847287.zip/node_modules/next/link.js
var next_link = __webpack_require__(58804);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ../../.yarn/__virtual__/next-virtual-cff1f1d108/0/cache/next-npm-13.0.0-0d765f7d5e-7b5c847287.zip/node_modules/next/router.js
var next_router = __webpack_require__(87347);
// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(91987);
// EXTERNAL MODULE: ../../.yarn/__virtual__/usehooks-ts-virtual-e376d4cf26/0/cache/usehooks-ts-npm-2.9.1-14c625587f-36f1e4142c.zip/node_modules/usehooks-ts/dist/esm/index.js + 36 modules
var esm = __webpack_require__(78420);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-lib-analytics-virtual-863cade9f6/1/packages/lib-analytics/src/index.ts + 2 modules
var src = __webpack_require__(57910);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-lib-utils-virtual-08ae943915/1/packages/lib-utils/src/index.ts + 19 modules
var lib_utils_src = __webpack_require__(65582);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-hooks-cart-virtual-97c767eaa3/1/packages/hooks-cart/src/index.ts + 8 modules
var hooks_cart_src = __webpack_require__(93784);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-lib-api-products-virtual-81752d2989/1/packages/lib-api-products/src/index.ts + 130 modules
var lib_api_products_src = __webpack_require__(68825);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-hooks-product-variants-virtual-3d0a0bb929/1/packages/hooks-product-variants/src/index.ts + 3 modules
var hooks_product_variants_src = __webpack_require__(88596);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-lib-algolia-virtual-7767b18cc0/1/packages/lib-algolia/src/index.ts + 7 modules
var lib_algolia_src = __webpack_require__(5283);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-component-loaders-virtual-61e12a86f6/1/packages/component-loaders/src/index.ts + 7 modules
var component_loaders_src = __webpack_require__(96360);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-component-typography-virtual-537720fdd1/1/packages/component-typography/src/index.ts + 2 modules
var component_typography_src = __webpack_require__(91371);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-lib-styles-virtual-b3f1d479f2/1/packages/lib-styles/src/index.ts + 18 modules
var lib_styles_src = __webpack_require__(52203);
// EXTERNAL MODULE: ../../.yarn/__virtual__/styled-components-virtual-29066d9421/0/cache/styled-components-npm-5.3.5-88e3937b59-05a664dfe4.zip/node_modules/styled-components/dist/styled-components.browser.cjs.js
var styled_components_browser_cjs = __webpack_require__(33982);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-component-product-card-virtual-69967d117c/1/packages/component-product-card/src/components/price-wrapper/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    const data = _taggedTemplateLiteral([
        "\n  display: flex;\n  min-height: 68px;\n  @media screen and (max-width: ",
        "px) {\n    min-height: 88px;\n  }\n\n  flex-direction: column;\n  justify-content: space-between;\n  padding: 10px 16px;\n  gap: 6px;\n  ",
        " {\n    position: relative;\n    text-align: right;\n    @media screen and (max-width: ",
        "px) {\n      text-align: left;\n    }\n\n    &:after {\n      position: absolute;\n      top: 16px;\n      left: 0;\n      width: 100%;\n      height: 1px;\n      background-color: ",
        ';\n      content: "";\n    }\n    @media screen and (max-width: 1300px) {\n      &:after {\n        top: 12px;\n      }\n      font-size: 16px;\n    }\n  }\n  ',
        " {\n    height: 24px;\n    @media screen and (max-width: 1300px) {\n      font-size: 18px;\n    }\n  }\n  @media screen and (max-width: ",
        "px) {\n    padding: 8px 16px;\n    gap: 0;\n  }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _taggedTemplateLiteral([
        "\n  height: 24px;\n  transform: translate3d(-16px, -60%, 0px);\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: ",
        ";\n  justify-content: space-between;\n"
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = _taggedTemplateLiteral([
        "\n  font-size: 16px;\n"
    ]);
    _templateObject3 = function() {
        return data;
    };
    return data;
}



const PriceContainer = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-9a4665c8-0"
})(_templateObject(), lib_styles_src/* gridTheme.container.minWidth.sm */.k.container.minWidth.sm, component_typography_src/* Subtitle */.QE, lib_styles_src/* gridTheme.container.minWidth.sm */.k.container.minWidth.sm, lib_styles_src/* theme.palette.gray.30 */.rS.palette.gray[30], component_typography_src.H6, lib_styles_src/* gridTheme.breakpoints.s */.k.breakpoints.s);
const LoadingWrapper = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-9a4665c8-1"
})(_templateObject1());
const FlexWrapper = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-9a4665c8-2"
})(_templateObject2(), (props)=>props.direction || "row");
const SqmSpan = styled_components_browser_cjs["default"].span.withConfig({
    componentId: "sc-9a4665c8-3"
})(_templateObject3());

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-component-product-card-virtual-69967d117c/1/packages/component-product-card/src/components/price-wrapper/price-wrapper.tsx







const PriceWrapper = (param)=>{
    let { product , prices , activeVariantSKU  } = param;
    const { activeBreakPoint  } = (0,lib_styles_src/* useWindowSize */.iP)();
    const { loadingPrices , mainPrice , previousPrice , isSqmProduct  } = (0,hooks_product_variants_src/* useProductPricing */.Br)(product, prices, activeVariantSKU);
    const notYetAvailable = (0,react.useMemo)(()=>{
        let hasValidPrice = false;
        product.variants.forEach((variant)=>{
            if (variant.price.gross != undefined && variant.price.gross != 0) {
                hasValidPrice = true;
            }
        });
        return !hasValidPrice;
    }, [
        product.variants
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(PriceContainer, {
        children: notYetAvailable ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FlexWrapper, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(component_typography_src.H6, {
                    maxFontSize: "18px",
                    textColor: lib_styles_src/* theme.palette.blue.main */.rS.palette.blue.main,
                    top: 24,
                    children: "Vara v\xe6ntanleg"
                })
            })
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(FlexWrapper, {
                children: [
                    !loadingPrices ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(FlexWrapper, {
                        direction: "column",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(component_typography_src/* EyebrowSmall */.xA, {
                                textColor: lib_styles_src/* theme.palette.gray.60 */.rS.palette.gray[60],
                                children: mainPrice === null || mainPrice === void 0 ? void 0 : mainPrice.label
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(component_typography_src.H6, {
                                maxFontSize: "24px",
                                textColor: lib_styles_src/* theme.palette.blue.main */.rS.palette.blue.main,
                                children: mainPrice && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        mainPrice.price,
                                        " ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SqmSpan, {
                                            children: isSqmProduct ? "/m\xb2" : null
                                        })
                                    ]
                                })
                            }),
                            [
                                "xxs",
                                "xs"
                            ].includes(activeBreakPoint) && previousPrice && /*#__PURE__*/ (0,jsx_runtime.jsxs)(component_typography_src/* Subtitle */.QE, {
                                textColor: lib_styles_src/* theme.palette.gray.30 */.rS.palette.gray[30],
                                children: [
                                    previousPrice.price,
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SqmSpan, {
                                        children: isSqmProduct ? "/m\xb2" : null
                                    })
                                ]
                            })
                        ]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingWrapper, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(component_loaders_src.DotLoader, {
                            size: 84
                        })
                    }),
                    ![
                        "xxs",
                        "xs"
                    ].includes(activeBreakPoint) && previousPrice ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(FlexWrapper, {
                        direction: "column",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(component_typography_src/* EyebrowSmall */.xA, {
                                textColor: lib_styles_src/* theme.palette.gray.60 */.rS.palette.gray[60],
                                children: previousPrice.label
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(component_typography_src/* Subtitle */.QE, {
                                textColor: lib_styles_src/* theme.palette.gray.30 */.rS.palette.gray[30],
                                children: [
                                    previousPrice.price,
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SqmSpan, {
                                        children: isSqmProduct ? "/m\xb2" : null
                                    })
                                ]
                            })
                        ]
                    }) : null
                ]
            })
        })
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-component-product-card-virtual-69967d117c/1/packages/component-product-card/src/components/price-wrapper/index.ts


// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-component-buttons-virtual-1a577fdc8c/1/packages/component-buttons/src/index.ts + 16 modules
var component_buttons_src = __webpack_require__(80620);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-lib-icons-virtual-412b14e947/1/packages/lib-icons/src/index.ts + 181 modules
var lib_icons_src = __webpack_require__(45628);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-component-product-card-virtual-69967d117c/1/packages/component-product-card/src/components/product-card-buttons/styles.ts
function styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function styles_templateObject() {
    const data = styles_taggedTemplateLiteral([
        "\n  position: relative;\n  display: grid;\n  width: 100%;\n  border-top: 1px solid ",
        ";\n  grid-template-columns: 56px auto;\n  @media screen and (max-width: 1078px) {\n    grid-template-columns: 56px auto;\n  }\n  @media screen and (max-width: 698px) {\n    grid-template-columns: 40px auto;\n  }\n  .icon-button {\n    height: 100%;\n    border: none;\n  }\n  .button-container,\n  .add-to-cart-button {\n    width: 100%;\n    border: none;\n  }\n  .add-to-cart-button {\n    cursor: ",
        " !important;\n    pointer-events: ",
        " !important;\n    transition: 300ms !important;\n  }\n"
    ]);
    styles_templateObject = function() {
        return data;
    };
    return data;
}
function styles_templateObject1() {
    const data = styles_taggedTemplateLiteral([
        "\n  width: 100%;\n  padding: 10px;\n  margin: auto;\n  background-color: ",
        ";\n"
    ]);
    styles_templateObject1 = function() {
        return data;
    };
    return data;
}


const ButtonWrapper = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-c721399e-0"
})(styles_templateObject(), lib_styles_src/* theme.palette.gray.10 */.rS.palette.gray[10], (props)=>props.disabledAddToCart ? "wait" : "pointer", (props)=>props.disabledAddToCart ? "none" : "initial");
const LoaderContainer = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-c721399e-1"
})(styles_templateObject1(), lib_styles_src/* theme.palette.blue.dark */.rS.palette.blue.dark);

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-component-product-card-virtual-69967d117c/1/packages/component-product-card/src/components/product-card-buttons/product-card-buttons.tsx







const ProductCardButtons = (param)=>{
    let { onClickProductDetailPage , addToCartClick , disabled , disabledAddToCart , showDetail , outOfStock  } = param;
    const { activeBreakPoint  } = (0,lib_styles_src/* useWindowSize */.iP)();
    const [addingToCart, setAddingToCart] = (0,react.useState)(false);
    const handleClickAddToCart = (0,react.useCallback)(()=>{
        setAddingToCart(true);
        addToCartClick();
    }, [
        addToCartClick
    ]);
    (0,react.useEffect)(()=>{
        if (!disabledAddToCart) {
            setAddingToCart(false);
        }
    }, [
        disabledAddToCart
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ButtonWrapper, {
        className: "swiper-no-swiping",
        disabledAddToCart: disabledAddToCart !== null && disabledAddToCart !== void 0 ? disabledAddToCart : false,
        children: [
            !showDetail ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: addingToCart ? /*#__PURE__*/ (0,jsx_runtime.jsx)(LoaderContainer, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(component_loaders_src.MainLoader, {
                        size: 34
                    })
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(component_buttons_src/* IconButton */.hU, {
                    ariaLabel: "Setja v\xf6ru \xed k\xf6rfu",
                    buttonColor: "blueButton",
                    className: "add-to-cart-button",
                    disabled: addingToCart || outOfStock,
                    icon: lib_icons_src.BagAddIcons,
                    small: false,
                    onClick: handleClickAddToCart
                })
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(component_buttons_src/* Button */.zx, {
                disabled: disabled,
                icon: ![
                    "xs",
                    "xxs"
                ].includes(activeBreakPoint) ? lib_icons_src.LongArrowRightIcons : null,
                label: "Sko\xf0a v\xf6ru",
                stretch: true,
                onClick: onClickProductDetailPage
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-component-product-card-virtual-69967d117c/1/packages/component-product-card/src/components/product-card-buttons/index.ts


;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-component-product-card-virtual-69967d117c/1/packages/component-product-card/src/components/product-card-information/styles.ts
function product_card_information_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function product_card_information_styles_templateObject() {
    const data = product_card_information_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  flex-grow: 1;\n  padding: 16px;\n  @media screen and (max-width: ",
        "px) {\n    padding: 12px 16px;\n  }\n"
    ]);
    product_card_information_styles_templateObject = function() {
        return data;
    };
    return data;
}
function product_card_information_styles_templateObject1() {
    const data = product_card_information_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  width: 100%;\n  justify-content: flex-end;\n"
    ]);
    product_card_information_styles_templateObject1 = function() {
        return data;
    };
    return data;
}
function styles_templateObject2() {
    const data = product_card_information_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  width: 100%;\n  justify-content: space-between;\n  @media screen and (max-width: ",
        "px) {\n    justify-content: flex-start;\n  }\n"
    ]);
    styles_templateObject2 = function() {
        return data;
    };
    return data;
}
function styles_templateObject3() {
    const data = product_card_information_styles_taggedTemplateLiteral([
        "\n  position: relative;\n  display: inline-block;\n  width: 50%;\n  max-width: 45%;\n  @media screen and (max-width: ",
        "px) {\n    width: 100%;\n    max-width: 100%;\n  }\n"
    ]);
    styles_templateObject3 = function() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = product_card_information_styles_taggedTemplateLiteral([
        "\n  width: 45%;\n  @media screen and (max-width: ",
        "px) {\n    display: none;\n  }\n"
    ]);
    _templateObject4 = function() {
        return data;
    };
    return data;
}
function _templateObject5() {
    const data = product_card_information_styles_taggedTemplateLiteral([
        "\n  overflow: hidden;\n  flex: 1;\n  color: ",
        ";\n  text-overflow: ellipsis;\n  white-space: nowrap;\n"
    ]);
    _templateObject5 = function() {
        return data;
    };
    return data;
}
function _templateObject6() {
    const data = product_card_information_styles_taggedTemplateLiteral([
        "\n  overflow: hidden;\n  height: 20px;\n  flex: 1;\n  text-align: right;\n  text-overflow: ellipsis;\n  text-transform: uppercase;\n  user-select: all;\n  white-space: nowrap;\n"
    ]);
    _templateObject6 = function() {
        return data;
    };
    return data;
}
function _templateObject7() {
    const data = product_card_information_styles_taggedTemplateLiteral([
        "\n  overflow: hidden;\n  color: ",
        ";\n  font-weight: 400;\n  text-align: left;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  @media screen and (max-width: ",
        "px) {\n    /* stylelint-disable-next-line value-no-vendor-prefix */\n    display: -webkit-box;\n    overflow: hidden;\n    padding: 0;\n    -webkit-box-orient: vertical;\n    font-size: 16px;\n    gap: 8px;\n    -webkit-line-clamp: 3;\n    text-overflow: ellipsis;\n    white-space: normal;\n  }\n"
    ]);
    _templateObject7 = function() {
        return data;
    };
    return data;
}
function _templateObject8() {
    const data = product_card_information_styles_taggedTemplateLiteral([
        "\n  position: relative;\n  display: inline-block;\n  max-width: 100%;\n"
    ]);
    _templateObject8 = function() {
        return data;
    };
    return data;
}
function _templateObject9() {
    const data = product_card_information_styles_taggedTemplateLiteral([
        "\n  overflow: hidden;\n  color: ",
        ";\n  font-size: 16px;\n  font-weight: 400;\n  text-align: left;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  @media screen and (max-width: ",
        "px) {\n    font-size: 14px;\n  }\n  @media screen and (max-width: ",
        "px) {\n    display: none;\n  }\n"
    ]);
    _templateObject9 = function() {
        return data;
    };
    return data;
}
function _templateObject10() {
    const data = product_card_information_styles_taggedTemplateLiteral([
        "\n  height: 25px;\n  margin-top: 8px;\n"
    ]);
    _templateObject10 = function() {
        return data;
    };
    return data;
}
function _templateObject11() {
    const data = product_card_information_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  width: fit-content;\n  height: 100%;\n  align-items: center;\n  background-color: ",
        ";\n  padding-inline: 16px;\n"
    ]);
    _templateObject11 = function() {
        return data;
    };
    return data;
}
function _templateObject12() {
    const data = product_card_information_styles_taggedTemplateLiteral([
        "\n  position: absolute;\n  top: 50%;\n  right: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 2px 4px 1px 4px;\n  border-radius: 4px;\n  margin-right: 10px;\n  background-color: ",
        ";\n  opacity: 0;\n  pointer-events: none;\n  transform: translateY(-50%); /* adjust to align perfectly */\n  transition: opacity 0.3s ease, visibility 0.3s ease;\n  visibility: hidden;\n  white-space: nowrap;\n\n  &::after {\n    position: absolute;\n    top: 50%;\n    left: 100%;\n    width: 0;\n    height: 0;\n    border-top: 4px solid transparent;\n    border-bottom: 4px solid transparent;\n    border-left: 4px solid ",
        ';\n    content: "";\n    transform: translateY(-50%);\n  }\n\n  @media screen and (max-width: 768px) {\n    display: none;\n  }\n'
    ]);
    _templateObject12 = function() {
        return data;
    };
    return data;
}
function _templateObject13() {
    const data = product_card_information_styles_taggedTemplateLiteral([
        "\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n\n  &:hover ",
        " {\n    opacity: 1;\n    visibility: visible;\n  }\n"
    ]);
    _templateObject13 = function() {
        return data;
    };
    return data;
}



const ProdInfoWrapper = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-7076d68c-0"
})(product_card_information_styles_templateObject(), lib_styles_src/* gridTheme.container.maxWidth.s */.k.container.maxWidth.s);
const RightFloatContainer = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-7076d68c-1"
})(product_card_information_styles_templateObject1());
const styles_FlexWrapper = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-7076d68c-2"
})(styles_templateObject2(), lib_styles_src/* gridTheme.container.maxWidth.xs */.k.container.maxWidth.xs);
const BrandContainer = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-7076d68c-3"
})(styles_templateObject3(), lib_styles_src/* gridTheme.container.maxWidth.s */.k.container.maxWidth.s);
const ProductNumberContainer = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-7076d68c-4"
})(_templateObject4(), lib_styles_src/* gridTheme.container.maxWidth.s */.k.container.maxWidth.s);
const BrandName = (0,styled_components_browser_cjs["default"])(component_typography_src/* EyebrowSmall */.xA).withConfig({
    componentId: "sc-7076d68c-5"
})(_templateObject5(), lib_styles_src/* theme.palette.gray.60 */.rS.palette.gray[60]);
const ProductNumber = (0,styled_components_browser_cjs["default"])(component_typography_src/* EyebrowSmall */.xA).withConfig({
    componentId: "sc-7076d68c-6"
})(_templateObject6());
const ProductName = (0,styled_components_browser_cjs["default"])(component_typography_src/* PLargeBold */.ej).withConfig({
    componentId: "sc-7076d68c-7"
})(_templateObject7(), lib_styles_src/* theme.palette.blue.dark */.rS.palette.blue.dark, lib_styles_src/* gridTheme.container.maxWidth.s */.k.container.maxWidth.s);
const HoverLabelContainer = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-7076d68c-8"
})(_templateObject8());
const ShortDecriptionText = (0,styled_components_browser_cjs["default"])(component_typography_src/* PMedium */.aW).withConfig({
    componentId: "sc-7076d68c-9"
})(_templateObject9(), lib_styles_src/* theme.palette.gray.60 */.rS.palette.gray[60], lib_styles_src/* gridTheme.container.maxWidth.s */.k.container.maxWidth.s, lib_styles_src/* gridTheme.container.maxWidth.xs */.k.container.maxWidth.xs);
const EnvironmentalWrapper = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-7076d68c-10"
})(_templateObject10());
const EnvironmentalInner = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-7076d68c-11"
})(_templateObject11(), lib_styles_src/* theme.palette.green.dark */.rS.palette.green.dark);
const HoverLabel = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-7076d68c-12"
})(_templateObject12(), lib_styles_src/* theme.palette.blue.dark */.rS.palette.blue.dark, lib_styles_src/* theme.palette.blue.dark */.rS.palette.blue.dark);
const HoverContainer = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-7076d68c-13"
})(_templateObject13(), HoverLabel);

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-component-product-card-virtual-69967d117c/1/packages/component-product-card/src/components/product-card-information/product-card-information.tsx





const ProductCardInformation = (param)=>{
    let { brand , prodName , sku , shortDecription , addedLabel  } = param;
    const { activeBreakPoint  } = (0,lib_styles_src/* useWindowSize */.iP)();
    const clickToCopy = (0,react.useCallback)((e)=>{
        e.preventDefault();
        if (!sku) {
            return;
        }
        navigator.clipboard.writeText(sku);
    }, [
        sku
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ProdInfoWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles_FlexWrapper, {
                children: [
                    addedLabel && /*#__PURE__*/ (0,jsx_runtime.jsx)(component_typography_src/* EyebrowSmall */.xA, {
                        children: addedLabel
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BrandContainer, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BrandName, {
                            textColor: lib_styles_src/* theme.palette.black.main */.rS.palette.black.main,
                            children: brand
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductNumberContainer, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HoverContainer, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(HoverLabelContainer, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductNumber, {
                                        textColor: lib_styles_src/* theme.palette.gray.60 */.rS.palette.gray[60],
                                        onClick: clickToCopy,
                                        children: sku
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HoverLabel, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(component_typography_src/* EyebrowSmall */.xA, {
                                            textColor: lib_styles_src/* theme.palette.white.main */.rS.palette.white.main,
                                            children: "Afrita v\xf6run\xfamer"
                                        })
                                    })
                                ]
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductName, {
                children: prodName
            }),
            ![
                "xxs",
                "xs"
            ].includes(activeBreakPoint) && /*#__PURE__*/ (0,jsx_runtime.jsx)(ShortDecriptionText, {
                children: shortDecription
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-component-product-card-virtual-69967d117c/1/packages/component-product-card/src/components/product-card-information/index.ts


// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-component-quantity-input-virtual-a245e83f98/1/packages/component-quantity-input/src/index.ts + 8 modules
var component_quantity_input_src = __webpack_require__(75290);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-component-select-virtual-f6511e8fae/1/packages/component-select/src/index.ts + 6 modules
var component_select_src = __webpack_require__(388);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-hooks-auth-next-virtual-a089da2ab7/1/packages/hooks-auth-next/src/index.ts + 14 modules
var hooks_auth_next_src = __webpack_require__(68814);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-lib-api-price-virtual-284954a275/1/packages/lib-api-price/src/index.ts + 2 modules
var lib_api_price_src = __webpack_require__(62681);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-component-product-card-virtual-69967d117c/1/packages/component-product-card/src/components/product-card-open/styles.ts
function product_card_open_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function product_card_open_styles_templateObject() {
    const data = product_card_open_styles_taggedTemplateLiteral([
        "\n  position: absolute;\n  z-index: 100;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  border: 1px solid ",
        ";\n  background-color: ",
        ";\n  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.1);\n  clip-path: inset(-10px -20px -20px 0px);\n  inset: 8px 8px 8px 8px;\n  opacity: ",
        ";\n  pointer-events: ",
        ";\n  transform: ",
        ";\n  transition: 200ms;\n  transition-timing-function: ease-out;\n"
    ]);
    product_card_open_styles_templateObject = function() {
        return data;
    };
    return data;
}
function product_card_open_styles_templateObject1() {
    const data = product_card_open_styles_taggedTemplateLiteral([
        "\n  width: 100%;\n  .select-container {\n    display: flex;\n    flex-direction: column-reverse;\n    border: 1px solid ",
        ";\n    &.first {\n      z-index: 102;\n    }\n    &.second {\n      z-index: 103;\n    }\n    .menu-wrapper {\n      width: 95%;\n      margin-right: auto;\n      margin-bottom: 50px;\n      margin-left: auto;\n      &.open {\n        ul {\n          border: 1px solid ",
        ";\n          box-shadow: none;\n        }\n      }\n    }\n  }\n"
    ]);
    product_card_open_styles_templateObject1 = function() {
        return data;
    };
    return data;
}
function product_card_open_styles_templateObject2() {
    const data = product_card_open_styles_taggedTemplateLiteral([
        "\n  .button-container {\n    border-right: 1px solid ",
        ";\n    border-left: 1px solid ",
        ";\n  }\n  .quantity-input {\n    border: none;\n    border-top: 1px solid ",
        ";\n  }\n  .add-to-cart-button {\n    border: none;\n  }\n"
    ]);
    product_card_open_styles_templateObject2 = function() {
        return data;
    };
    return data;
}
function product_card_open_styles_templateObject3() {
    const data = product_card_open_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  height: 100%;\n  flex-direction: column;\n"
    ]);
    product_card_open_styles_templateObject3 = function() {
        return data;
    };
    return data;
}
function styles_templateObject4() {
    const data = product_card_open_styles_taggedTemplateLiteral([
        "\n  transform: translate3d(8px, -8px, 0px);\n"
    ]);
    styles_templateObject4 = function() {
        return data;
    };
    return data;
}
function styles_templateObject5() {
    const data = product_card_open_styles_taggedTemplateLiteral([
        "\n  display: grid;\n  grid-template-columns: auto 40px;\n"
    ]);
    styles_templateObject5 = function() {
        return data;
    };
    return data;
}
function styles_templateObject6() {
    const data = product_card_open_styles_taggedTemplateLiteral([
        "\n  padding-top: 24px;\n  padding-bottom: 16px;\n  padding-inline: 24px;\n"
    ]);
    styles_templateObject6 = function() {
        return data;
    };
    return data;
}
function styles_templateObject7() {
    const data = product_card_open_styles_taggedTemplateLiteral([
        "\n  position: relative;\n  width: 64px;\n  height: 33px;\n  pointer-events: none;\n  transform: translate3d(-16px, -24px, 0px);\n"
    ]);
    styles_templateObject7 = function() {
        return data;
    };
    return data;
}
function styles_templateObject8() {
    const data = product_card_open_styles_taggedTemplateLiteral([
        "\n  position: relative;\n  display: flex;\n  height: 100%;\n  flex-direction: column;\n  justify-content: flex-end;\n  padding-bottom: 16px;\n  padding-inline: 24px;\n"
    ]);
    styles_templateObject8 = function() {
        return data;
    };
    return data;
}
function styles_templateObject9() {
    const data = product_card_open_styles_taggedTemplateLiteral([
        "\n  max-height: 120px;\n  padding-top: 20px;\n  padding-bottom: 16px;\n  border-bottom: 1px solid ",
        ";\n  overflow-y: auto;\n"
    ]);
    styles_templateObject9 = function() {
        return data;
    };
    return data;
}
function styles_templateObject10() {
    const data = product_card_open_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  padding-top: 16px;\n  gap: 8px;\n\n  li {\n    max-height: 100px;\n    list-style: square;\n    overflow-y: auto;\n    ",
        "\n  }\n"
    ]);
    styles_templateObject10 = function() {
        return data;
    };
    return data;
}
function styles_templateObject11() {
    const data = product_card_open_styles_taggedTemplateLiteral([
        "\n  display: inline-flex;\n  width: 100%;\n  box-sizing: border-box;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  border: 1px solid #ffffff;\n  background-color: ",
        ";\n  gap: 10px;\n  text-align: left;\n"
    ]);
    styles_templateObject11 = function() {
        return data;
    };
    return data;
}




const ProductDetailContainer = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-ca281b8b-0"
})(product_card_open_styles_templateObject(), lib_styles_src/* theme.palette.gray.10 */.rS.palette.gray[10], lib_styles_src/* theme.palette.white.main */.rS.palette.white.main, (props)=>props.show ? "1" : "0", (props)=>props.show ? "initial" : "none", (props)=>props.show ? "translateY(0px)" : "translateY(16px)");
const VariantSelectionOptions = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-ca281b8b-1"
})(product_card_open_styles_templateObject1(), lib_styles_src/* theme.palette.gray.10 */.rS.palette.gray[10], lib_styles_src/* theme.palette.gray.10 */.rS.palette.gray[10]);
const DetailButtonWrapper = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-ca281b8b-2"
})(product_card_open_styles_templateObject2(), lib_styles_src/* theme.palette.white.main */.rS.palette.white.main, lib_styles_src/* theme.palette.white.main */.rS.palette.white.main, lib_styles_src/* theme.palette.gray.10 */.rS.palette.gray[10]);
const ProductInfo = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-ca281b8b-3"
})(product_card_open_styles_templateObject3());
const ButtonContainer = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-ca281b8b-4"
})(styles_templateObject4());
const ProductHead = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-ca281b8b-5"
})(styles_templateObject5());
const ProductDescription = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-ca281b8b-6"
})(styles_templateObject6());
const styles_LoadingWrapper = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-ca281b8b-7"
})(styles_templateObject7());
const VariantPrice = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-ca281b8b-8"
})(styles_templateObject8());
const FullDescription = (0,styled_components_browser_cjs["default"])(component_typography_src/* PSmall */.zK).withConfig({
    componentId: "sc-ca281b8b-9"
})(styles_templateObject9(), lib_styles_src/* theme.palette.gray.10 */.rS.palette.gray[10]);
const DetailList = (0,styled_components_browser_cjs["default"])(component_typography_src/* PSmall */.zK).withConfig({
    componentId: "sc-ca281b8b-10"
})(styles_templateObject10(), (0,lib_styles_src/* scrollStyle */.vh)({
    color: "dark-blue"
}));
const ButtonLoadingWrapper = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-ca281b8b-11"
})(styles_templateObject11(), lib_styles_src/* theme.palette.blue.main */.rS.palette.blue.main);

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-component-product-card-virtual-69967d117c/1/packages/component-product-card/src/components/product-card-open/product-card-open.tsx
















const ProductCardOpen = /*#__PURE__*/ (0,react.forwardRef)((param, ref)=>{
    let { slug , show =false , activeVariantSKU , setActiveVariantSKU , handleClose , onClickProductDetailPage , localPrices , setLocalPrices , isLoading , algoliaInsights  } = param;
    var ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9;
    const [product, setProduct] = (0,react.useState)();
    const { prices  } = (0,lib_api_products_src/* useProductPrices */.gv)(product ? [
        product.id
    ] : []);
    const { sendAddToCartInsights  } = (0,lib_algolia_src/* useAlgoliaInsights */.HX)();
    const { user  } = (0,hooks_auth_next_src/* useAuth */.aC)();
    (0,react.useEffect)(()=>{
        if (prices && product) {
            setLocalPrices(prices);
        }
    });
    (0,react.useEffect)(()=>{
        const fetchProduct = async ()=>{
            if (show) {
                const data = await (0,lib_api_products_src/* productBySlug */.H1)(slug);
                if (data) {
                    setProduct(data);
                }
            }
        };
        fetchProduct();
    }, [
        show,
        slug
    ]);
    const { activeVariant , activeColor , colorSelectionList , sizeSelectionList , activeSize , handleColorChange , handleSizeChange , permitPurchase , errorMessage  } = (0,hooks_product_variants_src/* useProductVariants */.Rk)(product, activeVariantSKU, setActiveVariantSKU, null);
    const price = (0,react.useMemo)(()=>{
        return localPrices === null || localPrices === void 0 ? void 0 : localPrices[activeVariantSKU];
    }, [
        activeVariantSKU,
        localPrices
    ]);
    const productNotAvailableYet = (0,react.useMemo)(()=>{
        return (price === null || price === void 0 ? void 0 : price.price.gross) === 0;
    }, [
        price
    ]);
    const unitLabel = (0,react.useMemo)(()=>{
        if (activeVariant === null || activeVariant === void 0 ? void 0 : activeVariant.meta.unit) {
            return activeVariant === null || activeVariant === void 0 ? void 0 : activeVariant.meta.unit;
        } else {
            var ref;
            var ref1;
            const units = (ref1 = (ref = activeVariant === null || activeVariant === void 0 ? void 0 : activeVariant.meta.unit) === null || ref === void 0 ? void 0 : ref.toString().split(";")) !== null && ref1 !== void 0 ? ref1 : [];
            if (units.length === 0) {
                return "";
            }
            return units[units.length - 1];
        }
    }, [
        activeVariant === null || activeVariant === void 0 ? void 0 : activeVariant.meta.unit
    ]);
    var ref10;
    const currentCount = (0,lib_api_products_src/* useCartItemCount */.PO)((ref10 = activeVariant === null || activeVariant === void 0 ? void 0 : activeVariant.id) !== null && ref10 !== void 0 ? ref10 : null);
    const [count, setCount] = (0,react.useState)(currentCount > 1 ? 1 : currentCount);
    (0,react.useEffect)(()=>{
        if (currentCount <= 0) {
            setCount(1);
            return;
        }
        setCount(currentCount);
    }, [
        currentCount
    ]);
    var ref11;
    const handleItemToString = (0,react.useCallback)((option)=>{
        return (ref11 = option === null || option === void 0 ? void 0 : option.label) !== null && ref11 !== void 0 ? ref11 : "";
    }, []);
    const { setCartQuantity  } = (0,hooks_cart_src/* useCart */.jD)();
    const handleAddToCart = (0,react.useCallback)(()=>{
        if (isNaN(count)) {
            return;
        }
        var ref;
        setCartQuantity({
            variantId: activeVariant === null || activeVariant === void 0 ? void 0 : activeVariant.id,
            slug: (ref = product === null || product === void 0 ? void 0 : product.slug) !== null && ref !== void 0 ? ref : "",
            quantity: count
        });
        sendAddToCartInsights({
            eventName: "Add to Cart",
            queryID: (algoliaInsights === null || algoliaInsights === void 0 ? void 0 : algoliaInsights.queryID) || "",
            index: (algoliaInsights === null || algoliaInsights === void 0 ? void 0 : algoliaInsights.index) || "",
            objectIDs: [
                (activeVariant === null || activeVariant === void 0 ? void 0 : activeVariant.sku) || ""
            ]
        });
    }, [
        activeVariant === null || activeVariant === void 0 ? void 0 : activeVariant.id,
        activeVariant === null || activeVariant === void 0 ? void 0 : activeVariant.sku,
        algoliaInsights === null || algoliaInsights === void 0 ? void 0 : algoliaInsights.index,
        algoliaInsights === null || algoliaInsights === void 0 ? void 0 : algoliaInsights.queryID,
        count,
        product === null || product === void 0 ? void 0 : product.slug,
        sendAddToCartInsights,
        setCartQuantity
    ]);
    if (localPrices == undefined) {
        return null;
    }
    var ref12, ref13;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ProductDetailContainer, {
        ref: ref,
        className: "swiper-no-swiping",
        show: show !== null && show !== void 0 ? show : false,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ProductInfo, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ProductDescription, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ProductHead, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(component_typography_src.H6, {
                                        maxFontSize: "28px",
                                        textColor: lib_styles_src/* theme.palette.blue.dark */.rS.palette.blue.dark,
                                        children: product === null || product === void 0 ? void 0 : product.name
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonContainer, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(component_buttons_src/* IconButton */.hU, {
                                            ariaLabel: "Loka",
                                            buttonColor: "whiteButton",
                                            icon: lib_icons_src.CancelLargeIcons,
                                            small: true,
                                            onClick: handleClose
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FullDescription, {
                                textColor: lib_styles_src/* theme.palette.gray.60 */.rS.palette.gray[60],
                                children: product === null || product === void 0 ? void 0 : product.description
                            })
                        ]
                    }),
                    !errorMessage && productNotAvailableYet ? /*#__PURE__*/ (0,jsx_runtime.jsx)(VariantPrice, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(component_typography_src.H6, {
                            maxFontSize: "18px",
                            textColor: lib_styles_src/* theme.palette.blue.main */.rS.palette.blue.main,
                            children: "Vara v\xe6ntanleg"
                        })
                    }) : null,
                    !errorMessage && !productNotAvailableYet ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(VariantPrice, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(component_typography_src/* EyebrowSmall */.xA, {
                                textColor: lib_styles_src/* theme.palette.gray.60 */.rS.palette.gray[60],
                                children: user ? "MITT VER\xd0" : "VER\xd0"
                            }),
                            ((price === null || price === void 0 ? void 0 : (ref1 = price.discounted) === null || ref1 === void 0 ? void 0 : ref1.gross) || (price === null || price === void 0 ? void 0 : (ref2 = price.price) === null || ref2 === void 0 ? void 0 : ref2.gross)) && /*#__PURE__*/ (0,jsx_runtime.jsx)(component_typography_src.H6, {
                                maxFontSize: "28px",
                                textColor: lib_styles_src/* theme.palette.blue.main */.rS.palette.blue.main,
                                children: (price === null || price === void 0 ? void 0 : (ref3 = price.discounted) === null || ref3 === void 0 ? void 0 : ref3.gross) ? (ref5 = (0,lib_api_price_src/* getPrice */.aS)(price === null || price === void 0 ? void 0 : (ref4 = price.discounted) === null || ref4 === void 0 ? void 0 : ref4.gross)) === null || ref5 === void 0 ? void 0 : ref5.humanReadable : (ref7 = (0,lib_api_price_src/* getPrice */.aS)(price === null || price === void 0 ? void 0 : (ref6 = price.price) === null || ref6 === void 0 ? void 0 : ref6.gross)) === null || ref7 === void 0 ? void 0 : ref7.humanReadable
                            }),
                            (price === null || price === void 0 ? void 0 : (ref8 = price.discounted) === null || ref8 === void 0 ? void 0 : ref8.gross) === undefined && (price === null || price === void 0 ? void 0 : (ref9 = price.price) === null || ref9 === void 0 ? void 0 : ref9.gross) === undefined && /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_LoadingWrapper, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(component_loaders_src.DotLoader, {
                                    size: 84
                                })
                            })
                        ]
                    }) : null,
                    errorMessage ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductDescription, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(component_typography_src/* PMedium */.aW, {
                            textColor: lib_styles_src/* theme.palette.orange.dark */.rS.palette.orange.dark,
                            children: errorMessage
                        })
                    }) : null
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(VariantSelectionOptions, {
                children: [
                    colorSelectionList.length > 1 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(component_select_src/* Select */.P, {
                        align: "left",
                        className: "select-container first",
                        // disableInactive={true} // FIXME
                        fit: true,
                        handleSelectedItemChange: handleColorChange,
                        hideDefaultPlaceholder: true,
                        hideValue: true,
                        items: colorSelectionList,
                        itemToString: handleItemToString,
                        placeholder: (ref12 = activeColor === null || activeColor === void 0 ? void 0 : activeColor.label) !== null && ref12 !== void 0 ? ref12 : "Veldu lit",
                        selectedItem: activeColor,
                        textColor: (activeColor === null || activeColor === void 0 ? void 0 : activeColor.label) ? lib_styles_src/* theme.palette.blue.main */.rS.palette.blue.main : lib_styles_src/* theme.palette.gray.40 */.rS.palette.gray[40]
                    }) : null,
                    sizeSelectionList.length > 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)(component_select_src/* Select */.P, {
                        align: "left",
                        className: "select-container second",
                        // disableInactive={true} // FIXME
                        fit: true,
                        handleSelectedItemChange: handleSizeChange,
                        hideDefaultPlaceholder: true,
                        hideValue: true,
                        items: sizeSelectionList,
                        itemToString: handleItemToString,
                        placeholder: (ref13 = activeSize === null || activeSize === void 0 ? void 0 : activeSize.label) !== null && ref13 !== void 0 ? ref13 : "Veldu st\xe6r\xf0",
                        selectedItem: activeSize,
                        textColor: (activeSize === null || activeSize === void 0 ? void 0 : activeSize.label) ? lib_styles_src/* theme.palette.blue.main */.rS.palette.blue.main : lib_styles_src/* theme.palette.gray.40 */.rS.palette.gray[40]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(DetailButtonWrapper, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(component_quantity_input_src/* QuantityInput */.F, {
                        quantity: count,
                        quantityUnit: unitLabel !== null && unitLabel !== void 0 ? unitLabel : "",
                        setQuantity: setCount,
                        stretch: true
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                        children: isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonLoadingWrapper, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(component_loaders_src.MainLoader, {
                                size: 54
                            })
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(component_buttons_src/* Button */.zx, {
                            buttonColor: "blueButton",
                            customClassName: "add-to-cart-button",
                            disabled: !permitPurchase || !(activeVariant === null || activeVariant === void 0 ? void 0 : activeVariant.webstoreInStock) || productNotAvailableYet,
                            icon: lib_icons_src.BagAddIcons,
                            label: "B\xe6ta \xed k\xf6rfu",
                            stretch: true,
                            onClick: handleAddToCart
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(component_buttons_src/* Button */.zx, {
                        disabled: false,
                        icon: lib_icons_src.LongArrowRightIcons,
                        label: "Sko\xf0a v\xf6ru",
                        stretch: true,
                        onClick: onClickProductDetailPage
                    })
                ]
            })
        ]
    });
});

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-component-product-card-virtual-69967d117c/1/packages/component-product-card/src/components/product-card-open/index.ts


// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-hooks-compare-products-virtual-cdc2b75dbe/1/packages/hooks-compare-products/src/index.ts + 3 modules
var hooks_compare_products_src = __webpack_require__(11914);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-component-product-card-virtual-69967d117c/1/packages/component-product-card/src/components/product-image/styles.ts
function product_image_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function product_image_styles_templateObject() {
    const data = product_image_styles_taggedTemplateLiteral([
        "\n  position: absolute;\n  right: 0;\n  bottom: 50%;\n  width: fit-content;\n  width: 148px;\n  padding-top: 2px;\n  border-radius: 4px;\n  background-color: ",
        ";\n  opacity: 0;\n  pointer-events: none;\n  transform: translate3d(-58px, 50%, 0);\n  transition: 250ms;\n  &::after {\n    position: absolute;\n    top: 50%;\n    left: 100%;\n    width: 0;\n    height: 0;\n    border-top: 4px solid transparent;\n    border-bottom: 4px solid transparent;\n    border-left: 4px solid ",
        ';\n    content: "";\n    transform: translate3d(0, -50%, 0);\n  }\n  @media screen and (max-width: 768px) {\n    display: none;\n  }\n'
    ]);
    product_image_styles_templateObject = function() {
        return data;
    };
    return data;
}
function product_image_styles_templateObject1() {
    const data = product_image_styles_taggedTemplateLiteral([
        "\n  position: absolute;\n  right: 8px;\n  bottom: 8px;\n  display: flex;\n  width: 40px;\n  height: 40px;\n  align-items: center;\n  justify-content: center;\n  border: 1px solid ",
        ";\n  border-radius: 50%;\n  background-color: ",
        ";\n  transition: box-shadow 200ms ease-in-out;\n  &:hover {\n    box-shadow: ",
        ";\n    ",
        " {\n      opacity: 1;\n      transform: translate3d(-48px, 50%, 0);\n    }\n  }\n"
    ]);
    product_image_styles_templateObject1 = function() {
        return data;
    };
    return data;
}
function product_image_styles_templateObject2() {
    const data = product_image_styles_taggedTemplateLiteral([
        "\n  position: relative;\n  padding: 32px;\n  @media screen and (max-width: ",
        "px) {\n    padding: 16px;\n  }\n"
    ]);
    product_image_styles_templateObject2 = function() {
        return data;
    };
    return data;
}
function product_image_styles_templateObject3() {
    const data = product_image_styles_taggedTemplateLiteral([
        "\n  width: 100%;\n  height: 241px;\n  max-height: 241px;\n  object-fit: contain;\n  @media screen and (max-width: ",
        "px) {\n    height: 150px;\n    max-height: 150px;\n  }\n"
    ]);
    product_image_styles_templateObject3 = function() {
        return data;
    };
    return data;
}
function product_image_styles_templateObject4() {
    const data = product_image_styles_taggedTemplateLiteral([
        "\n  position: absolute;\n  right: 8px;\n  bottom: 8px;\n  width: 40px;\n  height: 40px;\n  padding: 13px;\n  border: 1px solid ",
        ";\n  border-radius: 50%;\n  background-color: ",
        ";\n  &:hover {\n    box-shadow: ",
        ";\n  }\n"
    ]);
    product_image_styles_templateObject4 = function() {
        return data;
    };
    return data;
}



const ButtonHoverLabel = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-a38bae14-0"
})(product_image_styles_templateObject(), lib_styles_src/* theme.palette.blue.dark */.rS.palette.blue.dark, lib_styles_src/* theme.palette.blue.dark */.rS.palette.blue.dark);
const CircleButton = styled_components_browser_cjs["default"].button.withConfig({
    componentId: "sc-a38bae14-1"
})(product_image_styles_templateObject1(), lib_styles_src/* theme.palette.gray.10 */.rS.palette.gray[10], lib_styles_src/* theme.palette.white.main */.rS.palette.white.main, lib_styles_src/* theme.palette.boxShadow.input */.rS.palette.boxShadow.input, ButtonHoverLabel);
const ImageWrapper = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-a38bae14-2"
})(product_image_styles_templateObject2(), lib_styles_src/* gridTheme.container.maxWidth.s */.k.container.maxWidth.s);
const ProdImage = styled_components_browser_cjs["default"].img.withConfig({
    componentId: "sc-a38bae14-3"
})(product_image_styles_templateObject3(), lib_styles_src/* gridTheme.container.maxWidth.s */.k.container.maxWidth.s);
const HeartWrapper = styled_components_browser_cjs["default"].button.withConfig({
    componentId: "sc-a38bae14-4"
})(product_image_styles_templateObject4(), lib_styles_src/* theme.palette.gray.10 */.rS.palette.gray[10], lib_styles_src/* theme.palette.white.main */.rS.palette.white.main, lib_styles_src/* theme.palette.boxShadow.input */.rS.palette.boxShadow.input);

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-component-product-card-virtual-69967d117c/1/packages/component-product-card/src/components/product-image/product-image.tsx




const placeholderImageHandler = (e)=>{
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    const target = e.target;
    target.src = "https://www.datocms-assets.com/65892/1664464657-placeholder-do-not-remove.jpg";
};
const ProductImage = (param)=>{
    let { productImage , product , rental  } = param;
    const { addProduct , products  } = (0,hooks_compare_products_src/* useCompareProducts */.j)();
    const addToComparison = (0,react.useCallback)((e)=>{
        e.preventDefault();
        addProduct(product.slug);
    }, [
        addProduct,
        product.slug
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageWrapper, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProdImage, {
            alt: "decorative",
            src: productImage,
            onError: placeholderImageHandler
        })
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-component-product-card-virtual-69967d117c/1/packages/component-product-card/src/components/product-image/index.ts


;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-component-product-card-virtual-69967d117c/1/packages/component-product-card/src/components/index.ts






;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-component-product-card-virtual-69967d117c/1/packages/component-product-card/src/styles.ts
function src_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function src_styles_templateObject() {
    const data = src_styles_taggedTemplateLiteral([
        "\n  position: relative;\n  display: flex;\n  min-width: 150px;\n  max-width: 328px;\n  max-height: 570px;\n  flex: 0 0 calc(50% - 8px);\n  flex-direction: column;\n  justify-content: space-between;\n  border: 1px solid ",
        ";\n  background-color: ",
        ";\n  box-shadow: ",
        ";\n  transition: all 0.5s;\n  &:hover {\n    box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.1);\n  }\n  @media screen and (max-width: ",
        "px) {\n    flex: 0 0 calc(50% - 8px);\n  }\n  @media screen and (max-width: ",
        "px) {\n    flex: 0 0 calc(50% - 8px);\n  }\n  .icon-button {\n    transition: 0ms !important;\n    * {\n      transition: 0ms !important;\n    }\n  }\n\n  ",
        " {\n    border-bottom: 1px solid ",
        ";\n  }\n\n  ",
        " {\n    border-bottom: 1px solid ",
        ";\n  }\n\n  &.rent {\n    min-height: auto;\n    border: 1px solid ",
        ";\n    .bottom-card-content {\n      display: flex;\n      width: 100%;\n      flex-direction: column;\n      flex-grow: 1;\n      justify-content: flex-end;\n    }\n    ",
        " {\n      border-bottom: 1px solid ",
        ";\n    }\n    ",
        " {\n      border-bottom: none;\n    }\n  }\n  &.display-card {\n    ",
        " {\n      border-bottom: none;\n    }\n    .bottom-card-content {\n      display: flex;\n      width: 100%;\n      flex-direction: column;\n      flex-grow: 1;\n      justify-content: flex-end;\n    }\n  }\n  &.special-no-price {\n    border: 1px solid ",
        ";\n    ",
        " {\n      border-bottom: 1px solid ",
        ";\n    }\n    ",
        " {\n      border-bottom: none;\n    }\n    .bottom-card-content {\n      display: flex;\n      width: 100%;\n      flex-direction: column;\n      flex-grow: 1;\n      justify-content: flex-end;\n    }\n  }\n  .custom-button {\n    border: 1px solid ",
        ";\n    ",
        " {\n      border-bottom: 1px solid ",
        ";\n    }\n    ",
        " {\n      border-bottom: 1px solid ",
        ";\n    }\n  }\n\n  .display-card-button {\n    border: none;\n    border-top: 1px solid ",
        ";\n  }\n\n  a {\n    display: flex;\n    height: 100%;\n    flex-basis: 100%;\n    flex-direction: column;\n    flex-grow: 1;\n  }\n"
    ]);
    src_styles_templateObject = function() {
        return data;
    };
    return data;
}
function src_styles_templateObject1() {
    const data = src_styles_taggedTemplateLiteral([
        "\n  position: absolute;\n  z-index: 1;\n  top: 0;\n  left: 0;\n  width: fit-content;\n  pointer-events: none;\n"
    ]);
    src_styles_templateObject1 = function() {
        return data;
    };
    return data;
}
function src_styles_templateObject2() {
    const data = src_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  width: 32px;\n  height: 32px;\n  align-items: center;\n  justify-content: center;\n  background-color: ",
        ";\n"
    ]);
    src_styles_templateObject2 = function() {
        return data;
    };
    return data;
}
function src_styles_templateObject3() {
    const data = src_styles_taggedTemplateLiteral([
        "\n  position: absolute;\n  z-index: 1;\n  top: 16px;\n  right: 16px;\n  width: fit-content;\n  svg {\n    pointer-events: none;\n  }\n"
    ]);
    src_styles_templateObject3 = function() {
        return data;
    };
    return data;
}
function src_styles_templateObject4() {
    const data = src_styles_taggedTemplateLiteral([
        "\n  font-size: 20px;\n  font-style: italic;\n  font-weight: 700;\n  text-align: center;\n"
    ]);
    src_styles_templateObject4 = function() {
        return data;
    };
    return data;
}
function src_styles_templateObject5() {
    const data = src_styles_taggedTemplateLiteral([
        "\n  position: relative;\n  display: flex;\n  overflow: hidden;\n  width: fit-content;\n  align-items: center;\n  padding: 16px 36px 16px 20px;\n  margin-right: 8px;\n  margin-bottom: 8px;\n  background-color: ",
        ";\n  ",
        " {\n    color: ",
        ';\n    -webkit-font-smoothing: antialiased;\n  }\n  &:before {\n    position: absolute;\n    top: 0;\n    right: 0;\n    width: 28px;\n    height: 100%;\n    background-color: white;\n    content: "";\n    transform: rotate(45deg);\n    transform-origin: bottom left;\n  }\n  &:after {\n    position: absolute;\n    top: 0;\n    right: 0;\n    width: 28px;\n    height: 100%;\n    background-color: white;\n    content: "";\n    transform: rotate(-45deg);\n    transform-origin: top left;\n  }\n'
    ]);
    src_styles_templateObject5 = function() {
        return data;
    };
    return data;
}





const ProductCardContainer = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-b2a62c21-0"
})(src_styles_templateObject(), lib_styles_src/* theme.palette.gray.10 */.rS.palette.gray[10], lib_styles_src/* theme.palette.white.main */.rS.palette.white.main, (props)=>props.showDetail ? "0px 4px 20px rgba(0, 0, 0, 0.1)" : "none", lib_styles_src/* gridTheme.container.maxWidth.sm */.k.container.maxWidth.sm, lib_styles_src/* gridTheme.container.maxWidth.s */.k.container.maxWidth.s, ImageWrapper, lib_styles_src/* theme.palette.gray.10 */.rS.palette.gray[10], ProdInfoWrapper, lib_styles_src/* theme.palette.gray.10 */.rS.palette.gray[10], lib_styles_src/* theme.palette.yellow.main */.rS.palette.yellow.main, ImageWrapper, lib_styles_src/* theme.palette.yellow.main */.rS.palette.yellow.main, ProdInfoWrapper, ProdInfoWrapper, lib_styles_src/* theme.palette.blue.lighter */.rS.palette.blue.lighter, ImageWrapper, lib_styles_src/* theme.palette.blue.lighter */.rS.palette.blue.lighter, ProdInfoWrapper, lib_styles_src/* theme.palette.blue.main */.rS.palette.blue.main, ImageWrapper, lib_styles_src/* theme.palette.blue.main */.rS.palette.blue.main, ProdInfoWrapper, lib_styles_src/* theme.palette.blue.main */.rS.palette.blue.main, lib_styles_src/* theme.palette.gray.10 */.rS.palette.gray[10]);
const TagContainer = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-b2a62c21-1"
})(src_styles_templateObject1());
const IconBackdrop = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-b2a62c21-2"
})(src_styles_templateObject2(), lib_styles_src/* theme.palette.green.dark */.rS.palette.green.dark);
const IconContainer = (0,styled_components_browser_cjs["default"])((link_default())).withConfig({
    componentId: "sc-b2a62c21-3"
})(src_styles_templateObject3());
const TagText = styled_components_browser_cjs["default"].p.withConfig({
    componentId: "sc-b2a62c21-4"
})(src_styles_templateObject4());
const TagBlock = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-b2a62c21-5"
})(src_styles_templateObject5(), (props)=>props.color === "blue" ? lib_styles_src/* theme.palette.blue.main */.rS.palette.blue.main : lib_styles_src/* theme.palette.yellow.main */.rS.palette.yellow.main, TagText, (props)=>props.color === "blue" ? lib_styles_src/* theme.palette.yellow.main */.rS.palette.yellow.main : lib_styles_src/* theme.palette.blue.dark */.rS.palette.blue.dark);

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-component-product-card-virtual-69967d117c/1/packages/component-product-card/src/product-standard-card.tsx















const ProductStandardCard = (param)=>{
    let { product , smallMobileCard , prices , lowestPriceSKU , listIndex , analyticsSectionId , algoliaInsights  } = param;
    var ref, ref1, ref2, ref3, ref4;
    const environmentalAttributes = product === null || product === void 0 ? void 0 : (ref = product.attributes) === null || ref === void 0 ? void 0 : ref["environmentalInfoType"];
    const hasEnvironmentalAttributes = environmentalAttributes && environmentalAttributes.length > 0;
    const [localPrices, setLocalPrices] = (0,react.useState)(prices);
    const containerRef = (0,react.useRef)(null);
    const isVisible = (0,lib_utils_src/* useOnScreen */.RO)(containerRef);
    const { sendClickInsights  } = (0,lib_algolia_src/* useAlgoliaInsights */.HX)();
    const [hasBeenVisible, setHasBeenVisible] = (0,react.useState)(false);
    const [localProduct, setLocalProduct] = (0,react.useState)();
    var ref5;
    const [activeVariantSKU, setActiveVariantSKU] = (0,react.useState)((ref5 = Object.keys(prices !== null && prices !== void 0 ? prices : {})[0]) !== null && ref5 !== void 0 ? ref5 : "");
    const { activeVariant  } = (0,hooks_product_variants_src/* useProductVariants */.Rk)(localProduct !== null && localProduct !== void 0 ? localProduct : product, activeVariantSKU, setActiveVariantSKU, lowestPriceSKU);
    const [showDetail, setShowDetail] = (0,react.useState)(false);
    const router = (0,next_router.useRouter)();
    const collapseRef = (0,react.useRef)(null);
    const { addToCart , isReady , isLoading  } = (0,hooks_cart_src/* useCart */.jD)();
    (0,react.useEffect)(()=>{
        if (lowestPriceSKU) {
            setActiveVariantSKU(lowestPriceSKU);
        }
    }, [
        lowestPriceSKU
    ]);
    const price = (0,react.useMemo)(()=>{
        return localPrices === null || localPrices === void 0 ? void 0 : localPrices[activeVariantSKU];
    }, [
        activeVariantSKU,
        localPrices
    ]);
    (0,react.useEffect)(()=>{
        if (isVisible && !hasBeenVisible) {
            setHasBeenVisible(true);
            var ref;
            src/* analytics.addProductListImpression */.c.addProductListImpression([
                product
            ], {
                [product.id]: (ref = price === null || price === void 0 ? void 0 : price.price.gross.toString()) !== null && ref !== void 0 ? ref : ""
            }, analyticsSectionId);
        }
    // we only want to fire this once
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isVisible,
        hasBeenVisible
    ]);
    const fetchProduct = (0,react.useCallback)(async ()=>{
        const data = await (0,lib_api_products_src/* productBySlug */.H1)(product.slug);
        if (!data) {
            return null;
        }
        return data;
    }, [
        product.slug
    ]);
    (0,react.useEffect)(()=>{
        if (prices) {
            setLocalPrices(prices);
        }
    }, [
        prices
    ]);
    const tags = (0,react.useMemo)(()=>{
        var ref;
        const list = [];
        if ((price === null || price === void 0 ? void 0 : (ref = price.discounted) === null || ref === void 0 ? void 0 : ref.name) === "RETAIL") {
            var ref1;
            if (price === null || price === void 0 ? void 0 : (ref1 = price.discounted) === null || ref1 === void 0 ? void 0 : ref1.percentage) {
                var ref2;
                return [
                    {
                        label: "-".concat(price === null || price === void 0 ? void 0 : (ref2 = price.discounted) === null || ref2 === void 0 ? void 0 : ref2.percentage, "%"),
                        color: "yellow"
                    }
                ];
            } else {
                return [
                    {
                        label: "Tilbo\xf0",
                        color: "yellow"
                    }
                ];
            }
        }
        return list;
    }, [
        price
    ]);
    const handleCollapseDetails = (0,react.useCallback)(()=>{
        setShowDetail(false);
    }, []);
    (0,esm/* useOnClickOutside */.t$)(collapseRef, handleCollapseDetails);
    const addProductListClick = (0,react.useCallback)(()=>{
        var ref;
        src/* analytics.addProductListClick */.c.addProductListClick(product, (ref = price === null || price === void 0 ? void 0 : price.price.gross.toString()) !== null && ref !== void 0 ? ref : "", listIndex, analyticsSectionId);
        !!algoliaInsights && sendClickInsights(algoliaInsights);
    }, [
        algoliaInsights,
        analyticsSectionId,
        listIndex,
        price === null || price === void 0 ? void 0 : price.price.gross,
        product,
        sendClickInsights
    ]);
    const onClickProductDetailPage = (0,react.useCallback)(()=>{
        addProductListClick();
        router.push("/vara/".concat(product.slug));
    }, [
        addProductListClick,
        product.slug,
        router
    ]);
    const handleAddToCart = (0,react.useCallback)((apiProduct)=>{
        const availableColors = [];
        const availableSizes = [];
        apiProduct.variants.forEach((variant)=>{
            if (variant.meta.color && !availableColors.includes(variant.meta.color)) {
                availableColors.push(variant.meta.color);
            }
            if (variant.meta.size && !availableColors.includes(variant.meta.size)) {
                availableSizes.push(variant.meta.size);
            }
        });
        if (availableColors.length > 1 || availableSizes.length > 1) {
            setShowDetail(true);
        } else {
            if (activeVariant === null || activeVariant === void 0 ? void 0 : activeVariant.id) {
                addToCart({
                    slug: product.slug
                });
                return;
            }
            addToCart({
                variantId: activeVariant === null || activeVariant === void 0 ? void 0 : activeVariant.id
            });
        }
    }, [
        activeVariant === null || activeVariant === void 0 ? void 0 : activeVariant.id,
        addToCart,
        product.slug
    ]);
    const handleButtonClick = (0,react.useCallback)(async ()=>{
        let data = localProduct !== null && localProduct !== void 0 ? localProduct : null;
        if (data === null) {
            data = await fetchProduct();
            if (data) {
                setLocalProduct(data);
                handleAddToCart(data);
            }
        } else {
            handleAddToCart(data);
        }
    }, [
        fetchProduct,
        handleAddToCart,
        localProduct
    ]);
    const availability = (0,react.useMemo)(()=>{
        if (showDetail) {
            var ref;
            return (ref = activeVariant === null || activeVariant === void 0 ? void 0 : activeVariant.webstoreInStock) !== null && ref !== void 0 ? ref : false;
        }
        var ref1;
        return (ref1 = product === null || product === void 0 ? void 0 : product.webstoreInStock) !== null && ref1 !== void 0 ? ref1 : false;
    }, [
        activeVariant === null || activeVariant === void 0 ? void 0 : activeVariant.webstoreInStock,
        product === null || product === void 0 ? void 0 : product.webstoreInStock,
        showDetail
    ]);
    const handleClose = (0,react.useCallback)(()=>{
        setShowDetail(false);
    }, []);
    const getBrand = (product)=>{
        var ref;
        const brandAttribute = (ref = product.attributes) === null || ref === void 0 ? void 0 : ref["brand"];
        if (!brandAttribute) {
            return undefined;
        }
        return (brandAttribute === null || brandAttribute === void 0 ? void 0 : brandAttribute[0]) !== "no brand" ? brandAttribute[0] : undefined;
    };
    const displayImage = (0,react.useMemo)(()=>{
        var ref, ref1, ref2, ref3;
        if ((ref = product.firstImage) === null || ref === void 0 ? void 0 : (ref1 = ref.image) === null || ref1 === void 0 ? void 0 : ref1.productList) {
            var ref4, ref5;
            return (ref4 = product.firstImage) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.image) === null || ref5 === void 0 ? void 0 : ref5.productList;
        } else if (activeVariant === null || activeVariant === void 0 ? void 0 : (ref2 = activeVariant.firstImage) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.image) === null || ref3 === void 0 ? void 0 : ref3.productList) {
            var ref6, ref7;
            return activeVariant === null || activeVariant === void 0 ? void 0 : (ref6 = activeVariant.firstImage) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.image) === null || ref7 === void 0 ? void 0 : ref7.productList;
        } else {
            return "https://www.datocms-assets.com/65892/1664464657-placeholder-do-not-remove.jpg";
        }
    }, [
        activeVariant === null || activeVariant === void 0 ? void 0 : (ref1 = activeVariant.firstImage) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.image) === null || ref2 === void 0 ? void 0 : ref2.productList,
        (ref3 = product.firstImage) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.image) === null || ref4 === void 0 ? void 0 : ref4.productList
    ]);
    var ref6;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ProductCardContainer, {
        ref: containerRef,
        className: "product-card",
        showDetail: showDetail,
        smallMobileCard: smallMobileCard !== null && smallMobileCard !== void 0 ? smallMobileCard : false,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TagContainer, {
                children: tags.map((param)=>{
                    let { label , color  } = param;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TagBlock, {
                        color: color,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TagText, {
                            children: label
                        })
                    }, label);
                })
            }),
            hasEnvironmentalAttributes && /*#__PURE__*/ (0,jsx_runtime.jsx)(IconContainer, {
                href: "/vara/".concat(product.slug),
                onClick: addProductListClick,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconBackdrop, {
                    title: "Umhverfisv\xe6n vara",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lib_icons_src.PlanetIcons, {
                        iconColor: lib_styles_src/* theme.palette.white.main */.rS.palette.white.main,
                        size: 24
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((link_default()), {
                href: "/vara/".concat(product.slug),
                onClick: addProductListClick,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductImage, {
                        product: product,
                        productImage: displayImage
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductCardInformation, {
                        brand: getBrand(product),
                        prodName: product.name,
                        shortDecription: product.description,
                        sku: (ref6 = activeVariant === null || activeVariant === void 0 ? void 0 : activeVariant.sku) !== null && ref6 !== void 0 ? ref6 : ""
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PriceWrapper, {
                        activeVariantSKU: activeVariantSKU,
                        prices: localPrices,
                        product: localProduct !== null && localProduct !== void 0 ? localProduct : product
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductCardButtons, {
                addToCartClick: handleButtonClick,
                disabledAddToCart: !isReady || showDetail,
                outOfStock: availability === false,
                showDetail: showDetail,
                onClickProductDetailPage: onClickProductDetailPage
            }),
            showDetail && /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductCardOpen, {
                ref: collapseRef,
                activeVariantSKU: activeVariantSKU,
                algoliaInsights: algoliaInsights,
                handleClose: handleClose,
                isLoading: isLoading,
                localPrices: localPrices,
                setActiveVariantSKU: setActiveVariantSKU,
                setLocalPrices: setLocalPrices,
                show: showDetail,
                slug: product.slug,
                onClickProductDetailPage: onClickProductDetailPage
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-component-product-card-virtual-69967d117c/1/packages/component-product-card/src/product-custom-card.tsx








const ProductCustomCard = (param)=>{
    let { product , addedLabel , algoliaInsights  } = param;
    var ref, ref1, ref2, ref3;
    const activeVariant = product.variants[0];
    const { sendClickInsights  } = (0,lib_algolia_src/* useAlgoliaInsights */.HX)();
    const handleClick = (0,react.useCallback)(()=>{
        !!algoliaInsights && sendClickInsights(algoliaInsights);
    }, [
        algoliaInsights,
        sendClickInsights
    ]);
    const displayImage = (0,react.useMemo)(()=>{
        var ref, ref1, ref2, ref3;
        if (activeVariant === null || activeVariant === void 0 ? void 0 : (ref = activeVariant.firstImage) === null || ref === void 0 ? void 0 : (ref1 = ref.image) === null || ref1 === void 0 ? void 0 : ref1.productList) {
            var ref4, ref5;
            return activeVariant === null || activeVariant === void 0 ? void 0 : (ref4 = activeVariant.firstImage) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.image) === null || ref5 === void 0 ? void 0 : ref5.productList;
        } else if ((ref2 = product.firstImage) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.image) === null || ref3 === void 0 ? void 0 : ref3.productList) {
            var ref6, ref7;
            return (ref6 = product.firstImage) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.image) === null || ref7 === void 0 ? void 0 : ref7.productList;
        } else {
            return "https://www.datocms-assets.com/65892/1664464657-placeholder-do-not-remove.jpg";
        }
    }, [
        activeVariant === null || activeVariant === void 0 ? void 0 : (ref = activeVariant.firstImage) === null || ref === void 0 ? void 0 : (ref1 = ref.image) === null || ref1 === void 0 ? void 0 : ref1.productList,
        (ref2 = product.firstImage) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.image) === null || ref3 === void 0 ? void 0 : ref3.productList
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductCardContainer, {
        className: "product-card special-no-price",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)((link_default()), {
            href: "/vara/".concat(product.slug),
            onClick: handleClick,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductImage, {
                    product: product,
                    productImage: displayImage,
                    rental: true
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "bottom-card-content",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductCardInformation, {
                            addedLabel: addedLabel,
                            prodName: product.name,
                            shortDecription: product.description,
                            sku: ""
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(component_buttons_src/* Button */.zx, {
                            buttonColor: "blueButton",
                            customClassName: "custom-button",
                            icon: lib_icons_src.ArrowRightIcons,
                            label: "Sko\xf0a v\xf6ru",
                            stretch: true
                        })
                    ]
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-component-product-card-virtual-69967d117c/1/packages/component-product-card/src/product-rent-card.tsx








const ProductRentCard = (param)=>{
    let { product , addedLabel , algoliaInsights  } = param;
    var ref, ref1, ref2, ref3, ref4;
    const activeVariant = product.variants[0];
    const { sendClickInsights  } = (0,lib_algolia_src/* useAlgoliaInsights */.HX)();
    const handleClick = (0,react.useCallback)(()=>{
        !!algoliaInsights && sendClickInsights(algoliaInsights);
    }, [
        algoliaInsights,
        sendClickInsights
    ]);
    const displayImage = (0,react.useMemo)(()=>{
        var ref, ref1, ref2, ref3;
        if (activeVariant === null || activeVariant === void 0 ? void 0 : (ref = activeVariant.firstImage) === null || ref === void 0 ? void 0 : (ref1 = ref.image) === null || ref1 === void 0 ? void 0 : ref1.productList) {
            var ref4, ref5;
            return activeVariant === null || activeVariant === void 0 ? void 0 : (ref4 = activeVariant.firstImage) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.image) === null || ref5 === void 0 ? void 0 : ref5.productList;
        } else if ((ref2 = product.firstImage) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.image) === null || ref3 === void 0 ? void 0 : ref3.productList) {
            var ref6, ref7;
            return (ref6 = product.firstImage) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.image) === null || ref7 === void 0 ? void 0 : ref7.productList;
        } else {
            return "https://www.datocms-assets.com/65892/1664464657-placeholder-do-not-remove.jpg";
        }
    }, [
        activeVariant === null || activeVariant === void 0 ? void 0 : (ref = activeVariant.firstImage) === null || ref === void 0 ? void 0 : (ref1 = ref.image) === null || ref1 === void 0 ? void 0 : ref1.productList,
        (ref2 = product.firstImage) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.image) === null || ref3 === void 0 ? void 0 : ref3.productList
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductCardContainer, {
        className: "product-card rent",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)((link_default()), {
            href: "/leiguvara/".concat(product.slug),
            onClick: handleClick,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductImage, {
                    product: product,
                    productImage: displayImage,
                    rental: true
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "bottom-card-content",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductCardInformation, {
                            addedLabel: addedLabel,
                            prodName: product.name,
                            shortDecription: product.description,
                            sku: ((ref4 = product.variants[0]) === null || ref4 === void 0 ? void 0 : ref4.sku) || ""
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(component_buttons_src/* Button */.zx, {
                            buttonColor: "yellowButton",
                            icon: lib_icons_src.ArrowRightIcons,
                            label: "Sko\xf0a v\xf6ru",
                            stretch: true
                        })
                    ]
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-component-product-card-virtual-69967d117c/1/packages/component-product-card/src/product-display-card.tsx








const ProductDisplayCard = (param)=>{
    let { product , algoliaInsights  } = param;
    var ref, ref1, ref2, ref3;
    const activeVariant = product.variants[0];
    const { sendClickInsights  } = (0,lib_algolia_src/* useAlgoliaInsights */.HX)();
    const handleClick = (0,react.useCallback)(()=>{
        !!algoliaInsights && sendClickInsights(algoliaInsights);
    }, [
        algoliaInsights,
        sendClickInsights
    ]);
    const displayImage = (0,react.useMemo)(()=>{
        var ref, ref1, ref2, ref3;
        if (activeVariant === null || activeVariant === void 0 ? void 0 : (ref = activeVariant.firstImage) === null || ref === void 0 ? void 0 : (ref1 = ref.image) === null || ref1 === void 0 ? void 0 : ref1.productList) {
            var ref4, ref5;
            return activeVariant === null || activeVariant === void 0 ? void 0 : (ref4 = activeVariant.firstImage) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.image) === null || ref5 === void 0 ? void 0 : ref5.productList;
        } else if ((ref2 = product.firstImage) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.image) === null || ref3 === void 0 ? void 0 : ref3.productList) {
            var ref6, ref7;
            return (ref6 = product.firstImage) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.image) === null || ref7 === void 0 ? void 0 : ref7.productList;
        } else {
            return "https://www.datocms-assets.com/65892/1664464657-placeholder-do-not-remove.jpg";
        }
    }, [
        activeVariant === null || activeVariant === void 0 ? void 0 : (ref = activeVariant.firstImage) === null || ref === void 0 ? void 0 : (ref1 = ref.image) === null || ref1 === void 0 ? void 0 : ref1.productList,
        (ref2 = product.firstImage) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.image) === null || ref3 === void 0 ? void 0 : ref3.productList
    ]);
    const getBrand = (product)=>{
        var ref;
        const brandAttribute = (ref = product.attributes) === null || ref === void 0 ? void 0 : ref["brand"];
        if (!brandAttribute) {
            return undefined;
        }
        return (brandAttribute === null || brandAttribute === void 0 ? void 0 : brandAttribute[0]) !== "no brand" ? brandAttribute[0] : undefined;
    };
    var ref4;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductCardContainer, {
        className: "product-card display-card",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)((link_default()), {
            href: "/vara/".concat(product.slug),
            onClick: handleClick,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductImage, {
                    product: product,
                    productImage: displayImage,
                    rental: true
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "bottom-card-content",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductCardInformation, {
                            brand: getBrand(product),
                            prodName: product.name,
                            shortDecription: product.description,
                            sku: (ref4 = activeVariant === null || activeVariant === void 0 ? void 0 : activeVariant.sku) !== null && ref4 !== void 0 ? ref4 : ""
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(component_buttons_src/* Button */.zx, {
                            customClassName: "display-card-button",
                            icon: lib_icons_src.ArrowRightIcons,
                            label: "Sko\xf0a v\xf6ru",
                            stretch: true
                        })
                    ]
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-component-product-card-virtual-69967d117c/1/packages/component-product-card/src/product-limited-card.tsx














const ProductLimitedCard = (param)=>{
    let { product , smallMobileCard , prices , lowestPriceSKU , listIndex , analyticsSectionId , algoliaInsights  } = param;
    var ref, ref1, ref2, ref3, ref4;
    const environmentalAttributes = product === null || product === void 0 ? void 0 : (ref = product.attributes) === null || ref === void 0 ? void 0 : ref["environmentalInfoType"];
    const hasEnvironmentalAttributes = environmentalAttributes && environmentalAttributes.length > 0;
    const [localPrices, setLocalPrices] = (0,react.useState)(prices);
    const containerRef = (0,react.useRef)(null);
    const isVisible = (0,lib_utils_src/* useOnScreen */.RO)(containerRef);
    const { sendClickInsights  } = (0,lib_algolia_src/* useAlgoliaInsights */.HX)();
    const [hasBeenVisible, setHasBeenVisible] = (0,react.useState)(false);
    var ref5;
    const [activeVariantSKU, setActiveVariantSKU] = (0,react.useState)((ref5 = Object.keys(prices !== null && prices !== void 0 ? prices : {})[0]) !== null && ref5 !== void 0 ? ref5 : "");
    const { activeVariant  } = (0,hooks_product_variants_src/* useProductVariants */.Rk)(product, activeVariantSKU, setActiveVariantSKU, lowestPriceSKU);
    const [showDetail, setShowDetail] = (0,react.useState)(false);
    const router = (0,next_router.useRouter)();
    const collapseRef = (0,react.useRef)(null);
    (0,react.useEffect)(()=>{
        if (lowestPriceSKU) {
            setActiveVariantSKU(lowestPriceSKU);
        }
    }, [
        lowestPriceSKU
    ]);
    const price = (0,react.useMemo)(()=>{
        return localPrices === null || localPrices === void 0 ? void 0 : localPrices[activeVariantSKU];
    }, [
        activeVariantSKU,
        localPrices
    ]);
    (0,react.useEffect)(()=>{
        if (isVisible && !hasBeenVisible) {
            setHasBeenVisible(true);
            var ref;
            src/* analytics.addProductListImpression */.c.addProductListImpression([
                product
            ], {
                [product.id]: (ref = price === null || price === void 0 ? void 0 : price.price.gross.toString()) !== null && ref !== void 0 ? ref : ""
            }, analyticsSectionId);
        }
    // we only want to fire this once
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isVisible,
        hasBeenVisible
    ]);
    (0,react.useEffect)(()=>{
        if (prices) {
            setLocalPrices(prices);
        }
    }, [
        prices
    ]);
    const tags = (0,react.useMemo)(()=>{
        var ref;
        const list = [];
        if ((price === null || price === void 0 ? void 0 : (ref = price.discounted) === null || ref === void 0 ? void 0 : ref.name) === "RETAIL") {
            var ref1;
            if (price === null || price === void 0 ? void 0 : (ref1 = price.discounted) === null || ref1 === void 0 ? void 0 : ref1.percentage) {
                var ref2;
                return [
                    {
                        label: "-".concat(price === null || price === void 0 ? void 0 : (ref2 = price.discounted) === null || ref2 === void 0 ? void 0 : ref2.percentage, "%"),
                        color: "yellow"
                    }
                ];
            } else {
                return [
                    {
                        label: "Tilbo\xf0",
                        color: "yellow"
                    }
                ];
            }
        }
        return list;
    }, [
        price
    ]);
    const handleCollapseDetails = (0,react.useCallback)(()=>{
        setShowDetail(false);
    }, []);
    (0,esm/* useOnClickOutside */.t$)(collapseRef, handleCollapseDetails);
    const addProductListClick = (0,react.useCallback)(()=>{
        var ref;
        src/* analytics.addProductListClick */.c.addProductListClick(product, (ref = price === null || price === void 0 ? void 0 : price.price.gross.toString()) !== null && ref !== void 0 ? ref : "", listIndex, analyticsSectionId);
        !!algoliaInsights && sendClickInsights(algoliaInsights);
    }, [
        algoliaInsights,
        analyticsSectionId,
        listIndex,
        price === null || price === void 0 ? void 0 : price.price.gross,
        product,
        sendClickInsights
    ]);
    const onClickProductDetailPage = (0,react.useCallback)(()=>{
        addProductListClick();
        router.push("/vara/".concat(product.slug));
    }, [
        addProductListClick,
        product.slug,
        router
    ]);
    const displayImage = (0,react.useMemo)(()=>{
        var ref, ref1, ref2, ref3;
        if (activeVariant === null || activeVariant === void 0 ? void 0 : (ref = activeVariant.firstImage) === null || ref === void 0 ? void 0 : (ref1 = ref.image) === null || ref1 === void 0 ? void 0 : ref1.productList) {
            var ref4, ref5;
            return activeVariant === null || activeVariant === void 0 ? void 0 : (ref4 = activeVariant.firstImage) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.image) === null || ref5 === void 0 ? void 0 : ref5.productList;
        } else if ((ref2 = product.firstImage) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.image) === null || ref3 === void 0 ? void 0 : ref3.productList) {
            var ref6, ref7;
            return (ref6 = product.firstImage) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.image) === null || ref7 === void 0 ? void 0 : ref7.productList;
        } else {
            return "https://www.datocms-assets.com/65892/1664464657-placeholder-do-not-remove.jpg";
        }
    }, [
        activeVariant === null || activeVariant === void 0 ? void 0 : (ref1 = activeVariant.firstImage) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.image) === null || ref2 === void 0 ? void 0 : ref2.productList,
        (ref3 = product.firstImage) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.image) === null || ref4 === void 0 ? void 0 : ref4.productList
    ]);
    var ref6;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ProductCardContainer, {
        ref: containerRef,
        className: "product-card",
        showDetail: showDetail,
        smallMobileCard: smallMobileCard !== null && smallMobileCard !== void 0 ? smallMobileCard : false,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TagContainer, {
                children: tags.map((param)=>{
                    let { label , color  } = param;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TagBlock, {
                        color: color,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TagText, {
                            children: label
                        })
                    }, label);
                })
            }),
            hasEnvironmentalAttributes && /*#__PURE__*/ (0,jsx_runtime.jsx)(IconContainer, {
                href: "/vara/".concat(product.slug),
                onClick: addProductListClick,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconBackdrop, {
                    title: "Umhverfisv\xe6n vara",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lib_icons_src.PlanetIcons, {
                        iconColor: lib_styles_src/* theme.palette.white.main */.rS.palette.white.main,
                        size: 24
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((link_default()), {
                href: "/vara/".concat(product.slug),
                onClick: addProductListClick,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductImage, {
                        product: product,
                        productImage: displayImage
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductCardInformation, {
                        prodName: product.name,
                        shortDecription: product.description,
                        sku: (ref6 = activeVariant === null || activeVariant === void 0 ? void 0 : activeVariant.sku) !== null && ref6 !== void 0 ? ref6 : ""
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PriceWrapper, {
                        activeVariantSKU: activeVariantSKU,
                        prices: localPrices,
                        product: product
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(component_buttons_src/* Button */.zx, {
                buttonColor: "whiteButton",
                icon: lib_icons_src.LongArrowRightIcons,
                label: "Sko\xf0a v\xf6ru",
                stretch: true,
                onClick: onClickProductDetailPage
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-component-product-card-virtual-69967d117c/1/packages/component-product-card/src/index.ts







/***/ }),

/***/ 36355:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ ProductSliderSection; }
});

// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(61261);
// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(91987);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-component-page-container-virtual-6ffaf0ab98/1/packages/component-page-container/src/index.ts + 1 modules
var src = __webpack_require__(53000);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-component-slider-virtual-0c239e2406/1/packages/component-slider/src/index.ts + 14 modules
var component_slider_src = __webpack_require__(46146);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-lib-styles-virtual-b3f1d479f2/1/packages/lib-styles/src/index.ts + 18 modules
var lib_styles_src = __webpack_require__(52203);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-text-block-variant-one-virtual-a533df4313/1/packages/component-text-block-variant-one/src/index.ts + 4 modules
var component_text_block_variant_one_src = __webpack_require__(71667);
// EXTERNAL MODULE: ../../.yarn/__virtual__/styled-components-virtual-29066d9421/0/cache/styled-components-npm-5.3.5-88e3937b59-05a664dfe4.zip/node_modules/styled-components/dist/styled-components.browser.cjs.js
var styled_components_browser_cjs = __webpack_require__(33982);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-component-product-slider-section-virtual-37024fa6cf/1/packages/component-product-slider-section/src/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    const data = _taggedTemplateLiteral([
        "\n  position: relative;\n  width: 100%;\n  max-width: ",
        "px;\n  margin-right: auto;\n  margin-left: auto;\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _taggedTemplateLiteral([
        "\n  display: flex;\n  width: 100%;\n  max-width: 1000px;\n  flex-direction: column;\n  gap: 50px;\n  @media screen and (max-width: ",
        "px) {\n    gap: 30px;\n  }\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  overflow-x: visible;\n  @media screen and (max-width: ",
        "px) {\n    width: 100%;\n  }\n  .swiper-slide {\n    width: 325px !important;\n  }\n  .product-card {\n    width: 100% !important;\n    flex: none;\n  }\n\n  @media screen and (max-width: 375px) {\n    .swiper-slide {\n      width: calc(100% - 48px) !important;\n    }\n  }\n"
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = _taggedTemplateLiteral([
        "\n  width: 100%;\n\n  @media screen and (min-width: ",
        "px) and (max-width: ",
        "px) {\n    padding-right: 56px;\n  }\n  @media screen and (min-width: ",
        "px) and (max-width: ",
        "px) {\n    padding-right: 56px;\n  }\n\n  @media screen and (min-width: ",
        "px) {\n    padding-right: 56px;\n  }\n  @media screen and (max-width: ",
        "px) {\n    width: 100%;\n  }\n"
    ]);
    _templateObject3 = function() {
        return data;
    };
    return data;
}


const Container = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-5014b963-0"
})(_templateObject(), lib_styles_src/* gridTheme.maxContentWidth */.k.maxContentWidth);
const TextContainer = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-5014b963-1"
})(_templateObject1(), lib_styles_src/* gridTheme.container.maxWidth.sm */.k.container.maxWidth.sm);
const ProductSliderWrapper = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-5014b963-2"
})(_templateObject2(), lib_styles_src/* gridTheme.container.maxWidth.sm */.k.container.maxWidth.sm);
const TextBlockWrapper = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-5014b963-3"
})(_templateObject3(), lib_styles_src/* gridTheme.container.minWidth.md */.k.container.minWidth.md, lib_styles_src/* gridTheme.container.maxWidth.md */.k.container.maxWidth.md, lib_styles_src/* gridTheme.container.minWidth.lg */.k.container.minWidth.lg, lib_styles_src/* gridTheme.container.maxWidth.lg */.k.container.maxWidth.lg, lib_styles_src/* gridTheme.container.minWidth.xl */.k.container.minWidth.xl, lib_styles_src/* gridTheme.container.maxWidth.sm */.k.container.maxWidth.sm);

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-component-product-slider-section-virtual-37024fa6cf/1/packages/component-product-slider-section/src/component-product-slider-section.tsx







const ProductSliderSection = (param)=>{
    let { heading , paragraph , collection , buttonLabel , headingUnderlineColor  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* PageContainer */._, {
                backgroundColor: lib_styles_src/* theme.palette.gray.5 */.rS.palette.gray[5],
                flexDirection: "column",
                justifyContent: "center",
                offsetNav: false,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TextContainer, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TextBlockWrapper, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(component_text_block_variant_one_src/* TextBlockVariantOne */.p, {
                                buttonLabel: buttonLabel ? buttonLabel : "",
                                buttonLink: "/vorur",
                                heading: heading ? heading : "",
                                // eslint-disable-next-line max-len
                                headingUnderlineColor: headingUnderlineColor,
                                paragraph: paragraph
                            })
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductSliderWrapper, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(component_slider_src/* Slider */.iR, {
                    autoPad: true,
                    paginationGutter: true,
                    slideCollection: collection
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-component-product-slider-section-virtual-37024fa6cf/1/packages/component-product-slider-section/src/index.ts



/***/ }),

/***/ 75290:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "F": function() { return /* reexport */ QuantityInput; }
});

// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(61261);
// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(91987);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-lib-icons-virtual-412b14e947/1/packages/lib-icons/src/index.ts + 181 modules
var src = __webpack_require__(45628);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-lib-styles-virtual-b3f1d479f2/1/packages/lib-styles/src/index.ts + 18 modules
var lib_styles_src = __webpack_require__(52203);
// EXTERNAL MODULE: ../../.yarn/__virtual__/styled-components-virtual-29066d9421/0/cache/styled-components-npm-5.3.5-88e3937b59-05a664dfe4.zip/node_modules/styled-components/dist/styled-components.browser.cjs.js
var styled_components_browser_cjs = __webpack_require__(33982);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-component-quantity-input-virtual-a245e83f98/1/packages/component-quantity-input/src/components/mini-quantity-input/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    const data = _taggedTemplateLiteral([
        "\n  display: flex;\n  width: ",
        ";\n  align-items: center;\n  justify-content: space-between;\n  border: 1px solid ",
        ";\n  background-color: ",
        ";\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _taggedTemplateLiteral([
        "\n  width: ",
        ";\n  height: 40px;\n  border: none;\n  border-right: 1px solid ",
        ";\n  border-left: 1px solid ",
        ";\n  background-color: ",
        ";\n  color: ",
        ";\n  font-size: 20px;\n  outline: none;\n  text-align: center;\n  @media screen and (max-width: ",
        "px) {\n    width: ",
        ";\n    height: ",
        ";\n    min-height: 38px;\n  }\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = _taggedTemplateLiteral([
        "\n  display: flex;\n  width: 100%;\n  align-items: center;\n  justify-content: space-between;\n"
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = _taggedTemplateLiteral([
        "\n  display: flex;\n  width: 100%;\n  min-width: 38px;\n  height: 40px;\n  align-items: center;\n  justify-content: center;\n  @media screen and (max-width: ",
        "px) {\n    width: ",
        ";\n    height: ",
        ";\n    min-height: 38px;\n  }\n\n  &:disabled {\n    pointer-events: none;\n  }\n"
    ]);
    _templateObject3 = function() {
        return data;
    };
    return data;
}


const QtyButtonContainer = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-c1c4d5a9-0"
})(_templateObject(), (props)=>props.stretch ? "100%" : "fit-content", lib_styles_src/* theme.palette.gray.10 */.rS.palette.gray[10], lib_styles_src/* theme.palette.white.main */.rS.palette.white.main);
const QtyInputNumber = styled_components_browser_cjs["default"].input.withConfig({
    componentId: "sc-c1c4d5a9-1"
})(_templateObject1(), (props)=>props.stretch ? "100%" : "58px", lib_styles_src/* theme.palette.gray.10 */.rS.palette.gray[10], lib_styles_src/* theme.palette.gray.10 */.rS.palette.gray[10], lib_styles_src/* theme.palette.white.main */.rS.palette.white.main, lib_styles_src/* theme.palette.blue.dark */.rS.palette.blue.dark, lib_styles_src/* gridTheme.container.maxWidth.s */.k.container.maxWidth.s, (props)=>props.stretch ? "100%" : "42px", (props)=>props.stretch ? "100%" : "38px");
const QtyButtonWrapper = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-c1c4d5a9-2"
})(_templateObject2());
const QtyIconButton = styled_components_browser_cjs["default"].button.withConfig({
    componentId: "sc-c1c4d5a9-3"
})(_templateObject3(), lib_styles_src/* gridTheme.container.maxWidth.s */.k.container.maxWidth.s, (props)=>props.stretch ? "100%" : "38px", (props)=>props.stretch ? "100%" : "38px");

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-component-quantity-input-virtual-a245e83f98/1/packages/component-quantity-input/src/components/mini-quantity-input/mini-quantity-input.tsx






const MiniQuantityInput = (param)=>{
    let { quantity , addClick , subtractClick , onInputChange , addDisabled =false , stretch =false , setQuantity , ...props } = param;
    const checkValue = (0,react.useCallback)(()=>{
        if (Number.isNaN(quantity)) {
            setQuantity(1);
        }
    }, [
        quantity,
        setQuantity
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(QtyButtonContainer, {
        className: "quantity-input",
        stretch: stretch,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(QtyButtonWrapper, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(QtyIconButton, {
                    "aria-label": "Minnka magn",
                    disabled: quantity < 2,
                    stretch: stretch,
                    onClick: subtractClick,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(src.SubtractIcons, {
                        iconColor: lib_styles_src/* theme.palette.blue.main */.rS.palette.blue.main,
                        size: 16
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(QtyInputNumber, {
                    "aria-label": "quantity",
                    name: "quantity",
                    stretch: stretch,
                    type: "number",
                    value: quantity,
                    onBlur: checkValue,
                    onChange: onInputChange,
                    ...props
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(QtyIconButton, {
                    "aria-label": "B\xe6ta vi\xf0 magni",
                    disabled: addDisabled,
                    stretch: stretch,
                    onClick: addClick,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(src.AddIcons, {
                        iconColor: lib_styles_src/* theme.palette.blue.main */.rS.palette.blue.main,
                        size: 16
                    })
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-component-quantity-input-virtual-a245e83f98/1/packages/component-quantity-input/src/components/mini-quantity-input/index.ts


// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-component-typography-virtual-537720fdd1/1/packages/component-typography/src/index.ts + 2 modules
var component_typography_src = __webpack_require__(91371);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-component-quantity-input-virtual-a245e83f98/1/packages/component-quantity-input/src/components/default-quantity-input/styles.ts
function styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function styles_templateObject() {
    const data = styles_taggedTemplateLiteral([
        "\n  display: flex;\n  width: ",
        ";\n  height: ",
        ";\n  align-items: center;\n  justify-content: space-between;\n  padding: 10px 2px 10px 17px;\n  border: 1px solid ",
        ";\n  background-color: ",
        ";\n"
    ]);
    styles_templateObject = function() {
        return data;
    };
    return data;
}
function styles_templateObject1() {
    const data = styles_taggedTemplateLiteral([
        "\n  display: flex;\n  width: 100%;\n  flex-direction: ",
        ";\n  align-items: ",
        ";\n  gap: ",
        ";\n  p {\n    font-size: 12px;\n    text-transform: ",
        ";\n    user-select: none;\n  }\n"
    ]);
    styles_templateObject1 = function() {
        return data;
    };
    return data;
}
function styles_templateObject2() {
    const data = styles_taggedTemplateLiteral([
        "\n  width: 1px;\n  height: 24px;\n  background-color: ",
        ";\n"
    ]);
    styles_templateObject2 = function() {
        return data;
    };
    return data;
}
function styles_templateObject3() {
    const data = styles_taggedTemplateLiteral([
        "\n  max-width: 50px;\n  border: none;\n  background-color: ",
        ";\n  color: ",
        ";\n  outline: none;\n"
    ]);
    styles_templateObject3 = function() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = styles_taggedTemplateLiteral([
        "\n  display: flex;\n"
    ]);
    _templateObject4 = function() {
        return data;
    };
    return data;
}
function _templateObject5() {
    const data = styles_taggedTemplateLiteral([
        "\n  display: flex;\n  width: 40px;\n  height: 40px;\n  align-items: center;\n  justify-content: center;\n  border-left: 1px solid ",
        ";\n\n  &:disabled {\n    pointer-events: none;\n  }\n"
    ]);
    _templateObject5 = function() {
        return data;
    };
    return data;
}


const styles_QtyButtonContainer = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-897325e1-0"
})(styles_templateObject(), (props)=>props.stretch ? "100%" : "192px", (props)=>props.textInRow ? "38px" : "54px", lib_styles_src/* theme.palette.gray.10 */.rS.palette.gray[10], lib_styles_src/* theme.palette.white.main */.rS.palette.white.main);
const TextWrapper = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-897325e1-1"
})(styles_templateObject1(), (props)=>props.textInRow ? "row" : "column", (props)=>props.textInRow ? "center" : "flex-start", (props)=>props.textInRow ? "10px" : "0", (props)=>props.uppercase ? "uppercase" : "capitalize");
const SeperatorLine = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-897325e1-2"
})(styles_templateObject2(), lib_styles_src/* theme.palette.gray.10 */.rS.palette.gray[10]);
const styles_QtyInputNumber = styled_components_browser_cjs["default"].input.withConfig({
    componentId: "sc-897325e1-3"
})(styles_templateObject3(), lib_styles_src/* theme.palette.white.main */.rS.palette.white.main, lib_styles_src/* theme.palette.black.main */.rS.palette.black.main);
const styles_QtyButtonWrapper = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-897325e1-4"
})(_templateObject4());
const styles_QtyIconButton = styled_components_browser_cjs["default"].button.withConfig({
    componentId: "sc-897325e1-5"
})(_templateObject5(), lib_styles_src/* theme.palette.gray.10 */.rS.palette.gray[10]);

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-component-quantity-input-virtual-a245e83f98/1/packages/component-quantity-input/src/components/default-quantity-input/default-quantity-input.tsx







const DefaultQuantityInput = (param)=>{
    let { quantity =0 , quantityUnit ="magn stk" , setQuantity , addClick , subtractClick , onInputChange , addDisabled =false , stretch =false , textInRow =false , uppercase =true , ...props } = param;
    const checkValue = (0,react.useCallback)(()=>{
        if (Number.isNaN(quantity)) {
            setQuantity(1);
        }
    }, [
        quantity,
        setQuantity
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles_QtyButtonContainer, {
        className: "quantity-input",
        stretch: stretch,
        textInRow: textInRow,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(TextWrapper, {
                textInRow: textInRow,
                uppercase: uppercase,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(component_typography_src/* PSmall */.zK, {
                        lineHeight: "18px",
                        textColor: lib_styles_src/* theme.palette.gray.50 */.rS.palette.gray[50],
                        children: quantityUnit
                    }),
                    textInRow && /*#__PURE__*/ (0,jsx_runtime.jsx)(SeperatorLine, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_QtyInputNumber, {
                        "aria-label": "quantity",
                        name: "quantity",
                        type: "number",
                        value: quantity,
                        onBlur: checkValue,
                        onChange: onInputChange,
                        ...props
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles_QtyButtonWrapper, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_QtyIconButton, {
                        "aria-label": "Minnka magn",
                        disabled: quantity < 2,
                        onClick: subtractClick,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(src.SubtractIcons, {
                            iconColor: lib_styles_src/* theme.palette.blue.main */.rS.palette.blue.main,
                            size: 14
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_QtyIconButton, {
                        "aria-label": "B\xe6ta vi\xf0 magni",
                        disabled: addDisabled,
                        onClick: addClick,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(src.AddIcons, {
                            iconColor: lib_styles_src/* theme.palette.blue.main */.rS.palette.blue.main,
                            size: 14
                        })
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-component-quantity-input-virtual-a245e83f98/1/packages/component-quantity-input/src/components/default-quantity-input/index.ts


;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-component-quantity-input-virtual-a245e83f98/1/packages/component-quantity-input/src/components/index.ts



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-component-quantity-input-virtual-a245e83f98/1/packages/component-quantity-input/src/quantity-input.tsx



const QuantityInput = (param)=>{
    let { quantity , setQuantity , quantityUnit ="magn stk" , stretch =false , textInRow =false , addDisabled =false , uppercase =true , miniVersion =false  } = param;
    const handleAdd = react.useCallback(()=>{
        setQuantity(quantity + 1);
    }, [
        quantity,
        setQuantity
    ]);
    const handleSubtract = react.useCallback(()=>{
        setQuantity(quantity - 1);
    }, [
        quantity,
        setQuantity
    ]);
    const handleInputChange = react.useCallback((e)=>{
        setQuantity(parseInt(e.currentTarget.value, 10));
    }, [
        setQuantity
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: miniVersion ? /*#__PURE__*/ (0,jsx_runtime.jsx)(MiniQuantityInput, {
            addClick: handleAdd,
            addDisabled: addDisabled,
            quantity: quantity,
            setQuantity: setQuantity,
            stretch: stretch,
            subtractClick: handleSubtract,
            onInputChange: handleInputChange
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(DefaultQuantityInput, {
            addClick: handleAdd,
            addDisabled: addDisabled,
            quantity: quantity,
            quantityUnit: quantityUnit,
            setQuantity: setQuantity,
            stretch: stretch,
            subtractClick: handleSubtract,
            textInRow: textInRow,
            uppercase: uppercase,
            onInputChange: handleInputChange
        })
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-component-quantity-input-virtual-a245e83f98/1/packages/component-quantity-input/src/index.ts



/***/ }),

/***/ 388:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "P": function() { return /* reexport */ Select; }
});

// UNUSED EXPORTS: Autocomplete

// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(61261);
;// CONCATENATED MODULE: ../../.yarn/cache/@babel-runtime-npm-7.20.1-8f9256f2ed-00567a333d.zip/node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
function objectWithoutPropertiesLoose_objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
// EXTERNAL MODULE: ../../.yarn/cache/@babel-runtime-npm-7.20.1-8f9256f2ed-00567a333d.zip/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(37997);
// EXTERNAL MODULE: ../../.yarn/cache/prop-types-npm-15.8.1-17c71ee7ee-c056d3f1c0.zip/node_modules/prop-types/index.js
var prop_types = __webpack_require__(22283);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(91987);
// EXTERNAL MODULE: ../../.yarn/cache/react-is-npm-17.0.2-091bbb8db6-9d6d111d89.zip/node_modules/react-is/index.js
var react_is = __webpack_require__(90215);
;// CONCATENATED MODULE: ../../.yarn/cache/compute-scroll-into-view-npm-2.0.4-c2c11d0ba3-f3d1db9276.zip/node_modules/compute-scroll-into-view/dist/index.js
let e=e=>"object"==typeof e&&null!=e&&1===e.nodeType,t=(e,t)=>(!t||"hidden"!==e)&&("visible"!==e&&"clip"!==e),n=(e,n)=>{if(e.clientHeight<e.scrollHeight||e.clientWidth<e.scrollWidth){let l=getComputedStyle(e,null);return t(l.overflowY,n)||t(l.overflowX,n)||(e=>{let t=(e=>{if(!e.ownerDocument||!e.ownerDocument.defaultView)return null;try{return e.ownerDocument.defaultView.frameElement}catch(e){return null}})(e);return!!t&&(t.clientHeight<e.scrollHeight||t.clientWidth<e.scrollWidth)})(e)}return!1},l=(e,t,n,l,i,o,r,d)=>o<e&&r>t||o>e&&r<t?0:o<=e&&d<=n||r>=t&&d>=n?o-e-l:r>t&&d<n||o<e&&d>n?r-t+i:0,i=e=>{let t=e.parentElement;return null==t?e.getRootNode().host||null:t};var o=(t,o)=>{var r,d,h,f,u,s;if("undefined"==typeof document)return[];let{scrollMode:a,block:c,inline:g,boundary:m,skipOverflowHiddenElements:p}=o,w="function"==typeof m?m:e=>e!==m;if(!e(t))throw new TypeError("Invalid target");let W=document.scrollingElement||document.documentElement,H=[],b=t;for(;e(b)&&w(b);){if(b=i(b),b===W){H.push(b);break}null!=b&&b===document.body&&n(b)&&!n(document.documentElement)||null!=b&&n(b,p)&&H.push(b)}let v=null!=(d=null==(r=window.visualViewport)?void 0:r.width)?d:innerWidth,y=null!=(f=null==(h=window.visualViewport)?void 0:h.height)?f:innerHeight,E=null!=(u=window.scrollX)?u:pageXOffset,M=null!=(s=window.scrollY)?s:pageYOffset,{height:x,width:I,top:C,right:R,bottom:T,left:V}=t.getBoundingClientRect(),k="start"===c||"nearest"===c?C:"end"===c?T:C+x/2,B="center"===g?V+I/2:"end"===g?R:V,D=[];for(let e=0;e<H.length;e++){let t=H[e],{height:n,width:i,top:o,right:r,bottom:d,left:h}=t.getBoundingClientRect();if("if-needed"===a&&C>=0&&V>=0&&T<=y&&R<=v&&C>=o&&T<=d&&V>=h&&R<=r)return D;let f=getComputedStyle(t),u=parseInt(f.borderLeftWidth,10),s=parseInt(f.borderTopWidth,10),m=parseInt(f.borderRightWidth,10),p=parseInt(f.borderBottomWidth,10),w=0,b=0,O="offsetWidth"in t?t.offsetWidth-t.clientWidth-u-m:0,X="offsetHeight"in t?t.offsetHeight-t.clientHeight-s-p:0,Y="offsetWidth"in t?0===t.offsetWidth?0:i/t.offsetWidth:0,L="offsetHeight"in t?0===t.offsetHeight?0:n/t.offsetHeight:0;if(W===t)w="start"===c?k:"end"===c?k-y:"nearest"===c?l(M,M+y,y,s,p,M+k,M+k+x,x):k-y/2,b="start"===g?B:"center"===g?B-v/2:"end"===g?B-v:l(E,E+v,v,u,m,E+B,E+B+I,I),w=Math.max(0,w+M),b=Math.max(0,b+E);else{w="start"===c?k-o-s:"end"===c?k-d+p+X:"nearest"===c?l(o,d,n,s,p+X,k,k+x,x):k-(o+n/2)+X/2,b="start"===g?B-h-u:"center"===g?B-(h+i/2)+O/2:"end"===g?B-r+m+O:l(h,r,i,u,m+O,B,B+I,I);let{scrollLeft:e,scrollTop:f}=t;w=Math.max(0,Math.min(f+w/L,t.scrollHeight-n/L+X)),b=Math.max(0,Math.min(e+b/Y,t.scrollWidth-i/Y+O)),k+=f-w,B+=e-b}D.push({el:t,top:w,left:b})}return D};//# sourceMappingURL=index.js.map

// EXTERNAL MODULE: ../../.yarn/cache/tslib-npm-2.4.1-36f0ed04db-19480d6e03.zip/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(99290);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/downshift-virtual-9dc38b34f4/0/cache/downshift-npm-7.6.0-caea68ee5e-f738e0b50b.zip/node_modules/downshift/dist/downshift.esm.js










var idCounter = 0;

/**
 * Accepts a parameter and returns it if it's a function
 * or a noop function if it's not. This allows us to
 * accept a callback, but not worry about it if it's not
 * passed.
 * @param {Function} cb the callback
 * @return {Function} a function
 */
function cbToCb(cb) {
  return typeof cb === 'function' ? cb : noop;
}
function noop() {}

/**
 * Scroll node into view if necessary
 * @param {HTMLElement} node the element that should scroll into view
 * @param {HTMLElement} menuNode the menu element of the component
 */
function scrollIntoView(node, menuNode) {
  if (!node) {
    return;
  }
  var actions = o(node, {
    boundary: menuNode,
    block: 'nearest',
    scrollMode: 'if-needed'
  });
  actions.forEach(function (_ref) {
    var el = _ref.el,
      top = _ref.top,
      left = _ref.left;
    el.scrollTop = top;
    el.scrollLeft = left;
  });
}

/**
 * @param {HTMLElement} parent the parent node
 * @param {HTMLElement} child the child node
 * @param {Window} environment The window context where downshift renders.
 * @return {Boolean} whether the parent is the child or the child is in the parent
 */
function isOrContainsNode(parent, child, environment) {
  var result = parent === child || child instanceof environment.Node && parent.contains && parent.contains(child);
  return result;
}

/**
 * Simple debounce implementation. Will call the given
 * function once after the time given has passed since
 * it was last called.
 * @param {Function} fn the function to call after the time
 * @param {Number} time the time to wait
 * @return {Function} the debounced function
 */
function debounce(fn, time) {
  var timeoutId;
  function cancel() {
    if (timeoutId) {
      clearTimeout(timeoutId);
    }
  }
  function wrapper() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    cancel();
    timeoutId = setTimeout(function () {
      timeoutId = null;
      fn.apply(void 0, args);
    }, time);
  }
  wrapper.cancel = cancel;
  return wrapper;
}

/**
 * This is intended to be used to compose event handlers.
 * They are executed in order until one of them sets
 * `event.preventDownshiftDefault = true`.
 * @param {...Function} fns the event handler functions
 * @return {Function} the event handler to add to an element
 */
function callAllEventHandlers() {
  for (var _len2 = arguments.length, fns = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    fns[_key2] = arguments[_key2];
  }
  return function (event) {
    for (var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
      args[_key3 - 1] = arguments[_key3];
    }
    return fns.some(function (fn) {
      if (fn) {
        fn.apply(void 0, [event].concat(args));
      }
      return event.preventDownshiftDefault || event.hasOwnProperty('nativeEvent') && event.nativeEvent.preventDownshiftDefault;
    });
  };
}
function handleRefs() {
  for (var _len4 = arguments.length, refs = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
    refs[_key4] = arguments[_key4];
  }
  return function (node) {
    refs.forEach(function (ref) {
      if (typeof ref === 'function') {
        ref(node);
      } else if (ref) {
        ref.current = node;
      }
    });
  };
}

/**
 * This generates a unique ID for an instance of Downshift
 * @return {String} the unique ID
 */
function generateId() {
  return String(idCounter++);
}

/**
 * Resets idCounter to 0. Used for SSR.
 */
function resetIdCounter() {
  idCounter = 0;
}

/**
 * Default implementation for status message. Only added when menu is open.
 * Will specify if there are results in the list, and if so, how many,
 * and what keys are relevant.
 *
 * @param {Object} param the downshift state and other relevant properties
 * @return {String} the a11y status message
 */
function getA11yStatusMessage$1(_ref2) {
  var isOpen = _ref2.isOpen,
    resultCount = _ref2.resultCount,
    previousResultCount = _ref2.previousResultCount;
  if (!isOpen) {
    return '';
  }
  if (!resultCount) {
    return 'No results are available.';
  }
  if (resultCount !== previousResultCount) {
    return resultCount + " result" + (resultCount === 1 ? ' is' : 's are') + " available, use up and down arrow keys to navigate. Press Enter key to select.";
  }
  return '';
}

/**
 * Takes an argument and if it's an array, returns the first item in the array
 * otherwise returns the argument
 * @param {*} arg the maybe-array
 * @param {*} defaultValue the value if arg is falsey not defined
 * @return {*} the arg or it's first item
 */
function unwrapArray(arg, defaultValue) {
  arg = Array.isArray(arg) ? /* istanbul ignore next (preact) */arg[0] : arg;
  if (!arg && defaultValue) {
    return defaultValue;
  } else {
    return arg;
  }
}

/**
 * @param {Object} element (P)react element
 * @return {Boolean} whether it's a DOM element
 */
function isDOMElement(element) {

  // then we assume this is react
  return typeof element.type === 'string';
}

/**
 * @param {Object} element (P)react element
 * @return {Object} the props
 */
function getElementProps(element) {
  return element.props;
}

/**
 * Throws a helpful error message for required properties. Useful
 * to be used as a default in destructuring or object params.
 * @param {String} fnName the function name
 * @param {String} propName the prop name
 */
function requiredProp(fnName, propName) {
  // eslint-disable-next-line no-console
  console.error("The property \"" + propName + "\" is required in \"" + fnName + "\"");
}
var stateKeys = (/* unused pure expression or super */ null && (['highlightedIndex', 'inputValue', 'isOpen', 'selectedItem', 'type']));
/**
 * @param {Object} state the state object
 * @return {Object} state that is relevant to downshift
 */
function pickState(state) {
  if (state === void 0) {
    state = {};
  }
  var result = {};
  stateKeys.forEach(function (k) {
    if (state.hasOwnProperty(k)) {
      result[k] = state[k];
    }
  });
  return result;
}

/**
 * This will perform a shallow merge of the given state object
 * with the state coming from props
 * (for the controlled component scenario)
 * This is used in state updater functions so they're referencing
 * the right state regardless of where it comes from.
 *
 * @param {Object} state The state of the component/hook.
 * @param {Object} props The props that may contain controlled values.
 * @returns {Object} The merged controlled state.
 */
function getState(state, props) {
  return Object.keys(state).reduce(function (prevState, key) {
    prevState[key] = isControlledProp(props, key) ? props[key] : state[key];
    return prevState;
  }, {});
}

/**
 * This determines whether a prop is a "controlled prop" meaning it is
 * state which is controlled by the outside of this component rather
 * than within this component.
 *
 * @param {Object} props The props that may contain controlled values.
 * @param {String} key the key to check
 * @return {Boolean} whether it is a controlled controlled prop
 */
function isControlledProp(props, key) {
  return props[key] !== undefined;
}

/**
 * Normalizes the 'key' property of a KeyboardEvent in IE/Edge
 * @param {Object} event a keyboardEvent object
 * @return {String} keyboard key
 */
function normalizeArrowKey(event) {
  var key = event.key,
    keyCode = event.keyCode;
  /* istanbul ignore next (ie) */
  if (keyCode >= 37 && keyCode <= 40 && key.indexOf('Arrow') !== 0) {
    return "Arrow" + key;
  }
  return key;
}

/**
 * Simple check if the value passed is object literal
 * @param {*} obj any things
 * @return {Boolean} whether it's object literal
 */
function isPlainObject(obj) {
  return Object.prototype.toString.call(obj) === '[object Object]';
}

/**
 * Returns the new index in the list, in a circular way. If next value is out of bonds from the total,
 * it will wrap to either 0 or itemCount - 1.
 *
 * @param {number} moveAmount Number of positions to move. Negative to move backwards, positive forwards.
 * @param {number} baseIndex The initial position to move from.
 * @param {number} itemCount The total number of items.
 * @param {Function} getItemNodeFromIndex Used to check if item is disabled.
 * @param {boolean} circular Specify if navigation is circular. Default is true.
 * @returns {number} The new index after the move.
 */
function getNextWrappingIndex(moveAmount, baseIndex, itemCount, getItemNodeFromIndex, circular) {
  if (circular === void 0) {
    circular = true;
  }
  if (itemCount === 0) {
    return -1;
  }
  var itemsLastIndex = itemCount - 1;
  if (typeof baseIndex !== 'number' || baseIndex < 0 || baseIndex >= itemCount) {
    baseIndex = moveAmount > 0 ? -1 : itemsLastIndex + 1;
  }
  var newIndex = baseIndex + moveAmount;
  if (newIndex < 0) {
    newIndex = circular ? itemsLastIndex : 0;
  } else if (newIndex > itemsLastIndex) {
    newIndex = circular ? 0 : itemsLastIndex;
  }
  var nonDisabledNewIndex = getNextNonDisabledIndex(moveAmount, newIndex, itemCount, getItemNodeFromIndex, circular);
  if (nonDisabledNewIndex === -1) {
    return baseIndex >= itemCount ? -1 : baseIndex;
  }
  return nonDisabledNewIndex;
}

/**
 * Returns the next index in the list of an item that is not disabled.
 *
 * @param {number} moveAmount Number of positions to move. Negative to move backwards, positive forwards.
 * @param {number} baseIndex The initial position to move from.
 * @param {number} itemCount The total number of items.
 * @param {Function} getItemNodeFromIndex Used to check if item is disabled.
 * @param {boolean} circular Specify if navigation is circular. Default is true.
 * @returns {number} The new index. Returns baseIndex if item is not disabled. Returns next non-disabled item otherwise. If no non-disabled found it will return -1.
 */
function getNextNonDisabledIndex(moveAmount, baseIndex, itemCount, getItemNodeFromIndex, circular) {
  var currentElementNode = getItemNodeFromIndex(baseIndex);
  if (!currentElementNode || !currentElementNode.hasAttribute('disabled')) {
    return baseIndex;
  }
  if (moveAmount > 0) {
    for (var index = baseIndex + 1; index < itemCount; index++) {
      if (!getItemNodeFromIndex(index).hasAttribute('disabled')) {
        return index;
      }
    }
  } else {
    for (var _index = baseIndex - 1; _index >= 0; _index--) {
      if (!getItemNodeFromIndex(_index).hasAttribute('disabled')) {
        return _index;
      }
    }
  }
  if (circular) {
    return moveAmount > 0 ? getNextNonDisabledIndex(1, 0, itemCount, getItemNodeFromIndex, false) : getNextNonDisabledIndex(-1, itemCount - 1, itemCount, getItemNodeFromIndex, false);
  }
  return -1;
}

/**
 * Checks if event target is within the downshift elements.
 *
 * @param {EventTarget} target Target to check.
 * @param {HTMLElement[]} downshiftElements The elements that form downshift (list, toggle button etc).
 * @param {Window} environment The window context where downshift renders.
 * @param {boolean} checkActiveElement Whether to also check activeElement.
 *
 * @returns {boolean} Whether or not the target is within downshift elements.
 */
function targetWithinDownshift(target, downshiftElements, environment, checkActiveElement) {
  if (checkActiveElement === void 0) {
    checkActiveElement = true;
  }
  return downshiftElements.some(function (contextNode) {
    return contextNode && (isOrContainsNode(contextNode, target, environment) || checkActiveElement && isOrContainsNode(contextNode, environment.document.activeElement, environment));
  });
}

// eslint-disable-next-line import/no-mutable-exports
var validateControlledUnchanged = (/* unused pure expression or super */ null && (noop));
/* istanbul ignore next */
if (false) {}

var cleanupStatus = debounce(function (documentProp) {
  getStatusDiv(documentProp).textContent = '';
}, 500);

/**
 * @param {String} status the status message
 * @param {Object} documentProp document passed by the user.
 */
function setStatus(status, documentProp) {
  var div = getStatusDiv(documentProp);
  if (!status) {
    return;
  }
  div.textContent = status;
  cleanupStatus(documentProp);
}

/**
 * Get the status node or create it if it does not already exist.
 * @param {Object} documentProp document passed by the user.
 * @return {HTMLElement} the status node.
 */
function getStatusDiv(documentProp) {
  if (documentProp === void 0) {
    documentProp = document;
  }
  var statusDiv = documentProp.getElementById('a11y-status-message');
  if (statusDiv) {
    return statusDiv;
  }
  statusDiv = documentProp.createElement('div');
  statusDiv.setAttribute('id', 'a11y-status-message');
  statusDiv.setAttribute('role', 'status');
  statusDiv.setAttribute('aria-live', 'polite');
  statusDiv.setAttribute('aria-relevant', 'additions text');
  Object.assign(statusDiv.style, {
    border: '0',
    clip: 'rect(0 0 0 0)',
    height: '1px',
    margin: '-1px',
    overflow: 'hidden',
    padding: '0',
    position: 'absolute',
    width: '1px'
  });
  documentProp.body.appendChild(statusDiv);
  return statusDiv;
}

var unknown =  false ? 0 : 0;
var mouseUp =  false ? 0 : 1;
var itemMouseEnter =  false ? 0 : 2;
var keyDownArrowUp =  false ? 0 : 3;
var keyDownArrowDown =  false ? 0 : 4;
var keyDownEscape =  false ? 0 : 5;
var keyDownEnter =  false ? 0 : 6;
var keyDownHome =  false ? 0 : 7;
var keyDownEnd =  false ? 0 : 8;
var clickItem =  false ? 0 : 9;
var blurInput =  false ? 0 : 10;
var changeInput =  false ? 0 : 11;
var keyDownSpaceButton =  false ? 0 : 12;
var clickButton =  false ? 0 : 13;
var blurButton =  false ? 0 : 14;
var controlledPropUpdatedSelectedItem =  false ? 0 : 15;
var touchEnd =  false ? 0 : 16;

var stateChangeTypes$3 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  unknown: unknown,
  mouseUp: mouseUp,
  itemMouseEnter: itemMouseEnter,
  keyDownArrowUp: keyDownArrowUp,
  keyDownArrowDown: keyDownArrowDown,
  keyDownEscape: keyDownEscape,
  keyDownEnter: keyDownEnter,
  keyDownHome: keyDownHome,
  keyDownEnd: keyDownEnd,
  clickItem: clickItem,
  blurInput: blurInput,
  changeInput: changeInput,
  keyDownSpaceButton: keyDownSpaceButton,
  clickButton: clickButton,
  blurButton: blurButton,
  controlledPropUpdatedSelectedItem: controlledPropUpdatedSelectedItem,
  touchEnd: touchEnd
});

var _excluded$4 = (/* unused pure expression or super */ null && (["refKey", "ref"])),
  _excluded2$3 = (/* unused pure expression or super */ null && (["onClick", "onPress", "onKeyDown", "onKeyUp", "onBlur"])),
  _excluded3$2 = (/* unused pure expression or super */ null && (["onKeyDown", "onBlur", "onChange", "onInput", "onChangeText"])),
  _excluded4$1 = (/* unused pure expression or super */ null && (["refKey", "ref"])),
  _excluded5 = (/* unused pure expression or super */ null && (["onMouseMove", "onMouseDown", "onClick", "onPress", "index", "item"]));
var Downshift = /*#__PURE__*/(/* unused pure expression or super */ null && (function () {
  var Downshift = /*#__PURE__*/function (_Component) {
    _inheritsLoose(Downshift, _Component);
    function Downshift(_props) {
      var _this;
      _this = _Component.call(this, _props) || this;
      // fancy destructuring + defaults + aliases
      // this basically says each value of state should either be set to
      // the initial value or the default value if the initial value is not provided
      _this.id = _this.props.id || "downshift-" + generateId();
      _this.menuId = _this.props.menuId || _this.id + "-menu";
      _this.labelId = _this.props.labelId || _this.id + "-label";
      _this.inputId = _this.props.inputId || _this.id + "-input";
      _this.getItemId = _this.props.getItemId || function (index) {
        return _this.id + "-item-" + index;
      };
      _this.input = null;
      _this.items = [];
      // itemCount can be changed asynchronously
      // from within downshift (so it can't come from a prop)
      // this is why we store it as an instance and use
      // getItemCount rather than just use items.length
      // (to support windowing + async)
      _this.itemCount = null;
      _this.previousResultCount = 0;
      _this.timeoutIds = [];
      /**
       * @param {Function} fn the function to call after the time
       * @param {Number} time the time to wait
       */
      _this.internalSetTimeout = function (fn, time) {
        var id = setTimeout(function () {
          _this.timeoutIds = _this.timeoutIds.filter(function (i) {
            return i !== id;
          });
          fn();
        }, time);
        _this.timeoutIds.push(id);
      };
      _this.setItemCount = function (count) {
        _this.itemCount = count;
      };
      _this.unsetItemCount = function () {
        _this.itemCount = null;
      };
      _this.setHighlightedIndex = function (highlightedIndex, otherStateToSet) {
        if (highlightedIndex === void 0) {
          highlightedIndex = _this.props.defaultHighlightedIndex;
        }
        if (otherStateToSet === void 0) {
          otherStateToSet = {};
        }
        otherStateToSet = pickState(otherStateToSet);
        _this.internalSetState(_extends({
          highlightedIndex: highlightedIndex
        }, otherStateToSet));
      };
      _this.clearSelection = function (cb) {
        _this.internalSetState({
          selectedItem: null,
          inputValue: '',
          highlightedIndex: _this.props.defaultHighlightedIndex,
          isOpen: _this.props.defaultIsOpen
        }, cb);
      };
      _this.selectItem = function (item, otherStateToSet, cb) {
        otherStateToSet = pickState(otherStateToSet);
        _this.internalSetState(_extends({
          isOpen: _this.props.defaultIsOpen,
          highlightedIndex: _this.props.defaultHighlightedIndex,
          selectedItem: item,
          inputValue: _this.props.itemToString(item)
        }, otherStateToSet), cb);
      };
      _this.selectItemAtIndex = function (itemIndex, otherStateToSet, cb) {
        var item = _this.items[itemIndex];
        if (item == null) {
          return;
        }
        _this.selectItem(item, otherStateToSet, cb);
      };
      _this.selectHighlightedItem = function (otherStateToSet, cb) {
        return _this.selectItemAtIndex(_this.getState().highlightedIndex, otherStateToSet, cb);
      };
      // any piece of our state can live in two places:
      // 1. Uncontrolled: it's internal (this.state)
      //    We will call this.setState to update that state
      // 2. Controlled: it's external (this.props)
      //    We will call this.props.onStateChange to update that state
      //
      // In addition, we'll call this.props.onChange if the
      // selectedItem is changed.
      _this.internalSetState = function (stateToSet, cb) {
        var isItemSelected, onChangeArg;
        var onStateChangeArg = {};
        var isStateToSetFunction = typeof stateToSet === 'function';

        // we want to call `onInputValueChange` before the `setState` call
        // so someone controlling the `inputValue` state gets notified of
        // the input change as soon as possible. This avoids issues with
        // preserving the cursor position.
        // See https://github.com/downshift-js/downshift/issues/217 for more info.
        if (!isStateToSetFunction && stateToSet.hasOwnProperty('inputValue')) {
          _this.props.onInputValueChange(stateToSet.inputValue, _extends({}, _this.getStateAndHelpers(), stateToSet));
        }
        return _this.setState(function (state) {
          state = _this.getState(state);
          var newStateToSet = isStateToSetFunction ? stateToSet(state) : stateToSet;

          // Your own function that could modify the state that will be set.
          newStateToSet = _this.props.stateReducer(state, newStateToSet);

          // checks if an item is selected, regardless of if it's different from
          // what was selected before
          // used to determine if onSelect and onChange callbacks should be called
          isItemSelected = newStateToSet.hasOwnProperty('selectedItem');
          // this keeps track of the object we want to call with setState
          var nextState = {};
          // we need to call on change if the outside world is controlling any of our state
          // and we're trying to update that state. OR if the selection has changed and we're
          // trying to update the selection
          if (isItemSelected && newStateToSet.selectedItem !== state.selectedItem) {
            onChangeArg = newStateToSet.selectedItem;
          }
          newStateToSet.type = newStateToSet.type || unknown;
          Object.keys(newStateToSet).forEach(function (key) {
            // onStateChangeArg should only have the state that is
            // actually changing
            if (state[key] !== newStateToSet[key]) {
              onStateChangeArg[key] = newStateToSet[key];
            }
            // the type is useful for the onStateChangeArg
            // but we don't actually want to set it in internal state.
            // this is an undocumented feature for now... Not all internalSetState
            // calls support it and I'm not certain we want them to yet.
            // But it enables users controlling the isOpen state to know when
            // the isOpen state changes due to mouseup events which is quite handy.
            if (key === 'type') {
              return;
            }
            newStateToSet[key];
            // if it's coming from props, then we don't care to set it internally
            if (!isControlledProp(_this.props, key)) {
              nextState[key] = newStateToSet[key];
            }
          });

          // if stateToSet is a function, then we weren't able to call onInputValueChange
          // earlier, so we'll call it now that we know what the inputValue state will be.
          if (isStateToSetFunction && newStateToSet.hasOwnProperty('inputValue')) {
            _this.props.onInputValueChange(newStateToSet.inputValue, _extends({}, _this.getStateAndHelpers(), newStateToSet));
          }
          return nextState;
        }, function () {
          // call the provided callback if it's a function
          cbToCb(cb)();

          // only call the onStateChange and onChange callbacks if
          // we have relevant information to pass them.
          var hasMoreStateThanType = Object.keys(onStateChangeArg).length > 1;
          if (hasMoreStateThanType) {
            _this.props.onStateChange(onStateChangeArg, _this.getStateAndHelpers());
          }
          if (isItemSelected) {
            _this.props.onSelect(stateToSet.selectedItem, _this.getStateAndHelpers());
          }
          if (onChangeArg !== undefined) {
            _this.props.onChange(onChangeArg, _this.getStateAndHelpers());
          }
          // this is currently undocumented and therefore subject to change
          // We'll try to not break it, but just be warned.
          _this.props.onUserAction(onStateChangeArg, _this.getStateAndHelpers());
        });
      };
      //////////////////////////// ROOT
      _this.rootRef = function (node) {
        return _this._rootNode = node;
      };
      _this.getRootProps = function (_temp, _temp2) {
        var _extends2;
        var _ref = _temp === void 0 ? {} : _temp,
          _ref$refKey = _ref.refKey,
          refKey = _ref$refKey === void 0 ? 'ref' : _ref$refKey,
          ref = _ref.ref,
          rest = _objectWithoutPropertiesLoose(_ref, _excluded$4);
        var _ref2 = _temp2 === void 0 ? {} : _temp2,
          _ref2$suppressRefErro = _ref2.suppressRefError,
          suppressRefError = _ref2$suppressRefErro === void 0 ? false : _ref2$suppressRefErro;
        // this is used in the render to know whether the user has called getRootProps.
        // It uses that to know whether to apply the props automatically
        _this.getRootProps.called = true;
        _this.getRootProps.refKey = refKey;
        _this.getRootProps.suppressRefError = suppressRefError;
        var _this$getState = _this.getState(),
          isOpen = _this$getState.isOpen;
        return _extends((_extends2 = {}, _extends2[refKey] = handleRefs(ref, _this.rootRef), _extends2.role = 'combobox', _extends2['aria-expanded'] = isOpen, _extends2['aria-haspopup'] = 'listbox', _extends2['aria-owns'] = isOpen ? _this.menuId : null, _extends2['aria-labelledby'] = _this.labelId, _extends2), rest);
      };
      //\\\\\\\\\\\\\\\\\\\\\\\\\\ ROOT
      _this.keyDownHandlers = {
        ArrowDown: function ArrowDown(event) {
          var _this2 = this;
          event.preventDefault();
          if (this.getState().isOpen) {
            var amount = event.shiftKey ? 5 : 1;
            this.moveHighlightedIndex(amount, {
              type: keyDownArrowDown
            });
          } else {
            this.internalSetState({
              isOpen: true,
              type: keyDownArrowDown
            }, function () {
              var itemCount = _this2.getItemCount();
              if (itemCount > 0) {
                var _this2$getState = _this2.getState(),
                  highlightedIndex = _this2$getState.highlightedIndex;
                var nextHighlightedIndex = getNextWrappingIndex(1, highlightedIndex, itemCount, function (index) {
                  return _this2.getItemNodeFromIndex(index);
                });
                _this2.setHighlightedIndex(nextHighlightedIndex, {
                  type: keyDownArrowDown
                });
              }
            });
          }
        },
        ArrowUp: function ArrowUp(event) {
          var _this3 = this;
          event.preventDefault();
          if (this.getState().isOpen) {
            var amount = event.shiftKey ? -5 : -1;
            this.moveHighlightedIndex(amount, {
              type: keyDownArrowUp
            });
          } else {
            this.internalSetState({
              isOpen: true,
              type: keyDownArrowUp
            }, function () {
              var itemCount = _this3.getItemCount();
              if (itemCount > 0) {
                var _this3$getState = _this3.getState(),
                  highlightedIndex = _this3$getState.highlightedIndex;
                var nextHighlightedIndex = getNextWrappingIndex(-1, highlightedIndex, itemCount, function (index) {
                  return _this3.getItemNodeFromIndex(index);
                });
                _this3.setHighlightedIndex(nextHighlightedIndex, {
                  type: keyDownArrowUp
                });
              }
            });
          }
        },
        Enter: function Enter(event) {
          if (event.which === 229) {
            return;
          }
          var _this$getState2 = this.getState(),
            isOpen = _this$getState2.isOpen,
            highlightedIndex = _this$getState2.highlightedIndex;
          if (isOpen && highlightedIndex != null) {
            event.preventDefault();
            var item = this.items[highlightedIndex];
            var itemNode = this.getItemNodeFromIndex(highlightedIndex);
            if (item == null || itemNode && itemNode.hasAttribute('disabled')) {
              return;
            }
            this.selectHighlightedItem({
              type: keyDownEnter
            });
          }
        },
        Escape: function Escape(event) {
          event.preventDefault();
          this.reset(_extends({
            type: keyDownEscape
          }, !this.state.isOpen && {
            selectedItem: null,
            inputValue: ''
          }));
        }
      };
      //////////////////////////// BUTTON
      _this.buttonKeyDownHandlers = _extends({}, _this.keyDownHandlers, {
        ' ': function _(event) {
          event.preventDefault();
          this.toggleMenu({
            type: keyDownSpaceButton
          });
        }
      });
      _this.inputKeyDownHandlers = _extends({}, _this.keyDownHandlers, {
        Home: function Home(event) {
          var _this4 = this;
          var _this$getState3 = this.getState(),
            isOpen = _this$getState3.isOpen;
          if (!isOpen) {
            return;
          }
          event.preventDefault();
          var itemCount = this.getItemCount();
          if (itemCount <= 0 || !isOpen) {
            return;
          }

          // get next non-disabled starting downwards from 0 if that's disabled.
          var newHighlightedIndex = getNextNonDisabledIndex(1, 0, itemCount, function (index) {
            return _this4.getItemNodeFromIndex(index);
          }, false);
          this.setHighlightedIndex(newHighlightedIndex, {
            type: keyDownHome
          });
        },
        End: function End(event) {
          var _this5 = this;
          var _this$getState4 = this.getState(),
            isOpen = _this$getState4.isOpen;
          if (!isOpen) {
            return;
          }
          event.preventDefault();
          var itemCount = this.getItemCount();
          if (itemCount <= 0 || !isOpen) {
            return;
          }

          // get next non-disabled starting upwards from last index if that's disabled.
          var newHighlightedIndex = getNextNonDisabledIndex(-1, itemCount - 1, itemCount, function (index) {
            return _this5.getItemNodeFromIndex(index);
          }, false);
          this.setHighlightedIndex(newHighlightedIndex, {
            type: keyDownEnd
          });
        }
      });
      _this.getToggleButtonProps = function (_temp3) {
        var _ref3 = _temp3 === void 0 ? {} : _temp3,
          onClick = _ref3.onClick;
          _ref3.onPress;
          var onKeyDown = _ref3.onKeyDown,
          onKeyUp = _ref3.onKeyUp,
          onBlur = _ref3.onBlur,
          rest = _objectWithoutPropertiesLoose(_ref3, _excluded2$3);
        var _this$getState5 = _this.getState(),
          isOpen = _this$getState5.isOpen;
        var enabledEventHandlers = {
          onClick: callAllEventHandlers(onClick, _this.buttonHandleClick),
          onKeyDown: callAllEventHandlers(onKeyDown, _this.buttonHandleKeyDown),
          onKeyUp: callAllEventHandlers(onKeyUp, _this.buttonHandleKeyUp),
          onBlur: callAllEventHandlers(onBlur, _this.buttonHandleBlur)
        };
        var eventHandlers = rest.disabled ? {} : enabledEventHandlers;
        return _extends({
          type: 'button',
          role: 'button',
          'aria-label': isOpen ? 'close menu' : 'open menu',
          'aria-haspopup': true,
          'data-toggle': true
        }, eventHandlers, rest);
      };
      _this.buttonHandleKeyUp = function (event) {
        // Prevent click event from emitting in Firefox
        event.preventDefault();
      };
      _this.buttonHandleKeyDown = function (event) {
        var key = normalizeArrowKey(event);
        if (_this.buttonKeyDownHandlers[key]) {
          _this.buttonKeyDownHandlers[key].call(_assertThisInitialized(_this), event);
        }
      };
      _this.buttonHandleClick = function (event) {
        event.preventDefault();
        // handle odd case for Safari and Firefox which
        // don't give the button the focus properly.
        /* istanbul ignore if (can't reasonably test this) */
        if (_this.props.environment.document.activeElement === _this.props.environment.document.body) {
          event.target.focus();
        }
        // to simplify testing components that use downshift, we'll not wrap this in a setTimeout
        // if the NODE_ENV is test. With the proper build system, this should be dead code eliminated
        // when building for production and should therefore have no impact on production code.
        if (false) {} else {
          // Ensure that toggle of menu occurs after the potential blur event in iOS
          _this.internalSetTimeout(function () {
            return _this.toggleMenu({
              type: clickButton
            });
          });
        }
      };
      _this.buttonHandleBlur = function (event) {
        var blurTarget = event.target; // Save blur target for comparison with activeElement later
        // Need setTimeout, so that when the user presses Tab, the activeElement is the next focused element, not body element
        _this.internalSetTimeout(function () {
          if (!_this.isMouseDown && (_this.props.environment.document.activeElement == null || _this.props.environment.document.activeElement.id !== _this.inputId) && _this.props.environment.document.activeElement !== blurTarget // Do nothing if we refocus the same element again (to solve issue in Safari on iOS)
          ) {
            _this.reset({
              type: blurButton
            });
          }
        });
      };
      //\\\\\\\\\\\\\\\\\\\\\\\\\\\\\ BUTTON
      /////////////////////////////// LABEL
      _this.getLabelProps = function (props) {
        return _extends({
          htmlFor: _this.inputId,
          id: _this.labelId
        }, props);
      };
      //\\\\\\\\\\\\\\\\\\\\\\\\\\\\\ LABEL
      /////////////////////////////// INPUT
      _this.getInputProps = function (_temp4) {
        var _ref4 = _temp4 === void 0 ? {} : _temp4,
          onKeyDown = _ref4.onKeyDown,
          onBlur = _ref4.onBlur,
          onChange = _ref4.onChange,
          onInput = _ref4.onInput;
          _ref4.onChangeText;
          var rest = _objectWithoutPropertiesLoose(_ref4, _excluded3$2);
        var onChangeKey;
        var eventHandlers = {};

        /* istanbul ignore next (preact) */
        {
          onChangeKey = 'onChange';
        }
        var _this$getState6 = _this.getState(),
          inputValue = _this$getState6.inputValue,
          isOpen = _this$getState6.isOpen,
          highlightedIndex = _this$getState6.highlightedIndex;
        if (!rest.disabled) {
          var _eventHandlers;
          eventHandlers = (_eventHandlers = {}, _eventHandlers[onChangeKey] = callAllEventHandlers(onChange, onInput, _this.inputHandleChange), _eventHandlers.onKeyDown = callAllEventHandlers(onKeyDown, _this.inputHandleKeyDown), _eventHandlers.onBlur = callAllEventHandlers(onBlur, _this.inputHandleBlur), _eventHandlers);
        }
        return _extends({
          'aria-autocomplete': 'list',
          'aria-activedescendant': isOpen && typeof highlightedIndex === 'number' && highlightedIndex >= 0 ? _this.getItemId(highlightedIndex) : null,
          'aria-controls': isOpen ? _this.menuId : null,
          'aria-labelledby': rest && rest['aria-label'] ? undefined : _this.labelId,
          // https://developer.mozilla.org/en-US/docs/Web/Security/Securing_your_site/Turning_off_form_autocompletion
          // revert back since autocomplete="nope" is ignored on latest Chrome and Opera
          autoComplete: 'off',
          value: inputValue,
          id: _this.inputId
        }, eventHandlers, rest);
      };
      _this.inputHandleKeyDown = function (event) {
        var key = normalizeArrowKey(event);
        if (key && _this.inputKeyDownHandlers[key]) {
          _this.inputKeyDownHandlers[key].call(_assertThisInitialized(_this), event);
        }
      };
      _this.inputHandleChange = function (event) {
        _this.internalSetState({
          type: changeInput,
          isOpen: true,
          inputValue: event.target.value,
          highlightedIndex: _this.props.defaultHighlightedIndex
        });
      };
      _this.inputHandleBlur = function () {
        // Need setTimeout, so that when the user presses Tab, the activeElement is the next focused element, not the body element
        _this.internalSetTimeout(function () {
          var downshiftButtonIsActive = _this.props.environment.document && !!_this.props.environment.document.activeElement && !!_this.props.environment.document.activeElement.dataset && _this.props.environment.document.activeElement.dataset.toggle && _this._rootNode && _this._rootNode.contains(_this.props.environment.document.activeElement);
          if (!_this.isMouseDown && !downshiftButtonIsActive) {
            _this.reset({
              type: blurInput
            });
          }
        });
      };
      //\\\\\\\\\\\\\\\\\\\\\\\\\\\\\ INPUT
      /////////////////////////////// MENU
      _this.menuRef = function (node) {
        _this._menuNode = node;
      };
      _this.getMenuProps = function (_temp5, _temp6) {
        var _extends3;
        var _ref5 = _temp5 === void 0 ? {} : _temp5,
          _ref5$refKey = _ref5.refKey,
          refKey = _ref5$refKey === void 0 ? 'ref' : _ref5$refKey,
          ref = _ref5.ref,
          props = _objectWithoutPropertiesLoose(_ref5, _excluded4$1);
        var _ref6 = _temp6 === void 0 ? {} : _temp6,
          _ref6$suppressRefErro = _ref6.suppressRefError,
          suppressRefError = _ref6$suppressRefErro === void 0 ? false : _ref6$suppressRefErro;
        _this.getMenuProps.called = true;
        _this.getMenuProps.refKey = refKey;
        _this.getMenuProps.suppressRefError = suppressRefError;
        return _extends((_extends3 = {}, _extends3[refKey] = handleRefs(ref, _this.menuRef), _extends3.role = 'listbox', _extends3['aria-labelledby'] = props && props['aria-label'] ? null : _this.labelId, _extends3.id = _this.menuId, _extends3), props);
      };
      //\\\\\\\\\\\\\\\\\\\\\\\\\\\\\ MENU
      /////////////////////////////// ITEM
      _this.getItemProps = function (_temp7) {
        var _enabledEventHandlers;
        var _ref7 = _temp7 === void 0 ? {} : _temp7,
          onMouseMove = _ref7.onMouseMove,
          onMouseDown = _ref7.onMouseDown,
          onClick = _ref7.onClick;
          _ref7.onPress;
          var index = _ref7.index,
          _ref7$item = _ref7.item,
          item = _ref7$item === void 0 ?  true ? /* istanbul ignore next */undefined : 0 : _ref7$item,
          rest = _objectWithoutPropertiesLoose(_ref7, _excluded5);
        if (index === undefined) {
          _this.items.push(item);
          index = _this.items.indexOf(item);
        } else {
          _this.items[index] = item;
        }
        var onSelectKey = 'onClick';
        var customClickHandler = onClick;
        var enabledEventHandlers = (_enabledEventHandlers = {
          // onMouseMove is used over onMouseEnter here. onMouseMove
          // is only triggered on actual mouse movement while onMouseEnter
          // can fire on DOM changes, interrupting keyboard navigation
          onMouseMove: callAllEventHandlers(onMouseMove, function () {
            if (index === _this.getState().highlightedIndex) {
              return;
            }
            _this.setHighlightedIndex(index, {
              type: itemMouseEnter
            });

            // We never want to manually scroll when changing state based
            // on `onMouseMove` because we will be moving the element out
            // from under the user which is currently scrolling/moving the
            // cursor
            _this.avoidScrolling = true;
            _this.internalSetTimeout(function () {
              return _this.avoidScrolling = false;
            }, 250);
          }),
          onMouseDown: callAllEventHandlers(onMouseDown, function (event) {
            // This prevents the activeElement from being changed
            // to the item so it can remain with the current activeElement
            // which is a more common use case.
            event.preventDefault();
          })
        }, _enabledEventHandlers[onSelectKey] = callAllEventHandlers(customClickHandler, function () {
          _this.selectItemAtIndex(index, {
            type: clickItem
          });
        }), _enabledEventHandlers);

        // Passing down the onMouseDown handler to prevent redirect
        // of the activeElement if clicking on disabled items
        var eventHandlers = rest.disabled ? {
          onMouseDown: enabledEventHandlers.onMouseDown
        } : enabledEventHandlers;
        return _extends({
          id: _this.getItemId(index),
          role: 'option',
          'aria-selected': _this.getState().highlightedIndex === index
        }, eventHandlers, rest);
      };
      //\\\\\\\\\\\\\\\\\\\\\\\\\\\\\ ITEM
      _this.clearItems = function () {
        _this.items = [];
      };
      _this.reset = function (otherStateToSet, cb) {
        if (otherStateToSet === void 0) {
          otherStateToSet = {};
        }
        otherStateToSet = pickState(otherStateToSet);
        _this.internalSetState(function (_ref8) {
          var selectedItem = _ref8.selectedItem;
          return _extends({
            isOpen: _this.props.defaultIsOpen,
            highlightedIndex: _this.props.defaultHighlightedIndex,
            inputValue: _this.props.itemToString(selectedItem)
          }, otherStateToSet);
        }, cb);
      };
      _this.toggleMenu = function (otherStateToSet, cb) {
        if (otherStateToSet === void 0) {
          otherStateToSet = {};
        }
        otherStateToSet = pickState(otherStateToSet);
        _this.internalSetState(function (_ref9) {
          var isOpen = _ref9.isOpen;
          return _extends({
            isOpen: !isOpen
          }, isOpen && {
            highlightedIndex: _this.props.defaultHighlightedIndex
          }, otherStateToSet);
        }, function () {
          var _this$getState7 = _this.getState(),
            isOpen = _this$getState7.isOpen,
            highlightedIndex = _this$getState7.highlightedIndex;
          if (isOpen) {
            if (_this.getItemCount() > 0 && typeof highlightedIndex === 'number') {
              _this.setHighlightedIndex(highlightedIndex, otherStateToSet);
            }
          }
          cbToCb(cb)();
        });
      };
      _this.openMenu = function (cb) {
        _this.internalSetState({
          isOpen: true
        }, cb);
      };
      _this.closeMenu = function (cb) {
        _this.internalSetState({
          isOpen: false
        }, cb);
      };
      _this.updateStatus = debounce(function () {
        var state = _this.getState();
        var item = _this.items[state.highlightedIndex];
        var resultCount = _this.getItemCount();
        var status = _this.props.getA11yStatusMessage(_extends({
          itemToString: _this.props.itemToString,
          previousResultCount: _this.previousResultCount,
          resultCount: resultCount,
          highlightedItem: item
        }, state));
        _this.previousResultCount = resultCount;
        setStatus(status, _this.props.environment.document);
      }, 200);
      var _this$props = _this.props,
        defaultHighlightedIndex = _this$props.defaultHighlightedIndex,
        _this$props$initialHi = _this$props.initialHighlightedIndex,
        _highlightedIndex = _this$props$initialHi === void 0 ? defaultHighlightedIndex : _this$props$initialHi,
        defaultIsOpen = _this$props.defaultIsOpen,
        _this$props$initialIs = _this$props.initialIsOpen,
        _isOpen = _this$props$initialIs === void 0 ? defaultIsOpen : _this$props$initialIs,
        _this$props$initialIn = _this$props.initialInputValue,
        _inputValue = _this$props$initialIn === void 0 ? '' : _this$props$initialIn,
        _this$props$initialSe = _this$props.initialSelectedItem,
        _selectedItem = _this$props$initialSe === void 0 ? null : _this$props$initialSe;
      var _state = _this.getState({
        highlightedIndex: _highlightedIndex,
        isOpen: _isOpen,
        inputValue: _inputValue,
        selectedItem: _selectedItem
      });
      if (_state.selectedItem != null && _this.props.initialInputValue === undefined) {
        _state.inputValue = _this.props.itemToString(_state.selectedItem);
      }
      _this.state = _state;
      return _this;
    }
    var _proto = Downshift.prototype;
    /**
     * Clear all running timeouts
     */
    _proto.internalClearTimeouts = function internalClearTimeouts() {
      this.timeoutIds.forEach(function (id) {
        clearTimeout(id);
      });
      this.timeoutIds = [];
    }

    /**
     * Gets the state based on internal state or props
     * If a state value is passed via props, then that
     * is the value given, otherwise it's retrieved from
     * stateToMerge
     *
     * @param {Object} stateToMerge defaults to this.state
     * @return {Object} the state
     */;
    _proto.getState = function getState$1(stateToMerge) {
      if (stateToMerge === void 0) {
        stateToMerge = this.state;
      }
      return getState(stateToMerge, this.props);
    };
    _proto.getItemCount = function getItemCount() {
      // things read better this way. They're in priority order:
      // 1. `this.itemCount`
      // 2. `this.props.itemCount`
      // 3. `this.items.length`
      var itemCount = this.items.length;
      if (this.itemCount != null) {
        itemCount = this.itemCount;
      } else if (this.props.itemCount !== undefined) {
        itemCount = this.props.itemCount;
      }
      return itemCount;
    };
    _proto.getItemNodeFromIndex = function getItemNodeFromIndex(index) {
      return this.props.environment.document.getElementById(this.getItemId(index));
    };
    _proto.scrollHighlightedItemIntoView = function scrollHighlightedItemIntoView() {
      /* istanbul ignore else (react-native) */
      {
        var node = this.getItemNodeFromIndex(this.getState().highlightedIndex);
        this.props.scrollIntoView(node, this._menuNode);
      }
    };
    _proto.moveHighlightedIndex = function moveHighlightedIndex(amount, otherStateToSet) {
      var _this6 = this;
      var itemCount = this.getItemCount();
      var _this$getState8 = this.getState(),
        highlightedIndex = _this$getState8.highlightedIndex;
      if (itemCount > 0) {
        var nextHighlightedIndex = getNextWrappingIndex(amount, highlightedIndex, itemCount, function (index) {
          return _this6.getItemNodeFromIndex(index);
        });
        this.setHighlightedIndex(nextHighlightedIndex, otherStateToSet);
      }
    };
    _proto.getStateAndHelpers = function getStateAndHelpers() {
      var _this$getState9 = this.getState(),
        highlightedIndex = _this$getState9.highlightedIndex,
        inputValue = _this$getState9.inputValue,
        selectedItem = _this$getState9.selectedItem,
        isOpen = _this$getState9.isOpen;
      var itemToString = this.props.itemToString;
      var id = this.id;
      var getRootProps = this.getRootProps,
        getToggleButtonProps = this.getToggleButtonProps,
        getLabelProps = this.getLabelProps,
        getMenuProps = this.getMenuProps,
        getInputProps = this.getInputProps,
        getItemProps = this.getItemProps,
        openMenu = this.openMenu,
        closeMenu = this.closeMenu,
        toggleMenu = this.toggleMenu,
        selectItem = this.selectItem,
        selectItemAtIndex = this.selectItemAtIndex,
        selectHighlightedItem = this.selectHighlightedItem,
        setHighlightedIndex = this.setHighlightedIndex,
        clearSelection = this.clearSelection,
        clearItems = this.clearItems,
        reset = this.reset,
        setItemCount = this.setItemCount,
        unsetItemCount = this.unsetItemCount,
        setState = this.internalSetState;
      return {
        // prop getters
        getRootProps: getRootProps,
        getToggleButtonProps: getToggleButtonProps,
        getLabelProps: getLabelProps,
        getMenuProps: getMenuProps,
        getInputProps: getInputProps,
        getItemProps: getItemProps,
        // actions
        reset: reset,
        openMenu: openMenu,
        closeMenu: closeMenu,
        toggleMenu: toggleMenu,
        selectItem: selectItem,
        selectItemAtIndex: selectItemAtIndex,
        selectHighlightedItem: selectHighlightedItem,
        setHighlightedIndex: setHighlightedIndex,
        clearSelection: clearSelection,
        clearItems: clearItems,
        setItemCount: setItemCount,
        unsetItemCount: unsetItemCount,
        setState: setState,
        // props
        itemToString: itemToString,
        // derived
        id: id,
        // state
        highlightedIndex: highlightedIndex,
        inputValue: inputValue,
        isOpen: isOpen,
        selectedItem: selectedItem
      };
    };
    _proto.componentDidMount = function componentDidMount() {
      var _this7 = this;
      /* istanbul ignore if (react-native) */
      if (false) {}

      /* istanbul ignore if (react-native) */
      {
        // this.isMouseDown helps us track whether the mouse is currently held down.
        // This is useful when the user clicks on an item in the list, but holds the mouse
        // down long enough for the list to disappear (because the blur event fires on the input)
        // this.isMouseDown is used in the blur handler on the input to determine whether the blur event should
        // trigger hiding the menu.
        var onMouseDown = function onMouseDown() {
          _this7.isMouseDown = true;
        };
        var onMouseUp = function onMouseUp(event) {
          _this7.isMouseDown = false;
          // if the target element or the activeElement is within a downshift node
          // then we don't want to reset downshift
          var contextWithinDownshift = targetWithinDownshift(event.target, [_this7._rootNode, _this7._menuNode], _this7.props.environment);
          if (!contextWithinDownshift && _this7.getState().isOpen) {
            _this7.reset({
              type: mouseUp
            }, function () {
              return _this7.props.onOuterClick(_this7.getStateAndHelpers());
            });
          }
        };
        // Touching an element in iOS gives focus and hover states, but touching out of
        // the element will remove hover, and persist the focus state, resulting in the
        // blur event not being triggered.
        // this.isTouchMove helps us track whether the user is tapping or swiping on a touch screen.
        // If the user taps outside of Downshift, the component should be reset,
        // but not if the user is swiping
        var onTouchStart = function onTouchStart() {
          _this7.isTouchMove = false;
        };
        var onTouchMove = function onTouchMove() {
          _this7.isTouchMove = true;
        };
        var onTouchEnd = function onTouchEnd(event) {
          var contextWithinDownshift = targetWithinDownshift(event.target, [_this7._rootNode, _this7._menuNode], _this7.props.environment, false);
          if (!_this7.isTouchMove && !contextWithinDownshift && _this7.getState().isOpen) {
            _this7.reset({
              type: touchEnd
            }, function () {
              return _this7.props.onOuterClick(_this7.getStateAndHelpers());
            });
          }
        };
        var environment = this.props.environment;
        environment.addEventListener('mousedown', onMouseDown);
        environment.addEventListener('mouseup', onMouseUp);
        environment.addEventListener('touchstart', onTouchStart);
        environment.addEventListener('touchmove', onTouchMove);
        environment.addEventListener('touchend', onTouchEnd);
        this.cleanup = function () {
          _this7.internalClearTimeouts();
          _this7.updateStatus.cancel();
          environment.removeEventListener('mousedown', onMouseDown);
          environment.removeEventListener('mouseup', onMouseUp);
          environment.removeEventListener('touchstart', onTouchStart);
          environment.removeEventListener('touchmove', onTouchMove);
          environment.removeEventListener('touchend', onTouchEnd);
        };
      }
    };
    _proto.shouldScroll = function shouldScroll(prevState, prevProps) {
      var _ref10 = this.props.highlightedIndex === undefined ? this.getState() : this.props,
        currentHighlightedIndex = _ref10.highlightedIndex;
      var _ref11 = prevProps.highlightedIndex === undefined ? prevState : prevProps,
        prevHighlightedIndex = _ref11.highlightedIndex;
      var scrollWhenOpen = currentHighlightedIndex && this.getState().isOpen && !prevState.isOpen;
      var scrollWhenNavigating = currentHighlightedIndex !== prevHighlightedIndex;
      return scrollWhenOpen || scrollWhenNavigating;
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
      if (false) {}
      if (isControlledProp(this.props, 'selectedItem') && this.props.selectedItemChanged(prevProps.selectedItem, this.props.selectedItem)) {
        this.internalSetState({
          type: controlledPropUpdatedSelectedItem,
          inputValue: this.props.itemToString(this.props.selectedItem)
        });
      }
      if (!this.avoidScrolling && this.shouldScroll(prevState, prevProps)) {
        this.scrollHighlightedItemIntoView();
      }

      /* istanbul ignore else (react-native) */
      {
        this.updateStatus();
      }
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
      this.cleanup(); // avoids memory leak
    };
    _proto.render = function render() {
      var children = unwrapArray(this.props.children, noop);
      // because the items are rerendered every time we call the children
      // we clear this out each render and it will be populated again as
      // getItemProps is called.
      this.clearItems();
      // we reset this so we know whether the user calls getRootProps during
      // this render. If they do then we don't need to do anything,
      // if they don't then we need to clone the element they return and
      // apply the props for them.
      this.getRootProps.called = false;
      this.getRootProps.refKey = undefined;
      this.getRootProps.suppressRefError = undefined;
      // we do something similar for getMenuProps
      this.getMenuProps.called = false;
      this.getMenuProps.refKey = undefined;
      this.getMenuProps.suppressRefError = undefined;
      // we do something similar for getLabelProps
      this.getLabelProps.called = false;
      // and something similar for getInputProps
      this.getInputProps.called = false;
      var element = unwrapArray(children(this.getStateAndHelpers()));
      if (!element) {
        return null;
      }
      if (this.getRootProps.called || this.props.suppressRefError) {
        if (false) {}
        return element;
      } else if (isDOMElement(element)) {
        // they didn't apply the root props, but we can clone
        // this and apply the props ourselves
        return /*#__PURE__*/cloneElement(element, this.getRootProps(getElementProps(element)));
      }

      /* istanbul ignore else */
      if (false) {}

      /* istanbul ignore next */
      return undefined;
    };
    return Downshift;
  }(Component);
  Downshift.defaultProps = {
    defaultHighlightedIndex: null,
    defaultIsOpen: false,
    getA11yStatusMessage: getA11yStatusMessage$1,
    itemToString: function itemToString(i) {
      if (i == null) {
        return '';
      }
      if (false) {}
      return String(i);
    },
    onStateChange: noop,
    onInputValueChange: noop,
    onUserAction: noop,
    onChange: noop,
    onSelect: noop,
    onOuterClick: noop,
    selectedItemChanged: function selectedItemChanged(prevItem, item) {
      return prevItem !== item;
    },
    environment: /* istanbul ignore next (ssr) */
    typeof window === 'undefined' ? {} : window,
    stateReducer: function stateReducer(state, stateToSet) {
      return stateToSet;
    },
    suppressRefError: false,
    scrollIntoView: scrollIntoView
  };
  Downshift.stateChangeTypes = stateChangeTypes$3;
  return Downshift;
}()));
 false ? 0 : void 0;
var Downshift$1 = (/* unused pure expression or super */ null && (Downshift));
function validateGetMenuPropsCalledCorrectly(node, _ref12) {
  var refKey = _ref12.refKey;
  if (!node) {
    // eslint-disable-next-line no-console
    console.error("downshift: The ref prop \"" + refKey + "\" from getMenuProps was not applied correctly on your menu element.");
  }
}
function validateGetRootPropsCalledCorrectly(element, _ref13) {
  var refKey = _ref13.refKey;
  var refKeySpecified = refKey !== 'ref';
  var isComposite = !isDOMElement(element);
  if (isComposite && !refKeySpecified && !isForwardRef(element)) {
    // eslint-disable-next-line no-console
    console.error('downshift: You returned a non-DOM element. You must specify a refKey in getRootProps');
  } else if (!isComposite && refKeySpecified) {
    // eslint-disable-next-line no-console
    console.error("downshift: You returned a DOM element. You should not specify a refKey in getRootProps. You specified \"" + refKey + "\"");
  }
  if (!isForwardRef(element) && !getElementProps(element)[refKey]) {
    // eslint-disable-next-line no-console
    console.error("downshift: You must apply the ref prop \"" + refKey + "\" from getRootProps onto your root element.");
  }
}

var _excluded$3 = ["isInitialMount", "highlightedIndex", "items", "environment"];
var dropdownDefaultStateValues = {
  highlightedIndex: -1,
  isOpen: false,
  selectedItem: null,
  inputValue: ''
};
function callOnChangeProps(action, state, newState) {
  var props = action.props,
    type = action.type;
  var changes = {};
  Object.keys(state).forEach(function (key) {
    invokeOnChangeHandler(key, action, state, newState);
    if (newState[key] !== state[key]) {
      changes[key] = newState[key];
    }
  });
  if (props.onStateChange && Object.keys(changes).length) {
    props.onStateChange((0,esm_extends/* default */.Z)({
      type: type
    }, changes));
  }
}
function invokeOnChangeHandler(key, action, state, newState) {
  var props = action.props,
    type = action.type;
  var handler = "on" + capitalizeString(key) + "Change";
  if (props[handler] && newState[key] !== undefined && newState[key] !== state[key]) {
    props[handler]((0,esm_extends/* default */.Z)({
      type: type
    }, newState));
  }
}

/**
 * Default state reducer that returns the changes.
 *
 * @param {Object} s state.
 * @param {Object} a action with changes.
 * @returns {Object} changes.
 */
function stateReducer(s, a) {
  return a.changes;
}

/**
 * Returns a message to be added to aria-live region when item is selected.
 *
 * @param {Object} selectionParameters Parameters required to build the message.
 * @returns {string} The a11y message.
 */
function getA11ySelectionMessage(selectionParameters) {
  var selectedItem = selectionParameters.selectedItem,
    itemToStringLocal = selectionParameters.itemToString;
  return selectedItem ? itemToStringLocal(selectedItem) + " has been selected." : '';
}

/**
 * Debounced call for updating the a11y message.
 */
var updateA11yStatus = debounce(function (getA11yMessage, document) {
  setStatus(getA11yMessage(), document);
}, 200);

// istanbul ignore next
var useIsomorphicLayoutEffect = typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined' ? react.useLayoutEffect : react.useEffect;
function useElementIds(_ref) {
  var _ref$id = _ref.id,
    id = _ref$id === void 0 ? "downshift-" + generateId() : _ref$id,
    labelId = _ref.labelId,
    menuId = _ref.menuId,
    getItemId = _ref.getItemId,
    toggleButtonId = _ref.toggleButtonId,
    inputId = _ref.inputId;
  var elementIdsRef = (0,react.useRef)({
    labelId: labelId || id + "-label",
    menuId: menuId || id + "-menu",
    getItemId: getItemId || function (index) {
      return id + "-item-" + index;
    },
    toggleButtonId: toggleButtonId || id + "-toggle-button",
    inputId: inputId || id + "-input"
  });
  return elementIdsRef.current;
}
function getItemAndIndex(itemProp, indexProp, items, errorMessage) {
  var item, index;
  if (itemProp === undefined) {
    if (indexProp === undefined) {
      throw new Error(errorMessage);
    }
    item = items[indexProp];
    index = indexProp;
  } else {
    index = indexProp === undefined ? items.indexOf(itemProp) : indexProp;
    item = itemProp;
  }
  return [item, index];
}
function itemToString(item) {
  return item ? String(item) : '';
}
function isAcceptedCharacterKey(key) {
  return /^\S{1}$/.test(key);
}
function capitalizeString(string) {
  return "" + string.slice(0, 1).toUpperCase() + string.slice(1);
}
function useLatestRef(val) {
  var ref = (0,react.useRef)(val);
  // technically this is not "concurrent mode safe" because we're manipulating
  // the value during render (so it's not idempotent). However, the places this
  // hook is used is to support memoizing callbacks which will be called
  // *during* render, so we need the latest values *during* render.
  // If not for this, then we'd probably want to use useLayoutEffect instead.
  ref.current = val;
  return ref;
}

/**
 * Computes the controlled state using a the previous state, props,
 * two reducers, one from downshift and an optional one from the user.
 * Also calls the onChange handlers for state values that have changed.
 *
 * @param {Function} reducer Reducer function from downshift.
 * @param {Object} initialState Initial state of the hook.
 * @param {Object} props The hook props.
 * @returns {Array} An array with the state and an action dispatcher.
 */
function useEnhancedReducer(reducer, initialState, props) {
  var prevStateRef = (0,react.useRef)();
  var actionRef = (0,react.useRef)();
  var enhancedReducer = (0,react.useCallback)(function (state, action) {
    actionRef.current = action;
    state = getState(state, action.props);
    var changes = reducer(state, action);
    var newState = action.props.stateReducer(state, (0,esm_extends/* default */.Z)({}, action, {
      changes: changes
    }));
    return newState;
  }, [reducer]);
  var _useReducer = (0,react.useReducer)(enhancedReducer, initialState),
    state = _useReducer[0],
    dispatch = _useReducer[1];
  var propsRef = useLatestRef(props);
  var dispatchWithProps = (0,react.useCallback)(function (action) {
    return dispatch((0,esm_extends/* default */.Z)({
      props: propsRef.current
    }, action));
  }, [propsRef]);
  var action = actionRef.current;
  (0,react.useEffect)(function () {
    if (action && prevStateRef.current && prevStateRef.current !== state) {
      callOnChangeProps(action, getState(prevStateRef.current, action.props), state);
    }
    prevStateRef.current = state;
  }, [state, props, action]);
  return [state, dispatchWithProps];
}

/**
 * Wraps the useEnhancedReducer and applies the controlled prop values before
 * returning the new state.
 *
 * @param {Function} reducer Reducer function from downshift.
 * @param {Object} initialState Initial state of the hook.
 * @param {Object} props The hook props.
 * @returns {Array} An array with the state and an action dispatcher.
 */
function useControlledReducer$1(reducer, initialState, props) {
  var _useEnhancedReducer = useEnhancedReducer(reducer, initialState, props),
    state = _useEnhancedReducer[0],
    dispatch = _useEnhancedReducer[1];
  return [getState(state, props), dispatch];
}
var defaultProps$3 = {
  itemToString: itemToString,
  stateReducer: stateReducer,
  getA11ySelectionMessage: getA11ySelectionMessage,
  scrollIntoView: scrollIntoView,
  environment: /* istanbul ignore next (ssr) */
  typeof window === 'undefined' ? {} : window
};
function getDefaultValue$1(props, propKey, defaultStateValues) {
  if (defaultStateValues === void 0) {
    defaultStateValues = dropdownDefaultStateValues;
  }
  var defaultValue = props["default" + capitalizeString(propKey)];
  if (defaultValue !== undefined) {
    return defaultValue;
  }
  return defaultStateValues[propKey];
}
function getInitialValue$1(props, propKey, defaultStateValues) {
  if (defaultStateValues === void 0) {
    defaultStateValues = dropdownDefaultStateValues;
  }
  var value = props[propKey];
  if (value !== undefined) {
    return value;
  }
  var initialValue = props["initial" + capitalizeString(propKey)];
  if (initialValue !== undefined) {
    return initialValue;
  }
  return getDefaultValue$1(props, propKey, defaultStateValues);
}
function getInitialState$2(props) {
  var selectedItem = getInitialValue$1(props, 'selectedItem');
  var isOpen = getInitialValue$1(props, 'isOpen');
  var highlightedIndex = getInitialValue$1(props, 'highlightedIndex');
  var inputValue = getInitialValue$1(props, 'inputValue');
  return {
    highlightedIndex: highlightedIndex < 0 && selectedItem && isOpen ? props.items.indexOf(selectedItem) : highlightedIndex,
    isOpen: isOpen,
    selectedItem: selectedItem,
    inputValue: inputValue
  };
}
function getHighlightedIndexOnOpen(props, state, offset) {
  var items = props.items,
    initialHighlightedIndex = props.initialHighlightedIndex,
    defaultHighlightedIndex = props.defaultHighlightedIndex;
  var selectedItem = state.selectedItem,
    highlightedIndex = state.highlightedIndex;
  if (items.length === 0) {
    return -1;
  }

  // initialHighlightedIndex will give value to highlightedIndex on initial state only.
  if (initialHighlightedIndex !== undefined && highlightedIndex === initialHighlightedIndex) {
    return initialHighlightedIndex;
  }
  if (defaultHighlightedIndex !== undefined) {
    return defaultHighlightedIndex;
  }
  if (selectedItem) {
    return items.indexOf(selectedItem);
  }
  if (offset === 0) {
    return -1;
  }
  return offset < 0 ? items.length - 1 : 0;
}

/**
 * Reuse the movement tracking of mouse and touch events.
 *
 * @param {boolean} isOpen Whether the dropdown is open or not.
 * @param {Array<Object>} downshiftElementRefs Downshift element refs to track movement (toggleButton, menu etc.)
 * @param {Object} environment Environment where component/hook exists.
 * @param {Function} handleBlur Handler on blur from mouse or touch.
 * @returns {Object} Ref containing whether mouseDown or touchMove event is happening
 */
function useMouseAndTouchTracker(isOpen, downshiftElementRefs, environment, handleBlur) {
  var mouseAndTouchTrackersRef = (0,react.useRef)({
    isMouseDown: false,
    isTouchMove: false
  });
  (0,react.useEffect)(function () {
    if ((environment == null ? void 0 : environment.addEventListener) == null) {
      return;
    }

    // The same strategy for checking if a click occurred inside or outside downshift
    // as in downshift.js.
    var onMouseDown = function onMouseDown() {
      mouseAndTouchTrackersRef.current.isMouseDown = true;
    };
    var onMouseUp = function onMouseUp(event) {
      mouseAndTouchTrackersRef.current.isMouseDown = false;
      if (isOpen && !targetWithinDownshift(event.target, downshiftElementRefs.map(function (ref) {
        return ref.current;
      }), environment)) {
        handleBlur();
      }
    };
    var onTouchStart = function onTouchStart() {
      mouseAndTouchTrackersRef.current.isTouchMove = false;
    };
    var onTouchMove = function onTouchMove() {
      mouseAndTouchTrackersRef.current.isTouchMove = true;
    };
    var onTouchEnd = function onTouchEnd(event) {
      if (isOpen && !mouseAndTouchTrackersRef.current.isTouchMove && !targetWithinDownshift(event.target, downshiftElementRefs.map(function (ref) {
        return ref.current;
      }), environment, false)) {
        handleBlur();
      }
    };
    environment.addEventListener('mousedown', onMouseDown);
    environment.addEventListener('mouseup', onMouseUp);
    environment.addEventListener('touchstart', onTouchStart);
    environment.addEventListener('touchmove', onTouchMove);
    environment.addEventListener('touchend', onTouchEnd);

    // eslint-disable-next-line consistent-return
    return function cleanup() {
      environment.removeEventListener('mousedown', onMouseDown);
      environment.removeEventListener('mouseup', onMouseUp);
      environment.removeEventListener('touchstart', onTouchStart);
      environment.removeEventListener('touchmove', onTouchMove);
      environment.removeEventListener('touchend', onTouchEnd);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen, environment]);
  return mouseAndTouchTrackersRef;
}

/* istanbul ignore next */
// eslint-disable-next-line import/no-mutable-exports
var useGetterPropsCalledChecker = function useGetterPropsCalledChecker() {
  return noop;
};
/**
 * Custom hook that checks if getter props are called correctly.
 *
 * @param  {...any} propKeys Getter prop names to be handled.
 * @returns {Function} Setter function called inside getter props to set call information.
 */
/* istanbul ignore next */
if (false) {}
function useA11yMessageSetter(getA11yMessage, dependencyArray, _ref2) {
  var isInitialMount = _ref2.isInitialMount,
    highlightedIndex = _ref2.highlightedIndex,
    items = _ref2.items,
    environment = _ref2.environment,
    rest = objectWithoutPropertiesLoose_objectWithoutPropertiesLoose(_ref2, _excluded$3);
  // Sets a11y status message on changes in state.
  (0,react.useEffect)(function () {
    if (isInitialMount || false) {
      return;
    }
    updateA11yStatus(function () {
      return getA11yMessage((0,esm_extends/* default */.Z)({
        highlightedIndex: highlightedIndex,
        highlightedItem: items[highlightedIndex],
        resultCount: items.length
      }, rest));
    }, environment.document);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, dependencyArray);
}
function useScrollIntoView(_ref3) {
  var highlightedIndex = _ref3.highlightedIndex,
    isOpen = _ref3.isOpen,
    itemRefs = _ref3.itemRefs,
    getItemNodeFromIndex = _ref3.getItemNodeFromIndex,
    menuElement = _ref3.menuElement,
    scrollIntoViewProp = _ref3.scrollIntoView;
  // used not to scroll on highlight by mouse.
  var shouldScrollRef = (0,react.useRef)(true);
  // Scroll on highlighted item if change comes from keyboard.
  useIsomorphicLayoutEffect(function () {
    if (highlightedIndex < 0 || !isOpen || !Object.keys(itemRefs.current).length) {
      return;
    }
    if (shouldScrollRef.current === false) {
      shouldScrollRef.current = true;
    } else {
      scrollIntoViewProp(getItemNodeFromIndex(highlightedIndex), menuElement);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [highlightedIndex]);
  return shouldScrollRef;
}

// eslint-disable-next-line import/no-mutable-exports
var useControlPropsValidator = noop;
/* istanbul ignore next */
if (false) {}

/**
 * Handles selection on Enter / Alt + ArrowUp. Closes the menu and resets the highlighted index, unless there is a highlighted.
 * In that case, selects the item and resets to defaults for open state and highlighted idex.
 * @param {Object} props The useCombobox props.
 * @param {number} highlightedIndex The index from the state.
 * @param {boolean} inputValue Also return the input value for state.
 * @returns The changes for the state.
 */
function getChangesOnSelection(props, highlightedIndex, inputValue) {
  var _props$items;
  if (inputValue === void 0) {
    inputValue = true;
  }
  var shouldSelect = ((_props$items = props.items) == null ? void 0 : _props$items.length) && highlightedIndex >= 0;
  return (0,esm_extends/* default */.Z)({
    isOpen: false,
    highlightedIndex: -1
  }, shouldSelect && (0,esm_extends/* default */.Z)({
    selectedItem: props.items[highlightedIndex],
    isOpen: getDefaultValue$1(props, 'isOpen'),
    highlightedIndex: getDefaultValue$1(props, 'highlightedIndex')
  }, inputValue && {
    inputValue: props.itemToString(props.items[highlightedIndex])
  }));
}

function downshiftCommonReducer(state, action, stateChangeTypes) {
  var type = action.type,
    props = action.props;
  var changes;
  switch (type) {
    case stateChangeTypes.ItemMouseMove:
      changes = {
        highlightedIndex: action.disabled ? -1 : action.index
      };
      break;
    case stateChangeTypes.MenuMouseLeave:
      changes = {
        highlightedIndex: -1
      };
      break;
    case stateChangeTypes.ToggleButtonClick:
    case stateChangeTypes.FunctionToggleMenu:
      changes = {
        isOpen: !state.isOpen,
        highlightedIndex: state.isOpen ? -1 : getHighlightedIndexOnOpen(props, state, 0)
      };
      break;
    case stateChangeTypes.FunctionOpenMenu:
      changes = {
        isOpen: true,
        highlightedIndex: getHighlightedIndexOnOpen(props, state, 0)
      };
      break;
    case stateChangeTypes.FunctionCloseMenu:
      changes = {
        isOpen: false
      };
      break;
    case stateChangeTypes.FunctionSetHighlightedIndex:
      changes = {
        highlightedIndex: action.highlightedIndex
      };
      break;
    case stateChangeTypes.FunctionSetInputValue:
      changes = {
        inputValue: action.inputValue
      };
      break;
    case stateChangeTypes.FunctionReset:
      changes = {
        highlightedIndex: getDefaultValue$1(props, 'highlightedIndex'),
        isOpen: getDefaultValue$1(props, 'isOpen'),
        selectedItem: getDefaultValue$1(props, 'selectedItem'),
        inputValue: getDefaultValue$1(props, 'inputValue')
      };
      break;
    default:
      throw new Error('Reducer called without proper action type.');
  }
  return (0,esm_extends/* default */.Z)({}, state, changes);
}
/* eslint-enable complexity */

function getItemIndexByCharacterKey(_a) {
    var keysSoFar = _a.keysSoFar, highlightedIndex = _a.highlightedIndex, items = _a.items, itemToString = _a.itemToString, getItemNodeFromIndex = _a.getItemNodeFromIndex;
    var lowerCasedKeysSoFar = keysSoFar.toLowerCase();
    for (var index = 0; index < items.length; index++) {
        // if we already have a search query in progress, we also consider the current highlighted item.
        var offsetIndex = (index + highlightedIndex + (keysSoFar.length < 2 ? 1 : 0)) % items.length;
        var item = items[offsetIndex];
        if (item !== undefined &&
            itemToString(item).toLowerCase().startsWith(lowerCasedKeysSoFar)) {
            var element = getItemNodeFromIndex(offsetIndex);
            if (!(element === null || element === void 0 ? void 0 : element.hasAttribute('disabled'))) {
                return offsetIndex;
            }
        }
    }
    return highlightedIndex;
}
var propTypes$2 = {
    items: (prop_types_default()).array.isRequired,
    itemToString: (prop_types_default()).func,
    getA11yStatusMessage: (prop_types_default()).func,
    getA11ySelectionMessage: (prop_types_default()).func,
    highlightedIndex: (prop_types_default()).number,
    defaultHighlightedIndex: (prop_types_default()).number,
    initialHighlightedIndex: (prop_types_default()).number,
    isOpen: (prop_types_default()).bool,
    defaultIsOpen: (prop_types_default()).bool,
    initialIsOpen: (prop_types_default()).bool,
    selectedItem: (prop_types_default()).any,
    initialSelectedItem: (prop_types_default()).any,
    defaultSelectedItem: (prop_types_default()).any,
    id: (prop_types_default()).string,
    labelId: (prop_types_default()).string,
    menuId: (prop_types_default()).string,
    getItemId: (prop_types_default()).func,
    toggleButtonId: (prop_types_default()).string,
    stateReducer: (prop_types_default()).func,
    onSelectedItemChange: (prop_types_default()).func,
    onHighlightedIndexChange: (prop_types_default()).func,
    onStateChange: (prop_types_default()).func,
    onIsOpenChange: (prop_types_default()).func,
    environment: prop_types_default().shape({
        addEventListener: (prop_types_default()).func,
        removeEventListener: (prop_types_default()).func,
        document: prop_types_default().shape({
            getElementById: (prop_types_default()).func,
            activeElement: (prop_types_default()).any,
            body: (prop_types_default()).any
        })
    })
};
/**
 * Default implementation for status message. Only added when menu is open.
 * Will specift if there are results in the list, and if so, how many,
 * and what keys are relevant.
 *
 * @param {Object} param the downshift state and other relevant properties
 * @return {String} the a11y status message
 */
function getA11yStatusMessage(_a) {
    var isOpen = _a.isOpen, resultCount = _a.resultCount, previousResultCount = _a.previousResultCount;
    if (!isOpen) {
        return '';
    }
    if (!resultCount) {
        return 'No results are available.';
    }
    if (resultCount !== previousResultCount) {
        return "".concat(resultCount, " result").concat(resultCount === 1 ? ' is' : 's are', " available, use up and down arrow keys to navigate. Press Enter or Space Bar keys to select.");
    }
    return '';
}
var defaultProps$2 = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, defaultProps$3), { getA11yStatusMessage: getA11yStatusMessage });
// eslint-disable-next-line import/no-mutable-exports
var validatePropTypes$2 = noop;
/* istanbul ignore next */
if (false) {}

var ToggleButtonClick$1 =  false ? 0 : 0;
var ToggleButtonKeyDownArrowDown =  false ? 0 : 1;
var ToggleButtonKeyDownArrowUp =  false ? 0 : 2;
var ToggleButtonKeyDownCharacter =  false ? 0 : 3;
var ToggleButtonKeyDownEscape =  false ? 0 : 4;
var ToggleButtonKeyDownHome =  false ? 0 : 5;
var ToggleButtonKeyDownEnd =  false ? 0 : 6;
var ToggleButtonKeyDownEnter =  false ? 0 : 7;
var ToggleButtonKeyDownSpaceButton =  false ? 0 : 8;
var ToggleButtonKeyDownPageUp =  false ? 0 : 9;
var ToggleButtonKeyDownPageDown =  false ? 0 : 10;
var ToggleButtonBlur =  false ? 0 : 11;
var MenuMouseLeave$1 =  false ? 0 : 12;
var ItemMouseMove$1 =  false ? 0 : 13;
var ItemClick$1 =  false ? 0 : 14;
var FunctionToggleMenu$1 =  false ? 0 : 15;
var FunctionOpenMenu$1 =  false ? 0 : 16;
var FunctionCloseMenu$1 =  false ? 0 : 17;
var FunctionSetHighlightedIndex$1 =  false ? 0 : 18;
var FunctionSelectItem$1 =  false ? 0 : 19;
var FunctionSetInputValue$1 =  false ? 0 : 20;
var FunctionReset$2 =  false ? 0 : 21;

var stateChangeTypes$2 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  ToggleButtonClick: ToggleButtonClick$1,
  ToggleButtonKeyDownArrowDown: ToggleButtonKeyDownArrowDown,
  ToggleButtonKeyDownArrowUp: ToggleButtonKeyDownArrowUp,
  ToggleButtonKeyDownCharacter: ToggleButtonKeyDownCharacter,
  ToggleButtonKeyDownEscape: ToggleButtonKeyDownEscape,
  ToggleButtonKeyDownHome: ToggleButtonKeyDownHome,
  ToggleButtonKeyDownEnd: ToggleButtonKeyDownEnd,
  ToggleButtonKeyDownEnter: ToggleButtonKeyDownEnter,
  ToggleButtonKeyDownSpaceButton: ToggleButtonKeyDownSpaceButton,
  ToggleButtonKeyDownPageUp: ToggleButtonKeyDownPageUp,
  ToggleButtonKeyDownPageDown: ToggleButtonKeyDownPageDown,
  ToggleButtonBlur: ToggleButtonBlur,
  MenuMouseLeave: MenuMouseLeave$1,
  ItemMouseMove: ItemMouseMove$1,
  ItemClick: ItemClick$1,
  FunctionToggleMenu: FunctionToggleMenu$1,
  FunctionOpenMenu: FunctionOpenMenu$1,
  FunctionCloseMenu: FunctionCloseMenu$1,
  FunctionSetHighlightedIndex: FunctionSetHighlightedIndex$1,
  FunctionSelectItem: FunctionSelectItem$1,
  FunctionSetInputValue: FunctionSetInputValue$1,
  FunctionReset: FunctionReset$2
});

/* eslint-disable complexity */
function downshiftSelectReducer(state, action) {
  var _props$items;
  var type = action.type,
    props = action.props,
    altKey = action.altKey;
  var changes;
  switch (type) {
    case ItemClick$1:
      changes = {
        isOpen: getDefaultValue$1(props, 'isOpen'),
        highlightedIndex: getDefaultValue$1(props, 'highlightedIndex'),
        selectedItem: props.items[action.index]
      };
      break;
    case ToggleButtonKeyDownCharacter:
      {
        var lowercasedKey = action.key;
        var inputValue = "" + state.inputValue + lowercasedKey;
        var prevHighlightedIndex = !state.isOpen && state.selectedItem ? props.items.indexOf(state.selectedItem) : state.highlightedIndex;
        var highlightedIndex = getItemIndexByCharacterKey({
          keysSoFar: inputValue,
          highlightedIndex: prevHighlightedIndex,
          items: props.items,
          itemToString: props.itemToString,
          getItemNodeFromIndex: action.getItemNodeFromIndex
        });
        changes = {
          inputValue: inputValue,
          highlightedIndex: highlightedIndex,
          isOpen: true
        };
      }
      break;
    case ToggleButtonKeyDownArrowDown:
      {
        var _highlightedIndex = state.isOpen ? getNextWrappingIndex(1, state.highlightedIndex, props.items.length, action.getItemNodeFromIndex, false) : altKey && state.selectedItem == null ? -1 : getHighlightedIndexOnOpen(props, state, 1);
        changes = {
          highlightedIndex: _highlightedIndex,
          isOpen: true
        };
      }
      break;
    case ToggleButtonKeyDownArrowUp:
      if (state.isOpen && altKey) {
        changes = getChangesOnSelection(props, state.highlightedIndex, false);
      } else {
        var _highlightedIndex2 = state.isOpen ? getNextWrappingIndex(-1, state.highlightedIndex, props.items.length, action.getItemNodeFromIndex, false) : getHighlightedIndexOnOpen(props, state, -1);
        changes = {
          highlightedIndex: _highlightedIndex2,
          isOpen: true
        };
      }
      break;
    // only triggered when menu is open.
    case ToggleButtonKeyDownEnter:
    case ToggleButtonKeyDownSpaceButton:
      changes = getChangesOnSelection(props, state.highlightedIndex, false);
      break;
    case ToggleButtonKeyDownHome:
      changes = {
        highlightedIndex: getNextNonDisabledIndex(1, 0, props.items.length, action.getItemNodeFromIndex, false),
        isOpen: true
      };
      break;
    case ToggleButtonKeyDownEnd:
      changes = {
        highlightedIndex: getNextNonDisabledIndex(-1, props.items.length - 1, props.items.length, action.getItemNodeFromIndex, false),
        isOpen: true
      };
      break;
    case ToggleButtonKeyDownPageUp:
      changes = {
        highlightedIndex: getNextWrappingIndex(-10, state.highlightedIndex, props.items.length, action.getItemNodeFromIndex, false)
      };
      break;
    case ToggleButtonKeyDownPageDown:
      changes = {
        highlightedIndex: getNextWrappingIndex(10, state.highlightedIndex, props.items.length, action.getItemNodeFromIndex, false)
      };
      break;
    case ToggleButtonKeyDownEscape:
      changes = {
        isOpen: false,
        highlightedIndex: -1
      };
      break;
    case ToggleButtonBlur:
      changes = (0,esm_extends/* default */.Z)({
        isOpen: false,
        highlightedIndex: -1
      }, state.highlightedIndex >= 0 && ((_props$items = props.items) == null ? void 0 : _props$items.length) && {
        selectedItem: props.items[state.highlightedIndex]
      });
      break;
    case FunctionSelectItem$1:
      changes = {
        selectedItem: action.selectedItem
      };
      break;
    default:
      return downshiftCommonReducer(state, action, stateChangeTypes$2);
  }
  return (0,esm_extends/* default */.Z)({}, state, changes);
}
/* eslint-enable complexity */

var _excluded$2 = ["onMouseLeave", "refKey", "onKeyDown", "onBlur", "ref"],
  _excluded2$2 = ["onBlur", "onClick", "onPress", "onKeyDown", "refKey", "ref"],
  _excluded3$1 = ["item", "index", "onMouseMove", "onClick", "onPress", "refKey", "ref", "disabled"];
downshift_esm_useSelect.stateChangeTypes = stateChangeTypes$2;
function downshift_esm_useSelect(userProps) {
  if (userProps === void 0) {
    userProps = {};
  }
  validatePropTypes$2(userProps, downshift_esm_useSelect);
  // Props defaults and destructuring.
  var props = (0,esm_extends/* default */.Z)({}, defaultProps$2, userProps);
  var items = props.items,
    scrollIntoView = props.scrollIntoView,
    environment = props.environment,
    itemToString = props.itemToString,
    getA11ySelectionMessage = props.getA11ySelectionMessage,
    getA11yStatusMessage = props.getA11yStatusMessage;
  // Initial state depending on controlled props.
  var initialState = getInitialState$2(props);
  var _useControlledReducer = useControlledReducer$1(downshiftSelectReducer, initialState, props),
    state = _useControlledReducer[0],
    dispatch = _useControlledReducer[1];
  var isOpen = state.isOpen,
    highlightedIndex = state.highlightedIndex,
    selectedItem = state.selectedItem,
    inputValue = state.inputValue;

  // Element efs.
  var toggleButtonRef = (0,react.useRef)(null);
  var menuRef = (0,react.useRef)(null);
  var itemRefs = (0,react.useRef)({});
  // used to keep the inputValue clearTimeout object between renders.
  var clearTimeoutRef = (0,react.useRef)(null);
  // prevent id re-generation between renders.
  var elementIds = useElementIds(props);
  // used to keep track of how many items we had on previous cycle.
  var previousResultCountRef = (0,react.useRef)();
  var isInitialMountRef = (0,react.useRef)(true);
  // utility callback to get item element.
  var latest = useLatestRef({
    state: state,
    props: props
  });

  // Some utils.
  var getItemNodeFromIndex = (0,react.useCallback)(function (index) {
    return itemRefs.current[elementIds.getItemId(index)];
  }, [elementIds]);

  // Effects.
  // Sets a11y status message on changes in state.
  useA11yMessageSetter(getA11yStatusMessage, [isOpen, highlightedIndex, inputValue, items], (0,esm_extends/* default */.Z)({
    isInitialMount: isInitialMountRef.current,
    previousResultCount: previousResultCountRef.current,
    items: items,
    environment: environment,
    itemToString: itemToString
  }, state));
  // Sets a11y status message on changes in selectedItem.
  useA11yMessageSetter(getA11ySelectionMessage, [selectedItem], (0,esm_extends/* default */.Z)({
    isInitialMount: isInitialMountRef.current,
    previousResultCount: previousResultCountRef.current,
    items: items,
    environment: environment,
    itemToString: itemToString
  }, state));
  // Scroll on highlighted item if change comes from keyboard.
  var shouldScrollRef = useScrollIntoView({
    menuElement: menuRef.current,
    highlightedIndex: highlightedIndex,
    isOpen: isOpen,
    itemRefs: itemRefs,
    scrollIntoView: scrollIntoView,
    getItemNodeFromIndex: getItemNodeFromIndex
  });

  // Sets cleanup for the keysSoFar callback, debounded after 500ms.
  (0,react.useEffect)(function () {
    // init the clean function here as we need access to dispatch.
    clearTimeoutRef.current = debounce(function (outerDispatch) {
      outerDispatch({
        type: FunctionSetInputValue$1,
        inputValue: ''
      });
    }, 500);

    // Cancel any pending debounced calls on mount
    return function () {
      clearTimeoutRef.current.cancel();
    };
  }, []);

  // Invokes the keysSoFar callback set up above.
  (0,react.useEffect)(function () {
    if (!inputValue) {
      return;
    }
    clearTimeoutRef.current(dispatch);
  }, [dispatch, inputValue]);
  useControlPropsValidator({
    isInitialMount: isInitialMountRef.current,
    props: props,
    state: state
  });
  (0,react.useEffect)(function () {
    if (isInitialMountRef.current) {
      return;
    }
    previousResultCountRef.current = items.length;
  });
  // Add mouse/touch events to document.
  var mouseAndTouchTrackersRef = useMouseAndTouchTracker(isOpen, [menuRef, toggleButtonRef], environment, function () {
    dispatch({
      type: ToggleButtonBlur
    });
  });
  var setGetterPropCallInfo = useGetterPropsCalledChecker('getMenuProps', 'getToggleButtonProps');
  // Make initial ref false.
  (0,react.useEffect)(function () {
    isInitialMountRef.current = false;
    return function () {
      isInitialMountRef.current = true;
    };
  }, []);
  // Reset itemRefs on close.
  (0,react.useEffect)(function () {
    if (!isOpen) {
      itemRefs.current = {};
    }
  }, [isOpen]);

  // Event handler functions.
  var toggleButtonKeyDownHandlers = (0,react.useMemo)(function () {
    return {
      ArrowDown: function ArrowDown(event) {
        event.preventDefault();
        dispatch({
          type: ToggleButtonKeyDownArrowDown,
          getItemNodeFromIndex: getItemNodeFromIndex,
          altKey: event.altKey
        });
      },
      ArrowUp: function ArrowUp(event) {
        event.preventDefault();
        dispatch({
          type: ToggleButtonKeyDownArrowUp,
          getItemNodeFromIndex: getItemNodeFromIndex,
          altKey: event.altKey
        });
      },
      Home: function Home(event) {
        event.preventDefault();
        dispatch({
          type: ToggleButtonKeyDownHome,
          getItemNodeFromIndex: getItemNodeFromIndex
        });
      },
      End: function End(event) {
        event.preventDefault();
        dispatch({
          type: ToggleButtonKeyDownEnd,
          getItemNodeFromIndex: getItemNodeFromIndex
        });
      },
      Escape: function Escape() {
        if (latest.current.state.isOpen) {
          dispatch({
            type: ToggleButtonKeyDownEscape
          });
        }
      },
      Enter: function Enter(event) {
        event.preventDefault();
        dispatch({
          type: latest.current.state.isOpen ? ToggleButtonKeyDownEnter : ToggleButtonClick$1
        });
      },
      PageUp: function PageUp(event) {
        if (latest.current.state.isOpen) {
          event.preventDefault();
          dispatch({
            type: ToggleButtonKeyDownPageUp,
            getItemNodeFromIndex: getItemNodeFromIndex
          });
        }
      },
      PageDown: function PageDown(event) {
        if (latest.current.state.isOpen) {
          event.preventDefault();
          dispatch({
            type: ToggleButtonKeyDownPageDown,
            getItemNodeFromIndex: getItemNodeFromIndex
          });
        }
      },
      ' ': function _(event) {
        event.preventDefault();
        var currentState = latest.current.state;
        if (!currentState.isOpen) {
          dispatch({
            type: ToggleButtonClick$1
          });
          return;
        }
        if (currentState.inputValue) {
          dispatch({
            type: ToggleButtonKeyDownCharacter,
            key: ' ',
            getItemNodeFromIndex: getItemNodeFromIndex
          });
        } else {
          dispatch({
            type: ToggleButtonKeyDownSpaceButton
          });
        }
      }
    };
  }, [dispatch, getItemNodeFromIndex, latest]);

  // Action functions.
  var toggleMenu = (0,react.useCallback)(function () {
    dispatch({
      type: FunctionToggleMenu$1
    });
  }, [dispatch]);
  var closeMenu = (0,react.useCallback)(function () {
    dispatch({
      type: FunctionCloseMenu$1
    });
  }, [dispatch]);
  var openMenu = (0,react.useCallback)(function () {
    dispatch({
      type: FunctionOpenMenu$1
    });
  }, [dispatch]);
  var setHighlightedIndex = (0,react.useCallback)(function (newHighlightedIndex) {
    dispatch({
      type: FunctionSetHighlightedIndex$1,
      highlightedIndex: newHighlightedIndex
    });
  }, [dispatch]);
  var selectItem = (0,react.useCallback)(function (newSelectedItem) {
    dispatch({
      type: FunctionSelectItem$1,
      selectedItem: newSelectedItem
    });
  }, [dispatch]);
  var reset = (0,react.useCallback)(function () {
    dispatch({
      type: FunctionReset$2
    });
  }, [dispatch]);
  var setInputValue = (0,react.useCallback)(function (newInputValue) {
    dispatch({
      type: FunctionSetInputValue$1,
      inputValue: newInputValue
    });
  }, [dispatch]);
  // Getter functions.
  var getLabelProps = (0,react.useCallback)(function (labelProps) {
    return (0,esm_extends/* default */.Z)({
      id: elementIds.labelId,
      htmlFor: elementIds.toggleButtonId
    }, labelProps);
  }, [elementIds]);
  var getMenuProps = (0,react.useCallback)(function (_temp, _temp2) {
    var _extends2;
    var _ref = _temp === void 0 ? {} : _temp,
      onMouseLeave = _ref.onMouseLeave,
      _ref$refKey = _ref.refKey,
      refKey = _ref$refKey === void 0 ? 'ref' : _ref$refKey;
      _ref.onKeyDown;
      _ref.onBlur;
      var ref = _ref.ref,
      rest = objectWithoutPropertiesLoose_objectWithoutPropertiesLoose(_ref, _excluded$2);
    var _ref2 = _temp2 === void 0 ? {} : _temp2,
      _ref2$suppressRefErro = _ref2.suppressRefError,
      suppressRefError = _ref2$suppressRefErro === void 0 ? false : _ref2$suppressRefErro;
    var menuHandleMouseLeave = function menuHandleMouseLeave() {
      dispatch({
        type: MenuMouseLeave$1
      });
    };
    setGetterPropCallInfo('getMenuProps', suppressRefError, refKey, menuRef);
    return (0,esm_extends/* default */.Z)((_extends2 = {}, _extends2[refKey] = handleRefs(ref, function (menuNode) {
      menuRef.current = menuNode;
    }), _extends2.id = elementIds.menuId, _extends2.role = 'listbox', _extends2['aria-labelledby'] = rest && rest['aria-label'] ? undefined : "" + elementIds.labelId, _extends2.onMouseLeave = callAllEventHandlers(onMouseLeave, menuHandleMouseLeave), _extends2), rest);
  }, [dispatch, setGetterPropCallInfo, elementIds]);
  var getToggleButtonProps = (0,react.useCallback)(function (_temp3, _temp4) {
    var _extends3;
    var _ref3 = _temp3 === void 0 ? {} : _temp3,
      onBlur = _ref3.onBlur,
      onClick = _ref3.onClick;
      _ref3.onPress;
      var onKeyDown = _ref3.onKeyDown,
      _ref3$refKey = _ref3.refKey,
      refKey = _ref3$refKey === void 0 ? 'ref' : _ref3$refKey,
      ref = _ref3.ref,
      rest = objectWithoutPropertiesLoose_objectWithoutPropertiesLoose(_ref3, _excluded2$2);
    var _ref4 = _temp4 === void 0 ? {} : _temp4,
      _ref4$suppressRefErro = _ref4.suppressRefError,
      suppressRefError = _ref4$suppressRefErro === void 0 ? false : _ref4$suppressRefErro;
    var latestState = latest.current.state;
    var toggleButtonHandleClick = function toggleButtonHandleClick() {
      dispatch({
        type: ToggleButtonClick$1
      });
    };
    var toggleButtonHandleBlur = function toggleButtonHandleBlur() {
      if (latestState.isOpen && !mouseAndTouchTrackersRef.current.isMouseDown) {
        dispatch({
          type: ToggleButtonBlur
        });
      }
    };
    var toggleButtonHandleKeyDown = function toggleButtonHandleKeyDown(event) {
      var key = normalizeArrowKey(event);
      if (key && toggleButtonKeyDownHandlers[key]) {
        toggleButtonKeyDownHandlers[key](event);
      } else if (isAcceptedCharacterKey(key)) {
        dispatch({
          type: ToggleButtonKeyDownCharacter,
          key: key,
          getItemNodeFromIndex: getItemNodeFromIndex
        });
      }
    };
    var toggleProps = (0,esm_extends/* default */.Z)((_extends3 = {}, _extends3[refKey] = handleRefs(ref, function (toggleButtonNode) {
      toggleButtonRef.current = toggleButtonNode;
    }), _extends3['aria-activedescendant'] = latestState.isOpen && latestState.highlightedIndex > -1 ? elementIds.getItemId(latestState.highlightedIndex) : '', _extends3['aria-controls'] = elementIds.menuId, _extends3['aria-expanded'] = latest.current.state.isOpen, _extends3['aria-haspopup'] = 'listbox', _extends3['aria-labelledby'] = rest && rest['aria-label'] ? undefined : "" + elementIds.labelId, _extends3.id = elementIds.toggleButtonId, _extends3.role = 'combobox', _extends3.tabIndex = 0, _extends3.onBlur = callAllEventHandlers(onBlur, toggleButtonHandleBlur), _extends3), rest);
    if (!rest.disabled) {
      /* istanbul ignore if (react-native) */
      {
        toggleProps.onClick = callAllEventHandlers(onClick, toggleButtonHandleClick);
        toggleProps.onKeyDown = callAllEventHandlers(onKeyDown, toggleButtonHandleKeyDown);
      }
    }
    setGetterPropCallInfo('getToggleButtonProps', suppressRefError, refKey, toggleButtonRef);
    return toggleProps;
  }, [latest, elementIds, setGetterPropCallInfo, dispatch, mouseAndTouchTrackersRef, toggleButtonKeyDownHandlers, getItemNodeFromIndex]);
  var getItemProps = (0,react.useCallback)(function (_temp5) {
    var _extends4;
    var _ref5 = _temp5 === void 0 ? {} : _temp5,
      itemProp = _ref5.item,
      indexProp = _ref5.index,
      onMouseMove = _ref5.onMouseMove,
      onClick = _ref5.onClick;
      _ref5.onPress;
      var _ref5$refKey = _ref5.refKey,
      refKey = _ref5$refKey === void 0 ? 'ref' : _ref5$refKey,
      ref = _ref5.ref,
      disabled = _ref5.disabled,
      rest = objectWithoutPropertiesLoose_objectWithoutPropertiesLoose(_ref5, _excluded3$1);
    var _latest$current = latest.current,
      latestState = _latest$current.state,
      latestProps = _latest$current.props;
    var _getItemAndIndex = getItemAndIndex(itemProp, indexProp, latestProps.items, 'Pass either item or index to getItemProps!'),
      item = _getItemAndIndex[0],
      index = _getItemAndIndex[1];
    var itemHandleMouseMove = function itemHandleMouseMove() {
      if (index === latestState.highlightedIndex) {
        return;
      }
      shouldScrollRef.current = false;
      dispatch({
        type: ItemMouseMove$1,
        index: index,
        disabled: disabled
      });
    };
    var itemHandleClick = function itemHandleClick() {
      dispatch({
        type: ItemClick$1,
        index: index
      });
    };
    var itemProps = (0,esm_extends/* default */.Z)((_extends4 = {
      disabled: disabled,
      role: 'option',
      'aria-selected': "" + (item === selectedItem),
      id: elementIds.getItemId(index)
    }, _extends4[refKey] = handleRefs(ref, function (itemNode) {
      if (itemNode) {
        itemRefs.current[elementIds.getItemId(index)] = itemNode;
      }
    }), _extends4), rest);
    if (!disabled) {
      /* istanbul ignore next (react-native) */
      {
        itemProps.onClick = callAllEventHandlers(onClick, itemHandleClick);
      }
    }
    itemProps.onMouseMove = callAllEventHandlers(onMouseMove, itemHandleMouseMove);
    return itemProps;
  }, [latest, selectedItem, elementIds, shouldScrollRef, dispatch]);
  return {
    // prop getters.
    getToggleButtonProps: getToggleButtonProps,
    getLabelProps: getLabelProps,
    getMenuProps: getMenuProps,
    getItemProps: getItemProps,
    // actions.
    toggleMenu: toggleMenu,
    openMenu: openMenu,
    closeMenu: closeMenu,
    setHighlightedIndex: setHighlightedIndex,
    selectItem: selectItem,
    reset: reset,
    setInputValue: setInputValue,
    // state.
    highlightedIndex: highlightedIndex,
    isOpen: isOpen,
    selectedItem: selectedItem,
    inputValue: inputValue
  };
}

var InputKeyDownArrowDown =  false ? 0 : 0;
var InputKeyDownArrowUp =  false ? 0 : 1;
var InputKeyDownEscape =  false ? 0 : 2;
var InputKeyDownHome =  false ? 0 : 3;
var InputKeyDownEnd =  false ? 0 : 4;
var InputKeyDownPageUp =  false ? 0 : 5;
var InputKeyDownPageDown =  false ? 0 : 6;
var InputKeyDownEnter =  false ? 0 : 7;
var InputChange =  false ? 0 : 8;
var InputBlur =  false ? 0 : 9;
var InputFocus =  false ? 0 : 10;
var MenuMouseLeave =  false ? 0 : 11;
var ItemMouseMove =  false ? 0 : 12;
var ItemClick =  false ? 0 : 13;
var ToggleButtonClick =  false ? 0 : 14;
var FunctionToggleMenu =  false ? 0 : 15;
var FunctionOpenMenu =  false ? 0 : 16;
var FunctionCloseMenu =  false ? 0 : 17;
var FunctionSetHighlightedIndex =  false ? 0 : 18;
var FunctionSelectItem =  false ? 0 : 19;
var FunctionSetInputValue =  false ? 0 : 20;
var FunctionReset$1 =  false ? 0 : 21;
var ControlledPropUpdatedSelectedItem =  false ? 0 : 22;

var stateChangeTypes$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  InputKeyDownArrowDown: InputKeyDownArrowDown,
  InputKeyDownArrowUp: InputKeyDownArrowUp,
  InputKeyDownEscape: InputKeyDownEscape,
  InputKeyDownHome: InputKeyDownHome,
  InputKeyDownEnd: InputKeyDownEnd,
  InputKeyDownPageUp: InputKeyDownPageUp,
  InputKeyDownPageDown: InputKeyDownPageDown,
  InputKeyDownEnter: InputKeyDownEnter,
  InputChange: InputChange,
  InputBlur: InputBlur,
  InputFocus: InputFocus,
  MenuMouseLeave: MenuMouseLeave,
  ItemMouseMove: ItemMouseMove,
  ItemClick: ItemClick,
  ToggleButtonClick: ToggleButtonClick,
  FunctionToggleMenu: FunctionToggleMenu,
  FunctionOpenMenu: FunctionOpenMenu,
  FunctionCloseMenu: FunctionCloseMenu,
  FunctionSetHighlightedIndex: FunctionSetHighlightedIndex,
  FunctionSelectItem: FunctionSelectItem,
  FunctionSetInputValue: FunctionSetInputValue,
  FunctionReset: FunctionReset$1,
  ControlledPropUpdatedSelectedItem: ControlledPropUpdatedSelectedItem
});

function getInitialState$1(props) {
  var initialState = getInitialState$2(props);
  var selectedItem = initialState.selectedItem;
  var inputValue = initialState.inputValue;
  if (inputValue === '' && selectedItem && props.defaultInputValue === undefined && props.initialInputValue === undefined && props.inputValue === undefined) {
    inputValue = props.itemToString(selectedItem);
  }
  return (0,esm_extends/* default */.Z)({}, initialState, {
    inputValue: inputValue
  });
}
var propTypes$1 = {
  items: (prop_types_default()).array.isRequired,
  itemToString: (prop_types_default()).func,
  selectedItemChanged: (prop_types_default()).func,
  getA11yStatusMessage: (prop_types_default()).func,
  getA11ySelectionMessage: (prop_types_default()).func,
  highlightedIndex: (prop_types_default()).number,
  defaultHighlightedIndex: (prop_types_default()).number,
  initialHighlightedIndex: (prop_types_default()).number,
  isOpen: (prop_types_default()).bool,
  defaultIsOpen: (prop_types_default()).bool,
  initialIsOpen: (prop_types_default()).bool,
  selectedItem: (prop_types_default()).any,
  initialSelectedItem: (prop_types_default()).any,
  defaultSelectedItem: (prop_types_default()).any,
  inputValue: (prop_types_default()).string,
  defaultInputValue: (prop_types_default()).string,
  initialInputValue: (prop_types_default()).string,
  id: (prop_types_default()).string,
  labelId: (prop_types_default()).string,
  menuId: (prop_types_default()).string,
  getItemId: (prop_types_default()).func,
  inputId: (prop_types_default()).string,
  toggleButtonId: (prop_types_default()).string,
  stateReducer: (prop_types_default()).func,
  onSelectedItemChange: (prop_types_default()).func,
  onHighlightedIndexChange: (prop_types_default()).func,
  onStateChange: (prop_types_default()).func,
  onIsOpenChange: (prop_types_default()).func,
  onInputValueChange: (prop_types_default()).func,
  environment: prop_types_default().shape({
    addEventListener: (prop_types_default()).func,
    removeEventListener: (prop_types_default()).func,
    document: prop_types_default().shape({
      getElementById: (prop_types_default()).func,
      activeElement: (prop_types_default()).any,
      body: (prop_types_default()).any
    })
  })
};

/**
 * The useCombobox version of useControlledReducer, which also
 * checks if the controlled prop selectedItem changed between
 * renders. If so, it will also update inputValue with its
 * string equivalent. It uses the common useEnhancedReducer to
 * compute the rest of the state.
 *
 * @param {Function} reducer Reducer function from downshift.
 * @param {Object} initialState Initial state of the hook.
 * @param {Object} props The hook props.
 * @returns {Array} An array with the state and an action dispatcher.
 */
function useControlledReducer(reducer, initialState, props) {
  var previousSelectedItemRef = (0,react.useRef)();
  var _useEnhancedReducer = useEnhancedReducer(reducer, initialState, props),
    state = _useEnhancedReducer[0],
    dispatch = _useEnhancedReducer[1];

  // ToDo: if needed, make same approach as selectedItemChanged from Downshift.
  (0,react.useEffect)(function () {
    if (!isControlledProp(props, 'selectedItem')) {
      return;
    }
    if (props.selectedItemChanged(previousSelectedItemRef.current, props.selectedItem)) {
      dispatch({
        type: ControlledPropUpdatedSelectedItem,
        inputValue: props.itemToString(props.selectedItem)
      });
    }
    previousSelectedItemRef.current = state.selectedItem === previousSelectedItemRef.current ? props.selectedItem : state.selectedItem;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.selectedItem, props.selectedItem]);
  return [getState(state, props), dispatch];
}

// eslint-disable-next-line import/no-mutable-exports
var validatePropTypes$1 = noop;
/* istanbul ignore next */
if (false) {}
var defaultProps$1 = (0,esm_extends/* default */.Z)({}, defaultProps$3, {
  selectedItemChanged: function selectedItemChanged(prevItem, item) {
    return prevItem !== item;
  },
  getA11yStatusMessage: getA11yStatusMessage$1
});

/* eslint-disable complexity */
function downshiftUseComboboxReducer(state, action) {
  var _props$items;
  var type = action.type,
    props = action.props,
    altKey = action.altKey;
  var changes;
  switch (type) {
    case ItemClick:
      changes = {
        isOpen: getDefaultValue$1(props, 'isOpen'),
        highlightedIndex: getDefaultValue$1(props, 'highlightedIndex'),
        selectedItem: props.items[action.index],
        inputValue: props.itemToString(props.items[action.index])
      };
      break;
    case InputKeyDownArrowDown:
      if (state.isOpen) {
        changes = {
          highlightedIndex: getNextWrappingIndex(1, state.highlightedIndex, props.items.length, action.getItemNodeFromIndex, true)
        };
      } else {
        changes = {
          highlightedIndex: altKey && state.selectedItem == null ? -1 : getHighlightedIndexOnOpen(props, state, 1, action.getItemNodeFromIndex),
          isOpen: props.items.length >= 0
        };
      }
      break;
    case InputKeyDownArrowUp:
      if (state.isOpen) {
        if (altKey) {
          changes = getChangesOnSelection(props, state.highlightedIndex);
        } else {
          changes = {
            highlightedIndex: getNextWrappingIndex(-1, state.highlightedIndex, props.items.length, action.getItemNodeFromIndex, true)
          };
        }
      } else {
        changes = {
          highlightedIndex: getHighlightedIndexOnOpen(props, state, -1, action.getItemNodeFromIndex),
          isOpen: props.items.length >= 0
        };
      }
      break;
    case InputKeyDownEnter:
      changes = getChangesOnSelection(props, state.highlightedIndex);
      break;
    case InputKeyDownEscape:
      changes = (0,esm_extends/* default */.Z)({
        isOpen: false,
        highlightedIndex: -1
      }, !state.isOpen && {
        selectedItem: null,
        inputValue: ''
      });
      break;
    case InputKeyDownPageUp:
      changes = {
        highlightedIndex: getNextWrappingIndex(-10, state.highlightedIndex, props.items.length, action.getItemNodeFromIndex, false)
      };
      break;
    case InputKeyDownPageDown:
      changes = {
        highlightedIndex: getNextWrappingIndex(10, state.highlightedIndex, props.items.length, action.getItemNodeFromIndex, false)
      };
      break;
    case InputKeyDownHome:
      changes = {
        highlightedIndex: getNextNonDisabledIndex(1, 0, props.items.length, action.getItemNodeFromIndex, false)
      };
      break;
    case InputKeyDownEnd:
      changes = {
        highlightedIndex: getNextNonDisabledIndex(-1, props.items.length - 1, props.items.length, action.getItemNodeFromIndex, false)
      };
      break;
    case InputBlur:
      changes = (0,esm_extends/* default */.Z)({
        isOpen: false,
        highlightedIndex: -1
      }, state.highlightedIndex >= 0 && ((_props$items = props.items) == null ? void 0 : _props$items.length) && action.selectItem && {
        selectedItem: props.items[state.highlightedIndex],
        inputValue: props.itemToString(props.items[state.highlightedIndex])
      });
      break;
    case InputChange:
      changes = {
        isOpen: true,
        highlightedIndex: getDefaultValue$1(props, 'highlightedIndex'),
        inputValue: action.inputValue
      };
      break;
    case InputFocus:
      changes = {
        isOpen: true,
        highlightedIndex: getHighlightedIndexOnOpen(props, state, 0)
      };
      break;
    case FunctionSelectItem:
      changes = {
        selectedItem: action.selectedItem,
        inputValue: props.itemToString(action.selectedItem)
      };
      break;
    case ControlledPropUpdatedSelectedItem:
      changes = {
        inputValue: action.inputValue
      };
      break;
    default:
      return downshiftCommonReducer(state, action, stateChangeTypes$1);
  }
  return (0,esm_extends/* default */.Z)({}, state, changes);
}
/* eslint-enable complexity */

var _excluded$1 = ["onMouseLeave", "refKey", "ref"],
  _excluded2$1 = ["item", "index", "refKey", "ref", "onMouseMove", "onMouseDown", "onClick", "onPress", "disabled"],
  _excluded3 = ["onClick", "onPress", "refKey", "ref"],
  _excluded4 = ["onKeyDown", "onChange", "onInput", "onFocus", "onBlur", "onChangeText", "refKey", "ref"];
useCombobox.stateChangeTypes = stateChangeTypes$1;
function useCombobox(userProps) {
  if (userProps === void 0) {
    userProps = {};
  }
  validatePropTypes$1(userProps, useCombobox);
  // Props defaults and destructuring.
  var props = (0,esm_extends/* default */.Z)({}, defaultProps$1, userProps);
  var initialIsOpen = props.initialIsOpen,
    defaultIsOpen = props.defaultIsOpen,
    items = props.items,
    scrollIntoView = props.scrollIntoView,
    environment = props.environment,
    getA11yStatusMessage = props.getA11yStatusMessage,
    getA11ySelectionMessage = props.getA11ySelectionMessage,
    itemToString = props.itemToString;
  // Initial state depending on controlled props.
  var initialState = getInitialState$1(props);
  var _useControlledReducer = useControlledReducer(downshiftUseComboboxReducer, initialState, props),
    state = _useControlledReducer[0],
    dispatch = _useControlledReducer[1];
  var isOpen = state.isOpen,
    highlightedIndex = state.highlightedIndex,
    selectedItem = state.selectedItem,
    inputValue = state.inputValue;

  // Element refs.
  var menuRef = (0,react.useRef)(null);
  var itemRefs = (0,react.useRef)({});
  var inputRef = (0,react.useRef)(null);
  var toggleButtonRef = (0,react.useRef)(null);
  var isInitialMountRef = (0,react.useRef)(true);
  // prevent id re-generation between renders.
  var elementIds = useElementIds(props);
  // used to keep track of how many items we had on previous cycle.
  var previousResultCountRef = (0,react.useRef)();
  // utility callback to get item element.
  var latest = useLatestRef({
    state: state,
    props: props
  });
  var getItemNodeFromIndex = (0,react.useCallback)(function (index) {
    return itemRefs.current[elementIds.getItemId(index)];
  }, [elementIds]);

  // Effects.
  // Sets a11y status message on changes in state.
  useA11yMessageSetter(getA11yStatusMessage, [isOpen, highlightedIndex, inputValue, items], (0,esm_extends/* default */.Z)({
    isInitialMount: isInitialMountRef.current,
    previousResultCount: previousResultCountRef.current,
    items: items,
    environment: environment,
    itemToString: itemToString
  }, state));
  // Sets a11y status message on changes in selectedItem.
  useA11yMessageSetter(getA11ySelectionMessage, [selectedItem], (0,esm_extends/* default */.Z)({
    isInitialMount: isInitialMountRef.current,
    previousResultCount: previousResultCountRef.current,
    items: items,
    environment: environment,
    itemToString: itemToString
  }, state));
  // Scroll on highlighted item if change comes from keyboard.
  var shouldScrollRef = useScrollIntoView({
    menuElement: menuRef.current,
    highlightedIndex: highlightedIndex,
    isOpen: isOpen,
    itemRefs: itemRefs,
    scrollIntoView: scrollIntoView,
    getItemNodeFromIndex: getItemNodeFromIndex
  });
  useControlPropsValidator({
    isInitialMount: isInitialMountRef.current,
    props: props,
    state: state
  });
  // Focus the input on first render if required.
  (0,react.useEffect)(function () {
    var focusOnOpen = initialIsOpen || defaultIsOpen || isOpen;
    if (focusOnOpen && inputRef.current) {
      inputRef.current.focus();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  (0,react.useEffect)(function () {
    if (isInitialMountRef.current) {
      return;
    }
    previousResultCountRef.current = items.length;
  });
  // Add mouse/touch events to document.
  var mouseAndTouchTrackersRef = useMouseAndTouchTracker(isOpen, [inputRef, menuRef, toggleButtonRef], environment, function () {
    dispatch({
      type: InputBlur,
      selectItem: false
    });
  });
  var setGetterPropCallInfo = useGetterPropsCalledChecker('getInputProps', 'getMenuProps');
  // Make initial ref false.
  (0,react.useEffect)(function () {
    isInitialMountRef.current = false;
    return function () {
      isInitialMountRef.current = true;
    };
  }, []);
  // Reset itemRefs on close.
  (0,react.useEffect)(function () {
    var _environment$document;
    if (!isOpen) {
      itemRefs.current = {};
    } else if (((_environment$document = environment.document) == null ? void 0 : _environment$document.activeElement) !== inputRef.current) {
      var _inputRef$current;
      inputRef == null ? void 0 : (_inputRef$current = inputRef.current) == null ? void 0 : _inputRef$current.focus();
    }
  }, [isOpen, environment]);

  /* Event handler functions */
  var inputKeyDownHandlers = (0,react.useMemo)(function () {
    return {
      ArrowDown: function ArrowDown(event) {
        event.preventDefault();
        dispatch({
          type: InputKeyDownArrowDown,
          altKey: event.altKey,
          getItemNodeFromIndex: getItemNodeFromIndex
        });
      },
      ArrowUp: function ArrowUp(event) {
        event.preventDefault();
        dispatch({
          type: InputKeyDownArrowUp,
          altKey: event.altKey,
          getItemNodeFromIndex: getItemNodeFromIndex
        });
      },
      Home: function Home(event) {
        if (!latest.current.state.isOpen) {
          return;
        }
        event.preventDefault();
        dispatch({
          type: InputKeyDownHome,
          getItemNodeFromIndex: getItemNodeFromIndex
        });
      },
      End: function End(event) {
        if (!latest.current.state.isOpen) {
          return;
        }
        event.preventDefault();
        dispatch({
          type: InputKeyDownEnd,
          getItemNodeFromIndex: getItemNodeFromIndex
        });
      },
      Escape: function Escape(event) {
        var latestState = latest.current.state;
        if (latestState.isOpen || latestState.inputValue || latestState.selectedItem || latestState.highlightedIndex > -1) {
          event.preventDefault();
          dispatch({
            type: InputKeyDownEscape
          });
        }
      },
      Enter: function Enter(event) {
        var latestState = latest.current.state;
        // if closed or no highlighted index, do nothing.
        if (!latestState.isOpen || event.which === 229 // if IME composing, wait for next Enter keydown event.
        ) {
          return;
        }
        event.preventDefault();
        dispatch({
          type: InputKeyDownEnter,
          getItemNodeFromIndex: getItemNodeFromIndex
        });
      },
      PageUp: function PageUp(event) {
        if (latest.current.state.isOpen) {
          event.preventDefault();
          dispatch({
            type: InputKeyDownPageUp,
            getItemNodeFromIndex: getItemNodeFromIndex
          });
        }
      },
      PageDown: function PageDown(event) {
        if (latest.current.state.isOpen) {
          event.preventDefault();
          dispatch({
            type: InputKeyDownPageDown,
            getItemNodeFromIndex: getItemNodeFromIndex
          });
        }
      }
    };
  }, [dispatch, latest, getItemNodeFromIndex]);

  // Getter props.
  var getLabelProps = (0,react.useCallback)(function (labelProps) {
    return (0,esm_extends/* default */.Z)({
      id: elementIds.labelId,
      htmlFor: elementIds.inputId
    }, labelProps);
  }, [elementIds]);
  var getMenuProps = (0,react.useCallback)(function (_temp, _temp2) {
    var _extends2;
    var _ref = _temp === void 0 ? {} : _temp,
      onMouseLeave = _ref.onMouseLeave,
      _ref$refKey = _ref.refKey,
      refKey = _ref$refKey === void 0 ? 'ref' : _ref$refKey,
      ref = _ref.ref,
      rest = objectWithoutPropertiesLoose_objectWithoutPropertiesLoose(_ref, _excluded$1);
    var _ref2 = _temp2 === void 0 ? {} : _temp2,
      _ref2$suppressRefErro = _ref2.suppressRefError,
      suppressRefError = _ref2$suppressRefErro === void 0 ? false : _ref2$suppressRefErro;
    setGetterPropCallInfo('getMenuProps', suppressRefError, refKey, menuRef);
    return (0,esm_extends/* default */.Z)((_extends2 = {}, _extends2[refKey] = handleRefs(ref, function (menuNode) {
      menuRef.current = menuNode;
    }), _extends2.id = elementIds.menuId, _extends2.role = 'listbox', _extends2['aria-labelledby'] = rest && rest['aria-label'] ? undefined : "" + elementIds.labelId, _extends2.onMouseLeave = callAllEventHandlers(onMouseLeave, function () {
      dispatch({
        type: MenuMouseLeave
      });
    }), _extends2), rest);
  }, [dispatch, setGetterPropCallInfo, elementIds]);
  var getItemProps = (0,react.useCallback)(function (_temp3) {
    var _extends3, _ref4;
    var _ref3 = _temp3 === void 0 ? {} : _temp3,
      itemProp = _ref3.item,
      indexProp = _ref3.index,
      _ref3$refKey = _ref3.refKey,
      refKey = _ref3$refKey === void 0 ? 'ref' : _ref3$refKey,
      ref = _ref3.ref,
      onMouseMove = _ref3.onMouseMove,
      onMouseDown = _ref3.onMouseDown,
      onClick = _ref3.onClick;
      _ref3.onPress;
      var disabled = _ref3.disabled,
      rest = objectWithoutPropertiesLoose_objectWithoutPropertiesLoose(_ref3, _excluded2$1);
    var _latest$current = latest.current,
      latestProps = _latest$current.props,
      latestState = _latest$current.state;
    var _getItemAndIndex = getItemAndIndex(itemProp, indexProp, latestProps.items, 'Pass either item or index to getItemProps!'),
      index = _getItemAndIndex[1];
    var onSelectKey = 'onClick';
    var customClickHandler = onClick;
    var itemHandleMouseMove = function itemHandleMouseMove() {
      if (index === latestState.highlightedIndex) {
        return;
      }
      shouldScrollRef.current = false;
      dispatch({
        type: ItemMouseMove,
        index: index,
        disabled: disabled
      });
    };
    var itemHandleClick = function itemHandleClick() {
      dispatch({
        type: ItemClick,
        index: index
      });
    };
    var itemHandleMouseDown = function itemHandleMouseDown(e) {
      return e.preventDefault();
    };
    return (0,esm_extends/* default */.Z)((_extends3 = {}, _extends3[refKey] = handleRefs(ref, function (itemNode) {
      if (itemNode) {
        itemRefs.current[elementIds.getItemId(index)] = itemNode;
      }
    }), _extends3.disabled = disabled, _extends3.role = 'option', _extends3['aria-selected'] = "" + (index === latestState.highlightedIndex), _extends3.id = elementIds.getItemId(index), _extends3), !disabled && (_ref4 = {}, _ref4[onSelectKey] = callAllEventHandlers(customClickHandler, itemHandleClick), _ref4), {
      onMouseMove: callAllEventHandlers(onMouseMove, itemHandleMouseMove),
      onMouseDown: callAllEventHandlers(onMouseDown, itemHandleMouseDown)
    }, rest);
  }, [dispatch, latest, shouldScrollRef, elementIds]);
  var getToggleButtonProps = (0,react.useCallback)(function (_temp4) {
    var _extends4;
    var _ref5 = _temp4 === void 0 ? {} : _temp4,
      onClick = _ref5.onClick;
      _ref5.onPress;
      var _ref5$refKey = _ref5.refKey,
      refKey = _ref5$refKey === void 0 ? 'ref' : _ref5$refKey,
      ref = _ref5.ref,
      rest = objectWithoutPropertiesLoose_objectWithoutPropertiesLoose(_ref5, _excluded3);
    var latestState = latest.current.state;
    var toggleButtonHandleClick = function toggleButtonHandleClick() {
      dispatch({
        type: ToggleButtonClick
      });
    };
    return (0,esm_extends/* default */.Z)((_extends4 = {}, _extends4[refKey] = handleRefs(ref, function (toggleButtonNode) {
      toggleButtonRef.current = toggleButtonNode;
    }), _extends4['aria-controls'] = elementIds.menuId, _extends4['aria-expanded'] = latestState.isOpen, _extends4.id = elementIds.toggleButtonId, _extends4.tabIndex = -1, _extends4), !rest.disabled && (0,esm_extends/* default */.Z)({}, {
      onClick: callAllEventHandlers(onClick, toggleButtonHandleClick)
    }), rest);
  }, [dispatch, latest, elementIds]);
  var getInputProps = (0,react.useCallback)(function (_temp5, _temp6) {
    var _extends5;
    var _ref6 = _temp5 === void 0 ? {} : _temp5,
      onKeyDown = _ref6.onKeyDown,
      onChange = _ref6.onChange,
      onInput = _ref6.onInput,
      onFocus = _ref6.onFocus,
      onBlur = _ref6.onBlur;
      _ref6.onChangeText;
      var _ref6$refKey = _ref6.refKey,
      refKey = _ref6$refKey === void 0 ? 'ref' : _ref6$refKey,
      ref = _ref6.ref,
      rest = objectWithoutPropertiesLoose_objectWithoutPropertiesLoose(_ref6, _excluded4);
    var _ref7 = _temp6 === void 0 ? {} : _temp6,
      _ref7$suppressRefErro = _ref7.suppressRefError,
      suppressRefError = _ref7$suppressRefErro === void 0 ? false : _ref7$suppressRefErro;
    setGetterPropCallInfo('getInputProps', suppressRefError, refKey, inputRef);
    var latestState = latest.current.state;
    var inputHandleKeyDown = function inputHandleKeyDown(event) {
      var key = normalizeArrowKey(event);
      if (key && inputKeyDownHandlers[key]) {
        inputKeyDownHandlers[key](event);
      }
    };
    var inputHandleChange = function inputHandleChange(event) {
      dispatch({
        type: InputChange,
        inputValue: event.target.value
      });
    };
    var inputHandleBlur = function inputHandleBlur(event) {
      /* istanbul ignore else */
      if (latestState.isOpen && !mouseAndTouchTrackersRef.current.isMouseDown) {
        dispatch({
          type: InputBlur,
          selectItem: event.relatedTarget !== null
        });
      }
    };
    var inputHandleFocus = function inputHandleFocus() {
      if (!latestState.isOpen) {
        dispatch({
          type: InputFocus
        });
      }
    };

    /* istanbul ignore next (preact) */
    var onChangeKey = 'onChange';
    var eventHandlers = {};
    if (!rest.disabled) {
      var _eventHandlers;
      eventHandlers = (_eventHandlers = {}, _eventHandlers[onChangeKey] = callAllEventHandlers(onChange, onInput, inputHandleChange), _eventHandlers.onKeyDown = callAllEventHandlers(onKeyDown, inputHandleKeyDown), _eventHandlers.onBlur = callAllEventHandlers(onBlur, inputHandleBlur), _eventHandlers.onFocus = callAllEventHandlers(onFocus, inputHandleFocus), _eventHandlers);
    }
    return (0,esm_extends/* default */.Z)((_extends5 = {}, _extends5[refKey] = handleRefs(ref, function (inputNode) {
      inputRef.current = inputNode;
    }), _extends5['aria-activedescendant'] = latestState.isOpen && latestState.highlightedIndex > -1 ? elementIds.getItemId(latestState.highlightedIndex) : '', _extends5['aria-autocomplete'] = 'list', _extends5['aria-controls'] = elementIds.menuId, _extends5['aria-expanded'] = latestState.isOpen, _extends5['aria-labelledby'] = rest && rest['aria-label'] ? undefined : "" + elementIds.labelId, _extends5.autoComplete = 'off', _extends5.id = elementIds.inputId, _extends5.role = 'combobox', _extends5.value = latestState.inputValue, _extends5), eventHandlers, rest);
  }, [dispatch, inputKeyDownHandlers, latest, mouseAndTouchTrackersRef, setGetterPropCallInfo, elementIds]);

  // returns
  var toggleMenu = (0,react.useCallback)(function () {
    dispatch({
      type: FunctionToggleMenu
    });
  }, [dispatch]);
  var closeMenu = (0,react.useCallback)(function () {
    dispatch({
      type: FunctionCloseMenu
    });
  }, [dispatch]);
  var openMenu = (0,react.useCallback)(function () {
    dispatch({
      type: FunctionOpenMenu
    });
  }, [dispatch]);
  var setHighlightedIndex = (0,react.useCallback)(function (newHighlightedIndex) {
    dispatch({
      type: FunctionSetHighlightedIndex,
      highlightedIndex: newHighlightedIndex
    });
  }, [dispatch]);
  var selectItem = (0,react.useCallback)(function (newSelectedItem) {
    dispatch({
      type: FunctionSelectItem,
      selectedItem: newSelectedItem
    });
  }, [dispatch]);
  var setInputValue = (0,react.useCallback)(function (newInputValue) {
    dispatch({
      type: FunctionSetInputValue,
      inputValue: newInputValue
    });
  }, [dispatch]);
  var reset = (0,react.useCallback)(function () {
    dispatch({
      type: FunctionReset$1
    });
  }, [dispatch]);
  return {
    // prop getters.
    getItemProps: getItemProps,
    getLabelProps: getLabelProps,
    getMenuProps: getMenuProps,
    getInputProps: getInputProps,
    getToggleButtonProps: getToggleButtonProps,
    // actions.
    toggleMenu: toggleMenu,
    openMenu: openMenu,
    closeMenu: closeMenu,
    setHighlightedIndex: setHighlightedIndex,
    setInputValue: setInputValue,
    selectItem: selectItem,
    reset: reset,
    // state.
    highlightedIndex: highlightedIndex,
    isOpen: isOpen,
    selectedItem: selectedItem,
    inputValue: inputValue
  };
}

var defaultStateValues = {
  activeIndex: -1,
  selectedItems: []
};

/**
 * Returns the initial value for a state key in the following order:
 * 1. controlled prop, 2. initial prop, 3. default prop, 4. default
 * value from Downshift.
 *
 * @param {Object} props Props passed to the hook.
 * @param {string} propKey Props key to generate the value for.
 * @returns {any} The initial value for that prop.
 */
function getInitialValue(props, propKey) {
  return getInitialValue$1(props, propKey, defaultStateValues);
}

/**
 * Returns the default value for a state key in the following order:
 * 1. controlled prop, 2. default prop, 3. default value from Downshift.
 *
 * @param {Object} props Props passed to the hook.
 * @param {string} propKey Props key to generate the value for.
 * @returns {any} The initial value for that prop.
 */
function getDefaultValue(props, propKey) {
  return getDefaultValue$1(props, propKey, defaultStateValues);
}

/**
 * Gets the initial state based on the provided props. It uses initial, default
 * and controlled props related to state in order to compute the initial value.
 *
 * @param {Object} props Props passed to the hook.
 * @returns {Object} The initial state.
 */
function getInitialState(props) {
  var activeIndex = getInitialValue(props, 'activeIndex');
  var selectedItems = getInitialValue(props, 'selectedItems');
  return {
    activeIndex: activeIndex,
    selectedItems: selectedItems
  };
}

/**
 * Returns true if dropdown keydown operation is permitted. Should not be
 * allowed on keydown with modifier keys (ctrl, alt, shift, meta), on
 * input element with text content that is either highlighted or selection
 * cursor is not at the starting position.
 *
 * @param {KeyboardEvent} event The event from keydown.
 * @returns {boolean} Whether the operation is allowed.
 */
function isKeyDownOperationPermitted(event) {
  if (event.shiftKey || event.metaKey || event.ctrlKey || event.altKey) {
    return false;
  }
  var element = event.target;
  if (element instanceof HTMLInputElement &&
  // if element is a text input
  element.value !== '' && (
  // and we have text in it
  // and cursor is either not at the start or is currently highlighting text.
  element.selectionStart !== 0 || element.selectionEnd !== 0)) {
    return false;
  }
  return true;
}

/**
 * Returns a message to be added to aria-live region when item is removed.
 *
 * @param {Object} selectionParameters Parameters required to build the message.
 * @returns {string} The a11y message.
 */
function getA11yRemovalMessage(selectionParameters) {
  var removedSelectedItem = selectionParameters.removedSelectedItem,
    itemToStringLocal = selectionParameters.itemToString;
  return itemToStringLocal(removedSelectedItem) + " has been removed.";
}
var propTypes = {
  selectedItems: (prop_types_default()).array,
  initialSelectedItems: (prop_types_default()).array,
  defaultSelectedItems: (prop_types_default()).array,
  itemToString: (prop_types_default()).func,
  getA11yRemovalMessage: (prop_types_default()).func,
  stateReducer: (prop_types_default()).func,
  activeIndex: (prop_types_default()).number,
  initialActiveIndex: (prop_types_default()).number,
  defaultActiveIndex: (prop_types_default()).number,
  onActiveIndexChange: (prop_types_default()).func,
  onSelectedItemsChange: (prop_types_default()).func,
  keyNavigationNext: (prop_types_default()).string,
  keyNavigationPrevious: (prop_types_default()).string,
  environment: prop_types_default().shape({
    addEventListener: (prop_types_default()).func,
    removeEventListener: (prop_types_default()).func,
    document: prop_types_default().shape({
      getElementById: (prop_types_default()).func,
      activeElement: (prop_types_default()).any,
      body: (prop_types_default()).any
    })
  })
};
var defaultProps = {
  itemToString: defaultProps$3.itemToString,
  stateReducer: defaultProps$3.stateReducer,
  environment: defaultProps$3.environment,
  getA11yRemovalMessage: getA11yRemovalMessage,
  keyNavigationNext: 'ArrowRight',
  keyNavigationPrevious: 'ArrowLeft'
};

// eslint-disable-next-line import/no-mutable-exports
var validatePropTypes = noop;
/* istanbul ignore next */
if (false) {}

var SelectedItemClick =  false ? 0 : 0;
var SelectedItemKeyDownDelete =  false ? 0 : 1;
var SelectedItemKeyDownBackspace =  false ? 0 : 2;
var SelectedItemKeyDownNavigationNext =  false ? 0 : 3;
var SelectedItemKeyDownNavigationPrevious =  false ? 0 : 4;
var DropdownKeyDownNavigationPrevious =  false ? 0 : 5;
var DropdownKeyDownBackspace =  false ? 0 : 6;
var DropdownClick =  false ? 0 : 7;
var FunctionAddSelectedItem =  false ? 0 : 8;
var FunctionRemoveSelectedItem =  false ? 0 : 9;
var FunctionSetSelectedItems =  false ? 0 : 10;
var FunctionSetActiveIndex =  false ? 0 : 11;
var FunctionReset =  false ? 0 : 12;

var stateChangeTypes = /*#__PURE__*/Object.freeze({
  __proto__: null,
  SelectedItemClick: SelectedItemClick,
  SelectedItemKeyDownDelete: SelectedItemKeyDownDelete,
  SelectedItemKeyDownBackspace: SelectedItemKeyDownBackspace,
  SelectedItemKeyDownNavigationNext: SelectedItemKeyDownNavigationNext,
  SelectedItemKeyDownNavigationPrevious: SelectedItemKeyDownNavigationPrevious,
  DropdownKeyDownNavigationPrevious: DropdownKeyDownNavigationPrevious,
  DropdownKeyDownBackspace: DropdownKeyDownBackspace,
  DropdownClick: DropdownClick,
  FunctionAddSelectedItem: FunctionAddSelectedItem,
  FunctionRemoveSelectedItem: FunctionRemoveSelectedItem,
  FunctionSetSelectedItems: FunctionSetSelectedItems,
  FunctionSetActiveIndex: FunctionSetActiveIndex,
  FunctionReset: FunctionReset
});

/* eslint-disable complexity */
function downshiftMultipleSelectionReducer(state, action) {
  var type = action.type,
    index = action.index,
    props = action.props,
    selectedItem = action.selectedItem;
  var activeIndex = state.activeIndex,
    selectedItems = state.selectedItems;
  var changes;
  switch (type) {
    case SelectedItemClick:
      changes = {
        activeIndex: index
      };
      break;
    case SelectedItemKeyDownNavigationPrevious:
      changes = {
        activeIndex: activeIndex - 1 < 0 ? 0 : activeIndex - 1
      };
      break;
    case SelectedItemKeyDownNavigationNext:
      changes = {
        activeIndex: activeIndex + 1 >= selectedItems.length ? -1 : activeIndex + 1
      };
      break;
    case SelectedItemKeyDownBackspace:
    case SelectedItemKeyDownDelete:
      {
        if (activeIndex < 0) {
          break;
        }
        var newActiveIndex = activeIndex;
        if (selectedItems.length === 1) {
          newActiveIndex = -1;
        } else if (activeIndex === selectedItems.length - 1) {
          newActiveIndex = selectedItems.length - 2;
        }
        changes = (0,esm_extends/* default */.Z)({
          selectedItems: [].concat(selectedItems.slice(0, activeIndex), selectedItems.slice(activeIndex + 1))
        }, {
          activeIndex: newActiveIndex
        });
        break;
      }
    case DropdownKeyDownNavigationPrevious:
      changes = {
        activeIndex: selectedItems.length - 1
      };
      break;
    case DropdownKeyDownBackspace:
      changes = {
        selectedItems: selectedItems.slice(0, selectedItems.length - 1)
      };
      break;
    case FunctionAddSelectedItem:
      changes = {
        selectedItems: [].concat(selectedItems, [selectedItem])
      };
      break;
    case DropdownClick:
      changes = {
        activeIndex: -1
      };
      break;
    case FunctionRemoveSelectedItem:
      {
        var _newActiveIndex = activeIndex;
        var selectedItemIndex = selectedItems.indexOf(selectedItem);
        if (selectedItemIndex < 0) {
          break;
        }
        if (selectedItems.length === 1) {
          _newActiveIndex = -1;
        } else if (selectedItemIndex === selectedItems.length - 1) {
          _newActiveIndex = selectedItems.length - 2;
        }
        changes = {
          selectedItems: [].concat(selectedItems.slice(0, selectedItemIndex), selectedItems.slice(selectedItemIndex + 1)),
          activeIndex: _newActiveIndex
        };
        break;
      }
    case FunctionSetSelectedItems:
      {
        var newSelectedItems = action.selectedItems;
        changes = {
          selectedItems: newSelectedItems
        };
        break;
      }
    case FunctionSetActiveIndex:
      {
        var _newActiveIndex2 = action.activeIndex;
        changes = {
          activeIndex: _newActiveIndex2
        };
        break;
      }
    case FunctionReset:
      changes = {
        activeIndex: getDefaultValue(props, 'activeIndex'),
        selectedItems: getDefaultValue(props, 'selectedItems')
      };
      break;
    default:
      throw new Error('Reducer called without proper action type.');
  }
  return (0,esm_extends/* default */.Z)({}, state, changes);
}

var _excluded = ["refKey", "ref", "onClick", "onKeyDown", "selectedItem", "index"],
  _excluded2 = ["refKey", "ref", "onKeyDown", "onClick", "preventKeyAction"];
useMultipleSelection.stateChangeTypes = stateChangeTypes;
function useMultipleSelection(userProps) {
  if (userProps === void 0) {
    userProps = {};
  }
  validatePropTypes(userProps, useMultipleSelection);
  // Props defaults and destructuring.
  var props = (0,esm_extends/* default */.Z)({}, defaultProps, userProps);
  var getA11yRemovalMessage = props.getA11yRemovalMessage,
    itemToString = props.itemToString,
    environment = props.environment,
    keyNavigationNext = props.keyNavigationNext,
    keyNavigationPrevious = props.keyNavigationPrevious;

  // Reducer init.
  var _useControlledReducer = useControlledReducer$1(downshiftMultipleSelectionReducer, getInitialState(props), props),
    state = _useControlledReducer[0],
    dispatch = _useControlledReducer[1];
  var activeIndex = state.activeIndex,
    selectedItems = state.selectedItems;

  // Refs.
  var isInitialMountRef = (0,react.useRef)(true);
  var dropdownRef = (0,react.useRef)(null);
  var previousSelectedItemsRef = (0,react.useRef)(selectedItems);
  var selectedItemRefs = (0,react.useRef)();
  selectedItemRefs.current = [];
  var latest = useLatestRef({
    state: state,
    props: props
  });

  // Effects.
  /* Sets a11y status message on changes in selectedItem. */
  (0,react.useEffect)(function () {
    if (isInitialMountRef.current || false) {
      return;
    }
    if (selectedItems.length < previousSelectedItemsRef.current.length) {
      var removedSelectedItem = previousSelectedItemsRef.current.find(function (item) {
        return selectedItems.indexOf(item) < 0;
      });
      setStatus(getA11yRemovalMessage({
        itemToString: itemToString,
        resultCount: selectedItems.length,
        removedSelectedItem: removedSelectedItem,
        activeIndex: activeIndex,
        activeSelectedItem: selectedItems[activeIndex]
      }), environment.document);
    }
    previousSelectedItemsRef.current = selectedItems;

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedItems.length]);
  // Sets focus on active item.
  (0,react.useEffect)(function () {
    if (isInitialMountRef.current) {
      return;
    }
    if (activeIndex === -1 && dropdownRef.current) {
      dropdownRef.current.focus();
    } else if (selectedItemRefs.current[activeIndex]) {
      selectedItemRefs.current[activeIndex].focus();
    }
  }, [activeIndex]);
  useControlPropsValidator({
    isInitialMount: isInitialMountRef.current,
    props: props,
    state: state
  });
  var setGetterPropCallInfo = useGetterPropsCalledChecker('getDropdownProps');
  // Make initial ref false.
  (0,react.useEffect)(function () {
    isInitialMountRef.current = false;
    return function () {
      isInitialMountRef.current = true;
    };
  }, []);

  // Event handler functions.
  var selectedItemKeyDownHandlers = (0,react.useMemo)(function () {
    var _ref;
    return _ref = {}, _ref[keyNavigationPrevious] = function () {
      dispatch({
        type: SelectedItemKeyDownNavigationPrevious
      });
    }, _ref[keyNavigationNext] = function () {
      dispatch({
        type: SelectedItemKeyDownNavigationNext
      });
    }, _ref.Delete = function Delete() {
      dispatch({
        type: SelectedItemKeyDownDelete
      });
    }, _ref.Backspace = function Backspace() {
      dispatch({
        type: SelectedItemKeyDownBackspace
      });
    }, _ref;
  }, [dispatch, keyNavigationNext, keyNavigationPrevious]);
  var dropdownKeyDownHandlers = (0,react.useMemo)(function () {
    var _ref2;
    return _ref2 = {}, _ref2[keyNavigationPrevious] = function (event) {
      if (isKeyDownOperationPermitted(event)) {
        dispatch({
          type: DropdownKeyDownNavigationPrevious
        });
      }
    }, _ref2.Backspace = function Backspace(event) {
      if (isKeyDownOperationPermitted(event)) {
        dispatch({
          type: DropdownKeyDownBackspace
        });
      }
    }, _ref2;
  }, [dispatch, keyNavigationPrevious]);

  // Getter props.
  var getSelectedItemProps = (0,react.useCallback)(function (_temp) {
    var _extends2;
    var _ref3 = _temp === void 0 ? {} : _temp,
      _ref3$refKey = _ref3.refKey,
      refKey = _ref3$refKey === void 0 ? 'ref' : _ref3$refKey,
      ref = _ref3.ref,
      onClick = _ref3.onClick,
      onKeyDown = _ref3.onKeyDown,
      selectedItemProp = _ref3.selectedItem,
      indexProp = _ref3.index,
      rest = objectWithoutPropertiesLoose_objectWithoutPropertiesLoose(_ref3, _excluded);
    var latestState = latest.current.state;
    var _getItemAndIndex = getItemAndIndex(selectedItemProp, indexProp, latestState.selectedItems, 'Pass either item or index to getSelectedItemProps!'),
      index = _getItemAndIndex[1];
    var isFocusable = index > -1 && index === latestState.activeIndex;
    var selectedItemHandleClick = function selectedItemHandleClick() {
      dispatch({
        type: SelectedItemClick,
        index: index
      });
    };
    var selectedItemHandleKeyDown = function selectedItemHandleKeyDown(event) {
      var key = normalizeArrowKey(event);
      if (key && selectedItemKeyDownHandlers[key]) {
        selectedItemKeyDownHandlers[key](event);
      }
    };
    return (0,esm_extends/* default */.Z)((_extends2 = {}, _extends2[refKey] = handleRefs(ref, function (selectedItemNode) {
      if (selectedItemNode) {
        selectedItemRefs.current.push(selectedItemNode);
      }
    }), _extends2.tabIndex = isFocusable ? 0 : -1, _extends2.onClick = callAllEventHandlers(onClick, selectedItemHandleClick), _extends2.onKeyDown = callAllEventHandlers(onKeyDown, selectedItemHandleKeyDown), _extends2), rest);
  }, [dispatch, latest, selectedItemKeyDownHandlers]);
  var getDropdownProps = (0,react.useCallback)(function (_temp2, _temp3) {
    var _extends3;
    var _ref4 = _temp2 === void 0 ? {} : _temp2,
      _ref4$refKey = _ref4.refKey,
      refKey = _ref4$refKey === void 0 ? 'ref' : _ref4$refKey,
      ref = _ref4.ref,
      onKeyDown = _ref4.onKeyDown,
      onClick = _ref4.onClick,
      _ref4$preventKeyActio = _ref4.preventKeyAction,
      preventKeyAction = _ref4$preventKeyActio === void 0 ? false : _ref4$preventKeyActio,
      rest = objectWithoutPropertiesLoose_objectWithoutPropertiesLoose(_ref4, _excluded2);
    var _ref5 = _temp3 === void 0 ? {} : _temp3,
      _ref5$suppressRefErro = _ref5.suppressRefError,
      suppressRefError = _ref5$suppressRefErro === void 0 ? false : _ref5$suppressRefErro;
    setGetterPropCallInfo('getDropdownProps', suppressRefError, refKey, dropdownRef);
    var dropdownHandleKeyDown = function dropdownHandleKeyDown(event) {
      var key = normalizeArrowKey(event);
      if (key && dropdownKeyDownHandlers[key]) {
        dropdownKeyDownHandlers[key](event);
      }
    };
    var dropdownHandleClick = function dropdownHandleClick() {
      dispatch({
        type: DropdownClick
      });
    };
    return (0,esm_extends/* default */.Z)((_extends3 = {}, _extends3[refKey] = handleRefs(ref, function (dropdownNode) {
      if (dropdownNode) {
        dropdownRef.current = dropdownNode;
      }
    }), _extends3), !preventKeyAction && {
      onKeyDown: callAllEventHandlers(onKeyDown, dropdownHandleKeyDown),
      onClick: callAllEventHandlers(onClick, dropdownHandleClick)
    }, rest);
  }, [dispatch, dropdownKeyDownHandlers, setGetterPropCallInfo]);

  // returns
  var addSelectedItem = (0,react.useCallback)(function (selectedItem) {
    dispatch({
      type: FunctionAddSelectedItem,
      selectedItem: selectedItem
    });
  }, [dispatch]);
  var removeSelectedItem = (0,react.useCallback)(function (selectedItem) {
    dispatch({
      type: FunctionRemoveSelectedItem,
      selectedItem: selectedItem
    });
  }, [dispatch]);
  var setSelectedItems = (0,react.useCallback)(function (newSelectedItems) {
    dispatch({
      type: FunctionSetSelectedItems,
      selectedItems: newSelectedItems
    });
  }, [dispatch]);
  var setActiveIndex = (0,react.useCallback)(function (newActiveIndex) {
    dispatch({
      type: FunctionSetActiveIndex,
      activeIndex: newActiveIndex
    });
  }, [dispatch]);
  var reset = (0,react.useCallback)(function () {
    dispatch({
      type: FunctionReset
    });
  }, [dispatch]);
  return {
    getSelectedItemProps: getSelectedItemProps,
    getDropdownProps: getDropdownProps,
    addSelectedItem: addSelectedItem,
    removeSelectedItem: removeSelectedItem,
    setSelectedItems: setSelectedItems,
    setActiveIndex: setActiveIndex,
    reset: reset,
    selectedItems: selectedItems,
    activeIndex: activeIndex
  };
}



// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-lib-icons-virtual-412b14e947/1/packages/lib-icons/src/index.ts + 181 modules
var src = __webpack_require__(45628);
// EXTERNAL MODULE: ../../.yarn/__virtual__/styled-components-virtual-29066d9421/0/cache/styled-components-npm-5.3.5-88e3937b59-05a664dfe4.zip/node_modules/styled-components/dist/styled-components.browser.cjs.js
var styled_components_browser_cjs = __webpack_require__(33982);
// EXTERNAL MODULE: ../../.yarn/cache/styled-tools-npm-1.7.2-97a33384f1-00cc179608.zip/node_modules/styled-tools/dist/es/index.js + 3 modules
var es = __webpack_require__(25711);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-lib-styles-virtual-b3f1d479f2/1/packages/lib-styles/src/index.ts + 18 modules
var lib_styles_src = __webpack_require__(52203);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-component-select-virtual-f6511e8fae/1/packages/component-select/src/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    const data = _taggedTemplateLiteral([
        "\n  position: relative;\n  z-index: 1;\n  width: 100%;\n  height: 56px;\n  border-top: 1px solid ",
        ";\n  border-right: 1px solid ",
        ";\n  border-left: 1px solid ",
        ";\n  transition: box-shadow 0.15s;\n  transition: 0.3s;\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _taggedTemplateLiteral([
        "\n  height: 24px;\n  padding-right: 24px;\n  padding-left: 24px;\n  margin-left: auto;\n  .byko-icon {\n    stroke: ",
        ";\n    transition: transform 0.15s ease-out, fill 0.15s;\n  }\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = _taggedTemplateLiteral([
        "\n  position: absolute;\n  z-index: 1;\n  bottom: 0;\n  left: 0;\n  display: block;\n  width: ",
        ";\n  height: 1px;\n  background-color: ",
        ";\n  transition: width 0.15s ease-out;\n"
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = _taggedTemplateLiteral([
        "\n  position: relative;\n  z-index: 0;\n  display: flex;\n  width: 100%;\n  height: 100%;\n  box-sizing: border-box;\n  align-items: center;\n  padding-left: 16px;\n  border: 0;\n  background-color: ",
        ";\n  color: ",
        ";\n  cursor: pointer;\n  font-size: 1rem;\n  font-weight: 500;\n  text-align: left;\n  transition: border-color 0.15s;\n\n  .byko-icon {\n    stroke: ",
        ";\n    transition: transform 0.15s ease-out, fill 0.15s;\n  }\n\n  &:hover {\n    box-shadow: 0px 18px 45px rgba(0, 0, 0, 0.09);\n    outline: none;\n    transition: background-color 200ms ease, box-shadow 300ms ease, border 200ms ease;\n  }\n  &:focus {\n    outline: none;\n  }\n"
    ]);
    _templateObject3 = function() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = _taggedTemplateLiteral([
        "\n  position: absolute;\n  right: ",
        ";\n  left: ",
        ";\n  min-width: ",
        ";\n  padding-bottom: 4px;\n  padding-left: 4px;\n  pointer-events: ",
        ";\n  transition: opacity 0.15s;\n"
    ]);
    _templateObject4 = function() {
        return data;
    };
    return data;
}
function _templateObject5() {
    const data = _taggedTemplateLiteral([
        "\n  z-index: 2;\n  max-height: 255px;\n  border-right: 1px solid ",
        ";\n  border-bottom: 1px solid ",
        ";\n  border-left: 1px solid ",
        ";\n  background-color: ",
        ";\n  box-shadow: ",
        ";\n  list-style: none;\n  opacity: ",
        ";\n  overflow-y: scroll;\n  pointer-events: ",
        ";\n  transition: 0.3s;\n  ::-webkit-scrollbar {\n    width: 4px;\n  }\n\n  ::-webkit-scrollbar-track {\n    background-color: ",
        ";\n  }\n\n  ::-webkit-scrollbar-thumb {\n    background-color: ",
        ";\n  }\n"
    ]);
    _templateObject5 = function() {
        return data;
    };
    return data;
}
function _templateObject6() {
    const data = _taggedTemplateLiteral([
        "\n  max-height: 400px;\n  ",
        "\n"
    ]);
    _templateObject6 = function() {
        return data;
    };
    return data;
}
function _templateObject7() {
    const data = _taggedTemplateLiteral([
        "\n  display: flex;\n  width: 100%;\n  height: 56px;\n  align-items: center;\n  padding: 0 16px;\n  border-top: 1px solid ",
        ";\n  background-color: ",
        ";\n  color: ",
        ";\n  cursor: pointer;\n  font-size: 16px;\n  font-weight: 400;\n  font-weight: ",
        ";\n  text-align: left;\n  transition: border-color 0.15s, background-color 0.15s;\n  &:hover {\n    background-color: ",
        ";\n  }\n"
    ]);
    _templateObject7 = function() {
        return data;
    };
    return data;
}
function _templateObject8() {
    const data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  height: 56px;\n"
    ]);
    _templateObject8 = function() {
        return data;
    };
    return data;
}
function _templateObject9() {
    const data = _taggedTemplateLiteral([
        "\n  display: flex;\n  width: 18px;\n  min-width: 18px;\n  height: 18px;\n  min-height: 18px;\n  align-items: center;\n  justify-content: center;\n  border: 1px solid ",
        ";\n  margin-right: 8px;\n  transition: background-color 0.15s, border-color 0.15s;\n"
    ]);
    _templateObject9 = function() {
        return data;
    };
    return data;
}
function _templateObject10() {
    const data = _taggedTemplateLiteral([
        "\n  position: absolute;\n  z-index: 1;\n  top: calc(50% - 8px);\n  right: 17px;\n  transition: transform 0.15s ease-out;\n"
    ]);
    _templateObject10 = function() {
        return data;
    };
    return data;
}
function _templateObject11() {
    const data = _taggedTemplateLiteral([
        "\n  color: ",
        ";\n  font-weight: normal;\n  @media screen and (max-width: ",
        "px) {\n    font-size: 16px;\n  }\n"
    ]);
    _templateObject11 = function() {
        return data;
    };
    return data;
}



const styles_SelectContainer = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-1e1a7c09-0"
})(_templateObject(), (props)=>props.isOpen ? lib_styles_src/* theme.palette.blue.main */.rS.palette.blue.main : "transparent", (props)=>props.isOpen ? lib_styles_src/* theme.palette.blue.main */.rS.palette.blue.main : "transparent", (props)=>props.isOpen ? lib_styles_src/* theme.palette.blue.main */.rS.palette.blue.main : "transparent");
const styles_IconWrapper = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-1e1a7c09-1"
})(_templateObject1(), lib_styles_src/* theme.palette.yellow.main */.rS.palette.yellow.main);
const styles_FocusLine = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-1e1a7c09-2"
})(_templateObject2(), (0,es/* ifProp */.fq)({
    isOpen: true
}, "100%", "0"), lib_styles_src/* theme.palette.blue.main */.rS.palette.blue.main);
const styles_SelectBtn = styled_components_browser_cjs["default"].button.withConfig({
    componentId: "sc-1e1a7c09-3"
})(_templateObject3(), lib_styles_src/* theme.palette.white.main */.rS.palette.white.main, lib_styles_src/* theme.palette.blue.main */.rS.palette.blue.main, lib_styles_src/* theme.palette.blue.main */.rS.palette.blue.main);
const styles_MenuWrapper = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-1e1a7c09-4"
})(_templateObject4(), (0,es/* ifProp */.fq)({
    align: "right"
}, "0", "inherit"), (0,es/* ifProp */.fq)({
    align: "left"
}, "-5px", "inherit"), (0,es/* ifProp */.fq)({
    fit: true
}, "calc(100% + 6px)", "300px"), (0,es/* ifProp */.fq)({
    isOpen: true
}, "unset", "none"));
const styles_Menu = styled_components_browser_cjs["default"].ul.withConfig({
    componentId: "sc-1e1a7c09-5"
})(_templateObject5(), (props)=>props.isOpen ? lib_styles_src/* theme.palette.blue.main */.rS.palette.blue.main : "transparent", (props)=>props.isOpen ? lib_styles_src/* theme.palette.blue.main */.rS.palette.blue.main : "transparent", (props)=>props.isOpen ? lib_styles_src/* theme.palette.blue.main */.rS.palette.blue.main : "transparent", lib_styles_src/* theme.palette.white.main */.rS.palette.white.main, (props)=>props.isOpen ? " 0px 18px 45px rgba(0, 0, 0, 0.09);" : "none", (0,es/* ifProp */.fq)({
    isOpen: true
}, "1", "0"), (0,es/* ifProp */.fq)({
    isOpen: true
}, "unset", "none"), lib_styles_src/* theme.palette.white.main */.rS.palette.white.main, lib_styles_src/* theme.palette.blue.main */.rS.palette.blue.main);
const MenuInner = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-1e1a7c09-6"
})(_templateObject6(), (0,lib_styles_src/* scrollStyle */.vh)({
    color: "dark-blue"
}));
const styles_ListItem = styled_components_browser_cjs["default"].button.withConfig({
    componentId: "sc-1e1a7c09-7"
})(_templateObject7(), lib_styles_src/* theme.palette.gray.10 */.rS.palette.gray[10], (props)=>props.highlighted ? lib_styles_src/* theme.palette.blue.lightest */.rS.palette.blue.lightest : props.disabledLine ? "transparent" : "transparent", (props)=>props.disabledLine ? lib_styles_src/* theme.palette.gray.20 */.rS.palette.gray[20] : lib_styles_src/* theme.palette.blue.dark */.rS.palette.blue.dark, (0,es/* ifProp */.fq)({
    selected: true
}, "700", "400"), (props)=>props.disabledLine ? lib_styles_src/* theme.palette.gray.5 */.rS.palette.gray[5] : lib_styles_src/* theme.palette.blue.lightest */.rS.palette.blue.lightest);
const styles_SearchWrapper = styled_components_browser_cjs["default"].li.withConfig({
    componentId: "sc-1e1a7c09-8"
})(_templateObject8());
const Checkbox = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-1e1a7c09-9"
})(_templateObject9(), lib_styles_src/* theme.palette.black.main */.rS.palette.black.main);
const PrefixIcon = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-1e1a7c09-10"
})(_templateObject10());
const PlaceholderText = styled_components_browser_cjs["default"].p.withConfig({
    componentId: "sc-1e1a7c09-11"
})(_templateObject11(), (props)=>props.textColor ? props.textColor : lib_styles_src/* theme.palette.blue.main */.rS.palette.blue.main, lib_styles_src/* gridTheme.breakpoints.xs */.k.breakpoints.xs);

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-component-select-virtual-f6511e8fae/1/packages/component-select/src/select.tsx





function Select(param) {
    let { items , placeholder , align ="left" , fit , withIcon =false , hideValue =false , textColor , selectedItem: initialSelectedItem , hideDefaultPlaceholder =false , itemToString =(item)=>item , handleSelectedItemChange , className ="select-container"  } = param;
    const { //
    isOpen , getToggleButtonProps , getMenuProps , getItemProps , selectedItem , highlightedIndex  } = downshift_esm_useSelect({
        items,
        selectedItem: initialSelectedItem ? initialSelectedItem : null,
        itemToString,
        onSelectedItemChange: handleSelectedItemChange ? handleSelectedItemChange : ()=>{
        // Empty on purpose
        }
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles_SelectContainer, {
        className: "".concat(className, " ").concat(isOpen ? "open" : ""),
        isOpen: isOpen,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles_SelectBtn, {
                "aria-label": "Veldu m\xf6guleika",
                type: "button",
                ...getToggleButtonProps(),
                children: [
                    isOpen && !selectedItem && !hideDefaultPlaceholder && "Veldu m\xf6guleika",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PlaceholderText, {
                        textColor: textColor,
                        children: placeholder
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_IconWrapper, {
                        children: isOpen ? /*#__PURE__*/ (0,jsx_runtime.jsx)(src.ArrowUpIcons, {
                            size: 24
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(src.ArrowDownIcons, {
                            size: 24
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_FocusLine, {
                        isOpen: isOpen
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_MenuWrapper, {
                align: align,
                "aria-label": "veldu m\xf6guleika",
                className: "menu-wrapper ".concat(isOpen ? "open" : ""),
                fit: !!fit,
                isOpen: isOpen,
                role: "listbox",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_Menu, {
                    ...getMenuProps(),
                    isOpen: isOpen,
                    role: "group",
                    children: items.map((item, index)=>{
                        const highlighted = highlightedIndex === index;
                        const selected = selectedItem === item;
                        const props = getItemProps({
                            item,
                            index
                        });
                        const key = index;
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles_ListItem, {
                            role: "button",
                            ...props,
                            highlighted: highlighted,
                            selected: selected,
                            children: [
                                itemToString(item),
                                withIcon ? /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_IconWrapper, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(src.LongArrowSideIcons, {
                                        size: 24
                                    })
                                }) : // eslint-disable-next-line @typescript-eslint/no-explicit-any
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_IconWrapper, {
                                    children: hideValue ? "" : item.value
                                })
                            ]
                        }, key);
                    })
                })
            })
        ]
    });
}

// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-component-inputs-virtual-052bad3006/1/packages/component-inputs/src/index.ts + 11 modules
var component_inputs_src = __webpack_require__(45535);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-component-select-virtual-f6511e8fae/1/packages/component-select/src/autocomplete.tsx







const Autocomplete = (param)=>{
    let { items , align ="left" , fit , withIcon =false , itemToString =(item)=>item  } = param;
    const [inputItems, setInputItems] = useState(items);
    const [inputValue, setInputValue] = useState("");
    const { isOpen , getToggleButtonProps , getMenuProps , highlightedIndex , getItemProps , selectedItem  } = useSelect({
        items: inputItems
    });
    const handleChange = useCallback((e)=>{
        e.preventDefault();
        setInputValue(e.target.value);
        setInputItems(items.filter((item)=>(item.label || "").toLowerCase().startsWith(e.target.value.toLowerCase())));
    }, [
        setInputItems,
        items,
        setInputValue
    ]);
    const handleOnClick = useCallback(()=>{
        setInputValue("");
        setInputItems(items);
    }, [
        setInputValue,
        setInputItems,
        items
    ]);
    return /*#__PURE__*/ _jsxs(SelectContainer, {
        children: [
            /*#__PURE__*/ _jsxs(SelectBtn, {
                "aria-label": "Veldu m\xf6guleika",
                type: "button",
                ...getToggleButtonProps(),
                children: [
                    !selectedItem ? "Veldu m\xf6guleika" : /*#__PURE__*/ _jsx("p", {
                        children: selectedItem.label
                    }),
                    /*#__PURE__*/ _jsx(IconWrapper, {
                        children: isOpen ? /*#__PURE__*/ _jsx(ArrowUpIcons, {
                            size: 24
                        }) : /*#__PURE__*/ _jsx(ArrowDownIcons, {
                            size: 24
                        })
                    }),
                    /*#__PURE__*/ _jsx(FocusLine, {
                        isOpen: isOpen
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(MenuWrapper, {
                align: align,
                "aria-label": "veldu m\xf6guleika",
                fit: !!fit,
                role: "listbox",
                children: /*#__PURE__*/ _jsxs(Menu, {
                    ...getMenuProps({}, {
                        suppressRefError: true
                    }),
                    isOpen: isOpen,
                    role: "group",
                    children: [
                        /*#__PURE__*/ _jsx(SearchWrapper, {
                            role: "none",
                            children: /*#__PURE__*/ _jsx(SearchInput, {
                                isDirty: Boolean(inputValue),
                                placeholder: "Hva\xf0 viltu finna ?",
                                type: "text",
                                value: inputValue,
                                onChange: handleChange,
                                onClick: handleOnClick
                            })
                        }),
                        inputItems.map((item, index)=>{
                            const highlighted = highlightedIndex === index;
                            const selected = selectedItem === item.label;
                            const props = getItemProps({
                                item,
                                index
                            });
                            const key = index;
                            return /*#__PURE__*/ _jsxs(ListItem, {
                                ...props,
                                highlighted: highlighted,
                                role: "button",
                                selected: selected,
                                children: [
                                    itemToString(item),
                                    withIcon ? /*#__PURE__*/ _jsx(IconWrapper, {
                                        children: /*#__PURE__*/ _jsx(LongArrowSideIcons, {
                                            size: 24
                                        })
                                    }) : /*#__PURE__*/ _jsx(IconWrapper, {
                                        children: item.value
                                    })
                                ]
                            }, key);
                        })
                    ]
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-component-select-virtual-f6511e8fae/1/packages/component-select/src/index.ts




/***/ }),

/***/ 60002:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "XZ": function() { return /* reexport */ Checkbox; },
  "ml": function() { return /* reexport */ FormikCheckbox; },
  "EU": function() { return /* reexport */ RadioButton; },
  "ZD": function() { return /* reexport */ Toggle; }
});

// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(61261);
// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(91987);
// EXTERNAL MODULE: ../../.yarn/__virtual__/styled-components-virtual-29066d9421/0/cache/styled-components-npm-5.3.5-88e3937b59-05a664dfe4.zip/node_modules/styled-components/dist/styled-components.browser.cjs.js
var styled_components_browser_cjs = __webpack_require__(33982);
// EXTERNAL MODULE: ../../.yarn/cache/styled-tools-npm-1.7.2-97a33384f1-00cc179608.zip/node_modules/styled-tools/dist/es/index.js + 3 modules
var es = __webpack_require__(25711);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-component-typography-virtual-537720fdd1/1/packages/component-typography/src/index.ts + 2 modules
var src = __webpack_require__(91371);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-lib-styles-virtual-b3f1d479f2/1/packages/lib-styles/src/index.ts + 18 modules
var lib_styles_src = __webpack_require__(52203);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-component-selectors-virtual-9e0e678d5e/1/packages/component-selectors/src/radio-button/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    const data = _taggedTemplateLiteral([
        "\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  cursor: pointer;\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _taggedTemplateLiteral([
        "\n  position: absolute;\n  width: 24px;\n  height: 24px;\n  border: 3px solid ",
        ";\n  border-color: ",
        ";\n  border-radius: ",
        ";\n  background-color: ",
        ";\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = _taggedTemplateLiteral([
        "\n  position: absolute;\n  left: 5px;\n  width: 14px;\n  height: 14px;\n  align-self: center;\n  border-radius: ",
        ";\n  opacity: 0;\n  pointer-events: auto;\n  transition: background-color 0.2s ease-out, border 0.2s ease-out;\n"
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = _taggedTemplateLiteral([
        "\n  margin-left: 26px;\n  color: ",
        ";\n  cursor: pointer;\n"
    ]);
    _templateObject3 = function() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = _taggedTemplateLiteral([
        "\n  border-radius: 0;\n  cursor: pointer;\n  visibility: hidden;\n\n  &:hover ~ ",
        " {\n    border-color: ",
        ";\n  }\n  &:focus ~ ",
        " {\n    border: 1px solid ",
        ";\n    outline: 2px double ",
        ";\n  }\n\n  &:checked ~ ",
        " {\n    border: 1px solid ",
        ";\n    background: ",
        ";\n    opacity: 1;\n\n    &::after {\n      display: block;\n      width: 12px;\n      height: 12px;\n      margin: 4px;\n      color: ",
        ";\n    }\n  }\n  &:checked ~ ",
        " {\n    border: 3px solid ",
        ";\n  }\n\n  &:disabled {\n    ~ ",
        " {\n      color: ",
        ";\n      cursor: not-allowed;\n    }\n    ~ ",
        " {\n      border: 3px solid ",
        ";\n      cursor: not-allowed;\n    }\n  }\n"
    ]);
    _templateObject4 = function() {
        return data;
    };
    return data;
}




const Label = styled_components_browser_cjs["default"].label.withConfig({
    componentId: "sc-1a4e24bb-0"
})(_templateObject());
const CircleOuter = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-1a4e24bb-1"
})(_templateObject1(), (0,es/* ifProp */.fq)({
    white: true
}, "".concat(lib_styles_src/* theme.palette.white.main */.rS.palette.white.main), "".concat(lib_styles_src/* theme.palette.blue.main */.rS.palette.blue.main)), (0,es/* ifProp */.fq)({
    white: true
}, "".concat(lib_styles_src/* theme.palette.white.main */.rS.palette.white.main), "".concat(lib_styles_src/* theme.palette.blue.light */.rS.palette.blue.light)), (0,es/* ifProp */.fq)({
    radioBox: true
}, "0", "50%"), (0,es/* ifProp */.fq)({
    white: true
}, "".concat(lib_styles_src/* theme.palette.gray.5 */.rS.palette.gray[5]), "".concat(lib_styles_src/* theme.palette.white.main */.rS.palette.white.main)));
const Circle = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-1a4e24bb-2"
})(_templateObject2(), (0,es/* ifProp */.fq)({
    radioBox: true
}, "0", "50%"));
const Text = (0,styled_components_browser_cjs["default"])(src/* PSmall */.zK).withConfig({
    componentId: "sc-1a4e24bb-3"
})(_templateObject3(), (0,es/* ifProp */.fq)({
    white: true
}, "".concat(lib_styles_src/* theme.palette.white.main */.rS.palette.white.main), "".concat(lib_styles_src/* theme.palette.blue.main */.rS.palette.blue.main)));
const RadioInput = styled_components_browser_cjs["default"].input.withConfig({
    componentId: "sc-1a4e24bb-4"
})(_templateObject4(), CircleOuter, (0,es/* ifProp */.fq)({
    white: true
}, "".concat(lib_styles_src/* theme.palette.white.main */.rS.palette.white.main), "".concat(lib_styles_src/* theme.palette.blue.main */.rS.palette.blue.main)), CircleOuter, (0,es/* ifProp */.fq)({
    white: true
}, "".concat(lib_styles_src/* theme.palette.white.main */.rS.palette.white.main), "".concat(lib_styles_src/* theme.palette.blue.main */.rS.palette.blue.main)), (0,es/* ifProp */.fq)({
    white: true
}, "".concat(lib_styles_src/* theme.palette.white.main */.rS.palette.white.main), "".concat(lib_styles_src/* theme.palette.blue.main */.rS.palette.blue.main)), Circle, (0,es/* ifProp */.fq)({
    white: true
}, "".concat(lib_styles_src/* theme.palette.white.main */.rS.palette.white.main), "".concat(lib_styles_src/* theme.palette.blue.main */.rS.palette.blue.main)), (0,es/* ifProp */.fq)({
    white: true
}, "".concat(lib_styles_src/* theme.palette.white.main */.rS.palette.white.main), "".concat(lib_styles_src/* theme.palette.blue.main */.rS.palette.blue.main)), lib_styles_src/* theme.palette.white.main */.rS.palette.white.main, CircleOuter, (0,es/* ifProp */.fq)({
    white: true
}, "".concat(lib_styles_src/* theme.palette.white.main */.rS.palette.white.main), "".concat(lib_styles_src/* theme.palette.blue.main */.rS.palette.blue.main)), Text, (0,es/* ifProp */.fq)({
    white: true
}, "".concat(lib_styles_src/* theme.palette.white.main */.rS.palette.white.main), "".concat(lib_styles_src/* theme.palette.gray.20 */.rS.palette.gray[20])), CircleOuter, (0,es/* ifProp */.fq)({
    white: true
}, "".concat(lib_styles_src/* theme.palette.white.main */.rS.palette.white.main), "".concat(lib_styles_src/* theme.palette.gray.20 */.rS.palette.gray[20])));

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-component-selectors-virtual-9e0e678d5e/1/packages/component-selectors/src/radio-button/radio-button.tsx



const noop = ()=>{
    return;
};
const RadioButton = (param)=>{
    let { label ="" , arialabel ="" , checked =false , disabled =false , white =false , radioBox =false , value , onChange =noop , ...props } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Label, {
        "aria-label": label ? arialabel : label,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(RadioInput, {
                checked: checked,
                disabled: disabled,
                radioBox: radioBox,
                type: "radio",
                value: value,
                white: white,
                onChange: onChange,
                ...props
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CircleOuter, {
                radioBox: radioBox,
                white: white
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Circle, {
                radioBox: radioBox,
                white: white
            }),
            label && /*#__PURE__*/ (0,jsx_runtime.jsx)(Text, {
                white: white,
                children: label
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-component-selectors-virtual-9e0e678d5e/1/packages/component-selectors/src/radio-button/index.ts


// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-lib-icons-virtual-412b14e947/1/packages/lib-icons/src/index.ts + 181 modules
var lib_icons_src = __webpack_require__(45628);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-component-selectors-virtual-9e0e678d5e/1/packages/component-selectors/src/check-box/styles.ts
function styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function styles_templateObject() {
    const data = styles_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  padding-bottom: 2px;\n"
    ]);
    styles_templateObject = function() {
        return data;
    };
    return data;
}
function styles_templateObject1() {
    const data = styles_taggedTemplateLiteral([
        "\n  position: relative;\n  display: flex;\n  flex-direction: ",
        ";\n  align-items: center;\n  justify-content: ",
        ";\n  cursor: pointer;\n  gap: ",
        ";\n  opacity: 1;\n"
    ]);
    styles_templateObject1 = function() {
        return data;
    };
    return data;
}
function styles_templateObject2() {
    const data = styles_taggedTemplateLiteral([
        "\n  color: ",
        ";\n  cursor: pointer;\n"
    ]);
    styles_templateObject2 = function() {
        return data;
    };
    return data;
}
function styles_templateObject3() {
    const data = styles_taggedTemplateLiteral([
        "\n  color: ",
        ";\n"
    ]);
    styles_templateObject3 = function() {
        return data;
    };
    return data;
}
function styles_templateObject4() {
    const data = styles_taggedTemplateLiteral([
        "\n  position: relative;\n  display: flex;\n  width: ",
        ";\n  min-width: ",
        ";\n  height: ",
        ";\n  min-height: ",
        ";\n  align-items: center;\n  justify-content: center;\n  border: 1px solid ",
        ";\n  background-color: ",
        ";\n  outline: 1px solid ",
        ";\n  pointer-events: none;\n  transition: all 150ms;\n"
    ]);
    styles_templateObject4 = function() {
        return data;
    };
    return data;
}
function _templateObject5() {
    const data = styles_taggedTemplateLiteral([
        "\n  position: absolute;\n  border-radius: 0;\n  cursor: pointer;\n  opacity: 0;\n\n  &:hover ~ ",
        " {\n    border: 1px solid ",
        ";\n    outline: 1px solid ",
        ";\n  }\n\n  &:checked ~ ",
        " {\n    width: ",
        ";\n    height: ",
        ";\n    border: 1px solid ",
        ";\n    background-color: ",
        ";\n    outline: 1px solid ",
        ";\n  }\n\n  &:focus ~ ",
        " {\n    border: 1px solid ",
        ";\n    outline: 1px solid ",
        ";\n  }\n\n  &:not(:checked) {\n    &:focus ~ ",
        " {\n      width: ",
        ";\n      height: ",
        ";\n      svg {\n        opacity: 0;\n      }\n      &:after {\n        position: absolute;\n        border: 2px solid ",
        ";\n        background-color: ",
        ';\n        content: "";\n        inset: 0;\n      }\n    }\n  }\n\n  &:disabled {\n    ~ ',
        " {\n      color: ",
        ";\n      cursor: not-allowed;\n    }\n    ~ ",
        " {\n      border: 2px solid ",
        ";\n      cursor: not-allowed;\n    }\n    ~ ",
        " {\n      border: 2px solid ",
        ";\n      background-color: ",
        ";\n      cursor: not-allowed;\n      outline: 1px solid ",
        ";\n    }\n  }\n"
    ]);
    _templateObject5 = function() {
        return data;
    };
    return data;
}
function _templateObject6() {
    const data = styles_taggedTemplateLiteral([
        "\n  padding-left: 24px;\n  margin-top: 4px;\n  color: ",
        ";\n  font-size: 14px;\n  text-transform: uppercase;\n"
    ]);
    _templateObject6 = function() {
        return data;
    };
    return data;
}




const CheckboxWrapper = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-e35232c7-0"
})(styles_templateObject());
const styles_Label = styled_components_browser_cjs["default"].label.withConfig({
    componentId: "sc-e35232c7-1"
})(styles_templateObject1(), (0,es/* ifProp */.fq)({
    reverse: true
}, "row-reverse", "row"), (0,es/* ifProp */.fq)({
    reverse: true
}, "flex-end", "flex-start"), (props)=>props.smallBox ? "8px" : "20px");
const styles_Text = (0,styled_components_browser_cjs["default"])(src/* PSmall */.zK).withConfig({
    componentId: "sc-e35232c7-2"
})(styles_templateObject2(), (0,es/* ifProp */.fq)({
    white: true
}, "".concat(lib_styles_src/* theme.palette.white.main */.rS.palette.white.main), "".concat(lib_styles_src/* theme.palette.blue.main */.rS.palette.blue.main)));
const QuantityNumberWrapper = (0,styled_components_browser_cjs["default"])(src/* PSmall */.zK).withConfig({
    componentId: "sc-e35232c7-3"
})(styles_templateObject3(), lib_styles_src/* theme.palette.gray.50 */.rS.palette.gray[50]);
const StyledCheckbox = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-e35232c7-4"
})(styles_templateObject4(), (props)=>props.smallBox ? "16px" : "24px", (props)=>props.smallBox ? "16px" : "24px", (props)=>props.smallBox ? "16px" : "24px", (props)=>props.smallBox ? "16px" : "24px", (0,es/* ifProp */.fq)({
    white: true
}, "".concat(lib_styles_src/* theme.palette.white.main */.rS.palette.white.main), "".concat(lib_styles_src/* theme.palette.blue.lighter */.rS.palette.blue.lighter)), (0,es/* ifProp */.fq)({
    white: true
}, "".concat(lib_styles_src/* theme.palette.gray.5 */.rS.palette.gray[5]), "".concat(lib_styles_src/* theme.palette.white.main */.rS.palette.white.main)), (0,es/* ifProp */.fq)({
    white: true
}, "".concat(lib_styles_src/* theme.palette.white.main */.rS.palette.white.main), "".concat(lib_styles_src/* theme.palette.blue.lighter */.rS.palette.blue.lighter)));
const CheckboxInput = styled_components_browser_cjs["default"].input.withConfig({
    componentId: "sc-e35232c7-5"
})(_templateObject5(), StyledCheckbox, (0,es/* ifProp */.fq)({
    white: true
}, "".concat(lib_styles_src/* theme.palette.white.main */.rS.palette.white.main), "".concat(lib_styles_src/* theme.palette.blue.main */.rS.palette.blue.main)), (0,es/* ifProp */.fq)({
    white: true
}, "".concat(lib_styles_src/* theme.palette.white.main */.rS.palette.white.main), "".concat(lib_styles_src/* theme.palette.blue.main */.rS.palette.blue.main)), StyledCheckbox, (props)=>props.smallBox ? "16px" : "24px", (props)=>props.smallBox ? "16px" : "24px", lib_styles_src/* theme.palette.transparent.main */.rS.palette.transparent.main, (0,es/* ifProp */.fq)({
    white: true
}, "".concat(lib_styles_src/* theme.palette.white.main */.rS.palette.white.main), "".concat(lib_styles_src/* theme.palette.blue.main */.rS.palette.blue.main)), lib_styles_src/* theme.palette.transparent.main */.rS.palette.transparent.main, StyledCheckbox, (0,es/* ifProp */.fq)({
    white: true
}, " ".concat(lib_styles_src/* theme.palette.gray.5 */.rS.palette.gray[5]), "".concat(lib_styles_src/* theme.palette.white.main */.rS.palette.white.main)), (0,es/* ifProp */.fq)({
    white: true
}, "".concat(lib_styles_src/* theme.palette.white.main */.rS.palette.white.main), "".concat(lib_styles_src/* theme.palette.blue.main */.rS.palette.blue.main)), StyledCheckbox, (props)=>props.smallBox ? "16px" : "24px", (props)=>props.smallBox ? "16px" : "24px", (0,es/* ifProp */.fq)({
    white: true
}, "".concat(lib_styles_src/* theme.palette.white.main */.rS.palette.white.main), "".concat(lib_styles_src/* theme.palette.blue.main */.rS.palette.blue.main)), (0,es/* ifProp */.fq)({
    white: true
}, " ".concat(lib_styles_src/* theme.palette.gray.5 */.rS.palette.gray[5]), "".concat(lib_styles_src/* theme.palette.white.main */.rS.palette.white.main)), styles_Text, (0,es/* ifProp */.fq)({
    white: true
}, "".concat(lib_styles_src/* theme.palette.white.main */.rS.palette.white.main), "".concat(lib_styles_src/* theme.palette.gray.20 */.rS.palette.gray[20])), styles_Label, lib_styles_src/* theme.palette.gray.20 */.rS.palette.gray[20], StyledCheckbox, (0,es/* ifProp */.fq)({
    white: true
}, "".concat(lib_styles_src/* theme.palette.white.main */.rS.palette.white.main), "".concat(lib_styles_src/* theme.palette.gray.20 */.rS.palette.gray[20])), (0,es/* ifProp */.fq)({
    white: true
}, "".concat(lib_styles_src/* theme.palette.gray.5 */.rS.palette.gray[5]), "".concat(lib_styles_src/* theme.palette.white.main */.rS.palette.white.main)), (0,es/* ifProp */.fq)({
    white: true
}, "".concat(lib_styles_src/* theme.palette.white.main */.rS.palette.white.main), "".concat(lib_styles_src/* theme.palette.gray.20 */.rS.palette.gray[20])));
const ErrorText = styled_components_browser_cjs["default"].p.withConfig({
    componentId: "sc-e35232c7-6"
})(_templateObject6(), lib_styles_src/* theme.palette.triggers.warning.main */.rS.palette.triggers.warning.main);

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-component-selectors-virtual-9e0e678d5e/1/packages/component-selectors/src/check-box/checkbox.tsx





const Checkbox = (param)=>{
    let { arialabel ="" , label ="" , disabled =false , white =false , reverse =false , smallBox =false , checked , quantityNumber , value , onClick , errorText , ...props } = param;
    const ariaLabelText = arialabel ? arialabel : typeof label === "string" ? label : "";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(CheckboxWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles_Label, {
                "aria-label": ariaLabelText,
                className: "checkbox",
                reverse: reverse,
                smallBox: smallBox,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckboxInput, {
                        className: "checkbox-input",
                        type: "checkbox",
                        onClick: onClick,
                        ...props,
                        checked: checked,
                        disabled: disabled,
                        smallBox: smallBox,
                        value: value,
                        white: white
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledCheckbox, {
                        ...props,
                        disabled: disabled,
                        smallBox: smallBox,
                        white: white,
                        children: checked && /*#__PURE__*/ (0,jsx_runtime.jsx)(lib_icons_src.CheckmarkIcons, {
                            iconColor: white ? lib_styles_src/* theme.palette.blue.dark */.rS.palette.blue.dark : lib_styles_src/* theme.palette.white.main */.rS.palette.white.main,
                            size: 16
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_Text, {
                        className: "checkbox-text",
                        white: white,
                        children: label
                    }),
                    quantityNumber && /*#__PURE__*/ (0,jsx_runtime.jsxs)(QuantityNumberWrapper, {
                        className: "checkbox-quantity",
                        children: [
                            "(",
                            quantityNumber,
                            ")"
                        ]
                    })
                ]
            }),
            Boolean(errorText) && /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorText, {
                children: errorText
            })
        ]
    });
};

// EXTERNAL MODULE: ../../.yarn/__virtual__/formik-virtual-2973c76625/0/cache/formik-npm-2.2.9-0e8cb516ca-f07f80eee8.zip/node_modules/formik/dist/index.js
var dist = __webpack_require__(20097);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-component-selectors-virtual-9e0e678d5e/1/packages/component-selectors/src/check-box/formik-checkbox.tsx




const FormikCheckbox = (props)=>{
    // useField() returns [formik.getFieldProps(), formik.getFieldMeta()]
    // which we can spread on <input> and alse replace ErrorMessage entirely.
    const [field, meta] = (0,dist.useField)(props);
    const errorText = Boolean(meta.touched) && meta.error || false;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox, {
        ...field,
        ...props,
        checked: field.value,
        errorText: errorText
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-component-selectors-virtual-9e0e678d5e/1/packages/component-selectors/src/check-box/index.ts



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-component-selectors-virtual-9e0e678d5e/1/packages/component-selectors/src/toggle/styles.ts
function toggle_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function toggle_styles_templateObject() {
    const data = toggle_styles_taggedTemplateLiteral([
        "\n  position: relative;\n  display: flex;\n  align-items: center;\n  cursor: ",
        ";\n"
    ]);
    toggle_styles_templateObject = function() {
        return data;
    };
    return data;
}
function toggle_styles_templateObject1() {
    const data = toggle_styles_taggedTemplateLiteral([
        "\n  margin-left: 16px;\n  color: ",
        ";\n  font-size: 1rem;\n  font-weight: 400;\n  line-height: 1;\n"
    ]);
    toggle_styles_templateObject1 = function() {
        return data;
    };
    return data;
}
function toggle_styles_templateObject2() {
    const data = toggle_styles_taggedTemplateLiteral([
        "\n  position: relative;\n  width: 48px;\n  height: 24px;\n  border: ",
        ";\n  border-radius: 12px;\n  background-color: ",
        ";\n  outline: ",
        ";\n  transition: background-color 0.15s;\n  &:after {\n    position: absolute;\n    top: 3px;\n    right: 3px;\n    bottom: 3px;\n    left: ",
        ";\n    display: flex;\n    width: 18px;\n    height: 18px;\n    border-radius: 12px;\n    margin: auto 0;\n    margin-left: ",
        ";\n    background-color: ",
        ';\n    content: "";\n    transition: all 150ms ease-out;\n  }\n\n  &:before {\n    border-radius: 10px;\n  }\n  &:hover {\n    &:after {\n      left: ',
        ';\n      width: 28px;\n      content: "";\n    }\n  }\n'
    ]);
    toggle_styles_templateObject2 = function() {
        return data;
    };
    return data;
}
function toggle_styles_templateObject3() {
    const data = toggle_styles_taggedTemplateLiteral([
        "\n  position: absolute;\n  border-radius: 0;\n  visibility: hidden;\n\n  &:disabled {\n    ~ ",
        " {\n      border: ",
        ";\n      background-color: ",
        ";\n      outline: ",
        ";\n      &:after {\n        width: 18px;\n      }\n      &:hover {\n        transform: none;\n\n        &:before {\n          transform: translateZ(-1em);\n        }\n      }\n    }\n  }\n"
    ]);
    toggle_styles_templateObject3 = function() {
        return data;
    };
    return data;
}



const toggle_styles_Label = styled_components_browser_cjs["default"].label.withConfig({
    componentId: "sc-769b99bf-0"
})(toggle_styles_templateObject(), (0,es/* ifProp */.fq)({
    disabled: true
}, "not-allowed", "pointer"));
const toggle_styles_Text = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-769b99bf-1"
})(toggle_styles_templateObject1(), (props)=>props.labelColor);
const Switch = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-769b99bf-2"
})(toggle_styles_templateObject2(), (0,es/* ifProp */.fq)({
    border: true
}, "1px solid ".concat(lib_styles_src/* theme.palette.white.main */.rS.palette.white.main), "none"), (0,es/* ifProp */.fq)({
    checked: true
}, lib_styles_src/* theme.palette.blue.main */.rS.palette.blue.main, lib_styles_src/* theme.palette.gray.30 */.rS.palette.gray[30]), (0,es/* ifProp */.fq)({
    border: true
}, "1px solid ".concat(lib_styles_src/* theme.palette.blue.main */.rS.palette.blue.main), "none"), (0,es/* ifProp */.fq)({
    checked: true
}, "25px", "3px"), (0,es/* ifProp */.fq)({
    checked: true
}, "auto", "0"), lib_styles_src/* theme.palette.white.main */.rS.palette.white.main, (0,es/* ifProp */.fq)({
    checked: true
}, "0", "3px"));
const styles_CheckboxInput = styled_components_browser_cjs["default"].input.withConfig({
    componentId: "sc-769b99bf-3"
})(toggle_styles_templateObject3(), Switch, (0,es/* ifProp */.fq)({
    border: true
}, "1px solid ".concat(lib_styles_src/* theme.palette.white.main */.rS.palette.white.main), "none"), lib_styles_src/* theme.palette.gray.10 */.rS.palette.gray[10], (0,es/* ifProp */.fq)({
    border: true
}, "1px solid ".concat(lib_styles_src/* theme.palette.gray.10 */.rS.palette.gray[10]), "none"));

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-component-selectors-virtual-9e0e678d5e/1/packages/component-selectors/src/toggle/toggle.tsx




const Toggle = (param)=>{
    let { label ="" , labelColor =lib_styles_src/* theme.palette.blue.dark */.rS.palette.blue.dark , checked =false , onToggle , disabled =false , border =false , className ="toggle-container" , ...props } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(toggle_styles_Label, {
        className: className,
        disabled: disabled,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_CheckboxInput, {
                border: border,
                checked: checked,
                disabled: disabled,
                name: label,
                type: "checkbox",
                onChange: onToggle,
                ...props
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Switch, {
                border: border,
                checked: checked
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(toggle_styles_Text, {
                labelColor: labelColor,
                children: label
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-component-selectors-virtual-9e0e678d5e/1/packages/component-selectors/src/toggle/index.ts


;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-component-selectors-virtual-9e0e678d5e/1/packages/component-selectors/src/index.ts





/***/ }),

/***/ 46146:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "iR": function() { return /* reexport */ Slider; }
});

// UNUSED EXPORTS: ContentSlide, ImageSlide, Slides

// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(61261);
// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(91987);
// EXTERNAL MODULE: ../../.yarn/unplugged/swiper-npm-8.4.7-9971804532/node_modules/swiper/react/swiper-react.js + 105 modules
var swiper_react = __webpack_require__(13682);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-component-page-container-virtual-6ffaf0ab98/1/packages/component-page-container/src/index.ts + 1 modules
var src = __webpack_require__(53000);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-component-buttons-virtual-1a577fdc8c/1/packages/component-buttons/src/index.ts + 16 modules
var component_buttons_src = __webpack_require__(80620);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-lib-icons-virtual-412b14e947/1/packages/lib-icons/src/index.ts + 181 modules
var lib_icons_src = __webpack_require__(45628);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-lib-styles-virtual-b3f1d479f2/1/packages/lib-styles/src/index.ts + 18 modules
var lib_styles_src = __webpack_require__(52203);
// EXTERNAL MODULE: ../../.yarn/__virtual__/styled-components-virtual-29066d9421/0/cache/styled-components-npm-5.3.5-88e3937b59-05a664dfe4.zip/node_modules/styled-components/dist/styled-components.browser.cjs.js
var styled_components_browser_cjs = __webpack_require__(33982);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-component-slider-virtual-0c239e2406/1/packages/component-slider/src/components/slider-buttons/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    const data = _taggedTemplateLiteral([
        "\n  display: flex;\n  width: 100%;\n  max-width: ",
        "px;\n  align-items: center;\n  justify-content: end;\n  margin-top: 30px;\n  margin-right: auto;\n  margin-left: auto;\n  gap: 12px;\n  button {\n    border: 1px solid ",
        ";\n  }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _taggedTemplateLiteral([
        "\n  position: relative;\n  width: 100%;\n  height: 1px;\n  background-color: ",
        ";\n  &:after {\n    position: absolute;\n    width: ",
        "%;\n    height: 3px;\n    background-color: ",
        ';\n    content: "";\n    transform: translate3d(0, -1px, 0);\n    transition: 300ms;\n  }\n'
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}


const SliderButtonsWrapper = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-1f2f81aa-0"
})(_templateObject(), lib_styles_src/* gridTheme.maxContentWidth */.k.maxContentWidth, lib_styles_src/* theme.palette.gray.20 */.rS.palette.gray[20]);
const SliderProgress = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-1f2f81aa-1"
})(_templateObject1(), lib_styles_src/* theme.palette.gray.30 */.rS.palette.gray[30], (props)=>String(props.progress), lib_styles_src/* theme.palette.blue.main */.rS.palette.blue.main);

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-component-slider-virtual-0c239e2406/1/packages/component-slider/src/components/slider-buttons/slider-buttons.tsx








const SliderButtons = (param)=>{
    let { progress  } = param;
    const { activeBreakPoint  } = (0,lib_styles_src/* useWindowSize */.iP)();
    const swiperClick = (0,swiper_react/* useSwiper */.oc)();
    const handlePrevClick = (0,react.useCallback)(()=>{
        swiperClick.slidePrev();
    }, [
        swiperClick
    ]);
    const handleNextClick = (0,react.useCallback)(()=>{
        swiperClick.slideNext();
    }, [
        swiperClick
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SliderButtonsWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SliderProgress, {
                progress: progress
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(component_buttons_src/* IconButton */.hU, {
                ariaLabel: "\xc1fram",
                icon: lib_icons_src.ArrowLeftIcons,
                small: [
                    "s",
                    "xs"
                ].includes(activeBreakPoint),
                onClick: handlePrevClick
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(component_buttons_src/* IconButton */.hU, {
                ariaLabel: "Til baka",
                icon: lib_icons_src.ArrowRightIcons,
                small: [
                    "s",
                    "xs"
                ].includes(activeBreakPoint),
                onClick: handleNextClick
            })
        ]
    });
};

// EXTERNAL MODULE: ../../packages/types-utils/src/index.ts + 3 modules
var types_utils_src = __webpack_require__(71612);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-component-slider-virtual-0c239e2406/1/packages/component-slider/src/components/slide-variants/slides.tsx




const SlideConvert = {
    image: (props)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(ImageSlide, {
            alt: props.alt,
            height: props.height,
            src: props.src
        }),
    video: (props)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(VideoSlide, {
            height: props.height,
            src: props.src
        }),
    content: (props)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(ContentSlide, {
            content: props.content
        })
};
const Slides = (param)=>{
    let { collection  } = param;
    return collection.map((item)=>{
        const fn = SlideConvert[item.type];
        if (!fn) {
            return null;
        }
        // We know that this is the correct type.
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return fn(item);
    }).filter(isNotNull);
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-component-slider-virtual-0c239e2406/1/packages/component-slider/src/components/slide-variants/image-slide.tsx


const ImageSlide = (param)=>{
    let { alt , src , height =240  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
        alt: alt,
        height: height,
        src: src
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-component-slider-virtual-0c239e2406/1/packages/component-slider/src/components/slide-variants/styles.ts
function styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function styles_templateObject() {
    const data = styles_taggedTemplateLiteral([
        ""
    ]);
    styles_templateObject = function() {
        return data;
    };
    return data;
}
function styles_templateObject1() {
    const data = styles_taggedTemplateLiteral([
        "\n  width: 100%;\n  height: 100%;\n"
    ]);
    styles_templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = styles_taggedTemplateLiteral([
        ""
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}

const IFrameWrapper = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-f2ceb9f9-0"
})(styles_templateObject());
const IFrame = styled_components_browser_cjs["default"].iframe.withConfig({
    componentId: "sc-f2ceb9f9-1"
})(styles_templateObject1());
const VideoBlockContainer = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-f2ceb9f9-2"
})(_templateObject2());

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-component-slider-virtual-0c239e2406/1/packages/component-slider/src/components/slide-variants/video-slide.tsx



const VideoSlide = (param)=>{
    let { src , height =240 , width  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(IFrame, {
        allowFullScreen: true,
        frameBorder: "0",
        height: height,
        src: "https://youtube.com/embed/".concat(src),
        width: width
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-component-slider-virtual-0c239e2406/1/packages/component-slider/src/components/slide-variants/content-slide.tsx


const ContentSlide = (param)=>{
    let { content  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: content
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-component-slider-virtual-0c239e2406/1/packages/component-slider/src/components/slide-variants/index.ts





;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-component-slider-virtual-0c239e2406/1/packages/component-slider/src/components/index.ts



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-component-slider-virtual-0c239e2406/1/packages/component-slider/src/components/clickable-slide/styles.ts
function clickable_slide_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function clickable_slide_styles_templateObject() {
    const data = clickable_slide_styles_taggedTemplateLiteral([
        "\n  width: 100%;\n  cursor: pointer;\n"
    ]);
    clickable_slide_styles_templateObject = function() {
        return data;
    };
    return data;
}

const SlideButton = styled_components_browser_cjs["default"].button.withConfig({
    componentId: "sc-b97d623c-0"
})(clickable_slide_styles_templateObject());

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-component-slider-virtual-0c239e2406/1/packages/component-slider/src/components/clickable-slide/clickable-slide.tsx



const ClickableSlide = (param)=>{
    let { onClick , index , slideContent  } = param;
    const handleClick = (0,react.useCallback)(()=>{
        if (onClick) {
            onClick(index);
        }
    }, [
        index,
        onClick
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SlideButton, {
        type: "button",
        onClick: handleClick,
        children: slideContent
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-component-slider-virtual-0c239e2406/1/packages/component-slider/src/components/clickable-slide/index.ts


;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-component-slider-virtual-0c239e2406/1/packages/component-slider/src/styles.ts
/* eslint-disable max-len */ function src_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function src_styles_templateObject() {
    const data = src_styles_taggedTemplateLiteral([
        "\n  .swiper {\n    position: relative;\n    width: 100%;\n    height: 100%;\n  }\n\n  .swiper-slide {\n    display: flex;\n    background: transparent;\n  }\n\n  .swiper-slide img {\n    display: block;\n    width: 100%;\n  }\n"
    ]);
    src_styles_templateObject = function() {
        return data;
    };
    return data;
}
function src_styles_templateObject1() {
    const data = src_styles_taggedTemplateLiteral([
        '\n  /**\n * Swiper 8.4.7\n * Most modern mobile touch slider and framework with hardware accelerated transitions\n * https://swiperjs.com\n *\n * Copyright 2014-2023 Vladimir Kharlampidi <3\n *\n * Released under the MIT License\n *\n * Released on: January 30, 2023\n */\n\n  @font-face {\n    font-family: swiper-icons;\n    font-style: normal;\n    font-weight: 400;\n    src: url("data:application/font-woff;charset=utf-8;base64, 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");\n  }\n  :root {\n    --swiper-theme-color: #007aff;\n    --swiper-navigation-size: 44px;\n  }\n  .swiper {\n    position: relative;\n    z-index: 1;\n    overflow: hidden;\n    padding: 0;\n    margin-right: auto;\n    margin-left: auto;\n    list-style: none;\n  }\n  .swiper-vertical > .swiper-wrapper {\n    flex-direction: column;\n  }\n  .swiper-wrapper {\n    position: relative;\n    z-index: 1;\n    display: flex;\n    width: 100%;\n    height: 100%;\n    box-sizing: content-box;\n    transition-property: transform;\n  }\n  .swiper-android .swiper-slide,\n  .swiper-wrapper {\n    transform: translate3d(0px, 0, 0);\n  }\n  .swiper-pointer-events {\n    touch-action: pan-y;\n  }\n  .swiper-pointer-events.swiper-vertical {\n    touch-action: pan-x;\n  }\n  .swiper-slide {\n    position: relative;\n    width: 100%;\n    height: 100%;\n    flex-shrink: 0;\n    transition-property: transform;\n  }\n  .swiper-slide-invisible-blank {\n    visibility: hidden;\n  }\n  .swiper-autoheight,\n  .swiper-autoheight .swiper-slide {\n    height: auto;\n  }\n  .swiper-autoheight .swiper-wrapper {\n    align-items: flex-start;\n    transition-property: transform, height;\n  }\n  .swiper-backface-hidden .swiper-slide {\n    backface-visibility: hidden;\n    transform: translateZ(0);\n  }\n  .swiper-3d,\n  .swiper-3d.swiper-css-mode .swiper-wrapper {\n    perspective: 1200px;\n  }\n  .swiper-3d .swiper-cube-shadow,\n  .swiper-3d .swiper-slide,\n  .swiper-3d .swiper-slide-shadow,\n  .swiper-3d .swiper-slide-shadow-bottom,\n  .swiper-3d .swiper-slide-shadow-left,\n  .swiper-3d .swiper-slide-shadow-right,\n  .swiper-3d .swiper-slide-shadow-top,\n  .swiper-3d .swiper-wrapper {\n    transform-style: preserve-3d;\n  }\n  .swiper-3d .swiper-slide-shadow,\n  .swiper-3d .swiper-slide-shadow-bottom,\n  .swiper-3d .swiper-slide-shadow-left,\n  .swiper-3d .swiper-slide-shadow-right,\n  .swiper-3d .swiper-slide-shadow-top {\n    position: absolute;\n    z-index: 10;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    pointer-events: none;\n  }\n  .swiper-3d .swiper-slide-shadow {\n    background: rgba(0, 0, 0, 0.15);\n  }\n  .swiper-3d .swiper-slide-shadow-left {\n    background-image: linear-gradient(to left, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0));\n  }\n  .swiper-3d .swiper-slide-shadow-right {\n    background-image: linear-gradient(to right, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0));\n  }\n  .swiper-3d .swiper-slide-shadow-top {\n    background-image: linear-gradient(to top, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0));\n  }\n  .swiper-3d .swiper-slide-shadow-bottom {\n    background-image: linear-gradient(to bottom, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0));\n  }\n  .swiper-css-mode > .swiper-wrapper {\n    overflow: auto;\n    -ms-overflow-style: none;\n    scrollbar-width: none;\n  }\n  .swiper-css-mode > .swiper-wrapper::-webkit-scrollbar {\n    display: none;\n  }\n  .swiper-css-mode > .swiper-wrapper > .swiper-slide {\n    scroll-snap-align: start start;\n  }\n  .swiper-horizontal.swiper-css-mode > .swiper-wrapper {\n    scroll-snap-type: x mandatory;\n  }\n  .swiper-vertical.swiper-css-mode > .swiper-wrapper {\n    scroll-snap-type: y mandatory;\n  }\n  .swiper-centered > .swiper-wrapper::before {\n    flex-shrink: 0;\n    order: 9999;\n    content: "";\n  }\n  .swiper-centered.swiper-horizontal > .swiper-wrapper > .swiper-slide:first-child {\n    margin-inline-start: var(--swiper-centered-offset-before);\n    -webkit-margin-start: var(--swiper-centered-offset-before);\n  }\n  .swiper-centered.swiper-horizontal > .swiper-wrapper::before {\n    width: var(--swiper-centered-offset-after);\n    height: 100%;\n    min-height: 1px;\n  }\n  .swiper-centered.swiper-vertical > .swiper-wrapper > .swiper-slide:first-child {\n    -webkit-margin-before: var(--swiper-centered-offset-before);\n    margin-block-start: var(--swiper-centered-offset-before);\n  }\n  .swiper-centered.swiper-vertical > .swiper-wrapper::before {\n    width: 100%;\n    min-width: 1px;\n    height: var(--swiper-centered-offset-after);\n  }\n  .swiper-centered > .swiper-wrapper > .swiper-slide {\n    scroll-snap-align: center center;\n    scroll-snap-stop: always;\n  }\n  .swiper-virtual .swiper-slide {\n    backface-visibility: hidden;\n    transform: translateZ(0);\n  }\n  .swiper-virtual.swiper-css-mode .swiper-wrapper::after {\n    position: absolute;\n    top: 0;\n    left: 0;\n    content: "";\n    pointer-events: none;\n  }\n  .swiper-virtual.swiper-css-mode.swiper-horizontal .swiper-wrapper::after {\n    width: var(--swiper-virtual-size);\n    height: 1px;\n  }\n  .swiper-virtual.swiper-css-mode.swiper-vertical .swiper-wrapper::after {\n    width: 1px;\n    height: var(--swiper-virtual-size);\n  }\n\n  .swiper-button-next,\n  .swiper-button-prev {\n    position: absolute;\n    z-index: 10;\n    top: 50%;\n    display: flex;\n    width: calc(var(--swiper-navigation-size) / 44 * 27);\n    height: var(--swiper-navigation-size);\n    align-items: center;\n    justify-content: center;\n    margin-top: calc(0px - (var(--swiper-navigation-size) / 2));\n    color: var(--swiper-navigation-color, var(--swiper-theme-color));\n    cursor: pointer;\n  }\n  .swiper-button-next.swiper-button-disabled,\n  .swiper-button-prev.swiper-button-disabled {\n    cursor: auto;\n    opacity: 0.35;\n    pointer-events: none;\n  }\n  .swiper-button-next.swiper-button-hidden,\n  .swiper-button-prev.swiper-button-hidden {\n    cursor: auto;\n    opacity: 0;\n    pointer-events: none;\n  }\n  .swiper-navigation-disabled .swiper-button-next,\n  .swiper-navigation-disabled .swiper-button-prev {\n    display: none !important;\n  }\n  .swiper-button-next:after,\n  .swiper-button-prev:after {\n    /* stylelint-disable-next-line font-family-no-missing-generic-family-keyword */\n    font-family: swiper-icons;\n    font-size: var(--swiper-navigation-size);\n    font-variant: initial;\n    letter-spacing: 0;\n    line-height: 1;\n    text-transform: none !important;\n  }\n  .swiper-button-prev,\n  .swiper-rtl .swiper-button-next {\n    right: auto;\n    left: 10px;\n  }\n  .swiper-button-prev:after,\n  .swiper-rtl .swiper-button-next:after {\n    content: "prev";\n  }\n  .swiper-button-next,\n  .swiper-rtl .swiper-button-prev {\n    right: 10px;\n    left: auto;\n  }\n  .swiper-button-next:after,\n  .swiper-rtl .swiper-button-prev:after {\n    content: "next";\n  }\n  .swiper-button-lock {\n    display: none;\n  }\n  .swiper-pagination {\n    position: absolute;\n    z-index: 10;\n    text-align: center;\n    transform: translate3d(0, 0, 0);\n    transition: 0.3s opacity;\n  }\n  .swiper-pagination.swiper-pagination-hidden {\n    opacity: 0;\n  }\n  .swiper-pagination-disabled > .swiper-pagination,\n  .swiper-pagination.swiper-pagination-disabled {\n    display: none !important;\n  }\n  .swiper-horizontal > .swiper-pagination-bullets,\n  .swiper-pagination-bullets.swiper-pagination-horizontal,\n  .swiper-pagination-custom,\n  .swiper-pagination-fraction {\n    bottom: 10px;\n    left: 0;\n    width: 100%;\n  }\n  .swiper-pagination-bullets-dynamic {\n    overflow: hidden;\n    font-size: 0;\n  }\n  .swiper-pagination-bullets-dynamic .swiper-pagination-bullet {\n    position: relative;\n    transform: scale(0.33);\n  }\n  .swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active {\n    transform: scale(1);\n  }\n  .swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-main {\n    transform: scale(1);\n  }\n  .swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-prev {\n    transform: scale(0.66);\n  }\n  .swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-prev-prev {\n    transform: scale(0.33);\n  }\n  .swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-next {\n    transform: scale(0.66);\n  }\n  .swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-next-next {\n    transform: scale(0.33);\n  }\n  .swiper-pagination-bullet {\n    display: inline-block;\n    width: var(--swiper-pagination-bullet-width, var(--swiper-pagination-bullet-size, 8px));\n    height: var(--swiper-pagination-bullet-height, var(--swiper-pagination-bullet-size, 8px));\n    border-radius: 50%;\n    background: var(--swiper-pagination-bullet-inactive-color, #000);\n    opacity: var(--swiper-pagination-bullet-inactive-opacity, 0.2);\n  }\n  button.swiper-pagination-bullet {\n    padding: 0;\n    border: none;\n    margin: 0;\n    appearance: none;\n    box-shadow: none;\n  }\n  .swiper-pagination-clickable .swiper-pagination-bullet {\n    cursor: pointer;\n  }\n  .swiper-pagination-bullet:only-child {\n    display: none !important;\n  }\n  .swiper-pagination-bullet-active {\n    background: var(--swiper-pagination-color, var(--swiper-theme-color));\n    opacity: var(--swiper-pagination-bullet-opacity, 1);\n  }\n  .swiper-pagination-vertical.swiper-pagination-bullets,\n  .swiper-vertical > .swiper-pagination-bullets {\n    top: 50%;\n    right: 10px;\n    transform: translate3d(0px, -50%, 0);\n  }\n  .swiper-pagination-vertical.swiper-pagination-bullets .swiper-pagination-bullet,\n  .swiper-vertical > .swiper-pagination-bullets .swiper-pagination-bullet {\n    display: block;\n    margin: var(--swiper-pagination-bullet-vertical-gap, 6px) 0;\n  }\n  .swiper-pagination-vertical.swiper-pagination-bullets.swiper-pagination-bullets-dynamic,\n  .swiper-vertical > .swiper-pagination-bullets.swiper-pagination-bullets-dynamic {\n    top: 50%;\n    width: 8px;\n    transform: translateY(-50%);\n  }\n  .swiper-pagination-vertical.swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet,\n  .swiper-vertical > .swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet {\n    display: inline-block;\n    transition: 0.2s transform, 0.2s top;\n  }\n  .swiper-horizontal > .swiper-pagination-bullets .swiper-pagination-bullet,\n  .swiper-pagination-horizontal.swiper-pagination-bullets .swiper-pagination-bullet {\n    margin: 0 var(--swiper-pagination-bullet-horizontal-gap, 4px);\n  }\n  .swiper-horizontal > .swiper-pagination-bullets.swiper-pagination-bullets-dynamic,\n  .swiper-pagination-horizontal.swiper-pagination-bullets.swiper-pagination-bullets-dynamic {\n    left: 50%;\n    transform: translateX(-50%);\n    white-space: nowrap;\n  }\n  .swiper-horizontal > .swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet,\n  .swiper-pagination-horizontal.swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet {\n    transition: 0.2s transform, 0.2s left;\n  }\n  .swiper-horizontal.swiper-rtl > .swiper-pagination-bullets-dynamic .swiper-pagination-bullet {\n    transition: 0.2s transform, 0.2s right;\n  }\n  .swiper-pagination-progressbar {\n    position: absolute;\n    background: rgba(0, 0, 0, 0.25);\n  }\n  .swiper-pagination-progressbar .swiper-pagination-progressbar-fill {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background: var(--swiper-pagination-color, var(--swiper-theme-color));\n    transform: scale(0);\n    transform-origin: left top;\n  }\n  .swiper-rtl .swiper-pagination-progressbar .swiper-pagination-progressbar-fill {\n    transform-origin: right top;\n  }\n  .swiper-horizontal > .swiper-pagination-progressbar,\n  .swiper-pagination-progressbar.swiper-pagination-horizontal,\n  .swiper-pagination-progressbar.swiper-pagination-vertical.swiper-pagination-progressbar-opposite,\n  .swiper-vertical > .swiper-pagination-progressbar.swiper-pagination-progressbar-opposite {\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 4px;\n  }\n  .swiper-horizontal > .swiper-pagination-progressbar.swiper-pagination-progressbar-opposite,\n  .swiper-pagination-progressbar.swiper-pagination-horizontal.swiper-pagination-progressbar-opposite,\n  .swiper-pagination-progressbar.swiper-pagination-vertical,\n  .swiper-vertical > .swiper-pagination-progressbar {\n    top: 0;\n    left: 0;\n    width: 4px;\n    height: 100%;\n  }\n  .swiper-pagination-lock {\n    display: none;\n  }\n  .swiper-scrollbar-disabled > .swiper-scrollbar,\n  .swiper-scrollbar.swiper-scrollbar-disabled {\n    display: none !important;\n  }\n  .swiper-horizontal > .swiper-scrollbar,\n  .swiper-scrollbar.swiper-scrollbar-horizontal {\n    position: absolute;\n    z-index: 50;\n    bottom: 3px;\n    left: 1%;\n    width: 98%;\n    height: 5px;\n  }\n  .swiper-scrollbar.swiper-scrollbar-vertical,\n  .swiper-vertical > .swiper-scrollbar {\n    position: absolute;\n    z-index: 50;\n    top: 1%;\n    right: 3px;\n    width: 5px;\n    height: 98%;\n  }\n  .swiper-scrollbar-drag {\n    position: relative;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    border-radius: 10px;\n    background: rgba(0, 0, 0, 0.5);\n  }\n  .swiper-scrollbar-cursor-drag {\n    cursor: move;\n  }\n  .swiper-scrollbar-lock {\n    display: none;\n  }\n  .swiper-zoom-container {\n    display: flex;\n    width: 100%;\n    height: 100%;\n    align-items: center;\n    justify-content: center;\n    text-align: center;\n  }\n  .swiper-zoom-container > canvas,\n  .swiper-zoom-container > img,\n  .swiper-zoom-container > svg {\n    max-width: 100%;\n    max-height: 100%;\n    object-fit: contain;\n  }\n  .swiper-slide-zoomed {\n    cursor: move;\n  }\n  .swiper-lazy-preloader {\n    position: absolute;\n    z-index: 10;\n    top: 50%;\n    left: 50%;\n    width: 42px;\n    height: 42px;\n    box-sizing: border-box;\n    border: 4px solid var(--swiper-preloader-color, var(--swiper-theme-color));\n    border-radius: 50%;\n    border-top-color: transparent;\n    margin-top: -21px;\n    margin-left: -21px;\n    transform-origin: 50%;\n  }\n  .swiper-watch-progress .swiper-slide-visible .swiper-lazy-preloader,\n  .swiper:not(.swiper-watch-progress) .swiper-lazy-preloader {\n    animation: swiper-preloader-spin 1s infinite linear;\n  }\n  .swiper-lazy-preloader-white {\n    --swiper-preloader-color: #fff;\n  }\n  .swiper-lazy-preloader-black {\n    --swiper-preloader-color: #000;\n  }\n  @keyframes swiper-preloader-spin {\n    0% {\n      transform: rotate(0deg);\n    }\n    100% {\n      transform: rotate(360deg);\n    }\n  }\n  .swiper .swiper-notification {\n    position: absolute;\n    z-index: -1000;\n    top: 0;\n    left: 0;\n    opacity: 0;\n    pointer-events: none;\n  }\n  .swiper-free-mode > .swiper-wrapper {\n    margin: 0 auto;\n    transition-timing-function: ease-out;\n  }\n  .swiper-grid > .swiper-wrapper {\n    flex-wrap: wrap;\n  }\n  .swiper-grid-column > .swiper-wrapper {\n    flex-direction: column;\n    flex-wrap: wrap;\n  }\n  .swiper-fade.swiper-free-mode .swiper-slide {\n    transition-timing-function: ease-out;\n  }\n  .swiper-fade .swiper-slide {\n    pointer-events: none;\n    transition-property: opacity;\n  }\n  .swiper-fade .swiper-slide .swiper-slide {\n    pointer-events: none;\n  }\n  .swiper-fade .swiper-slide-active,\n  .swiper-fade .swiper-slide-active .swiper-slide-active {\n    pointer-events: auto;\n  }\n  .swiper-cube {\n    overflow: visible;\n  }\n  .swiper-cube .swiper-slide {\n    z-index: 1;\n    width: 100%;\n    height: 100%;\n    backface-visibility: hidden;\n    pointer-events: none;\n    transform-origin: 0 0;\n    visibility: hidden;\n  }\n  .swiper-cube .swiper-slide .swiper-slide {\n    pointer-events: none;\n  }\n  .swiper-cube.swiper-rtl .swiper-slide {\n    transform-origin: 100% 0;\n  }\n  .swiper-cube .swiper-slide-active,\n  .swiper-cube .swiper-slide-active .swiper-slide-active {\n    pointer-events: auto;\n  }\n  .swiper-cube .swiper-slide-active,\n  .swiper-cube .swiper-slide-next,\n  .swiper-cube .swiper-slide-next + .swiper-slide,\n  .swiper-cube .swiper-slide-prev {\n    pointer-events: auto;\n    visibility: visible;\n  }\n  .swiper-cube .swiper-slide-shadow-bottom,\n  .swiper-cube .swiper-slide-shadow-left,\n  .swiper-cube .swiper-slide-shadow-right,\n  .swiper-cube .swiper-slide-shadow-top {\n    z-index: 0;\n    backface-visibility: hidden;\n  }\n  .swiper-cube .swiper-cube-shadow {\n    position: absolute;\n    z-index: 0;\n    bottom: 0px;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    opacity: 0.6;\n  }\n  .swiper-cube .swiper-cube-shadow:before {\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    background: #000;\n    content: "";\n    filter: blur(50px);\n  }\n  .swiper-flip {\n    overflow: visible;\n  }\n  .swiper-flip .swiper-slide {\n    z-index: 1;\n    backface-visibility: hidden;\n    pointer-events: none;\n  }\n  .swiper-flip .swiper-slide .swiper-slide {\n    pointer-events: none;\n  }\n  .swiper-flip .swiper-slide-active,\n  .swiper-flip .swiper-slide-active .swiper-slide-active {\n    pointer-events: auto;\n  }\n  .swiper-flip .swiper-slide-shadow-bottom,\n  .swiper-flip .swiper-slide-shadow-left,\n  .swiper-flip .swiper-slide-shadow-right,\n  .swiper-flip .swiper-slide-shadow-top {\n    z-index: 0;\n    backface-visibility: hidden;\n  }\n  .swiper-creative .swiper-slide {\n    overflow: hidden;\n    backface-visibility: hidden;\n    transition-property: transform, opacity, height;\n  }\n  .swiper-cards {\n    overflow: visible;\n  }\n  .swiper-cards .swiper-slide {\n    overflow: hidden;\n    backface-visibility: hidden;\n    transform-origin: center bottom;\n  }\n\n  .swiper-scrollbar {\n    position: relative;\n    border-radius: 10px;\n    background: rgba(0, 0, 0, 0.1);\n    touch-action: none;\n  }\n'
    ]);
    src_styles_templateObject1 = function() {
        return data;
    };
    return data;
}

const SwiperContainer = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-5ef640b7-0"
})(src_styles_templateObject());
const SwiperStyledContainer = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-5ef640b7-1"
})(src_styles_templateObject1());

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-component-slider-virtual-0c239e2406/1/packages/component-slider/src/slider.tsx








const Slider = (param)=>{
    let { slideCollection , slidesPerGroup =1 , spaceBetween =20 , breakpoints , paginationGutter =false , autoPadLeft =false , autoPadRight =false , autoPad =false , slideWidth =325 , onClick , resetCondition  } = param;
    const { width  } = (0,lib_styles_src/* useWindowSize */.iP)();
    const sidePadding = (0,react.useMemo)(()=>{
        if (width <= 699) {
            return 24;
        }
        if (width <= 1079) {
            return 48;
        }
        if (width <= 1439) {
            return 56;
        }
        if (width >= lib_styles_src/* gridTheme.maxContentWidth */.k.maxContentWidth + 309) {
            return (width - lib_styles_src/* gridTheme.maxContentWidth */.k.maxContentWidth) * 0.5;
        }
        return 56 + width * 0.05;
    }, [
        width
    ]);
    const localBreakpoints = (0,react.useMemo)(()=>{
        if (breakpoints) {
            return breakpoints;
        }
        const content = {};
        const localSlideWidth = slideWidth !== null && slideWidth !== void 0 ? slideWidth : 325;
        for(let i = 320; i < 2400; i++){
            const sliderPerView = i / localSlideWidth;
            content[i] = {
                slidesPerView: sliderPerView < 1 ? 1 : sliderPerView,
                spaceBetween: 10
            };
        }
        return content;
    }, [
        breakpoints,
        slideWidth
    ]);
    const [progress, setProgress] = (0,react.useState)(0);
    const localSlideCollection = (0,react.useMemo)(()=>{
        return slideCollection.map((slide, index)=>{
            return {
                ...slide,
                key: index
            };
        }, []);
    }, [
        slideCollection
    ]);
    const keys = (0,react.useMemo)(()=>Object.keys(localBreakpoints), [
        localBreakpoints
    ]);
    const getSlidesPerView = (0,react.useMemo)(()=>{
        let perView = 1;
        if (true) {
            for(let i = keys.length - 1; i > 0; i--){
                if (window.innerWidth >= Number(keys[i])) {
                    var ref;
                    perView = Number((ref = localBreakpoints[Number(keys[i])]) === null || ref === void 0 ? void 0 : ref.slidesPerView);
                    break;
                }
            }
        }
        return perView;
    }, [
        keys,
        localBreakpoints
    ]);
    const handleChangeHandler = (0,react.useCallback)((swiper, slidesPerView)=>{
        const localProgress = (slidesPerView + swiper.activeIndex) / slideCollection.length * 100;
        setProgress(localProgress <= 100 ? localProgress : 100);
    }, [
        slideCollection.length
    ]);
    const handleChange = (0,react.useCallback)((swiper)=>{
        handleChangeHandler(swiper, getSlidesPerView);
    }, [
        getSlidesPerView,
        handleChangeHandler
    ]);
    const showPagination = (0,react.useMemo)(()=>{
        return getSlidesPerView < slideCollection.length;
    }, [
        getSlidesPerView,
        slideCollection.length
    ]);
    if (width === 0) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SwiperStyledContainer, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SwiperContainer, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(swiper_react/* Swiper */.tq, {
                followFinger: true,
                slidesOffsetAfter: autoPad || autoPadRight ? sidePadding : 0,
                slidesOffsetBefore: autoPad || autoPadLeft ? sidePadding : 0,
                slidesPerGroup: slidesPerGroup,
                slidesPerView: getSlidesPerView,
                breakpoints: localBreakpoints,
                spaceBetween: spaceBetween,
                onAfterInit: handleChange,
                onResize: handleChange,
                onTransitionStart: handleChange,
                children: [
                    localSlideCollection === null || localSlideCollection === void 0 ? void 0 : localSlideCollection.map((slideContent, index)=>onClick ? /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ClickableSlide, {
                                index: index,
                                slideContent: slideContent,
                                onClick: onClick
                            }, slideContent.key)
                        }, slideContent.key) : /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                            children: slideContent
                        }, slideContent.key)),
                    showPagination && Boolean(paginationGutter) && /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* PageContainer */._, {
                        flexDirection: "column",
                        offsetNav: false,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SliderButtons, {
                            progress: progress
                        })
                    }),
                    showPagination && !Boolean(paginationGutter) && /*#__PURE__*/ (0,jsx_runtime.jsx)(SliderButtons, {
                        progress: progress
                    })
                ]
            }, resetCondition)
        })
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-component-slider-virtual-0c239e2406/1/packages/component-slider/src/index.ts





/***/ }),

/***/ 63323:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "u": function() { return /* reexport */ Tooltip; }
});

// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(61261);
// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(91987);
// EXTERNAL MODULE: ../../.yarn/__virtual__/usehooks-ts-virtual-e376d4cf26/0/cache/usehooks-ts-npm-2.9.1-14c625587f-36f1e4142c.zip/node_modules/usehooks-ts/dist/esm/index.js + 36 modules
var esm = __webpack_require__(78420);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-component-typography-virtual-537720fdd1/1/packages/component-typography/src/index.ts + 2 modules
var src = __webpack_require__(91371);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-lib-icons-virtual-412b14e947/1/packages/lib-icons/src/index.ts + 181 modules
var lib_icons_src = __webpack_require__(45628);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-lib-styles-virtual-b3f1d479f2/1/packages/lib-styles/src/index.ts + 18 modules
var lib_styles_src = __webpack_require__(52203);
// EXTERNAL MODULE: ../../.yarn/__virtual__/styled-components-virtual-29066d9421/0/cache/styled-components-npm-5.3.5-88e3937b59-05a664dfe4.zip/node_modules/styled-components/dist/styled-components.browser.cjs.js
var styled_components_browser_cjs = __webpack_require__(33982);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-component-tooltip-virtual-e0488091c2/1/packages/component-tooltip/src/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    const data = _taggedTemplateLiteral([
        ""
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _taggedTemplateLiteral([
        "\n  position: absolute;\n  z-index: 3000;\n  top: 0px;\n  display: unset;\n  width: ",
        "px;\n  opacity: ",
        ";\n  pointer-events: none;\n  transform: translate3d(0, ",
        ", 0);\n  transition: 150ms;\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = _taggedTemplateLiteral([
        "\n  position: relative;\n  left: 0px;\n  display: flex;\n  width: 100%;\n  box-sizing: border-box;\n  padding: 0px 16px;\n  transform: translate3d(0, -6px, 0);\n  svg {\n    cursor: pointer;\n  }\n"
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = _taggedTemplateLiteral([
        "\n  position: relative;\n  top: 32px;\n  box-sizing: border-box;\n  padding: 16px;\n  border: 2px solid ",
        ";\n  background-color: ",
        ";\n  transform: translate3d(0, -6px, 0);\n  &::before {\n    position: absolute;\n    top: 0px;\n    width: 16px;\n    height: 16px;\n    background-color: ",
        ';\n    content: "";\n  }\n  &::after {\n    position: absolute;\n    top: 0px;\n    right: 0px;\n    left: 0px;\n    height: 12px;\n    background-color: ',
        ';\n    content: "";\n  }\n'
    ]);
    _templateObject3 = function() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = _taggedTemplateLiteral([
        "\n  position: relative;\n  max-width: 320px;\n  ",
        " {\n    ",
        "\n    ",
        "\n  }\n  ",
        " {\n    &::before {\n      ",
        "\n      ",
        "\n      ",
        "\n      transform: translate3d(",
        ", -50%, 0)\n        rotate(-45deg);\n    }\n  }\n"
    ]);
    _templateObject4 = function() {
        return data;
    };
    return data;
}


const InfoIconClickable = styled_components_browser_cjs["default"].button.withConfig({
    componentId: "sc-96df9a79-0"
})(_templateObject());
const PopoutContainer = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-96df9a79-1"
})(_templateObject1(), (props)=>props.width.toString(), (props)=>props.showTooltip ? "1" : "0", (props)=>props.showTooltip ? "0" : "16px");
const InfoIconContainer = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-96df9a79-2"
})(_templateObject2());
const TooltipContainer = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-96df9a79-3"
})(_templateObject3(), lib_styles_src/* theme.palette.blue.main */.rS.palette.blue.main, lib_styles_src/* theme.palette.white.main */.rS.palette.white.main, lib_styles_src/* theme.palette.blue.main */.rS.palette.blue.main, lib_styles_src/* theme.palette.white.main */.rS.palette.white.main);
const TooltipWrapper = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-96df9a79-4"
})(_templateObject4(), PopoutContainer, (props)=>props.arrowLocation === "right" ? "transform: translate3d(calc(-100% + 52px), 0, 0)" : "", (props)=>props.arrowLocation === "center" ? "transform: translate3d(calc(-50% + 18px), 0, 0)" : "", TooltipContainer, (props)=>props.arrowLocation === "left" ? "left: 16px;" : "", (props)=>props.arrowLocation === "right" ? "right: 16px;" : "", (props)=>props.arrowLocation === "center" ? "left: 50%;" : "", (props)=>props.arrowLocation === "center" ? "-50%" : "0");

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-component-tooltip-virtual-e0488091c2/1/packages/component-tooltip/src/tooltip.tsx








const Tooltip = (param)=>{
    let { content , arrowLocation ="right" , width =320 , className ="tooltip-container"  } = param;
    const hoverRef = (0,react.useRef)(null);
    const isHover = (0,esm/* useHover */.XI)(hoverRef);
    const iconColor = (0,react.useMemo)(()=>{
        return isHover ? lib_styles_src/* theme.palette.blue.main */.rS.palette.blue.main : lib_styles_src/* theme.palette.gray.20 */.rS.palette.gray[20];
    }, [
        isHover
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(TooltipWrapper, {
        arrowLocation: arrowLocation,
        className: className,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoIconContainer, {
                ref: hoverRef,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lib_icons_src.InfoFilledIcons, {
                    "aria-label": "uppl\xfdsingar",
                    iconColor: iconColor,
                    size: 20
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PopoutContainer, {
                showTooltip: isHover,
                width: width,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TooltipContainer, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* PSmall */.zK, {
                        textColor: lib_styles_src/* theme.palette.black.main */.rS.palette.black.main,
                        children: content
                    })
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-component-tooltip-virtual-e0488091c2/1/packages/component-tooltip/src/index.ts



/***/ }),

/***/ 91371:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "xh": function() { return /* reexport */ BtnText; },
  "Gp": function() { return /* reexport */ EyebrowLarge; },
  "Bz": function() { return /* reexport */ EyebrowMedium; },
  "xA": function() { return /* reexport */ EyebrowSmall; },
  "H1": function() { return /* reexport */ H1; },
  "H2": function() { return /* reexport */ H2; },
  "H3": function() { return /* reexport */ H3; },
  "H4": function() { return /* reexport */ H4; },
  "H5": function() { return /* reexport */ H5; },
  "H6": function() { return /* reexport */ H6; },
  "ZA": function() { return /* reexport */ HeadingsStyles; },
  "cG": function() { return /* reexport */ PLarge; },
  "ej": function() { return /* reexport */ PLargeBold; },
  "aW": function() { return /* reexport */ PMedium; },
  "zo": function() { return /* reexport */ PMediumBold; },
  "zK": function() { return /* reexport */ PSmall; },
  "cZ": function() { return /* reexport */ PSmallBold; },
  "QE": function() { return /* reexport */ Subtitle; },
  "zE": function() { return /* reexport */ SubtitleBold; },
  "c": function() { return /* reexport */ paragraphStyles; }
});

// UNUSED EXPORTS: PMediumCond

// EXTERNAL MODULE: ../../.yarn/__virtual__/styled-components-virtual-29066d9421/0/cache/styled-components-npm-5.3.5-88e3937b59-05a664dfe4.zip/node_modules/styled-components/dist/styled-components.browser.cjs.js
var styled_components_browser_cjs = __webpack_require__(33982);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-lib-styles-virtual-b3f1d479f2/1/packages/lib-styles/src/index.ts + 18 modules
var src = __webpack_require__(52203);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-component-typography-virtual-537720fdd1/1/packages/component-typography/src/headings.tsx
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    const data = _taggedTemplateLiteral([
        "\n  margin-top: ",
        ";\n  margin-right: ",
        ";\n  margin-bottom: ",
        ";\n  margin-left: ",
        ";\n  color: ",
        ";\n  letter-spacing: -0.02em;\n  line-height: 110%;\n  overflow-wrap: break-word;\n  text-align: ",
        ";\n  text-transform: ",
        ";\n  &::selection {\n    background-color: ",
        ";\n  }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _taggedTemplateLiteral([
        "\n  color: ",
        ";\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = _taggedTemplateLiteral([
        "\n  color: ",
        ";\n  font-size: 24px;\n  ",
        "\n  @media screen and (max-width: 375px) {\n    font-size: 20px;\n  }\n  ",
        "\n"
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = _taggedTemplateLiteral([
        "\n  color: ",
        ";\n  font-size: 20px;\n  ",
        "\n  @media screen and (max-width: 375px) {\n    font-size: 20px;\n  }\n  ",
        "\n"
    ]);
    _templateObject3 = function() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = _taggedTemplateLiteral([
        "\n  color: ",
        ";\n  font-size: 20px;\n  ",
        "\n  @media screen and (max-width: 375px) {\n    font-size: 20px;\n  }\n  ",
        "\n"
    ]);
    _templateObject4 = function() {
        return data;
    };
    return data;
}
function _templateObject5() {
    const data = _taggedTemplateLiteral([
        "\n  color: ",
        ";\n  font-size: 20px;\n  ",
        "\n  @media screen and (max-width: 375px) {\n    font-size: 20px;\n  }\n  ",
        "\n"
    ]);
    _templateObject5 = function() {
        return data;
    };
    return data;
}
function _templateObject6() {
    const data = _taggedTemplateLiteral([
        "\n  color: ",
        ";\n  font-size: 20px;\n  ",
        "\n  @media screen and (max-width: 375px) {\n    font-size: 20px;\n  }\n  ",
        "\n"
    ]);
    _templateObject6 = function() {
        return data;
    };
    return data;
}


const HeadingsStyles = (0,styled_components_browser_cjs.css)(_templateObject(), (p)=>"".concat(p.top ? p.top : "0", "px"), (p)=>"".concat(p.right ? p.right : "0", "px"), (p)=>"".concat(p.bottom ? p.bottom : "0", "px"), (p)=>"".concat(p.left ? p.left : "0", "px"), (p)=>p.textColor ? p.textColor : src/* theme.palette.blue.main */.rS.palette.blue.main, (p)=>p.textAlign ? p.textAlign : "inherit", (p)=>p.uppercase ? "uppercase" : "initial", src/* theme.palette.yellow.main */.rS.palette.yellow.main);
const H1 = styled_components_browser_cjs["default"].h1.withConfig({
    componentId: "sc-8857618a-0"
})(_templateObject1(), (param)=>{
    let { textColor  } = param;
    return textColor ? textColor : src/* theme.palette.blue.dark */.rS.palette.blue.dark;
}, (props)=>props.maxFontSize ? "font-size: ".concat(props.maxFontSize, ";") : "font-size: 32px;", HeadingsStyles);
const H2 = styled_components_browser_cjs["default"].h2.withConfig({
    componentId: "sc-8857618a-1"
})(_templateObject2(), (param)=>{
    let { textColor  } = param;
    return textColor ? textColor : src/* theme.palette.blue.dark */.rS.palette.blue.dark;
}, (props)=>props.maxFontSize ? "font-size: ".concat(props.maxFontSize, ";") : "font-size: 24px;", HeadingsStyles);
const H3 = styled_components_browser_cjs["default"].h3.withConfig({
    componentId: "sc-8857618a-2"
})(_templateObject3(), (param)=>{
    let { textColor  } = param;
    return textColor ? textColor : src/* theme.palette.blue.dark */.rS.palette.blue.dark;
}, (props)=>props.maxFontSize ? "font-size: ".concat(props.maxFontSize, ";") : "font-size: 20px;", HeadingsStyles);
const H4 = styled_components_browser_cjs["default"].h4.withConfig({
    componentId: "sc-8857618a-3"
})(_templateObject4(), (param)=>{
    let { textColor  } = param;
    return textColor ? textColor : src/* theme.palette.blue.dark */.rS.palette.blue.dark;
}, (props)=>props.maxFontSize ? "font-size: ".concat(props.maxFontSize, ";") : "font-size: 20px;", HeadingsStyles);
const H5 = styled_components_browser_cjs["default"].h5.withConfig({
    componentId: "sc-8857618a-4"
})(_templateObject5(), (param)=>{
    let { textColor  } = param;
    return textColor ? textColor : src/* theme.palette.blue.dark */.rS.palette.blue.dark;
}, (props)=>props.maxFontSize ? "font-size: ".concat(props.maxFontSize, ";") : "font-size: 20px;", HeadingsStyles);
const H6 = styled_components_browser_cjs["default"].h6.withConfig({
    componentId: "sc-8857618a-5"
})(_templateObject6(), (param)=>{
    let { textColor  } = param;
    return textColor ? textColor : src/* theme.palette.blue.dark */.rS.palette.blue.dark;
}, (props)=>props.maxFontSize ? "font-size: ".concat(props.maxFontSize, ";") : "font-size: 20px;", HeadingsStyles);

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-component-typography-virtual-537720fdd1/1/packages/component-typography/src/non-responsive.tsx
function non_responsive_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function non_responsive_templateObject() {
    const data = non_responsive_taggedTemplateLiteral([
        "\n  margin-top: ",
        ";\n  margin-right: ",
        ";\n  margin-bottom: ",
        ";\n  margin-left: ",
        ";\n  color: ",
        ";\n  line-height: ",
        ";\n  overflow-wrap: break-word;\n  text-align: ",
        ";\n  &::selection {\n    background-color: ",
        ";\n  }\n"
    ]);
    non_responsive_templateObject = function() {
        return data;
    };
    return data;
}
function non_responsive_templateObject1() {
    const data = non_responsive_taggedTemplateLiteral([
        "\n  font-size: 16px;\n  font-weight: medium;\n  ",
        "\n"
    ]);
    non_responsive_templateObject1 = function() {
        return data;
    };
    return data;
}
function non_responsive_templateObject2() {
    const data = non_responsive_taggedTemplateLiteral([
        "\n  font-size: 16px;\n  font-weight: medium;\n  letter-spacing: 0.05em;\n  text-transform: uppercase;\n  ",
        "\n"
    ]);
    non_responsive_templateObject2 = function() {
        return data;
    };
    return data;
}
function non_responsive_templateObject3() {
    const data = non_responsive_taggedTemplateLiteral([
        "\n  font-size: 14px;\n  font-weight: medium;\n  letter-spacing: 0.05em;\n  text-transform: uppercase;\n  ",
        "\n"
    ]);
    non_responsive_templateObject3 = function() {
        return data;
    };
    return data;
}
function non_responsive_templateObject4() {
    const data = non_responsive_taggedTemplateLiteral([
        "\n  font-size: 12px;\n  font-weight: medium;\n  letter-spacing: 0.05em;\n  text-transform: uppercase;\n  ",
        "\n"
    ]);
    non_responsive_templateObject4 = function() {
        return data;
    };
    return data;
}
function non_responsive_templateObject5() {
    const data = non_responsive_taggedTemplateLiteral([
        "\n  font-size: 20px;\n  font-weight: normal;\n  line-height: 150%;\n  ",
        "\n"
    ]);
    non_responsive_templateObject5 = function() {
        return data;
    };
    return data;
}
function non_responsive_templateObject6() {
    const data = non_responsive_taggedTemplateLiteral([
        "\n  font-size: 20px;\n  font-weight: bold;\n  line-height: 150%;\n  ",
        "\n"
    ]);
    non_responsive_templateObject6 = function() {
        return data;
    };
    return data;
}
function _templateObject7() {
    const data = non_responsive_taggedTemplateLiteral([
        "\n  font-size: 20px;\n  line-height: 150%;\n  ",
        "\n"
    ]);
    _templateObject7 = function() {
        return data;
    };
    return data;
}
function _templateObject8() {
    const data = non_responsive_taggedTemplateLiteral([
        "\n  font-size: 20px;\n  font-weight: 400;\n  line-height: 150%;\n  ",
        "\n"
    ]);
    _templateObject8 = function() {
        return data;
    };
    return data;
}
function _templateObject9() {
    const data = non_responsive_taggedTemplateLiteral([
        "\n  font-size: 18px;\n  font-stretch: condensed;\n  ",
        "\n"
    ]);
    _templateObject9 = function() {
        return data;
    };
    return data;
}
function _templateObject10() {
    const data = non_responsive_taggedTemplateLiteral([
        "\n  font-size: 18px;\n  ",
        "\n"
    ]);
    _templateObject10 = function() {
        return data;
    };
    return data;
}
function _templateObject11() {
    const data = non_responsive_taggedTemplateLiteral([
        "\n  font-size: 18px;\n  font-weight: bold;\n  ",
        "\n"
    ]);
    _templateObject11 = function() {
        return data;
    };
    return data;
}
function _templateObject12() {
    const data = non_responsive_taggedTemplateLiteral([
        "\n  font-size: 16px;\n  font-weight: normal;\n  ",
        "\n"
    ]);
    _templateObject12 = function() {
        return data;
    };
    return data;
}
function _templateObject13() {
    const data = non_responsive_taggedTemplateLiteral([
        "\n  font-size: 16px;\n  font-weight: bold;\n  ",
        "\n"
    ]);
    _templateObject13 = function() {
        return data;
    };
    return data;
}


const paragraphStyles = (0,styled_components_browser_cjs.css)(non_responsive_templateObject(), (p)=>"".concat(p.top ? p.top : "0", "px"), (p)=>"".concat(p.right ? p.right : "0", "px"), (p)=>"".concat(p.bottom ? p.bottom : "0", "px"), (p)=>"".concat(p.left ? p.left : "0", "px"), (p)=>p.textColor ? p.textColor : src/* theme.palette.blue.main */.rS.palette.blue.main, (p)=>p.lineHeight ? p.lineHeight : "170%", (p)=>p.textAlign ? p.textAlign : "inherit", src/* theme.palette.yellow.main */.rS.palette.yellow.main);
const BtnText = styled_components_browser_cjs["default"].p.withConfig({
    componentId: "sc-2be93998-0"
})(non_responsive_templateObject1(), paragraphStyles);
const EyebrowLarge = styled_components_browser_cjs["default"].p.withConfig({
    componentId: "sc-2be93998-1"
})(non_responsive_templateObject2(), paragraphStyles);
const EyebrowMedium = styled_components_browser_cjs["default"].p.withConfig({
    componentId: "sc-2be93998-2"
})(non_responsive_templateObject3(), paragraphStyles);
const EyebrowSmall = styled_components_browser_cjs["default"].p.withConfig({
    componentId: "sc-2be93998-3"
})(non_responsive_templateObject4(), paragraphStyles);
const Subtitle = styled_components_browser_cjs["default"].p.withConfig({
    componentId: "sc-2be93998-4"
})(non_responsive_templateObject5(), paragraphStyles);
const SubtitleBold = styled_components_browser_cjs["default"].p.withConfig({
    componentId: "sc-2be93998-5"
})(non_responsive_templateObject6(), paragraphStyles);
const PLarge = styled_components_browser_cjs["default"].p.withConfig({
    componentId: "sc-2be93998-6"
})(_templateObject7(), paragraphStyles);
const PLargeBold = styled_components_browser_cjs["default"].p.withConfig({
    componentId: "sc-2be93998-7"
})(_templateObject8(), paragraphStyles);
const PMediumCond = styled_components_browser_cjs["default"].p.withConfig({
    componentId: "sc-2be93998-8"
})(_templateObject9(), paragraphStyles);
const PMedium = styled_components_browser_cjs["default"].p.withConfig({
    componentId: "sc-2be93998-9"
})(_templateObject10(), paragraphStyles);
const PMediumBold = styled_components_browser_cjs["default"].p.withConfig({
    componentId: "sc-2be93998-10"
})(_templateObject11(), paragraphStyles);
const PSmall = styled_components_browser_cjs["default"].p.withConfig({
    componentId: "sc-2be93998-11"
})(_templateObject12(), paragraphStyles);
const PSmallBold = styled_components_browser_cjs["default"].p.withConfig({
    componentId: "sc-2be93998-12"
})(_templateObject13(), paragraphStyles);

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-component-typography-virtual-537720fdd1/1/packages/component-typography/src/index.ts




/***/ }),

/***/ 68814:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "aC": function() { return /* reexport */ useAuth; },
  "aF": function() { return /* reexport */ useUser; },
  "KL": function() { return /* reexport */ userState; }
});

// UNUSED EXPORTS: activeMembershipState, emailState, loginErrorState, loginLoadingState, membershipsState, securityCodeState, showAsGuestOptionState

// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(91987);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@sentry-nextjs-virtual-cec61ebd1a/0/cache/@sentry-nextjs-npm-7.32.1-0e41610603-6cf9140fad.zip/node_modules/@sentry/nextjs/esm/index.client.js + 70 modules
var index_client = __webpack_require__(56811);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-component-drawer-virtual-d170d66b66/1/packages/component-drawer/src/index.ts + 6 modules
var src = __webpack_require__(58879);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-lib-api-rest-virtual-a514398bdb/1/packages/lib-api-rest/src/index.ts + 4 modules
var lib_api_rest_src = __webpack_require__(97639);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-lib-recoil-virtual-ff20ed22cf/1/packages/lib-recoil/src/index.js
var lib_recoil_src = __webpack_require__(27105);
// EXTERNAL MODULE: ../../packages/types-utils/src/index.ts + 3 modules
var types_utils_src = __webpack_require__(71612);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-hooks-auth-next-virtual-a089da2ab7/1/packages/hooks-auth-next/src/store/user.ts

const userState = (0,lib_recoil_src/* atom */.cn)({
    key: "user",
    default: null
});
const useUser = ()=>(0,lib_recoil_src/* useRecoilValue */.sJ)(userState);

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-hooks-auth-next-virtual-a089da2ab7/1/packages/hooks-auth-next/src/store/login-error.ts

const loginErrorState = (0,lib_recoil_src/* atom */.cn)({
    key: "loginErrorState",
    default: ""
});

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-hooks-auth-next-virtual-a089da2ab7/1/packages/hooks-auth-next/src/store/login-loading.ts

const loginLoadingState = (0,lib_recoil_src/* atom */.cn)({
    key: "loginLoadingState",
    default: false
});

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-hooks-auth-next-virtual-a089da2ab7/1/packages/hooks-auth-next/src/store/memberships.ts

const membershipsState = (0,lib_recoil_src/* atom */.cn)({
    key: "memberships",
    default: []
});

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-hooks-auth-next-virtual-a089da2ab7/1/packages/hooks-auth-next/src/store/active-membership.ts
/* provided dependency */ var Buffer = __webpack_require__(85474)["Buffer"];



const TOKEN = "active-membership-token";
const clearToken = ()=>{
    if (false) {}
    window.localStorage.removeItem(TOKEN);
};
const setToken = (value, user)=>{
    if (false) {}
    if (user == null || value == null) {
        clearToken();
        return;
    }
    const newToken = Buffer.from("".concat(user.id, ":").concat(value), "utf-8").toString("base64");
    window.localStorage.setItem(TOKEN, newToken);
};
const getMembership = (user, memberships)=>{
    if (false) {}
    const token = window.localStorage.getItem(TOKEN);
    if (!token || !user) {
        return null;
    }
    try {
        const parsed = Buffer.from(token, "base64").toString("utf-8");
        const [tokenUser, id] = parsed.split(":");
        if (!tokenUser || !id) {
            return null;
        }
        if (parseInt(tokenUser, 10) != user.id) {
            return null;
        }
        const currentToken = parseInt(id, 10);
        if (Number.isNaN(currentToken)) {
            return null;
        }
        const findItem = memberships.find((e)=>e.id === currentToken);
        if (!findItem) {
            return null;
        }
        return findItem;
    } catch (_e) {
        return null;
    }
};
const activeMembershipState = (0,lib_recoil_src/* selector */.nZ)({
    key: "next-login-active-membership",
    set: (param, value)=>{
        let { get  } = param;
        const user = get(userState);
        const memberships = get(membershipsState);
        if (value instanceof lib_recoil_src/* DefaultValue */.nY) {
            return;
        }
        if (value == null || user == null) {
            clearToken();
            return;
        }
        const isInMemberships = memberships.find((e)=>{
            return e.id === (value === null || value === void 0 ? void 0 : value.id);
        });
        if (!isInMemberships) {
            clearToken();
            return;
        }
        setToken(value.id, user);
        return;
    },
    get: (param)=>{
        let { get  } = param;
        const user = get(userState);
        const memberships = get(membershipsState);
        if (user == null || "object" === "undefined" || !memberships) {
            return null;
        }
        const membership = getMembership(user, memberships);
        if (!membership) {
            var ref;
            // Select the first membership
            return (ref = memberships.find(Boolean)) !== null && ref !== void 0 ? ref : null;
        }
        return membership;
    }
});
const isMembershipStateSetStore = (0,lib_recoil_src/* selector */.nZ)({
    key: "next-login-is-membership-state-set",
    get: (param)=>{
        let { get  } = param;
        const user = get(userState);
        const memberships = get(membershipsState);
        const activeMembership = get(activeMembershipState);
        if (memberships.length === 1 && activeMembership) {
            return true;
        }
        const membership = getMembership(user, memberships);
        return (membership === null || membership === void 0 ? void 0 : membership.id) === (activeMembership === null || activeMembership === void 0 ? void 0 : activeMembership.id);
    }
});

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-hooks-auth-next-virtual-a089da2ab7/1/packages/hooks-auth-next/src/store/email.ts

const savedEmailState = (0,lib_recoil_src/* atom */.cn)({
    key: "savedEmail",
    default: false
});
const emailState = (0,lib_recoil_src/* atom */.cn)({
    key: "email",
    default: false
});

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-hooks-auth-next-virtual-a089da2ab7/1/packages/hooks-auth-next/src/store/is-auth-loaded.ts

const isAuthLoadedState = (0,lib_recoil_src/* atom */.cn)({
    key: "auth-loaded",
    default: false
});

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-hooks-auth-next-virtual-a089da2ab7/1/packages/hooks-auth-next/src/store/is-authenticated.ts



const isAuthenticatedState = (0,lib_recoil_src/* selector */.nZ)({
    key: "auth-is-authenticated",
    get: (param)=>{
        let { get  } = param;
        const user = get(userState);
        const isLoaded = get(isAuthLoadedState);
        return !!(isLoaded && user != null);
    }
});

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-hooks-auth-next-virtual-a089da2ab7/1/packages/hooks-auth-next/src/store/show-as-guest-option.ts

const showAsGuestOptionState = (0,lib_recoil_src/* atom */.cn)({
    key: "showAsGuestOption",
    default: false
});

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-hooks-auth-next-virtual-a089da2ab7/1/packages/hooks-auth-next/src/store/requesting-switch-account-state.ts

const requestingSwitchAccountState = (0,lib_recoil_src/* atom */.cn)({
    key: "requesting-switch-account-state",
    default: false
});

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-hooks-auth-next-virtual-a089da2ab7/1/packages/hooks-auth-next/src/store/security-code.ts

const securityCodeState = (0,lib_recoil_src/* atom */.cn)({
    key: "securityCode",
    default: null
});

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-hooks-auth-next-virtual-a089da2ab7/1/packages/hooks-auth-next/src/store/index.ts












;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-hooks-auth-next-virtual-a089da2ab7/1/packages/hooks-auth-next/src/store/registration-status.ts

const registrationStatusState = (0,lib_recoil_src/* atom */.cn)({
    key: "registration-status",
    default: {
        acceptedTerms: false,
        registeredEmail: false,
        hasInvite: false,
        isOnboarding: false
    }
});

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-hooks-auth-next-virtual-a089da2ab7/1/packages/hooks-auth-next/src/use-auth.ts










const isValidJSON = (str)=>{
    try {
        JSON.parse(str);
        return true;
    } catch (e) {
        return false;
    }
};
const fakerouter = {
    push: (_value)=>{
    /** Empty on purpose. */ }
};
const useRouter = !(0,types_utils_src/* isJest */.V5)() ? (__webpack_require__(87347).useRouter) : fakerouter;
const useAuth = ()=>{
    const router = useRouter();
    const [requestSwitchAccount, setRequestSwitchAccount] = (0,lib_recoil_src/* useRecoilState */.FV)(requestingSwitchAccountState);
    const [showAsGuestOption, setShowAsGuestOption] = (0,lib_recoil_src/* useRecoilState */.FV)(showAsGuestOptionState);
    const setOpen = (0,lib_recoil_src/* useSetRecoilState */.Zl)(src/* drawerState */.Z$);
    const isAuthenticated = (0,lib_recoil_src/* useRecoilValue */.sJ)(isAuthenticatedState);
    const [isAuthLoaded, setIsAuthLoaded] = (0,lib_recoil_src/* useRecoilState */.FV)(isAuthLoadedState);
    const [user, setUser] = (0,lib_recoil_src/* useRecoilState */.FV)(userState);
    const [loading, setLoading] = (0,lib_recoil_src/* useRecoilState */.FV)(loginLoadingState);
    const [activeMembership, setActiveMembership] = (0,lib_recoil_src/* useRecoilState */.FV)(activeMembershipState);
    const isMembershipStateSet = (0,lib_recoil_src/* useRecoilValue */.sJ)(isMembershipStateSetStore);
    const [savedEmail, setSavedEmail] = (0,lib_recoil_src/* useRecoilState */.FV)(savedEmailState);
    const [securityCode, setSecurityCode] = (0,lib_recoil_src/* useRecoilState */.FV)(securityCodeState);
    const [memberships, setMemberships] = (0,lib_recoil_src/* useRecoilState */.FV)(membershipsState);
    const [emailIsLoading, setEmailIsLoading] = (0,lib_recoil_src/* useRecoilState */.FV)(emailState);
    const [loginError, setError] = (0,lib_recoil_src/* useRecoilState */.FV)(loginErrorState);
    const [registrationStatus, setRegistrationStatus] = (0,lib_recoil_src/* useRecoilState */.FV)(registrationStatusState);
    const token = (0,types_utils_src/* isSSR */.yF)() ? undefined : localStorage.getItem("token");
    const handleSetPrefersAnonymousCheckout = (0,react.useCallback)(()=>{
        sessionStorage.setItem("prefers-anonymous-checkout", "true");
        setShowAsGuestOption(false);
        setOpen(false);
        router.push("/kaupferli");
    }, [
        router,
        setOpen,
        setShowAsGuestOption
    ]);
    const createPolledLogin = (0,react.useCallback)(async (method, auth)=>{
        try {
            const res = await lib_api_rest_src/* restApi.usersPolledLoginCreate */._O.usersPolledLoginCreate({
                method,
                auth
            });
            const verificationCode = res.data.verificationCode || null;
            setSecurityCode(verificationCode);
            if (res.data.complete === true) {
                var ref, ref1;
                const acceptedTerms = ((ref = res.data.login) === null || ref === void 0 ? void 0 : ref.user.verified.termsAccepted) !== null ? true : false;
                const registeredEmail = ((ref1 = res.data.login) === null || ref1 === void 0 ? void 0 : ref1.user.verified.email) !== "" ? true : false;
                setRegistrationStatus({
                    acceptedTerms,
                    registeredEmail,
                    hasInvite: sessionStorage.getItem("invitationToken") === null ? false : true,
                    isOnboarding: !acceptedTerms || !registeredEmail
                });
                setSecurityCode(null);
                if (res.data.login !== null) {
                    setUser(res.data.login.user);
                    setMemberships(res.data.login.user.memberships.filter((item)=>item.active));
                    localStorage.setItem("token", res.data.login.saleor.accessToken);
                    index_client/* setUser */.av({
                        id: res.data.login.user.id.toString()
                    });
                }
                setLoading(false);
            } else if (res.data.complete === false) {
                setTimeout(()=>{
                    createPolledLogin(lib_api_rest_src/* PolledLoginMethodEnum.Poll */.GG.Poll, res.data.authRequest);
                }, 2000);
            }
        } catch (err) {
            var ref2, ref3;
            setLoading(false);
            setSecurityCode(null);
            const error = (ref2 = err.error) === null || ref2 === void 0 ? void 0 : ref2.detail;
            const isValid = error ? isValidJSON(error) : false;
            const parsedError = isValid ? JSON.parse(error) : null;
            const message = (parsedError === null || parsedError === void 0 ? void 0 : (ref3 = parsedError.responseStatus) === null || ref3 === void 0 ? void 0 : ref3.message) || "Eitthva\xf0 f\xf3r \xfarskei\xf0is";
            setError(message);
            index_client/* setUser */.av(null);
        }
    }, [
        setSecurityCode,
        setRegistrationStatus,
        setLoading,
        setUser,
        setMemberships,
        setError
    ]);
    const login = (0,react.useCallback)(async (auth, method)=>{
        setActiveMembership(null);
        setLoading(true);
        lib_api_rest_src/* restApi.setSecurityData */._O.setSecurityData("");
        if (token) {
            localStorage.removeItem("token");
        }
        await createPolledLogin(method, auth);
    }, [
        setActiveMembership,
        setLoading,
        token,
        createPolledLogin
    ]);
    const logout = (0,react.useCallback)(()=>{
        localStorage.removeItem("token");
        localStorage.removeItem("staffToken");
        setUser(null);
        index_client/* setUser */.av(null);
        setMemberships([]);
        setActiveMembership(null);
        lib_api_rest_src/* restApi.setSecurityData */._O.setSecurityData("");
    }, [
        setUser,
        setMemberships,
        setActiveMembership
    ]);
    const fetchUser = (0,react.useCallback)(async ()=>{
        if (!token) {
            logout();
            setIsAuthLoaded(true);
            return;
        }
        try {
            var ref, ref1;
            const res = await lib_api_rest_src/* restApi.usersMeRetrieve */._O.usersMeRetrieve();
            setUser(res.data);
            index_client/* setUser */.av({
                id: res.data.id.toString()
            });
            const acceptedTerms = res.data.verified.termsAccepted !== null ? true : false;
            const registeredEmail = res.data.verified.email !== "" ? true : false;
            setRegistrationStatus({
                acceptedTerms,
                registeredEmail,
                hasInvite: sessionStorage.getItem("invitationToken") === null ? false : true,
                isOnboarding: registrationStatus.isOnboarding
            });
            if (!acceptedTerms || !registeredEmail) {
                setOpen(true);
            }
            if (((ref = res.data) === null || ref === void 0 ? void 0 : (ref1 = ref.memberships) === null || ref1 === void 0 ? void 0 : ref1.length) >= 1) {
                setMemberships(res.data.memberships.filter((item)=>item.active));
            }
        } catch (err) {
            logout();
        }
        setIsAuthLoaded(true);
    }, [
        token,
        setIsAuthLoaded,
        logout,
        setUser,
        setRegistrationStatus,
        registrationStatus.isOnboarding,
        setOpen,
        setMemberships
    ]);
    (0,react.useEffect)(()=>{
        token && lib_api_rest_src/* restApi.setSecurityData */._O.setSecurityData(token);
    }, [
        token
    ]);
    const switchAccount = (0,react.useCallback)(async (id)=>{
        if (!token) {
            logout();
            return;
        }
        setLoading(true);
        lib_api_rest_src/* restApi.setSecurityData */._O.setSecurityData(token);
        try {
            const res = await lib_api_rest_src/* restApi.membershipsSwitchAccountCreate */._O.membershipsSwitchAccountCreate(id);
            if (res !== null) {
                const active = res.data.user.memberships.filter((item)=>item.active);
                const firstActive = active.find(Boolean);
                setMemberships(active);
                setActiveMembership(firstActive !== null && firstActive !== void 0 ? firstActive : null);
                localStorage.setItem("token", res.data.saleor.accessToken);
                setLoading(false);
            }
        } catch (err) {
            console.error(err);
        }
    }, [
        token,
        setLoading,
        logout,
        setMemberships,
        setActiveMembership
    ]);
    const finalizeOnboarding = (0,react.useCallback)(()=>{
        setRegistrationStatus({
            acceptedTerms: true,
            registeredEmail: true,
            hasInvite: registrationStatus.hasInvite,
            isOnboarding: false
        });
    }, [
        registrationStatus.hasInvite,
        setRegistrationStatus
    ]);
    const addEmail = (0,react.useCallback)(async (email, addToPostList)=>{
        try {
            setEmailIsLoading(true);
            const res = await lib_api_rest_src/* restApi.usersSetEmailCreate */._O.usersSetEmailCreate({
                email,
                addToPostList
            });
            setSavedEmail(true);
            setRegistrationStatus({
                acceptedTerms: registrationStatus.acceptedTerms,
                registeredEmail: true,
                hasInvite: registrationStatus.hasInvite,
                isOnboarding: registrationStatus.isOnboarding
            });
            localStorage.setItem("token", res.data.saleor.accessToken);
            setEmailIsLoading(false);
        } catch (err) {
            console.error(err);
        }
    }, [
        registrationStatus.acceptedTerms,
        registrationStatus.hasInvite,
        registrationStatus.isOnboarding,
        setEmailIsLoading,
        setRegistrationStatus,
        setSavedEmail
    ]);
    const acceptTerms = (0,react.useCallback)(async ()=>{
        try {
            const { data  } = await lib_api_rest_src/* restApi.usersAcceptTermsCreate */._O.usersAcceptTermsCreate();
            setRegistrationStatus({
                acceptedTerms: data.verified.termsAccepted !== null ? true : false,
                registeredEmail: savedEmail ? true : data.verified.email !== "" ? true : false,
                hasInvite: sessionStorage.getItem("invitationToken") === null ? false : true,
                isOnboarding: registrationStatus.isOnboarding
            });
            setUser(data);
        } catch (err) {
            console.error(err);
        }
    }, [
        registrationStatus.isOnboarding,
        savedEmail,
        setRegistrationStatus,
        setUser
    ]);
    return {
        login,
        logout,
        switchAccount,
        isAuthenticated,
        isAuthLoaded: isAuthLoaded && (isAuthenticated && activeMembership != null || !isAuthenticated),
        isMembershipStateSet,
        memberships,
        activeMembership,
        setActiveMembership,
        setError,
        loginError,
        fetchUser,
        addEmail,
        acceptTerms,
        emailIsLoading,
        loading,
        user,
        finalizeOnboarding,
        registrationStatus,
        handleSetPrefersAnonymousCheckout,
        showAsGuestOption,
        setShowAsGuestOption,
        requestSwitchAccount,
        setRequestSwitchAccount,
        securityCode
    };
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-hooks-auth-next-virtual-a089da2ab7/1/packages/hooks-auth-next/src/index.ts




/***/ }),

/***/ 93784:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "jD": function() { return /* reexport */ useCart; },
  "Ol": function() { return /* reexport */ useCheckoutExtra; }
});

// UNUSED EXPORTS: cartAdditionNotificaktionsState, cartItemCountState, checkoutDataState, loadingVariantIdCollectionState, setDeferMinicartToggleState, showMinicartState

// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(91987);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-hooks-toasts-virtual-f5251b1d06/1/packages/hooks-toasts/src/index.ts + 5 modules
var src = __webpack_require__(66746);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-lib-api-products-virtual-81752d2989/1/packages/lib-api-products/src/index.ts + 130 modules
var lib_api_products_src = __webpack_require__(68825);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-lib-analytics-virtual-863cade9f6/1/packages/lib-analytics/src/index.ts + 2 modules
var lib_analytics_src = __webpack_require__(57910);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-lib-recoil-virtual-ff20ed22cf/1/packages/lib-recoil/src/index.js
var lib_recoil_src = __webpack_require__(27105);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-hooks-cart-virtual-97c767eaa3/1/packages/hooks-cart/src/store/show-minicart.ts

const showMinicartState = (0,lib_recoil_src/* atom */.cn)({
    key: "show-minicart-state",
    default: false
});
const setDeferMinicartToggleState = (0,lib_recoil_src/* atom */.cn)({
    key: "show-minicart-state-defer-state",
    default: false
});

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-hooks-cart-virtual-97c767eaa3/1/packages/hooks-cart/src/store/checkout-data.ts

const checkoutDataState = (0,lib_recoil_src/* atom */.cn)({
    key: "checkout-data",
    default: null
});

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-hooks-cart-virtual-97c767eaa3/1/packages/hooks-cart/src/store/loading-variant-id.ts

const loadingVariantIdCollectionState = (0,lib_recoil_src/* atom */.cn)({
    key: "loading-variant-id-collection-state",
    default: []
});

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-hooks-cart-virtual-97c767eaa3/1/packages/hooks-cart/src/store/cart-addition-notifications-state.ts

const cartAdditionNotificaktionsState = (0,lib_recoil_src/* atom */.cn)({
    key: "cart-addition-notifications-state",
    default: []
});

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-hooks-cart-virtual-97c767eaa3/1/packages/hooks-cart/src/store/cart-item-count.ts

const cartItemCountState = (0,lib_recoil_src/* atom */.cn)({
    key: "cart-item-count-state",
    default: 0
});

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-hooks-cart-virtual-97c767eaa3/1/packages/hooks-cart/src/store/index.ts






// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-hooks-auth-next-virtual-a089da2ab7/1/packages/hooks-auth-next/src/index.ts + 14 modules
var hooks_auth_next_src = __webpack_require__(68814);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-lib-api-rest-virtual-a514398bdb/1/packages/lib-api-rest/src/index.ts + 4 modules
var lib_api_rest_src = __webpack_require__(97639);
// EXTERNAL MODULE: ../../packages/types-utils/src/index.ts + 3 modules
var types_utils_src = __webpack_require__(71612);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-hooks-cart-virtual-97c767eaa3/1/packages/hooks-cart/src/use-checkout-extra.ts








const useCheckoutExtra = ()=>{
    const { user , isMembershipStateSet  } = (0,hooks_auth_next_src/* useAuth */.aC)();
    const [checkoutData, setCheckoutData] = (0,lib_recoil_src/* useRecoilState */.FV)(checkoutDataState);
    const [cartItemCount, setCartItemCount] = (0,lib_recoil_src/* useRecoilState */.FV)(cartItemCountState);
    const { set: setAnonymousToken  } = (0,lib_api_products_src/* useAnonymousToken */.D$)();
    const setCheckoutItems = (0,lib_recoil_src/* useSetRecoilState */.Zl)(lib_api_products_src/* _checkout */.z$);
    let checkoutId = null;
    if (!(0,types_utils_src/* isSSR */.yF)()) {
        checkoutId = localStorage.getItem("myanonymousCartToken");
    }
    (0,react.useEffect)(()=>{
        const localcheckoutId = localStorage.getItem("myanonymousCartToken");
        if (user === null && localcheckoutId === null) {
            setCheckoutData(null);
            setCheckoutItems(null);
        }
    }, [
        setCheckoutData,
        user,
        setCheckoutItems
    ]);
    const mergeAnonymousCartWithUserCart = (0,react.useCallback)(async (anonymousToken)=>{
        try {
            const result = await lib_api_rest_src/* restApi.checkoutsMergeUpdate */._O.checkoutsMergeUpdate("current", {
                token: anonymousToken
            });
            localStorage.removeItem("myanonymousCartToken");
            setCheckoutData(result.data);
            setCheckoutItems(result.data);
            setCartItemCount(result.data.quantity);
        } catch (error) {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            const status = error.status;
            if (status === 403 || status === 404) {
                localStorage.removeItem("myanonymousCartToken");
            }
            console.error(error);
        }
    }, [
        setCartItemCount,
        setCheckoutData,
        setCheckoutItems
    ]);
    const updateCheckoutData = (0,react.useCallback)(async (options)=>{
        try {
            if (!checkoutData) {
                return;
            }
            if (user && isMembershipStateSet) {
                const result = await lib_api_rest_src/* restApi.checkoutsPartialUpdate */._O.checkoutsPartialUpdate("current", options);
                setCheckoutData(result.data);
                setCheckoutItems(result.data);
                setCartItemCount(result.data.quantity);
            } else {
                if (checkoutId) {
                    const result1 = await lib_api_rest_src/* restApi.checkoutsPartialUpdate */._O.checkoutsPartialUpdate(checkoutId, options);
                    setCheckoutData(result1.data);
                    setCheckoutItems(result1.data);
                    setCartItemCount(result1.data.quantity);
                }
            }
        } catch (error) {
            console.error(error);
        }
    }, [
        checkoutData,
        isMembershipStateSet,
        setCheckoutData,
        user,
        checkoutId,
        setCartItemCount,
        setCheckoutItems
    ]);
    const fetchCheckoutData = (0,react.useCallback)(async ()=>{
        const localcheckoutId = localStorage.getItem("myanonymousCartToken");
        try {
            if (user) {
                if (localcheckoutId) {
                    await mergeAnonymousCartWithUserCart(localcheckoutId);
                } else {
                    const result = await lib_api_rest_src/* restApi.checkoutsRetrieve */._O.checkoutsRetrieve("current");
                    setCheckoutData(result.data);
                    setCheckoutItems(result.data);
                    setCartItemCount(result.data.quantity);
                }
            } else {
                if (localcheckoutId) {
                    var ref, ref1, ref2;
                    const result1 = await lib_api_rest_src/* restApi.checkoutsRetrieve */._O.checkoutsRetrieve(localcheckoutId);
                    setCheckoutData(result1.data);
                    setCheckoutItems(result1.data);
                    setCartItemCount(result1.data.quantity);
                    if (((ref = result1.data) === null || ref === void 0 ? void 0 : ref.quantity) && typeof ((ref1 = result1.data) === null || ref1 === void 0 ? void 0 : ref1.quantity) === "number" && !Number.isNaN((ref2 = result1.data) === null || ref2 === void 0 ? void 0 : ref2.quantity)) {
                        setCartItemCount(result1.data.quantity);
                    }
                } else {
                    const result2 = await lib_api_rest_src/* restApi.checkoutsRetrieve */._O.checkoutsRetrieve("current");
                    setAnonymousToken(result2.data.token);
                }
            }
        } catch (error) {
            console.error(error);
        }
    }, [
        user,
        mergeAnonymousCartWithUserCart,
        setCheckoutData,
        setCheckoutItems,
        setCartItemCount,
        setAnonymousToken
    ]);
    return {
        fetchCheckoutData,
        updateCheckoutData,
        checkoutData,
        cartItemCount
    };
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-hooks-cart-virtual-97c767eaa3/1/packages/hooks-cart/src/use-cart.ts







const useCart = ()=>{
    const { setErrorMessage , setMessagePosition  } = (0,src/* useToasts */.e)();
    const { cartUpdate , clearCart: handleClearCart  } = (0,lib_api_products_src/* useCheckout */.Mg)();
    const cartState = (0,lib_api_products_src/* useCheckoutState */.HX)();
    const isLoading = cartState === "LOADING" || cartState === "INITIAL_LOAD";
    const hasError = cartState === "ERROR";
    const isReady = cartState === "READY";
    const cartItemList = (0,lib_api_products_src/* useCheckoutLines */.HE)();
    const [cartAdditionNotifications, setCartAdditionNotifications] = (0,lib_recoil_src/* useRecoilState */.FV)(cartAdditionNotificaktionsState);
    const [loadingVariantIdCollection, setLoadingVariantIdCollection] = (0,lib_recoil_src/* useRecoilState */.FV)(loadingVariantIdCollectionState);
    const [showMinicart, setShowMinicart] = (0,lib_recoil_src/* useRecoilState */.FV)(showMinicartState);
    const [deferMinicartToggle, setDeferMinicartToggle] = (0,lib_recoil_src/* useRecoilState */.FV)(setDeferMinicartToggleState);
    const totalProducts = (0,lib_api_products_src/* useTotalCartCount */.Dc)();
    const { fetchCheckoutData  } = useCheckoutExtra();
    const handleUpdateCartError = (0,react.useCallback)((updateResults)=>{
        if ((updateResults === null || updateResults === void 0 ? void 0 : updateResults.code) === "INSUFFICIENT_STOCK") {
            setMessagePosition("top-right");
            setErrorMessage(updateResults.message);
        } else if ((updateResults === null || updateResults === void 0 ? void 0 : updateResults.code) === "QUANTITY_GREATER_THAN_LIMIT") {
            setMessagePosition("top-right");
            setErrorMessage(updateResults.message);
        } else if ((updateResults === null || updateResults === void 0 ? void 0 : updateResults.code) === "SHIPPING_ADDRESS_NOT_SET") {
        // Do Nothing, harmless error
        } else if ((updateResults === null || updateResults === void 0 ? void 0 : updateResults.code) === "NOT_FOUND" || (updateResults === null || updateResults === void 0 ? void 0 : updateResults.code) === "UNKNOWN") {
            setMessagePosition("top-right");
            setErrorMessage("Villa kom upp vi\xf0 a\xf0 b\xe6ta v\xf6ru \xed k\xf6rfu");
        }
        if (updateResults === null || updateResults === void 0 ? void 0 : updateResults.code) {
            return true;
        }
        return false;
    }, [
        setErrorMessage,
        setMessagePosition
    ]);
    (0,react.useEffect)(()=>{
        if (showMinicart === false) {
            setDeferMinicartToggle(true);
        }
    }, [
        setDeferMinicartToggle,
        showMinicart
    ]);
    (0,react.useEffect)(()=>{
        const timeout = setTimeout(()=>{
            setDeferMinicartToggle(false);
        }, 300);
        return ()=>{
            clearTimeout(timeout);
        };
    }, [
        deferMinicartToggle,
        setDeferMinicartToggle
    ]);
    const addToLoading = (0,react.useCallback)((variantId)=>{
        setLoadingVariantIdCollection((prev)=>{
            if (prev.includes(variantId)) {
                return prev;
            }
            return [
                ...prev,
                variantId
            ];
        });
    }, [
        setLoadingVariantIdCollection
    ]);
    const removeFromLoading = (0,react.useCallback)((variantId)=>{
        setLoadingVariantIdCollection((prev)=>{
            return prev.filter((id)=>id !== variantId);
        });
    }, [
        setLoadingVariantIdCollection
    ]);
    const toggleShowMinicart = (0,react.useCallback)((open)=>{
        if (typeof open === "boolean") {
            setShowMinicart(open);
        } else {
            setShowMinicart((current)=>{
                if (current === false && deferMinicartToggle === false) {
                    return true;
                } else {
                    return false;
                }
            });
        }
    }, [
        deferMinicartToggle,
        setShowMinicart
    ]);
    const addToCart = (0,lib_api_products_src/* useProductCartVariantHelper */.eq)(async (param)=>{
        let { variantIdGQL , itemCount , variantId  } = param;
        const newCount = itemCount + 1;
        addToLoading(variantId);
        setCartAdditionNotifications((prev)=>{
            if (prev.includes(variantId)) {
                return prev;
            }
            return [
                ...prev,
                variantId
            ];
        });
        setTimeout(()=>{
            setCartAdditionNotifications((prev)=>{
                return prev.filter((id)=>id !== variantId);
            });
        }, 10000);
        const updateResults = await cartUpdate({
            [variantIdGQL]: newCount
        });
        handleUpdateCartError(updateResults);
        await fetchCheckoutData();
        removeFromLoading(variantId);
    }, [
        cartUpdate
    ]);
    const setCartQuantity = (0,lib_api_products_src/* useProductCartVariantHelper */.eq)(async (param)=>{
        let { variantIdGQL , quantity , variantId  } = param;
        addToLoading(variantId);
        setCartAdditionNotifications((prev)=>{
            if (prev.includes(variantId)) {
                return prev;
            }
            return [
                ...prev,
                variantId
            ];
        });
        setTimeout(()=>{
            setCartAdditionNotifications((prev)=>{
                return prev.filter((id)=>id !== variantId);
            });
        }, 10000);
        const updateResults = await cartUpdate({
            [variantIdGQL]: quantity
        });
        handleUpdateCartError(updateResults);
        await fetchCheckoutData();
        removeFromLoading(variantId);
    }, [
        cartUpdate
    ]);
    const removeFromCart = (0,lib_api_products_src/* useProductCartVariantHelper */.eq)(async (param)=>{
        let { variantIdGQL , variantId  } = param;
        const cartItem = cartItemList.find((item)=>item.variant.id === variantId);
        if (cartItem) {
            try {
                lib_analytics_src/* analytics.removeProductFromCart */.c.removeProductFromCart(cartItem);
            } catch (error) {
                console.error(error);
            }
        }
        addToLoading(variantId);
        await cartUpdate({
            [variantIdGQL]: 0
        });
        await fetchCheckoutData();
        removeFromLoading(variantId);
    }, [
        cartUpdate
    ]);
    const clearCart = (0,lib_api_products_src/* useCartHelper */.YL)(()=>{
        handleClearCart();
    }, [
        handleClearCart
    ]);
    return {
        isLoading,
        isReady,
        hasError,
        showMinicart,
        toggleShowMinicart,
        addToCart,
        removeFromCart,
        cartAdditionNotifications,
        loadingVariantIdCollection,
        clearCart,
        totalProducts,
        setCartQuantity,
        cartItemList
    };
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-hooks-cart-virtual-97c767eaa3/1/packages/hooks-cart/src/index.ts





/***/ }),

/***/ 11914:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "j": function() { return /* reexport */ useCompareProducts; }
});

// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(91987);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-lib-recoil-virtual-ff20ed22cf/1/packages/lib-recoil/src/index.js
var src = __webpack_require__(27105);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-lib-api-products-virtual-81752d2989/1/packages/lib-api-products/src/index.ts + 130 modules
var lib_api_products_src = __webpack_require__(68825);
// EXTERNAL MODULE: ../../packages/types-utils/src/index.ts + 3 modules
var types_utils_src = __webpack_require__(71612);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-hooks-compare-products-virtual-cdc2b75dbe/1/packages/hooks-compare-products/src/store/product-props.ts



const COMPARE_PRODUCT_LOCAL_STORAGE_KEY = "comparison-product";
const MAX_PRODUCTS_TO_COMPARE = 4;
const productSlugState = (0,src/* atom */.cn)({
    key: "product-slug-state",
    default: []
});
const productForComparisonState = (0,src/* selectorFamily */.CG)({
    key: "product-for-comparison-state",
    get: (slug)=>async ()=>{
            const value = await (0,lib_api_products_src/* productBySlug */.H1)(slug);
            return value;
        }
});
const productHasBeenInitialzed = (0,src/* atom */.cn)({
    key: "product-has-been-initialized",
    default: false
});
const productsForComparisonState = (0,src/* selector */.nZ)({
    key: "products-for-comparison-state",
    get: async (param)=>{
        let { get  } = param;
        const slugState = get(productSlugState);
        const hasBeenInitialized = get(productHasBeenInitialzed);
        if (hasBeenInitialized && !(0,types_utils_src/* isSSR */.yF)()) {
            if (slugState.length === 0) {
                localStorage.removeItem(COMPARE_PRODUCT_LOCAL_STORAGE_KEY);
                return [];
            }
            const jsonValues = JSON.stringify(slugState);
            localStorage.setItem(COMPARE_PRODUCT_LOCAL_STORAGE_KEY, jsonValues);
        }
        const value = await Promise.all(slugState.map((slug)=>{
            const product = get(productForComparisonState(slug));
            return product;
        }));
        return value.filter(types_utils_src/* isNotNull */.K0);
    }
});

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-hooks-compare-products-virtual-cdc2b75dbe/1/packages/hooks-compare-products/src/store/index.ts


;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-hooks-compare-products-virtual-cdc2b75dbe/1/packages/hooks-compare-products/src/use-compare-products.ts



const useCompareProducts = ()=>{
    const setProductSlug = (0,src/* useSetRecoilState */.Zl)(productSlugState);
    const setHasBeenInitialized = (0,src/* useSetRecoilState */.Zl)(productHasBeenInitialzed);
    const productsForComparison = (0,src/* useRecoilValueLoadable */.$P)(productsForComparisonState);
    const productsRef = (0,react.useRef)([]);
    if (productsForComparison.state === "hasValue") {
        productsRef.current = productsForComparison.contents;
    }
    (0,react.useEffect)(()=>{
        const productSlugLocalStorage = localStorage.getItem(COMPARE_PRODUCT_LOCAL_STORAGE_KEY);
        if (!productSlugLocalStorage) {
            setHasBeenInitialized(true);
            return;
        }
        const productSlugLocalStorageParsed = JSON.parse(productSlugLocalStorage);
        setProductSlug(productSlugLocalStorageParsed);
        setHasBeenInitialized(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const removeProduct = (0,react.useCallback)((slug)=>{
        setProductSlug((value)=>value.filter((product)=>product !== slug));
    }, [
        setProductSlug
    ]);
    const addProduct = (0,react.useCallback)((slug)=>{
        setProductSlug((value)=>[
                ...value,
                slug
            ].slice(0, MAX_PRODUCTS_TO_COMPARE));
    }, [
        setProductSlug
    ]);
    const clearAllProducts = (0,react.useCallback)(()=>{
        localStorage.removeItem(COMPARE_PRODUCT_LOCAL_STORAGE_KEY);
        setProductSlug([]);
    }, [
        setProductSlug
    ]);
    return {
        products: productsRef.current,
        removeProduct,
        addProduct,
        clearAllProducts
    };
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-hooks-compare-products-virtual-cdc2b75dbe/1/packages/hooks-compare-products/src/index.ts



/***/ }),

/***/ 22400:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "E": function() { return /* reexport */ useCustomerAccountMembership; }
});

// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(91987);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-hooks-toasts-virtual-f5251b1d06/1/packages/hooks-toasts/src/index.ts + 5 modules
var src = __webpack_require__(66746);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-lib-api-rest-virtual-a514398bdb/1/packages/lib-api-rest/src/index.ts + 4 modules
var lib_api_rest_src = __webpack_require__(97639);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-lib-recoil-virtual-ff20ed22cf/1/packages/lib-recoil/src/index.js
var lib_recoil_src = __webpack_require__(27105);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-hooks-customer-account-membership-virtual-e9df779240/1/packages/hooks-customer-account-membership/src/store/customer-account-membership-management-state.ts

const customerAccountMembershipManagementState = (0,lib_recoil_src/* atom */.cn)({
    key: "customerAccountMembershipManagementState",
    default: []
});

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-hooks-customer-account-membership-virtual-e9df779240/1/packages/hooks-customer-account-membership/src/store/customer-account-invite-details-state.ts

const customerAccountInviteDetailsState = (0,lib_recoil_src/* atom */.cn)({
    key: "customerAccountInviteDetailsState",
    default: null
});

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-hooks-customer-account-membership-virtual-e9df779240/1/packages/hooks-customer-account-membership/src/store/customer-account-changed-record-state.ts

const customerAccountChangedRecordState = (0,lib_recoil_src/* atom */.cn)({
    key: "customerAccountChangedRecordState",
    default: null
});

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-hooks-customer-account-membership-virtual-e9df779240/1/packages/hooks-customer-account-membership/src/store/invite-details-loading-state.ts

const inviteDetailsLoadingState = (0,lib_recoil_src/* atom */.cn)({
    key: "inviteDetailsLoadingState",
    default: false
});

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-hooks-customer-account-membership-virtual-e9df779240/1/packages/hooks-customer-account-membership/src/store/index.ts





;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-hooks-customer-account-membership-virtual-e9df779240/1/packages/hooks-customer-account-membership/src/use-customer-account-membership.ts





const GENERIC_ERROR_MESSAGE = "Eitthva\xf0 f\xf3r \xfarskei\xf0is";
const convertInvitationToManagementItem = (invitation)=>{
    var _email, _email1, _unvalidatedName;
    return {
        acceptedAt: invitation.acceptedAt,
        id: invitation.id,
        isInvitation: true,
        createdAt: invitation.createdAt,
        role: lib_api_rest_src/* RoleEnum.Contractor */.BH.Contractor,
        active: true,
        canPurchase: !!invitation.canPurchase,
        canViewSalesTransactions: !!invitation.canViewSalesTransactions,
        expanded: false,
        isRepresentative: !!invitation.isRepresentative,
        isUserManager: !!invitation.isUserManager,
        user: {
            id: -1,
            customerAgentId: invitation.createAsAgent ? "interim id" : "",
            avatar: {
                default: "none"
            },
            email: (_email = invitation.email) !== null && _email !== void 0 ? _email : "",
            verified: {
                email: (_email1 = invitation.email) !== null && _email1 !== void 0 ? _email1 : "",
                name: (_unvalidatedName = invitation.unvalidatedName) !== null && _unvalidatedName !== void 0 ? _unvalidatedName : ""
            }
        }
    };
};
const useCustomerAccountMembership = ()=>{
    customerAccountInviteDetailsState;
    const [changedRecords, setChangedRecords] = (0,lib_recoil_src/* useRecoilState */.FV)(customerAccountChangedRecordState);
    const [inviteDetails, setInviteDetails] = (0,lib_recoil_src/* useRecoilState */.FV)(customerAccountInviteDetailsState);
    const [inviteDetailsLoading, setInviteDetailsLoading] = (0,lib_recoil_src/* useRecoilState */.FV)(inviteDetailsLoadingState);
    const { setErrorMessage  } = (0,src/* useToasts */.e)();
    const [customerAccountMembershipManagementList, setCustomerAccountMembershipManagementList] = (0,lib_recoil_src/* useRecoilState */.FV)(customerAccountMembershipManagementState);
    const toggleExpand = (0,react.useCallback)((id, expanded)=>{
        const updatedCollection = customerAccountMembershipManagementList.map((item)=>{
            if (item.id !== id) {
                return item;
            }
            return {
                ...item,
                expanded
            };
        });
        setCustomerAccountMembershipManagementList(updatedCollection);
    }, [
        customerAccountMembershipManagementList,
        setCustomerAccountMembershipManagementList
    ]);
    const [loadingData, setLoadingData] = (0,react.useState)(false);
    const fetchCustomerAccountMembershipManagementList = (0,react.useCallback)(async ()=>{
        setCustomerAccountMembershipManagementList([]);
        setLoadingData(true);
        const { data  } = await lib_api_rest_src/* restApi.membershipManagementList */._O.membershipManagementList();
        const { data: invitations  } = await lib_api_rest_src/* restApi.invitationsList */._O.invitationsList();
        const invitationList = [];
        invitations.forEach((invitation)=>{
            // we want to hide invitations that have already been accepted
            if (invitation.acceptedAt === null) {
                invitationList.push(convertInvitationToManagementItem(invitation));
            }
        });
        setLoadingData(false);
        setCustomerAccountMembershipManagementList([
            ...invitationList,
            ...data
        ]);
    }, [
        setCustomerAccountMembershipManagementList
    ]);
    (0,react.useEffect)(()=>{
        const changeList = {};
        customerAccountMembershipManagementList.forEach((item)=>{
            var _id;
            changeList[item.id] = (_id = changeList[item.id]) !== null && _id !== void 0 ? _id : false;
        });
        setChangedRecords(changeList);
    }, [
        customerAccountMembershipManagementList,
        setChangedRecords
    ]);
    const setHasChanges = (0,react.useCallback)((id, hasChanges)=>{
        setChangedRecords((current)=>{
            return {
                ...current,
                [id]: hasChanges
            };
        });
    }, [
        setChangedRecords
    ]);
    const updateActiveStatus = (0,react.useCallback)(async (id, isActive)=>{
        const { data  } = await lib_api_rest_src/* restApi.membershipManagementPartialUpdate */._O.membershipManagementPartialUpdate(id, {
            active: isActive
        });
        const updatedCollection = customerAccountMembershipManagementList.map((item)=>{
            if (item.id !== id) {
                return item;
            }
            return {
                ...item,
                active: !!data.active
            };
        });
        setCustomerAccountMembershipManagementList(updatedCollection);
    }, [
        customerAccountMembershipManagementList,
        setCustomerAccountMembershipManagementList
    ]);
    const updateCustomerAccountMembershipManagement = (0,react.useCallback)(async (id, payload)=>{
        const { data  } = await lib_api_rest_src/* restApi.membershipManagementPartialUpdate */._O.membershipManagementPartialUpdate(id, payload);
        const updatedCollection = customerAccountMembershipManagementList.map((item)=>{
            if (item.id !== id) {
                return item;
            }
            return {
                ...data,
                expanded: true
            };
        });
        setCustomerAccountMembershipManagementList(updatedCollection);
    }, [
        customerAccountMembershipManagementList,
        setCustomerAccountMembershipManagementList
    ]);
    const sendInvite = (0,react.useCallback)(async (invitation)=>{
        try {
            const { data  } = await lib_api_rest_src/* restApi.invitationsCreate */._O.invitationsCreate(invitation);
            const updatedCollection = [
                convertInvitationToManagementItem(data),
                ...customerAccountMembershipManagementList
            ];
            setCustomerAccountMembershipManagementList(updatedCollection);
            return true;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            if (error.status && error.status === 400 && error.error && error.error.length === 1) {
                setErrorMessage(error.error[0]);
            } else if (error.status && error.status === 409 && error.error && error.error.email) {
                setErrorMessage("\xdea\xf0 er \xfeegar b\xfai\xf0 a\xf0 senda bo\xf0 \xe1 \xfeetta netfang");
            } else {
                setErrorMessage(GENERIC_ERROR_MESSAGE);
            }
            return false;
        }
    }, [
        customerAccountMembershipManagementList,
        setCustomerAccountMembershipManagementList,
        setErrorMessage
    ]);
    const updateInvite = (0,react.useCallback)(async (id, updatedInvitation)=>{
        try {
            const { data  } = await lib_api_rest_src/* restApi.invitationsPartialUpdate */._O.invitationsPartialUpdate(id, updatedInvitation);
            const updatedCollection = customerAccountMembershipManagementList.map((item)=>{
                if (item.id !== id || !item.isInvitation) {
                    return item;
                }
                return {
                    ...convertInvitationToManagementItem(data),
                    expanded: true
                };
            });
            setCustomerAccountMembershipManagementList(updatedCollection);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            if (error.status && error.status === 400 && error.error && error.error.length === 1) {
                setErrorMessage(error.error[0]);
            } else {
                setErrorMessage(GENERIC_ERROR_MESSAGE);
            }
        }
    }, [
        customerAccountMembershipManagementList,
        setCustomerAccountMembershipManagementList,
        setErrorMessage
    ]);
    const revokeInvite = (0,react.useCallback)(async (id)=>{
        try {
            await lib_api_rest_src/* restApi.invitationsDestroy */._O.invitationsDestroy(id);
            const updatedCollection = customerAccountMembershipManagementList.filter((item)=>{
                return item.id !== id || !item.isInvitation;
            });
            setCustomerAccountMembershipManagementList(updatedCollection);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            if (error.status && error.status === 400 && error.error && error.error.length === 1) {
                setErrorMessage(error.error[0]);
            } else {
                setErrorMessage(GENERIC_ERROR_MESSAGE);
            }
        }
    }, [
        customerAccountMembershipManagementList,
        setCustomerAccountMembershipManagementList,
        setErrorMessage
    ]);
    const resendInvite = (0,react.useCallback)(async (id)=>{
        try {
            await lib_api_rest_src/* restApi.invitationsResendCreate */._O.invitationsResendCreate(id);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            if (error.status && error.status === 400 && error.error && error.error.length === 1) {
                setErrorMessage(error.error[0]);
            } else {
                setErrorMessage(GENERIC_ERROR_MESSAGE);
            }
        }
    }, [
        setErrorMessage
    ]);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const acceptInvite = (0,react.useCallback)(async (token)=>{
        const res = await lib_api_rest_src/* restApi.invitationsAcceptCreate */._O.invitationsAcceptCreate({
            token
        }).catch((error)=>{
            if (error.status && error.status === 400 && error.error && error.error.length === 1) {
                setErrorMessage(error.error[0]);
            } else {
                setErrorMessage(GENERIC_ERROR_MESSAGE);
            }
            return error;
        });
        return res === null || res === void 0 ? void 0 : res.data;
    }, [
        setErrorMessage
    ]);
    const fetchInviteDetails = (0,react.useCallback)(async (token)=>{
        setInviteDetailsLoading(true);
        try {
            const { data  } = await lib_api_rest_src/* restApi.accountsInvitationsDetailsRetrieve */._O.accountsInvitationsDetailsRetrieve({
                token
            });
            setInviteDetails(data);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            if (error.status && error.status === 400 && error.error && error.error.length === 1) {
                setErrorMessage(error.error[0]);
            } else if (error.status && error.status !== 404) {
                setErrorMessage(GENERIC_ERROR_MESSAGE);
            }
        }
        setInviteDetailsLoading(false);
    }, [
        setErrorMessage,
        setInviteDetails,
        setInviteDetailsLoading
    ]);
    const setCustomerAgentStatusToTrue = (0,react.useCallback)((id)=>{
        const updatedCollection = customerAccountMembershipManagementList.map((item)=>{
            if (item.id !== id) {
                return item;
            }
            return {
                ...item,
                user: {
                    ...item.user,
                    customerAgentId: "provisional id"
                }
            };
        });
        setCustomerAccountMembershipManagementList(updatedCollection);
    }, [
        customerAccountMembershipManagementList,
        setCustomerAccountMembershipManagementList
    ]);
    return {
        customerAccountMembershipManagementList,
        fetchCustomerAccountMembershipManagementList,
        updateCustomerAccountMembershipManagement,
        changedRecords,
        setHasChanges,
        toggleExpand,
        loadingData,
        sendInvite,
        revokeInvite,
        updateActiveStatus,
        updateInvite,
        resendInvite,
        acceptInvite,
        fetchInviteDetails,
        inviteDetails,
        inviteDetailsLoading,
        setCustomerAgentStatusToTrue
    };
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-hooks-customer-account-membership-virtual-e9df779240/1/packages/hooks-customer-account-membership/src/index.ts



/***/ }),

/***/ 6315:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "d": function() { return /* reexport */ useModal; }
});

// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(91987);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-lib-recoil-virtual-ff20ed22cf/1/packages/lib-recoil/src/index.js
var src = __webpack_require__(27105);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-hooks-modal-virtual-7ecc3a3b97/1/packages/hooks-modal/src/store/modal-props.ts

const modalPropsState = (0,src/* atom */.cn)({
    key: "modal-props",
    default: undefined
});

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-hooks-modal-virtual-7ecc3a3b97/1/packages/hooks-modal/src/store/index.ts


;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-hooks-modal-virtual-7ecc3a3b97/1/packages/hooks-modal/src/use-modal.ts



const useModal = ()=>{
    const [modalProps, setModalProps] = (0,src/* useRecoilState */.FV)(modalPropsState);
    const show = (0,react.useCallback)((config)=>{
        setModalProps(config);
    }, [
        setModalProps
    ]);
    const hide = (0,react.useCallback)(()=>{
        setModalProps(undefined);
    }, [
        setModalProps
    ]);
    return {
        show,
        hide,
        modalProps
    };
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-hooks-modal-virtual-7ecc3a3b97/1/packages/hooks-modal/src/index.ts



/***/ }),

/***/ 88596:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "cc": function() { return /* reexport */ useProductInventory; },
  "Br": function() { return /* reexport */ useProductPricing; },
  "Rk": function() { return /* reexport */ useProductVariants; }
});

// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(91987);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-hooks-product-variants-virtual-3d0a0bb929/1/packages/hooks-product-variants/src/use-product-variants.ts

const clothSizeWeights = {
    "3xs": 0,
    xxxs: 1,
    "2xs": 2,
    xxs: 3,
    xs: 4,
    s: 5,
    m: 6,
    l: 7,
    xl: 8,
    xxl: 9,
    "2xl": 10,
    xxxl: 11,
    "3xl": 12
};
const useProductVariants = (product, activeVariantSKU, setActiveVariantSKU, lowestPriceSku)=>{
    const [activeSizeId, setActiveSizeId] = (0,react.useState)(-1);
    const [activeColorId, setActiveColorId] = (0,react.useState)(-1);
    const [activeSize, setActiveSize] = (0,react.useState)();
    const [activeColor, setActiveColor] = (0,react.useState)();
    const [availableSizes, setAvailableSizes] = (0,react.useState)([]);
    const [availableColors, setAvailableColors] = (0,react.useState)([]);
    (0,react.useEffect)(()=>{
        // this is for debugging purposes, ment to be deployed temporarily
        // FIXME: This still needed?
        product === null || product === void 0 ? void 0 : product.variants.forEach((param)=>{
            let { meta , sku , name  } = param;
            if (meta && (meta === null || meta === void 0 ? void 0 : meta.color) === "" && (meta === null || meta === void 0 ? void 0 : meta.size) === "" && (meta === null || meta === void 0 ? void 0 : meta.style) === "" && (meta === null || meta === void 0 ? void 0 : meta.unit) === "" && product.variants.length > 1) {
                // eslint-disable-next-line no-console
                console.log("Meta data missing for product variant with sku: ", sku, " - ", name);
            }
        });
    }, [
        product,
        product === null || product === void 0 ? void 0 : product.variants
    ]);
    const activeVariant = (0,react.useMemo)(()=>{
        return product === null || product === void 0 ? void 0 : product.variants.find((variant)=>{
            return variant.sku === activeVariantSKU;
        });
    }, [
        activeVariantSKU,
        product === null || product === void 0 ? void 0 : product.variants
    ]);
    const availableSizesForActiveVariant = (0,react.useMemo)(()=>{
        const available = [];
        if (activeColorId !== -1) {
            product === null || product === void 0 ? void 0 : product.variants.forEach((variant)=>{
                if (variant.meta) {
                    var ref;
                    if ((activeColor === null || activeColor === void 0 ? void 0 : activeColor.value) === ((ref = variant.meta) === null || ref === void 0 ? void 0 : ref.color)) {
                        var ref1;
                        if (!available.includes((ref1 = variant.meta) === null || ref1 === void 0 ? void 0 : ref1.size)) {
                            var ref2;
                            available.push((ref2 = variant.meta) === null || ref2 === void 0 ? void 0 : ref2.size);
                        }
                    }
                }
            });
        }
        return available;
    }, [
        activeColor === null || activeColor === void 0 ? void 0 : activeColor.value,
        activeColorId,
        product === null || product === void 0 ? void 0 : product.variants
    ]);
    const availableColorsForActiveVariant = (0,react.useMemo)(()=>{
        const available = [];
        if (activeSizeId !== -1) {
            product === null || product === void 0 ? void 0 : product.variants.forEach((variant)=>{
                if (variant.meta) {
                    var ref;
                    if ((activeSize === null || activeSize === void 0 ? void 0 : activeSize.value) === ((ref = variant.meta) === null || ref === void 0 ? void 0 : ref.size)) {
                        var ref1;
                        if (!available.includes((ref1 = variant.meta) === null || ref1 === void 0 ? void 0 : ref1.color)) {
                            var ref2;
                            available.push((ref2 = variant.meta) === null || ref2 === void 0 ? void 0 : ref2.color);
                        }
                    }
                }
            });
        }
        return available;
    }, [
        activeSize === null || activeSize === void 0 ? void 0 : activeSize.value,
        activeSizeId,
        product === null || product === void 0 ? void 0 : product.variants
    ]);
    (0,react.useEffect)(()=>{
        const values = [];
        product === null || product === void 0 ? void 0 : product.variants.forEach((variant)=>{
            if (variant.meta) {
                var ref;
                const value = (ref = variant.meta) === null || ref === void 0 ? void 0 : ref.size;
                if (value && value.length && !values.includes(value)) {
                    values.push(value);
                }
            }
        });
        if (values.some((value)=>[
                "3xs",
                "xxxs",
                "2xs",
                "xxs",
                "xs",
                "s",
                "m",
                "l",
                "xl",
                "xxl",
                "2xl",
                "xxxl",
                "3xl"
            ].includes(value.toLowerCase()))) {
            setAvailableSizes(values.sort((a, b)=>{
                const aWeight = clothSizeWeights[a.toLowerCase()];
                const bWeight = clothSizeWeights[b.toLowerCase()];
                if (aWeight && bWeight) {
                    return aWeight - bWeight;
                }
                // this will sort unknown sizes at the end of the list
                return 1;
            }));
        } else if (values.every((value)=>!isNaN(parseFloat(value)))) {
            setAvailableSizes(values.sort((a, b)=>parseFloat(a) - parseFloat(b)));
        } else {
            setAvailableSizes(values.sort((a, b)=>a.localeCompare(b)));
        }
    }, [
        product === null || product === void 0 ? void 0 : product.variants
    ]);
    (0,react.useEffect)(()=>{
        const values = [];
        product === null || product === void 0 ? void 0 : product.variants.forEach((variant)=>{
            if (variant.meta) {
                var ref;
                const value = (ref = variant.meta) === null || ref === void 0 ? void 0 : ref.color;
                if (value && value.length && !values.includes(value)) {
                    values.push(value);
                }
            }
        });
        if (values.length > 1) {
            setAvailableColors(values);
        }
    }, [
        product === null || product === void 0 ? void 0 : product.variants
    ]);
    const sizeSelectionList = (0,react.useMemo)(()=>{
        const list = [];
        availableSizes.forEach((item, index)=>{
            list.push({
                id: index,
                value: item,
                label: item,
                active: availableSizesForActiveVariant.length === 0 || availableSizesForActiveVariant.includes(item)
            });
        });
        const topElement = {
            id: -1,
            label: "Veldu st\xe6r\xf0",
            value: "Veldu st\xe6r\xf0"
        };
        return [
            topElement,
            ...list
        ];
    }, [
        availableSizes,
        availableSizesForActiveVariant
    ]);
    const colorSelectionList = (0,react.useMemo)(()=>{
        const list = [];
        availableColors.forEach((item, index)=>{
            list.push({
                id: index,
                value: item,
                label: item,
                active: availableColorsForActiveVariant.length === 0 || availableColorsForActiveVariant.includes(item)
            });
        });
        const topElement = {
            id: -1,
            label: "Veldu lit",
            value: "Veldu lit"
        };
        return [
            topElement,
            ...list
        ];
    }, [
        availableColors,
        availableColorsForActiveVariant
    ]);
    (0,react.useEffect)(()=>{
        const value = sizeSelectionList.find((size)=>{
            return size.id === activeSizeId;
        });
        setActiveSize(value);
    }, [
        activeSizeId,
        sizeSelectionList
    ]);
    (0,react.useEffect)(()=>{
        const value = colorSelectionList.find((color)=>{
            return color.id === activeColorId;
        });
        setActiveColor(value);
    }, [
        activeColorId,
        colorSelectionList
    ]);
    (0,react.useEffect)(()=>{
        if (availableColors.length && availableSizes.length) {
            if (activeColorId >= 0 && activeSizeId >= 0) {
                const updatedVariantSelection = product === null || product === void 0 ? void 0 : product.variants.find((variant)=>{
                    var ref, ref1;
                    return ((ref = variant.meta) === null || ref === void 0 ? void 0 : ref.color) === (activeColor === null || activeColor === void 0 ? void 0 : activeColor.value) && ((ref1 = variant.meta) === null || ref1 === void 0 ? void 0 : ref1.size) === (activeSize === null || activeSize === void 0 ? void 0 : activeSize.value);
                });
                if (updatedVariantSelection && updatedVariantSelection.sku) {
                    setActiveVariantSKU(lowestPriceSku !== null && lowestPriceSku !== void 0 ? lowestPriceSku : updatedVariantSelection.sku);
                }
            }
        } else if (availableColors.length) {
            if (activeColorId >= 0) {
                const updatedVariantSelection1 = product === null || product === void 0 ? void 0 : product.variants.find((variant)=>{
                    var ref;
                    return ((ref = variant.meta) === null || ref === void 0 ? void 0 : ref.color) === (activeColor === null || activeColor === void 0 ? void 0 : activeColor.value);
                });
                if (updatedVariantSelection1 && updatedVariantSelection1.sku) {
                    setActiveVariantSKU(lowestPriceSku !== null && lowestPriceSku !== void 0 ? lowestPriceSku : updatedVariantSelection1.sku);
                }
            }
        } else if (availableSizes.length) {
            if (activeSizeId >= 0) {
                const updatedVariantSelection2 = product === null || product === void 0 ? void 0 : product.variants.find((variant)=>{
                    var ref;
                    return ((ref = variant.meta) === null || ref === void 0 ? void 0 : ref.size) === (activeSize === null || activeSize === void 0 ? void 0 : activeSize.value);
                });
                if (updatedVariantSelection2 && updatedVariantSelection2.sku) {
                    setActiveVariantSKU(lowestPriceSku !== null && lowestPriceSku !== void 0 ? lowestPriceSku : updatedVariantSelection2.sku);
                }
            }
        }
    }, [
        activeColor,
        activeColorId,
        activeSize,
        activeSizeId,
        availableColors.length,
        availableSizes.length,
        lowestPriceSku,
        product === null || product === void 0 ? void 0 : product.variants,
        setActiveVariantSKU
    ]);
    const handleSizeChange = (0,react.useCallback)((value)=>{
        if (!(value === null || value === void 0 ? void 0 : value.selectedItem) || value.selectedItem.id === -1) {
            setActiveSizeId(-1);
            return;
        }
        var _id;
        setActiveSizeId((_id = value.selectedItem.id) !== null && _id !== void 0 ? _id : 0);
    }, []);
    const handleColorChange = (0,react.useCallback)((value)=>{
        if (!(value === null || value === void 0 ? void 0 : value.selectedItem) || value.selectedItem.id === -1) {
            setActiveColorId(-1);
            return;
        }
        var _id;
        setActiveColorId((_id = value.selectedItem.id) !== null && _id !== void 0 ? _id : 0);
    }, [
        setActiveColorId
    ]);
    const errorMessage = (0,react.useMemo)(()=>{
        if ((activeColor === null || activeColor === void 0 ? void 0 : activeColor.active) === false || (activeSize === null || activeSize === void 0 ? void 0 : activeSize.active) === false) {
            return "\xdeessi st\xe6r\xf0 er ekki \xed bo\xf0i fyrir \xfeennan lit, vinsamlegast uppf\xe6r\xf0u vali\xf0.";
        }
        return null;
    }, [
        activeColor === null || activeColor === void 0 ? void 0 : activeColor.active,
        activeSize === null || activeSize === void 0 ? void 0 : activeSize.active
    ]);
    const permitPurchase = (0,react.useMemo)(()=>{
        if (availableColors.length > 1 && activeColorId === -1) {
            return false;
        }
        if (availableSizes.length > 1 && activeSizeId === -1) {
            return false;
        }
        if (errorMessage) {
            return false;
        }
        return true;
    }, [
        activeColorId,
        activeSizeId,
        availableColors.length,
        availableSizes.length,
        errorMessage
    ]);
    (0,react.useEffect)(()=>{
        // find and set selection values for first available (in stock) variant:
        if (activeColorId === -1 && activeSizeId === -1) {
            var ref;
            const validVariant = product === null || product === void 0 ? void 0 : product.variants.find((variant)=>{
                return variant.webstoreInStock;
            });
            var ref1;
            const meta = (ref1 = validVariant === null || validVariant === void 0 ? void 0 : validVariant.meta) !== null && ref1 !== void 0 ? ref1 : (ref = product === null || product === void 0 ? void 0 : product.variants[0]) === null || ref === void 0 ? void 0 : ref.meta;
            if (meta) {
                const sizeSelectionItem = sizeSelectionList.find((item)=>{
                    return item.value === (meta === null || meta === void 0 ? void 0 : meta.size);
                });
                const colorSelectionItem = colorSelectionList.find((item)=>{
                    return item.value === (meta === null || meta === void 0 ? void 0 : meta.color);
                });
                if (meta === null || meta === void 0 ? void 0 : meta.color.length) {
                    handleColorChange({
                        selectedItem: colorSelectionItem !== null && colorSelectionItem !== void 0 ? colorSelectionItem : null
                    });
                }
                if (meta === null || meta === void 0 ? void 0 : meta.size.length) {
                    handleSizeChange({
                        selectedItem: sizeSelectionItem !== null && sizeSelectionItem !== void 0 ? sizeSelectionItem : null
                    });
                }
            }
        }
    }, [
        activeColorId,
        activeSizeId,
        colorSelectionList,
        handleColorChange,
        handleSizeChange,
        product === null || product === void 0 ? void 0 : product.variants,
        sizeSelectionList
    ]);
    return {
        activeVariant,
        sizeSelectionList,
        colorSelectionList,
        activeSize,
        activeColor,
        handleSizeChange,
        handleColorChange,
        permitPurchase,
        errorMessage
    };
};

// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-hooks-auth-next-virtual-a089da2ab7/1/packages/hooks-auth-next/src/index.ts + 14 modules
var src = __webpack_require__(68814);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-lib-api-price-virtual-284954a275/1/packages/lib-api-price/src/index.ts + 2 modules
var lib_api_price_src = __webpack_require__(62681);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-hooks-product-variants-virtual-3d0a0bb929/1/packages/hooks-product-variants/src/use-product-pricing.ts



const useProductPricing = (product, prices, activeVariantSKU)=>{
    var ref;
    const price = prices === null || prices === void 0 ? void 0 : prices[activeVariantSKU];
    var ref1;
    const isSqmProduct = (ref1 = prices === null || prices === void 0 ? void 0 : (ref = prices[activeVariantSKU]) === null || ref === void 0 ? void 0 : ref.isSqmProduct) !== null && ref1 !== void 0 ? ref1 : false;
    const { user  } = (0,src/* useAuth */.aC)();
    const lowestPrices = (0,react.useMemo)(()=>{
        const discountedList = [];
        const retailList = [];
        product.variants.forEach((param)=>{
            let { sku  } = param;
            if (sku) {
                var ref;
                const variantPrice = prices === null || prices === void 0 ? void 0 : prices[sku];
                const discount = variantPrice === null || variantPrice === void 0 ? void 0 : (ref = variantPrice.discounted) === null || ref === void 0 ? void 0 : ref.gross;
                const retail = variantPrice === null || variantPrice === void 0 ? void 0 : variantPrice.price.gross;
                // we have both discount and retail price for this variant
                if (discount && retail) {
                    discountedList.push({
                        discount,
                        retail
                    });
                }
                // we have retail price for this variant, stored seperately
                if (retail) {
                    retailList.push(retail);
                }
            }
        });
        // we sort any discount prices
        const sortedDiscount = discountedList.sort((a, b)=>{
            if (a.discount < b.discount) {
                return -1;
            }
            if (a.discount > b.discount) {
                return 1;
            }
            return 0;
        });
        // we stort any retail prices
        const sortedRetail = retailList.sort((a, b)=>a - b);
        // we have variying discount prices
        if (sortedDiscount.length && sortedDiscount[0] !== sortedDiscount[sortedDiscount.length - 1]) {
            var ref, ref1, ref2, ref3;
            var ref4, ref5, ref6, ref7;
            // we return the discounted price with the accompanying retail price
            return {
                discount: (ref5 = (ref1 = (0,lib_api_price_src/* getPrice */.aS)((ref4 = (ref = sortedDiscount[0]) === null || ref === void 0 ? void 0 : ref.discount) !== null && ref4 !== void 0 ? ref4 : 0)) === null || ref1 === void 0 ? void 0 : ref1.humanReadable) !== null && ref5 !== void 0 ? ref5 : "",
                retail: (ref7 = (ref3 = (0,lib_api_price_src/* getPrice */.aS)((ref6 = (ref2 = sortedDiscount[0]) === null || ref2 === void 0 ? void 0 : ref2.retail) !== null && ref6 !== void 0 ? ref6 : 0)) === null || ref3 === void 0 ? void 0 : ref3.humanReadable) !== null && ref7 !== void 0 ? ref7 : ""
            };
        }
        // we have variying retail prices
        if (sortedRetail.length && sortedRetail[0] !== sortedRetail[sortedRetail.length - 1]) {
            var ref8;
            var ref9, ref10;
            return {
                discount: null,
                retail: (ref10 = (ref8 = (0,lib_api_price_src/* getPrice */.aS)((ref9 = sortedRetail[0]) !== null && ref9 !== void 0 ? ref9 : 0)) === null || ref8 === void 0 ? void 0 : ref8.humanReadable) !== null && ref10 !== void 0 ? ref10 : ""
            };
        }
        return {
            discount: null,
            retail: null
        };
    }, [
        prices,
        product.variants
    ]);
    const retailPrice = (0,react.useMemo)(()=>{
        if (price === null || price === void 0 ? void 0 : price.price) {
            var ref;
            var _gross, ref1;
            return (ref1 = (ref = (0,lib_api_price_src/* getPrice */.aS)((_gross = price.price.gross) !== null && _gross !== void 0 ? _gross : 0)) === null || ref === void 0 ? void 0 : ref.humanReadable) !== null && ref1 !== void 0 ? ref1 : "";
        }
        return null;
    }, [
        price === null || price === void 0 ? void 0 : price.price
    ]);
    const discountedPrice = (0,react.useMemo)(()=>{
        if (price === null || price === void 0 ? void 0 : price.discounted) {
            var ref;
            var _gross, ref1;
            return (ref1 = (ref = (0,lib_api_price_src/* getPrice */.aS)((_gross = price.discounted.gross) !== null && _gross !== void 0 ? _gross : 0)) === null || ref === void 0 ? void 0 : ref.humanReadable) !== null && ref1 !== void 0 ? ref1 : "";
        }
        return null;
    }, [
        price === null || price === void 0 ? void 0 : price.discounted
    ]);
    const mainPrice = (0,react.useMemo)(()=>{
        var ref;
        var _gross;
        const firstPrice = (_gross = (ref = product.variants[0]) === null || ref === void 0 ? void 0 : ref.price.gross) !== null && _gross !== void 0 ? _gross : 0;
        const usePriceFromLabel = product.variants.some((variant)=>{
            var ref;
            if (firstPrice !== ((ref = variant.price) === null || ref === void 0 ? void 0 : ref.gross)) {
                return true;
            }
            return false;
        });
        const label = usePriceFromLabel ? "VER\xd0 FR\xc1" : user ? "MITT VER\xd0" : "VER\xd0";
        let localPrice;
        const activeVariantPrice = prices === null || prices === void 0 ? void 0 : prices[activeVariantSKU];
        if (activeVariantPrice === null || activeVariantPrice === void 0 ? void 0 : activeVariantPrice.isSqmProduct) {
            var ref1;
            if ((ref1 = activeVariantPrice.discounted) === null || ref1 === void 0 ? void 0 : ref1.perSqm) {
                var ref2;
                var ref3;
                localPrice = (ref3 = (ref2 = (0,lib_api_price_src/* getPrice */.aS)(activeVariantPrice.discounted.perSqm)) === null || ref2 === void 0 ? void 0 : ref2.humanReadable) !== null && ref3 !== void 0 ? ref3 : "";
            } else {
                var ref4;
                var _perSqm, ref5;
                localPrice = (ref5 = (ref4 = (0,lib_api_price_src/* getPrice */.aS)((_perSqm = activeVariantPrice.price.perSqm) !== null && _perSqm !== void 0 ? _perSqm : null)) === null || ref4 === void 0 ? void 0 : ref4.humanReadable) !== null && ref5 !== void 0 ? ref5 : "";
            }
        } else if ((lowestPrices === null || lowestPrices === void 0 ? void 0 : lowestPrices.discount) && (lowestPrices === null || lowestPrices === void 0 ? void 0 : lowestPrices.retail)) {
            // Display lowest discount price out of all variants
            localPrice = lowestPrices.discount;
        } else if (!(lowestPrices === null || lowestPrices === void 0 ? void 0 : lowestPrices.discount) && (lowestPrices === null || lowestPrices === void 0 ? void 0 : lowestPrices.retail)) {
            // Display lowest retail price out of all variants
            localPrice = lowestPrices.retail;
        } else if (!(lowestPrices === null || lowestPrices === void 0 ? void 0 : lowestPrices.discount) && !(lowestPrices === null || lowestPrices === void 0 ? void 0 : lowestPrices.retail) && discountedPrice) {
            // Display standard discount price, same price applies to all variants
            localPrice = discountedPrice;
        } else if (!(lowestPrices === null || lowestPrices === void 0 ? void 0 : lowestPrices.discount) && !(lowestPrices === null || lowestPrices === void 0 ? void 0 : lowestPrices.retail) && !discountedPrice && retailPrice) {
            // Display standard retail price, same price applies to all variants
            localPrice = retailPrice;
        } else {
            // this should never happen except when loading
            return null;
        }
        return {
            label,
            price: localPrice
        };
    }, [
        activeVariantSKU,
        discountedPrice,
        lowestPrices.discount,
        lowestPrices.retail,
        prices,
        product.variants,
        retailPrice,
        user
    ]);
    const previousPrice = (0,react.useMemo)(()=>{
        var ref;
        const label = "VER\xd0 \xc1\xd0UR";
        let localPrice;
        const activeVariantPrice = prices === null || prices === void 0 ? void 0 : prices[activeVariantSKU];
        if ((activeVariantPrice === null || activeVariantPrice === void 0 ? void 0 : activeVariantPrice.isSqmProduct) && ((ref = activeVariantPrice.discounted) === null || ref === void 0 ? void 0 : ref.perSqm)) {
            var ref1;
            var _perSqm, ref2;
            localPrice = (ref2 = (ref1 = (0,lib_api_price_src/* getPrice */.aS)((_perSqm = activeVariantPrice.price.perSqm) !== null && _perSqm !== void 0 ? _perSqm : null)) === null || ref1 === void 0 ? void 0 : ref1.humanReadable) !== null && ref2 !== void 0 ? ref2 : "";
        } else if ((lowestPrices === null || lowestPrices === void 0 ? void 0 : lowestPrices.discount) && lowestPrices.retail) {
            localPrice = lowestPrices.retail;
        } else if (!(lowestPrices === null || lowestPrices === void 0 ? void 0 : lowestPrices.discount) && !(lowestPrices === null || lowestPrices === void 0 ? void 0 : lowestPrices.retail) && discountedPrice && retailPrice) {
            localPrice = retailPrice;
        } else {
            // this should never happen except when loading
            return null;
        }
        return {
            label,
            price: localPrice
        };
    }, [
        activeVariantSKU,
        discountedPrice,
        lowestPrices === null || lowestPrices === void 0 ? void 0 : lowestPrices.discount,
        lowestPrices.retail,
        prices,
        retailPrice
    ]);
    const loadingPrices = (0,react.useMemo)(()=>{
        return previousPrice === null && mainPrice === null;
    }, [
        mainPrice,
        previousPrice
    ]);
    return {
        loadingPrices,
        mainPrice,
        previousPrice,
        isSqmProduct
    };
};

// EXTERNAL MODULE: ../../.yarn/__virtual__/react-query-virtual-9ac5b1aaa1/0/cache/react-query-npm-3.39.1-7899b170b9-9273b7c2ad.zip/node_modules/react-query/es/index.js
var es = __webpack_require__(85166);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-lib-api-rest-virtual-a514398bdb/1/packages/lib-api-rest/src/index.ts + 4 modules
var lib_api_rest_src = __webpack_require__(97639);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-hooks-product-variants-virtual-3d0a0bb929/1/packages/hooks-product-variants/src/use-product-inventory.ts



const useProductInventory = (param)=>{
    let { productSlug , activeVariantSKU , warehouses  } = param;
    var ref;
    const inventoryQuery = (0,es.useQuery)([
        "product-inventory",
        productSlug
    ], ()=>lib_api_rest_src/* restApi.productsInventoryRetrieve */._O.productsInventoryRetrieve(productSlug), {
        enabled: !!productSlug,
        refetchOnWindowFocus: false
    });
    const inventory = (ref = inventoryQuery.data) === null || ref === void 0 ? void 0 : ref.data;
    const availability = (0,react.useMemo)(()=>{
        const availabilityStatus = {
            soldOutInWebstore: true,
            available: [],
            lowStock: [],
            outOfStock: []
        };
        const status = inventory === null || inventory === void 0 ? void 0 : inventory.variants.find((variant)=>{
            return variant.sku === activeVariantSKU;
        }, []);
        const WAREHOUSE_SLUGS = [
            "LAG390",
            "LAG330",
            "LAG339",
            "LAG305",
            "LAG380"
        ];
        let availableInWarehouses = false;
        if (status && status.inventoryStatus) {
            warehouses.forEach((warehouse)=>{
                if (status.inventoryStatus[warehouse.slug]) {
                    if (status.inventoryStatus[warehouse.slug] === "sold_out") {
                        if (!WAREHOUSE_SLUGS.includes(warehouse.slug)) {
                            availabilityStatus.outOfStock.push({
                                slug: warehouse.slug,
                                name: warehouse.name
                            });
                        }
                    } else if (status.inventoryStatus[warehouse.slug] === "low") {
                        if (WAREHOUSE_SLUGS.includes(warehouse.slug)) {
                            availableInWarehouses = true;
                        } else {
                            availabilityStatus.lowStock.push({
                                slug: warehouse.slug,
                                name: warehouse.name
                            });
                        }
                    } else {
                        if (WAREHOUSE_SLUGS.includes(warehouse.slug)) {
                            availableInWarehouses = true;
                        } else {
                            availabilityStatus.available.push({
                                slug: warehouse.slug,
                                name: warehouse.name
                            });
                        }
                    }
                }
            }, []);
        }
        let soldOutInWebstore = true;
        if (status === null || status === void 0 ? void 0 : status.webstoreInStock) {
            soldOutInWebstore = false;
        }
        if (availableInWarehouses) {
            availabilityStatus.available.push({
                slug: "VORUHUS",
                name: "V\xf6ruh\xfas"
            });
        } else {
            availabilityStatus.outOfStock.push({
                slug: "VORUHUS",
                name: "V\xf6ruh\xfas"
            });
        }
        return {
            ...availabilityStatus,
            soldOutInWebstore
        };
    }, [
        inventory,
        activeVariantSKU,
        warehouses
    ]);
    return {
        inventory,
        availability
    };
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-hooks-product-variants-virtual-3d0a0bb929/1/packages/hooks-product-variants/src/index.ts





/***/ }),

/***/ 66746:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "e": function() { return /* reexport */ useToasts; }
});

// UNUSED EXPORTS: errorMessageState

// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-lib-recoil-virtual-ff20ed22cf/1/packages/lib-recoil/src/index.js
var src = __webpack_require__(27105);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-hooks-toasts-virtual-f5251b1d06/1/packages/hooks-toasts/src/store/error-message.ts

const errorMessageState = (0,src/* atom */.cn)({
    key: "error-message",
    default: ""
});

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-hooks-toasts-virtual-f5251b1d06/1/packages/hooks-toasts/src/store/success-message.ts

const successMessageState = (0,src/* atom */.cn)({
    key: "success-message",
    default: ""
});

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-hooks-toasts-virtual-f5251b1d06/1/packages/hooks-toasts/src/store/message-position.ts

const messagePositionState = (0,src/* atom */.cn)({
    key: "toast-message-position",
    default: "bottom-left"
});

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-hooks-toasts-virtual-f5251b1d06/1/packages/hooks-toasts/src/store/index.ts




;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-hooks-toasts-virtual-f5251b1d06/1/packages/hooks-toasts/src/use-toasts.ts


const useToasts = ()=>{
    const [errorMessage, setErrorMessage] = (0,src/* useRecoilState */.FV)(errorMessageState);
    const [successMessage, setSuccessMessage] = (0,src/* useRecoilState */.FV)(successMessageState);
    const [messagePosition, setMessagePosition] = (0,src/* useRecoilState */.FV)(messagePositionState);
    return {
        errorMessage,
        setErrorMessage,
        successMessage,
        setSuccessMessage,
        messagePosition,
        setMessagePosition
    };
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-hooks-toasts-virtual-f5251b1d06/1/packages/hooks-toasts/src/index.ts




/***/ }),

/***/ 5283:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "_E": function() { return /* reexport */ AlgoliaInsightProvider; },
  "HX": function() { return /* reexport */ useAlgoliaInsights; },
  "zC": function() { return /* reexport */ useAlgoliaProductQuery; }
});

// UNUSED EXPORTS: API_KEY, APP_ID, AlgoliaInsightContext, algoliaContentQueryFetcher, algoliaProductsQueryFetcher, compileActiveFilters, compileAlgoliaProductFilters, compileFacets, contentSearchClient, fetchAlgoliaContent, fetchAlgoliaProducts, productSearchClient, productSortOptionsMap, searchClient, sortFacetOptions, storage, useAlgoliaContentQuery

// EXTERNAL MODULE: ../../.yarn/__virtual__/algoliasearch-helper-virtual-5e408b75ac/0/cache/algoliasearch-helper-npm-3.11.1-1cc35e5b35-207616ca45.zip/node_modules/algoliasearch-helper/index.js
var algoliasearch_helper = __webpack_require__(66667);
var algoliasearch_helper_default = /*#__PURE__*/__webpack_require__.n(algoliasearch_helper);
// EXTERNAL MODULE: ../../.yarn/cache/algoliasearch-npm-4.14.3-6f18dd148d-bcb8ccc3e1.zip/node_modules/algoliasearch/dist/algoliasearch-lite.umd.js
var algoliasearch_lite_umd = __webpack_require__(29775);
var algoliasearch_lite_umd_default = /*#__PURE__*/__webpack_require__.n(algoliasearch_lite_umd);
// EXTERNAL MODULE: ../../.yarn/cache/date-fns-npm-2.28.0-c19c5add1b-a0516b2e4f.zip/node_modules/date-fns/esm/addSeconds/index.js
var addSeconds = __webpack_require__(48826);
// EXTERNAL MODULE: ../../.yarn/cache/lodash-npm-4.17.21-6382451519-eb835a2e51.zip/node_modules/lodash/lodash.js
var lodash = __webpack_require__(35735);
// EXTERNAL MODULE: ../../.yarn/__virtual__/react-query-virtual-9ac5b1aaa1/0/cache/react-query-npm-3.39.1-7899b170b9-9273b7c2ad.zip/node_modules/react-query/es/index.js
var es = __webpack_require__(85166);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-lib-utils-virtual-08ae943915/1/packages/lib-utils/src/index.ts + 19 modules
var src = __webpack_require__(65582);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-algolia-virtual-7767b18cc0/1/packages/lib-algolia/src/conf.ts


const envPrefix = (0,src/* getBykoConfig */.Hp)("ALGOLIA_ENV_PREFIX");
const APP_ID = (0,src/* getBykoConfig */.Hp)("ALGOLIA_APP_ID");
const API_KEY = (0,src/* getBykoConfig */.Hp)("ALGOLIA_API_KEY");
const PRODUCT_DEFAULT_SORTING = "new";
const PRODUCT_SORT_OPTIONS = [
    {
        value: "",
        label: "Ra\xf0a eftir"
    },
    {
        value: "popular",
        label: "Vins\xe6lt"
    },
    {
        value: "new",
        label: "N\xfdjast efst"
    },
    {
        value: "price_desc",
        label: "D\xfdrast efst"
    },
    {
        value: "price_asc",
        label: "\xd3d\xfdrast efst"
    },
    {
        value: "sku",
        label: "V\xf6run\xfamer"
    }
];
const PRODUCT_SORT_OPTIONS_MAP = (0,lodash.fromPairs)(PRODUCT_SORT_OPTIONS.map((o)=>[
        o.value,
        o
    ]));
const conf_DEFAULT_PAGE_SIZE = 24;
const conf_SEARCH_INDEXES = {
    products: "".concat(envPrefix, "_products"),
    content: "".concat(envPrefix, "_content"),
    employees: "".concat(envPrefix, "_employees")
};
const conf_PRICE_PATH = "variants.price.gross";
const conf_RANGE_FACETS = [
    conf_PRICE_PATH
];
const FACET_NAME_OVERRIDES = {
    categories: "V\xf6ruflokkar",
    "attributes.brand": "V\xf6rumerki",
    "attributes.type": "Tegund",
    "attributes.typeParent": "Yfirtegund",
    "attributes.environmentalInfo": "Umhverfisuppl\xfdsingar",
    [conf_PRICE_PATH]: "Ver\xf0bil"
};
const conf_FACET_UNIT_OVERRIDES = {
    [conf_PRICE_PATH]: "kr."
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-algolia-virtual-7767b18cc0/1/packages/lib-algolia/src/api.ts
/* eslint-disable
  react/jsx-sort-props,
  react-perf/jsx-no-new-function-as-prop,
  react-perf/jsx-no-new-array-as-prop,
  react/jsx-no-bind,
  no-empty,
  @typescript-eslint/ban-ts-comment */ 






const searchClient = algoliasearch_lite_umd_default()(APP_ID, API_KEY);
const productSearchClient = algoliasearch_helper_default()(searchClient, conf_SEARCH_INDEXES.products);
const contentSearchClient = algoliasearch_helper_default()(searchClient, conf_SEARCH_INDEXES.content);
const productSortOptionsMap = (0,lodash.fromPairs)(PRODUCT_SORT_OPTIONS.map((o)=>[
        o.value,
        o
    ]));
// TODO: Create simple polymorghic localStorage/memory cache in utils
const storage = typeof sessionStorage == "undefined" ? {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    obj: {},
    get (key) {
        var _key;
        return (_key = this.obj[key]) !== null && _key !== void 0 ? _key : null;
    },
    set (key, data) {
        this.obj[key] = data;
    }
} : {
    get: (key)=>{
        try {
            var ref;
            return JSON.parse((ref = window.sessionStorage.getItem(key)) !== null && ref !== void 0 ? ref : "");
        } catch (e) {
            return null;
        }
    },
    set: (key, data)=>{
        sessionStorage.setItem(key, JSON.stringify(data));
    }
};
async function getAvailableFacetKeys(indexName) {
    var ref;
    let availableFacets = storage.get("availableFacets");
    const now = new Date();
    if (!(availableFacets === null || availableFacets === void 0 ? void 0 : (ref = availableFacets.keys) === null || ref === void 0 ? void 0 : ref.length) || now > new Date(availableFacets === null || availableFacets === void 0 ? void 0 : availableFacets.exp)) {
        var ref1;
        const { results  } = await searchClient.search([
            {
                indexName,
                params: {
                    hitsPerPage: 1,
                    analytics: false,
                    analyticsTags: [],
                    facets: [
                        conf_PRICE_PATH,
                        "categories",
                        "attributes.*",
                        "specs.*"
                    ],
                    clickAnalytics: true
                }
            }
        ]);
        const facets = results === null || results === void 0 ? void 0 : (ref1 = results[0]) === null || ref1 === void 0 ? void 0 : ref1.facets;
        availableFacets = {
            keys: facets && Object.keys(facets),
            exp: (0,addSeconds/* default */.Z)(now, 60)
        };
        storage.set("availableFacets", availableFacets);
    }
    return availableFacets.keys;
}
async function fetchAlgoliaProducts(param) {
    let { productIds , categoryId , sortBy , query , page =1 , pageSize =conf_DEFAULT_PAGE_SIZE , filters  } = param;
    const indexName = "".concat(conf_SEARCH_INDEXES.products, "_").concat(sortBy || "popular");
    const strFilters = [];
    if (categoryId) {
        strFilters.push("categories:".concat(categoryId));
    }
    if (productIds && productIds.length > 0) {
        strFilters.push("objectID:".concat(productIds.join(" OR objectID:")));
    }
    var ref;
    // Do the actual search:
    const params = {
        query,
        index: indexName,
        disjunctiveFacets: (ref = await getAvailableFacetKeys(indexName)) !== null && ref !== void 0 ? ref : [],
        ...filters,
        filters: strFilters.join(" AND "),
        hitsPerPage: pageSize,
        page: page - 1,
        clickAnalytics: true
    };
    const res = await productSearchClient.searchOnce(params);
    const result = {
        ...res.content
    };
    // @ts-ignore
    delete result._state;
    // @ts-ignore
    delete result._rawResults;
    return result;
}
function algoliaProductsQueryFetcher(context) {
    return fetchAlgoliaProducts(context.queryKey[2]);
}
function useAlgoliaProductQuery(props, initialData) {
    var ref;
    var ref1;
    return (0,es.useQuery)([
        "algolia",
        conf_SEARCH_INDEXES.products,
        props
    ], algoliaProductsQueryFetcher, {
        initialData,
        keepPreviousData: true,
        refetchOnWindowFocus: false,
        enabled: ((ref1 = (ref = props.productIds) === null || ref === void 0 ? void 0 : ref.length) !== null && ref1 !== void 0 ? ref1 : 0) > 0 || props.categoryId !== undefined || props.query !== undefined
    });
}
async function fetchAlgoliaContent(param) {
    let { //
    query , page =1 , pageSize =DEFAULT_PAGE_SIZE  } = param;
    const params = {
        query,
        index: SEARCH_INDEXES.content,
        hitsPerPage: pageSize,
        page: page - 1,
        clickAnalytics: true
    };
    const res = await contentSearchClient.searchOnce(params);
    const result = {
        ...res.content
    };
    // @ts-ignore
    delete result._state;
    // @ts-ignore
    delete result._rawResults;
    return result;
}
function algoliaContentQueryFetcher(context) {
    return fetchAlgoliaContent(context.queryKey[2]);
}
function useAlgoliaContentQuery(props) {
    return useQuery([
        "algolia",
        SEARCH_INDEXES.content,
        props
    ], algoliaContentQueryFetcher, {
        keepPreviousData: true
    });
}
function compileAlgoliaProductFilters(q) {
    const query = omit(q, [
        "q",
        "slug",
        "sort",
        "page"
    ]);
    // Only use filtering params
    const filteredQuery = pickBy(query, (v, k)=>v && k.startsWith("specs.") || k.startsWith("attributes.") || k === "categories" || k === PRICE_PATH);
    const numericRefinements = mapValues(//
    pick(filteredQuery, RANGE_FACETS), (v)=>{
        const [minV, maxV] = v.split("...");
        return {
            ">=": minV ? [
                parseInt(minV, 10)
            ] : [],
            "<=": maxV ? [
                parseInt(maxV, 10)
            ] : []
        };
    });
    const cleanQuery = mapValues(filteredQuery, (v)=>{
        return ensureList(v === null || v === void 0 ? void 0 : v.split(",")).map((item)=>item.replace("_", ","));
    });
    const disjunctiveFacetsRefinements = omit(cleanQuery, RANGE_FACETS);
    return {
        disjunctiveFacetsRefinements,
        numericRefinements
    };
}
function sortFacetOptions(key, options, facetOrderValues) {
    var ref, ref1;
    if (!facetOrderValues) {
        return options;
    }
    const order = (ref = facetOrderValues[key]) === null || ref === void 0 ? void 0 : ref.order;
    const remainingOrder = (ref1 = facetOrderValues[key]) === null || ref1 === void 0 ? void 0 : ref1.sortRemainingBy;
    const sortOptionsMap = fromPairs(options.map((o)=>[
            o.label,
            o
        ]));
    const orderedOptions = ensureList(order === null || order === void 0 ? void 0 : order.map((o)=>sortOptionsMap[o]));
    const remainingOptions = options === null || options === void 0 ? void 0 : options.filter((f)=>{
        return !(order === null || order === void 0 ? void 0 : order.includes(f.label));
    });
    if ((remainingOptions === null || remainingOptions === void 0 ? void 0 : remainingOptions.length) && remainingOrder === "alpha") {
        remainingOptions.sort((a, b)=>a.label.localeCompare(b.label));
    } else if ((remainingOptions === null || remainingOptions === void 0 ? void 0 : remainingOptions.length) && remainingOrder === "count") {
        remainingOptions.sort((a, b)=>b.count - a.count);
    }
    return [
        ...orderedOptions,
        ...remainingOptions
    ];
}
function compileFacets(results, allCategories, queryParams, attrNameMap, activeCategorySlug) {
    var ref;
    var ref1;
    const disjunctiveFacets = fromPairs((ref1 = results === null || results === void 0 ? void 0 : (ref = results.disjunctiveFacets) === null || ref === void 0 ? void 0 : ref.map((f)=>[
            f.name,
            f
        ])) !== null && ref1 !== void 0 ? ref1 : []);
    const catFacet = disjunctiveFacets["categories"];
    delete disjunctiveFacets["categories"];
    const categoryMap = fromPairs(allCategories.map((c)=>[
            c.id,
            c
        ]));
    const categories = ensureList(toPairs(catFacet === null || catFacet === void 0 ? void 0 : catFacet.data).map((param)=>{
        let [idStr, count] = param;
        const id = parseInt(idStr, 10);
        const cat = categoryMap[id];
        if (cat && cat.slug !== activeCategorySlug) {
            var ref;
            var ref1;
            return {
                value: id,
                label: cat === null || cat === void 0 ? void 0 : cat.name,
                count,
                active: (ref1 = (ref = queryParams["categories"]) === null || ref === void 0 ? void 0 : ref.includes(idStr)) !== null && ref1 !== void 0 ? ref1 : false,
                parent: cat.parent
            };
        }
        return null;
    }));
    const specs = fromPairs(toPairs(disjunctiveFacets).filter((param)=>{
        let [k] = param;
        return k.indexOf("specs.") === 0 || k.indexOf("attributes.") === 0 || k === PRICE_PATH;
    }).map((param)=>{
        let [attr, { data: valueCounts  }] = param;
        const isSpec = attr.indexOf("specs.") === 0;
        var _attr;
        const unit = (_attr = FACET_UNIT_OVERRIDES[attr]) !== null && _attr !== void 0 ? _attr : isSpec ? attr.split("|")[1] : undefined;
        var _attr1;
        const facetLabel = (_attr1 = attrNameMap[attr]) !== null && _attr1 !== void 0 ? _attr1 : attr.replace("specs.", "").replace("attributes.", "").split("|")[0];
        if (RANGE_FACETS.includes(attr)) {
            const _facet = disjunctiveFacets[attr];
            const stats = _facet === null || _facet === void 0 ? void 0 : _facet.stats;
            const data = _facet === null || _facet === void 0 ? void 0 : _facet.data;
            const val = queryParams[attr];
            const [minValue, maxValue] = ((val === null || val === void 0 ? void 0 : val[0]) || "").split("...");
            return [
                attr,
                {
                    type: "range",
                    label: facetLabel,
                    unit,
                    min: stats === null || stats === void 0 ? void 0 : stats.min,
                    max: stats === null || stats === void 0 ? void 0 : stats.max,
                    minValue: parseInt(minValue || "0", 10) || undefined,
                    maxValue: parseInt(maxValue || "0", 10) || undefined,
                    data
                }
            ];
        }
        const options = toPairs(valueCounts).map((param)=>{
            let [value, count] = param;
            var ref;
            const sanitizedValue = value.replace(",", "_");
            const label = unit ? "".concat(value, " ").concat(unit) : value;
            var ref1;
            return {
                value: sanitizedValue,
                label,
                count,
                active: (ref1 = (ref = queryParams[attr]) === null || ref === void 0 ? void 0 : ref.includes(sanitizedValue)) !== null && ref1 !== void 0 ? ref1 : false
            };
        });
        return [
            attr,
            {
                type: "choice",
                label: facetLabel,
                options
            }
        ];
    }));
    return {
        categories: {
            type: "hierarchical",
            label: "V\xf6ruflokkar",
            options: categories
        },
        ...specs
    };
}
function compileActiveFilters(facets) {
    return toPairs(facets).reduce((acc, param)=>{
        let [attr, facet] = param;
        return [
            ...acc,
            ...facet.type === "choice" || facet.type === "hierarchical" ? facet.options.filter((opt)=>opt.active).map((param)=>{
                let { value , label  } = param;
                return {
                    attr,
                    value,
                    label
                };
            }) : [],
            ...facet.type === "range" && (!!facet.minValue || !!facet.maxValue) ? [
                {
                    attr,
                    value: facet.label,
                    label: facet.label
                }
            ] : []
        ];
    }, []);
}

// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(61261);
// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(91987);
// EXTERNAL MODULE: ../../.yarn/cache/uuid-npm-9.0.0-46c41e3e43-8dd2c83c43.zip/node_modules/uuid/dist/esm-browser/v4.js + 3 modules
var v4 = __webpack_require__(54106);
// EXTERNAL MODULE: ../../.yarn/cache/cookie-npm-0.6.0-362d6a2e45-f56a7d32a0.zip/node_modules/cookie/index.js
var cookie = __webpack_require__(67520);
;// CONCATENATED MODULE: ../../.yarn/cache/universal-cookie-npm-7.0.2-3ffccb506b-c2c20cc491.zip/node_modules/universal-cookie/esm/index.mjs


function hasDocumentCookie() {
    const testingValue = typeof global === 'undefined'
        ? undefined
        : global.TEST_HAS_DOCUMENT_COOKIE;
    if (typeof testingValue === 'boolean') {
        return testingValue;
    }
    // Can we get/set cookies on document.cookie?
    return typeof document === 'object' && typeof document.cookie === 'string';
}
function parseCookies(cookies) {
    if (typeof cookies === 'string') {
        return cookie/* parse */.Q(cookies);
    }
    else if (typeof cookies === 'object' && cookies !== null) {
        return cookies;
    }
    else {
        return {};
    }
}
function readCookie(value, options = {}) {
    const cleanValue = cleanupCookieValue(value);
    if (!options.doNotParse) {
        try {
            return JSON.parse(cleanValue);
        }
        catch (e) {
            // At least we tried
        }
    }
    // Ignore clean value if we failed the deserialization
    // It is not relevant anymore to trim those values
    return value;
}
function cleanupCookieValue(value) {
    // express prepend j: before serializing a cookie
    if (value && value[0] === 'j' && value[1] === ':') {
        return value.substr(2);
    }
    return value;
}

class esm_Cookies {
    constructor(cookies, defaultSetOptions = {}) {
        this.changeListeners = [];
        this.HAS_DOCUMENT_COOKIE = false;
        this.update = () => {
            if (!this.HAS_DOCUMENT_COOKIE) {
                return;
            }
            const previousCookies = this.cookies;
            this.cookies = cookie/* parse */.Q(document.cookie);
            this._checkChanges(previousCookies);
        };
        const domCookies = typeof document === 'undefined' ? '' : document.cookie;
        this.cookies = parseCookies(cookies || domCookies);
        this.defaultSetOptions = defaultSetOptions;
        this.HAS_DOCUMENT_COOKIE = hasDocumentCookie();
    }
    _emitChange(params) {
        for (let i = 0; i < this.changeListeners.length; ++i) {
            this.changeListeners[i](params);
        }
    }
    _checkChanges(previousCookies) {
        const names = new Set(Object.keys(previousCookies).concat(Object.keys(this.cookies)));
        names.forEach((name) => {
            if (previousCookies[name] !== this.cookies[name]) {
                this._emitChange({
                    name,
                    value: readCookie(this.cookies[name]),
                });
            }
        });
    }
    _startPolling() {
        this.pollingInterval = setInterval(this.update, 300);
    }
    _stopPolling() {
        if (this.pollingInterval) {
            clearInterval(this.pollingInterval);
        }
    }
    get(name, options = {}) {
        if (!options.doNotUpdate) {
            this.update();
        }
        return readCookie(this.cookies[name], options);
    }
    getAll(options = {}) {
        if (!options.doNotUpdate) {
            this.update();
        }
        const result = {};
        for (let name in this.cookies) {
            result[name] = readCookie(this.cookies[name], options);
        }
        return result;
    }
    set(name, value, options) {
        if (options) {
            options = Object.assign(Object.assign({}, this.defaultSetOptions), options);
        }
        else {
            options = this.defaultSetOptions;
        }
        const stringValue = typeof value === 'string' ? value : JSON.stringify(value);
        this.cookies = Object.assign(Object.assign({}, this.cookies), { [name]: stringValue });
        if (this.HAS_DOCUMENT_COOKIE) {
            document.cookie = cookie/* serialize */.q(name, stringValue, options);
        }
        this._emitChange({ name, value, options });
    }
    remove(name, options) {
        const finalOptions = (options = Object.assign(Object.assign(Object.assign({}, this.defaultSetOptions), options), { expires: new Date(1970, 1, 1, 0, 0, 1), maxAge: 0 }));
        this.cookies = Object.assign({}, this.cookies);
        delete this.cookies[name];
        if (this.HAS_DOCUMENT_COOKIE) {
            document.cookie = cookie/* serialize */.q(name, '', finalOptions);
        }
        this._emitChange({ name, value: undefined, options });
    }
    addChangeListener(callback) {
        this.changeListeners.push(callback);
        if (this.HAS_DOCUMENT_COOKIE && this.changeListeners.length === 1) {
            if (typeof window === 'object' && 'cookieStore' in window) {
                window.cookieStore.addEventListener('change', this.update);
            }
            else {
                this._startPolling();
            }
        }
    }
    removeChangeListener(callback) {
        const idx = this.changeListeners.indexOf(callback);
        if (idx >= 0) {
            this.changeListeners.splice(idx, 1);
        }
        if (this.HAS_DOCUMENT_COOKIE && this.changeListeners.length === 0) {
            if (typeof window === 'object' && 'cookieStore' in window) {
                window.cookieStore.removeEventListener('change', this.update);
            }
            else {
                this._stopPolling();
            }
        }
    }
}



// EXTERNAL MODULE: ../../.yarn/cache/hoist-non-react-statics-npm-3.3.2-e7b709e6c1-b153827042.zip/node_modules/hoist-non-react-statics/dist/hoist-non-react-statics.cjs.js
var hoist_non_react_statics_cjs = __webpack_require__(26504);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/react-cookie-virtual-ad0084fe3b/0/cache/react-cookie-npm-7.0.2-5c329bce35-072f48bafd.zip/node_modules/react-cookie/esm/index.mjs






const CookiesContext = react.createContext(new esm_Cookies());
const { Provider, Consumer } = CookiesContext;

class CookiesProvider extends react.Component {
    constructor(props) {
        super(props);
        if (props.cookies) {
            this.cookies = props.cookies;
        }
        else {
            this.cookies = new Cookies(undefined, props.defaultSetOptions);
        }
    }
    render() {
        return React.createElement(Provider, { value: this.cookies }, this.props.children);
    }
}

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise, SuppressedError, Symbol */


function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

function withCookies(WrappedComponent) {
    // @ts-ignore
    const name = WrappedComponent.displayName || WrappedComponent.name;
    class CookieWrapper extends React.Component {
        constructor() {
            super(...arguments);
            this.onChange = () => {
                // Make sure to update children with new values
                this.forceUpdate();
            };
        }
        listen() {
            this.props.cookies.addChangeListener(this.onChange);
        }
        unlisten(cookies) {
            (cookies || this.props.cookies).removeChangeListener(this.onChange);
        }
        componentDidMount() {
            this.listen();
        }
        componentDidUpdate(prevProps) {
            if (prevProps.cookies !== this.props.cookies) {
                this.unlisten(prevProps.cookies);
                this.listen();
            }
        }
        componentWillUnmount() {
            this.unlisten();
        }
        render() {
            const _a = this.props, { forwardedRef, cookies } = _a, restProps = __rest(_a, ["forwardedRef", "cookies"]);
            const allCookies = cookies.getAll();
            return (React.createElement(WrappedComponent, Object.assign({}, restProps, { ref: forwardedRef, cookies: cookies, allCookies: allCookies })));
        }
    }
    CookieWrapper.displayName = `withCookies(${name})`;
    CookieWrapper.WrappedComponent = WrappedComponent;
    const ForwardedComponent = React.forwardRef((props, ref) => {
        return (React.createElement(Consumer, null, (cookies) => (React.createElement(CookieWrapper, Object.assign({ cookies: cookies }, props, { forwardedRef: ref })))));
    });
    ForwardedComponent.displayName = CookieWrapper.displayName;
    ForwardedComponent.WrappedComponent = CookieWrapper.WrappedComponent;
    return hoistStatics(ForwardedComponent, WrappedComponent);
}

function isInBrowser() {
    return (typeof window !== 'undefined' &&
        typeof window.document !== 'undefined' &&
        typeof window.document.createElement !== 'undefined');
}

function useCookies(dependencies) {
    const cookies = (0,react.useContext)(CookiesContext);
    if (!cookies) {
        throw new Error('Missing <CookiesProvider>');
    }
    const [allCookies, setCookies] = (0,react.useState)(() => cookies.getAll());
    if (isInBrowser()) {
        (0,react.useLayoutEffect)(() => {
            function onChange() {
                const newCookies = cookies.getAll({
                    doNotUpdate: true,
                });
                if (shouldUpdate(dependencies || null, newCookies, allCookies)) {
                    setCookies(newCookies);
                }
            }
            cookies.addChangeListener(onChange);
            return () => {
                cookies.removeChangeListener(onChange);
            };
        }, [cookies, allCookies]);
    }
    const setCookie = (0,react.useMemo)(() => cookies.set.bind(cookies), [cookies]);
    const removeCookie = (0,react.useMemo)(() => cookies.remove.bind(cookies), [cookies]);
    const updateCookies = (0,react.useMemo)(() => cookies.update.bind(cookies), [cookies]);
    return [allCookies, setCookie, removeCookie, updateCookies];
}
function shouldUpdate(dependencies, newCookies, oldCookies) {
    if (!dependencies) {
        return true;
    }
    for (let dependency of dependencies) {
        if (newCookies[dependency] !== oldCookies[dependency]) {
            return true;
        }
    }
    return false;
}



;// CONCATENATED MODULE: ../../.yarn/__virtual__/react-use-virtual-6cd4a83c3e/0/cache/react-use-npm-17.4.0-0ef4521544-0889da919b.zip/node_modules/react-use/esm/misc/util.js
var noop = function () { };
function on(obj) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    if (obj && obj.addEventListener) {
        obj.addEventListener.apply(obj, args);
    }
}
function off(obj) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    if (obj && obj.removeEventListener) {
        obj.removeEventListener.apply(obj, args);
    }
}
var isBrowser = typeof window !== 'undefined';
var isNavigator = typeof navigator !== 'undefined';

;// CONCATENATED MODULE: ../../.yarn/__virtual__/react-use-virtual-6cd4a83c3e/0/cache/react-use-npm-17.4.0-0ef4521544-0889da919b.zip/node_modules/react-use/esm/useLocalStorage.js


var useLocalStorage = function (key, initialValue, options) {
    if (!isBrowser) {
        return [initialValue, noop, noop];
    }
    if (!key) {
        throw new Error('useLocalStorage key may not be falsy');
    }
    var deserializer = options
        ? options.raw
            ? function (value) { return value; }
            : options.deserializer
        : JSON.parse;
    // eslint-disable-next-line react-hooks/rules-of-hooks
    var initializer = (0,react.useRef)(function (key) {
        try {
            var serializer = options ? (options.raw ? String : options.serializer) : JSON.stringify;
            var localStorageValue = localStorage.getItem(key);
            if (localStorageValue !== null) {
                return deserializer(localStorageValue);
            }
            else {
                initialValue && localStorage.setItem(key, serializer(initialValue));
                return initialValue;
            }
        }
        catch (_a) {
            // If user is in private mode or has storage restriction
            // localStorage can throw. JSON.parse and JSON.stringify
            // can throw, too.
            return initialValue;
        }
    });
    // eslint-disable-next-line react-hooks/rules-of-hooks
    var _a = (0,react.useState)(function () { return initializer.current(key); }), state = _a[0], setState = _a[1];
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0,react.useLayoutEffect)(function () { return setState(initializer.current(key)); }, [key]);
    // eslint-disable-next-line react-hooks/rules-of-hooks
    var set = (0,react.useCallback)(function (valOrFunc) {
        try {
            var newState = typeof valOrFunc === 'function' ? valOrFunc(state) : valOrFunc;
            if (typeof newState === 'undefined')
                return;
            var value = void 0;
            if (options)
                if (options.raw)
                    if (typeof newState === 'string')
                        value = newState;
                    else
                        value = JSON.stringify(newState);
                else if (options.serializer)
                    value = options.serializer(newState);
                else
                    value = JSON.stringify(newState);
            else
                value = JSON.stringify(newState);
            localStorage.setItem(key, value);
            setState(deserializer(value));
        }
        catch (_a) {
            // If user is in private mode or has storage restriction
            // localStorage can throw. Also JSON.stringify can throw.
        }
    }, [key, setState]);
    // eslint-disable-next-line react-hooks/rules-of-hooks
    var remove = (0,react.useCallback)(function () {
        try {
            localStorage.removeItem(key);
            setState(undefined);
        }
        catch (_a) {
            // If user is in private mode or has storage restriction
            // localStorage can throw.
        }
    }, [key, setState]);
    return [state, set, remove];
};
/* harmony default export */ var esm_useLocalStorage = (useLocalStorage);

// EXTERNAL MODULE: ../../.yarn/__virtual__/react-use-virtual-6cd4a83c3e/0/cache/react-use-npm-17.4.0-0ef4521544-0889da919b.zip/node_modules/react-use/esm/useEffectOnce.js
var useEffectOnce = __webpack_require__(19633);
// EXTERNAL MODULE: ../../.yarn/cache/search-insights-npm-2.2.1-4d82e361bc-6809c0bb63.zip/node_modules/search-insights/index-browser.cjs.js
var index_browser_cjs = __webpack_require__(88108);
var index_browser_cjs_default = /*#__PURE__*/__webpack_require__.n(index_browser_cjs);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-algolia-virtual-7767b18cc0/1/packages/lib-algolia/src/context.tsx
/* eslint-disable react-perf/jsx-no-new-object-as-prop */ 







const context_APP_ID = (0,src/* getBykoConfig */.Hp)("ALGOLIA_APP_ID");
const context_API_KEY = (0,src/* getBykoConfig */.Hp)("ALGOLIA_API_KEY");
const DEBUGG = false;
const AlgoliaInsightContext = /*#__PURE__*/ (0,react.createContext)({});
function AlgoliaInsightProvider(param) {
    let { children  } = param;
    var ref;
    const [algoliaInit, setAlgoliaInit] = (0,react.useState)(false);
    const [lastAlgoliaParameters, setLastAlgoliaParamters] = esm_useLocalStorage("algoliaParameters", {
        index: "",
        queryID: ""
    });
    const [eventsToken] = esm_useLocalStorage("eventsToken", (0,v4/* default */.Z)());
    const [cookies] = useCookies([
        "cookiehub",
        "_ga"
    ]);
    const analyticsConsent =  true && ((ref = window.cookiehub) === null || ref === void 0 ? void 0 : ref.hasConsented("analytics")) || DEBUGG;
    const extractGoogleAnalyticsUserIdFromCookie = ()=>{
        const gaCookie = cookies === null || cookies === void 0 ? void 0 : cookies._ga;
        if (gaCookie) {
            // Remove the Google Analytics tracker from the device ID.
            const userIdParts = gaCookie.split(".").slice(-2);
            if (userIdParts.length === 2) {
                return userIdParts.join("_");
            }
        }
        return undefined;
    };
    const userId = extractGoogleAnalyticsUserIdFromCookie() || eventsToken;
    const sendViewInsights = (0,react.useCallback)((param)=>{
        let { eventName , objectIDs  } = param;
        if (algoliaInit && analyticsConsent) {
            index_browser_cjs_default()("viewedObjectIDs", {
                index: conf_SEARCH_INDEXES.products,
                eventName,
                objectIDs
            });
        }
    }, [
        algoliaInit,
        analyticsConsent
    ]);
    const sendClickInsights = (0,react.useCallback)((param)=>{
        let { eventName , index , queryID , objectIDs , positions  } = param;
        if (algoliaInit && analyticsConsent) {
            index_browser_cjs_default()("clickedObjectIDsAfterSearch", {
                eventName,
                index,
                queryID,
                objectIDs,
                positions
            });
        }
    }, [
        algoliaInit,
        analyticsConsent
    ]);
    const sendAddToCartInsights = (0,react.useCallback)((param)=>{
        let { eventName , index , queryID , objectIDs  } = param;
        if (algoliaInit && analyticsConsent) {
            index_browser_cjs_default()("convertedObjectIDsAfterSearch", {
                eventName,
                index: index || (lastAlgoliaParameters === null || lastAlgoliaParameters === void 0 ? void 0 : lastAlgoliaParameters.index) || "",
                queryID: queryID || (lastAlgoliaParameters === null || lastAlgoliaParameters === void 0 ? void 0 : lastAlgoliaParameters.queryID) || "",
                objectIDs
            });
        }
    }, [
        algoliaInit,
        analyticsConsent,
        lastAlgoliaParameters
    ]);
    const sendFilterClickedEvent = (0,react.useCallback)((param)=>{
        let { eventName , filter  } = param;
        if (algoliaInit && analyticsConsent) {
            index_browser_cjs_default()("clickedFilters", {
                eventName,
                index: conf_SEARCH_INDEXES.products,
                filters: [
                    filter
                ]
            });
        }
    }, [
        algoliaInit,
        analyticsConsent
    ]);
    (0,react.useEffect)(()=>{
        index_browser_cjs_default()("setUserToken", userId);
    }, [
        userId
    ]);
    (0,useEffectOnce/* default */.Z)(()=>{
        setAlgoliaInit(true);
        index_browser_cjs_default()("init", {
            appId: context_APP_ID,
            apiKey: context_API_KEY
        });
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(AlgoliaInsightContext.Provider, {
        value: {
            algoliaInit,
            sendViewInsights,
            sendClickInsights,
            sendAddToCartInsights,
            sendFilterClickedEvent,
            setLastAlgoliaParamters
        },
        children: children
    });
}
function useAlgoliaInsights() {
    return (0,react.useContext)(AlgoliaInsightContext);
}

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-algolia-virtual-7767b18cc0/1/packages/lib-algolia/src/index.ts




/***/ }),

/***/ 57910:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "c": function() { return /* binding */ analytics; }
});

// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-lib-category-helper-virtual-74e1c37b52/1/packages/lib-category-helper/src/index.ts
var src = __webpack_require__(15440);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-analytics-virtual-863cade9f6/1/packages/lib-analytics/src/utils/index.ts

function snakeCaseToTitleCase(snakeCaseString) {
    return snakeCaseString.split("_").map((word)=>word.charAt(0).toUpperCase() + word.slice(1)).join(" ");
}
function buildCategoryTree(data, parent) {
    const result = [];
    for (const category of data){
        if (category.parent === parent) {
            result.push(category, ...buildCategoryTree(data, category.id));
        }
    }
    return result;
}
function buildAnalyticsProduct(product, price, name, listIndex, analyticsSectionId) {
    let quantity = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : 1;
    let sortedCategories = [];
    // checking if product has categories, and if it is an array.
    //  CheckoutLineVariant does not have categories, so we need to check for that.
    if ("categories" in product && Array.isArray(product.categories)) {
        const categories = [];
        product.categories.forEach((categoryId)=>{
            const category = src/* categoriesData.get */.zR.get().find((cat)=>cat.id === categoryId);
            if (category) {
                categories.push(category);
            }
        });
        sortedCategories = buildCategoryTree(categories !== null && categories !== void 0 ? categories : [], null);
    }
    var ref;
    const analyticsPrice = (ref = price.replace("kr", "").replace(".", "").trim()) !== null && ref !== void 0 ? ref : "0";
    let brand = "";
    try {
        var _brand;
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        brand = (_brand = product.attributes.brand) !== null && _brand !== void 0 ? _brand : "N/A";
        // check if brand is a string or array
        if (Array.isArray(brand)) {
            brand = brand[0];
        }
    } catch (e) {
        brand = "N/A";
    }
    const analyticsProduct = {
        item_name: name,
        item_id: product.id.toString(),
        price: analyticsPrice,
        item_brand: brand,
        item_variant: "N/A",
        quantity
    };
    if (analyticsSectionId) {
        analyticsProduct["item_list_name"] = snakeCaseToTitleCase(analyticsSectionId);
        analyticsProduct["item_list_id"] = analyticsSectionId;
    }
    if (listIndex) {
        analyticsProduct["index"] = listIndex;
    }
    const categoryFields = sortedCategories.slice(0, 5).reduce((acc, category, index)=>{
        acc["item_category".concat(index > 0 ? index + 1 : "")] = category.name;
        return acc;
    }, {});
    return {
        ...analyticsProduct,
        ...categoryFields
    };
}

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-analytics-virtual-863cade9f6/1/packages/lib-analytics/src/products.ts
/* eslint-disable no-console */ /* eslint-disable @typescript-eslint/ban-ts-comment */ /* eslint-disable max-len */ 
// Enabling this will log the events to the console instead of sending them to Google Analytics as well as bypassing the cookie consent check
const DEBUG = false;
/**
 * Sends a Google Analytics view_item_list event when a product is viewed in a list
 * See https://developers.google.com/analytics/devguides/collection/ga4/reference/events?client_type=gtm#view_item_list
 *
 * @param {ProductList[]} products - the products to add impression for
 * @param {Record<string, string>} prices - a mapping of product ID to price
 * @param {AnalyticsProductListSection} analyticsSectionId - the section ID for the product list
 */ const addProductListImpression = (products, prices, analyticsSectionId)=>{
    var ref;
    if (false) {}
    if (((ref = window.cookiehub) === null || ref === void 0 ? void 0 : ref.hasConsented("analytics")) || DEBUG) {
        const analyticsProducts = products.map((product, index)=>{
            const price = prices[product.id];
            var _name;
            return buildAnalyticsProduct(product, price !== null && price !== void 0 ? price : "0", (_name = product.name) !== null && _name !== void 0 ? _name : "", index, analyticsSectionId);
        });
        // @ts-ignore
        if (DEBUG === false) {
            window.dataLayer.push({
                event: "view_item_list",
                ecommerce: {
                    items: analyticsProducts
                }
            });
        } else {
            console.log({
                event: "view_item_list",
                ecommerce: {
                    items: analyticsProducts
                }
            });
        }
    }
};
/**
 * Sends a Google Analytics select_item event when a product is clicked on in a list
 * See https://developers.google.com/analytics/devguides/collection/ga4/reference/events?client_type=gtm#select_item
 *
 * @param {ProductList} product The product that was clicked.
 * @param {string} price The price of the product that was clicked.
 * @param {number} listIndex The index of the product in the list.
 * @param {AnalyticsProductListSection} analyticsSectionId The ID of the section in which the product list
 * appears.
 */ const addProductListClick = (product, price, listIndex, analyticsSectionId)=>{
    var ref;
    if (false) {}
    if (((ref = window.cookiehub) === null || ref === void 0 ? void 0 : ref.hasConsented("analytics")) || DEBUG) {
        const analyticsProduct = buildAnalyticsProduct(product, price, product.name, listIndex, analyticsSectionId);
        // @ts-ignore
        if (DEBUG === false) {
            window.dataLayer.push({
                event: "select_item",
                items: [
                    analyticsProduct
                ]
            });
        } else {
            console.log({
                event: "select_item",
                items: [
                    analyticsProduct
                ]
            });
        }
    }
};
/**
 * Sends a Google Analytics view_item event when a product is viewed in a list
 * See https://developers.google.com/analytics/devguides/collection/ga4/reference/events?client_type=gtm#view_item
 *
 * @param {ProductDetail} product - the product to add impression for
 * @param {string} price The price of the product that was clicked.
 */ const addProductPageViewImpression = (product, price)=>{
    var ref;
    if (false) {}
    if (((ref = window.cookiehub) === null || ref === void 0 ? void 0 : ref.hasConsented("analytics")) || DEBUG) {
        const analyticsProduct = buildAnalyticsProduct(product, price, product.name);
        // @ts-ignore
        if (DEBUG === false) {
            window.dataLayer.push({
                event: "view_item",
                ecommerce: {
                    currency: "ISK",
                    value: analyticsProduct.price,
                    items: [
                        analyticsProduct
                    ]
                }
            });
        } else {
            console.log({
                event: "view_item",
                ecommerce: {
                    currency: "ISK",
                    value: analyticsProduct.price,
                    items: [
                        analyticsProduct
                    ]
                }
            });
        }
    }
};
/**
 * Sends a Google Analytics add_to_cart event when a product is added to the cart
 *  See https://developers.google.com/analytics/devguides/collection/ga4/reference/events?client_type=gtm#add_to_cart
 * @param {CheckoutLine} product The product being added to the cart.
 * @param {number} quantity The quantity of the product being added to the cart.
 * @param {number} listIndex The index of the product in the list, if any.
 * @param {AnalyticsProductListSection} analyticsSectionId The section of the product list, if any.
 */ const addProductToCart = (product, quantity, listIndex, analyticsSectionId)=>{
    var ref;
    if (false) {}
    if (((ref = window.cookiehub) === null || ref === void 0 ? void 0 : ref.hasConsented("analytics")) || DEBUG) {
        var _name;
        const analyticsProduct = buildAnalyticsProduct(product.variant, product.totalPrice.amount.gross.toString(), (_name = product.variant.name) !== null && _name !== void 0 ? _name : "", listIndex, analyticsSectionId, quantity);
        // @ts-ignore
        if (DEBUG === false) {
            window.dataLayer.push({
                event: "add_to_cart",
                ecommerce: {
                    currency: "ISK",
                    value: analyticsProduct.price,
                    items: [
                        analyticsProduct
                    ]
                }
            });
        } else {
            console.log({
                event: "add_to_cart",
                ecommerce: {
                    currency: "ISK",
                    value: analyticsProduct.price,
                    items: [
                        analyticsProduct
                    ]
                }
            });
        }
    }
};
/**
 * Sends a Google Analytics remove_from_cart event when a product is removed from the cart
 * See https://developers.google.com/analytics/devguides/collection/ga4/reference/events?client_type=gtm#remove_from_cart
 *
 * @param {CheckoutLine} product - product to remove from cart
 */ const removeProductFromCart = (product)=>{
    var ref;
    if (false) {}
    if (((ref = window.cookiehub) === null || ref === void 0 ? void 0 : ref.hasConsented("analytics")) || DEBUG) {
        var _name;
        const analyticsProduct = buildAnalyticsProduct(product.variant, "0", (_name = product.variant.name) !== null && _name !== void 0 ? _name : "", undefined, undefined, product.quantity);
        // @ts-ignore
        if (DEBUG === false) {
            window.dataLayer.push({
                event: "remove_from_cart",
                ecommerce: {
                    currency: "ISK",
                    value: analyticsProduct.price,
                    items: [
                        analyticsProduct
                    ]
                }
            });
        } else {
            console.log({
                event: "remove_from_cart",
                ecommerce: {
                    currency: "ISK",
                    value: analyticsProduct.price,
                    items: [
                        analyticsProduct
                    ]
                }
            });
        }
    }
};
/**
 * Sends a Google Analytics view_cart event when the cart page is viewed
 * See https://developers.google.com/analytics/devguides/collection/ga4/reference/events?client_type=gtm#view_cart
 *
 * @param {Checkout} checkout - checkout object
 */ const viewCartPage = (checkout)=>{
    var ref;
    if (false) {}
    if (((ref = window.cookiehub) === null || ref === void 0 ? void 0 : ref.hasConsented("analytics")) || DEBUG) {
        const analyticsProducts = checkout.lines.map((product)=>{
            var _name;
            return buildAnalyticsProduct(product.variant, product.totalPrice.amount.gross.toString(), (_name = product.variant.name) !== null && _name !== void 0 ? _name : "", undefined, undefined, product.quantity);
        });
        const totalPrice = analyticsProducts.reduce((acc, product)=>{
            return acc + parseInt(product.price, 10);
        }, 0);
        // @ts-ignore
        if (DEBUG === false) {
            window.dataLayer.push({
                event: "view_cart",
                ecommerce: {
                    currency: "ISK",
                    value: totalPrice,
                    items: analyticsProducts
                }
            });
        } else {
            console.log({
                event: "view_cart",
                ecommerce: {
                    currency: "ISK",
                    value: totalPrice,
                    items: analyticsProducts
                }
            });
        }
    }
};
/**
 * Sends a Google Analytics begin_checkout event when the checkout process is started
 * See https://developers.google.com/analytics/devguides/collection/ga4/reference/events?client_type=gtm#begin_checkout
 *
 * @param {Checkout} checkout - checkout object
 */ const checkoutStarted = (checkout)=>{
    var ref;
    if (false) {}
    if (((ref = window.cookiehub) === null || ref === void 0 ? void 0 : ref.hasConsented("analytics")) || DEBUG) {
        const analyticsProducts = checkout.lines.map((product)=>{
            var _name;
            return buildAnalyticsProduct(product.variant, product.totalPrice.amount.gross.toString(), (_name = product.variant.name) !== null && _name !== void 0 ? _name : "", undefined, undefined, product.quantity);
        });
        const totalPrice = analyticsProducts.reduce((acc, product)=>{
            return acc + parseInt(product.price, 10);
        }, 0);
        // @ts-ignore
        if (DEBUG === false) {
            window.dataLayer.push({
                event: "begin_checkout",
                ecommerce: {
                    currency: "ISK",
                    value: totalPrice,
                    items: analyticsProducts
                }
            });
        } else {
            console.log({
                event: "begin_checkout",
                ecommerce: {
                    currency: "ISK",
                    value: totalPrice,
                    items: analyticsProducts
                }
            });
        }
    }
};
/**
 * Sends a Google Analytics add_shipping_info event when the shipping info is added to the checkout
 * See https://developers.google.com/analytics/devguides/collection/ga4/reference/events?client_type=gtm#add_shipping_info
 *
 * @param {Checkout} checkout - checkout object
 * @param {string} shippingTier - delivery method
 */ const addShippingInfo = (checkout, shippingTier)=>{
    var ref;
    if (false) {}
    if (((ref = window.cookiehub) === null || ref === void 0 ? void 0 : ref.hasConsented("analytics")) || DEBUG) {
        const analyticsProducts = checkout.lines.map((product)=>{
            var _name;
            return buildAnalyticsProduct(product.variant, product.totalPrice.amount.gross.toString(), (_name = product.variant.name) !== null && _name !== void 0 ? _name : "", undefined, undefined, product.quantity);
        });
        const totalPrice = analyticsProducts.reduce((acc, product)=>{
            return acc + parseInt(product.price, 10);
        }, 0);
        // @ts-ignore
        if (DEBUG === false) {
            window.dataLayer.push({
                event: "add_shipping_info",
                ecommerce: {
                    shipping_tier: shippingTier,
                    currency: "ISK",
                    value: totalPrice,
                    items: analyticsProducts
                }
            });
        } else {
            console.log({
                event: "add_shipping_info",
                ecommerce: {
                    shipping_tier: shippingTier,
                    currency: "ISK",
                    value: totalPrice,
                    items: analyticsProducts
                }
            });
        }
    }
};
/**
 * Sends a Google Analytics add_payment_info event when the payment info is added to the checkout
 * See https://developers.google.com/analytics/devguides/collection/ga4/reference/events?client_type=gtm#add_payment_info
 *
 * @param {Checkout} checkout - checkout object
 * @param {PaymentType} paymentType - payment method
 */ const addPaymentInfo = (checkout, paymentType)=>{
    var ref;
    if (false) {}
    if (((ref = window.cookiehub) === null || ref === void 0 ? void 0 : ref.hasConsented("analytics")) || DEBUG) {
        const analyticsProducts = checkout.lines.map((product)=>{
            var _name;
            return buildAnalyticsProduct(product.variant, product.totalPrice.amount.gross.toString(), (_name = product.variant.name) !== null && _name !== void 0 ? _name : "", undefined, undefined, product.quantity);
        });
        const totalPrice = analyticsProducts.reduce((acc, product)=>{
            return acc + parseInt(product.price, 10);
        }, 0);
        // @ts-ignore
        if (DEBUG === false) {
            window.dataLayer.push({
                event: "add_payment_info",
                ecommerce: {
                    currency: "ISK",
                    value: totalPrice,
                    payment_type: paymentType,
                    items: analyticsProducts
                }
            });
        } else {
            console.log({
                event: "add_payment_info",
                ecommerce: {
                    currency: "ISK",
                    value: totalPrice,
                    payment_type: paymentType,
                    items: analyticsProducts
                }
            });
        }
    }
};
/**
 * Sends a Google Analytics purchase event when the checkout is completed
 * See https://developers.google.com/analytics/devguides/collection/ga4/reference/events?client_type=gtm#purchase
 *
 * @param {Checkout} checkout - checkout object
 * @param {string} shippingCost - shipping cost
 * @param {string} totalTax - total tax
 * @param {string} transactionId - transaction id
 */ const checkoutCompleted = (checkout, shippingCost, totalTax, transactionId)=>{
    var ref;
    if (false) {}
    if (((ref = window.cookiehub) === null || ref === void 0 ? void 0 : ref.hasConsented("analytics")) || DEBUG) {
        const analyticsProducts = checkout.lines.map((product)=>{
            var _name;
            return buildAnalyticsProduct(product.variant, product.totalPrice.amount.gross.toString(), (_name = product.variant.name) !== null && _name !== void 0 ? _name : "", undefined, undefined, product.quantity);
        });
        const totalPrice = analyticsProducts.reduce((acc, product)=>{
            return acc + parseInt(product.price, 10);
        }, 0);
        // @ts-ignore
        if (DEBUG === false) {
            window.dataLayer.push({
                event: "purchase",
                ecommerce: {
                    currency: "ISK",
                    value: totalPrice,
                    tax: totalTax,
                    transaction_id: transactionId,
                    affiliation: "BYKO webstore",
                    shipping: shippingCost,
                    items: analyticsProducts
                }
            });
        } else {
            console.log({
                event: "purchase",
                ecommerce: {
                    currency: "ISK",
                    value: totalPrice,
                    tax: totalTax,
                    transaction_id: transactionId,
                    affiliation: "BYKO webstore",
                    shipping: shippingCost,
                    items: analyticsProducts
                }
            });
        }
    }
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-analytics-virtual-863cade9f6/1/packages/lib-analytics/src/index.ts

const analytics = {
    addPaymentInfo: addPaymentInfo,
    addProductListClick: addProductListClick,
    addProductListImpression: addProductListImpression,
    addProductPageViewImpression: addProductPageViewImpression,
    addProductToCart: addProductToCart,
    addShippingInfo: addShippingInfo,
    checkoutCompleted: checkoutCompleted,
    checkoutStarted: checkoutStarted,
    removeProductFromCart: removeProductFromCart,
    viewCartPage: viewCartPage
};


/***/ }),

/***/ 42039:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "A2": function() { return /* reexport */ GetFrontPageBySlugDocument; },
  "w8": function() { return /* reexport */ PageByParentPageAndSlugDocument; },
  "JZ": function() { return /* reexport */ getOpeningHours; },
  "v7": function() { return /* reexport */ getProductPageBySlug; },
  "Ax": function() { return /* reexport */ useFrontpage; },
  "c6": function() { return /* reexport */ useFrontpageBySlug; },
  "VT": function() { return /* reexport */ useMegaMenuData; },
  "DS": function() { return /* reexport */ useOpeningHours; },
  "Rb": function() { return /* reexport */ usePageBySlug; },
  "fg": function() { return /* reexport */ withDato; },
  "xF": function() { return /* reexport */ withDatoFrontpage; },
  "RO": function() { return /* reexport */ withDatoPageBySlug; }
});

// UNUSED EXPORTS: ActionButtonPartsFragmentDoc, ActionButtonRecordPartsFragmentDoc, AuthorblockRecorddPartsFragmentDoc, BulletContainerblockPartsFragmentDoc, Contentsection1RecordPartsFragmentDoc, Contentsection2RecordPartsFragmentDoc, Contentsection3RecordPartsFragmentDoc, Contentsection4RecordPartsFragmentDoc, Contentsection5RecordPartsFragmentDoc, Contentsection6RecordPartsFragmentDoc, Contentsection7RecordPartsFragmentDoc, Contentsection8RecordPartsFragmentDoc, Contentsection9RecordPartsFragmentDoc, ContentsectionFilesPartsFragmentDoc, ContentsectionProductSliderPartsFragmentDoc, DefaultHeaderPartsFragmentDoc, FrontPageHeaderPartsFragmentDoc, FrontpagePartsFragmentDoc, GetFrontPageDocument, GetStringByKeyDocument, HtmlBlockRecordPartsFragmentDoc, IconbBlockRecordPartsFragmentDoc, ImageBlockPartsFragmentDoc, ImageBlockPartsWithTitleFragmentDoc, ImageFilePartsFragmentDoc, ImageTilesBlockRecordPartsFragmentDoc, ListcontainerblockRecordPartsFragmentDoc, ListitemblockModelTextFieldPartsFragmentDoc, ListitemblockRecordPartsFragmentDoc, PageBySlugDocument, PagePartsFragmentDoc, PagesByParentDocument, PhotoGalleryBlockRecordPartsFragmentDoc, SeoFieldPartsFragmentDoc, StringRecordFragmentFragmentDoc, TextBlockPartsFragmentDoc, TextblockModelContentFieldPartsFragmentDoc, TopbannerdefaultblockRecordPartsFragmentDoc, getFrontpage, getFrontpageBySlug, getMegaMenuData, getPageBySlug, trpc, useDatoStringByKey, useProductPageBySlug

;// CONCATENATED MODULE: ../../.yarn/cache/@babel-runtime-npm-7.20.1-8f9256f2ed-00567a333d.zip/node_modules/@babel/runtime/helpers/esm/defineProperty.js
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
;// CONCATENATED MODULE: ../../.yarn/cache/@babel-runtime-npm-7.20.1-8f9256f2ed-00567a333d.zip/node_modules/@babel/runtime/helpers/esm/objectSpread2.js

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
;// CONCATENATED MODULE: ../../.yarn/cache/@babel-runtime-npm-7.20.1-8f9256f2ed-00567a333d.zip/node_modules/@babel/runtime/helpers/esm/classCallCheck.js
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
;// CONCATENATED MODULE: ../../.yarn/cache/@babel-runtime-npm-7.20.1-8f9256f2ed-00567a333d.zip/node_modules/@babel/runtime/helpers/esm/createClass.js
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
;// CONCATENATED MODULE: ../../.yarn/cache/@babel-runtime-npm-7.20.1-8f9256f2ed-00567a333d.zip/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
// EXTERNAL MODULE: ../../.yarn/cache/@babel-runtime-npm-7.20.1-8f9256f2ed-00567a333d.zip/node_modules/@babel/runtime/helpers/esm/setPrototypeOf.js
var setPrototypeOf = __webpack_require__(86422);
;// CONCATENATED MODULE: ../../.yarn/cache/@babel-runtime-npm-7.20.1-8f9256f2ed-00567a333d.zip/node_modules/@babel/runtime/helpers/esm/inherits.js

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) (0,setPrototypeOf/* default */.Z)(subClass, superClass);
}
;// CONCATENATED MODULE: ../../.yarn/cache/@babel-runtime-npm-7.20.1-8f9256f2ed-00567a333d.zip/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
;// CONCATENATED MODULE: ../../.yarn/cache/@babel-runtime-npm-7.20.1-8f9256f2ed-00567a333d.zip/node_modules/@babel/runtime/helpers/esm/isNativeReflectConstruct.js
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
;// CONCATENATED MODULE: ../../.yarn/cache/@babel-runtime-npm-7.20.1-8f9256f2ed-00567a333d.zip/node_modules/@babel/runtime/helpers/esm/typeof.js
function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}
;// CONCATENATED MODULE: ../../.yarn/cache/@babel-runtime-npm-7.20.1-8f9256f2ed-00567a333d.zip/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js


function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized(self);
}
;// CONCATENATED MODULE: ../../.yarn/cache/@babel-runtime-npm-7.20.1-8f9256f2ed-00567a333d.zip/node_modules/@babel/runtime/helpers/esm/createSuper.js



function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
;// CONCATENATED MODULE: ../../.yarn/cache/@babel-runtime-npm-7.20.1-8f9256f2ed-00567a333d.zip/node_modules/@babel/runtime/helpers/esm/isNativeFunction.js
function _isNativeFunction(fn) {
  return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
;// CONCATENATED MODULE: ../../.yarn/cache/@babel-runtime-npm-7.20.1-8f9256f2ed-00567a333d.zip/node_modules/@babel/runtime/helpers/esm/construct.js


function _construct(Parent, args, Class) {
  if (_isNativeReflectConstruct()) {
    _construct = Reflect.construct.bind();
  } else {
    _construct = function _construct(Parent, args, Class) {
      var a = [null];
      a.push.apply(a, args);
      var Constructor = Function.bind.apply(Parent, a);
      var instance = new Constructor();
      if (Class) (0,setPrototypeOf/* default */.Z)(instance, Class.prototype);
      return instance;
    };
  }
  return _construct.apply(null, arguments);
}
;// CONCATENATED MODULE: ../../.yarn/cache/@babel-runtime-npm-7.20.1-8f9256f2ed-00567a333d.zip/node_modules/@babel/runtime/helpers/esm/wrapNativeSuper.js




function _wrapNativeSuper(Class) {
  var _cache = typeof Map === "function" ? new Map() : undefined;
  _wrapNativeSuper = function _wrapNativeSuper(Class) {
    if (Class === null || !_isNativeFunction(Class)) return Class;
    if (typeof Class !== "function") {
      throw new TypeError("Super expression must either be null or a function");
    }
    if (typeof _cache !== "undefined") {
      if (_cache.has(Class)) return _cache.get(Class);
      _cache.set(Class, Wrapper);
    }
    function Wrapper() {
      return _construct(Class, arguments, _getPrototypeOf(this).constructor);
    }
    Wrapper.prototype = Object.create(Class.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    return (0,setPrototypeOf/* default */.Z)(Wrapper, Class);
  };
  return _wrapNativeSuper(Class);
}
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@trpc-client-virtual-a6e1cba112/0/cache/@trpc-client-npm-9.24.0-82cf00b2ad-6a939e59b3.zip/node_modules/@trpc/client/dist/TRPCClientError-09b8a26b.esm.js








var TRPCClientError = /*#__PURE__*/function (_Error) {
  _inherits(TRPCClientError, _Error);

  var _super = /*#__PURE__*/_createSuper(TRPCClientError);

  /**
   * @deprecated use `cause`
   */

  /**
   * Fatal error - expect no more results after this error
   * Used for when WebSockets disconnect prematurely.
   */
  function TRPCClientError(message, opts) {
    var _opts$cause, _opts$isDone, _opts$result, _opts$result2;

    var _this;

    _classCallCheck(this, TRPCClientError);

    var cause = (_opts$cause = opts.cause) !== null && _opts$cause !== void 0 ? _opts$cause : opts.originalError; // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore https://github.com/tc39/proposal-error-cause

    _this = _super.call(this, message, {
      cause: cause
    });
    _this.originalError = void 0;
    _this.cause = void 0;
    _this.shape = void 0;
    _this.data = void 0;
    _this.isDone = void 0;
    _this.isDone = (_opts$isDone = opts.isDone) !== null && _opts$isDone !== void 0 ? _opts$isDone : false;
    _this.cause = _this.originalError = cause;
    _this.shape = (_opts$result = opts.result) === null || _opts$result === void 0 ? void 0 : _opts$result.error;
    _this.data = (_opts$result2 = opts.result) === null || _opts$result2 === void 0 ? void 0 : _opts$result2.error.data;
    _this.name = 'TRPCClientError';
    Object.setPrototypeOf(_assertThisInitialized(_this), TRPCClientError.prototype);
    return _this;
  }

  _createClass(TRPCClientError, null, [{
    key: "from",
    value: function from(result) {
      var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      if (!(result instanceof Error)) {
        var _message;

        return new TRPCClientError((_message = result.error.message) !== null && _message !== void 0 ? _message : '', _objectSpread2(_objectSpread2({}, opts), {}, {
          cause: null,
          result: result
        }));
      }

      if (result.name === 'TRPCClientError') {
        return result;
      }

      return new TRPCClientError(result.message, _objectSpread2(_objectSpread2({}, opts), {}, {
        cause: result,
        result: null
      }));
    }
  }]);

  return TRPCClientError;
}( /*#__PURE__*/_wrapNativeSuper(Error));



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@trpc-client-virtual-a6e1cba112/0/cache/@trpc-client-npm-9.24.0-82cf00b2ad-6a939e59b3.zip/node_modules/@trpc/client/dist/transformRPCResponse-3700ef8b.esm.js









var TRPCAbortError = /*#__PURE__*/function (_Error) {
  _inherits(TRPCAbortError, _Error);

  var _super = /*#__PURE__*/_createSuper(TRPCAbortError);

  function TRPCAbortError() {
    var _this;

    _classCallCheck(this, TRPCAbortError);

    _this = _super.call(this, 'The operation was aborted.');
    _this.name = 'TRPCAbortError';
    Object.setPrototypeOf(_assertThisInitialized(_this), TRPCAbortError.prototype);
    return _this;
  }

  return _createClass(TRPCAbortError);
}( /*#__PURE__*/_wrapNativeSuper(Error));

// https://github.com/trpc/trpc/pull/669
function arrayToDict(array) {
  var dict = {};

  for (var index = 0; index < array.length; index++) {
    var element = array[index];
    dict[index] = element;
  }

  return dict;
}

function httpRequest(props) {
  var type = props.type,
      rt = props.runtime,
      path = props.path;
  var ac = rt.AbortController ? new rt.AbortController() : null;
  var method = {
    query: 'GET',
    mutation: 'POST',
    subscription: 'PATCH'
  };
  var input = 'input' in props ? rt.transformer.serialize(props.input) : arrayToDict(props.inputs.map(function (_input) {
    return rt.transformer.serialize(_input);
  }));

  function getUrl() {
    var url = props.url + '/' + path;
    var queryParts = [];

    if ('inputs' in props) {
      queryParts.push('batch=1');
    }

    if (type === 'query' && input !== undefined) {
      queryParts.push("input=".concat(encodeURIComponent(JSON.stringify(input))));
    }

    if (queryParts.length) {
      url += '?' + queryParts.join('&');
    }

    return url;
  }

  function getBody() {
    if (type === 'query') {
      return undefined;
    }

    return input !== undefined ? JSON.stringify(input) : undefined;
  }

  var promise = new Promise(function (resolve, reject) {
    var url = getUrl();
    Promise.resolve(rt.headers()).then(function (rawHeaders) {
      var headers = {
        'content-type': 'application/json'
      };

      for (var key in rawHeaders) {
        var header = rawHeaders[key];

        if (header !== undefined) {
          if (Array.isArray(header)) {
            headers[key] = header.join(',');
          } else {
            headers[key] = header;
          }
        }
      }

      return rt.fetch(url, {
        method: method[type],
        signal: ac === null || ac === void 0 ? void 0 : ac.signal,
        body: getBody(),
        headers: headers
      });
    }).then(function (res) {
      return res.json();
    }).then(function (json) {
      resolve(json);
    }).catch(reject);
  });

  var cancel = function cancel() {
    ac === null || ac === void 0 ? void 0 : ac.abort();
  };

  return {
    promise: promise,
    cancel: cancel
  };
}

function transformRPCResponse(_ref) {
  var envelope = _ref.envelope,
      runtime = _ref.runtime;

  if ('error' in envelope) {
    return TRPCClientError.from(_objectSpread2(_objectSpread2({}, envelope), {}, {
      error: runtime.transformer.deserialize(envelope.error)
    }));
  }

  if (envelope.result.type === 'data') {
    return _objectSpread2(_objectSpread2({}, envelope.result), {}, {
      data: runtime.transformer.deserialize(envelope.result.data)
    });
  }

  return envelope.result;
}



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@trpc-client-virtual-a6e1cba112/0/cache/@trpc-client-npm-9.24.0-82cf00b2ad-6a939e59b3.zip/node_modules/@trpc/client/links/httpLink/dist/trpc-client-links-httpLink.esm.js










function trpc_client_links_httpLink_esm_httpLink(opts) {
  var url = opts.url; // initialized config

  return function (runtime) {
    // initialized in app
    return function (_ref) {
      var op = _ref.op,
          prev = _ref.prev,
          onDestroy = _ref.onDestroy;
      var path = op.path,
          input = op.input,
          type = op.type;

      var _httpRequest = httpRequest({
        runtime: runtime,
        type: type,
        input: input,
        url: url,
        path: path
      }),
          promise = _httpRequest.promise,
          cancel = _httpRequest.cancel;

      var isDone = false;

      var prevOnce = function prevOnce(result) {
        if (isDone) {
          return;
        }

        isDone = true;
        prev(result);
      };

      onDestroy(function () {
        prevOnce(TRPCClientError.from(new TRPCAbortError(), {
          isDone: true
        }));
        cancel();
      });
      promise.then(function (envelope) {
        prevOnce(transformRPCResponse({
          envelope: envelope,
          runtime: runtime
        }));
      }).catch(function (cause) {
        prevOnce(TRPCClientError.from(cause));
      });
    };
  };
}



// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-lib-utils-virtual-08ae943915/1/packages/lib-utils/src/index.ts + 19 modules
var src = __webpack_require__(65582);
;// CONCATENATED MODULE: ../../.yarn/cache/@babel-runtime-npm-7.20.1-8f9256f2ed-00567a333d.zip/node_modules/@babel/runtime/helpers/esm/arrayLikeToArray.js
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}
;// CONCATENATED MODULE: ../../.yarn/cache/@babel-runtime-npm-7.20.1-8f9256f2ed-00567a333d.zip/node_modules/@babel/runtime/helpers/esm/unsupportedIterableToArray.js

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
;// CONCATENATED MODULE: ../../.yarn/cache/@babel-runtime-npm-7.20.1-8f9256f2ed-00567a333d.zip/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js

function _createForOfIteratorHelper(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (!it) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it) o = it;
      var i = 0;
      var F = function F() {};
      return {
        s: F,
        n: function n() {
          if (i >= o.length) return {
            done: true
          };
          return {
            done: false,
            value: o[i++]
          };
        },
        e: function e(_e) {
          throw _e;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var normalCompletion = true,
    didErr = false,
    err;
  return {
    s: function s() {
      it = it.call(o);
    },
    n: function n() {
      var step = it.next();
      normalCompletion = step.done;
      return step;
    },
    e: function e(_e2) {
      didErr = true;
      err = _e2;
    },
    f: function f() {
      try {
        if (!normalCompletion && it["return"] != null) it["return"]();
      } finally {
        if (didErr) throw err;
      }
    }
  };
}
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@trpc-client-virtual-a6e1cba112/0/cache/@trpc-client-npm-9.24.0-82cf00b2ad-6a939e59b3.zip/node_modules/@trpc/client/links/httpBatchLink/dist/trpc-client-links-httpBatchLink.esm.js











/**
 * Dataloader that's very inspired by https://github.com/graphql/dataloader
 * Less configuration, no caching, and allows you to cancel requests
 * When cancelling a single fetch the whole batch will be cancelled only when _all_ items are cancelled
 */
function dataLoader(fetchMany, opts) {
  var batch = null;
  var dispatchTimer = null;

  var destroyTimerAndBatch = function destroyTimerAndBatch() {
    clearTimeout(dispatchTimer);
    dispatchTimer = null;
    batch = null;
  };

  function dispatch() {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    var batchCopy = batch;
    destroyTimerAndBatch();

    var _fetchMany = fetchMany(batchCopy.items.map(function (v) {
      return v.key;
    })),
        promise = _fetchMany.promise,
        cancel = _fetchMany.cancel;

    batchCopy.cancel = cancel;
    promise.then(function (result) {
      for (var i = 0; i < result.length; i++) {
        var _value = result[i];
        batchCopy.items[i].resolve(_value);
      }
    }).catch(function (cause) {
      var _iterator = _createForOfIteratorHelper(batchCopy.items),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var item = _step.value;
          item.reject(cause);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    });
  }

  function load(key) {
    var batchItem = {
      cancelled: false,
      key: key
    };

    if (!batch) {
      batch = {
        items: [],
        cancel: function cancel() {
          destroyTimerAndBatch();
        }
      };
    }

    var thisBatch = batch;
    var promise = new Promise(function (resolve, reject) {
      var item = batchItem;
      item.reject = reject;
      item.resolve = resolve;
      thisBatch.items.push(item);

      if (typeof (opts === null || opts === void 0 ? void 0 : opts.maxBatchSize) !== 'undefined' && thisBatch.items.length >= opts.maxBatchSize) {
        dispatch();
        return;
      }
    });

    if (!dispatchTimer) {
      dispatchTimer = setTimeout(dispatch);
    }

    var cancel = function cancel() {
      batchItem.cancelled = true;

      if (thisBatch.items.some(function (item) {
        return !item.cancelled;
      })) {
        // there are still things that can be resolved
        return;
      }

      thisBatch.cancel();
    };

    return {
      promise: promise,
      cancel: cancel
    };
  }

  return {
    load: load
  };
}

function httpBatchLink(opts) {
  var url = opts.url,
      maxBatchSize = opts.maxBatchSize; // initialized config

  return function (runtime) {
    // initialized in app
    var fetcher = function fetcher(type) {
      return function (keyInputPairs) {
        var path = keyInputPairs.map(function (op) {
          return op.path;
        }).join(',');
        var inputs = keyInputPairs.map(function (op) {
          return op.input;
        });

        var _httpRequest = httpRequest({
          url: url,
          inputs: inputs,
          path: path,
          runtime: runtime,
          type: type
        }),
            promise = _httpRequest.promise,
            cancel = _httpRequest.cancel;

        return {
          promise: promise.then(function (res) {
            if (!Array.isArray(res)) {
              return keyInputPairs.map(function () {
                return res;
              });
            }

            return res;
          }),
          cancel: cancel
        };
      };
    };

    var query = dataLoader(fetcher('query'), {
      maxBatchSize: maxBatchSize
    });
    var mutation = dataLoader(fetcher('mutation'), {
      maxBatchSize: maxBatchSize
    });
    var subscription = dataLoader(fetcher('subscription'), {
      maxBatchSize: maxBatchSize
    });
    var loaders = {
      query: query,
      subscription: subscription,
      mutation: mutation
    };
    return function (_ref) {
      var op = _ref.op,
          prev = _ref.prev,
          onDestroy = _ref.onDestroy;
      var loader = loaders[op.type];

      var _loader$load = loader.load(op),
          promise = _loader$load.promise,
          cancel = _loader$load.cancel;

      var isDone = false;

      var prevOnce = function prevOnce(result) {
        if (isDone) {
          return;
        }

        isDone = true;
        prev(result);
      };

      onDestroy(function () {
        prevOnce(TRPCClientError.from(new TRPCAbortError(), {
          isDone: true
        }));
        cancel();
      });
      promise.then(function (envelope) {
        prevOnce(transformRPCResponse({
          envelope: envelope,
          runtime: runtime
        }));
      }).catch(function (cause) {
        prevOnce(TRPCClientError.from(cause));
      });
    };
  };
}



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@trpc-client-virtual-a6e1cba112/0/cache/@trpc-client-npm-9.24.0-82cf00b2ad-6a939e59b3.zip/node_modules/@trpc/client/dist/trpc-client.esm.js













function getWindow() {
  if (typeof window !== 'undefined') {
    return window;
  }

  return __webpack_require__.g;
}
function getAbortController(ac) {
  var win = getWindow();
  return ac || win.AbortController || null;
}

function getFetch(f) {
  if (f) {
    return f;
  }

  var win = getWindow();

  if (win.fetch) {
    return typeof win.fetch.bind === 'function' ? win.fetch.bind(win) : win.fetch;
  }

  throw new Error('No fetch implementation found');
}

function observable() {
  var listeners = [];
  var value = null;
  return {
    subscribe: function subscribe(callbacks) {
      var listener = {
        callbacks: callbacks,
        unsubscribe: function unsubscribe() {
          var index = listeners.indexOf(listener);

          if (index !== -1) {
            var _listener$callbacks$o, _listener$callbacks;

            listeners.splice(index, 1);
            (_listener$callbacks$o = (_listener$callbacks = listener.callbacks).onDone) === null || _listener$callbacks$o === void 0 ? void 0 : _listener$callbacks$o.call(_listener$callbacks);
          }
        }
      };
      listeners.push(listener);
      return function () {
        listener.unsubscribe();
      };
    },
    next: function next(newValue) {
      var oldValue = value;
      value = newValue;

      if (oldValue !== newValue) {
        var _iterator = _createForOfIteratorHelper(listeners),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var _listener$callbacks$o2, _listener$callbacks2;

            var listener = _step.value;
            (_listener$callbacks$o2 = (_listener$callbacks2 = listener.callbacks).onNext) === null || _listener$callbacks$o2 === void 0 ? void 0 : _listener$callbacks$o2.call(_listener$callbacks2, newValue);
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }
    },
    done: function done() {
      while (listeners.length) {
        var _listener$callbacks$o3, _listener$callbacks3;

        var listener = listeners.pop();
        listener === null || listener === void 0 ? void 0 : (_listener$callbacks$o3 = (_listener$callbacks3 = listener.callbacks).onDone) === null || _listener$callbacks$o3 === void 0 ? void 0 : _listener$callbacks$o3.call(_listener$callbacks3);
        listener === null || listener === void 0 ? void 0 : listener.unsubscribe();
      }
    },
    error: function (_error) {
      function error(_x) {
        return _error.apply(this, arguments);
      }

      error.toString = function () {
        return _error.toString();
      };

      return error;
    }(function (error) {
      var _iterator2 = _createForOfIteratorHelper(listeners),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var _listener$callbacks$o4, _listener$callbacks4;

          var listener = _step2.value;
          (_listener$callbacks$o4 = (_listener$callbacks4 = listener.callbacks).onError) === null || _listener$callbacks$o4 === void 0 ? void 0 : _listener$callbacks$o4.call(_listener$callbacks4, error);
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    })
  };
}
function observableSubject(initialValue) {
  var $obs = observable();
  var value = initialValue;
  $obs.next(initialValue);
  return _objectSpread2(_objectSpread2({}, $obs), {}, {
    next: function next(v) {
      value = v;
      $obs.next(v);
    },
    get: function get() {
      return value;
    }
  });
}

function executeChain(opts) {
  var $result = observableSubject(null);

  var updateResult = function updateResult(result) {
    if (result instanceof Error) {
      $result.error(result);

      if (result.isDone) {
        $result.done();
      }
    } else {
      $result.next(result);
    }
  };

  function walk(_ref) {
    var index = _ref.index,
        op = _ref.op,
        stack = _ref.stack;
    var link = opts.links[index];
    var prev = index === 0 ? function (value) {
      return updateResult(value);
    } : stack[index - 1];
    link({
      op: op,
      prev: prev,
      next: function next(op, prevOp) {
        var prevStack = stack.slice();
        prevStack[index] = prevOp;
        walk({
          index: index + 1,
          op: op,
          stack: prevStack
        });
      },
      onDestroy: function onDestroy(callback) {
        $result.subscribe({
          onDone: function onDone() {
            callback();
          }
        });
      }
    });
  }

  walk({
    index: 0,
    op: opts.op,
    stack: []
  });
  return $result;
}

var idCounter = 0;

function getRequestId() {
  return ++idCounter;
}

var TRPCClient = /*#__PURE__*/function () {
  function TRPCClient(opts) {
    var _this = this;

    _classCallCheck(this, TRPCClient);

    this.links = void 0;
    this.runtime = void 0;
    var transformer = opts.transformer ? 'input' in opts.transformer ? {
      serialize: opts.transformer.input.serialize,
      deserialize: opts.transformer.output.deserialize
    } : opts.transformer : {
      serialize: function serialize(data) {
        return data;
      },
      deserialize: function deserialize(data) {
        return data;
      }
    };

    var _fetch = getFetch(opts === null || opts === void 0 ? void 0 : opts.fetch);

    var AC = getAbortController(opts === null || opts === void 0 ? void 0 : opts.AbortController);

    function getHeadersFn() {
      if (opts.headers) {
        var headers = opts.headers;
        return typeof headers === 'function' ? headers : function () {
          return headers;
        };
      }

      return function () {
        return {};
      };
    }

    this.runtime = {
      transformer: transformer,
      AbortController: AC,
      fetch: _fetch,
      headers: getHeadersFn()
    };

    if ('links' in opts) {
      this.links = opts.links.map(function (link) {
        return link(_this.runtime);
      });
    } else {
      this.links = [httpBatchLink({
        url: opts.url
      })(this.runtime)];
    }
  }

  _createClass(TRPCClient, [{
    key: "$request",
    value: function $request(_ref) {
      var type = _ref.type,
          input = _ref.input,
          path = _ref.path,
          _ref$context = _ref.context,
          context = _ref$context === void 0 ? {} : _ref$context;
      var $result = executeChain({
        links: this.links,
        op: {
          id: getRequestId(),
          type: type,
          path: path,
          input: input,
          context: context
        }
      });
      return $result;
    }
  }, {
    key: "requestAsPromise",
    value: function requestAsPromise(opts) {
      var $result = this.$request(opts);
      var promise = new Promise(function (resolve, reject) {
        var res = $result.get();

        if ((res === null || res === void 0 ? void 0 : res.type) === 'data') {
          resolve(res.data);
          $result.done();
          return;
        }

        $result.subscribe({
          onNext: function onNext(result) {
            if ((result === null || result === void 0 ? void 0 : result.type) !== 'data') {
              return;
            }

            resolve(result.data);
            $result.done();
          },
          onError: function onError(err) {
            reject(err);
            $result.done();
          },
          onDone: function onDone() {
            reject(TRPCClientError.from(new TRPCAbortError()));
          }
        });
      });

      promise.cancel = function () {
        $result.done();
      };

      return promise;
    }
  }, {
    key: "query",
    value: function query(path) {
      var _args$;

      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      var context = (_args$ = args[1]) === null || _args$ === void 0 ? void 0 : _args$.context;
      return this.requestAsPromise({
        type: 'query',
        path: path,
        input: args[0],
        context: context
      });
    }
  }, {
    key: "mutation",
    value: function mutation(path) {
      var _args$2;

      for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        args[_key2 - 1] = arguments[_key2];
      }

      var context = (_args$2 = args[1]) === null || _args$2 === void 0 ? void 0 : _args$2.context;
      return this.requestAsPromise({
        type: 'mutation',
        path: path,
        input: args[0],
        context: context
      });
    }
  }, {
    key: "subscription",
    value: function subscription(path, input, opts) {
      var $res = this.$request({
        type: 'subscription',
        path: path,
        input: input,
        context: opts.context
      });
      $res.subscribe({
        onNext: function onNext(output) {
          if (output) {
            var _opts$onNext;

            (_opts$onNext = opts.onNext) === null || _opts$onNext === void 0 ? void 0 : _opts$onNext.call(opts, output);
          }
        },
        onError: function onError(err) {
          var _opts$onError;

          (_opts$onError = opts.onError) === null || _opts$onError === void 0 ? void 0 : _opts$onError.call(opts, err);
        },
        onDone: opts.onDone
      });
      return function () {
        $res.done();
      };
    }
  }]);

  return TRPCClient;
}();

/* eslint-disable @typescript-eslint/no-explicit-any */
function createTRPCClient(opts) {
  return new TRPCClient(opts);
}



;// CONCATENATED MODULE: ../../.yarn/cache/@babel-runtime-npm-7.20.1-8f9256f2ed-00567a333d.zip/node_modules/@babel/runtime/helpers/esm/arrayWithoutHoles.js

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
;// CONCATENATED MODULE: ../../.yarn/cache/@babel-runtime-npm-7.20.1-8f9256f2ed-00567a333d.zip/node_modules/@babel/runtime/helpers/esm/iterableToArray.js
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
;// CONCATENATED MODULE: ../../.yarn/cache/@babel-runtime-npm-7.20.1-8f9256f2ed-00567a333d.zip/node_modules/@babel/runtime/helpers/esm/nonIterableSpread.js
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
;// CONCATENATED MODULE: ../../.yarn/cache/@babel-runtime-npm-7.20.1-8f9256f2ed-00567a333d.zip/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js




function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
;// CONCATENATED MODULE: ../../.yarn/cache/@babel-runtime-npm-7.20.1-8f9256f2ed-00567a333d.zip/node_modules/@babel/runtime/helpers/esm/arrayWithHoles.js
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
;// CONCATENATED MODULE: ../../.yarn/cache/@babel-runtime-npm-7.20.1-8f9256f2ed-00567a333d.zip/node_modules/@babel/runtime/helpers/esm/iterableToArrayLimit.js
function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _s, _e;
  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);
      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }
  return _arr;
}
;// CONCATENATED MODULE: ../../.yarn/cache/@babel-runtime-npm-7.20.1-8f9256f2ed-00567a333d.zip/node_modules/@babel/runtime/helpers/esm/nonIterableRest.js
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
;// CONCATENATED MODULE: ../../.yarn/cache/@babel-runtime-npm-7.20.1-8f9256f2ed-00567a333d.zip/node_modules/@babel/runtime/helpers/esm/slicedToArray.js




function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(91987);
// EXTERNAL MODULE: ../../.yarn/__virtual__/react-query-virtual-9ac5b1aaa1/0/cache/react-query-npm-3.39.1-7899b170b9-9273b7c2ad.zip/node_modules/react-query/es/index.js
var es = __webpack_require__(85166);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@trpc-react-virtual-b46683a84d/0/cache/@trpc-react-npm-9.24.0-3fee922f79-bff5be9e40.zip/node_modules/@trpc/react/dist/trpc-react.esm.js








var TRPCContext = /*#__PURE__*/(0,react.createContext)(null);

function getClientArgs(pathAndInput, opts) {
  var _pathAndInput = _slicedToArray(pathAndInput, 2),
      path = _pathAndInput[0],
      input = _pathAndInput[1];

  return [path, input, opts];
}

function createReactQueryHooks() {
  var Context = TRPCContext;

  function createClient(opts) {
    return createTRPCClient(opts);
  }

  function TRPCProvider(props) {
    var client = props.client,
        queryClient = props.queryClient,
        ssrContext = props.ssrContext;

    var _useState = (0,react.useState)(props.ssrState || (props.isPrepass ? 'prepass' : false)),
        _useState2 = _slicedToArray(_useState, 2),
        ssrState = _useState2[0],
        setSSRState = _useState2[1];

    (0,react.useEffect)(function () {
      // Only updating state to `mounted` if we are using SSR.
      // This makes it so we don't have an unnecessary re-render when opting out of SSR.
      setSSRState(function (state) {
        return state ? 'mounted' : false;
      });
    }, []);
    return /*#__PURE__*/react.createElement(Context.Provider, {
      value: {
        queryClient: queryClient,
        client: client,
        isPrepass: ssrState === 'prepass',
        ssrContext: ssrContext || null,
        ssrState: ssrState,
        fetchQuery: (0,react.useCallback)(function (pathAndInput, opts) {
          return queryClient.fetchQuery(pathAndInput, function () {
            var _ref;

            return (_ref = client).query.apply(_ref, _toConsumableArray(getClientArgs(pathAndInput, opts)));
          }, opts);
        }, [client, queryClient]),
        fetchInfiniteQuery: (0,react.useCallback)(function (pathAndInput, opts) {
          return queryClient.fetchInfiniteQuery(pathAndInput, function (_ref2) {
            var _ref3;

            var pageParam = _ref2.pageParam;

            var _pathAndInput2 = _slicedToArray(pathAndInput, 2),
                path = _pathAndInput2[0],
                input = _pathAndInput2[1];

            var actualInput = _objectSpread2(_objectSpread2({}, input), {}, {
              cursor: pageParam
            });

            return (_ref3 = client).query.apply(_ref3, _toConsumableArray(getClientArgs([path, actualInput], opts)));
          }, opts);
        }, [client, queryClient]),
        prefetchQuery: (0,react.useCallback)(function (pathAndInput, opts) {
          return queryClient.prefetchQuery(pathAndInput, function () {
            var _ref4;

            return (_ref4 = client).query.apply(_ref4, _toConsumableArray(getClientArgs(pathAndInput, opts)));
          }, opts);
        }, [client, queryClient]),
        prefetchInfiniteQuery: (0,react.useCallback)(function (pathAndInput, opts) {
          return queryClient.prefetchInfiniteQuery(pathAndInput, function (_ref5) {
            var _ref6;

            var pageParam = _ref5.pageParam;

            var _pathAndInput3 = _slicedToArray(pathAndInput, 2),
                path = _pathAndInput3[0],
                input = _pathAndInput3[1];

            var actualInput = _objectSpread2(_objectSpread2({}, input), {}, {
              cursor: pageParam
            });

            return (_ref6 = client).query.apply(_ref6, _toConsumableArray(getClientArgs([path, actualInput], opts)));
          }, opts);
        }, [client, queryClient]),

        /**
         * @deprecated use `invalidateQueries`
         */
        invalidateQuery: (0,react.useCallback)(function () {
          return queryClient.invalidateQueries.apply(queryClient, arguments);
        }, [queryClient]),
        invalidateQueries: (0,react.useCallback)(function () {
          return queryClient.invalidateQueries.apply(queryClient, arguments);
        }, [queryClient]),
        refetchQueries: (0,react.useCallback)(function () {
          return queryClient.refetchQueries.apply(queryClient, arguments);
        }, [queryClient]),
        cancelQuery: (0,react.useCallback)(function (pathAndInput) {
          return queryClient.cancelQueries(pathAndInput);
        }, [queryClient]),
        setQueryData: (0,react.useCallback)(function () {
          return queryClient.setQueryData.apply(queryClient, arguments);
        }, [queryClient]),
        getQueryData: (0,react.useCallback)(function () {
          return queryClient.getQueryData.apply(queryClient, arguments);
        }, [queryClient]),
        setInfiniteQueryData: (0,react.useCallback)(function () {
          return queryClient.setQueryData.apply(queryClient, arguments);
        }, [queryClient]),
        getInfiniteQueryData: (0,react.useCallback)(function () {
          return queryClient.getQueryData.apply(queryClient, arguments);
        }, [queryClient])
      }
    }, props.children);
  }

  function useContext() {
    return react.useContext(Context);
  }
  /**
   * Hack to make sure errors return `status`='error` when doing SSR
   * @link https://github.com/trpc/trpc/pull/1645
   */


  function useSSRQueryOptionsIfNeeded(pathAndInput, opts) {
    var _queryClient$getQuery;

    var _useContext = useContext(),
        queryClient = _useContext.queryClient,
        ssrState = _useContext.ssrState;

    return ssrState && ssrState !== 'mounted' && ((_queryClient$getQuery = queryClient.getQueryCache().find(pathAndInput)) === null || _queryClient$getQuery === void 0 ? void 0 : _queryClient$getQuery.state.status) === 'error' ? _objectSpread2({
      retryOnMount: false
    }, opts) : opts;
  }

  function useQuery$1(pathAndInput, opts) {
    var _useContext2 = useContext(),
        client = _useContext2.client,
        isPrepass = _useContext2.isPrepass,
        queryClient = _useContext2.queryClient,
        prefetchQuery = _useContext2.prefetchQuery;

    if (typeof window === 'undefined' && isPrepass && (opts === null || opts === void 0 ? void 0 : opts.ssr) !== false && (opts === null || opts === void 0 ? void 0 : opts.enabled) !== false && !queryClient.getQueryCache().find(pathAndInput)) {
      prefetchQuery(pathAndInput, opts);
    }

    var actualOpts = useSSRQueryOptionsIfNeeded(pathAndInput, opts);
    return (0,es.useQuery)(pathAndInput, function () {
      var _ref7;

      return (_ref7 = client).query.apply(_ref7, _toConsumableArray(getClientArgs(pathAndInput, actualOpts)));
    }, actualOpts);
  }

  function useMutation$1(path, opts) {
    var _useContext3 = useContext(),
        client = _useContext3.client;

    return (0,es.useMutation)(function (input) {
      var actualPath = Array.isArray(path) ? path[0] : path;
      return client.mutation(actualPath, input, opts);
    }, opts);
  }
  /* istanbul ignore next */

  /**
   * ⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️
   *  **Experimental.** API might change without major version bump
   * ⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠
   */


  function useSubscription(pathAndInput, opts) {
    var _opts$enabled;

    var enabled = (_opts$enabled = opts === null || opts === void 0 ? void 0 : opts.enabled) !== null && _opts$enabled !== void 0 ? _opts$enabled : true;
    var queryKey = (0,es.hashQueryKey)(pathAndInput);

    var _useContext4 = useContext(),
        client = _useContext4.client;

    return (0,react.useEffect)(function () {
      if (!enabled) {
        return;
      }

      var _pathAndInput4 = _slicedToArray(pathAndInput, 2),
          path = _pathAndInput4[0],
          input = _pathAndInput4[1];

      var isStopped = false;
      var unsub = client.subscription(path, input !== null && input !== void 0 ? input : undefined, {
        onError: function onError(err) {
          if (!isStopped) {
            var _opts$onError;

            (_opts$onError = opts.onError) === null || _opts$onError === void 0 ? void 0 : _opts$onError.call(opts, err);
          }
        },
        onNext: function onNext(res) {
          if (res.type === 'data' && !isStopped) {
            opts.onNext(res.data);
          }
        }
      });
      return function () {
        isStopped = true;
        unsub();
      }; // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [queryKey, enabled]);
  }

  function useInfiniteQuery$1(pathAndInput, opts) {
    var _pathAndInput5 = _slicedToArray(pathAndInput, 2),
        path = _pathAndInput5[0],
        input = _pathAndInput5[1];

    var _useContext5 = useContext(),
        client = _useContext5.client,
        isPrepass = _useContext5.isPrepass,
        prefetchInfiniteQuery = _useContext5.prefetchInfiniteQuery,
        queryClient = _useContext5.queryClient;

    if (typeof window === 'undefined' && isPrepass && (opts === null || opts === void 0 ? void 0 : opts.ssr) !== false && (opts === null || opts === void 0 ? void 0 : opts.enabled) !== false && !queryClient.getQueryCache().find(pathAndInput)) {
      prefetchInfiniteQuery(pathAndInput, opts);
    }

    var actualOpts = useSSRQueryOptionsIfNeeded(pathAndInput, opts);
    return (0,es.useInfiniteQuery)(pathAndInput, function (_ref8) {
      var _ref9, _ref10;

      var pageParam = _ref8.pageParam;

      var actualInput = _objectSpread2(_objectSpread2({}, (_ref9 = input) !== null && _ref9 !== void 0 ? _ref9 : {}), {}, {
        cursor: pageParam
      });

      return (_ref10 = client).query.apply(_ref10, _toConsumableArray(getClientArgs([path, actualInput], actualOpts)));
    }, actualOpts);
  }

  function useDehydratedState(client, trpcState) {
    var transformed = (0,react.useMemo)(function () {
      if (!trpcState) {
        return trpcState;
      }

      return client.runtime.transformer.deserialize(trpcState);
    }, [client, trpcState]);
    return transformed;
  }

  return {
    Provider: TRPCProvider,
    createClient: createClient,
    useContext: useContext,
    useQuery: useQuery$1,
    useMutation: useMutation$1,
    useSubscription: useSubscription,
    useDehydratedState: useDehydratedState,
    useInfiniteQuery: useInfiniteQuery$1
  };
}



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-api-dato-client-virtual-fc2b9374fc/1/packages/lib-api-dato-client/src/base.ts

const base_trpc = createReactQueryHooks();

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-api-dato-client-virtual-fc2b9374fc/1/packages/lib-api-dato-client/src/use-page-by-slug.ts
/* eslint-disable @typescript-eslint/explicit-function-return-type */ 


// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const usePageBySlug = (param)=>{
    let { slug , secret , initialData , parentPage =true  } = param;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return base_trpc.useQuery([
        "getPageBySlug",
        {
            slug,
            secret,
            parentPage
        }
    ], {
        initialData: initialData !== null && initialData !== void 0 ? initialData : undefined
    });
};
const getPageBySlug = function(_url, secret) {
    let parentPage = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true, props = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : undefined;
    return (slug)=>{
        const fullurl = (0,src/* getBykoConfig */.Hp)("CMS_API_URL");
        var ref;
        return ((ref = props === null || props === void 0 ? void 0 : props.trpcClient) !== null && ref !== void 0 ? ref : base_trpc.createClient({
            links: [
                trpc_client_links_httpLink_esm_httpLink({
                    url: fullurl
                })
            ]
        })).query("getPageBySlug", {
            slug,
            secret,
            parentPage
        });
    };
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-api-dato-client-virtual-fc2b9374fc/1/packages/lib-api-dato-client/src/use-frontpage.ts



// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const useFrontpage = (param)=>{
    let { secret , initialData , forPro  } = param;
    return base_trpc.useQuery([
        "getFrontpage",
        {
            secret,
            forPro: forPro !== null && forPro !== void 0 ? forPro : undefined
        }
    ], {
        initialData,
        refetchOnWindowFocus: false
    });
};
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const useFrontpageBySlug = (param)=>{
    let { secret , initialData , slug  } = param;
    return base_trpc.useQuery([
        "getFrontpageBySlug",
        {
            secret,
            slug
        }
    ], {
        initialData,
        refetchOnWindowFocus: false
    });
};
const getFrontpage = function(_url, secret, forPro) {
    let props = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : undefined;
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    return ()=>{
        const fullurl = (0,src/* getBykoConfig */.Hp)("CMS_API_URL");
        var ref;
        return ((ref = props === null || props === void 0 ? void 0 : props.trpcClient) !== null && ref !== void 0 ? ref : base_trpc.createClient({
            links: [
                trpc_client_links_httpLink_esm_httpLink({
                    url: fullurl
                })
            ]
        })).query("getFrontpage", {
            secret,
            forPro: forPro !== null && forPro !== void 0 ? forPro : undefined
        });
    };
};
const getFrontpageBySlug = function(_url, slug, secret) {
    let props = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : undefined;
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    return ()=>{
        const fullurl = getBykoConfig("CMS_API_URL");
        var ref;
        return ((ref = props === null || props === void 0 ? void 0 : props.trpcClient) !== null && ref !== void 0 ? ref : trpc.createClient({
            links: [
                httpLink({
                    url: fullurl
                })
            ]
        })).query("getFrontpageBySlug", {
            secret,
            slug
        });
    };
};

// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(61261);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/react-ssr-prepass-virtual-faa5e9bd4f/0/cache/react-ssr-prepass-npm-1.5.0-c07b4142ee-efe89b9f8b.zip/node_modules/react-ssr-prepass/dist/react-ssr-prepass.es.js


function _extends() {
  _extends = Object.assign || function(e) {
    for (var r = 1; r < arguments.length; r++) {
      var t = arguments[r];
      for (var n in t) {
        if (Object.prototype.hasOwnProperty.call(t, n)) {
          e[n] = t[n];
        }
      }
    }
    return e;
  };
  return _extends.apply(this, arguments);
}

var n = 60103;

var u = 60106;

var o = 60107;

var a = 60108;

var i = 60114;

var c = 60109;

var l = 60110;

var f = 60111;

var s = 60112;

var v = 60113;

var p = 60115;

var d = 60116;

if ("function" == typeof Symbol && Symbol.for) {
  var m = Symbol.for;
  n = m("react.element");
  u = m("react.portal");
  o = m("react.fragment");
  a = m("react.strict_mode");
  i = m("react.profiler");
  c = m("react.provider");
  l = m("react.context");
  f = Symbol.for("react.concurrent_mode");
  s = m("react.forward_ref");
  v = m("react.suspense");
  p = m("react.memo");
  d = m("react.lazy");
}

var h = n;

var y = u;

var _ = o;

var S = a;

var x = i;

var b = c;

var M = l;

var g = f;

var k = s;

var w = v;

var F = p;

var I = d;

var q = react.Children.toArray;

var isAbstractElement = function(e) {
  return null !== e && "object" == typeof e;
};

var getChildrenArray = function(e) {
  return q(e).filter(isAbstractElement);
};

var computeProps = function(e, r) {
  return "object" == typeof r ? _extends({}, r, e) : e;
};

var E = new Map;

var C = {};

var D = void 0;

var P = void 0;

var getCurrentContextMap = function() {
  return _extends({}, C);
};

var getCurrentContextStore = function() {
  return new Map(E);
};

var flushPrevContextMap = function() {
  var e = D;
  D = void 0;
  return e;
};

var flushPrevContextStore = function() {
  var e = P;
  P = void 0;
  return e;
};

var restoreContextMap = function(e) {
  if (void 0 !== e) {
    _extends(C, e);
  }
};

var restoreContextStore = function(e) {
  if (void 0 !== e) {
    E.set(e[0], e[1]);
  }
};

var setCurrentContextMap = function(e) {
  D = void 0;
  C = e;
};

var setCurrentContextStore = function(e) {
  P = void 0;
  E = e;
};

var readContextValue = function(e) {
  var r = E.get(e);
  if (void 0 !== r) {
    return r;
  }
  return e._currentValue;
};

var R = {};

var maskContext = function(e) {
  var r = e.contextType;
  var t = e.contextTypes;
  if (r) {
    return readContextValue(r);
  } else if (!t) {
    return R;
  }
  var n = {};
  for (var u in t) {
    n[u] = C[u];
  }
  return n;
};

var z = null;

var getCurrentErrorFrame = function() {
  return z;
};

var setCurrentErrorFrame = function(e) {
  z = e || null;
};

var O = {
  current: {
    uniqueID: 0
  }
};

var W = "function" == typeof Object.is ? Object.is : function is(e, r) {
  return e === r && (0 !== e || 1 / e == 1 / r) || e != e && r != r;
};

var j = null;

var setCurrentIdentity = function(e) {
  j = e;
};

var getCurrentIdentity = function() {
  if (null === j) {
    throw new Error("[react-ssr-prepass] Hooks can only be called inside the body of a function component. (https://fb.me/react-invalid-hook-call)");
  }
  return j;
};

var H = null;

var T = null;

var U = !1;

var $ = null;

var A = 0;

var setFirstHook = function(e) {
  H = e;
};

function createWorkInProgressHook() {
  if (null === T) {
    if (null === H) {
      return H = T = {
        memoizedState: null,
        queue: null,
        next: null
      };
    } else {
      return T = H;
    }
  } else if (null === T.next) {
    return T = T.next = {
      memoizedState: null,
      queue: null,
      next: null
    };
  } else {
    return T = T.next;
  }
}

function basicStateReducer(e, r) {
  return "function" == typeof r ? r(e) : r;
}

function useReducer(e, r, t) {
  var n = getCurrentIdentity();
  if (null === (T = createWorkInProgressHook()).queue) {
    var u;
    if (e === basicStateReducer) {
      u = "function" == typeof r ? r() : r;
    } else {
      u = void 0 !== t ? t(r) : r;
    }
    T.memoizedState = u;
  }
  var o = T.queue || (T.queue = {
    last: null,
    dispatch: null
  });
  var a = o.dispatch || (o.dispatch = dispatchAction.bind(null, n, o));
  if (null !== $) {
    var i = $.get(o);
    if (void 0 !== i) {
      $.delete(o);
      var c = T.memoizedState;
      var l = i;
      do {
        c = e(c, l.action);
        l = l.next;
      } while (null !== l);
      T.memoizedState = c;
    }
  }
  return [ T.memoizedState, a ];
}

function useMemo(e, r) {
  getCurrentIdentity();
  var t = void 0 === r ? null : r;
  var n = (T = createWorkInProgressHook()).memoizedState;
  if (null !== n && null !== t) {
    if (function areHookInputsEqual(e, r) {
      if (null === r) {
        return !1;
      }
      for (var t = 0; t < r.length && t < e.length; t++) {
        if (!W(e[t], r[t])) {
          return !1;
        }
      }
      return !0;
    }(t, n[1])) {
      return n[0];
    }
  }
  var u = e();
  T.memoizedState = [ u, t ];
  return u;
}

function useOpaqueIdentifier() {
  getCurrentIdentity();
  if (!(T = createWorkInProgressHook()).memoizedState) {
    T.memoizedState = "R:" + (O.current.uniqueID++).toString(36);
  }
  return T.memoizedState;
}

function dispatchAction(e, r, t) {
  if (e === j) {
    U = !0;
    var n = {
      action: t,
      next: null
    };
    if (null === $) {
      $ = new Map;
    }
    var u = $.get(r);
    if (void 0 === u) {
      $.set(r, n);
    } else {
      var o = u;
      while (null !== o.next) {
        o = o.next;
      }
      o.next = n;
    }
  }
}

function noop() {}

function _ref$2(e) {
  e();
}

var N = {
  readContext: function readContext(e, r) {
    return readContextValue(e);
  },
  useSyncExternalStore: function useSyncExternalStore(e, r, t) {
    return r();
  },
  useContext: function useContext(e, r) {
    getCurrentIdentity();
    return readContextValue(e);
  },
  useMemo: useMemo,
  useReducer: useReducer,
  useRef: function useRef(e) {
    getCurrentIdentity();
    var r = (T = createWorkInProgressHook()).memoizedState;
    if (null === r) {
      var t = {
        current: e
      };
      T.memoizedState = t;
      return t;
    } else {
      return r;
    }
  },
  useState: function useState(e) {
    return useReducer(basicStateReducer, e);
  },
  useCallback: function useCallback(e, r) {
    return useMemo((function() {
      return e;
    }), r);
  },
  useMutableSource: function useMutableSource(e, r, t) {
    getCurrentIdentity();
    return r(e._source);
  },
  useTransition: function useTransition() {
    return [ _ref$2, !1 ];
  },
  useDeferredValue: function useDeferredValue(e) {
    return e;
  },
  useOpaqueIdentifier: useOpaqueIdentifier,
  useId: useOpaqueIdentifier,
  unstable_useId: useOpaqueIdentifier,
  unstable_useOpaqueIdentifier: useOpaqueIdentifier,
  useLayoutEffect: noop,
  useImperativeHandle: noop,
  useEffect: noop,
  useDebugValue: noop
};

var resolve = function(e) {
  var r = e._payload || e;
  if (0 === r._status) {
    return r._result;
  } else if (1 === r._status) {
    return Promise.resolve(r._result);
  } else if (2 === r._status) {
    return Promise.reject(r._result);
  }
  r._status = 0;
  return r._result = (r._ctor || r._result)().then((function(e) {
    r._result = e;
    if ("function" == typeof e) {
      r._status = 1;
    } else if (null !== e && "object" == typeof e && "function" == typeof e.default) {
      r._result = e.default;
      r._status = 1;
    } else {
      r._status = 2;
    }
  })).catch((function(e) {
    r._status = 2;
    r._result = e;
    return Promise.reject(e);
  }));
};

var render$3 = function(e, r, n) {
  var u = e._payload || e;
  if (1 === u._status) {
    return (0,react.createElement)(u._result, r);
  }
  return null;
};

var makeFrame$1 = function(e, r, t) {
  return {
    contextMap: getCurrentContextMap(),
    contextStore: getCurrentContextStore(),
    id: getCurrentIdentity(),
    hook: H,
    kind: "frame.hooks",
    errorFrame: getCurrentErrorFrame(),
    thenable: t,
    props: r,
    type: e
  };
};

var render$2 = function(e, r, t) {
  try {
    return function renderWithHooks(e, r, t) {
      T = null;
      var n = e(r, t);
      while (A < 25 && U) {
        U = !1;
        A += 1;
        T = null;
        n = e(r, t);
      }
      A = 0;
      $ = null;
      T = null;
      return n;
    }(e, computeProps(r, e.defaultProps), maskContext(e));
  } catch (n) {
    if ("function" != typeof n.then) {
      throw n;
    }
    t.push(makeFrame$1(e, r, n));
    return null;
  }
};

function _ref$1() {
  return !1;
}

function _ref2() {
  return null;
}

var createInstance = function(e, r) {
  var t = {
    _thrown: 0,
    queue: n = [],
    isMounted: _ref$1,
    enqueueForceUpdate: _ref2,
    enqueueReplaceState: function(e, r) {
      if (e._isMounted) {
        n.length = 0;
        n.push(r);
      }
    },
    enqueueSetState: function(e, r) {
      if (e._isMounted) {
        n.push(r);
      }
    }
  };
  var n;
  var u = computeProps(r, e.defaultProps);
  var o = maskContext(e);
  var a = new e(u, o, t);
  a.props = u;
  a.context = o;
  a.updater = t;
  a._isMounted = !0;
  if (void 0 === a.state) {
    a.state = null;
  }
  if ("function" == typeof a.componentDidCatch || "function" == typeof e.getDerivedStateFromError) {
    var i = makeFrame(e, a, null);
    i.errorFrame = i;
    setCurrentErrorFrame(i);
  }
  if ("function" == typeof e.getDerivedStateFromProps) {
    var c = (0, e.getDerivedStateFromProps)(a.props, a.state);
    if (null != c) {
      a.state = _extends({}, a.state, c);
    }
  } else if ("function" == typeof a.componentWillMount) {
    a.componentWillMount();
  } else if ("function" == typeof a.UNSAFE_componentWillMount) {
    a.UNSAFE_componentWillMount();
  }
  return a;
};

var makeFrame = function(e, r, t) {
  return {
    contextMap: getCurrentContextMap(),
    contextStore: getCurrentContextStore(),
    errorFrame: getCurrentErrorFrame(),
    thenable: t,
    kind: "frame.class",
    error: null,
    instance: r,
    type: e
  };
};

var render$1 = function(e, r, t) {
  !function(e) {
    var r = e.updater.queue;
    if (r.length > 0) {
      var t = _extends({}, e.state);
      for (var n = 0, u = r.length; n < u; n++) {
        var o = r[n];
        var a = "function" == typeof o ? o.call(e, t, e.props, e.context) : o;
        if (null !== a) {
          _extends(t, a);
        }
      }
      e.state = t;
      r.length = 0;
    }
  }(r);
  var n = null;
  try {
    n = r.render();
  } catch (n) {
    if ("function" != typeof n.then) {
      throw n;
    }
    t.push(makeFrame(e, r, n));
    return null;
  }
  if (void 0 !== e.childContextTypes && "function" == typeof r.getChildContext) {
    var u = r.getChildContext();
    if (null !== u && "object" == typeof u) {
      !function(e) {
        D = {};
        for (var r in e) {
          D[r] = C[r];
          C[r] = e[r];
        }
      }(u);
    }
  }
  if ("function" != typeof r.getDerivedStateFromProps && ("function" == typeof r.componentWillMount || "function" == typeof r.UNSAFE_componentWillMount) && "function" == typeof r.componentWillUnmount) {
    try {
      r.componentWillUnmount();
    } catch (e) {}
  }
  r._isMounted = !1;
  return n;
};

var L = react.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentDispatcher;

var V = "function" == typeof setImmediate;

var render = function(e, r, t, n, u) {
  return (o = e).prototype && o.prototype.isReactComponent ? function(e, r, t, n, u) {
    setCurrentIdentity(null);
    var o = createInstance(e, r);
    var a = n(u, o);
    if (a) {
      t.push(makeFrame(e, o, a));
      return null;
    }
    return render$1(e, o, t);
  }(e, r, t, n, u) : function(e, r, t, n, u) {
    setFirstHook(null);
    setCurrentIdentity({});
    var o = n(u);
    if (o) {
      t.push(makeFrame$1(e, r, o));
      return null;
    }
    return render$2(e, r, t);
  }(e, r, t, n, u);
  var o;
};

var visitElement = function(e, r, n) {
  switch (function(e) {
    switch (e.$$typeof) {
     case y:
      return y;

     case h:
      switch (e.type) {
       case g:
        return g;

       case _:
        return _;

       case x:
        return x;

       case S:
        return S;

       case w:
        return w;

       default:
        switch (e.type && e.type.$$typeof) {
         case I:
          return I;

         case F:
          return F;

         case M:
          return M;

         case b:
          return b;

         case k:
          return k;

         default:
          return h;
        }
      }

     default:
      return;
    }
  }(e)) {
   case w:
   case S:
   case g:
   case x:
   case _:
    return getChildrenArray(e.props.children);

   case b:
    var u = e.props;
    var o = u.children;
    !function(e, r) {
      P = [ e, E.get(e) ];
      E.set(e, r);
    }(e.type._context, u.value);
    return getChildrenArray(o);

   case M:
    var a = e.props.children;
    if ("function" == typeof a) {
      var i = e.type;
      var c = readContextValue("object" == typeof i._context ? i._context : i);
      return getChildrenArray(a(c));
    } else {
      return [];
    }

   case I:
    var l = function(e, r, t) {
      if ((e._payload || e)._status <= 0) {
        t.push({
          kind: "frame.lazy",
          contextMap: getCurrentContextMap(),
          contextStore: getCurrentContextStore(),
          errorFrame: getCurrentErrorFrame(),
          thenable: resolve(e),
          props: r,
          type: e
        });
        return null;
      }
      return render$3(e, r);
    }(e.type, e.props, r);
    return getChildrenArray(l);

   case F:
    var f = (0,react.createElement)(e.type.type, e.props);
    return getChildrenArray(f);

   case k:
    var s = e.type;
    var v = s.render;
    var p = computeProps(e.props, s.defaultProps);
    var d = (0,react.createElement)(v, p);
    return getChildrenArray(d);

   case h:
    if ("string" == typeof e.type) {
      return getChildrenArray(e.props.children);
    } else {
      var m = render(e.type, e.props, r, n, e);
      return getChildrenArray(m);
    }

   default:
    return [];
  }
};

var visitLoop = function(e, r, t, n, u, o) {
  var a = L.current;
  var i = Date.now();
  try {
    L.current = N;
    while (e.length > 0) {
      var c = e[e.length - 1].shift();
      if (void 0 !== c) {
        var l = visitElement(c, u, o);
        e.push(l);
        r.push(flushPrevContextMap());
        t.push(flushPrevContextStore());
        n.push(getCurrentErrorFrame());
      } else {
        e.pop();
        restoreContextMap(r.pop());
        restoreContextStore(t.pop());
        setCurrentErrorFrame(n.pop());
      }
      if (V && Date.now() - i > 5) {
        return !0;
      }
    }
    return !1;
  } catch (e) {
    var f = getCurrentErrorFrame();
    if (!f) {
      throw e;
    }
    f.error = e;
    u.unshift(f);
    return !1;
  } finally {
    L.current = a;
  }
};

var makeYieldFrame = function(e, r, t, n) {
  return {
    contextMap: getCurrentContextMap(),
    contextStore: getCurrentContextStore(),
    errorFrame: getCurrentErrorFrame(),
    thenable: null,
    kind: "frame.yield",
    traversalChildren: e,
    traversalMap: r,
    traversalStore: t,
    traversalErrorFrame: n
  };
};

var visit = function(e, r, t) {
  var n = [ e ];
  var u = [ flushPrevContextMap() ];
  var o = [ flushPrevContextStore() ];
  var a = [ getCurrentErrorFrame() ];
  if (visitLoop(n, u, o, a, r, t)) {
    r.unshift(makeYieldFrame(n, u, o, a));
  }
};

var update = function(e, r, t) {
  if ("frame.yield" === e.kind) {
    setCurrentIdentity(null);
    setCurrentContextMap(e.contextMap);
    setCurrentContextStore(e.contextStore);
    setCurrentErrorFrame(e.errorFrame);
    if (visitLoop(e.traversalChildren, e.traversalMap, e.traversalStore, e.traversalErrorFrame, r, t)) {
      r.unshift(makeYieldFrame(e.traversalChildren, e.traversalMap, e.traversalStore, e.traversalErrorFrame));
    }
  } else {
    var n = L.current;
    var u = null;
    L.current = N;
    try {
      if ("frame.class" === e.kind) {
        u = function(e, r) {
          setCurrentIdentity(null);
          setCurrentContextMap(r.contextMap);
          setCurrentContextStore(r.contextStore);
          setCurrentErrorFrame(r.errorFrame);
          if (r.error) {
            if (++r.instance.updater._thrown >= 25) {
              return null;
            }
            r.instance._isMounted = !0;
            if ("function" == typeof r.instance.componentDidCatch) {
              r.instance.componentDidCatch(r.error);
            }
            if ("function" == typeof r.type.getDerivedStateFromError) {
              r.instance.updater.enqueueSetState(r.instance, r.type.getDerivedStateFromError(r.error));
            }
          }
          return render$1(r.type, r.instance, e);
        }(r, e);
      } else if ("frame.hooks" === e.kind) {
        u = function(e, r) {
          setFirstHook(r.hook);
          setCurrentIdentity(r.id);
          setCurrentContextMap(r.contextMap);
          setCurrentContextStore(r.contextStore);
          setCurrentErrorFrame(r.errorFrame);
          return render$2(r.type, r.props, e);
        }(r, e);
      } else if ("frame.lazy" === e.kind) {
        u = function(e, r) {
          setCurrentIdentity(null);
          setCurrentContextMap(r.contextMap);
          setCurrentContextStore(r.contextStore);
          setCurrentErrorFrame(r.errorFrame);
          return render$3(r.type, r.props);
        }(0, e);
      }
    } catch (e) {
      var o = getCurrentErrorFrame();
      if (!o) {
        throw e;
      }
      o.error = e;
      r.unshift(o);
      u = null;
    } finally {
      L.current = n;
    }
    visit(getChildrenArray(u), r, t);
  }
};

function _ref(e, r) {
  setImmediate(e);
}

var flushFrames = function(e, r, t) {
  var n = e.shift();
  if (!n) {
    return Promise.resolve();
  }
  if (V && "frame.yield" === n.kind) {
    n.thenable = new Promise(_ref);
  }
  return Promise.resolve(n.thenable).then((function() {
    !function(e) {
      O.current = e;
    }(t);
    update(n, e, r);
    return flushFrames(e, r, t);
  }), (function(t) {
    if (!n.errorFrame) {
      throw t;
    }
    n.errorFrame.error = t;
    update(n.errorFrame, e, r);
  }));
};

var defaultVisitor = function() {
  return;
};

var renderPrepass = function(e, r) {
  if (!r) {
    r = defaultVisitor;
  }
  var t = [];
  var n = O.current = {
    uniqueID: 0
  };
  setCurrentContextMap({});
  setCurrentContextStore(new Map);
  setCurrentErrorFrame(null);
  try {
    visit(getChildrenArray(e), t, r);
  } catch (e) {
    return Promise.reject(e);
  }
  return flushFrames(t, r, n);
};


//# sourceMappingURL=react-ssr-prepass.es.js.map

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-api-dato-client-virtual-fc2b9374fc/1/packages/lib-api-dato-client/src/get-config.ts

function getConfig() {
    // This is used by some crazy code that I'm not even going to touch
    // FIXME: Leaving this here for now, but slightly altered
    const values = {
        ENV: (0,src/* getBykoConfig */.Hp)("ENV"),
        SALEOR_GQL_URL: (0,src/* getBykoConfig */.Hp)("SALEOR_GQL_URL"),
        SALEOR_BASE_HOST: (0,src/* getBykoConfig */.Hp)("SALEOR_BASE_HOST"),
        CMS_API_URL: (0,src/* getBykoConfig */.Hp)("CMS_API_URL"),
        IMAGES_API_URL: (0,src/* getBykoConfig */.Hp)("IMAGES_API_URL"),
        SITEIMPROV_KEY: (0,src/* getBykoConfig */.Hp)("SITEIMPROV_KEY"),
        KLAVIYO_PUBLIC_API_KEY: (0,src/* getBykoConfig */.Hp)("KLAVIYO_PUBLIC_API_KEY"),
        BASE_URL: (0,src/* getBykoConfig */.Hp)("BASE_URL")
    };
    const missingKeys = Object.entries(values).filter((param)=>{
        let [, value] = param;
        return !value;
    }).map((param)=>{
        let [key] = param;
        return key;
    });
    if (missingKeys.length) {
        missingKeys.forEach((key)=>{
            console.error("Missing env variable: ".concat(key));
        });
    }
    return values;
}

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-api-dato-client-virtual-fc2b9374fc/1/packages/lib-api-dato-client/src/with-trpc.tsx
/* eslint-disable @typescript-eslint/no-shadow */ /* eslint-disable @typescript-eslint/explicit-function-return-type */ /* eslint-disable @typescript-eslint/no-explicit-any */ /**
 * Heavily based on urql's ssr
 * https://github.com/FormidableLabs/urql/blob/main/packages/next-urql/src/with-urql-client.ts
 */ 





const transformQueryOrMutationCacheErrors = (result)=>{
    const error = result.state.error;
    if (error instanceof Error && error.name === "TRPCClientError") {
        const newError = {
            message: error.message,
            data: error.data,
            shape: error.shape
        };
        return {
            ...result,
            state: {
                ...result.state,
                error: newError
            }
        };
    }
    return result;
};
const withTRPC = (opts)=>{
    const { config: getClientConfig  } = opts;
    return (AppOrPage)=>{
        const trpc = createReactQueryHooks();
        const WithTRPC = (props)=>{
            var ref;
            const [{ queryClient , trpcClient , ssrState , ssrContext  }] = (0,react.useState)(()=>{
                if (props.trpc) {
                    return props.trpc;
                }
                const config = getClientConfig({});
                const queryClient = new es.QueryClient(config.queryClientConfig);
                const trpcClient = trpc.createClient(config);
                return {
                    queryClient,
                    trpcClient,
                    ssrState: opts.ssr ? "mounting" : false,
                    ssrContext: null
                };
            });
            const hydratedState = trpc.useDehydratedState(trpcClient, (ref = props.pageProps) === null || ref === void 0 ? void 0 : ref.trpcState);
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(trpc.Provider, {
                client: trpcClient,
                queryClient: queryClient,
                ssrContext: ssrContext,
                ssrState: ssrState,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es.QueryClientProvider, {
                    client: queryClient,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es.Hydrate, {
                        state: hydratedState,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AppOrPage, {
                            ...props
                        })
                    })
                })
            });
        };
        if (AppOrPage.getInitialProps || opts.ssr) {
            WithTRPC.getInitialProps = async (appOrPageCtx)=>{
                var ref;
                const AppTree = appOrPageCtx.AppTree;
                // Determine if we are wrapping an App component or a Page component.
                const isApp = !!appOrPageCtx.Component;
                const ctx = isApp ? appOrPageCtx.ctx : appOrPageCtx;
                // Run the wrapped component's getInitialProps function.
                let pageProps = {};
                const bykoConfig = getConfig();
                if (AppOrPage.getInitialProps) {
                    const originalProps = await AppOrPage.getInitialProps({
                        ...appOrPageCtx,
                        config: bykoConfig
                    });
                    var ref1;
                    const originalPageProps = isApp ? appOrPageCtx.Component.getInitialProps ? appOrPageCtx.Component.getInitialProps({
                        ...originalProps,
                        ...appOrPageCtx
                    }) : (ref1 = {}) !== null && ref1 !== void 0 ? ref1 : {} : originalProps;
                    pageProps = {
                        ...originalPageProps,
                        ...pageProps
                    };
                }
                const getAppTreeProps = (props)=>isApp ? {
                        pageProps: props
                    } : props;
                if (true) {
                    return getAppTreeProps(pageProps);
                }
                const config = getClientConfig({
                    ctx
                });
                const trpcClient = createTRPCClient(config);
                const queryClient = new es.QueryClient(config.queryClientConfig);
                const trpcProp = {
                    config,
                    trpcClient,
                    queryClient,
                    ssrState: "prepass",
                    ssrContext: ctx
                };
                const prepassProps = {
                    pageProps,
                    trpc: trpcProp
                };
                // Run the prepass step on AppTree. This will run all trpc queries on the server.
                // multiple prepass ensures that we can do batching on the server
                while(true){
                    // render full tree
                    await renderPrepass(/*#__PURE__*/ (0,react.createElement)(AppTree, prepassProps));
                    if (!queryClient.isFetching()) {
                        break;
                    }
                    // wait until the query cache has settled it's promises
                    await new Promise((resolve)=>{
                        const unsub = queryClient.getQueryCache().subscribe((event)=>{
                            if ((event === null || event === void 0 ? void 0 : event.query.getObserversCount()) === 0) {
                                resolve();
                                unsub();
                            }
                        });
                    });
                }
                const dehydratedCache = (0,es.dehydrate)(queryClient, {
                    shouldDehydrateQuery: ()=>{
                        // makes sure errors are also dehydrated
                        return true;
                    }
                });
                // since error instances can't be serialized, let's make them into `TRPCClientErrorLike`-objects
                const dehydratedCacheWithErrors = {
                    ...dehydratedCache,
                    queries: dehydratedCache.queries.map(transformQueryOrMutationCacheErrors),
                    mutations: dehydratedCache.mutations.map(transformQueryOrMutationCacheErrors)
                };
                // dehydrate query client's state and add it to the props
                pageProps["trpcState"] = trpcClient.runtime.transformer.serialize(dehydratedCacheWithErrors);
                const appTreeProps = getAppTreeProps(pageProps);
                const meta = ((ref = opts.responseMeta) === null || ref === void 0 ? void 0 : ref.call(opts, {
                    ctx,
                    clientErrors: [
                        ...dehydratedCache.queries,
                        ...dehydratedCache.mutations
                    ].map((v)=>v.state.error).flatMap((err)=>err instanceof Error && err.name === "TRPCClientError" ? [
                            err
                        ] : [])
                })) || {};
                for (const [key, value] of Object.entries(meta.headers || {})){
                    if (typeof value === "string") {
                        var ref2;
                        (ref2 = ctx.res) === null || ref2 === void 0 ? void 0 : ref2.setHeader(key, value);
                    }
                }
                if (meta.status && ctx.res) {
                    ctx.res.statusCode = meta.status;
                }
                return appTreeProps;
            };
        }
        const displayName = AppOrPage.displayName || AppOrPage.name || "Component";
        WithTRPC.displayName = "withTRPC(".concat(displayName, ")");
        return WithTRPC;
    };
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-api-dato-client-virtual-fc2b9374fc/1/packages/lib-api-dato-client/src/with-dato.tsx



// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const withDato = ()=>{
    return withTRPC({
        config: ()=>{
            const fullUrl = (0,src/* getBykoConfig */.Hp)("CMS_API_URL");
            return {
                links: [
                    trpc_client_links_httpLink_esm_httpLink({
                        url: fullUrl
                    })
                ]
            };
        },
        /**
     * @link https://trpc.io/docs/ssr
     */ ssr: true,
        responseMeta: (param)=>{
            let { clientErrors  } = param;
            return {
                status: clientErrors.length ? 404 : 200
            };
        }
    });
};

// EXTERNAL MODULE: ../../.yarn/__virtual__/graphql-tag-virtual-0a79057ca9/0/cache/graphql-tag-npm-2.12.6-99a5a7f6de-b15162a3d6.zip/node_modules/graphql-tag/lib/index.js
var lib = __webpack_require__(86759);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-api-dato-client-virtual-fc2b9374fc/1/packages/lib-api-dato-client/src/gql.ts
/* eslint-disable @typescript-eslint/explicit-function-return-type */ function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    const data = _taggedTemplateLiteral([
        "\n  fragment ImageFileParts on FileField {\n    __typename\n    id\n    jpeg: url(imgixParams: { fm: jpg, q: 100 })\n    alt\n    blurhash\n    title\n    width\n    height\n    focalPoint {\n      x\n      y\n    }\n  }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _taggedTemplateLiteral([
        "\n  fragment TextblockModelContentFieldParts on TextblockModelContentField {\n    blocks\n    links\n    value\n  }\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = _taggedTemplateLiteral([
        "\n  fragment ActionButtonRecordParts on ActionButtonRecord {\n    __typename\n    id\n    link\n    text\n  }\n"
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = _taggedTemplateLiteral([
        "\n  fragment TextBlockParts on TextblockRecord {\n    icon\n    title\n    introtext\n    headingunderlinecolor\n    content {\n      ...TextblockModelContentFieldParts\n    }\n    actionbutton {\n      ...ActionButtonRecordParts\n    }\n  }\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject3 = function() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = _taggedTemplateLiteral([
        "\n  fragment DefaultHeaderParts on TopbannerdefaultblockRecord {\n    __typename\n    id\n    mirrorxaxis\n    mirroryaxis\n    images {\n      ...ImageFileParts\n    }\n    content {\n      ...TextBlockParts\n    }\n  }\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject4 = function() {
        return data;
    };
    return data;
}
function _templateObject5() {
    const data = _taggedTemplateLiteral([
        "\n  fragment TopbannerdefaultblockRecordParts on TopbannerdefaultblockRecord {\n    __typename\n    id\n    id\n    images {\n      ...ImageFileParts\n    }\n    content {\n      ...TextBlockParts\n    }\n    mirrorxaxis\n    mirroryaxis\n  }\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject5 = function() {
        return data;
    };
    return data;
}
function _templateObject6() {
    const data = _taggedTemplateLiteral([
        "\n  fragment IconbBlockRecordParts on IconblockRecord {\n    __typename\n    id\n    icon\n  }\n"
    ]);
    _templateObject6 = function() {
        return data;
    };
    return data;
}
function _templateObject7() {
    const data = _taggedTemplateLiteral([
        "\n  fragment SeoFieldParts on SeoField {\n    __typename\n    title\n    image {\n      ...ImageFileParts\n    }\n    description\n  }\n  ",
        "\n"
    ]);
    _templateObject7 = function() {
        return data;
    };
    return data;
}
function _templateObject8() {
    const data = _taggedTemplateLiteral([
        "\n  fragment AuthorblockRecorddParts on AuthorblockRecord {\n    __typename\n    id\n    author\n    date\n  }\n"
    ]);
    _templateObject8 = function() {
        return data;
    };
    return data;
}
function _templateObject9() {
    const data = _taggedTemplateLiteral([
        "\n  fragment ImageBlockParts on ImageblockRecord {\n    __typename\n    id\n    content {\n      ...ImageFileParts\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject9 = function() {
        return data;
    };
    return data;
}
function _templateObject10() {
    const data = _taggedTemplateLiteral([
        "\n  fragment Contentsection1RecordParts on Contentsection1Record {\n    __typename\n    id\n    image {\n      ...ImageBlockParts\n    }\n    mirrory\n    text {\n      ...TextBlockParts\n    }\n  }\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject10 = function() {
        return data;
    };
    return data;
}
function _templateObject11() {
    const data = _taggedTemplateLiteral([
        "\n  fragment Contentsection2RecordParts on Contentsection2Record {\n    __typename\n    id\n    images {\n      ...ImageBlockParts\n    }\n    primaryimage {\n      ...ImageBlockParts\n    }\n    text {\n      ...TextBlockParts\n    }\n  }\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject11 = function() {
        return data;
    };
    return data;
}
function _templateObject12() {
    const data = _taggedTemplateLiteral([
        "\n  fragment Contentsection3RecordParts on Contentsection3Record {\n    __typename\n    id\n    mirrory\n    images {\n      ...ImageBlockParts\n    }\n    text {\n      ...TextBlockParts\n    }\n  }\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject12 = function() {
        return data;
    };
    return data;
}
function _templateObject13() {
    const data = _taggedTemplateLiteral([
        "\n  fragment ActionButtonParts on ImageactionbuttonRecord {\n    __typename\n    id\n    url\n    content {\n      ...ImageFileParts\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject13 = function() {
        return data;
    };
    return data;
}
function _templateObject14() {
    const data = _taggedTemplateLiteral([
        "\n  fragment ImageBlockPartsWithTitle on ImageblockwithtitleRecord {\n    __typename\n    id\n    content {\n      ...ImageFileParts\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject14 = function() {
        return data;
    };
    return data;
}
function _templateObject15() {
    const data = _taggedTemplateLiteral([
        "\n  fragment BulletContainerblockParts on BulletcontainerblockRecord {\n    id\n    __typename\n    intro {\n      ...TextBlockParts\n    }\n    title\n    content {\n      text\n      id\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject15 = function() {
        return data;
    };
    return data;
}
function _templateObject16() {
    const data = _taggedTemplateLiteral([
        "\n  fragment Contentsection4RecordParts on Contentsection4Record {\n    __typename\n    id\n    mirrory\n    images {\n      ... on ImageactionbuttonRecord {\n        ...ActionButtonParts\n      }\n      ... on ImageblockwithtitleRecord {\n        ...ImageBlockPartsWithTitle\n      }\n    }\n    primaryimages {\n      ...ImageBlockParts\n    }\n    bullettext {\n      ...BulletContainerblockParts\n    }\n  }\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject16 = function() {
        return data;
    };
    return data;
}
function _templateObject17() {
    const data = _taggedTemplateLiteral([
        "\n  fragment ListitemblockModelTextFieldParts on ListitemblockModelTextField {\n    blocks\n    links\n    value\n  }\n"
    ]);
    _templateObject17 = function() {
        return data;
    };
    return data;
}
function _templateObject18() {
    const data = _taggedTemplateLiteral([
        "\n  fragment ListitemblockRecordParts on ListitemblockRecord {\n    __typename\n    id\n    icon\n    mirrorx\n    text {\n      ...ListitemblockModelTextFieldParts\n    }\n    title\n  }\n  ",
        "\n"
    ]);
    _templateObject18 = function() {
        return data;
    };
    return data;
}
function _templateObject19() {
    const data = _taggedTemplateLiteral([
        "\n  fragment ListcontainerblockRecordParts on ListcontainerblockRecord {\n    __typename\n    id\n    content {\n      ...ListitemblockRecordParts\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject19 = function() {
        return data;
    };
    return data;
}
function _templateObject20() {
    const data = _taggedTemplateLiteral([
        "\n  fragment Contentsection5RecordParts on Contentsection5Record {\n    __typename\n    id\n    mirrory\n    primaryimage {\n      ...ImageBlockParts\n    }\n    content {\n      ...ListcontainerblockRecordParts\n    }\n    text {\n      ...TextBlockParts\n    }\n  }\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject20 = function() {
        return data;
    };
    return data;
}
function _templateObject21() {
    const data = _taggedTemplateLiteral([
        "\n  fragment Contentsection6RecordParts on Contentsection6Record {\n    __typename\n    id\n    mirrorx\n    image {\n      ...ImageBlockParts\n    }\n    text {\n      ...TextBlockParts\n    }\n  }\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject21 = function() {
        return data;
    };
    return data;
}
function _templateObject22() {
    const data = _taggedTemplateLiteral([
        "\n  fragment Contentsection7RecordParts on Contentsection7Record {\n    __typename\n    id\n    primaryimages {\n      ...ImageBlockParts\n    }\n    images {\n      ...ActionButtonParts\n    }\n    text {\n      ...TextBlockParts\n    }\n    mirrory\n  }\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject22 = function() {
        return data;
    };
    return data;
}
function _templateObject23() {
    const data = _taggedTemplateLiteral([
        "\n  fragment Contentsection8RecordParts on Contentsection8Record {\n    __typename\n    id\n    mirrory\n    images {\n      ...ImageBlockPartsWithTitle\n    }\n    primaryimages {\n      ...ImageBlockParts\n    }\n    text {\n      ...TextBlockParts\n    }\n  }\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject23 = function() {
        return data;
    };
    return data;
}
function _templateObject24() {
    const data = _taggedTemplateLiteral([
        "\n  fragment Contentsection9RecordParts on Contentsection9Record {\n    __typename\n    id\n    primaryimages {\n      ...ImageBlockParts\n    }\n    images {\n      ...ActionButtonParts\n    }\n    text {\n      ...TextBlockParts\n    }\n    mirrory\n  }\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject24 = function() {
        return data;
    };
    return data;
}
function _templateObject25() {
    const data = _taggedTemplateLiteral([
        "\n  fragment ContentsectionFilesParts on FiledownloadsectionRecord {\n    __typename\n    id\n    fileDownloadTab {\n      __typename\n      id\n      title\n      icon {\n        ...IconbBlockRecordParts\n      }\n      files {\n        __typename\n        id\n        filename\n        mimeType\n        title\n        url\n      }\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject25 = function() {
        return data;
    };
    return data;
}
function _templateObject26() {
    const data = _taggedTemplateLiteral([
        "\n  fragment ContentsectionProductSliderParts on ProductslidersectionRecord {\n    __typename\n    id\n    paragraph {\n      blocks\n      links\n      value\n    }\n    heading\n    headingUnderlineColor\n    products {\n      id\n      saleorProducts {\n        saleorProduct\n        id\n      }\n    }\n  }\n"
    ]);
    _templateObject26 = function() {
        return data;
    };
    return data;
}
function _templateObject27() {
    const data = _taggedTemplateLiteral([
        "\n  fragment ImageTilesBlockRecordParts on ImageTilesBlockRecord {\n    __typename\n    id\n    image {\n      ...ImageBlockParts\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject27 = function() {
        return data;
    };
    return data;
}
function _templateObject28() {
    const data = _taggedTemplateLiteral([
        "\n  fragment HtmlBlockRecordParts on HtmlBlockRecord {\n    __typename\n    id\n    html\n  }\n"
    ]);
    _templateObject28 = function() {
        return data;
    };
    return data;
}
function _templateObject29() {
    const data = _taggedTemplateLiteral([
        "\n  fragment PhotoGalleryBlockRecordParts on PhotoGalleryBlockRecord {\n    __typename\n    id\n    image {\n      ...ImageBlockParts\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject29 = function() {
        return data;
    };
    return data;
}
function _templateObject30() {
    const data = _taggedTemplateLiteral([
        "\n  fragment PageParts on PageRecord {\n    __typename\n    id\n    parentpage\n    parentPage {\n      id\n    }\n    title\n    slug\n    top {\n      ... on TopbannerdefaultblockRecord {\n        ...TopbannerdefaultblockRecordParts\n      }\n    }\n    tags {\n      ...IconbBlockRecordParts\n    }\n    seo {\n      ...SeoFieldParts\n    }\n    author {\n      ...AuthorblockRecorddParts\n    }\n    content {\n      ... on Contentsection1Record {\n        ...Contentsection1RecordParts\n      }\n      ... on Contentsection2Record {\n        ...Contentsection2RecordParts\n      }\n      ... on Contentsection3Record {\n        ...Contentsection3RecordParts\n      }\n      ... on Contentsection4Record {\n        ...Contentsection4RecordParts\n      }\n      ... on Contentsection5Record {\n        ...Contentsection5RecordParts\n      }\n      ... on Contentsection6Record {\n        ...Contentsection6RecordParts\n      }\n      ... on Contentsection7Record {\n        ...Contentsection7RecordParts\n      }\n      ... on Contentsection8Record {\n        ...Contentsection8RecordParts\n      }\n      ... on Contentsection9Record {\n        ...Contentsection9RecordParts\n      }\n      ... on FiledownloadsectionRecord {\n        ...ContentsectionFilesParts\n      }\n      ... on ProductslidersectionRecord {\n        ...ContentsectionProductSliderParts\n      }\n      ... on ImageTilesBlockRecord {\n        ...ImageTilesBlockRecordParts\n      }\n      ... on PhotoGalleryBlockRecord {\n        ...PhotoGalleryBlockRecordParts\n      }\n      ... on SimplybookmeBlockRecord {\n        __typename\n        id\n      }\n      ... on HtmlBlockRecord {\n        __typename\n        id\n        html\n      }\n    }\n  }\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject30 = function() {
        return data;
    };
    return data;
}
function _templateObject31() {
    const data = _taggedTemplateLiteral([
        "\n  fragment FrontPageHeaderParts on TopBannerFrontPageRecord {\n    __typename\n    id\n    title\n    image {\n      ...ImageFileParts\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject31 = function() {
        return data;
    };
    return data;
}
function _templateObject32() {
    const data = _taggedTemplateLiteral([
        "\n  fragment FrontpageParts on FrontpageRecord {\n    __typename\n    id\n    top {\n      ...FrontPageHeaderParts\n    }\n    seo {\n      ...SeoFieldParts\n    }\n    content {\n      ... on Contentsection1Record {\n        ...Contentsection1RecordParts\n      }\n      ... on Contentsection2Record {\n        ...Contentsection2RecordParts\n      }\n      ... on Contentsection3Record {\n        ...Contentsection3RecordParts\n      }\n      ... on Contentsection4Record {\n        ...Contentsection4RecordParts\n      }\n      ... on Contentsection5Record {\n        ...Contentsection5RecordParts\n      }\n      ... on Contentsection6Record {\n        ...Contentsection6RecordParts\n      }\n      ... on Contentsection7Record {\n        ...Contentsection7RecordParts\n      }\n      ... on Contentsection8Record {\n        ...Contentsection8RecordParts\n      }\n      ... on Contentsection9Record {\n        ...Contentsection9RecordParts\n      }\n      ... on FiledownloadsectionRecord {\n        ...ContentsectionFilesParts\n      }\n      ... on ProductslidersectionRecord {\n        ...ContentsectionProductSliderParts\n      }\n      ... on ImageTilesBlockRecord {\n        ...ImageTilesBlockRecordParts\n      }\n      ... on PhotoGalleryBlockRecord {\n        ...PhotoGalleryBlockRecordParts\n      }\n      ... on SimplybookmeBlockRecord {\n        __typename\n        id\n      }\n      ... on HtmlBlockRecord {\n        __typename\n        id\n        html\n      }\n    }\n    published\n  }\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject32 = function() {
        return data;
    };
    return data;
}
function _templateObject33() {
    const data = _taggedTemplateLiteral([
        "\n  fragment StringRecordFragment on StringRecord {\n    key\n    string {\n      alertType\n      message\n    }\n  }\n"
    ]);
    _templateObject33 = function() {
        return data;
    };
    return data;
}
function _templateObject34() {
    const data = _taggedTemplateLiteral([
        "\n  query PageByParentPageAndSlug($parentpage: ItemId!, $slug: String!) {\n    allPages(filter: { parentPage: { eq: $parentpage }, slug: { eq: $slug } }) {\n      ...PageParts\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject34 = function() {
        return data;
    };
    return data;
}
function _templateObject35() {
    const data = _taggedTemplateLiteral([
        "\n  query PageBySlug($slug: String!) {\n    allPages(filter: { slug: { eq: $slug } }) {\n      ...PageParts\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject35 = function() {
        return data;
    };
    return data;
}
function _templateObject36() {
    const data = _taggedTemplateLiteral([
        "\n  query PagesByParent($parentpage: ItemId!) {\n    allPages(filter: { parentPage: { eq: $parentpage } }) {\n      ...PageParts\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject36 = function() {
        return data;
    };
    return data;
}
function _templateObject37() {
    const data = _taggedTemplateLiteral([
        "\n  query GetFrontPage($limitDate: DateTime) {\n    allFrontpages(filter: { published: { lt: $limitDate } }, first: 1, orderBy: [published_DESC]) {\n      ...FrontpageParts\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject37 = function() {
        return data;
    };
    return data;
}
function _templateObject38() {
    const data = _taggedTemplateLiteral([
        "\n  query GetFrontPageBySlug($slug: String!) {\n    allFrontpages(filter: { slug: { eq: $slug } }, first: 1, orderBy: [published_DESC]) {\n      ...FrontpageParts\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject38 = function() {
        return data;
    };
    return data;
}
function _templateObject39() {
    const data = _taggedTemplateLiteral([
        "\n  query GetStringByKey($key: String!) {\n    allStrings(filter: { key: { eq: $key } }) {\n      ...StringRecordFragment\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject39 = function() {
        return data;
    };
    return data;
}

const ImageFilePartsFragmentDoc = /*#__PURE__*/ (0,lib/* default */.ZP)(_templateObject());
const TextblockModelContentFieldPartsFragmentDoc = /*#__PURE__*/ (0,lib/* default */.ZP)(_templateObject1());
const ActionButtonRecordPartsFragmentDoc = /*#__PURE__*/ (0,lib/* default */.ZP)(_templateObject2());
const TextBlockPartsFragmentDoc = /*#__PURE__*/ (0,lib/* default */.ZP)(_templateObject3(), TextblockModelContentFieldPartsFragmentDoc, ActionButtonRecordPartsFragmentDoc);
const DefaultHeaderPartsFragmentDoc = /*#__PURE__*/ (0,lib/* default */.ZP)(_templateObject4(), ImageFilePartsFragmentDoc, TextBlockPartsFragmentDoc);
const TopbannerdefaultblockRecordPartsFragmentDoc = /*#__PURE__*/ (0,lib/* default */.ZP)(_templateObject5(), ImageFilePartsFragmentDoc, TextBlockPartsFragmentDoc);
const IconbBlockRecordPartsFragmentDoc = /*#__PURE__*/ (0,lib/* default */.ZP)(_templateObject6());
const SeoFieldPartsFragmentDoc = /*#__PURE__*/ (0,lib/* default */.ZP)(_templateObject7(), ImageFilePartsFragmentDoc);
const AuthorblockRecorddPartsFragmentDoc = /*#__PURE__*/ (0,lib/* default */.ZP)(_templateObject8());
const ImageBlockPartsFragmentDoc = /*#__PURE__*/ (0,lib/* default */.ZP)(_templateObject9(), ImageFilePartsFragmentDoc);
const Contentsection1RecordPartsFragmentDoc = /*#__PURE__*/ (0,lib/* default */.ZP)(_templateObject10(), ImageBlockPartsFragmentDoc, TextBlockPartsFragmentDoc);
const Contentsection2RecordPartsFragmentDoc = /*#__PURE__*/ (0,lib/* default */.ZP)(_templateObject11(), ImageBlockPartsFragmentDoc, TextBlockPartsFragmentDoc);
const Contentsection3RecordPartsFragmentDoc = /*#__PURE__*/ (0,lib/* default */.ZP)(_templateObject12(), ImageBlockPartsFragmentDoc, TextBlockPartsFragmentDoc);
const ActionButtonPartsFragmentDoc = /*#__PURE__*/ (0,lib/* default */.ZP)(_templateObject13(), ImageFilePartsFragmentDoc);
const ImageBlockPartsWithTitleFragmentDoc = /*#__PURE__*/ (0,lib/* default */.ZP)(_templateObject14(), ImageFilePartsFragmentDoc);
const BulletContainerblockPartsFragmentDoc = /*#__PURE__*/ (0,lib/* default */.ZP)(_templateObject15(), TextBlockPartsFragmentDoc);
const Contentsection4RecordPartsFragmentDoc = /*#__PURE__*/ (0,lib/* default */.ZP)(_templateObject16(), ActionButtonPartsFragmentDoc, ImageBlockPartsWithTitleFragmentDoc, ImageBlockPartsFragmentDoc, BulletContainerblockPartsFragmentDoc);
const ListitemblockModelTextFieldPartsFragmentDoc = /*#__PURE__*/ (0,lib/* default */.ZP)(_templateObject17());
const ListitemblockRecordPartsFragmentDoc = /*#__PURE__*/ (0,lib/* default */.ZP)(_templateObject18(), ListitemblockModelTextFieldPartsFragmentDoc);
const ListcontainerblockRecordPartsFragmentDoc = /*#__PURE__*/ (0,lib/* default */.ZP)(_templateObject19(), ListitemblockRecordPartsFragmentDoc);
const Contentsection5RecordPartsFragmentDoc = /*#__PURE__*/ (0,lib/* default */.ZP)(_templateObject20(), ImageBlockPartsFragmentDoc, ListcontainerblockRecordPartsFragmentDoc, TextBlockPartsFragmentDoc);
const Contentsection6RecordPartsFragmentDoc = /*#__PURE__*/ (0,lib/* default */.ZP)(_templateObject21(), ImageBlockPartsFragmentDoc, TextBlockPartsFragmentDoc);
const Contentsection7RecordPartsFragmentDoc = /*#__PURE__*/ (0,lib/* default */.ZP)(_templateObject22(), ImageBlockPartsFragmentDoc, ActionButtonPartsFragmentDoc, TextBlockPartsFragmentDoc);
const Contentsection8RecordPartsFragmentDoc = /*#__PURE__*/ (0,lib/* default */.ZP)(_templateObject23(), ImageBlockPartsWithTitleFragmentDoc, ImageBlockPartsFragmentDoc, TextBlockPartsFragmentDoc);
const Contentsection9RecordPartsFragmentDoc = /*#__PURE__*/ (0,lib/* default */.ZP)(_templateObject24(), ImageBlockPartsFragmentDoc, ActionButtonPartsFragmentDoc, TextBlockPartsFragmentDoc);
const ContentsectionFilesPartsFragmentDoc = /*#__PURE__*/ (0,lib/* default */.ZP)(_templateObject25(), IconbBlockRecordPartsFragmentDoc);
const ContentsectionProductSliderPartsFragmentDoc = /*#__PURE__*/ (0,lib/* default */.ZP)(_templateObject26());
const ImageTilesBlockRecordPartsFragmentDoc = /*#__PURE__*/ (0,lib/* default */.ZP)(_templateObject27(), ImageBlockPartsFragmentDoc);
const HtmlBlockRecordPartsFragmentDoc = /*#__PURE__*/ (0,lib/* default */.ZP)(_templateObject28());
const PhotoGalleryBlockRecordPartsFragmentDoc = /*#__PURE__*/ (0,lib/* default */.ZP)(_templateObject29(), ImageBlockPartsFragmentDoc);
const PagePartsFragmentDoc = /*#__PURE__*/ (0,lib/* default */.ZP)(_templateObject30(), TopbannerdefaultblockRecordPartsFragmentDoc, IconbBlockRecordPartsFragmentDoc, SeoFieldPartsFragmentDoc, AuthorblockRecorddPartsFragmentDoc, Contentsection1RecordPartsFragmentDoc, Contentsection2RecordPartsFragmentDoc, Contentsection3RecordPartsFragmentDoc, Contentsection4RecordPartsFragmentDoc, Contentsection5RecordPartsFragmentDoc, Contentsection6RecordPartsFragmentDoc, Contentsection7RecordPartsFragmentDoc, Contentsection8RecordPartsFragmentDoc, Contentsection9RecordPartsFragmentDoc, ContentsectionFilesPartsFragmentDoc, ContentsectionProductSliderPartsFragmentDoc, ImageTilesBlockRecordPartsFragmentDoc, PhotoGalleryBlockRecordPartsFragmentDoc, HtmlBlockRecordPartsFragmentDoc);
const FrontPageHeaderPartsFragmentDoc = /*#__PURE__*/ (0,lib/* default */.ZP)(_templateObject31(), ImageFilePartsFragmentDoc);
const FrontpagePartsFragmentDoc = /*#__PURE__*/ (0,lib/* default */.ZP)(_templateObject32(), FrontPageHeaderPartsFragmentDoc, SeoFieldPartsFragmentDoc, Contentsection1RecordPartsFragmentDoc, Contentsection2RecordPartsFragmentDoc, Contentsection3RecordPartsFragmentDoc, Contentsection4RecordPartsFragmentDoc, Contentsection5RecordPartsFragmentDoc, Contentsection6RecordPartsFragmentDoc, Contentsection7RecordPartsFragmentDoc, Contentsection8RecordPartsFragmentDoc, Contentsection9RecordPartsFragmentDoc, ContentsectionFilesPartsFragmentDoc, ContentsectionProductSliderPartsFragmentDoc, ImageTilesBlockRecordPartsFragmentDoc, PhotoGalleryBlockRecordPartsFragmentDoc, HtmlBlockRecordPartsFragmentDoc);
const StringRecordFragmentFragmentDoc = /*#__PURE__*/ (0,lib/* default */.ZP)(_templateObject33());
const PageByParentPageAndSlugDocument = /*#__PURE__*/ (0,lib/* default */.ZP)(_templateObject34(), PagePartsFragmentDoc);
const PageBySlugDocument = /*#__PURE__*/ (0,lib/* default */.ZP)(_templateObject35(), PagePartsFragmentDoc);
const PagesByParentDocument = /*#__PURE__*/ (0,lib/* default */.ZP)(_templateObject36(), PagePartsFragmentDoc);
const GetFrontPageDocument = /*#__PURE__*/ (0,lib/* default */.ZP)(_templateObject37(), FrontpagePartsFragmentDoc);
const GetFrontPageBySlugDocument = /*#__PURE__*/ (0,lib/* default */.ZP)(_templateObject38(), FrontpagePartsFragmentDoc);
const GetStringByKeyDocument = /*#__PURE__*/ (0,lib/* default */.ZP)(_templateObject39(), StringRecordFragmentFragmentDoc);

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-api-dato-client-virtual-fc2b9374fc/1/packages/lib-api-dato-client/src/with-dato-page-by-slug.tsx
/* eslint-disable @typescript-eslint/no-explicit-any */ 
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const withDatoPageBySlug = (component)=>{
    var _getInitialProps;
    const oldFn = (_getInitialProps = component.getInitialProps) !== null && _getInitialProps !== void 0 ? _getInitialProps : null;
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    component.getInitialProps = async (context)=>{
        const value = oldFn ? await oldFn(context) : {};
        const { res  } = context;
        const slug = Array.isArray(context.query["slug"]) ? context.query["slug"].join("/") : context.query["slug"];
        if (!slug || Array.isArray(slug)) {
            if (context.res) {
                if (res) {
                    res.statusCode = 500;
                }
            }
            return {
                slug: "INVALID SLUG",
                notFound: false,
                internalError: true
            };
        }
        try {
            const data = await getPageBySlug("/api/cms", undefined, true, context)(slug);
            if ("error" in data) {
                const { notFound , internalError  } = data.error;
                if (res) {
                    res.statusCode = notFound ? 404 : 500;
                }
                return {
                    ...value,
                    slug,
                    notFound,
                    internalError
                };
            }
            return {
                ...value,
                slug,
                data,
                internalError: false,
                notFound: false
            };
        } catch (_e) {
            console.error(_e);
            return {
                ...value,
                slug,
                internalError: true,
                notFound: false
            };
        }
    };
    return component;
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-api-dato-client-virtual-fc2b9374fc/1/packages/lib-api-dato-client/src/with-dato-frontpage.tsx
/* eslint-disable @typescript-eslint/no-explicit-any */ 
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const withDatoFrontpage = (component, forPro)=>{
    var _getInitialProps;
    const oldFn = (_getInitialProps = component.getInitialProps) !== null && _getInitialProps !== void 0 ? _getInitialProps : null;
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    component.getInitialProps = async (context)=>{
        const value = oldFn ? await oldFn(context) : {};
        const { res  } = context;
        try {
            const data = await getFrontpage("/api/cms", undefined, forPro, context)();
            if ("error" in data) {
                const { notFound , internalError  } = data.error;
                if (res) {
                    res.statusCode = notFound ? 404 : 500;
                }
                return {
                    ...value,
                    notFound,
                    internalError
                };
            }
            return {
                ...value,
                data,
                internalError: false,
                notFound: false
            };
        } catch (_e) {
            console.error(_e);
            return {
                ...value,
                internalError: true,
                notFound: false
            };
        }
    };
    return component;
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-api-dato-client-virtual-fc2b9374fc/1/packages/lib-api-dato-client/src/use-megamenudata.ts



// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const useMegaMenuData = ()=>{
    return base_trpc.useQuery([
        "getMenu"
    ], {
        refetchOnWindowFocus: false
    });
};
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const getMegaMenuData = (url)=>()=>{
        const fullurl = getBykoConfig("CMS_API_URL");
        return trpc.createClient({
            links: [
                httpLink({
                    url: url !== null && url !== void 0 ? url : fullurl
                })
            ]
        }).query("getMenu");
    };

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-api-dato-client-virtual-fc2b9374fc/1/packages/lib-api-dato-client/src/use-dato-string-by-key.ts

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const useDatoStringByKey = (key)=>{
    return trpc.useQuery([
        "getStringByKey",
        {
            key
        }
    ]);
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-api-dato-client-virtual-fc2b9374fc/1/packages/lib-api-dato-client/src/use-product-page-by-slug.tsx
/* eslint-disable @typescript-eslint/explicit-function-return-type */ 


// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const useProductPageBySlug = (param)=>{
    let { slug , secret , initialData  } = param;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return trpc.useQuery([
        "getProduct",
        {
            slug,
            secret
        }
    ], {
        initialData: initialData !== null && initialData !== void 0 ? initialData : undefined
    });
};
const getProductPageBySlug = function(secret) {
    let props = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : undefined;
    return async (slug)=>{
        const fullurl = (0,src/* getBykoConfig */.Hp)("CMS_API_URL");
        try {
            var ref;
            const data = await ((ref = props === null || props === void 0 ? void 0 : props.trpcClient) !== null && ref !== void 0 ? ref : base_trpc.createClient({
                links: [
                    trpc_client_links_httpLink_esm_httpLink({
                        url: fullurl
                    })
                ]
            })).query("getProduct", {
                slug,
                secret
            });
            return data !== null && data !== void 0 ? data : null;
        } catch (e) {
            return null;
        }
    };
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-api-dato-client-virtual-fc2b9374fc/1/packages/lib-api-dato-client/src/use-opening-hours.tsx
/* eslint-disable @typescript-eslint/explicit-function-return-type */ 


// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const useOpeningHours = (param)=>{
    let { initialData  } = param;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return base_trpc.useQuery([
        "getOpeningHours"
    ], {
        initialData: initialData !== null && initialData !== void 0 ? initialData : undefined,
        refetchOnWindowFocus: false
    });
};
const getOpeningHours = function() {
    let props = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : undefined;
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    return async ()=>{
        const fullurl = (0,src/* getBykoConfig */.Hp)("CMS_API_URL");
        try {
            var ref;
            const data = await ((ref = props === null || props === void 0 ? void 0 : props.trpcClient) !== null && ref !== void 0 ? ref : base_trpc.createClient({
                links: [
                    trpc_client_links_httpLink_esm_httpLink({
                        url: fullurl
                    })
                ]
            })).query("getOpeningHours");
            return data !== null && data !== void 0 ? data : null;
        } catch (e) {
            return null;
        }
    };
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-api-dato-client-virtual-fc2b9374fc/1/packages/lib-api-dato-client/src/index.ts














/***/ }),

/***/ 62681:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "aS": function() { return /* reexport */ getPrice; }
});

// UNUSED EXPORTS: pricingStore, usePrice

// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-lib-recoil-virtual-ff20ed22cf/1/packages/lib-recoil/src/index.js
var src = __webpack_require__(27105);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-hooks-auth-next-virtual-a089da2ab7/1/packages/hooks-auth-next/src/index.ts + 14 modules
var hooks_auth_next_src = __webpack_require__(68814);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-lib-api-rest-virtual-a514398bdb/1/packages/lib-api-rest/src/index.ts + 4 modules
var lib_api_rest_src = __webpack_require__(97639);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-api-price-virtual-284954a275/1/packages/lib-api-price/src/batch-fetch.ts

/**
 * Config
 */ const TIME_BETWEEN_FETCH_MS = 150;
const MAX_ITEMS_IN_BATCH = 48;
/** DO NOT TOUCH. These are global objects used to control the batch process. */ const FETCH_STACK = [];
let timer = null;
/**
 * DO NOT USE OUTSIDE OF THIS FILE!
 * Internal util for batch request. Should only be called with window.setTimeout or similar.
 * Removes first MAX_ITEMS_IN_BATCH from the stack, and processes (elements array).
 *
 * Resolves and rejects all sku in the elements array.
 */ const _fetchNow = async ()=>{
    timer = null;
    const elements = FETCH_STACK.splice(0, MAX_ITEMS_IN_BATCH);
    if (elements.length === 0) {
        return;
    }
    /**
   * Creates an object with all promise (resolve and reject) in elements array.
   */ const ObjectSKUResolver = elements.reduce((a, b)=>{
        a[b.sku] = {
            resolve: b.resolve,
            reject: b.reject
        };
        return a;
    }, {});
    /**
   * internal helper functions for the internal util _fetchNow.
   */ /** Reject single variant - called when price could not be fetched (404, 5xx) */ const rejectSKU = (sku)=>{
        const obj = ObjectSKUResolver[sku];
        if (!obj) {
            throw new Error("Variant rejected which was not in original batch. Should not happen?");
        }
        return obj.reject;
    };
    /**
   * Reject all variants in element array.
   */ const rejectAll = ()=>Object.keys(ObjectSKUResolver).forEach((sku)=>rejectSKU(sku)());
    /**
   * Resolve variant with PriceItem.
   */ const resolveSKU = (sku)=>{
        const obj = ObjectSKUResolver[sku];
        if (!obj) {
            throw new Error("Price API returned an variant which was not in the original batch: ".concat(sku));
        }
        return obj.resolve;
    };
    /**
   * Clean process.
   */ const clean = ()=>{
        if (FETCH_STACK.length && !timer) {
            timer = window.setTimeout(_fetchNow, TIME_BETWEEN_FETCH_MS);
        }
    };
    /** End of internal helper functions for internal helper util. */ /** All SKU's in the element array.  */ const skus = elements.map((param)=>{
        let { sku  } = param;
        return sku;
    }).filter((e)=>e != null);
    /** SKU's string - solely for rest api url. */ const data = await lib_api_rest_src/* restApi.productsPricesList */._O.productsPricesList({
        sku: skus
    });
    /**
   * Rest API responded with error. REJECT ALL PRICES.
   * TODO: Add again to batch with a timeout?
   */ if (!data.ok) {
        rejectAll();
        clean();
        return;
    }
    var _results;
    /**
   * Results from API - SWAGGER AUTOGENERATED TYPE DEFINITION IS WRONG.
   * WE PLAY GOD AGAIN!
   */ const priceResults = (_results = data.data.results) !== null && _results !== void 0 ? _results : {};
    /**
   * Found variant's sku's.
   */ const found = Object.keys(priceResults).map((sku)=>sku).filter((sku)=>skus.includes(sku));
    /**
   *  Not found variant's sku's. Included in batch request but not in found
   */ const notFound = skus.filter((sku)=>!found.includes(sku));
    /** ACTION: Reject all not found variants! */ notFound.forEach((sku)=>rejectSKU(sku)());
    /** ACTION: Resolve all found variants! */ found.forEach((sku)=>{
        const value = priceResults[sku];
        resolveSKU(sku)(value);
    });
    /** ACTION: Clean up! */ clean();
};
/**
 * Batch request for price api.
 * Returns an promise that is resolved when price is fetched from the API for the variant.
 * Rejects a promise if variant is not found or API returns an error.
 */ const priceApiBatchGet = (param)=>{
    let { sku  } = param;
    /*
    Pushes an object: sku and promises, resolve and reject, to the stack.
  */ return new Promise((resolve, reject)=>{
        const obj = {
            sku,
            resolve,
            reject
        };
        FETCH_STACK.push(obj);
        /**
     * If timer is null, no action is pending. Create a new one.
     */ if (timer == null) {
            timer = window.setTimeout(_fetchNow, TIME_BETWEEN_FETCH_MS);
        }
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-api-price-virtual-284954a275/1/packages/lib-api-price/src/store.ts



const getPrice = (value)=>{
    if (value === null) {
        return null;
    }
    return {
        original: value,
        humanReadable: "".concat(new Intl.NumberFormat("is-IS", {
            style: "currency",
            currency: "ISK"
        }).format(Math.ceil(parseFloat(value.toString()))).replace("ISK", "").split("").filter((x)=>x.trim() !== "").join("").replaceAll(/,/g, "."), " kr.").replace("&nbsp;", "").replace(/kr\. kr\./g, " kr.")
    };
};
/***
 *  export const variantPricing = selectorFamily<ProductPricing | null, string>;
 *  export const pricing = selectorFamily<Record<string, ProductPricing> | null, string>({
 */ const store_pricing = (0,src/* selectorFamily */.CG)({
    key: "pricing-pricing",
    get: (sku)=>async (param)=>{
            let { get  } = param;
            /** Get user state. Solely so Recoil knows that this should be recomputed if user state changes. */ get(hooks_auth_next_src/* userState */.KL);
            /** This should not be fetched on SSR. */ if (false) {}
            if (!sku) {
                return null;
            }
            try {
                const data = await priceApiBatchGet({
                    sku
                });
                if (!data) {
                    return null;
                }
                var _isSqmProduct, _perSqm;
                const prices = {
                    isSqmProduct: (_isSqmProduct = data.isSqmProduct) !== null && _isSqmProduct !== void 0 ? _isSqmProduct : false,
                    packagingQuantity: data.packagingQuantity,
                    sqm: data.sqm,
                    price: {
                        gross: getPrice(data.price.gross),
                        net: getPrice(data.price.net),
                        perSqm: getPrice((_perSqm = data.price.perSqm) !== null && _perSqm !== void 0 ? _perSqm : null),
                        vat: getPrice(data.price.vat)
                    }
                };
                if (data.discounted) {
                    var _perSqm1;
                    prices.discounted = {
                        gross: getPrice(data.discounted.gross),
                        net: getPrice(data.discounted.net),
                        perSqm: getPrice((_perSqm1 = data.discounted.perSqm) !== null && _perSqm1 !== void 0 ? _perSqm1 : null),
                        name: data.discounted.name,
                        percentage: data.discounted.percentage
                    };
                }
                return prices;
            } catch (_e) {
                return null;
            }
        }
});

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-api-price-virtual-284954a275/1/packages/lib-api-price/src/index.ts


const usePrice = (sku)=>{
    const data = useRecoilValueLoadable(pricing(sku));
    switch(data.state){
        case "hasValue":
            return data.contents;
        default:
            return null;
    }
};

const pricingStore = (/* unused pure expression or super */ null && (pricing));


/***/ }),

/***/ 68825:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "oo": function() { return /* reexport */ CheckoutProvider; },
  "Cv": function() { return /* reexport */ CountryCode; },
  "z$": function() { return /* reexport */ _checkout; },
  "Qo": function() { return /* reexport */ algoliaHitToProduct; },
  "JE": function() { return /* reexport */ checkout; },
  "H1": function() { return /* reexport */ productBySlug; },
  "D$": function() { return /* reexport */ useAnonymousToken; },
  "Uk": function() { return /* reexport */ use_apollo_useApollo; },
  "YL": function() { return /* reexport */ useCartHelper; },
  "PO": function() { return /* reexport */ useCartItemCount; },
  "Mg": function() { return /* reexport */ useCheckout; },
  "nc": function() { return /* reexport */ useCheckoutBillingAddressUpdateMutation; },
  "HE": function() { return /* reexport */ useCheckoutLines; },
  "Eh": function() { return /* reexport */ useCheckoutShippingAddressUpdateMutation; },
  "HX": function() { return /* reexport */ useCheckoutState; },
  "eq": function() { return /* reexport */ useProductCartVariantHelper; },
  "BY": function() { return /* reexport */ useProductLowestPrices; },
  "gv": function() { return /* reexport */ useProductPrices; },
  "WZ": function() { return /* reexport */ useSetCheckoutStateValue; },
  "Dc": function() { return /* reexport */ useTotalCartCount; }
});

// UNUSED EXPORTS: APOLLO_STATE_PROP_NAME, CheckoutContext, FailBackImages, ProductFailImages, SaleorProvider, Sort, Store, anonymousTokenStore, cartObject, checkoutLines, fromGlobalId, getCategoryBySlug, handleCheckoutError, initialState, initializeApollo, intFromGlobalId, loadingCartState, productStore, selectorCartItem, selectorCartItemCount, state, toGlobalId, totalCartCount, useCartItem, useCategoryBySlug, useClearCheckout, useGetCheckout, useProductBySlug, useSetCheckoutValue, useSort, useUpdateShippingMethod, useUpdateStore, withSaleor

// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(91987);
var react_namespaceObject = /*#__PURE__*/__webpack_require__.t(react, 2);
// EXTERNAL MODULE: ../../.yarn/__virtual__/react-query-virtual-9ac5b1aaa1/0/cache/react-query-npm-3.39.1-7899b170b9-9273b7c2ad.zip/node_modules/react-query/es/index.js
var es = __webpack_require__(85166);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-lib-api-rest-virtual-a514398bdb/1/packages/lib-api-rest/src/index.ts + 4 modules
var src = __webpack_require__(97639);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-lib-category-helper-virtual-74e1c37b52/1/packages/lib-category-helper/src/index.ts
var lib_category_helper_src = __webpack_require__(15440);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-lib-recoil-virtual-ff20ed22cf/1/packages/lib-recoil/src/index.js
var lib_recoil_src = __webpack_require__(27105);
// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(61261);
// EXTERNAL MODULE: ../../.yarn/cache/tslib-npm-2.4.1-36f0ed04db-19480d6e03.zip/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(99290);
// EXTERNAL MODULE: ../../.yarn/cache/ts-invariant-npm-0.10.3-4657a5b439-bb07d56fe4.zip/node_modules/ts-invariant/lib/invariant.js
var invariant = __webpack_require__(32218);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@apollo-client-virtual-cd9e78d17f/0/cache/@apollo-client-npm-3.7.1-a80032e019-95bb1f226f.zip/node_modules/@apollo/client/utilities/globals/maybe.js
function maybe(thunk) {
    try {
        return thunk();
    }
    catch (_a) { }
}
//# sourceMappingURL=maybe.js.map
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@apollo-client-virtual-cd9e78d17f/0/cache/@apollo-client-npm-3.7.1-a80032e019-95bb1f226f.zip/node_modules/@apollo/client/utilities/globals/global.js

/* harmony default export */ var globals_global = (maybe(function () { return globalThis; }) ||
    maybe(function () { return window; }) ||
    maybe(function () { return self; }) ||
    maybe(function () { return global; }) || maybe(function () { return maybe.constructor("return this")(); }));
//# sourceMappingURL=global.js.map
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@apollo-client-virtual-cd9e78d17f/0/cache/@apollo-client-npm-3.7.1-a80032e019-95bb1f226f.zip/node_modules/@apollo/client/utilities/globals/DEV.js


var __ = "__";
var GLOBAL_KEY = [__, __].join("DEV");
function getDEV() {
    try {
        return Boolean(__DEV__);
    }
    catch (_a) {
        Object.defineProperty(globals_global, GLOBAL_KEY, {
            value: maybe(function () { return "production"; }) !== "production",
            enumerable: false,
            configurable: true,
            writable: true,
        });
        return globals_global[GLOBAL_KEY];
    }
}
/* harmony default export */ var DEV = (getDEV());
//# sourceMappingURL=DEV.js.map
// EXTERNAL MODULE: ../../.yarn/cache/ts-invariant-npm-0.10.3-4657a5b439-bb07d56fe4.zip/node_modules/ts-invariant/process/index.js
var process = __webpack_require__(69368);
// EXTERNAL MODULE: ../../.yarn/cache/graphql-npm-16.5.0-348f68b718-a82a926d08.zip/node_modules/graphql/language/source.mjs + 1 modules
var source = __webpack_require__(81052);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@apollo-client-virtual-cd9e78d17f/0/cache/@apollo-client-npm-3.7.1-a80032e019-95bb1f226f.zip/node_modules/@apollo/client/utilities/globals/fix-graphql.js


function removeTemporaryGlobals() {
    return typeof source/* Source */.H === "function" ? (0,process/* remove */.O)() : (0,process/* remove */.O)();
}
//# sourceMappingURL=fix-graphql.js.map
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@apollo-client-virtual-cd9e78d17f/0/cache/@apollo-client-npm-3.7.1-a80032e019-95bb1f226f.zip/node_modules/@apollo/client/utilities/globals/index.js



function checkDEV() {
    __DEV__ ? (0,invariant/* invariant */.kG)("boolean" === typeof DEV, DEV) : (0,invariant/* invariant */.kG)("boolean" === typeof DEV, 38);
}

removeTemporaryGlobals();



checkDEV();
//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../../.yarn/cache/@wry-trie-npm-0.3.2-68fe447c78-151d06b519.zip/node_modules/@wry/trie/lib/trie.esm.js
// A [trie](https://en.wikipedia.org/wiki/Trie) data structure that holds
// object keys weakly, yet can also hold non-object keys, unlike the
// native `WeakMap`.
// If no makeData function is supplied, the looked-up data will be an empty,
// null-prototype Object.
var defaultMakeData = function () { return Object.create(null); };
// Useful for processing arguments objects as well as arrays.
var _a = Array.prototype, forEach = _a.forEach, slice = _a.slice;
var Trie = /** @class */ (function () {
    function Trie(weakness, makeData) {
        if (weakness === void 0) { weakness = true; }
        if (makeData === void 0) { makeData = defaultMakeData; }
        this.weakness = weakness;
        this.makeData = makeData;
    }
    Trie.prototype.lookup = function () {
        var array = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            array[_i] = arguments[_i];
        }
        return this.lookupArray(array);
    };
    Trie.prototype.lookupArray = function (array) {
        var node = this;
        forEach.call(array, function (key) { return node = node.getChildTrie(key); });
        return node.data || (node.data = this.makeData(slice.call(array)));
    };
    Trie.prototype.getChildTrie = function (key) {
        var map = this.weakness && isObjRef(key)
            ? this.weak || (this.weak = new WeakMap())
            : this.strong || (this.strong = new Map());
        var child = map.get(key);
        if (!child)
            map.set(key, child = new Trie(this.weakness, this.makeData));
        return child;
    };
    return Trie;
}());
function isObjRef(value) {
    switch (typeof value) {
        case "object":
            if (value === null)
                break;
        // Fall through to return true...
        case "function":
            return true;
    }
    return false;
}


//# sourceMappingURL=trie.esm.js.map

;// CONCATENATED MODULE: ../../.yarn/cache/@wry-context-npm-0.6.1-23b1ac5edc-4187863175.zip/node_modules/@wry/context/lib/context.esm.js
// This currentContext variable will only be used if the makeSlotClass
// function is called, which happens only if this is the first copy of the
// @wry/context package to be imported.
var currentContext = null;
// This unique internal object is used to denote the absence of a value
// for a given Slot, and is never exposed to outside code.
var MISSING_VALUE = {};
var idCounter = 1;
// Although we can't do anything about the cost of duplicated code from
// accidentally bundling multiple copies of the @wry/context package, we can
// avoid creating the Slot class more than once using makeSlotClass.
var makeSlotClass = function () { return /** @class */ (function () {
    function Slot() {
        // If you have a Slot object, you can find out its slot.id, but you cannot
        // guess the slot.id of a Slot you don't have access to, thanks to the
        // randomized suffix.
        this.id = [
            "slot",
            idCounter++,
            Date.now(),
            Math.random().toString(36).slice(2),
        ].join(":");
    }
    Slot.prototype.hasValue = function () {
        for (var context_1 = currentContext; context_1; context_1 = context_1.parent) {
            // We use the Slot object iself as a key to its value, which means the
            // value cannot be obtained without a reference to the Slot object.
            if (this.id in context_1.slots) {
                var value = context_1.slots[this.id];
                if (value === MISSING_VALUE)
                    break;
                if (context_1 !== currentContext) {
                    // Cache the value in currentContext.slots so the next lookup will
                    // be faster. This caching is safe because the tree of contexts and
                    // the values of the slots are logically immutable.
                    currentContext.slots[this.id] = value;
                }
                return true;
            }
        }
        if (currentContext) {
            // If a value was not found for this Slot, it's never going to be found
            // no matter how many times we look it up, so we might as well cache
            // the absence of the value, too.
            currentContext.slots[this.id] = MISSING_VALUE;
        }
        return false;
    };
    Slot.prototype.getValue = function () {
        if (this.hasValue()) {
            return currentContext.slots[this.id];
        }
    };
    Slot.prototype.withValue = function (value, callback, 
    // Given the prevalence of arrow functions, specifying arguments is likely
    // to be much more common than specifying `this`, hence this ordering:
    args, thisArg) {
        var _a;
        var slots = (_a = {
                __proto__: null
            },
            _a[this.id] = value,
            _a);
        var parent = currentContext;
        currentContext = { parent: parent, slots: slots };
        try {
            // Function.prototype.apply allows the arguments array argument to be
            // omitted or undefined, so args! is fine here.
            return callback.apply(thisArg, args);
        }
        finally {
            currentContext = parent;
        }
    };
    // Capture the current context and wrap a callback function so that it
    // reestablishes the captured context when called.
    Slot.bind = function (callback) {
        var context = currentContext;
        return function () {
            var saved = currentContext;
            try {
                currentContext = context;
                return callback.apply(this, arguments);
            }
            finally {
                currentContext = saved;
            }
        };
    };
    // Immediately run a callback function without any captured context.
    Slot.noContext = function (callback, 
    // Given the prevalence of arrow functions, specifying arguments is likely
    // to be much more common than specifying `this`, hence this ordering:
    args, thisArg) {
        if (currentContext) {
            var saved = currentContext;
            try {
                currentContext = null;
                // Function.prototype.apply allows the arguments array argument to be
                // omitted or undefined, so args! is fine here.
                return callback.apply(thisArg, args);
            }
            finally {
                currentContext = saved;
            }
        }
        else {
            return callback.apply(thisArg, args);
        }
    };
    return Slot;
}()); };
// We store a single global implementation of the Slot class as a permanent
// non-enumerable symbol property of the Array constructor. This obfuscation
// does nothing to prevent access to the Slot class, but at least it ensures
// the implementation (i.e. currentContext) cannot be tampered with, and all
// copies of the @wry/context package (hopefully just one) will share the
// same Slot implementation. Since the first copy of the @wry/context package
// to be imported wins, this technique imposes a very high cost for any
// future breaking changes to the Slot class.
var globalKey = "@wry/context:Slot";
var host = Array;
var Slot = host[globalKey] || function () {
    var Slot = makeSlotClass();
    try {
        Object.defineProperty(host, globalKey, {
            value: host[globalKey] = Slot,
            enumerable: false,
            writable: false,
            configurable: false,
        });
    }
    finally {
        return Slot;
    }
}();

var bind = Slot.bind, noContext = Slot.noContext;
function setTimeoutWithContext(callback, delay) {
    return setTimeout(bind(callback), delay);
}
// Turn any generator function into an async function (using yield instead
// of await), with context automatically preserved across yields.
function asyncFromGen(genFn) {
    return function () {
        var gen = genFn.apply(this, arguments);
        var boundNext = bind(gen.next);
        var boundThrow = bind(gen.throw);
        return new Promise(function (resolve, reject) {
            function invoke(method, argument) {
                try {
                    var result = method.call(gen, argument);
                }
                catch (error) {
                    return reject(error);
                }
                var next = result.done ? resolve : invokeNext;
                if (isPromiseLike(result.value)) {
                    result.value.then(next, result.done ? reject : invokeThrow);
                }
                else {
                    next(result.value);
                }
            }
            var invokeNext = function (value) { return invoke(boundNext, value); };
            var invokeThrow = function (error) { return invoke(boundThrow, error); };
            invokeNext();
        });
    };
}
function isPromiseLike(value) {
    return value && typeof value.then === "function";
}
// If you use the fibers npm package to implement coroutines in Node.js,
// you should call this function at least once to ensure context management
// remains coherent across any yields.
var wrappedFibers = (/* unused pure expression or super */ null && ([]));
function wrapYieldingFiberMethods(Fiber) {
    // There can be only one implementation of Fiber per process, so this array
    // should never grow longer than one element.
    if (wrappedFibers.indexOf(Fiber) < 0) {
        var wrap = function (obj, method) {
            var fn = obj[method];
            obj[method] = function () {
                return noContext(fn, arguments, this);
            };
        };
        // These methods can yield, according to
        // https://github.com/laverdet/node-fibers/blob/ddebed9b8ae3883e57f822e2108e6943e5c8d2a8/fibers.js#L97-L100
        wrap(Fiber, "yield");
        wrap(Fiber.prototype, "run");
        wrap(Fiber.prototype, "throwInto");
        wrappedFibers.push(Fiber);
    }
    return Fiber;
}


//# sourceMappingURL=context.esm.js.map

;// CONCATENATED MODULE: ../../.yarn/cache/optimism-npm-0.16.1-b6a027d092-7506a3e5e3.zip/node_modules/optimism/lib/bundle.esm.js





function defaultDispose() { }
var Cache = /** @class */ (function () {
    function Cache(max, dispose) {
        if (max === void 0) { max = Infinity; }
        if (dispose === void 0) { dispose = defaultDispose; }
        this.max = max;
        this.dispose = dispose;
        this.map = new Map();
        this.newest = null;
        this.oldest = null;
    }
    Cache.prototype.has = function (key) {
        return this.map.has(key);
    };
    Cache.prototype.get = function (key) {
        var node = this.getNode(key);
        return node && node.value;
    };
    Cache.prototype.getNode = function (key) {
        var node = this.map.get(key);
        if (node && node !== this.newest) {
            var older = node.older, newer = node.newer;
            if (newer) {
                newer.older = older;
            }
            if (older) {
                older.newer = newer;
            }
            node.older = this.newest;
            node.older.newer = node;
            node.newer = null;
            this.newest = node;
            if (node === this.oldest) {
                this.oldest = newer;
            }
        }
        return node;
    };
    Cache.prototype.set = function (key, value) {
        var node = this.getNode(key);
        if (node) {
            return node.value = value;
        }
        node = {
            key: key,
            value: value,
            newer: null,
            older: this.newest
        };
        if (this.newest) {
            this.newest.newer = node;
        }
        this.newest = node;
        this.oldest = this.oldest || node;
        this.map.set(key, node);
        return node.value;
    };
    Cache.prototype.clean = function () {
        while (this.oldest && this.map.size > this.max) {
            this.delete(this.oldest.key);
        }
    };
    Cache.prototype.delete = function (key) {
        var node = this.map.get(key);
        if (node) {
            if (node === this.newest) {
                this.newest = node.older;
            }
            if (node === this.oldest) {
                this.oldest = node.newer;
            }
            if (node.newer) {
                node.newer.older = node.older;
            }
            if (node.older) {
                node.older.newer = node.newer;
            }
            this.map.delete(key);
            this.dispose(node.value, key);
            return true;
        }
        return false;
    };
    return Cache;
}());

var parentEntrySlot = new Slot();

var bundle_esm_a;
var bundle_esm_hasOwnProperty = Object.prototype.hasOwnProperty;
var 
// This Array.from polyfill is restricted to working with Set<any> for now,
// but we can improve the polyfill and add other input types, as needed. Note
// that this fallback implementation will only be used if the host environment
// does not support a native Array.from function. In most modern JS runtimes,
// the toArray function exported here will be === Array.from.
toArray = (bundle_esm_a = Array.from, bundle_esm_a === void 0 ? function (collection) {
    var array = [];
    collection.forEach(function (item) { return array.push(item); });
    return array;
} : bundle_esm_a);
function maybeUnsubscribe(entryOrDep) {
    var unsubscribe = entryOrDep.unsubscribe;
    if (typeof unsubscribe === "function") {
        entryOrDep.unsubscribe = void 0;
        unsubscribe();
    }
}

var emptySetPool = [];
var POOL_TARGET_SIZE = 100;
// Since this package might be used browsers, we should avoid using the
// Node built-in assert module.
function assert(condition, optionalMessage) {
    if (!condition) {
        throw new Error(optionalMessage || "assertion failure");
    }
}
function valueIs(a, b) {
    var len = a.length;
    return (
    // Unknown values are not equal to each other.
    len > 0 &&
        // Both values must be ordinary (or both exceptional) to be equal.
        len === b.length &&
        // The underlying value or exception must be the same.
        a[len - 1] === b[len - 1]);
}
function valueGet(value) {
    switch (value.length) {
        case 0: throw new Error("unknown value");
        case 1: return value[0];
        case 2: throw value[1];
    }
}
function valueCopy(value) {
    return value.slice(0);
}
var Entry = /** @class */ (function () {
    function Entry(fn) {
        this.fn = fn;
        this.parents = new Set();
        this.childValues = new Map();
        // When this Entry has children that are dirty, this property becomes
        // a Set containing other Entry objects, borrowed from emptySetPool.
        // When the set becomes empty, it gets recycled back to emptySetPool.
        this.dirtyChildren = null;
        this.dirty = true;
        this.recomputing = false;
        this.value = [];
        this.deps = null;
        ++Entry.count;
    }
    Entry.prototype.peek = function () {
        if (this.value.length === 1 && !mightBeDirty(this)) {
            rememberParent(this);
            return this.value[0];
        }
    };
    // This is the most important method of the Entry API, because it
    // determines whether the cached this.value can be returned immediately,
    // or must be recomputed. The overall performance of the caching system
    // depends on the truth of the following observations: (1) this.dirty is
    // usually false, (2) this.dirtyChildren is usually null/empty, and thus
    // (3) valueGet(this.value) is usually returned without recomputation.
    Entry.prototype.recompute = function (args) {
        assert(!this.recomputing, "already recomputing");
        rememberParent(this);
        return mightBeDirty(this)
            ? reallyRecompute(this, args)
            : valueGet(this.value);
    };
    Entry.prototype.setDirty = function () {
        if (this.dirty)
            return;
        this.dirty = true;
        this.value.length = 0;
        reportDirty(this);
        // We can go ahead and unsubscribe here, since any further dirty
        // notifications we receive will be redundant, and unsubscribing may
        // free up some resources, e.g. file watchers.
        maybeUnsubscribe(this);
    };
    Entry.prototype.dispose = function () {
        var _this = this;
        this.setDirty();
        // Sever any dependency relationships with our own children, so those
        // children don't retain this parent Entry in their child.parents sets,
        // thereby preventing it from being fully garbage collected.
        forgetChildren(this);
        // Because this entry has been kicked out of the cache (in index.js),
        // we've lost the ability to find out if/when this entry becomes dirty,
        // whether that happens through a subscription, because of a direct call
        // to entry.setDirty(), or because one of its children becomes dirty.
        // Because of this loss of future information, we have to assume the
        // worst (that this entry might have become dirty very soon), so we must
        // immediately mark this entry's parents as dirty. Normally we could
        // just call entry.setDirty() rather than calling parent.setDirty() for
        // each parent, but that would leave this entry in parent.childValues
        // and parent.dirtyChildren, which would prevent the child from being
        // truly forgotten.
        eachParent(this, function (parent, child) {
            parent.setDirty();
            forgetChild(parent, _this);
        });
    };
    Entry.prototype.forget = function () {
        // The code that creates Entry objects in index.ts will replace this method
        // with one that actually removes the Entry from the cache, which will also
        // trigger the entry.dispose method.
        this.dispose();
    };
    Entry.prototype.dependOn = function (dep) {
        dep.add(this);
        if (!this.deps) {
            this.deps = emptySetPool.pop() || new Set();
        }
        this.deps.add(dep);
    };
    Entry.prototype.forgetDeps = function () {
        var _this = this;
        if (this.deps) {
            toArray(this.deps).forEach(function (dep) { return dep.delete(_this); });
            this.deps.clear();
            emptySetPool.push(this.deps);
            this.deps = null;
        }
    };
    Entry.count = 0;
    return Entry;
}());
function rememberParent(child) {
    var parent = parentEntrySlot.getValue();
    if (parent) {
        child.parents.add(parent);
        if (!parent.childValues.has(child)) {
            parent.childValues.set(child, []);
        }
        if (mightBeDirty(child)) {
            reportDirtyChild(parent, child);
        }
        else {
            reportCleanChild(parent, child);
        }
        return parent;
    }
}
function reallyRecompute(entry, args) {
    forgetChildren(entry);
    // Set entry as the parent entry while calling recomputeNewValue(entry).
    parentEntrySlot.withValue(entry, recomputeNewValue, [entry, args]);
    if (maybeSubscribe(entry, args)) {
        // If we successfully recomputed entry.value and did not fail to
        // (re)subscribe, then this Entry is no longer explicitly dirty.
        setClean(entry);
    }
    return valueGet(entry.value);
}
function recomputeNewValue(entry, args) {
    entry.recomputing = true;
    // Set entry.value as unknown.
    entry.value.length = 0;
    try {
        // If entry.fn succeeds, entry.value will become a normal Value.
        entry.value[0] = entry.fn.apply(null, args);
    }
    catch (e) {
        // If entry.fn throws, entry.value will become exceptional.
        entry.value[1] = e;
    }
    // Either way, this line is always reached.
    entry.recomputing = false;
}
function mightBeDirty(entry) {
    return entry.dirty || !!(entry.dirtyChildren && entry.dirtyChildren.size);
}
function setClean(entry) {
    entry.dirty = false;
    if (mightBeDirty(entry)) {
        // This Entry may still have dirty children, in which case we can't
        // let our parents know we're clean just yet.
        return;
    }
    reportClean(entry);
}
function reportDirty(child) {
    eachParent(child, reportDirtyChild);
}
function reportClean(child) {
    eachParent(child, reportCleanChild);
}
function eachParent(child, callback) {
    var parentCount = child.parents.size;
    if (parentCount) {
        var parents = toArray(child.parents);
        for (var i = 0; i < parentCount; ++i) {
            callback(parents[i], child);
        }
    }
}
// Let a parent Entry know that one of its children may be dirty.
function reportDirtyChild(parent, child) {
    // Must have called rememberParent(child) before calling
    // reportDirtyChild(parent, child).
    assert(parent.childValues.has(child));
    assert(mightBeDirty(child));
    var parentWasClean = !mightBeDirty(parent);
    if (!parent.dirtyChildren) {
        parent.dirtyChildren = emptySetPool.pop() || new Set;
    }
    else if (parent.dirtyChildren.has(child)) {
        // If we already know this child is dirty, then we must have already
        // informed our own parents that we are dirty, so we can terminate
        // the recursion early.
        return;
    }
    parent.dirtyChildren.add(child);
    // If parent was clean before, it just became (possibly) dirty (according to
    // mightBeDirty), since we just added child to parent.dirtyChildren.
    if (parentWasClean) {
        reportDirty(parent);
    }
}
// Let a parent Entry know that one of its children is no longer dirty.
function reportCleanChild(parent, child) {
    // Must have called rememberChild(child) before calling
    // reportCleanChild(parent, child).
    assert(parent.childValues.has(child));
    assert(!mightBeDirty(child));
    var childValue = parent.childValues.get(child);
    if (childValue.length === 0) {
        parent.childValues.set(child, valueCopy(child.value));
    }
    else if (!valueIs(childValue, child.value)) {
        parent.setDirty();
    }
    removeDirtyChild(parent, child);
    if (mightBeDirty(parent)) {
        return;
    }
    reportClean(parent);
}
function removeDirtyChild(parent, child) {
    var dc = parent.dirtyChildren;
    if (dc) {
        dc.delete(child);
        if (dc.size === 0) {
            if (emptySetPool.length < POOL_TARGET_SIZE) {
                emptySetPool.push(dc);
            }
            parent.dirtyChildren = null;
        }
    }
}
// Removes all children from this entry and returns an array of the
// removed children.
function forgetChildren(parent) {
    if (parent.childValues.size > 0) {
        parent.childValues.forEach(function (_value, child) {
            forgetChild(parent, child);
        });
    }
    // Remove this parent Entry from any sets to which it was added by the
    // addToSet method.
    parent.forgetDeps();
    // After we forget all our children, this.dirtyChildren must be empty
    // and therefore must have been reset to null.
    assert(parent.dirtyChildren === null);
}
function forgetChild(parent, child) {
    child.parents.delete(parent);
    parent.childValues.delete(child);
    removeDirtyChild(parent, child);
}
function maybeSubscribe(entry, args) {
    if (typeof entry.subscribe === "function") {
        try {
            maybeUnsubscribe(entry); // Prevent double subscriptions.
            entry.unsubscribe = entry.subscribe.apply(null, args);
        }
        catch (e) {
            // If this Entry has a subscribe function and it threw an exception
            // (or an unsubscribe function it previously returned now throws),
            // return false to indicate that we were not able to subscribe (or
            // unsubscribe), and this Entry should remain dirty.
            entry.setDirty();
            return false;
        }
    }
    // Returning true indicates either that there was no entry.subscribe
    // function or that it succeeded.
    return true;
}

var EntryMethods = {
    setDirty: true,
    dispose: true,
    forget: true,
};
function dep(options) {
    var depsByKey = new Map();
    var subscribe = options && options.subscribe;
    function depend(key) {
        var parent = parentEntrySlot.getValue();
        if (parent) {
            var dep_1 = depsByKey.get(key);
            if (!dep_1) {
                depsByKey.set(key, dep_1 = new Set);
            }
            parent.dependOn(dep_1);
            if (typeof subscribe === "function") {
                maybeUnsubscribe(dep_1);
                dep_1.unsubscribe = subscribe(key);
            }
        }
    }
    depend.dirty = function dirty(key, entryMethodName) {
        var dep = depsByKey.get(key);
        if (dep) {
            var m_1 = (entryMethodName &&
                bundle_esm_hasOwnProperty.call(EntryMethods, entryMethodName)) ? entryMethodName : "setDirty";
            // We have to use toArray(dep).forEach instead of dep.forEach, because
            // modifying a Set while iterating over it can cause elements in the Set
            // to be removed from the Set before they've been iterated over.
            toArray(dep).forEach(function (entry) { return entry[m_1](); });
            depsByKey.delete(key);
            maybeUnsubscribe(dep);
        }
    };
    return depend;
}

function makeDefaultMakeCacheKeyFunction() {
    var keyTrie = new Trie(typeof WeakMap === "function");
    return function () {
        return keyTrie.lookupArray(arguments);
    };
}
// The defaultMakeCacheKey function is remarkably powerful, because it gives
// a unique object for any shallow-identical list of arguments. If you need
// to implement a custom makeCacheKey function, you may find it helpful to
// delegate the final work to defaultMakeCacheKey, which is why we export it
// here. However, you may want to avoid defaultMakeCacheKey if your runtime
// does not support WeakMap, or you have the ability to return a string key.
// In those cases, just write your own custom makeCacheKey functions.
var defaultMakeCacheKey = makeDefaultMakeCacheKeyFunction();
var caches = new Set();
function wrap(originalFunction, options) {
    if (options === void 0) { options = Object.create(null); }
    var cache = new Cache(options.max || Math.pow(2, 16), function (entry) { return entry.dispose(); });
    var keyArgs = options.keyArgs;
    var makeCacheKey = options.makeCacheKey ||
        makeDefaultMakeCacheKeyFunction();
    var optimistic = function () {
        var key = makeCacheKey.apply(null, keyArgs ? keyArgs.apply(null, arguments) : arguments);
        if (key === void 0) {
            return originalFunction.apply(null, arguments);
        }
        var entry = cache.get(key);
        if (!entry) {
            cache.set(key, entry = new Entry(originalFunction));
            entry.subscribe = options.subscribe;
            // Give the Entry the ability to trigger cache.delete(key), even though
            // the Entry itself does not know about key or cache.
            entry.forget = function () { return cache.delete(key); };
        }
        var value = entry.recompute(Array.prototype.slice.call(arguments));
        // Move this entry to the front of the least-recently used queue,
        // since we just finished computing its value.
        cache.set(key, entry);
        caches.add(cache);
        // Clean up any excess entries in the cache, but only if there is no
        // active parent entry, meaning we're not in the middle of a larger
        // computation that might be flummoxed by the cleaning.
        if (!parentEntrySlot.hasValue()) {
            caches.forEach(function (cache) { return cache.clean(); });
            caches.clear();
        }
        return value;
    };
    Object.defineProperty(optimistic, "size", {
        get: function () {
            return cache["map"].size;
        },
        configurable: false,
        enumerable: false,
    });
    function dirtyKey(key) {
        var entry = cache.get(key);
        if (entry) {
            entry.setDirty();
        }
    }
    optimistic.dirtyKey = dirtyKey;
    optimistic.dirty = function dirty() {
        dirtyKey(makeCacheKey.apply(null, arguments));
    };
    function peekKey(key) {
        var entry = cache.get(key);
        if (entry) {
            return entry.peek();
        }
    }
    optimistic.peekKey = peekKey;
    optimistic.peek = function peek() {
        return peekKey(makeCacheKey.apply(null, arguments));
    };
    function forgetKey(key) {
        return cache.delete(key);
    }
    optimistic.forgetKey = forgetKey;
    optimistic.forget = function forget() {
        return forgetKey(makeCacheKey.apply(null, arguments));
    };
    optimistic.makeCacheKey = makeCacheKey;
    optimistic.getKey = keyArgs ? function getKey() {
        return makeCacheKey.apply(null, keyArgs.apply(null, arguments));
    } : makeCacheKey;
    return Object.freeze(optimistic);
}


//# sourceMappingURL=bundle.esm.js.map

;// CONCATENATED MODULE: ../../.yarn/cache/@wry-equality-npm-0.5.3-f33e7d1c57-7ea8ded514.zip/node_modules/@wry/equality/lib/equality.esm.js
var equality_esm_a = Object.prototype, equality_esm_toString = equality_esm_a.toString, equality_esm_hasOwnProperty = equality_esm_a.hasOwnProperty;
var fnToStr = Function.prototype.toString;
var previousComparisons = new Map();
/**
 * Performs a deep equality check on two JavaScript values, tolerating cycles.
 */
function equal(a, b) {
    try {
        return check(a, b);
    }
    finally {
        previousComparisons.clear();
    }
}
function check(a, b) {
    // If the two values are strictly equal, our job is easy.
    if (a === b) {
        return true;
    }
    // Object.prototype.toString returns a representation of the runtime type of
    // the given value that is considerably more precise than typeof.
    var aTag = equality_esm_toString.call(a);
    var bTag = equality_esm_toString.call(b);
    // If the runtime types of a and b are different, they could maybe be equal
    // under some interpretation of equality, but for simplicity and performance
    // we just return false instead.
    if (aTag !== bTag) {
        return false;
    }
    switch (aTag) {
        case '[object Array]':
            // Arrays are a lot like other objects, but we can cheaply compare their
            // lengths as a short-cut before comparing their elements.
            if (a.length !== b.length)
                return false;
        // Fall through to object case...
        case '[object Object]': {
            if (previouslyCompared(a, b))
                return true;
            var aKeys = definedKeys(a);
            var bKeys = definedKeys(b);
            // If `a` and `b` have a different number of enumerable keys, they
            // must be different.
            var keyCount = aKeys.length;
            if (keyCount !== bKeys.length)
                return false;
            // Now make sure they have the same keys.
            for (var k = 0; k < keyCount; ++k) {
                if (!equality_esm_hasOwnProperty.call(b, aKeys[k])) {
                    return false;
                }
            }
            // Finally, check deep equality of all child properties.
            for (var k = 0; k < keyCount; ++k) {
                var key = aKeys[k];
                if (!check(a[key], b[key])) {
                    return false;
                }
            }
            return true;
        }
        case '[object Error]':
            return a.name === b.name && a.message === b.message;
        case '[object Number]':
            // Handle NaN, which is !== itself.
            if (a !== a)
                return b !== b;
        // Fall through to shared +a === +b case...
        case '[object Boolean]':
        case '[object Date]':
            return +a === +b;
        case '[object RegExp]':
        case '[object String]':
            return a == "".concat(b);
        case '[object Map]':
        case '[object Set]': {
            if (a.size !== b.size)
                return false;
            if (previouslyCompared(a, b))
                return true;
            var aIterator = a.entries();
            var isMap = aTag === '[object Map]';
            while (true) {
                var info = aIterator.next();
                if (info.done)
                    break;
                // If a instanceof Set, aValue === aKey.
                var _a = info.value, aKey = _a[0], aValue = _a[1];
                // So this works the same way for both Set and Map.
                if (!b.has(aKey)) {
                    return false;
                }
                // However, we care about deep equality of values only when dealing
                // with Map structures.
                if (isMap && !check(aValue, b.get(aKey))) {
                    return false;
                }
            }
            return true;
        }
        case '[object Uint16Array]':
        case '[object Uint8Array]': // Buffer, in Node.js.
        case '[object Uint32Array]':
        case '[object Int32Array]':
        case '[object Int8Array]':
        case '[object Int16Array]':
        case '[object ArrayBuffer]':
            // DataView doesn't need these conversions, but the equality check is
            // otherwise the same.
            a = new Uint8Array(a);
            b = new Uint8Array(b);
        // Fall through...
        case '[object DataView]': {
            var len = a.byteLength;
            if (len === b.byteLength) {
                while (len-- && a[len] === b[len]) {
                    // Keep looping as long as the bytes are equal.
                }
            }
            return len === -1;
        }
        case '[object AsyncFunction]':
        case '[object GeneratorFunction]':
        case '[object AsyncGeneratorFunction]':
        case '[object Function]': {
            var aCode = fnToStr.call(a);
            if (aCode !== fnToStr.call(b)) {
                return false;
            }
            // We consider non-native functions equal if they have the same code
            // (native functions require === because their code is censored).
            // Note that this behavior is not entirely sound, since !== function
            // objects with the same code can behave differently depending on
            // their closure scope. However, any function can behave differently
            // depending on the values of its input arguments (including this)
            // and its calling context (including its closure scope), even
            // though the function object is === to itself; and it is entirely
            // possible for functions that are not === to behave exactly the
            // same under all conceivable circumstances. Because none of these
            // factors are statically decidable in JavaScript, JS function
            // equality is not well-defined. This ambiguity allows us to
            // consider the best possible heuristic among various imperfect
            // options, and equating non-native functions that have the same
            // code has enormous practical benefits, such as when comparing
            // functions that are repeatedly passed as fresh function
            // expressions within objects that are otherwise deeply equal. Since
            // any function created from the same syntactic expression (in the
            // same code location) will always stringify to the same code
            // according to fnToStr.call, we can reasonably expect these
            // repeatedly passed function expressions to have the same code, and
            // thus behave "the same" (with all the caveats mentioned above),
            // even though the runtime function objects are !== to one another.
            return !endsWith(aCode, nativeCodeSuffix);
        }
    }
    // Otherwise the values are not equal.
    return false;
}
function definedKeys(obj) {
    // Remember that the second argument to Array.prototype.filter will be
    // used as `this` within the callback function.
    return Object.keys(obj).filter(isDefinedKey, obj);
}
function isDefinedKey(key) {
    return this[key] !== void 0;
}
var nativeCodeSuffix = "{ [native code] }";
function endsWith(full, suffix) {
    var fromIndex = full.length - suffix.length;
    return fromIndex >= 0 &&
        full.indexOf(suffix, fromIndex) === fromIndex;
}
function previouslyCompared(a, b) {
    // Though cyclic references can make an object graph appear infinite from the
    // perspective of a depth-first traversal, the graph still contains a finite
    // number of distinct object references. We use the previousComparisons cache
    // to avoid comparing the same pair of object references more than once, which
    // guarantees termination (even if we end up comparing every object in one
    // graph to every object in the other graph, which is extremely unlikely),
    // while still allowing weird isomorphic structures (like rings with different
    // lengths) a chance to pass the equality test.
    var bSet = previousComparisons.get(a);
    if (bSet) {
        // Return true here because we can be sure false will be returned somewhere
        // else if the objects are not equivalent.
        if (bSet.has(b))
            return true;
    }
    else {
        previousComparisons.set(a, bSet = new Set);
    }
    bSet.add(b);
    return false;
}


//# sourceMappingURL=equality.esm.js.map

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@apollo-client-virtual-cd9e78d17f/0/cache/@apollo-client-npm-3.7.1-a80032e019-95bb1f226f.zip/node_modules/@apollo/client/utilities/graphql/fragments.js


function getFragmentQueryDocument(document, fragmentName) {
    var actualFragmentName = fragmentName;
    var fragments = [];
    document.definitions.forEach(function (definition) {
        if (definition.kind === 'OperationDefinition') {
            throw __DEV__ ? new invariant/* InvariantError */.ej("Found a ".concat(definition.operation, " operation").concat(definition.name ? " named '".concat(definition.name.value, "'") : '', ". ") +
                'No operations are allowed when using a fragment as a query. Only fragments are allowed.') : new invariant/* InvariantError */.ej(43);
        }
        if (definition.kind === 'FragmentDefinition') {
            fragments.push(definition);
        }
    });
    if (typeof actualFragmentName === 'undefined') {
        __DEV__ ? (0,invariant/* invariant */.kG)(fragments.length === 1, "Found ".concat(fragments.length, " fragments. `fragmentName` must be provided when there is not exactly 1 fragment.")) : (0,invariant/* invariant */.kG)(fragments.length === 1, 44);
        actualFragmentName = fragments[0].name.value;
    }
    var query = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, document), { definitions: (0,tslib_es6/* __spreadArray */.ev)([
            {
                kind: 'OperationDefinition',
                operation: 'query',
                selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                        {
                            kind: 'FragmentSpread',
                            name: {
                                kind: 'Name',
                                value: actualFragmentName,
                            },
                        },
                    ],
                },
            }
        ], document.definitions, true) });
    return query;
}
function createFragmentMap(fragments) {
    if (fragments === void 0) { fragments = []; }
    var symTable = {};
    fragments.forEach(function (fragment) {
        symTable[fragment.name.value] = fragment;
    });
    return symTable;
}
function getFragmentFromSelection(selection, fragmentMap) {
    switch (selection.kind) {
        case 'InlineFragment':
            return selection;
        case 'FragmentSpread': {
            var fragmentName = selection.name.value;
            if (typeof fragmentMap === "function") {
                return fragmentMap(fragmentName);
            }
            var fragment = fragmentMap && fragmentMap[fragmentName];
            __DEV__ ? (0,invariant/* invariant */.kG)(fragment, "No fragment named ".concat(fragmentName)) : (0,invariant/* invariant */.kG)(fragment, 45);
            return fragment || null;
        }
        default:
            return null;
    }
}
//# sourceMappingURL=fragments.js.map
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@apollo-client-virtual-cd9e78d17f/0/cache/@apollo-client-npm-3.7.1-a80032e019-95bb1f226f.zip/node_modules/@apollo/client/cache/core/cache.js



var ApolloCache = (function () {
    function ApolloCache() {
        this.getFragmentDoc = wrap(getFragmentQueryDocument);
    }
    ApolloCache.prototype.batch = function (options) {
        var _this = this;
        var optimisticId = typeof options.optimistic === "string" ? options.optimistic :
            options.optimistic === false ? null : void 0;
        var updateResult;
        this.performTransaction(function () { return updateResult = options.update(_this); }, optimisticId);
        return updateResult;
    };
    ApolloCache.prototype.recordOptimisticTransaction = function (transaction, optimisticId) {
        this.performTransaction(transaction, optimisticId);
    };
    ApolloCache.prototype.transformDocument = function (document) {
        return document;
    };
    ApolloCache.prototype.transformForLink = function (document) {
        return document;
    };
    ApolloCache.prototype.identify = function (object) {
        return;
    };
    ApolloCache.prototype.gc = function () {
        return [];
    };
    ApolloCache.prototype.modify = function (options) {
        return false;
    };
    ApolloCache.prototype.readQuery = function (options, optimistic) {
        if (optimistic === void 0) { optimistic = !!options.optimistic; }
        return this.read((0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, options), { rootId: options.id || 'ROOT_QUERY', optimistic: optimistic }));
    };
    ApolloCache.prototype.readFragment = function (options, optimistic) {
        if (optimistic === void 0) { optimistic = !!options.optimistic; }
        return this.read((0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, options), { query: this.getFragmentDoc(options.fragment, options.fragmentName), rootId: options.id, optimistic: optimistic }));
    };
    ApolloCache.prototype.writeQuery = function (_a) {
        var id = _a.id, data = _a.data, options = (0,tslib_es6/* __rest */._T)(_a, ["id", "data"]);
        return this.write(Object.assign(options, {
            dataId: id || 'ROOT_QUERY',
            result: data,
        }));
    };
    ApolloCache.prototype.writeFragment = function (_a) {
        var id = _a.id, data = _a.data, fragment = _a.fragment, fragmentName = _a.fragmentName, options = (0,tslib_es6/* __rest */._T)(_a, ["id", "data", "fragment", "fragmentName"]);
        return this.write(Object.assign(options, {
            query: this.getFragmentDoc(fragment, fragmentName),
            dataId: id,
            result: data,
        }));
    };
    ApolloCache.prototype.updateQuery = function (options, update) {
        return this.batch({
            update: function (cache) {
                var value = cache.readQuery(options);
                var data = update(value);
                if (data === void 0 || data === null)
                    return value;
                cache.writeQuery((0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, options), { data: data }));
                return data;
            },
        });
    };
    ApolloCache.prototype.updateFragment = function (options, update) {
        return this.batch({
            update: function (cache) {
                var value = cache.readFragment(options);
                var data = update(value);
                if (data === void 0 || data === null)
                    return value;
                cache.writeFragment((0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, options), { data: data }));
                return data;
            },
        });
    };
    return ApolloCache;
}());

//# sourceMappingURL=cache.js.map
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@apollo-client-virtual-cd9e78d17f/0/cache/@apollo-client-npm-3.7.1-a80032e019-95bb1f226f.zip/node_modules/@apollo/client/cache/core/types/common.js

var MissingFieldError = (function (_super) {
    (0,tslib_es6/* __extends */.ZT)(MissingFieldError, _super);
    function MissingFieldError(message, path, query, variables) {
        var _a;
        var _this = _super.call(this, message) || this;
        _this.message = message;
        _this.path = path;
        _this.query = query;
        _this.variables = variables;
        if (Array.isArray(_this.path)) {
            _this.missing = _this.message;
            for (var i = _this.path.length - 1; i >= 0; --i) {
                _this.missing = (_a = {}, _a[_this.path[i]] = _this.missing, _a);
            }
        }
        else {
            _this.missing = _this.path;
        }
        _this.__proto__ = MissingFieldError.prototype;
        return _this;
    }
    return MissingFieldError;
}(Error));

//# sourceMappingURL=common.js.map
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@apollo-client-virtual-cd9e78d17f/0/cache/@apollo-client-npm-3.7.1-a80032e019-95bb1f226f.zip/node_modules/@apollo/client/utilities/common/objects.js
function isNonNullObject(obj) {
    return obj !== null && typeof obj === 'object';
}
//# sourceMappingURL=objects.js.map
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@apollo-client-virtual-cd9e78d17f/0/cache/@apollo-client-npm-3.7.1-a80032e019-95bb1f226f.zip/node_modules/@apollo/client/utilities/graphql/storeUtils.js



function makeReference(id) {
    return { __ref: String(id) };
}
function isReference(obj) {
    return Boolean(obj && typeof obj === 'object' && typeof obj.__ref === 'string');
}
function isDocumentNode(value) {
    return (isNonNullObject(value) &&
        value.kind === "Document" &&
        Array.isArray(value.definitions));
}
function isStringValue(value) {
    return value.kind === 'StringValue';
}
function isBooleanValue(value) {
    return value.kind === 'BooleanValue';
}
function isIntValue(value) {
    return value.kind === 'IntValue';
}
function isFloatValue(value) {
    return value.kind === 'FloatValue';
}
function isVariable(value) {
    return value.kind === 'Variable';
}
function isObjectValue(value) {
    return value.kind === 'ObjectValue';
}
function isListValue(value) {
    return value.kind === 'ListValue';
}
function isEnumValue(value) {
    return value.kind === 'EnumValue';
}
function isNullValue(value) {
    return value.kind === 'NullValue';
}
function valueToObjectRepresentation(argObj, name, value, variables) {
    if (isIntValue(value) || isFloatValue(value)) {
        argObj[name.value] = Number(value.value);
    }
    else if (isBooleanValue(value) || isStringValue(value)) {
        argObj[name.value] = value.value;
    }
    else if (isObjectValue(value)) {
        var nestedArgObj_1 = {};
        value.fields.map(function (obj) {
            return valueToObjectRepresentation(nestedArgObj_1, obj.name, obj.value, variables);
        });
        argObj[name.value] = nestedArgObj_1;
    }
    else if (isVariable(value)) {
        var variableValue = (variables || {})[value.name.value];
        argObj[name.value] = variableValue;
    }
    else if (isListValue(value)) {
        argObj[name.value] = value.values.map(function (listValue) {
            var nestedArgArrayObj = {};
            valueToObjectRepresentation(nestedArgArrayObj, name, listValue, variables);
            return nestedArgArrayObj[name.value];
        });
    }
    else if (isEnumValue(value)) {
        argObj[name.value] = value.value;
    }
    else if (isNullValue(value)) {
        argObj[name.value] = null;
    }
    else {
        throw __DEV__ ? new invariant/* InvariantError */.ej("The inline argument \"".concat(name.value, "\" of kind \"").concat(value.kind, "\"") +
            'is not supported. Use variables instead of inline arguments to ' +
            'overcome this limitation.') : new invariant/* InvariantError */.ej(54);
    }
}
function storeKeyNameFromField(field, variables) {
    var directivesObj = null;
    if (field.directives) {
        directivesObj = {};
        field.directives.forEach(function (directive) {
            directivesObj[directive.name.value] = {};
            if (directive.arguments) {
                directive.arguments.forEach(function (_a) {
                    var name = _a.name, value = _a.value;
                    return valueToObjectRepresentation(directivesObj[directive.name.value], name, value, variables);
                });
            }
        });
    }
    var argObj = null;
    if (field.arguments && field.arguments.length) {
        argObj = {};
        field.arguments.forEach(function (_a) {
            var name = _a.name, value = _a.value;
            return valueToObjectRepresentation(argObj, name, value, variables);
        });
    }
    return getStoreKeyName(field.name.value, argObj, directivesObj);
}
var KNOWN_DIRECTIVES = [
    'connection',
    'include',
    'skip',
    'client',
    'rest',
    'export',
];
var getStoreKeyName = Object.assign(function (fieldName, args, directives) {
    if (args &&
        directives &&
        directives['connection'] &&
        directives['connection']['key']) {
        if (directives['connection']['filter'] &&
            directives['connection']['filter'].length > 0) {
            var filterKeys = directives['connection']['filter']
                ? directives['connection']['filter']
                : [];
            filterKeys.sort();
            var filteredArgs_1 = {};
            filterKeys.forEach(function (key) {
                filteredArgs_1[key] = args[key];
            });
            return "".concat(directives['connection']['key'], "(").concat(stringify(filteredArgs_1), ")");
        }
        else {
            return directives['connection']['key'];
        }
    }
    var completeFieldName = fieldName;
    if (args) {
        var stringifiedArgs = stringify(args);
        completeFieldName += "(".concat(stringifiedArgs, ")");
    }
    if (directives) {
        Object.keys(directives).forEach(function (key) {
            if (KNOWN_DIRECTIVES.indexOf(key) !== -1)
                return;
            if (directives[key] && Object.keys(directives[key]).length) {
                completeFieldName += "@".concat(key, "(").concat(stringify(directives[key]), ")");
            }
            else {
                completeFieldName += "@".concat(key);
            }
        });
    }
    return completeFieldName;
}, {
    setStringify: function (s) {
        var previous = stringify;
        stringify = s;
        return previous;
    },
});
var stringify = function defaultStringify(value) {
    return JSON.stringify(value, stringifyReplacer);
};
function stringifyReplacer(_key, value) {
    if (isNonNullObject(value) && !Array.isArray(value)) {
        value = Object.keys(value).sort().reduce(function (copy, key) {
            copy[key] = value[key];
            return copy;
        }, {});
    }
    return value;
}
function argumentsObjectFromField(field, variables) {
    if (field.arguments && field.arguments.length) {
        var argObj_1 = {};
        field.arguments.forEach(function (_a) {
            var name = _a.name, value = _a.value;
            return valueToObjectRepresentation(argObj_1, name, value, variables);
        });
        return argObj_1;
    }
    return null;
}
function resultKeyNameFromField(field) {
    return field.alias ? field.alias.value : field.name.value;
}
function getTypenameFromResult(result, selectionSet, fragmentMap) {
    if (typeof result.__typename === 'string') {
        return result.__typename;
    }
    for (var _i = 0, _a = selectionSet.selections; _i < _a.length; _i++) {
        var selection = _a[_i];
        if (storeUtils_isField(selection)) {
            if (selection.name.value === '__typename') {
                return result[resultKeyNameFromField(selection)];
            }
        }
        else {
            var typename = getTypenameFromResult(result, getFragmentFromSelection(selection, fragmentMap).selectionSet, fragmentMap);
            if (typeof typename === 'string') {
                return typename;
            }
        }
    }
}
function storeUtils_isField(selection) {
    return selection.kind === 'Field';
}
function isInlineFragment(selection) {
    return selection.kind === 'InlineFragment';
}
//# sourceMappingURL=storeUtils.js.map
// EXTERNAL MODULE: ../../.yarn/cache/graphql-npm-16.5.0-348f68b718-a82a926d08.zip/node_modules/graphql/language/visitor.mjs
var visitor = __webpack_require__(69423);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@apollo-client-virtual-cd9e78d17f/0/cache/@apollo-client-npm-3.7.1-a80032e019-95bb1f226f.zip/node_modules/@apollo/client/utilities/graphql/getFromAST.js


function checkDocument(doc) {
    __DEV__ ? (0,invariant/* invariant */.kG)(doc && doc.kind === 'Document', "Expecting a parsed GraphQL document. Perhaps you need to wrap the query string in a \"gql\" tag? http://docs.apollostack.com/apollo-client/core.html#gql") : (0,invariant/* invariant */.kG)(doc && doc.kind === 'Document', 46);
    var operations = doc.definitions
        .filter(function (d) { return d.kind !== 'FragmentDefinition'; })
        .map(function (definition) {
        if (definition.kind !== 'OperationDefinition') {
            throw __DEV__ ? new invariant/* InvariantError */.ej("Schema type definitions not allowed in queries. Found: \"".concat(definition.kind, "\"")) : new invariant/* InvariantError */.ej(47);
        }
        return definition;
    });
    __DEV__ ? (0,invariant/* invariant */.kG)(operations.length <= 1, "Ambiguous GraphQL document: contains ".concat(operations.length, " operations")) : (0,invariant/* invariant */.kG)(operations.length <= 1, 48);
    return doc;
}
function getOperationDefinition(doc) {
    checkDocument(doc);
    return doc.definitions.filter(function (definition) { return definition.kind === 'OperationDefinition'; })[0];
}
function getOperationName(doc) {
    return (doc.definitions
        .filter(function (definition) {
        return definition.kind === 'OperationDefinition' && definition.name;
    })
        .map(function (x) { return x.name.value; })[0] || null);
}
function getFragmentDefinitions(doc) {
    return doc.definitions.filter(function (definition) { return definition.kind === 'FragmentDefinition'; });
}
function getQueryDefinition(doc) {
    var queryDef = getOperationDefinition(doc);
    __DEV__ ? (0,invariant/* invariant */.kG)(queryDef && queryDef.operation === 'query', 'Must contain a query definition.') : (0,invariant/* invariant */.kG)(queryDef && queryDef.operation === 'query', 49);
    return queryDef;
}
function getFragmentDefinition(doc) {
    __DEV__ ? (0,invariant/* invariant */.kG)(doc.kind === 'Document', "Expecting a parsed GraphQL document. Perhaps you need to wrap the query string in a \"gql\" tag? http://docs.apollostack.com/apollo-client/core.html#gql") : (0,invariant/* invariant */.kG)(doc.kind === 'Document', 50);
    __DEV__ ? (0,invariant/* invariant */.kG)(doc.definitions.length <= 1, 'Fragment must have exactly one definition.') : (0,invariant/* invariant */.kG)(doc.definitions.length <= 1, 51);
    var fragmentDef = doc.definitions[0];
    __DEV__ ? (0,invariant/* invariant */.kG)(fragmentDef.kind === 'FragmentDefinition', 'Must be a fragment definition.') : (0,invariant/* invariant */.kG)(fragmentDef.kind === 'FragmentDefinition', 52);
    return fragmentDef;
}
function getMainDefinition(queryDoc) {
    checkDocument(queryDoc);
    var fragmentDefinition;
    for (var _i = 0, _a = queryDoc.definitions; _i < _a.length; _i++) {
        var definition = _a[_i];
        if (definition.kind === 'OperationDefinition') {
            var operation = definition.operation;
            if (operation === 'query' ||
                operation === 'mutation' ||
                operation === 'subscription') {
                return definition;
            }
        }
        if (definition.kind === 'FragmentDefinition' && !fragmentDefinition) {
            fragmentDefinition = definition;
        }
    }
    if (fragmentDefinition) {
        return fragmentDefinition;
    }
    throw __DEV__ ? new invariant/* InvariantError */.ej('Expected a parsed GraphQL query with a query, mutation, subscription, or a fragment.') : new invariant/* InvariantError */.ej(53);
}
function getDefaultValues(definition) {
    var defaultValues = Object.create(null);
    var defs = definition && definition.variableDefinitions;
    if (defs && defs.length) {
        defs.forEach(function (def) {
            if (def.defaultValue) {
                valueToObjectRepresentation(defaultValues, def.variable.name, def.defaultValue);
            }
        });
    }
    return defaultValues;
}
//# sourceMappingURL=getFromAST.js.map
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@apollo-client-virtual-cd9e78d17f/0/cache/@apollo-client-npm-3.7.1-a80032e019-95bb1f226f.zip/node_modules/@apollo/client/utilities/common/filterInPlace.js
function filterInPlace(array, test, context) {
    var target = 0;
    array.forEach(function (elem, i) {
        if (test.call(this, elem, i, array)) {
            array[target++] = elem;
        }
    }, context);
    array.length = target;
    return array;
}
//# sourceMappingURL=filterInPlace.js.map
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@apollo-client-virtual-cd9e78d17f/0/cache/@apollo-client-npm-3.7.1-a80032e019-95bb1f226f.zip/node_modules/@apollo/client/utilities/graphql/transform.js







var TYPENAME_FIELD = {
    kind: 'Field',
    name: {
        kind: 'Name',
        value: '__typename',
    },
};
function isEmpty(op, fragmentMap) {
    return !op || op.selectionSet.selections.every(function (selection) { return selection.kind === 'FragmentSpread' &&
        isEmpty(fragmentMap[selection.name.value], fragmentMap); });
}
function nullIfDocIsEmpty(doc) {
    return isEmpty(getOperationDefinition(doc) || getFragmentDefinition(doc), createFragmentMap(getFragmentDefinitions(doc)))
        ? null
        : doc;
}
function getDirectiveMatcher(directives) {
    return function directiveMatcher(directive) {
        return directives.some(function (dir) {
            return (dir.name && dir.name === directive.name.value) ||
                (dir.test && dir.test(directive));
        });
    };
}
function removeDirectivesFromDocument(directives, doc) {
    var variablesInUse = Object.create(null);
    var variablesToRemove = [];
    var fragmentSpreadsInUse = Object.create(null);
    var fragmentSpreadsToRemove = [];
    var modifiedDoc = nullIfDocIsEmpty((0,visitor/* visit */.Vn)(doc, {
        Variable: {
            enter: function (node, _key, parent) {
                if (parent.kind !== 'VariableDefinition') {
                    variablesInUse[node.name.value] = true;
                }
            },
        },
        Field: {
            enter: function (node) {
                if (directives && node.directives) {
                    var shouldRemoveField = directives.some(function (directive) { return directive.remove; });
                    if (shouldRemoveField &&
                        node.directives &&
                        node.directives.some(getDirectiveMatcher(directives))) {
                        if (node.arguments) {
                            node.arguments.forEach(function (arg) {
                                if (arg.value.kind === 'Variable') {
                                    variablesToRemove.push({
                                        name: arg.value.name.value,
                                    });
                                }
                            });
                        }
                        if (node.selectionSet) {
                            getAllFragmentSpreadsFromSelectionSet(node.selectionSet).forEach(function (frag) {
                                fragmentSpreadsToRemove.push({
                                    name: frag.name.value,
                                });
                            });
                        }
                        return null;
                    }
                }
            },
        },
        FragmentSpread: {
            enter: function (node) {
                fragmentSpreadsInUse[node.name.value] = true;
            },
        },
        Directive: {
            enter: function (node) {
                if (getDirectiveMatcher(directives)(node)) {
                    return null;
                }
            },
        },
    }));
    if (modifiedDoc &&
        filterInPlace(variablesToRemove, function (v) { return !!v.name && !variablesInUse[v.name]; }).length) {
        modifiedDoc = removeArgumentsFromDocument(variablesToRemove, modifiedDoc);
    }
    if (modifiedDoc &&
        filterInPlace(fragmentSpreadsToRemove, function (fs) { return !!fs.name && !fragmentSpreadsInUse[fs.name]; })
            .length) {
        modifiedDoc = removeFragmentSpreadFromDocument(fragmentSpreadsToRemove, modifiedDoc);
    }
    return modifiedDoc;
}
var addTypenameToDocument = Object.assign(function (doc) {
    return (0,visitor/* visit */.Vn)(doc, {
        SelectionSet: {
            enter: function (node, _key, parent) {
                if (parent &&
                    parent.kind === 'OperationDefinition') {
                    return;
                }
                var selections = node.selections;
                if (!selections) {
                    return;
                }
                var skip = selections.some(function (selection) {
                    return (storeUtils_isField(selection) &&
                        (selection.name.value === '__typename' ||
                            selection.name.value.lastIndexOf('__', 0) === 0));
                });
                if (skip) {
                    return;
                }
                var field = parent;
                if (storeUtils_isField(field) &&
                    field.directives &&
                    field.directives.some(function (d) { return d.name.value === 'export'; })) {
                    return;
                }
                return (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, node), { selections: (0,tslib_es6/* __spreadArray */.ev)((0,tslib_es6/* __spreadArray */.ev)([], selections, true), [TYPENAME_FIELD], false) });
            },
        },
    });
}, {
    added: function (field) {
        return field === TYPENAME_FIELD;
    },
});
var connectionRemoveConfig = {
    test: function (directive) {
        var willRemove = directive.name.value === 'connection';
        if (willRemove) {
            if (!directive.arguments ||
                !directive.arguments.some(function (arg) { return arg.name.value === 'key'; })) {
                __DEV__ && invariant/* invariant.warn */.kG.warn('Removing an @connection directive even though it does not have a key. ' +
                    'You may want to use the key parameter to specify a store key.');
            }
        }
        return willRemove;
    },
};
function removeConnectionDirectiveFromDocument(doc) {
    return removeDirectivesFromDocument([connectionRemoveConfig], checkDocument(doc));
}
function hasDirectivesInSelectionSet(directives, selectionSet, nestedCheck) {
    if (nestedCheck === void 0) { nestedCheck = true; }
    return (!!selectionSet &&
        selectionSet.selections &&
        selectionSet.selections.some(function (selection) {
            return hasDirectivesInSelection(directives, selection, nestedCheck);
        }));
}
function hasDirectivesInSelection(directives, selection, nestedCheck) {
    if (nestedCheck === void 0) { nestedCheck = true; }
    if (!isField(selection)) {
        return true;
    }
    if (!selection.directives) {
        return false;
    }
    return (selection.directives.some(getDirectiveMatcher(directives)) ||
        (nestedCheck &&
            hasDirectivesInSelectionSet(directives, selection.selectionSet, nestedCheck)));
}
function getArgumentMatcher(config) {
    return function argumentMatcher(argument) {
        return config.some(function (aConfig) {
            return argument.value &&
                argument.value.kind === 'Variable' &&
                argument.value.name &&
                (aConfig.name === argument.value.name.value ||
                    (aConfig.test && aConfig.test(argument)));
        });
    };
}
function removeArgumentsFromDocument(config, doc) {
    var argMatcher = getArgumentMatcher(config);
    return nullIfDocIsEmpty((0,visitor/* visit */.Vn)(doc, {
        OperationDefinition: {
            enter: function (node) {
                return (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, node), { variableDefinitions: node.variableDefinitions ? node.variableDefinitions.filter(function (varDef) {
                        return !config.some(function (arg) { return arg.name === varDef.variable.name.value; });
                    }) : [] });
            },
        },
        Field: {
            enter: function (node) {
                var shouldRemoveField = config.some(function (argConfig) { return argConfig.remove; });
                if (shouldRemoveField) {
                    var argMatchCount_1 = 0;
                    if (node.arguments) {
                        node.arguments.forEach(function (arg) {
                            if (argMatcher(arg)) {
                                argMatchCount_1 += 1;
                            }
                        });
                    }
                    if (argMatchCount_1 === 1) {
                        return null;
                    }
                }
            },
        },
        Argument: {
            enter: function (node) {
                if (argMatcher(node)) {
                    return null;
                }
            },
        },
    }));
}
function removeFragmentSpreadFromDocument(config, doc) {
    function enter(node) {
        if (config.some(function (def) { return def.name === node.name.value; })) {
            return null;
        }
    }
    return nullIfDocIsEmpty((0,visitor/* visit */.Vn)(doc, {
        FragmentSpread: { enter: enter },
        FragmentDefinition: { enter: enter },
    }));
}
function getAllFragmentSpreadsFromSelectionSet(selectionSet) {
    var allFragments = [];
    selectionSet.selections.forEach(function (selection) {
        if ((storeUtils_isField(selection) || isInlineFragment(selection)) &&
            selection.selectionSet) {
            getAllFragmentSpreadsFromSelectionSet(selection.selectionSet).forEach(function (frag) { return allFragments.push(frag); });
        }
        else if (selection.kind === 'FragmentSpread') {
            allFragments.push(selection);
        }
    });
    return allFragments;
}
function buildQueryFromSelectionSet(document) {
    var definition = getMainDefinition(document);
    var definitionOperation = definition.operation;
    if (definitionOperation === 'query') {
        return document;
    }
    var modifiedDoc = (0,visitor/* visit */.Vn)(document, {
        OperationDefinition: {
            enter: function (node) {
                return (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, node), { operation: 'query' });
            },
        },
    });
    return modifiedDoc;
}
function removeClientSetsFromDocument(document) {
    checkDocument(document);
    var modifiedDoc = removeDirectivesFromDocument([
        {
            test: function (directive) { return directive.name.value === 'client'; },
            remove: true,
        },
    ], document);
    if (modifiedDoc) {
        modifiedDoc = (0,visitor/* visit */.Vn)(modifiedDoc, {
            FragmentDefinition: {
                enter: function (node) {
                    if (node.selectionSet) {
                        var isTypenameOnly = node.selectionSet.selections.every(function (selection) {
                            return storeUtils_isField(selection) && selection.name.value === '__typename';
                        });
                        if (isTypenameOnly) {
                            return null;
                        }
                    }
                },
            },
        });
    }
    return modifiedDoc;
}
//# sourceMappingURL=transform.js.map
// EXTERNAL MODULE: ../../.yarn/cache/graphql-npm-16.5.0-348f68b718-a82a926d08.zip/node_modules/graphql/language/kinds.mjs
var kinds = __webpack_require__(65797);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@apollo-client-virtual-cd9e78d17f/0/cache/@apollo-client-npm-3.7.1-a80032e019-95bb1f226f.zip/node_modules/@apollo/client/utilities/common/canUse.js

var canUseWeakMap = typeof WeakMap === 'function' &&
    maybe(function () { return navigator.product; }) !== 'ReactNative';
var canUseWeakSet = typeof WeakSet === 'function';
var canUseSymbol = typeof Symbol === 'function' &&
    typeof Symbol.for === 'function';
var canUseAsyncIteratorSymbol = canUseSymbol && Symbol.asyncIterator;
var canUseDOM = typeof maybe(function () { return window.document.createElement; }) === "function";
var usingJSDOM = maybe(function () { return navigator.userAgent.indexOf("jsdom") >= 0; }) || false;
var canUseLayoutEffect = canUseDOM && !usingJSDOM;
//# sourceMappingURL=canUse.js.map
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@apollo-client-virtual-cd9e78d17f/0/cache/@apollo-client-npm-3.7.1-a80032e019-95bb1f226f.zip/node_modules/@apollo/client/utilities/common/compact.js
function compact() {
    var objects = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        objects[_i] = arguments[_i];
    }
    var result = Object.create(null);
    objects.forEach(function (obj) {
        if (!obj)
            return;
        Object.keys(obj).forEach(function (key) {
            var value = obj[key];
            if (value !== void 0) {
                result[key] = value;
            }
        });
    });
    return result;
}
//# sourceMappingURL=compact.js.map
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@apollo-client-virtual-cd9e78d17f/0/cache/@apollo-client-npm-3.7.1-a80032e019-95bb1f226f.zip/node_modules/@apollo/client/utilities/common/mergeDeep.js


var mergeDeep_hasOwnProperty = Object.prototype.hasOwnProperty;
function mergeDeep() {
    var sources = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        sources[_i] = arguments[_i];
    }
    return mergeDeepArray(sources);
}
function mergeDeepArray(sources) {
    var target = sources[0] || {};
    var count = sources.length;
    if (count > 1) {
        var merger = new DeepMerger();
        for (var i = 1; i < count; ++i) {
            target = merger.merge(target, sources[i]);
        }
    }
    return target;
}
var defaultReconciler = function (target, source, property) {
    return this.merge(target[property], source[property]);
};
var DeepMerger = (function () {
    function DeepMerger(reconciler) {
        if (reconciler === void 0) { reconciler = defaultReconciler; }
        this.reconciler = reconciler;
        this.isObject = isNonNullObject;
        this.pastCopies = new Set();
    }
    DeepMerger.prototype.merge = function (target, source) {
        var _this = this;
        var context = [];
        for (var _i = 2; _i < arguments.length; _i++) {
            context[_i - 2] = arguments[_i];
        }
        if (isNonNullObject(source) && isNonNullObject(target)) {
            Object.keys(source).forEach(function (sourceKey) {
                if (mergeDeep_hasOwnProperty.call(target, sourceKey)) {
                    var targetValue = target[sourceKey];
                    if (source[sourceKey] !== targetValue) {
                        var result = _this.reconciler.apply(_this, (0,tslib_es6/* __spreadArray */.ev)([target, source, sourceKey], context, false));
                        if (result !== targetValue) {
                            target = _this.shallowCopyForMerge(target);
                            target[sourceKey] = result;
                        }
                    }
                }
                else {
                    target = _this.shallowCopyForMerge(target);
                    target[sourceKey] = source[sourceKey];
                }
            });
            return target;
        }
        return source;
    };
    DeepMerger.prototype.shallowCopyForMerge = function (value) {
        if (isNonNullObject(value)) {
            if (!this.pastCopies.has(value)) {
                if (Array.isArray(value)) {
                    value = value.slice(0);
                }
                else {
                    value = (0,tslib_es6/* __assign */.pi)({ __proto__: Object.getPrototypeOf(value) }, value);
                }
                this.pastCopies.add(value);
            }
        }
        return value;
    };
    return DeepMerger;
}());

//# sourceMappingURL=mergeDeep.js.map
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@apollo-client-virtual-cd9e78d17f/0/cache/@apollo-client-npm-3.7.1-a80032e019-95bb1f226f.zip/node_modules/@apollo/client/utilities/graphql/directives.js


function shouldInclude(_a, variables) {
    var directives = _a.directives;
    if (!directives || !directives.length) {
        return true;
    }
    return getInclusionDirectives(directives).every(function (_a) {
        var directive = _a.directive, ifArgument = _a.ifArgument;
        var evaledValue = false;
        if (ifArgument.value.kind === 'Variable') {
            evaledValue = variables && variables[ifArgument.value.name.value];
            __DEV__ ? (0,invariant/* invariant */.kG)(evaledValue !== void 0, "Invalid variable referenced in @".concat(directive.name.value, " directive.")) : (0,invariant/* invariant */.kG)(evaledValue !== void 0, 39);
        }
        else {
            evaledValue = ifArgument.value.value;
        }
        return directive.name.value === 'skip' ? !evaledValue : evaledValue;
    });
}
function getDirectiveNames(root) {
    var names = [];
    visit(root, {
        Directive: function (node) {
            names.push(node.name.value);
        },
    });
    return names;
}
var hasAnyDirectives = function (names, root) { return hasDirectives(names, root, false); };
var hasAllDirectives = function (names, root) { return hasDirectives(names, root, true); };
function hasDirectives(names, root, all) {
    var nameSet = new Set(names);
    var uniqueCount = nameSet.size;
    (0,visitor/* visit */.Vn)(root, {
        Directive: function (node) {
            if (nameSet.delete(node.name.value) &&
                (!all || !nameSet.size)) {
                return visitor/* BREAK */.$_;
            }
        },
    });
    return all ? !nameSet.size : nameSet.size < uniqueCount;
}
function hasClientExports(document) {
    return document && hasDirectives(['client', 'export'], document, true);
}
function isInclusionDirective(_a) {
    var value = _a.name.value;
    return value === 'skip' || value === 'include';
}
function getInclusionDirectives(directives) {
    var result = [];
    if (directives && directives.length) {
        directives.forEach(function (directive) {
            if (!isInclusionDirective(directive))
                return;
            var directiveArguments = directive.arguments;
            var directiveName = directive.name.value;
            __DEV__ ? (0,invariant/* invariant */.kG)(directiveArguments && directiveArguments.length === 1, "Incorrect number of arguments for the @".concat(directiveName, " directive.")) : (0,invariant/* invariant */.kG)(directiveArguments && directiveArguments.length === 1, 40);
            var ifArgument = directiveArguments[0];
            __DEV__ ? (0,invariant/* invariant */.kG)(ifArgument.name && ifArgument.name.value === 'if', "Invalid argument for the @".concat(directiveName, " directive.")) : (0,invariant/* invariant */.kG)(ifArgument.name && ifArgument.name.value === 'if', 41);
            var ifValue = ifArgument.value;
            __DEV__ ? (0,invariant/* invariant */.kG)(ifValue &&
                (ifValue.kind === 'Variable' || ifValue.kind === 'BooleanValue'), "Argument for the @".concat(directiveName, " directive must be a variable or a boolean value.")) : (0,invariant/* invariant */.kG)(ifValue &&
                (ifValue.kind === 'Variable' || ifValue.kind === 'BooleanValue'), 42);
            result.push({ directive: directive, ifArgument: ifArgument });
        });
    }
    return result;
}
//# sourceMappingURL=directives.js.map
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@apollo-client-virtual-cd9e78d17f/0/cache/@apollo-client-npm-3.7.1-a80032e019-95bb1f226f.zip/node_modules/@apollo/client/utilities/common/maybeDeepFreeze.js


function deepFreeze(value) {
    var workSet = new Set([value]);
    workSet.forEach(function (obj) {
        if (isNonNullObject(obj) && shallowFreeze(obj) === obj) {
            Object.getOwnPropertyNames(obj).forEach(function (name) {
                if (isNonNullObject(obj[name]))
                    workSet.add(obj[name]);
            });
        }
    });
    return value;
}
function shallowFreeze(obj) {
    if (__DEV__ && !Object.isFrozen(obj)) {
        try {
            Object.freeze(obj);
        }
        catch (e) {
            if (e instanceof TypeError)
                return null;
            throw e;
        }
    }
    return obj;
}
function maybeDeepFreeze(obj) {
    if (__DEV__) {
        deepFreeze(obj);
    }
    return obj;
}
//# sourceMappingURL=maybeDeepFreeze.js.map
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@apollo-client-virtual-cd9e78d17f/0/cache/@apollo-client-npm-3.7.1-a80032e019-95bb1f226f.zip/node_modules/@apollo/client/cache/inmemory/helpers.js

var hasOwn = Object.prototype.hasOwnProperty;
function isNullish(value) {
    return value === null || value === void 0;
}
var isArray = Array.isArray;
function defaultDataIdFromObject(_a, context) {
    var __typename = _a.__typename, id = _a.id, _id = _a._id;
    if (typeof __typename === "string") {
        if (context) {
            context.keyObject =
                !isNullish(id) ? { id: id } :
                    !isNullish(_id) ? { _id: _id } :
                        void 0;
        }
        if (isNullish(id) && !isNullish(_id)) {
            id = _id;
        }
        if (!isNullish(id)) {
            return "".concat(__typename, ":").concat((typeof id === "number" ||
                typeof id === "string") ? id : JSON.stringify(id));
        }
    }
}
var defaultConfig = {
    dataIdFromObject: defaultDataIdFromObject,
    addTypename: true,
    resultCaching: true,
    canonizeResults: false,
};
function normalizeConfig(config) {
    return compact(defaultConfig, config);
}
function shouldCanonizeResults(config) {
    var value = config.canonizeResults;
    return value === void 0 ? defaultConfig.canonizeResults : value;
}
function getTypenameFromStoreObject(store, objectOrReference) {
    return isReference(objectOrReference)
        ? store.get(objectOrReference.__ref, "__typename")
        : objectOrReference && objectOrReference.__typename;
}
var TypeOrFieldNameRegExp = /^[_a-z][_0-9a-z]*/i;
function fieldNameFromStoreName(storeFieldName) {
    var match = storeFieldName.match(TypeOrFieldNameRegExp);
    return match ? match[0] : storeFieldName;
}
function selectionSetMatchesResult(selectionSet, result, variables) {
    if (isNonNullObject(result)) {
        return isArray(result)
            ? result.every(function (item) { return selectionSetMatchesResult(selectionSet, item, variables); })
            : selectionSet.selections.every(function (field) {
                if (storeUtils_isField(field) && shouldInclude(field, variables)) {
                    var key = resultKeyNameFromField(field);
                    return hasOwn.call(result, key) &&
                        (!field.selectionSet ||
                            selectionSetMatchesResult(field.selectionSet, result[key], variables));
                }
                return true;
            });
    }
    return false;
}
function storeValueIsStoreObject(value) {
    return isNonNullObject(value) &&
        !isReference(value) &&
        !isArray(value);
}
function makeProcessedFieldsMerger() {
    return new DeepMerger;
}
function extractFragmentContext(document, fragments) {
    var fragmentMap = createFragmentMap(getFragmentDefinitions(document));
    return {
        fragmentMap: fragmentMap,
        lookupFragment: function (name) {
            var def = fragmentMap[name];
            if (!def && fragments) {
                def = fragments.lookup(name);
            }
            return def || null;
        },
    };
}
//# sourceMappingURL=helpers.js.map
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@apollo-client-virtual-cd9e78d17f/0/cache/@apollo-client-npm-3.7.1-a80032e019-95bb1f226f.zip/node_modules/@apollo/client/cache/inmemory/entityStore.js







var DELETE = Object.create(null);
var delModifier = function () { return DELETE; };
var INVALIDATE = Object.create(null);
var EntityStore = (function () {
    function EntityStore(policies, group) {
        var _this = this;
        this.policies = policies;
        this.group = group;
        this.data = Object.create(null);
        this.rootIds = Object.create(null);
        this.refs = Object.create(null);
        this.getFieldValue = function (objectOrReference, storeFieldName) { return maybeDeepFreeze(isReference(objectOrReference)
            ? _this.get(objectOrReference.__ref, storeFieldName)
            : objectOrReference && objectOrReference[storeFieldName]); };
        this.canRead = function (objOrRef) {
            return isReference(objOrRef)
                ? _this.has(objOrRef.__ref)
                : typeof objOrRef === "object";
        };
        this.toReference = function (objOrIdOrRef, mergeIntoStore) {
            if (typeof objOrIdOrRef === "string") {
                return makeReference(objOrIdOrRef);
            }
            if (isReference(objOrIdOrRef)) {
                return objOrIdOrRef;
            }
            var id = _this.policies.identify(objOrIdOrRef)[0];
            if (id) {
                var ref = makeReference(id);
                if (mergeIntoStore) {
                    _this.merge(id, objOrIdOrRef);
                }
                return ref;
            }
        };
    }
    EntityStore.prototype.toObject = function () {
        return (0,tslib_es6/* __assign */.pi)({}, this.data);
    };
    EntityStore.prototype.has = function (dataId) {
        return this.lookup(dataId, true) !== void 0;
    };
    EntityStore.prototype.get = function (dataId, fieldName) {
        this.group.depend(dataId, fieldName);
        if (hasOwn.call(this.data, dataId)) {
            var storeObject = this.data[dataId];
            if (storeObject && hasOwn.call(storeObject, fieldName)) {
                return storeObject[fieldName];
            }
        }
        if (fieldName === "__typename" &&
            hasOwn.call(this.policies.rootTypenamesById, dataId)) {
            return this.policies.rootTypenamesById[dataId];
        }
        if (this instanceof Layer) {
            return this.parent.get(dataId, fieldName);
        }
    };
    EntityStore.prototype.lookup = function (dataId, dependOnExistence) {
        if (dependOnExistence)
            this.group.depend(dataId, "__exists");
        if (hasOwn.call(this.data, dataId)) {
            return this.data[dataId];
        }
        if (this instanceof Layer) {
            return this.parent.lookup(dataId, dependOnExistence);
        }
        if (this.policies.rootTypenamesById[dataId]) {
            return Object.create(null);
        }
    };
    EntityStore.prototype.merge = function (older, newer) {
        var _this = this;
        var dataId;
        if (isReference(older))
            older = older.__ref;
        if (isReference(newer))
            newer = newer.__ref;
        var existing = typeof older === "string"
            ? this.lookup(dataId = older)
            : older;
        var incoming = typeof newer === "string"
            ? this.lookup(dataId = newer)
            : newer;
        if (!incoming)
            return;
        __DEV__ ? (0,invariant/* invariant */.kG)(typeof dataId === "string", "store.merge expects a string ID") : (0,invariant/* invariant */.kG)(typeof dataId === "string", 1);
        var merged = new DeepMerger(storeObjectReconciler).merge(existing, incoming);
        this.data[dataId] = merged;
        if (merged !== existing) {
            delete this.refs[dataId];
            if (this.group.caching) {
                var fieldsToDirty_1 = Object.create(null);
                if (!existing)
                    fieldsToDirty_1.__exists = 1;
                Object.keys(incoming).forEach(function (storeFieldName) {
                    if (!existing || existing[storeFieldName] !== merged[storeFieldName]) {
                        fieldsToDirty_1[storeFieldName] = 1;
                        var fieldName = fieldNameFromStoreName(storeFieldName);
                        if (fieldName !== storeFieldName &&
                            !_this.policies.hasKeyArgs(merged.__typename, fieldName)) {
                            fieldsToDirty_1[fieldName] = 1;
                        }
                        if (merged[storeFieldName] === void 0 && !(_this instanceof Layer)) {
                            delete merged[storeFieldName];
                        }
                    }
                });
                if (fieldsToDirty_1.__typename &&
                    !(existing && existing.__typename) &&
                    this.policies.rootTypenamesById[dataId] === merged.__typename) {
                    delete fieldsToDirty_1.__typename;
                }
                Object.keys(fieldsToDirty_1).forEach(function (fieldName) { return _this.group.dirty(dataId, fieldName); });
            }
        }
    };
    EntityStore.prototype.modify = function (dataId, fields) {
        var _this = this;
        var storeObject = this.lookup(dataId);
        if (storeObject) {
            var changedFields_1 = Object.create(null);
            var needToMerge_1 = false;
            var allDeleted_1 = true;
            var sharedDetails_1 = {
                DELETE: DELETE,
                INVALIDATE: INVALIDATE,
                isReference: isReference,
                toReference: this.toReference,
                canRead: this.canRead,
                readField: function (fieldNameOrOptions, from) { return _this.policies.readField(typeof fieldNameOrOptions === "string" ? {
                    fieldName: fieldNameOrOptions,
                    from: from || makeReference(dataId),
                } : fieldNameOrOptions, { store: _this }); },
            };
            Object.keys(storeObject).forEach(function (storeFieldName) {
                var fieldName = fieldNameFromStoreName(storeFieldName);
                var fieldValue = storeObject[storeFieldName];
                if (fieldValue === void 0)
                    return;
                var modify = typeof fields === "function"
                    ? fields
                    : fields[storeFieldName] || fields[fieldName];
                if (modify) {
                    var newValue = modify === delModifier ? DELETE :
                        modify(maybeDeepFreeze(fieldValue), (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, sharedDetails_1), { fieldName: fieldName, storeFieldName: storeFieldName, storage: _this.getStorage(dataId, storeFieldName) }));
                    if (newValue === INVALIDATE) {
                        _this.group.dirty(dataId, storeFieldName);
                    }
                    else {
                        if (newValue === DELETE)
                            newValue = void 0;
                        if (newValue !== fieldValue) {
                            changedFields_1[storeFieldName] = newValue;
                            needToMerge_1 = true;
                            fieldValue = newValue;
                        }
                    }
                }
                if (fieldValue !== void 0) {
                    allDeleted_1 = false;
                }
            });
            if (needToMerge_1) {
                this.merge(dataId, changedFields_1);
                if (allDeleted_1) {
                    if (this instanceof Layer) {
                        this.data[dataId] = void 0;
                    }
                    else {
                        delete this.data[dataId];
                    }
                    this.group.dirty(dataId, "__exists");
                }
                return true;
            }
        }
        return false;
    };
    EntityStore.prototype.delete = function (dataId, fieldName, args) {
        var _a;
        var storeObject = this.lookup(dataId);
        if (storeObject) {
            var typename = this.getFieldValue(storeObject, "__typename");
            var storeFieldName = fieldName && args
                ? this.policies.getStoreFieldName({ typename: typename, fieldName: fieldName, args: args })
                : fieldName;
            return this.modify(dataId, storeFieldName ? (_a = {},
                _a[storeFieldName] = delModifier,
                _a) : delModifier);
        }
        return false;
    };
    EntityStore.prototype.evict = function (options, limit) {
        var evicted = false;
        if (options.id) {
            if (hasOwn.call(this.data, options.id)) {
                evicted = this.delete(options.id, options.fieldName, options.args);
            }
            if (this instanceof Layer && this !== limit) {
                evicted = this.parent.evict(options, limit) || evicted;
            }
            if (options.fieldName || evicted) {
                this.group.dirty(options.id, options.fieldName || "__exists");
            }
        }
        return evicted;
    };
    EntityStore.prototype.clear = function () {
        this.replace(null);
    };
    EntityStore.prototype.extract = function () {
        var _this = this;
        var obj = this.toObject();
        var extraRootIds = [];
        this.getRootIdSet().forEach(function (id) {
            if (!hasOwn.call(_this.policies.rootTypenamesById, id)) {
                extraRootIds.push(id);
            }
        });
        if (extraRootIds.length) {
            obj.__META = { extraRootIds: extraRootIds.sort() };
        }
        return obj;
    };
    EntityStore.prototype.replace = function (newData) {
        var _this = this;
        Object.keys(this.data).forEach(function (dataId) {
            if (!(newData && hasOwn.call(newData, dataId))) {
                _this.delete(dataId);
            }
        });
        if (newData) {
            var __META = newData.__META, rest_1 = (0,tslib_es6/* __rest */._T)(newData, ["__META"]);
            Object.keys(rest_1).forEach(function (dataId) {
                _this.merge(dataId, rest_1[dataId]);
            });
            if (__META) {
                __META.extraRootIds.forEach(this.retain, this);
            }
        }
    };
    EntityStore.prototype.retain = function (rootId) {
        return this.rootIds[rootId] = (this.rootIds[rootId] || 0) + 1;
    };
    EntityStore.prototype.release = function (rootId) {
        if (this.rootIds[rootId] > 0) {
            var count = --this.rootIds[rootId];
            if (!count)
                delete this.rootIds[rootId];
            return count;
        }
        return 0;
    };
    EntityStore.prototype.getRootIdSet = function (ids) {
        if (ids === void 0) { ids = new Set(); }
        Object.keys(this.rootIds).forEach(ids.add, ids);
        if (this instanceof Layer) {
            this.parent.getRootIdSet(ids);
        }
        else {
            Object.keys(this.policies.rootTypenamesById).forEach(ids.add, ids);
        }
        return ids;
    };
    EntityStore.prototype.gc = function () {
        var _this = this;
        var ids = this.getRootIdSet();
        var snapshot = this.toObject();
        ids.forEach(function (id) {
            if (hasOwn.call(snapshot, id)) {
                Object.keys(_this.findChildRefIds(id)).forEach(ids.add, ids);
                delete snapshot[id];
            }
        });
        var idsToRemove = Object.keys(snapshot);
        if (idsToRemove.length) {
            var root_1 = this;
            while (root_1 instanceof Layer)
                root_1 = root_1.parent;
            idsToRemove.forEach(function (id) { return root_1.delete(id); });
        }
        return idsToRemove;
    };
    EntityStore.prototype.findChildRefIds = function (dataId) {
        if (!hasOwn.call(this.refs, dataId)) {
            var found_1 = this.refs[dataId] = Object.create(null);
            var root = this.data[dataId];
            if (!root)
                return found_1;
            var workSet_1 = new Set([root]);
            workSet_1.forEach(function (obj) {
                if (isReference(obj)) {
                    found_1[obj.__ref] = true;
                }
                if (isNonNullObject(obj)) {
                    Object.keys(obj).forEach(function (key) {
                        var child = obj[key];
                        if (isNonNullObject(child)) {
                            workSet_1.add(child);
                        }
                    });
                }
            });
        }
        return this.refs[dataId];
    };
    EntityStore.prototype.makeCacheKey = function () {
        return this.group.keyMaker.lookupArray(arguments);
    };
    return EntityStore;
}());

var CacheGroup = (function () {
    function CacheGroup(caching, parent) {
        if (parent === void 0) { parent = null; }
        this.caching = caching;
        this.parent = parent;
        this.d = null;
        this.resetCaching();
    }
    CacheGroup.prototype.resetCaching = function () {
        this.d = this.caching ? dep() : null;
        this.keyMaker = new Trie(canUseWeakMap);
    };
    CacheGroup.prototype.depend = function (dataId, storeFieldName) {
        if (this.d) {
            this.d(makeDepKey(dataId, storeFieldName));
            var fieldName = fieldNameFromStoreName(storeFieldName);
            if (fieldName !== storeFieldName) {
                this.d(makeDepKey(dataId, fieldName));
            }
            if (this.parent) {
                this.parent.depend(dataId, storeFieldName);
            }
        }
    };
    CacheGroup.prototype.dirty = function (dataId, storeFieldName) {
        if (this.d) {
            this.d.dirty(makeDepKey(dataId, storeFieldName), storeFieldName === "__exists" ? "forget" : "setDirty");
        }
    };
    return CacheGroup;
}());
function makeDepKey(dataId, storeFieldName) {
    return storeFieldName + '#' + dataId;
}
function maybeDependOnExistenceOfEntity(store, entityId) {
    if (supportsResultCaching(store)) {
        store.group.depend(entityId, "__exists");
    }
}
(function (EntityStore) {
    var Root = (function (_super) {
        (0,tslib_es6/* __extends */.ZT)(Root, _super);
        function Root(_a) {
            var policies = _a.policies, _b = _a.resultCaching, resultCaching = _b === void 0 ? true : _b, seed = _a.seed;
            var _this = _super.call(this, policies, new CacheGroup(resultCaching)) || this;
            _this.stump = new Stump(_this);
            _this.storageTrie = new Trie(canUseWeakMap);
            if (seed)
                _this.replace(seed);
            return _this;
        }
        Root.prototype.addLayer = function (layerId, replay) {
            return this.stump.addLayer(layerId, replay);
        };
        Root.prototype.removeLayer = function () {
            return this;
        };
        Root.prototype.getStorage = function () {
            return this.storageTrie.lookupArray(arguments);
        };
        return Root;
    }(EntityStore));
    EntityStore.Root = Root;
})(EntityStore || (EntityStore = {}));
var Layer = (function (_super) {
    (0,tslib_es6/* __extends */.ZT)(Layer, _super);
    function Layer(id, parent, replay, group) {
        var _this = _super.call(this, parent.policies, group) || this;
        _this.id = id;
        _this.parent = parent;
        _this.replay = replay;
        _this.group = group;
        replay(_this);
        return _this;
    }
    Layer.prototype.addLayer = function (layerId, replay) {
        return new Layer(layerId, this, replay, this.group);
    };
    Layer.prototype.removeLayer = function (layerId) {
        var _this = this;
        var parent = this.parent.removeLayer(layerId);
        if (layerId === this.id) {
            if (this.group.caching) {
                Object.keys(this.data).forEach(function (dataId) {
                    var ownStoreObject = _this.data[dataId];
                    var parentStoreObject = parent["lookup"](dataId);
                    if (!parentStoreObject) {
                        _this.delete(dataId);
                    }
                    else if (!ownStoreObject) {
                        _this.group.dirty(dataId, "__exists");
                        Object.keys(parentStoreObject).forEach(function (storeFieldName) {
                            _this.group.dirty(dataId, storeFieldName);
                        });
                    }
                    else if (ownStoreObject !== parentStoreObject) {
                        Object.keys(ownStoreObject).forEach(function (storeFieldName) {
                            if (!equal(ownStoreObject[storeFieldName], parentStoreObject[storeFieldName])) {
                                _this.group.dirty(dataId, storeFieldName);
                            }
                        });
                    }
                });
            }
            return parent;
        }
        if (parent === this.parent)
            return this;
        return parent.addLayer(this.id, this.replay);
    };
    Layer.prototype.toObject = function () {
        return (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, this.parent.toObject()), this.data);
    };
    Layer.prototype.findChildRefIds = function (dataId) {
        var fromParent = this.parent.findChildRefIds(dataId);
        return hasOwn.call(this.data, dataId) ? (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, fromParent), _super.prototype.findChildRefIds.call(this, dataId)) : fromParent;
    };
    Layer.prototype.getStorage = function () {
        var p = this.parent;
        while (p.parent)
            p = p.parent;
        return p.getStorage.apply(p, arguments);
    };
    return Layer;
}(EntityStore));
var Stump = (function (_super) {
    (0,tslib_es6/* __extends */.ZT)(Stump, _super);
    function Stump(root) {
        return _super.call(this, "EntityStore.Stump", root, function () { }, new CacheGroup(root.group.caching, root.group)) || this;
    }
    Stump.prototype.removeLayer = function () {
        return this;
    };
    Stump.prototype.merge = function () {
        return this.parent.merge.apply(this.parent, arguments);
    };
    return Stump;
}(Layer));
function storeObjectReconciler(existingObject, incomingObject, property) {
    var existingValue = existingObject[property];
    var incomingValue = incomingObject[property];
    return equal(existingValue, incomingValue) ? existingValue : incomingValue;
}
function supportsResultCaching(store) {
    return !!(store instanceof EntityStore && store.group.caching);
}
//# sourceMappingURL=entityStore.js.map
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@apollo-client-virtual-cd9e78d17f/0/cache/@apollo-client-npm-3.7.1-a80032e019-95bb1f226f.zip/node_modules/@apollo/client/cache/inmemory/object-canon.js





function shallowCopy(value) {
    if (isNonNullObject(value)) {
        return isArray(value)
            ? value.slice(0)
            : (0,tslib_es6/* __assign */.pi)({ __proto__: Object.getPrototypeOf(value) }, value);
    }
    return value;
}
var ObjectCanon = (function () {
    function ObjectCanon() {
        this.known = new (canUseWeakSet ? WeakSet : Set)();
        this.pool = new Trie(canUseWeakMap);
        this.passes = new WeakMap();
        this.keysByJSON = new Map();
        this.empty = this.admit({});
    }
    ObjectCanon.prototype.isKnown = function (value) {
        return isNonNullObject(value) && this.known.has(value);
    };
    ObjectCanon.prototype.pass = function (value) {
        if (isNonNullObject(value)) {
            var copy = shallowCopy(value);
            this.passes.set(copy, value);
            return copy;
        }
        return value;
    };
    ObjectCanon.prototype.admit = function (value) {
        var _this = this;
        if (isNonNullObject(value)) {
            var original = this.passes.get(value);
            if (original)
                return original;
            var proto = Object.getPrototypeOf(value);
            switch (proto) {
                case Array.prototype: {
                    if (this.known.has(value))
                        return value;
                    var array = value.map(this.admit, this);
                    var node = this.pool.lookupArray(array);
                    if (!node.array) {
                        this.known.add(node.array = array);
                        if (__DEV__) {
                            Object.freeze(array);
                        }
                    }
                    return node.array;
                }
                case null:
                case Object.prototype: {
                    if (this.known.has(value))
                        return value;
                    var proto_1 = Object.getPrototypeOf(value);
                    var array_1 = [proto_1];
                    var keys = this.sortedKeys(value);
                    array_1.push(keys.json);
                    var firstValueIndex_1 = array_1.length;
                    keys.sorted.forEach(function (key) {
                        array_1.push(_this.admit(value[key]));
                    });
                    var node = this.pool.lookupArray(array_1);
                    if (!node.object) {
                        var obj_1 = node.object = Object.create(proto_1);
                        this.known.add(obj_1);
                        keys.sorted.forEach(function (key, i) {
                            obj_1[key] = array_1[firstValueIndex_1 + i];
                        });
                        if (__DEV__) {
                            Object.freeze(obj_1);
                        }
                    }
                    return node.object;
                }
            }
        }
        return value;
    };
    ObjectCanon.prototype.sortedKeys = function (obj) {
        var keys = Object.keys(obj);
        var node = this.pool.lookupArray(keys);
        if (!node.keys) {
            keys.sort();
            var json = JSON.stringify(keys);
            if (!(node.keys = this.keysByJSON.get(json))) {
                this.keysByJSON.set(json, node.keys = { sorted: keys, json: json });
            }
        }
        return node.keys;
    };
    return ObjectCanon;
}());

var canonicalStringify = Object.assign(function (value) {
    if (isNonNullObject(value)) {
        if (stringifyCanon === void 0) {
            resetCanonicalStringify();
        }
        var canonical = stringifyCanon.admit(value);
        var json = stringifyCache.get(canonical);
        if (json === void 0) {
            stringifyCache.set(canonical, json = JSON.stringify(canonical));
        }
        return json;
    }
    return JSON.stringify(value);
}, {
    reset: resetCanonicalStringify,
});
var stringifyCanon;
var stringifyCache;
function resetCanonicalStringify() {
    stringifyCanon = new ObjectCanon;
    stringifyCache = new (canUseWeakMap ? WeakMap : Map)();
}
//# sourceMappingURL=object-canon.js.map
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@apollo-client-virtual-cd9e78d17f/0/cache/@apollo-client-npm-3.7.1-a80032e019-95bb1f226f.zip/node_modules/@apollo/client/cache/inmemory/readFromStore.js









;
function execSelectionSetKeyArgs(options) {
    return [
        options.selectionSet,
        options.objectOrReference,
        options.context,
        options.context.canonizeResults,
    ];
}
var StoreReader = (function () {
    function StoreReader(config) {
        var _this = this;
        this.knownResults = new (canUseWeakMap ? WeakMap : Map)();
        this.config = compact(config, {
            addTypename: config.addTypename !== false,
            canonizeResults: shouldCanonizeResults(config),
        });
        this.canon = config.canon || new ObjectCanon;
        this.executeSelectionSet = wrap(function (options) {
            var _a;
            var canonizeResults = options.context.canonizeResults;
            var peekArgs = execSelectionSetKeyArgs(options);
            peekArgs[3] = !canonizeResults;
            var other = (_a = _this.executeSelectionSet).peek.apply(_a, peekArgs);
            if (other) {
                if (canonizeResults) {
                    return (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, other), { result: _this.canon.admit(other.result) });
                }
                return other;
            }
            maybeDependOnExistenceOfEntity(options.context.store, options.enclosingRef.__ref);
            return _this.execSelectionSetImpl(options);
        }, {
            max: this.config.resultCacheMaxSize,
            keyArgs: execSelectionSetKeyArgs,
            makeCacheKey: function (selectionSet, parent, context, canonizeResults) {
                if (supportsResultCaching(context.store)) {
                    return context.store.makeCacheKey(selectionSet, isReference(parent) ? parent.__ref : parent, context.varString, canonizeResults);
                }
            }
        });
        this.executeSubSelectedArray = wrap(function (options) {
            maybeDependOnExistenceOfEntity(options.context.store, options.enclosingRef.__ref);
            return _this.execSubSelectedArrayImpl(options);
        }, {
            max: this.config.resultCacheMaxSize,
            makeCacheKey: function (_a) {
                var field = _a.field, array = _a.array, context = _a.context;
                if (supportsResultCaching(context.store)) {
                    return context.store.makeCacheKey(field, array, context.varString);
                }
            }
        });
    }
    StoreReader.prototype.resetCanon = function () {
        this.canon = new ObjectCanon;
    };
    StoreReader.prototype.diffQueryAgainstStore = function (_a) {
        var store = _a.store, query = _a.query, _b = _a.rootId, rootId = _b === void 0 ? 'ROOT_QUERY' : _b, variables = _a.variables, _c = _a.returnPartialData, returnPartialData = _c === void 0 ? true : _c, _d = _a.canonizeResults, canonizeResults = _d === void 0 ? this.config.canonizeResults : _d;
        var policies = this.config.cache.policies;
        variables = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, getDefaultValues(getQueryDefinition(query))), variables);
        var rootRef = makeReference(rootId);
        var execResult = this.executeSelectionSet({
            selectionSet: getMainDefinition(query).selectionSet,
            objectOrReference: rootRef,
            enclosingRef: rootRef,
            context: (0,tslib_es6/* __assign */.pi)({ store: store, query: query, policies: policies, variables: variables, varString: canonicalStringify(variables), canonizeResults: canonizeResults }, extractFragmentContext(query, this.config.fragments)),
        });
        var missing;
        if (execResult.missing) {
            missing = [new MissingFieldError(firstMissing(execResult.missing), execResult.missing, query, variables)];
            if (!returnPartialData) {
                throw missing[0];
            }
        }
        return {
            result: execResult.result,
            complete: !missing,
            missing: missing,
        };
    };
    StoreReader.prototype.isFresh = function (result, parent, selectionSet, context) {
        if (supportsResultCaching(context.store) &&
            this.knownResults.get(result) === selectionSet) {
            var latest = this.executeSelectionSet.peek(selectionSet, parent, context, this.canon.isKnown(result));
            if (latest && result === latest.result) {
                return true;
            }
        }
        return false;
    };
    StoreReader.prototype.execSelectionSetImpl = function (_a) {
        var _this = this;
        var selectionSet = _a.selectionSet, objectOrReference = _a.objectOrReference, enclosingRef = _a.enclosingRef, context = _a.context;
        if (isReference(objectOrReference) &&
            !context.policies.rootTypenamesById[objectOrReference.__ref] &&
            !context.store.has(objectOrReference.__ref)) {
            return {
                result: this.canon.empty,
                missing: "Dangling reference to missing ".concat(objectOrReference.__ref, " object"),
            };
        }
        var variables = context.variables, policies = context.policies, store = context.store;
        var typename = store.getFieldValue(objectOrReference, "__typename");
        var objectsToMerge = [];
        var missing;
        var missingMerger = new DeepMerger();
        if (this.config.addTypename &&
            typeof typename === "string" &&
            !policies.rootIdsByTypename[typename]) {
            objectsToMerge.push({ __typename: typename });
        }
        function handleMissing(result, resultName) {
            var _a;
            if (result.missing) {
                missing = missingMerger.merge(missing, (_a = {}, _a[resultName] = result.missing, _a));
            }
            return result.result;
        }
        var workSet = new Set(selectionSet.selections);
        workSet.forEach(function (selection) {
            var _a, _b;
            if (!shouldInclude(selection, variables))
                return;
            if (storeUtils_isField(selection)) {
                var fieldValue = policies.readField({
                    fieldName: selection.name.value,
                    field: selection,
                    variables: context.variables,
                    from: objectOrReference,
                }, context);
                var resultName = resultKeyNameFromField(selection);
                if (fieldValue === void 0) {
                    if (!addTypenameToDocument.added(selection)) {
                        missing = missingMerger.merge(missing, (_a = {},
                            _a[resultName] = "Can't find field '".concat(selection.name.value, "' on ").concat(isReference(objectOrReference)
                                ? objectOrReference.__ref + " object"
                                : "object " + JSON.stringify(objectOrReference, null, 2)),
                            _a));
                    }
                }
                else if (isArray(fieldValue)) {
                    fieldValue = handleMissing(_this.executeSubSelectedArray({
                        field: selection,
                        array: fieldValue,
                        enclosingRef: enclosingRef,
                        context: context,
                    }), resultName);
                }
                else if (!selection.selectionSet) {
                    if (context.canonizeResults) {
                        fieldValue = _this.canon.pass(fieldValue);
                    }
                }
                else if (fieldValue != null) {
                    fieldValue = handleMissing(_this.executeSelectionSet({
                        selectionSet: selection.selectionSet,
                        objectOrReference: fieldValue,
                        enclosingRef: isReference(fieldValue) ? fieldValue : enclosingRef,
                        context: context,
                    }), resultName);
                }
                if (fieldValue !== void 0) {
                    objectsToMerge.push((_b = {}, _b[resultName] = fieldValue, _b));
                }
            }
            else {
                var fragment = getFragmentFromSelection(selection, context.lookupFragment);
                if (!fragment && selection.kind === kinds/* Kind.FRAGMENT_SPREAD */.h.FRAGMENT_SPREAD) {
                    throw __DEV__ ? new invariant/* InvariantError */.ej("No fragment named ".concat(selection.name.value)) : new invariant/* InvariantError */.ej(5);
                }
                if (fragment && policies.fragmentMatches(fragment, typename)) {
                    fragment.selectionSet.selections.forEach(workSet.add, workSet);
                }
            }
        });
        var result = mergeDeepArray(objectsToMerge);
        var finalResult = { result: result, missing: missing };
        var frozen = context.canonizeResults
            ? this.canon.admit(finalResult)
            : maybeDeepFreeze(finalResult);
        if (frozen.result) {
            this.knownResults.set(frozen.result, selectionSet);
        }
        return frozen;
    };
    StoreReader.prototype.execSubSelectedArrayImpl = function (_a) {
        var _this = this;
        var field = _a.field, array = _a.array, enclosingRef = _a.enclosingRef, context = _a.context;
        var missing;
        var missingMerger = new DeepMerger();
        function handleMissing(childResult, i) {
            var _a;
            if (childResult.missing) {
                missing = missingMerger.merge(missing, (_a = {}, _a[i] = childResult.missing, _a));
            }
            return childResult.result;
        }
        if (field.selectionSet) {
            array = array.filter(context.store.canRead);
        }
        array = array.map(function (item, i) {
            if (item === null) {
                return null;
            }
            if (isArray(item)) {
                return handleMissing(_this.executeSubSelectedArray({
                    field: field,
                    array: item,
                    enclosingRef: enclosingRef,
                    context: context,
                }), i);
            }
            if (field.selectionSet) {
                return handleMissing(_this.executeSelectionSet({
                    selectionSet: field.selectionSet,
                    objectOrReference: item,
                    enclosingRef: isReference(item) ? item : enclosingRef,
                    context: context,
                }), i);
            }
            if (__DEV__) {
                assertSelectionSetForIdValue(context.store, field, item);
            }
            return item;
        });
        return {
            result: context.canonizeResults ? this.canon.admit(array) : array,
            missing: missing,
        };
    };
    return StoreReader;
}());

function firstMissing(tree) {
    try {
        JSON.stringify(tree, function (_, value) {
            if (typeof value === "string")
                throw value;
            return value;
        });
    }
    catch (result) {
        return result;
    }
}
function assertSelectionSetForIdValue(store, field, fieldValue) {
    if (!field.selectionSet) {
        var workSet_1 = new Set([fieldValue]);
        workSet_1.forEach(function (value) {
            if (isNonNullObject(value)) {
                __DEV__ ? (0,invariant/* invariant */.kG)(!isReference(value), "Missing selection set for object of type ".concat(getTypenameFromStoreObject(store, value), " returned for query field ").concat(field.name.value)) : (0,invariant/* invariant */.kG)(!isReference(value), 6);
                Object.values(value).forEach(workSet_1.add, workSet_1);
            }
        });
    }
}
//# sourceMappingURL=readFromStore.js.map
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@apollo-client-virtual-cd9e78d17f/0/cache/@apollo-client-npm-3.7.1-a80032e019-95bb1f226f.zip/node_modules/@apollo/client/utilities/common/cloneDeep.js
var cloneDeep_toString = Object.prototype.toString;
function cloneDeep(value) {
    return cloneDeepHelper(value);
}
function cloneDeepHelper(val, seen) {
    switch (cloneDeep_toString.call(val)) {
        case "[object Array]": {
            seen = seen || new Map;
            if (seen.has(val))
                return seen.get(val);
            var copy_1 = val.slice(0);
            seen.set(val, copy_1);
            copy_1.forEach(function (child, i) {
                copy_1[i] = cloneDeepHelper(child, seen);
            });
            return copy_1;
        }
        case "[object Object]": {
            seen = seen || new Map;
            if (seen.has(val))
                return seen.get(val);
            var copy_2 = Object.create(Object.getPrototypeOf(val));
            seen.set(val, copy_2);
            Object.keys(val).forEach(function (key) {
                copy_2[key] = cloneDeepHelper(val[key], seen);
            });
            return copy_2;
        }
        default:
            return val;
    }
}
//# sourceMappingURL=cloneDeep.js.map
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@apollo-client-virtual-cd9e78d17f/0/cache/@apollo-client-npm-3.7.1-a80032e019-95bb1f226f.zip/node_modules/@apollo/client/utilities/common/arrays.js
function isNonEmptyArray(value) {
    return Array.isArray(value) && value.length > 0;
}
//# sourceMappingURL=arrays.js.map
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@apollo-client-virtual-cd9e78d17f/0/cache/@apollo-client-npm-3.7.1-a80032e019-95bb1f226f.zip/node_modules/@apollo/client/utilities/common/makeUniqueId.js
var prefixCounts = new Map();
function makeUniqueId(prefix) {
    var count = prefixCounts.get(prefix) || 1;
    prefixCounts.set(prefix, count + 1);
    return "".concat(prefix, ":").concat(count, ":").concat(Math.random().toString(36).slice(2));
}
//# sourceMappingURL=makeUniqueId.js.map
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@apollo-client-virtual-cd9e78d17f/0/cache/@apollo-client-npm-3.7.1-a80032e019-95bb1f226f.zip/node_modules/@apollo/client/utilities/common/stringifyForDisplay.js

function stringifyForDisplay(value) {
    var undefId = makeUniqueId("stringifyForDisplay");
    return JSON.stringify(value, function (key, value) {
        return value === void 0 ? undefId : value;
    }).split(JSON.stringify(undefId)).join("<undefined>");
}
//# sourceMappingURL=stringifyForDisplay.js.map
;// CONCATENATED MODULE: ../../.yarn/cache/@wry-context-npm-0.7.0-0eeba0eb62-f4ff78023a.zip/node_modules/@wry/context/lib/context.esm.js
// This currentContext variable will only be used if the makeSlotClass
// function is called, which happens only if this is the first copy of the
// @wry/context package to be imported.
var context_esm_currentContext = null;
// This unique internal object is used to denote the absence of a value
// for a given Slot, and is never exposed to outside code.
var context_esm_MISSING_VALUE = {};
var context_esm_idCounter = 1;
// Although we can't do anything about the cost of duplicated code from
// accidentally bundling multiple copies of the @wry/context package, we can
// avoid creating the Slot class more than once using makeSlotClass.
var context_esm_makeSlotClass = function () { return /** @class */ (function () {
    function Slot() {
        // If you have a Slot object, you can find out its slot.id, but you cannot
        // guess the slot.id of a Slot you don't have access to, thanks to the
        // randomized suffix.
        this.id = [
            "slot",
            context_esm_idCounter++,
            Date.now(),
            Math.random().toString(36).slice(2),
        ].join(":");
    }
    Slot.prototype.hasValue = function () {
        for (var context_1 = context_esm_currentContext; context_1; context_1 = context_1.parent) {
            // We use the Slot object iself as a key to its value, which means the
            // value cannot be obtained without a reference to the Slot object.
            if (this.id in context_1.slots) {
                var value = context_1.slots[this.id];
                if (value === context_esm_MISSING_VALUE)
                    break;
                if (context_1 !== context_esm_currentContext) {
                    // Cache the value in currentContext.slots so the next lookup will
                    // be faster. This caching is safe because the tree of contexts and
                    // the values of the slots are logically immutable.
                    context_esm_currentContext.slots[this.id] = value;
                }
                return true;
            }
        }
        if (context_esm_currentContext) {
            // If a value was not found for this Slot, it's never going to be found
            // no matter how many times we look it up, so we might as well cache
            // the absence of the value, too.
            context_esm_currentContext.slots[this.id] = context_esm_MISSING_VALUE;
        }
        return false;
    };
    Slot.prototype.getValue = function () {
        if (this.hasValue()) {
            return context_esm_currentContext.slots[this.id];
        }
    };
    Slot.prototype.withValue = function (value, callback, 
    // Given the prevalence of arrow functions, specifying arguments is likely
    // to be much more common than specifying `this`, hence this ordering:
    args, thisArg) {
        var _a;
        var slots = (_a = {
                __proto__: null
            },
            _a[this.id] = value,
            _a);
        var parent = context_esm_currentContext;
        context_esm_currentContext = { parent: parent, slots: slots };
        try {
            // Function.prototype.apply allows the arguments array argument to be
            // omitted or undefined, so args! is fine here.
            return callback.apply(thisArg, args);
        }
        finally {
            context_esm_currentContext = parent;
        }
    };
    // Capture the current context and wrap a callback function so that it
    // reestablishes the captured context when called.
    Slot.bind = function (callback) {
        var context = context_esm_currentContext;
        return function () {
            var saved = context_esm_currentContext;
            try {
                context_esm_currentContext = context;
                return callback.apply(this, arguments);
            }
            finally {
                context_esm_currentContext = saved;
            }
        };
    };
    // Immediately run a callback function without any captured context.
    Slot.noContext = function (callback, 
    // Given the prevalence of arrow functions, specifying arguments is likely
    // to be much more common than specifying `this`, hence this ordering:
    args, thisArg) {
        if (context_esm_currentContext) {
            var saved = context_esm_currentContext;
            try {
                context_esm_currentContext = null;
                // Function.prototype.apply allows the arguments array argument to be
                // omitted or undefined, so args! is fine here.
                return callback.apply(thisArg, args);
            }
            finally {
                context_esm_currentContext = saved;
            }
        }
        else {
            return callback.apply(thisArg, args);
        }
    };
    return Slot;
}()); };
function context_esm_maybe(fn) {
    try {
        return fn();
    }
    catch (ignored) { }
}
// We store a single global implementation of the Slot class as a permanent
// non-enumerable property of the globalThis object. This obfuscation does
// nothing to prevent access to the Slot class, but at least it ensures the
// implementation (i.e. currentContext) cannot be tampered with, and all copies
// of the @wry/context package (hopefully just one) will share the same Slot
// implementation. Since the first copy of the @wry/context package to be
// imported wins, this technique imposes a steep cost for any future breaking
// changes to the Slot class.
var context_esm_globalKey = "@wry/context:Slot";
var context_esm_host = 
// Prefer globalThis when available.
// https://github.com/benjamn/wryware/issues/347
context_esm_maybe(function () { return globalThis; }) ||
    // Fall back to global, which works in Node.js and may be converted by some
    // bundlers to the appropriate identifier (window, self, ...) depending on the
    // bundling target. https://github.com/endojs/endo/issues/576#issuecomment-1178515224
    context_esm_maybe(function () { return __webpack_require__.g; }) ||
    // Otherwise, use a dummy host that's local to this module. We used to fall
    // back to using the Array constructor as a namespace, but that was flagged in
    // https://github.com/benjamn/wryware/issues/347, and can be avoided.
    Object.create(null);
// Whichever globalHost we're using, make TypeScript happy about the additional
// globalKey property.
var globalHost = context_esm_host;
var context_esm_Slot = globalHost[context_esm_globalKey] ||
    // Earlier versions of this package stored the globalKey property on the Array
    // constructor, so we check there as well, to prevent Slot class duplication.
    Array[context_esm_globalKey] ||
    (function (Slot) {
        try {
            Object.defineProperty(globalHost, context_esm_globalKey, {
                value: Slot,
                enumerable: false,
                writable: false,
                // When it was possible for globalHost to be the Array constructor (a
                // legacy Slot dedup strategy), it was important for the property to be
                // configurable:true so it could be deleted. That does not seem to be as
                // important when globalHost is the global object, but I don't want to
                // cause similar problems again, and configurable:true seems safest.
                // https://github.com/endojs/endo/issues/576#issuecomment-1178274008
                configurable: true
            });
        }
        finally {
            return Slot;
        }
    })(context_esm_makeSlotClass());

var context_esm_bind = context_esm_Slot.bind, context_esm_noContext = context_esm_Slot.noContext;
function context_esm_setTimeoutWithContext(callback, delay) {
    return setTimeout(context_esm_bind(callback), delay);
}
// Turn any generator function into an async function (using yield instead
// of await), with context automatically preserved across yields.
function context_esm_asyncFromGen(genFn) {
    return function () {
        var gen = genFn.apply(this, arguments);
        var boundNext = context_esm_bind(gen.next);
        var boundThrow = context_esm_bind(gen.throw);
        return new Promise(function (resolve, reject) {
            function invoke(method, argument) {
                try {
                    var result = method.call(gen, argument);
                }
                catch (error) {
                    return reject(error);
                }
                var next = result.done ? resolve : invokeNext;
                if (context_esm_isPromiseLike(result.value)) {
                    result.value.then(next, result.done ? reject : invokeThrow);
                }
                else {
                    next(result.value);
                }
            }
            var invokeNext = function (value) { return invoke(boundNext, value); };
            var invokeThrow = function (error) { return invoke(boundThrow, error); };
            invokeNext();
        });
    };
}
function context_esm_isPromiseLike(value) {
    return value && typeof value.then === "function";
}
// If you use the fibers npm package to implement coroutines in Node.js,
// you should call this function at least once to ensure context management
// remains coherent across any yields.
var context_esm_wrappedFibers = (/* unused pure expression or super */ null && ([]));
function context_esm_wrapYieldingFiberMethods(Fiber) {
    // There can be only one implementation of Fiber per process, so this array
    // should never grow longer than one element.
    if (context_esm_wrappedFibers.indexOf(Fiber) < 0) {
        var wrap = function (obj, method) {
            var fn = obj[method];
            obj[method] = function () {
                return context_esm_noContext(fn, arguments, this);
            };
        };
        // These methods can yield, according to
        // https://github.com/laverdet/node-fibers/blob/ddebed9b8ae3883e57f822e2108e6943e5c8d2a8/fibers.js#L97-L100
        wrap(Fiber, "yield");
        wrap(Fiber.prototype, "run");
        wrap(Fiber.prototype, "throwInto");
        context_esm_wrappedFibers.push(Fiber);
    }
    return Fiber;
}


//# sourceMappingURL=context.esm.js.map

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@apollo-client-virtual-cd9e78d17f/0/cache/@apollo-client-npm-3.7.1-a80032e019-95bb1f226f.zip/node_modules/@apollo/client/cache/inmemory/reactiveVars.js


var cacheSlot = new context_esm_Slot();
var cacheInfoMap = new WeakMap();
function getCacheInfo(cache) {
    var info = cacheInfoMap.get(cache);
    if (!info) {
        cacheInfoMap.set(cache, info = {
            vars: new Set,
            dep: dep(),
        });
    }
    return info;
}
function forgetCache(cache) {
    getCacheInfo(cache).vars.forEach(function (rv) { return rv.forgetCache(cache); });
}
function recallCache(cache) {
    getCacheInfo(cache).vars.forEach(function (rv) { return rv.attachCache(cache); });
}
function makeVar(value) {
    var caches = new Set();
    var listeners = new Set();
    var rv = function (newValue) {
        if (arguments.length > 0) {
            if (value !== newValue) {
                value = newValue;
                caches.forEach(function (cache) {
                    getCacheInfo(cache).dep.dirty(rv);
                    broadcast(cache);
                });
                var oldListeners = Array.from(listeners);
                listeners.clear();
                oldListeners.forEach(function (listener) { return listener(value); });
            }
        }
        else {
            var cache = cacheSlot.getValue();
            if (cache) {
                attach(cache);
                getCacheInfo(cache).dep(rv);
            }
        }
        return value;
    };
    rv.onNextChange = function (listener) {
        listeners.add(listener);
        return function () {
            listeners.delete(listener);
        };
    };
    var attach = rv.attachCache = function (cache) {
        caches.add(cache);
        getCacheInfo(cache).vars.add(rv);
        return rv;
    };
    rv.forgetCache = function (cache) { return caches.delete(cache); };
    return rv;
}
function broadcast(cache) {
    if (cache.broadcastWatches) {
        cache.broadcastWatches();
    }
}
//# sourceMappingURL=reactiveVars.js.map
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@apollo-client-virtual-cd9e78d17f/0/cache/@apollo-client-npm-3.7.1-a80032e019-95bb1f226f.zip/node_modules/@apollo/client/cache/inmemory/key-extractor.js



var specifierInfoCache = Object.create(null);
function lookupSpecifierInfo(spec) {
    var cacheKey = JSON.stringify(spec);
    return specifierInfoCache[cacheKey] ||
        (specifierInfoCache[cacheKey] = Object.create(null));
}
function keyFieldsFnFromSpecifier(specifier) {
    var info = lookupSpecifierInfo(specifier);
    return info.keyFieldsFn || (info.keyFieldsFn = function (object, context) {
        var extract = function (from, key) { return context.readField(key, from); };
        var keyObject = context.keyObject = collectSpecifierPaths(specifier, function (schemaKeyPath) {
            var extracted = extractKeyPath(context.storeObject, schemaKeyPath, extract);
            if (extracted === void 0 &&
                object !== context.storeObject &&
                hasOwn.call(object, schemaKeyPath[0])) {
                extracted = extractKeyPath(object, schemaKeyPath, extractKey);
            }
            __DEV__ ? (0,invariant/* invariant */.kG)(extracted !== void 0, "Missing field '".concat(schemaKeyPath.join('.'), "' while extracting keyFields from ").concat(JSON.stringify(object))) : (0,invariant/* invariant */.kG)(extracted !== void 0, 2);
            return extracted;
        });
        return "".concat(context.typename, ":").concat(JSON.stringify(keyObject));
    });
}
function keyArgsFnFromSpecifier(specifier) {
    var info = lookupSpecifierInfo(specifier);
    return info.keyArgsFn || (info.keyArgsFn = function (args, _a) {
        var field = _a.field, variables = _a.variables, fieldName = _a.fieldName;
        var collected = collectSpecifierPaths(specifier, function (keyPath) {
            var firstKey = keyPath[0];
            var firstChar = firstKey.charAt(0);
            if (firstChar === "@") {
                if (field && isNonEmptyArray(field.directives)) {
                    var directiveName_1 = firstKey.slice(1);
                    var d = field.directives.find(function (d) { return d.name.value === directiveName_1; });
                    var directiveArgs = d && argumentsObjectFromField(d, variables);
                    return directiveArgs && extractKeyPath(directiveArgs, keyPath.slice(1));
                }
                return;
            }
            if (firstChar === "$") {
                var variableName = firstKey.slice(1);
                if (variables && hasOwn.call(variables, variableName)) {
                    var varKeyPath = keyPath.slice(0);
                    varKeyPath[0] = variableName;
                    return extractKeyPath(variables, varKeyPath);
                }
                return;
            }
            if (args) {
                return extractKeyPath(args, keyPath);
            }
        });
        var suffix = JSON.stringify(collected);
        if (args || suffix !== "{}") {
            fieldName += ":" + suffix;
        }
        return fieldName;
    });
}
function collectSpecifierPaths(specifier, extractor) {
    var merger = new DeepMerger;
    return getSpecifierPaths(specifier).reduce(function (collected, path) {
        var _a;
        var toMerge = extractor(path);
        if (toMerge !== void 0) {
            for (var i = path.length - 1; i >= 0; --i) {
                toMerge = (_a = {}, _a[path[i]] = toMerge, _a);
            }
            collected = merger.merge(collected, toMerge);
        }
        return collected;
    }, Object.create(null));
}
function getSpecifierPaths(spec) {
    var info = lookupSpecifierInfo(spec);
    if (!info.paths) {
        var paths_1 = info.paths = [];
        var currentPath_1 = [];
        spec.forEach(function (s, i) {
            if (isArray(s)) {
                getSpecifierPaths(s).forEach(function (p) { return paths_1.push(currentPath_1.concat(p)); });
                currentPath_1.length = 0;
            }
            else {
                currentPath_1.push(s);
                if (!isArray(spec[i + 1])) {
                    paths_1.push(currentPath_1.slice(0));
                    currentPath_1.length = 0;
                }
            }
        });
    }
    return info.paths;
}
function extractKey(object, key) {
    return object[key];
}
function extractKeyPath(object, path, extract) {
    extract = extract || extractKey;
    return normalize(path.reduce(function reducer(obj, key) {
        return isArray(obj)
            ? obj.map(function (child) { return reducer(child, key); })
            : obj && extract(obj, key);
    }, object));
}
function normalize(value) {
    if (isNonNullObject(value)) {
        if (isArray(value)) {
            return value.map(normalize);
        }
        return collectSpecifierPaths(Object.keys(value).sort(), function (path) { return extractKeyPath(value, path); });
    }
    return value;
}
//# sourceMappingURL=key-extractor.js.map
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@apollo-client-virtual-cd9e78d17f/0/cache/@apollo-client-npm-3.7.1-a80032e019-95bb1f226f.zip/node_modules/@apollo/client/cache/inmemory/policies.js







getStoreKeyName.setStringify(canonicalStringify);
function argsFromFieldSpecifier(spec) {
    return spec.args !== void 0 ? spec.args :
        spec.field ? argumentsObjectFromField(spec.field, spec.variables) : null;
}
var nullKeyFieldsFn = function () { return void 0; };
var simpleKeyArgsFn = function (_args, context) { return context.fieldName; };
var mergeTrueFn = function (existing, incoming, _a) {
    var mergeObjects = _a.mergeObjects;
    return mergeObjects(existing, incoming);
};
var mergeFalseFn = function (_, incoming) { return incoming; };
var Policies = (function () {
    function Policies(config) {
        this.config = config;
        this.typePolicies = Object.create(null);
        this.toBeAdded = Object.create(null);
        this.supertypeMap = new Map();
        this.fuzzySubtypes = new Map();
        this.rootIdsByTypename = Object.create(null);
        this.rootTypenamesById = Object.create(null);
        this.usingPossibleTypes = false;
        this.config = (0,tslib_es6/* __assign */.pi)({ dataIdFromObject: defaultDataIdFromObject }, config);
        this.cache = this.config.cache;
        this.setRootTypename("Query");
        this.setRootTypename("Mutation");
        this.setRootTypename("Subscription");
        if (config.possibleTypes) {
            this.addPossibleTypes(config.possibleTypes);
        }
        if (config.typePolicies) {
            this.addTypePolicies(config.typePolicies);
        }
    }
    Policies.prototype.identify = function (object, partialContext) {
        var _a;
        var policies = this;
        var typename = partialContext && (partialContext.typename ||
            ((_a = partialContext.storeObject) === null || _a === void 0 ? void 0 : _a.__typename)) || object.__typename;
        if (typename === this.rootTypenamesById.ROOT_QUERY) {
            return ["ROOT_QUERY"];
        }
        var storeObject = partialContext && partialContext.storeObject || object;
        var context = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, partialContext), { typename: typename, storeObject: storeObject, readField: partialContext && partialContext.readField || function () {
                var options = normalizeReadFieldOptions(arguments, storeObject);
                return policies.readField(options, {
                    store: policies.cache["data"],
                    variables: options.variables,
                });
            } });
        var id;
        var policy = typename && this.getTypePolicy(typename);
        var keyFn = policy && policy.keyFn || this.config.dataIdFromObject;
        while (keyFn) {
            var specifierOrId = keyFn(object, context);
            if (isArray(specifierOrId)) {
                keyFn = keyFieldsFnFromSpecifier(specifierOrId);
            }
            else {
                id = specifierOrId;
                break;
            }
        }
        id = id ? String(id) : void 0;
        return context.keyObject ? [id, context.keyObject] : [id];
    };
    Policies.prototype.addTypePolicies = function (typePolicies) {
        var _this = this;
        Object.keys(typePolicies).forEach(function (typename) {
            var _a = typePolicies[typename], queryType = _a.queryType, mutationType = _a.mutationType, subscriptionType = _a.subscriptionType, incoming = (0,tslib_es6/* __rest */._T)(_a, ["queryType", "mutationType", "subscriptionType"]);
            if (queryType)
                _this.setRootTypename("Query", typename);
            if (mutationType)
                _this.setRootTypename("Mutation", typename);
            if (subscriptionType)
                _this.setRootTypename("Subscription", typename);
            if (hasOwn.call(_this.toBeAdded, typename)) {
                _this.toBeAdded[typename].push(incoming);
            }
            else {
                _this.toBeAdded[typename] = [incoming];
            }
        });
    };
    Policies.prototype.updateTypePolicy = function (typename, incoming) {
        var _this = this;
        var existing = this.getTypePolicy(typename);
        var keyFields = incoming.keyFields, fields = incoming.fields;
        function setMerge(existing, merge) {
            existing.merge =
                typeof merge === "function" ? merge :
                    merge === true ? mergeTrueFn :
                        merge === false ? mergeFalseFn :
                            existing.merge;
        }
        setMerge(existing, incoming.merge);
        existing.keyFn =
            keyFields === false ? nullKeyFieldsFn :
                isArray(keyFields) ? keyFieldsFnFromSpecifier(keyFields) :
                    typeof keyFields === "function" ? keyFields :
                        existing.keyFn;
        if (fields) {
            Object.keys(fields).forEach(function (fieldName) {
                var existing = _this.getFieldPolicy(typename, fieldName, true);
                var incoming = fields[fieldName];
                if (typeof incoming === "function") {
                    existing.read = incoming;
                }
                else {
                    var keyArgs = incoming.keyArgs, read = incoming.read, merge = incoming.merge;
                    existing.keyFn =
                        keyArgs === false ? simpleKeyArgsFn :
                            isArray(keyArgs) ? keyArgsFnFromSpecifier(keyArgs) :
                                typeof keyArgs === "function" ? keyArgs :
                                    existing.keyFn;
                    if (typeof read === "function") {
                        existing.read = read;
                    }
                    setMerge(existing, merge);
                }
                if (existing.read && existing.merge) {
                    existing.keyFn = existing.keyFn || simpleKeyArgsFn;
                }
            });
        }
    };
    Policies.prototype.setRootTypename = function (which, typename) {
        if (typename === void 0) { typename = which; }
        var rootId = "ROOT_" + which.toUpperCase();
        var old = this.rootTypenamesById[rootId];
        if (typename !== old) {
            __DEV__ ? (0,invariant/* invariant */.kG)(!old || old === which, "Cannot change root ".concat(which, " __typename more than once")) : (0,invariant/* invariant */.kG)(!old || old === which, 3);
            if (old)
                delete this.rootIdsByTypename[old];
            this.rootIdsByTypename[typename] = rootId;
            this.rootTypenamesById[rootId] = typename;
        }
    };
    Policies.prototype.addPossibleTypes = function (possibleTypes) {
        var _this = this;
        this.usingPossibleTypes = true;
        Object.keys(possibleTypes).forEach(function (supertype) {
            _this.getSupertypeSet(supertype, true);
            possibleTypes[supertype].forEach(function (subtype) {
                _this.getSupertypeSet(subtype, true).add(supertype);
                var match = subtype.match(TypeOrFieldNameRegExp);
                if (!match || match[0] !== subtype) {
                    _this.fuzzySubtypes.set(subtype, new RegExp(subtype));
                }
            });
        });
    };
    Policies.prototype.getTypePolicy = function (typename) {
        var _this = this;
        if (!hasOwn.call(this.typePolicies, typename)) {
            var policy_1 = this.typePolicies[typename] = Object.create(null);
            policy_1.fields = Object.create(null);
            var supertypes = this.supertypeMap.get(typename);
            if (supertypes && supertypes.size) {
                supertypes.forEach(function (supertype) {
                    var _a = _this.getTypePolicy(supertype), fields = _a.fields, rest = (0,tslib_es6/* __rest */._T)(_a, ["fields"]);
                    Object.assign(policy_1, rest);
                    Object.assign(policy_1.fields, fields);
                });
            }
        }
        var inbox = this.toBeAdded[typename];
        if (inbox && inbox.length) {
            inbox.splice(0).forEach(function (policy) {
                _this.updateTypePolicy(typename, policy);
            });
        }
        return this.typePolicies[typename];
    };
    Policies.prototype.getFieldPolicy = function (typename, fieldName, createIfMissing) {
        if (typename) {
            var fieldPolicies = this.getTypePolicy(typename).fields;
            return fieldPolicies[fieldName] || (createIfMissing && (fieldPolicies[fieldName] = Object.create(null)));
        }
    };
    Policies.prototype.getSupertypeSet = function (subtype, createIfMissing) {
        var supertypeSet = this.supertypeMap.get(subtype);
        if (!supertypeSet && createIfMissing) {
            this.supertypeMap.set(subtype, supertypeSet = new Set());
        }
        return supertypeSet;
    };
    Policies.prototype.fragmentMatches = function (fragment, typename, result, variables) {
        var _this = this;
        if (!fragment.typeCondition)
            return true;
        if (!typename)
            return false;
        var supertype = fragment.typeCondition.name.value;
        if (typename === supertype)
            return true;
        if (this.usingPossibleTypes &&
            this.supertypeMap.has(supertype)) {
            var typenameSupertypeSet = this.getSupertypeSet(typename, true);
            var workQueue_1 = [typenameSupertypeSet];
            var maybeEnqueue_1 = function (subtype) {
                var supertypeSet = _this.getSupertypeSet(subtype, false);
                if (supertypeSet &&
                    supertypeSet.size &&
                    workQueue_1.indexOf(supertypeSet) < 0) {
                    workQueue_1.push(supertypeSet);
                }
            };
            var needToCheckFuzzySubtypes = !!(result && this.fuzzySubtypes.size);
            var checkingFuzzySubtypes = false;
            for (var i = 0; i < workQueue_1.length; ++i) {
                var supertypeSet = workQueue_1[i];
                if (supertypeSet.has(supertype)) {
                    if (!typenameSupertypeSet.has(supertype)) {
                        if (checkingFuzzySubtypes) {
                            __DEV__ && invariant/* invariant.warn */.kG.warn("Inferring subtype ".concat(typename, " of supertype ").concat(supertype));
                        }
                        typenameSupertypeSet.add(supertype);
                    }
                    return true;
                }
                supertypeSet.forEach(maybeEnqueue_1);
                if (needToCheckFuzzySubtypes &&
                    i === workQueue_1.length - 1 &&
                    selectionSetMatchesResult(fragment.selectionSet, result, variables)) {
                    needToCheckFuzzySubtypes = false;
                    checkingFuzzySubtypes = true;
                    this.fuzzySubtypes.forEach(function (regExp, fuzzyString) {
                        var match = typename.match(regExp);
                        if (match && match[0] === typename) {
                            maybeEnqueue_1(fuzzyString);
                        }
                    });
                }
            }
        }
        return false;
    };
    Policies.prototype.hasKeyArgs = function (typename, fieldName) {
        var policy = this.getFieldPolicy(typename, fieldName, false);
        return !!(policy && policy.keyFn);
    };
    Policies.prototype.getStoreFieldName = function (fieldSpec) {
        var typename = fieldSpec.typename, fieldName = fieldSpec.fieldName;
        var policy = this.getFieldPolicy(typename, fieldName, false);
        var storeFieldName;
        var keyFn = policy && policy.keyFn;
        if (keyFn && typename) {
            var context = {
                typename: typename,
                fieldName: fieldName,
                field: fieldSpec.field || null,
                variables: fieldSpec.variables,
            };
            var args = argsFromFieldSpecifier(fieldSpec);
            while (keyFn) {
                var specifierOrString = keyFn(args, context);
                if (isArray(specifierOrString)) {
                    keyFn = keyArgsFnFromSpecifier(specifierOrString);
                }
                else {
                    storeFieldName = specifierOrString || fieldName;
                    break;
                }
            }
        }
        if (storeFieldName === void 0) {
            storeFieldName = fieldSpec.field
                ? storeKeyNameFromField(fieldSpec.field, fieldSpec.variables)
                : getStoreKeyName(fieldName, argsFromFieldSpecifier(fieldSpec));
        }
        if (storeFieldName === false) {
            return fieldName;
        }
        return fieldName === fieldNameFromStoreName(storeFieldName)
            ? storeFieldName
            : fieldName + ":" + storeFieldName;
    };
    Policies.prototype.readField = function (options, context) {
        var objectOrReference = options.from;
        if (!objectOrReference)
            return;
        var nameOrField = options.field || options.fieldName;
        if (!nameOrField)
            return;
        if (options.typename === void 0) {
            var typename = context.store.getFieldValue(objectOrReference, "__typename");
            if (typename)
                options.typename = typename;
        }
        var storeFieldName = this.getStoreFieldName(options);
        var fieldName = fieldNameFromStoreName(storeFieldName);
        var existing = context.store.getFieldValue(objectOrReference, storeFieldName);
        var policy = this.getFieldPolicy(options.typename, fieldName, false);
        var read = policy && policy.read;
        if (read) {
            var readOptions = makeFieldFunctionOptions(this, objectOrReference, options, context, context.store.getStorage(isReference(objectOrReference)
                ? objectOrReference.__ref
                : objectOrReference, storeFieldName));
            return cacheSlot.withValue(this.cache, read, [existing, readOptions]);
        }
        return existing;
    };
    Policies.prototype.getReadFunction = function (typename, fieldName) {
        var policy = this.getFieldPolicy(typename, fieldName, false);
        return policy && policy.read;
    };
    Policies.prototype.getMergeFunction = function (parentTypename, fieldName, childTypename) {
        var policy = this.getFieldPolicy(parentTypename, fieldName, false);
        var merge = policy && policy.merge;
        if (!merge && childTypename) {
            policy = this.getTypePolicy(childTypename);
            merge = policy && policy.merge;
        }
        return merge;
    };
    Policies.prototype.runMergeFunction = function (existing, incoming, _a, context, storage) {
        var field = _a.field, typename = _a.typename, merge = _a.merge;
        if (merge === mergeTrueFn) {
            return makeMergeObjectsFunction(context.store)(existing, incoming);
        }
        if (merge === mergeFalseFn) {
            return incoming;
        }
        if (context.overwrite) {
            existing = void 0;
        }
        return merge(existing, incoming, makeFieldFunctionOptions(this, void 0, { typename: typename, fieldName: field.name.value, field: field, variables: context.variables }, context, storage || Object.create(null)));
    };
    return Policies;
}());

function makeFieldFunctionOptions(policies, objectOrReference, fieldSpec, context, storage) {
    var storeFieldName = policies.getStoreFieldName(fieldSpec);
    var fieldName = fieldNameFromStoreName(storeFieldName);
    var variables = fieldSpec.variables || context.variables;
    var _a = context.store, toReference = _a.toReference, canRead = _a.canRead;
    return {
        args: argsFromFieldSpecifier(fieldSpec),
        field: fieldSpec.field || null,
        fieldName: fieldName,
        storeFieldName: storeFieldName,
        variables: variables,
        isReference: isReference,
        toReference: toReference,
        storage: storage,
        cache: policies.cache,
        canRead: canRead,
        readField: function () {
            return policies.readField(normalizeReadFieldOptions(arguments, objectOrReference, variables), context);
        },
        mergeObjects: makeMergeObjectsFunction(context.store),
    };
}
function normalizeReadFieldOptions(readFieldArgs, objectOrReference, variables) {
    var fieldNameOrOptions = readFieldArgs[0], from = readFieldArgs[1], argc = readFieldArgs.length;
    var options;
    if (typeof fieldNameOrOptions === "string") {
        options = {
            fieldName: fieldNameOrOptions,
            from: argc > 1 ? from : objectOrReference,
        };
    }
    else {
        options = (0,tslib_es6/* __assign */.pi)({}, fieldNameOrOptions);
        if (!hasOwn.call(options, "from")) {
            options.from = objectOrReference;
        }
    }
    if (__DEV__ && options.from === void 0) {
        __DEV__ && invariant/* invariant.warn */.kG.warn("Undefined 'from' passed to readField with arguments ".concat(stringifyForDisplay(Array.from(readFieldArgs))));
    }
    if (void 0 === options.variables) {
        options.variables = variables;
    }
    return options;
}
function makeMergeObjectsFunction(store) {
    return function mergeObjects(existing, incoming) {
        if (isArray(existing) || isArray(incoming)) {
            throw __DEV__ ? new invariant/* InvariantError */.ej("Cannot automatically merge arrays") : new invariant/* InvariantError */.ej(4);
        }
        if (isNonNullObject(existing) &&
            isNonNullObject(incoming)) {
            var eType = store.getFieldValue(existing, "__typename");
            var iType = store.getFieldValue(incoming, "__typename");
            var typesDiffer = eType && iType && eType !== iType;
            if (typesDiffer) {
                return incoming;
            }
            if (isReference(existing) &&
                storeValueIsStoreObject(incoming)) {
                store.merge(existing.__ref, incoming);
                return existing;
            }
            if (storeValueIsStoreObject(existing) &&
                isReference(incoming)) {
                store.merge(existing, incoming.__ref);
                return incoming;
            }
            if (storeValueIsStoreObject(existing) &&
                storeValueIsStoreObject(incoming)) {
                return (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, existing), incoming);
            }
        }
        return incoming;
    };
}
//# sourceMappingURL=policies.js.map
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@apollo-client-virtual-cd9e78d17f/0/cache/@apollo-client-npm-3.7.1-a80032e019-95bb1f226f.zip/node_modules/@apollo/client/cache/inmemory/writeToStore.js









;
function getContextFlavor(context, clientOnly, deferred) {
    var key = "".concat(clientOnly).concat(deferred);
    var flavored = context.flavors.get(key);
    if (!flavored) {
        context.flavors.set(key, flavored = (context.clientOnly === clientOnly &&
            context.deferred === deferred) ? context : (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, context), { clientOnly: clientOnly, deferred: deferred }));
    }
    return flavored;
}
var StoreWriter = (function () {
    function StoreWriter(cache, reader, fragments) {
        this.cache = cache;
        this.reader = reader;
        this.fragments = fragments;
    }
    StoreWriter.prototype.writeToStore = function (store, _a) {
        var _this = this;
        var query = _a.query, result = _a.result, dataId = _a.dataId, variables = _a.variables, overwrite = _a.overwrite;
        var operationDefinition = getOperationDefinition(query);
        var merger = makeProcessedFieldsMerger();
        variables = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, getDefaultValues(operationDefinition)), variables);
        var context = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({ store: store, written: Object.create(null), merge: function (existing, incoming) {
                return merger.merge(existing, incoming);
            }, variables: variables, varString: canonicalStringify(variables) }, extractFragmentContext(query, this.fragments)), { overwrite: !!overwrite, incomingById: new Map, clientOnly: false, deferred: false, flavors: new Map });
        var ref = this.processSelectionSet({
            result: result || Object.create(null),
            dataId: dataId,
            selectionSet: operationDefinition.selectionSet,
            mergeTree: { map: new Map },
            context: context,
        });
        if (!isReference(ref)) {
            throw __DEV__ ? new invariant/* InvariantError */.ej("Could not identify object ".concat(JSON.stringify(result))) : new invariant/* InvariantError */.ej(7);
        }
        context.incomingById.forEach(function (_a, dataId) {
            var storeObject = _a.storeObject, mergeTree = _a.mergeTree, fieldNodeSet = _a.fieldNodeSet;
            var entityRef = makeReference(dataId);
            if (mergeTree && mergeTree.map.size) {
                var applied = _this.applyMerges(mergeTree, entityRef, storeObject, context);
                if (isReference(applied)) {
                    return;
                }
                storeObject = applied;
            }
            if (__DEV__ && !context.overwrite) {
                var fieldsWithSelectionSets_1 = Object.create(null);
                fieldNodeSet.forEach(function (field) {
                    if (field.selectionSet) {
                        fieldsWithSelectionSets_1[field.name.value] = true;
                    }
                });
                var hasSelectionSet_1 = function (storeFieldName) {
                    return fieldsWithSelectionSets_1[fieldNameFromStoreName(storeFieldName)] === true;
                };
                var hasMergeFunction_1 = function (storeFieldName) {
                    var childTree = mergeTree && mergeTree.map.get(storeFieldName);
                    return Boolean(childTree && childTree.info && childTree.info.merge);
                };
                Object.keys(storeObject).forEach(function (storeFieldName) {
                    if (hasSelectionSet_1(storeFieldName) &&
                        !hasMergeFunction_1(storeFieldName)) {
                        warnAboutDataLoss(entityRef, storeObject, storeFieldName, context.store);
                    }
                });
            }
            store.merge(dataId, storeObject);
        });
        store.retain(ref.__ref);
        return ref;
    };
    StoreWriter.prototype.processSelectionSet = function (_a) {
        var _this = this;
        var dataId = _a.dataId, result = _a.result, selectionSet = _a.selectionSet, context = _a.context, mergeTree = _a.mergeTree;
        var policies = this.cache.policies;
        var incoming = Object.create(null);
        var typename = (dataId && policies.rootTypenamesById[dataId]) ||
            getTypenameFromResult(result, selectionSet, context.fragmentMap) ||
            (dataId && context.store.get(dataId, "__typename"));
        if ("string" === typeof typename) {
            incoming.__typename = typename;
        }
        var readField = function () {
            var options = normalizeReadFieldOptions(arguments, incoming, context.variables);
            if (isReference(options.from)) {
                var info = context.incomingById.get(options.from.__ref);
                if (info) {
                    var result_1 = policies.readField((0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, options), { from: info.storeObject }), context);
                    if (result_1 !== void 0) {
                        return result_1;
                    }
                }
            }
            return policies.readField(options, context);
        };
        var fieldNodeSet = new Set();
        this.flattenFields(selectionSet, result, context, typename).forEach(function (context, field) {
            var _a;
            var resultFieldKey = resultKeyNameFromField(field);
            var value = result[resultFieldKey];
            fieldNodeSet.add(field);
            if (value !== void 0) {
                var storeFieldName = policies.getStoreFieldName({
                    typename: typename,
                    fieldName: field.name.value,
                    field: field,
                    variables: context.variables,
                });
                var childTree = getChildMergeTree(mergeTree, storeFieldName);
                var incomingValue = _this.processFieldValue(value, field, field.selectionSet
                    ? getContextFlavor(context, false, false)
                    : context, childTree);
                var childTypename = void 0;
                if (field.selectionSet &&
                    (isReference(incomingValue) ||
                        storeValueIsStoreObject(incomingValue))) {
                    childTypename = readField("__typename", incomingValue);
                }
                var merge = policies.getMergeFunction(typename, field.name.value, childTypename);
                if (merge) {
                    childTree.info = {
                        field: field,
                        typename: typename,
                        merge: merge,
                    };
                }
                else {
                    maybeRecycleChildMergeTree(mergeTree, storeFieldName);
                }
                incoming = context.merge(incoming, (_a = {},
                    _a[storeFieldName] = incomingValue,
                    _a));
            }
            else if (__DEV__ &&
                !context.clientOnly &&
                !context.deferred &&
                !addTypenameToDocument.added(field) &&
                !policies.getReadFunction(typename, field.name.value)) {
                __DEV__ && invariant/* invariant.error */.kG.error("Missing field '".concat(resultKeyNameFromField(field), "' while writing result ").concat(JSON.stringify(result, null, 2)).substring(0, 1000));
            }
        });
        try {
            var _b = policies.identify(result, {
                typename: typename,
                selectionSet: selectionSet,
                fragmentMap: context.fragmentMap,
                storeObject: incoming,
                readField: readField,
            }), id = _b[0], keyObject = _b[1];
            dataId = dataId || id;
            if (keyObject) {
                incoming = context.merge(incoming, keyObject);
            }
        }
        catch (e) {
            if (!dataId)
                throw e;
        }
        if ("string" === typeof dataId) {
            var dataRef = makeReference(dataId);
            var sets = context.written[dataId] || (context.written[dataId] = []);
            if (sets.indexOf(selectionSet) >= 0)
                return dataRef;
            sets.push(selectionSet);
            if (this.reader && this.reader.isFresh(result, dataRef, selectionSet, context)) {
                return dataRef;
            }
            var previous_1 = context.incomingById.get(dataId);
            if (previous_1) {
                previous_1.storeObject = context.merge(previous_1.storeObject, incoming);
                previous_1.mergeTree = mergeMergeTrees(previous_1.mergeTree, mergeTree);
                fieldNodeSet.forEach(function (field) { return previous_1.fieldNodeSet.add(field); });
            }
            else {
                context.incomingById.set(dataId, {
                    storeObject: incoming,
                    mergeTree: mergeTreeIsEmpty(mergeTree) ? void 0 : mergeTree,
                    fieldNodeSet: fieldNodeSet,
                });
            }
            return dataRef;
        }
        return incoming;
    };
    StoreWriter.prototype.processFieldValue = function (value, field, context, mergeTree) {
        var _this = this;
        if (!field.selectionSet || value === null) {
            return __DEV__ ? cloneDeep(value) : value;
        }
        if (isArray(value)) {
            return value.map(function (item, i) {
                var value = _this.processFieldValue(item, field, context, getChildMergeTree(mergeTree, i));
                maybeRecycleChildMergeTree(mergeTree, i);
                return value;
            });
        }
        return this.processSelectionSet({
            result: value,
            selectionSet: field.selectionSet,
            context: context,
            mergeTree: mergeTree,
        });
    };
    StoreWriter.prototype.flattenFields = function (selectionSet, result, context, typename) {
        if (typename === void 0) { typename = getTypenameFromResult(result, selectionSet, context.fragmentMap); }
        var fieldMap = new Map();
        var policies = this.cache.policies;
        var limitingTrie = new Trie(false);
        (function flatten(selectionSet, inheritedContext) {
            var visitedNode = limitingTrie.lookup(selectionSet, inheritedContext.clientOnly, inheritedContext.deferred);
            if (visitedNode.visited)
                return;
            visitedNode.visited = true;
            selectionSet.selections.forEach(function (selection) {
                if (!shouldInclude(selection, context.variables))
                    return;
                var clientOnly = inheritedContext.clientOnly, deferred = inheritedContext.deferred;
                if (!(clientOnly && deferred) &&
                    isNonEmptyArray(selection.directives)) {
                    selection.directives.forEach(function (dir) {
                        var name = dir.name.value;
                        if (name === "client")
                            clientOnly = true;
                        if (name === "defer") {
                            var args = argumentsObjectFromField(dir, context.variables);
                            if (!args || args.if !== false) {
                                deferred = true;
                            }
                        }
                    });
                }
                if (storeUtils_isField(selection)) {
                    var existing = fieldMap.get(selection);
                    if (existing) {
                        clientOnly = clientOnly && existing.clientOnly;
                        deferred = deferred && existing.deferred;
                    }
                    fieldMap.set(selection, getContextFlavor(context, clientOnly, deferred));
                }
                else {
                    var fragment = getFragmentFromSelection(selection, context.lookupFragment);
                    if (!fragment && selection.kind === kinds/* Kind.FRAGMENT_SPREAD */.h.FRAGMENT_SPREAD) {
                        throw __DEV__ ? new invariant/* InvariantError */.ej("No fragment named ".concat(selection.name.value)) : new invariant/* InvariantError */.ej(8);
                    }
                    if (fragment &&
                        policies.fragmentMatches(fragment, typename, result, context.variables)) {
                        flatten(fragment.selectionSet, getContextFlavor(context, clientOnly, deferred));
                    }
                }
            });
        })(selectionSet, context);
        return fieldMap;
    };
    StoreWriter.prototype.applyMerges = function (mergeTree, existing, incoming, context, getStorageArgs) {
        var _a;
        var _this = this;
        if (mergeTree.map.size && !isReference(incoming)) {
            var e_1 = (!isArray(incoming) &&
                (isReference(existing) || storeValueIsStoreObject(existing))) ? existing : void 0;
            var i_1 = incoming;
            if (e_1 && !getStorageArgs) {
                getStorageArgs = [isReference(e_1) ? e_1.__ref : e_1];
            }
            var changedFields_1;
            var getValue_1 = function (from, name) {
                return isArray(from)
                    ? (typeof name === "number" ? from[name] : void 0)
                    : context.store.getFieldValue(from, String(name));
            };
            mergeTree.map.forEach(function (childTree, storeFieldName) {
                var eVal = getValue_1(e_1, storeFieldName);
                var iVal = getValue_1(i_1, storeFieldName);
                if (void 0 === iVal)
                    return;
                if (getStorageArgs) {
                    getStorageArgs.push(storeFieldName);
                }
                var aVal = _this.applyMerges(childTree, eVal, iVal, context, getStorageArgs);
                if (aVal !== iVal) {
                    changedFields_1 = changedFields_1 || new Map;
                    changedFields_1.set(storeFieldName, aVal);
                }
                if (getStorageArgs) {
                    (0,invariant/* invariant */.kG)(getStorageArgs.pop() === storeFieldName);
                }
            });
            if (changedFields_1) {
                incoming = (isArray(i_1) ? i_1.slice(0) : (0,tslib_es6/* __assign */.pi)({}, i_1));
                changedFields_1.forEach(function (value, name) {
                    incoming[name] = value;
                });
            }
        }
        if (mergeTree.info) {
            return this.cache.policies.runMergeFunction(existing, incoming, mergeTree.info, context, getStorageArgs && (_a = context.store).getStorage.apply(_a, getStorageArgs));
        }
        return incoming;
    };
    return StoreWriter;
}());

var emptyMergeTreePool = [];
function getChildMergeTree(_a, name) {
    var map = _a.map;
    if (!map.has(name)) {
        map.set(name, emptyMergeTreePool.pop() || { map: new Map });
    }
    return map.get(name);
}
function mergeMergeTrees(left, right) {
    if (left === right || !right || mergeTreeIsEmpty(right))
        return left;
    if (!left || mergeTreeIsEmpty(left))
        return right;
    var info = left.info && right.info ? (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, left.info), right.info) : left.info || right.info;
    var needToMergeMaps = left.map.size && right.map.size;
    var map = needToMergeMaps ? new Map :
        left.map.size ? left.map : right.map;
    var merged = { info: info, map: map };
    if (needToMergeMaps) {
        var remainingRightKeys_1 = new Set(right.map.keys());
        left.map.forEach(function (leftTree, key) {
            merged.map.set(key, mergeMergeTrees(leftTree, right.map.get(key)));
            remainingRightKeys_1.delete(key);
        });
        remainingRightKeys_1.forEach(function (key) {
            merged.map.set(key, mergeMergeTrees(right.map.get(key), left.map.get(key)));
        });
    }
    return merged;
}
function mergeTreeIsEmpty(tree) {
    return !tree || !(tree.info || tree.map.size);
}
function maybeRecycleChildMergeTree(_a, name) {
    var map = _a.map;
    var childTree = map.get(name);
    if (childTree && mergeTreeIsEmpty(childTree)) {
        emptyMergeTreePool.push(childTree);
        map.delete(name);
    }
}
var warnings = new Set();
function warnAboutDataLoss(existingRef, incomingObj, storeFieldName, store) {
    var getChild = function (objOrRef) {
        var child = store.getFieldValue(objOrRef, storeFieldName);
        return typeof child === "object" && child;
    };
    var existing = getChild(existingRef);
    if (!existing)
        return;
    var incoming = getChild(incomingObj);
    if (!incoming)
        return;
    if (isReference(existing))
        return;
    if (equal(existing, incoming))
        return;
    if (Object.keys(existing).every(function (key) { return store.getFieldValue(incoming, key) !== void 0; })) {
        return;
    }
    var parentType = store.getFieldValue(existingRef, "__typename") ||
        store.getFieldValue(incomingObj, "__typename");
    var fieldName = fieldNameFromStoreName(storeFieldName);
    var typeDotName = "".concat(parentType, ".").concat(fieldName);
    if (warnings.has(typeDotName))
        return;
    warnings.add(typeDotName);
    var childTypenames = [];
    if (!isArray(existing) &&
        !isArray(incoming)) {
        [existing, incoming].forEach(function (child) {
            var typename = store.getFieldValue(child, "__typename");
            if (typeof typename === "string" &&
                !childTypenames.includes(typename)) {
                childTypenames.push(typename);
            }
        });
    }
    __DEV__ && invariant/* invariant.warn */.kG.warn("Cache data may be lost when replacing the ".concat(fieldName, " field of a ").concat(parentType, " object.\n\nTo address this problem (which is not a bug in Apollo Client), ").concat(childTypenames.length
        ? "either ensure all objects of type " +
            childTypenames.join(" and ") + " have an ID or a custom merge function, or "
        : "", "define a custom merge function for the ").concat(typeDotName, " field, so InMemoryCache can safely merge these objects:\n\n  existing: ").concat(JSON.stringify(existing).slice(0, 1000), "\n  incoming: ").concat(JSON.stringify(incoming).slice(0, 1000), "\n\nFor more information about these options, please refer to the documentation:\n\n  * Ensuring entity objects have IDs: https://go.apollo.dev/c/generating-unique-identifiers\n  * Defining custom merge functions: https://go.apollo.dev/c/merging-non-normalized-objects\n"));
}
//# sourceMappingURL=writeToStore.js.map
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@apollo-client-virtual-cd9e78d17f/0/cache/@apollo-client-npm-3.7.1-a80032e019-95bb1f226f.zip/node_modules/@apollo/client/cache/inmemory/inMemoryCache.js















var InMemoryCache = (function (_super) {
    (0,tslib_es6/* __extends */.ZT)(InMemoryCache, _super);
    function InMemoryCache(config) {
        if (config === void 0) { config = {}; }
        var _this = _super.call(this) || this;
        _this.watches = new Set();
        _this.typenameDocumentCache = new Map();
        _this.makeVar = makeVar;
        _this.txCount = 0;
        _this.config = normalizeConfig(config);
        _this.addTypename = !!_this.config.addTypename;
        _this.policies = new Policies({
            cache: _this,
            dataIdFromObject: _this.config.dataIdFromObject,
            possibleTypes: _this.config.possibleTypes,
            typePolicies: _this.config.typePolicies,
        });
        _this.init();
        return _this;
    }
    InMemoryCache.prototype.init = function () {
        var rootStore = this.data = new EntityStore.Root({
            policies: this.policies,
            resultCaching: this.config.resultCaching,
        });
        this.optimisticData = rootStore.stump;
        this.resetResultCache();
    };
    InMemoryCache.prototype.resetResultCache = function (resetResultIdentities) {
        var _this = this;
        var previousReader = this.storeReader;
        var fragments = this.config.fragments;
        this.storeWriter = new StoreWriter(this, this.storeReader = new StoreReader({
            cache: this,
            addTypename: this.addTypename,
            resultCacheMaxSize: this.config.resultCacheMaxSize,
            canonizeResults: shouldCanonizeResults(this.config),
            canon: resetResultIdentities
                ? void 0
                : previousReader && previousReader.canon,
            fragments: fragments,
        }), fragments);
        this.maybeBroadcastWatch = wrap(function (c, options) {
            return _this.broadcastWatch(c, options);
        }, {
            max: this.config.resultCacheMaxSize,
            makeCacheKey: function (c) {
                var store = c.optimistic ? _this.optimisticData : _this.data;
                if (supportsResultCaching(store)) {
                    var optimistic = c.optimistic, id = c.id, variables = c.variables;
                    return store.makeCacheKey(c.query, c.callback, canonicalStringify({ optimistic: optimistic, id: id, variables: variables }));
                }
            }
        });
        new Set([
            this.data.group,
            this.optimisticData.group,
        ]).forEach(function (group) { return group.resetCaching(); });
    };
    InMemoryCache.prototype.restore = function (data) {
        this.init();
        if (data)
            this.data.replace(data);
        return this;
    };
    InMemoryCache.prototype.extract = function (optimistic) {
        if (optimistic === void 0) { optimistic = false; }
        return (optimistic ? this.optimisticData : this.data).extract();
    };
    InMemoryCache.prototype.read = function (options) {
        var _a = options.returnPartialData, returnPartialData = _a === void 0 ? false : _a;
        try {
            return this.storeReader.diffQueryAgainstStore((0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, options), { store: options.optimistic ? this.optimisticData : this.data, config: this.config, returnPartialData: returnPartialData })).result || null;
        }
        catch (e) {
            if (e instanceof MissingFieldError) {
                return null;
            }
            throw e;
        }
    };
    InMemoryCache.prototype.write = function (options) {
        try {
            ++this.txCount;
            return this.storeWriter.writeToStore(this.data, options);
        }
        finally {
            if (!--this.txCount && options.broadcast !== false) {
                this.broadcastWatches();
            }
        }
    };
    InMemoryCache.prototype.modify = function (options) {
        if (hasOwn.call(options, "id") && !options.id) {
            return false;
        }
        var store = options.optimistic
            ? this.optimisticData
            : this.data;
        try {
            ++this.txCount;
            return store.modify(options.id || "ROOT_QUERY", options.fields);
        }
        finally {
            if (!--this.txCount && options.broadcast !== false) {
                this.broadcastWatches();
            }
        }
    };
    InMemoryCache.prototype.diff = function (options) {
        return this.storeReader.diffQueryAgainstStore((0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, options), { store: options.optimistic ? this.optimisticData : this.data, rootId: options.id || "ROOT_QUERY", config: this.config }));
    };
    InMemoryCache.prototype.watch = function (watch) {
        var _this = this;
        if (!this.watches.size) {
            recallCache(this);
        }
        this.watches.add(watch);
        if (watch.immediate) {
            this.maybeBroadcastWatch(watch);
        }
        return function () {
            if (_this.watches.delete(watch) && !_this.watches.size) {
                forgetCache(_this);
            }
            _this.maybeBroadcastWatch.forget(watch);
        };
    };
    InMemoryCache.prototype.gc = function (options) {
        canonicalStringify.reset();
        var ids = this.optimisticData.gc();
        if (options && !this.txCount) {
            if (options.resetResultCache) {
                this.resetResultCache(options.resetResultIdentities);
            }
            else if (options.resetResultIdentities) {
                this.storeReader.resetCanon();
            }
        }
        return ids;
    };
    InMemoryCache.prototype.retain = function (rootId, optimistic) {
        return (optimistic ? this.optimisticData : this.data).retain(rootId);
    };
    InMemoryCache.prototype.release = function (rootId, optimistic) {
        return (optimistic ? this.optimisticData : this.data).release(rootId);
    };
    InMemoryCache.prototype.identify = function (object) {
        if (isReference(object))
            return object.__ref;
        try {
            return this.policies.identify(object)[0];
        }
        catch (e) {
            __DEV__ && invariant/* invariant.warn */.kG.warn(e);
        }
    };
    InMemoryCache.prototype.evict = function (options) {
        if (!options.id) {
            if (hasOwn.call(options, "id")) {
                return false;
            }
            options = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, options), { id: "ROOT_QUERY" });
        }
        try {
            ++this.txCount;
            return this.optimisticData.evict(options, this.data);
        }
        finally {
            if (!--this.txCount && options.broadcast !== false) {
                this.broadcastWatches();
            }
        }
    };
    InMemoryCache.prototype.reset = function (options) {
        var _this = this;
        this.init();
        canonicalStringify.reset();
        if (options && options.discardWatches) {
            this.watches.forEach(function (watch) { return _this.maybeBroadcastWatch.forget(watch); });
            this.watches.clear();
            forgetCache(this);
        }
        else {
            this.broadcastWatches();
        }
        return Promise.resolve();
    };
    InMemoryCache.prototype.removeOptimistic = function (idToRemove) {
        var newOptimisticData = this.optimisticData.removeLayer(idToRemove);
        if (newOptimisticData !== this.optimisticData) {
            this.optimisticData = newOptimisticData;
            this.broadcastWatches();
        }
    };
    InMemoryCache.prototype.batch = function (options) {
        var _this = this;
        var update = options.update, _a = options.optimistic, optimistic = _a === void 0 ? true : _a, removeOptimistic = options.removeOptimistic, onWatchUpdated = options.onWatchUpdated;
        var updateResult;
        var perform = function (layer) {
            var _a = _this, data = _a.data, optimisticData = _a.optimisticData;
            ++_this.txCount;
            if (layer) {
                _this.data = _this.optimisticData = layer;
            }
            try {
                return updateResult = update(_this);
            }
            finally {
                --_this.txCount;
                _this.data = data;
                _this.optimisticData = optimisticData;
            }
        };
        var alreadyDirty = new Set();
        if (onWatchUpdated && !this.txCount) {
            this.broadcastWatches((0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, options), { onWatchUpdated: function (watch) {
                    alreadyDirty.add(watch);
                    return false;
                } }));
        }
        if (typeof optimistic === 'string') {
            this.optimisticData = this.optimisticData.addLayer(optimistic, perform);
        }
        else if (optimistic === false) {
            perform(this.data);
        }
        else {
            perform();
        }
        if (typeof removeOptimistic === "string") {
            this.optimisticData = this.optimisticData.removeLayer(removeOptimistic);
        }
        if (onWatchUpdated && alreadyDirty.size) {
            this.broadcastWatches((0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, options), { onWatchUpdated: function (watch, diff) {
                    var result = onWatchUpdated.call(this, watch, diff);
                    if (result !== false) {
                        alreadyDirty.delete(watch);
                    }
                    return result;
                } }));
            if (alreadyDirty.size) {
                alreadyDirty.forEach(function (watch) { return _this.maybeBroadcastWatch.dirty(watch); });
            }
        }
        else {
            this.broadcastWatches(options);
        }
        return updateResult;
    };
    InMemoryCache.prototype.performTransaction = function (update, optimisticId) {
        return this.batch({
            update: update,
            optimistic: optimisticId || (optimisticId !== null),
        });
    };
    InMemoryCache.prototype.transformDocument = function (document) {
        if (this.addTypename) {
            var result = this.typenameDocumentCache.get(document);
            if (!result) {
                result = addTypenameToDocument(document);
                this.typenameDocumentCache.set(document, result);
                this.typenameDocumentCache.set(result, result);
            }
            return result;
        }
        return document;
    };
    InMemoryCache.prototype.transformForLink = function (document) {
        var fragments = this.config.fragments;
        return fragments
            ? fragments.transform(document)
            : document;
    };
    InMemoryCache.prototype.broadcastWatches = function (options) {
        var _this = this;
        if (!this.txCount) {
            this.watches.forEach(function (c) { return _this.maybeBroadcastWatch(c, options); });
        }
    };
    InMemoryCache.prototype.broadcastWatch = function (c, options) {
        var lastDiff = c.lastDiff;
        var diff = this.diff(c);
        if (options) {
            if (c.optimistic &&
                typeof options.optimistic === "string") {
                diff.fromOptimisticTransaction = true;
            }
            if (options.onWatchUpdated &&
                options.onWatchUpdated.call(this, c, diff, lastDiff) === false) {
                return;
            }
        }
        if (!lastDiff || !equal(lastDiff.result, diff.result)) {
            c.callback(c.lastDiff = diff, lastDiff);
        }
    };
    return InMemoryCache;
}(ApolloCache));

//# sourceMappingURL=inMemoryCache.js.map
;// CONCATENATED MODULE: ../../.yarn/cache/zen-observable-ts-npm-1.2.5-4ddaa0e233-3b707b7a02.zip/node_modules/zen-observable-ts/module.js
function _createForOfIteratorHelperLoose(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) return (it = it.call(o)).next.bind(it); if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

// === Symbol Support ===
var hasSymbols = function () {
  return typeof Symbol === 'function';
};

var hasSymbol = function (name) {
  return hasSymbols() && Boolean(Symbol[name]);
};

var getSymbol = function (name) {
  return hasSymbol(name) ? Symbol[name] : '@@' + name;
};

if (hasSymbols() && !hasSymbol('observable')) {
  Symbol.observable = Symbol('observable');
}

var SymbolIterator = getSymbol('iterator');
var SymbolObservable = getSymbol('observable');
var SymbolSpecies = getSymbol('species'); // === Abstract Operations ===

function getMethod(obj, key) {
  var value = obj[key];
  if (value == null) return undefined;
  if (typeof value !== 'function') throw new TypeError(value + ' is not a function');
  return value;
}

function getSpecies(obj) {
  var ctor = obj.constructor;

  if (ctor !== undefined) {
    ctor = ctor[SymbolSpecies];

    if (ctor === null) {
      ctor = undefined;
    }
  }

  return ctor !== undefined ? ctor : Observable;
}

function isObservable(x) {
  return x instanceof Observable; // SPEC: Brand check
}

function hostReportError(e) {
  if (hostReportError.log) {
    hostReportError.log(e);
  } else {
    setTimeout(function () {
      throw e;
    });
  }
}

function enqueue(fn) {
  Promise.resolve().then(function () {
    try {
      fn();
    } catch (e) {
      hostReportError(e);
    }
  });
}

function cleanupSubscription(subscription) {
  var cleanup = subscription._cleanup;
  if (cleanup === undefined) return;
  subscription._cleanup = undefined;

  if (!cleanup) {
    return;
  }

  try {
    if (typeof cleanup === 'function') {
      cleanup();
    } else {
      var unsubscribe = getMethod(cleanup, 'unsubscribe');

      if (unsubscribe) {
        unsubscribe.call(cleanup);
      }
    }
  } catch (e) {
    hostReportError(e);
  }
}

function closeSubscription(subscription) {
  subscription._observer = undefined;
  subscription._queue = undefined;
  subscription._state = 'closed';
}

function flushSubscription(subscription) {
  var queue = subscription._queue;

  if (!queue) {
    return;
  }

  subscription._queue = undefined;
  subscription._state = 'ready';

  for (var i = 0; i < queue.length; ++i) {
    notifySubscription(subscription, queue[i].type, queue[i].value);
    if (subscription._state === 'closed') break;
  }
}

function notifySubscription(subscription, type, value) {
  subscription._state = 'running';
  var observer = subscription._observer;

  try {
    var m = getMethod(observer, type);

    switch (type) {
      case 'next':
        if (m) m.call(observer, value);
        break;

      case 'error':
        closeSubscription(subscription);
        if (m) m.call(observer, value);else throw value;
        break;

      case 'complete':
        closeSubscription(subscription);
        if (m) m.call(observer);
        break;
    }
  } catch (e) {
    hostReportError(e);
  }

  if (subscription._state === 'closed') cleanupSubscription(subscription);else if (subscription._state === 'running') subscription._state = 'ready';
}

function onNotify(subscription, type, value) {
  if (subscription._state === 'closed') return;

  if (subscription._state === 'buffering') {
    subscription._queue.push({
      type: type,
      value: value
    });

    return;
  }

  if (subscription._state !== 'ready') {
    subscription._state = 'buffering';
    subscription._queue = [{
      type: type,
      value: value
    }];
    enqueue(function () {
      return flushSubscription(subscription);
    });
    return;
  }

  notifySubscription(subscription, type, value);
}

var Subscription = /*#__PURE__*/function () {
  function Subscription(observer, subscriber) {
    // ASSERT: observer is an object
    // ASSERT: subscriber is callable
    this._cleanup = undefined;
    this._observer = observer;
    this._queue = undefined;
    this._state = 'initializing';
    var subscriptionObserver = new SubscriptionObserver(this);

    try {
      this._cleanup = subscriber.call(undefined, subscriptionObserver);
    } catch (e) {
      subscriptionObserver.error(e);
    }

    if (this._state === 'initializing') this._state = 'ready';
  }

  var _proto = Subscription.prototype;

  _proto.unsubscribe = function unsubscribe() {
    if (this._state !== 'closed') {
      closeSubscription(this);
      cleanupSubscription(this);
    }
  };

  _createClass(Subscription, [{
    key: "closed",
    get: function () {
      return this._state === 'closed';
    }
  }]);

  return Subscription;
}();

var SubscriptionObserver = /*#__PURE__*/function () {
  function SubscriptionObserver(subscription) {
    this._subscription = subscription;
  }

  var _proto2 = SubscriptionObserver.prototype;

  _proto2.next = function next(value) {
    onNotify(this._subscription, 'next', value);
  };

  _proto2.error = function error(value) {
    onNotify(this._subscription, 'error', value);
  };

  _proto2.complete = function complete() {
    onNotify(this._subscription, 'complete');
  };

  _createClass(SubscriptionObserver, [{
    key: "closed",
    get: function () {
      return this._subscription._state === 'closed';
    }
  }]);

  return SubscriptionObserver;
}();

var Observable = /*#__PURE__*/function () {
  function Observable(subscriber) {
    if (!(this instanceof Observable)) throw new TypeError('Observable cannot be called as a function');
    if (typeof subscriber !== 'function') throw new TypeError('Observable initializer must be a function');
    this._subscriber = subscriber;
  }

  var _proto3 = Observable.prototype;

  _proto3.subscribe = function subscribe(observer) {
    if (typeof observer !== 'object' || observer === null) {
      observer = {
        next: observer,
        error: arguments[1],
        complete: arguments[2]
      };
    }

    return new Subscription(observer, this._subscriber);
  };

  _proto3.forEach = function forEach(fn) {
    var _this = this;

    return new Promise(function (resolve, reject) {
      if (typeof fn !== 'function') {
        reject(new TypeError(fn + ' is not a function'));
        return;
      }

      function done() {
        subscription.unsubscribe();
        resolve();
      }

      var subscription = _this.subscribe({
        next: function (value) {
          try {
            fn(value, done);
          } catch (e) {
            reject(e);
            subscription.unsubscribe();
          }
        },
        error: reject,
        complete: resolve
      });
    });
  };

  _proto3.map = function map(fn) {
    var _this2 = this;

    if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
    var C = getSpecies(this);
    return new C(function (observer) {
      return _this2.subscribe({
        next: function (value) {
          try {
            value = fn(value);
          } catch (e) {
            return observer.error(e);
          }

          observer.next(value);
        },
        error: function (e) {
          observer.error(e);
        },
        complete: function () {
          observer.complete();
        }
      });
    });
  };

  _proto3.filter = function filter(fn) {
    var _this3 = this;

    if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
    var C = getSpecies(this);
    return new C(function (observer) {
      return _this3.subscribe({
        next: function (value) {
          try {
            if (!fn(value)) return;
          } catch (e) {
            return observer.error(e);
          }

          observer.next(value);
        },
        error: function (e) {
          observer.error(e);
        },
        complete: function () {
          observer.complete();
        }
      });
    });
  };

  _proto3.reduce = function reduce(fn) {
    var _this4 = this;

    if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
    var C = getSpecies(this);
    var hasSeed = arguments.length > 1;
    var hasValue = false;
    var seed = arguments[1];
    var acc = seed;
    return new C(function (observer) {
      return _this4.subscribe({
        next: function (value) {
          var first = !hasValue;
          hasValue = true;

          if (!first || hasSeed) {
            try {
              acc = fn(acc, value);
            } catch (e) {
              return observer.error(e);
            }
          } else {
            acc = value;
          }
        },
        error: function (e) {
          observer.error(e);
        },
        complete: function () {
          if (!hasValue && !hasSeed) return observer.error(new TypeError('Cannot reduce an empty sequence'));
          observer.next(acc);
          observer.complete();
        }
      });
    });
  };

  _proto3.concat = function concat() {
    var _this5 = this;

    for (var _len = arguments.length, sources = new Array(_len), _key = 0; _key < _len; _key++) {
      sources[_key] = arguments[_key];
    }

    var C = getSpecies(this);
    return new C(function (observer) {
      var subscription;
      var index = 0;

      function startNext(next) {
        subscription = next.subscribe({
          next: function (v) {
            observer.next(v);
          },
          error: function (e) {
            observer.error(e);
          },
          complete: function () {
            if (index === sources.length) {
              subscription = undefined;
              observer.complete();
            } else {
              startNext(C.from(sources[index++]));
            }
          }
        });
      }

      startNext(_this5);
      return function () {
        if (subscription) {
          subscription.unsubscribe();
          subscription = undefined;
        }
      };
    });
  };

  _proto3.flatMap = function flatMap(fn) {
    var _this6 = this;

    if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
    var C = getSpecies(this);
    return new C(function (observer) {
      var subscriptions = [];

      var outer = _this6.subscribe({
        next: function (value) {
          if (fn) {
            try {
              value = fn(value);
            } catch (e) {
              return observer.error(e);
            }
          }

          var inner = C.from(value).subscribe({
            next: function (value) {
              observer.next(value);
            },
            error: function (e) {
              observer.error(e);
            },
            complete: function () {
              var i = subscriptions.indexOf(inner);
              if (i >= 0) subscriptions.splice(i, 1);
              completeIfDone();
            }
          });
          subscriptions.push(inner);
        },
        error: function (e) {
          observer.error(e);
        },
        complete: function () {
          completeIfDone();
        }
      });

      function completeIfDone() {
        if (outer.closed && subscriptions.length === 0) observer.complete();
      }

      return function () {
        subscriptions.forEach(function (s) {
          return s.unsubscribe();
        });
        outer.unsubscribe();
      };
    });
  };

  _proto3[SymbolObservable] = function () {
    return this;
  };

  Observable.from = function from(x) {
    var C = typeof this === 'function' ? this : Observable;
    if (x == null) throw new TypeError(x + ' is not an object');
    var method = getMethod(x, SymbolObservable);

    if (method) {
      var observable = method.call(x);
      if (Object(observable) !== observable) throw new TypeError(observable + ' is not an object');
      if (isObservable(observable) && observable.constructor === C) return observable;
      return new C(function (observer) {
        return observable.subscribe(observer);
      });
    }

    if (hasSymbol('iterator')) {
      method = getMethod(x, SymbolIterator);

      if (method) {
        return new C(function (observer) {
          enqueue(function () {
            if (observer.closed) return;

            for (var _iterator = _createForOfIteratorHelperLoose(method.call(x)), _step; !(_step = _iterator()).done;) {
              var item = _step.value;
              observer.next(item);
              if (observer.closed) return;
            }

            observer.complete();
          });
        });
      }
    }

    if (Array.isArray(x)) {
      return new C(function (observer) {
        enqueue(function () {
          if (observer.closed) return;

          for (var i = 0; i < x.length; ++i) {
            observer.next(x[i]);
            if (observer.closed) return;
          }

          observer.complete();
        });
      });
    }

    throw new TypeError(x + ' is not observable');
  };

  Observable.of = function of() {
    for (var _len2 = arguments.length, items = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      items[_key2] = arguments[_key2];
    }

    var C = typeof this === 'function' ? this : Observable;
    return new C(function (observer) {
      enqueue(function () {
        if (observer.closed) return;

        for (var i = 0; i < items.length; ++i) {
          observer.next(items[i]);
          if (observer.closed) return;
        }

        observer.complete();
      });
    });
  };

  _createClass(Observable, null, [{
    key: SymbolSpecies,
    get: function () {
      return this;
    }
  }]);

  return Observable;
}();

if (hasSymbols()) {
  Object.defineProperty(Observable, Symbol('extensions'), {
    value: {
      symbol: SymbolObservable,
      hostReportError: hostReportError
    },
    configurable: true
  });
}



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@apollo-client-virtual-cd9e78d17f/0/cache/@apollo-client-npm-3.7.1-a80032e019-95bb1f226f.zip/node_modules/@apollo/client/link/utils/createOperation.js

function createOperation(starting, operation) {
    var context = (0,tslib_es6/* __assign */.pi)({}, starting);
    var setContext = function (next) {
        if (typeof next === 'function') {
            context = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, context), next(context));
        }
        else {
            context = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, context), next);
        }
    };
    var getContext = function () { return ((0,tslib_es6/* __assign */.pi)({}, context)); };
    Object.defineProperty(operation, 'setContext', {
        enumerable: false,
        value: setContext,
    });
    Object.defineProperty(operation, 'getContext', {
        enumerable: false,
        value: getContext,
    });
    return operation;
}
//# sourceMappingURL=createOperation.js.map
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@apollo-client-virtual-cd9e78d17f/0/cache/@apollo-client-npm-3.7.1-a80032e019-95bb1f226f.zip/node_modules/@apollo/client/link/utils/transformOperation.js

function transformOperation(operation) {
    var transformedOperation = {
        variables: operation.variables || {},
        extensions: operation.extensions || {},
        operationName: operation.operationName,
        query: operation.query,
    };
    if (!transformedOperation.operationName) {
        transformedOperation.operationName =
            typeof transformedOperation.query !== 'string'
                ? getOperationName(transformedOperation.query) || undefined
                : '';
    }
    return transformedOperation;
}
//# sourceMappingURL=transformOperation.js.map
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@apollo-client-virtual-cd9e78d17f/0/cache/@apollo-client-npm-3.7.1-a80032e019-95bb1f226f.zip/node_modules/@apollo/client/link/utils/validateOperation.js

function validateOperation(operation) {
    var OPERATION_FIELDS = [
        'query',
        'operationName',
        'variables',
        'extensions',
        'context',
    ];
    for (var _i = 0, _a = Object.keys(operation); _i < _a.length; _i++) {
        var key = _a[_i];
        if (OPERATION_FIELDS.indexOf(key) < 0) {
            throw __DEV__ ? new invariant/* InvariantError */.ej("illegal argument: ".concat(key)) : new invariant/* InvariantError */.ej(26);
        }
    }
    return operation;
}
//# sourceMappingURL=validateOperation.js.map
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@apollo-client-virtual-cd9e78d17f/0/cache/@apollo-client-npm-3.7.1-a80032e019-95bb1f226f.zip/node_modules/@apollo/client/link/core/ApolloLink.js




function passthrough(op, forward) {
    return (forward ? forward(op) : Observable.of());
}
function toLink(handler) {
    return typeof handler === 'function' ? new ApolloLink(handler) : handler;
}
function isTerminating(link) {
    return link.request.length <= 1;
}
var LinkError = (function (_super) {
    (0,tslib_es6/* __extends */.ZT)(LinkError, _super);
    function LinkError(message, link) {
        var _this = _super.call(this, message) || this;
        _this.link = link;
        return _this;
    }
    return LinkError;
}(Error));
var ApolloLink = (function () {
    function ApolloLink(request) {
        if (request)
            this.request = request;
    }
    ApolloLink.empty = function () {
        return new ApolloLink(function () { return Observable.of(); });
    };
    ApolloLink.from = function (links) {
        if (links.length === 0)
            return ApolloLink.empty();
        return links.map(toLink).reduce(function (x, y) { return x.concat(y); });
    };
    ApolloLink.split = function (test, left, right) {
        var leftLink = toLink(left);
        var rightLink = toLink(right || new ApolloLink(passthrough));
        if (isTerminating(leftLink) && isTerminating(rightLink)) {
            return new ApolloLink(function (operation) {
                return test(operation)
                    ? leftLink.request(operation) || Observable.of()
                    : rightLink.request(operation) || Observable.of();
            });
        }
        else {
            return new ApolloLink(function (operation, forward) {
                return test(operation)
                    ? leftLink.request(operation, forward) || Observable.of()
                    : rightLink.request(operation, forward) || Observable.of();
            });
        }
    };
    ApolloLink.execute = function (link, operation) {
        return (link.request(createOperation(operation.context, transformOperation(validateOperation(operation)))) || Observable.of());
    };
    ApolloLink.concat = function (first, second) {
        var firstLink = toLink(first);
        if (isTerminating(firstLink)) {
            __DEV__ && invariant/* invariant.warn */.kG.warn(new LinkError("You are calling concat on a terminating link, which will have no effect", firstLink));
            return firstLink;
        }
        var nextLink = toLink(second);
        if (isTerminating(nextLink)) {
            return new ApolloLink(function (operation) {
                return firstLink.request(operation, function (op) { return nextLink.request(op) || Observable.of(); }) || Observable.of();
            });
        }
        else {
            return new ApolloLink(function (operation, forward) {
                return (firstLink.request(operation, function (op) {
                    return nextLink.request(op, forward) || Observable.of();
                }) || Observable.of());
            });
        }
    };
    ApolloLink.prototype.split = function (test, left, right) {
        return this.concat(ApolloLink.split(test, left, right || new ApolloLink(passthrough)));
    };
    ApolloLink.prototype.concat = function (next) {
        return ApolloLink.concat(this, next);
    };
    ApolloLink.prototype.request = function (operation, forward) {
        throw __DEV__ ? new invariant/* InvariantError */.ej('request is not implemented') : new invariant/* InvariantError */.ej(21);
    };
    ApolloLink.prototype.onError = function (error, observer) {
        if (observer && observer.error) {
            observer.error(error);
            return false;
        }
        throw error;
    };
    ApolloLink.prototype.setOnError = function (fn) {
        this.onError = fn;
        return this;
    };
    return ApolloLink;
}());

//# sourceMappingURL=ApolloLink.js.map
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@apollo-client-virtual-cd9e78d17f/0/cache/@apollo-client-npm-3.7.1-a80032e019-95bb1f226f.zip/node_modules/@apollo/client/link/core/execute.js

var execute = ApolloLink.execute;
//# sourceMappingURL=execute.js.map
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@apollo-client-virtual-cd9e78d17f/0/cache/@apollo-client-npm-3.7.1-a80032e019-95bb1f226f.zip/node_modules/@apollo/client/version.js
var version = '3.7.1';
//# sourceMappingURL=version.js.map
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@apollo-client-virtual-cd9e78d17f/0/cache/@apollo-client-npm-3.7.1-a80032e019-95bb1f226f.zip/node_modules/@apollo/client/link/http/serializeFetchParameter.js

var serializeFetchParameter = function (p, label) {
    var serialized;
    try {
        serialized = JSON.stringify(p);
    }
    catch (e) {
        var parseError = __DEV__ ? new invariant/* InvariantError */.ej("Network request failed. ".concat(label, " is not serializable: ").concat(e.message)) : new invariant/* InvariantError */.ej(23);
        parseError.parseError = e;
        throw parseError;
    }
    return serialized;
};
//# sourceMappingURL=serializeFetchParameter.js.map
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@apollo-client-virtual-cd9e78d17f/0/cache/@apollo-client-npm-3.7.1-a80032e019-95bb1f226f.zip/node_modules/@apollo/client/link/http/selectURI.js
var selectURI = function (operation, fallbackURI) {
    var context = operation.getContext();
    var contextURI = context.uri;
    if (contextURI) {
        return contextURI;
    }
    else if (typeof fallbackURI === 'function') {
        return fallbackURI(operation);
    }
    else {
        return fallbackURI || '/graphql';
    }
};
//# sourceMappingURL=selectURI.js.map
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@apollo-client-virtual-cd9e78d17f/0/cache/@apollo-client-npm-3.7.1-a80032e019-95bb1f226f.zip/node_modules/@apollo/client/utilities/common/responseIterator.js

function isNodeResponse(value) {
    return !!value.body;
}
function isReadableStream(value) {
    return !!value.getReader;
}
function isAsyncIterableIterator(value) {
    return !!(canUseAsyncIteratorSymbol &&
        value[Symbol.asyncIterator]);
}
function isStreamableBlob(value) {
    return !!value.stream;
}
function isBlob(value) {
    return !!value.arrayBuffer;
}
function isNodeReadableStream(value) {
    return !!value.pipe;
}
//# sourceMappingURL=responseIterator.js.map
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@apollo-client-virtual-cd9e78d17f/0/cache/@apollo-client-npm-3.7.1-a80032e019-95bb1f226f.zip/node_modules/@apollo/client/link/http/iterators/async.js
function asyncIterator(source) {
    var _a;
    var iterator = source[Symbol.asyncIterator]();
    return _a = {
            next: function () {
                return iterator.next();
            }
        },
        _a[Symbol.asyncIterator] = function () {
            return this;
        },
        _a;
}
//# sourceMappingURL=async.js.map
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@apollo-client-virtual-cd9e78d17f/0/cache/@apollo-client-npm-3.7.1-a80032e019-95bb1f226f.zip/node_modules/@apollo/client/link/http/iterators/nodeStream.js

function nodeStreamIterator(stream) {
    var cleanup = null;
    var error = null;
    var done = false;
    var data = [];
    var waiting = [];
    function onData(chunk) {
        if (error)
            return;
        if (waiting.length) {
            var shiftedArr = waiting.shift();
            if (Array.isArray(shiftedArr) && shiftedArr[0]) {
                return shiftedArr[0]({ value: chunk, done: false });
            }
        }
        data.push(chunk);
    }
    function onError(err) {
        error = err;
        var all = waiting.slice();
        all.forEach(function (pair) {
            pair[1](err);
        });
        !cleanup || cleanup();
    }
    function onEnd() {
        done = true;
        var all = waiting.slice();
        all.forEach(function (pair) {
            pair[0]({ value: undefined, done: true });
        });
        !cleanup || cleanup();
    }
    cleanup = function () {
        cleanup = null;
        stream.removeListener("data", onData);
        stream.removeListener("error", onError);
        stream.removeListener("end", onEnd);
        stream.removeListener("finish", onEnd);
        stream.removeListener("close", onEnd);
    };
    stream.on("data", onData);
    stream.on("error", onError);
    stream.on("end", onEnd);
    stream.on("finish", onEnd);
    stream.on("close", onEnd);
    function getNext() {
        return new Promise(function (resolve, reject) {
            if (error)
                return reject(error);
            if (data.length)
                return resolve({ value: data.shift(), done: false });
            if (done)
                return resolve({ value: undefined, done: true });
            waiting.push([resolve, reject]);
        });
    }
    var iterator = {
        next: function () {
            return getNext();
        },
    };
    if (canUseAsyncIteratorSymbol) {
        iterator[Symbol.asyncIterator] = function () {
            return this;
        };
    }
    return iterator;
}
//# sourceMappingURL=nodeStream.js.map
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@apollo-client-virtual-cd9e78d17f/0/cache/@apollo-client-npm-3.7.1-a80032e019-95bb1f226f.zip/node_modules/@apollo/client/link/http/iterators/promise.js

function promiseIterator(promise) {
    var resolved = false;
    var iterator = {
        next: function () {
            if (resolved)
                return Promise.resolve({
                    value: undefined,
                    done: true,
                });
            resolved = true;
            return new Promise(function (resolve, reject) {
                promise
                    .then(function (value) {
                    resolve({ value: value, done: false });
                })
                    .catch(reject);
            });
        },
    };
    if (canUseAsyncIteratorSymbol) {
        iterator[Symbol.asyncIterator] = function () {
            return this;
        };
    }
    return iterator;
}
//# sourceMappingURL=promise.js.map
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@apollo-client-virtual-cd9e78d17f/0/cache/@apollo-client-npm-3.7.1-a80032e019-95bb1f226f.zip/node_modules/@apollo/client/link/http/iterators/reader.js

function readerIterator(reader) {
    var iterator = {
        next: function () {
            return reader.read();
        },
    };
    if (canUseAsyncIteratorSymbol) {
        iterator[Symbol.asyncIterator] = function () {
            return this;
        };
    }
    return iterator;
}
//# sourceMappingURL=reader.js.map
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@apollo-client-virtual-cd9e78d17f/0/cache/@apollo-client-npm-3.7.1-a80032e019-95bb1f226f.zip/node_modules/@apollo/client/link/http/responseIterator.js





function responseIterator(response) {
    var body = response;
    if (isNodeResponse(response))
        body = response.body;
    if (isAsyncIterableIterator(body))
        return asyncIterator(body);
    if (isReadableStream(body))
        return readerIterator(body.getReader());
    if (isStreamableBlob(body)) {
        return readerIterator(body.stream().getReader());
    }
    if (isBlob(body))
        return promiseIterator(body.arrayBuffer());
    if (isNodeReadableStream(body))
        return nodeStreamIterator(body);
    throw new Error("Unknown body type for responseIterator. Please pass a streamable response.");
}
//# sourceMappingURL=responseIterator.js.map
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@apollo-client-virtual-cd9e78d17f/0/cache/@apollo-client-npm-3.7.1-a80032e019-95bb1f226f.zip/node_modules/@apollo/client/link/utils/throwServerError.js
var throwServerError = function (response, result, message) {
    var error = new Error(message);
    error.name = 'ServerError';
    error.response = response;
    error.statusCode = response.status;
    error.result = result;
    throw error;
};
//# sourceMappingURL=throwServerError.js.map
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@apollo-client-virtual-cd9e78d17f/0/cache/@apollo-client-npm-3.7.1-a80032e019-95bb1f226f.zip/node_modules/@apollo/client/link/http/parseAndCheckHttpResponse.js



var parseAndCheckHttpResponse_hasOwnProperty = Object.prototype.hasOwnProperty;
function readMultipartBody(response, observer) {
    var _a, _b, _c;
    return (0,tslib_es6/* __awaiter */.mG)(this, void 0, void 0, function () {
        var decoder, contentType, delimiter, boundaryVal, boundary, buffer, iterator, running, _d, value, done, chunk, bi, message, i, headers, contentType_1, body, result;
        var _e;
        return (0,tslib_es6/* __generator */.Jh)(this, function (_f) {
            switch (_f.label) {
                case 0:
                    if (TextDecoder === undefined) {
                        throw new Error("TextDecoder must be defined in the environment: please import a polyfill.");
                    }
                    decoder = new TextDecoder("utf-8");
                    contentType = (_a = response.headers) === null || _a === void 0 ? void 0 : _a.get('content-type');
                    delimiter = "boundary=";
                    boundaryVal = (contentType === null || contentType === void 0 ? void 0 : contentType.includes(delimiter))
                        ? contentType === null || contentType === void 0 ? void 0 : contentType.substring((contentType === null || contentType === void 0 ? void 0 : contentType.indexOf(delimiter)) + delimiter.length).replace(/['"]/g, "").replace(/\;(.*)/gm, "").trim()
                        : "-";
                    boundary = "--".concat(boundaryVal);
                    buffer = "";
                    iterator = responseIterator(response);
                    running = true;
                    _f.label = 1;
                case 1:
                    if (!running) return [3, 3];
                    return [4, iterator.next()];
                case 2:
                    _d = _f.sent(), value = _d.value, done = _d.done;
                    chunk = typeof value === "string" ? value : decoder.decode(value);
                    running = !done;
                    buffer += chunk;
                    bi = buffer.indexOf(boundary);
                    while (bi > -1) {
                        message = void 0;
                        _e = [
                            buffer.slice(0, bi),
                            buffer.slice(bi + boundary.length),
                        ], message = _e[0], buffer = _e[1];
                        if (message.trim()) {
                            i = message.indexOf("\r\n\r\n");
                            headers = parseHeaders(message.slice(0, i));
                            contentType_1 = headers["content-type"];
                            if (contentType_1 &&
                                contentType_1.toLowerCase().indexOf("application/json") === -1) {
                                throw new Error("Unsupported patch content type: application/json is required.");
                            }
                            body = message.slice(i);
                            try {
                                result = parseJsonBody(response, body.replace("\r\n", ""));
                                if (Object.keys(result).length > 1 ||
                                    "data" in result ||
                                    "incremental" in result ||
                                    "errors" in result) {
                                    (_b = observer.next) === null || _b === void 0 ? void 0 : _b.call(observer, result);
                                }
                            }
                            catch (err) {
                                handleError(err, observer);
                            }
                        }
                        bi = buffer.indexOf(boundary);
                    }
                    return [3, 1];
                case 3:
                    (_c = observer.complete) === null || _c === void 0 ? void 0 : _c.call(observer);
                    return [2];
            }
        });
    });
}
function parseHeaders(headerText) {
    var headersInit = {};
    headerText.split("\n").forEach(function (line) {
        var i = line.indexOf(":");
        if (i > -1) {
            var name_1 = line.slice(0, i).trim().toLowerCase();
            var value = line.slice(i + 1).trim();
            headersInit[name_1] = value;
        }
    });
    return headersInit;
}
function parseJsonBody(response, bodyText) {
    if (response.status >= 300) {
        var getResult = function () {
            try {
                return JSON.parse(bodyText);
            }
            catch (err) {
                return bodyText;
            }
        };
        throwServerError(response, getResult(), "Response not successful: Received status code ".concat(response.status));
    }
    try {
        return JSON.parse(bodyText);
    }
    catch (err) {
        var parseError = err;
        parseError.name = "ServerParseError";
        parseError.response = response;
        parseError.statusCode = response.status;
        parseError.bodyText = bodyText;
        throw parseError;
    }
}
function handleError(err, observer) {
    var _a, _b;
    if (err.name === "AbortError")
        return;
    if (err.result && err.result.errors && err.result.data) {
        (_a = observer.next) === null || _a === void 0 ? void 0 : _a.call(observer, err.result);
    }
    (_b = observer.error) === null || _b === void 0 ? void 0 : _b.call(observer, err);
}
function readJsonBody(response, operation, observer) {
    parseAndCheckHttpResponse(operation)(response)
        .then(function (result) {
        var _a, _b;
        (_a = observer.next) === null || _a === void 0 ? void 0 : _a.call(observer, result);
        (_b = observer.complete) === null || _b === void 0 ? void 0 : _b.call(observer);
    })
        .catch(function (err) { return handleError(err, observer); });
}
function parseAndCheckHttpResponse(operations) {
    return function (response) {
        return response
            .text()
            .then(function (bodyText) { return parseJsonBody(response, bodyText); })
            .then(function (result) {
            if (response.status >= 300) {
                throwServerError(response, result, "Response not successful: Received status code ".concat(response.status));
            }
            if (!Array.isArray(result) &&
                !parseAndCheckHttpResponse_hasOwnProperty.call(result, "data") &&
                !parseAndCheckHttpResponse_hasOwnProperty.call(result, "errors")) {
                throwServerError(response, result, "Server response was missing for query '".concat(Array.isArray(operations)
                    ? operations.map(function (op) { return op.operationName; })
                    : operations.operationName, "'."));
            }
            return result;
        });
    };
}
//# sourceMappingURL=parseAndCheckHttpResponse.js.map
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@apollo-client-virtual-cd9e78d17f/0/cache/@apollo-client-npm-3.7.1-a80032e019-95bb1f226f.zip/node_modules/@apollo/client/link/http/checkFetcher.js

var checkFetcher = function (fetcher) {
    if (!fetcher && typeof fetch === 'undefined') {
        throw __DEV__ ? new invariant/* InvariantError */.ej("\n\"fetch\" has not been found globally and no fetcher has been configured. To fix this, install a fetch package (like https://www.npmjs.com/package/cross-fetch), instantiate the fetcher, and pass it into your HttpLink constructor. For example:\n\nimport fetch from 'cross-fetch';\nimport { ApolloClient, HttpLink } from '@apollo/client';\nconst client = new ApolloClient({\n  link: new HttpLink({ uri: '/graphql', fetch })\n});\n    ") : new invariant/* InvariantError */.ej(22);
    }
};
//# sourceMappingURL=checkFetcher.js.map
// EXTERNAL MODULE: ../../.yarn/cache/graphql-npm-16.5.0-348f68b718-a82a926d08.zip/node_modules/graphql/language/printer.mjs + 1 modules
var language_printer = __webpack_require__(64006);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@apollo-client-virtual-cd9e78d17f/0/cache/@apollo-client-npm-3.7.1-a80032e019-95bb1f226f.zip/node_modules/@apollo/client/link/http/selectHttpOptionsAndBody.js


;
var defaultHttpOptions = {
    includeQuery: true,
    includeExtensions: false,
    preserveHeaderCase: false,
};
var defaultHeaders = {
    accept: '*/*',
    'content-type': 'application/json',
};
var defaultOptions = {
    method: 'POST',
};
var fallbackHttpConfig = {
    http: defaultHttpOptions,
    headers: defaultHeaders,
    options: defaultOptions,
};
var defaultPrinter = function (ast, printer) { return printer(ast); };
function selectHttpOptionsAndBody(operation, fallbackConfig) {
    var configs = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        configs[_i - 2] = arguments[_i];
    }
    configs.unshift(fallbackConfig);
    return selectHttpOptionsAndBodyInternal.apply(void 0, __spreadArray([operation,
        defaultPrinter], configs, false));
}
function selectHttpOptionsAndBodyInternal(operation, printer) {
    var configs = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        configs[_i - 2] = arguments[_i];
    }
    var options = {};
    var http = {};
    configs.forEach(function (config) {
        options = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, options), config.options), { headers: (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, options.headers), config.headers) });
        if (config.credentials) {
            options.credentials = config.credentials;
        }
        http = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, http), config.http);
    });
    options.headers = removeDuplicateHeaders(options.headers, http.preserveHeaderCase);
    var operationName = operation.operationName, extensions = operation.extensions, variables = operation.variables, query = operation.query;
    var body = { operationName: operationName, variables: variables };
    if (http.includeExtensions)
        body.extensions = extensions;
    if (http.includeQuery)
        body.query = printer(query, language_printer/* print */.S);
    return {
        options: options,
        body: body,
    };
}
;
function removeDuplicateHeaders(headers, preserveHeaderCase) {
    if (!preserveHeaderCase) {
        var normalizedHeaders_1 = Object.create(null);
        Object.keys(Object(headers)).forEach(function (name) {
            normalizedHeaders_1[name.toLowerCase()] = headers[name];
        });
        return normalizedHeaders_1;
    }
    var headerData = Object.create(null);
    Object.keys(Object(headers)).forEach(function (name) {
        headerData[name.toLowerCase()] = { originalName: name, value: headers[name] };
    });
    var normalizedHeaders = Object.create(null);
    Object.keys(headerData).forEach(function (name) {
        normalizedHeaders[headerData[name].originalName] = headerData[name].value;
    });
    return normalizedHeaders;
}
//# sourceMappingURL=selectHttpOptionsAndBody.js.map
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@apollo-client-virtual-cd9e78d17f/0/cache/@apollo-client-npm-3.7.1-a80032e019-95bb1f226f.zip/node_modules/@apollo/client/link/http/createSignalIfSupported.js
var createSignalIfSupported = function () {
    if (typeof AbortController === 'undefined')
        return { controller: false, signal: false };
    var controller = new AbortController();
    var signal = controller.signal;
    return { controller: controller, signal: signal };
};
//# sourceMappingURL=createSignalIfSupported.js.map
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@apollo-client-virtual-cd9e78d17f/0/cache/@apollo-client-npm-3.7.1-a80032e019-95bb1f226f.zip/node_modules/@apollo/client/link/http/rewriteURIForGET.js

function rewriteURIForGET(chosenURI, body) {
    var queryParams = [];
    var addQueryParam = function (key, value) {
        queryParams.push("".concat(key, "=").concat(encodeURIComponent(value)));
    };
    if ('query' in body) {
        addQueryParam('query', body.query);
    }
    if (body.operationName) {
        addQueryParam('operationName', body.operationName);
    }
    if (body.variables) {
        var serializedVariables = void 0;
        try {
            serializedVariables = serializeFetchParameter(body.variables, 'Variables map');
        }
        catch (parseError) {
            return { parseError: parseError };
        }
        addQueryParam('variables', serializedVariables);
    }
    if (body.extensions) {
        var serializedExtensions = void 0;
        try {
            serializedExtensions = serializeFetchParameter(body.extensions, 'Extensions map');
        }
        catch (parseError) {
            return { parseError: parseError };
        }
        addQueryParam('extensions', serializedExtensions);
    }
    var fragment = '', preFragment = chosenURI;
    var fragmentStart = chosenURI.indexOf('#');
    if (fragmentStart !== -1) {
        fragment = chosenURI.substr(fragmentStart);
        preFragment = chosenURI.substr(0, fragmentStart);
    }
    var queryParamsPrefix = preFragment.indexOf('?') === -1 ? '?' : '&';
    var newURI = preFragment + queryParamsPrefix + queryParams.join('&') + fragment;
    return { newURI: newURI };
}
//# sourceMappingURL=rewriteURIForGET.js.map
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@apollo-client-virtual-cd9e78d17f/0/cache/@apollo-client-npm-3.7.1-a80032e019-95bb1f226f.zip/node_modules/@apollo/client/link/utils/fromError.js

function fromError(errorValue) {
    return new Observable(function (observer) {
        observer.error(errorValue);
    });
}
//# sourceMappingURL=fromError.js.map
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@apollo-client-virtual-cd9e78d17f/0/cache/@apollo-client-npm-3.7.1-a80032e019-95bb1f226f.zip/node_modules/@apollo/client/link/http/createHttpLink.js














var backupFetch = maybe(function () { return fetch; });
var createHttpLink = function (linkOptions) {
    if (linkOptions === void 0) { linkOptions = {}; }
    var _a = linkOptions.uri, uri = _a === void 0 ? '/graphql' : _a, preferredFetch = linkOptions.fetch, _b = linkOptions.print, print = _b === void 0 ? defaultPrinter : _b, includeExtensions = linkOptions.includeExtensions, preserveHeaderCase = linkOptions.preserveHeaderCase, useGETForQueries = linkOptions.useGETForQueries, _c = linkOptions.includeUnusedVariables, includeUnusedVariables = _c === void 0 ? false : _c, requestOptions = (0,tslib_es6/* __rest */._T)(linkOptions, ["uri", "fetch", "print", "includeExtensions", "preserveHeaderCase", "useGETForQueries", "includeUnusedVariables"]);
    if (__DEV__) {
        checkFetcher(preferredFetch || backupFetch);
    }
    var linkConfig = {
        http: { includeExtensions: includeExtensions, preserveHeaderCase: preserveHeaderCase },
        options: requestOptions.fetchOptions,
        credentials: requestOptions.credentials,
        headers: requestOptions.headers,
    };
    return new ApolloLink(function (operation) {
        var chosenURI = selectURI(operation, uri);
        var context = operation.getContext();
        var clientAwarenessHeaders = {};
        if (context.clientAwareness) {
            var _a = context.clientAwareness, name_1 = _a.name, version = _a.version;
            if (name_1) {
                clientAwarenessHeaders['apollographql-client-name'] = name_1;
            }
            if (version) {
                clientAwarenessHeaders['apollographql-client-version'] = version;
            }
        }
        var contextHeaders = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, clientAwarenessHeaders), context.headers);
        var contextConfig = {
            http: context.http,
            options: context.fetchOptions,
            credentials: context.credentials,
            headers: contextHeaders,
        };
        var _b = selectHttpOptionsAndBodyInternal(operation, print, fallbackHttpConfig, linkConfig, contextConfig), options = _b.options, body = _b.body;
        if (body.variables && !includeUnusedVariables) {
            var unusedNames_1 = new Set(Object.keys(body.variables));
            (0,visitor/* visit */.Vn)(operation.query, {
                Variable: function (node, _key, parent) {
                    if (parent && parent.kind !== 'VariableDefinition') {
                        unusedNames_1.delete(node.name.value);
                    }
                },
            });
            if (unusedNames_1.size) {
                body.variables = (0,tslib_es6/* __assign */.pi)({}, body.variables);
                unusedNames_1.forEach(function (name) {
                    delete body.variables[name];
                });
            }
        }
        var controller;
        if (!options.signal) {
            var _c = createSignalIfSupported(), _controller = _c.controller, signal = _c.signal;
            controller = _controller;
            if (controller)
                options.signal = signal;
        }
        var definitionIsMutation = function (d) {
            return d.kind === 'OperationDefinition' && d.operation === 'mutation';
        };
        if (useGETForQueries &&
            !operation.query.definitions.some(definitionIsMutation)) {
            options.method = 'GET';
        }
        if (hasDirectives(['defer'], operation.query)) {
            options.headers.accept = "multipart/mixed; deferSpec=20220824, application/json";
        }
        if (options.method === 'GET') {
            var _d = rewriteURIForGET(chosenURI, body), newURI = _d.newURI, parseError = _d.parseError;
            if (parseError) {
                return fromError(parseError);
            }
            chosenURI = newURI;
        }
        else {
            try {
                options.body = serializeFetchParameter(body, 'Payload');
            }
            catch (parseError) {
                return fromError(parseError);
            }
        }
        return new Observable(function (observer) {
            var currentFetch = preferredFetch || maybe(function () { return fetch; }) || backupFetch;
            currentFetch(chosenURI, options)
                .then(function (response) {
                var _a;
                operation.setContext({ response: response });
                var ctype = (_a = response.headers) === null || _a === void 0 ? void 0 : _a.get('content-type');
                if (ctype !== null && /^multipart\/mixed/i.test(ctype)) {
                    return readMultipartBody(response, observer);
                }
                else {
                    return readJsonBody(response, operation, observer);
                }
            })
                .catch(function (err) { return handleError(err, observer); });
            return function () {
                if (controller)
                    controller.abort();
            };
        });
    });
};
//# sourceMappingURL=createHttpLink.js.map
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@apollo-client-virtual-cd9e78d17f/0/cache/@apollo-client-npm-3.7.1-a80032e019-95bb1f226f.zip/node_modules/@apollo/client/link/http/HttpLink.js



var HttpLink = (function (_super) {
    (0,tslib_es6/* __extends */.ZT)(HttpLink, _super);
    function HttpLink(options) {
        if (options === void 0) { options = {}; }
        var _this = _super.call(this, createHttpLink(options).request) || this;
        _this.options = options;
        return _this;
    }
    return HttpLink;
}(ApolloLink));

//# sourceMappingURL=HttpLink.js.map
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@apollo-client-virtual-cd9e78d17f/0/cache/@apollo-client-npm-3.7.1-a80032e019-95bb1f226f.zip/node_modules/@apollo/client/utilities/common/incrementalResult.js
function isExecutionPatchIncrementalResult(value) {
    return !!value.incremental;
}
//# sourceMappingURL=incrementalResult.js.map
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@apollo-client-virtual-cd9e78d17f/0/cache/@apollo-client-npm-3.7.1-a80032e019-95bb1f226f.zip/node_modules/@apollo/client/utilities/observables/asyncMap.js

function asyncMap(observable, mapFn, catchFn) {
    return new Observable(function (observer) {
        var next = observer.next, error = observer.error, complete = observer.complete;
        var activeCallbackCount = 0;
        var completed = false;
        var promiseQueue = {
            then: function (callback) {
                return new Promise(function (resolve) { return resolve(callback()); });
            },
        };
        function makeCallback(examiner, delegate) {
            if (examiner) {
                return function (arg) {
                    ++activeCallbackCount;
                    var both = function () { return examiner(arg); };
                    promiseQueue = promiseQueue.then(both, both).then(function (result) {
                        --activeCallbackCount;
                        next && next.call(observer, result);
                        if (completed) {
                            handler.complete();
                        }
                    }, function (error) {
                        --activeCallbackCount;
                        throw error;
                    }).catch(function (caught) {
                        error && error.call(observer, caught);
                    });
                };
            }
            else {
                return function (arg) { return delegate && delegate.call(observer, arg); };
            }
        }
        var handler = {
            next: makeCallback(mapFn, next),
            error: makeCallback(catchFn, error),
            complete: function () {
                completed = true;
                if (!activeCallbackCount) {
                    complete && complete.call(observer);
                }
            },
        };
        var sub = observable.subscribe(handler);
        return function () { return sub.unsubscribe(); };
    });
}
//# sourceMappingURL=asyncMap.js.map
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@apollo-client-virtual-cd9e78d17f/0/cache/@apollo-client-npm-3.7.1-a80032e019-95bb1f226f.zip/node_modules/@apollo/client/utilities/common/errorHandling.js
function graphQLResultHasError(result) {
    return (result.errors && result.errors.length > 0) || false;
}
//# sourceMappingURL=errorHandling.js.map
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@apollo-client-virtual-cd9e78d17f/0/cache/@apollo-client-npm-3.7.1-a80032e019-95bb1f226f.zip/node_modules/@apollo/client/utilities/observables/iteration.js
function iterateObserversSafely(observers, method, argument) {
    var observersWithMethod = [];
    observers.forEach(function (obs) { return obs[method] && observersWithMethod.push(obs); });
    observersWithMethod.forEach(function (obs) { return obs[method](argument); });
}
//# sourceMappingURL=iteration.js.map
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@apollo-client-virtual-cd9e78d17f/0/cache/@apollo-client-npm-3.7.1-a80032e019-95bb1f226f.zip/node_modules/@apollo/client/utilities/observables/subclassing.js


function fixObservableSubclass(subclass) {
    function set(key) {
        Object.defineProperty(subclass, key, { value: Observable });
    }
    if (canUseSymbol && Symbol.species) {
        set(Symbol.species);
    }
    set("@@species");
    return subclass;
}
//# sourceMappingURL=subclassing.js.map
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@apollo-client-virtual-cd9e78d17f/0/cache/@apollo-client-npm-3.7.1-a80032e019-95bb1f226f.zip/node_modules/@apollo/client/utilities/observables/Concast.js




function Concast_isPromiseLike(value) {
    return value && typeof value.then === "function";
}
var Concast = (function (_super) {
    (0,tslib_es6/* __extends */.ZT)(Concast, _super);
    function Concast(sources) {
        var _this = _super.call(this, function (observer) {
            _this.addObserver(observer);
            return function () { return _this.removeObserver(observer); };
        }) || this;
        _this.observers = new Set();
        _this.promise = new Promise(function (resolve, reject) {
            _this.resolve = resolve;
            _this.reject = reject;
        });
        _this.handlers = {
            next: function (result) {
                if (_this.sub !== null) {
                    _this.latest = ["next", result];
                    _this.notify("next", result);
                    iterateObserversSafely(_this.observers, "next", result);
                }
            },
            error: function (error) {
                var sub = _this.sub;
                if (sub !== null) {
                    if (sub)
                        setTimeout(function () { return sub.unsubscribe(); });
                    _this.sub = null;
                    _this.latest = ["error", error];
                    _this.reject(error);
                    _this.notify("error", error);
                    iterateObserversSafely(_this.observers, "error", error);
                }
            },
            complete: function () {
                var sub = _this.sub;
                if (sub !== null) {
                    var value = _this.sources.shift();
                    if (!value) {
                        if (sub)
                            setTimeout(function () { return sub.unsubscribe(); });
                        _this.sub = null;
                        if (_this.latest &&
                            _this.latest[0] === "next") {
                            _this.resolve(_this.latest[1]);
                        }
                        else {
                            _this.resolve();
                        }
                        _this.notify("complete");
                        iterateObserversSafely(_this.observers, "complete");
                    }
                    else if (Concast_isPromiseLike(value)) {
                        value.then(function (obs) { return _this.sub = obs.subscribe(_this.handlers); });
                    }
                    else {
                        _this.sub = value.subscribe(_this.handlers);
                    }
                }
            },
        };
        _this.nextResultListeners = new Set();
        _this.cancel = function (reason) {
            _this.reject(reason);
            _this.sources = [];
            _this.handlers.complete();
        };
        _this.promise.catch(function (_) { });
        if (typeof sources === "function") {
            sources = [new Observable(sources)];
        }
        if (Concast_isPromiseLike(sources)) {
            sources.then(function (iterable) { return _this.start(iterable); }, _this.handlers.error);
        }
        else {
            _this.start(sources);
        }
        return _this;
    }
    Concast.prototype.start = function (sources) {
        if (this.sub !== void 0)
            return;
        this.sources = Array.from(sources);
        this.handlers.complete();
    };
    Concast.prototype.deliverLastMessage = function (observer) {
        if (this.latest) {
            var nextOrError = this.latest[0];
            var method = observer[nextOrError];
            if (method) {
                method.call(observer, this.latest[1]);
            }
            if (this.sub === null &&
                nextOrError === "next" &&
                observer.complete) {
                observer.complete();
            }
        }
    };
    Concast.prototype.addObserver = function (observer) {
        if (!this.observers.has(observer)) {
            this.deliverLastMessage(observer);
            this.observers.add(observer);
        }
    };
    Concast.prototype.removeObserver = function (observer) {
        if (this.observers.delete(observer) &&
            this.observers.size < 1) {
            this.handlers.complete();
        }
    };
    Concast.prototype.notify = function (method, arg) {
        var nextResultListeners = this.nextResultListeners;
        if (nextResultListeners.size) {
            this.nextResultListeners = new Set;
            nextResultListeners.forEach(function (listener) { return listener(method, arg); });
        }
    };
    Concast.prototype.beforeNext = function (callback) {
        var called = false;
        this.nextResultListeners.add(function (method, arg) {
            if (!called) {
                called = true;
                callback(method, arg);
            }
        });
    };
    return Concast;
}(Observable));

fixObservableSubclass(Concast);
//# sourceMappingURL=Concast.js.map
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@apollo-client-virtual-cd9e78d17f/0/cache/@apollo-client-npm-3.7.1-a80032e019-95bb1f226f.zip/node_modules/@apollo/client/errors/index.js



function isApolloError(err) {
    return err.hasOwnProperty('graphQLErrors');
}
var generateErrorMessage = function (err) {
    var message = '';
    if (isNonEmptyArray(err.graphQLErrors) || isNonEmptyArray(err.clientErrors)) {
        var errors = (err.graphQLErrors || [])
            .concat(err.clientErrors || []);
        errors.forEach(function (error) {
            var errorMessage = error
                ? error.message
                : 'Error message not found.';
            message += "".concat(errorMessage, "\n");
        });
    }
    if (err.networkError) {
        message += "".concat(err.networkError.message, "\n");
    }
    message = message.replace(/\n$/, '');
    return message;
};
var errors_ApolloError = (function (_super) {
    (0,tslib_es6/* __extends */.ZT)(ApolloError, _super);
    function ApolloError(_a) {
        var graphQLErrors = _a.graphQLErrors, clientErrors = _a.clientErrors, networkError = _a.networkError, errorMessage = _a.errorMessage, extraInfo = _a.extraInfo;
        var _this = _super.call(this, errorMessage) || this;
        _this.graphQLErrors = graphQLErrors || [];
        _this.clientErrors = clientErrors || [];
        _this.networkError = networkError || null;
        _this.message = errorMessage || generateErrorMessage(_this);
        _this.extraInfo = extraInfo;
        _this.__proto__ = ApolloError.prototype;
        return _this;
    }
    return ApolloError;
}(Error));

//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@apollo-client-virtual-cd9e78d17f/0/cache/@apollo-client-npm-3.7.1-a80032e019-95bb1f226f.zip/node_modules/@apollo/client/core/networkStatus.js
var NetworkStatus;
(function (NetworkStatus) {
    NetworkStatus[NetworkStatus["loading"] = 1] = "loading";
    NetworkStatus[NetworkStatus["setVariables"] = 2] = "setVariables";
    NetworkStatus[NetworkStatus["fetchMore"] = 3] = "fetchMore";
    NetworkStatus[NetworkStatus["refetch"] = 4] = "refetch";
    NetworkStatus[NetworkStatus["poll"] = 6] = "poll";
    NetworkStatus[NetworkStatus["ready"] = 7] = "ready";
    NetworkStatus[NetworkStatus["error"] = 8] = "error";
})(NetworkStatus || (NetworkStatus = {}));
function isNetworkRequestInFlight(networkStatus) {
    return networkStatus ? networkStatus < 7 : false;
}
//# sourceMappingURL=networkStatus.js.map
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@apollo-client-virtual-cd9e78d17f/0/cache/@apollo-client-npm-3.7.1-a80032e019-95bb1f226f.zip/node_modules/@apollo/client/core/ObservableQuery.js





var ObservableQuery_assign = Object.assign, ObservableQuery_hasOwnProperty = Object.hasOwnProperty;
var ObservableQuery = (function (_super) {
    (0,tslib_es6/* __extends */.ZT)(ObservableQuery, _super);
    function ObservableQuery(_a) {
        var queryManager = _a.queryManager, queryInfo = _a.queryInfo, options = _a.options;
        var _this = _super.call(this, function (observer) {
            try {
                var subObserver = observer._subscription._observer;
                if (subObserver && !subObserver.error) {
                    subObserver.error = defaultSubscriptionObserverErrorCallback;
                }
            }
            catch (_a) { }
            var first = !_this.observers.size;
            _this.observers.add(observer);
            var last = _this.last;
            if (last && last.error) {
                observer.error && observer.error(last.error);
            }
            else if (last && last.result) {
                observer.next && observer.next(last.result);
            }
            if (first) {
                _this.reobserve().catch(function () { });
            }
            return function () {
                if (_this.observers.delete(observer) && !_this.observers.size) {
                    _this.tearDownQuery();
                }
            };
        }) || this;
        _this.observers = new Set();
        _this.subscriptions = new Set();
        _this.queryInfo = queryInfo;
        _this.queryManager = queryManager;
        _this.isTornDown = false;
        var _b = queryManager.defaultOptions.watchQuery, _c = _b === void 0 ? {} : _b, _d = _c.fetchPolicy, defaultFetchPolicy = _d === void 0 ? "cache-first" : _d;
        var _e = options.fetchPolicy, fetchPolicy = _e === void 0 ? defaultFetchPolicy : _e, _f = options.initialFetchPolicy, initialFetchPolicy = _f === void 0 ? (fetchPolicy === "standby" ? defaultFetchPolicy : fetchPolicy) : _f;
        _this.options = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, options), { initialFetchPolicy: initialFetchPolicy, fetchPolicy: fetchPolicy });
        _this.queryId = queryInfo.queryId || queryManager.generateQueryId();
        var opDef = getOperationDefinition(_this.query);
        _this.queryName = opDef && opDef.name && opDef.name.value;
        return _this;
    }
    Object.defineProperty(ObservableQuery.prototype, "query", {
        get: function () {
            return this.queryManager.transform(this.options.query).document;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ObservableQuery.prototype, "variables", {
        get: function () {
            return this.options.variables;
        },
        enumerable: false,
        configurable: true
    });
    ObservableQuery.prototype.result = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var observer = {
                next: function (result) {
                    resolve(result);
                    _this.observers.delete(observer);
                    if (!_this.observers.size) {
                        _this.queryManager.removeQuery(_this.queryId);
                    }
                    setTimeout(function () {
                        subscription.unsubscribe();
                    }, 0);
                },
                error: reject,
            };
            var subscription = _this.subscribe(observer);
        });
    };
    ObservableQuery.prototype.getCurrentResult = function (saveAsLastResult) {
        if (saveAsLastResult === void 0) { saveAsLastResult = true; }
        var lastResult = this.getLastResult(true);
        var networkStatus = this.queryInfo.networkStatus ||
            (lastResult && lastResult.networkStatus) ||
            NetworkStatus.ready;
        var result = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, lastResult), { loading: isNetworkRequestInFlight(networkStatus), networkStatus: networkStatus });
        var _a = this.options.fetchPolicy, fetchPolicy = _a === void 0 ? "cache-first" : _a;
        if (fetchPolicy === 'network-only' ||
            fetchPolicy === 'no-cache' ||
            fetchPolicy === 'standby' ||
            this.queryManager.transform(this.options.query).hasForcedResolvers) {
        }
        else {
            var diff = this.queryInfo.getDiff();
            if (diff.complete || this.options.returnPartialData) {
                result.data = diff.result;
            }
            if (equal(result.data, {})) {
                result.data = void 0;
            }
            if (diff.complete) {
                delete result.partial;
                if (diff.complete &&
                    result.networkStatus === NetworkStatus.loading &&
                    (fetchPolicy === 'cache-first' ||
                        fetchPolicy === 'cache-only')) {
                    result.networkStatus = NetworkStatus.ready;
                    result.loading = false;
                }
            }
            else {
                result.partial = true;
            }
            if (__DEV__ &&
                !diff.complete &&
                !this.options.partialRefetch &&
                !result.loading &&
                !result.data &&
                !result.error) {
                logMissingFieldErrors(diff.missing);
            }
        }
        if (saveAsLastResult) {
            this.updateLastResult(result);
        }
        return result;
    };
    ObservableQuery.prototype.isDifferentFromLastResult = function (newResult, variables) {
        return (!this.last ||
            !equal(this.last.result, newResult) ||
            (variables && !equal(this.last.variables, variables)));
    };
    ObservableQuery.prototype.getLast = function (key, variablesMustMatch) {
        var last = this.last;
        if (last &&
            last[key] &&
            (!variablesMustMatch || equal(last.variables, this.variables))) {
            return last[key];
        }
    };
    ObservableQuery.prototype.getLastResult = function (variablesMustMatch) {
        return this.getLast("result", variablesMustMatch);
    };
    ObservableQuery.prototype.getLastError = function (variablesMustMatch) {
        return this.getLast("error", variablesMustMatch);
    };
    ObservableQuery.prototype.resetLastResults = function () {
        delete this.last;
        this.isTornDown = false;
    };
    ObservableQuery.prototype.resetQueryStoreErrors = function () {
        this.queryManager.resetErrors(this.queryId);
    };
    ObservableQuery.prototype.refetch = function (variables) {
        var _a;
        var reobserveOptions = {
            pollInterval: 0,
        };
        var fetchPolicy = this.options.fetchPolicy;
        if (fetchPolicy === 'cache-and-network') {
            reobserveOptions.fetchPolicy = fetchPolicy;
        }
        else if (fetchPolicy === 'no-cache') {
            reobserveOptions.fetchPolicy = 'no-cache';
        }
        else {
            reobserveOptions.fetchPolicy = 'network-only';
        }
        if (__DEV__ && variables && ObservableQuery_hasOwnProperty.call(variables, "variables")) {
            var queryDef = getQueryDefinition(this.query);
            var vars = queryDef.variableDefinitions;
            if (!vars || !vars.some(function (v) { return v.variable.name.value === "variables"; })) {
                __DEV__ && invariant/* invariant.warn */.kG.warn("Called refetch(".concat(JSON.stringify(variables), ") for query ").concat(((_a = queryDef.name) === null || _a === void 0 ? void 0 : _a.value) || JSON.stringify(queryDef), ", which does not declare a $variables variable.\nDid you mean to call refetch(variables) instead of refetch({ variables })?"));
            }
        }
        if (variables && !equal(this.options.variables, variables)) {
            reobserveOptions.variables = this.options.variables = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, this.options.variables), variables);
        }
        this.queryInfo.resetLastWrite();
        return this.reobserve(reobserveOptions, NetworkStatus.refetch);
    };
    ObservableQuery.prototype.fetchMore = function (fetchMoreOptions) {
        var _this = this;
        var combinedOptions = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, (fetchMoreOptions.query ? fetchMoreOptions : (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, this.options), { query: this.query }), fetchMoreOptions), { variables: (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, this.options.variables), fetchMoreOptions.variables) }))), { fetchPolicy: "no-cache" });
        var qid = this.queryManager.generateQueryId();
        var queryInfo = this.queryInfo;
        var originalNetworkStatus = queryInfo.networkStatus;
        queryInfo.networkStatus = NetworkStatus.fetchMore;
        if (combinedOptions.notifyOnNetworkStatusChange) {
            this.observe();
        }
        var updatedQuerySet = new Set();
        return this.queryManager.fetchQuery(qid, combinedOptions, NetworkStatus.fetchMore).then(function (fetchMoreResult) {
            _this.queryManager.removeQuery(qid);
            if (queryInfo.networkStatus === NetworkStatus.fetchMore) {
                queryInfo.networkStatus = originalNetworkStatus;
            }
            _this.queryManager.cache.batch({
                update: function (cache) {
                    var updateQuery = fetchMoreOptions.updateQuery;
                    if (updateQuery) {
                        cache.updateQuery({
                            query: _this.query,
                            variables: _this.variables,
                            returnPartialData: true,
                            optimistic: false,
                        }, function (previous) { return updateQuery(previous, {
                            fetchMoreResult: fetchMoreResult.data,
                            variables: combinedOptions.variables,
                        }); });
                    }
                    else {
                        cache.writeQuery({
                            query: combinedOptions.query,
                            variables: combinedOptions.variables,
                            data: fetchMoreResult.data,
                        });
                    }
                },
                onWatchUpdated: function (watch) {
                    updatedQuerySet.add(watch.query);
                },
            });
            return fetchMoreResult;
        }).finally(function () {
            if (!updatedQuerySet.has(_this.query)) {
                reobserveCacheFirst(_this);
            }
        });
    };
    ObservableQuery.prototype.subscribeToMore = function (options) {
        var _this = this;
        var subscription = this.queryManager
            .startGraphQLSubscription({
            query: options.document,
            variables: options.variables,
            context: options.context,
        })
            .subscribe({
            next: function (subscriptionData) {
                var updateQuery = options.updateQuery;
                if (updateQuery) {
                    _this.updateQuery(function (previous, _a) {
                        var variables = _a.variables;
                        return updateQuery(previous, {
                            subscriptionData: subscriptionData,
                            variables: variables,
                        });
                    });
                }
            },
            error: function (err) {
                if (options.onError) {
                    options.onError(err);
                    return;
                }
                __DEV__ && invariant/* invariant.error */.kG.error('Unhandled GraphQL subscription error', err);
            },
        });
        this.subscriptions.add(subscription);
        return function () {
            if (_this.subscriptions.delete(subscription)) {
                subscription.unsubscribe();
            }
        };
    };
    ObservableQuery.prototype.setOptions = function (newOptions) {
        return this.reobserve(newOptions);
    };
    ObservableQuery.prototype.setVariables = function (variables) {
        if (equal(this.variables, variables)) {
            return this.observers.size
                ? this.result()
                : Promise.resolve();
        }
        this.options.variables = variables;
        if (!this.observers.size) {
            return Promise.resolve();
        }
        return this.reobserve({
            fetchPolicy: this.options.initialFetchPolicy,
            variables: variables,
        }, NetworkStatus.setVariables);
    };
    ObservableQuery.prototype.updateQuery = function (mapFn) {
        var queryManager = this.queryManager;
        var result = queryManager.cache.diff({
            query: this.options.query,
            variables: this.variables,
            returnPartialData: true,
            optimistic: false,
        }).result;
        var newResult = mapFn(result, {
            variables: this.variables,
        });
        if (newResult) {
            queryManager.cache.writeQuery({
                query: this.options.query,
                data: newResult,
                variables: this.variables,
            });
            queryManager.broadcastQueries();
        }
    };
    ObservableQuery.prototype.startPolling = function (pollInterval) {
        this.options.pollInterval = pollInterval;
        this.updatePolling();
    };
    ObservableQuery.prototype.stopPolling = function () {
        this.options.pollInterval = 0;
        this.updatePolling();
    };
    ObservableQuery.prototype.applyNextFetchPolicy = function (reason, options) {
        if (options.nextFetchPolicy) {
            var _a = options.fetchPolicy, fetchPolicy = _a === void 0 ? "cache-first" : _a, _b = options.initialFetchPolicy, initialFetchPolicy = _b === void 0 ? fetchPolicy : _b;
            if (fetchPolicy === "standby") {
            }
            else if (typeof options.nextFetchPolicy === "function") {
                options.fetchPolicy = options.nextFetchPolicy(fetchPolicy, {
                    reason: reason,
                    options: options,
                    observable: this,
                    initialFetchPolicy: initialFetchPolicy,
                });
            }
            else if (reason === "variables-changed") {
                options.fetchPolicy = initialFetchPolicy;
            }
            else {
                options.fetchPolicy = options.nextFetchPolicy;
            }
        }
        return options.fetchPolicy;
    };
    ObservableQuery.prototype.fetch = function (options, newNetworkStatus) {
        this.queryManager.setObservableQuery(this);
        return this.queryManager.fetchQueryObservable(this.queryId, options, newNetworkStatus);
    };
    ObservableQuery.prototype.updatePolling = function () {
        var _this = this;
        if (this.queryManager.ssrMode) {
            return;
        }
        var _a = this, pollingInfo = _a.pollingInfo, pollInterval = _a.options.pollInterval;
        if (!pollInterval) {
            if (pollingInfo) {
                clearTimeout(pollingInfo.timeout);
                delete this.pollingInfo;
            }
            return;
        }
        if (pollingInfo &&
            pollingInfo.interval === pollInterval) {
            return;
        }
        __DEV__ ? (0,invariant/* invariant */.kG)(pollInterval, 'Attempted to start a polling query without a polling interval.') : (0,invariant/* invariant */.kG)(pollInterval, 12);
        var info = pollingInfo || (this.pollingInfo = {});
        info.interval = pollInterval;
        var maybeFetch = function () {
            if (_this.pollingInfo) {
                if (!isNetworkRequestInFlight(_this.queryInfo.networkStatus)) {
                    _this.reobserve({
                        fetchPolicy: _this.options.initialFetchPolicy === 'no-cache' ? 'no-cache' : 'network-only',
                    }, NetworkStatus.poll).then(poll, poll);
                }
                else {
                    poll();
                }
            }
            ;
        };
        var poll = function () {
            var info = _this.pollingInfo;
            if (info) {
                clearTimeout(info.timeout);
                info.timeout = setTimeout(maybeFetch, info.interval);
            }
        };
        poll();
    };
    ObservableQuery.prototype.updateLastResult = function (newResult, variables) {
        if (variables === void 0) { variables = this.variables; }
        this.last = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, this.last), { result: this.queryManager.assumeImmutableResults
                ? newResult
                : cloneDeep(newResult), variables: variables });
        if (!isNonEmptyArray(newResult.errors)) {
            delete this.last.error;
        }
        return this.last;
    };
    ObservableQuery.prototype.reobserve = function (newOptions, newNetworkStatus) {
        var _this = this;
        this.isTornDown = false;
        var useDisposableConcast = newNetworkStatus === NetworkStatus.refetch ||
            newNetworkStatus === NetworkStatus.fetchMore ||
            newNetworkStatus === NetworkStatus.poll;
        var oldVariables = this.options.variables;
        var oldFetchPolicy = this.options.fetchPolicy;
        var mergedOptions = compact(this.options, newOptions || {});
        var options = useDisposableConcast
            ? mergedOptions
            : ObservableQuery_assign(this.options, mergedOptions);
        if (!useDisposableConcast) {
            this.updatePolling();
            if (newOptions &&
                newOptions.variables &&
                !equal(newOptions.variables, oldVariables) &&
                options.fetchPolicy !== "standby" &&
                options.fetchPolicy === oldFetchPolicy) {
                this.applyNextFetchPolicy("variables-changed", options);
                if (newNetworkStatus === void 0) {
                    newNetworkStatus = NetworkStatus.setVariables;
                }
            }
        }
        var variables = options.variables && (0,tslib_es6/* __assign */.pi)({}, options.variables);
        var concast = this.fetch(options, newNetworkStatus);
        var observer = {
            next: function (result) {
                _this.reportResult(result, variables);
            },
            error: function (error) {
                _this.reportError(error, variables);
            },
        };
        if (!useDisposableConcast) {
            if (this.concast && this.observer) {
                this.concast.removeObserver(this.observer);
            }
            this.concast = concast;
            this.observer = observer;
        }
        concast.addObserver(observer);
        return concast.promise;
    };
    ObservableQuery.prototype.observe = function () {
        this.reportResult(this.getCurrentResult(false), this.variables);
    };
    ObservableQuery.prototype.reportResult = function (result, variables) {
        var lastError = this.getLastError();
        if (lastError || this.isDifferentFromLastResult(result, variables)) {
            if (lastError || !result.partial || this.options.returnPartialData) {
                this.updateLastResult(result, variables);
            }
            iterateObserversSafely(this.observers, 'next', result);
        }
    };
    ObservableQuery.prototype.reportError = function (error, variables) {
        var errorResult = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, this.getLastResult()), { error: error, errors: error.graphQLErrors, networkStatus: NetworkStatus.error, loading: false });
        this.updateLastResult(errorResult, variables);
        iterateObserversSafely(this.observers, 'error', this.last.error = error);
    };
    ObservableQuery.prototype.hasObservers = function () {
        return this.observers.size > 0;
    };
    ObservableQuery.prototype.tearDownQuery = function () {
        if (this.isTornDown)
            return;
        if (this.concast && this.observer) {
            this.concast.removeObserver(this.observer);
            delete this.concast;
            delete this.observer;
        }
        this.stopPolling();
        this.subscriptions.forEach(function (sub) { return sub.unsubscribe(); });
        this.subscriptions.clear();
        this.queryManager.stopQuery(this.queryId);
        this.observers.clear();
        this.isTornDown = true;
    };
    return ObservableQuery;
}(Observable));

fixObservableSubclass(ObservableQuery);
function reobserveCacheFirst(obsQuery) {
    var _a = obsQuery.options, fetchPolicy = _a.fetchPolicy, nextFetchPolicy = _a.nextFetchPolicy;
    if (fetchPolicy === "cache-and-network" ||
        fetchPolicy === "network-only") {
        return obsQuery.reobserve({
            fetchPolicy: "cache-first",
            nextFetchPolicy: function () {
                this.nextFetchPolicy = nextFetchPolicy;
                if (typeof nextFetchPolicy === "function") {
                    return nextFetchPolicy.apply(this, arguments);
                }
                return fetchPolicy;
            },
        });
    }
    return obsQuery.reobserve();
}
function defaultSubscriptionObserverErrorCallback(error) {
    __DEV__ && invariant/* invariant.error */.kG.error('Unhandled error', error.message, error.stack);
}
function logMissingFieldErrors(missing) {
    if (__DEV__ && missing) {
        __DEV__ && invariant/* invariant.debug */.kG.debug("Missing cache result fields: ".concat(JSON.stringify(missing)), missing);
    }
}
//# sourceMappingURL=ObservableQuery.js.map
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@apollo-client-virtual-cd9e78d17f/0/cache/@apollo-client-npm-3.7.1-a80032e019-95bb1f226f.zip/node_modules/@apollo/client/core/LocalState.js





var LocalState = (function () {
    function LocalState(_a) {
        var cache = _a.cache, client = _a.client, resolvers = _a.resolvers, fragmentMatcher = _a.fragmentMatcher;
        this.cache = cache;
        if (client) {
            this.client = client;
        }
        if (resolvers) {
            this.addResolvers(resolvers);
        }
        if (fragmentMatcher) {
            this.setFragmentMatcher(fragmentMatcher);
        }
    }
    LocalState.prototype.addResolvers = function (resolvers) {
        var _this = this;
        this.resolvers = this.resolvers || {};
        if (Array.isArray(resolvers)) {
            resolvers.forEach(function (resolverGroup) {
                _this.resolvers = mergeDeep(_this.resolvers, resolverGroup);
            });
        }
        else {
            this.resolvers = mergeDeep(this.resolvers, resolvers);
        }
    };
    LocalState.prototype.setResolvers = function (resolvers) {
        this.resolvers = {};
        this.addResolvers(resolvers);
    };
    LocalState.prototype.getResolvers = function () {
        return this.resolvers || {};
    };
    LocalState.prototype.runResolvers = function (_a) {
        var document = _a.document, remoteResult = _a.remoteResult, context = _a.context, variables = _a.variables, _b = _a.onlyRunForcedResolvers, onlyRunForcedResolvers = _b === void 0 ? false : _b;
        return (0,tslib_es6/* __awaiter */.mG)(this, void 0, void 0, function () {
            return (0,tslib_es6/* __generator */.Jh)(this, function (_c) {
                if (document) {
                    return [2, this.resolveDocument(document, remoteResult.data, context, variables, this.fragmentMatcher, onlyRunForcedResolvers).then(function (localResult) { return ((0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, remoteResult), { data: localResult.result })); })];
                }
                return [2, remoteResult];
            });
        });
    };
    LocalState.prototype.setFragmentMatcher = function (fragmentMatcher) {
        this.fragmentMatcher = fragmentMatcher;
    };
    LocalState.prototype.getFragmentMatcher = function () {
        return this.fragmentMatcher;
    };
    LocalState.prototype.clientQuery = function (document) {
        if (hasDirectives(['client'], document)) {
            if (this.resolvers) {
                return document;
            }
        }
        return null;
    };
    LocalState.prototype.serverQuery = function (document) {
        return removeClientSetsFromDocument(document);
    };
    LocalState.prototype.prepareContext = function (context) {
        var cache = this.cache;
        return (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, context), { cache: cache, getCacheKey: function (obj) {
                return cache.identify(obj);
            } });
    };
    LocalState.prototype.addExportedVariables = function (document, variables, context) {
        if (variables === void 0) { variables = {}; }
        if (context === void 0) { context = {}; }
        return (0,tslib_es6/* __awaiter */.mG)(this, void 0, void 0, function () {
            return (0,tslib_es6/* __generator */.Jh)(this, function (_a) {
                if (document) {
                    return [2, this.resolveDocument(document, this.buildRootValueFromCache(document, variables) || {}, this.prepareContext(context), variables).then(function (data) { return ((0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, variables), data.exportedVariables)); })];
                }
                return [2, (0,tslib_es6/* __assign */.pi)({}, variables)];
            });
        });
    };
    LocalState.prototype.shouldForceResolvers = function (document) {
        var forceResolvers = false;
        (0,visitor/* visit */.Vn)(document, {
            Directive: {
                enter: function (node) {
                    if (node.name.value === 'client' && node.arguments) {
                        forceResolvers = node.arguments.some(function (arg) {
                            return arg.name.value === 'always' &&
                                arg.value.kind === 'BooleanValue' &&
                                arg.value.value === true;
                        });
                        if (forceResolvers) {
                            return visitor/* BREAK */.$_;
                        }
                    }
                },
            },
        });
        return forceResolvers;
    };
    LocalState.prototype.buildRootValueFromCache = function (document, variables) {
        return this.cache.diff({
            query: buildQueryFromSelectionSet(document),
            variables: variables,
            returnPartialData: true,
            optimistic: false,
        }).result;
    };
    LocalState.prototype.resolveDocument = function (document, rootValue, context, variables, fragmentMatcher, onlyRunForcedResolvers) {
        if (context === void 0) { context = {}; }
        if (variables === void 0) { variables = {}; }
        if (fragmentMatcher === void 0) { fragmentMatcher = function () { return true; }; }
        if (onlyRunForcedResolvers === void 0) { onlyRunForcedResolvers = false; }
        return (0,tslib_es6/* __awaiter */.mG)(this, void 0, void 0, function () {
            var mainDefinition, fragments, fragmentMap, definitionOperation, defaultOperationType, _a, cache, client, execContext;
            return (0,tslib_es6/* __generator */.Jh)(this, function (_b) {
                mainDefinition = getMainDefinition(document);
                fragments = getFragmentDefinitions(document);
                fragmentMap = createFragmentMap(fragments);
                definitionOperation = mainDefinition
                    .operation;
                defaultOperationType = definitionOperation
                    ? definitionOperation.charAt(0).toUpperCase() +
                        definitionOperation.slice(1)
                    : 'Query';
                _a = this, cache = _a.cache, client = _a.client;
                execContext = {
                    fragmentMap: fragmentMap,
                    context: (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, context), { cache: cache, client: client }),
                    variables: variables,
                    fragmentMatcher: fragmentMatcher,
                    defaultOperationType: defaultOperationType,
                    exportedVariables: {},
                    onlyRunForcedResolvers: onlyRunForcedResolvers,
                };
                return [2, this.resolveSelectionSet(mainDefinition.selectionSet, rootValue, execContext).then(function (result) { return ({
                        result: result,
                        exportedVariables: execContext.exportedVariables,
                    }); })];
            });
        });
    };
    LocalState.prototype.resolveSelectionSet = function (selectionSet, rootValue, execContext) {
        return (0,tslib_es6/* __awaiter */.mG)(this, void 0, void 0, function () {
            var fragmentMap, context, variables, resultsToMerge, execute;
            var _this = this;
            return (0,tslib_es6/* __generator */.Jh)(this, function (_a) {
                fragmentMap = execContext.fragmentMap, context = execContext.context, variables = execContext.variables;
                resultsToMerge = [rootValue];
                execute = function (selection) { return (0,tslib_es6/* __awaiter */.mG)(_this, void 0, void 0, function () {
                    var fragment, typeCondition;
                    return (0,tslib_es6/* __generator */.Jh)(this, function (_a) {
                        if (!shouldInclude(selection, variables)) {
                            return [2];
                        }
                        if (storeUtils_isField(selection)) {
                            return [2, this.resolveField(selection, rootValue, execContext).then(function (fieldResult) {
                                    var _a;
                                    if (typeof fieldResult !== 'undefined') {
                                        resultsToMerge.push((_a = {},
                                            _a[resultKeyNameFromField(selection)] = fieldResult,
                                            _a));
                                    }
                                })];
                        }
                        if (isInlineFragment(selection)) {
                            fragment = selection;
                        }
                        else {
                            fragment = fragmentMap[selection.name.value];
                            __DEV__ ? (0,invariant/* invariant */.kG)(fragment, "No fragment named ".concat(selection.name.value)) : (0,invariant/* invariant */.kG)(fragment, 11);
                        }
                        if (fragment && fragment.typeCondition) {
                            typeCondition = fragment.typeCondition.name.value;
                            if (execContext.fragmentMatcher(rootValue, typeCondition, context)) {
                                return [2, this.resolveSelectionSet(fragment.selectionSet, rootValue, execContext).then(function (fragmentResult) {
                                        resultsToMerge.push(fragmentResult);
                                    })];
                            }
                        }
                        return [2];
                    });
                }); };
                return [2, Promise.all(selectionSet.selections.map(execute)).then(function () {
                        return mergeDeepArray(resultsToMerge);
                    })];
            });
        });
    };
    LocalState.prototype.resolveField = function (field, rootValue, execContext) {
        return (0,tslib_es6/* __awaiter */.mG)(this, void 0, void 0, function () {
            var variables, fieldName, aliasedFieldName, aliasUsed, defaultResult, resultPromise, resolverType, resolverMap, resolve;
            var _this = this;
            return (0,tslib_es6/* __generator */.Jh)(this, function (_a) {
                variables = execContext.variables;
                fieldName = field.name.value;
                aliasedFieldName = resultKeyNameFromField(field);
                aliasUsed = fieldName !== aliasedFieldName;
                defaultResult = rootValue[aliasedFieldName] || rootValue[fieldName];
                resultPromise = Promise.resolve(defaultResult);
                if (!execContext.onlyRunForcedResolvers ||
                    this.shouldForceResolvers(field)) {
                    resolverType = rootValue.__typename || execContext.defaultOperationType;
                    resolverMap = this.resolvers && this.resolvers[resolverType];
                    if (resolverMap) {
                        resolve = resolverMap[aliasUsed ? fieldName : aliasedFieldName];
                        if (resolve) {
                            resultPromise = Promise.resolve(cacheSlot.withValue(this.cache, resolve, [
                                rootValue,
                                argumentsObjectFromField(field, variables),
                                execContext.context,
                                { field: field, fragmentMap: execContext.fragmentMap },
                            ]));
                        }
                    }
                }
                return [2, resultPromise.then(function (result) {
                        if (result === void 0) { result = defaultResult; }
                        if (field.directives) {
                            field.directives.forEach(function (directive) {
                                if (directive.name.value === 'export' && directive.arguments) {
                                    directive.arguments.forEach(function (arg) {
                                        if (arg.name.value === 'as' && arg.value.kind === 'StringValue') {
                                            execContext.exportedVariables[arg.value.value] = result;
                                        }
                                    });
                                }
                            });
                        }
                        if (!field.selectionSet) {
                            return result;
                        }
                        if (result == null) {
                            return result;
                        }
                        if (Array.isArray(result)) {
                            return _this.resolveSubSelectedArray(field, result, execContext);
                        }
                        if (field.selectionSet) {
                            return _this.resolveSelectionSet(field.selectionSet, result, execContext);
                        }
                    })];
            });
        });
    };
    LocalState.prototype.resolveSubSelectedArray = function (field, result, execContext) {
        var _this = this;
        return Promise.all(result.map(function (item) {
            if (item === null) {
                return null;
            }
            if (Array.isArray(item)) {
                return _this.resolveSubSelectedArray(field, item, execContext);
            }
            if (field.selectionSet) {
                return _this.resolveSelectionSet(field.selectionSet, item, execContext);
            }
        }));
    };
    return LocalState;
}());

//# sourceMappingURL=LocalState.js.map
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@apollo-client-virtual-cd9e78d17f/0/cache/@apollo-client-npm-3.7.1-a80032e019-95bb1f226f.zip/node_modules/@apollo/client/core/QueryInfo.js






;
var destructiveMethodCounts = new (canUseWeakMap ? WeakMap : Map)();
function wrapDestructiveCacheMethod(cache, methodName) {
    var original = cache[methodName];
    if (typeof original === "function") {
        cache[methodName] = function () {
            destructiveMethodCounts.set(cache, (destructiveMethodCounts.get(cache) + 1) % 1e15);
            return original.apply(this, arguments);
        };
    }
}
function cancelNotifyTimeout(info) {
    if (info["notifyTimeout"]) {
        clearTimeout(info["notifyTimeout"]);
        info["notifyTimeout"] = void 0;
    }
}
var QueryInfo = (function () {
    function QueryInfo(queryManager, queryId) {
        if (queryId === void 0) { queryId = queryManager.generateQueryId(); }
        this.queryId = queryId;
        this.listeners = new Set();
        this.document = null;
        this.lastRequestId = 1;
        this.subscriptions = new Set();
        this.stopped = false;
        this.dirty = false;
        this.observableQuery = null;
        var cache = this.cache = queryManager.cache;
        if (!destructiveMethodCounts.has(cache)) {
            destructiveMethodCounts.set(cache, 0);
            wrapDestructiveCacheMethod(cache, "evict");
            wrapDestructiveCacheMethod(cache, "modify");
            wrapDestructiveCacheMethod(cache, "reset");
        }
    }
    QueryInfo.prototype.init = function (query) {
        var networkStatus = query.networkStatus || NetworkStatus.loading;
        if (this.variables &&
            this.networkStatus !== NetworkStatus.loading &&
            !equal(this.variables, query.variables)) {
            networkStatus = NetworkStatus.setVariables;
        }
        if (!equal(query.variables, this.variables)) {
            this.lastDiff = void 0;
        }
        Object.assign(this, {
            document: query.document,
            variables: query.variables,
            networkError: null,
            graphQLErrors: this.graphQLErrors || [],
            networkStatus: networkStatus,
        });
        if (query.observableQuery) {
            this.setObservableQuery(query.observableQuery);
        }
        if (query.lastRequestId) {
            this.lastRequestId = query.lastRequestId;
        }
        return this;
    };
    QueryInfo.prototype.reset = function () {
        cancelNotifyTimeout(this);
        this.dirty = false;
    };
    QueryInfo.prototype.getDiff = function (variables) {
        if (variables === void 0) { variables = this.variables; }
        var options = this.getDiffOptions(variables);
        if (this.lastDiff && equal(options, this.lastDiff.options)) {
            return this.lastDiff.diff;
        }
        this.updateWatch(this.variables = variables);
        var oq = this.observableQuery;
        if (oq && oq.options.fetchPolicy === "no-cache") {
            return { complete: false };
        }
        var diff = this.cache.diff(options);
        this.updateLastDiff(diff, options);
        return diff;
    };
    QueryInfo.prototype.updateLastDiff = function (diff, options) {
        this.lastDiff = diff ? {
            diff: diff,
            options: options || this.getDiffOptions(),
        } : void 0;
    };
    QueryInfo.prototype.getDiffOptions = function (variables) {
        var _a;
        if (variables === void 0) { variables = this.variables; }
        return {
            query: this.document,
            variables: variables,
            returnPartialData: true,
            optimistic: true,
            canonizeResults: (_a = this.observableQuery) === null || _a === void 0 ? void 0 : _a.options.canonizeResults,
        };
    };
    QueryInfo.prototype.setDiff = function (diff) {
        var _this = this;
        var oldDiff = this.lastDiff && this.lastDiff.diff;
        this.updateLastDiff(diff);
        if (!this.dirty &&
            !equal(oldDiff && oldDiff.result, diff && diff.result)) {
            this.dirty = true;
            if (!this.notifyTimeout) {
                this.notifyTimeout = setTimeout(function () { return _this.notify(); }, 0);
            }
        }
    };
    QueryInfo.prototype.setObservableQuery = function (oq) {
        var _this = this;
        if (oq === this.observableQuery)
            return;
        if (this.oqListener) {
            this.listeners.delete(this.oqListener);
        }
        this.observableQuery = oq;
        if (oq) {
            oq["queryInfo"] = this;
            this.listeners.add(this.oqListener = function () {
                var diff = _this.getDiff();
                if (diff.fromOptimisticTransaction) {
                    oq["observe"]();
                }
                else {
                    reobserveCacheFirst(oq);
                }
            });
        }
        else {
            delete this.oqListener;
        }
    };
    QueryInfo.prototype.notify = function () {
        var _this = this;
        cancelNotifyTimeout(this);
        if (this.shouldNotify()) {
            this.listeners.forEach(function (listener) { return listener(_this); });
        }
        this.dirty = false;
    };
    QueryInfo.prototype.shouldNotify = function () {
        if (!this.dirty || !this.listeners.size) {
            return false;
        }
        if (isNetworkRequestInFlight(this.networkStatus) &&
            this.observableQuery) {
            var fetchPolicy = this.observableQuery.options.fetchPolicy;
            if (fetchPolicy !== "cache-only" &&
                fetchPolicy !== "cache-and-network") {
                return false;
            }
        }
        return true;
    };
    QueryInfo.prototype.stop = function () {
        if (!this.stopped) {
            this.stopped = true;
            this.reset();
            this.cancel();
            this.cancel = QueryInfo.prototype.cancel;
            this.subscriptions.forEach(function (sub) { return sub.unsubscribe(); });
            var oq = this.observableQuery;
            if (oq)
                oq.stopPolling();
        }
    };
    QueryInfo.prototype.cancel = function () { };
    QueryInfo.prototype.updateWatch = function (variables) {
        var _this = this;
        if (variables === void 0) { variables = this.variables; }
        var oq = this.observableQuery;
        if (oq && oq.options.fetchPolicy === "no-cache") {
            return;
        }
        var watchOptions = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, this.getDiffOptions(variables)), { watcher: this, callback: function (diff) { return _this.setDiff(diff); } });
        if (!this.lastWatch ||
            !equal(watchOptions, this.lastWatch)) {
            this.cancel();
            this.cancel = this.cache.watch(this.lastWatch = watchOptions);
        }
    };
    QueryInfo.prototype.resetLastWrite = function () {
        this.lastWrite = void 0;
    };
    QueryInfo.prototype.shouldWrite = function (result, variables) {
        var lastWrite = this.lastWrite;
        return !(lastWrite &&
            lastWrite.dmCount === destructiveMethodCounts.get(this.cache) &&
            equal(variables, lastWrite.variables) &&
            equal(result.data, lastWrite.result.data));
    };
    QueryInfo.prototype.markResult = function (result, document, options, cacheWriteBehavior) {
        var _this = this;
        var graphQLErrors = isNonEmptyArray(result.errors)
            ? result.errors.slice(0)
            : [];
        this.reset();
        if ('incremental' in result && isNonEmptyArray(result.incremental)) {
            var mergedData_1 = this.getDiff().result;
            var merger_1 = new DeepMerger();
            result.incremental.forEach(function (_a) {
                var data = _a.data, path = _a.path, errors = _a.errors;
                for (var i = path.length - 1; i >= 0; --i) {
                    var key = path[i];
                    var isNumericKey = !isNaN(+key);
                    var parent_1 = isNumericKey ? [] : {};
                    parent_1[key] = data;
                    data = parent_1;
                }
                if (errors) {
                    graphQLErrors.push.apply(graphQLErrors, errors);
                }
                mergedData_1 = merger_1.merge(mergedData_1, data);
            });
            result.data = mergedData_1;
        }
        this.graphQLErrors = graphQLErrors;
        if (options.fetchPolicy === 'no-cache') {
            this.updateLastDiff({ result: result.data, complete: true }, this.getDiffOptions(options.variables));
        }
        else if (cacheWriteBehavior !== 0) {
            if (shouldWriteResult(result, options.errorPolicy)) {
                this.cache.performTransaction(function (cache) {
                    if (_this.shouldWrite(result, options.variables)) {
                        cache.writeQuery({
                            query: document,
                            data: result.data,
                            variables: options.variables,
                            overwrite: cacheWriteBehavior === 1,
                        });
                        _this.lastWrite = {
                            result: result,
                            variables: options.variables,
                            dmCount: destructiveMethodCounts.get(_this.cache),
                        };
                    }
                    else {
                        if (_this.lastDiff &&
                            _this.lastDiff.diff.complete) {
                            result.data = _this.lastDiff.diff.result;
                            return;
                        }
                    }
                    var diffOptions = _this.getDiffOptions(options.variables);
                    var diff = cache.diff(diffOptions);
                    if (!_this.stopped) {
                        _this.updateWatch(options.variables);
                    }
                    _this.updateLastDiff(diff, diffOptions);
                    if (diff.complete) {
                        result.data = diff.result;
                    }
                });
            }
            else {
                this.lastWrite = void 0;
            }
        }
    };
    QueryInfo.prototype.markReady = function () {
        this.networkError = null;
        return this.networkStatus = NetworkStatus.ready;
    };
    QueryInfo.prototype.markError = function (error) {
        this.networkStatus = NetworkStatus.error;
        this.lastWrite = void 0;
        this.reset();
        if (error.graphQLErrors) {
            this.graphQLErrors = error.graphQLErrors;
        }
        if (error.networkError) {
            this.networkError = error.networkError;
        }
        return error;
    };
    return QueryInfo;
}());

function shouldWriteResult(result, errorPolicy) {
    if (errorPolicy === void 0) { errorPolicy = "none"; }
    var ignoreErrors = errorPolicy === "ignore" ||
        errorPolicy === "all";
    var writeWithErrors = !graphQLResultHasError(result);
    if (!writeWithErrors && ignoreErrors && result.data) {
        writeWithErrors = true;
    }
    return writeWithErrors;
}
//# sourceMappingURL=QueryInfo.js.map
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@apollo-client-virtual-cd9e78d17f/0/cache/@apollo-client-npm-3.7.1-a80032e019-95bb1f226f.zip/node_modules/@apollo/client/core/QueryManager.js












var QueryManager_hasOwnProperty = Object.prototype.hasOwnProperty;
var QueryManager = (function () {
    function QueryManager(_a) {
        var cache = _a.cache, link = _a.link, defaultOptions = _a.defaultOptions, _b = _a.queryDeduplication, queryDeduplication = _b === void 0 ? false : _b, onBroadcast = _a.onBroadcast, _c = _a.ssrMode, ssrMode = _c === void 0 ? false : _c, _d = _a.clientAwareness, clientAwareness = _d === void 0 ? {} : _d, localState = _a.localState, assumeImmutableResults = _a.assumeImmutableResults;
        this.clientAwareness = {};
        this.queries = new Map();
        this.fetchCancelFns = new Map();
        this.transformCache = new (canUseWeakMap ? WeakMap : Map)();
        this.queryIdCounter = 1;
        this.requestIdCounter = 1;
        this.mutationIdCounter = 1;
        this.inFlightLinkObservables = new Map();
        this.cache = cache;
        this.link = link;
        this.defaultOptions = defaultOptions || Object.create(null);
        this.queryDeduplication = queryDeduplication;
        this.clientAwareness = clientAwareness;
        this.localState = localState || new LocalState({ cache: cache });
        this.ssrMode = ssrMode;
        this.assumeImmutableResults = !!assumeImmutableResults;
        if ((this.onBroadcast = onBroadcast)) {
            this.mutationStore = Object.create(null);
        }
    }
    QueryManager.prototype.stop = function () {
        var _this = this;
        this.queries.forEach(function (_info, queryId) {
            _this.stopQueryNoBroadcast(queryId);
        });
        this.cancelPendingFetches(__DEV__ ? new invariant/* InvariantError */.ej('QueryManager stopped while query was in flight') : new invariant/* InvariantError */.ej(13));
    };
    QueryManager.prototype.cancelPendingFetches = function (error) {
        this.fetchCancelFns.forEach(function (cancel) { return cancel(error); });
        this.fetchCancelFns.clear();
    };
    QueryManager.prototype.mutate = function (_a) {
        var _b, _c;
        var mutation = _a.mutation, variables = _a.variables, optimisticResponse = _a.optimisticResponse, updateQueries = _a.updateQueries, _d = _a.refetchQueries, refetchQueries = _d === void 0 ? [] : _d, _e = _a.awaitRefetchQueries, awaitRefetchQueries = _e === void 0 ? false : _e, updateWithProxyFn = _a.update, onQueryUpdated = _a.onQueryUpdated, _f = _a.fetchPolicy, fetchPolicy = _f === void 0 ? ((_b = this.defaultOptions.mutate) === null || _b === void 0 ? void 0 : _b.fetchPolicy) || "network-only" : _f, _g = _a.errorPolicy, errorPolicy = _g === void 0 ? ((_c = this.defaultOptions.mutate) === null || _c === void 0 ? void 0 : _c.errorPolicy) || "none" : _g, keepRootFields = _a.keepRootFields, context = _a.context;
        return (0,tslib_es6/* __awaiter */.mG)(this, void 0, void 0, function () {
            var mutationId, _h, document, hasClientExports, mutationStoreValue, self;
            return (0,tslib_es6/* __generator */.Jh)(this, function (_j) {
                switch (_j.label) {
                    case 0:
                        __DEV__ ? (0,invariant/* invariant */.kG)(mutation, 'mutation option is required. You must specify your GraphQL document in the mutation option.') : (0,invariant/* invariant */.kG)(mutation, 14);
                        __DEV__ ? (0,invariant/* invariant */.kG)(fetchPolicy === 'network-only' ||
                            fetchPolicy === 'no-cache', "Mutations support only 'network-only' or 'no-cache' fetchPolicy strings. The default `network-only` behavior automatically writes mutation results to the cache. Passing `no-cache` skips the cache write.") : (0,invariant/* invariant */.kG)(fetchPolicy === 'network-only' ||
                            fetchPolicy === 'no-cache', 15);
                        mutationId = this.generateMutationId();
                        _h = this.transform(mutation), document = _h.document, hasClientExports = _h.hasClientExports;
                        mutation = this.cache.transformForLink(document);
                        variables = this.getVariables(mutation, variables);
                        if (!hasClientExports) return [3, 2];
                        return [4, this.localState.addExportedVariables(mutation, variables, context)];
                    case 1:
                        variables = (_j.sent());
                        _j.label = 2;
                    case 2:
                        mutationStoreValue = this.mutationStore &&
                            (this.mutationStore[mutationId] = {
                                mutation: mutation,
                                variables: variables,
                                loading: true,
                                error: null,
                            });
                        if (optimisticResponse) {
                            this.markMutationOptimistic(optimisticResponse, {
                                mutationId: mutationId,
                                document: mutation,
                                variables: variables,
                                fetchPolicy: fetchPolicy,
                                errorPolicy: errorPolicy,
                                context: context,
                                updateQueries: updateQueries,
                                update: updateWithProxyFn,
                                keepRootFields: keepRootFields,
                            });
                        }
                        this.broadcastQueries();
                        self = this;
                        return [2, new Promise(function (resolve, reject) {
                                return asyncMap(self.getObservableFromLink(mutation, (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, context), { optimisticResponse: optimisticResponse }), variables, false), function (result) {
                                    if (graphQLResultHasError(result) && errorPolicy === 'none') {
                                        throw new errors_ApolloError({
                                            graphQLErrors: result.errors,
                                        });
                                    }
                                    if (mutationStoreValue) {
                                        mutationStoreValue.loading = false;
                                        mutationStoreValue.error = null;
                                    }
                                    var storeResult = (0,tslib_es6/* __assign */.pi)({}, result);
                                    if (typeof refetchQueries === "function") {
                                        refetchQueries = refetchQueries(storeResult);
                                    }
                                    if (errorPolicy === 'ignore' &&
                                        graphQLResultHasError(storeResult)) {
                                        delete storeResult.errors;
                                    }
                                    return self.markMutationResult({
                                        mutationId: mutationId,
                                        result: storeResult,
                                        document: mutation,
                                        variables: variables,
                                        fetchPolicy: fetchPolicy,
                                        errorPolicy: errorPolicy,
                                        context: context,
                                        update: updateWithProxyFn,
                                        updateQueries: updateQueries,
                                        awaitRefetchQueries: awaitRefetchQueries,
                                        refetchQueries: refetchQueries,
                                        removeOptimistic: optimisticResponse ? mutationId : void 0,
                                        onQueryUpdated: onQueryUpdated,
                                        keepRootFields: keepRootFields,
                                    });
                                }).subscribe({
                                    next: function (storeResult) {
                                        self.broadcastQueries();
                                        resolve(storeResult);
                                    },
                                    error: function (err) {
                                        if (mutationStoreValue) {
                                            mutationStoreValue.loading = false;
                                            mutationStoreValue.error = err;
                                        }
                                        if (optimisticResponse) {
                                            self.cache.removeOptimistic(mutationId);
                                        }
                                        self.broadcastQueries();
                                        reject(err instanceof errors_ApolloError ? err : new errors_ApolloError({
                                            networkError: err,
                                        }));
                                    },
                                });
                            })];
                }
            });
        });
    };
    QueryManager.prototype.markMutationResult = function (mutation, cache) {
        var _this = this;
        if (cache === void 0) { cache = this.cache; }
        var result = mutation.result;
        var cacheWrites = [];
        var skipCache = mutation.fetchPolicy === "no-cache";
        if (!skipCache && shouldWriteResult(result, mutation.errorPolicy)) {
            cacheWrites.push({
                result: result.data,
                dataId: 'ROOT_MUTATION',
                query: mutation.document,
                variables: mutation.variables,
            });
            var updateQueries_1 = mutation.updateQueries;
            if (updateQueries_1) {
                this.queries.forEach(function (_a, queryId) {
                    var observableQuery = _a.observableQuery;
                    var queryName = observableQuery && observableQuery.queryName;
                    if (!queryName || !QueryManager_hasOwnProperty.call(updateQueries_1, queryName)) {
                        return;
                    }
                    var updater = updateQueries_1[queryName];
                    var _b = _this.queries.get(queryId), document = _b.document, variables = _b.variables;
                    var _c = cache.diff({
                        query: document,
                        variables: variables,
                        returnPartialData: true,
                        optimistic: false,
                    }), currentQueryResult = _c.result, complete = _c.complete;
                    if (complete && currentQueryResult) {
                        var nextQueryResult = updater(currentQueryResult, {
                            mutationResult: result,
                            queryName: document && getOperationName(document) || void 0,
                            queryVariables: variables,
                        });
                        if (nextQueryResult) {
                            cacheWrites.push({
                                result: nextQueryResult,
                                dataId: 'ROOT_QUERY',
                                query: document,
                                variables: variables,
                            });
                        }
                    }
                });
            }
        }
        if (cacheWrites.length > 0 ||
            mutation.refetchQueries ||
            mutation.update ||
            mutation.onQueryUpdated ||
            mutation.removeOptimistic) {
            var results_1 = [];
            this.refetchQueries({
                updateCache: function (cache) {
                    if (!skipCache) {
                        cacheWrites.forEach(function (write) { return cache.write(write); });
                    }
                    var update = mutation.update;
                    if (update) {
                        if (!skipCache) {
                            var diff = cache.diff({
                                id: "ROOT_MUTATION",
                                query: _this.transform(mutation.document).asQuery,
                                variables: mutation.variables,
                                optimistic: false,
                                returnPartialData: true,
                            });
                            if (diff.complete && !(isExecutionPatchIncrementalResult(result))) {
                                result = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, result), { data: diff.result });
                            }
                        }
                        update(cache, result, {
                            context: mutation.context,
                            variables: mutation.variables,
                        });
                    }
                    if (!skipCache && !mutation.keepRootFields) {
                        cache.modify({
                            id: 'ROOT_MUTATION',
                            fields: function (value, _a) {
                                var fieldName = _a.fieldName, DELETE = _a.DELETE;
                                return fieldName === "__typename" ? value : DELETE;
                            },
                        });
                    }
                },
                include: mutation.refetchQueries,
                optimistic: false,
                removeOptimistic: mutation.removeOptimistic,
                onQueryUpdated: mutation.onQueryUpdated || null,
            }).forEach(function (result) { return results_1.push(result); });
            if (mutation.awaitRefetchQueries || mutation.onQueryUpdated) {
                return Promise.all(results_1).then(function () { return result; });
            }
        }
        return Promise.resolve(result);
    };
    QueryManager.prototype.markMutationOptimistic = function (optimisticResponse, mutation) {
        var _this = this;
        var data = typeof optimisticResponse === "function"
            ? optimisticResponse(mutation.variables)
            : optimisticResponse;
        return this.cache.recordOptimisticTransaction(function (cache) {
            try {
                _this.markMutationResult((0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, mutation), { result: { data: data } }), cache);
            }
            catch (error) {
                __DEV__ && invariant/* invariant.error */.kG.error(error);
            }
        }, mutation.mutationId);
    };
    QueryManager.prototype.fetchQuery = function (queryId, options, networkStatus) {
        return this.fetchQueryObservable(queryId, options, networkStatus).promise;
    };
    QueryManager.prototype.getQueryStore = function () {
        var store = Object.create(null);
        this.queries.forEach(function (info, queryId) {
            store[queryId] = {
                variables: info.variables,
                networkStatus: info.networkStatus,
                networkError: info.networkError,
                graphQLErrors: info.graphQLErrors,
            };
        });
        return store;
    };
    QueryManager.prototype.resetErrors = function (queryId) {
        var queryInfo = this.queries.get(queryId);
        if (queryInfo) {
            queryInfo.networkError = undefined;
            queryInfo.graphQLErrors = [];
        }
    };
    QueryManager.prototype.transform = function (document) {
        var transformCache = this.transformCache;
        if (!transformCache.has(document)) {
            var transformed = this.cache.transformDocument(document);
            var noConnection = removeConnectionDirectiveFromDocument(transformed);
            var clientQuery = this.localState.clientQuery(transformed);
            var serverQuery = noConnection && this.localState.serverQuery(noConnection);
            var cacheEntry_1 = {
                document: transformed,
                hasClientExports: hasClientExports(transformed),
                hasForcedResolvers: this.localState.shouldForceResolvers(transformed),
                clientQuery: clientQuery,
                serverQuery: serverQuery,
                defaultVars: getDefaultValues(getOperationDefinition(transformed)),
                asQuery: (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, transformed), { definitions: transformed.definitions.map(function (def) {
                        if (def.kind === "OperationDefinition" &&
                            def.operation !== "query") {
                            return (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, def), { operation: "query" });
                        }
                        return def;
                    }) })
            };
            var add = function (doc) {
                if (doc && !transformCache.has(doc)) {
                    transformCache.set(doc, cacheEntry_1);
                }
            };
            add(document);
            add(transformed);
            add(clientQuery);
            add(serverQuery);
        }
        return transformCache.get(document);
    };
    QueryManager.prototype.getVariables = function (document, variables) {
        return (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, this.transform(document).defaultVars), variables);
    };
    QueryManager.prototype.watchQuery = function (options) {
        options = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, options), { variables: this.getVariables(options.query, options.variables) });
        if (typeof options.notifyOnNetworkStatusChange === 'undefined') {
            options.notifyOnNetworkStatusChange = false;
        }
        var queryInfo = new QueryInfo(this);
        var observable = new ObservableQuery({
            queryManager: this,
            queryInfo: queryInfo,
            options: options,
        });
        this.queries.set(observable.queryId, queryInfo);
        queryInfo.init({
            document: observable.query,
            observableQuery: observable,
            variables: observable.variables,
        });
        return observable;
    };
    QueryManager.prototype.query = function (options, queryId) {
        var _this = this;
        if (queryId === void 0) { queryId = this.generateQueryId(); }
        __DEV__ ? (0,invariant/* invariant */.kG)(options.query, 'query option is required. You must specify your GraphQL document ' +
            'in the query option.') : (0,invariant/* invariant */.kG)(options.query, 16);
        __DEV__ ? (0,invariant/* invariant */.kG)(options.query.kind === 'Document', 'You must wrap the query string in a "gql" tag.') : (0,invariant/* invariant */.kG)(options.query.kind === 'Document', 17);
        __DEV__ ? (0,invariant/* invariant */.kG)(!options.returnPartialData, 'returnPartialData option only supported on watchQuery.') : (0,invariant/* invariant */.kG)(!options.returnPartialData, 18);
        __DEV__ ? (0,invariant/* invariant */.kG)(!options.pollInterval, 'pollInterval option only supported on watchQuery.') : (0,invariant/* invariant */.kG)(!options.pollInterval, 19);
        return this.fetchQuery(queryId, options).finally(function () { return _this.stopQuery(queryId); });
    };
    QueryManager.prototype.generateQueryId = function () {
        return String(this.queryIdCounter++);
    };
    QueryManager.prototype.generateRequestId = function () {
        return this.requestIdCounter++;
    };
    QueryManager.prototype.generateMutationId = function () {
        return String(this.mutationIdCounter++);
    };
    QueryManager.prototype.stopQueryInStore = function (queryId) {
        this.stopQueryInStoreNoBroadcast(queryId);
        this.broadcastQueries();
    };
    QueryManager.prototype.stopQueryInStoreNoBroadcast = function (queryId) {
        var queryInfo = this.queries.get(queryId);
        if (queryInfo)
            queryInfo.stop();
    };
    QueryManager.prototype.clearStore = function (options) {
        if (options === void 0) { options = {
            discardWatches: true,
        }; }
        this.cancelPendingFetches(__DEV__ ? new invariant/* InvariantError */.ej('Store reset while query was in flight (not completed in link chain)') : new invariant/* InvariantError */.ej(20));
        this.queries.forEach(function (queryInfo) {
            if (queryInfo.observableQuery) {
                queryInfo.networkStatus = NetworkStatus.loading;
            }
            else {
                queryInfo.stop();
            }
        });
        if (this.mutationStore) {
            this.mutationStore = Object.create(null);
        }
        return this.cache.reset(options);
    };
    QueryManager.prototype.getObservableQueries = function (include) {
        var _this = this;
        if (include === void 0) { include = "active"; }
        var queries = new Map();
        var queryNamesAndDocs = new Map();
        var legacyQueryOptions = new Set();
        if (Array.isArray(include)) {
            include.forEach(function (desc) {
                if (typeof desc === "string") {
                    queryNamesAndDocs.set(desc, false);
                }
                else if (isDocumentNode(desc)) {
                    queryNamesAndDocs.set(_this.transform(desc).document, false);
                }
                else if (isNonNullObject(desc) && desc.query) {
                    legacyQueryOptions.add(desc);
                }
            });
        }
        this.queries.forEach(function (_a, queryId) {
            var oq = _a.observableQuery, document = _a.document;
            if (oq) {
                if (include === "all") {
                    queries.set(queryId, oq);
                    return;
                }
                var queryName = oq.queryName, fetchPolicy = oq.options.fetchPolicy;
                if (fetchPolicy === "standby" ||
                    (include === "active" && !oq.hasObservers())) {
                    return;
                }
                if (include === "active" ||
                    (queryName && queryNamesAndDocs.has(queryName)) ||
                    (document && queryNamesAndDocs.has(document))) {
                    queries.set(queryId, oq);
                    if (queryName)
                        queryNamesAndDocs.set(queryName, true);
                    if (document)
                        queryNamesAndDocs.set(document, true);
                }
            }
        });
        if (legacyQueryOptions.size) {
            legacyQueryOptions.forEach(function (options) {
                var queryId = makeUniqueId("legacyOneTimeQuery");
                var queryInfo = _this.getQuery(queryId).init({
                    document: options.query,
                    variables: options.variables,
                });
                var oq = new ObservableQuery({
                    queryManager: _this,
                    queryInfo: queryInfo,
                    options: (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, options), { fetchPolicy: "network-only" }),
                });
                (0,invariant/* invariant */.kG)(oq.queryId === queryId);
                queryInfo.setObservableQuery(oq);
                queries.set(queryId, oq);
            });
        }
        if (__DEV__ && queryNamesAndDocs.size) {
            queryNamesAndDocs.forEach(function (included, nameOrDoc) {
                if (!included) {
                    __DEV__ && invariant/* invariant.warn */.kG.warn("Unknown query ".concat(typeof nameOrDoc === "string" ? "named " : "").concat(JSON.stringify(nameOrDoc, null, 2), " requested in refetchQueries options.include array"));
                }
            });
        }
        return queries;
    };
    QueryManager.prototype.reFetchObservableQueries = function (includeStandby) {
        var _this = this;
        if (includeStandby === void 0) { includeStandby = false; }
        var observableQueryPromises = [];
        this.getObservableQueries(includeStandby ? "all" : "active").forEach(function (observableQuery, queryId) {
            var fetchPolicy = observableQuery.options.fetchPolicy;
            observableQuery.resetLastResults();
            if (includeStandby ||
                (fetchPolicy !== "standby" &&
                    fetchPolicy !== "cache-only")) {
                observableQueryPromises.push(observableQuery.refetch());
            }
            _this.getQuery(queryId).setDiff(null);
        });
        this.broadcastQueries();
        return Promise.all(observableQueryPromises);
    };
    QueryManager.prototype.setObservableQuery = function (observableQuery) {
        this.getQuery(observableQuery.queryId).setObservableQuery(observableQuery);
    };
    QueryManager.prototype.startGraphQLSubscription = function (_a) {
        var _this = this;
        var query = _a.query, fetchPolicy = _a.fetchPolicy, errorPolicy = _a.errorPolicy, variables = _a.variables, _b = _a.context, context = _b === void 0 ? {} : _b;
        query = this.transform(query).document;
        variables = this.getVariables(query, variables);
        var makeObservable = function (variables) {
            return _this.getObservableFromLink(query, context, variables).map(function (result) {
                if (fetchPolicy !== 'no-cache') {
                    if (shouldWriteResult(result, errorPolicy)) {
                        _this.cache.write({
                            query: query,
                            result: result.data,
                            dataId: 'ROOT_SUBSCRIPTION',
                            variables: variables,
                        });
                    }
                    _this.broadcastQueries();
                }
                if (graphQLResultHasError(result)) {
                    throw new errors_ApolloError({
                        graphQLErrors: result.errors,
                    });
                }
                return result;
            });
        };
        if (this.transform(query).hasClientExports) {
            var observablePromise_1 = this.localState.addExportedVariables(query, variables, context).then(makeObservable);
            return new Observable(function (observer) {
                var sub = null;
                observablePromise_1.then(function (observable) { return sub = observable.subscribe(observer); }, observer.error);
                return function () { return sub && sub.unsubscribe(); };
            });
        }
        return makeObservable(variables);
    };
    QueryManager.prototype.stopQuery = function (queryId) {
        this.stopQueryNoBroadcast(queryId);
        this.broadcastQueries();
    };
    QueryManager.prototype.stopQueryNoBroadcast = function (queryId) {
        this.stopQueryInStoreNoBroadcast(queryId);
        this.removeQuery(queryId);
    };
    QueryManager.prototype.removeQuery = function (queryId) {
        this.fetchCancelFns.delete(queryId);
        if (this.queries.has(queryId)) {
            this.getQuery(queryId).stop();
            this.queries.delete(queryId);
        }
    };
    QueryManager.prototype.broadcastQueries = function () {
        if (this.onBroadcast)
            this.onBroadcast();
        this.queries.forEach(function (info) { return info.notify(); });
    };
    QueryManager.prototype.getLocalState = function () {
        return this.localState;
    };
    QueryManager.prototype.getObservableFromLink = function (query, context, variables, deduplication) {
        var _this = this;
        var _a;
        if (deduplication === void 0) { deduplication = (_a = context === null || context === void 0 ? void 0 : context.queryDeduplication) !== null && _a !== void 0 ? _a : this.queryDeduplication; }
        var observable;
        var serverQuery = this.transform(query).serverQuery;
        if (serverQuery) {
            var _b = this, inFlightLinkObservables_1 = _b.inFlightLinkObservables, link = _b.link;
            var operation = {
                query: serverQuery,
                variables: variables,
                operationName: getOperationName(serverQuery) || void 0,
                context: this.prepareContext((0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, context), { forceFetch: !deduplication })),
            };
            context = operation.context;
            if (deduplication) {
                var byVariables_1 = inFlightLinkObservables_1.get(serverQuery) || new Map();
                inFlightLinkObservables_1.set(serverQuery, byVariables_1);
                var varJson_1 = canonicalStringify(variables);
                observable = byVariables_1.get(varJson_1);
                if (!observable) {
                    var concast = new Concast([
                        execute(link, operation)
                    ]);
                    byVariables_1.set(varJson_1, observable = concast);
                    concast.beforeNext(function () {
                        if (byVariables_1.delete(varJson_1) &&
                            byVariables_1.size < 1) {
                            inFlightLinkObservables_1.delete(serverQuery);
                        }
                    });
                }
            }
            else {
                observable = new Concast([
                    execute(link, operation)
                ]);
            }
        }
        else {
            observable = new Concast([
                Observable.of({ data: {} })
            ]);
            context = this.prepareContext(context);
        }
        var clientQuery = this.transform(query).clientQuery;
        if (clientQuery) {
            observable = asyncMap(observable, function (result) {
                return _this.localState.runResolvers({
                    document: clientQuery,
                    remoteResult: result,
                    context: context,
                    variables: variables,
                });
            });
        }
        return observable;
    };
    QueryManager.prototype.getResultsFromLink = function (queryInfo, cacheWriteBehavior, options) {
        var requestId = queryInfo.lastRequestId = this.generateRequestId();
        options = cloneDeep(options);
        var linkDocument = this.cache.transformForLink(this.transform(queryInfo.document).document);
        return asyncMap(this.getObservableFromLink(linkDocument, options.context, options.variables), function (result) {
            var graphQLErrors = isNonEmptyArray(result.errors)
                ? result.errors.slice(0)
                : [];
            if ('incremental' in result && isNonEmptyArray(result.incremental)) {
                result.incremental.forEach(function (incrementalResult) {
                    if (incrementalResult.errors) {
                        graphQLErrors.push.apply(graphQLErrors, incrementalResult.errors);
                    }
                });
            }
            var hasErrors = isNonEmptyArray(graphQLErrors);
            if (requestId >= queryInfo.lastRequestId) {
                if (hasErrors && options.errorPolicy === "none") {
                    throw queryInfo.markError(new errors_ApolloError({
                        graphQLErrors: graphQLErrors,
                    }));
                }
                queryInfo.markResult(result, linkDocument, options, cacheWriteBehavior);
                queryInfo.markReady();
            }
            var aqr = {
                data: result.data,
                loading: false,
                networkStatus: NetworkStatus.ready,
            };
            if (hasErrors && options.errorPolicy !== "ignore") {
                aqr.errors = graphQLErrors;
                aqr.networkStatus = NetworkStatus.error;
            }
            return aqr;
        }, function (networkError) {
            var error = isApolloError(networkError)
                ? networkError
                : new errors_ApolloError({ networkError: networkError });
            if (requestId >= queryInfo.lastRequestId) {
                queryInfo.markError(error);
            }
            throw error;
        });
    };
    QueryManager.prototype.fetchQueryObservable = function (queryId, options, networkStatus) {
        var _this = this;
        if (networkStatus === void 0) { networkStatus = NetworkStatus.loading; }
        var query = this.transform(options.query).document;
        var variables = this.getVariables(query, options.variables);
        var queryInfo = this.getQuery(queryId);
        var defaults = this.defaultOptions.watchQuery;
        var _a = options.fetchPolicy, fetchPolicy = _a === void 0 ? defaults && defaults.fetchPolicy || "cache-first" : _a, _b = options.errorPolicy, errorPolicy = _b === void 0 ? defaults && defaults.errorPolicy || "none" : _b, _c = options.returnPartialData, returnPartialData = _c === void 0 ? false : _c, _d = options.notifyOnNetworkStatusChange, notifyOnNetworkStatusChange = _d === void 0 ? false : _d, _e = options.context, context = _e === void 0 ? {} : _e;
        var normalized = Object.assign({}, options, {
            query: query,
            variables: variables,
            fetchPolicy: fetchPolicy,
            errorPolicy: errorPolicy,
            returnPartialData: returnPartialData,
            notifyOnNetworkStatusChange: notifyOnNetworkStatusChange,
            context: context,
        });
        var fromVariables = function (variables) {
            normalized.variables = variables;
            var concastSources = _this.fetchQueryByPolicy(queryInfo, normalized, networkStatus);
            if (normalized.fetchPolicy !== "standby" &&
                concastSources.length > 0 &&
                queryInfo.observableQuery) {
                queryInfo.observableQuery["applyNextFetchPolicy"]("after-fetch", options);
            }
            return concastSources;
        };
        var cleanupCancelFn = function () { return _this.fetchCancelFns.delete(queryId); };
        this.fetchCancelFns.set(queryId, function (reason) {
            cleanupCancelFn();
            setTimeout(function () { return concast.cancel(reason); });
        });
        var concast = new Concast(this.transform(normalized.query).hasClientExports
            ? this.localState.addExportedVariables(normalized.query, normalized.variables, normalized.context).then(fromVariables)
            : fromVariables(normalized.variables));
        concast.promise.then(cleanupCancelFn, cleanupCancelFn);
        return concast;
    };
    QueryManager.prototype.refetchQueries = function (_a) {
        var _this = this;
        var updateCache = _a.updateCache, include = _a.include, _b = _a.optimistic, optimistic = _b === void 0 ? false : _b, _c = _a.removeOptimistic, removeOptimistic = _c === void 0 ? optimistic ? makeUniqueId("refetchQueries") : void 0 : _c, onQueryUpdated = _a.onQueryUpdated;
        var includedQueriesById = new Map();
        if (include) {
            this.getObservableQueries(include).forEach(function (oq, queryId) {
                includedQueriesById.set(queryId, {
                    oq: oq,
                    lastDiff: _this.getQuery(queryId).getDiff(),
                });
            });
        }
        var results = new Map;
        if (updateCache) {
            this.cache.batch({
                update: updateCache,
                optimistic: optimistic && removeOptimistic || false,
                removeOptimistic: removeOptimistic,
                onWatchUpdated: function (watch, diff, lastDiff) {
                    var oq = watch.watcher instanceof QueryInfo &&
                        watch.watcher.observableQuery;
                    if (oq) {
                        if (onQueryUpdated) {
                            includedQueriesById.delete(oq.queryId);
                            var result = onQueryUpdated(oq, diff, lastDiff);
                            if (result === true) {
                                result = oq.refetch();
                            }
                            if (result !== false) {
                                results.set(oq, result);
                            }
                            return result;
                        }
                        if (onQueryUpdated !== null) {
                            includedQueriesById.set(oq.queryId, { oq: oq, lastDiff: lastDiff, diff: diff });
                        }
                    }
                },
            });
        }
        if (includedQueriesById.size) {
            includedQueriesById.forEach(function (_a, queryId) {
                var oq = _a.oq, lastDiff = _a.lastDiff, diff = _a.diff;
                var result;
                if (onQueryUpdated) {
                    if (!diff) {
                        var info = oq["queryInfo"];
                        info.reset();
                        diff = info.getDiff();
                    }
                    result = onQueryUpdated(oq, diff, lastDiff);
                }
                if (!onQueryUpdated || result === true) {
                    result = oq.refetch();
                }
                if (result !== false) {
                    results.set(oq, result);
                }
                if (queryId.indexOf("legacyOneTimeQuery") >= 0) {
                    _this.stopQueryNoBroadcast(queryId);
                }
            });
        }
        if (removeOptimistic) {
            this.cache.removeOptimistic(removeOptimistic);
        }
        return results;
    };
    QueryManager.prototype.fetchQueryByPolicy = function (queryInfo, _a, networkStatus) {
        var _this = this;
        var query = _a.query, variables = _a.variables, fetchPolicy = _a.fetchPolicy, refetchWritePolicy = _a.refetchWritePolicy, errorPolicy = _a.errorPolicy, returnPartialData = _a.returnPartialData, context = _a.context, notifyOnNetworkStatusChange = _a.notifyOnNetworkStatusChange;
        var oldNetworkStatus = queryInfo.networkStatus;
        queryInfo.init({
            document: this.transform(query).document,
            variables: variables,
            networkStatus: networkStatus,
        });
        var readCache = function () { return queryInfo.getDiff(variables); };
        var resultsFromCache = function (diff, networkStatus) {
            if (networkStatus === void 0) { networkStatus = queryInfo.networkStatus || NetworkStatus.loading; }
            var data = diff.result;
            if (__DEV__ &&
                !returnPartialData &&
                !equal(data, {})) {
                logMissingFieldErrors(diff.missing);
            }
            var fromData = function (data) { return Observable.of((0,tslib_es6/* __assign */.pi)({ data: data, loading: isNetworkRequestInFlight(networkStatus), networkStatus: networkStatus }, (diff.complete ? null : { partial: true }))); };
            if (data && _this.transform(query).hasForcedResolvers) {
                return _this.localState.runResolvers({
                    document: query,
                    remoteResult: { data: data },
                    context: context,
                    variables: variables,
                    onlyRunForcedResolvers: true,
                }).then(function (resolved) { return fromData(resolved.data || void 0); });
            }
            return fromData(data);
        };
        var cacheWriteBehavior = fetchPolicy === "no-cache" ? 0 :
            (networkStatus === NetworkStatus.refetch &&
                refetchWritePolicy !== "merge") ? 1
                : 2;
        var resultsFromLink = function () { return _this.getResultsFromLink(queryInfo, cacheWriteBehavior, {
            variables: variables,
            context: context,
            fetchPolicy: fetchPolicy,
            errorPolicy: errorPolicy,
        }); };
        var shouldNotify = notifyOnNetworkStatusChange &&
            typeof oldNetworkStatus === "number" &&
            oldNetworkStatus !== networkStatus &&
            isNetworkRequestInFlight(networkStatus);
        switch (fetchPolicy) {
            default:
            case "cache-first": {
                var diff = readCache();
                if (diff.complete) {
                    return [
                        resultsFromCache(diff, queryInfo.markReady()),
                    ];
                }
                if (returnPartialData || shouldNotify) {
                    return [
                        resultsFromCache(diff),
                        resultsFromLink(),
                    ];
                }
                return [
                    resultsFromLink(),
                ];
            }
            case "cache-and-network": {
                var diff = readCache();
                if (diff.complete || returnPartialData || shouldNotify) {
                    return [
                        resultsFromCache(diff),
                        resultsFromLink(),
                    ];
                }
                return [
                    resultsFromLink(),
                ];
            }
            case "cache-only":
                return [
                    resultsFromCache(readCache(), queryInfo.markReady()),
                ];
            case "network-only":
                if (shouldNotify) {
                    return [
                        resultsFromCache(readCache()),
                        resultsFromLink(),
                    ];
                }
                return [resultsFromLink()];
            case "no-cache":
                if (shouldNotify) {
                    return [
                        resultsFromCache(queryInfo.getDiff()),
                        resultsFromLink(),
                    ];
                }
                return [resultsFromLink()];
            case "standby":
                return [];
        }
    };
    QueryManager.prototype.getQuery = function (queryId) {
        if (queryId && !this.queries.has(queryId)) {
            this.queries.set(queryId, new QueryInfo(this, queryId));
        }
        return this.queries.get(queryId);
    };
    QueryManager.prototype.prepareContext = function (context) {
        if (context === void 0) { context = {}; }
        var newContext = this.localState.prepareContext(context);
        return (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, newContext), { clientAwareness: this.clientAwareness });
    };
    return QueryManager;
}());

//# sourceMappingURL=QueryManager.js.map
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@apollo-client-virtual-cd9e78d17f/0/cache/@apollo-client-npm-3.7.1-a80032e019-95bb1f226f.zip/node_modules/@apollo/client/utilities/common/mergeOptions.js


function mergeOptions(defaults, options) {
    return compact(defaults, options, options.variables && {
        variables: (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, (defaults && defaults.variables)), options.variables),
    });
}
//# sourceMappingURL=mergeOptions.js.map
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@apollo-client-virtual-cd9e78d17f/0/cache/@apollo-client-npm-3.7.1-a80032e019-95bb1f226f.zip/node_modules/@apollo/client/core/ApolloClient.js







var hasSuggestedDevtools = false;


var ApolloClient = (function () {
    function ApolloClient(options) {
        var _this = this;
        this.resetStoreCallbacks = [];
        this.clearStoreCallbacks = [];
        var uri = options.uri, credentials = options.credentials, headers = options.headers, cache = options.cache, _a = options.ssrMode, ssrMode = _a === void 0 ? false : _a, _b = options.ssrForceFetchDelay, ssrForceFetchDelay = _b === void 0 ? 0 : _b, _c = options.connectToDevTools, connectToDevTools = _c === void 0 ? typeof window === 'object' &&
            !window.__APOLLO_CLIENT__ &&
            __DEV__ : _c, _d = options.queryDeduplication, queryDeduplication = _d === void 0 ? true : _d, defaultOptions = options.defaultOptions, _e = options.assumeImmutableResults, assumeImmutableResults = _e === void 0 ? false : _e, resolvers = options.resolvers, typeDefs = options.typeDefs, fragmentMatcher = options.fragmentMatcher, clientAwarenessName = options.name, clientAwarenessVersion = options.version;
        var link = options.link;
        if (!link) {
            link = uri
                ? new HttpLink({ uri: uri, credentials: credentials, headers: headers })
                : ApolloLink.empty();
        }
        if (!cache) {
            throw __DEV__ ? new invariant/* InvariantError */.ej("To initialize Apollo Client, you must specify a 'cache' property " +
                "in the options object. \n" +
                "For more information, please visit: https://go.apollo.dev/c/docs") : new invariant/* InvariantError */.ej(9);
        }
        this.link = link;
        this.cache = cache;
        this.disableNetworkFetches = ssrMode || ssrForceFetchDelay > 0;
        this.queryDeduplication = queryDeduplication;
        this.defaultOptions = defaultOptions || Object.create(null);
        this.typeDefs = typeDefs;
        if (ssrForceFetchDelay) {
            setTimeout(function () { return (_this.disableNetworkFetches = false); }, ssrForceFetchDelay);
        }
        this.watchQuery = this.watchQuery.bind(this);
        this.query = this.query.bind(this);
        this.mutate = this.mutate.bind(this);
        this.resetStore = this.resetStore.bind(this);
        this.reFetchObservableQueries = this.reFetchObservableQueries.bind(this);
        if (connectToDevTools && typeof window === 'object') {
            window.__APOLLO_CLIENT__ = this;
        }
        if (!hasSuggestedDevtools && __DEV__) {
            hasSuggestedDevtools = true;
            if (typeof window !== 'undefined' &&
                window.document &&
                window.top === window.self &&
                !window.__APOLLO_DEVTOOLS_GLOBAL_HOOK__) {
                var nav = window.navigator;
                var ua = nav && nav.userAgent;
                var url = void 0;
                if (typeof ua === "string") {
                    if (ua.indexOf("Chrome/") > -1) {
                        url = "https://chrome.google.com/webstore/detail/" +
                            "apollo-client-developer-t/jdkknkkbebbapilgoeccciglkfbmbnfm";
                    }
                    else if (ua.indexOf("Firefox/") > -1) {
                        url = "https://addons.mozilla.org/en-US/firefox/addon/apollo-developer-tools/";
                    }
                }
                if (url) {
                    __DEV__ && invariant/* invariant.log */.kG.log("Download the Apollo DevTools for a better development " +
                        "experience: " + url);
                }
            }
        }
        this.version = version;
        this.localState = new LocalState({
            cache: cache,
            client: this,
            resolvers: resolvers,
            fragmentMatcher: fragmentMatcher,
        });
        this.queryManager = new QueryManager({
            cache: this.cache,
            link: this.link,
            defaultOptions: this.defaultOptions,
            queryDeduplication: queryDeduplication,
            ssrMode: ssrMode,
            clientAwareness: {
                name: clientAwarenessName,
                version: clientAwarenessVersion,
            },
            localState: this.localState,
            assumeImmutableResults: assumeImmutableResults,
            onBroadcast: connectToDevTools ? function () {
                if (_this.devToolsHookCb) {
                    _this.devToolsHookCb({
                        action: {},
                        state: {
                            queries: _this.queryManager.getQueryStore(),
                            mutations: _this.queryManager.mutationStore || {},
                        },
                        dataWithOptimisticResults: _this.cache.extract(true),
                    });
                }
            } : void 0,
        });
    }
    ApolloClient.prototype.stop = function () {
        this.queryManager.stop();
    };
    ApolloClient.prototype.watchQuery = function (options) {
        if (this.defaultOptions.watchQuery) {
            options = mergeOptions(this.defaultOptions.watchQuery, options);
        }
        if (this.disableNetworkFetches &&
            (options.fetchPolicy === 'network-only' ||
                options.fetchPolicy === 'cache-and-network')) {
            options = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, options), { fetchPolicy: 'cache-first' });
        }
        return this.queryManager.watchQuery(options);
    };
    ApolloClient.prototype.query = function (options) {
        if (this.defaultOptions.query) {
            options = mergeOptions(this.defaultOptions.query, options);
        }
        __DEV__ ? (0,invariant/* invariant */.kG)(options.fetchPolicy !== 'cache-and-network', 'The cache-and-network fetchPolicy does not work with client.query, because ' +
            'client.query can only return a single result. Please use client.watchQuery ' +
            'to receive multiple results from the cache and the network, or consider ' +
            'using a different fetchPolicy, such as cache-first or network-only.') : (0,invariant/* invariant */.kG)(options.fetchPolicy !== 'cache-and-network', 10);
        if (this.disableNetworkFetches && options.fetchPolicy === 'network-only') {
            options = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, options), { fetchPolicy: 'cache-first' });
        }
        return this.queryManager.query(options);
    };
    ApolloClient.prototype.mutate = function (options) {
        if (this.defaultOptions.mutate) {
            options = mergeOptions(this.defaultOptions.mutate, options);
        }
        return this.queryManager.mutate(options);
    };
    ApolloClient.prototype.subscribe = function (options) {
        return this.queryManager.startGraphQLSubscription(options);
    };
    ApolloClient.prototype.readQuery = function (options, optimistic) {
        if (optimistic === void 0) { optimistic = false; }
        return this.cache.readQuery(options, optimistic);
    };
    ApolloClient.prototype.readFragment = function (options, optimistic) {
        if (optimistic === void 0) { optimistic = false; }
        return this.cache.readFragment(options, optimistic);
    };
    ApolloClient.prototype.writeQuery = function (options) {
        this.cache.writeQuery(options);
        this.queryManager.broadcastQueries();
    };
    ApolloClient.prototype.writeFragment = function (options) {
        this.cache.writeFragment(options);
        this.queryManager.broadcastQueries();
    };
    ApolloClient.prototype.__actionHookForDevTools = function (cb) {
        this.devToolsHookCb = cb;
    };
    ApolloClient.prototype.__requestRaw = function (payload) {
        return execute(this.link, payload);
    };
    ApolloClient.prototype.resetStore = function () {
        var _this = this;
        return Promise.resolve()
            .then(function () { return _this.queryManager.clearStore({
            discardWatches: false,
        }); })
            .then(function () { return Promise.all(_this.resetStoreCallbacks.map(function (fn) { return fn(); })); })
            .then(function () { return _this.reFetchObservableQueries(); });
    };
    ApolloClient.prototype.clearStore = function () {
        var _this = this;
        return Promise.resolve()
            .then(function () { return _this.queryManager.clearStore({
            discardWatches: true,
        }); })
            .then(function () { return Promise.all(_this.clearStoreCallbacks.map(function (fn) { return fn(); })); });
    };
    ApolloClient.prototype.onResetStore = function (cb) {
        var _this = this;
        this.resetStoreCallbacks.push(cb);
        return function () {
            _this.resetStoreCallbacks = _this.resetStoreCallbacks.filter(function (c) { return c !== cb; });
        };
    };
    ApolloClient.prototype.onClearStore = function (cb) {
        var _this = this;
        this.clearStoreCallbacks.push(cb);
        return function () {
            _this.clearStoreCallbacks = _this.clearStoreCallbacks.filter(function (c) { return c !== cb; });
        };
    };
    ApolloClient.prototype.reFetchObservableQueries = function (includeStandby) {
        return this.queryManager.reFetchObservableQueries(includeStandby);
    };
    ApolloClient.prototype.refetchQueries = function (options) {
        var map = this.queryManager.refetchQueries(options);
        var queries = [];
        var results = [];
        map.forEach(function (result, obsQuery) {
            queries.push(obsQuery);
            results.push(result);
        });
        var result = Promise.all(results);
        result.queries = queries;
        result.results = results;
        result.catch(function (error) {
            __DEV__ && invariant/* invariant.debug */.kG.debug("In client.refetchQueries, Promise.all promise rejected with error ".concat(error));
        });
        return result;
    };
    ApolloClient.prototype.getObservableQueries = function (include) {
        if (include === void 0) { include = "active"; }
        return this.queryManager.getObservableQueries(include);
    };
    ApolloClient.prototype.extract = function (optimistic) {
        return this.cache.extract(optimistic);
    };
    ApolloClient.prototype.restore = function (serializedState) {
        return this.cache.restore(serializedState);
    };
    ApolloClient.prototype.addResolvers = function (resolvers) {
        this.localState.addResolvers(resolvers);
    };
    ApolloClient.prototype.setResolvers = function (resolvers) {
        this.localState.setResolvers(resolvers);
    };
    ApolloClient.prototype.getResolvers = function () {
        return this.localState.getResolvers();
    };
    ApolloClient.prototype.setLocalStateFragmentMatcher = function (fragmentMatcher) {
        this.localState.setFragmentMatcher(fragmentMatcher);
    };
    ApolloClient.prototype.setLink = function (newLink) {
        this.link = this.queryManager.link = newLink;
    };
    return ApolloClient;
}());

//# sourceMappingURL=ApolloClient.js.map
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@apollo-client-virtual-cd9e78d17f/0/cache/@apollo-client-npm-3.7.1-a80032e019-95bb1f226f.zip/node_modules/@apollo/client/link/batch/batching.js


var OperationBatcher = (function () {
    function OperationBatcher(_a) {
        var batchDebounce = _a.batchDebounce, batchInterval = _a.batchInterval, batchMax = _a.batchMax, batchHandler = _a.batchHandler, batchKey = _a.batchKey;
        this.batchesByKey = new Map();
        this.batchDebounce = batchDebounce;
        this.batchInterval = batchInterval;
        this.batchMax = batchMax || 0;
        this.batchHandler = batchHandler;
        this.batchKey = batchKey || (function () { return ''; });
    }
    OperationBatcher.prototype.enqueueRequest = function (request) {
        var _this = this;
        var requestCopy = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, request), { next: [], error: [], complete: [], subscribers: new Set() });
        var key = this.batchKey(request.operation);
        if (!requestCopy.observable) {
            requestCopy.observable = new Observable(function (observer) {
                var batch = _this.batchesByKey.get(key);
                if (!batch)
                    _this.batchesByKey.set(key, batch = new Set());
                var isFirstEnqueuedRequest = batch.size === 0;
                var isFirstSubscriber = requestCopy.subscribers.size === 0;
                requestCopy.subscribers.add(observer);
                if (isFirstSubscriber) {
                    batch.add(requestCopy);
                }
                if (observer.next) {
                    requestCopy.next.push(observer.next.bind(observer));
                }
                if (observer.error) {
                    requestCopy.error.push(observer.error.bind(observer));
                }
                if (observer.complete) {
                    requestCopy.complete.push(observer.complete.bind(observer));
                }
                if (isFirstEnqueuedRequest || _this.batchDebounce) {
                    _this.scheduleQueueConsumption(key);
                }
                if (batch.size === _this.batchMax) {
                    _this.consumeQueue(key);
                }
                return function () {
                    var _a;
                    if (requestCopy.subscribers.delete(observer) &&
                        requestCopy.subscribers.size < 1) {
                        if (batch.delete(requestCopy) && batch.size < 1) {
                            _this.consumeQueue(key);
                            (_a = batch.subscription) === null || _a === void 0 ? void 0 : _a.unsubscribe();
                        }
                    }
                };
            });
        }
        return requestCopy.observable;
    };
    OperationBatcher.prototype.consumeQueue = function (key) {
        if (key === void 0) { key = ''; }
        var batch = this.batchesByKey.get(key);
        this.batchesByKey.delete(key);
        if (!batch || !batch.size) {
            return;
        }
        var operations = [];
        var forwards = [];
        var observables = [];
        var nexts = [];
        var errors = [];
        var completes = [];
        batch.forEach(function (request) {
            operations.push(request.operation);
            forwards.push(request.forward);
            observables.push(request.observable);
            nexts.push(request.next);
            errors.push(request.error);
            completes.push(request.complete);
        });
        var batchedObservable = this.batchHandler(operations, forwards) || Observable.of();
        var onError = function (error) {
            errors.forEach(function (rejecters) {
                if (rejecters) {
                    rejecters.forEach(function (e) { return e(error); });
                }
            });
        };
        batch.subscription = batchedObservable.subscribe({
            next: function (results) {
                if (!Array.isArray(results)) {
                    results = [results];
                }
                if (nexts.length !== results.length) {
                    var error = new Error("server returned results with length ".concat(results.length, ", expected length of ").concat(nexts.length));
                    error.result = results;
                    return onError(error);
                }
                results.forEach(function (result, index) {
                    if (nexts[index]) {
                        nexts[index].forEach(function (next) { return next(result); });
                    }
                });
            },
            error: onError,
            complete: function () {
                completes.forEach(function (complete) {
                    if (complete) {
                        complete.forEach(function (c) { return c(); });
                    }
                });
            },
        });
        return observables;
    };
    OperationBatcher.prototype.scheduleQueueConsumption = function (key) {
        var _this = this;
        clearTimeout(this.scheduledBatchTimer);
        this.scheduledBatchTimer = setTimeout(function () {
            _this.consumeQueue(key);
        }, this.batchInterval);
    };
    return OperationBatcher;
}());

//# sourceMappingURL=batching.js.map
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@apollo-client-virtual-cd9e78d17f/0/cache/@apollo-client-npm-3.7.1-a80032e019-95bb1f226f.zip/node_modules/@apollo/client/link/batch/batchLink.js




var BatchLink = (function (_super) {
    (0,tslib_es6/* __extends */.ZT)(BatchLink, _super);
    function BatchLink(fetchParams) {
        var _this = _super.call(this) || this;
        var _a = fetchParams || {}, batchDebounce = _a.batchDebounce, _b = _a.batchInterval, batchInterval = _b === void 0 ? 10 : _b, _c = _a.batchMax, batchMax = _c === void 0 ? 0 : _c, _d = _a.batchHandler, batchHandler = _d === void 0 ? function () { return null; } : _d, _e = _a.batchKey, batchKey = _e === void 0 ? function () { return ''; } : _e;
        _this.batcher = new OperationBatcher({
            batchDebounce: batchDebounce,
            batchInterval: batchInterval,
            batchMax: batchMax,
            batchHandler: batchHandler,
            batchKey: batchKey,
        });
        if (fetchParams.batchHandler.length <= 1) {
            _this.request = function (operation) { return _this.batcher.enqueueRequest({ operation: operation }); };
        }
        return _this;
    }
    BatchLink.prototype.request = function (operation, forward) {
        return this.batcher.enqueueRequest({
            operation: operation,
            forward: forward,
        });
    };
    return BatchLink;
}(ApolloLink));

//# sourceMappingURL=batchLink.js.map
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@apollo-client-virtual-cd9e78d17f/0/cache/@apollo-client-npm-3.7.1-a80032e019-95bb1f226f.zip/node_modules/@apollo/client/link/batch-http/batchHttpLink.js






var BatchHttpLink = (function (_super) {
    (0,tslib_es6/* __extends */.ZT)(BatchHttpLink, _super);
    function BatchHttpLink(fetchParams) {
        var _this = _super.call(this) || this;
        var _a = fetchParams || {}, _b = _a.uri, uri = _b === void 0 ? '/graphql' : _b, fetcher = _a.fetch, _c = _a.print, print = _c === void 0 ? defaultPrinter : _c, includeExtensions = _a.includeExtensions, preserveHeaderCase = _a.preserveHeaderCase, batchInterval = _a.batchInterval, batchDebounce = _a.batchDebounce, batchMax = _a.batchMax, batchKey = _a.batchKey, requestOptions = (0,tslib_es6/* __rest */._T)(_a, ["uri", "fetch", "print", "includeExtensions", "preserveHeaderCase", "batchInterval", "batchDebounce", "batchMax", "batchKey"]);
        checkFetcher(fetcher);
        if (!fetcher) {
            fetcher = fetch;
        }
        var linkConfig = {
            http: { includeExtensions: includeExtensions, preserveHeaderCase: preserveHeaderCase },
            options: requestOptions.fetchOptions,
            credentials: requestOptions.credentials,
            headers: requestOptions.headers,
        };
        _this.batchDebounce = batchDebounce;
        _this.batchInterval = batchInterval || 10;
        _this.batchMax = batchMax || 10;
        var batchHandler = function (operations) {
            var chosenURI = selectURI(operations[0], uri);
            var context = operations[0].getContext();
            var clientAwarenessHeaders = {};
            if (context.clientAwareness) {
                var _a = context.clientAwareness, name_1 = _a.name, version = _a.version;
                if (name_1) {
                    clientAwarenessHeaders['apollographql-client-name'] = name_1;
                }
                if (version) {
                    clientAwarenessHeaders['apollographql-client-version'] = version;
                }
            }
            var contextConfig = {
                http: context.http,
                options: context.fetchOptions,
                credentials: context.credentials,
                headers: (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, clientAwarenessHeaders), context.headers),
            };
            var optsAndBody = operations.map(function (operation) {
                return selectHttpOptionsAndBodyInternal(operation, print, fallbackHttpConfig, linkConfig, contextConfig);
            });
            var loadedBody = optsAndBody.map(function (_a) {
                var body = _a.body;
                return body;
            });
            var options = optsAndBody[0].options;
            if (options.method === 'GET') {
                return fromError(new Error('apollo-link-batch-http does not support GET requests'));
            }
            try {
                options.body = serializeFetchParameter(loadedBody, 'Payload');
            }
            catch (parseError) {
                return fromError(parseError);
            }
            var controller;
            if (!options.signal) {
                var _b = createSignalIfSupported(), _controller = _b.controller, signal = _b.signal;
                controller = _controller;
                if (controller)
                    options.signal = signal;
            }
            return new Observable(function (observer) {
                fetcher(chosenURI, options)
                    .then(function (response) {
                    operations.forEach(function (operation) { return operation.setContext({ response: response }); });
                    return response;
                })
                    .then(parseAndCheckHttpResponse(operations))
                    .then(function (result) {
                    observer.next(result);
                    observer.complete();
                    return result;
                })
                    .catch(function (err) {
                    if (err.name === 'AbortError')
                        return;
                    if (err.result && err.result.errors && err.result.data) {
                        observer.next(err.result);
                    }
                    observer.error(err);
                });
                return function () {
                    if (controller)
                        controller.abort();
                };
            });
        };
        batchKey =
            batchKey ||
                (function (operation) {
                    var context = operation.getContext();
                    var contextConfig = {
                        http: context.http,
                        options: context.fetchOptions,
                        credentials: context.credentials,
                        headers: context.headers,
                    };
                    return selectURI(operation, uri) + JSON.stringify(contextConfig);
                });
        _this.batcher = new BatchLink({
            batchDebounce: _this.batchDebounce,
            batchInterval: _this.batchInterval,
            batchMax: _this.batchMax,
            batchKey: batchKey,
            batchHandler: batchHandler,
        });
        return _this;
    }
    BatchHttpLink.prototype.request = function (operation) {
        return this.batcher.request(operation);
    };
    return BatchHttpLink;
}(ApolloLink));

//# sourceMappingURL=batchHttpLink.js.map
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@apollo-client-virtual-cd9e78d17f/0/cache/@apollo-client-npm-3.7.1-a80032e019-95bb1f226f.zip/node_modules/@apollo/client/link/context/index.js



function setContext(setter) {
    return new ApolloLink(function (operation, forward) {
        var request = (0,tslib_es6/* __rest */._T)(operation, []);
        return new Observable(function (observer) {
            var handle;
            var closed = false;
            Promise.resolve(request)
                .then(function (req) { return setter(req, operation.getContext()); })
                .then(operation.setContext)
                .then(function () {
                if (closed)
                    return;
                handle = forward(operation).subscribe({
                    next: observer.next.bind(observer),
                    error: observer.error.bind(observer),
                    complete: observer.complete.bind(observer),
                });
            })
                .catch(observer.error.bind(observer));
            return function () {
                closed = true;
                if (handle)
                    handle.unsubscribe();
            };
        });
    });
}
//# sourceMappingURL=index.js.map
// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-lib-utils-virtual-08ae943915/1/packages/lib-utils/src/index.ts + 19 modules
var lib_utils_src = __webpack_require__(65582);
// EXTERNAL MODULE: ../../packages/types-utils/src/index.ts + 3 modules
var types_utils_src = __webpack_require__(71612);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-api-products-virtual-81752d2989/1/packages/lib-api-products/src/provider/use-apollo.ts
/* eslint-disable @typescript-eslint/no-explicit-any */ 





const APOLLO_STATE_PROP_NAME = "__APOLLO_STATE__";
const httpLink = new BatchHttpLink({
    uri: (0,lib_utils_src/* getBykoConfig */.Hp)("SALEOR_GQL_URL"),
    batchMax: 20,
    batchInterval: 20
});
const authLink = setContext((_, context)=>{
    if (!(0,types_utils_src/* isSSR */.yF)()) {
        const token = window.localStorage.getItem("token");
        if (token) {
            return {
                ...context,
                headers: {
                    ...context.headers,
                    Authorization: "JWT ".concat(token)
                }
            };
        }
    }
    return context;
});
let client = null;
const use_apollo_initializeApollo = function() {
    let initialState = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : undefined;
    if (client) {
        return client;
    }
    //
    // Notice:
    // We are not using initialState and will probably not since
    // since the server is not using Apollo at all.
    //
    const cache = new InMemoryCache().restore(initialState !== null && initialState !== void 0 ? initialState : {});
    client = new ApolloClient({
        link: authLink.concat(httpLink),
        cache
    });
    return client;
};
const use_apollo_useApollo = function() {
    let cache = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const { client: _client  } = (0,react.useMemo)(()=>{
        const currentInitState = cache !== null && cache !== void 0 ? cache : undefined;
        const currentClient = use_apollo_initializeApollo(currentInitState);
        return {
            client: currentClient
        };
    // Only run this on inital load.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return _client;
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-api-products-virtual-81752d2989/1/packages/lib-api-products/src/provider/provider.tsx
/* eslint-disable @typescript-eslint/no-explicit-any */ 




const isServer = "object" === "undefined";
// eslint-disable-next-line @typescript-eslint/no-explicit-any
let windowApolloState = !isServer ? window["__NEXT_DATA__"][APOLLO_STATE_PROP_NAME] : "{}";
try {
    windowApolloState = JSON.parse(windowApolloState);
} catch (e) {
    windowApolloState = {};
}
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const withSaleor = (Component)=>{
    const fn = (props)=>{
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const client = useApollo(windowApolloState);
        return /*#__PURE__*/ _jsx(ApolloProvider, {
            client: client,
            children: /*#__PURE__*/ _jsx(Component, {
                ...props
            })
        });
    };
    fn.getInitialProps = (ctx)=>{
        if (Component.getInitialProps) {
            return {
                ...Component.getInitialProps(ctx)
            };
        }
        return {};
    };
    return fn;
};
const SaleorProvider = (param)=>{
    let { children  } = param;
    const client = useApollo(windowApolloState);
    return /*#__PURE__*/ _jsx(ApolloProvider, {
        client: client,
        children: children
    });
};

// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-hooks-auth-next-virtual-a089da2ab7/1/packages/hooks-auth-next/src/index.ts + 14 modules
var hooks_auth_next_src = __webpack_require__(68814);
// EXTERNAL MODULE: ../../.yarn/__virtual__/graphql-tag-virtual-0a79057ca9/0/cache/graphql-tag-npm-2.12.6-99a5a7f6de-b15162a3d6.zip/node_modules/graphql-tag/lib/index.js
var lib = __webpack_require__(86759);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@apollo-client-virtual-cd9e78d17f/0/cache/@apollo-client-npm-3.7.1-a80032e019-95bb1f226f.zip/node_modules/@apollo/client/react/parser/index.js

var DocumentType;
(function (DocumentType) {
    DocumentType[DocumentType["Query"] = 0] = "Query";
    DocumentType[DocumentType["Mutation"] = 1] = "Mutation";
    DocumentType[DocumentType["Subscription"] = 2] = "Subscription";
})(DocumentType || (DocumentType = {}));
var cache = new Map();
function operationName(type) {
    var name;
    switch (type) {
        case DocumentType.Query:
            name = 'Query';
            break;
        case DocumentType.Mutation:
            name = 'Mutation';
            break;
        case DocumentType.Subscription:
            name = 'Subscription';
            break;
    }
    return name;
}
function parser(document) {
    var cached = cache.get(document);
    if (cached)
        return cached;
    var variables, type, name;
    __DEV__ ? (0,invariant/* invariant */.kG)(!!document && !!document.kind, "Argument of ".concat(document, " passed to parser was not a valid GraphQL ") +
        "DocumentNode. You may need to use 'graphql-tag' or another method " +
        "to convert your operation into a document") : (0,invariant/* invariant */.kG)(!!document && !!document.kind, 32);
    var fragments = [];
    var queries = [];
    var mutations = [];
    var subscriptions = [];
    for (var _i = 0, _a = document.definitions; _i < _a.length; _i++) {
        var x = _a[_i];
        if (x.kind === 'FragmentDefinition') {
            fragments.push(x);
            continue;
        }
        if (x.kind === 'OperationDefinition') {
            switch (x.operation) {
                case 'query':
                    queries.push(x);
                    break;
                case 'mutation':
                    mutations.push(x);
                    break;
                case 'subscription':
                    subscriptions.push(x);
                    break;
            }
        }
    }
    __DEV__ ? (0,invariant/* invariant */.kG)(!fragments.length ||
        (queries.length || mutations.length || subscriptions.length), "Passing only a fragment to 'graphql' is not yet supported. " +
        "You must include a query, subscription or mutation as well") : (0,invariant/* invariant */.kG)(!fragments.length ||
        (queries.length || mutations.length || subscriptions.length), 33);
    __DEV__ ? (0,invariant/* invariant */.kG)(queries.length + mutations.length + subscriptions.length <= 1, "react-apollo only supports a query, subscription, or a mutation per HOC. " +
        "".concat(document, " had ").concat(queries.length, " queries, ").concat(subscriptions.length, " ") +
        "subscriptions and ".concat(mutations.length, " mutations. ") +
        "You can use 'compose' to join multiple operation types to a component") : (0,invariant/* invariant */.kG)(queries.length + mutations.length + subscriptions.length <= 1, 34);
    type = queries.length ? DocumentType.Query : DocumentType.Mutation;
    if (!queries.length && !mutations.length)
        type = DocumentType.Subscription;
    var definitions = queries.length
        ? queries
        : mutations.length
            ? mutations
            : subscriptions;
    __DEV__ ? (0,invariant/* invariant */.kG)(definitions.length === 1, "react-apollo only supports one definition per HOC. ".concat(document, " had ") +
        "".concat(definitions.length, " definitions. ") +
        "You can use 'compose' to join multiple operation types to a component") : (0,invariant/* invariant */.kG)(definitions.length === 1, 35);
    var definition = definitions[0];
    variables = definition.variableDefinitions || [];
    if (definition.name && definition.name.kind === 'Name') {
        name = definition.name.value;
    }
    else {
        name = 'data';
    }
    var payload = { name: name, type: type, variables: variables };
    cache.set(document, payload);
    return payload;
}
function verifyDocumentType(document, type) {
    var operation = parser(document);
    var requiredOperationName = operationName(type);
    var usedOperationName = operationName(operation.type);
    __DEV__ ? (0,invariant/* invariant */.kG)(operation.type === type, "Running a ".concat(requiredOperationName, " requires a graphql ") +
        "".concat(requiredOperationName, ", but a ").concat(usedOperationName, " was used instead.")) : (0,invariant/* invariant */.kG)(operation.type === type, 36);
}
//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@apollo-client-virtual-cd9e78d17f/0/cache/@apollo-client-npm-3.7.1-a80032e019-95bb1f226f.zip/node_modules/@apollo/client/react/context/ApolloContext.js


var contextKey = canUseSymbol
    ? Symbol.for('__APOLLO_CONTEXT__')
    : '__APOLLO_CONTEXT__';
function getApolloContext() {
    var context = react.createContext[contextKey];
    if (!context) {
        Object.defineProperty(react.createContext, contextKey, {
            value: context = react.createContext({}),
            enumerable: false,
            writable: false,
            configurable: true,
        });
        context.displayName = 'ApolloContext';
    }
    return context;
}

//# sourceMappingURL=ApolloContext.js.map
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@apollo-client-virtual-cd9e78d17f/0/cache/@apollo-client-npm-3.7.1-a80032e019-95bb1f226f.zip/node_modules/@apollo/client/react/hooks/useApolloClient.js



function useApolloClient(override) {
    var context = (0,react.useContext)(getApolloContext());
    var client = override || context.client;
    __DEV__ ? (0,invariant/* invariant */.kG)(!!client, 'Could not find "client" in the context or passed in as an option. ' +
        'Wrap the root component in an <ApolloProvider>, or pass an ApolloClient ' +
        'instance in via options.') : (0,invariant/* invariant */.kG)(!!client, 31);
    return client;
}
//# sourceMappingURL=useApolloClient.js.map
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@apollo-client-virtual-cd9e78d17f/0/cache/@apollo-client-npm-3.7.1-a80032e019-95bb1f226f.zip/node_modules/@apollo/client/react/hooks/useMutation.js







function useMutation(mutation, options) {
    var client = useApolloClient(options === null || options === void 0 ? void 0 : options.client);
    verifyDocumentType(mutation, DocumentType.Mutation);
    var _a = (0,react.useState)({
        called: false,
        loading: false,
        client: client,
    }), result = _a[0], setResult = _a[1];
    var ref = (0,react.useRef)({
        result: result,
        mutationId: 0,
        isMounted: true,
        client: client,
        mutation: mutation,
        options: options,
    });
    {
        Object.assign(ref.current, { client: client, options: options, mutation: mutation });
    }
    var execute = (0,react.useCallback)(function (executeOptions) {
        if (executeOptions === void 0) { executeOptions = {}; }
        var _a = ref.current, client = _a.client, options = _a.options, mutation = _a.mutation;
        var baseOptions = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, options), { mutation: mutation });
        if (!ref.current.result.loading && !baseOptions.ignoreResults && ref.current.isMounted) {
            setResult(ref.current.result = {
                loading: true,
                error: void 0,
                data: void 0,
                called: true,
                client: client,
            });
        }
        var mutationId = ++ref.current.mutationId;
        var clientOptions = mergeOptions(baseOptions, executeOptions);
        return client.mutate(clientOptions).then(function (response) {
            var _a, _b, _c;
            var data = response.data, errors = response.errors;
            var error = errors && errors.length > 0
                ? new errors_ApolloError({ graphQLErrors: errors })
                : void 0;
            if (mutationId === ref.current.mutationId &&
                !clientOptions.ignoreResults) {
                var result_1 = {
                    called: true,
                    loading: false,
                    data: data,
                    error: error,
                    client: client,
                };
                if (ref.current.isMounted && !equal(ref.current.result, result_1)) {
                    setResult(ref.current.result = result_1);
                }
            }
            (_b = (_a = ref.current.options) === null || _a === void 0 ? void 0 : _a.onCompleted) === null || _b === void 0 ? void 0 : _b.call(_a, response.data, clientOptions);
            (_c = executeOptions.onCompleted) === null || _c === void 0 ? void 0 : _c.call(executeOptions, response.data, clientOptions);
            return response;
        }).catch(function (error) {
            var _a, _b, _c, _d;
            if (mutationId === ref.current.mutationId &&
                ref.current.isMounted) {
                var result_2 = {
                    loading: false,
                    error: error,
                    data: void 0,
                    called: true,
                    client: client,
                };
                if (!equal(ref.current.result, result_2)) {
                    setResult(ref.current.result = result_2);
                }
            }
            if (((_a = ref.current.options) === null || _a === void 0 ? void 0 : _a.onError) || clientOptions.onError) {
                (_c = (_b = ref.current.options) === null || _b === void 0 ? void 0 : _b.onError) === null || _c === void 0 ? void 0 : _c.call(_b, error, clientOptions);
                (_d = executeOptions.onError) === null || _d === void 0 ? void 0 : _d.call(executeOptions, error, clientOptions);
                return { data: void 0, errors: error };
            }
            throw error;
        });
    }, []);
    var reset = (0,react.useCallback)(function () {
        if (ref.current.isMounted) {
            setResult({ called: false, loading: false, client: client });
        }
    }, []);
    (0,react.useEffect)(function () {
        ref.current.isMounted = true;
        return function () {
            ref.current.isMounted = false;
        };
    }, []);
    return [execute, (0,tslib_es6/* __assign */.pi)({ reset: reset }, result)];
}
//# sourceMappingURL=useMutation.js.map
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-api-products-virtual-81752d2989/1/packages/lib-api-products/src/generated/graphql.tsx
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    const data = _taggedTemplateLiteral([
        "\n    fragment CheckoutLine on CheckoutLine {\n  id\n  quantity\n  variant {\n    id\n    product {\n      id\n    }\n  }\n}\n    "
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _taggedTemplateLiteral([
        "\n    fragment Checkout on Checkout {\n  id\n  token\n  quantity\n  lines {\n    ...CheckoutLine\n  }\n}\n    ",
        ""
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = _taggedTemplateLiteral([
        "\n    fragment CheckoutError on CheckoutError {\n  code\n  field\n  message\n  variants\n}\n    "
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = _taggedTemplateLiteral([
        "\n    fragment CountryDisplayFields on CountryDisplay {\n  code\n  country\n}\n    "
    ]);
    _templateObject3 = function() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = _taggedTemplateLiteral([
        "\n    fragment AddressFields on Address {\n  id\n  firstName\n  lastName\n  companyName\n  streetAddress1\n  streetAddress2\n  city\n  cityArea\n  postalCode\n  country {\n    ...CountryDisplayFields\n  }\n  countryArea\n  phone\n  isDefaultShippingAddress\n  isDefaultBillingAddress\n}\n    ",
        ""
    ]);
    _templateObject4 = function() {
        return data;
    };
    return data;
}
function _templateObject5() {
    const data = _taggedTemplateLiteral([
        "\n    fragment OrderFields on Order {\n  id\n  token\n  shippingAddress {\n    ...AddressFields\n  }\n  billingAddress {\n    ...AddressFields\n  }\n  lines {\n    id\n    productName\n    variantName\n    variant {\n      metadata {\n        key\n        value\n      }\n      id\n      name\n      sku\n      product {\n        id\n        name\n        slug\n        thumbnail {\n          url\n          alt\n        }\n        thumbnail2x: thumbnail(size: 510) {\n          url\n        }\n      }\n    }\n    quantity\n    totalPrice {\n      gross {\n        amount\n      }\n    }\n  }\n  created\n  total {\n    gross {\n      amount\n    }\n  }\n  subtotal {\n    gross {\n      amount\n    }\n    tax {\n      amount\n    }\n  }\n  shippingMethod {\n    id\n    name\n    price {\n      amount\n    }\n    description\n  }\n  shippingPrice {\n    gross {\n      amount\n    }\n  }\n  discounts {\n    amount {\n      amount\n    }\n  }\n  discountName\n  undiscountedTotal {\n    gross {\n      amount\n    }\n  }\n  invoices {\n    id\n    url\n  }\n  payments {\n    id\n    gateway\n    isActive\n    chargeStatus\n    capturedAmount {\n      amount\n    }\n    total {\n      amount\n    }\n    creditCard {\n      brand\n      lastDigits\n      expMonth\n      expYear\n    }\n  }\n  original\n  origin\n  customerNote\n}\n    ",
        ""
    ]);
    _templateObject5 = function() {
        return data;
    };
    return data;
}
function _templateObject6() {
    const data = _taggedTemplateLiteral([
        "\n    fragment ProductMedia on ProductMedia {\n  id\n  alt\n  url\n  type\n}\n    "
    ]);
    _templateObject6 = function() {
        return data;
    };
    return data;
}
function _templateObject7() {
    const data = _taggedTemplateLiteral([
        "\n    fragment Money on Money {\n  amount\n  currency\n}\n    "
    ]);
    _templateObject7 = function() {
        return data;
    };
    return data;
}
function _templateObject8() {
    const data = _taggedTemplateLiteral([
        "\n    fragment TaxedMoney on TaxedMoney {\n  net {\n    ...Money\n  }\n  tax {\n    ...Money\n  }\n  gross {\n    ...Money\n  }\n  currency\n}\n    ",
        ""
    ]);
    _templateObject8 = function() {
        return data;
    };
    return data;
}
function _templateObject9() {
    const data = _taggedTemplateLiteral([
        "\n    fragment Product on Product {\n  id\n  slug\n  name\n  description\n  thumbnail(size: 340) {\n    url\n    alt\n  }\n  media {\n    ...ProductMedia\n  }\n  variants {\n    id\n    sku\n    name\n    attributes {\n      attribute {\n        id\n        name\n        slug\n      }\n      values {\n        name\n        boolean\n      }\n    }\n    metadata {\n      key\n      value\n    }\n    quantityAvailable\n    pricing {\n      onSale\n      discount {\n        gross {\n          amount\n        }\n      }\n    }\n  }\n  category {\n    id\n    name\n    slug\n    parent {\n      id\n      name\n      slug\n      parent {\n        id\n        name\n        slug\n        parent {\n          id\n          name\n          slug\n        }\n      }\n    }\n  }\n  isAvailable\n  pricing {\n    priceRange {\n      start {\n        ...TaxedMoney\n      }\n      stop {\n        ...TaxedMoney\n      }\n    }\n  }\n}\n    ",
        "\n",
        ""
    ]);
    _templateObject9 = function() {
        return data;
    };
    return data;
}
function _templateObject10() {
    const data = _taggedTemplateLiteral([
        "\n    mutation AccountAddressCreate($address: AddressInput!) {\n  accountAddressCreate(input: $address) {\n    address {\n      ...AddressFields\n    }\n    accountErrors {\n      field\n      message\n      code\n    }\n  }\n}\n    ",
        ""
    ]);
    _templateObject10 = function() {
        return data;
    };
    return data;
}
function _templateObject11() {
    const data = _taggedTemplateLiteral([
        "\n    mutation AccountAddressUpdate($id: ID!, $address: AddressInput!) {\n  accountAddressUpdate(id: $id, input: $address) {\n    address {\n      ...AddressFields\n    }\n    accountErrors {\n      field\n      message\n      code\n    }\n  }\n}\n    ",
        ""
    ]);
    _templateObject11 = function() {
        return data;
    };
    return data;
}
function _templateObject12() {
    const data = _taggedTemplateLiteral([
        "\n    mutation AccountAddressDelete($id: ID!) {\n  accountAddressDelete(id: $id) {\n    accountErrors {\n      field\n      message\n      code\n    }\n  }\n}\n    "
    ]);
    _templateObject12 = function() {
        return data;
    };
    return data;
}
function _templateObject13() {
    const data = _taggedTemplateLiteral([
        "\n    query CategoryBySlug($slug: String!) {\n  category(slug: $slug) {\n    id\n    name\n    slug\n  }\n}\n    "
    ]);
    _templateObject13 = function() {
        return data;
    };
    return data;
}
function _templateObject14() {
    const data = _taggedTemplateLiteral([
        "\n    query AnonymousCheckoutByToken($token: UUID!) {\n  checkout(token: $token) {\n    ...Checkout\n  }\n}\n    ",
        ""
    ]);
    _templateObject14 = function() {
        return data;
    };
    return data;
}
function _templateObject15() {
    const data = _taggedTemplateLiteral([
        "\n    query MyCheckout {\n  me {\n    id\n    checkout {\n      ...Checkout\n    }\n  }\n}\n    ",
        ""
    ]);
    _templateObject15 = function() {
        return data;
    };
    return data;
}
function _templateObject16() {
    const data = _taggedTemplateLiteral([
        '\n    mutation CheckoutCreate($email: String!, $lines: [CheckoutLineInput]!) {\n  checkoutCreate(input: {email: $email, lines: $lines, channel: "webstore"}) {\n    created\n    checkout {\n      ...Checkout\n    }\n    errors {\n      ...CheckoutError\n    }\n  }\n}\n    ',
        "\n",
        ""
    ]);
    _templateObject16 = function() {
        return data;
    };
    return data;
}
function _templateObject17() {
    const data = _taggedTemplateLiteral([
        "\n    mutation CheckoutLinesAdd($token: UUID!, $lines: [CheckoutLineInput]!) {\n  checkoutLinesAdd(token: $token, lines: $lines) {\n    errors {\n      ...CheckoutError\n    }\n  }\n}\n    ",
        ""
    ]);
    _templateObject17 = function() {
        return data;
    };
    return data;
}
function _templateObject18() {
    const data = _taggedTemplateLiteral([
        "\n    mutation CheckoutLinesUpdate($token: UUID!, $lines: [CheckoutLineInput]!) {\n  checkoutLinesUpdate(token: $token, lines: $lines) {\n    errors {\n      ...CheckoutError\n    }\n  }\n}\n    ",
        ""
    ]);
    _templateObject18 = function() {
        return data;
    };
    return data;
}
function _templateObject19() {
    const data = _taggedTemplateLiteral([
        "\n    mutation CheckoutLineDelete($token: UUID!, $lineId: ID!) {\n  checkoutLineDelete(token: $token, lineId: $lineId) {\n    errors {\n      ...CheckoutError\n    }\n  }\n}\n    ",
        ""
    ]);
    _templateObject19 = function() {
        return data;
    };
    return data;
}
function _templateObject20() {
    const data = _taggedTemplateLiteral([
        "\n    mutation CheckoutShippingAddressUpdate($token: UUID!, $shippingAddress: AddressInput!) {\n  checkoutShippingAddressUpdate(token: $token, shippingAddress: $shippingAddress) {\n    errors {\n      ...CheckoutError\n    }\n  }\n}\n    ",
        ""
    ]);
    _templateObject20 = function() {
        return data;
    };
    return data;
}
function _templateObject21() {
    const data = _taggedTemplateLiteral([
        "\n    mutation CheckoutBillingAddressUpdate($token: UUID!, $billingAddress: AddressInput!) {\n  checkoutBillingAddressUpdate(token: $token, billingAddress: $billingAddress) {\n    errors {\n      ...CheckoutError\n    }\n  }\n}\n    ",
        ""
    ]);
    _templateObject21 = function() {
        return data;
    };
    return data;
}
function _templateObject22() {
    const data = _taggedTemplateLiteral([
        "\n    mutation CheckoutAddressesUpdate($token: UUID!, $billingAddress: AddressInput!, $shippingAddress: AddressInput!) {\n  checkoutBillingAddressUpdate(token: $token, billingAddress: $billingAddress) {\n    errors {\n      ...CheckoutError\n    }\n  }\n  checkoutShippingAddressUpdate(token: $token, shippingAddress: $shippingAddress) {\n    errors {\n      ...CheckoutError\n    }\n  }\n}\n    ",
        ""
    ]);
    _templateObject22 = function() {
        return data;
    };
    return data;
}
function _templateObject23() {
    const data = _taggedTemplateLiteral([
        "\n    mutation CheckoutShippingMethodUpdate($token: UUID!, $shippingMethodId: ID!) {\n  checkoutShippingMethodUpdate(token: $token, shippingMethodId: $shippingMethodId) {\n    errors {\n      ...CheckoutError\n    }\n  }\n}\n    ",
        ""
    ]);
    _templateObject23 = function() {
        return data;
    };
    return data;
}
function _templateObject24() {
    const data = _taggedTemplateLiteral([
        "\n    mutation CheckoutPaymentCreate($token: UUID!, $input: PaymentInput!) {\n  checkoutPaymentCreate(token: $token, input: $input) {\n    payment {\n      id\n      gateway\n      token\n      chargeStatus\n    }\n    errors {\n      field\n      message\n      code\n    }\n  }\n}\n    "
    ]);
    _templateObject24 = function() {
        return data;
    };
    return data;
}
function _templateObject25() {
    const data = _taggedTemplateLiteral([
        "\n    mutation AddNoteToOrder($order: ID!, $input: OrderAddNoteInput!) {\n  orderAddNote(order: $order, input: $input) {\n    order {\n      ...OrderFields\n    }\n  }\n}\n    ",
        ""
    ]);
    _templateObject25 = function() {
        return data;
    };
    return data;
}
function _templateObject26() {
    const data = _taggedTemplateLiteral([
        "\n    mutation CheckoutComplete($token: UUID!, $paymentData: JSONString) {\n  checkoutComplete(token: $token, paymentData: $paymentData) {\n    order {\n      ...OrderFields\n    }\n    confirmationNeeded\n    confirmationData\n    errors {\n      ...CheckoutError\n    }\n  }\n}\n    ",
        "\n",
        ""
    ]);
    _templateObject26 = function() {
        return data;
    };
    return data;
}
function _templateObject27() {
    const data = _taggedTemplateLiteral([
        "\n    mutation CheckoutEmailUpdate($email: String!, $token: UUID!) {\n  checkoutEmailUpdate(email: $email, token: $token) {\n    errors {\n      ...CheckoutError\n    }\n  }\n}\n    ",
        ""
    ]);
    _templateObject27 = function() {
        return data;
    };
    return data;
}
function _templateObject28() {
    const data = _taggedTemplateLiteral([
        "\n    mutation CheckoutReceiverUpdate($token: UUID!, $billingAddress: AddressInput!, $shippingAddress: AddressInput!, $email: String!) {\n  checkoutBillingAddressUpdate(token: $token, billingAddress: $billingAddress) {\n    checkout {\n      ...Checkout\n    }\n    errors {\n      ...CheckoutError\n    }\n  }\n  checkoutShippingAddressUpdate(token: $token, shippingAddress: $shippingAddress) {\n    checkout {\n      ...Checkout\n    }\n    errors {\n      ...CheckoutError\n    }\n  }\n  checkoutEmailUpdate(token: $token, email: $email) {\n    checkout {\n      ...Checkout\n    }\n    errors {\n      ...CheckoutError\n    }\n  }\n}\n    ",
        "\n",
        ""
    ]);
    _templateObject28 = function() {
        return data;
    };
    return data;
}
function _templateObject29() {
    const data = _taggedTemplateLiteral([
        "\n    query OrderByToken($token: UUID!) {\n  orderByToken(token: $token) {\n    ...OrderFields\n  }\n}\n    ",
        ""
    ]);
    _templateObject29 = function() {
        return data;
    };
    return data;
}
function _templateObject30() {
    const data = _taggedTemplateLiteral([
        "\n    query ProductById($id: ID!) {\n  product(id: $id) {\n    ...Product\n  }\n}\n    ",
        ""
    ]);
    _templateObject30 = function() {
        return data;
    };
    return data;
}
function _templateObject31() {
    const data = _taggedTemplateLiteral([
        "\n    query Product($slug: String!) {\n  product(slug: $slug) {\n    ...Product\n  }\n}\n    ",
        ""
    ]);
    _templateObject31 = function() {
        return data;
    };
    return data;
}
function _templateObject32() {
    const data = _taggedTemplateLiteral([
        "\n    query Products($first: Int!, $last: Int, $after: String, $before: String, $filter: ProductFilterInput, $sortBy: ProductOrder) {\n  products(\n    first: $first\n    last: $last\n    after: $after\n    before: $before\n    filter: $filter\n    sortBy: $sortBy\n  ) {\n    totalCount\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    edges {\n      cursor\n      node {\n        ...Product\n      }\n    }\n  }\n}\n    ",
        ""
    ]);
    _templateObject32 = function() {
        return data;
    };
    return data;
}
function _templateObject33() {
    const data = _taggedTemplateLiteral([
        "\n    query UserAddresses {\n  me {\n    id\n    addresses {\n      ...AddressFields\n    }\n  }\n}\n    ",
        ""
    ]);
    _templateObject33 = function() {
        return data;
    };
    return data;
}


const graphql_defaultOptions = {};
var AccountErrorCode;
(function(AccountErrorCode) {
    AccountErrorCode["AccountNotConfirmed"] = "ACCOUNT_NOT_CONFIRMED";
    AccountErrorCode["ActivateOwnAccount"] = "ACTIVATE_OWN_ACCOUNT";
    AccountErrorCode["ActivateSuperuserAccount"] = "ACTIVATE_SUPERUSER_ACCOUNT";
    AccountErrorCode["ChannelInactive"] = "CHANNEL_INACTIVE";
    AccountErrorCode["DeactivateOwnAccount"] = "DEACTIVATE_OWN_ACCOUNT";
    AccountErrorCode["DeactivateSuperuserAccount"] = "DEACTIVATE_SUPERUSER_ACCOUNT";
    AccountErrorCode["DeleteNonStaffUser"] = "DELETE_NON_STAFF_USER";
    AccountErrorCode["DeleteOwnAccount"] = "DELETE_OWN_ACCOUNT";
    AccountErrorCode["DeleteStaffAccount"] = "DELETE_STAFF_ACCOUNT";
    AccountErrorCode["DeleteSuperuserAccount"] = "DELETE_SUPERUSER_ACCOUNT";
    AccountErrorCode["DuplicatedInputItem"] = "DUPLICATED_INPUT_ITEM";
    AccountErrorCode["GraphqlError"] = "GRAPHQL_ERROR";
    AccountErrorCode["Inactive"] = "INACTIVE";
    AccountErrorCode["Invalid"] = "INVALID";
    AccountErrorCode["InvalidCredentials"] = "INVALID_CREDENTIALS";
    AccountErrorCode["InvalidPassword"] = "INVALID_PASSWORD";
    AccountErrorCode["JwtDecodeError"] = "JWT_DECODE_ERROR";
    AccountErrorCode["JwtInvalidCsrfToken"] = "JWT_INVALID_CSRF_TOKEN";
    AccountErrorCode["JwtInvalidToken"] = "JWT_INVALID_TOKEN";
    AccountErrorCode["JwtMissingToken"] = "JWT_MISSING_TOKEN";
    AccountErrorCode["JwtSignatureExpired"] = "JWT_SIGNATURE_EXPIRED";
    AccountErrorCode["LeftNotManageablePermission"] = "LEFT_NOT_MANAGEABLE_PERMISSION";
    AccountErrorCode["MissingChannelSlug"] = "MISSING_CHANNEL_SLUG";
    AccountErrorCode["NotFound"] = "NOT_FOUND";
    AccountErrorCode["OutOfScopeGroup"] = "OUT_OF_SCOPE_GROUP";
    AccountErrorCode["OutOfScopePermission"] = "OUT_OF_SCOPE_PERMISSION";
    AccountErrorCode["OutOfScopeUser"] = "OUT_OF_SCOPE_USER";
    AccountErrorCode["PasswordEntirelyNumeric"] = "PASSWORD_ENTIRELY_NUMERIC";
    AccountErrorCode["PasswordTooCommon"] = "PASSWORD_TOO_COMMON";
    AccountErrorCode["PasswordTooShort"] = "PASSWORD_TOO_SHORT";
    AccountErrorCode["PasswordTooSimilar"] = "PASSWORD_TOO_SIMILAR";
    AccountErrorCode["Required"] = "REQUIRED";
    AccountErrorCode["Unique"] = "UNIQUE";
})(AccountErrorCode || (AccountErrorCode = {}));
var AddressTypeEnum;
(function(AddressTypeEnum) {
    AddressTypeEnum["Billing"] = "BILLING";
    AddressTypeEnum["Shipping"] = "SHIPPING";
})(AddressTypeEnum || (AddressTypeEnum = {}));
var AppErrorCode;
(function(AppErrorCode) {
    AppErrorCode["Forbidden"] = "FORBIDDEN";
    AppErrorCode["GraphqlError"] = "GRAPHQL_ERROR";
    AppErrorCode["Invalid"] = "INVALID";
    AppErrorCode["InvalidManifestFormat"] = "INVALID_MANIFEST_FORMAT";
    AppErrorCode["InvalidPermission"] = "INVALID_PERMISSION";
    AppErrorCode["InvalidStatus"] = "INVALID_STATUS";
    AppErrorCode["InvalidUrlFormat"] = "INVALID_URL_FORMAT";
    AppErrorCode["ManifestUrlCantConnect"] = "MANIFEST_URL_CANT_CONNECT";
    AppErrorCode["NotFound"] = "NOT_FOUND";
    AppErrorCode["OutOfScopeApp"] = "OUT_OF_SCOPE_APP";
    AppErrorCode["OutOfScopePermission"] = "OUT_OF_SCOPE_PERMISSION";
    AppErrorCode["Required"] = "REQUIRED";
    AppErrorCode["Unique"] = "UNIQUE";
})(AppErrorCode || (AppErrorCode = {}));
var AppExtensionMountEnum;
(function(AppExtensionMountEnum) {
    AppExtensionMountEnum["NavigationCatalog"] = "NAVIGATION_CATALOG";
    AppExtensionMountEnum["NavigationCustomers"] = "NAVIGATION_CUSTOMERS";
    AppExtensionMountEnum["NavigationDiscounts"] = "NAVIGATION_DISCOUNTS";
    AppExtensionMountEnum["NavigationOrders"] = "NAVIGATION_ORDERS";
    AppExtensionMountEnum["NavigationPages"] = "NAVIGATION_PAGES";
    AppExtensionMountEnum["NavigationTranslations"] = "NAVIGATION_TRANSLATIONS";
    AppExtensionMountEnum["ProductDetailsMoreActions"] = "PRODUCT_DETAILS_MORE_ACTIONS";
    AppExtensionMountEnum["ProductOverviewCreate"] = "PRODUCT_OVERVIEW_CREATE";
    AppExtensionMountEnum["ProductOverviewMoreActions"] = "PRODUCT_OVERVIEW_MORE_ACTIONS";
})(AppExtensionMountEnum || (AppExtensionMountEnum = {}));
var AppExtensionTargetEnum;
(function(AppExtensionTargetEnum) {
    AppExtensionTargetEnum["AppPage"] = "APP_PAGE";
    AppExtensionTargetEnum["Popup"] = "POPUP";
})(AppExtensionTargetEnum || (AppExtensionTargetEnum = {}));
var AppSortField;
(function(AppSortField) {
    AppSortField[/** Sort apps by creation date. */ "CreationDate"] = "CREATION_DATE";
    AppSortField[/** Sort apps by name. */ "Name"] = "NAME";
})(AppSortField || (AppSortField = {}));
var AppTypeEnum;
(function(AppTypeEnum) {
    AppTypeEnum[/** Local Saleor App. The app is fully manageable from dashboard. You can change assigned permissions, add webhooks, or authentication token */ "Local"] = "LOCAL";
    AppTypeEnum[/** Third party external App. Installation is fully automated. Saleor uses a defined App manifest to gather all required information. */ "Thirdparty"] = "THIRDPARTY";
})(AppTypeEnum || (AppTypeEnum = {}));
var AreaUnitsEnum;
(function(AreaUnitsEnum) {
    AreaUnitsEnum["SqCm"] = "SQ_CM";
    AreaUnitsEnum["SqFt"] = "SQ_FT";
    AreaUnitsEnum["SqInch"] = "SQ_INCH";
    AreaUnitsEnum["SqKm"] = "SQ_KM";
    AreaUnitsEnum["SqM"] = "SQ_M";
    AreaUnitsEnum["SqYd"] = "SQ_YD";
})(AreaUnitsEnum || (AreaUnitsEnum = {}));
var AttributeChoicesSortField;
(function(AttributeChoicesSortField) {
    AttributeChoicesSortField[/** Sort attribute choice by name. */ "Name"] = "NAME";
    AttributeChoicesSortField[/** Sort attribute choice by slug. */ "Slug"] = "SLUG";
})(AttributeChoicesSortField || (AttributeChoicesSortField = {}));
var AttributeEntityTypeEnum;
(function(AttributeEntityTypeEnum) {
    AttributeEntityTypeEnum["Page"] = "PAGE";
    AttributeEntityTypeEnum["Product"] = "PRODUCT";
})(AttributeEntityTypeEnum || (AttributeEntityTypeEnum = {}));
var AttributeErrorCode;
(function(AttributeErrorCode) {
    AttributeErrorCode["AlreadyExists"] = "ALREADY_EXISTS";
    AttributeErrorCode["GraphqlError"] = "GRAPHQL_ERROR";
    AttributeErrorCode["Invalid"] = "INVALID";
    AttributeErrorCode["NotFound"] = "NOT_FOUND";
    AttributeErrorCode["Required"] = "REQUIRED";
    AttributeErrorCode["Unique"] = "UNIQUE";
})(AttributeErrorCode || (AttributeErrorCode = {}));
var AttributeInputTypeEnum;
(function(AttributeInputTypeEnum) {
    AttributeInputTypeEnum["Boolean"] = "BOOLEAN";
    AttributeInputTypeEnum["Date"] = "DATE";
    AttributeInputTypeEnum["DateTime"] = "DATE_TIME";
    AttributeInputTypeEnum["Dropdown"] = "DROPDOWN";
    AttributeInputTypeEnum["File"] = "FILE";
    AttributeInputTypeEnum["Multiselect"] = "MULTISELECT";
    AttributeInputTypeEnum["Numeric"] = "NUMERIC";
    AttributeInputTypeEnum["Reference"] = "REFERENCE";
    AttributeInputTypeEnum["RichText"] = "RICH_TEXT";
    AttributeInputTypeEnum["Swatch"] = "SWATCH";
})(AttributeInputTypeEnum || (AttributeInputTypeEnum = {}));
var AttributeSortField;
(function(AttributeSortField) {
    AttributeSortField[/** Sort attributes based on whether they can be displayed or not in a product grid. */ "AvailableInGrid"] = "AVAILABLE_IN_GRID";
    AttributeSortField[/** Sort attributes by the filterable in dashboard flag */ "FilterableInDashboard"] = "FILTERABLE_IN_DASHBOARD";
    AttributeSortField[/** Sort attributes by the filterable in storefront flag */ "FilterableInStorefront"] = "FILTERABLE_IN_STOREFRONT";
    AttributeSortField[/** Sort attributes by the variant only flag */ "IsVariantOnly"] = "IS_VARIANT_ONLY";
    AttributeSortField[/** Sort attributes by name */ "Name"] = "NAME";
    AttributeSortField[/** Sort attributes by slug */ "Slug"] = "SLUG";
    AttributeSortField[/** Sort attributes by their position in storefront */ "StorefrontSearchPosition"] = "STOREFRONT_SEARCH_POSITION";
    AttributeSortField[/** Sort attributes by the value required flag */ "ValueRequired"] = "VALUE_REQUIRED";
    AttributeSortField[/** Sort attributes by visibility in the storefront */ "VisibleInStorefront"] = "VISIBLE_IN_STOREFRONT";
})(AttributeSortField || (AttributeSortField = {}));
var AttributeTypeEnum;
(function(AttributeTypeEnum) {
    AttributeTypeEnum["PageType"] = "PAGE_TYPE";
    AttributeTypeEnum["ProductType"] = "PRODUCT_TYPE";
})(AttributeTypeEnum || (AttributeTypeEnum = {}));
var CategorySortField;
(function(CategorySortField) {
    CategorySortField[/** Sort categories by name. */ "Name"] = "NAME";
    CategorySortField[/** Sort categories by product count. */ "ProductCount"] = "PRODUCT_COUNT";
    CategorySortField[/** Sort categories by subcategory count. */ "SubcategoryCount"] = "SUBCATEGORY_COUNT";
})(CategorySortField || (CategorySortField = {}));
var ChannelErrorCode;
(function(ChannelErrorCode) {
    ChannelErrorCode["AlreadyExists"] = "ALREADY_EXISTS";
    ChannelErrorCode["ChannelsCurrencyMustBeTheSame"] = "CHANNELS_CURRENCY_MUST_BE_THE_SAME";
    ChannelErrorCode["ChannelWithOrders"] = "CHANNEL_WITH_ORDERS";
    ChannelErrorCode["DuplicatedInputItem"] = "DUPLICATED_INPUT_ITEM";
    ChannelErrorCode["GraphqlError"] = "GRAPHQL_ERROR";
    ChannelErrorCode["Invalid"] = "INVALID";
    ChannelErrorCode["NotFound"] = "NOT_FOUND";
    ChannelErrorCode["Required"] = "REQUIRED";
    ChannelErrorCode["Unique"] = "UNIQUE";
})(ChannelErrorCode || (ChannelErrorCode = {}));
var CheckoutErrorCode;
(function(CheckoutErrorCode) {
    CheckoutErrorCode["BillingAddressNotSet"] = "BILLING_ADDRESS_NOT_SET";
    CheckoutErrorCode["ChannelInactive"] = "CHANNEL_INACTIVE";
    CheckoutErrorCode["CheckoutNotFullyPaid"] = "CHECKOUT_NOT_FULLY_PAID";
    CheckoutErrorCode["DeliveryMethodNotApplicable"] = "DELIVERY_METHOD_NOT_APPLICABLE";
    CheckoutErrorCode["EmailNotSet"] = "EMAIL_NOT_SET";
    CheckoutErrorCode["GiftCardNotApplicable"] = "GIFT_CARD_NOT_APPLICABLE";
    CheckoutErrorCode["GraphqlError"] = "GRAPHQL_ERROR";
    CheckoutErrorCode["InsufficientStock"] = "INSUFFICIENT_STOCK";
    CheckoutErrorCode["Invalid"] = "INVALID";
    CheckoutErrorCode["InvalidShippingMethod"] = "INVALID_SHIPPING_METHOD";
    CheckoutErrorCode["MissingChannelSlug"] = "MISSING_CHANNEL_SLUG";
    CheckoutErrorCode["NotFound"] = "NOT_FOUND";
    CheckoutErrorCode["NoLines"] = "NO_LINES";
    CheckoutErrorCode["PaymentError"] = "PAYMENT_ERROR";
    CheckoutErrorCode["ProductNotPublished"] = "PRODUCT_NOT_PUBLISHED";
    CheckoutErrorCode["ProductUnavailableForPurchase"] = "PRODUCT_UNAVAILABLE_FOR_PURCHASE";
    CheckoutErrorCode["QuantityGreaterThanLimit"] = "QUANTITY_GREATER_THAN_LIMIT";
    CheckoutErrorCode["Required"] = "REQUIRED";
    CheckoutErrorCode["ShippingAddressNotSet"] = "SHIPPING_ADDRESS_NOT_SET";
    CheckoutErrorCode["ShippingMethodNotApplicable"] = "SHIPPING_METHOD_NOT_APPLICABLE";
    CheckoutErrorCode["ShippingMethodNotSet"] = "SHIPPING_METHOD_NOT_SET";
    CheckoutErrorCode["ShippingNotRequired"] = "SHIPPING_NOT_REQUIRED";
    CheckoutErrorCode["TaxError"] = "TAX_ERROR";
    CheckoutErrorCode["UnavailableVariantInChannel"] = "UNAVAILABLE_VARIANT_IN_CHANNEL";
    CheckoutErrorCode["Unique"] = "UNIQUE";
    CheckoutErrorCode["VoucherNotApplicable"] = "VOUCHER_NOT_APPLICABLE";
    CheckoutErrorCode["ZeroQuantity"] = "ZERO_QUANTITY";
})(CheckoutErrorCode || (CheckoutErrorCode = {}));
var CheckoutSortField;
(function(CheckoutSortField) {
    CheckoutSortField[/** Sort checkouts by creation date. */ "CreationDate"] = "CREATION_DATE";
    CheckoutSortField[/** Sort checkouts by customer. */ "Customer"] = "CUSTOMER";
    CheckoutSortField[/** Sort checkouts by payment. */ "Payment"] = "PAYMENT";
})(CheckoutSortField || (CheckoutSortField = {}));
var CollectionErrorCode;
(function(CollectionErrorCode) {
    CollectionErrorCode["CannotManageProductWithoutVariant"] = "CANNOT_MANAGE_PRODUCT_WITHOUT_VARIANT";
    CollectionErrorCode["DuplicatedInputItem"] = "DUPLICATED_INPUT_ITEM";
    CollectionErrorCode["GraphqlError"] = "GRAPHQL_ERROR";
    CollectionErrorCode["Invalid"] = "INVALID";
    CollectionErrorCode["NotFound"] = "NOT_FOUND";
    CollectionErrorCode["Required"] = "REQUIRED";
    CollectionErrorCode["Unique"] = "UNIQUE";
})(CollectionErrorCode || (CollectionErrorCode = {}));
var CollectionPublished;
(function(CollectionPublished) {
    CollectionPublished["Hidden"] = "HIDDEN";
    CollectionPublished["Published"] = "PUBLISHED";
})(CollectionPublished || (CollectionPublished = {}));
var CollectionSortField;
(function(CollectionSortField) {
    CollectionSortField[/** Sort collections by availability. */ "Availability"] = "AVAILABILITY";
    CollectionSortField[/** Sort collections by name. */ "Name"] = "NAME";
    CollectionSortField[/** Sort collections by product count. */ "ProductCount"] = "PRODUCT_COUNT";
    CollectionSortField[/** Sort collections by publication date. */ "PublicationDate"] = "PUBLICATION_DATE";
})(CollectionSortField || (CollectionSortField = {}));
var ConfigurationTypeFieldEnum;
(function(ConfigurationTypeFieldEnum) {
    ConfigurationTypeFieldEnum["Boolean"] = "BOOLEAN";
    ConfigurationTypeFieldEnum["Multiline"] = "MULTILINE";
    ConfigurationTypeFieldEnum["Output"] = "OUTPUT";
    ConfigurationTypeFieldEnum["Password"] = "PASSWORD";
    ConfigurationTypeFieldEnum["Secret"] = "SECRET";
    ConfigurationTypeFieldEnum["Secretmultiline"] = "SECRETMULTILINE";
    ConfigurationTypeFieldEnum["String"] = "STRING";
})(ConfigurationTypeFieldEnum || (ConfigurationTypeFieldEnum = {}));
var CountryCode;
(function(CountryCode) {
    CountryCode["Ad"] = "AD";
    CountryCode["Ae"] = "AE";
    CountryCode["Af"] = "AF";
    CountryCode["Ag"] = "AG";
    CountryCode["Ai"] = "AI";
    CountryCode["Al"] = "AL";
    CountryCode["Am"] = "AM";
    CountryCode["Ao"] = "AO";
    CountryCode["Aq"] = "AQ";
    CountryCode["Ar"] = "AR";
    CountryCode["As"] = "AS";
    CountryCode["At"] = "AT";
    CountryCode["Au"] = "AU";
    CountryCode["Aw"] = "AW";
    CountryCode["Ax"] = "AX";
    CountryCode["Az"] = "AZ";
    CountryCode["Ba"] = "BA";
    CountryCode["Bb"] = "BB";
    CountryCode["Bd"] = "BD";
    CountryCode["Be"] = "BE";
    CountryCode["Bf"] = "BF";
    CountryCode["Bg"] = "BG";
    CountryCode["Bh"] = "BH";
    CountryCode["Bi"] = "BI";
    CountryCode["Bj"] = "BJ";
    CountryCode["Bl"] = "BL";
    CountryCode["Bm"] = "BM";
    CountryCode["Bn"] = "BN";
    CountryCode["Bo"] = "BO";
    CountryCode["Bq"] = "BQ";
    CountryCode["Br"] = "BR";
    CountryCode["Bs"] = "BS";
    CountryCode["Bt"] = "BT";
    CountryCode["Bv"] = "BV";
    CountryCode["Bw"] = "BW";
    CountryCode["By"] = "BY";
    CountryCode["Bz"] = "BZ";
    CountryCode["Ca"] = "CA";
    CountryCode["Cc"] = "CC";
    CountryCode["Cd"] = "CD";
    CountryCode["Cf"] = "CF";
    CountryCode["Cg"] = "CG";
    CountryCode["Ch"] = "CH";
    CountryCode["Ci"] = "CI";
    CountryCode["Ck"] = "CK";
    CountryCode["Cl"] = "CL";
    CountryCode["Cm"] = "CM";
    CountryCode["Cn"] = "CN";
    CountryCode["Co"] = "CO";
    CountryCode["Cr"] = "CR";
    CountryCode["Cu"] = "CU";
    CountryCode["Cv"] = "CV";
    CountryCode["Cw"] = "CW";
    CountryCode["Cx"] = "CX";
    CountryCode["Cy"] = "CY";
    CountryCode["Cz"] = "CZ";
    CountryCode["De"] = "DE";
    CountryCode["Dj"] = "DJ";
    CountryCode["Dk"] = "DK";
    CountryCode["Dm"] = "DM";
    CountryCode["Do"] = "DO";
    CountryCode["Dz"] = "DZ";
    CountryCode["Ec"] = "EC";
    CountryCode["Ee"] = "EE";
    CountryCode["Eg"] = "EG";
    CountryCode["Eh"] = "EH";
    CountryCode["Er"] = "ER";
    CountryCode["Es"] = "ES";
    CountryCode["Et"] = "ET";
    CountryCode["Fi"] = "FI";
    CountryCode["Fj"] = "FJ";
    CountryCode["Fk"] = "FK";
    CountryCode["Fm"] = "FM";
    CountryCode["Fo"] = "FO";
    CountryCode["Fr"] = "FR";
    CountryCode["Ga"] = "GA";
    CountryCode["Gb"] = "GB";
    CountryCode["Gd"] = "GD";
    CountryCode["Ge"] = "GE";
    CountryCode["Gf"] = "GF";
    CountryCode["Gg"] = "GG";
    CountryCode["Gh"] = "GH";
    CountryCode["Gi"] = "GI";
    CountryCode["Gl"] = "GL";
    CountryCode["Gm"] = "GM";
    CountryCode["Gn"] = "GN";
    CountryCode["Gp"] = "GP";
    CountryCode["Gq"] = "GQ";
    CountryCode["Gr"] = "GR";
    CountryCode["Gs"] = "GS";
    CountryCode["Gt"] = "GT";
    CountryCode["Gu"] = "GU";
    CountryCode["Gw"] = "GW";
    CountryCode["Gy"] = "GY";
    CountryCode["Hk"] = "HK";
    CountryCode["Hm"] = "HM";
    CountryCode["Hn"] = "HN";
    CountryCode["Hr"] = "HR";
    CountryCode["Ht"] = "HT";
    CountryCode["Hu"] = "HU";
    CountryCode["Id"] = "ID";
    CountryCode["Ie"] = "IE";
    CountryCode["Il"] = "IL";
    CountryCode["Im"] = "IM";
    CountryCode["In"] = "IN";
    CountryCode["Io"] = "IO";
    CountryCode["Iq"] = "IQ";
    CountryCode["Ir"] = "IR";
    CountryCode["Is"] = "IS";
    CountryCode["It"] = "IT";
    CountryCode["Je"] = "JE";
    CountryCode["Jm"] = "JM";
    CountryCode["Jo"] = "JO";
    CountryCode["Jp"] = "JP";
    CountryCode["Ke"] = "KE";
    CountryCode["Kg"] = "KG";
    CountryCode["Kh"] = "KH";
    CountryCode["Ki"] = "KI";
    CountryCode["Km"] = "KM";
    CountryCode["Kn"] = "KN";
    CountryCode["Kp"] = "KP";
    CountryCode["Kr"] = "KR";
    CountryCode["Kw"] = "KW";
    CountryCode["Ky"] = "KY";
    CountryCode["Kz"] = "KZ";
    CountryCode["La"] = "LA";
    CountryCode["Lb"] = "LB";
    CountryCode["Lc"] = "LC";
    CountryCode["Li"] = "LI";
    CountryCode["Lk"] = "LK";
    CountryCode["Lr"] = "LR";
    CountryCode["Ls"] = "LS";
    CountryCode["Lt"] = "LT";
    CountryCode["Lu"] = "LU";
    CountryCode["Lv"] = "LV";
    CountryCode["Ly"] = "LY";
    CountryCode["Ma"] = "MA";
    CountryCode["Mc"] = "MC";
    CountryCode["Md"] = "MD";
    CountryCode["Me"] = "ME";
    CountryCode["Mf"] = "MF";
    CountryCode["Mg"] = "MG";
    CountryCode["Mh"] = "MH";
    CountryCode["Mk"] = "MK";
    CountryCode["Ml"] = "ML";
    CountryCode["Mm"] = "MM";
    CountryCode["Mn"] = "MN";
    CountryCode["Mo"] = "MO";
    CountryCode["Mp"] = "MP";
    CountryCode["Mq"] = "MQ";
    CountryCode["Mr"] = "MR";
    CountryCode["Ms"] = "MS";
    CountryCode["Mt"] = "MT";
    CountryCode["Mu"] = "MU";
    CountryCode["Mv"] = "MV";
    CountryCode["Mw"] = "MW";
    CountryCode["Mx"] = "MX";
    CountryCode["My"] = "MY";
    CountryCode["Mz"] = "MZ";
    CountryCode["Na"] = "NA";
    CountryCode["Nc"] = "NC";
    CountryCode["Ne"] = "NE";
    CountryCode["Nf"] = "NF";
    CountryCode["Ng"] = "NG";
    CountryCode["Ni"] = "NI";
    CountryCode["Nl"] = "NL";
    CountryCode["No"] = "NO";
    CountryCode["Np"] = "NP";
    CountryCode["Nr"] = "NR";
    CountryCode["Nu"] = "NU";
    CountryCode["Nz"] = "NZ";
    CountryCode["Om"] = "OM";
    CountryCode["Pa"] = "PA";
    CountryCode["Pe"] = "PE";
    CountryCode["Pf"] = "PF";
    CountryCode["Pg"] = "PG";
    CountryCode["Ph"] = "PH";
    CountryCode["Pk"] = "PK";
    CountryCode["Pl"] = "PL";
    CountryCode["Pm"] = "PM";
    CountryCode["Pn"] = "PN";
    CountryCode["Pr"] = "PR";
    CountryCode["Ps"] = "PS";
    CountryCode["Pt"] = "PT";
    CountryCode["Pw"] = "PW";
    CountryCode["Py"] = "PY";
    CountryCode["Qa"] = "QA";
    CountryCode["Re"] = "RE";
    CountryCode["Ro"] = "RO";
    CountryCode["Rs"] = "RS";
    CountryCode["Ru"] = "RU";
    CountryCode["Rw"] = "RW";
    CountryCode["Sa"] = "SA";
    CountryCode["Sb"] = "SB";
    CountryCode["Sc"] = "SC";
    CountryCode["Sd"] = "SD";
    CountryCode["Se"] = "SE";
    CountryCode["Sg"] = "SG";
    CountryCode["Sh"] = "SH";
    CountryCode["Si"] = "SI";
    CountryCode["Sj"] = "SJ";
    CountryCode["Sk"] = "SK";
    CountryCode["Sl"] = "SL";
    CountryCode["Sm"] = "SM";
    CountryCode["Sn"] = "SN";
    CountryCode["So"] = "SO";
    CountryCode["Sr"] = "SR";
    CountryCode["Ss"] = "SS";
    CountryCode["St"] = "ST";
    CountryCode["Sv"] = "SV";
    CountryCode["Sx"] = "SX";
    CountryCode["Sy"] = "SY";
    CountryCode["Sz"] = "SZ";
    CountryCode["Tc"] = "TC";
    CountryCode["Td"] = "TD";
    CountryCode["Tf"] = "TF";
    CountryCode["Tg"] = "TG";
    CountryCode["Th"] = "TH";
    CountryCode["Tj"] = "TJ";
    CountryCode["Tk"] = "TK";
    CountryCode["Tl"] = "TL";
    CountryCode["Tm"] = "TM";
    CountryCode["Tn"] = "TN";
    CountryCode["To"] = "TO";
    CountryCode["Tr"] = "TR";
    CountryCode["Tt"] = "TT";
    CountryCode["Tv"] = "TV";
    CountryCode["Tw"] = "TW";
    CountryCode["Tz"] = "TZ";
    CountryCode["Ua"] = "UA";
    CountryCode["Ug"] = "UG";
    CountryCode["Um"] = "UM";
    CountryCode["Us"] = "US";
    CountryCode["Uy"] = "UY";
    CountryCode["Uz"] = "UZ";
    CountryCode["Va"] = "VA";
    CountryCode["Vc"] = "VC";
    CountryCode["Ve"] = "VE";
    CountryCode["Vg"] = "VG";
    CountryCode["Vi"] = "VI";
    CountryCode["Vn"] = "VN";
    CountryCode["Vu"] = "VU";
    CountryCode["Wf"] = "WF";
    CountryCode["Ws"] = "WS";
    CountryCode["Ye"] = "YE";
    CountryCode["Yt"] = "YT";
    CountryCode["Za"] = "ZA";
    CountryCode["Zm"] = "ZM";
    CountryCode["Zw"] = "ZW";
})(CountryCode || (CountryCode = {}));
var CustomerEventsEnum;
(function(CustomerEventsEnum) {
    CustomerEventsEnum["AccountCreated"] = "ACCOUNT_CREATED";
    CustomerEventsEnum["CustomerDeleted"] = "CUSTOMER_DELETED";
    CustomerEventsEnum["DigitalLinkDownloaded"] = "DIGITAL_LINK_DOWNLOADED";
    CustomerEventsEnum["EmailAssigned"] = "EMAIL_ASSIGNED";
    CustomerEventsEnum["EmailChanged"] = "EMAIL_CHANGED";
    CustomerEventsEnum["EmailChangedRequest"] = "EMAIL_CHANGED_REQUEST";
    CustomerEventsEnum["NameAssigned"] = "NAME_ASSIGNED";
    CustomerEventsEnum["NoteAdded"] = "NOTE_ADDED";
    CustomerEventsEnum["NoteAddedToOrder"] = "NOTE_ADDED_TO_ORDER";
    CustomerEventsEnum["PasswordChanged"] = "PASSWORD_CHANGED";
    CustomerEventsEnum["PasswordReset"] = "PASSWORD_RESET";
    CustomerEventsEnum["PasswordResetLinkSent"] = "PASSWORD_RESET_LINK_SENT";
    CustomerEventsEnum["PlacedOrder"] = "PLACED_ORDER";
})(CustomerEventsEnum || (CustomerEventsEnum = {}));
var DiscountErrorCode;
(function(DiscountErrorCode) {
    DiscountErrorCode["AlreadyExists"] = "ALREADY_EXISTS";
    DiscountErrorCode["CannotManageProductWithoutVariant"] = "CANNOT_MANAGE_PRODUCT_WITHOUT_VARIANT";
    DiscountErrorCode["DuplicatedInputItem"] = "DUPLICATED_INPUT_ITEM";
    DiscountErrorCode["GraphqlError"] = "GRAPHQL_ERROR";
    DiscountErrorCode["Invalid"] = "INVALID";
    DiscountErrorCode["NotFound"] = "NOT_FOUND";
    DiscountErrorCode["Required"] = "REQUIRED";
    DiscountErrorCode["Unique"] = "UNIQUE";
})(DiscountErrorCode || (DiscountErrorCode = {}));
var DiscountStatusEnum;
(function(DiscountStatusEnum) {
    DiscountStatusEnum["Active"] = "ACTIVE";
    DiscountStatusEnum["Expired"] = "EXPIRED";
    DiscountStatusEnum["Scheduled"] = "SCHEDULED";
})(DiscountStatusEnum || (DiscountStatusEnum = {}));
var DiscountValueTypeEnum;
(function(DiscountValueTypeEnum) {
    DiscountValueTypeEnum["Fixed"] = "FIXED";
    DiscountValueTypeEnum["Percentage"] = "PERCENTAGE";
})(DiscountValueTypeEnum || (DiscountValueTypeEnum = {}));
var DistanceUnitsEnum;
(function(DistanceUnitsEnum) {
    DistanceUnitsEnum["Cm"] = "CM";
    DistanceUnitsEnum["Ft"] = "FT";
    DistanceUnitsEnum["Inch"] = "INCH";
    DistanceUnitsEnum["Km"] = "KM";
    DistanceUnitsEnum["M"] = "M";
    DistanceUnitsEnum["Yd"] = "YD";
})(DistanceUnitsEnum || (DistanceUnitsEnum = {}));
var EventDeliveryAttemptSortField;
(function(EventDeliveryAttemptSortField) {
    EventDeliveryAttemptSortField[/** Sort event delivery attempts by created at. */ "CreatedAt"] = "CREATED_AT";
})(EventDeliveryAttemptSortField || (EventDeliveryAttemptSortField = {}));
var EventDeliverySortField;
(function(EventDeliverySortField) {
    EventDeliverySortField[/** Sort event deliveries by created at. */ "CreatedAt"] = "CREATED_AT";
})(EventDeliverySortField || (EventDeliverySortField = {}));
var EventDeliveryStatusEnum;
(function(EventDeliveryStatusEnum) {
    EventDeliveryStatusEnum["Failed"] = "FAILED";
    EventDeliveryStatusEnum["Pending"] = "PENDING";
    EventDeliveryStatusEnum["Success"] = "SUCCESS";
})(EventDeliveryStatusEnum || (EventDeliveryStatusEnum = {}));
var ExportErrorCode;
(function(ExportErrorCode) {
    ExportErrorCode["GraphqlError"] = "GRAPHQL_ERROR";
    ExportErrorCode["Invalid"] = "INVALID";
    ExportErrorCode["NotFound"] = "NOT_FOUND";
    ExportErrorCode["Required"] = "REQUIRED";
})(ExportErrorCode || (ExportErrorCode = {}));
var ExportEventsEnum;
(function(ExportEventsEnum) {
    ExportEventsEnum["ExportedFileSent"] = "EXPORTED_FILE_SENT";
    ExportEventsEnum["ExportDeleted"] = "EXPORT_DELETED";
    ExportEventsEnum["ExportFailed"] = "EXPORT_FAILED";
    ExportEventsEnum["ExportFailedInfoSent"] = "EXPORT_FAILED_INFO_SENT";
    ExportEventsEnum["ExportPending"] = "EXPORT_PENDING";
    ExportEventsEnum["ExportSuccess"] = "EXPORT_SUCCESS";
})(ExportEventsEnum || (ExportEventsEnum = {}));
var ExportFileSortField;
(function(ExportFileSortField) {
    ExportFileSortField["CreatedAt"] = "CREATED_AT";
    ExportFileSortField["LastModifiedAt"] = "LAST_MODIFIED_AT";
    ExportFileSortField["Status"] = "STATUS";
    ExportFileSortField["UpdatedAt"] = "UPDATED_AT";
})(ExportFileSortField || (ExportFileSortField = {}));
var ExportScope;
(function(ExportScope) {
    ExportScope[/** Export all products. */ "All"] = "ALL";
    ExportScope[/** Export the filtered products. */ "Filter"] = "FILTER";
    ExportScope[/** Export products with given ids. */ "Ids"] = "IDS";
})(ExportScope || (ExportScope = {}));
var ExternalNotificationErrorCodes;
(function(ExternalNotificationErrorCodes) {
    ExternalNotificationErrorCodes["ChannelInactive"] = "CHANNEL_INACTIVE";
    ExternalNotificationErrorCodes["InvalidModelType"] = "INVALID_MODEL_TYPE";
    ExternalNotificationErrorCodes["NotFound"] = "NOT_FOUND";
    ExternalNotificationErrorCodes["Required"] = "REQUIRED";
})(ExternalNotificationErrorCodes || (ExternalNotificationErrorCodes = {}));
var FileTypesEnum;
(function(FileTypesEnum) {
    FileTypesEnum["Csv"] = "CSV";
    FileTypesEnum["Xlsx"] = "XLSX";
})(FileTypesEnum || (FileTypesEnum = {}));
var FulfillmentStatus;
(function(FulfillmentStatus) {
    FulfillmentStatus["Canceled"] = "CANCELED";
    FulfillmentStatus["Fulfilled"] = "FULFILLED";
    FulfillmentStatus["Refunded"] = "REFUNDED";
    FulfillmentStatus["RefundedAndReturned"] = "REFUNDED_AND_RETURNED";
    FulfillmentStatus["Replaced"] = "REPLACED";
    FulfillmentStatus["Returned"] = "RETURNED";
    FulfillmentStatus["WaitingForApproval"] = "WAITING_FOR_APPROVAL";
})(FulfillmentStatus || (FulfillmentStatus = {}));
var GiftCardErrorCode;
(function(GiftCardErrorCode) {
    GiftCardErrorCode["AlreadyExists"] = "ALREADY_EXISTS";
    GiftCardErrorCode["DuplicatedInputItem"] = "DUPLICATED_INPUT_ITEM";
    GiftCardErrorCode["ExpiredGiftCard"] = "EXPIRED_GIFT_CARD";
    GiftCardErrorCode["GraphqlError"] = "GRAPHQL_ERROR";
    GiftCardErrorCode["Invalid"] = "INVALID";
    GiftCardErrorCode["NotFound"] = "NOT_FOUND";
    GiftCardErrorCode["Required"] = "REQUIRED";
    GiftCardErrorCode["Unique"] = "UNIQUE";
})(GiftCardErrorCode || (GiftCardErrorCode = {}));
var GiftCardEventsEnum;
(function(GiftCardEventsEnum) {
    GiftCardEventsEnum["Activated"] = "ACTIVATED";
    GiftCardEventsEnum["BalanceReset"] = "BALANCE_RESET";
    GiftCardEventsEnum["Bought"] = "BOUGHT";
    GiftCardEventsEnum["Deactivated"] = "DEACTIVATED";
    GiftCardEventsEnum["ExpiryDateUpdated"] = "EXPIRY_DATE_UPDATED";
    GiftCardEventsEnum["Issued"] = "ISSUED";
    GiftCardEventsEnum["NoteAdded"] = "NOTE_ADDED";
    GiftCardEventsEnum["Resent"] = "RESENT";
    GiftCardEventsEnum["SentToCustomer"] = "SENT_TO_CUSTOMER";
    GiftCardEventsEnum["TagsUpdated"] = "TAGS_UPDATED";
    GiftCardEventsEnum["Updated"] = "UPDATED";
    GiftCardEventsEnum["UsedInOrder"] = "USED_IN_ORDER";
})(GiftCardEventsEnum || (GiftCardEventsEnum = {}));
var GiftCardSettingsErrorCode;
(function(GiftCardSettingsErrorCode) {
    GiftCardSettingsErrorCode["GraphqlError"] = "GRAPHQL_ERROR";
    GiftCardSettingsErrorCode["Invalid"] = "INVALID";
    GiftCardSettingsErrorCode["Required"] = "REQUIRED";
})(GiftCardSettingsErrorCode || (GiftCardSettingsErrorCode = {}));
var GiftCardSettingsExpiryTypeEnum;
(function(GiftCardSettingsExpiryTypeEnum) {
    GiftCardSettingsExpiryTypeEnum["ExpiryPeriod"] = "EXPIRY_PERIOD";
    GiftCardSettingsExpiryTypeEnum["NeverExpire"] = "NEVER_EXPIRE";
})(GiftCardSettingsExpiryTypeEnum || (GiftCardSettingsExpiryTypeEnum = {}));
var GiftCardSortField;
(function(GiftCardSortField) {
    GiftCardSortField[/** Sort orders by current balance. */ "CurrentBalance"] = "CURRENT_BALANCE";
    GiftCardSortField[/** Sort orders by product. */ "Product"] = "PRODUCT";
    GiftCardSortField[/** Sort orders by used by. */ "UsedBy"] = "USED_BY";
})(GiftCardSortField || (GiftCardSortField = {}));
var InvoiceErrorCode;
(function(InvoiceErrorCode) {
    InvoiceErrorCode["EmailNotSet"] = "EMAIL_NOT_SET";
    InvoiceErrorCode["InvalidStatus"] = "INVALID_STATUS";
    InvoiceErrorCode["NotFound"] = "NOT_FOUND";
    InvoiceErrorCode["NotReady"] = "NOT_READY";
    InvoiceErrorCode["NoInvoicePlugin"] = "NO_INVOICE_PLUGIN";
    InvoiceErrorCode["NumberNotSet"] = "NUMBER_NOT_SET";
    InvoiceErrorCode["Required"] = "REQUIRED";
    InvoiceErrorCode["UrlNotSet"] = "URL_NOT_SET";
})(InvoiceErrorCode || (InvoiceErrorCode = {}));
var JobStatusEnum;
(function(JobStatusEnum) {
    JobStatusEnum["Deleted"] = "DELETED";
    JobStatusEnum["Failed"] = "FAILED";
    JobStatusEnum["Pending"] = "PENDING";
    JobStatusEnum["Success"] = "SUCCESS";
})(JobStatusEnum || (JobStatusEnum = {}));
var LanguageCodeEnum;
(function(LanguageCodeEnum) {
    LanguageCodeEnum["En"] = "EN";
    LanguageCodeEnum["Is"] = "IS";
})(LanguageCodeEnum || (LanguageCodeEnum = {}));
var MeasurementUnitsEnum;
(function(MeasurementUnitsEnum) {
    MeasurementUnitsEnum["AcreFt"] = "ACRE_FT";
    MeasurementUnitsEnum["AcreIn"] = "ACRE_IN";
    MeasurementUnitsEnum["Cm"] = "CM";
    MeasurementUnitsEnum["CubicCentimeter"] = "CUBIC_CENTIMETER";
    MeasurementUnitsEnum["CubicDecimeter"] = "CUBIC_DECIMETER";
    MeasurementUnitsEnum["CubicFoot"] = "CUBIC_FOOT";
    MeasurementUnitsEnum["CubicInch"] = "CUBIC_INCH";
    MeasurementUnitsEnum["CubicMeter"] = "CUBIC_METER";
    MeasurementUnitsEnum["CubicMillimeter"] = "CUBIC_MILLIMETER";
    MeasurementUnitsEnum["CubicYard"] = "CUBIC_YARD";
    MeasurementUnitsEnum["FlOz"] = "FL_OZ";
    MeasurementUnitsEnum["Ft"] = "FT";
    MeasurementUnitsEnum["G"] = "G";
    MeasurementUnitsEnum["Inch"] = "INCH";
    MeasurementUnitsEnum["Kg"] = "KG";
    MeasurementUnitsEnum["Km"] = "KM";
    MeasurementUnitsEnum["Lb"] = "LB";
    MeasurementUnitsEnum["Liter"] = "LITER";
    MeasurementUnitsEnum["M"] = "M";
    MeasurementUnitsEnum["Oz"] = "OZ";
    MeasurementUnitsEnum["Pint"] = "PINT";
    MeasurementUnitsEnum["Qt"] = "QT";
    MeasurementUnitsEnum["SqCm"] = "SQ_CM";
    MeasurementUnitsEnum["SqFt"] = "SQ_FT";
    MeasurementUnitsEnum["SqInch"] = "SQ_INCH";
    MeasurementUnitsEnum["SqKm"] = "SQ_KM";
    MeasurementUnitsEnum["SqM"] = "SQ_M";
    MeasurementUnitsEnum["SqYd"] = "SQ_YD";
    MeasurementUnitsEnum["Tonne"] = "TONNE";
    MeasurementUnitsEnum["Yd"] = "YD";
})(MeasurementUnitsEnum || (MeasurementUnitsEnum = {}));
var MenuErrorCode;
(function(MenuErrorCode) {
    MenuErrorCode["CannotAssignNode"] = "CANNOT_ASSIGN_NODE";
    MenuErrorCode["GraphqlError"] = "GRAPHQL_ERROR";
    MenuErrorCode["Invalid"] = "INVALID";
    MenuErrorCode["InvalidMenuItem"] = "INVALID_MENU_ITEM";
    MenuErrorCode["NotFound"] = "NOT_FOUND";
    MenuErrorCode["NoMenuItemProvided"] = "NO_MENU_ITEM_PROVIDED";
    MenuErrorCode["Required"] = "REQUIRED";
    MenuErrorCode["TooManyMenuItems"] = "TOO_MANY_MENU_ITEMS";
    MenuErrorCode["Unique"] = "UNIQUE";
})(MenuErrorCode || (MenuErrorCode = {}));
var MenuItemsSortField;
(function(MenuItemsSortField) {
    MenuItemsSortField[/** Sort menu items by name. */ "Name"] = "NAME";
})(MenuItemsSortField || (MenuItemsSortField = {}));
var MenuSortField;
(function(MenuSortField) {
    MenuSortField[/** Sort menus by items count. */ "ItemsCount"] = "ITEMS_COUNT";
    MenuSortField[/** Sort menus by name. */ "Name"] = "NAME";
})(MenuSortField || (MenuSortField = {}));
var MetadataErrorCode;
(function(MetadataErrorCode) {
    MetadataErrorCode["GraphqlError"] = "GRAPHQL_ERROR";
    MetadataErrorCode["Invalid"] = "INVALID";
    MetadataErrorCode["NotFound"] = "NOT_FOUND";
    MetadataErrorCode["NotUpdated"] = "NOT_UPDATED";
    MetadataErrorCode["Required"] = "REQUIRED";
})(MetadataErrorCode || (MetadataErrorCode = {}));
var NavigationType;
(function(NavigationType) {
    NavigationType[/** Main storefront navigation. */ "Main"] = "MAIN";
    NavigationType[/** Secondary storefront navigation. */ "Secondary"] = "SECONDARY";
})(NavigationType || (NavigationType = {}));
var OrderAction;
(function(OrderAction) {
    OrderAction[/** Represents the capture action. */ "Capture"] = "CAPTURE";
    OrderAction[/** Represents a mark-as-paid action. */ "MarkAsPaid"] = "MARK_AS_PAID";
    OrderAction[/** Represents a refund action. */ "Refund"] = "REFUND";
    OrderAction[/** Represents a void action. */ "Void"] = "VOID";
})(OrderAction || (OrderAction = {}));
var OrderDirection;
(function(OrderDirection) {
    OrderDirection[/** Specifies an ascending sort order. */ "Asc"] = "ASC";
    OrderDirection[/** Specifies a descending sort order. */ "Desc"] = "DESC";
})(OrderDirection || (OrderDirection = {}));
var OrderDiscountType;
(function(OrderDiscountType) {
    OrderDiscountType["Manual"] = "MANUAL";
    OrderDiscountType["Voucher"] = "VOUCHER";
})(OrderDiscountType || (OrderDiscountType = {}));
var OrderErrorCode;
(function(OrderErrorCode) {
    OrderErrorCode["BillingAddressNotSet"] = "BILLING_ADDRESS_NOT_SET";
    OrderErrorCode["CannotCancelFulfillment"] = "CANNOT_CANCEL_FULFILLMENT";
    OrderErrorCode["CannotCancelOrder"] = "CANNOT_CANCEL_ORDER";
    OrderErrorCode["CannotDelete"] = "CANNOT_DELETE";
    OrderErrorCode["CannotDiscount"] = "CANNOT_DISCOUNT";
    OrderErrorCode["CannotFulfillUnpaidOrder"] = "CANNOT_FULFILL_UNPAID_ORDER";
    OrderErrorCode["CannotRefund"] = "CANNOT_REFUND";
    OrderErrorCode["CaptureInactivePayment"] = "CAPTURE_INACTIVE_PAYMENT";
    OrderErrorCode["ChannelInactive"] = "CHANNEL_INACTIVE";
    OrderErrorCode["DuplicatedInputItem"] = "DUPLICATED_INPUT_ITEM";
    OrderErrorCode["FulfillOrderLine"] = "FULFILL_ORDER_LINE";
    OrderErrorCode["GiftCardLine"] = "GIFT_CARD_LINE";
    OrderErrorCode["GraphqlError"] = "GRAPHQL_ERROR";
    OrderErrorCode["InsufficientStock"] = "INSUFFICIENT_STOCK";
    OrderErrorCode["Invalid"] = "INVALID";
    OrderErrorCode["InvalidQuantity"] = "INVALID_QUANTITY";
    OrderErrorCode["NotAvailableInChannel"] = "NOT_AVAILABLE_IN_CHANNEL";
    OrderErrorCode["NotEditable"] = "NOT_EDITABLE";
    OrderErrorCode["NotFound"] = "NOT_FOUND";
    OrderErrorCode["OrderNoShippingAddress"] = "ORDER_NO_SHIPPING_ADDRESS";
    OrderErrorCode["PaymentError"] = "PAYMENT_ERROR";
    OrderErrorCode["PaymentMissing"] = "PAYMENT_MISSING";
    OrderErrorCode["ProductNotPublished"] = "PRODUCT_NOT_PUBLISHED";
    OrderErrorCode["ProductUnavailableForPurchase"] = "PRODUCT_UNAVAILABLE_FOR_PURCHASE";
    OrderErrorCode["Required"] = "REQUIRED";
    OrderErrorCode["ShippingMethodNotApplicable"] = "SHIPPING_METHOD_NOT_APPLICABLE";
    OrderErrorCode["ShippingMethodRequired"] = "SHIPPING_METHOD_REQUIRED";
    OrderErrorCode["TaxError"] = "TAX_ERROR";
    OrderErrorCode["Unique"] = "UNIQUE";
    OrderErrorCode["VoidInactivePayment"] = "VOID_INACTIVE_PAYMENT";
    OrderErrorCode["ZeroQuantity"] = "ZERO_QUANTITY";
})(OrderErrorCode || (OrderErrorCode = {}));
var OrderEventsEmailsEnum;
(function(OrderEventsEmailsEnum) {
    OrderEventsEmailsEnum["Confirmed"] = "CONFIRMED";
    OrderEventsEmailsEnum["DigitalLinks"] = "DIGITAL_LINKS";
    OrderEventsEmailsEnum["FulfillmentConfirmation"] = "FULFILLMENT_CONFIRMATION";
    OrderEventsEmailsEnum["OrderCancel"] = "ORDER_CANCEL";
    OrderEventsEmailsEnum["OrderConfirmation"] = "ORDER_CONFIRMATION";
    OrderEventsEmailsEnum["OrderRefund"] = "ORDER_REFUND";
    OrderEventsEmailsEnum["PaymentConfirmation"] = "PAYMENT_CONFIRMATION";
    OrderEventsEmailsEnum["ShippingConfirmation"] = "SHIPPING_CONFIRMATION";
    OrderEventsEmailsEnum["TrackingUpdated"] = "TRACKING_UPDATED";
})(OrderEventsEmailsEnum || (OrderEventsEmailsEnum = {}));
var OrderEventsEnum;
(function(OrderEventsEnum) {
    OrderEventsEnum["AddedProducts"] = "ADDED_PRODUCTS";
    OrderEventsEnum["Canceled"] = "CANCELED";
    OrderEventsEnum["Confirmed"] = "CONFIRMED";
    OrderEventsEnum["DraftCreated"] = "DRAFT_CREATED";
    OrderEventsEnum["DraftCreatedFromReplace"] = "DRAFT_CREATED_FROM_REPLACE";
    OrderEventsEnum["EmailSent"] = "EMAIL_SENT";
    OrderEventsEnum["ExternalServiceNotification"] = "EXTERNAL_SERVICE_NOTIFICATION";
    OrderEventsEnum["FulfillmentAwaitsApproval"] = "FULFILLMENT_AWAITS_APPROVAL";
    OrderEventsEnum["FulfillmentCanceled"] = "FULFILLMENT_CANCELED";
    OrderEventsEnum["FulfillmentFulfilledItems"] = "FULFILLMENT_FULFILLED_ITEMS";
    OrderEventsEnum["FulfillmentRefunded"] = "FULFILLMENT_REFUNDED";
    OrderEventsEnum["FulfillmentReplaced"] = "FULFILLMENT_REPLACED";
    OrderEventsEnum["FulfillmentRestockedItems"] = "FULFILLMENT_RESTOCKED_ITEMS";
    OrderEventsEnum["FulfillmentReturned"] = "FULFILLMENT_RETURNED";
    OrderEventsEnum["InvoiceGenerated"] = "INVOICE_GENERATED";
    OrderEventsEnum["InvoiceRequested"] = "INVOICE_REQUESTED";
    OrderEventsEnum["InvoiceSent"] = "INVOICE_SENT";
    OrderEventsEnum["InvoiceUpdated"] = "INVOICE_UPDATED";
    OrderEventsEnum["NoteAdded"] = "NOTE_ADDED";
    OrderEventsEnum["OrderDiscountAdded"] = "ORDER_DISCOUNT_ADDED";
    OrderEventsEnum["OrderDiscountAutomaticallyUpdated"] = "ORDER_DISCOUNT_AUTOMATICALLY_UPDATED";
    OrderEventsEnum["OrderDiscountDeleted"] = "ORDER_DISCOUNT_DELETED";
    OrderEventsEnum["OrderDiscountUpdated"] = "ORDER_DISCOUNT_UPDATED";
    OrderEventsEnum["OrderFullyPaid"] = "ORDER_FULLY_PAID";
    OrderEventsEnum["OrderLineDiscountRemoved"] = "ORDER_LINE_DISCOUNT_REMOVED";
    OrderEventsEnum["OrderLineDiscountUpdated"] = "ORDER_LINE_DISCOUNT_UPDATED";
    OrderEventsEnum["OrderLineProductDeleted"] = "ORDER_LINE_PRODUCT_DELETED";
    OrderEventsEnum["OrderLineVariantDeleted"] = "ORDER_LINE_VARIANT_DELETED";
    OrderEventsEnum["OrderMarkedAsPaid"] = "ORDER_MARKED_AS_PAID";
    OrderEventsEnum["OrderReplacementCreated"] = "ORDER_REPLACEMENT_CREATED";
    OrderEventsEnum["Other"] = "OTHER";
    OrderEventsEnum["OversoldItems"] = "OVERSOLD_ITEMS";
    OrderEventsEnum["PaymentAuthorized"] = "PAYMENT_AUTHORIZED";
    OrderEventsEnum["PaymentCaptured"] = "PAYMENT_CAPTURED";
    OrderEventsEnum["PaymentFailed"] = "PAYMENT_FAILED";
    OrderEventsEnum["PaymentRefunded"] = "PAYMENT_REFUNDED";
    OrderEventsEnum["PaymentVoided"] = "PAYMENT_VOIDED";
    OrderEventsEnum["Placed"] = "PLACED";
    OrderEventsEnum["PlacedFromDraft"] = "PLACED_FROM_DRAFT";
    OrderEventsEnum["RemovedProducts"] = "REMOVED_PRODUCTS";
    OrderEventsEnum["TrackingUpdated"] = "TRACKING_UPDATED";
    OrderEventsEnum["UpdatedAddress"] = "UPDATED_ADDRESS";
})(OrderEventsEnum || (OrderEventsEnum = {}));
var OrderOriginEnum;
(function(OrderOriginEnum) {
    OrderOriginEnum["Checkout"] = "CHECKOUT";
    OrderOriginEnum["Draft"] = "DRAFT";
    OrderOriginEnum["Reissue"] = "REISSUE";
})(OrderOriginEnum || (OrderOriginEnum = {}));
var OrderSettingsErrorCode;
(function(OrderSettingsErrorCode) {
    OrderSettingsErrorCode["Invalid"] = "INVALID";
})(OrderSettingsErrorCode || (OrderSettingsErrorCode = {}));
var OrderSortField;
(function(OrderSortField) {
    OrderSortField[/**
   * Sort orders by creation date.
   *
   * DEPRECATED: this field will be removed in Saleor 4.0.
   */ "CreatedAt"] = "CREATED_AT";
    OrderSortField[/**
   * Sort orders by creation date.
   *
   * DEPRECATED: this field will be removed in Saleor 4.0.
   */ "CreationDate"] = "CREATION_DATE";
    OrderSortField[/** Sort orders by customer. */ "Customer"] = "CUSTOMER";
    OrderSortField[/** Sort orders by fulfillment status. */ "FulfillmentStatus"] = "FULFILLMENT_STATUS";
    OrderSortField[/** Sort orders by last modified at. */ "LastModifiedAt"] = "LAST_MODIFIED_AT";
    OrderSortField[/** Sort orders by number. */ "Number"] = "NUMBER";
    OrderSortField[/** Sort orders by payment. */ "Payment"] = "PAYMENT";
})(OrderSortField || (OrderSortField = {}));
var OrderStatus;
(function(OrderStatus) {
    OrderStatus["Canceled"] = "CANCELED";
    OrderStatus["Draft"] = "DRAFT";
    OrderStatus["Fulfilled"] = "FULFILLED";
    OrderStatus["PartiallyFulfilled"] = "PARTIALLY_FULFILLED";
    OrderStatus["PartiallyReturned"] = "PARTIALLY_RETURNED";
    OrderStatus["Returned"] = "RETURNED";
    OrderStatus["Unconfirmed"] = "UNCONFIRMED";
    OrderStatus["Unfulfilled"] = "UNFULFILLED";
})(OrderStatus || (OrderStatus = {}));
var OrderStatusFilter;
(function(OrderStatusFilter) {
    OrderStatusFilter["Canceled"] = "CANCELED";
    OrderStatusFilter["Fulfilled"] = "FULFILLED";
    OrderStatusFilter["PartiallyFulfilled"] = "PARTIALLY_FULFILLED";
    OrderStatusFilter["ReadyToCapture"] = "READY_TO_CAPTURE";
    OrderStatusFilter["ReadyToFulfill"] = "READY_TO_FULFILL";
    OrderStatusFilter["Unconfirmed"] = "UNCONFIRMED";
    OrderStatusFilter["Unfulfilled"] = "UNFULFILLED";
})(OrderStatusFilter || (OrderStatusFilter = {}));
var PageErrorCode;
(function(PageErrorCode) {
    PageErrorCode["AttributeAlreadyAssigned"] = "ATTRIBUTE_ALREADY_ASSIGNED";
    PageErrorCode["DuplicatedInputItem"] = "DUPLICATED_INPUT_ITEM";
    PageErrorCode["GraphqlError"] = "GRAPHQL_ERROR";
    PageErrorCode["Invalid"] = "INVALID";
    PageErrorCode["NotFound"] = "NOT_FOUND";
    PageErrorCode["Required"] = "REQUIRED";
    PageErrorCode["Unique"] = "UNIQUE";
})(PageErrorCode || (PageErrorCode = {}));
var PageSortField;
(function(PageSortField) {
    PageSortField[/** Sort pages by creation date. */ "CreationDate"] = "CREATION_DATE";
    PageSortField[/** Sort pages by publication date. */ "PublicationDate"] = "PUBLICATION_DATE";
    PageSortField[/** Sort pages by slug. */ "Slug"] = "SLUG";
    PageSortField[/** Sort pages by title. */ "Title"] = "TITLE";
    PageSortField[/** Sort pages by visibility. */ "Visibility"] = "VISIBILITY";
})(PageSortField || (PageSortField = {}));
var PageTypeSortField;
(function(PageTypeSortField) {
    PageTypeSortField[/** Sort page types by name. */ "Name"] = "NAME";
    PageTypeSortField[/** Sort page types by slug. */ "Slug"] = "SLUG";
})(PageTypeSortField || (PageTypeSortField = {}));
var PaymentChargeStatusEnum;
(function(PaymentChargeStatusEnum) {
    PaymentChargeStatusEnum["Cancelled"] = "CANCELLED";
    PaymentChargeStatusEnum["FullyCharged"] = "FULLY_CHARGED";
    PaymentChargeStatusEnum["FullyRefunded"] = "FULLY_REFUNDED";
    PaymentChargeStatusEnum["NotCharged"] = "NOT_CHARGED";
    PaymentChargeStatusEnum["PartiallyCharged"] = "PARTIALLY_CHARGED";
    PaymentChargeStatusEnum["PartiallyRefunded"] = "PARTIALLY_REFUNDED";
    PaymentChargeStatusEnum["Pending"] = "PENDING";
    PaymentChargeStatusEnum["Refused"] = "REFUSED";
})(PaymentChargeStatusEnum || (PaymentChargeStatusEnum = {}));
var PaymentErrorCode;
(function(PaymentErrorCode) {
    PaymentErrorCode["BalanceCheckError"] = "BALANCE_CHECK_ERROR";
    PaymentErrorCode["BillingAddressNotSet"] = "BILLING_ADDRESS_NOT_SET";
    PaymentErrorCode["ChannelInactive"] = "CHANNEL_INACTIVE";
    PaymentErrorCode["CheckoutEmailNotSet"] = "CHECKOUT_EMAIL_NOT_SET";
    PaymentErrorCode["GraphqlError"] = "GRAPHQL_ERROR";
    PaymentErrorCode["Invalid"] = "INVALID";
    PaymentErrorCode["InvalidShippingMethod"] = "INVALID_SHIPPING_METHOD";
    PaymentErrorCode["NotFound"] = "NOT_FOUND";
    PaymentErrorCode["NotSupportedGateway"] = "NOT_SUPPORTED_GATEWAY";
    PaymentErrorCode["NoCheckoutLines"] = "NO_CHECKOUT_LINES";
    PaymentErrorCode["PartialPaymentNotAllowed"] = "PARTIAL_PAYMENT_NOT_ALLOWED";
    PaymentErrorCode["PaymentError"] = "PAYMENT_ERROR";
    PaymentErrorCode["Required"] = "REQUIRED";
    PaymentErrorCode["ShippingAddressNotSet"] = "SHIPPING_ADDRESS_NOT_SET";
    PaymentErrorCode["ShippingMethodNotSet"] = "SHIPPING_METHOD_NOT_SET";
    PaymentErrorCode["UnavailableVariantInChannel"] = "UNAVAILABLE_VARIANT_IN_CHANNEL";
    PaymentErrorCode["Unique"] = "UNIQUE";
})(PaymentErrorCode || (PaymentErrorCode = {}));
var PermissionEnum;
(function(PermissionEnum) {
    PermissionEnum["HandlePayments"] = "HANDLE_PAYMENTS";
    PermissionEnum["ImpersonateUser"] = "IMPERSONATE_USER";
    PermissionEnum["ManageApps"] = "MANAGE_APPS";
    PermissionEnum["ManageChannels"] = "MANAGE_CHANNELS";
    PermissionEnum["ManageCheckouts"] = "MANAGE_CHECKOUTS";
    PermissionEnum["ManageDiscounts"] = "MANAGE_DISCOUNTS";
    PermissionEnum["ManageGiftCard"] = "MANAGE_GIFT_CARD";
    PermissionEnum["ManageMenus"] = "MANAGE_MENUS";
    PermissionEnum["ManageOrders"] = "MANAGE_ORDERS";
    PermissionEnum["ManagePages"] = "MANAGE_PAGES";
    PermissionEnum["ManagePageTypesAndAttributes"] = "MANAGE_PAGE_TYPES_AND_ATTRIBUTES";
    PermissionEnum["ManagePlugins"] = "MANAGE_PLUGINS";
    PermissionEnum["ManageProducts"] = "MANAGE_PRODUCTS";
    PermissionEnum["ManageProductTypesAndAttributes"] = "MANAGE_PRODUCT_TYPES_AND_ATTRIBUTES";
    PermissionEnum["ManageSettings"] = "MANAGE_SETTINGS";
    PermissionEnum["ManageShipping"] = "MANAGE_SHIPPING";
    PermissionEnum["ManageStaff"] = "MANAGE_STAFF";
    PermissionEnum["ManageTranslations"] = "MANAGE_TRANSLATIONS";
    PermissionEnum["ManageUsers"] = "MANAGE_USERS";
})(PermissionEnum || (PermissionEnum = {}));
var PermissionGroupErrorCode;
(function(PermissionGroupErrorCode) {
    PermissionGroupErrorCode["AssignNonStaffMember"] = "ASSIGN_NON_STAFF_MEMBER";
    PermissionGroupErrorCode["CannotRemoveFromLastGroup"] = "CANNOT_REMOVE_FROM_LAST_GROUP";
    PermissionGroupErrorCode["DuplicatedInputItem"] = "DUPLICATED_INPUT_ITEM";
    PermissionGroupErrorCode["LeftNotManageablePermission"] = "LEFT_NOT_MANAGEABLE_PERMISSION";
    PermissionGroupErrorCode["OutOfScopePermission"] = "OUT_OF_SCOPE_PERMISSION";
    PermissionGroupErrorCode["OutOfScopeUser"] = "OUT_OF_SCOPE_USER";
    PermissionGroupErrorCode["Required"] = "REQUIRED";
    PermissionGroupErrorCode["Unique"] = "UNIQUE";
})(PermissionGroupErrorCode || (PermissionGroupErrorCode = {}));
var PermissionGroupSortField;
(function(PermissionGroupSortField) {
    PermissionGroupSortField[/** Sort permission group accounts by name. */ "Name"] = "NAME";
})(PermissionGroupSortField || (PermissionGroupSortField = {}));
var PluginConfigurationType;
(function(PluginConfigurationType) {
    PluginConfigurationType["Global"] = "GLOBAL";
    PluginConfigurationType["PerChannel"] = "PER_CHANNEL";
})(PluginConfigurationType || (PluginConfigurationType = {}));
var PluginErrorCode;
(function(PluginErrorCode) {
    PluginErrorCode["GraphqlError"] = "GRAPHQL_ERROR";
    PluginErrorCode["Invalid"] = "INVALID";
    PluginErrorCode["NotFound"] = "NOT_FOUND";
    PluginErrorCode["PluginMisconfigured"] = "PLUGIN_MISCONFIGURED";
    PluginErrorCode["Required"] = "REQUIRED";
    PluginErrorCode["Unique"] = "UNIQUE";
})(PluginErrorCode || (PluginErrorCode = {}));
var PluginSortField;
(function(PluginSortField) {
    PluginSortField["IsActive"] = "IS_ACTIVE";
    PluginSortField["Name"] = "NAME";
})(PluginSortField || (PluginSortField = {}));
var PostalCodeRuleInclusionTypeEnum;
(function(PostalCodeRuleInclusionTypeEnum) {
    PostalCodeRuleInclusionTypeEnum["Exclude"] = "EXCLUDE";
    PostalCodeRuleInclusionTypeEnum["Include"] = "INCLUDE";
})(PostalCodeRuleInclusionTypeEnum || (PostalCodeRuleInclusionTypeEnum = {}));
var ProductAttributeType;
(function(ProductAttributeType) {
    ProductAttributeType["Product"] = "PRODUCT";
    ProductAttributeType["Variant"] = "VARIANT";
})(ProductAttributeType || (ProductAttributeType = {}));
var ProductErrorCode;
(function(ProductErrorCode) {
    ProductErrorCode["AlreadyExists"] = "ALREADY_EXISTS";
    ProductErrorCode["AttributeAlreadyAssigned"] = "ATTRIBUTE_ALREADY_ASSIGNED";
    ProductErrorCode["AttributeCannotBeAssigned"] = "ATTRIBUTE_CANNOT_BE_ASSIGNED";
    ProductErrorCode["AttributeVariantsDisabled"] = "ATTRIBUTE_VARIANTS_DISABLED";
    ProductErrorCode["CannotManageProductWithoutVariant"] = "CANNOT_MANAGE_PRODUCT_WITHOUT_VARIANT";
    ProductErrorCode["DuplicatedInputItem"] = "DUPLICATED_INPUT_ITEM";
    ProductErrorCode["GraphqlError"] = "GRAPHQL_ERROR";
    ProductErrorCode["Invalid"] = "INVALID";
    ProductErrorCode["NotFound"] = "NOT_FOUND";
    ProductErrorCode["NotProductsImage"] = "NOT_PRODUCTS_IMAGE";
    ProductErrorCode["NotProductsVariant"] = "NOT_PRODUCTS_VARIANT";
    ProductErrorCode["PreorderVariantCannotBeDeactivated"] = "PREORDER_VARIANT_CANNOT_BE_DEACTIVATED";
    ProductErrorCode["ProductNotAssignedToChannel"] = "PRODUCT_NOT_ASSIGNED_TO_CHANNEL";
    ProductErrorCode["ProductWithoutCategory"] = "PRODUCT_WITHOUT_CATEGORY";
    ProductErrorCode["Required"] = "REQUIRED";
    ProductErrorCode["Unique"] = "UNIQUE";
    ProductErrorCode["UnsupportedMediaProvider"] = "UNSUPPORTED_MEDIA_PROVIDER";
    ProductErrorCode["VariantNoDigitalContent"] = "VARIANT_NO_DIGITAL_CONTENT";
})(ProductErrorCode || (ProductErrorCode = {}));
var ProductFieldEnum;
(function(ProductFieldEnum) {
    ProductFieldEnum["Category"] = "CATEGORY";
    ProductFieldEnum["ChargeTaxes"] = "CHARGE_TAXES";
    ProductFieldEnum["Collections"] = "COLLECTIONS";
    ProductFieldEnum["Description"] = "DESCRIPTION";
    ProductFieldEnum["Name"] = "NAME";
    ProductFieldEnum["ProductMedia"] = "PRODUCT_MEDIA";
    ProductFieldEnum["ProductType"] = "PRODUCT_TYPE";
    ProductFieldEnum["ProductWeight"] = "PRODUCT_WEIGHT";
    ProductFieldEnum["VariantId"] = "VARIANT_ID";
    ProductFieldEnum["VariantMedia"] = "VARIANT_MEDIA";
    ProductFieldEnum["VariantSku"] = "VARIANT_SKU";
    ProductFieldEnum["VariantWeight"] = "VARIANT_WEIGHT";
})(ProductFieldEnum || (ProductFieldEnum = {}));
var ProductMediaType;
(function(ProductMediaType) {
    ProductMediaType["Image"] = "IMAGE";
    ProductMediaType["Video"] = "VIDEO";
})(ProductMediaType || (ProductMediaType = {}));
var ProductOrderField;
(function(ProductOrderField) {
    ProductOrderField[/** Sort products by collection. Note: This option is available only for the `Collection.products` query. */ "Collection"] = "COLLECTION";
    ProductOrderField[/** Sort products by update date. */ "Date"] = "DATE";
    ProductOrderField[/** Sort products by update date. */ "LastModified"] = "LAST_MODIFIED";
    ProductOrderField[/** Sort products by update date. */ "LastModifiedAt"] = "LAST_MODIFIED_AT";
    ProductOrderField[/** Sort products by a minimal price of a product's variant. */ "MinimalPrice"] = "MINIMAL_PRICE";
    ProductOrderField[/** Sort products by name. */ "Name"] = "NAME";
    ProductOrderField[/** Sort products by price. */ "Price"] = "PRICE";
    ProductOrderField[/** Sort products by publication date. */ "PublicationDate"] = "PUBLICATION_DATE";
    ProductOrderField[/** Sort products by publication status. */ "Published"] = "PUBLISHED";
    ProductOrderField[/** Sort products by publication date. */ "PublishedAt"] = "PUBLISHED_AT";
    ProductOrderField[/** Sort products by name. */ "Rank"] = "RANK";
    ProductOrderField[/** Sort products by rating. */ "Rating"] = "RATING";
    ProductOrderField[/** Sort products by type. */ "Type"] = "TYPE";
})(ProductOrderField || (ProductOrderField = {}));
var ProductTypeConfigurable;
(function(ProductTypeConfigurable) {
    ProductTypeConfigurable["Configurable"] = "CONFIGURABLE";
    ProductTypeConfigurable["Simple"] = "SIMPLE";
})(ProductTypeConfigurable || (ProductTypeConfigurable = {}));
var ProductTypeEnum;
(function(ProductTypeEnum) {
    ProductTypeEnum["Digital"] = "DIGITAL";
    ProductTypeEnum["Shippable"] = "SHIPPABLE";
})(ProductTypeEnum || (ProductTypeEnum = {}));
var ProductTypeKindEnum;
(function(ProductTypeKindEnum) {
    ProductTypeKindEnum["GiftCard"] = "GIFT_CARD";
    ProductTypeKindEnum["Normal"] = "NORMAL";
})(ProductTypeKindEnum || (ProductTypeKindEnum = {}));
var ProductTypeSortField;
(function(ProductTypeSortField) {
    ProductTypeSortField[/** Sort products by type. */ "Digital"] = "DIGITAL";
    ProductTypeSortField[/** Sort products by name. */ "Name"] = "NAME";
    ProductTypeSortField[/** Sort products by shipping. */ "ShippingRequired"] = "SHIPPING_REQUIRED";
})(ProductTypeSortField || (ProductTypeSortField = {}));
var ProductVariantSortField;
(function(ProductVariantSortField) {
    ProductVariantSortField[/** Sort products variants by last modified at. */ "LastModifiedAt"] = "LAST_MODIFIED_AT";
})(ProductVariantSortField || (ProductVariantSortField = {}));
var ReportingPeriod;
(function(ReportingPeriod) {
    ReportingPeriod["ThisMonth"] = "THIS_MONTH";
    ReportingPeriod["Today"] = "TODAY";
})(ReportingPeriod || (ReportingPeriod = {}));
var SaleSortField;
(function(SaleSortField) {
    SaleSortField[/** Sort sales by created at. */ "CreatedAt"] = "CREATED_AT";
    SaleSortField[/** Sort sales by end date. */ "EndDate"] = "END_DATE";
    SaleSortField[/** Sort sales by last modified at. */ "LastModifiedAt"] = "LAST_MODIFIED_AT";
    SaleSortField[/** Sort sales by name. */ "Name"] = "NAME";
    SaleSortField[/** Sort sales by start date. */ "StartDate"] = "START_DATE";
    SaleSortField[/** Sort sales by type. */ "Type"] = "TYPE";
    SaleSortField[/** Sort sales by value. */ "Value"] = "VALUE";
})(SaleSortField || (SaleSortField = {}));
var SaleType;
(function(SaleType) {
    SaleType["Fixed"] = "FIXED";
    SaleType["Percentage"] = "PERCENTAGE";
})(SaleType || (SaleType = {}));
var ShippingErrorCode;
(function(ShippingErrorCode) {
    ShippingErrorCode["AlreadyExists"] = "ALREADY_EXISTS";
    ShippingErrorCode["DuplicatedInputItem"] = "DUPLICATED_INPUT_ITEM";
    ShippingErrorCode["GraphqlError"] = "GRAPHQL_ERROR";
    ShippingErrorCode["Invalid"] = "INVALID";
    ShippingErrorCode["MaxLessThanMin"] = "MAX_LESS_THAN_MIN";
    ShippingErrorCode["NotFound"] = "NOT_FOUND";
    ShippingErrorCode["Required"] = "REQUIRED";
    ShippingErrorCode["Unique"] = "UNIQUE";
})(ShippingErrorCode || (ShippingErrorCode = {}));
var ShippingMethodTypeEnum;
(function(ShippingMethodTypeEnum) {
    ShippingMethodTypeEnum["Price"] = "PRICE";
    ShippingMethodTypeEnum["Weight"] = "WEIGHT";
})(ShippingMethodTypeEnum || (ShippingMethodTypeEnum = {}));
var ShopErrorCode;
(function(ShopErrorCode) {
    ShopErrorCode["AlreadyExists"] = "ALREADY_EXISTS";
    ShopErrorCode["CannotFetchTaxRates"] = "CANNOT_FETCH_TAX_RATES";
    ShopErrorCode["GraphqlError"] = "GRAPHQL_ERROR";
    ShopErrorCode["Invalid"] = "INVALID";
    ShopErrorCode["NotFound"] = "NOT_FOUND";
    ShopErrorCode["Required"] = "REQUIRED";
    ShopErrorCode["Unique"] = "UNIQUE";
})(ShopErrorCode || (ShopErrorCode = {}));
var StaffMemberStatus;
(function(StaffMemberStatus) {
    StaffMemberStatus[/** User account has been activated. */ "Active"] = "ACTIVE";
    StaffMemberStatus[/** User account has not been activated yet. */ "Deactivated"] = "DEACTIVATED";
})(StaffMemberStatus || (StaffMemberStatus = {}));
var StockAvailability;
(function(StockAvailability) {
    StockAvailability["InStock"] = "IN_STOCK";
    StockAvailability["OutOfStock"] = "OUT_OF_STOCK";
})(StockAvailability || (StockAvailability = {}));
var StockErrorCode;
(function(StockErrorCode) {
    StockErrorCode["AlreadyExists"] = "ALREADY_EXISTS";
    StockErrorCode["GraphqlError"] = "GRAPHQL_ERROR";
    StockErrorCode["Invalid"] = "INVALID";
    StockErrorCode["NotFound"] = "NOT_FOUND";
    StockErrorCode["Required"] = "REQUIRED";
    StockErrorCode["Unique"] = "UNIQUE";
})(StockErrorCode || (StockErrorCode = {}));
var StorePaymentMethodEnum;
(function(StorePaymentMethodEnum) {
    StorePaymentMethodEnum[/** Storage is disabled. The payment is not stored. */ "None"] = "NONE";
    StorePaymentMethodEnum[/** Off session storage type. The payment is stored to be reused even if the customer is absent. */ "OffSession"] = "OFF_SESSION";
    StorePaymentMethodEnum[/** On session storage type. The payment is stored only to be reused when the customer is present in the checkout flow. */ "OnSession"] = "ON_SESSION";
})(StorePaymentMethodEnum || (StorePaymentMethodEnum = {}));
var TimePeriodTypeEnum;
(function(TimePeriodTypeEnum) {
    TimePeriodTypeEnum["Day"] = "DAY";
    TimePeriodTypeEnum["Month"] = "MONTH";
    TimePeriodTypeEnum["Week"] = "WEEK";
    TimePeriodTypeEnum["Year"] = "YEAR";
})(TimePeriodTypeEnum || (TimePeriodTypeEnum = {}));
var TransactionKind;
(function(TransactionKind) {
    TransactionKind["ActionToConfirm"] = "ACTION_TO_CONFIRM";
    TransactionKind["Auth"] = "AUTH";
    TransactionKind["Cancel"] = "CANCEL";
    TransactionKind["Capture"] = "CAPTURE";
    TransactionKind["Confirm"] = "CONFIRM";
    TransactionKind["External"] = "EXTERNAL";
    TransactionKind["Pending"] = "PENDING";
    TransactionKind["Refund"] = "REFUND";
    TransactionKind["RefundOngoing"] = "REFUND_ONGOING";
    TransactionKind["Void"] = "VOID";
})(TransactionKind || (TransactionKind = {}));
var TranslatableKinds;
(function(TranslatableKinds) {
    TranslatableKinds["Attribute"] = "ATTRIBUTE";
    TranslatableKinds["AttributeValue"] = "ATTRIBUTE_VALUE";
    TranslatableKinds["Category"] = "CATEGORY";
    TranslatableKinds["Collection"] = "COLLECTION";
    TranslatableKinds["MenuItem"] = "MENU_ITEM";
    TranslatableKinds["Page"] = "PAGE";
    TranslatableKinds["Product"] = "PRODUCT";
    TranslatableKinds["Sale"] = "SALE";
    TranslatableKinds["ShippingMethod"] = "SHIPPING_METHOD";
    TranslatableKinds["Variant"] = "VARIANT";
    TranslatableKinds["Voucher"] = "VOUCHER";
})(TranslatableKinds || (TranslatableKinds = {}));
var TranslationErrorCode;
(function(TranslationErrorCode) {
    TranslationErrorCode["GraphqlError"] = "GRAPHQL_ERROR";
    TranslationErrorCode["Invalid"] = "INVALID";
    TranslationErrorCode["NotFound"] = "NOT_FOUND";
    TranslationErrorCode["Required"] = "REQUIRED";
})(TranslationErrorCode || (TranslationErrorCode = {}));
var UploadErrorCode;
(function(UploadErrorCode) {
    UploadErrorCode["GraphqlError"] = "GRAPHQL_ERROR";
})(UploadErrorCode || (UploadErrorCode = {}));
var UserSortField;
(function(UserSortField) {
    UserSortField[/** Sort users by created at. */ "CreatedAt"] = "CREATED_AT";
    UserSortField[/** Sort users by email. */ "Email"] = "EMAIL";
    UserSortField[/** Sort users by first name. */ "FirstName"] = "FIRST_NAME";
    UserSortField[/** Sort users by last modified at. */ "LastModifiedAt"] = "LAST_MODIFIED_AT";
    UserSortField[/** Sort users by last name. */ "LastName"] = "LAST_NAME";
    UserSortField[/** Sort users by order count. */ "OrderCount"] = "ORDER_COUNT";
})(UserSortField || (UserSortField = {}));
var VariantAttributeScope;
(function(VariantAttributeScope) {
    VariantAttributeScope["All"] = "ALL";
    VariantAttributeScope["NotVariantSelection"] = "NOT_VARIANT_SELECTION";
    VariantAttributeScope["VariantSelection"] = "VARIANT_SELECTION";
})(VariantAttributeScope || (VariantAttributeScope = {}));
var VolumeUnitsEnum;
(function(VolumeUnitsEnum) {
    VolumeUnitsEnum["AcreFt"] = "ACRE_FT";
    VolumeUnitsEnum["AcreIn"] = "ACRE_IN";
    VolumeUnitsEnum["CubicCentimeter"] = "CUBIC_CENTIMETER";
    VolumeUnitsEnum["CubicDecimeter"] = "CUBIC_DECIMETER";
    VolumeUnitsEnum["CubicFoot"] = "CUBIC_FOOT";
    VolumeUnitsEnum["CubicInch"] = "CUBIC_INCH";
    VolumeUnitsEnum["CubicMeter"] = "CUBIC_METER";
    VolumeUnitsEnum["CubicMillimeter"] = "CUBIC_MILLIMETER";
    VolumeUnitsEnum["CubicYard"] = "CUBIC_YARD";
    VolumeUnitsEnum["FlOz"] = "FL_OZ";
    VolumeUnitsEnum["Liter"] = "LITER";
    VolumeUnitsEnum["Pint"] = "PINT";
    VolumeUnitsEnum["Qt"] = "QT";
})(VolumeUnitsEnum || (VolumeUnitsEnum = {}));
var VoucherDiscountType;
(function(VoucherDiscountType) {
    VoucherDiscountType["Fixed"] = "FIXED";
    VoucherDiscountType["Percentage"] = "PERCENTAGE";
    VoucherDiscountType["Shipping"] = "SHIPPING";
})(VoucherDiscountType || (VoucherDiscountType = {}));
var VoucherSortField;
(function(VoucherSortField) {
    VoucherSortField[/** Sort vouchers by code. */ "Code"] = "CODE";
    VoucherSortField[/** Sort vouchers by end date. */ "EndDate"] = "END_DATE";
    VoucherSortField[/** Sort vouchers by minimum spent amount. */ "MinimumSpentAmount"] = "MINIMUM_SPENT_AMOUNT";
    VoucherSortField[/** Sort vouchers by start date. */ "StartDate"] = "START_DATE";
    VoucherSortField[/** Sort vouchers by type. */ "Type"] = "TYPE";
    VoucherSortField[/** Sort vouchers by usage limit. */ "UsageLimit"] = "USAGE_LIMIT";
    VoucherSortField[/** Sort vouchers by value. */ "Value"] = "VALUE";
})(VoucherSortField || (VoucherSortField = {}));
var VoucherTypeEnum;
(function(VoucherTypeEnum) {
    VoucherTypeEnum["EntireOrder"] = "ENTIRE_ORDER";
    VoucherTypeEnum["Shipping"] = "SHIPPING";
    VoucherTypeEnum["SpecificProduct"] = "SPECIFIC_PRODUCT";
})(VoucherTypeEnum || (VoucherTypeEnum = {}));
var WarehouseClickAndCollectOptionEnum;
(function(WarehouseClickAndCollectOptionEnum) {
    WarehouseClickAndCollectOptionEnum["All"] = "ALL";
    WarehouseClickAndCollectOptionEnum["Disabled"] = "DISABLED";
    WarehouseClickAndCollectOptionEnum["Local"] = "LOCAL";
})(WarehouseClickAndCollectOptionEnum || (WarehouseClickAndCollectOptionEnum = {}));
var WarehouseErrorCode;
(function(WarehouseErrorCode) {
    WarehouseErrorCode["AlreadyExists"] = "ALREADY_EXISTS";
    WarehouseErrorCode["GraphqlError"] = "GRAPHQL_ERROR";
    WarehouseErrorCode["Invalid"] = "INVALID";
    WarehouseErrorCode["NotFound"] = "NOT_FOUND";
    WarehouseErrorCode["Required"] = "REQUIRED";
    WarehouseErrorCode["Unique"] = "UNIQUE";
})(WarehouseErrorCode || (WarehouseErrorCode = {}));
var WarehouseSortField;
(function(WarehouseSortField) {
    WarehouseSortField[/** Sort warehouses by name. */ "Name"] = "NAME";
})(WarehouseSortField || (WarehouseSortField = {}));
var WebhookErrorCode;
(function(WebhookErrorCode) {
    WebhookErrorCode["GraphqlError"] = "GRAPHQL_ERROR";
    WebhookErrorCode["Invalid"] = "INVALID";
    WebhookErrorCode["NotFound"] = "NOT_FOUND";
    WebhookErrorCode["Required"] = "REQUIRED";
    WebhookErrorCode["Unique"] = "UNIQUE";
})(WebhookErrorCode || (WebhookErrorCode = {}));
var WebhookEventTypeAsyncEnum;
(function(WebhookEventTypeAsyncEnum) {
    WebhookEventTypeAsyncEnum[/** All the events. */ "AnyEvents"] = "ANY_EVENTS";
    WebhookEventTypeAsyncEnum[/** A new checkout is created. */ "CheckoutCreated"] = "CHECKOUT_CREATED";
    WebhookEventTypeAsyncEnum[/** A checkout is updated. It also triggers all updates related to the checkout. */ "CheckoutUpdated"] = "CHECKOUT_UPDATED";
    WebhookEventTypeAsyncEnum[/** A new collection is created. */ "CollectionCreated"] = "COLLECTION_CREATED";
    WebhookEventTypeAsyncEnum[/** A collection is deleted. */ "CollectionDeleted"] = "COLLECTION_DELETED";
    WebhookEventTypeAsyncEnum[/** A collection is updated. */ "CollectionUpdated"] = "COLLECTION_UPDATED";
    WebhookEventTypeAsyncEnum[/** A new customer account is created. */ "CustomerCreated"] = "CUSTOMER_CREATED";
    WebhookEventTypeAsyncEnum[/** A customer account is updated. */ "CustomerUpdated"] = "CUSTOMER_UPDATED";
    WebhookEventTypeAsyncEnum["DraftOrderCreated"] = "DRAFT_ORDER_CREATED";
    WebhookEventTypeAsyncEnum["DraftOrderDeleted"] = "DRAFT_ORDER_DELETED";
    WebhookEventTypeAsyncEnum["DraftOrderUpdated"] = "DRAFT_ORDER_UPDATED";
    WebhookEventTypeAsyncEnum[/** A fulfillment is cancelled. */ "FulfillmentCanceled"] = "FULFILLMENT_CANCELED";
    WebhookEventTypeAsyncEnum[/** A new fulfillment is created. */ "FulfillmentCreated"] = "FULFILLMENT_CREATED";
    WebhookEventTypeAsyncEnum[/** An invoice is deleted. */ "InvoiceDeleted"] = "INVOICE_DELETED";
    WebhookEventTypeAsyncEnum[/** An invoice for order requested. */ "InvoiceRequested"] = "INVOICE_REQUESTED";
    WebhookEventTypeAsyncEnum[/** Invoice has been sent. */ "InvoiceSent"] = "INVOICE_SENT";
    WebhookEventTypeAsyncEnum[/** User notification triggered. */ "NotifyUser"] = "NOTIFY_USER";
    WebhookEventTypeAsyncEnum[/** An order is cancelled. */ "OrderCancelled"] = "ORDER_CANCELLED";
    WebhookEventTypeAsyncEnum[/** An order is confirmed (status change unconfirmed -> unfulfilled) by a staff user using the OrderConfirm mutation. It also triggers when the user completes the checkout and the shop setting `automatically_confirm_all_new_orders` is enabled. */ "OrderConfirmed"] = "ORDER_CONFIRMED";
    WebhookEventTypeAsyncEnum[/** A new order is placed. */ "OrderCreated"] = "ORDER_CREATED";
    WebhookEventTypeAsyncEnum[/** An order is fulfilled. */ "OrderFulfilled"] = "ORDER_FULFILLED";
    WebhookEventTypeAsyncEnum[/** Payment is made and an order is fully paid. */ "OrderFullyPaid"] = "ORDER_FULLY_PAID";
    WebhookEventTypeAsyncEnum[/** An order is updated; triggered for all changes related to an order; covers all other order webhooks, except for ORDER_CREATED. */ "OrderUpdated"] = "ORDER_UPDATED";
    WebhookEventTypeAsyncEnum[/** A new page is created. */ "PageCreated"] = "PAGE_CREATED";
    WebhookEventTypeAsyncEnum[/** A page is deleted. */ "PageDeleted"] = "PAGE_DELETED";
    WebhookEventTypeAsyncEnum[/** A page is updated. */ "PageUpdated"] = "PAGE_UPDATED";
    WebhookEventTypeAsyncEnum[/** A new product is created. */ "ProductCreated"] = "PRODUCT_CREATED";
    WebhookEventTypeAsyncEnum[/** A product is deleted. */ "ProductDeleted"] = "PRODUCT_DELETED";
    WebhookEventTypeAsyncEnum[/** A product is updated. */ "ProductUpdated"] = "PRODUCT_UPDATED";
    WebhookEventTypeAsyncEnum["ProductVariantBackInStock"] = "PRODUCT_VARIANT_BACK_IN_STOCK";
    WebhookEventTypeAsyncEnum[/** A new product variant is created. */ "ProductVariantCreated"] = "PRODUCT_VARIANT_CREATED";
    WebhookEventTypeAsyncEnum[/** A product variant is deleted. */ "ProductVariantDeleted"] = "PRODUCT_VARIANT_DELETED";
    WebhookEventTypeAsyncEnum["ProductVariantOutOfStock"] = "PRODUCT_VARIANT_OUT_OF_STOCK";
    WebhookEventTypeAsyncEnum[/** A product variant is updated. */ "ProductVariantUpdated"] = "PRODUCT_VARIANT_UPDATED";
    WebhookEventTypeAsyncEnum["SaleCreated"] = "SALE_CREATED";
    WebhookEventTypeAsyncEnum["SaleDeleted"] = "SALE_DELETED";
    WebhookEventTypeAsyncEnum["SaleUpdated"] = "SALE_UPDATED";
    WebhookEventTypeAsyncEnum["TranslationCreated"] = "TRANSLATION_CREATED";
    WebhookEventTypeAsyncEnum["TranslationUpdated"] = "TRANSLATION_UPDATED";
})(WebhookEventTypeAsyncEnum || (WebhookEventTypeAsyncEnum = {}));
var WebhookEventTypeEnum;
(function(WebhookEventTypeEnum) {
    WebhookEventTypeEnum["AnyEvents"] = "ANY_EVENTS";
    WebhookEventTypeEnum["CheckoutCreated"] = "CHECKOUT_CREATED";
    WebhookEventTypeEnum["CheckoutFilterShippingMethods"] = "CHECKOUT_FILTER_SHIPPING_METHODS";
    WebhookEventTypeEnum["CheckoutUpdated"] = "CHECKOUT_UPDATED";
    WebhookEventTypeEnum["CollectionCreated"] = "COLLECTION_CREATED";
    WebhookEventTypeEnum["CollectionDeleted"] = "COLLECTION_DELETED";
    WebhookEventTypeEnum["CollectionUpdated"] = "COLLECTION_UPDATED";
    WebhookEventTypeEnum["CustomerCreated"] = "CUSTOMER_CREATED";
    WebhookEventTypeEnum["CustomerUpdated"] = "CUSTOMER_UPDATED";
    WebhookEventTypeEnum["DraftOrderCreated"] = "DRAFT_ORDER_CREATED";
    WebhookEventTypeEnum["DraftOrderDeleted"] = "DRAFT_ORDER_DELETED";
    WebhookEventTypeEnum["DraftOrderUpdated"] = "DRAFT_ORDER_UPDATED";
    WebhookEventTypeEnum["FulfillmentCanceled"] = "FULFILLMENT_CANCELED";
    WebhookEventTypeEnum["FulfillmentCreated"] = "FULFILLMENT_CREATED";
    WebhookEventTypeEnum["InvoiceDeleted"] = "INVOICE_DELETED";
    WebhookEventTypeEnum["InvoiceRequested"] = "INVOICE_REQUESTED";
    WebhookEventTypeEnum["InvoiceSent"] = "INVOICE_SENT";
    WebhookEventTypeEnum["NotifyUser"] = "NOTIFY_USER";
    WebhookEventTypeEnum["OrderCancelled"] = "ORDER_CANCELLED";
    WebhookEventTypeEnum["OrderConfirmed"] = "ORDER_CONFIRMED";
    WebhookEventTypeEnum["OrderCreated"] = "ORDER_CREATED";
    WebhookEventTypeEnum["OrderFilterShippingMethods"] = "ORDER_FILTER_SHIPPING_METHODS";
    WebhookEventTypeEnum["OrderFulfilled"] = "ORDER_FULFILLED";
    WebhookEventTypeEnum["OrderFullyPaid"] = "ORDER_FULLY_PAID";
    WebhookEventTypeEnum["OrderUpdated"] = "ORDER_UPDATED";
    WebhookEventTypeEnum["PageCreated"] = "PAGE_CREATED";
    WebhookEventTypeEnum["PageDeleted"] = "PAGE_DELETED";
    WebhookEventTypeEnum["PageUpdated"] = "PAGE_UPDATED";
    WebhookEventTypeEnum["PaymentAuthorize"] = "PAYMENT_AUTHORIZE";
    WebhookEventTypeEnum["PaymentCapture"] = "PAYMENT_CAPTURE";
    WebhookEventTypeEnum["PaymentConfirm"] = "PAYMENT_CONFIRM";
    WebhookEventTypeEnum["PaymentListGateways"] = "PAYMENT_LIST_GATEWAYS";
    WebhookEventTypeEnum["PaymentProcess"] = "PAYMENT_PROCESS";
    WebhookEventTypeEnum["PaymentRefund"] = "PAYMENT_REFUND";
    WebhookEventTypeEnum["PaymentVoid"] = "PAYMENT_VOID";
    WebhookEventTypeEnum["ProductCreated"] = "PRODUCT_CREATED";
    WebhookEventTypeEnum["ProductDeleted"] = "PRODUCT_DELETED";
    WebhookEventTypeEnum["ProductUpdated"] = "PRODUCT_UPDATED";
    WebhookEventTypeEnum["ProductVariantBackInStock"] = "PRODUCT_VARIANT_BACK_IN_STOCK";
    WebhookEventTypeEnum["ProductVariantCreated"] = "PRODUCT_VARIANT_CREATED";
    WebhookEventTypeEnum["ProductVariantDeleted"] = "PRODUCT_VARIANT_DELETED";
    WebhookEventTypeEnum["ProductVariantOutOfStock"] = "PRODUCT_VARIANT_OUT_OF_STOCK";
    WebhookEventTypeEnum["ProductVariantUpdated"] = "PRODUCT_VARIANT_UPDATED";
    WebhookEventTypeEnum["SaleCreated"] = "SALE_CREATED";
    WebhookEventTypeEnum["SaleDeleted"] = "SALE_DELETED";
    WebhookEventTypeEnum["SaleUpdated"] = "SALE_UPDATED";
    WebhookEventTypeEnum["ShippingListMethodsForCheckout"] = "SHIPPING_LIST_METHODS_FOR_CHECKOUT";
    WebhookEventTypeEnum["TranslationCreated"] = "TRANSLATION_CREATED";
    WebhookEventTypeEnum["TranslationUpdated"] = "TRANSLATION_UPDATED";
})(WebhookEventTypeEnum || (WebhookEventTypeEnum = {}));
var WebhookEventTypeSyncEnum;
(function(WebhookEventTypeSyncEnum) {
    WebhookEventTypeSyncEnum["CheckoutFilterShippingMethods"] = "CHECKOUT_FILTER_SHIPPING_METHODS";
    WebhookEventTypeSyncEnum["OrderFilterShippingMethods"] = "ORDER_FILTER_SHIPPING_METHODS";
    WebhookEventTypeSyncEnum["PaymentAuthorize"] = "PAYMENT_AUTHORIZE";
    WebhookEventTypeSyncEnum["PaymentCapture"] = "PAYMENT_CAPTURE";
    WebhookEventTypeSyncEnum["PaymentConfirm"] = "PAYMENT_CONFIRM";
    WebhookEventTypeSyncEnum["PaymentListGateways"] = "PAYMENT_LIST_GATEWAYS";
    WebhookEventTypeSyncEnum["PaymentProcess"] = "PAYMENT_PROCESS";
    WebhookEventTypeSyncEnum["PaymentRefund"] = "PAYMENT_REFUND";
    WebhookEventTypeSyncEnum["PaymentVoid"] = "PAYMENT_VOID";
    WebhookEventTypeSyncEnum["ShippingListMethodsForCheckout"] = "SHIPPING_LIST_METHODS_FOR_CHECKOUT";
})(WebhookEventTypeSyncEnum || (WebhookEventTypeSyncEnum = {}));
var WebhookSampleEventTypeEnum;
(function(WebhookSampleEventTypeEnum) {
    WebhookSampleEventTypeEnum["CheckoutCreated"] = "CHECKOUT_CREATED";
    WebhookSampleEventTypeEnum["CheckoutUpdated"] = "CHECKOUT_UPDATED";
    WebhookSampleEventTypeEnum["CollectionCreated"] = "COLLECTION_CREATED";
    WebhookSampleEventTypeEnum["CollectionDeleted"] = "COLLECTION_DELETED";
    WebhookSampleEventTypeEnum["CollectionUpdated"] = "COLLECTION_UPDATED";
    WebhookSampleEventTypeEnum["CustomerCreated"] = "CUSTOMER_CREATED";
    WebhookSampleEventTypeEnum["CustomerUpdated"] = "CUSTOMER_UPDATED";
    WebhookSampleEventTypeEnum["DraftOrderCreated"] = "DRAFT_ORDER_CREATED";
    WebhookSampleEventTypeEnum["DraftOrderDeleted"] = "DRAFT_ORDER_DELETED";
    WebhookSampleEventTypeEnum["DraftOrderUpdated"] = "DRAFT_ORDER_UPDATED";
    WebhookSampleEventTypeEnum["FulfillmentCanceled"] = "FULFILLMENT_CANCELED";
    WebhookSampleEventTypeEnum["FulfillmentCreated"] = "FULFILLMENT_CREATED";
    WebhookSampleEventTypeEnum["InvoiceDeleted"] = "INVOICE_DELETED";
    WebhookSampleEventTypeEnum["InvoiceRequested"] = "INVOICE_REQUESTED";
    WebhookSampleEventTypeEnum["InvoiceSent"] = "INVOICE_SENT";
    WebhookSampleEventTypeEnum["NotifyUser"] = "NOTIFY_USER";
    WebhookSampleEventTypeEnum["OrderCancelled"] = "ORDER_CANCELLED";
    WebhookSampleEventTypeEnum["OrderConfirmed"] = "ORDER_CONFIRMED";
    WebhookSampleEventTypeEnum["OrderCreated"] = "ORDER_CREATED";
    WebhookSampleEventTypeEnum["OrderFulfilled"] = "ORDER_FULFILLED";
    WebhookSampleEventTypeEnum["OrderFullyPaid"] = "ORDER_FULLY_PAID";
    WebhookSampleEventTypeEnum["OrderUpdated"] = "ORDER_UPDATED";
    WebhookSampleEventTypeEnum["PageCreated"] = "PAGE_CREATED";
    WebhookSampleEventTypeEnum["PageDeleted"] = "PAGE_DELETED";
    WebhookSampleEventTypeEnum["PageUpdated"] = "PAGE_UPDATED";
    WebhookSampleEventTypeEnum["ProductCreated"] = "PRODUCT_CREATED";
    WebhookSampleEventTypeEnum["ProductDeleted"] = "PRODUCT_DELETED";
    WebhookSampleEventTypeEnum["ProductUpdated"] = "PRODUCT_UPDATED";
    WebhookSampleEventTypeEnum["ProductVariantBackInStock"] = "PRODUCT_VARIANT_BACK_IN_STOCK";
    WebhookSampleEventTypeEnum["ProductVariantCreated"] = "PRODUCT_VARIANT_CREATED";
    WebhookSampleEventTypeEnum["ProductVariantDeleted"] = "PRODUCT_VARIANT_DELETED";
    WebhookSampleEventTypeEnum["ProductVariantOutOfStock"] = "PRODUCT_VARIANT_OUT_OF_STOCK";
    WebhookSampleEventTypeEnum["ProductVariantUpdated"] = "PRODUCT_VARIANT_UPDATED";
    WebhookSampleEventTypeEnum["SaleCreated"] = "SALE_CREATED";
    WebhookSampleEventTypeEnum["SaleDeleted"] = "SALE_DELETED";
    WebhookSampleEventTypeEnum["SaleUpdated"] = "SALE_UPDATED";
    WebhookSampleEventTypeEnum["TranslationCreated"] = "TRANSLATION_CREATED";
    WebhookSampleEventTypeEnum["TranslationUpdated"] = "TRANSLATION_UPDATED";
})(WebhookSampleEventTypeEnum || (WebhookSampleEventTypeEnum = {}));
var WeightUnitsEnum;
(function(WeightUnitsEnum) {
    WeightUnitsEnum["G"] = "G";
    WeightUnitsEnum["Kg"] = "KG";
    WeightUnitsEnum["Lb"] = "LB";
    WeightUnitsEnum["Oz"] = "OZ";
    WeightUnitsEnum["Tonne"] = "TONNE";
})(WeightUnitsEnum || (WeightUnitsEnum = {}));
const CheckoutLineFragmentDoc = (0,lib/* gql */.Ps)(_templateObject());
const CheckoutFragmentDoc = (0,lib/* gql */.Ps)(_templateObject1(), CheckoutLineFragmentDoc);
const CheckoutErrorFragmentDoc = (0,lib/* gql */.Ps)(_templateObject2());
const CountryDisplayFieldsFragmentDoc = (0,lib/* gql */.Ps)(_templateObject3());
const AddressFieldsFragmentDoc = (0,lib/* gql */.Ps)(_templateObject4(), CountryDisplayFieldsFragmentDoc);
const OrderFieldsFragmentDoc = (0,lib/* gql */.Ps)(_templateObject5(), AddressFieldsFragmentDoc);
const ProductMediaFragmentDoc = (0,lib/* gql */.Ps)(_templateObject6());
const MoneyFragmentDoc = (0,lib/* gql */.Ps)(_templateObject7());
const TaxedMoneyFragmentDoc = (0,lib/* gql */.Ps)(_templateObject8(), MoneyFragmentDoc);
const ProductFragmentDoc = (0,lib/* gql */.Ps)(_templateObject9(), ProductMediaFragmentDoc, TaxedMoneyFragmentDoc);
const AccountAddressCreateDocument = (0,lib/* gql */.Ps)(_templateObject10(), AddressFieldsFragmentDoc);
/**
 * __useAccountAddressCreateMutation__
 *
 * To run a mutation, you first call `useAccountAddressCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAccountAddressCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [accountAddressCreateMutation, { data, loading, error }] = useAccountAddressCreateMutation({
 *   variables: {
 *      address: // value for 'address'
 *   },
 * });
 */ function useAccountAddressCreateMutation(baseOptions) {
    const options = {
        ...graphql_defaultOptions,
        ...baseOptions
    };
    return Apollo.useMutation(AccountAddressCreateDocument, options);
}
const AccountAddressUpdateDocument = (0,lib/* gql */.Ps)(_templateObject11(), AddressFieldsFragmentDoc);
/**
 * __useAccountAddressUpdateMutation__
 *
 * To run a mutation, you first call `useAccountAddressUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAccountAddressUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [accountAddressUpdateMutation, { data, loading, error }] = useAccountAddressUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      address: // value for 'address'
 *   },
 * });
 */ function useAccountAddressUpdateMutation(baseOptions) {
    const options = {
        ...graphql_defaultOptions,
        ...baseOptions
    };
    return Apollo.useMutation(AccountAddressUpdateDocument, options);
}
const AccountAddressDeleteDocument = (0,lib/* gql */.Ps)(_templateObject12());
/**
 * __useAccountAddressDeleteMutation__
 *
 * To run a mutation, you first call `useAccountAddressDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAccountAddressDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [accountAddressDeleteMutation, { data, loading, error }] = useAccountAddressDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */ function useAccountAddressDeleteMutation(baseOptions) {
    const options = {
        ...graphql_defaultOptions,
        ...baseOptions
    };
    return Apollo.useMutation(AccountAddressDeleteDocument, options);
}
const graphql_CategoryBySlugDocument = (0,lib/* gql */.Ps)(_templateObject13());
/**
 * __useCategoryBySlugQuery__
 *
 * To run a query within a React component, call `useCategoryBySlugQuery` and pass it any options that fit your needs.
 * When your component renders, `useCategoryBySlugQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCategoryBySlugQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */ function useCategoryBySlugQuery(baseOptions) {
    const options = {
        ...graphql_defaultOptions,
        ...baseOptions
    };
    return Apollo.useQuery(graphql_CategoryBySlugDocument, options);
}
function useCategoryBySlugLazyQuery(baseOptions) {
    const options = {
        ...graphql_defaultOptions,
        ...baseOptions
    };
    return Apollo.useLazyQuery(graphql_CategoryBySlugDocument, options);
}
const AnonymousCheckoutByTokenDocument = (0,lib/* gql */.Ps)(_templateObject14(), CheckoutFragmentDoc);
/**
 * __useAnonymousCheckoutByTokenQuery__
 *
 * To run a query within a React component, call `useAnonymousCheckoutByTokenQuery` and pass it any options that fit your needs.
 * When your component renders, `useAnonymousCheckoutByTokenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAnonymousCheckoutByTokenQuery({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */ function useAnonymousCheckoutByTokenQuery(baseOptions) {
    const options = {
        ...graphql_defaultOptions,
        ...baseOptions
    };
    return Apollo.useQuery(AnonymousCheckoutByTokenDocument, options);
}
function useAnonymousCheckoutByTokenLazyQuery(baseOptions) {
    const options = {
        ...graphql_defaultOptions,
        ...baseOptions
    };
    return Apollo.useLazyQuery(AnonymousCheckoutByTokenDocument, options);
}
const MyCheckoutDocument = (0,lib/* gql */.Ps)(_templateObject15(), CheckoutFragmentDoc);
/**
 * __useMyCheckoutQuery__
 *
 * To run a query within a React component, call `useMyCheckoutQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyCheckoutQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyCheckoutQuery({
 *   variables: {
 *   },
 * });
 */ function useMyCheckoutQuery(baseOptions) {
    const options = {
        ...graphql_defaultOptions,
        ...baseOptions
    };
    return Apollo.useQuery(MyCheckoutDocument, options);
}
function useMyCheckoutLazyQuery(baseOptions) {
    const options = {
        ...graphql_defaultOptions,
        ...baseOptions
    };
    return Apollo.useLazyQuery(MyCheckoutDocument, options);
}
const CheckoutCreateDocument = (0,lib/* gql */.Ps)(_templateObject16(), CheckoutFragmentDoc, CheckoutErrorFragmentDoc);
/**
 * __useCheckoutCreateMutation__
 *
 * To run a mutation, you first call `useCheckoutCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCheckoutCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [checkoutCreateMutation, { data, loading, error }] = useCheckoutCreateMutation({
 *   variables: {
 *      email: // value for 'email'
 *      lines: // value for 'lines'
 *   },
 * });
 */ function useCheckoutCreateMutation(baseOptions) {
    const options = {
        ...graphql_defaultOptions,
        ...baseOptions
    };
    return useMutation(CheckoutCreateDocument, options);
}
const CheckoutLinesAddDocument = (0,lib/* gql */.Ps)(_templateObject17(), CheckoutErrorFragmentDoc);
/**
 * __useCheckoutLinesAddMutation__
 *
 * To run a mutation, you first call `useCheckoutLinesAddMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCheckoutLinesAddMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [checkoutLinesAddMutation, { data, loading, error }] = useCheckoutLinesAddMutation({
 *   variables: {
 *      token: // value for 'token'
 *      lines: // value for 'lines'
 *   },
 * });
 */ function useCheckoutLinesAddMutation(baseOptions) {
    const options = {
        ...graphql_defaultOptions,
        ...baseOptions
    };
    return Apollo.useMutation(CheckoutLinesAddDocument, options);
}
const CheckoutLinesUpdateDocument = (0,lib/* gql */.Ps)(_templateObject18(), CheckoutErrorFragmentDoc);
/**
 * __useCheckoutLinesUpdateMutation__
 *
 * To run a mutation, you first call `useCheckoutLinesUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCheckoutLinesUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [checkoutLinesUpdateMutation, { data, loading, error }] = useCheckoutLinesUpdateMutation({
 *   variables: {
 *      token: // value for 'token'
 *      lines: // value for 'lines'
 *   },
 * });
 */ function useCheckoutLinesUpdateMutation(baseOptions) {
    const options = {
        ...graphql_defaultOptions,
        ...baseOptions
    };
    return useMutation(CheckoutLinesUpdateDocument, options);
}
const CheckoutLineDeleteDocument = (0,lib/* gql */.Ps)(_templateObject19(), CheckoutErrorFragmentDoc);
/**
 * __useCheckoutLineDeleteMutation__
 *
 * To run a mutation, you first call `useCheckoutLineDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCheckoutLineDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [checkoutLineDeleteMutation, { data, loading, error }] = useCheckoutLineDeleteMutation({
 *   variables: {
 *      token: // value for 'token'
 *      lineId: // value for 'lineId'
 *   },
 * });
 */ function useCheckoutLineDeleteMutation(baseOptions) {
    const options = {
        ...graphql_defaultOptions,
        ...baseOptions
    };
    return Apollo.useMutation(CheckoutLineDeleteDocument, options);
}
const CheckoutShippingAddressUpdateDocument = (0,lib/* gql */.Ps)(_templateObject20(), CheckoutErrorFragmentDoc);
/**
 * __useCheckoutShippingAddressUpdateMutation__
 *
 * To run a mutation, you first call `useCheckoutShippingAddressUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCheckoutShippingAddressUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [checkoutShippingAddressUpdateMutation, { data, loading, error }] = useCheckoutShippingAddressUpdateMutation({
 *   variables: {
 *      token: // value for 'token'
 *      shippingAddress: // value for 'shippingAddress'
 *   },
 * });
 */ function useCheckoutShippingAddressUpdateMutation(baseOptions) {
    const options = {
        ...graphql_defaultOptions,
        ...baseOptions
    };
    return useMutation(CheckoutShippingAddressUpdateDocument, options);
}
const CheckoutBillingAddressUpdateDocument = (0,lib/* gql */.Ps)(_templateObject21(), CheckoutErrorFragmentDoc);
/**
 * __useCheckoutBillingAddressUpdateMutation__
 *
 * To run a mutation, you first call `useCheckoutBillingAddressUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCheckoutBillingAddressUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [checkoutBillingAddressUpdateMutation, { data, loading, error }] = useCheckoutBillingAddressUpdateMutation({
 *   variables: {
 *      token: // value for 'token'
 *      billingAddress: // value for 'billingAddress'
 *   },
 * });
 */ function useCheckoutBillingAddressUpdateMutation(baseOptions) {
    const options = {
        ...graphql_defaultOptions,
        ...baseOptions
    };
    return useMutation(CheckoutBillingAddressUpdateDocument, options);
}
const CheckoutAddressesUpdateDocument = (0,lib/* gql */.Ps)(_templateObject22(), CheckoutErrorFragmentDoc);
/**
 * __useCheckoutAddressesUpdateMutation__
 *
 * To run a mutation, you first call `useCheckoutAddressesUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCheckoutAddressesUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [checkoutAddressesUpdateMutation, { data, loading, error }] = useCheckoutAddressesUpdateMutation({
 *   variables: {
 *      token: // value for 'token'
 *      billingAddress: // value for 'billingAddress'
 *      shippingAddress: // value for 'shippingAddress'
 *   },
 * });
 */ function useCheckoutAddressesUpdateMutation(baseOptions) {
    const options = {
        ...graphql_defaultOptions,
        ...baseOptions
    };
    return useMutation(CheckoutAddressesUpdateDocument, options);
}
const CheckoutShippingMethodUpdateDocument = (0,lib/* gql */.Ps)(_templateObject23(), CheckoutErrorFragmentDoc);
/**
 * __useCheckoutShippingMethodUpdateMutation__
 *
 * To run a mutation, you first call `useCheckoutShippingMethodUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCheckoutShippingMethodUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [checkoutShippingMethodUpdateMutation, { data, loading, error }] = useCheckoutShippingMethodUpdateMutation({
 *   variables: {
 *      token: // value for 'token'
 *      shippingMethodId: // value for 'shippingMethodId'
 *   },
 * });
 */ function useCheckoutShippingMethodUpdateMutation(baseOptions) {
    const options = {
        ...graphql_defaultOptions,
        ...baseOptions
    };
    return useMutation(CheckoutShippingMethodUpdateDocument, options);
}
const CheckoutPaymentCreateDocument = (0,lib/* gql */.Ps)(_templateObject24());
/**
 * __useCheckoutPaymentCreateMutation__
 *
 * To run a mutation, you first call `useCheckoutPaymentCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCheckoutPaymentCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [checkoutPaymentCreateMutation, { data, loading, error }] = useCheckoutPaymentCreateMutation({
 *   variables: {
 *      token: // value for 'token'
 *      input: // value for 'input'
 *   },
 * });
 */ function useCheckoutPaymentCreateMutation(baseOptions) {
    const options = {
        ...graphql_defaultOptions,
        ...baseOptions
    };
    return useMutation(CheckoutPaymentCreateDocument, options);
}
const AddNoteToOrderDocument = (0,lib/* gql */.Ps)(_templateObject25(), OrderFieldsFragmentDoc);
/**
 * __useAddNoteToOrderMutation__
 *
 * To run a mutation, you first call `useAddNoteToOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddNoteToOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addNoteToOrderMutation, { data, loading, error }] = useAddNoteToOrderMutation({
 *   variables: {
 *      order: // value for 'order'
 *      input: // value for 'input'
 *   },
 * });
 */ function useAddNoteToOrderMutation(baseOptions) {
    const options = {
        ...graphql_defaultOptions,
        ...baseOptions
    };
    return Apollo.useMutation(AddNoteToOrderDocument, options);
}
const CheckoutCompleteDocument = (0,lib/* gql */.Ps)(_templateObject26(), OrderFieldsFragmentDoc, CheckoutErrorFragmentDoc);
/**
 * __useCheckoutCompleteMutation__
 *
 * To run a mutation, you first call `useCheckoutCompleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCheckoutCompleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [checkoutCompleteMutation, { data, loading, error }] = useCheckoutCompleteMutation({
 *   variables: {
 *      token: // value for 'token'
 *      paymentData: // value for 'paymentData'
 *   },
 * });
 */ function useCheckoutCompleteMutation(baseOptions) {
    const options = {
        ...graphql_defaultOptions,
        ...baseOptions
    };
    return useMutation(CheckoutCompleteDocument, options);
}
const CheckoutEmailUpdateDocument = (0,lib/* gql */.Ps)(_templateObject27(), CheckoutErrorFragmentDoc);
/**
 * __useCheckoutEmailUpdateMutation__
 *
 * To run a mutation, you first call `useCheckoutEmailUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCheckoutEmailUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [checkoutEmailUpdateMutation, { data, loading, error }] = useCheckoutEmailUpdateMutation({
 *   variables: {
 *      email: // value for 'email'
 *      token: // value for 'token'
 *   },
 * });
 */ function useCheckoutEmailUpdateMutation(baseOptions) {
    const options = {
        ...graphql_defaultOptions,
        ...baseOptions
    };
    return useMutation(CheckoutEmailUpdateDocument, options);
}
const CheckoutReceiverUpdateDocument = (0,lib/* gql */.Ps)(_templateObject28(), CheckoutFragmentDoc, CheckoutErrorFragmentDoc);
/**
 * __useCheckoutReceiverUpdateMutation__
 *
 * To run a mutation, you first call `useCheckoutReceiverUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCheckoutReceiverUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [checkoutReceiverUpdateMutation, { data, loading, error }] = useCheckoutReceiverUpdateMutation({
 *   variables: {
 *      token: // value for 'token'
 *      billingAddress: // value for 'billingAddress'
 *      shippingAddress: // value for 'shippingAddress'
 *      email: // value for 'email'
 *   },
 * });
 */ function useCheckoutReceiverUpdateMutation(baseOptions) {
    const options = {
        ...graphql_defaultOptions,
        ...baseOptions
    };
    return Apollo.useMutation(CheckoutReceiverUpdateDocument, options);
}
const OrderByTokenDocument = (0,lib/* gql */.Ps)(_templateObject29(), OrderFieldsFragmentDoc);
/**
 * __useOrderByTokenQuery__
 *
 * To run a query within a React component, call `useOrderByTokenQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrderByTokenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrderByTokenQuery({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */ function useOrderByTokenQuery(baseOptions) {
    const options = {
        ...graphql_defaultOptions,
        ...baseOptions
    };
    return Apollo.useQuery(OrderByTokenDocument, options);
}
function useOrderByTokenLazyQuery(baseOptions) {
    const options = {
        ...graphql_defaultOptions,
        ...baseOptions
    };
    return Apollo.useLazyQuery(OrderByTokenDocument, options);
}
const ProductByIdDocument = (0,lib/* gql */.Ps)(_templateObject30(), ProductFragmentDoc);
/**
 * __useProductByIdQuery__
 *
 * To run a query within a React component, call `useProductByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */ function useProductByIdQuery(baseOptions) {
    const options = {
        ...graphql_defaultOptions,
        ...baseOptions
    };
    return Apollo.useQuery(ProductByIdDocument, options);
}
function useProductByIdLazyQuery(baseOptions) {
    const options = {
        ...graphql_defaultOptions,
        ...baseOptions
    };
    return Apollo.useLazyQuery(ProductByIdDocument, options);
}
const ProductDocument = (0,lib/* gql */.Ps)(_templateObject31(), ProductFragmentDoc);
/**
 * __useProductQuery__
 *
 * To run a query within a React component, call `useProductQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */ function useProductQuery(baseOptions) {
    const options = {
        ...graphql_defaultOptions,
        ...baseOptions
    };
    return Apollo.useQuery(ProductDocument, options);
}
function useProductLazyQuery(baseOptions) {
    const options = {
        ...graphql_defaultOptions,
        ...baseOptions
    };
    return Apollo.useLazyQuery(ProductDocument, options);
}
const ProductsDocument = (0,lib/* gql */.Ps)(_templateObject32(), ProductFragmentDoc);
/**
 * __useProductsQuery__
 *
 * To run a query within a React component, call `useProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      filter: // value for 'filter'
 *      sortBy: // value for 'sortBy'
 *   },
 * });
 */ function useProductsQuery(baseOptions) {
    const options = {
        ...graphql_defaultOptions,
        ...baseOptions
    };
    return Apollo.useQuery(ProductsDocument, options);
}
function useProductsLazyQuery(baseOptions) {
    const options = {
        ...graphql_defaultOptions,
        ...baseOptions
    };
    return Apollo.useLazyQuery(ProductsDocument, options);
}
const UserAddressesDocument = (0,lib/* gql */.Ps)(_templateObject33(), AddressFieldsFragmentDoc);
/**
 * __useUserAddressesQuery__
 *
 * To run a query within a React component, call `useUserAddressesQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserAddressesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserAddressesQuery({
 *   variables: {
 *   },
 * });
 */ function useUserAddressesQuery(baseOptions) {
    const options = {
        ...graphql_defaultOptions,
        ...baseOptions
    };
    return Apollo.useQuery(UserAddressesDocument, options);
}
function useUserAddressesLazyQuery(baseOptions) {
    const options = {
        ...graphql_defaultOptions,
        ...baseOptions
    };
    return Apollo.useLazyQuery(UserAddressesDocument, options);
}

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-api-products-virtual-81752d2989/1/packages/lib-api-products/src/provider/checkout-provider/const.ts
const CHECKOUT_ERRORS = [
    "NOT_FOUND",
    "QUANTITY_GREATER_THAN_LIMIT",
    "INSUFFICIENT_STOCK",
    "UNKNOWN"
];
const checkoutErrorCodeMap = {
    NOT_FOUND: "Fann ekki v\xf6ru",
    QUANTITY_GREATER_THAN_LIMIT: "Ekki n\xe6gilegt magn af \xfeessari v\xf6ru til \xe1 lager",
    INSUFFICIENT_STOCK: "Ekki n\xe6gilegt magn af \xfeessari v\xf6ru til \xe1 lager",
    UNKNOWN: "\xd3\xfeekkt villa"
};
const POLL_CHECKOUT = 1000 * 60 * 15;
const LOCAL_KEY = "myanonymousCartToken";

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-api-products-virtual-81752d2989/1/packages/lib-api-products/src/provider/checkout-provider/store/const.ts
const Key = (value)=>"byko-checkout:".concat(value);

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-api-products-virtual-81752d2989/1/packages/lib-api-products/src/provider/checkout-provider/store/anonymous-token.ts




var ref;
const _token = (0,lib_recoil_src/* atom */.cn)({
    key: Key("AnonymousToken-hack"),
    default: (0,types_utils_src/* isSSR */.yF)() ? undefined : (ref = localStorage.getItem(LOCAL_KEY)) !== null && ref !== void 0 ? ref : undefined
});
const anonymousTokenStore = (0,lib_recoil_src/* selector */.nZ)({
    key: Key("anonymous-token-store"),
    get: (param)=>{
        let { get  } = param;
        get(_token);
        var ref;
        const value = (0,types_utils_src/* isSSR */.yF)() ? undefined : (ref = localStorage.getItem(LOCAL_KEY)) !== null && ref !== void 0 ? ref : undefined;
        return value;
    },
    set: (props, newValue)=>{
        if (newValue instanceof lib_recoil_src/* DefaultValue */.nY) {
            return;
        }
        if (newValue == null) {
            props.set(_token, null);
            localStorage.removeItem(LOCAL_KEY);
            return;
        }
        props.set(_token, newValue);
        localStorage.setItem(LOCAL_KEY, newValue);
    }
});

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-api-products-virtual-81752d2989/1/packages/lib-api-products/src/provider/checkout-provider/hooks/use-anonymous-token.ts



/**
 * Helper for anonymous token
 * @returns
 */ const useAnonymousToken = ()=>{
    const [token, set] = (0,lib_recoil_src/* useRecoilState */.FV)(anonymousTokenStore);
    const remove = (0,react.useCallback)(()=>{
        set(null);
    }, [
        set
    ]);
    return {
        set,
        remove,
        token: token !== null && token !== void 0 ? token : undefined
    };
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-api-products-virtual-81752d2989/1/packages/lib-api-products/src/provider/checkout-provider/hooks/use-checkout-error.ts

const handleCheckoutError = (err)=>{
    const error = err === null || err === void 0 ? void 0 : err[0];
    if (error) {
        var ref;
        const errorMSG = (ref = checkoutErrorCodeMap[error === null || error === void 0 ? void 0 : error.code]) !== null && ref !== void 0 ? ref : checkoutErrorCodeMap.UNKNOWN;
        console.error(errorMSG);
    }
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-api-products-virtual-81752d2989/1/packages/lib-api-products/src/provider/checkout-provider/store/checkout.ts



const _checkout = (0,lib_recoil_src/* atom */.cn)({
    key: Key("Checkout"),
    default: null
});
const checkout = (0,lib_recoil_src/* selector */.nZ)({
    key: Key("Checkout-Parsed"),
    get: (param)=>{
        let { get  } = param;
        const value = get(_checkout);
        // TODO: Add id to checkout fragment
        if (!value || !value.lines || value.lines.length === 0) {
            return value;
        }
        var ref;
        const lines = ((ref = value === null || value === void 0 ? void 0 : value.lines) !== null && ref !== void 0 ? ref : []).map((e)=>{
            var ref;
            if (e === null || e === void 0 ? void 0 : (ref = e.variant) === null || ref === void 0 ? void 0 : ref.id) {
                var _id, _id1;
                return {
                    ...e,
                    variant: {
                        ...e.variant,
                        product: e.variant.product ? {
                            ...e.variant.product,
                            parsedID: (_id = e.variant.product.id) !== null && _id !== void 0 ? _id : null
                        } : null,
                        parsedID: (_id1 = e.variant.id) !== null && _id1 !== void 0 ? _id1 : null
                    }
                };
            }
            return e;
        }).filter(types_utils_src/* isNotNull */.K0);
        return {
            ...value,
            lines: lines !== null && lines !== void 0 ? lines : []
        };
    }
});

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-api-products-virtual-81752d2989/1/packages/lib-api-products/src/provider/checkout-provider/store/checkout-lines.ts



const checkoutLines = (0,lib_recoil_src/* selector */.nZ)({
    key: Key("CheckoutLines"),
    get: (param)=>{
        let { get  } = param;
        const checkoutValue = get(checkout);
        var ref;
        return (ref = checkoutValue === null || checkoutValue === void 0 ? void 0 : checkoutValue.lines) !== null && ref !== void 0 ? ref : [];
    }
});
const cartObject = (0,lib_recoil_src/* selector */.nZ)({
    key: Key("CartObject"),
    get: (param)=>{
        let { get  } = param;
        const cart = get(checkoutLines);
        return cart.reduce((a, b)=>{
            const id = b.variant.parsedID;
            if (!id) {
                return a;
            }
            a[id] = b;
            return a;
        }, {});
    }
});
const totalCartCount = (0,lib_recoil_src/* selector */.nZ)({
    key: Key("TotalCartCount"),
    get: (param)=>{
        let { get  } = param;
        const items = get(checkoutLines);
        return items.reduce((count, item)=>{
            if ((item === null || item === void 0 ? void 0 : item.quantity) && typeof (item === null || item === void 0 ? void 0 : item.quantity) === "number" && !Number.isNaN(item === null || item === void 0 ? void 0 : item.quantity)) {
                return count + item.quantity;
            }
            return count;
        }, 0);
    }
});
const selectorCartItem = (0,lib_recoil_src/* selectorFamily */.CG)({
    key: Key("SelectorCartItem"),
    get: (id)=>(param)=>{
            let { get  } = param;
            const value = get(cartObject);
            if (value[id]) {}
            var _id;
            return (_id = value[id]) !== null && _id !== void 0 ? _id : null;
        }
});
const selectorCartItemCount = (0,lib_recoil_src/* selectorFamily */.CG)({
    key: Key("SelectorCartItemCount"),
    get: (id)=>{
        return (param)=>{
            let { get  } = param;
            var ref, ref1, ref2;
            const value = get(cartObject);
            if (!value[id]) {
                return 0;
            }
            const count = typeof ((ref = value[id]) === null || ref === void 0 ? void 0 : ref.quantity) === "number" && !Number.isNaN((ref1 = value[id]) === null || ref1 === void 0 ? void 0 : ref1.quantity) ? (ref2 = value[id]) === null || ref2 === void 0 ? void 0 : ref2.quantity : 0;
            return count;
        };
    }
});

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-api-products-virtual-81752d2989/1/packages/lib-api-products/src/provider/checkout-provider/store/loading-cart-state.ts


const loadingCartState = (0,lib_recoil_src/* atom */.cn)({
    key: Key("LoadingCartState"),
    default: {}
});

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-api-products-virtual-81752d2989/1/packages/lib-api-products/src/provider/checkout-provider/store/state.ts


const state = (0,lib_recoil_src/* atom */.cn)({
    key: Key("State"),
    default: "INITIAL_LOAD"
});

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-api-products-virtual-81752d2989/1/packages/lib-api-products/src/provider/checkout-provider/store/atom.ts





const atom_Store = {
    anonymousTokenStore: anonymousTokenStore,
    loadingCartState: loadingCartState,
    _checkout: _checkout,
    checkout: _checkout,
    checkoutLines: checkoutLines,
    cartObject: cartObject,
    state: state,
    totalCartCount: totalCartCount,
    cartItem: selectorCartItem,
    cartItemCount: selectorCartItemCount
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-api-products-virtual-81752d2989/1/packages/lib-api-products/src/provider/checkout-provider/hooks/use-checkout-state.ts


const useSetCheckoutStateValue = ()=>(0,lib_recoil_src/* useSetRecoilState */.Zl)(atom_Store.state);
const useCheckoutState = ()=>{
    const state = (0,lib_recoil_src/* useRecoilValue */.sJ)(atom_Store.state);
    return state;
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-api-products-virtual-81752d2989/1/packages/lib-api-products/src/provider/checkout-provider/hooks/use-checkout.ts


/** TODO: Fix GQL id to number id */ const useSetCheckoutValue = ()=>(0,lib_recoil_src/* useSetRecoilState */.Zl)(atom_Store.checkout);
const useCheckoutLines = ()=>{
    return (0,lib_recoil_src/* useRecoilValue */.sJ)(atom_Store.checkoutLines);
};
const useTotalCartCount = ()=>(0,lib_recoil_src/* useRecoilValue */.sJ)(atom_Store.totalCartCount);
const useCartItemCount = (value)=>(0,lib_recoil_src/* useRecoilValue */.sJ)(atom_Store.cartItemCount("".concat(value !== null && value !== void 0 ? value : 0)));
const useCartItem = (value)=>useRecoilValue(Store.cartItem("".concat(value !== null && value !== void 0 ? value : 0)));

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-api-products-virtual-81752d2989/1/packages/lib-api-products/src/provider/checkout-provider/hooks/use-clear-checkout.ts




const useClearCheckout = (param)=>{
    let { checkout , token  } = param;
    const [handleDelete] = useMutation(CheckoutLineDeleteDocument);
    return (0,react.useCallback)(async ()=>{
        var ref;
        const skus = ((ref = checkout === null || checkout === void 0 ? void 0 : checkout.lines) !== null && ref !== void 0 ? ref : []).filter(types_utils_src/* isNotNull */.K0).map((param)=>{
            let { id  } = param;
            return id;
        });
        await Promise.allSettled(skus.map((sku)=>handleDelete({
                variables: {
                    token,
                    lineId: sku
                }
            })));
    }, [
        checkout === null || checkout === void 0 ? void 0 : checkout.lines,
        handleDelete,
        token
    ]);
};

// EXTERNAL MODULE: ../../.yarn/__virtual__/@apollo-client-virtual-e2a13f3a66/0/cache/@apollo-client-npm-3.7.1-a80032e019-95bb1f226f.zip/node_modules/@apollo/client/utilities/globals/index.js + 4 modules
var globals = __webpack_require__(94896);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@apollo-client-virtual-e2a13f3a66/0/cache/@apollo-client-npm-3.7.1-a80032e019-95bb1f226f.zip/node_modules/@apollo/client/utilities/common/canUse.js
var canUse = __webpack_require__(17182);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@apollo-client-virtual-e2a13f3a66/0/cache/@apollo-client-npm-3.7.1-a80032e019-95bb1f226f.zip/node_modules/@apollo/client/react/hooks/useSyncExternalStore.js



var didWarnUncachedGetSnapshot = false;
var uSESKey = "useSyncExternalStore";
var realHook = react_namespaceObject[uSESKey];
var useSyncExternalStore = realHook || (function (subscribe, getSnapshot, getServerSnapshot) {
    var value = getSnapshot();
    if (__DEV__ &&
        !didWarnUncachedGetSnapshot &&
        value !== getSnapshot()) {
        didWarnUncachedGetSnapshot = true;
        __DEV__ && globals/* invariant.error */.kG.error('The result of getSnapshot should be cached to avoid an infinite loop');
    }
    var _a = react.useState({ inst: { value: value, getSnapshot: getSnapshot } }), inst = _a[0].inst, forceUpdate = _a[1];
    if (canUse/* canUseLayoutEffect */.JC) {
        react.useLayoutEffect(function () {
            Object.assign(inst, { value: value, getSnapshot: getSnapshot });
            if (checkIfSnapshotChanged(inst)) {
                forceUpdate({ inst: inst });
            }
        }, [subscribe, value, getSnapshot]);
    }
    else {
        Object.assign(inst, { value: value, getSnapshot: getSnapshot });
    }
    react.useEffect(function () {
        if (checkIfSnapshotChanged(inst)) {
            forceUpdate({ inst: inst });
        }
        return subscribe(function handleStoreChange() {
            if (checkIfSnapshotChanged(inst)) {
                forceUpdate({ inst: inst });
            }
        });
    }, [subscribe]);
    return value;
});
function checkIfSnapshotChanged(_a) {
    var value = _a.value, getSnapshot = _a.getSnapshot;
    try {
        return value !== getSnapshot();
    }
    catch (_b) {
        return true;
    }
}
//# sourceMappingURL=useSyncExternalStore.js.map
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@apollo-client-virtual-e2a13f3a66/0/cache/@apollo-client-npm-3.7.1-a80032e019-95bb1f226f.zip/node_modules/@apollo/client/utilities/common/compact.js
function compact_compact() {
    var objects = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        objects[_i] = arguments[_i];
    }
    var result = Object.create(null);
    objects.forEach(function (obj) {
        if (!obj)
            return;
        Object.keys(obj).forEach(function (key) {
            var value = obj[key];
            if (value !== void 0) {
                result[key] = value;
            }
        });
    });
    return result;
}
//# sourceMappingURL=compact.js.map
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@apollo-client-virtual-e2a13f3a66/0/cache/@apollo-client-npm-3.7.1-a80032e019-95bb1f226f.zip/node_modules/@apollo/client/utilities/common/mergeOptions.js


function mergeOptions_mergeOptions(defaults, options) {
    return compact_compact(defaults, options, options.variables && {
        variables: (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, (defaults && defaults.variables)), options.variables),
    });
}
//# sourceMappingURL=mergeOptions.js.map
// EXTERNAL MODULE: ../../.yarn/__virtual__/@apollo-client-virtual-e2a13f3a66/0/cache/@apollo-client-npm-3.7.1-a80032e019-95bb1f226f.zip/node_modules/@apollo/client/react/context/ApolloContext.js
var ApolloContext = __webpack_require__(26065);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@apollo-client-virtual-e2a13f3a66/0/cache/@apollo-client-npm-3.7.1-a80032e019-95bb1f226f.zip/node_modules/@apollo/client/utilities/common/arrays.js
function arrays_isNonEmptyArray(value) {
    return Array.isArray(value) && value.length > 0;
}
//# sourceMappingURL=arrays.js.map
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@apollo-client-virtual-e2a13f3a66/0/cache/@apollo-client-npm-3.7.1-a80032e019-95bb1f226f.zip/node_modules/@apollo/client/errors/index.js



function errors_isApolloError(err) {
    return err.hasOwnProperty('graphQLErrors');
}
var errors_generateErrorMessage = function (err) {
    var message = '';
    if (arrays_isNonEmptyArray(err.graphQLErrors) || arrays_isNonEmptyArray(err.clientErrors)) {
        var errors = (err.graphQLErrors || [])
            .concat(err.clientErrors || []);
        errors.forEach(function (error) {
            var errorMessage = error
                ? error.message
                : 'Error message not found.';
            message += "".concat(errorMessage, "\n");
        });
    }
    if (err.networkError) {
        message += "".concat(err.networkError.message, "\n");
    }
    message = message.replace(/\n$/, '');
    return message;
};
var client_errors_ApolloError = (function (_super) {
    (0,tslib_es6/* __extends */.ZT)(ApolloError, _super);
    function ApolloError(_a) {
        var graphQLErrors = _a.graphQLErrors, clientErrors = _a.clientErrors, networkError = _a.networkError, errorMessage = _a.errorMessage, extraInfo = _a.extraInfo;
        var _this = _super.call(this, errorMessage) || this;
        _this.graphQLErrors = graphQLErrors || [];
        _this.clientErrors = clientErrors || [];
        _this.networkError = networkError || null;
        _this.message = errorMessage || errors_generateErrorMessage(_this);
        _this.extraInfo = extraInfo;
        _this.__proto__ = ApolloError.prototype;
        return _this;
    }
    return ApolloError;
}(Error));

//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@apollo-client-virtual-e2a13f3a66/0/cache/@apollo-client-npm-3.7.1-a80032e019-95bb1f226f.zip/node_modules/@apollo/client/core/networkStatus.js
var networkStatus_NetworkStatus;
(function (NetworkStatus) {
    NetworkStatus[NetworkStatus["loading"] = 1] = "loading";
    NetworkStatus[NetworkStatus["setVariables"] = 2] = "setVariables";
    NetworkStatus[NetworkStatus["fetchMore"] = 3] = "fetchMore";
    NetworkStatus[NetworkStatus["refetch"] = 4] = "refetch";
    NetworkStatus[NetworkStatus["poll"] = 6] = "poll";
    NetworkStatus[NetworkStatus["ready"] = 7] = "ready";
    NetworkStatus[NetworkStatus["error"] = 8] = "error";
})(networkStatus_NetworkStatus || (networkStatus_NetworkStatus = {}));
function networkStatus_isNetworkRequestInFlight(networkStatus) {
    return networkStatus ? networkStatus < 7 : false;
}
//# sourceMappingURL=networkStatus.js.map
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@apollo-client-virtual-e2a13f3a66/0/cache/@apollo-client-npm-3.7.1-a80032e019-95bb1f226f.zip/node_modules/@apollo/client/react/parser/index.js

var parser_DocumentType;
(function (DocumentType) {
    DocumentType[DocumentType["Query"] = 0] = "Query";
    DocumentType[DocumentType["Mutation"] = 1] = "Mutation";
    DocumentType[DocumentType["Subscription"] = 2] = "Subscription";
})(parser_DocumentType || (parser_DocumentType = {}));
var parser_cache = new Map();
function parser_operationName(type) {
    var name;
    switch (type) {
        case parser_DocumentType.Query:
            name = 'Query';
            break;
        case parser_DocumentType.Mutation:
            name = 'Mutation';
            break;
        case parser_DocumentType.Subscription:
            name = 'Subscription';
            break;
    }
    return name;
}
function parser_parser(document) {
    var cached = parser_cache.get(document);
    if (cached)
        return cached;
    var variables, type, name;
    __DEV__ ? (0,globals/* invariant */.kG)(!!document && !!document.kind, "Argument of ".concat(document, " passed to parser was not a valid GraphQL ") +
        "DocumentNode. You may need to use 'graphql-tag' or another method " +
        "to convert your operation into a document") : (0,globals/* invariant */.kG)(!!document && !!document.kind, 32);
    var fragments = [];
    var queries = [];
    var mutations = [];
    var subscriptions = [];
    for (var _i = 0, _a = document.definitions; _i < _a.length; _i++) {
        var x = _a[_i];
        if (x.kind === 'FragmentDefinition') {
            fragments.push(x);
            continue;
        }
        if (x.kind === 'OperationDefinition') {
            switch (x.operation) {
                case 'query':
                    queries.push(x);
                    break;
                case 'mutation':
                    mutations.push(x);
                    break;
                case 'subscription':
                    subscriptions.push(x);
                    break;
            }
        }
    }
    __DEV__ ? (0,globals/* invariant */.kG)(!fragments.length ||
        (queries.length || mutations.length || subscriptions.length), "Passing only a fragment to 'graphql' is not yet supported. " +
        "You must include a query, subscription or mutation as well") : (0,globals/* invariant */.kG)(!fragments.length ||
        (queries.length || mutations.length || subscriptions.length), 33);
    __DEV__ ? (0,globals/* invariant */.kG)(queries.length + mutations.length + subscriptions.length <= 1, "react-apollo only supports a query, subscription, or a mutation per HOC. " +
        "".concat(document, " had ").concat(queries.length, " queries, ").concat(subscriptions.length, " ") +
        "subscriptions and ".concat(mutations.length, " mutations. ") +
        "You can use 'compose' to join multiple operation types to a component") : (0,globals/* invariant */.kG)(queries.length + mutations.length + subscriptions.length <= 1, 34);
    type = queries.length ? parser_DocumentType.Query : parser_DocumentType.Mutation;
    if (!queries.length && !mutations.length)
        type = parser_DocumentType.Subscription;
    var definitions = queries.length
        ? queries
        : mutations.length
            ? mutations
            : subscriptions;
    __DEV__ ? (0,globals/* invariant */.kG)(definitions.length === 1, "react-apollo only supports one definition per HOC. ".concat(document, " had ") +
        "".concat(definitions.length, " definitions. ") +
        "You can use 'compose' to join multiple operation types to a component") : (0,globals/* invariant */.kG)(definitions.length === 1, 35);
    var definition = definitions[0];
    variables = definition.variableDefinitions || [];
    if (definition.name && definition.name.kind === 'Name') {
        name = definition.name.value;
    }
    else {
        name = 'data';
    }
    var payload = { name: name, type: type, variables: variables };
    parser_cache.set(document, payload);
    return payload;
}
function parser_verifyDocumentType(document, type) {
    var operation = parser_parser(document);
    var requiredOperationName = parser_operationName(type);
    var usedOperationName = parser_operationName(operation.type);
    __DEV__ ? (0,globals/* invariant */.kG)(operation.type === type, "Running a ".concat(requiredOperationName, " requires a graphql ") +
        "".concat(requiredOperationName, ", but a ").concat(usedOperationName, " was used instead.")) : (0,globals/* invariant */.kG)(operation.type === type, 36);
}
//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@apollo-client-virtual-e2a13f3a66/0/cache/@apollo-client-npm-3.7.1-a80032e019-95bb1f226f.zip/node_modules/@apollo/client/react/hooks/useApolloClient.js



function useApolloClient_useApolloClient(override) {
    var context = (0,react.useContext)((0,ApolloContext/* getApolloContext */.K)());
    var client = override || context.client;
    __DEV__ ? (0,globals/* invariant */.kG)(!!client, 'Could not find "client" in the context or passed in as an option. ' +
        'Wrap the root component in an <ApolloProvider>, or pass an ApolloClient ' +
        'instance in via options.') : (0,globals/* invariant */.kG)(!!client, 31);
    return client;
}
//# sourceMappingURL=useApolloClient.js.map
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@apollo-client-virtual-e2a13f3a66/0/cache/@apollo-client-npm-3.7.1-a80032e019-95bb1f226f.zip/node_modules/@apollo/client/utilities/common/objects.js
function objects_isNonNullObject(obj) {
    return obj !== null && typeof obj === 'object';
}
//# sourceMappingURL=objects.js.map
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@apollo-client-virtual-e2a13f3a66/0/cache/@apollo-client-npm-3.7.1-a80032e019-95bb1f226f.zip/node_modules/@apollo/client/utilities/common/maybeDeepFreeze.js


function maybeDeepFreeze_deepFreeze(value) {
    var workSet = new Set([value]);
    workSet.forEach(function (obj) {
        if (objects_isNonNullObject(obj) && maybeDeepFreeze_shallowFreeze(obj) === obj) {
            Object.getOwnPropertyNames(obj).forEach(function (name) {
                if (objects_isNonNullObject(obj[name]))
                    workSet.add(obj[name]);
            });
        }
    });
    return value;
}
function maybeDeepFreeze_shallowFreeze(obj) {
    if (__DEV__ && !Object.isFrozen(obj)) {
        try {
            Object.freeze(obj);
        }
        catch (e) {
            if (e instanceof TypeError)
                return null;
            throw e;
        }
    }
    return obj;
}
function maybeDeepFreeze_maybeDeepFreeze(obj) {
    if (__DEV__) {
        maybeDeepFreeze_deepFreeze(obj);
    }
    return obj;
}
//# sourceMappingURL=maybeDeepFreeze.js.map
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@apollo-client-virtual-e2a13f3a66/0/cache/@apollo-client-npm-3.7.1-a80032e019-95bb1f226f.zip/node_modules/@apollo/client/react/hooks/useQuery.js












var useQuery_hasOwnProperty = Object.prototype.hasOwnProperty;
function useQuery_useQuery(query, options) {
    if (options === void 0) { options = Object.create(null); }
    return useInternalState(useApolloClient_useApolloClient(options.client), query).useQuery(options);
}
function useInternalState(client, query) {
    var stateRef = (0,react.useRef)();
    if (!stateRef.current ||
        client !== stateRef.current.client ||
        query !== stateRef.current.query) {
        stateRef.current = new InternalState(client, query, stateRef.current);
    }
    var state = stateRef.current;
    var _a = (0,react.useState)(0), _tick = _a[0], setTick = _a[1];
    state.forceUpdate = function () {
        setTick(function (tick) { return tick + 1; });
    };
    return state;
}
var InternalState = (function () {
    function InternalState(client, query, previous) {
        this.client = client;
        this.query = query;
        this.asyncResolveFns = new Set();
        this.optionsToIgnoreOnce = new (canUse/* canUseWeakSet */.sy ? WeakSet : Set)();
        this.ssrDisabledResult = maybeDeepFreeze_maybeDeepFreeze({
            loading: true,
            data: void 0,
            error: void 0,
            networkStatus: networkStatus_NetworkStatus.loading,
        });
        this.skipStandbyResult = maybeDeepFreeze_maybeDeepFreeze({
            loading: false,
            data: void 0,
            error: void 0,
            networkStatus: networkStatus_NetworkStatus.ready,
        });
        this.toQueryResultCache = new (canUse/* canUseWeakMap */.mr ? WeakMap : Map)();
        parser_verifyDocumentType(query, parser_DocumentType.Query);
        var previousResult = previous && previous.result;
        var previousData = previousResult && previousResult.data;
        if (previousData) {
            this.previousData = previousData;
        }
    }
    InternalState.prototype.forceUpdate = function () {
        __DEV__ && globals/* invariant.warn */.kG.warn("Calling default no-op implementation of InternalState#forceUpdate");
    };
    InternalState.prototype.asyncUpdate = function () {
        var _this = this;
        return new Promise(function (resolve) {
            _this.asyncResolveFns.add(resolve);
            _this.optionsToIgnoreOnce.add(_this.watchQueryOptions);
            _this.forceUpdate();
        });
    };
    InternalState.prototype.useQuery = function (options) {
        var _this = this;
        this.renderPromises = (0,react.useContext)((0,ApolloContext/* getApolloContext */.K)()).renderPromises;
        this.useOptions(options);
        var obsQuery = this.useObservableQuery();
        var result = useSyncExternalStore((0,react.useCallback)(function () {
            if (_this.renderPromises) {
                return function () { };
            }
            var onNext = function () {
                var previousResult = _this.result;
                var result = obsQuery.getCurrentResult();
                if (previousResult &&
                    previousResult.loading === result.loading &&
                    previousResult.networkStatus === result.networkStatus &&
                    equal(previousResult.data, result.data)) {
                    return;
                }
                _this.setResult(result);
            };
            var onError = function (error) {
                var last = obsQuery["last"];
                subscription.unsubscribe();
                try {
                    obsQuery.resetLastResults();
                    subscription = obsQuery.subscribe(onNext, onError);
                }
                finally {
                    obsQuery["last"] = last;
                }
                if (!useQuery_hasOwnProperty.call(error, 'graphQLErrors')) {
                    throw error;
                }
                var previousResult = _this.result;
                if (!previousResult ||
                    (previousResult && previousResult.loading) ||
                    !equal(error, previousResult.error)) {
                    _this.setResult({
                        data: (previousResult && previousResult.data),
                        error: error,
                        loading: false,
                        networkStatus: networkStatus_NetworkStatus.error,
                    });
                }
            };
            var subscription = obsQuery.subscribe(onNext, onError);
            return function () { return subscription.unsubscribe(); };
        }, [
            obsQuery,
            this.renderPromises,
            this.client.disableNetworkFetches,
        ]), function () { return _this.getCurrentResult(); }, function () { return _this.getCurrentResult(); });
        this.unsafeHandlePartialRefetch(result);
        var queryResult = this.toQueryResult(result);
        if (!queryResult.loading && this.asyncResolveFns.size) {
            this.asyncResolveFns.forEach(function (resolve) { return resolve(queryResult); });
            this.asyncResolveFns.clear();
        }
        return queryResult;
    };
    InternalState.prototype.useOptions = function (options) {
        var _a;
        var watchQueryOptions = this.createWatchQueryOptions(this.queryHookOptions = options);
        var currentWatchQueryOptions = this.watchQueryOptions;
        if (this.optionsToIgnoreOnce.has(currentWatchQueryOptions) ||
            !equal(watchQueryOptions, currentWatchQueryOptions)) {
            this.watchQueryOptions = watchQueryOptions;
            if (currentWatchQueryOptions && this.observable) {
                this.optionsToIgnoreOnce.delete(currentWatchQueryOptions);
                this.observable.reobserve(this.getObsQueryOptions());
                this.previousData = ((_a = this.result) === null || _a === void 0 ? void 0 : _a.data) || this.previousData;
                this.result = void 0;
            }
        }
        this.onCompleted = options.onCompleted || InternalState.prototype.onCompleted;
        this.onError = options.onError || InternalState.prototype.onError;
        if ((this.renderPromises || this.client.disableNetworkFetches) &&
            this.queryHookOptions.ssr === false &&
            !this.queryHookOptions.skip) {
            this.result = this.ssrDisabledResult;
        }
        else if (this.queryHookOptions.skip ||
            this.watchQueryOptions.fetchPolicy === 'standby') {
            this.result = this.skipStandbyResult;
        }
        else if (this.result === this.ssrDisabledResult ||
            this.result === this.skipStandbyResult) {
            this.result = void 0;
        }
    };
    InternalState.prototype.getObsQueryOptions = function () {
        var toMerge = [];
        var globalDefaults = this.client.defaultOptions.watchQuery;
        if (globalDefaults)
            toMerge.push(globalDefaults);
        if (this.queryHookOptions.defaultOptions) {
            toMerge.push(this.queryHookOptions.defaultOptions);
        }
        toMerge.push(compact_compact(this.observable && this.observable.options, this.watchQueryOptions));
        return toMerge.reduce(mergeOptions_mergeOptions);
    };
    InternalState.prototype.createWatchQueryOptions = function (_a) {
        var _b;
        if (_a === void 0) { _a = {}; }
        var skip = _a.skip, ssr = _a.ssr, onCompleted = _a.onCompleted, onError = _a.onError, defaultOptions = _a.defaultOptions, otherOptions = (0,tslib_es6/* __rest */._T)(_a, ["skip", "ssr", "onCompleted", "onError", "defaultOptions"]);
        var watchQueryOptions = Object.assign(otherOptions, { query: this.query });
        if (this.renderPromises &&
            (watchQueryOptions.fetchPolicy === 'network-only' ||
                watchQueryOptions.fetchPolicy === 'cache-and-network')) {
            watchQueryOptions.fetchPolicy = 'cache-first';
        }
        if (!watchQueryOptions.variables) {
            watchQueryOptions.variables = {};
        }
        if (skip) {
            var _c = watchQueryOptions.fetchPolicy, fetchPolicy = _c === void 0 ? this.getDefaultFetchPolicy() : _c, _d = watchQueryOptions.initialFetchPolicy, initialFetchPolicy = _d === void 0 ? fetchPolicy : _d;
            Object.assign(watchQueryOptions, {
                initialFetchPolicy: initialFetchPolicy,
                fetchPolicy: 'standby',
            });
        }
        else if (!watchQueryOptions.fetchPolicy) {
            watchQueryOptions.fetchPolicy =
                ((_b = this.observable) === null || _b === void 0 ? void 0 : _b.options.initialFetchPolicy) ||
                    this.getDefaultFetchPolicy();
        }
        return watchQueryOptions;
    };
    InternalState.prototype.getDefaultFetchPolicy = function () {
        var _a, _b;
        return (((_a = this.queryHookOptions.defaultOptions) === null || _a === void 0 ? void 0 : _a.fetchPolicy) ||
            ((_b = this.client.defaultOptions.watchQuery) === null || _b === void 0 ? void 0 : _b.fetchPolicy) ||
            "cache-first");
    };
    InternalState.prototype.onCompleted = function (data) { };
    InternalState.prototype.onError = function (error) { };
    InternalState.prototype.useObservableQuery = function () {
        var obsQuery = this.observable =
            this.renderPromises
                && this.renderPromises.getSSRObservable(this.watchQueryOptions)
                || this.observable
                || this.client.watchQuery(this.getObsQueryOptions());
        this.obsQueryFields = (0,react.useMemo)(function () { return ({
            refetch: obsQuery.refetch.bind(obsQuery),
            reobserve: obsQuery.reobserve.bind(obsQuery),
            fetchMore: obsQuery.fetchMore.bind(obsQuery),
            updateQuery: obsQuery.updateQuery.bind(obsQuery),
            startPolling: obsQuery.startPolling.bind(obsQuery),
            stopPolling: obsQuery.stopPolling.bind(obsQuery),
            subscribeToMore: obsQuery.subscribeToMore.bind(obsQuery),
        }); }, [obsQuery]);
        var ssrAllowed = !(this.queryHookOptions.ssr === false ||
            this.queryHookOptions.skip);
        if (this.renderPromises && ssrAllowed) {
            this.renderPromises.registerSSRObservable(obsQuery);
            if (obsQuery.getCurrentResult().loading) {
                this.renderPromises.addObservableQueryPromise(obsQuery);
            }
        }
        return obsQuery;
    };
    InternalState.prototype.setResult = function (nextResult) {
        var previousResult = this.result;
        if (previousResult && previousResult.data) {
            this.previousData = previousResult.data;
        }
        this.result = nextResult;
        this.forceUpdate();
        this.handleErrorOrCompleted(nextResult);
    };
    InternalState.prototype.handleErrorOrCompleted = function (result) {
        var _this = this;
        if (!result.loading) {
            Promise.resolve().then(function () {
                if (result.error) {
                    _this.onError(result.error);
                }
                else if (result.data) {
                    _this.onCompleted(result.data);
                }
            }).catch(function (error) {
                __DEV__ && globals/* invariant.warn */.kG.warn(error);
            });
        }
    };
    InternalState.prototype.getCurrentResult = function () {
        if (!this.result) {
            this.handleErrorOrCompleted(this.result = this.observable.getCurrentResult());
        }
        return this.result;
    };
    InternalState.prototype.toQueryResult = function (result) {
        var queryResult = this.toQueryResultCache.get(result);
        if (queryResult)
            return queryResult;
        var data = result.data, partial = result.partial, resultWithoutPartial = (0,tslib_es6/* __rest */._T)(result, ["data", "partial"]);
        this.toQueryResultCache.set(result, queryResult = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({ data: data }, resultWithoutPartial), this.obsQueryFields), { client: this.client, observable: this.observable, variables: this.observable.variables, called: !this.queryHookOptions.skip, previousData: this.previousData }));
        if (!queryResult.error && arrays_isNonEmptyArray(result.errors)) {
            queryResult.error = new client_errors_ApolloError({ graphQLErrors: result.errors });
        }
        return queryResult;
    };
    InternalState.prototype.unsafeHandlePartialRefetch = function (result) {
        if (result.partial &&
            this.queryHookOptions.partialRefetch &&
            !result.loading &&
            (!result.data || Object.keys(result.data).length === 0) &&
            this.observable.options.fetchPolicy !== 'cache-only') {
            Object.assign(result, {
                loading: true,
                networkStatus: networkStatus_NetworkStatus.refetch,
            });
            this.observable.refetch();
        }
    };
    return InternalState;
}());
//# sourceMappingURL=useQuery.js.map
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-apollo-helpers-virtual-e34935d3ab/1/packages/lib-apollo-helpers/src/use-query.ts




/**
 * Apollo sometimes returns null while fetching new data.
 * This hook will return the previous data while fetching new data.
 *
 */ const useQueryWithPollAndRefetchOnUserStateChange = (_name, query, options, // eslint-disable-next-line @typescript-eslint/no-explicit-any, unused-imports/no-unused-vars
_deps)=>{
    var ref;
    /* Options */ const bindToUserStateChange = (ref = options === null || options === void 0 ? void 0 : options.bindToUserStateChange) !== null && ref !== void 0 ? ref : true;
    var ref1;
    const pollInterval = (ref1 = options === null || options === void 0 ? void 0 : options.pollInterval) !== null && ref1 !== void 0 ? ref1 : 1000 * 60 * 5;
    var ref2;
    const allowUpdate = (ref2 = options === null || options === void 0 ? void 0 : options.allowUpdate) !== null && ref2 !== void 0 ? ref2 : true;
    /* State */ const user = (0,hooks_auth_next_src/* useUser */.aF)();
    const prevUser = (0,lib_utils_src/* usePrevious */.D9)(user);
    const ref3 = (0,react.useRef)(null);
    const optionsWithPoll = (0,react.useMemo)(()=>{
        if (pollInterval) {
            return {
                ...options,
                pollInterval
            };
        }
        return options;
    }, [
        options,
        pollInterval
    ]);
    const { data , error , loading , refetch , ...rest } = useQuery_useQuery(query, optionsWithPoll);
    const errorObj = error ? {
        error
    } : {};
    (0,react.useEffect)(()=>{
        if ((options === null || options === void 0 ? void 0 : options.skip) || !allowUpdate) {
            return;
        }
        /**
     * Refetch if user state changes
     */ if (user !== prevUser && bindToUserStateChange) {
            void refetch(options === null || options === void 0 ? void 0 : options.variables);
        }
        return;
    }, [
        prevUser,
        user,
        refetch,
        options,
        bindToUserStateChange,
        allowUpdate
    ]);
    //useEffect(() => {
    /**
   * Refetch if deps change
   */ /* if (options?.skip || !allowUpdate) {
      return;
    }
    console.log("refetch ueQuery");
    void refetch(options?.variables);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [deps]);*/ /**
   * if user state has changed, return undefined data.
   */ if (bindToUserStateChange && user !== prevUser) {
        return {
            data: undefined,
            ...errorObj,
            loading,
            ...rest,
            refetch
        };
    }
    /**
   * If data exists update ref.
   */ if (data) {
        ref3.current = data;
    }
    /**
   * Always show undefined if skip is true.
   */ if (options === null || options === void 0 ? void 0 : options.skip) {
        return {
            ...rest,
            data: undefined,
            loading: false,
            refetch
        };
    }
    var _current;
    /**
   * Returns previous data or loaded data.
   */ return {
        data: (_current = ref3.current) !== null && _current !== void 0 ? _current : undefined,
        loading: ref3.current ? false : loading,
        ...errorObj,
        refetch,
        ...rest
    };
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-apollo-helpers-virtual-e34935d3ab/1/packages/lib-apollo-helpers/src/index.ts


;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-api-products-virtual-81752d2989/1/packages/lib-api-products/src/provider/checkout-provider/hooks/use-get-checkout.ts










const useGetCheckout = function() {
    let { shouldForceReloadOnInit =true  } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var ref, ref1, ref2, ref3;
    const { user , loading  } = (0,hooks_auth_next_src/* useAuth */.aC)();
    const showLogin = !loading;
    const { token: anonymousToken  } = useAnonymousToken();
    const checkout = (0,lib_recoil_src/* useRecoilValue */.sJ)(atom_Store.checkout);
    const setCheckoutValue = useSetCheckoutValue();
    const currentState = useCheckoutState();
    const setState = useSetCheckoutStateValue();
    const { data: anonCheckoutQuery , loading: anonCheckoutLoading , refetch: refetchCheckout  } = useQueryWithPollAndRefetchOnUserStateChange("AnonymousCheckoutByToken", AnonymousCheckoutByTokenDocument, {
        skip: !anonymousToken,
        variables: {
            token: anonymousToken
        },
        allowUpdate: currentState !== "LOADING",
        nextFetchPolicy: "no-cache",
        errorPolicy: "all",
        pollInterval: POLL_CHECKOUT
    }, [
        currentState,
        anonymousToken
    ]);
    const { data: myCheckoutQuery , loading: myCheckoutLoading , refetch: refetchMyCheckout  } = useQueryWithPollAndRefetchOnUserStateChange("MyCheckout", MyCheckoutDocument, {
        skip: !user,
        allowUpdate: currentState !== "LOADING",
        errorPolicy: "all",
        nextFetchPolicy: "no-cache",
        pollInterval: POLL_CHECKOUT
    }, [
        currentState,
        user
    ]);
    const handleUpdate = (0,react.useCallback)(async ()=>{
        if (checkout !== null) {
            return null;
        }
        if (user) {
            var ref;
            const value = await refetchMyCheckout();
            var ref1;
            const myCheckout = (ref1 = (ref = value.data.me) === null || ref === void 0 ? void 0 : ref.checkout) !== null && ref1 !== void 0 ? ref1 : null;
            setCheckoutValue(myCheckout);
            return myCheckout !== null && myCheckout !== void 0 ? myCheckout : null;
        }
        if (anonymousToken) {
            const value1 = await refetchCheckout();
            var _checkout;
            const anonCheckout = (_checkout = value1.data.checkout) !== null && _checkout !== void 0 ? _checkout : null;
            setCheckoutValue(anonCheckout);
            return anonCheckout;
        }
        setCheckoutValue(null);
        return null;
    }, [
        anonymousToken,
        refetchCheckout,
        refetchMyCheckout,
        setCheckoutValue,
        user,
        checkout
    ]);
    (0,react.useEffect)(()=>{
        if (currentState === "LOADING") {
            return;
        }
        handleUpdate();
    }, [
        myCheckoutQuery,
        anonCheckoutQuery,
        anonymousToken,
        user,
        handleUpdate,
        currentState
    ]);
    const handleInitialLoad = (0,react.useCallback)(async ()=>{
        await handleUpdate();
        setState("READY");
    }, [
        handleUpdate,
        setState
    ]);
    (0,react.useEffect)(()=>{
        if (!shouldForceReloadOnInit) {
            return;
        }
        handleInitialLoad();
    }, [
        handleInitialLoad,
        shouldForceReloadOnInit
    ]);
    const checkoutReady = (0,react.useMemo)(()=>{
        if (!showLogin) {
            return false;
        }
        if (user) {
            var ref;
            return (myCheckoutQuery === null || myCheckoutQuery === void 0 ? void 0 : (ref = myCheckoutQuery.me) === null || ref === void 0 ? void 0 : ref.checkout) != null;
        }
        return (anonCheckoutQuery === null || anonCheckoutQuery === void 0 ? void 0 : anonCheckoutQuery.checkout) != null;
    }, [
        anonCheckoutQuery === null || anonCheckoutQuery === void 0 ? void 0 : anonCheckoutQuery.checkout,
        myCheckoutQuery === null || myCheckoutQuery === void 0 ? void 0 : (ref = myCheckoutQuery.me) === null || ref === void 0 ? void 0 : ref.checkout,
        showLogin,
        user
    ]);
    const refetch = (0,react.useCallback)(async ()=>{
        if (user) {
            await refetchMyCheckout();
            return;
        }
        await refetchCheckout();
    }, [
        refetchCheckout,
        refetchMyCheckout,
        user
    ]);
    const checkoutLine = (0,react.useMemo)(()=>{
        var ref, ref1;
        if (showLogin) {
            return [];
        }
        if (!user) {
            var ref2;
            var ref3;
            return (ref3 = anonCheckoutQuery === null || anonCheckoutQuery === void 0 ? void 0 : (ref2 = anonCheckoutQuery.checkout) === null || ref2 === void 0 ? void 0 : ref2.lines) !== null && ref3 !== void 0 ? ref3 : [];
        }
        var ref4;
        return (ref4 = myCheckoutQuery === null || myCheckoutQuery === void 0 ? void 0 : (ref = myCheckoutQuery.me) === null || ref === void 0 ? void 0 : (ref1 = ref.checkout) === null || ref1 === void 0 ? void 0 : ref1.lines) !== null && ref4 !== void 0 ? ref4 : [];
    }, [
        showLogin,
        user,
        myCheckoutQuery === null || myCheckoutQuery === void 0 ? void 0 : (ref1 = myCheckoutQuery.me) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.checkout) === null || ref2 === void 0 ? void 0 : ref2.lines,
        anonCheckoutQuery === null || anonCheckoutQuery === void 0 ? void 0 : (ref3 = anonCheckoutQuery.checkout) === null || ref3 === void 0 ? void 0 : ref3.lines
    ]);
    return {
        checkoutReady,
        checkoutLine,
        update: handleUpdate,
        refetch,
        refetchCheckout,
        refetchMyCheckout,
        anonCheckoutQuery,
        myCheckoutQuery,
        myCheckoutLoading,
        anonCheckoutLoading
    };
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-api-products-virtual-81752d2989/1/packages/lib-api-products/src/provider/checkout-provider/hooks/use-update-shipping-method.tsx
/* eslint-disable @typescript-eslint/no-explicit-any */ 

const useUpdateShippingMethod = (param)=>{
    let { refetch , myCheckoutQuery  } = param;
    var ref, ref1;
    const [checkoutShippingMethodUpdate] = useCheckoutShippingMethodUpdateMutation({
        onCompleted: ()=>refetch()
    });
    return (0,react.useCallback)((id)=>{
        var ref, ref1;
        return checkoutShippingMethodUpdate({
            variables: {
                token: myCheckoutQuery === null || myCheckoutQuery === void 0 ? void 0 : (ref = myCheckoutQuery.me) === null || ref === void 0 ? void 0 : (ref1 = ref.checkout) === null || ref1 === void 0 ? void 0 : ref1.token,
                shippingMethodId: id
            }
        }).then((res)=>res);
    }, [
        checkoutShippingMethodUpdate,
        myCheckoutQuery === null || myCheckoutQuery === void 0 ? void 0 : (ref = myCheckoutQuery.me) === null || ref === void 0 ? void 0 : (ref1 = ref.checkout) === null || ref1 === void 0 ? void 0 : ref1.token
    ]);
};

// EXTERNAL MODULE: ../../.yarn/cache/lodash-npm-4.17.21-6382451519-eb835a2e51.zip/node_modules/lodash/toPairs.js
var toPairs = __webpack_require__(65399);
var toPairs_default = /*#__PURE__*/__webpack_require__.n(toPairs);
// EXTERNAL MODULE: ../../.yarn/cache/uuid-npm-9.0.0-46c41e3e43-8dd2c83c43.zip/node_modules/uuid/dist/esm-browser/v4.js + 3 modules
var v4 = __webpack_require__(54106);
// EXTERNAL MODULE: ../../.yarn/cache/lodash-npm-4.17.21-6382451519-eb835a2e51.zip/node_modules/lodash/fromPairs.js
var fromPairs = __webpack_require__(98235);
var fromPairs_default = /*#__PURE__*/__webpack_require__.n(fromPairs);
// EXTERNAL MODULE: ../../.yarn/cache/lodash-npm-4.17.21-6382451519-eb835a2e51.zip/node_modules/lodash/lodash.js
var lodash = __webpack_require__(35735);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-api-products-virtual-81752d2989/1/packages/lib-api-products/src/provider/checkout-provider/utils/ensure-list.ts

/**
 * Always returns a list with `null` and `undefined` values removed.
 *
 * ```typescript
 * ensureList() // => []
 * ensureList(null) // => []
 * ensureList([null, undefined, true, false, '', 0]) // => [true, false, '', 0]
 * ```
 */ const ensureList = (arg)=>{
    const list = (0,lodash.isArray)(arg) ? arg : [
        arg
    ];
    return (0,lodash.filter)(list, (x)=>x != null);
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-api-products-virtual-81752d2989/1/packages/lib-api-products/src/provider/checkout-provider/utils/get-cart-quantity-map.ts


const getCartQuantityMap = (cart, variantIds)=>{
    let pairs = ensureList(cart === null || cart === void 0 ? void 0 : cart.lines).map((line)=>[
            line.variant.id,
            line.quantity
        ]);
    if (variantIds != null) {
        pairs = pairs.filter((param)=>{
            let [id] = param;
            return variantIds.includes(id);
        });
    }
    return fromPairs_default()(pairs);
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-api-products-virtual-81752d2989/1/packages/lib-api-products/src/provider/checkout-provider/hooks/use-update-store.ts











const typeIsError = (value)=>value != null && Array.isArray(value);
let id = null;
const useUpdateStore = (param)=>{
    let { refetchMyCheckout , refetchCheckout  } = param;
    const user = (0,hooks_auth_next_src/* useUser */.aF)();
    const { token: anonymousToken , set: setAnonymousToken  } = useAnonymousToken();
    const [checkoutLinesUpdate] = useCheckoutLinesUpdateMutation({});
    const setState = useSetCheckoutStateValue();
    const setLoading = (0,lib_recoil_src/* useSetRecoilState */.Zl)(atom_Store.loadingCartState);
    //const setCheckoutValue = useSetCheckoutValue();
    const [checkoutCreate] = useCheckoutCreateMutation({
        onError: (err)=>{
            // eslint-disable-next-line no-console
            console.error(err);
        }
    });
    (0,react.useEffect)(()=>{
        const fn = ()=>{
            id = null;
        };
        document.body.addEventListener("CheckoutChange", fn);
        return ()=>{
            document.body.removeEventListener("CheckoutChange", fn);
        };
    }, []);
    const handleCreateCheckout = (0,react.useCallback)(async (stateUpdate)=>{
        let nextCheckout;
        if (user) {
            // Fetching existing or 'authenticated' checkout
            const refetchRes = await refetchMyCheckout();
            if (refetchRes) {
                var ref;
                var ref1;
                nextCheckout = (ref1 = (ref = refetchRes.data.me) === null || ref === void 0 ? void 0 : ref.checkout) !== null && ref1 !== void 0 ? ref1 : undefined;
            }
            // Creating new 'authenticated' checkout
            if (!nextCheckout) {
                var ref2, ref3, ref4, ref5, ref6, ref7;
                var _email;
                const email = (_email = user.verified.email) !== null && _email !== void 0 ? _email : "".concat(user.id, "@user.saleor");
                const data = await checkoutCreate({
                    variables: {
                        email,
                        lines: toPairs_default()(stateUpdate).map((param)=>{
                            let [variantId, quantity] = param;
                            return {
                                quantity,
                                variantId
                            };
                        })
                    }
                });
                if (((ref2 = data.data) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.checkoutCreate) === null || ref3 === void 0 ? void 0 : ref3.errors) && !((ref4 = data.data) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.checkoutCreate) === null || ref5 === void 0 ? void 0 : ref5.created)) {
                    const errorCode = data.data.checkoutCreate.errors.find((err)=>{
                        return CHECKOUT_ERRORS.includes(err === null || err === void 0 ? void 0 : err.code);
                    });
                    if (errorCode) {
                        return errorCode.code;
                    }
                    return "UNKNOWN";
                }
                nextCheckout = (ref6 = data.data) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.checkoutCreate) === null || ref7 === void 0 ? void 0 : ref7.checkout;
            }
        } else if (anonymousToken) {
            var ref8, ref9;
            // Fetching existing 'anonymous' checkout
            nextCheckout = (ref8 = await refetchCheckout()) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.data) === null || ref9 === void 0 ? void 0 : ref9.checkout;
        } else {
            var ref10, ref11, ref12, ref13, ref14, ref15;
            // Creating new 'anonymous' checkout
            const data1 = await checkoutCreate({
                variables: {
                    email: "".concat((0,v4/* default */.Z)(), "@anonymous.saleor"),
                    lines: toPairs_default()(stateUpdate).map((param)=>{
                        let [variantId, quantity] = param;
                        return {
                            quantity,
                            variantId
                        };
                    })
                }
            });
            if (((ref10 = data1.data) === null || ref10 === void 0 ? void 0 : (ref11 = ref10.checkoutCreate) === null || ref11 === void 0 ? void 0 : ref11.errors) && !((ref12 = data1.data) === null || ref12 === void 0 ? void 0 : (ref13 = ref12.checkoutCreate) === null || ref13 === void 0 ? void 0 : ref13.created)) {
                const errorCode1 = data1.data.checkoutCreate.errors.find((err)=>{
                    return CHECKOUT_ERRORS.includes(err === null || err === void 0 ? void 0 : err.code);
                });
                if (errorCode1) {
                    return errorCode1.code;
                }
                return "UNKNOWN";
            }
            nextCheckout = data1 === null || data1 === void 0 ? void 0 : (ref14 = data1.data) === null || ref14 === void 0 ? void 0 : (ref15 = ref14.checkoutCreate) === null || ref15 === void 0 ? void 0 : ref15.checkout;
            if (nextCheckout && nextCheckout.token) {
                setAnonymousToken(nextCheckout === null || nextCheckout === void 0 ? void 0 : nextCheckout.token);
            }
        }
        if (typeIsError(nextCheckout)) {
            return "UNKNOWN";
        }
        return nextCheckout;
    }, [
        anonymousToken,
        checkoutCreate,
        refetchMyCheckout,
        refetchCheckout,
        setAnonymousToken,
        user
    ]);
    const handleUpdateCheckout = (0,react.useCallback)(async (param)=>{
        let { toUpdate , checkout  } = param;
        var ref, ref1;
        const currentId = (0,v4/* default */.Z)();
        id = currentId;
        const checkoutUpdate = toUpdate.length ? (ref = await checkoutLinesUpdate({
            variables: {
                token: checkout === null || checkout === void 0 ? void 0 : checkout.token,
                lines: toUpdate.map((param)=>{
                    let [variantId, quantity] = param;
                    return {
                        quantity,
                        variantId
                    };
                })
            }
        })) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : ref1.checkoutLinesUpdate : {
            errors: []
        };
        //setCheckoutValue(checkout);
        const errors = checkoutUpdate === null || checkoutUpdate === void 0 ? void 0 : checkoutUpdate.errors;
        if (errors && errors.length > 0) {
            const errorCode = errors.find((err)=>{
                return CHECKOUT_ERRORS.includes(err === null || err === void 0 ? void 0 : err.code);
            });
            if (errorCode) {
                return errorCode.code;
            }
            return "UNKNOWN";
        }
        if (id === currentId) {
            setLoading({});
        }
        return;
    }, [
        checkoutLinesUpdate,
        setLoading
    ]);
    const getStore = (0,react.useCallback)(async (stateUpdate)=>{
        setState("LOADING");
        // TODO(Andri): refactor this
        const checkout = await handleCreateCheckout(stateUpdate);
        if (!checkout) {
            return "UNKNOWN";
        }
        if (typeof checkout == "string") {
            return checkout;
        }
        const currentState = getCartQuantityMap(checkout);
        const stateUpdatePairs = toPairs_default()(stateUpdate);
        const toUpdate = stateUpdatePairs.filter((param)=>{
            let [vId, qty] = param;
            return currentState[vId] !== qty;
        });
        setLoading(toUpdate.reduce((a, b)=>({
                ...a,
                [b[0]]: b[1]
            }), {}));
        const possibleErrorValue = await handleUpdateCheckout({
            toUpdate,
            checkout
        });
        setState("READY");
        if (possibleErrorValue) {
            return possibleErrorValue;
        }
        return;
    }, [
        setState,
        handleCreateCheckout,
        setLoading,
        handleUpdateCheckout
    ]);
    const handleUpdate = (0,react.useCallback)(async (stateUpdate)=>{
        const value = await getStore(stateUpdate);
        if (value) {
            var _value;
            return {
                code: value,
                message: (_value = checkoutErrorCodeMap[value]) !== null && _value !== void 0 ? _value : checkoutErrorCodeMap.UNKNOWN
            };
        }
    }, [
        getStore
    ]);
    return (0,react.useMemo)(()=>({
            update: handleUpdate
        }), [
        handleUpdate
    ]);
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-api-products-virtual-81752d2989/1/packages/lib-api-products/src/provider/checkout-provider/hooks/index.ts









;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-api-products-virtual-81752d2989/1/packages/lib-api-products/src/provider/checkout-provider/checkout-context-provider.tsx
/* eslint-disable @typescript-eslint/no-explicit-any */ 




const CheckoutContext = /*#__PURE__*/ (0,react.createContext)(null);
const CheckoutProvider = (param)=>{
    let { children  } = param;
    var ref, ref1, ref2, ref3, ref4;
    const { checkoutReady , checkoutLine , anonCheckoutQuery , myCheckoutQuery , myCheckoutLoading , anonCheckoutLoading , refetchCheckout , refetchMyCheckout , refetch  } = useGetCheckout();
    const { update  } = useUpdateStore({
        refetch,
        refetchCheckout,
        refetchMyCheckout
    });
    const { user , loading  } = (0,hooks_auth_next_src/* useAuth */.aC)();
    const showLogin = !loading;
    const handleUpdateShippingMethod = useUpdateShippingMethod({
        refetch,
        myCheckoutQuery
    });
    const [checkoutAddressesUpdateMutation] = useCheckoutAddressesUpdateMutation({
        onCompleted: ()=>refetch()
    });
    const [checkoutEmailUpdate] = useCheckoutEmailUpdateMutation();
    const [checkoutPaymentCreate] = useCheckoutPaymentCreateMutation();
    const [checkoutComplete] = useCheckoutCompleteMutation();
    var ref5, ref6;
    const checkoutToken = (ref6 = (ref5 = myCheckoutQuery === null || myCheckoutQuery === void 0 ? void 0 : (ref = myCheckoutQuery.me) === null || ref === void 0 ? void 0 : (ref1 = ref.checkout) === null || ref1 === void 0 ? void 0 : ref1.token) !== null && ref5 !== void 0 ? ref5 : anonCheckoutQuery === null || anonCheckoutQuery === void 0 ? void 0 : (ref2 = anonCheckoutQuery.checkout) === null || ref2 === void 0 ? void 0 : ref2.token) !== null && ref6 !== void 0 ? ref6 : undefined;
    const updateCheckoutAddresses = (0,react.useCallback)((shippingAddress, billingAddress)=>checkoutAddressesUpdateMutation({
            variables: {
                token: checkoutToken,
                shippingAddress,
                billingAddress
            }
        }).then((res)=>res), [
        checkoutAddressesUpdateMutation,
        checkoutToken
    ]);
    const updateCheckoutEmail = (0,react.useCallback)((email)=>{
        return checkoutEmailUpdate({
            variables: {
                email,
                token: checkoutToken
            }
        }).then((res)=>{
            var ref, ref1;
            handleCheckoutError(res === null || res === void 0 ? void 0 : (ref = res.data) === null || ref === void 0 ? void 0 : (ref1 = ref.checkoutEmailUpdate) === null || ref1 === void 0 ? void 0 : ref1.errors);
        });
    }, [
        checkoutEmailUpdate,
        checkoutToken
    ]);
    const createPayment = (0,react.useCallback)((input)=>{
        return checkoutPaymentCreate({
            variables: {
                token: checkoutToken,
                input
            }
        }).then((res)=>{
            var ref;
            return res === null || res === void 0 ? void 0 : (ref = res.data) === null || ref === void 0 ? void 0 : ref.checkoutPaymentCreate;
        });
    }, [
        checkoutPaymentCreate,
        checkoutToken
    ]);
    const completeCheckout = (0,react.useCallback)(async (paymentData)=>{
        var ref;
        const result = await checkoutComplete({
            variables: {
                token: checkoutToken,
                paymentData: paymentData !== null && paymentData !== void 0 ? paymentData : null
            }
        });
        return result === null || result === void 0 ? void 0 : (ref = result.data) === null || ref === void 0 ? void 0 : ref.checkoutComplete;
    }, [
        checkoutComplete,
        checkoutToken
    ]);
    const getVariant = (0,react.useCallback)((variantId)=>{
        const value = checkoutLine.find((item)=>item.variant.id === variantId);
        return value !== null && value !== void 0 ? value : null;
    }, [
        checkoutLine
    ]);
    const isCheckoutLoading = (0,react.useMemo)(()=>{
        if (!showLogin) {
            return true;
        }
        if (user) {
            return myCheckoutLoading;
        }
        return anonCheckoutLoading;
    }, [
        anonCheckoutLoading,
        myCheckoutLoading,
        showLogin,
        user
    ]);
    const checkout = (0,react.useMemo)(()=>{
        if (showLogin && user) {
            var ref;
            var ref1;
            return (ref1 = myCheckoutQuery === null || myCheckoutQuery === void 0 ? void 0 : (ref = myCheckoutQuery.me) === null || ref === void 0 ? void 0 : ref.checkout) !== null && ref1 !== void 0 ? ref1 : undefined;
        }
        var ref2;
        return (ref2 = anonCheckoutQuery === null || anonCheckoutQuery === void 0 ? void 0 : anonCheckoutQuery.checkout) !== null && ref2 !== void 0 ? ref2 : undefined;
    }, [
        anonCheckoutQuery === null || anonCheckoutQuery === void 0 ? void 0 : anonCheckoutQuery.checkout,
        myCheckoutQuery === null || myCheckoutQuery === void 0 ? void 0 : (ref3 = myCheckoutQuery.me) === null || ref3 === void 0 ? void 0 : ref3.checkout,
        showLogin,
        user
    ]);
    const token = (0,react.useMemo)(()=>{
        var ref;
        if (showLogin && user) {
            var ref1, ref2;
            var ref3;
            return (ref3 = myCheckoutQuery === null || myCheckoutQuery === void 0 ? void 0 : (ref1 = myCheckoutQuery.me) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.checkout) === null || ref2 === void 0 ? void 0 : ref2.token) !== null && ref3 !== void 0 ? ref3 : undefined;
        }
        var ref4;
        return (ref4 = anonCheckoutQuery === null || anonCheckoutQuery === void 0 ? void 0 : (ref = anonCheckoutQuery.checkout) === null || ref === void 0 ? void 0 : ref.token) !== null && ref4 !== void 0 ? ref4 : undefined;
    }, [
        anonCheckoutQuery === null || anonCheckoutQuery === void 0 ? void 0 : anonCheckoutQuery.checkout,
        myCheckoutQuery === null || myCheckoutQuery === void 0 ? void 0 : (ref4 = myCheckoutQuery.me) === null || ref4 === void 0 ? void 0 : ref4.checkout,
        showLogin,
        user
    ]);
    const handleClearCart = useClearCheckout({
        token,
        checkout
    });
    const value = (0,react.useMemo)(()=>({
            checkoutReady,
            getVariant,
            checkoutLine,
            cartUpdate: update,
            clearCart: handleClearCart,
            updateShippingMethod: handleUpdateShippingMethod,
            updateCheckoutAddresses,
            updateCheckoutEmail,
            createPayment,
            completeCheckout,
            checkout,
            checkoutLoading: isCheckoutLoading
        }), [
        checkoutReady,
        getVariant,
        checkoutLine,
        update,
        handleClearCart,
        handleUpdateShippingMethod,
        updateCheckoutAddresses,
        updateCheckoutEmail,
        createPayment,
        completeCheckout,
        checkout,
        isCheckoutLoading
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckoutContext.Provider, {
        value: value,
        children: children
    });
};
const useCheckout = ()=>{
    const value = (0,react.useContext)(CheckoutContext);
    if (value == null) {
        throw new Error("Should be used inside provider");
    }
    return value;
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-api-products-virtual-81752d2989/1/packages/lib-api-products/src/provider/checkout-provider/store/index.ts







;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-api-products-virtual-81752d2989/1/packages/lib-api-products/src/provider/checkout-provider/index.tsx





;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-api-products-virtual-81752d2989/1/packages/lib-api-products/src/provider/index.ts




;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-api-products-virtual-81752d2989/1/packages/lib-api-products/src/hooks/const.ts
const ProductFailImages = [
    {
        url: "https://www.datocms-assets.com/65892/1664464657-placeholder-do-not-remove.jpg",
        alt: ""
    },
    {
        url: "https://www.datocms-assets.com/65892/1664464657-placeholder-do-not-remove.jpg",
        alt: ""
    }
];
const FailBackImages = {
    url: "https://www.datocms-assets.com/65892/1664464657-placeholder-do-not-remove.jpg",
    alt: ""
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-api-products-virtual-81752d2989/1/packages/lib-api-products/src/hooks/to-global-id.ts
/* provided dependency */ var Buffer = __webpack_require__(85474)["Buffer"];
const toGlobalId = (model, id)=>{
    const label = "".concat(model, ":").concat(id);
    if ( false || typeof btoa === "undefined") {
        return Buffer.from(label).toString("base64");
    }
    return window.btoa(label);
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-api-products-virtual-81752d2989/1/packages/lib-api-products/src/hooks/use-product-by-slug.ts
/* eslint-disable @typescript-eslint/no-explicit-any */ 








const algoliaHitToProduct = (hitValue)=>{
    var ref, ref1, ref2, ref3, ref4;
    // FIXME: This method should not exist. Frontend should use ProductList and not augment it
    if (!hitValue) {
        return null;
    }
    var _alt;
    const image = ((ref = hitValue.firstImage) === null || ref === void 0 ? void 0 : (ref1 = ref.image) === null || ref1 === void 0 ? void 0 : ref1.productGallery2x) ? {
        alt: (_alt = hitValue.firstImage.alt) !== null && _alt !== void 0 ? _alt : "",
        url: (ref2 = hitValue.firstImage) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.image) === null || ref3 === void 0 ? void 0 : ref3.productGallery2x
    } : ProductFailImages[Math.floor(Math.random() * ProductFailImages.length)];
    var ref5;
    return {
        ...hitValue,
        description: (ref5 = hitValue === null || hitValue === void 0 ? void 0 : (ref4 = hitValue.shortDescription) === null || ref4 === void 0 ? void 0 : ref4.is) !== null && ref5 !== void 0 ? ref5 : "",
        media: [
            image
        ],
        thumbnail: image
    };
};
const productBySlug = async (slug)=>{
    var ref, ref1, ref2, ref3, ref4, ref5;
    // FIXME: This method should not exist. Frontend should use ProductDetail and not augment it
    if (slug == null) {
        return null;
    }
    const { data , error  } = await src/* restApi.productsBySlugRetrieve */._O.productsBySlugRetrieve(slug);
    // TODO:
    if (error) {
        throw new Error(error);
    }
    if (!data) {
        return null;
    }
    const breadcrumbs = (0,lib_category_helper_src/* getCategoriesAndBreadcrumb */.UY)(data.categories, {
        title: data.name,
        slug: data.slug
    });
    var _alt;
    const image = ((ref = data.firstImage) === null || ref === void 0 ? void 0 : (ref1 = ref.image) === null || ref1 === void 0 ? void 0 : ref1.productGallery2x) ? {
        alt: (_alt = data.firstImage.alt) !== null && _alt !== void 0 ? _alt : "",
        url: (ref2 = data.firstImage) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.image) === null || ref3 === void 0 ? void 0 : ref3.productGallery2x
    } : ProductFailImages[Math.floor(Math.random() * ProductFailImages.length)];
    var ref6, _alt1, ref7;
    // TODO: Add video
    const media = (ref7 = (ref4 = data.media) === null || ref4 === void 0 ? void 0 : ref4.filter((e)=>"image" in e).filter((e)=>{
        var ref;
        return (ref = e.image) === null || ref === void 0 ? void 0 : ref.productGallery2x;
    }).map((e)=>{
        var ref;
        return {
            id: e.id,
            url: (ref6 = (ref = e.image) === null || ref === void 0 ? void 0 : ref.productGallery2x) !== null && ref6 !== void 0 ? ref6 : "",
            alt: (_alt1 = e.alt) !== null && _alt1 !== void 0 ? _alt1 : ""
        };
    })) !== null && ref7 !== void 0 ? ref7 : [];
    const variants = data.variants.map((variant)=>{
        Object.keys(variant.attributes).forEach((e)=>{
            const item = variant.attributes[e];
            if (typeof item === "object" && "is-IS" in item && "en" in item) {
                variant.attributes[e] = item["is-IS"];
            }
        });
        return variant;
    });
    const attributes = variants.reduce((a, b)=>{
        Object.keys(b.attributes).forEach((e)=>{
            let item = b.attributes[e];
            const compareItem = a[e];
            if (typeof item === "object" && "is-IS" in item && "en" in item) {
                item = item["is-IS"];
            }
            if (!a[e]) {
                a[e] = item;
                return;
            }
            if (!compareItem) {
                // Only for typing.
                return;
            }
            if (!Array.isArray(compareItem)) {
                if (typeof item === "object" && e !== null) {
                    const firstItemKey = Object.keys(item)[0];
                    if (!firstItemKey) {
                        return;
                    }
                    const firstItem = item[firstItemKey];
                    const compareItemChild = compareItem[firstItemKey];
                    if (firstItem === compareItemChild) {
                        // Atttribute already exists.
                        return;
                    }
                    a[e] = [
                        compareItem,
                        item
                    ];
                    return;
                }
                if (item === compareItem) {
                    // Atttribute already exists.
                    return;
                }
                a[e] = [
                    compareItem,
                    item
                ];
                return;
            }
            if (typeof item === "object" && e !== null) {
                const firstItemKey1 = Object.keys(item)[0];
                const hasItem = !!compareItem.find((compareItemItem)=>{
                    return compareItemItem[firstItemKey1] === item[firstItemKey1];
                });
                if (hasItem) {
                    return;
                }
                a[e] = [
                    ...compareItem,
                    item
                ];
            }
            if (compareItem.includes(item)) {
                return;
            }
            a[e] = [
                ...compareItem,
                item
            ];
        });
        return a;
    }, {});
    var ref8;
    return {
        ...data,
        breadcrumbs,
        description: (ref8 = data === null || data === void 0 ? void 0 : (ref5 = data.shortDescription) === null || ref5 === void 0 ? void 0 : ref5.is) !== null && ref8 !== void 0 ? ref8 : "",
        media: media,
        thumbnail: image,
        attributes
    };
};
const useProductBySlug = function(slug) {
    let enabled = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
    const { data , error , isLoading  } = useQuery([
        "productBySlug",
        slug
    ], ()=>productBySlug(slug), {
        enabled: enabled && slug != null,
        refetchOnWindowFocus: false
    });
    const [product, setProduct] = useRecoilState(productStore(slug !== null && slug !== void 0 ? slug : null));
    useEffect(()=>{
        setProduct(product);
    }, [
        product,
        setProduct
    ]);
    return {
        error: error ? new ApolloError({
            errorMessage: "something went wrong"
        }) : null,
        loading: isLoading,
        data: typeof data === "object" ? data : product !== null && product !== void 0 ? product : null,
        notFound: data === null
    };
};
const productStore = (0,lib_recoil_src/* atomFamily */.xu)({
    key: "productStore",
    default: null
});
const useProductCartVariantHelper = (fn, deps)=>{
    return (0,lib_recoil_src/* useRecoilCallback */._8)((param)=>{
        let { snapshot , set  } = param;
        return async (param)=>{
            let { variantId: _variantId , slug , options , ...props } = param;
            const { setOnLoad  } = {
                setOnLoad: true,
                ...options !== null && options !== void 0 ? options : {}
            };
            if (setOnLoad) {
                const currentState = await snapshot.getPromise(state);
                if (currentState !== "READY") {
                    return;
                }
                set(state, "LOADING");
            }
            const [variantId, _product] = await (async ()=>{
                var ref;
                if (_variantId) {
                    const x = typeof _variantId === "string" ? parseInt(_variantId, 10) : _variantId;
                    if (!x || Number.isNaN(x)) {
                        return [
                            null,
                            null
                        ];
                    }
                    return [
                        x,
                        null
                    ];
                }
                if (!slug) {
                    return [
                        null,
                        null
                    ];
                }
                // Check if object is in cache
                const currentProductItem = await snapshot.getPromise(productStore("".concat(slug)));
                if (currentProductItem) {
                    var ref1;
                    if ((ref1 = currentProductItem.variants[0]) === null || ref1 === void 0 ? void 0 : ref1.id) {
                        var ref2;
                        return [
                            (ref2 = currentProductItem.variants[0]) === null || ref2 === void 0 ? void 0 : ref2.id,
                            currentProductItem
                        ];
                    }
                    return [
                        null,
                        currentProductItem
                    ];
                }
                // Fetch data
                const product = await productBySlug("".concat(slug));
                var ref3;
                return [
                    (ref3 = (ref = product === null || product === void 0 ? void 0 : product.variants[0]) === null || ref === void 0 ? void 0 : ref.id) !== null && ref3 !== void 0 ? ref3 : null,
                    product
                ];
            })();
            if (!variantId) {
                return;
            }
            if (_product === null || _product === void 0 ? void 0 : _product.slug) {
                set(productStore("".concat(slug)), _product);
            }
            const itemCount = await snapshot.getPromise(selectorCartItemCount("".concat(variantId)));
            const item = await snapshot.getPromise(selectorCartItem("".concat(variantId)));
            const gqlVariantId = toGlobalId("ProductVariant", variantId);
            const fnProps = {
                variantId: variantId,
                variantIdGQL: gqlVariantId,
                itemCount,
                item,
                ...props
            };
            const value = await fn(fnProps);
            if (setOnLoad) {
                set(state, "READY");
            }
            return value;
        };
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        deps
    ]);
};
const useCartHelper = (fn, deps)=>{
    return (0,lib_recoil_src/* useRecoilCallback */._8)((param)=>{
        let { snapshot , set  } = param;
        return async function() {
            let { options  } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
            const { setOnLoad  } = {
                setOnLoad: true,
                ...options !== null && options !== void 0 ? options : {}
            };
            if (setOnLoad) {
                const currentState = await snapshot.getPromise(state);
                if (currentState !== "READY") {
                    return;
                }
                set(state, "LOADING");
            }
            const value = await fn();
            if (setOnLoad) {
                set(state, "READY");
            }
            return value;
        };
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        deps
    ]);
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-api-products-virtual-81752d2989/1/packages/lib-api-products/src/interfaces/sort.ts
const sort_Sort = [
    {
        id: 0,
        label: "Vins\xe6last",
        value: "Vins\xe6last"
    },
    {
        id: 1,
        label: "D\xfdrast efst",
        value: "D\xfdrast efst"
    },
    {
        id: 2,
        label: "\xd3d\xfdrast efst",
        value: "\xd3d\xfdrast efst"
    },
    {
        id: 3,
        label: "N\xfdjast efst",
        value: "N\xfdjast efst"
    }
];

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-api-products-virtual-81752d2989/1/packages/lib-api-products/src/interfaces/index.ts





;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-api-products-virtual-81752d2989/1/packages/lib-api-products/src/hooks/use-sort.ts


const useSort = ()=>{
    const [active, setActive] = useState(0);
    const { values , activeItem  } = useMemo(()=>{
        const itemValues = Sort.map((value)=>{
            return {
                ...value,
                active: value.id === active
            };
        });
        const activeItemValue = itemValues.find((itemValue)=>itemValue.id === active);
        return {
            values: itemValues,
            activeItem: activeItemValue
        };
    }, [
        active
    ]);
    const handleClick = useCallback((id)=>{
        setActive(id);
    }, []);
    return {
        active,
        activeItem,
        handleClick,
        values
    };
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-api-products-virtual-81752d2989/1/packages/lib-api-products/src/hooks/use-category-by-slug.ts



const useCategoryBySlug = (slug)=>{
    var ref;
    const { data , error , loading  } = useQuery(CategoryBySlugDocument, {
        variables: {
            slug: slug !== null && slug !== void 0 ? slug : ""
        },
        skip: !slug
    });
    var ref1;
    return {
        error: error !== null && error !== void 0 ? error : null,
        loading,
        data: (data === null || data === void 0 ? void 0 : (ref = data.category) === null || ref === void 0 ? void 0 : ref.slug) === slug ? (ref1 = data === null || data === void 0 ? void 0 : data.category) !== null && ref1 !== void 0 ? ref1 : null : null,
        notFound: !error && !loading && !(data === null || data === void 0 ? void 0 : data.category)
    };
};
const getCategoryBySlug = function() {
    let client = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : initializeApollo();
    return async (slug)=>{
        var ref, ref1, ref2, ref3;
        const data = await client.query({
            query: CategoryBySlugDocument,
            variables: {
                slug
            }
        });
        var _error, ref4;
        return {
            error: (_error = data.error) !== null && _error !== void 0 ? _error : null,
            data: (data === null || data === void 0 ? void 0 : (ref = data.data) === null || ref === void 0 ? void 0 : (ref1 = ref.category) === null || ref1 === void 0 ? void 0 : ref1.slug) === slug ? (ref4 = data === null || data === void 0 ? void 0 : (ref2 = data.data) === null || ref2 === void 0 ? void 0 : ref2.category) !== null && ref4 !== void 0 ? ref4 : null : null,
            notFound: !data.error && !(data === null || data === void 0 ? void 0 : (ref3 = data.data) === null || ref3 === void 0 ? void 0 : ref3.category)
        };
    };
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-api-products-virtual-81752d2989/1/packages/lib-api-products/src/hooks/use-prices.ts
/* eslint-disable @typescript-eslint/ban-ts-comment */ 


function useProductLowestPrices(ids) {
    const { activeMembership , isAuthLoaded  } = (0,hooks_auth_next_src/* useAuth */.aC)();
    const { data: prices , isLoading  } = (0,es.useQuery)({
        queryKey: [
            "prices",
            ids === null || ids === void 0 ? void 0 : ids.sort(),
            activeMembership === null || activeMembership === void 0 ? void 0 : activeMembership.id
        ],
        queryFn: async (param)=>{
            let { queryKey  } = param;
            const [_, _ids] = queryKey;
            const { data: priceData  } = await src/* restApi.productsLowestPricesList */._O.productsLowestPricesList({
                // @ts-ignore
                id: _ids.join(",")
            });
            return priceData.results;
        },
        enabled: !!(ids === null || ids === void 0 ? void 0 : ids.length) && isAuthLoaded,
        keepPreviousData: true,
        refetchOnWindowFocus: false
    });
    return {
        prices,
        loadingPrices: isLoading
    };
}
function useProductPrices(ids) {
    const { activeMembership , isAuthLoaded  } = (0,hooks_auth_next_src/* useAuth */.aC)();
    const { data: prices , isLoading  } = (0,es.useQuery)({
        queryKey: [
            "prices",
            ids === null || ids === void 0 ? void 0 : ids.sort(),
            activeMembership === null || activeMembership === void 0 ? void 0 : activeMembership.id
        ],
        queryFn: async (param)=>{
            let { queryKey  } = param;
            const [_, _ids] = queryKey;
            const { data: priceData  } = await src/* restApi.productsPricesList */._O.productsPricesList({
                // @ts-ignore
                id: _ids.join(",")
            });
            return priceData.results;
        },
        enabled: !!(ids === null || ids === void 0 ? void 0 : ids.length) && isAuthLoaded,
        keepPreviousData: true,
        refetchOnWindowFocus: false
    });
    return {
        prices,
        loadingPrices: isLoading
    };
}

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-api-products-virtual-81752d2989/1/packages/lib-api-products/src/hooks/index.ts








;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-api-products-virtual-81752d2989/1/packages/lib-api-products/src/index.ts






/***/ }),

/***/ 97639:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "zc": function() { return /* reexport */ ContentType; },
  "cC": function() { return /* reexport */ CountryEnum; },
  "GT": function() { return /* reexport */ CustomerContactInfoMethodEnum; },
  "GG": function() { return /* reexport */ PolledLoginMethodEnum; },
  "K7": function() { return /* reexport */ RelationTypeEnum; },
  "BH": function() { return /* reexport */ RoleEnum; },
  "Ul": function() { return /* reexport */ TopicEnum; },
  "_O": function() { return /* binding */ restApi; }
});

// UNUSED EXPORTS: ClickAndCollectOptionEnum, DesignationEnum, ExternalMethodEnum, HttpClient, ProductMediaTypeEnum, ShippingMethodTypeEnum, StatusEnum, handleRestResponse

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-api-rest-virtual-a514398bdb/1/packages/lib-api-rest/src/http-client.ts
/* eslint-disable */ /* tslint:disable */ /*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */ var ContentType;
(function(ContentType) {
    ContentType["Json"] = "application/json";
    ContentType["FormData"] = "multipart/form-data";
    ContentType["UrlEncoded"] = "application/x-www-form-urlencoded";
})(ContentType || (ContentType = {}));
class HttpClient {
    encodeQueryParam(key, value) {
        const encodedKey = encodeURIComponent(key);
        return "".concat(encodedKey, "=").concat(encodeURIComponent(typeof value === "number" ? value : "".concat(value)));
    }
    addQueryParam(query, key) {
        return this.encodeQueryParam(key, query[key]);
    }
    addArrayQueryParam(query, key) {
        const value = query[key];
        return value.map((v)=>this.encodeQueryParam(key, v)).join("&");
    }
    toQueryString(rawQuery) {
        const query = rawQuery || {};
        const keys = Object.keys(query).filter((key)=>"undefined" !== typeof query[key]);
        return keys.map((key)=>Array.isArray(query[key]) ? this.addArrayQueryParam(query, key) : this.addQueryParam(query, key)).join("&");
    }
    addQueryParams(rawQuery) {
        const queryString = this.toQueryString(rawQuery);
        return queryString ? "?".concat(queryString) : "";
    }
    mergeRequestParams(params1, params2) {
        return {
            ...this.baseApiParams,
            ...params1,
            ...params2 || {},
            headers: {
                ...this.baseApiParams.headers || {},
                ...params1.headers || {},
                ...params2 && params2.headers || {}
            }
        };
    }
    constructor(apiConfig = {}){
        this.baseUrl = "";
        this.securityData = null;
        this.abortControllers = new Map();
        this.customFetch = function() {
            for(var _len = arguments.length, fetchParams = new Array(_len), _key = 0; _key < _len; _key++){
                fetchParams[_key] = arguments[_key];
            }
            return fetch(...fetchParams);
        };
        this.baseApiParams = {
            credentials: "same-origin",
            headers: {},
            redirect: "follow",
            referrerPolicy: "no-referrer"
        };
        this.setSecurityData = (data)=>{
            this.securityData = data;
        };
        this.contentFormatters = {
            [ContentType.Json]: (input)=>input !== null && (typeof input === "object" || typeof input === "string") ? JSON.stringify(input) : input,
            [ContentType.FormData]: (input)=>Object.keys(input || {}).reduce((formData, key)=>{
                    const property = input[key];
                    formData.append(key, property instanceof Blob ? property : typeof property === "object" && property !== null ? JSON.stringify(property) : "".concat(property));
                    return formData;
                }, new FormData()),
            [ContentType.UrlEncoded]: (input)=>this.toQueryString(input)
        };
        this.createAbortSignal = (cancelToken)=>{
            if (this.abortControllers.has(cancelToken)) {
                const abortController = this.abortControllers.get(cancelToken);
                if (abortController) {
                    return abortController.signal;
                }
                return void 0;
            }
            const abortController1 = new AbortController();
            this.abortControllers.set(cancelToken, abortController1);
            return abortController1.signal;
        };
        this.abortRequest = (cancelToken)=>{
            const abortController = this.abortControllers.get(cancelToken);
            if (abortController) {
                abortController.abort();
                this.abortControllers.delete(cancelToken);
            }
        };
        this.request = async (param)=>{
            let { body , secure , path , type , query , format , baseUrl , cancelToken , ...params } = param;
            const secureParams = (typeof secure === "boolean" ? secure : this.baseApiParams.secure) && this.securityWorker && await this.securityWorker(this.securityData) || {};
            const requestParams = this.mergeRequestParams(params, secureParams);
            const queryString = query && this.toQueryString(query);
            const payloadFormatter = this.contentFormatters[type || ContentType.Json];
            const responseFormat = format || requestParams.format;
            var ref;
            return this.customFetch("".concat(baseUrl || this.baseUrl || "").concat(path).concat(queryString ? "?".concat(queryString) : ""), {
                ...requestParams,
                headers: {
                    ...type && type !== ContentType.FormData ? {
                        "Content-Type": type
                    } : {},
                    ...requestParams.headers || {}
                },
                signal: cancelToken ? (ref = this.createAbortSignal(cancelToken)) !== null && ref !== void 0 ? ref : null : null,
                body: typeof body === "undefined" || body === null ? null : payloadFormatter(body)
            }).then(async (response)=>{
                const r = response;
                r.data = null;
                r.error = null;
                const data = !responseFormat ? r : await response[responseFormat]().then((data)=>{
                    if (r.ok) {
                        r.data = data;
                    } else {
                        r.error = data;
                    }
                    return r;
                }).catch((e)=>{
                    r.error = e;
                    return r;
                });
                if (cancelToken) {
                    this.abortControllers.delete(cancelToken);
                }
                if (!response.ok) throw data;
                return data;
            });
        };
        Object.assign(this, apiConfig);
    }
}

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-api-rest-virtual-a514398bdb/1/packages/lib-api-rest/src/Api.ts
/* eslint-disable */ /* tslint:disable */ /*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */ 
class Api extends HttpClient {
    constructor(...args){
        var _this;
        super(...args), _this = this;
        /**
   * No description
   *
   * @tags account-settings
   * @name AccountSettingsRetrieve
   * @request GET:/api/account-settings/
   * @secure
   * @response `200` `CustomerAccountSettings`
   */ this.accountSettingsRetrieve = function() {
            let params = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
            return _this.request({
                path: "/api/account-settings/",
                method: "GET",
                secure: true,
                format: "json",
                ...params
            });
        };
        /**
   * No description
   *
   * @tags account-settings
   * @name AccountSettingsUpdate
   * @request PUT:/api/account-settings/
   * @secure
   * @response `200` `CustomerAccountSettings`
   */ this.accountSettingsUpdate = function(data) {
            let params = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
            return _this.request({
                path: "/api/account-settings/",
                method: "PUT",
                body: data,
                secure: true,
                type: ContentType.Json,
                format: "json",
                ...params
            });
        };
        /**
   * No description
   *
   * @tags account-settings
   * @name AccountSettingsPartialUpdate
   * @request PATCH:/api/account-settings/
   * @secure
   * @response `200` `CustomerAccountSettings`
   */ this.accountSettingsPartialUpdate = function(data) {
            let params = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
            return _this.request({
                path: "/api/account-settings/",
                method: "PATCH",
                body: data,
                secure: true,
                type: ContentType.Json,
                format: "json",
                ...params
            });
        };
        /**
   * No description
   *
   * @tags accounts
   * @name AccountsList
   * @request GET:/api/accounts/
   * @secure
   * @response `200` `(CustomerAccount)[]`
   */ this.accountsList = function() {
            let params = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
            return _this.request({
                path: "/api/accounts/",
                method: "GET",
                secure: true,
                format: "json",
                ...params
            });
        };
        /**
   * No description
   *
   * @tags accounts
   * @name AccountsRetrieve
   * @request GET:/api/accounts/{ssn}/
   * @secure
   * @response `200` `CustomerAccount`
   */ this.accountsRetrieve = function(ssn) {
            let params = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
            return _this.request({
                path: "/api/accounts/".concat(ssn, "/"),
                method: "GET",
                secure: true,
                format: "json",
                ...params
            });
        };
        /**
   * No description
   *
   * @tags accounts
   * @name AccountsAddressesList
   * @request GET:/api/accounts/addresses/
   * @secure
   * @response `200` `(CustomerAddress)[]`
   */ this.accountsAddressesList = function() {
            let params = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
            return _this.request({
                path: "/api/accounts/addresses/",
                method: "GET",
                secure: true,
                format: "json",
                ...params
            });
        };
        /**
   * No description
   *
   * @tags accounts
   * @name AccountsAddressesCreate
   * @request POST:/api/accounts/addresses/
   * @secure
   * @response `201` `CustomerAddress`
   */ this.accountsAddressesCreate = function(data) {
            let params = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
            return _this.request({
                path: "/api/accounts/addresses/",
                method: "POST",
                body: data,
                secure: true,
                type: ContentType.Json,
                format: "json",
                ...params
            });
        };
        /**
   * No description
   *
   * @tags accounts
   * @name AccountsAddressesRetrieve
   * @request GET:/api/accounts/addresses/{id}/
   * @secure
   * @response `200` `CustomerAddress`
   */ this.accountsAddressesRetrieve = function(id) {
            let params = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
            return _this.request({
                path: "/api/accounts/addresses/".concat(id, "/"),
                method: "GET",
                secure: true,
                format: "json",
                ...params
            });
        };
        /**
   * No description
   *
   * @tags accounts
   * @name AccountsAddressesUpdate
   * @request PUT:/api/accounts/addresses/{id}/
   * @secure
   * @response `200` `CustomerAddress`
   */ this.accountsAddressesUpdate = function(id, data) {
            let params = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
            return _this.request({
                path: "/api/accounts/addresses/".concat(id, "/"),
                method: "PUT",
                body: data,
                secure: true,
                type: ContentType.Json,
                format: "json",
                ...params
            });
        };
        /**
   * No description
   *
   * @tags accounts
   * @name AccountsAddressesPartialUpdate
   * @request PATCH:/api/accounts/addresses/{id}/
   * @secure
   * @response `200` `CustomerAddress`
   */ this.accountsAddressesPartialUpdate = function(id, data) {
            let params = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
            return _this.request({
                path: "/api/accounts/addresses/".concat(id, "/"),
                method: "PATCH",
                body: data,
                secure: true,
                type: ContentType.Json,
                format: "json",
                ...params
            });
        };
        /**
   * No description
   *
   * @tags accounts
   * @name AccountsAddressesDestroy
   * @request DELETE:/api/accounts/addresses/{id}/
   * @secure
   * @response `204` `void` No response body
   */ this.accountsAddressesDestroy = function(id) {
            let params = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
            return _this.request({
                path: "/api/accounts/addresses/".concat(id, "/"),
                method: "DELETE",
                secure: true,
                ...params
            });
        };
        /**
   * @description Sets address as a primary address and removes primary status of existing addresses (if any) for the users account. The response contains all addresses.
   *
   * @tags accounts
   * @name AccountsAddressesSetPrimaryCreate
   * @request POST:/api/accounts/addresses/{id}/set-primary/
   * @secure
   * @response `200` `(CustomerAddress)[]`
   */ this.accountsAddressesSetPrimaryCreate = function(id) {
            let params = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
            return _this.request({
                path: "/api/accounts/addresses/".concat(id, "/set-primary/"),
                method: "POST",
                secure: true,
                format: "json",
                ...params
            });
        };
        /**
   * No description
   *
   * @tags accounts
   * @name AccountsAgentsList
   * @request GET:/api/accounts/agents/
   * @secure
   * @response `200` `(CustomerAgent)[]`
   */ this.accountsAgentsList = function() {
            let params = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
            return _this.request({
                path: "/api/accounts/agents/",
                method: "GET",
                secure: true,
                format: "json",
                ...params
            });
        };
        /**
   * No description
   *
   * @tags accounts
   * @name AccountsAgentsCreate
   * @request POST:/api/accounts/agents/
   * @secure
   * @response `201` `CustomerAgent`
   */ this.accountsAgentsCreate = function(data) {
            let params = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
            return _this.request({
                path: "/api/accounts/agents/",
                method: "POST",
                body: data,
                secure: true,
                type: ContentType.Json,
                format: "json",
                ...params
            });
        };
        /**
   * No description
   *
   * @tags accounts
   * @name AccountsAgentsRetrieve
   * @request GET:/api/accounts/agents/{id}/
   * @secure
   * @response `200` `CustomerAgent`
   */ this.accountsAgentsRetrieve = function(id) {
            let params = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
            return _this.request({
                path: "/api/accounts/agents/".concat(id, "/"),
                method: "GET",
                secure: true,
                format: "json",
                ...params
            });
        };
        /**
   * No description
   *
   * @tags accounts
   * @name AccountsAgentsUpdate
   * @request PUT:/api/accounts/agents/{id}/
   * @secure
   * @response `200` `CustomerAgent`
   */ this.accountsAgentsUpdate = function(id, data) {
            let params = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
            return _this.request({
                path: "/api/accounts/agents/".concat(id, "/"),
                method: "PUT",
                body: data,
                secure: true,
                type: ContentType.Json,
                format: "json",
                ...params
            });
        };
        /**
   * No description
   *
   * @tags accounts
   * @name AccountsAgentsPartialUpdate
   * @request PATCH:/api/accounts/agents/{id}/
   * @secure
   * @response `200` `CustomerAgent`
   */ this.accountsAgentsPartialUpdate = function(id, data) {
            let params = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
            return _this.request({
                path: "/api/accounts/agents/".concat(id, "/"),
                method: "PATCH",
                body: data,
                secure: true,
                type: ContentType.Json,
                format: "json",
                ...params
            });
        };
        /**
   * No description
   *
   * @tags accounts
   * @name AccountsContactInfoList
   * @request GET:/api/accounts/contact-info/
   * @secure
   * @response `200` `(CustomerContactInfo)[]`
   */ this.accountsContactInfoList = function() {
            let params = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
            return _this.request({
                path: "/api/accounts/contact-info/",
                method: "GET",
                secure: true,
                format: "json",
                ...params
            });
        };
        /**
   * No description
   *
   * @tags accounts
   * @name AccountsContactInfoCreate
   * @request POST:/api/accounts/contact-info/
   * @secure
   * @response `201` `CustomerContactInfo`
   */ this.accountsContactInfoCreate = function(data) {
            let params = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
            return _this.request({
                path: "/api/accounts/contact-info/",
                method: "POST",
                body: data,
                secure: true,
                type: ContentType.Json,
                format: "json",
                ...params
            });
        };
        /**
   * No description
   *
   * @tags accounts
   * @name AccountsContactInfoRetrieve
   * @request GET:/api/accounts/contact-info/{id}/
   * @secure
   * @response `200` `CustomerContactInfo`
   */ this.accountsContactInfoRetrieve = function(id) {
            let params = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
            return _this.request({
                path: "/api/accounts/contact-info/".concat(id, "/"),
                method: "GET",
                secure: true,
                format: "json",
                ...params
            });
        };
        /**
   * No description
   *
   * @tags accounts
   * @name AccountsContactInfoUpdate
   * @request PUT:/api/accounts/contact-info/{id}/
   * @secure
   * @response `200` `CustomerContactInfo`
   */ this.accountsContactInfoUpdate = function(id, data) {
            let params = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
            return _this.request({
                path: "/api/accounts/contact-info/".concat(id, "/"),
                method: "PUT",
                body: data,
                secure: true,
                type: ContentType.Json,
                format: "json",
                ...params
            });
        };
        /**
   * No description
   *
   * @tags accounts
   * @name AccountsContactInfoPartialUpdate
   * @request PATCH:/api/accounts/contact-info/{id}/
   * @secure
   * @response `200` `CustomerContactInfo`
   */ this.accountsContactInfoPartialUpdate = function(id, data) {
            let params = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
            return _this.request({
                path: "/api/accounts/contact-info/".concat(id, "/"),
                method: "PATCH",
                body: data,
                secure: true,
                type: ContentType.Json,
                format: "json",
                ...params
            });
        };
        /**
   * No description
   *
   * @tags accounts
   * @name AccountsContactInfoDestroy
   * @request DELETE:/api/accounts/contact-info/{id}/
   * @secure
   * @response `204` `void` No response body
   */ this.accountsContactInfoDestroy = function(id) {
            let params = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
            return _this.request({
                path: "/api/accounts/contact-info/".concat(id, "/"),
                method: "DELETE",
                secure: true,
                ...params
            });
        };
        /**
   * No description
   *
   * @tags accounts
   * @name AccountsCreditLimitRetrieve
   * @request GET:/api/accounts/credit-limit/
   * @secure
   * @response `200` `CustomerCreditLimit`
   */ this.accountsCreditLimitRetrieve = function() {
            let params = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
            return _this.request({
                path: "/api/accounts/credit-limit/",
                method: "GET",
                secure: true,
                format: "json",
                ...params
            });
        };
        /**
   * No description
   *
   * @tags accounts
   * @name AccountsInvitationsList
   * @request GET:/api/accounts/invitations/
   * @secure
   * @response `200` `(CustomerAccountInvitation)[]`
   */ this.accountsInvitationsList = function() {
            let params = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
            return _this.request({
                path: "/api/accounts/invitations/",
                method: "GET",
                secure: true,
                format: "json",
                ...params
            });
        };
        /**
   * No description
   *
   * @tags accounts
   * @name AccountsInvitationsCreate
   * @request POST:/api/accounts/invitations/
   * @secure
   * @response `201` `CustomerAccountInvitation`
   */ this.accountsInvitationsCreate = function(data) {
            let params = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
            return _this.request({
                path: "/api/accounts/invitations/",
                method: "POST",
                body: data,
                secure: true,
                type: ContentType.Json,
                format: "json",
                ...params
            });
        };
        /**
   * No description
   *
   * @tags accounts
   * @name AccountsInvitationsRetrieve
   * @request GET:/api/accounts/invitations/{id}/
   * @secure
   * @response `200` `CustomerAccountInvitation`
   */ this.accountsInvitationsRetrieve = function(id) {
            let params = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
            return _this.request({
                path: "/api/accounts/invitations/".concat(id, "/"),
                method: "GET",
                secure: true,
                format: "json",
                ...params
            });
        };
        /**
   * No description
   *
   * @tags accounts
   * @name AccountsInvitationsUpdate
   * @request PUT:/api/accounts/invitations/{id}/
   * @secure
   * @response `200` `CustomerAccountInvitation`
   */ this.accountsInvitationsUpdate = function(id, data) {
            let params = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
            return _this.request({
                path: "/api/accounts/invitations/".concat(id, "/"),
                method: "PUT",
                body: data,
                secure: true,
                type: ContentType.Json,
                format: "json",
                ...params
            });
        };
        /**
   * No description
   *
   * @tags accounts
   * @name AccountsInvitationsPartialUpdate
   * @request PATCH:/api/accounts/invitations/{id}/
   * @secure
   * @response `200` `CustomerAccountInvitation`
   */ this.accountsInvitationsPartialUpdate = function(id, data) {
            let params = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
            return _this.request({
                path: "/api/accounts/invitations/".concat(id, "/"),
                method: "PATCH",
                body: data,
                secure: true,
                type: ContentType.Json,
                format: "json",
                ...params
            });
        };
        /**
   * No description
   *
   * @tags accounts
   * @name AccountsInvitationsDestroy
   * @request DELETE:/api/accounts/invitations/{id}/
   * @secure
   * @response `204` `void` No response body
   */ this.accountsInvitationsDestroy = function(id) {
            let params = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
            return _this.request({
                path: "/api/accounts/invitations/".concat(id, "/"),
                method: "DELETE",
                secure: true,
                ...params
            });
        };
        /**
   * No description
   *
   * @tags accounts
   * @name AccountsInvitationsResendCreate
   * @request POST:/api/accounts/invitations/{id}/resend/
   * @secure
   * @response `200` `CustomerAccountInvitation`
   */ this.accountsInvitationsResendCreate = function(id) {
            let params = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
            return _this.request({
                path: "/api/accounts/invitations/".concat(id, "/resend/"),
                method: "POST",
                secure: true,
                format: "json",
                ...params
            });
        };
        /**
   * No description
   *
   * @tags accounts
   * @name AccountsInvitationsAcceptCreate
   * @request POST:/api/accounts/invitations/accept/
   * @secure
   * @response `200` `Login`
   */ this.accountsInvitationsAcceptCreate = function(data) {
            let params = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
            return _this.request({
                path: "/api/accounts/invitations/accept/",
                method: "POST",
                body: data,
                secure: true,
                type: ContentType.Json,
                format: "json",
                ...params
            });
        };
        /**
   * No description
   *
   * @tags accounts
   * @name AccountsInvitationsDetailsRetrieve
   * @request GET:/api/accounts/invitations/details/
   * @secure
   * @response `200` `CustomerAccountInvitationDetail`
   */ this.accountsInvitationsDetailsRetrieve = function(query) {
            let params = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
            return _this.request({
                path: "/api/accounts/invitations/details/",
                method: "GET",
                query: query || {
                    format: "json"
                },
                secure: true,
                format: "json",
                ...params
            });
        };
        /**
   * No description
   *
   * @tags accounts
   * @name AccountsMembershipsList
   * @request GET:/api/accounts/memberships/
   * @secure
   * @response `200` `(CustomerAccountMembership)[]`
   */ this.accountsMembershipsList = function() {
            let params = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
            return _this.request({
                path: "/api/accounts/memberships/",
                method: "GET",
                secure: true,
                format: "json",
                ...params
            });
        };
        /**
   * No description
   *
   * @tags accounts
   * @name AccountsMembershipsRetrieve
   * @request GET:/api/accounts/memberships/{id}/
   * @secure
   * @response `200` `CustomerAccountMembership`
   */ this.accountsMembershipsRetrieve = function(id) {
            let params = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
            return _this.request({
                path: "/api/accounts/memberships/".concat(id, "/"),
                method: "GET",
                secure: true,
                format: "json",
                ...params
            });
        };
        /**
   * No description
   *
   * @tags accounts
   * @name AccountsMembershipsSwitchAccountCreate
   * @request POST:/api/accounts/memberships/{id}/switch-account/
   * @secure
   * @response `200` `Login`
   */ this.accountsMembershipsSwitchAccountCreate = function(id) {
            let params = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
            return _this.request({
                path: "/api/accounts/memberships/".concat(id, "/switch-account/"),
                method: "POST",
                secure: true,
                format: "json",
                ...params
            });
        };
        /**
   * No description
   *
   * @tags accounts
   * @name AccountsMembershipsManagementList
   * @request GET:/api/accounts/memberships/management/
   * @secure
   * @response `200` `(CustomerAccountMembershipManagement)[]`
   */ this.accountsMembershipsManagementList = function() {
            let params = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
            return _this.request({
                path: "/api/accounts/memberships/management/",
                method: "GET",
                secure: true,
                format: "json",
                ...params
            });
        };
        /**
   * No description
   *
   * @tags accounts
   * @name AccountsMembershipsManagementRetrieve
   * @request GET:/api/accounts/memberships/management/{id}/
   * @secure
   * @response `200` `CustomerAccountMembershipManagement`
   */ this.accountsMembershipsManagementRetrieve = function(id) {
            let params = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
            return _this.request({
                path: "/api/accounts/memberships/management/".concat(id, "/"),
                method: "GET",
                secure: true,
                format: "json",
                ...params
            });
        };
        /**
   * No description
   *
   * @tags accounts
   * @name AccountsMembershipsManagementUpdate
   * @request PUT:/api/accounts/memberships/management/{id}/
   * @secure
   * @response `200` `CustomerAccountMembershipManagement`
   */ this.accountsMembershipsManagementUpdate = function(id, data) {
            let params = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
            return _this.request({
                path: "/api/accounts/memberships/management/".concat(id, "/"),
                method: "PUT",
                body: data,
                secure: true,
                type: ContentType.Json,
                format: "json",
                ...params
            });
        };
        /**
   * No description
   *
   * @tags accounts
   * @name AccountsMembershipsManagementPartialUpdate
   * @request PATCH:/api/accounts/memberships/management/{id}/
   * @secure
   * @response `200` `CustomerAccountMembershipManagement`
   */ this.accountsMembershipsManagementPartialUpdate = function(id, data) {
            let params = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
            return _this.request({
                path: "/api/accounts/memberships/management/".concat(id, "/"),
                method: "PATCH",
                body: data,
                secure: true,
                type: ContentType.Json,
                format: "json",
                ...params
            });
        };
        /**
   * No description
   *
   * @tags accounts
   * @name AccountsRelationsList
   * @request GET:/api/accounts/relations/
   * @secure
   * @response `200` `(CustomerAccountRelation)[]`
   */ this.accountsRelationsList = function(query) {
            let params = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
            return _this.request({
                path: "/api/accounts/relations/",
                method: "GET",
                query: query || {
                    format: "json"
                },
                secure: true,
                format: "json",
                ...params
            });
        };
        /**
   * No description
   *
   * @tags accounts
   * @name AccountsRelationsCreate
   * @request POST:/api/accounts/relations/
   * @secure
   * @response `201` `CustomerAccountRelation`
   */ this.accountsRelationsCreate = function(data) {
            let params = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
            return _this.request({
                path: "/api/accounts/relations/",
                method: "POST",
                body: data,
                secure: true,
                type: ContentType.Json,
                format: "json",
                ...params
            });
        };
        /**
   * No description
   *
   * @tags accounts
   * @name AccountsRelationsRetrieve
   * @request GET:/api/accounts/relations/{id}/
   * @secure
   * @response `200` `CustomerAccountRelation`
   */ this.accountsRelationsRetrieve = function(id) {
            let params = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
            return _this.request({
                path: "/api/accounts/relations/".concat(id, "/"),
                method: "GET",
                secure: true,
                format: "json",
                ...params
            });
        };
        /**
   * No description
   *
   * @tags accounts
   * @name AccountsRelationsUpdate
   * @request PUT:/api/accounts/relations/{id}/
   * @secure
   * @response `200` `CustomerAccountRelation`
   */ this.accountsRelationsUpdate = function(id, data) {
            let params = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
            return _this.request({
                path: "/api/accounts/relations/".concat(id, "/"),
                method: "PUT",
                body: data,
                secure: true,
                type: ContentType.Json,
                format: "json",
                ...params
            });
        };
        /**
   * No description
   *
   * @tags accounts
   * @name AccountsRelationsPartialUpdate
   * @request PATCH:/api/accounts/relations/{id}/
   * @secure
   * @response `200` `CustomerAccountRelation`
   */ this.accountsRelationsPartialUpdate = function(id, data) {
            let params = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
            return _this.request({
                path: "/api/accounts/relations/".concat(id, "/"),
                method: "PATCH",
                body: data,
                secure: true,
                type: ContentType.Json,
                format: "json",
                ...params
            });
        };
        /**
   * No description
   *
   * @tags accounts
   * @name AccountsRelationsDestroy
   * @request DELETE:/api/accounts/relations/{id}/
   * @secure
   * @response `204` `void` No response body
   */ this.accountsRelationsDestroy = function(id) {
            let params = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
            return _this.request({
                path: "/api/accounts/relations/".concat(id, "/"),
                method: "DELETE",
                secure: true,
                ...params
            });
        };
        /**
   * No description
   *
   * @tags accounts
   * @name AccountsSettingsRetrieve
   * @request GET:/api/accounts/settings/
   * @secure
   * @response `200` `CustomerAccountSettings`
   */ this.accountsSettingsRetrieve = function() {
            let params = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
            return _this.request({
                path: "/api/accounts/settings/",
                method: "GET",
                secure: true,
                format: "json",
                ...params
            });
        };
        /**
   * No description
   *
   * @tags accounts
   * @name AccountsSettingsUpdate
   * @request PUT:/api/accounts/settings/
   * @secure
   * @response `200` `CustomerAccountSettings`
   */ this.accountsSettingsUpdate = function(data) {
            let params = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
            return _this.request({
                path: "/api/accounts/settings/",
                method: "PUT",
                body: data,
                secure: true,
                type: ContentType.Json,
                format: "json",
                ...params
            });
        };
        /**
   * No description
   *
   * @tags accounts
   * @name AccountsSettingsPartialUpdate
   * @request PATCH:/api/accounts/settings/
   * @secure
   * @response `200` `CustomerAccountSettings`
   */ this.accountsSettingsPartialUpdate = function(data) {
            let params = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
            return _this.request({
                path: "/api/accounts/settings/",
                method: "PATCH",
                body: data,
                secure: true,
                type: ContentType.Json,
                format: "json",
                ...params
            });
        };
        /**
   * @description Display all categories with total product count
   *
   * @tags categories
   * @name CategoriesList
   * @request GET:/api/categories/
   * @secure
   * @response `200` `(Category)[]`
   */ this.categoriesList = function() {
            let params = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
            return _this.request({
                path: "/api/categories/",
                method: "GET",
                secure: true,
                format: "json",
                ...params
            });
        };
        /**
   * @description Display all categories with total product count
   *
   * @tags categories
   * @name CategoriesRetrieve
   * @request GET:/api/categories/{id}/
   * @secure
   * @response `200` `Category`
   */ this.categoriesRetrieve = function(id) {
            let params = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
            return _this.request({
                path: "/api/categories/".concat(id, "/"),
                method: "GET",
                secure: true,
                format: "json",
                ...params
            });
        };
        /**
   * @description Display all categories with total product count
   *
   * @tags categories
   * @name CategoriesRentalList
   * @request GET:/api/categories/rental/
   * @secure
   * @response `200` `(Category)[]`
   */ this.categoriesRentalList = function() {
            let params = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
            return _this.request({
                path: "/api/categories/rental/",
                method: "GET",
                secure: true,
                format: "json",
                ...params
            });
        };
        /**
   * No description
   *
   * @tags checkouts
   * @name CheckoutsList
   * @request GET:/api/checkouts/
   * @secure
   * @response `200` `PaginatedCheckoutList`
   */ this.checkoutsList = function(query) {
            let params = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
            return _this.request({
                path: "/api/checkouts/",
                method: "GET",
                query: query || {
                    format: "json"
                },
                secure: true,
                format: "json",
                ...params
            });
        };
        /**
   * No description
   *
   * @tags checkouts
   * @name CheckoutsRetrieve
   * @request GET:/api/checkouts/{token}/
   * @secure
   * @response `200` `Checkout`
   */ this.checkoutsRetrieve = function(token) {
            let params = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
            return _this.request({
                path: "/api/checkouts/".concat(token, "/"),
                method: "GET",
                secure: true,
                format: "json",
                ...params
            });
        };
        /**
   * No description
   *
   * @tags checkouts
   * @name CheckoutsUpdate
   * @request PUT:/api/checkouts/{token}/
   * @secure
   * @response `200` `Checkout`
   */ this.checkoutsUpdate = function(token, data) {
            let params = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
            return _this.request({
                path: "/api/checkouts/".concat(token, "/"),
                method: "PUT",
                body: data,
                secure: true,
                type: ContentType.Json,
                format: "json",
                ...params
            });
        };
        /**
   * No description
   *
   * @tags checkouts
   * @name CheckoutsPartialUpdate
   * @request PATCH:/api/checkouts/{token}/
   * @secure
   * @response `200` `Checkout`
   */ this.checkoutsPartialUpdate = function(token, data) {
            let params = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
            return _this.request({
                path: "/api/checkouts/".concat(token, "/"),
                method: "PATCH",
                body: data,
                secure: true,
                type: ContentType.Json,
                format: "json",
                ...params
            });
        };
        /**
   * @description Connect logged in user to checkout
   *
   * @tags checkouts
   * @name CheckoutsConnectRetrieve
   * @request GET:/api/checkouts/{token}/connect/
   * @secure
   * @response `200` `Checkout`
   */ this.checkoutsConnectRetrieve = function(token) {
            let params = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
            return _this.request({
                path: "/api/checkouts/".concat(token, "/connect/"),
                method: "GET",
                secure: true,
                format: "json",
                ...params
            });
        };
        /**
   * @description Merge checkouts
   *
   * @tags checkouts
   * @name CheckoutsMergeUpdate
   * @request PUT:/api/checkouts/{token}/merge/
   * @secure
   * @response `200` `Checkout`
   */ this.checkoutsMergeUpdate = function(token, data) {
            let params = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
            return _this.request({
                path: "/api/checkouts/".concat(token, "/merge/"),
                method: "PUT",
                body: data,
                secure: true,
                type: ContentType.Json,
                format: "json",
                ...params
            });
        };
        /**
   * No description
   *
   * @tags credit-limit
   * @name CreditLimitRetrieve
   * @request GET:/api/credit-limit/
   * @secure
   * @response `200` `CustomerCreditLimit`
   */ this.creditLimitRetrieve = function() {
            let params = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
            return _this.request({
                path: "/api/credit-limit/",
                method: "GET",
                secure: true,
                format: "json",
                ...params
            });
        };
        /**
   * No description
   *
   * @tags customer-agents
   * @name CustomerAgentsList
   * @request GET:/api/customer-agents/
   * @secure
   * @response `200` `(CustomerAgent)[]`
   */ this.customerAgentsList = function() {
            let params = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
            return _this.request({
                path: "/api/customer-agents/",
                method: "GET",
                secure: true,
                format: "json",
                ...params
            });
        };
        /**
   * No description
   *
   * @tags customer-agents
   * @name CustomerAgentsCreate
   * @request POST:/api/customer-agents/
   * @secure
   * @response `201` `CustomerAgent`
   */ this.customerAgentsCreate = function(data) {
            let params = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
            return _this.request({
                path: "/api/customer-agents/",
                method: "POST",
                body: data,
                secure: true,
                type: ContentType.Json,
                format: "json",
                ...params
            });
        };
        /**
   * No description
   *
   * @tags customer-agents
   * @name CustomerAgentsRetrieve
   * @request GET:/api/customer-agents/{id}/
   * @secure
   * @response `200` `CustomerAgent`
   */ this.customerAgentsRetrieve = function(id) {
            let params = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
            return _this.request({
                path: "/api/customer-agents/".concat(id, "/"),
                method: "GET",
                secure: true,
                format: "json",
                ...params
            });
        };
        /**
   * No description
   *
   * @tags customer-agents
   * @name CustomerAgentsUpdate
   * @request PUT:/api/customer-agents/{id}/
   * @secure
   * @response `200` `CustomerAgent`
   */ this.customerAgentsUpdate = function(id, data) {
            let params = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
            return _this.request({
                path: "/api/customer-agents/".concat(id, "/"),
                method: "PUT",
                body: data,
                secure: true,
                type: ContentType.Json,
                format: "json",
                ...params
            });
        };
        /**
   * No description
   *
   * @tags customer-agents
   * @name CustomerAgentsPartialUpdate
   * @request PATCH:/api/customer-agents/{id}/
   * @secure
   * @response `200` `CustomerAgent`
   */ this.customerAgentsPartialUpdate = function(id, data) {
            let params = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
            return _this.request({
                path: "/api/customer-agents/".concat(id, "/"),
                method: "PATCH",
                body: data,
                secure: true,
                type: ContentType.Json,
                format: "json",
                ...params
            });
        };
        /**
   * No description
   *
   * @tags customer-contacts-info
   * @name CustomerContactsInfoList
   * @request GET:/api/customer-contacts-info/
   * @secure
   * @response `200` `(CustomerContactInfo)[]`
   */ this.customerContactsInfoList = function() {
            let params = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
            return _this.request({
                path: "/api/customer-contacts-info/",
                method: "GET",
                secure: true,
                format: "json",
                ...params
            });
        };
        /**
   * No description
   *
   * @tags customer-contacts-info
   * @name CustomerContactsInfoCreate
   * @request POST:/api/customer-contacts-info/
   * @secure
   * @response `201` `CustomerContactInfo`
   */ this.customerContactsInfoCreate = function(data) {
            let params = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
            return _this.request({
                path: "/api/customer-contacts-info/",
                method: "POST",
                body: data,
                secure: true,
                type: ContentType.Json,
                format: "json",
                ...params
            });
        };
        /**
   * No description
   *
   * @tags customer-contacts-info
   * @name CustomerContactsInfoRetrieve
   * @request GET:/api/customer-contacts-info/{id}/
   * @secure
   * @response `200` `CustomerContactInfo`
   */ this.customerContactsInfoRetrieve = function(id) {
            let params = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
            return _this.request({
                path: "/api/customer-contacts-info/".concat(id, "/"),
                method: "GET",
                secure: true,
                format: "json",
                ...params
            });
        };
        /**
   * No description
   *
   * @tags customer-contacts-info
   * @name CustomerContactsInfoUpdate
   * @request PUT:/api/customer-contacts-info/{id}/
   * @secure
   * @response `200` `CustomerContactInfo`
   */ this.customerContactsInfoUpdate = function(id, data) {
            let params = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
            return _this.request({
                path: "/api/customer-contacts-info/".concat(id, "/"),
                method: "PUT",
                body: data,
                secure: true,
                type: ContentType.Json,
                format: "json",
                ...params
            });
        };
        /**
   * No description
   *
   * @tags customer-contacts-info
   * @name CustomerContactsInfoPartialUpdate
   * @request PATCH:/api/customer-contacts-info/{id}/
   * @secure
   * @response `200` `CustomerContactInfo`
   */ this.customerContactsInfoPartialUpdate = function(id, data) {
            let params = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
            return _this.request({
                path: "/api/customer-contacts-info/".concat(id, "/"),
                method: "PATCH",
                body: data,
                secure: true,
                type: ContentType.Json,
                format: "json",
                ...params
            });
        };
        /**
   * No description
   *
   * @tags customer-contacts-info
   * @name CustomerContactsInfoDestroy
   * @request DELETE:/api/customer-contacts-info/{id}/
   * @secure
   * @response `204` `void` No response body
   */ this.customerContactsInfoDestroy = function(id) {
            let params = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
            return _this.request({
                path: "/api/customer-contacts-info/".concat(id, "/"),
                method: "DELETE",
                secure: true,
                ...params
            });
        };
        /**
   * No description
   *
   * @tags customer-relations
   * @name CustomerRelationsList
   * @request GET:/api/customer-relations/
   * @secure
   * @response `200` `(CustomerAccountRelation)[]`
   */ this.customerRelationsList = function(query) {
            let params = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
            return _this.request({
                path: "/api/customer-relations/",
                method: "GET",
                query: query || {
                    format: "json"
                },
                secure: true,
                format: "json",
                ...params
            });
        };
        /**
   * No description
   *
   * @tags customer-relations
   * @name CustomerRelationsCreate
   * @request POST:/api/customer-relations/
   * @secure
   * @response `201` `CustomerAccountRelation`
   */ this.customerRelationsCreate = function(data) {
            let params = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
            return _this.request({
                path: "/api/customer-relations/",
                method: "POST",
                body: data,
                secure: true,
                type: ContentType.Json,
                format: "json",
                ...params
            });
        };
        /**
   * No description
   *
   * @tags customer-relations
   * @name CustomerRelationsRetrieve
   * @request GET:/api/customer-relations/{id}/
   * @secure
   * @response `200` `CustomerAccountRelation`
   */ this.customerRelationsRetrieve = function(id) {
            let params = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
            return _this.request({
                path: "/api/customer-relations/".concat(id, "/"),
                method: "GET",
                secure: true,
                format: "json",
                ...params
            });
        };
        /**
   * No description
   *
   * @tags customer-relations
   * @name CustomerRelationsUpdate
   * @request PUT:/api/customer-relations/{id}/
   * @secure
   * @response `200` `CustomerAccountRelation`
   */ this.customerRelationsUpdate = function(id, data) {
            let params = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
            return _this.request({
                path: "/api/customer-relations/".concat(id, "/"),
                method: "PUT",
                body: data,
                secure: true,
                type: ContentType.Json,
                format: "json",
                ...params
            });
        };
        /**
   * No description
   *
   * @tags customer-relations
   * @name CustomerRelationsPartialUpdate
   * @request PATCH:/api/customer-relations/{id}/
   * @secure
   * @response `200` `CustomerAccountRelation`
   */ this.customerRelationsPartialUpdate = function(id, data) {
            let params = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
            return _this.request({
                path: "/api/customer-relations/".concat(id, "/"),
                method: "PATCH",
                body: data,
                secure: true,
                type: ContentType.Json,
                format: "json",
                ...params
            });
        };
        /**
   * No description
   *
   * @tags customer-relations
   * @name CustomerRelationsDestroy
   * @request DELETE:/api/customer-relations/{id}/
   * @secure
   * @response `204` `void` No response body
   */ this.customerRelationsDestroy = function(id) {
            let params = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
            return _this.request({
                path: "/api/customer-relations/".concat(id, "/"),
                method: "DELETE",
                secure: true,
                ...params
            });
        };
        /**
   * No description
   *
   * @tags event-trigger
   * @name EventTriggerCreate
   * @request POST:/api/event-trigger/
   * @secure
   * @response `200` `DRFAttributeBanner`
   * @response `400` `DRFAttributeBanner`
   * @response `500` `DRFAttributeBanner`
   */ this.eventTriggerCreate = function(data) {
            let params = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
            return _this.request({
                path: "/api/event-trigger/",
                method: "POST",
                body: data,
                secure: true,
                type: ContentType.Json,
                format: "json",
                ...params
            });
        };
        /**
   * No description
   *
   * @tags external-request
   * @name ExternalRequestAttachmentRetrieve
   * @request GET:/api/external-request/attachment/
   * @secure
   * @response `200` `ExternalRequest`
   */ this.externalRequestAttachmentRetrieve = function(query) {
            let params = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
            return _this.request({
                path: "/api/external-request/attachment/",
                method: "GET",
                query: query || {
                    format: "json"
                },
                secure: true,
                format: "json",
                ...params
            });
        };
        /**
   * No description
   *
   * @tags external-request
   * @name ExternalRequestAttachmentBundleRetrieve
   * @request GET:/api/external-request/attachment-bundle/
   * @secure
   * @response `200` `ExternalRequest`
   */ this.externalRequestAttachmentBundleRetrieve = function(query) {
            let params = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
            return _this.request({
                path: "/api/external-request/attachment-bundle/",
                method: "GET",
                query: query || {
                    format: "json"
                },
                secure: true,
                format: "json",
                ...params
            });
        };
        /**
   * No description
   *
   * @tags external-request
   * @name ExternalRequestDiscountsCreate
   * @request POST:/api/external-request/discounts/
   * @secure
   * @response `200` `Discount`
   */ this.externalRequestDiscountsCreate = function(data) {
            let params = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
            return _this.request({
                path: "/api/external-request/discounts/",
                method: "POST",
                body: data,
                secure: true,
                type: ContentType.Json,
                format: "json",
                ...params
            });
        };
        /**
   * No description
   *
   * @tags external-request
   * @name ExternalRequestPrepaymentsCreate
   * @request POST:/api/external-request/prepayments/
   * @secure
   * @response `200` `Prepayment`
   */ this.externalRequestPrepaymentsCreate = function(data) {
            let params = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
            return _this.request({
                path: "/api/external-request/prepayments/",
                method: "POST",
                body: data,
                secure: true,
                type: ContentType.Json,
                format: "json",
                ...params
            });
        };
        /**
   * No description
   *
   * @tags external-request
   * @name ExternalRequestRemittanceSlipsCreate
   * @request POST:/api/external-request/remittance-slips/
   * @secure
   * @response `200` `RemittanceSlips`
   */ this.externalRequestRemittanceSlipsCreate = function(data) {
            let params = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
            return _this.request({
                path: "/api/external-request/remittance-slips/",
                method: "POST",
                body: data,
                secure: true,
                type: ContentType.Json,
                format: "json",
                ...params
            });
        };
        /**
   * No description
   *
   * @tags external-request
   * @name ExternalRequestSalesInvoiceDetailsCreate
   * @request POST:/api/external-request/sales-invoice-details/
   * @secure
   * @response `200` `SalesInvoiceDetail`
   */ this.externalRequestSalesInvoiceDetailsCreate = function(data) {
            let params = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
            return _this.request({
                path: "/api/external-request/sales-invoice-details/",
                method: "POST",
                body: data,
                secure: true,
                type: ContentType.Json,
                format: "json",
                ...params
            });
        };
        /**
   * No description
   *
   * @tags external-request
   * @name ExternalRequestSalesInvoicesCreate
   * @request POST:/api/external-request/sales-invoices/
   * @secure
   * @response `200` `SalesInvoice`
   */ this.externalRequestSalesInvoicesCreate = function(data) {
            let params = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
            return _this.request({
                path: "/api/external-request/sales-invoices/",
                method: "POST",
                body: data,
                secure: true,
                type: ContentType.Json,
                format: "json",
                ...params
            });
        };
        /**
   * No description
   *
   * @tags external-request
   * @name ExternalRequestSalesTransactionsCreate
   * @request POST:/api/external-request/sales-transactions/
   * @secure
   * @response `200` `SalesTransaction`
   */ this.externalRequestSalesTransactionsCreate = function(data) {
            let params = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
            return _this.request({
                path: "/api/external-request/sales-transactions/",
                method: "POST",
                body: data,
                secure: true,
                type: ContentType.Json,
                format: "json",
                ...params
            });
        };
        /**
   * No description
   *
   * @tags field-types
   * @name FieldTypesList
   * @request GET:/api/field-types/
   * @secure
   * @response `200` `(FieldType)[]`
   */ this.fieldTypesList = function() {
            let params = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
            return _this.request({
                path: "/api/field-types/",
                method: "GET",
                secure: true,
                format: "json",
                ...params
            });
        };
        /**
   * No description
   *
   * @tags invitations
   * @name InvitationsList
   * @request GET:/api/invitations/
   * @secure
   * @response `200` `(CustomerAccountInvitation)[]`
   */ this.invitationsList = function() {
            let params = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
            return _this.request({
                path: "/api/invitations/",
                method: "GET",
                secure: true,
                format: "json",
                ...params
            });
        };
        /**
   * No description
   *
   * @tags invitations
   * @name InvitationsCreate
   * @request POST:/api/invitations/
   * @secure
   * @response `201` `CustomerAccountInvitation`
   */ this.invitationsCreate = function(data) {
            let params = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
            return _this.request({
                path: "/api/invitations/",
                method: "POST",
                body: data,
                secure: true,
                type: ContentType.Json,
                format: "json",
                ...params
            });
        };
        /**
   * No description
   *
   * @tags invitations
   * @name InvitationsRetrieve
   * @request GET:/api/invitations/{id}/
   * @secure
   * @response `200` `CustomerAccountInvitation`
   */ this.invitationsRetrieve = function(id) {
            let params = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
            return _this.request({
                path: "/api/invitations/".concat(id, "/"),
                method: "GET",
                secure: true,
                format: "json",
                ...params
            });
        };
        /**
   * No description
   *
   * @tags invitations
   * @name InvitationsUpdate
   * @request PUT:/api/invitations/{id}/
   * @secure
   * @response `200` `CustomerAccountInvitation`
   */ this.invitationsUpdate = function(id, data) {
            let params = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
            return _this.request({
                path: "/api/invitations/".concat(id, "/"),
                method: "PUT",
                body: data,
                secure: true,
                type: ContentType.Json,
                format: "json",
                ...params
            });
        };
        /**
   * No description
   *
   * @tags invitations
   * @name InvitationsPartialUpdate
   * @request PATCH:/api/invitations/{id}/
   * @secure
   * @response `200` `CustomerAccountInvitation`
   */ this.invitationsPartialUpdate = function(id, data) {
            let params = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
            return _this.request({
                path: "/api/invitations/".concat(id, "/"),
                method: "PATCH",
                body: data,
                secure: true,
                type: ContentType.Json,
                format: "json",
                ...params
            });
        };
        /**
   * No description
   *
   * @tags invitations
   * @name InvitationsDestroy
   * @request DELETE:/api/invitations/{id}/
   * @secure
   * @response `204` `void` No response body
   */ this.invitationsDestroy = function(id) {
            let params = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
            return _this.request({
                path: "/api/invitations/".concat(id, "/"),
                method: "DELETE",
                secure: true,
                ...params
            });
        };
        /**
   * No description
   *
   * @tags invitations
   * @name InvitationsResendCreate
   * @request POST:/api/invitations/{id}/resend/
   * @secure
   * @response `200` `CustomerAccountInvitation`
   */ this.invitationsResendCreate = function(id) {
            let params = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
            return _this.request({
                path: "/api/invitations/".concat(id, "/resend/"),
                method: "POST",
                secure: true,
                format: "json",
                ...params
            });
        };
        /**
   * No description
   *
   * @tags invitations
   * @name InvitationsAcceptCreate
   * @request POST:/api/invitations/accept/
   * @secure
   * @response `200` `Login`
   */ this.invitationsAcceptCreate = function(data) {
            let params = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
            return _this.request({
                path: "/api/invitations/accept/",
                method: "POST",
                body: data,
                secure: true,
                type: ContentType.Json,
                format: "json",
                ...params
            });
        };
        /**
   * No description
   *
   * @tags invitations
   * @name InvitationsDetailsRetrieve
   * @request GET:/api/invitations/details/
   * @secure
   * @response `200` `CustomerAccountInvitationDetail`
   */ this.invitationsDetailsRetrieve = function(query) {
            let params = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
            return _this.request({
                path: "/api/invitations/details/",
                method: "GET",
                query: query || {
                    format: "json"
                },
                secure: true,
                format: "json",
                ...params
            });
        };
        /**
   * No description
   *
   * @tags loan-application
   * @name LoanApplicationApplyCreate
   * @request POST:/api/loan-application/apply/
   * @secure
   * @response `200` `void` No response body
   */ this.loanApplicationApplyCreate = function(data) {
            let params = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
            return _this.request({
                path: "/api/loan-application/apply/",
                method: "POST",
                body: data,
                secure: true,
                type: ContentType.Json,
                ...params
            });
        };
        /**
   * No description
   *
   * @tags loan-application
   * @name LoanApplicationCalculatorPreviewRetrieve
   * @request GET:/api/loan-application/calculator-preview/
   * @secure
   * @response `200` `OptionsResponse`
   */ this.loanApplicationCalculatorPreviewRetrieve = function(query) {
            let params = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
            return _this.request({
                path: "/api/loan-application/calculator-preview/",
                method: "GET",
                query: query || {
                    format: "json"
                },
                secure: true,
                format: "json",
                ...params
            });
        };
        /**
   * No description
   *
   * @tags loan-application
   * @name LoanApplicationCalculatorResultRetrieve
   * @request GET:/api/loan-application/calculator-result/
   * @secure
   * @response `200` `LoanCalculationResponse`
   */ this.loanApplicationCalculatorResultRetrieve = function(query) {
            let params = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
            return _this.request({
                path: "/api/loan-application/calculator-result/",
                method: "GET",
                query: query || {
                    format: "json"
                },
                secure: true,
                format: "json",
                ...params
            });
        };
        /**
   * No description
   *
   * @tags loan-application
   * @name LoanApplicationStatusRetrieve
   * @request GET:/api/loan-application/status/
   * @secure
   * @response `200` `void` No response body
   */ this.loanApplicationStatusRetrieve = function() {
            let params = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
            return _this.request({
                path: "/api/loan-application/status/",
                method: "GET",
                secure: true,
                ...params
            });
        };
        /**
   * No description
   *
   * @tags membership-management
   * @name MembershipManagementList
   * @request GET:/api/membership-management/
   * @secure
   * @response `200` `(CustomerAccountMembershipManagement)[]`
   */ this.membershipManagementList = function() {
            let params = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
            return _this.request({
                path: "/api/membership-management/",
                method: "GET",
                secure: true,
                format: "json",
                ...params
            });
        };
        /**
   * No description
   *
   * @tags membership-management
   * @name MembershipManagementRetrieve
   * @request GET:/api/membership-management/{id}/
   * @secure
   * @response `200` `CustomerAccountMembershipManagement`
   */ this.membershipManagementRetrieve = function(id) {
            let params = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
            return _this.request({
                path: "/api/membership-management/".concat(id, "/"),
                method: "GET",
                secure: true,
                format: "json",
                ...params
            });
        };
        /**
   * No description
   *
   * @tags membership-management
   * @name MembershipManagementUpdate
   * @request PUT:/api/membership-management/{id}/
   * @secure
   * @response `200` `CustomerAccountMembershipManagement`
   */ this.membershipManagementUpdate = function(id, data) {
            let params = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
            return _this.request({
                path: "/api/membership-management/".concat(id, "/"),
                method: "PUT",
                body: data,
                secure: true,
                type: ContentType.Json,
                format: "json",
                ...params
            });
        };
        /**
   * No description
   *
   * @tags membership-management
   * @name MembershipManagementPartialUpdate
   * @request PATCH:/api/membership-management/{id}/
   * @secure
   * @response `200` `CustomerAccountMembershipManagement`
   */ this.membershipManagementPartialUpdate = function(id, data) {
            let params = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
            return _this.request({
                path: "/api/membership-management/".concat(id, "/"),
                method: "PATCH",
                body: data,
                secure: true,
                type: ContentType.Json,
                format: "json",
                ...params
            });
        };
        /**
   * No description
   *
   * @tags memberships
   * @name MembershipsList
   * @request GET:/api/memberships/
   * @secure
   * @response `200` `(CustomerAccountMembership)[]`
   */ this.membershipsList = function() {
            let params = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
            return _this.request({
                path: "/api/memberships/",
                method: "GET",
                secure: true,
                format: "json",
                ...params
            });
        };
        /**
   * No description
   *
   * @tags memberships
   * @name MembershipsRetrieve
   * @request GET:/api/memberships/{id}/
   * @secure
   * @response `200` `CustomerAccountMembership`
   */ this.membershipsRetrieve = function(id) {
            let params = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
            return _this.request({
                path: "/api/memberships/".concat(id, "/"),
                method: "GET",
                secure: true,
                format: "json",
                ...params
            });
        };
        /**
   * No description
   *
   * @tags memberships
   * @name MembershipsSwitchAccountCreate
   * @request POST:/api/memberships/{id}/switch-account/
   * @secure
   * @response `200` `Login`
   */ this.membershipsSwitchAccountCreate = function(id) {
            let params = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
            return _this.request({
                path: "/api/memberships/".concat(id, "/switch-account/"),
                method: "POST",
                secure: true,
                format: "json",
                ...params
            });
        };
        /**
   * No description
   *
   * @tags products
   * @name ProductsList
   * @request GET:/api/products/
   * @secure
   * @response `200` `PaginatedProductListList`
   */ this.productsList = function(query) {
            let params = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
            return _this.request({
                path: "/api/products/",
                method: "GET",
                query: query || {
                    format: "json"
                },
                secure: true,
                format: "json",
                ...params
            });
        };
        /**
   * No description
   *
   * @tags products
   * @name ProductsRetrieve
   * @request GET:/api/products/{slug}/
   * @secure
   * @response `200` `ProductDetail`
   */ this.productsRetrieve = function(slug) {
            let params = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
            return _this.request({
                path: "/api/products/".concat(slug, "/"),
                method: "GET",
                secure: true,
                format: "json",
                ...params
            });
        };
        /**
   * No description
   *
   * @tags products
   * @name ProductsInventoryRetrieve
   * @request GET:/api/products/{slug}/inventory/
   * @secure
   * @response `200` `ProductInventory`
   */ this.productsInventoryRetrieve = function(slug) {
            let params = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
            return _this.request({
                path: "/api/products/".concat(slug, "/inventory/"),
                method: "GET",
                secure: true,
                format: "json",
                ...params
            });
        };
        /**
   * No description
   *
   * @tags products
   * @name ProductsPricesRetrieve
   * @request GET:/api/products/{slug}/prices/
   * @secure
   * @response `200` `Record<string, { price: { vat: number, net: number, gross: number, perSqm?: number | null }, discounted: { vat: number, net: number, gross: number, perSqm?: number | null, name: string, percentage: number }, isSqmProduct?: boolean, packagingQuantity?: number, sqm: number | null }>`
   */ this.productsPricesRetrieve = function(slug) {
            let params = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
            return _this.request({
                path: "/api/products/".concat(slug, "/prices/"),
                method: "GET",
                secure: true,
                format: "json",
                ...params
            });
        };
        /**
   * No description
   *
   * @tags products
   * @name ProductsApiProductsMediaBySkuRetrieve
   * @request GET:/api/products/api/products/media/by-sku/{sku}/
   * @secure
   * @response `200` `ProductDetail`
   */ this.productsApiProductsMediaBySkuRetrieve = function(sku) {
            let params = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
            return _this.request({
                path: "/api/products/api/products/media/by-sku/".concat(sku, "/"),
                method: "GET",
                secure: true,
                format: "json",
                ...params
            });
        };
        /**
   * No description
   *
   * @tags products
   * @name ProductsBySlugRetrieve
   * @request GET:/api/products/by-slug/{slug}/
   * @secure
   * @response `200` `ProductDetail`
   */ this.productsBySlugRetrieve = function(slug) {
            let params = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
            return _this.request({
                path: "/api/products/by-slug/".concat(slug, "/"),
                method: "GET",
                secure: true,
                format: "json",
                ...params
            });
        };
        /**
   * No description
   *
   * @tags products
   * @name ProductsInventoryList
   * @request GET:/api/products/inventory/
   * @secure
   * @response `200` `PaginatedProductInventoryList`
   */ this.productsInventoryList = function(query) {
            let params = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
            return _this.request({
                path: "/api/products/inventory/",
                method: "GET",
                query: query || {
                    format: "json"
                },
                secure: true,
                format: "json",
                ...params
            });
        };
        /**
   * No description
   *
   * @tags products
   * @name ProductsLowestPricesList
   * @request GET:/api/products/lowest-prices/
   * @secure
   * @response `200` `{ count: number, next: string | null, previous: string | null, results: Record<string, Record<string, { price: { vat: number, net: number, gross: number, perSqm?: number | null }, discounted: { vat: number, net: number, gross: number, perSqm?: number | null, name: string, percentage: number }, isSqmProduct?: boolean, packagingQuantity?: number, sqm: number | null }>> }`
   */ this.productsLowestPricesList = function(query) {
            let params = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
            return _this.request({
                path: "/api/products/lowest-prices/",
                method: "GET",
                query: query || {
                    format: "json"
                },
                secure: true,
                format: "json",
                ...params
            });
        };
        /**
   * No description
   *
   * @tags products
   * @name ProductsMediaBySkuRetrieve
   * @request GET:/api/products/media/by-sku/{sku}
   * @secure
   * @response `200` `ProductDetail`
   */ this.productsMediaBySkuRetrieve = function(sku) {
            let params = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
            return _this.request({
                path: "/api/products/media/by-sku/".concat(sku),
                method: "GET",
                secure: true,
                format: "json",
                ...params
            });
        };
        /**
   * No description
   *
   * @tags products
   * @name ProductsPricesList
   * @request GET:/api/products/prices/
   * @secure
   * @response `200` `{ count: number, next: string | null, previous: string | null, results: Record<string, { price: { vat: number, net: number, gross: number, perSqm?: number | null }, discounted: { vat: number, net: number, gross: number, perSqm?: number | null, name: string, percentage: number }, isSqmProduct?: boolean, packagingQuantity?: number, sqm: number | null }> }`
   */ this.productsPricesList = function(query) {
            let params = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
            return _this.request({
                path: "/api/products/prices/",
                method: "GET",
                query: query || {
                    format: "json"
                },
                secure: true,
                format: "json",
                ...params
            });
        };
        /**
   * No description
   *
   * @tags products
   * @name ProductsSyncCreate
   * @request POST:/api/products/sync/
   * @secure
   * @response `200` `ProductSync`
   */ this.productsSyncCreate = function(data) {
            let params = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
            return _this.request({
                path: "/api/products/sync/",
                method: "POST",
                body: data,
                secure: true,
                type: ContentType.Json,
                format: "json",
                ...params
            });
        };
        /**
   * No description
   *
   * @tags products
   * @name ProductsTestLoggingRetrieve
   * @request GET:/api/products/test-logging/
   * @secure
   * @response `200` `ProductDetail`
   */ this.productsTestLoggingRetrieve = function() {
            let params = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
            return _this.request({
                path: "/api/products/test-logging/",
                method: "GET",
                secure: true,
                format: "json",
                ...params
            });
        };
        /**
   * No description
   *
   * @tags products
   * @name ProductsThrowExcRetrieve
   * @request GET:/api/products/throw-exc/
   * @secure
   * @response `200` `ProductDetail`
   */ this.productsThrowExcRetrieve = function() {
            let params = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
            return _this.request({
                path: "/api/products/throw-exc/",
                method: "GET",
                secure: true,
                format: "json",
                ...params
            });
        };
        /**
   * No description
   *
   * @tags saltpay
   * @name SaltpayPaymentTokensList
   * @request GET:/api/saltpay/payment-tokens/
   * @secure
   * @response `200` `(PaymentToken)[]`
   */ this.saltpayPaymentTokensList = function() {
            let params = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
            return _this.request({
                path: "/api/saltpay/payment-tokens/",
                method: "GET",
                secure: true,
                format: "json",
                ...params
            });
        };
        /**
   * No description
   *
   * @tags saltpay
   * @name SaltpayPaymentTokensCreate
   * @request POST:/api/saltpay/payment-tokens/
   * @secure
   * @response `201` `PaymentToken`
   */ this.saltpayPaymentTokensCreate = function(data) {
            let params = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
            return _this.request({
                path: "/api/saltpay/payment-tokens/",
                method: "POST",
                body: data,
                secure: true,
                type: ContentType.Json,
                format: "json",
                ...params
            });
        };
        /**
   * No description
   *
   * @tags saltpay
   * @name SaltpayPaymentsCallbackCreate
   * @request POST:/api/saltpay/payments/{id}/callback/
   * @secure
   * @response `200` `void` No response body
   */ this.saltpayPaymentsCallbackCreate = function(id) {
            let params = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
            return _this.request({
                path: "/api/saltpay/payments/".concat(id, "/callback/"),
                method: "POST",
                secure: true,
                ...params
            });
        };
        /**
   * No description
   *
   * @tags saltpay
   * @name SaltpayVirtualCardsList
   * @request GET:/api/saltpay/virtual-cards/
   * @secure
   * @response `200` `(VirtualCard)[]`
   */ this.saltpayVirtualCardsList = function() {
            let params = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
            return _this.request({
                path: "/api/saltpay/virtual-cards/",
                method: "GET",
                secure: true,
                format: "json",
                ...params
            });
        };
        /**
   * No description
   *
   * @tags saltpay
   * @name SaltpayVirtualCardsCreate
   * @request POST:/api/saltpay/virtual-cards/
   * @secure
   * @response `201` `VirtualCard`
   */ this.saltpayVirtualCardsCreate = function(data) {
            let params = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
            return _this.request({
                path: "/api/saltpay/virtual-cards/",
                method: "POST",
                body: data,
                secure: true,
                type: ContentType.Json,
                format: "json",
                ...params
            });
        };
        /**
   * No description
   *
   * @tags saltpay
   * @name SaltpayVirtualCardsDestroy
   * @request DELETE:/api/saltpay/virtual-cards/{id}/
   * @secure
   * @response `204` `void` No response body
   */ this.saltpayVirtualCardsDestroy = function(id) {
            let params = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
            return _this.request({
                path: "/api/saltpay/virtual-cards/".concat(id, "/"),
                method: "DELETE",
                secure: true,
                ...params
            });
        };
        /**
   * @description OpenApi3 schema for this API. Format can be selected via content negotiation. - YAML: application/vnd.oai.openapi - JSON: application/vnd.oai.openapi+json
   *
   * @tags schema
   * @name SchemaRetrieve
   * @request GET:/api/schema/
   * @secure
   * @response `200` `Record<string, any>`
   */ this.schemaRetrieve = function(query) {
            let params = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
            return _this.request({
                path: "/api/schema/",
                method: "GET",
                query: query || {
                    format: "json"
                },
                secure: true,
                format: "json",
                ...params
            });
        };
        /**
   * No description
   *
   * @tags spec-field-types
   * @name SpecFieldTypesList
   * @request GET:/api/spec-field-types/
   * @secure
   * @response `200` `({ id: string, name: Record<string, string>, unit: string, index: number, category: string, defaultValue: (string | number | number | boolean | null), isMultiValue: boolean, template: number })[]`
   */ this.specFieldTypesList = function() {
            let params = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
            return _this.request({
                path: "/api/spec-field-types/",
                method: "GET",
                secure: true,
                format: "json",
                ...params
            });
        };
        /**
   * No description
   *
   * @tags sync-messages
   * @name SyncMessagesCreate
   * @request POST:/api/sync-messages/
   * @secure
   * @response `200` `SyncMessage`
   */ this.syncMessagesCreate = function(data) {
            let params = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
            return _this.request({
                path: "/api/sync-messages/",
                method: "POST",
                body: data,
                secure: true,
                type: ContentType.Json,
                format: "json",
                ...params
            });
        };
        /**
   * No description
   *
   * @tags users
   * @name UsersList
   * @request GET:/api/users/
   * @secure
   * @response `200` `(User)[]`
   */ this.usersList = function(query) {
            let params = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
            return _this.request({
                path: "/api/users/",
                method: "GET",
                query: query || {
                    format: "json"
                },
                secure: true,
                format: "json",
                ...params
            });
        };
        /**
   * No description
   *
   * @tags users
   * @name UsersRetrieve
   * @request GET:/api/users/{id}/
   * @secure
   * @response `200` `User`
   */ this.usersRetrieve = function(id) {
            let params = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
            return _this.request({
                path: "/api/users/".concat(id, "/"),
                method: "GET",
                secure: true,
                format: "json",
                ...params
            });
        };
        /**
   * No description
   *
   * @tags users
   * @name UsersSettingsRetrieve
   * @request GET:/api/users/{id}/settings/
   * @secure
   * @response `200` `object`
   */ this.usersSettingsRetrieve = function(id) {
            let params = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
            return _this.request({
                path: "/api/users/".concat(id, "/settings/"),
                method: "GET",
                secure: true,
                format: "json",
                ...params
            });
        };
        /**
   * No description
   *
   * @tags users
   * @name UsersSettingsCreate
   * @request POST:/api/users/{id}/settings/
   * @secure
   * @response `200` `object`
   */ this.usersSettingsCreate = function(id, data) {
            let params = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
            return _this.request({
                path: "/api/users/".concat(id, "/settings/"),
                method: "POST",
                body: data,
                secure: true,
                format: "json",
                ...params
            });
        };
        /**
   * No description
   *
   * @tags users
   * @name UsersSettingsPartialUpdate
   * @request PATCH:/api/users/{id}/settings/
   * @secure
   * @response `200` `object`
   */ this.usersSettingsPartialUpdate = function(id, data) {
            let params = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
            return _this.request({
                path: "/api/users/".concat(id, "/settings/"),
                method: "PATCH",
                body: data,
                secure: true,
                format: "json",
                ...params
            });
        };
        /**
   * No description
   *
   * @tags users
   * @name UsersAcceptTermsCreate
   * @request POST:/api/users/accept_terms/
   * @secure
   * @response `200` `User`
   */ this.usersAcceptTermsCreate = function() {
            let params = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
            return _this.request({
                path: "/api/users/accept_terms/",
                method: "POST",
                secure: true,
                format: "json",
                ...params
            });
        };
        /**
   * No description
   *
   * @tags users
   * @name UsersCheckEmailAvailabilityCreate
   * @request POST:/api/users/check-email-availability/
   * @secure
   * @response `200` `CheckEmailAvailabilityResponse`
   */ this.usersCheckEmailAvailabilityCreate = function(data) {
            let params = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
            return _this.request({
                path: "/api/users/check-email-availability/",
                method: "POST",
                body: data,
                secure: true,
                type: ContentType.Json,
                format: "json",
                ...params
            });
        };
        /**
   * No description
   *
   * @tags users
   * @name UsersImpersonateCreate
   * @request POST:/api/users/impersonate/
   * @secure
   * @response `200` `Login`
   */ this.usersImpersonateCreate = function(data) {
            let params = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
            return _this.request({
                path: "/api/users/impersonate/",
                method: "POST",
                body: data,
                secure: true,
                type: ContentType.Json,
                format: "json",
                ...params
            });
        };
        /**
   * No description
   *
   * @tags users
   * @name UsersLoginCreate
   * @request POST:/api/users/login/
   * @secure
   * @response `200` `Login`
   */ this.usersLoginCreate = function(data) {
            let params = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
            return _this.request({
                path: "/api/users/login/",
                method: "POST",
                body: data,
                secure: true,
                type: ContentType.Json,
                format: "json",
                ...params
            });
        };
        /**
   * No description
   *
   * @tags users
   * @name UsersMeRetrieve
   * @request GET:/api/users/me/
   * @secure
   * @response `200` `User`
   */ this.usersMeRetrieve = function() {
            let params = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
            return _this.request({
                path: "/api/users/me/",
                method: "GET",
                secure: true,
                format: "json",
                ...params
            });
        };
        /**
   * No description
   *
   * @tags users
   * @name UsersPolledLoginCreate
   * @request POST:/api/users/polled-login/
   * @secure
   * @response `200` `PollLogin`
   */ this.usersPolledLoginCreate = function(data) {
            let params = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
            return _this.request({
                path: "/api/users/polled-login/",
                method: "POST",
                body: data,
                secure: true,
                type: ContentType.Json,
                format: "json",
                ...params
            });
        };
        /**
   * No description
   *
   * @tags users
   * @name UsersSetEmailCreate
   * @request POST:/api/users/set_email/
   * @secure
   * @response `200` `Login`
   */ this.usersSetEmailCreate = function(data) {
            let params = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
            return _this.request({
                path: "/api/users/set_email/",
                method: "POST",
                body: data,
                secure: true,
                type: ContentType.Json,
                format: "json",
                ...params
            });
        };
        /**
   * No description
   *
   * @tags users
   * @name UsersVerifyEmailCreate
   * @request POST:/api/users/verify_email/
   * @secure
   * @response `200` `Login`
   */ this.usersVerifyEmailCreate = function(data) {
            let params = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
            return _this.request({
                path: "/api/users/verify_email/",
                method: "POST",
                body: data,
                secure: true,
                type: ContentType.Json,
                format: "json",
                ...params
            });
        };
        /**
   * No description
   *
   * @tags warehouses
   * @name WarehousesList
   * @request GET:/api/warehouses/
   * @secure
   * @response `200` `(Warehouse)[]`
   */ this.warehousesList = function() {
            let params = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
            return _this.request({
                path: "/api/warehouses/",
                method: "GET",
                secure: true,
                format: "json",
                ...params
            });
        };
        /**
   * No description
   *
   * @tags warehouses
   * @name WarehousesRetrieve
   * @request GET:/api/warehouses/{id}/
   * @secure
   * @response `200` `Warehouse`
   */ this.warehousesRetrieve = function(id) {
            let params = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
            return _this.request({
                path: "/api/warehouses/".concat(id, "/"),
                method: "GET",
                secure: true,
                format: "json",
                ...params
            });
        };
        /**
   * No description
   *
   * @tags warehouses
   * @name WarehousesHasContractRetrieve
   * @request GET:/api/warehouses/has_contract/
   * @secure
   * @response `200` `Warehouse`
   */ this.warehousesHasContractRetrieve = function() {
            let params = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
            return _this.request({
                path: "/api/warehouses/has_contract/",
                method: "GET",
                secure: true,
                format: "json",
                ...params
            });
        };
    }
}

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-api-rest-virtual-a514398bdb/1/packages/lib-api-rest/src/config.ts
/* eslint-disable eslint-comments/disable-enable-pair */ /* eslint-disable @typescript-eslint/no-explicit-any */ // So we can skip types/node
let URL =  false ? 0 : window.__APP__CONFIG__.SALEOR_BASE_HOST;
const securityWorker = (token)=>{
    const conf = {
        headers: {
            Authorization: ""
        }
    };
    if (token && token !== "" && "object" !== "undefined") {
        Object.assign(conf.headers, {
            Authorization: "JWT ".concat(token)
        });
    }
    return Promise.resolve(conf);
};
const restApiConf = {
    baseUrl: URL ? URL.replace(/\/$/, "") : null,
    securityWorker
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-api-rest-virtual-a514398bdb/1/packages/lib-api-rest/src/data-contracts.ts
/* eslint-disable */ /* tslint:disable */ /*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */ var ClickAndCollectOptionEnum;
(function(ClickAndCollectOptionEnum) {
    ClickAndCollectOptionEnum["Disabled"] = "disabled";
    ClickAndCollectOptionEnum["Local"] = "local";
    ClickAndCollectOptionEnum["All"] = "all";
})(ClickAndCollectOptionEnum || (ClickAndCollectOptionEnum = {}));
var CountryEnum;
(function(CountryEnum) {
    CountryEnum["AF"] = "AF";
    CountryEnum["AX"] = "AX";
    CountryEnum["AL"] = "AL";
    CountryEnum["DZ"] = "DZ";
    CountryEnum["AS"] = "AS";
    CountryEnum["AD"] = "AD";
    CountryEnum["AO"] = "AO";
    CountryEnum["AI"] = "AI";
    CountryEnum["AQ"] = "AQ";
    CountryEnum["AG"] = "AG";
    CountryEnum["AR"] = "AR";
    CountryEnum["AM"] = "AM";
    CountryEnum["AW"] = "AW";
    CountryEnum["AU"] = "AU";
    CountryEnum["AT"] = "AT";
    CountryEnum["AZ"] = "AZ";
    CountryEnum["BS"] = "BS";
    CountryEnum["BH"] = "BH";
    CountryEnum["BD"] = "BD";
    CountryEnum["BB"] = "BB";
    CountryEnum["BY"] = "BY";
    CountryEnum["BE"] = "BE";
    CountryEnum["BZ"] = "BZ";
    CountryEnum["BJ"] = "BJ";
    CountryEnum["BM"] = "BM";
    CountryEnum["BT"] = "BT";
    CountryEnum["BO"] = "BO";
    CountryEnum["BQ"] = "BQ";
    CountryEnum["BA"] = "BA";
    CountryEnum["BW"] = "BW";
    CountryEnum["BV"] = "BV";
    CountryEnum["BR"] = "BR";
    CountryEnum["IO"] = "IO";
    CountryEnum["BN"] = "BN";
    CountryEnum["BG"] = "BG";
    CountryEnum["BF"] = "BF";
    CountryEnum["BI"] = "BI";
    CountryEnum["CV"] = "CV";
    CountryEnum["KH"] = "KH";
    CountryEnum["CM"] = "CM";
    CountryEnum["CA"] = "CA";
    CountryEnum["KY"] = "KY";
    CountryEnum["CF"] = "CF";
    CountryEnum["TD"] = "TD";
    CountryEnum["CL"] = "CL";
    CountryEnum["CN"] = "CN";
    CountryEnum["CX"] = "CX";
    CountryEnum["CC"] = "CC";
    CountryEnum["CO"] = "CO";
    CountryEnum["KM"] = "KM";
    CountryEnum["CG"] = "CG";
    CountryEnum["CD"] = "CD";
    CountryEnum["CK"] = "CK";
    CountryEnum["CR"] = "CR";
    CountryEnum["CI"] = "CI";
    CountryEnum["HR"] = "HR";
    CountryEnum["CU"] = "CU";
    CountryEnum["CW"] = "CW";
    CountryEnum["CY"] = "CY";
    CountryEnum["CZ"] = "CZ";
    CountryEnum["DK"] = "DK";
    CountryEnum["DJ"] = "DJ";
    CountryEnum["DM"] = "DM";
    CountryEnum["DO"] = "DO";
    CountryEnum["EC"] = "EC";
    CountryEnum["EG"] = "EG";
    CountryEnum["SV"] = "SV";
    CountryEnum["GQ"] = "GQ";
    CountryEnum["ER"] = "ER";
    CountryEnum["EE"] = "EE";
    CountryEnum["SZ"] = "SZ";
    CountryEnum["ET"] = "ET";
    CountryEnum["FK"] = "FK";
    CountryEnum["FO"] = "FO";
    CountryEnum["FJ"] = "FJ";
    CountryEnum["FI"] = "FI";
    CountryEnum["FR"] = "FR";
    CountryEnum["GF"] = "GF";
    CountryEnum["PF"] = "PF";
    CountryEnum["TF"] = "TF";
    CountryEnum["GA"] = "GA";
    CountryEnum["GM"] = "GM";
    CountryEnum["GE"] = "GE";
    CountryEnum["DE"] = "DE";
    CountryEnum["GH"] = "GH";
    CountryEnum["GI"] = "GI";
    CountryEnum["GR"] = "GR";
    CountryEnum["GL"] = "GL";
    CountryEnum["GD"] = "GD";
    CountryEnum["GP"] = "GP";
    CountryEnum["GU"] = "GU";
    CountryEnum["GT"] = "GT";
    CountryEnum["GG"] = "GG";
    CountryEnum["GN"] = "GN";
    CountryEnum["GW"] = "GW";
    CountryEnum["GY"] = "GY";
    CountryEnum["HT"] = "HT";
    CountryEnum["HM"] = "HM";
    CountryEnum["VA"] = "VA";
    CountryEnum["HN"] = "HN";
    CountryEnum["HK"] = "HK";
    CountryEnum["HU"] = "HU";
    CountryEnum["IS"] = "IS";
    CountryEnum["IN"] = "IN";
    CountryEnum["ID"] = "ID";
    CountryEnum["IR"] = "IR";
    CountryEnum["IQ"] = "IQ";
    CountryEnum["IE"] = "IE";
    CountryEnum["IM"] = "IM";
    CountryEnum["IL"] = "IL";
    CountryEnum["IT"] = "IT";
    CountryEnum["JM"] = "JM";
    CountryEnum["JP"] = "JP";
    CountryEnum["JE"] = "JE";
    CountryEnum["JO"] = "JO";
    CountryEnum["KZ"] = "KZ";
    CountryEnum["KE"] = "KE";
    CountryEnum["KI"] = "KI";
    CountryEnum["KW"] = "KW";
    CountryEnum["KG"] = "KG";
    CountryEnum["LA"] = "LA";
    CountryEnum["LV"] = "LV";
    CountryEnum["LB"] = "LB";
    CountryEnum["LS"] = "LS";
    CountryEnum["LR"] = "LR";
    CountryEnum["LY"] = "LY";
    CountryEnum["LI"] = "LI";
    CountryEnum["LT"] = "LT";
    CountryEnum["LU"] = "LU";
    CountryEnum["MO"] = "MO";
    CountryEnum["MG"] = "MG";
    CountryEnum["MW"] = "MW";
    CountryEnum["MY"] = "MY";
    CountryEnum["MV"] = "MV";
    CountryEnum["ML"] = "ML";
    CountryEnum["MT"] = "MT";
    CountryEnum["MH"] = "MH";
    CountryEnum["MQ"] = "MQ";
    CountryEnum["MR"] = "MR";
    CountryEnum["MU"] = "MU";
    CountryEnum["YT"] = "YT";
    CountryEnum["MX"] = "MX";
    CountryEnum["FM"] = "FM";
    CountryEnum["MD"] = "MD";
    CountryEnum["MC"] = "MC";
    CountryEnum["MN"] = "MN";
    CountryEnum["ME"] = "ME";
    CountryEnum["MS"] = "MS";
    CountryEnum["MA"] = "MA";
    CountryEnum["MZ"] = "MZ";
    CountryEnum["MM"] = "MM";
    CountryEnum["NA"] = "NA";
    CountryEnum["NR"] = "NR";
    CountryEnum["NP"] = "NP";
    CountryEnum["NL"] = "NL";
    CountryEnum["NC"] = "NC";
    CountryEnum["NZ"] = "NZ";
    CountryEnum["NI"] = "NI";
    CountryEnum["NE"] = "NE";
    CountryEnum["NG"] = "NG";
    CountryEnum["NU"] = "NU";
    CountryEnum["NF"] = "NF";
    CountryEnum["KP"] = "KP";
    CountryEnum["MK"] = "MK";
    CountryEnum["MP"] = "MP";
    CountryEnum["NO"] = "NO";
    CountryEnum["OM"] = "OM";
    CountryEnum["PK"] = "PK";
    CountryEnum["PW"] = "PW";
    CountryEnum["PS"] = "PS";
    CountryEnum["PA"] = "PA";
    CountryEnum["PG"] = "PG";
    CountryEnum["PY"] = "PY";
    CountryEnum["PE"] = "PE";
    CountryEnum["PH"] = "PH";
    CountryEnum["PN"] = "PN";
    CountryEnum["PL"] = "PL";
    CountryEnum["PT"] = "PT";
    CountryEnum["PR"] = "PR";
    CountryEnum["QA"] = "QA";
    CountryEnum["RE"] = "RE";
    CountryEnum["RO"] = "RO";
    CountryEnum["RU"] = "RU";
    CountryEnum["RW"] = "RW";
    CountryEnum["BL"] = "BL";
    CountryEnum["SH"] = "SH";
    CountryEnum["KN"] = "KN";
    CountryEnum["LC"] = "LC";
    CountryEnum["MF"] = "MF";
    CountryEnum["PM"] = "PM";
    CountryEnum["VC"] = "VC";
    CountryEnum["WS"] = "WS";
    CountryEnum["SM"] = "SM";
    CountryEnum["ST"] = "ST";
    CountryEnum["SA"] = "SA";
    CountryEnum["SN"] = "SN";
    CountryEnum["RS"] = "RS";
    CountryEnum["SC"] = "SC";
    CountryEnum["SL"] = "SL";
    CountryEnum["SG"] = "SG";
    CountryEnum["SX"] = "SX";
    CountryEnum["SK"] = "SK";
    CountryEnum["SI"] = "SI";
    CountryEnum["SB"] = "SB";
    CountryEnum["SO"] = "SO";
    CountryEnum["ZA"] = "ZA";
    CountryEnum["GS"] = "GS";
    CountryEnum["KR"] = "KR";
    CountryEnum["SS"] = "SS";
    CountryEnum["ES"] = "ES";
    CountryEnum["LK"] = "LK";
    CountryEnum["SD"] = "SD";
    CountryEnum["SR"] = "SR";
    CountryEnum["SJ"] = "SJ";
    CountryEnum["SE"] = "SE";
    CountryEnum["CH"] = "CH";
    CountryEnum["SY"] = "SY";
    CountryEnum["TW"] = "TW";
    CountryEnum["TJ"] = "TJ";
    CountryEnum["TZ"] = "TZ";
    CountryEnum["TH"] = "TH";
    CountryEnum["TL"] = "TL";
    CountryEnum["TG"] = "TG";
    CountryEnum["TK"] = "TK";
    CountryEnum["TO"] = "TO";
    CountryEnum["TT"] = "TT";
    CountryEnum["TN"] = "TN";
    CountryEnum["TR"] = "TR";
    CountryEnum["TM"] = "TM";
    CountryEnum["TC"] = "TC";
    CountryEnum["TV"] = "TV";
    CountryEnum["UG"] = "UG";
    CountryEnum["UA"] = "UA";
    CountryEnum["AE"] = "AE";
    CountryEnum["GB"] = "GB";
    CountryEnum["UM"] = "UM";
    CountryEnum["US"] = "US";
    CountryEnum["UY"] = "UY";
    CountryEnum["UZ"] = "UZ";
    CountryEnum["VU"] = "VU";
    CountryEnum["VE"] = "VE";
    CountryEnum["VN"] = "VN";
    CountryEnum["VG"] = "VG";
    CountryEnum["VI"] = "VI";
    CountryEnum["WF"] = "WF";
    CountryEnum["EH"] = "EH";
    CountryEnum["YE"] = "YE";
    CountryEnum["ZM"] = "ZM";
    CountryEnum["ZW"] = "ZW";
})(CountryEnum || (CountryEnum = {}));
var CustomerContactInfoMethodEnum;
(function(CustomerContactInfoMethodEnum) {
    CustomerContactInfoMethodEnum["PHONE_NUMBER"] = "PHONE_NUMBER";
    CustomerContactInfoMethodEnum["EMAIL"] = "EMAIL";
})(CustomerContactInfoMethodEnum || (CustomerContactInfoMethodEnum = {}));
var DesignationEnum;
(function(DesignationEnum) {
    DesignationEnum["Individual"] = "Individual";
    DesignationEnum["Unverified"] = "Unverified";
    DesignationEnum["Verified"] = "Verified";
})(DesignationEnum || (DesignationEnum = {}));
var ExternalMethodEnum;
(function(ExternalMethodEnum) {
    ExternalMethodEnum["Invoice"] = "invoice";
    ExternalMethodEnum["Details"] = "details";
    ExternalMethodEnum["Slips"] = "slips";
    ExternalMethodEnum["Transactions"] = "transactions";
    ExternalMethodEnum["Prepayments"] = "prepayments";
    ExternalMethodEnum["Discounts"] = "discounts";
})(ExternalMethodEnum || (ExternalMethodEnum = {}));
var PolledLoginMethodEnum;
(function(PolledLoginMethodEnum) {
    PolledLoginMethodEnum["App"] = "App";
    PolledLoginMethodEnum["Sim"] = "Sim";
    PolledLoginMethodEnum["Poll"] = "Poll";
})(PolledLoginMethodEnum || (PolledLoginMethodEnum = {}));
var ProductMediaTypeEnum;
(function(ProductMediaTypeEnum) {
    ProductMediaTypeEnum["IMAGE"] = "IMAGE";
    ProductMediaTypeEnum["VIDEO"] = "VIDEO";
})(ProductMediaTypeEnum || (ProductMediaTypeEnum = {}));
var RelationTypeEnum;
(function(RelationTypeEnum) {
    RelationTypeEnum["Project"] = "Project";
    RelationTypeEnum["Key"] = "Key";
    RelationTypeEnum["Division"] = "Division";
})(RelationTypeEnum || (RelationTypeEnum = {}));
var RoleEnum;
(function(RoleEnum) {
    RoleEnum["Owner"] = "Owner";
    RoleEnum["Admin"] = "Admin";
    RoleEnum["Contractor"] = "Contractor";
    RoleEnum["Employee"] = "Employee";
})(RoleEnum || (RoleEnum = {}));
var ShippingMethodTypeEnum;
(function(ShippingMethodTypeEnum) {
    ShippingMethodTypeEnum["Price"] = "price";
    ShippingMethodTypeEnum["Weight"] = "weight";
})(ShippingMethodTypeEnum || (ShippingMethodTypeEnum = {}));
var StatusEnum;
(function(StatusEnum) {
    StatusEnum["Success"] = "success";
})(StatusEnum || (StatusEnum = {}));
var TopicEnum;
(function(TopicEnum) {
    TopicEnum["Business"] = "Business";
    TopicEnum["Delivery"] = "Delivery";
    TopicEnum["Home"] = "Home";
})(TopicEnum || (TopicEnum = {}));

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-api-rest-virtual-a514398bdb/1/packages/lib-api-rest/src/index.ts
/* tslint:disable */ 

const restApi = new Api(restApiConf);





/***/ }),

/***/ 15440:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "UY": function() { return /* binding */ getCategoriesAndBreadcrumb; },
/* harmony export */   "zR": function() { return /* binding */ categoriesData; }
/* harmony export */ });
/* unused harmony exports getCategoriesWithChildren, initialFetch, getCategoriesAndChildren */
/* harmony import */ var _byko_lib_api_rest__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97639);
/* harmony import */ var _byko_types_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(71612);
/* eslint-disable @typescript-eslint/no-namespace */ /* eslint-disable @typescript-eslint/prefer-namespace-keyword */ 

const getCategoryID = (slug)=>{
    try {
        var ref;
        var ref1;
        const id = (ref1 = (ref = slug === null || slug === void 0 ? void 0 : slug.split("-")) === null || ref === void 0 ? void 0 : ref.pop()) !== null && ref1 !== void 0 ? ref1 : null;
        const numberID = parseInt(id !== null && id !== void 0 ? id : "0", 10);
        return numberID;
    } catch (e) {
        return null;
    }
};
const getCategoriesWithChildren = (slug, value)=>{
    var ref;
    var ref1;
    const categories = (ref1 = (ref = value === null || value === void 0 ? void 0 : value.find((e)=>e.slug === "voruflokkar")) === null || ref === void 0 ? void 0 : ref.children) !== null && ref1 !== void 0 ? ref1 : [];
    const newValue = categories.map((e)=>{
        if (e.slug === slug) {
            if (e.children) {
                return [
                    e,
                    ...e.children
                ];
            }
            return [
                e
            ];
        }
        var _children;
        return getCategoriesWithChildren(slug, (_children = e.children) !== null && _children !== void 0 ? _children : null);
    });
    if (newValue.length === 0) {
        return null;
    }
    return newValue.flat().filter(isNotNull).map((e)=>typeof e === "number" ? e : getCategoryID(e.slug)).filter(isNotNull);
};
const findCategory = (cat)=>(id)=>{
        return (cat || []).map((e)=>{
            if (e.parent === id) {
                return [
                    e.id,
                    ...findCategory(cat)(e.id)
                ].flat();
            }
            return [];
        }).flat();
    };
const MAX_LENGTH = 3;
const initialFetch = async ()=>{
    var ref;
    var ref1;
    return (ref1 = (ref = await restApi.categoriesList()) === null || ref === void 0 ? void 0 : ref.data) !== null && ref1 !== void 0 ? ref1 : [];
};
const categoriesData = {
    get: ()=>{
        var ___BYKO_CATEGORIES__, ___BYKO_CATEGORIES__1;
        return (0,_byko_types_utils__WEBPACK_IMPORTED_MODULE_1__/* .isSSR */ .yF)() ? (___BYKO_CATEGORIES__ = __webpack_require__.g.__BYKO_CATEGORIES__) !== null && ___BYKO_CATEGORIES__ !== void 0 ? ___BYKO_CATEGORIES__ : [] : (___BYKO_CATEGORIES__1 = window.__BYKO_CATEGORIES__) !== null && ___BYKO_CATEGORIES__1 !== void 0 ? ___BYKO_CATEGORIES__1 : [];
    }
};
const getCategoriesAndChildren = (id)=>{
    const data = categoriesData.get();
    const cats = findCategory(data)(id);
    return cats;
};
const getCategoriesAndBreadcrumb = (ids, product)=>{
    const data = categoriesData.get();
    const cats = data.filter((e)=>ids.includes(e.id));
    let searchIds = ids;
    const catArr = [];
    while(searchIds.length > 0){
        var _parent;
        const primaryId = cats.find((e)=>searchIds.includes(e.id) && !searchIds.includes((_parent = e.parent) !== null && _parent !== void 0 ? _parent : -1));
        if (primaryId) {
            searchIds = searchIds.filter((e)=>e !== primaryId.id);
            var _slug;
            catArr.push({
                title: primaryId.name,
                url: "/voruflokkar/".concat((_slug = primaryId.slug) !== null && _slug !== void 0 ? _slug : "")
            });
            if (catArr.length === MAX_LENGTH) {
                break;
            }
        } else {
            break;
        }
    }
    if (product) {
        return [
            {
                title: "Fors\xed\xf0a",
                url: "/"
            },
            ...catArr !== null && catArr !== void 0 ? catArr : [],
            {
                title: product.title,
                url: "/vara/".concat(product.slug)
            }
        ];
    }
    return [
        {
            title: "Fors\xed\xf0a",
            url: "/"
        },
        ...catArr !== null && catArr !== void 0 ? catArr : []
    ];
};


/***/ }),

/***/ 39452:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "t": function() { return /* binding */ datoQueries; }
});

// EXTERNAL MODULE: ../../.yarn/__virtual__/graphql-tag-virtual-0a79057ca9/0/cache/graphql-tag-npm-2.12.6-99a5a7f6de-b15162a3d6.zip/node_modules/graphql-tag/lib/index.js
var lib = __webpack_require__(86759);
// EXTERNAL MODULE: ../../.yarn/__virtual__/react-query-virtual-9ac5b1aaa1/0/cache/react-query-npm-3.39.1-7899b170b9-9273b7c2ad.zip/node_modules/react-query/es/index.js
var es = __webpack_require__(85166);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/graphql-request-virtual-c5c11a2d41/0/cache/graphql-request-npm-5.2.0-31dd65ab47-a8aa378163.zip/node_modules/graphql-request/build/esm/defaultJsonSerializer.js
const defaultJsonSerializer = {
    parse: JSON.parse,
    stringify: JSON.stringify,
};
//# sourceMappingURL=defaultJsonSerializer.js.map
// EXTERNAL MODULE: ../../.yarn/cache/extract-files-npm-9.0.0-6ee13e6aab-c31781d090.zip/node_modules/extract-files/public/isExtractableFile.js
var isExtractableFile = __webpack_require__(66458);
// EXTERNAL MODULE: ../../.yarn/cache/extract-files-npm-9.0.0-6ee13e6aab-c31781d090.zip/node_modules/extract-files/public/extractFiles.js
var extractFiles = __webpack_require__(98902);
// EXTERNAL MODULE: ../../.yarn/cache/form-data-npm-3.0.1-d080d436e0-b019e8d35c.zip/node_modules/form-data/lib/browser.js
var browser = __webpack_require__(88388);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/graphql-request-virtual-c5c11a2d41/0/cache/graphql-request-npm-5.2.0-31dd65ab47-a8aa378163.zip/node_modules/graphql-request/build/esm/createRequestBody.js



/**
 * Duck type if NodeJS stream
 * https://github.com/sindresorhus/is-stream/blob/3750505b0727f6df54324784fe369365ef78841e/index.js#L3
 */
const isExtractableFileEnhanced = (value) => isExtractableFile(value) ||
    (value !== null && typeof value === `object` && typeof value.pipe === `function`);
/**
 * Returns Multipart Form if body contains files
 * (https://github.com/jaydenseric/graphql-multipart-request-spec)
 * Otherwise returns JSON
 */
const createRequestBody = (query, variables, operationName, jsonSerializer = defaultJsonSerializer) => {
    const { clone, files } = extractFiles({ query, variables, operationName }, ``, isExtractableFileEnhanced);
    if (files.size === 0) {
        if (!Array.isArray(query)) {
            return jsonSerializer.stringify(clone);
        }
        if (typeof variables !== `undefined` && !Array.isArray(variables)) {
            throw new Error(`Cannot create request body with given variable type, array expected`);
        }
        // Batch support
        const payload = query.reduce((accu, currentQuery, index) => {
            accu.push({ query: currentQuery, variables: variables ? variables[index] : undefined });
            return accu;
        }, []);
        return jsonSerializer.stringify(payload);
    }
    const Form = typeof FormData === `undefined` ? browser : FormData;
    const form = new Form();
    form.append(`operations`, jsonSerializer.stringify(clone));
    const map = {};
    let i = 0;
    files.forEach((paths) => {
        map[++i] = paths;
    });
    form.append(`map`, jsonSerializer.stringify(map));
    i = 0;
    files.forEach((paths, file) => {
        form.append(`${++i}`, file);
    });
    return form;
};
/* harmony default export */ var esm_createRequestBody = (createRequestBody);
//# sourceMappingURL=createRequestBody.js.map
;// CONCATENATED MODULE: ../../.yarn/__virtual__/graphql-request-virtual-c5c11a2d41/0/cache/graphql-request-npm-5.2.0-31dd65ab47-a8aa378163.zip/node_modules/graphql-request/build/esm/helpers.js
const uppercase = (str) => str.toUpperCase();
/**
 * Convert Headers instance into regular object
 */
const HeadersInstanceToPlainObject = (headers) => {
    const o = {};
    headers.forEach((v, k) => {
        o[k] = v;
    });
    return o;
};
//# sourceMappingURL=helpers.js.map
;// CONCATENATED MODULE: ../../.yarn/__virtual__/graphql-request-virtual-c5c11a2d41/0/cache/graphql-request-npm-5.2.0-31dd65ab47-a8aa378163.zip/node_modules/graphql-request/build/esm/parseArgs.js
const parseRequestArgs = (documentOrOptions, variables, requestHeaders) => {
    return documentOrOptions.document
        ? documentOrOptions
        : {
            document: documentOrOptions,
            variables: variables,
            requestHeaders: requestHeaders,
            signal: undefined,
        };
};
const parseRawRequestArgs = (queryOrOptions, variables, requestHeaders) => {
    return queryOrOptions.query
        ? queryOrOptions
        : {
            query: queryOrOptions,
            variables: variables,
            requestHeaders: requestHeaders,
            signal: undefined,
        };
};
const parseBatchRequestArgs = (documentsOrOptions, requestHeaders) => {
    return documentsOrOptions.documents
        ? documentsOrOptions
        : {
            documents: documentsOrOptions,
            requestHeaders: requestHeaders,
            signal: undefined,
        };
};
const parseArgs_parseRequestExtendedArgs = (urlOrOptions, document, ...variablesAndRequestHeaders) => {
    const [variables, requestHeaders] = variablesAndRequestHeaders;
    return urlOrOptions.document
        ? urlOrOptions
        : {
            url: urlOrOptions,
            document: document,
            variables,
            requestHeaders,
            signal: undefined,
        };
};
const parseArgs_parseRawRequestExtendedArgs = (urlOrOptions, query, ...variablesAndRequestHeaders) => {
    const [variables, requestHeaders] = variablesAndRequestHeaders;
    return urlOrOptions.query
        ? urlOrOptions
        : {
            url: urlOrOptions,
            query: query,
            variables,
            requestHeaders,
            signal: undefined,
        };
};
//# sourceMappingURL=parseArgs.js.map
// EXTERNAL MODULE: ../../.yarn/cache/graphql-npm-16.5.0-348f68b718-a82a926d08.zip/node_modules/graphql/language/parser.mjs + 9 modules
var parser = __webpack_require__(85448);
// EXTERNAL MODULE: ../../.yarn/cache/graphql-npm-16.5.0-348f68b718-a82a926d08.zip/node_modules/graphql/language/printer.mjs + 1 modules
var printer = __webpack_require__(64006);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/graphql-request-virtual-c5c11a2d41/0/cache/graphql-request-npm-5.2.0-31dd65ab47-a8aa378163.zip/node_modules/graphql-request/build/esm/resolveRequestDocument.js

/**
 * helpers
 */
const extractOperationName = (document) => {
    let operationName = undefined;
    const operationDefinitions = document.definitions.filter((definition) => definition.kind === `OperationDefinition`);
    if (operationDefinitions.length === 1) {
        operationName = operationDefinitions[0]?.name?.value;
    }
    return operationName;
};
const resolveRequestDocument = (document) => {
    if (typeof document === `string`) {
        let operationName = undefined;
        try {
            const parsedDocument = (0,parser/* parse */.Qc)(document);
            operationName = extractOperationName(parsedDocument);
        }
        catch (err) {
            // Failed parsing the document, the operationName will be undefined
        }
        return { query: document, operationName };
    }
    const operationName = extractOperationName(document);
    return { query: (0,printer/* print */.S)(document), operationName };
};
//# sourceMappingURL=resolveRequestDocument.js.map
;// CONCATENATED MODULE: ../../.yarn/__virtual__/graphql-request-virtual-c5c11a2d41/0/cache/graphql-request-npm-5.2.0-31dd65ab47-a8aa378163.zip/node_modules/graphql-request/build/esm/types.js
class ClientError extends Error {
    constructor(response, request) {
        const message = `${ClientError.extractMessage(response)}: ${JSON.stringify({
            response,
            request,
        })}`;
        super(message);
        Object.setPrototypeOf(this, ClientError.prototype);
        this.response = response;
        this.request = request;
        // this is needed as Safari doesn't support .captureStackTrace
        if (typeof Error.captureStackTrace === `function`) {
            Error.captureStackTrace(this, ClientError);
        }
    }
    static extractMessage(response) {
        return response.errors?.[0]?.message ?? `GraphQL Error (Code: ${response.status})`;
    }
}
//# sourceMappingURL=types.js.map
// EXTERNAL MODULE: ../../.yarn/cache/cross-fetch-npm-3.1.5-e414995db9-f6b8c6ee3e.zip/node_modules/cross-fetch/dist/browser-ponyfill.js
var browser_ponyfill = __webpack_require__(22171);
var browser_ponyfill_namespaceObject = /*#__PURE__*/__webpack_require__.t(browser_ponyfill, 2);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/graphql-request-virtual-c5c11a2d41/0/cache/graphql-request-npm-5.2.0-31dd65ab47-a8aa378163.zip/node_modules/graphql-request/build/esm/graphql-ws.js


// import type WebSocket from 'ws'
const CONNECTION_INIT = `connection_init`;
const CONNECTION_ACK = `connection_ack`;
const PING = `ping`;
const PONG = `pong`;
const SUBSCRIBE = `subscribe`;
const NEXT = `next`;
const ERROR = `error`;
const COMPLETE = `complete`;
class GraphQLWebSocketMessage {
    get type() {
        return this._type;
    }
    get id() {
        return this._id;
    }
    get payload() {
        return this._payload;
    }
    constructor(type, payload, id) {
        this._type = type;
        this._payload = payload;
        this._id = id;
    }
    get text() {
        const result = { type: this.type };
        if (this.id != null && this.id != undefined)
            result.id = this.id;
        if (this.payload != null && this.payload != undefined)
            result.payload = this.payload;
        return JSON.stringify(result);
    }
    static parse(data, f) {
        const { type, payload, id } = JSON.parse(data);
        return new GraphQLWebSocketMessage(type, f(payload), id);
    }
}
class GraphQLWebSocketClient {
    constructor(socket, { onInit, onAcknowledged, onPing, onPong }) {
        this.socketState = { acknowledged: false, lastRequestId: 0, subscriptions: {} };
        this.socket = socket;
        socket.onopen = async (e) => {
            this.socketState.acknowledged = false;
            this.socketState.subscriptions = {};
            socket.send(ConnectionInit(onInit ? await onInit() : null).text);
        };
        socket.onclose = (e) => {
            this.socketState.acknowledged = false;
            this.socketState.subscriptions = {};
        };
        socket.onerror = (e) => {
            console.error(e);
        };
        socket.onmessage = (e) => {
            try {
                const message = parseMessage(e.data);
                switch (message.type) {
                    case CONNECTION_ACK: {
                        if (this.socketState.acknowledged) {
                            console.warn(`Duplicate CONNECTION_ACK message ignored`);
                        }
                        else {
                            this.socketState.acknowledged = true;
                            if (onAcknowledged)
                                onAcknowledged(message.payload);
                        }
                        return;
                    }
                    case PING: {
                        if (onPing)
                            onPing(message.payload).then((r) => socket.send(Pong(r).text));
                        else
                            socket.send(Pong(null).text);
                        return;
                    }
                    case PONG: {
                        if (onPong)
                            onPong(message.payload);
                        return;
                    }
                }
                if (!this.socketState.acknowledged) {
                    // Web-socket connection not acknowledged
                    return;
                }
                if (message.id === undefined || message.id === null || !this.socketState.subscriptions[message.id]) {
                    // No subscription identifer or subscription indentifier is not found
                    return;
                }
                const { query, variables, subscriber } = this.socketState.subscriptions[message.id];
                switch (message.type) {
                    case NEXT: {
                        if (!message.payload.errors && message.payload.data) {
                            subscriber.next && subscriber.next(message.payload.data);
                        }
                        if (message.payload.errors) {
                            subscriber.error &&
                                subscriber.error(new ClientError({ ...message.payload, status: 200 }, { query, variables }));
                        }
                        else {
                        }
                        return;
                    }
                    case ERROR: {
                        subscriber.error &&
                            subscriber.error(new ClientError({ errors: message.payload, status: 200 }, { query, variables }));
                        return;
                    }
                    case COMPLETE: {
                        subscriber.complete && subscriber.complete();
                        delete this.socketState.subscriptions[message.id];
                        return;
                    }
                }
            }
            catch (e) {
                // Unexpected errors while handling graphql-ws message
                console.error(e);
                socket.close(1006);
            }
            socket.close(4400, `Unknown graphql-ws message.`);
        };
    }
    makeSubscribe(query, operationName, subscriber, variables) {
        const subscriptionId = (this.socketState.lastRequestId++).toString();
        this.socketState.subscriptions[subscriptionId] = { query, variables, subscriber };
        this.socket.send(Subscribe(subscriptionId, { query, operationName, variables }).text);
        return () => {
            this.socket.send(Complete(subscriptionId).text);
            delete this.socketState.subscriptions[subscriptionId];
        };
    }
    rawRequest(query, variables) {
        return new Promise((resolve, reject) => {
            let result;
            this.rawSubscribe(query, {
                next: (data, extensions) => (result = { data, extensions }),
                error: reject,
                complete: () => resolve(result),
            }, variables);
        });
    }
    request(document, variables) {
        return new Promise((resolve, reject) => {
            let result;
            this.subscribe(document, {
                next: (data) => (result = data),
                error: reject,
                complete: () => resolve(result),
            }, variables);
        });
    }
    subscribe(document, subscriber, variables) {
        const { query, operationName } = resolveRequestDocument(document);
        return this.makeSubscribe(query, operationName, subscriber, variables);
    }
    rawSubscribe(query, subscriber, variables) {
        return this.makeSubscribe(query, undefined, subscriber, variables);
    }
    ping(payload) {
        this.socket.send(Ping(payload).text);
    }
    close() {
        this.socket.close(1000);
    }
}
GraphQLWebSocketClient.PROTOCOL = `graphql-transport-ws`;
// Helper functions
function parseMessage(data, f = (a) => a) {
    const m = GraphQLWebSocketMessage.parse(data, f);
    return m;
}
function ConnectionInit(payload) {
    return new GraphQLWebSocketMessage(CONNECTION_INIT, payload);
}
function Ping(payload) {
    return new GraphQLWebSocketMessage(PING, payload, undefined);
}
function Pong(payload) {
    return new GraphQLWebSocketMessage(PONG, payload, undefined);
}
function Subscribe(id, payload) {
    return new GraphQLWebSocketMessage(SUBSCRIBE, payload, id);
}
function Complete(id) {
    return new GraphQLWebSocketMessage(COMPLETE, undefined, id);
}
//# sourceMappingURL=graphql-ws.js.map
;// CONCATENATED MODULE: ../../.yarn/__virtual__/graphql-request-virtual-c5c11a2d41/0/cache/graphql-request-npm-5.2.0-31dd65ab47-a8aa378163.zip/node_modules/graphql-request/build/esm/index.js








/**
 * Convert the given headers configuration into a plain object.
 */
const resolveHeaders = (headers) => {
    let oHeaders = {};
    if (headers) {
        if ((typeof Headers !== `undefined` && headers instanceof Headers) ||
            (browser_ponyfill_namespaceObject && browser_ponyfill.Headers && headers instanceof browser_ponyfill.Headers)) {
            oHeaders = HeadersInstanceToPlainObject(headers);
        }
        else if (Array.isArray(headers)) {
            headers.forEach(([name, value]) => {
                if (name && value !== undefined) {
                    oHeaders[name] = value;
                }
            });
        }
        else {
            oHeaders = headers;
        }
    }
    return oHeaders;
};
/**
 * Clean a GraphQL document to send it via a GET query
 */
const cleanQuery = (str) => str.replace(/([\s,]|#[^\n\r]+)+/g, ` `).trim();
/**
 * Create query string for GraphQL request
 */
const buildRequestConfig = (params) => {
    if (!Array.isArray(params.query)) {
        const params_ = params;
        const search = [`query=${encodeURIComponent(cleanQuery(params_.query))}`];
        if (params.variables) {
            search.push(`variables=${encodeURIComponent(params_.jsonSerializer.stringify(params_.variables))}`);
        }
        if (params_.operationName) {
            search.push(`operationName=${encodeURIComponent(params_.operationName)}`);
        }
        return search.join(`&`);
    }
    if (typeof params.variables !== `undefined` && !Array.isArray(params.variables)) {
        throw new Error(`Cannot create query with given variable type, array expected`);
    }
    // Batch support
    const params_ = params;
    const payload = params.query.reduce((acc, currentQuery, index) => {
        acc.push({
            query: cleanQuery(currentQuery),
            variables: params_.variables ? params_.jsonSerializer.stringify(params_.variables[index]) : undefined,
        });
        return acc;
    }, []);
    return `query=${encodeURIComponent(params_.jsonSerializer.stringify(payload))}`;
};
const createHttpMethodFetcher = (method) => async (params) => {
    const { url, query, variables, operationName, fetch, fetchOptions, middleware } = params;
    const headers = { ...params.headers };
    let queryParams = ``;
    let body = undefined;
    if (method === `POST`) {
        body = esm_createRequestBody(query, variables, operationName, fetchOptions.jsonSerializer);
        if (typeof body === `string`) {
            // @ts-expect-error todo
            headers[`Content-Type`] = `application/json`;
        }
    }
    else {
        // @ts-expect-error todo needs ADT for TS to understand the different states
        queryParams = buildRequestConfig({
            query,
            variables,
            operationName,
            jsonSerializer: fetchOptions.jsonSerializer ?? defaultJsonSerializer,
        });
    }
    const init = {
        method,
        headers,
        body,
        ...fetchOptions,
    };
    let urlResolved = url;
    let initResolved = init;
    if (middleware) {
        const result = await Promise.resolve(middleware({ ...init, url, operationName, variables }));
        const { url: urlNew, ...initNew } = result;
        urlResolved = urlNew;
        initResolved = initNew;
    }
    if (queryParams) {
        urlResolved = `${urlResolved}?${queryParams}`;
    }
    return await fetch(urlResolved, initResolved);
};
/**
 * GraphQL Client.
 */
class GraphQLClient {
    constructor(url, requestConfig = {}) {
        this.url = url;
        this.requestConfig = requestConfig;
        /**
         * Send a GraphQL query to the server.
         */
        this.rawRequest = async (...args) => {
            const [queryOrOptions, variables, requestHeaders] = args;
            const rawRequestOptions = parseRawRequestArgs(queryOrOptions, variables, requestHeaders);
            const { headers, fetch = browser_ponyfill, method = `POST`, requestMiddleware, responseMiddleware, ...fetchOptions } = this.requestConfig;
            const { url } = this;
            if (rawRequestOptions.signal !== undefined) {
                fetchOptions.signal = rawRequestOptions.signal;
            }
            const { operationName } = resolveRequestDocument(rawRequestOptions.query);
            return makeRequest({
                url,
                query: rawRequestOptions.query,
                variables: rawRequestOptions.variables,
                headers: {
                    ...resolveHeaders(callOrIdentity(headers)),
                    ...resolveHeaders(rawRequestOptions.requestHeaders),
                },
                operationName,
                fetch,
                method,
                fetchOptions,
                middleware: requestMiddleware,
            })
                .then((response) => {
                if (responseMiddleware) {
                    responseMiddleware(response);
                }
                return response;
            })
                .catch((error) => {
                if (responseMiddleware) {
                    responseMiddleware(error);
                }
                throw error;
            });
        };
    }
    async request(documentOrOptions, ...variablesAndRequestHeaders) {
        const [variables, requestHeaders] = variablesAndRequestHeaders;
        const requestOptions = parseRequestArgs(documentOrOptions, variables, requestHeaders);
        const { headers, fetch = browser_ponyfill, method = `POST`, requestMiddleware, responseMiddleware, ...fetchOptions } = this.requestConfig;
        const { url } = this;
        if (requestOptions.signal !== undefined) {
            fetchOptions.signal = requestOptions.signal;
        }
        const { query, operationName } = resolveRequestDocument(requestOptions.document);
        return makeRequest({
            url,
            query,
            variables: requestOptions.variables,
            headers: {
                ...resolveHeaders(callOrIdentity(headers)),
                ...resolveHeaders(requestOptions.requestHeaders),
            },
            operationName,
            fetch,
            method,
            fetchOptions,
            middleware: requestMiddleware,
        })
            .then((response) => {
            if (responseMiddleware) {
                responseMiddleware(response);
            }
            return response.data;
        })
            .catch((error) => {
            if (responseMiddleware) {
                responseMiddleware(error);
            }
            throw error;
        });
    }
    // prettier-ignore
    batchRequests(documentsOrOptions, requestHeaders) {
        const batchRequestOptions = parseBatchRequestArgs(documentsOrOptions, requestHeaders);
        const { headers, ...fetchOptions } = this.requestConfig;
        if (batchRequestOptions.signal !== undefined) {
            fetchOptions.signal = batchRequestOptions.signal;
        }
        const queries = batchRequestOptions.documents.map(({ document }) => resolveRequestDocument(document).query);
        const variables = batchRequestOptions.documents.map(({ variables }) => variables);
        return makeRequest({
            url: this.url,
            query: queries,
            // @ts-expect-error TODO reconcile batch variables into system.
            variables,
            headers: {
                ...resolveHeaders(callOrIdentity(headers)),
                ...resolveHeaders(batchRequestOptions.requestHeaders),
            },
            operationName: undefined,
            fetch: this.requestConfig.fetch ?? browser_ponyfill,
            method: this.requestConfig.method || `POST`,
            fetchOptions,
            middleware: this.requestConfig.requestMiddleware,
        })
            .then((response) => {
            if (this.requestConfig.responseMiddleware) {
                this.requestConfig.responseMiddleware(response);
            }
            return response.data;
        })
            .catch((error) => {
            if (this.requestConfig.responseMiddleware) {
                this.requestConfig.responseMiddleware(error);
            }
            throw error;
        });
    }
    setHeaders(headers) {
        this.requestConfig.headers = headers;
        return this;
    }
    /**
     * Attach a header to the client. All subsequent requests will have this header.
     */
    setHeader(key, value) {
        const { headers } = this.requestConfig;
        if (headers) {
            // todo what if headers is in nested array form... ?
            //@ts-ignore
            headers[key] = value;
        }
        else {
            this.requestConfig.headers = { [key]: value };
        }
        return this;
    }
    /**
     * Change the client endpoint. All subsequent requests will send to this endpoint.
     */
    setEndpoint(value) {
        this.url = value;
        return this;
    }
}
const makeRequest = async (params) => {
    const { query, variables, fetchOptions } = params;
    const fetcher = createHttpMethodFetcher(uppercase(params.method ?? `post`));
    const isBatchingQuery = Array.isArray(params.query);
    const response = await fetcher(params);
    const result = await getResult(response, fetchOptions.jsonSerializer ?? defaultJsonSerializer);
    const successfullyReceivedData = Array.isArray(result)
        ? !result.some(({ data }) => !data)
        : Boolean(result.data);
    const successfullyPassedErrorPolicy = Array.isArray(result) ||
        !result.errors ||
        (Array.isArray(result.errors) && !result.errors.length) ||
        fetchOptions.errorPolicy === `all` ||
        fetchOptions.errorPolicy === `ignore`;
    if (response.ok && successfullyPassedErrorPolicy && successfullyReceivedData) {
        // @ts-expect-error TODO fixme
        const { errors, ...rest } = Array.isArray(result) ? result : result;
        const data = fetchOptions.errorPolicy === `ignore` ? rest : result;
        const dataEnvelope = isBatchingQuery ? { data } : data;
        // @ts-expect-error TODO
        return {
            ...dataEnvelope,
            headers: response.headers,
            status: response.status,
        };
    }
    else {
        const errorResult = typeof result === `string`
            ? {
                error: result,
            }
            : result;
        throw new ClientError(
        // @ts-expect-error TODO
        { ...errorResult, status: response.status, headers: response.headers }, { query, variables });
    }
};
/**
 * Send a GraphQL Query to the GraphQL server for execution.
 */
const rawRequest = async (...args) => {
    const [urlOrOptions, query, ...variablesAndRequestHeaders] = args;
    const requestOptions = parseRawRequestExtendedArgs(urlOrOptions, query, ...variablesAndRequestHeaders);
    const client = new GraphQLClient(requestOptions.url);
    return client.rawRequest({
        ...requestOptions,
    });
};
async function request(urlOrOptions, 
// @ts-ignore
document, ...variablesAndRequestHeaders) {
    // @ts-ignore
    const requestOptions = parseRequestExtendedArgs(urlOrOptions, document, ...variablesAndRequestHeaders);
    const client = new GraphQLClient(requestOptions.url);
    return client.request({
        ...requestOptions,
    });
}
/**
 * Send a batch of GraphQL Document to the GraphQL server for execution.
 *
 * @example
 *
 * ```ts
 * // You can pass a raw string
 *
 * await batchRequests('https://foo.bar/graphql', [
 * {
 *  query: `
 *   {
 *     query {
 *       users
 *     }
 *   }`
 * },
 * {
 *   query: `
 *   {
 *     query {
 *       users
 *     }
 *   }`
 * }])
 *
 * // You can also pass a GraphQL DocumentNode as query. Convenient if you
 * // are using graphql-tag package.
 *
 * import gql from 'graphql-tag'
 *
 * await batchRequests('https://foo.bar/graphql', [{ query: gql`...` }])
 * ```
 */
const batchRequests = async (...args) => {
    const params = parseBatchRequestsArgsExtended(args);
    const client = new GraphQLClient(params.url);
    return client.batchRequests(params);
};
const parseBatchRequestsArgsExtended = (args) => {
    if (args.length === 1) {
        return args[0];
    }
    else {
        return {
            url: args[0],
            documents: args[1],
            requestHeaders: args[2],
            signal: undefined,
        };
    }
};
/* harmony default export */ var esm = ((/* unused pure expression or super */ null && (request)));
const getResult = async (response, jsonSerializer) => {
    let contentType;
    response.headers.forEach((value, key) => {
        if (key.toLowerCase() === `content-type`) {
            contentType = value;
        }
    });
    if (contentType &&
        (contentType.toLowerCase().startsWith(`application/json`) ||
            contentType.toLowerCase().startsWith(`application/graphql+json`) ||
            contentType.toLowerCase().startsWith(`application/graphql-response+json`))) {
        return jsonSerializer.parse(await response.text());
    }
    else {
        return response.text();
    }
};
const callOrIdentity = (value) => {
    return typeof value === `function` ? value() : value;
};
/**
 * Convenience passthrough template tag to get the benefits of tooling for the gql template tag. This does not actually parse the input into a GraphQL DocumentNode like graphql-tag package does. It just returns the string with any variables given interpolated. Can save you a bit of performance and having to install another package.
 *
 * @example
 *
 * import { gql } from 'graphql-request'
 *
 * await request('https://foo.bar/graphql', gql`...`)
 *
 * @remarks
 *
 * Several tools in the Node GraphQL ecosystem are hardcoded to specially treat any template tag named "gql". For example see this prettier issue: https://github.com/prettier/prettier/issues/4360. Using this template tag has no runtime effect beyond variable interpolation.
 */
const gql = (chunks, ...variables) => {
    return chunks.reduce((accumulator, chunk, index) => `${accumulator}${chunk}${index in variables ? variables[index] : ``}`, ``);
};


//# sourceMappingURL=index.js.map
// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-lib-utils-virtual-08ae943915/1/packages/lib-utils/src/index.ts + 19 modules
var src = __webpack_require__(65582);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-dato-virtual-5a00219d6f/1/packages/lib-dato/src/get-config.ts

function getConfig() {
    const values = {
        DATO_GRAPHQL_URL: (0,src/* getBykoConfig */.Hp)("DATO_GRAPHQL_URL"),
        DATO_TOKEN_CMS: (0,src/* getBykoConfig */.Hp)("DATO_TOKEN_CMS")
    };
    return values;
}

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-dato-virtual-5a00219d6f/1/packages/lib-dato/src/dato-graphql-client.ts
/* provided dependency */ var process = __webpack_require__(97441);


const { DATO_GRAPHQL_URL , DATO_TOKEN_CMS  } = getConfig();
if (DATO_TOKEN_CMS === "") {
    console.error("missing DATO_TOKEN_CMS");
}
if (DATO_GRAPHQL_URL === "") {
    console.error("missing CMS_API_URL");
}
var ref;
const graphQLClient = new GraphQLClient(DATO_GRAPHQL_URL !== null && DATO_GRAPHQL_URL !== void 0 ? DATO_GRAPHQL_URL : "https://graphql.datocms.com", {
    headers: {
        Authorization: "Bearer ".concat(DATO_TOKEN_CMS),
        "X-Environment": (ref = process.env["DATO_ENVIRONMENT"]) !== null && ref !== void 0 ? ref : "main"
    }
});

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-dato-virtual-5a00219d6f/1/packages/lib-dato/src/content-queries/fragments.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    const data = _taggedTemplateLiteral([
        "\n  fragment JobTitleParts on JobTitleRecord {\n    __typename\n    id\n    name\n  }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _taggedTemplateLiteral([
        "\n  fragment DepartmentParts on DepartmentRecord {\n    __typename\n    id\n    name\n  }\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = _taggedTemplateLiteral([
        "\n  fragment EmployeeParts on EmployeeRecord {\n    __typename\n    id\n    name\n    email\n    mobilePhone\n    workPhone\n    jobTitle {\n      ...JobTitleParts\n    }\n    department {\n      ...DepartmentParts\n    }\n    subDepartment {\n      ...SubDepartmentParts\n    }\n  }\n"
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = _taggedTemplateLiteral([
        "\n  fragment SubDepartmentParts on SubDepartmentRecord {\n    __typename\n    id\n    name\n  }\n"
    ]);
    _templateObject3 = function() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = _taggedTemplateLiteral([
        "\n  fragment ImageFileParts on FileField {\n    __typename\n    id\n    jpeg: url(imgixParams: { fm: jpg, q: 100 })\n    alt\n    blurhash\n    title\n    width\n    height\n    focalPoint {\n      x\n      y\n    }\n  }\n"
    ]);
    _templateObject4 = function() {
        return data;
    };
    return data;
}
function _templateObject5() {
    const data = _taggedTemplateLiteral([
        "\n  fragment ImageBlockParts on ImageblockRecord {\n    __typename\n    id\n    content {\n      ...ImageFileParts\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject5 = function() {
        return data;
    };
    return data;
}
function _templateObject6() {
    const data = _taggedTemplateLiteral([
        "\n  fragment ImageBlockPartsWithTitle on ImageblockwithtitleRecord {\n    __typename\n    id\n    content {\n      ...ImageFileParts\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject6 = function() {
        return data;
    };
    return data;
}
function _templateObject7() {
    const data = _taggedTemplateLiteral([
        "\n  fragment ActionButtonParts on ImageactionbuttonRecord {\n    __typename\n    id\n    url\n    content {\n      ...ImageFileParts\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject7 = function() {
        return data;
    };
    return data;
}
function _templateObject8() {
    const data = _taggedTemplateLiteral([
        "\n  fragment TextblockModelContentFieldParts on TextblockModelContentField {\n    blocks\n    links\n    value\n  }\n"
    ]);
    _templateObject8 = function() {
        return data;
    };
    return data;
}
function _templateObject9() {
    const data = _taggedTemplateLiteral([
        "\n  fragment ListitemblockModelTextFieldParts on ListitemblockModelTextField {\n    blocks\n    links\n    value\n  }\n"
    ]);
    _templateObject9 = function() {
        return data;
    };
    return data;
}
function _templateObject10() {
    const data = _taggedTemplateLiteral([
        "\n  fragment ActionButtonRecordParts on ActionButtonRecord {\n    __typename\n    id\n    link\n    text\n  }\n"
    ]);
    _templateObject10 = function() {
        return data;
    };
    return data;
}
function _templateObject11() {
    const data = _taggedTemplateLiteral([
        "\n  fragment TextBlockParts on TextblockRecord {\n    icon\n    title\n    introtext\n    headingunderlinecolor\n    content {\n      ...TextblockModelContentFieldParts\n    }\n    actionbutton {\n      ...ActionButtonRecordParts\n    }\n  }\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject11 = function() {
        return data;
    };
    return data;
}
function _templateObject12() {
    const data = _taggedTemplateLiteral([
        "\n  fragment DefaultHeaderParts on TopbannerdefaultblockRecord {\n    __typename\n    id\n    mirrorxaxis\n    mirroryaxis\n    images {\n      ...ImageFileParts\n    }\n    content {\n      ...TextBlockParts\n    }\n  }\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject12 = function() {
        return data;
    };
    return data;
}
function _templateObject13() {
    const data = _taggedTemplateLiteral([
        "\n  fragment FrontPageHeaderParts on TopBannerFrontPageRecord {\n    __typename\n    id\n    title\n    image {\n      ...ImageFileParts\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject13 = function() {
        return data;
    };
    return data;
}
function _templateObject14() {
    const data = _taggedTemplateLiteral([
        "\n  fragment SeoFieldParts on SeoField {\n    __typename\n    title\n    image {\n      ...ImageFileParts\n    }\n    description\n  }\n  ",
        "\n"
    ]);
    _templateObject14 = function() {
        return data;
    };
    return data;
}
function _templateObject15() {
    const data = _taggedTemplateLiteral([
        "\n  fragment AuthorblockRecorddParts on AuthorblockRecord {\n    __typename\n    id\n    author\n    date\n  }\n"
    ]);
    _templateObject15 = function() {
        return data;
    };
    return data;
}
function _templateObject16() {
    const data = _taggedTemplateLiteral([
        "\n  fragment IconbBlockRecordParts on IconblockRecord {\n    __typename\n    id\n    icon\n  }\n"
    ]);
    _templateObject16 = function() {
        return data;
    };
    return data;
}
function _templateObject17() {
    const data = _taggedTemplateLiteral([
        "\n  fragment TopbannerdefaultblockRecordParts on TopbannerdefaultblockRecord {\n    __typename\n    id\n    id\n    images {\n      ...ImageFileParts\n    }\n    content {\n      ...TextBlockParts\n    }\n    mirrorxaxis\n    mirroryaxis\n  }\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject17 = function() {
        return data;
    };
    return data;
}
function _templateObject18() {
    const data = _taggedTemplateLiteral([
        "\n  fragment ListitemblockRecordParts on ListitemblockRecord {\n    __typename\n    id\n    icon\n    mirrorx\n    text {\n      ...ListitemblockModelTextFieldParts\n    }\n    title\n  }\n  ",
        "\n"
    ]);
    _templateObject18 = function() {
        return data;
    };
    return data;
}
function _templateObject19() {
    const data = _taggedTemplateLiteral([
        "\n  fragment ListcontainerblockRecordParts on ListcontainerblockRecord {\n    __typename\n    id\n    content {\n      ...ListitemblockRecordParts\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject19 = function() {
        return data;
    };
    return data;
}
function _templateObject20() {
    const data = _taggedTemplateLiteral([
        "\n  fragment BulletContainerblockParts on BulletcontainerblockRecord {\n    id\n    __typename\n\n    intro {\n      ...TextBlockParts\n    }\n    title\n    content {\n      text\n      id\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject20 = function() {
        return data;
    };
    return data;
}
function _templateObject21() {
    const data = _taggedTemplateLiteral([
        "\n  fragment Contentsection1RecordParts on Contentsection1Record {\n    __typename\n    id\n    image {\n      ...ImageBlockParts\n    }\n    mirrory\n    text {\n      ...TextBlockParts\n    }\n  }\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject21 = function() {
        return data;
    };
    return data;
}
function _templateObject22() {
    const data = _taggedTemplateLiteral([
        "\n  fragment Contentsection2RecordParts on Contentsection2Record {\n    __typename\n    id\n    images {\n      ...ImageBlockParts\n    }\n    primaryimage {\n      ...ImageBlockParts\n    }\n    text {\n      ...TextBlockParts\n    }\n  }\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject22 = function() {
        return data;
    };
    return data;
}
function _templateObject23() {
    const data = _taggedTemplateLiteral([
        "\n  fragment Contentsection3RecordParts on Contentsection3Record {\n    __typename\n    id\n    mirrory\n    images {\n      ...ImageBlockParts\n    }\n\n    text {\n      ...TextBlockParts\n    }\n  }\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject23 = function() {
        return data;
    };
    return data;
}
function _templateObject24() {
    const data = _taggedTemplateLiteral([
        "\n  fragment Contentsection4RecordParts on Contentsection4Record {\n    __typename\n    id\n    mirrory\n    images {\n      ... on ImageactionbuttonRecord {\n        ...ActionButtonParts\n      }\n      ... on ImageblockwithtitleRecord {\n        ...ImageBlockPartsWithTitle\n      }\n    }\n    primaryimages {\n      ...ImageBlockParts\n    }\n    bullettext {\n      ...BulletContainerblockParts\n    }\n  }\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject24 = function() {
        return data;
    };
    return data;
}
function _templateObject25() {
    const data = _taggedTemplateLiteral([
        "\n  fragment Contentsection5RecordParts on Contentsection5Record {\n    __typename\n    id\n    mirrory\n    primaryimage {\n      ...ImageBlockParts\n    }\n    content {\n      ...ListcontainerblockRecordParts\n    }\n    text {\n      ...TextBlockParts\n    }\n  }\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject25 = function() {
        return data;
    };
    return data;
}
function _templateObject26() {
    const data = _taggedTemplateLiteral([
        "\n  fragment Contentsection6RecordParts on Contentsection6Record {\n    __typename\n    id\n    mirrorx\n    image {\n      ...ImageBlockParts\n    }\n    text {\n      ...TextBlockParts\n    }\n  }\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject26 = function() {
        return data;
    };
    return data;
}
function _templateObject27() {
    const data = _taggedTemplateLiteral([
        "\n  fragment Contentsection7RecordParts on Contentsection7Record {\n    __typename\n    id\n    primaryimages {\n      ...ImageBlockParts\n    }\n    images {\n      ...ActionButtonParts\n    }\n    text {\n      ...TextBlockParts\n    }\n    mirrory\n  }\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject27 = function() {
        return data;
    };
    return data;
}
function _templateObject28() {
    const data = _taggedTemplateLiteral([
        "\n  fragment Contentsection8RecordParts on Contentsection8Record {\n    __typename\n    id\n    mirrory\n    images {\n      ...ImageBlockPartsWithTitle\n    }\n    primaryimages {\n      ...ImageBlockParts\n    }\n    text {\n      ...TextBlockParts\n    }\n  }\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject28 = function() {
        return data;
    };
    return data;
}
function _templateObject29() {
    const data = _taggedTemplateLiteral([
        "\n  fragment Contentsection9RecordParts on Contentsection9Record {\n    __typename\n    id\n    primaryimages {\n      ...ImageBlockParts\n    }\n    images {\n      ...ActionButtonParts\n    }\n    text {\n      ...TextBlockParts\n    }\n    mirrory\n  }\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject29 = function() {
        return data;
    };
    return data;
}
function _templateObject30() {
    const data = _taggedTemplateLiteral([
        "\n  fragment ImageTilesBlockRecordParts on ImageTilesBlockRecord {\n    __typename\n    id\n    image {\n      ...ImageBlockParts\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject30 = function() {
        return data;
    };
    return data;
}
function _templateObject31() {
    const data = _taggedTemplateLiteral([
        "\n  fragment PhotoGalleryBlockRecordParts on PhotoGalleryBlockRecord {\n    __typename\n    id\n    image {\n      ...ImageBlockParts\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject31 = function() {
        return data;
    };
    return data;
}
function _templateObject32() {
    const data = _taggedTemplateLiteral([
        "\n  fragment ContentsectionFilesParts on FiledownloadsectionRecord {\n    __typename\n    id\n    fileDownloadTab {\n      __typename\n      id\n      title\n      icon {\n        ...IconbBlockRecordParts\n      }\n      files {\n        __typename\n        id\n        filename\n        mimeType\n        title\n        url\n      }\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject32 = function() {
        return data;
    };
    return data;
}
function _templateObject33() {
    const data = _taggedTemplateLiteral([
        "\n  fragment ContentsectionProductSliderParts on ProductslidersectionRecord {\n    __typename\n    id\n    paragraph {\n      blocks\n      links\n      value\n    }\n    heading\n    headingUnderlineColor\n    products {\n      id\n      saleorProducts {\n        saleorProduct\n        id\n      }\n    }\n  }\n"
    ]);
    _templateObject33 = function() {
        return data;
    };
    return data;
}
function _templateObject34() {
    const data = _taggedTemplateLiteral([
        "\n  fragment ProductParts on ProductPageRecord {\n    __typename\n    id\n    slug\n    content {\n      ... on Contentsection1Record {\n        ...Contentsection1RecordParts\n      }\n      ... on Contentsection2Record {\n        ...Contentsection2RecordParts\n      }\n      ... on Contentsection3Record {\n        ...Contentsection3RecordParts\n      }\n      ... on Contentsection4Record {\n        ...Contentsection4RecordParts\n      }\n      ... on Contentsection5Record {\n        ...Contentsection5RecordParts\n      }\n      ... on Contentsection6Record {\n        ...Contentsection6RecordParts\n      }\n      ... on Contentsection7Record {\n        ...Contentsection7RecordParts\n      }\n      ... on Contentsection8Record {\n        ...Contentsection8RecordParts\n      }\n      ... on Contentsection9Record {\n        ...Contentsection9RecordParts\n      }\n      ... on FiledownloadsectionRecord {\n        ...ContentsectionFilesParts\n      }\n      ... on ProductslidersectionRecord {\n        ...ContentsectionProductSliderParts\n      }\n      ... on ImageTilesBlockRecord {\n        ...ImageTilesBlockRecordParts\n      }\n      ... on PhotoGalleryBlockRecord {\n        ...PhotoGalleryBlockRecordParts\n      }\n      ... on SimplybookmeBlockRecord {\n        __typename\n        id\n      }\n    }\n  }\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject34 = function() {
        return data;
    };
    return data;
}
function _templateObject35() {
    const data = _taggedTemplateLiteral([
        "\n  fragment DatoPageParts on PageRecord {\n    __typename\n    id\n    parentpage\n    parentPage {\n      id\n    }\n    title\n    slug\n    top {\n      ... on TopbannerdefaultblockRecord {\n        ...TopbannerdefaultblockRecordParts\n      }\n    }\n    tags {\n      ...IconbBlockRecordParts\n    }\n    seo {\n      ...SeoFieldParts\n    }\n    author {\n      ...AuthorblockRecorddParts\n    }\n    content {\n      ... on Contentsection1Record {\n        ...Contentsection1RecordParts\n      }\n      ... on Contentsection2Record {\n        ...Contentsection2RecordParts\n      }\n      ... on Contentsection3Record {\n        ...Contentsection3RecordParts\n      }\n      ... on Contentsection4Record {\n        ...Contentsection4RecordParts\n      }\n      ... on Contentsection5Record {\n        ...Contentsection5RecordParts\n      }\n      ... on Contentsection6Record {\n        ...Contentsection6RecordParts\n      }\n      ... on Contentsection7Record {\n        ...Contentsection7RecordParts\n      }\n      ... on Contentsection8Record {\n        ...Contentsection8RecordParts\n      }\n      ... on Contentsection9Record {\n        ...Contentsection9RecordParts\n      }\n      ... on FiledownloadsectionRecord {\n        ...ContentsectionFilesParts\n      }\n      ... on ProductslidersectionRecord {\n        ...ContentsectionProductSliderParts\n      }\n      ... on ImageTilesBlockRecord {\n        ...ImageTilesBlockRecordParts\n      }\n      ... on PhotoGalleryBlockRecord {\n        ...PhotoGalleryBlockRecordParts\n      }\n      ... on SimplybookmeBlockRecord {\n        __typename\n        id\n      }\n    }\n  }\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject35 = function() {
        return data;
    };
    return data;
}
function _templateObject36() {
    const data = _taggedTemplateLiteral([
        "\n  fragment DatoFrontpageParts on FrontpageRecord {\n    __typename\n    id\n    top {\n      ...FrontPageHeaderParts\n    }\n    seo {\n      ...SeoFieldParts\n    }\n    content {\n      ... on Contentsection1Record {\n        ...Contentsection1RecordParts\n      }\n      ... on Contentsection2Record {\n        ...Contentsection2RecordParts\n      }\n      ... on Contentsection3Record {\n        ...Contentsection3RecordParts\n      }\n      ... on Contentsection4Record {\n        ...Contentsection4RecordParts\n      }\n      ... on Contentsection5Record {\n        ...Contentsection5RecordParts\n      }\n      ... on Contentsection6Record {\n        ...Contentsection6RecordParts\n      }\n      ... on Contentsection7Record {\n        ...Contentsection7RecordParts\n      }\n      ... on Contentsection8Record {\n        ...Contentsection8RecordParts\n      }\n      ... on Contentsection9Record {\n        ...Contentsection9RecordParts\n      }\n      ... on FiledownloadsectionRecord {\n        ...ContentsectionFilesParts\n      }\n      ... on ProductslidersectionRecord {\n        ...ContentsectionProductSliderParts\n      }\n      ... on ImageTilesBlockRecord {\n        ...ImageTilesBlockRecordParts\n      }\n      ... on PhotoGalleryBlockRecord {\n        ...PhotoGalleryBlockRecordParts\n      }\n      ... on SimplybookmeBlockRecord {\n        __typename\n        id\n      }\n    }\n    published\n  }\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject36 = function() {
        return data;
    };
    return data;
}
function _templateObject37() {
    const data = _taggedTemplateLiteral([
        "\n  fragment StringRecordFragment on StringRecord {\n    key\n    string {\n      alertType\n      message\n    }\n  }\n"
    ]);
    _templateObject37 = function() {
        return data;
    };
    return data;
}
function _templateObject38() {
    const data = _taggedTemplateLiteral([
        "\n  fragment OpeningHourFragment on OpeningHourRecord {\n    __typename\n    id\n    location {\n      id\n      locationAddress\n      locationName\n      locationType\n      openingHours {\n        id\n        hours {\n          id\n          dateName\n          dateOpeningHours\n        }\n      }\n    }\n  }\n"
    ]);
    _templateObject38 = function() {
        return data;
    };
    return data;
}

const JobTitleParts = (0,lib/* default */.ZP)(_templateObject());
const DepartmentParts = (0,lib/* default */.ZP)(_templateObject1());
const EmployeeParts = (0,lib/* default */.ZP)(_templateObject2());
const SubDepartmentParts = (0,lib/* default */.ZP)(_templateObject3());
const ImageFileParts = (0,lib/* default */.ZP)(_templateObject4());
const ImageBlockParts = (0,lib/* default */.ZP)(_templateObject5(), ImageFileParts);
const ImageBlockPartsWithTitle = (0,lib/* default */.ZP)(_templateObject6(), ImageFileParts);
const ActionButtonParts = (0,lib/* default */.ZP)(_templateObject7(), ImageFileParts);
const TextblockModelContentFieldParts = (0,lib/* default */.ZP)(_templateObject8());
const ListitemblockModelTextFieldParts = (0,lib/* default */.ZP)(_templateObject9());
const ActionButtonRecordParts = (0,lib/* default */.ZP)(_templateObject10());
const TextBlockParts = (0,lib/* default */.ZP)(_templateObject11(), TextblockModelContentFieldParts, ActionButtonRecordParts);
const DefaultHeaderParts = (0,lib/* default */.ZP)(_templateObject12(), ImageFileParts, TextBlockParts);
const FrontPageHeaderParts = (0,lib/* default */.ZP)(_templateObject13(), ImageFileParts);
const SeoFieldParts = (0,lib/* default */.ZP)(_templateObject14(), ImageFileParts);
const AuthorblockRecorddParts = (0,lib/* default */.ZP)(_templateObject15());
const IconbBlockRecordParts = (0,lib/* default */.ZP)(_templateObject16());
const TopbannerdefaultblockRecordParts = (0,lib/* default */.ZP)(_templateObject17(), ImageFileParts, TextBlockParts);
const ListitemblockRecordParts = (0,lib/* default */.ZP)(_templateObject18(), ListitemblockModelTextFieldParts);
const ListcontainerblockRecordParts = (0,lib/* default */.ZP)(_templateObject19(), ListitemblockRecordParts);
const BulletContainerblockParts = (0,lib/* default */.ZP)(_templateObject20(), TextBlockParts);
const Contentsection1RecordParts = (0,lib/* default */.ZP)(_templateObject21(), ImageBlockParts, TextBlockParts);
const Contentsection2RecordParts = (0,lib/* default */.ZP)(_templateObject22(), ImageBlockParts, TextBlockParts, ImageBlockParts);
const Contentsection3RecordParts = (0,lib/* default */.ZP)(_templateObject23(), ImageBlockParts, TextBlockParts);
const Contentsection4RecordParts = (0,lib/* default */.ZP)(_templateObject24(), ActionButtonParts, ImageBlockPartsWithTitle, ImageBlockParts, BulletContainerblockParts);
const Contentsection5RecordParts = (0,lib/* default */.ZP)(_templateObject25(), ImageBlockParts, ListcontainerblockRecordParts, TextBlockParts);
const Contentsection6RecordParts = (0,lib/* default */.ZP)(_templateObject26(), ImageBlockParts, TextBlockParts);
const Contentsection7RecordParts = (0,lib/* default */.ZP)(_templateObject27(), ImageBlockParts, ActionButtonParts, TextBlockParts);
const Contentsection8RecordParts = (0,lib/* default */.ZP)(_templateObject28(), ImageBlockPartsWithTitle, ImageBlockParts, TextBlockParts);
const Contentsection9RecordParts = (0,lib/* default */.ZP)(_templateObject29(), ImageBlockParts, ActionButtonParts, TextBlockParts);
const ImageTilesBlockRecordParts = (0,lib/* default */.ZP)(_templateObject30(), ImageBlockParts);
const PhotoGalleryBlockRecordParts = (0,lib/* default */.ZP)(_templateObject31(), ImageBlockParts);
const ContentsectionFilesParts = (0,lib/* default */.ZP)(_templateObject32(), IconbBlockRecordParts);
const ContentsectionProductSliderParts = (0,lib/* default */.ZP)(_templateObject33());
const ProductParts = (0,lib/* default */.ZP)(_templateObject34(), Contentsection1RecordParts, Contentsection2RecordParts, Contentsection3RecordParts, Contentsection4RecordParts, Contentsection5RecordParts, Contentsection6RecordParts, Contentsection7RecordParts, Contentsection8RecordParts, Contentsection9RecordParts, ContentsectionFilesParts, ContentsectionProductSliderParts, ImageTilesBlockRecordParts, PhotoGalleryBlockRecordParts);
const DatoPageParts = (0,lib/* default */.ZP)(_templateObject35(), TopbannerdefaultblockRecordParts, IconbBlockRecordParts, SeoFieldParts, AuthorblockRecorddParts, Contentsection1RecordParts, Contentsection2RecordParts, Contentsection3RecordParts, Contentsection4RecordParts, Contentsection5RecordParts, Contentsection6RecordParts, Contentsection7RecordParts, Contentsection8RecordParts, Contentsection9RecordParts, ContentsectionFilesParts, ContentsectionProductSliderParts, ImageTilesBlockRecordParts, PhotoGalleryBlockRecordParts);
const DatoFrontpageParts = (0,lib/* default */.ZP)(_templateObject36(), FrontPageHeaderParts, SeoFieldParts, Contentsection1RecordParts, Contentsection2RecordParts, Contentsection3RecordParts, Contentsection4RecordParts, Contentsection5RecordParts, Contentsection6RecordParts, Contentsection7RecordParts, Contentsection8RecordParts, Contentsection9RecordParts, ContentsectionFilesParts, ContentsectionProductSliderParts, ImageTilesBlockRecordParts, PhotoGalleryBlockRecordParts);
const StringRecordFragment = (0,lib/* default */.ZP)(_templateObject37());
const OpeningHourFragment = (0,lib/* default */.ZP)(_templateObject38());

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-dato-virtual-5a00219d6f/1/packages/lib-dato/src/content-queries/get-all-pages.ts
function get_all_pages_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function get_all_pages_templateObject() {
    const data = get_all_pages_taggedTemplateLiteral([
        "\n        query AllPages($first: IntType, $skip: IntType, $id: ItemId) {\n          allPages(orderBy: id_ASC, first: $first, skip: $skip, filter: { id: { eq: $id } }) {\n            ...DatoPageParts\n          }\n          meta: _allPagesMeta {\n            count\n          }\n        }\n        ",
        "\n      "
    ]);
    get_all_pages_templateObject = function() {
        return data;
    };
    return data;
}




async function getAllPages(param) {
    let { first , id , skip  } = param;
    try {
        const request = await graphQLClient.request((0,lib/* gql */.Ps)(get_all_pages_templateObject(), DatoPageParts), {
            first,
            skip,
            id
        });
        return request;
    } catch (error) {
        console.error("Error in getAllPages:", error);
        throw error;
    }
}
function useGetAllPages(param) {
    let { first , id , skip  } = param;
    const { data , isLoading , error  } = (0,es.useQuery)("get-all-pages", async ()=>{
        const result = await getAllPages({
            first,
            id,
            skip
        });
        return result;
    });
    return {
        data: data === null || data === void 0 ? void 0 : data.allPages,
        isLoading,
        error,
        meta: data === null || data === void 0 ? void 0 : data.meta
    };
}

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-dato-virtual-5a00219d6f/1/packages/lib-dato/src/content-queries/get-front-page-by-slug.ts
function get_front_page_by_slug_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function get_front_page_by_slug_templateObject() {
    const data = get_front_page_by_slug_taggedTemplateLiteral([
        "\n        query GetFrontPageBySlug($slug: String!) {\n          allFrontpages(filter: { slug: { eq: $slug } }, first: 1, orderBy: [published_DESC]) {\n            ...DatoFrontpageParts\n          }\n        }\n        ",
        "\n      "
    ]);
    get_front_page_by_slug_templateObject = function() {
        return data;
    };
    return data;
}




function useGetFrontPageBySlug(param) {
    let { slug  } = param;
    const { data , isLoading , error  } = (0,es.useQuery)("get-slug-front-page-by-".concat(slug), async ()=>{
        const request = await graphQLClient.request((0,lib/* gql */.Ps)(get_front_page_by_slug_templateObject(), DatoFrontpageParts), {
            slug
        });
        return request;
    });
    return {
        data: data === null || data === void 0 ? void 0 : data.allFrontpages,
        isLoading,
        error
    };
}

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-dato-virtual-5a00219d6f/1/packages/lib-dato/src/content-queries/get-front-page.ts
function get_front_page_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function get_front_page_templateObject() {
    const data = get_front_page_taggedTemplateLiteral([
        "\n          query GetFrontPage($limitDate: DateTime, $forPro: BooleanType!) {\n            allFrontpages(\n              filter: { published: { lt: $limitDate }, forsidaFyrirFagadila: { eq: $forPro } }\n              first: 1\n              orderBy: [published_DESC]\n            ) {\n              ...DatoFrontpageParts\n            }\n          }\n          ",
        "\n        "
    ]);
    get_front_page_templateObject = function() {
        return data;
    };
    return data;
}




function useGetFrontPage(param) {
    let { forPro , limitDate  } = param;
    const { data , isLoading , error  } = (0,es.useQuery)("get-specific-front-page-by-".concat(forPro ? "forPro" : "common", "-").concat(limitDate), async ()=>{
        const request = await graphQLClient.request((0,lib/* gql */.Ps)(get_front_page_templateObject(), DatoFrontpageParts), {
            limitDate,
            forPro
        });
        return request;
    }, {
        refetchOnWindowFocus: false
    });
    return {
        data: data === null || data === void 0 ? void 0 : data.allFrontpages,
        isLoading,
        error
    };
}

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-dato-virtual-5a00219d6f/1/packages/lib-dato/src/content-queries/get-opening-hours.ts
function get_opening_hours_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function get_opening_hours_templateObject() {
    const data = get_opening_hours_taggedTemplateLiteral([
        "\n      query GetOpeningHours {\n        openingHour {\n          ...OpeningHourFragment\n        }\n      }\n      ",
        "\n    "
    ]);
    get_opening_hours_templateObject = function() {
        return data;
    };
    return data;
}




function useGetOpeningHours() {
    const { data , isLoading , error  } = (0,es.useQuery)("get-opening-hours", async ()=>{
        const request = await graphQLClient.request((0,lib/* gql */.Ps)(get_opening_hours_templateObject(), OpeningHourFragment));
        return request;
    });
    return {
        data: data === null || data === void 0 ? void 0 : data.openingHours,
        isLoading,
        error
    };
}

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-dato-virtual-5a00219d6f/1/packages/lib-dato/src/content-queries/get-page-by-parent-page-and-slug.ts
function get_page_by_parent_page_and_slug_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function get_page_by_parent_page_and_slug_templateObject() {
    const data = get_page_by_parent_page_and_slug_taggedTemplateLiteral([
        "\n        query PageByParentPageAndSlug($parentpage: ItemId!, $slug: String!) {\n          allPages(filter: { parentPage: { eq: $parentpage }, slug: { eq: $slug } }) {\n            ...DatoPageParts\n          }\n        }\n        ",
        "\n      "
    ]);
    get_page_by_parent_page_and_slug_templateObject = function() {
        return data;
    };
    return data;
}




function useGetPageByParentPageAndSlug(param) {
    let { parentpage , slug  } = param;
    const { data , isLoading , error  } = (0,es.useQuery)("get-page-slug-parentpage-by-".concat(parentpage, "-and-").concat(slug), async ()=>{
        const request = await graphQLClient.request((0,lib/* gql */.Ps)(get_page_by_parent_page_and_slug_templateObject(), DatoPageParts), {
            parentpage,
            slug
        });
        return request;
    });
    return {
        data: data === null || data === void 0 ? void 0 : data.allPages,
        isLoading,
        error
    };
}

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-dato-virtual-5a00219d6f/1/packages/lib-dato/src/content-queries/get-page-by-slug.ts
function get_page_by_slug_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function get_page_by_slug_templateObject() {
    const data = get_page_by_slug_taggedTemplateLiteral([
        "\n        query PageBySlug($slug: String!) {\n          allPages(filter: { slug: { eq: $slug } }) {\n            ...DatoPageParts\n          }\n        }\n        ",
        "\n      "
    ]);
    get_page_by_slug_templateObject = function() {
        return data;
    };
    return data;
}




function useGetPageBySlug(param) {
    let { slug  } = param;
    const { data , isLoading , error  } = (0,es.useQuery)("get-page-slug-by-".concat(slug), async ()=>{
        const request = await graphQLClient.request((0,lib/* gql */.Ps)(get_page_by_slug_templateObject(), DatoPageParts), {
            slug
        });
        return request;
    });
    return {
        data: data === null || data === void 0 ? void 0 : data.allPages,
        isLoading,
        error
    };
}

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-dato-virtual-5a00219d6f/1/packages/lib-dato/src/content-queries/get-pages-by-parent.ts
function get_pages_by_parent_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function get_pages_by_parent_templateObject() {
    const data = get_pages_by_parent_taggedTemplateLiteral([
        "\n        query PagesByParent($parentpage: ItemId!) {\n          allPages(filter: { parentPage: { eq: $parentpage } }) {\n            ...DatoPageParts\n          }\n        }\n        ",
        "\n      "
    ]);
    get_pages_by_parent_templateObject = function() {
        return data;
    };
    return data;
}




function useGetPagesByParent(param) {
    let { parentpage  } = param;
    const { data , isLoading , error  } = (0,es.useQuery)("get-pages-parent-by-".concat(parentpage), async ()=>{
        const request = await graphQLClient.request((0,lib/* gql */.Ps)(get_pages_by_parent_templateObject(), DatoPageParts), {
            parentpage
        });
        return request;
    });
    return {
        data: data === null || data === void 0 ? void 0 : data.allPages,
        isLoading,
        error
    };
}

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-dato-virtual-5a00219d6f/1/packages/lib-dato/src/content-queries/get-product-by-slug.ts
function get_product_by_slug_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function get_product_by_slug_templateObject() {
    const data = get_product_by_slug_taggedTemplateLiteral([
        "\n        query ProductBySlug($slug: String!) {\n          allProductPages(filter: { slug: { eq: $slug } }) {\n            ...ProductParts\n          }\n        }\n        ",
        "\n      "
    ]);
    get_product_by_slug_templateObject = function() {
        return data;
    };
    return data;
}




function useGetProductBySlug(param) {
    let { slug  } = param;
    const { data , isLoading , error  } = (0,es.useQuery)("get-product-by-".concat(slug), async ()=>{
        const request = await graphQLClient.request((0,lib/* gql */.Ps)(get_product_by_slug_templateObject(), ProductParts), {
            slug
        });
        return request;
    });
    return {
        data: data === null || data === void 0 ? void 0 : data.allProductPages,
        isLoading,
        error
    };
}

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-dato-virtual-5a00219d6f/1/packages/lib-dato/src/content-queries/get-string-by-key.ts
function get_string_by_key_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function get_string_by_key_templateObject() {
    const data = get_string_by_key_taggedTemplateLiteral([
        "\n        query GetStringByKey($key: String!) {\n          allStrings(filter: { key: { eq: $key } }) {\n            ...StringRecordFragment\n          }\n        }\n        ",
        "\n      "
    ]);
    get_string_by_key_templateObject = function() {
        return data;
    };
    return data;
}




function useGetStringByKey(param) {
    let { key  } = param;
    const { data , isLoading , error  } = (0,es.useQuery)("get-string-by-".concat(key), async ()=>{
        const request = await graphQLClient.request((0,lib/* gql */.Ps)(get_string_by_key_templateObject(), StringRecordFragment), {
            key
        });
        return request;
    });
    return {
        data: data === null || data === void 0 ? void 0 : data.allStrings,
        isLoading,
        error
    };
}

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-dato-virtual-5a00219d6f/1/packages/lib-dato/src/content-queries/get-all-employees.ts
function get_all_employees_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function get_all_employees_templateObject() {
    const data = get_all_employees_taggedTemplateLiteral([
        "\n      query GetAllEmployees($first: IntType, $skip: IntType, $id: ItemId) {\n        allEmployees(first: $first, skip: $skip, filter: { id: { eq: $id } }) {\n          ...EmployeeParts\n        }\n      }\n      ",
        "\n      ",
        "\n      ",
        "\n      ",
        "\n    "
    ]);
    get_all_employees_templateObject = function() {
        return data;
    };
    return data;
}




async function fetchAllEmployees() {
    let skip = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, first = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 100, id = arguments.length > 2 ? arguments[2] : void 0;
    try {
        // const first = 100;
        const query = (0,lib/* gql */.Ps)(get_all_employees_templateObject(), EmployeeParts, JobTitleParts, DepartmentParts, SubDepartmentParts);
        const variables = {
            first,
            skip,
            id
        };
        const data = await graphQLClient.request(query, variables);
        if (data.allEmployees.length === first) {
            // If the number of records returned equals 'first', there may be more records
            const moreData = await fetchAllEmployees(skip + first);
            return [
                ...data.allEmployees,
                ...moreData
            ];
        } else {
            // If fewer than 'first' records are returned, we've got all the records
            return data.allEmployees;
        }
    } catch (error) {
        console.error("Error fetching all employees:", error);
        throw error;
    }
}
function useAllEmployees() {
    const fetcher = (_)=>fetchAllEmployees();
    const { data , isLoading , error  } = (0,es.useQuery)("all-employees", fetcher, {
        refetchOnWindowFocus: false
    });
    return {
        data,
        isLoading,
        error
    };
}

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-dato-virtual-5a00219d6f/1/packages/lib-dato/src/content-queries/get-text-on-page.ts
function get_text_on_page_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function get_text_on_page_templateObject() {
    const data = get_text_on_page_taggedTemplateLiteral([
        "\n        query GetTextOnPage {\n          textOnPage {\n            hasPostPaymentDiscountInvoiceExplanation\n            globalBannerText\n            netgiroPaymentHeading\n            netgiroPaymentHint\n            netgiroPaymentDescriptionFirst\n            netgiroPaymentDescriptionSecond\n            mittBykoOnboardingTitleNotAuthenticated\n            mittBykoOnboardingSubtitle\n            mittBykoOnboardingDescription\n          }\n        }\n      "
    ]);
    get_text_on_page_templateObject = function() {
        return data;
    };
    return data;
}



// fetches text on page from dato
function useGetTextOnPage() {
    const { data , isLoading , error  } = (0,es.useQuery)("get-text-on-page", async ()=>{
        const request = await graphQLClient.request((0,lib/* gql */.Ps)(get_text_on_page_templateObject()));
        return request;
    }, {
        refetchOnWindowFocus: false
    });
    return {
        data: data === null || data === void 0 ? void 0 : data.textOnPage,
        isLoading,
        error
    };
}

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-dato-virtual-5a00219d6f/1/packages/lib-dato/src/content-queries/get-text-on-footer.ts
function get_text_on_footer_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function get_text_on_footer_templateObject() {
    const data = get_text_on_footer_taggedTemplateLiteral([
        "\n        query GetFooterText {\n          footerText {\n            labelForOpeningHoursAndStoresLink\n            labelForTermsLink\n            facebookLink\n            youtubeLink\n            instagramLink\n            telephoneNumber\n            email\n          }\n        }\n      "
    ]);
    get_text_on_footer_templateObject = function() {
        return data;
    };
    return data;
}



function useGetFooterText() {
    const { data , isLoading , error  } = (0,es.useQuery)("get-footer-text", async ()=>{
        const request = await graphQLClient.request((0,lib/* gql */.Ps)(get_text_on_footer_templateObject()));
        return request;
    }, {
        refetchOnWindowFocus: false
    });
    return {
        data: data === null || data === void 0 ? void 0 : data.footerText,
        isLoading,
        error
    };
}

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-dato-virtual-5a00219d6f/1/packages/lib-dato/src/content-queries/get-header-text.ts
function get_header_text_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function get_header_text_templateObject() {
    const data = get_header_text_taggedTemplateLiteral([
        "\n        query HeaderTextQuery {\n          headerText {\n            descriptionForLoginPopover\n            descriptionForAudkennisappLoginPopover\n            headingForLoginPopover\n            hintForPhoneNumberInput\n            hintForKennitalaInput\n            hintTextForSearchBarLargeScreens\n            hintTextForSearchBarSmallScreens\n            labelForAssistanceWithElectronicIdLink\n            labelForLoginButton\n            labelForRememberPhoneNumberCheckbox\n            labelForRememberKennitalaCheckbox\n            labelForMegamenuButton\n          }\n        }\n      "
    ]);
    get_header_text_templateObject = function() {
        return data;
    };
    return data;
}



// fetches text on page from dato
function useGetHeaderText() {
    const { data , isLoading , error  } = (0,es.useQuery)("get-header-text", async ()=>{
        const request = await graphQLClient.request((0,lib/* gql */.Ps)(get_header_text_templateObject()));
        return request;
    }, {
        refetchOnWindowFocus: false
    });
    return {
        data: data === null || data === void 0 ? void 0 : data.headerText,
        isLoading,
        error
    };
}

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-dato-virtual-5a00219d6f/1/packages/lib-dato/src/content-queries/get-environmental-information.ts
function get_environmental_information_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function get_environmental_information_templateObject() {
    const data = get_environmental_information_taggedTemplateLiteral([
        "\n        query EnvironmentalInformation {\n          allEnvironmentalInformations {\n            id\n            pimKey\n            description\n            logo {\n              __typename\n              id\n              alt\n              author\n              basename\n              blurUpThumb\n              blurhash\n              colors {\n                __typename\n                alpha\n                blue\n                cssRgb\n                green\n                hex\n                red\n              }\n              filename\n              focalPoint {\n                __typename\n                x\n                y\n              }\n              format\n              height\n              md5\n              mimeType\n              responsiveImage {\n                __typename\n                alt\n                aspectRatio\n                base64\n                bgColor\n                height\n                sizes\n                src\n                srcSet\n                title\n                webpSrcSet\n                width\n              }\n              size\n              smartTags\n              tags\n              thumbhash\n              title\n              url\n              width\n            }\n          }\n        }\n      "
    ]);
    get_environmental_information_templateObject = function() {
        return data;
    };
    return data;
}



function useGetEnvironmentalInformation() {
    const { data , isLoading , error  } = (0,es.useQuery)("get-environmental-information", async ()=>{
        const request = await graphQLClient.request((0,lib/* gql */.Ps)(get_environmental_information_templateObject()));
        return request;
    });
    return {
        data,
        isLoading,
        error
    };
}

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-dato-virtual-5a00219d6f/1/packages/lib-dato/src/index.ts














const datoQueries = {
    useGetAllPages: useGetAllPages,
    getAllPages: getAllPages,
    useGetFrontPageBySlug: useGetFrontPageBySlug,
    useGetFrontPage: useGetFrontPage,
    useGetOpeningHours: useGetOpeningHours,
    useGetPageByParentPageAndSlug: useGetPageByParentPageAndSlug,
    useGetPageBySlug: useGetPageBySlug,
    useGetPagesByParent: useGetPagesByParent,
    useGetProductBySlug: useGetProductBySlug,
    useGetStringByKey: useGetStringByKey,
    useAllEmployees: useAllEmployees,
    fetchAllEmployees: fetchAllEmployees,
    useGetTextOnPage: useGetTextOnPage,
    useGetFooterText: useGetFooterText,
    useGetHeaderText: useGetHeaderText,
    useGetEnvironmentalInformation: useGetEnvironmentalInformation
};


/***/ }),

/***/ 45628:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "AddIcons": function() { return /* reexport */ AddIcons; },
  "AddUserIcons": function() { return /* reexport */ AddUserIcons; },
  "AdviceIcons": function() { return /* reexport */ AdviceIcons; },
  "ArrowDownIcons": function() { return /* reexport */ ArrowDownIcons; },
  "ArrowLeftIcons": function() { return /* reexport */ ArrowLeftIcons; },
  "ArrowRightIcons": function() { return /* reexport */ ArrowRightIcons; },
  "ArrowUpIcons": function() { return /* reexport */ ArrowUpIcons; },
  "AttentionIcons": function() { return /* reexport */ AttentionIcons; },
  "AurIcons": function() { return /* reexport */ AurIcons; },
  "BagAddIcons": function() { return /* reexport */ BagAddIcons; },
  "BarbecueToolsFilledDecorative": function() { return /* reexport */ BarbecueToolsFilledDecorative; },
  "BarbecueToolsLineDecorative": function() { return /* reexport */ BarbecueToolsLineDecorative; },
  "BeraSamanIcons": function() { return /* reexport */ BeraSamanIcons; },
  "BykoMainLogo": function() { return /* reexport */ BykoMainLogo; },
  "CalculatorIcons": function() { return /* reexport */ CalculatorIcons; },
  "CalendarCheckmarkIcons": function() { return /* reexport */ CalendarCheckmarkIcons; },
  "CalendarIcons": function() { return /* reexport */ CalendarIcons; },
  "CancelLargeIcons": function() { return /* reexport */ CancelLargeIcons; },
  "CancelSmallIcons": function() { return /* reexport */ CancelSmallIcons; },
  "CartIcons": function() { return /* reexport */ CartIcons; },
  "CheckmarkIcons": function() { return /* reexport */ CheckmarkIcons; },
  "ChevronIcon": function() { return /* reexport */ ChevronIcon; },
  "Clock1FilledDecorative": function() { return /* reexport */ Clock1FilledDecorative; },
  "Clock2LineDecorative": function() { return /* reexport */ Clock2LineDecorative; },
  "ClockWhiteFilledDecorative": function() { return /* reexport */ ClockWhiteFilledDecorative; },
  "ContextAlternateIcons": function() { return /* reexport */ ContextAlternateIcons; },
  "ContextCommonUserIcons": function() { return /* reexport */ ContextCommonUserIcons; },
  "ContextProUserIcons": function() { return /* reexport */ ContextProUserIcons; },
  "CreditCardAddIcons": function() { return /* reexport */ CreditCardAddIcons; },
  "CreditCardNormalIcons": function() { return /* reexport */ CreditCardNormalIcons; },
  "CreditLimitIcons": function() { return /* reexport */ CreditLimitIcons; },
  "CreditLimitSmallIcons": function() { return /* reexport */ CreditLimitSmallIcons; },
  "DataIcons": function() { return /* reexport */ DataIcons; },
  "DeactivateIcons": function() { return /* reexport */ DeactivateIcons; },
  "DeliverOrderIcons": function() { return /* reexport */ DeliverOrderIcons; },
  "DeliveryIcons": function() { return /* reexport */ DeliveryIcons; },
  "DesignFilledDecorative": function() { return /* reexport */ DesignFilledDecorative; },
  "DesignLineDecorative": function() { return /* reexport */ DesignLineDecorative; },
  "DiscountIcons": function() { return /* reexport */ DiscountIcons; },
  "DiscountPercentcons": function() { return /* reexport */ DiscountPercentcons; },
  "DocumentFilledDecorative": function() { return /* reexport */ DocumentFilledDecorative; },
  "DocumentLineDecorative": function() { return /* reexport */ DocumentLineDecorative; },
  "DotsIcons": function() { return /* reexport */ DotsIcons; },
  "DownloadIcons": function() { return /* reexport */ DownloadIcons; },
  "DrillFilledDecorative": function() { return /* reexport */ DrillFilledDecorative; },
  "DrillIcons": function() { return /* reexport */ DrillIcons; },
  "DrillLineDecorative": function() { return /* reexport */ DrillLineDecorative; },
  "EcologyFilledDecorative": function() { return /* reexport */ EcologyFilledDecorative; },
  "EcologyIcons": function() { return /* reexport */ EcologyIcons; },
  "EcologyLineDecorative": function() { return /* reexport */ EcologyLineDecorative; },
  "EyeClosedIcons": function() { return /* reexport */ EyeClosedIcons; },
  "EyeOpenIcons": function() { return /* reexport */ EyeOpenIcons; },
  "FacebookIcons": function() { return /* reexport */ FacebookIcons; },
  "FacebookSimpleIcons": function() { return /* reexport */ FacebookSimpleIcons; },
  "FenceIcons": function() { return /* reexport */ FenceIcons; },
  "FilterIcons": function() { return /* reexport */ FilterIcons; },
  "FlagIcons": function() { return /* reexport */ FlagIcons; },
  "GlassesIcons": function() { return /* reexport */ GlassesIcons; },
  "GlobeFilledDecorative": function() { return /* reexport */ GlobeFilledDecorative; },
  "GlobeLineDecorative": function() { return /* reexport */ GlobeLineDecorative; },
  "HeartFilledIcons": function() { return /* reexport */ HeartFilledIcons; },
  "HeartIcons": function() { return /* reexport */ HeartIcons; },
  "HouseIcons": function() { return /* reexport */ HouseIcons; },
  "InfoFilledIcons": function() { return /* reexport */ InfoFilledIcons; },
  "InfoIcons": function() { return /* reexport */ InfoIcons; },
  "InfoOneFilledIcons": function() { return /* reexport */ InfoOneFilledIcons; },
  "InfoSmallIcons": function() { return /* reexport */ InfoSmallIcons; },
  "InfoSquareIcons": function() { return /* reexport */ InfoSquareIcons; },
  "InstagramIcons": function() { return /* reexport */ InstagramIcons; },
  "InstagramLineIcons": function() { return /* reexport */ InstagramLineIcons; },
  "KeyIcons": function() { return /* reexport */ KeyIcons; },
  "LawnmowerFilledDecorative": function() { return /* reexport */ LawnmowerFilledDecorative; },
  "LawnmowerIcons": function() { return /* reexport */ LawnmowerIcons; },
  "LawnmowerLineDecorative": function() { return /* reexport */ LawnmowerLineDecorative; },
  "LeafBulbFilledDecorative": function() { return /* reexport */ LeafBulbFilledDecorative; },
  "LeafBulbLineDecorative": function() { return /* reexport */ LeafBulbLineDecorative; },
  "LikeThumbsUpIcons": function() { return /* reexport */ LikeThumbsUpIcons; },
  "ListIcons": function() { return /* reexport */ ListIcons; },
  "LocationIcons": function() { return /* reexport */ LocationIcons; },
  "LogoutIcons": function() { return /* reexport */ LogoutIcons; },
  "LogoutReverseIcons": function() { return /* reexport */ LogoutReverseIcons; },
  "LongArrowDownIcons": function() { return /* reexport */ LongArrowDownIcons; },
  "LongArrowLeftIcons": function() { return /* reexport */ LongArrowLeftIcons; },
  "LongArrowRightIcons": function() { return /* reexport */ LongArrowRightIcons; },
  "LongArrowSideIcons": function() { return /* reexport */ LongArrowSideIcons; },
  "LongArrowUpIcons": function() { return /* reexport */ LongArrowUpIcons; },
  "MailIcons": function() { return /* reexport */ MailIcons; },
  "MastercardIcons": function() { return /* reexport */ MastercardIcons; },
  "Measure1FilledDecorative": function() { return /* reexport */ Measure1FilledDecorative; },
  "Measure1LineDecorative": function() { return /* reexport */ Measure1LineDecorative; },
  "Measure2FilledDecorative": function() { return /* reexport */ Measure2FilledDecorative; },
  "Measure2LineDecorative": function() { return /* reexport */ Measure2LineDecorative; },
  "MeasureBigFilledDecorative": function() { return /* reexport */ MeasureBigFilledDecorative; },
  "MeasureBigLineDecorative": function() { return /* reexport */ MeasureBigLineDecorative; },
  "MenuIcons": function() { return /* reexport */ MenuIcons; },
  "MobileContact1FilledDecorative": function() { return /* reexport */ MobileContact1FilledDecorative; },
  "MobileContact2LineDecorative": function() { return /* reexport */ MobileContact2LineDecorative; },
  "MobileWhiteFilledDecorative": function() { return /* reexport */ MobileWhiteFilledDecorative; },
  "MushroomIcons": function() { return /* reexport */ MushroomIcons; },
  "NetgiroIcons": function() { return /* reexport */ NetgiroIcons; },
  "NewsletterFilledDecorative": function() { return /* reexport */ NewsletterFilledDecorative; },
  "NewsletterineDecorative": function() { return /* reexport */ NewsletterineDecorative; },
  "NotandiIcons": function() { return /* reexport */ NotandiIcons; },
  "PagesIcons": function() { return /* reexport */ PagesIcons; },
  "PaintBrushFilledDecorative": function() { return /* reexport */ PaintBrushFilledDecorative; },
  "PaintBrushLineDecorative": function() { return /* reexport */ PaintBrushLineDecorative; },
  "PaintBucket1FilledDecorative": function() { return /* reexport */ PaintBucket1FilledDecorative; },
  "PaintBucket1LineDecorative": function() { return /* reexport */ PaintBucket1LineDecorative; },
  "PaintBucket2FilledDecorative": function() { return /* reexport */ PaintBucket2FilledDecorative; },
  "PaintBucket2LineDecorative": function() { return /* reexport */ PaintBucket2LineDecorative; },
  "PaintFilledDecorative": function() { return /* reexport */ PaintFilledDecorative; },
  "PaintLineDecorative": function() { return /* reexport */ PaintLineDecorative; },
  "PaintRollFilledDecorative": function() { return /* reexport */ PaintRollFilledDecorative; },
  "PaintRollLineDecorative": function() { return /* reexport */ PaintRollLineDecorative; },
  "PaintbrushIcons": function() { return /* reexport */ PaintbrushIcons; },
  "PdfIcons": function() { return /* reexport */ PdfIcons; },
  "PeiIcons": function() { return /* reexport */ PeiIcons; },
  "PickaxeFilledDecorative": function() { return /* reexport */ PickaxeFilledDecorative; },
  "PickaxeLineDecorative": function() { return /* reexport */ PickaxeLineDecorative; },
  "PlanetIcons": function() { return /* reexport */ PlanetIcons; },
  "PlantGroundFilledDecorative": function() { return /* reexport */ PlantGroundFilledDecorative; },
  "PlantGroundLineDecorative": function() { return /* reexport */ PlantGroundLineDecorative; },
  "PresentIcons": function() { return /* reexport */ PresentIcons; },
  "ProductIcons": function() { return /* reexport */ ProductIcons; },
  "ReceiptIcons": function() { return /* reexport */ ReceiptIcons; },
  "ReceiptTwoIcons": function() { return /* reexport */ ReceiptTwoIcons; },
  "RecycleFilledDecorative": function() { return /* reexport */ RecycleFilledDecorative; },
  "RecycleLineDecorative": function() { return /* reexport */ RecycleLineDecorative; },
  "RefreshIcons": function() { return /* reexport */ RefreshIcons; },
  "RemoveUserIcons": function() { return /* reexport */ RemoveUserIcons; },
  "ResidenceIcons": function() { return /* reexport */ ResidenceIcons; },
  "ResidenceSimpleIcons": function() { return /* reexport */ ResidenceSimpleIcons; },
  "RulerPencilFilledDecorative": function() { return /* reexport */ RulerPencilFilledDecorative; },
  "RulerPencilLineDecorative": function() { return /* reexport */ RulerPencilLineDecorative; },
  "SaveIcons": function() { return /* reexport */ SaveIcons; },
  "ScissorsFilledDecorative": function() { return /* reexport */ ScissorsFilledDecorative; },
  "ScissorsLineDecorative": function() { return /* reexport */ ScissorsLineDecorative; },
  "SearchIcons": function() { return /* reexport */ SearchIcons; },
  "SendMailIcons": function() { return /* reexport */ SendMailIcons; },
  "SendMessageFilledDecorative": function() { return /* reexport */ SendMessageFilledDecorative; },
  "SendMessageineDecorative": function() { return /* reexport */ SendMessageineDecorative; },
  "SendMessagesBlueFilledDecorative": function() { return /* reexport */ SendMessagesBlueFilledDecorative; },
  "ServiceIcons": function() { return /* reexport */ ServiceIcons; },
  "SettingsCogwheelFilledDecorative": function() { return /* reexport */ SettingsCogwheelFilledDecorative; },
  "SettingsCogwheelLineDecorative": function() { return /* reexport */ SettingsCogwheelLineDecorative; },
  "SettingsGearFilledDecorative": function() { return /* reexport */ SettingsGearFilledDecorative; },
  "SettingsGearLineDecorative": function() { return /* reexport */ SettingsGearLineDecorative; },
  "SettingsIcons": function() { return /* reexport */ SettingsIcons; },
  "SettingsToolsFilledDecorative": function() { return /* reexport */ SettingsToolsFilledDecorative; },
  "SettingsToolsLineDecorative": function() { return /* reexport */ SettingsToolsLineDecorative; },
  "ShoppingBagIcons": function() { return /* reexport */ ShoppingBagIcons; },
  "ShoppingTagIcons": function() { return /* reexport */ ShoppingTagIcons; },
  "ShovelFilledDecorative": function() { return /* reexport */ ShovelFilledDecorative; },
  "ShovelLineDecorative": function() { return /* reexport */ ShovelLineDecorative; },
  "SmallFenceIcons": function() { return /* reexport */ SmallFenceIcons; },
  "SubtractIcons": function() { return /* reexport */ SubtractIcons; },
  "SwissKnifeFilledDecorative": function() { return /* reexport */ SwissKnifeFilledDecorative; },
  "SwissKnifeIcons": function() { return /* reexport */ SwissKnifeIcons; },
  "SwissKnifeLineDecorative": function() { return /* reexport */ SwissKnifeLineDecorative; },
  "TimeClock1FilledDecorative": function() { return /* reexport */ TimeClock1FilledDecorative; },
  "TimeClock2LineDecorative": function() { return /* reexport */ TimeClock2LineDecorative; },
  "TrashCanIcons": function() { return /* reexport */ TrashCanIcons; },
  "TreeFilledDecorative": function() { return /* reexport */ TreeFilledDecorative; },
  "TreeIcons": function() { return /* reexport */ TreeIcons; },
  "TreeLineDecorative": function() { return /* reexport */ TreeLineDecorative; },
  "VisaIcons": function() { return /* reexport */ VisaIcons; },
  "WalletIcons": function() { return /* reexport */ WalletIcons; },
  "WalletSmallIcons": function() { return /* reexport */ WalletSmallIcons; },
  "WindowIcons": function() { return /* reexport */ WindowIcons; },
  "WrenchFilledDecorative": function() { return /* reexport */ WrenchFilledDecorative; },
  "WrenchIcons": function() { return /* reexport */ WrenchIcons; },
  "WrenchLineDecorative": function() { return /* reexport */ WrenchLineDecorative; },
  "WrenchSmallIcons": function() { return /* reexport */ WrenchSmallIcons; },
  "XlsIcons": function() { return /* reexport */ XlsIcons; },
  "YoutubeIcons": function() { return /* reexport */ YoutubeIcons; }
});

// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(61261);
// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(91987);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-icons-virtual-412b14e947/1/packages/lib-icons/src/standard/long-arrow-right-icons.tsx


const LongArrowRightIcons = (param)=>{
    let { size , iconColor , ...props } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        className: "byko-icon",
        fill: "none",
        height: size,
        viewBox: "0 0 24 24",
        width: size,
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
            stroke: iconColor,
            strokeMiterlimit: 10,
            strokeWidth: 2,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M2 12h20"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M15 5l7 7-7 7",
                    stroke: iconColor,
                    strokeLinecap: "square"
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-icons-virtual-412b14e947/1/packages/lib-icons/src/standard/long-arrow-left-icons.tsx


const LongArrowLeftIcons = (param)=>{
    let { size , iconColor  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        fill: "none",
        height: size,
        viewBox: "0 0 24 24",
        width: size,
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M22 12H2",
                stroke: iconColor,
                strokeMiterlimit: "10",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M9 19L2 12L9 5",
                stroke: iconColor,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-icons-virtual-412b14e947/1/packages/lib-icons/src/standard/long-arrow-down-icons.tsx


const LongArrowDownIcons = (param)=>{
    let { size , iconColor , ...props } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        className: "byko-icon",
        fill: "none",
        height: size,
        viewBox: "0 0 24 24",
        width: size,
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M12 2V22",
                stroke: iconColor,
                strokeMiterlimit: "10",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M19 15L12 22L5 15",
                stroke: iconColor,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-icons-virtual-412b14e947/1/packages/lib-icons/src/standard/long-arrow-up-icons.tsx


const LongArrowUpIcons = (param)=>{
    let { size , iconColor  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        fill: "none",
        height: size,
        viewBox: "0 0 24 24",
        width: size,
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M12 22V2",
                stroke: iconColor,
                strokeMiterlimit: "10",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M5 9L12 2L19 9",
                stroke: iconColor,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-icons-virtual-412b14e947/1/packages/lib-icons/src/standard/arrow-up-icons.tsx


const ArrowUpIcons = (param)=>{
    let { size , iconColor ="#00416A" , ...props } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        className: "byko-icon",
        fill: "none",
        height: size,
        viewBox: "0 0 24 24",
        width: size,
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M6 14L12 8L18 14",
            stroke: iconColor,
            strokeLinecap: "square",
            strokeMiterlimit: "10",
            strokeWidth: "2"
        })
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-icons-virtual-412b14e947/1/packages/lib-icons/src/standard/arrow-right-icons.tsx


const ArrowRightIcons = (param)=>{
    let { size , iconColor  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        className: "byko-icon",
        fill: "none",
        height: size,
        viewBox: "0 0 24 24",
        width: size,
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M10 6L16 12L10 18",
            stroke: iconColor,
            strokeLinecap: "square",
            strokeMiterlimit: "10",
            strokeWidth: "2"
        })
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-icons-virtual-412b14e947/1/packages/lib-icons/src/standard/arrow-left-icons.tsx


const ArrowLeftIcons = (param)=>{
    let { size , iconColor  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        className: "byko-icon",
        fill: "none",
        height: size,
        viewBox: "0 0 24 24",
        width: size,
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M14 18L8 12L14 6",
            stroke: iconColor,
            strokeLinecap: "square",
            strokeMiterlimit: "10",
            strokeWidth: "2"
        })
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-icons-virtual-412b14e947/1/packages/lib-icons/src/standard/arrow-down-icons.tsx


const ArrowDownIcons = (param)=>{
    let { size , iconColor ="#00416A"  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        fill: "none",
        height: size,
        viewBox: "0 0 24 24",
        width: size,
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M18 10L12 16L6 10",
            stroke: iconColor,
            strokeLinecap: "square",
            strokeMiterlimit: "10",
            strokeWidth: "2"
        })
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-icons-virtual-412b14e947/1/packages/lib-icons/src/standard/long-arrow-side-icons.tsx


const LongArrowSideIcons = (param)=>{
    let { size , iconColor ="#00416A" , ...props } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        className: "byko-icon",
        fill: "none",
        height: size,
        stroke: iconColor,
        viewBox: "0 0 24 24",
        width: size,
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
            strokeMiterlimit: 10,
            strokeWidth: 2,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M5 18.5L18.5 5"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M8.5 5h10v10",
                    strokeLinecap: "square"
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-lib-styles-virtual-b3f1d479f2/1/packages/lib-styles/src/index.ts + 18 modules
var src = __webpack_require__(52203);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-icons-virtual-412b14e947/1/packages/lib-icons/src/standard/search-icons.tsx



const SearchIcons = (param)=>{
    let { size , iconColor =src/* theme.palette.blue.main */.rS.palette.blue.main  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        fill: "none",
        height: size,
        viewBox: "0 0 23 23",
        width: size,
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M21 21L14.656 14.656",
                stroke: iconColor,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M9 17C13.4183 17 17 13.4183 17 9C17 4.58172 13.4183 1 9 1C4.58172 1 1 4.58172 1 9C1 13.4183 4.58172 17 9 17Z",
                stroke: iconColor,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-icons-virtual-412b14e947/1/packages/lib-icons/src/standard/cart-icons.tsx


const CartIcons = (param)=>{
    let { size , iconColor  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        fill: "none",
        height: size,
        viewBox: "0 0 24 24",
        width: size,
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                // eslint-disable-next-line max-len
                d: "M6 23C6.55228 23 7 22.5523 7 22C7 21.4477 6.55228 21 6 21C5.44772 21 5 21.4477 5 22C5 22.5523 5.44772 23 6 23Z",
                fill: iconColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                // eslint-disable-next-line max-len
                d: "M20 23C20.5523 23 21 22.5523 21 22C21 21.4477 20.5523 21 20 21C19.4477 21 19 21.4477 19 22C19 22.5523 19.4477 23 20 23Z",
                fill: iconColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                // eslint-disable-next-line max-len
                d: "M6 23C6.55228 23 7 22.5523 7 22C7 21.4477 6.55228 21 6 21C5.44772 21 5 21.4477 5 22C5 22.5523 5.44772 23 6 23Z",
                stroke: iconColor,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                // eslint-disable-next-line max-len
                d: "M20 23C20.5523 23 21 22.5523 21 22C21 21.4477 20.5523 21 20 21C19.4477 21 19 21.4477 19 22C19 22.5523 19.4477 23 20 23Z",
                stroke: iconColor,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M4.8 7H22L20 17H6L4 2H1",
                stroke: iconColor,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-icons-virtual-412b14e947/1/packages/lib-icons/src/standard/discount-icons.tsx


const DiscountIcons = (param)=>{
    let { size , iconColor  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        fill: "none",
        height: size,
        viewBox: "0 0 24 24",
        width: size,
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M20 12C20 10.3 21.3 9 23 9V4H1V9C2.7 9 4 10.3 4 12C4 13.7 2.7 15 1 15V20H23V15C21.3 15 20 13.7 20 12Z",
                stroke: iconColor,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M15 9L9 15",
                stroke: iconColor,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                // eslint-disable-next-line max-len
                d: "M9.5 10C10.3284 10 11 9.32843 11 8.5C11 7.67157 10.3284 7 9.5 7C8.67157 7 8 7.67157 8 8.5C8 9.32843 8.67157 10 9.5 10Z",
                fill: iconColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                // eslint-disable-next-line max-len
                d: "M14.5 17C15.3284 17 16 16.3284 16 15.5C16 14.6716 15.3284 14 14.5 14C13.6716 14 13 14.6716 13 15.5C13 16.3284 13.6716 17 14.5 17Z",
                fill: iconColor
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-icons-virtual-412b14e947/1/packages/lib-icons/src/standard/list-icons.tsx


const ListIcons = (param)=>{
    let { size , iconColor  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        fill: "none",
        height: size,
        viewBox: "0 0 24 24",
        width: size,
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M12 6H23",
                stroke: iconColor,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M8 3H2V9H8V3Z",
                stroke: iconColor,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M12 18H23",
                stroke: iconColor,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M2 15L8 21",
                stroke: iconColor,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M8 15L2 21",
                stroke: iconColor,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-icons-virtual-412b14e947/1/packages/lib-icons/src/standard/visa-icons.tsx
/* eslint-disable max-len */ 


const VisaIcons = (param)=>{
    let { size  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        fill: "none",
        height: size,
        viewBox: "0 0 24 24",
        width: size,
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M0 0h24v24H0z",
                fill: "none"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M22.222 15.768l-.225-1.125h-2.514l-.4 1.117-2.015.004a4199.19 4199.19 0 0 1 2.884-6.918c.164-.391.455-.59.884-.588.328.003.863.003 1.606.001L24 15.765l-1.778.003zm-2.173-2.666h1.62l-.605-2.82-1.015 2.82zM7.06 8.257l2.026.002-3.132 7.51-2.051-.002a950.849 950.849 0 0 1-1.528-5.956c-.1-.396-.298-.673-.679-.804C1.357 8.89.792 8.71 0 8.465V8.26h3.237c.56 0 .887.271.992.827.106.557.372 1.975.8 4.254L7.06 8.257zm4.81.002l-1.602 7.508-1.928-.002L9.94 8.257l1.93.002zm3.91-.139c.577 0 1.304.18 1.722.345l-.338 1.557c-.378-.152-1-.357-1.523-.35-.76.013-1.23.332-1.23.638 0 .498.816.749 1.656 1.293.959.62 1.085 1.177 1.073 1.782-.013 1.256-1.073 2.495-3.309 2.495-1.02-.015-1.388-.101-2.22-.396l.352-1.625c.847.355 1.206.468 1.93.468.663 0 1.232-.268 1.237-.735.004-.332-.2-.497-.944-.907-.744-.411-1.788-.98-1.774-2.122.017-1.462 1.402-2.443 3.369-2.443z",
                fill: src/* theme.palette.blue.main */.rS.palette.blue.main
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-icons-virtual-412b14e947/1/packages/lib-icons/src/standard/mastercard-icons.tsx
/* eslint-disable max-len */ 


const MastercardIcons = (param)=>{
    let { size  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        fill: "none",
        height: size,
        viewBox: "0 0 24 24",
        width: size,
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M0 0h24v24H0z",
                fill: "none"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M12 6.654a6.786 6.786 0 0 1 2.596 5.344A6.786 6.786 0 0 1 12 17.34a6.786 6.786 0 0 1-2.596-5.343A6.786 6.786 0 0 1 12 6.654zm-.87-.582A7.783 7.783 0 0 0 8.4 12a7.783 7.783 0 0 0 2.728 5.926 6.798 6.798 0 1 1 .003-11.854zm1.742 11.854A7.783 7.783 0 0 0 15.6 12a7.783 7.783 0 0 0-2.73-5.928 6.798 6.798 0 1 1 .003 11.854z",
                fill: src/* theme.palette.blue.main */.rS.palette.blue.main
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-icons-virtual-412b14e947/1/packages/lib-icons/src/standard/receipt-icons.tsx


const ReceiptIcons = (param)=>{
    let { size , iconColor  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        fill: "none",
        height: size,
        viewBox: "0 0 16 16",
        width: size,
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                // eslint-disable-next-line max-len
                d: "M13.0769 1H2.92308C2.41354 1 2 1.38827 2 1.86667V14L4.30769 12.2667L6.15385 14L8 12.2667L9.84615 14L11.6923 12.2667L14 14V1.86667C14 1.38827 13.5865 1 13.0769 1Z",
                stroke: iconColor,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "1.5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M5 5L11 5",
                stroke: iconColor,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "1.5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M5 8H11",
                stroke: iconColor,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "1.5"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-icons-virtual-412b14e947/1/packages/lib-icons/src/standard/logout-icons.tsx


const LogoutIcons = (param)=>{
    let { size , iconColor  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        className: "byko-icon",
        fill: "none",
        height: size,
        viewBox: "0 0 24 24",
        width: size,
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M9 12H21",
                stroke: iconColor,
                strokeMiterlimit: "10",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M17 16L21 12L17 8",
                stroke: iconColor,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M19 4V1H5V23H19V20",
                stroke: iconColor,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-icons-virtual-412b14e947/1/packages/lib-icons/src/standard/wallet-icons.tsx


const WalletIcons = (param)=>{
    let { size , iconColor  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        fill: "none",
        height: size,
        viewBox: "0 0 24 24",
        width: size,
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M21 12V5H3C1.895 5 1 4.105 1 3V20C1 21.657 2.343 23 4 23H21V16",
                stroke: iconColor,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M17 2V1H3C1.895 1 1 1.895 1 3C1 4.105 1.895 5 3 5",
                stroke: iconColor,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M23 16H18C16.895 16 16 15.105 16 14C16 12.895 16.895 12 18 12H23V16Z",
                stroke: iconColor,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-icons-virtual-412b14e947/1/packages/lib-icons/src/standard/credit-card-add-icons.tsx


const CreditCardAddIcons = (param)=>{
    let { size , iconColor  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        fill: "none",
        height: size,
        viewBox: "0 0 24 24",
        width: size,
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M1 6H23",
                stroke: iconColor,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M1 11H23",
                stroke: iconColor,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M20 16V22",
                stroke: iconColor,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M17 19H23",
                stroke: iconColor,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M23 11V4C23 2.9 22.1 2 21 2H16H3C1.9 2 1 2.9 1 4V17C1 18.1 1.9 19 3 19H11",
                stroke: iconColor,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-icons-virtual-412b14e947/1/packages/lib-icons/src/standard/pages-icons.tsx
/* eslint-disable max-len */ 

const PagesIcons = (param)=>{
    let { size , iconColor  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        className: "byko-icon",
        fill: "none",
        height: size,
        viewBox: "0 0 24 24",
        width: size,
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M18 5H2V23H18V5Z",
                stroke: iconColor,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M5 1H22V21",
                stroke: iconColor,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M6 10H14",
                stroke: iconColor,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M6 14H14",
                stroke: iconColor,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M6 18H10",
                stroke: iconColor,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2"
            })
        ]
    });
};
/* harmony default export */ var pages_icons = ((/* unused pure expression or super */ null && (PagesIcons)));

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-icons-virtual-412b14e947/1/packages/lib-icons/src/standard/credit-card-normal-icons.tsx


const CreditCardNormalIcons = (param)=>{
    let { size , iconColor  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        fill: "none",
        height: size,
        viewBox: "0 0 24 24",
        width: size,
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M1 7H23",
                stroke: iconColor,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M1 11H23",
                stroke: iconColor,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                // eslint-disable-next-line max-len
                d: "M21 21H3C1.895 21 1 20.105 1 19V5C1 3.895 1.895 3 3 3H16H21C22.105 3 23 3.895 23 5V19C23 20.105 22.105 21 21 21Z",
                stroke: iconColor,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M5 16H10",
                stroke: iconColor,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M18 16H19",
                stroke: iconColor,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-icons-virtual-412b14e947/1/packages/lib-icons/src/standard/glasses-icons.tsx
/* eslint-disable max-len */ 

const GlassesIcons = (param)=>{
    let { size , iconColor  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        className: "byko-icon",
        fill: "none",
        height: size,
        viewBox: "0 0 24 24",
        width: size,
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M10 16H14",
                stroke: iconColor,
                strokeMiterlimit: "10",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M8 2L5.88 2.707C5.60422 2.79879 5.35177 2.94958 5.14021 3.14888C4.92865 3.34818 4.76307 3.59119 4.655 3.861L1.572 11.57C1.19395 12.5149 0.99981 13.5233 1 14.541V17C1 18.0609 1.42143 19.0783 2.17157 19.8284C2.92172 20.5786 3.93913 21 5 21H6C7.06087 21 8.07828 20.5786 8.82843 19.8284C9.57857 19.0783 10 18.0609 10 17V15C10 14.4696 9.78929 13.9609 9.41421 13.5858C9.03914 13.2107 8.53043 13 8 13H2",
                stroke: iconColor,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M16 2L18.12 2.707C18.3958 2.79879 18.6482 2.94958 18.8598 3.14888C19.0714 3.34818 19.2369 3.59119 19.345 3.861L22.428 11.57C22.806 12.5149 23.0002 13.5233 23 14.541V17C23 18.0609 22.5786 19.0783 21.8284 19.8284C21.0783 20.5786 20.0609 21 19 21H18C16.9391 21 15.9217 20.5786 15.1716 19.8284C14.4214 19.0783 14 18.0609 14 17V15C14 14.4696 14.2107 13.9609 14.5858 13.5858C14.9609 13.2107 15.4696 13 16 13H22",
                stroke: iconColor,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2"
            })
        ]
    });
};
/* harmony default export */ var glasses_icons = ((/* unused pure expression or super */ null && (GlassesIcons)));

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-icons-virtual-412b14e947/1/packages/lib-icons/src/standard/planet-icons.tsx
/* eslint-disable max-len */ 

const PlanetIcons = (param)=>{
    let { size ="24" , iconColor ="#008F69"  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        fill: "none",
        height: size,
        viewBox: "0 0 24 24",
        width: size,
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                clipPath: "url(#clip0_2242_4156)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M7.11 3L8.722 4.325L10.367 6.081L9.963 8.821L7.369 10.133L6.667 12.439L7.974 13.839L8.68 16.312L6.717 17.959L6 20",
                        stroke: iconColor,
                        strokeLinecap: "square",
                        strokeLinejoin: "round",
                        strokeMiterlimit: "10",
                        strokeWidth: "2"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M23 8C22.3038 8.93503 21.3987 9.69446 20.357 10.2177C19.3153 10.741 18.1658 11.0137 17 11.014C15.9391 11.014 14.9217 11.4354 14.1716 12.1856C13.4214 12.9357 13 13.9531 13 15.014C13 16.0749 13.4214 17.0923 14.1716 17.8424C14.9217 18.5926 15.9391 19.014 17 19.014C18.5913 19.014 20.1174 18.3819 21.2426 17.2566C22.3679 16.1314 23 14.6053 23 13.014V8Z",
                        stroke: iconColor,
                        strokeLinecap: "square",
                        strokeLinejoin: "round",
                        strokeMiterlimit: "10",
                        strokeWidth: "2"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M16.757 15.771C16.1992 16.3277 15.7569 16.9891 15.4553 17.7173C15.1538 18.4454 14.9991 19.2259 15 20.014C15 20.8096 14.6839 21.5727 14.1213 22.1353C13.5587 22.6979 12.7956 23.014 12 23.014",
                        stroke: iconColor,
                        strokeLinecap: "square",
                        strokeMiterlimit: "10",
                        strokeWidth: "2"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M8 22.242C6.46131 21.6443 5.07699 20.7076 3.94976 19.5017C2.82252 18.2958 1.98132 16.8515 1.48856 15.2761C0.995801 13.7006 0.864142 12.0344 1.10335 10.4011C1.34256 8.76778 1.9465 7.20931 2.87035 5.84131C3.7942 4.47332 5.01425 3.33093 6.43996 2.49891C7.86566 1.66688 9.46043 1.16659 11.1059 1.03515C12.7514 0.903714 14.4054 1.14451 15.9451 1.73966C17.4848 2.33481 18.8707 3.26905 20 4.47304C20.1 4.58404 20.207 4.69704 20.306 4.81304",
                        stroke: iconColor,
                        strokeLinecap: "square",
                        strokeMiterlimit: "10",
                        strokeWidth: "2"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M12.5 1.5L12.939 2.34904L13.559 4.16204L15.843 6.00004L19 4",
                        stroke: iconColor,
                        strokeLinecap: "square",
                        strokeLinejoin: "round",
                        strokeMiterlimit: "10",
                        strokeWidth: "2"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_2242_4156",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        fill: "white",
                        height: "24",
                        width: "24"
                    })
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-icons-virtual-412b14e947/1/packages/lib-icons/src/standard/bera-saman-icons.tsx


const BeraSamanIcons = (param)=>{
    let { size , iconColor  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        className: "byko-icon",
        fill: "none",
        height: size,
        viewBox: "0 0 24 24",
        width: size,
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M13.2 15L13.8 15.7C14.6 16.5 15.6 17 16.8 17H22",
                stroke: iconColor,
                strokeMiterlimit: "10",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M1 7H4.2C5.3 7 6.4 7.5 7.2 8.3L7.8 9",
                stroke: iconColor,
                strokeMiterlimit: "10",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M1 17H4.2C5.3 17 6.4 16.5 7.2 15.7L13.8 8.3C14.6 7.5 15.6 7 16.8 7H22",
                stroke: iconColor,
                strokeMiterlimit: "10",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M19 14L22 17L19 20",
                stroke: iconColor,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M19 10L22 7L19 4",
                stroke: iconColor,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-icons-virtual-412b14e947/1/packages/lib-icons/src/standard/drill-icons.tsx
/* eslint-disable max-len */ 

const DrillIcons = (param)=>{
    let { size , iconColor  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        className: "byko-icon",
        fill: "none",
        height: size,
        viewBox: "0 0 24 24",
        width: size,
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M20 5H23",
                stroke: iconColor,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M16 9H3C2.46957 9 1.96086 8.78929 1.58579 8.41421C1.21071 8.03914 1 7.53043 1 7V3C1 2.46957 1.21071 1.96086 1.58579 1.58579C1.96086 1.21071 2.46957 1 3 1H16L20 2V8L16 9Z",
                stroke: iconColor,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M14.283 18.755L11.138 18.305C10.8653 18.266 10.6037 18.171 10.3694 18.0261C10.1351 17.8812 9.93334 17.6895 9.77665 17.4629C9.61995 17.2364 9.51174 16.9799 9.45881 16.7096C9.40587 16.4393 9.40934 16.1609 9.469 15.892L11 9H5L3.207 17.071C3.14248 17.3613 3.01404 17.6336 2.83101 17.868C2.64799 18.1024 2.415 18.293 2.149 18.426L2.106 18.447C1.77369 18.6131 1.49419 18.8684 1.29884 19.1844C1.10349 19.5004 1.00001 19.8645 1 20.236V23H16V20.735C16 20.2536 15.8264 19.7883 15.511 19.4246C15.1956 19.0609 14.7596 18.8231 14.283 18.755V18.755Z",
                stroke: iconColor,
                strokeMiterlimit: "10",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M16 1V9",
                stroke: iconColor,
                strokeMiterlimit: "10",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M5 5H7",
                stroke: iconColor,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2"
            })
        ]
    });
};
/* harmony default export */ var drill_icons = ((/* unused pure expression or super */ null && (DrillIcons)));

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-icons-virtual-412b14e947/1/packages/lib-icons/src/standard/product-icons.tsx
/* eslint-disable max-len */ 

const ProductIcons = (param)=>{
    let { size , iconColor  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        className: "byko-icon",
        fill: "none",
        height: size,
        viewBox: "0 0 24 24",
        width: size,
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M12 11.5V22.5",
                stroke: iconColor,
                strokeMiterlimit: "10",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M3 6.5L12 11.5L21 6.5",
                stroke: iconColor,
                strokeMiterlimit: "10",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M21 17.5V6.5L12 1.5L3 6.5V17.5L12 22.5L21 17.5Z",
                stroke: iconColor,
                strokeMiterlimit: "10",
                strokeWidth: "2"
            })
        ]
    });
};
/* harmony default export */ var product_icons = ((/* unused pure expression or super */ null && (ProductIcons)));

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-icons-virtual-412b14e947/1/packages/lib-icons/src/standard/cancel-large-icons.tsx


const CancelLargeIcons = (param)=>{
    let { size , iconColor  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        className: "byko-icon",
        fill: "none",
        height: size,
        viewBox: "0 0 24 24",
        width: size,
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M19 5L5 19",
                stroke: iconColor,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M19 19L5 5",
                stroke: iconColor,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-icons-virtual-412b14e947/1/packages/lib-icons/src/standard/cancel-small-icons.tsx


const CancelSmallIcons = (param)=>{
    let { size , iconColor  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        className: "byko-icon",
        fill: "none",
        height: size,
        viewBox: "0 0 24 24",
        width: size,
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M16 8L8 16",
                stroke: iconColor,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M16 16L8 8",
                stroke: iconColor,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-icons-virtual-412b14e947/1/packages/lib-icons/src/standard/heart-icons.tsx


const HeartIcons = (param)=>{
    let { size , iconColor  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        className: "byko-icon",
        fill: "none",
        height: size,
        viewBox: "0 0 24 24",
        width: size,
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            // eslint-disable-next-line max-len
            d: "M17 1C14.9 1 13.1 2.1 12 3.7C10.9 2.1 9.1 1 7 1C3.7 1 1 3.7 1 7C1 13 12 22 12 22C12 22 23 13 23 7C23 3.7 20.3 1 17 1Z",
            stroke: iconColor,
            strokeLinecap: "square",
            strokeMiterlimit: "10",
            strokeWidth: "2"
        })
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-icons-virtual-412b14e947/1/packages/lib-icons/src/standard/download-icons.tsx


const DownloadIcons = (param)=>{
    let { size , iconColor  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        className: "byko-icon",
        fill: "none",
        height: size,
        viewBox: "0 0 24 24",
        width: size,
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M12 1V17",
                stroke: iconColor,
                strokeMiterlimit: "10",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M18 11L12 17L6 11",
                stroke: iconColor,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M22 22H2",
                stroke: iconColor,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-icons-virtual-412b14e947/1/packages/lib-icons/src/standard/calendar-icons.tsx
/* eslint-disable max-len */ 

const CalendarIcons = (param)=>{
    let { size , iconColor  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        className: "byko-icon",
        fill: "none",
        height: size,
        viewBox: "0 0 24 24",
        width: size,
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M7 12H5V13H7V12Z",
                stroke: iconColor,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M13 12H11V13H13V12Z",
                stroke: iconColor,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M7 17H5V18H7V17Z",
                stroke: iconColor,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M13 17H11V18H13V17Z",
                stroke: iconColor,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M19 12H17V13H19V12Z",
                stroke: iconColor,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M21 3H3C1.89543 3 1 3.89543 1 5V20C1 21.1046 1.89543 22 3 22H21C22.1046 22 23 21.1046 23 20V5C23 3.89543 22.1046 3 21 3Z",
                stroke: iconColor,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M6 1V4",
                stroke: iconColor,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M18 1V4",
                stroke: iconColor,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M1 8H23",
                stroke: iconColor,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-icons-virtual-412b14e947/1/packages/lib-icons/src/standard/notandi-icons.tsx
/* eslint-disable max-len */ 

const NotandiIcons = (param)=>{
    let { size , iconColor  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        fill: "none",
        height: size,
        viewBox: "0 0 24 24",
        width: size,
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M12 12C9.239 12 7 9.761 7 7V6C7 3.239 9.239 1 12 1C14.761 1 17 3.239 17 6V7C17 9.761 14.761 12 12 12Z",
                stroke: iconColor,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M22 20.908C22 19.108 20.803 17.525 19.066 17.052C17.172 16.535 14.586 16 12 16C9.414 16 6.828 16.535 4.934 17.052C3.197 17.525 2 19.108 2 20.908V23H22V20.908Z",
                stroke: iconColor,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-icons-virtual-412b14e947/1/packages/lib-icons/src/standard/menu-icons.tsx


const MenuIcons = (param)=>{
    let { size , iconColor  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        fill: "none",
        height: size,
        viewBox: "0 0 24 24",
        width: size,
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M1 12H23",
                stroke: iconColor,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M1 5H23",
                stroke: iconColor,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M12 19H23",
                stroke: iconColor,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2"
            })
        ]
    });
};
/* harmony default export */ var menu_icons = ((/* unused pure expression or super */ null && (MenuIcons)));

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-icons-virtual-412b14e947/1/packages/lib-icons/src/standard/refresh-icons.tsx


const RefreshIcons = (param)=>{
    let { size , iconColor  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        className: "byko-icon",
        fill: "none",
        height: size,
        viewBox: "0 0 24 24",
        width: size,
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M2 12C2 6.5 6.5 2 12 2C15.9 2 19.3 4.2 20.9 7.5",
                stroke: iconColor,
                strokeMiterlimit: "10",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M22 12C22 17.5 17.5 22 12 22C8.09998 22 4.69998 19.8 3.09998 16.5",
                stroke: iconColor,
                strokeMiterlimit: "10",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M21.8 1.69995L21 7.59995L15 6.79995",
                stroke: iconColor,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M2.19995 22.2999L2.99995 16.3999L8.99995 17.1999",
                stroke: iconColor,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-icons-virtual-412b14e947/1/packages/lib-icons/src/standard/mail-icons.tsx


const MailIcons = (param)=>{
    let { size , iconColor  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        fill: "none",
        height: size,
        viewBox: "0 0 24 20",
        width: size,
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                // eslint-disable-next-line max-len
                d: "M1 11V17C1 17.5304 1.21071 18.0391 1.58579 18.4142C1.96086 18.7893 2.46957 19 3 19H21C21.5304 19 22.0391 18.7893 22.4142 18.4142C22.7893 18.0391 23 17.5304 23 17V11",
                stroke: iconColor,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                // eslint-disable-next-line max-len
                d: "M23 6V3C23 2.46957 22.7893 1.96086 22.4142 1.58579C22.0391 1.21071 21.5304 1 21 1H3C2.46957 1 1.96086 1.21071 1.58579 1.58579C1.21071 1.96086 1 2.46957 1 3V6L12 12L23 6Z",
                stroke: iconColor,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2"
            })
        ]
    });
};
/* harmony default export */ var mail_icons = ((/* unused pure expression or super */ null && (MailIcons)));

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-icons-virtual-412b14e947/1/packages/lib-icons/src/standard/checkmark-icons.tsx


const CheckmarkIcons = (param)=>{
    let { size , iconColor  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        fill: "none",
        height: size,
        viewBox: "0 0 24 24",
        width: size,
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M9 21L1 13L4 10L9 15L21 3L24 6L9 21Z",
            fill: iconColor
        })
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-icons-virtual-412b14e947/1/packages/lib-icons/src/standard/chevron-icons.tsx


const ChevronIcon = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        fill: "none",
        height: "13",
        viewBox: "0 0 9 13",
        width: "9",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M1.91663 1.75L6.66663 6.5L1.91663 11.25",
            stroke: "#0A3A5C",
            strokeLinecap: "square",
            strokeMiterlimit: "10",
            strokeWidth: "2"
        })
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-icons-virtual-412b14e947/1/packages/lib-icons/src/standard/settings-icons.tsx
/* eslint-disable max-len */ 

const SettingsIcons = (param)=>{
    let { size , iconColor  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        fill: "none",
        height: size,
        viewBox: "0 0 24 24",
        width: size,
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z",
                stroke: iconColor,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M20 12C19.9988 11.4239 19.9358 10.8496 19.812 10.287L22.526 8.232L20.526 4.768L17.383 6.094C16.5319 5.3137 15.5217 4.72723 14.422 4.375L14 1H10L9.578 4.375C8.47834 4.72723 7.46814 5.3137 6.617 6.094L3.474 4.768L1.474 8.232L4.188 10.287C3.93739 11.4153 3.93739 12.5847 4.188 13.713L1.474 15.768L3.474 19.232L6.617 17.906C7.46814 18.6863 8.47834 19.2728 9.578 19.625L10 23H14L14.422 19.625C15.5217 19.2728 16.5319 18.6863 17.383 17.906L20.526 19.232L22.526 15.768L19.812 13.713C19.9358 13.1504 19.9988 12.5761 20 12V12Z",
                stroke: iconColor,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-icons-virtual-412b14e947/1/packages/lib-icons/src/standard/credit-limit-icons.tsx


const CreditLimitIcons = (param)=>{
    let { size , iconColor  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        className: "byko-icon",
        fill: "none",
        height: size,
        viewBox: "0 0 24 24",
        width: size,
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M17 11H23V22H1V11H6",
                stroke: iconColor,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M9 14H6V11L15 2L18 5L9 14Z",
                stroke: iconColor,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M6 18H18",
                stroke: iconColor,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-icons-virtual-412b14e947/1/packages/lib-icons/src/standard/info-icons.tsx


const InfoIcons = (param)=>{
    let { size , iconColor  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        fill: "none",
        height: size,
        viewBox: "0 0 24 24",
        width: size,
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                // eslint-disable-next-line max-len
                d: "M12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1C5.92487 1 1 5.92487 1 12C1 18.0751 5.92487 23 12 23Z",
                stroke: iconColor,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M12 11V18",
                stroke: iconColor,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                // eslint-disable-next-line max-len
                d: "M12 8C12.8284 8 13.5 7.32843 13.5 6.5C13.5 5.67157 12.8284 5 12 5C11.1716 5 10.5 5.67157 10.5 6.5C10.5 7.32843 11.1716 8 12 8Z",
                fill: iconColor
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-icons-virtual-412b14e947/1/packages/lib-icons/src/standard/wrench-icons.tsx
/* eslint-disable max-len */ 

const WrenchIcons = (param)=>{
    let { size , iconColor  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        fill: "none",
        height: size,
        viewBox: "0 0 24 24",
        width: size,
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                clipPath: "url(#clip0_924_5307)",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M22.6974 5.07656L23.649 4.76912L23.1476 3.21738L21.9919 4.36785L22.6974 5.07656ZM19.4629 8.29638L18.7575 9.00516L19.463 9.70732L20.1684 9.0051L19.4629 8.29638ZM15.6885 4.53975L14.9829 3.83115L14.2711 4.53993L14.983 5.24853L15.6885 4.53975ZM18.9219 1.31992L19.6275 2.02852L20.836 0.825188L19.1958 0.358153L18.9219 1.31992ZM12.6673 2.93628L11.9228 2.26865L12.6673 2.93628ZM11.4862 8.72625L12.0898 9.52354L12.7009 9.0609L12.413 8.35058L11.4862 8.72625ZM0.920898 16.725L0.317295 15.9277L-0.0791016 16.2278V16.725H0.920898ZM0.920898 23H-0.0791016V24H0.920898V23ZM7.27348 23V24H7.76983L8.06996 23.6047L7.27348 23ZM15.2586 12.4818L15.5396 11.5221L14.8786 11.3286L14.4621 11.8772L15.2586 12.4818ZM21.1228 11.2279L21.8015 11.9623L21.1228 11.2279ZM21.9919 4.36785L18.7574 7.58767L20.1684 9.0051L23.4029 5.78527L21.9919 4.36785ZM20.1684 7.5876L16.3939 3.83097L14.983 5.24853L18.7575 9.00516L20.1684 7.5876ZM16.3941 5.24835L19.6275 2.02852L18.2163 0.611324L14.9829 3.83115L16.3941 5.24835ZM10.8826 7.92897L0.317295 15.9277L1.5245 17.5223L12.0898 9.52354L10.8826 7.92897ZM8.06996 23.6047L16.0551 13.0865L14.4621 11.8772L6.477 22.3953L8.06996 23.6047ZM0.920898 24H7.27348V22H0.920898V24ZM-0.0791016 16.725V23H1.9209V16.725H-0.0791016ZM21.8015 11.9623C23.7915 10.123 24.4717 7.31555 23.649 4.76912L21.7459 5.384C22.3372 7.2143 21.8424 9.20106 20.444 10.4936L21.8015 11.9623ZM14.9776 13.4415C17.336 14.1321 19.9044 13.7158 21.8015 11.9623L20.444 10.4936C19.1309 11.7073 17.3171 12.0426 15.5396 11.5221L14.9776 13.4415ZM11.9228 2.26865C10.3633 4.0077 9.61239 6.76548 10.5595 9.10192L12.413 8.35058C11.8021 6.84363 12.2686 4.87867 13.4118 3.6039L11.9228 2.26865ZM19.1958 0.358153C16.6343 -0.371227 13.8519 0.117419 11.9228 2.26865L13.4118 3.6039C14.737 2.12603 16.6775 1.72057 18.6481 2.28169L19.1958 0.358153Z",
                    fill: iconColor
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_924_5307",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        fill: "white",
                        height: "24",
                        width: "24"
                    })
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-icons-virtual-412b14e947/1/packages/lib-icons/src/standard/wallet-small-icons.tsx


const WalletSmallIcons = (param)=>{
    let { iconColor , size  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        fill: "none",
        height: size,
        viewBox: "0 0 16 16",
        width: size,
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M9 11C10.1046 11 11 10.1046 11 9C11 7.89543 10.1046 7 9 7C7.89543 7 7 7.89543 7 9C7 10.1046 7.89543 11 9 11Z",
                fill: iconColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                // eslint-disable-next-line max-len
                d: "M2 2.73333V12.2667C2 12.7264 2.16857 13.1673 2.46863 13.4923C2.76869 13.8174 3.17565 14 3.6 14H14V4.46667H3.6C3.17565 4.46667 2.76869 4.28405 2.46863 3.95899C2.16857 3.63392 2 3.19304 2 2.73333ZM2 2.73333C2 2.27362 2.16857 1.83274 2.46863 1.50768C2.76869 1.18262 3.17565 1 3.6 1H10.8V2.73333",
                stroke: iconColor,
                strokeLinecap: "square",
                strokeWidth: "1.5"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-icons-virtual-412b14e947/1/packages/lib-icons/src/standard/wrench-small-icons.tsx


const WrenchSmallIcons = (param)=>{
    let { iconColor , size  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        fill: "none",
        height: size,
        viewBox: "0 0 16 16",
        width: size,
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            // eslint-disable-next-line max-len
            d: "M14.664 3.20267L12.6667 5.2L10.8 3.33333L12.7973 1.336C12.3297 1.12413 11.8136 1 11.2667 1C9.20493 1 7.53333 2.6716 7.53333 4.73333C7.53333 5.24853 7.63787 5.73947 7.8264 6.18653L1 11.2667V15H4.73333L9.81347 8.1736C10.2605 8.36213 10.7515 8.46667 11.2667 8.46667C13.3284 8.46667 15 6.79507 15 4.73333C15 4.1864 14.8759 3.67027 14.664 3.20267Z",
            stroke: iconColor,
            strokeLinecap: "round",
            strokeMiterlimit: "10",
            strokeWidth: "1.5"
        })
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-icons-virtual-412b14e947/1/packages/lib-icons/src/standard/credit-limit-small-icons.tsx


const CreditLimitSmallIcons = (param)=>{
    let { iconColor , size  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        fill: "none",
        height: size,
        viewBox: "0 0 16 16",
        width: size,
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                clipPath: "url(#clip0_878_6007)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M10 1L12 3L7 8L4 9L5 6L10 1Z",
                        stroke: iconColor,
                        strokeLinecap: "square",
                        strokeWidth: "1.5"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M11.5 6.5H15.5V15.5H0.5V6.5H2.5",
                        stroke: iconColor,
                        strokeLinecap: "square",
                        strokeWidth: "1.5"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M3.5 11.5H12.5",
                        stroke: iconColor,
                        strokeLinecap: "square",
                        strokeWidth: "1.5"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_878_6007",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        fill: "white",
                        height: "16",
                        width: "16"
                    })
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-icons-virtual-412b14e947/1/packages/lib-icons/src/standard/info-small-icons.tsx


const InfoSmallIcons = (param)=>{
    let { iconColor , size  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        fill: "none",
        height: size,
        viewBox: "0 0 16 16",
        width: size,
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                clipPath: "url(#clip0_878_5931)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M12.5 1.5H14V15.5H2V1.5H3.5",
                        stroke: iconColor,
                        strokeLinecap: "square",
                        strokeWidth: "1.5"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M10 0.5H6V2.5H10V0.5Z",
                        stroke: iconColor,
                        strokeLinecap: "square",
                        strokeWidth: "1.5"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M5 6H11",
                        stroke: iconColor,
                        strokeLinecap: "square",
                        strokeWidth: "1.5"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M5 9H11",
                        stroke: iconColor,
                        strokeLinecap: "square",
                        strokeWidth: "1.5"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M5 12H11",
                        stroke: iconColor,
                        strokeLinecap: "square",
                        strokeWidth: "1.5"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_878_5931",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        fill: "white",
                        height: "16",
                        width: "16"
                    })
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-icons-virtual-412b14e947/1/packages/lib-icons/src/standard/pdf-icons.tsx
/* eslint-disable max-len */ 

const PdfIcons = (param)=>{
    let { size , iconColor , ...props } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        fill: "none",
        height: size,
        viewBox: "0 0 24 24",
        width: size,
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                height: "10",
                stroke: iconColor,
                strokeWidth: "2",
                width: "18",
                x: "5",
                y: "10"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M20 10.4286V7.28571L14 1H2V23H20V20.9048",
                stroke: iconColor,
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M20 7H14V1",
                stroke: iconColor,
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M9.04861 18C9.1006 18 9.13527 17.9647 9.13527 17.9118V15.8294C9.13527 15.7941 9.1526 15.7765 9.18726 15.7765H9.47325C10.5219 15.7765 11.2065 15.2471 11.2065 13.8882C11.2065 12.5206 10.5479 12 9.47325 12H8.08666C8.03466 12 8 12.0353 8 12.0882V17.9118C8 17.9647 8.03466 18 8.08666 18H9.04861ZM9.43858 14.7618H9.18726C9.1526 14.7618 9.13527 14.7441 9.13527 14.7088V13.0676C9.13527 13.0324 9.1526 13.0147 9.18726 13.0147H9.43858C9.88056 13.0147 10.0712 13.2088 10.0712 13.8882C10.0712 14.5676 9.88056 14.7618 9.43858 14.7618Z",
                fill: iconColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M12.5714 17.9118C12.5714 17.9647 12.6061 18 12.6581 18H14.1486C14.9633 18 15.4399 17.6824 15.6566 17.0029C15.7606 16.6676 15.8125 16.2618 15.8125 15C15.8125 13.7382 15.7606 13.3324 15.6566 12.9971C15.4399 12.3176 14.9633 12 14.1486 12H12.6581C12.6061 12 12.5714 12.0353 12.5714 12.0882V17.9118ZM13.7067 16.9059V13.0941C13.7067 13.0588 13.724 13.0412 13.7587 13.0412H14.036C14.322 13.0412 14.478 13.1471 14.5646 13.4118C14.6339 13.5971 14.6599 13.8529 14.6599 15C14.6599 16.1471 14.6339 16.4029 14.5646 16.5882C14.478 16.8529 14.322 16.9588 14.036 16.9588H13.7587C13.724 16.9588 13.7067 16.9412 13.7067 16.9059Z",
                fill: iconColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M17.2528 17.9118C17.2528 17.9647 17.2875 18 17.3395 18H18.3014C18.3534 18 18.3881 17.9647 18.3881 17.9118V15.6088C18.3881 15.5735 18.4054 15.5559 18.4401 15.5559H19.714C19.766 15.5559 19.8007 15.5206 19.8007 15.4676V14.5941C19.8007 14.5412 19.766 14.5059 19.714 14.5059H18.4401C18.4054 14.5059 18.3881 14.4882 18.3881 14.4529V13.0941C18.3881 13.0588 18.4054 13.0412 18.4401 13.0412H19.9133C19.9653 13.0412 20 13.0059 20 12.9529V12.0882C20 12.0353 19.9653 12 19.9133 12H17.3395C17.2875 12 17.2528 12.0353 17.2528 12.0882V17.9118Z",
                fill: iconColor
            })
        ]
    });
};
/* harmony default export */ var pdf_icons = ((/* unused pure expression or super */ null && (PdfIcons)));

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-icons-virtual-412b14e947/1/packages/lib-icons/src/standard/xls-icons.tsx
/* eslint-disable max-len */ 

const XlsIcons = (param)=>{
    let { size , iconColor , ...props } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        fill: "none",
        height: size,
        viewBox: "0 0 24 24",
        width: size,
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M12.2771 17.9226C12.3423 17.9226 12.3858 17.8883 12.364 17.8367L10.9185 14.8797L12.2445 12.1633C12.2662 12.1117 12.2227 12.0774 12.1575 12.0774H10.9402C10.875 12.0774 10.8424 12.1117 10.8207 12.1633L10.2011 13.6762H10.1794L9.55988 12.1633C9.53815 12.1117 9.50554 12.0774 9.44033 12.0774H8.21216C8.14695 12.0774 8.10347 12.1117 8.12521 12.1633L9.4512 14.8797L8.00565 17.8367C7.98392 17.8883 8.02739 17.9226 8.0926 17.9226H9.3099C9.37512 17.9226 9.41859 17.8883 9.44033 17.8367L10.1794 16.1777H10.2011L10.9293 17.8367C10.9511 17.8883 10.9837 17.9226 11.0489 17.9226H12.2771Z",
                fill: iconColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M13.3319 17.8367C13.3319 17.8883 13.3754 17.9226 13.4406 17.9226H16.0111C16.0763 17.9226 16.1198 17.8883 16.1198 17.8367V16.9943C16.1198 16.9427 16.0763 16.9083 16.0111 16.9083H14.821C14.7775 16.9083 14.7557 16.8911 14.7557 16.8567V12.1633C14.7557 12.1117 14.7123 12.0774 14.6471 12.0774H13.4406C13.3754 12.0774 13.3319 12.1117 13.3319 12.1633V17.8367Z",
                fill: iconColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M21 16.1862C21 15.1977 20.6087 14.7679 19.5979 14.4585L19.1523 14.3209C18.5763 14.1404 18.4567 14.0029 18.4567 13.5645C18.4567 13.1691 18.6415 12.9799 19.0219 12.9799C19.4132 12.9799 19.5979 13.1948 19.6088 13.616C19.6088 13.6676 19.6631 13.6934 19.7284 13.6848L20.837 13.5473C20.9022 13.5387 20.9348 13.5043 20.9348 13.4527C20.8804 12.533 20.2718 12 18.9784 12C17.6633 12 17.022 12.5673 17.022 13.6246C17.022 14.5616 17.3807 15 18.4241 15.3181L18.8697 15.4556C19.424 15.6275 19.5545 15.808 19.5545 16.3238C19.5545 16.8567 19.3697 17.0201 18.9675 17.0201C18.5437 17.0201 18.348 16.8052 18.3263 16.2636C18.3263 16.212 18.2828 16.1862 18.2067 16.1948L17.0438 16.341C16.9786 16.3496 16.9568 16.384 16.9568 16.4355C16.9786 17.4413 17.6198 18 18.9567 18C20.424 18 21 17.3811 21 16.1862Z",
                fill: iconColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                height: "10",
                stroke: iconColor,
                strokeWidth: "2",
                width: "18",
                x: "5",
                y: "10"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M20 10.4286V7.28571L14 1H2V23H20V20.9048",
                stroke: iconColor,
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M20 7H14V1",
                stroke: iconColor,
                strokeWidth: "2"
            })
        ]
    });
};
/* harmony default export */ var xls_icons = ((/* unused pure expression or super */ null && (XlsIcons)));

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-icons-virtual-412b14e947/1/packages/lib-icons/src/standard/key-icons.tsx


const KeyIcons = (param)=>{
    let { size , iconColor  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        fill: "none",
        height: size,
        viewBox: "0 0 16 16",
        width: size,
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                // eslint-disable-next-line max-len
                d: "M5.20005 12.2C5.97325 12.2 6.60005 11.5732 6.60005 10.8C6.60005 10.0268 5.97325 9.40002 5.20005 9.40002C4.42685 9.40002 3.80005 10.0268 3.80005 10.8C3.80005 11.5732 4.42685 12.2 5.20005 12.2Z",
                stroke: iconColor,
                strokeLinecap: "round",
                strokeMiterlimit: "10",
                strokeWidth: "1.5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                // eslint-disable-next-line max-len
                d: "M15 1H12.2L6.404 6.796C6.0204 6.6812 5.62093 6.6 5.2 6.6C2.88067 6.6 1 8.48067 1 10.8C1 13.1193 2.88067 15 5.2 15C7.51933 15 9.4 13.1193 9.4 10.8C9.4 10.3791 9.3188 9.9796 9.204 9.596L11.2667 7.53333V4.73333H14.0667L15 3.8V1Z",
                stroke: iconColor,
                strokeLinecap: "round",
                strokeMiterlimit: "10",
                strokeWidth: "1.5"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-icons-virtual-412b14e947/1/packages/lib-icons/src/standard/info-filled-icons.tsx


const InfoFilledIcons = (param)=>{
    let { size , iconColor  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        fill: "none",
        height: size,
        viewBox: "0 0 24 24",
        width: size,
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            // eslint-disable-next-line max-len
            d: "M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM13 17H11V11H13V17ZM13 9H11V7H13V9Z",
            fill: iconColor
        })
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-icons-virtual-412b14e947/1/packages/lib-icons/src/standard/add-icons.tsx


const AddIcons = (param)=>{
    let { size , iconColor ="#0A3A5C"  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        fill: "none",
        height: size,
        viewBox: "0 0 24 24",
        width: size,
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M18 11H13V6H11V11H6V13H11V18H13V13H18V11Z",
            fill: iconColor
        })
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-icons-virtual-412b14e947/1/packages/lib-icons/src/standard/dots-icons.tsx


const DotsIcons = (param)=>{
    let { size , iconColor  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        fill: "none",
        height: size,
        viewBox: "0 0 24 24",
        width: size,
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                // eslint-disable-next-line max-len
                d: "M12 14C13.1046 14 14 13.1046 14 12C14 10.8954 13.1046 10 12 10C10.8954 10 10 10.8954 10 12C10 13.1046 10.8954 14 12 14Z",
                fill: iconColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                // eslint-disable-next-line max-len
                d: "M4 14C5.10457 14 6 13.1046 6 12C6 10.8954 5.10457 10 4 10C2.89543 10 2 10.8954 2 12C2 13.1046 2.89543 14 4 14Z",
                fill: iconColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                // eslint-disable-next-line max-len
                d: "M20 14C21.1046 14 22 13.1046 22 12C22 10.8954 21.1046 10 20 10C18.8954 10 18 10.8954 18 12C18 13.1046 18.8954 14 20 14Z",
                fill: iconColor
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-icons-virtual-412b14e947/1/packages/lib-icons/src/standard/calendar-checkmark-icons.tsx


const CalendarCheckmarkIcons = (param)=>{
    let { size , iconColor  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        fill: "none",
        height: size,
        viewBox: "0 0 24 24",
        width: size,
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M9 15L11 17L16 12",
                stroke: iconColor,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                // eslint-disable-next-line max-len
                d: "M21 3H3C1.89543 3 1 3.89543 1 5V20C1 21.1046 1.89543 22 3 22H21C22.1046 22 23 21.1046 23 20V5C23 3.89543 22.1046 3 21 3Z",
                stroke: iconColor,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M6 1V4",
                stroke: iconColor,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M18 1V4",
                stroke: iconColor,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M1 8H23",
                stroke: iconColor,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-icons-virtual-412b14e947/1/packages/lib-icons/src/standard/window-icons.tsx


const WindowIcons = (param)=>{
    let { size , iconColor  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        fill: "none",
        height: size,
        viewBox: "0 0 24 24",
        width: size,
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M12 2V23",
                stroke: iconColor,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M3 17H21",
                stroke: iconColor,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M3.05603 11H20.944",
                stroke: iconColor,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M5 5L12.0077 11L19 5.01312",
                stroke: iconColor,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                // eslint-disable-next-line max-len
                d: "M21 10C21 7.61305 20.0518 5.32387 18.364 3.63604C16.6761 1.94821 14.3869 1 12 1C9.61305 1 7.32387 1.94821 5.63604 3.63604C3.94821 5.32387 3 7.61305 3 10V23H21V10Z",
                stroke: iconColor,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-icons-virtual-412b14e947/1/packages/lib-icons/src/standard/lawnmower-icons.tsx


const LawnmowerIcons = (param)=>{
    let { size , iconColor  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        fill: "none",
        height: size,
        viewBox: "0 0 24 24",
        width: size,
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M1 1H5L7.939 9.603",
                stroke: iconColor,
                strokeMiterlimit: "10",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M8.89099 20H17",
                stroke: iconColor,
                strokeMiterlimit: "10",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                // eslint-disable-next-line max-len
                d: "M20 14V13.709C20.0001 13.2326 19.8301 12.7717 19.5207 12.4095C19.2112 12.0472 18.7826 11.8073 18.312 11.733L7.939 9.60002C7.58309 9.52697 7.21538 9.53409 6.86256 9.62087C6.50974 9.70765 6.18068 9.8719 5.89926 10.1017C5.61784 10.3315 5.39112 10.6211 5.23558 10.9495C5.08003 11.2778 4.99956 11.6367 5 12V12",
                stroke: iconColor,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                // eslint-disable-next-line max-len
                d: "M5 23C7.20914 23 9 21.2091 9 19C9 16.7909 7.20914 15 5 15C2.79086 15 1 16.7909 1 19C1 21.2091 2.79086 23 5 23Z",
                stroke: iconColor,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                // eslint-disable-next-line max-len
                d: "M20 23C21.6569 23 23 21.6569 23 20C23 18.3431 21.6569 17 20 17C18.3431 17 17 18.3431 17 20C17 21.6569 18.3431 23 20 23Z",
                stroke: iconColor,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-icons-virtual-412b14e947/1/packages/lib-icons/src/standard/receipt-two-icons.tsx


const ReceiptTwoIcons = (param)=>{
    let { size , iconColor  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        fill: "none",
        height: size,
        viewBox: "0 0 24 24",
        width: size,
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M1 20V23H13V20.417C13 19.036 14.119 18 15.5 18H3C1.895 18 1 18.895 1 20Z",
                stroke: iconColor,
                strokeMiterlimit: "10",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M15.5 18C16.794 18 18 18.924 18 20.5C18 21.881 19.119 23 20.5 23C21.881 23 23 21.881 23 20.5V1H7V18",
                stroke: iconColor,
                strokeMiterlimit: "10",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M12 7H18",
                stroke: iconColor,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M12 12H18",
                stroke: iconColor,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-icons-virtual-412b14e947/1/packages/lib-icons/src/standard/save-icons.tsx


const SaveIcons = (param)=>{
    let { size , iconColor  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        fill: "none",
        height: size,
        viewBox: "0 0 24 24",
        width: size,
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M6 22V14H18V22",
                stroke: iconColor,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M16.9999 1.00005H2V23H21.9999V7L16.9999 1.00005Z",
                stroke: iconColor,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                height: "5",
                stroke: iconColor,
                strokeWidth: "2",
                width: "10",
                x: "6",
                y: "6"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-icons-virtual-412b14e947/1/packages/lib-icons/src/standard/eye-open-icons.tsx


const EyeOpenIcons = (param)=>{
    let { size , iconColor  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        fill: "none",
        height: size,
        viewBox: "0 0 24 24",
        width: size,
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                clipPath: "url(#clip0_955_5311)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        // eslint-disable-next-line max-len
                        d: "M1 12C2.99969 8.5 5.99985 5 12 5C18.0002 5 21.0002 8.5 23 12C21.0002 16.375 17.0001 19 12 19C6.99988 19 2.99969 16.375 1 12Z",
                        stroke: iconColor,
                        strokeLinecap: "square",
                        strokeMiterlimit: "10",
                        strokeWidth: "2"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        // eslint-disable-next-line max-len
                        d: "M12 16C14.2091 16 16 14.2091 16 12C16 9.79086 14.2091 8 12 8C9.79086 8 8 9.79086 8 12C8 14.2091 9.79086 16 12 16Z",
                        stroke: iconColor,
                        strokeLinecap: "square",
                        strokeMiterlimit: "10",
                        strokeWidth: "2"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_955_5311",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        fill: "white",
                        height: "24",
                        width: "24"
                    })
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-icons-virtual-412b14e947/1/packages/lib-icons/src/standard/info-one-filled.tsx


const InfoOneFilledIcons = (param)=>{
    let { size , iconColor  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        fill: "none",
        height: size,
        viewBox: "0 0 24 24",
        width: size,
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            // eslint-disable-next-line max-len
            d: "M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM13 17H11V11H13V17ZM13 9H11V7H13V9Z",
            fill: iconColor
        })
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-icons-virtual-412b14e947/1/packages/lib-icons/src/standard/send-mail-icons.tsx


const SendMailIcons = (param)=>{
    let { size , iconColor  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        fill: "none",
        height: size,
        viewBox: "0 0 24 24",
        width: size,
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                clipPath: "url(#clip0_716_4188)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M22 2L10 14",
                        stroke: iconColor,
                        strokeMiterlimit: "10",
                        strokeWidth: "2"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M22 2L15 22L10 14L2 9L22 2Z",
                        stroke: iconColor,
                        strokeLinecap: "square",
                        strokeMiterlimit: "10",
                        strokeWidth: "2"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_716_4188",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        fill: "white",
                        height: "24",
                        width: "24"
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var send_mail_icons = ((/* unused pure expression or super */ null && (SendMailIcons)));

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-icons-virtual-412b14e947/1/packages/lib-icons/src/standard/house-icons.tsx


const HouseIcons = (param)=>{
    let { size , iconColor  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        fill: "none",
        height: size,
        viewBox: "0 0 24 24",
        width: size,
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M1 11L12 2L23 11",
                stroke: iconColor,
                strokeMiterlimit: "10",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M10 23V17H14V23",
                stroke: iconColor,
                strokeMiterlimit: "10",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M4 13V23H10M20 13V23H14",
                stroke: iconColor,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-icons-virtual-412b14e947/1/packages/lib-icons/src/standard/calculator-icons.tsx


const CalculatorIcons = (param)=>{
    let { size , iconColor  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        fill: "none",
        height: size,
        viewBox: "0 0 24 24",
        width: size,
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M22 1H3V23H22V1Z",
                stroke: iconColor,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M18 5H7V10H18V5Z",
                stroke: iconColor,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M7 14H8",
                stroke: iconColor,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M12 14H13",
                stroke: iconColor,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M7 18H8",
                stroke: iconColor,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M12 18H13",
                stroke: iconColor,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M17 14H18",
                stroke: iconColor,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M17 18H18",
                stroke: iconColor,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2"
            })
        ]
    });
};
/* harmony default export */ var calculator_icons = ((/* unused pure expression or super */ null && (CalculatorIcons)));

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-icons-virtual-412b14e947/1/packages/lib-icons/src/standard/mushroom-icons.tsx


const MushroomIcons = (param)=>{
    let { size , iconColor  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        fill: "none",
        height: size,
        viewBox: "0 0 24 24",
        width: size,
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                // eslint-disable-next-line max-len
                d: "M6.89722 13.5135L5.95685 18.2154C5.46179 20.6906 7.35498 22.9999 9.87915 22.9999H14.1207C16.6449 22.9999 18.5381 20.6906 18.043 18.2155L17.105 13.5252",
                stroke: iconColor,
                strokeMiterlimit: "10",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                // eslint-disable-next-line max-len
                d: "M13.3743 1.11389C13.1364 1.69659 13 2.33179 13 3C13 5.76141 15.2386 8 18 8C19.405 8 20.6702 7.41644 21.5786 6.48334",
                stroke: iconColor,
                strokeMiterlimit: "10",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                // eslint-disable-next-line max-len
                d: "M8.5 11C9.88071 11 11 9.88071 11 8.5C11 7.11929 9.88071 6 8.5 6C7.11929 6 6 7.11929 6 8.5C6 9.88071 7.11929 11 8.5 11Z",
                stroke: iconColor,
                strokeMiterlimit: "10",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                // eslint-disable-next-line max-len
                d: "M1 10C1 7.0625 5.92487 1 12 1C18.0751 1 23 7.0625 23 10C23 12.125 18.0751 14 12 14C5.92487 14 1 12.0625 1 10Z",
                stroke: iconColor,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2"
            })
        ]
    });
};
/* harmony default export */ var mushroom_icons = ((/* unused pure expression or super */ null && (MushroomIcons)));

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-icons-virtual-412b14e947/1/packages/lib-icons/src/standard/add-user-icons.tsx


const AddUserIcons = (param)=>{
    let { size , iconColor  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        className: "byko-icon",
        fill: "none",
        height: size,
        viewBox: "0 0 24 24",
        width: size,
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M13 16H8C4.5 16 1 19.1337 1 23C1 23 22.958 23 23 23",
                stroke: iconColor,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M20 13V19",
                stroke: iconColor,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M17 16H23",
                stroke: iconColor,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "12.5",
                cy: "7.5",
                r: "5.5",
                stroke: iconColor,
                strokeWidth: "2"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-icons-virtual-412b14e947/1/packages/lib-icons/src/standard/eye-closed-icons.tsx


const EyeClosedIcons = (param)=>{
    let { size =18 , iconColor  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        fill: "none",
        height: size,
        viewBox: "0 0 24 24",
        width: size,
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                clipPath: "url(#clip0_955_5309)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M2 22L22 2",
                        stroke: iconColor,
                        strokeLinecap: "square",
                        strokeMiterlimit: "10",
                        strokeWidth: "2"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        // eslint-disable-next-line max-len
                        d: "M1 12C2.99969 8.5 5.99985 5 12 5C18.0002 5 21.0002 8.5 23 12C21.0002 16.375 17.0001 19 12 19C6.99988 19 2.99969 16.375 1 12Z",
                        stroke: iconColor,
                        strokeLinecap: "square",
                        strokeMiterlimit: "10",
                        strokeWidth: "2"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        // eslint-disable-next-line max-len
                        d: "M12 16C14.2091 16 16 14.2091 16 12C16 9.79086 14.2091 8 12 8C9.79086 8 8 9.79086 8 12C8 14.2091 9.79086 16 12 16Z",
                        stroke: iconColor,
                        strokeLinecap: "square",
                        strokeMiterlimit: "10",
                        strokeWidth: "2"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_955_5309",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        fill: "white",
                        height: "24",
                        width: "24"
                    })
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-icons-virtual-412b14e947/1/packages/lib-icons/src/standard/facebook-icons.tsx
/* eslint-disable max-len */ 

const FacebookIcons = (param)=>{
    let { size , iconColor  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        className: "byko-icon",
        fill: "none",
        height: size,
        viewBox: "0 0 24 24",
        width: size,
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                clipPath: "url(#clip0_751_4392)",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M24 12.072C23.9997 9.77878 23.3424 7.53367 22.1058 5.60245C20.8692 3.67123 19.1051 2.13478 17.0225 1.17498C14.9398 0.215189 12.6257 -0.127747 10.3542 0.186774C8.08263 0.501294 5.94878 1.4601 4.20524 2.94968C2.4617 4.43926 1.18149 6.39723 0.516158 8.59179C-0.149172 10.7864 -0.171753 13.1256 0.451088 15.3326C1.07393 17.5396 2.31611 19.5219 4.03057 21.0449C5.74503 22.5679 7.85996 23.5677 10.125 23.926V15.541H7.078V12.072H10.125V9.42798C10.125 6.42098 11.917 4.75898 14.657 4.75898C15.5571 4.77189 16.4552 4.8501 17.344 4.99298V7.94698H15.83C15.3742 7.88648 14.9131 8.00946 14.548 8.28887C14.1829 8.56828 13.9437 8.98125 13.883 9.43698C13.8658 9.5646 13.8632 9.69376 13.875 9.82198V12.072H17.2L16.668 15.541H13.868V23.926C16.692 23.4809 19.2644 22.0423 21.1219 19.8691C22.9795 17.6959 24.0001 14.9309 24 12.072Z",
                    fill: iconColor
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_751_4392",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        fill: "white",
                        height: "24",
                        width: "24"
                    })
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-icons-virtual-412b14e947/1/packages/lib-icons/src/standard/instagram-icons.tsx
/* eslint-disable max-len */ 

const InstagramIcons = (param)=>{
    let { size , iconColor  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        fill: "none",
        height: size,
        viewBox: "0 0 24 24",
        width: size,
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            clipRule: "evenodd",
            d: "M1 4C1 2.34315 2.34315 1 4 1H20C21.6569 1 23 2.34315 23 4V20C23 21.6569 21.6569 23 20 23H4C2.34315 23 1 21.6569 1 20V4ZM17.5 12C17.5 15.0376 15.0376 17.5 12 17.5C8.96243 17.5 6.5 15.0376 6.5 12C6.5 8.96243 8.96243 6.5 12 6.5C15.0376 6.5 17.5 8.96243 17.5 12ZM19.15 6.5C20.0613 6.5 20.8 5.76127 20.8 4.85C20.8 3.93873 20.0613 3.2 19.15 3.2C18.2387 3.2 17.5 3.93873 17.5 4.85C17.5 5.76127 18.2387 6.5 19.15 6.5Z",
            fill: iconColor,
            fillRule: "evenodd"
        })
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-icons-virtual-412b14e947/1/packages/lib-icons/src/standard/youtube-icons.tsx


const YoutubeIcons = (param)=>{
    let { size , iconColor  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        fill: "none",
        height: size,
        viewBox: "0 0 24 24",
        width: size,
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            // eslint-disable-next-line max-len
            d: "M23.8 7.19998C23.8 7.19998 23.6 5.49998 22.8 4.79998C21.9 3.79998 20.9 3.79998 20.4 3.79998C17 3.59998 12 3.59998 12 3.59998C12 3.59998 7 3.59998 3.6 3.79998C3.1 3.89998 2.1 3.89998 1.2 4.79998C0.5 5.49998 0.2 7.19998 0.2 7.19998C0.2 7.19998 0 9.09998 0 11.1V12.9C0 14.8 0.2 16.8 0.2 16.8C0.2 16.8 0.4 18.5 1.2 19.2C2.1 20.2 3.3 20.1 3.8 20.2C5.7 20.4 12 20.4 12 20.4C12 20.4 17 20.4 20.4 20.1C20.9 20 21.9 20 22.8 19.1C23.5 18.4 23.8 16.7 23.8 16.7C23.8 16.7 24 14.8 24 12.8V11C24 9.09998 23.8 7.19998 23.8 7.19998ZM9.5 15.1V8.39998L16 11.8L9.5 15.1Z",
            fill: iconColor
        })
    });
};
/* harmony default export */ var youtube_icons = ((/* unused pure expression or super */ null && (YoutubeIcons)));

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-icons-virtual-412b14e947/1/packages/lib-icons/src/standard/paintbrush-icons.tsx


const PaintbrushIcons = (param)=>{
    let { size , iconColor  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        fill: "none",
        height: size,
        viewBox: "0 0 24 24",
        width: size,
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                clipPath: "url(#clip0_805_5142)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M15.021 18.879L22.092 11.808L19.971 9.68596H17.142V6.85796L12.192 1.90796L5.12097 8.97896",
                        stroke: iconColor,
                        strokeMiterlimit: "10",
                        strokeWidth: "2"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        // eslint-disable-next-line max-len
                        d: "M4.41402 9.686C3.21202 10.888 3.21202 12.727 4.41402 13.929L5.82802 15.343L1.65602 19.515C0.949021 20.222 0.807021 21.353 1.37302 22.202C2.15102 23.263 3.56502 23.263 4.41402 22.414L8.65702 18.171L10.071 19.585C11.273 20.787 13.112 20.787 14.314 19.585L15.021 18.878L5.12102 8.979L4.41402 9.686Z",
                        stroke: iconColor,
                        strokeLinecap: "square",
                        strokeMiterlimit: "10",
                        strokeWidth: "2"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_805_5142",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        fill: "white",
                        height: "24",
                        width: "24"
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var paintbrush_icons = ((/* unused pure expression or super */ null && (PaintbrushIcons)));

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-icons-virtual-412b14e947/1/packages/lib-icons/src/standard/like-thumbs-up-icons.tsx


const LikeThumbsUpIcons = (param)=>{
    let { size , iconColor  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        fill: "none",
        height: size,
        viewBox: "0 0 24 24",
        width: size,
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                // eslint-disable-next-line max-len
                d: "M8 22H18.229C18.6568 22.0001 19.0734 21.8622 19.4175 21.6067C19.7616 21.3512 20.0152 20.9915 20.141 20.5803L22.91 11.602C23.002 11.3014 23.0225 10.9833 22.97 10.6732C22.9175 10.3632 22.7934 10.0698 22.6076 9.81678C22.4218 9.56372 22.1796 9.35799 21.9004 9.21614C21.6212 9.07428 21.3128 9.00025 21 9H14V5C14 2.61412 12.749 1.39478 11.236 1.02679C11.0884 0.991934 10.9348 0.99108 10.7868 1.02429C10.6389 1.05751 10.5002 1.12392 10.3814 1.21859C10.2625 1.31325 10.1665 1.4337 10.1004 1.57094C10.0344 1.70817 10.0001 1.85865 10 2.0111L9 7L6 12",
                stroke: iconColor,
                strokeMiterlimit: "10",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M6 10H1V22H6V10Z",
                stroke: iconColor,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2"
            })
        ]
    });
};
/* harmony default export */ var like_thumbs_up_icons = ((/* unused pure expression or super */ null && (LikeThumbsUpIcons)));

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-icons-virtual-412b14e947/1/packages/lib-icons/src/standard/info-square-icons.tsx
/* eslint-disable max-len */ 

const InfoSquareIcons = (param)=>{
    let { size , iconColor  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        fill: "none",
        height: size,
        viewBox: "0 0 24 24",
        width: size,
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M21 1H3V23H21V1Z",
                stroke: iconColor,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M12 11L12 19",
                stroke: iconColor,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2.5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M12 7.5C12.8284 7.5 13.5 6.82843 13.5 6C13.5 5.17157 12.8284 4.5 12 4.5C11.1716 4.5 10.5 5.17157 10.5 6C10.5 6.82843 11.1716 7.5 12 7.5Z",
                fill: iconColor
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-icons-virtual-412b14e947/1/packages/lib-icons/src/standard/attention.tsx
/* eslint-disable max-len */ 


const AttentionIcons = (param)=>{
    let { size =24 , iconColor =src/* theme.palette.blue.dark */.rS.palette.blue.dark  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        fill: "none",
        height: size,
        viewBox: "0 0 24 24",
        width: size,
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                clipPath: "url(#clip0_1432_7120)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M1.24302 18.953L10.152 2.11098C10.33 1.77464 10.5963 1.49318 10.9222 1.29687C11.2482 1.10056 11.6215 0.996826 12.002 0.996826C12.3825 0.996826 12.7559 1.10056 13.0818 1.29687C13.4078 1.49318 13.6741 1.77464 13.852 2.11098L22.761 18.953C22.9282 19.2708 23.0103 19.6265 22.9991 19.9855C22.988 20.3445 22.8841 20.6944 22.6975 21.0013C22.5109 21.3081 22.2479 21.5614 21.9343 21.7364C21.6207 21.9114 21.2672 22.0022 20.908 22H3.09202C2.73323 22.0015 2.38014 21.9102 2.06709 21.7349C1.75404 21.5596 1.49169 21.3063 1.30555 20.9995C1.11942 20.6928 1.01583 20.3431 1.00488 19.9845C0.993918 19.6259 1.07596 19.2705 1.24302 18.953V18.953Z",
                        stroke: iconColor,
                        strokeLinecap: "square",
                        strokeMiterlimit: "10",
                        strokeWidth: "2"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M12 8V14",
                        stroke: iconColor,
                        strokeLinecap: "square",
                        strokeMiterlimit: "10",
                        strokeWidth: "2"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M12 19C12.8284 19 13.5 18.3284 13.5 17.5C13.5 16.6716 12.8284 16 12 16C11.1716 16 10.5 16.6716 10.5 17.5C10.5 18.3284 11.1716 19 12 19Z",
                        fill: iconColor
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_1432_7120",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        fill: "white",
                        height: size,
                        width: size
                    })
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-icons-virtual-412b14e947/1/packages/lib-icons/src/standard/subtract-icons.tsx


const SubtractIcons = (param)=>{
    let { size , iconColor ="#0A3A5C"  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        fill: "none",
        height: size,
        viewBox: "0 0 24 24",
        width: size,
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M18 11H6V13H18V11Z",
            fill: iconColor
        })
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-icons-virtual-412b14e947/1/packages/lib-icons/src/standard/remove-user-icons.tsx


const RemoveUserIcons = (param)=>{
    let { size , iconColor  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        fill: "none",
        height: size,
        viewBox: "0 0 24 24",
        width: size,
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                clipPath: "url(#clip0_1363_7065)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M13.5 16H9C5.5 16 2 19.1337 2 23C2 23 23.958 23 24 23",
                        stroke: iconColor,
                        strokeLinecap: "square",
                        strokeMiterlimit: "10",
                        strokeWidth: "2"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M18 16L23 16",
                        stroke: iconColor,
                        strokeLinecap: "square",
                        strokeMiterlimit: "10",
                        strokeWidth: "2"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                        cx: "12.5",
                        cy: "7.5",
                        r: "5.5",
                        stroke: iconColor,
                        strokeWidth: "2"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_1363_7065",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        fill: "white",
                        height: "24",
                        width: "24"
                    })
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-icons-virtual-412b14e947/1/packages/lib-icons/src/standard/bag-add-icons.tsx


const BagAddIcons = (param)=>{
    let { size , iconColor ="#0A3A5C"  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        fill: "none",
        height: size,
        viewBox: "0 0 24 24",
        width: size,
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M13 23H2V6H20V13",
                stroke: iconColor,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M7 9V5C7 2.791 8.791 1 11 1C13.209 1 15 2.791 15 5V9",
                stroke: iconColor,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M19 17V23",
                stroke: iconColor,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M16 20H22",
                stroke: iconColor,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-icons-virtual-412b14e947/1/packages/lib-icons/src/standard/advice-icon.tsx


const AdviceIcons = (param)=>{
    let { size , iconColor  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        fill: "none",
        height: size,
        viewBox: "0 0 24 23",
        width: size,
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M1 1H23V16H13L6 21V16H1V1Z",
            stroke: iconColor,
            strokeLinecap: "square",
            strokeMiterlimit: "10",
            strokeWidth: "2"
        })
    });
};
/* harmony default export */ var advice_icon = ((/* unused pure expression or super */ null && (AdviceIcons)));

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-icons-virtual-412b14e947/1/packages/lib-icons/src/standard/instagram-line-icons.tsx
/* eslint-disable max-len */ 

const InstagramLineIcons = (param)=>{
    let { size , iconColor  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        fill: "none",
        height: size,
        viewBox: "0 0 25 24",
        width: size,
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M12.5 2.98176C15.437 2.98176 15.785 2.99276 16.945 3.04576C17.6424 3.05388 18.3332 3.18209 18.987 3.42476C19.465 3.60086 19.8973 3.88212 20.252 4.24776C20.6176 4.60245 20.8989 5.03476 21.075 5.51276C21.3177 6.16661 21.4459 6.85737 21.454 7.55476C21.507 8.71476 21.518 9.06276 21.518 11.9998C21.518 14.9368 21.507 15.2848 21.454 16.4448C21.4459 17.1421 21.3177 17.8329 21.075 18.4868C20.8919 18.9612 20.6116 19.3921 20.252 19.7517C19.8924 20.1113 19.4615 20.3917 18.987 20.5748C18.3332 20.8174 17.6424 20.9456 16.945 20.9538C15.785 21.0068 15.437 21.0178 12.5 21.0178C9.563 21.0178 9.215 21.0068 8.055 20.9538C7.35762 20.9456 6.66685 20.8174 6.013 20.5748C5.535 20.3987 5.10269 20.1174 4.748 19.7518C4.38237 19.3971 4.10111 18.9648 3.925 18.4868C3.68233 17.8329 3.55412 17.1421 3.546 16.4448C3.493 15.2848 3.482 14.9368 3.482 11.9998C3.482 9.06276 3.493 8.71476 3.546 7.55476C3.55412 6.85737 3.68233 6.16661 3.925 5.51276C4.10111 5.03476 4.38237 4.60245 4.748 4.24776C5.10269 3.88212 5.535 3.60086 6.013 3.42476C6.66685 3.18209 7.35762 3.05388 8.055 3.04576C9.215 2.99276 9.563 2.98176 12.5 2.98176ZM12.5 0.999756C9.513 0.999756 9.138 1.01276 7.965 1.06576C7.05258 1.08461 6.1499 1.25737 5.295 1.57676C4.56355 1.85993 3.8994 2.29294 3.34521 2.84799C2.79102 3.40305 2.35904 4.06786 2.077 4.79976C1.75762 5.65466 1.58486 6.55734 1.566 7.46976C1.513 8.63776 1.5 9.01276 1.5 11.9998C1.5 14.9868 1.513 15.3618 1.566 16.5348C1.58486 17.4472 1.75762 18.3499 2.077 19.2048C2.36017 19.9362 2.79319 20.6004 3.34824 21.1545C3.90329 21.7087 4.56811 22.1407 5.3 22.4228C6.1549 22.7421 7.05758 22.9149 7.97 22.9338C9.138 22.9868 9.513 22.9998 12.5 22.9998C15.487 22.9998 15.862 22.9868 17.035 22.9338C17.9474 22.9149 18.8501 22.7421 19.705 22.4228C20.4365 22.1396 21.1006 21.7066 21.6548 21.1515C22.209 20.5965 22.641 19.9316 22.923 19.1998C23.2424 18.3449 23.4151 17.4422 23.434 16.5298C23.487 15.3618 23.5 14.9868 23.5 11.9998C23.5 9.01276 23.487 8.63776 23.434 7.46476C23.4151 6.55234 23.2424 5.64966 22.923 4.79476C22.6398 4.0633 22.2068 3.39916 21.6518 2.84497C21.0967 2.29078 20.4319 1.85879 19.7 1.57676C18.8451 1.25737 17.9424 1.08461 17.03 1.06576C15.862 1.01276 15.487 0.999756 12.5 0.999756Z",
                fill: iconColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M12.5006 6.35107C11.3833 6.35107 10.2911 6.68238 9.36215 7.3031C8.43318 7.92382 7.70913 8.80608 7.28157 9.8383C6.85401 10.8705 6.74214 12.0063 6.96011 13.1021C7.17808 14.1979 7.71609 15.2045 8.50612 15.9945C9.29615 16.7845 10.3027 17.3226 11.3985 17.5405C12.4943 17.7585 13.6301 17.6466 14.6623 17.2191C15.6946 16.7915 16.5768 16.0675 17.1975 15.1385C17.8183 14.2095 18.1496 13.1173 18.1496 12.0001C18.1496 10.5019 17.5544 9.06502 16.495 8.00563C15.4356 6.94624 13.9988 6.35107 12.5006 6.35107ZM12.5006 15.6671C11.7753 15.6671 11.0663 15.452 10.4633 15.0491C9.86025 14.6461 9.39025 14.0734 9.1127 13.4034C8.83515 12.7333 8.76253 11.996 8.90403 11.2847C9.04552 10.5733 9.39477 9.91995 9.9076 9.40711C10.4204 8.89427 11.0738 8.54503 11.7852 8.40353C12.4965 8.26204 13.2338 8.33466 13.9039 8.61221C14.5739 8.88975 15.1466 9.35976 15.5496 9.9628C15.9525 10.5658 16.1676 11.2748 16.1676 12.0001C16.1676 12.9726 15.7812 13.9053 15.0935 14.593C14.4058 15.2807 13.4731 15.6671 12.5006 15.6671Z",
                fill: iconColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M18.3708 7.44792C19.0998 7.44792 19.6908 6.85694 19.6908 6.12792C19.6908 5.39891 19.0998 4.80792 18.3708 4.80792C17.6418 4.80792 17.0508 5.39891 17.0508 6.12792C17.0508 6.85694 17.6418 7.44792 18.3708 7.44792Z",
                fill: iconColor
            })
        ]
    });
};
/* harmony default export */ var instagram_line_icons = ((/* unused pure expression or super */ null && (InstagramLineIcons)));

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-icons-virtual-412b14e947/1/packages/lib-icons/src/standard/facebook-simple-icons.tsx
/* eslint-disable max-len */ 

const FacebookSimpleIcons = (param)=>{
    let { size , iconColor  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        fill: "none",
        height: size,
        viewBox: "0 0 25 24",
        width: size,
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M9.53153 22.9998L9.5 12.9998H5.5V8.99976H9.5V6.49976C9.5 2.78836 11.7983 0.999756 15.1091 0.999756C16.6951 0.999756 18.0581 1.11783 18.4553 1.17061V5.04924L16.1591 5.05028C14.3584 5.05028 14.0098 5.9059 14.0098 7.16147V8.99976H19.25L17.25 12.9998H14.0098V22.9998H9.53153Z",
            fill: iconColor
        })
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-icons-virtual-412b14e947/1/packages/lib-icons/src/standard/heart-filled-icons.tsx
/* eslint-disable max-len */ 

const HeartFilledIcons = (param)=>{
    let { size , iconColor ="#0A3A5C"  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        fill: "none",
        height: size,
        viewBox: "0 0 24 24",
        width: size,
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M17.4545 1C15.1636 1 13.2 2.20476 12 3.95714C10.8 2.20476 8.83636 1 6.54545 1C2.94545 1 0 3.95714 0 7.57143C0 14.1429 12 24 12 24C12 24 24 14.1429 24 7.57143C24 3.95714 21.0545 1 17.4545 1Z",
            fill: iconColor
        })
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-icons-virtual-412b14e947/1/packages/lib-icons/src/standard/residence-icons.tsx
/* eslint-disable max-len */ 

const ResidenceIcons = (param)=>{
    let { size , iconColor ="#0A3A5C"  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        fill: "none",
        height: size,
        viewBox: "0 0 24 24",
        width: size,
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M18 9C18 13.938 10 22 10 22C10 22 2 13.938 2 9C2 3.938 6.134 1 10 1C13.866 1 18 3.938 18 9Z",
                stroke: iconColor,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M20 17V23",
                stroke: iconColor,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M17 20H23",
                stroke: iconColor,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M10 12C11.6569 12 13 10.6569 13 9C13 7.34315 11.6569 6 10 6C8.34315 6 7 7.34315 7 9C7 10.6569 8.34315 12 10 12Z",
                stroke: iconColor,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-icons-virtual-412b14e947/1/packages/lib-icons/src/standard/ecology-icons.tsx
/* eslint-disable max-len */ 

const EcologyIcons = (param)=>{
    let { size , iconColor ="#0A3A5C"  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        fill: "none",
        height: size,
        viewBox: "0 0 24 24",
        width: size,
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                clipPath: "url(#clip0_1881_7318)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M7.11 3L8.722 4.325L10.367 6.081L9.963 8.821L7.369 10.133L6.667 12.439L7.974 13.839L8.68 16.312L6.717 17.959L6 20",
                        stroke: iconColor,
                        strokeLinecap: "square",
                        strokeLinejoin: "round",
                        strokeMiterlimit: "10",
                        strokeWidth: "2"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M23 8C22.3038 8.93503 21.3987 9.69446 20.357 10.2177C19.3153 10.741 18.1658 11.0137 17 11.014C15.9391 11.014 14.9217 11.4354 14.1716 12.1856C13.4214 12.9357 13 13.9531 13 15.014C13 16.0749 13.4214 17.0923 14.1716 17.8424C14.9217 18.5926 15.9391 19.014 17 19.014C18.5913 19.014 20.1174 18.3819 21.2426 17.2566C22.3679 16.1314 23 14.6053 23 13.014V8Z",
                        stroke: iconColor,
                        strokeLinecap: "square",
                        strokeLinejoin: "round",
                        strokeMiterlimit: "10",
                        strokeWidth: "2"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M16.757 15.771C16.1992 16.3277 15.7569 16.9891 15.4553 17.7173C15.1538 18.4454 14.9991 19.2259 15 20.014C15 20.8096 14.6839 21.5727 14.1213 22.1353C13.5587 22.6979 12.7956 23.014 12 23.014",
                        stroke: iconColor,
                        strokeLinecap: "square",
                        strokeMiterlimit: "10",
                        strokeWidth: "2"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M7.63787 23.1742L8.56999 23.5363L9.29426 21.672L8.36214 21.3099L7.63787 23.1742ZM20 4.47304L20.743 3.8037L20.7362 3.79624L20.7294 3.78892L20 4.47304ZM19.5454 5.46221L20.1945 6.22285L21.7158 4.92451L21.0666 4.16387L19.5454 5.46221ZM8.36214 21.3099C6.96341 20.7665 5.705 19.9151 4.6803 18.8189L3.21922 20.1846C4.44898 21.5002 5.95922 22.522 7.63787 23.1742L8.36214 21.3099ZM4.6803 18.8189C3.65559 17.7226 2.8909 16.4097 2.44297 14.9775L0.534152 15.5746C1.07173 17.2933 1.98945 18.869 3.21922 20.1846L4.6803 18.8189ZM2.44297 14.9775C1.99503 13.5454 1.87534 12.0307 2.0928 10.546L0.113908 10.2562C-0.147061 12.038 -0.00342667 13.8558 0.534152 15.5746L2.44297 14.9775ZM2.0928 10.546C2.31025 9.06125 2.85925 7.64454 3.69907 6.40098L2.04163 5.28165C1.03375 6.77408 0.374877 8.4743 0.113908 10.2562L2.0928 10.546ZM3.69907 6.40098C4.53889 5.15742 5.64796 4.11893 6.94399 3.36259L5.93592 1.63522C4.38054 2.54292 3.04952 3.78923 2.04163 5.28165L3.69907 6.40098ZM6.94399 3.36259C8.24002 2.60625 9.68973 2.15146 11.1855 2.03198L11.0263 0.038327C9.23114 0.18172 7.49131 0.727519 5.93592 1.63522L6.94399 3.36259ZM11.1855 2.03198C12.6814 1.91249 14.1849 2.13138 15.5845 2.6724L16.3056 0.806915C14.6259 0.157628 12.8215 -0.105066 11.0263 0.038327L11.1855 2.03198ZM15.5845 2.6724C16.9842 3.21342 18.2441 4.06268 19.2706 5.15716L20.7294 3.78892C19.4974 2.47541 17.9854 1.4562 16.3056 0.806915L15.5845 2.6724ZM19.257 5.14237C19.3808 5.2797 19.4568 5.35848 19.5454 5.46221L21.0666 4.16387C20.9572 4.0356 20.8192 3.88838 20.743 3.8037L19.257 5.14237Z",
                        stroke: iconColor
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M12.5 1.5L12.939 2.34904L13.559 4.16204L15.843 6.00004L19 4",
                        stroke: iconColor,
                        strokeLinecap: "square",
                        strokeLinejoin: "round",
                        strokeMiterlimit: "10",
                        strokeWidth: "2"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_1881_7318",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        fill: "white",
                        height: size,
                        width: size
                    })
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-icons-virtual-412b14e947/1/packages/lib-icons/src/standard/fence-icons.tsx


const FenceIcons = (param)=>{
    let { size , iconColor  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        fill: "none",
        height: size,
        viewBox: "0 0 24 24",
        width: size,
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M6 9H10",
                stroke: iconColor,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M6 17H10",
                stroke: iconColor,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M14 9H18",
                stroke: iconColor,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M14 17H18",
                stroke: iconColor,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M2 22V5L4 2L6 5V22H2Z",
                stroke: iconColor,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M10 22V5L12 2L14 5V22H10Z",
                stroke: iconColor,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M18 22V5L20 2L22 5V22H18Z",
                stroke: iconColor,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-icons-virtual-412b14e947/1/packages/lib-icons/src/standard/swiss-knife-icons.tsx


const SwissKnifeIcons = (param)=>{
    let { size , iconColor  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        fill: "none",
        height: size,
        viewBox: "0 0 24 24",
        width: size,
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M16 17V8C16 4.1 19.1 1 23 1V20",
                stroke: iconColor,
                strokeMiterlimit: "10",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M1 20V5H7V9C5.9 9 5 9.9 5 11C5 12.1 5.9 13 7 13V17",
                stroke: iconColor,
                strokeMiterlimit: "10",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M1 20C1 18.3 2.3 17 4 17H20C21.7 17 23 18.3 23 20C23 21.7 21.7 23 20 23H4C2.3 23 1 21.7 1 20Z",
                stroke: iconColor,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-icons-virtual-412b14e947/1/packages/lib-icons/src/standard/tree-icons.tsx


const TreeIcons = (param)=>{
    let { size , iconColor  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        fill: "none",
        height: size,
        viewBox: "0 0 24 24",
        width: size,
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M6 14C6 9.0625 12 2 12 2C12 2 18 9.0625 18 14C18 17.3137 15.3137 19 12 19C8.68629 19 6 17.3137 6 14Z",
                stroke: iconColor,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M12 13V23",
                stroke: iconColor,
                strokeMiterlimit: "10",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M7 23H17",
                stroke: iconColor,
                strokeMiterlimit: "10",
                strokeWidth: "2"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-icons-virtual-412b14e947/1/packages/lib-icons/src/standard/shopping-tag-icons.tsx


const ShoppingTagIcons = (param)=>{
    let { size , iconColor  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        fill: "none",
        height: size,
        viewBox: "0 0 24 24",
        width: size,
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M13 22L22 13L10 1H1V10L13 22Z",
                stroke: iconColor,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M7 9C8.10457 9 9 8.10457 9 7C9 5.89543 8.10457 5 7 5C5.89543 5 5 5.89543 5 7C5 8.10457 5.89543 9 7 9Z",
                stroke: iconColor,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M13 10L16 13",
                stroke: iconColor,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M10 13L13 16",
                stroke: iconColor,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-icons-virtual-412b14e947/1/packages/lib-icons/src/standard/shopping-bag-icons.tsx


const ShoppingBagIcons = (param)=>{
    let { size , iconColor  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        fill: "none",
        height: size,
        viewBox: "0 0 24 24",
        width: size,
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M21 23H3V7H21V23Z",
                stroke: iconColor,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M8 10V5C8 2.8 9.8 1 12 1C14.2 1 16 2.8 16 5V10",
                stroke: iconColor,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-icons-virtual-412b14e947/1/packages/lib-icons/src/standard/service-icons.tsx


const ServiceIcons = (param)=>{
    let { size , iconColor  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        fill: "none",
        height: size,
        viewBox: "0 0 24 24",
        width: size,
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M6 7C4.3 7 3 5.7 3 4C3 2.3 4.3 1 6 1C7.7 1 9 2.3 9 4C9 5.7 7.7 7 6 7Z",
                stroke: iconColor,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M8 23H4V19L2 16V10H10V16L8 19V23Z",
                stroke: iconColor,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M15 6H18",
                stroke: iconColor,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M15 10H17",
                stroke: iconColor,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M15 14H18",
                stroke: iconColor,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M15 18H17",
                stroke: iconColor,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M22 1H15V23H22V1Z",
                stroke: iconColor,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-icons-virtual-412b14e947/1/packages/lib-icons/src/standard/flag-icons.tsx


const FlagIcons = (param)=>{
    let { size , iconColor  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        fill: "none",
        height: size,
        viewBox: "0 0 24 24",
        width: size,
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M3 3H21L18 9L21 15H3",
                stroke: iconColor,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M3 1V23",
                stroke: iconColor,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-icons-virtual-412b14e947/1/packages/lib-icons/src/standard/data-icons.tsx


const DataIcons = (param)=>{
    let { size , iconColor  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        fill: "none",
        height: size,
        viewBox: "0 0 24 24",
        width: size,
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M19.2 4H21V23H3V4H4.8",
                stroke: iconColor,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M7 10H17",
                stroke: iconColor,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M7 14.5555H17",
                stroke: iconColor,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M7 19H11",
                stroke: iconColor,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                height: "4",
                stroke: iconColor,
                strokeWidth: "2",
                width: "8",
                x: "8",
                y: "1"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-icons-virtual-412b14e947/1/packages/lib-icons/src/standard/discount-percent-icons.tsx
/* eslint-disable max-len */ 

const DiscountPercentcons = (param)=>{
    let { size , iconColor  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        fill: "none",
        height: size,
        viewBox: "0 0 16 16",
        width: size,
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M2 14L14 2",
                stroke: iconColor,
                strokeLinecap: "square",
                strokeWidth: "1.5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M3.5 6C4.88071 6 6 4.88071 6 3.5C6 2.11929 4.88071 1 3.5 1C2.11929 1 1 2.11929 1 3.5C1 4.88071 2.11929 6 3.5 6Z",
                stroke: iconColor,
                strokeLinecap: "square",
                strokeWidth: "1.5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M12.5 15C13.8807 15 15 13.8807 15 12.5C15 11.1193 13.8807 10 12.5 10C11.1193 10 10 11.1193 10 12.5C10 13.8807 11.1193 15 12.5 15Z",
                stroke: iconColor,
                strokeLinecap: "square",
                strokeWidth: "1.5"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-icons-virtual-412b14e947/1/packages/lib-icons/src/standard/small-fence-icons.tsx


const SmallFenceIcons = (param)=>{
    let { size , iconColor ="#0A3A5C"  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        fill: "none",
        height: size,
        viewBox: "0 0 16 16",
        width: size,
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M5.6731 8L9.82694 8",
                stroke: iconColor,
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: "1.5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M5.6731 13L9.82694 13",
                stroke: iconColor,
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: "1.5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M1 15V4.78571L3.07692 2L5.15385 4.78571V15H1Z",
                stroke: iconColor,
                strokeLinecap: "round",
                strokeWidth: "1.5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M10.3462 15V4.78571L12.4231 2L14.5 4.78571V15H10.3462Z",
                stroke: iconColor,
                strokeLinecap: "round",
                strokeWidth: "1.5"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-icons-virtual-412b14e947/1/packages/lib-icons/src/standard/residence-simple-icons.tsx
/* eslint-disable max-len */ 

const ResidenceSimpleIcons = (param)=>{
    let { size , iconColor ="#0A3A5C"  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        fill: "none",
        height: size,
        viewBox: "0 0 24 24",
        width: size,
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M8 4.69995V8.69995",
                stroke: iconColor,
                strokeLinecap: "square",
                strokeWidth: "1.5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M6 6.69995H10",
                stroke: iconColor,
                strokeLinecap: "square",
                strokeWidth: "1.5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M13.5 6.6C13.5 11.2667 8 15 8 15C8 15 2.5 11.2667 2.5 6.6C2.5 5.11479 3.07946 3.69041 4.11091 2.6402C5.14236 1.59 6.54131 1 8 1C9.45869 1 10.8576 1.59 11.8891 2.6402C12.9205 3.69041 13.5 5.11479 13.5 6.6V6.6Z",
                stroke: iconColor,
                strokeLinecap: "square",
                strokeWidth: "1.5"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-icons-virtual-412b14e947/1/packages/lib-icons/src/standard/logout-reverse-icons.tsx


const LogoutReverseIcons = (param)=>{
    let { size , iconColor  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        className: "byko-icon",
        fill: "none",
        height: size,
        viewBox: "0 0 24 24",
        width: size,
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M17 12H2",
                stroke: iconColor,
                strokeMiterlimit: "10",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M7 17L2 12L7 7",
                stroke: iconColor,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M10 1H22V23H10",
                stroke: iconColor,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-icons-virtual-412b14e947/1/packages/lib-icons/src/standard/trash-can-icons.tsx


const TrashCanIcons = (param)=>{
    let { size , iconColor  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        fill: "none",
        height: size,
        viewBox: "0 0 24 24",
        width: size,
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M20 9L19 23H5.00002L4 9",
                stroke: iconColor,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M2 5L22 5",
                stroke: iconColor,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M8 5V1H16V5",
                stroke: iconColor,
                strokeMiterlimit: "10",
                strokeWidth: "2"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-icons-virtual-412b14e947/1/packages/lib-icons/src/standard/deactivate-icons.tsx
/* eslint-disable max-len */ 

const DeactivateIcons = (param)=>{
    let { size , iconColor  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        fill: "none",
        height: size,
        viewBox: "0 0 24 24",
        width: size,
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M19.8 4.19995L4.20001 19.8",
                stroke: iconColor,
                strokeMiterlimit: "10",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1C5.92487 1 1 5.92487 1 12C1 18.0751 5.92487 23 12 23Z",
                stroke: iconColor,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-icons-virtual-412b14e947/1/packages/lib-icons/src/standard/filter-icons.tsx



const FilterIcons = (param)=>{
    let { size , iconColor =src/* theme.palette.blue.main */.rS.palette.blue.main  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        fill: "none",
        height: size,
        viewBox: "0 0 16 16",
        width: "16",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M14.6667 2.66675L9.33337 8.00008V13.3334L6.66671 14.6667V8.00008L1.33337 2.66675V0.666748H14.6667V2.66675Z",
            stroke: iconColor,
            strokeLinecap: "square",
            strokeMiterlimit: "10",
            strokeWidth: "1.33333"
        })
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-icons-virtual-412b14e947/1/packages/lib-icons/src/standard/present-icons.tsx
/* eslint-disable max-len */ 

const PresentIcons = (param)=>{
    let { size , iconColor  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        fill: "none",
        height: size,
        viewBox: "0 0 24 25",
        width: size,
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                clipPath: "url(#clip0_337_11512)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M4 4.00031C4.02271 3.31531 4.31631 2.66732 4.81634 2.1986C5.31637 1.72988 5.98197 1.47874 6.667 1.50031C10.611 1.50031 12 6.50031 12 6.50031H6.667C5.98197 6.52188 5.31637 6.27073 4.81634 5.80201C4.31631 5.33329 4.02271 4.6853 4 4.00031V4.00031Z",
                        stroke: iconColor,
                        strokeLinecap: "square",
                        strokeMiterlimit: "10",
                        strokeWidth: "2"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M17.333 6.50031H12C12 6.50031 13.389 1.50031 17.333 1.50031C18.018 1.47874 18.6836 1.72988 19.1837 2.1986C19.6837 2.66732 19.9773 3.31531 20 4.00031C19.9773 4.6853 19.6837 5.33329 19.1837 5.80201C18.6836 6.27073 18.018 6.52188 17.333 6.50031Z",
                        stroke: iconColor,
                        strokeLinecap: "square",
                        strokeMiterlimit: "10",
                        strokeWidth: "2"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M21 13.5V21.5C21 22.0304 20.7893 22.5391 20.4142 22.9142C20.0391 23.2893 19.5304 23.5 19 23.5H5C4.46957 23.5 3.96086 23.2893 3.58579 22.9142C3.21071 22.5391 3 22.0304 3 21.5V13.5",
                        stroke: iconColor,
                        strokeLinecap: "square",
                        strokeMiterlimit: "10",
                        strokeWidth: "2"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M23 6.5H1V10.5H23V6.5Z",
                        stroke: iconColor,
                        strokeLinecap: "square",
                        strokeMiterlimit: "10",
                        strokeWidth: "2"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M12 6.5V23.5",
                        stroke: iconColor,
                        strokeLinecap: "square",
                        strokeMiterlimit: "10",
                        strokeWidth: "2"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_337_11512",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        fill: "white",
                        height: size,
                        transform: "translate(0 0.5)",
                        width: size
                    })
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-icons-virtual-412b14e947/1/packages/lib-icons/src/standard/aur-icons.tsx
/* eslint-disable max-len */ 

const AurIcons = (param)=>{
    let { size  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        fill: "none",
        height: size,
        viewBox: "0 0 25 25",
        width: size,
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M12.7299 0.0172754C12.6054 0.00863764 12.4218 0.00503858 12.0748 0.00359896C11.81 0.00287914 11.5731 0.00287914 11.5494 0.00431877C11.5256 0.00575839 11.4378 0.0100773 11.355 0.0143961C11.2723 0.018715 11.1427 0.0273528 11.0671 0.0331113C10.9915 0.0388698 10.867 0.0496669 10.79 0.0575849C10.713 0.0655028 10.5834 0.0806189 10.5021 0.0906962C10.4207 0.100774 10.2804 0.120209 10.1889 0.133885C10.0975 0.147561 9.9442 0.173475 9.84703 0.19147C9.74986 0.208745 9.59438 0.239697 9.50152 0.259852C9.40866 0.279287 9.24167 0.318157 9.13082 0.34551C9.01997 0.372863 8.85009 0.418211 8.75292 0.445564C8.65574 0.472916 8.49882 0.519704 8.40381 0.549936C8.30879 0.579449 8.15835 0.629835 8.06909 0.660787C7.97984 0.692459 7.83443 0.745725 7.74518 0.779556C7.65592 0.813388 7.5134 0.870253 7.42846 0.905524C7.34352 0.940794 7.20244 1.00198 7.11534 1.04085C7.02825 1.07972 6.82886 1.17545 6.67266 1.25319C6.51646 1.33165 6.31059 1.4389 6.21558 1.49217C6.12056 1.54472 5.98164 1.62534 5.90606 1.66996C5.83048 1.71459 5.71243 1.78729 5.64333 1.83048C5.57422 1.87367 5.4461 1.95717 5.359 2.01547C5.2719 2.07378 5.14738 2.16016 5.08187 2.20622C5.01637 2.25301 4.9084 2.33219 4.84074 2.38258C4.77307 2.43296 4.67014 2.51214 4.6104 2.55893C4.55137 2.60572 4.42756 2.70649 4.33687 2.78207C4.24617 2.85837 4.11948 2.96707 4.05614 3.02321C3.9928 3.07936 3.87763 3.18517 3.80061 3.25715C3.72359 3.32985 3.58107 3.46949 3.48389 3.56739C3.38672 3.666 3.24923 3.80997 3.17869 3.88699C3.10743 3.96401 2.9901 4.09717 2.91668 4.18211C2.84398 4.26705 2.72809 4.40669 2.65971 4.49163C2.59132 4.57657 2.49559 4.69965 2.44592 4.76516C2.39625 4.83066 2.32211 4.93071 2.28036 4.9883C2.23934 5.04588 2.16591 5.14954 2.11841 5.21864C2.0709 5.28774 1.99172 5.40579 1.94277 5.48137L1.93175 5.49865C1.88383 5.57372 1.81739 5.67781 1.77938 5.7405C1.73763 5.80816 1.66133 5.93773 1.60878 6.02843C1.55623 6.11912 1.47849 6.25877 1.43603 6.33795C1.39356 6.41713 1.31222 6.57404 1.25679 6.68705C1.20065 6.80007 1.13082 6.94403 1.10203 7.00737C1.07324 7.07071 1.02213 7.18372 0.989742 7.25931C0.95735 7.33489 0.904084 7.46085 0.872412 7.54003C0.840741 7.61921 0.788914 7.75382 0.757242 7.83875C0.725571 7.92369 0.674464 8.06621 0.644232 8.15547C0.614 8.24473 0.568652 8.38581 0.542738 8.46859C0.516825 8.55137 0.477955 8.68093 0.457081 8.75651C0.436206 8.8321 0.402375 8.95662 0.38222 9.03364C0.362785 9.11066 0.331833 9.23735 0.313838 9.31437C0.295843 9.39139 0.263451 9.54255 0.241857 9.64908C0.220263 9.75561 0.189311 9.92117 0.173475 10.0162C0.157639 10.1112 0.134605 10.2573 0.123088 10.3401C0.111571 10.4229 0.0935756 10.5625 0.0834982 10.6496C0.0734208 10.7367 0.0590246 10.8807 0.0511067 10.9699C0.0431887 11.0592 0.0309519 11.2161 0.0251934 11.319C0.0187151 11.422 0.011517 11.6278 0.00863775 11.7761C0.0057585 11.9244 0.0057585 12.1641 0.00863775 12.3088C0.0107972 12.4535 0.0165557 12.6327 0.0208746 12.7083C0.0251934 12.7839 0.0338312 12.9098 0.0403095 12.989C0.046068 13.0682 0.057585 13.1963 0.0655029 13.2733C0.0734208 13.3504 0.0878171 13.4785 0.0978945 13.5577C0.107252 13.6368 0.127407 13.7779 0.141083 13.8708C0.15476 13.9636 0.179233 14.1098 0.194349 14.1947C0.210185 14.2796 0.233939 14.4063 0.248335 14.4754C0.262731 14.5445 0.285765 14.6518 0.299442 14.713C0.313118 14.7741 0.34551 14.908 0.371423 15.0095C0.396616 15.1117 0.441245 15.2787 0.470757 15.3802C0.500269 15.4824 0.544178 15.6293 0.568652 15.7063C0.593125 15.7833 0.637034 15.9143 0.665826 15.9978C0.694619 16.0813 0.737807 16.2008 0.761561 16.2642C0.785315 16.3275 0.830663 16.4441 0.862335 16.5233C0.894007 16.6025 0.944393 16.7241 0.973906 16.7932C1.00342 16.8623 1.05093 16.971 1.07972 17.0344C1.10851 17.0977 1.18625 17.2597 1.25247 17.3943C1.31942 17.5289 1.40363 17.6944 1.43962 17.7614C1.47633 17.8283 1.54544 17.9514 1.59294 18.0349C1.64045 18.1184 1.70667 18.2314 1.74051 18.2868C1.77434 18.3423 1.83264 18.4358 1.87007 18.4956C1.9075 18.5546 1.98596 18.6748 2.04427 18.7619C2.10257 18.849 2.18895 18.9735 2.23502 19.039C2.2818 19.1045 2.36386 19.2161 2.41713 19.2874C2.4704 19.3586 2.56973 19.4868 2.63811 19.5717C2.70577 19.6566 2.80655 19.7797 2.86197 19.8445C2.91668 19.91 3.00666 20.0137 3.06208 20.0748C3.11679 20.1367 3.2262 20.2548 3.30394 20.3383C3.3824 20.4218 3.51412 20.5557 3.59618 20.637C3.67896 20.7184 3.79197 20.827 3.8474 20.8782C3.89778 20.9253 3.97612 20.9962 4.02997 21.0449L4.04534 21.0588C4.09861 21.1063 4.19147 21.1869 4.25049 21.2373C4.31024 21.2884 4.43116 21.3885 4.52042 21.4598C4.60968 21.5317 4.76012 21.6483 4.85513 21.7189C4.95015 21.7902 5.08475 21.8873 5.15385 21.9363C5.22296 21.9845 5.32877 22.0565 5.38779 22.0961C5.43978 22.1305 5.52011 22.1824 5.57898 22.2204L5.60374 22.2364C5.66348 22.2739 5.76498 22.3372 5.83048 22.3768C5.89598 22.4164 6.00611 22.4812 6.07521 22.5208C6.14432 22.5604 6.25949 22.6244 6.33075 22.6633C6.40201 22.7022 6.57548 22.7907 6.71585 22.8605C6.85621 22.9303 7.04912 23.0218 7.14414 23.0642C7.23915 23.106 7.38527 23.1686 7.46805 23.2031C7.55083 23.237 7.71279 23.3003 7.82796 23.3435C7.94313 23.3867 8.11948 23.4493 8.22025 23.4824C8.32103 23.5163 8.46859 23.5638 8.54777 23.5875C8.62695 23.6113 8.75651 23.6487 8.83569 23.6703C8.91487 23.6919 9.03148 23.7228 9.09483 23.7387C9.15817 23.7545 9.26686 23.7804 9.33596 23.7963C9.40507 23.8121 9.54111 23.8409 9.63828 23.8611C9.73546 23.8805 9.88302 23.9078 9.9658 23.9222C10.0486 23.9366 10.1702 23.9561 10.2357 23.9654C10.3012 23.9755 10.4322 23.9935 10.5273 24.005C10.6223 24.0165 10.7698 24.0331 10.8548 24.041C10.9397 24.0489 11.0793 24.0604 11.1643 24.0669C11.2492 24.0727 11.3953 24.0813 11.4882 24.0856C11.5811 24.09 11.8128 24.0936 12.0029 24.0936C12.1929 24.0936 12.4261 24.09 12.5211 24.0856C12.6161 24.0813 12.7637 24.0727 12.8486 24.0662C12.9336 24.0604 13.0718 24.0489 13.1546 24.041C13.2373 24.0331 13.359 24.0201 13.4245 24.0122C13.49 24.005 13.6131 23.9885 13.698 23.9762C13.783 23.9647 13.9284 23.9417 14.0205 23.9258C14.1119 23.9107 14.2516 23.8848 14.33 23.8697C14.4078 23.8539 14.5251 23.8294 14.5906 23.815C14.6561 23.8006 14.7986 23.7668 14.9073 23.7394C15.016 23.7121 15.1751 23.6703 15.26 23.6458C15.345 23.6214 15.4767 23.5825 15.5515 23.5595C15.6264 23.5364 15.761 23.4925 15.8503 23.4616C15.9395 23.4313 16.082 23.3809 16.167 23.3493C16.2519 23.3176 16.388 23.2643 16.4693 23.2319C16.5506 23.1988 16.6658 23.1513 16.7248 23.1254C16.7846 23.0995 16.8861 23.0541 16.9516 23.0246C17.0171 22.9951 17.143 22.9354 17.2323 22.8922C17.3216 22.849 17.4605 22.7785 17.5418 22.7353C17.6232 22.6928 17.7477 22.6251 17.8189 22.5855C17.8902 22.546 18.0083 22.4776 18.0817 22.4344C18.1551 22.3905 18.2667 22.3228 18.33 22.2832C18.3934 22.2436 18.5049 22.1717 18.5784 22.1234C18.6518 22.0752 18.7734 21.9931 18.8483 21.9406C18.9231 21.8873 19.0549 21.7923 19.1398 21.729C19.2247 21.6656 19.3399 21.5778 19.3953 21.5339C19.4508 21.4907 19.5703 21.3928 19.6617 21.3172C19.7531 21.2409 19.8776 21.1344 19.9388 21.0797C20 21.0257 20.1123 20.9235 20.1871 20.853C20.262 20.7824 20.416 20.6313 20.529 20.5175C20.6421 20.4031 20.7911 20.2462 20.8616 20.1691C20.9314 20.0921 21.0423 19.9654 21.1085 19.8884C21.1747 19.8114 21.2848 19.6782 21.3532 19.5933C21.4216 19.5083 21.5238 19.3766 21.58 19.3018C21.6368 19.2269 21.7232 19.1081 21.7729 19.039C21.8225 18.9699 21.9248 18.8188 22.0011 18.7043C22.0774 18.5899 22.1702 18.4452 22.2076 18.384C22.2451 18.3228 22.3149 18.2062 22.3631 18.1249C22.4106 18.0435 22.4934 17.896 22.5474 17.7974C22.6014 17.6987 22.6921 17.5231 22.7489 17.4087C22.8065 17.2942 22.8857 17.1272 22.926 17.038C22.9663 16.9487 23.0297 16.8047 23.0664 16.7176C23.1031 16.6305 23.1578 16.4945 23.1887 16.4153C23.2197 16.3361 23.2737 16.19 23.309 16.0914C23.3442 15.9928 23.3975 15.8351 23.4277 15.7423C23.4572 15.6494 23.5055 15.4904 23.5343 15.3896C23.5631 15.2888 23.6019 15.1492 23.6199 15.0801C23.6379 15.011 23.6703 14.8778 23.6919 14.7849C23.7135 14.6921 23.7473 14.5344 23.7675 14.4358C23.7869 14.3365 23.815 14.1897 23.8287 14.1083C23.8431 14.027 23.8654 13.883 23.879 13.788C23.8927 13.693 23.9122 13.5454 23.9222 13.4605C23.9323 13.3755 23.9474 13.2316 23.9553 13.1402C23.9633 13.0488 23.9748 12.9019 23.9805 12.8127C23.9863 12.7234 23.9949 12.5147 24 12.3484C24.0065 12.1123 24.0065 11.9798 24 11.7437C23.9949 11.5775 23.9863 11.3673 23.9805 11.2759C23.9748 11.1844 23.9647 11.0534 23.9589 10.9843C23.9525 10.9152 23.9395 10.7857 23.9294 10.6964C23.9194 10.6072 23.9035 10.4747 23.8934 10.4013C23.8841 10.3279 23.8611 10.1789 23.8431 10.0702C23.8251 9.96148 23.7934 9.78441 23.7718 9.67787C23.7509 9.57134 23.7149 9.40578 23.6933 9.31077C23.671 9.21575 23.6336 9.06387 23.6098 8.97246C23.5861 8.88104 23.5436 8.72916 23.5155 8.63415C23.4875 8.53913 23.4313 8.36062 23.3903 8.23825C23.35 8.11588 23.2982 7.96616 23.2766 7.90714C23.255 7.84739 23.2168 7.74734 23.1923 7.68399C23.1679 7.62065 23.1204 7.5026 23.0865 7.42126C23.0527 7.33992 22.9915 7.1974 22.9498 7.10455C22.908 7.01169 22.8339 6.85405 22.7857 6.75544C22.7374 6.6561 22.6669 6.51574 22.628 6.44232C22.5891 6.3689 22.5229 6.24797 22.4812 6.17239C22.4394 6.09681 22.3581 5.95645 22.2998 5.85927C22.2422 5.7621 22.1493 5.61309 22.0946 5.52816C22.0399 5.44322 21.9536 5.31221 21.9017 5.23663C21.8499 5.16105 21.7736 5.05308 21.7326 4.9955C21.6908 4.93791 21.6138 4.83426 21.562 4.76516C21.5094 4.69605 21.4252 4.58736 21.3748 4.52402C21.3237 4.46068 21.2431 4.36206 21.1956 4.3052C21.1474 4.24761 21.0617 4.14756 21.0041 4.08205C20.9465 4.01655 20.8594 3.91938 20.8105 3.86539C20.7615 3.81212 20.5996 3.64657 20.4506 3.49829C20.3016 3.34929 20.1166 3.17077 20.0396 3.10167C19.9626 3.03257 19.8524 2.93539 19.7948 2.88573C19.7373 2.83678 19.635 2.75112 19.5681 2.69642C19.5012 2.64099 19.3903 2.55317 19.3234 2.50135C19.2564 2.4488 19.1348 2.35738 19.0534 2.29836C18.9721 2.23934 18.8411 2.14576 18.7619 2.09177C18.6827 2.03707 18.5438 1.94493 18.4524 1.88663C18.361 1.82832 18.2105 1.73475 18.1177 1.67932C18.0248 1.6239 17.8902 1.54616 17.8189 1.50657C17.7477 1.46698 17.6116 1.39356 17.5166 1.34389C17.4216 1.2935 17.2597 1.21288 17.1567 1.16394C17.0538 1.11427 16.9033 1.04517 16.822 1.00918C16.7407 0.973906 16.6176 0.921359 16.5485 0.892567C16.4794 0.863774 16.3721 0.821306 16.3109 0.797552C16.2498 0.773798 16.1252 0.72773 16.0338 0.694619C15.9424 0.662227 15.8028 0.614 15.7229 0.587367C15.6422 0.561453 15.5127 0.520424 15.4349 0.49739C15.3565 0.473636 15.2391 0.440525 15.1736 0.42253C15.1081 0.404534 14.9901 0.373582 14.9109 0.353428C14.8317 0.333993 14.7022 0.303041 14.623 0.285046C14.5438 0.26705 14.4049 0.238258 14.3135 0.220262C14.222 0.202267 14.0702 0.174914 13.9752 0.159078C13.8801 0.143243 13.7441 0.122368 13.6728 0.112291C13.6016 0.102213 13.4734 0.0863774 13.3885 0.0763C13.3036 0.0662226 13.1596 0.0511066 13.0682 0.0431886C12.9768 0.0352707 12.8249 0.0237537 12.7299 0.0172754Z",
                fill: "#EBBB30"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M7.18732 8.86089C7.09663 8.85729 6.98938 8.85441 6.94979 8.85513C6.9102 8.85513 6.8195 8.85873 6.74824 8.86161C6.67698 8.86449 6.5798 8.87024 6.5323 8.87456C6.48479 8.87888 6.40561 8.88752 6.35594 8.894C6.30627 8.90048 6.22206 8.91343 6.16879 8.92279C6.11552 8.93287 6.02483 8.9523 5.96724 8.96598C5.90966 8.98038 5.81104 9.00845 5.7477 9.03004C5.68436 9.05092 5.58862 9.08763 5.53536 9.11066C5.48209 9.13442 5.40435 9.17257 5.3626 9.1956C5.32085 9.21863 5.25607 9.25894 5.21864 9.28414C5.18121 9.31005 5.12578 9.35036 5.09627 9.37483C5.06676 9.39859 5.01853 9.44178 4.98902 9.46913C4.96023 9.49648 4.912 9.54831 4.88177 9.5843C4.85225 9.61957 4.80906 9.67643 4.78675 9.71027C4.76444 9.7441 4.73133 9.7988 4.71261 9.83263C4.69461 9.86646 4.66798 9.92261 4.65287 9.9586C4.63847 9.99387 4.61544 10.0558 4.60176 10.0954C4.5888 10.135 4.56793 10.2048 4.55641 10.2501C4.54489 10.2955 4.52906 10.3703 4.52042 10.4157C4.5125 10.461 4.49883 10.5539 4.49163 10.6208C4.48371 10.6878 4.47363 10.8404 4.47003 10.9591C4.46499 11.0966 4.46284 11.8618 4.46427 13.0718L4.46643 14.9685L5.81608 14.9721V13.2517H8.18426V14.9721H9.53751C9.53751 11.8776 9.53463 11.0246 9.53031 10.9195C9.52599 10.8224 9.51808 10.6928 9.5116 10.6316C9.50584 10.5704 9.49288 10.4733 9.48281 10.4157C9.47345 10.3581 9.45617 10.2739 9.44394 10.2285C9.43242 10.1832 9.41154 10.1119 9.39715 10.0702C9.38275 10.0284 9.3518 9.95428 9.32805 9.90461C9.30429 9.85495 9.2611 9.77865 9.23159 9.73546C9.2028 9.69155 9.15457 9.62893 9.12506 9.5951C9.09555 9.56126 9.04588 9.51088 9.01421 9.4828C8.98326 9.45473 8.92711 9.40794 8.88968 9.37843C8.85225 9.34892 8.78891 9.30429 8.74932 9.2791C8.70973 9.25318 8.63847 9.21216 8.59096 9.18768C8.54345 9.16249 8.47075 9.12794 8.429 9.10994C8.38725 9.09267 8.30519 9.06171 8.24545 9.04084C8.18642 9.02069 8.10149 8.99477 8.0583 8.98326C8.01511 8.97174 7.94169 8.95446 7.89634 8.94439C7.85099 8.93503 7.76029 8.91847 7.69479 8.90839C7.62929 8.89832 7.52564 8.88536 7.46445 8.87888C7.40327 8.87312 7.27802 8.86449 7.18732 8.86089Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M19.3737 8.86809C19.3183 8.86449 19.2017 8.86017 19.1146 8.85801C19.0275 8.85657 18.8994 8.85729 18.8303 8.86089C18.7612 8.86377 18.664 8.87024 18.6143 8.87456C18.5647 8.87888 18.4869 8.88752 18.4416 8.894C18.3962 8.89976 18.3135 8.91271 18.258 8.92279C18.2026 8.93287 18.1069 8.95302 18.0457 8.96886C17.9845 8.98398 17.8938 9.00989 17.8441 9.02644C17.7945 9.043 17.7189 9.07107 17.675 9.08907C17.6311 9.10634 17.5519 9.14377 17.4986 9.17041C17.4454 9.19776 17.3576 9.24887 17.3043 9.28414C17.251 9.32013 17.1841 9.36763 17.1567 9.38923C17.1294 9.41154 17.0696 9.46625 17.0243 9.51088C16.9796 9.55479 16.9221 9.61741 16.8976 9.64908C16.8724 9.68075 16.835 9.73402 16.8141 9.76785C16.7932 9.80168 16.7608 9.86143 16.7421 9.90102C16.7234 9.94061 16.696 10.0068 16.6816 10.0486C16.6673 10.0903 16.6442 10.1695 16.6305 10.2249C16.6169 10.2804 16.5981 10.3811 16.5881 10.4481C16.5787 10.515 16.5672 10.6122 16.5629 10.664C16.5586 10.7158 16.5521 10.8173 16.5478 10.8908C16.5434 10.9707 16.5384 11.8121 16.5355 12.9984L16.5305 14.9721H17.8873C17.8909 10.8749 17.8917 10.7684 17.9039 10.7036C17.9111 10.6662 17.9269 10.6079 17.9384 10.574C17.95 10.5402 17.9701 10.4949 17.9823 10.474C17.9953 10.4524 18.0255 10.415 18.0493 10.3905C18.0774 10.3624 18.1126 10.3365 18.1501 10.3171C18.1817 10.3012 18.2285 10.2804 18.2544 10.2717C18.2803 10.2638 18.3365 10.2508 18.3804 10.2429C18.4243 10.2357 18.5128 10.2257 18.5784 10.2213C18.6561 10.2156 18.8094 10.2141 19.0246 10.2163C19.2046 10.2185 19.3795 10.2235 19.4133 10.2278C19.4472 10.2314 19.4896 10.2364 19.5083 10.2386L19.5429 10.2429V8.88248C19.4896 8.87672 19.4292 8.8724 19.3737 8.86809Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M11.8517 9.12362L10.5021 9.12002V11.1333C10.5021 12.3772 10.5049 13.1942 10.5093 13.2697C10.5136 13.3367 10.5215 13.4389 10.528 13.4965C10.5345 13.5541 10.5474 13.6448 10.5568 13.698C10.5668 13.7513 10.5841 13.8312 10.5956 13.8744C10.6072 13.9176 10.628 13.9874 10.6424 14.0291C10.6568 14.0709 10.6863 14.1421 10.7079 14.1875C10.7295 14.2328 10.7713 14.3063 10.8001 14.3495C10.8296 14.3926 10.8771 14.456 10.9066 14.4898C10.9361 14.5236 10.9872 14.5762 11.021 14.6071C11.0542 14.6381 11.1189 14.6921 11.1643 14.7266C11.2096 14.7612 11.278 14.808 11.3154 14.8317C11.3529 14.8548 11.4241 14.8944 11.4738 14.9195C11.5235 14.9447 11.612 14.9843 11.6718 15.0074C11.7308 15.0311 11.8172 15.0613 11.8625 15.0757C11.9079 15.0894 11.9906 15.1125 12.0461 15.1254C12.1015 15.1391 12.1936 15.1585 12.2512 15.1693C12.3088 15.1794 12.3944 15.1931 12.442 15.1988C12.4895 15.2053 12.5895 15.2154 12.6651 15.2219C12.7565 15.2291 12.8854 15.2334 13.0538 15.2334C13.192 15.2334 13.3561 15.2298 13.4173 15.2247C13.4785 15.2197 13.5706 15.2111 13.6224 15.2053C13.6743 15.1996 13.7642 15.1866 13.824 15.1765C13.883 15.1664 13.968 15.1506 14.0111 15.1405C14.0543 15.1305 14.1357 15.1096 14.1911 15.0937C14.2465 15.0772 14.3307 15.0498 14.3782 15.0318C14.4258 15.0146 14.5201 14.9728 14.587 14.9397C14.6539 14.9066 14.7482 14.854 14.7957 14.8224C14.8432 14.7907 14.908 14.7439 14.9397 14.718C14.9714 14.6928 15.0347 14.6331 15.0801 14.5863C15.1254 14.5388 15.1808 14.4761 15.2032 14.4466C15.2255 14.4171 15.2643 14.3588 15.2888 14.3171C15.314 14.2753 15.3486 14.2091 15.3665 14.1695C15.3838 14.1299 15.4097 14.0666 15.4234 14.0291C15.4371 13.9917 15.4594 13.919 15.4724 13.8672C15.486 13.8154 15.5033 13.7412 15.5112 13.7016C15.5192 13.662 15.5321 13.5764 15.54 13.5109C15.5479 13.4454 15.558 13.3388 15.5623 13.2733C15.5667 13.1978 15.5695 12.4196 15.5688 11.1369V9.12002L14.2199 9.12362L14.212 13.205C14.1868 13.3165 14.1717 13.3727 14.1616 13.4007C14.1522 13.4295 14.1328 13.477 14.1184 13.5051C14.104 13.5339 14.0752 13.5814 14.0551 13.6109C14.0349 13.6404 13.9917 13.6887 13.96 13.7189C13.9276 13.7491 13.8744 13.7909 13.8413 13.811C13.8082 13.8319 13.7448 13.8636 13.7016 13.8809C13.6584 13.8989 13.5901 13.9219 13.5505 13.932C13.5109 13.942 13.4346 13.9572 13.3813 13.9651C13.323 13.9737 13.2237 13.9809 13.133 13.9838C13.0372 13.9867 12.9422 13.9845 12.8738 13.9795C12.8141 13.9744 12.7284 13.9644 12.6831 13.9564C12.6377 13.9492 12.5694 13.9348 12.5319 13.9248C12.4945 13.914 12.4312 13.8931 12.3916 13.878C12.352 13.8621 12.2915 13.8326 12.2562 13.8118C12.2217 13.7909 12.1691 13.7535 12.1396 13.7283C12.1101 13.7038 12.0655 13.6577 12.0403 13.6268C12.0158 13.5958 11.9806 13.5411 11.9618 13.5066C11.9431 13.4713 11.9194 13.4166 11.9093 13.3849C11.8985 13.3532 11.8827 13.2985 11.8747 13.2625L11.8589 13.1978L11.8517 9.12362Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M7.2845 10.1242C7.23483 10.1177 7.12902 10.1119 7.02177 10.1098C6.92315 10.1083 6.80942 10.1098 6.76983 10.1134C6.73024 10.117 6.66546 10.1249 6.62587 10.1314C6.58628 10.1378 6.5215 10.1515 6.48191 10.1616C6.44232 10.1717 6.38545 10.1897 6.35594 10.2012C6.32643 10.2127 6.27748 10.235 6.24797 10.2508C6.21846 10.266 6.16519 10.3005 6.12992 10.3271C6.09393 10.3545 6.04786 10.397 6.02555 10.4229C6.00395 10.4488 5.97516 10.4877 5.96076 10.5093C5.94709 10.5309 5.92549 10.5719 5.91254 10.5992C5.89958 10.6266 5.8823 10.6705 5.87367 10.6964C5.86503 10.7223 5.85207 10.772 5.84487 10.808C5.83768 10.844 5.8276 10.9145 5.824 10.9663C5.81968 11.0189 5.81608 11.2492 5.81608 11.4896V11.9201H8.18426C8.17994 10.9851 8.17851 10.9224 8.16699 10.862C8.15979 10.8245 8.14395 10.7626 8.13244 10.7252C8.1202 10.6878 8.09645 10.6295 8.07917 10.5956C8.06262 10.5618 8.03238 10.5136 8.01295 10.4877C7.99423 10.4617 7.95896 10.4222 7.93521 10.3984C7.91217 10.3754 7.86971 10.3401 7.84235 10.3207C7.815 10.3012 7.76101 10.2696 7.72358 10.2501C7.68615 10.2314 7.62785 10.2062 7.59402 10.194C7.56019 10.1825 7.4954 10.1645 7.45006 10.1537C7.40471 10.1436 7.32985 10.1306 7.2845 10.1242Z",
                fill: "#EBBB30"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-icons-virtual-412b14e947/1/packages/lib-icons/src/standard/netgiro-icons.tsx
/* eslint-disable max-len */ 

const NetgiroIcons = (param)=>{
    let { size  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        fill: "none",
        height: size,
        viewBox: "0 0 24 20",
        width: size,
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M0 18.2667V15.2334H0.780267V15.4743C1.01934 15.2718 1.3233 15.162 1.63661 15.1651C1.83649 15.1634 2.03424 15.2063 2.21545 15.2906C2.39666 15.375 2.55677 15.4987 2.68412 15.6528C2.88894 15.8927 2.9972 16.1941 2.9972 16.7256V18.2784H2.1789V16.6652C2.1789 16.3648 2.10672 16.2077 1.99748 16.0995C1.93651 16.0423 1.86471 15.9979 1.78632 15.9689C1.70792 15.94 1.62452 15.927 1.54103 15.9307C1.39834 15.9334 1.25812 15.9685 1.13091 16.0332C1.00371 16.0979 0.892824 16.1906 0.806601 16.3043V18.2784H0V18.2667Z",
                fill: "#64C2A1"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M6.94418 17.7848C6.65158 18.134 6.16391 18.3261 5.69282 18.3261C4.78966 18.3261 4.104 17.7009 4.104 16.75C4.104 15.9073 4.6814 15.165 5.58456 15.165C6.42725 15.165 7.01635 15.8751 7.01635 16.7178C7.01558 16.7944 7.00775 16.8708 6.99294 16.946H4.88622C4.90656 17.1473 5.00216 17.3335 5.15389 17.4673C5.30561 17.6011 5.50228 17.6727 5.70453 17.6677C5.84975 17.6644 5.99281 17.6318 6.12518 17.572C6.25756 17.5122 6.37654 17.4263 6.47504 17.3196L6.94418 17.7848ZM6.18634 16.3647C6.16821 16.2181 6.09694 16.0832 5.98604 15.9856C5.87513 15.888 5.73229 15.8345 5.58456 15.8351C5.43133 15.833 5.28227 15.885 5.1635 15.9818C5.04473 16.0787 4.96384 16.2142 4.93499 16.3647H6.18634Z",
                fill: "#64C2A1"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M10.399 18.2666C10.2337 18.307 10.064 18.327 9.89382 18.3261C9.4003 18.3261 9.05113 18.1574 8.84631 17.893C8.69025 17.6882 8.61808 17.4112 8.61808 16.9899V15.917H7.77539V15.2343H8.61808V14.3916H9.43638V15.2343H10.4361V15.917H9.4237V17.0728C9.41301 17.2084 9.44729 17.3438 9.52124 17.4581C9.57492 17.5104 9.63938 17.5505 9.71013 17.5754C9.78088 17.6004 9.85621 17.6096 9.93088 17.6024C10.0438 17.5995 10.1564 17.5875 10.2674 17.5663L10.399 18.2666Z",
                fill: "#64C2A1"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M14.5031 18.0982C14.5031 18.6395 14.4055 18.9643 14.2261 19.2296C13.9471 19.6149 13.4594 19.847 12.8742 19.847C12.289 19.847 11.7185 19.57 11.4181 19.2208L11.936 18.6912C12.0522 18.8295 12.1978 18.9401 12.3621 19.0152C12.5264 19.0903 12.7053 19.1279 12.886 19.1252C13.0014 19.1311 13.1167 19.1127 13.2246 19.0712C13.3324 19.0297 13.4304 18.9661 13.5121 18.8843C13.6331 18.7517 13.7072 18.5595 13.7072 18.1743V18.0768C13.4758 18.2638 13.1853 18.362 12.8879 18.3538C12.67 18.3521 12.4549 18.3052 12.2561 18.216C12.0573 18.1269 11.8792 17.9974 11.7331 17.8359C11.4787 17.5368 11.3418 17.1555 11.3478 16.763C11.3478 15.8725 12.0101 15.1742 12.8401 15.1742C13.1651 15.1669 13.4816 15.2782 13.7306 15.4872V15.2463H14.5109V18.0992L14.5031 18.0982ZM13.6847 16.2929C13.5991 16.1757 13.4868 16.0806 13.357 16.0156C13.2272 15.9507 13.0838 15.9176 12.9386 15.9193C12.4568 15.9193 12.1584 16.3163 12.1584 16.7503C12.1538 16.8584 12.1714 16.9664 12.21 17.0675C12.2486 17.1686 12.3073 17.2608 12.3827 17.3385C12.4581 17.4162 12.5485 17.4777 12.6485 17.5193C12.7484 17.5608 12.8557 17.5816 12.964 17.5803C13.1075 17.583 13.2496 17.5505 13.3776 17.4855C13.5056 17.4205 13.6158 17.3252 13.6984 17.2077V16.2929H13.6847Z",
                fill: "#64C2A1"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M16.7299 18.2668H15.9116V15.2335H16.7299V18.2668ZM17.2956 13.7646L16.5495 14.7634H15.9838L16.4168 13.7646H17.2956Z",
                fill: "#64C2A1"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M19.9943 15.9551C19.8993 15.9276 19.8005 15.9154 19.7017 15.919C19.5525 15.9228 19.4068 15.9646 19.2783 16.0404C19.1498 16.1161 19.0428 16.2234 18.9672 16.352V18.2666H18.1489V15.2333H18.9292V15.5464C19.1096 15.3172 19.4471 15.1729 19.807 15.1729C19.8999 15.173 19.9925 15.1812 20.084 15.1972L19.9943 15.9551Z",
                fill: "#64C2A1"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M22.4472 15.173C22.7587 15.179 23.0615 15.2767 23.3177 15.454C23.5739 15.6312 23.7721 15.8801 23.8874 16.1695C24.0028 16.4589 24.0302 16.7759 23.9662 17.0808C23.9022 17.3857 23.7497 17.6649 23.5278 17.8835C23.3058 18.1021 23.0243 18.2504 22.7184 18.3097C22.4126 18.369 22.0961 18.3368 21.8085 18.217C21.5209 18.0973 21.275 17.8953 21.1017 17.6365C20.9283 17.3776 20.8352 17.0734 20.834 16.7619C20.8324 16.5507 20.8732 16.3413 20.954 16.1462C21.0348 15.9511 21.154 15.7743 21.3044 15.6261C21.4549 15.4779 21.6336 15.3615 21.8299 15.2836C22.0262 15.2058 22.2361 15.1682 22.4472 15.173ZM22.4472 17.5802C22.6126 17.585 22.7756 17.5404 22.9155 17.4521C23.0553 17.3637 23.1656 17.2356 23.2322 17.0842C23.2988 16.9328 23.3188 16.765 23.2894 16.6022C23.2601 16.4394 23.1828 16.289 23.0676 16.1704C22.9523 16.0518 22.8042 15.9702 22.6423 15.9363C22.4804 15.9023 22.3121 15.9174 22.1588 15.9797C22.0056 16.0419 21.8744 16.1485 21.7821 16.2858C21.6898 16.423 21.6405 16.5847 21.6406 16.7501C21.6523 17.2076 21.9771 17.5802 22.4472 17.5802ZM23.4821 13.7646L22.7359 14.7634H22.1702L22.6033 13.7646H23.4821Z",
                fill: "#64C2A1"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M3.80371 5.95009V11.4588C5.26497 11.4588 6.66643 10.8785 7.69998 9.8455C8.73352 8.8125 9.31455 7.41135 9.31532 5.95009V0.4375C8.59145 0.4375 7.87466 0.580094 7.2059 0.85714C6.53713 1.13419 5.92949 1.54026 5.41768 2.05216C4.90587 2.56406 4.4999 3.17177 4.22298 3.84059C3.94605 4.5094 3.80358 5.22621 3.80371 5.95009Z",
                fill: "#00ADEF"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M14.7441 5.95009V11.4588C15.4681 11.4589 16.185 11.3164 16.8539 11.0394C17.5227 10.7624 18.1305 10.3564 18.6424 9.84446C19.1543 9.33255 19.5604 8.72479 19.8374 8.05592C20.1144 7.38704 20.2569 6.67015 20.2567 5.94619V0.4375C19.5328 0.437372 18.8159 0.579872 18.147 0.85686C17.4781 1.13385 16.8704 1.5399 16.3585 2.05181C15.8465 2.56373 15.4405 3.17148 15.1635 3.84036C14.8865 4.50924 14.744 5.22613 14.7441 5.95009Z",
                fill: "#FFE200"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M14.7802 5.95009C14.7803 5.22597 14.6377 4.50891 14.3606 3.83991C14.0835 3.17091 13.6773 2.56307 13.1652 2.05113C12.653 1.53918 12.0451 1.13317 11.376 0.856301C10.7069 0.579427 9.98975 0.437116 9.26562 0.437501V5.95009C9.26601 6.67389 9.40895 7.39052 9.68629 8.05907C9.96363 8.72762 10.3699 9.335 10.882 9.84653C11.3941 10.3581 12.0019 10.7637 12.6707 11.0404C13.3396 11.317 14.0564 11.4592 14.7802 11.4588V5.95009Z",
                fill: "#64C2A1"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-icons-virtual-412b14e947/1/packages/lib-icons/src/standard/pei-icons.tsx
/* eslint-disable max-len */ 

const PeiIcons = (param)=>{
    let { size  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        fill: "none",
        height: size,
        viewBox: "0 0 24 18",
        width: size,
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M0.000148297 5.48462C-0.00928363 4.68116 0.431572 4.06494 1.21582 3.83508C1.72654 3.68731 2.25892 3.60696 2.78466 3.51264C4.78051 3.15516 6.77682 2.80164 8.77359 2.45208C10.836 2.08784 12.8986 1.725 14.9613 1.36356C16.5923 1.07606 18.2282 0.813016 19.8519 0.490234C21.2269 0.217756 21.9619 1.03764 22.153 2.11008C22.5177 4.15623 22.8842 6.20202 23.2527 8.24747C23.4933 9.5917 23.7417 10.9349 23.9709 12.2812C24.1431 13.2915 23.5381 14.1494 22.5103 14.3356C20.7127 14.6612 18.9122 14.9644 17.1111 15.2788L11.6018 16.236C9.75824 16.5569 7.91459 16.8777 6.07082 17.1984C5.36831 17.3206 4.66406 17.4317 3.96331 17.5638C2.70222 17.8013 2.02557 17.0048 1.84916 16.0466C1.37791 13.4766 0.92832 10.9027 0.470348 8.33061C0.319087 7.48279 0.167128 6.63531 0.0200602 5.78714C0.00683877 5.68684 0.00018731 5.58578 0.000148297 5.48462ZM3.29853 7.10761C3.76489 7.18725 3.78759 7.2159 3.78759 7.66164C3.78759 9.24528 3.78829 10.8289 3.78969 12.4125C3.78929 12.5982 3.80543 12.7835 3.8379 12.9662C4.00173 13.864 4.9858 14.4603 5.8731 14.1868V11.5071C6.09108 11.6692 6.29229 11.8763 6.53927 11.9926C7.42972 12.4146 8.95978 12.2218 9.66019 10.9405C10.1245 10.0909 10.2244 9.18787 10.1112 8.24188C9.99101 7.21101 9.38387 5.96704 7.76263 5.78329C7.02694 5.6991 6.35343 5.83709 5.82838 6.41209C5.75642 6.49104 5.69529 6.58012 5.61459 6.68282C5.54857 6.21402 5.3002 5.94643 4.87401 5.83255C4.38215 5.70085 3.89868 5.80565 3.41521 5.88111C3.38727 5.89166 3.36244 5.90906 3.34297 5.9317C3.3235 5.95434 3.31002 5.98151 3.30377 6.01071C3.29469 6.37296 3.29853 6.73627 3.29853 7.10761ZM12.9547 9.48864C13.0742 9.52742 13.1713 9.5613 13.2691 9.59065C14.1879 9.86452 15.0856 9.85369 15.9499 9.39223C17.1652 8.74352 17.2578 6.93783 16.0753 6.23323C14.9966 5.58976 13.8326 5.54086 12.669 6.01839C11.7338 6.40266 11.1435 7.10376 10.9118 8.09237C10.7686 8.70335 10.8008 9.31503 10.9262 9.9267C11.1008 10.7787 11.5626 11.4187 12.3438 11.7844C12.7322 11.9682 13.148 12.0875 13.5748 12.1376C14.5879 12.2459 15.5943 12.1918 16.5459 11.7565C16.7107 11.6807 16.7782 11.5885 16.7555 11.3995C16.7233 11.1274 16.7279 10.8507 16.7111 10.5765C16.7003 10.3959 16.6789 10.216 16.6625 10.036C16.6391 10.0365 16.6157 10.039 16.5927 10.0434C16.5228 10.0699 16.4561 10.1021 16.3855 10.1251C15.6337 10.3721 14.8736 10.5649 14.0708 10.457C13.4075 10.3679 13.0424 10.0601 12.9547 9.48864ZM17.9313 12.0248H20.0971V6.00023H17.9313V12.0248Z",
                fill: "#5A3795"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M12.9549 9.48826C13.0426 10.0598 13.409 10.3675 14.0703 10.4566C14.8737 10.5645 15.6332 10.3717 16.3849 10.1247C16.4548 10.1017 16.5247 10.0695 16.5921 10.043C16.6151 10.0386 16.6385 10.0361 16.662 10.0357C16.6784 10.2156 16.6997 10.3955 16.7105 10.5761C16.7273 10.8503 16.7227 11.127 16.7549 11.3991C16.7776 11.5881 16.7102 11.6803 16.5453 11.7561C15.5937 12.1914 14.589 12.2452 13.5742 12.1372C13.1474 12.0871 12.7316 11.9678 12.3432 11.7841C11.5631 11.4183 11.1013 10.7783 10.927 9.92632C10.8016 9.31324 10.7695 8.70366 10.9127 8.09198C11.1443 7.10338 11.7347 6.40227 12.6698 6.01801C13.8334 5.54047 14.9974 5.58938 16.0761 6.23285C17.2586 6.93745 17.166 8.74314 15.9507 9.39184C15.0861 9.85331 14.1887 9.86414 13.27 9.59026C13.1701 9.56092 13.0743 9.52703 12.9549 9.48826ZM13.0247 8.26909C13.4492 8.43572 13.8631 8.55345 14.3113 8.46297C14.6138 8.40289 14.8039 8.20202 14.8119 7.94876C14.8189 7.73043 14.6103 7.51209 14.3277 7.44083C13.6769 7.27909 13.1879 7.58161 13.0254 8.26909H13.0247Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M17.9316 12.0246V6H20.0975V12.0246H17.9316Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M6.00893 8.22212C6.24927 7.78721 6.75265 7.61918 7.16626 7.7142C7.62039 7.819 7.84501 8.14282 7.93863 8.5718C8.02492 8.96585 7.9816 9.35605 7.85235 9.73507C7.71681 10.1309 7.41987 10.3244 7.01395 10.3639C6.61921 10.4026 6.1022 10.1522 5.94395 9.8011C5.82169 9.53071 5.88072 8.45233 6.00893 8.22212Z",
                fill: "#5A3795"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M10.1127 8.24197C9.99114 7.21109 9.384 5.96713 7.76276 5.78338C7.02707 5.69919 6.35356 5.83717 5.82851 6.41217C5.75655 6.49147 5.69542 6.58055 5.61472 6.68325C5.5487 6.21445 5.30032 5.94686 4.87414 5.83298C4.38228 5.70128 3.89881 5.80608 3.41534 5.88154C3.3874 5.8921 3.36257 5.90949 3.3431 5.93214C3.32363 5.95478 3.31015 5.98194 3.3039 6.01114C3.29482 6.37445 3.29866 6.73775 3.29866 7.10909C3.76502 7.18874 3.78772 7.21738 3.78772 7.66313C3.78772 9.24676 3.78842 10.8304 3.78982 12.414C3.78942 12.5997 3.80556 12.7849 3.83803 12.9677C4.00186 13.8655 4.98593 14.4618 5.87323 14.1883V11.5072C6.09121 11.6693 6.29242 11.8764 6.5394 11.9927C7.42984 12.4147 8.95991 12.2219 9.66032 10.9405C10.126 10.091 10.2259 9.18796 10.1127 8.24197ZM7.85114 9.73536C7.7156 10.1311 7.41867 10.3247 7.01274 10.3642C6.98035 10.3671 6.9478 10.3682 6.91528 10.3673C6.80812 10.3701 6.70141 10.3525 6.60088 10.3152C6.31618 10.2276 6.04754 10.0375 5.941 9.80138C5.81838 9.53065 5.87742 8.45227 6.00458 8.22206C6.0972 8.0589 6.2317 7.92343 6.3942 7.82965C6.5567 7.73587 6.74129 7.68719 6.9289 7.68863C7.00731 7.68776 7.08554 7.69632 7.16191 7.71413C7.61604 7.81893 7.84066 8.14276 7.93428 8.57174C8.02371 8.96613 7.98039 9.35633 7.85114 9.73536Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M13.0254 8.26959C13.1878 7.58211 13.6769 7.27959 14.3277 7.44272C14.6103 7.51259 14.8189 7.73232 14.8119 7.95065C14.8038 8.20252 14.6138 8.40234 14.312 8.46347C13.8652 8.55394 13.4495 8.43622 13.0254 8.26959Z",
                fill: "#5A3795"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M20.1249 5.05328C20.225 4.85982 20.2735 4.64388 20.266 4.42621C20.2584 4.20855 20.195 3.99649 20.0817 3.81045C19.9685 3.62441 19.8093 3.47063 19.6194 3.36393C19.4296 3.25722 19.2154 3.20117 18.9976 3.20117C18.7798 3.20117 18.5657 3.25722 18.3758 3.36393C18.186 3.47063 18.0268 3.62441 17.9135 3.81045C17.8003 3.99649 17.7368 4.20855 17.7293 4.42621C17.7217 4.64388 17.7703 4.85982 17.8703 5.05328H20.1249Z",
                fill: "#F08422"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-icons-virtual-412b14e947/1/packages/lib-icons/src/standard/delivery-icons.tsx


const DeliveryIcons = (param)=>{
    let { size , iconColor  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        fill: "none",
        height: size,
        viewBox: "0 0 24 23",
        width: size,
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M9 6.5H18L19 10.5L23 12.5V18.5H17.829",
                stroke: iconColor,
                strokeMiterlimit: "10",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M9 2.5H1V18.5H9V2.5Z",
                stroke: iconColor,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                // eslint-disable-next-line max-len
                d: "M15 22.5C16.6569 22.5 18 21.1569 18 19.5C18 17.8431 16.6569 16.5 15 16.5C13.3431 16.5 12 17.8431 12 19.5C12 21.1569 13.3431 22.5 15 22.5Z",
                stroke: iconColor,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M14 9.5V11.5H16",
                stroke: iconColor,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-icons-virtual-412b14e947/1/packages/lib-icons/src/standard/deliver-order-icons.tsx
/* eslint-disable max-len */ 

const DeliverOrderIcons = (param)=>{
    let { size , iconColor  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        fill: "none",
        height: size,
        viewBox: "0 0 24 24",
        width: size,
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                clipPath: "url(#clip0_279_27484)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M6.5 3.25L18.5 9.25",
                        stroke: iconColor,
                        strokeMiterlimit: "10",
                        strokeWidth: "2"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M23 7L13 12L1 6",
                        stroke: iconColor,
                        strokeMiterlimit: "10",
                        strokeWidth: "2"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M13 12V23",
                        stroke: iconColor,
                        strokeMiterlimit: "10",
                        strokeWidth: "2"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M23 7V17L13 23L1 17V6L11 1L23 7Z",
                        stroke: iconColor,
                        strokeLinecap: "square",
                        strokeMiterlimit: "10",
                        strokeWidth: "2"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_279_27484",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        fill: "white",
                        height: "24",
                        width: "24"
                    })
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-icons-virtual-412b14e947/1/packages/lib-icons/src/standard/location-icons.tsx
/* eslint-disable max-len */ 

const LocationIcons = (param)=>{
    let { size , iconColor  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        fill: "none",
        height: size,
        viewBox: "0 0 24 24",
        width: size,
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                clipPath: "url(#clip0_1194_7374)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M19.8182 9.00012C19.8182 13.9381 11.8182 22.0001 11.8182 22.0001C11.8182 22.0001 3.81817 13.9381 3.81817 9.00012C3.81817 3.93812 7.95217 1.00012 11.8182 1.00012C15.6842 1.00012 19.8182 3.93812 19.8182 9.00012Z",
                        stroke: iconColor,
                        strokeLinecap: "square",
                        strokeMiterlimit: "10",
                        strokeWidth: "2"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M11.8182 12.0001C13.475 12.0001 14.8182 10.657 14.8182 9.00012C14.8182 7.34327 13.475 6.00012 11.8182 6.00012C10.1613 6.00012 8.81817 7.34327 8.81817 9.00012C8.81817 10.657 10.1613 12.0001 11.8182 12.0001Z",
                        stroke: iconColor,
                        strokeLinecap: "square",
                        strokeMiterlimit: "10",
                        strokeWidth: "2"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_1194_7374",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        fill: "white",
                        height: "24",
                        rx: "12",
                        width: "24",
                        y: "0.00012207"
                    })
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-icons-virtual-412b14e947/1/packages/lib-icons/src/standard/context-pro-user-icons.tsx
/* eslint-disable max-len */ 

const ContextProUserIcons = (param)=>{
    let { iconColor , size  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        height: size,
        viewBox: "0 0 32.736 44.195",
        width: size,
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
            transform: "translate(1799.885 1087.396)",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M-1783.516-934.867a16.387,16.387,0,0,0-16.369,16.369,1.819,1.819,0,0,0,1.819,1.819,1.846,1.846,0,0,0,.218-.014h28.664a1.846,1.846,0,0,0,.218.014,1.819,1.819,0,0,0,1.819-1.819A16.387,16.387,0,0,0-1783.516-934.867Zm0,3.638a12.73,12.73,0,0,1,12.63,11.152h-25.26A12.73,12.73,0,0,1-1783.516-931.229Z",
                    fill: iconColor,
                    transform: "translate(0 -126.522)"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M-1781.846-1070.436v.02h1.81a10.924,10.924,0,0,0,10.281,7.265,10.914,10.914,0,0,0,10.3-7.3h1.414c.05,0,.1.008.152.008s.111,0,.165-.008h.068v-.008a1.681,1.681,0,0,0,1.446-1.663,1.681,1.681,0,0,0-1.446-1.663v-.007h-.053a1.722,1.722,0,0,0-.342,0h-.925v-.033c0-.171,0-.321,0-.47a10.766,10.766,0,0,0-5.724-9.607.969.969,0,0,1-.352-.4,4.933,4.933,0,0,0-4.694-3.1h-.012a4.945,4.945,0,0,0-4.7,3.115.966.966,0,0,1-.355.4,10.672,10.672,0,0,0-5.655,8.588c-.04.391-.054.775-.069,1.182,0,.112-.008.225-.013.339h-1.07l-.222,0v.019a1.68,1.68,0,0,0-1.449,1.661A1.679,1.679,0,0,0-1781.846-1070.436Zm12.091,3.648a7.271,7.271,0,0,1-6.284-3.609l.587,0h11.445l.538-.01A7.27,7.27,0,0,1-1769.755-1066.788Zm-5.07-12.983v3.507l.006.182v.06h.019a1.693,1.693,0,0,0,1.674,1.464,1.694,1.694,0,0,0,1.676-1.464h.01v-.089c0-.046.006-.092.006-.138s0-.077-.006-.115v-2.045q0-1.979,0-3.959a1.67,1.67,0,0,1,1.666-1.684,1.683,1.683,0,0,1,1.207.481,1.687,1.687,0,0,1,.5,1.209q0,1.968,0,3.935v1.626l0,.781h.021a1.675,1.675,0,0,0,1.652,1.424,1.675,1.675,0,0,0,1.649-1.41l.022,0v-.016h0v-.483h0v-3.26a7.305,7.305,0,0,1,2.351,5.945h-14.771A7.5,7.5,0,0,1-1774.825-1079.771Z",
                    fill: iconColor,
                    transform: "translate(-13.761)"
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-icons-virtual-412b14e947/1/packages/lib-icons/src/standard/context-common-user-icons.tsx
/* eslint-disable max-len */ 

const ContextCommonUserIcons = (param)=>{
    let { iconColor , size  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        height: size,
        viewBox: "0 0 40.984 40.721",
        width: size,
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M39.483,15.382,26.53,2.5a8.587,8.587,0,0,0-12.077,0L1.5,15.382a5.041,5.041,0,0,0-1.5,3.6V35.649a5.108,5.108,0,0,0,5.123,5.093H35.861a5.108,5.108,0,0,0,5.123-5.093V18.983A5.041,5.041,0,0,0,39.483,15.382ZM25.615,37.347H15.369V30.668a5.123,5.123,0,0,1,10.246,0Zm11.954-1.7a1.7,1.7,0,0,1-1.708,1.7H29.03V30.668a8.538,8.538,0,0,0-17.077,0v6.679H5.123a1.7,1.7,0,0,1-1.708-1.7V18.983a1.706,1.706,0,0,1,.5-1.2L16.868,4.909a5.158,5.158,0,0,1,7.247,0L37.068,17.788a1.706,1.706,0,0,1,.5,1.2Z",
            fill: iconColor,
            transform: "translate(0 -0.021)"
        })
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-icons-virtual-412b14e947/1/packages/lib-icons/src/standard/context-alternate-icons.tsx
/* eslint-disable max-len */ 

const ContextAlternateIcons = (param)=>{
    let { iconColor , size  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        height: size,
        viewBox: "0 0 89.314 82.262",
        width: size,
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
            id: "Group_10102",
            transform: "translate(-20178.314 -17401.335)",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                    id: "Group_10101",
                    transform: "translate(22034.777 18503.922)",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M-1783.516-934.867a16.387,16.387,0,0,0-16.369,16.369,1.819,1.819,0,0,0,1.819,1.819,1.846,1.846,0,0,0,.218-.014h28.664a1.846,1.846,0,0,0,.218.014,1.819,1.819,0,0,0,1.819-1.819A16.387,16.387,0,0,0-1783.516-934.867Zm0,3.638a12.73,12.73,0,0,1,12.63,11.152h-25.26A12.73,12.73,0,0,1-1783.516-931.229Z",
                            fill: iconColor,
                            transform: "translate(0 -126.522)"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M-1781.846-1070.436v.02h1.81a10.924,10.924,0,0,0,10.281,7.265,10.914,10.914,0,0,0,10.3-7.3h1.414c.05,0,.1.008.152.008s.111,0,.165-.008h.068v-.008a1.681,1.681,0,0,0,1.446-1.663,1.681,1.681,0,0,0-1.446-1.663v-.007h-.053a1.722,1.722,0,0,0-.342,0h-.925v-.033c0-.171,0-.321,0-.47a10.766,10.766,0,0,0-5.724-9.607.969.969,0,0,1-.352-.4,4.933,4.933,0,0,0-4.694-3.1h-.012a4.945,4.945,0,0,0-4.7,3.115.966.966,0,0,1-.355.4,10.672,10.672,0,0,0-5.655,8.588c-.04.391-.054.775-.069,1.182,0,.112-.008.225-.013.339h-1.07l-.222,0v.019a1.68,1.68,0,0,0-1.449,1.661A1.679,1.679,0,0,0-1781.846-1070.436Zm12.091,3.648a7.271,7.271,0,0,1-6.284-3.609l.587,0h11.445l.538-.01A7.27,7.27,0,0,1-1769.755-1066.788Zm-5.07-12.983v3.507l.006.182v.06h.019a1.693,1.693,0,0,0,1.674,1.464,1.694,1.694,0,0,0,1.676-1.464h.01v-.089c0-.046.006-.092.006-.138s0-.077-.006-.115v-2.045q0-1.979,0-3.959a1.67,1.67,0,0,1,1.666-1.684,1.683,1.683,0,0,1,1.207.481,1.687,1.687,0,0,1,.5,1.209q0,1.968,0,3.935v1.626l0,.781h.021a1.675,1.675,0,0,0,1.652,1.424,1.675,1.675,0,0,0,1.649-1.41l.022,0v-.016h0v-.483h0v-3.26a7.305,7.305,0,0,1,2.351,5.945h-14.771A7.5,7.5,0,0,1-1774.825-1079.771Z",
                            fill: iconColor,
                            transform: "translate(-13.761)"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M39.483,15.382,26.53,2.5a8.587,8.587,0,0,0-12.077,0L1.5,15.382a5.041,5.041,0,0,0-1.5,3.6V35.649a5.108,5.108,0,0,0,5.123,5.093H35.861a5.108,5.108,0,0,0,5.123-5.093V18.983A5.041,5.041,0,0,0,39.483,15.382ZM25.615,37.347H15.369V30.668a5.123,5.123,0,0,1,10.246,0Zm11.954-1.7a1.7,1.7,0,0,1-1.708,1.7H29.03V30.668a8.538,8.538,0,0,0-17.077,0v6.679H5.123a1.7,1.7,0,0,1-1.708-1.7V18.983a1.706,1.706,0,0,1,.5-1.2L16.868,4.909a5.158,5.158,0,0,1,7.247,0L37.068,17.788a1.706,1.706,0,0,1,.5,1.2Z",
                    fill: iconColor,
                    transform: "translate(20178.314 17419.979)"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M-2307.452-1300.364c0-1.04,0-2.018,0-3a1.423,1.423,0,0,1,.571-1.186,1.358,1.358,0,0,1,1.483-.173,1.322,1.322,0,0,1,.842,1.232c.011,2.067.03,4.135,0,6.2a2.6,2.6,0,0,1-2.634,2.642c-2.067.036-4.134.018-6.2.005a1.425,1.425,0,0,1-1.373-1.43,1.428,1.428,0,0,1,1.38-1.458c1.393-.016,2.787-.007,4.18-.008h.474c-.308-.288-.546-.522-.8-.742a14.412,14.412,0,0,0-7.672-3.511,14.191,14.191,0,0,0-7.548.989,14.4,14.4,0,0,0-5.2,3.645,14.177,14.177,0,0,0-3.451,6.674c-.122.58-.206,1.167-.293,1.754a1.458,1.458,0,0,1-1.883,1.351,1.453,1.453,0,0,1-1.042-1.64c.1-.779.224-1.56.4-2.326a17.006,17.006,0,0,1,4.263-7.968,17.1,17.1,0,0,1,9.3-5.188,17.069,17.069,0,0,1,12.224,2c.935.537,1.775,1.24,2.657,1.868C-2307.687-1300.557-2307.6-1300.478-2307.452-1300.364Z",
                    fill: iconColor,
                    transform: "matrix(0.966, 0.259, -0.259, 0.966, 22132.066, 19266.5)"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M-2307.452-1300.364c0-1.04,0-2.018,0-3a1.423,1.423,0,0,1,.571-1.186,1.358,1.358,0,0,1,1.483-.173,1.322,1.322,0,0,1,.842,1.232c.011,2.067.03,4.135,0,6.2a2.6,2.6,0,0,1-2.634,2.642c-2.067.036-4.134.018-6.2.005a1.425,1.425,0,0,1-1.373-1.43,1.428,1.428,0,0,1,1.38-1.458c1.393-.016,2.787-.007,4.18-.008h.474c-.308-.288-.546-.522-.8-.742a14.412,14.412,0,0,0-7.672-3.511,14.191,14.191,0,0,0-7.548.989,14.4,14.4,0,0,0-5.2,3.645,14.177,14.177,0,0,0-3.451,6.674c-.122.58-.206,1.167-.293,1.754a1.458,1.458,0,0,1-1.883,1.351,1.453,1.453,0,0,1-1.042-1.64c.1-.779.224-1.56.4-2.326a17.006,17.006,0,0,1,4.263-7.968,17.1,17.1,0,0,1,9.3-5.188,17.069,17.069,0,0,1,12.224,2c.935.537,1.775,1.24,2.657,1.868C-2307.687-1300.557-2307.6-1300.478-2307.452-1300.364Z",
                    fill: iconColor,
                    transform: "matrix(-0.966, -0.259, 0.259, -0.966, 18319.934, 15618.43)"
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-icons-virtual-412b14e947/1/packages/lib-icons/src/standard/index.ts










































































































;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-icons-virtual-412b14e947/1/packages/lib-icons/src/decorative/filled/barbecue-tools-filled-decorative.tsx


const BarbecueToolsFilledDecorative = (param)=>{
    let { size  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        fill: "none",
        height: size,
        viewBox: "0 0 48 48",
        width: size,
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                // eslint-disable-next-line max-len
                d: "M36 31C35.4477 31 35 30.5522 35 30V18C35 17.4477 35.4477 17 36 17C36.5523 17 37 17.4477 37 18V30C37 30.5522 36.5523 31 36 31Z",
                fill: "#AEAEAE"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                // eslint-disable-next-line max-len
                d: "M12 31C11.4477 31 11 30.5522 11 30V18C11 17.4477 11.4477 17 12 17C12.5523 17 13 17.4477 13 18V30C13 30.5522 12.5523 31 12 31Z",
                fill: "#AEAEAE"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                // eslint-disable-next-line max-len
                d: "M12 19C8.14014 19 5 15.8599 5 12V2C5 1.44775 5.44775 1 6 1C6.55225 1 7 1.44775 7 2V12C7 14.7568 9.24316 17 12 17C14.7568 17 17 14.7568 17 12V2C17 1.44775 17.4478 1 18 1C18.5522 1 19 1.44775 19 2V12C19 15.8599 15.8599 19 12 19Z",
                fill: "#AEAEAE"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                // eslint-disable-next-line max-len
                d: "M11.5002 46.9755C8.90274 46.722 6.99999 44.3868 7 41.777V30C7 29.4477 7.44772 29 8 29H16C16.5523 29 17 29.4477 17 30V42C17 44.9217 14.4805 47.2665 11.5002 46.9755Z",
                fill: "#FFD330"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                // eslint-disable-next-line max-len
                d: "M16 31H8C7.44772 31 7 30.5523 7 30C7 29.4477 7.44771 29 8 29H16C16.5523 29 17 29.4477 17 30C17 30.5523 16.5523 31 16 31Z",
                fill: "#00416A"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                // eslint-disable-next-line max-len
                d: "M35.5002 46.9755C32.9027 46.722 31 44.3868 31 41.777V30C31 29.4477 31.4477 29 32 29H40C40.5523 29 41 29.4477 41 30V42C41 44.9217 38.4805 47.2665 35.5002 46.9755Z",
                fill: "#FFD330"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                // eslint-disable-next-line max-len
                d: "M40 31H32C31.4477 31 31 30.5523 31 30C31 29.4477 31.4477 29 32 29H40C40.5523 29 41 29.4477 41 30C41 30.5523 40.5523 31 40 31Z",
                fill: "#00416A"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                // eslint-disable-next-line max-len
                d: "M43 1H29C27.8954 1 27 1.89545 27 3V19C27 20.1045 27.8954 21 29 21H43C44.1046 21 45 20.1045 45 19V3C45 1.89545 44.1046 1 43 1ZM34 16C34 16.5522 33.5522 17 33 17C32.4478 17 32 16.5522 32 16V6C32 5.44775 32.4478 5 33 5C33.5522 5 34 5.44775 34 6V16ZM40 16C40 16.5522 39.5522 17 39 17C38.4478 17 38 16.5522 38 16V6C38 5.44775 38.4478 5 39 5C39.5522 5 40 5.44775 40 6V16Z",
                fill: "#AEAEAE"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-icons-virtual-412b14e947/1/packages/lib-icons/src/decorative/filled/design-filled-decorative.tsx


const DesignFilledDecorative = (param)=>{
    let { size  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        fill: "none",
        height: size,
        viewBox: "0 0 48 48",
        width: size,
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M39.4719 43.839L40.6549 40.655L43.8389 39.472L44.9299 44.93L39.4719 43.839Z",
                fill: "#0A3A5C"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M33.1619 42.577L35.6549 35.364L42.5769 33.162L43.8389 39.472L39.4719 43.839L33.1619 42.577Z",
                fill: "#FFEC8E"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                // eslint-disable-next-line max-len
                d: "M13.0698 3.65496L18.3628 8.94796L14.6558 14.655L8.94884 18.362L3.65484 13.07C2.87384 12.289 2.87384 11.023 3.65484 10.242L10.2408 3.65596C11.0218 2.87396 12.2888 2.87396 13.0698 3.65496Z",
                fill: "#0A3A5C"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M18.362 8.94912L12.655 14.6561L36.869 38.8701L42.576 33.1631L18.362 8.94912Z",
                fill: "#00416A"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M13.6549 13.6556L8.94775 18.3628L33.1617 42.5767L37.8688 37.8696L13.6549 13.6556Z",
                fill: "#00416A"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M17.6553 8.2404L8.24097 17.6547L9.65517 19.0689L19.0695 9.6546L17.6553 8.2404Z",
                fill: "#E6E7E8"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                // eslint-disable-next-line max-len
                d: "M45.2129 12.686L35.3139 2.78698C34.5329 2.00598 33.2669 2.00598 32.4859 2.78698L2.78692 32.485C2.00592 33.266 2.00592 34.532 2.78692 35.313L12.6859 45.212C13.4669 45.993 14.7329 45.993 15.5139 45.212L45.2119 15.514C45.9939 14.734 45.9939 13.467 45.2129 12.686Z",
                fill: "#FFD330"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M29.6566 5.61571L28.2424 7.02991L33.8992 12.6867L35.3134 11.2725L29.6566 5.61571Z",
                fill: "#0A3A5C"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M23.9999 11.272L22.5857 12.6862L26.1212 16.2217L27.5354 14.8075L23.9999 11.272Z",
                fill: "#0A3A5C"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M18.3422 16.929L16.928 18.3432L22.5848 24L23.999 22.5858L18.3422 16.929Z",
                fill: "#0A3A5C"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M7.02919 28.2422L5.61499 29.6564L11.2718 35.3132L12.686 33.899L7.02919 28.2422Z",
                fill: "#0A3A5C"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M12.6862 22.586L11.272 24.0002L14.8075 27.5357L16.2217 26.1215L12.6862 22.586Z",
                fill: "#0A3A5C"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-icons-virtual-412b14e947/1/packages/lib-icons/src/decorative/filled/drill-filled-decorative.tsx


const DrillFilledDecorative = (param)=>{
    let { size  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        fill: "none",
        height: size,
        viewBox: "0 0 48 48",
        width: size,
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                clipPath: "url(#clip0_1144_7151)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        // eslint-disable-next-line max-len
                        d: "M29 42V40.389C29.0032 39.2044 28.5844 38.0574 27.8186 37.1536C27.0528 36.2498 25.9901 35.6483 24.821 35.457L19.984 34.65C19.2139 34.5254 18.523 34.1047 18.0589 33.4776C17.5948 32.8506 17.3942 32.0669 17.5 31.294L18.988 20.132C19.0068 19.991 18.9953 19.8477 18.9543 19.7116C18.9133 19.5754 18.8437 19.4496 18.7502 19.3424C18.6567 19.2353 18.5414 19.1493 18.412 19.0903C18.2827 19.0312 18.1422 19.0005 18 19H8.00003C7.75772 19.0001 7.52368 19.0881 7.3414 19.2478C7.15912 19.4074 7.04101 19.6278 7.00903 19.868L5.31703 32.551C5.2467 33.078 5.0376 33.5768 4.71113 33.9964C4.38466 34.416 3.95255 34.7413 3.45903 34.939L3.14403 35.065C2.21395 35.4331 1.41644 36.0731 0.855586 36.9014C0.29473 37.7296 -0.0034254 38.7077 2.9692e-05 39.708V42H29Z",
                        fill: "#FFD330"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        // eslint-disable-next-line max-len
                        d: "M35.6 4.2L31.6 1.2C31.4269 1.07018 31.2164 1 31 1H26V21H31C31.2164 21 31.4269 20.9298 31.6 20.8L35.6 17.8C35.7242 17.7069 35.825 17.5861 35.8944 17.4472C35.9639 17.3084 36 17.1552 36 17V5C36 4.84475 35.9639 4.69164 35.8944 4.55279C35.825 4.41393 35.7242 4.29315 35.6 4.2Z",
                        fill: "#C6C6C6"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        // eslint-disable-next-line max-len
                        d: "M26 1H5C3.67441 1.00159 2.40356 1.52888 1.46622 2.46622C0.528882 3.40356 0.00158786 4.67441 0 6L0 16C0.00158786 17.3256 0.528882 18.5964 1.46622 19.5338C2.40356 20.4711 3.67441 20.9984 5 21H26V1Z",
                        fill: "#FFD330"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        // eslint-disable-next-line max-len
                        d: "M0 42V46C0 46.2652 0.105357 46.5196 0.292893 46.7071C0.48043 46.8946 0.734784 47 1 47H28C28.2652 47 28.5196 46.8946 28.7071 46.7071C28.8946 46.5196 29 46.2652 29 46V42H0Z",
                        fill: "#0A3A5C"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        // eslint-disable-next-line max-len
                        d: "M17.675 30H19.982C20.1525 30.0001 20.3202 29.9566 20.4691 29.8737C20.6181 29.7907 20.7433 29.6711 20.833 29.5261C20.9227 29.3811 20.9738 29.2156 20.9815 29.0453C20.9892 28.875 20.9533 28.7055 20.8771 28.553L18.5 23.8L17.675 30Z",
                        fill: "#FFD330"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        // eslint-disable-next-line max-len
                        d: "M11 14H7C6.44772 14 6 14.4477 6 15C6 15.5523 6.44772 16 7 16H11C11.5523 16 12 15.5523 12 15C12 14.4477 11.5523 14 11 14Z",
                        fill: "#0A3A5C"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        // eslint-disable-next-line max-len
                        d: "M11 10H7C6.44772 10 6 10.4477 6 11C6 11.5523 6.44772 12 7 12H11C11.5523 12 12 11.5523 12 11C12 10.4477 11.5523 10 11 10Z",
                        fill: "#0A3A5C"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        // eslint-disable-next-line max-len
                        d: "M11 6H7C6.44772 6 6 6.44772 6 7C6 7.55228 6.44772 8 7 8H11C11.5523 8 12 7.55228 12 7C12 6.44772 11.5523 6 11 6Z",
                        fill: "#0A3A5C"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M28 1H26V21H28V1Z",
                        fill: "#AEAEAE"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        // eslint-disable-next-line max-len
                        d: "M42 10H47C47.2652 10 47.5196 10.1054 47.7071 10.2929C47.8946 10.4804 48 10.7348 48 11C48 11.2652 47.8946 11.5196 47.7071 11.7071C47.5196 11.8946 47.2652 12 47 12H42V10Z",
                        fill: "#0A3A5C"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        // eslint-disable-next-line max-len
                        d: "M42 12V8C42 7.73478 41.8946 7.48043 41.7071 7.29289C41.5196 7.10536 41.2652 7 41 7H36V15H41C41.2652 15 41.5196 14.8946 41.7071 14.7071C41.8946 14.5196 42 14.2652 42 14V12Z",
                        fill: "#AEAEAE"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M6.59106 23H18.6091L18.8751 21H6.85806L6.59106 23Z",
                        fill: "#FFD330"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        // eslint-disable-next-line max-len
                        d: "M10 37C11.1046 37 12 36.1046 12 35C12 33.8954 11.1046 33 10 33C8.89543 33 8 33.8954 8 35C8 36.1046 8.89543 37 10 37Z",
                        fill: "#0A3A5C"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_1144_7151",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        fill: "white",
                        height: "48",
                        width: "48"
                    })
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-icons-virtual-412b14e947/1/packages/lib-icons/src/decorative/filled/measure-1-filled-decorative.tsx


const Measure1FilledDecorative = (param)=>{
    let { size  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        fill: "none",
        height: size,
        viewBox: "0 0 48 48",
        width: size,
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                // eslint-disable-next-line max-len
                d: "M31 2H17C15.895 2 15 2.895 15 4V46C15 47.105 15.895 48 17 48H31C32.105 48 33 47.105 33 46V4C33 2.895 32.105 2 31 2Z",
                fill: "#FFD330"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M23 8H15V10H23V8Z",
                fill: "#0A3A5C"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M20 16H15V18H20V16Z",
                fill: "#0A3A5C"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M23 24H15V26H23V24Z",
                fill: "#0A3A5C"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M23 40H15V42H23V40Z",
                fill: "#0A3A5C"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M20 32H15V34H20V32Z",
                fill: "#0A3A5C"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-icons-virtual-412b14e947/1/packages/lib-icons/src/decorative/filled/measure-2-filled-decorative.tsx


const Measure2FilledDecorative = (param)=>{
    let { size  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        fill: "none",
        height: size,
        viewBox: "0 0 48 48",
        width: size,
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                // eslint-disable-next-line max-len
                d: "M45.213 12.686L35.314 2.78698C34.533 2.00598 33.267 2.00598 32.486 2.78698L2.78704 32.485C2.00604 33.266 2.00604 34.532 2.78704 35.313L12.686 45.212C13.467 45.993 14.733 45.993 15.514 45.212L45.212 15.514C45.994 14.734 45.994 13.467 45.213 12.686Z",
                fill: "#FFD330"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M29.6566 5.61571L28.2424 7.02991L33.8992 12.6867L35.3134 11.2725L29.6566 5.61571Z",
                fill: "#0A3A5C"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M24 11.272L22.5858 12.6862L26.1213 16.2217L27.5355 14.8075L24 11.272Z",
                fill: "#0A3A5C"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M18.3422 16.929L16.928 18.3432L22.5848 24L23.999 22.5858L18.3422 16.929Z",
                fill: "#0A3A5C"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M7.02919 28.2422L5.61499 29.6564L11.2718 35.3132L12.686 33.899L7.02919 28.2422Z",
                fill: "#0A3A5C"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M12.6863 22.586L11.2721 24.0002L14.8076 27.5357L16.2218 26.1215L12.6863 22.586Z",
                fill: "#0A3A5C"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-icons-virtual-412b14e947/1/packages/lib-icons/src/decorative/filled/measure-big-filled-decorative.tsx


const MeasureBigFilledDecorative = (param)=>{
    let { size  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        fill: "none",
        height: size,
        viewBox: "0 0 48 48",
        width: size,
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                // eslint-disable-next-line max-len
                d: "M42.707 43.293L2.707 3.29304C2.42 3.00604 1.99 2.92104 1.617 3.07604C1.244 3.23104 1 3.59604 1 4.00004V44C1 44.552 1.448 45 2 45H42C42.404 45 42.769 44.756 42.924 44.383C43.079 44.009 42.993 43.579 42.707 43.293ZM22.924 36.383C22.769 36.756 22.404 37 22 37H12C11.448 37 11 36.552 11 36V26C11 25.596 11.244 25.231 11.617 25.076C11.991 24.92 12.42 25.006 12.707 25.293L22.707 35.293C22.993 35.579 23.079 36.009 22.924 36.383Z",
                fill: "#FFD330"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M5 20H1V22H5V20Z",
                fill: "#0A3A5C"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M5 14H1V16H5V14Z",
                fill: "#0A3A5C"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M5 26H1V28H5V26Z",
                fill: "#0A3A5C"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M5 32H1V34H5V32Z",
                fill: "#0A3A5C"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M5 38H1V40H5V38Z",
                fill: "#0A3A5C"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-icons-virtual-412b14e947/1/packages/lib-icons/src/decorative/filled/paint-brush-filled-decorative.tsx


const PaintBrushFilledDecorative = (param)=>{
    let { size  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        fill: "none",
        height: size,
        viewBox: "0 0 48 48",
        width: size,
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                // eslint-disable-next-line max-len
                d: "M30.749 41.293L6.70703 17.251L21.556 2.40203C22.337 1.62103 23.603 1.62103 24.384 2.40203L35.913 13.93C36.209 14.226 36.289 14.675 36.114 15.055L32.84 22.172L40.018 18.948C40.397 18.778 40.841 18.86 41.135 19.153L45.597 23.615C46.378 24.396 46.378 25.662 45.597 26.443L30.749 41.293Z",
                fill: "#E6E7E8"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M32.1627 39.8782L8.12134 15.8368L6.70714 17.251L30.7485 41.2924L32.1627 39.8782Z",
                fill: "#C6C6C6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                // eslint-disable-next-line max-len
                d: "M6.70692 17.251L5.99992 17.958C3.27092 20.687 3.27092 25.129 5.99992 27.857L9.53592 31.393L2.46492 38.464C0.515924 40.413 0.515924 43.586 2.46492 45.535C4.41392 47.484 7.58692 47.484 9.53592 45.535L16.6069 38.464L20.1419 42C22.8709 44.729 27.3119 44.729 30.0409 42L30.7479 41.293L6.70692 17.251ZM4.58592 43.414C3.80492 42.633 3.80492 41.367 4.58592 40.586C5.36692 39.805 6.63292 39.805 7.41392 40.586C8.19492 41.367 8.19492 42.633 7.41392 43.414C6.63292 44.195 5.36692 44.195 4.58592 43.414Z",
                fill: "#0A3A5C"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                // eslint-disable-next-line max-len
                d: "M4.58599 43.414C3.80499 42.633 3.80499 41.367 4.58599 40.586C5.36699 39.805 6.63299 39.805 7.41399 40.586C8.19499 41.367 8.19499 42.633 7.41399 43.414C6.63299 44.195 5.36699 44.195 4.58599 43.414Z",
                fill: "#E6E7E8"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-icons-virtual-412b14e947/1/packages/lib-icons/src/decorative/filled/paint-bucket-1-filled-decorative.tsx


const PaintBucket1FilledDecorative = (param)=>{
    let { size  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        fill: "none",
        height: size,
        viewBox: "0 0 48 48",
        width: size,
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M24 1C14.789 1 5 3.453 5 8V40C5 44.547 14.789 47 24 47C33.211 47 43 44.547 43 40V8C43 3.453 33.211 1 24 1Z",
                fill: "#0A3A5C"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                // eslint-disable-next-line max-len
                d: "M41 8C41 5.912 34.532 3 24 3C13.468 3 7 5.912 7 8C7 10.088 13.468 13 24 13C24.676 13 25.331 12.985 25.969 12.96C26.534 12.938 27 13.394 27 13.959V25.83C27 27.454 28.216 28.911 29.839 28.995C31.569 29.086 33 27.71 33 26V12.988C33 12.516 33.334 12.115 33.794 12.011C38.387 10.977 41 9.324 41 8Z",
                fill: "#FFD330"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-icons-virtual-412b14e947/1/packages/lib-icons/src/decorative/filled/paint-bucket-2-filled-decorative.tsx


const PaintBucket2FilledDecorative = (param)=>{
    let { size  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        fill: "none",
        height: size,
        viewBox: "0 0 48 48",
        width: size,
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                // eslint-disable-next-line max-len
                d: "M42.3561 23.388L27.2701 2.81495C27.1421 2.59695 26.7861 2.15895 26.7401 2.11295C25.2981 0.669955 22.7361 0.633955 19.5331 2.00795C16.6141 3.25795 13.3971 5.55595 10.4761 8.47695C7.5551 11.398 5.2571 14.614 4.0071 17.533C2.6331 20.739 2.6701 23.299 4.1121 24.741C4.1571 24.786 4.6111 25.152 4.8191 25.274L25.3861 40.357C25.9311 40.868 26.6401 41.098 27.4601 41.098C30.1851 41.098 34.1321 38.56 37.3451 35.348C41.5261 31.167 44.5641 25.743 42.3561 23.388Z",
                fill: "#0A3A5C"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                // eslint-disable-next-line max-len
                d: "M6.823 31.432C6.448 30.891 5.552 30.891 5.177 31.432C4.479 32.441 1 37.601 1 40C1 42.757 3.243 45 6 45C8.757 45 11 42.757 11 40C11 37.601 7.521 32.441 6.823 31.432Z",
                fill: "#FFD330"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                // eslint-disable-next-line max-len
                d: "M32 5H28.872L30.339 7H32C35.859 7 39 10.14 39 14C39 17.86 35.859 21 32 21H24C23.447 21 23 21.448 23 22C23 22.552 23.447 23 24 23H32C36.963 23 41 18.962 41 14C41 9.038 36.963 5 32 5Z",
                fill: "#C6C6C6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                // eslint-disable-next-line max-len
                d: "M20.32 3.84596C17.63 4.99896 14.636 7.14596 11.89 9.89096C9.14504 12.637 6.99804 15.63 5.84504 18.32C4.84504 20.654 4.72604 22.525 5.52704 23.326C6.32604 24.125 8.19804 24.008 10.533 23.008C13.223 21.855 16.217 19.708 18.962 16.963C21.707 14.218 23.855 11.224 25.008 8.53296C26.008 6.19996 26.127 4.32796 25.326 3.52796C24.974 3.17596 24.416 3.00196 23.703 3.00196C22.792 3.00096 21.629 3.28496 20.32 3.84596Z",
                fill: "#FFD330"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-icons-virtual-412b14e947/1/packages/lib-icons/src/decorative/filled/paint-filled-decorative.tsx


const PaintFilledDecorative = (param)=>{
    let { size  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        fill: "none",
        height: size,
        viewBox: "0 0 48 48",
        width: size,
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                // eslint-disable-next-line max-len
                d: "M7 22C7 26.418 10.582 30 15 30H20V43C20 45.209 21.791 47 24 47C26.209 47 28 45.209 28 43V30H33C37.418 30 41 26.418 41 22H7Z",
                fill: "#0A3A5C"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M41 6H7V22H41V6Z",
                fill: "#E6E7E8"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                // eslint-disable-next-line max-len
                d: "M41 3C41 1.895 40.105 1 39 1H9C7.895 1 7 1.895 7 3V8H30C30.552 8 31 8.448 31 9V14.893C31 15.889 31.681 16.813 32.664 16.973C33.917 17.176 35 16.215 35 15V9C35 8.448 35.448 8 36 8H41V3Z",
                fill: "#80B3D2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M41 20H7V22H41V20Z",
                fill: "#AEAEAE"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-icons-virtual-412b14e947/1/packages/lib-icons/src/decorative/filled/paint-roll-filled-decorative.tsx


const PaintRollFilledDecorative = (param)=>{
    let { size  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        fill: "none",
        height: size,
        viewBox: "0 0 48 48",
        width: size,
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M25 26H23V21H2C1.447 21 1 20.552 1 20V8C1 7.448 1.447 7 2 7H8V9H3V19H24C24.553 19 25 19.448 25 20V26Z",
                fill: "#AEAEAE"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M28 26H20V46H28V26Z",
                fill: "#FFD330"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                // eslint-disable-next-line max-len
                d: "M28 47H20C19.447 47 19 46.552 19 46V26C19 25.448 19.447 25 20 25H28C28.553 25 29 25.448 29 26V46C29 46.552 28.553 47 28 47ZM21 45H27V27H21V45Z",
                fill: "#FFD330"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M38 32C38 29.791 42 24 42 24C42 24 46 29.791 46 32C46 34.209 44.209 36 42 36C39.791 36 38 34.209 38 32Z",
                fill: "#00416A"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                // eslint-disable-next-line max-len
                d: "M42 37C39.243 37 37 34.757 37 32C37 29.601 40.479 24.441 41.177 23.432L42 22.24L42.823 23.431C43.521 24.441 47 29.601 47 32C47 34.757 44.757 37 42 37ZM42 25.808C40.561 28.057 39 30.908 39 32C39 33.654 40.346 35 42 35C43.654 35 45 33.654 45 32C45 30.907 43.439 28.057 42 25.808Z",
                fill: "#00416A"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M40 15H8C6.895 15 6 14.105 6 13V4H42V13C42 14.105 41.105 15 40 15Z",
                fill: "#E6E7E8"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M42 3V5H6V3C6 1.895 6.895 1 8 1H40C41.105 1 42 1.895 42 3Z",
                fill: "#00416A"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-icons-virtual-412b14e947/1/packages/lib-icons/src/decorative/filled/pickaxe-filled-decorative.tsx


const PickaxeFilledDecorative = (param)=>{
    let { size  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        fill: "none",
        height: size,
        viewBox: "0 0 48 48",
        width: size,
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                // eslint-disable-next-line max-len
                d: "M14.3218 3.11803L15.3598 1.04203C15.4678 0.826689 15.6498 0.657546 15.8725 0.565687C16.0951 0.473828 16.3435 0.465426 16.5718 0.542025C23.7494 2.96689 30.2706 7.01526 35.6279 12.3721C40.9853 17.7289 45.0343 24.2497 47.4598 31.427C47.5364 31.6554 47.528 31.9037 47.4362 32.1264C47.3443 32.3491 47.1752 32.5311 46.9598 32.639L44.8998 33.669C44.7819 33.7279 44.6535 33.7629 44.522 33.772C44.3905 33.7811 44.2585 33.7641 44.1336 33.722C44.0087 33.6799 43.8934 33.6135 43.7942 33.5267C43.6951 33.4399 43.614 33.3343 43.5558 33.216C37.377 20.7333 27.2635 10.6297 14.7748 4.46303C14.6564 4.40482 14.5508 4.32376 14.4638 4.22453C14.3769 4.12529 14.3105 4.00984 14.2684 3.88482C14.2263 3.7598 14.2093 3.62768 14.2185 3.49608C14.2277 3.36448 14.2628 3.23599 14.3218 3.11803V3.11803Z",
                fill: "#C6C6C6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                // eslint-disable-next-line max-len
                d: "M39.751 17.071L35.719 21.1C33.0703 17.8787 30.1122 14.9249 26.887 12.281L30.925 8.24304C34.2274 10.8018 37.1929 13.768 39.751 17.071V17.071Z",
                fill: "#AEAEAE"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                // eslint-disable-next-line max-len
                d: "M27.2928 14.707L33.7068 8.29303C33.8944 8.10556 34.1487 8.00024 34.4138 8.00024C34.679 8.00024 34.9333 8.10556 35.1208 8.29303L39.7058 12.873C39.7988 12.9659 39.8726 13.0762 39.9229 13.1976C39.9732 13.319 39.9991 13.4491 39.9991 13.5805C39.9991 13.7119 39.9732 13.8421 39.9229 13.9635C39.8726 14.0849 39.7988 14.1952 39.7058 14.288L33.2858 20.708C33.193 20.801 33.0827 20.8748 32.9613 20.9251C32.8399 20.9754 32.7097 21.0013 32.5783 21.0013C32.4469 21.0013 32.3168 20.9754 32.1954 20.9251C32.074 20.8748 31.9637 20.801 31.8708 20.708L27.2908 16.123C27.1978 16.03 27.1241 15.9196 27.0739 15.798C27.0236 15.6764 26.9979 15.5462 26.998 15.4146C26.9982 15.2831 27.0244 15.1529 27.075 15.0315C27.1255 14.91 27.1996 14.7998 27.2928 14.707Z",
                fill: "#C6C6C6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                // eslint-disable-next-line max-len
                d: "M32 20L9.24195 44.758C8.84823 45.1524 8.38061 45.4653 7.86583 45.6788C7.35106 45.8923 6.79924 46.0022 6.24195 46.0022C5.68467 46.0022 5.13285 45.8923 4.61808 45.6788C4.1033 45.4653 3.63568 45.1524 3.24195 44.758V44.758C2.84755 44.3643 2.53466 43.8967 2.32117 43.3819C2.10769 42.8671 1.9978 42.3153 1.9978 41.758C1.9978 41.2007 2.10769 40.6489 2.32117 40.1341C2.53466 39.6193 2.84755 39.1517 3.24195 38.758L28 16L32 20Z",
                fill: "#FFD330"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                // eslint-disable-next-line max-len
                d: "M3.24195 38.7581L7.89995 34.4811L13.519 40.1001L9.24195 44.7581C8.84823 45.1525 8.38061 45.4654 7.86583 45.6789C7.35106 45.8923 6.79924 46.0022 6.24195 46.0022C5.68467 46.0022 5.13285 45.8923 4.61808 45.6789C4.1033 45.4654 3.63568 45.1525 3.24195 44.7581V44.7581C2.84755 44.3644 2.53466 43.8967 2.32117 43.382C2.10769 42.8672 1.9978 42.3154 1.9978 41.7581C1.9978 41.2008 2.10769 40.649 2.32117 40.1342C2.53466 39.6194 2.84755 39.1518 3.24195 38.7581V38.7581Z",
                fill: "#0A3A5C"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-icons-virtual-412b14e947/1/packages/lib-icons/src/decorative/filled/ruler-pencil-filled-decorative.tsx


const RulerPencilFilledDecorative = (param)=>{
    let { size  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        fill: "none",
        height: size,
        viewBox: "0 0 48 48",
        width: size,
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M21 1H5C4.448 1 4 1.448 4 2V46C4 46.552 4.448 47 5 47H21C21.552 47 22 46.552 22 46V2C22 1.448 21.552 1 21 1Z",
                fill: "#FFD330"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M12 7H4V9H12V7Z",
                fill: "#0A3A5C"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M9 15H4V17H9V15Z",
                fill: "#0A3A5C"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M12 23H4V25H12V23Z",
                fill: "#0A3A5C"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M12 39H4V41H12V39Z",
                fill: "#0A3A5C"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M9 31H4V33H9V31Z",
                fill: "#0A3A5C"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M44 9V2C44 1.448 43.553 1 43 1H31C30.447 1 30 1.448 30 2V9H44Z",
                fill: "#0A3A5C"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M44 8H30V10H44V8Z",
                fill: "#E6E7E8"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M37 10H30V37H37V10Z",
                fill: "#00416A"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M44 10H37V37H44V10Z",
                fill: "#00416A"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M30 37L37 47L44 37H30Z",
                fill: "#FFEC8E"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M39.7999 43H34.2L37 47L39.7999 43Z",
                fill: "#0A3A5C"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-icons-virtual-412b14e947/1/packages/lib-icons/src/decorative/filled/scissors-filled-decorative.tsx


const ScissorsFilledDecorative = (param)=>{
    let { size  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        fill: "none",
        height: size,
        viewBox: "0 0 48 48",
        width: size,
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                // eslint-disable-next-line max-len
                d: "M29.0669 36.179C28.5299 37.663 34.4629 30.978 32.9239 31.777L6.61494 1.08301C3.82794 5.72801 4.55994 11.672 8.38994 15.502L29.0669 36.179Z",
                fill: "#AEAEAE"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                // eslint-disable-next-line max-len
                d: "M28 39C28 34.589 31.589 31 36 31C40.411 31 44 34.589 44 39C44 43.411 40.411 47 36 47C31.589 47 28 43.411 28 39ZM30 39C30 42.309 32.691 45 36 45C39.309 45 42 42.309 42 39C42 35.691 39.309 33 36 33C32.691 33 30 35.691 30 39Z",
                fill: "#00416A"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M26.327 24.0811L21.894 29.0061L26.121 33.2331L30.456 28.8981L26.327 24.0811Z",
                fill: "#959595"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                // eslint-disable-next-line max-len
                d: "M39.6101 15.502C43.4401 11.672 44.1721 5.72801 41.3851 1.08301L15.0761 31.777C13.5371 30.978 19.4691 37.663 18.9331 36.179L39.6101 15.502Z",
                fill: "#AEAEAE"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                // eslint-disable-next-line max-len
                d: "M12 47C7.589 47 4 43.411 4 39C4 34.589 7.589 31 12 31C16.411 31 20 34.589 20 39C20 43.411 16.411 47 12 47ZM12 33C8.691 33 6 35.691 6 39C6 42.309 8.691 45 12 45C15.309 45 18 42.309 18 39C18 35.691 15.309 33 12 33Z",
                fill: "#00416A"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                // eslint-disable-next-line max-len
                d: "M24 28C25.1046 28 26 27.1046 26 26C26 24.8954 25.1046 24 24 24C22.8954 24 22 24.8954 22 26C22 27.1046 22.8954 28 24 28Z",
                fill: "#00416A"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-icons-virtual-412b14e947/1/packages/lib-icons/src/decorative/filled/settings-cogwheel-filled-decorative.tsx


const SettingsCogwheelFilledDecorative = (param)=>{
    let { size  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        fill: "none",
        height: size,
        viewBox: "0 0 48 48",
        width: size,
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                // eslint-disable-next-line max-len
                d: "M46.083 20L40.4 19.529C40.0247 18.1455 39.4731 16.816 38.759 15.573L42.45 11.211C42.6121 11.0196 42.6962 10.7742 42.6859 10.5236C42.6755 10.273 42.5713 10.0354 42.394 9.85801L38.142 5.61501C37.9646 5.43769 37.727 5.33351 37.4764 5.32314C37.2258 5.31277 36.9805 5.39696 36.789 5.55901L32.428 9.24901C31.1847 8.53298 29.8549 7.97883 28.471 7.60001L28 1.91701C27.9791 1.66643 27.8646 1.43291 27.6793 1.26297C27.494 1.09303 27.2514 0.999138 27 1.00001H21C20.7486 0.999138 20.506 1.09303 20.3207 1.26297C20.1354 1.43291 20.0209 1.66643 20 1.91701L19.529 7.60001C18.1455 7.97536 16.816 8.52687 15.573 9.24101L11.211 5.55401C11.0196 5.39195 10.7742 5.30777 10.5236 5.31814C10.273 5.32851 10.0354 5.43269 9.85801 5.61001L5.61501 9.85801C5.43769 10.0354 5.33351 10.273 5.32314 10.5236C5.31277 10.7742 5.39696 11.0196 5.55901 11.211L9.24901 15.572C8.53298 16.8154 7.97883 18.1451 7.60001 19.529L1.91701 20C1.66643 20.0209 1.43291 20.1354 1.26297 20.3207C1.09303 20.506 0.999138 20.7486 1.00001 21V27C0.999138 27.2514 1.09303 27.494 1.26297 27.6793C1.43291 27.8646 1.66643 27.9791 1.91701 28L7.60401 28.475C7.97936 29.8585 8.53087 31.188 9.24501 32.431L5.55401 36.789C5.39195 36.9805 5.30777 37.2258 5.31814 37.4764C5.32851 37.727 5.43269 37.9646 5.61001 38.142L9.85301 42.385C10.0304 42.562 10.2677 42.666 10.5181 42.6764C10.7685 42.6868 11.0136 42.6028 11.205 42.441L15.567 38.751C16.8117 39.4679 18.1432 40.0221 19.529 40.4L20 46.083C20.0209 46.3336 20.1354 46.5671 20.3207 46.737C20.506 46.907 20.7486 47.0009 21 47H27C27.2514 47.0009 27.494 46.907 27.6793 46.737C27.8646 46.5671 27.9791 46.3336 28 46.083L28.476 40.392C29.8589 40.0154 31.188 39.4636 32.431 38.75L36.793 42.441C36.9845 42.6031 37.2298 42.6872 37.4804 42.6769C37.731 42.6665 37.9686 42.5623 38.146 42.385L42.389 38.142C42.5663 37.9646 42.6705 37.727 42.6809 37.4764C42.6912 37.2258 42.6071 36.9805 42.445 36.789L38.755 32.428C39.4692 31.1842 40.022 29.8545 40.4 28.471L46.083 28C46.3336 27.9791 46.5671 27.8646 46.737 27.6793C46.907 27.494 47.0009 27.2514 47 27V21C47.0009 20.7486 46.907 20.506 46.737 20.3207C46.5671 20.1354 46.3336 20.0209 46.083 20ZM24 31C22.6155 31 21.2622 30.5895 20.111 29.8203C18.9599 29.0511 18.0627 27.9579 17.5328 26.6788C17.003 25.3997 16.8644 23.9922 17.1345 22.6344C17.4046 21.2765 18.0713 20.0292 19.0503 19.0503C20.0292 18.0713 21.2765 17.4046 22.6344 17.1345C23.9922 16.8644 25.3997 17.003 26.6788 17.5328C27.9579 18.0627 29.0511 18.9599 29.8203 20.111C30.5895 21.2622 31 22.6155 31 24C31 25.8565 30.2625 27.637 28.9498 28.9498C27.637 30.2625 25.8565 31 24 31Z",
                fill: "#C6C6C6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                // eslint-disable-next-line max-len
                d: "M24 14C22.0222 14 20.0888 14.5865 18.4443 15.6853C16.7998 16.7841 15.5181 18.3459 14.7612 20.1732C14.0043 22.0004 13.8063 24.0111 14.1922 25.9509C14.578 27.8907 15.5304 29.6725 16.9289 31.0711C18.3275 32.4696 20.1093 33.422 22.0491 33.8079C23.9889 34.1937 25.9996 33.9957 27.8268 33.2388C29.6541 32.4819 31.2159 31.2002 32.3147 29.5557C33.4135 27.9112 34 25.9778 34 24C34 21.3478 32.9464 18.8043 31.0711 16.9289C29.1957 15.0536 26.6522 14 24 14ZM24 31C22.6155 31 21.2622 30.5895 20.111 29.8203C18.9599 29.0511 18.0627 27.9579 17.5328 26.6788C17.003 25.3997 16.8644 23.9922 17.1345 22.6344C17.4046 21.2765 18.0713 20.0292 19.0503 19.0503C20.0292 18.0713 21.2765 17.4046 22.6344 17.1345C23.9922 16.8644 25.3997 17.003 26.6788 17.5328C27.9579 18.0627 29.0511 18.9599 29.8203 20.111C30.5895 21.2622 31 22.6155 31 24C31 25.8565 30.2625 27.637 28.9498 28.9497C27.637 30.2625 25.8565 31 24 31Z",
                fill: "#7C7C7C"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-icons-virtual-412b14e947/1/packages/lib-icons/src/decorative/filled/settings-gear-filled-decorative.tsx


const SettingsGearFilledDecorative = (param)=>{
    let { size  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        fill: "none",
        height: size,
        viewBox: "0 0 48 48",
        width: size,
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                // eslint-disable-next-line max-len
                d: "M46 19H41.8896C40.9307 19 40.0718 18.4199 39.6836 17.4775C39.311 16.5811 39.5078 15.5635 40.1851 14.8857L43.0918 11.9795C43.2793 11.792 43.3848 11.5381 43.3848 11.2725C43.3848 11.0068 43.2793 10.7529 43.0918 10.5654L37.4351 4.9082C37.0444 4.51758 36.4116 4.51758 36.021 4.9082L33.1143 7.81445C32.436 8.49218 31.4185 8.69043 30.478 8.29785C29.5801 7.92773 29 7.06934 29 6.11035V2C29 1.44727 28.5522 1 28 1H20C19.4478 1 19 1.44727 19 2V6.11035C19 7.06933 18.4199 7.92773 17.4785 8.3164C16.5811 8.68847 15.5635 8.49218 14.8857 7.81445L11.979 4.9082C11.5884 4.51758 10.9556 4.51758 10.5649 4.9082L4.9082 10.5654C4.7207 10.7529 4.61523 11.0068 4.61523 11.2725C4.61523 11.5381 4.7207 11.792 4.9082 11.9795L7.81445 14.8857C8.49218 15.5635 8.68896 16.5811 8.29785 17.5225C7.92822 18.4199 7.06934 19 6.11035 19H2C1.44775 19 1 19.4473 1 20V28C1 28.5527 1.44775 29 2 29H6.11035C7.06933 29 7.92822 29.5801 8.3164 30.5225C8.68896 31.4189 8.49218 32.4365 7.81494 33.1143L4.9082 36.0205C4.7207 36.208 4.61523 36.4619 4.61523 36.7275C4.61523 36.9932 4.7207 37.2471 4.9082 37.4346L10.5649 43.0918C10.9556 43.4824 11.5884 43.4824 11.979 43.0918L14.8857 40.1856C15.564 39.5078 16.5815 39.3096 17.522 39.7021C18.4199 40.0723 19 40.9307 19 41.8896V46C19 46.5527 19.4478 47 20 47H28C28.5522 47 29 46.5527 29 46V41.8896C29 40.9307 29.5801 40.0723 30.5215 39.6836C31.4189 39.3115 32.4365 39.5068 33.1143 40.1856L36.021 43.0918C36.4116 43.4824 37.0444 43.4824 37.4351 43.0918L43.0918 37.4346C43.2793 37.2471 43.3848 36.9932 43.3848 36.7275C43.3848 36.4619 43.2793 36.208 43.0918 36.0205L40.1856 33.1143C39.5078 32.4365 39.311 31.4189 39.7021 30.4775C40.0718 29.5801 40.9307 29 41.8896 29H46C46.5522 29 47 28.5527 47 28V20C47 19.4473 46.5522 19 46 19ZM24 31C20.134 31 17 27.866 17 24C17 20.134 20.134 17 24 17C27.866 17 31 20.134 31 24C31 27.866 27.866 31 24 31Z",
                fill: "#C6C6C6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                // eslint-disable-next-line max-len
                d: "M24 13C17.9249 13 13 17.9249 13 24C13 30.0751 17.9249 35 24 35C30.0751 35 35 30.0751 35 24C35 17.9249 30.0751 13 24 13ZM24 31C20.134 31 17 27.866 17 24C17 20.134 20.134 17 24 17C27.866 17 31 20.134 31 24C31 27.866 27.866 31 24 31Z",
                fill: "#959595"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-icons-virtual-412b14e947/1/packages/lib-icons/src/decorative/filled/settings-tools-filled-decorative.tsx


const SettingsToolsFilledDecorative = (param)=>{
    let { size  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        fill: "none",
        height: size,
        viewBox: "0 0 48 48",
        width: size,
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                clipPath: "url(#clip0_1144_7143)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        // eslint-disable-next-line max-len
                        d: "M45.989 35.373L32.167 23.437L25 30.389L37.373 43.989C37.4397 44.0657 37.5107 44.1407 37.586 44.214C38.1524 44.7805 38.8249 45.2299 39.565 45.5364C40.3051 45.843 41.0984 46.0008 41.8995 46.0008C42.7006 46.0008 43.4939 45.843 44.234 45.5364C44.9741 45.2299 45.6466 44.7805 46.213 44.214C46.286 44.141 46.357 44.066 46.426 43.99C46.9632 43.3956 47.3781 42.7011 47.6469 41.9463C47.9157 41.1915 48.0331 40.3912 47.9925 39.591C47.952 38.7908 47.7541 38.0064 47.4104 37.2827C47.0666 36.559 46.5836 35.91 45.989 35.373Z",
                        fill: "#FFD330"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        // eslint-disable-next-line max-len
                        d: "M10.414 14H13L21.847 22.847L25 20L16 11V8.414C15.9999 8.1488 15.8945 7.89449 15.707 7.707L10 2L4 8L9.707 13.707C9.89449 13.8945 10.1488 13.9999 10.414 14Z",
                        fill: "#AEAEAE"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        // eslint-disable-next-line max-len
                        d: "M37.6289 24.383C40.2996 24.1618 42.8052 23.0004 44.7 21.1054C46.5948 19.2104 47.756 16.7047 47.9769 14.034C48.0685 12.5863 47.9044 11.1337 47.4919 9.74298L41.4799 15.754L34.2509 8.52498L40.2619 2.51298C38.8711 2.10321 37.4189 1.94174 35.9719 2.03598C33.3011 2.25669 30.7951 3.41776 28.8999 5.31259C27.0047 7.20743 25.8432 9.71316 25.6219 12.384C25.5278 13.8327 25.69 15.2866 26.1009 16.679L5.04594 35.688C4.42228 36.2519 4.04812 37.0404 4.00574 37.8802C3.96336 38.7199 4.25623 39.5421 4.81994 40.166C4.85594 40.206 4.89194 40.244 4.92994 40.281L9.72294 45.075C10.3185 45.6684 11.1254 46.0009 11.9661 45.9994C12.8068 45.9979 13.6125 45.6625 14.2059 45.067C14.2429 45.031 14.2779 44.993 14.3129 44.955L33.3329 23.9C34.7254 24.3122 36.1797 24.4758 37.6289 24.383Z",
                        fill: "#C6C6C6"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        // eslint-disable-next-line max-len
                        d: "M40.9999 40C40.7347 40 40.4804 39.8946 40.2929 39.707L33.2929 32.707C33.1108 32.5184 33.01 32.2658 33.0122 32.0036C33.0145 31.7414 33.1197 31.4906 33.3051 31.3052C33.4905 31.1198 33.7413 31.0146 34.0035 31.0124C34.2657 31.0101 34.5183 31.1109 34.7069 31.293L41.7069 38.293C41.8467 38.4329 41.9419 38.6111 41.9805 38.805C42.0191 38.999 41.9993 39.2 41.9236 39.3827C41.8479 39.5654 41.7198 39.7216 41.5554 39.8314C41.391 39.9413 41.1977 40 40.9999 40Z",
                        fill: "#FFD330"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_1144_7143",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        fill: "white",
                        height: "48",
                        width: "48"
                    })
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-icons-virtual-412b14e947/1/packages/lib-icons/src/decorative/filled/shovel-filled-decorative.tsx


const ShovelFilledDecorative = (param)=>{
    let { size  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        fill: "none",
        height: size,
        viewBox: "0 0 48 48",
        width: size,
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                // eslint-disable-next-line max-len
                d: "M24 47C24 47 13 45.0833 13 38V25C13 24.4477 13.4477 24 14 24H34C34.5523 24 35 24.4477 35 25V38C35 45 24 47 24 47Z",
                fill: "#E6E7E8"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                // eslint-disable-next-line max-len
                d: "M29 1H19C18.4477 1 18 1.44775 18 2V3C18 5.96722 20.1669 8.43134 23 8.90967V31C23 31.5522 23.4478 32 24 32C24.5522 32 25 31.5522 25 31V8.90967C27.8331 8.43134 30 5.96722 30 3V2C30 1.44775 29.5522 1 29 1ZM24 7C21.7944 7 20 5.20557 20 3H28C28 5.20557 26.2056 7 24 7Z",
                fill: "#00416A"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-icons-virtual-412b14e947/1/packages/lib-icons/src/decorative/filled/swiss-knife-filled-decorative.tsx


const SwissKnifeFilledDecorative = (param)=>{
    let { size  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        fill: "none",
        height: size,
        viewBox: "0 0 48 48",
        width: size,
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M32 39V15C32 7.268 38.268 1 46 1V39H32Z",
                fill: "#C6C6C6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                // eslint-disable-next-line max-len
                d: "M2 40V11C2 10.448 2.448 10 3 10H13C13.552 10 14 10.448 14 11V18C11.791 18 10 19.791 10 22C10 24.209 11.791 26 14 26V40H2Z",
                fill: "#C6C6C6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M40 47H8C4.141 47 1 43.86 1 40C1 36.14 4.141 33 8 33H40C43.859 33 47 36.14 47 40C47 43.86 43.859 47 40 47Z",
                fill: "#00416A"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                // eslint-disable-next-line max-len
                d: "M41 29C40.447 29 40 28.552 40 28V11C40 10.448 40.447 10 41 10C41.553 10 42 10.448 42 11V28C42 28.552 41.553 29 41 29Z",
                fill: "#E6E7E8"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                // eslint-disable-next-line max-len
                d: "M8 43C9.65685 43 11 41.6569 11 40C11 38.3431 9.65685 37 8 37C6.34315 37 5 38.3431 5 40C5 41.6569 6.34315 43 8 43Z",
                fill: "#00416A"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                // eslint-disable-next-line max-len
                d: "M40 43C41.6569 43 43 41.6569 43 40C43 38.3431 41.6569 37 40 37C38.3431 37 37 38.3431 37 40C37 41.6569 38.3431 43 40 43Z",
                fill: "#00416A"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-icons-virtual-412b14e947/1/packages/lib-icons/src/decorative/filled/wrench-filled-decorative.tsx


const WrenchFilledDecorative = (param)=>{
    let { size  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        fill: "none",
        height: size,
        viewBox: "0 0 48 48",
        width: size,
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            // eslint-disable-next-line max-len
            d: "M46.3593 10.3012C46.2519 9.97016 45.9804 9.71918 45.6425 9.63715C45.3007 9.55414 44.9472 9.65668 44.7011 9.90277L39.4609 15.143L33.8037 9.48577L39.0439 4.24554C39.29 3.99945 39.3906 3.643 39.3095 3.30413C39.2275 2.96624 38.9755 2.69378 38.6445 2.58733C37.1064 2.08928 35.5107 1.90569 33.9091 2.04534C27.7597 2.57757 22.8427 8.03264 22.9482 14.2035C22.9648 15.1547 23.0937 16.1 23.3339 17.0219L4.5849 33.5707C2.98627 34.9828 2.07025 36.934 2.00385 39.0649C1.93745 41.1957 2.73139 43.1996 4.2392 44.7075C5.68842 46.1567 7.59662 46.9467 9.63568 46.9467C9.71771 46.9467 9.79974 46.9457 9.88177 46.9428C12.0126 46.8764 13.9638 45.9604 15.3759 44.3618L31.9247 25.6137C33.6953 26.0756 35.5156 26.1274 37.3456 25.7612C41.6962 24.895 45.2812 21.5922 46.4775 17.3481C47.1357 15.0102 47.0956 12.5737 46.3593 10.3012ZM9.94623 41.0004C8.84168 41.0004 7.94623 40.105 7.94623 39.0004C7.94623 37.8958 8.84168 37.0004 9.94623 37.0004C11.0508 37.0004 11.9462 37.8958 11.9462 39.0004C11.9462 40.105 11.0508 41.0004 9.94623 41.0004Z",
            fill: "#C6C6C6"
        })
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-icons-virtual-412b14e947/1/packages/lib-icons/src/decorative/filled/cookies.tsx
/* eslint-disable max-len */ 

const CookiesFilledDecorative = ()=>{
    return /*#__PURE__*/ _jsxs("svg", {
        fill: "none",
        height: "138",
        viewBox: "0 0 138 138",
        width: "138",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ _jsxs("g", {
                filter: "url(#filter0_d_812_6351)",
                children: [
                    /*#__PURE__*/ _jsx("path", {
                        clipRule: "evenodd",
                        d: "M67.5228 36.2718C69.3843 30.7262 74.5748 27 80.4398 27C86.0819 27 90.9342 30.4417 92.9999 35.3327C92.8088 35.3542 92.6176 35.4015 92.4309 35.4764C91.6548 35.7881 91.1558 36.4979 91.0677 37.2849C90.6789 37.255 90.2788 37.3114 89.8941 37.4659C88.534 38.012 87.8834 39.5772 88.4413 40.9617C88.56 41.2562 88.7238 41.5188 88.9212 41.7446C88.8732 41.7608 88.8256 41.7782 88.778 41.7973C87.4179 42.3435 86.7673 43.9087 87.3252 45.2931C87.6518 46.1035 88.3197 46.6723 89.0905 46.8953C88.6604 47.497 88.5396 48.3067 88.8405 49.0534C89.071 49.6256 89.5059 50.0532 90.024 50.2835C88.5739 51.7141 86.7889 52.8288 84.7615 53.4995C82.7871 54.1527 74.6168 55.5957 70.5319 51C68.4893 48.4468 65.3213 42.8298 67.5228 36.2718Z",
                        fill: "#80B3D2",
                        fillRule: "evenodd"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M75.6382 40.2766C77.3303 40.2766 78.702 38.9049 78.702 37.2128C78.702 35.5206 77.3303 34.1489 75.6382 34.1489C73.9461 34.1489 72.5743 35.5206 72.5743 37.2128C72.5743 38.9049 73.9461 40.2766 75.6382 40.2766Z",
                        fill: "#E5F0F6"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M85.8508 37.2128C86.9789 37.2128 87.8933 36.2983 87.8933 35.1702C87.8933 34.0422 86.9789 33.1277 85.8508 33.1277C84.7227 33.1277 83.8082 34.0422 83.8082 35.1702C83.8082 36.2983 84.7227 37.2128 85.8508 37.2128Z",
                        fill: "#E5F0F6"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M82.2763 46.4042C83.6864 46.4042 84.8295 45.2611 84.8295 43.851C84.8295 42.441 83.6864 41.2979 82.2763 41.2979C80.8662 41.2979 79.7231 42.441 79.7231 43.851C79.7231 45.2611 80.8662 46.4042 82.2763 46.4042Z",
                        fill: "#0A3A5C"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        clipRule: "evenodd",
                        d: "M44.9998 55.5957C44.9998 44.8962 53.7045 36.1915 64.404 36.1915C75.1035 36.1915 83.8083 44.8962 83.8083 55.5957C83.8083 55.6133 83.8082 55.631 83.8082 55.6486C83.617 55.6138 83.4201 55.5957 83.2191 55.5957C81.9566 55.5957 80.8575 56.3103 80.2901 57.3645C79.7626 57.1037 79.1705 56.9574 78.5448 56.9574C76.3322 56.9574 74.5382 58.7864 74.5382 61.0425C74.5382 61.5224 74.6194 61.983 74.7684 62.4109C74.6921 62.4066 74.6155 62.4042 74.5382 62.4042C72.3256 62.4042 70.5317 64.2332 70.5317 66.4893C70.5317 67.8098 71.146 68.9839 72.0993 69.7307C71.1577 70.3326 70.5317 71.4002 70.5317 72.617C70.5317 73.0793 70.6221 73.5201 70.7858 73.922C68.7863 74.6203 66.6387 75 64.404 75C53.7045 75 44.9998 66.2952 44.9998 55.5957Z",
                        fill: "#00416A",
                        fillRule: "evenodd"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M59.2977 50.4894C60.9898 50.4894 62.3615 49.1177 62.3615 47.4256C62.3615 45.7335 60.9898 44.3618 59.2977 44.3618C57.6056 44.3618 56.2339 45.7335 56.2339 47.4256C56.2339 49.1177 57.6056 50.4894 59.2977 50.4894Z",
                        fill: "#E5F0F6"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M74.6169 51.5106C75.745 51.5106 76.6594 50.5962 76.6594 49.4681C76.6594 48.34 75.745 47.4255 74.6169 47.4255C73.4888 47.4255 72.5743 48.34 72.5743 49.4681C72.5743 50.5962 73.4888 51.5106 74.6169 51.5106Z",
                        fill: "#80B3D2"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M62.3614 69.8936C63.4895 69.8936 64.404 68.9791 64.404 67.851C64.404 66.723 63.4895 65.8085 62.3614 65.8085C61.2333 65.8085 60.3188 66.723 60.3188 67.851C60.3188 68.9791 61.2333 69.8936 62.3614 69.8936Z",
                        fill: "#80B3D2"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M54.1912 59.6808C55.3193 59.6808 56.2338 58.7663 56.2338 57.6383C56.2338 56.5102 55.3193 55.5957 54.1912 55.5957C53.0632 55.5957 52.1487 56.5102 52.1487 57.6383C52.1487 58.7663 53.0632 59.6808 54.1912 59.6808Z",
                        fill: "#E5F0F6"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M67.4679 60.7021C69.16 60.7021 70.5317 59.3304 70.5317 57.6383C70.5317 55.9462 69.16 54.5745 67.4679 54.5745C65.7758 54.5745 64.4041 55.9462 64.4041 57.6383C64.4041 59.3304 65.7758 60.7021 67.4679 60.7021Z",
                        fill: "#E5F0F6"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M82.0239 66.8433C81.6144 66.106 82.2452 65.2241 83.0752 65.3735L83.9257 65.5266C84.1869 65.5736 84.4186 65.7225 84.57 65.9404L84.9097 66.4297C85.3701 67.0928 84.8955 68 84.0883 68H83.2548C82.8917 68 82.557 67.8031 82.3807 67.4856L82.0239 66.8433Z",
                        fill: "#00416A"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M88.1725 59.6091C88.9411 59.3529 89.6793 60.0691 89.4465 60.8451L89.3361 61.2132C89.2499 61.5004 89.0395 61.7337 88.7628 61.849L87.3846 62.4232C86.7259 62.6976 86 62.2136 86 61.5001L86 61.0539C86 60.6235 86.2755 60.2413 86.6838 60.1052L88.1725 59.6091Z",
                        fill: "#80B3D2"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M79.1815 60.8081C79.9329 60.4742 80.7437 61.1393 80.5632 61.9414L80.4983 62.2298C80.4358 62.5079 80.2575 62.746 80.0083 62.8845L79.4856 63.1748C78.8191 63.545 78 63.0631 78 62.3006L78 61.983C78 61.5878 78.2328 61.2297 78.5939 61.0692L79.1815 60.8081Z",
                        fill: "#0A3A5C"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M89.8081 44.8185C89.4742 44.0671 90.1393 43.2563 90.9414 43.4368L91.2298 43.5017C91.5079 43.5642 91.746 43.7425 91.8845 43.9917L92.1748 44.5144C92.545 45.1809 92.0631 46 91.3006 46H90.983C90.5878 46 90.2297 45.7672 90.0692 45.4061L89.8081 44.8185Z",
                        fill: "#0A3A5C"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M91.315 39C91.6564 39 91.9013 39.3291 91.8032 39.6561L91.6746 40.0847C91.6274 40.2421 91.512 40.3701 91.3603 40.4333C90.8913 40.6287 90.4318 40.1363 90.659 39.682L90.8591 39.2817C90.9455 39.1091 91.1219 39 91.315 39Z",
                        fill: "#00416A"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M77.4772 68.1904C78.1942 68.1007 78.7667 68.7778 78.559 69.47L78.3361 70.2132C78.2499 70.5004 78.0395 70.7337 77.7628 70.849L76.3846 71.4232C75.7259 71.6976 75 71.2136 75 70.5001L75 69.3828C75 68.8785 75.3755 68.4531 75.876 68.3905L77.4772 68.1904Z",
                        fill: "#5995BE"
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("defs", {
                children: /*#__PURE__*/ _jsxs("filter", {
                    colorInterpolationFilters: "sRGB",
                    filterUnits: "userSpaceOnUse",
                    height: "138",
                    id: "filter0_d_812_6351",
                    width: "138",
                    x: "-0.000244141",
                    y: "0",
                    children: [
                        /*#__PURE__*/ _jsx("feFlood", {
                            floodOpacity: "0",
                            result: "BackgroundImageFix"
                        }),
                        /*#__PURE__*/ _jsx("feColorMatrix", {
                            in: "SourceAlpha",
                            result: "hardAlpha",
                            type: "matrix",
                            values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        }),
                        /*#__PURE__*/ _jsx("feOffset", {
                            dy: "18"
                        }),
                        /*#__PURE__*/ _jsx("feGaussianBlur", {
                            stdDeviation: "22.5"
                        }),
                        /*#__PURE__*/ _jsx("feComposite", {
                            in2: "hardAlpha",
                            operator: "out"
                        }),
                        /*#__PURE__*/ _jsx("feColorMatrix", {
                            type: "matrix",
                            values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.09 0"
                        }),
                        /*#__PURE__*/ _jsx("feBlend", {
                            in2: "BackgroundImageFix",
                            mode: "normal",
                            result: "effect1_dropShadow_812_6351"
                        }),
                        /*#__PURE__*/ _jsx("feBlend", {
                            in: "SourceGraphic",
                            in2: "effect1_dropShadow_812_6351",
                            mode: "normal",
                            result: "shape"
                        })
                    ]
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-icons-virtual-412b14e947/1/packages/lib-icons/src/decorative/filled/clock-white.tsx
/* eslint-disable max-len */ 

const ClockWhiteFilledDecorative = (param)=>{
    let { size  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        fill: "none",
        height: size,
        viewBox: "0 0 32 32",
        width: size,
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M16 30C23.732 30 30 23.732 30 16C30 8.26801 23.732 2 16 2C8.26801 2 2 8.26801 2 16C2 23.732 8.26801 30 16 30Z",
                fill: "#00416A"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M16 31.3333C7.54494 31.3333 0.666687 24.4547 0.666687 16C0.666687 7.54521 7.54494 0.666626 16 0.666626C24.4551 0.666626 31.3334 7.54521 31.3334 16C31.3334 24.4547 24.4551 31.3333 16 31.3333ZM16 3.33329C9.01565 3.33329 3.33335 9.01559 3.33335 16C3.33335 22.9843 9.01565 28.6666 16 28.6666C22.9844 28.6666 28.6667 22.9843 28.6667 16C28.6667 9.01559 22.9844 3.33329 16 3.33329Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M16 16.6666C15.6316 16.6666 15.3334 16.3681 15.3334 16V7.33329C15.3334 6.96513 15.6316 6.66663 16 6.66663C16.3685 6.66663 16.6667 6.96513 16.6667 7.33329V16C16.6667 16.3681 16.3685 16.6666 16 16.6666Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M24 16.6666H16C15.6316 16.6666 15.3334 16.3681 15.3334 15.9999C15.3334 15.6318 15.6316 15.3333 16 15.3333H24C24.3685 15.3333 24.6667 15.6318 24.6667 15.9999C24.6667 16.3681 24.3685 16.6666 24 16.6666Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M9.99939 24C9.85095 24 9.70186 23.9505 9.57816 23.8493C9.29301 23.6162 9.25069 23.1963 9.48376 22.9111L15.4838 15.5778C15.7175 15.2933 16.1368 15.2513 16.4219 15.484C16.7071 15.7171 16.7494 16.137 16.5163 16.4222L10.5163 23.7555C10.3842 23.9167 10.1927 24 9.99939 24Z",
                fill: "#F85E00"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M16 18C17.1046 18 18 17.1046 18 16C18 14.8954 17.1046 14 16 14C14.8954 14 14 14.8954 14 16C14 17.1046 14.8954 18 16 18Z",
                fill: "white"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-icons-virtual-412b14e947/1/packages/lib-icons/src/decorative/filled/send-messages-blue.tsx
/* eslint-disable max-len */ 

const SendMessagesBlueFilledDecorative = (param)=>{
    let { size  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        fill: "none",
        height: size,
        viewBox: "0 0 32 32",
        width: size,
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M30.4713 1.52865C30.3787 1.43609 30.261 1.37282 30.1327 1.34674C30.0044 1.32066 29.8713 1.33292 29.75 1.38199L1.74997 12.7153C1.63268 12.7628 1.53132 12.8426 1.45772 12.9455C1.38412 13.0484 1.34132 13.1702 1.33433 13.2965C1.32734 13.4228 1.35644 13.5485 1.41824 13.6589C1.48003 13.7693 1.57197 13.8599 1.68331 13.92L9.99997 18.4L13.6 22L18.078 30.316C18.1352 30.4222 18.2201 30.511 18.3238 30.5727C18.4275 30.6345 18.546 30.667 18.6666 30.6667C18.6789 30.6673 18.6911 30.6673 18.7033 30.6667C18.8296 30.6597 18.9514 30.617 19.0543 30.5434C19.1572 30.4699 19.2371 30.3686 19.2846 30.2513L30.618 2.25132C30.6673 2.1298 30.6797 1.99641 30.6537 1.86786C30.6276 1.73932 30.5641 1.62132 30.4713 1.52865Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M30.4713 1.52864C30.3523 1.40968 30.1927 1.34013 30.0245 1.33395C29.8564 1.32776 29.6921 1.3854 29.5647 1.4953L10.2313 18.162C10.1588 18.2245 10.1006 18.302 10.0606 18.3891C10.0207 18.4762 10 18.5708 10 18.6666V21.3333C10 21.5101 10.0702 21.6797 10.1953 21.8047C10.3203 21.9297 10.4899 22 10.6667 22H13.3333C13.4292 22 13.524 21.9794 13.6113 21.9395C13.6985 21.8996 13.776 21.8413 13.8387 21.7686L30.5053 2.4353C30.6151 2.30779 30.6727 2.14346 30.6664 1.97529C30.6601 1.80713 30.5904 1.64757 30.4713 1.52864Z",
                fill: "#80B3D2"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-icons-virtual-412b14e947/1/packages/lib-icons/src/decorative/filled/mobile-white.tsx
/* eslint-disable max-len */ 

const MobileWhiteFilledDecorative = (param)=>{
    let { size  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        fill: "none",
        height: size,
        viewBox: "0 0 32 32",
        width: size,
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                clipRule: "evenodd",
                d: "M9.33335 31.3333C7.86069 31.3333 6.66669 30.085 6.66669 28.5454V3.33329C6.66669 1.86053 7.86059 0.666626 9.33335 0.666626H22.6667C24.1394 0.666626 25.3334 1.9149 25.3334 3.45451V28.5454C25.3334 30.085 24.1394 31.3333 22.6667 31.3333H9.33335Z",
                fill: "white",
                fillRule: "evenodd"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                clipRule: "evenodd",
                d: "M14.6667 28.6666C14.6667 27.9299 15.264 27.3333 16 27.3333C16.736 27.3333 17.3334 27.9299 17.3334 28.6666C17.3334 29.4033 16.736 29.9999 16 29.9999C15.264 29.9999 14.6667 29.4033 14.6667 28.6666Z",
                fill: "#E6E7E8",
                fillRule: "evenodd"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                clipRule: "evenodd",
                d: "M8 3.99935C8 3.63147 8.29831 3.33325 8.66713 3.33325H23.3329C23.7013 3.33325 24 3.63653 24 3.99935V25.3338C24 25.7017 23.7017 25.9999 23.3329 25.9999H8.66713C8.29868 25.9999 8 25.6966 8 25.3338V3.99935Z",
                fill: "#00416A",
                fillRule: "evenodd"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                clipRule: "evenodd",
                d: "M17.3334 16H14.6667C12.8258 16 11.3334 17.4924 11.3334 19.3333C11.3334 19.7015 11.6333 20 12.0046 20H19.9955C20.3662 20 20.6667 19.6979 20.6667 19.3333C20.6667 17.4924 19.1743 16 17.3334 16Z",
                fill: "white",
                fillRule: "evenodd"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M16 14.6666C17.4728 14.6666 18.6667 13.4727 18.6667 11.9999C18.6667 10.5272 17.4728 9.33325 16 9.33325C14.5273 9.33325 13.3334 10.5272 13.3334 11.9999C13.3334 13.4727 14.5273 14.6666 16 14.6666Z",
                fill: "white"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-icons-virtual-412b14e947/1/packages/lib-icons/src/decorative/filled/recycle-filled-decorative.tsx
/* eslint-disable max-len */ 

const RecycleFilledDecorative = (param)=>{
    let { size  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        fill: "none",
        height: size,
        viewBox: "0 0 48 48",
        width: size,
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M5 24C4.997 20.599 5.90776 17.2597 7.63705 14.3311C9.36634 11.4025 11.8506 8.99236 14.8302 7.35254C17.8098 5.71272 21.1752 4.9035 24.5746 5.00949C27.9739 5.11547 31.2824 6.13277 34.154 7.95501L31.125 10.524C30.9864 10.6413 30.8824 10.794 30.824 10.9659C30.7657 11.1378 30.7552 11.3223 30.7937 11.4997C30.8323 11.6771 30.9184 11.8407 31.0428 11.9728C31.1672 12.105 31.3253 12.2008 31.5 12.25L42.367 15.278C42.4542 15.3028 42.5444 15.3153 42.635 15.315C42.9002 15.315 43.1546 15.2097 43.3421 15.0221C43.5296 14.8346 43.635 14.5802 43.635 14.315C43.6349 14.2732 43.6322 14.2315 43.627 14.19L42.24 3.12301C42.2177 2.94405 42.1473 2.77447 42.0365 2.63221C41.9256 2.48996 41.7783 2.38033 41.6103 2.31494C41.4422 2.24956 41.2595 2.23084 41.0817 2.26078C40.9038 2.29072 40.7374 2.3682 40.6 2.48501L37.332 5.25801C33.8915 2.81063 29.8437 1.35751 25.6322 1.05788C21.4207 0.758245 17.208 1.62367 13.4557 3.55932C9.70334 5.49497 6.55623 8.42614 4.35919 12.0316C2.16216 15.6372 0.999977 19.7779 1 24C1 24.5304 1.21071 25.0392 1.58579 25.4142C1.96086 25.7893 2.46957 26 3 26C3.53043 26 4.03914 25.7893 4.41421 25.4142C4.78929 25.0392 5 24.5304 5 24Z",
                fill: "#00416A"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M45 22C44.4696 22 43.9608 22.2107 43.5858 22.5858C43.2107 22.9609 43 23.4696 43 24C43.0032 27.401 42.0926 30.7404 40.3635 33.669C38.6343 36.5976 36.1501 39.0078 33.1705 40.6476C30.191 42.2875 26.8256 43.0967 23.4263 42.9907C20.027 42.8847 16.7185 41.8673 13.847 40.045L16.875 37.476C17.0136 37.3587 17.1176 37.206 17.176 37.0341C17.2343 36.8622 17.2448 36.6777 17.2063 36.5003C17.1677 36.3229 17.0816 36.1593 16.9572 36.0272C16.8328 35.895 16.6747 35.7992 16.5 35.75L5.62899 32.722C5.47028 32.6779 5.30313 32.6737 5.1424 32.7097C4.98167 32.7458 4.83233 32.8209 4.70765 32.9286C4.58297 33.0363 4.48682 33.173 4.42774 33.3268C4.36866 33.4806 4.34848 33.6466 4.36899 33.81L5.75999 44.877C5.78245 45.0558 5.8528 45.2252 5.9636 45.3673C6.0744 45.5094 6.22153 45.6189 6.38944 45.6842C6.55735 45.7496 6.7398 45.7684 6.91751 45.7386C7.09521 45.7088 7.26157 45.6315 7.39899 45.515L10.668 42.742C14.1085 45.1894 18.1563 46.6425 22.3678 46.9421C26.5793 47.2418 30.792 46.3763 34.5443 44.4407C38.2967 42.505 41.4438 39.5739 43.6408 35.9684C45.8378 32.3629 47 28.2222 47 24C47 23.4696 46.7893 22.9609 46.4142 22.5858C46.0391 22.2107 45.5304 22 45 22Z",
                fill: "#00416A"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-icons-virtual-412b14e947/1/packages/lib-icons/src/decorative/filled/globe-filled-decorativ.tsx
/* eslint-disable max-len */ 

const GlobeFilledDecorative = (param)=>{
    let { size  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        fill: "none",
        height: size,
        viewBox: "0 0 48 48",
        width: size,
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M24 44C35.0457 44 44 35.0457 44 24C44 12.9543 35.0457 4 24 4C12.9543 4 4 12.9543 4 24C4 35.0457 12.9543 44 24 44Z",
                fill: "#E6E7E8"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M24 3C12.4209 3 3 12.4204 3 24C3 35.5796 12.4209 45 24 45C35.5791 45 45 35.5796 45 24C45 12.4204 35.5791 3 24 3ZM5.05068 25H13.0256C13.0934 27.8687 13.4465 30.5658 14.0381 33H7.27288C5.975 30.5974 5.20168 27.8801 5.05068 25ZM25 13V5.1318C27.5506 5.7593 29.8107 8.7484 31.2738 13H25ZM31.8866 15C32.5201 17.4156 32.9005 20.1379 32.9752 23H25V15H31.8866ZM23 5.1318V13H16.7262C18.1893 8.7484 20.4494 5.7593 23 5.1318ZM23 15V23H15.0248C15.0995 20.1379 15.4799 17.4156 16.1134 15H23ZM13.0256 23H5.05068C5.20168 20.1199 5.975 17.4026 7.27288 15H14.0381C13.4465 17.4342 13.0934 20.1313 13.0256 23ZM15.0248 25H23V33H16.1134C15.4799 30.5844 15.0995 27.8621 15.0248 25ZM23 35V42.8682C20.4494 42.2407 18.1893 39.2516 16.7262 35H23ZM25 42.8682V35H31.2738C29.8107 39.2516 27.5506 42.2407 25 42.8682ZM25 33V25H32.9752C32.9005 27.8621 32.5201 30.5844 31.8866 33H25ZM34.9744 25H42.9493C42.7983 27.8801 42.025 30.5974 40.7271 33H33.9619C34.5535 30.5658 34.9066 27.8687 34.9744 25ZM34.9744 23C34.9066 20.1313 34.5535 17.4342 33.9619 15H40.7271C42.025 17.4026 42.7983 20.1199 42.9493 23H34.9744ZM39.4631 13H33.404C32.4645 10.0355 31.1542 7.5772 29.5812 5.8395C33.6132 7.0812 37.0651 9.6392 39.4631 13ZM18.4188 5.8395C16.8458 7.5772 15.5355 10.0355 14.596 13H8.53688C10.9349 9.6392 14.3868 7.0812 18.4188 5.8395ZM8.53688 35H14.596C15.5355 37.9645 16.8458 40.4228 18.4188 42.1605C14.3868 40.9188 10.9349 38.3608 8.53688 35ZM29.5812 42.1605C31.1542 40.4228 32.4645 37.9645 33.404 35H39.4631C37.0651 38.3608 33.6132 40.9188 29.5812 42.1605Z",
                fill: "#0A3A5C"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M16 19C17.6569 19 19 17.6569 19 16C19 14.3431 17.6569 13 16 13C14.3431 13 13 14.3431 13 16C13 17.6569 14.3431 19 16 19Z",
                fill: "#FFD330"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M16 20C13.7939 20 12 18.2056 12 16C12 13.7944 13.7939 12 16 12C18.2061 12 20 13.7944 20 16C20 18.2056 18.2061 20 16 20ZM16 14C14.8975 14 14 14.897 14 16C14 17.103 14.8975 18 16 18C17.1025 18 18 17.103 18 16C18 14.897 17.1025 14 16 14Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M33 26C34.6569 26 36 24.6569 36 23C36 21.3431 34.6569 20 33 20C31.3431 20 30 21.3431 30 23C30 24.6569 31.3431 26 33 26Z",
                fill: "#FFD330"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M33 27C30.7939 27 29 25.2056 29 23C29 20.7944 30.7939 19 33 19C35.2061 19 37 20.7944 37 23C37 25.2056 35.2061 27 33 27ZM33 21C31.8975 21 31 21.897 31 23C31 24.103 31.8975 25 33 25C34.1025 25 35 24.103 35 23C35 21.897 34.1025 21 33 21Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M24 37C25.6569 37 27 35.6569 27 34C27 32.3431 25.6569 31 24 31C22.3431 31 21 32.3431 21 34C21 35.6569 22.3431 37 24 37Z",
                fill: "#FFD330"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M24 38C21.7939 38 20 36.2056 20 34C20 31.7944 21.7939 30 24 30C26.2061 30 28 31.7944 28 34C28 36.2056 26.2061 38 24 38ZM24 32C22.8975 32 22 32.897 22 34C22 35.103 22.8975 36 24 36C25.1025 36 26 35.103 26 34C26 32.897 25.1025 32 24 32Z",
                fill: "white"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-icons-virtual-412b14e947/1/packages/lib-icons/src/decorative/filled/newsletter-filled-decorative.tsx
/* eslint-disable max-len */ 

const NewsletterFilledDecorative = (param)=>{
    let { size  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        fill: "none",
        height: size,
        viewBox: "0 0 48 48",
        width: size,
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M24 37C23.813 37 23.627 36.948 23.463 36.844L1.46302 22.844C1.15902 22.651 0.983015 22.308 1.00102 21.948C1.02002 21.589 1.23002 21.266 1.55302 21.105L24 7L46.447 21.105C46.769 21.266 46.98 21.588 46.999 21.948C47.018 22.308 46.841 22.65 46.537 22.844L24.537 36.844C24.373 36.948 24.187 37 24 37Z",
                fill: "#D6B200"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M39 38H9V2C9 1.448 9.448 1 10 1H38C38.552 1 39 1.448 39 2V38Z",
                fill: "#F7F7F7"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M46 47C45.916 47 45.831 46.989 45.748 46.968L22.748 40.968L23 34L47 22V46C47 46.31 46.856 46.602 46.611 46.792C46.435 46.928 46.219 47 46 47Z",
                fill: "#FFD330"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M46 47H2C1.447 47 1 46.552 1 46V22L46.479 45.122C46.88 45.341 47.083 45.804 46.969 46.247C46.856 46.69 46.457 47 46 47Z",
                fill: "#FFE24D"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M32 10H16C15.448 10 15 9.553 15 9C15 8.447 15.448 8 16 8H32C32.552 8 33 8.447 33 9C33 9.553 32.552 10 32 10Z",
                fill: "#959595"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M32 17H16C15.448 17 15 16.553 15 16C15 15.447 15.448 15 16 15H32C32.552 15 33 15.447 33 16C33 16.553 32.552 17 32 17Z",
                fill: "#959595"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M25 24H16C15.448 24 15 23.553 15 23C15 22.447 15.448 22 16 22H25C25.552 22 26 22.447 26 23C26 23.553 25.552 24 25 24Z",
                fill: "#959595"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-icons-virtual-412b14e947/1/packages/lib-icons/src/decorative/filled/leaf-bulb-filled-decorativ.tsx
/* eslint-disable max-len */ 

const LeafBulbFilledDecorative = (param)=>{
    let { size  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        fill: "none",
        height: size,
        viewBox: "0 0 48 48",
        width: size,
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M41 18C41 7.96838 32.3111 -0.0338086 22.0485 1.10889C14.451 1.9549 8.23519 7.97095 7.17293 15.5412C6.00667 23.853 10.8634 31.193 18 33.8899V39H30V33.8899C36.4235 31.4625 41 25.2735 41 18Z",
                fill: "#E6E7E8"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M18 41C18 44.3137 20.6863 47 24 47C27.3137 47 30 44.3137 30 41V39H18V41Z",
                fill: "#AEAEAE"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M33 12H32C27.5817 12 24 15.5817 24 20V22H25C29.4183 22 33 18.4183 33 14V12Z",
                fill: "#52C6A8"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M15 19C15 23.4183 18.5817 27 23 27H24V25C24 20.5817 20.4183 17 16 17H15V19Z",
                fill: "#52C6A8"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M24 34C23.4473 34 23 33.5522 23 33V9C23 8.44775 23.4473 8 24 8C24.5527 8 25 8.44775 25 9V33C25 33.5522 24.5527 34 24 34Z",
                fill: "#008F69"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M30 38H18V40H30V38Z",
                fill: "#AEAEAE"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-icons-virtual-412b14e947/1/packages/lib-icons/src/decorative/filled/document-filled-decorativ.tsx
/* eslint-disable max-len */ 

const DocumentFilledDecorative = (param)=>{
    let { size  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        fill: "none",
        height: size,
        viewBox: "0 0 48 48",
        width: size,
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M42 41H12C10.895 41 10 40.105 10 39V3C10 1.895 10.895 1 12 1H42C43.105 1 44 1.895 44 3V39C44 40.105 43.105 41 42 41Z",
                fill: "#AEAEAE"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M36 47H6C4.895 47 4 46.105 4 45V9C4 7.895 4.895 7 6 7H36C37.105 7 38 7.895 38 9V45C38 46.105 37.105 47 36 47Z",
                fill: "#E6E7E8"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M29 19H13C12.448 19 12 18.552 12 18C12 17.448 12.448 17 13 17H29C29.552 17 30 17.448 30 18C30 18.552 29.552 19 29 19Z",
                fill: "#AEAEAE"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M29 27H13C12.448 27 12 26.552 12 26C12 25.448 12.448 25 13 25H29C29.552 25 30 25.448 30 26C30 26.552 29.552 27 29 27Z",
                fill: "#AEAEAE"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M21 35H13C12.448 35 12 34.552 12 34C12 33.448 12.448 33 13 33H21C21.552 33 22 33.448 22 34C22 34.552 21.552 35 21 35Z",
                fill: "#AEAEAE"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-icons-virtual-412b14e947/1/packages/lib-icons/src/decorative/filled/send-message-filled-decorativ.tsx
/* eslint-disable max-len */ 

const SendMessageFilledDecorative = (param)=>{
    let { size  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        fill: "none",
        height: size,
        viewBox: "0 0 48 48",
        width: size,
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M45.707 2.29304C45.5682 2.1542 45.3915 2.0593 45.1991 2.02017C45.0067 1.98105 44.807 1.99944 44.625 2.07304L2.62499 19.073C2.44906 19.1442 2.29701 19.264 2.18661 19.4183C2.07621 19.5727 2.01201 19.7553 2.00153 19.9448C1.99104 20.1343 2.03469 20.3229 2.12739 20.4885C2.22008 20.6541 2.35798 20.7899 2.52499 20.88L15 27.6L20.4 33L27.117 45.474C27.2028 45.6334 27.3302 45.7665 27.4857 45.8592C27.6412 45.9518 27.819 46.0005 28 46C28.0183 46.001 28.0367 46.001 28.055 46C28.2445 45.9896 28.4271 45.9255 28.5815 45.8152C28.7359 45.7049 28.8557 45.5529 28.927 45.377L45.927 3.37704C46.001 3.19475 46.0196 2.99468 45.9805 2.80186C45.9414 2.60904 45.8462 2.43205 45.707 2.29304Z",
                fill: "#E6E7E8"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M45.707 2.29308C45.5285 2.11464 45.2891 2.01032 45.0368 2.00104C44.7846 1.99177 44.5382 2.07823 44.347 2.24308L15.347 27.2431C15.2382 27.3369 15.1508 27.4531 15.091 27.5837C15.0311 27.7144 15.0001 27.8564 15 28.0001V32.0001C15 32.2653 15.1054 32.5196 15.2929 32.7072C15.4804 32.8947 15.7348 33.0001 16 33.0001H20C20.1439 33.0002 20.2861 32.9692 20.4169 32.9093C20.5477 32.8494 20.6641 32.762 20.758 32.6531L45.758 3.65308C45.9227 3.4618 46.009 3.21531 45.9995 2.96306C45.9901 2.71081 45.8856 2.47148 45.707 2.29308Z",
                fill: "#AEAEAE"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-icons-virtual-412b14e947/1/packages/lib-icons/src/decorative/filled/ecology-filled-decorativ.tsx
/* eslint-disable max-len */ 

const EcologyFilledDecorative = (param)=>{
    let { size  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        fill: "none",
        height: size,
        viewBox: "0 0 48 48",
        width: size,
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M24 47C36.7025 47 47 36.7025 47 24C47 11.2975 36.7025 1 24 1C11.2975 1 1 11.2975 1 24C1 36.7025 11.2975 47 24 47Z",
                fill: "#E6E7E8"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M1.00001 24C0.997059 27.2585 1.68831 30.4801 3.02773 33.4506C4.36715 36.421 6.32401 39.072 8.76801 41.227L10.8 38.18C10.8 38.18 12.252 37.761 12.565 37.199C13.545 35.435 11.805 32.364 11.805 32.364C11.7691 31.628 11.6517 30.8982 11.455 30.188C11.193 29.535 9.36401 28.64 9.36401 28.64C9.36401 28.64 7.60001 25.765 7.60001 24C7.5692 23.308 7.8127 22.6317 8.27761 22.1181C8.74252 21.6045 9.39129 21.2951 10.083 21.257C10.6665 21.1333 11.2179 20.8893 11.7017 20.5404C12.1856 20.1916 12.5913 19.7456 12.893 19.231C12.893 19.231 15.115 18.642 15.637 17.731C16.159 16.82 15.05 13.556 15.05 13.556C15.2554 12.6939 15.2479 11.7946 15.028 10.936C14.6636 10.1421 14.0957 9.45873 13.382 8.95503C12.8084 7.52083 11.9357 6.22538 10.822 5.15503C7.78794 7.27271 5.31042 10.0921 3.6003 13.3732C1.89019 16.6543 0.99812 20.3 1.00001 24Z",
                fill: "#04B485"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M24 1.00001C23.38 1.00001 22.768 1.03201 22.161 1.08001C21.961 1.69901 20.93 3.28801 21.19 4.00501C21.45 4.72201 23.585 5.38901 23.585 5.38901C23.585 5.38901 23.019 7.60001 24 8.38301C24.981 9.16601 26.549 8.12201 27.136 8.31801C27.723 8.51401 27.593 12.368 27.593 12.368C27.593 12.368 29.488 14.459 31.351 14.721C33.214 14.983 36.051 11.821 36.051 11.821C38.1363 11.3467 40.1771 10.6943 42.151 9.87101C40.0026 7.10582 37.25 4.86881 34.1039 3.33122C30.9578 1.79363 27.5017 0.996215 24 1.00001Z",
                fill: "#04B485"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M38.8581 25.5C39.3811 26.742 37.8761 29.912 36.6361 30.531C35.3667 31.1072 34.2603 31.9896 33.416 33.099C32.958 33.818 32.357 36.783 30.855 37.371C29.353 37.959 25.7901 41.313 23.8951 40.79C22.0001 40.267 22 35.761 23.307 33.735C24.087 32.526 23.176 29.88 23.107 28.966C23.038 28.052 20.3 26.352 20.3 25.438C20.3 24 23.4361 20.21 23.4361 20.21C23.4361 20.21 26.0061 19.361 26.7901 19.557C27.5827 19.8452 28.3424 20.2174 29.056 20.667C30.4379 20.7701 31.8001 21.0556 33.107 21.516L34.607 22.888C34.607 22.888 38.3351 24.261 38.8581 25.5Z",
                fill: "#04B485"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M47.316 19.0231C47.1166 18.9577 46.9017 18.9563 46.7014 19.0191C46.5012 19.0818 46.3255 19.2056 46.199 19.3731C44.9042 21.1233 43.2159 22.5445 41.2705 23.522C39.3251 24.4995 37.1771 25.0058 35 25.0001C33.0217 24.9985 31.0981 25.6493 29.5272 26.8518C27.9563 28.0543 26.8258 29.7412 26.3108 31.6513C25.7958 33.5615 25.9251 35.5881 26.6787 37.4172C27.4323 39.2464 28.768 40.776 30.479 41.7691C29.9798 42.7828 29.1953 43.6286 28.2219 44.2026C27.2486 44.7766 26.1287 45.0538 25 45.0001C24.7348 45.0001 24.4804 45.1054 24.2929 45.293C24.1054 45.4805 24 45.7348 24 46.0001C24 46.2653 24.1054 46.5196 24.2929 46.7072C24.4804 46.8947 24.7348 47.0001 25 47.0001C28.919 47.0001 30.86 45.0001 32.315 42.5901C33.184 42.8622 34.0894 43.0005 35 43.0001C38.4466 42.9961 41.7509 41.6252 44.188 39.1881C46.6251 36.7509 47.996 33.4467 48 30.0001V19.9731C48.0003 19.7629 47.9343 19.558 47.8115 19.3875C47.6888 19.217 47.5154 19.0895 47.316 19.0231Z",
                fill: "#008F69"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M40.313 28.3371C34.062 30.5671 31.713 35.1421 29.995 38.4831C29.58 39.2901 29.224 39.9771 28.877 40.5601C29.3634 41.0216 29.9001 41.4272 30.477 41.7691C30.915 41.0601 31.327 40.2601 31.771 39.3951C33.423 36.1831 35.477 32.1851 40.982 30.2191C41.1088 30.1775 41.2261 30.1109 41.3268 30.0233C41.4276 29.9357 41.5098 29.8288 41.5685 29.7089C41.6273 29.589 41.6614 29.4585 41.669 29.3252C41.6765 29.1919 41.6572 29.0584 41.6124 28.9327C41.5675 28.8069 41.4979 28.6914 41.4077 28.593C41.3174 28.4946 41.2084 28.4153 41.087 28.3596C40.9656 28.304 40.8343 28.2733 40.7009 28.2693C40.5674 28.2652 40.4345 28.2879 40.31 28.3361L40.313 28.3371Z",
                fill: "#52C6A8"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-icons-virtual-412b14e947/1/packages/lib-icons/src/decorative/filled/clock-1-filled-decorative.tsx
/* eslint-disable max-len */ 

const Clock1FilledDecorative = (param)=>{
    let { size  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        fill: "none",
        height: size,
        viewBox: "0 0 48 48",
        width: size,
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M24 45C35.598 45 45 35.598 45 24C45 12.402 35.598 3 24 3C12.402 3 3 12.402 3 24C3 35.598 12.402 45 24 45Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M24 47C11.3174 47 1 36.6821 1 24C1 11.3179 11.3174 1 24 1C36.6826 1 47 11.3179 47 24C47 36.6821 36.6826 47 24 47ZM24 5C13.5234 5 5 13.5234 5 24C5 34.4766 13.5234 43 24 43C34.4766 43 43 34.4766 43 24C43 13.5234 34.4766 5 24 5Z",
                fill: "#00416A"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M24 25C23.4473 25 23 24.5522 23 24V11C23 10.4477 23.4473 10 24 10C24.5527 10 25 10.4477 25 11V24C25 24.5522 24.5527 25 24 25Z",
                fill: "#0A3A5C"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M36 25H24C23.4473 25 23 24.5523 23 24C23 23.4477 23.4473 23 24 23H36C36.5527 23 37 23.4477 37 24C37 24.5523 36.5527 25 36 25Z",
                fill: "#0A3A5C"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M14.9991 36.0001C14.7764 36.0001 14.5528 35.9258 14.3672 35.774C13.9395 35.4244 13.876 34.7945 14.2256 34.3668L23.2256 23.3668C23.5762 22.94 24.2051 22.877 24.6329 23.2261C25.0606 23.5757 25.1241 24.2056 24.7745 24.6334L15.7745 35.6334C15.5762 35.8751 15.2891 36.0001 14.9991 36.0001Z",
                fill: "#F85E00"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M24 27C25.6569 27 27 25.6569 27 24C27 22.3431 25.6569 21 24 21C22.3431 21 21 22.3431 21 24C21 25.6569 22.3431 27 24 27Z",
                fill: "#0A3A5C"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-icons-virtual-412b14e947/1/packages/lib-icons/src/decorative/filled/lawnmower-filled-decorative.tsx
/* eslint-disable max-len */ 

const LawnmowerFilledDecorative = (param)=>{
    let { size  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        fill: "none",
        height: size,
        viewBox: "0 0 48 48",
        width: size,
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M34 19H22V28H34V19Z",
                fill: "#0A3A5C"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M13.409 23.754C13.1735 23.7537 12.9457 23.6702 12.7657 23.5184C12.5857 23.3666 12.465 23.1561 12.425 22.924L9.444 5.65901C9.36366 5.19472 9.12199 4.77371 8.76158 4.4702C8.40117 4.16669 7.94518 4.00017 7.474 4.00001H4C3.73478 4.00001 3.48043 3.89465 3.29289 3.70711C3.10536 3.51958 3 3.26522 3 3.00001C3 2.73479 3.10536 2.48044 3.29289 2.2929C3.48043 2.10536 3.73478 2.00001 4 2.00001H7.474C8.41716 1.99836 9.33043 2.33079 10.0518 2.93834C10.7733 3.54589 11.2562 4.38931 11.415 5.31901L14.4 22.584C14.4248 22.7277 14.4179 22.8751 14.3797 23.0159C14.3415 23.1566 14.2729 23.2873 14.1789 23.3988C14.0849 23.5103 13.9676 23.5998 13.8353 23.6612C13.703 23.7226 13.5588 23.7542 13.413 23.754H13.409Z",
                fill: "#FFD330"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M37.585 24.591L11.585 21.532C10.8837 21.4494 10.1728 21.5163 9.49918 21.7282C8.82556 21.9402 8.20449 22.2925 7.67685 22.7618C7.14921 23.2312 6.72698 23.807 6.43796 24.4513C6.14893 25.0956 5.99967 25.7938 6 26.5V38C6 38.2652 6.10536 38.5196 6.29289 38.7071C6.48043 38.8947 6.73478 39 7 39H41C41.2652 39 41.5196 38.8947 41.7071 38.7071C41.8946 38.5196 42 38.2652 42 38V29.557C42.0001 28.3322 41.5506 27.1499 40.7368 26.2345C39.9229 25.3192 38.8014 24.7343 37.585 24.591Z",
                fill: "#00416A"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M8 43C11.3137 43 14 40.3137 14 37C14 33.6863 11.3137 31 8 31C4.68629 31 2 33.6863 2 37C2 40.3137 4.68629 43 8 43Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M41 43C43.7614 43 46 40.7614 46 38C46 35.2386 43.7614 33 41 33C38.2386 33 36 35.2386 36 38C36 40.7614 38.2386 43 41 43Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M8 44C6.61553 44 5.26216 43.5895 4.11101 42.8203C2.95987 42.0511 2.06266 40.9579 1.53285 39.6788C1.00303 38.3997 0.86441 36.9922 1.13451 35.6344C1.4046 34.2765 2.07129 33.0292 3.05026 32.0503C4.02922 31.0713 5.2765 30.4046 6.63437 30.1345C7.99224 29.8644 9.3997 30.003 10.6788 30.5328C11.9579 31.0627 13.0511 31.9599 13.8203 33.111C14.5895 34.2622 15 35.6155 15 37C14.9976 38.8558 14.2594 40.6349 12.9471 41.9471C11.6349 43.2594 9.85579 43.9976 8 44ZM8 32C7.0111 32 6.0444 32.2932 5.22215 32.8427C4.39991 33.3921 3.75904 34.173 3.38061 35.0866C3.00217 36.0002 2.90315 37.0056 3.09608 37.9755C3.289 38.9454 3.76521 39.8363 4.46447 40.5355C5.16373 41.2348 6.05465 41.711 7.02455 41.9039C7.99446 42.0969 8.99979 41.9978 9.91342 41.6194C10.8271 41.241 11.6079 40.6001 12.1574 39.7779C12.7068 38.9556 13 37.9889 13 37C12.9984 35.6744 12.4711 34.4036 11.5338 33.4662C10.5964 32.5289 9.3256 32.0016 8 32Z",
                fill: "#FFD330"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M41 44C39.8133 44 38.6533 43.6481 37.6666 42.9888C36.6799 42.3295 35.9109 41.3925 35.4567 40.2961C35.0026 39.1997 34.8838 37.9933 35.1153 36.8295C35.3468 35.6656 35.9182 34.5965 36.7574 33.7574C37.5965 32.9182 38.6656 32.3468 39.8295 32.1153C40.9933 31.8838 42.1997 32.0026 43.2961 32.4567C44.3925 32.9109 45.3295 33.6799 45.9888 34.6666C46.6481 35.6533 47 36.8133 47 38C46.9984 39.5908 46.3658 41.116 45.2409 42.2409C44.116 43.3658 42.5908 43.9984 41 44ZM41 34C40.2089 34 39.4355 34.2346 38.7777 34.6741C38.1199 35.1137 37.6072 35.7384 37.3045 36.4693C37.0017 37.2002 36.9225 38.0044 37.0769 38.7804C37.2312 39.5563 37.6122 40.269 38.1716 40.8284C38.731 41.3878 39.4437 41.7688 40.2196 41.9231C40.9956 42.0775 41.7998 41.9983 42.5307 41.6955C43.2616 41.3928 43.8864 40.8801 44.3259 40.2223C44.7654 39.5645 45 38.7911 45 38C45 36.9391 44.5786 35.9217 43.8284 35.1716C43.0783 34.4214 42.0609 34 41 34Z",
                fill: "#FFD330"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M36 14H20C19.4477 14 19 14.4477 19 15V19C19 19.5523 19.4477 20 20 20H36C36.5523 20 37 19.5523 37 19V15C37 14.4477 36.5523 14 36 14Z",
                fill: "#FFD330"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-icons-virtual-412b14e947/1/packages/lib-icons/src/decorative/filled/tree-filled-decorative.tsx
/* eslint-disable max-len */ 

const TreeFilledDecorative = (param)=>{
    let { size  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        fill: "none",
        height: size,
        viewBox: "0 0 48 48",
        width: size,
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M24 39C16.103 39 11 34.6821 11 28C11 17.874 22.7383 3.94092 23.2378 3.35254L24 2.45557L24.7622 3.35254C25.2617 3.94092 37 17.874 37 28C37 34.6821 31.897 39 24 39Z",
                fill: "#52C6A8"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M28.293 27.293L25 30.5859V19C25 18.4477 24.5522 18 24 18C23.4477 18 23 18.4477 23 19V25.5859L19.707 22.293C19.3164 21.9024 18.6836 21.9024 18.293 22.293C17.9023 22.6836 17.9023 23.3164 18.293 23.707L23 28.4141V46C23 46.5522 23.4477 47 24 47C24.5522 47 25 46.5522 25 46V33.4141L29.707 28.707C30.0976 28.3164 30.0976 27.6836 29.707 27.293C29.3164 26.9024 28.6836 26.9023 28.293 27.293Z",
                fill: "#008F69"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M34 47H14C13.4477 47 13 46.5523 13 46C13 45.4477 13.4477 45 14 45H34C34.5522 45 35 45.4477 35 46C35 46.5523 34.5522 47 34 47Z",
                fill: "#FFB784"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-icons-virtual-412b14e947/1/packages/lib-icons/src/decorative/filled/time-clock-1-filled-decorative.tsx
/* eslint-disable max-len */ 

const TimeClock1FilledDecorative = (param)=>{
    let { size  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        fill: "none",
        height: size,
        viewBox: "0 0 48 48",
        width: size,
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M24 45C35.598 45 45 35.598 45 24C45 12.402 35.598 3 24 3C12.402 3 3 12.402 3 24C3 35.598 12.402 45 24 45Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M24 47C19.451 47 15.0042 45.6511 11.2219 43.1238C7.43956 40.5965 4.4916 37.0044 2.75078 32.8017C1.00997 28.599 0.554489 23.9745 1.44195 19.5129C2.32941 15.0514 4.51995 10.9532 7.73655 7.73655C10.9532 4.51995 15.0514 2.32941 19.5129 1.44195C23.9745 0.554489 28.599 1.00997 32.8017 2.75078C37.0044 4.4916 40.5965 7.43956 43.1238 11.2219C45.6511 15.0042 47 19.451 47 24C46.9931 30.0979 44.5677 35.944 40.2559 40.2559C35.944 44.5677 30.0979 46.9931 24 47ZM24 5.00001C20.2422 5.00001 16.5687 6.11434 13.4442 8.20209C10.3196 10.2898 7.88436 13.2572 6.4463 16.729C5.00823 20.2008 4.63197 24.0211 5.36509 27.7067C6.09821 31.3924 7.90778 34.7778 10.565 37.435C13.2222 40.0922 16.6077 41.9018 20.2933 42.6349C23.9789 43.3681 27.7992 42.9918 31.271 41.5537C34.7428 40.1157 37.7102 37.6804 39.7979 34.5558C41.8857 31.4313 43 27.7579 43 24C42.9945 18.9626 40.9909 14.1331 37.4289 10.5711C33.8669 7.00913 29.0374 5.00557 24 5.00001Z",
                fill: "#0A3A5C"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M15.0001 36C14.8109 35.9998 14.6257 35.9459 14.4659 35.8446C14.3061 35.7433 14.1783 35.5988 14.0974 35.4278C14.0164 35.2568 13.9857 35.0664 14.0086 34.8786C14.0316 34.6908 14.1073 34.5134 14.2271 34.367L23.2271 23.367C23.3964 23.1663 23.6378 23.0403 23.8993 23.0161C24.1607 22.9919 24.4212 23.0715 24.6244 23.2378C24.8277 23.404 24.9574 23.6435 24.9856 23.9045C25.0138 24.1656 24.9382 24.4272 24.7751 24.633L15.7751 35.633C15.6812 35.7478 15.5629 35.8403 15.4289 35.9038C15.2949 35.9672 15.1484 36.0001 15.0001 36Z",
                fill: "#F85E00"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M24 27C25.6569 27 27 25.6569 27 24C27 22.3431 25.6569 21 24 21C22.3431 21 21 22.3431 21 24C21 25.6569 22.3431 27 24 27Z",
                fill: "#0A3A5C"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M33 25H24C23.8354 25 23.6734 24.9594 23.5282 24.8818C23.3831 24.8042 23.2593 24.6919 23.168 24.555L15.168 12.555C15.0951 12.4457 15.0445 12.3232 15.0189 12.1944C14.9934 12.0655 14.9935 11.9329 15.0192 11.8041C15.0712 11.544 15.2243 11.3152 15.445 11.168C15.6657 11.0208 15.9358 10.9673 16.1959 11.0192C16.456 11.0712 16.6848 11.2243 16.832 11.445L24.535 23H33C33.2652 23 33.5196 23.1054 33.7071 23.2929C33.8946 23.4804 34 23.7348 34 24C34 24.2652 33.8946 24.5196 33.7071 24.7071C33.5196 24.8946 33.2652 25 33 25Z",
                fill: "#0A3A5C"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M24 11C23.7348 11 23.4804 10.8946 23.2929 10.7071C23.1054 10.5196 23 10.2652 23 10V8C23 7.73478 23.1054 7.48043 23.2929 7.29289C23.4804 7.10536 23.7348 7 24 7C24.2652 7 24.5196 7.10536 24.7071 7.29289C24.8946 7.48043 25 7.73478 25 8V10C25 10.2652 24.8946 10.5196 24.7071 10.7071C24.5196 10.8946 24.2652 11 24 11Z",
                fill: "#959595"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M37 24C37 23.7348 37.1054 23.4804 37.2929 23.2929C37.4804 23.1054 37.7348 23 38 23H40C40.2652 23 40.5196 23.1054 40.7071 23.2929C40.8946 23.4804 41 23.7348 41 24C41 24.2652 40.8946 24.5196 40.7071 24.7071C40.5196 24.8946 40.2652 25 40 25H38C37.7348 25 37.4804 24.8946 37.2929 24.7071C37.1054 24.5196 37 24.2652 37 24Z",
                fill: "#959595"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M24 37C24.2652 37 24.5196 37.1054 24.7071 37.2929C24.8946 37.4804 25 37.7348 25 38V40C25 40.2652 24.8946 40.5196 24.7071 40.7071C24.5196 40.8946 24.2652 41 24 41C23.7348 41 23.4804 40.8946 23.2929 40.7071C23.1054 40.5196 23 40.2652 23 40V38C23 37.7348 23.1054 37.4804 23.2929 37.2929C23.4804 37.1054 23.7348 37 24 37Z",
                fill: "#959595"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M11 24C11 24.2652 10.8946 24.5196 10.7071 24.7071C10.5196 24.8946 10.2652 25 10 25H8C7.73478 25 7.48043 24.8946 7.29289 24.7071C7.10536 24.5196 7 24.2652 7 24C7 23.7348 7.10536 23.4804 7.29289 23.2929C7.48043 23.1054 7.73478 23 8 23H10C10.2652 23 10.5196 23.1054 10.7071 23.2929C10.8946 23.4804 11 23.7348 11 24Z",
                fill: "#959595"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-icons-virtual-412b14e947/1/packages/lib-icons/src/decorative/filled/plant-ground-filled-decorative.tsx
/* eslint-disable max-len */ 

const PlantGroundFilledDecorative = (param)=>{
    let { size  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        fill: "none",
        height: size,
        viewBox: "0 0 48 48",
        width: size,
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M34 18C30.0334 18 26.6165 20.3154 25 23.663V2C25 1.44775 24.5527 1 24 1C23.4473 1 23 1.44775 23 2V13.663C21.3835 10.3154 17.9665 8 14 8H12V12C12 17.5228 16.4772 22 22 22H23V38.2529C23 38.8052 23.4473 39.2529 24 39.2529C24.5527 39.2529 25 38.8052 25 38.2529V32H26C31.5228 32 36 27.5228 36 22V18H34Z",
                fill: "#52C6A8"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M46 47H2C1.44727 47 1 46.5522 1 46C1 45.4478 1.44727 45 2 45H11.1006C11.5654 42.7207 13.585 41 16 41C16.7637 41 17.5156 41.1816 18.1992 41.5229C19.7881 38.7412 22.7363 37 26 37C30.625 37 34.4453 40.5064 34.9443 45H46C46.5527 45 47 45.4478 47 46C47 46.5522 46.5527 47 46 47Z",
                fill: "#FFB784"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-icons-virtual-412b14e947/1/packages/lib-icons/src/decorative/filled/mobile-contact-1-filled-decorative.tsx
/* eslint-disable max-len */ 

const MobileContact1FilledDecorative = (param)=>{
    let { size  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        fill: "none",
        height: size,
        viewBox: "0 0 48 48",
        width: size,
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                clipRule: "evenodd",
                d: "M14 47C11.791 47 10 45.1276 10 42.8182V5C10 2.79086 11.7909 1 14 1H34C36.209 1 38 2.87241 38 5.18182V42.8182C38 45.1276 36.209 47 34 47H14Z",
                fill: "#0A3A5C",
                fillRule: "evenodd"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                clipRule: "evenodd",
                d: "M22 43C22 41.895 22.896 41 24 41C25.104 41 26 41.895 26 43C26 44.105 25.104 45 24 45C22.896 45 22 44.105 22 43Z",
                fill: "#F7F7F7",
                fillRule: "evenodd"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                clipRule: "evenodd",
                d: "M12 5.99914C12 5.44733 12.4475 5 13.0007 5H34.9993C35.552 5 36 5.45492 36 5.99914V38.0009C36 38.5527 35.5525 39 34.9993 39H13.0007C12.448 39 12 38.5451 12 38.0009V5.99914Z",
                fill: "#80B3D2",
                fillRule: "evenodd"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                clipRule: "evenodd",
                d: "M26 24H22C19.2386 24 17 26.2386 17 29C17 29.5523 17.4499 30 18.0068 30H29.9932C30.5492 30 31 29.5468 31 29C31 26.2386 28.7614 24 26 24Z",
                fill: "white",
                fillRule: "evenodd"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M24 22C26.2091 22 28 20.2091 28 18C28 15.7909 26.2091 14 24 14C21.7909 14 20 15.7909 20 18C20 20.2091 21.7909 22 24 22Z",
                fill: "white"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-icons-virtual-412b14e947/1/packages/lib-icons/src/decorative/filled/index.ts






































;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-icons-virtual-412b14e947/1/packages/lib-icons/src/decorative/line/barbecue-tools-line-decorative.tsx


const BarbecueToolsLineDecorative = (param)=>{
    let { size , color ="#0A3A5C"  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        fill: "none",
        height: size,
        viewBox: "0 0 48 48",
        width: size,
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M40 30H32V42C32 44.2 33.8 46 36 46C38.2 46 40 44.2 40 42V30Z",
                stroke: color,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2.5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M36 30V2",
                stroke: color,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2.5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M44 2H28V18H44V2Z",
                stroke: color,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2.5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M16 30H8V42C8 44.2 9.8 46 12 46C14.2 46 16 44.2 16 42V30Z",
                stroke: color,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2.5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M12 30V18",
                stroke: color,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2.5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M18 2V12C18 15.3 15.3 18 12 18C8.7 18 6 15.3 6 12V2",
                stroke: color,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2.5"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-icons-virtual-412b14e947/1/packages/lib-icons/src/decorative/line/design-line-decorative.tsx


const DesignLineDecorative = (param)=>{
    let { size , color ="#0A3A5C"  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        fill: "none",
        height: size,
        viewBox: "0 0 48 48",
        width: size,
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M8 16L16 8",
                stroke: color,
                strokeMiterlimit: "10",
                strokeWidth: "2.5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M42 34L34 42",
                stroke: color,
                strokeMiterlimit: "10",
                strokeWidth: "2.5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M25 33L34 42L44 44L42 34L33 25",
                stroke: color,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2.5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M23 15L12 4L4 12L15 23",
                stroke: color,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2.5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M14 44L4 34L34 4L44 14L14 44Z",
                stroke: color,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2.5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M22 16L24 18",
                stroke: color,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2.5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M28 10L32 14",
                stroke: color,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2.5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M16 22L20 26",
                stroke: color,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2.5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M10 28L12 30",
                stroke: color,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2.5"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-icons-virtual-412b14e947/1/packages/lib-icons/src/decorative/line/drill-line-decorative.tsx


const DrillLineDecorative = (param)=>{
    let { size , color ="#0A3A5C"  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        fill: "none",
        height: size,
        viewBox: "0 0 48 48",
        width: size,
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M21.0001 28L18.3291 24.697L18.8421 25.331",
                stroke: color,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2.5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M42 11H46",
                stroke: color,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2.5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                // eslint-disable-next-line max-len
                d: "M29 20H6C4.93913 20 3.92172 19.5786 3.17157 18.8284C2.42143 18.0783 2 17.0609 2 16V6C2 4.93913 2.42143 3.92172 3.17157 3.17157C3.92172 2.42143 4.93913 2 6 2H29L36 5V17L29 20Z",
                stroke: color,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2.5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                // eslint-disable-next-line max-len
                d: "M25.658 35.443L20.858 34.643C19.8279 34.4707 18.906 33.9024 18.2894 33.0595C17.6728 32.2166 17.4103 31.1659 17.558 30.132L19 20H9L7 34L4.514 34.994C3.77181 35.291 3.13563 35.8035 2.68752 36.4655C2.23942 37.1275 1.99995 37.9086 2 38.708V46H29V39.389C29.0001 38.4421 28.6643 37.5259 28.0524 36.8034C27.4404 36.0808 26.592 35.5988 25.658 35.443V35.443Z",
                stroke: color,
                strokeMiterlimit: "10",
                strokeWidth: "2.5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M29 2V20",
                stroke: color,
                strokeMiterlimit: "10",
                strokeWidth: "2.5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M42 8H36V14H42V8Z",
                stroke: color,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2.5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M8 14H12",
                stroke: color,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2.5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M8 8H12",
                stroke: color,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2.5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M2 41H29",
                stroke: color,
                strokeMiterlimit: "10",
                strokeWidth: "2.5"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-icons-virtual-412b14e947/1/packages/lib-icons/src/decorative/line/measure-1-line-decorative.tsx


const Measure1LineDecorative = (param)=>{
    let { size , color ="#0A3A5C"  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        fill: "none",
        height: size,
        viewBox: "0 0 48 48",
        width: size,
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M16 12H22",
                stroke: color,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2.5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M16 20H20",
                stroke: color,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2.5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M16 28H22",
                stroke: color,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2.5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M16 36H20",
                stroke: color,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2.5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M32 2H16V46H32V2Z",
                stroke: color,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2.5"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-icons-virtual-412b14e947/1/packages/lib-icons/src/decorative/line/measure-2-line-decorative.tsx


const Measure2LineDecorative = (param)=>{
    let { size , color ="#0A3A5C"  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        fill: "none",
        height: size,
        viewBox: "0 0 48 48",
        width: size,
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M22 16L24 18",
                stroke: color,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2.5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M28 10L32 14",
                stroke: color,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2.5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M16 22L20 26",
                stroke: color,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2.5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M10 28L12 30",
                stroke: color,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2.5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M14 44L4 34L34 4L44 14L14 44Z",
                stroke: color,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2.5"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-icons-virtual-412b14e947/1/packages/lib-icons/src/decorative/line/measure-big-line-decorative.tsx


const MeasureBigLineDecorative = (param)=>{
    let { size , color ="#0A3A5C"  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        fill: "none",
        height: size,
        viewBox: "0 0 48 48",
        width: size,
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M2 20H6",
                stroke: color,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2.5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M2 28H6",
                stroke: color,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2.5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M2 36H6",
                stroke: color,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2.5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M12 26V36H22L12 26Z",
                stroke: color,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2.5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M2 4V44H42L2 4Z",
                stroke: color,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2.5"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-icons-virtual-412b14e947/1/packages/lib-icons/src/decorative/line/paint-brush-line-decorative.tsx


const PaintBrushLineDecorative = (param)=>{
    let { size , color ="#0A3A5C"  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        fill: "none",
        height: size,
        viewBox: "0 0 48 48",
        width: size,
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M30.7491 39.879L44.9291 25.699L40.6861 21.456L31.0001 24L33.5771 14.423L22.2631 3.10901L8.12109 17.251",
                stroke: color,
                strokeMiterlimit: "10",
                strokeWidth: "2.5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                // eslint-disable-next-line max-len
                d: "M8.12099 17.251L6.70699 18.665C4.36399 21.008 4.36399 24.807 6.70699 27.15L10.95 31.393L3.17199 39.171C1.60999 40.733 1.60999 43.266 3.17199 44.828C4.73399 46.39 7.26699 46.39 8.82899 44.828L16.607 37.05L20.85 41.293C23.193 43.636 26.992 43.636 29.335 41.293L30.749 39.879L8.12099 17.251Z",
                stroke: color,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2.5"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-icons-virtual-412b14e947/1/packages/lib-icons/src/decorative/line/paint-bucket-1-line-decorative.tsx


const PaintBucket1LineDecorative = (param)=>{
    let { size , color ="#0A3A5C"  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        fill: "none",
        height: size,
        viewBox: "0 0 48 48",
        width: size,
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M6 8V40C6 43.314 14.059 46 24 46C33.941 46 42 43.314 42 40V8",
                stroke: color,
                strokeMiterlimit: "10",
                strokeWidth: "2.5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                // eslint-disable-next-line max-len
                d: "M24 2C14.059 2 6 4.686 6 8C6 11.314 14.059 14 24 14C24.688 14 25.333 13.949 26 13.923V25C26 26.657 27.343 28 29 28C30.657 28 32 26.657 32 25V13.369C37.922 12.386 42 10.354 42 8C42 4.686 33.941 2 24 2Z",
                stroke: color,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2.5"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-icons-virtual-412b14e947/1/packages/lib-icons/src/decorative/line/paint-bucket-2-line-decorative.tsx


const PaintBucket2LineDecorative = (param)=>{
    let { size , color ="#0A3A5C"  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        fill: "none",
        height: size,
        viewBox: "0 0 48 48",
        width: size,
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                clipPath: "url(#clip0_1144_7152)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M4.80005 24L26 39.6C27.6 41.2 32.3 38.9001 36.6 34.7001C40.9 30.5001 43.1 25.7 41.5 24.1L26 2.80005",
                        stroke: color,
                        strokeMiterlimit: "10",
                        strokeWidth: "2.5"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        // eslint-disable-next-line max-len
                        d: "M19.6315 17.6693C25.4893 11.8115 28.3385 5.16337 25.9954 2.82025C23.6523 0.477126 17.0041 3.32634 11.1463 9.18415C5.28849 15.042 2.43927 21.6901 4.78239 24.0332C7.12552 26.3764 13.7737 23.5272 19.6315 17.6693Z",
                        stroke: color,
                        strokeLinecap: "square",
                        strokeMiterlimit: "10",
                        strokeWidth: "2.5"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M2 40C2 37.8 6 32 6 32C6 32 10 37.8 10 40C10 42.2 8.2 44 6 44C3.8 44 2 42.2 2 40Z",
                        stroke: color,
                        strokeLinecap: "square",
                        strokeMiterlimit: "10",
                        strokeWidth: "2.5"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M24 22H32C36.4 22 40 18.4 40 14C40 9.6 36.4 6 32 6H28.4",
                        stroke: color,
                        strokeLinecap: "square",
                        strokeMiterlimit: "10",
                        strokeWidth: "2.5"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_1144_7152",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        fill: "white",
                        height: "48",
                        width: "48"
                    })
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-icons-virtual-412b14e947/1/packages/lib-icons/src/decorative/line/paint-line-decorative.tsx


const PaintLineDecorative = (param)=>{
    let { size , color ="#0A3A5C"  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        fill: "none",
        height: size,
        viewBox: "0 0 48 48",
        width: size,
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M40 22H8",
                stroke: color,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2.5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                // eslint-disable-next-line max-len
                d: "M40 2V24C40 27.314 37.314 30 34 30H28V42C28 44.209 26.209 46 24 46C21.791 46 20 44.209 20 42V30H14C10.686 30 8 27.314 8 24V2H26L30 9L34 2H40Z",
                stroke: color,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2.5"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-icons-virtual-412b14e947/1/packages/lib-icons/src/decorative/line/paint-roll-line-decorative.tsx


const PaintRollLineDecorative = (param)=>{
    let { size , color ="#0A3A5C"  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        fill: "none",
        height: size,
        viewBox: "0 0 48 48",
        width: size,
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M41 2H7V14H41V2Z",
                stroke: color,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2.5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M2 8V18C2 19.105 2.895 20 4 20H22C23.105 20 24 20.895 24 22V27",
                stroke: color,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2.5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M28 27H20V46H28V27Z",
                stroke: color,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2.5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M37 32C37 29.791 41 24 41 24C41 24 45 29.791 45 32C45 34.209 43.209 36 41 36C38.791 36 37 34.209 37 32Z",
                stroke: color,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2.5"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-icons-virtual-412b14e947/1/packages/lib-icons/src/decorative/line/pickaxe-line-decorative.tsx


const PickaxeLineDecorative = (param)=>{
    let { size , color ="#0A3A5C"  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        fill: "none",
        height: size,
        viewBox: "0 0 48 48",
        width: size,
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M14 40L8 34",
                stroke: color,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2.5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M31.9539 10.046L35.4999 6.5L41.4999 12.5L37.9469 16.053",
                stroke: color,
                strokeMiterlimit: "10",
                strokeWidth: "2.5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                // eslint-disable-next-line max-len
                d: "M30 24L10.242 43.758C9.84823 44.1524 9.3806 44.4653 8.86583 44.6788C8.35106 44.8923 7.79924 45.0022 7.24195 45.0022C6.68467 45.0022 6.13285 44.8923 5.61808 44.6788C5.1033 44.4653 4.63568 44.1524 4.24195 43.758C3.84755 43.3643 3.53466 42.8967 3.32117 42.3819C3.10769 41.8671 2.9978 41.3153 2.9978 40.758C2.9978 40.2007 3.10769 39.6489 3.32117 39.1341C3.53466 38.6193 3.84755 38.1517 4.24195 37.758L24 18",
                stroke: color,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2.5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                // eslint-disable-next-line max-len
                d: "M18.072 2.59998C24.3662 4.84749 30.0823 8.4656 34.8069 13.1927C39.5316 17.9198 43.1467 23.6377 45.391 29.933L42.591 31.718C36.3059 20.7736 27.2303 11.6922 16.29 5.39998L18.072 2.59998Z",
                stroke: color,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2.5"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-icons-virtual-412b14e947/1/packages/lib-icons/src/decorative/line/ruler-pencil-line-decorative.tsx


const RulerPencilLineDecorative = (param)=>{
    let { size , color ="#0A3A5C"  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        fill: "none",
        height: size,
        viewBox: "0 0 48 48",
        width: size,
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M31 35H45",
                stroke: color,
                strokeMiterlimit: "10",
                strokeWidth: "2.5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M31 10H45",
                stroke: color,
                strokeMiterlimit: "10",
                strokeWidth: "2.5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M45 35L38 44L31 35V2H45V35Z",
                stroke: color,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2.5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M4 12H12",
                stroke: color,
                strokeMiterlimit: "10",
                strokeWidth: "2.5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M4 20H10",
                stroke: color,
                strokeMiterlimit: "10",
                strokeWidth: "2.5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M4 28H12",
                stroke: color,
                strokeMiterlimit: "10",
                strokeWidth: "2.5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M4 36H10",
                stroke: color,
                strokeMiterlimit: "10",
                strokeWidth: "2.5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M20 2H4V46H20V2Z",
                stroke: color,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2.5"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-icons-virtual-412b14e947/1/packages/lib-icons/src/decorative/line/scissors-line-decorative.tsx


const ScissorsLineDecorative = (param)=>{
    let { size , color ="#0A3A5C"  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        fill: "none",
        height: size,
        viewBox: "0 0 48 48",
        width: size,
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M14.8781 34.505L40.0001 4",
                stroke: color,
                strokeMiterlimit: "10",
                strokeWidth: "2.5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M33.122 34.505L8 4",
                stroke: color,
                strokeMiterlimit: "10",
                strokeWidth: "2.5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                // eslint-disable-next-line max-len
                d: "M38 44C41.3137 44 44 41.3137 44 38C44 34.6863 41.3137 32 38 32C34.6863 32 32 34.6863 32 38C32 41.3137 34.6863 44 38 44Z",
                stroke: color,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2.5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                // eslint-disable-next-line max-len
                d: "M10 44C13.3137 44 16 41.3137 16 38C16 34.6863 13.3137 32 10 32C6.68629 32 4 34.6863 4 38C4 41.3137 6.68629 44 10 44Z",
                stroke: color,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2.5"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-icons-virtual-412b14e947/1/packages/lib-icons/src/decorative/line/settings-cogwheel-line-decorative.tsx


const SettingsCogwheelLineDecorative = (param)=>{
    let { size , color ="#0A3A5C"  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        fill: "none",
        height: size,
        viewBox: "0 0 48 48",
        width: size,
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                // eslint-disable-next-line max-len
                d: "M24 31C27.866 31 31 27.866 31 24C31 20.134 27.866 17 24 17C20.134 17 17 20.134 17 24C17 27.866 20.134 31 24 31Z",
                stroke: color,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2.5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                // eslint-disable-next-line max-len
                d: "M46 27V21L39.6 20.466C39.1994 18.6962 38.4986 17.0082 37.528 15.475L41.683 10.565L37.435 6.322L32.525 10.477C30.9923 9.50443 29.3042 8.80191 27.534 8.4L27 2H21L20.466 8.4C18.6962 8.80063 17.0082 9.50143 15.475 10.472L10.565 6.317L6.322 10.565L10.477 15.475C9.50443 17.0077 8.80191 18.6958 8.4 20.466L2 21V27L8.4 27.534C8.80063 29.3038 9.50143 30.9918 10.472 32.525L6.317 37.435L10.56 41.678L15.47 37.523C17.0042 38.4961 18.6941 39.1986 20.466 39.6L21 46H27L27.534 39.595C29.3038 39.1944 30.9918 38.4936 32.525 37.523L37.435 41.678L41.678 37.435L37.523 32.525C38.4956 30.9923 39.1981 29.3042 39.6 27.534L46 27Z",
                stroke: color,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2.5"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-icons-virtual-412b14e947/1/packages/lib-icons/src/decorative/line/settings-gear-line-decorative.tsx


const SettingsGearLineDecorative = (param)=>{
    let { size , color ="#0A3A5C"  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        fill: "none",
        height: size,
        viewBox: "0 0 48 48",
        width: size,
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                // eslint-disable-next-line max-len
                d: "M24 31C27.866 31 31 27.866 31 24C31 20.134 27.866 17 24 17C20.134 17 17 20.134 17 24C17 27.866 20.134 31 24 31Z",
                stroke: color,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2.5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                // eslint-disable-next-line max-len
                d: "M40 24C39.998 22.8478 39.872 21.6992 39.624 20.574L45.052 16.464L41.052 9.536L34.766 12.188C33.0639 10.6271 31.0435 9.45413 28.844 8.75L28 2H20L19.156 8.75C16.9565 9.45413 14.9361 10.6271 13.234 12.188L6.948 9.536L2.948 16.464L8.376 20.574C7.87501 22.8305 7.87501 25.1695 8.376 27.426L2.948 31.536L6.948 38.464L13.234 35.812C14.9361 37.3729 16.9565 38.5459 19.156 39.25L20 46H28L28.844 39.25C31.0435 38.5459 33.0639 37.3729 34.766 35.812L41.052 38.464L45.052 31.536L39.624 27.426C39.872 26.3008 39.998 25.1522 40 24V24Z",
                stroke: color,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2.5"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-icons-virtual-412b14e947/1/packages/lib-icons/src/decorative/line/settings-tools-line-decorative.tsx


const SettingsToolsLineDecorative = (param)=>{
    let { size , color ="#0A3A5C"  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        fill: "none",
        height: size,
        viewBox: "0 0 48 48",
        width: size,
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                // eslint-disable-next-line max-len
                d: "M38.0001 29.77L41.9891 33.37C42.6029 33.9245 43.0975 34.598 43.4428 35.3496C43.7882 36.1011 43.977 36.9151 43.998 37.742C44.0189 38.5688 43.8715 39.3913 43.5647 40.1594C43.2578 40.9275 42.798 41.6252 42.2131 42.21V42.21C41.6283 42.7949 40.9306 43.2548 40.1625 43.5616C39.3944 43.8684 38.5719 44.0159 37.745 43.9949C36.9182 43.974 36.1042 43.7851 35.3526 43.4397C34.6011 43.0944 33.9276 42.5998 33.3731 41.986L27.9641 36",
                stroke: color,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2.5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M22.225 18.69L15 11.464V9L9 3L3 9L9 15H11.464L18.51 22.046",
                stroke: color,
                strokeMiterlimit: "10",
                strokeWidth: "2.5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                // eslint-disable-next-line max-len
                d: "M44.514 10.391L38.776 16.128L31.876 9.22803L37.613 3.49003C36.2854 3.09872 34.8992 2.94436 33.518 3.03403C30.9689 3.24496 28.5772 4.35328 26.7685 6.16185C24.9597 7.97041 23.8512 10.3619 23.64 12.911C23.5496 14.294 23.7043 15.682 24.097 17.011L3.99998 35.155C3.69571 35.4301 3.45054 35.7641 3.27935 36.1368C3.10816 36.5096 3.01452 36.9132 3.00414 37.3232C2.99376 37.7333 3.06685 38.1411 3.21895 38.522C3.37106 38.9029 3.59902 39.2489 3.88898 39.539L8.46398 44.114C8.75423 44.4033 9.10021 44.6307 9.48095 44.7822C9.86169 44.9338 10.2692 45.0065 10.6789 44.9958C11.0886 44.9852 11.4918 44.8914 11.8641 44.7202C12.2365 44.5491 12.5702 44.304 12.845 44L31 23.907C32.3291 24.2997 33.7171 24.4544 35.1 24.364C37.6491 24.1528 40.0406 23.0443 41.8492 21.2355C43.6577 19.4268 44.7661 17.0351 44.977 14.486C45.0644 13.1044 44.9077 11.7182 44.514 10.391Z",
                stroke: color,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2.5"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-icons-virtual-412b14e947/1/packages/lib-icons/src/decorative/line/shovel-line-decorative.tsx


const ShovelLineDecorative = (param)=>{
    let { size , color ="#0A3A5C"  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        fill: "none",
        height: size,
        viewBox: "0 0 48 48",
        width: size,
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                clipPath: "url(#clip0_1144_7130)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M24 10C20.686 10 18 7.314 18 4V2H30V4C30 7.314 27.314 10 24 10Z",
                        stroke: color,
                        strokeLinecap: "square",
                        strokeMiterlimit: "10",
                        strokeWidth: "2.5"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        // eslint-disable-next-line max-len
                        d: "M24 47C24 47 13 45.0833 13 38V25C13 24.4477 13.4477 24 14 24H34C34.5523 24 35 24.4477 35 25V38C35 45 24 47 24 47Z",
                        stroke: color,
                        strokeLinecap: "square",
                        strokeWidth: "2.5"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M24 10V34",
                        stroke: color,
                        strokeLinecap: "square",
                        strokeMiterlimit: "10",
                        strokeWidth: "2.5"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_1144_7130",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        fill: "white",
                        height: "48",
                        width: "48"
                    })
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-icons-virtual-412b14e947/1/packages/lib-icons/src/decorative/line/swiss-knife-line-decorative.tsx


const SwissKnifeLineDecorative = (param)=>{
    let { size , color ="#0A3A5C"  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        fill: "none",
        height: size,
        viewBox: "0 0 48 48",
        width: size,
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M32 34V16C32 8.3 38.3 2 46 2V40",
                stroke: color,
                strokeMiterlimit: "10",
                strokeWidth: "2.5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M2 40V10H14V18C11.8 18 10 19.8 10 22C10 24.2 11.8 26 14 26V34",
                stroke: color,
                strokeMiterlimit: "10",
                strokeWidth: "2.5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M2 40C2 36.7 4.7 34 8 34H40C43.3 34 46 36.7 46 40C46 43.3 43.3 46 40 46H8C4.7 46 2 43.3 2 40Z",
                stroke: color,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2.5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M40 28V13",
                stroke: color,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2.5"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-icons-virtual-412b14e947/1/packages/lib-icons/src/decorative/line/wrench-line-decorative.tsx


const WrenchLineDecorative = (param)=>{
    let { size , color ="#0A3A5C"  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        fill: "none",
        height: size,
        viewBox: "0 0 48 48",
        width: size,
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            // eslint-disable-next-line max-len
            d: "M45.5 9.59997L39.6 15.5L32.5 8.39997L38.4 2.49997C37 2.09997 35.6 1.89997 34 1.99997C28.4 2.49997 23.9 7.49997 24 13.1C24 14.2 24.2 15.3 24.5 16.3L5.30004 33.3C2.40004 35.8 2.30004 40.3 5.00004 43C7.70004 45.7 12.1 45.6 14.7 42.7L31.7 23.5C33.4 24 35.3 24.2 37.3 23.8C41.3 23 44.6 20 45.7 16.1C46.2 13.8 46.1 11.6 45.5 9.59997Z",
            stroke: color,
            strokeLinecap: "square",
            strokeMiterlimit: "10",
            strokeWidth: "2.5"
        })
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-icons-virtual-412b14e947/1/packages/lib-icons/src/decorative/line/recycle-line-decorative.tsx
/* eslint-disable max-len */ 

const RecycleLineDecorative = (param)=>{
    let { size , color ="#0A3A5C"  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        fill: "none",
        height: size,
        viewBox: "0 0 48 48",
        width: size,
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M42.068 2.26001L43.526 13.854L32.142 10.682",
                stroke: color,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2.5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M43.526 13.854C41.2555 9.48002 37.5821 5.99503 33.0947 3.95773C28.6073 1.92044 23.5658 1.44884 18.7784 2.61854C13.991 3.78824 9.73495 6.53149 6.69259 10.4085C3.65022 14.2856 1.99773 19.0718 2 24",
                stroke: color,
                strokeMiterlimit: "10",
                strokeWidth: "2.5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M5.932 45.74L4.474 34.146L15.858 37.318",
                stroke: color,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2.5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M4.474 34.146C6.74318 38.5227 10.4166 42.0104 14.9051 44.0496C19.3936 46.0888 24.4369 46.5613 29.2261 45.3913C34.0152 44.2213 38.2726 41.4767 41.3152 37.5976C44.3579 33.7186 46.0094 28.93 46.005 24",
                stroke: color,
                strokeMiterlimit: "10",
                strokeWidth: "2.5"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-icons-virtual-412b14e947/1/packages/lib-icons/src/decorative/line/globe-line-decorative.tsx
/* eslint-disable max-len */ 

const GlobeLineDecorative = (param)=>{
    let { size , color ="#0A3A5C"  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        fill: "none",
        height: size,
        viewBox: "0 0 48 48",
        width: size,
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M24 2V46",
                stroke: "black",
                strokeMiterlimit: "10",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M2 24H46",
                stroke: "black",
                strokeMiterlimit: "10",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M4.94397 13H43.056",
                stroke: "black",
                strokeMiterlimit: "10",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M4.94397 35H43.056",
                stroke: "black",
                strokeMiterlimit: "10",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M24 46C30.0751 46 35 36.1503 35 24C35 11.8497 30.0751 2 24 2C17.9249 2 13 11.8497 13 24C13 36.1503 17.9249 46 24 46Z",
                stroke: color,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M24 46C36.1503 46 46 36.1503 46 24C46 11.8497 36.1503 2 24 2C11.8497 2 2 11.8497 2 24C2 36.1503 11.8497 46 24 46Z",
                stroke: color,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-icons-virtual-412b14e947/1/packages/lib-icons/src/decorative/line/newsletter-line-decorativ.tsx


const NewsletterineDecorative = (param)=>{
    let { size , color ="#0A3A5C"  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        fill: "none",
        height: size,
        viewBox: "0 0 48 48",
        width: size,
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M10 16.2L2 22V46H46V22L38 16.2",
                stroke: color,
                strokeMiterlimit: "10",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M10 26.4V2H38V26.4",
                stroke: color,
                strokeMiterlimit: "10",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M2 22L46 46",
                stroke: color,
                strokeMiterlimit: "10",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M46 22L24 34",
                stroke: color,
                strokeMiterlimit: "10",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M18 12H30",
                stroke: color,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M18 20H30",
                stroke: color,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-icons-virtual-412b14e947/1/packages/lib-icons/src/decorative/line/leaf-bulb-line-decorativ.tsx
/* eslint-disable max-len */ 

const LeafBulbLineDecorative = (param)=>{
    let { size , color ="#0A3A5C"  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        fill: "none",
        height: size,
        viewBox: "0 0 48 48",
        width: size,
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M24 40V9",
                stroke: "black",
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2.5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M18 40H30",
                stroke: "black",
                strokeMiterlimit: "10",
                strokeWidth: "2.5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M33 12H32C27.5817 12 24 15.5817 24 20V22H25C29.4183 22 33 18.4183 33 14V12Z",
                stroke: color,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2.5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M15 21C15 25.4183 18.5817 29 23 29H24V27C24 22.5817 20.4183 19 16 19H15V21Z",
                stroke: color,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2.5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M41 19C41 8.96835 32.311 0.966167 22.0485 2.1089C14.451 2.95488 8.23515 8.97092 7.17293 16.5412C6.00667 24.853 10.8634 32.193 18 34.8899V40C18 43.3137 20.6863 46 24 46H24C27.3137 46 30 43.3137 30 40V34.8899C36.4235 32.4624 41 26.2735 41 19Z",
                stroke: color,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2.5"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-icons-virtual-412b14e947/1/packages/lib-icons/src/decorative/line/document-line-decorativ.tsx


const DocumentLineDecorative = (param)=>{
    let { size , color ="#0A3A5C"  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        fill: "none",
        height: size,
        viewBox: "0 0 48 48",
        width: size,
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M38 8H6V46H38V8Z",
                stroke: color,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M10 2H44V42",
                stroke: color,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M14 18H30",
                stroke: color,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M14 26H30",
                stroke: color,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M14 34H22",
                stroke: color,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-icons-virtual-412b14e947/1/packages/lib-icons/src/decorative/line/send-message-line-decorativ.tsx


const SendMessageineDecorative = (param)=>{
    let { size , color ="#0A3A5C"  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        fill: "none",
        height: size,
        viewBox: "0 0 48 48",
        width: size,
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M45 3L20 28",
                stroke: color,
                strokeMiterlimit: "10",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M45 3L28 45L20 28L3 20L45 3Z",
                stroke: color,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-icons-virtual-412b14e947/1/packages/lib-icons/src/decorative/line/ecology-line-decorative.tsx
/* eslint-disable max-len */ 

const EcologyLineDecorative = (param)=>{
    let { size , color ="#0A3A5C"  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        fill: "none",
        height: size,
        viewBox: "0 0 48 48",
        width: size,
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M11.39 5.97095C12.4571 6.99385 13.2934 8.2328 13.843 9.60495C14.5256 10.0868 15.0686 10.7406 15.417 11.4999C15.6274 12.3212 15.6346 13.1813 15.438 14.0059C15.438 14.0059 16.5 17.1249 16 17.9999C15.5 18.8749 13.375 19.4379 13.375 19.4379C13.0865 19.9302 12.6984 20.3569 12.2355 20.6906C11.7727 21.0243 11.2453 21.2577 10.687 21.3759C10.0255 21.4127 9.40507 21.7088 8.96045 22.2C8.51582 22.6913 8.28283 23.338 8.31202 23.9999C8.31202 25.6879 10 28.4379 10 28.4379C10 28.4379 11.75 29.2939 12 29.9189C12.1883 30.5981 12.3007 31.296 12.335 31.9999C12.335 31.9999 14 34.9379 13.062 36.6249C12.762 37.1629 11.374 37.5629 11.374 37.5629L9.42702 40.4829",
                stroke: color,
                strokeMiterlimit: "10",
                strokeWidth: "2.5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M41.3619 10.4869C39.4737 11.2754 37.5212 11.9001 35.5259 12.3539C35.5259 12.3539 32.8129 15.3739 31.0259 15.1239C29.2389 14.8739 27.4319 12.8739 27.4319 12.8739C27.4319 12.8739 27.5619 9.18795 26.9999 8.99995C26.4379 8.81195 24.9379 9.81195 23.9999 9.06195C23.0619 8.31195 23.5999 6.19995 23.5999 6.19995C23.5999 6.19995 21.5589 5.56395 21.3089 4.87595C21.0589 4.18795 22.0519 2.65695 22.2409 2.06995",
                stroke: color,
                strokeMiterlimit: "10",
                strokeWidth: "2.5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M44 14.8359C42.4657 11.476 40.1101 8.55648 37.1504 6.34654C34.1908 4.13661 30.7224 2.70742 27.065 2.19077C23.4077 1.67412 19.6791 2.08663 16.2231 3.39028C12.7671 4.69392 9.69503 6.84673 7.29006 9.65019C4.88509 12.4536 3.22469 15.8175 2.46195 19.4316C1.69922 23.0456 1.85872 26.7936 2.92573 30.3298C3.99275 33.866 5.93293 37.0766 8.56738 39.6656C11.2018 42.2546 14.4457 44.1386 18 45.144",
                stroke: color,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2.5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M39.321 31.1609C28.934 34.8709 31.9 45.9999 23 45.9999",
                stroke: color,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2.5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M30.257 20.523C29.7288 20.2046 29.167 19.9454 28.582 19.75C27.4869 19.7924 26.4049 20.0032 25.374 20.375C25.374 20.375 22.374 24 22.374 25.375C22.395 25.5701 22.4729 25.7548 22.598 25.906",
                stroke: color,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2.5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M46 19.9729C44.6076 21.8429 42.7975 23.3617 40.7141 24.4082C38.6306 25.4546 36.3315 25.9996 34 25.9999C31.8783 25.9999 29.8434 26.8428 28.3431 28.343C26.8429 29.8433 26 31.8782 26 33.9999C26 36.1216 26.8429 38.1565 28.3431 39.6568C29.8434 41.157 31.8783 41.9999 34 41.9999C37.1826 41.9999 40.2348 40.7356 42.4853 38.4852C44.7357 36.2347 46 33.1825 46 29.9999V19.9729Z",
                stroke: color,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2.5"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-icons-virtual-412b14e947/1/packages/lib-icons/src/decorative/line/clock-2-line-decorative.tsx
/* eslint-disable max-len */ 

const Clock2LineDecorative = (param)=>{
    let { size , color ="#0A3A5C"  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        fill: "none",
        height: size,
        viewBox: "0 0 48 48",
        width: size,
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M24 46C36.1503 46 46 36.1503 46 24C46 11.8497 36.1503 2 24 2C11.8497 2 2 11.8497 2 24C2 36.1503 11.8497 46 24 46Z",
                stroke: color,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M24 10V24H38",
                stroke: color,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-icons-virtual-412b14e947/1/packages/lib-icons/src/decorative/line/lawnmower-line-decorative.tsx
/* eslint-disable max-len */ 

const LawnmowerLineDecorative = (param)=>{
    let { size , color ="#0A3A5C"  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        fill: "none",
        height: size,
        viewBox: "0 0 48 48",
        width: size,
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M16 38H36",
                stroke: color,
                strokeMiterlimit: "10",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M21 18V16L35 17V20",
                stroke: "black",
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M13.41 22.754L10.43 5.49C10.3098 4.79296 9.94708 4.16083 9.40603 3.70523C8.86497 3.24962 8.18033 2.99984 7.473 3H3",
                stroke: color,
                strokeMiterlimit: "10",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M41 33V29.557C41.0001 28.577 40.6404 27.631 39.9891 26.8986C39.3378 26.1662 38.4404 25.6984 37.467 25.584L11.467 22.526C10.906 22.4601 10.3375 22.5137 9.79875 22.6833C9.26 22.8529 8.76329 23.1347 8.3413 23.5101C7.91931 23.8855 7.58161 24.3461 7.35042 24.8614C7.11924 25.3767 6.99981 25.9352 7 26.5V29",
                stroke: color,
                strokeMiterlimit: "10",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M41 43C43.7614 43 46 40.7614 46 38C46 35.2386 43.7614 33 41 33C38.2386 33 36 35.2386 36 38C36 40.7614 38.2386 43 41 43Z",
                stroke: color,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M9 43C12.866 43 16 39.866 16 36C16 32.134 12.866 29 9 29C5.13401 29 2 32.134 2 36C2 39.866 5.13401 43 9 43Z",
                stroke: color,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-icons-virtual-412b14e947/1/packages/lib-icons/src/decorative/line/tree-line-decorative.tsx


const TreeLineDecorative = (param)=>{
    let { size , color ="#0A3A5C"  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        fill: "none",
        height: size,
        viewBox: "0 0 48 48",
        width: size,
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M12 28C12 18.125 24 4 24 4C24 4 36 18.125 36 28C36 34.6274 30.6274 38 24 38C17.3726 38 12 34.6274 12 28Z",
                stroke: color,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2.5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M24 19V46",
                stroke: color,
                strokeMiterlimit: "10",
                strokeWidth: "2.5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M14 46H34",
                stroke: color,
                strokeMiterlimit: "10",
                strokeWidth: "2.5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M24 33L29 28",
                stroke: color,
                strokeMiterlimit: "10",
                strokeWidth: "2.5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M19 23L24 28",
                stroke: color,
                strokeMiterlimit: "10",
                strokeWidth: "2.5"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-icons-virtual-412b14e947/1/packages/lib-icons/src/decorative/line/time-clock-2-line-decorative.tsx
/* eslint-disable max-len */ 

const TimeClock2LineDecorative = (param)=>{
    let { size , color ="#0A3A5C"  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        fill: "none",
        height: size,
        viewBox: "0 0 48 48",
        width: size,
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M24 2V10",
                stroke: color,
                strokeMiterlimit: "10",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M46 24H38",
                stroke: color,
                strokeMiterlimit: "10",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M24 46V38",
                stroke: color,
                strokeMiterlimit: "10",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M2 24H10",
                stroke: color,
                strokeMiterlimit: "10",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M24 46C36.1503 46 46 36.1503 46 24C46 11.8497 36.1503 2 24 2C11.8497 2 2 11.8497 2 24C2 36.1503 11.8497 46 24 46Z",
                stroke: color,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M16 12L24 24H32",
                stroke: color,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-icons-virtual-412b14e947/1/packages/lib-icons/src/decorative/line/plant-ground-line-decorative.tsx
/* eslint-disable max-len */ 

const PlantGroundLineDecorative = (param)=>{
    let { size , color ="#0A3A5C"  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        fill: "none",
        height: size,
        viewBox: "0 0 48 48",
        width: size,
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M36 18H34C28.4771 18 24 22.4771 24 28V32H26C31.5229 32 36 27.5229 36 22V18Z",
                stroke: color,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2.5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M12 8H14C19.5229 8 24 12.4771 24 18V22H22C16.4771 22 12 17.5229 12 12V8Z",
                stroke: color,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2.5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M24 38.2527V2",
                stroke: color,
                strokeMiterlimit: "10",
                strokeWidth: "2.5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M2 46H12C12 43.7908 13.7909 42 16 42C16.9974 42 17.8983 42.3782 18.5989 42.9821C19.791 40.0618 22.6509 38 26 38C30.4183 38 34 41.5817 34 46H46",
                stroke: color,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2.5"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-icons-virtual-412b14e947/1/packages/lib-icons/src/decorative/line/mobile-contact-2-line-decorative.tsx
/* eslint-disable max-len */ 

const MobileContact2LineDecorative = (param)=>{
    let { size , color ="#0A3A5C"  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        fill: "none",
        height: size,
        viewBox: "0 0 48 48",
        width: size,
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M31 31H17C17 27.686 19.686 25 23 25H25C28.314 25 31 27.686 31 31Z",
                stroke: color,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M24 22C26.2091 22 28 20.2091 28 18C28 15.7909 26.2091 14 24 14C21.7909 14 20 15.7909 20 18C20 20.2091 21.7909 22 24 22Z",
                stroke: color,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M34.5 46H13.5C11.5671 46 10 44.209 10 42V6C10 3.791 11.5671 2 13.5 2H34.5C36.4329 2 38 3.791 38 6V42C38 44.209 36.4329 46 34.5 46Z",
                stroke: color,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M10 8H38",
                stroke: color,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M10 37H38",
                stroke: color,
                strokeLinecap: "square",
                strokeMiterlimit: "10",
                strokeWidth: "2"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-icons-virtual-412b14e947/1/packages/lib-icons/src/decorative/line/index.ts


































;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-icons-virtual-412b14e947/1/packages/lib-icons/src/decorative/index.ts







































































;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-icons-virtual-412b14e947/1/packages/lib-icons/src/logo/byko-main-logo.tsx
/* eslint-disable max-len */ 

const BykoMainLogo = (param)=>{
    let { width =141 , textColor ="white" , underLineColor ="#FFD330"  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        fill: "none",
        viewBox: "0 0 141 40",
        width: width,
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M10.71 7.21727H18.4232C20.4886 7.21727 20.9554 7.90575 20.9554 8.85093C20.9554 9.79612 20.4886 10.5546 18.4232 10.5546H10.71V7.21727ZM10.71 16.4241H19.4617C21.4863 16.4241 22.1048 17.3285 22.1048 18.4545C22.1048 19.5806 21.4863 20.4849 19.4617 20.4849H10.71V16.4241ZM0.709656 26.7862H22.8399C30.4248 26.7862 32.9453 23.4547 32.9453 18.3845C32.9453 16.4591 31.86 13.3435 28.5285 12.4742V12.4041C30.4831 11.6398 31.6033 9.64443 31.6033 7.36314C31.6033 3.23231 29.2695 0.916021 23.966 0.916021H0.709656V26.7862ZM43.389 26.7862H53.2085V19.5047L64.8775 0.916021H54.0195L48.2491 10.3037L42.6014 0.916021H31.7084L43.3773 19.5047L43.389 26.7862ZM87.8946 26.7862H100.678L89.5924 10.8288L100.322 0.910181H86.7744L76.2723 10.8288V0.910181H66.4528V26.7803H76.2664V20.2282L80.8348 16.4591L87.8946 26.7862ZM99.441 13.8511C99.441 27.2705 110.923 27.6964 117.12 27.6964C123.316 27.6964 134.792 27.2588 134.792 13.8511C134.792 0.443425 123.31 0 117.12 0C110.929 0 99.441 0.437585 99.441 13.8453V13.8511ZM110.305 13.8453C110.305 8.59422 112.954 6.52881 117.12 6.52881C121.285 6.52881 123.923 8.58838 123.923 13.8453C123.923 19.1021 121.28 21.1676 117.12 21.1676C112.96 21.1676 110.282 19.108 110.282 13.8511",
                fill: textColor !== null && textColor !== void 0 ? textColor : undefined
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M132.779 33.9277C132.935 33.9406 133.09 33.9166 133.234 33.8577C133.234 33.8577 125.346 33.811 125.346 33.8577C125.346 33.9043 129.366 33.9335 129.226 33.9393C130.306 33.9393 131.56 33.9393 132.779 33.9393",
                fill: underLineColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M110.673 32.091C112.061 32.0326 112.907 32.0151 113.386 32.0093L114.261 31.8984H114.01L109.652 31.9684C109.068 31.9684 108.1 32.0326 108.094 32.056C108.088 32.0793 109.844 32.056 110.673 32.0968",
                fill: underLineColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M135.323 34.8506C135.211 34.8402 135.097 34.8402 134.985 34.8506H134.81L132.68 34.8039C132.488 34.8039 133.083 34.3547 133.538 34.3197C133.853 34.3412 134.169 34.3176 134.477 34.2496C134.477 34.2496 133.176 34.1913 133.042 34.1855C132.908 34.1796 133.042 34.2555 132.879 34.2613C132.491 34.2172 132.102 34.1939 131.712 34.1913C131.659 34.1271 133.462 34.1913 133.462 34.1505C132.862 34.1063 132.259 34.1063 131.659 34.1505C130.953 34.1096 131.741 34.0746 130.895 34.0279C130.311 34.0279 129.489 34.0746 128.794 34.0279C128.794 34.0279 126.134 34.0629 124.594 33.9696H124.844C124.967 33.9346 123.462 33.9404 122.575 33.9054C122.575 33.9054 133.83 33.6895 133.83 33.6662C133.83 33.6428 132.272 33.6662 129.6 33.602C129.53 33.5612 130.551 33.602 130.352 33.5028C129.133 33.5028 127.873 33.5028 126.799 33.5028C126.939 33.5028 126.922 33.5028 126.927 33.462H122.295C124.769 33.3686 127.785 33.4095 130.807 33.462C131.087 33.5028 131.443 33.4095 131.227 33.3803C124.967 33.2461 112.359 33.3803 112.388 33.2636C112.417 33.1469 114.471 33.2228 115.515 33.2053C120.469 33.1353 126.256 33.2578 131.577 33.2811C131.735 33.2111 131.758 33.1411 131.577 33.0594C125.801 32.896 120.019 32.9485 114.249 32.8377H114.109C111.635 32.9544 107.627 32.8377 104.535 32.9544C102.201 33.0419 99.5519 33.0652 97.0664 33.1119L100.526 32.966C102.994 32.8902 105.462 32.966 107.627 32.8377C108.245 32.7968 109.482 32.8377 110.404 32.8377L111.653 32.791L110.287 32.7502C109.978 32.7152 118.123 32.686 117.82 32.5868L106.396 32.5576C105.474 32.476 107.207 32.2076 107.831 32.1901C107.878 32.1901 108 32.1901 107.989 32.1901C107.977 32.1901 107.405 32.1901 106.921 32.1609L109.71 32.1084H109.803C108.239 32.1084 105.048 32.0559 105.089 32.0325C105.13 32.0092 110.509 31.9508 113.14 31.9158C111.349 31.9158 109.301 31.875 107.528 31.875C100.38 31.9275 93.8691 31.9975 87.2353 32.0967C86.436 32.1492 85.6249 32.1842 84.8198 32.1959C83.5654 32.1959 82.1243 32.2484 80.7765 32.2601C82.9352 32.2017 85.3741 32.0442 87.5037 32.0092C87.6774 32.0059 87.8491 31.9723 88.0113 31.91C88.0113 31.91 81.1207 32.05 77.9934 32.1784C77.375 32.1784 76.4473 32.2776 75.8288 32.2776C73.0691 32.2776 70.3327 32.4118 71.1612 32.4001C70.1694 32.4526 68.3432 32.4584 66.5987 32.5401C66.3186 32.5401 66.9137 32.6627 66.9137 32.6627C67.9931 32.931 64.4807 32.8435 60.029 32.9427C56.2891 33.0127 52.1758 33.0769 50.0345 33.2869C49.6609 33.3331 49.2849 33.3564 48.9084 33.357C51.6906 32.9505 54.4939 32.7051 57.3043 32.6218C59.0897 32.6218 62.6779 32.6918 62.6837 32.5576C62.6837 32.0384 54.4337 32.6568 51.9599 32.7268C47.0239 32.8727 42.333 33.3103 37.7179 33.5845C35.8333 33.7012 33.943 33.7595 32.0584 33.8296L32.5193 33.7654C30.1855 33.8587 27.9217 33.9521 25.5179 34.1154L24.8703 34.1563C19.946 34.4888 15.7276 34.7747 10.7216 35.1598C9.4964 35.259 8.27116 35.3874 7.04592 35.4924C6.1299 35.6032 7.68187 35.5507 6.15906 35.7141C6.15906 35.7141 5.57563 35.8308 8.91297 35.5274C9.09383 35.5274 9.03548 35.6149 8.68541 35.6266C6.87672 35.7374 4.72964 35.8775 2.79842 36.1225C2.79842 36.1225 1.19973 36.1634 1.01303 36.1575C0.826327 36.1517 0.756347 36.1984 0.756347 36.1984C0.756347 36.1984 0.645466 36.3034 0.511272 36.4551L0.412096 36.5718C0.228813 36.7812 0.0934216 37.0281 0.0153543 37.2952C-0.0051181 37.4012 -0.0051181 37.5102 0.0153543 37.6161C0.0249091 37.6556 0.0365938 37.6946 0.0503599 37.7328C0.202057 38.0887 0.715497 38.3571 1.98742 38.363H2.6292C2.8159 38.363 3.1718 38.328 3.09595 38.363C2.92822 38.3825 2.76238 38.4157 2.60003 38.4621C2.82302 38.4866 3.04803 38.4866 3.27101 38.4621C3.71444 38.398 4.37372 38.2346 4.92799 38.2054C5.78566 38.1354 4.99218 38.2871 5.99572 38.2054C11.2934 37.7912 16.4628 37.5345 21.8539 37.2544C21.9822 37.2544 21.8539 37.2544 21.6789 37.2952L23.4642 37.1902L103.572 36.14C107.656 36.2042 111.682 36.2742 112.907 36.3267C113.887 36.3851 111.927 36.4668 111.915 36.4784C113.117 36.4784 113.555 36.4784 114.576 36.4784C114.85 36.4784 115.853 36.5951 115.807 36.4784C115.445 36.4506 115.086 36.392 114.733 36.3034L116.04 36.3326C116.697 36.3749 117.356 36.3749 118.012 36.3326C120.189 36.2217 122.54 36.4376 124.722 36.4901C124.064 36.5681 123.401 36.6051 122.738 36.6009C122.446 36.741 128.952 36.6009 130.364 36.5426C130.621 36.5426 131.793 36.07 131.974 36.0583L132.937 35.7841C133.328 35.7841 133.66 35.7841 134.174 35.7841C135.452 35.8775 135.101 35.434 136 35.1248C135.784 35.0731 135.563 35.0476 135.341 35.049L135.323 34.8506ZM97.6498 32.2484C99.7444 32.0675 104.651 32.12 104.704 32.1667C104.756 32.2134 99.1202 32.2834 96.1737 32.3359L97.6498 32.2484ZM92.1538 32.9077C88.1396 32.9777 83.8163 32.9836 79.8021 33.1528C79.1895 33.1528 78.2618 33.1528 77.6434 33.1528C79.7729 33.0652 81.6925 32.9544 83.8163 32.9019C84.038 32.9019 84.5747 32.9019 84.7439 32.9019C85.157 32.9051 85.5699 32.8856 85.9808 32.8435H85.2107C85.2107 32.8435 88.233 32.7677 90.6484 32.756C90.8118 32.756 90.7768 32.756 90.8585 32.8027C93.5307 32.8027 97.7024 32.6568 97.8599 32.6627L98.2041 32.616C99.1143 32.6451 100.001 32.7793 101.081 32.8027H101.39V32.6743C98.6126 32.8202 95.2169 32.6743 92.1304 32.7268L92.1538 32.9077ZM107.014 33.2286C106.641 33.2286 99.867 33.1061 96.4421 33.1644H96.3604H94.5459C94.7684 33.1639 94.9906 33.1483 95.211 33.1177H95.5728C99.6102 33.1177 103.84 33.1177 107.825 33.1761C107.566 33.2519 107.295 33.2796 107.026 33.2578L107.014 33.2286ZM122.126 33.9229C121.916 33.9229 121.134 33.9229 120.959 33.9229L122.411 33.8879C122.563 33.8879 122.581 33.9404 122.143 33.9346L122.126 33.9229ZM135.312 35.0081C135.084 34.953 134.851 34.9198 134.617 34.9089H135.201C135.545 34.9089 135.644 34.9906 135.317 35.014",
                fill: underLineColor
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-icons-virtual-412b14e947/1/packages/lib-icons/src/logo/index.ts


;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-icons-virtual-412b14e947/1/packages/lib-icons/src/index.ts





/***/ }),

/***/ 94845:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ZZ": function() { return /* reexport */ AppidIllustration; },
  "LQ": function() { return /* reexport */ Error400; },
  "Vm": function() { return /* reexport */ Error500; },
  "fX": function() { return /* reexport */ IcelandBykoLocationIllustration; },
  "Y8": function() { return /* reexport */ PipulagnirIllustration; },
  "NQ": function() { return /* reexport */ StafraentIllustration; },
  "rr": function() { return /* reexport */ StarfsmennIllustration; }
});

// UNUSED EXPORTS: AfreidslaIllustration, BaturIllustration, ByggingakraniIllustration, DreymaIllustration, FjolskyldaIllustration, HeimsendingIllustration, KaupaIllustration, RadgjofIllustration, SkipuleggjaIllustration

// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(61261);
// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(91987);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-illustrations-virtual-f4c8d3dc38/1/packages/lib-illustrations/src/afgreidsla.tsx
/* eslint-disable max-len */ 

const AfreidslaIllustration = (param)=>{
    let { size =200  } = param;
    return /*#__PURE__*/ _jsxs("svg", {
        fill: "none",
        height: size,
        viewBox: "0 0 662 611",
        width: size,
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M269.98 184.47C291.98 191.47 261.26 261.47 227.13 266.47C236.48 219.36 245.2 176.59 269.98 184.47Z",
                fill: "#D9EEE8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M195.03 161.88C178.67 167.08 201.52 219.1 226.88 222.79C219.93 187.8 213.45 156.02 195.03 161.88Z",
                fill: "#D9EEE8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M253.69 141.14C267.34 145.48 248.29 188.88 227.13 191.95C232.92 162.8 238.3 136.28 253.69 141.14Z",
                fill: "#D9EEE8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M228.3 143.36H225.96V329.41H228.3V143.36Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M80.3001 434.01C85.0608 434.01 88.9201 430.151 88.9201 425.39C88.9201 420.629 85.0608 416.77 80.3001 416.77C75.5394 416.77 71.6801 420.629 71.6801 425.39C71.6801 430.151 75.5394 434.01 80.3001 434.01Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M261.37 434.01C266.131 434.01 269.99 430.151 269.99 425.39C269.99 420.629 266.131 416.77 261.37 416.77C256.609 416.77 252.75 420.629 252.75 425.39C252.75 430.151 256.609 434.01 261.37 434.01Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M194.34 258.57H157.92V345.38H194.34V258.57Z",
                fill: "#0067A5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M191.392 201.503L176.618 192.973L93.6627 336.656L108.437 345.186L191.392 201.503Z",
                fill: "#408DBC"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M267.24 380.6H65.0601V416.27H267.24V380.6Z",
                fill: "#0067A5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M252.75 345.06H88.92V380.73H252.75V345.06Z",
                fill: "#FF7D20"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M227.13 345.06C232.989 345.06 238.607 342.733 242.75 338.59C246.893 334.447 249.22 328.829 249.22 322.97H205.04C205.04 328.829 207.367 334.447 211.51 338.59C215.653 342.733 221.271 345.06 227.13 345.06Z",
                fill: "#428FBD"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M455.51 240.34H402.51V265.92H455.51V240.34Z",
                fill: "#0067A5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M504.3 231.51L487.05 224.67C479.12 219.74 455.12 204.5 449.9 197.54C449.822 195.533 449.245 193.577 448.22 191.85C447.195 190.123 445.755 188.679 444.03 187.65C443.861 187.553 443.667 187.508 443.472 187.519C443.277 187.531 443.09 187.6 442.933 187.717C442.777 187.834 442.659 187.994 442.592 188.178C442.526 188.361 442.515 188.56 442.56 188.75C443.095 190.58 443.324 192.485 443.24 194.39V194.85C438.66 192.85 432.7 189.85 428.47 186.29C428.266 186.112 428.017 185.995 427.75 185.952C427.483 185.908 427.209 185.94 426.959 186.044C426.71 186.148 426.494 186.32 426.337 186.54C426.18 186.76 426.087 187.02 426.07 187.29C425.26 197.1 436.82 205.01 446.24 207.63C464.24 254.53 505.56 264.07 505.56 264.07L504.3 231.51Z",
                fill: "#0067A5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M532.53 153.38C523.78 151.29 511.81 157.56 509.91 158.89C508.01 160.22 509.91 162.89 512.57 163.26C509.14 166.26 508.18 170.49 509.14 172.77C510.1 175.05 514.66 175.05 517.32 173.91C517.32 173.91 518.65 181.13 515.61 185.13C512.57 189.13 501.73 191.02 501.73 191.02C501.73 191.02 506.11 199.38 519.79 199.38C533.47 199.38 536.52 190.64 536.52 190.64L526.78 174.14L532.53 153.38Z",
                fill: "#EE9697"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M555.72 207.94C555.72 207.94 563.3 192.14 567.13 183.22C570.96 174.3 564.85 167.45 553.06 169.92C541.27 172.39 538.61 160.41 536.52 156.61C534.43 152.81 529.52 150.33 522.45 153.76V162.69C522.45 162.69 531.77 164.4 523.21 171.25C523.21 171.25 521.02 191.41 535.14 193.02C549.26 194.63 555.53 203.76 555.72 207.94Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M564.66 268.14C565.47 250.82 565.25 189.64 535.14 193.05C535.14 193.05 515.99 205.69 501.73 191.05C501.73 191.05 481.2 191.43 483.67 234.39C483.67 234.39 481.39 247.7 470.56 242.95C470.56 242.95 493.94 260.25 509.15 263.1C524.36 265.95 542.22 276.21 555.53 271.1L555.73 271.03C560.78 269.2 564.4 273.46 564.66 268.14Z",
                fill: "#0067A5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M501.73 231.74C501.73 231.74 490.14 267.44 501.73 310.21H551.54C551.54 310.21 535 271.43 532.72 249.76C530.44 228.09 501.73 231.74 501.73 231.74Z",
                fill: "#0067A5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M546.17 257.82C554.85 256.82 558.78 246.09 552.37 240.16C548.09 236.16 540.8 234.96 534.37 234.16C517.23 232.16 486.6 243.33 486.6 243.33C482.184 239.887 477.348 237.017 472.21 234.79C466.67 233.09 475.76 243.34 475.76 243.34C471.488 244.309 467.015 243.849 463.03 242.03C462.797 241.933 462.542 241.902 462.292 241.941C462.043 241.98 461.809 242.087 461.616 242.251C461.424 242.414 461.28 242.628 461.202 242.867C461.123 243.107 461.112 243.364 461.17 243.61C462.52 249.87 470.54 254.81 486.17 251.78C508.58 255.5 530.09 259.68 546.17 257.82Z",
                fill: "#EE9697"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M470.56 407.46C526.87 398.55 540.4 376.82 556.38 337.8C564.44 318.11 577.75 303.58 588.96 294.02V270.54H364.18V433.95H406.91C419.77 422.67 439.52 412.37 470.56 407.46Z",
                fill: "#66A4C9"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M588.96 294.02V270.54H364.18V301.85H580.55C583.41 298.95 586.3 296.34 588.96 294.02Z",
                fill: "#408DBC"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M366.74 288.9H364.4V434.05H366.74V288.9Z",
                fill: "#408DBC"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M377.35 288.9H375.01V434.05H377.35V288.9Z",
                fill: "#408DBC"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M387.95 288.9H385.61V434.05H387.95V288.9Z",
                fill: "#408DBC"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M398.56 288.9H396.22V434.05H398.56V288.9Z",
                fill: "#408DBC"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M596.38 265.79H360.01V275.29H596.38V265.79Z",
                fill: "#8CBBD7"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M428.08 202.93H362.42V254.85H428.08V202.93Z",
                fill: "#8FBCD8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M402.51 245.3H387.62V265.79H402.51V245.3Z",
                fill: "#8FBCD8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M448.2 233.77H435.06V246.91H448.2V233.77Z",
                fill: "#8FBCD8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M448.19 248.08H433.88V233.77H436.22V245.74H448.19V248.08Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M428.08 253.68H362.42V256.02H428.08V253.68Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M435.48 258.81C436.485 258.81 437.3 257.995 437.3 256.99C437.3 255.985 436.485 255.17 435.48 255.17C434.475 255.17 433.66 255.985 433.66 256.99C433.66 257.995 434.475 258.81 435.48 258.81Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M441.62 258.81C442.625 258.81 443.44 257.995 443.44 256.99C443.44 255.985 442.625 255.17 441.62 255.17C440.615 255.17 439.8 255.985 439.8 256.99C439.8 257.995 440.615 258.81 441.62 258.81Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M447.77 258.81C448.775 258.81 449.59 257.995 449.59 256.99C449.59 255.985 448.775 255.17 447.77 255.17C446.765 255.17 445.95 255.985 445.95 256.99C445.95 257.995 446.765 258.81 447.77 258.81Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M517.99 161.7C518.553 161.7 519.01 161.243 519.01 160.68C519.01 160.117 518.553 159.66 517.99 159.66C517.427 159.66 516.97 160.117 516.97 160.68C516.97 161.243 517.427 161.7 517.99 161.7Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M329.37 164.64C329.37 164.64 314.66 165.3 314.66 179.35V193.14H329.37V164.64Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M329.37 164.64C329.37 164.64 341.67 164.42 344.52 166.64C347.37 168.86 343.42 172.5 343.42 172.5C343.42 172.5 351.55 181.21 339.91 184.79V202.41C339.91 202.41 333.14 204.41 325.66 198.26V183.66H323.37C322.9 183.66 322.434 183.567 322 183.388C321.566 183.208 321.171 182.944 320.839 182.611C320.506 182.279 320.242 181.884 320.063 181.45C319.883 181.016 319.79 180.55 319.79 180.08C319.79 179.13 320.167 178.218 320.838 177.545C321.509 176.872 322.42 176.493 323.37 176.49H325.66L329.37 164.64Z",
                fill: "#EE9697"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M305.77 264.81C305.77 264.81 277.38 204.49 325.66 198.23H350.56V280.68H314L314.33 264.81H305.77Z",
                fill: "#008B66"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M312.58 217.99C314.458 217.99 315.98 216.468 315.98 214.59C315.98 212.712 314.458 211.19 312.58 211.19C310.702 211.19 309.18 212.712 309.18 214.59C309.18 216.468 310.702 217.99 312.58 217.99Z",
                fill: "#40A88D"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M326.58 229.25C329.468 229.25 331.81 226.908 331.81 224.02C331.81 221.132 329.468 218.79 326.58 218.79C323.692 218.79 321.35 221.132 321.35 224.02C321.35 226.908 323.692 229.25 326.58 229.25Z",
                fill: "#40A88D"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M341.64 255.54C344.528 255.54 346.87 253.198 346.87 250.31C346.87 247.422 344.528 245.08 341.64 245.08C338.752 245.08 336.41 247.422 336.41 250.31C336.41 253.198 338.752 255.54 341.64 255.54Z",
                fill: "#40A88D"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M309.17 253.71C311.048 253.71 312.57 252.188 312.57 250.31C312.57 248.432 311.048 246.91 309.17 246.91C307.292 246.91 305.77 248.432 305.77 250.31C305.77 252.188 307.292 253.71 309.17 253.71Z",
                fill: "#40A88D"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M304.17 225.72C305.109 225.72 305.87 224.959 305.87 224.02C305.87 223.081 305.109 222.32 304.17 222.32C303.231 222.32 302.47 223.081 302.47 224.02C302.47 224.959 303.231 225.72 304.17 225.72Z",
                fill: "#40A88D"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M334.33 213.88C336.014 213.88 337.38 212.515 337.38 210.83C337.38 209.146 336.014 207.78 334.33 207.78C332.646 207.78 331.28 209.146 331.28 210.83C331.28 212.515 332.646 213.88 334.33 213.88Z",
                fill: "#40A88D"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M325.41 206.09C326.349 206.09 327.11 205.329 327.11 204.39C327.11 203.451 326.349 202.69 325.41 202.69C324.471 202.69 323.71 203.451 323.71 204.39C323.71 205.329 324.471 206.09 325.41 206.09Z",
                fill: "#40A88D"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M312.58 238.08C313.519 238.08 314.28 237.319 314.28 236.38C314.28 235.441 313.519 234.68 312.58 234.68C311.641 234.68 310.88 235.441 310.88 236.38C310.88 237.319 311.641 238.08 312.58 238.08Z",
                fill: "#40A88D"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M341.29 269.81C342.229 269.81 342.99 269.049 342.99 268.11C342.99 267.171 342.229 266.41 341.29 266.41C340.351 266.41 339.59 267.171 339.59 268.11C339.59 269.049 340.351 269.81 341.29 269.81Z",
                fill: "#40A88D"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M342.99 206.09C343.929 206.09 344.69 205.329 344.69 204.39C344.69 203.451 343.929 202.69 342.99 202.69C342.051 202.69 341.29 203.451 341.29 204.39C341.29 205.329 342.051 206.09 342.99 206.09Z",
                fill: "#40A88D"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M329.37 275.01C330.309 275.01 331.07 274.249 331.07 273.31C331.07 272.371 330.309 271.61 329.37 271.61C328.431 271.61 327.67 272.371 327.67 273.31C327.67 274.249 328.431 275.01 329.37 275.01Z",
                fill: "#40A88D"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M324.86 244.47C326.622 244.47 328.05 243.042 328.05 241.28C328.05 239.518 326.622 238.09 324.86 238.09C323.098 238.09 321.67 239.518 321.67 241.28C321.67 243.042 323.098 244.47 324.86 244.47Z",
                fill: "#40A88D"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M342.99 228.17C344.752 228.17 346.18 226.742 346.18 224.98C346.18 223.218 344.752 221.79 342.99 221.79C341.228 221.79 339.8 223.218 339.8 224.98C339.8 226.742 341.228 228.17 342.99 228.17Z",
                fill: "#40A88D"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M350.56 280.68H314V435.09H350.56V280.68Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M335.08 156.07C335.08 156.07 337.31 171 325.66 176.49C319.05 172.47 316.86 160.25 335.08 156.07Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M336.38 171.17C337.004 171.17 337.51 170.664 337.51 170.04C337.51 169.416 337.004 168.91 336.38 168.91C335.756 168.91 335.25 169.416 335.25 170.04C335.25 170.664 335.756 171.17 336.38 171.17Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M309.17 259.48C309.17 259.48 311.59 278.15 328.71 288.03C334.42 291.32 331.35 300.1 328.71 302.96C328.49 307.35 337.5 309.32 340.13 307.57C343.42 298.57 342.13 284.62 328.27 264.81C325.983 262.115 322.941 260.167 319.537 259.217C316.133 258.267 312.522 258.359 309.17 259.48Z",
                fill: "#EE9697"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M330.25 256.61H305.77V264.81H330.25V256.61Z",
                fill: "#008B66"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M329.01 221.72H326.67V264.81H329.01V221.72Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M282.9 416.27H280.56V297.02H300.83V299.36H282.9V416.27Z",
                fill: "#82B5D3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M307.95 293.99H291.61V301.97H307.95V293.99Z",
                fill: "#82B5D3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M416.15 465.14L414.08 464.06C414.28 463.67 419.08 454.64 431.66 445.06C443.19 436.29 463.71 425.47 495.96 423.71C527.42 421.99 545.14 406.3 554.46 393.43C560.552 385.066 564.932 375.581 567.35 365.52L569.65 365.96C567.216 376.343 562.713 386.128 556.41 394.73C546.79 408.03 528.51 424.27 496.09 426.04C464.51 427.77 444.45 438.3 433.19 446.83C421 456.14 416.2 465.04 416.15 465.14Z",
                fill: "#66A4C9"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M386.78 433.92H36.9V436.26H386.78V433.92Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M282.82 405.29H56.8V416.77H282.82V405.29Z",
                fill: "#82B5D3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M117.48 380.73H115.14V408.34H117.48V380.73Z",
                fill: "#82B5D3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M217.16 380.73H214.82V408.34H217.16V380.73Z",
                fill: "#82B5D3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M88.92 357.23H136.83C138.342 357.23 139.792 357.831 140.861 358.899C141.93 359.968 142.53 361.418 142.53 362.93V364.86C142.53 366.372 141.93 367.822 140.861 368.891C139.792 369.959 138.342 370.56 136.83 370.56H88.92V357.23Z",
                fill: "#FFCAA3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M154.34 370.41C157.98 370.41 160.93 367.46 160.93 363.82C160.93 360.18 157.98 357.23 154.34 357.23C150.7 357.23 147.75 360.18 147.75 363.82C147.75 367.46 150.7 370.41 154.34 370.41Z",
                fill: "#FFCAA3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M267.24 379.43H65.0601V381.77H267.24V379.43Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M108.87 346.78L93.0801 337.66L94.2501 335.64L108.01 343.58L190.38 200.92L192.41 202.08L108.87 346.78Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M338.97 425.39C338.97 425.39 361.58 428.91 363.97 435.09H334.97L338.97 425.39Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M527.45 218.79H525.11V233.77H527.45V218.79Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M554.41 247.26C547.86 226.48 504.22 239.08 503.78 239.21L503.12 236.96C510.861 234.825 518.804 233.507 526.82 233.03C543.3 232.28 553.61 236.95 556.65 246.56L554.41 247.26Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M482.38 231.61C481.96 225.148 482.343 218.658 483.52 212.29C486.09 199.06 492.33 191.29 501.52 189.86L501.88 192.18C481.93 195.3 484.65 231.05 484.68 231.41L482.38 231.61Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M504.62 398.65V288.9H502.3V399.56C503.07 399.26 503.85 398.96 504.62 398.65Z",
                fill: "#408DBC"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M494.01 402.32V288.9H491.67V402.99L494.01 402.32Z",
                fill: "#408DBC"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M483.4 405.04V288.9H481.07V405.55L483.4 405.04Z",
                fill: "#408DBC"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M470.56 407.46L472.8 407.09V288.9H470.46V407.48L470.56 407.46Z",
                fill: "#408DBC"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M462.19 408.98V288.9H459.85V409.46L462.19 408.98Z",
                fill: "#408DBC"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M451.59 411.47V288.9H449.3V412.14C450.02 411.9 450.79 411.68 451.59 411.47Z",
                fill: "#408DBC"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M440.98 414.75V288.9H438.64V415.58C439.4 415.3 440.2 415.03 440.98 414.75Z",
                fill: "#408DBC"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M430.38 419.02V288.9H428.04V420.14C428.8 419.74 429.59 419.38 430.38 419.02Z",
                fill: "#408DBC"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M419.77 424.6V288.9H417.43V426.06C418.19 425.57 418.97 425.08 419.77 424.6Z",
                fill: "#408DBC"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M409.16 432.04V288.9H406.83V434.02C407.58 433.35 408.36 432.69 409.16 432.04Z",
                fill: "#408DBC"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-illustrations-virtual-f4c8d3dc38/1/packages/lib-illustrations/src/appid.tsx
/* eslint-disable max-len */ 

const AppidIllustration = (param)=>{
    let { size =200  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        fill: "none",
        height: size,
        viewBox: "0 0 662 611",
        width: size,
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M126.69 510.42C149.64 492.87 136.16 403.96 86.57 386.11C63.23 417.42 78.79 503.66 126.69 510.42Z",
                fill: "#008B66"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M92.846 397.917L90.7085 398.615L126.91 509.556L129.048 508.858L92.846 397.917Z",
                fill: "#87C9B7"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M121.59 511.58C107.74 511.58 96.0201 507.23 86.7001 498.58C65.4201 478.89 64.1601 444.13 64.1201 442.66V441.41L65.3701 441.5C65.8801 441.5 78.1201 442.5 91.8001 451.5C104.4 459.77 120.56 476.65 126 510.15L126.2 511.39L124.94 511.45C123.79 511.56 122.68 511.58 121.59 511.58ZM66.4301 443.93C66.8401 450.54 69.6501 479.77 88.2301 496.93C97.5401 505.54 109.42 509.7 123.53 509.27C120.43 491.4 112.19 467.67 90.6301 453.47C83.3288 448.615 75.0806 445.363 66.4301 443.93Z",
                fill: "#87C9B7"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M419.71 249.21C409.71 246.82 396.09 253.97 393.92 255.49C391.75 257.01 393.92 260.04 396.92 260.49C393.01 263.96 391.92 268.73 393.01 271.33C394.1 273.93 399.31 273.93 402.34 272.63C402.34 272.63 403.86 280.87 400.39 285.42C396.92 289.97 384.57 292.13 384.57 292.13C384.57 292.13 389.57 301.67 405.16 301.67C420.75 301.67 424.23 291.67 424.23 291.67L409.49 272.6L419.71 249.21Z",
                fill: "#A37160"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M456.56 371.87C456.56 371.87 454.95 390.68 441.43 397.63C434.98 386.97 436.61 383.63 436.61 383.63C441.201 379.622 444.474 374.321 446 368.42C447.28 363.57 456.56 371.87 456.56 371.87Z",
                fill: "#A37160"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M462.05 498.68L433.1 509.68L434.77 513.68C436.16 517.04 434.77 522.33 432.2 524.78L431.79 525.17C429.977 526.862 427.776 528.081 425.38 528.72C417.81 530.83 417.75 535.34 417.75 535.34H435.23L470.36 510.23L462.05 498.68Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M309.21 535.42C309.21 535.42 315.75 528.59 328.39 524.86C341.03 521.13 366.39 521.13 366.39 521.13V535.42H309.21Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M393.96 190.74C422.198 190.74 445.09 167.848 445.09 139.61C445.09 111.372 422.198 88.48 393.96 88.48C365.722 88.48 342.83 111.372 342.83 139.61C342.83 167.848 365.722 190.74 393.96 190.74Z",
                fill: "#408DBC"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M187 279.1C182.101 278.375 177.322 276.996 172.79 275C179.24 271 182.91 266.09 181.2 257.39C178.52 243.74 197.91 254.39 197.91 254.39C197.91 254.39 195.42 270.13 207.91 276.8L208.27 276.99C201.503 279.61 194.15 280.339 187 279.1Z",
                fill: "#FDC498"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M202.71 253.06C202.71 253.06 202.18 267.67 190.05 267.43C176.77 267.18 176.68 252.84 176.68 252.84L202.71 253.06Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M201.92 243.63C201.92 243.63 208.01 242.63 208.21 246.97C208.33 249.64 204.46 251.25 202.16 250.51C199.86 249.77 201.92 243.63 201.92 243.63Z",
                fill: "#FDC498"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M176.9 243.12C176.9 243.12 172.19 241.4 171.38 245C170.79 247.6 174.17 250 176.57 249.71C178.97 249.42 176.9 243.12 176.9 243.12Z",
                fill: "#FDC498"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M204.64 238.26C204.64 238.26 206.51 262.61 191.02 263.6C175.53 264.59 174.48 244.19 174.61 238.73L204.64 238.26Z",
                fill: "#FDC498"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M183.91 246.43C184.335 246.43 184.68 246.085 184.68 245.66C184.68 245.235 184.335 244.89 183.91 244.89C183.485 244.89 183.14 245.235 183.14 245.66C183.14 246.085 183.485 246.43 183.91 246.43Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M194.91 246.99C195.335 246.99 195.68 246.645 195.68 246.22C195.68 245.795 195.335 245.45 194.91 245.45C194.485 245.45 194.14 245.795 194.14 246.22C194.14 246.645 194.485 246.99 194.91 246.99Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M190 244.42C188.15 244.14 188.31 246.85 187.46 248.52C186.61 250.19 185.31 249.95 184.77 250.98C184.23 252.01 185.53 252.98 186.35 253.11C187.17 253.24 187.9 254.77 190.08 253.62C192.08 252.56 193.08 253.01 193.3 251.79C193.69 249.73 191.3 250.21 191.17 247.89C191 246.17 191.14 244.61 190 244.42Z",
                fill: "#FFEEE0"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M190 223.35C185.84 223.353 181.85 225.007 178.908 227.949C175.967 230.89 174.313 234.88 174.31 239.04H205.69C205.69 234.879 204.037 230.888 201.095 227.946C198.152 225.003 194.161 223.35 190 223.35Z",
                fill: "#FFD400"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M207.13 238.54H173.08V241.35H207.13V238.54Z",
                fill: "#FFE770"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M173.08 241.34C173.08 241.34 178.17 243.53 190.08 243.53C201.99 243.53 207.17 241.34 207.17 241.34H173.08Z",
                fill: "#FF7D20"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M194.14 221.16H186.02V231.86H194.14V221.16Z",
                fill: "#FFD400"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M182 224.72L186 231.02V223.02L182 224.72Z",
                fill: "#FF7D20"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M198.15 224.72L194.15 231.02V223.02L198.15 224.72Z",
                fill: "#FF7D20"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M149.55 311.42C149.55 311.42 152.01 278.49 172.75 275.02C193.49 271.55 208.21 277.02 208.21 277.02C208.21 277.02 226 283.61 226.81 311.42H149.55Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M174.8 273.84H168.07V354.95H174.8V273.84Z",
                fill: "#FFD400"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M211.66 273.84H204.93V354.95H211.66V273.84Z",
                fill: "#FFD400"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M207.13 286.34H171.31V354.52H207.13V286.34Z",
                fill: "#FFD400"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M190 260.52C189.258 260.525 188.518 260.431 187.8 260.24L188.41 258.07C188.59 258.12 192.83 259.23 195.18 255.51L197.09 256.71C196.338 257.904 195.29 258.882 194.047 259.55C192.805 260.218 191.41 260.552 190 260.52Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M197.42 390.9V493.24H226.81C226.81 442.15 231.81 368.55 221.71 354.52C221.71 354.52 183.1 353.95 168.07 354.95C168.07 354.95 139.95 444.87 163.87 493.24H184.87C170.09 448.24 197.42 390.9 197.42 390.9Z",
                fill: "#FFD400"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M347.3 155.57H228.76C219.36 155.57 211.74 163.19 211.74 172.59V411.54C211.74 420.94 219.36 428.56 228.76 428.56H347.3C356.7 428.56 364.32 420.94 364.32 411.54V172.59C364.32 163.19 356.7 155.57 347.3 155.57Z",
                fill: "#82B5D3"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M338.48 164.48H237.58C228.815 164.48 221.71 171.585 221.71 180.35V403.15C221.71 411.915 228.815 419.02 237.58 419.02H338.48C347.245 419.02 354.35 411.915 354.35 403.15V180.35C354.35 171.585 347.245 164.48 338.48 164.48Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M233.71 164.48H342.35C345.533 164.48 348.585 165.744 350.835 167.995C353.086 170.245 354.35 173.297 354.35 176.48V207.48H221.71V176.48C221.71 173.297 222.974 170.245 225.225 167.995C227.475 165.744 230.528 164.48 233.71 164.48Z",
                fill: "#408DBC"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M249 161.92H327.4V164.76C327.4 167.314 326.385 169.764 324.579 171.57C322.773 173.376 320.324 174.39 317.77 174.39H258.63C256.076 174.39 253.627 173.376 251.821 171.57C250.015 169.764 249 167.314 249 164.76V161.92Z",
                fill: "#82B5D3"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M316.65 163.74H275.8V165.99H316.65V163.74Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M262.88 169.78C261.925 169.78 260.991 169.497 260.197 168.966C259.402 168.435 258.783 167.681 258.418 166.798C258.052 165.916 257.956 164.945 258.143 164.008C258.329 163.071 258.789 162.21 259.465 161.535C260.14 160.859 261.001 160.399 261.938 160.213C262.875 160.027 263.846 160.122 264.728 160.488C265.611 160.853 266.365 161.472 266.896 162.267C267.427 163.061 267.71 163.995 267.71 164.95C267.71 166.231 267.201 167.46 266.295 168.365C265.39 169.271 264.161 169.78 262.88 169.78ZM262.88 162.37C262.367 162.368 261.865 162.519 261.437 162.802C261.01 163.086 260.676 163.491 260.479 163.964C260.282 164.438 260.23 164.96 260.329 165.463C260.429 165.966 260.676 166.429 261.039 166.792C261.401 167.154 261.864 167.401 262.367 167.501C262.871 167.6 263.392 167.548 263.866 167.351C264.339 167.154 264.744 166.82 265.028 166.393C265.312 165.965 265.462 165.463 265.46 164.95C265.444 164.275 265.166 163.633 264.684 163.161C264.202 162.688 263.555 162.423 262.88 162.42V162.37Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M341.77 181.96H322.61V184.21H341.77V181.96Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M341.77 188.82H322.61V191.07H341.77V188.82Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M341.77 195.67H322.61V197.92H341.77V195.67Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M365.44 328.13H363.19V172.59C363.185 168.377 361.509 164.339 358.53 161.36C355.551 158.381 351.513 156.705 347.3 156.7H300.69V154.42H347.3C352.11 154.425 356.72 156.338 360.121 159.739C363.522 163.14 365.435 167.751 365.44 172.56V328.13Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M212.86 302.35H210.61V374.79H212.86V302.35Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M236.48 184.42H239.84C240.74 184.42 240.94 184.72 240.94 185.13C240.94 185.54 240.74 185.87 239.84 185.87H236.48V184.42ZM236.48 188.42H240.28C241.16 188.42 241.43 188.81 241.43 189.3C241.43 189.79 241.16 190.18 240.28 190.18H236.48V188.42ZM232.14 192.92H241.76C245.05 192.92 246.15 191.47 246.15 189.27C246.158 188.69 245.975 188.123 245.627 187.659C245.28 187.194 244.789 186.857 244.23 186.7C244.65 186.515 245.004 186.207 245.243 185.815C245.483 185.424 245.597 184.968 245.57 184.51C245.57 182.71 244.57 181.7 242.25 181.7H232.14V192.92Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M245.62 195.67H232.14V197.92H245.62V195.67Z",
                fill: "#FFD400"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M421.9 251.69C421.9 251.69 425.19 241.42 433 240.42C440.81 239.42 443.07 254.11 458.47 245.14C473.87 236.17 489.78 250.55 489.78 250.55L462.18 278.42C462.18 278.42 461.71 268.26 450.27 271.65C438.83 275.04 431.54 265.56 431.21 260.65C430.88 255.74 425.21 255.57 425.21 255.57L421.9 251.69Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M154.49 291.75C147.62 307.22 148.49 327.96 152.59 338.58C165.67 348.29 190.48 350.02 226.81 341.52V328.13C226.81 328.13 198.44 313.51 168.07 324.36V310.99L154.49 291.75Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M236.87 320.42C236.87 320.42 226.81 322.97 226.81 328.12C226.81 333.27 235.51 332.59 235.51 332.59L236.87 320.42Z",
                fill: "#FDC498"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M339.83 298.7H236.18C234.131 298.7 232.47 300.361 232.47 302.41V336.33C232.47 338.379 234.131 340.04 236.18 340.04H339.83C341.879 340.04 343.54 338.379 343.54 336.33V302.41C343.54 300.361 341.879 298.7 339.83 298.7Z",
                fill: "#0067A5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M250.89 314.27H246.82L245.82 311.54C245.705 311.25 245.505 311 245.246 310.825C244.988 310.649 244.683 310.555 244.37 310.555C244.058 310.555 243.752 310.649 243.494 310.825C243.235 311 243.035 311.25 242.92 311.54L241.92 314.27H238.11C237.858 314.274 237.614 314.356 237.41 314.503C237.206 314.651 237.053 314.857 236.97 315.095C236.887 315.333 236.879 315.59 236.947 315.832C237.015 316.075 237.156 316.29 237.35 316.45L240.26 318.77L238.96 322.27C238.843 322.568 238.821 322.894 238.896 323.205C238.972 323.516 239.142 323.795 239.383 324.006C239.624 324.216 239.924 324.347 240.242 324.38C240.56 324.413 240.881 324.346 241.16 324.19L244.62 322.28L247.49 323.98C247.768 324.147 248.091 324.223 248.415 324.197C248.738 324.171 249.045 324.044 249.292 323.834C249.539 323.624 249.715 323.342 249.793 323.028C249.872 322.713 249.85 322.381 249.73 322.08L248.59 319.01L251.67 316.45C251.872 316.292 252.019 316.074 252.09 315.828C252.161 315.582 252.153 315.32 252.066 315.079C251.98 314.837 251.82 314.63 251.609 314.484C251.398 314.339 251.146 314.264 250.89 314.27Z",
                fill: "#FFD400"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M272.28 314.27H268.21L267.21 311.54C267.095 311.25 266.895 311 266.637 310.825C266.378 310.649 266.073 310.555 265.76 310.555C265.448 310.555 265.142 310.649 264.884 310.825C264.625 311 264.425 311.25 264.31 311.54L263.31 314.27H259.5C259.249 314.274 259.004 314.356 258.8 314.503C258.596 314.651 258.443 314.857 258.36 315.095C258.277 315.333 258.269 315.59 258.337 315.832C258.405 316.075 258.546 316.29 258.74 316.45L261.65 318.77L260.35 322.27C260.233 322.568 260.211 322.894 260.287 323.205C260.362 323.516 260.532 323.795 260.773 324.006C261.014 324.216 261.314 324.347 261.632 324.38C261.951 324.413 262.271 324.346 262.55 324.19L266.01 322.28L268.88 323.98C269.158 324.147 269.481 324.223 269.805 324.197C270.128 324.171 270.435 324.044 270.682 323.834C270.93 323.624 271.105 323.342 271.183 323.028C271.262 322.713 271.24 322.381 271.12 322.08L270 319.01L273 316.42C273.187 316.262 273.322 316.052 273.388 315.817C273.453 315.582 273.447 315.332 273.37 315.101C273.292 314.869 273.147 314.666 272.953 314.518C272.758 314.37 272.524 314.284 272.28 314.27Z",
                fill: "#FFD400"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M293.67 314.27H289.6L288.6 311.54C288.485 311.25 288.285 311 288.026 310.825C287.768 310.649 287.463 310.555 287.15 310.555C286.838 310.555 286.532 310.649 286.274 310.825C286.015 311 285.815 311.25 285.7 311.54L284.7 314.27H280.88C280.628 314.274 280.384 314.356 280.18 314.503C279.976 314.651 279.823 314.857 279.74 315.095C279.657 315.333 279.649 315.59 279.717 315.832C279.785 316.075 279.926 316.29 280.12 316.45L283.03 318.77L281.73 322.27C281.613 322.568 281.591 322.894 281.666 323.205C281.742 323.516 281.912 323.795 282.153 324.006C282.394 324.216 282.694 324.347 283.012 324.38C283.331 324.413 283.651 324.346 283.93 324.19L287.39 322.28L290.26 323.98C290.538 324.147 290.861 324.223 291.185 324.197C291.508 324.171 291.815 324.044 292.062 323.834C292.309 323.624 292.485 323.342 292.563 323.028C292.642 322.713 292.62 322.381 292.5 322.08L291.36 319.01L294.44 316.45C294.641 316.292 294.787 316.076 294.859 315.831C294.93 315.586 294.923 315.324 294.838 315.084C294.753 314.843 294.594 314.635 294.385 314.489C294.175 314.343 293.925 314.266 293.67 314.27Z",
                fill: "#FFD400"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M315.06 314.27H311L310 311.54C309.887 311.249 309.688 310.998 309.431 310.822C309.173 310.645 308.867 310.551 308.555 310.551C308.242 310.551 307.937 310.645 307.679 310.822C307.422 310.998 307.223 311.249 307.11 311.54L306.11 314.27H302.29C302.038 314.274 301.794 314.356 301.59 314.503C301.386 314.651 301.232 314.857 301.15 315.095C301.067 315.333 301.059 315.59 301.127 315.832C301.195 316.075 301.336 316.29 301.53 316.45L304.44 318.77L303.14 322.27C303.023 322.568 303.001 322.894 303.076 323.205C303.152 323.516 303.322 323.795 303.563 324.006C303.804 324.216 304.104 324.347 304.422 324.38C304.74 324.413 305.061 324.346 305.34 324.19L308.8 322.28L311.67 323.98C311.948 324.147 312.271 324.223 312.595 324.197C312.918 324.171 313.225 324.044 313.472 323.834C313.719 323.624 313.895 323.342 313.973 323.028C314.052 322.713 314.03 322.381 313.91 322.08L312.78 319.01L315.85 316.45C316.052 316.291 316.2 316.073 316.271 315.826C316.341 315.579 316.332 315.316 316.245 315.074C316.157 314.832 315.996 314.624 315.783 314.48C315.57 314.335 315.317 314.262 315.06 314.27Z",
                fill: "#FFD400"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M336.45 314.27H332.38L331.38 311.54C331.267 311.249 331.069 310.998 330.811 310.822C330.553 310.645 330.248 310.551 329.935 310.551C329.623 310.551 329.317 310.645 329.06 310.822C328.802 310.998 328.603 311.249 328.49 311.54L327.49 314.27H323.67C323.418 314.274 323.174 314.356 322.97 314.503C322.766 314.651 322.613 314.857 322.53 315.095C322.447 315.333 322.439 315.59 322.507 315.832C322.575 316.075 322.716 316.29 322.91 316.45L325.82 318.77L324.52 322.27C324.403 322.568 324.381 322.894 324.456 323.205C324.532 323.516 324.702 323.795 324.943 324.006C325.184 324.216 325.484 324.347 325.802 324.38C326.121 324.413 326.441 324.346 326.72 324.19L330.18 322.28L333.05 323.98C333.328 324.147 333.651 324.223 333.975 324.197C334.298 324.171 334.605 324.044 334.852 323.834C335.1 323.624 335.275 323.342 335.353 323.028C335.432 322.713 335.41 322.381 335.29 322.08L334.16 319.01L337.23 316.45C337.432 316.292 337.579 316.074 337.65 315.828C337.721 315.582 337.713 315.32 337.626 315.079C337.54 314.837 337.38 314.63 337.169 314.484C336.958 314.339 336.706 314.264 336.45 314.27Z",
                fill: "#FFD400"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M336.45 314.27H332.38L331.38 311.54C331.279 311.264 331.101 311.023 330.867 310.846C330.633 310.669 330.353 310.562 330.06 310.54V322.31L330.17 322.25L333.04 323.95C333.318 324.117 333.641 324.193 333.965 324.167C334.288 324.141 334.595 324.014 334.842 323.804C335.089 323.594 335.265 323.312 335.343 322.998C335.422 322.683 335.4 322.351 335.28 322.05L334.15 318.98L337.22 316.42C337.409 316.259 337.545 316.045 337.609 315.805C337.673 315.566 337.663 315.312 337.579 315.079C337.496 314.845 337.343 314.642 337.141 314.498C336.939 314.354 336.698 314.274 336.45 314.27Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M226.81 341.52C226.81 341.52 239.47 343.52 249.25 341.32C250.86 340.87 251.46 334.81 251.25 331.08C251.206 330.474 250.928 329.908 250.475 329.503C250.021 329.098 249.428 328.885 248.82 328.91C241.28 329.27 229.09 329.17 226.82 328.13L226.81 341.52Z",
                fill: "#FDC498"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M251.448 331.299L239.394 332.089L239.541 334.335L251.595 333.544L251.448 331.299Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M251.089 336.113L240.781 336.788L240.928 339.034L251.236 338.358L251.089 336.113Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M192.13 299.83H182.93C180.476 299.825 178.124 298.848 176.388 297.112C174.653 295.377 173.675 293.024 173.67 290.57V273.84H175.92V290.57C175.92 292.427 176.658 294.207 177.97 295.52C179.283 296.833 181.064 297.57 182.92 297.57H192.12L192.13 299.83Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M236.13 393.54C234.861 393.54 233.645 393.037 232.747 392.141C231.849 391.245 231.343 390.029 231.34 388.76V358.61C231.343 357.343 231.847 356.129 232.743 355.233C233.639 354.337 234.853 353.833 236.12 353.83H339.88C341.148 353.83 342.364 354.334 343.26 355.23C344.156 356.127 344.66 357.342 344.66 358.61V382.42C344.657 383.687 344.153 384.901 343.257 385.797C342.361 386.693 341.147 387.197 339.88 387.2H246.75C246.189 387.201 245.644 387.388 245.2 387.73L239.06 392.52C238.225 393.178 237.193 393.537 236.13 393.54ZM236.13 356.08C235.459 356.08 234.816 356.347 234.341 356.821C233.867 357.296 233.6 357.939 233.6 358.61V388.76C233.599 389.235 233.731 389.701 233.982 390.104C234.233 390.508 234.592 390.832 235.019 391.041C235.445 391.25 235.922 391.334 236.395 391.284C236.867 391.235 237.316 391.053 237.69 390.76L243.83 385.98C244.669 385.332 245.7 384.98 246.76 384.98H339.89C340.562 384.98 341.207 384.714 341.683 384.24C342.159 383.765 342.427 383.122 342.43 382.45V358.61C342.427 357.938 342.159 357.295 341.683 356.82C341.207 356.346 340.562 356.08 339.89 356.08H236.13Z",
                fill: "#D9E8F2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M261.87 419.02H259.62V401.97C259.623 400.703 260.127 399.489 261.023 398.593C261.919 397.697 263.133 397.193 264.4 397.19H354.32V399.42H264.4C263.729 399.42 263.086 399.687 262.611 400.161C262.137 400.636 261.87 401.279 261.87 401.95V419.02Z",
                fill: "#D9E8F2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M335.48 362.63H288.03V364.88H335.48V362.63Z",
                fill: "#D9E8F2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M335.48 370.74H288.03V372.99H335.48V370.74Z",
                fill: "#D9E8F2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M466.78 191.75C466.052 191.745 465.335 191.578 464.68 191.26C463.873 190.869 463.193 190.258 462.719 189.497C462.245 188.736 461.995 187.857 462 186.96V156.81C462.003 155.543 462.507 154.329 463.403 153.433C464.299 152.537 465.513 152.033 466.78 152.03H557.32C558.586 152.033 559.799 152.537 560.694 153.434C561.588 154.33 562.09 155.544 562.09 156.81V180.63C562.09 181.896 561.588 183.11 560.694 184.006C559.799 184.903 558.586 185.407 557.32 185.41H477.41C476.844 185.41 476.295 185.6 475.85 185.95L469.71 190.73C468.874 191.387 467.843 191.746 466.78 191.75ZM466.78 154.28C466.108 154.28 465.464 154.546 464.988 155.02C464.511 155.495 464.243 156.138 464.24 156.81V186.96C464.239 187.435 464.371 187.901 464.622 188.304C464.873 188.708 465.232 189.032 465.659 189.241C466.085 189.45 466.562 189.534 467.035 189.484C467.507 189.435 467.956 189.253 468.33 188.96L474.47 184.17C475.313 183.521 476.347 183.17 477.41 183.17H557.32C557.991 183.17 558.635 182.903 559.109 182.429C559.584 181.955 559.85 181.311 559.85 180.64V156.81C559.847 156.14 559.58 155.498 559.106 155.024C558.632 154.55 557.99 154.283 557.32 154.28H466.78Z",
                fill: "#D9E8F2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M552.91 160.84H518.68V163.09H552.91V160.84Z",
                fill: "#D9E8F2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M552.9 168.95H496.9V171.2H552.9V168.95Z",
                fill: "#D9E8F2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M570.47 232.9C569.409 232.903 568.378 232.551 567.54 231.9L561.4 227.12C560.956 226.77 560.406 226.58 559.84 226.58H490.76C489.492 226.58 488.277 226.077 487.38 225.18C486.484 224.284 485.98 223.068 485.98 221.8V197.97C485.983 196.703 486.487 195.489 487.383 194.593C488.279 193.697 489.493 193.193 490.76 193.19H570.48C571.747 193.193 572.961 193.697 573.857 194.593C574.753 195.489 575.258 196.703 575.26 197.97V228.12C575.264 229.015 575.015 229.893 574.54 230.653C574.066 231.412 573.386 232.021 572.58 232.41C571.923 232.731 571.202 232.899 570.47 232.9ZM490.76 195.42C490.089 195.42 489.446 195.687 488.971 196.161C488.497 196.636 488.23 197.279 488.23 197.95V221.77C488.23 222.441 488.497 223.085 488.971 223.559C489.446 224.034 490.089 224.3 490.76 224.3H559.84C560.904 224.3 561.937 224.652 562.78 225.3L568.92 230.09C569.295 230.379 569.744 230.557 570.215 230.605C570.686 230.653 571.161 230.568 571.586 230.36C572.011 230.152 572.37 229.829 572.622 229.428C572.873 229.027 573.008 228.564 573.01 228.09V197.97C573.008 197.3 572.74 196.658 572.266 196.184C571.792 195.71 571.15 195.443 570.48 195.44L490.76 195.42Z",
                fill: "#D9E8F2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M518.58 201.99H495.17V204.24H518.58V201.99Z",
                fill: "#D9E8F2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M540.35 210.11H495.17V212.36H540.35V210.11Z",
                fill: "#D9E8F2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M335.48 407.54H288.03V409.79H335.48V407.54Z",
                fill: "#D9E8F2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M275.68 406.77C275.68 406.77 276.39 403.26 279.82 404.03C283.25 404.8 281.67 410.81 275.68 413.42C269.68 410.81 267.74 404.84 271.54 404.03C275 403.29 275.68 406.77 275.68 406.77Z",
                fill: "#D9E8F2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M396 330.55L328.39 524.84H373C373 524.84 368.26 503.18 380.44 491.67C392.62 480.16 398 467.3 396 453.08C394 438.86 403.45 427.7 403.45 427.7C403.45 427.7 410.22 486.25 429.17 516.04L469.11 501.82C469.11 501.82 474.01 486.26 452.19 472.06C431.34 458.5 434.01 439.29 436.62 427.7C448.54 374.8 437.97 355.6 427.14 330.55H396Z",
                fill: "#008B66"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M313.25 241.85C313.25 241.85 317.09 250.47 314.83 257.75C312.57 265.03 307.83 257.75 307.83 257.75L313.25 241.85Z",
                fill: "#A37160"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M288.37 262.72C305.878 262.72 320.07 248.528 320.07 231.02C320.07 213.513 305.878 199.32 288.37 199.32C270.863 199.32 256.67 213.513 256.67 231.02C256.67 248.528 270.863 262.72 288.37 262.72Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M288.56 227.28C288.56 227.28 290.29 218.69 298.68 220.56C307.07 222.43 303.23 239.87 288.56 246.26C273.89 239.87 269.13 222.55 278.43 220.56C286.89 218.75 288.56 227.28 288.56 227.28Z",
                fill: "#FF7D20"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M246.01 282.23C254.184 282.23 260.81 275.604 260.81 267.43C260.81 259.256 254.184 252.63 246.01 252.63C237.836 252.63 231.21 259.256 231.21 267.43C231.21 275.604 237.836 282.23 246.01 282.23Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M246.1 265.69C246.1 265.69 246.91 261.69 250.83 262.55C254.75 263.41 252.95 271.55 246.1 274.55C239.25 271.55 237.03 263.49 241.38 262.55C245.32 261.71 246.1 265.69 246.1 265.69Z",
                fill: "#40A88D"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M427.14 330.55L420.41 287.9C420.022 285.45 418.773 283.218 416.886 281.607C415 279.996 412.601 279.11 410.12 279.11H351.66L314.83 257.75L304.67 243.53C304.67 243.53 296.54 249.09 300.67 256.11C307.36 267.43 329.67 291.97 352.32 296.37C374.97 300.77 392.26 311.26 395.98 330.55H427.14Z",
                fill: "#A37160"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M378.21 132.07C378.21 132.07 395.3 129.78 395.84 116.46V109.33C395.84 109.33 405.2 106.39 402.2 127.04C402.2 127.04 416.29 126.96 419.39 128.57C420.044 128.91 420.579 129.44 420.923 130.092C421.267 130.743 421.405 131.484 421.317 132.216C421.229 132.947 420.92 133.635 420.431 134.186C419.942 134.737 419.296 135.126 418.58 135.3C421.34 137.72 420.19 142.48 417.37 143.3C417.97 143.827 418.41 144.511 418.641 145.275C418.872 146.039 418.884 146.853 418.675 147.623C418.467 148.394 418.047 149.09 417.463 149.634C416.879 150.178 416.154 150.547 415.37 150.7C417.52 152.22 413.37 157.7 403.66 157.47C393.95 157.24 378.23 153.3 378.23 153.3L378.21 132.07Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M375.34 127.29H369.42C367.835 127.29 366.55 128.575 366.55 130.16V154.64C366.55 156.225 367.835 157.51 369.42 157.51H375.34C376.925 157.51 378.21 156.225 378.21 154.64V130.16C378.21 128.575 376.925 127.29 375.34 127.29Z",
                fill: "#82B5D3"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M418.58 136.42H404.75V134.17H418.58C418.778 134.186 418.976 134.157 419.161 134.086C419.347 134.015 419.513 133.904 419.65 133.76C420.132 132.988 420.337 132.074 420.23 131.17L422.46 130.93C422.644 132.466 422.236 134.014 421.32 135.26C420.975 135.641 420.551 135.943 420.078 136.143C419.605 136.343 419.094 136.438 418.58 136.42Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M417.37 144.26H404.75V142.01H417.37C417.73 142.01 418.96 141.8 418.96 139.77H421.21C421.21 143.42 418.44 144.26 417.37 144.26Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M415.35 151.42H404.75V149.12H415.35C417.65 149.12 418.18 147.71 418.23 147.55L420.38 148.18C420.35 148.31 419.43 151.42 415.35 151.42Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M403.31 127.25L401.1 126.82C402.91 117.33 401.32 113.34 399.67 111.67C399.168 111.162 398.557 110.774 397.883 110.535C397.21 110.296 396.491 110.212 395.78 110.29L395.38 108.08C396.45 107.937 397.538 108.043 398.559 108.39C399.581 108.737 400.509 109.315 401.27 110.08C404.23 113.08 404.91 118.85 403.31 127.25Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M379.34 132.07H377.09V157.51H379.34V132.07Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M211.66 353.83H174.8V356.08H211.66V353.83Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M163.87 493.24L146.37 500.63C144.333 501.49 142.594 502.931 141.372 504.774C140.15 506.617 139.499 508.779 139.5 510.99H191.14L184.68 493.24H163.87Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M197.42 493.24V510.99H247.66C248.66 505.73 245.44 499.85 239.01 497.46L226.81 493.24H197.42Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M409.52 272.61C409.52 272.61 427.52 268.42 425.75 254.54C424.66 245.95 410.12 249.23 410.12 249.23V256.79C414.93 254.79 417.01 261.52 410.12 264.15L409.52 272.61Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M458.28 377.6C458.28 377.6 473.35 289.5 410.12 280.14V303.48C410.12 303.48 434.25 315.93 440.01 338C442.697 348.766 444.394 359.755 445.08 370.83L458.28 377.6Z",
                fill: "#40A88D"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M410.12 280.14C404.53 279.14 391.21 276.83 351.66 279.14L335.66 289.83C335.66 289.83 342.1 296.36 362.47 300.03C382.84 303.7 395.86 322.33 396.03 330.58H427.17L422.83 297.21L410.12 280.14Z",
                fill: "#40A88D"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M364.32 287.76C365.491 287.76 366.44 286.811 366.44 285.64C366.44 284.469 365.491 283.52 364.32 283.52C363.149 283.52 362.2 284.469 362.2 285.64C362.2 286.811 363.149 287.76 364.32 287.76Z",
                fill: "#8CCBBA"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M398.15 314.81C399.321 314.81 400.27 313.861 400.27 312.69C400.27 311.519 399.321 310.57 398.15 310.57C396.979 310.57 396.03 311.519 396.03 312.69C396.03 313.861 396.979 314.81 398.15 314.81Z",
                fill: "#8CCBBA"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M417.7 311.53C418.871 311.53 419.82 310.581 419.82 309.41C419.82 308.239 418.871 307.29 417.7 307.29C416.529 307.29 415.58 308.239 415.58 309.41C415.58 310.581 416.529 311.53 417.7 311.53Z",
                fill: "#8CCBBA"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M369.06 296.3C370.231 296.3 371.18 295.351 371.18 294.18C371.18 293.009 370.231 292.06 369.06 292.06C367.889 292.06 366.94 293.009 366.94 294.18C366.94 295.351 367.889 296.3 369.06 296.3Z",
                fill: "#8CCBBA"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M405.74 288.7C406.911 288.7 407.86 287.751 407.86 286.58C407.86 285.409 406.911 284.46 405.74 284.46C404.569 284.46 403.62 285.409 403.62 286.58C403.62 287.751 404.569 288.7 405.74 288.7Z",
                fill: "#8CCBBA"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M388.01 305.88C389.181 305.88 390.13 304.931 390.13 303.76C390.13 302.589 389.181 301.64 388.01 301.64C386.839 301.64 385.89 302.589 385.89 303.76C385.89 304.931 386.839 305.88 388.01 305.88Z",
                fill: "#8CCBBA"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M393.29 294.18C394.803 294.18 396.03 292.953 396.03 291.44C396.03 289.927 394.803 288.7 393.29 288.7C391.777 288.7 390.55 289.927 390.55 291.44C390.55 292.953 391.777 294.18 393.29 294.18Z",
                fill: "#8CCBBA"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M422.38 295.09C424.396 295.09 426.03 293.456 426.03 291.44C426.03 289.424 424.396 287.79 422.38 287.79C420.364 287.79 418.73 289.424 418.73 291.44C418.73 293.456 420.364 295.09 422.38 295.09Z",
                fill: "#8CCBBA"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M434.98 316.34C436.996 316.34 438.63 314.706 438.63 312.69C438.63 310.674 436.996 309.04 434.98 309.04C432.964 309.04 431.33 310.674 431.33 312.69C431.33 314.706 432.964 316.34 434.98 316.34Z",
                fill: "#8CCBBA"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M452.18 335.19C454.196 335.19 455.83 333.556 455.83 331.54C455.83 329.524 454.196 327.89 452.18 327.89C450.164 327.89 448.53 329.524 448.53 331.54C448.53 333.556 450.164 335.19 452.18 335.19Z",
                fill: "#8CCBBA"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M450.28 361.69C452.296 361.69 453.93 360.056 453.93 358.04C453.93 356.024 452.296 354.39 450.28 354.39C448.264 354.39 446.63 356.024 446.63 358.04C446.63 360.056 448.264 361.69 450.28 361.69Z",
                fill: "#8CCBBA"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M402.1 327.9C403.691 327.9 404.98 326.611 404.98 325.02C404.98 323.43 403.691 322.14 402.1 322.14C400.51 322.14 399.22 323.43 399.22 325.02C399.22 326.611 400.51 327.9 402.1 327.9Z",
                fill: "#8CCBBA"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M403 304.39C404.514 304.39 405.74 303.163 405.74 301.65C405.74 300.137 404.514 298.91 403 298.91C401.487 298.91 400.26 300.137 400.26 301.65C400.26 303.163 401.487 304.39 403 304.39Z",
                fill: "#8CCBBA"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M356.47 290.15C357.271 290.15 357.92 289.501 357.92 288.7C357.92 287.899 357.271 287.25 356.47 287.25C355.669 287.25 355.02 287.899 355.02 288.7C355.02 289.501 355.669 290.15 356.47 290.15Z",
                fill: "#8CCBBA"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M346.65 291.6C347.451 291.6 348.1 290.951 348.1 290.15C348.1 289.349 347.451 288.7 346.65 288.7C345.849 288.7 345.2 289.349 345.2 290.15C345.2 290.951 345.849 291.6 346.65 291.6Z",
                fill: "#8CCBBA"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M377.87 287.09C378.671 287.09 379.32 286.441 379.32 285.64C379.32 284.839 378.671 284.19 377.87 284.19C377.069 284.19 376.42 284.839 376.42 285.64C376.42 286.441 377.069 287.09 377.87 287.09Z",
                fill: "#8CCBBA"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M413.33 299.2C414.131 299.2 414.78 298.551 414.78 297.75C414.78 296.949 414.131 296.3 413.33 296.3C412.529 296.3 411.88 296.949 411.88 297.75C411.88 298.551 412.529 299.2 413.33 299.2Z",
                fill: "#8CCBBA"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M423.35 305.21C424.151 305.21 424.8 304.561 424.8 303.76C424.8 302.959 424.151 302.31 423.35 302.31C422.549 302.31 421.9 302.959 421.9 303.76C421.9 304.561 422.549 305.21 423.35 305.21Z",
                fill: "#8CCBBA"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M445.14 313.47C445.941 313.47 446.59 312.821 446.59 312.02C446.59 311.219 445.941 310.57 445.14 310.57C444.339 310.57 443.69 311.219 443.69 312.02C443.69 312.821 444.339 313.47 445.14 313.47Z",
                fill: "#8CCBBA"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M454.98 348.59C455.781 348.59 456.43 347.941 456.43 347.14C456.43 346.339 455.781 345.69 454.98 345.69C454.179 345.69 453.53 346.339 453.53 347.14C453.53 347.941 454.179 348.59 454.98 348.59Z",
                fill: "#8CCBBA"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M455.83 366.66C456.631 366.66 457.28 366.011 457.28 365.21C457.28 364.409 456.631 363.76 455.83 363.76C455.029 363.76 454.38 364.409 454.38 365.21C454.38 366.011 455.029 366.66 455.83 366.66Z",
                fill: "#8CCBBA"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M435.37 302.56C436.585 302.56 437.57 301.575 437.57 300.36C437.57 299.145 436.585 298.16 435.37 298.16C434.155 298.16 433.17 299.145 433.17 300.36C433.17 301.575 434.155 302.56 435.37 302.56Z",
                fill: "#8CCBBA"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M381.09 295.42C381.775 295.42 382.33 294.865 382.33 294.18C382.33 293.495 381.775 292.94 381.09 292.94C380.405 292.94 379.85 293.495 379.85 294.18C379.85 294.865 380.405 295.42 381.09 295.42Z",
                fill: "#8CCBBA"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M443.79 325.25C444.729 325.25 445.49 324.489 445.49 323.55C445.49 322.611 444.729 321.85 443.79 321.85C442.851 321.85 442.09 322.611 442.09 323.55C442.09 324.489 442.851 325.25 443.79 325.25Z",
                fill: "#8CCBBA"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M447.89 342.48C449.238 342.48 450.33 341.388 450.33 340.04C450.33 338.693 449.238 337.6 447.89 337.6C446.543 337.6 445.45 338.693 445.45 340.04C445.45 341.388 446.543 342.48 447.89 342.48Z",
                fill: "#8CCBBA"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M414.56 322.28C415.245 322.28 415.8 321.725 415.8 321.04C415.8 320.355 415.245 319.8 414.56 319.8C413.875 319.8 413.32 320.355 413.32 321.04C413.32 321.725 413.875 322.28 414.56 322.28Z",
                fill: "#8CCBBA"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M407.86 313.93C408.545 313.93 409.1 313.375 409.1 312.69C409.1 312.005 408.545 311.45 407.86 311.45C407.175 311.45 406.62 312.005 406.62 312.69C406.62 313.375 407.175 313.93 407.86 313.93Z",
                fill: "#8CCBBA"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M423.4 252.97C423.4 252.85 421.27 240.86 434.71 237.52C441.45 235.85 445.48 239.21 449.03 242.17C453.35 245.78 457.09 248.89 465.3 244.96L466.3 246.96C456.78 251.51 451.92 247.45 447.62 243.87C444.17 240.99 440.91 238.27 435.28 239.67C423.94 242.49 425.56 252.12 425.64 252.53L423.4 252.97Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M455.92 283.26L454 282.1L455 282.68L454 282.1C454 282.1 455.69 279.18 454.48 276.47C453.48 274.15 450.63 272.47 446.11 271.6L446.56 269.39C451.85 270.46 455.21 272.54 456.56 275.58C458.21 279.42 456 283.1 455.92 283.26Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M424.5 256.25C426.422 256.25 427.98 254.692 427.98 252.77C427.98 250.848 426.422 249.29 424.5 249.29C422.578 249.29 421.02 250.848 421.02 252.77C421.02 254.692 422.578 256.25 424.5 256.25Z",
                fill: "#FFD400"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M372 525.42C371.78 525.05 366.7 516.19 373 501.68C375.54 495.76 378.72 492.68 382.09 489.39C386.04 485.54 390.09 481.56 393.66 472.32C396.1 465.93 395.87 460.4 395.66 454.53C395.32 446.29 394.96 437.76 402.59 427.06C428.06 391.71 425.01 368.19 424.97 367.96L427.2 367.63C427.34 368.63 430.48 392.2 404.42 428.37C397.24 438.44 397.57 446.21 397.91 454.44C398.15 460.27 398.4 466.3 395.79 473.12C392.07 482.82 387.62 487.17 383.69 491C380.49 494.12 377.46 497.06 375.09 502.57C369.32 515.96 373.97 524.2 374.02 524.28L372 525.42Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M575.44 248.17C579.063 248.17 582 245.233 582 241.61C582 237.987 579.063 235.05 575.44 235.05C571.817 235.05 568.88 237.987 568.88 241.61C568.88 245.233 571.817 248.17 575.44 248.17Z",
                fill: "#408DBC"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M459 206.69C462.623 206.69 465.56 203.753 465.56 200.13C465.56 196.507 462.623 193.57 459 193.57C455.377 193.57 452.44 196.507 452.44 200.13C452.44 203.753 455.377 206.69 459 206.69Z",
                fill: "#FF7D20"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M462.27 113.02C458.099 113.018 454.023 111.78 450.556 109.461C447.089 107.142 444.387 103.848 442.793 99.994C441.198 96.1401 440.782 91.8999 441.597 87.8095C442.412 83.7191 444.421 79.9622 447.371 77.0137C450.321 74.0652 454.079 72.0576 458.169 71.2446C462.26 70.4317 466.5 70.8499 470.353 72.4464C474.206 74.043 477.5 76.7461 479.817 80.2142C482.134 83.6822 483.37 87.7593 483.37 91.9301C483.365 97.5236 481.14 102.886 477.184 106.841C473.228 110.795 467.864 113.017 462.27 113.02ZM462.27 73.0801C458.542 73.0801 454.898 74.1856 451.798 76.2569C448.698 78.3282 446.282 81.2721 444.855 84.7165C443.428 88.1609 443.055 91.951 443.782 95.6076C444.51 99.2641 446.305 102.623 448.941 105.259C451.577 107.895 454.936 109.691 458.593 110.418C462.249 111.145 466.039 110.772 469.484 109.345C472.928 107.919 475.872 105.502 477.943 102.403C480.015 99.3027 481.12 95.6583 481.12 91.9301C481.115 86.9324 479.127 82.1409 475.593 78.607C472.059 75.0731 467.268 73.0854 462.27 73.0801Z",
                fill: "#D9E8F2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M462.57 99.4501L449.82 87.6601L451.35 86.0101L462.06 95.9201L476.68 71.3801L478.61 72.5301L462.57 99.4501Z",
                fill: "#4AAD93"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M511.67 533.17H265.88V535.42H511.67V533.17Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M258.26 510.92H116.28V513.17H258.26V510.92Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M404.37 257.81C405.127 257.81 405.74 257.197 405.74 256.44C405.74 255.683 405.127 255.07 404.37 255.07C403.613 255.07 403 255.683 403 256.44C403 257.197 403.613 257.81 404.37 257.81Z",
                fill: "#003C71"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-illustrations-virtual-f4c8d3dc38/1/packages/lib-illustrations/src/batur.tsx
/* eslint-disable max-len */ 

const BaturIllustration = (param)=>{
    let { size =200  } = param;
    return /*#__PURE__*/ _jsxs("svg", {
        fill: "none",
        height: size,
        viewBox: "0 0 662 611",
        width: size,
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M495.97 225.5H493.45V262.06H495.97V225.5Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M474.28 239.21H471.76V262.06H474.28V239.21Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M122.8 212.91H120.28V257.76H122.8V212.91Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M193.55 123.08H191.03V190.09H193.55V123.08Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M202.23 145.89H199.71V212.9H202.23V145.89Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M226.98 225.5H128.4V282.95H226.98V225.5Z",
                fill: "#A6CAE0"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M226.98 232.02H182.3V179.4H257.48L226.98 232.02Z",
                fill: "#A6CAE0"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M114.21 256H213.5V275.15H434.01V256H530.32L490.1 325.5H114.21V312.03H137.62V286.49H123.43L114.21 256Z",
                fill: "#408DBC"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M305.58 246.78H241.04V275.15H305.58V246.78Z",
                fill: "#0067A5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M370.12 246.78H305.58V275.15H370.12V246.78Z",
                fill: "#82B5D3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M434.66 246.78H370.12V275.15H434.66V246.78Z",
                fill: "#0067A5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M337.85 218.43H273.31V246.8H337.85V218.43Z",
                fill: "#FF9D57"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M402.39 218.49H337.85V246.86H402.39V218.49Z",
                fill: "#0067A5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M370.12 190.27H305.58V218.64H370.12V190.27Z",
                fill: "#82B5D3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M197.32 185.11H187.26V195.17H197.32V185.11Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M214.28 185.11H204.22V195.17H214.28V185.11Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M197.32 200.33H187.26V210.39H197.32V200.33Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M214.28 200.33H204.22V210.39H214.28V200.33Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M231.24 185.11H221.18V195.17H231.24V185.11Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M248.22 189.91C246.141 189.91 244.109 189.294 242.381 188.139C240.653 186.984 239.305 185.343 238.51 183.422C237.715 181.502 237.506 179.388 237.912 177.35C238.317 175.311 239.318 173.438 240.788 171.968C242.258 170.499 244.131 169.498 246.17 169.092C248.208 168.687 250.322 168.895 252.242 169.69C254.162 170.486 255.804 171.833 256.959 173.561C258.114 175.289 258.73 177.321 258.73 179.4C258.727 182.187 257.619 184.858 255.649 186.829C253.678 188.799 251.007 189.907 248.22 189.91ZM248.22 171.41C246.638 171.41 245.091 171.879 243.775 172.758C242.46 173.637 241.434 174.887 240.829 176.349C240.223 177.81 240.065 179.419 240.374 180.971C240.682 182.523 241.444 183.948 242.563 185.067C243.682 186.186 245.107 186.948 246.659 187.256C248.211 187.565 249.82 187.407 251.281 186.801C252.743 186.196 253.993 185.17 254.872 183.855C255.751 182.539 256.22 180.992 256.22 179.41C256.22 178.36 256.013 177.319 255.611 176.349C255.209 175.378 254.62 174.496 253.877 173.753C253.134 173.01 252.252 172.421 251.281 172.019C250.311 171.617 249.271 171.41 248.22 171.41Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M182.3 211.65H114.21V214.17H182.3V211.65Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M435.92 276.41H212.24V257.26H164.57V254.74H214.76V273.89H433.4V254.74H530.32V257.26H435.92V276.41Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M138.88 286.49H136.36V312.02H138.88V286.49Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M153.53 286.49H151.01V312.02H153.53V286.49Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M168.19 286.49H165.67V312.02H168.19V286.49Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M182.85 286.49H180.33V312.02H182.85V286.49Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M197.51 286.49H194.99V312.02H197.51V286.49Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M212.16 286.49H209.64V312.02H212.16V286.49Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M451.33 282.19C450.1 282.19 448.897 281.825 447.874 281.142C446.852 280.458 446.054 279.487 445.584 278.35C445.113 277.214 444.99 275.963 445.23 274.757C445.47 273.55 446.062 272.442 446.932 271.572C447.802 270.702 448.91 270.11 450.117 269.87C451.323 269.63 452.574 269.753 453.71 270.224C454.847 270.694 455.818 271.492 456.502 272.514C457.185 273.537 457.55 274.74 457.55 275.97C457.547 277.619 456.891 279.2 455.725 280.365C454.559 281.531 452.979 282.187 451.33 282.19ZM451.33 272.27C450.599 272.272 449.884 272.491 449.277 272.899C448.67 273.306 448.197 273.885 447.919 274.561C447.64 275.237 447.569 275.981 447.712 276.698C447.856 277.415 448.209 278.073 448.727 278.59C449.245 279.106 449.904 279.458 450.622 279.6C451.339 279.742 452.083 279.668 452.758 279.388C453.434 279.107 454.011 278.633 454.417 278.025C454.823 277.416 455.04 276.701 455.04 275.97C455.039 275.484 454.942 275.003 454.755 274.555C454.567 274.107 454.294 273.699 453.949 273.357C453.605 273.014 453.196 272.743 452.747 272.558C452.297 272.373 451.816 272.279 451.33 272.28V272.27Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M473 282.19C471.77 282.19 470.567 281.825 469.544 281.142C468.522 280.458 467.724 279.487 467.254 278.35C466.783 277.214 466.66 275.963 466.9 274.757C467.14 273.55 467.732 272.442 468.602 271.572C469.472 270.702 470.58 270.11 471.787 269.87C472.993 269.63 474.244 269.753 475.38 270.224C476.517 270.694 477.488 271.492 478.172 272.514C478.855 273.537 479.22 274.74 479.22 275.97C479.217 277.619 478.561 279.2 477.395 280.365C476.229 281.531 474.649 282.187 473 282.19ZM473 272.27C472.268 272.27 471.553 272.487 470.944 272.894C470.336 273.3 469.862 273.878 469.582 274.554C469.302 275.23 469.228 275.974 469.371 276.692C469.514 277.41 469.866 278.069 470.384 278.586C470.901 279.104 471.56 279.456 472.278 279.599C472.996 279.742 473.74 279.669 474.416 279.388C475.092 279.108 475.67 278.634 476.076 278.026C476.483 277.417 476.7 276.702 476.7 275.97C476.697 274.991 476.306 274.052 475.613 273.36C474.919 272.669 473.98 272.28 473 272.28V272.27Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M494.71 282.19C493.48 282.19 492.277 281.825 491.254 281.142C490.231 280.458 489.434 279.487 488.963 278.35C488.493 277.214 488.37 275.963 488.61 274.757C488.85 273.55 489.442 272.442 490.312 271.572C491.182 270.702 492.29 270.11 493.497 269.87C494.703 269.63 495.954 269.753 497.09 270.224C498.227 270.694 499.198 271.492 499.882 272.514C500.565 273.537 500.93 274.74 500.93 275.97C500.927 277.619 500.271 279.2 499.105 280.365C497.939 281.531 496.359 282.187 494.71 282.19ZM494.71 272.27C493.978 272.27 493.263 272.487 492.654 272.894C492.046 273.3 491.572 273.878 491.292 274.554C491.012 275.23 490.938 275.974 491.081 276.692C491.224 277.41 491.576 278.069 492.094 278.586C492.611 279.104 493.27 279.456 493.988 279.599C494.706 279.742 495.45 279.669 496.126 279.388C496.802 279.108 497.38 278.634 497.786 278.026C498.193 277.417 498.41 276.702 498.41 275.97C498.407 274.991 498.016 274.052 497.323 273.36C496.629 272.669 495.69 272.28 494.71 272.28V272.27Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M579.88 370.05C588.21 370.05 596.2 366.741 602.09 360.85C607.981 354.96 611.29 346.97 611.29 338.64H548.46C548.463 346.971 551.774 354.961 557.666 360.851C563.558 366.741 571.549 370.05 579.88 370.05Z",
                fill: "#E5F0F6"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M386.17 387.68C394.5 387.68 402.488 384.372 408.38 378.484C414.272 372.596 417.585 364.61 417.59 356.28H354.76C354.763 364.609 358.073 372.595 363.963 378.484C369.854 384.372 377.841 387.68 386.17 387.68Z",
                fill: "#E5F0F6"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M485 340.53C493.33 340.53 501.32 337.221 507.21 331.33C513.101 325.44 516.41 317.451 516.41 309.12H453.54C453.541 313.249 454.356 317.337 455.938 321.15C457.521 324.964 459.839 328.428 462.76 331.345C465.682 334.262 469.15 336.575 472.966 338.151C476.782 339.727 480.871 340.535 485 340.53Z",
                fill: "#E5F0F6"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M451 492.38C459.331 492.38 467.322 489.071 473.214 483.181C479.106 477.291 482.417 469.301 482.42 460.97H419.6C419.6 469.299 422.908 477.287 428.796 483.177C434.685 489.067 442.671 492.377 451 492.38Z",
                fill: "#E5F0F6"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M100.22 342.79C91.3864 342.78 82.9175 339.266 76.671 333.019C70.4246 326.773 66.9107 318.304 66.9001 309.47H69.4201C69.4201 317.639 72.6651 325.473 78.4413 331.249C84.2174 337.025 92.0515 340.27 100.22 340.27C108.389 340.27 116.223 337.025 121.999 331.249C127.775 325.473 131.02 317.639 131.02 309.47H133.54C133.53 318.304 130.016 326.773 123.769 333.019C117.523 339.266 109.054 342.78 100.22 342.79Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M164.34 342.79C155.503 342.785 147.029 339.273 140.778 333.026C134.527 326.779 131.011 318.307 131 309.47H133.52C133.665 317.544 136.975 325.238 142.736 330.896C148.497 336.555 156.25 339.725 164.325 339.725C172.4 339.725 180.153 336.555 185.914 330.896C191.675 325.238 194.985 317.544 195.13 309.47H197.64C197.632 318.301 194.122 326.769 187.879 333.015C181.636 339.261 173.171 342.777 164.34 342.79Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M228.47 342.79C219.636 342.782 211.165 339.269 204.918 333.022C198.671 326.775 195.158 318.305 195.15 309.47H197.66C197.806 317.544 201.115 325.238 206.876 330.896C212.638 336.555 220.39 339.725 228.465 339.725C236.54 339.725 244.293 336.555 250.054 330.896C255.815 325.238 259.125 317.544 259.27 309.47H261.79C261.78 318.304 258.266 326.773 252.019 333.019C245.773 339.266 237.304 342.78 228.47 342.79Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M292.59 342.79C283.756 342.78 275.287 339.266 269.041 333.019C262.795 326.773 259.281 318.304 259.27 309.47H261.79C261.79 317.639 265.035 325.473 270.811 331.249C276.587 337.025 284.421 340.27 292.59 340.27C300.759 340.27 308.593 337.025 314.369 331.249C320.145 325.473 323.39 317.639 323.39 309.47H325.91C325.899 318.304 322.386 326.773 316.139 333.019C309.893 339.266 301.424 342.78 292.59 342.79Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M356.71 342.79C347.876 342.78 339.407 339.266 333.161 333.019C326.915 326.773 323.401 318.304 323.39 309.47H325.91C325.91 317.639 329.155 325.473 334.931 331.249C340.707 337.025 348.541 340.27 356.71 340.27C364.879 340.27 372.713 337.025 378.489 331.249C384.265 325.473 387.51 317.639 387.51 309.47H390C389.99 318.299 386.48 326.763 380.24 333.009C374 339.254 365.539 342.772 356.71 342.79Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M420.83 342.79C411.996 342.78 403.527 339.266 397.281 333.019C391.034 326.773 387.521 318.304 387.51 309.47H390C390.145 317.544 393.455 325.238 399.216 330.896C404.977 336.555 412.73 339.725 420.805 339.725C428.88 339.725 436.633 336.555 442.394 330.896C448.155 325.238 451.465 317.544 451.61 309.47H454.12C454.112 318.299 450.603 326.765 444.363 333.012C438.122 339.258 429.659 342.774 420.83 342.79Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M485 342.79C476.166 342.782 467.695 339.269 461.448 333.022C455.201 326.775 451.688 318.305 451.68 309.47H454.19C454.336 317.544 457.645 325.238 463.406 330.896C469.168 336.555 476.92 339.725 484.995 339.725C493.07 339.725 500.823 336.555 506.584 330.896C512.345 325.238 515.655 317.544 515.8 309.47H518.32C518.31 318.304 514.796 326.773 508.549 333.019C502.303 339.266 493.834 342.78 485 342.79Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M549.08 342.79C540.246 342.78 531.777 339.266 525.531 333.019C519.284 326.773 515.771 318.304 515.76 309.47H518.28C518.28 317.639 521.525 325.473 527.301 331.249C533.077 337.025 540.911 340.27 549.08 340.27C557.249 340.27 565.083 337.025 570.859 331.249C576.635 325.473 579.88 317.639 579.88 309.47H582.4C582.389 318.304 578.876 326.773 572.629 333.019C566.383 339.266 557.914 342.78 549.08 342.79Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M613.2 342.79C604.366 342.78 595.897 339.266 589.651 333.019C583.405 326.773 579.891 318.304 579.88 309.47H582.4C582.4 317.639 585.645 325.473 591.421 331.249C597.197 337.025 605.031 340.27 613.2 340.27C621.369 340.27 629.203 337.025 634.979 331.249C640.755 325.473 644 317.639 644 309.47H646.52C646.512 318.305 642.999 326.775 636.752 333.022C630.505 339.269 622.035 342.782 613.2 342.79Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M66.8901 389.59C58.058 389.579 49.5906 386.067 43.3445 379.823C37.0984 373.578 33.5833 365.112 33.5701 356.28H36.0901C36.2355 364.354 39.545 372.048 45.3062 377.706C51.0675 383.365 58.8199 386.535 66.8951 386.535C74.9703 386.535 82.7227 383.365 88.4839 377.706C94.2451 372.048 97.5546 364.354 97.7001 356.28H100.21C100.199 365.113 96.6853 373.581 90.4386 379.826C84.1919 386.07 75.7229 389.582 66.8901 389.59Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M131 389.59C122.171 389.577 113.707 386.063 107.464 379.819C101.222 373.574 97.7105 365.109 97.7 356.28H100.21C100.355 364.354 103.665 372.048 109.426 377.706C115.187 383.365 122.94 386.535 131.015 386.535C139.09 386.535 146.843 383.365 152.604 377.706C158.365 372.048 161.674 364.354 161.82 356.28H164.34C164.327 365.116 160.809 373.585 154.558 379.83C148.308 386.075 139.835 389.585 131 389.59Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M195.14 389.59C186.308 389.579 177.841 386.067 171.594 379.823C165.348 373.578 161.833 365.112 161.82 356.28H164.34C164.34 364.449 167.585 372.283 173.361 378.059C179.137 383.835 186.971 387.08 195.14 387.08C203.309 387.08 211.143 383.835 216.919 378.059C222.695 372.283 225.94 364.449 225.94 356.28H228.46C228.447 365.112 224.932 373.578 218.686 379.823C212.44 386.067 203.972 389.579 195.14 389.59Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M259.26 389.59C250.428 389.579 241.96 386.067 235.714 379.823C229.468 373.578 225.953 365.112 225.94 356.28H228.46C228.46 364.449 231.705 372.283 237.481 378.059C243.257 383.835 251.091 387.08 259.26 387.08C267.429 387.08 275.263 383.835 281.039 378.059C286.815 372.283 290.06 364.449 290.06 356.28H292.58C292.567 365.112 289.052 373.578 282.806 379.823C276.559 386.067 268.092 389.579 259.26 389.59Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M387.51 389.59C378.677 389.582 370.208 386.07 363.961 379.826C357.715 373.581 354.201 365.113 354.19 356.28H356.71C356.71 364.449 359.955 372.283 365.731 378.059C371.507 383.835 379.341 387.08 387.51 387.08C395.679 387.08 403.513 383.835 409.289 378.059C415.065 372.283 418.31 364.449 418.31 356.28H420.83C420.817 365.112 417.302 373.578 411.056 379.823C404.809 386.067 396.342 389.579 387.51 389.59Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M451.63 389.59C442.798 389.579 434.331 386.067 428.084 379.823C421.838 373.578 418.323 365.112 418.31 356.28H420.83C420.83 364.449 424.075 372.283 429.851 378.059C435.627 383.835 443.461 387.08 451.63 387.08C459.799 387.08 467.633 383.835 473.409 378.059C479.185 372.283 482.43 364.449 482.43 356.28H485C484.987 365.121 481.465 373.595 475.208 379.84C468.951 386.086 460.471 389.593 451.63 389.59Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M515.75 389.59C506.918 389.579 498.451 386.067 492.205 379.823C485.958 373.578 482.443 365.112 482.43 356.28H485C485 360.325 485.797 364.33 487.345 368.067C488.893 371.804 491.161 375.199 494.021 378.059C496.881 380.919 500.277 383.188 504.014 384.736C507.75 386.283 511.755 387.08 515.8 387.08C519.845 387.08 523.85 386.283 527.587 384.736C531.324 383.188 534.719 380.919 537.579 378.059C540.439 375.199 542.708 371.804 544.256 368.067C545.804 364.33 546.6 360.325 546.6 356.28H549.12C549.11 365.122 545.589 373.597 539.331 379.843C533.073 386.09 524.592 389.595 515.75 389.59Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M579.87 389.59C571.038 389.579 562.571 386.067 556.324 379.823C550.078 373.578 546.563 365.112 546.55 356.28H549.07C549.216 364.354 552.525 372.048 558.286 377.706C564.047 383.365 571.8 386.535 579.875 386.535C587.95 386.535 595.703 383.365 601.464 377.706C607.225 372.048 610.535 364.354 610.68 356.28H613.2C613.187 365.114 609.67 373.582 603.422 379.826C597.174 386.071 588.704 389.582 579.87 389.59Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M100.22 436.39C91.3864 436.379 82.9175 432.866 76.671 426.619C70.4246 420.373 66.9107 411.904 66.9001 403.07H69.4201C69.4201 411.239 72.6651 419.073 78.4413 424.849C84.2174 430.625 92.0515 433.87 100.22 433.87C108.389 433.87 116.223 430.625 121.999 424.849C127.775 419.073 131.02 411.239 131.02 403.07H133.54C133.53 411.904 130.016 420.373 123.769 426.619C117.523 432.866 109.054 436.379 100.22 436.39Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M164.34 436.39C155.503 436.385 147.029 432.873 140.778 426.626C134.527 420.379 131.011 411.907 131 403.07H133.52C133.665 411.144 136.975 418.838 142.736 424.496C148.497 430.155 156.25 433.325 164.325 433.325C172.4 433.325 180.153 430.155 185.914 424.496C191.675 418.838 194.985 411.144 195.13 403.07H197.64C197.632 411.901 194.122 420.369 187.879 426.615C181.636 432.861 173.171 436.377 164.34 436.39Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M292.59 436.39C283.756 436.379 275.287 432.866 269.041 426.619C262.795 420.373 259.281 411.904 259.27 403.07H261.79C261.79 411.239 265.035 419.073 270.811 424.849C276.587 430.625 284.421 433.87 292.59 433.87C300.759 433.87 308.593 430.625 314.369 424.849C320.145 419.073 323.39 411.239 323.39 403.07H325.91C325.899 411.904 322.386 420.373 316.139 426.619C309.893 432.866 301.424 436.379 292.59 436.39Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M356.71 436.39C347.876 436.379 339.407 432.866 333.161 426.619C326.915 420.373 323.401 411.904 323.39 403.07H325.91C325.91 411.239 329.155 419.073 334.931 424.849C340.707 430.625 348.541 433.87 356.71 433.87C364.879 433.87 372.713 430.625 378.489 424.849C384.265 419.073 387.51 411.239 387.51 403.07H390C389.99 411.899 386.48 420.363 380.24 426.609C374 432.854 365.539 436.372 356.71 436.39Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M420.83 436.39C411.996 436.379 403.527 432.866 397.281 426.619C391.034 420.373 387.521 411.904 387.51 403.07H390C390.145 411.144 393.455 418.838 399.216 424.496C404.977 430.155 412.73 433.325 420.805 433.325C428.88 433.325 436.633 430.155 442.394 424.496C448.155 418.838 451.465 411.144 451.61 403.07H454.12C454.112 411.899 450.603 420.365 444.363 426.612C438.122 432.858 429.659 436.374 420.83 436.39Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M485 436.39C476.166 436.382 467.695 432.869 461.448 426.622C455.201 420.375 451.688 411.905 451.68 403.07H454.19C454.336 411.144 457.645 418.838 463.406 424.496C469.168 430.155 476.92 433.325 484.995 433.325C493.07 433.325 500.823 430.155 506.584 424.496C512.345 418.838 515.655 411.144 515.8 403.07H518.32C518.31 411.904 514.796 420.373 508.549 426.619C502.303 432.866 493.834 436.379 485 436.39Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M549.08 436.39C540.246 436.379 531.777 432.866 525.531 426.619C519.284 420.373 515.771 411.904 515.76 403.07H518.28C518.28 411.239 521.525 419.073 527.301 424.849C533.077 430.625 540.911 433.87 549.08 433.87C557.249 433.87 565.083 430.625 570.859 424.849C576.635 419.073 579.88 411.239 579.88 403.07H582.4C582.389 411.904 578.876 420.373 572.629 426.619C566.383 432.866 557.914 436.379 549.08 436.39Z",
                fill: "#003C71"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-illustrations-virtual-f4c8d3dc38/1/packages/lib-illustrations/src/byggingakrani.tsx
/* eslint-disable max-len */ 

const ByggingakraniIllustration = (param)=>{
    let { size =200  } = param;
    return /*#__PURE__*/ _jsxs("svg", {
        fill: "none",
        height: size,
        viewBox: "0 0 662 611",
        width: size,
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M469.85 100.77H441.29V143.83H469.85V100.77Z",
                fill: "#0067A5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M116.03 221.51H83.5901C80.7679 221.51 78.4801 223.798 78.4801 226.62V239.66C78.4801 242.482 80.7679 244.77 83.5901 244.77H116.03C118.852 244.77 121.14 242.482 121.14 239.66V226.62C121.14 223.798 118.852 221.51 116.03 221.51Z",
                fill: "#D9D9D9"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M160.51 221.51H128.07C125.248 221.51 122.96 223.798 122.96 226.62V239.66C122.96 242.482 125.248 244.77 128.07 244.77H160.51C163.332 244.77 165.62 242.482 165.62 239.66V226.62C165.62 223.798 163.332 221.51 160.51 221.51Z",
                fill: "#D9D9D9"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M204.99 221.51H172.55C169.728 221.51 167.44 223.798 167.44 226.62V239.66C167.44 242.482 169.728 244.77 172.55 244.77H204.99C207.812 244.77 210.1 242.482 210.1 239.66V226.62C210.1 223.798 207.812 221.51 204.99 221.51Z",
                fill: "#D9D9D9"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M249.47 221.51H217.03C214.208 221.51 211.92 223.798 211.92 226.62V239.66C211.92 242.482 214.208 244.77 217.03 244.77H249.47C252.292 244.77 254.58 242.482 254.58 239.66V226.62C254.58 223.798 252.292 221.51 249.47 221.51Z",
                fill: "#D9D9D9"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M138.27 246.57H105.83C103.008 246.57 100.72 248.858 100.72 251.68V264.72C100.72 267.542 103.008 269.83 105.83 269.83H138.27C141.092 269.83 143.38 267.542 143.38 264.72V251.68C143.38 248.858 141.092 246.57 138.27 246.57Z",
                fill: "#D9D9D9"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M182.75 246.57H150.31C147.488 246.57 145.2 248.858 145.2 251.68V264.72C145.2 267.542 147.488 269.83 150.31 269.83H182.75C185.572 269.83 187.86 267.542 187.86 264.72V251.68C187.86 248.858 185.572 246.57 182.75 246.57Z",
                fill: "#D9D9D9"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M227.23 246.57H194.79C191.968 246.57 189.68 248.858 189.68 251.68V264.72C189.68 267.542 191.968 269.83 194.79 269.83H227.23C230.052 269.83 232.34 267.542 232.34 264.72V251.68C232.34 248.858 230.052 246.57 227.23 246.57Z",
                fill: "#D9D9D9"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M271.71 246.57H239.27C236.448 246.57 234.16 248.858 234.16 251.68V264.72C234.16 267.542 236.448 269.83 239.27 269.83H271.71C274.532 269.83 276.82 267.542 276.82 264.72V251.68C276.82 248.858 274.532 246.57 271.71 246.57Z",
                fill: "#D9D9D9"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M116.03 271.62H83.5901C80.7679 271.62 78.4801 273.908 78.4801 276.73V289.77C78.4801 292.592 80.7679 294.88 83.5901 294.88H116.03C118.852 294.88 121.14 292.592 121.14 289.77V276.73C121.14 273.908 118.852 271.62 116.03 271.62Z",
                fill: "#D9D9D9"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M160.51 271.62H128.07C125.248 271.62 122.96 273.908 122.96 276.73V289.77C122.96 292.592 125.248 294.88 128.07 294.88H160.51C163.332 294.88 165.62 292.592 165.62 289.77V276.73C165.62 273.908 163.332 271.62 160.51 271.62Z",
                fill: "#D9D9D9"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M204.99 271.62H172.55C169.728 271.62 167.44 273.908 167.44 276.73V289.77C167.44 292.592 169.728 294.88 172.55 294.88H204.99C207.812 294.88 210.1 292.592 210.1 289.77V276.73C210.1 273.908 207.812 271.62 204.99 271.62Z",
                fill: "#D9D9D9"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M249.47 271.62H217.03C214.208 271.62 211.92 273.908 211.92 276.73V289.77C211.92 292.592 214.208 294.88 217.03 294.88H249.47C252.292 294.88 254.58 292.592 254.58 289.77V276.73C254.58 273.908 252.292 271.62 249.47 271.62Z",
                fill: "#D9D9D9"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M138.27 296.68H105.83C103.008 296.68 100.72 298.968 100.72 301.79V314.83C100.72 317.652 103.008 319.94 105.83 319.94H138.27C141.092 319.94 143.38 317.652 143.38 314.83V301.79C143.38 298.968 141.092 296.68 138.27 296.68Z",
                fill: "#D9D9D9"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M182.75 296.68H150.31C147.488 296.68 145.2 298.968 145.2 301.79V314.83C145.2 317.652 147.488 319.94 150.31 319.94H182.75C185.572 319.94 187.86 317.652 187.86 314.83V301.79C187.86 298.968 185.572 296.68 182.75 296.68Z",
                fill: "#D9D9D9"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M116.03 321.77H83.5901C80.7679 321.77 78.4801 324.058 78.4801 326.88V339.92C78.4801 342.742 80.7679 345.03 83.5901 345.03H116.03C118.852 345.03 121.14 342.742 121.14 339.92V326.88C121.14 324.058 118.852 321.77 116.03 321.77Z",
                fill: "#D9D9D9"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M160.51 321.77H128.07C125.248 321.77 122.96 324.058 122.96 326.88V339.92C122.96 342.742 125.248 345.03 128.07 345.03H160.51C163.332 345.03 165.62 342.742 165.62 339.92V326.88C165.62 324.058 163.332 321.77 160.51 321.77Z",
                fill: "#D9D9D9"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M204.99 321.77H172.55C169.728 321.77 167.44 324.058 167.44 326.88V339.92C167.44 342.742 169.728 345.03 172.55 345.03H204.99C207.812 345.03 210.1 342.742 210.1 339.92V326.88C210.1 324.058 207.812 321.77 204.99 321.77Z",
                fill: "#D9D9D9"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M138.27 346.82H105.83C103.008 346.82 100.72 349.108 100.72 351.93V364.97C100.72 367.792 103.008 370.08 105.83 370.08H138.27C141.092 370.08 143.38 367.792 143.38 364.97V351.93C143.38 349.108 141.092 346.82 138.27 346.82Z",
                fill: "#D9D9D9"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M182.75 346.82H150.31C147.488 346.82 145.2 349.108 145.2 351.93V364.97C145.2 367.792 147.488 370.08 150.31 370.08H182.75C185.572 370.08 187.86 367.792 187.86 364.97V351.93C187.86 349.108 185.572 346.82 182.75 346.82Z",
                fill: "#D9D9D9"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M116.03 371.88H83.5901C80.7679 371.88 78.4801 374.168 78.4801 376.99V390.03C78.4801 392.852 80.7679 395.14 83.5901 395.14H116.03C118.852 395.14 121.14 392.852 121.14 390.03V376.99C121.14 374.168 118.852 371.88 116.03 371.88Z",
                fill: "#D9D9D9"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M204.99 371.88H172.55C169.728 371.88 167.44 374.168 167.44 376.99V390.03C167.44 392.852 169.728 395.14 172.55 395.14H204.99C207.812 395.14 210.1 392.852 210.1 390.03V376.99C210.1 374.168 207.812 371.88 204.99 371.88Z",
                fill: "#D9D9D9"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M158.59 374.63C159.725 374.63 160.814 375.081 161.617 375.884C162.419 376.686 162.87 377.775 162.87 378.91V388.1C162.87 389.236 162.42 390.326 161.617 391.13C160.815 391.934 159.726 392.387 158.59 392.39H130C128.863 392.387 127.774 391.935 126.97 391.131C126.166 390.327 125.713 389.237 125.71 388.1V378.91C125.713 377.774 126.166 376.685 126.97 375.883C127.774 375.081 128.864 374.63 130 374.63H158.59ZM158.59 371.88H130C128.144 371.88 126.363 372.618 125.05 373.93C123.738 375.243 123 377.023 123 378.88V388.07C123 389.927 123.738 391.707 125.05 393.02C126.363 394.333 128.144 395.07 130 395.07H158.59C160.447 395.07 162.227 394.333 163.54 393.02C164.853 391.707 165.59 389.927 165.59 388.07V378.88C165.59 377.023 164.853 375.243 163.54 373.93C162.227 372.618 160.447 371.88 158.59 371.88Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M138.27 396.93H105.83C103.008 396.93 100.72 399.218 100.72 402.04V415.08C100.72 417.902 103.008 420.19 105.83 420.19H138.27C141.092 420.19 143.38 417.902 143.38 415.08V402.04C143.38 399.218 141.092 396.93 138.27 396.93Z",
                fill: "#D9D9D9"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M182.75 396.93H150.31C147.488 396.93 145.2 399.218 145.2 402.04V415.08C145.2 417.902 147.488 420.19 150.31 420.19H182.75C185.572 420.19 187.86 417.902 187.86 415.08V402.04C187.86 399.218 185.572 396.93 182.75 396.93Z",
                fill: "#D9D9D9"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M259.94 418.57C250.068 417.099 240.437 414.318 231.3 410.3C244.3 402.19 251.72 392.3 248.3 374.77C242.89 347.22 282.01 368.69 282.01 368.69C282.01 368.69 277.01 400.45 302.14 413.91L302.86 414.29C293.41 418 278.67 421.57 259.94 418.57Z",
                fill: "#FDC498"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M291.72 366C291.72 366 290.66 395.47 266.17 395C239.39 394.48 239.17 365.55 239.17 365.55L291.72 366Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M290.13 347C290.13 347 302.42 345 302.82 353.74C303.06 359.13 295.24 362.39 290.61 360.9C285.98 359.41 290.13 347 290.13 347Z",
                fill: "#FDC498"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M239.65 346C239.65 346 230.14 342.54 228.51 349.79C227.32 355.05 234.14 359.79 238.98 359.29C243.82 358.79 239.65 346 239.65 346Z",
                fill: "#FDC498"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M295.62 336.17C295.62 336.17 299.4 385.3 268.14 387.29C236.88 389.28 234.76 348.13 235.03 337.13L295.62 336.17Z",
                fill: "#FDC498"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M253.8 352.64C254.651 352.64 255.34 351.951 255.34 351.1C255.34 350.249 254.651 349.56 253.8 349.56C252.95 349.56 252.26 350.249 252.26 351.1C252.26 351.951 252.95 352.64 253.8 352.64Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M275.98 353.76C276.831 353.76 277.52 353.071 277.52 352.22C277.52 351.369 276.831 350.68 275.98 350.68C275.13 350.68 274.44 351.369 274.44 352.22C274.44 353.071 275.13 353.76 275.98 353.76Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M239.21 365.58C239.21 365.58 250.83 365.34 263.95 365.58C277.07 365.82 292.19 365.98 292.19 365.98C292.19 365.98 289.24 395.65 267.51 394.98C248.88 394.48 239.44 374.89 239.21 365.58Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M265.97 348.62C262.24 348.05 262.56 353.52 260.84 356.89C259.12 360.26 256.51 359.77 255.43 361.89C254.35 364.01 256.96 365.89 258.62 366.17C260.28 366.45 261.75 369.53 266.15 367.17C270.15 365.04 272.15 365.93 272.64 363.47C273.41 359.31 268.64 360.29 268.35 355.6C268.1 352.12 268.37 349 265.97 348.62Z",
                fill: "#FFEEE0"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M266.17 306.09C262.012 306.09 257.896 306.909 254.054 308.5C250.213 310.091 246.723 312.423 243.783 315.363C240.843 318.303 238.511 321.793 236.92 325.634C235.329 329.475 234.51 333.592 234.51 337.75H297.82C297.82 329.355 294.486 321.304 288.551 315.367C282.615 309.429 274.565 306.093 266.17 306.09Z",
                fill: "#FFD400"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M300.64 336.73H231.94V342.39H300.64V336.73Z",
                fill: "#FFE770"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M231.94 342.39C231.94 342.39 242.2 346.8 266.17 346.8C290.14 346.8 300.64 342.39 300.64 342.39H231.94Z",
                fill: "#FF7D20"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M274.44 301.67H258.05V323.26H274.44V301.67Z",
                fill: "#FFD400"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M249.98 308.85C249.91 308.85 258.05 321.56 258.05 321.56V305.45L249.98 308.85Z",
                fill: "#FF7D20"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M282.51 308.85C282.58 308.85 274.44 321.56 274.44 321.56V305.45L282.51 308.85Z",
                fill: "#FF7D20"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M184.47 483.74C184.47 483.74 189.47 417.31 231.27 410.3C273.07 403.29 302.81 414.3 302.81 414.3C302.81 414.3 338.65 427.67 340.35 483.75L184.47 483.74Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M235.41 407.97H221.83V483.74H235.41V407.97Z",
                fill: "#FFD400"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M309.79 407.97H296.21V483.74H309.79V407.97Z",
                fill: "#FFD400"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M300.64 433.18H228.37V483.74H300.64V433.18Z",
                fill: "#FFD400"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M364.84 483.15H165.42V485.9H364.84V483.15Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M284.08 447.81H251.45C247.255 447.805 243.233 446.139 240.262 443.176C237.292 440.213 235.616 436.195 235.6 432V408H238.35V432C238.353 435.474 239.734 438.804 242.19 441.26C244.646 443.716 247.977 445.097 251.45 445.1H284.08V447.81Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M437.24 548.29C488.52 548.29 530.09 506.72 530.09 455.44C530.09 404.16 488.52 362.59 437.24 362.59C385.961 362.59 344.39 404.16 344.39 455.44C344.39 506.72 385.961 548.29 437.24 548.29Z",
                fill: "#E5E5E5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M486.75 401.75C485.197 401.752 483.678 401.293 482.385 400.431C481.093 399.569 480.085 398.343 479.49 396.909C478.894 395.474 478.738 393.895 479.04 392.371C479.343 390.847 480.091 389.448 481.189 388.349C482.288 387.251 483.687 386.503 485.211 386.2C486.735 385.898 488.314 386.054 489.749 386.649C491.184 387.245 492.41 388.253 493.271 389.545C494.133 390.837 494.592 392.357 494.59 393.91C494.587 395.988 493.761 397.981 492.291 399.451C490.821 400.921 488.829 401.747 486.75 401.75ZM486.75 388.81C485.741 388.808 484.754 389.105 483.914 389.665C483.074 390.224 482.419 391.02 482.031 391.951C481.644 392.883 481.541 393.909 481.737 394.899C481.933 395.889 482.418 396.798 483.13 397.513C483.843 398.227 484.752 398.714 485.741 398.911C486.731 399.109 487.757 399.008 488.69 398.623C489.622 398.237 490.419 397.583 490.98 396.744C491.541 395.906 491.84 394.919 491.84 393.91C491.838 392.56 491.301 391.266 490.347 390.31C489.393 389.355 488.1 388.815 486.75 388.81Z",
                fill: "#989898"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M426.04 373.32C424.487 373.322 422.968 372.863 421.676 372.002C420.384 371.141 419.376 369.915 418.781 368.481C418.185 367.047 418.028 365.468 418.33 363.945C418.632 362.421 419.378 361.022 420.476 359.923C421.573 358.824 422.972 358.075 424.495 357.772C426.018 357.468 427.597 357.623 429.032 358.217C430.467 358.81 431.694 359.817 432.557 361.108C433.42 362.399 433.88 363.917 433.88 365.47C433.878 367.549 433.051 369.543 431.582 371.014C430.112 372.486 428.12 373.315 426.04 373.32ZM426.04 360.38C425.031 360.378 424.043 360.676 423.203 361.235C422.363 361.795 421.708 362.591 421.32 363.524C420.933 364.456 420.831 365.482 421.028 366.472C421.224 367.463 421.71 368.372 422.424 369.086C423.138 369.8 424.047 370.286 425.038 370.482C426.028 370.679 427.054 370.577 427.986 370.19C428.919 369.803 429.715 369.147 430.275 368.307C430.834 367.467 431.132 366.48 431.13 365.47C431.128 364.121 430.59 362.828 429.636 361.874C428.682 360.92 427.389 360.383 426.04 360.38Z",
                fill: "#989898"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M423.2 413.52C422.1 413.52 421.025 413.194 420.11 412.582C419.196 411.971 418.483 411.102 418.062 410.085C417.642 409.069 417.532 407.95 417.748 406.872C417.963 405.793 418.494 404.802 419.272 404.025C420.051 403.248 421.042 402.719 422.122 402.506C423.201 402.292 424.319 402.404 425.335 402.826C426.351 403.248 427.218 403.963 427.828 404.878C428.438 405.794 428.762 406.87 428.76 407.97C428.757 409.443 428.171 410.855 427.128 411.895C426.086 412.936 424.673 413.52 423.2 413.52ZM423.2 405.16C422.644 405.16 422.101 405.325 421.639 405.634C421.177 405.942 420.817 406.381 420.604 406.895C420.391 407.408 420.336 407.973 420.444 408.518C420.553 409.063 420.82 409.564 421.213 409.957C421.606 410.35 422.107 410.618 422.652 410.726C423.197 410.834 423.762 410.779 424.275 410.566C424.789 410.353 425.228 409.993 425.537 409.531C425.845 409.069 426.01 408.526 426.01 407.97C426.01 407.225 425.714 406.51 425.187 405.983C424.66 405.456 423.945 405.16 423.2 405.16Z",
                fill: "#989898"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M355.91 416.31C354.812 416.31 353.739 415.984 352.827 415.375C351.914 414.765 351.203 413.898 350.783 412.884C350.363 411.87 350.253 410.754 350.467 409.677C350.681 408.601 351.209 407.612 351.986 406.836C352.762 406.059 353.751 405.531 354.827 405.317C355.904 405.102 357.02 405.212 358.034 405.632C359.048 406.053 359.915 406.764 360.525 407.677C361.135 408.589 361.46 409.662 361.46 410.76C361.455 412.23 360.868 413.639 359.829 414.679C358.789 415.718 357.38 416.305 355.91 416.31ZM355.91 407.96C355.356 407.96 354.815 408.124 354.355 408.432C353.894 408.74 353.535 409.177 353.323 409.688C353.111 410.2 353.056 410.763 353.164 411.306C353.272 411.849 353.539 412.348 353.93 412.74C354.322 413.131 354.821 413.398 355.364 413.506C355.907 413.614 356.47 413.559 356.982 413.347C357.493 413.135 357.931 412.776 358.238 412.316C358.546 411.855 358.71 411.314 358.71 410.76C358.7 410.024 358.4 409.322 357.876 408.806C357.352 408.289 356.646 408 355.91 408V407.96Z",
                fill: "#989898"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M411.29 385.23C413.599 385.23 415.47 383.359 415.47 381.05C415.47 378.741 413.599 376.87 411.29 376.87C408.982 376.87 407.11 378.741 407.11 381.05C407.11 383.359 408.982 385.23 411.29 385.23Z",
                fill: "white"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M375.01 399.49C378.219 399.49 380.82 396.889 380.82 393.68C380.82 390.471 378.219 387.87 375.01 387.87C371.801 387.87 369.2 390.471 369.2 393.68C369.2 396.889 371.801 399.49 375.01 399.49Z",
                fill: "white"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M448.51 410.76C450.819 410.76 452.69 408.889 452.69 406.58C452.69 404.271 450.819 402.4 448.51 402.4C446.202 402.4 444.33 404.271 444.33 406.58C444.33 408.889 446.202 410.76 448.51 410.76Z",
                fill: "white"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M399.1 410.55C400.707 410.55 402.01 409.247 402.01 407.64C402.01 406.033 400.707 404.73 399.1 404.73C397.493 404.73 396.19 406.033 396.19 407.64C396.19 409.247 397.493 410.55 399.1 410.55Z",
                fill: "white"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M493.29 430.13C494.897 430.13 496.2 428.827 496.2 427.22C496.2 425.613 494.897 424.31 493.29 424.31C491.683 424.31 490.38 425.613 490.38 427.22C490.38 428.827 491.683 430.13 493.29 430.13Z",
                fill: "white"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M347.87 393.21C354.995 393.21 360.77 387.434 360.77 380.31C360.77 373.186 354.995 367.41 347.87 367.41C340.746 367.41 334.97 373.186 334.97 380.31C334.97 387.434 340.746 393.21 347.87 393.21Z",
                fill: "#E5E5E5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M393.93 513.62C409.996 513.62 423.02 500.596 423.02 484.53C423.02 468.464 409.996 455.44 393.93 455.44C377.864 455.44 364.84 468.464 364.84 484.53C364.84 500.596 377.864 513.62 393.93 513.62Z",
                fill: "white"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M369.67 446.63C371.841 446.63 373.6 444.87 373.6 442.7C373.6 440.53 371.841 438.77 369.67 438.77C367.5 438.77 365.74 440.53 365.74 442.7C365.74 444.87 367.5 446.63 369.67 446.63Z",
                fill: "white"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M437.63 438.86C439.42 438.86 440.87 437.409 440.87 435.62C440.87 433.831 439.42 432.38 437.63 432.38C435.841 432.38 434.39 433.831 434.39 435.62C434.39 437.409 435.841 438.86 437.63 438.86Z",
                fill: "white"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M449.75 454.73C451.54 454.73 452.99 453.279 452.99 451.49C452.99 449.701 451.54 448.25 449.75 448.25C447.961 448.25 446.51 449.701 446.51 451.49C446.51 453.279 447.961 454.73 449.75 454.73Z",
                fill: "white"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M414.97 453.99C417.002 453.99 418.65 452.342 418.65 450.31C418.65 448.278 417.002 446.63 414.97 446.63C412.938 446.63 411.29 448.278 411.29 450.31C411.29 452.342 412.938 453.99 414.97 453.99Z",
                fill: "white"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M351.55 450.32C353.583 450.32 355.23 448.672 355.23 446.64C355.23 444.608 353.583 442.96 351.55 442.96C349.518 442.96 347.87 444.608 347.87 446.64C347.87 448.672 349.518 450.32 351.55 450.32Z",
                fill: "white"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M401.2 473.74C402.36 473.74 403.3 472.8 403.3 471.64C403.3 470.48 402.36 469.54 401.2 469.54C400.04 469.54 399.1 470.48 399.1 471.64C399.1 472.8 400.04 473.74 401.2 473.74Z",
                fill: "white"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M473.77 453.99C476.647 453.99 478.98 451.657 478.98 448.78C478.98 445.903 476.647 443.57 473.77 443.57C470.893 443.57 468.56 445.903 468.56 448.78C468.56 451.657 470.893 453.99 473.77 453.99Z",
                fill: "white"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M375.01 481.84C378.18 481.84 380.75 479.27 380.75 476.1C380.75 472.93 378.18 470.36 375.01 470.36C371.84 470.36 369.27 472.93 369.27 476.1C369.27 479.27 371.84 481.84 375.01 481.84Z",
                fill: "white"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M462.01 424.26C461.098 424.26 460.207 423.99 459.449 423.483C458.691 422.977 458.1 422.257 457.751 421.414C457.402 420.572 457.311 419.645 457.489 418.751C457.667 417.856 458.106 417.035 458.75 416.39C459.395 415.746 460.217 415.306 461.111 415.129C462.005 414.951 462.932 415.042 463.774 415.391C464.617 415.74 465.337 416.331 465.843 417.089C466.35 417.847 466.62 418.738 466.62 419.65C466.62 420.255 466.501 420.855 466.269 421.414C466.038 421.974 465.698 422.482 465.27 422.91C464.842 423.338 464.334 423.677 463.774 423.909C463.215 424.141 462.616 424.26 462.01 424.26ZM462.01 417.79C461.642 417.79 461.283 417.899 460.977 418.103C460.671 418.308 460.433 418.598 460.292 418.938C460.151 419.278 460.114 419.652 460.186 420.013C460.258 420.374 460.435 420.705 460.695 420.965C460.955 421.225 461.286 421.403 461.647 421.474C462.008 421.546 462.382 421.509 462.722 421.368C463.062 421.228 463.352 420.989 463.557 420.683C463.761 420.377 463.87 420.018 463.87 419.65C463.87 419.157 463.674 418.684 463.325 418.335C462.977 417.986 462.503 417.79 462.01 417.79Z",
                fill: "#989898"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M405.66 436.74C404.505 436.74 403.375 436.397 402.414 435.755C401.454 435.113 400.705 434.2 400.264 433.133C399.822 432.065 399.707 430.89 399.933 429.757C400.159 428.624 400.716 427.583 401.534 426.767C402.352 425.951 403.393 425.395 404.527 425.171C405.66 424.947 406.835 425.064 407.902 425.507C408.969 425.951 409.88 426.701 410.521 427.663C411.161 428.624 411.502 429.755 411.5 430.91C411.497 432.457 410.881 433.94 409.786 435.033C408.691 436.126 407.207 436.74 405.66 436.74ZM405.66 427.82C405.049 427.82 404.451 428.001 403.943 428.341C403.435 428.68 403.039 429.163 402.805 429.728C402.571 430.292 402.51 430.913 402.629 431.513C402.749 432.112 403.043 432.663 403.475 433.095C403.907 433.527 404.458 433.821 405.057 433.941C405.657 434.06 406.278 433.999 406.843 433.765C407.407 433.531 407.89 433.135 408.229 432.627C408.569 432.119 408.75 431.521 408.75 430.91C408.75 430.09 408.424 429.305 407.845 428.725C407.266 428.146 406.48 427.82 405.66 427.82Z",
                fill: "#989898"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M388.64 373.94C387.819 373.94 387.016 373.696 386.333 373.24C385.651 372.783 385.119 372.135 384.805 371.376C384.491 370.617 384.41 369.782 384.571 368.977C384.732 368.171 385.128 367.432 385.709 366.852C386.291 366.272 387.031 365.878 387.837 365.719C388.642 365.56 389.477 365.643 390.235 365.959C390.993 366.274 391.641 366.808 392.096 367.492C392.55 368.175 392.792 368.979 392.79 369.8C392.787 370.899 392.349 371.952 391.571 372.728C390.793 373.504 389.739 373.94 388.64 373.94ZM388.64 368.4C388.363 368.4 388.093 368.482 387.862 368.636C387.632 368.79 387.453 369.008 387.347 369.264C387.241 369.52 387.213 369.802 387.267 370.073C387.321 370.345 387.454 370.594 387.65 370.79C387.846 370.986 388.095 371.119 388.367 371.173C388.639 371.227 388.92 371.199 389.176 371.093C389.432 370.987 389.65 370.808 389.804 370.578C389.958 370.348 390.04 370.077 390.04 369.8C390.04 369.429 389.893 369.073 389.63 368.81C389.368 368.548 389.011 368.4 388.64 368.4Z",
                fill: "#989898"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M210.11 295.3H107.76V298.05H210.11V295.3Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M246.37 247.94H166.53V245.19H246.37C248.342 245.19 250.233 244.408 251.628 243.014C253.022 241.621 253.808 239.731 253.81 237.76V230.32C253.808 228.349 253.022 226.459 251.628 225.066C250.233 223.672 248.342 222.89 246.37 222.89H235.01V220.14H246.37C249.07 220.143 251.659 221.216 253.569 223.124C255.479 225.032 256.555 227.62 256.56 230.32V237.76C256.555 240.46 255.479 243.048 253.569 244.956C251.659 246.864 249.07 247.937 246.37 247.94Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M212.39 228.55H209.64V237.75H212.39V228.55Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M168.22 228.55H165.47V237.75H168.22V228.55Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M122.91 278.65H120.16V287.85H122.91V278.65Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M167.91 278.65H165.16V287.85H167.91V278.65Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M123.7 228.55H120.95V237.75H123.7V228.55Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M145.21 344.05H99.4501V346.8H145.21V344.05Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M397.23 503.75H394.48V470.84C394.48 469.221 393.838 467.669 392.694 466.523C391.55 465.378 389.999 464.733 388.38 464.73C386.034 464.727 383.784 463.794 382.125 462.135C380.466 460.476 379.533 458.226 379.53 455.88V439.24H382.3V455.88C382.303 457.497 382.946 459.047 384.09 460.19C385.233 461.334 386.783 461.977 388.4 461.98C390.747 461.985 392.997 462.921 394.656 464.581C396.315 466.242 397.248 468.493 397.25 470.84L397.23 503.75Z",
                fill: "#0067A5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M402.47 440.62L386.47 408.62C385.955 407.59 385.164 406.724 384.184 406.119C383.205 405.514 382.076 405.194 380.925 405.194C379.774 405.194 378.645 405.514 377.666 406.119C376.687 406.724 375.895 407.59 375.38 408.62L359.38 440.62C358.901 441.567 358.673 442.62 358.717 443.68C358.762 444.74 359.078 445.771 359.635 446.674C360.191 447.577 360.971 448.322 361.898 448.838C362.825 449.354 363.869 449.623 364.93 449.62H396.93C397.99 449.621 399.033 449.351 399.959 448.835C400.885 448.318 401.663 447.573 402.218 446.67C402.774 445.767 403.089 444.737 403.133 443.678C403.177 442.619 402.949 441.566 402.47 440.62Z",
                fill: "#408DBC"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M397.23 474.91H394.21C391.979 474.91 390.17 476.719 390.17 478.95V499.7C390.17 501.931 391.979 503.74 394.21 503.74H397.23C399.461 503.74 401.27 501.931 401.27 499.7V478.95C401.27 476.719 399.461 474.91 397.23 474.91Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M445.93 162.42H443.18V394.02H445.93V162.42Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M471.23 162.42H468.48V394.02H471.23V162.42Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M541.3 164.9H317.98V150L346.3 136.85H541.3V164.9ZM320.73 162.15H538.55V139.6H346.93L320.73 151.75V162.15Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M362.85 164.81H360.1V227.52H362.85V164.81Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M350.98 241.15L348.89 239.37L361.67 224.29L374.08 239.31L371.96 241.06L361.65 228.58L350.98 241.15Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M420.49 238.84H303.93V253.31H420.49V238.84Z",
                fill: "#63A2C8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M420.49 256H303.93V270.47H420.49V256Z",
                fill: "#63A2C8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M354.988 137.198L353.182 139.271L382.22 164.566L384.026 162.493L354.988 137.198Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M392.711 137.188L390.905 139.262L419.942 164.557L421.749 162.484L392.711 137.188Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M430.438 137.187L428.631 139.26L457.669 164.555L459.475 162.482L430.438 137.187Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M444.958 180.415L443.151 182.488L468.939 204.953L470.745 202.879L444.958 180.415Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M444.963 212.1L443.156 214.174L468.944 236.638L470.75 234.565L444.963 212.1Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M444.968 243.786L443.161 245.859L468.949 268.324L470.755 266.25L444.968 243.786Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M444.965 275.465L443.159 277.538L468.946 300.003L470.753 297.929L444.965 275.465Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M444.96 307.16L443.154 309.234L468.941 331.698L470.748 329.625L444.96 307.16Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M444.966 338.483L443.16 340.556L468.947 363.021L470.754 360.947L444.966 338.483Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M444.962 369.795L443.156 371.869L468.943 394.333L470.75 392.26L444.962 369.795Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M468.171 137.197L466.364 139.271L495.402 164.566L497.208 162.493L468.171 137.197Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M505.897 137.196L504.091 139.269L533.128 164.564L534.934 162.491L505.897 137.196Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M469.85 138.23H420.85V162.43H469.85V138.23Z",
                fill: "#0067A5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M471.23 163.8H419.48V136.8H471.23V163.8ZM422.23 161.05H468.48V139.6H422.23V161.05Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M433.35 269.09H291.6V271.84H433.35V269.09Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M317.13 238.84H314.38V268.84H317.13V238.84Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M362.85 238.84H360.1V268.84H362.85V238.84Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M408.57 238.84H405.82V268.84H408.57V238.84Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M602.17 363.94H485.61V378.41H602.17V363.94Z",
                fill: "#63A2C8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M602.17 381.1H485.61V395.57H602.17V381.1Z",
                fill: "#63A2C8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M498.81 363.94H496.06V393.94H498.81V363.94Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M544.53 363.94H541.78V393.94H544.53V363.94Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M590.24 363.94H587.49V393.94H590.24V363.94Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M602.17 329.61H485.61V344.08H602.17V329.61Z",
                fill: "#63A2C8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M602.17 346.78H485.61V361.25H602.17V346.78Z",
                fill: "#63A2C8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M498.81 329.61H496.06V359.61H498.81V329.61Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M544.53 329.61H541.78V359.61H544.53V329.61Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M590.24 329.61H587.49V359.61H590.24V329.61Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M481.5 393.4H417.02V396.15H481.5V393.4Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M441.29 100.77H469.85V138.23",
                fill: "#0067A5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M471.23 138.23H468.48V102.14H441.29V99.39H471.23V138.23Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M451.05 83.73H448.3V118.06H451.05V83.73Z",
                fill: "#003C71"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-illustrations-virtual-f4c8d3dc38/1/packages/lib-illustrations/src/dreyma.tsx
/* eslint-disable max-len */ 

const DreymaIllustration = (param)=>{
    let { size =200  } = param;
    return /*#__PURE__*/ _jsxs("svg", {
        fill: "none",
        height: size,
        viewBox: "0 0 663 611",
        width: size,
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M400.22 448.26C470.609 448.26 527.67 391.199 527.67 320.81C527.67 250.421 470.609 193.36 400.22 193.36C329.831 193.36 272.77 250.421 272.77 320.81C272.77 391.199 329.831 448.26 400.22 448.26Z",
                fill: "#E5E5E5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M342.16 405.7C342.16 405.7 312.58 369.81 300.26 348.7C294.26 338.35 303.12 338.53 310.75 347.91C318.38 357.29 338.9 354.29 338.9 354.29C338.9 354.29 345.53 362.53 367.9 382.64C387.78 400.52 342.16 405.7 342.16 405.7Z",
                fill: "white"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M340.65 356.14C339.424 354.823 338.372 353.355 337.52 351.77C335.437 347.917 333.578 343.947 331.95 339.88C331.738 339.337 331.366 338.871 330.882 338.544C330.399 338.218 329.828 338.047 329.244 338.053C328.661 338.06 328.094 338.244 327.618 338.581C327.142 338.918 326.78 339.392 326.58 339.94C324.94 344.5 325.64 350.86 329.07 356.05C332.84 361.77 342.47 363.49 342.47 363.49L345.98 361.88L340.65 356.14Z",
                fill: "white"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M330.13 380.61L317.13 364.61L332.13 353.1L337.45 360.68C342.54 367.84 334.44 377.89 330.13 380.61Z",
                fill: "#B8D4E6"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M317.336 335.557L305.677 343.75C304.751 344.401 304.528 345.68 305.179 346.606L322.475 371.216C323.126 372.143 324.405 372.366 325.331 371.715L336.99 363.521C337.916 362.87 338.139 361.591 337.488 360.665L320.192 336.055C319.541 335.129 318.262 334.906 317.336 335.557Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M317.093 337.041L307.169 344.016C306.306 344.623 306.098 345.814 306.705 346.677L322.891 369.708C323.498 370.571 324.689 370.779 325.552 370.172L335.476 363.197C336.339 362.591 336.547 361.4 335.941 360.537L319.754 337.506C319.148 336.643 317.956 336.435 317.093 337.041Z",
                fill: "#408DBC"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M310.398 342.112L318.131 336.642L318.531 337.208C318.655 337.384 318.705 337.603 318.668 337.815C318.632 338.028 318.513 338.218 318.336 338.342L311.932 342.872C311.756 342.997 311.538 343.046 311.325 343.01C311.112 342.973 310.923 342.854 310.798 342.678L310.398 342.112Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M424.46 353.29C422.8 350.23 428.04 346.83 425.24 346.64L421.94 344.01C421.096 343.891 420.265 343.69 419.46 343.41C417.63 342.73 416.24 341.68 415.81 339.77L411.42 320.14L388.78 328.25C388.78 328.25 396.46 343.41 387.78 343.41C383.38 343.41 379.41 344 374.4 350.06L424.46 353.29Z",
                fill: "white"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M380.9 305.35C380.9 305.35 371.46 313.47 371.01 325.51C370.92 329.79 376.67 327.89 377.79 327.18C378.24 331.96 381.71 336.92 388.11 336.95C394.51 336.98 407.9 325.61 409.26 318.48C410.62 311.35 397.52 293.04 380.9 305.35Z",
                fill: "white"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M407.37 301.2C400.22 291.32 386.18 293.35 379.7 297.31C375.89 299.79 371.04 298.75 371.04 298.75C371.76 303.006 373.766 306.94 376.79 310.02C381.92 315.37 388.36 313.77 391.48 313.43C394.6 313.09 397.48 316.2 395.01 320.15C392.54 324.1 379.41 325.4 377.9 328.14C375.9 333.49 384.53 341.75 384.53 341.75C384.53 341.75 392.53 341.3 397.05 331.62C397.51 330.62 397.89 329.68 398.24 328.74C400.17 323.53 412.15 323.98 412.15 323.98C412.15 323.98 414.06 310.44 407.37 301.2Z",
                fill: "#FF7D20"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M379.02 317.9C378.958 318.001 378.908 318.108 378.87 318.22C378.76 318.598 378.799 319.004 378.978 319.355C379.157 319.706 379.462 319.976 379.833 320.11C380.203 320.243 380.611 320.231 380.973 320.075C381.334 319.919 381.623 319.631 381.78 319.27L379.02 317.9Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M382.75 318.04C381.83 316.49 379.35 316.29 379.33 316.29L379.48 314.08C379.63 314.08 383.13 314.35 384.65 316.9L382.75 318.04Z",
                fill: "#FF7D20"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M308.6 353.29L322.6 353.98C325.08 354.05 325.3 356.64 324.28 357.98C323.26 359.32 320.8 360.14 315.9 360.26C314.625 360.353 313.345 360.353 312.07 360.26C309.49 359.27 305.2 353.56 308.6 353.29Z",
                fill: "white"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M313.43 359.77L326.2 360.7C327.82 360.7 328.67 362.7 328.09 363.98C327.27 365.85 324.55 366.98 317.39 367.25C316.65 367.25 314.67 367.25 314.21 366.91C312.22 365.34 310.04 360.14 313.43 359.77Z",
                fill: "white"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M315.42 365.56L328.2 366.49C329.82 366.49 330.66 368.49 330.09 369.77C329.26 371.64 326.55 372.77 319.39 373.04C318.65 373.04 318.27 372.46 317.81 372.09C315.81 370.53 312.04 365.87 315.42 365.56Z",
                fill: "white"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M255.26 396.2H479.26V459.2H233.11V418.4C233.105 415.487 233.674 412.602 234.785 409.91C235.895 407.217 237.526 404.77 239.583 402.708C241.64 400.646 244.084 399.01 246.774 397.894C249.464 396.777 252.348 396.201 255.26 396.2Z",
                fill: "#80B3D2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M409.38 360.36H219.77V507.48H409.38V360.36Z",
                fill: "#408DBC"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M128.03 459.45C128.03 459.45 120.32 500.29 158.03 517.75C195.74 535.21 212.34 510.68 238.54 502.75C264.74 494.82 283.38 498.59 301.69 505.66C320 512.73 372.69 502.93 387.69 459.41L128.03 459.45Z",
                fill: "#E5F0F6"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M427.42 344.88L421.94 344.01C421.373 343.926 420.812 343.805 420.26 343.65C414.26 346.21 402.89 349.07 387.74 343.42C379.74 343.42 373.2 345.32 359.35 378.27C358.089 381.28 355.889 383.802 353.077 385.46C350.266 387.118 346.995 387.823 343.75 387.47L289.15 381.47L290.9 403.99C290.9 403.99 349.47 427.68 372.9 421.34C383.68 417.6 394.9 403.15 400.2 396.2H440.1C439.47 382.69 440.72 347.37 427.42 344.88Z",
                fill: "#008B66"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M275.74 397.3H247.5C246.853 397.304 246.219 397.112 245.682 396.751C245.145 396.389 244.73 395.874 244.49 395.272C244.251 394.671 244.198 394.011 244.339 393.379C244.48 392.747 244.808 392.173 245.28 391.73C250.34 386.98 259.28 380.67 278.87 380.67C300.03 380.67 329.35 384.06 351.87 389.09L351.38 391.25C329.05 386.25 299.92 382.88 278.91 382.88C260.14 382.88 251.62 388.88 246.84 393.34C246.685 393.477 246.576 393.658 246.528 393.859C246.48 394.06 246.496 394.27 246.572 394.462C246.649 394.654 246.783 394.817 246.957 394.93C247.13 395.042 247.334 395.098 247.54 395.09H275.78L275.74 397.3Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M251.9 396.87L250.56 395.14C262.62 386.04 270.56 386.78 270.88 386.82L270.64 389.02C270.57 388.98 263.17 388.37 251.9 396.87Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M478.9 439.21V373.31C478.9 373.31 427.53 371.06 400.23 396.2C430.65 427.68 478.9 439.21 478.9 439.21Z",
                fill: "#80B3D2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M362.7 423.65C343.36 423.65 313.61 413.31 312.21 412.82L312.94 410.73C313.32 410.86 350.65 423.84 368.44 421.04C386.01 418.28 402.82 389.9 402.99 389.61L404.9 390.73C401.666 396.035 398.015 401.075 393.98 405.8C385.12 416.13 376.64 421.99 368.79 423.23C366.774 423.525 364.738 423.666 362.7 423.65Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M207.32 324.63C268.569 324.63 318.22 274.978 318.22 213.73C318.22 152.482 268.569 102.83 207.32 102.83C146.072 102.83 96.4202 152.482 96.4202 213.73C96.4202 274.978 146.072 324.63 207.32 324.63Z",
                fill: "#73ACCE"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M184.61 459.45C190.633 459.45 196.41 457.057 200.669 452.798C204.928 448.539 207.32 442.763 207.32 436.74H161.9C161.9 442.763 164.293 448.539 168.552 452.798C172.811 457.057 178.587 459.45 184.61 459.45Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M212.47 452.52C211.024 452.522 209.61 452.095 208.406 451.293C207.203 450.491 206.264 449.35 205.709 448.014C205.155 446.679 205.008 445.209 205.289 443.79C205.57 442.371 206.266 441.068 207.288 440.045C208.31 439.021 209.612 438.324 211.03 438.041C212.449 437.758 213.919 437.903 215.255 438.456C216.592 439.008 217.734 439.945 218.537 441.148C219.341 442.35 219.77 443.764 219.77 445.21C219.77 447.147 219.001 449.005 217.633 450.375C216.264 451.746 214.407 452.517 212.47 452.52ZM212.47 440.12C211.461 440.118 210.473 440.416 209.633 440.975C208.793 441.535 208.138 442.331 207.75 443.264C207.363 444.196 207.261 445.222 207.458 446.213C207.654 447.203 208.14 448.112 208.854 448.826C209.568 449.54 210.477 450.026 211.468 450.222C212.458 450.419 213.484 450.317 214.416 449.93C215.349 449.543 216.145 448.887 216.705 448.047C217.264 447.207 217.562 446.22 217.56 445.21C217.552 443.864 217.013 442.576 216.059 441.627C215.106 440.677 213.816 440.143 212.47 440.14V440.12Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M179.43 424.78C172.07 421.99 169.89 417.29 170.3 413.78C170.71 410.27 173.68 407.69 177.86 407.15C181.18 406.73 183.55 404.83 184.06 402.15C184.57 399.47 183.14 396.99 180.36 395.46C175.77 392.92 173.23 388.32 174.05 384C174.81 380 178.11 377.29 182.88 376.67L183.17 378.87C179.39 379.36 176.8 381.43 176.23 384.41C175.59 387.79 177.68 391.41 181.43 393.52C185.02 395.52 186.9 399.05 186.23 402.57C185.56 406.09 182.44 408.75 178.14 409.3C174.96 409.71 172.79 411.5 172.5 413.99C172.21 416.48 174.05 420.29 180.22 422.64L179.43 424.78Z",
                fill: "#8FBCD8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M191.54 429.69L191.05 427.53C193.19 427.04 195.05 425.34 195.19 423.65C195.33 421.96 193.81 420.84 192.48 420.23C189.12 418.67 187.23 415.86 187.67 413.06C188.08 410.44 190.41 408.55 193.74 408.15L194.01 410.35C191.67 410.63 190.11 411.77 189.86 413.4C189.58 415.2 190.97 417.09 193.41 418.22C196.18 419.5 197.63 421.56 197.41 423.88C197.11 426.54 194.66 428.98 191.54 429.69Z",
                fill: "#8FBCD8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M122.97 99.5H80.5802V325.77H122.97V99.5Z",
                fill: "#BFD9E9"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M229.17 99.5H186.78V325.77H229.17V99.5Z",
                fill: "#BFD9E9"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M153.26 256.14C150.816 256.103 148.392 255.695 146.07 254.93L146.74 252.82C153.4 254.92 158.74 254 161.38 250.3C163.48 247.36 168.51 235.3 144.89 203.21C127.29 179.32 128.83 154.34 137.7 141.21C142.7 133.9 149.81 130.63 156.87 132.47C166.37 134.95 166.71 145.02 165.56 149.99L163.4 149.5C163.52 149 166.1 137.17 156.31 134.61C150.12 133 144.01 135.85 139.53 142.45C131.08 154.93 129.71 178.84 146.67 201.86C163.46 224.64 169.47 242.76 163.18 251.56C161.04 254.6 157.57 256.14 153.26 256.14Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M147.51 264.63H145.3V148.05H164.48V150.27H147.51V264.63Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M163.9 148.43C161.282 148.43 158.772 149.47 156.921 151.321C155.07 153.172 154.03 155.682 154.03 158.3H173.77C173.77 155.682 172.73 153.172 170.879 151.321C169.028 149.47 166.518 148.43 163.9 148.43Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M187.88 99.5H185.67V325.77H187.88V99.5Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M124.07 99.5H121.86V325.77H124.07V99.5Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M209.08 99.5H206.87V325.77H209.08V99.5Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M163.26 170.56C163.26 171.414 162.921 172.233 162.317 172.837C161.713 173.441 160.894 173.78 160.04 173.78C159.186 173.78 158.367 173.441 157.763 172.837C157.159 172.233 156.82 171.414 156.82 170.56C156.82 168.78 160.04 163.18 160.04 163.18C160.04 163.18 163.26 168.78 163.26 170.56Z",
                fill: "white"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M172.97 184.44C172.92 185.41 172.5 186.324 171.795 186.993C171.091 187.662 170.157 188.035 169.185 188.035C168.214 188.035 167.279 187.662 166.575 186.993C165.871 186.324 165.45 185.41 165.4 184.44C165.4 182.35 169.18 175.76 169.18 175.76C169.18 175.76 172.97 182.35 172.97 184.44Z",
                fill: "white"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M146.4 298.27C149.128 298.27 151.34 297.164 151.34 295.8C151.34 294.436 149.128 293.33 146.4 293.33C143.672 293.33 141.46 294.436 141.46 295.8C141.46 297.164 143.672 298.27 146.4 298.27Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M149.78 229.71H143.08C140.97 229.71 139.26 231.42 139.26 233.53V250.06C139.26 252.17 140.97 253.88 143.08 253.88H149.78C151.89 253.88 153.6 252.17 153.6 250.06V233.53C153.6 231.42 151.89 229.71 149.78 229.71Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M139.26 245.34C141.425 245.34 143.18 243.585 143.18 241.42C143.18 239.255 141.425 237.5 139.26 237.5C137.095 237.5 135.34 239.255 135.34 241.42C135.34 243.585 137.095 245.34 139.26 245.34Z",
                fill: "#0067A5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M153.6 245.34C155.765 245.34 157.52 243.585 157.52 241.42C157.52 239.255 155.765 237.5 153.6 237.5C151.435 237.5 149.68 239.255 149.68 241.42C149.68 243.585 151.435 245.34 153.6 245.34Z",
                fill: "#FFD400"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M304.44 137.24H239.93V249.47H304.44V137.24Z",
                fill: "#D9E8F2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M289.147 147.788L246.246 205.387L248.018 206.707L290.92 149.108L289.147 147.788Z",
                fill: "white"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M271.712 157.259L247.317 190.012L249.089 191.332L273.485 158.579L271.712 157.259Z",
                fill: "white"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M305.55 250.58H238.82V136.14H305.55V250.58ZM241.04 248.37H303.34V138.37H241.04V248.37Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M280.71 245.64H272.85V248.4H280.71V245.64Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M280.7 245.64H272.85L270.63 220.91H282.91L280.7 245.64Z",
                fill: "#FF7D20"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M276.84 235.83C278.044 235.83 279.02 234.854 279.02 233.65C279.02 232.446 278.044 231.47 276.84 231.47C275.636 231.47 274.66 232.446 274.66 233.65C274.66 234.854 275.636 235.83 276.84 235.83Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M294.38 240.96L285.81 219.26L289.48 217.57L290.41 219.58L288.64 220.39L296.44 240.14L294.38 240.96Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M290.849 220.837L288.633 221.857L289.556 223.865L291.773 222.845L290.849 220.837Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M298.22 231.46H288.51V248.4H298.22V231.46Z",
                fill: "#FF7D20"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M330.27 248.41H229.52V255.05H330.27V248.41Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M285.2 293.35L283.66 291.76C299.382 276.555 310.205 257 314.74 235.603C319.274 214.207 317.315 191.943 309.113 171.667C300.911 151.392 286.839 134.028 268.703 121.802C250.567 109.577 229.192 103.047 207.32 103.05C184.722 103.087 162.682 110.076 144.193 123.069C125.704 136.063 111.661 154.431 103.97 175.68L101.89 174.93C110.79 150.083 128.179 129.177 150.989 115.9C173.8 102.623 200.566 97.8288 226.567 102.362C252.568 106.895 276.132 120.465 293.104 140.678C310.075 160.89 319.364 186.447 319.33 212.84C319.382 227.87 316.384 242.755 310.518 256.593C304.651 270.432 296.038 282.936 285.2 293.35Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M207.32 324.85C154.32 324.85 108.19 287.24 97.5901 235.42L99.7601 234.97C102.951 250.415 109.428 264.993 118.751 277.713C128.075 290.434 140.027 300.999 153.795 308.691C167.563 316.383 182.825 321.023 198.545 322.294C214.265 323.566 230.075 321.44 244.9 316.06L245.65 318.14C233.364 322.6 220.391 324.871 207.32 324.85Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M324.9 326.51C323.642 326.51 322.413 326.137 321.367 325.438C320.321 324.739 319.506 323.746 319.024 322.584C318.543 321.422 318.417 320.143 318.662 318.909C318.908 317.676 319.513 316.542 320.403 315.653C321.292 314.763 322.426 314.158 323.659 313.912C324.893 313.667 326.172 313.793 327.334 314.274C328.496 314.756 329.489 315.571 330.188 316.617C330.887 317.662 331.26 318.892 331.26 320.15C331.257 321.836 330.587 323.452 329.394 324.644C328.202 325.836 326.586 326.507 324.9 326.51ZM324.9 316.01C324.079 316.01 323.276 316.254 322.593 316.71C321.911 317.167 321.379 317.815 321.065 318.574C320.751 319.333 320.67 320.168 320.831 320.973C320.992 321.779 321.388 322.518 321.969 323.098C322.551 323.678 323.291 324.072 324.097 324.231C324.902 324.39 325.737 324.307 326.495 323.991C327.253 323.676 327.901 323.142 328.356 322.458C328.81 321.775 329.052 320.971 329.05 320.15C329.047 319.051 328.609 317.998 327.831 317.222C327.053 316.446 325.999 316.01 324.9 316.01Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M319.46 303.6C327.391 303.6 333.82 297.171 333.82 289.24C333.82 281.309 327.391 274.88 319.46 274.88C311.529 274.88 305.1 281.309 305.1 289.24C305.1 297.171 311.529 303.6 319.46 303.6Z",
                fill: "#80B3D2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M319.46 304.71C316.12 304.698 312.873 303.609 310.2 301.606C307.527 299.603 305.57 296.792 304.62 293.59L306.74 292.97C307.571 295.804 309.325 298.279 311.724 300.002C314.122 301.725 317.027 302.598 319.978 302.481C322.929 302.364 325.757 301.265 328.012 299.358C330.267 297.451 331.82 294.845 332.424 291.954C333.029 289.063 332.65 286.054 331.349 283.402C330.047 280.751 327.897 278.611 325.241 277.322C322.584 276.032 319.572 275.667 316.684 276.284C313.796 276.902 311.197 278.467 309.3 280.73L307.6 279.31C309.27 277.315 311.417 275.773 313.841 274.828C316.265 273.882 318.889 273.563 321.469 273.901C324.049 274.238 326.502 275.221 328.602 276.758C330.701 278.295 332.379 280.337 333.48 282.695C334.581 285.053 335.069 287.65 334.9 290.247C334.73 292.843 333.909 295.355 332.511 297.55C331.114 299.745 329.185 301.551 326.904 302.803C324.622 304.054 322.062 304.71 319.46 304.71Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M444.39 330.87C442.889 330.87 441.421 330.425 440.172 329.59C438.924 328.756 437.951 327.57 437.377 326.182C436.803 324.795 436.653 323.268 436.947 321.796C437.24 320.323 437.964 318.971 439.027 317.91C440.089 316.848 441.443 316.126 442.916 315.835C444.389 315.543 445.915 315.695 447.302 316.271C448.688 316.847 449.873 317.821 450.706 319.071C451.539 320.32 451.982 321.788 451.98 323.29C451.977 325.301 451.177 327.229 449.754 328.65C448.33 330.072 446.401 330.87 444.39 330.87ZM444.39 317.87C443.328 317.87 442.29 318.185 441.407 318.775C440.524 319.365 439.835 320.204 439.429 321.185C439.022 322.166 438.916 323.246 439.123 324.288C439.331 325.329 439.842 326.286 440.593 327.037C441.344 327.788 442.301 328.3 443.342 328.507C444.384 328.714 445.464 328.608 446.445 328.201C447.426 327.795 448.265 327.107 448.855 326.223C449.445 325.34 449.76 324.302 449.76 323.24C449.744 321.825 449.172 320.474 448.167 319.478C447.162 318.482 445.805 317.923 444.39 317.92V317.87Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M475.21 317.34C482.799 317.34 488.95 311.188 488.95 303.6C488.95 296.012 482.799 289.86 475.21 289.86C467.622 289.86 461.47 296.012 461.47 303.6C461.47 311.188 467.622 317.34 475.21 317.34Z",
                fill: "#0067A5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M475.21 318.44C471.274 318.44 467.5 316.877 464.717 314.093C461.934 311.31 460.37 307.536 460.37 303.6C460.37 299.664 461.934 295.89 464.717 293.107C467.5 290.323 471.274 288.76 475.21 288.76V290.97C472.712 290.97 470.27 291.711 468.193 293.099C466.116 294.486 464.497 296.459 463.542 298.767C462.586 301.075 462.335 303.614 462.823 306.064C463.31 308.514 464.513 310.764 466.279 312.531C468.046 314.297 470.296 315.5 472.746 315.987C475.196 316.475 477.736 316.225 480.043 315.269C482.351 314.313 484.324 312.694 485.712 310.617C487.099 308.54 487.84 306.098 487.84 303.6H490.05C490.047 307.535 488.483 311.308 485.701 314.091C482.918 316.873 479.145 318.437 475.21 318.44Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M459 250.38C501.769 250.38 536.44 215.709 536.44 172.94C536.44 130.171 501.769 95.5 459 95.5C416.231 95.5 381.56 130.171 381.56 172.94C381.56 215.709 416.231 250.38 459 250.38Z",
                fill: "#FFD400"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M425.99 244.23C412.168 237.811 400.511 227.509 392.443 214.58C384.374 201.651 380.243 186.653 380.551 171.416C380.859 156.179 385.595 141.361 394.18 128.768C402.765 116.176 414.828 106.354 428.899 100.5C442.97 94.6455 458.44 93.0121 473.424 95.7987C488.407 98.5854 502.256 105.672 513.281 116.193C524.306 126.715 532.032 140.218 535.516 155.054C538.999 169.891 538.091 185.421 532.9 199.75L530.82 198.99C535.867 185.06 536.751 169.963 533.364 155.539C529.978 141.116 522.468 127.989 511.75 117.761C501.031 107.532 487.568 100.643 473.002 97.9344C458.436 95.2256 443.397 96.8139 429.718 102.506C416.039 108.197 404.312 117.746 395.967 129.988C387.622 142.23 383.019 156.636 382.721 171.448C382.422 186.261 386.44 200.841 394.285 213.409C402.129 225.977 413.462 235.991 426.9 242.23L425.99 244.23Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M431.7 152.9H429.48V145.28H417.11V143.07H431.7V152.9Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M497.62 152.9H495.4V143.07H508.29V145.28H497.62V152.9Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M468.35 206.15H452.77V228.33H468.35V206.15Z",
                fill: "#0067A5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M513.19 158.82H408.26C405.305 158.82 402.91 161.215 402.91 164.17V165.31C402.91 168.265 405.305 170.66 408.26 170.66H513.19C516.145 170.66 518.54 168.265 518.54 165.31V164.17C518.54 161.215 516.145 158.82 513.19 158.82Z",
                fill: "white"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M490.55 204.22H430.78C428.175 204.221 425.64 203.38 423.552 201.823C421.463 200.266 419.933 198.077 419.19 195.58L410.7 167.02H510.64L502.14 195.58C501.397 198.077 499.867 200.266 497.779 201.823C495.69 203.38 493.155 204.221 490.55 204.22Z",
                fill: "white"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M469.82 158.82H460.97V128.28C460.916 127.135 460.423 126.055 459.593 125.264C458.764 124.473 457.661 124.031 456.515 124.031C455.369 124.031 454.267 124.473 453.437 125.264C452.607 126.055 452.114 127.135 452.06 128.28V135.28H443.2V128.28C443.2 124.75 444.602 121.365 447.099 118.868C449.595 116.372 452.98 114.97 456.51 114.97C460.04 114.97 463.426 116.372 465.922 118.868C468.418 121.365 469.82 124.75 469.82 128.28V158.82Z",
                fill: "white"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M438.3 158.82C438.3 158.82 438.3 158.77 438.3 158.75C438.337 157.713 438.166 156.68 437.795 155.711C437.424 154.743 436.861 153.859 436.141 153.112C435.421 152.366 434.558 151.772 433.604 151.367C432.649 150.961 431.622 150.752 430.585 150.752C429.548 150.752 428.521 150.961 427.567 151.367C426.612 151.772 425.749 152.366 425.029 153.112C424.309 153.859 423.747 154.743 423.376 155.711C423.005 156.68 422.833 157.713 422.87 158.75V158.82H438.3Z",
                fill: "white"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M504.22 158.82V158.75C504.257 157.713 504.086 156.68 503.715 155.711C503.344 154.743 502.781 153.859 502.061 153.112C501.341 152.366 500.478 151.772 499.524 151.367C498.569 150.961 497.542 150.752 496.505 150.752C495.468 150.752 494.441 150.961 493.487 151.367C492.532 151.772 491.669 152.366 490.949 153.112C490.229 153.859 489.667 154.743 489.296 155.711C488.925 156.68 488.753 157.713 488.79 158.75C488.79 158.75 488.79 158.75 488.79 158.82H504.22Z",
                fill: "white"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M451.11 146.37C451.063 147.239 450.685 148.056 450.053 148.654C449.422 149.252 448.585 149.586 447.715 149.586C446.845 149.586 446.009 149.252 445.377 148.654C444.746 148.056 444.367 147.239 444.32 146.37C444.32 144.49 447.72 137.88 447.72 137.88C447.72 137.88 451.11 144.49 451.11 146.37Z",
                fill: "white"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M474.59 204.22H447.72V208.06H474.59V204.22Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M508.29 157.72H408.83V159.93H508.29V157.72Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M518.53 169.56H417.11V171.77H518.53V169.56Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M490.55 205.33H438.3V203.14H490.55C492.915 203.128 495.214 202.358 497.109 200.943C499.004 199.529 500.396 197.544 501.08 195.28L508.49 170.37L510.61 171L503.2 195.91C502.377 198.627 500.703 201.008 498.426 202.703C496.15 204.399 493.389 205.319 490.55 205.33Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M470.9 158.82H468.69V128.28C468.599 125.104 467.273 122.088 464.995 119.873C462.716 117.658 459.663 116.419 456.485 116.419C453.307 116.419 450.255 117.658 447.976 119.873C445.697 122.088 444.371 125.104 444.28 128.28H442.06C442.06 124.456 443.579 120.788 446.284 118.084C448.988 115.379 452.656 113.86 456.48 113.86C460.305 113.86 463.972 115.379 466.677 118.084C469.381 120.788 470.9 124.456 470.9 128.28V158.82Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M574.95 224.86H446.33C442.762 224.86 439.87 227.752 439.87 231.32V273.87C439.87 277.438 442.762 280.33 446.33 280.33H574.95C578.518 280.33 581.41 277.438 581.41 273.87V231.32C581.41 227.752 578.518 224.86 574.95 224.86Z",
                fill: "#0067A5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M469.56 245.02H475.25C476.77 245.02 477.12 245.53 477.12 246.22C477.12 246.91 476.77 247.48 475.25 247.48H469.56V245.02ZM469.56 251.81H476C477.49 251.81 477.95 252.48 477.95 253.3C477.95 254.12 477.49 254.8 476 254.8H469.56V251.81ZM462.18 259.45H478.51C484.09 259.45 485.96 256.99 485.96 253.25C485.973 252.266 485.66 251.305 485.07 250.516C484.481 249.728 483.648 249.156 482.7 248.89V248.84C483.413 248.525 484.012 248 484.418 247.335C484.823 246.671 485.016 245.898 484.97 245.12C484.97 242.12 483.24 240.37 479.33 240.37H462.18V259.45ZM493.67 259.45H500.9V254.08L509.52 240.37H501.52L497.26 247.29L493.07 240.37H485.07L493.69 254.08L493.67 259.45ZM526.49 259.45H535.9L527.72 247.68L535.64 240.37H525.64L517.9 247.68V240.37H510.66V259.45H517.9V254.61L521.26 251.83L526.49 259.45ZM535.01 249.91C535.01 259.8 543.48 260.12 548.01 260.12C552.54 260.12 561.01 259.8 561.01 249.91C561.01 240.02 552.55 239.7 548.01 239.7C543.47 239.7 535.01 240.02 535.01 249.91ZM543.01 249.91C543.01 246.03 545.01 244.51 548.01 244.51C551.01 244.51 553.01 246.03 553.01 249.91C553.01 253.79 551.06 255.31 548.01 255.31C544.96 255.31 543.01 253.79 543.01 249.91Z",
                fill: "white"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M561.48 265.4H561.1H559.53C559.38 265.4 559.83 265.07 560.16 265.05C560.391 265.063 560.623 265.047 560.85 265C560.85 265 559.85 264.95 559.8 264.95C559.75 264.95 559.8 265 559.68 265.01C559.388 264.972 559.094 264.952 558.8 264.95H560.07C559.627 264.918 559.183 264.918 558.74 264.95C558.22 264.95 558.8 264.95 558.17 264.86C557.73 264.86 557.17 264.86 556.63 264.86C556.63 264.86 554.63 264.86 553.53 264.81H553.71C553.8 264.81 552.71 264.81 552.04 264.76C552.04 264.76 560.34 264.61 560.34 264.59C560.34 264.57 559.19 264.59 557.22 264.54C557.17 264.54 557.92 264.54 557.78 264.47H555.16C555.26 264.47 555.25 264.47 555.25 264.47H551.83C553.66 264.4 555.88 264.47 558.11 264.47C558.32 264.47 558.58 264.47 558.42 264.41C553.8 264.32 544.5 264.41 544.53 264.33C545.296 264.27 546.065 264.27 546.83 264.33C550.49 264.27 554.75 264.33 558.68 264.33C558.8 264.33 558.81 264.23 558.68 264.17C554.42 264.05 550.16 264.09 545.9 264.01H545.8C543.97 264.1 541.01 264.01 538.74 264.1C536.99 264.16 535.06 264.18 533.22 264.21L535.78 264.1C537.6 264.05 539.42 264.1 541.01 264.01C541.47 264.01 542.38 264.01 543.01 264.01H543.94H542.94C542.71 264.01 548.72 264.01 548.49 263.89H540.07C539.39 263.83 540.67 263.63 541.07 263.62C541.07 263.62 541.2 263.62 541.19 263.62H540.4H542.46H542.53C541.38 263.62 539.02 263.62 539.05 263.57C539.08 263.52 543.05 263.51 544.99 263.48C543.67 263.48 542.16 263.48 540.85 263.48C535.58 263.48 530.78 263.57 525.85 263.64C525.26 263.64 524.67 263.71 524.07 263.72C523.14 263.72 522.07 263.72 521.07 263.72C522.66 263.72 524.46 263.57 526.07 263.54C526.196 263.533 526.32 263.509 526.44 263.47C526.44 263.47 521.36 263.57 519.06 263.66C518.6 263.66 517.91 263.74 517.46 263.74C515.46 263.74 513.4 263.84 514.04 263.83C513.31 263.83 511.96 263.83 510.67 263.93C510.47 263.93 510.9 264.02 510.9 264.02C511.7 264.22 509.11 264.15 505.82 264.23C503.07 264.28 500.04 264.32 498.45 264.48C498.175 264.52 497.898 264.537 497.62 264.53C499.675 264.232 501.745 264.051 503.82 263.99C505.13 263.99 507.82 264.04 507.82 263.94C507.82 263.56 501.74 264.02 499.91 264.07C496.27 264.18 492.81 264.5 489.41 264.7C488.02 264.79 486.62 264.83 485.23 264.88H485.58C483.85 264.95 482.18 265.02 480.42 265.14H479.94C476.31 265.39 473.2 265.6 469.51 265.88C468.6 265.95 467.7 266.05 466.8 266.13C466.12 266.21 467.27 266.13 466.14 266.29C466.14 266.29 465.72 266.38 468.14 266.15C468.27 266.15 468.22 266.22 467.97 266.23C466.63 266.31 465.05 266.41 463.62 266.59H462.31C462.14 266.59 462.12 266.59 462.12 266.59L461.93 266.78L461.86 266.86C461.727 267.018 461.628 267.202 461.57 267.4C461.56 267.476 461.56 267.554 461.57 267.63C461.569 267.66 461.569 267.69 461.57 267.72C461.68 267.98 462.06 268.18 462.99 268.19H463.47C463.61 268.19 463.87 268.19 463.81 268.19C463.688 268.204 463.568 268.227 463.45 268.26C463.613 268.279 463.777 268.279 463.94 268.26C464.27 268.21 464.76 268.09 465.16 268.07C465.8 268.01 465.21 268.07 465.95 268.07C469.86 267.77 473.67 267.58 477.65 267.37C477.74 267.37 477.65 267.37 477.52 267.37L478.84 267.3L537.93 266.52C540.93 266.57 543.93 266.62 544.81 266.66C545.53 266.66 544.09 266.76 544.08 266.77C544.96 266.77 545.29 266.77 546.08 266.77C546.28 266.77 547.02 266.86 546.99 266.77C546.724 266.748 546.459 266.705 546.2 266.64H547.2C547.686 266.673 548.174 266.673 548.66 266.64C550.26 266.56 551.99 266.72 553.66 266.76C553.172 266.814 552.681 266.841 552.19 266.84C551.98 266.94 556.77 266.84 557.82 266.84C558.01 266.84 558.87 266.49 559 266.48L559.72 266.28C560 266.28 560.25 266.28 560.63 266.28C561.57 266.35 561.31 266.02 561.97 265.79C561.812 265.757 561.651 265.74 561.49 265.74L561.48 265.4ZM533.69 263.67C535.23 263.54 538.87 263.58 538.89 263.61C538.91 263.64 534.77 263.7 532.6 263.74L533.69 263.67ZM529.63 264.16C526.63 264.21 523.48 264.22 520.52 264.34C520.07 264.34 519.38 264.34 518.93 264.34C520.5 264.27 521.93 264.19 523.48 264.15C523.65 264.15 524.04 264.15 524.17 264.15C524.474 264.155 524.778 264.138 525.08 264.1C524.89 264.11 524.7 264.11 524.51 264.1C524.51 264.1 526.74 264.05 528.51 264.04C528.559 264.027 528.611 264.027 528.66 264.04C530.66 264.04 533.66 263.93 533.85 263.94H534.1C534.77 263.94 535.43 264.07 536.23 264.08H536.45V264.13C534.45 264.24 531.9 264.13 529.62 264.13L529.63 264.16ZM540.62 264.5C540.35 264.5 535.35 264.41 532.82 264.45H531.42C531.583 264.462 531.747 264.462 531.91 264.45H532.18C535.18 264.45 538.28 264.45 541.18 264.45C540.988 264.504 540.789 264.524 540.59 264.51L540.62 264.5ZM551.73 265H550.9H551.97C552.08 265 552.09 265 551.77 265H551.73ZM561.5 265.84C561.333 265.799 561.162 265.775 560.99 265.77H561.41C561.67 265.77 561.74 265.83 561.5 265.85",
                fill: "#FFD400"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M574.26 281.43H467.9V279.22H574.26C575.855 279.204 577.38 278.56 578.503 277.428C579.626 276.295 580.258 274.765 580.26 273.17V232.01C580.258 230.415 579.626 228.885 578.503 227.752C577.38 226.62 575.855 225.976 574.26 225.96H488.83V223.75H574.26C576.45 223.753 578.549 224.624 580.098 226.172C581.646 227.721 582.517 229.82 582.52 232.01V273.14C582.523 274.227 582.311 275.304 581.897 276.309C581.484 277.314 580.876 278.227 580.109 278.997C579.341 279.767 578.43 280.378 577.427 280.796C576.423 281.213 575.347 281.429 574.26 281.43Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M478.9 373.31C524.15 373.31 559.06 414.44 557.19 459.45H400.19V453.6L478.9 373.31Z",
                fill: "#80B3D2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M571.26 458.05H146.21V460.26H571.26V458.05Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M75.6702 196.57C81.7177 196.57 86.6202 191.668 86.6202 185.62C86.6202 179.573 81.7177 174.67 75.6702 174.67C69.6226 174.67 64.7202 179.573 64.7202 185.62C64.7202 191.668 69.6226 196.57 75.6702 196.57Z",
                fill: "#BFD9E9"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-illustrations-virtual-f4c8d3dc38/1/packages/lib-illustrations/src/fjolskylda.tsx
/* eslint-disable max-len */ 

const FjolskyldaIllustration = (param)=>{
    let { size =200  } = param;
    return /*#__PURE__*/ _jsxs("svg", {
        fill: "none",
        height: size,
        viewBox: "0 0 662 611",
        width: size,
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M292.63 174.16C263.38 155.25 230.51 168.94 229.12 196.04C204.33 196.04 182.12 225.61 199.06 250.04C169 270.56 185.21 324.49 216.36 319.7C216.74 352.88 260.76 378.86 292.63 361.17C325.63 342.86 374.69 227.3 374.69 227.3C374.69 227.3 341.36 152.17 292.63 174.16Z",
                fill: "#D9EEE8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M323.09 397.33C309.8 336.33 268.21 302.07 235.65 284.07C200.31 264.53 167.65 259.39 167.35 259.34L167.67 257.23C168 257.28 200.95 262.47 236.62 282.18C269.62 300.39 311.71 335.07 325.17 396.88L323.09 397.33Z",
                fill: "white"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M211.084 196.166L209.088 196.908L243.013 288.081L245.009 287.339L211.084 196.166Z",
                fill: "white"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M346.3 323.83C291.56 287.73 270.43 241.98 262.3 209.95C253.54 175.23 257.8 148.66 257.84 148.39L259.94 148.74C259.94 149 255.71 175.21 264.39 209.52C272.39 241.16 293.29 286.36 347.39 322.05L346.3 323.83Z",
                fill: "white"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M315.425 156.254L269.369 231.539L271.179 232.646L317.236 157.362L315.425 156.254Z",
                fill: "white"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M261.76 207.94C216.76 207.94 214.54 166.54 214.52 166.12L216.65 166.03C217.268 173.156 219.461 180.055 223.07 186.23C230.97 199.46 244.32 206.05 262.72 205.8V207.93L261.76 207.94Z",
                fill: "white"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M184.13 308.15L183.26 306.21C183.51 306.1 207.59 295.14 218.83 274.42L220.71 275.42C209.11 296.8 184.38 308.04 184.13 308.15Z",
                fill: "white"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M91.3501 369.91C119.25 347.96 157.57 360.6 171.97 382.73C186.37 404.86 218.97 413.2 260.45 386.99C301.93 360.78 370.14 388.99 331.77 462.12H73.9301C73.9301 462.12 41.0901 409.48 91.3501 369.91Z",
                fill: "#D9EEE8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M576.81 238.1H287.93V441.08H576.81V238.1Z",
                fill: "white"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M455.53 216.01C455.53 216.01 424.01 237.01 428.32 264.91C431.7 286.78 454.59 303.63 499.77 298.2C535.94 293.86 539.33 321.77 528.44 351.36C521.35 370.61 514.35 419.15 552.44 441.08H576.82V207.28L455.53 216.01Z",
                fill: "#D9D9D9"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M490.72 363.45H370.42V349.02L423.47 275.98H490.72V363.45Z",
                fill: "#E5F0F6"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M451.136 281.685L409.879 337.117L411.588 338.389L452.845 282.957L451.136 281.685Z",
                fill: "white"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M434.357 290.803L410.898 322.322L412.607 323.593L436.066 292.075L434.357 290.803Z",
                fill: "white"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M491.79 364.51H369.35V274.92H491.79V364.51ZM371.48 362.38H489.66V277.05H371.48V362.38Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M498.55 360H364.16V370.85H498.55V360Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M404.26 276.22H402.13V361.88H404.26V276.22Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M403.2 298.57H379.21V300.7H403.2V298.57Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M345.75 442.15H287.17V260.84H289.3V440.02H345.75V442.15Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M559.98 440.02H370.42V442.15H559.98V440.02Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M342.61 158.41L253 239.61C253 242.472 254.137 245.216 256.16 247.24C258.184 249.263 260.928 250.4 263.79 250.4C265.208 250.401 266.612 250.123 267.922 249.582C269.232 249.04 270.423 248.245 271.426 247.243C272.429 246.241 273.225 245.051 273.768 243.742C274.311 242.432 274.59 241.028 274.59 239.61C274.59 242.472 275.727 245.216 277.75 247.24C279.774 249.263 282.518 250.4 285.38 250.4C288.242 250.4 290.986 249.263 293.01 247.24C295.033 245.216 296.17 242.472 296.17 239.61C296.255 242.416 297.43 245.079 299.445 247.033C301.46 248.988 304.158 250.081 306.965 250.081C309.772 250.081 312.47 248.988 314.485 247.033C316.5 245.079 317.675 242.416 317.76 239.61C317.763 242.473 318.902 245.217 320.927 247.24C322.952 249.264 325.697 250.4 328.56 250.4C331.422 250.4 334.166 249.263 336.19 247.24C338.213 245.216 339.35 242.472 339.35 239.61C339.435 242.416 340.61 245.079 342.625 247.033C344.64 248.988 347.338 250.081 350.145 250.081C352.952 250.081 355.65 248.988 357.665 247.033C359.68 245.079 360.855 242.416 360.94 239.61C360.94 242.472 362.077 245.216 364.1 247.24C366.124 249.263 368.868 250.4 371.73 250.4C374.592 250.4 377.336 249.263 379.36 247.24C381.383 245.216 382.52 242.472 382.52 239.61C382.523 242.469 383.659 245.211 385.68 247.233C387.7 249.256 390.441 250.395 393.3 250.4C396.162 250.4 398.906 249.263 400.93 247.24C402.953 245.216 404.09 242.472 404.09 239.61C404.175 242.416 405.35 245.079 407.365 247.033C409.38 248.988 412.078 250.081 414.885 250.081C417.692 250.081 420.39 248.988 422.405 247.033C424.42 245.079 425.595 242.416 425.68 239.61C425.765 242.416 426.94 245.079 428.955 247.033C430.97 248.988 433.668 250.081 436.475 250.081C439.282 250.081 441.98 248.988 443.995 247.033C446.01 245.079 447.185 242.416 447.27 239.61C447.27 242.472 448.407 245.216 450.43 247.24C452.454 249.263 455.198 250.4 458.06 250.4C460.922 250.4 463.666 249.263 465.69 247.24C467.713 245.216 468.85 242.472 468.85 239.61C468.935 242.416 470.11 245.079 472.125 247.033C474.14 248.988 476.838 250.081 479.645 250.081C482.452 250.081 485.15 248.988 487.165 247.033C489.18 245.079 490.355 242.416 490.44 239.61C490.525 242.416 491.7 245.079 493.715 247.033C495.73 248.988 498.428 250.081 501.235 250.081C504.042 250.081 506.74 248.988 508.755 247.033C510.77 245.079 511.945 242.416 512.03 239.61C512.03 242.472 513.167 245.216 515.19 247.24C517.214 249.263 519.958 250.4 522.82 250.4C525.683 250.4 528.428 249.264 530.453 247.24C532.478 245.217 533.617 242.473 533.62 239.61C533.62 242.472 534.757 245.216 536.78 247.24C538.804 249.263 541.548 250.4 544.41 250.4C547.272 250.4 550.016 249.263 552.04 247.24C554.063 245.216 555.2 242.472 555.2 239.61C555.285 242.416 556.46 245.079 558.475 247.033C560.49 248.988 563.188 250.081 565.995 250.081C568.802 250.081 571.5 248.988 573.515 247.033C575.53 245.079 576.705 242.416 576.79 239.61V158.41H342.61Z",
                fill: "#FF7D20"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M567.22 153.08H348.02V155.21H567.22V153.08Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M566.02 251.47C563.744 251.466 561.516 250.809 559.602 249.577C557.688 248.345 556.167 246.59 555.22 244.52C554.279 246.593 552.761 248.35 550.848 249.583C548.934 250.816 546.706 251.471 544.43 251.471C542.154 251.471 539.926 250.816 538.012 249.583C536.099 248.35 534.581 246.593 533.64 244.52C532.697 246.592 531.178 248.349 529.264 249.581C527.35 250.813 525.121 251.468 522.845 251.468C520.569 251.468 518.34 250.813 516.426 249.581C514.512 248.349 512.993 246.592 512.05 244.52C511.107 246.592 509.588 248.349 507.674 249.581C505.76 250.813 503.531 251.468 501.255 251.468C498.979 251.468 496.75 250.813 494.836 249.581C492.922 248.349 491.403 246.592 490.46 244.52C489.519 246.593 488.001 248.35 486.088 249.583C484.174 250.816 481.946 251.471 479.67 251.471C477.394 251.471 475.166 250.816 473.252 249.583C471.339 248.35 469.821 246.593 468.88 244.52C467.937 246.592 466.418 248.349 464.504 249.581C462.59 250.813 460.361 251.468 458.085 251.468C455.809 251.468 453.58 250.813 451.666 249.581C449.752 248.349 448.233 246.592 447.29 244.52C446.347 246.592 444.828 248.349 442.914 249.581C441 250.813 438.771 251.468 436.495 251.468C434.219 251.468 431.99 250.813 430.076 249.581C428.162 248.349 426.643 246.592 425.7 244.52C424.757 246.592 423.238 248.349 421.324 249.581C419.41 250.813 417.181 251.468 414.905 251.468C412.629 251.468 410.4 250.813 408.486 249.581C406.572 248.349 405.053 246.592 404.11 244.52C403.167 246.592 401.648 248.349 399.734 249.581C397.82 250.813 395.591 251.468 393.315 251.468C391.039 251.468 388.81 250.813 386.896 249.581C384.982 248.349 383.463 246.592 382.52 244.52C381.579 246.593 380.061 248.35 378.148 249.583C376.234 250.816 374.006 251.471 371.73 251.471C369.454 251.471 367.226 250.816 365.312 249.583C363.399 248.35 361.881 246.593 360.94 244.52C359.997 246.592 358.478 248.349 356.564 249.581C354.65 250.813 352.421 251.468 350.145 251.468C347.869 251.468 345.64 250.813 343.726 249.581C341.812 248.349 340.293 246.592 339.35 244.52C338.407 246.592 336.888 248.349 334.974 249.581C333.06 250.813 330.831 251.468 328.555 251.468C326.279 251.468 324.05 250.813 322.136 249.581C320.222 248.349 318.703 246.592 317.76 244.52C316.819 246.593 315.301 248.35 313.388 249.583C311.474 250.816 309.246 251.471 306.97 251.471C304.694 251.471 302.466 250.816 300.552 249.583C298.639 248.35 297.121 246.593 296.18 244.52C295.237 246.592 293.718 248.349 291.804 249.581C289.89 250.813 287.661 251.468 285.385 251.468C283.109 251.468 280.88 250.813 278.966 249.581C277.052 248.349 275.533 246.592 274.59 244.52C273.467 246.983 271.534 248.987 269.115 250.2C266.695 251.413 263.933 251.761 261.287 251.188C258.642 250.614 256.272 249.153 254.572 247.047C252.872 244.941 251.943 242.317 251.94 239.61H254.07C254.028 240.913 254.249 242.212 254.719 243.428C255.189 244.645 255.898 245.754 256.806 246.691C257.713 247.628 258.799 248.372 260 248.881C261.2 249.39 262.491 249.652 263.795 249.652C265.099 249.652 266.39 249.39 267.59 248.881C268.791 248.372 269.877 247.628 270.785 246.691C271.692 245.754 272.401 244.645 272.871 243.428C273.341 242.212 273.562 240.913 273.52 239.61H275.65C275.65 242.191 276.675 244.665 278.5 246.49C280.325 248.315 282.799 249.34 285.38 249.34C287.961 249.34 290.435 248.315 292.26 246.49C294.085 244.665 295.11 242.191 295.11 239.61H297.24C297.24 240.888 297.492 242.153 297.981 243.333C298.47 244.514 299.186 245.587 300.09 246.49C300.993 247.394 302.066 248.11 303.247 248.599C304.427 249.088 305.692 249.34 306.97 249.34C308.248 249.34 309.513 249.088 310.694 248.599C311.874 248.11 312.947 247.394 313.85 246.49C314.754 245.587 315.47 244.514 315.959 243.333C316.448 242.153 316.7 240.888 316.7 239.61H318.83C318.83 242.191 319.855 244.665 321.68 246.49C323.505 248.315 325.98 249.34 328.56 249.34C331.141 249.34 333.615 248.315 335.44 246.49C337.265 244.665 338.29 242.191 338.29 239.61H340.42C340.378 240.913 340.599 242.212 341.069 243.428C341.539 244.645 342.248 245.754 343.156 246.691C344.063 247.628 345.149 248.372 346.35 248.881C347.55 249.39 348.841 249.652 350.145 249.652C351.449 249.652 352.74 249.39 353.941 248.881C355.141 248.372 356.227 247.628 357.135 246.691C358.042 245.754 358.751 244.645 359.221 243.428C359.691 242.212 359.912 240.913 359.87 239.61H362C362 242.191 363.025 244.665 364.85 246.49C366.675 248.315 369.149 249.34 371.73 249.34C374.311 249.34 376.785 248.315 378.61 246.49C380.435 244.665 381.46 242.191 381.46 239.61H383.59C383.59 242.191 384.615 244.665 386.44 246.49C388.265 248.315 390.74 249.34 393.32 249.34C395.901 249.34 398.375 248.315 400.2 246.49C402.025 244.665 403.05 242.191 403.05 239.61H405.18C405.138 240.913 405.359 242.212 405.829 243.428C406.299 244.645 407.008 245.754 407.916 246.691C408.823 247.628 409.909 248.372 411.11 248.881C412.31 249.39 413.601 249.652 414.905 249.652C416.209 249.652 417.5 249.39 418.701 248.881C419.901 248.372 420.987 247.628 421.895 246.691C422.802 245.754 423.511 244.645 423.981 243.428C424.451 242.212 424.672 240.913 424.63 239.61H426.76C426.76 242.191 427.785 244.665 429.61 246.49C431.435 248.315 433.91 249.34 436.49 249.34C439.071 249.34 441.546 248.315 443.37 246.49C445.195 244.665 446.22 242.191 446.22 239.61H448.35C448.35 242.191 449.375 244.665 451.2 246.49C453.025 248.315 455.5 249.34 458.08 249.34C460.661 249.34 463.135 248.315 464.96 246.49C466.785 244.665 467.81 242.191 467.81 239.61H469.94C469.94 242.191 470.965 244.665 472.79 246.49C474.615 248.315 477.09 249.34 479.67 249.34C482.251 249.34 484.725 248.315 486.55 246.49C488.375 244.665 489.4 242.191 489.4 239.61H491.53C491.53 242.191 492.555 244.665 494.38 246.49C496.205 248.315 498.68 249.34 501.26 249.34C503.841 249.34 506.315 248.315 508.14 246.49C509.965 244.665 510.99 242.191 510.99 239.61H513.12C513.078 240.913 513.299 242.212 513.769 243.428C514.239 244.645 514.948 245.754 515.856 246.691C516.763 247.628 517.849 248.372 519.05 248.881C520.25 249.39 521.541 249.652 522.845 249.652C524.149 249.652 525.44 249.39 526.641 248.881C527.841 248.372 528.927 247.628 529.835 246.691C530.742 245.754 531.451 244.645 531.921 243.428C532.391 242.212 532.612 240.913 532.57 239.61H534.7C534.7 242.191 535.725 244.665 537.55 246.49C539.375 248.315 541.849 249.34 544.43 249.34C547.011 249.34 549.485 248.315 551.31 246.49C553.135 244.665 554.16 242.191 554.16 239.61H556.3C556.3 242.191 557.325 244.665 559.15 246.49C560.975 248.315 563.449 249.34 566.03 249.34C568.611 249.34 571.085 248.315 572.91 246.49C574.735 244.665 575.76 242.191 575.76 239.61H577.89C577.887 242.756 576.636 245.773 574.41 247.997C572.184 250.221 569.166 251.47 566.02 251.47Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M566.02 229.88C563.743 229.877 561.515 229.221 559.601 227.989C557.686 226.757 556.166 225.001 555.22 222.93C554.279 225.003 552.761 226.76 550.848 227.993C548.934 229.226 546.706 229.881 544.43 229.881C542.154 229.881 539.926 229.226 538.012 227.993C536.099 226.76 534.581 225.003 533.64 222.93C532.697 225.002 531.178 226.759 529.264 227.991C527.35 229.223 525.121 229.878 522.845 229.878C520.569 229.878 518.34 229.223 516.426 227.991C514.512 226.759 512.993 225.002 512.05 222.93C511.107 225.002 509.588 226.759 507.674 227.991C505.76 229.223 503.531 229.878 501.255 229.878C498.979 229.878 496.75 229.223 494.836 227.991C492.922 226.759 491.403 225.002 490.46 222.93C489.519 225.003 488.001 226.76 486.088 227.993C484.174 229.226 481.946 229.881 479.67 229.881C477.394 229.881 475.166 229.226 473.252 227.993C471.339 226.76 469.821 225.003 468.88 222.93C467.937 225.002 466.418 226.759 464.504 227.991C462.59 229.223 460.361 229.878 458.085 229.878C455.809 229.878 453.58 229.223 451.666 227.991C449.752 226.759 448.233 225.002 447.29 222.93C446.347 225.002 444.828 226.759 442.914 227.991C441 229.223 438.771 229.878 436.495 229.878C434.219 229.878 431.99 229.223 430.076 227.991C428.162 226.759 426.643 225.002 425.7 222.93C424.757 225.002 423.238 226.759 421.324 227.991C419.41 229.223 417.181 229.878 414.905 229.878C412.629 229.878 410.4 229.223 408.486 227.991C406.572 226.759 405.053 225.002 404.11 222.93C403.167 225.002 401.648 226.759 399.734 227.991C397.82 229.223 395.591 229.878 393.315 229.878C391.039 229.878 388.81 229.223 386.896 227.991C384.982 226.759 383.463 225.002 382.52 222.93C381.579 225.003 380.061 226.76 378.148 227.993C376.234 229.226 374.006 229.881 371.73 229.881C369.454 229.881 367.226 229.226 365.312 227.993C363.399 226.76 361.881 225.003 360.94 222.93C359.997 225.002 358.478 226.759 356.564 227.991C354.65 229.223 352.421 229.878 350.145 229.878C347.869 229.878 345.64 229.223 343.726 227.991C341.812 226.759 340.293 225.002 339.35 222.93C338.407 225.002 336.888 226.759 334.974 227.991C333.06 229.223 330.831 229.878 328.555 229.878C326.279 229.878 324.05 229.223 322.136 227.991C320.222 226.759 318.703 225.002 317.76 222.93C316.819 225.003 315.301 226.76 313.388 227.993C311.474 229.226 309.246 229.881 306.97 229.881C304.694 229.881 302.466 229.226 300.552 227.993C298.639 226.76 297.121 225.003 296.18 222.93C295.06 225.398 293.128 227.409 290.706 228.626C288.284 229.843 285.518 230.194 282.868 229.62C280.219 229.046 277.847 227.582 276.146 225.471C274.445 223.36 273.518 220.731 273.52 218.02H275.65C275.65 220.601 276.675 223.075 278.5 224.9C280.325 226.725 282.799 227.75 285.38 227.75C287.961 227.75 290.435 226.725 292.26 224.9C294.085 223.075 295.11 220.601 295.11 218.02H297.24C297.24 219.298 297.492 220.563 297.981 221.744C298.47 222.924 299.186 223.997 300.09 224.9C300.993 225.804 302.066 226.52 303.247 227.009C304.427 227.498 305.692 227.75 306.97 227.75C308.248 227.75 309.513 227.498 310.694 227.009C311.874 226.52 312.947 225.804 313.85 224.9C314.754 223.997 315.47 222.924 315.959 221.744C316.448 220.563 316.7 219.298 316.7 218.02H318.83C318.83 220.601 319.855 223.075 321.68 224.9C323.505 226.725 325.979 227.75 328.56 227.75C331.141 227.75 333.615 226.725 335.44 224.9C337.265 223.075 338.29 220.601 338.29 218.02H340.42C340.378 219.323 340.599 220.622 341.069 221.838C341.539 223.055 342.248 224.164 343.155 225.101C344.063 226.038 345.149 226.782 346.35 227.291C347.55 227.8 348.841 228.062 350.145 228.062C351.449 228.062 352.74 227.8 353.94 227.291C355.141 226.782 356.227 226.038 357.135 225.101C358.042 224.164 358.751 223.055 359.221 221.838C359.691 220.622 359.912 219.323 359.87 218.02H362C362 220.601 363.025 223.075 364.85 224.9C366.675 226.725 369.149 227.75 371.73 227.75C374.311 227.75 376.785 226.725 378.61 224.9C380.435 223.075 381.46 220.601 381.46 218.02H383.59C383.59 220.601 384.615 223.075 386.44 224.9C388.265 226.725 390.739 227.75 393.32 227.75C395.901 227.75 398.375 226.725 400.2 224.9C402.025 223.075 403.05 220.601 403.05 218.02H405.18C405.138 219.323 405.359 220.622 405.829 221.838C406.299 223.055 407.008 224.164 407.915 225.101C408.823 226.038 409.909 226.782 411.11 227.291C412.31 227.8 413.601 228.062 414.905 228.062C416.209 228.062 417.5 227.8 418.7 227.291C419.901 226.782 420.987 226.038 421.895 225.101C422.802 224.164 423.511 223.055 423.981 221.838C424.451 220.622 424.672 219.323 424.63 218.02H426.76C426.76 220.601 427.785 223.075 429.61 224.9C431.435 226.725 433.909 227.75 436.49 227.75C439.071 227.75 441.545 226.725 443.37 224.9C445.195 223.075 446.22 220.601 446.22 218.02H448.35C448.35 220.601 449.375 223.075 451.2 224.9C453.025 226.725 455.499 227.75 458.08 227.75C460.661 227.75 463.135 226.725 464.96 224.9C466.785 223.075 467.81 220.601 467.81 218.02H469.94C469.94 220.601 470.965 223.075 472.79 224.9C474.615 226.725 477.089 227.75 479.67 227.75C482.251 227.75 484.725 226.725 486.55 224.9C488.375 223.075 489.4 220.601 489.4 218.02H491.53C491.53 220.601 492.555 223.075 494.38 224.9C496.205 226.725 498.679 227.75 501.26 227.75C503.841 227.75 506.315 226.725 508.14 224.9C509.965 223.075 510.99 220.601 510.99 218.02H513.12C513.078 219.323 513.299 220.622 513.769 221.838C514.239 223.055 514.948 224.164 515.855 225.101C516.763 226.038 517.849 226.782 519.05 227.291C520.25 227.8 521.541 228.062 522.845 228.062C524.149 228.062 525.44 227.8 526.64 227.291C527.841 226.782 528.927 226.038 529.835 225.101C530.742 224.164 531.451 223.055 531.921 221.838C532.391 220.622 532.612 219.323 532.57 218.02H534.7C534.7 220.601 535.725 223.075 537.55 224.9C539.375 226.725 541.849 227.75 544.43 227.75C547.011 227.75 549.485 226.725 551.31 224.9C553.135 223.075 554.16 220.601 554.16 218.02H556.3C556.3 220.601 557.325 223.075 559.15 224.9C560.975 226.725 563.449 227.75 566.03 227.75C568.611 227.75 571.085 226.725 572.91 224.9C574.735 223.075 575.76 220.601 575.76 218.02H577.89C577.887 221.166 576.636 224.183 574.41 226.407C572.184 228.631 569.166 229.88 566.02 229.88Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M566.02 208.94C563.743 208.937 561.516 208.281 559.601 207.049C557.687 205.817 556.166 204.061 555.22 201.99C554.279 204.063 552.761 205.82 550.848 207.053C548.934 208.286 546.706 208.941 544.43 208.941C542.154 208.941 539.926 208.286 538.013 207.053C536.099 205.82 534.581 204.063 533.64 201.99C532.697 204.062 531.178 205.819 529.264 207.051C527.35 208.283 525.121 208.938 522.845 208.938C520.569 208.938 518.34 208.283 516.426 207.051C514.512 205.819 512.993 204.062 512.05 201.99C511.107 204.062 509.588 205.819 507.674 207.051C505.76 208.283 503.531 208.938 501.255 208.938C498.979 208.938 496.75 208.283 494.836 207.051C492.922 205.819 491.403 204.062 490.46 201.99C489.519 204.063 488.001 205.82 486.088 207.053C484.174 208.286 481.946 208.941 479.67 208.941C477.394 208.941 475.166 208.286 473.253 207.053C471.339 205.82 469.821 204.063 468.88 201.99C467.937 204.062 466.418 205.819 464.504 207.051C462.59 208.283 460.361 208.938 458.085 208.938C455.809 208.938 453.58 208.283 451.666 207.051C449.752 205.819 448.233 204.062 447.29 201.99C446.347 204.062 444.828 205.819 442.914 207.051C441 208.283 438.771 208.938 436.495 208.938C434.219 208.938 431.99 208.283 430.076 207.051C428.162 205.819 426.643 204.062 425.7 201.99C424.757 204.062 423.238 205.819 421.324 207.051C419.41 208.283 417.182 208.938 414.905 208.938C412.629 208.938 410.4 208.283 408.486 207.051C406.572 205.819 405.053 204.062 404.11 201.99C403.167 204.062 401.648 205.819 399.734 207.051C397.82 208.283 395.592 208.938 393.315 208.938C391.039 208.938 388.81 208.283 386.896 207.051C384.982 205.819 383.463 204.062 382.52 201.99C381.579 204.063 380.061 205.82 378.148 207.053C376.234 208.286 374.006 208.941 371.73 208.941C369.454 208.941 367.226 208.286 365.312 207.053C363.399 205.82 361.881 204.063 360.94 201.99C359.997 204.062 358.478 205.819 356.564 207.051C354.65 208.283 352.422 208.938 350.145 208.938C347.869 208.938 345.64 208.283 343.726 207.051C341.812 205.819 340.293 204.062 339.35 201.99C338.407 204.062 336.888 205.819 334.974 207.051C333.06 208.283 330.832 208.938 328.555 208.938C326.279 208.938 324.05 208.283 322.136 207.051C320.222 205.819 318.703 204.062 317.76 201.99C316.637 204.453 314.704 206.457 312.285 207.67C309.865 208.883 307.103 209.231 304.457 208.658C301.812 208.084 299.443 206.623 297.742 204.517C296.042 202.411 295.113 199.787 295.11 197.08H297.24C297.24 198.358 297.492 199.623 297.981 200.804C298.47 201.984 299.186 203.057 300.09 203.96C300.993 204.864 302.066 205.58 303.247 206.069C304.427 206.558 305.692 206.81 306.97 206.81C308.248 206.81 309.513 206.558 310.694 206.069C311.874 205.58 312.947 204.864 313.85 203.96C314.754 203.057 315.47 201.984 315.959 200.804C316.448 199.623 316.7 198.358 316.7 197.08H318.83C318.83 199.661 319.855 202.135 321.68 203.96C323.505 205.785 325.98 206.81 328.56 206.81C331.141 206.81 333.616 205.785 335.44 203.96C337.265 202.135 338.29 199.661 338.29 197.08H340.42C340.378 198.383 340.599 199.682 341.069 200.898C341.539 202.115 342.248 203.224 343.156 204.161C344.063 205.098 345.149 205.843 346.35 206.351C347.55 206.86 348.841 207.122 350.145 207.122C351.449 207.122 352.74 206.86 353.941 206.351C355.141 205.843 356.227 205.098 357.135 204.161C358.042 203.224 358.751 202.115 359.221 200.898C359.691 199.682 359.912 198.383 359.87 197.08H362C362 199.661 363.025 202.135 364.85 203.96C366.675 205.785 369.15 206.81 371.73 206.81C374.311 206.81 376.786 205.785 378.61 203.96C380.435 202.135 381.46 199.661 381.46 197.08H383.59C383.59 199.661 384.615 202.135 386.44 203.96C388.265 205.785 390.74 206.81 393.32 206.81C395.901 206.81 398.376 205.785 400.2 203.96C402.025 202.135 403.05 199.661 403.05 197.08H405.18C405.138 198.383 405.359 199.682 405.829 200.898C406.299 202.115 407.008 203.224 407.916 204.161C408.823 205.098 409.909 205.843 411.11 206.351C412.31 206.86 413.601 207.122 414.905 207.122C416.209 207.122 417.5 206.86 418.701 206.351C419.901 205.843 420.987 205.098 421.895 204.161C422.802 203.224 423.511 202.115 423.981 200.898C424.451 199.682 424.672 198.383 424.63 197.08H426.76C426.76 199.661 427.785 202.135 429.61 203.96C431.435 205.785 433.91 206.81 436.49 206.81C439.071 206.81 441.546 205.785 443.37 203.96C445.195 202.135 446.22 199.661 446.22 197.08H448.35C448.35 199.661 449.375 202.135 451.2 203.96C453.025 205.785 455.5 206.81 458.08 206.81C460.661 206.81 463.136 205.785 464.96 203.96C466.785 202.135 467.81 199.661 467.81 197.08H469.94C469.94 199.661 470.965 202.135 472.79 203.96C474.615 205.785 477.09 206.81 479.67 206.81C482.251 206.81 484.726 205.785 486.55 203.96C488.375 202.135 489.4 199.661 489.4 197.08H491.53C491.53 199.661 492.555 202.135 494.38 203.96C496.205 205.785 498.68 206.81 501.26 206.81C503.841 206.81 506.316 205.785 508.14 203.96C509.965 202.135 510.99 199.661 510.99 197.08H513.12C513.078 198.383 513.299 199.682 513.769 200.898C514.239 202.115 514.948 203.224 515.856 204.161C516.763 205.098 517.849 205.843 519.05 206.351C520.25 206.86 521.541 207.122 522.845 207.122C524.149 207.122 525.44 206.86 526.641 206.351C527.841 205.843 528.927 205.098 529.835 204.161C530.742 203.224 531.451 202.115 531.921 200.898C532.391 199.682 532.612 198.383 532.57 197.08H534.7C534.7 199.661 535.725 202.135 537.55 203.96C539.375 205.785 541.85 206.81 544.43 206.81C547.011 206.81 549.486 205.785 551.31 203.96C553.135 202.135 554.16 199.661 554.16 197.08H556.3C556.3 199.661 557.325 202.135 559.15 203.96C560.975 205.785 563.45 206.81 566.03 206.81C568.611 206.81 571.086 205.785 572.91 203.96C574.735 202.135 575.76 199.661 575.76 197.08H577.89C577.887 200.226 576.636 203.243 574.41 205.467C572.184 207.691 569.166 208.94 566.02 208.94Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M566.02 188.01C563.744 188.006 561.516 187.349 559.602 186.117C557.688 184.885 556.167 183.13 555.22 181.06C554.279 183.133 552.761 184.89 550.848 186.123C548.934 187.356 546.706 188.011 544.43 188.011C542.154 188.011 539.926 187.356 538.012 186.123C536.099 184.89 534.581 183.133 533.64 181.06C532.697 183.132 531.178 184.889 529.264 186.121C527.35 187.353 525.121 188.008 522.845 188.008C520.569 188.008 518.34 187.353 516.426 186.121C514.512 184.889 512.993 183.132 512.05 181.06C511.107 183.132 509.588 184.889 507.674 186.121C505.76 187.353 503.531 188.008 501.255 188.008C498.979 188.008 496.75 187.353 494.836 186.121C492.922 184.889 491.403 183.132 490.46 181.06C489.519 183.133 488.001 184.89 486.088 186.123C484.174 187.356 481.946 188.011 479.67 188.011C477.394 188.011 475.166 187.356 473.252 186.123C471.339 184.89 469.821 183.133 468.88 181.06C467.937 183.132 466.418 184.889 464.504 186.121C462.59 187.353 460.361 188.008 458.085 188.008C455.809 188.008 453.58 187.353 451.666 186.121C449.752 184.889 448.233 183.132 447.29 181.06C446.347 183.132 444.828 184.889 442.914 186.121C441 187.353 438.771 188.008 436.495 188.008C434.219 188.008 431.99 187.353 430.076 186.121C428.162 184.889 426.643 183.132 425.7 181.06C424.757 183.132 423.238 184.889 421.324 186.121C419.41 187.353 417.181 188.008 414.905 188.008C412.629 188.008 410.4 187.353 408.486 186.121C406.572 184.889 405.053 183.132 404.11 181.06C403.167 183.132 401.648 184.889 399.734 186.121C397.82 187.353 395.591 188.008 393.315 188.008C391.039 188.008 388.81 187.353 386.896 186.121C384.982 184.889 383.463 183.132 382.52 181.06C381.579 183.133 380.061 184.89 378.148 186.123C376.234 187.356 374.006 188.011 371.73 188.011C369.454 188.011 367.226 187.356 365.312 186.123C363.399 184.89 361.881 183.133 360.94 181.06C359.997 183.132 358.478 184.889 356.564 186.121C354.65 187.353 352.421 188.008 350.145 188.008C347.869 188.008 345.64 187.353 343.726 186.121C341.812 184.889 340.293 183.132 339.35 181.06C338.227 183.523 336.294 185.527 333.875 186.74C331.455 187.953 328.693 188.301 326.047 187.728C323.402 187.154 321.032 185.693 319.332 183.587C317.632 181.481 316.703 178.857 316.7 176.15H318.83C318.83 178.731 319.855 181.205 321.68 183.03C323.505 184.855 325.98 185.88 328.56 185.88C331.141 185.88 333.615 184.855 335.44 183.03C337.265 181.205 338.29 178.731 338.29 176.15H340.42C340.378 177.453 340.599 178.752 341.069 179.968C341.539 181.185 342.248 182.294 343.156 183.231C344.063 184.168 345.149 184.912 346.35 185.421C347.55 185.93 348.841 186.192 350.145 186.192C351.449 186.192 352.74 185.93 353.941 185.421C355.141 184.912 356.227 184.168 357.135 183.231C358.042 182.294 358.751 181.185 359.221 179.968C359.691 178.752 359.912 177.453 359.87 176.15H362C362 178.731 363.025 181.205 364.85 183.03C366.675 184.855 369.15 185.88 371.73 185.88C374.311 185.88 376.785 184.855 378.61 183.03C380.435 181.205 381.46 178.731 381.46 176.15H383.59C383.59 178.731 384.615 181.205 386.44 183.03C388.265 184.855 390.74 185.88 393.32 185.88C395.901 185.88 398.375 184.855 400.2 183.03C402.025 181.205 403.05 178.731 403.05 176.15H405.18C405.138 177.453 405.359 178.752 405.829 179.968C406.299 181.185 407.008 182.294 407.916 183.231C408.823 184.168 409.909 184.912 411.11 185.421C412.31 185.93 413.601 186.192 414.905 186.192C416.209 186.192 417.5 185.93 418.701 185.421C419.901 184.912 420.987 184.168 421.895 183.231C422.802 182.294 423.511 181.185 423.981 179.968C424.451 178.752 424.672 177.453 424.63 176.15H426.76C426.76 178.731 427.785 181.205 429.61 183.03C431.435 184.855 433.91 185.88 436.49 185.88C439.071 185.88 441.546 184.855 443.37 183.03C445.195 181.205 446.22 178.731 446.22 176.15H448.35C448.35 178.731 449.375 181.205 451.2 183.03C453.025 184.855 455.5 185.88 458.08 185.88C460.661 185.88 463.136 184.855 464.96 183.03C466.785 181.205 467.81 178.731 467.81 176.15H469.94C469.94 178.731 470.965 181.205 472.79 183.03C474.615 184.855 477.09 185.88 479.67 185.88C482.251 185.88 484.726 184.855 486.55 183.03C488.375 181.205 489.4 178.731 489.4 176.15H491.53C491.53 178.731 492.555 181.205 494.38 183.03C496.205 184.855 498.68 185.88 501.26 185.88C503.841 185.88 506.316 184.855 508.14 183.03C509.965 181.205 510.99 178.731 510.99 176.15H513.12C513.078 177.453 513.299 178.752 513.769 179.968C514.239 181.185 514.948 182.294 515.856 183.231C516.763 184.168 517.849 184.912 519.05 185.421C520.25 185.93 521.541 186.192 522.845 186.192C524.149 186.192 525.44 185.93 526.641 185.421C527.841 184.912 528.927 184.168 529.835 183.231C530.742 182.294 531.451 181.185 531.921 179.968C532.391 178.752 532.612 177.453 532.57 176.15H534.7C534.7 178.731 535.725 181.205 537.55 183.03C539.375 184.855 541.85 185.88 544.43 185.88C547.011 185.88 549.485 184.855 551.31 183.03C553.135 181.205 554.16 178.731 554.16 176.15H556.3C556.3 178.731 557.325 181.205 559.15 183.03C560.975 184.855 563.45 185.88 566.03 185.88C568.611 185.88 571.086 184.855 572.91 183.03C574.735 181.205 575.76 178.731 575.76 176.15H577.89C577.887 179.296 576.636 182.313 574.41 184.537C572.184 186.761 569.166 188.01 566.02 188.01Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M566.02 167.07C563.743 167.067 561.515 166.411 559.601 165.179C557.686 163.947 556.166 162.191 555.22 160.12C554.279 162.193 552.761 163.95 550.848 165.183C548.934 166.416 546.706 167.071 544.43 167.071C542.154 167.071 539.926 166.416 538.012 165.183C536.099 163.95 534.581 162.193 533.64 160.12C532.697 162.192 531.178 163.949 529.264 165.181C527.35 166.413 525.121 167.068 522.845 167.068C520.569 167.068 518.34 166.413 516.426 165.181C514.512 163.949 512.993 162.192 512.05 160.12C511.107 162.192 509.588 163.949 507.674 165.181C505.76 166.413 503.531 167.068 501.255 167.068C498.979 167.068 496.75 166.413 494.836 165.181C492.922 163.949 491.403 162.192 490.46 160.12C489.519 162.193 488.001 163.95 486.088 165.183C484.174 166.416 481.946 167.071 479.67 167.071C477.394 167.071 475.166 166.416 473.252 165.183C471.339 163.95 469.821 162.193 468.88 160.12C467.937 162.192 466.418 163.949 464.504 165.181C462.59 166.413 460.361 167.068 458.085 167.068C455.809 167.068 453.58 166.413 451.666 165.181C449.752 163.949 448.233 162.192 447.29 160.12C446.347 162.192 444.828 163.949 442.914 165.181C441 166.413 438.771 167.068 436.495 167.068C434.219 167.068 431.99 166.413 430.076 165.181C428.162 163.949 426.643 162.192 425.7 160.12C424.757 162.192 423.238 163.949 421.324 165.181C419.41 166.413 417.181 167.068 414.905 167.068C412.629 167.068 410.4 166.413 408.486 165.181C406.572 163.949 405.053 162.192 404.11 160.12C403.167 162.192 401.648 163.949 399.734 165.181C397.82 166.413 395.591 167.068 393.315 167.068C391.039 167.068 388.81 166.413 386.896 165.181C384.982 163.949 383.463 162.192 382.52 160.12C381.579 162.193 380.061 163.95 378.148 165.183C376.234 166.416 374.006 167.071 371.73 167.071C369.454 167.071 367.226 166.416 365.312 165.183C363.399 163.95 361.881 162.193 360.94 160.12C359.813 162.577 357.881 164.575 355.463 165.783C353.046 166.992 350.288 167.339 347.646 166.766C345.005 166.193 342.638 164.735 340.939 162.633C339.239 160.532 338.308 157.913 338.3 155.21H340.43C340.388 156.513 340.609 157.812 341.079 159.028C341.549 160.245 342.258 161.354 343.165 162.291C344.073 163.228 345.159 163.972 346.36 164.481C347.56 164.99 348.851 165.252 350.155 165.252C351.459 165.252 352.75 164.99 353.951 164.481C355.151 163.972 356.237 163.228 357.145 162.291C358.052 161.354 358.761 160.245 359.231 159.028C359.701 157.812 359.922 156.513 359.88 155.21H362.01C362.01 157.791 363.035 160.265 364.86 162.09C366.685 163.915 369.159 164.94 371.74 164.94C374.321 164.94 376.795 163.915 378.62 162.09C380.445 160.265 381.47 157.791 381.47 155.21H383.6C383.6 157.791 384.625 160.265 386.45 162.09C388.275 163.915 390.749 164.94 393.33 164.94C395.911 164.94 398.385 163.915 400.21 162.09C402.035 160.265 403.06 157.791 403.06 155.21H405.19C405.148 156.513 405.369 157.812 405.839 159.028C406.309 160.245 407.018 161.354 407.926 162.291C408.833 163.228 409.919 163.972 411.12 164.481C412.32 164.99 413.611 165.252 414.915 165.252C416.219 165.252 417.51 164.99 418.71 164.481C419.911 163.972 420.997 163.228 421.905 162.291C422.812 161.354 423.521 160.245 423.991 159.028C424.461 157.812 424.682 156.513 424.64 155.21H426.77C426.77 157.791 427.795 160.265 429.62 162.09C431.445 163.915 433.92 164.94 436.5 164.94C439.081 164.94 441.555 163.915 443.38 162.09C445.205 160.265 446.23 157.791 446.23 155.21H448.36C448.36 157.791 449.385 160.265 451.21 162.09C453.035 163.915 455.509 164.94 458.09 164.94C460.671 164.94 463.145 163.915 464.97 162.09C466.795 160.265 467.82 157.791 467.82 155.21H469.95C469.95 157.791 470.975 160.265 472.8 162.09C474.625 163.915 477.1 164.94 479.68 164.94C482.261 164.94 484.735 163.915 486.56 162.09C488.385 160.265 489.41 157.791 489.41 155.21H491.54C491.54 157.791 492.565 160.265 494.39 162.09C496.215 163.915 498.689 164.94 501.27 164.94C503.851 164.94 506.325 163.915 508.15 162.09C509.975 160.265 511 157.791 511 155.21H513.13C513.088 156.513 513.309 157.812 513.779 159.028C514.249 160.245 514.958 161.354 515.865 162.291C516.773 163.228 517.859 163.972 519.06 164.481C520.26 164.99 521.551 165.252 522.855 165.252C524.159 165.252 525.45 164.99 526.651 164.481C527.851 163.972 528.937 163.228 529.845 162.291C530.752 161.354 531.461 160.245 531.931 159.028C532.401 157.812 532.622 156.513 532.58 155.21H534.71C534.71 157.791 535.735 160.265 537.56 162.09C539.385 163.915 541.86 164.94 544.44 164.94C547.021 164.94 549.495 163.915 551.32 162.09C553.145 160.265 554.17 157.791 554.17 155.21H556.3C556.3 157.791 557.325 160.265 559.15 162.09C560.975 163.915 563.449 164.94 566.03 164.94C568.611 164.94 571.085 163.915 572.91 162.09C574.735 160.265 575.76 157.791 575.76 155.21H577.89C577.887 158.356 576.636 161.373 574.41 163.597C572.184 165.821 569.166 167.07 566.02 167.07Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M576.81 238.51C574.34 238.357 572.021 237.269 570.325 235.467C568.629 233.665 567.683 231.285 567.68 228.81H565.55C565.592 230.113 565.371 231.412 564.901 232.628C564.431 233.845 563.722 234.954 562.815 235.891C561.907 236.828 560.821 237.572 559.62 238.081C558.42 238.59 557.129 238.852 555.825 238.852C554.521 238.852 553.23 238.59 552.03 238.081C550.829 237.572 549.743 236.828 548.836 235.891C547.928 234.954 547.219 233.845 546.749 232.628C546.279 231.412 546.058 230.113 546.1 228.81H543.97C543.97 231.391 542.945 233.865 541.12 235.69C539.295 237.515 536.821 238.54 534.24 238.54C531.659 238.54 529.185 237.515 527.36 235.69C525.535 233.865 524.51 231.391 524.51 228.81H522.38C522.38 231.391 521.355 233.865 519.53 235.69C517.705 237.515 515.231 238.54 512.65 238.54C510.069 238.54 507.595 237.515 505.77 235.69C503.945 233.865 502.92 231.391 502.92 228.81H500.79C500.79 231.391 499.765 233.865 497.94 235.69C496.115 237.515 493.641 238.54 491.06 238.54C488.48 238.54 486.005 237.515 484.18 235.69C482.355 233.865 481.33 231.391 481.33 228.81H479.2C479.242 230.113 479.021 231.412 478.551 232.628C478.081 233.845 477.372 234.954 476.465 235.891C475.557 236.828 474.471 237.572 473.27 238.081C472.07 238.59 470.779 238.852 469.475 238.852C468.171 238.852 466.88 238.59 465.68 238.081C464.479 237.572 463.393 236.828 462.486 235.891C461.578 234.954 460.869 233.845 460.399 232.628C459.929 231.412 459.708 230.113 459.75 228.81H457.62C457.62 231.391 456.595 233.865 454.77 235.69C452.945 237.515 450.471 238.54 447.89 238.54C445.309 238.54 442.835 237.515 441.01 235.69C439.185 233.865 438.16 231.391 438.16 228.81H436.03C436.03 231.391 435.005 233.865 433.18 235.69C431.355 237.515 428.881 238.54 426.3 238.54C423.719 238.54 421.245 237.515 419.42 235.69C417.595 233.865 416.57 231.391 416.57 228.81H414.44C414.44 231.391 413.415 233.865 411.59 235.69C409.765 237.515 407.291 238.54 404.71 238.54C402.13 238.54 399.655 237.515 397.83 235.69C396.005 233.865 394.98 231.391 394.98 228.81H392.85C392.892 230.113 392.671 231.412 392.201 232.628C391.731 233.845 391.022 234.954 390.115 235.891C389.207 236.828 388.121 237.572 386.921 238.081C385.72 238.59 384.429 238.852 383.125 238.852C381.821 238.852 380.53 238.59 379.33 238.081C378.129 237.572 377.043 236.828 376.135 235.891C375.228 234.954 374.519 233.845 374.049 232.628C373.579 231.412 373.358 230.113 373.4 228.81H371.3C371.3 231.391 370.275 233.865 368.45 235.69C366.625 237.515 364.151 238.54 361.57 238.54C358.989 238.54 356.515 237.515 354.69 235.69C352.865 233.865 351.84 231.391 351.84 228.81H349.71C349.71 231.391 348.685 233.865 346.86 235.69C345.035 237.515 342.561 238.54 339.98 238.54C337.399 238.54 334.925 237.515 333.1 235.69C331.275 233.865 330.25 231.391 330.25 228.81H328.12C328.12 231.391 327.095 233.865 325.27 235.69C323.445 237.515 320.971 238.54 318.39 238.54C315.809 238.54 313.335 237.515 311.51 235.69C309.685 233.865 308.66 231.391 308.66 228.81H306.5C306.542 230.113 306.321 231.412 305.851 232.628C305.381 233.845 304.672 234.954 303.765 235.891C302.857 236.828 301.771 237.572 300.57 238.081C299.37 238.59 298.079 238.852 296.775 238.852C295.471 238.852 294.18 238.59 292.98 238.081C291.779 237.572 290.693 236.828 289.785 235.891C288.878 234.954 288.169 233.845 287.699 232.628C287.229 231.412 287.008 230.113 287.05 228.81H284.92C284.92 231.391 283.895 233.865 282.07 235.69C280.245 237.515 277.771 238.54 275.19 238.54C272.61 238.54 270.135 237.515 268.31 235.69C266.485 233.865 265.46 231.391 265.46 228.81H263.3C263.303 231.517 264.232 234.141 265.932 236.247C267.632 238.353 270.002 239.814 272.647 240.388C275.293 240.961 278.055 240.613 280.475 239.4C282.894 238.187 284.826 236.183 285.95 233.72C286.893 235.792 288.412 237.549 290.326 238.781C292.24 240.013 294.469 240.668 296.745 240.668C299.021 240.668 301.25 240.013 303.164 238.781C305.078 237.549 306.597 235.792 307.54 233.72C308.483 235.792 310.002 237.549 311.916 238.781C313.83 240.013 316.059 240.668 318.335 240.668C320.611 240.668 322.84 240.013 324.754 238.781C326.668 237.549 328.187 235.792 329.13 233.72C330.071 235.793 331.589 237.55 333.502 238.783C335.416 240.016 337.644 240.671 339.92 240.671C342.196 240.671 344.424 240.016 346.338 238.783C348.251 237.55 349.769 235.793 350.71 233.72C351.653 235.792 353.172 237.549 355.086 238.781C357 240.013 359.229 240.668 361.505 240.668C363.781 240.668 366.01 240.013 367.924 238.781C369.838 237.549 371.357 235.792 372.3 233.72C373.243 235.792 374.762 237.549 376.676 238.781C378.59 240.013 380.819 240.668 383.095 240.668C385.371 240.668 387.6 240.013 389.514 238.781C391.428 237.549 392.947 235.792 393.89 233.72C394.833 235.792 396.352 237.549 398.266 238.781C400.18 240.013 402.409 240.668 404.685 240.668C406.961 240.668 409.19 240.013 411.104 238.781C413.018 237.549 414.537 235.792 415.48 233.72C416.421 235.793 417.939 237.55 419.852 238.783C421.766 240.016 423.994 240.671 426.27 240.671C428.546 240.671 430.774 240.016 432.688 238.783C434.601 237.55 436.119 235.793 437.06 233.72C438.003 235.792 439.522 237.549 441.436 238.781C443.35 240.013 445.579 240.668 447.855 240.668C450.131 240.668 452.36 240.013 454.274 238.781C456.188 237.549 457.707 235.792 458.65 233.72C459.593 235.792 461.112 237.549 463.026 238.781C464.94 240.013 467.169 240.668 469.445 240.668C471.721 240.668 473.95 240.013 475.864 238.781C477.778 237.549 479.297 235.792 480.24 233.72C481.181 235.793 482.699 237.55 484.612 238.783C486.526 240.016 488.754 240.671 491.03 240.671C493.306 240.671 495.534 240.016 497.448 238.783C499.361 237.55 500.879 235.793 501.82 233.72C502.763 235.792 504.282 237.549 506.196 238.781C508.11 240.013 510.339 240.668 512.615 240.668C514.891 240.668 517.12 240.013 519.034 238.781C520.948 237.549 522.467 235.792 523.41 233.72C524.353 235.792 525.872 237.549 527.786 238.781C529.7 240.013 531.929 240.668 534.205 240.668C536.481 240.668 538.71 240.013 540.624 238.781C542.538 237.549 544.057 235.792 545 233.72C545.943 235.792 547.462 237.549 549.376 238.781C551.29 240.013 553.519 240.668 555.795 240.668C558.071 240.668 560.3 240.013 562.214 238.781C564.128 237.549 565.647 235.792 566.59 233.72C567.491 235.698 568.917 237.39 570.714 238.612C572.511 239.835 574.61 240.539 576.78 240.65L576.81 238.51Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M567.68 207.88H565.55C565.592 209.183 565.371 210.482 564.901 211.698C564.431 212.915 563.722 214.024 562.815 214.961C561.907 215.898 560.821 216.642 559.62 217.151C558.42 217.66 557.129 217.922 555.825 217.922C554.521 217.922 553.23 217.66 552.03 217.151C550.829 216.642 549.743 215.898 548.836 214.961C547.928 214.024 547.219 212.915 546.749 211.698C546.279 210.482 546.058 209.183 546.1 207.88H543.97C543.97 210.461 542.945 212.935 541.12 214.76C539.295 216.585 536.821 217.61 534.24 217.61C531.66 217.61 529.185 216.585 527.36 214.76C525.535 212.935 524.51 210.461 524.51 207.88H522.38C522.38 210.461 521.355 212.935 519.53 214.76C517.705 216.585 515.231 217.61 512.65 217.61C510.069 217.61 507.595 216.585 505.77 214.76C503.945 212.935 502.92 210.461 502.92 207.88H500.79C500.79 210.461 499.765 212.935 497.94 214.76C496.115 216.585 493.641 217.61 491.06 217.61C488.48 217.61 486.005 216.585 484.18 214.76C482.355 212.935 481.33 210.461 481.33 207.88H479.2C479.242 209.183 479.021 210.482 478.551 211.698C478.081 212.915 477.372 214.024 476.465 214.961C475.557 215.898 474.471 216.642 473.27 217.151C472.07 217.66 470.779 217.922 469.475 217.922C468.171 217.922 466.88 217.66 465.68 217.151C464.479 216.642 463.393 215.898 462.486 214.961C461.578 214.024 460.869 212.915 460.399 211.698C459.929 210.482 459.708 209.183 459.75 207.88H457.62C457.62 210.461 456.595 212.935 454.77 214.76C452.945 216.585 450.471 217.61 447.89 217.61C445.309 217.61 442.835 216.585 441.01 214.76C439.185 212.935 438.16 210.461 438.16 207.88H436.03C436.03 210.461 435.005 212.935 433.18 214.76C431.355 216.585 428.881 217.61 426.3 217.61C423.719 217.61 421.245 216.585 419.42 214.76C417.595 212.935 416.57 210.461 416.57 207.88H414.44C414.44 210.461 413.415 212.935 411.59 214.76C409.765 216.585 407.291 217.61 404.71 217.61C402.129 217.61 399.655 216.585 397.83 214.76C396.005 212.935 394.98 210.461 394.98 207.88H392.85C392.892 209.183 392.671 210.482 392.201 211.698C391.731 212.915 391.022 214.024 390.115 214.961C389.207 215.898 388.121 216.642 386.921 217.151C385.72 217.66 384.429 217.922 383.125 217.922C381.821 217.922 380.53 217.66 379.33 217.151C378.129 216.642 377.043 215.898 376.135 214.961C375.228 214.024 374.519 212.915 374.049 211.698C373.579 210.482 373.358 209.183 373.4 207.88H371.3C371.3 210.461 370.275 212.935 368.45 214.76C366.625 216.585 364.151 217.61 361.57 217.61C358.989 217.61 356.515 216.585 354.69 214.76C352.865 212.935 351.84 210.461 351.84 207.88H349.71C349.71 210.461 348.685 212.935 346.86 214.76C345.035 216.585 342.561 217.61 339.98 217.61C337.399 217.61 334.925 216.585 333.1 214.76C331.275 212.935 330.25 210.461 330.25 207.88H328.12C328.12 210.461 327.095 212.935 325.27 214.76C323.445 216.585 320.971 217.61 318.39 217.61C315.809 217.61 313.335 216.585 311.51 214.76C309.685 212.935 308.66 210.461 308.66 207.88H306.5C306.542 209.183 306.321 210.482 305.851 211.698C305.381 212.915 304.672 214.024 303.765 214.961C302.857 215.898 301.771 216.642 300.57 217.151C299.37 217.66 298.079 217.922 296.775 217.922C295.471 217.922 294.18 217.66 292.98 217.151C291.779 216.642 290.693 215.898 289.785 214.961C288.878 214.024 288.169 212.915 287.699 211.698C287.229 210.482 287.008 209.183 287.05 207.88H284.92C284.923 210.587 285.852 213.211 287.552 215.317C289.252 217.423 291.622 218.884 294.267 219.458C296.913 220.031 299.675 219.683 302.095 218.47C304.514 217.257 306.446 215.253 307.57 212.79C308.513 214.862 310.032 216.619 311.946 217.851C313.86 219.083 316.089 219.738 318.365 219.738C320.641 219.738 322.87 219.083 324.784 217.851C326.698 216.619 328.217 214.862 329.16 212.79C330.101 214.863 331.619 216.62 333.532 217.853C335.446 219.086 337.674 219.741 339.95 219.741C342.226 219.741 344.454 219.086 346.368 217.853C348.281 216.62 349.799 214.863 350.74 212.79C351.683 214.862 353.202 216.619 355.116 217.851C357.03 219.083 359.259 219.738 361.535 219.738C363.811 219.738 366.04 219.083 367.954 217.851C369.868 216.619 371.387 214.862 372.33 212.79C373.273 214.862 374.792 216.619 376.706 217.851C378.62 219.083 380.849 219.738 383.125 219.738C385.401 219.738 387.63 219.083 389.544 217.851C391.458 216.619 392.977 214.862 393.92 212.79C394.863 214.862 396.382 216.619 398.296 217.851C400.21 219.083 402.439 219.738 404.715 219.738C406.991 219.738 409.22 219.083 411.134 217.851C413.048 216.619 414.567 214.862 415.51 212.79C416.451 214.863 417.969 216.62 419.882 217.853C421.796 219.086 424.024 219.741 426.3 219.741C428.576 219.741 430.804 219.086 432.718 217.853C434.631 216.62 436.149 214.863 437.09 212.79C438.033 214.862 439.552 216.619 441.466 217.851C443.38 219.083 445.609 219.738 447.885 219.738C450.161 219.738 452.39 219.083 454.304 217.851C456.218 216.619 457.737 214.862 458.68 212.79C459.623 214.862 461.142 216.619 463.056 217.851C464.97 219.083 467.199 219.738 469.475 219.738C471.751 219.738 473.98 219.083 475.894 217.851C477.808 216.619 479.327 214.862 480.27 212.79C481.211 214.863 482.729 216.62 484.642 217.853C486.556 219.086 488.784 219.741 491.06 219.741C493.336 219.741 495.564 219.086 497.478 217.853C499.391 216.62 500.909 214.863 501.85 212.79C502.793 214.862 504.312 216.619 506.226 217.851C508.14 219.083 510.369 219.738 512.645 219.738C514.921 219.738 517.15 219.083 519.064 217.851C520.978 216.619 522.497 214.862 523.44 212.79C524.383 214.862 525.902 216.619 527.816 217.851C529.73 219.083 531.959 219.738 534.235 219.738C536.511 219.738 538.74 219.083 540.654 217.851C542.568 216.619 544.087 214.862 545.03 212.79C545.973 214.862 547.492 216.619 549.406 217.851C551.32 219.083 553.549 219.738 555.825 219.738C558.101 219.738 560.33 219.083 562.244 217.851C564.158 216.619 565.677 214.862 566.62 212.79C567.522 214.766 568.949 216.456 570.746 217.677C572.543 218.897 574.641 219.6 576.81 219.71V217.58C574.342 217.423 572.025 216.333 570.33 214.532C568.635 212.731 567.688 210.353 567.68 207.88Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M576.81 196.64C574.341 196.485 572.023 195.396 570.328 193.595C568.632 191.793 567.685 189.414 567.68 186.94H565.55C565.592 188.243 565.371 189.542 564.901 190.758C564.431 191.975 563.722 193.084 562.815 194.021C561.907 194.958 560.821 195.703 559.62 196.211C558.42 196.72 557.129 196.982 555.825 196.982C554.521 196.982 553.23 196.72 552.03 196.211C550.829 195.703 549.743 194.958 548.835 194.021C547.928 193.084 547.219 191.975 546.749 190.758C546.279 189.542 546.058 188.243 546.1 186.94H543.97C543.97 189.521 542.945 191.995 541.12 193.82C539.295 195.645 536.821 196.67 534.24 196.67C531.659 196.67 529.185 195.645 527.36 193.82C525.535 191.995 524.51 189.521 524.51 186.94H522.38C522.38 189.521 521.355 191.995 519.53 193.82C517.705 195.645 515.231 196.67 512.65 196.67C510.069 196.67 507.595 195.645 505.77 193.82C503.945 191.995 502.92 189.521 502.92 186.94H500.79C500.79 189.521 499.765 191.995 497.94 193.82C496.115 195.645 493.641 196.67 491.06 196.67C488.479 196.67 486.005 195.645 484.18 193.82C482.355 191.995 481.33 189.521 481.33 186.94H479.2C479.242 188.243 479.021 189.542 478.551 190.758C478.081 191.975 477.372 193.084 476.465 194.021C475.557 194.958 474.471 195.703 473.27 196.211C472.07 196.72 470.779 196.982 469.475 196.982C468.171 196.982 466.88 196.72 465.68 196.211C464.479 195.703 463.393 194.958 462.485 194.021C461.578 193.084 460.869 191.975 460.399 190.758C459.929 189.542 459.708 188.243 459.75 186.94H457.62C457.62 189.521 456.595 191.995 454.77 193.82C452.945 195.645 450.471 196.67 447.89 196.67C445.309 196.67 442.835 195.645 441.01 193.82C439.185 191.995 438.16 189.521 438.16 186.94H436.03C436.03 189.521 435.005 191.995 433.18 193.82C431.355 195.645 428.881 196.67 426.3 196.67C423.719 196.67 421.245 195.645 419.42 193.82C417.595 191.995 416.57 189.521 416.57 186.94H414.44C414.44 189.521 413.415 191.995 411.59 193.82C409.765 195.645 407.291 196.67 404.71 196.67C402.129 196.67 399.655 195.645 397.83 193.82C396.005 191.995 394.98 189.521 394.98 186.94H392.85C392.892 188.243 392.671 189.542 392.201 190.758C391.731 191.975 391.022 193.084 390.115 194.021C389.207 194.958 388.121 195.703 386.92 196.211C385.72 196.72 384.429 196.982 383.125 196.982C381.821 196.982 380.53 196.72 379.33 196.211C378.129 195.703 377.043 194.958 376.135 194.021C375.228 193.084 374.519 191.975 374.049 190.758C373.579 189.542 373.358 188.243 373.4 186.94H371.3C371.3 189.521 370.275 191.995 368.45 193.82C366.625 195.645 364.151 196.67 361.57 196.67C358.989 196.67 356.515 195.645 354.69 193.82C352.865 191.995 351.84 189.521 351.84 186.94H349.71C349.71 189.521 348.685 191.995 346.86 193.82C345.035 195.645 342.561 196.67 339.98 196.67C337.399 196.67 334.925 195.645 333.1 193.82C331.275 191.995 330.25 189.521 330.25 186.94H328.12C328.12 189.521 327.095 191.995 325.27 193.82C323.445 195.645 320.971 196.67 318.39 196.67C315.809 196.67 313.335 195.645 311.51 193.82C309.685 191.995 308.66 189.521 308.66 186.94H306.5C306.498 189.651 307.425 192.28 309.125 194.391C310.826 196.502 313.199 197.966 315.848 198.54C318.498 199.114 321.264 198.763 323.686 197.546C326.108 196.329 328.04 194.319 329.16 191.85C330.101 193.923 331.619 195.68 333.532 196.913C335.446 198.146 337.674 198.801 339.95 198.801C342.226 198.801 344.454 198.146 346.368 196.913C348.281 195.68 349.799 193.923 350.74 191.85C351.683 193.922 353.202 195.679 355.116 196.911C357.03 198.143 359.259 198.798 361.535 198.798C363.811 198.798 366.04 198.143 367.954 196.911C369.868 195.679 371.387 193.922 372.33 191.85C373.273 193.922 374.792 195.679 376.706 196.911C378.62 198.143 380.849 198.798 383.125 198.798C385.401 198.798 387.63 198.143 389.544 196.911C391.458 195.679 392.977 193.922 393.92 191.85C394.863 193.922 396.382 195.679 398.296 196.911C400.21 198.143 402.439 198.798 404.715 198.798C406.991 198.798 409.22 198.143 411.134 196.911C413.048 195.679 414.567 193.922 415.51 191.85C416.451 193.923 417.969 195.68 419.882 196.913C421.796 198.146 424.024 198.801 426.3 198.801C428.576 198.801 430.804 198.146 432.718 196.913C434.631 195.68 436.149 193.923 437.09 191.85C438.033 193.922 439.552 195.679 441.466 196.911C443.38 198.143 445.609 198.798 447.885 198.798C450.161 198.798 452.39 198.143 454.304 196.911C456.218 195.679 457.737 193.922 458.68 191.85C459.623 193.922 461.142 195.679 463.056 196.911C464.97 198.143 467.199 198.798 469.475 198.798C471.751 198.798 473.98 198.143 475.894 196.911C477.808 195.679 479.327 193.922 480.27 191.85C481.211 193.923 482.729 195.68 484.642 196.913C486.556 198.146 488.784 198.801 491.06 198.801C493.336 198.801 495.564 198.146 497.478 196.913C499.391 195.68 500.909 193.923 501.85 191.85C502.793 193.922 504.312 195.679 506.226 196.911C508.14 198.143 510.369 198.798 512.645 198.798C514.921 198.798 517.15 198.143 519.064 196.911C520.978 195.679 522.497 193.922 523.44 191.85C524.383 193.922 525.902 195.679 527.816 196.911C529.73 198.143 531.959 198.798 534.235 198.798C536.511 198.798 538.74 198.143 540.654 196.911C542.568 195.679 544.087 193.922 545.03 191.85C545.973 193.922 547.492 195.679 549.406 196.911C551.32 198.143 553.549 198.798 555.825 198.798C558.101 198.798 560.33 198.143 562.244 196.911C564.158 195.679 565.677 193.922 566.62 191.85C567.522 193.827 568.949 195.518 570.746 196.74C572.543 197.961 574.64 198.667 576.81 198.78V196.64Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M576.81 175.7C574.34 175.547 572.021 174.459 570.325 172.657C568.629 170.855 567.683 168.475 567.68 166H565.55C565.592 167.303 565.371 168.602 564.901 169.818C564.431 171.035 563.722 172.144 562.815 173.081C561.907 174.018 560.821 174.762 559.621 175.271C558.42 175.78 557.129 176.042 555.825 176.042C554.521 176.042 553.23 175.78 552.03 175.271C550.829 174.762 549.743 174.018 548.836 173.081C547.928 172.144 547.219 171.035 546.749 169.818C546.279 168.602 546.058 167.303 546.1 166H543.97C543.97 168.581 542.945 171.055 541.12 172.88C539.296 174.705 536.821 175.73 534.24 175.73C531.66 175.73 529.185 174.705 527.36 172.88C525.535 171.055 524.51 168.581 524.51 166H522.38C522.38 168.581 521.355 171.055 519.53 172.88C517.706 174.705 515.231 175.73 512.65 175.73C510.07 175.73 507.595 174.705 505.77 172.88C503.945 171.055 502.92 168.581 502.92 166H500.79C500.79 168.581 499.765 171.055 497.94 172.88C496.116 174.705 493.641 175.73 491.06 175.73C488.48 175.73 486.005 174.705 484.18 172.88C482.355 171.055 481.33 168.581 481.33 166H479.2C479.242 167.303 479.021 168.602 478.551 169.818C478.081 171.035 477.372 172.144 476.465 173.081C475.557 174.018 474.471 174.762 473.271 175.271C472.07 175.78 470.779 176.042 469.475 176.042C468.171 176.042 466.88 175.78 465.68 175.271C464.479 174.762 463.393 174.018 462.486 173.081C461.578 172.144 460.869 171.035 460.399 169.818C459.929 168.602 459.708 167.303 459.75 166H457.62C457.62 168.581 456.595 171.055 454.77 172.88C452.946 174.705 450.471 175.73 447.89 175.73C445.31 175.73 442.835 174.705 441.01 172.88C439.185 171.055 438.16 168.581 438.16 166H436.03C436.03 168.581 435.005 171.055 433.18 172.88C431.356 174.705 428.881 175.73 426.3 175.73C423.72 175.73 421.245 174.705 419.42 172.88C417.595 171.055 416.57 168.581 416.57 166H414.44C414.44 168.581 413.415 171.055 411.59 172.88C409.766 174.705 407.291 175.73 404.71 175.73C402.13 175.73 399.655 174.705 397.83 172.88C396.005 171.055 394.98 168.581 394.98 166H392.85C392.892 167.303 392.671 168.602 392.201 169.818C391.731 171.035 391.022 172.144 390.115 173.081C389.207 174.018 388.121 174.762 386.921 175.271C385.72 175.78 384.429 176.042 383.125 176.042C381.821 176.042 380.53 175.78 379.33 175.271C378.129 174.762 377.043 174.018 376.136 173.081C375.228 172.144 374.519 171.035 374.049 169.818C373.579 168.602 373.358 167.303 373.4 166H371.3C371.3 168.581 370.275 171.055 368.45 172.88C366.626 174.705 364.151 175.73 361.57 175.73C358.99 175.73 356.515 174.705 354.69 172.88C352.865 171.055 351.84 168.581 351.84 166H349.71C349.71 168.581 348.685 171.055 346.86 172.88C345.036 174.705 342.561 175.73 339.98 175.73C337.4 175.73 334.925 174.705 333.1 172.88C331.275 171.055 330.25 168.581 330.25 166H328.12C328.121 168.708 329.048 171.334 330.747 173.441C332.447 175.549 334.817 177.012 337.463 177.587C340.109 178.162 342.872 177.814 345.292 176.601C347.713 175.388 349.646 173.383 350.77 170.92C351.716 172.989 353.236 174.742 355.15 175.971C357.064 177.2 359.291 177.854 361.565 177.854C363.84 177.854 366.066 177.2 367.98 175.971C369.894 174.742 371.414 172.989 372.36 170.92C373.306 172.989 374.826 174.742 376.74 175.971C378.654 177.2 380.881 177.854 383.155 177.854C385.43 177.854 387.656 177.2 389.57 175.971C391.484 174.742 393.004 172.989 393.95 170.92C394.896 172.989 396.416 174.742 398.33 175.971C400.244 177.2 402.471 177.854 404.745 177.854C407.02 177.854 409.246 177.2 411.16 175.971C413.074 174.742 414.594 172.989 415.54 170.92C416.484 172.989 418.003 174.743 419.916 175.973C421.829 177.203 424.056 177.857 426.33 177.857C428.604 177.857 430.831 177.203 432.744 175.973C434.657 174.743 436.176 172.989 437.12 170.92C438.066 172.989 439.586 174.742 441.5 175.971C443.414 177.2 445.641 177.854 447.915 177.854C450.19 177.854 452.416 177.2 454.33 175.971C456.244 174.742 457.764 172.989 458.71 170.92C459.656 172.989 461.176 174.742 463.09 175.971C465.004 177.2 467.231 177.854 469.505 177.854C471.78 177.854 474.006 177.2 475.92 175.971C477.834 174.742 479.354 172.989 480.3 170.92C481.244 172.989 482.763 174.743 484.676 175.973C486.589 177.203 488.816 177.857 491.09 177.857C493.364 177.857 495.591 177.203 497.504 175.973C499.417 174.743 500.936 172.989 501.88 170.92C502.826 172.989 504.346 174.742 506.26 175.971C508.174 177.2 510.401 177.854 512.675 177.854C514.95 177.854 517.176 177.2 519.09 175.971C521.004 174.742 522.524 172.989 523.47 170.92C524.416 172.989 525.936 174.742 527.85 175.971C529.764 177.2 531.991 177.854 534.265 177.854C536.54 177.854 538.766 177.2 540.68 175.971C542.594 174.742 544.114 172.989 545.06 170.92C546.006 172.989 547.526 174.742 549.44 175.971C551.354 177.2 553.581 177.854 555.855 177.854C558.13 177.854 560.356 177.2 562.27 175.971C564.184 174.742 565.704 172.989 566.65 170.92C567.553 172.895 568.981 174.585 570.777 175.805C572.574 177.025 574.671 177.729 576.84 177.84L576.81 175.7Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M321.6 314.63C323.17 314.79 323.86 314.29 325.22 312.63C326.79 310.72 329.63 311.37 330.15 312.9C330.376 313.756 330.826 314.537 331.453 315.163C332.081 315.788 332.863 316.236 333.72 316.46C336.12 317.23 337.56 320.14 335.85 322.14C335.194 322.825 334.687 323.64 334.364 324.532C334.04 325.424 333.906 326.373 333.97 327.32C333.97 330.32 328.41 332.8 325.97 328.68C323.53 324.56 322.49 319.39 320.86 318C319.23 316.61 319.46 314.41 321.6 314.63Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M326.43 314.87C322.78 315.42 317.43 321.24 318.36 325.61C319.29 329.98 329.12 330.42 331.82 325.87C334.52 321.32 332.87 313.91 326.43 314.87Z",
                fill: "#FDC498"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M326.79 327.15C326.49 327.23 323.23 333.15 323.79 335.01C324.089 335.896 324.313 336.806 324.46 337.73L314.01 331.8C316.729 330.995 319.054 329.215 320.54 326.8C323.24 322.65 326.79 327.15 326.79 327.15Z",
                fill: "#FDC498"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M343.68 374.28C341.88 367.92 339.87 366.11 339.87 366.11C339.87 366.11 327.87 371.22 325.41 370.47C322.72 369.66 323.19 362.32 323.41 358.33C323.429 355.74 322.677 353.202 321.25 351.04C321.62 350.36 326.55 349.88 326.87 349.23C330.22 346.35 332.26 342.73 329.96 338.49C326.68 332.49 321.15 332.15 314.72 328.95C308.29 325.75 308.46 320.01 309.72 313.62C310.98 307.23 307.72 303.72 307.72 303.72C306.72 302.5 305.72 302.54 305.36 302.86C304.79 304.99 306.99 307.54 306.3 307.86C305.94 308.03 305.13 307.41 304.43 306.77C303.72 306.97 304.79 308.43 305.32 308.9C305.892 309.36 306.348 309.948 306.65 310.617C306.953 311.286 307.093 312.017 307.06 312.75C305.176 316.511 304.152 320.644 304.06 324.85C304.06 328.67 306.72 331.99 310.21 334.7C304.502 346.24 302.202 359.169 303.58 371.97C304.44 378.53 307.67 384.97 313.29 392.02C313.29 392.02 310.12 398.02 308.7 401.02C311.51 404.38 318.15 395.43 320.23 391.44C312.93 385.84 310.29 371.58 313.7 366.26C314.99 369.26 316.94 372.95 320.42 374.93C326.82 378.58 337.48 372.57 337.48 372.57L341.76 379.79C341.76 379.79 345.12 379.43 343.68 374.28Z",
                fill: "#FDC498"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M304.06 349.33C304.06 349.33 300.14 360.62 302.23 371.75L324.59 367.46C324.59 367.46 326.07 353.13 320.06 349.6C314.05 346.07 304.06 349.33 304.06 349.33Z",
                fill: "#0067A5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M320.24 322.33C319.09 321.33 315.46 317.66 325.76 316.71C336.06 315.76 325.69 324.28 325.69 324.28L320.24 322.33Z",
                fill: "#FDC498"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M322.44 315.62C322.44 315.62 322.7 317.36 326.03 317.77C329.36 318.18 327.03 319.93 328.03 321.11C328.317 321.089 328.604 321.134 328.871 321.241C329.138 321.347 329.377 321.514 329.57 321.727C329.762 321.94 329.904 322.194 329.984 322.47C330.064 322.746 330.079 323.037 330.03 323.32C329.84 324.32 327.51 324.38 327.51 324.38C327.51 324.38 323.8 328.61 326.61 330.27C329.42 331.93 334.11 331.4 333.96 327.27C333.81 323.14 333.96 319.67 333.96 319.67L333.3 317.28L328.12 313.39L322.44 315.62Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M304.01 323.99L309.94 324.31C309.94 324.31 311.29 327.68 316.07 329.62C314.07 331.8 318.07 333.23 324.01 332.93C330.61 336.06 332.9 341.99 331.73 345.93C330.56 349.87 322.29 351.52 316.73 351.52C311.17 351.52 302.49 351.14 302.49 351.14C302.49 351.14 305.3 340.59 308.16 336.02C308.16 336.02 302.4 331.4 302.01 323.88L304.01 323.99Z",
                fill: "#FF7D20"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M322.144 343.03L322.012 345.427L324.139 345.543L324.27 343.147L322.144 343.03Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M312.126 359.611L312.056 369.901L314.186 369.915L314.256 359.626L312.126 359.611Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M301.308 359.416L301.191 361.543L305.275 361.766L305.392 359.639L301.308 359.416Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M315.78 348.56L310.16 345.81C310.16 345.81 309.39 346.97 311.04 348.06C312.69 349.15 311.15 349.86 309.8 349.79L307.25 349.65C307.302 350.317 307.553 350.952 307.97 351.474C308.387 351.997 308.952 352.382 309.59 352.58C311.369 353.015 313.21 353.136 315.03 352.94L315.78 348.56Z",
                fill: "#FDC498"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M318.96 353.28C317.648 353.286 316.338 353.193 315.04 353L315.37 350.9C315.49 350.9 327.74 352.78 330.75 345.54L332.75 346.35C330.3 352.28 323.39 353.28 318.96 353.28Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M312.16 391.11L316.59 386.99L320.17 391.54C320.17 391.54 314.08 404.54 308.36 401.36L313 392.52L312.16 391.11Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M336.11 373.72L334.38 367.72L340.06 365.94C340.06 365.94 347.61 377.7 342.06 381.21L337.44 373.21L336.11 373.72Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M323.24 319.89C323.555 319.89 323.81 319.635 323.81 319.32C323.81 319.005 323.555 318.75 323.24 318.75C322.925 318.75 322.67 319.005 322.67 319.32C322.67 319.635 322.925 319.89 323.24 319.89Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M279.01 321.82H259.77L255.51 295.9H283.27L279.01 321.82Z",
                fill: "#80B3D2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M287.93 294.83H254.05V296.96H287.93V294.83Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M268.6 320.75H258.98V322.88H268.6V320.75Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M272.69 288.43C277.6 288.43 281.58 284.45 281.58 279.54C281.58 274.63 277.6 270.65 272.69 270.65C267.78 270.65 263.8 274.63 263.8 279.54C263.8 284.45 267.78 288.43 272.69 288.43Z",
                fill: "#FF7D20"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M279.058 273.251L264.968 284.078L266.266 285.767L280.356 274.94L279.058 273.251Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M272.69 289.5C271.307 289.624 269.913 289.459 268.598 289.015C267.282 288.571 266.074 287.857 265.049 286.92C264.024 285.983 263.206 284.843 262.646 283.573C262.086 282.302 261.797 280.929 261.797 279.54C261.797 278.152 262.086 276.778 262.646 275.508C263.206 274.237 264.024 273.097 265.049 272.16C266.074 271.223 267.282 270.51 268.598 270.065C269.913 269.621 271.307 269.456 272.69 269.58V271.71C271.141 271.71 269.628 272.169 268.34 273.03C267.052 273.89 266.049 275.113 265.456 276.544C264.863 277.974 264.708 279.549 265.01 281.068C265.313 282.586 266.058 283.982 267.153 285.077C268.248 286.172 269.644 286.917 271.163 287.22C272.681 287.522 274.256 287.367 275.686 286.774C277.117 286.181 278.34 285.178 279.2 283.89C280.061 282.603 280.52 281.089 280.52 279.54H282.65C282.64 282.178 281.587 284.706 279.721 286.571C277.856 288.437 275.328 289.49 272.69 289.5Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M461.12 467.96V481.71H496.73C496.741 480.632 496.368 479.585 495.677 478.756C494.986 477.928 494.023 477.373 492.96 477.19C488.96 476.25 480.02 476.25 474.34 470.03C468.66 463.81 461.12 467.96 461.12 467.96Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M424.1 461.93L415.78 481.71H448.88C448.887 480.633 448.512 479.588 447.822 478.76C447.132 477.933 446.171 477.377 445.11 477.19C441.11 476.25 431.88 475.08 433.86 466.6C435.76 458.4 424.1 461.93 424.1 461.93Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M519.44 302.81L517.84 301.4L530.84 286.58C528.91 285.23 524.97 282.09 524.43 278.73C524.31 278.03 524.35 277.312 524.548 276.629C524.745 275.947 525.095 275.318 525.57 274.79C526.029 274.227 526.605 273.771 527.257 273.453C527.91 273.136 528.624 272.964 529.35 272.95H529.55C534.02 272.95 539.05 278.03 539.26 278.25L537.74 279.74C536.46 278.43 532.52 275.08 529.56 275.08H529.42C528.991 275.093 528.57 275.198 528.186 275.388C527.801 275.578 527.462 275.848 527.19 276.18C526.919 276.476 526.718 276.829 526.604 277.214C526.489 277.598 526.464 278.004 526.53 278.4C526.99 281.25 531.36 284.47 533 285.46L534.08 286.12L519.44 302.81Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M512.48 295.78C515.48 298.17 520.82 299 523.25 299.27C523.633 299.309 524.02 299.257 524.378 299.116C524.737 298.975 525.056 298.75 525.31 298.46C527.13 296.4 531.31 291.46 531.49 289.46C531.68 286.95 525.49 287.97 516.49 290.54C507.49 293.11 512.48 295.78 512.48 295.78Z",
                fill: "#FDC498"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M514.35 302.11C514.45 301.81 517.45 295.72 517.45 295.72L525.7 288.34C525.7 288.34 513.7 289.29 511.13 293.11L508.58 296.93L514.35 302.11Z",
                fill: "#FDC498"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M465.94 295.72C465.94 295.72 471.94 298.59 473.45 303.91C474.96 309.23 473.23 309.29 471.91 308.91C470.59 308.53 471.21 312.42 468.29 314.01C465.37 315.6 458.9 315.35 458.9 315.35C458.9 315.35 456.4 309.51 457.79 304.3C459.18 299.09 465.94 295.72 465.94 295.72Z",
                fill: "#FDC498"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M465.71 311.89L462.3 324.28H452.3C452.3 324.28 450.86 295.19 466 295.69C466.641 301.078 466.544 306.528 465.71 311.89Z",
                fill: "#FDC498"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M475.1 331.95L480.4 473.21H462.3C462.3 473.21 452.06 443 456.59 427.58L435.12 473.21L421.37 462.28C421.37 462.28 425.24 427.76 441.32 410.93C441.32 410.93 430.25 376.7 441.04 362.83L475.1 331.95Z",
                fill: "#008B66"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M494.85 318.03L509.37 295.72L516.37 298.92C516.37 298.92 510.14 327.46 503.74 331.92C494.53 338.38 479.27 337.65 479.27 337.65L475.37 365.28L441.49 364.53L436.41 328.81C436.191 327.505 436.261 326.168 436.613 324.893C436.965 323.617 437.592 322.434 438.449 321.427C439.306 320.419 440.374 319.61 441.576 319.058C442.778 318.506 444.087 318.223 445.41 318.23L494.85 318.03Z",
                fill: "#008B66"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M554.906 285.845L535.915 271.935L530.934 278.736L549.925 292.645L554.906 285.845Z",
                fill: "white"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M452.86 312.91C452.86 312.91 460.18 313.57 463.78 307.91C463.78 307.91 460.88 307.12 461.78 304.97C462.91 302.27 465.71 304.37 465.71 304.37C465.71 304.37 468.06 300.47 472.2 301.16C477.2 302 478.38 296.95 475.43 295.49C474.853 295.237 474.338 294.861 473.92 294.39C471.29 291.16 466.98 289.61 463.55 291.04C462.509 291.454 461.373 291.568 460.27 291.37C456.76 290.83 452.2 293.37 452.2 297.98C452.2 302.59 450.79 303.68 449.29 304.87C446.39 307.2 448.04 312.92 452.86 312.91Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M461.3 475.47C452.94 451.55 454.3 438.66 455.45 428.3L455.54 427.47C455.72 425.79 455.98 423.98 456.25 422.05C457.7 411.89 459.49 399.24 451.75 393.29C441.58 385.48 444.01 372.29 444.12 371.76L446.21 372.16C446.21 372.29 443.94 384.61 453.04 391.6C461.77 398.3 459.88 411.6 458.36 422.35C458.09 424.26 457.84 426.05 457.66 427.69L457.57 428.52C456.42 439.2 455.11 451.3 463.32 474.76L461.3 475.47Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M476.39 360.46H445.49V362.59H476.39V360.46Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M472.554 383.988L465.536 387.68L466.089 388.733L473.108 385.042L472.554 383.988Z",
                fill: "#47AC91"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M458.684 371.212L451.666 374.903L452.22 375.956L459.238 372.265L458.684 371.212Z",
                fill: "#47AC91"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M469.283 404.592L462.264 408.283L462.818 409.336L469.837 405.645L469.283 404.592Z",
                fill: "#47AC91"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M476.348 417.287L469.33 420.978L469.884 422.032L476.902 418.34L476.348 417.287Z",
                fill: "#47AC91"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M466.877 431.16L459.859 434.851L460.413 435.904L467.431 432.213L466.877 431.16Z",
                fill: "#47AC91"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M434.124 443.716L427.105 447.407L427.659 448.46L434.678 444.769L434.124 443.716Z",
                fill: "#00614F"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M476.351 448.464L469.333 452.155L469.887 453.208L476.905 449.517L476.351 448.464Z",
                fill: "#47AC91"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M475.197 442.709L468.049 439.276L467.534 440.349L474.682 443.782L475.197 442.709Z",
                fill: "#47AC91"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M437.72 458.053L430.572 454.62L430.057 455.693L437.205 459.126L437.72 458.053Z",
                fill: "#00614F"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M464.15 420.29L460.32 418.03L459.8 419.11L463.63 421.37L464.15 420.29Z",
                fill: "#47AC91"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M473.51 399.36L469.67 397.11L469.16 398.18L472.99 400.44L473.51 399.36Z",
                fill: "#47AC91"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M459.8 384.98L455.97 382.73L455.45 383.8L459.28 386.06L459.8 384.98Z",
                fill: "#47AC91"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M449.21 391.898L442.191 395.589L442.745 396.642L449.763 392.951L449.21 391.898Z",
                fill: "#00614F"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M445.939 412.501L438.92 416.192L439.474 417.246L446.492 413.555L445.939 412.501Z",
                fill: "#00614F"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M452.994 425.197L445.975 428.888L446.529 429.941L453.548 426.25L452.994 425.197Z",
                fill: "#00614F"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M440.8 428.2L436.96 425.95L436.45 427.02L440.28 429.28L440.8 428.2Z",
                fill: "#00614F"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M450.15 407.27L446.32 405.02L445.8 406.09L449.64 408.35L450.15 407.27Z",
                fill: "#00614F"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M442.97 439.33L439.14 437.07L438.62 438.15L442.45 440.41L442.97 439.33Z",
                fill: "#00614F"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M470.68 372.55L466.84 370.29L466.33 371.37L470.16 373.63L470.68 372.55Z",
                fill: "#47AC91"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M466.33 459.15L462.49 456.89L461.98 457.97L465.81 460.22L466.33 459.15Z",
                fill: "#47AC91"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M483.19 338.6C480.003 338.608 476.82 338.367 473.67 337.88L474.02 335.78C474.22 335.78 493.41 338.97 503.1 331.12C511.85 324.03 514.75 303.74 515.26 299.57L508.92 296.69L509.81 294.75L517.54 298.27L517.46 299.03C517.36 300.03 514.85 324.34 504.46 332.78C498.58 337.53 489.86 338.6 483.19 338.6Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M469.64 305.54C470.087 305.54 470.45 305.177 470.45 304.73C470.45 304.283 470.087 303.92 469.64 303.92C469.193 303.92 468.83 304.283 468.83 304.73C468.83 305.177 469.193 305.54 469.64 305.54Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M560.3 310.38C560.244 311.611 559.715 312.773 558.824 313.625C557.933 314.476 556.748 314.951 555.515 314.951C554.283 314.951 553.097 314.476 552.206 313.625C551.315 312.773 550.786 311.611 550.73 310.38C550.73 307.73 555.52 299.94 555.52 299.94C555.52 299.94 560.3 307.73 560.3 310.38Z",
                fill: "white"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M549.66 322.75C549.614 323.561 549.26 324.324 548.67 324.882C548.079 325.441 547.298 325.752 546.485 325.752C545.673 325.752 544.891 325.441 544.3 324.882C543.71 324.324 543.356 323.561 543.31 322.75C543.31 321 546.48 315.84 546.48 315.84C546.48 315.84 549.66 321 549.66 322.75Z",
                fill: "white"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M231.936 404.418L230.138 405.56L236.135 414.996L237.933 413.853L231.936 404.418Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M276.52 428.33C279.165 428.33 281.31 426.185 281.31 423.54C281.31 420.895 279.165 418.75 276.52 418.75C273.875 418.75 271.73 420.895 271.73 423.54C271.73 426.185 273.875 428.33 276.52 428.33Z",
                fill: "#47AC91"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M63.39 427C66.6319 427 69.26 424.372 69.26 421.13C69.26 417.888 66.6319 415.26 63.39 415.26C60.1481 415.26 57.52 417.888 57.52 421.13C57.52 424.372 60.1481 427 63.39 427Z",
                fill: "#47AC91"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M63.3501 424.04C64.9572 424.04 66.2601 422.737 66.2601 421.13C66.2601 419.523 64.9572 418.22 63.3501 418.22C61.7429 418.22 60.4401 419.523 60.4401 421.13C60.4401 422.737 61.7429 424.04 63.3501 424.04Z",
                fill: "#FFE047"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M73.64 440.49C76.0535 440.49 78.01 438.533 78.01 436.12C78.01 433.707 76.0535 431.75 73.64 431.75C71.2265 431.75 69.27 433.707 69.27 436.12C69.27 438.533 71.2265 440.49 73.64 440.49Z",
                fill: "#47AC91"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M73.6101 438.29C74.8085 438.29 75.7801 437.318 75.7801 436.12C75.7801 434.921 74.8085 433.95 73.6101 433.95C72.4116 433.95 71.4401 434.921 71.4401 436.12C71.4401 437.318 72.4116 438.29 73.6101 438.29Z",
                fill: "#FFE047"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M47.57 452.14C51.2427 452.14 54.22 449.163 54.22 445.49C54.22 441.817 51.2427 438.84 47.57 438.84C43.8974 438.84 40.92 441.817 40.92 445.49C40.92 449.163 43.8974 452.14 47.57 452.14Z",
                fill: "#47AC91"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M47.5201 448.79C49.3426 448.79 50.8201 447.312 50.8201 445.49C50.8201 443.667 49.3426 442.19 47.5201 442.19C45.6976 442.19 44.2201 443.667 44.2201 445.49C44.2201 447.312 45.6976 448.79 47.5201 448.79Z",
                fill: "#FFE047"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M223.04 461.17C223.04 461.17 229.73 434.11 258.98 433.58C288.23 433.05 299.1 431.91 325.66 416.86C360.54 397.11 410.72 416.86 402.9 462.12L223.04 461.17Z",
                fill: "#47AC91"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M294.98 446.12C313.3 435.47 326.3 419 343.5 410.28C337.237 411.476 331.212 413.685 325.66 416.82C299.1 431.87 288.24 433 258.98 433.54C229.72 434.08 223.05 461.13 223.05 461.13L278.45 461.43C281.73 456.28 286.9 450.81 294.98 446.12Z",
                fill: "#269D7D"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M260.55 446.36C256.16 427.18 246.6 415.72 246.5 415.6L248.13 414.23C248.53 414.7 258.13 426.17 262.62 445.89L260.55 446.36Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M269.93 452.82C265.26 421.37 275.42 394.2 275.53 393.92L277.53 394.68C277.43 394.95 267.46 421.68 272.05 452.51L269.93 452.82Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M263.28 408.35C265.925 408.35 268.07 406.205 268.07 403.56C268.07 400.915 265.925 398.77 263.28 398.77C260.635 398.77 258.49 400.915 258.49 403.56C258.49 406.205 260.635 408.35 263.28 408.35Z",
                fill: "#47AC91"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M263.25 405.94C264.565 405.94 265.63 404.874 265.63 403.56C265.63 402.246 264.565 401.18 263.25 401.18C261.936 401.18 260.87 402.246 260.87 403.56C260.87 404.874 261.936 405.94 263.25 405.94Z",
                fill: "#FFE047"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M276.52 425.92C277.834 425.92 278.9 424.854 278.9 423.54C278.9 422.226 277.834 421.16 276.52 421.16C275.206 421.16 274.14 422.226 274.14 423.54C274.14 424.854 275.206 425.92 276.52 425.92Z",
                fill: "#FFE047"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M248.04 430.7C250.685 430.7 252.83 428.555 252.83 425.91C252.83 423.265 250.685 421.12 248.04 421.12C245.395 421.12 243.25 423.265 243.25 425.91C243.25 428.555 245.395 430.7 248.04 430.7Z",
                fill: "#47AC91"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M248.04 428.29C249.354 428.29 250.42 427.224 250.42 425.91C250.42 424.596 249.354 423.53 248.04 423.53C246.726 423.53 245.66 424.596 245.66 425.91C245.66 427.224 246.726 428.29 248.04 428.29Z",
                fill: "#FFE047"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M240.41 441.08C241.724 441.08 242.79 440.015 242.79 438.7C242.79 437.386 241.724 436.32 240.41 436.32C239.096 436.32 238.03 437.386 238.03 438.7C238.03 440.015 239.096 441.08 240.41 441.08Z",
                fill: "#008B66"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M251.81 448.62C253.892 448.62 255.58 446.932 255.58 444.85C255.58 442.768 253.892 441.08 251.81 441.08C249.728 441.08 248.04 442.768 248.04 444.85C248.04 446.932 249.728 448.62 251.81 448.62Z",
                fill: "#008B66"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M237.48 456.24C239.258 456.24 240.7 454.798 240.7 453.02C240.7 451.242 239.258 449.8 237.48 449.8C235.702 449.8 234.26 451.242 234.26 453.02C234.26 454.798 235.702 456.24 237.48 456.24Z",
                fill: "#FFD400"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M255.87 410.06C249.04 400.06 238.03 406.56 237.56 406.85L236.45 405.03C236.59 404.95 249.65 397.16 257.63 408.86L255.87 410.06Z",
                fill: "white"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M250.23 412.77C248.06 409.71 244.58 411.21 244.44 411.27L243.57 409.33C245.01 408.673 246.633 408.533 248.164 408.936C249.695 409.339 251.04 410.259 251.97 411.54L250.23 412.77Z",
                fill: "white"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M70.15 379.07L68.38 377.89C68.64 377.49 95.16 338.48 136.38 352.02L135.72 354.02C96.04 341.02 70.41 378.68 70.15 379.07Z",
                fill: "#D9EEE8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M571.72 492.32C603.968 492.32 630.11 466.178 630.11 433.93C630.11 401.682 603.968 375.54 571.72 375.54C539.472 375.54 513.33 401.682 513.33 433.93C513.33 466.178 539.472 492.32 571.72 492.32Z",
                fill: "#FFD400"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M606.84 448.8H583.92V465.25H606.84V448.8Z",
                fill: "white"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M583.92 459.99C587.386 456.901 591.829 455.13 596.47 454.99C604.17 454.81 606.37 451.68 606.85 448.78C607.33 445.88 583.92 446.44 583.92 446.44V459.99Z",
                fill: "#ADCEE2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M565.77 407.99H604.05V433.67C604.05 434.686 603.647 435.66 602.928 436.378C602.21 437.096 601.236 437.5 600.22 437.5H569.6C569.097 437.5 568.599 437.401 568.134 437.208C567.67 437.016 567.247 436.734 566.892 436.378C566.536 436.023 566.254 435.6 566.062 435.136C565.869 434.671 565.77 434.173 565.77 433.67V407.99Z",
                fill: "#63A2C8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M604.05 404.49H565.77V412.17H604.05V404.49Z",
                fill: "#0067A5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M538.13 417.23H576.41V458.53C576.41 459.033 576.311 459.531 576.119 459.996C575.926 460.46 575.644 460.883 575.288 461.238C574.933 461.594 574.51 461.876 574.046 462.068C573.581 462.261 573.083 462.36 572.58 462.36H541.96C540.944 462.36 539.97 461.956 539.252 461.238C538.534 460.52 538.13 459.546 538.13 458.53V417.23Z",
                fill: "#0067A5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M576.41 421.68H538.13V423.81H576.41V421.68Z",
                fill: "#63A2C8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M576.41 426.8H538.13V428.93H576.41V426.8Z",
                fill: "#63A2C8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M576.41 431.91H538.13V434.04H576.41V431.91Z",
                fill: "#63A2C8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M557.72 446.28C551.459 446.275 545.456 443.786 541.028 439.36C536.599 434.933 534.108 428.931 534.1 422.67V421.6H538.1V423.73H536.3C536.566 429.241 538.943 434.438 542.937 438.245C546.932 442.051 552.238 444.174 557.755 444.174C563.273 444.174 568.579 442.051 572.573 438.245C576.567 434.438 578.944 429.241 579.21 423.73H576.45V421.6H581.3V422.67C581.295 428.925 578.81 434.923 574.39 439.348C569.97 443.774 563.975 446.267 557.72 446.28Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M538.13 417.28C538.13 417.28 539.25 431.52 548.46 432.57C557.67 433.62 556.4 422.95 563.67 423.03C570.94 423.11 575.86 417.28 575.86 417.28H538.13Z",
                fill: "white"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M557.59 448.1C559.186 448.1 560.48 446.806 560.48 445.21C560.48 443.614 559.186 442.32 557.59 442.32C555.994 442.32 554.7 443.614 554.7 445.21C554.7 446.806 555.994 448.1 557.59 448.1Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M600.97 409.17H598.84C598.84 407.402 598.492 405.652 597.815 404.019C597.139 402.386 596.148 400.902 594.898 399.652C593.648 398.402 592.164 397.411 590.531 396.735C588.898 396.058 587.148 395.71 585.38 395.71C583.612 395.71 581.862 396.058 580.229 396.735C578.596 397.411 577.112 398.402 575.862 399.652C574.612 400.902 573.621 402.386 572.945 404.019C572.268 405.652 571.92 407.402 571.92 409.17H569.79C569.79 407.123 570.193 405.095 570.977 403.204C571.76 401.312 572.909 399.594 574.356 398.146C575.804 396.699 577.523 395.55 579.414 394.767C581.305 393.983 583.333 393.58 585.38 393.58C587.427 393.58 589.455 393.983 591.346 394.767C593.238 395.55 594.956 396.699 596.404 398.146C597.852 399.594 599 401.312 599.783 403.204C600.567 405.095 600.97 407.123 600.97 409.17Z",
                fill: "#0067A5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M599.06 432.97H591.97V445.04H599.06V432.97Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M595.47 425.18C594.465 425.18 593.482 425.478 592.647 426.037C591.811 426.595 591.16 427.389 590.776 428.318C590.392 429.247 590.292 430.269 590.488 431.255C590.685 432.24 591.17 433.146 591.882 433.856C592.593 434.566 593.499 435.049 594.485 435.244C595.471 435.438 596.493 435.336 597.421 434.95C598.349 434.564 599.142 433.912 599.699 433.075C600.256 432.238 600.552 431.255 600.55 430.25C600.55 429.583 600.419 428.923 600.163 428.307C599.908 427.692 599.533 427.132 599.062 426.661C598.59 426.19 598.03 425.817 597.413 425.563C596.797 425.309 596.137 425.179 595.47 425.18ZM595.47 431.28C595.272 431.28 595.079 431.221 594.915 431.111C594.75 431.002 594.622 430.845 594.546 430.663C594.471 430.48 594.451 430.279 594.489 430.085C594.528 429.891 594.623 429.713 594.763 429.573C594.903 429.433 595.081 429.338 595.275 429.299C595.469 429.261 595.67 429.28 595.853 429.356C596.036 429.432 596.192 429.56 596.302 429.724C596.411 429.889 596.47 430.082 596.47 430.28C596.47 430.412 596.444 430.543 596.393 430.665C596.342 430.787 596.268 430.898 596.174 430.991C596.08 431.084 595.968 431.157 595.846 431.207C595.723 431.256 595.592 431.281 595.46 431.28H595.47Z",
                fill: "#0067A5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M605.85 442.8H584.91C583.01 442.8 581.47 444.34 581.47 446.24V446.68C581.47 448.58 583.01 450.12 584.91 450.12H605.85C607.75 450.12 609.29 448.58 609.29 446.68V446.24C609.29 444.34 607.75 442.8 605.85 442.8Z",
                fill: "#0067A5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M588.97 455.01H586.84V467.61H588.97V455.01Z",
                fill: "#FFD400"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M593.04 459.99H590.91V467.6H593.04V459.99Z",
                fill: "#FFD400"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M590.56 477.73C590.518 478.406 590.221 479.041 589.727 479.505C589.234 479.969 588.582 480.227 587.905 480.227C587.228 480.227 586.576 479.969 586.083 479.505C585.589 479.041 585.292 478.406 585.25 477.73C585.25 476.26 587.9 470.56 587.9 470.56C587.9 470.56 590.56 476.28 590.56 477.73Z",
                fill: "white"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M545.5 487.28C536.49 482.851 528.749 476.212 522.997 467.983C517.245 459.754 513.671 450.203 512.607 440.219C511.544 430.236 513.025 420.146 516.914 410.89C520.802 401.634 526.971 393.513 534.846 387.285C542.72 381.056 552.043 376.923 561.946 375.271C571.849 373.618 582.009 374.5 591.479 377.834C600.949 381.168 609.42 386.846 616.104 394.338C622.787 401.83 627.465 410.892 629.7 420.68L627.62 421.15C625.464 411.713 620.953 402.976 614.509 395.753C608.064 388.53 599.896 383.056 590.765 379.842C581.634 376.628 571.838 375.778 562.29 377.372C552.742 378.966 543.753 382.952 536.162 388.958C528.57 394.963 522.622 402.794 518.874 411.718C515.125 420.643 513.697 430.372 514.723 439.997C515.749 449.623 519.196 458.832 524.742 466.766C530.288 474.699 537.753 481.1 546.44 485.37L545.5 487.28Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M511.13 480.64H370.42V482.77H511.13V480.64Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M162.11 461.65H210.11C210.11 461.65 208.42 452.82 191.03 455.11C183.71 449.24 167.73 455.11 160.26 453.68C152.66 456.28 162.11 461.65 162.11 461.65Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M222.5 404.31L209.02 443.46L182.26 426.72L208.91 396.36L222.5 404.31Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M197.2 414.17C194.988 414.169 192.825 413.52 190.978 412.302C189.132 411.084 187.683 409.351 186.811 407.318C185.939 405.286 185.682 403.042 186.072 400.864C186.463 398.687 187.483 396.672 189.007 395.069C190.531 393.465 192.491 392.344 194.646 391.843C196.8 391.343 199.054 391.485 201.129 392.253C203.204 393.02 205.008 394.379 206.318 396.161C207.628 397.944 208.387 400.071 208.5 402.28C208.65 405.274 207.605 408.205 205.595 410.429C203.584 412.653 200.774 413.987 197.78 414.14L197.2 414.17ZM197.2 393.68H196.73C194.301 393.742 191.993 394.758 190.308 396.509C188.623 398.26 187.695 400.605 187.726 403.035C187.757 405.465 188.744 407.785 190.473 409.492C192.202 411.2 194.535 412.157 196.965 412.157C199.395 412.157 201.728 411.2 203.457 409.492C205.186 407.785 206.173 405.465 206.204 403.035C206.235 400.605 205.307 398.26 203.622 396.509C201.937 394.758 199.629 393.742 197.2 393.68Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M208.97 432.57C209.83 431.57 235.27 412.32 235.27 412.32L232.3 407.53L208.39 421.53L208.97 432.57Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M161.3 405.5H196.42C198.703 405.5 200.95 406.074 202.953 407.169C204.956 408.264 206.652 409.845 207.885 411.766C209.118 413.688 209.848 415.889 210.008 418.166C210.167 420.444 209.752 422.725 208.8 424.8L190.98 455.11H167.68L184.87 426.43H134.5C131.012 426.43 127.668 425.045 125.202 422.578C122.736 420.112 121.35 416.768 121.35 413.28C121.35 411.364 121.768 409.472 122.574 407.734C123.381 405.997 124.557 404.456 126.02 403.22L164.92 370.4H180.76C180.76 370.4 190.13 387.65 183.47 394.03C176.3 400.92 161.3 405.5 161.3 405.5Z",
                fill: "#FF7D20"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M150.13 418.52L168.68 450.19C169.358 451.347 169.719 452.662 169.726 454.002C169.732 455.343 169.385 456.662 168.718 457.825C168.051 458.988 167.089 459.954 165.928 460.626C164.768 461.298 163.451 461.651 162.11 461.65H112.95V446.65H144.18L123.3 420.18L150.13 418.52Z",
                fill: "#FF7D20"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M165.72 386.87C165.72 386.87 163.3 421.54 210.1 428.13V420.13C210.1 420.13 180.76 419.86 178.1 386.49L165.72 386.87Z",
                fill: "#FDC498"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M205.75 358.97C205.75 358.97 190.58 348.75 164.92 370.4C173.92 378.4 180.76 370.4 180.76 370.4C180.76 370.4 185.16 365.5 186.76 371.33C188.36 377.16 199.15 372.23 199.15 372.23C199.15 372.23 200.55 376.49 203.15 374.03C205.75 371.57 210.15 365.77 205.75 358.97Z",
                fill: "#FDC498"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M180.97 363.97C180.97 363.97 179.26 354.43 186.97 351.97C186.97 351.97 188.72 344.68 197.52 344.71C204.71 343.52 211 348.92 210.06 352.71C216.31 357.92 213.84 366.51 207.58 367.71C207.58 367.71 202.51 367.71 200.92 363.52C199.33 359.33 194.52 360.12 194.72 362.92C194.92 365.72 184.37 371.76 180.97 363.97Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M198.3 349.55C203.16 349.55 207.1 345.61 207.1 340.75C207.1 335.89 203.16 331.95 198.3 331.95C193.44 331.95 189.5 335.89 189.5 340.75C189.5 345.61 193.44 349.55 198.3 349.55Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M210.1 420.18C213.786 420.007 217.369 418.91 220.52 416.99C220.676 416.901 220.854 416.86 221.033 416.87C221.211 416.88 221.384 416.941 221.528 417.047C221.673 417.153 221.784 417.298 221.848 417.465C221.912 417.632 221.927 417.815 221.89 417.99C221.575 418.724 221.088 419.373 220.47 419.88C217.62 422.52 216.87 422.67 216.87 422.67C217.801 422.97 218.785 423.067 219.757 422.953C220.728 422.839 221.664 422.517 222.5 422.01C223.92 424.17 222.5 427.32 219.05 428.52C216.65 429.35 203.8 427.52 198.3 425.6C202.38 422.98 210.1 420.18 210.1 420.18Z",
                fill: "#FDC498"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M201.43 368.86C200.208 368.573 199.017 368.171 197.87 367.66L198.74 365.71C199.735 366.158 200.77 366.513 201.83 366.77L201.43 368.86Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M121.35 461.65H79.9C79.9 461.65 83.1 454.32 93.49 453.65C103.88 452.98 104.55 445.46 113.17 445.46C122.89 445.49 121.35 461.65 121.35 461.65Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M186.97 428.07H142.62C139.011 428.067 135.551 426.633 132.999 424.081C130.447 421.529 129.013 418.069 129.01 414.46H131.14C131.143 417.504 132.353 420.422 134.505 422.575C136.658 424.727 139.576 425.937 142.62 425.94H186.97V428.07Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M153.86 445.54H112.95V447.67H153.86V445.54Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M315.78 461.06H58.15V463.19H315.78V461.06Z",
                fill: "#003C71"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-illustrations-virtual-f4c8d3dc38/1/packages/lib-illustrations/src/heimsending.tsx
/* eslint-disable max-len */ 

const HeimsendingIllustration = (param)=>{
    let { size =200  } = param;
    return /*#__PURE__*/ _jsxs("svg", {
        fill: "none",
        height: size,
        viewBox: "0 0 662 611",
        width: size,
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M213.83 145.71C210.026 145.729 206.265 146.513 202.77 148.016C199.276 149.52 196.12 151.711 193.49 154.46L79.72 241.58V256.95C79.72 265.95 86.53 273.2 94.93 273.2H430.44C438.83 273.2 445.64 265.93 445.64 256.95V145.71H213.83Z",
                fill: "#66A4C9"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M445.64 241.58H79.72V252.09H445.64V241.58Z",
                fill: "#0067A5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M202.92 273.2C202.92 273.08 202.92 272.96 202.92 272.84C202.92 253.49 188.24 237.84 170.13 237.84C152.02 237.84 137.33 253.53 137.33 272.84C137.33 272.96 137.33 273.08 137.33 273.2H202.92Z",
                fill: "#66A4C9"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M406.53 273.2C406.53 273.08 406.53 272.96 406.53 272.84C406.53 253.49 391.84 237.84 373.73 237.84C355.62 237.84 340.93 253.53 340.93 272.84C340.93 272.96 340.93 273.08 340.93 273.2H406.53Z",
                fill: "#66A4C9"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M302.66 159.61H209.76L184.38 213.83H302.66V159.61Z",
                fill: "white"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M270.34 153.64H266.51V233.26H270.34V153.64Z",
                fill: "#66A4C9"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M197.89 159.61H199.19L172.02 213.83H127.23L197.89 159.61Z",
                fill: "white"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M195.36 225.55V202.14C189.3 202.14 184.36 207.39 184.36 213.86C184.36 220.33 189.3 225.55 195.36 225.55Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M170.14 298.95C183.798 298.95 194.87 287.117 194.87 272.52C194.87 257.923 183.798 246.09 170.14 246.09C156.482 246.09 145.41 257.923 145.41 272.52C145.41 287.117 156.482 298.95 170.14 298.95Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M373.74 298.95C387.398 298.95 398.47 287.117 398.47 272.52C398.47 257.923 387.398 246.09 373.74 246.09C360.082 246.09 349.01 257.923 349.01 272.52C349.01 287.117 360.082 298.95 373.74 298.95Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M204.24 272.99H201.89C201.89 254.23 187.65 238.99 170.14 238.99C152.63 238.99 138.38 254.25 138.38 272.99H136C136 252.94 151.3 236.63 170.11 236.63C188.92 236.63 204.24 252.94 204.24 272.99Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M407.84 272.99H405.5C405.5 254.23 391.25 238.99 373.74 238.99C356.23 238.99 342 254.23 342 272.99H339.66C339.66 252.94 354.96 236.63 373.76 236.63C392.56 236.63 407.84 252.94 407.84 272.99Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M424.83 213.82H422.49V241.58H424.83V213.82Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M171.3 257.41H168.96V287.62H171.3V257.41Z",
                fill: "#0067A5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M382.873 261.035L362.888 282.392L364.596 283.991L384.582 262.634L382.873 261.035Z",
                fill: "#0067A5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M382.11 158.44H209.76V160.78H382.11V158.44Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M343.74 159.61H341.4V213.82H343.74V159.61Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M445.65 212.65H285V214.99H445.65V212.65Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M92.8799 260.87C97.4197 260.87 101.1 256.939 101.1 252.09C101.1 247.241 97.4197 243.31 92.8799 243.31C88.3401 243.31 84.6599 247.241 84.6599 252.09C84.6599 256.939 88.3401 260.87 92.8799 260.87Z",
                fill: "#FFD400"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M359.19 181.6H364.12C365.44 181.6 365.74 182.07 365.74 182.71C365.74 183.35 365.44 183.87 364.12 183.87H359.19V181.6ZM359.19 187.88H364.77C366.07 187.88 366.46 188.5 366.46 189.27C366.46 190.04 366.07 190.66 364.77 190.66H359.19V187.88ZM352.8 194.96H367C371.83 194.96 373.46 192.69 373.46 189.22C373.479 188.338 373.214 187.474 372.704 186.754C372.195 186.034 371.468 185.496 370.63 185.22V185.14C371.267 184.83 371.798 184.337 372.154 183.725C372.51 183.112 372.676 182.407 372.63 181.7C372.63 178.87 371.12 177.29 367.74 177.29H352.8V194.96ZM380.08 194.96H386.36V189.96L393.82 177.26H386.88L383.19 183.67L379.56 177.26H372.62L380.08 189.96V194.96ZM408.53 194.96H416.7L409.61 184.06L416.47 177.29H407.81L401.1 184.06V177.29H394.82V194.96H401.1V190.48L404.01 187.91L408.53 194.96ZM415.91 186.13C415.91 195.28 423.25 195.58 427.21 195.58C431.17 195.58 438.5 195.28 438.5 186.13C438.5 176.98 431.16 176.67 427.21 176.67C423.26 176.67 415.91 176.97 415.91 186.13ZM422.85 186.13C422.85 182.54 424.54 181.13 427.21 181.13C429.88 181.13 431.56 182.54 431.56 186.13C431.56 189.72 429.87 191.13 427.21 191.13C424.55 191.13 422.85 189.72 422.85 186.13Z",
                fill: "white"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M438.84 200.47H438.52H437.15C437.03 200.47 437.41 200.16 437.7 200.14C437.901 200.154 438.104 200.137 438.3 200.09C438.3 200.09 437.47 200.09 437.39 200.09C437.31 200.09 437.39 200.09 437.28 200.09C437.027 200.069 436.773 200.069 436.52 200.09H437.62C437.237 200.063 436.853 200.063 436.47 200.09C436.02 200.09 436.47 200.09 435.98 200.01C435.49 199.93 435.08 200.01 434.64 200.01C434.64 200.01 432.94 200.01 431.95 199.96H432.11C432.19 199.96 431.23 199.96 430.67 199.91L437.86 199.75C437.86 199.75 436.86 199.75 435.15 199.7C435.15 199.7 435.76 199.7 435.64 199.64C434.86 199.64 434.05 199.64 433.36 199.64C433.45 199.64 433.44 199.64 433.45 199.64H430.45C432.03 199.58 433.96 199.64 435.89 199.64C436.07 199.64 436.29 199.64 436.16 199.58C432.16 199.49 424.1 199.58 424.11 199.5C424.776 199.456 425.444 199.456 426.11 199.5C429.28 199.5 432.98 199.5 436.38 199.55C436.48 199.55 436.49 199.46 436.38 199.4C432.69 199.29 429 199.33 425.3 199.25H425.22C423.64 199.33 421.07 199.25 419.1 199.33C417.59 199.38 415.91 199.4 414.32 199.43L416.53 199.33C418.11 199.28 419.69 199.33 421.07 199.25C421.47 199.25 422.26 199.25 422.85 199.25H423.65H422.77C422.58 199.25 427.77 199.25 427.59 199.14H420.29C419.7 199.09 420.8 198.91 421.2 198.89C421.2 198.89 421.31 198.89 421.3 198.89H420.62H422.4H422.46C421.46 198.89 419.46 198.89 419.46 198.84L424.61 198.76C423.46 198.76 422.15 198.76 421.02 198.76C416.45 198.76 412.29 198.84 408.02 198.91C407.51 198.91 407.02 198.97 406.48 198.98C405.67 198.98 404.75 198.98 403.89 198.98C405.27 198.98 406.83 198.84 408.19 198.81C408.35 198.81 408.53 198.81 408.51 198.74C408.49 198.67 404.11 198.84 402.11 198.93C401.72 198.93 401.11 199 400.73 199C398.96 199 397.21 199.09 397.73 199.08C397.09 199.08 395.92 199.08 394.81 199.17C394.63 199.17 395.01 199.26 395.01 199.26C395.7 199.44 393.45 199.38 390.61 199.45C388.22 199.45 385.61 199.54 384.22 199.69C383.98 199.71 383.74 199.71 383.5 199.69C385.278 199.413 387.071 199.246 388.87 199.19C390.01 199.19 392.3 199.19 392.3 199.19C392.3 198.83 387.03 199.25 385.45 199.3C382.29 199.4 379.3 199.71 376.35 199.89C375.14 199.97 373.93 200.01 372.73 200.06H373.03C371.53 200.12 370.09 200.19 368.56 200.3H368.15C365 200.53 362.3 200.72 359.1 200.99C358.32 201.05 357.54 201.14 356.75 201.21C356.17 201.29 357.16 201.21 356.19 201.36C356.19 201.36 355.82 201.44 357.95 201.24C358.06 201.24 358.02 201.3 357.8 201.3C356.64 201.38 355.27 201.47 354.04 201.64H352.9C352.75 201.64 352.73 201.64 352.73 201.64C352.674 201.691 352.624 201.748 352.58 201.81L352.51 201.89C352.395 202.035 352.311 202.202 352.26 202.38C352.25 202.453 352.25 202.527 352.26 202.6V202.68C352.36 202.93 352.69 203.11 353.5 203.11H354C354.12 203.11 354.35 203.11 354.3 203.11L353.98 203.17C354.123 203.189 354.267 203.189 354.41 203.17C354.76 203.09 355.114 203.03 355.47 202.99C356.02 202.94 355.47 203.05 356.15 202.99C359.54 202.71 362.84 202.54 366.29 202.34C366.37 202.34 366.29 202.34 366.18 202.34L367.32 202.27L418.52 201.55C421.12 201.55 423.7 201.64 424.52 201.68C425.34 201.72 423.9 201.78 423.89 201.78C424.66 201.78 424.94 201.78 425.59 201.78C425.77 201.78 426.41 201.86 426.38 201.78C426.147 201.76 425.916 201.72 425.69 201.66H426.53C426.949 201.693 427.371 201.693 427.79 201.66C429.18 201.59 430.68 201.74 432.08 201.77C431.659 201.824 431.235 201.851 430.81 201.85C430.62 201.94 434.81 201.85 435.68 201.85C435.85 201.85 436.6 201.53 436.68 201.52L437.3 201.33C437.54 201.33 437.76 201.33 438.09 201.33C438.9 201.4 438.68 201.09 439.25 200.88C439.11 200.863 438.969 200.863 438.83 200.88L438.84 200.47ZM414.74 198.97C416.08 198.84 419.24 198.88 419.25 198.91C419.26 198.94 415.68 198.99 413.8 199.03L414.74 198.97ZM411.23 199.42C408.66 199.42 405.9 199.42 403.34 199.58C402.94 199.58 402.34 199.58 401.95 199.58C403.31 199.52 404.54 199.45 405.95 199.41C406.146 199.399 406.343 199.399 406.54 199.41C406.803 199.427 407.067 199.427 407.33 199.41C407.167 199.42 407.003 199.42 406.84 199.41C406.84 199.41 408.77 199.41 410.32 199.35C410.363 199.344 410.407 199.344 410.45 199.35C412.16 199.35 414.83 199.26 414.94 199.26H415.16C415.74 199.26 416.31 199.37 417 199.39H417.2V199.44C415.42 199.54 413.2 199.44 411.28 199.44L411.23 199.42ZM420.79 199.78C420.55 199.78 416.23 199.7 414.04 199.78H412.82C412.88 199.78 413.25 199.78 413.25 199.78H413.48C416.06 199.78 418.76 199.78 421.3 199.78C421.3 199.78 421 199.84 420.79 199.84V199.78ZM430.44 200.29H429.69H430.62C430.71 200.29 430.72 200.29 430.44 200.29ZM438.88 201.07C438.732 201.034 438.582 201.01 438.43 201H438.8C439.02 201 439.08 201.06 438.88 201.07Z",
                fill: "#FFD400"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M556 480.89L554.22 479.37C574.68 455.37 588.04 434.03 597.56 410.27C608.39 383.27 606.91 356.36 593.5 336.55C582.5 320.37 558.74 301.08 507.5 301.08H46.5V298.74H507.5C559.8 298.74 584.21 318.59 595.5 335.23C609.35 355.7 610.91 383.37 599.79 411.15C590.07 435.14 576.58 456.66 556 480.89Z",
                fill: "#66A4C9"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M532.76 478.5C532.76 478.5 543.18 437.38 492.11 443.78C435.93 450.78 354.59 468.46 327.9 427.15C301.47 386.25 338.06 345.24 377.04 349.15C413.36 352.81 419.51 369.15 453.54 338.77C508.91 289.35 605.61 323.77 583.97 398.89C579 416.14 562.88 451.62 532.76 478.5Z",
                fill: "#E5E5E5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M350.996 426.094L350.048 428.233L365.828 435.226L366.776 433.086L350.996 426.094Z",
                fill: "white"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M394.48 424.795L383.147 429.55L384.053 431.707L395.386 426.953L394.48 424.795Z",
                fill: "white"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M403.377 439.646L402.688 441.882L413.238 445.134L413.927 442.898L403.377 439.646Z",
                fill: "white"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M438.269 427.36L424.136 431.149L424.745 433.418L438.878 429.63L438.269 427.36Z",
                fill: "white"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M447.08 435.34H444.74V440.79H447.08V435.34Z",
                fill: "white"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M344.133 417.472L332.252 420.11L332.759 422.394L344.64 419.756L344.133 417.472Z",
                fill: "white"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M474.47 428.6H461.08V430.94H474.47V428.6Z",
                fill: "white"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M490.036 416.735L488.175 418.153L493.455 425.081L495.316 423.662L490.036 416.735Z",
                fill: "white"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M519.255 426.132L507.716 431.626L508.722 433.739L520.261 428.245L519.255 426.132Z",
                fill: "white"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M535.986 426.234L534.572 428.098L539.176 431.592L540.591 429.728L535.986 426.234Z",
                fill: "white"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M547.747 443.275L537.866 446.15L538.52 448.397L548.4 445.522L547.747 443.275Z",
                fill: "white"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M549.041 419.506L549.003 421.846L561.911 422.056L561.949 419.716L549.041 419.506Z",
                fill: "white"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M378.21 416.16H375.87V420H378.21V416.16Z",
                fill: "white"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M413.788 418.776L413.359 421.077L418.637 422.063L419.067 419.762L413.788 418.776Z",
                fill: "white"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M83.93 375.63C95.93 363.4 112.09 353.03 129.19 352.05C148.19 350.95 161.64 357.91 169.59 372.56C179.81 391.41 201.1 398.49 227.06 380.4C258.5 358.49 300.06 373.4 307.37 410.5H49.77L83.93 375.63Z",
                fill: "#D9EEE8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M84.1901 371.97H81.8501V420H84.1901V371.97Z",
                fill: "white"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M108.13 371.97H105.79V420H108.13V371.97Z",
                fill: "white"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M132.07 352.05H129.73V420.01H132.07V352.05Z",
                fill: "white"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M156.01 371.97H153.67V420H156.01V371.97Z",
                fill: "white"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M179.95 398.9H177.61V420.01H179.95V398.9Z",
                fill: "white"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M203.89 371.97H201.55V420H203.89V371.97Z",
                fill: "white"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M227.83 398.9H225.49V420.01H227.83V398.9Z",
                fill: "white"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M251.77 357.91H249.43V420.01H251.77V357.91Z",
                fill: "white"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M275.71 371.97H273.37V420H275.71V371.97Z",
                fill: "white"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M619.52 359.02C611.91 310.86 565.73 285.2 535.33 285.2H454.77V282.86H535.33C566.57 282.86 614.02 309.2 621.84 358.65L619.52 359.02Z",
                fill: "#66A4C9"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M500.074 332.366L338.046 345.26L342.461 400.745L504.489 387.851L500.074 332.366Z",
                fill: "#FFD400"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M484.9 389.71C484.9 389.62 484.9 389.53 484.9 389.45C484.722 386.042 483.864 382.704 482.374 379.633C480.885 376.562 478.796 373.821 476.229 371.572C473.663 369.322 470.671 367.61 467.432 366.536C464.193 365.462 460.771 365.048 457.369 365.319C453.967 365.589 450.653 366.539 447.625 368.112C444.596 369.685 441.913 371.849 439.735 374.476C437.556 377.103 435.926 380.14 434.941 383.407C433.956 386.675 433.636 390.107 434 393.5V393.76L484.9 389.71Z",
                fill: "#FFD400"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M459.4 410.5C470.037 410.5 478.66 401.877 478.66 391.24C478.66 380.603 470.037 371.98 459.4 371.98C448.763 371.98 440.14 380.603 440.14 391.24C440.14 401.877 448.763 410.5 459.4 410.5Z",
                fill: "#0067A5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M465.645 382.06L451.361 398.819L453.142 400.337L467.426 383.578L465.645 382.06Z",
                fill: "#FFD400"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M416.255 381.86L341.47 387.798L341.656 390.13L416.44 384.192L416.255 381.86Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M341.4 401.98L336.89 345.33L339.22 345.14L343.55 399.47L432.63 392.53C432.426 385.551 434.952 378.768 439.67 373.622C444.389 368.476 450.928 365.373 457.898 364.972C464.868 364.571 471.72 366.903 476.997 371.474C482.275 376.045 485.562 382.494 486.16 389.45L483.83 389.63C483.225 383.228 480.126 377.321 475.202 373.185C470.277 369.049 463.923 367.017 457.513 367.528C451.103 368.039 445.151 371.052 440.944 375.916C436.737 380.779 434.612 387.103 435.03 393.52L435.13 394.69L341.4 401.98Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M503.049 332.973L500.709 333.16L505.162 388.82L507.502 388.633L503.049 332.973Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M342.188 399.555L302.244 402.727L302.429 405.06L342.374 401.888L342.188 399.555Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M296.87 410.99C295.802 410.989 294.751 410.731 293.805 410.237C292.858 409.742 292.045 409.027 291.435 408.151C290.825 407.275 290.435 406.265 290.298 405.206C290.162 404.147 290.284 403.071 290.652 402.069C291.021 401.068 291.626 400.17 292.417 399.452C293.207 398.734 294.159 398.218 295.192 397.947C296.224 397.676 297.307 397.659 298.348 397.896C299.389 398.133 300.357 398.618 301.17 399.31C301.836 399.873 302.383 400.562 302.779 401.338C303.176 402.114 303.414 402.961 303.48 403.83C303.55 404.698 303.448 405.571 303.18 406.4C302.912 407.229 302.484 407.996 301.919 408.66C301.355 409.323 300.665 409.868 299.889 410.264C299.114 410.661 298.268 410.901 297.4 410.97L296.87 410.99ZM296.87 400.07H296.52C295.816 400.125 295.137 400.353 294.543 400.733C293.949 401.114 293.457 401.635 293.112 402.251C292.767 402.866 292.58 403.558 292.566 404.263C292.552 404.969 292.713 405.667 293.033 406.296C293.354 406.924 293.825 407.464 294.404 407.868C294.983 408.271 295.653 408.525 296.354 408.607C297.055 408.69 297.765 408.598 298.422 408.341C299.079 408.083 299.662 407.667 300.12 407.13C300.485 406.702 300.762 406.206 300.934 405.67C301.105 405.135 301.169 404.57 301.12 404.01C301.025 402.874 300.486 401.821 299.62 401.08C298.854 400.432 297.884 400.074 296.88 400.07H296.87Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M548.08 409.54H522.47V411.88H548.08V409.54Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M538.21 266.85H532.36V410.49H538.21V266.85Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M583.293 270.13L490.916 263.281L487.296 312.107L579.673 318.956L583.293 270.13Z",
                fill: "#0067A5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M510.17 276.79H510.4L510.32 276.9H510.13L510.04 277.01L510.33 277.3L510.24 277.45H510.12L509.98 277.24V277.05L509.57 276.83H509.42L509.25 277.05L509.45 276.98L509.7 277.19V277.35L510 277.52L510.19 278L510.03 278.1L509.72 278.15L509.93 278.44L509.85 278.54L509.43 278.44L509.6 278.26H509.33V278.52H509.52L509.73 278.76L509.64 278.95L509.86 279.08V279.27H509.56V279.42L509.78 279.59L509.69 279.77L509.83 280.01V280.16L509.61 280.11L509.49 279.72H509.29L509.39 279.92L509.26 280.1L509.66 280.4L509.94 280.3V280.46L509.56 280.51L509.47 280.61L509.8 280.83L509.86 281.1L509.78 281.71L509.54 281.84L509.79 282.05L509.51 282.18H509.13V281.87L508.91 281.78L508.83 281.85L508.97 282.01L508.84 282.23L509.32 282.46L509.12 282.56V282.67H509.35L509.41 282.94L509.65 283.23V283.42L509.53 283.48L509.34 283.39L509.44 283.67L509.39 283.78L509.57 283.91V284.21L509.33 284.31V284.58L509.51 284.82V285.12L509.07 284.94H508.99V285.1L509.24 285.23H509.48L509.39 285.38L509.49 285.57L509.43 285.84L509.3 286.02L509.41 286.6L509.17 286.77L509.24 286.85H509.36L509.23 287.03L509.36 287.3L509.15 287.59L509.09 287.86L509.26 288.1L509.12 288.47V288.74L509.29 289.06L509.08 289.23V289.42L508.99 289.57L509.21 289.78L509.08 289.88H508.89V290.14L508.99 290.26V290.45L509.09 290.61L508.93 290.79V291.06L508.81 291.2L508.94 291.44V291.59L508.79 291.47L508.67 291.57L508.85 291.66L508.74 292.23L508.62 292.29L508.85 292.69L508.64 292.95L508.71 293.03H508.87V293.14L508.6 293.2L508.76 293.55L508.51 293.8L508.46 293.95L508.71 294.2V294.39H508.52L508.66 295.05L508.37 295.41L508.53 295.81L508.4 296.03L508.46 296.22L508.3 296.32L508.44 296.53L508.26 296.78H508L508.18 297.02L508.12 297.21L508.29 297.49V297.64L508.13 297.82L508.3 298.06L508.25 298.17L508.1 298.24L508.15 298.51L508.06 298.66H507.91V298.78L508.14 298.72L508.21 298.8L508.1 299.33L507.81 299.54L507.88 299.66L508.12 299.56V299.71L507.98 299.97V300.47L507.89 300.73L507.72 301.98L507.81 302.26L507.73 302.36L507.79 303.06L507.32 303.14L507.07 303L506.39 302.88L506.11 302.97H505.39L505.13 302.84L505.29 302.28V301.82L505.37 301.71V301.4L505.31 301.28V301.02L505.39 300.91L505.44 300.22L505.67 300.28L505.79 300.21L505.49 300.04L505.43 299.92L505.5 299.5L505.63 299.24L505.57 299.05V298.51L505.66 298.29V297.72L505.78 297.57H505.71L505.83 297.47L505.63 297.14L505.71 297V296.84L505.84 296.62L505.74 296.39V296.01L505.87 295.83L505.77 295.59L505.86 295.37V295.21L505.94 295.07L505.88 294.91L505.98 294.61L505.88 294.41L505.94 293.58H506.09L506.14 293.47L506 293.34L506.2 292.71L506.06 292.51V292.35L506.26 292.25L506.31 292.03L506.11 291.63L506.31 291.49L506.17 291.41L506.37 291.19V291.04L506.22 290.95L506.16 290.79L506.24 290.68L506.43 290.74V290.32L506.21 290.15V289.99L506.33 289.89L506.55 290.06L506.63 289.95L506.38 289.7L506.47 289.52L506.37 289.28L506.54 289.1V288.8L506.67 288.58V288.46L506.76 288.31L506.66 288.08L506.76 287.82L506.85 287.14H507.04L506.91 286.87L506.96 286.75L506.83 286.36L506.98 285.95L506.89 285.64L507.02 285.42V285.27L507.11 285.12L506.93 284.88L507.15 284.59L507.08 284.51L507.13 284.24L507 284L507.13 283.78V283.63L507.22 283.48L507.12 283.32V283.09L507.35 283.19V283.11L507.15 282.76L507.23 282.61L507.06 282.37L507.22 282.3L507.41 282.35L507.53 282.29L507.31 282.12L507.25 281.96L507.33 281.81L507.2 281.54L507.43 281.48L507.28 280.93L507.34 280.74L507.53 280.64L507.37 280.33L507.64 280.19L507.43 279.99L507.63 279.81L507.42 279.57L507.47 279.42L507.75 279.32L507.56 279.19L507.69 279.05L507.52 278.81V278.65L507.64 278.55L507.82 278.71V278.9L508.14 279.2L508.5 278.99L508.79 279.21L508.99 279.11L508.74 278.9V278.78L508.82 278.67H509.01L509.08 278.79L509.23 278.84L509.31 278.77L509.05 278.67V278.52L508.87 278.43L508.73 278.69L508.59 278.6L508.42 278.32L508.06 277.99L508.11 277.84L507.81 277.7L507.75 277.58L507.88 277.36L507.74 277.08H507.86L508.04 277.25V277.32L508.22 277.45L508.42 277.85L508.63 278.02L508.68 277.94L508.52 277.47L508.27 277.23L508.36 277.16L508.58 277.25V277.4L508.87 277.65L508.95 277.58L508.82 277.27L509.1 277.1L508.92 276.97L508.65 277.06L508.54 276.94H507.93L507.87 276.78L507.99 276.71L508.36 276.85L508.48 276.79L508.15 276.53L507.96 276.63L507.81 276.54V276.28H507.96L508.14 276.45L508.3 276.35L508.08 276.21V275.95H508.2L508.33 276.3L508.48 276.35L508.65 276.59L508.56 276.78L509 276.96L509.28 276.83L509.57 277.01L509.85 276.91L510.06 277.12L510.17 276.79ZM506.07 291.96H506.18H506.07ZM507.86 275.55L507.75 275.43L508.14 274.84H508.25L508.34 274.73V274.58L508.43 274.47L508.83 274.65L508.63 274.87H508.51V274.98L508.71 274.88L508.97 274.98L509.07 275.21H508.72L508.5 275.08L508.14 275.28L508.21 275.36L508.04 275.58L507.86 275.55ZM507.68 277.94L507.57 277.82L507.66 277.71L507.92 277.85V278.04L508.22 278.17L508.32 278.3L508.2 278.44V278.52H508.35L508.44 278.83H508.18L507.92 278.66L508.01 278.55L507.94 278.43L507.65 278.26L507.74 278.07L507.68 277.94ZM508.15 274.73H507.99L507.88 274.64V274.49L507.96 274.38L508.25 274.55L508.15 274.73ZM507.4 283.73H507.28V283.81L507.4 283.73ZM507.26 284.52V284.6H507.41L507.26 284.52ZM507.7 280.2L507.77 280.32L508.09 280.11L508.46 280.29L508.58 280.19L508.21 279.97H508.06L507.97 280.07H507.67L507.7 280.2ZM507.7 282.45H507.54L507.72 282.65L507.8 282.55L507.7 282.45ZM507.93 280.86H507.78L507.69 280.93L507.76 281.05H507.88L507.93 280.86ZM507.93 279.34L508.05 279.27H507.86L507.93 279.34ZM508.29 279.63L507.99 279.49L507.83 279.56L508.28 279.78L508.4 279.71L508.29 279.63ZM507.69 282.03L507.8 282.12L507.88 282.01L507.69 282.03ZM508.91 276.43L508.8 276.3V276.07L508.55 275.9L508.63 275.76L508.53 275.63H508.38L508.24 275.43L508.52 275.26L508.63 275.35V275.69L508.88 275.86V276.05L509.21 276.23H509.66L509.77 276.35L509.57 276.49L509.27 276.35L509.03 276.52L508.91 276.43ZM507.83 281.66H507.75V281.74L507.83 281.66ZM508.28 281.27H507.82V281.39L508.12 281.52L507.99 281.67H508.14L508.36 281.88V281.73L508.18 281.53L508.35 281.35L508.49 281.47H508.64L508.4 281.15L508.61 280.86H508.19L508.32 281.13L508.28 281.27ZM508.01 280.83H508.16L508.05 280.75L508.01 280.83ZM508.06 282.17L507.91 282.12V282.28H508.1L508.06 282.17ZM508.06 283.86L507.91 283.77L507.79 283.84L508.01 283.97L508.06 283.86ZM507.98 283.35L508.13 283.44L508.06 283.32L507.87 283.27V283.35H507.98ZM507.98 284.85L507.92 284.65L507.81 284.57L507.73 284.68V284.91L507.91 285L507.98 284.85ZM507.67 286.51V286.58L507.83 286.52L507.67 286.51ZM508.31 279.45L508.42 279.53L508.5 279.46V279.31L508.39 279.22H508.31V279.45ZM508.72 280.55L508.43 280.41L508.31 280.48L508.68 280.66L508.72 280.55ZM508.37 282.16V282.05L508.25 282.11L508.37 282.16ZM508.22 283.68H508.11V283.8H508.22V283.68ZM509.3 274.82L509.22 274.93L508.82 274.67L508.98 274.57L509.42 274.71L509.3 274.82ZM509.37 274.94L509.49 274.87V274.68L509.65 274.58L509.76 274.66V274.82L509.56 274.95L509.66 275.04H509.97L510.08 275.13H510.31L510.42 275.21L510.34 275.28L509.76 275.39L509.85 275.7L509.97 275.64L510.1 275.42L510.32 275.55V275.7L509.97 275.75L510.14 276.07L510.33 275.97L510.41 276.05L510.32 276.12L510.17 276.07L509.98 276.17L509.71 276.11L509.42 275.9L509.37 276.05L509.25 276.12L509.14 276.07L509.01 275.79L508.76 275.62L508.98 275.22L509.08 275.3L509.18 275.01L509.37 274.94ZM508.15 284.17V284.29H508.27V284.18L508.15 284.17ZM508.71 278.17H508.78L508.72 278.01H508.64L508.71 278.17ZM508.94 277.61H508.83L508.71 277.68L508.97 277.78L508.94 277.61ZM508.72 280L508.57 280.07L508.67 280.15H508.91V280.27H509.02V280.12L508.72 280ZM508.72 279.7L508.6 279.76L508.71 279.85L508.83 279.74L508.72 279.7ZM508.47 284.04L508.56 283.89L508.3 283.79L508.36 283.99L508.27 284.14H508.5L508.47 284.04ZM508.98 279.3H508.71L509.03 279.55L508.91 279.73L509.02 279.78L509.14 279.71L509.08 279.4L508.98 279.3ZM508.62 283.09L508.51 283.04L508.42 283.11L508.62 283.09ZM508.41 284.91H508.29V284.99H508.4L508.41 284.91ZM508.68 282.22L508.53 282.17V282.32L508.68 282.22ZM508.92 281.01L508.66 280.95L508.8 281.16L509.06 281.29V280.99L508.92 281.01ZM509.29 275.57L509.13 275.64L509.2 275.72H509.36L509.29 275.57ZM509.39 277.3L509.09 277.2L509.01 277.31L509.26 277.48V277.64L508.98 277.85H509.09L509.32 277.76L509.7 277.9L509.79 277.71L509.42 277.53V277.38L509.39 277.3ZM509.29 274.54V274.43L509.44 274.51L509.29 274.54ZM509.13 278.73L508.97 278.84H509.05L509.45 279.1V278.99L509.34 278.91H509.18L509.13 278.73ZM508.68 282.73L508.75 282.85V283L509.09 283.1L509 282.79L508.78 282.58L508.68 282.73ZM509.58 275.27H509.39L509.27 275.37H509.73L509.58 275.27ZM508.58 285.21H508.65V285.13L508.58 285.21ZM508.81 284.61V284.54H508.73L508.81 284.61ZM509.4 281.41H509.09L509.04 281.55H509.31L509.55 281.38L509.4 281.41ZM509.18 280.74H509.33L509.41 280.63H509.15L509.18 280.74ZM509.37 281.74H509.22L509.1 281.85L509.25 281.93L509.4 281.87L509.37 281.74ZM508.96 284.27L509.1 284.36L509.22 284.29L509.04 284.13L508.96 284.27ZM509.09 284.01L509.21 283.91H509.06L509.09 284.01ZM509.38 281.13L509.64 281.3V281.14L509.38 281.01V281.13ZM509.46 282.67L509.28 282.5L509.48 282.36L509.62 282.56V282.71L509.46 282.67ZM508.86 292.33H508.78L508.83 292.18L508.86 292.33ZM510.26 274.97L510.11 274.92V274.77L510.33 274.9L510.26 274.97ZM510.16 276.34H510.31V276.5H510.05L509.98 276.34H510.16ZM509.91 278.69L510.09 278.81V278.97L509.83 278.79L509.91 278.69ZM509.91 279.45V279.69L509.76 279.75V279.52L509.91 279.45Z",
                fill: "#FFD400"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M521.21 275.81L521.58 276.07L521.81 276.01L521.66 275.96L521.71 275.85H521.93V276.12H522.2V275.97L522.47 275.91V276.14L522.57 276.34L522.77 276.2V276.05L523.03 276.15V276.3L523.29 276.4V276.56H523.49L523.61 276.46L523.46 276.37L523.3 276.43L523.36 276.21H523.48L523.7 276.34V276.45L523.85 276.5L523.98 276.7L524.18 276.6L524.44 276.7L524.31 276.92L524.38 277.08H524.68L524.79 277.17L524.51 277.34L524.45 277.18L524.29 277.24L524.11 277.15V277.31L524.33 277.51H524.45L525.05 277.67H524.93L524.84 277.82L524.98 278.02H525.47L525.58 278.1L525.03 278.29L525.29 278.42L525.56 278.37L525.63 278.49L525.35 278.62L525.21 278.49L524.74 278.65L524.84 278.77L525.16 278.68L525.38 278.81H525.53L525.76 278.72L525.98 278.92L525.86 279.03L525.62 279.09L525.4 278.96H525.25L525.12 279.11V279.19L525.4 279.13L525.58 279.22H525.93L526.14 279.39V279.5L525.83 279.59L525.89 279.71H526.2V279.91L526.08 280.01L526.14 280.21L525.85 280.49V280.61L525.45 280.81H525.57L525.91 280.76L526.06 280.89H526.21L526.39 281.06H526.05L525.88 281.24L525.73 281.19V281.26L525.84 281.35L526.15 281.29L526.29 281.34V281.57L526.06 281.63L526.12 281.75H526.54V281.9L526.34 282.04V282.23L526.05 282.47H526.47L526.57 282.66L526.45 282.77L526.26 282.72H525.76L525.64 282.78L525.71 282.87H526.32L526.27 283.1L526.55 283.35L526.5 283.5L526.38 283.56L526.13 283.39L525.7 283.55L525.81 283.63L526.12 283.58L526.38 283.68L526.32 283.9L526.43 284.02V284.22L526.34 284.36H526.16L526.02 284.2L525.89 284.34H526.08L526.29 284.54L526.13 284.76L526.35 284.85V285.01L525.95 285.13L526.21 285.3L526.08 285.52L526.29 285.8L526.05 285.98V286.13L525.93 286.27L526.1 286.48L526.16 286.67L525.89 286.73L525.95 286.96V287.11L526.17 287.28V287.51H525.87L525.96 287.86L525.91 288.01L526.05 288.21L525.96 288.28H525.81L525.61 288.95L525.37 289.12L525.16 288.77L524.85 288.89V289.05L524.69 289.11L524.63 288.92L524.45 288.71L524.26 288.66L524.37 288.78L524.31 289.05H524.12L524.06 288.82L523.88 288.61L523.59 288.47L523.39 288.61H523.24L523.14 288.87L523.02 288.98H522.87L522.74 288.62L522.56 288.53L522.46 288.34L522.3 288.4V288.51L522.53 288.61V288.91H522.37L522.23 288.82V288.52H522L521.82 288.35L521.62 288.53H521.85V288.87H521.59L521.46 288.51L521.34 288.58V288.73L521.44 288.93H521.28L521.18 288.84H520.71L520.61 288.71L520.18 288.8L519.88 288.7L519.5 288.78L519.36 288.58L519 288.71L518.74 288.61L518.68 288.38L518.57 288.45L518.51 288.71H518.35L518.02 288.57L517.86 288.63L517.64 288.5H517.34L517.22 288.57L517.04 288.4L516.8 288.57V289.07L516.67 289.26L516.74 289.37L516.64 289.64H516.41L516.51 289.8L516.75 289.7V289.82L516.61 290.07V290.23L516.49 290.33H516.34L516.66 290.66L516.54 290.73L516.39 290.68L516.23 290.75L516.52 291L516.46 291.22L516.6 291.35V291.54L516.47 291.79V292.06L516.6 292.34L516.47 292.6L516.53 292.72L516.41 292.9L516.59 293.02V293.64L516.47 293.71L516.64 294.02L516.59 294.17L516.76 294.42L516.59 294.67L516.69 294.83L516.49 295.01L516.55 295.13L516.81 295.3L516.6 295.51L516.67 295.63H516.86L516.73 295.92V296.35L516.86 296.62L516.73 296.81L516.99 297.44V297.55L517.2 297.83L517.1 298.13L517.24 298.25L517.15 298.4L517.28 298.72L517.13 298.78L517.04 298.93H517.31L517.41 299.05V299.24L517.51 299.33L517.57 299.6L517.48 299.75L517.73 299.96L517.79 300.27L518.02 300.82L517.85 301H518.11L518.36 301.21L518.62 301.31L518.54 301.46L518.84 301.56L519.01 301.72L519.24 301.78L519.6 302.07H519.68L519.86 302.23H520.09L520.29 302.09L520.54 302.23L521.33 301.98L521.47 302.07L521.56 301.96L521.79 301.86L522.05 301.96V301.69V301.54L522.21 301.47L522.66 300.97L522.57 300.73L522.65 300.63V300.36L522.73 300.25V299.94L522.9 299.77V299.5L522.79 299.34L522.93 299.01V298.66L522.86 298.51L523.02 297.87L522.96 297.71L523.06 297.37L522.98 296.95V296.6L523.17 296.2L523.1 296.08L523.22 295.44L523.12 295.28V294.09L523.03 293.78L523.12 293.67L523.43 293.62L523.58 293.67L523.73 293.6L523.92 293.69L524.19 293.64L524.45 293.73H525.33L525.5 294.01L525.41 294.65V294.96V295.11L525.47 295.31L525.38 295.45L525.44 295.61L525.38 295.91L525.45 296.11L525.36 297.25L525.27 297.51L525.15 297.58V297.69H525.38L525.32 297.88L525.17 297.94L525.28 298.52L525.07 298.66L525.16 299.01L525.08 299.16L525.21 299.36L525.1 299.85L524.97 300.03L525.12 300.12L525.07 300.3H524.88L524.99 300.38V300.69L524.87 300.8L524.61 300.7L524.78 300.94H524.97V301.01H525L524.75 301.18L524.82 301.3L525.01 301.35V301.62L524.83 301.49L524.71 301.56L524.81 301.72V301.91L524.69 302.01V302.17L524.49 302.34V302.49L524.73 302.39L524.8 302.51L524.67 302.62H524.52L524.4 302.69V302.99L524.13 303.05L524.04 303.27L523.56 303.5L523.3 303.41L523.18 303.47L523.25 303.59L523.5 303.76L523.38 303.83H523.04L522.93 303.74L522.81 303.85L523.02 304.05L522.97 304.2H522.63L522.46 304.45L522.28 304.28L522.19 304.47L522.12 304.39L521.99 304.49H521.77L521.51 304.32L521.38 304.51L521.02 304.71H520.83V304.6L520.69 304.55L520.48 304.69L519.96 304.53V304.6H519.76L519.69 304.52L519.43 304.46L519.34 304.19L519.13 304.36L518.83 304.3L518.69 304.1L518.89 303.96H519.05L518.98 303.84H518.79L518.67 303.91V304.02H518.29L518.49 303.88L518.39 303.76L518.11 303.86H518L517.8 303.46H517.65L517.51 303.26H517.36L517.18 303.09V302.94H516.83L516.51 302.68L516.42 302.33L516.23 302.28L516.17 302.12V301.97L515.97 301.58L515.75 301.37V301.18L515.61 300.94L515.67 300.75L515.41 300.54L515.23 299.38L515.05 298.8L514.75 297.05V296.91L514.61 296.28L514.7 296.1L514.6 295.94L514.54 295.63L514.6 295.37L514.42 295.16L514.51 294.59L514.45 294.28V293.87L514.58 293.68L514.51 293.6H514.39V292.88L514.47 292.77L514.38 292.49L514.47 292.35L514.36 292.19V291.73L514.49 291.59L514.38 291.46V291.16L514.51 291.01V290.71L514.42 290.36L514.55 290.21L514.41 290.01L514.46 289.9L514.4 289.63L514.52 289.52L514.71 289.61L514.79 289.54L514.58 289.22L514.51 288.68L514.64 288.43L514.58 288.27L514.7 288.12L514.57 287.85L514.78 287.67L514.63 287.51V287.36V287.05L514.79 286.91V286.57L514.69 286.33L514.82 286.19L514.96 286.27L515.05 286.16H514.9L514.84 285.85L514.93 285.75L515.12 285.68V285.6L514.92 285.7L514.83 285.39L514.92 285.25V285.13L515 285.02L514.95 284.75L515 284.6H515.11V284.33L515.26 283.8V283.5L515.47 283.28V283.13L515.64 282.91L515.58 282.76L515.67 282.57V282.3L515.87 282.13V281.82L515.99 281.72H516L515.82 281.63L515.99 281.37L515.9 281.06L516.02 280.95L516.2 281.04V280.93L516.07 280.69L516.42 280.53L516.21 280.36L516.44 280.26L516.35 279.95L516.44 279.84L516.66 279.89L516.58 279.43H516.74L516.95 279.6L517.11 279.5L517.26 279.55L517.42 279.48L517.2 279.35L517.08 279.5L516.86 279.37V279.17L516.95 279.06L517.28 279.2L517.56 279.11L517.66 279.19L517.97 279.25L518.09 279.15L518.02 279.03L517.61 278.92H517.26L517.2 278.69L517.32 278.62L517.62 278.72H517.78V278.61H517.59L517.41 278.49L517.65 278.31H517.88L517.98 278.47L518.07 278.32L517.77 278.15L517.54 278.25L517.47 278.13L517.86 278L517.94 277.89L518.17 277.95L518.31 278.07H518.39L518.22 277.79L518.27 277.64L518.72 277.75L518.8 277.68L518.56 277.32V277.01H518.71V277.16L519 277.34L519.2 277.27H519.5L519.61 277.35H519.91L520 277.24L519.84 277.3L519.29 277.03L519.2 277.18L519.02 277.05L518.93 276.74V276.59L519.06 276.83L519.21 276.88L519.33 276.81L519.2 276.57L519.28 276.46H519.7L519.6 276.19L519.72 276.12L519.9 276.29L520 276.14V276.29L520.11 276.42V276.04L520.45 276.1L520.53 276.03V275.84H520.8L520.98 276.04H521.1V275.78L521.21 275.81ZM514.93 287.81L514.87 287.69V287.8L514.93 287.81ZM516.2 282.55H516L516.07 282.67H516.19L516.2 282.55ZM516.2 282.89H516.09L516.04 282.96L516.2 282.89ZM516.53 281.5V281.35H516.38L516.53 281.5ZM516.53 283.11V282.99H516.39V283.1L516.53 283.11ZM516.72 281.06H516.83L516.88 280.95L516.65 280.89L516.72 281.06ZM516.9 280.58L517.02 280.51L516.92 280.42L516.79 280.53L516.9 280.58ZM516.31 289.66L516.39 289.59V289.48L516.19 289.58L516.31 289.66ZM517.05 279.71H517V279.79L517.05 279.71ZM516.9 282.18L516.83 282.1V282.14L516.9 282.18ZM520.9 278.08L520.82 278.15L520.61 277.95L520.4 278.08L520.55 278.25L520.43 278.32L520.12 278.26L520.21 278.11L519.81 277.85L519.72 278L519.94 278.13L520.01 278.25L519.87 278.54H519.99L520.09 278.74L519.87 278.65L519.48 278.77L519.3 278.64L519.02 278.7L519.28 278.8L519.46 279.46H519.31L519.16 279.37L518.81 279.49H518.54L518.65 279.61H518.95L519.21 279.78L519.09 279.85L518.83 279.72L518.71 279.82L518.84 280.1L518.79 280.21L518.53 280.15L518.45 280.26L518.54 280.53L518.46 280.64L518.27 280.55H518.12L518.29 280.79V280.98L518.43 281.22L518.31 281.33L518.16 281.24L517.77 281.4H517.61L517.51 281.24H517.36V281.35L517.62 281.45L517.73 281.57L518 281.47L518.15 281.56L518.21 281.72L517.94 281.78L517.83 281.69H517.71L518 281.98L517.83 282.16L517.72 282.07H517.34L517.26 282.17H517.45L517.67 282.38L517.94 282.32L518 282.48L517.88 282.58L517.74 282.46L517.46 282.59H517.27L517.2 282.47H517L516.88 282.57L517.02 282.66H517.18L517.25 282.78L517.44 282.72L517.74 282.78L517.81 282.94L517.69 283.01L517.35 282.94L517.26 283.05L517.51 283.3L517.23 283.58H517.49L517.56 283.66L517.44 283.73H517.25L517.13 283.79L517.34 284.04L517.29 284.19H517.1L517.02 284.3L517.2 284.51L516.87 284.75L517.21 284.81L517.28 284.93L517.08 285.07L516.93 284.98H516.85L517.02 285.26L516.93 285.48L517.15 285.61V285.73L516.9 285.94L517.07 286.29L517.31 286.12L517.71 286.38L517.87 286.24L518.24 286.42L518.6 286.26L518.78 286.46H519L519.24 286.33L519.53 286.42L519.96 286.34L520.09 286.62L520.27 286.36L520.39 286.3L520.56 286.5L520.75 286.55L521.03 286.31L521.14 286.39L521.24 286.67L521.42 286.76L521.47 287.14H521.62L521.68 286.92L521.54 286.72L521.64 286.46H521.75L521.97 286.62L522.21 286.45L522.36 286.5V286.65L522.49 286.89L522.61 286.82L522.71 286.56L522.87 286.5L523 286.74L523.29 286.49L523.43 286.66H523.69L523.93 286.06V285.91L524.02 285.8L523.88 285.6V285.45L524.04 285.3L523.99 285.03L524.09 284.73H524.32L524.17 284.61L524.12 284.26L524.2 284.19L524.53 284.37L524.66 284.26L524.18 284V283.88L524.33 283.97L524.45 283.9L524.38 283.74L524.16 283.57V283.14H524.43V283.06L524.19 282.78L524.27 282.67H524.43L524.6 282.84L524.88 282.74L524.99 282.79L525.08 282.68L524.47 282.6L524.36 282.48L524.49 282.33L524.38 282.25H524.26L524.21 282.47L524.14 282.39L524.2 282.09L524.14 281.86L524.22 281.25L524.16 281.06V280.91L524.07 280.63L524.26 280.53L524.05 280.32L523.99 280.09L524.06 279.75L523.8 279.54L523.74 279.38L523.94 279.21L523.79 279.16L523.64 279.22L523.57 279.14V278.84H523.26V278.45L523.35 278.31L523.09 278.21L523.04 278.36H522.78L522.91 278.14L522.43 278.37L522.37 278.14L522.11 278.01L521.83 278.18L521.7 277.97L521.5 278.07V278.22H521.15L521.24 278.03L521.18 277.91L520.94 277.97L520.9 278.08ZM517.3 280.26L517.39 280.15L517.24 280.1L517.12 280.17L517.3 280.26ZM516.81 285.88L516.93 285.81L516.82 285.73L516.7 285.83L516.81 285.88ZM516.4 291.39L516.52 291.32H516.41L516.29 291.39H516.4ZM517.33 279.92L517.41 279.85L517.3 279.77L517.17 279.91L517.33 279.92ZM517.25 281.48H517.1V281.56L517.25 281.48ZM517.07 281.81H517.22V281.73H517.11L517.07 281.81ZM517.15 282.28V282.2H517.03L517.15 282.28ZM516.49 291.67H516.38V291.78L516.49 291.67ZM517.35 280.67V280.59H517.28V280.67H517.35ZM517.62 279.58V279.47L517.47 279.53L517.62 279.58ZM517.62 280.3L517.55 280.18L517.47 280.29L517.62 280.3ZM517.45 281.05H517.64L517.54 280.93L517.45 281V281.05ZM517.89 277.72H517.78V277.57H517.89V277.72ZM517.46 284.53H517.35V284.46L517.46 284.53ZM517.91 279.53L518.07 279.47L517.81 279.37L517.91 279.53ZM517.83 280.02L517.99 279.92L517.85 279.87L517.8 279.98L517.83 280.02ZM518.32 278.61L518.06 278.51V278.63L518.32 278.76L518.44 278.66L518.32 278.61ZM518.12 280.27L517.97 280.22L518.04 280.38H518.19L518.12 280.27ZM517.95 281.06V281.18H518.1V281.11L518.03 280.99H517.88L517.95 281.06ZM518.31 278.3L518.53 278.39V278.21L518.27 278.11L518.15 278.22L518.31 278.3ZM518.4 279.03L518.34 278.91L518.22 278.98L518.4 279.03ZM518.49 279.88L518.35 279.83L518.48 280.03H518.6L518.49 279.88ZM518.9 278.99L518.52 279.04V279.16H518.9L519.01 279.24L519.16 279.18L519.1 279.06H519L518.9 278.99ZM519.01 277.55L519.17 277.48L519.03 277.36H518.91L519.01 277.55ZM518.8 278.83L518.92 278.77L518.81 278.72L518.8 278.83ZM518.2 288L518.25 287.85L518.12 287.96L518.2 288ZM519.03 278.31V278.2L518.92 278.15V278.3L519.03 278.31ZM519.48 277.89L519.34 277.8L519.21 277.91L519.43 278.12V278.23L519.34 278.34H519.19L519.14 278.49L519.49 278.44L519.64 278.53H519.76L519.65 278.41L519.56 278.05L519.48 277.89ZM518.48 288.33L518.4 288.28V288.4L518.48 288.33ZM519.56 276.79L519.87 276.74L519.8 276.62H519.61L519.5 276.69L519.56 276.79ZM519.56 277.59H519.68L519.49 277.5L519.56 277.59ZM519.93 277.28L520.04 277.36V277.21L520 277.14L519.92 277.21L519.93 277.28ZM520.18 277.53L520.05 277.63L520.38 277.81L520.47 277.74V277.62H520.31L520.18 277.53ZM519.38 288.14V288.06V288.14ZM520.38 276.68H520.26L520.33 276.76L520.38 276.68ZM520.38 276.34V276.46H520.58V276.2H520.35L520.38 276.34ZM520.84 276.79V276.68L520.69 276.75L520.84 276.79ZM520.9 277.52H520.83V277.67L520.9 277.52ZM521.14 276.4H521.25V276.29H521.13L520.99 276.16L520.94 276.31L521.04 276.44L521.14 276.4ZM520.92 278.25H520.85L520.97 278.18L520.92 278.25ZM521.04 277.25L521.12 277.14L521 277.21L521.04 277.25ZM519.67 304.47V304.32H519.55V304.39L519.67 304.47ZM522 278.14V278.02H522.11L522 278.14ZM522.38 276.6L522.43 276.45L522.3 276.21V276.63L522.38 276.6ZM522.61 276.69L522.51 276.99L522.66 277.04L522.74 276.93V276.7L522.94 276.6V276.45L523.07 276.26L522.87 276.36L522.81 276.67L522.61 276.69ZM522.99 276.61H523.07V276.54H522.99V276.61ZM521.32 302.24V302.16H521.2L521.32 302.24ZM523.32 277.09V276.94L523.1 276.85L523.15 277.19L523.32 277.09ZM523.39 276.71H523.54L523.74 276.5H523.48L523.39 276.71ZM523.56 277.53V277.45V277.56V277.53ZM523.56 277.91H523.48V278.06L523.56 277.91ZM523.82 278L523.9 277.93L523.79 277.85L523.67 277.91V278.03L523.82 278ZM523.92 277.21L523.97 277.02H523.85L523.76 277.24L523.92 277.21ZM523 288.45H522.88V288.53L523 288.45ZM523.82 276.77V276.92H524.01L524.29 276.75L524.06 276.69L523.98 276.77H523.82ZM523.77 278.49L524.09 278.4L523.98 278.28L523.67 278.37L523.77 278.49ZM523.05 287.76L523.13 287.65L523.06 287.57L522.98 287.68L523.05 287.76ZM523.84 277.62V277.69L524.23 277.64V277.45H524.16L524.03 277.63L523.84 277.62ZM524.12 277.41V277.22H524L523.92 277.33L524.12 277.41ZM524.17 276.19V276.3H524.09V276.14L524.17 276.19ZM523.95 278.08L524.49 278L524.42 277.85L524.78 277.72L524.71 277.6L524.45 277.47L524.4 277.58V277.85L524.05 277.9L523.95 278.08ZM523.28 287.08L523.42 287.2V287.43L523.54 287.36V287.14L523.36 286.94L523.28 287.08ZM523.65 288.83V288.98H523.45L523.35 288.82H523.2V288.67L523.31 288.76L523.55 288.66L523.66 288.71L523.65 288.83ZM522.22 304.01V304.16L522.33 304.21V303.83H522.21L522.22 304.01ZM524.22 280.23L524.34 280.12L524.15 280.19L524.22 280.23ZM524.63 278.35H524.47L524.34 278.53H524.8V278.37L524.63 278.35ZM524.44 279.35L524.67 279.25L524.53 279.16L524.4 279.31L524.44 279.35ZM524.26 281.67L524.35 281.6H524.27L524.26 281.67ZM524.17 285.56L524.25 285.45L524.14 285.36L524.06 285.47L524.17 285.56ZM524.04 285.78H524.23L524.04 285.69V285.78ZM524.71 278.22H524.87V278.11L524.73 278.03L524.6 278.13L524.71 278.22ZM524.71 279.07L524.99 278.93L524.88 278.85H524.61V278.96L524.71 279.07ZM524.6 280.13V280.01L524.51 280.08L524.6 280.13ZM524.73 279.79L524.82 279.69H524.71L524.62 279.8L524.73 279.79ZM524.47 283.37H524.36L524.42 283.49H524.5L524.47 283.37ZM524.32 285.95V285.84H524.21L524.32 285.95ZM524.7 280.21L524.77 280.29H525L525.2 280.12L524.93 280.17L524.7 280.21ZM524.6 282.14H524.79L524.61 282.05L524.6 282.14ZM524.69 283.03V282.91H524.5L524.69 283.03ZM524.95 279.49L525.11 279.43L525.19 279.28L524.84 279.37L524.95 279.49ZM524.67 283.71L524.6 283.63L524.52 283.7L524.67 283.71ZM524.67 283.48V283.4V283.48ZM524.96 280.48L524.89 280.4V280.51L524.96 280.48ZM525.05 281.4V281.51L525.16 281.56L525.05 281.4ZM525.05 282.29L524.95 282.16L524.9 282.27L525.05 282.29ZM524.92 284.65H524.77V284.77L524.92 284.65ZM525.48 277.12L525.37 277.07H525.48V277.12ZM525.55 279.76L525.44 279.64H525.29V279.79L525.55 279.76ZM525.21 280.65V280.58V280.65ZM525.08 282.98H525.23L525.45 283.11V282.99L525.16 282.85L525.08 282.98ZM525.52 280.14L525.32 280.28H525.47L525.71 280.15L525.6 280.06L525.52 280.14ZM525.4 282.27V282.16L525.25 282.11L525.17 282.18L525.4 282.27ZM525.16 283.48H525.31L525.21 283.36L525.09 283.43L525.16 283.48ZM525.57 279.48L525.77 279.3H525.51L525.42 279.41L525.57 279.48ZM525.21 283.85V283.77H525.14L525.06 283.84L525.21 283.85ZM525.45 281.11L525.73 280.98L525.62 280.9L525.41 281.07L525.45 281.11ZM525.51 281.88L525.59 281.77H525.48L525.39 281.88H525.51ZM525.86 278.09H525.75L525.87 277.98L525.86 278.09ZM525.76 279.95L526.19 279.87L526.13 279.71H526L525.72 279.88L525.76 279.95ZM526.15 278.41L526.03 278.48L525.84 278.39V278.31L526.15 278.41ZM525.69 281.51H525.61L525.68 281.59L525.69 281.51ZM525.49 285.17H525.64V285.14H525.49V285.17ZM524.56 300.27L524.45 300.18L524.37 300.29L524.56 300.27ZM525.92 281.53L526.07 281.46L525.93 281.34L525.81 281.44L525.92 281.53ZM525.81 282.94L525.69 283L525.8 283.09L525.92 283.02L525.81 282.94ZM525.9 282.29V282.18H525.83L525.75 282.29H525.9ZM525.9 283.89V283.82H525.74L525.9 283.89ZM525.79 284.38V284.31L525.71 284.38H525.79ZM525.85 284.65V284.54L525.76 284.65H525.85ZM526.46 280.57L526.18 280.63L526.12 280.47L526.4 280.34L526.51 280.42L526.46 280.57ZM525.77 286.71V286.63L525.68 286.74L525.77 286.71ZM524.97 299.07V298.92L524.89 299.06L524.97 299.07ZM526 284.89L526.09 284.78H525.9L525.85 284.89H526ZM525.92 285.99V285.91L525.76 285.98L525.92 285.99ZM526.22 281.99L526.3 281.92L526.19 281.83L526.11 281.9L526.22 281.99ZM526.22 286.27L526.11 286.22L526.19 286.15L526.37 286.32L526.22 286.27ZM526.22 287.84L526.13 287.91V287.83L526.22 287.84ZM526.7 282.29H526.59V282.22L526.7 282.29ZM526.63 283.85V283.96L526.56 283.88L526.61 283.77L526.63 283.85Z",
                fill: "#FFD400"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M531.16 278.2L531.08 278.3L531 278.14L531.12 278.08L531.16 278.2ZM533.59 276.35H533.74L533.94 276.21H534.09L534.23 276.41H534.54V276.56L534.83 276.77L534.89 276.96L535.11 277.06L535.17 277.37L535.43 277.46L535.49 277.58L535.37 277.69L535.59 277.89V278.05L535.33 277.99V278.11L535.58 278.28V278.51L535.68 278.7L535.55 278.92V279.08L535.42 279.34L535.24 279.17L535.12 279.24L535.2 279.66V279.89H535.05L535.17 279.7L534.92 279.53V280.03L534.73 279.98L534.61 280.05V280.39L534.27 280.29V280.59L533.99 280.65V280.42H533.83L533.66 280.68H533.24L533.4 280.54L533.23 280.3L533.11 280.41V280.6L532.75 280.34V280.53H532.68L532.42 280.4V280.14H532.18H532.04V280.02L531.77 279.96L531.86 279.81L531.76 279.58L531.89 279.43L531.71 279.31L531.66 279.42L531.77 279.54L531.68 279.61H531.46L531.35 279.53L531.47 279.39V279.12L531.7 279.17L531.76 278.91L531.65 278.82L531.45 278.96L531.3 278.87V278.76L531.39 278.61H531.51L531.69 278.74V278.63L531.47 278.38L531.53 278.16H531.34V277.89L531.68 277.95V278.14L531.94 278.28L531.85 278H531.74L531.79 277.85L531.69 277.65V277.5L532.03 277.56L532.18 277.5L531.98 277.21V277.1L532.32 277.24L532.47 277.18L532.41 277.02L532.15 276.85L532.27 276.78L532.57 276.88L533.04 276.68V276.49L533.43 276.37L533.54 276.49L533.76 276.54L533.59 276.35ZM531.51 277.15L531.65 277.28H531.5L531.51 277.15ZM530 298.52L529.92 298.47L529.97 298.36H530.24L530 298.52ZM532.44 294.95L532.63 295L532.69 295.74L532.6 295.84V296.3H532.22L532.29 296.42L532.55 296.48L532.46 296.63L532.55 297.01L532.46 297.12L532.17 296.91L532.05 297.01L532.45 297.35L532.36 297.5L532.48 297.93H532.25V298.08L532.36 298.17L532.23 298.31L532.29 298.51L532.4 298.59V298.78H532.28L532.02 298.65L531.9 298.71L532.15 298.96L532.06 299.18L531.91 299.13L531.78 298.86L531.52 298.65L531.46 298.49L531.58 298.42H531.89V298.22L531.79 298.1L531.36 298.22L531.18 298.02L531.05 298.2L531.27 298.44V298.63L531.15 298.7L530.86 298.49L530.7 298.55L530.88 298.76L531.14 298.89L531.26 298.79H531.6V298.95L531.51 299.06L531.14 298.91L530.98 299.05L531.23 299.26L531.57 299.33L531.69 299.22L531.99 299.4L531.74 299.68L531.45 299.43L531.01 299.63L531.12 299.75L531.31 299.69L531.65 299.79L531.52 300.01L531.63 300.1L531.97 300.16L531.8 299.88L531.85 299.73L532.26 299.84L532.1 299.98L532.34 300.22V300.38L532.22 300.49L531.89 300.27L531.81 300.38L531.87 300.5H532L532.13 300.77V300.96L532.34 301.17V301.36L532.26 301.43H532L531.87 301.23L531.66 301.44H531.85L531.95 301.57H532.07L531.86 301.86H531.71L531.49 301.65H531.41L531.32 301.95L531.68 302.17V302.28L531.91 302.68V302.79L531.55 302.5V302.34L531.3 302.13L531.06 302.27H530.87L530.57 302.09L530.49 302.24L530.9 302.38L531.05 302.32L531.2 302.44L531.5 302.5L531.29 302.72L530.92 302.57L530.8 302.64L530.87 302.76L531.13 302.9H531.51L531.62 302.98H532L532.07 303.1V303.29H531.92L531.66 303.12L531.53 303.3L531.93 303.6L531.88 303.75H531.77L531.55 303.62L531.48 303.46V303.31L531.08 303.02L530.88 303.19L530.65 303.14L530.52 302.9L530.27 303.11L530.02 302.94V302.75L530.18 302.68L530.48 302.78V302.71L530.2 302.42L530.29 302.27L530.04 302.02V301.87L530.34 301.97V301.67L530.16 301.46H530.05L530.25 301.29L530.04 301L530.21 300.78L529.98 300.84L529.73 300.63V300.48L529.81 300.37H530.08L530.23 300.46L530.43 300.36L530.83 300.54L530.66 300.87L530.98 301.09H531.52L531.67 301.02L531.54 300.82V300.47L531.33 300.3V300.07L531.04 299.86H530.77L530.87 299.98L531.06 300.03L531.17 300.16L530.81 300.32L530.56 300.07L530.39 300.25H530.17V299.98L530.4 299.92L530.34 299.76L530.1 299.86L529.92 299.73L529.97 299.54L530.27 299.64L530.51 299.54L530.65 299.63H530.81V299.29L530.89 299.18L530.78 299.09H530.59L530.38 298.81L530.47 298.66L530.22 298.41L530.62 298.14V297.83L530.26 297.61H530.07V297.5L530.34 297.4L530.2 297.24V297.08L530.29 296.94H530.44L530.54 297.1L530.67 296.95L530.46 296.63L530.55 296.53L530.78 296.47L530.71 296.35L530.44 296.44H530.33V296.33L530.41 296.22H530.68L530.36 295.89L530.64 295.76H530.83V295.61L530.68 295.49L530.56 295.67L530.41 295.62V295.47L530.65 295.37V294.88L530.55 294.68L530.66 294.3L530.58 293.8L530.71 293.58V293.24L531 293.14L530.75 292.97L530.87 292.82L530.74 292.51L531 292.14L530.94 291.95V291.87L530.85 291.56L530.91 291.26L531.09 290.97L530.92 290.69V290.53L531.08 290.43L531.01 289.78L531.11 289.52V289.25L531.35 289.07V288.96L531.28 288.88H531.09L531.14 288.19L531.05 287.88L531.23 287.51V287.09L531.32 286.45L531.44 286.38L531.38 286.18L531.5 286.04L531.37 285.72L531.55 285.43V285.09L531.64 284.9V284.06L531.73 283.92H531.84L531.92 283.82L531.86 283.7H531.7V283.43H532.58L532.74 283.32L533.11 283.5L533.23 283.44H533.84L533.9 283.71L533.78 284.32L533.93 284.86L533.72 285.08L533.82 285.24L533.72 285.57L533.83 285.7V286.12L533.63 286.22L533.7 286.37L533.65 286.52L533.41 286.62L533.56 286.67L533.67 286.83L533.46 286.97L533.68 287.21L533.36 287.8L533.57 288.09V288.24L533.32 288.56L533.47 289.03L533.22 289.36L533.36 289.52L533.27 289.71L533.37 289.98V290.13L533.15 289.96L533.02 290.1L533.34 290.43V290.58L533.44 290.78L533.31 291.08L533.19 291.14L533.28 291.38V291.99L533.19 292.1V292.75L532.92 292.84L533.13 293.05V293.24L533 293.38V293.5L532.84 293.68L532.97 293.92V294.03L532.85 294.14L532.56 294L532.47 294.11L532.66 294.16L532.85 294.71L532.75 295.05L532.64 294.89L532.44 294.95ZM529.85 302.02L529.73 302.09V301.93H529.92L529.85 302.02ZM529.64 302.81L529.8 302.71L529.71 302.93L529.64 302.81ZM529.64 304.57H529.49L529.58 304.43L529.68 304.51L529.64 304.57ZM530.04 299.25H529.92V299.02L530.1 299.11L530.04 299.25ZM529.65 303.92L529.59 303.8H529.66L529.65 303.92ZM530.24 298.08L530.09 298.03V297.91L530.18 297.8L530.4 297.86V298.05L530.24 298.08ZM530.24 298.69L530.35 298.77V298.88H530.12V298.77L530.24 298.69ZM530.02 300.2L529.94 300.15L529.99 300.04L530.02 300.2ZM530.02 301.34L530.16 301.5H530.08L529.9 301.37L530.02 301.34ZM530.62 304.1L530.73 304.18H531.19L531.29 304.3L531.24 304.45H531.13L530.83 304.31L530.67 304.38V304.57L530.43 304.63H530.28L529.97 304.72L529.86 304.64L530.03 304.46L529.84 304.41L529.67 304.2L529.75 304.06H530.02L530.24 304.19L530.48 304.09L530.62 304.1ZM530.2 302.5H530L529.82 302.29H529.98L530.24 302.42L530.2 302.5ZM530.69 303.61L530.36 303.51H530.2L530.27 303.67H530.88L530.98 303.76V303.91H530.83L530.49 303.81L530.37 303.91L530 303.73V303.55L529.78 303.38L529.72 303.22V303.07L530.13 303.18L530.37 303.08L530.65 303.33L530.69 303.61ZM531.96 277.83H532.07V277.68H531.96L531.84 277.79L531.96 277.83ZM530.27 301.55L530.16 301.5L530.27 301.55ZM532.06 278.45H531.99V278.6L532.1 278.69L532.06 278.45ZM530.9 294.64H530.82L530.74 294.74V294.82L531.04 294.88L530.94 294.76L530.9 294.64ZM530.54 299.47L530.4 299.38V299.19L530.64 299.09L530.71 299.18V299.48L530.63 299.55L530.54 299.47ZM532 278.14V278.26L532.28 278.2V278.14L532.13 278.09L532 278.14ZM532.29 277.44H532.52L532.41 277.35H532.1V277.43L532.29 277.44ZM531.92 279.78H532.04H531.93H531.92ZM530.21 304.42V304.27H530.09V304.38L530.21 304.42ZM531.11 292.71L531.2 292.6L531.09 292.52L531.01 292.63L531.11 292.71ZM532.11 279.56L532.22 279.61V279.46L532.08 279.3L531.99 279.44L532.11 279.56ZM530.55 301H530.71L530.79 300.89H530.61L530.45 300.95L530.55 301ZM531 296.14V296.02H530.89V296.13L531 296.14ZM530.9 297.5L530.99 297.4L530.76 297.34V297.42L530.9 297.5ZM530.73 297.83L530.84 297.88L530.96 297.81L530.89 297.66H530.74L530.73 297.83ZM530.95 296.93L531.03 296.83L530.83 296.89L530.95 296.93ZM531.03 295.26V295.18V295.37V295.26ZM530.65 301.38L530.83 301.55L530.7 301.81L530.99 302.02H531.14L530.95 301.59L531.11 301.45L531.56 301.56V301.36L531.26 301.19L530.87 301.31L530.77 301.19H530.58V301.34L530.65 301.38ZM532.47 277.9H532.85L532.74 277.82H532.63L532.45 277.66L532.33 277.76L532.47 277.9ZM531 298.28H530.89L530.84 298.36L531 298.28ZM530.46 304.51H530.39V304.58L530.46 304.51ZM532.46 278.67H532.54L532.47 278.55L532.39 278.62L532.46 278.67ZM532.78 276.4V276.51L532.63 276.46V276.39L532.78 276.4ZM532.59 279.94L532.53 279.82H532.45V279.94H532.59ZM531.59 292.94L531.83 292.76L531.76 292.68L531.49 292.81L531.59 292.94ZM531.43 294.07V293.96L531.35 294.03L531.43 294.07ZM531.38 295.79L531.47 295.68L531.35 295.63L531.27 295.7L531.38 295.79ZM531.31 296.24V296.32H531.47L531.55 296.21L531.43 296.28L531.31 296.24ZM531.42 297.32L531.31 297.23L531.23 297.34L531.4 297.55L531.67 297.61V297.45H531.52L531.42 297.32ZM531.72 297.88L531.66 297.76H531.39L531.18 298.01L531.42 297.91H531.57L531.86 298.09L532.14 297.99L532.22 297.89L532.03 297.83L531.87 297.94L531.72 297.88ZM532.72 278.31H532.88L532.77 278.19L532.65 278.26L532.72 278.31ZM531.34 303.62L531.18 303.72L530.86 303.47L530.98 303.4L531.43 303.51L531.34 303.62ZM531.57 295.92L531.65 295.85L531.47 295.8L531.57 295.92ZM531.57 294.92L531.64 295.04H531.75L531.96 294.87L531.85 294.82L531.76 294.89L531.57 294.92ZM531.47 300.92L531.32 300.99L531.21 300.9L531.15 300.71L531.27 300.6L531.45 300.65L531.56 300.77L531.47 300.92ZM531.79 294.64L531.9 294.69L532.02 294.62L531.76 294.45L531.68 294.52L531.79 294.64ZM532.79 280.31L532.9 280.39H533.02L533.1 280.25L533 280.09H532.85L532.77 280.16L532.79 280.31ZM533.31 276.87L533.17 276.78L533.05 276.85L533.31 276.87ZM531.87 293.81H531.98L532.1 293.74L531.8 293.65L531.87 293.81ZM531.19 303.96L531.04 303.91L531.19 303.96ZM533.25 277.17L533.18 277.09L533.1 277.2L533.25 277.17ZM533.07 277.65L533.15 277.58H533.07V277.65ZM531.63 304.14L531.36 304.2L531.22 304.08V304L531.75 304.07L531.63 304.14ZM531.9 295.91H532.02L531.95 295.79L531.83 295.86L531.9 295.91ZM531.82 297.59L531.96 297.67H532.23L532.32 297.57L532.08 297.63L531.83 297.45L531.71 297.52L531.82 297.59ZM532.11 294.13H531.99L532.1 294.21L532.26 294.15L532.11 294.13ZM531.98 296.91H532.09L531.92 296.63L531.8 296.7L531.98 296.91ZM532.31 292.96L532.61 293.06L532.54 292.94L532.28 292.81L532.17 292.87L532.31 292.96ZM533.52 276.65L533.4 276.8H533.55V276.69L533.52 276.65ZM533.44 277.22H533.36V277.33L533.44 277.22ZM533.17 279.84L533.28 279.92L533.44 279.86L533.18 279.69L533.17 279.84ZM532.33 293.84L532.41 293.77L532.34 293.65H532.23V293.8L532.33 293.84ZM532.23 295.13V295.06L532.11 295.13H532.23ZM532.24 296.05L532.09 295.93V296L532.24 296.05ZM531.71 304.73H531.6L531.46 304.49L531.54 304.42L531.84 304.52V304.71L531.71 304.73ZM532.38 294.65L532.23 294.56V294.68L532.38 294.65ZM533.61 276.14L533.83 276.23L533.63 276.3L533.61 276.14ZM533.35 280.14L533.6 280.39L533.73 280.1L533.52 279.89L533.36 279.95L533.35 280.14ZM532.74 291.49V291.41H532.59L532.74 291.49ZM532.47 294.49H532.36L532.47 294.57V294.49ZM532.19 299.25L532.31 299.3L532.37 299.46L532.28 299.6H532.17L532.03 299.4L532.19 299.25ZM532.12 302.34L531.86 302.25V302.13L532 302.14L532.14 302.23L532.12 302.34ZM531.81 303.96L531.89 303.85L532 303.98L531.91 304.08L531.81 303.96ZM533.81 279.69L533.93 279.55L533.83 279.46H533.71L533.81 279.69ZM533.69 279.76H533.76H533.69ZM533 292.05L533.12 291.98L533.02 291.86L532.93 291.97L533 292.05ZM534 280.05V279.9L533.84 279.96V280.14L534 280.05ZM534.09 280.36V280.14H534.21V280.03H534.05L533.92 280.29L534.09 280.36ZM534.64 279.64L534.49 279.55L534.33 279.73L534.47 279.85L534.64 279.64ZM534.5 279.97L534.43 279.85V279.96L534.5 279.97ZM534.93 278.86L534.82 278.77V278.88L534.93 278.86ZM535.53 278.94L535.46 278.82L535.38 278.93L535.53 278.94Z",
                fill: "#FFD400"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M550.56 278.91L550.5 279.21L550.56 279.41L550.43 280.08L550.53 280.4L550.4 280.54V280.73L550.53 281.01L550.33 281.6L550.46 281.92L550.26 282.1L550.19 282.44L550.26 282.55L550.16 282.89L550.22 283.05L550.14 283.2V283.54L550.05 283.69V283.99L550.11 284.15L550.01 284.45V284.6L549.92 284.75V285.06L549.82 285.32V286.05L549.73 286.15L549.68 287.3L549.75 287.42L549.59 288.05V288.44L549.51 288.55V288.74L549.42 288.88L549.56 289.05V289.24L549.47 289.35L549.4 290.83L549.21 291.35L549.31 291.55L549.15 291.65L549.25 291.85L549.15 292.19L549.21 292.35L549.13 292.45V292.73L549.07 293.56L548.9 293.78L548.97 293.9L548.84 294.08V294.5L548.75 294.61L548.82 294.77L548.69 294.95L548.79 295.23L548.62 295.44V296.06L548.49 296.28V296.54L548.55 296.74L548.45 297.04V297.23L548.2 297.52L548.43 297.57L548.31 298.1V298.52H548.15L548.25 298.71V298.87L547.98 299L548.11 299.24L548.02 299.38L548.16 299.59L547.91 299.91L548.06 300.49L547.89 300.71V300.87L547.81 301.01V301.32L547.73 301.43V301.81L547.46 301.86V302.48L547.19 302.53L547.28 302.84L547.2 302.95H547V303.36L546.84 303.47L546.74 303.84L546.46 304.01V304.16L546.16 304.49V304.68L545.81 304.76V304.92H545.62L545.36 304.71H545.29L545.35 304.87L545.61 305L545.44 305.14V305.29L545.22 305.2L545.16 305.5L544.89 305.56L544.67 305.46L544.54 305.57L544.73 305.62V305.89L544.61 305.96H544.34L544.14 306.13V305.98H544.03L543.98 306.13L543.78 306.27H543.63L543.53 306.07L543.24 306.31L543.06 306.22L543 306.41L542.73 306.51L542.58 306.42L542.04 306.49L541.98 306.26L541.74 306.39H541.48L541.26 306.19H540.88L540.78 305.99L540.54 306.05L540.4 306L540.49 305.81V305.7L540.2 305.9L540.09 305.82L539.64 305.75L539.36 305.42L539.17 305.37L539 305.16L539.28 304.99L539.17 304.91L538.93 304.97L538.49 304.29L538.54 304.1H538.35L538.12 303.62L538.17 303.51L538.07 303.35V303.24L538.01 303.08V302.89L537.88 302.08L538.04 301.98L537.91 301.66V300.48L538.04 300.3L537.98 300.14V299.99V298.99L538.08 298.69V298.19L538.24 297.63L538.36 297.53V297.33L538.55 296.89V296.73L538.71 295.73L538.79 295.62L538.73 295.46L538.98 295.13L539.19 293.93L539.27 293.78L540.21 294L540.43 294.17L540.98 294.4H541.36V294.78L541.19 295V295.46L541.07 295.64L541.12 295.95L540.92 296.12L540.98 296.28L540.89 296.46L540.95 296.66L540.78 296.92V297.37L540.61 297.51L540.69 298.01L540.49 298.08V298.42L540.59 298.62L540.38 298.91L540.47 299.64L540.24 299.78L540.34 299.94L540.42 300.4L540.25 300.58L540.35 300.74L540.23 300.92L540.44 301.13L540.23 301.42L540.33 301.62V301.73L540.43 301.96V302.14L540.3 302.32L540.48 302.45V302.75L540.81 303.43L540.99 303.52V303.75L541.09 303.83H541.36L541.54 304.07L541.83 304.29L542.22 304.16L542.62 304.38L542.71 304.28L543.13 304.23L543.19 304.39L543.59 304.23V304.04L543.79 303.98L544 304.18L543.88 304.29L544.21 304.51L544.29 304.43L544.14 304.35L544.06 303.84L544.26 303.74L544.21 303.93L544.58 304.07L544.42 303.72L544.54 303.54L544.69 303.59L544.83 303.86L544.98 303.8L544.78 303.44H544.63L545.02 302.86L545.08 302.55L545.24 302.41V302.07L545.36 302L545.49 301.67L545.39 301.51L545.6 301.3V301.1L545.8 300.85V300.24L546 300.14H546.19L546.02 299.86V299.63L545.92 299.35L546.05 299.21L546.31 299.31L546.24 299.19H546.09V298.73L546.18 298.47L546.37 298.56L546.45 298.45L546.34 298.36H546.23L546.12 298.2V298.14H546.43L546.55 298.08L546.32 297.6L546.41 297.34H546.64L546.44 297.06L546.52 296.95L546.42 296.75L546.69 295.66V294.9L546.78 294.71V294.44L546.87 294.33V293.49L547.08 293.24L546.9 293V292.89L547.1 292.75L546.94 292.28V292.09L546.67 292.15V292.34L546.41 292.24L546.36 292.47L545.95 292.32L545.73 292.65L545.55 292.56L545.35 292.66L545.24 292.61L544.73 292.73L543.97 292.67L543.86 292.59L543.55 292.75L543.25 292.58L543.15 292.42H543V292.61H542.85L542.75 292.45H542.56L542.45 292.33H542.22V292.1H541.84L541.7 291.9L541.61 292.08H541.46L541.21 291.76H541.06L540.94 291.86L540.75 291.77L540.81 291.59L540.48 291.41L540.65 291.19L540.54 291.07L540.22 291.24L540.11 291.15L540.17 290.93L540.5 291.03L540.59 290.92H540.44V290.62L540.68 290.44L540.61 290.36L540.18 290.48L540.12 290.32L540.21 290.06L540.41 290L540.34 289.88L540.1 289.98L539.85 289.84L539.61 289.94L539.38 289.89L539.32 289.69L539.44 289.62H539.75L539.86 289.7L540.02 289.6H539.75L539.46 289.39L539.26 289.52L539.04 289.35L539.29 289.11L539.19 288.95L538.95 289.04L538.8 288.99V288.84L538.96 288.78L539.1 288.9L539.57 288.79L539.62 288.68L539.54 288.59H539.43L539.34 288.74H539.04L538.94 288.5H538.75L538.64 288.42L538.73 288.27L538.63 288L539.03 287.8L538.96 287.68L538.72 287.81L538.47 287.57L538.71 287.43L538.76 287.32L538.69 287.24L538.38 287.29V287.18L538.59 286.96L538.49 286.76L538.61 286.62L538.41 286.3L538.65 286.13V285.82L538.44 285.54L538.53 285.43H538.79L538.63 285.11L539.1 284.95L538.95 284.83L538.72 284.92L538.57 284.87L538.5 284.76L538.55 284.57H538.93L538.65 284.28V284.13L538.58 283.97L538.63 283.82L538.75 283.75L538.9 283.84H539.05L538.98 283.73L538.84 283.68V283.45L539.26 283.52L539.34 283.41L539.12 283.28V283.09L539.4 283.03L539.3 282.84V282.69L539.11 282.56V282.33L539.35 282.23H539.5L539.36 281.99L539.43 281.65L539.71 281.45V281.14L539.98 281.09L539.92 280.85L540.13 280.64L540.22 280.99L540.55 281.13L540.38 280.89V280.7L540.17 280.45L540.29 280.35H540.64L540.54 280.16L540.63 280.01H540.93L540.99 279.71L541.27 279.62V279.89L541.36 279.74L541.27 279.43L541.55 279.26L541.94 279.21V278.99H542.4L542.3 278.76L542.39 278.69H542.73L542.89 278.55H543.05L543.28 278.46H543.59L543.87 278.29L544.16 278.46L544.36 278.33L544.7 278.39V278.54L544.77 278.62V278.4L545 278.34H545.34L545.64 278.48L545.8 278.41L546.09 278.55H546.36L546.54 278.76H546.65L546.76 278.88H546.95L547.32 279.1L547.46 279.27L547.71 279.4L547.88 279.68L548.12 279.58V279.01L548.21 278.82V278.59L548.51 278.65L548.78 278.59L548.93 278.68L549.05 278.61L549.65 278.74H549.88L550.25 278.89L550.56 278.91ZM539.08 283.14H538.93H539.08ZM538.93 285.73L538.98 285.61H538.9L538.78 285.72L538.93 285.73ZM539.31 282.66L539.42 282.78L539.22 282.88L539.07 282.79V282.64L539.16 282.53H539.31V282.66ZM538.84 286.48V286.37L538.76 286.48H538.84ZM539.13 284.06V283.95L539.02 283.9L539 284.14L539.13 284.06ZM539.07 286.96L539.4 287.06L539.52 286.99L539.34 286.94L539.09 286.69V286.62H539L538.89 287L539.07 286.96ZM539.38 283.73H539.5L539.43 283.61H539.32L539.23 283.71L539.38 283.73ZM539.24 286.13L539.18 286.01L539.06 286.08L539.24 286.13ZM539.34 284.38L539.21 284.49L539.54 284.66L539.63 284.59L539.48 284.51L539.34 284.38ZM539.08 288.38L539.32 288.16H539.17L538.94 288.26L539.08 288.38ZM539.88 284.27L539.59 284.02L539.39 284.16H539.28V284.23L539.48 284.17L539.73 284.34L540 284.4L540.39 284.24L540.29 284.12L540.04 284.29L539.88 284.27ZM539.17 286.62H539.4L539.55 286.71V286.44L539.4 286.39L539.17 286.62ZM539.68 283.41H539.83L539.98 283.53L540.06 283.42H539.91L539.84 283.26H539.69L539.57 283.37L539.68 283.41ZM539.48 285.04L539.78 285.14V284.99L539.67 284.87H539.52L539.44 284.98L539.48 285.04ZM539.88 287.36L539.76 287.43L539.43 287.25H539.31V287.37L539.87 287.52H540.14V287.41L540.03 287.33L539.88 287.36ZM539.45 285.85L539.71 285.94L539.83 285.87L539.5 285.66L539.38 285.76L539.45 285.85ZM539.69 282.62L539.85 282.51L539.74 282.43L539.65 282.57L539.69 282.62ZM539.49 286.23H539.38V286.35L539.49 286.23ZM539.41 287.94L539.53 287.84H539.68V287.73H539.29L539.21 287.84L539.41 287.94ZM544.23 280.66L544.17 280.85H543.91V281.07L543.68 281.13L543.53 281.08L543.1 281.24L542.92 281.54H542.77L542.47 281.44V281.6L542.62 281.65V281.8L542.5 281.95L542.12 281.8L542.01 281.87L542.26 282.08V282.24L542.14 282.3L541.88 282.21L541.76 282.31L541.93 282.67L541.77 282.77L541.55 282.57H541.4L541.46 282.81L541.6 282.89V283.01L541.33 283.1L541.19 282.9L541.07 282.97L541.66 283.32L541.08 283.43L540.78 283.33L540.65 283.43L540.91 283.61L540.98 283.73L540.93 283.88L541.17 284.16V284.31L540.76 284.17L540.64 284.24L540.93 284.49L540.84 284.67H540.69L540.58 284.55L540.4 284.49L540.16 284.63L539.86 284.46L539.74 284.52L539.69 284.67H539.93L540.06 284.87V285.14L540.22 285.04L540.15 284.84L540.27 284.77L540.58 284.83L540.65 284.92L540.6 285.07L540.66 285.22L541 285.14L540.94 284.87L540.99 284.76H541.14L541.24 284.88L541.14 285.26L541.25 285.34H540.98L540.81 285.56L540.62 285.51L540.53 285.31V285.5L540.7 285.74V285.85L540.43 285.91L540.33 285.71L540.45 285.61V285.42H540.15L539.93 285.25L539.84 285.4V285.52L540.18 285.58L540.25 285.66L540.09 285.8L540.19 285.92L540.53 286.03L540.65 285.92L540.84 286.01L540.9 286.13L540.82 286.24H540.66L540.52 286.08L540.4 286.19V286.3L540.65 286.51L540.3 286.68V286.87L539.91 286.96L539.78 286.68L539.61 286.86L539.56 287.08H539.75L540.09 287.22L540.43 287.17V286.9L540.55 286.79H540.74L540.86 286.69L540.8 286.49L540.92 286.39L541.03 286.47V286.78L541.22 286.83L541.28 286.95L541.2 287.06L540.95 286.85L540.69 287.25L540.89 287.15L541.07 287.2L541.14 287.32L540.97 287.61L541.34 287.79L541 288.14L541.16 288.07L541.45 288.28L541.29 288.35L541.18 288.23H541.03L540.78 288.44L540.89 288.53L541.21 288.4L541.45 288.68L541.65 288.62V288.97L542.01 289.26L541.86 289.32L541.96 289.48L541.8 289.63H541.95L542.07 289.48L542.33 289.58V289.69L542.67 289.75L542.73 289.91H543L543.25 290.04L543.43 290.25L543.71 290.08L543.89 290.28L544.39 290.2L544.53 290.4L544.85 290.2L545.15 290.3L545.43 290.13H545.54L546.02 289.86L546.43 289.47L547.06 288.67V288.52L547.19 288.41L547.59 287.64L547.85 286.64V285.64L547.97 285.53L547.87 285.37L547.93 285.07L548.05 285.01L547.98 284.85L548.12 284.02L548.07 283.67L548.18 283.22L547.82 282.43L547.61 282.22V282.14L547.47 282.05L547.27 281.69L546.88 281.24V281.13L546.67 281L546.54 281.11L546.29 280.93L546.02 280.88L545.85 280.71L545.69 280.77L545.39 280.68H545.16L544.9 280.58L544.58 280.75L544.37 280.54L544.23 280.66ZM539.76 286.25L539.88 286.18L539.81 286.1H539.66L539.61 286.25H539.76ZM540.18 282.19L540.32 282.36V282.25L540.07 282.04L540 282.14L540.18 282.19ZM539.94 283.86L540.24 283.92L540.18 283.76L540.03 283.67H539.87L539.94 283.86ZM539.65 288.27L539.53 288.34L539.68 288.39L539.84 288.32L539.89 288.17H539.77L539.65 288.27ZM540.2 281.32V281.24L540.08 281.31L540.2 281.32ZM539.96 286.69H540.08V286.53H540L539.92 286.68L539.96 286.69ZM539.81 289.16H539.93V289.01L539.63 288.95L539.69 289.11L539.81 289.16ZM539.96 290.16L539.69 290.26L539.59 290.02L539.68 289.91L539.94 289.97L540.05 290.09L539.96 290.16ZM540.28 283.38H540.43V283.27H540.16L540.28 283.38ZM539.77 288.73H539.92H539.77ZM540.37 282.59L540.67 282.72V282.61L540.3 282.43L540.21 282.54L540.37 282.59ZM540.43 282.9L540.23 282.96L540.34 283.08L540.73 282.92L540.55 282.83L540.43 282.9ZM540.01 287.95L540.13 287.88H540.32L540.43 287.96V287.89L540.1 287.6L539.86 287.85L540.01 287.95ZM540.54 281.87V281.76H540.35L540.54 281.87ZM540.08 288.57L540 288.71L540.15 288.76L540.26 288.69L540.33 288.81L540.48 288.86L540.6 288.76H540.79L540.72 288.68H540.42L540.08 288.57ZM540.24 290.57L539.96 290.67L539.86 290.54L539.95 290.32L540.25 290.38L540.36 290.51L540.24 290.57ZM540.63 283.69L540.48 283.64V283.79L540.96 283.94V283.82H540.77L540.63 283.69ZM540.44 287.34L540.32 287.45H540.17V287.57H540.7L540.61 287.33L540.44 287.34ZM540.55 284.34L540.44 284.29V284.41L540.55 284.34ZM540.89 282.34H540.97V282.22L540.71 282.09V282.2L540.89 282.34ZM540.27 289.1H540.15L540.22 289.22L540.27 289.1ZM539.08 304.64V304.53H538.96L539.08 304.64ZM540.3 288.26L540.56 288.31L540.49 288.16H540.3V288.26ZM540.5 289.11L540.43 288.95H540.32V289.14L540.5 289.11ZM540.5 289.34L540.29 289.56H540.45L540.69 289.42L540.62 289.27L540.5 289.34ZM541.18 280.22L541.11 280.1V280.26L541.18 280.22ZM541.04 281.01L541.23 281.1V281.14L541.05 281.05L541.04 281.01ZM541.04 282.5H541V282.57L541.04 282.5ZM540.84 285.74L540.77 285.62L540.89 285.51L541 285.56V285.67L540.92 285.82L540.84 285.74ZM541.39 281.88L541.1 281.7L541.16 281.94H541.31L541.39 281.88ZM540.68 287.88L540.79 287.97L540.91 287.86L540.69 287.77L540.68 287.88ZM541.31 281.47H541.42V281.39H541.27L541.31 281.47ZM541.11 283.67L541.35 283.5L541.5 283.55V283.74L541.38 283.85L541.11 283.67ZM541.36 282.32L541.51 282.4L541.59 282.3L541.37 282.13H541.26V282.24L541.36 282.32ZM541.27 284.53H541.16V284.41L541.27 284.53ZM541.01 289.09H540.9L540.85 289.17L541.01 289.09ZM540.88 291.3L541 291.23H540.7L540.88 291.3ZM541.64 281.15H541.79L541.61 280.98L541.53 281.05L541.64 281.15ZM541.75 281.73L541.47 281.79L541.96 282.02L541.81 281.85L541.75 281.73ZM541.3 288.85L541.38 288.7L541.26 288.81L541.3 288.85ZM542.11 279.47H542.03V279.62L542.11 279.47ZM542 281.64L542.15 281.69L542.27 281.58L542.01 281.41L541.93 281.52L542 281.64ZM542.07 280.72L542.19 280.66H542.07V280.72ZM542.32 280.86L542.37 280.75L542.21 280.81L542.32 280.86ZM542.47 280.49L542.66 280.42L542.56 280.3H542.37L542.32 280.45L542.47 280.49ZM542.41 281.25H542.56L542.65 281.14L542.38 281.08L542.41 281.25ZM543 279.95L542.7 279.89V280.05L542.84 280.13L543 280.07V279.95ZM543 281.21V281.13L542.88 281.2L543 281.21ZM542.94 280.9V280.82V280.9ZM543.39 280.05H543.46V279.97H543.38L543.39 280.05ZM541.99 306.05V305.94L541.88 305.89L541.95 306.05H541.99ZM543.99 279.05L543.87 279.12L543.98 279.24L543.99 279.05ZM542.49 304.5V304.39H542.37L542.49 304.5ZM542.44 306.18L542.57 306.04V305.89H542.45L542.44 306.18ZM544.63 279.18H544.48V279.34L544.63 279.18ZM542.8 304.96L542.92 304.81L542.78 304.69L542.65 304.87L542.8 304.96ZM543.12 305.25H543V305.37H543.15L543.2 305.26L543.12 305.25ZM545.03 280.05H545.15L545.08 279.93H544.96L545.03 280.05ZM543.28 304.65L543.21 304.53V304.64L543.28 304.65ZM543.13 306.21V306.14V306.21ZM543.33 305.04H543.52V304.92H543.36L543.33 305.04ZM543.7 304.72H543.81L543.9 304.46L543.83 304.38L543.63 304.6L543.7 304.72ZM543.6 305.51H543.75V305.43L543.53 305.38L543.6 305.51ZM544.19 305.29L544.31 305.22L544.09 305.05L544 305.14L544.19 305.29ZM544.26 304.8L544.37 304.85V304.7L544.26 304.61L544.14 304.72L544.26 304.8ZM544.4 305.53H544.25V305.65H544.55H544.48L544.4 305.53ZM544.67 304.53H544.82V304.42L544.6 304.33L544.52 304.44L544.67 304.53ZM544.73 305.23L544.54 305.18L544.61 305.33L544.8 305.39L544.73 305.23ZM544.8 304.85L545.1 304.91L545.03 304.79H544.84L544.8 304.85ZM545.13 304V303.92H545V304H545.13ZM545.31 304.09H545.12L545.23 304.21L545.31 304.09ZM545.31 305.23L545.24 305.15L545.16 305.26L545.31 305.23ZM546.31 299.65L546.25 299.53V299.64L546.31 299.65ZM546.63 298.49L546.71 298.38H546.6L546.63 298.49ZM548.81 283.97V283.82H548.73V283.97L548.8 284.05L548.81 283.97ZM548.67 284.92V284.8L548.62 284.91L548.67 284.92ZM548 298.97H548.15V298.9H548V298.97Z",
                fill: "#FFD400"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M559.51 288.59H559.62V288.78L559.87 288.99L559.99 288.89L560.33 288.95L560.49 288.85L560.56 289H560.71L560.58 289.22V289.41L560.69 289.49L560.84 289.43V289.2H561.15V289.47L561.27 289.29L561.46 289.34L561.73 289.28L561.61 289.43L561.67 289.62H561.82L562.08 289.79L562.21 290V289.85L562.36 289.9L562.46 290.13L562.8 290.23L563 290.14V289.79H563.08L563.15 289.34L563.02 289.06L563.3 288.85L563.12 288.72L563.29 288.58L563.11 288.34V288.18L563.27 288.04V287.85L563.39 287.78L563.2 287.73V287.54L563.37 287.29L563.27 287.13L563.32 286.98L563.26 286.7L563.31 286.56L563.59 286.46L563.3 286.25L563.36 285.99L563.29 285.87L563.57 285.62L563.4 285.45L563.31 285.6L563.17 285.44V285.29L563.32 285.34L563.39 284.88L563.28 284.8L563.22 284.57L563.35 284.38L563.21 284.18L563 284.4L563.11 283.95L562.96 283.44L563.01 283.25L562.88 282.97V282.79L562.67 282.62L562.42 282.79L562.31 282.71V282.55L562.59 282.42L562.52 282.3L562.28 282.47H562.16V282.19L562.39 282.1L562.33 281.9L562.19 281.81V281.96L561.99 282.02V281.6L562.23 281.51L562.08 281.46L561.77 281.55L561.64 281.2L561.48 281.37L561.03 281.15L560.88 281.22H560.73L560.82 281.03V280.8H560.66V281.14H560.28L560 281.35L559.76 281.07V281.22L559.48 281.39L559.26 281.18L559.14 281.32L559.2 281.48L558.8 281.72L558.87 281.88V281.99L558.48 282.11L558.67 282.16V282.47H558.56L558.42 282.3L558.25 282.41L558.54 282.69L558.45 282.84L558.62 283.08V283.23L558.39 283.18L558.31 283.29L558.44 283.53L558.27 283.74L558.37 283.94L558.14 284.04L558.27 284.35L558.22 284.5L558.28 284.7L558.08 284.84L558.22 284.96V285.26L558.31 285.5L558.23 286.07L558.29 286.34L558.24 286.49L558.3 286.69L558.06 286.93H557.94L557.56 286.83H556.95L556.8 286.9L556.46 286.83L556.15 286.89L555.98 286.61L556.04 286.31L555.97 286.11L556.07 285.85L555.97 285.19L556.05 285.05L555.95 284.85L556.04 284.74L555.91 284.42L556.01 284.09V283.74L556.28 283.11L556.22 282.96L556.36 282.66L556.43 282.21L556.6 281.99L556.54 281.76L556.62 281.61L556.82 281.55L556.76 281.35L556.82 281.05L556.99 280.83L557.05 280.5L557.25 280.4V280.24L557.42 280.06L557.64 280.15V279.81L557.72 279.74H558.03L558.12 279.48L558.4 279.38L558.48 279.24H558.64L558.97 279.42L559.05 279.27L558.87 279.14L559.11 278.97L559.37 279.14L559.25 279.21L559.36 279.33L559.48 279.23V278.88L559.97 278.99V278.84H560.08L560.37 279.05L560.5 278.87L560.73 278.93L560.91 279.09H561.33L561.44 279.18L561.55 279.11L561.74 279.16L561.84 279.32L561.97 279.22H562.2L562.11 279.3V279.37L562.44 279.51L562.49 279.33L562.67 279.53L562.58 279.64L562.72 279.92H562.87L563.04 279.66V279.78L562.91 279.96L563.02 280.08L563.22 279.91L563.33 280.03V280.37H563.18L563.01 280.51H563.12L563.51 280.38V280.19L563.83 280.02L563.89 280.14V280.29L563.69 280.39L563.75 280.51H564.21V280.77L563.94 280.83V280.95L564.09 281L564.21 280.93L564.47 281.03V281.17L564.31 281.28V281.43L564.11 281.49L564.18 281.61L564.37 281.67L564.52 281.6H564.75L564.93 281.76L564.76 282.02L564.86 282.22L564.98 282.15L565.24 282.21L565.03 282.46L565.1 282.58H565.25L565.36 282.67L565.24 282.73H565.09L564.7 282.89H565.08L565.38 283.02L564.98 283.22L564.83 283.13L564.71 283.2L564.56 283.15L564.25 283.28L564.36 283.37L564.75 283.24L564.93 283.37H565.43V283.56L565.31 283.67L564.9 283.52V283.63L565.23 283.85L564.91 284.09L564.98 284.21H565.4L565.5 284.3L565.3 284.55L565.75 284.66L565.7 284.77L565.42 284.94L565.9 285.09L565.79 285.62L565.51 285.79H565.7L565.87 286L565.67 286.21L566.04 286.35L565.86 286.68L566.05 286.74L565.84 286.91L566.02 287.12V287.27L565.78 287.44L566.07 287.62L565.72 287.74L565.78 287.86H565.93L566 287.98L565.82 288.31L566.05 288.37V288.52L565.82 288.46L565.99 288.78V289.27H565.79L565.93 289.54L565.83 289.8L566.05 289.97L565.92 290.16L565.73 290.07H565.62L565.8 290.2L565.9 290.44L565.61 290.69L565.91 290.75V290.97L565.73 290.88L565.57 290.99L565.79 291.12L565.86 291.24L565.77 291.38L565.9 291.62V291.77L565.78 291.84L565.68 291.72L565.56 291.78L565.77 291.99V292.14L565.61 292.32L565.91 292.38L565.86 292.53L565.74 292.6L565.63 292.52H565.51L565.72 292.84L565.59 293.09L565.77 293.18V293.34L565.6 293.51V293.78L565.74 294.02L565.64 294.24V294.82L565.51 295.03L565.57 295.19L565.45 295.37L565.59 295.54L565.41 295.79L565.48 295.95L565.31 296.13L565.49 296.37L565.36 296.55L565.29 296.89L565.43 297.13L565.38 297.28L565.19 297.34V297.72L565.36 297.96L565.22 298.34L565.31 298.61L565.17 299.02V299.67L564.96 299.85L565.1 300.01V300.16L565.2 300.43L565 300.5L564.92 300.6L565.09 300.81V300.92L565.18 301.16L565.1 301.26H564.87V301.41L565.06 301.54L564.89 301.68L565.07 301.92L564.86 302.14L564.96 302.33L564.8 302.4L565.02 302.61V302.76L564.85 303.02L564.96 303.56L564.72 303.77L564.78 303.93V304.04L564.88 304.2L564.83 304.35L564.62 304.56V304.83L564.8 304.99V305.18L564.63 305.4V305.52L564.54 305.63L564.68 305.87L564.47 306.12V306.85L564.31 306.95L564.37 307.22L562 307.24L561.67 307.13H561.36L561.3 306.9V306.55L561.38 306.41V305.72L561.5 305.61L561.43 305.49V305.34L561.29 305.14V304.95L561.18 304.87L560.82 305.07H560.67L559.75 305.57H559.52L559.34 305.45L559.14 305.62H558.79L558.65 305.54L558.53 305.6L558.26 305.55L558.05 305.38L557.8 305.59L557.55 305.3L557.41 305.25L557.16 304.89L557.07 305.11L556.81 305.06L556.59 304.89H556.44L556.27 304.64H556V304.52L556.21 304.31L556.06 304.22L555.9 304.32L555.46 304.1L555.04 303.64V303.46L554.75 303.21V303.06L554.39 302.73L554.45 302.54L554.19 302.37V302.22L553.87 301.93L553.96 301.78L553.78 301.61V301.5L553.93 301.55L554.24 301.38V301.3L554.09 301.25L553.82 301.34L553.68 301.14L554 300.98L553.82 300.77L553.62 300.95L553.51 300.83V300.63L553.78 300.54L553.6 300.37V300.1L553.31 299.85V299.55L553.4 299.44L553.67 299.34L553.61 299.15L553.82 298.97H553.51L553.19 298.72L553.46 298.62L553.25 298.41V298.26L553.37 298.19H553.6L553.53 298.07L553.16 297.93V297.85H553.39L553.78 297.73H553.63L553.47 297.79L553.21 297.7V297.54L553.53 297.37L553.42 297.29H553.23V296.68L553.35 296.61L553.18 296.37L553.27 296.22L553.2 296.06L553.26 295.8L553.19 295.64L553.33 295.39V294.77L553.41 294.63V294.4L553.65 294.22L553.43 294.13L553.55 293.53L553.79 293.36V293.28L553.64 293.23H553.79L553.89 292.97L553.75 292.77L553.96 292.55V292.4L554.13 292.22L554.07 292.02L554.23 291.88V291.58L554.31 291.47L554.42 291.55H554.57L554.52 291.24L554.61 291.09H554.84L554.73 290.93L554.87 290.71H555.06L554.99 290.52H555.19V290.37L555.64 289.98L556.01 290.13L555.84 289.85V289.69L556.04 289.56L555.99 289.74L556.29 289.8L556.45 289.74V289.55L556.85 289.39L557.05 289.17H557.2V288.98H557.35L557.57 289.11L557.7 288.96L557.63 288.81H557.75L557.85 288.94H558.04L558.17 288.84L558.66 288.91L558.97 288.86L559.11 288.95H559.38L559.51 288.84H559.43L559.51 288.59ZM553.51 296.28H553.67V296.16H553.51L553.43 296.27L553.51 296.28ZM553.61 295.45V295.38L553.53 295.33V295.41L553.61 295.45ZM553.44 299.26L553.31 299.02L553.47 298.96L553.61 299.04L553.68 299.2L553.44 299.26ZM553.81 295.89L553.97 295.82H553.81V295.89ZM553.75 296.68H553.9L554.02 296.58H553.76L553.75 296.68ZM553.95 296.05L553.83 296.12V296.2H554L553.95 296.05ZM553.63 299.88L553.98 299.72L553.72 299.62L553.56 299.8L553.63 299.88ZM553.55 300.41V300.22L553.66 300.27L553.55 300.41ZM554.24 292.59H554.17V292.7L554.24 292.59ZM553.89 297.38L553.84 297.49H553.96L554.13 297.31H554L553.89 297.38ZM554.29 292.98V292.9L554.21 292.97L554.29 292.98ZM554.02 298.19H554.17L554 298.02L553.91 298.13L554.02 298.19ZM554.16 296.29H554.31L554.36 296.18H554.17L554.09 296.25L554.16 296.29ZM554.08 297.89H554.23L554.32 297.75L554.13 297.7L554.05 297.77L554.08 297.89ZM553.87 300.21L553.98 300.29L554.26 300.12H554.15L553.88 300.17L553.87 300.21ZM554.67 292.51H554.52L554.47 292.58L554.81 292.76L554.96 292.69L554.78 292.6L554.67 292.51ZM554.54 294.26V294.14H554.39V294.22L554.54 294.26ZM554.33 295.54V295.47H554.22L554.33 295.54ZM554.1 298.66V298.54V298.69V298.66ZM554.19 299.51L554.39 299.37L554.24 299.32L554.04 299.46L554.19 299.51ZM554.57 293.42H554.64L554.53 293.34L554.57 293.42ZM554.37 299.18L554.65 299.01L554.46 298.95L554.19 299.01V299.13L554.37 299.18ZM554.71 293.01L554.91 292.91H554.76L554.67 292.98L554.71 293.01ZM554.65 295.87H554.54V295.95L554.65 295.87ZM554.41 297.54L554.57 297.47H554.42L554.41 297.54ZM554.47 297.81L554.4 297.73L554.47 297.81ZM554.47 298.15H554.4L554.47 298.23V298.15ZM554.38 299.86L554.62 299.76H554.32V299.87L554.38 299.86ZM554.38 300.59L554.5 300.52L554.39 300.44L554.27 300.54L554.38 300.59ZM554.47 300.33L554.75 300.23L554.9 300.32V300.14H554.75L554.39 300.26L554.47 300.33ZM554.77 297.41V297.33L554.65 297.4L554.77 297.41ZM554.32 301.92L554.59 301.86L554.68 301.72H554.37L554.32 301.92ZM554.71 297.1L554.82 297.22L555.14 297.01L554.87 297.07L554.71 297.1ZM554.71 297.97L554.87 297.91L554.76 297.82L554.68 297.89L554.71 297.97ZM554.45 300.97L554.51 301.09L554.68 300.95L554.75 301.03V300.92L554.48 300.86L554.45 300.97ZM554.8 298.78L554.89 298.64L554.74 298.59L554.65 298.77L554.8 298.78ZM554.75 299.5L554.91 299.4H554.72L554.59 299.5H554.75ZM558.35 291.06L558.27 291.17H558.11L557.75 290.99V291.3L557.46 291.16L557.16 291.49L557.02 291.36L556.94 291.43L557.04 291.59L556.95 291.74L556.8 291.8L556.61 291.75L556.49 291.82L556.55 292.09V292.51L556.19 292.67L555.85 292.57L556.17 292.94L556 293.12L556.26 293.25V293.37L556.07 293.43L555.89 293.3L555.72 293.44L556.05 293.69L555.68 294.01L555.83 294.06L555.99 293.96L556.14 294.01V294.16L555.98 294.23H555.67V294.39L555.93 294.52L556 294.64H555.8L555.64 294.82H555.95V294.89L555.86 295H555.6L555.51 295.11L555.73 295.2L555.8 295.36L555.68 295.47L555.34 295.4L555.58 295.77L555.23 295.85L555.14 295.96V296.04L555.48 295.99L555.7 296.16L555.31 296.25L555.2 296.16H555.05L554.81 296.33L554.92 296.38L555.15 296.28H555.31L555.48 296.56L555.23 296.74H555L555.11 296.82L555.35 296.69L555.57 296.89L555.28 297.1L555.38 297.26L555.15 297.4L555.1 297.51H555.37L555.54 297.71L555.34 297.85H555.04L555.21 298.05H555.36L555.56 297.95L555.7 298.12L555.62 298.19L555.32 298.09L555.05 298.14L554.92 298.4L555.03 298.45V298.3H555.14L555.41 298.4L555.51 298.52L555.27 298.65H555.12V298.8L555.26 298.89L555.39 298.78H555.58V298.94L555.33 299.19L555.23 298.99L554.88 299.04L554.76 299.14L554.83 299.22H555.29L555.4 299.31H555.66L555.77 299.4L555.63 299.69L555.81 299.9L555.51 299.8V299.91L555.31 299.97H555.8L555.66 300.38L555.87 300.59L555.64 300.65L555.5 300.52L555.33 300.7H555.48L555.64 300.63L555.89 300.77L555.96 300.93H555.81L555.59 300.8V301.15L555.9 301.06H556.09L556.34 301.31L556.54 301.21L556.6 301.44L556.48 301.55V301.7H556.9V301.97L557.12 302.17V302.29L557.03 302.47L557.36 302.58L557.42 302.85L557.77 302.8L558.21 302.98L558.28 303.14L558.66 303.09L558.88 303.26L559.42 303.15L559.57 303.24L559.7 303.06L560.06 302.85L560.23 302.56L560.74 302.33V302.06L561.02 301.89V301.7L561.29 301.61L561.44 301.12L561.62 300.87L561.55 300.71L561.83 300.01V299.78L561.92 299.55V299.13L562.04 298.57V298.26L562.31 298.17V298.14L562.1 297.94L562.19 297.75V297.56L562.29 297.37L562.21 296.87L562.34 296.58V296.23L562.43 296.04V295.43L562.59 295.29L562.49 295.13L562.58 294.91L562.5 294.52L562.36 294.32L562.45 294.17V293.98L562.28 293.78L562.33 293.63L562.08 293.3L562.02 293.11L561.81 292.86L561.55 292.27L561.3 292.06L561.13 291.78L560.68 291.67L560.28 291.37L559.94 291.31L559.57 291.09L559.3 291.19L559.19 291.1L558.35 291.06ZM554.84 296.65H554.99V296.54H554.84V296.65ZM555.29 292.65H555.41L555.34 292.57L555.26 292.64L555.29 292.65ZM555.57 293.55H555.46V293.62L555.57 293.55ZM555.01 300.61L555.13 300.54H554.94L555.01 300.61ZM555.01 301.49L555.14 301.35L554.99 301.3L554.9 301.37L555.01 301.49ZM555.08 302.6H554.97L554.92 302.72L555.08 302.6ZM555.26 299.67L555.58 299.47H555.46L555.32 299.38L555.19 299.52L555.26 299.67ZM555.26 300.4L555.58 300.31L555.63 300.16L555.2 300.24V300.35L555.26 300.4ZM555.37 301.02V300.94H555.25L555.17 301.05L555.37 301.02ZM555.37 301.89L555.5 301.79H555.19V301.9L555.37 301.89ZM555.69 297.18H555.8L555.87 297.3L555.79 297.41L555.6 297.32L555.69 297.18ZM555.84 296.62L555.73 296.53H555.89L555.84 296.62ZM555.63 301.53L555.79 301.47L555.68 301.34L555.48 301.52L555.63 301.53ZM555.55 303.13L555.64 302.98H555.41L555.36 303.09L555.55 303.13ZM556.61 289.3H556.46L556.51 289.15L556.67 289.08L556.61 289.3ZM555.66 302.18H555.55V302.29L555.66 302.41L555.78 302.3L555.66 302.18ZM555.66 302.03L555.93 301.94L555.86 301.82H555.64L555.54 302.08L555.66 302.03ZM555.49 302.75H555.64L555.77 302.61H555.54L555.49 302.75ZM555.49 303.59L555.77 303.46H555.42L555.49 303.59ZM556.49 292.85H556.42V292.78L556.49 292.85ZM557.42 280.38L557.54 280.31H557.38L557.42 280.38ZM555.86 302.38L555.94 302.31L555.82 302.38H555.86ZM555.86 303.23L556.07 303.05L555.96 302.97H555.8L555.72 303.08V303.24L555.86 303.23ZM556.91 289.14H556.76V289.02H556.92L556.91 289.14ZM556.05 301.72L556.21 301.62L555.95 301.56L555.9 301.67L556.05 301.72ZM555.92 304.01L555.81 303.92L555.73 303.99L555.92 304.01ZM557.09 289.76V289.61H557V289.84L557.09 289.76ZM556.09 302.15H556.2L556.29 302.05L556.17 302L556.06 302.07L556.09 302.15ZM558 279.73L558.06 279.54H557.98L557.86 279.65L558 279.73ZM556.2 303.6V303.48H556.09V303.59L556.2 303.6ZM558 280.49H558.11V280.38L558.04 280.26H557.89V280.34L558 280.49ZM557.93 282.89L558.05 282.83L557.9 282.78L557.93 282.89ZM556.59 302.55L556.68 302.44L556.44 302.5L556.59 302.55ZM558.44 281.71L558.26 281.58V281.73L558.41 281.78L558.44 281.71ZM556.83 302.87L556.92 302.77H556.8L556.83 302.87ZM558.46 281.14L558.41 281.25L558.74 281.46L558.82 281.32L558.49 281.14H558.46ZM558.64 279.66L558.72 279.59H558.64V279.66ZM556.86 304.75V304.87H557L557.12 304.8L557.05 304.68L556.87 304.59L556.86 304.75ZM558.93 279.91H558.81V280.07L558.93 279.91ZM557.15 303.32V303.21L557.07 303.32H557.15ZM558.57 289.4L558.5 289.32V289.43L558.57 289.4ZM557.68 303.4L557.76 303.33H557.61L557.68 303.4ZM559.54 280.95V280.8H559.47V280.95H559.54ZM559.71 279.21L559.6 279.16V279.31L559.71 279.21ZM557.83 304.44L557.9 304.56H558.02V304.41L557.91 304.36L557.83 304.44ZM560.1 279.14L560.23 279.34L560.18 279.07L560.1 279.14ZM560.22 280.07L560.15 279.98V280.14L560.22 280.07ZM560.59 279.63L560.53 279.48H560.41V279.71L560.59 279.63ZM560.45 280.5V280.39H560.38V280.51L560.45 280.5ZM560.62 279.29V279.44H560.77L560.86 279.29L560.76 279.09L560.68 279.16L560.62 279.29ZM560.19 289.24V289.08L560 288.99V289.14L560.19 289.24ZM560.72 280.52V280.68L561.07 280.59V280.39L560.95 280.46L560.72 280.52ZM560.96 279.82L561.12 279.71L560.98 279.59V279.44L560.87 279.35L560.76 279.8L560.96 279.82ZM561.09 281.12L561.3 280.95L561.23 280.83H561.12L561.09 281.12ZM561.32 280.19H561.4H561.28H561.32ZM561.41 280.46V280.57L561.56 280.66L561.68 280.59L561.62 280.43V280.28H561.46L561.41 280.46ZM561.62 279.71L561.73 279.8V279.64L561.58 279.59L561.62 279.71ZM561.72 280.98V280.9H561.65L561.72 280.98ZM561.89 280.23L561.97 280.08H561.9V279.93L561.84 280.23H561.89ZM562.17 280.59V280.67H562.02L561.94 280.75L562.09 280.83L562.24 280.77L562.33 280.62H562.26L562.46 280.44L562.35 280.36L562.07 280.53L562.17 280.59ZM562.31 281.18L562.24 281.1V281.21L562.31 281.18ZM562.44 280.04V279.93L562.32 280.03L562.44 280.04ZM562.57 280.85L562.68 280.94V280.79H562.42L562.37 280.9L562.57 280.85ZM562.43 281.64H562.55L562.63 281.53L562.48 281.45L562.4 281.59L562.43 281.64ZM562.76 281.29L562.69 281.21H562.58L562.76 281.29ZM562.63 282.12L563.02 281.99V281.91L562.84 281.86L562.56 282.03L562.63 282.12ZM562.75 283.04L562.69 283.34L562.54 283.26V283.14L562.44 282.97L562.52 282.9H562.67L562.75 283.04ZM562.96 281.22L562.89 281.1V281.22H562.96ZM562.89 281.64L563.04 281.73L563.35 281.64L563.46 281.72L563.62 281.54L563.39 281.6L563.32 281.48L562.89 281.6V281.64ZM563.1 280.89L563.37 280.8V280.72L563.02 280.81L563.1 280.89ZM562.98 282.53L563.1 282.42L562.99 282.37V282.48L562.98 282.53ZM563.31 282.13L563.55 281.96L563.41 281.87L563.13 282.04L563.31 282.13ZM563.23 281.24V281.36L563.66 281.2V281.14H563.39L563.27 281.25L563.23 281.24ZM563.23 283.65L563.35 283.55H563.2L563.04 283.65H563.23ZM563.33 282.82L563.41 282.71H563.26L563.17 282.82H563.33ZM563.42 282.56L563.71 282.35L563.56 282.3L563.35 282.48L563.42 282.56ZM563.57 283.11L563.3 283.2V283.35L563.69 283.15L563.63 283.03L563.57 283.11ZM563.23 284.11L563.66 283.99L563.55 283.91L563.24 284L563.23 284.11ZM563.49 284.78V284.67H563.37L563.29 284.78V284.9L563.49 284.78ZM563.72 282.12L564.04 282.03V281.92L563.93 281.87L563.69 282.04L563.72 282.12ZM563.84 283.7L564 283.6L563.89 283.55L563.68 283.69L563.84 283.7ZM564.02 282.76V282.68H563.86L563.78 282.79L564.02 282.76ZM564.28 281.36L564.19 281.51H564.04L563.93 281.39L564.01 281.28H564.21L564.28 281.36ZM564.15 282.54L564.39 282.36L564.21 282.31L564.09 282.38L564.04 282.53L564.15 282.54ZM563.9 284.89L563.98 284.82H563.87L563.9 284.89ZM564.2 283.95H564.04V284.03L564.2 283.95ZM564.46 284.51H564.58V284.43H564.43L564.46 284.51ZM564.63 284.9L564.86 284.81L564.75 284.72L564.51 284.86L564.63 284.9ZM564.89 283.9H564.7L564.97 283.81L565.15 283.98L565.03 284.08L564.89 283.9ZM563.27 305.75L563.2 305.67L563.15 305.78L563.27 305.75ZM564.93 285.39L565.06 285.25L565 285.14L564.84 285.21V285.36L564.93 285.39ZM565.02 283.22L564.95 283.06L565.1 283.11L565.02 283.22ZM565.27 284.5L565.12 284.34H565.31L565.27 284.5ZM565.19 286.56V286.49L565.08 286.4L564.96 286.51L565.19 286.56ZM565.09 287.85L564.98 287.8V287.96L565.09 287.85ZM565.45 285.66V285.54H565.6L565.45 285.66Z",
                fill: "#FFD400"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M279.13 375.83H209.76V410.5H279.13V375.83Z",
                fill: "#0067A5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M279.13 361.39H209.76V379.17H279.13V361.39Z",
                fill: "#0067A5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M244.45 370.8H209.76V373.14H244.45V370.8Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M258.13 361.49H255.79V356H233.4V361.49H231.06V353.66H258.13V361.49Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M510.61 409.54H157.63V411.88H510.61V409.54Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M249.903 384.91L253.438 388.445L236.814 405.069C236.411 405.473 235.864 405.699 235.294 405.699C234.724 405.699 234.177 405.473 233.774 405.069L233.258 404.553C232.854 404.15 232.628 403.603 232.628 403.033C232.628 402.463 232.854 401.916 233.258 401.513L249.882 384.889L249.903 384.91Z",
                fill: "#FFD400"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M259.83 382.26L255.66 386.43L251.94 382.71L256.11 378.54C254.858 378.125 253.502 378.145 252.263 378.596C251.023 379.047 249.972 379.904 249.28 381.027C248.587 382.149 248.294 383.473 248.447 384.783C248.6 386.093 249.191 387.314 250.124 388.246C251.056 389.179 252.277 389.77 253.587 389.923C254.897 390.076 256.221 389.783 257.343 389.09C258.466 388.398 259.322 387.347 259.774 386.107C260.225 384.868 260.245 383.512 259.83 382.26Z",
                fill: "#FFD400"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M234.15 385.33L234.39 382.17L229.49 381.79L229.62 380.56L234.56 378.85C234.956 378.712 235.378 378.665 235.794 378.713C236.211 378.76 236.611 378.9 236.966 379.123C237.321 379.345 237.622 379.645 237.846 379.999C238.07 380.354 238.211 380.754 238.26 381.17L238.73 385.06L254.73 398.95C255.131 399.298 255.456 399.725 255.686 400.205C255.915 400.684 256.043 401.205 256.061 401.736C256.08 402.267 255.989 402.797 255.795 403.291C255.6 403.785 255.306 404.234 254.93 404.61C254.55 404.993 254.093 405.291 253.59 405.487C253.087 405.682 252.549 405.77 252.01 405.745C251.471 405.719 250.943 405.581 250.461 405.339C249.979 405.097 249.552 404.757 249.21 404.34L237 389.51H235C234.215 389.508 233.453 389.248 232.83 388.77L229.11 385.91L229.21 384.91L234.15 385.33Z",
                fill: "#FFD400"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-illustrations-virtual-f4c8d3dc38/1/packages/lib-illustrations/src/kaupa.tsx
/* eslint-disable max-len */ 

const KaupaIllustration = (param)=>{
    let { size =200  } = param;
    return /*#__PURE__*/ _jsxs("svg", {
        fill: "none",
        height: size,
        viewBox: "0 0 663 611",
        width: size,
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M532.9 443.31C532.9 443.31 496.09 398.15 423.44 408.31C350.79 418.47 311.81 373.48 281.49 318.39C251.17 263.3 154.13 362.5 154.13 362.5C154.13 362.5 168.46 413.36 112.44 453.04C56.4201 492.72 82.7701 528.61 82.7701 528.61H473.9L532.9 443.31Z",
                fill: "#D9EEE8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M154.13 362.5C154.13 362.5 147.6 331.5 117.71 343.34C87.8201 355.18 55.5301 317.77 79.2901 290.51C103.05 263.25 134.4 275.2 149.5 281.77C164.6 288.34 180.01 262.51 152.61 227.52C125.21 192.53 177.81 135.71 229.28 197.16C280.75 258.61 281.44 318.35 281.44 318.35L154.13 362.5Z",
                fill: "#D9EEE8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M349.37 550.14C313.15 526.59 283.04 490.42 262.31 445.55C245.7 409.6 235.64 369 234.71 334.18C233.23 278.43 208.21 242.18 187.47 221.6C165.01 199.29 142.67 190.06 142.47 189.97L143.36 187.79C143.59 187.88 166.36 197.29 189.16 219.93C210.16 240.82 235.59 277.59 237.1 334.12C238.02 368.63 248 408.89 264.48 444.56C285.02 489.03 314.83 524.86 350.68 548.16L349.37 550.14Z",
                fill: "white"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M135.17 538.71L133.65 536.91C224.85 459.73 213.08 382.36 194.12 352.24C172.46 317.84 137.06 310.31 111.18 310.04C93.6174 309.968 76.1485 312.605 59.3901 317.86L58.6201 315.63C75.6183 310.33 93.325 307.653 111.13 307.69C137.63 307.95 173.87 315.69 196.13 350.99C215.45 381.71 227.61 460.48 135.17 538.71Z",
                fill: "white"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M105.998 264.576L103.769 265.354L118.459 307.465L120.687 306.688L105.998 264.576Z",
                fill: "white"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M190.08 220.34L187.83 219.65C196.46 191.49 187.56 164.82 187.46 164.55L189.69 163.79C189.79 164.07 198.9 191.46 190.08 220.34Z",
                fill: "white"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M134.497 395.218L133.071 397.086L200.266 448.387L201.692 446.519L134.497 395.218Z",
                fill: "white"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M175.565 428.134L142.188 452.082L143.564 454L176.941 430.051L175.565 428.134Z",
                fill: "white"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M408.77 545.7L407.16 544C467.16 488.32 479.5 401.5 479.62 400.63L481.95 400.95C481.83 401.8 469.39 489.43 408.77 545.7Z",
                fill: "white"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M430.643 395.516L428.588 396.678L463.69 458.796L465.745 457.635L430.643 395.516Z",
                fill: "white"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M537.44 299.68C574.206 299.68 604.01 269.876 604.01 233.11C604.01 196.344 574.206 166.54 537.44 166.54C500.675 166.54 470.87 196.344 470.87 233.11C470.87 269.876 500.675 299.68 537.44 299.68Z",
                fill: "#D9EEE8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M548.96 223.95L541.57 225.83L540.79 218.24L554.32 198.88L562.49 204.58L548.96 223.95Z",
                fill: "#408DBC"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M568.06 209.21C569.64 206.555 570.158 203.4 569.508 200.38C568.859 197.359 567.092 194.695 564.561 192.923C562.03 191.151 558.922 190.402 555.861 190.827C552.801 191.251 550.014 192.817 548.06 195.21L568.06 209.21Z",
                fill: "#408DBC"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M563.371 192.486L560.291 196.896L562.218 198.242L565.298 193.831L563.371 192.486Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M550.225 199.839L548.879 201.766L561.527 210.603L562.873 208.676L550.225 199.839Z",
                fill: "#408DBC"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M547.559 203.53L546.214 205.457L558.864 214.292L560.209 212.365L547.559 203.53Z",
                fill: "#408DBC"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M544.982 207.34L543.636 209.266L556.285 218.103L557.63 216.177L544.982 207.34Z",
                fill: "#408DBC"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M542.328 211.031L540.982 212.957L553.632 221.792L554.978 219.866L542.328 211.031Z",
                fill: "#408DBC"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M559.51 266.37L552.08 268.07L551.48 260.47L567.87 238.61L575.9 244.51L559.51 266.37Z",
                fill: "#408DBC"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M581.36 249.28C583.001 246.662 583.592 243.521 583.013 240.485C582.434 237.45 580.729 234.747 578.239 232.917C575.75 231.086 572.661 230.266 569.591 230.619C566.522 230.972 563.699 232.473 561.69 234.82L581.36 249.28Z",
                fill: "#408DBC"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M576.885 229.638L573.711 233.996L575.614 235.383L578.789 231.025L576.885 229.638Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M564.949 238.321L562.836 239.373L570.817 255.407L572.929 254.355L564.949 238.321Z",
                fill: "#D9EEE8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M561.293 242.216L559.18 243.267L567.16 259.301L569.273 258.25L561.293 242.216Z",
                fill: "#D9EEE8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M557.651 246.127L555.538 247.179L563.518 263.212L565.631 262.161L557.651 246.127Z",
                fill: "#D9EEE8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M554.004 250.112L551.891 251.163L559.871 267.197L561.984 266.146L554.004 250.112Z",
                fill: "#D9EEE8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M500.83 242.36H492.54L488.39 249.55L492.54 256.73H500.83L504.98 249.55L500.83 242.36Z",
                fill: "#408DBC"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M496.69 253.43C498.833 253.43 500.57 251.693 500.57 249.55C500.57 247.407 498.833 245.67 496.69 245.67C494.547 245.67 492.81 247.407 492.81 249.55C492.81 251.693 494.547 253.43 496.69 253.43Z",
                fill: "#D9EEE8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M534.33 249.31H524.23L519.19 258.05L524.23 266.79H534.33L539.37 258.05L534.33 249.31Z",
                fill: "#408DBC"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M529.28 262.77C531.887 262.77 534 260.657 534 258.05C534 255.443 531.887 253.33 529.28 253.33C526.673 253.33 524.56 255.443 524.56 258.05C524.56 260.657 526.673 262.77 529.28 262.77Z",
                fill: "#D9EEE8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M524.95 220.51H513.64L507.99 230.3L513.64 240.09H524.95L530.6 230.3L524.95 220.51Z",
                fill: "#408DBC"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M519.3 235.58C522.216 235.58 524.58 233.216 524.58 230.3C524.58 227.384 522.216 225.02 519.3 225.02C516.384 225.02 514.02 227.384 514.02 230.3C514.02 233.216 516.384 235.58 519.3 235.58Z",
                fill: "#D9EEE8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M441.04 76.2H368.97C364.342 76.2 360.59 79.9519 360.59 84.58V87.55C360.59 92.1782 364.342 95.93 368.97 95.93H441.04C445.668 95.93 449.42 92.1782 449.42 87.55V84.58C449.42 79.9519 445.668 76.2 441.04 76.2Z",
                fill: "#FF9D57"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M461.78 90.24C460.431 90.242 459.111 89.8437 457.988 89.0955C456.866 88.3473 455.99 87.2829 455.472 86.0369C454.954 84.7908 454.818 83.4193 455.08 82.0957C455.342 80.772 455.991 79.5559 456.944 78.6011C457.898 77.6463 459.113 76.9958 460.436 76.7318C461.759 76.4679 463.131 76.6023 464.378 77.1182C465.625 77.6341 466.69 78.5082 467.44 79.63C468.19 80.7518 468.59 82.0707 468.59 83.42C468.588 85.2263 467.869 86.9579 466.593 88.2361C465.317 89.5142 463.586 90.2347 461.78 90.24ZM461.78 78.96C460.898 78.96 460.036 79.2216 459.302 79.7117C458.569 80.2017 457.997 80.8983 457.66 81.7133C457.322 82.5282 457.234 83.425 457.406 84.2901C457.578 85.1553 458.003 85.95 458.626 86.5737C459.25 87.1975 460.045 87.6222 460.91 87.7943C461.775 87.9664 462.672 87.8781 463.487 87.5405C464.302 87.203 464.998 86.6313 465.488 85.8979C465.979 85.1644 466.24 84.3021 466.24 83.42C466.23 82.2441 465.755 81.1199 464.92 80.2922C464.084 79.4644 462.956 79 461.78 79V78.96Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M466.782 86.1179L465.315 87.9667L473.18 94.2071L474.647 92.3584L466.782 86.1179Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M376.01 88.82C377.65 88.82 378.98 87.4903 378.98 85.85C378.98 84.2097 377.65 82.88 376.01 82.88C374.37 82.88 373.04 84.2097 373.04 85.85C373.04 87.4903 374.37 88.82 376.01 88.82Z",
                fill: "#FFD400"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M386.32 88.82C387.96 88.82 389.29 87.4903 389.29 85.85C389.29 84.2097 387.96 82.88 386.32 82.88C384.68 82.88 383.35 84.2097 383.35 85.85C383.35 87.4903 384.68 88.82 386.32 88.82Z",
                fill: "#FFD400"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M396.64 88.82C398.28 88.82 399.61 87.4903 399.61 85.85C399.61 84.2097 398.28 82.88 396.64 82.88C395 82.88 393.67 84.2097 393.67 85.85C393.67 87.4903 395 88.82 396.64 88.82Z",
                fill: "#FFD400"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M282.96 208.82C294.09 206.16 309.35 214.15 311.77 215.82C314.19 217.49 311.77 220.91 308.38 221.39C312.75 225.27 313.97 230.6 312.75 233.5C311.53 236.4 305.75 236.41 302.33 234.95C302.33 234.95 300.63 244.16 304.51 249.24C308.39 254.32 322.18 256.75 322.18 256.75C322.18 256.75 316.61 267.4 299.18 267.4C281.75 267.4 277.9 256.28 277.9 256.28L294.34 235L282.96 208.82Z",
                fill: "#FDC498"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M401.9 200.6C401.9 200.6 397.62 210.23 400.14 218.36C402.66 226.49 407.96 218.36 407.96 218.36L401.9 200.6Z",
                fill: "#FDC498"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M492.5 127.87H414.98C408.148 127.87 402.61 133.408 402.61 140.24V204.81C402.61 211.642 408.148 217.18 414.98 217.18H492.5C499.332 217.18 504.87 211.642 504.87 204.81V140.24C504.87 133.408 499.332 127.87 492.5 127.87Z",
                fill: "#408DBC"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M274.65 299.72L282.17 252.06C282.605 249.322 284.002 246.828 286.109 245.027C288.217 243.225 290.898 242.234 293.67 242.23H358.99L400.15 218.36L411.5 202.48C411.5 202.48 420.58 208.69 415.95 216.54C408.47 229.19 383.57 256.61 358.23 261.54C332.89 266.47 313.6 278.18 309.44 299.74L274.65 299.72Z",
                fill: "#FDC498"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M434 151.91H412.78V154.27H434V151.91Z",
                fill: "white"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M436.65 146.46H442.74V159.06H436.65C435.231 159.06 433.87 158.496 432.867 157.493C431.864 156.49 431.3 155.129 431.3 153.71V151.81C431.3 150.391 431.864 149.03 432.867 148.027C433.87 147.024 435.231 146.46 436.65 146.46Z",
                fill: "#A8CBE1"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M470.65 189.88H479.05V194C479.05 194.947 478.674 195.855 478.005 196.524C477.335 197.194 476.427 197.57 475.48 197.57H474.21C473.263 197.57 472.355 197.194 471.686 196.524C471.016 195.855 470.64 194.947 470.64 194V189.91L470.65 189.88Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M461.97 175.82H460.18C458.854 175.82 457.582 175.293 456.645 174.356C455.707 173.418 455.18 172.146 455.18 170.82V159.06H457.53V170.8C457.533 171.507 457.815 172.185 458.315 172.685C458.815 173.185 459.493 173.467 460.2 173.47H461.99L461.97 175.82Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M487.94 142.81H443.95C441.907 142.81 440.25 144.467 440.25 146.51V159.67C440.25 161.713 441.907 163.37 443.95 163.37H487.94C489.984 163.37 491.64 161.713 491.64 159.67V146.51C491.64 144.467 489.984 142.81 487.94 142.81Z",
                fill: "#FFD400"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M465.12 159.06H484.19V188.69C484.19 190.066 483.643 191.387 482.67 192.36C481.697 193.333 480.377 193.88 479 193.88H470.31C468.934 193.88 467.614 193.333 466.64 192.36C465.667 191.387 465.12 190.066 465.12 188.69V159.06Z",
                fill: "#FFD400"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M457.52 147.51H455.16V153.09H457.52V147.51Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M463.15 147.51H460.79V153.09H463.15V147.51Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M468.79 147.51H466.43V153.09H468.79V147.51Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M441.43 152.76H439.07V147.44C439.073 145.9 439.686 144.424 440.775 143.335C441.864 142.246 443.34 141.633 444.88 141.63H456.33V144H444.9C443.986 144.003 443.11 144.367 442.464 145.013C441.817 145.66 441.453 146.536 441.45 147.45L441.43 152.76Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M464.77 206.45C462.05 206.382 459.382 205.695 456.967 204.442C454.551 203.19 452.453 201.404 450.83 199.22C446.07 193.22 440.03 190.49 434.28 191.82C428.53 193.15 424.07 198.34 422.48 205.65L420.18 205.15C421.97 196.92 427.04 191.08 433.75 189.53C440.46 187.98 447.33 190.98 452.68 197.76C457.31 203.62 463.68 204.94 467.95 203.65C469.54 203.214 470.952 202.287 471.985 201.001C473.017 199.716 473.618 198.137 473.7 196.49L476.05 196.68C475.926 198.798 475.144 200.824 473.814 202.476C472.484 204.129 470.672 205.326 468.63 205.9C467.378 206.274 466.077 206.459 464.77 206.45Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M289.72 243.46C295.96 242.3 314.81 239.69 358.99 242.23L376.91 254.23C376.91 254.23 369.71 261.52 346.91 265.62C324.11 269.72 309.6 290.54 309.4 299.76H274.65L279.5 262.47L289.72 243.46Z",
                fill: "#40A88D"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M235.64 487.58L268 499.92L266.13 504.41C264.57 508.17 266.13 514.08 269 516.82L269.46 517.26C271.48 519.164 273.94 520.538 276.62 521.26C285.07 523.62 285.14 528.65 285.14 528.65H265.61L226.36 500.6L235.64 487.58Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M406.42 528.61C406.42 528.61 399.12 520.98 385 516.82C370.88 512.66 342.51 512.66 342.51 512.66V528.66L406.42 528.61Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M309.44 299.72L385 516.82H322.18C322.18 516.82 335.56 466.41 301.12 408.27C303.73 436.79 293.56 473.7 272.38 506.98L227.75 491.1C227.75 491.1 222.28 473.71 246.66 457.85C269.96 442.69 266.98 421.23 264.06 408.27C250.74 349.16 262.55 327.71 274.65 299.72H309.44Z",
                fill: "#FFD400"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M272.34 255.96L266.5 318.92L280.3 319.3L287.57 243.73L272.34 255.96Z",
                fill: "#FFD400"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M277.87 267.42H310.71L306.11 307.06H274.65L277.87 267.42Z",
                fill: "#FFD400"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M294.34 235C294.34 235 274.23 230.32 276.2 214.81C277.42 205.22 293.67 208.88 293.67 208.88V217.32C288.29 215.15 285.97 222.62 293.67 225.55L294.34 235Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M360.32 518H320.77L321.03 516.6C328.1 478.54 320.68 440.3 300.14 408.92C271.07 368.57 274.57 342.25 274.73 341.15L277.06 341.49C277.06 341.76 273.6 368.06 302.06 407.58C322.71 439.14 330.32 477.44 323.57 515.64H360.3L360.32 518Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M454.84 526.2H180.2V528.56H454.84V526.2Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M300.09 218.44C300.935 218.44 301.62 217.755 301.62 216.91C301.62 216.065 300.935 215.38 300.09 215.38C299.245 215.38 298.56 216.065 298.56 216.91C298.56 217.755 299.245 218.44 300.09 218.44Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M293.64 229.9C293.64 229.9 282.73 224.69 275.94 230.25C269.15 235.81 279.38 248.93 260.29 254.6C241.2 260.27 240.73 284.24 240.73 284.24L284.58 283.15C284.58 283.15 276.67 275.01 288.18 268.28C299.69 261.55 297.56 248.37 293.82 244.34C290.08 240.31 294.3 235.55 294.3 235.55L293.64 229.9Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M253.03 262.47L252.17 260.27C261.71 256.57 262.04 251.12 262.41 244.82C262.72 239.68 263.07 233.82 269.55 229.67C282.49 221.33 290.61 232.15 290.69 232.26L288.79 233.65C288.51 233.28 281.87 224.52 270.79 231.65C265.31 235.18 265.02 239.93 264.72 244.96C264.39 251.18 263.97 258.22 253.03 262.47Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M290.52 281.8C290.33 281.8 285.65 280.69 283.86 276.47C282.42 273.08 283.3 268.78 286.46 263.67L288.46 264.91C285.73 269.32 284.91 272.91 286.02 275.53C287.32 278.63 291.02 279.53 291.02 279.53L290.52 281.8Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M276.4 233.84L302.64 200.6C301.438 199.873 300.009 199.622 298.631 199.893C297.253 200.165 296.026 200.941 295.19 202.07L275.83 226.35L276.4 233.84Z",
                fill: "#FFD400"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M276.4 233.84C276.4 233.84 262.46 221.84 270.46 208.17C277.87 195.46 293.23 200.71 297.32 204.17L280.38 229.25L276.4 233.84Z",
                fill: "#FFD400"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M322.18 241.16C322.18 241.16 315.23 295.32 314.78 349.47C285.24 339.97 301.62 311.47 301.62 311.47C302.22 288.022 304.702 264.661 309.04 241.61L322.18 241.16Z",
                fill: "#FFD400"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M319.91 330.01H258.43L261.17 318.92H319.91V330.01Z",
                fill: "#40A88D"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M260.94 324.75L258.65 324.18L260.25 317.74H319.91V320.1H262.09L260.94 324.75Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M319.92 328.83H258.43V331.19H319.92V328.83Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M292.7 360.43H295.68V340.68H292.7V360.43Z",
                fill: "white"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M291.48 368.06H296.9V357.95H291.48V368.06Z",
                fill: "white"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M307.58 347.36V353.88H306.35L304.42 351.7H302.32C301.949 351.7 301.593 351.848 301.33 352.11C301.068 352.373 300.92 352.729 300.92 353.1V358.27C300.92 358.641 301.068 358.997 301.33 359.26C301.593 359.523 301.949 359.67 302.32 359.67H304.25L306.18 357.8H307.58V359.67C307.58 359.67 318.21 360.83 320.47 353.35C320.513 353.204 320.508 353.049 320.458 352.905C320.408 352.762 320.314 352.638 320.19 352.55C320.059 352.444 319.894 352.386 319.725 352.386C319.556 352.386 319.392 352.444 319.26 352.55C318.07 353.6 314.7 356.23 312.91 353.9C311.82 352.48 312 347.33 312 347.33L307.58 347.36Z",
                fill: "white"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M312.03 339.45H307.58V348.62H312.03V339.45Z",
                fill: "white"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M314.51 340.69H305.09V310.69C305.09 309.629 305.512 308.612 306.262 307.862C307.012 307.111 308.029 306.69 309.09 306.69H310.51C311.571 306.69 312.588 307.111 313.339 307.862C314.089 308.612 314.51 309.629 314.51 310.69V340.69Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M298.9 340.69H289.48V310.69C289.48 309.629 289.902 308.612 290.652 307.862C291.402 307.111 292.419 306.69 293.48 306.69H294.9C295.961 306.69 296.978 307.111 297.729 307.862C298.479 308.612 298.9 309.629 298.9 310.69V340.69Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M295.37 364.1H293.01V368.06H295.37V364.1Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M228.154 489.973L227.362 492.197L271.99 508.079L272.782 505.856L228.154 489.973Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M383.27 228.15L390.73 244.53C390.73 244.53 378.09 260.09 342.37 266.65C337.83 255.14 358.99 242.23 358.99 242.23L383.27 228.15Z",
                fill: "#40A88D"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M295.97 201.92L290.5 198.52L287.01 204.24L292.24 205.98L295.97 201.92Z",
                fill: "#FFD400"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M273.9 226.75C273.13 219.75 274.46 214 277.85 209.75C280.826 206.181 285.006 203.826 289.6 203.13L289.85 205.48L289.73 204.31L289.85 205.48C289.21 205.55 274.16 207.48 276.24 226.48L273.9 226.75Z",
                fill: "#FF7D20"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M490.3 218.36H428.9V216H490.3C493.852 215.997 497.257 214.586 499.769 212.076C502.281 209.566 503.695 206.161 503.7 202.61V142.44C503.695 138.889 502.281 135.484 499.769 132.974C497.257 130.464 493.852 129.053 490.3 129.05H417.18C413.631 129.055 410.228 130.468 407.718 132.978C405.208 135.488 403.795 138.89 403.79 142.44V178.71H401.44V142.44C401.445 138.267 403.105 134.267 406.056 131.316C409.007 128.365 413.007 126.705 417.18 126.7H490.3C494.475 126.703 498.478 128.362 501.431 131.312C504.383 134.263 506.045 138.265 506.05 142.44V202.61C506.045 206.786 504.384 210.789 501.431 213.741C498.479 216.694 494.476 218.355 490.3 218.36Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M527.98 279.13H413.51C407.523 279.13 402.67 283.983 402.67 289.97V349.64C402.67 355.627 407.523 360.48 413.51 360.48H527.98C533.967 360.48 538.82 355.627 538.82 349.64V289.97C538.82 283.983 533.967 279.13 527.98 279.13Z",
                fill: "#F09D61"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M527.97 279.13H514.64L452.59 360.48H527.97C530.845 360.48 533.602 359.338 535.635 357.305C537.668 355.272 538.81 352.515 538.81 349.64V290C538.814 288.574 538.537 287.161 537.994 285.843C537.451 284.524 536.653 283.325 535.646 282.316C534.639 281.306 533.443 280.505 532.125 279.958C530.808 279.411 529.396 279.13 527.97 279.13Z",
                fill: "#EB7C2D"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M516.19 312.09C522.425 312.09 527.48 307.035 527.48 300.8C527.48 294.565 522.425 289.51 516.19 289.51C509.955 289.51 504.9 294.565 504.9 300.8C504.9 307.035 509.955 312.09 516.19 312.09Z",
                fill: "#F6D330"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M444.21 341.62H415.03V349.11H444.21V341.62Z",
                fill: "#00416A"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M425.89 331.03H415.03V338.52H425.89V331.03Z",
                fill: "#00416A"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M451.61 331.03H433.34V338.52H451.61V331.03Z",
                fill: "#00416A"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M478.26 331.03H459.99V338.52H478.26V331.03Z",
                fill: "#00416A"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M491.86 331.03H486.63V338.52H491.86V331.03Z",
                fill: "#00416A"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M480.79 341.62H451.61V349.11H480.79V341.62Z",
                fill: "#00416A"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M434.2 322.63H422.14C419.942 322.627 417.835 321.753 416.281 320.199C414.727 318.645 413.853 316.538 413.85 314.34V313.05C413.853 310.852 414.727 308.745 416.281 307.191C417.835 305.637 419.942 304.763 422.14 304.76H434.2C436.398 304.763 438.505 305.637 440.059 307.191C441.613 308.745 442.487 310.852 442.49 313.05V314.34C442.487 316.538 441.613 318.645 440.059 320.199C438.505 321.753 436.398 322.627 434.2 322.63ZM422.14 307.12C420.566 307.12 419.057 307.744 417.943 308.856C416.83 309.968 416.203 311.476 416.2 313.05V314.34C416.203 315.914 416.83 317.422 417.943 318.534C419.057 319.646 420.566 320.27 422.14 320.27H434.2C435.769 320.254 437.269 319.625 438.38 318.517C439.49 317.408 440.122 315.909 440.14 314.34V313.05C440.122 311.481 439.49 309.982 438.38 308.874C437.269 307.765 435.769 307.136 434.2 307.12H422.14Z",
                fill: "#00416A"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M346.76 198.57C368.581 198.57 386.27 180.881 386.27 159.06C386.27 137.239 368.581 119.55 346.76 119.55C324.939 119.55 307.25 137.239 307.25 159.06C307.25 180.881 324.939 198.57 346.76 198.57Z",
                fill: "#D9EEE8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M283.43 175.74H281.07V167.31H362.44V169.66H283.43V175.74Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M364.61 172.11H326.26V153.68C326.26 149.93 327.75 146.333 330.402 143.682C333.053 141.03 336.65 139.54 340.4 139.54H350.47C354.22 139.54 357.817 141.03 360.469 143.682C363.12 146.333 364.61 149.93 364.61 153.68V172.11Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M345.66 165.28C350.327 165.28 354.11 161.497 354.11 156.83C354.11 152.163 350.327 148.38 345.66 148.38C340.993 148.38 337.21 152.163 337.21 156.83C337.21 161.497 340.993 165.28 345.66 165.28Z",
                fill: "#408DBC"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-illustrations-virtual-f4c8d3dc38/1/packages/lib-illustrations/src/pipulagnir.tsx
/* eslint-disable max-len */ 

const PipulagnirIllustration = (param)=>{
    let { size =200  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        fill: "none",
        height: size,
        viewBox: "0 0 662 611",
        width: size,
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M365.43 331.01L358.78 325.4C358.78 325.4 354.21 331.84 356.91 337.45C359.61 343.06 370.66 353.45 387.37 350.76C404.08 348.07 391.61 341.19 391.61 341.19L381.01 332.43L365.43 331.01Z",
                fill: "#F4B587"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M387.37 335.28C387.37 335.28 424.24 345.6 467.05 314.84L483.34 347.72C483.34 347.72 445.21 379.54 387.34 350.72L387.37 335.28Z",
                fill: "#D9E8F2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M437.87 363.78C410.87 363.78 387.04 352.24 386.72 352.08L385.82 351.64L386.9 338.18L389.84 338.42L388.92 349.85C395.31 352.76 434.34 369.28 466.74 355.29L467.91 358C458.397 361.958 448.173 363.926 437.87 363.78Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M345.1 360.42H247.35C237.039 360.409 227.153 356.309 219.862 349.018C212.571 341.727 208.471 331.841 208.46 321.53V271.63H227.65V321.53C227.658 326.752 229.736 331.758 233.429 335.451C237.122 339.144 242.128 341.222 247.35 341.23H345.1C350.321 341.222 355.327 339.144 359.018 335.451C362.709 331.758 364.785 326.751 364.79 321.53V224.89C364.803 215.301 368.618 206.109 375.399 199.329C382.179 192.548 391.371 188.733 400.96 188.72H445.6C450.109 188.72 454.433 186.929 457.621 183.741C460.809 180.553 462.6 176.229 462.6 171.72V104.72H481.79V171.72C481.787 181.317 477.974 190.521 471.187 197.307C464.401 204.094 455.197 207.907 445.6 207.91H401C396.491 207.91 392.167 209.701 388.979 212.889C385.791 216.077 384 220.401 384 224.91V321.55C383.987 331.86 379.883 341.744 372.59 349.031C365.297 356.319 355.41 360.415 345.1 360.42Z",
                fill: "#E5E5E5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M468.2 272.08C468.2 272.08 459.15 279.86 458.72 291.4C458.63 295.5 464.14 293.68 465.21 293C465.64 297.58 468.97 302.33 475.11 302.36C481.25 302.39 494.11 291.49 495.37 284.66C496.63 277.83 484.09 260.28 468.2 272.08Z",
                fill: "#F4B587"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M468.71 285.94C469.472 285.94 470.09 285.322 470.09 284.56C470.09 283.798 469.472 283.18 468.71 283.18C467.948 283.18 467.33 283.798 467.33 284.56C467.33 285.322 467.948 285.94 468.71 285.94Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M479.14 292.79C479.14 292.79 481.96 305.67 479.05 314.01C476.14 322.35 506.45 314.85 506.45 314.85L506.03 308.99C506.03 308.99 498.6 274.1 484.51 269.28C470.42 264.46 479.14 292.79 479.14 292.79Z",
                fill: "#F4B587"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M480.12 272.71C480.12 272.71 482.77 277.83 484.48 280.86C484.48 280.86 489.59 279.93 490.35 284.56C490.365 285.382 490.115 286.187 489.638 286.857C489.161 287.526 488.482 288.025 487.7 288.28C487.7 288.28 492.04 292.72 501.43 293.34H505.5C505.5 293.34 502.57 286.12 499.35 278.95C498.087 276.068 496.01 273.617 493.374 271.899C490.738 270.181 487.657 269.271 484.51 269.28C481.83 272.14 480.12 272.71 480.12 272.71Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M465.23 385.04H516.23C536.72 404.18 519.1 488.85 406.8 403.8L440.8 483.93H411.29L375.52 397.19C374.42 394.224 374.121 391.022 374.652 387.904C375.184 384.786 376.528 381.863 378.548 379.429C380.569 376.996 383.195 375.138 386.162 374.043C389.13 372.947 392.333 372.653 395.45 373.19L465.23 385.04Z",
                fill: "#FF7D20"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M461.6 428.43V463.51C461.599 466.191 462.126 468.846 463.151 471.324C464.176 473.801 465.679 476.052 467.575 477.948C469.47 479.845 471.72 481.349 474.197 482.375C476.674 483.402 479.329 483.93 482.01 483.93H560.5V459.99H492.43L499.06 421.57L461.6 428.43Z",
                fill: "#FF7D20"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M501.78 310.63C497.15 312.3 492.34 315.21 488.46 314.85H467.05V385.04H519.14V331.96C519.14 319.46 513.93 309.38 501.78 310.63Z",
                fill: "#D9E8F2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M479.14 296.45H479.05V296.5L479.14 296.45Z",
                fill: "#82B5D3"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M506.03 308.99C505.895 308.973 505.761 308.946 505.63 308.91C495.1 314.59 481.4 312.34 476.49 310.52C471.58 310.66 470.97 311.91 464.88 316.37L498.2 318.47C494.28 342.12 491.3 385.04 491.3 385.04C491.3 385.04 521.39 401.61 545.37 385.04C562.9 372.93 564.04 318.8 506.03 308.99Z",
                fill: "#D9E8F2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M477.09 278.92H499.35C499.35 278.92 493.48 262.71 477.09 262.71C460.7 262.71 462.65 278.92 462.65 278.92H477.09Z",
                fill: "#408DBC"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M462.65 278.92C462.65 278.92 441.65 273.07 446.21 264.53C450.77 255.99 483.34 278.92 483.34 278.92H462.65Z",
                fill: "#82B5D3"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M477.21 307.9H467.05V385.04H477.21V307.9Z",
                fill: "#FF7D20"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M509.83 307.9H499.67V385.04H509.83V307.9Z",
                fill: "#FF7D20"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M509.82 329.16H472.1V402.09H509.82V329.16Z",
                fill: "#FF7D20"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M504.28 347.78C504.28 347.78 532.13 348.04 528.8 365.63C526.53 377.63 510.45 376.54 504.28 372.93C498.11 369.32 504.28 347.78 504.28 347.78Z",
                fill: "#FF7D20"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M491.88 442.75C443.64 442.75 399.78 399.04 399.32 398.59L401.42 396.51C401.88 396.97 447.71 442.71 496.51 439.66L496.69 442.6C495.09 442.7 493.48 442.75 491.88 442.75Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M387.37 335.28C387.37 335.28 386.84 322.81 370.37 322.81H361.56C361.56 322.81 362.71 329.25 370.37 329.15C374.21 329.15 375.63 332.32 376.09 335.56C376.317 337.338 377.181 338.973 378.522 340.162C379.862 341.352 381.588 342.015 383.38 342.03H387.38L387.37 335.28Z",
                fill: "#F4B587"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M294.51 486.76H275.32V176.18C275.32 169.815 277.849 163.71 282.35 159.209C286.85 154.709 292.955 152.18 299.32 152.18H322.12V171.37H299.3C298.031 171.373 296.814 171.878 295.916 172.776C295.018 173.674 294.513 174.89 294.51 176.16V486.76Z",
                fill: "#CBCBCB"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M415.02 181.52H412.07C410.358 181.52 408.97 182.908 408.97 184.62V208.64C408.97 210.352 410.358 211.74 412.07 211.74H415.02C416.732 211.74 418.12 210.352 418.12 208.64V184.62C418.12 182.908 416.732 181.52 415.02 181.52Z",
                fill: "#989898"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M300.03 233.46V230.51C300.03 228.798 298.642 227.41 296.93 227.41H272.91C271.198 227.41 269.81 228.798 269.81 230.51V233.46C269.81 235.172 271.198 236.56 272.91 236.56H296.93C298.642 236.56 300.03 235.172 300.03 233.46Z",
                fill: "#989898"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M389.56 255.42V252.47C389.56 250.758 388.172 249.37 386.46 249.37H362.44C360.728 249.37 359.34 250.758 359.34 252.47V255.42C359.34 257.132 360.728 258.52 362.44 258.52H386.46C388.172 258.52 389.56 257.132 389.56 255.42Z",
                fill: "#989898"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M233.17 271.65V268.7C233.17 266.988 231.782 265.6 230.07 265.6H206.05C204.338 265.6 202.95 266.988 202.95 268.7V271.65C202.95 273.362 204.338 274.75 206.05 274.75H230.07C231.782 274.75 233.17 273.362 233.17 271.65Z",
                fill: "#989898"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M300.03 317.38V314.43C300.03 312.718 298.642 311.33 296.93 311.33H272.91C271.198 311.33 269.81 312.718 269.81 314.43V317.38C269.81 319.092 271.198 320.48 272.91 320.48H296.93C298.642 320.48 300.03 319.092 300.03 317.38Z",
                fill: "#989898"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M300.02 386.52V383.57C300.02 381.858 298.632 380.47 296.92 380.47H272.9C271.188 380.47 269.8 381.858 269.8 383.57V386.52C269.8 388.232 271.188 389.62 272.9 389.62H296.92C298.632 389.62 300.02 388.232 300.02 386.52Z",
                fill: "#989898"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M319.45 360.52H249.02L249.09 341.19H319.52L319.45 360.52Z",
                fill: "#CBCBCB"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M251.82 335.37H248.87C247.158 335.37 245.77 336.758 245.77 338.47V362.49C245.77 364.202 247.158 365.59 248.87 365.59H251.82C253.532 365.59 254.92 364.202 254.92 362.49V338.47C254.92 336.758 253.532 335.37 251.82 335.37Z",
                fill: "#989898"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M320.96 335.37H318.01C316.298 335.37 314.91 336.758 314.91 338.47V362.49C314.91 364.202 316.298 365.59 318.01 365.59H320.96C322.672 365.59 324.06 364.202 324.06 362.49V338.47C324.06 336.758 322.672 335.37 320.96 335.37Z",
                fill: "#989898"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M511.3 307.9H508.35V354.73H511.3V307.9Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M395.686 371.714L395.15 374.615L476.905 389.723L477.441 386.823L395.686 371.714Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M387.37 332.204L385.891 350.625L388.832 350.861L390.311 332.44L387.37 332.204Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M509.83 391.35V380.75C509.83 380.75 510.96 371.32 501.54 369.66C492.12 368 484.92 367.44 484.92 367.44C484.92 367.44 484.36 373.63 495.17 375.39C496.32 378.61 484.47 378.5 479.53 372.68C479.215 372.328 478.806 372.075 478.351 371.95C477.895 371.825 477.414 371.835 476.964 371.977C476.514 372.12 476.114 372.39 475.814 372.754C475.513 373.118 475.325 373.561 475.27 374.03C474.29 382.33 479.44 393.28 509.83 391.35Z",
                fill: "#F4B587"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M512.5 393.86H509.54V373.03H536.32V375.98H512.5V393.86Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M440.66 483.85V505.53H381.71C381.71 505.53 385.45 493.23 407.47 493.95C416.62 494.69 411.15 483.85 411.15 483.85H440.66Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M570.46 494.95C570.308 498.496 570.58 502.048 571.27 505.53H582.04V459.91H560.36V483.85C560.36 483.85 571.2 485.8 570.46 494.95Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M560.36 505.53C560.36 505.53 561.36 496.34 574.03 496.34L582.03 505.53H560.36Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M612.77 505.14H363.64V508.09H612.77V505.14Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M226.08 104.74H223.13V255.53H226.08V104.74Z",
                fill: "#E5F0F6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M219.43 104.74H216.48V255.53H219.43V104.74Z",
                fill: "#E5F0F6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M212.79 104.74H209.84V255.53H212.79V104.74Z",
                fill: "#E5F0F6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M354.02 166.97H329.01V169.92H354.02V166.97Z",
                fill: "#E5F0F6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M354.02 160.32H329.01V163.27H354.02V160.32Z",
                fill: "#E5F0F6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M354.02 153.68H329.01V156.63H354.02V153.68Z",
                fill: "#E5F0F6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M143.15 501.75C187.968 501.75 224.3 465.418 224.3 420.6C224.3 375.782 187.968 339.45 143.15 339.45C98.3322 339.45 62.0001 375.782 62.0001 420.6C62.0001 465.418 98.3322 501.75 143.15 501.75Z",
                fill: "#FFD400"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M178.14 381.27H166.8V439.14H178.14V381.27Z",
                fill: "#408DBC"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M178.41 361.21V374.51H166.53V361.21C163.872 362.547 161.743 364.742 160.486 367.439C159.23 370.136 158.92 373.178 159.607 376.073C160.294 378.968 161.938 381.547 164.272 383.392C166.606 385.237 169.495 386.24 172.47 386.24C175.446 386.24 178.334 385.237 180.668 383.392C183.002 381.547 184.646 378.968 185.333 376.073C186.02 373.178 185.71 370.136 184.454 367.439C183.198 364.742 181.068 362.547 178.41 361.21Z",
                fill: "#408DBC"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M173.17 387.83H171.97C170.545 387.83 169.39 388.985 169.39 390.41V430.39C169.39 431.815 170.545 432.97 171.97 432.97H173.17C174.595 432.97 175.75 431.815 175.75 430.39V390.41C175.75 388.985 174.595 387.83 173.17 387.83Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M138.37 380.39L143.8 375.72L136.6 367.28L138.78 365.51L149.38 370.67C150.232 371.082 150.981 371.68 151.571 372.419C152.161 373.159 152.578 374.021 152.791 374.943C153.004 375.865 153.008 376.823 152.801 377.747C152.595 378.67 152.185 379.536 151.6 380.28L146.14 387.28L149.57 435.02C149.655 436.216 149.493 437.417 149.094 438.548C148.695 439.679 148.067 440.716 147.25 441.594C146.433 442.472 145.444 443.172 144.345 443.652C143.246 444.131 142.059 444.379 140.86 444.38C139.644 444.38 138.442 444.126 137.33 443.634C136.218 443.143 135.22 442.425 134.402 441.526C133.583 440.627 132.96 439.567 132.575 438.414C132.189 437.261 132.047 436.041 132.16 434.83L136.23 391.55L133.02 388.35C131.769 387.101 130.968 385.473 130.74 383.72L129.36 373.23L131.05 371.86L138.37 380.39Z",
                fill: "#408DBC"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M135.83 395.46H146.7L149.54 434.99C149.635 436.2 149.476 437.415 149.075 438.56C148.674 439.705 148.039 440.754 147.21 441.64C146.382 442.526 145.378 443.23 144.262 443.707C143.147 444.184 141.944 444.423 140.731 444.41C139.518 444.397 138.321 444.131 137.216 443.63C136.112 443.129 135.123 442.403 134.314 441.499C133.505 440.595 132.893 439.533 132.517 438.38C132.141 437.226 132.009 436.007 132.13 434.8L135.83 395.46Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M143.139 374.991L134.764 382.96L136.116 384.38L144.49 376.41L143.139 374.991Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M189.56 393.45H96.7401V395.41H189.56V393.45Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M193.21 434.75H92.7701V456.89H193.21V434.75Z",
                fill: "#FFF6CC"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M193.21 407.42H92.7701V429.56H193.21V407.42Z",
                fill: "#FFF6CC"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M100.71 385.87H92.7701V456.9H100.71V385.87Z",
                fill: "#FFF6CC"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M193.53 385.87H185.59V456.9H193.53V385.87Z",
                fill: "#FFF6CC"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M193.53 455.91H92.7701V457.87H193.53V455.91Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M128.08 433.77H92.7701V435.73H128.08V433.77Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M178.13 428.58H92.7701V430.54H178.13V428.58Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M153.2 406.43H92.7701V408.39H153.2V406.43Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M62.9901 420.6H60.9901C60.9978 402.044 67.2869 384.037 78.8335 369.51C90.38 354.984 106.504 344.794 124.58 340.6L125.02 342.52C107.371 346.612 91.628 356.561 80.3565 370.745C69.0851 384.929 62.9497 402.513 62.9501 420.63L62.9901 420.6Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M143.15 502.73V500.73C160.321 500.734 177.039 495.223 190.843 485.011C204.646 474.798 214.806 460.423 219.825 444.002C224.845 427.581 224.458 409.983 218.724 393.798C212.989 377.613 202.208 363.697 187.97 354.1L189.07 352.47C203.657 362.304 214.7 376.561 220.575 393.143C226.45 409.725 226.845 427.755 221.703 444.578C216.561 461.401 206.152 476.129 192.011 486.592C177.869 497.056 160.742 502.702 143.15 502.7V502.73Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M143.6 520.76C129.109 520.817 114.781 517.697 101.626 511.619C88.4715 505.541 76.809 496.652 67.4601 485.58L68.9601 484.31C78.1252 495.163 89.5582 503.875 102.454 509.833C115.35 515.79 129.395 518.847 143.6 518.79C157.555 518.77 171.352 515.838 184.109 510.181C196.866 504.525 208.302 496.268 217.686 485.939C227.07 475.61 234.195 463.437 238.606 450.197C243.016 436.957 244.615 422.943 243.3 409.05L245.3 408.86C246.64 423.029 245.008 437.322 240.508 450.825C236.008 464.327 228.74 476.742 219.167 487.274C209.595 497.807 197.929 506.225 184.917 511.991C171.905 517.757 157.833 520.744 143.6 520.76Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M116.27 383.08H117.6C118.353 383.08 119.076 383.379 119.608 383.912C120.141 384.444 120.44 385.167 120.44 385.92V453.11H113.44V385.92C113.44 385.169 113.738 384.448 114.268 383.915C114.799 383.383 115.519 383.083 116.27 383.08Z",
                fill: "#408DBC"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M115.6 451.28H118.26C119.764 451.28 121.206 451.877 122.269 452.941C123.333 454.004 123.93 455.446 123.93 456.95V459.13H109.93V456.95C109.93 455.446 110.527 454.004 111.591 452.941C112.654 451.877 114.096 451.28 115.6 451.28Z",
                fill: "#FF7D20"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M116.94 457.45C112.113 457.45 107.484 459.368 104.071 462.781C100.658 466.194 98.7401 470.823 98.7401 475.65H135.14C135.14 470.823 133.223 466.194 129.809 462.781C126.396 459.368 121.767 457.45 116.94 457.45Z",
                fill: "#FF9B53"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M134.84 475.65H99.0401C97.5821 475.65 96.4001 476.832 96.4001 478.29V479.52C96.4001 480.978 97.5821 482.16 99.0401 482.16H134.84C136.298 482.16 137.48 480.978 137.48 479.52V478.29C137.48 476.832 136.298 475.65 134.84 475.65Z",
                fill: "#FF7D20"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M99.7201 475.65H97.7201C97.7213 472.17 98.669 468.755 100.462 465.772C102.255 462.788 104.825 460.349 107.898 458.714C110.971 457.08 114.43 456.312 117.906 456.493C121.382 456.673 124.743 457.796 127.63 459.74L126.6 461.37C124.009 459.626 120.992 458.619 117.872 458.458C114.752 458.296 111.647 458.985 108.889 460.452C106.132 461.919 103.824 464.108 102.214 466.785C100.604 469.462 99.7527 472.526 99.7501 475.65H99.7201Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M137.48 474.67H95.7201V476.63H137.48V474.67Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M137.48 481.34H95.7201V483.3H137.48V481.34Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M117.92 390.78H115.96V444.35H117.92V390.78Z",
                fill: "#003C71"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-illustrations-virtual-f4c8d3dc38/1/packages/lib-illustrations/src/radgjof.tsx
/* eslint-disable max-len */ 

const RadgjofIllustration = (param)=>{
    let { size =200  } = param;
    return /*#__PURE__*/ _jsxs("svg", {
        fill: "none",
        height: size,
        viewBox: "0 0 663 611",
        width: size,
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M538.68 530.73C538.68 530.73 527.09 466.73 464.85 467.43C411.28 468 376.31 508.5 312 505.71C262.33 503.55 256.25 530.71 256.25 530.71L538.68 530.73Z",
                fill: "#D9EEE8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M419.95 467.77C424.36 471.65 441.53 464.65 443.12 454.06C435.95 450.66 419.39 457.97 419.95 467.77Z",
                fill: "#D9EEE8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M456.33 464.28C465.69 465.36 477.91 461.16 479.5 450.57C472.33 447.2 458.63 453.95 456.33 464.28Z",
                fill: "#D9EEE8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M550.1 527.72C551 518.34 546.55 506.21 535.93 504.83C532.67 512.06 539.69 525.63 550.1 527.72Z",
                fill: "#D9EEE8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M450.37 451.28C457.64 450.37 466.1 444.95 465.37 436.67C459.31 435.4 450.21 443.01 450.37 451.28Z",
                fill: "#D9EEE8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M392.9 531.13L391.55 530.34C422.36 477.5 482.55 447.57 483.11 447.27L483.8 448.68C483.18 448.98 423.45 478.71 392.9 531.13Z",
                fill: "white"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M464.49 545.36L463.49 544.14C463.88 543.83 502.31 512.49 516.67 482.98L518.08 483.67C503.58 513.49 464.9 545.04 464.49 545.36Z",
                fill: "white"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M433.7 536.38L432.53 535.33C432.91 534.91 470.53 493.33 506.27 475.78L506.96 477.19C471.53 494.58 434.07 535.96 433.7 536.38Z",
                fill: "white"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M580.84 295.05H445.54V371.24H580.84V295.05Z",
                fill: "#408DBC"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M457.216 250.895L452.547 253.782L476.36 292.295L481.03 289.407L457.216 250.895Z",
                fill: "#6EA8CC"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M480.627 250.893L475.958 253.781L499.771 292.293L504.441 289.406L480.627 250.893Z",
                fill: "#6EA8CC"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M504.047 250.897L499.377 253.784L523.191 292.296L527.86 289.409L504.047 250.897Z",
                fill: "#6EA8CC"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M527.466 250.89L522.797 253.777L546.61 292.289L551.28 289.402L527.466 250.89Z",
                fill: "#6EA8CC"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M550.877 250.898L546.208 253.785L570.021 292.297L574.691 289.41L550.877 250.898Z",
                fill: "#6EA8CC"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M569.997 250.826L546.183 289.339L550.853 292.226L574.666 253.714L569.997 250.826Z",
                fill: "#6EA8CC"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M546.58 250.826L522.766 289.338L527.436 292.225L551.249 253.713L546.58 250.826Z",
                fill: "#6EA8CC"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M523.168 250.827L499.354 289.339L504.024 292.226L527.837 253.714L523.168 250.827Z",
                fill: "#6EA8CC"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M501.697 252.197L477.699 290.685L482.365 293.595L506.364 255.107L501.697 252.197Z",
                fill: "#6EA8CC"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M478.19 252.186L454.192 290.674L458.858 293.583L482.857 255.095L478.19 252.186Z",
                fill: "#6EA8CC"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M452.66 235.34H437.96V371.86H452.66V235.34Z",
                fill: "#6EA8CC"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M586.03 235.34H571.33V371.86H586.03V235.34Z",
                fill: "#6EA8CC"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M580.84 245.11H445.54V257.37H580.84V245.11Z",
                fill: "#6EA8CC"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M580.84 282.98H445.54V295.24H580.84V282.98Z",
                fill: "#6EA8CC"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M590.56 370.45H434.48V372.02H590.56V370.45Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M571.33 295.1H452.66V296.67H571.33V295.1Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M466.79 296.68H465.22V368.11H466.79V296.68Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M479.98 296.68H478.41V368.11H479.98V296.68Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M493.18 296.68H491.61V368.11H493.18V296.68Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M506.38 296.68H504.81V368.11H506.38V296.68Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M519.57 296.68H518V368.11H519.57V296.68Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M532.77 296.68H531.2V368.11H532.77V296.68Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M545.97 296.68H544.4V368.11H545.97V296.68Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M559.17 296.68H557.6V368.11H559.17V296.68Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M454.9 380.59C454.9 380.59 460.28 357.41 494.05 361.32C527.82 365.23 552.42 355.06 572.37 349.02C592.32 342.98 603.52 351.56 608.37 357.68L589.79 380.59H454.9Z",
                fill: "#85C7B6"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M455.64 380.76L454.11 380.41C454.17 380.17 460.05 356.59 494.11 360.54C523.18 363.91 545.7 356.69 563.79 350.89C566.69 349.96 569.43 349.08 572.11 348.27C580.99 345.58 589.04 345.48 596.03 347.97L595.5 349.44C588.83 347.07 581.12 347.18 572.57 349.77C569.89 350.58 567.16 351.46 564.27 352.38C546.03 358.23 523.33 365.51 493.93 362.1C461.24 358.28 455.69 380.54 455.64 380.76Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M454.45 394.13C438.624 384.121 425.594 370.262 416.578 353.85C407.563 337.437 402.857 319.006 402.9 300.28C402.9 298.4 402.95 296.51 403.04 294.64L404.61 294.72C404.52 296.56 404.47 298.43 404.47 300.28C404.429 318.736 409.068 336.902 417.954 353.078C426.84 369.255 439.682 382.914 455.28 392.78L454.45 394.13Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M537.19 409.04L536.87 407.51C555.521 403.538 572.813 394.767 587.036 382.066C601.26 369.364 611.923 353.171 617.972 335.086C624.02 317.002 625.246 297.652 621.526 278.949C617.807 260.246 609.271 242.837 596.764 228.443C584.256 214.048 568.209 203.167 550.208 196.874C532.207 190.581 512.875 189.094 494.123 192.559C475.372 196.025 457.849 204.324 443.287 216.636C428.724 228.947 417.627 244.846 411.09 262.76L409.62 262.23C416.249 244.061 427.505 227.936 442.275 215.449C457.044 202.962 474.817 194.545 493.835 191.029C512.854 187.514 532.461 189.023 550.718 195.405C568.975 201.788 585.251 212.824 597.937 227.424C610.623 242.023 619.28 259.679 623.052 278.649C626.824 297.618 625.582 317.244 619.447 335.586C613.312 353.928 602.497 370.351 588.071 383.234C573.645 396.116 556.107 405.011 537.19 409.04Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M92.6701 530.37C107.67 518.93 98.8401 460.95 66.5001 449.31C51.2801 469.75 61.4301 525.99 92.6701 530.37Z",
                fill: "#008B66"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M70.0517 457.643L68.5576 458.125L91.9502 530.593L93.4443 530.111L70.0517 457.643Z",
                fill: "#87C9B7"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M93.6101 531.16H92.6601C74.7201 531.16 60.5501 523.88 51.6601 510.16C44.9001 499.67 42.9001 488.06 42.7601 483.39V482.25L43.8301 482.62C44.2701 482.77 87.3901 497.97 93.4601 530.23L93.6101 531.16ZM44.4001 484.52C45.3162 493.325 48.2561 501.799 52.9901 509.28C61.5201 522.52 74.5501 529.35 91.7101 529.59C85.7501 501.68 51.0601 487.08 44.4001 484.52Z",
                fill: "#87C9B7"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M180.9 302.8V404.08H130.9V388.08C130.9 388.08 102.68 382.84 102.66 352.74C102.66 326.93 116.49 306.49 151.66 301.74V295.38H180.9V302.8Z",
                fill: "#008B66"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M183.9 270.8V276.45C183.9 276.45 188.45 283.56 188.27 285.38C188.09 287.2 183.9 287.02 183.9 287.02L174.78 291.58V309.07L158.78 297.77C158.78 297.77 155.86 276.27 161.51 270.77C167.16 265.27 183.9 270.8 183.9 270.8Z",
                fill: "#F8D37D"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M184.61 272.2L186.03 263.28C186.03 263.28 164.44 259.18 159.79 271.48C158.145 275.943 157.312 280.664 157.33 285.42L164.98 282.01C164.98 282.01 160.2 280.09 161.43 276.13C162.66 272.17 169.82 274.9 169.82 274.9C169.82 274.9 165.9 289.66 169.82 295.13C173.74 300.6 187.03 300.23 183.94 287.02L176.74 284.88C176.74 284.88 175.08 287.88 173.18 287.88C171.28 287.88 171.26 277.72 173.18 272.57L184.61 272.2Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M178.39 279.4C178.981 279.4 179.46 278.921 179.46 278.33C179.46 277.739 178.981 277.26 178.39 277.26C177.799 277.26 177.32 277.739 177.32 278.33C177.32 278.921 177.799 279.4 178.39 279.4Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M157.746 296.678L156.898 297.999L176.331 310.47L177.179 309.148L157.746 296.678Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M150.79 389.49L136.04 389.17C128.91 388.997 122.015 386.587 116.33 382.28C109.74 377.55 101.89 368.57 101.88 352.69C101.88 335.69 107.63 322.5 119 313.42L120 314.65C109 323.41 103.45 336.21 103.46 352.65C103.46 364.87 108.12 374.4 117.26 380.98C122.707 385.087 129.301 387.387 136.12 387.56L149.24 387.84V364.28H150.81L150.79 389.49Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M137.01 305.77L136.52 304.28C141.409 302.713 146.43 301.588 151.52 300.92L151.73 302.48C146.734 303.13 141.807 304.231 137.01 305.77Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M137.55 335.45H135.98V364.67H137.55V335.45Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M108.13 233.38C140.544 233.38 166.82 207.104 166.82 174.69C166.82 142.276 140.544 116 108.13 116C75.7166 116 49.4402 142.276 49.4402 174.69C49.4402 207.104 75.7166 233.38 108.13 233.38Z",
                fill: "#FFD400"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M108.13 234.17C94.1848 234.192 80.6766 229.305 69.9731 220.366C59.2696 211.427 52.0537 199.006 49.5901 185.28L51.1301 185C52.7291 193.834 56.3588 202.176 61.7329 209.368C67.1069 216.559 74.0784 222.404 82.0975 226.441C90.1165 230.477 98.9638 232.596 107.942 232.628C116.919 232.661 125.782 230.608 133.83 226.63L134.53 228.04C126.326 232.107 117.287 234.206 108.13 234.17Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M85.7301 182.67H130.25C130.25 183.996 129.723 185.268 128.786 186.205C127.848 187.143 126.576 187.67 125.25 187.67H90.7301C89.4041 187.67 88.1323 187.143 87.1946 186.205C86.2569 185.268 85.7301 183.996 85.7301 182.67Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M108.77 169.28H107.2V212.61H108.77V169.28Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M121.863 169.172L120.309 169.398L126.631 212.73L128.184 212.503L121.863 169.172Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M94.3997 169.16L88.0708 212.49L89.6243 212.717L95.9532 169.387L94.3997 169.16Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M86.9101 204.06H82.0602V214.39H86.9101V204.06Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M134.18 204.06H129.33V214.39H134.18V204.06Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M130.25 208.47H85.7301V210.04H130.25V208.47Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M156 210L154.74 209.07C159.987 201.962 163.538 193.747 165.121 185.055C166.704 176.363 166.277 167.424 163.873 158.922C161.47 150.421 157.152 142.582 151.252 136.006C145.352 129.43 138.025 124.291 129.833 120.982C121.641 117.674 112.801 116.284 103.988 116.918C95.1762 117.553 86.6261 120.196 78.9925 124.644C71.3589 129.092 64.8443 135.228 59.9474 142.581C55.0504 149.935 51.901 158.312 50.7401 167.07L49.1801 166.86C50.3728 157.864 53.6079 149.261 58.6378 141.708C63.6676 134.155 70.3589 127.853 78.1994 123.285C86.0399 118.717 94.8218 116.003 103.873 115.351C112.924 114.699 122.004 116.127 130.418 119.525C138.832 122.923 146.357 128.202 152.417 134.956C158.477 141.71 162.911 149.762 165.38 158.494C167.849 167.226 168.288 176.407 166.662 185.334C165.036 194.262 161.389 202.699 156 210Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M316.42 88.48H406.5C406.5 88.48 409.2 63.97 384.79 63.97C366.98 63.97 361.42 77.62 361.42 77.62C361.42 77.62 351.17 63.94 331.67 67.5C315.67 70.42 312.35 80.33 312.35 80.33C312.35 80.33 291.35 76.21 285.15 88.48H316.42Z",
                fill: "#B2D1E4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M474.18 117.75H400.9C400.9 117.75 398.7 97.8099 418.56 97.8099C433.05 97.8099 437.56 108.91 437.56 108.91C437.56 108.91 445.9 97.7899 461.77 100.68C474.83 103.06 477.49 111.12 477.49 111.12C477.49 111.12 494.57 107.77 499.63 117.75H474.18Z",
                fill: "#B2D1E4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M269.2 154.01H267.63V225.98H269.2V154.01Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M279.06 154.01H277.49V225.98H279.06V154.01Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M276.95 233.73H275.38C275.219 231.993 274.415 230.379 273.125 229.204C271.836 228.029 270.155 227.377 268.41 227.377C266.666 227.377 264.984 228.029 263.695 229.204C262.406 230.379 261.601 231.993 261.44 233.73H259.9C259.9 231.465 260.8 229.293 262.401 227.691C264.003 226.09 266.175 225.19 268.44 225.19C270.705 225.19 272.877 226.09 274.479 227.691C276.08 229.293 276.98 231.465 276.98 233.73H276.95Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M235.17 129.98H233.6V225.98H235.17V129.98Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M242.9 233.73H241.33C241.169 231.993 240.365 230.379 239.075 229.204C237.786 228.029 236.105 227.377 234.36 227.377C232.616 227.377 230.934 228.029 229.645 229.204C228.356 230.379 227.551 231.993 227.39 233.73H225.9C225.9 232.608 226.121 231.498 226.55 230.462C226.979 229.426 227.608 228.484 228.401 227.691C229.194 226.898 230.136 226.269 231.172 225.84C232.208 225.411 233.319 225.19 234.44 225.19C235.562 225.19 236.672 225.411 237.708 225.84C238.744 226.269 239.686 226.898 240.479 227.691C241.272 228.484 241.901 229.426 242.33 230.462C242.759 231.498 242.98 232.608 242.98 233.73H242.9Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M286.66 233.73H285.09C285.18 232.76 285.067 231.783 284.758 230.859C284.448 229.936 283.95 229.087 283.294 228.367C282.638 227.648 281.839 227.073 280.948 226.679C280.057 226.286 279.094 226.083 278.12 226.083C277.146 226.083 276.183 226.286 275.292 226.679C274.402 227.073 273.603 227.648 272.947 228.367C272.291 229.087 271.792 229.936 271.483 230.859C271.173 231.783 271.06 232.76 271.15 233.73H269.59C269.551 232.585 269.743 231.443 270.154 230.373C270.565 229.304 271.188 228.327 271.984 227.503C272.78 226.679 273.735 226.024 274.79 225.576C275.845 225.129 276.979 224.898 278.125 224.898C279.271 224.898 280.406 225.129 281.461 225.576C282.516 226.024 283.47 226.679 284.266 227.503C285.063 228.327 285.685 229.304 286.096 230.373C286.508 231.443 286.699 232.585 286.66 233.73Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M122.01 397.52H249.12V530.37H196.12C186.388 530.375 176.75 528.463 167.758 524.741C158.765 521.02 150.594 515.563 143.712 508.682C136.829 501.802 131.37 493.632 127.646 484.641C123.923 475.649 122.008 466.012 122.01 456.28V397.52Z",
                fill: "#4C95C0"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M206.02 292.15C202.02 293.47 204.55 297.27 200.17 299.06C195.79 300.85 193.17 301.17 193.51 305.72C193.85 310.27 190.42 310.59 190.26 315.14C190.1 319.69 194 317.84 194.48 321.2C194.96 324.56 194.16 329.76 200.66 332.36C207.16 334.96 211.54 329.52 215.44 330.36C219.34 331.2 227.13 332.36 230.22 327.8C233.31 323.24 230.22 320.39 234.28 317.6C238.34 314.81 231.36 310.75 232 305.39C232.64 300.03 224.7 300.68 222.91 297.39C221.12 294.1 216.57 292.51 214.14 294.46C211.71 296.41 209.75 290.92 206.02 292.15Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M218.36 299.81C218.36 299.81 218.69 304.75 225.78 305.81C232.87 306.87 226.78 311.01 226.78 311.01C226.78 311.01 230.31 313.56 229.19 317.59C228.07 321.62 219.63 320.44 219.63 320.44V328.12C219.63 328.12 231.75 332.5 240.56 338.12C242.08 339.12 240 342.18 241.25 343.2C209.41 343.2 186.06 341.11 186.06 341.11C186.06 341.11 197.97 331.21 205.99 328.92C207.276 327.363 208.211 325.546 208.728 323.593C209.246 321.641 209.336 319.6 208.99 317.61C207.9 310.61 214.84 314.71 213.99 308.21C213.14 301.71 218.36 299.81 218.36 299.81Z",
                fill: "#A37160"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M238.49 336.84C209.99 343.73 199.49 331.84 199.49 331.84C165.87 346.59 144.49 397.54 144.49 397.54H157.07L188.32 364.69C194.86 364.69 192.68 376.77 192.68 376.77L217.1 397.52H157.1H228.17C228.17 397.52 232.17 389.81 238.51 374.2C253.69 338.28 238.49 336.84 238.49 336.84Z",
                fill: "#FF7D20"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M441.36 309.51C447.784 307.467 453.703 304.09 458.73 299.6C460.14 298.405 461.212 296.861 461.836 295.121C462.461 293.382 462.618 291.509 462.29 289.69C461.69 286.83 460.83 283.69 459.78 282.08L449.58 293.46C449.58 293.46 455.01 285.76 451.04 283.69C451.04 283.69 447.46 289.69 438.52 295.89C436.09 302.91 441.36 309.51 441.36 309.51Z",
                fill: "#FDC498"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M442.05 309.07C442.05 309.07 410.71 333.16 352.9 324.41V302.96C352.9 302.96 403.67 311.04 438.54 295.89L442.05 309.07Z",
                fill: "#0067A5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M332.95 270.65C332.95 270.65 325.22 275.77 323.76 284.65C323.29 287.8 327.71 286.94 328.61 286.52C328.469 288.483 329.087 290.426 330.335 291.947C331.583 293.469 333.367 294.454 335.32 294.7C340.04 295.32 351 288.18 352.66 283.04C354.32 277.9 346.35 263.12 332.95 270.65Z",
                fill: "#FDC498"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M332.13 281.4C332.721 281.4 333.2 280.921 333.2 280.33C333.2 279.739 332.721 279.26 332.13 279.26C331.539 279.26 331.06 279.739 331.06 280.33C331.06 280.921 331.539 281.4 332.13 281.4Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M219.16 310.14C219.751 310.14 220.23 309.661 220.23 309.07C220.23 308.479 219.751 308 219.16 308C218.569 308 218.09 308.479 218.09 309.07C218.09 309.661 218.569 310.14 219.16 310.14Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M339.36 287.69C339.36 287.69 340.28 297.89 337.22 304.03C334.16 310.17 359.4 315.86 359.4 315.86L358.5 302.8C358.5 302.8 356.15 275.18 345.8 270.06C335.45 264.94 339.36 287.69 339.36 287.69Z",
                fill: "#FDC498"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M342.08 272.28C342.08 272.28 343.62 276.48 344.64 278.98C344.64 278.98 348.64 278.77 348.8 282.41C348.723 283.038 348.45 283.626 348.019 284.09C347.588 284.553 347.021 284.868 346.4 284.99C346.4 284.99 349.31 288.84 356.48 290.23C357.407 286.515 357.341 282.622 356.29 278.94C355.601 276.594 354.241 274.5 352.377 272.917C350.513 271.334 348.227 270.331 345.8 270.03C344.746 271.051 343.474 271.821 342.08 272.28Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M356.29 278.97C356.29 278.97 353.35 264.28 340.74 262.52C325.74 260.42 322.2 274 322.2 274L356.29 278.97Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M332.33 365.74C332.33 365.74 327.03 388.86 335.42 420.12C343.81 451.38 313.35 458 313.35 516.28H338.51C338.51 516.28 367.78 462.34 367.34 431.71C367.34 431.71 362.79 480.09 385.74 516.28H413.11L369.41 365.75L332.33 365.74Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M370.54 364.71L370.01 314.61C370.01 314.61 346.01 313.16 337.62 303.48C314.81 314.03 294.62 336.79 299.21 362.1C303.89 387.75 345.13 392.8 357.05 373.1V365.75L370.54 364.71Z",
                fill: "#0067A5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M334.58 291.73C335.045 291.731 335.505 291.641 335.934 291.464C336.364 291.287 336.754 291.027 337.083 290.7C337.412 290.372 337.672 289.982 337.85 289.553C338.029 289.124 338.12 288.664 338.12 288.2H331.05C331.05 289.136 331.422 290.034 332.084 290.696C332.746 291.358 333.644 291.73 334.58 291.73Z",
                fill: "white"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M213.04 464.45V481.28H258.04C258.04 481.28 257.45 475.1 247.74 472.89C238.03 470.68 232.74 468.89 233.32 458.03C233.9 447.17 213.04 464.45 213.04 464.45Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M202.99 376.75H237.44L269.05 404.75C272.798 408.075 275.333 412.552 276.258 417.476C277.183 422.4 276.445 427.491 274.16 431.95L252.37 474.44C251.241 473.925 250.082 473.478 248.9 473.1V408.71C248.9 405.742 247.721 402.896 245.623 400.797C243.524 398.699 240.678 397.52 237.71 397.52V469.75H211.52V397.52C206.526 397.52 201.737 395.536 198.205 392.005C194.674 388.474 192.69 383.684 192.69 378.69V376.75H202.99Z",
                fill: "#FF7D20"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M316.9 513.96V530.73H361.9C361.9 530.73 361.31 524.55 351.59 522.34C341.87 520.13 336.59 518.34 337.17 507.48C337.75 496.62 316.9 513.96 316.9 513.96Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M388.09 513.96V530.73H433.09C433.09 530.73 432.5 524.55 422.79 522.34C413.08 520.13 407.79 518.34 408.37 507.48C408.95 496.62 388.09 513.96 388.09 513.96Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M349.07 496.59L347.65 495.93C363.07 462.64 367.28 437.53 368.1 422.33C368.98 405.87 366.18 397.16 366.15 397.07L367.64 396.58C367.76 396.93 378.9 432.28 349.07 496.59Z",
                fill: "#408DBC"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M357.05 373.09C363.232 368.292 370.844 365.704 378.67 365.74C389.85 365.74 392.21 357.74 392.21 357.74H357.05V373.09Z",
                fill: "#FDC498"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M357.04 356.9H319.22V358.47H357.04V356.9Z",
                fill: "#408DBC"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M370.8 315.85H369.23V357.68H370.8V315.85Z",
                fill: "#408DBC"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M347.97 310.85C338.43 308.1 335.2 301.44 335.07 301.16L336.49 300.49L335.78 300.83L336.49 300.49C336.49 300.55 339.58 306.8 348.4 309.35L347.97 310.85Z",
                fill: "#408DBC"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M492.04 529.95H75.7202V531.52H492.04V529.95Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M304.04 179.57H366.31V218.57H285.19V198.47C285.185 195.991 285.669 193.535 286.613 191.243C287.558 188.95 288.946 186.867 290.696 185.112C292.447 183.356 294.527 181.963 296.817 181.012C299.106 180.061 301.561 179.571 304.04 179.57Z",
                fill: "#0067A5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M288.9 179.57H346.4C349.034 179.57 351.559 180.616 353.422 182.478C355.284 184.341 356.33 186.866 356.33 189.5V204.5H279.01V189.5C279.01 186.873 280.051 184.354 281.904 182.492C283.758 180.631 286.273 179.581 288.9 179.57Z",
                fill: "#6EA8CC"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M269.96 204.54H356.35V218.54H270.84C268.87 218.54 266.98 217.757 265.586 216.364C264.193 214.97 263.41 213.08 263.41 211.11C263.409 210.248 263.577 209.395 263.906 208.599C264.234 207.802 264.716 207.078 265.324 206.468C265.933 205.858 266.655 205.374 267.451 205.043C268.246 204.712 269.099 204.541 269.96 204.54Z",
                fill: "#6EA8CC"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M356.36 203H276.31V204.57H356.36V203Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M357.14 154.01H355.57V225.98H357.14V154.01Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M364.9 233.73H363.33C363.169 231.993 362.365 230.379 361.075 229.204C359.786 228.029 358.105 227.377 356.36 227.377C354.616 227.377 352.934 228.029 351.645 229.204C350.356 230.379 349.551 231.993 349.39 233.73H347.82C347.82 231.465 348.72 229.293 350.321 227.691C351.923 226.09 354.095 225.19 356.36 225.19C358.625 225.19 360.797 226.09 362.399 227.691C364 229.293 364.9 231.465 364.9 233.73Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M374.75 233.73H373.18C373.27 232.76 373.157 231.782 372.848 230.859C372.538 229.936 372.04 229.087 371.384 228.367C370.728 227.648 369.929 227.073 369.038 226.679C368.147 226.286 367.184 226.083 366.21 226.083C365.236 226.083 364.273 226.286 363.382 226.679C362.492 227.073 361.693 227.648 361.037 228.367C360.381 229.087 359.882 229.936 359.573 230.859C359.263 231.782 359.15 232.76 359.24 233.73H357.67C357.67 231.465 358.57 229.293 360.171 227.691C361.773 226.09 363.945 225.19 366.21 225.19C368.475 225.19 370.647 226.09 372.249 227.691C373.85 229.293 374.75 231.465 374.75 233.73Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M357.14 146.94H263.41V154H357.14V146.94Z",
                fill: "#6EA8CC"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M366.31 146.94H357.14V154H366.31V146.94Z",
                fill: "#0067A5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M367 146.94H365.43V225.97H367V146.94Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M270.1 160.7C270.98 160.701 271.851 160.529 272.663 160.194C273.476 159.858 274.215 159.365 274.837 158.744C275.459 158.123 275.953 157.385 276.29 156.572C276.627 155.76 276.8 154.889 276.8 154.01H263.41C263.41 155.784 264.115 157.486 265.37 158.741C266.624 159.995 268.326 160.7 270.1 160.7Z",
                fill: "#0067A5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M283.49 160.7C284.37 160.701 285.241 160.529 286.053 160.194C286.866 159.858 287.605 159.365 288.227 158.744C288.849 158.123 289.343 157.385 289.68 156.572C290.017 155.76 290.19 154.889 290.19 154.01H276.8C276.8 155.784 277.505 157.486 278.76 158.741C280.014 159.995 281.716 160.7 283.49 160.7Z",
                fill: "#6EA8CC"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M296.9 160.7C297.78 160.701 298.651 160.529 299.463 160.194C300.276 159.858 301.015 159.365 301.637 158.744C302.259 158.123 302.753 157.385 303.09 156.572C303.427 155.76 303.6 154.889 303.6 154.01H290.19C290.19 154.89 290.364 155.762 290.701 156.575C291.039 157.388 291.533 158.126 292.157 158.748C292.78 159.369 293.52 159.861 294.334 160.197C295.148 160.532 296.02 160.703 296.9 160.7Z",
                fill: "#0067A5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M310.27 160.7C311.15 160.701 312.021 160.529 312.833 160.194C313.646 159.858 314.385 159.365 315.007 158.744C315.629 158.123 316.123 157.385 316.46 156.572C316.797 155.76 316.97 154.889 316.97 154.01H303.58C303.58 155.784 304.285 157.486 305.54 158.741C306.794 159.995 308.496 160.7 310.27 160.7Z",
                fill: "#6EA8CC"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M323.66 160.7C324.54 160.701 325.411 160.529 326.223 160.194C327.036 159.858 327.775 159.365 328.397 158.744C329.019 158.123 329.513 157.385 329.85 156.572C330.187 155.76 330.36 154.889 330.36 154.01H316.97C316.97 155.784 317.675 157.486 318.93 158.741C320.184 159.995 321.886 160.7 323.66 160.7Z",
                fill: "#0067A5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M337.05 160.7C337.93 160.701 338.801 160.529 339.613 160.194C340.426 159.858 341.165 159.365 341.787 158.744C342.409 158.123 342.903 157.385 343.24 156.572C343.577 155.76 343.75 154.889 343.75 154.01H330.36C330.36 155.784 331.065 157.486 332.32 158.741C333.574 159.995 335.276 160.7 337.05 160.7Z",
                fill: "#6EA8CC"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M350.44 160.7C351.32 160.701 352.191 160.529 353.003 160.194C353.816 159.858 354.555 159.365 355.177 158.744C355.799 158.123 356.293 157.385 356.63 156.572C356.967 155.76 357.14 154.889 357.14 154.01H343.75C343.75 155.784 344.455 157.486 345.71 158.741C346.964 159.995 348.666 160.7 350.44 160.7Z",
                fill: "#0067A5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M361.14 209.35C360.038 209.35 358.961 209.023 358.045 208.411C357.128 207.798 356.414 206.928 355.993 205.909C355.572 204.891 355.462 203.77 355.678 202.69C355.894 201.609 356.425 200.616 357.205 199.838C357.985 199.059 358.978 198.53 360.06 198.316C361.141 198.102 362.261 198.214 363.279 198.637C364.296 199.06 365.165 199.775 365.776 200.693C366.387 201.61 366.712 202.688 366.71 203.79C366.707 205.265 366.119 206.68 365.075 207.722C364.031 208.764 362.616 209.35 361.14 209.35ZM361.14 199.79C360.349 199.79 359.576 200.025 358.918 200.464C358.26 200.904 357.747 201.528 357.445 202.259C357.142 202.99 357.063 203.794 357.217 204.57C357.371 205.346 357.752 206.059 358.312 206.618C358.871 207.178 359.584 207.559 360.36 207.713C361.136 207.867 361.94 207.788 362.671 207.485C363.402 207.183 364.026 206.67 364.466 206.012C364.906 205.354 365.14 204.581 365.14 203.79C365.14 202.729 364.719 201.712 363.969 200.962C363.218 200.211 362.201 199.79 361.14 199.79Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M382.9 233.55H207.92V235.12H382.9V233.55Z",
                fill: "white"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M382.9 243.08H260.66V244.65H382.9V243.08Z",
                fill: "white"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M249.82 204.54H218.95C217.017 204.54 215.45 206.105 215.45 208.035C215.45 209.965 217.017 211.53 218.95 211.53H249.82C251.753 211.53 253.32 209.965 253.32 208.035C253.32 206.105 251.753 204.54 249.82 204.54Z",
                fill: "#FF7D20"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M234.39 129.88C227.99 129.88 221.853 132.422 217.328 136.948C212.802 141.473 210.26 147.61 210.26 154.01H258.52C258.52 147.61 255.978 141.473 251.453 136.948C246.927 132.422 240.79 129.88 234.39 129.88Z",
                fill: "#FF7D20"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M242.87 202.22L241.41 201.65L247.99 184.62L254.74 183.36L255.03 184.9L249.13 186L242.87 202.22Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M248.7 192.06H240.17V204.55H248.7V192.06Z",
                fill: "white"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M249.49 205.33H239.39V191.27H248.71V192.84H240.96V203.76H247.92V195.83H249.49V205.33Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M248.71 203.76H221.89V205.33H248.71V203.76Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M249.74 153.22H210.26V154.79H249.74V153.22Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M384.32 98.83C382.273 98.83 380.272 98.223 378.57 97.0857C376.868 95.9484 375.541 94.332 374.758 92.4408C373.975 90.5496 373.77 88.4685 374.169 86.4608C374.568 84.4531 375.554 82.6089 377.002 81.1615C378.449 79.714 380.293 78.7282 382.301 78.3289C384.309 77.9295 386.39 78.1345 388.281 78.9179C390.172 79.7012 391.789 81.0278 392.926 82.7299C394.063 84.4319 394.67 86.433 394.67 88.48C394.667 91.2242 393.576 93.8552 391.636 95.7956C389.695 97.7361 387.064 98.8274 384.32 98.83ZM384.32 79.17C382.478 79.168 380.677 79.7124 379.145 80.7342C377.613 81.756 376.418 83.2093 375.712 84.9103C375.005 86.6113 374.82 88.4835 375.178 90.2902C375.536 92.0968 376.422 93.7566 377.723 95.0596C379.025 96.3627 380.684 97.2503 382.49 97.6104C384.296 97.9704 386.169 97.7866 387.871 97.0823C389.572 96.3779 391.027 95.1846 392.05 93.6534C393.074 92.1222 393.62 90.3218 393.62 88.48C393.617 86.0134 392.637 83.6484 390.894 81.9033C389.151 80.1582 386.787 79.1753 384.32 79.17Z",
                fill: "#FFD400"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M76.2489 160.561L75.1921 161.722L82.1361 168.043L83.1929 166.882L76.2489 160.561Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M75.6101 159.45H70.4201C69.6138 159.45 68.9601 160.104 68.9601 160.91C68.9601 161.716 69.6138 162.37 70.4201 162.37H75.6101C76.4165 162.37 77.0701 161.716 77.0701 160.91C77.0701 160.104 76.4165 159.45 75.6101 159.45Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M140.012 160.559L133.068 166.88L134.124 168.041L141.069 161.72L140.012 160.559Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M140.65 162.38H145.84C146.646 162.38 147.3 161.726 147.3 160.92C147.3 160.114 146.646 159.46 145.84 159.46H140.65C139.844 159.46 139.19 160.114 139.19 160.92C139.19 161.726 139.844 162.38 140.65 162.38Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M102.709 136.165L101.221 136.667L102.883 141.594L104.371 141.092L102.709 136.165Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M113.548 136.158L111.886 141.086L113.374 141.587L115.035 136.66L113.548 136.158Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M115.64 133.05H100.56C99.4225 133.05 98.5002 133.972 98.5002 135.11C98.5002 136.248 99.4225 137.17 100.56 137.17H115.64C116.778 137.17 117.7 136.248 117.7 135.11C117.7 133.972 116.778 133.05 115.64 133.05Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M134.43 172.72C135.385 168.724 135.422 164.564 134.539 160.552C133.656 156.54 131.875 152.78 129.33 149.555C126.785 146.33 123.542 143.724 119.845 141.932C116.148 140.14 112.093 139.209 107.985 139.209C103.877 139.209 99.8221 140.14 96.1252 141.932C92.4284 143.724 89.1857 146.33 86.6407 149.555C84.0957 152.78 82.3146 156.54 81.4312 160.552C80.5478 164.564 80.585 168.724 81.5401 172.72H134.43Z",
                fill: "#0067A5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M135.18 161.25H85.7301V162.82H135.18V161.25Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M135.18 158.67H85.7301V160.24H135.18V158.67Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M118.43 150.52C120.264 150.52 121.75 149.034 121.75 147.2C121.75 145.366 120.264 143.88 118.43 143.88C116.597 143.88 115.11 145.366 115.11 147.2C115.11 149.034 116.597 150.52 118.43 150.52Z",
                fill: "#5298C2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M98.8201 168.14C99.3614 168.14 99.8001 167.701 99.8001 167.16C99.8001 166.619 99.3614 166.18 98.8201 166.18C98.2789 166.18 97.8401 166.619 97.8401 167.16C97.8401 167.701 98.2789 168.14 98.8201 168.14Z",
                fill: "#5298C2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M103.47 168.14C104.011 168.14 104.45 167.701 104.45 167.16C104.45 166.619 104.011 166.18 103.47 166.18C102.929 166.18 102.49 166.619 102.49 167.16C102.49 167.701 102.929 168.14 103.47 168.14Z",
                fill: "#5298C2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M108.13 168.14C108.671 168.14 109.11 167.701 109.11 167.16C109.11 166.619 108.671 166.18 108.13 166.18C107.589 166.18 107.15 166.619 107.15 167.16C107.15 167.701 107.589 168.14 108.13 168.14Z",
                fill: "#5298C2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M112.79 168.14C113.331 168.14 113.77 167.701 113.77 167.16C113.77 166.619 113.331 166.18 112.79 166.18C112.249 166.18 111.81 166.619 111.81 167.16C111.81 167.701 112.249 168.14 112.79 168.14Z",
                fill: "#5298C2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M117.45 168.14C117.991 168.14 118.43 167.701 118.43 167.16C118.43 166.619 117.991 166.18 117.45 166.18C116.909 166.18 116.47 166.619 116.47 167.16C116.47 167.701 116.909 168.14 117.45 168.14Z",
                fill: "#5298C2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M128.9 397.52C128.9 397.52 134.48 390.62 145.9 390.62H150.29C152.12 390.62 153.875 391.347 155.169 392.641C156.463 393.935 157.19 395.69 157.19 397.52H128.9Z",
                fill: "#A37160"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M198.27 396.74H113.81V398.31H198.27V396.74Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M194.287 356.388L167.305 385.659L168.46 386.723L195.442 357.452L194.287 356.388Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M250.39 389.28L234.9 375.6C233.205 374.105 232.134 372.028 231.9 369.78C231.71 367.23 232.72 364.67 234.9 362.17C235.778 361.279 236.457 360.213 236.893 359.041C237.329 357.869 237.512 356.618 237.43 355.37C236.99 350.89 232.77 347.6 232.73 347.57L233.68 346.33C233.87 346.48 238.49 350.06 238.99 355.22C239.102 356.685 238.899 358.156 238.396 359.536C237.892 360.916 237.099 362.172 236.07 363.22C234.17 365.38 233.28 367.54 233.44 369.64C233.632 371.474 234.489 373.175 235.85 374.42L251.36 388.11L250.39 389.28Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M238.2 469.75H236.63V397.03C236.625 394.077 235.449 391.247 233.361 389.159C231.273 387.071 228.443 385.895 225.49 385.89H211.73V384.28H225.49C228.86 384.283 232.092 385.623 234.475 388.006C236.858 390.389 238.198 393.62 238.2 396.99V469.75Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M134.94 506.26C151.387 506.26 164.72 492.927 164.72 476.48C164.72 460.033 151.387 446.7 134.94 446.7C118.493 446.7 105.16 460.033 105.16 476.48C105.16 492.927 118.493 506.26 134.94 506.26Z",
                fill: "#408DBC"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M170.21 478.77C182.626 478.77 192.69 468.705 192.69 456.29C192.69 443.875 182.626 433.81 170.21 433.81C157.795 433.81 147.73 443.875 147.73 456.29C147.73 468.705 157.795 478.77 170.21 478.77Z",
                fill: "#70AACD"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M168.45 470.87V467.43H171.97V470.87H168.45ZM171.45 462.67H168.9L168.49 441.67H171.9L171.45 462.67Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M141.09 474.06L137.55 479.17C137.071 479.922 136.802 480.789 136.77 481.68V483.36H133.65V481.63C133.615 480.163 134.088 478.728 134.99 477.57L138.5 472.5C139.364 471.465 139.867 470.177 139.93 468.83C139.958 468.161 139.848 467.493 139.608 466.868C139.368 466.243 139.002 465.674 138.534 465.195C138.065 464.717 137.504 464.339 136.884 464.085C136.265 463.831 135.6 463.707 134.93 463.72C134.261 463.72 133.598 463.854 132.981 464.114C132.365 464.375 131.807 464.757 131.34 465.237C130.874 465.717 130.509 466.286 130.267 466.91C130.025 467.535 129.91 468.201 129.93 468.87H126.81C126.807 467.81 127.017 466.761 127.428 465.784C127.838 464.807 128.442 463.923 129.201 463.184C129.96 462.445 130.861 461.867 131.849 461.483C132.836 461.099 133.891 460.918 134.95 460.95C136.006 460.906 137.061 461.079 138.048 461.457C139.035 461.834 139.935 462.41 140.693 463.147C141.45 463.885 142.049 464.769 142.452 465.747C142.856 466.724 143.056 467.773 143.04 468.83C142.967 470.737 142.284 472.57 141.09 474.06ZM133.35 492.06V488.38H137.07V492.02L133.35 492.06Z",
                fill: "#70AACD"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M415.26 196.26C421.959 196.26 427.39 190.829 427.39 184.13C427.39 177.431 421.959 172 415.26 172C408.561 172 403.13 177.431 403.13 184.13C403.13 190.829 408.561 196.26 415.26 196.26Z",
                fill: "#FFD400"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M411.34 183.08C410.66 183.08 409.995 182.878 409.429 182.5C408.863 182.122 408.422 181.585 408.162 180.956C407.902 180.328 407.834 179.636 407.966 178.969C408.099 178.302 408.427 177.689 408.908 177.208C409.389 176.726 410.002 176.399 410.669 176.266C411.336 176.133 412.028 176.201 412.657 176.462C413.285 176.722 413.822 177.163 414.2 177.729C414.578 178.294 414.78 178.96 414.78 179.64C414.78 180.552 414.418 181.427 413.773 182.072C413.127 182.718 412.253 183.08 411.34 183.08ZM411.34 177.77C410.971 177.772 410.61 177.883 410.304 178.09C409.998 178.297 409.76 178.589 409.62 178.931C409.48 179.273 409.444 179.649 409.517 180.011C409.591 180.373 409.77 180.705 410.031 180.966C410.293 181.226 410.627 181.403 410.989 181.475C411.351 181.546 411.727 181.508 412.068 181.367C412.409 181.225 412.701 180.985 412.906 180.678C413.111 180.371 413.22 180.009 413.22 179.64C413.22 179.394 413.171 179.15 413.077 178.922C412.982 178.694 412.844 178.488 412.669 178.314C412.494 178.14 412.287 178.003 412.059 177.909C411.831 177.816 411.587 177.769 411.34 177.77Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M419.21 192.21C418.53 192.21 417.865 192.008 417.299 191.63C416.733 191.252 416.292 190.715 416.032 190.086C415.772 189.458 415.704 188.766 415.836 188.099C415.969 187.432 416.297 186.819 416.778 186.338C417.259 185.856 417.872 185.529 418.539 185.396C419.206 185.263 419.898 185.331 420.527 185.592C421.155 185.852 421.692 186.293 422.07 186.859C422.448 187.424 422.65 188.09 422.65 188.77C422.65 189.682 422.288 190.557 421.643 191.202C420.997 191.848 420.122 192.21 419.21 192.21ZM419.21 186.9C418.84 186.9 418.479 187.01 418.171 187.215C417.864 187.421 417.624 187.713 417.482 188.054C417.341 188.396 417.304 188.772 417.376 189.135C417.448 189.498 417.626 189.831 417.888 190.092C418.149 190.354 418.483 190.532 418.845 190.604C419.208 190.676 419.584 190.639 419.926 190.498C420.267 190.356 420.56 190.116 420.765 189.809C420.97 189.501 421.08 189.14 421.08 188.77C421.078 188.275 420.88 187.801 420.53 187.451C420.179 187.1 419.705 186.903 419.21 186.9Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M419.627 179.085L409.275 189.437L410.385 190.547L420.737 180.195L419.627 179.085Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M415.26 197.04C412.704 197.04 410.206 196.282 408.081 194.862C405.956 193.442 404.3 191.423 403.323 189.062C402.345 186.701 402.09 184.102 402.589 181.596C403.088 179.089 404.32 176.787 406.128 174.981C407.936 173.174 410.239 171.944 412.746 171.447C415.253 170.95 417.851 171.207 420.211 172.186C422.572 173.166 424.589 174.823 426.008 176.949C427.426 179.075 428.182 181.574 428.18 184.13C428.175 187.554 426.812 190.836 424.39 193.256C421.967 195.677 418.684 197.037 415.26 197.04ZM415.26 172.78C413.015 172.78 410.821 173.446 408.954 174.693C407.088 175.94 405.633 177.713 404.774 179.787C403.915 181.86 403.69 184.143 404.128 186.344C404.566 188.546 405.647 190.568 407.235 192.156C408.822 193.743 410.844 194.824 413.046 195.262C415.248 195.7 417.53 195.475 419.604 194.616C421.678 193.757 423.45 192.302 424.697 190.436C425.944 188.569 426.61 186.375 426.61 184.13C426.608 181.121 425.411 178.235 423.283 176.107C421.155 173.979 418.27 172.783 415.26 172.78Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M443.07 224.75C447.831 224.75 451.69 220.891 451.69 216.13C451.69 211.369 447.831 207.51 443.07 207.51C438.309 207.51 434.45 211.369 434.45 216.13C434.45 220.891 438.309 224.75 443.07 224.75Z",
                fill: "#E5E5E5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M443.07 225.53C441.211 225.53 439.394 224.979 437.848 223.946C436.302 222.913 435.097 221.445 434.386 219.727C433.674 218.01 433.488 216.12 433.851 214.296C434.213 212.473 435.109 210.798 436.423 209.483C437.738 208.169 439.413 207.273 441.236 206.911C443.06 206.548 444.95 206.734 446.667 207.446C448.385 208.157 449.853 209.362 450.886 210.908C451.919 212.453 452.47 214.271 452.47 216.13C452.47 218.623 451.48 221.014 449.717 222.777C447.954 224.54 445.563 225.53 443.07 225.53ZM443.07 208.3C441.522 208.3 440.008 208.759 438.72 209.62C437.432 210.48 436.429 211.703 435.836 213.134C435.244 214.564 435.088 216.139 435.391 217.658C435.693 219.176 436.438 220.572 437.533 221.667C438.629 222.762 440.024 223.507 441.543 223.81C443.061 224.112 444.636 223.957 446.067 223.364C447.497 222.771 448.72 221.768 449.581 220.48C450.441 219.192 450.9 217.679 450.9 216.13C450.901 215.1 450.7 214.081 450.307 213.129C449.914 212.177 449.338 211.312 448.611 210.583C447.884 209.854 447.02 209.276 446.07 208.881C445.119 208.485 444.1 208.281 443.07 208.28V208.3Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M603.07 379.8H518.79V381.37H603.07V379.8Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M443.42 216.79L442.34 215.66C446.87 211.364 450.262 206.011 452.212 200.08C454.163 194.15 454.611 187.828 453.515 181.682C452.42 175.536 449.816 169.758 445.936 164.867C442.057 159.975 437.024 156.123 431.29 153.657C425.555 151.19 419.297 150.186 413.078 150.734C406.859 151.283 400.874 153.366 395.659 156.798C390.444 160.23 386.163 164.903 383.2 170.398C380.236 175.893 378.683 182.037 378.68 188.28V204.61H365.9V203.04H377.09V188.28C377.088 181.776 378.702 175.373 381.785 169.646C384.869 163.92 389.326 159.048 394.757 155.47C400.188 151.891 406.423 149.717 412.902 149.143C419.38 148.568 425.9 149.612 431.876 152.179C437.852 154.747 443.097 158.758 447.14 163.853C451.183 168.948 453.897 174.967 455.04 181.37C456.182 187.773 455.716 194.359 453.685 200.538C451.653 206.717 448.119 212.294 443.4 216.77L443.42 216.79Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M207.44 203.76H158.05V205.33H207.44V203.76Z",
                fill: "#003C71"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-illustrations-virtual-f4c8d3dc38/1/packages/lib-illustrations/src/skipuleggja.tsx
/* eslint-disable max-len */ 

const SkipuleggjaIllustration = (param)=>{
    let { size =200  } = param;
    return /*#__PURE__*/ _jsxs("svg", {
        fill: "none",
        height: size,
        viewBox: "0 0 662 611",
        width: size,
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M120.15 67.76C55.9401 82.4 30.7001 149.3 55.0201 194.2C71.6301 224.86 102.71 254.63 159.92 270.2C307.77 310.38 248.92 419.9 386.17 487.51C448.1 522.91 536.69 509.67 536.69 509.67C536.69 509.67 551.06 383.31 547.12 310.9C462.29 295.83 409.58 249.45 364.12 187.46C318.66 125.47 258.96 36.14 120.15 67.76Z",
                fill: "#D9EEE8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M481.02 469.38C481.02 469.38 472.25 519.49 536.69 509.65C633.28 494.92 685.9 324.73 547.12 310.88C408.34 297.03 481.02 469.38 481.02 469.38Z",
                fill: "#D9EEE8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M527.88 555.45C467.37 564.56 414.28 549.45 378.5 533.84C333.75 514.3 305.67 489.72 305.39 489.47L307.29 487.32C307.57 487.56 335.37 511.89 379.74 531.25C420.61 549.09 484.33 566.25 555.74 546.62L556.5 549.38C547.089 551.969 537.532 553.996 527.88 555.45Z",
                fill: "#66A4C9"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M411.16 294.75C411.16 294.75 401.98 275.31 356.36 276.38C310.74 277.45 278.83 303.48 274.8 345.59C270.77 387.7 379.94 389.29 379.94 389.29L427.8 319.84L411.16 294.75Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M446.3 443.64L440.25 404.85H336.63V443.64H433.58H446.3Z",
                fill: "#A1D4C7"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M444.27 443.64H509.46C515.36 433.24 519.18 418.44 515.82 400.57L466.18 384.5C466.18 384.5 411.4 384.4 432.13 425.33C435.393 431.918 439.472 438.07 444.27 443.64Z",
                fill: "#A1D4C7"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M439.97 288.82C439.97 288.82 436.74 258.67 399.85 270.25C407.44 293.67 411.16 294.75 411.16 294.75L439.97 288.82Z",
                fill: "white"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M407.44 349.14C406.486 346.835 404.727 344.955 402.49 343.851C400.252 342.747 397.69 342.494 395.28 343.14C386.12 345.14 379.93 342.4 377.78 337.83C375.63 333.26 377.37 322.99 387.4 321.4C397.43 319.81 418.4 325.71 418.4 325.71V343.14L407.44 349.14Z",
                fill: "white"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M447.9 307.39C447.9 307.39 444.14 315.61 449.99 320.18C456.72 325.43 452.29 335.25 443.86 334.24C435.43 333.23 434.37 337.95 435.4 341.99C436.97 348.13 427.91 350.4 421.45 349.59C414.99 348.78 421.45 317.08 421.45 317.08L447.9 307.39Z",
                fill: "white"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M378.6 357.48C398.66 355.17 405.01 347.39 406.41 340.28C402.275 340.041 398.257 338.817 394.69 336.71C373.08 324.29 387.22 286.94 387.22 286.94C439.72 267.82 440.53 296.89 440.53 296.89C440.53 296.89 450.22 297.17 450.22 304.71C450.22 313.86 440.53 313.59 440.53 313.59C439.263 317.886 437.148 321.885 434.31 325.35C431.716 328.939 430.294 333.242 430.24 337.67C430.47 342.75 430.24 347.17 433.6 349.99C436.74 352.63 442.68 353.71 452.91 356.13C463.14 358.55 512.38 366.9 513.46 410.79H332.51C332.51 410.79 331.92 362.87 378.6 357.48Z",
                fill: "#F59795"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M398.51 300.99C398.51 300.99 397.11 300.49 395.68 302.83C393.68 306.12 390.62 312.62 391.68 316.56C392.62 320.19 400 321.15 404.74 317.68C407.1 315.95 406.47 312.23 402.74 312.18C399.37 312.14 400.48 301.68 398.51 300.99Z",
                fill: "#FBCCCB"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M407.44 305.65C408.556 305.65 409.46 304.746 409.46 303.63C409.46 302.514 408.556 301.61 407.44 301.61C406.325 301.61 405.42 302.514 405.42 303.63C405.42 304.746 406.325 305.65 407.44 305.65Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M386.25 305.65C387.366 305.65 388.27 304.746 388.27 303.63C388.27 302.514 387.366 301.61 386.25 301.61C385.135 301.61 384.23 302.514 384.23 303.63C384.23 304.746 385.135 305.65 386.25 305.65Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M435.06 281.29C423.88 283.63 425.57 298.05 440.51 296.89C442.883 296.807 445.218 297.51 447.15 298.89C447.15 298.89 451.41 277.85 435.06 281.29Z",
                fill: "white"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M419.46 280.48C411.2 280.81 407.46 284.48 400.93 289.92C393.36 296.26 383.14 299.06 376.93 294.48C370.72 289.9 373.44 280.65 384.75 280.48C371.82 280.96 372.09 262.76 394.44 265.59C416.79 268.42 419.46 280.48 419.46 280.48Z",
                fill: "white"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M433.6 292.21V289.14H436.42V293.23C439.71 294.51 444.23 296.56 440.53 296.87C435.08 297.32 434.67 301.05 437.75 307.92C438.299 309 438.639 310.174 438.75 311.38C438.743 311.777 438.587 312.158 438.313 312.446C438.039 312.734 437.667 312.909 437.271 312.937C436.874 312.964 436.482 312.842 436.171 312.595C435.86 312.347 435.653 311.993 435.59 311.6C435.109 308.644 433.825 305.877 431.88 303.6C427.38 298.32 433.6 292.21 433.6 292.21Z",
                fill: "white"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M380.76 356.14C386.437 355.567 392.008 354.221 397.32 352.14C397.32 352.14 413 371.57 435.92 351.52C452.461 353.754 468.614 358.263 483.92 364.92C518.25 380.14 517.08 410.85 517.08 410.85L373.72 421.28L320.14 410.79C336.52 375.77 347.81 360.01 380.76 356.14Z",
                fill: "#A1D4C7"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M402.01 331.72V328.85C406.85 328.85 410.84 327.44 413.87 324.65L415.81 326.76C413.35 329.03 408.96 331.72 402.01 331.72Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M240.5 443.64H418.31L414.72 430.71H240.5V443.64Z",
                fill: "#408DBC"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M327.82 340.79H211.96L240.5 443.64H356.36L327.82 340.79Z",
                fill: "#408DBC"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M517.82 423.27L514.96 423.04C516.89 399.04 507.63 380.62 487.44 368.3C477.79 362.564 467.155 358.677 456.08 356.84L456.44 354C457.11 354.08 522.6 363.24 517.82 423.27Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M407.5 315.64C405.489 315.64 403.522 315.044 401.85 313.926C400.178 312.809 398.874 311.22 398.104 309.362C397.335 307.504 397.133 305.459 397.526 303.486C397.918 301.513 398.887 299.701 400.309 298.279C401.731 296.856 403.543 295.888 405.516 295.495C407.489 295.103 409.534 295.304 411.392 296.074C413.25 296.844 414.839 298.147 415.956 299.82C417.074 301.492 417.67 303.459 417.67 305.47C417.668 308.166 416.595 310.752 414.688 312.658C412.782 314.565 410.197 315.637 407.5 315.64ZM407.5 298.17C406.056 298.17 404.645 298.598 403.444 299.4C402.244 300.202 401.308 301.343 400.756 302.676C400.203 304.01 400.059 305.478 400.34 306.894C400.622 308.31 401.317 309.611 402.338 310.632C403.359 311.653 404.66 312.348 406.076 312.63C407.492 312.911 408.96 312.767 410.294 312.214C411.628 311.662 412.768 310.726 413.57 309.526C414.372 308.325 414.8 306.914 414.8 305.47C414.803 304.509 414.616 303.557 414.25 302.669C413.885 301.78 413.348 300.972 412.67 300.292C411.992 299.611 411.186 299.07 410.299 298.701C409.412 298.332 408.461 298.141 407.5 298.14V298.17Z",
                fill: "white"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M384.12 315.64C382.109 315.64 380.142 315.044 378.47 313.926C376.798 312.809 375.494 311.22 374.724 309.362C373.955 307.504 373.753 305.459 374.146 303.486C374.538 301.513 375.507 299.701 376.929 298.279C378.351 296.856 380.163 295.888 382.136 295.495C384.109 295.103 386.154 295.304 388.012 296.074C389.87 296.844 391.459 298.147 392.576 299.82C393.694 301.492 394.29 303.459 394.29 305.47C394.287 308.166 393.215 310.752 391.308 312.658C389.402 314.565 386.817 315.637 384.12 315.64ZM384.12 298.17C382.676 298.17 381.265 298.598 380.064 299.4C378.864 300.202 377.928 301.343 377.376 302.676C376.823 304.01 376.679 305.478 376.96 306.894C377.242 308.31 377.937 309.611 378.958 310.632C379.979 311.653 381.28 312.348 382.696 312.63C384.112 312.911 385.58 312.767 386.914 312.214C388.248 311.662 389.388 310.726 390.19 309.526C390.992 308.325 391.42 306.914 391.42 305.47C391.423 303.53 390.656 301.669 389.287 300.295C387.918 298.92 386.06 298.145 384.12 298.14V298.17Z",
                fill: "white"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M433.58 304.04H416.23V306.91H433.58V304.04Z",
                fill: "white"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M415.35 361.44C409.49 361.44 402.73 359.49 396.35 353.1L398.35 351.1C411.66 364.34 426.61 356.34 429.46 354.6L430.24 355.8L430.96 357.05C426.227 359.845 420.847 361.358 415.35 361.44Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M439.08 362.83C441.378 362.83 443.24 360.968 443.24 358.67C443.24 356.373 441.378 354.51 439.08 354.51C436.783 354.51 434.92 356.373 434.92 358.67C434.92 360.968 436.783 362.83 439.08 362.83Z",
                fill: "#80C5B3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M430.22 369.02C432.518 369.02 434.38 367.158 434.38 364.86C434.38 362.563 432.518 360.7 430.22 360.7C427.923 360.7 426.06 362.563 426.06 364.86C426.06 367.158 427.923 369.02 430.22 369.02Z",
                fill: "#80C5B3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M418.57 372.11C420.868 372.11 422.73 370.248 422.73 367.95C422.73 365.653 420.868 363.79 418.57 363.79C416.273 363.79 414.41 365.653 414.41 367.95C414.41 370.248 416.273 372.11 418.57 372.11Z",
                fill: "#80C5B3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M406.17 371.14C408.468 371.14 410.33 369.278 410.33 366.98C410.33 364.683 408.468 362.82 406.17 362.82C403.873 362.82 402.01 364.683 402.01 366.98C402.01 369.278 403.873 371.14 406.17 371.14Z",
                fill: "#80C5B3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M394.67 365.89C396.968 365.89 398.83 364.028 398.83 361.73C398.83 359.433 396.968 357.57 394.67 357.57C392.373 357.57 390.51 359.433 390.51 361.73C390.51 364.028 392.373 365.89 394.67 365.89Z",
                fill: "#80C5B3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M389.42 357.41C391.718 357.41 393.58 355.548 393.58 353.25C393.58 350.952 391.718 349.09 389.42 349.09C387.123 349.09 385.26 350.952 385.26 353.25C385.26 355.548 387.123 357.41 389.42 357.41Z",
                fill: "#80C5B3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M443.49 353.91C445.788 353.91 447.65 352.048 447.65 349.75C447.65 347.452 445.788 345.59 443.49 345.59C441.193 345.59 439.33 347.452 439.33 349.75C439.33 352.048 441.193 353.91 443.49 353.91Z",
                fill: "#80C5B3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M283.83 196.2V160.2C283.83 159.044 283.371 157.935 282.553 157.117C281.735 156.299 280.626 155.84 279.47 155.84H184.35C183.194 155.84 182.085 156.299 181.267 157.117C180.449 157.935 179.99 159.044 179.99 160.2V188.62C179.99 189.776 180.449 190.885 181.267 191.703C182.085 192.521 183.194 192.98 184.35 192.98H266.78C267.751 192.977 268.695 193.301 269.46 193.9L276.79 199.61C277.432 200.11 278.202 200.421 279.011 200.507C279.821 200.593 280.638 200.45 281.371 200.095C282.104 199.74 282.722 199.187 283.157 198.499C283.591 197.81 283.825 197.014 283.83 196.2Z",
                fill: "#0067A5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M217.54 164.93H189.61V167.8H217.54V164.93Z",
                fill: "white"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M243.52 174.61H189.61V177.48H243.52V174.61Z",
                fill: "white"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M121.6 258.14V222.14C121.603 220.983 122.064 219.874 122.884 219.056C123.703 218.239 124.813 217.78 125.97 217.78H221.09C221.663 217.78 222.23 217.893 222.759 218.112C223.288 218.331 223.768 218.652 224.173 219.057C224.578 219.462 224.899 219.943 225.118 220.472C225.337 221.001 225.45 221.567 225.45 222.14V250.56C225.45 251.133 225.337 251.7 225.118 252.229C224.899 252.758 224.578 253.238 224.173 253.643C223.768 254.048 223.288 254.369 222.759 254.588C222.23 254.807 221.663 254.92 221.09 254.92H138.6C137.63 254.924 136.688 255.247 135.92 255.84L128.6 261.56C127.957 262.049 127.191 262.35 126.387 262.429C125.582 262.509 124.772 262.363 124.046 262.008C123.32 261.653 122.707 261.104 122.275 260.421C121.843 259.738 121.609 258.948 121.6 258.14Z",
                fill: "white"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M125.95 263.93C124.413 263.922 122.94 263.307 121.854 262.219C120.768 261.131 120.155 259.658 120.15 258.12V222.14C120.153 220.604 120.765 219.131 121.852 218.045C122.94 216.96 124.414 216.35 125.95 216.35H221.07C222.605 216.353 224.076 216.964 225.161 218.049C226.247 219.134 226.857 220.605 226.86 222.14V250.56C226.86 252.097 226.25 253.57 225.165 254.658C224.079 255.745 222.607 256.357 221.07 256.36H138.6C137.949 256.366 137.317 256.583 136.8 256.98L129.48 262.69C128.473 263.482 127.231 263.918 125.95 263.93ZM125.95 219.23C125.175 219.23 124.431 219.537 123.882 220.085C123.333 220.632 123.023 221.375 123.02 222.15V258.15C123.02 258.699 123.175 259.236 123.465 259.701C123.756 260.166 124.172 260.54 124.664 260.781C125.157 261.022 125.708 261.119 126.253 261.062C126.799 261.006 127.317 260.797 127.75 260.46L135.07 254.75C136.089 253.961 137.341 253.532 138.63 253.53H221.07C221.845 253.527 222.588 253.218 223.135 252.668C223.683 252.119 223.99 251.375 223.99 250.6V222.14C223.99 221.366 223.682 220.623 223.135 220.075C222.587 219.528 221.845 219.22 221.07 219.22L125.95 219.23Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M215.81 226.86H187.88V229.73H215.81V226.86Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M215.81 236.54H161.9V239.41H215.81V236.54Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M203.07 333.51C218.385 333.51 230.8 321.095 230.8 305.78C230.8 290.465 218.385 278.05 203.07 278.05C187.755 278.05 175.34 290.465 175.34 305.78C175.34 321.095 187.755 333.51 203.07 333.51Z",
                fill: "#A1D4C7"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M203.07 324.79C213.442 324.79 221.85 316.382 221.85 306.01C221.85 295.638 213.442 287.23 203.07 287.23C192.698 287.23 184.29 295.638 184.29 306.01C184.29 316.382 192.698 324.79 203.07 324.79Z",
                fill: "white"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M203.07 313.93C202.83 313.929 202.593 313.868 202.382 313.753C202.17 313.638 201.991 313.472 201.86 313.27L191.65 297.39L194.06 295.84L202.92 309.61L216.92 281.91L219.48 283.2L204.35 313.14C204.236 313.367 204.064 313.559 203.851 313.698C203.639 313.837 203.394 313.917 203.14 313.93H203.07Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M379.94 392.96H468.35C468.35 392.96 476.69 407.2 468.35 418.32C460.01 429.44 416.93 405.64 416.93 405.64L405.19 410.57C403.429 411.313 401.456 411.377 399.65 410.75L399.2 410.6C398.045 410.199 397 409.532 396.151 408.652C395.301 407.772 394.671 406.705 394.312 405.536C393.952 404.367 393.874 403.13 394.082 401.925C394.29 400.72 394.779 399.581 395.51 398.6C395.51 398.6 383.27 400.25 379.94 392.96Z",
                fill: "#FBCCCB"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M455.36 348.9C455.36 348.9 446.56 379.97 465.49 386.24C465.49 386.24 475.62 387.99 487.07 377.48C487.07 377.48 497.64 375.79 497.64 368.74C497.64 361.69 489.27 361.69 489.27 361.69L490.6 348.9H455.36Z",
                fill: "#FBCCCB"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M454.75 358.23C454.75 358.23 442.24 371.71 454.08 372.23C465.92 372.75 461.97 361.71 461.97 361.71L454.75 358.23Z",
                fill: "#FBCCCB"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M470.39 379.59L466.69 407.14L495.46 393.38C495.46 393.38 488.37 370.27 484.2 367.64C480.03 365.01 470.39 379.59 470.39 379.59Z",
                fill: "#FBCCCB"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M448.6 338.79C448.6 338.79 451.39 352.44 466.36 352.44C481.33 352.44 489.7 355.53 489.26 361.69C496.71 365.22 494.58 370.87 489.26 372.22C489.26 372.22 484.18 383.05 493.09 386.22C493.09 386.22 498.49 375.69 504.21 372.22C509.93 368.75 517.42 345.84 497.61 337.03C475.48 317.96 448.6 338.79 448.6 338.79Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M493.12 386.24C493.12 386.24 519.79 407.12 519.79 443.64H448.6C456.25 428.49 440.65 416.59 440.65 416.59C440.65 416.59 458.33 414 450.41 392.96L493.12 386.24Z",
                fill: "white"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M521.23 443.64H518.36C518.36 421.13 508.21 404.64 499.69 394.79L501.87 392.92C510.7 403.14 521.23 420.25 521.23 443.64Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M440.81 418.01L440.52 415.16L440.66 416.59L440.51 415.16C440.89 415.16 449.81 414.06 450.9 404.68L453.75 405.01C452.38 416.71 440.92 418 440.81 418.01Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M460.59 363.75C461.706 363.75 462.61 362.846 462.61 361.73C462.61 360.614 461.706 359.71 460.59 359.71C459.475 359.71 458.57 360.614 458.57 361.73C458.57 362.846 459.475 363.75 460.59 363.75Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M303.2 244.46C303.2 244.46 302.63 289.84 320.14 301.61C332.51 307.39 350.59 289.92 350.59 289.92L356.36 280.43C356.36 280.43 367.82 274.58 367.82 267.6C367.82 260.62 357.05 257.39 352.74 261.16L344.66 241.77L303.2 244.46Z",
                fill: "#F59795"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M326.89 296.74V328C326.89 328 359.61 328.2 359.61 303.63V267.63L329.41 272.31L326.89 296.74Z",
                fill: "#F59795"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M295.6 250.79C295.6 250.79 301.88 258.46 312.79 253.62C323.7 248.78 328.07 246.74 332.54 253.01C337.01 259.28 345.9 266.27 352.77 261.16C359.64 256.05 368.93 263.79 367.85 267.6C376.99 265.24 376.6 253.6 370.14 245.54C363.68 237.48 367.71 230.19 359.64 222.54C351.57 214.89 338.01 213.66 329.44 219.31C320.87 224.96 312.8 225.77 305.92 225.77C293.5 225.75 286.28 237.87 295.6 250.79Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M320.77 271.37C320.571 271.053 320.282 270.803 319.94 270.652C319.598 270.501 319.218 270.455 318.85 270.52C318.482 270.586 318.141 270.76 317.872 271.02C317.603 271.28 317.418 271.614 317.34 271.98C316.39 276.61 315.53 283.41 318.41 284.71C321.55 286.14 324.48 283.79 325.94 282.28C326.224 281.978 326.4 281.59 326.44 281.178C326.48 280.765 326.381 280.351 326.16 280L320.77 271.37Z",
                fill: "#FBCCCB"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M328.33 317.83H325.46V335.11H328.33V317.83Z",
                fill: "white"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M361.04 296.74H358.17V335.11H361.04V296.74Z",
                fill: "white"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M542.7 442.2H214.59V445.07H542.7V442.2Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M328.91 270.49C330.026 270.49 330.93 269.586 330.93 268.47C330.93 267.354 330.026 266.45 328.91 266.45C327.795 266.45 326.89 267.354 326.89 268.47C326.89 269.586 327.795 270.49 328.91 270.49Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M310.81 270.49C311.926 270.49 312.83 269.586 312.83 268.47C312.83 267.354 311.926 266.45 310.81 266.45C309.695 266.45 308.79 267.354 308.79 268.47C308.79 269.586 309.695 270.49 310.81 270.49Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M323.81 294.01L323.48 291.16C323.55 291.16 330.48 290.27 334.31 284.37L336.71 285.94C335.228 288.097 333.318 289.927 331.098 291.315C328.879 292.703 326.399 293.621 323.81 294.01Z",
                fill: "#003C71"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-illustrations-virtual-f4c8d3dc38/1/packages/lib-illustrations/src/stafraent.tsx
/* eslint-disable max-len */ 

const StafraentIllustration = (param)=>{
    let { size =200  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        fill: "none",
        height: size,
        viewBox: "0 0 662 611",
        width: size,
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M436.38 184.01C477.437 184.01 510.72 150.727 510.72 109.67C510.72 68.6132 477.437 35.33 436.38 35.33C395.323 35.33 362.04 68.6132 362.04 109.67C362.04 150.727 395.323 184.01 436.38 184.01Z",
                fill: "#E5E5E5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M400.88 322.06H218.31C208.629 322.06 200.78 329.908 200.78 339.59V463.35C200.78 473.032 208.629 480.88 218.31 480.88H400.88C410.562 480.88 418.41 473.032 418.41 463.35V339.59C418.41 329.908 410.562 322.06 400.88 322.06Z",
                fill: "#82B5D3"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M395.37 331.45H224.5C222.719 331.449 220.956 331.798 219.31 332.478C217.664 333.159 216.169 334.156 214.909 335.415C213.649 336.673 212.649 338.167 211.966 339.812C211.283 341.456 210.931 343.219 210.93 345V455.17C210.93 459.414 212.616 463.483 215.616 466.484C218.617 469.484 222.687 471.17 226.93 471.17H393.27C397.514 471.17 401.583 469.484 404.584 466.484C407.584 463.483 409.27 459.414 409.27 455.17V345.32C409.27 343.496 408.91 341.69 408.211 340.005C407.513 338.321 406.488 336.79 405.197 335.502C403.906 334.213 402.373 333.192 400.687 332.497C399.001 331.802 397.194 331.446 395.37 331.45Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M395.37 331.45H341.01L251.34 471.15H393.27C397.514 471.15 401.583 469.464 404.584 466.464C407.584 463.463 409.27 459.393 409.27 455.15V345.32C409.27 343.496 408.91 341.69 408.211 340.005C407.513 338.321 406.488 336.79 405.197 335.502C403.906 334.213 402.373 333.192 400.687 332.497C399.001 331.802 397.194 331.446 395.37 331.45Z",
                fill: "#E5F0F6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M373.3 350.1H336.35C333.423 350.1 331.05 352.473 331.05 355.4V384.59C331.05 387.517 333.423 389.89 336.35 389.89H373.3C376.227 389.89 378.6 387.517 378.6 384.59V355.4C378.6 352.473 376.227 350.1 373.3 350.1Z",
                fill: "#408DBC"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M385.21 209H300.28C297.047 209 293.947 210.284 291.66 212.57C289.374 214.856 288.09 217.957 288.09 221.19V288.28C288.09 291.513 289.374 294.614 291.66 296.9C293.947 299.186 297.047 300.47 300.28 300.47H385.21C386.811 300.47 388.396 300.155 389.875 299.542C391.354 298.929 392.698 298.032 393.83 296.9C394.962 295.768 395.86 294.424 396.472 292.945C397.085 291.466 397.4 289.881 397.4 288.28V221.18C397.397 217.949 396.112 214.851 393.826 212.567C391.54 210.283 388.441 209 385.21 209Z",
                fill: "#FFD400"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M211.03 382.34C223.19 382.92 223.2 401.88 218.03 430.86C226.35 467.93 216.75 492.5 198.81 503.38L186 564.63L131.6 542.45C131.6 542.45 176.45 370 188.6 335.8C188.6 335.8 205.25 327.26 198.84 368.25C192.43 409.24 198.84 414.36 198.84 414.36C198.84 414.36 197.6 381.7 211.03 382.34Z",
                fill: "#F59795"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M204.31 395.47L216.8 397.39C216.8 397.39 216.52 386.58 210.6 386C204.68 385.42 204.31 395.47 204.31 395.47Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M516.22 532C501.97 504 469.17 469.46 469.17 469.46C469.17 469.46 463.06 415.66 441.64 403.86C424.22 394.25 402.22 394.95 389.41 401.36C389.41 401.36 374.47 375.74 368.06 371.47C361.65 367.2 347.14 370.28 369.35 409.9C377.46 423.62 379.59 430.39 379.59 430.39C379.59 430.39 366.04 411.5 354.83 426.23C354.83 426.23 371.34 475.47 416.43 499.85C426.19 520.31 431.43 537.01 444.28 562.39L516.22 532Z",
                fill: "#F59795"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M372.47 381.35L362.6 386.48C362.6 386.48 356.9 376.96 363.25 374.23C367.82 372.28 372.47 381.35 372.47 381.35Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M285.28 436.58H255.65C251.634 436.581 247.77 435.046 244.85 432.288C241.931 429.53 240.177 425.76 239.95 421.75L238.48 399.93H302.48L301 421.75C300.773 425.763 299.016 429.536 296.093 432.295C293.169 435.053 289.3 436.586 285.28 436.58Z",
                fill: "#FFD400"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M292.68 399.93H287.68V388.41C287.68 387.63 287.37 386.883 286.819 386.331C286.268 385.78 285.52 385.47 284.74 385.47H256.6C255.82 385.47 255.073 385.78 254.521 386.331C253.97 386.883 253.66 387.63 253.66 388.41V399.93H248.66V388.41C248.676 386.309 249.517 384.299 251.003 382.813C252.489 381.327 254.499 380.486 256.6 380.47H284.79C286.891 380.486 288.902 381.327 290.387 382.813C291.873 384.299 292.714 386.309 292.73 388.41L292.68 399.93Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M268.31 437.58H255.65C251.38 437.577 247.273 435.943 244.169 433.011C241.064 430.08 239.198 426.073 238.95 421.81L237.41 398.93H302.41V400.93H239.6L241 421.68C241.212 425.436 242.853 428.968 245.586 431.553C248.32 434.137 251.938 435.578 255.7 435.58H268.36L268.31 437.58Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M268.192 399.221L252.007 415.407L253.421 416.821L269.606 400.635L268.192 399.221Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M283.786 399.227L267.607 415.406L269.022 416.82L285.2 400.641L283.786 399.227Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M299.401 399.212L283.215 415.398L284.63 416.812L300.815 400.627L299.401 399.212Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M271.6 370.38L269.73 369.67C273.52 359.67 279.63 352.92 287.87 349.57C303.47 343.25 321.01 351.31 321.75 351.65L320.9 353.46C320.73 353.38 303.39 345.46 288.61 351.46C280.89 354.56 275.17 360.93 271.6 370.38Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M268.12 365.72L268.94 370.66C268.98 370.908 269.08 371.143 269.231 371.344C269.382 371.545 269.581 371.706 269.809 371.813C270.037 371.919 270.287 371.968 270.538 371.956C270.79 371.943 271.034 371.869 271.25 371.74L275.53 369.21C275.771 369.067 275.969 368.861 276.102 368.614C276.236 368.368 276.3 368.089 276.287 367.809C276.275 367.529 276.187 367.257 276.033 367.023C275.878 366.789 275.663 366.601 275.41 366.48L270.31 364.07C270.055 363.95 269.772 363.902 269.491 363.931C269.21 363.96 268.943 364.065 268.718 364.235C268.492 364.404 268.317 364.632 268.212 364.894C268.107 365.156 268.075 365.442 268.12 365.72Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M199.6 442.56C199.35 440.7 193.67 396.83 204.31 384.56C205.127 383.552 206.157 382.737 207.325 382.173C208.494 381.61 209.773 381.311 211.07 381.3V383.3C210.057 383.31 209.059 383.545 208.149 383.99C207.239 384.435 206.44 385.077 205.81 385.87C195.76 397.42 201.51 441.81 201.57 442.25L199.6 442.56Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M186.42 505.72L186.23 503.72C197.14 502.65 205.54 498.1 211.17 490.19C226.05 469.28 217.17 431.46 217.1 431.08L219.05 430.62C220.621 437.886 221.531 445.28 221.77 452.71C222.14 464.07 220.87 480.01 212.77 491.35C206.81 499.76 197.94 504.59 186.42 505.72Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M181.276 355.674L130.662 542.22L132.592 542.743L183.206 356.198L181.276 355.674Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M385.23 441.43C385.1 441.18 371.91 416.43 361.37 396.24C356.72 387.36 355.22 380.16 356.91 374.84C357.505 372.639 358.904 370.74 360.83 369.52L361.75 371.3C361.67 371.35 353.15 376.2 363.14 395.3C373.67 415.45 386.86 440.23 386.99 440.48L385.23 441.43Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M415.96 500.73C377.7 480.04 361.32 443.19 361.16 442.83L362.99 442.03C363.15 442.39 379.28 478.62 416.91 498.97L415.96 500.73Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M385.602 393.149L383.908 394.213L399.328 418.785L401.022 417.722L385.602 393.149Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M410.057 396.838L408.427 397.997L417.721 411.07L419.351 409.911L410.057 396.838Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M413.89 385.55H389.26V383.55H413.89C423.322 383.55 432.661 381.692 441.374 378.083C450.088 374.474 458.005 369.184 464.675 362.514C471.344 355.845 476.634 347.928 480.243 339.214C483.852 330.501 485.71 321.162 485.71 311.73C485.71 302.299 483.852 292.959 480.243 284.246C476.634 275.532 471.344 267.615 464.675 260.946C458.005 254.277 450.088 248.986 441.374 245.377C432.661 241.768 423.322 239.91 413.89 239.91V237.91C433.468 237.91 452.245 245.687 466.089 259.531C479.933 273.375 487.71 292.152 487.71 311.73C487.71 331.308 479.933 350.085 466.089 363.929C452.245 377.773 433.468 385.55 413.89 385.55Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M412.68 243.07C414.978 243.07 416.84 241.208 416.84 238.91C416.84 236.612 414.978 234.75 412.68 234.75C410.383 234.75 408.52 236.612 408.52 238.91C408.52 241.208 410.383 243.07 412.68 243.07Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M365.49 90.4C367.788 90.4 369.65 88.5375 369.65 86.24C369.65 83.9425 367.788 82.08 365.49 82.08C363.193 82.08 361.33 83.9425 361.33 86.24C361.33 88.5375 363.193 90.4 365.49 90.4Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M486.79 314.18C489.088 314.18 490.95 312.317 490.95 310.02C490.95 307.722 489.088 305.86 486.79 305.86C484.493 305.86 482.63 307.722 482.63 310.02C482.63 312.317 484.493 314.18 486.79 314.18Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M432.66 157.53H424.13V115.84L448.6 81.71V141.57C448.59 145.796 446.907 149.847 443.921 152.837C440.935 155.827 436.886 157.514 432.66 157.53Z",
                fill: "#FF7D20"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M411.71 138.85L406.71 135.53L461.32 53.27L483.39 45.55C483.914 47.0512 483.821 48.699 483.131 50.1315C482.441 51.564 481.211 52.6641 479.71 53.19L465.21 58.27L411.71 138.85Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M350.6 157.53H424.09V128.84H407.24L398.67 132.84C398.67 132.84 361.9 134.16 350.6 157.53Z",
                fill: "#3D8CBB"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M363.85 143.19H398.23V132.8C398.23 132.8 382.12 131.94 363.85 143.19Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M443.39 128.84H429.36C428.62 128.84 428.02 129.44 428.02 130.18V130.19C428.02 130.93 428.62 131.53 429.36 131.53H443.39C444.13 131.53 444.73 130.93 444.73 130.19V130.18C444.73 129.44 444.13 128.84 443.39 128.84Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M443.39 134.42H429.36C428.62 134.42 428.02 135.02 428.02 135.76V135.77C428.02 136.51 428.62 137.11 429.36 137.11H443.39C444.13 137.11 444.73 136.51 444.73 135.77V135.76C444.73 135.02 444.13 134.42 443.39 134.42Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M443.39 140H429.36C428.62 140 428.02 140.6 428.02 141.34V141.35C428.02 142.09 428.62 142.69 429.36 142.69H443.39C444.13 142.69 444.73 142.09 444.73 141.35V141.34C444.73 140.6 444.13 140 443.39 140Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M428.31 113.89H417.09V119.62H428.31V113.89Z",
                fill: "#3D8CBB"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M444.73 89.33H433.51V95.06H444.73V89.33Z",
                fill: "#3D8CBB"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M461.16 64.78H449.94V70.51H461.16V64.78Z",
                fill: "#3D8CBB"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M415.12 166.26C421.808 166.26 427.23 160.838 427.23 154.15C427.23 147.462 421.808 142.04 415.12 142.04C408.432 142.04 403.01 147.462 403.01 154.15C403.01 160.838 408.432 166.26 415.12 166.26Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M415.12 157.3C416.705 157.3 417.99 156.015 417.99 154.43C417.99 152.845 416.705 151.56 415.12 151.56C413.535 151.56 412.25 152.845 412.25 154.43C412.25 156.015 413.535 157.3 415.12 157.3Z",
                fill: "#3D8CBB"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M369.79 166.26C374.739 166.26 378.75 162.249 378.75 157.3C378.75 152.352 374.739 148.34 369.79 148.34C364.842 148.34 360.83 152.352 360.83 157.3C360.83 162.249 364.842 166.26 369.79 166.26Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M369.79 160.17C371.375 160.17 372.66 158.885 372.66 157.3C372.66 155.715 371.375 154.43 369.79 154.43C368.205 154.43 366.92 155.715 366.92 157.3C366.92 158.885 368.205 160.17 369.79 160.17Z",
                fill: "#3D8CBB"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M325.36 139.11H323.36V193.51H325.36V139.11Z",
                fill: "#59B49C"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M331.69 139.11H329.69V193.51H331.69V139.11Z",
                fill: "#59B49C"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M338.02 139.11H336.02V193.51H338.02V139.11Z",
                fill: "#59B49C"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M344.34 139.11H342.34V193.51H344.34V139.11Z",
                fill: "#59B49C"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M350.67 139.11H348.67V193.51H350.67V139.11Z",
                fill: "#59B49C"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M357 162.17H355V168.26H357V162.17Z",
                fill: "#59B49C"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M363.32 162.17H361.32V168.26H363.32V162.17Z",
                fill: "#59B49C"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M369.65 162.17H367.65V168.26H369.65V162.17Z",
                fill: "#59B49C"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M375.98 162.17H373.98V168.26H375.98V162.17Z",
                fill: "#59B49C"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M382.3 162.17H380.3V168.26H382.3V162.17Z",
                fill: "#59B49C"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M388.63 162.17H386.63V168.26H388.63V162.17Z",
                fill: "#59B49C"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M394.95 162.17H392.95V168.26H394.95V162.17Z",
                fill: "#59B49C"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M401.28 162.17H399.28V168.26H401.28V162.17Z",
                fill: "#59B49C"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M407.61 162.17H405.61V168.26H407.61V162.17Z",
                fill: "#59B49C"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M413.93 162.17H411.93V168.26H413.93V162.17Z",
                fill: "#59B49C"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M420.26 162.17H418.26V168.26H420.26V162.17Z",
                fill: "#59B49C"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M426.59 162.17H424.59V168.26H426.59V162.17Z",
                fill: "#59B49C"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M432.91 162.17H430.91V168.26H432.91V162.17Z",
                fill: "#59B49C"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M439.24 162.17H437.24V168.26H439.24V162.17Z",
                fill: "#59B49C"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M445.57 162.17H443.57V168.26H445.57V162.17Z",
                fill: "#59B49C"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M451.89 162.17H449.89V168.26H451.89V162.17Z",
                fill: "#59B49C"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M458.22 162.17H456.22V168.26H458.22V162.17Z",
                fill: "#59B49C"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M464.55 162.17H462.55V168.26H464.55V162.17Z",
                fill: "#59B49C"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M360.16 170.8H358.16V176.89H360.16V170.8Z",
                fill: "#59B49C"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M366.49 170.8H364.49V176.89H366.49V170.8Z",
                fill: "#59B49C"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M372.81 170.8H370.81V176.89H372.81V170.8Z",
                fill: "#59B49C"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M379.14 170.8H377.14V176.89H379.14V170.8Z",
                fill: "#59B49C"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M385.47 170.8H383.47V176.89H385.47V170.8Z",
                fill: "#59B49C"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M391.79 170.8H389.79V176.89H391.79V170.8Z",
                fill: "#59B49C"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M398.12 170.8H396.12V176.89H398.12V170.8Z",
                fill: "#59B49C"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M404.45 170.8H402.45V176.89H404.45V170.8Z",
                fill: "#59B49C"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M410.77 170.8H408.77V176.89H410.77V170.8Z",
                fill: "#59B49C"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M417.1 170.8H415.1V176.89H417.1V170.8Z",
                fill: "#59B49C"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M423.42 170.8H421.42V176.89H423.42V170.8Z",
                fill: "#59B49C"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M429.75 170.8H427.75V176.89H429.75V170.8Z",
                fill: "#59B49C"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M436.08 170.8H434.08V176.89H436.08V170.8Z",
                fill: "#59B49C"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M442.4 170.8H440.4V176.89H442.4V170.8Z",
                fill: "#59B49C"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M448.73 170.8H446.73V176.89H448.73V170.8Z",
                fill: "#59B49C"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M455.06 170.8H453.06V176.89H455.06V170.8Z",
                fill: "#59B49C"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M461.38 170.8H459.38V176.89H461.38V170.8Z",
                fill: "#59B49C"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M467.71 170.8H465.71V176.89H467.71V170.8Z",
                fill: "#59B49C"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M357 178.79H355V184.88H357V178.79Z",
                fill: "#59B49C"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M363.32 178.79H361.32V184.88H363.32V178.79Z",
                fill: "#59B49C"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M369.65 178.79H367.65V184.88H369.65V178.79Z",
                fill: "#59B49C"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M375.98 178.79H373.98V184.88H375.98V178.79Z",
                fill: "#59B49C"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M382.3 178.79H380.3V184.88H382.3V178.79Z",
                fill: "#59B49C"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M388.63 178.79H386.63V184.88H388.63V178.79Z",
                fill: "#59B49C"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M394.95 178.79H392.95V184.88H394.95V178.79Z",
                fill: "#59B49C"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M401.28 178.79H399.28V184.88H401.28V178.79Z",
                fill: "#59B49C"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M407.61 178.79H405.61V184.88H407.61V178.79Z",
                fill: "#59B49C"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M413.93 178.79H411.93V184.88H413.93V178.79Z",
                fill: "#59B49C"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M420.26 178.79H418.26V184.88H420.26V178.79Z",
                fill: "#59B49C"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M426.59 178.79H424.59V184.88H426.59V178.79Z",
                fill: "#59B49C"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M432.91 178.79H430.91V184.88H432.91V178.79Z",
                fill: "#59B49C"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M439.24 178.79H437.24V184.88H439.24V178.79Z",
                fill: "#59B49C"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M445.57 178.79H443.57V184.88H445.57V178.79Z",
                fill: "#59B49C"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M451.89 178.79H449.89V184.88H451.89V178.79Z",
                fill: "#59B49C"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M458.22 178.79H456.22V184.88H458.22V178.79Z",
                fill: "#59B49C"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M464.55 178.79H462.55V184.88H464.55V178.79Z",
                fill: "#59B49C"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M360.16 187.43H358.16V193.52H360.16V187.43Z",
                fill: "#59B49C"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M366.49 187.43H364.49V193.52H366.49V187.43Z",
                fill: "#59B49C"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M372.81 187.43H370.81V193.52H372.81V187.43Z",
                fill: "#59B49C"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M379.14 187.43H377.14V193.52H379.14V187.43Z",
                fill: "#59B49C"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M385.47 187.43H383.47V193.52H385.47V187.43Z",
                fill: "#59B49C"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M391.79 187.43H389.79V193.52H391.79V187.43Z",
                fill: "#59B49C"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M398.12 187.43H396.12V193.52H398.12V187.43Z",
                fill: "#59B49C"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M404.45 187.43H402.45V193.52H404.45V187.43Z",
                fill: "#59B49C"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M410.77 187.43H408.77V193.52H410.77V187.43Z",
                fill: "#59B49C"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M417.1 187.43H415.1V193.52H417.1V187.43Z",
                fill: "#59B49C"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M423.42 187.43H421.42V193.52H423.42V187.43Z",
                fill: "#59B49C"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M429.75 187.43H427.75V193.52H429.75V187.43Z",
                fill: "#59B49C"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M436.08 187.43H434.08V193.52H436.08V187.43Z",
                fill: "#59B49C"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M442.4 187.43H440.4V193.52H442.4V187.43Z",
                fill: "#59B49C"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M448.73 187.43H446.73V193.52H448.73V187.43Z",
                fill: "#59B49C"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M455.06 187.43H453.06V193.52H455.06V187.43Z",
                fill: "#59B49C"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M461.38 187.43H459.38V193.52H461.38V187.43Z",
                fill: "#59B49C"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M467.71 187.43H465.71V193.52H467.71V187.43Z",
                fill: "#59B49C"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M345.34 264.57C336.99 261.5 333.78 256.71 332.55 253.24C331.68 250.804 331.476 248.181 331.96 245.64L333.96 245.98V246.06C333.55 247.94 332.23 257.6 346.07 262.69L345.34 264.57Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M348.27 260.23C348.27 260.23 323.12 275 327.36 288.66C327.755 289.722 328.394 290.675 329.226 291.443C330.059 292.211 331.06 292.772 332.15 293.08C333.95 293.58 335.86 293.14 336.54 291.39C336.79 290.789 336.844 290.125 336.695 289.491C336.546 288.857 336.201 288.287 335.71 287.86C334.05 286.48 332.37 283.78 336.31 279.64C342.37 273.27 352.31 265.92 352.31 265.92L348.27 260.23Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M350.72 240C350.72 240 340.35 231 328.87 240.95C317.39 250.9 308.09 249.81 303.37 250.14C300.17 250.36 297.84 252.88 297.27 256.59C297.167 257.317 297.229 258.057 297.451 258.756C297.673 259.456 298.05 260.096 298.553 260.63C299.056 261.164 299.673 261.578 300.358 261.841C301.043 262.104 301.779 262.21 302.51 262.15C303.435 262.068 304.319 261.729 305.063 261.173C305.806 260.617 306.38 259.864 306.72 259C307.43 257.28 309.12 255.54 313.13 256.12C320.5 257.21 328.13 254.8 332.55 249.6C336.97 244.4 339.81 243.71 342.2 244.78C344.59 245.85 350.72 240 350.72 240Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M336.51 261.04C338.603 261.04 340.3 259.343 340.3 257.25C340.3 255.157 338.603 253.46 336.51 253.46C334.417 253.46 332.72 255.157 332.72 257.25C332.72 259.343 334.417 261.04 336.51 261.04Z",
                fill: "#0067A5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M379.28 236.44C379.28 236.44 372.92 252.2 357.82 247.44C355.62 247.27 351.51 249.61 351.43 250.08C351.35 250.55 357.36 256.13 357.36 256.13C357.36 256.13 379.53 255 379.28 236.44Z",
                fill: "#0067A5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M373.37 218.18L342.2 244.78C342.2 244.78 352.35 255.06 348.27 260.23L352.27 265.92C352.27 265.92 359.68 260.92 356.57 250.77C356.6 250.77 374.6 241.44 373.37 218.18Z",
                fill: "#0067A5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M351.51 248.6C352.559 248.6 353.41 247.749 353.41 246.7C353.41 245.651 352.559 244.8 351.51 244.8C350.461 244.8 349.61 245.651 349.61 246.7C349.61 247.749 350.461 248.6 351.51 248.6Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M398.4 226.46H396.4V220.46C396.397 217.493 395.218 214.648 393.12 212.55C391.022 210.452 388.177 209.273 385.21 209.27H311.6L311.3 208.95C301.626 198.38 295.235 185.223 292.908 171.084C290.581 156.945 292.417 142.435 298.193 129.321C303.969 116.208 313.435 105.058 325.438 97.231C337.441 89.4039 351.461 85.2376 365.79 85.24V87.24C351.89 87.2495 338.291 91.2897 326.64 98.8712C314.989 106.453 305.787 117.25 300.148 129.955C294.509 142.661 292.676 156.728 294.87 170.454C297.064 184.18 303.192 196.976 312.51 207.29H385.21C388.707 207.295 392.059 208.687 394.531 211.159C397.003 213.632 398.395 216.983 398.4 220.48V226.46Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M385.21 300.77H300.28C296.782 300.765 293.428 299.372 290.956 296.897C288.483 294.423 287.093 291.068 287.09 287.57V225H289.09V287.62C289.093 290.588 290.272 293.434 292.37 295.533C294.468 297.633 297.312 298.815 300.28 298.82H385.21C388.178 298.815 391.023 297.633 393.12 295.533C395.218 293.434 396.397 290.588 396.4 287.62V253.46H398.4V287.57C398.397 291.068 397.007 294.423 394.535 296.897C392.062 299.372 388.708 300.765 385.21 300.77Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M414.23 355.64C437.421 355.64 456.22 336.84 456.22 313.65C456.22 290.46 437.421 271.66 414.23 271.66C391.04 271.66 372.24 290.46 372.24 313.65C372.24 336.84 391.04 355.64 414.23 355.64Z",
                fill: "#0067A5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M415.23 310.02H413.23V348.18H415.23V310.02Z",
                fill: "#8FBCD8"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M415.86 298.92C415.895 299.828 415.746 300.733 415.423 301.582C415.1 302.431 414.609 303.206 413.979 303.86C413.349 304.514 412.594 305.035 411.758 305.391C410.922 305.746 410.023 305.93 409.115 305.93C408.207 305.93 407.308 305.746 406.472 305.391C405.636 305.035 404.881 304.514 404.251 303.86C403.621 303.206 403.13 302.431 402.807 301.582C402.484 300.733 402.335 299.828 402.37 298.92C402.37 295.2 409.12 281.56 409.12 281.56C409.12 281.56 415.86 295.2 415.86 298.92Z",
                fill: "#FF7D20"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M426.17 298.92C426.205 299.828 426.056 300.733 425.733 301.582C425.41 302.431 424.919 303.206 424.289 303.86C423.659 304.514 422.904 305.035 422.068 305.391C421.232 305.746 420.333 305.93 419.425 305.93C418.517 305.93 417.618 305.746 416.782 305.391C415.946 305.035 415.191 304.514 414.561 303.86C413.931 303.206 413.44 302.431 413.117 301.582C412.794 300.733 412.645 299.828 412.68 298.92C412.68 295.2 419.43 281.56 419.43 281.56C419.43 281.56 426.17 295.2 426.17 298.92Z",
                fill: "#FF7D20"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M423.46 302.72C423.46 305.168 422.488 307.516 420.757 309.247C419.026 310.978 416.678 311.95 414.23 311.95C411.782 311.95 409.434 310.978 407.704 309.247C405.973 307.516 405 305.168 405 302.72C405 297.62 414.23 278.95 414.23 278.95C414.23 278.95 423.46 297.62 423.46 302.72Z",
                fill: "#FFD400"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M420.3 339.75H420.25C419.029 339.738 417.839 339.365 416.83 338.678C415.821 337.991 415.038 337.02 414.58 335.888C414.123 334.756 414.01 333.514 414.258 332.318C414.505 331.123 415.101 330.027 415.97 329.17C418.11 327.06 428.33 323.66 429.49 323.28L431.41 322.65L430.75 324.56C430.35 325.71 426.75 335.87 424.63 337.98L423.93 337.27L424.63 337.98C423.476 339.117 421.92 339.753 420.3 339.75ZM428.16 325.84C423.99 327.3 418.54 329.45 417.37 330.6C416.583 331.377 416.137 332.434 416.13 333.54C416.125 334.088 416.228 334.633 416.433 335.141C416.638 335.65 416.942 336.113 417.327 336.504C417.711 336.895 418.169 337.206 418.674 337.42C419.179 337.634 419.722 337.746 420.27 337.75C421.389 337.762 422.468 337.33 423.27 336.55C424.4 335.4 426.6 330 428.16 325.84Z",
                fill: "#8FBCD8"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M409.11 329.36C408.385 329.36 407.668 329.206 407.006 328.91C406.345 328.614 405.753 328.181 405.27 327.64C403.67 325.84 401.47 318.05 401.04 316.5L400.5 314.55L402.38 315.31C403.86 315.91 411.38 318.99 412.95 320.79C413.613 321.53 414.048 322.446 414.201 323.428C414.354 324.41 414.219 325.415 413.813 326.322C413.406 327.229 412.746 327.998 411.911 328.537C411.077 329.077 410.104 329.362 409.11 329.36ZM403.54 318C404.54 321.32 405.94 325.42 406.76 326.35C407.324 326.942 408.096 327.291 408.912 327.324C409.729 327.357 410.527 327.072 411.137 326.528C411.747 325.984 412.121 325.225 412.182 324.409C412.242 323.594 411.983 322.788 411.46 322.16C410.6 321.2 406.73 319.33 403.54 318Z",
                fill: "#8FBCD8"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M388.83 309.3H386.83V324.73H388.83V309.3Z",
                fill: "#8FBCD8"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M441.01 313.15H439.01V334.01H441.01V313.15Z",
                fill: "#8FBCD8"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M388.01 306.55C390.992 306.55 393.41 304.132 393.41 301.15C393.41 298.168 390.992 295.75 388.01 295.75C385.028 295.75 382.61 298.168 382.61 301.15C382.61 304.132 385.028 306.55 388.01 306.55Z",
                fill: "#FFD400"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M440.01 309.42C444.053 309.42 447.33 306.143 447.33 302.1C447.33 298.057 444.053 294.78 440.01 294.78C435.967 294.78 432.69 298.057 432.69 302.1C432.69 306.143 435.967 309.42 440.01 309.42Z",
                fill: "#FFD400"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M388.01 303.71C389.424 303.71 390.57 302.564 390.57 301.15C390.57 299.736 389.424 298.59 388.01 298.59C386.596 298.59 385.45 299.736 385.45 301.15C385.45 302.564 386.596 303.71 388.01 303.71Z",
                fill: "#0067A5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M440.01 305.57C441.927 305.57 443.48 304.016 443.48 302.1C443.48 300.184 441.927 298.63 440.01 298.63C438.094 298.63 436.54 300.184 436.54 302.1C436.54 304.016 438.094 305.57 440.01 305.57Z",
                fill: "#0067A5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M393.41 323.73H381.82V325.73H393.41V323.73Z",
                fill: "#8FBCD8"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M357.14 251.62L356.09 249.92C374.21 238.68 372.39 218.48 372.37 218.28L374.37 218.07C374.38 218.29 376.35 239.71 357.14 251.62Z",
                fill: "#8FBCD8"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M425.99 355L425.44 353.08C432.777 350.997 439.387 346.908 444.527 341.274C449.668 335.641 453.135 328.685 454.539 321.189C455.943 313.692 455.229 305.953 452.476 298.841C449.723 291.728 445.041 285.524 438.956 280.927C432.871 276.329 425.625 273.52 418.031 272.815C410.437 272.11 402.797 273.537 395.969 276.936C389.142 280.334 383.398 285.57 379.382 292.054C375.367 298.538 373.24 306.013 373.24 313.64H371.24C371.239 305.641 373.47 297.801 377.68 291.001C381.891 284.2 387.915 278.709 395.075 275.144C402.235 271.579 410.248 270.082 418.212 270.82C426.177 271.559 433.777 274.505 440.159 279.326C446.541 284.148 451.452 290.653 454.34 298.113C457.228 305.572 457.978 313.688 456.506 321.55C455.034 329.412 451.398 336.708 446.007 342.617C440.616 348.526 433.684 352.814 425.99 355Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M345.19 382.67C341.06 382.67 336.9 380.46 336.9 374.86H342.6C342.567 375.208 342.611 375.558 342.727 375.887C342.843 376.216 343.029 376.516 343.273 376.766C343.516 377.016 343.811 377.211 344.137 377.336C344.463 377.461 344.812 377.513 345.16 377.49C345.511 377.516 345.864 377.464 346.192 377.338C346.521 377.212 346.818 377.015 347.061 376.76C347.305 376.506 347.49 376.202 347.602 375.868C347.714 375.534 347.751 375.18 347.71 374.83C347.718 374.48 347.655 374.132 347.524 373.807C347.393 373.482 347.197 373.187 346.948 372.941C346.699 372.695 346.402 372.502 346.075 372.374C345.749 372.247 345.4 372.188 345.05 372.2H344.25V367.2H345.05C345.525 367.24 346.001 367.136 346.416 366.902C346.83 366.668 347.165 366.314 347.376 365.886C347.586 365.459 347.663 364.978 347.597 364.506C347.53 364.034 347.322 363.594 347.001 363.242C346.68 362.89 346.261 362.642 345.797 362.532C345.333 362.423 344.847 362.455 344.402 362.625C343.957 362.796 343.574 363.096 343.303 363.488C343.031 363.879 342.884 364.344 342.88 364.82H337.14C337.14 360.13 340.71 357.29 345.14 357.29C349.76 357.29 353.14 360.37 353.14 364.68C353.195 365.65 352.983 366.616 352.526 367.473C352.069 368.33 351.386 369.045 350.55 369.54C351.464 370.11 352.21 370.912 352.714 371.864C353.218 372.816 353.462 373.884 353.42 374.96C353.48 380.22 349.6 382.67 345.19 382.67Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M506.08 499C494.82 500 488.36 506.2 488.77 517.6C489.18 529 480.77 533.49 469.47 531.81C458.17 530.13 451.47 533.97 449.2 540.81C446.93 547.65 442.69 550.15 431.87 549.45L442.07 571.27L509.75 555.85L526.12 520.85L506.08 499Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M435.09 550.48C434.09 550.48 432.96 550.48 431.8 550.36L431.93 548.36C443.18 549.1 446.36 546.13 448.25 540.36C450.83 532.59 458.62 529.08 469.62 530.72C475.8 531.64 480.94 530.6 484.09 527.79C486.69 525.46 487.93 522.01 487.77 517.54C487.35 505.98 493.82 499.01 505.99 497.9L506.17 499.9C495.06 500.9 489.39 506.98 489.77 517.46C489.95 522.46 488.45 526.58 485.42 529.28C481.82 532.5 476.11 533.71 469.33 532.7C459.23 531.19 452.42 534.14 450.15 540.99C447.88 547.84 443.73 550.48 435.09 550.48Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M122.22 509.6C122.22 509.6 142.39 504.29 156.93 529.03C165.65 543.86 167.83 554.03 194.86 555.77C221.89 557.51 210.43 596.33 176.46 587.04C142.49 577.75 110.68 549.04 110.68 549.04L122.22 509.6Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M194.8 556.77C170.42 555.22 165.6 546.56 158.92 534.57C158.02 532.95 157.09 531.28 156.07 529.57C142.07 505.82 123.27 510.39 122.47 510.57L121.97 508.64C122.18 508.58 143.04 503.43 157.8 528.53C158.8 530.29 159.8 531.98 160.67 533.6C167.27 545.47 171.67 553.31 194.93 554.78L194.8 556.77Z",
                fill: "#003C71"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-illustrations-virtual-f4c8d3dc38/1/packages/lib-illustrations/src/starfsmenn.tsx
/* eslint-disable max-len */ 

const StarfsmennIllustration = (param)=>{
    let { size =200  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        fill: "none",
        height: size,
        viewBox: "0 0 662 611",
        width: size,
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M479.72 95.12H190.77C176.527 95.12 164.98 106.667 164.98 120.91V175.01C164.98 189.253 176.527 200.8 190.77 200.8H479.72C493.963 200.8 505.51 189.253 505.51 175.01V120.91C505.51 106.667 493.963 95.12 479.72 95.12Z",
                fill: "#FFD400"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M480.86 201.8H425.1V199.8H480.86C493.86 199.8 504.51 188.68 504.51 175.01V120.91C504.51 107.24 493.9 96.12 480.86 96.12V94.12C495 94.12 506.51 106.12 506.51 120.91V175C506.51 189.78 495 201.8 480.86 201.8Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M169.3 191.35C165.82 186.612 163.962 180.878 164 175V120.9C164 106.12 175.5 94.11 189.65 94.11H427.75V96.11H189.63C176.63 96.11 165.98 107.23 165.98 120.9V175C165.948 180.449 167.677 185.763 170.91 190.15L169.3 191.35Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M190.36 217.65C167.73 217.65 149.36 198.41 149.36 174.76V120.15C149.36 96.5 167.77 77.26 190.36 77.26H231.24V79.26H190.36C168.83 79.26 151.36 97.6 151.36 120.15V174.76C151.36 197.31 168.87 215.65 190.36 215.65V217.65Z",
                fill: "#80B3D2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M480.13 217.65V215.65C501.66 215.65 519.13 197.31 519.13 174.76V120.15C519.13 97.6 501.62 79.26 480.13 79.26H367V77.26H480.13C502.76 77.26 521.13 96.5 521.13 120.15V174.76C521.17 198.41 502.76 217.65 480.13 217.65Z",
                fill: "#80B3D2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M111.27 495.16C68.19 496.42 30.72 407.16 95.14 347.22C160.26 286.67 197.4 333.39 189.92 362.11C182.44 390.83 266.6 378.06 347.67 310.19C452.31 222.59 543.74 266.33 530.31 321.69C519.98 364.29 493.92 388.23 543.18 400.83C614.7 419.14 587.67 491.7 504.89 516C480.73 523.11 428.15 504.49 368.33 500.39C264 493.28 138.65 494.36 111.27 495.16Z",
                fill: "#E5E5E5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M545.17 335.26L543.23 334.77C550.92 304.55 547.12 281.57 531.95 266.47C509.6 244.22 468.6 245.41 453.33 249.37L452.83 247.44C468.45 243.39 510.4 242.2 533.36 265.05C549.07 280.69 553 304.31 545.17 335.26Z",
                fill: "#E5E5E5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M51.7899 463.72C36.3899 422.91 43.9399 391.49 52.9799 372.33C62.7799 351.55 76.4499 340.26 76.5799 340.15L77.8499 341.7C77.7099 341.81 64.3499 352.87 54.7499 373.27C45.8999 392.07 38.5299 422.9 53.6599 463L51.7899 463.72Z",
                fill: "#E5E5E5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M342.25 369.52C317.39 348.17 314.09 226.18 409.07 245.86C450.74 256.86 458.07 299.66 457.01 331.27C455.81 368.02 462.57 379.27 498.42 386.42C525.22 391.75 526.2 436.72 492.79 443.48C459.38 450.24 367.1 390.88 342.25 369.52Z",
                fill: "#FF7D20"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M266.87 330.78C262.16 337.33 239.94 343.39 230.56 347.22C196.21 361.22 98.79 392.8 95.97 468.22C94.27 514 125.31 530 150 535.42C155.303 536.577 160.679 537.372 166.09 537.8V482.33L280.68 473.89C280.68 473.89 389.92 392.77 355.57 372.8C329.81 357.8 299.73 339.74 295.19 320.11C293.68 313.57 279.42 313.34 266.87 330.78Z",
                fill: "#0067A5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M198.43 387.14H200.73C201.34 387.14 201.48 387.34 201.48 387.62C201.48 387.9 201.34 388.13 200.73 388.13H198.43V387.14ZM198.43 389.88H201C201.6 389.88 201.79 390.15 201.79 390.48C201.79 390.81 201.6 391.09 201 391.09H198.4L198.43 389.88ZM195.43 392.97H202C204.26 392.97 205 391.97 205 390.46C205.006 390.063 204.881 389.676 204.644 389.357C204.407 389.039 204.072 388.808 203.69 388.7C203.977 388.574 204.218 388.362 204.381 388.093C204.544 387.825 204.62 387.513 204.6 387.2C204.6 385.97 203.9 385.28 202.33 385.28H195.4L195.43 392.97ZM208.14 392.97H211.06V390.8L214.54 385.26H211.31L209.59 388.06L207.9 385.26H204.66L208.14 390.8V392.97ZM221.4 392.97H225.2L221.9 388.21L225.1 385.26H221.1L218 388.21V385.26H215V393H218V391L219.36 389.88L221.4 392.97ZM224.83 389.11C224.83 393.11 228.25 393.24 230.1 393.24C231.95 393.24 235.36 393.11 235.36 389.11C235.36 385.11 232 385 230.12 385C228.24 385 224.85 385.13 224.85 389.12L224.83 389.11ZM228.09 389.12C228.09 387.56 228.88 386.94 230.09 386.94C231.3 386.94 232.09 387.56 232.09 389.12C232.09 390.68 231.31 391.3 230.09 391.3C228.87 391.3 228.09 390.69 228.09 389.12Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M235.54 395.37H234.75C234.69 395.37 234.87 395.24 235.01 395.23H235.29H234.86C234.86 395.23 234.86 395.23 234.81 395.23C234.693 395.219 234.576 395.219 234.46 395.23H234.97C234.79 395.22 234.61 395.22 234.43 395.23C234.22 395.23 234.43 395.23 234.21 395.23H233.58C233.58 395.23 232.79 395.23 232.33 395.23H232.4C232.4 395.23 231.99 395.23 231.73 395.23L235.08 395.16H233.82C233.82 395.16 234.1 395.16 234.05 395.16H233H231.62C232.35 395.16 233.25 395.16 234.15 395.16C234.23 395.16 234.34 395.16 234.28 395.16C232.41 395.16 228.66 395.16 228.67 395.16C228.979 395.137 229.29 395.137 229.6 395.16C231.07 395.16 232.8 395.16 234.38 395.16C234.43 395.16 234.43 395.16 234.38 395.09C232.66 395.04 230.94 395.09 229.22 395.03C228.48 395.03 227.28 395.03 226.36 395.03C225.66 395.03 224.88 395.03 224.14 395.08H225.14C225.87 395.08 226.61 395.08 227.25 395.08H228.05C227.95 395.08 230.38 395.08 230.29 395.08H226.89C226.61 395.08 227.13 394.98 227.31 394.97C227.203 394.961 227.096 394.961 226.99 394.97H227.82H226.42H228.82H227.14C225.02 394.97 223.08 394.97 221.14 395.04H220.42H219.22C219.86 395.04 220.59 394.98 221.22 394.97H221.37C221.37 394.97 219.32 394.97 218.37 395.05H217.72C216.9 395.05 216.09 395.05 216.34 395.05C216.05 395.05 215.5 395.05 214.98 395.05C214.9 395.05 215.08 395.05 215.08 395.05C215.4 395.13 214.35 395.11 213.08 395.14C211.96 395.14 210.74 395.14 210.08 395.24H209.75C210.578 395.119 211.413 395.045 212.25 395.02C212.78 395.02 213.85 395.02 213.85 395.02C212.783 394.955 211.714 394.972 210.65 395.07C209.18 395.12 207.79 395.25 206.41 395.33L204.73 395.4H204.87C204.17 395.4 203.5 395.46 202.79 395.51H202.59C201.13 395.61 199.87 395.69 198.38 395.81L197.28 395.91C197.01 395.91 197.48 395.91 197.02 395.97C197.02 395.97 196.85 395.97 197.84 395.92C197.89 395.92 197.84 395.92 197.77 395.92C197.23 395.92 196.59 395.99 196.02 396.06C196.02 396.06 195.54 396.06 195.49 396.06C195.44 396.06 195.41 396.06 195.41 396.06L195.34 396.13C195.287 396.192 195.246 396.263 195.22 396.34C195.215 396.373 195.215 396.407 195.22 396.44C195.27 396.55 195.42 396.63 195.8 396.63H196.13H195.98H196.18C196.31 396.63 196.51 396.56 196.67 396.55C196.83 396.54 196.67 396.55 196.99 396.55C198.57 396.43 200.11 396.35 201.72 396.27H201.66H202.19L226.05 395.96C227.26 395.96 228.47 395.96 228.83 396.01C229.19 396.06 228.54 396.01 228.53 396.06H229.33C229.41 396.06 229.71 396.06 229.69 396.06C229.582 396.054 229.475 396.037 229.37 396.01H229.76C229.956 396.026 230.154 396.026 230.35 396.01C231 396.01 231.7 396.01 232.35 396.06C232.153 396.075 231.956 396.075 231.76 396.06C231.67 396.11 233.61 396.06 234.03 396.06C234.1 396.06 234.45 395.92 234.51 395.91L234.79 395.83H235.16C235.54 395.83 235.44 395.72 235.71 395.63C235.643 395.622 235.576 395.622 235.51 395.63L235.54 395.37ZM224.29 394.79C224.91 394.79 226.38 394.79 226.39 394.79L223.85 394.84H224.29V394.79ZM222.65 395.04C221.45 395.04 220.17 395.04 218.97 395.11H218.33C218.96 395.11 219.53 395.05 220.17 395.04H220.44C220.563 395.046 220.687 395.046 220.81 395.04H220.58H222.2H222.26H224.35H224.46C224.73 395.04 224.99 395.09 225.31 395.1H225.41C224.58 395.15 223.57 395.1 222.65 395.1V395.04ZM227.08 395.25C226.97 395.25 224.95 395.25 223.93 395.25H223.37H223.57H223.67C224.88 395.25 226.14 395.25 227.32 395.25C227.32 395.25 227.18 395.25 227.08 395.25ZM231.58 395.45H231.66C231.66 395.45 231.71 395.45 231.58 395.45ZM235.51 395.79C235.44 395.779 235.369 395.779 235.3 395.79H235.47C235.57 395.79 235.6 395.79 235.47 395.79",
                fill: "#FFD400"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M284.45 358.91C297.435 358.338 310.285 356.034 322.66 352.06C306.9 339.82 298.66 326.06 305.46 303.83C316.15 268.91 262.66 291.44 262.66 291.44C262.66 291.44 264.91 333.19 230.56 347.22C230.24 347.36 229.9 347.49 229.56 347.62C241.23 353.71 259.83 360.28 284.45 358.91Z",
                fill: "#FDC498"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M250.4 286.67C250.4 286.67 247.81 324.94 279.55 327.62C314.27 330.54 318.38 293.14 318.38 293.14L250.4 286.67Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M255 262.27C255 262.27 239.37 258.02 237.68 269.27C236.68 276.2 246.32 281.47 252.51 280.15C258.7 278.83 255 262.27 255 262.27Z",
                fill: "#FDC498"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M320.85 263.84C320.85 263.84 333.61 260.65 334.75 270.25C335.58 277.25 326.12 282.45 319.92 281.13C313.72 279.81 320.85 263.84 320.85 263.84Z",
                fill: "#FDC498"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M251.77 252.77C251.77 252.77 237.88 310.58 278.05 317.34C318.22 324.1 326.48 271.16 327.6 256.9L251.77 252.77Z",
                fill: "#FDC498"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M246.86 246.11C246.86 246.11 239.15 261.49 251.4 264.11C261.48 266.28 263.5 256.88 263.5 256.88C263.5 256.88 265.8 263.69 274.34 262.7C281.94 261.82 284.45 252.7 284.45 252.7C284.45 252.7 284.4 261.03 288.53 262.7C294.19 265.02 298.42 260.47 298.13 252.7C299.54 263 307.84 263.46 308.85 255.81C310.24 263 318.39 264.65 318.4 256.33C320.94 263 330.04 262.84 327.6 256.83C309.68 243.57 246.86 246.11 246.86 246.11Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M251.4 232.87C251.4 232.87 324.6 185.95 327.6 256.87C267.91 250.89 251.4 232.87 251.4 232.87Z",
                fill: "#408DBC"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M327.6 256.9C327.6 256.9 247.27 215.23 220.6 221.61C205.1 225.32 218.17 235.26 231.82 242.92C243.279 249.323 256.052 253.017 269.16 253.72L327.6 256.9Z",
                fill: "#0067A5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M248.79 274.35C248.165 273.888 247.658 273.285 247.31 272.59C246.963 271.895 246.784 271.127 246.79 270.35C246.89 269.577 247.146 268.832 247.541 268.16C247.936 267.488 248.463 266.903 249.09 266.44L250.26 268.07L249.68 267.25L250.26 268.06C249.479 268.641 248.953 269.501 248.79 270.46C248.815 270.925 248.943 271.378 249.167 271.787C249.39 272.195 249.702 272.548 250.08 272.82L248.79 274.35Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M325.05 276.68L323.78 275.13C324.338 274.747 324.813 274.256 325.177 273.685C325.541 273.115 325.787 272.477 325.9 271.81C325.954 270.979 325.709 270.156 325.21 269.49L326.71 268.18C327.586 269.251 328.012 270.621 327.9 272C327.764 272.932 327.442 273.826 326.952 274.63C326.462 275.435 325.815 276.132 325.05 276.68Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M286 267.61C290.9 267.37 289.75 274.42 291.52 279C293.29 283.58 296.75 283.31 297.85 286.15C298.95 288.99 295.35 291.15 293.16 291.27C290.97 291.39 288.66 295.19 283.28 291.6C278.33 288.3 275.65 289.19 275.38 285.94C274.94 280.46 280.94 282.36 281.99 276.34C282.81 271.86 282.89 267.77 286 267.61Z",
                fill: "#FFEEE0"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M284.34 308.14C275.34 308.14 269.82 304.63 266.71 301.48C264.429 299.223 262.715 296.458 261.71 293.41L263.64 292.88C263.81 293.49 267.99 307.81 287.64 305.99L287.82 307.99C286.58 308.09 285.43 308.14 284.34 308.14Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M301.46 274.47C302.57 274.47 303.47 273.57 303.47 272.46C303.47 271.35 302.57 270.45 301.46 270.45C300.35 270.45 299.45 271.35 299.45 272.46C299.45 273.57 300.35 274.47 301.46 274.47Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M272.61 272.94C273.72 272.94 274.62 272.04 274.62 270.93C274.62 269.82 273.72 268.92 272.61 268.92C271.5 268.92 270.6 269.82 270.6 270.93C270.6 272.04 271.5 272.94 272.61 272.94Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M275.4 457.73C275.4 457.73 262.69 395.1 334.8 360.3C349.6 356.57 362.52 354.46 365.43 342.8C366.16 339.88 392.34 334.29 393.58 342.8C394.82 351.31 404.47 361.8 415.45 366.89C437.45 377.03 519.45 423.58 519.45 484.02C519.45 507.11 499.74 526.26 480.03 527.95L463.7 481.77L345.45 486.84L275.4 457.73Z",
                fill: "#408DBC"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M402.87 326.07C402.87 326.07 390.97 347.07 403.82 359.07C398.56 377.29 387.11 389.12 373.59 389.96C360.07 390.8 349.77 370.96 351.97 355.56C351.97 355.56 364.58 350.4 365.15 338.5C365.72 326.6 365.43 317.91 365.43 317.91L402.87 326.07Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M365.36 332.92C365.36 332.92 369.68 353.76 385.25 358.26C390.685 359.773 396.496 359.098 401.44 356.38C392.63 344.16 402.87 326.07 402.87 326.07L365.43 317.93C365.43 317.93 365.62 324 365.36 332.92Z",
                fill: "#FFEBDD"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M514.54 429.89L512.85 428.82C515.596 424.676 517.167 419.866 517.398 414.901C517.629 409.935 516.51 405 514.16 400.62C507.4 387.73 491.87 379.62 472.63 378.86C461.82 378.44 446.85 375.39 436.93 363.18C433.377 358.925 430.885 353.887 429.66 348.48L431.66 348.14C431.71 348.41 436.84 375.48 472.74 376.86C492.74 377.62 508.86 386.16 515.96 399.69C518.472 404.383 519.666 409.669 519.416 414.986C519.166 420.303 517.481 425.453 514.54 429.89Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M376.38 256.9C359.92 267.66 345.44 321.69 373.12 335.74C399.48 349.13 428.22 311.19 431.59 286.67C434.96 262.15 405.07 238.13 376.38 256.9Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M375.74 298.37C376.85 298.37 377.75 297.47 377.75 296.36C377.75 295.25 376.85 294.35 375.74 294.35C374.63 294.35 373.73 295.25 373.73 296.36C373.73 297.47 374.63 298.37 375.74 298.37Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M401.81 306.4C402.92 306.4 403.82 305.5 403.82 304.39C403.82 303.28 402.92 302.38 401.81 302.38C400.7 302.38 399.8 303.28 399.8 304.39C399.8 305.5 400.7 306.4 401.81 306.4Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M386.83 299.36C385.261 302.232 383.042 304.698 380.35 306.56C377.35 308.79 378.58 312.86 383.35 312.51C387.48 312.2 390.41 313.57 391.48 312.25C392.86 310.53 388.98 307.3 390.13 303.44C391.83 297.8 388.34 296.66 386.83 299.36Z",
                fill: "#FFB784"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M386.37 329.82C382.542 329.8 378.763 328.968 375.28 327.38L376.19 325.6C376.78 325.9 390.81 332.82 401.06 321.03L402.57 322.35C400.594 324.72 398.115 326.621 395.313 327.913C392.511 329.205 389.456 329.857 386.37 329.82Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M413.57 274.47C413.57 274.47 403.82 299.93 431.86 308.58C461.42 317.7 443.14 285.05 443.14 285.05C443.14 285.05 438 266.26 423.52 256.9C405.31 245.15 373.73 249.01 373.73 249.01L353.32 277.55C353.32 277.55 401.79 297.56 413.57 274.47Z",
                fill: "#FF7D20"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M417.26 259.19C428.455 259.19 437.53 250.115 437.53 238.92C437.53 227.725 428.455 218.65 417.26 218.65C406.065 218.65 396.99 227.725 396.99 238.92C396.99 250.115 406.065 259.19 417.26 259.19Z",
                fill: "#FF7D20"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M346.41 292.22L344.41 291.78C344.48 291.5 346.05 284.86 351.61 281.41C354.87 279.41 358.79 278.9 363.26 279.96L365.2 280.43C379.34 283.84 405.67 290.2 412.61 274.07C415.4 267.57 417.43 262.91 418.61 260.21C419.93 257.26 420.07 256.95 421 257.29L421.89 257.62L421.61 258.55L420.74 258.28L421.48 258.78C421.35 259 420.48 260.83 414.41 274.86C406.8 292.53 379.41 285.93 364.7 282.38L362.76 281.91C358.84 280.97 355.44 281.37 352.65 283.1C347.88 286.1 346.42 292.16 346.41 292.22Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M415.45 316.78C415.45 316.78 425.21 323.16 429.53 316.78C433.85 310.4 424.65 303.45 418.83 304.39C413.01 305.33 415.45 316.78 415.45 316.78Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M431.6 325.56L429.69 324.98C432.36 316.25 430.26 309.88 423.46 306.06C412.86 300.11 411.64 290.79 411.59 290.4L413.59 290.16L412.59 290.28L413.59 290.16C413.59 290.25 414.77 298.88 424.45 304.32C429.75 307.3 435.31 313.41 431.6 325.56Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M417.26 259.26V257.26C420.887 257.26 424.433 256.184 427.449 254.169C430.465 252.154 432.816 249.29 434.204 245.938C435.592 242.587 435.955 238.9 435.247 235.342C434.54 231.784 432.793 228.517 430.228 225.952C427.663 223.387 424.395 221.64 420.838 220.932C417.28 220.225 413.593 220.588 410.241 221.976C406.89 223.364 404.026 225.715 402.011 228.731C399.996 231.747 398.92 235.293 398.92 238.92H396.92C396.92 234.897 398.113 230.965 400.348 227.62C402.583 224.275 405.759 221.668 409.476 220.128C413.193 218.589 417.282 218.186 421.228 218.971C425.174 219.756 428.798 221.693 431.642 224.537C434.487 227.382 436.424 231.006 437.209 234.952C437.994 238.897 437.591 242.987 436.052 246.704C434.512 250.42 431.905 253.597 428.56 255.832C425.215 258.067 421.283 259.26 417.26 259.26Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M417.1 253.67C413.313 253.667 409.683 252.162 407.005 249.485C404.328 246.807 402.822 243.176 402.82 239.39H404.82C404.822 242.646 406.117 245.768 408.419 248.07C410.722 250.373 413.844 251.667 417.1 251.67V253.67Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M369.65 303.03C371.047 303.03 372.18 301.897 372.18 300.5C372.18 299.103 371.047 297.97 369.65 297.97C368.253 297.97 367.12 299.103 367.12 300.5C367.12 301.897 368.253 303.03 369.65 303.03Z",
                fill: "#FFB784"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M403.82 313.56C405.234 313.56 406.38 312.414 406.38 311C406.38 309.586 405.234 308.44 403.82 308.44C402.406 308.44 401.26 309.586 401.26 311C401.26 312.414 402.406 313.56 403.82 313.56Z",
                fill: "#FFB784"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M361.39 302.33C361.39 302.33 348.54 299.89 350.8 291.33C353.32 281.68 364.41 288.26 364.41 288.26L361.39 302.33Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M369.79 391C346.64 385.43 350.93 355.75 350.98 355.45L352.98 355.76C352.367 360.715 352.563 365.737 353.56 370.63C355.73 380.71 361.36 386.91 370.28 389.06L369.79 391Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M520.44 484.05L518.44 484C518.79 468.94 508.53 441.52 485.16 416.89C462.86 393.38 403.93 360.3 403.33 359.97L404.33 358.22C404.93 358.55 464.12 391.79 486.63 415.52C510.37 440.56 520.8 468.59 520.44 484.05Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M274.42 457.94C274.3 457.38 271.48 443.94 275.42 426.15C279.02 409.72 289.31 386.42 317.88 368.75L318.88 370.45C290.94 387.73 280.88 410.45 277.34 426.45C273.5 443.85 276.34 457.35 276.34 457.45L274.42 457.94Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M174.68 444C174.68 444 192.97 445.32 184.44 479C175.91 512.68 154.16 486.24 154.16 486.24C154.16 486.24 164.17 440.78 174.68 444Z",
                fill: "#FDC498"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M204.867 458.343L422.765 436.402C428.75 435.799 434.729 437.599 439.387 441.404C444.045 445.21 447.001 450.71 447.603 456.695L452.464 504.961L189.434 531.447L184.574 483.181C183.971 477.196 185.77 471.217 189.576 466.559C193.382 461.901 198.882 458.946 204.867 458.343Z",
                fill: "#FFD400"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M480 528L474.31 511.91L452.84 447.47C452.84 447.47 439.32 449.72 445.08 473.6C449.92 493.67 441.01 501.24 424.68 503.92C408.35 506.6 371.49 512.73 371.49 512.73C371.49 512.73 372.14 526.73 398.31 524.91C402.54 529.27 411.22 534.12 427.91 530.5C434.31 535.2 448.52 538.62 480 528Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M445.24 535.94C436.57 535.94 431.12 533.94 427.7 531.52C418.81 533.39 411.23 533.07 405.16 530.58L405.91 528.73C411.71 531.1 419.04 531.35 427.71 529.47L428.16 529.38L428.52 529.65C433.59 533.42 447.04 538.07 480.18 526.84L480.65 526.68L481.29 528.57L480.82 528.73C465.18 534 453.68 535.94 445.24 535.94Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M389.89 526.11C384.77 526.11 380.49 524.93 377.11 522.58C373.76 520.286 371.408 516.804 370.53 512.84L372.53 512.52C373.35 515.953 375.413 518.959 378.32 520.96C382.88 524.12 389.38 524.91 397.63 523.3C420.96 518.76 440.54 514.15 440.74 514.1L441.2 516.05C441 516.05 421.39 520.72 398.01 525.27C395.336 525.809 392.617 526.09 389.89 526.11Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M216.63 529.71L216.43 527.71L371.43 511.71C372.05 511.65 433.05 505.71 442.14 494.54C445.68 490.21 444.73 481.79 443.81 473.65C442.46 461.65 441.06 449.28 452.64 446.47L453.11 448.41C443.24 450.81 444.48 461.79 445.8 473.41C446.8 482.41 447.8 490.82 443.69 495.8C434.07 507.57 374.18 513.44 371.63 513.69L216.63 529.71Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M459.766 465.015L457.872 465.656L479.068 528.276L480.962 527.635L459.766 465.015Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M398.43 411.63L400.72 411.4C401.33 411.34 401.49 411.53 401.51 411.81C401.53 412.09 401.43 412.33 400.81 412.39L398.53 412.62L398.43 411.63ZM398.7 414.36L401.29 414.1C401.89 414.04 402.1 414.29 402.13 414.62C402.16 414.95 402.01 415.24 401.41 415.3L398.82 415.56L398.7 414.36ZM396.05 417.73L402.61 417.07C404.85 416.84 405.5 415.78 405.35 414.28C405.315 413.885 405.151 413.513 404.884 413.22C404.616 412.927 404.26 412.731 403.87 412.66C404.144 412.504 404.364 412.268 404.502 411.984C404.639 411.701 404.687 411.382 404.64 411.07C404.51 409.85 403.75 409.23 402.18 409.39L395.29 410.08L396.05 417.73ZM408.7 416.46L411.61 416.16L411.39 414.01L414.29 408.15L411.08 408.47L409.64 411.47L407.64 408.85L404.42 409.18L408.42 414.34L408.7 416.46ZM421.88 415.13L425.67 414.75L421.91 410.35L424.79 407.09L420.79 407.5L418 410.75L417.71 407.81L414.8 408.1L415.57 415.77L418.48 415.48L418.28 413.48L419.52 412.23L421.88 415.13ZM424.88 410.95C425.28 414.95 428.69 414.71 430.53 414.53C432.37 414.35 435.75 413.87 435.35 409.9C434.95 405.93 431.54 406.14 429.7 406.32C427.86 406.5 424.48 406.98 424.88 410.95ZM428.1 410.63C427.94 409.07 428.66 408.38 429.9 408.26C431.14 408.14 431.98 408.66 432.13 410.26C432.28 411.86 431.57 412.51 430.34 412.63C429.11 412.75 428.26 412.22 428.1 410.63Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M436.18 416.1H436L435.36 416.15C435.3 416.15 435.47 416.01 435.6 415.99C435.694 415.981 435.788 415.964 435.88 415.94H435.45C435.33 415.931 435.21 415.931 435.09 415.94C435.09 415.94 435.6 415.89 435.6 415.88C435.423 415.868 435.246 415.868 435.07 415.88C434.86 415.88 435.07 415.88 434.84 415.88C434.631 415.911 434.421 415.931 434.21 415.94C434.21 415.94 433.43 416.03 432.97 416.05H433.04L432.37 416.1L435.69 415.69L434.44 415.8C434.44 415.8 434.72 415.8 434.66 415.75L433.66 415.86L432.29 416C433.02 415.89 433.92 415.82 434.81 415.74C434.9 415.74 435 415.74 434.93 415.74C433.07 415.89 429.34 416.31 429.35 416.27C429.652 416.203 429.96 416.167 430.27 416.16C431.74 415.99 433.46 415.85 435.03 415.7C435.08 415.7 435.08 415.65 435.03 415.63C433.32 415.76 431.61 415.95 429.89 416.09C429.16 416.2 427.97 416.29 427.06 416.41C426.36 416.51 425.58 416.59 424.85 416.68L425.85 416.53C426.58 416.44 427.31 416.39 427.95 416.29C428.13 416.29 428.5 416.23 428.77 416.2L429.14 416.15H428.74C428.64 416.15 431.06 415.9 430.96 415.88L427.58 416.21C427.3 416.21 427.81 416.09 427.99 416.06H428.04H427.72L428.54 415.97L427.14 416.09L429.53 415.81L427.86 415.97C425.75 416.2 423.86 416.41 421.86 416.64C421.62 416.64 421.38 416.72 421.14 416.74L419.95 416.88C420.58 416.8 421.3 416.68 421.95 416.61C422.02 416.61 422.11 416.61 422.1 416.61C422.09 416.61 420.1 416.86 419.1 416.99L418.46 417.09C417.64 417.18 416.84 417.29 417.09 417.26C416.8 417.26 416.26 417.36 415.74 417.44C415.66 417.44 415.84 417.44 415.84 417.44C416.17 417.49 415.12 417.57 413.84 417.73C412.73 417.87 411.52 418.01 410.89 418.13C410.69 418.18 410.65 418.13 410.56 418.19C411.37 417.986 412.192 417.829 413.02 417.72C413.55 417.66 414.62 417.58 414.61 417.54C413.545 417.584 412.486 417.707 411.44 417.91C409.98 418.1 408.61 418.37 407.25 418.59L405.58 418.83H405.71C405.02 418.92 404.35 419.02 403.65 419.14H403.46L399.3 419.86L398.22 420.07C397.95 420.13 398.41 420.07 397.96 420.16C397.96 420.16 397.8 420.21 398.78 420.02C398.83 420.02 398.78 420.02 398.71 420.02C398.18 420.11 397.54 420.21 396.98 420.34L396.45 420.41C396.38 420.41 396.38 420.41 396.38 420.41L396.31 420.49C396.257 420.553 396.222 420.629 396.21 420.71C396.204 420.743 396.204 420.777 396.21 420.81C396.27 420.91 396.43 420.98 396.81 420.94H397H397.14H396.99H397.19C397.32 420.94 397.51 420.84 397.67 420.81C397.83 420.78 397.67 420.81 397.99 420.81C399.55 420.53 401.07 420.3 402.66 420.06H402.61L403.13 419.98L426.84 417.28L429.61 417.05C429.9 417.05 429.32 417.13 429.32 417.13C429.68 417.13 429.81 417.07 430.11 417.05C430.19 417.05 430.49 417.05 430.47 417.05H430.15H430.54C430.735 417.04 430.928 417.016 431.12 416.98C431.76 416.89 432.47 416.88 433.12 416.83C432.93 416.879 432.736 416.91 432.54 416.92C432.46 416.97 434.38 416.74 434.8 416.68C434.87 416.68 435.21 416.5 435.26 416.49L435.54 416.38C435.66 416.368 435.78 416.368 435.9 416.38C436.29 416.38 436.17 416.24 436.42 416.13C436.42 416.13 436.35 416.13 436.23 416.13L436.18 416.1ZM424.98 416.43C425.59 416.31 427.06 416.18 427.06 416.19C427.06 416.2 425.41 416.39 424.54 416.5L424.98 416.43ZM423.37 416.79C422.18 416.93 420.9 417.06 419.72 417.23L419.08 417.29L420.9 417.03H421.17C421.26 417.03 421.54 416.98 421.54 416.98H421.31C421.31 416.98 422.2 416.86 422.92 416.79H422.98C423.77 416.71 424.98 416.55 425.06 416.54H425.16C425.43 416.54 425.7 416.54 426.02 416.54H426.11C425.29 416.66 424.28 416.72 423.37 416.83V416.79ZM427.79 416.53C427.68 416.53 425.67 416.71 424.66 416.83L424.13 416.88H424.32H424.43C425.62 416.77 426.88 416.63 428.06 416.53C428.06 416.53 427.92 416.53 427.82 416.53H427.79ZM432.32 416.28H431.97L432.4 416.23C432.4 416.23 432.45 416.23 432.32 416.23V416.28ZM436.26 416.17H436H436.17C436.27 416.17 436.31 416.17 436.17 416.17",
                fill: "#FFD400"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M184.44 479C184.44 479 194.23 477.94 204.8 476.75C216.53 475.45 218.32 490.16 205.93 491.29L199.17 492.04C199.17 492.04 215.69 490.18 216.71 497.69C217.73 505.2 200.3 505.5 200.3 505.5C200.3 505.5 218.3 502.17 218.3 510.06C218.3 517.95 200.3 517.67 200.3 517.67C200.3 517.67 219.16 514.02 220.57 521.21C222.48 530.94 213.41 533.69 202.46 536.35C182 541.35 154.63 536.35 154.63 536.35C154.63 536.35 146.79 515.19 155.09 482.35C163.39 449.51 175 479.38 184.44 479Z",
                fill: "#FDC498"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M200.68 493.11H199.13L199.21 491.11C206.21 491.37 211.37 489.67 213.35 486.42C213.864 485.616 214.146 484.686 214.167 483.732C214.189 482.778 213.947 481.836 213.47 481.01C212.859 479.995 211.986 479.164 210.942 478.605C209.899 478.045 208.723 477.777 207.54 477.83C198.54 477.83 174.79 481.64 174.54 481.67L174.23 479.67C175.23 479.51 198.41 475.8 207.53 475.8C209.069 475.747 210.594 476.109 211.945 476.848C213.296 477.587 214.424 478.676 215.21 480C215.853 481.141 216.177 482.433 216.149 483.742C216.121 485.051 215.741 486.328 215.05 487.44C213.73 489.6 210.12 493.11 200.68 493.11Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M180.19 539.67C177.87 539.67 175.47 539.62 172.99 539.52C165.444 539.223 157.921 538.489 150.46 537.32L150.79 535.32C151.18 535.39 190.02 541.87 211.73 532.76C211.86 532.76 220.16 529.66 219.94 523.76L221.94 523.68C222.22 531.09 212.85 534.51 212.45 534.68C204.51 538 193.67 539.67 180.19 539.67Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M154.1 491.73L152.1 491.42C155.33 470.92 159.99 456.58 165.97 448.8C170.61 442.8 174.36 442.98 174.76 443.02L174.55 445.02L174.66 444.02L174.57 445.02C174.44 445 161.5 444.69 154.1 491.73Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M113.26 518.49C98.38 499.75 92.24 480 95 459.86C100.41 420.64 138.27 392.86 138.65 392.6L139.82 394.22C139.45 394.49 102.27 421.78 96.98 460.15C94.28 479.74 100.28 498.95 114.81 517.25L113.26 518.49Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M200.73 506.54H200.29V504.54C210.23 504.6 213.84 502.54 215.14 500.75C215.44 500.374 215.651 499.935 215.757 499.465C215.862 498.996 215.86 498.508 215.75 498.04L217.65 497.4C217.857 498.163 217.888 498.963 217.739 499.74C217.59 500.516 217.265 501.248 216.79 501.88C214.58 505 209.17 506.54 200.73 506.54Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M200.3 518.71V516.71C211.87 516.66 215.54 514.13 216.7 512.62C216.971 512.318 217.171 511.959 217.287 511.57C217.403 511.181 217.431 510.771 217.37 510.37L219.29 509.81C219.434 510.495 219.426 511.203 219.265 511.884C219.104 512.565 218.795 513.202 218.36 513.75C215.94 517 209.87 518.67 200.3 518.71Z",
                fill: "#003C71"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M273.38 500.48L273.5 500.34H273L272.83 499.97L273.31 499.6L273.17 499.49L272.88 499.77H272.62L272.48 499.65L272.37 499.21H272.83V498.96L272.49 498.8V498.53L272 498.13L272.11 497.93H271.78V498.25L271.64 498.14L271.53 497.63L271.7 497.42L272.27 497.37L272.45 497.22L271.72 496.97L271.35 497.14L271.14 496.96L271.42 496.61L271.07 496.26L271.67 495.88L271.39 495.58L270.91 496.02L270.68 495.65L270.73 495.46H271.11L270.69 495.11L270.38 495.27L270.18 495.16V494.91L270.55 494.68L270.4 494.5L269.77 494.63L269.9 494.03L269.55 493.81L270.21 493.29L270.01 493.18L269.59 493.55L269.17 493.2H268.91L268.72 492.58L268.93 492.17H268.73L268.31 492.47L268.01 492.05L268.24 491.71L268.09 491.59L267.65 491.7L267.54 491.2L267.72 491.05H267.52L267.4 491.19L267.19 491.01V490.62L267.03 490.38L266.63 490.16V489.97L266.27 489.68V489.56L264.27 487.5L264.09 487.07L263.09 485.87L262.24 484.47L261.82 484.13V484L261 483V482.54L260.64 482.13V481.81L260.29 481.59L260.11 481.09V480.7L259.87 480.85L259.56 480.43V479.91L259.07 478.91V478.58L258.8 478.48V478.03L258.91 477.83L258.43 476.97V476.71L258.72 476.36L258.51 476.18L258.35 476.59L258.21 476.47V476.02H258.6V475.82L258.06 475.55V475.35L257.78 475.13L257.86 474.6H258.25L257.81 474.12L257.86 473.93L257.62 473.5L257.9 473.08L258.06 473.32L258.24 473.24L258.09 473L257.97 473.08L257.61 472.72V472.46L257.45 472.22V471.32L258 471L257.91 470.75H257.64L257.81 470.47V469.31L258.29 468.94L258.06 468.64L258.15 468.18L258.46 468.09L258.54 467.63L258.46 467.44L258.82 466.57L259.28 465.94L259.46 465.86V465.53L260.25 465V464.61L260.63 464.51L260.73 464.17L262.38 463.3H262.65L263.32 462.91L263.88 462.78L264.11 462.44L264.42 462.34L264.52 462.65L264.87 462.94L265.01 462.41H265.27L265.57 462.77L265.94 462.66L266.09 462.84L267.09 462.74L267.45 463.09L267.64 463.01V463.27L267.85 463.44L268.6 463.24L268.66 463.81L268.87 463.99H269.19L269.24 464.51L269.56 464.41L269.76 464.52L269.86 464.89L270.41 465.16L270.27 465.69L270.86 465.83V466.28L271.29 466.69L271.18 466.89L271.36 467.33L271.07 467.68L271.15 467.87L271.58 467.63L271.78 467.74L271.7 468.2L271.92 468.43V468.69H271.67L271.94 468.79L272.09 469.03V469.54L272.24 469.72L272.14 469.99L272.3 470.94L272.64 471.17L272.55 471.56L272.71 471.8V472.07L272.99 472.3L272.94 473.08L273.17 473.44L273.11 474.09L273.32 474.33L273.17 474.73L273.37 475.42L273.3 476.01L273.54 477.08L273.75 477.26L273.69 479.26L273.51 479.41L272.86 479.28L272.29 479.47L270.29 479.67L269.89 479.52L269.82 478.88L269.91 478.48L269.41 476.01V475.49L269.18 474.55V473.55L269.02 473.24V472.41L268.61 471.54L268.7 471.21L268.29 470.99V470.73L268.14 470.49L268.22 470.03L268 469.79L267.94 469.22L267.46 468.94L267.31 468.7V468L266.76 467.67V467.41H266.57L265.81 466.9H265.62L265.41 466.73L264.17 466.59L263.74 466.89L263.18 467.08L262.97 467.49H262.7L262.45 468.16H262.19L262.08 468.3L262.19 468.8L261.83 469.03L261.92 469.28L261.7 469.69L261.97 469.8L261.62 470.15L261.76 470.91L261.61 471.38L261.82 472.13L261.71 472.34L261.51 472.23L261.42 472.63H261.67L261.85 473.13L261.54 473.94L261.96 474.22L262.04 474.4L261.94 474.67L262.16 474.97L261.86 475.13L262.24 475.67L262.08 476.01L262.48 476.17L262.26 476.57L262.63 476.99L262.46 477.27L263 477.53L262.74 478.08L263.13 478.17L263.22 478.35L262.84 478.52L263.25 478.73V479.13L263.4 479.3H263.91L263.77 479.83L264.37 480.02L264.28 480.36L264.36 480.54L264.68 480.45L264.97 480.8L265.07 481.12L265.33 481.22L265.43 481.47H265.1V481.66L265.39 482.02V482.28L265.54 482.46L265.94 482.61L265.85 483.01L266.51 483.13L266.37 483.66L267.04 483.86V484.18L267.22 484.74L267.59 485.22V485.61L268.18 485.68L267.91 486.22L268.12 486.33L268.6 486.02L268.81 486.13V486.58L268.63 486.8L268.78 486.91L269.28 486.79L269.36 486.92L269.27 487.38L269.8 487.45L269.96 487.82L269.79 488.03L269.93 488.15L270.25 488.05L270.41 488.42L270.23 488.57L270.78 488.84V489.17L271.19 489.45V489.7L271.42 490.07L271.26 490.47L271.86 490.6L271.77 491L272.17 491.15L272.26 491.4L272.15 491.61L272.71 492L272.44 491.9L272.15 492.19L272.29 492.3H272.54L272.65 492.09L272.88 492.39L272.72 492.8L272.93 492.9L273.24 492.81L273.4 493.11V493.38H273.14L273.03 493.52L273.24 493.69L273.55 493.6L273.97 493.88L273.81 494.21L274.22 494.5V494.76L273.87 494.47L273.64 494.75L273.85 494.92H274.43L274.36 495.51L274.7 495.6L274.84 495.78L274.61 496.65L275 496.74L275.29 497.03L275.08 497.5L275.54 497.58L275.7 497.89L275.61 498.29L275.44 498.5L275.59 498.68L275.99 498.83V499.22L276.42 499.63L276.26 499.97L276.42 500.28L276.27 500.62L276.69 501.02L276.53 501.36L276.78 501.85L276.98 501.96L277.25 502.71L277.06 503.38L277.16 503.69L277.04 504.48L277.28 504.9L277.23 505.1L276.99 505.25L277.06 505.96L276.72 506.38V506.7L276 508V508.25L275.53 508.69V509.01L275.07 509.63L274.76 509.73L274.23 510.24L273.71 510.16L273.6 510.43L273.24 510.66L273.09 510.48L272.83 511.02H272.37L270.93 511.48L270.66 511.38L270.17 511.62L269.82 511.34L269.19 511.53L269.1 511.22L268.66 511.39L268.51 511.15L267.72 511.03L267.64 510.85L267.14 510.96L266.85 510.67L266.73 510.74L266.09 510.16L265.69 510.07L264.92 509.44L264.68 509.01L264.18 508.55V508.23L263.71 508.02L263.62 507.83L263.73 507.56L263.64 507.31L263.32 507.41V506.89L262.98 506.67L263.16 506.52L262.82 506.36L262.4 505.43H262.14L262.22 504.97L261.8 504.62H262.18L261.88 504.2L261.83 503.69L261.22 503.37L261.5 502.95L261.35 502.71V502.19L261 501.9H261.25L261.18 501.19L260.82 500.84L260.91 500.38L260.76 499.56L260.55 499.38L260.5 498.94L260.04 498.79L260.37 498.3L260.09 498.07V497.75L259.8 497.39L259.95 496.99L259.8 496.74V496.48L259.57 496.18L259.66 495.79L259.44 495.48L259.54 495.22L259.3 494.79L259.22 493.96L259.33 493.75L259.82 493.51L261.49 493.41L261.72 493.12L262.85 492.82L263.13 492.98V493.69L263.37 494.12L263.27 494.39L263.45 494.95V495.21L263.81 495.57V496.4L264.06 496.96V497.73L264.45 498.4L264.34 498.67L264.57 499.04L264.68 500.04L265.22 501.6V501.86L266.22 504.41L266.52 504.83V505.15L266.74 505.39L266.86 505.89L267.79 506.83H268.05L268.2 507.01L268.73 507.15L269.02 507.51L269.34 507.41L269.61 507.51L269.86 507.42L270.86 507.58L271.3 507.41H271.62L272.04 507.11V506.78L272.47 506.48V506.22L272.53 506.15L272.83 505.86V505.48L273.07 505.33L273.36 504.39L273.27 504.14L273.5 503.86L273.13 503.38L273.5 503.15L273.26 502.72V502.33L272.86 502.18L273.47 501.8L273.12 501.51V501.25H273.38L273.49 501.04L273.4 500.79L273.04 501.09L272.63 500.87L272.97 500.39L273.17 500.49L273.38 500.48ZM258.04 472.48L258.2 472.2L257.93 472.1L257.77 472.38L258.04 472.48ZM258.04 471.9L258.33 471.55L257.96 471.71L258.04 471.9ZM258.75 473.12L258.86 472.91H258.59L258.49 473.17L258.75 473.12ZM258.89 470.71H258.7L258.78 470.9L258.89 470.71ZM258.89 467.42L258.94 467.29L258.76 467.37L258.89 467.42ZM259.18 472.17H258.99L258.93 472.31L259.18 472.17ZM260.42 500V500.19L260.27 500.02L260.42 500ZM260.83 501.51L260.61 501.27H260.8L261.02 501.44L260.83 501.51ZM261.22 472.03L261.42 472.14L261.6 471.99L261.05 471.66V471.86L261.22 472.03ZM261.94 483.71V483.64L261.88 483.71H261.94ZM262.94 480.71L262.99 480.51H262.73V480.77L262.94 480.71ZM265.41 487.95V487.89L265.23 488.04L265.41 487.95ZM265.9 481.9L265.79 482.04V481.85L265.9 481.9ZM266.36 462.68L266.02 462.58L266.49 462.73L266.36 462.68ZM266.7 464.84L266.43 464.67L266.51 464.86L266.7 464.84ZM268.15 463.15H267.82L267.87 463.02H268.13L268.15 463.15ZM268.15 463.92L267.95 463.87V464.07L268.15 463.92ZM268.36 485.85L268.28 485.73H268.47L268.36 485.85ZM269.12 492.85L269 493L269.27 493.1L269.63 492.81L269.41 492.57L269.12 492.85ZM269.37 465.19L269 465H269.07L269.37 465.19ZM270.6 494L270.8 494.1L270.85 493.91L270.64 493.73L270.46 493.88L270.6 494ZM271.1 493.24V493.04L270.91 493.12L271.1 493.24ZM271.23 494.51V494.39H271.1L271.23 494.51ZM271.62 493.83L271.86 493.74L271.78 493.55H271.52L271.41 493.69L271.62 493.83ZM271.81 496.46L271.51 496.68H271.78L272.34 496.49L271.99 496.27L271.81 496.46ZM271.81 510.79V510.66L271.69 510.8L271.81 510.79ZM272.23 498.99L272.05 499.14H271.86L272.02 498.86H272.28L272.23 498.99ZM272.14 492.93H271.94L271.89 493.06L272.14 492.93ZM272.14 491.64V491.51H271.94V491.7L272.14 491.64ZM272.1 498L272.6 497.88L272.46 497.7H272.26L272.1 498ZM272.52 495.76L272.62 495.49H272.42L272.26 495.83L272.52 495.76ZM272.57 500.08L272.39 500.23V500.03L272.57 500.08ZM272.7 493.74L272.8 493.47H272.55L272.44 493.67L272.7 493.74ZM272.95 498.17L272.71 498.32V498.65L273.14 498.48V498.28L272.95 498.17ZM272.88 494.88V494.76L272.71 495.03L272.88 494.88ZM273.04 496.42V496.28L272.9 496.17L272.85 496.3L273.04 496.42ZM272.98 500.36L272.91 500.3L272.99 500.43L273.04 500.36H272.98ZM273.24 499.11H273.11V499.24L273.24 499.11ZM273.33 494.26H273.53V493.88H273.34L273.23 494.08L273.33 494.26ZM273.43 497.8L273.62 497.72L273.41 497.54L273.23 497.69L273.43 497.8ZM273.43 497.22L273.35 497.1L273.3 497.23L273.43 497.22ZM273.59 495.65L273.7 495.45H273.32V495.65H273.59ZM273.68 505.46V505.26L273.49 505.35V505.6L273.68 505.46ZM273.81 502.28L273.61 502.17L273.5 502.37L273.64 502.55L273.89 502.46L273.81 502.28ZM273.87 504.79L273.78 504.54L273.67 504.75L273.87 504.79ZM273.87 498.4V498.27L273.75 498.41L273.87 498.4ZM274 503H273.81V503.19L274 503ZM273.86 503.53V503.79H274.12V503.41L273.86 503.53ZM274.1 496.27L274.45 495.92H274.07L273.85 496.33L274.1 496.27ZM274.26 501.68V501.55L274.06 501.5V501.7L274.26 501.68ZM274.42 497.53L274.53 497.39H274.33L274.22 497.53H274.42ZM274.74 498.79L274.66 498.67V498.8L274.74 498.79ZM275.2 496.36V496.55H275L274.92 496.37L275.1 496.22L275.2 496.36ZM277.09 501.59V501.85L276.87 501.55L277.09 501.59Z",
                fill: "#0067A5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M288 499.4L288.18 499.32V499.77L287.98 500.31L288.28 500.73L288.12 501.73L287.95 501.94L288.23 502.24V503.14L288.45 503.38L288.33 504.16L288.51 504.66V504.99L288.74 505.99V506.51L288.92 507V507.46L289.19 508.21L289.11 508.67L288.26 508.62L287.76 508.8L287.18 508.73L286.88 508.96L286.67 508.85L285.56 508.76L285.32 508.27V507.44L285.16 507.13L285.08 505.65L284.92 505.41L284.72 504.01L284.48 503.58L284.61 502.99L284.29 502.31L284.11 500.52L284.19 500.06L283.66 494.75L283.39 493.36L283.49 493.09V492.71L283.34 492.47V491.95L283.51 491.74L283.23 491.51L283.33 491.24L283.22 490.73L283.37 490.33L283.22 490.09V489.83L283.03 489.26L283.2 488.99L282.98 488.82L282.87 488.31L282.94 487.72L282.85 487.47L282.95 487.14L282.75 486.51H283.02L283.39 487.06L283.52 486.98L283.35 486.61L283.52 486.4H283.19L282.87 485.78L282.59 485.55V485L282.95 485.28L283.25 485.06L282.98 484.96L282.93 484.51L283.03 484.18L282.95 484.05L282.65 484.22L282.59 483.64L282.77 483.49L282.55 483.26L282.44 482.82L282.7 482.14L282.31 481.54V481.15L282.55 480.94V480.49L282.16 479.88L282.62 479.96L282.85 480.33L282.99 479.73L282.84 479.62L282.54 479.78L282.47 479.14L282.91 478.97L282.76 478.79L282.27 479.03L282.08 478.47L282.38 478.24L282 478V477.74L281.82 477.24L281.99 477.03L281.89 476.66L281.99 476.39L281.88 475.3L281.63 474.75L281.78 474.34L281.57 472.88L281.68 472.68V471.84L281.53 471.59V471.27L281.84 471.17L281.63 470.94V469.94L281.87 469.79L281.58 469.5V469.24L282 469V468.23L282.15 467.23L282.44 466.88V466.37H282.76L282.88 465.59L283.13 465.5V465.24L283.31 465.09V464.83L283.56 464.74L283.67 464.53V464.21L284 464V463.75L284.28 463.27L284.58 463.11L284.98 462.55L286.69 461.6L287.15 461.69L287.43 461.27L287.8 461.1L288.07 461.21L289.14 460.91L289.61 461.12L289.71 460.85L290.16 460.8L290.37 460.97H290.7L290.93 460.68L291.48 461.08L291.85 460.91V461.11L292.06 461.21H292.5L292.72 461.38L292.63 461.78L293 461.61L293.65 461.68L294.14 462.68L294.37 462.34L294.51 462.45L294.46 462.65L294.61 462.83H295.06L295.31 463.45L295.72 463.61L295.62 463.94L295.77 464.12L296.14 464.02L296.2 464.59L296.67 464.74V464.99L296.33 464.9L295.67 465.35L295.87 465.46L296.36 465.22L296.9 465.42L296.73 465.63L296.42 465.73L296.31 465.93L296.46 466.18L296.7 466.02L297.23 466.1L296.77 466.66L296.63 467.19L296.38 467.35L296.6 467.52L297.1 467.4V467.01H296.9L296.81 466.82L297.58 466.75L297.63 467.19L298.04 467.48L297.89 467.88L298.31 468.22H297.99L297.7 468.57L297.91 468.75L298.42 468.69L298.33 469.09L298.02 469.25L298.23 469.36L298.54 469.26L298.75 469.44V469.69L298.1 469.63L297.69 470.06V470.18L298.52 470.1L298.3 470.51L298.39 470.7L298.76 470.59L298.91 470.77V471.03L298.66 471.12L298.26 470.91L298.04 471.32H298.49L299.02 471.46L298.65 471.63L298.59 471.76L298.75 472H299.07L299.16 472.24L299.05 472.39L298.46 472.31L298.16 472.48L298.11 472.67L298.31 472.78L298.82 472.67L299.02 472.78L299.27 472.62V473L298.93 472.91L298.65 473.33L299.16 473.27L299.22 473.78L299.5 474.08L299.29 475.13L299.71 475.48L299.48 475.82L299.57 476.07L299.42 476.48L299.9 476.75L299.63 477.23L299.77 477.41L299.25 477.98L299.33 478.1L299.56 477.82L300.03 478.03L299.76 478.57L299.69 479.16L300.02 479.26L300.19 479.63L299.9 479.92L300.17 480.02L300.32 480.26H299.99V480.46H300.25L300.42 481.46L300.31 481.66L300.54 482.03L300.39 482.43L300.55 482.8L300.62 483.51L300.53 483.9L300.81 484.71L300.66 485.18L300.76 485.49L300.48 485.91L300.81 486V486.32L300.37 486.43H300.7L300.93 486.79L300.82 486.99L300.93 487.43L300.44 487.74L300.85 487.9V488.41L300.48 488.57L300.62 488.75L300.96 488.85V489.56L301.18 490.44L301.07 491.23L301.23 491.6L301.38 493.71L301.62 494.2L301.47 494.54L301.68 495.42L301.61 495.95L302 497L301.83 497.27L302.07 497.7L302.12 498.21L301.89 498.49V498.81L302.13 499.24V499.63L301.96 499.84L302.04 500.03L302.26 502.13L302.1 502.47L302.25 502.72L302.39 503.41V504.51L302.5 505.02L302.4 505.29L302.52 505.85V506.63L302.74 507.52L302.13 507.84L301.53 507.7L299.29 507.86L298.89 507.71L298.78 506.63L298.85 506.1L298.74 505.01L298.85 504.81L298.21 498.42V497.51L298.04 497.14L298.13 496.74L297.96 496.37H297.71L297.55 496.77L296.93 496.38H296.61L296.39 496.73L295.71 496.41L295.56 496.81L294.96 496.61L294.65 496.71L294.47 496.92L294.19 496.69L293.62 496.81L293.26 497.04L292.79 496.9L292.18 497.22L291.56 496.83L291.46 496.51L290.99 496.37V496.89L290.62 497.05L290.38 496.56L290.07 496.66V496.92L290.22 497.16L290.56 497.32L290.45 497.53H290.26L289.91 497.25H289.58L289.47 496.74L289.26 496.63L289.15 496.77L289.23 496.96L289.12 497.16L289.54 497.44L289.49 497.64L289.24 497.73L288.75 497.33L288.47 497.75L287.96 497.8L287.78 497.94L288.13 498.23V498.49L287.9 498.77L288.13 499.14L287.9 499.36L288 499.4ZM282.35 474.79L282.26 474.54L282.17 474.94L282.38 475.04L282.35 474.79ZM282.35 477.79L282.6 477.64L282.46 477.53L282.27 477.61L282.35 477.79ZM282.4 476.31V476.11L282.3 476.45L282.4 476.31ZM282.4 478.5L282.49 478.75L282.6 478.55V478.23H282.47L282.4 478.5ZM282.59 484.88H282.46L282.56 484.67L282.59 484.88ZM282.98 481.74L282.84 481.56L282.66 481.71L282.98 481.74ZM282.98 481.09H282.73V481.28L282.98 481.09ZM282.82 482.66L282.97 482.84L283.12 482.43H282.79L282.82 482.66ZM283.14 478.17H283L283.08 478.3L283.14 478.17ZM283.14 480.37L283.27 481L283.48 481.11L283.59 480.97L283.39 480.28L283.14 480.37ZM283.44 482.02V482.28L283.62 482.19V481.87L283.97 481.51L283.29 481.77L283.44 482.02ZM283.74 485.02L283.92 484.88L283.65 484.77L283.42 484.99L283.74 485.02ZM283.62 488.26L283.48 488.21L283.43 488.35L283.62 488.26ZM283.71 489.26L283.5 489.09V489.29L283.71 489.26ZM283.49 483.26L283.66 483.04L283.49 483.19V483.26ZM283.75 484.59L283.8 484.39H283.6V484.59H283.75ZM283.94 485.73L283.74 485.68L283.68 485.82L283.94 485.73ZM283.79 481.1H283.86V480.97L283.79 481.1ZM283.94 494.77V494.7L283.82 494.78L283.94 494.77ZM283.94 488.51L284.12 489.01V488.49L284.42 488.2H284.03L283.94 488.51ZM283.94 483.79L284.15 483.9L284.38 483.62H284.64L284.75 483.41H284.49L283.92 483.59L283.94 483.79ZM284.25 490.09V489.7H284.06L283.95 489.9L284.25 490.32V490.09ZM284.25 485.19L284.37 485.04H284.11L284.25 485.19ZM284.25 479.11L284.11 479.06V479.25L284.25 479.11ZM284.36 479.56L284.27 479.37L284.16 479.51L284.36 479.56ZM284.49 480.83H284.29V480.96L284.49 480.83ZM292.18 465.53H291.86L291.36 465.13H291.1L290.95 464.89L290.21 464.64L289.9 464.74L289.25 464.67L289.01 464.89L288.44 464.95L287.84 465.4H287.64L287.48 465.74L287 466V466.33L286.76 466.54L286.16 467.64L286.25 467.89L286.16 468.22L285.66 468.46L285.89 468.76L285.73 469.1H285.59V469.81L285.74 470.05L285.64 470.32L285.39 470.41V470.61L285.69 471.03L285.47 471.44V471.83L285.61 472.01L285.55 473.95L285.7 474.19V474.46H285.25V474.66L285.65 474.81L285.57 475.34H285.38L285.66 476.21L285.8 476.33L285.28 476.96L285.07 477.43V477.75L285.21 477.93L285.46 477.84L285.37 477.53L285.51 477.06L285.7 477.62L285.47 477.97L285.55 478.67L285.69 478.85H285.96L286.03 478.97L285.92 479.18L285.23 479.38L285.65 479.66V479.92L285.4 480.01L285.3 480.28H285.5L285.68 480.13L285.82 480.31V480.51L284.92 480.6L284.75 480.81L284.85 481.13L284.75 481.39L284.44 481.55L284.71 481.66L285.01 481.5L285.47 481.58L285.65 481.37H285.26L285.1 481L285.21 480.79L285.71 480.68L285.9 481.24L286.38 481.51L285.95 481.75H285.69L285.57 481.89H285.83L286.01 482.32L285.58 482.62V482.88H285.77L286 482.53H286.26L286.4 482.71V483.03L286.02 483.13L285.74 482.91L285.57 483.12L285.06 483.23V483.43L285.26 483.54L285.49 483.26H285.87L286.11 483.69V483.88H286.49L286.6 484.32L286.42 484.46L286.02 484.37L285.15 484.66L284.82 484.56L284.97 484.8L285.51 485.07L285.56 484.87L285.79 484.66L286.27 484.87V485.06L285.84 485.24L285.51 485.14L285.6 485.46L285.87 485.56L286.35 485.25L286.62 485.35L286.71 485.6L286.6 485.81L286.36 485.9L286.25 486.16L286.39 486.22L286.69 486.06L286.84 486.23L286.47 486.4V486.6H286.73L286.88 486.78L286.83 486.97L286.47 487.27L286.53 487.84H286.92L287.02 488.15L286.91 488.36H286.65V488.69L287.03 488.59L287.18 488.77L287.02 489.17L287.13 489.61L286.72 490.04L287.17 489.99L287.38 490.16L287 491L286.59 491.49L286.9 491.33L287.2 491.76L286.98 492.1L287.13 492.34L287.23 493.34L287.12 493.55L287.28 493.79L287.18 494.06L287.55 493.96L287.89 494.76H288.22L288.66 495.29H288.92L288.67 494.8L288.25 494.45V494.19L288.55 493.97L288.76 494.08L289 494.51H289.26L289.65 495.18H289.85L289.94 495.43L290.29 495.78L290.38 495.39L289.81 494.86L289.9 494.46H290.22L290.44 494.7L290.55 494.49L290.34 494.39L290.2 493.56L290.59 493.65L290.77 494.15L290.61 494.49H290.81L290.98 494.28L291.33 494.5V494.82L291.82 494.58V494.33L291.57 494.42L291.36 494.31L291.59 494.02L291.3 493.67H291.62L291.79 494.1H292.17L292.66 494.44L292.41 493.82V493.95L292.2 493.78L292.3 493.51L292.57 493.61L292.8 493.97L293.17 493.87L293.31 493.28L293.77 493.42L293.93 493.67H294.25L293.95 493.32L294.13 493.1L294.4 493.21L295.08 492.94L295.54 493.03L296.15 492.71L296.43 492.87L297.04 492.55L296.69 492.27H297.14L297.44 492.7V491.6L297.61 491.39L297.39 491.09L297.49 490.82L297.27 490.52L297.47 489.98L297.26 489.81L297.42 489.47L297.15 489.3L297.06 489.05L297.28 488.71V488.25L297 488.09L296.91 487.84L297.19 487.36V486.84L296.84 486.55V486.23L297.2 485.94L297.05 485.76V485.5L296.68 485.02L296.89 484.61L296.96 484.02L296.73 483.59L296.89 483.25L296.83 482.74L296.61 482.44L296.76 482.04L296.59 481.61L296.48 480.52L296.34 480.4L296.44 480.07L296.28 479.77L296.5 479.42L296.17 479.32V479L296.46 478.65V478.21L296.05 477.99V477.53L296.16 477.39H296.42L296.47 477.26L296.24 476.89V476.63L295.88 476.28L295.99 476.08L296.24 475.99V475.72H295.92L295.71 474.9L295.81 474.63H296.07L296.19 474.49L295.98 474.31L295.74 474.53L295.57 473.45L295.41 473.21L295.56 472.74H295.82L296.07 472.59L296.51 472.54L296.72 472.65L296.83 472.51L296.29 472.24L295.61 472.57L295.44 472.2L295.55 471.99L295.99 471.88L295.9 471.63L295.7 471.53L295.35 471.88L295 471.66V471.33L295.24 471.25L295.35 470.98L295.01 470.82L295.3 470.53L294.84 470.45L294.76 470.26L295.15 469.7H294.95L294.66 469.99L294.41 469.43L294.57 469.09L294.24 469L293.96 468.12L294.44 467.81L293.68 467.96L293.57 467.52L293.87 467.23L293.39 467.02V467.21L293.14 467.3L293.09 466.79L293.19 466.52L292.94 466.61L292.58 466.2V465.87H292.32L292.17 465.7V465.38L292.18 465.53ZM284.77 484.29L284.62 484.05L284.37 484.2V484.39L284.58 484.5L284.77 484.29ZM284.4 483L284.58 482.85L284.33 482.94L284.4 483ZM284.69 491L284.47 490.77L284.37 490.97L284.69 491ZM284.69 489L284.49 488.89L284.38 489.1L284.69 489ZM284.58 478.3L284.45 478.24V478.31L284.58 478.3ZM284.58 479.78L284.76 479.63H284.57L284.58 479.78ZM284.66 485.71L284.84 485.5H284.58L284.66 485.71ZM285.08 482.71L285.19 482.57H285L284.82 482.72L285.08 482.71ZM284.99 488.86L285.16 488.71L285.03 488.59L284.84 488.68L284.99 488.86ZM284.99 471.3H285.18H284.98H284.99ZM285.15 479.3L285.28 478.7L284.98 478.93L285.15 479.3ZM285.15 476.65L285.01 476.54V476.66L285.15 476.65ZM285.06 484.08L285.3 483.93H285.05L285.06 484.08ZM285.21 490.01H285.08L285.22 490.13L285.21 490.01ZM285.41 474.01L285.32 473.83L285.14 473.97L285.23 474.22L285.41 474.01ZM285.52 486.72L285.74 486.89L285.92 486.81L285.77 486.63L285.31 486.55V486.68L285.52 486.72ZM285.52 486.07H285.33L285.42 486.26L285.52 486.07ZM285.52 469.07L285.38 468.96V469.08L285.52 469.07ZM285.58 490.89L285.69 490.68L285.47 490.45L285.39 490.91L285.58 490.89ZM285.58 484.24L285.82 484.09L285.68 483.97H285.43L285.58 484.24ZM285.93 490.24V489.98L285.62 490.14L285.93 490.24ZM285.87 476.82V477.01H285.74V476.82H285.87ZM286.07 479.51V479.77L286 480V479.61L286.07 479.51ZM286.07 490.88H286.33L286.24 490.63H285.98L286.07 490.88ZM286.34 492.33L286.52 492.12H286.32L286.14 492.27L286.34 492.33ZM286.34 482.07V482.19H286.22V482.06L286.34 482.07ZM286.5 483.6L286.37 483.68L286.29 483.49L286.5 483.6ZM286.33 493.5L286.48 493.68L286.71 493.39L287.02 493.3L286.75 493.19L286.58 493.41L286.33 493.5ZM286.67 489.14H286.4V489.33L286.67 489.14ZM286.75 487.39V487.65L286.6 487.4L286.75 487.39ZM286.85 492.93L286.9 492.73L286.78 492.81L286.85 492.93ZM288.42 496.93V496.67H288.29V496.99L288.42 496.93ZM288.83 496.5L288.88 496.36H288.63L288.83 496.5ZM289.83 494.14L289.67 494.48L289.31 494.13L289.41 493.86H289.74L289.83 494.14ZM289.48 496.43H289.94L289.82 495.99H289.44L289.48 496.43ZM290.53 494.71V494.98L291.34 495.41L291.24 495.03L290.97 494.93L290.53 494.71ZM291.25 497.29V497.1L291.43 497.01L291.58 497.19L291.25 497.29ZM291.92 496.29V495.84L291.46 495.69L291.58 496.26L291.92 496.29ZM291.59 461.65L291.48 461.79L291.55 461.91L291.59 461.65ZM292.29 495.48L292.39 495.28L292.24 495.03H291.98L292.29 495.48ZM292.23 496.84L292.47 496.69L292.52 496.49L292.38 496.37L292.13 496.53L292.23 496.84ZM292.71 494.53L292.52 494.62L292.66 494.73L292.71 494.53ZM292.65 495.9H292.91V495.65L292.7 495.54L292.58 495.62L292.65 495.9ZM293.35 496.41H293.48L293.6 496.27L293.45 496.09L293.02 496.26L293.35 496.41ZM293.4 464.89H293.27V465L293.4 464.89ZM293.74 494.49L293.85 494.35L293.65 494.24L293.47 494.46L293.74 494.49ZM293.58 466.04L293.63 465.9L293.51 465.98L293.58 466.04ZM293.77 462.79V462.6H293.58L293.66 462.78L293.77 462.79ZM293.85 495.64H293.78V495.7L293.85 495.64ZM294.18 466.82L294.29 466.68H294.1L294 467L294.18 466.82ZM294.1 465.4L294.34 465.19L294.13 465.08L294.02 465.28L294.1 465.4ZM294.18 496.32H294.44L294.54 496.11H294.28L294.04 496.27L294.18 496.32ZM294.41 464.66H294.22V464.79L294.41 464.66ZM294.48 463.36L294.92 463.26L294.57 463.03L294.4 463.24L294.48 463.36ZM294.75 466.05L294.86 465.84H294.6L294.49 466.04L294.75 466.05ZM294.75 464.63L294.94 464.55L294.73 464.37L294.55 464.59L294.75 464.63ZM295.06 463.82H294.8L294.75 464.01L295.06 463.82ZM295.06 468.82L294.92 468.7V468.9L295.06 468.82ZM295.06 465.33L294.92 465.22V465.35L295.06 465.33ZM295.06 467.33V467.14V467.34V467.33ZM295.18 493.54H295.38V493.4H295L295.18 493.54ZM295.08 469.46L295.77 469.26L295.44 469.17L295.08 469.46ZM295.33 496.23L295.56 496.02H295.11L295.33 496.23ZM295.84 464.16L295.25 464.67L295.82 464.61L296.05 464.33L295.84 464.16ZM295.43 465.16L295.48 465.02H295.28L295.43 465.16ZM295.58 467.98V467.79L295.34 467.94L295.58 467.98ZM295.58 465.85L295.47 465.99L295.73 466.1L296.09 465.74H295.76L295.58 465.85ZM295.81 470.74H296.07L295.92 470.5H295.72L295.62 470.7L295.81 470.74ZM296.2 470.12L296.5 469.83L296.29 469.66L296.1 469.74L295.88 470.15L296.2 470.12ZM296.11 467.29L296.16 467.09H295.96L295.91 467.29H296.11ZM296.11 468.7L296.28 468.49L296.2 468.37H295.95V468.63L296.11 468.7ZM296.34 467.78L295.91 468.08L296.62 468.01L296.77 467.6H296.57L296.34 467.78ZM296.11 471.35H296.3L296.41 471.15H296.09L295.92 471.3L296.11 471.35ZM296.11 473.48H296.31L296.15 473.24H295.95V473.5L296.11 473.48ZM296.3 496H296.11L295.99 496.14L296.3 496ZM296 469.41L296.2 469.52L296.82 469.26V469.07L296.62 468.96L296.19 469.26L296 469.41ZM296.23 475.59V475.46H296.03L296.23 475.59ZM296.31 466.73L296.46 466.33H296.2L296.12 466.79L296.31 466.73ZM296.52 472H296.2L296.46 472.1L296.91 472.05L297.02 471.85L296.93 471.6H296.73L296.52 472ZM296.66 474.06L296.57 473.81L296.32 473.9V474.15L296.54 474.33L296.66 474.06ZM296.66 475.48V475.21H296.46V475.47L296.66 475.48ZM296.82 470.68L297.01 470.6L296.85 470.29L296.57 470.71L296.82 470.68ZM296.91 477.91L296.71 477.86L296.66 477.99L296.91 477.91ZM296.91 467.91L296.8 468.05L296.99 468.1L297.42 467.86H297.81L297.65 467.62H297.45L297.1 467.91H296.91ZM296.91 473.46L297.03 473.32L296.95 473.2L296.77 473.28L296.91 473.46ZM296.96 470.1L297.4 469.99L297.17 469.63L296.92 469.72L296.77 470.12L296.96 470.1ZM296.96 474.68L297.07 474.48L296.83 474.63L296.96 474.68ZM297.18 468.53L296.98 468.42L296.86 468.56L297.18 468.53ZM297.24 496.09L297.35 495.89L297.02 495.79V496.05L297.24 496.09ZM296.98 471.09V471.28L297.58 471.41L297.75 471.2L297.21 470.93L296.98 471.09ZM297.22 472.74H298V472.61L297.52 472.4L297.22 472.56V472.74ZM297.08 475.92L297.22 475.97L297.14 475.85L297.08 475.92ZM297.61 468.92L297.18 469.09V469.29L297.69 469.24L297.8 469.03L297.61 468.92ZM297.33 471.92L297.15 472.06L297.35 472.11L297.91 471.92V471.66H297.52L297.33 471.92ZM297.26 473.73V473.92L297.47 474.03L297.58 473.83L297.49 473.64L297.26 473.73ZM297.66 475.24L297.46 475.13L297.35 475.27L297.66 475.24ZM297.55 470.24L297.45 470.51L297.96 470.46L297.8 470.15L297.55 470.24ZM297.71 473.06V473.33H297.97L298.08 473.19L297.99 472.94L297.71 473.06ZM298.17 474.44L298.02 474.19L297.84 474.34L297.92 474.53L298.17 474.44ZM298.31 471.97L298.42 471.77H298.1L298.31 471.97ZM298.31 476.97L298.11 476.86L298.06 477.06L298.31 476.97ZM298.38 473.8L298.57 473.72L298.36 473.54L298.18 473.69L298.38 473.8ZM298.51 475.08H298.77L298.54 474.78L298.31 475.06L298.51 475.08ZM298.51 476.37L298.64 476.42V476.16L298.52 476.31L298.51 476.37ZM298.77 477.7V477.51L298.54 477.73L298.77 477.7ZM298.96 474.39L299.06 474.12L298.85 474.01L298.67 474.16V474.41L298.96 474.39ZM299.06 475.39H298.87V475.59L299.06 475.39ZM299.28 476.98L299.34 476.85H299.07L299.28 476.98ZM299.22 478.28H299.42V478.16L299.22 478.28ZM299.79 483.9L299.9 483.7L299.65 483.85L299.79 483.9ZM299.97 487.05L300.16 486.96H299.9L299.97 487.05ZM300.1 478.64H299.97V478.44L300.1 478.64ZM300.27 483.64L300.13 483.52L300.02 483.66L300.27 483.64ZM300.22 483.06H300.02L300.11 483.25L300.22 483.06ZM300.34 484.92L300.39 484.79L300.14 484.88L300.34 484.92ZM300.8 488.92H300.55V489.11L300.8 488.92Z",
                fill: "#0067A5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M312.49 458L312.9 458.22L313.25 457.86L313.5 457.77L313.68 458.21H314.06L314.37 458.69L314.26 458.9L314.54 459.13V458.8L314.92 458.7L315.03 459.2L315.38 459.43L315.47 459.09L315.93 459.18L315.84 459.51L316.23 459.6L316.14 459.93L316.44 460.35L316.97 460.49V460.94H317.23L317.54 461.42L317.23 461.52L317.12 461.72L317.33 461.96H317.79L318.33 462.81L318.1 463.15L318.25 463.33H318.58L318.74 463.7L318.24 463.88V464.2L318.45 464.37L318.61 464.1L318.97 464.39L319.02 464.9H318.56V465.28L318.75 465.2L319.15 465.35L319.24 465.6L319.74 466.13L319.4 466.55L319.55 466.8H319.81L320.05 467.23L319.68 467.46L319.83 467.64L320.16 467.73L320.23 468.44L320.57 469.24L320.85 469.41L320.93 469.59L320.78 470.06L321.43 470.71H321.81L321.7 470.2V469.2L321.81 468.99L322.14 469.09V468.9L321.93 468.72L322.16 467.8L322.01 467.55L322.08 467.03L322.26 466.88L322.17 466.63L322.33 466.23L322.18 466.05L322.38 465.51L322.24 465.34V464.75L322.53 465.05L322.64 464.84L322.47 464.41V463.18L322.82 463.47L322.92 463.14L322.65 463.03V462.71L322.79 462.18L322.63 461.94L322.81 461.15L323.09 460.67L323 460.42L323.09 459.42H323.41L323.59 459.28L323.8 459.45L324.05 460.01L324.29 459.85L324.03 459.17L323.55 458.96V458.7L323.96 458.92V458.15L324.07 457.94L324.5 458.35L324.61 458.21L324.51 457.77L324.6 457.44L325.08 457.71V457.13L325.25 456.92L325.67 457.26L326.13 457.35L326.36 457.71L326.15 458.12L326.57 458.46L326.43 459.06L326.78 459.28L326.89 459.14L326.84 458.57L326.48 458.21L326.62 457.68L327.09 457.83L327.16 458.53L327.3 458.71L327.48 458.56V457.92L327.76 458.15L328.22 457.59H328.48L328.59 457.39V456.87L329.01 457.21L328.95 457.93L329.62 457.48L329.85 457.84L329.76 458.24L329.64 458.31L329.48 458.07L329.32 458.41L329.47 458.59L329.97 458.41L330.26 458.12L330.41 458.3V458.5H330.02L330.15 459.13L330.3 459.31V459.05L330.74 458.88L330.89 459.06V459.51L331.03 459.63L331.23 460.32L331.18 460.52L331.4 460.75L331.32 461.21L331.66 461.44L331.58 461.96L331.68 462.27L331.89 462.45L331.63 463.05L331.98 463.34V463.6H331.85V463.92L332.16 464.41L331.85 464.63L332 464.81L332.3 465.81L332.16 465.69L332.11 465.83L332.26 466.07L332.48 467.01L332.34 467.48L332.49 467.73V468.73L332.66 469.17L332.5 469.44L332.67 469.88L332.57 470.21H332.32L332.21 470.41L332.38 470.78H332.7L332.8 471.22L332.55 471.31L332.46 471.64L332.93 471.79L333.03 472.23L332.59 472.34L332.82 472.64L333.01 473.27L332.91 473.53L333.02 474.04H332.77L332.6 474.26L332.8 474.36L333.04 474.21L333.29 474.7L333.18 474.97L333 475.05L332.91 474.8L332.73 474.95L332.84 475.39H333.17L333.25 475.64L333.15 475.85H332.89L333.29 476.65H333.1L333.22 477.22L333.43 477.39L333.66 479.63H333.21L333.29 479.82L333.67 479.71L333.78 480.22L333.68 480.49L333.47 480.31L333.29 480.46L333.51 480.76L333.69 480.61L333.75 481.19L333.58 481.4L333.73 481.64L333.78 482.16L333.61 482.37L333.96 483.24L333.85 483.51L334.11 484.77L334.02 485.1L334.24 485.4L334.09 485.87L333.79 486.03L334.05 486.13L334.29 486.56L334.19 486.83L333.94 486.92L333.89 487.05L334.24 487.34V487.85L334.15 488.25L334.45 489.9V490.48L334.62 490.91L334.53 491.24L334.72 491.81V492.13L334.94 492.95H334.67L334.81 493.07L335.19 495.55L335.35 495.79V496.31L335.62 498.93L335.8 499.49L335.91 500.49L335.68 500.78L336.04 502.42V502.87L336.26 503.17L336.19 503.76L336.28 504.01L336.1 504.16L335.35 504.36L335.01 504.27L332.45 504.4L332.2 503V502.42L331.95 501.15L331.76 499.3L331.58 498.8L331.65 498.21L331.47 497.71V497.26L331.29 496.76L331.39 496.43L331.06 494.43L331.15 494.03L330.91 493.54L331.07 493.27L330.95 492.7L331.31 492.41L330.67 491.82L330.75 491.36L330.46 491.01V490.75L330.74 490.27L330.56 489.84L330.67 489.57V489.18L330.51 488.94L330.6 487.83L330.43 487.46L330.34 485.92L330.7 485.69L330.3 485.54L330.13 485.11L330.22 484.71L330.46 484.56L330.04 484.28L329.95 484.03H330.28L330.36 483.57L330.01 483.28L330.14 482.69L329.99 482.44V480.82L329.84 480.58L330.05 480.11L329.91 479.99V479.8L329.7 479.62L329.85 479.16L329.68 478.79L329.34 478.56L329.58 478.41V478.02L329.35 477.59L329.49 477.06L329.34 476.88L329.29 476.37L329.4 476.17L329.23 475.8L329.34 475.59L329.62 475.76L329.79 475.55H329.53L329.1 475.14V474.81L329.37 474.98L329.42 474.78L329.27 474.6V474.28L329.12 474.1L329.03 473.1L329.1 472.58L328.95 472.34L328.84 470.67L328.69 470.43V470.16L328.97 470.39V469.94L328.83 469.83L328.58 469.92V469.65L328.36 469.42L328.25 468.98L328.43 468.83L328.13 468.41L328.03 466.8L328.3 466.9L328.43 466.25L328.31 465.74H328.19L328.08 466.01L328.2 466.52L328.08 466.66L327.94 466.48L328 466L327.84 465.7L327.79 463.96L328 464.07L328.09 464.96L328.23 465.14L328.34 464.94L328.21 463.59L327.82 462.99L327.72 463.19L328.01 463.55L327.64 463.78V463.39L327.49 463.15V462.57L327.34 462.32L327.44 461.41L326.88 461.59L326.58 461.17L326.28 461.4L325.7 460.81L326.05 461.68L325.75 461.9L325.84 462.21L326.21 462.63H326.53L326.48 462.83L326.23 462.92L325.49 462.6L325.4 462.35L325.26 462.82L325.55 463.18V463.43L325.7 463.55L325.85 463.15H326.04L326.28 463.57L326.23 463.77L325.77 463.69L325.59 463.84L325.7 464.21L325.12 464.27L325.17 464.72H325.49L325.84 464.95V465.46L325.99 465.7L325.89 465.97L325.98 466.22L325.88 466.55L325.63 465.93H325.37L325.26 466.08L325.67 466.94L325.57 467.21L325.74 467.64L325.52 468.05L325.57 467.92L325.22 467.63L325.1 467.71V467.96L325.38 468.26L325.56 468.11L325.77 468.28L325.87 468.59L325.69 468.74H325.17L325.42 469.23L325.19 469.51L325.58 470.18L325.47 470.39H324.95L325.2 470.94L325.11 471.34L325.23 471.91L325.12 472.05V472.88L324.68 473.06L324.98 473.48V474.32L324.8 474.47H324.48L324.37 474.68L324.93 475.14V475.39L324.5 475.57L324.45 475.76L324.73 475.99L324.5 476.28L324.66 476.52L324.71 477.09L324.55 478.01L324.37 478.16L324.57 479.5L324.36 479.97L324.51 480.21V480.47L324.09 480.71L324.45 481.13L324.22 481.41L324.29 482.11L324.08 482.58L324.24 482.89L323.88 483.12L323.31 483.24L323.13 483.39L322.8 483.3L321.34 483.63L320.62 483.51L320.38 483.67L320.24 483.55V483L319.91 481.1L319.22 478.1V477.71L318.63 476.99L318.81 476.84L318.62 476.28L318.41 476.11L318.56 475.71L318.2 475.29L318.11 474.4L317.53 471.81L317.37 471.56V471.18L317.01 470.77L316.96 470.25L316.75 470.15L316.86 469.88L316.45 469.72L316.04 468.15L316.13 467.82L315.7 467.35L315.77 466.76L315.43 466.6V465.89L315.54 465.69L315.2 465.52L315.15 465.66L314.68 464.87L314.43 464.96L314.07 464.61L313.97 464.17H314.22V463.91L314.07 463.8V464.06L313.86 463.95L313.62 463.46L313.8 463.31L313.35 462.71V462.33H313.09L312.53 461.87L312.25 462.29L312.42 462.72L312.21 463.19L312 463V463.2L312.21 463.37L312.38 463.87L312.21 464.08L312.14 464.61L312.35 464.84V464.98L312.5 465.16L312.36 465.69L312.11 465.78V466.36H312.43L312.51 466.48L312.14 466.64V466.96L312.41 467.07L312.12 467.42L312.54 468.34L312.43 468.55L312.6 470.27L312.43 470.49L312.28 470.31V470.57L312.9 470.96L312.62 471.37L312.52 471.06L312.34 471.21L312.79 471.81V472L312.48 472.16L312.89 473.02L312.81 473.48L312.98 474.48L312.87 474.68H312.67L312.98 475.16L312.71 475.06L312.87 475.43L312.77 475.7L313.08 476.19V476.51L312.92 476.85L313.13 477.6L313.02 477.8L313.21 479.01L313.12 479.47L313.24 480.04L313.08 480.32L313.23 481.14L313.11 481.28L313.57 484.53L313.47 484.86L313.59 485.43L313.39 485.97L313.48 486.22L313.35 486.88L313.57 487.76L313.46 487.96L313.73 488.77L313.68 489.49L313.84 489.8V490.24V492.31L313.61 492.59L313.85 493.08V493.6L314.05 494.29L313.97 494.81L314.2 495.76L314.1 496.09L314.29 496.65L314.13 497.06L314.32 497.62L314.13 498.28V499.38L314.31 499.88V500.46L314.63 502.46L314.54 502.79L314.67 503.48L314.53 503.95L314.74 506.06L314.28 505.98L314 506L311.94 506.08L311.74 505.97L311.1 506.03L310.86 505.6L311 505L310.72 502.9L310.95 502.56L310.79 502.31L310.85 501.6L310.68 500.52L310.78 499.6L310.63 499.43L310.69 498.77L310.47 498.47L310.4 497.13L310.57 496.91L310.28 496.56L310.4 495.9L310.21 495.27L310.35 494.68L310.25 494.36L310.16 492.18L310 492V491.48L310.17 491.21L309.86 490.66L310.17 490.56L309.92 490L310 489.54L309.9 489.17L309.84 487.3L309.67 486.87L309.83 486.59L309.7 485.89L309.81 485.69L309.57 485.26L309.4 484.26L309.67 483.71L309.33 483.49L309.6 482.94L309.44 481.41L309.67 481.13L309.17 480.6V480.34L309.61 480.16L309.39 479.93V479.67L309.03 479.38L309.3 479.49L309.54 479.27L309.44 478.96L309.08 478.6L309.15 477.95L309.63 477.58L309.45 477.15H309.2L309.05 476.97L309.11 476.26L309 476L309.34 475.51L309.05 475.28V475.03L309.22 474.82L308.9 474.2L308.95 474L309.2 473.91L308.87 473.24L309.07 472.64L308.71 472.29H309.1L308.78 471.68L309 471L308.91 470.75V469.33L308.67 468.91V468.32L308.91 468.17L308.63 468V467.56L308.9 467.72L309.01 467.52L308.92 467.27H308.66V466.95L308.84 466.8V466.54L308.59 465.99L308.69 465.72L308.54 465.54V465.08L308.71 464.87L309.06 465.1L309.17 464.89L309.08 464.64H308.75L308.27 464.37V464.11L308.45 463.96L308.94 464.36L308.73 463.61L308.31 463.26H308.57L308.68 463.12L308.45 462.75V461.59L308.97 461.66L308.8 461.29L308.87 460.7H309.13L309.42 461.06L309.53 460.85L309.29 460.36H308.97L308.76 460.19V460L308.94 459.85L309.28 460.01L309.47 459.35L309.88 459.56L310.05 458.71L310.39 458.93V458.48L310.69 458.26L310.96 458.42L311.33 458.19L311.62 458.55V458.23L311.98 457.87L312.24 457.97L312.43 457.89L312.49 458ZM308.94 462.43L309.2 462.53L309.1 462.15H308.78L308.94 462.43ZM309.17 468.6L309.02 468.36V468.62L309.16 468.8L309.17 468.6ZM309.17 465.96V465.76L309.04 465.71V465.97L309.17 465.96ZM309.17 466.73H309.11L309.25 466.78L309.17 466.73ZM309.17 463.37L309.32 463.62H309.52L309.43 463.31L309.22 463.13L309.17 463.37ZM309.43 461.47L309.64 461.65V461.33H309.45L309.43 461.47ZM309.63 464.1H309.43L309.52 464.28L309.71 464.33L309.63 464.1ZM309.63 471.46L309.55 471.34V471.47L309.63 471.46ZM309.73 468.68L309.66 468.56L309.75 468.81L309.73 468.68ZM309.9 462.68L309.7 462.57L309.79 462.82H309.99L309.9 462.68ZM310.1 460.14L309.75 459.85V460.11L309.91 460.42L310.18 460.52L310.1 460.14ZM310.1 461.14L310.01 460.89L309.9 461.09L310.1 461.14ZM309.96 463.61L310.06 463.92L310.27 464.09V463.71L310.11 463.46L310.22 463.26L309.97 463.35L309.96 463.61ZM310 487L310.12 486.92H310V487ZM310.25 467.67L310.01 467.24L310.07 467.81L310.25 467.67ZM310.38 461.32L310.11 461.16V461.41L310.25 461.47L310.38 461.32ZM310.45 462.03H310.19L310.28 462.28H310.54L310.45 462.03ZM310.28 469.28L310.2 469.15V469.22L310.28 469.28ZM310.35 462.94L310.59 463.37H310.79L310.47 462.76H310.34L310.35 462.94ZM310.44 459.32L310.62 459.23L310.54 459.05H310.35L310.44 459.32ZM310.68 470.66V470.46H310.55V470.65L310.68 470.66ZM310.61 460.33L310.72 460.19L310.64 460.01L310.55 460.4L310.7 460.58L310.61 460.33ZM311.11 458.93L311.02 458.68L310.77 458.77L310.86 459.02L311.11 458.93ZM311.06 464.23L310.99 464.1L310.81 464.25L311.06 464.23ZM311.06 461.97H310.93L311.02 462.22H311.22L311.06 461.97ZM311.06 459.84L311.27 460.01V459.63H311.07L311.06 459.84ZM311.37 463.55L311.66 463.85V463.59L311.45 463.41L311.57 463.27H311.18L311.37 463.55ZM311.37 462.65V462.58L311.31 462.65H311.37ZM311.5 467.09H311.37V467.35H311.57L311.5 467.09ZM311.56 460.63L311.42 460.57V460.7L311.56 460.63ZM311.64 464.63V464.89L311.85 464.99L312.02 464.78L311.79 464.42H311.47L311.64 464.63ZM311.64 465.4L311.5 465.23V465.42L311.64 465.4ZM312.03 462.2L311.79 461.71L311.58 461.6V461.86L311.76 462.3L311.96 462.41L312.03 462.2ZM311.85 459.2V458.74L311.64 458.57L311.57 459.09L311.65 459.28L311.85 459.2ZM311.85 471.72H311.65L311.73 471.84L311.85 471.72ZM311.85 469.21L311.72 469.15V469.35L311.85 469.21ZM311.97 460.15H311.78L311.99 460.33L311.97 460.15ZM312.4 458.63L312.48 458.17L312.28 458.12L312.21 458.71L312.4 458.63ZM312.4 474.12L312.5 473.85L312.25 473.94L312.4 474.12ZM312.53 459.39L312.43 459.66L312.71 459.24L312.63 459.05L312.5 459.13L312.53 459.39ZM313.18 458.74L313 458.95L313.21 459.12L313.18 458.74ZM313.74 458.62V458.36L313.49 458.45L313.74 458.62ZM314.59 458.02H314.78L314.86 458.2L314.59 458.02ZM314.8 464.65L314.6 464.54L314.68 464.72L314.8 464.65ZM315.41 466.2L315.23 466.28L315.28 466.15L315.41 466.2ZM315.78 460.2V459.94L315.3 459.73V459.98L315.53 460.35H315.73L315.78 460.2ZM316.16 465.33V465.07L315.99 465.28L316.16 465.33ZM316.37 460.92L316.45 460.52L316.16 460.81L316.37 460.92ZM317.3 464.38V464.06H317.17V464.38H317.3ZM317.45 462.68L317.63 462.6V462.4L317.32 462.56L317.45 462.68ZM318.1 464.68V464.49L317.86 464.64L318.01 464.89L318.1 464.68ZM318.42 473.62V473.81V473.62ZM320.29 469.76V469.37L320.18 469.58L320.29 469.76ZM321.4 471.19L321.84 471.02V470.83L321.72 470.9L321.63 470.72L321.32 470.82L321.15 471.03L321.4 471.19ZM322.02 470.87V470.74L321.97 470.88L322.02 470.87ZM322.27 469.56V469.49L322.21 469.56H322.27ZM322.93 465.87V465.55L322.68 465.64L322.93 465.87ZM323.07 469.15L322.94 469.1L322.83 469.31L322.97 469.42L323.07 469.15ZM323.2 466.56L323 466.51V466.77L323.21 466.88L323.2 466.56ZM323.64 465.22V464.96L323.15 464.63V464.82L323.53 465.43L323.64 465.22ZM323.45 461.37H323.19L323.42 461.73L323.45 461.37ZM323.69 462.5L323.28 462.22L323.65 462.77L323.69 462.5ZM323.43 459.88L323.79 460.3L323.88 459.84L323.47 459.68L323.43 459.88ZM323.63 468.97V468.7H323.44V468.9L323.63 468.97ZM323.53 475.63V475.82V475.62V475.63ZM323.85 463.39L323.6 463.48L323.69 463.73L323.89 463.84L323.85 463.39ZM323.8 466.11H323.67L323.82 466.35L323.8 466.11ZM324 461L323.64 460.65L323.75 461.16L323.96 461.26L324 461ZM323.8 461.67H324L323.91 461.48H323.72L323.8 461.67ZM323.95 466.95H323.76L323.84 467.13L323.95 466.95ZM323.95 470.62L323.8 470.51V470.71L323.94 470.82L323.95 470.62ZM323.85 467.79V467.73L323.79 467.8L323.85 467.79ZM324.14 468.08L324.06 467.9H323.8L324.03 468.27L324.14 468.08ZM324.14 462.34V462.02L323.94 461.91L324.03 462.22L324.14 462.34ZM324.04 466.48L324.27 466.91L324.48 467.02L324.59 466.88L324.37 466.58V466.38L324.02 466.09L323.91 466.23L324.04 466.48ZM324.31 469.16L323.95 468.81L324.13 469.38L324.31 469.16ZM324.38 462.89L323.97 462.61V462.87L324.26 463.16L324.38 462.89ZM323.99 472.42V472.68L324.21 472.85V472.53L323.99 472.42ZM324.21 465.69V465.43H324.08V465.69L324.22 465.8L324.21 465.69ZM324.08 479.78V479.97L324.26 479.82L324.08 479.78ZM324.13 469.96H324.39L324.1 469.67L324.13 469.96ZM324.54 460.55L324.38 460.31L324.11 460.21L324.22 460.65L324.36 460.77L324.54 460.55ZM324.54 461.72L324.78 461.56L324.39 460.89L324.2 460.98L324.46 461.66L324.54 461.72ZM324.54 467.78L324.7 467.45L324.4 467.02L324.24 467.3L324.54 467.78ZM324.41 477.35V477.16L324.28 477.04V477.37L324.41 477.35ZM324.41 458.5V458.7L324.71 459.12L325.45 459.37L325.67 459.67V459.41L325.43 458.92L325.23 458.87L325 459L324.69 458.45L324.41 458.5ZM324.54 462.3L324.63 462.55L324.91 462.78V462.45L324.68 462.02L324.36 462.12L324.54 462.3ZM324.54 471.15L324.68 471.33L324.79 471.12L324.7 470.87H324.45L324.54 471.15ZM324.54 470.31V470.24L324.48 470.32L324.54 470.31ZM324.63 464.17L324.68 464.03H324.49L324.63 464.17ZM324.57 464.88L324.66 465.13H324.86V464.61H324.54L324.57 464.88ZM324.51 468.12L324.73 468.42V468.35V468.16L324.51 468.12ZM324.94 459.55L324.73 459.44L324.62 459.65L324.79 459.95L325.05 460.06V459.73L324.94 459.55ZM324.85 469.55L325.06 469.72L325.16 469.45L325.01 469.27H324.63L324.85 469.55ZM324.98 472.18V471.92H324.72L324.77 472.37L324.97 472.48L324.98 472.18ZM324.76 468.72L324.97 468.82L324.8 468.45L324.76 468.72ZM325.07 463.46L324.86 463.28V463.6L325.13 463.7L325.07 463.46ZM324.89 466.77L325.26 467.18L325.35 466.85L324.87 466.51L324.89 466.77ZM325.42 458.58V458.32L325.13 457.96V457.7L324.95 457.78L324.9 457.98L325.29 458.58H325.42ZM325.33 460.91L325.25 460.66H325.05V460.86L325.34 461.15L325.33 460.91ZM325.39 462.13L325.5 461.86L325.25 461.37L325.07 461.52L325.39 462.13ZM325.39 465.55L325.52 465.47L325.36 465.23L325.25 465.37L325.39 465.55ZM325.51 460.25L325.86 460.6L325.74 460.03L325.53 459.86L325.36 460.07L325.51 460.25ZM326.3 459.2L326.19 458.69L325.96 458.33L326.05 457.93L325.75 457.51V457.26H325.62L325.46 457.6L325.82 457.88L325.62 458.55L325.99 458.96V459.48L326.29 459.9L326.48 459.95L326.37 459.44L326.3 459.2ZM326.14 464.57H325.82L325.92 464.36L326.12 464.41L326.14 464.57ZM326.38 460.57L326.65 460.67L326.35 460.25L326.18 460.46L326.38 460.57ZM326.18 461.75L326.28 461.48L326.7 461.77L326.65 461.96H326.2L326.18 461.75ZM327.08 456.56H327.27L327.63 456.91L327.81 456.83V456.38L328.14 456.47L328.29 456.65L328.02 457.13H327.82L327.47 457.55H327.22L326.96 456.93L326.68 457.35L326.32 457L326.23 456.75L326.4 456.54H326.73L326.95 456.78L327.08 456.56ZM327.13 459.66V459.34L326.92 459.23L326.83 459.62L326.98 459.8L327.13 459.66ZM327.29 456.15L327.38 456.34L327.26 456.48L327.12 456.36L327.17 456.17L327.29 456.15ZM327.68 459.34V458.7L327.47 458.52V459.3L327.68 459.34ZM327.68 462.44H327.87L327.66 462.33L327.68 462.44ZM327.94 459.9L327.79 459.72L327.69 459.99L327.96 460.15L327.94 459.9ZM327.94 458.41V458.67L328.15 458.78L328.36 458.31L328.01 458.08L327.94 458.41ZM328.27 465.48V465.16L328.08 465.24V465.5L328.27 465.48ZM328.27 461.48H328.14L328.23 461.73L328.27 461.48ZM328.63 468.28V468.03L328.45 468.24L328.55 468.49L328.63 468.28ZM328.45 458.17H328.72L328.82 457.9L328.58 457.41V457.74L328.45 458.17ZM328.68 463.63L328.59 463.32L328.48 463.59L328.57 463.77L328.68 463.63ZM328.86 464.77V464.39L328.7 464.67L328.86 464.77ZM329.01 461.14L328.74 461.04V461.23L328.95 461.34L329.01 461.14ZM329.01 465.47L328.87 465.42V465.48L329.01 465.47ZM329.01 466.83L329.19 466.68L329.05 466.56L328.94 466.77L329.01 466.83ZM329.19 471.13H329.06L329.15 471.38L329.19 471.13ZM329.28 467.51L329.09 467.59L329.24 467.84L329.28 467.51ZM329.35 472.09L329.15 471.98V472.23L329.36 472.41L329.35 472.09ZM329.47 456.64V456.9L329.35 457.04L329.18 456.6L329.47 456.64ZM329.47 464.13L329.38 463.89V464.15L329.47 464.13ZM329.66 459.53H329.46L329.55 459.72L329.66 459.53ZM329.66 473.28L329.52 473.1V473.42L329.72 473.53L329.66 473.28ZM329.72 461.65L329.57 461.41L329.66 461.66L329.72 461.65ZM329.78 466.1V465.91L329.6 466.06L329.76 466.3L329.78 466.1ZM329.78 470.82V470.43H329.66V470.76L329.78 470.82ZM329.78 476.95H329.98V476.64L329.83 476.46L329.65 476.6L329.78 476.95ZM329.78 476.05L329.7 475.93V476.06L329.78 476.05ZM329.86 474.3L330 474.41L329.9 474.03L329.71 474.12L329.86 474.3ZM329.75 468.05L329.83 468.23L330.03 468.28L329.86 467.91L329.75 468.05ZM329.88 462.35H329.76L329.9 462.53L329.88 462.35ZM329.88 471.91H330.01L329.92 471.66L329.81 471.87L329.88 471.91ZM330.05 463.37H329.86L329.95 463.68L330.2 463.53L330.05 463.37ZM330.18 469.16L330.09 468.92L329.98 469.12L330.13 469.24L330.18 469.16ZM330.35 475.28V475.02H330.08L329.97 475.16L330.2 475.53L330.35 475.28ZM330.19 477.56L330.07 477.63L330.21 477.75L330.19 477.56ZM330.19 472.91L330.38 472.83L330.23 472.65L330.12 472.85L330.19 472.91ZM330.19 482.01L330.36 481.87L330.11 481.96L330.19 482.01ZM330.26 460.96H330.13L330.22 461.15L330.26 460.96ZM330.5 478.69L330.41 478.5H330.15L330.25 478.81L330.52 478.91L330.5 478.69ZM330.25 471.09V471.35L330.69 471.18V470.92H330.23L330.25 471.09ZM330.41 470.17H330.29L330.36 470.29L330.41 470.17ZM330.5 473.59L330.3 473.54L330.38 473.73L330.5 473.59ZM330.5 461.84V461.71H330.37V461.84H330.5ZM330.41 476.37L330.6 476.29L330.39 476.12L330.41 476.37ZM330.71 459.49L330.5 459.26V459.52L330.65 459.7L330.71 459.49ZM330.81 472.59H330.61V472.65L330.81 472.59ZM330.75 472.02L330.86 471.87L330.61 471.96L330.75 472.02ZM330.85 464.02V464L330.67 464.14L330.85 464.02ZM330.79 483.27V483.08L330.68 483.28L330.79 483.27ZM330.88 490.62L330.74 490.44V490.7L330.88 490.62ZM331.1 478.01H330.91L330.99 478.19L331.1 478.01ZM330.94 470.66H331.14L331.24 470.39L331.09 470.21L330.91 470.3L330.94 470.66ZM331.31 471.14H331.05L331.27 471.38L331.31 471.14ZM331.31 488.77L331.1 488.6V488.86L331.31 488.77ZM331.44 474.1V473.85L331.19 473.94V474.2L331.4 474.31L331.44 474.1ZM331.37 476.56L331.22 476.32V476.58L331.43 476.82L331.37 476.56ZM331.37 463.56V463.24H331.24V463.56H331.37ZM331.55 477.49H331.29L331.5 477.72L331.55 477.49ZM331.55 472.58V472.31L331.36 472.4V472.59L331.55 472.58ZM331.41 464.78L331.59 464.69V464.31L331.44 464.13L331.49 464.64L331.41 464.78ZM331.62 475.15V474.89L331.44 474.97V475.17L331.62 475.15ZM331.76 465.65L331.58 465.15L331.52 465.87L331.76 465.65ZM331.81 478.36L331.56 478.45L331.71 478.63L331.81 478.36ZM331.89 473.36H331.69L331.64 473.49L331.84 473.6L331.89 473.36ZM331.71 470.93L331.86 471.11L332.36 470.99L331.82 470.72L331.71 470.93ZM331.93 467.35L331.78 467.18V467.44L331.93 467.62V467.35ZM331.93 476.14V475.95L331.8 475.89V476.09L331.93 476.14ZM331.93 479.68V479.37L331.81 479.44V479.7L331.93 479.68ZM332.35 468.47L332.06 468.12L331.89 468.33L331.98 468.57L332.18 468.68L332.35 468.47ZM332.25 471.97L332.1 471.73L331.99 471.93L332.08 472.18L332.25 471.97ZM332.2 474.62L332.12 474.44L332 474.58L332.2 474.62ZM332.31 469.32L332.36 469.12H332.1V469.39L332.31 469.56V469.32ZM332.22 475.46L332.44 475.7L332.55 475.49L332.39 475.25H332.13L332.22 475.46ZM332.42 472.98V472.79L332.22 472.68L332.4 473.18L332.42 472.98ZM332.52 479.11L332.57 478.91H332.37L332.52 479.11ZM332.58 486.11V485.92L332.41 486.06L332.58 486.11ZM332.95 477.55H332.82L332.96 477.67L332.95 477.55ZM333.13 481.92V481.73L332.95 481.81L333.13 481.92ZM333.25 483.14L333.61 482.84L333.04 482.9L333.18 483.02L333.25 483.14ZM333.18 478.56H333.05L333.19 478.68L333.18 478.56Z",
                fill: "#0067A5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M347.76 493.38L347.94 493.3V493.75L347.74 494.29L348.04 494.71L347.88 495.71L347.71 495.92L348 496.21V497.11L348.22 497.35L348.11 498.14L348.28 498.63V498.96L348.51 499.96V500.48L348.69 500.98V501.43L348.96 502.18L348.88 502.64L348.03 502.59L347.54 502.77L346.95 502.7L346.65 502.93L346.44 502.82L345.34 502.74L345.09 502.24V501.41L344.93 501.1L344.85 499.62L344.7 499.38L344.49 497.98L344.25 497.55L344.39 496.96L344.06 496.28L343.88 494.49L343.96 494.03L343.43 488.73L343.16 487.33L343.26 487.06V486.68L343.11 486.44V485.92L343.28 485.71L343 485.48L343.11 485.21L342.99 484.71L343.14 484.3L342.99 484.06V483.8L342.8 483.24L342.97 482.96L342.76 482.79L342.64 482.28L342.71 481.7L342.62 481.45L342.72 481.11L342.53 480.49H342.79L343.16 481.03L343.29 480.95L343.12 480.58L343.29 480.37H342.97L342.65 479.76L342.36 479.53V479.01L342.71 479.29L343.01 479.07L342.74 478.97V478.52L342.83 478.19L342.75 478.07L342.45 478.23L342.39 477.65L342.57 477.5L342.35 477.27L342.24 476.83L342.5 476.16L342.11 475.55V475.17L342.34 474.95V474.5L341.95 473.89L342.41 473.98L342.64 474.34L342.78 473.75L342.64 473.63L342.33 473.79L342.27 473.15L342.7 472.98L342.55 472.8L342.06 473.04L341.87 472.48L342.17 472.26L341.95 471.96V471.69L341.77 471.2L341.94 470.99L341.84 470.61L341.94 470.34L341.83 469.25L341.58 468.7L341.74 468.29L341.52 466.83L341.63 466.63V465.79L341.48 465.55V465.22L341.79 465.12L341.58 464.89V463.89L341.82 463.73L341.53 463.44V463.18L341.82 462.89V462.12L341.98 461.12L342.26 460.77V460.25H342.58L342.69 459.46L342.94 459.37V459.11L343.12 458.96V458.7L343.36 458.61L343.47 458.4V458.08L343.78 457.92V457.67L344.06 457.19L344.36 457.03L344.76 456.47L346.47 455.53L346.93 455.61L347.21 455.19L347.58 455.03L347.85 455.13L348.92 454.83L349.39 455.04L349.49 454.77L349.94 454.72L350.15 454.9H350.48L350.71 454.62L351.27 455.01L351.63 454.85V455.04L351.84 455.15H352.29L352.5 455.32L352.41 455.72L352.78 455.55L353.43 455.62L353.92 456.62L354.15 456.28L354.29 456.4L354.24 456.59L354.39 456.77H354.84L355.09 457.39L355.5 457.54L355.4 457.87L355.55 458.05L355.93 457.95L355.98 458.52L356.45 458.67V458.93L356.11 458.83L355.45 459.29L355.65 459.39L356.14 459.15L356.68 459.35L356.51 459.57L356.2 459.66L356.09 459.87L356.24 460.11L356.48 459.96L357.01 460.03L356.55 460.6L356.41 461.12L356.17 461.28L356.38 461.45L356.88 461.34V460.95H356.68L356.6 460.77L357.36 460.69L357.41 461.14L357.82 461.42L357.67 461.82L358.09 462.17H357.77L357.48 462.53L357.69 462.7L358.2 462.65L358.11 463.04L357.81 463.2L358.01 463.31L358.32 463.21L358.54 463.39V463.64L357.89 463.58L357.48 464.01V464.14L358.31 464.05L358.1 464.46L358.18 464.65L358.56 464.54L358.7 464.72V464.99L358.45 465.07L358.04 464.86L357.82 465.27L358.27 465.22L358.8 465.36L358.43 465.53L358.38 465.66L358.53 465.91H358.86L358.95 466.16L358.83 466.3L358.24 466.23L357.94 466.39L357.89 466.59L358.1 466.69L358.6 466.58L358.81 466.69L359.05 466.53V466.92L358.71 466.82L358.43 467.24L358.94 467.19L359 467.7L359.28 467.99L359.07 469.05L359.49 469.39L359.27 469.74L359.36 469.98L359.2 470.39L359.68 470.66L359.41 471.14L359.56 471.32L359.03 471.89L359.11 472.01L359.34 471.73L359.81 471.94L359.54 472.48L359.47 473.07L359.81 473.17L359.97 473.54L359.68 473.83L359.95 473.93L360.1 474.17H359.77V474.37H360.03L360.2 475.37L360.09 475.58L360.32 475.94L360.17 476.34L360.33 476.71L360.4 477.42L360.32 477.81L360.59 478.63L360.44 479.09L360.54 479.41L360.26 479.82L360.59 479.92V480.24L360.15 480.35H360.48L360.71 480.71L360.6 480.92L360.71 481.36L360.22 481.66L360.63 481.82L360.68 482.33L360.31 482.5L360.46 482.67L360.79 482.77V483.48L361.01 484.36L360.9 485.15L361.06 485.52L361.21 487.63L361.46 488.13L361.3 488.46L361.51 489.35L361.44 489.87L361.74 490.94L361.57 491.21L361.81 491.64V492.15L361.58 492.43V492.75L361.82 493.18V493.57L361.64 493.78L361.73 493.97L361.94 496.08L361.78 496.42L361.93 496.66L362.07 497.36V498.46L362.18 498.96L362.08 499.23L362.2 499.8V500.58L362.42 501.46L361.81 501.78L361.21 501.64L358.97 501.81L358.57 501.65L358.46 500.57L358.53 500.04L358.43 498.96L358.53 498.75L357.89 492.36V491.45L357.72 491.08L357.81 490.69L357.64 490.31H357.39L357.23 490.71L356.61 490.32H356.29L356.07 490.66L355.39 490.34L355.24 490.75L354.64 490.55L354.33 490.64L354.15 490.85L353.87 490.62L353.3 490.75L352.94 490.98L352.47 490.83L351.86 491.15L351.24 490.76L351.14 490.45L350.68 490.3V490.82L350.31 490.98L350.07 490.49L349.76 490.59V490.85L349.91 491.09L350.25 491.25L350.14 491.46H349.95L349.6 491.17H349.27L349.16 490.66L348.95 490.56L348.84 490.69L348.92 490.88L348.81 491.08L349.23 491.37L349.18 491.56L348.94 491.65L348.44 491.25L348.16 491.67H347.65L347.47 491.82L347.82 492.1V492.37L347.59 492.65L347.82 493.01L347.59 493.23L347.76 493.38ZM342.12 468.77L342.02 468.52L341.94 468.92L342.14 469.03L342.12 468.77ZM342.12 471.77L342.36 471.61L342.22 471.5L342.03 471.58L342.12 471.77ZM342.12 470.28V470.09L342.02 470.42L342.12 470.28ZM342.12 472.48L342.21 472.73L342.32 472.52V472.2H342.19L342.12 472.48ZM342.31 478.85L342.18 478.8L342.29 478.59L342.31 478.85ZM342.71 475.71L342.56 475.53L342.38 475.68L342.71 475.71ZM342.71 475.07H342.45V475.26L342.71 475.07ZM342.54 476.63L342.69 476.81L342.84 476.41H342.51L342.54 476.63ZM342.86 472.14H342.74L342.81 472.26L342.86 472.14ZM342.86 474.34L342.98 474.98L343.19 475.08L343.3 474.94L343.11 474.25L342.86 474.34ZM343.15 475.99V476.25L343.33 476.16V475.84L343.69 475.48L343 475.74L343.15 475.99ZM343.45 478.99L343.63 478.85L343.36 478.75L343.13 478.96L343.45 478.99ZM343.33 482.24L343.19 482.18L343.14 482.32L343.33 482.24ZM343.42 483.24L343.21 483.06V483.26L343.42 483.24ZM343.2 477.19L343.38 476.98L343.2 477.12V477.19ZM343.47 478.52V478.32H343.27V478.51L343.47 478.52ZM343.65 479.66H343.45V479.79L343.65 479.66ZM343.5 475.03L343.57 475.08V474.96L343.5 475.03ZM343.65 488.7V488.64L343.53 488.71L343.65 488.7ZM343.6 482.44L343.78 482.94V482.42L344.08 482.13H343.69L343.6 482.44ZM343.6 477.73L343.81 477.83L344.04 477.55H344.3L344.41 477.34H344.15L343.58 477.52L343.6 477.73ZM344 484V483.61H343.81L343.7 483.82L344 484.24V484ZM343.95 479.1L344.07 478.96H343.81L343.95 479.1ZM343.95 473.03L343.81 472.97V473.17L343.95 473.03ZM344.06 473.47L343.97 473.28L343.86 473.42L344.06 473.47ZM344.19 474.74H343.99V474.87L344.19 474.74ZM351.88 459.44H351.56L351.07 459.03H350.8L350.65 458.79L349.91 458.54L349.6 458.64L348.95 458.58L348.71 458.79L348.14 458.85L347.54 459.3H347.35L347.19 459.64L346.77 460V460.33L346.53 460.55L345.93 461.64L346.02 461.89L345.93 462.22L345.44 462.46L345.66 462.76L345.5 463.1L345.36 463.05V463.76L345.52 464L345.41 464.27L345.16 464.36V464.56L345.46 464.98L345.24 465.39V465.78L345.38 465.96L345.32 467.9L345.48 468.15V468.41H345.03V468.61L345.43 468.77L345.35 469.29H345.16L345.44 470.16L345.58 470.28L345.07 470.91L344.86 471.39V471.71L345 471.88L345.25 471.79L345.16 471.48L345.3 471.01L345.49 471.58L345.27 471.92L345.34 472.63L345.48 472.8H345.75L345.82 472.92L345.71 473.13L345.02 473.33L345.44 473.61V473.87L345 474L344.9 474.27H345.1L345.28 474.13L345.43 474.31V474.5L344.54 474.59L344.36 474.8L344.46 475.12L344.36 475.39L344.05 475.55L344.32 475.65L344.63 475.49L345.09 475.57L345.26 475.36H344.87L344.71 474.99L344.82 474.78L345.32 474.67L345.51 475.23L345.99 475.5L345.56 475.74H345.3L345.18 475.88H345.44L345.62 476.32L345.19 476.62V476.87H345.38L345.61 476.53H345.87L346.02 476.71V477.02L345.64 477.13L345.36 476.9L345.19 477.11L344.68 477.22V477.42L344.88 477.53L345.11 477.25H345.5L345.73 477.68V477.88H346.11L346.22 478.32L346.04 478.47L345.65 478.38L344.77 478.66L344.44 478.56L344.59 478.81L345.13 479.07L345.18 478.88L345.41 478.66L345.89 478.87L345.84 479.07L345.41 479.24L345.08 479.14L345.17 479.46L345.44 479.56L345.93 479.25L346.2 479.36L346.29 479.6L346.18 479.81L345.93 479.9L345.83 480.17H345.96L346.27 480.01L346.41 480.19L346.04 480.35V480.55H346.3L346.45 480.73L346.4 480.93L346.04 481.22L346.1 481.8H346.49L346.59 482.11L346.48 482.32H346.22V482.65L346.6 482.55L346.75 482.73L346.59 483.13L346.7 483.57L346.29 484L346.74 483.95L346.95 484.13V484.84L346.54 485.33L346.85 485.17L347.15 485.6L346.93 485.94L347.08 486.19L347.18 487.19L347.08 487.39L347.23 487.64L347.13 487.9L347.5 487.8L347.84 488.61H348.17L348.61 489.14H348.87L348.62 488.65L348.2 488.3V488.05L348.5 487.82L348.7 487.93L348.94 488.36H349.2L349.59 489.03H349.79L349.88 489.28L350.23 489.63L350.32 489.24L349.76 488.71L349.84 488.32H350.16L350.38 488.56L350.49 488.36L350.29 488.25L350.14 487.42L350.53 487.51L350.71 488.01L350.55 488.35H350.75L350.93 488.14L351.27 488.37V488.69L351.76 488.44V488.19L351.51 488.28L351.3 488.17L351.53 487.89L351.24 487.53H351.56L351.73 487.96H352.12L352.6 488.3L352.35 487.68V488L352.14 487.83L352.24 487.56L352.51 487.66L352.74 488.02L353.12 487.92L353.25 487.33L353.72 487.47L353.87 487.72H354.19L353.9 487.37L354.07 487.16L354.34 487.26L355.02 487L355.48 487.08L356.09 486.76L356.37 486.93L356.98 486.6L356.63 486.32H357.08L357.39 486.74V485.64L357.57 485.43L357.34 485.13L357.44 484.86L357.22 484.56L357.42 484.02L357.21 483.85L357.37 483.51L357.1 483.34L357.01 483.09L357.23 482.75V482.29L356.96 482.13L356.87 481.88L357.14 481.4V480.88L356.79 480.6V480.28L357.15 479.98L357 479.8V479.54L356.63 479.06L356.84 478.65L356.91 478.06L356.68 477.64L356.84 477.3L356.78 476.79L356.56 476.49L356.71 476.08L356.54 475.65L356.43 474.56L356.29 474.45L356.39 474.11L356.23 473.81L356.45 473.46L356.12 473.37V473.05L356.4 472.7V472.25L355.99 472.03V471.58L356.1 471.44H356.36L356.42 471.31L356 471V470.73L355.65 470.38L355.75 470.18L356 470.09V469.83H355.68L355.47 469.01L355.57 468.74H355.83L355.95 468.6L355.74 468.43L355.5 468.65L355.33 467.56L355.18 467.32L355.32 466.86H355.58L355.83 466.71L356.27 466.66L356.48 466.77L356.59 466.63L356.05 466.36L355.37 466.69L355.21 466.32L355.31 466.12L355.76 466.01L355.67 465.76L355.46 465.65L355.11 466.01L354.77 465.78V465.46L355.02 465.37L355.12 465.1L354.78 464.94L355.07 464.65L354.61 464.57L354.53 464.38L354.93 463.83L354.73 463.78L354.43 464.07L354.18 463.52L354.34 463.18L354.01 463.08L353.73 462.2L354.21 461.9L353.45 462.04L353.34 461.6L353.64 461.31L353.17 461.1L353.12 461.3L352.87 461.39L353 461L353.1 460.73L352.85 460.82L352.49 460.4V460.08H352.23L352.08 459.9V459.58L351.88 459.44ZM344.47 478.2L344.32 477.96L344.07 478.11V478.31L344.28 478.41L344.47 478.2ZM344.16 477.01L344.33 476.86L344.09 476.95L344.16 477.01ZM344.44 485.01L344.22 484.78L344.12 484.98L344.44 485.01ZM344.44 483.01L344.24 482.91L344.13 483.11L344.44 483.01ZM344.33 472.31L344.2 472.26V472.32L344.33 472.31ZM344.33 473.79L344.51 473.64H344.31L344.33 473.79ZM344.41 479.72L344.58 479.51H344.32L344.41 479.72ZM344.82 476.77L344.93 476.63H344.74L344.56 476.78L344.82 476.77ZM344.73 482.92L344.91 482.77L344.77 482.66L344.58 482.74L344.73 482.92ZM344.73 465.36H344.92L344.73 465.31V465.36ZM344.89 473.36L345.03 472.76L344.73 472.99L344.89 473.36ZM344.89 470.71L344.75 470.6V470.72L344.89 470.71ZM344.8 478.15L345.05 477.99H344.79L344.8 478.15ZM344.95 484.07H344.82L344.96 484.18L344.95 484.07ZM345.15 468.07L345.06 467.88L344.88 468.03L344.97 468.28L345.15 468.07ZM345.27 480.77L345.48 480.94L345.66 480.86L345.51 480.68L345.05 480.6V480.73L345.27 480.77ZM345.27 480.13H345.08L345.17 480.31L345.27 480.13ZM345.27 463.13L345.13 463.02V463.15L345.27 463.13ZM345.33 484.95L345.44 484.74L345.23 484.51L345.14 484.97L345.33 484.95ZM345.33 478.3L345.57 478.15L345.43 478.03H345.18L345.33 478.3ZM345.68 484.3V484.03L345.37 484.19L345.68 484.3ZM345.62 470.87V471.06H345.49V470.86L345.62 470.87ZM345.83 473.56V473.82L345.72 473.96V473.58L345.83 473.56ZM345.83 484.93H346.09L346 484.68H345.74L345.83 484.93ZM346.1 486.38L346.28 486.17H346.08L345.9 486.32L346.1 486.38ZM346.1 476.12V476.25H346V476.12H346.1ZM346.26 477.65L346.14 477.73L346.05 477.54L346.26 477.65ZM346.09 487.55L346.24 487.73L346.47 487.45L346.78 487.35L346.51 487.25L346.34 487.46L346.09 487.55ZM346.43 483.19H346.17V483.38L346.43 483.19ZM346.51 481.44V481.7L346.36 481.46L346.51 481.44ZM346.61 486.98L346.66 486.78L346.54 486.86L346.61 486.98ZM348.18 490.98V490.72H348.05V491.03L348.18 490.98ZM348.59 490.55L348.64 490.41H348.39L348.59 490.55ZM349.59 488.19L349.43 488.53L349.07 488.18L349.18 487.91H349.5L349.59 488.19ZM349.24 490.48H349.7L349.59 490.04H349.2L349.24 490.48ZM350.29 488.76V489.03L351.11 489.46L351 489.08L350.73 488.98L350.29 488.76ZM351.01 491.34V491.15L351.19 491.06L351.34 491.24L351.01 491.34ZM351.68 490.34V489.89L351.21 489.74L351.33 490.31L351.68 490.34ZM351.35 455.71L351.24 455.85L351.32 455.97L351.35 455.71ZM352.05 489.53L352.16 489.33L352 489.08H351.74L352.05 489.53ZM351.99 490.89L352.23 490.74L352.28 490.54L352.14 490.43L351.9 490.58L351.99 490.89ZM352.47 488.59L352.28 488.67L352.42 488.78L352.47 488.59ZM352.41 489.95H352.67V489.69L352.46 489.58L352.34 489.66L352.41 489.95ZM353.11 490.46L353.24 490.51L353.36 490.37L353.21 490.19L352.78 490.36L353.11 490.46ZM353.16 458.95L353.03 458.89V459L353.16 458.95ZM353.5 488.55L353.61 488.41L353.41 488.3L353.24 488.51L353.5 488.55ZM353.34 460.09L353.4 459.96L353.27 460.03L353.34 460.09ZM353.53 456.84V456.65H353.34L353.43 456.84H353.53ZM353.61 489.7L353.54 489.64V489.7H353.61ZM353.94 460.87L354.05 460.73H353.86L353.75 460.93L353.94 460.87ZM353.86 459.46L354.1 459.24L353.89 459.13L353.78 459.34L353.86 459.46ZM353.94 490.38H354.2L354.3 490.17H354.04L353.8 490.32L353.94 490.38ZM354.17 458.71H353.98V458.84L354.17 458.71ZM354.24 457.42L354.68 457.31L354.33 457.09L354.16 457.3L354.24 457.42ZM354.51 460.1L354.62 459.9H354.36L354.25 460.11L354.51 460.1ZM354.51 458.68L354.7 458.6L354.49 458.43L354.31 458.64L354.51 458.68ZM354.82 457.88H354.56L354.51 458.08L354.82 457.88ZM354.82 462.88L354.68 462.76V462.96L354.82 462.88ZM354.82 459.4L354.68 459.28V459.41L354.82 459.4ZM354.82 461.4V461.21V461.4ZM354.94 487.6H355.14L355.19 487.46H354.8L354.94 487.6ZM354.84 463.53L355.54 463.33L355.2 463.23L354.84 463.53ZM355.09 490.3L355.32 490.08H354.88L355.09 490.3ZM355.6 458.22L355.01 458.73L355.58 458.67L355.81 458.39L355.6 458.22ZM355.19 459.22V459.09H355L355.19 459.22ZM355.34 462.05V461.85L355 462L355.34 462.05ZM355.34 459.92L355.23 460.06L355.49 460.16L355.85 459.8H355.52L355.34 459.92ZM355.57 464.8H355.83L355.68 464.56H355.49L355.38 464.76L355.57 464.8ZM355.96 464.18L356.26 463.89L356.05 463.72L355.86 463.8L355.65 464.21L355.96 464.18ZM355.87 461.35L355.92 461.15H355.72L355.67 461.34L355.87 461.35ZM355.87 462.77L356.04 462.56L355.96 462.43H355.71V462.69L355.87 462.77ZM356.1 461.84L355.67 462.14L356.38 462.07L356.53 461.67H356.33L356.1 461.84ZM355.88 465.41H356.07L356.17 465.21H355.86L355.68 465.36L355.88 465.41ZM355.88 467.54H356.07L355.91 467.3L355.72 467.25V467.52L355.88 467.54ZM356.13 489.98H355.94L355.82 490.12L356.13 489.98ZM355.85 463.41L356.05 463.52L356.67 463.26V463.07L356.47 462.96L356.05 463.27L355.85 463.41ZM356.08 469.59V469.46H355.89L356.08 469.59ZM356.16 460.73L356.31 460.33H356.06L355.97 460.79L356.16 460.73ZM356.37 466.01H356.05L356.32 466.11H356.76L356.87 465.9L356.78 465.65H356.58L356.37 466.01ZM356.51 468.06L356.42 467.81L356.17 467.9V468.15L356.38 468.33L356.51 468.06ZM356.51 469.48V469.22L356.31 469.17V469.43L356.51 469.48ZM356.68 464.68L356.86 464.6L356.7 464.29L356.42 464.71L356.68 464.68ZM356.76 471.91L356.56 471.86L356.51 472L356.76 471.91ZM356.76 461.91L356.65 462.05H356.85L357.27 461.82H357.66L357.5 461.57H357.3L356.95 461.86L356.76 461.91ZM356.76 467.46L356.88 467.31L356.8 467.19L356.62 467.28L356.76 467.46ZM356.81 464.09L357.25 463.98L357.02 463.62L356.77 463.71L356.62 464.11L356.81 464.09ZM356.81 468.68L356.92 468.47L356.68 468.62L356.81 468.68ZM357.03 462.52L356.83 462.41L356.71 462.55L357.03 462.52ZM357.1 490.08L357.2 489.88L356.87 489.78V490.04L357.1 490.08ZM356.84 465.08V465.27L357.43 465.4L357.6 465.19L357.06 464.92L356.84 465.08ZM357.07 466.73H357.71V466.6L357.24 466.39L356.93 466.55L357.07 466.73ZM356.93 469.91L357.07 469.96L356.99 469.84L356.93 469.91ZM357.46 462.91L357.03 463.08L356.98 463.28H357.49L357.6 463.07L357.46 462.91ZM357.18 465.91L357 466H357.2L357.76 465.81V465.55H357.37L357.18 465.91ZM357.11 467.72V467.91L357.32 468.02L357.43 467.82L357.35 467.63L357.11 467.72ZM357.52 469.23L357.31 469.12L357.2 469.26L357.52 469.23ZM357.4 464.23L357.3 464.5H357.81L357.65 464.19L357.4 464.23ZM357.56 467.06V467.32H357.82L357.93 467.18L357.84 466.93L357.56 467.06ZM358.02 468.43L357.87 468.19L357.69 468.33L357.77 468.52L358.02 468.43ZM358.16 465.96L358.27 465.76H357.95L358.16 465.96ZM358.21 470.96L358.01 470.85V471.05L358.21 470.96ZM358.28 467.79L358.47 467.71L358.26 467.54L358.08 467.68L358.28 467.79ZM358.41 469.07H358.67L358.44 468.77L358.21 469.06L358.41 469.07ZM358.41 470.36L358.55 470.41V470.16L358.44 470.3L358.41 470.36ZM358.67 471.69V471.5L358.43 471.72L358.67 471.69ZM358.86 468.38L358.96 468.11L358.75 468L358.58 468.15V468.41L358.86 468.38ZM358.96 469.38H358.77V469.58L358.96 469.38ZM359.19 470.97L359.24 470.84H358.97L359.19 470.97ZM359.12 472.27H359.32V472.14L359.12 472.27ZM359.69 477.9L359.8 477.69L359.55 477.84L359.69 477.9ZM359.88 481.04L360.06 480.96H359.8L359.88 481.04ZM360 472.64H359.87V472.44L360 472.64ZM360.18 477.59L360.03 477.47L359.92 477.61L360.18 477.59ZM360.12 477.01H359.93L360.01 477.2L360.12 477.01ZM360.24 478.87L360.29 478.74L360.04 478.83L360.24 478.87ZM360.7 482.87H360.45V483.06L360.7 482.87Z",
                fill: "#0067A5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M375.88 476.48L375.71 476.04L376.11 475.48V475.29L375.93 475.5L375.73 475.4V474.81L375.44 474.52H375.18V474.26L375.46 473.91L375.05 473.63L375.3 472.89H375.55L375.4 472.71L375.16 472.8L374.66 472.33L375.08 472.03L374.52 471.63H374.27L374.41 471.1L374.71 470.88L374.18 470.8L374.31 470.08H374.56L374.61 469.88L374.39 469.71L374.15 469.8V470.12L373.94 470.01V469.69L374.05 469.49L373.72 468.81V468.55L373.41 468V467.67L373.16 467.12L373.23 466.53L372.88 466.3L372.99 466.04L372.86 465.47L372.65 465.29V464.98L372.44 464.8V464.54L372.02 463.61V462.61L371.84 462.11H371.52L371.34 462.25L371.57 462.62L371.2 462.78H371L370.82 462.92L371.11 463.28L371.43 463.19L371.81 463.79L371.29 463.72L371.05 463.94L371.34 464.23L371.65 464.07L371.79 464.18V465.18L371.95 465.42L371.78 465.7L372.25 466.49L372.14 466.69L372.29 466.87L372.11 467.08L372.34 467.45L371.65 467.58L371.8 467.83L372.27 468.04L372.43 468.28L372.25 468.49H371.99L371.81 468.64L372.35 469.42L371.99 469.72L372.31 470.4L372.15 470.67L372.3 470.91V471.18L372.39 472.07L372.55 472.38V473L372.77 473.3L372.71 473.95L372.99 474.18L372.83 474.45L373.08 475.07L373.01 475.6L373.33 477.5L373.16 477.78L373.31 477.96L373.42 479.04L373.56 479.22L373.62 479.73L373.51 479.94L373.81 480.36L373.72 480.82L373.8 481.52L373.37 481.82L373.52 482L373.99 482.21L373.92 482.74L374.18 483.42L374.02 483.76L374.18 484.07V484.91L374.35 485.35L374.17 485.49L374.46 486.43L374.36 486.7L374.66 487.12L374.61 487.97L374.79 488.4L374.69 488.73L374.78 488.98L374.67 489.19L374.83 489.49V489.82L375.01 490.32L374.89 490.46L375.12 492.7L375.3 493.19L375.15 493.66L375.21 494.24H374.95L375.4 494.78L375.45 496L375.34 496.14L375.55 496.96L375.44 497.16L375.61 497.53L375.83 499.71L375.66 499.98L373.44 500.4L372 500.16L371.88 499.65L371.74 499.47V498.47L371.34 494.47L370.86 491.03L370.69 490.6V490.27L370.51 489.77L370.72 489.24L370.42 486.94L370.22 486.25V485.8L370.07 485.56L369.99 483.5L369.66 482.82L369.9 482.6L369.62 481.08L369.74 481V480.68L369.44 480.26L369.68 479.46L369.33 479.18L369.46 478.58L369.18 478.35L369.33 477.88L369.23 476.34H369.43V475.83L369.16 475.73V476.18L369.01 476L369.12 475.8L368.92 475.04V474.13L369.03 473.99L368.85 473.43L369.01 473.16L368.75 471.83L368.86 471.62V471.3L368.63 470.87V470.42L368.38 469.93L368.47 469.53H368.66L368.29 469.05V468.73L368.54 468.64L368.37 468.2L368 468L368.22 467.66L368.13 467.41L368.24 467.14L368.04 466.51L368.15 466.24L367.79 465.24L367.95 464.96L367.81 464.2L367.92 464L368.22 464.36H368.48L368.39 464.12L368.04 463.89L368.21 463.62L367.75 463.53L367.62 462.26L367.7 461.79L367.49 461.62V461.3L367.29 460.54L367.18 459.46L367.25 458.93L367.1 458.69V458.04L367.21 457.9L367.05 457.53L367.16 457.39L367.02 457.21L366.91 456.21L366.76 455.97L366.82 455.31L366.68 454.56L366.77 454.1L367.59 453.95L367.83 453.79H368.83L369.27 453.62L370.48 453.5L370.82 453.66L371.07 453.57L371.6 453.71L371.9 453.49L372.35 453.44L372.9 453.77V454.03L373.07 454.47L373.51 455.01V455.46L373.88 455.87L373.78 456.21L373.87 456.46H374.13L374.28 456.64L374.1 456.73L374.21 457.17L374.39 457.08L374.47 457.27L374.3 457.48L374.6 457.84V458.16L374.45 458.56L374.87 458.97L375.14 460.3L375.03 460.5L375.3 460.61V460.99L375.61 461.48L375.45 461.81L375.92 462.61L375.82 462.94L376.1 463.17V463.81L376.32 464.11L376.38 464.69L376.52 464.87V465.26L376.81 465.55L376.76 466.33L377.18 466.68L377 467L377.57 467.59L377.28 467.88V468.26H377.59L377.74 468.44V468.7L377.44 468.92L377.61 469.29H377.94V469.73L377.69 469.82V470.08L378.15 470.16L378.28 470.79L377.92 471.09H378.44L378.56 471.72L378.13 471.9L378.03 472.16L378.67 472.1L378.76 472.35L378.56 472.95L378.31 473.04L378.45 473.16L378.88 472.92L378.94 473.56L378.46 473.86L378.66 473.97L378.97 473.88L379.03 473.74L379.18 473.99V474.31L379.46 474.54L379.39 475.13L379.48 475.38L379.88 475.53L379.95 476.17L379.81 476.12V476.5L380.06 476.41L380.21 476.59V477.11L380.45 477.53L380.59 479L381.02 480.06L381.56 482.2L381.47 482.53L381.85 483.14L381.63 483.48L382.18 483.88L382.08 482.88L382.39 482.72L382.09 482.36L382.24 481.89L381.95 481.6V479.99L381.63 479.37L381.84 478.96V478.71L381.55 478.42L381.68 477.82L381.53 477.58V477L381.34 476.43L381.49 475.97L381.33 475.72V475.27L381.03 473.56L381.19 473.22L381.04 473.04L381.15 472.19L380.85 471.7L380.9 470.92L380.75 470.74L380.85 470.48L380.56 469.54L380.47 468.64L380.62 468.17L380.4 467.94V467.48L380.18 466.6V466.15L379.91 464.69L379.97 464.04L379.82 463.86L379.6 462.92V462.46L379.87 462.56L379.98 462.42L379.61 461.94L379.76 461.48L379.51 460.99L379.72 460.51L379.45 460.35L379.34 459.9L379.52 459.76L379.2 459.14L379.44 458.99L379.54 458.72L379.22 458.05L379.3 457.58L378.99 457.03L379.15 456.7L378.67 456.49L379.04 456.32L378.92 455.1L379.27 455.39L379.46 455.31L379.36 455L379.09 454.89V454.64L379.43 454.15L378.84 454.08V453.75L378.52 453.14L378.63 452.94L378.33 451.87L378.87 452.14L379.29 451.84L379.63 452H380.15V452.33L380.54 451.71L380.82 452L381.25 451.76L381.62 452.18L381.76 451.65L382.19 451.47L382.64 452.08L382.59 452.21H382.33L382.22 452.36L382.36 452.53L382.68 452.44L382.97 452.8L382.89 453.26L382.55 453.1L382.36 453.18L382.53 453.55H382.79L383.02 453.92L382.58 454.03V454.48L382.83 454.39L383.07 454.81H382.81L382.73 455.27L382.88 455.51H383.2L383.38 456.01L382.83 456.26V456.46L382.98 456.64L383.43 456.59L383.33 456.92L382.86 456.78L383.27 457.64L382.97 457.86L383.44 458.66L383.36 459.18L383.5 459.88L383.42 460.4L383.56 460.52L383.64 461.28L383.46 461.43L382.96 461.55L383.05 461.86L383.26 461.97L383.76 461.79V462.43H383.11V462.75L383.32 462.86L383.69 462.76L383.99 463.18L383.91 463.64L384.07 464.59L383.97 464.86L384.22 465.42L383.78 465.53L383.67 465.73L383.91 466.16H384.16L384.4 466.59L384.09 466.69V467.14L384.3 467.31V467.57L384.07 467.79V468.05L384.45 468.59L384.15 468.82L384.4 469.37V470.15L384.77 470.63L384.54 470.91L384.77 471.34L384.68 471.67L384.97 472.67L384.86 472.87L385.06 474.14L384.89 474.42L385.22 475.1L385.38 476.69L385.28 478.25L385.43 478.5L385.71 479.95L385.81 480.95L385.95 483.58L386.21 484.33L386.05 484.67L386.32 485.41L386.24 485.81L386.33 486.06L386.55 488.94L386.89 490.39V492L387.1 492.76L387.23 494.76L387.41 495.25V495.58L387.57 495.82L387.51 496.6L387.64 497.17L387.55 497.63L387.62 498.33L387.29 498.24L386.4 498.33L386.15 498.48H385.15L384.58 498.6L384.16 498.84H383.26L382.95 499L382.79 498.69L382.44 498.4L382.6 498.06L382.5 497.75L382.23 497.65L382.28 496.87L382.07 496.7L382.01 496.12H381.69L381.99 495.9L381.92 495.78L381.74 495.93L381.59 495.75V495.43L381.38 495.32L381.15 494.32V494.06L380.97 493.56L381.02 493.36L380.8 493.12L380.9 492.85L380.75 492.61V492.29L380.42 492.19L380.31 491.75L380.49 491.6L380.4 491.35L380.08 491.45L380.03 490.94L380.13 490.67L379.82 490.77L379.73 490.52L379.93 489.91H379.6L379.43 489.48L379.51 489.02L379.31 488.91L379.21 488.53L379.38 488.32L379.06 487.77V487.2L378.82 486.77L379.04 486.36V486.1L378.63 485.89V485.57L378.81 485.42L378.72 485.17L378.37 484.88V484.63L378.61 484.47L378.51 484.03L378.27 484.25V484.57L378.02 484.01V483.75L377.78 483.26L377.87 482.86L377.57 482.44L377.72 482.04L377.97 481.95L377.29 481.63V481.24L377.14 481L377.23 480.6H376.97L377.17 480L376.83 479.84L376.94 479.7L376.79 479.52L377 478.99L376.65 478.76L376.78 478.1L376.63 477.93L376.38 478.01V477.75L376.52 477.8L376.29 477.5L376.54 477.41V476.97H376.27V477.22L376.11 477.5L375.96 477.32V477.06L376.14 476.91L376.03 476.47L375.88 476.48ZM367.43 458.6L367.55 458.46L367.46 458.21L367.34 458.29L367.43 458.6ZM367.89 466.95L367.75 466.84L367.87 466.76L367.89 466.95ZM368.33 463.03L368.25 462.91L368.2 463.05L368.33 463.03ZM369.02 467.29H368.89L368.97 467.41L369.02 467.29ZM369.21 463.46H368.96L369.17 463.69L369.21 463.46ZM369.21 460.23L369.26 460.03L369.12 459.92L369.01 460.12L369.15 460.24L369.21 460.23ZM369.49 477.06L369.34 476.88V477.14L369.49 477.38V477.06ZM369.56 477.76L369.38 477.91L369.52 478.02L369.56 477.76ZM370.43 458.88H370.3L370.46 459.19L370.43 458.88ZM370.75 460.08H371.01V459.82H370.57V460.08H370.75ZM370.86 461.16L370.75 460.72L370.58 461L370.67 461.25L370.86 461.16ZM370.99 461.86L370.84 461.68H370.58L370.75 462.05L370.95 462.16L370.99 461.86ZM371.19 461.26L371.28 461.51L371.55 461.61L371.65 461.34L371.08 460.88L371 461L371.19 461.26ZM371.36 464.92V464.6H371.11V464.92H371.36ZM372.08 466.92L371.79 466.62H371.4L371.77 467.03L372.08 466.92ZM371.54 469.29L371.41 469.24V469.31L371.54 469.29ZM372.81 464.52V464.33L372.76 464.52H372.81ZM373.11 479.08L373.28 478.87L373.01 478.7L372.84 478.91L373.11 479.08ZM373.39 479.96L373.17 479.72V479.98L373.31 480.16L373.39 479.96ZM373.39 480.86V480.73L373.21 480.88L373.39 480.86ZM374.21 469.09V468.83H374.02L374.21 469.09ZM374.26 470.89L374.07 470.97V470.84L374.26 470.89ZM374.93 489.09V489.16L374.87 489.1L374.93 489.09ZM375.34 471.43L375.44 471.09H375.18V471.28L375.34 471.43ZM375.44 472.43L375.65 472.6L375.76 472.33L375.49 472.23L375.44 472.43ZM375.7 473.69L375.88 473.54L375.83 473.1H375.7L375.63 473.62L375.7 473.69ZM376.18 464.99L376.03 464.81L375.91 464.89L376.18 464.99ZM376.37 470.78L376.29 470.6L376.18 470.8L376.37 470.78ZM376.45 472.78H376.32L376.27 472.98L376.45 472.78ZM376.87 468.67L376.66 468.49L376.36 468.72L376.76 468.87L376.87 468.67ZM376.62 473.86L376.93 473.76V473.5H376.73L376.49 473.65L376.44 473.85L376.62 473.86ZM376.53 470.44V470.38L376.47 470.45L376.53 470.44ZM376.81 471.32L376.67 471.2V471.4L376.81 471.32ZM377.09 473.32V473.19L376.91 473.34L377.09 473.32ZM377.46 470.63V470.37L377.22 470.59L377.46 470.63ZM377.36 478.58L377.56 478.69L377.61 478.49L377.33 478.33L377.36 478.58ZM377.49 471.53V471.47L377.37 471.55L377.49 471.53ZM377.66 479.71L377.77 479.51V479.19L377.64 479.14L377.73 479.39L377.66 479.71ZM377.94 473.49H377.68L377.76 473.68L377.94 473.49ZM378.11 481.54H377.84L377.99 481.71L378.11 481.54ZM378.11 474.54L378.02 474.3H377.89L378.06 474.67L378.11 474.54ZM378.11 481.2H378V481.33L378.11 481.2ZM378.26 482.73V482.47L378.05 482.3V482.69L378.26 482.73ZM378.38 483.24L378.19 483.32V483.64L378.51 483.54L378.38 483.24ZM379 475L378.79 474.83V475.09L379 475ZM378.88 478.31L378.81 478.19V478.32L378.88 478.31ZM378.88 452.94L378.98 453.32L379.33 453.54L379.74 453.17L379.14 452.98L378.99 452.8L378.88 452.94ZM379.04 482.75L378.96 482.63L378.91 482.76L379.04 482.75ZM379.29 452.51L379.2 452.32H379.07L379.17 452.57L379.29 452.51ZM379.22 479.38L379.08 479.32L379.16 479.45L379.22 479.38ZM379.38 480.33L379.23 480.15V480.4L379.38 480.33ZM379.6 481.27L379.4 481.17L379.55 481.41L379.6 481.27ZM379.65 485.59L379.57 485.47V485.6L379.65 485.59ZM379.87 456.39L379.92 456.19L379.76 455.95L379.65 456.09V456.34L379.79 456.46L379.87 456.39ZM379.87 452.84L379.99 452.76L379.77 452.52L379.66 452.66L379.87 452.84ZM379.76 453.68L379.91 453.86L380.02 453.66L379.81 453.49L379.76 453.68ZM380.13 477.21L380 477L379.82 477.15L380.13 477.21ZM380.13 454.88L380.36 454.6L380.08 454.43L379.96 454.51L380.13 454.88ZM380.13 457.46L380.05 457.34V457.48L380.13 457.46ZM380.2 458.17V457.97L380.02 458.11L380.2 458.17ZM380.2 478.24L380.4 478.35L380.45 478.15L380.3 477.97L380.11 478.06L380.2 478.24ZM380.43 489.52L380.28 489.34H380.16V489.54L380.36 489.64L380.43 489.52ZM380.34 459.12V459L380.22 459.08L380.34 459.12ZM380.34 479.32H380.47V478.93L380.33 478.88L380.22 479.02L380.34 479.32ZM380.59 456.77V456.57H380.27L380.59 456.77ZM380.59 488.08L380.79 488.13L380.7 487.88H380.44L380.59 488.08ZM380.68 480L380.6 479.82L380.49 480.02L380.7 480.19L380.68 480ZM380.75 457.65L380.92 457.44H380.66L380.61 457.57L380.75 457.65ZM380.75 455.2L380.96 455.31L380.91 454.86L380.66 454.95L380.75 455.2ZM380.8 488.96L380.9 488.76L380.73 488.91L380.8 488.96ZM380.88 484.63V484.5H380.76L380.88 484.63ZM381.23 452.83L381.05 452.39V452.72L381.23 452.83ZM381.15 453.35V453.67L381.36 453.78L381.47 453.64L381.37 453.33L381.15 453.35ZM381.35 464.95L381.16 465.04V465.23L381.35 464.95ZM381.67 454.65L381.5 454.22L381.25 454.31V454.57L381.59 454.8L381.67 454.65ZM381.74 455.36L381.33 455.21L381.64 455.63L381.74 455.36ZM381.63 463.25L381.49 463.2L381.58 463.44L381.63 463.25ZM381.98 456.43L381.77 456.32L381.66 456.53L381.87 456.7L381.98 456.43ZM381.83 453.03L382.03 453.13V452.87L381.88 452.69L381.7 452.78L381.83 453.03ZM382.07 457.39H381.88L382.03 457.57L382.07 457.39ZM382.24 453.95H381.98V454L382.24 453.95ZM382.36 455.75L382.17 455.83L382.52 456.05L382.36 455.75ZM382.2 454.86V455.05L382.47 455.15L382.36 454.71L382.2 454.86ZM382.61 461.4V461.15L382.43 461.3L382.61 461.4ZM382.61 498.91L382.49 499.05V498.86L382.61 498.91ZM382.61 457.21L382.74 457.13L382.66 457.01L382.54 457.08L382.61 457.21ZM382.82 457.96L382.73 457.71L382.62 457.91L382.82 457.96ZM383.04 458.84L382.77 458.74L382.92 458.92L383.04 458.84ZM383.15 460.57L383.03 460.71L383.12 460.9H383.38V460.57H383.15ZM383.61 458.07H383.35L383.59 457.92L383.61 458.07ZM383.91 464.95V464.7H383.78L383.91 464.95ZM384.31 471.43H384.11L384.32 471.54L384.31 471.43Z",
                fill: "#0067A5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M406.9 458.66L407.07 459.16V459.36L407.27 459.47L407.17 459.74L407.12 461.1L406.81 461.26H406.55L406.33 461.67L405.72 461.34L405.3 461.71H404.78L404.57 461.53L404.34 461.81L404.09 461.2L403.9 461.28L403.75 461.68H403.49L402.75 461.37V461.83L402.57 461.91L402.15 461.63H401.96V461.89L401.78 462.04L401.63 461.8H401.24L401.09 462.21L400.94 462.03V461.77L400.65 461.41H400.46L400.51 461.98L400.27 462.14L399.99 461.91L399.8 461.99V462.25L399.62 462.4L399.41 462.23V461.71L398.94 461.56L398.76 461.65L399.04 461.87L398.53 461.93L398.62 462.24L398.44 462.32L398.17 462.22L397.23 462.51H396.78L396.34 462.68L396.02 462.07L396.11 461.67L396.05 461.03L395.84 460.92L395.89 460.15L395.8 459.9L395.92 459.17L396.13 458.7H396.45L396.66 458.81L397.74 458.7L397.95 458.81L398.13 458.66L398.33 458.77L399.09 458.56L399.27 458.41L399.62 458.7L399.85 458.42H400.43L400.67 458.2H400.92L401.13 458.38L401.55 458.08L402.14 458.15L402.25 457.94L402.69 457.77L403.22 457.91L403.39 457.7L403.77 458.3L404.09 457.63H404.35L404.72 458.1L404.94 457.69L405.38 457.52L405.66 457.75L406.02 457.52L406.37 457.81L406.21 458.15L406.68 458.29L406.38 457.87L406.55 457.66H406.74L406.89 457.84V458.17L407.04 458.35L406.9 458.66ZM399.72 459.84V459.7L399.6 459.78L399.72 459.84ZM401.92 461.17L402.13 461.34L402.24 461.2L402.09 460.95H401.9L401.92 461.17ZM403.66 460.47L403.86 460.58V460.32L403.71 460.14L403.53 460.29L403.66 460.47ZM404.66 461.34L405.12 461.43L405.03 461.18H404.64L404.66 461.34ZM405.49 460.61L405.58 460.86L405.92 461.08L405.82 460.71L405.9 460.19L405.6 460.47L405.46 460.36L405.49 460.61ZM406.2 459.96V460.15L406.76 460.03V459.7L406.4 459.35L406.32 459.81L406.2 459.96ZM406.37 459.1L406.45 459.23V458.84L406.37 459.1Z",
                fill: "#0067A5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M410 485.88L410.18 486.37V486.57L410.38 486.68L410.28 486.95L410.22 488.31L409.92 488.47H409.66L409.44 488.88L408.83 488.56L408.41 488.92H407.89L407.68 488.75L407.45 489.03L407.2 488.41L407.01 488.49L406.86 488.89H406.6L405.86 488.58V489.03L405.68 489.11L405.26 488.83H405.07V489.09L404.89 489.24L404.74 489H404.35L404.2 489.4L404.05 489.22V488.96L403.76 488.6H403.57L403.62 489.18L403.38 489.33L403.1 489.1L402.91 489.18V489.45L402.73 489.59L402.52 489.42V489L402.05 488.86L401.87 488.94L402.15 489.17L401.64 489.22L401.73 489.53L401.55 489.62L401.28 489.51L400.34 489.8H399.89L399.45 489.98L399.13 489.36L399.22 488.97L399.16 488.33L398.95 488.22V487.44L398.86 487.19L398.98 486.47L399.19 485.99H399.51L399.72 486.1L400.8 485.99L401.01 486.1L401.19 485.95L401.39 486.06L402.15 485.86L402.32 485.71L402.68 486L402.91 485.72H403.49L403.73 485.5H403.98L404.19 485.67L404.61 485.37L405.2 485.44L405.31 485.24L405.74 485.06L406.27 485.2L406.45 484.99L406.83 485.6L407.15 484.92H407.41L407.78 485.4L408 484.99L408.44 484.82L408.72 485.05L409.08 484.82L409.43 485.1L409.27 485.44L409.74 485.59L409.44 485.17L409.61 484.96H409.8L409.95 485.13V485.46L410.1 485.64L410 485.88ZM402.83 487.05L402.88 486.92L402.76 486.99L402.83 487.05ZM405.03 488.38L405.24 488.55L405.35 488.41L405.2 488.17H405.01L405.03 488.38ZM406.77 487.69L406.97 487.8V487.53L406.82 487.35L406.64 487.5L406.77 487.69ZM407.77 488.56L408.23 488.64L408.14 488.39H407.75L407.77 488.56ZM408.6 487.83L408.69 488.08L409.03 488.3L408.93 487.92L409.01 487.4L408.71 487.69L408.57 487.57L408.6 487.83ZM409.31 487.17V487.37L409.87 487.24V486.92L409.51 486.57L409.42 487.03L409.31 487.17ZM409.48 486.32L409.55 486.44V486.06L409.48 486.32Z",
                fill: "#0067A5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M243.82 474.54L244 475.04L243.95 475.24L244.16 475.35L244.06 475.62L244 477L243.69 477.16H243.43L243.22 477.57L242.6 477.25L242.19 477.61H241.67L241.46 477.44L241.23 477.72L241 477L240.82 477.08L240.66 477.48H240.41L239.67 477.17V477.62L239.48 477.7L239.07 477.42H238.87V477.68L238.69 477.83L238.53 477.59H238.15L238 477.99L237.85 477.81V477.55L237.55 477.19H237.36L237.42 477.76L237.18 477.92L236.9 477.69L236.71 477.77V478.03L236.53 478.18L236.32 478.01V477.49L235.86 477.34L235.67 477.43L235.95 477.66L235.44 477.71L235.54 478.02L235.35 478.11L235.09 478L234.15 478.29H233.69L233.26 478.47L232.94 477.85L233.03 477.46L232.96 476.82L232.76 476.71L232.81 475.93L232.72 475.68L232.84 474.96L233.05 474.48H233.37L233.57 474.59L234.66 474.48L234.87 474.59L235.04 474.44L235.25 474.55L236 474.35L236.18 474.2L236.53 474.49L236.76 474.2H237.34L237.58 473.98H237.84L238.05 474.15L238.47 473.85L239.06 473.92L239.17 473.71L239.6 473.54L240.13 473.68L240.3 473.47L240.69 474.08L241.01 473.4H241.27L241.64 473.88L241.86 473.47L242.29 473.3L242.57 473.52L242.94 473.29L243.29 473.58L243.13 473.92L243.6 474.07L243.3 473.65L243.47 473.43H243.66L243.81 473.61V473.94L243.96 474.12L243.82 474.54ZM236.64 475.72L236.69 475.58L236.57 475.66L236.64 475.72ZM238.84 477.05L239.05 477.22L239.17 477.08L239.02 476.84H238.82L238.84 477.05ZM240.58 476.36L240.79 476.47V476.2L240.65 476.02L240.47 476.17L240.58 476.36ZM241.58 477.22L242.04 477.31L241.95 477.06H241.56L241.58 477.22ZM242.41 476.5L242.5 476.74L242.85 476.97L242.74 476.59L242.82 476.07L242.53 476.36L242.39 476.24L242.41 476.5ZM243.12 475.84V476.04L243.69 475.91V475.59L243.33 475.24L243.25 475.7L243.12 475.84ZM243.29 474.99L243.37 475.11V474.72L243.29 474.99Z",
                fill: "#0067A5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M247 501.76L247.18 502.26L247.13 502.46L247.34 502.57L247.24 502.83L247.18 504.19L246.87 504.36H246.61L246.39 504.77L245.78 504.44L245.37 504.8H244.85L244.64 504.63L244.41 504.91L244.15 504.29L243.97 504.37L243.81 504.78H243.56L242.82 504.47V504.92L242.63 505.01L242.21 504.73H242V505L241.82 505.15L241.66 504.9H241.28L241.13 505.3L240.98 505.12V504.86L240.68 504.5H240.49L240.55 505.08L240.31 505.23L240 505L239.81 505.09V505.35L239.63 505.5L239.42 505.32V504.8L238.96 504.66L238.77 504.74L239.05 504.97L238.54 505.02L238.64 505.34L238.45 505.42L238.18 505.32L237.25 505.61H236.79L236.36 505.78L236.04 505.17L236.13 504.77L236.06 504.13L235.86 504.02V503.24L235.77 502.99L235.89 502.27L236.1 501.8H236.42L236.62 501.9L237.71 501.8L237.91 501.9L238.09 501.76L238.3 501.86L239.05 501.66L239.23 501.51L239.58 501.8L239.81 501.52H240.39L240.63 501.31H240.89L241.1 501.48L241.52 501.18L242.11 501.25L242.22 501.05L242.65 500.88L243.18 501.02L243.35 500.8L243.74 501.41L244.06 500.73H244.32L244.69 501.21L244.91 500.8L245.34 500.63L245.62 500.86L245.99 500.63L246.34 500.92L246.18 501.25L246.65 501.4L246.34 500.98L246.52 500.77H246.71L246.86 500.95V501.27L247.01 501.45L247 501.76ZM239.82 502.93L239.87 502.8L239.75 502.88L239.82 502.93ZM242.02 504.26L242.23 504.43L242.35 504.29L242.19 504.05H242L242.02 504.26ZM243.76 503.57L243.97 503.68V503.42L243.83 503.24L243.65 503.38L243.76 503.57ZM244.76 504.44L245.22 504.52L245.13 504.27H244.74L244.76 504.44ZM245.59 503.71L245.68 503.96L246.03 504.18L245.92 503.81L246 503.28L245.71 503.57L245.57 503.45L245.59 503.71ZM246.3 503.06V503.25L246.87 503.13V502.8L246.51 502.45L246.43 502.91L246.3 503.06ZM246.47 502.2L246.55 502.32V501.94L246.47 502.2Z",
                fill: "#0067A5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M412.23 471.28L413.51 471.15L413.71 471.25L413.35 471.55L413.59 471.98H413.91L413.79 471.42L414.72 471.06L415.2 471.27L415.49 471.05L416.49 471.34V471.02L416.67 470.87L417.02 471.16H417.28L417.45 470.95L418.22 470.87L418.65 470.7L419.25 470.9L419.61 470.61L419.82 470.78L420.54 470.83V471.48L420.24 471.7V472.16L420.46 472.39V472.85L420.24 473.26L420.59 473.54L420.53 474.26L420.33 474.15L420.17 473.85L419.86 473.94V474.4L419.32 474.19V473.81L418.78 473.54L418.85 474.24L418.55 474.47L417.86 474.02L417.7 474.42H417.44L417 473.89L416.75 473.98L416.87 474.48L417.27 474.64L417.03 474.79L416.81 474.55L416.35 474.47L416 474H415.74L415.67 474.52H416.05L416.13 474.7L415.88 474.79L415.67 474.55L415.42 474.71L415.16 474.61L414.99 474.88L414.65 474.66L414.4 474.81L414.2 474.7L413.96 474.28L414.03 474.91H413.77L413.62 474.73L413.11 474.78V474.98H412.78L412.57 474.81H412.31L411.88 474.4L411.71 474.55L411.79 474.74L412.13 474.96L411.96 475.11L411.55 474.89L411.05 475.13H410.73L410.45 474.9L409.86 474.76L409.8 474.83L409.96 475.14H409.71L409.49 474.91H409.1L408.89 474.73L408.71 474.82L408.43 475.23L408.16 475.13L407.92 475.28L407.25 475.09L406.94 474.61H406.62L406.67 475.06L406.9 475.42L406.5 475.33L405.88 475.59L405.16 475.47L404.93 475.75L404.51 475.47L403.83 475.73L403.23 475.53L403 476L402.47 475.85L401.47 476.15H401.21L400.71 476.33L400.49 476.09L400.02 476.53L398.74 476.66L398.26 476.38L398.02 476.54V476.79L397.23 476.68L396.96 476.51L397.04 475.99L396.88 475.68V475.16L396.73 474.92L396.63 473.92L396.78 473.45L396.65 472.89L398.51 472.76L401.63 472.32L402.03 472.41L402.53 472.29L403.12 472.36L403.43 472.2L404.43 472.1L404.83 472.19L406.3 472.04L406.8 471.86H407.06L408.64 471.57L408.98 471.73L409.47 471.49L410.14 471.68L410.57 471.44L410.97 471.6L411.78 471.32L412.05 471.42L412.23 471.28ZM414.17 472.56L414.38 472.16H414.12L413.95 472.37L414.17 472.56ZM414.68 471.87H414.87L414.75 471.36H414.49L414.66 471.74L414.68 471.87ZM414.68 473.09L414.82 473.21L414.91 472.81H414.65L414.53 472.95L414.68 473.09ZM415.08 474.54L414.88 474.43V474.56L415.08 474.54ZM414.99 472.29L415.2 472.46V472.2L415 472L414.99 472.29ZM415.32 473.61V473.41L415.14 473.56L415.32 473.61ZM415.57 471.61V471.41H415.31V471.73L415.57 471.61ZM416.57 472.29L416.39 472.37L416.53 472.48L416.57 472.29ZM416.96 472.96L416.74 472.66L416.69 472.86L416.91 473.03L416.96 472.96ZM418.15 474.52H417.9V474.4L418.15 474.52ZM418.41 473.2L418.46 473.07H418.27L418.41 473.2ZM418.83 472.9L419.08 472.81L418.91 472.37H418.65L418.83 472.9ZM418.9 471.08H418.71L418.8 471.27L418.9 471.08ZM419.06 474.55L418.92 474.44L419.03 474.3L419.24 474.41L419.06 474.55ZM419.63 473.21L419.5 473.15V473.41L419.63 473.21ZM419.89 472.53L420.09 472.58L419.8 472.28L419.69 472.43L419.89 472.53ZM419.82 471.19V471.38V471.18V471.19Z",
                fill: "#0067A5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M237.82 488.46L239.1 488.33L239.31 488.44L238.95 488.73L239.19 489.16H239.5L239.38 488.59L240.32 488.24L240.79 488.45L241.09 488.22L242.09 488.51V488.19L242.27 488.04L242.63 488.33H242.88L243.05 488.12L243.82 488.05L244.25 487.87L244.86 488.07L245.21 487.78L245.42 487.95L246.14 488.01V488.65L245.84 488.88V489.33L246.06 489.57V490.02L245.84 490.43L246.2 490.72L246.14 491.43L245.93 491.32L245.77 491.02L245.46 491.11V491.57L244.92 491.36V490.98L244.37 490.71L244.44 491.41L244.14 491.64L243.45 491.19L243.3 491.59H243.04L242.6 491.05L242.35 491.14L242.46 491.64L242.86 491.8L242.62 491.95L242.4 491.71L241.94 491.63L241.71 491.27H241.46L241.38 491.8H241.76L241.85 491.98L241.6 492.07L241.38 491.84L241.14 491.99L240.87 491.89L240.7 492.16L240.36 491.94L240 492L239.79 491.9L239.55 491.47L239.62 492.11H239.36L239.22 491.93L238.71 491.98V492.18H238.38L238.17 492.01H237.92L237.49 491.6L237.31 491.74L237.39 491.93L237.74 492.15L237.56 492.3L237.15 492.08L236.66 492.33H236.34L236.06 492.1L235.46 491.96L235.41 492.03L235.57 492.34H235.31L235.09 492.1H234.71L234.5 491.93L234.31 492.01L234.03 492.43L233.76 492.32L233.52 492.48L232.85 492.29L232.55 491.8H232.23V492.25L232.46 492.61L232.07 492.52L231.45 492.78L230.73 492.66L230.49 492.94L230.08 492.66L229.4 492.92L228.8 492.72L228.56 493.01L228 493L227 493.29H226.74L226.24 493.47L226.02 493.24L225.55 493.67L224.27 493.8L223.79 493.52L223.55 493.68V493.93L222.76 493.82L222.48 493.65L222.56 493.13L222.4 492.82V492.3L222.25 492.06L222.15 491.06L222.3 490.6L222.18 490.03L224.04 489.9L227.16 489.46L227.55 489.55L228.06 489.43L228.65 489.51L228.95 489.35L229.95 489.24L230.34 489.33L231.81 489.18L232.31 489H232.57L234.16 488.71L234.5 488.87L234.99 488.63L235.65 488.82L236.08 488.58L236.48 488.74L237.3 488.46L237.56 488.56L237.82 488.46ZM239.76 489.75L239.98 489.34H239.72L239.54 489.55L239.76 489.75ZM240.27 489.05H240.46L240.35 488.55H240.09L240.25 488.92L240.27 489.05ZM240.27 490.28L240.41 490.39L240.5 490H240.23L240.12 490.14L240.27 490.28ZM240.67 491.72L240.46 491.61V491.74L240.67 491.72ZM240.57 489.47L240.78 489.64V489.38L240.57 489.21V489.47ZM240.9 490.79V490.6L240.72 490.74L240.9 490.79ZM241.15 488.79V488.59H240.89V488.91L241.15 488.79ZM242.15 489.47L241.96 489.55L242.1 489.67L242.15 489.47ZM242.54 490.14L242.31 489.84V490.04L242.52 490.21L242.54 490.14ZM243.73 491.7H243.47V491.58L243.73 491.7ZM243.98 490.38V490.25H243.79L243.98 490.38ZM244.4 490.08L244.65 489.99L244.48 489.56H244.22L244.4 490.08ZM244.48 488.27H244.29L244.37 488.46L244.48 488.27ZM244.63 491.74L244.49 491.62L244.61 491.48L244.81 491.59L244.63 491.74ZM245.21 490.39L245.07 490.34V490.59L245.21 490.39ZM245.46 489.72H245.66L245.37 489.43L245.26 489.57L245.46 489.72ZM245.39 488.37V488.56L245.44 488.36L245.39 488.37Z",
                fill: "#0067A5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M210.88 138.69L211.33 138.95L211.01 139.2L210.5 139.08L210.43 139.27L210.56 139.4L210.82 139.33L210.88 139.59L210.69 140.04L211.27 140.1L211.33 140.36L211.2 140.62L210.95 140.68L210.69 140.36L210.5 140.55L211.01 141L210.88 141.26L210.56 141.2L210.37 141.32L210.5 141.58L211.01 141.45L211.14 141.58V141.84L211 142L210.55 141.8L210.42 142L210.55 142.19L211 142.32L210.29 142.83L210.42 143.02L211.07 142.96L211 143.28L210.49 143.15L210.42 143.41L210.61 143.6H210.81V144L210.55 143.87L210.36 144.19L210.42 144.32H211L210.94 144.64H210.36L210.23 144.84L210.42 145.03L210.68 144.9L210.87 145.09V145.29L210.68 145.42L210.23 145.35L209.97 145.09L210.17 144.84L209.59 144.64L209.33 144.71L209.52 144.97L209.72 144.9L209.91 145.09V145.67L210.17 145.54L210.49 145.8L210.29 146.19L210.42 146.38L210.68 146.25L210.87 146.44L210.81 146.7L210.61 146.83L210.04 146.64L209.91 146.96L210.17 146.89L210.42 147.02H210.87L211 147.21L210.87 147.34L210.55 147.15L210.36 147.28V147.54L210.49 147.66H210.81L210.74 147.98L210.36 148.24L210.23 148.88L210.49 148.95L210.74 148.82L210.81 149.27L210.36 149.66L210.42 149.78L210.94 149.66L211.07 150.11L210.74 150.23L210.81 150.88L211.07 151.26L210.74 151.58L210.87 151.9L210.74 152.22L211 152.55L211.26 152.61L210.81 153L211.26 153.25L210.74 153.51L211.13 153.83L211.19 154.02L210.81 154.34L211.19 154.73L210.94 154.79L210.81 154.99L211.26 155.31V155.57L210.74 155.76L211.07 155.82L211.26 156.01L211.19 156.66L211 157.04L211.39 157.36L211.26 157.56H211.07L211.32 157.94L211.19 158.33L211.39 158.71L211.26 159.03L211.45 159.42L211.39 159.61L211.13 159.68L211.07 159.87L211.39 159.68L211.58 159.87L211.64 160.19L211.39 160.38L211.84 161.38L211.51 161.7L211.9 162.08L211.58 162.21L211.96 162.4V162.66L211.84 162.79L212.28 163.18L212.09 163.56L212.35 163.82L212.28 164.08L211.96 164.14L212.54 164.08L212.61 164.65L212.03 164.91L212.28 164.97L212.48 164.85L212.86 164.91L212.8 165.49L213.06 165.94L213.31 166.07L213.06 166.32L213.63 166.9L213.44 167.03L213.57 167.22H213.76L214.21 167.61L214.28 167.8L213.89 167.87L214.73 168.12L214.86 168.51L215.3 168.44L215.18 168.76L215.63 168.83L215.75 168.64L216.14 168.57L216.27 168.83L216.53 168.96L216.72 168.57H217.1L217.3 169.02L217.49 169.09L217.75 168.89L217.81 168.64L217.49 168.44L217.62 168.31L217.94 168.51L218.13 168.44L218.32 168.19L219.32 168.06L219.38 167.87L219.57 167.8L219.51 167.61L219.64 167.42L220.15 167.22L220.41 167.42L220.54 167.35L220.15 166.77L220.35 166.58L220.92 166.64L220.73 165.94L220.8 165.49L221.18 165.23L221.12 165.04L220.86 164.97L221.05 164.59L221.44 164.4L221.24 164.01L221.69 163.56L221.57 163.3L221.82 163.05L221.57 162.79V162.47L221.89 161.7L221.69 161.44L221.76 161.12L222.02 161.06H221.82V159.7L222.02 158.8L221.76 158.67L221.69 158.09L221.89 157.64L221.69 157.45L221.89 156.74V156.29L221.76 155.97L221.89 154.75L221.5 154.62L221.89 154.17L221.63 153.47L221.37 153.66L221.12 153.34L221.24 153.08L221 153L220.81 153.12L221 153.38L220.81 153.32L220.68 153.06L220.23 153L219.97 153.45L219.52 153.19H219.14L218.95 153.45L218.43 153.32L218.24 153.12L218.05 153.38L217.79 153.45L217.6 153.25L217.08 153.19L216.51 153.32L216.18 153.19L215.86 153.57L215.03 153.25L214.58 153.32L214.06 153.19L214.13 153L213.87 152.61L213.81 152.1L213.55 151.78L213.68 151.52L213.74 150.52L213.94 149.75L214.51 149.37H216.12L217.92 149.24L219.07 149.3L219.65 149.11L219.97 149.24L220.87 149.11L221.26 149.24L221.45 148.98H222.22V149.3L222.42 149.18L222.61 148.79L223.89 148.73L224.34 149.37L224.86 149.24L225.37 151.3L225.24 151.55L225.56 152.84L225.5 153.29L225.69 154.64L225.56 154.89L225.63 155.34L225.82 155.54L225.88 156.05L225.69 156.31L225.82 156.5L225.69 156.76L225.95 156.95L225.76 158.04L225.82 158.3L225.69 158.49L225.76 159.07L225.63 160.07L225.43 160.26L225.56 160.52V161.52L225.43 161.72L225.5 162.1L225.31 162.68L224.86 162.94L225.24 163L225.31 163.32L225.05 163.71V164.22L224.73 164.35L224.98 164.74L224.6 165.63L224.73 165.89L224.21 167.43L223.76 167.82L223.64 168.4L223.44 168.59L223.25 169.3H222.8L222.86 169.55L222.67 169.94H222.42L222.09 170.39L221.64 170.65L221.32 171.22L221 171.1L220.68 171.55L220.42 171.61L220.36 171.93L219.59 171.67L219.33 172.12L218.75 171.87L218.69 172.38L218.5 172.57L217.92 172.44L217.4 172.57L215.99 172.64L214.45 172.44L213.94 172.06L213.81 172.12L212.59 171.67L212.33 171.22L212.07 171.35L211.07 170.35L210.87 169.71L210.49 169.39L210.42 169.13L210.1 168.94L209.39 167.52V167.2L209.14 167.14V166.49L208.43 165.08L208.24 164.31L208.3 164.05L208.17 163.8L208.37 163.54L207.92 163.09L207.66 161.93L207.85 161.61L207.6 161.48L207.47 161.16L207.66 160.84V160.39L207.47 159.94H207.21V159.69L207.6 159.56L207.53 159.24L207.72 159.04L207.4 158.79L207.53 157.79L207.34 157.53L207.47 156.95L207.4 156.7L207.6 156.31L207.34 156.05L207.53 155.6V155.03L207.27 154.9V154.58L207.6 154.19L207.47 154L207.53 153.74L207.21 153.23L207.53 152.33L207.15 151.88L207.47 151.49L207.4 150.85L207.27 150.98V151.24L207.15 150.98V150.53L207.53 150.14L207.47 149.89L207.08 150.14L207.02 149.82L207.15 149.57L207.53 149.63L207.21 149.12L207.66 148.73L207.47 148.54L207.21 148.67L207.15 148.41L207.27 148.28L207.21 148.02L207.47 147.38L207.15 147.32L207.08 147.12L207.85 146.87L208.43 146.93L208.11 146.55L207.34 146.74L207.21 146.48L207.27 146.16L207.47 146.23L207.66 146.1L207.53 145.97L207.08 146.1L206.89 145.9L206.95 145.58L207.21 145.39L207.08 145.26L207.6 144.75L207.4 144.49L207.08 144.68L207.02 144.49L207.15 144.23L207.4 144.36L207.6 144.23L207.15 143.78L207.27 143.59L207.85 143.33L207.53 143.08L207.15 143.21L207.02 143.08L207.21 142.88L207.47 142.95L207.66 142.82L208.17 142.76L208.49 142.88L208.69 142.76L208.05 142.37L207.6 142.63L207.21 142.5L207.66 142.05L208.11 142.24L208.37 142.18L208.75 141.86L208.49 141.66L208.17 141.92L207.47 141.86L207.15 141.98L207.34 140.89L207.79 140.64V140.31L207.34 140.38L207.6 140.06L207.34 139.8L207.4 139.35L207.66 139.29L207.79 139.09L207.66 138.84L208.17 138.52L208.05 138.32L207.6 138.52L207.53 138.26L207.66 138H208.05L207.85 137.75V137.49L208.17 137.17L208.05 137.04L207.85 137.1L207.72 136.72L207.98 136.78L208.17 136.65L207.92 136.52L207.85 136.14L208.11 136.01L208.56 136.14L208.69 136.01L208.05 135.56L208.24 135.3L207.92 134.85L208.43 134.47L208.24 134.21L208.75 133.7L208.56 133.51L208.3 133.7L208.17 133.51L208.24 133.25L208.75 133.31L209.33 133.12L209.14 132.86L208.88 133.06H208.56L208.37 132.86L208.69 132.41L208.75 131.58L208.43 131.64L208.69 131.26L209.01 131.32L209.33 130.42L209.27 130.1L209.72 129.72L209.59 129.52L209.2 129.72L209.14 129.52L209.33 129.33L209.59 129.39L209.78 129.27L209.52 129.14L209.46 128.69L209.78 128.49L210.17 128.69V128.49L209.78 128.24L210.04 127.72L210.49 127.85L210.61 127.66L210.55 127.53L210.17 127.6L210.55 127.08L211.13 127.27L211.39 127.21L211 126.76H210.68L210.87 126.7L211.07 126.37L211.64 126.5L211.77 126.44L211.39 126.05L211.51 125.8L211.77 125.67L212.09 125.8L212.03 125.48L212.35 125.22L212.61 125.48L212.99 125.15L212.8 124.96L212.86 124.77H213.12L213.57 124.51L213.83 124.58L214.15 124.19L214.41 124.13L215.24 124.32L215.63 124H216L216.52 124.26L217.52 124.38L218.03 124.26L219.03 124.38L219.41 124.19L219.6 124.45L220.12 124.51L220.5 124.77L219.99 125.22H220.25L220.7 124.9H220.95L220.83 125.35L221.4 125.22L221.79 125.48L221.53 125.8L221.66 125.99L221.98 125.73L222.69 126.18L223.01 126.76V127L223.33 127.32L223.65 127.38L223.84 127.58L223.78 127.77L224.23 128.35V128.67L224.74 129.44V129.76L224.49 129.83L224.55 129.95L224.81 130.02L224.94 130.21L224.81 130.66L225.06 130.92L224.94 131.11L225.19 131.3L225.39 132.3L225.26 132.69L225.39 133.14L225.64 133.39L225.77 134.48L225.64 134.68V136.48L225.77 136.99L225.64 137.31L225.51 139.17L225.26 139.43V139.88L225.51 140.07L225.26 140.72L225.19 141.23L225 141.62L224.94 142.13L224.23 142.26L223.78 142.06L221.72 141.94L221.6 141.74L221.08 141.55L220.95 141.94L220.83 141.74L220.89 141.49L220.7 141.29L221.15 140.59L221.02 139.82L221.34 139.5L221.15 139.24L221.34 137.5L221.47 137.25L221.21 136.03L221.4 134.42L221.27 133.26L221.47 133.07L221.15 132.56L220.95 131.02L220.05 129.15L219.67 129.09L219.54 128.83L219.28 128.7L218.96 128.25L218.71 128.32L218.38 128.12L218 128.38L217.74 128.12L217.55 128.38H217.1L217.23 128.19L217.1 127.93L216.91 127.87L216.39 128.12L216.33 128.38L215.75 127.8V128.51L215.49 128.64L215.17 128.57L214.92 128.96L214.66 129.09L214.34 129.02L214.14 129.54L213.89 129.6L213.63 130.05L213.24 130.25L213.12 130.44L213.18 130.95L212.86 130.89L212.41 131.21L212.02 131.02L211.64 131.14L212.02 131.53L211.96 131.79L211.51 131.85L211.38 131.66L211.45 131.14L211.64 130.76L211.9 130.63L211.51 130.31L211.32 130.44V131L210.93 131.26L211 131.58L210.8 132.09L210.67 131.97L210.87 132.22L211.38 131.97L211.7 132.16L211.96 131.9L212.28 131.97L212.54 132.41L212.41 132.54L211.64 132.35L211.51 132.54L211.57 132.74L211.9 132.67L212.34 132.86L211.9 133.19H211.64L211.51 133.31L211.9 133.44L212.09 133.25L212.28 133.44V133.64L212.09 133.76L211.7 133.64L211.51 133.7L211.57 133.96L212.02 134.28L211.9 134.66L211.64 134.73L211.45 135.24L211.9 135.43L211.96 135.76L211.83 135.95L211.51 135.69L211 135.76L210.61 136.01L210.8 136.21L211 136.08L211.64 136.27L211.38 136.59L211.13 136.65L211.06 137.23L211.38 137.36L211.51 137.81L211.38 137.94H211V138.32L210.88 138.69ZM207.41 145.82L207.61 145.63L207.28 145.56L207.41 145.82ZM208.06 141.2H207.8L207.67 141.45H208.25L208.44 141.71L208.76 141.32H208.31L208.06 141.2ZM208 140L207.81 139.87L207.74 140.19L208 140ZM207.94 140.77L207.81 140.89L208 140.96L208.71 140.83V140.64L208.51 140.57L208.13 140.77H207.94ZM207.94 143.72H208.13L208.26 143.53H207.81L207.94 143.72ZM208 154.45L207.81 154.38L207.87 154.58L208 154.45ZM208.13 145.13L208.32 145.01L208.07 144.94L207.87 145.07L208.13 145.13ZM208.19 145.52L208 145.39L207.87 145.58L208.19 145.52ZM207.87 147.77H208.07L207.87 147.64V147.77ZM208.13 139.61L208.32 139.48L208.13 139.35L207.94 139.48L208.13 139.61ZM208.07 140L208.26 139.87L208.07 139.74L207.94 139.87L208.07 140ZM208 144.36L208.19 144.17L208 144L207.94 144.26L208 144.36ZM208.19 162.48L208 162.29V162.48H208.19ZM208.64 136.78L208.77 136.53L208.51 136.46L208.39 136.72L208.64 136.78ZM208.45 138L208.77 137.94L208.39 137.81L208.45 138ZM208.51 143.59L208.71 143.53L208.77 143.27H208.51L208.39 143.46L208.51 143.59ZM208.64 144.88L208.45 144.68L208.39 144.88H208.64ZM208.58 137.55H208.77L208.9 137.36L208.64 137.3L208.45 137.43L208.58 137.55ZM208.71 139.42L208.77 139.22H208.58L208.45 139.42H208.71ZM208.58 146.23L208.45 146.16L208.51 146.29L208.58 146.23ZM208.97 138.45L208.58 138.84L208.84 138.9L209.22 138.58L208.97 138.45ZM209.09 142.82L209.29 142.56L208.97 142.5L208.84 142.76L209.09 142.82ZM209.09 130.94L208.9 131L208.97 130.81L209.09 130.94ZM209 146.34H208.87L209 146.46V146.34ZM209.13 133.94L208.94 134.07L209.13 134.19L209.64 134L209.71 133.74L209.38 133.94H209.13ZM209 140.17L209.32 140.04L209.13 139.91L208.94 140.1L209 140.17ZM209.13 134.64L209.32 134.58L209.13 134.39L209 134.58L209.13 134.64ZM209.13 135.99L209.06 135.8L209 136L209.13 135.99ZM209.19 136.83L209 136.7V136.83H209.19ZM209.32 137.28V137.08H209.06L209 137.28H209.32ZM209 139.53L209.32 139.4L209.13 139.33L209 139.46V139.53ZM209.19 141.39L209 141.2L209.13 141.39H209.19ZM209.19 140.94V140.81L209.13 140.94H209.19ZM209.32 143.38L209.13 143.57L209.77 143.51V143.25L209.58 143.19L209.32 143.38ZM209.38 147.38L209.26 147.51L209.45 147.7L209.58 147.51L209.38 147.38ZM209.64 146.16L209.51 146.03L209.32 146.1L209.38 146.36L209.64 146.16ZM209.58 137.55L209.77 137.36H209.38L209.58 137.55ZM209.83 142.63L209.51 142.69L209.38 142.95L210.16 142.76L210.22 142.56L210.03 142.5L209.83 142.63ZM209.45 136.63L209.64 136.82L209.77 136.63L209.71 136.44L209.51 136.37L209.45 136.63ZM209.58 139.52H210.03L209.9 139.26L209.64 139.2L209.45 139.33L209.58 139.52ZM209.64 140.61L209.45 140.55V140.81L209.64 140.61ZM209.77 141.26L209.45 141.51L209.64 141.58L210.09 141.45L210.16 141.19L210.03 141.13L209.77 141.26ZM209.64 142.15L209.71 141.9L209.45 141.96L209.51 142.15H209.64ZM209.64 149.74L209.51 149.61L209.45 149.74H209.64ZM209.64 150.12L209.45 150.19L209.64 150.31V150.12ZM209.64 132.12L209.51 132.06V132.19L209.64 132.12ZM209.58 144.12L209.51 144.31H209.77L209.58 144.12ZM209.64 145.66L209.51 145.59V145.79L209.64 145.66ZM209.64 132.66V132.53L209.58 132.66H209.64ZM209.71 130.73L209.77 130.61L209.64 130.67L209.71 130.73ZM209.71 133.3H209.64L209.71 133.43V133.3ZM210.03 142.36L210.28 142.1L210.03 142.04L209.83 142.23L210.03 142.36ZM210.03 136.97L209.9 137.16L210.16 137.42L210.35 137.22L210.28 136.97L210.41 136.64H210.03V136.97ZM210.09 139.97L210.03 139.84L209.9 139.97H210.09ZM210.22 143.5L209.9 143.37V143.5H210.22ZM210.03 146.26L209.96 146.13L209.9 146.26H210.03ZM210.09 130.65L210.28 130.39L209.96 130.46L210.09 130.65ZM210.09 132.06L210.41 131.81L210.28 131.68L210.03 131.74L210 132L210.09 132.06ZM210.22 132.77L210.03 132.58L209.96 132.71L210.22 132.77ZM210.28 135.4L210.09 135.21L209.96 135.4H210.28ZM210.16 138.23L210.28 138.04H210.09L209.96 138.23H210.16ZM209.96 144.08H210.09V143.88H210L209.96 144.08ZM210.03 130.01L210.28 130.07L210.22 129.94H210.03V130.01ZM210.16 131.29H210.03L210.16 131.42V131.29ZM210.09 133.99V133.93L210.03 133.99H210.09ZM210.22 134.63L210.09 134.44L210.03 134.63H210.22ZM210.54 157.89L210.09 157.82L210.48 157.89H210.54ZM210.54 150.24V150L210.28 150.13L210.35 150.32L210.54 150.24ZM210.54 151.08L210.6 150.95L210.35 151.01L210.54 151.08ZM210.48 154.35V154.16L210.35 154.29L210.48 154.35ZM210.6 137.52L210.73 137.4L210.6 137.27L210.41 137.4L210.6 137.52ZM210.54 138.04L210.73 137.91L210.54 137.78L210.41 137.91L210.54 138.04ZM210.6 138.87L210.86 138.68L210.41 138.74L210.6 138.87ZM210.54 135.15L210.73 135.28L210.99 135.21L210.6 134.89L210.54 135.15ZM210.8 132.64L211.06 132.77L211.18 132.71L210.99 132.45L210.8 132.38L210.6 132.51L210.8 132.64ZM210.8 134.76L210.93 134.57L210.67 134.63L210.6 134.83L210.8 134.76ZM210.8 145.94L210.6 145.88L210.93 145.75L210.8 145.94ZM210.93 148.64L210.8 148.77L210.6 148.57L210.67 148.38L210.93 148.44V148.64ZM210.8 129.88L210.67 129.75V129.88H210.8ZM210.8 133.22L210.67 133.41L211.12 133.28L211.25 133.09L211 133L210.8 133.22ZM210.8 136.5L210.67 136.43V136.62L210.8 136.5ZM210.99 128.72L210.93 128.47L210.73 128.53L210.99 128.72ZM210.99 158.66L211.12 158.4H210.86L210.8 158.59L210.99 158.66ZM211 160.4H211.25L211.38 160.28L211.13 160.15L210.93 160.21L211 160.4ZM211.06 130.08H211.32L211.38 129.95L211 129.89L211.06 130.08ZM211.13 161.08L211.38 161.02L211.13 160.95V161.08ZM211.51 127.93H211.77L211.57 127.74L211.32 127.8L211.51 127.93ZM211.51 129.28L211.77 129.35V129.22L211.45 129.02L211.32 129.22L211.51 129.28ZM211.51 136.99L211.32 136.93L211.38 136.8H211.64L211.51 136.99ZM212.02 126.99L211.83 126.93L211.7 127.06L212.02 126.99ZM211.96 129.43L211.7 129.76L211.83 129.95L212.28 130.01L212.41 129.82L212.09 129.63L211.96 129.43ZM212.34 128.79L212.22 129.24H212.67L212.6 128.73L211.96 128.28L211.77 128.41L212.34 128.79ZM212.34 127.06H212L212.19 127.25L212.34 127.06ZM212.28 130.59L212.47 130.72L212.73 130.65L212.6 130.4L212.34 130.27L212.15 130.46L212.28 130.59ZM212.8 131.49L212.6 131.62L212.34 131.49L212.41 131.3H212.86L212.8 131.49ZM212.73 126.41L212.54 126.35L212.73 126.54V126.41ZM212.8 128.02L212.73 127.83L212.6 127.96L212.8 128.02ZM212.86 129.88L213.12 130.01L213.31 129.95L212.99 129.5L212.73 129.56L212.67 129.82L212.86 129.88ZM213.18 127.19L213.05 126.99L212.99 127.12L213.12 127.25L213.18 127.19ZM213.37 128.66L213.18 128.47L213.12 128.6L213.37 128.66ZM213.37 129.05L213.31 129.31H213.76L213.95 129.18L213.5 128.86L213.37 129.05ZM213.76 127.83H213.57L213.69 128.02L213.76 127.83ZM213.69 126.61L213.95 126.41L213.76 126.35L213.63 126.48L213.69 126.61ZM213.69 125.26L213.95 125.32V125.07L213.69 125V125.26ZM214.34 125.84L214.4 125.64H214.14V126L214.34 125.84ZM214.34 127.31V127.06L214.14 127.12L214.27 127.51L214.34 127.31ZM214.4 128.6L214.27 128.41L214.14 128.6H214.4ZM215.62 125.32L215.94 125.39L215.75 125.13L215.62 125.32ZM217.1 172.22L216.97 172.09L216.91 172.28L217.1 172.22ZM217.93 172.35L218.19 172.22V172.09L217.87 171.96L217.74 172.22L217.93 172.35ZM218.45 168.68L218.38 168.43L218.26 168.62L218.45 168.68ZM219.28 152.88L219.15 152.82L219.09 153.14L219.28 152.88ZM220.12 167.79L219.86 167.72V167.98L220.12 167.79ZM220.95 165.6L221.27 165.66L221.66 165.99L221.72 165.79L221.15 165.47L220.95 165.6ZM221.53 127.19L221.72 127.12L221.66 126.86H221.4L221.34 127.12L221.53 127.19ZM221.53 153.97L221.34 153.91L221.4 153.72L221.53 153.97ZM221.98 169.39V169.13L221.79 169.26L221.98 169.39ZM222.24 164.32L222.11 164.12L222.05 164.32H222.24ZM222.37 126.32L222.5 126.25L222.24 126.32H222.37ZM222.5 168.71V168.59H222.37L222.5 168.71ZM222.82 169.36L222.37 169.29L222.69 169.36H222.82ZM222.5 163.06L222.69 162.93H222.5V163.06ZM222.69 164.6L222.56 164.41L222.5 164.6H222.69ZM223.52 167.11L223.27 167.04L223.33 167.3H223.59L223.52 167.11ZM223.72 128.56L223.59 128.37H223.33V128.56H223.72ZM223.65 160.43V160.3L223.59 160.43H223.65ZM224.17 129.14V129.08L223.91 129.14V129.34L224.17 129.14ZM224.87 163.58L224.68 163.45V163.64L224.87 163.58ZM225.26 162.42L225.06 162.29V162.42H225.26ZM225.32 134.15L225.58 134.35V134H225.26L225.32 134.15Z",
                fill: "#0067A5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M234 138.05H234.26L234.7 138.43L234.9 138.24L234.06 137.73L234.32 137.53L234.19 137.34H233.93L233.68 137.08L233.81 136.76L233.68 136.57L233.74 136.12L234 135.74L233.74 135.67L233.87 135.29L234.19 135.09L234.06 134.96L234.32 134.64L233.87 134.58V135.09H233.61L233.48 134.96L233.55 134.71L233.81 134.58L233.61 134.32L233.81 134.07L233.48 133.81V133.36L233.81 133.29L234 133.55H234.26L234.32 133.42L233.68 133.1L233.87 132.78L233.29 132.27L233.36 132.01L233.16 131.62L233.29 131.37L233.61 131.56L233.36 131.05L233.29 130.53L233.1 130.21L233.29 130.02L233.55 130.15L233.81 130.08L233.1 129.44L232.91 128.8L232.71 128.67L232.84 128.48L233.29 128.35L232.78 127.45L233.16 127L233.03 126.42L233.1 126.16L232.84 125.84L233.16 125.65L233.03 125.26L233.29 125.14L233.74 125.33L234.38 125.14L234.96 125.2L235.35 125.01L235.93 125.33L236.37 125.01L236.82 125.14L236.89 125.26L237.4 125.01L237.72 125.39L238.11 125.52L238.17 125.07L238.56 125.14L238.88 125.59L239.07 125.46L239.14 125.14L239.52 124.94L239.65 125.26L240.1 125.39L240.42 125.01L241.06 125.52L241.19 125.01L241.45 124.94L241.71 125.07L241.77 125.39L242.03 125.52L242.16 125.33V125L242.35 124.93L242.8 125.13L242.86 125.38L243.18 125.51V125L243.57 124.93L243.89 125.32L244.15 125.19L244.21 124.87L244.79 125L244.73 125.25L244.85 125.51L245.3 124.93H245.63L245.5 125.93L245.37 125.73L245.3 125.99L245.43 126.18L245.69 126.25V126.83L245.37 126.89L245.24 127.15L245.43 127.4L245.75 127.34V128.34L245.5 128.21L245.24 128.34L245.11 128.85L244.73 128.79L244.6 128.34L244.41 128.21L244.21 128.27L244.08 128.72L243.7 128.79L243.57 128.47H243.12L242.99 128.79L242.8 128.66L242.61 128.27L242.16 128.47V128.72L241.71 128.79L241.39 128.4L241.13 128.34V128.72L240.94 128.85L240.68 128.79L240.36 128.08L240.23 128.27L240.16 128.79L239.72 128.85L239.46 128.34L239.2 128.79L238.3 128.92L237.85 128.85L237.02 129.11L236.89 129.94L237.27 130.01L237.15 130.46L236.82 130.39L236.63 130.52L236.89 130.59L237.27 131.29L237.34 131.74L237.15 131.81L236.89 131.61V131.23L236.5 131.16L236.7 131.74L236.5 131.94L237.02 132.13L237.08 132.32L236.44 132.71L236.76 132.96L236.57 133.22L237.02 133.61L236.89 133.8H236.57L236.5 134.06L236.76 134.7L237.08 135.02L236.89 135.21H237.27L237.47 135.6L237.34 135.79L236.7 135.85L237.02 136.3L237.34 136.37V137.27L236.82 137.2L237.02 137.52H237.34L237.53 137.72L237.4 137.91V138.23L237.6 138.68V139.13L237.34 139.39V140.09L237.66 140.35L237.47 140.86L237.79 141.86L237.72 142.18L237.85 142.38L237.98 142.12H238.37L238.43 142.5L239.27 143.15L239.39 142.83L238.95 142.63L239.01 142.05H239.27L239.65 142.89L239.91 142.63L240.16 142.95L240.42 143.02L240.16 142.5H239.91L240.04 142.44L240.1 142.18L240.29 142.12L240.49 142.25V142.57L240.81 142.83L241.06 143.34L241.19 143.15L241 142.44L241.06 142.18L241.51 142.38L241.64 142.76H241.84L242.22 143.47L242.48 143.53V143.02L242.61 142.83H242.86L242.93 143.08L243.31 143.47L243.57 143.53L243.7 144.05L243.89 144.17L244 144L243.93 143.74L243.55 143.48L243.49 143.03L244 142.39H244.19L244.26 142.71L243.93 143.36L244.45 144.19L243.93 144.45L244.13 144.9L244.39 145.03L244.58 145.67L244.19 145.48L243.93 145.54L243.74 144.96H243.55L243.23 144.32L242.97 144.25V143.68L242.52 143.61V143.81L242.78 143.87L243.04 144.58V144.9L243.49 144.96L243.55 145.67L243.1 145.54L242.84 145.86L242.2 145.67L241.82 145.93L241.37 145.86L241.43 145.67L241.69 145.6L241.75 145.15L241.56 145.03L241.43 145.48L241.04 145.6L240.72 145.28L240.53 145.41L240.79 145.8L240.34 145.86L239.95 145.67L239.82 145.41L239.57 145.54L239.63 145.86L239.12 145.73L238.35 145.8L238.15 145.67L237.9 145.8L237.7 146.25L237.38 146.44L237.58 146.7L237.38 146.89L237.77 147.15L237.83 148.82L237.7 149.07L237.83 149.46L237.51 149.59L237.77 149.78L237.9 150.78L237.83 151.29L238.09 152.29L237.9 152.49L238.03 152.68L238.15 153.45L237.96 153.71L238.22 154.09L238.15 154.86L237.96 155.25L238.28 155.89V156.15L237.96 156.53L238.28 156.73V158.65L238.15 158.98L238.35 159.62L238.28 160.39L238.41 162.19L238.35 162.64L238.47 163.54L238.41 164.05L238.6 164.95L238.5 166L238.63 166.45L238.44 167.09L238.63 167.54L238.96 167.87L239.73 167.74L240.17 167.99L240.37 167.8H241.27L241.65 167.61L241.85 167.74L241.91 167.99L242.1 168.12L242.29 167.99L242.36 167.74L242.81 167.61L243 167.99H243.26L243.39 167.61H243.71L243.9 167.74L243.96 167.99H244.22L244.48 167.54H244.74L245.06 167.99L245.31 168.12L245.64 168.7L245.89 168.76V169L246.08 169.39L246.28 169.45L246.66 170.45L246.6 170.71L246.41 170.58L246.28 170L245.89 169.94L245.83 169.23L245.44 169.56L245.51 169.75L245.89 170L245.96 170.58L246.34 170.9L246.73 171.61L246.54 171.68L246.02 171.48L245.76 171.68L245.25 171.55L245.38 171.42L245.64 171.48L245.83 171.03L245.51 170.58L245.31 170.78L245.25 171.29H244.86L244.74 170.84L244.16 170.45V170L243.9 170.13L243.96 170.38L244.29 170.71V171L244.86 171.52L244.67 171.71L244.35 171.65L244.29 171.39L243.84 171.32L243.77 170.87L243.58 170.75L243.39 170.94L243.52 171.32L243.77 171.26L243.84 171.77L243.39 171.71L243.07 171.39L242.68 171.71L242.29 171.65L242.23 171.32L241.78 171.65L241.27 171.58L240.95 171.39L240.75 171.65L240.5 171.71L237.99 171.65L236.38 171.39L236.06 171.45L235.74 171.32L235.29 171.52L234.91 171.32H234.59L234.46 171.13L234.71 170.94L234.65 170.3L234.78 169.85L234.59 169.4L234.65 169.2L234.52 168.95L234.65 168.43L234.59 167.43L234.71 166.92L234.59 166.02L234.71 165.63L234.59 163.63V161.5L234.46 160.92L234.59 160.02L234.39 159.44L234.59 159.12L234.65 158.67L234.39 158.03L234.59 157.19L234.27 156.68L234.52 156.36L234.27 156.1L234.33 155.26L234.2 155.01L234.33 154.24L234.2 153.34L234.33 153.08L234.2 152.08L234.27 151.08L234.14 150.76L234.27 150.31L234.14 150.05L234.2 149.79L234.01 149.09L234.2 148.89V148.38L234.01 147.87L234.2 147.67L234.52 147.87L234.71 147.67L234.07 147.35L233.94 146.52L234.2 146.26L233.88 145.49V145.23L234.2 144.78V144.46L234.33 144.27L233.88 143.82V143.56L234.14 143.43L234.07 142.98L233.88 142.66L233.82 141.76L234.27 141.7L234.14 141.44L233.88 141.31V140.86L233.69 140.22L234.2 140.29L233.82 139.64L233.88 139.32L233.69 139.13L233.75 138.81H234.39L233.82 138.42L233.69 137.59L234.07 137.65L233.88 137.85L234 138.05ZM233.48 133.05L233.29 132.92L233.48 132.86V133.05ZM234.06 136.71L234.26 136.65L234.51 136.84L234.77 136.71L234.64 136.46L234 136.39L233.87 136.58L234.06 136.71ZM234.19 132.15L234.38 132.09L234.19 131.9L234 132.09L234.19 132.15ZM234.19 133.76H234.06L234.19 133.95V133.76ZM234.58 146.41L234.51 146.22L234.32 146.29L234.58 146.41ZM234.45 145.13L234.7 145.06L234.77 144.87H234.38L234.45 145.13ZM234.64 133.95L234.45 134.02L234.7 134.14L234.64 133.95ZM234.77 135.3L234.45 135.24L234.58 135.43L234.77 135.3ZM234.7 139.3H234.51L234.45 139.5L234.7 139.69L234.83 139.5L234.7 139.3ZM234.64 142.3L234.83 142.11L234.58 142.04L234.45 142.17L234.64 142.3ZM234.7 143.65L234.77 143.46L234.58 143.39L234.45 143.59L234.7 143.65ZM234.51 131.38L234.77 131.45L234.9 131.25H234.51V131.38ZM234.7 132.86L234.9 132.79L234.7 132.6L234.51 132.73L234.7 132.86ZM234.77 137.36L235.03 137.55L235.22 137.29L234.77 137.1L234.58 137.23L234.77 137.36ZM234.9 144.23L235.15 144.36L235.22 144.16L234.7 143.97L234.9 144.23ZM235.28 134.59L234.9 134.4L234.96 134.66L235.28 134.98V135.24L235.48 135.43V135.75L235.15 135.62L234.96 135.88V136.07L235.15 136.2L235.8 135.88L236.18 136.01L235.8 135.17L235.28 134.91V134.59ZM235.15 145.71L235.22 145.64L235.03 145.51L234.9 145.64L235.15 145.71ZM235.22 132.09L235.35 131.96L235.15 131.9L234.96 132.02L235.22 132.09ZM235.28 133.44L235.15 133.24L234.96 133.31L235.28 133.44ZM235.28 138L235.67 138.19L235.86 138.06L235.15 137.87L234.96 138H235.28ZM235.09 147H235V147.19L235.09 147ZM235.22 138.65H235V138.84L235.22 138.65ZM235.09 140.26L235.28 140.13L235.15 140.06L235.03 140.19L235.09 140.26ZM235.41 136.79L235.67 136.92L235.93 136.79L235.54 136.47L235.28 136.53L235.41 136.79ZM235.6 140.96L235.8 140.83L235.6 140.64L235.41 140.83L235.6 140.96ZM235.54 145.01H235.73V144.88L235.41 144.82L235.54 145.01ZM235.73 134.01L235.54 133.88V134.13L235.73 134.01ZM235.8 139.4L235.6 139.34L235.54 139.53L235.8 139.4ZM235.73 132.78L235.86 132.66H235.67L235.73 132.78ZM236.18 140.04L236 140L235.94 140.19L236.18 140.04ZM236.05 137.41L236.18 137.28L236.05 137.35V137.41ZM236.44 131.95L236.25 131.89V132.08L236.44 131.95ZM236.44 135.42L236.63 135.55L236.82 135.29L236.44 135.1L236.25 135.23L236.44 135.42ZM236.57 139.21L236.25 139.08V139.34L236.63 139.59L236.76 139.4L236.57 139.21ZM236.37 138.05L236.63 138.12L236.57 137.86L236.37 137.8V138.05ZM236.63 136.83L236.76 136.7L236.57 136.64L236.44 136.77L236.63 136.83ZM236.63 140.88L236.44 140.62V140.81L236.63 140.88ZM236.63 130.02L236.7 129.89L236.57 129.77L236.5 129.96L236.63 130.02ZM237.15 148.46L236.63 148.33L236.89 148.46H237.15ZM237.4 134.33V134.52L236.76 134.39L236.89 133.94L237.34 134.13L237.4 134.33ZM237.02 125.53V125.33L236.82 125.27L237.02 125.53ZM236.89 140.24L237.15 140.3L237.34 140.17L237.15 140.04H236.82L236.89 140.24ZM237.08 141.52H237.34L237.21 141.26L236.89 141.2L236.82 141.46L237.08 141.52ZM237.02 138.82H237.27V138.57L237.08 138.5L236.89 138.63L237.02 138.82ZM237.15 140.69L236.95 140.56V140.69H237.15ZM237.15 151.09L236.95 151.03V151.16L237.15 151.09ZM237.4 133.04L237.15 133.11L237 133V132.74L237.13 132.61L237.38 132.74L237.4 133.04ZM237.21 137.86L237.02 137.8V138L237.21 137.86ZM237.85 124.86V125L237.79 124.93L237.85 124.86ZM238.17 142.98L238.3 142.72L238.11 142.59L237.98 142.85L238.17 142.98ZM238.69 145.23L238.82 144.97L238.75 144.84H238.49L238.37 145.1L238.43 145.36L238.62 145.48L238.69 145.23ZM239.14 144.39V144.71L239.33 144.65L239.39 144.46L239.14 144.39ZM239.97 143.69L239.59 143.3L239.78 143.88L239.97 143.69ZM239.78 145.1L239.84 144.91L239.59 144.97L239.78 145.1ZM239.97 144.84L240.16 144.65L239.91 144.78L239.97 144.84ZM240.16 144.46L240.23 144.65L240.42 144.58L240.29 144.2H240.04V144.33L240.16 144.46ZM240.1 143.36H240.36V143.17L240.1 143.11V143.36ZM240.55 125.76H240.42L240.55 125.89V125.76ZM240.68 143.76H241L240.87 143.44H240.61L240.68 143.76ZM241.32 144.47L241.26 144.21L241.06 144.28L241.32 144.47ZM241.32 125.58H241.19L241.32 125.71V125.58ZM241.39 143.38L241.51 143.12H241.32L241.39 143.38ZM241.58 171.26H241.77L241.71 171.07H241.45L241.58 171.26ZM241.71 144.08L241.84 143.96H242V143.7L241.81 143.57L241.75 143.76L241.88 143.96L241.55 143.83L241.71 144.08ZM241.77 126.42L242.03 126.35L242.09 126.16L241.96 126.03L241.71 126.16V126.42H241.77ZM242.09 170.17V169.97L241.84 170.17H242.09ZM242.09 142.61L241.96 142.29L242.09 142.16L242.48 142.29V142.61H242.09ZM242.41 144.53H242.28L242.35 144.73L242.41 144.53ZM242.67 168.37L242.8 168.17L242.61 167.98H242.35L242.54 168.5L242.67 168.37ZM242.8 145.5L242.67 145.24L242.61 145.43L242.8 145.5ZM243.31 170.17L243.25 169.97L243 170L243.07 170.45H243.32L243.31 170.17ZM243.25 142.29L243.31 142.54H243.06V142.16L243.25 142.29ZM243.31 169.29L243.51 169.42L243.31 169.03L243.12 169.09L243.31 169.29ZM243.38 168.29L243.51 168.48L243.89 168.67L244.08 169.12L244.34 169.25V169.51L244.6 169.89L244.79 169.83V169.51L244.6 169.25L244.34 169.19L244.21 168.67L243.89 168.55L243.76 168.03H243.31L243.38 168.29ZM243.83 142.08L243.63 142.01L243.89 141.89L243.83 142.08ZM244.02 126.47L243.76 126.53L243.89 126.73L244.02 126.53V126.47ZM244.34 125.76L244.41 126.02H244.6L244.66 125.57L244.41 125.44L244.21 125.57L244.34 125.76ZM244.28 126.92V127.18L244.53 127.37V126.85L244.28 126.92ZM244.66 168.35L244.85 168.1L244.73 167.97L244.47 168.03L244.41 168.22L244.66 168.35ZM245.18 169.96L245 170L244.94 170.26L245.18 169.96ZM245.43 169.12L245.3 168.93V169.12H245.43ZM246 168L246.39 168.13L246.45 168.65L246.64 169.03L246.52 169.29L246.32 169.22V168.9L246.19 168.71H246L245.87 168.13L245.48 167.88L245.42 167.68L245.55 167.55L245.87 167.68L246 168ZM245.87 128.69V128.82L245.74 128.69H245.87ZM246.71 167.75L246.64 167.94H246.39L246.45 167.49H246.71V167.75Z",
                fill: "#0067A5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M258.87 124.75L259.06 124.88L259.32 124.81L259.45 124.62L259.9 124.75L260.15 125.01L260.48 124.81L261.05 124.88L261.18 125.07L261.57 124.88L262.27 125.07L262.53 125.01L262.72 125.33H263.43L263.56 125.46L264.46 125.65L264.52 125.84L264.84 125.78L265.74 126.23L265.68 126.48L266.51 126.81L266.77 127.26L267.22 127.32L267.09 127.51L266.64 127.71L266.77 127.9L267.03 127.71L267.48 127.64L267.8 127.96L268.12 128.03L268.31 128.41V128.67L267.8 128.86L267.61 129.05L267.8 129.18L268.31 129.05L268.63 129.31L268.51 129.5L268.06 129.76L267.8 129.44H267.61L267.22 129.76L268.31 129.89L268.57 129.76L269.02 130.08L268.89 130.34L268.63 130.47L268.89 130.6H269.47L269.02 131.05L269.15 131.24L269.79 131.43L269.6 131.75L269.15 131.5L268.96 131.62V132L269.47 131.87L269.79 132.12L269.21 132.57L269.66 132.51L269.98 132.77L269.85 133.02L270.05 133.22L270.56 133.41L270.24 133.79L270.3 134.05L269.98 134.44L270.63 134.76L270.56 135.01L270.24 135.27L270.88 135.46L270.5 135.72L270.24 135.53L269.98 135.72L270.05 135.85L270.5 135.79L270.69 136.04L270.56 136.36L270.75 136.62L270.56 137.07L270.5 137.71L270.82 138.03V138.35L270.43 138.42V139.19L270.56 139.38L270.82 139.32L270.3 139.7L270.37 140.28L270.11 140.47L270.24 140.73L270 141L270.45 141.26L270.39 141.52L269.94 141.65L269.87 141.84L270 142.03L269.62 142.48L269.87 142.35L270.07 142.48V142.74L269.55 142.8L269.43 143.12L269.62 143.32L269.43 143.51H269.17L269.04 143.64V143.89L269.17 144.02L269.36 143.96V144.21H268.65L268.46 144.86L268.2 144.92L268.14 145.37L267.69 145.56V145.89L267.5 146.14H267.18V146.53L267.05 146.72L266.86 146.66L266.53 147.23L266.28 147.3V147.49H266.08L265.89 147.81L265.31 148.2L265.38 148.52L265.06 148.39L264.8 148.71L264.99 149.48L264.86 150.13L265.38 150.7V151L265.64 151.52L265.38 151.84L265.76 151.97L265.51 152.22L265.89 152.55V152.8L266.21 153.19V153.51L265.89 153.7L266.08 153.96L266.34 154.02V154.22L266.08 154.28L266.15 154.47L266.41 154.28L266.53 154.41L266.34 154.86L266.73 155.24L266.79 155.57L266.41 155.76L267.05 156.14L266.98 156.46L267.11 156.66L266.86 156.98L266.98 157.11L267.37 157.04V157.49L267.69 158.07L267.56 158.33L267.69 158.65L267.43 158.71L267.31 158.91L267.69 159.1L267.82 159.29L267.56 159.68H267.95L268.14 159.87L267.95 160.38L268.14 160.64L267.82 160.7L267.5 161.09L267.56 161.22L268.27 160.9L268.46 161.22L268.14 161.6L268.27 161.73L268.53 161.6L268.65 161.86L268.46 162.31L268.85 162.63H268.53L268.33 163.08L268.72 162.95L268.91 163.15L268.78 163.66L269.17 163.79L269.04 164.37L269.17 164.56L269.1 164.75L269.55 165.27L269.43 165.52L269.75 165.84V166.04L269.43 166.36L269.87 166.68L269.36 166.81L269.43 167L269.87 166.87L270 167.06L269.75 167.71L269.94 167.84L270.26 167.77L270.32 168.03L270.07 168.41L270.45 168.61L270.32 168.93L270.39 169.31L270.26 169.63L270.84 169.76V170.08L271.1 170.53V170.79L271.29 170.98L270.77 171.05L271.03 171.18L271.35 171.11L271.42 171.3L271.22 171.5L270.71 171.63L270.45 171.5L270.2 171.56L269.75 171.43L269.43 171.5H267.95L268.01 171.3L267.63 171.56L267.18 171.63L267.05 171.18L267.56 170.98L267.69 170.79L267.5 170.66L266.98 170.92L266.73 170.79V170.47L267.18 170.21L267.11 170.02L266.92 169.95L266.66 170.15L266.41 170.08V169.83L266.79 169.57L266.6 169.25H266.21L266.28 168.8L266.08 168.54L266.6 168.28L266.41 168.03L266.08 168.22L265.83 168.03L265.89 167.84L266.21 167.58L265.7 167.39L265.57 167.13L265.83 166.87L265.7 166.61L265.44 166.49L265.57 166.29L265.25 166.04L265.31 165.71L265.76 165.39L265.19 165.27L265.06 165.07L265.12 164.82L264.99 164.56L265.12 164.37L264.8 163.98L264.93 163.6L264.67 163.21V163L264.93 162.93L264.67 162.48V162.23L264.29 162.1V161.65L264.54 161.39L264.09 161.33L264.16 160.94L263.71 160.17L263.84 159.4L263.52 159.34L263.64 158.76L263.19 158.11V157.79L263 157.34V156.89L262.87 156.64L262.49 155.16L262.55 154.71L262.23 154.45V154.2L262.1 154.07L262.04 153.62L261.78 153.49V153.1L261.59 152.85V151.8L261.27 151.6V151.15L261.14 151.02L260.43 151.41L260.24 151.22L259.98 151.41L259.21 151.6V151.35L258.31 151.73L257.8 152.31L257.54 152.12H257.28L257.73 152.37L257.86 152.57L257.99 153.47L257.86 153.66L257.99 155.39L257.73 155.65L257.99 155.84L258.06 156.29L257.8 156.87L258.12 157.45L257.93 157.64L257.54 157.51L257.35 157.64L257.93 158.03L257.8 158.35L258.18 158.73L257.86 159.63L258.12 160.08L257.99 160.34L258.06 160.66L257.8 160.98L258.12 161.17L258.18 161.43L257.93 161.56L258.12 161.94L257.28 162.33L257.41 162.46L257.86 162.33L258.12 162.46L258.18 162.72L258 163L257.67 163.13L258 163.39L257.67 163.65L258.06 163.71L258.19 164.1L258.12 164.35L257.42 164.16L257.74 164.54H258.06L257.87 164.8L258.19 165.19V165.44L257.87 165.7L258.06 166.02L257.74 166.09L257.61 166.28L257.74 166.41H258L258.25 166.79L257.93 167.11L258.25 167.31V167.5H257.67L257.87 167.69L258.12 167.63L258.19 168.27L257.87 168.33L258.19 168.72L257.93 168.66L257.74 168.78L257.8 169.04H258.12L258.19 169.94L258.06 170.07L258 169.75L257.42 169.36L257.22 169.49L257.74 169.94L257.87 170.26H258.12L258.19 171.48L258.06 171.16L257.74 171.03L257.42 170.71L257.22 170.9L257.67 171.16L257.48 171.61L257.16 171.68L256.9 171.35L256.45 171.68L255.81 171.35L255.55 171.61H255.1L254.91 171.93L254.59 171.87L254.46 171.61L254.21 171.68L254.08 171.35L253.75 171.29L254.08 171.03L253.95 170.84H253.69L253.82 170.58L254.08 170.45L254.33 170.65L254.91 169.88L254.33 169.36L254.72 169.11H255.04L254.91 168.78L254.53 168.91L254.21 168.85L254.08 168.59L254.65 168.53L254.85 168.66L255.04 168.46H254.72L254.4 168.01L254.53 167.82H255.3L255.49 167.69H255.17L254.98 167.44V167.18L254.65 167.05L254.33 166.66L254.59 166.34L254.21 166.47L254.27 166.73L254.14 166.92L253.63 166.99L253.56 166.73L253.69 166.47L254.08 166.41V165.83L254.65 165.96L254.91 165.89L254.33 165.38L253.95 165.76L253.75 165.7L253.56 165.25L254.08 165.19L254.27 165.32L254.46 165.06L254.08 164.93L254.01 164.67L254.59 164.42L254.46 164.16L254.01 164.42L253.63 164.22L253.56 163.97L254.08 163.71L253.95 163.45L254.21 163.07L254.59 163.13L254.27 162.68L253.75 163.13L253.63 163.07L253.56 162.62L253.69 162.42L253.95 162.49L254.08 162.3V161.85L253.69 161.53L253.63 161.33L253.75 161.14L254.4 161.27L253.82 160.75L253.95 160.56L253.63 160.31V160L254.01 159.81L254.14 159.61L254.01 159.36L254.14 159.16L254.65 158.97L254.46 158.71L254.65 158.46L254.33 158.58L254.4 158.78L254 159L253.61 158.81L253.74 158.55L254 158.61L254.19 158.42L253.74 158.04L254.26 157.78L254.7 157.72L254.58 157.52L253.87 157.72L253.68 157.59L253.74 157.14H254.06V156.49L253.74 156.17L254.19 155.72L253.8 155.53L254.13 155.15L253.74 154.89L253.68 154.7L253.8 154.57H254.13V154.31L253.8 153.99L254.26 153.67L254.45 153.73L254.58 153.6L254.45 153.48L254.19 153.67H253.8L253.74 153.28L254.19 153.09L253.8 152.7L254.45 152.19L254.13 152.32L253.74 152.25L253.68 151.87L254.13 151.61L253.87 151.29L254.06 151.1L253.74 150.91L253.68 150.65L253.8 150.33H254.06L254.13 150.2L253.93 149.88L253.8 150.01V149.88L254.06 149.75L253.74 149.56L253.68 149.24L254 149V148.74L253.74 148.36V147.71L254 147.59L253.8 147.33L253.68 146.62L253.74 146.37L254.06 146.3L253.8 146.11L253.87 145.85L253.74 145.66V145.21L254.06 145.08L253.74 144.82L254 144.57L253.74 144.44L253.68 144.12L253.8 143.86L254.13 143.73L253.8 143.6V143.09L253.74 140.09L253.87 139.9L253.8 139.45L254.06 139.26L253.8 139.07L253.74 138.74L253.93 138.04L253.8 137.78V136.88L253.93 136.69L253.8 136.37V133.8L253.61 133.03L253.74 132.03L253.61 131.77L253.68 130.77L253.55 129.77L253.61 129.19L253.48 128.94L253.61 128.16L253.48 127.65L253.68 127.14L253.48 126.37L253.55 125.79L253.36 125.21L253.48 125.08H254.77L255.15 124.95L255.6 125.08L255.99 124.89L256.7 124.95L256.95 124.82L257.53 124.89L257.98 124.76L258.56 124.82L259.01 124.63L258.87 124.75ZM254.18 168.18L254.05 168.3L253.67 168.05L253.79 167.86L254.25 167.92L254.18 168.18ZM254.12 169.59H253.92L253.73 169.4L253.86 169.27L254.31 169.33L254.12 169.59ZM254.12 167.53V167.21L254.31 167.08L254.82 167.21L254.63 167.53L254.18 167.79L254.12 167.53ZM254.44 169.97L254.63 169.91L254.76 170.04L254.18 170.36V169.91L254.44 169.97ZM254.44 151.02L254.69 150.96L254.44 150.83L254.25 150.9L254.44 151.02ZM254.5 156.23H254.25V156.42L254.5 156.23ZM254.44 160.53L254.69 160.47L254.57 160.21L254.37 160.15L254.25 160.4L254.44 160.53ZM254.57 145.69L254.63 145.5L254.37 145.63L254.57 145.69ZM254.69 155.01L254.57 154.81L254.44 154.94L254.69 155.01ZM254.44 157.01V157.2L254.95 156.88L254.63 157.01H254.44ZM254.44 161.44V161.63H254.63L254.44 161.44ZM254.5 170.82V171.08L254.69 171.21L255.4 171.01L255.92 171.14L256 171L255.68 170.94L255.49 170.68L254.78 170.94L254.5 170.82ZM255.02 166.39L255.08 166.13L254.82 166.07L254.63 166.26L255.02 166.39ZM254.89 162.39L255.02 162.2H254.76L254.69 162.39H254.89ZM255.02 163.8L255.08 163.61L254.82 163.55L254.69 163.74L255.02 163.8ZM254.89 163.23L254.76 163.16L254.89 163.35V163.23ZM254.89 165.02L255.08 164.96L254.95 164.77L254.76 164.9L254.89 165.02ZM254.95 161.88V161.75L254.82 161.88H254.95ZM255.4 168.56L255.46 168.3L255.27 168.24L255.08 168.43L255.4 168.56ZM255.21 169.84L255.46 169.78L255.59 169.59L255.27 169.46L255.14 169.71L255.21 169.84ZM255.4 155.13L255.59 155L255.4 154.94L255.21 155.07L255.4 155.13ZM255.34 165.92L255.85 165.99L255.98 165.86L255.34 165.54L255.21 165.73L255.34 165.92ZM255.46 153.78V153.53L255.27 153.72L255.46 153.78ZM255.34 159.11L255.53 158.99H255.27L255.34 159.11ZM255.53 164.32L255.66 164.06L255.46 163.87L255.27 164.32H255.53ZM255.53 152.43L255.59 152.3L255.46 152.18L255.34 152.37L255.53 152.43ZM255.46 163.03L255.59 162.97L255.46 162.65L255.34 162.9L255.46 163.03ZM255.4 169.2L255.53 169.07H255.34L255.4 169.2ZM255.46 157.77V157.64L255.4 157.77H255.46ZM255.53 160.46V160.27H255.4L255.53 160.46ZM255.66 166.46L256.11 166.2L255.85 166.08L255.4 166.4L255.66 166.46ZM255.85 170.38L256.24 170.7L256.11 170.89L256.56 171.09L257 171V170.81L256.68 170.87L256 170L255.62 170.13L255.55 170.39L255.85 170.38ZM255.72 168.77V168.97L255.98 169.03L256.11 168.84L255.92 168.45L255.66 168.52L255.72 168.77ZM255.92 165.05L256.11 164.92L255.92 164.79L255.72 164.92L255.92 165.05ZM255.85 163.7L256.11 163.64L255.92 163.51L255.79 163.7H255.85ZM256.43 169.7H256.69L256.62 169.44L256.43 169.31L256.24 169.38L256.17 169.63L256.43 169.7ZM256.49 168.22L256.24 168.16L256.36 168.35L256.69 168.28L256.49 168.22ZM256.56 154.86L256.49 154.73L256.43 154.92L256.56 154.86ZM256.94 165.01L257.14 164.88L256.94 164.75L256.62 164.88L256.94 165.01ZM256.75 158.26V158.2L256.69 158.26H256.75ZM256.69 159.61L257.01 159.68V159.48L256.69 159.55V159.61ZM256.75 163.66L257.01 163.6L256.69 163.53L256.75 163.66ZM257.01 170.28L257.14 170.08L256.75 170.02L256.69 170.21L257.01 170.28ZM257.01 166.36L257.07 166.16L256.88 166.1L256.75 166.29L257.01 166.36ZM256.94 168.99L257.14 168.93L257.07 168.73L256.88 168.67L256.75 168.86L256.94 168.99ZM257.01 167.77L257.14 167.58L256.81 167.51L257.01 167.77ZM256.88 156.77V157L257.07 156.93L256.88 156.77ZM257 168.3H256.87L257 168.43V168.3ZM257.38 160.4L257.64 160.21H257.32L257.13 160.34L257.38 160.4ZM257.45 167.02L257.64 166.83L257.45 166.7L257.25 166.76L257.13 167.02H257.45ZM257.51 154.94L257.38 154.81L257.19 154.88L257.51 154.94ZM257.45 162.94L257.51 162.75H257.25L257.19 162.94H257.45ZM257.32 165.64L257.57 165.7L257.64 165.45L257.45 165.26L257.19 165.38L257.32 165.64ZM257.32 153.64H257.57L257.7 153.45L257.45 153.38L257.25 153.57L257.32 153.64ZM257.57 168.28L257.38 168.09L257.25 168.28H257.57ZM257.38 137.77H257.64V137.64L257.38 137.71V137.77ZM257.51 166.49L257.57 166.29L257.38 166.36L257.51 166.49ZM257.57 170.4L257.38 170.28L257.45 170.47L257.57 170.4ZM261.3 128.58L260.59 128.65L260.34 128.46L259.7 128.58L259.18 128.46L258.35 128.58L258.15 128.46L257.7 128.65L257.83 129.65V131H257.45L257.77 131.32L257.9 131.84L257.83 133.76L257.57 133.83L257.77 134.09L257.9 135.09L257.77 135.29L257.96 136.63L257.77 137.08L257.9 137.28L257.77 138.43L257.96 139.08L257.9 140.55L257.7 141.07L257.83 141.26L257.9 141.77L257.77 142.03L257.83 142.87L257.45 142.99L257.77 143.19V144L257.9 144.45L257.77 144.7L257.9 146.76L257.7 147.21L257.96 147.98L258.41 148.11L258.67 147.85L259.12 147.66L259.31 147.27L259.5 147.53L259.63 147.4L259.89 147.53L260.14 147.47L260.72 147.02L260.92 146.7L261.17 146.89L261.56 146.57V146.25H261.3L262.2 146.12L262.26 145.8L263.26 144.96L263.39 144.7L263.65 144.77L263.84 144.58L264 144H264.38L264.51 143.81L264.44 143.49L264.57 143.3L265.02 143.42L265.15 143.23L264.96 142.78H265.15L265.34 142.59L266.18 141.11L266.31 141.18L266.5 140.18L266.37 139.99L266.56 139.47L266.95 139.28L266.89 138.64L266.69 138.31L267.01 137.8L266.76 136.8L266.95 136.48L266.69 136.03L267.27 135.83L267.4 135.64L267.21 135.58L266.82 135.77L266.69 135.51L266.95 135.06L266.63 134.81L266.89 134.61L267.27 134.55L267.21 134.36H266.95L266.89 134.55L266.56 134.48L266.44 134.23L266.95 133.65L266.76 133.33L266.82 133.14H266.5L266.63 133.33L266.44 133.65L266.18 133.26L266.5 133.01L265.99 132.88L265.86 132.69L265.92 132.36L265.67 132.11L265.41 131.47L265.86 131.27L265.99 131.08L265.92 130.89L265.67 130.82L265.28 131.14H265L264.87 130.63L265.32 130.5L265 130.18L264.55 130.5L264.36 130.31L264.42 129.73L263.85 129.86L263.59 129.6L262.95 129.41L262.75 129.09L262.24 129.15L262.11 128.83L261.79 128.96L261.53 128.9L261.3 128.58ZM257.64 136.58L257.7 136.45L257.57 136.32L257.51 136.45L257.64 136.58ZM258.54 147.63L258.41 147.76V147.5L258.54 147.63ZM259.54 150.71L259.41 150.58V150.84L259.54 150.71ZM260.54 128.1L260.61 128.29L260.8 128.16L260.74 127.84H260.48L260.54 128.1ZM260.61 150.65H260.48V150.78L260.61 150.65ZM263.05 155.65V155.59L262.99 155.65H263.05ZM263.76 129.25L264.01 129.12V128.93H263.76L263.56 129.12L263.76 129.25ZM264.01 127.45L263.82 127.58L263.89 127.83L264.14 127.64L264.01 127.45ZM264.4 128.45L264.72 128.26H264.33L264.4 128.45ZM264.78 129.8L264.66 129.74L264.72 129.87L264.78 129.8ZM264.98 129.16L265.36 128.84L264.85 128.9L264.72 129.09L264.98 129.16ZM264.98 126.59L265.04 126.46L264.91 126.52L264.98 126.59ZM265.36 127.36L265.62 126.91H265.43L265.17 127.3L265.36 127.36ZM265.56 160.36L265.36 160.16L265.3 160.36H265.56ZM265.49 128.49L265.62 128.62L265.75 128.56L265.62 128.17L265.43 128.23L265.49 128.49ZM265.75 129.91L265.81 129.84L265.62 129.65L265.43 129.84L265.75 129.91ZM265.43 157.72L265.62 157.53H265.43V157.72ZM265.81 129.33L266.52 129.2L266.13 128.88L265.88 128.94L265.75 129.13L265.81 129.33ZM266 132.15V132L265.75 132.06L266 132.15ZM266 162.33V162.14L265.81 162.2L266 162.33ZM266.19 159.5H266L265.94 159.63L266.19 159.5ZM266.06 160.85V160.66L265.94 160.85H266.06ZM266.26 130.47L266.39 130.34H266.19L266 130.53L266.26 130.47ZM266.32 131.24L266.84 131.11L266.9 130.85L266.64 130.79L266.13 131.17L266.32 131.24ZM266.45 129.89L266.71 129.7L266.51 129.57L266.19 129.83L266.45 129.89ZM266.45 128.41L266.9 128.35L266.71 128.15L266.39 128.22L266.26 128.41H266.45ZM266.64 162.91L266.58 162.72H266.39L266.32 162.91H266.64ZM266.51 164.26L267.22 164L266.32 164.19L266.51 164.26ZM266.64 132.33H266.45L266.51 132.52L266.64 132.33ZM266.64 166.89V166.76L266.58 166.89H266.64ZM266.77 140.49L266.84 140.3H266.64L266.77 140.49ZM267.03 164.71H266.84L266.77 164.96L267.03 164.71ZM266.9 130.53L267.9 130.6L268.03 130.47H267.71L267.26 130.15L266.93 130.21L266.81 130.47L266.9 130.53ZM266.96 168.82L266.84 168.75V168.88L266.96 168.82ZM266.96 129.25L267.41 128.99L267.22 128.8L266.96 128.86L266.9 129.18L266.96 129.25ZM267.22 133.17L267.35 132.97L267.22 132.91L266.9 133.17H267.22ZM267.16 138.63L267.35 138.43L267.09 138.3L266.9 138.5L267.16 138.63ZM267.09 158.35L267.16 158.15H267L266.87 158.35H267.09ZM266.96 162.27L267.16 162.2L266.9 162.14L266.96 162.27ZM267.22 131.75L266.96 131.69V131.88L267.22 131.75ZM267 159.7L267.19 159.5L267 159.44L266.93 159.63L267 159.7ZM266.93 167.6L267.13 167.47H267L266.93 167.6ZM267.19 137.21L267.32 136.96L267.13 136.89L267 137.15L267.19 137.21ZM267.19 139.78V139.65L267.06 139.72L267.19 139.78ZM267.32 137.86L267.13 137.66L267.19 137.86H267.32ZM267.19 128.48L267.71 128.28V128.15H267.51L267.38 128.35L267.19 128.48ZM267.51 162.97L267.64 162.84L267.32 162.72L267.19 162.97H267.51ZM267.45 166.97L267.51 166.71L267.26 166.84L267.19 167.09L267.45 166.97ZM267.45 168.25H267.64L267.71 168.12L267.26 168.31L267.45 168.25ZM267.64 161.51L267.45 161.44L267.32 161.57L267.58 161.63L267.64 161.51ZM267.38 132.34L267.45 132.6L267.9 132.47L267.77 132.21L267.51 132.15L267.38 132.34ZM267.64 135.23L267.71 135.04H267.45L267.38 135.23H267.64ZM267.71 131.06L267.51 130.86L267.45 131.06H267.71ZM267.71 137.8L267.77 137.67L267.58 137.61L267.45 137.74L267.71 137.8ZM267.83 133.69L267.71 133.63L267.58 133.75L267.83 133.69ZM268.09 168.83L267.9 168.7L267.83 168.89L268.09 168.83ZM268.22 131.89L268.35 131.63H268.09L267.96 131.89H268.22ZM268.35 130.41L268.15 130.29L268.03 130.41H268.35ZM268.28 132.66V132.47L268.03 132.53L268.28 132.66ZM268.28 133.18L268.35 132.98L268.15 132.92L268.03 133.05L268.28 133.18ZM268.15 165.81L268.48 165.49L268.03 165.68L268.15 165.81ZM268.28 134.52L268.35 134.33L268.09 134.46L268.28 134.52ZM268.28 131.25L268.67 130.93L268.8 131.06L269 131L268.55 130.87L268.16 131.13L268.28 131.25ZM268.41 167.09L268.6 167.03L268.35 166.71L268.22 167.03L268.41 167.09ZM268.54 170.88L269.18 170.76L268.28 170.88H268.54ZM268.54 132.4L268.67 132.53L268.86 132.34L268.54 132.15L268.48 132.21L268.54 132.4ZM268.99 169.09L269.25 169.02L269.12 168.76H268.86L268.73 169.02L268.99 169.09ZM268.99 167.48L268.8 167.54L268.86 167.8L268.99 167.48ZM269.05 166.39L269.31 166.19H268.86L269.05 166.39ZM269.18 133.11L269.25 132.98L269.05 132.92L268.93 133.11H269.18ZM269.57 170.69L269.31 170.63L269.25 170.82L269.57 170.69ZM269.76 169.54L269.57 169.34L269.31 169.47L269.57 169.66L269.76 169.54ZM269.76 168.25L269.57 168.12L269.44 168.25L269.5 168.44L269.76 168.25ZM269.57 170.43L269.7 170.31H269.5L269.57 170.43ZM270.02 170.31L269.95 170.11L269.82 170.24L270.02 170.31ZM270.15 132.15H270V132H270.2L270.15 132.15ZM270.47 140.82L270.4 140.56L270.6 140.63L270.47 140.82ZM270.53 170.76V170.63L270.4 170.76H270.53Z",
                fill: "#0067A5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M282 125L282.06 126.28V128.28L281.93 128.8L282.06 129.5L281.93 129.83L281.87 131.37L282 131.95V133.42L282.12 133.62L281.93 134L282.06 134.19L282.12 134.77L281.93 135.22L282.06 135.41L281.93 136.76L282.06 137.02L281.87 137.53V138.18L282 138.63L281.87 138.88V139.33L282.06 139.72V140L281.87 140.25L282 140.51L281.8 140.77L282.06 141.09L281.93 141.67L282 141.92L281.8 142.31L282.06 142.5L281.93 143.5L282.12 143.76V144.14L281.93 144.4L282 144.59L281.87 144.78L282.12 145.1L281.8 146.26L282.12 146.58L281.8 147.58L282.12 147.9L282 148.41L282.06 148.67L281.93 148.92L282.12 149.25V149.57L281.87 149.82L282.06 150.08L281.93 150.27L282.25 150.66L282 151.56L282.32 152.01V152.26L282.12 152.46L282.19 152.71L281.93 153.04L282.38 153.42L282.12 153.94L282.44 154.32L282.19 154.38L282.51 154.83L282.25 155.28L282.44 155.35V155.61L282.32 155.48L282.19 155.61L282.44 155.99L282.19 156.63L282.57 156.7L282.51 156.95L282.19 157.08L282.57 157.34L282.44 157.73L282.12 157.98L282.19 158.11L282.57 158.05L282.7 158.24L282.64 158.95L282.51 159.2L282.83 159.72L282.64 160.04L282.7 160.49L283.02 161L282.7 161.45L282.96 161.52L283.09 161.71H282.83L282.7 161.84L283.09 162.16V162.41L282.77 162.8L283.15 162.86L283.22 163.76L282.83 164.15L283.47 164.41V164.6L283.28 164.79V165.31L283.73 165.56L283.79 165.82L283.41 166.14L283.47 166.27L283.73 166.14L284.24 166.33L284.18 166.59L284.31 166.91L284.69 167.1L284.44 167.55L284.5 167.94L283.99 168.07L283.86 168.32L283.92 168.45L284.18 168.32L284.31 168.45L284.56 168.26L284.76 168.45V168.9L284.89 168.45L285.14 168.13H284.76L284.63 167.81L284.76 167.55L285.27 167.88L285.21 168.07L285.72 168.26L285.79 168.65L285.98 168.77L286.17 168.71L286.36 168.13L286.88 168.39V168.71L287.2 168.77L287.26 168.32L287.84 168.07H288.42L288.93 168.39L289.13 168.2L288.8 168L288.87 167.62L289.13 167.55L289.64 167.68L289.77 167.62L289.64 167.17L289.7 166.91L289.96 167.04L290.28 166.72L290.54 166.65L290.47 166.4L291.05 165.88L290.67 165.82L290.8 165.5L291.25 165.43L291 165L291.06 164.68L291.32 164.48L291.38 163.97L291.64 163.84L291.58 163.52L292.09 163.14L291.58 163.07L291.71 162.88L292.15 162.62L291.83 162.36V162.04L292.15 161.72V160.82L292.67 160.57L292.22 160.25V160L292.6 159.81L292.54 159.55L292.73 159.1L292.28 158.97L292.6 158.39V157.88L292.41 157.49L292.48 157.24L292.67 157.36L292.8 157.17L292.6 156.72L292.8 156.34L292.48 156.14L292.6 155.76L292.73 155.82L292.6 155.31L292.86 154.99L292.73 154.73L292.86 154.47L292.6 154.09L293.12 153.57L292.86 153.38V153.12L292.6 152.8L292.54 152.48L293.05 152.16L292.73 151.9L292.93 151.65L292.54 151.2L292.73 150.88L292.99 150.81L292.8 150.55L292.93 150.3L292.6 149.85L292.8 149.53L292.73 148.95L292.54 148.82L292.99 148.18L292.67 147.86L292.8 147.66L292.54 147.41V147L292.8 146.81L292.67 146.49L292.86 146.23L292.48 145.97L292.41 145.72L292.73 145.33L292.48 145.01V144.3L292.67 143.98L292.41 143.79V143.15L292.67 142.76L292.28 142.63V142.25L292.6 141.99L292.35 141.73V141.48L292.09 141.16L292.15 140.9L292.48 140.83L292.67 140.64L292.28 140.45L292.15 140.26L292.09 139.68L292.22 139.42L292.48 139.49L292.6 139.23L292.15 139.04V138.33L292.41 137.88L292.15 137.69L292.09 135.57L291.9 133.7V131.78L291.64 130.56L291.71 130.24L291.51 129.59L291.64 128.44L291.51 127.44L291.64 126.99L291.38 125.45L291.51 125.32H292.35L292.8 125.06H294L294.83 125.19L295.28 125L295.6 125.06L295.73 125.25L295.67 125.64L295.92 126.03V126.73L295.73 126.92L296.05 127.18L296.12 127.44L295.8 127.89L295.99 128.14L296.18 128.85L296.05 129.11L296.12 129.43L295.86 129.75L296.12 129.88V130.88L295.92 131.08L296.18 131.27L296.12 131.98L296.25 132.36L295.92 132.49L296.31 132.81L296.18 133.39L296.31 133.58L296.05 133.84L296.37 134.03V134.67L296.12 134.74L296.37 134.8L296.44 134.93L296.18 135.25L296.57 135.77L296.44 136.09L296.5 136.41L296.44 136.28L296.25 136.54L296.5 136.47L296.7 137.05L296.57 137.89H296.37L296.57 138.01L296.7 138.46L296.63 138.78L296.76 139.11V139.88L296.57 140.2L296.82 140.45L296.63 141.35L296.82 141.8L296.63 142.25L296.76 142.45L296.5 142.77L296.82 143.15L296.57 144.15L296.82 144.53L296.7 144.98L296.89 145.24L296.7 145.5L296.95 146.07L296.76 146.4L296.89 146.65L296.63 146.91L296.82 147.1L297.02 147.04V147.62L297.15 147.87L297.02 148.32L297.15 148.64L297.08 148.84L297.21 149.93L297.08 150.19L297.21 150.63L297.08 151.63L297.21 151.82V152.4L296.95 152.27L296.89 152.4L297.15 152.53L297.27 153.62H297L297.2 153.75L297.32 154.33L297.26 154.84L297.07 154.97L297.26 155.48V156L297.07 156.45L297.13 156.77L297 157.67L297.13 158.12L296.94 158.51V159.51L296.81 159.96L296.87 160.54L296.62 160.47L296.42 160.67L296.55 160.92L296.42 161.44L296.55 161.57V161.82L296.36 162.14L296.42 162.4L296.23 162.59L296.3 162.98L296.1 163.17V163.94L295.85 164.01L295.72 163.88L295.65 164.07L295.85 164.14L295.91 164.46L295.65 164.78L295.78 165.03L295.59 165.36L295.72 165.87L295.59 166.13L295.4 166.19L295.33 166.7L294.88 166.83L294.95 167.54L294.82 167.93L294.56 168.05L294.5 168.57L294.18 168.7V168.95L293.6 169.4L293.53 169.72L293 170L292.87 170.32L292.68 170.38V170L292.36 170.19V170.77L292.16 170.64L292.04 170.83L291.65 170.58L291.52 170.71L291.65 170.9L291.33 171.28L290.56 171.8L290 172L289.87 171.74L289.61 171.94L289.67 172.13L289.22 172.51H288.58L288.39 172.64L288.2 172.51L288.26 172.19L288.13 172H287.88L287.68 171.81L287.49 172L287.75 172.13L287.88 172.39L287.81 172.64L287.55 172.71L287.1 172.51L287.17 172.19L286.85 172.32V172.58L286.72 172.71L285.63 172.45L285.82 172.32L286.01 172.45L286.2 172.26L285.88 172.19L285.82 171.68L285.69 171.49L285.31 171.42L285.18 170.97L284.73 170.78V170.2L284.47 170.14L284.21 170.33L284.28 170.65L283.83 170.84L283.64 170.52L282.86 170.84L282.74 171.1L283.06 171.17V171.36L282.61 171.17L282.35 170.78H281.77L281.64 170.59L281.71 170.33L281.9 170.59L282.09 170.33L282.16 169.94L282.48 169.43L282.03 169.17L281.71 169.69L282.09 170.01L281.39 170.07L281.26 170.27L280.81 169.88L280.94 169.75L281.13 169.82L281.64 169.56L281.26 169.24L281 169.3L280.94 169.05L281.07 168.79L280.81 168.53L280.23 168.72L280.1 168.4L281.39 168.27L281.51 168.08L281.19 167.89L280.68 168.02L280.23 167.76L279.84 168.08L279.65 167.95L280.1 167.31L279.91 167.12L280.49 166.73L280.36 166.54L279.72 166.8L279.52 166.35L279.97 166.03L279.78 165.9L279.2 166.03L279.14 165.83L279.27 165.58L279.84 165.7L280.04 165.64L280.1 165.38L279.84 165.32L279.65 165.45L279.33 165.19L279.07 165.26L278.88 165.13L279 165H279.32L279.51 164.74H279.25L279 164.36L279.64 164.16L279.51 163.91L279.25 163.78L279 163.91L278.67 163.71L279.12 163.39L279.32 163.52L279.45 163.39H279.19L278.87 163.01L279.51 162.62L279.38 162.49L278.87 162.62L278.61 162.56V162.3L279.06 162.04L278.93 161.72L278.61 161.79V161.53L279.32 161.4L279.51 161.21L279.32 161.08L278.93 161.21L278.55 161.14L278.67 160.69H279L278.8 160.31L278.35 160.44L278.29 159.99L278.48 159.86L278.61 160.12H278.87L278.93 159.99L278.8 159.8H278.55V159.41L278.93 159.15L278.8 158.64L278.55 158.57L278.67 158.9L278.35 159.09L278.23 158.9L278.48 158.51L278.35 158.38L278.16 157.61L278.42 157.35L278.67 157.48L279 157.23L278.48 157.29L278.23 156.9L278.55 156.52H278.8L278.87 156.33L278.67 156.2L278.23 156.39L277.97 156.26L278.1 155.94L278.42 155.81L278.35 155.36L278.8 154.98L278.74 154.85L278.16 155.11L277.84 154.91L278.35 154.46V153.82L277.97 153.63L278.03 153.37L278.42 153.11L278.23 152.73L278.35 152.41L278.16 152.28L278 152L278.26 151.68L277.87 150.84L278.26 150.33L278.13 150.14L278.26 149.94L278 149.3L278.13 148.85L277.94 147.95L278.07 147.63L277.94 147.37L278.07 147.12L277.74 146.6L278.07 146.28L277.87 145.19L278 144.93L277.87 144.74L278 144.48L277.81 144.1L278.07 143.52L277.81 142.81L277.94 142.17L277.81 141.17L278 140.85L277.74 140.02L277.94 139.24L277.81 138.54L277.94 138.09L277.81 136.93L277.94 136.42L277.81 135.42L277.94 135.23L277.81 134.23L278 134V132.14L277.87 131.62L277.93 130.53L277.8 130.28L278.19 127.28V125.87L278.06 125.35L278.19 124.9L279.92 124.84L280.12 124.71L280.7 124.77L281.08 124.65H282.08L282 125ZM278.65 152.36L278.85 152.23L278.65 152.11L278.4 152.43L278.65 152.36ZM278.65 153.78L278.78 153.58L278.46 153.71L278.65 153.78ZM278.98 149.09L279 149H278.81L278.98 149.09ZM279.17 158.66L279.43 158.72L279.36 158.47L279.17 158.34L278.98 158.53L279.17 158.66ZM279.3 160.01L279.49 159.82L279.3 159.69L279.04 159.82L279 160L279.3 160.01ZM279.23 150.31L279.04 150.18V150.37L279.23 150.31ZM279.17 156.67L279.3 156.47L279.04 156.6L279.17 156.67ZM279.1 158.08L279.3 157.95L279 158L279.1 158.08ZM279.23 159.43V159.3L279.1 159.43H279.23ZM279.3 160.84L279.36 160.71H279.17L279.1 160.84H279.3ZM279.55 156.47L279.87 156.35L279.68 156.22L279.49 156.41L279.55 156.47ZM279.62 162.06L279.68 161.87L279.49 161.93L279.62 162.06ZM279.68 164.83L279.87 164.76L279.75 164.57H279.62L279.49 164.76L279.68 164.83ZM279.49 167.01H279.68V167.14L279.49 167.01ZM279.87 160.52L279.68 160.33L279.55 160.52H279.87ZM279.68 163.52H279.87L280 163.32L279.81 163.26L279.62 163.45L279.68 163.52ZM279.87 164.16L279.75 164.35L280.33 164.16L280.39 163.97H280.07L279.87 164.16ZM280.2 159.92L280.33 159.73L280.13 159.66L279.94 159.86L280.2 159.92ZM280.65 163.32L280.13 163.52L280.45 163.65L280.97 163.45L280.9 163.26L280.65 163.32ZM280.33 164.99L280.39 164.8H280.13L280.33 164.99ZM280.45 157.99L280.33 157.93L280.2 158.12L280.45 157.99ZM280.2 166.34L280.45 166.41L280.71 166.21L281.03 166.28L281.1 166.15L280.97 165.96L280.65 165.89L280.2 166.34ZM280.45 167.69L280.77 167.56L280.9 167.37L280.65 167.31L280.2 167.63L280.45 167.69ZM280.58 162.17L280.65 161.97L280.39 162.1L280.58 162.17ZM280.52 169.3L280.45 169.11H280.71V169.36L280.52 169.3ZM280.77 157.93L280.9 157.8H280.65L280.52 157.93H280.77ZM280.58 160.63L280.77 160.5L280.58 160.56V160.63ZM281.22 166.92L281.29 166.66L280.9 166.92H281.22ZM281.22 161.46L281.42 161.33L281.1 161.2L280.97 161.4L281.22 161.46ZM281.22 162.81L281.48 162.68L281.22 162.55L281.03 162.68L281.22 162.81ZM281.35 164.22L281.54 164.03L281.1 163.97L281.03 164.16L281.35 164.22ZM282.12 163.39L281.8 163.13L281.54 163.45L281.16 163.52L281.29 163.65L281.74 163.45L282.51 163.65L283.02 163.26L282.83 163.13L282.44 163.39H282.12ZM281.42 165.39L281.16 165.27V165.39H281.42ZM281.54 167.64H281.8L282.12 167.32L281.93 167.19L281.35 167.58L281.54 167.64ZM281.54 145.64L281.48 145.38L281.42 145.57L281.54 145.64ZM281.54 151.87L281.61 151.68L281.42 151.81L281.54 151.87ZM281.61 164.87L282.06 164.68L281.93 164.48L281.48 164.61L281.42 164.87H281.61ZM281.54 168.87L282 169L282.19 168.67L282 168.55L281.42 168.67L281.54 168.87ZM281.8 152.36V152.1L281.61 152.04L281.48 152.23L281.8 152.36ZM281.67 153.71L281.87 153.58L281.67 153.51L281.48 153.64L281.67 153.71ZM281.61 150.37H281.54L281.61 150.49V150.37ZM281.74 155.06L281.93 154.99L281.74 154.86L281.54 154.99L281.74 155.06ZM281.67 156.21L281.54 156.15V156.34L281.67 156.21ZM281.8 166.21L282.12 165.89L281.87 165.82L281.61 166.02L281.54 166.21H281.8ZM281.8 157.99L282 157.79L281.93 157.6L281.67 157.67L281.61 157.92L281.8 157.99ZM281.8 158.82L281.61 158.76L281.74 158.95L281.8 158.82ZM281.87 161.97L282 161.84L281.74 161.78L281.61 161.97H281.87ZM282.06 160.68L281.87 160.43L281.74 160.62L282.06 160.68ZM282.51 165.18L282 165.31L281.87 165.57L282.51 165.44L282.64 165.31L282.51 165.18ZM282.12 168.46L282.51 168.26L282.57 168.01L282.38 167.88L282.12 167.94L281.87 168.26L282.12 168.46ZM282.19 161.33L282.44 161.39L282.51 161.2L282.38 161.01L281.93 161.13V161.39L282.19 161.33ZM282.32 162.74L282.57 162.68V162.42H282.12L282.06 162.61L282.32 162.74ZM282.19 164.09L282.38 164.22L282.57 163.96H282.06L282.19 164.09ZM282.32 160.68L282.44 160.49L282.12 160.68H282.32ZM282.44 166.85L282.64 166.72L282.51 166.53L282.25 166.59L282.19 166.85H282.44ZM282.44 167.62L282.96 167.3H282.44L282.32 167.49L282.44 167.62ZM282.32 170.32L282.64 170.71L282.89 170.58L283.22 170L282.44 169.93L282.32 170.32ZM282.57 169.04H282.83L282.89 168.65L282.44 168.91L282.57 169.04ZM282.77 164.8L283.02 164.73L282.89 164.47L282.64 164.6L282.57 164.8H282.77ZM282.64 166.14H282.83L283 166L282.74 165.87L282.61 166.13L282.64 166.14ZM282.89 169.29L282.77 169.68L283.22 169.74L283.6 169.29H282.89ZM282.96 165.44L282.83 165.37V165.44H282.96ZM283.34 168.33L283.6 168.01H283.15L282.83 168.33H283.34ZM283.79 171.09L283.67 171.48L283.28 171.54L283.15 171.41L283.41 170.96L283.67 170.9L283.79 171.09ZM283.28 166.85L283.54 166.79V166.53L283.22 166.79L283.28 166.85ZM283.34 167.62L283.86 167.43L283.99 167.24L283.86 167.04L283.28 167.49L283.34 167.62ZM283.28 169.04L283.54 168.97L283.86 168.65L283.28 168.78V169.04ZM283.67 170.38L283.54 170.19L283.6 170.45L283.67 170.38ZM283.79 169.68L284.05 169.61L284.37 169.29L284.18 169.23L283.73 169.42L283.79 169.68ZM284.05 170.13V170L283.86 170.13H284.05ZM284.12 171.86L283.86 171.93L283.99 171.67L284.24 171.61L284.12 171.86ZM284.44 170.86L284.76 171.25V171.51L284.31 171.44L284.18 170.99L284.24 170.74L284.44 170.86ZM284.76 169.13H284.63V169.26L284.76 169.13ZM287.91 168.42H287.58V168.68L287.2 169.32L286.81 169.39L286.75 168.94L286.3 168.81L286.17 169.32L285.98 169.45L285.79 169.32L285.66 168.81L285.34 168.94V169.26L284.76 169.64L285.08 169.77L285 170L285.19 170.13L285.32 169.93V169.61L285.45 169.42H285.64L285.77 170L285.39 170.26L285.51 170.77L285.71 170.83L285.84 170.64V170.19H286.16L286.35 169.93V169.61L286.8 169.49L286.99 170.19L286.93 170.38L286.73 170.19H286.41L286.48 170.9L286.8 170.77L286.86 171.35L287.31 171.48L287.44 170.71L287.18 170.32L287.31 170.19L287.51 170.38V170.64L287.89 170.71L287.83 170.19L287.51 169.87V169.61L287.89 169.29L287.76 168.65L288.4 168.78V169.29H288.53L288.73 168.71H288.47L288.15 168.2L287.91 168.42ZM285.34 172.34L285.01 171.76L284.95 172.21L284.82 172.08L284.76 171.64L285.27 171.44L285.53 172.44L285.34 172.34ZM285.14 168.62L285.27 168.55H285.14V168.62ZM285.85 168.04L285.79 167.91L285.91 167.78L285.85 168.04ZM286.23 171.12V170.8H286L285.87 170.99L286.06 171.51L286.32 171.38L286.23 171.12ZM286.36 171.7L286.43 172.21H286.68L286.81 172.02L286.75 171.57L286.49 171.51L286.36 171.7ZM286.62 171.31L286.56 171.06L286.49 171.31H286.62ZM288.16 170.16L288.35 170.22V169.9L288.16 169.45L287.91 169.58L287.84 169.9L287.97 170.16H288.16ZM288.29 171.7L288.35 172.08L288.61 172.21L288.87 172.15L289 172.34L289.19 172.28V172.15L288.93 172.08L288.87 171.64L289.32 171.38V171.12L289.06 171.19L288.68 171.51L288.42 171.38L288.35 171.12L288 171L288.07 171.77L288.29 171.7ZM288.8 170.7L288.74 170.44L288.48 170.38L288.55 170.83L288.8 170.7ZM289.25 168.77L289.32 168.65L289 168.71L289.25 168.77ZM289.19 170.32L289.32 170.06H289.13L289 170.25L289.19 170.32ZM289.38 168L289.51 168.26L289.83 168.32L289.7 167.81L289.38 168ZM289.77 169.42L289.83 169.22H289.58V169.48L289.77 169.42ZM289.77 171.02L289.9 170.57L289.7 170.51L289.58 170.96L289.77 171.02ZM290.22 171.54L290.47 171.6L290.41 171.28L290.22 171.09L289.96 171.54H290.22ZM290.8 170.96L290.67 170.77L290.6 170.96H290.8ZM291.63 164.79L291.7 164.6H291.5L291.44 164.79H291.63ZM292.63 161.13L292.51 161.07L292.38 161.19L292.57 161.32L292.63 161.13ZM293.41 152.33H293.21L293.47 152.52L293.41 152.33ZM293.47 154L293.41 153.81H293.21L293.47 154ZM293.53 153L293.41 152.8L293.28 153H293.53ZM293.47 154.41L293.34 154.28V154.41H293.47ZM294.11 168.35L294.05 168.09L293.86 168.22L294.11 168.35ZM294.5 164.62H294.43L294.5 164.75V164.62ZM295.4 165.97V165.84H295.27V166L295.4 165.97ZM295.85 163.27H295.72V163.47L295.85 163.27ZM296.04 161.92H296.3L296.17 161.73H295.97L296.04 161.92ZM296.42 142.07L296.36 141.88L296.23 142.07H296.42ZM296.42 137.51L296.55 137.45H296.36L296.42 137.51ZM296.49 139.44V139.38L296.42 139.44H296.49ZM296.87 160.77V160.9L296.75 160.77H296.87Z",
                fill: "#0067A5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M311.1 123.72L311.48 123.98L311.87 123.66L312.12 123.59L312.25 124.04H312.64L312.89 124.56L312.77 124.75L313.02 125.01L313.09 124.69L313.47 124.62L313.54 125.14L313.86 125.39L313.99 125.07L314.44 125.2L314.31 125.52L314.69 125.65L314.56 125.97L314.82 126.42L315.33 126.61V127.06H315.59L315.85 127.58L315.53 127.64L315.4 127.83L315.59 128.09L316.04 128.15L316.49 129.05L316.23 129.38L316.36 129.57L316.68 129.63L316.81 130.02L316.3 130.15V130.47L316.49 130.66L316.68 130.4L317.01 130.72V131.24L316.56 131.17V131.56L316.75 131.5L317.13 131.69L317.2 131.95L317.65 132.52L317.26 132.91L317.39 133.17H317.65L317.84 133.62L317.46 133.81L317.58 134L317.91 134.13V134.84L318.16 135.67L318.42 135.86L318.48 136.06L318.29 136.51L318.87 137.21H319.25L319.19 136.7L319.32 135.7L319.45 135.51L319.77 135.64V135.44L319.58 135.25L319.9 134.35L319.77 134.1L319.9 133.58L320.09 133.45L320.02 133.2L320.22 132.81L320.09 132.62L320.35 132.1L320.22 131.91L320.28 131.33L320.54 131.65L320.67 131.46L320.54 131.01L320.67 129.79L320.99 130.11L321.12 129.79L320.86 129.66V129.34L321.05 128.83L320.92 128.57L321.18 127.8L321.5 127.35L321.44 127.09L321.63 126.09H322L322.19 125.96L322.39 126.15L322.58 126.73L322.84 126.6L322.64 125.89L322.19 125.64V125.38L322.58 125.64L322.64 124.86L322.77 124.67L323.16 125.12L323.29 124.99L323.22 124.54L323.35 124.22L323.8 124.54L323.86 123.97L324.06 123.77L324.44 124.16L324.89 124.29L325.09 124.67L324.83 125.06L325.21 125.44L325 126L325.32 126.26L325.45 126.13V125.55L325.13 125.17L325.32 124.65L325.77 124.84V125.55L325.9 125.74L326.09 125.62L326.16 124.97L326.41 125.23L326.93 124.72H327.19L327.31 124.52L327.38 124.01L327.76 124.39L327.64 125.1L328.34 124.72L328.53 125.1L328.41 125.49L328.28 125.55L328.15 125.29L327.96 125.62L328.08 125.81L328.6 125.68L328.92 125.42L329.05 125.62L328.98 125.81H328.6L328.66 126.45L328.79 126.64V126.39L329.24 126.26L329.37 126.45L329.31 126.9L329.43 127.03L329.56 127.74L329.5 127.93L329.69 128.18L329.56 128.63L329.88 128.89L329.75 129.41L329.82 129.73L330.01 129.92L329.69 130.5L330.01 130.82V131.08H329.88L329.82 131.4L330.08 131.91L329.75 132.1L329.88 132.3L330.08 133.3L329.95 133.18L329.88 133.3L330.01 133.56L330.14 134.56L329.95 135.01L330.08 135.27L330.01 136.27L330.14 136.72L329.95 136.98L330.08 137.43L329.95 137.75H329.69L329.56 137.94L329.69 138.32H330L330.07 138.77L329.81 138.84L329.68 139.16L330.13 139.35L330.19 139.8L329.74 139.87L329.94 140.19L330.07 140.83L329.94 141.09L330 141.6H329.74L329.55 141.79L329.74 141.92L330 141.79L330.19 142.31L330.07 142.56L329.87 142.63L329.81 142.37L329.62 142.5L329.68 142.95L330 143.01L330.07 143.27L329.94 143.46H329.68L330 144.3H329.81L329.87 144.88L330.07 145.07V147.32L329.62 147.25L329.68 147.45L330.07 147.38L330.13 147.9L330 148.15L329.81 147.96L329.62 148.09L329.81 148.41L330 148.28V148.86L329.81 149.05L329.94 149.31V149.82L329.74 150.02L330 150.92L329.87 151.17L330 152.46L329.87 152.78L330.07 153.1L329.87 153.55L329.55 153.68L329.81 153.81L330 154.26L329.87 154.51L329.62 154.58L329.55 154.71L329.87 155.03V155.54L329.74 155.93L329.87 157.6L329.81 158.17L329.94 158.62L329.81 158.95L329.94 159.52L329.87 159.85L330 160.68L329.74 160.62L329.87 160.74L330 163.25L330.13 163.51L330.07 164.02V166.65L330.19 167.23V168.23L329.94 168.49L330.13 170.16L330.07 170.61L330.26 170.93L330.13 171.51L330.19 171.76L330 171.89L329.23 172.02L328.91 171.89L326.34 171.76L326.21 170.48L326.28 169.9L326.15 168.62V166.75L326.02 166.24L326.15 165.66L326.02 165.15L326.08 164.7L325.95 164.18L326.08 163.86L325.95 161.86L326.08 161.48L325.89 160.96L326.08 160.7L326.02 160.13L326.4 159.87L325.83 159.23L325.95 158.78L325.7 158.39V158.13L326.02 157.69L325.89 157.24L326 157V156.61L325.87 156.36L326.06 155.26L325.93 154.88L326 153.34L326.38 153.14L326 153L325.87 152.55L326 152.17L326.26 152.04L325.87 151.72L325.81 151.46L326.13 151.52L326.26 151.07L325.93 150.75L326.13 150.18L326 149.92L326.19 148.31L326.06 148.05L326.32 147.61L326.19 147.48L326.26 147.28L326.06 147.09L326.26 146.64L326.13 146.26L325.81 146L326.06 145.87L326.13 145.49L325.93 145.04L326.13 144.52L326 144.33V143.82L326.13 143.62L326 143.24L326.13 143.04L326.38 143.24L326.58 143.04L326.32 142.98L325.93 142.53L326 142.21L326.26 142.4L326.32 142.21L326.19 142.02V141.7L326.06 141.5V140.5L326.19 139.99L326.06 139.73L326.13 138.06L326 137.8L326.06 137.54L326.32 137.8L326.38 137.35L326.26 137.22L326 137.29L326.06 137.03L325.87 136.77L325.81 136.32L326 136.2L325.74 135.75L325.81 134.14L326.06 134.27L326.26 133.63L326.19 133.11H326.06L325.93 133.37L326 133.88L325.87 134.01L325.74 133.82V133.24L325.61 132.92L325.74 131.18L325.93 131.31V132.21L326.06 132.4L326.19 132.21V130.86L325.87 130.22L325.74 130.41L326 130.8L325.61 130.99L325.68 130.61L325.55 130.35L325.61 129.77L325.49 129.51L325.68 128.61L325.1 128.74L324.84 128.29L324.52 128.49L324.01 127.84L324.26 128.74L323.94 128.94L324.01 129.26L324.33 129.71H324.65L324.59 129.9L324.33 129.96L323.62 129.58L323.56 129.32L323.37 129.77L323.62 130.16V130.41L323.75 130.54L323.94 130.16H324.14L324.33 130.61L324.26 130.8L323.81 130.67L323.62 130.8L323.69 131.18H323.11V131.63L323.43 131.7L323.75 131.96V132.47L323.88 132.73L323.75 132.98L323.81 133.24L323.69 133.56L323.49 132.92H323.24L323.11 133.05L323.43 133.95L323.3 134.2L323.43 134.65L323.17 135.04L323.24 134.91L322.92 134.59L322.79 134.65V134.91L323.04 135.23L323.24 135.1L323.43 135.3L323.49 135.62L323.3 135.75L322.79 135.68L322.98 136.2L322.72 136.45L323.04 137.16L322.92 137.35L322.4 137.29L322.59 137.87L322.47 138.25L322.53 138.83L322.4 138.96L322.34 139.79L321.89 139.92L322.14 140.37L322.02 141.21L321.82 141.33H321.5L321.37 141.53L321.89 142.04V142.3L321.44 142.43L321.37 142.62L321.63 142.88L321.37 143.13L321.5 143.39V144L321.25 144.9L321.05 145.03L321.12 146.38L320.86 146.82L320.99 147.08L320.92 147.34L320.47 147.53L320.8 147.98L320.54 148.24V148.94L320.28 149.39L320.41 149.72L320.02 149.91L319.45 149.97L319.25 150.1L318.93 149.97L317.46 150.17L316.75 149.97L316.49 150.1L316.36 149.97L316.43 149.39L316.3 147.47L315.91 144.38L316 144L315.48 143.23L315.68 143.1L315.55 142.52L315.35 142.33L315.55 141.94L315.23 141.49V140.59L314.91 137.96L314.78 137.7V137.32L314.46 136.87V136.35L314.26 136.23L314.39 135.97L314.01 135.78L313.75 134.17L313.88 133.85L313.49 133.33L313.62 132.76L313.3 132.56L313.36 131.86L313.49 131.66L313.17 131.47L313.11 131.6L312.72 130.76L312.46 130.83L312.14 130.44L312.08 129.99H312.34V129.74L312.21 129.61L312.14 129.87L311.95 129.74L311.76 129.22L311.95 129.09L311.56 128.45V128L311.31 127.93L310.79 127.42L310.47 127.8L310.6 128.25L310.34 128.7L310.09 128.57L310.02 128.77L310.22 128.96L310.34 129.47L310.15 129.67L310.02 130.18L310.22 130.44L310.15 130.57L310.28 130.76L310.09 131.27L309.83 131.34L309.77 131.92H310.09L310.15 132.04L309.77 132.17V132.49L310.02 132.62L309.7 132.94L310.02 133.94L309.89 134.13V135.86L309.7 136.06L309.57 135.86L309.51 136.12L310.09 136.57L309.77 136.96L309.7 136.63L309.51 136.76L309.89 137.41V137.6L309.57 137.73L309.89 138.63L309.77 139.08L309.83 140.08L309.7 140.28L309.51 140.21L309.77 140.73L309.51 140.6L309.64 140.98L309.51 141.24L309.77 141.75V142.07L309.57 142.4L309.7 143.17L309.57 143.36L309.64 144.58L309.51 145.03L309.57 145.61L309.38 145.87L309.45 146.7L309.32 146.83L309.45 150.11L309.32 150.43L309.38 151L309.12 151.52L309.19 151.78L309 152.42L309.12 153.32L309 153.51L309.19 154.34L309.06 155.05L309.19 155.37V155.82L309 157.9L308.74 158.15L308.93 158.67L308.87 159.18L309 159.89L308.87 160.4L309 161.4L308.87 161.72L309 162.3L308.8 162.68L308.93 163.26L308.67 163.9L308.61 164.99L308.74 165.51L308.67 166.09L308.8 168.09L308.67 168.41L308.74 169.12L308.55 169.57V171.69L308.1 171.56L307.77 171.69L305.72 171.56L305.53 171.43H304.88L304.69 170.98L304.88 170.34L304.82 168.22L305.08 167.9L304.95 167.64L305.08 166.93L305 165.8L305.2 164.9L305.07 164.71L305.2 164.07L305 163.74L305.07 162.39L305.26 162.2L305 161.82L305.2 161.17L305.07 160.53L305.26 159.95L305.2 159.63L305.32 157.45L305.2 157.26L305.26 156.74L305.45 156.48L305.2 155.91L305.52 155.84L305.32 155.26L305.45 154.81L305.39 154.43L305.52 152.57L305.39 152.12L305.58 151.86L305.52 151.15L305.64 150.96L305.45 150.51L305.39 149.51L305.71 149L305.39 148.74L305.71 148.23V146.69L305.97 146.43L305.52 145.85L305.58 145.59L306.03 145.47L305.84 145.21V144.95L305.52 144.63L305.77 144.76L306.03 144.57L305.97 144.24L305.64 143.86L305.77 143.22L306.29 142.9L306.16 142.45H305.9L305.77 142.25L305.9 141.55L305.84 141.29L306.22 140.84L305.97 140.58V140.33L306.16 140.13L305.9 139.49L305.97 139.3L306.22 139.23L305.97 138.53L306.22 137.95L305.9 137.56L306.29 137.63L306 137L306.26 136.35L306.19 136.1L306.32 134.68L306.13 134.23L306.19 133.66L306.45 133.53L306.19 133.33V132.88L306.45 133.08L306.58 132.88L306.51 132.63L306.26 132.56V132.24L306.45 132.11L306.51 131.86L306.32 131.28L306.45 131.02L306.32 130.83L306.39 130.38L306.58 130.19L306.9 130.44L307.03 130.25L307 130L306.68 129.94L306.23 129.62L306.3 129.36L306.49 129.23L306.94 129.68L306.81 128.91L306.43 128.53H306.68L306.81 128.4L306.62 128.01L306.75 126.86L307.26 126.98L307.13 126.6L307.26 126.02H307.52L307.77 126.41L307.9 126.21L307.71 125.7H307.39L307.2 125.51V125.31L307.39 125.19L307.71 125.38L307.97 124.74L308.35 124.99L308.61 124.16L308.93 124.41V123.97L309.25 123.77L309.51 123.97L309.89 123.77L310.15 124.16L310.22 123.84L310.6 123.52L310.86 123.64L311.05 123.58L311.1 123.72ZM305.7 152.31L305.83 152.24H305.7V152.31ZM306.7 133.94L306.57 133.68L306.5 133.94L306.63 134.13L306.7 133.94ZM306.83 136.83L306.76 136.7V136.83H306.83ZM306.95 131.3V131.11L306.83 131.05V131.3H306.95ZM306.89 132.07H306.83L306.95 132.14L306.89 132.07ZM307.08 127.77L307.34 127.9L307.28 127.51H307L307.08 127.77ZM307.21 134.07L307.15 133.94L307.21 134.19V134.07ZM307.21 128.73L307.34 128.99L307.53 129.05L307.47 128.73L307.28 128.54L307.21 128.73ZM307.6 129.5L307.4 129.44L307.47 129.63L307.66 129.7L307.6 129.5ZM307.66 126.87L307.85 127.06V126.74H307.66V126.87ZM307.85 133.1L307.66 132.65V133.23L307.85 133.1ZM307.72 134.71L307.66 134.58V134.64L307.72 134.71ZM307.98 128.09L307.79 127.96L307.85 128.22L308.05 128.28L307.98 128.09ZM307.98 136.09V135.9H307.85V136.09H307.98ZM307.98 129.02L308.05 129.35L308.24 129.54V129.15L308.11 128.9L308.24 128.7L307.98 128.77V129.02ZM308.43 125.56L308.11 125.23L308.05 125.49L308.18 125.81L308.43 125.94V125.56ZM308.37 126.56L308.3 126.31L308.18 126.5L308.37 126.56ZM308.62 126.76L308.37 126.56V126.82L308.5 126.88L308.62 126.76ZM308.62 127.46L308.37 127.4L308.43 127.66H308.69L308.62 127.46ZM308.43 128.36L308.62 128.81L308.82 128.88L308.56 128.23H308.43V128.36ZM309.01 129.71L308.95 129.58L308.75 129.71H309.01ZM308.88 124.76L309.07 124.7L309.01 124.51H308.82L308.88 124.76ZM309.01 137.23H308.82L308.88 137.36L309.01 137.23ZM309 125.84L309.12 125.71L309.06 125.52L308.93 125.91L309.06 126.1L309 125.84ZM309.19 132.65H309V132.91L309.19 132.97V132.65ZM309.25 127.51H309.12L309.19 127.77L309.38 127.83L309.25 127.51ZM309.32 134.77L309.19 134.71V134.9L309.32 134.77ZM309.38 129.12L309.64 129.44L309.7 129.18L309.51 128.99L309.64 128.86H309.25L309.38 129.12ZM309.38 139.72L309.51 139.46L309.25 139.53L309.38 139.72ZM309.64 124.49L309.57 124.24L309.32 124.3L309.38 124.56L309.64 124.49ZM309.51 130.98L309.38 130.79V131L309.51 130.98ZM309.45 125.39L309.64 125.59V125.2L309.45 125.14V125.39ZM309.51 128.22V128.15L309.45 128.22H309.51ZM309.57 130.22V130.48L309.77 130.61L309.96 130.41L309.77 130.03H309.45L309.57 130.22ZM309.89 126.22L309.77 126.15V126.28L309.89 126.22ZM310.22 127.82L310.02 127.31L309.83 127.18L309.77 127.44L309.89 127.89L310.09 128.02L310.22 127.82ZM310.34 124.82L310.41 124.37L310.22 124.18L310.09 124.7L310.15 124.89L310.34 124.82ZM310.34 125.82H310.15L310.34 126.01V125.82ZM310.92 124.34L311.05 123.89L310.86 123.83L310.73 124.4L310.92 124.34ZM310.99 125.11L310.86 125.37L311.18 124.98L311.12 124.79L310.99 124.85V125.11ZM311.69 124.53L311.5 124.73L311.69 124.92V124.53ZM312.27 124.47L312.34 124.21L312.08 124.28L312.27 124.47ZM312.72 130.57L312.53 130.44L312.59 130.64L312.72 130.57ZM313.17 132.18L312.98 132.24L313.04 132.11L313.17 132.18ZM313.17 123.96H313.36L313.43 124.15L313.17 123.96ZM314.17 126.27L314.23 126.01L313.78 125.75V126L313.97 126.39L314.17 126.45V126.27ZM314.04 131.41V131.15L313.84 131.34L314.04 131.41ZM314.68 127.04L314.81 126.65L314.49 126.91L314.68 127.04ZM315.26 130.57V130.25H315.13L315.06 130.57H315.26ZM315.45 139.89V140L315.51 139.81L315.45 139.89ZM315.58 128.89L315.77 128.83L315.84 128.63L315.51 128.76L315.58 128.89ZM316.03 130.95V130.75L315.77 130.88L315.9 131.14L316.03 130.95ZM317.7 136.22V135.83L317.57 136.02L317.7 136.22ZM318.7 137.76L319.15 137.63V137.44L319.02 137.5L318.96 137.31L318.64 137.37L318.44 137.56L318.7 137.76ZM319.34 137.5V137.37L319.28 137.5H319.34ZM319.73 136.22V136.15L319.67 136.22H319.73ZM320.56 135.89L320.44 135.83L320.31 136.02L320.44 136.15L320.56 135.89ZM320.37 142.38V142.57L320.44 142.38H320.37ZM320.76 132.62L320.82 132.3L320.56 132.36L320.76 132.62ZM320.63 146.56V146.75L320.82 146.62L320.63 146.56ZM320.95 133.32L320.76 133.26V133.52L320.95 133.65V133.32ZM321.53 132.04V131.78L321.08 131.4L321.01 131.59L321.34 132.23L321.53 132.04ZM321.14 135.77L321.21 135.51H321.01V135.7L321.14 135.77ZM321.21 144.18L321.27 143.99L321.14 143.86L321.08 144.18H321.21ZM321.4 137.44L321.27 137.31L321.21 137.5L321.34 137.63L321.4 137.44ZM321.27 139.23V139.49L321.46 139.68L321.53 139.36L321.27 139.23ZM321.72 128.23L321.46 128.17L321.66 128.56L321.72 128.23ZM321.85 129.39L321.46 129.07L321.79 129.65L321.85 129.39ZM321.59 132.99H321.46L321.59 133.25V132.99ZM321.72 133.82H321.53L321.59 134.02L321.72 133.82ZM321.59 134.66V134.59L321.53 134.66H321.59ZM321.85 134.98L321.79 134.79H321.53L321.72 135.17L321.85 134.98ZM321.91 136.07L321.59 135.69L321.72 136.27L321.91 136.07ZM321.91 130.29L321.66 130.36L321.72 130.61L321.91 130.74V130.29ZM321.66 136.84L321.91 136.91L321.66 136.59V136.84ZM321.85 126.76L322.17 127.21L322.3 126.76L321.91 126.56L321.85 126.76ZM321.91 133.37L322.11 133.82L322.3 133.95L322.43 133.82L322.23 133.5L322.3 133.31L321.98 132.99L321.85 133.12L321.91 133.37ZM321.91 138.06L322.04 138.26L322.17 138.06L322.11 137.81H321.85L321.91 138.06ZM321.98 137.23V137.16L321.91 137.23H321.98ZM322.17 132.6V132.35H322L321.94 132.6L322.07 132.73L322.17 132.6ZM322.36 127.91L322.04 127.53L322.11 128.04L322.3 128.17L322.36 127.91ZM322.11 128.56H322.3L322.23 128.36H322L322.11 128.56ZM322.3 134.72L322.49 134.4L322.23 133.95L322.04 134.21L322.3 134.72ZM322.23 139.16L322.3 138.9L322.04 138.83V139.28L322.23 139.41V139.16ZM322.17 135.04L322.36 135.37V135.3L322.43 135.11L322.17 135.04ZM322.36 136.52L322.56 136.71L322.68 136.46L322.56 136.27H322.17L322.36 136.52ZM322.43 129.26V128.94L322.23 128.81L322.3 129.13L322.43 129.26ZM322.62 129.84L322.23 129.52V129.78L322.49 130.1L322.62 129.84ZM322.36 135.69L322.56 135.82L322.43 135.43L322.36 135.69ZM322.56 131.83L322.62 132.09L322.81 132.15V131.64H322.49L322.56 131.83ZM322.68 131.13L322.75 131H322.56L322.68 131.13ZM323.01 127.53L322.88 127.27L322.62 127.14L322.68 127.59L322.81 127.72L323.01 127.53ZM322.88 128.68L323.13 128.56L322.81 127.85L322.62 127.91L322.81 128.62L322.88 128.68ZM322.81 129.26L322.88 129.52L323.13 129.78L323.2 129.46L323.01 129.01L322.68 129.07L322.81 129.26ZM322.68 133.76L323.01 134.21L323.13 133.89L322.68 133.5V133.76ZM323.07 125.47L323.01 125.67L323.26 126.12L323.97 126.44L324.16 126.76L324.23 126.5L324.03 125.99L323.84 125.92L323.52 126.05L323.26 125.47H323.07ZM323.2 130.47L323.01 130.28V130.6L323.26 130.73L323.2 130.47ZM323.46 126.55L323.26 126.43L323.13 126.62L323.26 126.94L323.52 127.07L323.58 126.75L323.46 126.55ZM323.33 132.55L323.46 132.49L323.33 132.23L323.2 132.36L323.33 132.55ZM323.71 127.93L323.65 127.67L323.46 127.61L323.39 127.8L323.65 128.12L323.71 127.93ZM323.65 129.15L323.78 128.89L323.58 128.38L323.39 128.51L323.65 129.15ZM324.03 125.62L324.1 125.36L323.84 124.97L323.9 124.72L323.71 124.78L323.65 124.97L323.97 125.62H324.03ZM323.97 127.29L324.29 127.67L324.23 127.09L324.03 126.9L323.84 127.09L323.97 127.29ZM324.16 131.65H323.84L323.97 131.46L324.16 131.53V131.65ZM324.87 126.32L324.8 125.81L324.61 125.42L324.74 125.04L324.48 124.59V124.33H324.35L324.16 124.65L324.48 124.97L324.23 125.62L324.55 126.07L324.48 126.58L324.74 127.03L324.93 127.09L324.87 126.58V126.32ZM324.48 128.89L324.61 128.63L325 128.96L324.93 129.15L324.48 129.08V128.89ZM324.8 127.74L325.06 127.86L324.8 127.41L324.61 127.61L324.8 127.74ZM325.9 123.82H326L326.32 124.2L326.51 124.14L326.58 123.69L326.9 123.82L327.03 124.01L326.71 124.46L326.51 124.39L326.13 124.78H325.87L325.68 124.14L325.36 124.52L325.04 124.14L324.97 123.88L325.16 123.69L325.49 123.75L325.68 124.01L325.9 123.82ZM325.64 126.9V126.58L325.45 126.45L325.32 126.84L325.45 127.03L325.64 126.9ZM325.9 129.73H326L325.81 129.6L325.9 129.73ZM326.15 123.43L326.22 123.62L326.09 123.75L325.96 123.62L326.02 123.43H326.15ZM326.22 126.64L326.28 126L326.09 125.81L325.96 126.58L326.22 126.64ZM326.22 132.81V132.49L326.02 132.55V132.81H326.22ZM326.28 135.64V135.38L326.09 135.57L326.15 135.83L326.28 135.64ZM326.22 158.12L326.09 157.93V158.18L326.22 158.12ZM326.41 127.22L326.28 127.03L326.15 127.29L326.41 127.48V127.22ZM326.41 149.45L326.6 149.32L326.35 149.38L326.41 149.45ZM326.54 138.53H326.41L326.47 138.78L326.54 138.53ZM326.6 139.53L326.41 139.4V139.66L326.6 139.85V139.53ZM326.54 144.41L326.73 144.48V144.16L326.6 143.96L326.41 144.09L326.54 144.41ZM326.6 128.87H326.47L326.54 129.12L326.6 128.87ZM326.6 125.78L326.54 126.04L326.73 126.17L326.99 125.72L326.67 125.46L326.6 125.78ZM326.6 143.51L326.54 143.39V143.51H326.6ZM326.8 131.05L326.73 130.73L326.6 130.99L326.67 131.18L326.8 131.05ZM326.8 156.36L326.6 156.17V156.43L326.8 156.36ZM326.86 132.21V131.82L326.67 132.08L326.86 132.21ZM326.8 140.75L326.67 140.56V140.88L326.86 141.01L326.8 140.75ZM326.8 134.26L326.99 134.14L326.86 134.01L326.73 134.2L326.8 134.26ZM326.86 141.78L326.99 141.91L326.92 141.52L326.73 141.59L326.86 141.78ZM326.86 145.06L326.73 145.12L326.86 145.25V145.06ZM327.05 146.21L326.99 146.02L326.73 145.96L326.8 146.28L327.05 146.41V146.21ZM326.86 150.84V150.64L326.73 150.84H326.86ZM326.92 132.91L326.8 132.85V132.91H326.92ZM326.99 134.97L326.8 135.03L326.92 135.29L326.99 134.97ZM327.25 142.81L327.31 142.55L327.05 142.49L326.92 142.61L327.12 143L327.25 142.81ZM327.12 138.31L327.18 137.93H327L326.94 138.25L327.12 138.31ZM327.12 139.4H327.25L327.18 139.15L327.05 139.34L327.12 139.4ZM327.12 125.59L327.37 125.66L327.5 125.4L327.31 124.88L327.25 125.21L327.12 125.59ZM327.37 128.59L327.12 128.46V128.65L327.31 128.78L327.37 128.59ZM327.18 143.88L327.37 143.82L327.18 143.62V143.88ZM327.31 140.41L327.5 140.35L327.37 140.15L327.25 140.35L327.31 140.41ZM327.5 131.61L327.44 131.35L327.37 131.61H327.5ZM327.37 135.53L327.44 135.72L327.63 135.79L327.5 135.4L327.37 135.53ZM327.57 141.12L327.37 141.05L327.44 141.25L327.57 141.12ZM327.63 133.6V133.41L327.44 133.54L327.57 133.79L327.63 133.6ZM327.7 136.68L327.63 136.43L327.5 136.62L327.63 136.75L327.7 136.68ZM327.7 145.61H327.5L327.57 145.81L327.7 145.61ZM327.57 138.61V138.87L328.02 138.74L328.08 138.48L327.63 138.42L327.57 138.61ZM327.82 137.71H327.7L327.76 137.84L327.82 137.71ZM327.95 140.15L327.76 140.09V140.15H327.95ZM327.95 139.58L328.08 139.45L327.82 139.51L327.95 139.58ZM328.02 129.17L327.89 128.91L327.95 129.17H328.02ZM328.08 144.17L327.95 143.91L327.89 144.17L328.08 144.43V144.17ZM328.14 127.02H327.95L328.02 127.21L328.14 127.02ZM328.08 129.85H327.95L328.08 130.04V129.85ZM328.14 130.85H327.95L328.02 131.17L328.27 131.05L328.14 130.85ZM328.21 145.05L327.95 144.99L328.14 145.24L328.21 145.05ZM328.27 124.11V124.36L328.14 124.49L328.02 124.04L328.27 124.11ZM328.4 141.71V141.45L328.14 141.52L328.08 141.77L328.27 141.9L328.4 141.71ZM328.4 145.95L328.14 146.01L328.27 146.21L328.4 145.95ZM328.4 153.79V153.59L328.21 153.72L328.4 153.79ZM328.27 138.24L328.47 138.3L328.59 138.05L328.47 137.86L328.27 137.92V138.24ZM328.4 147.3V147L328.27 147.06V147.32L328.4 147.3ZM328.59 138.75H328.34L328.53 139.01L328.59 138.75ZM328.53 142.75L328.59 142.49L328.4 142.55V142.75H328.53ZM328.59 128.49H328.47L328.53 128.68L328.59 128.49ZM328.72 129.39V129.26H328.59V129.39H328.72ZM328.72 140.18L328.79 139.92L328.59 139.99V140.18H328.72ZM328.72 143.78V143.58L328.59 143.52V143.71L328.72 143.78ZM328.85 131.63V131.51L328.66 131.63H328.85ZM328.98 141.01L328.79 140.95L328.72 141.08L328.92 141.21L328.98 141.01ZM329.17 127.07L328.98 126.82L328.92 127.07L329.04 127.27L329.17 127.07ZM329 146.78L329.07 146.59H328.88L329 146.78ZM329.13 142.29L329.07 142.09L328.94 142.22L329.13 142.29ZM329 138.56L329.13 138.75L329.65 138.69L329.13 138.37L329 138.56ZM329.07 143.12L329.26 143.38L329.39 143.19L329.26 142.93L329 142.87L329.07 143.12ZM329.33 149.68V149.48L329.13 149.55L329.33 149.68ZM329.33 150.9L329.71 150.64H329.13L329.26 150.77L329.33 150.9ZM329.45 139.65L329.33 139.4L329.2 139.59L329.26 139.85L329.45 139.65ZM329.39 131.17V130.85H329.26V131.17H329.39ZM329.33 132.39L329.52 132.33V132L329.39 131.8V132.32L329.33 132.39ZM329.58 133.29L329.45 132.78L329.33 133.49L329.58 133.29ZM329.52 140.68V140.49L329.33 140.36L329.45 140.87L329.52 140.68ZM329.58 135.03L329.45 134.84L329.39 135.09L329.52 135.29L329.58 135.03ZM329.9 136.19L329.65 135.8L329.45 135.99L329.52 136.25L329.71 136.38L329.9 136.19ZM329.58 145.31H329.45L329.58 145.44V145.31ZM329.77 137.02L329.84 136.83H329.58L329.52 137.08L329.71 137.28L329.77 137.02ZM329.71 146.34H329.58L329.71 146.46V146.34Z",
                fill: "#0067A5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M367.3 152.44L367.24 152.63L367.95 152.89L367.75 153.21L368.33 153.59L368.2 153.79H367.2L367.71 154.24L368.29 153.98L368.87 154.3L369.45 154.24L369.58 154.43L369.38 154.56L369 154.36L368.42 154.69L367.97 154.36L367.71 154.56L368.29 155.07L368.1 155.26L367.39 155.07L367.58 154.81L367.52 154.56L367.01 154.36L366.81 154.56L367.14 154.69L367.26 155.07L367.07 155.33V155.59L367.39 155.39L367.58 155.46L367.78 156.16L368.23 156.42V156.68L367.78 156.74L367.52 156.42L367.58 156.23L367.46 156.03L367.01 155.84L366.75 155.91L366.81 156.29L367.14 156.23L367.26 156.42L367.14 156.87L366.62 156.61V157.06L366.94 157.13L366.75 157.58L366.88 157.9H366.36V158.35L366.04 158.28L365.85 158.54L365.92 158.22L365.59 157.83L365.34 157.9L365.21 158.09L365.53 158.22L365.66 158.48L365.59 158.73H365.34L365.02 158.48L365.14 158.22L364.5 157.83L364.25 157.96L364.37 158.22L364.63 158.09L364.76 158.28L364.63 158.67L364.25 158.73V158.93L365.08 158.86L365.27 159.12L365.14 159.31L364.31 159.05L364.18 159.44L363.79 159.18H363.6L363.67 158.86L363.54 158.67H363.22L362.77 157.96L362.64 158.22L362.7 158.48L363.15 158.8L363.22 159.18L363.47 159.31L363.73 160.15L363.35 159.95L363.02 160.34L362.7 160.4L362.51 160.08L361.8 160.4L361.61 160.21V160L361.16 159.81L361.03 159.55L361.1 159.36L360.9 159.17L360.71 159.3L360.65 159.75L360.78 159.94L361.1 160L361.16 160.45L361.48 160.9L361.35 161.03L361.03 160.58L360.65 160.33H360.33L360.46 159.94L360.2 159.81L360.07 160.45H359.68L359.62 159.94H359.3L359.43 160.2L359.23 160.26L359.56 160.52L359.49 160.84L359.3 160.97L359.04 160.52L358.72 160.45L358.59 160L358.27 159.81L358.08 160L358.21 160.2V160.52L358.72 160.77L358.53 160.97L358.46 160.77L357.82 160.58L357.56 160.97L357.18 160.84L357.11 160.58L356.6 160.39V159.88L356.41 159.75L356.09 160.13L356.21 160.45H356.54L356.6 160.97L356.47 161.16L356.28 161.1V160.84L355.83 160.26V160.52L355.51 161.03L355.64 161.61L355.32 161.22L355.06 161.8H355.44L355.57 161.99L355.51 162.19L355.19 162.44L355.25 162.57H355.51L355.7 162.89L355.57 163.15L355.77 164.15L355.44 164.02L354.67 164.47L354.8 164.6L355.51 164.47L355.7 164.92L355.51 165.11L354.93 164.86L354.74 164.98L355.25 165.37L355.57 165.24L355.77 165.37L355.83 165.63L355.44 165.56L354.93 165.82H354.61L354.8 166.01L355.25 165.82L355.77 166.08L355.64 166.4L356.02 166.72L355.7 166.98L355.38 166.85L355.19 167.1L355.51 167.17L355.89 167.49L355.64 167.81L356.02 168.13L355.51 168.45L355.83 168.84L355.64 169.1L354.87 168.77L354.54 169.03H354.16L354.29 169.29L354.74 169.1L355.51 169.29L355.7 169.16L355.89 169.35L355.83 169.61L355.44 169.55L355.32 169.74L355.77 170.19L355.44 170.64H355.77L355.83 170.96L355.44 170.89L354.99 171.15H354.67L354.35 170.96V171.09L354.8 171.41L355.57 171.28L355.7 171.54L355.12 171.6L354.29 171.47L354.03 171.6L353.58 171.47L352.75 171.6L352.49 171.47L351.98 171.54L352.1 171.22L351.72 170.77L351.85 170.57L352.55 170.51L352.1 170.12L352.17 169.74L351.65 169.42L351.72 169.22L351.98 169.1L352.36 169.29L352.49 169.16L352.04 168.84L351.98 168.58L352.55 168.32L352.36 168.2L352.1 168.26L351.65 168L351.85 167.88L352.36 168L352.55 167.88L352.04 167.49L352.1 167.17L351.65 166.78V166.59L351.91 166.46L352.23 166.59L352.49 166.46L352.36 166.27L352.1 166.2L352 166L352.06 165.74L351.74 165.42V165.17L352.06 165.04L352.25 165.36L353.09 164.91L352.96 164.78L352.12 164.91L352 164.65L352.12 164.4L352.64 164.33L352.89 164.52L353.22 164.46L353.41 164.27L353.28 164.14L352.51 164.08L352.38 163.88L352.96 163.63L352.83 163.43L352.57 163.56L352.06 163.37L352.12 162.79L351.8 162.85L351.74 162.6L352.06 162.28L352.25 162.47V162.73L352.44 162.98L352.57 162.79V162.4L352.12 162.08L352.19 161.63H352.38L352.57 160.99L352.77 161.06L352.96 160.86L352.83 160.67L352.57 160.93L352.19 160.99L352.12 161.44L351.87 161.51L351.8 161.25L352.12 160.86L351.87 160.54L352.51 160.22L352.83 160.48L353.15 160.29L353.34 160.35L353.47 160.16L353.34 160.03L353.02 160.22L352.64 160.16L352.44 159.9L352 160.09L351.8 159.96L351.74 159.71L352 159.64L352.44 159.84L353.15 159.58L352.83 159.26L352.19 159.45L352 159.06L352.57 158.81L352.44 158.55L352.89 158.23H353.15L352.77 157.91L352.25 158.16L352.12 157.97L352.44 157.65L352.7 157.78L353.34 157.52L353.41 157.33L352.7 157.52L352.44 157.07L352.89 156.88L353.09 157.07L353.54 157.01L353.22 156.94L353.02 156.69L352.7 156.62L352.38 156.82L352 156.49L352.12 156.3L352.89 156.37L353.47 156.24L353.73 156.43L354.5 156.17L354.76 156.43L355.27 156.3L355.46 156.43L355.59 156.94L355.79 157.07L356.11 156.82L356.23 156.94V157.46L356.43 157.65L356.62 157.33L356.56 157.07L356.75 156.94L356.94 157.07L357.13 157.65H357.58L357.65 158.29L358.1 158.23L357.84 158.04L357.97 157.91L357.9 157.72L357.65 157.59V157.27L357.78 157.07L358.03 157.01L358.16 157.46L358.29 157.52L358.42 157.33L358.55 157.46L358.93 157.07L359.19 157.72L359.45 157.78L359.77 157.2H360L360.33 157.59L360.58 157.46L360.39 157.01L360.52 156.82L360.65 156.94V157.2H361.03L361.29 157.91L361.48 157.84L361.55 157.39L361.16 157.07L361.29 156.62L361.48 156.69L361.87 157.27L362.19 157.14L362.32 157.97H362.64L362.7 157.72L362.57 157.2L362.25 157.14L362.19 156.75L362.38 156.56L362.57 156.69L362.64 157.2L362.9 157.27L363.41 158.1L363.67 158.23L363.6 157.46L363.22 157.27V156.88L363.67 156.75L363.73 157.33L363.92 157.52L364.44 157.72L364.69 157.59L364.5 157.07L364.31 157.27L363.99 157.07L364.18 156.75L363.79 156.49V156.3H364.18V156.56L364.37 156.75L364.69 156.82V156.11L364.5 155.72L364.57 155.53L365.08 155.6L364.82 155.66L364.89 156.11L365.34 156.17L365.14 155.53L365.21 155.27H365.59L365.79 155.6L366.04 155.34L365.59 154.95L365.34 155.02L365.59 154.7L365.53 154.25L366.24 153.99H366.56L366.69 154.12L367.07 153.99L366.36 153.54L366.49 153.41L366.94 153.35L367.39 153.54L367.58 153.41L366.88 152.9L366.94 152.7L366.69 152.58L366.56 152.32L366.62 152.13L367.39 152.25L367.3 152.44ZM351.76 158.93V159.05L351.69 158.93H351.76ZM352.02 151.8L351.89 151.86L351.76 151.73L351.89 151.54L352.14 151.6L352.02 151.8ZM351.89 153.14L351.76 153.02L351.89 152.89L352.08 152.95L351.89 153.14ZM351.89 157.32L351.76 157.26L351.89 157L352.14 157.13L351.89 157.32ZM352.08 158.6L351.89 158.73L351.76 158.54L351.89 158.22L352.08 158.35V158.6ZM352.02 164.13L351.76 164L351.82 163.74L352.02 163.62L352.21 163.74V164L352.02 164.13ZM356.02 125.39L355.89 126.39L355.76 126.58L355.89 127.86V131.2L356.02 132.04V133.39L355.89 134.29L355.95 134.61L355.63 134.87L356.08 135.57L356.4 135.64L356.92 135.44L357.3 135.7L357.56 135.51L358.2 135.32L358.33 135.38L358.84 135.25L359.42 135.57L359.55 135.44V135.19L360 135V135.32L360.65 135H361L361.13 135.32H361.38L361.77 135.06H362L362.32 135.38L362.9 135.13L363.16 135.19L363.54 135.77L363.8 135.38L363.99 135.51V135.77H363.61L363.54 135.96L363.86 136.35L364 136L364.9 136.32L365.42 136.13V136.58L365.03 136.77L365.48 137.03L365.67 136.84H366L366.77 137.22V137.48L367.41 137.93L367.09 138.12V138.38L366.64 138.76L366.83 138.89H367.83L368.47 139.21L368.21 139.34L367.76 139.21L367.31 139.28L367.19 139.47L367.25 139.6L367.51 139.66L367.76 139.41L368.15 139.73V140.18L368.66 140.5L368.6 140.76L368.21 141.01L368.34 141.14H368.92L369.05 141.33L368.66 141.78L368.53 142.23H368.09L368.15 141.85L368.41 141.78V141.4L367.63 141.72L367.76 141.98L367.63 142.43L368.09 142.3L368.02 142.55L368.34 142.62L369.05 142.23L368.86 141.91H369.56L369.63 142.1L369.18 142.49L369.24 142.81L368.92 143.07L368.41 142.75L368.09 142.81L367.63 143.13L367.89 143.33L367.7 143.58L367.89 143.71L368.15 143.58V143.33L368.47 143.13L368.79 143.33L368.98 143.2H369.56L369.69 143.39V143.71L369.31 143.84L369.37 144.1L368.66 144.55L368.79 144.8L368.66 145L367.66 144.87L367.22 145.06L367.34 145.25L367.73 145.06L368.5 145.38L368.82 145.19L369.46 145.45L369.72 145.32H370.17L370.3 145.64L369.79 145.7L369.59 145.57L369.27 145.64L369.08 145.83L368.69 145.96L368.89 146.09L369.53 145.9L369.85 146.15L369.53 146.41L369.08 146.28L368.69 146.35L368.56 146.54L367.92 146.02L368.37 145.83L368.5 145.64L368.44 145.51L367.79 145.77L367.66 146.28L367.73 146.47H368L368.38 146.73L369.02 146.47L369.35 146.79L370.12 146.67V147L369.35 146.94L368.9 147.07L368.25 146.87L368 147.07L367.42 146.68L367.16 147.07L366.9 147L366.52 146.62L366.97 146.42L367.1 146.23L366.97 145.97L367.1 145.78L367.35 145.85L367.55 145.65L367.35 145.4L367.1 145.65L366.71 145.59L366.45 145.2L367.03 144.82L366.84 144.69L366.45 144.88L366.2 144.82V144.56L366.39 144.3L366.58 144.43L367.8 144.62L368.25 144.56L368.64 144.24L368.51 144.11L368.13 144.37L367.61 143.98L367.03 144.3L366.39 143.92L366 144V143.81L366.26 143.75L366 143.36L366.06 143.17L366.45 142.85L366.32 142.65L365.61 142.72L365.55 142.52L365.87 142.33V142L365.74 141.81L365.94 141.62L365.87 141.42L365.61 141.55L365.42 141.94L365.16 142V141.74L365.42 141.49L365.29 141.29L364.91 141.1L365.04 140.97L365.74 140.91L365.81 140.72L365.68 140.52L365.49 140.65L365.04 140.59L364.84 140.39L364.46 140.59L364.07 140.52L363.88 139.75L363.56 139.69L363.37 139.5L362.72 139.56L362.53 139.37L362.59 139.11L362.34 139.05L361.57 139.17L360.99 138.85V138.6L360.8 138.4L360.54 138.47L360.41 138.92L359.96 138.72L359.83 138.4L359.64 138.27L359.45 138.4L359.38 138.92L358.93 138.79L358.87 138.21H358.61L358.74 138.6L358.1 138.85L357.65 138.21L357.46 138.4V138.85L357.07 138.92L357.13 139.24L356.62 139.43L356.04 138.98L355.98 139.5L355.46 139.69L355.85 139.95L355.4 140.2L355.27 140.39L355.53 140.33L355.72 140.46L355.91 140.84L355.46 141.1L355.72 141.42L355.66 141.62L355.85 142.06L355.66 142.45L355.79 142.71L355.66 142.96L355.79 143.48L355.66 143.74L355.27 143.48L355.08 143.61L355.21 143.8L355.66 143.99L355.14 144.63H355.72L355.91 145.08L355.72 145.21L355.53 145.66L355.98 146.31L355.91 146.5L355.66 146.56L355.27 146.31L355.08 146.5L355.66 146.88L355.53 147.14L355.79 147.46V147.72L355.53 148.04L355.72 148.23L355.53 148.55L355.79 149V149.26L355.46 149.07L354.69 149.2L354.5 149.32L355.66 149.71L355.46 150.03L355.21 150.1L354.82 149.97L355.14 150.35L355.53 150.22L355.72 150.42L355.53 150.87L355.59 151.25L355.34 151.44L355.27 151.64L355.59 151.57L355.72 151.7L355.66 151.89H355.4L355.34 152.09L355.53 152.47L355.34 152.6L354.95 152.41L354.5 152.6L353.99 152.54V152.73L354.24 152.86L354.56 152.79L355.34 153.05L355.53 152.92L355.72 153.11L355.66 153.37L355.4 153.24L354.89 153.44L354.56 154.08L353.67 153.82L353.47 153.95L352.77 153.76L352.32 153.95L352.12 153.76L352.19 153.44L352.7 153.56L353.47 153.31L353.34 153.05L352.96 153.18L352.32 152.99L352.44 152.79L353.28 152.86L353.47 152.6L352.57 152.41L352.32 152.47L352.12 152.21H352.89L353.47 151.83L353.15 151.7L352.96 151.83L352.25 151.77L352.57 151.44L353.02 151.38L353.41 151.51L353.34 151.32L353.15 151.38L352.89 151.06L352.25 151.32L352 151L352.19 150.81L352.71 150.88L353.16 150.68L353.86 150.81L354.51 150.68L354.38 150.43L353.67 150.68L353.41 150.43L352.9 150.62L352.51 150.3L352.84 150.04L353.29 150.23L353.35 150.11L352.9 149.72L352.45 149.91L352.26 149.85L352.19 149.53H352.77L352.96 149.4L352.64 149.27L352.51 148.95L352 149L351.94 148.81L352.19 148.87L352.64 148.62L353.29 148.81L353.61 148.62L354.18 148.81L354.44 148.68L353.8 148.3L353.29 148.55L352.96 148.3L352.26 148.49L352.07 148.04H352.9L353.09 147.91L352.77 147.85L352.45 147.33L353 147L352.87 146.87L352.17 147L351.98 146.55L352.55 146.42L352.81 146.68L353.39 146.36L353.26 146.23L352.75 146.42L352 146L352.44 145.87H353.15L353.02 145.68L352.57 145.49L352.19 145.61L352 145.49L352.38 145.1L352.25 144.84L352.77 144.65L353.28 144.71L352.83 144.33L352.12 144.46L352 144.2L352.06 143.88L352.44 143.75L352.25 143.49L351.8 143.43L352.06 142.98L351.93 142.53L352.38 142.27V141.82L352 141.5L352.06 141.25L352.7 141.12L352 140.6L352.38 140.41L352.06 140.15L352 139.83L352.25 139.7L352.7 139.83L352.89 139.77L352.32 139.45H352.06L351.93 139.32L352.44 139.19L352.89 138.87L352.51 138.74L352.19 139H352L352.13 138.35V137L352.45 136.81L352 136.55L352.07 135.72L352.19 135.52L352.45 135.46L352.07 134.46L352.39 134.14L352.19 133.82L352.77 133.5L353.35 133.56L352.77 133.24L352.39 133.37V133L352.9 132.87L352.58 132.74L352.45 132.48L352.51 132.23L352.71 132.1L353.16 132.29L353.41 132.16L353.29 131.97L352.77 131.84L352.39 131.97L352.32 131.71L352.64 131.46L352.39 131.07L352.45 130.88L352.84 130.56L352.77 130.43H352.39L352.45 129.43L352.77 129.24H352.39V128.85L352.64 128.92L352.58 128.66L352.39 128.53L352.32 127.63L352.45 127.37L352.32 126.67L352.39 126.22L352.71 126.09L352.39 125.7L352.71 125.06L354.71 124.87L354.91 125L355.23 124.93L356 125.13L356.02 125.39ZM351.84 150.39V150.2H352L352.07 150.39H351.84ZM352.04 144.67L352.1 144.87H351.91V144.67H352.04ZM352.04 147.5L351.91 147.63V147.5H352.04ZM352.16 154.37L351.91 154.57V154.25L352.16 154.37ZM353.71 154.18L353.96 154.12L354.41 154.31L354.67 154.18L355.25 154.37L355.57 154.31L355.7 154.44L355.57 154.57H355.31L354.99 154.82L354.8 154.76L354.67 154.89L354.8 155.02L355.25 154.89L355.7 155.15L355.57 155.6L354.73 155.27L354.35 155.47L353.9 155.21L353.51 155.53H353.26L353.38 155.72L354.67 155.6L355.18 155.92L355.05 156.11H354.6L354.41 155.85L354.09 156.11H353.64L353.45 155.92L352.93 156.11L352.61 155.92V155.72L352.87 155.34L352.42 155.47L352.23 155.4V154.89L352.74 155.02L353.06 154.82L352.23 154.37L352.87 154.12L353.38 154.31L353.71 154.18ZM352.55 167.09L353.06 167.29L353.19 167.16L352.48 166.84L352.29 167.03L352.55 167.09ZM352.36 169.66L352.87 169.98L353.13 169.92L353.06 169.73L352.36 169.54V169.66ZM352.48 135.55L352.61 135.75L352.81 135.55H352.48ZM352.74 140.31L352.93 140.18L352.74 140.05L352.55 140.24L352.74 140.31ZM352.61 145.31H352.87V145.11H352.55L352.61 145.31ZM352.87 134.77L352.74 134.64L352.61 134.77H352.87ZM352.81 159.05L353 158.93H352.61L352.81 159.05ZM352.81 136.89H352.68L352.74 137.02L352.81 136.89ZM352.81 142.48L352.74 142.35L352.68 142.48H352.81ZM352.81 142.67H352.68V142.93L352.93 142.99L352.81 142.67ZM352.74 162.33L353 162.14H352.74V162.33ZM352.74 165.8L352.87 165.93L353.13 165.86L352.81 165.61L352.74 165.8ZM352.93 136.06L352.81 135.99V136.12L352.93 136.06ZM352.93 143.83L353 143.7L352.81 143.77L352.93 143.83ZM353 171.2L352.75 171.13V171.26L353 171.2ZM353 166.25L353.13 166.06L352.81 166.25H353ZM353.2 167.73L353.07 167.53L352.87 167.66L353.2 167.73ZM352.94 168.56L353.13 168.5L353.2 168.3L352.87 168.37L352.94 168.56ZM353.26 169.33L353.52 169.27L353.77 169.01H353.32L353.07 168.82L352.87 168.95L353.26 169.33ZM353.07 158.93L353.39 158.8L353.26 158.67L353 158.73L353.07 158.93ZM353.2 141L353.13 140.81L353.07 141H353.2ZM353.39 154.81L353.32 154.49L353.13 154.56L353.07 154.75L353.39 154.81ZM353.13 145.18L353.32 144.99H353.13V145.18ZM353.32 147.88L353.45 147.68L353.26 147.56L353.13 147.81L353.32 147.88ZM353.13 149.35L353.32 149.48H353.84L354.22 149.29L353.9 149.35L353.26 149.1L353.13 149.35ZM353.39 143.77L353.65 143.83L353.26 143.51L353.2 143.64L353.39 143.77ZM353.52 163.68L353.26 163.62L353.2 163.74L353.39 163.87L353.52 163.68ZM353.26 161.56H353.52L353.39 161.37H353.26V161.56ZM353.45 166.44L353.26 166.31L353.32 166.44H353.45ZM353.39 170.62L353.52 170.49L353.26 170.55L353.39 170.62ZM353.32 169.62L353.52 169.88L353.84 170.01L353.97 169.82L353.65 169.75L353.32 169.62ZM353.52 170.97L353.39 170.91L353.32 171.1L353.52 170.97ZM353.77 165.13L353.9 164.87L353.58 164.93L353.45 165.13H353.77ZM353.77 149.84L353.58 149.77V150.03L353.77 149.84ZM353.97 151.12H353.77L353.58 151.32L353.65 151.44H354.29L354.03 151.32L353.97 151.12ZM353.84 152.21L353.9 152.02H353.65L353.58 152.21H353.84ZM353.65 153.56H354L354.45 153.24L354.25 153.11L353.61 153.37L353.65 153.56ZM353.84 155.04L353.9 154.85H353.65L353.84 155.04ZM353.9 164.1L353.65 164.36L353.84 164.55L354.48 164.29V164.04L354.16 164.16L353.9 164.1ZM353.84 166.35L354.09 166.28L353.84 166.15L353.65 166.28L353.84 166.35ZM354.03 161.66L353.84 161.53L353.71 161.66L353.84 161.85L354.03 161.66ZM353.97 165.83V165.7L353.71 165.77L353.97 165.83ZM353.97 167.12L353.71 167.05V167.31L353.97 167.12ZM353.9 147.12L353.77 147.05L353.84 147.24L353.9 147.12ZM354.09 163.05L354.35 162.85L353.77 162.92L353.84 163.18L354.09 163.05ZM354.09 163.56L353.84 163.43L353.77 163.63L353.97 163.75L354.09 163.56ZM354 169L353.93 168.87L353.87 169H354ZM354.06 170.41L353.93 170.29V170.41H354.06ZM354.32 144.65L354.45 144.4H354L354.12 144.53L354.32 144.65ZM354.06 167.65V167.59L354 167.65H354.06ZM354.25 147.93L354.38 147.74L354.19 147.67L354.06 147.87L354.25 147.93ZM354.38 154.87L354.45 154.74L354.25 154.61L354.12 154.87H354.38ZM354.38 166.37L354.12 166.3L354.32 166.56L354.51 166.43L354.38 166.37ZM354.45 152.11L354.83 152.3L354.96 152.11L354.77 151.98L354.45 152.04L354.32 151.85L354.19 152.04L354.45 152.11ZM354.51 157.05L354.38 156.92L354.25 157.05H354.51ZM354.38 161.29L354.51 161.23L354.45 161.04L354.25 161.1L354.38 161.29ZM354.51 162.38L354.38 162.26L354.25 162.45L354.51 162.38ZM354.45 160.27L354.38 160.07L354.32 160.27H354.45ZM354.51 161.55L354.32 161.49V161.68L354.51 161.55ZM354.64 163.8L354.51 163.67L354.38 163.8H354.64ZM354.57 167.07V166.88L354.38 167.01L354.57 167.07ZM354.45 169.77L354.7 169.84L354.57 169.58L354.38 169.64L354.45 169.77ZM354.57 148.19L354.77 147.99H354.57V148.19ZM354.7 148.57L354.57 148.51V148.57H354.7ZM354.83 151.46L355.09 151.34L354.96 151.14L354.57 151.34L354.83 151.46ZM354.83 170.35H354.7L354.64 170.54L354.83 170.35ZM355.09 163.61L355.02 163.41L354.83 163.61H355.09ZM355.15 148.06L355.35 147.8L355.09 147.87L354.9 148.12L355.15 148.06ZM355.6 153.84L355.47 154.03H355.28L354.96 153.65H355.47L355.6 153.84ZM355.15 168.49L355.09 168.36L354.96 168.49H355.15ZM355.09 148.89L355.35 148.83L355.41 148.64H355.15L355.02 148.77L355.09 148.89ZM355.15 166.43L355.41 166.62L355.6 166.43L355.22 166.17L355.02 166.24L355.15 166.43ZM355.35 146V145.81L355.09 145.88L355.15 146.07L355.35 146ZM355.41 150.69L355.15 150.56L355.09 150.76L355.41 150.69ZM355.41 140.99L355.28 140.8L355.15 140.99H355.41ZM355.28 145.17L355.35 144.98L355.15 145.1L355.28 145.17ZM355.35 157.05V157L355.15 157.13L355.35 157.05ZM355.35 155.77V155.9L355.22 155.77H355.35ZM355.35 167.77H355.22L355.28 167.96L355.35 167.77ZM355.67 155.77L355.6 155.96L355.54 155.7L355.67 155.77ZM355.73 132L355.6 132.06L355.73 132ZM355.92 158.14L356.12 157.89L355.67 158.21L355.92 158.14ZM356.12 159.43V159.11H356L355.87 159.49L356.12 159.43ZM356.31 158.72L356.57 158.79L356.5 158.4L356.18 158.47L356.31 158.72ZM356.57 159.11L356.7 159.69L356.95 159.75L357.34 160.33L357.59 160.39L357.66 160.14L357.53 159.82L357.21 159.62L357.14 159.11L356.7 158.85L356.57 159.11ZM356.82 137.2L356.76 137.01L356.7 137.2H356.82ZM356.89 158.2L357.08 158.07L356.95 157.69L356.76 158.07L356.89 158.2ZM357.21 158.71L357.34 158.91L357.59 158.97L357.66 159.36L358.17 159.61L357.98 159.36L357.91 158.91H357.66L357.53 158.26L357.27 158.33L357.14 158.52L357.21 158.71ZM357.53 139.18L357.47 138.99L357.72 138.93L357.85 139.18H357.53ZM357.72 135.78H357.66L357.72 135.91V135.78ZM358.49 156.98L358.3 156.85L358.49 156.72L358.69 156.79L358.49 156.98ZM358.3 158.78L358.36 159.03L358.62 158.91L358.69 158.46L358.49 158.39L358.3 158.52V158.78ZM358.81 137.19L358.88 136.94H358.62L358.81 137.19ZM358.75 158.07L358.81 158.33L359.2 158.39L359.33 158.97L359.65 159.1L359.78 159.68L359.97 159.81L360.16 159.68L360.1 159.23L359.71 158.97L359.65 158.39L360.29 158.33L359.91 157.81L359.71 157.75L359.59 158.39H359.33L358.88 157.62L358.69 157.75L358.75 158.07ZM358.75 159.48L359.01 159.55L359.14 159.29L358.94 159.03H358.69V159.29L358.75 159.48ZM358.88 136.1L358.75 135.91V136.1H358.88ZM359.52 156.98L359.33 156.91L359.52 156.72V156.98ZM359.52 136.04L359.78 136.17V135.72L359.59 135.65L359.46 135.84L359.52 136.04ZM359.84 139.12L359.65 138.99H359.84V139.12ZM360.23 160.77V160.51H360.49V160.77L360.29 160.9L360.23 160.77ZM360.61 158.58L360.68 158.84L360.93 158.39L360.74 158.33L360.61 158.58ZM361.26 137.84L361.19 137.71L361.06 137.84H361.26ZM361.58 158.84V158.71L361.32 158.65L361.45 158.91L361.58 158.84ZM361.7 136.04L362.03 135.78H361.7L361.51 135.91L361.7 136.04ZM361.7 138.41L361.58 138.35V138.54L361.7 138.41ZM361.7 159.16L361.58 159.36L361.64 159.61L361.9 159.29L361.7 159.16ZM361.83 137.06H361.7V137.19L361.83 137.06ZM361.83 158.06L361.7 158L361.77 158.19L361.83 158.06ZM362.83 137.18L362.63 137.38L362.83 137.5V137.18ZM362.83 139.05V139L362.7 139.06L362.83 139.05ZM362.83 159.54H363.15L363.08 159.35L362.83 159.28L362.7 159.41L362.83 159.54ZM362.96 138.66L362.76 138.53L362.83 138.72L362.96 138.66ZM363.79 137.44L363.92 137.31L363.85 137.18L363.66 137.31L363.85 137.7L363.79 137.44ZM363.98 138.6L363.79 138.53V138.72L363.98 138.6ZM364.43 138.15L364.5 137.95L364.31 137.83L364.11 137.95L364.43 138.15ZM364.37 139.56L364.18 139.82L364.37 139.88L364.5 139.69L364.43 139.5L364.75 139.17L364.31 139.3L364.37 139.56ZM364.5 159.56H364.43L364.5 159.43V159.56ZM364.75 137.4L364.95 137.34L364.82 137.14L364.56 137.21L364.75 137.4ZM364.69 138.75L364.95 138.81L365.01 138.62L364.82 138.49L364.56 138.56L364.69 138.75ZM364.63 140.1L364.69 140.23L365.46 139.91H364.75L364.63 140.1ZM364.88 157.25L365.01 157.44L365.53 157.57V157.25L365.33 157.12L365.14 156.74H364.82L365.08 156.99L364.88 157.25ZM365.2 139.46L365.4 139.52L365.78 139.2H365.14L365.2 139.46ZM365.91 156.99H366L365.81 157.31L366.26 157.76L366.51 157.7L366.64 157.51L366.06 156.99L366.13 156.74L365.94 156.48H365.49L365.61 156.93L365.91 156.99ZM365.72 138.81L365.98 138.62L365.85 138.36L365.65 138.43L365.59 138.68L365.72 138.81ZM366.17 140.1L366.3 139.91L365.72 140.03V140.16L365.98 140.29L366.17 140.1ZM365.91 143.1V143.23H365.78V143.1H365.91ZM366.1 156.1L366.36 156.49L366.55 156.04L366.17 155.72L365.85 155.97L366.1 156.1ZM366.17 153.66L365.91 153.47H366.3L366.17 153.66ZM366.55 154.5L365.98 154.3V154.56L366.49 154.82L366.62 154.69L366.55 154.5ZM366.3 138.18L366.81 137.99L366.62 137.86L366.1 137.99L366.3 138.18ZM366.23 139.53L366.49 139.66L366.81 139.27L366.62 139.14L366.17 139.21L366.1 139.4L366.23 139.53ZM366.81 140.43L366.87 140.62L366.68 140.56L366.17 140.69V141L366.42 141.07L366.87 140.81L367.39 140.04L366.87 139.91L366.62 140.3L366.81 140.43ZM366.49 142.36L366.87 142.23L366.81 141.91L366.17 142.16L366.23 142.42L366.49 142.36ZM366.49 141.36L366.3 141.3L366.23 141.43L366.49 141.36ZM366.23 146.12V146L366.55 145.74L366.68 145.94L366.62 146.26L366.42 146.39L366.23 146.12ZM366.81 152.93L366.62 153.05L366.3 152.8L366.49 152.67H366.81V152.93ZM366.42 139.93H366.36L366.42 139.99V139.93ZM367.07 147.12L367.26 147.25H368.61V147.7L368.22 147.89L368.35 148.15L367.97 148.4L367.45 148.15L367.13 148.4L366.68 148.21L366.62 147.95L367.13 147.76L367.45 148.02L368 148L368.19 147.81L367.87 147.49L367.55 147.75H367.23L367.1 147.49L366.91 147.43L366.46 147.62L366.33 147.3L366.52 147.17L366.91 147.3L367.07 147.12ZM366.42 151.49L366.55 151.3L366.75 151.42L366.68 151.68L366.42 151.49ZM366.55 155.49H366.81L366.68 155.11L366.42 155.17L366.55 155.49ZM367.26 142.71L366.68 143.03L366.81 143.29L366.55 143.67L366.87 143.74L367.13 143.22L367.45 142.9L367.26 142.71ZM367.52 149.07L367.2 149.2L367.39 149.39L367.77 149.26L368.35 149.52L368.22 149.84L368.35 150.03L368.54 149.97L368.74 150.16L368.67 150.48L368.42 150.54L368.16 150.29L367.9 150.22L368 150L367.87 149.8L367.42 149.68L366.97 149.74L366.78 149.55L367.17 149.1L366.97 148.9L366.65 149.03L366.52 148.84L366.59 148.65L366.84 148.78L367.29 148.58L367.68 148.9L367.52 149.07ZM366.68 158.45L366.75 158.7L366.55 158.64L366.62 158.45H366.68ZM366.62 141.68L366.87 141.87L367.39 141.68L367.58 141.42L367.13 141.29L366.68 141.42L366.62 141.68ZM366.81 150.29L366.62 150.35L366.75 150.16L366.81 150.29ZM367 150.67H367.32L367.2 150.99L366.94 151.06L366.62 150.67L366.75 150.48L367 150.67ZM367.26 141.1L368 141L368.13 140.81L367.93 140.62H367.61L367.16 140.81L367.1 141.07L367.26 141.1ZM367.26 142.51L367.39 142.39L367.2 142.26L367.07 142.39L367.26 142.51ZM367.64 150.42H367.2L367.07 150.16L367.52 150.03L367.77 150.16L367.64 150.42ZM367.71 151.77L367.52 151.89L367.13 151.7L367.07 151.51L367.52 151.38L367.71 151.44V151.77ZM367.71 138.72L367.2 138.4V138.27H367.77L367.9 138.47L367.71 138.72ZM367.45 143.93L367.52 143.74L367.32 143.67L367.2 143.86L367.45 143.93ZM367.32 146.56L367.39 146.43H367.2L367.32 146.56ZM367.71 157.35H367.52L367.58 157.1L367.71 157.35ZM370.09 151.19L369.19 151.12L368.93 151.25L368.54 150.99L368.29 151.19L368 151L367.61 150.94L367.55 150.68H367.81L368.39 150.94L369.09 150.75L369.54 151L369.99 150.88L370.19 151L370.09 151.19ZM367.9 140.33L368.1 140.14H367.77L367.64 140.27L367.9 140.33ZM367.71 152.15L368.03 152.28L369.19 152.21L369.38 152.34L369.12 152.66L368.42 152.41L367.84 152.73L367.64 152.15H367.71ZM370.15 149.07L369.51 149.32L368.93 149L368.54 149.2L367.9 148.87L368.42 148.62L368.93 148.87L369.44 148.68L370.28 148.87L370.41 149L370.15 149.07ZM368.52 156L367.95 155.81V155.62L368.08 155.68L368.33 155.56L368.59 155.62L368.72 155.81L368.52 156ZM369.36 152L368.97 151.68L368.59 151.87L368.01 151.62L368.4 151.36L368.91 151.55L369.36 151.49L369.75 151.87L369.36 152ZM369.3 153H369.62L369.42 153.45L369.17 153L368.52 153.32L368.14 153.06L368.01 152.8L369.01 152.93L369.21 152.8L369.3 153ZM368.46 144L368.72 143.94L369.04 143.62L368.78 143.49L368.33 143.81L368.46 144ZM370.26 149.53L370.2 149.78L369.94 149.91L369.49 149.72L369.1 150.04L369.36 150.17L369.62 150.11L370.2 150.23L370.32 150.36H369.87L369.55 150.62L368.78 150.23L368.46 149.53L369.17 149.4L369.42 149.53L370.2 149.46L370.26 149.53ZM369.17 153.9H368.91L368.46 153.64L368.65 153.45L369.17 153.51L369.3 153.7L369.17 153.9ZM369.87 147.73L369.36 147.92L369.3 148.24L368.78 148.43L368.52 148.05L368.97 147.92L369.17 147.73L369.04 147.47L369.3 147.34L369.94 147.54L369.87 147.73ZM368.87 154.99H369.12L369.06 155.18L368.54 155.12L368.61 154.92L368.87 154.86V154.99ZM368.74 139.89L368.61 139.96V139.76L368.74 139.89ZM369.32 145.03L369.12 144.58H369.64L369.77 144.84L369.64 145.09L369.32 145.03ZM369.38 140.73L369.19 140.79L369.25 140.6L369.44 140.53L369.38 140.73ZM370.02 148.5L369.38 148.24L370.02 148.11L370.22 148.43L370.02 148.5ZM369.83 144.32L369.51 144.07L369.77 143.94L370.02 144.07L369.83 144.32ZM370.02 152.42L369.89 152.55L369.7 152.42L369.89 152.22L370.02 152.42ZM370.41 146.32H370.28V146.12L370.41 146.32ZM370.47 147.66L370.41 147.86L370.34 147.66H370.47Z",
                fill: "#0067A5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M377.9 138.05H378.16L378.61 138.43L378.8 138.24L377.97 137.73L378.22 137.53L378.1 137.34H377.84L377.58 137.08L377.71 136.76L377.58 136.57L377.65 136.12L377.9 135.74L377.65 135.67L377.77 135.29L378.1 135.09L378 135L378.25 134.68L377.8 134.62V135.13H377.55L377.42 135L377.48 134.75L377.74 134.62L377.55 134.36L377.74 134.11L377.42 133.85V133.4L377.74 133.33L377.93 133.59H378.19L378.25 133.46L377.61 133.14L377.8 132.82L377.23 132.31L377.29 132.05L377.1 131.66L377.23 131.41L377.55 131.6L377.29 131.09L377.23 130.57L377.03 130.25L377.23 130.06L377.48 130.19L377.74 130.12L377.03 129.48L376.84 128.84L376.65 128.71L376.78 128.52L377.23 128.39L376.71 127.49L377.1 127.04L376.97 126.46L377.03 126.2L376.78 125.88L377.1 125.69L376.97 125.3L377.23 125.18L377.68 125.37L378.32 125.18L378.9 125.24L379.28 125.05L379.86 125.37L380.31 125.05L380.76 125.18L380.82 125.3L381.34 125.05L381.66 125.43L382.04 125.56L382.11 125.11L382.49 125.18L382.82 125.63L383.01 125.5L383.07 125.18L383.46 124.98L383.59 125.3L384.04 125.43L384.36 125.05L385 125.56L385.13 125.05L385.38 124.98L385.64 125.11L385.71 125.43L385.96 125.56L386.09 125.37V125L386.28 124.93L386.73 125.13L386.8 125.38L387.12 125.51V125L387.5 124.93L387.83 125.32L388.08 125.19L388.15 124.87L388.73 125L388.66 125.25L388.79 125.51L389.24 124.93H389.56L389.43 125.93L389.3 125.73L389.24 125.99L389.37 126.18L389.62 126.25V126.83L389.3 126.89L389.17 127.15L389.37 127.4L389.69 127.34V128.34L389.43 128.21L389.17 128.34L389.05 128.85L388.66 128.79L388.53 128.34L388.34 128.21L388.15 128.27L388.02 128.72L387.63 128.79L387.5 128.47H387L386.88 128.79L386.68 128.66L386.49 128.27L386.04 128.47V128.72L385.59 128.79L385.27 128.4L385.01 128.34V128.72L384.82 128.85L384.56 128.79L384.24 128.08L384.11 128.27L384.05 128.79L383.6 128.85L383.34 128.34L383.09 128.79L382.19 128.92L381.74 128.85L380.9 129.11L380.77 129.94L381.16 130.01L381.03 130.46L380.71 130.39L380.52 130.52L380.77 130.59L381.16 131.29L381.22 131.74L381.03 131.81L380.77 131.61V131.23L380.39 131.16L380.58 131.74L380.39 131.94L380.9 132.13L380.97 132.32L380.32 132.71L380.65 132.96L380.45 133.22L380.9 133.61L380.77 133.8H380.45L380.39 134.06L380.65 134.7L380.97 135.02L380.77 135.21H381.16L381.35 135.6L381.22 135.79L380.58 135.85L380.9 136.3L381.22 136.37V137.27L380.71 137.2L380.9 137.52H381.22L381.42 137.72L381.29 137.91V138.23L381.48 138.68V139.13L381.22 139.39V140.09L381.54 140.35L381.35 140.86L381.67 141.86L381.61 142.18L381.74 142.38L381.87 142.12H382.25L382.31 142.5L383.15 143.15L383.28 142.83L382.83 142.63L382.89 142.05H383.15L383.54 142.89L383.79 142.63L384.05 142.95L384.31 143.02L384.05 142.5H383.79L383.92 142.44L383.99 142.18L384.18 142.12L384.37 142.25V142.57L384.69 142.83L384.95 143.34L385.08 143.15L384.89 142.44L384.95 142.18L385.4 142.38L385.53 142.76H385.72L386.1 143.47L386.36 143.53V143.02L386.49 142.83H386.75L386.81 143.08L387.2 143.47L387.45 143.53L387.58 144.05L387.78 144.17L387.9 143.92L387.84 143.66L387.45 143.4L387.39 142.95L387.9 142.31H388.1L388.16 142.63L387.84 143.28L388.35 144.11L387.84 144.37L388.03 144.82L388.29 144.95L388.48 145.59L388.1 145.4L387.84 145.46L387.65 144.88H387.45L387.13 144.24L386.88 144.17V143.6L386.43 143.53V143.73L386.68 143.79L386.94 144.5V144.82L387.39 144.88L387.45 145.59L387 145.46L386.75 145.78L386.1 145.59L385.72 145.85L385.27 145.78L385.33 145.59L385.59 145.52L385.66 145.07L385.46 144.95L385.33 145.4L384.95 145.52L384.63 145.2L384.44 145.33L384.69 145.72L384.24 145.78L383.86 145.59L383.73 145.33L383.47 145.46L383.54 145.78L383.02 145.65L382.25 145.72L382.06 145.59L381.8 145.72L381.61 146.17L381.29 146.36L381.48 146.62L381.29 146.81L381.67 147.07L381.74 148.74L381.61 148.99L381.74 149.38L381.42 149.51L381.67 149.7L381.8 150.7L381.74 151.21L381.99 152.21L381.8 152.41L381.93 152.6L382.06 153.37L381.87 153.63L382.12 154.01L382.06 154.78L381.87 155.17L382.19 155.81V156.07L381.87 156.45L382.19 156.65V158.57L382.06 158.9L382.25 159.54L382.19 160.31L382.31 162.11L382.25 162.56L382.38 163.46L382.31 163.97L382.51 164.87L382.4 166L382.53 166.45L382.33 167.09L382.53 167.54L382.85 167.87L383.62 167.74L384.07 167.99L384.26 167.8H385.16L385.55 167.61L385.74 167.74L385.8 167.99L386 168.12L386.19 167.99L386.25 167.74L386.7 167.61L386.9 167.99H387.15L387.28 167.61H387.6L387.8 167.74L387.86 167.99H388.12L388.37 167.54H388.63L388.95 167.99L389.21 168.12L389.53 168.7L389.79 168.76V169L389.98 169.39L390.17 169.45L390.56 170.45L390.49 170.71L390.3 170.58L390.17 170L389.79 169.94L389.72 169.23L389.34 169.56L389.4 169.75L389.79 170L389.85 170.58L390.24 170.9L390.62 171.61L390.43 171.68L389.92 171.48L389.66 171.68L389.14 171.55L389.27 171.42L389.53 171.48L389.72 171.03L389.4 170.58L389.21 170.78L389.14 171.29H388.76L388.63 170.84L388.05 170.45V170L387.8 170.13L387.86 170.38L388.18 170.71V171L388.76 171.52L388.57 171.71L388.25 171.65L388.18 171.39L387.73 171.32L387.67 170.87L387.47 170.75L387.28 170.94L387.41 171.32L387.67 171.26L387.73 171.77L387.28 171.71L386.96 171.39L386.58 171.71L386.19 171.65L386.12 171.32L385.68 171.65L385.16 171.58L384.84 171.39L384.65 171.65L384.39 171.71L381.89 171.65L380.28 171.39L379.96 171.45L379.64 171.32L379.19 171.52L378.8 171.32H378.48L378.35 171.13L378.61 170.94L378.54 170.3L378.67 169.85L378.48 169.4L378.54 169.2L378.42 168.95L378.54 168.43L378.48 167.43L378.61 166.92L378.48 166.02L378.61 165.63L378.48 163.63V161.5L378.35 160.92L378.48 160.02L378.29 159.44L378.48 159.12L378.54 158.67L378.29 158.03L378.48 157.19L378.16 156.68L378.42 156.36L378.16 156.1L378.22 155.26L378.1 155.01L378.22 154.24L378.1 153.34L378.22 153.08L378.1 152.08L378.16 151.08L378.03 150.76L378.16 150.31L378.03 150.05L378.1 149.79L377.9 149.09L378.1 148.89V148.38L377.9 147.87L378.1 147.67L378.42 147.87L378.61 147.67L377.97 147.35L377.84 146.52L378.1 146.26L377.77 145.49V145.23L378.1 144.78V144.46L378.22 144.27L377.77 143.82V143.56L378.03 143.43L378 143L377.8 142.68L377.74 141.78L378.19 141.72L378.06 141.46L377.8 141.33V140.88L377.61 140.24L378.13 140.31L377.74 139.66L377.8 139.34L377.61 139.15L377.68 138.83H378.32L377.74 138.44L377.61 137.61L378 137.67L377.8 137.87L377.9 138.05ZM377.39 133.05L377.2 132.92L377.39 132.86V133.05ZM377.97 136.71L378.16 136.65L378.42 136.84L378.67 136.71L378.54 136.46L377.9 136.39L377.77 136.58L377.97 136.71ZM378.1 132.15L378.29 132.09L378.1 131.9L377.9 132.09L378.1 132.15ZM378.1 133.76H378L378.13 133.95L378.1 133.76ZM378.48 146.41L378.42 146.22L378.22 146.29L378.48 146.41ZM378.35 145.13L378.61 145.06L378.67 144.87H378.29L378.35 145.13ZM378.54 133.95L378.35 134.02L378.61 134.14L378.54 133.95ZM378.67 135.3L378.35 135.24L378.48 135.43L378.67 135.3ZM378.61 139.3H378.42L378.35 139.5L378.61 139.69L378.74 139.5L378.61 139.3ZM378.54 142.3L378.74 142.11L378.48 142.04L378.35 142.17L378.54 142.3ZM378.61 143.65L378.67 143.46L378.48 143.39L378.35 143.59L378.61 143.65ZM378.42 131.38L378.67 131.45L378.8 131.25H378.42V131.38ZM378.61 132.86L378.8 132.79L378.61 132.6L378.42 132.73L378.61 132.86ZM378.67 137.36L378.93 137.55L379.12 137.29L378.67 137.1L378.48 137.23L378.67 137.36ZM378.8 144.23L379.06 144.36L379.12 144.16L378.61 143.97L378.8 144.23ZM379.19 134.59L378.8 134.4L378.87 134.66L379.19 134.98V135.24L379.38 135.43V135.75L379.06 135.62L378.87 135.88V136.07L379.06 136.2L379.7 135.88L380.09 136.01L379.7 135.17L379.19 134.91V134.59ZM379.06 145.71L379.12 145.64L378.93 145.51L378.8 145.64L379.06 145.71ZM379.12 132.09L379.25 131.96L379.06 131.9L378.87 132.02L379.12 132.09ZM379.19 133.44L379.06 133.24L378.87 133.31L379.19 133.44ZM379.19 138L379.57 138.19L379.77 138.06L379.06 137.87L378.87 138H379.19ZM379 147L378.87 146.94V147.13L379 147ZM379.12 138.65H378.93V138.84L379.12 138.65ZM379 140.3L379.19 140.17L379.06 140.1L378.93 140.23L379 140.3ZM379.32 136.83L379.57 136.96L379.83 136.83L379.44 136.51L379.19 136.57L379.32 136.83ZM379.51 141L379.7 140.87L379.51 140.68L379.32 140.87L379.51 141ZM379.44 145.05H379.64V144.92L379.32 144.86L379.44 145.05ZM379.64 134.05L379.44 133.92V134.17L379.64 134.05ZM379.7 139.44L379.51 139.38L379.44 139.57L379.7 139.44ZM379.64 132.82L379.77 132.7H379.57L379.64 132.82ZM380.09 140.08L379.89 140.02L379.83 140.21L380.09 140.08ZM379.96 137.45L380.09 137.32L379.96 137.39V137.45ZM380.34 131.99L380.15 131.93V132.12L380.34 131.99ZM380.34 135.46L380.54 135.59L380.73 135.33L380.34 135.14L380.15 135.27L380.34 135.46ZM380.47 139.25L380.15 139.12V139.38L380.54 139.63L380.67 139.44L380.47 139.25ZM380.28 138.09L380.54 138.16L380.47 137.9L380.28 137.84V138.09ZM380.54 136.87L380.67 136.74L380.47 136.68L380.34 136.81L380.54 136.87ZM380.54 140.92L380.34 140.66V140.85L380.54 140.92ZM380.54 130.06L380.6 129.93L380.47 129.81L380.41 130L380.54 130.06ZM381.05 148.5L380.54 148.37L380.79 148.5H381.05ZM381.31 134.37V134.56L380.67 134.43L380.79 133.98L381.24 134.17L381.31 134.37ZM380.92 125.57V125.37L380.73 125.31L380.92 125.57ZM380.79 140.28L381.05 140.34L381.24 140.21L381.05 140.08H380.73L380.79 140.28ZM380.99 141.56H381.24L381.11 141.3L380.79 141.24L380.73 141.5L380.99 141.56ZM380.92 138.86H381.18V138.61L380.99 138.54L380.79 138.67L380.92 138.86ZM381.05 140.73L380.86 140.6V140.73H381.05ZM381.05 151.13L380.86 151.07V151.2L381.05 151.13ZM381.31 133.08L381.05 133.15L380.92 133.02V132.76L381.05 132.63L381.31 132.76V133.08ZM381.11 137.9L380.92 137.84V138L381.11 137.9ZM381.76 124.9V125L381.69 124.93L381.76 124.9ZM382.08 143.02L382.21 142.76L382.01 142.63L381.89 142.89L382.08 143.02ZM382.59 145.27L382.72 145.01L382.66 144.88H382.4L382.27 145.14L382.33 145.4L382.53 145.52L382.59 145.27ZM383.04 144.43V144.75L383.23 144.69L383.3 144.5L383.04 144.43ZM383.88 143.73L383.49 143.34L383.68 143.92L383.88 143.73ZM383.68 145.14L383.75 144.95L383.49 145.01L383.68 145.14ZM383.88 144.88L384.07 144.69L383.81 144.82L383.88 144.88ZM384.07 144.5L384.13 144.69L384.33 144.62L384.2 144.24H383.94V144.37L384.07 144.5ZM384.01 143.4H384.26V143.21L384.01 143.15V143.4ZM384.46 125.8H384.33L384.46 125.93V125.8ZM384.58 143.8H384.84L384.71 143.48H384.46L384.58 143.8ZM385.23 144.51L385.16 144.25L384.97 144.32L385.23 144.51ZM385.23 125.62H385.1L385.23 125.75V125.62ZM385.29 143.42L385.42 143.16H385.23L385.29 143.42ZM385.48 171.3H385.68L385.61 171.11H385.35L385.48 171.3ZM385.61 144.12L385.74 144H385.87V143.74L385.68 143.61L385.61 143.8L385.74 144L385.42 143.87L385.61 144.12ZM385.68 126.46L385.93 126.39L386 126.2L385.87 126.07L385.61 126.2V126.46H385.68ZM386 170.3V170.1L385.74 170.3H386ZM386 142.74L385.87 142.42L386 142.29L386.38 142.42V142.74H386ZM386.32 144.66H386.19L386.25 144.86L386.32 144.66ZM386.58 168.5L386.7 168.3L386.51 168.11H386.25L386.45 168.63L386.58 168.5ZM386.7 145.63L386.58 145.37L386.51 145.56L386.7 145.63ZM387.22 170.3L387.15 170.1L386.9 170.04L386.96 170.49H387.22V170.3ZM387.15 142.42L387.22 142.67H387V142.29L387.15 142.42ZM387.22 169.42L387.41 169.55L387.22 169.16L387.02 169.22L387.22 169.42ZM387.28 168.42L387.41 168.61L387.8 168.8L387.99 169.25L388.25 169.38V169.64L388.5 170.02L388.7 169.96V169.64L388.5 169.38L388.25 169.32L388.12 168.8L387.8 168.68L387.67 168.16H387.22L387.28 168.42ZM387.73 142.21L387.54 142.14L387.8 142.02L387.73 142.21ZM387.92 126.6L387.67 126.66L387.8 126.86L387.92 126.66V126.6ZM388.25 125.89L388.31 126.15H388.5L388.57 125.7L388.31 125.57L388.12 125.7L388.25 125.89ZM388.18 127.05V127.31L388.44 127.5V126.98L388.18 127.05ZM388.57 168.48L388.76 168.23L388.63 168.1L388.37 168.16L388.31 168.35L388.57 168.48ZM389.08 170.09L388.89 170.02L388.82 170.28L389.08 170.09ZM389.34 169.25L389.21 169.06V169.25H389.34ZM389.92 168.03L390.3 168.16L390.37 168.68L390.56 169.06L390.43 169.32L390.24 169.25V168.93L390.11 168.74H389.85L389.72 168.16L389.34 167.91L389.27 167.71L389.4 167.58L389.72 167.71L389.92 168.03ZM389.79 128.72V128.85L389.66 128.72H389.79ZM390.62 167.78L390.56 167.97H390.3L390.37 167.52H390.62V167.78Z",
                fill: "#0067A5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M415.68 126L415.8 126.39L415.74 127.48L415.61 127.8L415.8 127.99L415.74 128.44L415.87 128.89L414.87 129.08L414.29 128.96L413.91 129.08L413.59 128.96L412.82 129.08L412.17 128.96L411.92 129.02L411.72 128.83H411.21L410.95 128.96L410.12 129.02L409.03 128.89L408.77 129.02L408.32 128.96L407.87 129.15L407.68 129.6V130L407.48 130.45L407.61 130.64L407.55 131.73L407.68 132.18L407.61 134.18L407.8 134.5L407.74 136.56L407.87 136.88L407.74 137.46L407.93 138.46L407.68 139.3L407.93 140.07L407.74 140.33L407.93 141.03L407.68 142.03L407.8 143.03L407.61 143.48L407.8 143.93L407.68 144.38L407.8 145.6L407.68 145.79L407.74 146.05L407.48 146.24L407.74 146.56V148.3L407.48 149.07L407.68 149.78L407.48 150.23L407.68 150.61L407.55 151.19L407.68 152.41L407.48 152.6L407.61 152.92L407.35 153.18L407.74 153.44V153.76L407.55 153.95L407.68 154.34L407.29 154.46L407.68 154.66L407.8 155.66L407.48 155.85L407.74 156.24V156.43L407.42 156.75L407.74 156.95L407.55 157.33L407.74 158.04V158.55L407.61 158.74L407.74 159.07L407.61 159.32L407.68 159.9L407.29 159.71L407.16 159.84L407.29 160.03L407.68 160.22L407.55 160.74L407.16 160.8L407.42 160.93L407.68 160.86V161.31L407.35 161.19L407.23 161.31L407.61 161.7L407.55 162.02L407.29 162.21L407.61 162.28V162.66L407.16 162.6V162.73L407.55 163.05L407.68 163.88L407.55 164.08L407.23 164.01L407.61 164.27L407.48 164.72L407.68 165.17L407.48 165.55L407.68 165.81L407.48 166.07L407.8 166.52L407.74 166.84L407.48 166.97L407.55 167.16L407.23 167.61H407.74L407.87 167.8L407.74 168.25L407.1 168.06L406.97 168.12L407.1 168.32L407.55 168.44L407.87 168.38L407.93 168.64L407.8 168.89H407.42L407.74 169.09L407.93 170.09L407.87 170.35L408 171.35H407.68L407.42 171.8L405.04 171.86L404.91 171.6L404.66 171.86L404.27 171.99L404.14 171.54L404.72 171.6L404.66 171.35L404.34 171.22L404.08 171.35L403.76 171.28L403.24 170.51L403.69 170.25L403.76 170.77L403.89 170.96L404.14 170.7L404.08 170.19L403.76 170.12L403.63 169.74L404.21 169.42V168.9L404.46 168.97L404.72 168.84L404.59 168.58L404.14 168.78L403.69 168.65V168.26L404.46 168.39L404.4 168.13L403.95 167.81L404.4 167.62L404.98 167.56L404.59 167.17L404.14 167.43H403.89L403.56 167.11L403.82 166.98H404.53L404.4 166.91L404.21 166.46L403.56 166.72L403.37 166.59V166.21L403.63 166.14L404.21 166.33L404.34 166.14L403.56 165.69L404.34 165.31L404.14 165.11L403.69 165.31L403.37 165.24L403.31 164.99L403.44 164.79L403.63 164.86L403.82 164.73L403.89 164.22L404.4 164.15L404.21 163.77L403.5 164.28L403.37 163.96L403.5 163.44L403.89 163.19L403.76 162.99L403.82 162.74H403.56L403.37 162.48L403.44 162.16L404.01 162.09L403.76 161.65L404.4 161.2L404.14 161.13L403.63 161.32L403.44 161.13L403.5 160.81L404.27 160.94L404.4 160.87L403.82 160.36L403.37 160.49L403.44 160.3L403.89 159.98L403.5 159.65L403.56 159.46L403.95 159.2L403.76 159.08L403.5 159.2L403.37 159.08L403.44 158.82L404.01 158.75L404.21 158.56L404.59 158.5L404.53 158.37L404.01 158.56H403.69L403.5 158.37L403.56 158.11L403.89 158.05L404.08 157.86L403.89 157.66L403.44 157.79L403.37 157.6L403.56 157.21V156.21L403.76 155.95L403.56 155.5L403.69 155.25H403.95L404.08 155.05L403.5 154.99L403.44 154.8L403.56 154.6L403.89 154.67L403.69 154.54L403.56 154.15L404.4 153.9L403.95 153.58L404.01 153.32L403.5 152.74L403.95 152.42L403.89 152.23L403.69 152.48L403.56 152.35L403.5 151.84L403.63 151.65L403.5 150.65L403.69 150.27L403.56 150.01L403.63 149.69L403.31 149.3L403.56 148.98V148.47L403.37 148.21V147.89L403.69 147.63L403.56 147.31V146.54L403.82 146.28L403.56 145.9L403.76 145.64L403.37 145.45L403.44 145.13L403.82 144.74L403.56 144.55V144L403.89 143L403.63 142.68V142.42L403.95 142.04L403.76 141.72V140.1L403.63 139.98L403.56 139.46L403.89 139.08L403.95 138.82L403.69 138.5L403.95 137.92L403.76 136.92L403.89 136.6V136.15L403.69 135.89L403.89 134.74L403.56 134.48L403.82 133.9L403.76 133.71L403.95 133.45L403.69 132.45V129.62L403.5 129.3L403.63 128.72L403.11 128.66L402.86 128.79L402.28 128.59L400.93 128.79L400.74 128.66H399.97L399.39 128.53L398.87 128.79L398.43 128.59L398.17 128.66L397.78 129.04L397.72 128.59L396.95 128.79L397.01 129.04L396.75 128.98L396.69 128.72H395.92L395.86 127.89L395.6 127.5L395.73 127.25L395.28 126.92L395.79 126.8L395.6 125.8L395.79 125.48L395.66 125.22L395.92 124.96L396.69 125.09L396.88 124.96L397.46 125.16L398 125L398.64 125.13L399.41 124.93L399.73 125L400.06 124.87L400.63 125L401.02 124.87L401.6 125L402.05 124.93L402.24 125.06L403.72 125L403.97 124.87L405.07 125.06L405.39 124.93L406.74 125L406.99 124.87L407.31 124.93L407.51 125.13L408.02 124.87L408.47 125.06L409 125L409.32 125.19H410.02L410.21 125.06L411.76 125.19L412.27 125.06L412.72 125.19H413.49L413.75 125.06L415.55 125.32L415.87 125.7L415.68 126ZM396.15 128V127.8L396.02 127.87L396.15 128ZM402.7 127.35H402.51V127.55L402.7 127.35ZM403.28 164.48L403.15 164.23L403.34 164.16V164.42L403.28 164.48ZM403.6 169.17L403.21 169.11L403.34 168.92H403.73L403.6 169.17ZM403.41 161.59L403.28 161.53L403.47 161.47L403.41 161.59ZM403.79 167.59L403.6 167.85L403.28 167.66L403.41 167.46L403.66 167.4L403.79 167.59ZM403.53 171.64L403.41 171.51H403.66L403.53 171.64ZM403.73 153.33L403.6 153.59L403.53 153.33H403.73ZM403.92 156.41L404.11 156.29L403.79 156.09L403.73 156.35L403.92 156.41ZM404.05 151.85V151.73L403.79 151.66V151.85H404.05ZM403.98 149.22L403.86 149.16L403.92 149.35L403.98 149.22ZM404.11 150.83V150.7L403.92 150.83H404.11ZM404.31 162.52L404.37 162.26L404.11 162.2L404.05 162.39L404.31 162.52ZM404.31 159.69H404.5L404.31 159.5L404.11 159.63L404.31 159.69ZM404.37 157.12L404.5 156.99H404.18L404.37 157.12ZM404.31 169.58L404.5 169.39H404.18L404.31 169.58ZM404.31 170.8L404.5 170.68L404.31 170.74V170.8ZM404.37 165.86L405.2 165.99L405.01 165.79L404.43 165.73L404.37 165.86ZM404.69 155.77L404.56 155.58L404.43 155.64L404.69 155.77ZM404.56 164.57L404.75 164.44L404.56 164.38L404.43 164.51L404.56 164.57ZM404.56 163.22L405.01 163.35L405.2 163.22L404.69 162.97L404.5 163.03L404.56 163.22ZM404.82 161.75L404.95 161.94L405.2 162L405.33 161.87L405.08 161.68H404.56L404.82 161.75ZM404.69 170.29L404.95 170.48V170.29L404.63 170.03L404.69 170.29ZM405.01 152.29V152.1L404.82 152.23L405.01 152.29ZM405 165L404.87 165.26L405.32 165.19L405.19 164.87L405 165ZM405.06 166.67L405.32 166.54L405.13 166.41L404.93 166.6L405.06 166.67ZM405.13 162.67L405.38 162.48L405.19 162.35L405 162.54L405.13 162.67ZM405.13 146.74L405.06 146.93L405.25 147L405.13 146.74ZM405.25 163.74L405.06 163.87L405.19 164.07L405.32 164L405.25 163.74ZM405.25 159.74H405.45L405.32 159.55L405.13 159.61L405.25 159.74ZM405.58 169.57L405.13 169.51L405.45 169.57H405.58ZM405.51 155.76V155.57L405.32 155.69L405.51 155.76ZM405.38 161.09L405.32 161.03V161.09H405.38ZM405.51 170.98L405.32 171.18L405.38 171.43L405.64 171.3L405.51 170.98ZM405.64 166.04L405.83 165.84L405.7 165.71L405.38 165.97L405.64 166.04ZM405.38 168.67L405.7 168.73L405.64 168.48L405.38 168.61V168.67ZM405.96 161.99L405.9 161.73L405.64 161.6L405.45 161.73L405.96 161.99ZM405.83 166.68L406.28 166.81V166.49L405.96 166.36L405.7 166.74L405.83 166.68ZM405.9 159.1L406.09 158.91L405.77 159.03L405.9 159.1ZM406 168L406.25 167.88L405.93 167.75L405.8 167.94L406 168ZM406.06 170.64L405.87 170.51V170.7L406.06 170.64ZM406.19 161.19L406.38 161.07L406.19 160.94L406 161.07L406.19 161.19ZM406.25 162.54V162.41L406 162.54H406.25ZM406.19 163.96L406.32 163.76L406.12 163.7L406 163.89L406.19 163.96ZM406.25 159.78H406.44V159.52L406.12 159.59L406.25 159.78ZM406.44 155.78L406.38 155.59L406.25 155.72L406.44 155.78ZM406.44 170.17H406.64V170L406.44 169.88L406.25 170.07L406.44 170.17ZM406.38 167.35L406.57 167.48L406.77 167.28L406.32 167.15L406.38 167.35ZM406.64 168.89L406.83 168.82L406.38 168.7V168.82L406.64 168.89ZM406.64 164.89L406.83 164.76L406.57 164.57L406.44 164.7L406.64 164.89ZM406.57 169.52H406.44L406.57 169.71V169.52ZM406.7 163.29V163L406.51 163.13L406.7 163.29ZM406.57 164.29L406.7 164.16L406.51 164.23L406.57 164.29ZM406.83 166.09H406.89L406.7 165.83L406.57 165.96L406.83 166.09ZM406.83 159.34L407.09 159.21L406.77 159.09L406.64 159.21L406.83 159.34ZM406.96 160.76L406.83 160.5V160.63L406.96 160.76ZM407.02 166.67L406.83 166.86L407.28 166.92V166.6L407.15 166.47L407.02 166.67ZM407.02 171.03L407.09 170.78H406.96L406.83 170.97L407.02 171.03ZM406.94 155L407.07 155.06V154.93H406.94V155ZM407 152.43L407.13 152.3H407V152.43ZM407.32 165.21L407.13 165.02L407 165.21H407.32ZM407.58 169.84L407.2 170.09L407.45 170.22L407.71 170.03L407.58 169.84ZM407.77 128.98L407.65 128.85L407.58 128.98H407.77ZM435.2 128.27L434.56 128.66L434.37 128.21L433.86 128.72L433.6 128.79L433.34 129.04L433 129L432.55 128.61L432.36 129L431.52 129.26L431.39 129.45L431.07 129.39L431 130L431.9 130.33L431.13 130.77L431.33 130.97L431.97 130.77L432.03 131.03L431.71 131.42L431.9 131.74L431.13 132.12L431.33 132.38L431.07 132.7L431.52 132.83L431.65 133.02L431.52 133.28L431.26 133.41L431.45 133.73L431.71 133.54L431.9 133.79L431.71 133.99L431.52 133.79L431.07 133.99L431.52 134.24L431.65 134.63L431.26 134.89L431.45 135.01L431.78 134.95L431.65 135.34H431.2L431.58 135.66L431.78 136.66L431.52 136.85L431.71 137.24L431.39 137.62L431.52 137.75H431.78L431.65 138.07L431.33 138.2L431.65 138.27L431.71 138.39L431.39 138.97L431.52 139.23L431.45 139.55L431.58 139.81V140.19L431.39 140.39L431.78 140.58V140.71L431.39 140.9L431.58 141.09L431.65 141.41L431.39 141.74L431.71 141.93L431.39 142.12L431.71 142.57L431.45 143.08L431.52 143.34L431.33 143.6L431.65 143.92L431.71 144.18L431.45 144.5L431.52 144.75L431.39 144.95L430.94 145.14L431.07 145.33L431.45 145.14L431.65 145.2L431.71 145.46L431.45 146.46L431.65 146.58V146.84L431.45 147.23L431.52 147.55L431.39 147.87L430.94 148L431.13 148.12L431.52 148.06L431.45 148.9L431.2 149.02L431.52 149.28L431.58 149.73L431.45 149.92V150.5L431.13 150.57L431.26 150.82L431.52 150.95L431.33 151.95L431.52 152.14V152.46L431.26 152.85L431.58 153.04L431.2 153.23L431.07 153.43L431.52 153.36V154.01L431.26 154.2L431.52 154.52L431.26 154.65H431.52L431.58 154.9L431.26 155.48V156L431.58 156.06L431.52 156.57L431.26 156.96L431.52 157.15L431.33 157.47L431.52 157.67V157.99L431.33 158.37L431.39 158.63L431.26 158.82L431.52 159.08L431.39 159.53L431.52 160.94L431.39 161.26L431.52 162.03L431.39 162.48L431.52 163.38L431.39 163.9V165.57L431.52 166.21L431.39 170.13L431.52 170.39L431.33 171.22L431.45 171.67L430.81 171.74L430.36 171.61H428.69L428.24 171.8H427.47V169L427.66 168.1L427.54 167.85L427.6 167.65V165.21L427.47 164.38V163L427.6 162.55V161.46L427.47 160.88L427.54 159.47L427.41 158.96L427.47 158.7L427.34 157.54H427.6L427.54 156.96L427.79 156.64V156L427.47 155.94L427.6 154.85L427.54 154.33L427.73 153.82L427.47 152.82L427.66 152.5L427.54 152.24L427.73 152.05L427.66 151.86L427.86 151.6L427.79 151.02L427.66 150.83L427.41 150.9V150.38H427.66L427.79 150.25L427.54 150.06L427.73 149.74L427.41 149.48L427.79 148.84V148.39L427.6 148.2V147.94L427.79 147.88L427.86 147.62L427.73 147.17L427.79 146.91L427.66 146.66L427.73 145.76L428.05 145.44L427.66 145.31L427.79 144.73L427.73 144.47V143.19L428.18 142.87L427.73 142.61L427.86 142.29L427.73 142.09L427.79 141.58L428.05 141.45L427.73 141.26L427.92 140.94L427.66 140.36L427.73 140.17L428 140L427.87 139.81L427.93 139.55L427.74 139.29L427.67 138.84L428 138.59V138.14L427.74 137.82V137.49L428.06 137.17L427.87 136.98L428 136.66L427.61 136.15L427.93 135.44L427.67 135.25L427.55 134.73L428 134.54L427.8 134.28L428.12 133.96H428.44L428.25 133.7H427.61L427.48 133.51L427.61 133.13L427.87 133.06L427.8 132.87L427.93 132.68L427.61 132.35L427.55 132.1L427.87 131.97L427.8 131.65L428 131.13L427.55 131.01L427.67 130.75H428.19L428.32 130.62L428 130.56L427.74 130.24L428 130L428.32 129.88L428.06 129.75L427.87 129.88L427.61 129.75L427.48 129.49L427.87 129.36L427.93 128.72H427.74L427.35 129.04L427.16 128.91L427.35 128.46V128.14L427.16 128.01L426.9 128.59L426.33 128.91L425.94 128.85V128.59L425.04 128.91L424.53 128.65L424.14 128.98L423.63 128.59L423.05 128.98L422.73 128.72L422.28 129.04L421.76 128.72L421.31 129.04L420.86 129.17L420.67 128.91L420.35 129.17L419.9 129.1L419.52 128.85L419.19 129.04H418.94L418.75 129.23H418.36L417.91 128.98L417.97 127.98L417.85 127.73L417.97 127.4L417.85 126.31L417.97 126.12L417.91 125.61L418.1 124.96H418.75L419.07 125.35L419.39 125.09L419.9 125.28L419.97 125.73L420.16 125.54L420.22 125.22L420.74 125.03H423.37L423.63 125.16L423.88 124.96L424.46 124.9L424.65 125.09L424.98 124.9H425.3L425.62 125.22L425.88 124.9H426.13L426.52 125.16H426.71L426.97 124.83L427.22 124.9L427.55 125.22L427.67 125.09V124.83L429.15 124.9L429.41 124.77L429.86 124.83L429.99 124.96L430.76 124.83L431.34 125.03L431.46 124.77L431.85 125.28L432.11 124.96L432.88 125.28L433 125L433.51 124.93L433.58 125.32L433.96 124.87H434.28L434.73 125.38L434.99 125.32L434.93 124.93L435.25 124.87L435.57 125.25L435.89 125.32L436.02 125.19V124.93L436.79 124.8L436.66 125.06L436.21 125.38V125.7L436.08 125.9L436.28 125.96L436.6 125.25L436.92 125.32L436.98 124.93L437.43 124.87L437.5 125.13L437.82 125.25L438.07 124.87L438.78 124.93L438.65 125.32L439.1 125.7H439.3L438.65 126.41V126.6L438.85 126.73L439.04 126.67V126.09L439.3 126.28L439.55 126.15V126.41L439.75 126.8L440.07 126.6L439.87 126.09H439.62V125.77L439.81 125.25L439.75 124.93L440 124.8L440.19 125L440.26 125.32L440.13 125.7L440.26 125.9L440.19 126.41L440.45 126.8H440.19L440.13 127.05L440.32 127.25L440.52 128.25L440.32 128.18L440.26 128.44L440.52 128.76V129.21L440.07 128.76L439.49 129.02L439.3 128.96L439.23 129.15L439.04 129.02L438.85 128.63L438.59 128.7L438.52 128.12H438.78L438.97 127.93V127.67L438.78 127.48L438.52 128.06L438.07 128.38V128.63L437.75 128.89L437.37 128.25L437.11 128.18L436.98 128.31L437.37 128.89L437.24 129.21L436.85 128.83H436.66L436.47 129.02L435.83 128.7L435.51 128.76V129L435.12 129.13L434.99 128.74H435.44L435.38 128.16L435.2 128.27ZM418.57 128.98L418.63 128.79L418.44 128.72V128.92L418.57 128.98ZM422.04 125.38L422.1 125.19H421.91L421.78 125.45L422.04 125.38ZM424.16 128.14L424.09 127.95H423.9L424.09 128.21L424.16 128.14ZM424.22 125.38H424.09L424.03 125.58L424.16 125.7L424.22 125.38ZM425.31 128.38H425.18V128.51L425.31 128.38ZM426.15 128.45L426.34 128.32L425.89 128.45H426.15ZM427.5 151.25V151.38L427.37 151.25H427.5ZM428.07 143.8L427.95 144.12H428.2L428.14 143.67H427.88L428.07 143.8ZM428 128.6L428.19 128.48H428V128.6ZM428.38 144.92L428.44 144.79L428.32 144.6V144.47H428.19L428.32 144.6L428.38 144.92ZM428.64 142.92L428.38 143.05L428.64 143.18V142.92ZM428.57 140.8L428.7 140.67L428.51 140.8H428.57ZM428.7 141.8L428.83 141.61H428.64L428.51 141.8H428.7ZM429.09 145.59L429.02 145.47L428.96 145.59H429.09ZM429.41 129.92L429.28 129.79L429.15 129.92H429.41ZM429.47 141.8L429.86 141.55L429.47 141.68V141.8ZM429.54 132.87L429.73 132.81L429.54 132.75V132.87ZM429.86 133.32L429.67 133.07L429.54 133.39L429.86 133.32ZM429.67 125.32L429.92 125.2L429.73 125.07L429.6 125.2L429.67 125.32ZM429.73 130.66L429.86 130.46L429.6 130.59L429.73 130.66ZM429.79 131.94L429.92 131.68H429.73L429.6 131.94H429.79ZM430 143.7H429.87V143.83L430 143.7ZM430.13 131.17H430V131.3L430.13 131.17ZM430.32 132.72L430.64 132.52L430.07 132.59L430.32 132.72ZM430.32 129.83H430.13L430.19 129.95L430.32 129.83ZM430.26 133.62V133.42H430.13L430.26 133.62ZM430.64 148.45L430.51 148.39V148.58L430.64 148.45ZM430.9 131.56L430.96 131.43L430.58 131.37V131.5L430.9 131.56ZM430.77 132.84V132.65H430.58L430.77 132.84ZM430.64 153.53L430.9 153.4L430.71 153.27L430.58 153.47L430.64 153.53ZM430.77 133.42L430.96 133.29L430.71 133.36L430.77 133.42ZM430.9 134.64V134.51L430.71 134.64H430.9ZM430.77 151.22V151.15L430.71 151.22H430.77ZM430.9 130.47L430.77 130.34V130.53L430.9 130.47ZM431.03 141.07L431.22 141L430.96 140.87L430.84 141.07H431.03ZM431.09 142.54L431.22 142.42L431.16 142.29H430.84L431.09 142.54ZM431.16 142.8H430.9L431.03 142.93L431.16 142.8ZM431.09 143.57L430.96 143.51L431.03 143.7L431.09 143.57ZM431.22 146.57L431.03 146.38L430.96 146.57H431.22ZM431.35 131.28L431.22 131.21L431.03 131.34L431.35 131.28ZM431.22 148.17H431.09V148.37L431.22 148.17ZM431.22 151.17V150.98L431.09 151.1L431.22 151.17ZM431.29 128.62V128.49L431.22 128.62H431.29ZM431.74 132.15L432.06 132.35L431.8 132.67L431.54 132.73L431.35 132.35L431.48 132.09L431.74 132.15ZM431.8 129.91L431.61 130.03L431.48 129.91V129.65L431.74 129.58L431.93 129.71L431.8 129.91ZM432.12 128.49L432.25 128.68L432.44 128.49L432.12 128.23V128.49ZM433.34 128.75V128.17L433.15 128.62L433.34 128.75ZM433.6 126.63V126.82L433.79 126.69L433.92 126.12H433.6L433.47 126.31L433.6 126.63ZM433.79 128.11L433.92 127.91L433.79 127.46L433.6 127.53L433.53 128.04L433.79 128.11ZM434.18 126.05L434.43 125.99L434.37 125.86H434.11L433.92 126.05H434.18ZM434.05 127.14L434.11 127.34L434.37 127.01L434.24 126.82L433.98 126.89L434.05 127.14ZM434.24 128.88H434.43L434.5 129.01L434.05 129.07V128.81L434.24 128.88ZM434.95 126.69V125.99L434.5 126.44L434.56 126.63L434.82 126.76L434.95 126.69ZM435.14 127.4L435.4 127.34L435.53 127.08L435.46 126.82L435 127L435.14 127.4ZM435.4 125.73L435.33 125.54L435.01 125.47L435.14 125.67L435.4 125.73ZM435.4 126.05L435.46 125.79L435.2 125.86L435.08 126.05H435.4ZM435.65 126.69L435.91 126.76L435.85 126.5L435.65 126.56V126.69ZM436.04 127.91L435.85 127.85L435.91 128.04L436.04 127.91ZM436.36 128.43V128.23H436.17L436.36 128.43ZM436.75 126.43L436.87 126.55L436.81 126.81L437 126.94L437.07 127.26L437.26 127.45L437.45 127.39L437.52 127.07L437.39 126.81H437.13L436.94 126.23H436.68L436.75 126.43ZM437 127.9L436.94 127.71L436.68 127.58V128L436.87 128.07L437 127.9ZM437.45 125.98L437.2 125.91V126.11L437.45 125.98ZM437.58 126.62L437.84 126.75L438.03 126.68L437.97 126.43H437.52L437.58 126.62ZM437.65 127.97L437.84 128.22L438.09 128.03L438.03 127.52L437.84 127.65L437.77 127.9L437.65 127.97ZM438.35 125.53L438.16 125.46L438.03 125.72L438.29 125.85L438.09 126.04L438.22 126.23L438.48 126.11L438.54 125.78L438.35 125.53ZM438.09 127.26L438.16 127.45H438.42L438.54 127L438.29 126.88L438.03 127L438.09 127.26ZM438.35 128.87L438.48 129L438.35 129.12L438.16 129.06L438.09 128.8L438.35 128.87ZM439.06 125.27L438.99 125.01L439.12 124.88L439.38 125.01L439.44 125.27L439.19 125.53L439.06 125.27ZM439.19 128.61V128.8L439.38 128.93L439.51 128.67L439.44 128.1L439.19 128.16L439.12 128.35L439.19 128.61ZM439.57 127.26L439.51 127L439.44 127.26H439.57ZM439.89 127.71L439.7 127.45L439.57 127.71L439.89 128.1L440.02 127.9L439.89 127.71Z",
                fill: "#0067A5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M449.34 162.46L449.53 162.39L449.47 162.84L449.21 163.36L449.47 163.81L449.21 164.81L449 165L449.25 165.33L449.19 166.22L449.38 166.48L449.19 167.25L449.32 167.77L449.25 168.09L449.38 169.09L449.32 169.6L449.45 170.11L449.38 170.56L449.58 171.33L449.45 171.78L448.61 171.66L448.1 171.78L447.52 171.66L447.2 171.85L447.01 171.72L445.91 171.53L445.72 171.01L445.78 170.18L445.66 169.86L445.72 168.38L445.59 168.12L445.53 166.71L445.34 166.26L445.53 165.68L445.27 164.97V163.18L445.4 162.73V157.39L445.27 155.98L445.4 155.72V155.34L445.27 155.08L445.34 154.57L445.53 154.37L445.27 154.12L445.4 153.86L445.34 153.35L445.53 152.96L445.4 152.7L445.46 152.45L445.34 151.87L445.53 151.61L445.34 151.42L445.27 150.91L445.4 150.33L445.34 150.07L445.46 149.75L445.34 149.11L445.59 149.17L445.91 149.75L446.04 149.69L445.91 149.3L446.11 149.11L445.78 149.04L445.53 148.4L445.27 148.14L445.34 147.63L445.66 147.95L445.98 147.76L445.72 147.63V147.18L445.85 146.86L445.78 146.73L445.46 146.86V146.28L445.66 146.15L445.46 145.9L445.4 145.45L445.72 144.8L445.4 144.16V143.78L445.66 143.58V143.13L445.34 142.49L445.78 142.62L445.98 143L446.17 142.43L446.04 142.3L445.72 142.43V141.78L446.17 141.66L446.04 141.46L445.53 141.66L445.4 141.08L445.72 140.88L445.53 140.56L445.59 140.31L445.46 139.79L445.66 139.6L445.59 139.21L445.72 138.96V137.87L445.53 137.29L445.72 136.9L445.66 135.42L445.78 135.23L445.85 134.4L445.72 134.14L445.78 133.82L446.11 133.75L445.91 133.5L446.04 132.5L446.3 132.37L446.04 132.05V131.8L446.36 131.54L446.43 130.77L446.68 129.77L447.01 129.44L447.07 128.93H447.39L447.58 128.16L447.84 128.09L447.9 127.84L448.1 127.71L448.16 127.45L448.42 127.39L448.55 127.2V126.87L448.87 126.75V126.49L449.19 126.04L449.51 125.91L449.96 125.4L451.76 124.63L452.21 124.75L452.53 124.37L452.92 124.24L453.17 124.37L454.27 124.18L454.71 124.43L454.84 124.18H455.29L455.48 124.37L455.81 124.43L456.06 124.18L456.58 124.63L456.96 124.5V124.69L457.16 124.82H457.6L457.8 125.01L457.67 125.4L458.06 125.27L458.7 125.4L459.08 126.49L459.34 126.17L459.47 126.3L459.4 126.49L459.53 126.68H460L460.19 127.32L460.58 127.52L460.45 127.84L460.58 128.03L461 128V128.57L461.45 128.77V129.02L461.12 128.9L460.42 129.28L460.61 129.41L461.12 129.22L461.64 129.47L461.45 129.67L461.12 129.73L461 130L461.12 130.26L461.38 130.13L461.9 130.26L461.38 130.77L461.19 131.29L460.93 131.42L461.12 131.61L461.64 131.55L461.7 131.16L461.51 131.1L461.45 130.9H462.22V131.35L462.6 131.67L462.41 132.06L462.79 132.44L462.47 132.38L462.15 132.7L462.34 132.89H462.86L462.73 133.28L462.41 133.41L462.6 133.54L462.92 133.47L463.12 133.67V133.92L462.47 133.79L462.02 134.18V134.31H462.86L462.6 134.69L462.67 134.89L463.05 134.82L463.18 135.01L463.12 135.27L462.86 135.34L462.47 135.08L462.22 135.46H462.67L463.18 135.66L462.79 135.79L462.73 135.91L462.86 136.17L463.18 136.24L463.24 136.49L463.12 136.62L462.54 136.49L462.22 136.62L462.15 136.81L462.34 136.94L462.86 136.88L463.05 137.01L463.31 136.88V137.26L462.99 137.13L462.67 137.52H463.18V138L463.44 138.32L463.12 139.32L463.5 139.71L463.24 140.03L463.31 140.29L463.12 140.67L463.57 140.99L463.24 141.44L463.37 141.64L462.79 142.15L462.86 142.28L463.12 142.02L463.57 142.28L463.24 142.79L463.12 143.37L463.44 143.5L463.57 143.88L463.24 144.14L463.5 144.27L463.63 144.53L463.31 144.46L463.24 144.65L463.5 144.72L463.57 145.72L463.44 145.91L463.63 146.3L463.44 146.68L463.57 147.07V147.77L463.44 148.16L463.63 148.99L463.44 149.44L463.5 149.76L463.18 150.15L463.5 150.28V150.6L463.05 150.66L463.37 150.73L463.57 151.11L463.44 151.31L463.5 151.76L462.99 152.01L463.37 152.2V152.72L462.99 152.85L463.12 153.04L463.44 153.17L463.37 153.88L463.5 154.77L463.31 155.55L463.44 155.93L463.37 158.05L463.57 158.56L463.37 158.89L463.5 159.79L463.37 160.3L463.57 161.39L463.37 161.65L463.57 162.1V162.61L463.31 162.87V163.19L463.5 163.64L463.44 164.03L463.24 164.22L463.31 164.41V166.53L463.12 166.85L463.24 167.11L463.31 167.82L463.18 168.91L463.24 169.42L463.12 169.68L463.18 170.26L463.05 171.03L463.18 171.93L462.54 172.18L461.96 171.99L459.71 171.93L459.32 171.73V170.64L459.45 170.13V169.04L459.58 168.84V162.42L459.71 161.52L459.58 161.13L459.71 160.75L459.58 160.36H459.32L459.13 160.75L458.55 160.3H458.23L457.98 160.62L457.33 160.24L457.14 160.62L456.56 160.36L456.24 160.43L456.05 160.62L455.79 160.36L455.21 160.43L454.83 160.62L454.38 160.43L453.74 160.68L453.16 160.24L453.09 159.91L452.64 159.72L452.58 160.24L452.2 160.36L452 159.85L451.68 159.91L451.62 160.17L451.74 160.43L452.07 160.62L451.94 160.81H451.74L451.42 160.49L451.1 160.43L451 160L450.81 159.88L450.68 160L450.74 160.2L450.61 160.39L451 160.71L450.93 160.9L450.68 160.97L450.23 160.52L449.91 160.9H449.39L449.2 161.03L449.52 161.35L449.46 161.61L449.2 161.87L449.39 162.25L449.14 162.44L449.34 162.46ZM445.42 147.46L445.29 147.39L445.42 147.2V147.46ZM445.74 157.35V157.29L445.61 157.35H445.74ZM446.13 144.35L446 144.16L445.8 144.29L446.13 144.35ZM446.06 151.87L445.87 151.68L445.8 151.87H446.06ZM445.93 140.37L446.19 140.24L446.06 140.11L445.87 140.18L445.93 140.37ZM445.87 141.08L445.93 141.33L446.06 141.14V140.82H445.93L445.87 141.08ZM445.87 145.25L446 145.45L446.19 145.06L445.87 145V145.25ZM446.06 150.91L445.93 150.84L445.87 150.97L446.06 150.91ZM446.19 143.71H445.93V143.9L446.19 143.71ZM446.19 137.42L446.13 137.16L446 137.54L446.19 137.67V137.42ZM446.13 138.89V138.7L446 139L446.13 138.89ZM446.51 147.69L446.7 147.57L446.45 147.44L446.19 147.63L446.51 147.69ZM446.51 152.69L446.58 152.31H446.38L446.25 152.5L446.51 152.95V152.69ZM446.32 151.09L446.45 151.6L446.51 151.09L446.83 150.83H446.45L446.32 151.09ZM446.38 142.99L446.45 143.64L446.64 143.77L446.77 143.64L446.64 142.93L446.38 142.99ZM446.58 147.17L446.64 146.98L446.45 146.91L446.38 147.11L446.58 147.17ZM446.64 148.33L446.45 148.26L446.38 148.39L446.64 148.33ZM446.51 144.66V144.92L446.7 144.86L446.77 144.54L447.15 144.21L446.45 144.41L446.51 144.66ZM446.45 145.82L446.64 145.63L446.45 145.76V145.82ZM446.64 140.82H446.51L446.58 140.95L446.64 140.82ZM446.9 153.73L446.7 153.48L446.58 153.67L446.9 153.73ZM447.09 151.73L446.9 151.6L446.77 151.8L447.09 151.73ZM446.83 146.4L447.03 146.53L447.28 146.27L447.54 146.34L447.67 146.14L447.41 146.08L446.83 146.21V146.4ZM446.96 147.81L447.09 147.68H446.83L446.96 147.81ZM446.96 143.7L447.03 143.77V143.64L446.96 143.7ZM447.6 146.98L447.48 146.72L447.22 146.85V147L447.41 147.13L447.6 146.98ZM447.41 151.67L447.6 151.54L447.48 151.41L447.28 151.47L447.41 151.67ZM447.41 145.76L447.6 145.63L447.35 145.69L447.41 145.76ZM447.41 148.45L447.6 148.26H447.35L447.41 148.45ZM447.48 152.82H447.35L447.48 152.95V152.82ZM456.85 129.05H456.53L456.08 128.6L455.83 128.54L455.7 128.28L455 128L454.68 128.07L454.04 127.94L453.78 128.13H453.2L452.56 128.52H452.37L452.18 128.84L451.72 129.16L451.66 129.48L451.4 129.67L450.7 130.67L450.76 130.93L450.63 131.25L450.12 131.44L450.31 131.76L450.12 132.08L450 132L449.94 132.71L450.06 132.96L449.94 133.22L449.68 133.28L449.62 133.48L449.87 133.93L449.62 134.31L449.55 134.7L449.68 134.89L449.42 136.82L449.55 137.07L449.49 137.33H449L448.93 137.52L449.32 137.72L449.19 138.23H449L449.19 139.13L449.32 139.26L448.74 139.84L448.48 140.29V140.61L448.61 140.8L448.87 140.74L448.8 140.41L449 139.97L449.13 140.54L448.87 140.86V141.57L449 141.76L449.25 141.83L449.32 141.96L449.19 142.15L448.48 142.28L448.87 142.6L448.8 142.86L448.55 142.92L448.42 143.18L448.61 143.24L448.8 143.11L448.93 143.31L448.87 143.5H448L447.81 143.69L447.87 144.01L447.74 144.27L447.42 144.4L447.68 144.53L448 144.4L448.45 144.53L448.64 144.33H448.26L448.13 143.95L448.26 143.76L448.77 143.69L448.9 144.27L449.35 144.59L448.9 144.78L448.64 144.72L448.51 144.85L448.77 144.91L448.9 145.36L448.45 145.62V145.88H448.64L448.9 145.55L449.16 145.62L449.28 145.81V146.13L448.9 146.2L448.64 145.94L448.45 146.13L447.93 146.2L447.87 146.39L448.06 146.52L448.32 146.26H448.71L448.9 146.71L448.83 146.9H449.22L449.28 147.35L449.09 147.48L448.71 147.35L447.81 147.55L447.49 147.42L447.61 147.67L448.13 147.99L448.19 147.8L448.45 147.61L448.9 147.87L448.83 148.06L448.38 148.19L448.06 148.06L448.13 148.38L448.38 148.51L448.9 148.25L449.16 148.38L449.22 148.64L449.09 148.83L448.83 148.89L448.71 149.15L448.83 149.22L449.16 149.09L449.28 149.28L448.9 149.41L448.83 149.6L449.09 149.67L449.22 149.86L449.16 150.05L448.77 150.31V150.89L449.16 150.95L449.22 151.27L449.09 151.46H448.83L448.77 151.79L449.16 151.72L449.28 151.91L449.09 152.3L449.16 152.75L448.71 153.13H449.16L449.35 153.33L449.22 154.03L448.77 154.48L449.09 154.35L449.35 154.8L449.09 155.13L449.22 155.38V156.38L449.09 156.57L449.22 156.83L449.09 157.09L449.48 157.02L449.73 157.86L450.05 157.92L450.44 158.5H450.7L450.5 157.99L450.12 157.6V157.34L450.44 157.15L450.63 157.28L450.83 157.73L451.08 157.79L451.4 158.5L451.6 158.56L451.66 158.82L451.98 159.21L452.11 158.82L451.6 158.24L451.72 157.86H452L452.19 158.11L452.32 157.92L452.13 157.79L452.06 156.96L452.45 157.09L452.57 157.6L452.38 157.92L452.57 157.99L452.77 157.79L453.09 158.05V158.37L453.6 158.18V158L453.35 158.07L453.15 157.94L453.41 157.68L453.15 157.3H453.47L453.6 157.75H454L454.45 158.13L454.26 157.49V157.62L454.06 157.42L454.19 157.17L454.45 157.3L454.64 157.68L455.03 157.62L455.22 157.04L455.67 157.23L455.8 157.49H456.12L455.86 157.1L456.05 156.91L456.31 157.04L457.02 156.85L457.47 156.97L458.11 156.72L458.37 156.91L459.01 156.65L458.69 156.33L459.14 156.4L459.39 156.85L459.52 155.75L459.72 155.56L459.52 155.24L459.65 154.98L459.46 154.66L459.72 154.15L459.52 153.96L459.72 153.63L459.46 153.44L459.39 153.18L459.65 152.86L459.72 152.41L459.46 152.22L459.39 151.96L459.72 151.51L459.78 151L459.46 150.68V150.36L459.84 150.1L459.72 149.91L459.78 149.65L459.46 149.14L459.72 148.75L459.84 148.17L459.65 147.72L459.84 147.4V146.89L459.65 146.57L459.84 146.18L459.72 145.73V144.6L459.59 144.47L459.72 144.15L459.59 143.83L459.84 143.51L459.52 143.38V143.06L459.84 142.74V142.29L459.46 142.03L459.52 141.58L459.65 141.45L459.91 141.52L459.97 141.39L459.78 141L459.84 140.75L459.52 140.36L459.65 140.17L459.91 140.1L459.97 139.85H459.65L459.52 139.01L459.65 138.75L459.91 138.82L460.04 138.69L459.84 138.5L459.59 138.69L459.52 137.6L459.39 137.34L459.59 136.89L459.84 136.96L460.1 136.83H460.55L460.74 136.96L460.87 136.83L460.36 136.51L459.65 136.76L459.52 136.38L459.65 136.19L460.1 136.12L460.04 135.86L459.84 135.74L459.46 136.06L459.14 135.8L459.2 135.48L459.46 135.41L459.59 135.16L459.26 134.96L459.59 134.71L459.14 134.58L459.07 134.39L459.52 133.87L459.33 133.81L459.01 134.07L458.82 133.49L459.01 133.17L458.69 133.04L458.49 132.14L459.01 131.88L458.24 131.95L458.17 131.5L458.49 131.24L458.05 130.98L457.98 131.17L457.72 131.24V130.72L457.85 130.47L457.59 130.53L457.27 130.08L457.34 129.76L457.08 129.7L456.95 129.5V129.18L456.85 129.05ZM447.6 141.77L447.48 141.71V141.9L447.6 141.77ZM447.67 142.22L447.6 142.03L447.48 142.16L447.67 142.22ZM447.67 143.51L447.48 143.44V143.57L447.67 143.51ZM447.8 153.79L447.92 153.59L447.73 153.34L447.6 153.79H447.8ZM448.12 145.56L448.25 145.44L448.05 145.37L447.86 145.5L448.12 145.56ZM448.05 141.07L447.92 141V141.07H448.05ZM447.92 142.54L448.12 142.42H447.92V142.54ZM447.92 146.91L448.18 146.78H447.92V146.91ZM448.12 149.61L448.31 149.8L448.5 149.74L448.37 149.55L447.92 149.42V149.55L448.12 149.61ZM448.18 153.21L448.25 152.95L447.92 153.08L448.18 153.21ZM448.18 148.97H448L448.06 149.16L448.18 148.97ZM448.25 153.85L448.5 153.92L448.44 153.66H448.18L448.25 153.85ZM448.37 155.33L448.57 155.14L448.37 155.07L448.18 155.2L448.37 155.33ZM448.25 156.48L448.37 156.68L448.63 156.42L448.95 156.36L448.7 156.23L448.5 156.42L448.25 156.48ZM448.44 147.17L448.7 147.04L448.57 146.91H448.31L448.44 147.17ZM448.5 142.17L448.7 141.59L448.37 141.78L448.5 142.17ZM448.76 139.54L448.63 139.41V139.54H448.76ZM449.02 152.19L448.76 152.13V152.32L449.02 152.19ZM448.82 155.98L448.89 155.79L448.76 155.85L448.82 155.98ZM449.27 136.98L449.21 136.78L449.02 136.91L449.08 137.17L449.27 136.98ZM449.27 150.47L449.21 150.72L449.08 150.47H449.27ZM449.15 134.21H449.34L449.15 134.15V134.21ZM449.4 146.68L449.27 146.74L449.21 146.55L449.4 146.68ZM449.4 142.56V142.82L449.27 142.95V142.56H449.4ZM449.4 145.13V145.26H449.27V145.13H449.4ZM449.47 139.87V140H449.34V139.81L449.47 139.87ZM449.92 132.09L449.79 131.97V132.09H449.92ZM449.98 160.17V159.91H449.85V160.23L449.98 160.17ZM450.43 159.78L450.49 159.65H450.24L450.43 159.78ZM451.07 159.78L451.52 159.85L451.46 159.4L451.07 159.33V159.78ZM451.65 157.53L451.46 157.85L451.14 157.47L451.27 157.21L451.59 157.28L451.65 157.53ZM452.29 158.17L452.23 158.43L453 158.95L452.94 158.56L452.68 158.43L452.29 158.17ZM452.74 160.81V160.62L452.94 160.55L453.06 160.74L452.74 160.81ZM453.51 159.81L453.58 159.36L453.13 159.16L453.19 159.74L453.51 159.81ZM453.96 159.03L454.09 158.84L453.96 158.58L453.71 158.52L453.96 159.03ZM453.77 160.38L454.03 160.26L454.09 160.06L454 160L453.75 160.13L453.77 160.38ZM454.29 159.48L454.54 159.55V159.29L454.35 159.16L454.22 159.23L454.29 159.48ZM454.48 158.13L454.29 158.2L454.41 158.33L454.48 158.13ZM454.93 160.06L455.06 160.13L455.18 160L455.06 159.81L454.61 159.93L454.93 160.06ZM455.5 158.2L455.63 158.07L455.44 157.94L455.25 158.13L455.5 158.2ZM455.5 159.36L455.44 159.29V159.36H455.5ZM455.76 160.06H456L456.13 159.87L455.87 159.81L455.61 159.93L455.76 160.06ZM456.66 125.31L456.53 125.44L456.6 125.57L456.66 125.31ZM456.85 160.06L457.11 159.87H456.66L456.85 160.06ZM456.98 157.36H457.18L457.24 157.24L456.85 157.17L456.98 157.36ZM457.98 159.87L457.78 159.81L457.65 159.93L457.98 159.87ZM458.17 128.71L458.04 128.65V128.71H458.17ZM458.23 129.87L458.3 129.74L458.17 129.81L458.23 129.87ZM458.75 126.66V126.46H458.55L458.62 126.66H458.75ZM458.75 130.66L458.88 130.54H458.68L458.55 130.73L458.75 130.66ZM458.81 129.25L459.07 129.06L458.88 128.93L458.75 129.12L458.81 129.25ZM459 160.02L459.13 159.83L458.81 159.7L458.75 159.96L459 160.02ZM459.2 128.54H459V128.67L459.2 128.54ZM459.39 129.96L459.52 129.77H459.26L459.13 129.96H459.39ZM459.39 132.72L459.26 132.59L459.2 132.78L459.39 132.72ZM459.39 127.26L459.84 127.2L459.52 126.94L459.32 127.13L459.39 127.26ZM459.52 128.54L459.71 128.48L459.52 128.29L459.32 128.48L459.52 128.54ZM459.32 133.36L460.03 133.23L459.71 133.11L459.32 133.36ZM459.52 131.24V131.05L459.45 131.24H459.52ZM459.9 127.77L459.65 127.71L459.58 127.9L459.9 127.77ZM459.71 129.25L459.58 129.12V129.25H459.71ZM459.97 131.95V131.76L459.71 131.89L459.97 131.95ZM459.9 134.71H460.16L460.03 134.45H459.84L459.71 134.65L459.9 134.71ZM459.97 137.47H460.16L460.03 137.22L459.84 137.15L459.78 137.41L459.97 137.47ZM459.97 139.53V139.4H459.78L459.97 139.53ZM460.61 128.16L459.97 128.61H460.55L460.8 128.35L460.61 128.16ZM460.1 129.16L460.16 129.03H459.97L460.1 129.16ZM460.16 135.39H460.35L460.48 135.2H460.16L459.97 135.33L460.16 135.39ZM460.16 129.87L460 130L460.26 130.13L460.64 129.81L460.32 129.74L460.16 129.87ZM460.35 134.17L460.67 133.92L460.48 133.72L460.29 133.79L460.03 134.17H460.35ZM460.42 141.95L460.22 141.88L460.16 142.01L460.42 141.95ZM460.42 132.76L460.61 132.57L460.55 132.44H460.29L460.22 132.7L460.42 132.76ZM460.55 138.09L460.48 137.84L460.22 137.9V138.16L460.42 138.35L460.55 138.09ZM460.42 139.51L460.48 139.25L460.29 139.18L460.22 139.44L460.42 139.51ZM460.74 131.86L460.29 132.12H461L461.19 131.73L461 131.67L460.74 131.86ZM460.61 136.04H460.29L460.55 136.17H461L461.12 135.97L461.06 135.72L460.87 135.65L460.61 136.04ZM460.55 131.35L460.61 131.15L460.42 131.09L460.35 131.28L460.55 131.35ZM460.35 133.35L460.55 133.48L461.19 133.29V133.1L461 133L460.55 133.25L460.35 133.35ZM460.93 130.72L461.12 130.33H460.87L460.74 130.78L460.93 130.72ZM460.87 138.72L461 138.53L460.74 138.66L460.87 138.72ZM461.06 134.72L461.25 134.66L461.12 134.34L460.8 134.72H461.06ZM460.93 137.48L461.06 137.36L461 137.23L460.8 137.29L460.93 137.48ZM460.87 139.93L461 139.99L460.93 139.86L460.87 139.93ZM461.32 134.14L461.77 134.08L461.57 133.69L461.32 133.76L461.12 134.14H461.32ZM461.32 136.78L461.96 136.84V136.71L461.51 136.46L461.19 136.58L461.32 136.78ZM461.51 139.35L461.32 139.22L461.19 139.35H461.51ZM461.25 135.11V135.3L461.83 135.49L462.02 135.3L461.51 134.98L461.25 135.11ZM461.25 137.81V138L461.45 138.13L461.57 137.93L461.51 137.74L461.25 137.81ZM461.45 131.96L461.32 132.09L461.51 132.15L461.96 131.96H462.34L462.22 131.7L462.02 131.64L461.64 131.9L461.45 131.96ZM461.51 136.01L461.32 136.14L461.51 136.2L462.09 136.07L462.15 135.81L461.77 135.75L461.51 136.01ZM461.7 132.6L461.51 132.47L461.38 132.6H461.7ZM462.09 133.05L461.64 133.18L461.57 133.37H462.09L462.22 133.18L462.09 133.05ZM461.77 137.23L461.7 137.48H461.96L462.09 137.36L462.02 137.1L461.77 137.23ZM461.9 134.4L461.77 134.66H462.28L462.15 134.34L461.9 134.4ZM462.09 138.64L461.96 138.38L461.77 138.51L461.83 138.7L462.09 138.64ZM462.02 141.21L461.83 141.08L461.77 141.27L462.02 141.21ZM462.41 141.98V141.79L462.15 141.98H462.41ZM462.41 138.06L462.6 138L462.41 137.81L462.22 137.93L462.41 138.06ZM462.41 139.35H462.67L462.47 139.03L462.22 139.28L462.41 139.35ZM462.47 136.2L462.6 136.01H462.28L462.47 136.2ZM462.28 140.63L462.41 140.7V140.44L462.28 140.57V140.63ZM462.67 151.42L462.86 151.36L462.6 151.3L462.67 151.42ZM462.92 138.7L463.05 138.45L462.86 138.32L462.67 138.45V138.7H462.92ZM462.92 139.7H462.73L462.67 139.9L462.92 139.7ZM462.79 148.25L462.92 148.05L462.67 148.18L462.79 148.25ZM462.99 141.31L463.05 141.18L462.79 141.12L462.99 141.31ZM462.79 142.59L462.99 142.66V142.53L462.79 142.59ZM463.31 147.99L463.18 147.86L463.05 147.99H463.31ZM463.24 149.27L463.31 149.15L463.05 149.21L463.24 149.27ZM463.31 153.27H463V153.46L463.31 153.27ZM463.31 147.42H463.12L463.18 147.61L463.31 147.42ZM463.63 143.05H463.5L463.57 142.86L463.63 143.05Z",
                fill: "#0067A5"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-illustrations-virtual-f4c8d3dc38/1/packages/lib-illustrations/src/error-400.tsx
/* eslint-disable max-len */ 

const Error400 = (param)=>{
    let { size =200  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        fill: "none",
        height: size,
        viewBox: "0 0 539 620",
        width: size,
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M408.659 103.222c-164.959 0-224.359 298.467-300.544 298.467-49.54 0-89.711 41.637-89.711 93.011 0 49.378 37.074 89.711 83.966 92.807 1.874.408 3.83.489 5.745.204 19.922 0 38.296-6.722 53.166-18.089 110.897-58.952 174.371-228.637 247.378-228.637 63.311 0 114.645-53.207 114.645-118.881S471.97 103.222 408.659 103.222Z",
                fill: "#8FDBC7"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M215.996 232.778c12.623 0 22.856-10.598 22.856-23.671 0-13.072-10.233-23.67-22.856-23.67-12.622 0-22.855 10.598-22.855 23.67 0 13.073 10.233 23.671 22.855 23.671Z",
                fill: "#00416A"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M215.548 251.804c23.063 0 41.759-19.39 41.759-43.308s-18.696-43.307-41.759-43.307-41.759 19.389-41.759 43.307c0 23.918 18.696 43.308 41.759 43.308ZM144.415 208.496c0-35.648 24.363-65.348 56.792-72.233a69.333 69.333 0 0 1 14.341-1.507",
                stroke: "#0A3A5C",
                strokeWidth: 1.6,
                strokeMiterlimit: 10,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M108.237 605.596c-59.074 0-106.985-49.663-106.985-110.896 0-20.656 5.46-40.007 14.952-56.589M519.23 154.393c11.326 19.84 17.844 42.981 17.844 67.67 0 47.83-24.322 89.752-60.867 113.178",
                stroke: "#0A3A5C",
                strokeWidth: 2,
                strokeMiterlimit: 10,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M134.963 276.737c3.219 5.907 9.207 11.285 15.563 13.893 1.711 5.296-4.645 4.522-8.596 3.666-3.545-.733-12.223-11-9.493-17.477.489-1.06 1.956-1.1 2.526-.082Z",
                fill: "#FFB784"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M141.93 294.296c-3.545-.733-12.223-11-9.493-17.478",
                stroke: "#0A3A5C",
                strokeWidth: 1.6,
                strokeMiterlimit: 10,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M142.052 296.211c3.381-1.426 1.059-2.404 8.474-5.581 1.589 3.748 9.33 5.174 11.815 6.966 3.503 6.315 0 14.993-3.585 16.5-6.641 2.486-13.282.693-18.945.489-7.333-.285-8.596-13.729 2.241-18.374Z",
                fill: "#FFB784"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M157.533 314.585c-5.907 2.485-12.059.245-17.722 0",
                stroke: "#0A3A5C",
                strokeWidth: 1.6,
                strokeMiterlimit: 10,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "m141.604 296.252-16.011-1.263.488-6.274 16.012 1.263c1.751.122 3.014 1.629 2.892 3.381-.122 1.711-1.629 3.015-3.381 2.893Z",
                fill: "#FFB784"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "m129.341 295.193 13.77 1.059c1.752.122 3.015 1.629 2.893 3.381-.123 1.752-1.63 3.015-3.382 2.893l-11.285-.896a3.006 3.006 0 0 1-2.77-3.219l.203-2.77c.082-.245.326-.448.571-.448Z",
                fill: "#FFB784"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "m142.133 308.637-8.27-.652c-1.752-.122-3.015-1.629-2.893-3.381.123-1.752 1.63-3.015 3.382-2.893l8.27.652c1.752.122 3.015 1.63 2.893 3.381a3.172 3.172 0 0 1-3.382 2.893Z",
                fill: "#FFB784"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "m143.111 314.83-7.659-.612c-1.752-.122-3.015-1.629-2.893-3.381.122-1.752 1.63-3.015 3.382-2.893l7.659.611c1.752.123 3.015 1.63 2.893 3.382-.123 1.711-1.671 3.015-3.382 2.893Z",
                fill: "#FFB784"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M146.493 311.937c-.123 1.752-1.63 3.015-3.382 2.893l-7.659-.612c-1.752-.122-3.015-1.629-2.893-3.381M144.985 293.359c-.122 1.752-1.629 3.015-3.381 2.893l-16.011-1.263M95.811 502.237c21.756 37.767 23.182 90.607 48.237 116.885",
                stroke: "#0A3A5C",
                strokeWidth: 1.6,
                strokeMiterlimit: 10,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M415.544 200.43c47.004 0 85.108-38.104 85.108-85.108 0-47.003-38.104-85.107-85.108-85.107-47.003 0-85.107 38.104-85.107 85.107 0 47.004 38.104 85.108 85.107 85.108Z",
                fill: "#FFD330"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M470.422 218.356c15.616 0 28.274-12.659 28.274-28.275 0-15.615-12.658-28.274-28.274-28.274-15.615 0-28.274 12.659-28.274 28.274 0 15.616 12.659 28.275 28.274 28.275Z",
                fill: "#fff"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M470.422 214.118c13.276 0 24.037-10.761 24.037-24.037 0-13.275-10.761-24.037-24.037-24.037-13.275 0-24.037 10.762-24.037 24.037 0 13.276 10.762 24.037 24.037 24.037Z",
                fill: "#FFD330"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M442.678 370.685c.407-1.629-1.222-3.015-2.771-2.363-6.07 2.608-18.333 8.637-25.503 17.071-6.722 7.944-9.819 15.4-8.148 22.244.366 1.467 1.629 2.567 3.137 2.689 7.048.529 13.892-3.708 20.614-11.652 7.171-8.474 11.082-21.552 12.671-27.989Z",
                fill: "#04B485"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M408.211 383.559v204.885",
                stroke: "#008F69",
                strokeWidth: 1.6,
                strokeMiterlimit: 10
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M229.563 619.163h77.896v-14.707h-55.04c-8.149 0-22.856 3.707-22.856 14.707ZM273.278 219.822h-6.234c-4.481 0-17.477 16.541-18.863 26.441-5.622 2.322-22.937 34.752-23.181 45.874-13.322-5.459-39.641 5.459-49.093 5.459-9.451 0-12.751-1.018-17.396-2.363 1.467 6.03.204 17.03-3.341 21.797h73.578c8.922 0 11.896-4.36 14.748-10.226 2.852-5.867 34.711-64.248 34.711-64.248l-4.929-22.734Z",
                fill: "#0A3A5C"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M155.211 317.07h73.578c8.922 0 11.896-4.359 14.748-10.226 2.852-5.866 34.711-64.248 34.711-64.248",
                stroke: "#5995BE",
                strokeWidth: 1.6,
                strokeMiterlimit: 10,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M275.681 219.822c-4.644 5.134-15.562 29.863-15.562 29.863l34.059 5.704s12.792-25.87 19.474-35.567h-37.971Z",
                fill: "#0A3A5C"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M303.711 154.311c-1.833-9.126-11.855-16.093-23.996-16.093-11.489 0-16.989 3.178-19.759 7.986-2.852 3.137-4.523 6.926-4.523 11.081 0 1.996.408 3.911 1.141 5.745-1.018 6.314-2.933 10.714-1.141 17.07 1.386 4.848 4.645 15.93 1.752 24.974 21.43 12.63 47.708 1.793 62.456-8.352-8.922-12.874-13.689-34.263-15.93-42.411Z",
                fill: "#00416A"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M294.178 141.926c-4.034-2.363-9.045-3.748-14.422-3.748M311.004 178.959c-3.585-9.859-5.908-19.678-7.293-24.648M314.467 199.981a96.83 96.83 0 0 0 5.214-3.3c-1.629-2.322-3.096-4.929-4.44-7.659M266.311 140.541c-3.015 1.385-4.97 3.34-6.315 5.663-2.852 3.137-4.522 6.926-4.522 11.081 0 1.996.407 3.911 1.141 5.745-1.019 6.314-2.934 10.714-1.141 17.07 1.385 4.848 4.645 15.93 1.752 24.974 16.581 9.778 36.055 5.5 50.844-1.63",
                stroke: "#0A3A5C",
                strokeWidth: 1.6,
                strokeMiterlimit: 10,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M308.111 219.374c-6.478-7.415-6.478-25.381-6.478-28.885 0-8.108-20.655.122-20.655 6.6 0 6.355 1.018 13.892 1.629 22.285h25.504Z",
                fill: "#FFB784"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M280.978 197.089c0 6.355 1.018 13.892 1.629 22.285",
                stroke: "#0A3A5C",
                strokeWidth: 1.6,
                strokeMiterlimit: 10,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M327.259 219.822h-21.022c-.041.082-.122.122-.163.204-6.6 8.352-9.167 12.344-11.367 24.241h-27.663c2.241-11.897 4.767-15.889 11.367-24.241.041-.082.122-.122.163-.204h-5.296c-13.159 10.267-22.734 32.185-22.734 44.856 0 26.603 7.008 24.852 7.008 40.211v34.955h75.329c-2.933-10.551-5.988-21.837-5.988-29.537 0-11.855 4.481-34.955 6.6-45.059 2.118-10.063 17.477-45.426-6.234-45.426Z",
                fill: "#FFE24D"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "m222.357 198.725-11.036 2.545 1.409 6.113 11.036-2.545-1.409-6.113Z",
                fill: "#E5F0F6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "m215.477 200.293-4.169.961 1.41 6.114 4.168-.962-1.409-6.113Z",
                fill: "#7C7C7C"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "m214.556 200.523-3.255.751 1.409 6.114 3.256-.751-1.41-6.114Z",
                fill: "#7C7C7C"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "m216.001 206.678 5.042-1.163-1.41-6.113-5.042 1.163 1.41 6.113Z",
                fill: "#C6C6C6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "m225 223.774-.448.489-4.033.937-.652-.244-4.197-18.252 5.134-1.182L225 223.774Z",
                fill: "#E6E7E8"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "m225.163 223.122-1.059 1.263-1.345.285 2.2-2.566.204 1.018ZM224.674 220.963l-3.463 4.074-.692.163-.408-.163 4.319-5.093.244 1.019ZM224.185 218.804l-4.726 5.581-.244-1.018 4.726-5.582.244 1.019ZM223.696 216.604l-4.766 5.622-.204-1.019 4.726-5.622.244 1.019ZM223.167 214.444l-4.726 5.582-.204-1.019 4.726-5.581.204 1.018ZM222.678 212.285l-4.726 5.582-.245-1.019 4.726-5.581.245 1.018ZM222.189 210.126l-4.726 5.581-.244-1.018 4.725-5.582.245 1.019ZM221.7 207.967l-4.726 5.581-.244-1.018 4.726-5.582.244 1.019ZM221.17 205.807l-4.726 5.582-.203-1.019 3.952-4.685.896-.244.081.366ZM218.644 206.011l-2.688 3.219-.245-1.019 1.589-1.874 1.344-.326Z",
                fill: "#7C7C7C"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "m475.459 172.248-15.403 3.552 1.959 8.495 15.403-3.552-1.959-8.495Z",
                fill: "#E6E7E8"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "m465.888 174.452-5.836 1.346 1.959 8.495 5.836-1.346-1.959-8.495Z",
                fill: "#7C7C7C"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "m464.605 174.766-4.565 1.052 1.959 8.496 4.565-1.053-1.959-8.495Z",
                fill: "#7C7C7C"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "m466.578 183.322 7.027-1.621-1.959-8.495-7.027 1.62 1.959 8.496Z",
                fill: "#C6C6C6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "m479.1 207.152-.611.692-5.582 1.263-.937-.285-5.866-25.422 7.129-1.67 5.867 25.422Z",
                fill: "#E6E7E8"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "m479.344 206.256-1.466 1.711-1.874.448 3.014-3.585.326 1.426ZM478.652 203.2l-4.808 5.704-.937.203-.611-.163 6.03-7.129.326 1.385ZM477.959 200.226l-6.559 7.781-.326-1.426 6.559-7.781.326 1.426ZM477.267 197.17l-6.6 7.782-.286-1.385 6.56-7.782.326 1.385ZM476.574 194.156l-6.6 7.822-.285-1.426 6.559-7.782.326 1.386ZM475.881 191.141l-6.6 7.781-.325-1.385 6.6-7.781.325 1.385ZM475.189 188.126l-6.6 7.781-.326-1.385 6.6-7.781.326 1.385ZM474.496 185.111l-6.6 7.782-.326-1.386 6.6-7.781.326 1.385ZM473.804 182.096l-6.6 7.782-.326-1.385 5.541-6.56 1.262-.285.123.448ZM470.259 182.422l-3.748 4.441-.326-1.385 2.2-2.608 1.874-.448Z",
                fill: "#7C7C7C"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M228.789 209.678c.652 6.681 4.033 14.015 8.841 18.903-.489 5.541-6.03 2.323-9.33 0-2.933-2.077-6.885-14.911-1.833-19.8.814-.814 2.2-.285 2.322.897Z",
                fill: "#FFB784"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M228.3 228.541c-2.933-2.078-6.885-14.911-1.833-19.8",
                stroke: "#0A3A5C",
                strokeWidth: 1.6,
                strokeMiterlimit: 10,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "m234.696 234.122-18.903-9.9c-1.549-.815-2.119-2.689-1.345-4.237.815-1.548 2.689-2.118 4.237-1.344l18.904 9.9-2.893 5.581Z",
                fill: "#FFB784"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "m234.696 241.17-18.903-9.9c-1.549-.814-2.119-2.689-1.345-4.237.815-1.548 2.689-2.118 4.237-1.344l18.904 9.9-2.893 5.581Z",
                fill: "#FFB784"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "m234.696 248.178-18.903-9.9c-1.549-.815-2.119-2.689-1.345-4.237.815-1.548 2.689-2.119 4.237-1.345l18.904 9.9-2.893 5.582Z",
                fill: "#FFB784"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "m234.696 255.185-16.663-8.718c-1.548-.815-2.118-2.689-1.344-4.237.815-1.549 2.689-2.119 4.237-1.345l16.663 8.719-2.893 5.581Z",
                fill: "#FFB784"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M227.648 230.333c3.667 0 1.915-1.792 9.982-1.792 0 4.074 7.333 23.507 8.922 26.115h-15.319c-7.211-7.171-24.2-24.323-3.585-24.323Z",
                fill: "#FFB784"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M310.352 339.885h-51.863v264.571h51.863V339.885Z",
                fill: "#FFD330"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M258.489 604.456V339.885",
                stroke: "#0A3A5C",
                strokeWidth: 1.6,
                strokeMiterlimit: 10,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "m124.577 296.574 4.415 2.098 6.295-13.247-4.415-2.098-6.295 13.247Z",
                fill: "#80B3D2",
                stroke: "#0A3A5C",
                strokeWidth: 1.6,
                strokeMiterlimit: 10
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "m130.821 283.338-22.887-10.876-6.295 13.247 22.887 10.876 6.295-13.247Z",
                fill: "#E5F0F6",
                stroke: "#0A3A5C",
                strokeWidth: 1.6,
                strokeMiterlimit: 10
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "m138.701 287.082-3.459-1.644-1.644 3.459 3.459 1.643 1.644-3.458Z",
                fill: "#80B3D2",
                stroke: "#0A3A5C",
                strokeWidth: 1.6,
                strokeMiterlimit: 10
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "m138.711 287.044-30.759-14.585",
                stroke: "#0A3A5C",
                strokeWidth: 1.6,
                strokeMiterlimit: 10
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "m112.51 280.601-2.091 4.056 12.929 6.663 2.09-4.056-12.928-6.663Z",
                fill: "#C6C6C6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "m104.693 279.263-3.056 6.437 22.896 10.878 3.341-6.967",
                stroke: "#0A3A5C",
                strokeWidth: 1.6,
                strokeMiterlimit: 10
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M110.396 319.596h-25.34v14.667h25.34v-14.667Z",
                fill: "#E5F0F6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M110.415 246.242h4.889v-14.667h-4.889v14.667ZM110.415 260.909h4.889v-14.667h-4.889v14.667ZM110.415 275.575h4.889v-14.666h-4.889v14.666Z",
                fill: "#80B3D2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M110.396 260.93h-25.34v14.666h25.34V260.93ZM110.396 246.263h-25.34v14.667h25.34v-14.667ZM110.396 231.596h-25.34v14.667h25.34v-14.667ZM110.396 290.263h-25.34v14.667h25.34v-14.667ZM110.396 304.93h-25.34v14.666h25.34V304.93ZM110.396 334.263h-25.34v14.667h25.34v-14.667ZM110.396 348.93h-25.34v14.666h25.34V348.93Z",
                fill: "#E5F0F6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M110.415 304.909h4.889v-14.667h-4.889v14.667ZM110.415 319.575h4.889v-14.666h-4.889v14.666ZM110.415 334.242h4.889v-14.667h-4.889v14.667ZM110.415 348.909h4.889v-14.667h-4.889v14.667ZM110.415 363.575h4.889v-14.666h-4.889v14.666ZM119.115 231.596h-3.83v3.83h3.83v-3.83ZM119.115 246.263h-3.83v3.83h3.83v-3.83ZM119.115 260.93h-3.83v3.829h3.83v-3.829Z",
                fill: "#80B3D2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M119.115 290.263h-3.83v3.83h3.83v-3.83ZM119.115 304.93h-3.83v3.829h3.83v-3.829ZM119.115 319.596h-3.83v3.83h3.83v-3.83ZM119.115 334.263h-3.83v3.83h3.83v-3.83ZM119.115 348.93h-3.83v3.829h3.83v-3.829Z",
                fill: "#80B3D2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "m102.37 352.759-3.503 8.148M89.13 353.004l4.563 7.618M104.041 356.263l1.711 4.644M97.726 353.167l-4.033 2.852",
                stroke: "#636363",
                strokeWidth: 1.6,
                strokeMiterlimit: 10
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M100.456 346.444a1.955 1.955 0 1 0 0-3.91 1.955 1.955 0 0 0 0 3.91ZM93.937 346.444a1.955 1.955 0 1 0 .001-3.91 1.955 1.955 0 0 0-.001 3.91ZM96.993 341.148a1.955 1.955 0 1 0 0-3.91 1.955 1.955 0 0 0 0 3.91ZM104.326 341.148a1.955 1.955 0 1 0 0-3.91 1.955 1.955 0 0 0 0 3.91ZM90.067 341.148a1.955 1.955 0 1 0 0-3.91 1.955 1.955 0 0 0 0 3.91Z",
                fill: "#C6C6C6",
                stroke: "#636363",
                strokeWidth: 1.6,
                strokeMiterlimit: 10
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M88.519 322.856h17.64M89.089 325.585h17.844M87.826 328.274h17.641M89.781 330.963h17.886",
                stroke: "#00416A",
                strokeWidth: 1.6,
                strokeMiterlimit: 10
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "m101.651 309.163-1.68.325 1.262 6.52 1.68-.325-1.262-6.52Z",
                fill: "#AEAEAE"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "m103.753 315.559-3.36.651.379 1.96 3.36-.651-.379-1.96Z",
                fill: "#7C7C7C"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "m96.525 316.153 1.707-.123-.478-6.623-1.706.123.477 6.623Z",
                fill: "#AEAEAE"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "m95.209 309.582 3.413-.246-.144-1.991-3.413.246.144 1.991Z",
                fill: "#7C7C7C"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "m92.5 309.402-1.657.43 1.668 6.427 1.657-.43-1.669-6.427Z",
                fill: "#AEAEAE"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "m94.973 315.637-3.313.86.502 1.932 3.312-.859-.501-1.933Z",
                fill: "#7C7C7C"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "m88.152 315.478 1.707-.123-.477-6.623-1.707.123.477 6.623Z",
                fill: "#AEAEAE"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "m86.795 308.91 3.413-.246-.143-1.992-3.413.246.143 1.992Z",
                fill: "#7C7C7C"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "m105.593 316.214 1.707-.123-.478-6.623-1.706.123.477 6.623Z",
                fill: "#AEAEAE"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "m104.277 309.643 3.413-.246-.144-1.991-3.413.246.144 1.991ZM107.83 292.667h-1.589v9.533h1.589v-9.533Z",
                fill: "#7C7C7C"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M104.122 292.667h-1.589v9.533h1.589v-9.533Z",
                fill: "#C6C6C6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M100.415 292.667h-1.59v9.533h1.59v-9.533Z",
                fill: "#7C7C7C"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M96.707 292.667H95.12v9.533h1.588v-9.533Z",
                fill: "#C6C6C6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M93 292.667h-1.589v9.533H93v-9.533Z",
                fill: "#7C7C7C"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M89.293 292.667h-1.59v9.533h1.59v-9.533Z",
                fill: "#C6C6C6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M91.86 264.148h-2.242l-1.14 1.956 1.14 1.915h2.241l1.1-1.915-1.1-1.956Z",
                fill: "#5995BE",
                stroke: "#4A4A4A",
                strokeWidth: 1.6,
                strokeMiterlimit: 10
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M90.678 269.648h-2.241l-1.14 1.915 1.14 1.956h2.24l1.1-1.956-1.1-1.915Z",
                fill: "#7C7C7C",
                stroke: "#4A4A4A",
                strokeWidth: 1.6,
                strokeMiterlimit: 10
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M97.644 263.089h-2.24l-1.1 1.955 1.1 1.915h2.24l1.141-1.915-1.14-1.955Z",
                fill: "#5995BE",
                stroke: "#4A4A4A",
                strokeWidth: 1.6,
                strokeMiterlimit: 10
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M101.596 267h-2.24l-1.141 1.956 1.14 1.914h2.241l1.1-1.914-1.1-1.956Z",
                fill: "#7C7C7C",
                stroke: "#4A4A4A",
                strokeWidth: 1.6,
                strokeMiterlimit: 10
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M106.281 270.137h-2.24l-1.141 1.956 1.141 1.914h2.24l1.1-1.914-1.1-1.956Z",
                fill: "#5995BE",
                stroke: "#4A4A4A",
                strokeWidth: 1.6,
                strokeMiterlimit: 10
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M105.507 263.089h-2.24l-1.141 1.955 1.141 1.915h2.24l1.1-1.915-1.1-1.955Z",
                fill: "#7C7C7C",
                stroke: "#4A4A4A",
                strokeWidth: 1.6,
                strokeMiterlimit: 10
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M96.504 268.548h-2.241l-1.14 1.956 1.14 1.955h2.24l1.1-1.955-1.1-1.956Z",
                fill: "#5995BE",
                stroke: "#4A4A4A",
                strokeWidth: 1.6,
                strokeMiterlimit: 10
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "m90.515 253.841 1.1 1.915 1.14 1.955h-4.48l1.1-1.955 1.14-1.915Z",
                fill: "#959595",
                stroke: "#4A4A4A",
                strokeWidth: 1.6,
                strokeMiterlimit: 10
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "m93.733 253.963-1.14-1.956-1.1-1.914h4.481l-1.14 1.914-1.1 1.956Z",
                fill: "#80B3D2",
                stroke: "#4A4A4A",
                strokeWidth: 1.6,
                strokeMiterlimit: 10
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "m98.052 253.841 1.1 1.915 1.141 1.955h-4.481l1.1-1.955 1.14-1.915ZM101.27 253.963l-1.14-1.956-1.1-1.914h4.481l-1.141 1.914-1.1 1.956Z",
                fill: "#959595",
                stroke: "#4A4A4A",
                strokeWidth: 1.6,
                strokeMiterlimit: 10
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "m105.589 253.841 1.141 1.915 1.1 1.955h-4.482l1.141-1.955 1.1-1.915Z",
                fill: "#80B3D2",
                stroke: "#4A4A4A",
                strokeWidth: 1.6,
                strokeMiterlimit: 10
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M91.493 242.881a3.748 3.748 0 1 0 0-7.496 3.748 3.748 0 0 0 0 7.496Z",
                fill: "#fff",
                stroke: "#636363",
                strokeWidth: 1.6,
                strokeMiterlimit: 10
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M95.811 242.881a3.748 3.748 0 1 0 0-7.496 3.748 3.748 0 0 0 0 7.496Z",
                fill: "#80B3D2",
                stroke: "#636363",
                strokeWidth: 1.6,
                strokeMiterlimit: 10
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M100.17 242.881a3.749 3.749 0 1 0 0-7.498 3.749 3.749 0 0 0 0 7.498Z",
                fill: "#fff",
                stroke: "#636363",
                strokeWidth: 1.6,
                strokeMiterlimit: 10
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M104.489 242.881a3.748 3.748 0 1 0 0-7.496 3.748 3.748 0 0 0 0 7.496Z",
                fill: "#AEAEAE",
                stroke: "#636363",
                strokeWidth: 1.6,
                strokeMiterlimit: 10
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M110.396 238.93v7.333M110.396 253.596v7.334M110.396 268.263v7.333h-25.34v-7.333M110.396 297.596v7.334M110.396 312.263v7.333M110.396 326.93v7.333M110.396 341.596v7.334M119.115 290.263h-34.06v-7.333M119.115 260.93h-34.06v-7.334M119.115 231.596h-34.06M85.056 356.263v7.333h25.34v-7.333M119.115 246.263h-34.06v-7.333M119.115 304.93h-34.06v-7.334M119.115 319.596h-34.06v-7.333",
                stroke: "#0A3A5C",
                strokeWidth: 1.6,
                strokeMiterlimit: 10
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M119.115 334.263h-34.06v-7.333",
                stroke: "#00416A",
                strokeWidth: 1.6,
                strokeMiterlimit: 10
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M119.115 348.93h-34.06v-7.334",
                stroke: "#0A3A5C",
                strokeWidth: 1.6,
                strokeMiterlimit: 10
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "m109.163 276.501-4.031 7.823 4.309 2.221 4.032-7.823-4.31-2.221Z",
                fill: "#7C7C7C"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M162.952 362.863H141.4a.818.818 0 0 1-.815-.815v-23.181c0-.449.367-.815.815-.815h21.552c.448 0 .815.366.815.815v23.181a.818.818 0 0 1-.815.815Z",
                fill: "#3FA9F5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M146.656 362.863h-5.215a.818.818 0 0 1-.815-.815v-23.141c0-.448.367-.814.815-.814h5.255v24.77h-.04Z",
                fill: "#00416A"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M162.952 362.863H141.4a.818.818 0 0 1-.815-.815v-.367h23.182v.367a.818.818 0 0 1-.815.815Z",
                fill: "#0A3A5C"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M141.4 338.093h21.552c.448 0 .815.366.815.814v.367h-23.182v-.367c0-.448.367-.814.815-.814ZM169.959 341.189h-6.192v3.055h4.563a3.139 3.139 0 0 1 3.137 3.137v6.193a3.138 3.138 0 0 1-3.137 3.137h-4.563v3.056h6.192a4.555 4.555 0 0 0 4.563-4.563v-9.452c0-2.526-2.078-4.563-4.563-4.563Z",
                fill: "#FFD330"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M169.959 359.4h-6.192v.367h6.192a4.555 4.555 0 0 0 4.563-4.563v-.367c0 2.526-2.078 4.563-4.563 4.563ZM171.467 347.381v-.366a3.138 3.138 0 0 0-3.137-3.137h-4.563v.366h4.563c1.711-.04 3.137 1.386 3.137 3.137Z",
                fill: "#D6B200"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M143.03 347.87c0-.04.04-.081.081-.081h2.078c1.141 0 1.67.53 1.67 1.344 0 .53-.244.897-.611 1.1.367.123.693.571.693 1.141 0 .978-.693 1.467-1.752 1.467h-2.037a.088.088 0 0 1-.082-.082v-4.889h-.04Zm1.914 1.956c.408 0 .612-.163.612-.53 0-.366-.204-.529-.612-.529h-.529c-.041 0-.041 0-.041.04v.937c0 .041 0 .041.041.041h.529v.041Zm-.529 2.037h.611c.407 0 .611-.204.611-.57 0-.367-.204-.571-.611-.571h-.611c-.041 0-.041 0-.041.041v1.059c0 .041 0 .041.041.041ZM148.652 352.881c-.041 0-.082-.04-.082-.081v-1.874l-1.548-3.015c0-.041 0-.081.041-.081h1.181c.041 0 .082.04.123.081l.855 1.711h.041l.856-1.711c.04-.041.081-.081.122-.081h1.14c.041 0 .082.04.041.081l-1.548 3.015v1.874c0 .041-.041.081-.081.081h-1.141ZM151.87 347.87c0-.04.041-.081.082-.081h1.181c.041 0 .082.041.082.081v1.997l1.466-1.997c.041-.04.082-.081.123-.081h1.303c.041 0 .082.041.041.081l-1.507 1.956 1.589 2.933c.04.041 0 .082-.041.082h-1.345c-.081 0-.081-.041-.122-.082l-.978-1.915-.529.734v1.181a.088.088 0 0 1-.082.082h-1.181a.088.088 0 0 1-.082-.082v-4.889ZM156.515 351.7c-.122-.407-.163-.693-.163-1.385 0-.693.041-.978.163-1.385.285-.815 1.018-1.263 1.915-1.263.896 0 1.629.407 1.914 1.263.123.407.163.692.163 1.385 0 .692-.04.978-.163 1.385-.285.815-1.018 1.263-1.914 1.263-.897 0-1.63-.407-1.915-1.263Zm2.566-.367c.041-.163.082-.407.082-1.018s0-.856-.082-1.019c-.081-.285-.325-.448-.651-.448s-.571.163-.652.448c-.041.163-.082.408-.082 1.019s0 .855.082 1.018c.081.286.326.448.652.448s.57-.162.651-.448Z",
                fill: "#0A3A5C"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M143.437 347.463c0-.041.041-.082.082-.082h2.077c1.141 0 1.671.53 1.671 1.345 0 .53-.245.896-.611 1.1.366.122.692.57.692 1.141 0 .977-.692 1.466-1.752 1.466h-2.037c-.04 0-.081-.04-.081-.081v-4.889h-.041Zm1.915 1.955c.407 0 .611-.162.611-.529s-.204-.53-.611-.53h-.53c-.041 0-.041 0-.041.041v.937c0 .041 0 .041.041.041h.53v.04Zm-.53 2.038h.611c.408 0 .611-.204.611-.571s-.203-.57-.611-.57h-.611c-.041 0-.041 0-.041.041v1.059c0 .041 0 .041.041.041ZM149.059 352.474c-.04 0-.081-.041-.081-.081v-1.874l-1.548-3.015c0-.041 0-.082.04-.082h1.182c.041 0 .081.041.122.082l.856 1.711h.04l.856-1.711c.041-.041.081-.082.122-.082h1.141c.041 0 .081.041.041.082l-1.549 3.015v1.874c0 .04-.04.081-.081.081h-1.141ZM152.278 347.463c0-.041.041-.082.081-.082h1.182c.04 0 .081.041.081.082v1.996l1.467-1.996c.041-.041.081-.082.122-.082h1.304c.041 0 .081.041.041.082l-1.508 1.955 1.589 2.934c.041.041 0 .081-.041.081h-1.344c-.082 0-.082-.04-.122-.081l-.978-1.915-.53.733v1.182c0 .041-.041.081-.081.081h-1.182c-.04 0-.081-.04-.081-.081v-4.889ZM156.922 351.293c-.122-.408-.163-.693-.163-1.386 0-.692.041-.977.163-1.385.285-.815 1.019-1.263 1.915-1.263.896 0 1.63.408 1.915 1.263.122.408.163.693.163 1.385 0 .693-.041.978-.163 1.386-.285.814-1.019 1.263-1.915 1.263-.896 0-1.63-.408-1.915-1.263Zm2.567-.367c.041-.163.081-.407.081-1.019 0-.611 0-.855-.081-1.018-.082-.285-.326-.448-.652-.448s-.57.163-.652.448c-.041.163-.081.407-.081 1.018 0 .612 0 .856.081 1.019.082.285.326.448.652.448s.57-.163.652-.448Z",
                fill: "#FFD330"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M332.841 339.885h-56.263v264.571h51.863V410.489c0-15.156 10.022-33.326 10.022-46.363-.041-4.808-2.811-14.178-5.622-24.241Z",
                fill: "#FFE24D"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "m227.078 230.048-11.326-5.826c-1.548-.815-2.119-2.689-1.345-4.237M226.467 236.526l-10.674-5.296c-1.549-.815-2.119-2.689-1.345-4.237M226.874 244.226l-11.081-5.989c-1.549-.815-2.119-2.689-1.345-4.237M229.563 252.496l-11.489-6.029c-1.548-.815-2.118-2.689-1.344-4.237M220.111 219.374l15.074 7.904",
                stroke: "#0A3A5C",
                strokeWidth: 1.6,
                strokeMiterlimit: 10,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M308.315 189.022c-4.971 9.493-26.93 18.945-36.422 13.974-9.493-4.97-14.015-33.529-9.045-43.022 4.971-9.493 18.822 2.363 28.274 7.333 9.493 4.971 22.163 12.223 17.193 21.715Z",
                fill: "#FFB784"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M308.315 189.022c-4.971 9.493-26.93 18.945-36.422 13.974-9.493-4.97-14.015-33.529-9.045-43.022 4.971-9.493 18.822 2.363 28.274 7.333 9.493 4.971 22.163 12.223 17.193 21.715Z",
                stroke: "#0A3A5C",
                strokeWidth: 1.6,
                strokeMiterlimit: 10,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M269.285 179.896v11.448c0 .408.245.734.611.897l.611.244a.895.895 0 0 0 .652 0l3.504-1.304a.985.985 0 0 0 .57-1.222l-4.114-10.389a1.01 1.01 0 0 0-.652-.57.929.929 0 0 0-1.182.896ZM277.23 181.037a1.63 1.63 0 1 0 0-3.259 1.63 1.63 0 0 0 0 3.259ZM265.496 182.626a1.63 1.63 0 1 0 0-3.26 1.63 1.63 0 0 0 0 3.26Z",
                fill: "#0A3A5C"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M276.904 195.174c.855-.53 3.666-1.833 5.011-1.956 1.344-.162 2.118.123 2.118.123",
                stroke: "#0A3A5C",
                strokeWidth: 1.6,
                strokeMiterlimit: 10,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M282.159 167.593c1.548 5.459 7.578 20.614 12.793 25.259 3.178-.571 8.23-2.2 11.407-4.074 3.178-1.874-.57-19.434-2.648-21.837-3.463-3.993-23.141-4.93-21.552.652Z",
                fill: "#00416A"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M293.974 180.793c1.304 4.318 3.748 13.688 8.148 17.355 2.689-.448 6.967-1.752 9.656-3.218 2.689-1.467-.489-15.36-2.241-17.234-2.893-3.137-16.907-1.303-15.563 3.097ZM281.304 145.022c5.255 3.097 7.74 12.915 7.211 19.352-5.419 8.596-28.967 14.993-38.704 8.759-3.911-6.518-4.196-13.933-3.3-20.207 6.437-11.856 27.704-12.1 34.793-7.904Z",
                fill: "#00416A"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M286.315 151.378c1.792 4.115 2.526 9.166 2.241 12.996-5.419 8.596-28.967 14.993-38.704 8.759-3.911-6.518-4.196-13.933-3.3-20.207 5.459-10.063 21.552-11.774 30.678-9.493",
                stroke: "#0A3A5C",
                strokeWidth: 1.6,
                strokeMiterlimit: 10,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M302.244 170.159c-1.507 0-2.851.897-3.788 2.363.04 3.708.896 7.782 3.34 11.285.163 0 .285.041.448.041 2.771 0 5.011-3.055 5.011-6.844s-2.24-6.845-5.011-6.845Z",
                fill: "#FFB784"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M298.578 169.507c-.448 4.849.244 11.082 4.44 15.889M282.893 169.507c2.729 8.678 6.6 18.456 12.059 23.345 2.73-.489 6.315-1.467 9.859-2.73",
                stroke: "#0A3A5C",
                strokeWidth: 1.6,
                strokeMiterlimit: 10,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M312.267 212.407h-38.745v7.415h38.745v-7.415Z",
                fill: "#5995BE"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M314.833 212.407h-41.311v7.415h41.311v-7.415Z",
                fill: "#5995BE"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M314.833 212.407h-41.311v7.415h41.311v-7.415Z",
                fill: "#FFD330"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M273.522 212.163v8.393",
                stroke: "#0A3A5C",
                strokeWidth: 1.6,
                strokeMiterlimit: 10,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M281.711 251.478c0-.041.041-.082.082-.082h2.077c1.141 0 1.671.53 1.671 1.345 0 .529-.245.896-.611 1.1.366.122.692.57.692 1.14 0 .978-.692 1.467-1.752 1.467h-2.037c-.04 0-.081-.041-.081-.081v-4.889h-.041Zm1.874 1.955c.408 0 .611-.163.611-.529 0-.367-.203-.53-.611-.53h-.529c-.041 0-.041 0-.041.041v.937c0 .041 0 .041.041.041h.529v.04Zm-.529 2.078h.611c.407 0 .611-.204.611-.57 0-.367-.204-.571-.611-.571h-.611c-.041 0-.041 0-.041.041v1.059l.041.041ZM287.293 256.489a.088.088 0 0 1-.082-.082v-1.874l-1.548-3.014c0-.041 0-.082.041-.082h1.181c.041 0 .082.041.122.082l.856 1.711h.041l.855-1.711c.041-.041.082-.082.122-.082h1.141c.041 0 .082.041.041.082l-1.548 3.014v1.874a.088.088 0 0 1-.082.082h-1.14ZM290.552 251.478c0-.041.041-.082.081-.082h1.182c.041 0 .081.041.081.082v1.996l1.467-1.996c.041-.041.081-.082.122-.082h1.304c.041 0 .081.041.041.082l-1.508 1.955 1.589 2.934c.041.04 0 .081-.041.081h-1.344c-.082 0-.082-.041-.122-.081l-.978-1.915-.53.733v1.182c0 .04-.04.081-.081.081h-1.182c-.04 0-.081-.041-.081-.081v-4.889ZM295.196 255.348c-.122-.407-.163-.692-.163-1.385 0-.693.041-.978.163-1.385.285-.815 1.019-1.263 1.915-1.263.896 0 1.63.407 1.915 1.263.122.407.163.692.163 1.385 0 .693-.041.978-.163 1.385-.285.815-1.019 1.263-1.915 1.263-.937-.041-1.67-.448-1.915-1.263Zm2.526-.407c.041-.163.082-.408.082-1.019s0-.855-.082-1.018c-.081-.285-.326-.448-.652-.448s-.57.163-.651.448c-.041.163-.082.407-.082 1.018s0 .856.082 1.019c.081.285.325.448.651.448.367 0 .571-.163.652-.448Z",
                fill: "#0A3A5C"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M280.896 251.478c0-.041.041-.082.082-.082h2.078c1.14 0 1.67.53 1.67 1.345 0 .529-.245.896-.611 1.1.366.122.692.57.692 1.14 0 .978-.692 1.467-1.751 1.467h-2.038c-.04 0-.081-.041-.081-.081v-4.889h-.041Zm1.874 1.955c.408 0 .611-.163.611-.529 0-.367-.203-.53-.611-.53h-.529c-.041 0-.041 0-.041.041v.937c0 .041 0 .041.041.041h.529v.04Zm-.529 2.078h.611c.407 0 .611-.204.611-.57 0-.367-.204-.571-.611-.571h-.611c-.041 0-.041 0-.041.041v1.059l.041.041ZM286.478 256.489a.088.088 0 0 1-.082-.082v-1.874l-1.548-3.014c0-.041 0-.082.041-.082h1.181c.041 0 .082.041.123.082l.855 1.711h.041l.855-1.711c.041-.041.082-.082.123-.082h1.14c.041 0 .082.041.041.082l-1.548 3.014v1.874c0 .041-.041.082-.081.082h-1.141ZM289.737 251.478c0-.041.041-.082.082-.082H291c.041 0 .081.041.081.082v1.996l1.467-1.996c.041-.041.082-.082.122-.082h1.304c.041 0 .082.041.041.082l-1.508 1.955 1.589 2.934c.041.04 0 .081-.04.081h-1.345c-.081 0-.081-.041-.122-.081l-.978-1.915-.53.733v1.182c0 .04-.04.081-.081.081h-1.181c-.041 0-.082-.041-.082-.081v-4.889ZM294.381 255.348c-.122-.407-.162-.692-.162-1.385 0-.693.04-.978.162-1.385.286-.815 1.019-1.263 1.915-1.263.897 0 1.63.407 1.915 1.263.122.407.163.692.163 1.385 0 .693-.041.978-.163 1.385-.285.815-1.018 1.263-1.915 1.263-.937-.041-1.67-.448-1.915-1.263Zm2.526-.407c.041-.163.082-.408.082-1.019s0-.855-.082-1.018c-.081-.285-.326-.448-.651-.448-.326 0-.571.163-.652.448-.041.163-.082.407-.082 1.018s0 .856.082 1.019c.081.285.326.448.652.448.366 0 .57-.163.651-.448Z",
                fill: "#00416A"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M329.093 401.77a3.253 3.253 0 0 1-2.404 1.1h-3.422c-.897 0-1.793-.366-2.404-1.059v-.041c-.57-.611-.856-1.426-.856-2.24l1.182-60.419h7.537l1.181 60.419c.041.855-.285 1.629-.814 2.24Z",
                fill: "#0A3A5C"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M332.963 323.344h-10.674a1.27 1.27 0 0 0-1.263 1.263h-.082a4.419 4.419 0 0 1-8.637-.774.57.57 0 0 0-.57-.489h-5.011a.557.557 0 0 0-.57.571v12.1c0 .326.244.57.57.57h5.011a.57.57 0 0 0 .57-.489c.245-2.2 2.119-3.952 4.4-3.952a4.411 4.411 0 0 1 4.319 3.545v3.463h7.863l1.222-4.808a7.783 7.783 0 0 1 7.252-4.929c4.196 0 7.578 3.3 7.781 7.415l1.589-.693c-.489-7.17-6.477-12.793-13.77-12.793Z",
                fill: "#00416A"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M304.2 327.663Z",
                stroke: "#0A3A5C",
                strokeWidth: 1.6,
                strokeMiterlimit: 10
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M250.544 619.163h77.897v-14.707H273.4c-8.148 0-22.856 3.707-22.856 14.707Z",
                fill: "#00416A"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M273.074 268.956c.407-9.412 3.137-19.108 5.296-24.689h-11.326c2.241-11.897 4.767-15.889 11.367-24.241.041-.082.122-.122.163-.204h-5.296c-13.159 10.267-22.734 32.185-22.734 44.856 0 26.603 7.008 24.852 7.008 40.211v34.955h19.026c0-11.081-4.685-44.977-3.504-70.888Z",
                fill: "#FFD330"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M273.278 219.822c-13.16 10.267-22.734 32.185-22.734 44.856 0 26.603 7.008 24.852 7.008 40.211v34.955",
                stroke: "#0A3A5C",
                strokeWidth: 1.6,
                strokeMiterlimit: 10,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M205.241 619.163V363.596H85.056v-144.67H33.64v93.948c0 69.952 19.474 111.182 67.629 159.296 48.156 48.197 26.604 146.993 103.971 146.993Z",
                fill: "#00416A"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M205.241 619.163V363.596H85.056V218.763",
                stroke: "#0A3A5C",
                strokeWidth: 1.6,
                strokeMiterlimit: 10,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M235.226 363.596H85.056v8.637h150.17v-8.637Z",
                fill: "#0A3A5C",
                stroke: "#0A3A5C",
                strokeWidth: 1.6,
                strokeMiterlimit: 10,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M297.437 339.681c4.93-1.303 8.556-5.785 8.556-11.122 0-2.281-.652-4.4-1.793-6.192a1.236 1.236 0 0 0-.204-.286l-4.766 6.763c-.611.897-1.752 1.304-2.771.978-1.955-.529-3.666-1.711-4.603-3.544-.449-.815-.326-1.834.203-2.608l4.563-6.477c-.611-.123-1.222-.163-1.833-.204h-.245c-6.355 0-11.488 5.174-11.488 11.489 0 4.929 3.096 9.126 7.455 10.755v42.615c-3.585 1.059-6.192 4.4-6.192 8.352 0 1.67.488 3.219 1.303 4.522l3.952-5.622a2.13 2.13 0 0 1 2.322-.815c1.589.448 3.056 1.426 3.83 2.933.367.693.285 1.508-.163 2.16l-3.83 5.418c.408.082.856.122 1.304.122 4.807 0 8.719-3.911 8.719-8.718 0-3.137-1.671-5.907-4.197-7.456l-.122-43.063Z",
                fill: "#00416A"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M291.815 388.367c1.589.448 3.055 1.426 3.829 2.933.367.693.286 1.507-.163 2.159l-3.829 5.419c.407.081.855.122 1.304.122 4.807 0 8.718-3.911 8.718-8.719 0-3.137-1.67-5.907-4.196-7.455v-43.145",
                stroke: "#80B3D2",
                strokeWidth: 1.6,
                strokeMiterlimit: 10,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M290.43 339.315v42.615c-3.586 1.059-6.193 4.4-6.193 8.351a8.51 8.51 0 0 0 1.304 4.523",
                stroke: "#0A3A5C",
                strokeWidth: 1.6,
                strokeMiterlimit: 10,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "m337.268 334.07-5.416 1.509 8.289 29.748 5.415-1.509-8.288-29.748Z",
                fill: "#5995BE"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M297.967 192.159c1.14 2.404 2.526 4.604 4.196 5.989 2.078-.367 5.133-1.222 7.659-2.281M278.9 212.163v8.393M284.278 212.163v8.393M289.656 216.115v4.441M295.074 216.115v4.441M300.452 216.115v4.441M305.83 216.115v4.441M311.248 216.115v4.441M273.522 219.822h41.311",
                stroke: "#0A3A5C",
                strokeWidth: 1.6,
                strokeMiterlimit: 10,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M328.441 219.822c-8.923 0-24.078 19.637-25.952 39.234-8.433 4.074-23.426 27.459-23.426 38.54 0-11.692-25.096-30.433-32.552-44h-16.989c13.811 24.893 26.034 79.282 44.082 79.282 13.403 0 19.27-15.156 27.785-24.363 8.922-9.656 35.241-42.574 41.759-49.093 6.559-6.478 8.8-39.6-14.707-39.6Z",
                fill: "#0A3A5C"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M229.563 253.596c13.811 24.893 26.033 79.282 44.081 79.282 13.404 0 19.271-15.156 27.786-24.363 8.922-9.656 35.24-42.574 41.759-49.093",
                stroke: "#5995BE",
                strokeWidth: 1.6,
                strokeMiterlimit: 10,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M387.637 332.307c-1.181-1.14-3.218-.448-3.422 1.182-1.059 7.904-2.771 26.522 2.2 40.659 4.441 12.671 10.715 20.941 19.433 23.548 1.874.571 3.911-.122 5.011-1.752 5.174-7.455 4.93-17.844.489-30.514-5.011-14.137-17.967-27.623-23.711-33.123Z",
                fill: "#008F69"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M361.889 390.933c-1.548-.611-3.137.774-2.73 2.404 1.997 7.741 7.415 25.626 17.356 36.87 8.881 10.063 17.803 15.36 26.848 14.504a4.555 4.555 0 0 0 3.993-3.504c1.955-8.881-2.16-18.374-11.041-28.437-9.941-11.285-27.011-18.903-34.426-21.837Z",
                fill: "#8FDBC7"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M369.548 520.856c-1.548-.612-3.178.774-2.729 2.403 1.792 6.804 6.355 21.185 14.422 30.311 7.455 8.434 14.952 12.915 22.57 12.182 1.63-.163 3.015-1.345 3.341-2.974 1.67-7.456-1.833-15.441-9.289-23.915-8.107-9.126-21.796-15.4-28.315-18.007Z",
                fill: "#008F69"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M369.385 470.541c-1.548-.611-3.178.774-2.729 2.403 1.792 6.804 6.355 21.267 14.463 30.475 7.496 8.474 15.033 12.955 22.651 12.222 1.63-.163 3.015-1.345 3.382-2.974 1.67-7.497-1.833-15.523-9.33-23.997-8.107-9.207-21.918-15.522-28.437-18.129Z",
                fill: "#04B485"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M453.474 433.915c.367-1.63-1.263-2.974-2.77-2.322-7.334 3.096-24.241 11.122-33.897 22.57-8.637 10.267-12.548 19.881-10.389 28.681.489 1.915 2.119 3.3 4.075 3.423 9.044.652 17.885-4.848 26.522-15.115 9.615-11.489 14.626-29.496 16.459-37.237Z",
                fill: "#008F69"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M450.459 505.659c.652-1.548-.733-3.177-2.363-2.77-6.477 1.63-19.678 5.704-28.192 13.037-7.986 6.844-12.223 13.811-11.611 20.9a3.598 3.598 0 0 0 2.729 3.178c6.926 1.629 14.422-1.508 22.408-8.393 8.433-7.333 14.422-19.8 17.029-25.952Z",
                fill: "#8FDBC7"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M454.248 578.096c.734 3.3 1.1 6.763 1.1 10.308 0 6.355-1.222 12.466-3.504 18.007M362.093 604.456c-1.793-5.012-2.73-10.43-2.73-16.052 0-13.037 5.174-24.852 13.607-33.489",
                stroke: "#0A3A5C",
                strokeWidth: 1.6,
                strokeMiterlimit: 10,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M439.989 97.722c0-17.11-13.852-30.963-30.963-30.963s-30.963 13.852-30.963 30.963h15.644c0-8.433 6.845-15.318 15.319-15.318s15.318 6.844 15.318 15.318c0 4.237-1.711 8.067-4.522 10.837-7.415 7.415-18.904 7.13-18.904 22.163v11.367h17.438v-5.541c0-10.674 3.096-7.496 12.222-16.622 5.785-5.622 9.411-13.485 9.411-22.204ZM418.315 149.83h-17.396v14.055h17.396V149.83Z",
                fill: "#00416A"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M448.137 172.726c5.174-6.641 13.241-10.878 22.285-10.878 8.882 0 16.826 4.115 22 10.552M498.696 190.081c0 15.604-12.67 28.275-28.274 28.275-15.603 0-28.274-12.671-28.274-28.275",
                stroke: "#0A3A5C",
                strokeWidth: 1.6,
                strokeMiterlimit: 10,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M473.804 64.111c15.638 0 28.315-12.677 28.315-28.315 0-15.637-12.677-28.315-28.315-28.315-15.638 0-28.315 12.678-28.315 28.315 0 15.638 12.677 28.315 28.315 28.315Z",
                fill: "#fff"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M473.804 59.507c13.095 0 23.711-10.615 23.711-23.71 0-13.096-10.616-23.712-23.711-23.712-13.096 0-23.711 10.616-23.711 23.711 0 13.096 10.615 23.711 23.711 23.711Z",
                fill: "#FFD330"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M399.452 241.211c15.615 0 28.274-12.659 28.274-28.274s-12.659-28.274-28.274-28.274c-15.616 0-28.274 12.659-28.274 28.274s12.658 28.274 28.274 28.274Z",
                fill: "#fff"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M399.452 237.544c13.59 0 24.607-11.017 24.607-24.607s-11.017-24.607-24.607-24.607-24.608 11.017-24.608 24.607 11.018 24.607 24.608 24.607Z",
                fill: "#FFD330"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M464.841 62.563c-11.204-3.748-19.311-14.34-19.311-26.807 0-15.604 12.67-28.275 28.274-28.275 7.211 0 13.811 2.73 18.822 7.17M501.141 28.504c.611 2.322.937 4.726.937 7.21 0 12.182-7.7 22.53-18.456 26.523",
                stroke: "#0A3A5C",
                strokeWidth: 1.6,
                strokeMiterlimit: 10,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M385.03 57.348c15.615 0 28.274-12.659 28.274-28.274S400.645.8 385.03.8c-15.616 0-28.274 12.659-28.274 28.274s12.658 28.274 28.274 28.274Z",
                fill: "#fff"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M385.03 53.274c13.365 0 24.2-10.835 24.2-24.2 0-13.365-10.835-24.2-24.2-24.2-13.366 0-24.2 10.835-24.2 24.2 0 13.365 10.834 24.2 24.2 24.2Z",
                fill: "#FFD330"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M406.704 47.244c-5.174 6.193-12.956 10.104-21.674 10.104-15.604 0-28.274-12.67-28.274-28.274M364.537 9.6C369.67 4.181 376.963.84 385.03.84c15.603 0 28.274 12.671 28.274 28.275M394.93 185.03a27.398 27.398 0 0 1 4.522-.367c15.604 0 28.274 12.67 28.274 28.274 0 15.604-12.67 28.274-28.274 28.274a28.184 28.184 0 0 1-15.726-4.767M372.726 222.144c-1.019-2.892-1.548-5.988-1.548-9.248a28.158 28.158 0 0 1 9.329-20.981",
                stroke: "#0A3A5C",
                strokeWidth: 1.6,
                strokeMiterlimit: 10,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "m414.037 201.693-5.011-3.178-5.011-3.178.448 4.807.163 1.834-6.722 12.141-8.189 14.788 9.9-13.688 8.148-11.245 1.711-.611 4.563-1.67Z",
                fill: "#959595"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "m414.037 201.693-5.011-3.178-1.548-.978 2.322 3.748-3.585 1.671-16.5 25.951 9.9-13.688 8.148-11.245 1.711-.611 4.563-1.67Z",
                fill: "#C6C6C6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "m408.211 204.626-5.255-.693M406.419 207.111l-4.889-.652M404.626 209.637l-4.522-.611M402.833 212.122l-4.155-.529M401.041 214.648l-3.789-.529M399.248 217.133l-3.422-.448M397.496 219.659l-3.096-.448M395.704 222.144l-2.73-.366M393.911 224.67l-2.363-.326M392.119 227.156l-1.997-.286",
                stroke: "#636363",
                strokeWidth: 1.6,
                strokeMiterlimit: 10,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M462.111 33.148v8.678l14.789-14.83h-8.678l-6.111 6.152Z",
                fill: "#AEAEAE"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M468.222 47.937h8.678l6.152-6.111v-8.718l-14.83 14.829Z",
                fill: "#7C7C7C"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M476.922 27.003 462.086 41.84l6.136 6.136 14.836-14.836-6.136-6.137Z",
                fill: "#959595"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "m471.726 23.493-6.152 6.151v8.678l6.152 6.152h8.678l6.152-6.152v-8.678l-6.152-6.151h-8.678Z",
                fill: "#C6C6C6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M480.078 30.581a5.164 5.164 0 0 1 0 7.334 4.89 4.89 0 0 1-.489.448c-.163.122-.367.285-.57.367-.204.122-.408.203-.612.326a8.801 8.801 0 0 1-.977.285c-.367.081-.774.122-1.141.081-.53 0-1.019-.122-1.548-.285-.734-.244-1.385-.652-1.997-1.222a5.109 5.109 0 0 1-1.222-1.996c-.163-.49-.244-1.019-.285-1.549 0-.366.041-.774.082-1.14a8.79 8.79 0 0 1 .285-.978c.081-.204.203-.408.326-.611.122-.204.244-.367.366-.57.123-.164.286-.327.448-.49 2.038-1.996 5.338-1.996 7.334 0Z",
                fill: "#7C7C7C"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M397.211 45.574 375.537 23.9l-.163-.163a5.926 5.926 0 0 1 0-8.392 5.926 5.926 0 0 1 8.393 0 5.926 5.926 0 0 1 0 8.392c-.285.285-.856.693-.856.693-.081.081-.163.122-.244.203a1.868 1.868 0 0 0 0 2.649 1.869 1.869 0 0 0 2.648 0c.204-.204.448-.367.692-.49a2.378 2.378 0 0 1 2.689.49c.448.448.693 1.059.693 1.67s-.245 1.222-.693 1.67a1.672 1.672 0 0 0 0 2.363l7.741 7.74",
                stroke: "#AEAEAE",
                strokeWidth: 1.6,
                strokeMiterlimit: 10,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "m398.433 45.167-21.674-21.674-.163-.163a5.926 5.926 0 0 1 0-8.393 5.927 5.927 0 0 1 8.393 0 5.926 5.926 0 0 1 0 8.393c-.285.285-.856.692-.856.692-.081.082-.163.122-.244.204a1.87 1.87 0 0 0 0 2.648 1.869 1.869 0 0 0 2.648 0c.204-.204.448-.367.693-.489a2.378 2.378 0 0 1 2.689.49c.448.447.692 1.058.692 1.67 0 .61-.244 1.222-.692 1.67a1.672 1.672 0 0 0 0 2.363l7.74 7.74",
                stroke: "#7C7C7C",
                strokeWidth: 1.6,
                strokeMiterlimit: 10,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M444.389 201.815a92.858 92.858 0 0 1-17.6 3.992M492.993 163.437a89.052 89.052 0 0 1-3.749 5.582M488.063 60.118c11.693 15.319 18.618 34.467 18.618 55.204 0 2.811-.122 5.582-.366 8.311M412.856 24.226c.896-.04 1.792-.04 2.688-.04a91.058 91.058 0 0 1 30.678 5.296M353.252 48.793a89.813 89.813 0 0 1 7.048-5.99M375.904 197.415c-30.474-14.748-51.497-45.956-51.497-82.093 0-12.955 2.689-25.259 7.578-36.422",
                stroke: "#0A3A5C",
                strokeWidth: 1.6,
                strokeMiterlimit: 10,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M447.322 97.722c0-17.11-13.852-30.963-30.963-30.963s-30.963 13.852-30.963 30.963h15.645c0-8.433 6.844-15.318 15.318-15.318s15.319 6.844 15.319 15.318c0 4.237-1.711 8.067-4.522 10.837-7.415 7.415-18.904 7.13-18.904 22.163v11.367h17.437v-5.541c0-10.674 3.096-7.496 12.222-16.622 5.785-5.622 9.411-13.485 9.411-22.204ZM425.648 149.83h-17.396v14.055h17.396V149.83Z",
                fill: "#E5F0F6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M385.437 97.722h15.645c0-8.433 6.844-15.318 15.318-15.318s15.319 6.844 15.319 15.318c0 4.237-1.712 8.067-4.523 10.837-7.414 7.415-18.903 7.13-18.903 22.163v11.367h17.437M425.648 163.885h-17.396V149.83",
                stroke: "#0A3A5C",
                strokeWidth: 1.6,
                strokeMiterlimit: 10,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M303.752 110.8c6.84 0 12.385-5.545 12.385-12.385s-5.545-12.385-12.385-12.385-12.385 5.545-12.385 12.385 5.545 12.385 12.385 12.385ZM279.919 121.474a5.377 5.377 0 1 0 0-10.755 5.377 5.377 0 0 0 0 10.755Z",
                fill: "#fff",
                stroke: "#0A3A5C",
                strokeWidth: 1.6,
                strokeMiterlimit: 10,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M13.8 297.433v26.441c0 60.704 14.667 99.774 50.03 140.515",
                stroke: "#0A3A5C",
                strokeWidth: 1.6,
                strokeMiterlimit: 10,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M389.756 619.163h35.2c10.674-6.111 17.844-17.6 17.844-30.759v-.041c0-2.241-2.444-3.667-4.4-2.567a35.37 35.37 0 0 1-17.396 4.563c-16.134 0-29.741-10.796-34.019-25.503-.652-2.16-3.381-2.812-4.97-1.223a35.269 35.269 0 0 0-10.104 24.771c0 13.159 7.211 24.648 17.845 30.759Z",
                fill: "#FFD330"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M382.056 563.633a35.264 35.264 0 0 0-10.104 24.771c0 13.159 7.17 24.648 17.844 30.759M81.796 619.163h384.308M146.044 299.674c-.122 1.752-1.629 3.015-3.381 2.893l-11.285-.897a3.006 3.006 0 0 1-2.771-3.218M145.515 305.744c-.122 1.752-1.63 3.015-3.382 2.893l-8.27-.652c-1.752-.122-3.015-1.63-2.893-3.381",
                stroke: "#0A3A5C",
                strokeWidth: 1.6,
                strokeMiterlimit: 10,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M145.067 301.752c1.67 1.915 4.685 3.748 10.796 3.422M276.7 604.456V371.907",
                stroke: "#0A3A5C",
                strokeWidth: 1.6,
                strokeMiterlimit: 10,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M279.919 335.444h-13.852v62.537h13.852v-62.537Z",
                fill: "#00416A"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M269.937 335.444h-3.87v62.537h3.87v-62.537Z",
                fill: "#80B3D2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M279.875 337.134h-6.07M279.875 338.846h-3.218M279.875 342.268h-3.218M279.875 345.731h-3.218M279.875 349.153h-3.218M279.875 352.575h-3.218M279.875 355.997h-3.218M279.875 359.46h-3.218M279.875 362.883h-3.218M279.875 366.305h-3.218M279.875 369.727h-3.218M279.875 373.149h-3.218M279.875 376.612h-3.218M279.875 380.034h-3.218M279.875 383.457h-3.218M279.875 386.879h-3.218M279.875 390.342h-3.218M279.875 340.557h-6.07M279.875 343.979h-6.07M279.875 347.442h-6.07M279.875 350.864h-6.07M279.875 354.286h-6.07M279.875 357.709h-6.07M279.875 361.171h-6.07M279.875 364.594h-6.07M279.875 368.016h-6.07M279.875 371.438h-6.07M279.875 374.901h-6.07M279.875 378.323h-6.07M279.875 381.746h-6.07M279.875 385.168h-6.07M279.875 388.631h-6.07M279.875 392.053h-6.07M279.875 395.475h-6.07",
                stroke: "#E5F0F6",
                strokeWidth: 1.6,
                strokeMiterlimit: 10
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M338.422 339.885h-83.478v7.374h83.478v-7.374Z",
                fill: "#0A3A5C"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-illustrations-virtual-f4c8d3dc38/1/packages/lib-illustrations/src/error-500.tsx
/* eslint-disable max-len */ 

const Error500 = (param)=>{
    let { size =200  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        fill: "none",
        height: size,
        viewBox: "0 0 483 510",
        width: size,
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M222.697 218.093c0 26.175-21.224 47.393-47.405 47.393s-47.405-21.218-47.405-47.393c0-26.174 21.224-47.393 47.405-47.393s47.405 21.219 47.405 47.393Z",
                stroke: "#FA8E4D",
                strokeWidth: 1.6
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M175.292 276.961c32.519 0 58.881-26.356 58.881-58.868 0-32.511-26.362-58.867-58.881-58.867-32.519 0-58.881 26.356-58.881 58.867 0 32.512 26.362 58.868 58.881 58.868Z",
                stroke: "#F85E00",
                strokeWidth: 1.6,
                strokeMiterlimit: 10,
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeDasharray: "20 20"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M391.202 194.83a138.054 138.054 0 0 1 1.951 3.972M382.512 180.219c1.95 2.873 3.795 5.852 5.568 8.866M356.937 151.956a137.2 137.2 0 0 1 18.942 19.291M139.857 304.267a134.52 134.52 0 0 1-6.137-22.98M229.385 388.844c-11.883-3.582-23.092-8.688-33.378-15.178M355.554 374.588a145.43 145.43 0 0 1-43.984 22.164M424.722 260.542c-.213 10.674-1.49 21.064-3.76 31.1M378.397 146.459a159.044 159.044 0 0 1 10.216 11.1M346.757 122.345c1.916 1.099 3.796 2.269 5.675 3.44M321.786 110.749a159.013 159.013 0 0 1 19.296 8.475M408.618 326.466a155.625 155.625 0 0 1-10.428 17.944M312.918 416.185a164.795 164.795 0 0 1-32.03 5.497M180.932 108.089c.638-.355 1.241-.745 1.88-1.099M168.02 116.529a180.862 180.862 0 0 1 5.392-3.723M104.918 313.309c-2.235-6.596-4.114-13.334-5.569-20.249M125.775 354.978a173.893 173.893 0 0 1-15.926-28.831M174.05 402.32a172.24 172.24 0 0 1-19.26-14.646M237.295 427.675a139.578 139.578 0 0 1-6.917-1.418M257.832 430.229c-3.44-.213-6.881-.532-10.251-.958M369.104 398.702c-16.423 11.632-34.939 20.498-54.873 25.888M409.966 357.992c-1.242 1.702-2.483 3.404-3.76 5.071M424.722 333.204c-2.661 5.425-5.569 10.709-8.762 15.78M440.4 282.315a172.142 172.142 0 0 1-8.3 33.441M124.746 388.454a195.087 195.087 0 0 1-29.299-42.2M323.524 444.449c-6.775 1.986-13.692 3.582-20.715 4.823M381.306 416.576c-11.919 8.404-24.794 15.532-38.486 21.135M458.774 301.642c-2.093 9.008-4.824 17.767-8.088 26.242M388.435 103.408a196.618 196.618 0 0 1 16.423 14.291M364.386 87.415a243.88 243.88 0 0 1 8.868 5.283M333.81 73.549c6.775 2.376 13.373 5.142 19.793 8.227M74.91 275.755a197.427 197.427 0 0 1-.851-18.405M315.862 469.84a210.034 210.034 0 0 1-18.977 3.298M392.94 436.186c-20.147 13.972-42.742 24.646-67.075 31.207M454.553 371.007c-6.775 11.028-14.508 21.383-23.056 31.029M475.338 326.466a213.07 213.07 0 0 1-13.266 31.207M481.049 306.181a191.877 191.877 0 0 1-2.767 10.781M427.772 108.621a221.233 221.233 0 0 1 8.974 10.178M389.748 76.35a219.078 219.078 0 0 1 29.689 23.831M125.03 94.117a214.798 214.798 0 0 1 11.209-9.22M94.17 127.664a214.655 214.655 0 0 1 21.567-24.823M80.195 365.723a216.566 216.566 0 0 1-17.948-40.073M126.733 422.037c-15.395-13.299-28.909-28.76-40.118-45.853M183.769 457.605a216.78 216.78 0 0 1-7.129-3.191M203.172 464.804a197.585 197.585 0 0 1-7.343-2.482M230.804 471.578c-5.498-.958-10.925-2.164-16.246-3.511M286.28 474.237c-5.711.461-11.493.674-17.345.674-9.01 0-17.878-.532-26.603-1.596M364.386 54.967a225.27 225.27 0 0 1 23.695 12.979M345.409 47.059c2.696.957 5.321 1.985 7.946 3.085M357.93 470.124a233.257 233.257 0 0 1-20.927 7.589M399.502 447.428a222.586 222.586 0 0 1-11.599 7.482M343.707 31.88c3.334 1.1 6.633 2.27 9.896 3.511M402.482 453.775c-7.272 4.93-14.827 9.504-22.631 13.618M303.731 500.657a228.943 228.943 0 0 1-17.239 1.808M362.08 484.841a244.468 244.468 0 0 1-32.774 10.78M407.022 460.691a243.96 243.96 0 0 1-30.86 17.837M343.707 15.745c7.023 2.163 13.904 4.646 20.679 7.376M453.063 258.981a186.085 186.085 0 0 1-1.561 22.377M124.675 371.751a174.677 174.677 0 0 1-4.93-6.489M375.595 407.391a173.532 173.532 0 0 1-9.967 6.596",
                stroke: "#5995BE",
                strokeWidth: 1.6,
                strokeMiterlimit: 10,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M60.326 472.57h41.891l7.023 35.924h11.102L94.165 374.588H32.978L59.12 508.494h8.23l-7.024-35.924Z",
                fill: "#FFD330"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "m81.856 384.943-8.087 41.491H31.843l8.123-41.491h41.89ZM66.214 465.123l6.101-31.242h-41.89l-6.137 31.242h41.926Z",
                fill: "#D6B200"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M79.764 448.279c4.043 2.943 9.01 4.716 14.4 4.716a24.152 24.152 0 0 0 14.402-4.716",
                stroke: "#0A3A5C",
                strokeWidth: 1.6,
                strokeMiterlimit: 10,
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeDasharray: "12 12"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M32.978 374.588 6.801 508.494h9.01l7.022-35.924h41.891l-7.023 35.924h10.286l26.178-133.906H32.978Z",
                fill: "#FFE24D"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "m84.056 384.943-8.123 41.491h-41.89l8.122-41.491h41.89ZM68.378 465.123l6.1-31.242h-41.89l-6.101 31.242h41.89Z",
                fill: "#FFEC8E"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "m59.333 401.823-1.916 9.752M56.708 415.37l-.142.744M61.46 390.865l7.733 29.753H42.166l19.296-29.753Z",
                stroke: "#F85E00",
                strokeWidth: 3,
                strokeMiterlimit: 10,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M54.863 452.463c.887 3.121-1.915 5.462-4.185 5.462-3.228 0-4.434-3.015-4.434-4.93 0-5.638 5.533-11.206 7.803-11.206-1.099 4.327-.141 7.234.816 10.674ZM62.631 446.009c.532 1.986-1.206 3.334-2.624 3.334-2.022 0-2.803-1.809-2.803-3.015 0-3.546 3.477-7.128 4.895-7.128-.674 2.731-.07 4.646.532 6.809ZM42.555 457.357c.532 1.986-1.206 3.334-2.625 3.334-2.022 0-2.802-1.809-2.802-3.015 0-3.546 3.476-7.128 4.895-7.128-.674 2.731-.071 4.646.532 6.809Z",
                fill: "#5995BE",
                stroke: "#5995BE",
                strokeWidth: 1.6,
                strokeMiterlimit: 10,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M192.542 508.494h257.34M1.415 508.57h125.85",
                stroke: "#0A3A5C",
                strokeWidth: 1.6,
                strokeMiterlimit: 10,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M160.784 231.817c-2.412 3.688 0 12.518 8.017 12.093-1.774-8.369 1.17-12.058 4.753-12.235 3.547-.142-9.79-4.397-12.77.142Z",
                fill: "#FFE24D"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M168.801 243.91c-1.774-8.369 1.17-12.058 4.753-12.235",
                stroke: "#0A3A5C",
                strokeWidth: 1.6,
                strokeMiterlimit: 10,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M160.217 202.1c5.817 3.227 7.023 12.199 2.696 20.071-4.363 7.837-12.131 9.185-17.948 5.958 6.455-4.22.957-8.263 5.285-16.1 4.363-7.908 4.15-13.156 9.967-9.929Z",
                fill: "#FFE24D"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M162.913 222.136c-4.363 7.837-12.131 9.185-17.948 5.957",
                stroke: "#0A3A5C",
                strokeWidth: 1.6,
                strokeMiterlimit: 10,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M156.705 183.872c2.944 3.511 1.242 8.795-2.022 10.319 8.23 5.71 13.373.426 14.863-2.305 1.489-2.695-4.186-9.716-12.841-8.014Z",
                fill: "#FFE24D"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M169.546 191.886c1.489-2.73-4.221-9.716-12.841-8.014",
                stroke: "#0A3A5C",
                strokeWidth: 1.6,
                strokeMiterlimit: 10,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M178.449 190.503c1.915 2.022 7.803 4.504 13.479 2.802-.071 3.901-6.775 10.355-12.521 10.816-5.747.461-6.775-1.773-5.534-5.142 1.206-3.334 3.086-10.036 4.576-8.476Z",
                fill: "#FFE24D"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M191.892 193.305c-.071 3.901-6.775 10.355-12.521 10.816-5.746.461-6.775-1.773-5.533-5.142",
                stroke: "#0A3A5C",
                strokeWidth: 1.6,
                strokeMiterlimit: 10,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M181.854 197.064c1.49 2.376 6.739 5.958 12.663 5.39 1.348 5.142-4.15 13.937-9.896 13.263-5.747-.674-10.819-8.192-8.939-11.241 1.88-3.05 5.037-9.221 6.172-7.412Z",
                fill: "#FFE24D"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M194.517 202.454c1.348 5.142-4.15 13.937-9.896 13.263",
                stroke: "#0A3A5C",
                strokeWidth: 1.6,
                strokeMiterlimit: 10,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M155.712 226.462c-1.596 1.596-4.079 6.383-2.944 11.703 4.044 1.347 9.861.142 11.918-1.915 2.058-2.057 8.478-7.731 3.264-11.242-5.25-3.546-10.287-.532-12.238 1.454Z",
                fill: "#FFE24D"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M152.733 238.129c4.043 1.348 9.86.142 11.918-1.915 2.057-2.056 8.477-7.73 3.263-11.241",
                stroke: "#0A3A5C",
                strokeWidth: 1.6,
                strokeMiterlimit: 10,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "m165.112 232.455 19.651 19.646 17.664-17.66-22.027-14.078-15.288 12.092Z",
                fill: "#FFB784"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "m180.01 196.319 5.994 3.795c.461.283.745.78.78 1.312l.284 3.901c.071.78.639 1.454 1.455 1.56l1.844.284c.497.071.958.39 1.206.815l8.123 14.043c.425.745.319 1.703-.319 2.305l-8.726 8.724c-4.47 4.468-14.756 2.731-18.906-1.454-2.589 2.589-6.349 3.015-10.287-.922-2.163-2.163-.106-6.773 1.774-8.688 4.044-4.043.355-16.064.355-16.064s12.769-11.951 16.423-9.611Z",
                fill: "#FFB784"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "m180.01 196.319 5.994 3.795c.461.283.745.78.78 1.312l.284 3.901c.071.78.639 1.454 1.455 1.56l1.844.284c.497.071.958.39 1.206.815l8.123 14.043c.425.745.319 1.703-.319 2.305l-8.726 8.724c-4.47 4.468-14.756 2.731-18.906-1.454-2.59 2.589-6.349 3.015-10.287-.922-2.163-2.163-.922-6.667 1.774-8.688 4.611-3.404.355-16.064.355-16.064s12.769-11.951 16.423-9.611Z",
                stroke: "#0A3A5C",
                strokeWidth: 1.6,
                strokeMiterlimit: 10,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "m163.338 215.256 9.755 9.752c-2.058 2.057-4.292 2.553-6.208.674l-6.101-6.1 2.554-4.326Z",
                fill: "#FFE24D"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M173.093 225.008c-2.058 2.057-4.292 2.554-6.208.674l-6.101-6.099",
                stroke: "#0A3A5C",
                strokeWidth: 1.6,
                strokeMiterlimit: 10,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "m180.4 206.922 9.045 5.887c.425.248.638.745.567 1.241l-.106.781c-.071.39-.284.744-.639.922l-1.525.851a1.215 1.215 0 0 1-1.596-.355l-6.385-8.617a.495.495 0 0 1-.071-.39c.036-.355.426-.497.71-.32ZM184.656 208.589a1.312 1.312 0 1 0 .001-2.625 1.312 1.312 0 0 0-.001 2.625ZM176.888 215.788a1.312 1.312 0 1 0 .001-2.625 1.312 1.312 0 0 0-.001 2.625Z",
                fill: "#0A3A5C"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M172.029 217.455c-.71-1.738-.32-4.043 1.17-5.922 1.632-2.057 4.115-2.944 6.101-2.341M180.932 206.249c.142-.993.567-2.022 1.277-2.944 1.064-1.347 2.554-2.127 3.937-2.198",
                stroke: "#0A3A5C",
                strokeWidth: 1.6,
                strokeMiterlimit: 10,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M194.056 220.753c0-.816-2.235-2.27-3.689-1.773-1.88 1.915-5.037 5.071-5.037 5.071l2.98 6.383-.107-3.865 5.853-5.816Z",
                fill: "#FF7BAC"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "m188.345 230.434-.106-3.83 6.384-6.383 2.519.354-2.093-2.127-8.513 8.156 1.809 3.83Z",
                fill: "#fff",
                stroke: "#fff",
                strokeWidth: 1.6,
                strokeMiterlimit: 10,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "m166.176 233.519 18.587 18.582",
                stroke: "#0A3A5C",
                strokeWidth: 1.6,
                strokeMiterlimit: 10,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "m185.507 224.334 7.591-7.837-.638-.638-7.414 7.412.461 1.063Z",
                fill: "#fff",
                stroke: "#fff",
                strokeWidth: 1.6,
                strokeMiterlimit: 10,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "m192.46 215.859-7.414 7.412 3.299 7.163-.106-3.83 6.384-6.383 2.519.354-4.682-4.716Z",
                stroke: "#0A3A5C",
                strokeWidth: 1.6,
                strokeMiterlimit: 10,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M179.265 182.56c-2.909-2.802-7.307-3.369-11.741-1.951 1.064 3.227 0 7.483-2.944 10.923-5.463-.958-12.025 2.695-15.536 9.397-5.215 10.001-.32 15.178-.994 23.654 5.818 3.227 17.736-4.114 22.099-11.951 1.206-2.199 1.986-4.468 2.341-6.667a21.028 21.028 0 0 0 4.114-3.298c6.243-6.49 7.414-15.497 2.661-20.107Z",
                fill: "#FFE24D"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M160.323 222.313c4.008-2.411 7.768-6.028 9.826-9.752 1.206-2.199 1.986-4.468 2.341-6.667a20.991 20.991 0 0 0 4.114-3.298c6.243-6.454 7.449-15.426 2.661-20.072-2.909-2.801-7.307-3.369-11.741-1.95.39 3.121.887 6.667-2.944 10.922",
                stroke: "#0A3A5C",
                strokeWidth: 1.6,
                strokeMiterlimit: 10,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "m146.915 180.574-.78 2.27-13.018 38.263-.709 2.057-7.449-2.482-3.724-1.241c-8.017-3.476-13.621-11.419-13.621-20.71 0-12.448 10.109-22.554 22.559-22.554 2.767 0 5.427.496 7.875 1.418h.035l8.832 2.979Z",
                fill: "#FFEC8E"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "m145.497 184.688-9.152-3.05h-.035a22.318 22.318 0 0 0-7.875-1.419c-8.584 0-16.033 4.788-19.863 11.845",
                stroke: "#F85E00",
                strokeWidth: 1.6,
                strokeMiterlimit: 10,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M135.387 188.411a22.064 22.064 0 0 0-7.803-1.418c-8.761 0-16.707 5.106-19.828 14.149.106 1.454.354 2.837 1.099 4.965 2.235-8.972 8.159-15.816 20.006-15.604 2.518.036 4.966.461 7.2 1.277h.036l6.349 2.092.958-2.837-8.017-2.624ZM135.387 214.015l-13.159-4.504c-1.277-.425-1.951-1.844-1.525-3.12l1.241-3.582c.426-1.277 1.845-1.95 3.121-1.525l13.16 4.539",
                fill: "#FFD330"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "m134.501 216.958-13.16-4.539c-1.277-.425-1.951-1.844-1.525-3.121l1.241-3.581c.426-1.277 1.845-1.951 3.122-1.525l13.159 4.539-2.837 8.227Z",
                fill: "#F85E00"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "m151.456 176.354-3.086 9.078-11.883 34.966-3.299 9.681-1.206-5.638.426-1.312.709-2.057 13.018-38.228.78-2.27.603-1.844 3.938-2.376Z",
                fill: "#FFEC8E"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "m141.169 197.454-8.052 23.618-.709 2.057-.426 1.312 1.206 5.638 3.299-9.681 7.484-21.986-2.802-.958Z",
                fill: "#FFD330"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "m151.456 176.354-18.268 53.725",
                stroke: "#F85E00",
                strokeWidth: 1.6,
                strokeMiterlimit: 10,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "m121.341 212.419 13.16 4.539",
                stroke: "#0A3A5C",
                strokeWidth: 1.6,
                strokeMiterlimit: 10,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "m124.959 220.682-3.724-1.241c-8.017-3.476-13.621-11.419-13.621-20.71",
                stroke: "#F85E00",
                strokeWidth: 1.6,
                strokeMiterlimit: 10,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "m137.338 208.696-6.526-2.235",
                stroke: "#0A3A5C",
                strokeWidth: 1.6,
                strokeMiterlimit: 10,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M258.151 112.664V184.9h.036L124.285 318.735v84.897h30.505v-72.237l133.866-133.87v-84.861h-30.505Z",
                fill: "#00416A"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M288.656 112.664v84.861l-45.048 45.037",
                stroke: "#0A3A5C",
                strokeWidth: 1.6,
                strokeMiterlimit: 10,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "m179.3 282.741 64.167 61.669 26.993-40.498-34.265-64.754-56.895 43.583Z",
                fill: "#00416A"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M130.812 401.965v-5.319",
                stroke: "#0A3A5C",
                strokeWidth: 1.6,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M130.812 387v-53.052",
                stroke: "#0A3A5C",
                strokeWidth: 1.6,
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeDasharray: "27.19 27.19"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M130.812 329.126v-5.32l3.76-3.759",
                stroke: "#0A3A5C",
                strokeWidth: 1.6,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M142.091 312.529 258.79 195.858",
                stroke: "#0A3A5C",
                strokeWidth: 1.6,
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeDasharray: "30.02 30.02"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "m262.55 192.099 3.76-3.759v-5.319",
                stroke: "#0A3A5C",
                strokeWidth: 1.6,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M266.31 170.467V126.53",
                stroke: "#0A3A5C",
                strokeWidth: 1.6,
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeDasharray: "35.39 35.39"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M266.31 120.253v-5.32M149.789 409.093v-5.319M283.194 118.799v-5.32M202.924 300.685l3.795-3.759",
                stroke: "#0A3A5C",
                strokeWidth: 1.6,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "m213.813 289.833 24.865-24.859",
                stroke: "#0A3A5C",
                strokeWidth: 1.6,
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeDasharray: "28.32 28.32"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "m242.225 261.428 3.76-3.759M140.14 408.561v-3.546M273.9 121.21v-3.546M197.355 294.55l2.483-2.518",
                stroke: "#0A3A5C",
                strokeWidth: 1.6,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "m204.307 287.599 33.307-33.299",
                stroke: "#0A3A5C",
                strokeWidth: 1.6,
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeDasharray: "17.71 17.71"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "m239.849 252.066 2.482-2.518M208.741 306.501l2.518-2.483",
                stroke: "#0A3A5C",
                strokeWidth: 1.6,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "m216.048 299.231 26.39-26.384",
                stroke: "#0A3A5C",
                strokeWidth: 1.6,
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeDasharray: "19.12 19.12"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "m244.814 270.435 2.519-2.517",
                stroke: "#0A3A5C",
                strokeWidth: 1.6,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "m349.134 259.088-4.434-14.469-14.401-4.326-17.274 17.27-1.526-.213-6.739 6.702 20.502 20.497 6.704-6.737-.213-1.348 17.381-17.376Z",
                fill: "#FFD330",
                stroke: "#0A3A5C",
                strokeWidth: 1.6,
                strokeMiterlimit: 10,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "m341.901 232.159-80.26 80.242 23.501 23.495 80.26-80.241-23.501-23.496Z",
                fill: "#FFD330"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M357.93 308.025H244.424v39.718H357.93v-39.718Z",
                fill: "#FFD330"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "m420.82 406.114 3.192 5.674c2.341 4.185 7.697 5.674 11.847 3.263l-33.058 19.078-16.175-28.015 10.854-6.241c8.158-4.752 18.622-1.951 23.34 6.241Z",
                fill: "#C74B00"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "m414.92 406.156-56.753-98.273-30.718 17.731 56.753 98.273 30.718-17.731Z",
                fill: "#FFD330"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M249.355 326.111h102.262l50.723 87.308",
                stroke: "#0A3A5C",
                strokeWidth: 1.6,
                strokeMiterlimit: 10,
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M244.424 338.984h102.262l50.688 87.273",
                stroke: "#0A3A5C",
                strokeWidth: 1.6,
                strokeMiterlimit: 10,
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "m423.622 226.781 5.392.071c3.972.036 7.236-3.156 7.236-7.163v31.597h-26.781v-10.355c0-7.837 6.314-14.15 14.153-14.15Z",
                fill: "#C74B00"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M300.326 30.64c-.851-.497-1.88-.639-2.802-.355l-3.476 1.064a3.374 3.374 0 0 0-2.093 1.844v.035a3.268 3.268 0 0 0-.142 2.518l20.076 61.03 7.662-2.34-17.664-61.81c-.284-.816-.816-1.526-1.561-1.987Z",
                fill: "#5995BE"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "m328.774 109.188-10.855 3.334a1.33 1.33 0 0 1-1.667-.887l-.106.036a4.694 4.694 0 0 0-5.321-1.88c-2.305.71-3.689 3.05-3.263 5.391a.56.56 0 0 1-.426.673l-5.107 1.561c-.32.106-.639-.071-.745-.39l-3.796-12.306c-.106-.319.071-.638.391-.745l5.107-1.56c.284-.071.603.036.71.319.957 2.163 3.405 3.334 5.711 2.625 2.163-.674 3.511-2.767 3.298-4.93l-1.099-3.546 8.016-2.447 2.767 4.504a8.312 8.312 0 0 0 8.938 2.766c4.257-1.312 6.669-5.71 5.605-9.965l1.844.177c1.738 7.412-2.589 15.001-10.002 17.27Z",
                fill: "#C6C6C6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M265.458 112.664h-4.753a1.045 1.045 0 0 1-1.064-1.064v-11.348c0-.603.461-1.064 1.064-1.064h4.753c.603 0 1.065.461 1.065 1.064V111.6c0 .567-.462 1.064-1.065 1.064Z",
                fill: "#5995BE",
                stroke: "#0A3A5C",
                strokeWidth: 1.6,
                strokeMiterlimit: 10,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M272.34 112.664h-4.753a1.045 1.045 0 0 1-1.064-1.064v-11.348c0-.603.461-1.064 1.064-1.064h4.753c.603 0 1.064.461 1.064 1.064V111.6c0 .567-.461 1.064-1.064 1.064Z",
                fill: "#5995BE",
                stroke: "#0A3A5C",
                strokeWidth: 1.6,
                strokeMiterlimit: 10,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M279.221 112.664h-4.753a1.045 1.045 0 0 1-1.064-1.064v-11.348c0-.603.461-1.064 1.064-1.064h4.753c.603 0 1.064.461 1.064 1.064V111.6c0 .567-.461 1.064-1.064 1.064Z",
                fill: "#5995BE",
                stroke: "#0A3A5C",
                strokeWidth: 1.6,
                strokeMiterlimit: 10,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M286.102 112.664h-4.753a1.045 1.045 0 0 1-1.064-1.064v-11.348c0-.603.461-1.064 1.064-1.064h4.753c.603 0 1.064.461 1.064 1.064V111.6c0 .567-.461 1.064-1.064 1.064Z",
                fill: "#5995BE",
                stroke: "#0A3A5C",
                strokeWidth: 1.6,
                strokeMiterlimit: 10,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "m155.357 420.725 4.08 1.135 4.079 6.028-8.052 14.291-.107-21.454Z",
                fill: "#FFB784"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M421.565 232.172h-79.667v28.369h79.667v-28.369ZM244.566 243.981c-4.54-10.32-14.649-17.519-26.425-17.519-.71 0-1.419.036-2.129.071l-8.016 8.086c1.099-.142 2.199-.178 3.299-.178 11.705 0 21.779 7.128 26.354 17.377l-14.046 13.511c-4.789-9.575-14.543-16.135-25.752-16.135-1.56 0-3.121.141-4.611.39l-8.158 8.227a27.28 27.28 0 0 1 5.923-.638c10.854 0 20.325 6.135 25.291 15.213l-.035.035c.248.39.496.851.744 1.277.142.319.32.674.462.993.071.177.141.284.248.426 4.753 10.035 8.052 29.185-11.812 34.646l38.592 38.016 31.073-39.718c-.107-.035-30.895-63.832-31.002-64.08Z",
                fill: "#FFD330"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "m156.209 445.194-7.697 3.475-23.837-8.05v-21.348l1.88-2.163h25.397l4.257 2.163v25.923Z",
                fill: "#FFB784"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M264.536 99.153h22.311l2.59-2.59v-11.17h-20.68l-4.221 13.76Z",
                fill: "#FFB784",
                stroke: "#0A3A5C",
                strokeWidth: 1.6,
                strokeMiterlimit: 10,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M324.765 36.455v42.13H213.387v-42.13h-9.967V88.55h131.277V36.455h-9.932Z",
                fill: "#AEAEAE"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M334.697 88.55H203.42",
                stroke: "#00416A",
                strokeWidth: 1.6,
                strokeMiterlimit: 10,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M266.913 88.266h-8.265V69.293c0-1.631.887-3.156 2.306-3.972l1.028-.602c.993-.568 2.164-.568 3.193-.071a3.166 3.166 0 0 1 1.738 2.837v20.78Z",
                fill: "#FFB784",
                stroke: "#0A3A5C",
                strokeWidth: 1.6,
                strokeMiterlimit: 10,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M271.063 88.266a4.155 4.155 0 0 1-4.15-4.15v-15.78a3.6 3.6 0 0 1 2.731-3.475 4.659 4.659 0 0 1 3.689.602l.177.107a3.586 3.586 0 0 1 1.667 3.014v15.532c0 2.306-1.844 4.15-4.114 4.15ZM279.327 88.266a4.155 4.155 0 0 1-4.15-4.15V68.089c0-.922.532-1.738 1.348-2.128.887-.426 1.916-.39 2.802.035l1.561.78a4.7 4.7 0 0 1 2.589 4.22v13.122a4.132 4.132 0 0 1-4.15 4.149Z",
                fill: "#FFB784",
                stroke: "#0A3A5C",
                strokeWidth: 1.6,
                strokeMiterlimit: 10,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M286.918 88.266h-.142a3.292 3.292 0 0 1-3.299-3.298V71.634c0-1.277.887-2.376 2.129-2.624l.142-.036a4.438 4.438 0 0 1 3.156.568c.781.496 1.277 1.347 1.277 2.27v13.12a3.27 3.27 0 0 1-3.263 3.334ZM278.192 71.67h-20.36c-.78 0-1.49.425-1.88 1.099l-4.54 8.227c-.816 1.454-.745 3.263.142 4.681l8.655 13.511h12.237c3.192 0 2.944-17.2-7.662-18.689h9.081c3.299 0 5.994-2.695 5.994-5.993v-1.135c.036-.957-.744-1.702-1.667-1.702Z",
                fill: "#FFB784",
                stroke: "#0A3A5C",
                strokeWidth: 1.6,
                strokeMiterlimit: 10,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M345.374 0H192.46v53.548h152.914V0Z",
                fill: "#AEAEAE"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M330.866 26.81H207.003",
                stroke: "#00416A",
                strokeWidth: 1.6,
                strokeMiterlimit: 10,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "m226.821 56.912-14.256 3.67 16.587 64.391 14.255-3.671-16.586-64.39Z",
                fill: "#00416A"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "m216.557 59.544-4.019 1.035 16.587 64.391 4.019-1.035-16.587-64.39Z",
                fill: "#80B3D2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "m227.398 59.151-6.278 1.596M227.859 60.889l-3.334.886M228.746 64.435l-3.299.851M229.668 67.981l-3.334.851M230.591 71.492l-3.335.887M231.513 75.038l-3.334.851M232.4 78.585l-3.335.85M233.322 82.095l-3.334.887M234.244 85.641l-3.334.852M235.131 89.188l-3.334.85M236.053 92.698l-3.334.887M236.975 96.245l-3.334.85M237.862 99.791l-3.334.851M238.784 103.302l-3.334.886M239.707 106.848l-3.335.851M240.593 110.394l-3.334.851M241.516 113.905l-3.335.886M228.321 62.662l-6.279 1.631M229.207 66.208l-6.242 1.596M230.13 69.754l-6.279 1.596M231.052 73.265l-6.279 1.631M231.939 76.811l-6.243 1.596M232.861 80.358l-6.278 1.595M233.783 83.868l-6.278 1.632M234.67 87.415l-6.243 1.595M235.592 90.96l-6.278 1.597M236.514 94.472l-6.278 1.63M237.401 98.018l-6.243 1.596M238.323 101.564l-6.278 1.596M239.246 105.075l-6.279 1.631M240.132 108.621l-6.243 1.596M241.055 112.167l-6.279 1.596M241.977 115.678l-6.279 1.631M242.864 119.224l-6.243 1.596",
                stroke: "#E5F0F6",
                strokeWidth: 1.6,
                strokeMiterlimit: 10
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M297.382 132.381c3.937 3.723 10.038 4.503 14.862 1.525 2.057-1.277 3.618-3.05 4.576-5.071.071-.107.106-.213.142-.32l-8.797-.532a2.695 2.695 0 0 1-2.447-1.95c-.603-2.057-.497-4.291.638-6.17.497-.852 1.49-1.313 2.483-1.277l8.407.496a16.4 16.4 0 0 0-.852-1.773 1.937 1.937 0 0 0-.142-.248c-3.547-5.745-11.102-7.518-16.848-3.972a12.216 12.216 0 0 0-5.569 12.767l-38.592 23.83a9.272 9.272 0 0 0-11.032-.957c-1.489.922-2.66 2.234-3.369 3.723l7.307.426a2.32 2.32 0 0 1 2.057 1.631c.497 1.702.426 3.546-.532 5.107-.426.709-1.242 1.099-2.057 1.028l-7.024-.425c.178.425.391.851.639 1.241 2.696 4.362 8.406 5.674 12.734 3.014a9.253 9.253 0 0 0 4.363-7.979l39.053-24.114Z",
                fill: "#C6C6C6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M250.206 154.509c.497 1.702.426 3.546-.532 5.107-.426.709-1.242 1.099-2.057 1.028l-7.024-.425c.178.425.391.851.639 1.241 2.696 4.362 8.406 5.674 12.734 3.014a9.253 9.253 0 0 0 4.363-7.979l39.017-24.15c3.938 3.724 10.039 4.504 14.863 1.525 2.057-1.277 3.618-3.05 4.575-5.071a1.24 1.24 0 0 0 .142-.319M293.799 125.82l-38.556 23.866a9.272 9.272 0 0 0-11.032-.957c-1.489.922-2.66 2.234-3.369 3.723",
                stroke: "#00416A",
                strokeWidth: 1.6,
                strokeMiterlimit: 10,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "m208.138 127.097-1.809-.39c-.142-.036-.319.071-.355.213l-7.981 36.916v.071l.071 4.078c0 .319.426.39.568.106l1.738-3.688c0-.035 0-.035.035-.071l7.981-36.916a.34.34 0 0 0-.248-.319Z",
                fill: "#AEAEAE"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "m216.641 103.865-8.46-1.825-5.92 27.419 8.46 1.826 5.92-27.42Z",
                fill: "#F85E00"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "m211.09 104.693-1.421-.307-5.09 23.572 1.422.307 5.089-23.572ZM214.316 105.401l-1.422-.307-5.089 23.572 1.421.307 5.09-23.572Z",
                fill: "#00416A"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "m295.431 219.441 1.1.886c.106.071.248.071.319-.035l12.024-14.575.036-.036 1.348-2.766c.106-.213-.142-.425-.319-.283l-2.448 1.879-.035.035-12.025 14.575a.225.225 0 0 0 0 .32Z",
                fill: "#AEAEAE"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "m281.715 232.183 5.083 4.149 13.438-16.451-5.082-4.15-13.439 16.452Z",
                fill: "#00416A"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "m285.745 233.565.852.696 11.554-14.145-.852-.695-11.554 14.144ZM283.828 231.97l.852.695 11.554-14.145-.852-.695-11.554 14.145Z",
                fill: "#C74B00"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "m252.822 182.089-7.874 3.327 30.172 71.372 7.874-3.328-30.172-71.371Z",
                fill: "#4A4A4A"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "m263.225 180.6-26.562 11.223 7.277 17.215 26.563-11.224-7.278-17.214Z",
                fill: "#FFD330"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "m270.495 197.809-26.567 11.206-7.272-17.199",
                stroke: "#0A3A5C",
                strokeWidth: 1.6,
                strokeMiterlimit: 10,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M299.085 160.963c1.064 4.185 4.93 6.809 8.619 5.852a6.048 6.048 0 0 0 2.199-1.064l-3.653-14.185a6.334 6.334 0 0 0-2.448.142c-3.689.922-5.817 5.071-4.717 9.255Z",
                fill: "#FFD330"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "m376.958 136.118-61.245 15.769 2.592 10.062 61.245-15.769-2.592-10.062Z",
                fill: "#AEAEAE"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "m376.984 136.11-61.246 15.77.336 1.305 61.246-15.77-.336-1.305Z",
                fill: "#E6E7E8"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "m378.279 141.136-61.246 15.769 1.292 5.014 61.245-15.769-1.291-5.014Z",
                fill: "#323232"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M306.25 151.566a6.334 6.334 0 0 0-2.448.142c-3.086.78-5.037 3.83-5.001 7.234.106-2.66 1.631-4.752 3.511-4.752 1.951 0 3.512 2.234 3.512 5s-1.596 5-3.512 5c-1.241 0-2.341-.922-2.979-2.34 1.348 3.688 4.93 5.887 8.335 5a6.045 6.045 0 0 0 2.2-1.064l-3.618-14.22Z",
                fill: "#D6B200"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M319.232 156.318c-1.845-7.128-8.407-11.596-14.685-9.965-1.383.354-2.66.993-3.76 1.808l6.243 24.221c1.348.213 2.767.142 4.15-.213 6.278-1.631 9.896-8.723 8.052-15.851Z",
                fill: "#323232"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M319.125 155.963c-1.95-6.915-8.406-11.206-14.578-9.61-1.383.354-2.66.993-3.76 1.808l4.257 16.561a18.275 18.275 0 0 0 3.901-.319c5.108-1.028 8.797-4.326 10.18-8.44Z",
                fill: "#AEAEAE"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M304.476 147.665c11.173-2.802 14.508 8.759 14.649 8.298-1.95-6.915-8.406-11.206-14.578-9.61-1.383.354-2.66.993-3.76 1.808l.319 1.312c1.029-.815 2.129-1.524 3.37-1.808Z",
                fill: "#E6E7E8"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M131.592 417.108h-4.753a1.045 1.045 0 0 1-1.064-1.064v-11.348c0-.603.461-1.064 1.064-1.064h4.753c.603 0 1.064.461 1.064 1.064v11.348c0 .603-.461 1.064-1.064 1.064Z",
                fill: "#00416A",
                stroke: "#0A3A5C",
                strokeWidth: 1.6,
                strokeMiterlimit: 10,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M138.473 417.108h-4.753a1.045 1.045 0 0 1-1.064-1.064v-11.348c0-.603.461-1.064 1.064-1.064h4.753c.603 0 1.064.461 1.064 1.064v11.348c0 .603-.461 1.064-1.064 1.064Z",
                fill: "#00416A",
                stroke: "#0A3A5C",
                strokeWidth: 1.6,
                strokeMiterlimit: 10,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M145.355 417.108h-4.753a1.046 1.046 0 0 1-1.065-1.064v-11.348c0-.603.462-1.064 1.065-1.064h4.753c.603 0 1.064.461 1.064 1.064v11.348c0 .603-.461 1.064-1.064 1.064Z",
                fill: "#00416A",
                stroke: "#0A3A5C",
                strokeWidth: 1.6,
                strokeMiterlimit: 10,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M152.236 417.108h-4.753a1.045 1.045 0 0 1-1.064-1.064v-11.348c0-.603.461-1.064 1.064-1.064h4.753c.603 0 1.064.461 1.064 1.064v11.348c0 .603-.496 1.064-1.064 1.064Z",
                fill: "#00416A",
                stroke: "#0A3A5C",
                strokeWidth: 1.6,
                strokeMiterlimit: 10,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M436.25 246.357h16.352v-57.768c-9.045 0-16.352 2.411-16.352 16.206v41.562Z",
                fill: "#C74B00"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M436.25 261.251h16.352v-57.768c-9.045 0-16.352 2.411-16.352 16.206v41.562Z",
                fill: "#F85E00"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "m452.602 238.803 5.001-4.929c.993-.958 1.525-2.27 1.525-3.653v-29.646h-6.526v38.228Z",
                fill: "#FFB784"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M457.709 261.251h-5.107v-22.448h5.107c.781 0 1.419.638 1.419 1.419v19.61c0 .78-.638 1.419-1.419 1.419Z",
                fill: "#FFB784"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M459.128 203.483h-6.526v-14.93h5.107c.781 0 1.419.638 1.419 1.419v13.511Z",
                fill: "#FA8E4D"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M459.128 208.341h-4.043M459.128 213.164h-4.043M459.128 203.483h-4.043M459.128 198.66h-4.043M459.128 193.837h-4.043M455.085 189.014h4.043v43.441h-4.043M455.085 238.803h4.043v22.625h-4.043M459.128 217.987h-4.043M459.128 222.81h-4.043M459.128 227.633h-4.043M459.128 242.881h-4.043M459.128 247.704h-4.043M459.128 252.527h-4.043M459.128 257.35h-4.043",
                stroke: "#C74B00",
                strokeWidth: 1.6,
                strokeMiterlimit: 10,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M447.387 216.568c0 25.462-6.775 20.781-6.775 37.909",
                stroke: "#0A3A5C",
                strokeWidth: 1.6,
                strokeMiterlimit: 10,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M436.25 241.605h-18.303v-7.696a4.715 4.715 0 0 1 4.717-4.716h13.586v12.412Z",
                fill: "#FFB784"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M449.516 194.05c-5.002.39-9.223 1.986-11.493 6.525",
                stroke: "#0A3A5C",
                strokeWidth: 1.6,
                strokeMiterlimit: 10,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "m407.979 431.115 9.861 17.093 60.442-34.895c-5.462-9.433-12.379-15.639-26.851-7.305l-43.452 25.107Z",
                fill: "#C74B00"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "m425.75 443.669 8.194 2.269a6.356 6.356 0 0 0 4.753-.603l31.037-17.908-3.937-6.844-40.047 23.086ZM405.319 462.606l-3.086-5.355 23.517-13.582 3.086 5.355c.461.815.178 1.879-.638 2.34l-20.538 11.845c-.816.496-1.844.212-2.341-.603Z",
                fill: "#FFB784"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "m466.648 429.2-3.937-6.844 15.607-9.007 3.086 5.354c.461.816.177 1.88-.639 2.341l-14.117 8.156Z",
                fill: "#FA8E4D"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "m461.576 432.108-2.448-4.255M456.539 435.016l-2.448-4.255M466.648 429.2l-2.483-4.255M471.685 426.257l-2.448-4.22M476.722 423.349l-2.448-4.22M479.347 416.186l2.447 4.255-45.473 26.242-2.448-4.255M427.24 446.258l2.448 4.255-23.659 13.653-2.448-4.22M451.467 437.924l-2.448-4.22M446.43 440.832l-2.448-4.22M441.393 443.775l-2.483-4.255M425.431 452.96l-2.447-4.22M420.394 455.868l-2.447-4.22M415.322 458.811l-2.447-4.255M410.285 461.719l-2.447-4.255",
                stroke: "#C74B00",
                strokeWidth: 1.6,
                strokeMiterlimit: 10,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "m413.371 431.612-15.039-26.03 8.087-4.645c2.731-1.561 6.207-.639 7.768 2.092l12.202 21.1-13.018 7.483Z",
                fill: "#FFB784"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "m410.392 412.107 3.192 5.674c2.341 4.185 7.697 5.674 11.847 3.263l-33.059 19.079-16.174-28.016 10.854-6.241c8.158-4.717 18.622-1.915 23.34 6.241Z",
                fill: "#F85E00"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M383.718 416.54c8.867-5.142 16.706 14.682 26.035 9.291",
                stroke: "#0A3A5C",
                strokeWidth: 1.6,
                strokeMiterlimit: 10,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "m427.879 413.774-17.949 10.355M424.935 408.739l-17.913 10.319M422.026 403.667l-17.913 10.355",
                stroke: "#0A3A5C",
                strokeWidth: 1.6,
                strokeMiterlimit: 10
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M470.727 413.42c-3.441-5.001-7.626-8.44-13.763-8.05",
                stroke: "#0A3A5C",
                strokeWidth: 1.6,
                strokeMiterlimit: 10,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "m392.372 440.123 9.861 17.092 60.442-34.895c-5.462-9.433-12.379-15.638-26.851-7.305l-43.452 25.108Z",
                fill: "#F85E00"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M445.827 424.803c-26.639 15.391-25.858 5.461-43.771 15.816M275.461 308.026l82.682-.107 34.229 59.222",
                stroke: "#0A3A5C",
                strokeWidth: 1.6,
                strokeMiterlimit: 10,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M333.314 350.155h-26.639v-26.632h26.639l7.094 13.227-7.094 13.405Z",
                fill: "#FFD330",
                stroke: "#0A3A5C",
                strokeWidth: 1.6,
                strokeMiterlimit: 10,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M307.917 322.281h-9.506v28.973h9.506l5.604-7.589V329.87l-5.604-7.589Z",
                fill: "#FFD330",
                stroke: "#0A3A5C",
                strokeWidth: 1.6,
                strokeMiterlimit: 10,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M306.675 339.693a2.943 2.943 0 1 0 0-5.886 2.943 2.943 0 1 0 0 5.886Z",
                fill: "#F85E00",
                stroke: "#0A3A5C",
                strokeWidth: 1.6,
                strokeMiterlimit: 10,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M340.408 336.75h-26.887M399.502 231.675l-57.604.497-90.38 90.429-7.129 26.383",
                stroke: "#0A3A5C",
                strokeWidth: 1.6,
                strokeMiterlimit: 10,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M417.947 242.881h-69.7l-58.101 58.052",
                stroke: "#0A3A5C",
                strokeWidth: 1.6,
                strokeMiterlimit: 10,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M413.336 253.13h-59.414l-54.802 54.789",
                stroke: "#0A3A5C",
                strokeWidth: 1.6,
                strokeMiterlimit: 10,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "m423.622 236.746 5.392.071c3.972.036 7.236-3.156 7.236-7.163v31.597h-26.781v-10.355c0-7.802 6.314-14.15 14.153-14.15Z",
                fill: "#F85E00"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M415.748 257.669c0-8.475 17.451-5.887 17.451-14.823",
                stroke: "#0A3A5C",
                strokeWidth: 1.6,
                strokeMiterlimit: 10,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M432.029 224.902v17.128M427.205 224.902v17.128M422.381 224.902v17.128",
                stroke: "#0A3A5C",
                strokeWidth: 1.6,
                strokeMiterlimit: 10
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "m233.641 264.549-10.499 10.497M236.053 268.911l-10.499 10.496M238.501 273.308l-10.5 10.497M240.913 277.67l-10.5 10.497",
                stroke: "#0A3A5C",
                strokeWidth: 1.6,
                strokeMiterlimit: 10,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "m236.798 261.428 8.69-8.688 6.953 13.475-8.726 8.724-6.917-13.511Z",
                fill: "#F85E00",
                stroke: "#0A3A5C",
                strokeWidth: 1.6,
                strokeMiterlimit: 10,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "m235.202 291.571 18.445-18.44 10.322 19.823-17.204 17.164-11.563-18.547Z",
                fill: "#fff",
                stroke: "#0A3A5C",
                strokeWidth: 1.6,
                strokeMiterlimit: 10,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "m241.09 291.145 3.724 7.128 11.848-11.844-3.725-7.128-11.847 11.844Z",
                fill: "#00416A",
                stroke: "#0A3A5C",
                strokeWidth: 1.6,
                strokeMiterlimit: 10,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "m216.261 272.351 28.766 43.157M218.176 301.536l22.417 28.405M207.996 234.619c1.099-.142 2.199-.178 3.299-.178 11.705 0 21.779 7.128 26.354 17.377",
                stroke: "#0A3A5C",
                strokeWidth: 1.6,
                strokeMiterlimit: 10,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "m186.572 256.534 24.794-24.788a.75.75 0 0 0 0-1.099l-5.108-5.036a.752.752 0 0 0-1.1 0l-24.794 24.788a.752.752 0 0 0 0 1.1l5.073 5.071a.827.827 0 0 0 1.135-.036Z",
                fill: "#00416A"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "m211.33 231.782-24.758 24.752M202.037 228.732l5.923 5.922M198.951 231.817l5.923 5.922M199.093 238.129l2.696 2.696M196.007 241.215l2.696 2.695M192.921 244.3l2.66 2.695M189.799 247.42l2.696 2.66M186.713 250.506l2.696 2.695M244.424 347.743l-38.592-38.015c18.268-5 18.942-22.909 9.826-38.548-4.895-8.44-15.253-14.007-24.688-14.007a27.29 27.29 0 0 0-5.924.638l8.159-8.227M156.209 442.782v-23.511l-4.257-2.163M148.618 445.442v3.227M140.141 442.782v3.227M131.663 440.158v3.192",
                stroke: "#0A3A5C",
                strokeWidth: 1.6,
                strokeMiterlimit: 10,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "m204.981 281.216-50.191 50.179v72.237M191.644 294.55l15.359 14.823",
                stroke: "#0A3A5C",
                strokeWidth: 1.6,
                strokeMiterlimit: 10,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "m268.757 291.784-23.73 23.724-8.406 27.448 7.768 6.028 7.129-26.383 23.234-23.228-5.995-7.589Z",
                fill: "#F85E00",
                stroke: "#C74B00",
                strokeWidth: 1.6,
                strokeMiterlimit: 10,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M345.409 53.584H192.46",
                stroke: "#00416A",
                strokeWidth: 1.6,
                strokeMiterlimit: 10,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-illustrations-virtual-f4c8d3dc38/1/packages/lib-illustrations/src/iceland-byko-location.tsx
/* eslint-disable max-len */ 

const IcelandBykoLocationIllustration = (param)=>{
    let { size =200  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        fill: "none",
        height: size,
        viewBox: "0 0 662 611",
        width: size,
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                y: "0.5",
                width: "579",
                height: "396",
                fill: "url(#pattern0)"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M26.3984 332.875C26.3984 334.115 25.9974 335.065 25.1953 335.727C24.3984 336.388 23.224 336.719 21.6719 336.719C21.0052 336.719 20.3906 336.654 19.8281 336.523C19.2708 336.398 18.7839 336.258 18.3672 336.102C17.8828 335.924 17.4401 335.719 17.0391 335.484L17.6953 333.32C17.6953 333.32 17.7656 333.349 17.9062 333.406C18.0469 333.469 18.2292 333.544 18.4531 333.633C18.6823 333.716 18.9427 333.81 19.2344 333.914C19.5312 334.013 19.8333 334.107 20.1406 334.195C20.4479 334.279 20.7474 334.349 21.0391 334.406C21.3359 334.464 21.6042 334.492 21.8438 334.492C22.4115 334.492 22.8333 334.411 23.1094 334.25C23.3854 334.089 23.5234 333.807 23.5234 333.406C23.5234 333.25 23.5052 333.104 23.4688 332.969C23.4375 332.833 23.3828 332.706 23.3047 332.586C23.2266 332.466 23.1198 332.357 22.9844 332.258C22.8542 332.159 22.6875 332.065 22.4844 331.977L19.25 330.609C18.4635 330.281 17.8724 329.831 17.4766 329.258C17.0807 328.68 16.8828 327.984 16.8828 327.172C16.8828 326.755 16.9479 326.378 17.0781 326.039C17.2083 325.695 17.3854 325.391 17.6094 325.125C17.8385 324.854 18.1042 324.622 18.4062 324.43C18.7135 324.232 19.0417 324.068 19.3906 323.938C19.7448 323.807 20.112 323.711 20.4922 323.648C20.8724 323.586 21.25 323.555 21.625 323.555C22.0521 323.555 22.4583 323.581 22.8438 323.633C23.2292 323.685 23.5859 323.753 23.9141 323.836C24.2422 323.914 24.5365 324 24.7969 324.094C25.0625 324.188 25.2865 324.276 25.4688 324.359C25.6562 324.438 25.7995 324.503 25.8984 324.555L26.0391 324.633L25.3203 326.656L25.1797 326.594C25.0911 326.552 24.9688 326.5 24.8125 326.438C24.6562 326.37 24.4688 326.299 24.25 326.227C24.0365 326.148 23.8047 326.078 23.5547 326.016C23.3047 325.948 23.0417 325.893 22.7656 325.852C22.4896 325.81 22.2135 325.789 21.9375 325.789C21.7031 325.789 21.4531 325.799 21.1875 325.82C20.9271 325.841 20.6849 325.891 20.4609 325.969C20.2422 326.047 20.0599 326.161 19.9141 326.312C19.7682 326.464 19.6953 326.669 19.6953 326.93C19.6953 326.992 19.6979 327.062 19.7031 327.141C19.7135 327.214 19.7474 327.294 19.8047 327.383C19.862 327.466 19.9531 327.555 20.0781 327.648C20.2031 327.742 20.3828 327.836 20.6172 327.93L23.5234 329.102C23.9766 329.284 24.3802 329.495 24.7344 329.734C25.0938 329.974 25.3958 330.247 25.6406 330.555C25.8906 330.862 26.0781 331.208 26.2031 331.594C26.3333 331.974 26.3984 332.401 26.3984 332.875ZM33.3281 334.484C33.6927 334.484 34 334.443 34.25 334.359C34.5 334.271 34.7031 334.148 34.8594 333.992C35.0208 333.831 35.1432 333.638 35.2266 333.414C35.3099 333.185 35.3698 332.93 35.4062 332.648C35.4427 332.367 35.4635 332.062 35.4688 331.734C35.474 331.401 35.4766 331.052 35.4766 330.688V323.766H38.5859V330.656C38.5859 331.672 38.487 332.56 38.2891 333.32C38.0964 334.076 37.7891 334.706 37.3672 335.211C36.9453 335.711 36.401 336.089 35.7344 336.344C35.0677 336.594 34.263 336.719 33.3203 336.719C32.3828 336.719 31.5807 336.594 30.9141 336.344C30.2526 336.089 29.7109 335.711 29.2891 335.211C28.8672 334.706 28.5573 334.076 28.3594 333.32C28.1615 332.56 28.0625 331.672 28.0625 330.656V323.766H31.1797V330.688C31.1797 331.052 31.1797 331.398 31.1797 331.727C31.1849 332.055 31.2031 332.359 31.2344 332.641C31.2708 332.922 31.3307 333.177 31.4141 333.406C31.4974 333.635 31.6172 333.831 31.7734 333.992C31.9349 334.148 32.1406 334.271 32.3906 334.359C32.6406 334.443 32.9531 334.484 33.3281 334.484ZM48.5078 330.172C48.5078 329.75 48.4948 329.344 48.4688 328.953C48.4427 328.562 48.3854 328.198 48.2969 327.859C48.2083 327.521 48.0807 327.214 47.9141 326.938C47.7474 326.661 47.5234 326.424 47.2422 326.227C46.9661 326.029 46.6224 325.875 46.2109 325.766C45.8047 325.656 45.3151 325.602 44.7422 325.602H44.1094V329.094H46.2578V331.039H44.1094V334.586H44.7422C45.2995 334.586 45.7786 334.536 46.1797 334.438C46.5859 334.333 46.9271 334.19 47.2031 334.008C47.4844 333.82 47.7109 333.594 47.8828 333.328C48.0547 333.062 48.1849 332.768 48.2734 332.445C48.3672 332.117 48.4297 331.763 48.4609 331.383C48.4922 330.997 48.5078 330.594 48.5078 330.172ZM51.625 330.195C51.625 331.221 51.4922 332.128 51.2266 332.914C50.9609 333.695 50.5547 334.352 50.0078 334.883C49.4661 335.414 48.7786 335.818 47.9453 336.094C47.112 336.365 46.1276 336.5 44.9922 336.5H41V331.039H39.7188V329.094H41V323.766H44.9922C47.1901 323.766 48.8438 324.297 49.9531 325.359C51.0677 326.422 51.625 328.034 51.625 330.195ZM58.8594 334.484C59.224 334.484 59.5312 334.443 59.7812 334.359C60.0312 334.271 60.2344 334.148 60.3906 333.992C60.5521 333.831 60.6745 333.638 60.7578 333.414C60.8411 333.185 60.901 332.93 60.9375 332.648C60.974 332.367 60.9948 332.062 61 331.734C61.0052 331.401 61.0078 331.052 61.0078 330.688V323.766H64.1172V330.656C64.1172 331.672 64.0182 332.56 63.8203 333.32C63.6276 334.076 63.3203 334.706 62.8984 335.211C62.4766 335.711 61.9323 336.089 61.2656 336.344C60.599 336.594 59.7943 336.719 58.8516 336.719C57.9141 336.719 57.112 336.594 56.4453 336.344C55.7839 336.089 55.2422 335.711 54.8203 335.211C54.3984 334.706 54.0885 334.076 53.8906 333.32C53.6927 332.56 53.5938 331.672 53.5938 330.656V323.766H56.7109V330.688C56.7109 331.052 56.7109 331.398 56.7109 331.727C56.7161 332.055 56.7344 332.359 56.7656 332.641C56.8021 332.922 56.862 333.177 56.9453 333.406C57.0286 333.635 57.1484 333.831 57.3047 333.992C57.4661 334.148 57.6719 334.271 57.9219 334.359C58.1719 334.443 58.4844 334.484 58.8594 334.484ZM69.7344 329.219C70.3125 329.219 70.8203 329.198 71.2578 329.156C71.7005 329.115 72.0677 329.029 72.3594 328.898C72.6562 328.768 72.8802 328.586 73.0312 328.352C73.1823 328.112 73.2578 327.799 73.2578 327.414C73.2578 327.07 73.2057 326.789 73.1016 326.57C72.9974 326.352 72.8255 326.18 72.5859 326.055C72.3464 325.93 72.0286 325.844 71.6328 325.797C71.2422 325.745 70.7578 325.719 70.1797 325.719H69.5938V329.219H69.7344ZM72.5469 330.164C73.1094 330.221 73.6302 330.318 74.1094 330.453C74.5885 330.583 75 330.773 75.3438 331.023C75.6927 331.273 75.9661 331.594 76.1641 331.984C76.362 332.375 76.4609 332.857 76.4609 333.43V336.5H73.3828V333.219C73.3828 332.812 73.3203 332.474 73.1953 332.203C73.0703 331.927 72.8854 331.708 72.6406 331.547C72.3958 331.38 72.0938 331.263 71.7344 331.195C71.375 331.128 70.9609 331.094 70.4922 331.094H69.5938V336.5H66.4766V323.766H69.8203C70.6953 323.766 71.4635 323.797 72.125 323.859C72.7917 323.922 73.3672 324.016 73.8516 324.141C74.3359 324.266 74.737 324.422 75.0547 324.609C75.3776 324.792 75.6354 325.005 75.8281 325.25C76.0208 325.49 76.1562 325.76 76.2344 326.062C76.3177 326.365 76.3594 326.693 76.3594 327.047C76.3594 327.609 76.2656 328.083 76.0781 328.469C75.8906 328.849 75.6276 329.159 75.2891 329.398C74.9505 329.638 74.5469 329.818 74.0781 329.938C73.6146 330.052 73.1042 330.128 72.5469 330.164ZM86.0625 336.5L81.2188 328.094V336.5H78.4609V323.766H81.7422L86.5 332.047V323.766H89.25V336.5H86.0625ZM91.7109 336.5V323.766H100.43V325.727H94.8203V328.969H99.7031V330.883H94.8203V334.586H100.5V336.5H91.7109ZM111.289 332.875C111.289 334.115 110.888 335.065 110.086 335.727C109.289 336.388 108.115 336.719 106.562 336.719C105.896 336.719 105.281 336.654 104.719 336.523C104.161 336.398 103.674 336.258 103.258 336.102C102.773 335.924 102.331 335.719 101.93 335.484L102.586 333.32C102.586 333.32 102.656 333.349 102.797 333.406C102.938 333.469 103.12 333.544 103.344 333.633C103.573 333.716 103.833 333.81 104.125 333.914C104.422 334.013 104.724 334.107 105.031 334.195C105.339 334.279 105.638 334.349 105.93 334.406C106.227 334.464 106.495 334.492 106.734 334.492C107.302 334.492 107.724 334.411 108 334.25C108.276 334.089 108.414 333.807 108.414 333.406C108.414 333.25 108.396 333.104 108.359 332.969C108.328 332.833 108.273 332.706 108.195 332.586C108.117 332.466 108.01 332.357 107.875 332.258C107.745 332.159 107.578 332.065 107.375 331.977L104.141 330.609C103.354 330.281 102.763 329.831 102.367 329.258C101.971 328.68 101.773 327.984 101.773 327.172C101.773 326.755 101.839 326.378 101.969 326.039C102.099 325.695 102.276 325.391 102.5 325.125C102.729 324.854 102.995 324.622 103.297 324.43C103.604 324.232 103.932 324.068 104.281 323.938C104.635 323.807 105.003 323.711 105.383 323.648C105.763 323.586 106.141 323.555 106.516 323.555C106.943 323.555 107.349 323.581 107.734 323.633C108.12 323.685 108.477 323.753 108.805 323.836C109.133 323.914 109.427 324 109.688 324.094C109.953 324.188 110.177 324.276 110.359 324.359C110.547 324.438 110.69 324.503 110.789 324.555L110.93 324.633L110.211 326.656L110.07 326.594C109.982 326.552 109.859 326.5 109.703 326.438C109.547 326.37 109.359 326.299 109.141 326.227C108.927 326.148 108.695 326.078 108.445 326.016C108.195 325.948 107.932 325.893 107.656 325.852C107.38 325.81 107.104 325.789 106.828 325.789C106.594 325.789 106.344 325.799 106.078 325.82C105.818 325.841 105.576 325.891 105.352 325.969C105.133 326.047 104.951 326.161 104.805 326.312C104.659 326.464 104.586 326.669 104.586 326.93C104.586 326.992 104.589 327.062 104.594 327.141C104.604 327.214 104.638 327.294 104.695 327.383C104.753 327.466 104.844 327.555 104.969 327.648C105.094 327.742 105.273 327.836 105.508 327.93L108.414 329.102C108.867 329.284 109.271 329.495 109.625 329.734C109.984 329.974 110.286 330.247 110.531 330.555C110.781 330.862 110.969 331.208 111.094 331.594C111.224 331.974 111.289 332.401 111.289 332.875Z",
                fill: "#0A3A5C"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M135 321.562C135 327.155 127 336.287 127 336.287C127 336.287 119 327.155 119 321.562C119 315.828 123.134 312.5 127 312.5C130.866 312.5 135 315.828 135 321.562Z",
                stroke: "#0A3A5C",
                strokeWidth: "2",
                strokeMiterlimit: "10",
                strokeLinecap: "square"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M127 324.959C128.657 324.959 130 323.438 130 321.561C130 319.684 128.657 318.163 127 318.163C125.343 318.163 124 319.684 124 321.561C124 323.438 125.343 324.959 127 324.959Z",
                stroke: "#0A3A5C",
                strokeWidth: "2",
                strokeMiterlimit: "10",
                strokeLinecap: "square"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M245.25 331.875C245.25 333.115 244.849 334.065 244.047 334.727C243.25 335.388 242.076 335.719 240.523 335.719C239.857 335.719 239.242 335.654 238.68 335.523C238.122 335.398 237.635 335.258 237.219 335.102C236.734 334.924 236.292 334.719 235.891 334.484L236.547 332.32C236.547 332.32 236.617 332.349 236.758 332.406C236.898 332.469 237.081 332.544 237.305 332.633C237.534 332.716 237.794 332.81 238.086 332.914C238.383 333.013 238.685 333.107 238.992 333.195C239.299 333.279 239.599 333.349 239.891 333.406C240.188 333.464 240.456 333.492 240.695 333.492C241.263 333.492 241.685 333.411 241.961 333.25C242.237 333.089 242.375 332.807 242.375 332.406C242.375 332.25 242.357 332.104 242.32 331.969C242.289 331.833 242.234 331.706 242.156 331.586C242.078 331.466 241.971 331.357 241.836 331.258C241.706 331.159 241.539 331.065 241.336 330.977L238.102 329.609C237.315 329.281 236.724 328.831 236.328 328.258C235.932 327.68 235.734 326.984 235.734 326.172C235.734 325.755 235.799 325.378 235.93 325.039C236.06 324.695 236.237 324.391 236.461 324.125C236.69 323.854 236.956 323.622 237.258 323.43C237.565 323.232 237.893 323.068 238.242 322.938C238.596 322.807 238.964 322.711 239.344 322.648C239.724 322.586 240.102 322.555 240.477 322.555C240.904 322.555 241.31 322.581 241.695 322.633C242.081 322.685 242.438 322.753 242.766 322.836C243.094 322.914 243.388 323 243.648 323.094C243.914 323.188 244.138 323.276 244.32 323.359C244.508 323.438 244.651 323.503 244.75 323.555L244.891 323.633L244.172 325.656L244.031 325.594C243.943 325.552 243.82 325.5 243.664 325.438C243.508 325.37 243.32 325.299 243.102 325.227C242.888 325.148 242.656 325.078 242.406 325.016C242.156 324.948 241.893 324.893 241.617 324.852C241.341 324.81 241.065 324.789 240.789 324.789C240.555 324.789 240.305 324.799 240.039 324.82C239.779 324.841 239.536 324.891 239.312 324.969C239.094 325.047 238.911 325.161 238.766 325.312C238.62 325.464 238.547 325.669 238.547 325.93C238.547 325.992 238.549 326.062 238.555 326.141C238.565 326.214 238.599 326.294 238.656 326.383C238.714 326.466 238.805 326.555 238.93 326.648C239.055 326.742 239.234 326.836 239.469 326.93L242.375 328.102C242.828 328.284 243.232 328.495 243.586 328.734C243.945 328.974 244.247 329.247 244.492 329.555C244.742 329.862 244.93 330.208 245.055 330.594C245.185 330.974 245.25 331.401 245.25 331.875ZM247.016 335.5V322.766H255.734V324.727H250.125V327.969H255.008V329.883H250.125V333.586H255.805V335.5H247.016ZM257.609 335.5V322.766H260.719V333.539H266.18V335.5H257.609ZM270.453 335.5H267.344V322.766H276.188V324.727H270.453V327.969H275.469V329.883H270.453V335.5ZM288.625 329.141C288.625 330.167 288.508 331.086 288.273 331.898C288.039 332.711 287.682 333.401 287.203 333.969C286.729 334.531 286.13 334.964 285.406 335.266C284.682 335.568 283.831 335.719 282.852 335.719C281.872 335.719 281.021 335.57 280.297 335.273C279.578 334.971 278.979 334.539 278.5 333.977C278.021 333.409 277.664 332.721 277.43 331.914C277.195 331.102 277.078 330.185 277.078 329.164C277.078 328.128 277.195 327.201 277.43 326.383C277.669 325.56 278.029 324.867 278.508 324.305C278.987 323.737 279.589 323.305 280.312 323.008C281.036 322.706 281.883 322.555 282.852 322.555C283.826 322.555 284.674 322.706 285.398 323.008C286.122 323.31 286.721 323.745 287.195 324.312C287.674 324.875 288.031 325.565 288.266 326.383C288.505 327.195 288.625 328.115 288.625 329.141ZM280.188 329.117C280.188 329.706 280.224 330.266 280.297 330.797C280.37 331.323 280.505 331.786 280.703 332.188C280.901 332.583 281.172 332.898 281.516 333.133C281.859 333.367 282.305 333.484 282.852 333.484C283.404 333.484 283.854 333.365 284.203 333.125C284.552 332.88 284.823 332.557 285.016 332.156C285.214 331.75 285.346 331.284 285.414 330.758C285.487 330.232 285.523 329.685 285.523 329.117C285.523 328.534 285.484 327.982 285.406 327.461C285.333 326.935 285.195 326.474 284.992 326.078C284.794 325.682 284.521 325.37 284.172 325.141C283.828 324.906 283.385 324.789 282.844 324.789C282.297 324.789 281.852 324.906 281.508 325.141C281.164 325.375 280.893 325.693 280.695 326.094C280.503 326.49 280.37 326.948 280.297 327.469C280.224 327.99 280.188 328.539 280.188 329.117ZM299.688 331.875C299.688 333.115 299.286 334.065 298.484 334.727C297.688 335.388 296.513 335.719 294.961 335.719C294.294 335.719 293.68 335.654 293.117 335.523C292.56 335.398 292.073 335.258 291.656 335.102C291.172 334.924 290.729 334.719 290.328 334.484L290.984 332.32C290.984 332.32 291.055 332.349 291.195 332.406C291.336 332.469 291.518 332.544 291.742 332.633C291.971 332.716 292.232 332.81 292.523 332.914C292.82 333.013 293.122 333.107 293.43 333.195C293.737 333.279 294.036 333.349 294.328 333.406C294.625 333.464 294.893 333.492 295.133 333.492C295.701 333.492 296.122 333.411 296.398 333.25C296.674 333.089 296.812 332.807 296.812 332.406C296.812 332.25 296.794 332.104 296.758 331.969C296.727 331.833 296.672 331.706 296.594 331.586C296.516 331.466 296.409 331.357 296.273 331.258C296.143 331.159 295.977 331.065 295.773 330.977L292.539 329.609C291.753 329.281 291.161 328.831 290.766 328.258C290.37 327.68 290.172 326.984 290.172 326.172C290.172 325.755 290.237 325.378 290.367 325.039C290.497 324.695 290.674 324.391 290.898 324.125C291.128 323.854 291.393 323.622 291.695 323.43C292.003 323.232 292.331 323.068 292.68 322.938C293.034 322.807 293.401 322.711 293.781 322.648C294.161 322.586 294.539 322.555 294.914 322.555C295.341 322.555 295.747 322.581 296.133 322.633C296.518 322.685 296.875 322.753 297.203 322.836C297.531 322.914 297.826 323 298.086 323.094C298.352 323.188 298.576 323.276 298.758 323.359C298.945 323.438 299.089 323.503 299.188 323.555L299.328 323.633L298.609 325.656L298.469 325.594C298.38 325.552 298.258 325.5 298.102 325.438C297.945 325.37 297.758 325.299 297.539 325.227C297.326 325.148 297.094 325.078 296.844 325.016C296.594 324.948 296.331 324.893 296.055 324.852C295.779 324.81 295.503 324.789 295.227 324.789C294.992 324.789 294.742 324.799 294.477 324.82C294.216 324.841 293.974 324.891 293.75 324.969C293.531 325.047 293.349 325.161 293.203 325.312C293.057 325.464 292.984 325.669 292.984 325.93C292.984 325.992 292.987 326.062 292.992 326.141C293.003 326.214 293.036 326.294 293.094 326.383C293.151 326.466 293.242 326.555 293.367 326.648C293.492 326.742 293.672 326.836 293.906 326.93L296.812 328.102C297.266 328.284 297.669 328.495 298.023 328.734C298.383 328.974 298.685 329.247 298.93 329.555C299.18 329.862 299.367 330.208 299.492 330.594C299.622 330.974 299.688 331.401 299.688 331.875ZM310.438 331.875C310.438 333.115 310.036 334.065 309.234 334.727C308.438 335.388 307.263 335.719 305.711 335.719C305.044 335.719 304.43 335.654 303.867 335.523C303.31 335.398 302.823 335.258 302.406 335.102C301.922 334.924 301.479 334.719 301.078 334.484L301.734 332.32C301.734 332.32 301.805 332.349 301.945 332.406C302.086 332.469 302.268 332.544 302.492 332.633C302.721 332.716 302.982 332.81 303.273 332.914C303.57 333.013 303.872 333.107 304.18 333.195C304.487 333.279 304.786 333.349 305.078 333.406C305.375 333.464 305.643 333.492 305.883 333.492C306.451 333.492 306.872 333.411 307.148 333.25C307.424 333.089 307.562 332.807 307.562 332.406C307.562 332.25 307.544 332.104 307.508 331.969C307.477 331.833 307.422 331.706 307.344 331.586C307.266 331.466 307.159 331.357 307.023 331.258C306.893 331.159 306.727 331.065 306.523 330.977L303.289 329.609C302.503 329.281 301.911 328.831 301.516 328.258C301.12 327.68 300.922 326.984 300.922 326.172C300.922 325.755 300.987 325.378 301.117 325.039C301.247 324.695 301.424 324.391 301.648 324.125C301.878 323.854 302.143 323.622 302.445 323.43C302.753 323.232 303.081 323.068 303.43 322.938C303.784 322.807 304.151 322.711 304.531 322.648C304.911 322.586 305.289 322.555 305.664 322.555C306.091 322.555 306.497 322.581 306.883 322.633C307.268 322.685 307.625 322.753 307.953 322.836C308.281 322.914 308.576 323 308.836 323.094C309.102 323.188 309.326 323.276 309.508 323.359C309.695 323.438 309.839 323.503 309.938 323.555L310.078 323.633L309.359 325.656L309.219 325.594C309.13 325.552 309.008 325.5 308.852 325.438C308.695 325.37 308.508 325.299 308.289 325.227C308.076 325.148 307.844 325.078 307.594 325.016C307.344 324.948 307.081 324.893 306.805 324.852C306.529 324.81 306.253 324.789 305.977 324.789C305.742 324.789 305.492 324.799 305.227 324.82C304.966 324.841 304.724 324.891 304.5 324.969C304.281 325.047 304.099 325.161 303.953 325.312C303.807 325.464 303.734 325.669 303.734 325.93C303.734 325.992 303.737 326.062 303.742 326.141C303.753 326.214 303.786 326.294 303.844 326.383C303.901 326.466 303.992 326.555 304.117 326.648C304.242 326.742 304.422 326.836 304.656 326.93L307.562 328.102C308.016 328.284 308.419 328.495 308.773 328.734C309.133 328.974 309.435 329.247 309.68 329.555C309.93 329.862 310.117 330.208 310.242 330.594C310.372 330.974 310.438 331.401 310.438 331.875Z",
                fill: "#0A3A5C"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M226 324.562C226 330.155 218 339.287 218 339.287C218 339.287 210 330.155 210 324.562C210 318.828 214.134 315.5 218 315.5C221.866 315.5 226 318.828 226 324.562Z",
                stroke: "#0A3A5C",
                strokeWidth: "2",
                strokeMiterlimit: "10",
                strokeLinecap: "square"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M218 327.959C219.657 327.959 221 326.438 221 324.561C221 322.684 219.657 321.163 218 321.163C216.343 321.163 215 322.684 215 324.561C215 326.438 216.343 327.959 218 327.959Z",
                stroke: "#0A3A5C",
                strokeWidth: "2",
                strokeMiterlimit: "10",
                strokeLinecap: "square"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M171.703 302.297C172.49 302.297 173.159 302.326 173.711 302.383C174.268 302.44 174.74 302.516 175.125 302.609C175.51 302.703 175.826 302.812 176.07 302.938C176.315 303.057 176.523 303.18 176.695 303.305C177.07 303.586 177.346 303.927 177.523 304.328C177.701 304.729 177.789 305.193 177.789 305.719C177.789 306.052 177.719 306.37 177.578 306.672C177.438 306.969 177.242 307.234 176.992 307.469C176.742 307.703 176.448 307.898 176.109 308.055C175.771 308.206 175.404 308.302 175.008 308.344C175.591 308.432 176.086 308.56 176.492 308.727C176.904 308.888 177.237 309.091 177.492 309.336C177.747 309.581 177.932 309.865 178.047 310.188C178.161 310.51 178.219 310.875 178.219 311.281C178.219 311.948 178.096 312.518 177.852 312.992C177.607 313.466 177.25 313.854 176.781 314.156C176.312 314.458 175.737 314.68 175.055 314.82C174.378 314.961 173.602 315.031 172.727 315.031H171.133H168.289V302.297H171.703ZM172.281 313.07C172.755 313.07 173.169 313.06 173.523 313.039C173.883 313.018 174.182 312.951 174.422 312.836C174.661 312.721 174.841 312.544 174.961 312.305C175.081 312.06 175.141 311.716 175.141 311.273C175.141 310.904 175.089 310.599 174.984 310.359C174.88 310.12 174.719 309.932 174.5 309.797C174.281 309.656 174 309.56 173.656 309.508C173.312 309.451 172.898 309.422 172.414 309.422H171.406V313.07H172.281ZM171.406 307.531H172.43C173.279 307.531 173.922 307.398 174.359 307.133C174.802 306.862 175.023 306.461 175.023 305.93C175.023 305.643 174.982 305.393 174.898 305.18C174.82 304.966 174.682 304.792 174.484 304.656C174.292 304.521 174.034 304.419 173.711 304.352C173.393 304.284 172.995 304.25 172.516 304.25H171.406V307.531ZM183.297 307.75C183.875 307.75 184.383 307.729 184.82 307.688C185.263 307.646 185.63 307.56 185.922 307.43C186.219 307.299 186.443 307.117 186.594 306.883C186.745 306.643 186.82 306.331 186.82 305.945C186.82 305.602 186.768 305.32 186.664 305.102C186.56 304.883 186.388 304.711 186.148 304.586C185.909 304.461 185.591 304.375 185.195 304.328C184.805 304.276 184.32 304.25 183.742 304.25H183.156V307.75H183.297ZM186.109 308.695C186.672 308.753 187.193 308.849 187.672 308.984C188.151 309.115 188.562 309.305 188.906 309.555C189.255 309.805 189.529 310.125 189.727 310.516C189.924 310.906 190.023 311.388 190.023 311.961V315.031H186.945V311.75C186.945 311.344 186.883 311.005 186.758 310.734C186.633 310.458 186.448 310.24 186.203 310.078C185.958 309.911 185.656 309.794 185.297 309.727C184.938 309.659 184.523 309.625 184.055 309.625H183.156V315.031H180.039V302.297H183.383C184.258 302.297 185.026 302.328 185.688 302.391C186.354 302.453 186.93 302.547 187.414 302.672C187.898 302.797 188.299 302.953 188.617 303.141C188.94 303.323 189.198 303.536 189.391 303.781C189.583 304.021 189.719 304.292 189.797 304.594C189.88 304.896 189.922 305.224 189.922 305.578C189.922 306.141 189.828 306.615 189.641 307C189.453 307.38 189.19 307.69 188.852 307.93C188.513 308.169 188.109 308.349 187.641 308.469C187.177 308.583 186.667 308.659 186.109 308.695ZM192.023 315.031V302.297H200.742V304.258H195.133V307.5H200.016V309.414H195.133V313.117H200.812V315.031H192.023ZM203.328 313.617V303.719H201.984V302.297H207.812V303.719H206.453V313.617H207.812V315.031H201.984V313.617H203.328ZM217.078 308.695C217.078 308.247 217.06 307.828 217.023 307.438C216.987 307.042 216.919 306.68 216.82 306.352C216.721 306.023 216.581 305.732 216.398 305.477C216.221 305.216 215.99 304.997 215.703 304.82C215.417 304.638 215.068 304.5 214.656 304.406C214.25 304.307 213.766 304.258 213.203 304.258H212.781V313.07H213.219C213.984 313.07 214.615 312.964 215.109 312.75C215.609 312.536 216.005 312.24 216.297 311.859C216.589 311.474 216.792 311.013 216.906 310.477C217.021 309.94 217.078 309.346 217.078 308.695ZM220.203 308.734C220.203 309.76 220.068 310.667 219.797 311.453C219.531 312.234 219.125 312.891 218.578 313.422C218.031 313.953 217.341 314.354 216.508 314.625C215.674 314.896 214.695 315.031 213.57 315.031H209.664V302.297H213.586C215.789 302.297 217.443 302.836 218.547 303.914C219.651 304.992 220.203 306.599 220.203 308.734ZM229.688 308.695C229.688 308.247 229.669 307.828 229.633 307.438C229.596 307.042 229.529 306.68 229.43 306.352C229.331 306.023 229.19 305.732 229.008 305.477C228.831 305.216 228.599 304.997 228.312 304.82C228.026 304.638 227.677 304.5 227.266 304.406C226.859 304.307 226.375 304.258 225.812 304.258H225.391V313.07H225.828C226.594 313.07 227.224 312.964 227.719 312.75C228.219 312.536 228.615 312.24 228.906 311.859C229.198 311.474 229.401 311.013 229.516 310.477C229.63 309.94 229.688 309.346 229.688 308.695ZM232.812 308.734C232.812 309.76 232.677 310.667 232.406 311.453C232.141 312.234 231.734 312.891 231.188 313.422C230.641 313.953 229.951 314.354 229.117 314.625C228.284 314.896 227.305 315.031 226.18 315.031H222.273V302.297H226.195C228.398 302.297 230.052 302.836 231.156 303.914C232.26 304.992 232.812 306.599 232.812 308.734ZM235.594 313.617V303.719H234.25V302.297H240.078V303.719H238.719V313.617H240.078V315.031H234.25V313.617H235.594ZM249.531 315.031L244.688 306.625V315.031H241.93V302.297H245.211L249.969 310.578V302.297H252.719V315.031H249.531Z",
                fill: "#0A3A5C"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                clipPath: "url(#clip0_1571_66718)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M162.818 306.694C162.818 312.288 154.818 321.42 154.818 321.42C154.818 321.42 146.818 312.288 146.818 306.694C146.818 300.961 150.952 297.633 154.818 297.633C158.684 297.633 162.818 300.961 162.818 306.694Z",
                        stroke: "#0A3A5C",
                        strokeWidth: "2",
                        strokeMiterlimit: "10",
                        strokeLinecap: "square"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M154.818 310.092C156.475 310.092 157.818 308.571 157.818 306.694C157.818 304.817 156.475 303.296 154.818 303.296C153.161 303.296 151.818 304.817 151.818 306.694C151.818 308.571 153.161 310.092 154.818 310.092Z",
                        stroke: "#0A3A5C",
                        strokeWidth: "2",
                        strokeMiterlimit: "10",
                        strokeLinecap: "square"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M195.352 286.5H192.234V273.766H195.352V279.234H195.898L199.383 273.766H202.648L198.359 280.109L203.078 286.5H199.578L195.836 281.148H195.352V286.5ZM203.234 285.164C203.719 285.102 204.122 285.021 204.445 284.922C204.773 284.818 205.036 284.664 205.234 284.461C205.432 284.258 205.573 283.992 205.656 283.664C205.74 283.336 205.781 282.914 205.781 282.398V273.766H208.906V282.414C208.906 283.258 208.807 283.979 208.609 284.578C208.417 285.172 208.117 285.661 207.711 286.047C207.31 286.427 206.802 286.708 206.188 286.891C205.578 287.073 204.859 287.174 204.031 287.195L203.234 285.164ZM217.844 273.766L222.102 286.5H218.992L218.109 283.703H214.344L213.461 286.5H210.352L214.547 273.766H217.844ZM214.742 282.273H217.844L216.281 277.578L214.742 282.273ZM223.547 286.5V273.766H226.656V284.539H232.117V286.5H223.547ZM239.75 273.766L244.008 286.5H240.898L240.016 283.703H236.25L235.367 286.5H232.258L236.453 273.766H239.75ZM236.648 282.273H239.75L238.188 277.578L236.648 282.273ZM248.711 279.219C249.289 279.219 249.797 279.198 250.234 279.156C250.677 279.115 251.044 279.029 251.336 278.898C251.633 278.768 251.857 278.586 252.008 278.352C252.159 278.112 252.234 277.799 252.234 277.414C252.234 277.07 252.182 276.789 252.078 276.57C251.974 276.352 251.802 276.18 251.562 276.055C251.323 275.93 251.005 275.844 250.609 275.797C250.219 275.745 249.734 275.719 249.156 275.719H248.57V279.219H248.711ZM251.523 280.164C252.086 280.221 252.607 280.318 253.086 280.453C253.565 280.583 253.977 280.773 254.32 281.023C254.669 281.273 254.943 281.594 255.141 281.984C255.339 282.375 255.438 282.857 255.438 283.43V286.5H252.359V283.219C252.359 282.812 252.297 282.474 252.172 282.203C252.047 281.927 251.862 281.708 251.617 281.547C251.372 281.38 251.07 281.263 250.711 281.195C250.352 281.128 249.938 281.094 249.469 281.094H248.57V286.5H245.453V273.766H248.797C249.672 273.766 250.44 273.797 251.102 273.859C251.768 273.922 252.344 274.016 252.828 274.141C253.312 274.266 253.714 274.422 254.031 274.609C254.354 274.792 254.612 275.005 254.805 275.25C254.997 275.49 255.133 275.76 255.211 276.062C255.294 276.365 255.336 276.693 255.336 277.047C255.336 277.609 255.242 278.083 255.055 278.469C254.867 278.849 254.604 279.159 254.266 279.398C253.927 279.638 253.523 279.818 253.055 279.938C252.591 280.052 252.081 280.128 251.523 280.164ZM261.93 282.188L264.438 273.766H267.375L263.414 286.5H260.367L256.414 273.766H259.312L261.93 282.188ZM279.969 280.141C279.969 281.167 279.852 282.086 279.617 282.898C279.383 283.711 279.026 284.401 278.547 284.969C278.073 285.531 277.474 285.964 276.75 286.266C276.026 286.568 275.174 286.719 274.195 286.719C273.216 286.719 272.365 286.57 271.641 286.273C270.922 285.971 270.323 285.539 269.844 284.977C269.365 284.409 269.008 283.721 268.773 282.914C268.539 282.102 268.422 281.185 268.422 280.164C268.422 279.128 268.539 278.201 268.773 277.383C269.013 276.56 269.372 275.867 269.852 275.305C270.331 274.737 270.932 274.305 271.656 274.008C272.38 273.706 273.227 273.555 274.195 273.555C275.169 273.555 276.018 273.706 276.742 274.008C277.466 274.31 278.065 274.745 278.539 275.312C279.018 275.875 279.375 276.565 279.609 277.383C279.849 278.195 279.969 279.115 279.969 280.141ZM271.531 280.117C271.531 280.706 271.568 281.266 271.641 281.797C271.714 282.323 271.849 282.786 272.047 283.188C272.245 283.583 272.516 283.898 272.859 284.133C273.203 284.367 273.648 284.484 274.195 284.484C274.747 284.484 275.198 284.365 275.547 284.125C275.896 283.88 276.167 283.557 276.359 283.156C276.557 282.75 276.69 282.284 276.758 281.758C276.831 281.232 276.867 280.685 276.867 280.117C276.867 279.534 276.828 278.982 276.75 278.461C276.677 277.935 276.539 277.474 276.336 277.078C276.138 276.682 275.865 276.37 275.516 276.141C275.172 275.906 274.729 275.789 274.188 275.789C273.641 275.789 273.195 275.906 272.852 276.141C272.508 276.375 272.237 276.693 272.039 277.094C271.846 277.49 271.714 277.948 271.641 278.469C271.568 278.99 271.531 279.539 271.531 280.117ZM289.688 281.234H286.836V279.359H292.414V286.5H290.383L290 285.547C289.891 285.75 289.737 285.924 289.539 286.07C289.341 286.216 289.112 286.339 288.852 286.438C288.596 286.531 288.318 286.602 288.016 286.648C287.719 286.695 287.411 286.719 287.094 286.719C286.255 286.719 285.5 286.586 284.828 286.32C284.156 286.055 283.583 285.656 283.109 285.125C282.641 284.589 282.279 283.919 282.023 283.117C281.768 282.31 281.641 281.37 281.641 280.297C281.641 279.266 281.779 278.336 282.055 277.508C282.331 276.674 282.734 275.966 283.266 275.383C283.802 274.794 284.461 274.344 285.242 274.031C286.023 273.714 286.919 273.555 287.93 273.555C288.482 273.555 288.969 273.591 289.391 273.664C289.818 273.737 290.188 273.828 290.5 273.938C290.812 274.042 291.07 274.151 291.273 274.266C291.482 274.38 291.646 274.479 291.766 274.562L290.875 276.633C290.641 276.529 290.401 276.427 290.156 276.328C289.917 276.224 289.674 276.133 289.43 276.055C289.19 275.977 288.951 275.914 288.711 275.867C288.477 275.815 288.242 275.789 288.008 275.789C287.492 275.789 287.031 275.888 286.625 276.086C286.224 276.284 285.883 276.576 285.602 276.961C285.326 277.341 285.115 277.812 284.969 278.375C284.823 278.938 284.75 279.586 284.75 280.32C284.75 280.888 284.799 281.424 284.898 281.93C285.003 282.435 285.161 282.878 285.375 283.258C285.589 283.633 285.859 283.932 286.188 284.156C286.516 284.375 286.904 284.484 287.352 284.484C287.799 284.484 288.211 284.451 288.586 284.383C288.966 284.315 289.333 284.229 289.688 284.125V281.234ZM300.008 284.484C300.372 284.484 300.68 284.443 300.93 284.359C301.18 284.271 301.383 284.148 301.539 283.992C301.701 283.831 301.823 283.638 301.906 283.414C301.99 283.185 302.049 282.93 302.086 282.648C302.122 282.367 302.143 282.062 302.148 281.734C302.154 281.401 302.156 281.052 302.156 280.688V273.766H305.266V280.656C305.266 281.672 305.167 282.56 304.969 283.32C304.776 284.076 304.469 284.706 304.047 285.211C303.625 285.711 303.081 286.089 302.414 286.344C301.747 286.594 300.943 286.719 300 286.719C299.062 286.719 298.26 286.594 297.594 286.344C296.932 286.089 296.391 285.711 295.969 285.211C295.547 284.706 295.237 284.076 295.039 283.32C294.841 282.56 294.742 281.672 294.742 280.656V273.766H297.859V280.688C297.859 281.052 297.859 281.398 297.859 281.727C297.865 282.055 297.883 282.359 297.914 282.641C297.951 282.922 298.01 283.177 298.094 283.406C298.177 283.635 298.297 283.831 298.453 283.992C298.615 284.148 298.82 284.271 299.07 284.359C299.32 284.443 299.633 284.484 300.008 284.484ZM310.883 279.219C311.461 279.219 311.969 279.198 312.406 279.156C312.849 279.115 313.216 279.029 313.508 278.898C313.805 278.768 314.029 278.586 314.18 278.352C314.331 278.112 314.406 277.799 314.406 277.414C314.406 277.07 314.354 276.789 314.25 276.57C314.146 276.352 313.974 276.18 313.734 276.055C313.495 275.93 313.177 275.844 312.781 275.797C312.391 275.745 311.906 275.719 311.328 275.719H310.742V279.219H310.883ZM313.695 280.164C314.258 280.221 314.779 280.318 315.258 280.453C315.737 280.583 316.148 280.773 316.492 281.023C316.841 281.273 317.115 281.594 317.312 281.984C317.51 282.375 317.609 282.857 317.609 283.43V286.5H314.531V283.219C314.531 282.812 314.469 282.474 314.344 282.203C314.219 281.927 314.034 281.708 313.789 281.547C313.544 281.38 313.242 281.263 312.883 281.195C312.523 281.128 312.109 281.094 311.641 281.094H310.742V286.5H307.625V273.766H310.969C311.844 273.766 312.612 273.797 313.273 273.859C313.94 273.922 314.516 274.016 315 274.141C315.484 274.266 315.885 274.422 316.203 274.609C316.526 274.792 316.784 275.005 316.977 275.25C317.169 275.49 317.305 275.76 317.383 276.062C317.466 276.365 317.508 276.693 317.508 277.047C317.508 277.609 317.414 278.083 317.227 278.469C317.039 278.849 316.776 279.159 316.438 279.398C316.099 279.638 315.695 279.818 315.227 279.938C314.763 280.052 314.253 280.128 313.695 280.164Z",
                fill: "#0A3A5C"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                clipPath: "url(#clip1_1571_66718)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M180.818 282.694C180.818 288.288 172.818 297.42 172.818 297.42C172.818 297.42 164.818 288.288 164.818 282.694C164.818 276.961 168.952 273.633 172.818 273.633C176.684 273.633 180.818 276.961 180.818 282.694Z",
                        stroke: "#0A3A5C",
                        strokeWidth: "2",
                        strokeMiterlimit: "10",
                        strokeLinecap: "square"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M172.818 286.092C174.475 286.092 175.818 284.571 175.818 282.694C175.818 280.817 174.475 279.296 172.818 279.296C171.161 279.296 169.818 280.817 169.818 282.694C169.818 284.571 171.161 286.092 172.818 286.092Z",
                        stroke: "#0A3A5C",
                        strokeWidth: "2",
                        strokeMiterlimit: "10",
                        strokeLinecap: "square"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M56.4453 307.234H53.5938V305.359H59.1719V312.5H57.1406L56.7578 311.547C56.6484 311.75 56.4948 311.924 56.2969 312.07C56.099 312.216 55.8698 312.339 55.6094 312.438C55.3542 312.531 55.0755 312.602 54.7734 312.648C54.4766 312.695 54.1693 312.719 53.8516 312.719C53.013 312.719 52.2578 312.586 51.5859 312.32C50.9141 312.055 50.3411 311.656 49.8672 311.125C49.3984 310.589 49.0365 309.919 48.7812 309.117C48.526 308.31 48.3984 307.37 48.3984 306.297C48.3984 305.266 48.5365 304.336 48.8125 303.508C49.0885 302.674 49.4922 301.966 50.0234 301.383C50.5599 300.794 51.2188 300.344 52 300.031C52.7812 299.714 53.6771 299.555 54.6875 299.555C55.2396 299.555 55.7266 299.591 56.1484 299.664C56.5755 299.737 56.9453 299.828 57.2578 299.938C57.5703 300.042 57.8281 300.151 58.0312 300.266C58.2396 300.38 58.4036 300.479 58.5234 300.562L57.6328 302.633C57.3984 302.529 57.1589 302.427 56.9141 302.328C56.6745 302.224 56.4323 302.133 56.1875 302.055C55.9479 301.977 55.7083 301.914 55.4688 301.867C55.2344 301.815 55 301.789 54.7656 301.789C54.25 301.789 53.7891 301.888 53.3828 302.086C52.9818 302.284 52.6406 302.576 52.3594 302.961C52.0833 303.341 51.8724 303.812 51.7266 304.375C51.5807 304.938 51.5078 305.586 51.5078 306.32C51.5078 306.888 51.5573 307.424 51.6562 307.93C51.7604 308.435 51.9193 308.878 52.1328 309.258C52.3464 309.633 52.6172 309.932 52.9453 310.156C53.2734 310.375 53.6615 310.484 54.1094 310.484C54.5573 310.484 54.9688 310.451 55.3438 310.383C55.724 310.315 56.0911 310.229 56.4453 310.125V307.234ZM64.8594 305.219C65.4375 305.219 65.9453 305.198 66.3828 305.156C66.8255 305.115 67.1927 305.029 67.4844 304.898C67.7812 304.768 68.0052 304.586 68.1562 304.352C68.3073 304.112 68.3828 303.799 68.3828 303.414C68.3828 303.07 68.3307 302.789 68.2266 302.57C68.1224 302.352 67.9505 302.18 67.7109 302.055C67.4714 301.93 67.1536 301.844 66.7578 301.797C66.3672 301.745 65.8828 301.719 65.3047 301.719H64.7188V305.219H64.8594ZM67.6719 306.164C68.2344 306.221 68.7552 306.318 69.2344 306.453C69.7135 306.583 70.125 306.773 70.4688 307.023C70.8177 307.273 71.0911 307.594 71.2891 307.984C71.487 308.375 71.5859 308.857 71.5859 309.43V312.5H68.5078V309.219C68.5078 308.812 68.4453 308.474 68.3203 308.203C68.1953 307.927 68.0104 307.708 67.7656 307.547C67.5208 307.38 67.2188 307.263 66.8594 307.195C66.5 307.128 66.0859 307.094 65.6172 307.094H64.7188V312.5H61.6016V299.766H64.9453C65.8203 299.766 66.5885 299.797 67.25 299.859C67.9167 299.922 68.4922 300.016 68.9766 300.141C69.4609 300.266 69.862 300.422 70.1797 300.609C70.5026 300.792 70.7604 301.005 70.9531 301.25C71.1458 301.49 71.2812 301.76 71.3594 302.062C71.4427 302.365 71.4844 302.693 71.4844 303.047C71.4844 303.609 71.3906 304.083 71.2031 304.469C71.0156 304.849 70.7526 305.159 70.4141 305.398C70.0755 305.638 69.6719 305.818 69.2031 305.938C68.7396 306.052 68.2292 306.128 67.6719 306.164ZM80.0547 299.766L84.3125 312.5H81.2031L80.3203 309.703H76.5547L75.6719 312.5H72.5625L76.7578 299.766H80.0547ZM76.9531 308.273H80.0547L78.4922 303.578L76.9531 308.273ZM93.3594 312.5L88.5156 304.094V312.5H85.7578V299.766H89.0391L93.7969 308.047V299.766H96.5469V312.5H93.3594ZM106.422 306.164C106.422 305.716 106.404 305.297 106.367 304.906C106.331 304.51 106.263 304.148 106.164 303.82C106.065 303.492 105.924 303.201 105.742 302.945C105.565 302.685 105.333 302.466 105.047 302.289C104.76 302.107 104.411 301.969 104 301.875C103.594 301.776 103.109 301.727 102.547 301.727H102.125V310.539H102.562C103.328 310.539 103.958 310.432 104.453 310.219C104.953 310.005 105.349 309.708 105.641 309.328C105.932 308.943 106.135 308.482 106.25 307.945C106.365 307.409 106.422 306.815 106.422 306.164ZM109.547 306.203C109.547 307.229 109.411 308.135 109.141 308.922C108.875 309.703 108.469 310.359 107.922 310.891C107.375 311.422 106.685 311.823 105.852 312.094C105.018 312.365 104.039 312.5 102.914 312.5H99.0078V299.766H102.93C105.133 299.766 106.786 300.305 107.891 301.383C108.995 302.461 109.547 304.068 109.547 306.203ZM112.328 311.086V301.188H110.984V299.766H116.812V301.188H115.453V311.086H116.812V312.5H110.984V311.086H112.328Z",
                fill: "#0A3A5C"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M143 297.562C143 303.155 135 312.287 135 312.287C135 312.287 127 303.155 127 297.562C127 291.828 131.134 288.5 135 288.5C138.866 288.5 143 291.828 143 297.562Z",
                stroke: "#0A3A5C",
                strokeWidth: "2",
                strokeMiterlimit: "10",
                strokeLinecap: "square"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M135 300.959C136.657 300.959 138 299.438 138 297.561C138 295.684 136.657 294.163 135 294.163C133.343 294.163 132 295.684 132 297.561C132 299.438 133.343 300.959 135 300.959Z",
                stroke: "#0A3A5C",
                strokeWidth: "2",
                strokeMiterlimit: "10",
                strokeLinecap: "square"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M364.969 102.164L369.227 114.898H366.117L365.234 112.102H361.469L360.586 114.898H357.477L361.672 102.164H364.969ZM361.867 110.672H364.969L363.406 105.977L361.867 110.672ZM373.789 114.898H370.672V102.164H373.789V107.633H374.336L377.82 102.164H381.086L376.797 108.508L381.516 114.898H378.016L374.273 109.547H373.789V114.898ZM387.836 112.883C388.201 112.883 388.508 112.841 388.758 112.758C389.008 112.669 389.211 112.547 389.367 112.391C389.529 112.229 389.651 112.036 389.734 111.812C389.818 111.583 389.878 111.328 389.914 111.047C389.951 110.766 389.971 110.461 389.977 110.133C389.982 109.799 389.984 109.451 389.984 109.086V102.164H393.094V109.055C393.094 110.07 392.995 110.958 392.797 111.719C392.604 112.474 392.297 113.104 391.875 113.609C391.453 114.109 390.909 114.487 390.242 114.742C389.576 114.992 388.771 115.117 387.828 115.117C386.891 115.117 386.089 114.992 385.422 114.742C384.76 114.487 384.219 114.109 383.797 113.609C383.375 113.104 383.065 112.474 382.867 111.719C382.669 110.958 382.57 110.07 382.57 109.055V102.164H385.688V109.086C385.688 109.451 385.688 109.797 385.688 110.125C385.693 110.453 385.711 110.758 385.742 111.039C385.779 111.32 385.839 111.576 385.922 111.805C386.005 112.034 386.125 112.229 386.281 112.391C386.443 112.547 386.648 112.669 386.898 112.758C387.148 112.841 387.461 112.883 387.836 112.883ZM398.711 107.617C399.289 107.617 399.797 107.596 400.234 107.555C400.677 107.513 401.044 107.427 401.336 107.297C401.633 107.167 401.857 106.984 402.008 106.75C402.159 106.51 402.234 106.198 402.234 105.812C402.234 105.469 402.182 105.188 402.078 104.969C401.974 104.75 401.802 104.578 401.562 104.453C401.323 104.328 401.005 104.242 400.609 104.195C400.219 104.143 399.734 104.117 399.156 104.117H398.57V107.617H398.711ZM401.523 108.562C402.086 108.62 402.607 108.716 403.086 108.852C403.565 108.982 403.977 109.172 404.32 109.422C404.669 109.672 404.943 109.992 405.141 110.383C405.339 110.773 405.438 111.255 405.438 111.828V114.898H402.359V111.617C402.359 111.211 402.297 110.872 402.172 110.602C402.047 110.326 401.862 110.107 401.617 109.945C401.372 109.779 401.07 109.661 400.711 109.594C400.352 109.526 399.938 109.492 399.469 109.492H398.57V114.898H395.453V102.164H398.797C399.672 102.164 400.44 102.195 401.102 102.258C401.768 102.32 402.344 102.414 402.828 102.539C403.312 102.664 403.714 102.82 404.031 103.008C404.354 103.19 404.612 103.404 404.805 103.648C404.997 103.888 405.133 104.159 405.211 104.461C405.294 104.763 405.336 105.091 405.336 105.445C405.336 106.008 405.242 106.482 405.055 106.867C404.867 107.247 404.604 107.557 404.266 107.797C403.927 108.036 403.523 108.216 403.055 108.336C402.591 108.451 402.081 108.526 401.523 108.562ZM407.438 114.898V102.164H416.156V104.125H410.547V107.367H415.43V109.281H410.547V112.984H416.227V114.898H407.438ZM424.156 102.164H427.312L423.203 110.688V114.898H420.266V110.688L416.211 102.164H419.312L421.727 107.422L424.156 102.164ZM431.195 107.617C431.773 107.617 432.281 107.596 432.719 107.555C433.161 107.513 433.529 107.427 433.82 107.297C434.117 107.167 434.341 106.984 434.492 106.75C434.643 106.51 434.719 106.198 434.719 105.812C434.719 105.469 434.667 105.188 434.562 104.969C434.458 104.75 434.286 104.578 434.047 104.453C433.807 104.328 433.49 104.242 433.094 104.195C432.703 104.143 432.219 104.117 431.641 104.117H431.055V107.617H431.195ZM434.008 108.562C434.57 108.62 435.091 108.716 435.57 108.852C436.049 108.982 436.461 109.172 436.805 109.422C437.154 109.672 437.427 109.992 437.625 110.383C437.823 110.773 437.922 111.255 437.922 111.828V114.898H434.844V111.617C434.844 111.211 434.781 110.872 434.656 110.602C434.531 110.326 434.346 110.107 434.102 109.945C433.857 109.779 433.555 109.661 433.195 109.594C432.836 109.526 432.422 109.492 431.953 109.492H431.055V114.898H427.938V102.164H431.281C432.156 102.164 432.924 102.195 433.586 102.258C434.253 102.32 434.828 102.414 435.312 102.539C435.797 102.664 436.198 102.82 436.516 103.008C436.839 103.19 437.096 103.404 437.289 103.648C437.482 103.888 437.617 104.159 437.695 104.461C437.779 104.763 437.82 105.091 437.82 105.445C437.82 106.008 437.727 106.482 437.539 106.867C437.352 107.247 437.089 107.557 436.75 107.797C436.411 108.036 436.008 108.216 435.539 108.336C435.076 108.451 434.565 108.526 434.008 108.562ZM440.633 113.484V103.586H439.289V102.164H445.117V103.586H443.758V113.484H445.117V114.898H439.289V113.484H440.633Z",
                fill: "#0A3A5C"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                clipPath: "url(#clip2_1571_66718)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M352.818 107.694C352.818 113.288 344.818 122.42 344.818 122.42C344.818 122.42 336.818 113.288 336.818 107.694C336.818 101.961 340.952 98.6328 344.818 98.6328C348.684 98.6328 352.818 101.961 352.818 107.694Z",
                        stroke: "#0A3A5C",
                        strokeWidth: "2",
                        strokeMiterlimit: "10",
                        strokeLinecap: "square"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M344.818 111.092C346.475 111.092 347.818 109.571 347.818 107.694C347.818 105.817 346.475 104.296 344.818 104.296C343.161 104.296 341.818 105.817 341.818 107.694C341.818 109.571 343.161 111.092 344.818 111.092Z",
                        stroke: "#0A3A5C",
                        strokeWidth: "2",
                        strokeMiterlimit: "10",
                        strokeLinecap: "square"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("pattern", {
                        id: "pattern0",
                        patternContentUnits: "objectBoundingBox",
                        width: "1",
                        height: "1",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("use", {
                            xlinkHref: "#image0_1571_66718",
                            transform: "translate(-0.00116963) scale(0.000480969 0.000703235)"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                        id: "clip0_1571_66718",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                            x: "143",
                            y: "296.5",
                            width: "24",
                            height: "27.1848",
                            rx: "12",
                            fill: "white"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                        id: "clip1_1571_66718",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                            x: "161",
                            y: "272.5",
                            width: "24",
                            height: "27.1848",
                            rx: "12",
                            fill: "white"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                        id: "clip2_1571_66718",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                            x: "333",
                            y: "97.5",
                            width: "24",
                            height: "27.1848",
                            rx: "12",
                            fill: "white"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("image", {
                        id: "image0_1571_66718",
                        width: "2084",
                        height: "1422",
                        xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAACCQAAAWOCAYAAACxfGTyAAAAAXNSR0IArs4c6QAAIABJREFUeF7s3V1y20YX4P3TEtEyFFfZXoGVFURZgZkVWM8KTK8g9NVcmr5778KsINQKotQsINIKwqwg0gKmLFYlggSQ7LeapGxJ5ge+Pxp/Vk3NMxOg+5xfwzYJHJxWwgcBBBBAAAEEEEAAAQQQQAABBBBAAAEEvhEIoqh72+mMXyl1DQ8CCCCAAAIIIIAAAggggEByAZX8FM5AAAEEEEAAAQQQQAABBBBAAAEEEECgHQJBGPZ8rUftyJYsEUAAAQQQQAABBBBAAIF8BShIyNeT0RBAAAEEEEAAAQQQQAABBBBAAAEEHBL47256Eur9c7okOLSopIIAAggggAACCCCAAAKlCVCQUBo1EyGAAAIIIIAAAggggAACCCCAAAIINFHg3zA8fq71uImxEzMCCCCAAAIIIIAAAgggUKUABQlV6jM3AggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACjgpQkODowpIWAggggAACCCCAAAIIIIAAAggggEA2geAuGoiSrigZ+J53nm00zkYAAQQQQAABBBBAAAEE2idAQUL71pyMEUAAAQQQQAABBBBAAAEEEEAAAQRiCARhZIsQ3qwOvaAwIQYahyCAAAIIIIAAAggggAACDwQoSOByQAABBBBAAAEEEEAAAQQQQAABBBBAYI1AEEbXIvLiyX+iMIGrBQEEEEAAAQQQQAABBBCIKUBBQkwoDkMAAQQQQAABBBBAAAEEEEAAAQQQaI9AEARHst/5Z2PGSn5iG4f2XA9kigACCCCAAAIIIIAAAukEKEhI58ZZCCCAAAIIIIAAAggggAACCCCAAAIOC/x3Nz3ZU+b3TSneep1Xr5SyHRT4IIAAAggggAACCCCAAAIIbBCgIIFLAwEEEEAAAQQQQAABBBBAAAEEEEAAgScCwV00ECUfN8H42uO+GlcNAggggAACCCCAAAIIILBDgB9OXCIIIIAAAggggAACCCCAAAIIIIAAAgg8EQjC6FxE3myCoSCBSwYBBBBAAAEEEEAAAQQQ2C1AQcJuI45AAAEEEEAAAQQQQAABBBBAAAEEEGiZQBBG99sxjEXMkYh6fU9gRP4+1N5xy0hIFwEEEEAAAQQQQAABBBBILEBBQmIyTkAAAQQQQAABBBBAAAEEEEAAAQQQcF3g3zA8fq71+D7PJx0TLnztdV03ID8EEEAAAQQQQAABBBBAIKsABQlZBTkfAQQQQAABBBBAAAEEEEAAAQQQQMB5geAuGoiSjzZRI+bDodZD55MmQQQQQAABBBBAAAEEEEAgowAFCRkBOR0BBBBAAAEEEEAAAQQQQAABBBBAwH2BBwUJE5lNj33fv3Q/azJEAAEEEEAAAQQQQAABBLIJUJCQzY+zEUAAAQQQQAABBBBAAAEEEEAAAQRaIHBfkEB3hBYsNikigEDpAp+NefksioZGqZdizLlSaux73nnpgTAhAggggAACCOQuQEFC7qQMiAACCCCAAAIIIIAAAggggAACCCDgmsB/d9OTPTU/8bXuuZYb+SCAAAJVCvwbhsf7Imci6vWaOC6MyFiJGc9Exs+1HlcZK3MjgAACCCCAQHIBChKSm3EGAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIZBQIwrAnooYi8iLuUEbkb1ugIEZdyp6cy3R6yTY6cfU4DgEEEEAAgfIFKEgo35wZEUAAAQQQQAABBBBAAAEEEEAAAQQQQAABBBBotcCy84z5PS+EZaGCXIuRc6PMtd32gWKFvHQZBwEEEEAAgfQCFCSkt+NMBBBAAAEEEEAAAQQQQAABBBBAAAEEEEAAAQQQSCiw3KZBnSfpjJBwikeH3xcrLLZ/MHI9FzXe2zPXvufZGPgggAACCCCAQIECFCQUiMvQCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggg8FggCCNbCPCmRi4Xi1jorlCjJSEUBBBAAAFXBChIcGUlyQMBBBBAAAEEEEAAAQQQQAABBBBAAAEEEEAAgZoLBFHUFSN/1jzMh+FdGCXXai5jmU9Hvu9fNih2QkUAAQQQQKByAQoSKl8CAkAAAQQQQAABBBBAAAEEEEAAAQQQQAABBBBAoB0CQRiORNS7Rmar5Ce2eWjkyhE0AggggECFAhQkVIjP1AgggAACCCCAAAIIIIAAAggggAACCCCAAAIIpBX4bMxLHc66SpmuMnLtH3iDtGOVdV4Qhpci6nVZ8+U6DwUJuXIyGAIIIIBAOwQoSGjHOpMlAggggAACCCCAAAIIIIAAAggggAACCCCAgAMC/91NT2wBgoh0lcgPX1Iy8iluQYItZHil1HXZHEEQHMl+55+y581tPgoScqNkIAQQQACB9ghQkNCetSZTBBBAAAEEEEAAAQQQQAABBBBAAAEEEEAAgQYK2AKCZ+G0L0r6IvJiXQpzo/733UHnLE56y20TRHyte3GOz+sYW0yxp8zveY1X+jgJij5Kj40JEUAAAQQQqKkABQk1XRjCQgABBBBAAAEEEEAAAQQQQAABBBBAAAEEEEAgCMOeiBpuKkT4IjSbfu/7/uUusSCKumLkz+Vx5jTvooRFvEYdzZQ5e671+GE8wV00ECUfd8VY1/9uRP4+1N5xXeMjLgQQQAABBOooQEFCHVeFmBBAAAEEEEAAAQQQQAABBBBAAAEEEEAAAQRaLbDoihBNbceDN3EgfO3Fut9/E0bjR1s95FyUEISRWcU7mYnpPixKuImiM2XkbZx8antMzMKP2sZPYAgggAACCJQsEOsLSskxMR0CCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAq0QsNsnPO1SYIsRDqLp+ePCga0cF772urvANnYoUPKT73nnu87f9d9XRRSfHxz3qCghCMNLEfV61zj1/u/5d5Wod75EhwACCCCAQDYBChKy+XE2AggggAACCCCAAAIIIIAAAggggAACCCCAAAKpBP67m57sKfP70+4GtkhBRL2LO6gR+fVQe/1txz/equHpkea9r/Uo7nybjtswx5eihAfdE7JOVen5MzE/Pt2OotKAmBwBBBBAAIEaC1CQUOPFITQEEEAAAQQQQAABBBBAAAEEEEAAAQQQQAABNwWCIDiS/c5YRF48LEhY02VgN4CRT/6BN9h04L9heLwvynZAeLHumDgFDbuDEAnCsCeifltz7MSIGShRv8QZp+7HGJG/D7V3XPc4iQ8BBBBAAIE6CFCQUIdVIAYEEEAAAQQQQAABBBBAAAEEEEAAAQQQQACBVgkEYWQLBN7YpB8WJGx5qL/RZ27U/7476JytOyDe9g/mytf6KOsCbNwSIuvANTw/ryKOGqZGSAgggAACCOQqQEFCrpwMhgACCCCAAAIIIIAAAggggAACCCCAAAIIIIDAdoGHD+6fvm1/E0ZDJfJzIkMlP/meZwscvvk8LHzYOuaWMeLGchNFZ8rI27jHN/+4fLa6aL4DGSCAAAIIILBZgIIErg4EEEAAAQQQQAABBBBAAAEEEEAAAQQQQAABBEoSWG2f8NeD6S587XXv/9+xCwgeDGDEfDjUevg0hYQdCx7FkYYjTexp5qnROZOZmO5zre3WG3wQQAABBBBAYI0ABQlcFggggAACCCCAAAIIIIAAAggggAACCCCAAAIIlCBgt094FkVjEfX6wXSZCxJEzKmvde9hCkEQHMl+558kaW3b+iHOOEEYmTjHuXWMubr1vONXSl27lRfZIIAAAgggkI8ABQn5ODIKAggggAACCCCAAAIIIIAAAggggAACCCCAAAJbBYIwHImodw8PerplQ+qH+rPp977vX96PnWrrB5HJrdc5SvNwfVlsMf3cxkvAKPnj0PNO2pg7OSOAAAIIILBLgIKEXUL8dwQQQAABBBBAAAEEEEAAAQQQQAABBBBAAAEEMgr8dzc92VPm9/XDmPe+1iP731IXJIg86bQQXj7pxBArg7QP14Mo6oqRP2NN4uBBm7bNcDBVUkIAAQQQQCCRAAUJibg4GAEEEEAAAQQQQAABBBBAAAEEEEAAAQQQQACBZAKr7RPGIvJi85nLooQMBQlyv3VD1m4FabZuuAnDvhL1SzIZp46eyGx6/LBLhVPZkQwCCCCAAAIpBShISAnHaQgggAACCCCAAAIIIIAAAggggAACCCCAAAIIxBEIwuhcRN7sPta8F1G/7T5u8xG2w4GZq9HmbgyxRk/8cD0I03VkiBVNQw5K212iIekRJgIIIIAAAqkEKEhIxcZJCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAgjsFmjqVgZJHq4HYdjLWkixW7IZR8zE/Phca9sNgw8CCCCAAAIIiAgFCVwGCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggUJNDUggTLEXfrBrojPLx4zKmvda+gy4lhEUAAAQQQaJwABQmNWzICRgABBBBAAAEEEEAAAQQQQAABBBBAAAEEEGiKwGdjXj6Lpp+bEi9xxhUwp6LU6OnRM2Ou6ZAQ15DjEEAAAQTaIEBBQhtWmRwRQAABBBBAAAEEEEAAAQQQQAABBBBAAAEEKhMIwshUNjkTFyNg5JN/4A2KGZxREUAAAQQQcEeAggR31pJMEEAAAQQQQAABBBBAAAEEEEAAAQQQQAABBGoocBNGYyXyQw1DI6S0AhQkpJXjPAQQQACBlglQkNCyBSddBBBAAAEEEEAAAQQQQAABBBBAAAEEEEAAgXIFgjA6F5E35c7KbIUKUJBQKC+DI4AAAgi4I0BBgjtrSSYIOC0QRFHXJnjb6YxfKXXtdLKr5P4Nw+N9pV6WkXMQBEe+71+2wZUcEUAAAQQQQAABBBBAAAEEEEAAgbIFgrtoIEo+lj0v8xUoQEFCgbgMjQACCCDgkgAFCS6tJrkg4LDA0ypyI/K3KLlUcxnLnpz7nmerzJ363ETRmTLy1uY6F9N7rvW4qAQ/G/PyIIp6h1oPi5qDcRFAAAEEEEAAAQQQQAABBBBAAIG2CgRh2BNRv7U1fyfzpiDByWUlKQQQQACB/AUoSMjflBERQKAAgZsw7CtRv+wY+kKMnM+UOSvy4X0B6a0d8knl/ESUnBRZeLGuKMF2abDBueBZ1roxDwIIIIAAAggggAACCCCAAAIIIPBUYNEJU9RfyDgkQEGCQ4tJKggggAACRQpQkFCkLmMjgEBuAostG4z8GX9Ac2VEnc3FjJr6MP2/u+nJnjK/P8zZiPlQZBeDp0UJQRheilK9Igsh4q8pRyKAAAIIIIAAAggggAACCCCAAALNFQjCyDQ3eiL/RoCCBC4KBBBAAAEEYglQkBCLiYMQQKAOAml/tC22dxAzuvO80SulruuQS5wYNlfOm1Nf616cMdIcY4sSrNOXDg1KfqIgIY0k5yCAAAIIIIAAAggggAACCCCAAAJfBW7CaKxEfsDEGYELX3tdZ7IhEQQQQAABBAoSoCChIFiGRQCB/AXSFiQ8iGQiYs5kNhv4vn+Zf4T5j7gpZ1tkced1ukUWWCy6I4h6LWLe+1qP8s+OERFAAAEEEEAAAQQQQAABBBBAAIH2CARhOBJR79qTsfOZUpDg/BKTIAIIIIBAHgIUJOShyBgIIFCKwNcH5HlMZ06bUJiwvXLeXM1ETorYkiIIgiPZ7/zzVZqihDyuOsZAAAEEEEAAAQQQQAABBBBAAIH2CgRh2BNRv7VXwLnMKUhwbklJCAEEEECgCAEKEopQZUwEEChEIAgju93Ci3wHr3dhwk0UnSkjb7fkPJkb1fvuoHOWp0sQRV0x8uejMdm6IU9ixkIAAQQQQAABBBBAAAEEEEAAgZYJbN6es2UQ7qRLQYI7a0kmCCCAAAIFClCQUCAuQyOAQL4COWzZsDEgI/LrndcZFLkFQhqN4C4aiJKPu841Yj4caj3cdVzc/762IEFkIrPpcVO2u4ibK8chgAACCCCAAAIIIIAAAggggAACZQkU88JNWdEzzxMBChK4JBBAAAEEEIghQEFCDCQOQQCB6gW+3UKgkJgK6TaQJdL/7qYne8r8Hm8Mc+pr3Yt37PajNhQkiBH5+1B7x3nMwRgIIIAAAggggAACCCCAAAIIIIBA2wSCMDoXkTdty9vRfClIcHRhSQsBBBBAIF8BChLy9WQ0BBAoSCDZg/lsQRglf9x1Or06dEtImrctGLjzOt2ssW8tADHyyT/wBtmUORsBBBBAAAEEEEAAAQQQQAABBBBon0Dcbpjtk2lkxhQkNHLZCBoBBBBAoGwBChLKFmc+BBBIJRCE4UhEvUt1cqqTzNVM5OS51uNUp+d0Urqq+Xxi39ZCcCbmx6ptciJmGAQQQAABBBBAAAEEEEAAAQQQQKA0gU1dKUsLgInyFJj42nuZ54CMhQACCCCAgIsCFCS4uKrkhIBjAp+Nefksmn6uIK1Kt3DI+AM1c+w7iiGoAK/ggmRKBBBAAAEEEEAAAQQQQAABBBBovkAQRqb5WZCBFfC1xzMWLgUEEEAAAQR2CPCPJZcIAgjUXuAmjIZK5OeqAp0b9b/vDjpnZc+frjvC4yiNmA+HWg/TxL67haB572s9SjM25yCAAAIIIIAAAggggAACCCCAAAJtFcjjnk9b7eqWN11E67YixIMAAgggUEcBChLquCrEhAACXwT+DcPjfVF/VUwykdn02Pf9y7LiyNgd4UmY5tTXupc09hgxTG69ztErpa6Tjs3xCCCAAAIIIIAAAggggAACCCCAQFsFdr8E0laZ5uVd1YtMzZMiYgQQQACBNgtQkNDm1Sd3BFIILAoEjDrxD7xBitMTnbLcqiEai6jXiU4s5GBzJaJWBQnmUoy6nClz9lzrcRHT5V0pb0T+vvM63aTFAztbCBr5VMa1UIQxYyKAAAIIIIAAAggggAACCCCAAAJVCNTkBZwqUnduTiPy66H2+s4lRkIIIIAAAgjkKEBBQo6YDIWA6wKrH0vnIvJCpNh2/bYY4SCaniuRH2ruenHrdU6SPujfllOMzgQpSczVTOQkSRFFrMKI2fT7MrtHpEye0xBAAAEEEEAAAQQQQAABBBBAAIHaCARhZDtOvqhNQASSSsC+BHSoveNUJ3MSAggggAACLRGgIKElC02aCOQhcBNG48cFAsUUJTwufMgj8qLHSLclwqaoYhUBpE9pMjeq991B5yzOEPFaCOabf5y4OAYBBBBAAAEEEEAAAQQQQAABBBBossBNFJ0pI2+bnAOxrwR4WYdLAQEEEEAAga0CFCRwgSCAQCyBTQ+mbVuyO68zyKNDwGKLhnDaFyUfYwVVn4MmvvZe5hFOcd0RHkdnxHw41Hq4K+b/7qYne8r8vus44YfXTiIOQAABBBBAAAEEEEAAAQQQQAABBO4FbsKwr0T9gogDAmxp6sAikgICCCCAQJECFCQUqcvYCDgkEIThpYh6vT4lcyUig1vPO0tTmBAEwZHsdXqixO631sxWdUp+8j3PbmeR6VNwd4Qnse3ubLBYm/3OP7uT2j3W7jE4AgEEEEAAAQQQQAABBBBAAAEEEGiHQPx7Lu3waHiWk1uvc5TmvmjD8yZ8BBBAAAEEYglQkBCLiYMQaLfAaguFv2IoTESM3QrgfCYyfq71eN05i04I0+mxzKVrlJw83gYixiw1PMR2ijjUni2oSP0pqzvCwwDtPnd3Xqe76QdT7A4JdlC6JKRee05EAAEEEEAAAQQQQAABBBBAAIH2CWx/Aah9Ho3OmC4JjV4+gkcAAQQQKFaAgoRifRkdAScEsj0ot90T1KWFMCIvXSg+WL+o5srX+ijLgpfbHeFhpOZqJnLytIBkUTgSTe3axetawQ+vLMvPuQgggAACCCCAAAIIIIAAAggg0DKBIAxHIupdy9J2Nd2JzKbHvu8v7oPyQQABBBBAAIGvAhQkcDUggMBOAVrI7SRaHDA36n/fHXRsh4jEn2xFH4mnW3fCZG5U72H8N1F0poy8TTA67ekSYHEoAggggAACCCCAAAIIIIAAAgi0WyAIw56I+q3dCk5lf+Frr+tURiSDAAIIIIBADgIUJOSAyBAItEGAFnK7V9luf3CovePdRy6PsB0IdDjrKmW6SsyJiHod99yijjNiPhxqPUy0VcOjYMx7X+tRUfExLgIIIIAAAggggAACCCCAAAIIIOCKwKo75WdX8iEPK2BOfa17WCCAAAIIIIDAVwEKErgaEEAglgAV27GY5P6B/rqjHxYgiEi3vttXmFMRdRJ7q4YHySYtyoinylEIIIAAAggggAACCCCAAAIIIICAmwI3YTSu7z0iN82LzsreHzRm73JPzLcvLu3JuUynl2ztUPQqMD4CCCCAQJ0EKEio02oQCwI1F0jRwr/mGRUS3pf94ppTgJCzw2z6PT+qcjZlOAQQQAABBBBAAAEEEEAAAQQQcFLgJoyGSuRnJ5MjqW0CE6PkXIw5V7PZGffSuFgQQAABBFwWoCDB5dUlNwRyFrAP2A+i6TlV27tgzZURdd1WJyPy66H2+ruU+O8IIIAAAggggAACCCCAAAIIIIBA2wXSb5vZdjm38rddR0XMiOIEt9aVbBBAAAEElgIUJHAlIIBAIgGKEhJxtfJgtm1o5bKTNAIIIIAAAggggAACCCCAAAIIpBCw99qeRdPPKU7lFEcF7L01JWZ463lnr5S6djRN0kIAAQQQaJEABQktWmxSRSAvAYoS8pJ0eBy2bXB4cUkNAQQQQAABBBBAAAEEEEAAAQTyFAjC8FJEvc5zTMZyQmAiYs5mIsPnWo+dyIgkEEAAAQRaKUBBQiuXnaQRyC6wrN6OhiLqXfbRGME9AfPe13rkXl5khAACCCCAAAIIIIAAAggggAACCOQrEIThiHts+Zq6NhpdE1xbUfJBAAEE2iVAQUK71ptsEchdILiLBqLkY+4DM2CjBYzIr4fa6zc6CYJHAAEEEEAAAQQQQAABBBBAAAEEShC4CcO+EvVLCVMxRfMFJkZkpGbToe/7l81PhwwQQAABBNogQEFCG1aZHBEoWOC/u+nJnjL2bfgXBU/F8M0RuPC1121OuESKAAIIIIAAAggggAACCCCAAAIIVCPwbxge74v6q5rZmbXBAhciZkSX0gavIKEjgAACLRGgIKElC02aCBQtEATBkdnvnCmRH4qei/GbIGCufK2PmhApMSKAAAIIIIAAAggggAACCCCAAAJVCwRhZKqOgfkbK7DomjAXM3qu9bixWRA4AggggICzAhQkOLu0JIZA+QKfjXn5LIqG7HlXvn0dZ/S1x78xdVwYYkIAAQQQQAABBBBAAAEEEEAAgdoJ3ITRmBd9arcsjQvIiPxtuyao2eyMLR0at3wEjAACCDgrwMMiZ5eWxBCoTiAIw56I+q26CJi5agH74+dQe8dVx8H8CCCAAAIIIIAAAggggAACCCCAQBMEgjAc8ZJPE1aqOTFSnNCctSJSBBBAwHUBChJcX2HyQ6AigdXed+ci8qKiEJi2UgFz6mvdqzQEJkcAAQQQQAABBBBAAAEEEEAAAQQaIhDcRQNR8rEh4RJmwwSWxQlybow6D/X++SulrhuWAuEigAACCDRYgIKEBi8eoSNQdwG7hcNBND2n3VzdVyr/+OyPHCVmeOt5Z/zAyd+XERFAAAEEEEAAAQQQQAABBBBAwC2BIIq6YuRPt7Iim7oKsNVqXVeGuBBAAAE3BShIcHNdyQqB2gjYooRnUTSk5VxtlqSCQMzp3OydfXfQOatgcqZEAAEEEEAAAQQQQAABBBBAAAEEai+w6jb6V+0DJUAnBChIcGIZSQIBBBBojAAFCY1ZKgJFoNkCN2E0VCI/NzsLos8mYK6MqDM1mw5937/MNhZnI4AAAggggAACCCCAAAIIIIAAAm4JBGFk3MqIbOoqQEFCXVeGuBBAAAE3BShIcHNdyQqBWgpQlFDLZakkKLZ0qISdSRFAAAEEEEAAAQQQQAABBBBAoMYCFCTUeHEcC42CBMcWtEHpBEFwJPv7g5nI8LnW4waFTqgIIJBBgIKEDHicigACyQRuouhMGXmb7CyOdl+ALR3cX2MyRAABBBBAAAEEEEAAAQQQQACBXQJBGJ2LyJtdx/HfEcgqQEFCVkHOTyMQ3EUDUdIXkRf2fCPmw6HWwzRjcQ4CCDRLgIKEZq0X0SLQaIEgjK7vv2w0OhGCL0jAnPpa9woanGERQAABBBBAAAEEEEAAAQQQQACBWgtQkFDr5XEqOAoSnFrO2icTRFFXjBmJqNdPgzVK/rjrdHqvlLLPDvgggICjAhQkOLqwpIVA3QT+DcPjfVF/1S0u4qmbgHnvaz2qW1TEgwACCCCAAAIIIIAAAggggAACCBQtQEFC0cKMfy9AQQLXQhkCn415eTCdjnZ3TTZXM5ETtnAoY1WYA4FqBChIqMadWRFonUAQhj0R9VvrEifhxAJzo/733UHnLPGJnIAAAggggAACCCCAAAIIIIAAAgg0WGDVzvxjg1Mg9IYI3HqdV7yR3pDFamiY/91NT/aU7Yqw3J4h1sfIJ//AG8Q6tsCDFi9XKvXSGHOsjHq5dSplLkWpy5kx1xRUFLgoDN14AQoSGr+EJIBAMwT4QdWMdapJlJOZmC5f4GqyGoSBAAIIIIAAAggggAACCCCAAAKlCHD/rBRmJrECSn7yPe8cDATyFojfFWH9zEbk77mYXpn3hm3xhFKmq0SOReRNFhNetsuix7kuC1CQ4PLqkhsCNRKg5VyNFqMBodgvnndep0uldgMWixARQAABBBBAAAEEEEAAAQQQQCAXAQoScmFkkFgCbJsai4mDEgkEUdQVY7siqNeJTlx3cMHdEhZFCHumt3s7iSSZ8OcqiRbHtkuAgoR2rTfZIlCZwE0YjZXID5UFwMQNFDCnvta9BgZOyAgggAACCCCAAAIIIIAAAggggEBiAQoSEpNxQlqBgh/2pg2L85orUMzfX+Zqbvb6eW3vGwTBkex1eqKkn2griVjLQjFCLCYOaq0ABQkS2Q3EAAAgAElEQVStXXoSR6BcgSCMTLkzMpsLArS4cmEVyQEBBBBAAAEEEEAAAQQQQAABBOIIFPNAL87MHNNCgQtfe90W5k3KOQssHvLvd0ZZtzrYEdaFKBmk3Wbk3zA83hdbhKDe5Zz+Yjgj5sOh1sMixmZMBFwRoCDBlZUkDwRqLLD6UvJPjUMktPoKTGQ2PfZ9/7K+IRIZAggggAACCCCAAAIIIIAAAgggkF2AgoTshowQV8Bc+VofxT2a4xBYJ7DcokHO8u82sN7bbvOrxAxvPe8szla/QRj2RJTtwPumuBWky29xtozskgAFCS6tJrkgUFMBux/TnjK/1zS8csIy8kn25DzJZMbIkG0uFmJUbCe5cDgWAQQQQAABBBBAAAEEEEAAAQQaKUBBQiOXrblBz6bf8xJQc5ev6sir/vvKKPlDzWX89J67MeZYlOoqI7YDyIsCnSYipu9rbbtD8EEAgR0CFCRwiSCAQOECN2FkH6z/XPhEtZ0gXcVxEEa2gKHA6s3agq0JjD24mrRaxIoAAggggAACCCCAAAIIIIAAAskFqn7AlzxizmiyAFulNnn1qov9szEvn0VT2xWhtfetbaeGuZjec63H1a0EMyPQLAEKEpq1XkSLQCMFgjC8FFGvGxl8LkGne5hOQcIj/Mmt1zmK04orlyVjEAQQQAABBBBAAAEEEEAAAQQQQKBkAQoSSgZv+3RGPvkH3qDtDOQfX+DfMDzeF7tFQ4vv9fPnJv4Fw5EIPBCgIIHLAYEWCax+1NhWRd985kYNvzvo2MrGXD+rfZp+y3XQBg1mqyUPtXecJmQKEp6qsR9XmuuIcxBAAAEEEEAAAQQQQAABBBBAoBkCFCQ0Y50cipJtUh1azKJTWW3LbLcnKHIbhKLTyDL+hcymPbY5yULIuW0WoCChzatP7q0T2NGpYDIT082zzdCqfdNli7+kiCj5yfc8u/VC7E8QBEfS6RwZI3arix9in9iGA1N4toGFHBFAAAEEEEAAAQQQQAABBBBAoPkCvJzS/DVsWAYTX3svGxYz4VYgcBOGfSXqlwqmrsGU5kpEBr7WthiDDwIIpBSgICElHKch0DSBxUPu/c4/O+M28ulWd4ZZW+PbYoSDaHre8gfqiaqMgyjqUoSw/QrN0nFi57XPAQgggAACCCCAAAIIIIAAAggggECFAhQkVIjf1qln0+9547utix8v7yAMRyLqXbyjHTsqp2cljqmQDgKpBChISMXGSQg0TyDh1gkTIzKaixml6ZhgH6yLsXtJtbZ90/ICSfCFvtVf7BL/cTLvqUhNjMYJCCCAAAIIIIAAAggggAACCCBQc4GbKDpTRt7WPEzCc0mAbqQurWauubT5hUOj5A81nfYp1sn1kmKwlgtQkNDyC4D02yOQ/oG3uTKizoxR56HeP9/WOWG5RUM0bG3F5IPLyYj8eqi9fpwrjB+bcZQeHTO59TpHWbt4JJ6VExBAAAEEEEAAAQQQQAABBBBAAIECBdj+tEBchl4rYMR8ONR6CA8CDwVst2Wz3zlrYffjC1EySLoFM1cPAgjsFqAgYbcRRyDghEAQhpci6nXWZGzLfBE5V0rO7v9hXvxYCqd9UWIfwL/IOke55y/2gDrPuYgi9gPz9IUi5SrVbjYjn/wDb1C7uAgIAQQQQAABBBBAAAEEEEAAAQQQyCCw6jz6Z4YhOBWB+ALcY4tv1ZIj/w3D431R5827z59lgRbPCAZ05c1iyLkIbBegIIErBIEWCKyqqz/nn+qXh/knzfqCsuz6cL8lRXAXDUTJx/x84m0pkP+8+WXQiJESbInRiHwIEgEEEEAAAQQQQAABBBBAAAEEEBAR7hlxGZQmQEFCadRNmKiFxQgTMTLkxbcmXJ3E2HQBChKavoLEj0BMgVV1tX2j/E3MU9w6bMN+aAW0wrvwtdfdhUe1+y6hOP/dnPpa9+IcyTEIIIAAAggggAACCCCAAAIIIIBAkwRuwmjcwnbpTVoiN2KlIMGNdcwhi//upid7yoya9eJhhsSNfLrVnSHbAmcw5FQEEghQkJAAi0MRcEEgCMOeiLL7gjVsa4VM+huLBHKuOJ/IbHrs+/7ltmiXRRDROI8tNDKpOHDyTMyPz7UeO5AKKSCAAAIIIIAAAggggAACCCCAAAJfBFr4pjKrX4UABQlVqNduztUzg99qF1ghAZlTmc0Gu+7hFzI1gyLQYgEKElq8+KTeXgH7QPxgOh0pI2/boLDpoXX+3RHYqqGC6ylWR4oK4mJKBBBAAAEEEEAAAQQQQAABBBBAIJPATRj2lahfMg3CyQhsE6AgofXXR1uKEYySP9R02qcQofWXPAAVCVCQUBE80yJQBwH32zCZq5nIyaY36PPtjhBv+4D8iyDqcCVVHMOG7TgqjorpEUAAAQQQQAABBBBAAAEEEEAAgcwCQRidt3YL1sx6DLBTgPtqO4lcPqAlxQgXomTge579u5QPAghUJEBBQkXwTItAXQRc7pawrZ1/noUBRuTvO6/TjbPfVL5FEHW5iqqOw1z5Wh9VHQXzI4AAAggggAACCCCAAAIIIIAAAnkLrLZu+CvvcRkPgYXAbPo9b4y381poQTEChQjtvLTJuqYCFCTUdGEIC4GyBdzrlrC9Y0GOhQETmU2P43xxz7MIouzro+7zGTEfDrUe1j1O4kMAAQQQQAABBBBAAAEEEEAAAQSSCuR4Hyvp1BzvtsDE195Lt1Mku3UCbhcjmCsRGfhaj1h9BBCojwAFCfVZCyJBoHKBIAiOZL9j/6F+U3kwWQPYUt2bY2HAZCamu2lLiKcpuP1FL+uCZT5/cut1juJ0qcg8EwMggAACCCCAAAIIIIAAAggggAACJQos72VFYxH1usRpmcpxAaPkj0PPO3E8TdJ7IuDuPWoKEbjYEaizAAUJdV4dYkOgIoGbMOwrUb9UNH0O027vjpBTfomKEWxSN2E0ViI/5JAgQ6wV2L7uoCGAAAIIIIAAAggggAACCCCAAAJNFVh1N/29qfETdx0FzHveIq/juhQXk6NbwEzEyNA/8AbFyTEyAghkFaAgIasg5yPgqID9crInatTIB+g79j7Loc1d4mKEVfeJfxy9XOqTlpKffM87r09ARIIAAggggAACCCCAAAIIIIAAAgjkIxCEkb3n0fzOpvlwMEpGgVuv84puoxkRG3T6qhjB/h3yokFhbwt1UYhwqztDrmNHVpQ0nBagIMHp5SU5BLIJ2HZwB9F0oER+zjZSmWfvfks+S0GCEfn7zut0k37JcbcVVplru3suI/Lrofb6u4/kCAQQQAABBBBAAAEEEEAAAQQQQKBZAo6+3dysRXAm2t33UJ1JlURk9bLc2JFiBAoRuKYRaKAABQkNXDRCRqBsgVVLuFEjvrDs6I5g7dIWJGR52H0TRWfKyNuy165d8/FDql3rTbYIIIAAAggggAACCCCAAAIItE8gCMORiHrXvszJOFcBuozmylnnwVYvHZ43shPyN7DmVGazge/7l3U2JzYEEPhWgIIErgoEEIglsPjiMp2O6vxQPW7BQPKCBHMlSvWybAUQhOGliHodC7uggzZ1dwjCyBQ0ZZnDTm69zlHSzhVlBshcCCCAAAIIIIAAAggggAACCCCAQFYBx950zsrB+SkFfO3xbCilXdNOc2OrFwoRmnbdES8CTwX4R4drAgEEEgnUuFtC7AfS8QsSzJWIDHytbXeITJ+qH/pv22qi6tgywa5OjluMksdcjIEAAggggAACCCCAAAIIIIAAAghUKRD/3laVUTJ3nQUoSKjz6uQXmwMdVS5kNu3RESG/a4KREKhKgIKEquSZF4EGC9SxW8LcqP99d9A5i8O660ebfXivxAzzKESw8VS/v585vfW8/qbuAS4UJMzE/Phca7sPGh8EEEAAAQQQQAABBBBAAAEEEEDAaQF7b+5ZNLUty184nSjJFSZAQUJhtLUZOAjDnoj6rTYBJQvkQpQMsnQsTjYdRyOAQNECFCQULcz4CDgssOyWMB9WvRWBiDn1te7FpV5fkGCujKizuZhR3g+2gyjqipE/48aX73G7beqwnUS2nM2Vr/VRtjE4GwEEEEAAAQQQQAABBBBAAAEEEGiOwK4XbpqTCZGWLWBfxjrU3nHZ8zJfeQKrF+TOm1a0tHhRUEmfQoTyrhVmQqAsAQoSypJmHgQcFVhUZIfTvij5WEWK27Yi2BTPTRj2lagTIzJWYsYym50X2fapqoKEuNsYNL9Dwu6iiyquTeZEAAEEEEAAAQQQQAABBBBAAAEEihKgS0JRsq6Pu72TquvZtyG/5d8N0bj6lwiTaOe3dXKSWTkWAQTKE6AgoTxrZkLAaYEgCI5kf38got6VlWiaYoSyYns4TzUFCeZ93C0nml6QYMR8ONR6WMXaMicCCCCAAAIIIIAAAggggAACCCBQlQBdEqqSb+i8Rj75B96godETdkyBIAxHZd6jjxnWpsMmIqYf9z52xrk4HQEEKhSgIKFCfKZGwEUB2w5qT6mBMvK22PyaU827qlj/XKzHw9ETFCMsCkk6/5QXWwEzKfmJNl4FuDIkAggggAACCCCAAAIIIIAAAgjUWqD8e0615iC4zQKTuVG97w46ZyC5LbDcYtn83oAsJ2JkeKs7w1dKXTcgXkJEAIGMAhQkZATkdAQQWC/woGPCSb57VZmrudnrN+0LdBBG9ovVi4Kvl4koOUnycL5BX1I3082m3xe55UbBa8bwCCCAAAIIIIAAAggggAACCCCAQGqBhr0NnTpPTkwtcHHrdU546JvarzEnNmUbF7vN8J3XGXBNNubSIlAEchGgICEXRgZBAIFNAqs9q06MUidZuiYYJX+YuRo1rRDh3qWEH4eTmZjuc63HSa7GEuJKEk6qY33t8W9ZKjlOQgABBBBAAAEEEEAAAQQQQACBpgssXwpqePfLpi9CXeNni4a6rkwhcdX/Pq85ldlswItlhSw/gyJQewEe4tR+iQgQAbcEgijqyly6Zk+OxciREvnhaYZG5G8lci1GzmVPzpO88V9XrUXeRv4sJj5zNRM5SVqM0JSq2e1m5srX+qgYV0ZFAAEEEEAAAQQQQAABBBBAAAEE6i8QhNG5iLypf6REWIaAvbc6F9NLeq+wjNiYoxiBYu89Z475QpQMXLjHn1mCARBosQAFCS1efFJHAIFyBW6i6CxLl4h10dofGHdep5umxdVNGA2VyM/lKuQ+24WvvW7uozIgAggggAACCCCAAAIIIIAAAggg0BABJ7bkbIh1/cM0p7ee109zr7D+uRHhJoGbMBqve/GvWjFzJUr1KESodhWYHYG6CFCQUJeVIA4EEHBewHYkOIiinojq5fEFMUsxQs2rZpNcCxQkJNHiWAQQQAABBBBAAAEEEEAAAQQQcFIgCMNLEfXayeRIKo7ARMT0fa1HcQ7mGHcEgjC095t/q1FGXIs1WgxCQaAuAhQk1GUliAMBBFolYPf3M/v7J+mLE9JXO/8bhsf7omwrvxcOoFOQ4MAikgICCCCAAAIIIIAAAggggAACCGQTuAnDvhL1S7ZROLuZAum2c21mrkT9VKBWxUhGPt3qzpAOHVynCCDwVICCBK4JBBBAoGKB5MUJ5tTXupcmbMeKEUSMfPIPvEEaC85BAAEEEEAAAQQQQAABBBBAAAEEXBGwnTmfRdPPruRDHvEEsnRQjTcDR9VZoC7dEYySP9R02vd9/7LOXsSGAALVCVCQUJ09MyOAAALfCOwsTsjwAH71BXXoSGeEpV0GDy4/BBBAAAEEEEAAAQQQQAABBBBAwCWBmyg6U0beupQTuWwWoBiBq+MmjMZ5bA2cVtJeg0pJ3/c8242XDwIIILBRgIIELg4EEECgpgLfFieY92n3gQvuooEo+VjTVNOHRUFCejvORAABBBBAAAEEEEAAAQQQQAABpwT+u5ue7Cnzu1NJkcxaAYoRuDBWnXD/qkhiYsQMDrW2L7/xQQABBHYKUJCwk4gDEEAAgeoFbNu9tHtvBWE4ElHvqs+igAgoSCgAlSERQAABBBBAAAEEEEAAAQQQQKCpAkEYXTvVHbOpC1Fo3Obq1vOO094rLDQ0Bi9N4CaMhkrk59ImXE1kRH698zoDrr+y5ZkPgWYLUJDQ7PUjegQQQGCjgC1iOIim51W27Sp8eShIKJyYCRBAAAEEEEAAAQQQQAABBBBAoDkCTr+Y0pxlKDTSmZgfn2s9LnQSBq+9QBCGlyLqdVmB2q4cczE9rr2yxJkHAbcEKEhwaz3JBgEEEFgItKIYwSZKQQJXPAIIIIAAAggggAACCCCAAAIIIPBFgG0bHL8YuBfm+ALHS89u9Sv7nX/iHZ35KLZnyEzIAAggQEEC1wACCCDgmEBrihFKLEgIwrAnSl36nnfu2OVCOggggAACCCCAAAIIIIAAAggg4JBAyQ8qHZJrQirmytf6qAmREmOxAmUVHhklf6jptO/7/mWxGTE6Agi4LkBBgusrTH4IINA6gZswGju9TcOjFTWnvta9Ihd5UYwg6jdR8hMFCUVKMzYCCCCAAAIIIIAAAggggAACCGQVYMuGrIL1Pd+I+XCo9bC+ERJZWQLBXTQQJR8LnG8yN6r33UHnrMA5GBoBBFokQEFCixabVBFAwH2Bgn90Lr6IKmW6SuT4geabCmUvfO11i5r/SzGCnYCChKKYGRcBBBBAAAEEEEAAAQQQQAABBHIQsF0zn0VT+ybzixyGY4iaCdx6nVevlLquWViEU4FAkQUJtivCXafT41qrYGGZEgGHBShIcHhxSQ0BBNolcBOGfSXql4KynszEdJ9rPX46fpFfgGPkkqkgwbY3s3Osq/Z9VIywCMS897UexYiJQxBAAAEEEEAAAQQQQAABBBBAAIHSBb69l1F6CExYmIC5uvW8Yx4SFwbcmIHttixmv3NWQIfciREzoAtHYy4FAkWgUQIUJDRquQgWAQQQWC/wbxge74v6qwgfI/LrndcZbPrBs6q+/1zE3DHGTFyQsIw3soUIAxH1Wox88g+8wcO51v6AX3NcjPg4BAEEEEAAAQQQQAABBBBAAAEEEChFoF3beJZCWqtJjMjfd16nS1FCrZaltGBsIYLs79v7me/yntReW3MxvXUvo+U9F+MhgEA7BShIaOe6kzUCCDgmsPhC2ukc3adlRPrKyNsMaU6MyEjNpkPf922rv62fIAwvFw/3S/+YK1/rL3lvm35htNfpiZL+w9aFT/ff2/g2AQUJpa8uEyKAAAIIIIAAAggggAACCCCAQDyBIl9WiRcBR5UhQFFCGcr1mmP5Z9vez8ypEMHIp4f3R9mioV7rTTQIuCpAQYKrK0teCCDQeoGvX1alG6dYwP6gEZFzY9T5ui0MtoHeRNFZxgKI1Ovla2/rv2U7v7Qr+cn3vHMbgN3CYU+Z39cFY7+cH3reYouHvD+LGJV6eR9H3uMzHgIIIIAAAggggAACCCCAAAIIuC1wE0ZDJfKz21mSnRWw9/CUmKEodcm9JDevifsOr0ZUP++tGey91MX44bRvlLw81J59eYsPAgggUKgABQmF8jI4AgggUA+BLx0UjDkSo752FNiTxYP4rD9egrtoIEo+VpHtrdd5ta5V3aq4wH6hfrMtrofnb/vxbn/sHWrvOM8cbTeG+x8WdmsMfgDkqctYCCCAAAIIIIAAAggggAACCLRHIAij64cdIduTOZmKyIURc6Zms7M4nU4Rq6fAakuGrlHqpMgXv3a93FVPHaJCAIGmC1CQ0PQVJH4EEECgAgH7BXm+5x3viTkWJV0j8jLvat3YaT3ocHBfPSwidj+1nVtIPC0yCMLIFmhsLGDI4wu7tTP7HVvd3Hu8dUT+BQ+xDTkQAQQQQAABBBBAAAEEEEAAAQQaK7Ct42NjkyLwVALLDqhmdOd5o3Uv8Nx36VwMPp1eUsCQijmXk+x9TB3OukqZroh0y7q3msf9zVwAGAQBBFolQEFCq5abZBFor8DiQfV0eixz6YoyRyLLLgFPHqRf3AsZkbGIuVRKjW87nfG6L/Bt0gyiqGvtzJ4cK2O3gJAXdcnfdhZQSs6MkZOnD/l3x2je+1qP7o/bVZAwN+p/SbezuB/b3hxQe6a3rcJ5U7eH3XlwBAIIIIAAAggggAACCCCAAAIItFUgCMNRbvvLtxXRybzN6Uxk+FzrsZPpFZiULdzI283eXzXGHCuRYyPK/t8/FJjC5qFn0+8pRKlEnkkRaLUABQmtXn6SR8BtgeWb6PsnIqqX9QvesrpYzo1R56HeP3e9QMF+6d5bVOaqk11bHjT6KnrwBXxRIS7KdkjYVmxx4WvPFmTE+thCmIMostdfP07HBpHHBRKxJuEgBBBAAAEEEEAAAQQQQAABBBBotQDbNbR6+eMkfyFKBlm3bI0zkQvHPCjwmYh9ac3IuVHm2r64dp/fQ8svW+Xe/8fVlrlGLTrKHossXo7b2cm1XDtzJUaNbnVn6Pp97nJdmQ0BBDYJUJDAtYEAAs4JBGHYs0UIRT5IN0r+UMac3XremQtf2u5bhO2puS3gsEUItemAUOwFak59rXsxixGWoTzYImJTbMvxFkUI75LEb6+rQ8+z/nwQQAABBBBAAAEEEEAAAQQQQACBnQJs17CTiAO+CJhTmc0GvB2/+ZII7qKBKPnYootmIkaGFCa0aMVJFYGKBChIqAieaRFAIH+BZSGCDMqvODWnotSoaVXGi20soujEKHWybRuB/FeqXiMaMR+UqEGCIozJrdc5WleIYq9BI6qfpSMH2zbU6/ogGgQQQAABBBBAAAEEEEAAAQTqLMB2DXVenVrGNjFiBodaD2sZXYVBrV5Y+qvCECqc2lyJUr2m3d+uEIypEUAgoQAFCQnBOBwBBOonYPffEmPsXnkVt74yV0ZkeOd5ozp3TbCV82rP9NpchJD1KrZbeNx5na5d5+XWIB1bhGALYrJ3ljDyyT/wbIEEHwQQQAABBBBAAAEEEEAAAQQQQGCrANs1cIGkEfC1x7OhJ3BBGNmtXN+k8XTnHLaTdWctyQSBegnwj0691oNoEEAggYB9w/9gOh3V8MH6otWVzKejurRAy/2heYJ1cvVQW5SgRK7z/6Firnytj1x1Iy8EEEAAAQQQQAABBBBAAAEEEMhHoN1vdOdj2M5RuPf0dN2XL7zJn+28Hp5mvdziFgsEEEAgTwEKEvLUZCwEEChNYLU/3iiXN9ILjbravdnsl2kj0q9h0Uah6s0fnGrk5q8hGSCAAAIIIIAAAggggAACCCBQrMBNGA2VyM/FzsLoDgpc+NrrOphX6pTojvCUjnuTqS8mTkQAgbUCFCRwYSCAQOMEmvljq9zChFVVr2373/I2Y427vFcBU6ne1JUjbgQQQAABBBBAAAEEEEAAAQTKErgJo7ES+aGs+ZjHDQGj5I9DzztxI5vsWdjOsrLf+Sf7SI6NoOQn3/PsNhZ8EEAAgcwCFCRkJmQABBAoS8Bu0fAsmp41+yG7Ob31vP4rpWyr/9w/S6NoKKLe5T44A5YqYMR8ONR6WOqkTIYAAggggAACCCCAAAIIIIAAAo0Q4CFqI5apnkEa+eQfePZFJj4i0syX30pZusmt1zkq6j52KRkwCQII1EaAgoTaLAWBIIDANgH7I8vsd84cqfqeiJHhre4M8/xC15xtLLjWYwrwpT8mFIchgAACCCCAAAIIIIAAAggg0DaBIAx7Iuq3tuVNvjkIUJDwCJFOI9uuKXPqa93L4apjCAQQaLkABQktvwBIH4EmCPwbhsf7omx7qBdNiDdBjBMjZpDHW/BBGI7oipBAviGHGpFfD7XXb0i4hIkAAggggAACCCCAAAIIIIAAAiUJcC+oJGgXp6EV/5dVpdNIjAuc6yUGEocggMAuAQoSdgnx3xFAoFIBh4sRHriaq7nZ63930LHbUST+8AM0MVmjTpiJ+fG51uNGBU2wCCCAAAIIIIAAAggggAACCCBQqEAQRnY7UNde3inUjMFXAjxg/nIp0Gkk1p+KC1973VhHchACCCCwQYCCBC4NBBCorUA7ihEe8V+IkoHvebYbROzPTRSdKSNvY5/AgU0T4Et/01aMeBFAAAEEEEAAAQQQQAABBBAoUGB1z+yvAqdgaIcFbr3Oqzy3kW0y1U0YDZXIz03OoZzYzXtf61E5czELAgi4KEBBgourSk4INFzAPmC3KSgjtvKydZXeRskfajrt+75/GXcpb8Kwr0T9Evd4jmuaAF/6m7ZixIsAAggggAACCCCAAAIIIIBAUQLcBypKth3j+tor5LnQZ2NeelF01KROn0EY2RfD3rRj5bNkaa58rY+yjMC5CCDQboFC/uFpNynZI4BAVoEgjEzWMVw434j8eud1BnErlpfV8XImol67kD85PBKY3Hqdo7jXAnYIIIAAAggggAACCCCAAAIIIOCuAN0y3V3b4jPL/8FyEARHstfpiZK+UXJ+6HknxeeRzwzch07iyAtTSbQ4FgEEHgtQkMAVgQACtRPgi+DjB9FiZHirO8M4D6NtJfLBdDpiC4faXdbZA2J/v+yGjIAAAggggAACCCCAAAIIIICAAwJBGF23sauoA0tXhxRy2xr0v7vpyZ6an4iod18Ty7/goSg0tj5JLMsLU4nJOAEBBO4FKEjgWkAAgdoJ3ITRWIn8ULvAKg3IXInIIO5eXbTuq3Sx8p/cyCf/wBvkPzAjIoAAAggggAACCCCAAAIIIIBAkwQWb6Pvd/5pUszEWh8Bu1Vs2g4G9tqb73nHqyIE2wVh/Va7s+n3SbairUoniKKuGPmzqvmbOK/t6HuovX4TYydmBBCoVoCChGr9mR0BBNYI3ITRUIn8DM46gfiFCUEYXrJ9gwtXkTn1te65kAk5IIAAAggggAACCCCAAAIIIIBANoEgDHsi6rdso3B2awW2vPSyeEB//zHmSIw6MkpeKpFjWf6f9QUITzCNmA+HWg/rbhzcRQNR8rHucdYvPrZuqPv6hTQAACAASURBVN+aEBEC9RegIKH+a0SECLROgHZZcZZ8e2EChnEM63+MEfn7UHv2Bx8fBBBAAAEEEEAAAQQQQAABBBBAQIIwHD1ukQ8KAvEF7L0mJWK3/BARc1TMy0zN2LaBl+LiXzdrjrwQI+czZc6eaz3ONBInI4BAKwQoSGjFMpMkAs0TYNuGuGu2vjCBL9Rx/ep7nP2BeOd1uq+UWv1IrG+sRIYAAggggAACCCCAAAIIIIAAAuUIcM+sHGdmySig5Cff884zjlLo6UEY2fjeFDqJ44PPxPxIQYLji0x6COQkQEFCTpAMgwAC+QrchGFfifol31FdHm1ZmHDreWf2ATbbNTR+rSczMV2+0Dd+HUkAAQQQQAABBBBAAAEEEEAAgdwEPhvz8lk0/ZzbgAyEQHECF772vm4BUdw8qUemICE13erEZnTCyJol5yOAQD4CFCTk48goCCCQs8DqB9Zl3L3Jcp6+ycNNRMwZrfuavIQitro48rzLZ7e3L33ft38O+CCAAAIIIIAAAggggAACCCCAQMsFgijqipE/W85A+g0RmBv1v+8OOmd1DTcII1PX2JoQlxH59VB7/SbESowIIFC9AAUJ1a8BESCAwAYB9sTj0mingHlvO10cRNNzJXJEp4R2XgVkjQACCCCAAAIIIIAAAggggMBTgeAuGoiSj8gg0AwBc3Xrecd13Y6UgoRsVxHbNWTz42wE2iZAQULbVpx8EWiQQBAER7Lf+adBIRMqAtkEjHy61Z3hqhjhh9VgbN+QTZWzEUAAAQQQQAABBBBAAAEEEHBC4CaKzpSRt04kQxLtEDDyyT/wBnVMloKELKvCdg1Z9DgXgTYKUJDQxlUnZwQaJECXhAYtFqFmFDCnt57Xf1KMcD8mRQkZdTkdAQQQQAABBBBAAAEEEEBgu4DdPrOubzKzdkuBIAwvRdRrPBBokkAd36Rn+5OMV1CNC00yZsbpCCBQkAAFCQXBMiwCCOQjwJfDfBwZpd4CRuTvO6/T3VCMcB/8ZG5Ur85779VbmegQQAABBBBAAAEEEEAAAQQeCiw7U+53jVInyphj+6Db1x73i2t6mdiCkWfR9HNNwyMsBLYI1G/rBu45Z7xgZ9Pvfd+/zDgKpyOAQIsE+ILZosUmVQSaKhCE0bmIvGlq/MSNwC4BI/KriHSVyP02Ddt+xL33tR7tGpP/jgACCCCAAAIIIIAAAggg4JbA4oH0dHp8n9VtpzNO2tHAFiGY/f0TEdVb9xuUgoT6XjM8QK3v2hBZHAFz6mvdi3NkGcfw5ymLcr3WMksmnIsAAuUJUJBQnjUzIYBASgG+IKaE4zSHBQxFCQ6vLqkhgAACCCCAAAIIIIAAAnkKLN+sj06MqP6uQngKEvKUz3esmzDsK1G/5DsqoyFQpkB97mdxvznDuiv5yfc8+wIhHwQQQCC2AAUJsak4EAEEqhSgS0KV+sxdTwGqkeu5LkSFAAIIIIAAAkUKBGFkno5vu00daq9f5LyMjQACCDRR4L+76YnaMz1l5G3c+ClIiCtV/nFBGI5E1LvyZ2ZGBPITmIn58bnW4/xGTDdScBcNRMnHdGe3+qwLX3vdVguQPAIIpBKgICEVGye1VeDfMDyuwxemNvpTtdrGVSfnXQJGyR93nU4vaYvOXePy3xFAAAEEEEAAgboKrCtIsLEakb/VbHrCXrZ1XTniQgCBsgTsvau95XYMtjX6i6Tz3nqdV/zGTKpWzvG8rFOOM7MULjCR2fS46u9sFCSkXGe6I6SE4zQEEKAggWsAgRgCtrXdQTQ9X7a1M1ciMmAP9xhwOR9yE0VnSar6c56e4RCopYC9+T4X06NYqpbLQ1AIIIAAAgggkLPATRiNt7Qbn8yN6n130DnLeVqGQwABBGotEATBkdnfP5FlIcIPmYLlYVMmviJP3lSUV+ScjI1AEQL2Xtad1+lWWfxEQULylbUvRh163knyMzkDAQQQEKEggasAgR0CtrJ8X5TdE+lJVbm5MiLDO88bVfnlqU0LaH9gy37nnzblTK4IxBTg5ntMKA5DAAEEEEAAgWYLxHw79GJu1JDChGavNdEj0DYB+zLMsygailKjOHtzLzshSDeXIoQH2HOj/sffn/W7+rgnVr81IaLMApW2/qcgIcX6zabfV93ZIkXUnIIAAjURoCChJgtBGPUUCMKwJ6KGO1rcTYzISM2mQ/5BLn4d2S+veGNmaK6A3T/5zusMKJJq7hoSOQIIIIAAAghsF0jxe+DCiIyVmLEodXnb6Yz5rsRVhgACdRP47256sqfM6MH9pwsj5kwp9WWf9flcvdwTc2z25FgZW4iQfDuGWHkb+eQfeINYx3JQaQJsZVoaNROVKmBOfa3t9jKlfyhISEjOvw0JwTgcAQSeClCQwDWBwAaBNF9KbNsiJTKMU8kOfDqBVUW4/UGeeB/EdDNyFgJNEzBXolSPv4eatm7EiwACCCCAAAJxBNL8Tns47kzMj2x1FUeaYxBAoAyBL10RRL0rY744c9CSO45S+cfchGFfifql/JmZEYFiBezLNYfa6xc7y7ejpyhyLTvE2sxnt9g41N5xbQIiEAQQaKQABQmNXDaCLlIgjx+D9h9pJWZ463lnvH2T/2plvQmZf0SMiED9BOiWUL81ISIEEEAAAQQQyC6Q8YHMxNfey+xRMAICCCCQXWC55YIaKZEfso+W5wjmytf6KM8RGSu7APfCshsyQn0F7D0sZeTaRjgXNQ71/nnR99RjbgNWX7TyIpvMxHQp6C0PnJkQcFWAggRXV5a8UgnYYoSDaHqe449BtnNItRLbT1oWjUwv6ZJQAC5DuiYwESPDW90ZFv1DzjU48kEAAQQQQACBegpkaVnNW7/1XFOiQqCNAmu2aKgXA/uE12s9RISHp7VbEgIqVmAiYs5kNhsUtUUyf6biLqB572tttxTigwACCGQSoCAhEx8nuyRgK9P3Rc5E1Osi8mI7h3xVgzDsiajf8h2V0RBwVmBRmCDz6aioH3LOypEYAggggAACCMQWsMUCxshQiVwbkbF9082+5ba3Z65vO51xHgWSmQoSxHw41HoYOyEORAABBAoQaMb9DB5AFbD0a4e0nQ+MMte7/n26CaNxji9QlZUe8yCQXcDIpyJetKEgIcbSGPnkH3iDGEdyCAIIILBTgIKEnUQc0AaB1Y9Be2PqRfH5misRGbCdQ3ZpfoxlN2SE9gksiqPMosr8fFtxQhAER7fPnl3n8eCgfcpkjAACCCCAQDsF4hQLLLe3e1yw8N1B5yyJWBBGJsnxX45V8pPveeepzuUkBBBAIAeB5rTdN6e+1r0cUmYI290gCI6e/v5edGmdTkfKyFvbrv5Qe/1tWKn/7WMFEHBCwFzNRE7y3DaAgoRdFwb/DuwS4r8jgEAyAQoSknlxtIMCN2Fk3+D5uYLU2M4hI3qcG54Zp+B0BFwXmIjIeE2Sx4sCLW7au77+5IcAAggggECuAmm/n/vaS3RvIu1DmaTz5IrDYAgg0HqBIAxHIupdQyAmvvZeNiTW2odpt+gwan758GHq4+vBXPlaH21KZLV16efaJ0qACBQsYHLsdkVBwrbFohih4EuZ4RFopUCiH/2tFCJpZwXsFg17okZ1aHfGdg7pL7OG/aBPnyhnIlCFAAUJVagzJwIIIIAAAo0UsG9/mk5naN/0TJpA0kKBlJ3SLnztdZPGxvH5CtyEYV8pNaZTRb6ujFZ/gSbeu5gb9b+kHWzqvxLVRfiwKGHxd6GoXx5Fs+X3d9qCv+qyZWYEihQwp7ee18/a0TMIw8uitm4uMvvix6YYoXhjZkCgnQIUJLRz3Vud9aKqOJz2RcnHukEs25eaoa/1qG6x1TWeVZX4ZTnbbdRVgbgQKEiAgoSCYBkWAQQQQAABdwTsQxIj0k9TiHCvkLQgIdUbbeyBW/lFZ4tWZL/zjw3Etie/8zqDrA8TKk+KABCIIdDEYoRlWjyUirG8iQ6xRQl7e+b/iZH/u+Y+1sbCucV5yvyeaDIORsBhAXsP/c7rdLN8j0jbccthVvsF7ZN/4A2czpHkEECgMgEKEiqjZ+KyBZYPrqMTETWs/8NrcyVGjW51Z5jli1XZxlXNt7ayvKpgmBcBlwQoSHBpNckFAQQQQACBXAWWD5f3B3m0H09ekJCi7Tnfa3Jd/zSDrXkoOxExfQry12suuo7sd86yPnBJs1ack59Ac4sRFgZs25DfpfBlpNu76P8zSv7P+qHN+3V/JwZ30aCOL1YVwMOQCMQWWLzYN5ue+L5vX1RL/KEg4RHZZG5Uj644iS8jTkAAgQQCFCQkwOLQZgqstmboKZFe/QsRvjGeiJEhhQm7r71Ub0ntHpYjEGi3ADfu273+ZI8AAggggMAGgVVBsH176kUeSEkLEm7CaKhEfk4y963XeUWxdxKxfI/d3m7cXInIgMKEx+b3D7LzeAs039VktLgCDS9GWKW5/gF5XIM2HGfvO9o8n2s93pXvqlOMPW7Tv5+TmZju07EoSNgly39vscDaPzNxPChIWCrZ7xlzMb04f4fFceUYBBBAYJMABQlcG84J2C/38z3vWCnTVWJsR4TXDiRp3xw5k9lskLbq0wGDrSnYH4D7ov5yPU/yQ6BUAQoSSuVmMgQQQAABBOouYLvOHUynoyzbM6zLMUlBQhCGPRH1WxIre6P1UHuLB0Z8qhGIV0C+LEy49byzthePPNze4v5hAZ0Sqrl2086a5u+qtHMVfN7GbQQKnrcRw38tFDBXt553vO3vrsW/odH0XIn8sCO5b7rH3ETRWd7/9jYCmCARiCeQqiiBgoRFNQJbNMS7xjgKAQRyEKAgIQdEhqiHwNMf7PWIqogozCmFCetdqRgv4npjzFYLUJDQ6uUneQQQQAABBB4KrDrPjWI8SEkMF7cgYVWEfJ60M4MR+fVQe/3EgXFCLgIp9j5fFOTPzd5ZW1sHf/tmvbmam71+Wz1yuRBLHMShYoSl2mz6PS/HPL6A1v2buO3fmgTFCF8mMkr+UNNp39rHK+oq8SJnKgTqJ5CoKGF756b6JZd3RHRFyFuU8RBAII4ABQlxlDimEQJtexhtf+jceZ1B298ceXpx3oTRuIibpI34Q0CQCOQtQEFC3qKMhwACCCCAQCMF0hYCxE02bkFC2u/6c6P+x4PcuKuR/3FBGF5m6Fw4MUrOxZhzpdT4ttMZu/4b+PHLFmxnkf8VWeyILj7koqjr8TWz9f7jmt/QqwKVYdJiuq+zmlMj6ph7XcX+2WV0JwRiFyW4+Hd1zBVcbA/tH3h26zU+CCCAQKkCFCSUys1kRQpkvMlRZGhFjr34EnGrO0PXb8rERSz6ZmncODgOAScEKEhwYhlJAgEEEEAAgSwCZXy/jlOQkKkAnbd7s1wCmc4t8E3xi2Vg5lKMulz8L2WubdGC/d++59lOGo38LLsjSNduX+Frbf83nwYJOPqQa+Jr72WDlqGQUON1Clpu3WADOIiinhLpZyjIKiQPBkXAcYFYRQmO/l29Y2npuuz4tU96CNRegIKE2i8RAcYRSNECMs6wTTrmm/3lmhR83rHehGFfifol73EZD4HWCax7uyMIjuZ73vGemOO5qDFvG7buqiBhBBBAAIEWCaze1LYPeF8UmfaugoRVUcRf6WIwV77WR0nPXbXXHiglZ01+uJ007zyPt4bPoqktFij0+tkc86K7gC1MOL/1vLOmFPHbIg4KEfK8Essfy832+uZ9m6/LJEVxthU63QzK/3PHjAg8EJiIkpNt39+S/Jl2QPZClAz4PuvASpICAg0XoCCh4QtI+EuBmyg6U0bett1j8aNHSZ8vGCKrPTdPRMTeQLXV6RXdBGv7VUn+zRYw7+dm79oWH4havKX16M/STMyPz7VevIXGBwEEEEAAAQTcEkiz33VagW0FCcuH2tE4/Rum5tTXupc0ttXviXf2vIf7eCcdp83H1+1m/2IdRYb8Xm7zVVlO7i6+eWvvNx3q5Zv/bfrE64rQJhFyRaBJApsLqer2HaUYVXM1N3t9XiQqRpdREUAguQAFCcnNOKNmAo/3V6xZcJWFY05vPa/flDdAimKyNy/vDex1Yvb3T0SpLsUrRYkzbssEaNvZsgUnXQQQQACBdgk8fCBfdOabChLyKYpI/lbvhm0G6EqX4EKovjvC5mB3deRIkCaHIrBRwMkuCS3b0q8dDyz5Q4yA6wLrvwe6/XLjokMU2z65fmmTHwINFKAgoYGLRsiPBfiBsPGKmMyN6lEF+a3PfXECe/nxtwkC6QXsG2aHnme7kPBBAAEEEEAAAccEyt4Sb90D4nyKEUSSdnTa/WYzxd9xLvcyC1rixPPomJY9VE3swwm5CGwobMpl7KoGactvQLoiVHWFMS8CRQl8W5RwE0ZjB7dWmYiR4a3uDNv+kmJRVxLjIoBANgEKErL5cXYNBIIwvEzfvrMGCRQcgv3BeNfp9Pgish56ecPR9ETUoh0rHwQQiClg5JN/4A1iHs1hCCCAAAIIINAQgSrebH9akJDjw6BEHZ3svPuizndt92Zbl995nS6/sTb8xgqCI9nv/FPfSz5514x1udhC9/med7zY3mz1mYsah3r/nGujvqtfVmSrv0s/lzVfafPMpt/7vn9Z2nwlT8RLTyWDMx0CJQkYkV8Ptde/ny4II1PS1OVMY+QThQjlUDMLAgikF6AgIb0dZ9ZAYLVdw0hE3tQgnDqHMBElJ+yVuXmJFtfSXqcnSuyX0xd1XkxiQ6AWArxZVotlIAgEEEAAAQTyFqjiYcx9QcLy993+IK9i4SRv88YtRvjqba5mIifPtR7nvQZNH6/2bZAzFNZ+2QpQVG/7m5V00mj6dZxH/LX/s5AiyacP9VIMUatTFn/3K/VyEZQxR2LU0eJ/K3OU179FtUqYYBBoscD9S3teFB3ti/rLBQqbk5pO+y4XirmwTuSAAAJLAQoSuBKcEFi11bRv6lKYsG1FM9x4ceJCiZHEsjVsZG8u9em8EQOMQ1orwN67rV16EkcAAQQQcFhgVfBtH7CXWqBrxHxQouxWULn+nrPjHmo93LVkyYsRvow4mYnpUpTwVXj3lhe7VqOU/37ha6+bZKblNbL4jZiksx7XRxJkB4+tosCrBMbJrdc5akMXEOfeoC7h4mAKBBogMDFKzpWRtw2IdWOItluXUtLn5cMmryKxI9A+AQoS2rfmTmdMYcLu5WULh91G90cs93wU+4bW6/hncSQCrRBIfBO3FSokiQACCCCAQMMFnHt4FqOjU4ZihPvVnshsesybaUuOIIzslhe5Fpbk/8fKXPlaL9+C3vHJ4R4DRQm7kB3+7w0p0EmxAvlse5Ji4lJPcXSP+VINmQwBBHIXmBgxgzgFt7nPzIAIIIBARgEKEjICcno9BVK+vVDPZAqIij1Pk6FSmJDMi6PdF3CtTaf7K0aGCCCAAAII7BZY7Xdu9wUvtTvC7sjSH7Gro9Pye776Lf0MyzP5fbV0+O9uerKnzO9ZPcs4f9e1scrFbueXR3EFRQllLGoN51h1nfmnhqFlDCl+UU/GiSo9PQjDUcKuKJXGy+QIIOC2AC8Zur2+ZIdAGwQoSGjDKrc4x+X+jp2+ErFvujtzYy2nJeWmSEJIChMSgnG4wwLteCPG4QUkNQQQQAABBL4RyOvhfI1oN3Z0WmzTNp2O8mzXa4sSDrV3XKP8Sw8lCMPLxnSXW9M9Y1mUE9mtQ4rokkcnjdKvyHpM6Gzb/xgdaOqxAumjuAnDvhL1S/oROBMBBBDIRWAyN6r33UHnLJfRGAQBBBCoSICChIrgmbZcgcUNpyjqqeWej7Tf/8pPUUKKS5HChBRonOKWwGz6PW2J3VpSskEAAQQQQKAZrfYTrJORT/6BN3h6xqrwYlhMwbo59bW2xfCt+zTvTeKvBbbLbgjzExFlixEKe5GBThqt+2OxSNjVggT7pu6h59k/M85+3N1yw9klIzEEnBOgK4JzS0pCCLRagIKEVi9/O5Nf3YCyN4nyaL3oAiJvaqRcRQoTUsJxWtMFJr72XjY9CeJHAAEEEEAAga8Cq+0aPjtl8uTt3bK+u8+N+l/b3mAL7qKBKPnYsOvnwii5Vka6RRYhrDHZ2LmjYX6EG1PA1YKERfo1LVS327g+13psQ1xs6arU4vfrzJjr+///mMvnbEFJ3Pw5DgEEKhOYiJi+r/WosgiYGAEEEMhZgIKEnEEZrjkCix8ly44J75oTdTGR8qZGNteybm5mi5KzEchNgJuouVEyEAIIIIAAAvUQcHC7Brn1Oq90OOuW8eb7k1Wc3Hqdo1dKXddjdYuNwm6TKPudf4qdxbXR29tJw7WVjJOP0wUJGzrRxHEp8hjb9cSo+WXS4oN1Md2E0ViJ/FBkvIyNAAIIPBSw9+nnYnp5/B2GLAIIIFAnAQoS6rQaxFKJwOIGyl6nJ8oWJxTXnrGS5JJNykPGZF7fHL3aX9C2hS2szWfGEDkdgcwCRuTXQ+3Zvy/5IIAAAggggIAjAs1rt19v+Da0Mr9fgZswGiqRn+u9InWM7uuWEXWMjpjyE3C6IEHMla/1UX5a+Y20rihhdc9m7TYTMzH9dQ//nNvOKD9iRkIAgUIEzOmt5/XbUthaCCGDIoBAbQUoSKjt0hBY2QKLNqXhtN/qwoSaVreXfS1kmY/rKIse5zZBwIj5cKi13XeZDwIIIIAAAgg4IhCE4aWIeu1IOvVI48mWEfUIKv8ouHbSm87E/Mjbj+n9mnKm2wUJInW7ju1LR7fPnl3bh3lPixK2djvYcD8sCCPb7YaXTpryB444EWiwAPfbGrx4hI4AArEEKEiIxcRBbRKwP15MpzNURt62Ke/7XOv2Y7Kpa2ALEw6i6YC3hZq6gsS9UaAlN9e5AhBAAAEEEGiLwKKgNpp+bku+JebpfAe65TaI6q8STR2bylzdet4xb0E6tqxP0nG9IEGk3C1IgijqWmJjzLEy6qXZk2Nl5KWIOfpSWLfhN+v2tfg2D/6Oc/vPJtkhUCsBXhKs1XIQDAIIFCNAQUIxroxaM4H7Hywyl8UPF9mTc9/zzreFaSup95QZta0S2u5Tdai945otYWPDaXuBS2MXjsA3Ctj9mLlpygWCAAIIIICAOwKL30pG/nQno/pk4nqxdxCGPRH1W33EmxdJm7b3aN7q5BOx+wUJMvG19zIPrcWWqp3O0XyuXu6JOTZKXiqR+/tTb2LPsaYgYfe/dd8WCK22ePgl9rwciAACCKQTmNx6nSPutaXD4ywEEGiOAAUJzVkrIt0i8E3BgVoVHohs/MFi90G/8zqDbf/Yr95yP1ciP7RrAdjPMu/1Xv34HciWazLvORkPgSIEfO3x3aEIWMZEAAEEEECgIgEeuBQHb39zHmqvX9wM1Y4c3EUDUfKx2iiaPzstmpu/htsyaEFBgkjMLnpP79197W6wKDrIb1uENfGsXjr6fdta2Rd01Gx64vv+pT3uJorO2to91e0/lWSHQM0E6I5QswUhHAQQKEqAhwpFyTJurgJpCg7iBWCuRKnerm4JQRiORNS7eGO6cJS58rU+ciGTuuWwfItIBuzRW7eVIZ44AnRQiaPEMQggUJXAsvjPjIyoayVmLCLnM5Ex+3NXtSLM2xQBHioXuVJu/65q3+/kwq6Vicymx/cPQQubhYErEWhDQcKu4qubMBqWup3lug4J8QuoJkbM4FDrYRBG17kWSlRyBTIpAgjUXIDuCDVfIMJDAIH8BChIyM+SkTIKLPYuDafLt0didDjION2j0+N0S2jbzZa5Uf/77qBzlqczY30VWN34tdd7fm8BAIxA8QLO74VcPCEzIIBA3gKrjlaDLTe6JyIyFiPndtuu205nTDvMvFeB8ZosUPqDoiZjpYjd5e5SQRjZbRDjt1FP4deiU/ie7ehit6EgQWRz8dXurRIKWPh1BQkJXzRadEtoXbfUAtaCIRFAYLsA3RG4QhBAoEUCFCS0aLHrnGo9tkbY3S2hTUUJ7GVZ/J+YRRFOFA3b1X2jeFdmKFSAG6WF8jI4AggkFVi13x0lLfBb3mSmi0JSb453U4CHysWuKwUJxfq6NDpbN7i0mstcKnkYXxXjbPr90y4fq3se49I7RD4pSFh2qlS/VUXDvAgggMAGAbojcGkggECrBChIaNVy1zfZOrUJ3dUtoU1FCbde5xVvEBb/5+bfMDzeFzXk7aLirZkhowCV2xkBOR0BBPISCILgSPY7thAhrzdzJzMxXbZ3yGuFGKdJAhQkFLtaFCQU6+vY6Gzd4NiCtqogQcx7X2v73ezLp7IOPKuChJX/IMfvi45doaSDAAJVCuza7qbK2JgbAQQQKEKAgoQiVBkzlcBNGI3r0w5te7eEesWaijvmSd/+oIx5IoelEFi+5Tm3HRNepzidUxAoXoCChOKNmQEBBLYKfNniS8nHvKnYripvUcZrigAFCcWtlO3Gcqi94+JmqHZkrp0i/M2pr3WviJEZs3yBlhUkPLp2q8zdPuQTkW597jGWf+0xIwIINECAe2wNWCRCRACBPAUoSMhTk7EyCdRj24bHKWzqllBZ27lMwslPZtuG5GZZzyjyQUvW2DgfAeHHEhcBAghUKFB44R5/x1W4ukxdpQAPlQvUX7OPeYGzlT70TRSdKSNvS5/Y8QlnYn6kY0/zF3nZCVHO2vLCwdMCrCoLEpp/9ZABAgi0QoDfn61YZpJEAIGvAhQkcDXUSqCORQki67slrNrsnyfds7hW4P8/e2dj3EiRxfHXtmaMDFUsEWAiwESALwJMBJgIMBGciQATAd4IMBFgR3C+CLAj2FXVYdmjj75qSd71eiXNV/dMf/xUdXWAp7vf+72WZqb73+9VMIayDRUgObjEQSpqB1bSZXIEeFlKLuQ4DAEfCHRV2oiUmT5EGxv6IIAgwQ31FLKu+FR60U0U++mVgwH9cLc56rgoTkTU7zb7DKGvlyVquL+EEDVshAAEeiRwPcyzox7HFVqk7gAAIABJREFUZ2gIQAACnRJAkNApbgarQsBPUYLIumwJSbxkRn6qp8qc7PMa56dB+3SOscMjgCAhvJhhMQQCJrDKSGVKGf3QkRssCHUEmmH8IsCGkYt4pJF2H0GCi7mz6nM2/Wo4HN46HIGuHREYF8VFh88ujrxo2O2L9SOyJDTkSDMIQCARAvpumOcHiTiLmxCAAAQEQQKTwEsCvooS1mVLiP5lkw3I3r8jq+/DmRL5qXdjMCBtAvwepB1/vIdARwSelS867TgT1WiYZ686cpNhIOANgejfZ7onPZLZ9DCFzeQkBPrdz5/FiFr0z/t5ft7T8AzbgIDJcqh3B5dK5OsGzSNpon8c5vnFSlR6rJU6pqxLJKHFDQhAwAkByjQ5wUqnEICApwQQJHgaGMwS8VeU8GG2BJ/ttDGPSBdpg6KdPszpAq3lPO0FDjss6aUhAQQJDcHRDAIQqErgvihOlaizjoUI78xjQahqpLguJgKccrcdzeWGnO1efeyP089Oo/JB1p4la23KABxokZv9PDOiPT6eEFhmNtTme/+5Jyb1Zca1VvIWEUJf+BkXAhAIjQDr7qFFDHshAIE2BBAktKFHW+cEekjVW8MnfSdKnQyz7GpV2/gq0pdP0hfXmBVdXMqicReUGWMDAX4PmBoQgIATAstTtnImor50MkDFTjmRWhEUl0VFgGdLm+FMo1TDEzFzIlx2B3/bJEhf7wgssvasslCYe+S3H7BBKOzFVFlkRRgMztmA9yIcGAEBCEAgUALpiFkDDRBmQwAClgggSLAEkm7cEvA5jagW+e0xG5ztTSYnStSvbkn00nurDUgj1tgRdaJm0/MU0pZ2FaGlCEYu+9646cpfxvGGQKvfA2+8wBAIQMAbAr4IEZ6AcELFm6mBIR0S4JS7Hdha5L/7eXZop7dwehkXEx2OtUFZOlpZu+nE/Wgm+uizPL8JyqsIjF0KcXaPKEcQQTBxAQIQgIAfBKzd01f3qLNhnhsxIx8IQAACXhFAkOBVODBmGwG/61MusyWINif7XpxcCD+stTcgn+oFPjvpWLuP8LG592BRLmQ6veA0hnvWjPCOAN9lJgMEIGCFgG9ChOdOPWSDL75Q6q0VR+kEAgEQWGV7+08Apvps4khm08MUBdjjYmIyBX54et/nSMVlm7UNjLiw2PNmsbYxnR7KXI5E6QMROeJQgD2+9AQBCEAAAksCRtj6mA2Omr6HPgkRRNQPiOyZVRCAgK8EECT4GhnsWktgdXrn0t/SCPq1ufFHFr5aG5BrNxiU/MuUtoiMizfu+Lyp4w0kDLFGYJhnPDtYo0lHEEiLwEJIt8goJad+L+aTMjOtmYm3hgCn3NvNg7lW33+6NzDvqcl9fM5mmEgwRiL6dJjnF4n426mbZJDpFDeDQQACEEicQL3SX8usxAuhnHnH/vo9PN5nE59IuA8BbwmwqeBtaDBsEwFS1Xc8NyrWplzVDzWLIC9Px3Bqo6OQ9SBMMGlEN6UQ7chrhumagI+CBLPJmRezo1Q3ArqeA4wHAUNg9Tx2WGUDZPGMsDM4EWWECP7fNzhRwhwPmcDTd1Nms6s6p/U55d486qn/ZtwXxWmkpQubT4peWrL54AI7ggQXVOkTAhCAAAQ2ETCloZWWj7L1aSWvlMiiNJiWxT8/EyB82BsZ/5hfEICArwQQJPgaGezaSmB5wm56te3mC0JLBCpkN1ileTUZEDZuTpvUU0r0+UOWXTZNP2XJo+i7cShMGGklV0rrS7PIvQC5O/g7eqA4+CGBCr8JXSEzm5x6d3CqRExtvJthnh11NTbjQCA1As/KMZkTGMfmnm8WS/bzzIgM1n6Wi/j6JMTsUSzipDbD4/F3+V2d3i6fy/WdiJhntqsygcJ9MTlXIj/FQ6IzT5It1fBEmA3bzuZa6UBl9+XSDrjgIwJ+lw4lYBCAAAQgAIEPCaQulGU+QAACfhNAkOB3fLCuhADpIV1PEX03zHNTJ3Hjp8ELukkpeTkTOf8sz29ce5By/5a+H4t4zfXO5brT55bGSDlMwfnuQ0rifx6nx2pHnygt3z0DWKu8THDgMRgCPRBYCA61OtZKjteJQGeiv3l5L38SLmhRRiy08dRGD+7UHJKTpjWBcblHBMaPkzNR8u+XJmnRP+/n+fk6U829dUfpPzxyIwxTKmaTC8OZ5lZS8qM5O/st66V7tj9+XD1u+j2Ny0u8gQAEIACBaAjwbBpNKHEEAjESQJAQY1QT84kXRJcB374Y30CM8IGxJmuC1uqMNOvuYthQMLBVhPDc2lWpDrIkuAuhfz339HJjTt9pvdgUNdkQ1mVjQZDg32zBogAJLDcl58dPWRA2u/ChaPFZNoRF9oQAXf/oGWU/zxYpMflAIDQCH2ZJeG79ZrHxqs2b0Hzt3d7Z9Ks6pTF6t9eRAffF5CZsEZojML11iyjBFnrWm2yRpB8IQAACEOiCABkSuqDMGBCAQFMCCBKakqOdVwTabox75Yw3xmzPjmAxNSebiI5jXlWUYB5aTTmGumU1qvbv2E2674hAVy8369LDl7jIb0lHc4Bh4iZQ9ZnKpIWei77YEXWiRBsBw5fRkfGoRE10bHHIOYHNm2ibBcfjYmLKO3zr3LhIBqjzTLR4d5rLkd6RQ9FysGXzfmTKUImWq5nSl6FklKPkh5eT+vohGxxTLrFdbO4nk8sXWdnadUhrCEAAAhCAgFsCrI255UvvEIBACwIIElrAo6lfBKouoPtltcfWbFmEX6RwFmUWLG2cgORBqYNpsEk0YLJUiOiLxyy7aLpYRZaEDgLo0RBmzrg6Nfwu1btSxw0W/vgt8WieYErYBMZFcVtBYGA2zWw8B3gMixOmHgcnGtMWz9VKvTIODbPMPF9b+WzOkiCjh2xwsO65774oTpWoX60YkEQnm8UdLZ9pntEL43eIkh9+Tnjz3P6YDY6avuf56VW3ViHU6pY3o0EAAhCAQFsC5eWX245AewhAAAJNCSBIaEqOdl4SsLxR7qWP3Ri1eeHLLK7tTaZXFlNysonYTVDlSZTwJEJQs9llmxSzi4XW6XSZzlrLGSfqOgqkB8MM88zq84MRlOlmIoTnC/Z3wzw/8AAPJkAgeAKcdH0WQtKxBz+f+3bg3fPS6nS80mLEB6VZCMzzmhJ5a07Kz0XdFPnuVd1NxU1ZEkyGk/08O33JhrINNWfLmt+HpVB396y87E3lsYJ4V2LuVI5n5xciSmiHvKJIs90gtIYABCAAAQhYJGB7zc6iaXQFAQgkTsDqhkLiLHHfEwKIEloHYuOpKdOzg5SFQSyytabqSQdmkbSNCMG4sSrXgQDBk5j2YcZM9De2UghbFTmxcdjHdGDMCAlYLMsUPh0tvwz3MnPP4wOBygTM+4gpZyIiRxZFvEYBeqdFXWqtrj7dG1yWGbR1k3hDNjQHz/plZob892tRcmYyW6yeZ86UyE+WHQrmXem+mNzYne+WSSbcHaKE5sEfFxPdvDUtIQABCEAAAt0TQJDQPXNGhAAEqhFAkFCNE1cFRoCF9DYB25x61FEa12AW2dpQjaXt5nrEsXiIH9UIbP6dqNb+w6usCcnYOGyCnzYQ+IgAJ10/QLJVqMn0gcATASP61LuDUyX6uELJExvgRiL6ciZyvk0kuGWTeCSz6eFLoSqp9xuF5lpEHziKezDvSmTXaTR3OmuEKKE+akoT1mdGCwhAAAIQ6J8AgoT+Y4AFEIDAegIIEpgZ0RIwKcBF1O/ROujGsY0LXqsNw/84GDaYRTYHvgfV5VPJh6CMxlgnBDalem4zmCXB09rNlTZ20RYCqRLgROD7yGvRP+/n+XmqcwG/txNYvXOYbAilZRhcsVyWd9Dnwzy/eDnGtk3iTRuUpCh3FalG/QbzroSYpVF8O22EKKEebg661OPF1RCAAAQg4AcBBAl+xAErIACBjwkgSGBWtCKw3KSWUxF1oEVfPmbZRd3apq0MKGnMae6adDekbl2elJzcpH7qpybNqC5H4BNVOG0442Rx3EaaaBZabYSXPiAggiDh+SzQd8M8P2BeQOA5geWzkZw5ej5uCnskWs4f8sH50ztZ2SbxQswwmx4/z5TAc19T/E7aOXnmcmKpKe1GentXaK31q5X8uZ9lx9Y6jLgjS4LpiAnhGgQgAAEIeEggqGdHD/lhEgQg4JAAggSHcGPuepW6zpzAWXMSSL8uSx3aJRsbG1xd2tvjWBsfWBwz5EGpx6BXGdpaOv0qg3FNMARcKK5XaeJvReTzdiD03UzkeFsK63b90xoC8RNgU+lljO2Wqol/BsXroadChJfAF8KE4V52VrEEy0iUHA+z7Mp0ZO9+HO886M6zsARRjt8bu8Me/Uj69TDPjaiKzxYCHHBhekAAAhCAQIAEWGcPMGiYDIFUCCBISCXSFv1cnZgxaWu3bhhtSx1q0ZzSrhyf7i8dP5wL1i+0d3AqgAclzyfJuJiYxene0hB7jidZ82aiv3Gx4W/1N0fLL89PiSYbLByHQAMCCBJeQgtrU7BByGlSQmCZultfeJYRocRqfWeyOGhRp0rk69IgP7tv8vxXSquzC1yIQF0Zb/U5zpWR9LskoOUXI1oCx2YC/A4yOyAAAQhAIDgC3N+DCxkGQyAlAggSUoq2BV8b1pAfaZELNZueP08FasGcyl1Q+68U1WiYZ69eXtURNwQJpeHp7wJS9vbH3v+Rm50WXmbY2T3bdirLcu3q0Uz0kQvxhP8xwkIINCOwyoT1d7PWMbdq9rsXM5EUfNueGS5GAkbEoEy2osMyAXqM3vvoU0iCBO4fPs6gbTZxX9tGx/I7SWiTA3shAAEIQCBIAtzbgwwbRkMgEQIIEhIJtA03baSrM/UK9VxdfLo3uLRhU50+SB+5dSHio5SNHabpR5BQZyJ3fC2LMB0DD2q4eqleF9lqiumpKPm3cXPb4rp1IYySfz2loQ4KMcZCoCcCHQkSe/KuzbBkSWhDL8S2Nt5/QvQbm/0iEJIgwZC7LyY3lTJy+IU5WWtcZT2LASjZomKIIj5AAAIQSIzAbPpVXwdCEyONuxCAQAMCCBIaQEuxif2FaX2nRc4fs+ziC6XedsGU0xqbKc+1+v65SMRsHO5NplcdLSQhSOjiC9BgDBbhG0BLqIkpy7OfZ+b0ZOlnXZrrssVPq2IYBAmlMeICCDwnwO//tvnAiZMUvi1GmLsj6qKjZ+EUkOJjCwKhCRK4h7QIdj9NRw/Z4KCrdZl+XKw/qv01sPo20AICEIAABCBQh0Cddbo6/XItBCAAAVsEECTYIhlxP4tTrZPJjbt6qfq1KHXRxenVhiUnIo7uyrVn6smOxQjGAAQJHs6w5fd+atL1fu6heZjkCYGyBfLV78mZEvnpI5NLRAL3xeR8bbsmviNIaEKNNgkTIKvUtuDru4csO2TjJt4vCJup8cY2VM8essEXIf3mrDLt/SdU3onazTv5i8D/8zg93lH6j0TnA25DAAIQgECABLTon/fz/DxA0zEZAhBIhACChEQC3cbNrhbljIpPiT5/yLJLVwsuvFSumwnv0w/3IEZAkNDmy+mwbVffe4cu0HUXBLZs9C/LLsjZJjFb2YuS1VNJCBK6mA2MEREBqxlKIuLyzhUtvwz3srMYXUvZJ5NNTe8OLsmKkPIs8NT3AJ9juI94Ope2mcW97QM6vA8HOIcxGQIQgEDqBCjXkPoMwH8IeE8AQYL3IerXwJ5OSY+0yIWaTc9d1DwaFxNTIuLp1PdIRG5E5Nt+Sfc6+uI0xCrWlz2wCOY0htkg1VqOH7PBmSvRTK8zYTV4T997H1zHhtoE9J2IutUiN0rLsvyOkiMRMaUctmfXqLDoaa1ua4AL+bVDQQMIWCJAiatKIElvXQlTOBctRXTKnCYiM1Q4YUvH0gCfY6xmukon0v17GuBccwWNbFGuyNIvBCAAAQi4IKCV/LmfZccu+va9z+UB1PmxVuqVEjnvIgu370ywDwK+EkCQ4GtkPLHLA1X49Vyr80/3Bmaj3Mrn2YvlaCb66LM8v1mdxDUn3ZITJpgHFnOz1lpMevSvrUCu10kwgoTnc2eu1YnNeVkPmdurPfjeu3WQ3j0hoF8P89xkUdj4qSJIWPyGzRfCsvcfpQ9E1IEWMS8jXwuLq57EHDNCILDamP09BFt7tbGCqKpX+xi8EoFVabpzEfVDpQZcBIE+CAT4HEPZhj4mio0xKUv0RPG+mNz0tD5iI5D0AQEIQAACqREI8HmxTYhW2e1OlejjNZlZr0XJGcKENoRpCwE3BBAkuOEaRa9+nZLWd6LVxUM+OG97Mn212Xr6JEZ4HqzVCfi+NuajmDcNnAhCkLDuxKjZCH0cDE7azskGzJw1WflpNnc5IeiMMh2vCJR+97cIEkai5dzGPYFoQAACHxLgRGCNGUFKzBqw/LvUbJjuiLpgw8m/2GDRCwKBLjBTtiHMmaxFftvPs9MwrbdndRVhtL3R6AkCEIAABCDQnIApg72fZyZTadSfZanpiclsd1LxHQ5hQtQzAudCJIAgIcSodWSzvyfk9GtR6qKpys0sPhqEJjPCJpScEO9oki2HKd2U7NSaDYPdF8WpEvXrmj+PYsqWwEaUD7MtGRu2fve3pI2/fsgGxzEJgZKJOI4GQeBFaasgbO7PyPJML/3ZxshlBJjrZYT4uz8E9I/DPL/wx55qllC2oRonH6+aif5m23qJjzbbtGmVQfMvm33SFwQgAAEIQMAdgTCfFavyMCUZ1I4+UVq+q9rmw+v064csO2UdsRk9WkHAJgEECTZpRtaX7ycajPpPiT5/yLJLFzcUasl2NqGDECSMi8nVtpIe5iTJYzY4czEXu4rEsuaW/qOr8RgneQJbv/tbREBCCYbk5w4AHBFgAb4+2NQ3beoT86cFggR/YoElJQQCLRGzRVxKyP0nEMQ7uiuM/h7OceUx/UIAAhCAQLgE9N0wzw/CtX+95atsdiYTgin1aiGLr76biRynLLiMbY7gT5gEECSEGTfnVgf2AjbSIhdqNj0fDoe3NuFQ+9ImzY19eb/YsSpf8qaMhhHJzEWfhPhws5rrRnRh4SGvjBR/h4AhsP1kcYkobiSz6aHt33ziAoHUCXCatdEM8P45ppFXCTQqE5smgAAXQyEQqCDB4L0vJjcVU+qGEo1k7Jxr9f2ne4PLZBx+5igZM1OMOj5DAAIQCJPA8/v1Ym1XqVeLFTetD5Ve/bPSb5VS7zJFPwwGN74fqHN3UDbubBJhzmKsTokAgoSUol3R1+Xm6+RGRH1ZsYlPl13PtTq3+eIcmDjDp1hUtcXaQr45hTPb3X1lWxBQM3PASESfhpRW1XDTu4NLFgurTlmus0Jgy+J6lUVAIwB6zAZHvr9EWWFFJxDoiAAbRw1BB1rfvaG30TRDgBNNKON3JGhBwsayd/HHLXgP4zxxWSUsCNaqUOIaCEAAAhDwgMBIK7lSWh822cdZZp+Wt6LlSq9EC23ECmZ9eb6THdrYl3F7L0aU4MHcxYRECSBISDTw29yushHkPzZ9J1pdPOSDcxubVfeTyWXzOkX+0+rZQmuChFUmg1sR/VaLupyLvrAhTmj2nQijrvRKbGFq0pIZoecvQnLDb1hcryMA0kr+3M+y4+TY4TAEHBAgtXYbqOlu2rSh1nfbZs93fVvN+EkSCFiQwL0l9Bmb5oI9JX1Cn7fYDwEIQAACFghcL/rQYrLpypNg4anf+Vy92hEjhBBTVvVIRMw/f25EDvt5tvzvLT7u39XSfMZpERKaQsAKAQQJVjDG00mcJQr0a1HqYphlixtok8/7jW42bZvwK2lTWZBgTrLt59nptv7GRXEhon54usbGhmVTVabvJ7g5GehgNtNldQIbThTXXQDUIr+V/S5UN4orIZAuATJCtYu9Fv3zfp6ft+uF1l0SGE8mR6Llry7HZCwINCFg432mybi22iDut0Wyl34qv6v3Yp2DQauWa3QwNF1CAAIQgAAEoiDwkA2+aHtAtJP1CTIdRjHfcCIsAggSwoqXU2sDL9VQymaZhkifP2TZZZObontlXqkLsV5QaZHjSWgwzLOtv1trHlgq9b8Nbt0N0hd9jWaij2xkarA9AeIUINmmRH/OCGwWJOj6Y6Jsrs+MFhD4kAAitdYzYvSQDQ6aPGO2HpkOGhFAkNAIG436IdD6faYfs5ejdrKg3KeDkY89E/2Nj++yrrBzb3BFln4hAAEIQCAZAhY2+ju6H3u7Zp/MXMHR5AggSEgu5Nsdvi8WNR7PIk/fPtIiF2o2PR8Oh7dVpwBK+aqkal9XusD2XAxSKkgYjw9kd/D3MytK+99msaW4j+ZandiooVWbbkkDTizZJkp/lQnMpl+t+w0eF5MGggThJaIyeC6EwHoCTbMBwfM9ATK2hDUbLD3jheU01oZKoNX7jA9OtxR4++BCwjaEUYrQVoA4iGKLJP1AAAIQgECyBCyVG2u4PlgLu+/ZjWs5w8UQCIAAgoQAgtS1iebU9I6oCyXydddj9zDe9Vyr86obxS/LAfRgb4xDbl1ge1lPvkyQYAC9eGBptYBnV5Hp3ynuVV3Xm8hFSDF+b4L3adN3uekLh606dcGDxQEINCTAZlFDcC+bbRBbWeqdbiwTaHrPsWwG3UGgjECr95myzrv4O+/RXVB2NsZomGevnPXuWcfMVc8CgjkQgAAEIBAiASvPruOiuBVRX7oGEHp5NNd86B8CNgkgSLBJM6K+zImhvcn0KhFRgojoO9Hq4iEfnG9LtftyczyikPfpysaHlNXJNZPF4vMnAysKEq5E5NtVm1YPQfZTjHooSiiKExH1e5+TgLHTI2BbkLAgaEmFnV408BgCH4n5QNKcQKvnjubD0rIJga4WuZrYRhsIPCMQ/O8KpeLCns9zrb6veogjbE9F7ovJTTrrYKFHC/shAAEIQMBTAlbEjF1lcSTToaezCLOiJIAgIcqw2nFquRk8uelCiWbHYlu96Nei1MUwy8ym9kcfThDa4vyun40LbOvKCdQXJLRLMekmZaOXooQLEfWD9ejSIQS6JsDp5K6JM14kBNiYtRhICzUzLVpDV1sIdLXIRRAg0JZAlXegtmO4bs9Gr2vC7vpPaaGezDnu5hE9QwACEIBAOgRmor/5LM9NRt7GHzdr8mvM4XBT4xjREAJ1CSBIqEsssetXJxnMxvy7E+qpIDDpv5Xo84csu3yeNWHdJnkqTBz5uVaQsCkbxUM2+GJbFgtj4weLyy0fKu6LybkS+cm+74gS7DOlRwgYAu1ESDCEQKoEOnvZTwKwvhvm+UESrgbuJIKEwAOYkPkuBAmL0nRPn+n0djgcmsx0zj72M885M5WOXxBIpTQamTyY+hCAAAQgAAFbBNqve3e3RsE6oq2o0w8EygggSCgjxN+FMgUy0iIXajY9N4s090VxqkT9ytSwReDjB5SS7ByjuVYn21JG2hQkuF2obv9wZisKT/1QM9M2UfrrhUCLLAnvFufn8n6R/qUTO3IlHSzc98KOQZMlkF65LsehbimIdGwd3a8IdLfIBXIItCPgQpDQzqL6rVfl+N7Ub0kLHwjEMAfLOCKaKSPE3yEAAQhAAAJVCbTb5O94/yX48mhVo8J1EOibAIKEviMQyPgs1i0DZU4GmP+npqCtibv+BGGl+bZlw/F5msW29S7dChIWs+rHYZ5f2CJqo59K/G0MRB8QcERAi/55P8/Pt3VvFsXzYna0I/pQlBEf6IMGJYpGIvpyW5kfRy7SLQScEOBkoFWso4dscFCW1cnqiHRWmwDPPLWR0aAnArFsBiN+7mkC2Rg2gXJE7rIj2ggAfUAAAhCAAATCIdA0u9LqkOJ5x2WFESSEM7WwNHACCBICD2CX5rvfmO3SG8bygcA6scDq5IxJF7q1TMim0g3j8fhAdgd/v/Ov5cJJB/N+NBN91Laulu14rjKjGKFEcuVabLOkv14IbCwFo5Q2mQ+O7AvL9J0odTLMMlPmiA8EgiXABq3N0LU7FWLTEvpaT4D5zswIhYBrQYJ5B+tCQIXwLZQZt8bOlu/VIXjewbt/CBiwEQIQgAAEIGCFQJWyy88HMmv6endwaX+9rtwd18/a5RZwBQTSIIAgIY04W/Gy6kaxlcHoJAUCazcMKy8Mb0iF/DLNYt2Hn5fgx0Vx2+DUdN34jWQ2PXRdt7WuUWbBcEfURR8PgnVt5XoIvCRgXiaWLzO7x6LUkdLyXReUtMhv+3l22sVYjAEBVwQ6uve5Mt+rfmeiv/FNdOgVoJ6NWZTp0fJXz2YwPARKCbR9pykbwPzuz0SOu/i9ui8mN7xflEXEw78nUIroeaZFDyOASRCAAAQgAIGwCNQQM67eyy77OhjHe3tYUwtrwyWAICHc2PViOYt2vWCPcdC1G/AfZTfY7vnaPu4nk8vnG49tFY5dLUo0TWXlenL0lCrLtVv0nwAB853qb7GbU9EJTLGoXeR5z2p4Sf9oFafdzpjrdnnSm0MCNRZ061qxOnjwRkQ6ydz2UkBe116u74lA5IIEsnf0NK8YFgIQgAAE4iVQ8dnhvihOlahf+wRRpfRrn/YxNgRiIYAgIZZIdugHdfU6hB3pUJtu8lVrimolf6rp9PRlRoFni2lP5FpvAnQlSDAG+3yyunLmikjnLG5BoDaBii9etfulAQQ6IkDaYpug9Y/DPDdlkPh4RgBBgmcBwZzNBBwKEl58D5yLEsi8GOhEj/zZdlWy8I9Ao4PZEIAABCAAAR8JbF2X9+kQnK8HBX0MKjZBoA0BBAlt6CXcljSLCQe/petGTLCfZccvu6mYHWE01+rk072BSeH00efj0zbtTyl3KUgwDs21+n6Tfy3Rt27OaabWCOkgMQKkfEss4JG5y0lBmwHVdw9ZdthFfXabVqfQV8XnzxRQ4KPvBBwKEtacSnMuSuCQg+8Tbo19kQsSEOAHOCcxGQIQgAAEIGCTwGz6lW/llG26R18Q8IEAggQfohCgDSyRFVOkAAAgAElEQVRSBxg0D0w2asPHbHC0bkG+QnaE0oWxj2peW1g06VqQYFKlPmSDA183LVbf/au+anp5MI0xAQJ1CLTO0lJnMK6FgG0CFe7NtoeMtz8LzyTxwunXsx6e9fp1mNHDJOBUkDA5VyI/vQBT+u7VBiRioDb0emob+X2MQzc9zSuGhQAEIAABCHhCYNMhSk/MwwwIREEAQUIUYezHCRTk/XAPeNSNi1pVBC5lmQPWpty1sHDXxyK17w9AVeIV8DzFdAhYJWCEWHPRJ5/l+Y3VjukMAh0QYMPIKuSRzKaHnLiwytRKZ30861kxnE7SImDhvWYTsC0lepyKEu4nk0ul5bu0Ahmwtw7nYJ9UVs86pqzSt33awdgQgAAEIAABCPRPoGz/oX8LsQACYRNAkBB2/Hq3HhV57yEIxoBtN/TyOtX6bpjnB9ucXdfHQzb4om2mgd4WqT1f8KF8QzBfPQz1g4DTBX0/XMSKWAmU36Nj9dy+X74LDu17HEaPvT3rhYEHK30h4PDdYFxM3m7JfubsGWatoNwX3tjxEYEYF+hXh2xOyf7HhIcABCAAAQhAYEXA2bMvhCEAAREECcyCVgQ4Kd0KX0KN9Y/DPDenDj76/PM4Pd5R+o+tMErSQ65fzCoXMVQJQH+L1Hbsr+Jj02vIktKUHO1SJMBGZIpRj8NnNowsx9HhpqJlS5PpDoF1MqEO21FHvx1vtH71yWT6pgSOs4XZj0ruhR2lyK33//20agCW4no5E1FfVm3DdRCAAAQgAAEIJERAyy8P+eC87UHHhIjhKgQqEUCQUAkTF20jcF8Up0rUr1CCwHoC+vUwz80L/0ef5QLY5KZsIaDsNMb605ubx10KaeRQizpUIocmPaMW/fN+np+/NLI/QYKIBFCnk0V8vvcQqE7ARtaW6qNxJQTsEeC33h5LU8ZlP8/MswcfTwiQBcSTQGDGdgKOBAk1RGdORAlkXQts4gfwfrqJ6Grt4RghQmBzDnMhAAEIQAACvRLQd1rUWyXytTh6Hu/VPQaHQMcEECR0DDzW4VjIizWyrf26HubZ0aZe7ovJuRL5qWyUmehvNtVf35Sl46XAYCWcMQsQ62tDbnio6FWQIDJ6yAYHPqsxqS9eNnv5OwSeE9icLQZOEPCZABtGtqPDb4Ftom364z2mDT3adkbA0QJozcMFo2GevbLtc0nJCNvD0V9rAmHdw8z7qt4dnCoRc0ji89bu0wEEIAABCEAAAmkScPQ8niZMvE6VAIKEVCNv2e/VpuQNL3iWwQbdnb57yLLDTZvplUo1rPwf5tnG36pxUVyIqB9eonopYihbbN50crlnQUIQWRIo3RD0FxXjOyTAyegOYTOUVQKrlN63POdZw+q94NCapwF0VPaMGIALmJgAgU3Z3Gy4vnovM+X1yjZrt4rNm9rCu0RTcr21c5Itw6Y3T9kQtCgjRPjaZt/0BQEIQAACEIBAogQQJCQaeNy2SQBBgk2aifdV83RF4rSid3/rIkXdjY1NgoQtp/M/Or1Tsti88bRP74KEALIk1I1n9LMfByGwjcBs+tVwODQbu3wgEBSBTQLAoJzwydiA0177hNGGLVUzdtkYiz4g0JiA498M8zy/N51eKC3fbbTR0SIs7xKNZ0XPDf3KlPBOhKDU8dZ53DM1hocABCAAAQhAIFACjp6FA6WB2RBoRABBQiNsNNpEgBNGzA1DoOwET91a1JsECZtEMFrJn/tZZsozvPuUzM2Np308ECQYoj8O89ycWvL2w2K+t6HBMEsETHYDJfJWRN+KVh8KCpS+FaVuResD0ergoyGVLErXaBGT5vhqP89OLZlFNxDojMCmEkmdGRDfQCOZTQ8RKPUfWE5n9x8DLKhAwLEg4cmCLdkSnGRHeBoX0VuFOeDhJVrktz6fa5flGHaPlajNpRk95IZJEIAABCAAAQgESABBQoBBw2TfCCBI8C0igdtD6YbAA2jH/K2LVXUXm7alON8sbPh4A3+rIGHLAp8PgoQQ0rzfTyaXnESx8wWil94JjLSSKzWXG9mRK5lOb9kw7D0mGOAJgXFR3IqoLz0xJwIz9Othnpua1nx6JIAgoUf4DF2dQEeCBGPQSoB29UEJB8cLsFsy31VnxJW9EDDvqnPRJ5/luSnh6fxjRDNK6SMl+phnEue4GQACEIAABCAAgScCjp+HAQ2BFAggSEghyh37SOmGjoH7NdzW0351xQgr1z4QOJhUjHkxO1ouQshPa91fkxJ9+ybK5gwEPggSjI8z0d90tchTd0qt0qy+qduO6yHgCwGTVUW0vpqLXPn6PfOFFXakTYBsOA7iz6KGA6j1ukSQUI8XV/dEoENBgvHwhSjBaXaEJ6IN3xV7CgjDfkTA0RwdTyZHMpcjWWYc+xbyEIAABCAAAQhAoBcCvLv3gp1B4yKAICGueHrjDaelvQlFt4ZszTRQXIioH+oaZE5caK3OjABBRIwI4ettfWzKJrBVWLDlgcIXQULf6TC3MV+ldv2jbmy5HgI9EhiJ6Mu53rn8dG9w2aMdDA2BoAhQtsFJuDrZ6HNieSSdLja7tPwViTu4ESsBR5u923C9EyUoOR5mmcmY4PTDPcYp3k46N+/ij9ng6Aul3jYdEAFCU3K0gwAEIAABCEDAKQEECU7x0nkaBBAkpBHnzr1cnZg2NbY/73xwBuyLwOghGxysW3zo9LTLmsW6shSgwzzb+FvoiyBBRN8N8/zj2vR9RfvZuJws9CAImFCRgH6NCKEiKi6DwAYClG1wMDVY2HAAtXqXCBKqs+LKHgn0IEgw3pr3qC5LV20ts9cjfoauTqCOKOFF9sNDMiBU58yVEIAABCAAAQh0TID39o6BM1yMBBAkxBhVT3zi1LQngejKjDWLZGaBYW8yvSrLamDTxHWlDbYvNG/f6PdHkNCsbMNSHDQ5fsiyyzYnVbbFiIwoNmcwfdkmYBZFlehzl98B2zbTHwR8JkDZBhfR8Vd06MLbvvpcPBNNp2bD691npvXbXaVekSGhr6gwbmUCPQkSKttn6UIEQpZA9t7N+pKIJr5a60MlYn6Lj0TUl72bigEQgAAEIAABCECgAoFtBxorNOcSCEBARBAkMA2cEmDR2ilenzr/KDvCajHJpELvMEvG+gX9khP8W1Ml+yRIkAYLkfdFcapE/Womi1byp9L60vbGLCeZfPoqYsuKwEiLXKjZ9LzLU33Qh0AKBEip7SrK6zdvXI1Gv+8JlGXSghUEvCDQ4D3AC7sbGMG7RQNovjXR8stM6ctdkUMt6kmA8K1vZmIPBCAAAQhAAAIQqEoAQUJVUlwHgc0EECQwO5wSWJ3OvkH57hSzB53r18M8PzGGrLIinCmRnzo3bMNC3dYT/CWLez4JEsxJ7/08++BkXxnj+2Jysy5Dhc2HKBYNy6LA37siYEQ3eq4uPt0bGDEUHwhAwBEByja4AEuWhDZUqzyvbXuOqtK+jX20hUBrAgmliCVLQuvZQgcQgAAEIAABCEAAApYJ2FxLt2wa3UEgGAIIEoIJVbiGcpIu3NhVtXyu1fdmA3BZpmN+3psAZTb9at1p6HExebspU8OT7Zt89W2Bus7Dz5YTf6Nhnr2qGt+y6xAklBHi7y4JUJLBJV36hsB6AuOiuBBRP8DHMoGETkBbJidVnkXWlfV6ssO35z3bfOgvAgIJCRJMtKp8pyOIKi5AAAIQgAAEIAABCARCoM6afCAuYSYEOieAIKFz5GkO+DxtfJoEovZ6JEqORcuZiPSZhnFt6YUyQcy2xenVYpj2Kno1FiO3lEzZWqairr8sGNYlxvVtCRgRgoi+ULPZJSUZ2tKkPQTqE1gKEPUf9VvSooTARyWwIFaNQOmzSGlGrOK2N0FtNRe5KnUCNd4BYkBFloQYoogPEIAABCAAAQhAIB4CCBLiiSWe9EcAQUJ/7JMbeWva/ORo4LB9AutrL5eJYcoeJrw7MVfj9OSWlNqWBQmclLU/n+nxBYGRVnKltL58yLLLL5QyWU/4QAACPRLw7v7YIwurQ9e4z1sdN/DOtmXDqlLyqlTQEDgfzA+fwCIjlJZFSSqt9Ful1I1Mp7cxCzP5XoY/b/EAAhCAAAQgAAEIRELAarbhSJjgBgRqE0CQUBsZDZoSeKP1q08mkxtOHzUlSLstBDY+FGxbyKq4QO1XhgTRr4d5flI2G7ZmhrC82TF+nJyJkn+X2cTfIVCDwEKAIFpfzUWuPsvzmxptuRQCEOiAAEJTZ5DJktAA7RaBzEhm08OyTVs2PhtAp4lPBK61yI0SfTMTuYnluYksCT5NMWyBAAQgAAEIQAACSROwergvaZI4nzQBBAlJh79758vS53dvESPGQECL/LafZ6cvfVmKYKZvNvmolfy5n2XH2xh4eAK00gPQlnINIrYFCUVxIqJ+j2Eu4UP/BKp8L/u3cmmBSVtf5LtXZGzwJSLY0SWBsgxEXdoS3ViW79PR8Vnj0EZxZEWWiCtTmCVJ+RiNsBPxW1LzFmchAAEIQAACEICArwQqrcf7ajx2QcAXAggSfIlEQnawgJ1QsLtydTb9at3Jt3HZRnmFRWoPBQlSVmbCYN9SrsG+IGEyORItf3UVbsZJgMCG77SPnpvfmWGeX/hoGzZBwCUBRKYu6QpZEhrgHRcflZCqzBFBQgPgNAmIgL4Tkau53rn8dG+wKPsQymc8Hh/I7uDvUOzFTghAAAIQgAAEIACBKAkgSIgyrDjVNQEECV0TZ7wFgTULhpCBQEMCm0sY3BeTGyXy9aaO51p9X7YoF6IgoXSTqIIQo24wfORU1weu94lAtdIkbSxefE+UeiVzOVr0o/SBiDpY36e+Fa1uzd/mom52dvTbYZZdmX8nS0KbKNA2dALjYvJWRD4P3Q8v7Xdwr/bST4tGvdy43JRBa92QpIa3GAi68p3AInuC0vryIcsuQ8jyxNqB71MK+yAAAQhAAAIQgEDcBOq8W8ZNAu8g0I4AgoR2/GjdkIBJpb83mV5t2yxu2DXNUiOwKTtCldM0FU5he7nRruRfT5uhaxfVHydnouTfG6eCg00Oai+n9sXrwN8K3886VhgBwo7IkRJlyrR8W6ft5muXwgmzCVZWn9zOePQCAb8IsEnkNB6VT/c7tSKwzp8/t1URnj65xynswAKNubYIjET0pe+ZE1Zl+IwwFAGcrcjTDwQgAAEIQAACEIBAdQIO1tKrD86VEIiHAIKEeGIZnCerhb8bFhaCC51HBm8+RV1lk6Ss9IG3p+VKBAllmSHEwUPUfTE5VyI/eTQ5MCV4AnayJJiSClrUqRMBXMl3MfgQ4AAESgiUlkaCYCsCWvTP+3l+3qqTxBp/kLWj5m80GT8Smyy4+5LASItczEVffJbn5h3dqw9lH70KB8ZAAAIQgAAEIACBpAjwbp5UuHHWIQEECQ7h0nU5AW83fMtN5wofCGw4QV3xFE1p7Sdv5+eWBfYqJ/y0yH/38+zQZghN2vodpf+w2Sd9QUBaZElYzsn5uYj60hHJ0t8QR+PSLQS8IVDlnuONsUEaou+Geb6hlEyQDjk3elW2yog4vq17D7mfTC6Vlu+cG8kAEPCcgHlXUKLPfSvpUCq69pwr5kEAAhCAAAQgAAEIBEqgptg9UC8xGwLOCSBIcI6YAcoIcLqujBB/X0dgW+2mcVnJgkWH5aevfRUkbFNlVj491GKjd9OM9LK8BV+foAloJX/uZ5kpsVD5sygJNJ1euN1U0nei1Mm20imVDeZCCAROYFwUtw6FP4HTsWG+/nGY5xc2ekqpD/N+UZcb2Z5SmiH4WpHAImuCmk3PfShNVe0dr6JnXAYBCEAAAhCAAAQgAIGKBGaiv/Exi1hF87kMAt4QQJDgTSjSNoQFwLTj38D7rXWVK6XcrVC2wNtFry22Vz3d12SjtyxOVccu64e/Q+BDAvr1Q5adfqHU2zIyCzHCZHrlpDyDyKLOsih1gRChLBL8PSUCVUokpcTDtq8ushrZtjGG/hBIxxBFfHBJwLw7KJHzPp6Blt9POUP85jLC9A0BCEAAAhCAAAQgsIlAWdlnyEEAAtUIIEioxomrOiDAgnYHkKMZYvNpwcoiggqplir31TXXDYKEVamKN1XNMQuLj4PBSZWN3ip9sphfhRLXNCGwSB2s5LRsEXxcTK4Wabrtfq5F9IVvaYvtukhvEGhOgN/+5uwqt6zwzFK5Ly78iEDl7FKwgwAEDIHFc1HdDCRN0CFEaEKNNhCAAAQgAAEIQAACdglQStEuT3pLmQCChJSj76HvjjaTPPQUk1oQ2Fi3fbUhfysin5f2X6FkgbfzcYMg4Z/H6fGO0n+U+v7igsWJp7ncLP7zjlyVbfpu6r+uIKKunVwPARF9J6JutciN0vJhxgSlD0TUD3Yo6TvR6kLm0wsfUhTb8YleIOCGwHg8PpDdwd9ueqfXJYHyMlOQ2k5gITL9+PnnlRJ9zKlrZg8EmhAwz2Ry5kKYsCybpy/4bjaJC20gAAEIQAACEIAABGwScJFl2KZ99AWBkAggSAgpWgnY6jjddgIEo3dxe6kGs9is5N8VKIyGefaq7Dpv62JvECTYyTLSTvVJ2YayWcXfPSZASQaPg4NpfhPw9n7pN7Za1j1kgy9sZTSqNXAkF3ub9SoSvriRMgH7woSmIuuUo4DvEIAABCAAAQhAAAKOCFQo++xoZLqFQHQEECREF9LwHUKUEH4MXXkw1+r7T/cGl+v6r3lCc2OWhae+vT7tv1mQcGvnJNHmkhhlsSV1dxkh/u4jAVMS4jEbHLHZ52N0sCkEAnYEcSF42p+NWvTP+3l+3p8FYY9cK4tW2K5iPQT6IWBxoXaZIUH+6scRRoUABCAAAQhAAAIQgMAzApRQZDpAwBoBBAnWUNKRTQKIEmzSjKSvkkWuOuUVtMhv+3l2uo2M1ydz1rCoKcgomRTtsiSMi4lJpV9eNiOSqYkbkRCwuJAeCRHcgEBlAvdFcapE/Vq5ARfWJmCEU/t5dli7IQ3eEWCeMhkg4I5AlferOqOPi4mucz3XQgACEIAABCAAAQhAwAUBshW6oEqfqRJAkJBq5APwG1FCAEHqzMTttZPrLjBXOWV4X0zOlchPnblYY6B1mSLqMigfrnmWBJ/ZlfvNFWkTaD7v0+aG96kT+F9RHO6K+k/qHFz7PxP9zWd5fuN6nJj7p7xIzNHFt54JlGagq2MfAuc6tLgWAhCAAAQgAAEIQMAFAQ4GuKBKnykTQJCQcvQD8B1RQgBBcm7idjHCKjOAWZyvfiK/Qqolrxes19h/P5lcKi3f2QtH8ywJdrM12POIniBQhcBzwZLZZN0ROVJavXrXVulbUer26d8fBoMbSj1UIcs1sRNg88h9hG2fQHZvsX8jUFrKv5hgUTQERsM8e/+81NKtOtnvWg5FcwhAAAIQgAAEIAABCKwnQDZVZgYErBJAkGAVJ525IkBtYldkfe93uxjBWH9fTG6UyNd1PClLteT9Sc81ggQ3aU2bnxZnEbHOjOTayAhcP/mjlbxVc3l/mhkxQ2Shxp3nBOwL4+D7MYHmYkFovifgteiUQEEgYAJl71h1XOP9vw4troUABCAAAQhAAAIQcEGALIUuqNJnygQQJKQc/cB8Jw18YAFraa67sgrli/m+L4C9fBgaTyZHouWvlsjXNjepqZTo82GeX9Tp36VNdezgWggEQQDFdRBhwsjtBOyXDoL4OgIsiLSfFzyjtGdIDxBYS6BCFrqq5MaPkzNR8u+q13MdBCAAAQhAAAIQgAAE7BIo30OwOx69QSB+AggS4o+xNQ//eZwe78wnN8Ph8F2qamudV+yINKsVQQV8mdkAn4s+KauR3GIubK1vasqEfDKZmjlevQREx7yHefbBb3cXC3ZN0kSTJaHjicFwIROwWnc5ZBDYHi4B77MLhYv2A8urCDYjcdWpGzyjOMVL56kSsCiwXKw9KP1HqijxGwIQgAAEIAABCECgXwJN1sL7tZjRIeA/AQQJ/seoNwtNHXi9u3ssSh09q00/Ei3nw73srC/DlgvecimivuzLBsZ1QUDfichZlZP4rRaoShbKutjcb0vvI0FCMbkSkW/b9lvavuapJ04glhLlAgg8EbBadxmsEOiLgJvyQX154+24CJgshIZnFAsQ6QICHxOw9vvEd5TpBQEIQAACEIAABCDQJwGyE/ZJn7FjJYAgIdbINvTLbPQqpY+U6ONtG/5VT7E3NKO0mTnFvjedXjwTSpS24QJfCei7mchxWUaEJ+tXJzDNBnzDDAb6x02ihxBOd5rv3n6eHT7xWGV0eNNRdGsvMnICsaPIMEz4BGbTr/rMQBQ+QDzwgQC/+d1E4aUwsZtR4xuF+RpfTPGodwJWBZaI3HqPJwZAAAIQgAAEIACBJAm8XH9PEgJOQ8ABAQQJDqCG1OWGLAiVXTCpax6zwdkXSr2t3Mjihat6xSZbQ8PNaYvG0FVTApU3uduLEURkwyn/hchlMr1SIl83daSjdh/wapUtoonBZEloQo02ECglMNfq+0/3BpelF3IBBDwmEEKWIY/xVTet5r24esdpXckJ7LTijbfdELB5kmxcTMwaA+/53YSOUSAAAQhAAAIQgAAE3hHYfKARSBCAQHMCCBKas4ui5X0xOVciP7V0ZiSiT6uk2m85ztrmC1HFYHBOtgQXdDvps5IgYVwUJyLq97YWbTpVeD+ZXIYwh17Wr7L0Ha6DtVK8nnfI6aY6eLk2VQLUpks18nH5zQZvN/HUon/ez/PzbkaLexSyJMQdX7zrnoDN3ycjRt8RdaJEThAmdB9LRoQABCAAAQhAAAKJEhg9ZIODvg7gJsoctxMhgCAhkUBvctPyItz1TPRp1dT7ttEvF8H1xbZSE7bHpD8rBEo3uO2duNR3wzw/eG71quSBOZX8rRVvHHfycpHvvpjcdJ7VocbJTDanHE8Iuo+JQOlvYUzO4ku8BBChuY8tAiZ7jHlOsceSniBgCGglf+5n2bFtGitxuhEmBPHOZtt/+oMABCAAAQhAAAIQ6IqAfj3Mc/PcyQcCELBMAEGCZaChdedi0bjvMg7LxQo5Q5gQzGzcuAlnsl/I7uDC1sLTywWyIEUsz8QAKzHFmx4iXXnjdFVW5dcebGRICIRGwGrd5dCcx954CFgWu8YDxq4nle/DdoeNszfmbJxxxav+CGzKSGfDopWIyJRsRJhgAyh9QAACEIAABCAAAQh8SGA2/Wo4HN6CBQIQsE8AQYJ9psH0uNrs/duRwSMt+qzPdLJGmKBFnXZ+etwR0Ii7XbuovtrINotN9uqGavlluJeZPhcfF4Ic53F69lD0z+P0eEfpP5yPuWaAqguNoZTC6IMhY0LgJQGbdZehC4G+CNjLatSXB0GMiyDBYpjIkmARJl1BQETmWn3/6d7AZKBz9glSWO6MBh1DAAIQgAAEIAABCNgg4Crblw3b6AMCMRBAkBBDFBv60M3im74TpU6GWXbV0MzWzd7XntTHZE1ojdNFBx8sqrvMcPF8cayb+W8d1wcnqO+LybkS+cn6KCUd1nk4GxfFLd+7riPEeOES0D8O89xkheEDgWAJmOeuXVH/CdaBQAyvKgwMxJ3ezeR5pfcQYEBEBLosK4MILqKJgysQgAAEIAABCECgbwI1yhT3bSrjQyBEAggSQoyaJZu7fHk3G5hqOj3tO93NYpFcq2NRciQih1ZP31uKS4LdXD9kg+O9yeREiZy63Lx+fvo4UEHCB+KN+2Jy00cGEC365yrZTxxnYUnwq4LLsRPocgE/dpb41y+BcTF5yzOW2xggSLDLd1Wf/ne7vdIbBFIloO+GeX7QlfdLIZxcunyP7MoXxoEABCAAAQhAAAIQ6I0AmQh7Q8/AqRBAkJBKpNf42cvpai2/POSD8y+UMgvVvX8WG6aDwYFofSBaLRZNtJJXfZw67x1GfwaMutq0eL54H+LC8/PNyjdav/pkMn3TS9gq1tIKkXEvPBkUAu8J8PLDbIiCAOV63IcRQYJ9xmRJsM+UHtMl0HUZKvNutDedXigt36VLHc8hAAEIQAACEIAABJoS6KLsWFPbaAeBWAggSIglkg38GBcTU0bh2wZN2zYZiehTn9NS9yLWaEuV9lsJaJH/7ueZyYohq3TSZv5/Hha29+nc/3mcHu8o/UfX9j/nWDb2uCguRNQPZdfxdwhA4D0BNhmZDTEQuC+KUyXq1xh88dOHbk8f+8nAvlXMW/tM6TFhAlp+Ge5lZ10T4P2ja+KMBwEIQAACEIAABCIhQLmGSAKJGz4TQJDgc3Qc29ajIOHJs+uZ6NPP8vzGsau1u1+ePp/ckPaxNjpvG5iyIftZdhyuGEFEnmUm6G2xrcbiIicNvf06YJjHBLo+UegxCkwLmAAle5wHj2wqDhCvsk/dhidYdQCDLiHQkkAdEXPLoT5q3tt7km1H6A8CEIAABCAAAQhAoDsCCBK6Y81IyRJAkJBs6EV8qe9r0tA/ZoMzX8o4PE2Jvk6gJzwlXbt+LVquRMlpoAvNo2GevXqC1Ndmf9XNUjajXE9n+o+XwPtMKPH6iGcpEOjrPpUCWxH9epjnJ2n42q2XZEnrljejxU2g6nuDCwqIElxQpU8IQAACEIAABCAQMQEECREHF9d8IYAgwZdI9GDHuJjoHobdNORortXJp3uDS49sMqKNvspa+IQBWzwg8JThwZjS32Z/9RTRpD32YNJgQpAEjEhvP8+McIoPBIImwMauy/AhXHJFt79nLFce0S8E+iPQ9zMNooT+Ys/IEIAABCAAAQhAIDgCCBKCCxkGh0cAQUJ4MbNmsWeChIVfZtP1cTA48SVbAouS1qYbHbUl8KxUwrgoTkTU7227rN+++onM+8nkUmn5rv4YtIBA0gRGIvp0mOcXSVPA+SgIkGmq0zBevx9N34pWt3NRN1rNb30sjdYpmQaD8QzTABpNILCWQHUxsyuA98XkRol87ap/+oUABCAAAQhAAC1Y22IAACAASURBVAIQiIQAgoRIAokbPhNAkOBzdBzb5qMgYeXySJQcD7PMZCfo/TN+nJyJkn/3bggGpE3g2UNRX6d95lp9XzWLice/L2nPI7z3loBvgjxvQWFYUAR8KQ8WFDQ3xi7KVs2UvkSgUA4YMU05I66AQFUCdd4fqvZZ57o3Wr/6ZDK9DbRkXx1XuRYCEIAABCAAAQhAoA0BBAlt6NEWApUIIEiohCnOi3zfMOw7xePzqK9ECSaF9udxzga88p3AMM/e/V73VJd7NMyzV1U4sZBfhRLXQOAdAS9LFhEfCNgg0JeAzobt8fah77SoSzWbng+HQ7NJx2cNgZ6etYgFBKIj8LzsXF/O8W7SF3nGhQAEIAABCEAAAgERQJAQULAwNVQCCBJCjZwFu30XJKxcvH7IBsfelHCYTI5Ea5Mu/wcLIaALCFQlcD3MsyNzcV9lROosJrIBVTWsXAcBGc1EH3FimZkQKwE2gXyPrH4ts9kZwoSP40SGNN/nLvYFRWA2/arv3xlKsQQ1YzAWAhCAAAQgAAEIdE5gJvob1uc6x86AiRFAkJBYwJ+7G4ggQUT03Uzk2KcbArUoE/7i9OC6Fv3zfp6fm6Hvi+JUifq1ezP0j1Xr2pOiu/voMGKQBBAjBBk2jK5LgHtCXWLdX2+ykj1mgzNfBMDdE1gjSBiPD2R38LcPtmADBIInoOWX4V521qcflG7okz5jQwACEIAABCAAAa8JkLnU6/BgXEwEECTEFM2avoQjSFg4NhIlx8Msu6rpppPL/1cUh7uijC2UcHBCmE6fE3iu0OzrdM9DNviiykbF6rvxHyIIAQiUECAVHFMkEQJkzQkl0P4JgPsm19czV99+Mz4EHBAYPWSDgyrvEg7GftclmU9c0qVvCEAAAhCAAAQgECIB3oNDjBo2h0sAQUK4sWtteWCChJW/1U9plwEaTyZHWuvDuchVk+wLy41XuRRRX5aNxd8h0ILAaJhnr57a93HSVIv8dz/PDqv4wMZTFUpcAwH9epjnJ3CAQAoEKNsQWpTtPWuH5vlLe5m7oUcQ+70i4E2WhMkN7+9ezQyMgQAEIAABCEAAAn0R8KpUeF8QGBcCXRJAkNAlbc/GClOQYCDWWygdj8cH853scEf0od6RQ6X14fNFCLPZ+pgNjpqc2DCpH/em0wul5TvPwos50RB4v3FpRDSi5a+uXXteMqJs7D4EE2U28XcI+EZgrtX3n+4NLn2zC3sg4IrAuChu2QByRddFv/WetV1Y4EufPNf4EgnsiICAF1kS+it/F0EEcQECEIAABCAAAQjEQsADsWwsKPEDAnUIIEioQyuya8MVJJhArF8ofcp6IKIOlIg50f1tlbC1ESWY/lcLG6YuJiUcqgDnmhoE3s/13tKMzqZfDYfD2zKjOUlYRoi/Q2BJYJhnPH8xGZIi0Nv9KynKtp1FlGCIkvnJ9ryiv6QJeLDwaw4UfDKZmvca3tuTnow4DwEIQAACEIBAigTMHtBc9EmTbNkp8sJnCNgmwIK4baIB9TcuJldVN+y9dEvLL8audVkPmtjbVpRgMjHoweCcbAlN6NNmE4GHbPDFU/aO+2Jyo0S+7paWvhvm+UGVMVm0r0KJayCAIIE5kB4B84wku4O/0/M8bI9nor9JfaGmr+xUYc8crIfAZgI+/K7cF5NzJfITcYIABCAAAQhAAAIQSIiAB+LYhGjjKgTWEkCQkPDECF6Q4CR2+k6UOhlmmRFrNPosFy71BamJG+Gj0TMCRiSzn2cm04esTvO86RqQFvltP89Oy8bty74yu/g7BHwkQIYEH6OCTa4JIFpzTdhF//ruIcsOm5Q1c2FNX31ScqQv8owbI4Hn7zd9+YdIri/yjAsBCEAAAhCAAAR6IXAts+lJley/vVjHoBBIiACChISC/dJVTgZsCb6WXx7ywXmbBdhxUZyIyBnChIS/ZG1df6bcXM4n9XvbLmu3V/KvKgId6rHWJkuDaAjou9q/8xXLoESDCEcg8L681a/ACIuAVvLn42Bw0uaZOCyPP7aWd6bQI4j93hHw4HRaP5nnvIsEBkEAAhCAAAQgAIGYCYy06LP9PD+P2Ul8g0BIBBAkhBQty7ZSz7cMqNlkkrNhnl+UXbnt7yvO5oQ5dSrbgEyw7fOUpj2dLB0N8+xVFfScHqxCiWtiJPBU7ueT6fRQ5nK0LCMkR9t/86nNHuNcwKftBLhPhDtDUq+zSdmGcOculvtMoN9nod7E3j6HBNsgAAEIQAACEIBANAT03UzkOPUShNGEE0eiIYAgIZpQ1neExbXKzK5FyVmVU+KbejTp7PcmkxMlclr7JG1lM7kwLgL6bpjnB08+jYvJ2+5FLfr1MM9Npo+tn38ep8c7Sv9Rdh1/h0CsBJ5ECc9PEC/TAe8eaVGm7MqREvn6mf/XwzwzogU+EEiCABs/UYR5NBN9lOqCTj/PYVHMG5yAwBYCS1GCeWbqOoUu5eaYmBCAAAQgAAEIQCBaAkm/u0YbVRyLggCChCjC2MwJXsLrcTMbTkr0eeuMCZRyqAc+0au1yG/7eWYya8j/iuJwV9R/ukYx1+r7T/cGl2XjjovJlYh8W3Ydf4dA5ARGc61Otn1nFkLApywK0+lp14vvkfPHPY8JkBrb4+DUMG2d+KpG86Av7SlTVdDMMB4C1QisSl/1UMaBe1O1CHEVBCAAAQhAAAIQCIpAD8+VQfHBWAj0SABBQo/wfRia9LmNojDSIhdqNj1vs5lkNqa0yKnS8l0jK2gUNwEl/3rKytFX7eKHbPBFWc1oMq3EPQ3xrhGB67lW51XEPI16pxEEAiOwzBYy+DswszF3AwGt5M/9LDtODRBZPlKLOP72Q6BadjZbtlHC0hZJ+oEABCAAAQhAAAL+EKiynu2PtVgCgbQIIEhIK94feXs/mVyyId58EpiTYiL6Qs1ml03FCWahXu8OTpWISY3/eXNraBkRgdEwz149+dPH6Z2qGw6cGIxo1uGKZQL6Tou61FpdFfnuVZm4x/LgdAcBbwjcF8WpEvWrNwZhSGsCVTMotR7Iow7ILOdRMDAlagLPs8S5dhRhtWvC9A8BCEAAAhCAAAQ6J0CJ1M6RMyAEqhNAkFCdVZRXskhsL6w2xAn/PE6P1Y4+QSRiLy5h9vT+dFBfJ0u16J/38/x8G7++bAszplidOoHlPUKulOgbmc2umorYUueI/+ERQLgWXszKLdZ3wzw/KL8uriv6EIjGRRBvIFCNQJeip3Ex0dWs4ioIQAACEIAABCAAAf8JdJtxy38eWAgBvwggSPArHp1b01dt+s4d7XxAUwtTruZ657LJydjlKazJsVbqGHFC58HrfcDni3C9iYZm06/KNkzHxeRKRL7tHRgGQCBAAjZEbAG6jckJEuBeEWvQ9Y/DPL+I1bt1fvVVQislxvgKgRWBkcymh2XvIjZocY+yQZE+IAABCEAAAhCAgCcEtPwy3MvOPLEGMyAAgRcEECQwJWRcFLci6ktQuCNgNp4Wp2JFrmYiN5/lufnnSp8X4oQjyjpUwhbyRf2XaxD5736eHW6DSIrTkKcYtvtHIL2NPf9igEWuCHD61BXZvvtNL0uCyWS2o/QffZNnfAikQKBq+bi2LMaPkzNR8u+2/dAeAhCAAAQgAAEIQMADAggSPAgCJkBgMwEECcwO4bRPL5NgJCI3WuRmIVRQ6naYZea0eenHZLXYETkSpY6U1oeISUqRBXZB/+UapMLDG2mLA5tWmOs1gZnob+oI1bx2BuMg8IIAgoR4p0SXadV9oLgUCU/f+GALNkAgCQJK/lX1HbkpD4RGTcnRDgIQgAAEIAABCHhIoMKatodWYxIEkiGAICGZUG92lLINPk0CU+pB3S6EClrezkXd7OzotzKd3m5LWbk4rS4iWutDpdUrUWL+3Zxw/9wn77ClnMDzxf1xUZyIqN/LW9m9omxztLcyEnbdpDcIeEIgvVPGnoDHjA4IkE2nA8i9DpFefU4Emb1OOAZPj8D1MM8W77muPuPx+EB2B3+76p9+IQABCEAAAhCAAAQ6JIAgoUPYDAWB+gQQJNRnFmULyjaEFNalaGGDxYgQQgrlR7Z+uDHZT03T7Zujq0U7U3IEsUvQcw3jfSGgRX7bz7NTX+zBDgjYJIAgwSZNL/v6oMyUlxZaNmpcFBci6gfL3dIdBCCwiUAHWRLI5MP0gwAEIAABCEAAAnEQ6KrsVxy08AIC3RNAkNA9cy9HpHail2HBqMQIPN+Y7C8LwfbTjv2IJBKbCLibFIGyjCRJwcDZ6Aj0dy+LDqW/DnWwWeiT88xpn6KBLWkQcJ+JhfebNGYSXkIAAhCAAAQgkAQB5xm2kqCIkxBwRABBgiOwoXVLqsLQIoa9MRJ42pjsMwvBtnrQCJdinHX41C8ByjX0y5/RXRPgvuGasAf9J5YSk6wfHsw5TEiPwGz61bbyhW2B3E8ml0rLd237oT0EIAABCEAAAhCAgFUCI9FyXqtHpW+HeX5Rqw0XQwACnRFAkNAZav8H4kXc/xhhYcwE3m9M9nhKZ2PqZRbgY557+NYbgcQ28nrjzMC9EeDZsjf0XQ6c1AmUN1q/+mQyfdMlYMaCQOoEtOif9/O83mJ0DWiI52rA4lIIQAACEIAABCDQHYGk3jW7w8pIEOiPAIKE/th7NzIbjt6FBIOSI6B/1CKvlKhf+3B9U52t/xXF4a6oKxH5vA+7GBMC0RJwfOIvWm44FgyBcVHciqgvgzEYQxsRGOZZUu+U1JtvNE1oBIHGBLTIf/fz7LBxByUNKcXiiiz9QgACEIAABCAAgRYEOMTTAh5NIeAngaQWj/wMgV9W9Xgy2y8QWAOB/giM+tv41z8+ZNnl3mRyMhe5+izPb/osH9FfCBgZAl0QcF8TuQsvGAMCmwhwkjydufFUcioVj3lfSiXS+OkVAYciTg5meBVpjIEABCAAAQhAAAILAtvKCoMIAhAIkwCChDDj5sxqXsadoaVjCHhPQIv8pkROVoKIkYg+FVEmPSqZEbyPHgYGR0DJv4ZZZjKP8IFAlAT+eZwe7yj9R5TO4dQLAvrHlOp0IkjgCwCB7gm4LNvAGkj38WRECEAAAhCAAAQgUEbgIRt88YVSb8uu4+8QgEA4BBAkhBOrzixlka0z1AwEAQhAAAJpEqAOXppxT8rrcVFciKgfknI6VWcTS6V5X0xulMjXqYYbvyHQEwGnz06UYukpqgwLAQhAAAIQgAAE1hLQd8M8PwAOBCAQFwEECXHF04o3qxTtf1vpjE4gAAEIQAACEPiQANkRmBEJELifTC7VXG60klfPsu8k4HmSLjrdKPSJKO9JPkUDW1IjMMwzZ+tXCBJSm034CwEIQAACEICA3wQoc+p3fLAOAs0IOHuha2YOrXwhcF9MzpXIT77Ygx0QgAAEIACBSAgks3EXSbxwwwKB/xXF4a4oU6KEEkAWePrWhRb5736eHfpmlwt77oviVIn61UXf9AkBCJQQcCjoRJDA7IMABCAAAQhAAAI+EUirLKBP5LEFAi4JIEhwSTfgvt9o/eqTyeRGRH0ZsBuYDgEIQAACEPCKwEz0N5/l+Y1XRmEMBDoggNi1A8g9DuHy5HKPbn00NOUafIoGtiRHwGF5GL7byc0mHIYABCAAAQhAwGcCs+lXw+Hw1mcTsQ0CEKhPAEFCfWbJtBhPJkei5a9kHMZRCEAAAhCAgFMCpJxzipfOvSZAqnuvw9PauIds8MUXSr1t3ZHHHSwF29M3HpuIaRCInYCzLFPjYmKy+HwbO0D8gwAEIAABCEAAAv4T0HfDPD/w304shAAE6hJAkFCXWGLXc5otsYDjLgQgAAEIuCIwesgGB7Fv2LmCR79xEGDDJ444rvXCYSp1X6iNi+JERP3uiz3YAYEUCbjKxsL9KcXZhM8QgAAEIAABCPhIQIv8tp9npz7ahk0QgEA7AggS2vGLvrU5CbQ3mV4pka+jdxYHIQABCEAAAo4IzLX6/tO9waWj7ukWAkEQYEM3iDA1MzIBQcL9ZHKptHzXDBCtIAABKwQc/dYgSLASHTqBAAQgAAEIQAACrQmwftYaIR1AwFsCCBK8DY0/hv2vKA53RZkUhp/7YxWWQAACEIAABMIgoJX8uZ9lx2FYi5UQcEtgXExMWn+eKd1i7r53h7Xdu3fm4xEp1+BDFLABAiJa9M/7eX5umwWCBNtE6Q8CEIAABCAAAQg0IjAa5tmrRi1pBAEIeE8AQYL3IfLDQE60+REHrIAABCAAgdAI6LuHLDukVENoccNeVwQoB+aKbM/9Ri5I4F2o5/nF8BB4R0C/Hub5iW0g48fJmSj5t+1+6Q8CEIAABCAAAQhAoA4BN896dSzgWghAwB0BBAnu2EbXMy/p0YUUhyAAAQhAwC2B0Uz00Wd5fuN2GHqHQDgE2NgNJ1Z1LI09E8y4KC5E1A91mHAtBCBgn4AW+e9+nh3a7pm1DttE6Q8CEIAABCAAAQjUJ0C5hvrMaAGBkAggSAgpWh7YymKcB0HABAhAAAIQCIIAL1JBhAkjOyYwnkyORMtfHQ/LcO4JXA/z7Mj9MP2MQKmRfrgzKgTWERjmmfV1LAQJzDUIQAACEIAABCDQOwHKNfQeAgyAgFsC1l/k3JpL7z4QQJTgQxSwAQIQgAAE/Cagfxzm+YXfNmIdBPohMC4mup+RGdUVAVenll3ZW6dfRDR1aHEtBDogoORfwyy7sjkSggSbNOkLAhCAAAQgAAEINCFAuYYm1GgDgZAIIEhwFK03Wr8yXcdYM9r4tjeZXimRrx3ho1sIQAACEIBAwAQQIwQcPEzvgACnzTuA3MMQLk4t9+DGR0PeF5NzJfKTD7ZgAwQgYAjYf85CkMDMggAEIAABCEAAAv0SmIn+hpKn/caA0SHgmgCChJaEzeb8J9Ppodb6UEQdKBFTz9D87/NV1yMRudGiL+ciV7H8qC78nkwvReTblghpDgEIQAACEIiIgP1F8ojg4AoEFgTGxcScbOUZMrL5ELEg4QYhdmSTFXeCJqBFftvPs1ObTiBIsEmTviAAAQhAAAIQgEA9AjFn3KtHgqshEDcBBAkN4rs6JfNSeFCxJ30nWl3IfHoxHA5vKzby9jLKN3gbGgyDAAQgAIHOCSBG6Bw5AwZJgBPnQYat1OgYT7SsRNhvSp3nAghAoEsC18M8O7I5IIIEmzTpCwIQgAAEIAABCNQlwHpaXWJcD4EQCSBIaBA1W3VvtZI/lci57fqHDVxq1QRRQit8NIYABCAAgfAJjOZanXy6NzCZg/hAAAIlBO6L4lSJ+hVQkRFwUNe9b0LjojgRUb/3bQfjQwACHxAYDfNsUSLT1gdBgi2S9AMBCEAAAhCAAARqE7D+bFfbAhpAAAKdEECQ0ACzLUHC+6H1nYicDfP8ooE5XjRhYdmLMGAEBCAAAQh0TMCklZuLPomlJFPH+BguUQLjyeRItPyVqPsRux3fqRaE1xFPV1wLm8Bs+pXNjJMIEsKeDlgPAQhAAAIQgEDABLT8MtzLzgL2ANMhAIGKBBAkVAT1/DL7goSn3sMWJvzzOD3eUdqIKj5vgJUmEIAABCAAgcAI6NcPWXb6hVJvAzMccyHQKwHS4PeK393gES4kjYviVkR96Q4aPUMAAo0IWM7IgiChURRoBAEIQAACEIAABNoSGD1kgwPW1dpipD0EwiCAIKFBnNwJEp6MCVeY8L+iONwRdaFEvm6AliYQgAAEIACBEAhQoiGEKGGj1wTcP0977X6kxunXwzw/icW58Xh8ILuDv2PxBz8gEBUBywIoBAlRzQ6cgQAEIAABCEAgFAKWn+lCcRs7IZAqAQQJDSLf3QJqmMKE5am3ybmI+qEBXppAAAIQgAAEvCWglfz5OBicoN72NkQYFgiBcTG5EpFvAzEXM6sRuB7m2VG1S/2/alwUJyLqd/8txUIIpEjArgAKQUKKcwifIQABCEAAAhDomUCl7AimVPh+np/3bCvDQwACFgggSGgAsTtBwjvjrkXJ2TDLzMJtMB9KOAQTKgyFAAQgAIFyAmRFKGfEFRCoTGBcFBeIVyvjCuXC0TDPXoVibJmd98XkXIn8VHYdf4cABHohYFUAhSChlxgyKAQgAAEIQAACCRPQon8uExq8E4nPpl8Nh8PbhHHhOgSiIIAgoUEYx8XE1Ir+vEHTVk3MqUw1nZ6G9OO7SnV60wevVrDjaHytlbxVc7kRpW9FqeVNW2tz2ovsFXHEGC8gAIFOCOjXD1l2SlaETmAzSCIE2PyJM9DDPIvm/fK+mNxQhi7OeYpXcRCw+XvDPSmOOYEXEIAABCAAAQiEQkDfDfP8oMzacVHciqgvRexmxyobN4a/jyeTo/lcvdoRfbjOH63027nI1Wd5bvbu+ECgEwLRLBh1Qms1SO8pZrX88pAPzkPZGPlfURzuijLZHToXcXQ5L/oaS4v8V4m+Ea1uZUeuHgaDm7K5sRKKXJAqua+oMS4EIBAGAX0nSp2ElqEoDLZYmToB83IsWv5KnUN0/iv5Vyy/mT1kxYtuOuAQBJwSsHhSDkGC00jROQQgAAEIQAACEPiAwFyr7z/dG1xuw7LaU3pXquEhGxyX7XmkiNns88x3ssOF8ECJKaFoBAh19uGsZh5LMQb4XJ0AgoTqrN5d2bsgYWnJSESfDvPcbCp7/3mj9au9yeREabVM4/r8xL75d62NIs78YB4tVW98NhAYaSVXi6wHO3LVZsH3vcIQ1hCAAAQg8BEBLb8M97IzyEAAAm4IrMSRf7vpnV77I6B/DOX9ZBsjBDP9zSBGhkBVAlUWsqv2hSChKimugwAEIAABCEAAAq0JsAHeAuFyLWV3tY/Wfi+tSumMFubSFAIfEECQ0GBCeCJIeLL8eib6NKbUKqvaQCec3l+EeCFAEK2vbKbQeVd/qcH8pwkEIACBuAmQFSHu+OKdTwQ4ge5TNOzYokV+28+zUzu99dcLm5P9sWdkCFQmYFE8yne+MnUuhAAEIAABCEAAAm0IjGQ2PdxUkvx+Mrk0BzFDyg7eBkaVtuag7yeTybGjw7yIQ6oEgWusEUCQ0AClZ4KEhQdm8e8xG5zFlLbGnEzSIqdKy3cNwhRsk0UJBi2XbTMgbANAdoRgpweGQwACbglckwLOLWB6h8BzAvfF5EaJfA2VqAhEsaCxWAhL7B0kqlmIM0kQ0Er+3M8yszjb+oMgoTVCOoAABCAAAQhAAALlBLYISv95nB7vKP3HqpORaDlPVZiwKFeh1bFWcuxwzWSrOKQ8mFwBgfoEECTUZyb3xeRcifzUoKnrJqO5Vidl9XdcG2G7/0Uamp3BiSgxp63q1L+xbYqr/pZlGLS+fMiyyy5EJWwAuAol/UIgLgIz0d8Yj3aVeiVzOdJKXqlFLTJTZie28jr69TDPTXYePhCAQEcE2PTtCHTHwwzzLPh3TMS7HU8ahoNAIwL6bpjnpvRj6w+ChNYI6QACEIAABCAAAQhsJWAOYe7n2eGmiza8gyUjTDCCDKX0kRJ93Mmaq8VsY0x9CFQlEPxiUVVHbV4XwMvqtcymJ5tS39hk0XVfptSAVuo4/BNL+k6LulRKLodZdtU1x/uiOFWifu16XMaDAARCIlC+yLtQ7K7ECqIWIoUfQvLwyVabJ+xC9B+bIdAXgQCeqftCE/S4RswWejk5yokEPQUxPiECtgRQPmbBTCiMuAoBCEAAAhCAQAIEtr0nlq0NGDHDYzY46uIgZ5ehWGaFmBsBgsn61eFB3PI13y45MFY6BBAkNIh12Q9kgy5dNFmox4Z72ZmLzvvu02RN0Lu75sf6xGHaGttuXmvRl2o2u+xbLGLKYYiWv2w7SH8QgEA8BJrUAV9ktNndPQtLmKDvHrLsMLaXmnhmIp7ETOBFSsaYXU3KNy365/08Pw/VaZ6TQ40cdidJQMm/bAj8ESQkOXtwGgIQgAAEIACBrghsOY3/RutXn0ymtxs35CM7yd+fCOF9sOdafR9blvWupjLjtCOAIKEBv5AWqYx6TCk5tfGS3gBVJ02exAlqqST7tpNBKw2yzIKgtboq8t0rnza7TKYJEfV7JTe4CAIQSJJAmxOuq/vkZbfq3oZhsrSQ3XB0mkEgaQKLLCui/pM0hAidDz3rDJnEIpyUuBQtAVsCKAQJ0U4RHIMABCAAAQhAoGcCFUo1XKw72GTazUWfhJ59z+D3QYTwbBpcD/PsqOdpwfCJEkCQ0CDwIQkSntwzJ10fs8GZT5viDdCXNjGKuryYHZl6OyJy1GX2hIX4Q/SNiFzJbHblQxYEreV4We/93ccjwUZpOLkAAhDojUD71F1Lsdjgssvf4fq42vtZf0xaQAACzwmQGj/K+TAa5tkrm54tMtS9+LjKBHdfTM6VyE827acvCEDAFQH9epjnJ217R5DQliDtIQABCEAAAhCAwHoC2w48bTqkYETuj4PBSch7Wca3nUV2b22yfH/py/wgO4IvkUjTDgQJDeK+SiPzpkHTnpvoO1HqJOZsCS8BL2I1nR7KXI5W9c0PLGVRuBbRt6LVrezI1cNgcOPbDTKQ0iI9fycYHgIQ2EDAilrW/AbvTaZXnosSrCxkM5MgAIFmBMZFcevTy3kzL2j1koDtRY61whVHGW7YmGQ+QyAcAmUn7qp6wve+KimugwAEIAABCEAAAjUIlJRbWPcM1qSEbA2LnF7qf5lxDmY5nQB0XkoAQUIpovUXhHyaK5VsCdtC+06oYC7S+kC0MkKFtZ+5qJudHf3W/DEkMQeChIZfbppBAAKGwEhEX871zmXbmmKhixLe3S9W9wq9I4dKyyuZTU/6zoTDVIVADATYBIohiut8sHNq+annde9etkUPz8Yyz/2fxxoZ/IJAbAQessEXbQ8HcC+KbVbgDwQgAAEIQAACfRMoE44uyxjoPz60U/84zPOLvm2vO74pj62VOlZavqvbttvrw+TbLSNGc0kAQUJDuuG/sOq7ud45bbvRDfmezwAAIABJREFU1BBf582MOk0Gg3eig5CEBU1hIUhoSo52EIDAi5eBOxE5a/NCsMwsNLnx+xS0fr0ouaPVwTvRgcjGMjfDPOMZiq8KBCwQ4HnFAkQ/u7BatmGtGLzktE1TLCELz5v6TDsIBE3AQraU8Nd3go4gxkMAAhCAAAQgECGBbaUajLsfZ0sMa7P8fUkGMeXDQhC0jx6ywUFbIW+EUxWXOiTAYnpD2OOiuBBRPzRs7k2zGOrxeAPTM0NY4PcsIJgDgeAJtBOyrerCXQXykF4erdn0KzIklGPiCgiUETAnCUTU72XX8fcQCdhbUNogErBSXug52fFkciRa/gqRNjZDIFkCFsRJCBKSnT04DgEIQAACEICACwJlpRoeJ2ei5N/vh7b37ujCnac+VweujrWoU7/L035MIeRSGC5jSt/dEkCQ0JD3fVGcKlG/NmzuW7PRXKuTVLIl+AbflT0IElyRpV8IJE/gumm5gqg2Hi2cxkt+JgEAAuZUBBvAMc8Da4KBTVkLbKRqfx6A9WlDYw4RvkEgCgKtf2sQJEQxD3ACAhCAAAQgAAEPCGwq1bB891+VzlZy+v7Akv9ihOUhK2OzOg71oFVZxgoPpg4mJEAAQULDIMe4eGpUUo/Z4Iy0LQ0nhWfNECR4FhDMgUBcBEZa9Nl+np/XdSuaDEMiv+3nmXmB4gMBCLQkQIr8lgA9bm5r0WPjHLFwMvo5Pp6fPZ5MmAaBLQTaltJCkMD0ggAEIAABCEAAAlYIjET0cq1MqwNRciSiDzaXcPVXjBByNoSXkdwkErEScTqBQA0CCBJqwHp5aZyLp/pOlDoZZplJq80nYAIsqAYcPEyHQDgErh+ywXEdIdvqgf5m88tIOM6L+PviFBJFbIXAuJi8DfWUAdErI6BfD/Pc1NRs9dny3mW1DuZ9MTlXIj+1MpbGEIBA5wTaip8QJHQeMgaEAAQgAAEIQCB5AnbeFW1jHI/HB7K7exZyNoSXTLTon5scKrPNlv4ggCChxRy4LyY3odWKqeou2RKqkvL3OgQJ/sYGyyAQGYHRTPTRZ3l+U9WvyLIMjURk5bu+Fa1uFxzm04vhcLj8Zz4QgMBWAmwExT1B2m4UGjolQvDW6dqfIsBcjHsu4l28BNousvLdj3du4BkEIAABCEAAAj4S0HcPWXZY54CTay9WZWaNmP5b12N13v9s+hVrlJ1TZ8A1BBAktJgW8Z+g0XczkeM6m0wtcNLUMgEECZaB0h0EIFBCoF62gMjvodY2x5h2EEiBQOS/BymEsMzH1r+J5Znp7JyuiVlwXhYk/g6BwAm0+p0ZF8VtHNm7Ao8i5kMAAhCAAAQgkAYBJf/yIUP3IotrMT0VpU9ifRakXEMaX6lQvESQ0CJSkZ3w3EzCcm3WFshpWoMAgoQasLgUAhCwQ6DG/WJZumFqMgh8bmdwj3pZvViZ54SHweDGJ8W3R5QwBQLvCNwXxakS9StI4iWglfwpWl/NRa6aiJ3LBQmmRKn8+TgYnLT5za0yTrxRwjMIhE1gmGeN17f47ocde6yHAAQgAAEIQCAkAvpumOcHfVr8v6I43BU5FVE/9GlHF2O3zSTWhY2MkQ6Bxi9s6SDa7mkqNW+Nkmou+qTJAiJzpR8CCBL64c6oEIBA9VOqq3Rov8fF7EP/jY/DPL+Iy0e8gYBdAsmIfO1iC7g3fSciV+Z/D1l2WUVAUH2zUN+JUidNT9tUHydg/JgOgUgJzLX6/tO9wWUT9/juN6FGGwhAAAIQgAAEINCIwOghGxxUeQ9s1PuWRv88To93lD6NsizDJr8p12B7GtFfCwIIElrAM03HRXGRgpJqhWmkRZ/t5/l5S2w074AAgoQOIDMEBCCwgUB1UUJk6bE/eqkyLztFvnvVx4sW0xMCoRBYZUx5E4q92GmXgBE+G3GC1upq02Zi3fruJluCmk5P69TJRBhjN670BoHuCVR//nxpG4KE7qPFiBCAAAQgAAEIJEyg45INywNRchZrWYZNM4lyDQl/xzx1HUFCy8CsVFV/tOwmtObXD9ngmM0Vv8OGIMHv+GAdBGInoEV+288zozre+olpA2hTGjTjY9PTumX8+DsEYiHAZlAskbTix7UWffm8vEPTe8VCmDCXm0pWKX2QkNC8EhIugkBYBJqn/+UeFFaksRYCEIAABCAAgcAJdHBqf3HwoZieijKlGSIsF1thClCuoQIkLumUAIIEC7hTKdvwAtVortVJ05SIFrDTRdkm3+PkTJT8G1AQgAAE+iOgf6xSrqDuydf+/Nk2cvNFcD/9wSoIdEsgjt+BbpklMtpIRJsU7KbEQ3InWhKJMW5CwBqBmehvmpSZRJBgLQR0BAEIQAACEIAABEoJDPPM2b7keDw+kJ3BScpChKcANH02Lg0gF0CgIQFnX/yG9gTZLLGyDS9ipF8/ZNkp2RKaTd3FDXIwOKjaeqb126oLLGRIqEqV6yAAAZcEqjz8Nj356tLu2n13nG6utn00gIDnBNJ+nvY8OJgHAQhAIBACVTN0vXQHQUIgAcZMCEAAAhCAAASiIOBCkLDYZ9ndNSL2H6KA1NoJDk61RkgH1gkgSLCA9H9Fcbgr6j8Wugq0C303EzmuulEeqJOVzV7MB6Vezefq1Y7ow0XDZQrYJ+GB+W+fV+5w84XXWsnbRRraHbl6GAxungtDECRYIEwXEICABQL67iHLDsuEayGfjjYpwfez7NgCLLqAQLIEeG5JNvQ4DgEIQMAmgdEwz17V7RBBQl1iXA8BCEAAAhCAAASaE7ApSECIsD4OTYW6zaNKSwiUE0CQUM6o0hUhb6RUcrDKRVp+Ge5lZ1UuDemaJ4GBsfm5yEAreaVEloIDWQgOvuzbLy3yX5PSdi76YlerY0o29B0RxocABJY/keX3h4CzJIxkNj0cDoe3RBsCEGhOIODfgOZO0xICEIAABKwTmGv1fd3SkggSrIeBDiEAAQhAAAIQgMBGAlWyqZbhQ4hQQohMrmVTiL/3QABBgiXoLKK+A3kts+mJzxszq4wW5xtC/62lKUE3EIAABCDwnMBs+lXZvSFIcV8FsQUTAQIQKCfAs3Q5I66AAAQgAIFyAk0yVyFIKOfKFRCAAAQgAAEIQMAWAfO89jgYnJRlU1033hutX31STE85iLk1Go2yhtmKL/1AYBMBBAkW50aQGykW/X/W1Wiu1UndUwluTPm4Vxa8uyLNOBCAAASeEaiwcT8uihMR9Xs43KjHFk6ssNR3ApRs8D1C2AcBCEAgIAIVhLDPvRkXxa0PGQ8DIoypEIAABCAAAQhAoC2BkRa5ULPpedkBpqeBVusGp5bKYbe13+P2+vUwz088NhDTEiWAIMFi4Nno/hCmqVPzmA3OmijdLIblo66Ik0u69A0BCEBgE4Fqm/chLQg3SQnM/IAABNYTuC8mN0rka/hAAAIQgAAEWhOoIIR9PgaHS1oTpwMIQAACEIAABCDQlMBoJvroszy/2dTBcj9HXyAgrYaY9cpqnLiqewIIEiwzv59MLpWW7yx3G2x3WuS/c9En224oXTu3Ktnwn67HZTwIQAACqRMY5lnpc0dAp6Svh3l2lHpM8R8CNggsaz8O/rbRF31AAAIQgAAERGT0kA0Oqh6OQJDAnIEABCAAAQhAAAK9Elj77GbKM+xNpmdK5KderQtrcMo1hBWvpKwt3RhIioYFZ1cLqkbN9bmF7qLpQov+eT/Pz31xiBqRvkQCOyAAgZQIVBEkLGrBTaZvvOdSMxWw9/5gIAR6JBBeuZYeYTE0BCAAAQhUJKB/HOb5RZWLESRUocQ1EIAABCAAAQhAwCmBkYjciJaruaibnfnkRu8OLsmkWJc55RrqEuP67gggSHDA+r4oTpWoXx10HXSXWsmfj4PBSdVTCi6dDSkluEsO9A0BCECgSwJVBAnGHu+zDdVMA9wlY8aCQIgEvP/OhwgVmyEAAQgkT6BauTCDCUFC8pMFABCAAAQgAAEIQCAKApRriCKM0TqBIMFRaHmh3QRW34lSJ8Msu3KEvlK346IwNYd+qHQxF0EAAhCAQGsCRpS2n2XHVTr653F6vKP0H1Wu7eGaWimAe7CPISEQFIFgsqIERRVjIQABCEDAEKiaqZH1G+YLBCAAAQhAAAIQgEAEBCjXEEEQY3YBQYKj6K4WV28p3bABcM+nS0kN7Gji0y0EIACB9QRGMpseDodDc1+s9BkXk7d+3kOrp/+t5CgXQSBxAjyTJT4BcB8CEICAWwKVhKQIEtwGgd4hAAEIQAACEIAABNwT0CK/7efZqfuRGAECzQggSGjGrVKr8WRyJFr+qnRxmhddP2SD4z5KOHAaL80Jh9cQgEAvBEYz0f9n796P2zb2QI//ViKgQPaM5QqsFHDHTAVmKohSgZUKIldguoIoFYSuIEoFkSqwMnP/j1SBzTsnogSQ3DtLUrZE8YHHLrAAvpw5c84cAfv47PJh7G9/23sehpdZavc0k81FFAa9LP3gWgQQ2Czg6XudYUMAAQQQaIhAmgezHB3UkMGmGwgggAACCCCAQIsFJqJ/yPr8tcVcdL0CAQISHKOz62sr8FCUHFVxhAMPHbaODRcggAACRQVyBSOYSn08toEf9kWnA/cj8FTA32wojBYCCCCAQFMEtv2GG90lfVHyvin9pR8IIIAAAggggAAC7RLQIv/sh0G3Xb2mt3UTICChhBFj59d25DS7FraXku0KMlhk8+JqBBBAIKNA7mAEU49/mWz0xygMjzMacDkCCGwQ8DHwiAFDAAEEEGiewLYHtAQkNG/M6RECCCCAAAIIINBCgYuJ6BOyJLRw5GvSZQISShooghK2Q5uHBGoyPspyxvj2UjdfwVmRRQW5HwEEEFgpUCgY4b7Emzg5VSK/emCc6vxhD9pJExColQC/j2s1XDQWAQQQqLeAlg/RXtBf1QkCEuo9tLQeAQQQQAABBBBA4KvAUESfRGE4wAQB3wQISChxRHjomgp7ONXq+Nle5yzV1QUv+l8cd3dFfSpYDLcjgAACCHwTsBKM8BB0/lktJu1YT4vqKpHXZYJr0e/2w/C0zDqpC4E2CHBcQxtGmT4igAACHgko+XHVcZE3cXyiRP3mUUtpCgIIIIAAAggggAACBQT0LwQlFODjVicCBCQ4YV1fKEEJ6cDLPMKB3RDpxoSrEEAAgTQCZX1+m2N3tNZdUaqnzH+LepWmfVmv2ZbiN2t5XI8AAnMBjmtgJiCAAAIIVCCwMusVxzlWMBJUiQACCCCAAAIIIOBUYCL6B45vcEpM4RkFCEjICGbjchbA0ymWeYQDRzekGxOuQgABBFIIVHK8wWetD74bj7sylZ4o6ck8o8KLFO3dfMmanXSFy6UABFou4NGRLC0fCbqPAAIItEvAPGe4Czq9l0p9ue85AQntmgP0FgEEEEAAAQQQaIlAJc9oW2JLN3MIEJCQA83GLaM4PhZRf9goq+FllHKEg1nI2kvG52WnAW/42NE9BBBoq8CGM3rLJBmNRofTnaC7IyaTwixI4U2W+rWSv/aD4CjLPVyLAALpBEZxfOUqs0m6FnAVAggggEBbBZZ/45nfjLLb+betHvQbAQQQQAABBBBAoLECF1EYmGeivBCoXICAhAqHYH4mtjq3soOzwn6UUXUZKcBnu2uT8VnWBasy+k8dCCCAQO0EJuPvoyi68q3d8+9e6WpRJoNCb0Mg2lAm466PffDNlPYgkFVg8Rv4U9b7uB4BBBBAAAF7AvpjFIbH9+WN4kTbK5uSEEAAAQQQQAABBBDwRMCTjWOeaNCMCgUISKgQ31TNzvxMA3BxG3SOHqZWzHR3yotJIZwSissQQACBjQKPH/L6jGXS9Gqtu2p+zENvtmubH+s+Dxltq7kAv7VqPoA0HwEEEGiMgP54GwQn5hnDKE7MEQ7Fj/tqjA0dQQABBBBAAAEEEGiKwET0D8/D8LIp/aEf9RQgIMGTcePBbOqBGIqSoygITGYJZ6/5GZJ6QCphZ8QUjAACbRBQ8qPrz2sXjCZY0HXwm4t2UyYCdRHguIa6jBTtRAABBFogsMjqNYoT84wh0/FeLdChiwgggAACCCCAAAINENAi/9wFnR7POxswmDXuAgEJHg3ef3fjox1lFsGJyt86LBt2rhrHZ3sdc/RC4dcojk0Kxz6BCYUpKQABBFooYH7s7oeByTrAC4FWCczPot7tTfXOF1u/SZoCyHENTRlJ+oEAAgg0QmAYhcGB6ckojs2GhLeN6BWdQAABBBBAAAEEEEBgSaCMY9FBR2CTAAEJns0Psyvzu2RsFtOJzN8+Nk+OcJgHEKg/ojCwOrdNuVrUyYazxre3lisQQACBFgpo0e/2w/C0hV2nyy0SmP9+S47mR34sjv2Y938ok3E3iqKrFnFs7CpZwZgJCCCAAAIeCVxEYWC+u2V0l/RFyXuP2kZTEEAAAQQQQAABBBCwK1DTbLZ2ESitKgGri7ZVdaKJ9d7E8YkS1SdbwrbR1dcTkSNz/s19MIK5w3ZAwn0rzI5Hvbt7pESZRYcygkaGInIpWs5FyQnzYdt84O8IIOChwPA26BySEszDkaFJhQUWRzyZYMi1Oyq1kr/2g8D8buA134F6ReYppgICCCCAgA8CD3eJLTJW/ulDu2gDAggggAACCCCAAAJuBPT1bRB0eU7rRpdSNwsQkODxDDEpbXdEDdiVn2aQ9MeHiwGuAhKWW2IWIrTWXRF1qES6Ivowz0N2k9ZciXwR0Vei1ZXsyLmMx1cPd1QuUhybcy1fpBHhGgQQQMAXARZkfRkJ2mFLYB6IYI50ShecaBY8RIn5rXAaBYH5Lm/li+MaWjnsdBoBBBDwVuBhJi++o7wdJhqGAAIIIIAAAgggYFGAoxssYlJUJgECEjJxVXMxqQOzu5cVkLCpZbMHGkrNzqNc9brtdC6zRqIRlJB9LnAHAgj4ITDV6udnex1zJBEvBGorYI5m2BuPB0rLTwU68eTIqQJl1epWftPWarhoLAIIINB8gaWUtaM40c3vND1EAAEEEEAAAQQQaL0ARze0fgpUAUBAQhXqOeokW0I2NB8CErK1ON3VizOqTzelhk5XElchgAACpQtwdEPp5FRoU2AeFChneTIhrWjHMAqDtUGLNtvtU1k3cXJJ5i+fRoS2IIAAAi0XmIy/f5iVkO+pls8Huo8AAggggAACCLRGgKMbWjPUHnWUgASPBiNNU27i5FSJ/Jrm2jZf07SAhFkgQjw+ESUnHNnQ5plN3xGovcBFFAa92veCDrROwHaGInNU034YdNsEORqNDmW382+b+kxfEUAAAQT8Flh+bjCK4wHB/36PGa1DAAEEEEAAAQQQsCPA0Q12HCklvQABCemtvLlyfm6xNv9QfuVNozxrSFMCEuYP73f7IuqIQATPJhnNQQCBXAIPz+rNVQA3IVCywCI70aXl312tC865ieMTJeq3koeP6hBAAAEEEFgn8OS7eBTHxyLqD8gQQAABBBBAAAEEEGiFAEc3tGKYfekkAQm+jETGdpC6fzNY3QMSHgQivM04NbgcAQQQ8F+AH7v+jxEt/CpwkyRnSstPlklaGJDAcQ2W5xDFIYAAAggUE3jyXbzIiPSpWLHcjQACCCCAAAIIIIBAbQRaeaRobUanYQ0lIKHmA/rf3fhoR5lsCfKi5l2x2vy6BiTMs19IX0TeWAWhMAQQQMAvgaFMxt2HZ/b61Txag8BcYPE760/7HvpjFIbH9sv1s0SOa/BzXGgVAggg0GoBLR+ivcD82/vRaxQnX3i+0uqZQecRQAABBBBAAIEWCbTr+VSLBtbLrhKQ4OWwZGuUecirdztnSuR1tjube3XdAhIIRGjuXKRnCCCwWkCL/HMXdHovlTIPfXkh4KXAKI6vLB/VMO/nmkUQLxEsNIrjGiwgUgQCCCCAgGUBfS0i57P/TCbn94GyjjIjWW47xSGAAAIIIIAAAgggUFhgeBt0Dnk2W9iRAlIKEJCQEqoOl93EyakS+bUObXXdxroEJMzPqDQZEdQr1yaUjwACCPgmQFCCbyNCex4KOD1HunUBCRzXwLsLAQQQQMB3gXmAglbqwMFRTb53nvYhgAACCCCAAAIItExAi363H4anLes23a1QgICECvFdVM0RDnNV3wMSCERwMfspEwEE6ihAUEIdR60dbXaWHWGWIKE9/+jjuIZ2vF/oJQIIIIAAAggggAACCCCAAAII1EPAPI/dD4NuPVpLK5siQEBCU0byQT/+F8fdHVGDNh/hUGZAwuy4hfvXeHy17kz0z1offBePT0TJCWdSNvCNR5cQQCC3AEEJuem40ZGA0+wIps1KfoyCwKSJbvzLuWXjBekgAggggAACCCCAAAIIIIAAAgggYFGgRc+lLKpRVEEBAhIKAvp6u1n83huPB21NNVhmQMK2OUAgwjYh/o4AAgjMBIai5Kgti7SMud8CLrMjzHreon/4cRa333Od1iGAAAIIIIAAAggggAACCCCAQHsEtJK/9oPgqD09pqe+CBCQ4MtIOGrHTZycKpFfHRXvbbE+BCTMUxTv9kXUW2+haBgCCCDgm4CWD7dh5/SlUl98axrtaYfATRyfKFG/ueztRPQPz8Pw0mUdPpQ9C8pMxp99aAttQAABBBBAAAEEEEAAAQQQQAABBFouMJTJuLsuy/cmG5OZfVdM9m91FIXBQcsd6X4OAQIScqClucW8OZXeOdRqelX1A+c2psqtMiCBQIQ07xCuQQABBDYJ6GsR6UdhOMAJgTIFFgvoV66PVqryd0qZnm38DVqmL3UhgAACCCCAAAIIIIAAAggggAACqQW0fIj2gn7q60VkdmS5FnPPm/v7plr9/Gyvc5alHK5FgIAEB3NgHimkzLnALx4Uf6FFLpXoS5lMzvNEIBVp6uKB8KnrB+xF2mjz3ioe9K/6YLbZJ8pCAAEE2iegr7Wos6noQdXBfe2zb2ePy8osVcXvlCpGlOMaqlCnTgQQQAABBBBAAAEEEEAAAQQQQGBZQF9HYXiY1mWxzmnWFL8GIny7V3+MwvA4bVlch4ARICDBwTxI9/B1tvvTBC2clxWgsCZQwoFA9UWW/aC/TbbVjy4tQACBdgrMvzdnwX1KXcp4fFV2cF873dvT60Vg4d9l9Ljs3yll9Gm5Do5rqEKdOhFAAAEEEEAAAQQQQAABBBBAAIEVAkp+jILArElufJnnOXvJuL/lKPjhbdA55MjdbZr8/aEAAQkO5sM8ZX/HnAv8MEPClprmu0C1VucuU520ZeG8igf9Ztz1budMibx2MK0oEgEEEEBgtcBQRMx3rsyCFbR80Up/MUELE62/kFmBaZNGYL54nlyKqFdpri94zUUUBr2CZXh/+39346Mdpf/0vqE0EAEEEEAAAQQQQAABBBBAAAEEEGi0QLqMBvPNOnqQ5vmYFvl9PwxOGs1G56wKEJBglfNbYQUfwg5F9NlU75y5CE5oQ1BCFQEJ96NfVrpnR1OXYhFAAIEGCuhrrdSlmsql7Mj5badzSQRvA4e5QJdGcWz+sfW2QBFZbm1FQELJpln8uRYBBBBAAAEEEEAAAQQQQAABBBBoi0CqbAZ51rUmon9gM1hbplHxftYqIGG+A333SOudKxcL9cU5H5dg6UHsUIsM1GR8ajM1ddODEqoMSDCzYBGQMsiWJcP2DKQ8BBBAAIF1AlrkH3MExFT0gB/O7Z4no7ukL0rel6jQkoCE5Au/g0qcVVSFAAIIIIAAAggggAACCCCAAAIIPBHQv0RhaNaqVr4WR26eicibrHjm+epd0Omx8SurXDuvr0VAgkkTokVOlJafvg2T/ngbBCc+T/TFWSvnFlP4X4jowaYPjyzTuMlBCVUHJJhx4AiHLLORaxFAAIFKBWaZiSYipwQnVDoOpVc+iuNjEfVHmRW3IaVdwUxhZQ4HdSGAAAIIIIAAAggggAACCCCAAAJNFdi4KcasEe6IGhRbw0x3HERTgelXegGvAxIWC+an6yJzTPSNmoyPbGYOSE+X7spFHz6luzrtVfpatBrchp3TogEZ8zNh5O+0NdflOlsBCTOfqfREiTnruatFrrJGfI3iRNfFjXYigAACCOhrLXJ6FwSDot+xWPorsAga7SuRX0tvpZYP0V7QL73eEiu0lCWsxBZTFQIIIIAAAggggAACCCCAAAIIINAogaFMxt1166d2NywTlNComeOoM94GJGRInzucanXs8xEON3F8okT95mAMh6LltGhgQhW7Ax1YPCoyTUDCrN9KXT26UetD0epQ70hX6VkQwounbc324UpAguvRpnwEEEDAlYD+KJNJ3+fAR1c9b3K5lR+r1I6AhCsR9arJ84i+IYAAAggggAACCCCAAAIIIIAAAr4KaNHv9sPQbPh+8rIbjHBffLZ1M1/daJc7Ae8CEvKeV+J7+tubJDl7fOSE1UEtHJiQIQDEasNdFZYyIGEgot7macOmD/Pl8ghIyCPs4T2LBaR5VhF9qEV1RaRXLJ2R/X6az0IRbRaCjn1rm/3eUiICZQkQmFCWtMt6ZlkRxuOBw99jqZo/1epnnwNpU3Viw0VusoMVbRX3I4AAAggggAACCCCAAAIIIIAAAq0RWHtUg5tghHtXghJaM8NydNSrgIRF+tzzvItoPh/hMA+0SC4d7xYrFJjQpPS6qQIS7pK+KHmf432zuEX/EoXhYNP9o9HoUHY7/+avgzu9EVizo3Xx3j7SSh1tX+TS1yLqSiv5sv3anD1/0E7O8M5pyG0IrBUgMKGuk2ORrcock7Ai81HJvVLyYxQE5yXXWlp1N3FyWslRGKX1kIoQQAABBBBAAAEEEEAAAQQQQAABbwXWHtXgNhjhq8fFbdA54ihcb+dHZQ3zKiDB0gNMb49wmO+slr9LGO1cgQlFA0JK6FfqKsoJSBAxu9Hvgk5/3Ydrk4I8UuM39MI0WVhMAIre3T0SpXpK6y+iTfCB/qKUurztdC7v54nTz4LEAb+xAAAgAElEQVSlwAlLn6sNHVW6hUBOAS0fih6XlLNmbssosAgMNMGDbzLe6u7y5gckXOYNLnaHTskIIIAAAggggAACCCCAAAIIIIBA8wXWZeYsKRhhBmw2j09FHz8Pw8vmi9PDtALeBCTYXqBLs3iYFsnmdSUfjZA5MGHx4N58SFS/g7AAfJqABJvHaGglf4nW51OR8/sPWbIjFBhAP29dm+Yoa3OdZi5YkcnB5lzP2leuR6CxAg1fVG7CuC1+c51495tmMv4+iqKrJhgv94HfPk0cVfqEAAIIIIAAAggggAACCCCAAAL1EFh9ZEJJGdyXiYZadH8/DE/rYUcrXQt4E5DgYsHMROHcBZ2eb6lBRnFi0vSWuVNvKKJPth0vcD/ZnC6Wup7Ri/K3BSTMP4DHZjHAVeDFhYg+dHxER0maVLMQsBaQsEgd/psT2RUBCRX94HDSPQpFwBsBAhK8GYrlhpiI7x1RA1936W/7jeItbIqGOf1+S1E/lyCAAAIIIIAAAggggAACCCCAAAJtFFi3Hlp1ZnSzmfeu0zn2bZ22jXOk6j57EZCwWBz+7AhjKEqOfDqrt4TF8DWU5vx66acJTKh7mvdtD/tLzlThaGpTbMkC1gISTLudHeexIiBhVl95R8aUPCxUh0BFAgQkVAS/vtrZ76t4fCJK3nvXuAcN2vYbxee2b2ubiwDjbXXydwQQQAABBBBAAAEEEEAAAQQQQKDlAkOZjLurMnJWsEF61VAMp1odP9vrnLV8nFrdfS8CEkpZKFuzSFfV6JfS57WdSxeYcBMntT0DeNPD/lEcH4uoP6oae+qtp4CJMNwPg67N1o/iRNssz5RlIg73g+BoVbksFNnWprxWCxCQ4NXwz39X6YH/mYn0dRSGh17hWWqM4wBjS62kGAQQQAABBBBAAAEEEEAAAQQQQKBhAmueUzrbFJmTz6xdqPH4pKlHmeZkac1tfgQk3CX9knazXdwGnSNfUoNUv0t/c2CCSXm8K8ocL+HqWANnb7R1AQkEIzgjb0PBwygMDmx11OHRKGszOXC2t63RoxwERISABC+mweJImlMR9daLBm1vhNVsO9urK+8Kh99r5XWCmhBAAAEEEEAAAQQQQAABBBBAAIFaCehfVmVF9zgL+lCL7u+H4WmtmO+zUJtGj8dXBFVkHz0vAhJKfmN4dYSDH+lS1gcm1PUs4FUBCdUHgGR/g3KHPwKbMg/kaaXD6MSNi10O683DwD0I1FBAX0/1zgkpxqofusUC+KBmgZONDUjg+6X69wQtQAABBBBAAAEEEEAAAQQQQACBNgnoj1EYHi/3uA4bc01GaqXkJAoCsyna+9fq515mbVVdiegr0epKlL4Spa4IWFg9nF4EJFSyKO/JEQ6L9LZXfjxMXx2YUMn4FPz4WQ5IqMMHcMEuc3taAS0fHl16/yVh/s+p9ERpc6THqyfFWdwN7fh9v3Gxa5H55FNaLq5DAIFvAiYw6a7TOfYl01Jbx8Zke9GdzqnS8lPdDGwHt/nU/1GcfPHj96xPKrQFAQQQQAABBBBAAAEEEEAAAQQQcCFQ32CEhxpa5Pe7oNP39XnrYi3nTETeZB/FzVnqs5dX7zvaG5AwHzcvjnCYn3ssf/szlR6/Seq4gLkckOB4AdifoaMlWwXWHedxf+PK9N+WA5gcB8hs3X17EyeXSuT1ViwuQACBe4HhVKtjsiJUPyEWmZv6tV34tvx9Uv2IzFtQx9+KvtjRDgQQQAABBBBAAAEEEEAAAQQQQCCbwOpghBo/nxmK6JNVR09kc7F79WLt1gQj5D/WvqHPAvNItz0gQUT09UTk6HkYXuYBtHWPn0cj6GvRanAbdk6/S8Y5I4BsCWUrZ1VAwl4yPmcRNptj5VevyUpQJGvHtoAE02cTlPBtvqz+ci9ic5MkZw539m4NSHAcEFGEhnsR8E7ApA+bij6u+neCdzAlN8hkRZDdjjmeIUc0csmN3VRdQ/8RwrFYHs0xmoIAAggggAACCCCAAAIIIIAAAo0VMBkF9sPgZLmDi2AEc/xB/sXz6tUuJqJPfHgOa+1ZV0OfBeaZKgQkLNS06Hf7YXiaB9HWPY4XKYs0c7i4uTYfZLPzZ9gBXmTMvbh33fsy75eBmRf7YdBN07lZSvDdzsmqL/c096+7ZpGt43O6Mu7PIHp09ZbFOH0dheHhpvKztSFdS7kKgSYKcESDH6P63934aEfpP/1oTcFWNPQfIWTeKTgvuB0BBBBAAAEEEEAAAQQQQAABBBDYLLA2i0BDghG+9V7LB7NRuopjHIod0bBiABv6LDDPm5WAhAdqVS88PN6VnWc4uQeBhgms+bDOG5BgjmmJwqBXpVKW7ASrzhofxYne1v40WSBYPNqmyN8RsJ8dBdN8Ah4HbGbv0JrMP9kL8ucOgtz8GQtaggACCCCAAAIIIIAAAggggAACzRPYlMG1ccEIX4dPX4tSx1EQmKwPpbzmlnImol5Zq5CAhK+UBCQ8mVXVHuHQ3A8Pa29fCmqXwMoAgtxHnHjw4Z8tEOBptgN7AQnxiRL1W7umE71FIJ3AutRn6e4WGcXxQIvqiuiBmkzOoii6Snsv1z0WaNxid80CEuZn5WmTdccE8/VWZeBpVAYL3oAIIIAAAggggAACCCCAAAIIIICAPwJDLbq/Lrt7G9YTzXPau6DT35YtYRFMcBKF4XGe4VtsJDVZ9O1mivdgTSqPh4t7CEhYo1rlEQ5ZdlC7mBSUiYBHAisDEuYLJPJ31nZOtfr52V7nLOt9tq5fnIH+b5bylrMd2ApIWPxY+ZSlLVyLQBsEigQjrEvpZaKYCU7IN3sa95vIs4CExT/WuqLVod6RrtJysBiplccDrcrAYwJwRNTbfCPMXQgggAACCCCAAAIIIIAAAggggAACDwVM5mSl9VkUhoN1Mm0IRvjW983ZEh5ZTMbfZ90c5vT5IwEJX4eRgISNn3P6420QnGyLvHHxUXkTJ6dK5FcXZVMmAjUSWBmQkHfH7G3QeVnF+/neO1dmh6XFK1sBCaZNozj5Yj3ir0aTi6Yi8FQg/zENaY9dIjgh27xr1HENIpLmSJ1sQvmunv9DS/pZU9CtCUi4ylpOvlZzFwIIIIAAAggggAACCCCAAAIIINB4gWEUBvcbRlZ2tl3BCN8IVm0ke2KRMQDAaTCCaXrG9jR5dhOQsGV0N53N4npijOLEnI2ycoea67opHwFPBFYGJJi2jeI40wKIiSrcD4KjvP0yO0CLBihlO65h3tLlrA6WAxL4jMk7IbiviQJrP2+2dTZtMMLTcvIHQGxrU1P+nuYzr059rTogIf9cnSs/ydozGh3KbidT5p86jRdtRQABBBBAAAEEEEAAAQQQQAABBMoW2JTpua3BCPdjYNZs1WR8ZLIgrLHYGtBxX1beTNyZ5gMBCV+5CEhIN3OGItqcPbI2PUq6YrJdNd8Fnlyy6yybG1c3SmDtAmH2LCL6l7zv4dFd0hcl70VkKJNxN2vKHzMieY5rmI3k0hdWmsW5tJkgHvSrUZOmQGeGouVUKzkgQ00BxVreqq9vg6CbJ4NKwQXe3EEQtWTO2Oj/7sZHO0r/mfE2ry+vMiCh4FyduT49RshkWlB/eI1O4xBAAAEEEEAAAQQQQAABBBBAAIFaCazexNT2YIQHQzhbsxVRp6syQGvR7/bD0Pxt7WuxXnPpPIM0AQlfx4CAhEwfQuUf4cAHTKYB4uLmCaxdrFu8Nz6l67K+jsLwMN21j69a/mIyEXh3QaeXdeEy13ENpik5AhIk5RnlTVzsyzDGQy0y0Fqd7+xoc3SF3HY65geIfJeMr5z/EMnQUC4tQSDle2ZVSwpmMyIgYdM/DOJ4IKLeljADSqnCfH/sh0G3lMqWKlmkn1v5j7Qs7VkRkNCoMcpiwbUIIIAAAggggAACCCCAAAIIIICAI4Enu/ydHy3gqCMVFTuciO49D8PZ834Hz3RTdkt/lMmkn2eDa8oKanUZAQkZh6uKIxz4oMk4SFzeJIGNi3Xpj23Inx1h1fnlq84q2oae/xz0x9GQaTIkpA1IyJ21YVtn/f77LHryNgjOVgWVkDXC78Fz0bo87+f7dpijXAoumBOQsGFQR3FigoVeuBj3isqsbLxtWa4ISMh0fFJF7lSLAAIIIIAAAggggAACCCCAAAII1Erg4bENuTc71qrH1hs7y4Z8G3ZOl9cB3B/VQCDCqtH0JCAh21nw1qdl9gJLP8Ihe3r67J3iDgQ8FNgWkJBmMTD3AtDGL6bJ+Pu0kW3z41fGn3P6Pmq/zYAE055U5eVsuI+3bVp8XowT2RF8HDh3bRreBp3DrBlPTHMs/UMg9+eTOxI/Sm5oBpfKxtvWZ/3DgISWBrX58QahFQgggAACCCCAAAIIIIAAAggg0HCB+UZFCxuiGu6UqnsXouVcduQ8CoLz9BtdU5X9+KICmXhz1FarWzwJSEh0rdS+Nnb1OS6u+pJ/h7WrFlFuwwRMCvsrJfLam35tOV8nRfaQoUzG3bSBA8v93vzFlP79X3BhzWlAwk2cXHo15s4n3/psGZYWmJ33gAosCuQ8w8tiFG1lC9QWFZ0U1cxAzPTfG7ZRCx4t8rU5DwMSCn632e4i5SGAAAIIIIAAAggggAACCCCAAAJNEhiKkiPR8neTOtXkvhTJxNtkl/u+EZBQcJTNEQ5qMj7Ku+CZpXqze3cvGZ+3a/EwixDX5hUwH5R3Qae/l4z7SuTXvOXYv2/zUQv/i+PurqhP6+p9mNYoa9tSpe5PmSWh4MKa04AEW4tUWX0ru37DmDmNjKysw1S8QSBXdoTFrnBz/piNowQISFgzQI18P+YMgLHxLrbl+ShDwl3SFyXvbbSPMhBAAAEEEEAAAQQQQAABBBBAAAEEHguYdRu/1msYoU0CE9E/PA9D89yY1wqBygMSLO4yrHKAh1Otjp/tdc5cN8LyQojr5lJ+LQS+Lfr7tjid5gN8fRrqzcEMm4Ym7ftMi363H4an24a5YBYCtwEJrVpQ0tdRGB6uGi92+m6bxc37e56IVQeBgQQkrJha24LNajsbKwpIsHm0wqOAhDg5F5E3tR0PGo4AAggggAACCCCAAAIIIIAAAgh4LaCvRdQrr5tI4xYC69ceIJoLVB+QEMfHIuqPJgxInsWNPP1ePKg3D4Ft7M7M0wTuaYrA0nk2fgUkpPsAX73Ynz8YwQxt+uNR0rWx4Nnd2QMSMix6pcoE0ZD5vukzOv2YNwSDboikzHDykMrBPCEgYcVcLJhVxuPZXey7KW/HbJ41uBSQ8IXfonlHhfsQQAABBBBAAAEEEEAAAQQQQAABBJoiUNb6cJ29qg9IaNju3LKOcBg1KJCjzm+gerf96cKIzUWLojZpP8CXgiiGE9G9ImlxMmdt2bKombm8p3BuAxJa9Fmy7ggPm7uHi8577i9HwHxX74dBN0ttLj4f037OZWlnE661dbyAdxZLQYBltM/Cd9CjZi4FJOgy+kAdCCCAAAIIIIAAAggggAACCCCAAAII+CxQ5Phwn/tls23VByQ0M91rKUc4EJRg863QsrLW7KD3ard8yt3L9ztptZK/7jqd45dKmR2buV9ZF8K2HdtQ9CiA5QXLVNkWsmRISJKeaPk7N1h9bhxGYXCwqrk3cXyiRP1Wn67Q0sICGd4jpi4XwQizPmRsR+F+16CARgcI5QxImH0378h5FAQmO1am1zyrlpzZSu93H5BgO9AhU6e4GAEEEEAAAQQQQAABBBBAAAEEEEAAAf8EhiJyqZV8UVPz3/qLUupyovWXIpto/etmvhb5EJDQ2N1VZex8dLZIkm8+cVcNBDbtDPZlYTbLe8cE5kz1zpdne52zovw5AzI2plzPWea3riwtWBKQkHeU9ccoDI9X3Z01CCVvC7jPI4EMC8NOv2cJSHgyKXz5HnIxWyeif8j6j4+vC/8pg/TWtXvuKidFAxMISHAxMygTAQQQQAABBBBAAAEEEEAAAQQQQKAFAo8CFqK9oN+CPn/tYqUBCS3ZXXVxG3SOiu7a3jQpnS6WtOnd0JK+bloQ8eE9aQIm7oJOz+V7ZuWi9Gh0KLudyzznYT9MYb1cdtGAhOUMDLYDEua7Z9Unv6a//ihKDbSWUyXy2krb1ixA+9l/Kz2mkA0Cm96z97d91vrguyQ5FVFvXWGSyuup7E2cXFp737sauJzlppl3D4uez8HxlfleynrvtiaasveS8XlWawIStsnydwQQQAABBBBAAAEEEEAAAQQQQAABBLYL2H7et73Gaq+oNCDhPtV6tQSl1D4UJUd5Uu2mbV2TH+CnNeC6NALrd4nf3z2KE3PkwYs0pdm+pqpgBNOPmyQ5U1p+ytWnDbutCwcMLZVtOyDB9DdVmblgst6kP8pk0o+i6Mpu2nZ9HYXh4arWFB6frF3k+soFNmWJuW+cCVTZETXIulibuXMZMjVkLruGN9h93/sHkPUfGQ+/l7Lem6b3eYIQ79vR5EwWaey4BgEEEEAAAQQQQAABBBBAAAEEEEAAgSICLp73FWmP63srDUhoXZpsLR/MGcC3nc6l7d3feXe6uZ5glO+ZQIqUz9Ut0Orr2yDo2n5vpBmBPIsyD8tdzmLw8G+jODFnfr9J045V1yxntEgTPKCV/LUfBEdp60xTZtqy8lxnFoiVkpOHQVs2F7u2jE9lATh5rLjHioDbY1ayNDHFZ3KW4up+rc33vY8Wq/6RYYJfVh3j8N/d+GhH6T/v++HqHyhZv6NMO8xRSSLqDx+NaRMCCCCAAAIIIIAAAggggAACCCCAAAJ1EHD1vM/XvlcWkFB0AdBX0BztujD3aCVf1FRMungRpa9EKZOiV7IELxCUkEO/Vbdsz45gOCraoTqciO5lPVvb1vAVD45ab1s0E8zyl1LK4IGNC67LbinLtMW9VM5qu6JuDyoZ3gadw1WBLssLfo46SLG+CWj5sOp8rvnvEj0QUa/KanLbfnRucy2UqWZb4dX/feXn8oOsRBei5dwErk6n6mBHmbn4LVuRq7ky++04Hg/SZwjSvxCMUP1kogUIIIAAAggggAACCCCAAAIIIIAAAvUWcPW8z1eVygISGv7Q2dV4z4IXzAPrVYsp5k8Pzxt21QjKralAhtTgFheD02FlaFu6AtNfNbpL+qLkffo7nl65KQV8kfJXlZsyeKAmAQn6lygMzaLbo5fZMbwrymSWKHx0yKbsCHwPFZn1Nb53KSBhESDZL5LJJI9GmqMj8pRb13sWv18+17X9Kdr95HM5S3Cu63+gkPUgxQhyCQIIIIAAAggggAACCCCAAAIIIIAAApYElrNjWyrW22IqCUjgoWfh+bB2x68p2eZiXuGWUoAnAvo6CsPDLI25iZNL5+enzxq0elE6S1vzXrvIBmEykxRe+F63WFQkBfmqoxeaE5BQRjCC/LMfBt1V86MFi5953xbNv28RkLD4LXJcdiDCPXDWo1WaPjAt+G34JCAhy/eD64AEM7+ytKfp85H+IYAAAggggAACCCCAAAIIIIAAAggg4FSgwo26Tvu1pvDSAxJYLLc1zJsXcXG25dyMcrTI7/thcJKlN2UcAZKnXVn6sO1amzvk10WzZdkB+6S9K1LLNyMgYf3nV9bzzDeM8cZjQFqw+Llt+vP3qgXWHB1RdbOqqt/m53FVfdhY76rP8wwZesoISDDtt/gZ7OUw0CgEEEAAAQQQQAABBBBAAAEEEEAAAQS8ECAgwd0wsEhuzzZNqme87XnXvaSpVj8/2+uc5elHkSMHNtenP0ZhaHYnV/IqFCiwosWbjFMGETwtdcUXUsqyvD2yYdMRCgYgZf9SzJnNQVvlZQBJ0VQuaadAy35wbhtke+/9bTVV9PfaBCTExyLqj4qUqBYBBBBAAAEEEEAAAQQQQAABBBBAAIF2CFh6PjzLBL7T2bzWNh0Poii6qhK2tAwJLI7bH+Y054vgbt+9jiXeBp2XL5X6krft86MNdvsi6m3eMh7eZwJq7oJOr0ibirZjFMdXIupV0XK+3r9ht3Penb+rxi3dol22IzrSlblKSn/Uorrpj/bYHIRiL0gkVQaZT9bGnoIQyCFQ9HM5R5Xe3vLf3fhoR+k/vW2gjYbVJSBh9n3f+ddGlykDAQQQQAABBBBAAAEEEEAAAQQQQAABBNYIWMigu8gEfbrtWPI068mux6mUgITFIpPZnV34nHbXIPUqP90Oc4IS6jWq9lubbXF6U/3zYxwSs3vyOP0i9HKJ+vo2CLqVBiNkSJOddjw2nQef73iA1eOWNnggS3rvtGU+sVh8YY7ieLAtWCVNVpebODlVIr+mNV9x3XCq1fG2bCBp2lugDdyKwFaBNO+HrYU06II2vCeXs+iY79PvkuQybWBcls/0olMj93dC0Yq5HwEEEEAAAQQQQAABBBBAAAEEEEAAgbYIFAhIWDxbPN22LnNPWeazxXXD5zwgId9CXFtmW+F+Dm+DzmGahV2zw13vds7yLyIXbisFVCeQKX1/2maaD7wwnvSU0j0R6aWcW8OJ6N7zMLxMW4/t6+bZHjqmftsBUmud518OY5MOJ3Wd6wIc0i4UZfmCSVvmk7F4kFJoSxaIrZ9VeYwet0d/lMmkvy3tUPF6bM9IymujgBb5fT8MTtrY91V9HsWJyeCT+vOxlm4PPi9NoK7WYgKwXqfuy2T8/bbPt9Rlbbhw8R1JhgQbmJSBAAIIIIAAAggggAACCCCAAAIIIIDAeoFca3fzjcPj87TPFn3ZHOc0IMHCblcm6laBzanJH96edZJurZoLaiKQLpOGjc7MF1m0SeHfXZnK39KZOEXamvf4hDR1bgoCGGXNyrAmOs5kPNmZZajQR0931uprLepsKnqQJegjb0DCwzQ/GxaxNgahfJszqp9jQXIoos/SBCLcj1/mcUgz8FyDQEaB5d3yGW9v1OWtOK7BjJiSH6dTdbCjtAlEeZN5EEv6/rR3dE7mHnIDAggggAACCCCAAAIIIIAAAggggAACLRLInt08X0b88tYINw2ek4CExQ5Uc0RD9geuLZpqNrqaNbJlEZTQV1rMbsT5S4nZ4d7NsRhoowuU4VqgQNqXok2bfRaMx12ZSk+UvorCcFC0zCL3LxbNByL6MG2a7Cz1bToTPmt6brN4FQXB+ab674MTzDVZgxDuyy2y+LQcgLEq2GN54fUmjk+UqKMCnzmzIISp3jnbdjTDKrtRHF+5GPss84RrEdj0WdE2nTYc17AY02Gh31kpvhNszB2CiW0oUgYCCCCAAAIIIIAAAggggAACCCCAAALbBbI8J8696bzCNcKHAtYDEubRGXLGgs/2iWbrioe7lIuUOV/cNMEJZvd1hjTCRSrlXvcCnnzYuO9othrmx5jsmiwD9ub7lgWjLIv/WY5cyNbzx1dnadPjO59G7z09oudpBpecRybMMyEoNdgWpLHJgiOEiswU7rUlsO44Flvl160cgoRSjlhJ3+U3cXLJb8CUY8JlCCCAAAIIIIAAAggggAACCCCAAAIIFBDIkkk398aukjY6bWOwGpCw2Pn627ZK+bttAfvpNuaRNsmx1cVa292mvHQCJS1ipGuMn1fNF+W1me9vi7QwzZdHmt2nWTOfFGlz/oAEeXK+0YNjG4ai5Ghd8ECGOi9E9MBWZg0WPovMFO61J5D+qCV7dfpZ0iLF2Cc/W+dbq+z/1lvu4Yajd3zDoD0IIIAAAggggAACCCCAAAIIIIAAAgg0QCDdM78iz+1sbWovim0lIGG2eD0eD5SWn4o2iPtzCQxvg87hS6W+HcOQq5jVN9larLXYJIrKJvBk4Tjb7e25erE4dpr7uJmUwR+jODFHMWw40ibdl5CNkcl7frsW+X0/DMxZ6I9eJuAizfERo7ukL0rer+6DvhaljotkQ3jartlRERkC5vS1iLpaKodjiGxMunaXMYzC4KDdBN96v/lzAKWHAmUEqhFYzJxDAAEEEEAAAQQQQAABBBBAAAEEEECgZIHJ+PsoipbXIh41Ind2BBHJciyEy54XDkhYLFYPOKLB5TClKdv9jsvCi7VpusE11gXKWMSw3uiKC1wsyvSzn/edLpBg21k/WvS7/TA0gRHOX7kXBFMGX2zqwMrADAvlLteZ65iIFe3gyAfn07EFFaT7jGgBxKyLHA+QbaRd/+OBLDLZxoOrEUAAAQQQQAABBBBAAAEEEEAAAQQQKCqwbvPnw3JHcWI2pL/IU1eZ602b2lcoICH3QlYeMe7ZKOB60dks6IXxpKeU7imRXxmOeglEYVDovV6v3tpp7SIAx2QyyPIhnzobxcaghBLP9Mn9Oa7kx9tO5/K7eHwi0/FgWwTfqlFZChTYeMxDkVFNc0zGk/LXBEYUiUQs0gfubYhAimjXhvR0azcW7//PWy/kggcC7oJPOT6DiYYAAggggAACCCCAAAIIIIAAAggggEA1ApuOVcib5fpxT/RH0fOM0FrJgRLpTkSfPA/Dy7J6nGuR0pxVoXc7Z0rkdVkNpZ7tArbPAVmMs0nJboIQGOvtQ+DtFVOtfn621znztoGeNix7UIK+jsLwMG131gUllBlAcpMkZ3mO29FK/lJaeiL6JArDQdo+L19nsuxoLeaYh2MXX37zLD7yd+b2rQlImC+iJpdkBcos2vobzHtmPwiOWg+xACDjSPaZ4HIO5Qrcyt4F7kAAAQQQQAABBBBAAAEEEEAAAQQQQACBJwL6+jYIui+VMpkQHr2cbZJ0kK1608BmDkjIn8qc+eVewE4qaBOIILsds8DIeenuB62kGuzMjZIa61U1WXeNZg0mWD5OwHW2k6dfZonJApHzve73vCoUPLDhyzh3kINXM5vGlC5QYuaT0vuWo0JnP6RztKVOt7g6tqFI2rc6+dFWBBBAAAEEEEAAAQQQQAABBBBAAAEEfBQwa0N3Qae3HJTg6rld2WtRqQMSZjt5x+NBnp20Pg5sQ9s0NLuVb4PgbFUUTZo+Z98RnqZUrvUXXtIAACAASURBVPFAYHgbdA7zzgsP2l9pE7Ica5AnU8nj8std5M/7ZeZyp66twS604LklOrBQ2bY6SDm1EajD+6VszLyfPWW307v6HEQu20n75p0UDUIAAQQQQAABBBBAAAEEEEAAAQQQQKBWAiZIQE3GR/dHZGfdMJu1s642P61qR6qAhMWDSrNjPstZ6ln7zfX2BExgwpkoNYiCwOx+TvUqtJs4VQ1cVKmAg0WMSvtTYuXLWQw2VZ3neIyH5WvR7/bD8LSs7o3iRGeta12kXtZyXF5fOB38lvdLljnhsp+UXROByfj7+x+RNWmx02a6/iHttPHVF249wJDjGqofVFqAAAIIIIAAAggggAACCCCAAAIIIIDAQmA41erYHMOeZbNsPj39S5EjubPUuTEgYbFAfSqi3mYplGt9EtDXotVApuPBtsWQUVwkdbtPfaYtawSGMhl3t80D9FYLpF6wyRn4MVugU+rgttO5LCuTRc5FQeuLYbbnXM5+LTVj+xex+x8DtmUorxKBnJ8JlbS1pEp57xSEtjynRnF8JaJeFWwVtyOAAAIIIIAAAggggAACCCCAAAIIIIBArQT0dRSGh2U0eW1AwvyMbD3gAWUZw1BaHRcierDqSAfSj5c2BlVXdBGFQa/qRtS1/ps4PlGiftvS/toY50jTPZyI7j0Pw0tfx9DasTNKftyWYWaRJeGzrxa0ywcBfX0bBN2ygox86HGaNtzEyaUSeZ3mWq5ZKWAtwHA0Gh3KbudfnBFAAAEEEEAAAQQQQAABBBBAAAEEEECgfQLmuOGp1n3X6z4rAxJS7wRu37g0pcePjnQgGKEpw5q2H/pjFIbHaa/muscCKXaSDqMwOKiD22KX8oloOZ0ofbYr6tOmduc5jqJMB2vBCKbRKQISzGV8fpY5wjWsK+U8qmHPcjeZQJ7cdEs32vkuzxGYZqsDlIMAAggggAACCCCAAAIIIIAAAggggAAC3gjoay3qTCk527ZZM0+THwUkmMWcHVEDdq3loaztPUMReVHb1tPwXAIT0T+4jnbK1bAa3JRmZ29dfE0mnIdHRGzu2/YjDKocPqvBCCJyG3ReptnVvuF4iAstcsD3aZWzouK6LafVr7g31qofxfGxiPrDWoFtLshCwAvHZ7R5AtF3BBBAAAEEEEAAAQQQQAABBBBAAAEEVgpYy9B6X/rXgISUqcgZFwQQqL9AbY4U8JF6FCd6e7vs7FzdXo/dK0Zxci4ib5ZL1SK/74fBid3aspc221k9HnenU3WwI7p7X4JW+kuKozQyVRiFwdojjZYLWp01Yz4HTJv3kuRYiZxwBFKmIaj7xXzOrhlBsopYndqF5xnjYXU8KAwBBBBAAAEEEEAAAQQQQAABBBBAAIFGCGRZI0nTYbVInXu2ahEqTQFcgwACNROwsKOyZj222twmByTMsuQo1VdafvqGVk1whTnXfLoTdJXSPSVigg/Mf0rJ5qJF/tkPg68BD9sm0Jodxk8WCuc7w6VPYMI20dr/fXgbdA7TZNiofU9zdGAUJ1/Kei/naF4NbymWvWZdIFoNIWgyAggggAACCCCAAAIIIIAAAggggAACCFgQyLpGkqZK5emD4YuHjdcil0qLeYC9+qWkt/SH0hau0iBzDQIeCRTeTelRXyppSpojG2Qy/j6KoqtKGmih0nmgWnIkIr3bIDgpY2HVBCDI7q75LF/8R72y0JWcRWQLwlhzbMPK99o8Y8K4r0R+zdk4bvNcoC5HtlTBuOGIkyqa05A69XUUhod5O0NAQl457kMAAQQQQAABBBBAAAEEEEAAAQQQQKCxAtbXEpXtc7dT0l+I6CvR6moq6nJnR3+R8fjK9gLek/TeSh+KKPPQ9klK8pTt5jIE6i1AdgRr4zdKkp7Wumt272tR5r9fzwvPtphtrUE1LOi/u/HRPAOCPvIpa4AW/W4/DE+zkK4K7tuU0sjMH9FishOVkvUhS1+4tohAsd3qRWquw71rsonUoemetzH/vCMgwfOhpXkIIIAAAggggAACCCCAAAIIIIAAAgiULaDlQ7QX9G1WOzsj2+xM1buds28LajarkAvRcj4LPJgml7aDDvK2dB6IMV9INDtyHfU9b/O4DwEXAtYjmlw0ss5lmkXm207nsoyMAnV1MkEIO2pqAhBMBgYvF+Pz7HBftai37YylRbaEc75/6jqbl9rt4EdaQ2S+diNVhpmmdbqU/uTPkkBAQikDRCUIIIAAAggggAACCCCAAAIIIIAAAgjUSCD/Bqh1nZwFJJjXbGFkPB48Pjs8u405V0KZXZ87ch4FwXn2Eqq5w/Q/jCe9+UKZSRleZbrwagyoNb3Aw3lu7lpehJ7tfl68ZrvotTqQbxk6qjlShOwI6QeYK60KzLLVxOMTUfq4Bp+twygMDrICrNz5neLoDoISskr7ej2ZUbaNzPwomPHnbdfx97wC2f+RYOu3f94Wcx8CCCCAAAIIIIAAAggggAACCCCAAAIIeCjgYD3xa0DCfXdv4uQ069nWZnFWRA/UZHLmSwaEosNnMijsiDpWIse+7uIt2kfuzyqgr0WrgUzHAxvz3AQtTKfqYEd0V+9IV7QcOtwpTXaErMPN9VYEFgv1J/X5HM23sDyKYxNs8ccjtJRf2gQlWJlqlRVifgPth4EJNOO1QWDlewQxiwLbsyTcB9+ao3LIDmaRnqIQQAABBBBAAAEEEEAAAQQQQAABBBBokMBt0HlpOxP4k4AE45XyofFQiwzUZHxqY3HW53GapxjXZkHtjc/tpG3OBC5MwE0UhgNnNTwo2ATDKL1zaDVQIeXCaBn9o47mC8x3QifmWAYT0FWrz82pVj8/2+ucZR2lWVYULX8/ui/D+46ghKziflxvghHugk7P9o8zP3pntxWjOB6IqLd2S6W0TZ85BCAwPxBAAAEEEEAAAQQQQAABBBBAAAEEEEAgo0CuLNLb6lgZkGBuMouiu6LMkQvLZ3wPRcvpbdg5bdsD+NFodCi7u30eqG+bVo34+1BEn8lk0vcl4Gb2nlTqQKbS00oOlEhXy+y/X28RJztCI6ak3524D0LQSh0VPfqnwp7m/qJdGZCg5UO0F/TT9mdheFmDYy3Sdqnp1w0nonvPw/Cy6R210b9RnHypT6YUGz2upIxZAOX86DGOH6tkBKgUAQQQQAABBBBAAAEEEEAAAQQQQACBegs4WVNcG5BgrMwCvN7tnN0veGqR3++CTr9tgQjL82bm0umc1njRrd5vBaet19da5PQuCAZ1m+ezBdFVr/H4ypegCqdDR+GVCswDtjpmYXY5iK3SdmWp3HzH7YeByYaT+bUys1DGgART6SIY8FPmBnBD+QIZMmCU3zi/amRe+zUetAYBBBBAAAEEEEAAAQQQQAABBBBAAAEEEFgtkO9Y622aGwMSzM2LHZunotQgCgKTMYHXQmC+I9bsRFOvQKm9wMVUq9M8qdpr33M6gIAlgZs4PlGifrNUXPnFTMbf5w3eWZ2OPt8Xd+0dyx+5CmrUv5R1jE8FnbNe5egu6YuS99YLpkAEEEAAAQQQQAABBBBAAAEEEEAAAQQQQAABewI5NlqmqXxrQEKaQtp8zeLc774S+bXNDvXtu/44ETkl5XZ9R5CW+yVwkyRn9cweky94wOhvyA6RO7XRKE5MAOAbv0aX1swF8s+Vtgou3iP/trX/9BsBBBBAAAEEEEAAAQQQQAABBBBAAAEEEKiFgKPMwAQkWBr9/+7GRztqdm5vbdOVW6KoQzFD0XIq0/Eg727oOnSSNiJQhcAiSOv8/qifKtqQq84i2RHWZ8vJH5AwPwKDBdxcg+nuJi3yz13Q6dXtSB93IulLXp1FJP39XIkAAggggAACCCCAAAIIIIAAAggggAACCCDgVmAi+gcXm7gJSLA4boszks2uVoISLLraK0pfi0j/NgjOWEyyp0pJCCwLbMgY4CmWnR3vozg+Np8xD4/xicIg9/fsTZyckn3HqykznIjuufgx5lUvHTWGLAmOYCkWAQQQQAABBBBAAAEEEEAAAQQQQAABBBCwJFBkTWNTE3IvlFjqV+OKqe3u4MaNxKMOXYiSfhQEJliEFwIIlCBQqwCtAtkRVlE+DEwo8uVtvk++S8afSxguqkghoEW/2w/D0xSXcskaAbIkMDUQQAABBBBAAAEEEEAAAQQQQAABBBBAAAE/BUyG4P0w6LpoHQEJDlTrtzvYAUL1RQ5F9JlMJn2OZah+MGhBOwVMUMKOqIHXxzdo+RDtBX0XI2QCE6IwNEf55H6xgJubzvaNuY/f2NSQUZL0tNZdpdWBKOlNRJ80OQOD6a9o+dv24FAeAggggAACCCCAAAIIIIAAAggggAACCCCAQGEBJ8/BTasISCg8NqsLWOwO/uSoeIpdK8CxDEwOBHwS8DxrzPA26Bz6fIQL3yV+zGab52b9dzc+2lHTIxF1tOKIJ2c/+PyQFBnF8dXDY018aRftQAABBBBAAAEEEEAAAQQQQAABBBBAAAEEWi3gcAMnAQkOZ9ZNHJ8oUb/dV7Ep1cUsq0KnczjbKSli0mH0eGCfenDm2RCUGnAsQ2ozLkSgNIH50QPJqYh6W1qlKSqqSwr+mzi59DrLRArrOl+iRX7fD4OTon14eJTHxrKU/Njk77KbODlVIr8W9eR+BBBAAAEEEEAAAQQQQAABBBBAAAEEEEAAAZsC+peiWZ/XtYaABJvjtKKsUZyci8ibxZ8y7XycLeKNx12ZSk+UPiRI4QnwhYge3AbBmc87nB1PMYpHoDYCy0Fa1TZcX0dhaD5XvX+xgFvpEBXOorHIiGACcl6l64n+GIXhcbpr63cVWT/qN2a0GAEEEEAAAQQQQAABBBBAAAEEEEAAAQRaIOBwsxwBCY7nz9KD92EUBgd5qxzdJX1R8j7v/U24z2SZMEEIajI5i6Loqgl9og8ItElg/pkoZ+kXZ13puIv0s93iUZL0RMvftsulvBQCBVJUzTIf7XYGD4ISU1Q4u6RwEETaiqq6jmMbqpKnXgQQQAABBBBAAAEEEEAAAQQQQAABBBBAYLXAbdB56WoDOAEJJcy6URwP5qnKiy2AtXSX7FArORetzwlCKGGyUgUCJQhUf4RDfbIjmOGYe40/lzA0VPFYIHdgwCKA0Bzz8CIfarHfC/nqLO+ulv6eKQ+YmhBAAAEEEEAAAQQQQAABBBBAAAEEEEAAgU0CWj7chp3TWaZ+85pKL9oL+q7QCEhwJfug3PnuVn1cNAXz0vEPJbS8kiouRMu5KH01Ebl8HoaXlbSCShFAwLnAPJW9NjvIcy7a5m1i/RZ7R3Gi8/aW+3IK5MiOYL7vtZZTJfI6Z633t2U64qlgXaXfvnjv/1l6xVSIAAIIIIAAAggggAACCCCAAAIIIIAAAgi0W2AoSo6iIDgvk4GAhDK1C9Z1EyeXFhY5CrbCze1ayV93nc6xq1QgblpNqQggUFTA7P7fG48HSstPRctKd3+9siPc94mAhHSja/Wqyfj7tEcDzY9n2O3PsyFZemWo31KNpRVD1o/SqKkIAQQQQAABBBBAAAEEEEAAAQQQQAABBBB4IFDNGgkBCTWahI1ekFLyY9nRODUaepqKQOMFbuL4RIky6YCcZkvQot/th+Fp3UDr+fmvr0XUq7pZz9urP6bJanSfAclqIMICTIv8vh8G5tiHRr6aHGTZyAGjUwgggAACCCCAAAIIIIAAAggggAACCCDQDIEK1mQJSKjJ1Gn8bsIKJn9Nhp5mItAagfku8445wuGNq07fBp2XdczEUpeABJPtRrQ+V5PJ2WR392BX1CdXY+my3KlWPz/b65w9rGP2PWzO09L6UER68/84DbgY3gadwzrO1zRjcxMn5miLX9NcyzUIIIAAAggggAACCCCAAAIIIIAAAggggAACtgTSbcizVZsph4AEm5oOy5rvwpS/HVZRcdH1O9O9YjCqR6CxAotsCb/Z72D5X7I2+vC/OO5uW9jXIv8okS8P6nMW1PG4T/paizrTWp0vL+DXeMF5GIXBwcLdnKPlNGvHxjmi5UO0F5jMIY17/Xc3PtpR+s/GdYwOIYAAAggggAACCCCAAAIIIIAAAggggAACfguUvhmOgAS/J8TX1jX+wX2DF11qMsVoJgJeCcwXg+XM5g70Vbvever0UmNmgWjj8dV0J+juKH2iRS6Vli+yI2aRXG47ncttu+cXjl2bO/ofZkGIouhqneEojq9sjl95Y6WvRauBKDHHJVQXjDDv8FAm4+4mZ1cus8AgrQ62lZ83YGKREeXfbeXzdwQQQAABBBBAAAEEEEAAAQQQQAABBBBAAAHbAuVuFCcgwfb4OSpvdJf0Rcl7R8VXWexQi+7X8Uz3KtGoG4E2CCyOqjFp863s9q/LcQ2LjDh9LXKwHwYmmMDa677sfKb6WpQ6joJgFhCx6ZUmq8O2Mvj7XMAEgOwHwVGZHpmyMhU4cqm+QStljgZ1IYAAAggggAACCCCAAAIIIIAAAggggAACdgXKfu5MQILd8bNSmgk+mCh99jwML+8LrHHq600mFzIZH1ex89PKQFEIAgiUIjCK44GIeluwsosoDHoFy3B++3zX+G5fRB1OtTpdPgbBVgPmC87auL5KU6YW+f0u6PS3ZWS4L6vBQXRpuKxfo0W/KzNwbxQnJugkXSBQgYCEmyQ5U1p+sg5GgQgggAACCCCAAAIIIIAAAggggAACCCCAAAKbBGZHF5dFREBCWdIZ6vm6kPPgGINMiwMZ6qru0nqe5V6dFzUj0G6BwkEJHAvzZAKly0CRPivCwwoISHDwfi2w8J+lNZmyI5iCC7SLeZJlZLgWAQQQQAABBBBAAAEEEEAAAQQQQAABBBCwKFDg2W7WVhCQkFWshOsfLgZokX+moo93RA2UyOsSqi+hCoIRSkCmCgQaJ1AoKKHEL9a6wa/bpZ41K8LDfrPQ7GQWDEX0SRSGAyelLwqdB6okl2mzZ0y1+jlvJo//7sZHO0r/6bI/lI0AAggggAACCCCAAAIIIIAAAggggAACCCDwVKDMzLwEJHg6A0dxoj1tWqFmlX0mSaHGcjMCCHgnkDdbTBQGfN+tGU2zAL2XjM+/Bb3ly4rwsHhS8Tt865SQ7SNTloQC7ZkfUdL516EWRSOAAAIIIIAAAggggAACCCCAAAIIIIAAAgisFChvAzkLNJ5OwbyLbp52Z9EsfX0bBN20Z5D73RdahwACVQjkW8DU11EYHlbR3rrU+b847u6K+lQkK8J9XxdHQVyJyIu69L9+7SweNLKtz6M4vkqVJaFAQIJpQ1MDMLf58ncEEEAAAQQQQAABBBBAAAEEEEAAAQQQQKBigYsoDHpltIGAhDKUc9RxEyenSuTXHLf6ewsp0/0dG1qGQI0EchzdUNqXao0YnzTVBHtEUWQCCQq9buL4RIn6rVAh3JxSQF9rkVM1mZzZGLuHlWb4HVLo/dXMAMyUw8dlCCCAAAIIIIAAAggggAACCCCAAAIIIIBAdQKFnu1maTYBCVm0Sry2aQs6HNVQ4uShKgQaLrDl3PkLEX0lWl2JkkVknx5EYThoOIsX3SM7QnXDoEX+UaIvReTcxnzPcGxDoR+tOQKMqkOmZgQQQAABBBBAAAEEEEAAAQQQQAABBBBAoEECZR13TUCCp5Mmw0KApz1YatZk/L3t3Zv16DitRAABFwLf0rzra7MAO9U7Z8/2Omcu6qLMdAImGGEvGZ8rkdfp7uAqNwL6FxsBCaZtaY9TKPKjdXSX9EXJezcWlIoAAggggAACCCCAAAIIIIAAAggggAACCCCwRmAYhcFBGToEJJShnKOOZgUk6I9RGB7nYOAWBBBAYKXAKI6PZTI5J9DJjwlCMIIf4yCir6MwPLTVmrTHKdwGnZcvlfqSp94tGU/yFMk9CCCAAAIIIIAAAggggAACCCCAAAIIIIAAAtsFCmW/3V78tysISMiiVeK15ixv2e38W2KV7qoiO4I7W0pGAAEEKhb4Xxx3d0QNyIxQ8UDMqreXHcGUdhMnp0rk1609U/JjFATnW69bcYGZP7uiPuW5l3sQQAABBBBAAAEEEEAAAQQQQAABBBBAAAEE8gloJX/tB8FRvruz3UVAQjavUq9Omyq51EZlrozsCJnJuAEBBBCogYDJivBdPD4h3b43gzW8DTqHeTMVrOrFTRyfKFG/beuhFv1uPwxPt1237u/N+L2Tt/fchwACCCCAAAIIIIAAAggggAACCCCAAAIIlC9Q9LlulhYTkJBFq+RrG/CAfiiTcZeU6iVPHKpDAAEEHAo8CEQ4EZEXDqui6EwC9gMA0x8fVazuURxfiahXmbrLxQgggAACCCCAAAIIIIAAAggggAACCCCAAAL5BUrMcE9AQv5hcn5n7QMStHyI9oK+cygqQAABBBBwLmCOEtK7nRMlckwggnPuzBVMtfr52V7nLPONG25Ie3yUFvlnPwy6eesexYk57uFN3vu5DwEEEEAAAQQQQAABBBBAAAEEEEAAAQQQQCCLQLFNZllqMtcSkJBVrMTr6xyQUHRxokRmqkIAAQQQWCMwy4aQJEdalAlEeA2UvwK3QeelzeMa7nua9rdIFAa5f1PexMmpEvnVX11ahgACCCCAAAIIIIAAAggggAACCCCAAAIINEPArOHeBZ2ei+fJ64RyPzxuBrnfvUi7CJCzFxff7tNXotXVw3Kmoi53dvSXTWVPp+pgR/TXHZF6R7pKy4G5ZyL65HkYXuZsG7chgAACCKwQmAUI3N4euD4K57+78ZHa0cdKy08MRC0ELqIw6LloaerjFJT8GAWByXSQ+XUTxydK1G+Zb+QGBBBAAAEEEEAAAQQQQAABBBBAAAEEEEAAgdQCVQQjmMYRkJB6iMq98H9x3N0V9SllrUMRmS3+ayVf1PT+f+svSqnZ/z/R+gsBAik1uQwBBBDwVODBd8OFKOnnXQBe1b152XIioo44ksHTCbCuWQ6PSEp7nIIW/W4/DE/zyI2SpCda/s5zL/cggAACCCCAAAIIIIAAAggggAACCCCAAAIIbBeoKhjBtIyAhO3jU8kVs3ObdzrmnG7R6ltgwX1jbjudyzJTaVSCQKUIIIAAAk8EHmfP0dci0o/CcJCXahTHxxzJkFfPj/umWv38bK9z5qI1qQMSlPy1HwQmmCXza/abZ7fzb+YbuQEBBBBAAAEEEEAAAQQQQAABBBBAAAEEEEBgq0CVwQimcQQkbB0iLkAAAQQQQMAfgTXH+QxFy+lt2DlNG6xmAhFMMIOIeuVP72hJHoGJ6B9cZUEa3SV9UfI+RbuGURjMjm3K83J8TFWeJnEPAggggAACCCCAAAIIIIAAAggggAACCCBQe4GqgxEMIAEJtZ9GdAABBBBAoC0Cn7U++C4Zf97cX/1RJpN+FEVXq64zRzPsiBookddtcWt6P6MwcPZ7LkNAghQJjLiJk0vmZNNnKv1DAAEEEEAAAQQQQAABBBBAAAEEEEAAgbIFdIHstrba6uwBtq0GUg4CCCCAAAIIzAVGSdITLX+n9LgQJf0oCM7vr59nRVCnIvIiZRlc5r9AocwE27p3E8cnStRv266b/V3Lh2gv6Ke6dumimyQ5U1p+ynMv9yCAAAIIIIAAAggggAACCCCAAAIIIIAAAgisF3B57G8adwIS0ihxDQIIIIAAAh4IZNmt/q25+np+NIN5qT886AZNsCtwEYVBz26R30rLEgRjUn/th0E3T1vyze08NXEPAggggAACCCCAAAIIIIAAAggggAACCCDQNgF9HYXhYVW9JiChKnnqRQABBBBAIKMAae0zgrXjcm8CEmbck/H3644L2TQc/92Nj3aU/rMdQ0YvEUAAAQQQQAABBBBAAAEEEEAAAQQQQACBsgX0L1EYDsqu1dRHQEIV6tSJAAIIIIBARoEsO9UzFs3lNRZwff5X9nmX70ft/+K4uyvqU42HgqYjgAACCCCAAAIIIIAAAggggAACCCCAAAIeC1SXJYGABI+nBU1DAAEEEEDgXmAUJ+ci8gYRBB4JaPkQ7QWLIzns23zW+uC7ZPw5bclFAiRGcaLT1sN1CCCAAAIIIIAAAggggAACCCCAAAIIIIAAAtkEJqJ/eB6Gl9nuKn41AQnFDSkBAQQQQAABpwI3cXyiRP3mtBIKr6eA44AEg5I5UCDnsQ0cSVLPKUirEUAAAQQQQAABBBBAAAEEEEAAAQQQQKAeAlr0u/0wPC27tQQklC1OfQgggAACCGQQWKSyN9kRXmS4jUvbIuBhQELeH7WjOB6IqLdtGTr6iQACCCCAAAIIIIAAAggggAACCCCAAAIIlCpQwvPkVf0hIKHUUaYyBBBAAAEE0gsQjJDeqrVXlvADMnOGBMl3FhmZQFo7i+k4AggggAACCCCAAAIIIIAAAggggAACCJQhUMLzZAISyhhI6kAAAQQQQMCCAMEIFhDbUEQJPyBHcXwlol5l4lTyYxQEJrNH6tcoSXqi5e/UN3AhAggggAACCCCAAAIIIIAAAggggAACCCCAQHqBEp4nr2oMGRLSDxFXIoAAAgggUIrAYmH2jGMaSuGudyUl/IAcxYkJLHiTBUor+Ws/CI6y3GOuzZ6NIWsNXI8AAggggAACCCCAAAIIIIAAAggggAACCLRUoITnyatkCUho6Xyj2wgggAACfgqM7pK+KHnvZ+tolW8CeRf+s/QjT0DCrPzJ+Psoiq5KqStLJVyLAAIIIIAAAggggAACCCCAAAIIIIAAAgi0UYCAhDaOOn1GAAEEEEBgLjAajQ5ltzPIuhMdv9YLXERh0HOpkDsgQfTHKAyPs7TtJk5OlcivWe7hWgQQQAABBBBAAAEEEEAAAQQQQAABBBBAAIEUAgQkpEDiEgQQQAABBBoocBPHJ0pUnyMaGji47rvkcUBC9iwJ/92Nj3aU/tM9GzUggAACCCCAAAIIIIAAAggggAACCCCAAALtETDZdu86neOXSn0pu9ccVAFCHAAAIABJREFU2VC2OPUhgAACCCCwEBglSU9rMTvCX4OCQE4BvwMSMmZJ+Kz1wXfJ+HNOC25DAAEEEEAAAQQQQAABBBBAAAEEEEAAAQQQWBLQot/th+FpVTAEJFQlT70IIIAAAq0VmB/PsNsXUW9bi0DHrQlEYeD091zhYxSU/BgFwXnaDuc/IiJtDVyHAAIIIIAAAggggAACCCCAAAIIIIAAAgi0QUBfT0SOnofhZZW9dfoAu8qOUTcCCCCAAAK+Ccx2f8fjE1Hy3re20Z76CrgOSBjdJf2CczZTFofFESa/1XdEaDkCCCCAAAIIIIAAAggggAACCCCAAAIIIFCtQJVHNCz3nICEaucCtSOAAAIItEDgQSDCiYi8aEGX6WKZApPx91EUXbmq0kJAgmRJCTbPINL511V/KBcBBBBAAAEEEEAAAQQQQAABBBBAAAEEEGiyQJbnsWU4EJBQhjJ1IIAAAgi0VmAUx8ciYo5neNVaBDruViDjkQhZG2MjIEFEhjIZd9MGTtzEyaUSeZ21rVyPAAIIIIAAAggggAACCCCAAAIIIIAAAgi0V8CPIxqW/QlIaO+MpOcIIIAAAg4FCERwiEvRjwSmWv38bK9z5orFUkCCaJF/9sOgm6adHNuQRolrEEAAAQQQQAABBBBAAAEEEEAAAQQQQMBjgQvRcq53pKu0HIjIG5dt9emIhuV+EpDgcuQpGwEEEECgdQKjJOmJNhkR3P64aB0sHV4voOVDtBeYOefkZSsgYd44/TEKQ5M1ZONrdsxJMv687Tr+jgACCCCAAAIIIIAAAggggAACCCCAAAIIeCmw5rmtWUOYTtXBjuiuVnKgRLoi+rBIlmXfjmhYHg8CErycoTQKAQQQQKBuAotz7wcEItRt5JrQ3nSL/Hl7ajcgwbRC/xKFoXmvbHyN4nggot5uu46/I4AAAggggAACCCCAAAIIIIAAAggggAAC3gnk2Eg2W2fodA611l2l1cH27Ap+HtGwPBYEJHg3O2kQAggggECdBGY7uePxiSh5X6d209ZGCVxEYdBz1SP7AQmmpduDEv4Xx91dUZ9c9YtyEUAAAQQQQAABBBBAAAEEEEAAAQQQQAABZwI5AhK2teVhdgVz7W3YOX2p1Jdt91X9dwISqh4B6kcAAQQQqK3Af3fjox2lzU7vF7XtBA1vgsAwCgNzBpmT12Ke/2m/8O1BCaM4OSfriH15SkQAAQQQQAABBBBAAAEEEEAAAQQQQAABxwIOAhIct9hZ8QQkOKOlYAQQQACBpgqYrAh74/FAafmpqX2kX/USuA06L11FwpqoW9HytwuRbWebkSXBhTplIoAAAggggAACCCCAAAIIIIAAAggggIBzAQISvhITkOB8tlEBAggggECTBMiK0KTRbFBflPwYBYHJJmD95TIgwTRWK/nrrtM5XhdQMYrjgYh6a71jFIgAAggggAACCCCAAAIIIIAAAggggAACCDgS2Pbc01G1XhZLQIKXw0KjEEAAAQR8FLiJk1Ml8quPbaNN7RbYlmmgiI7rgIR52/T1VO+cPNvrnC23dRTHVyLqVZE+cC8CCCCAAAIIIIAAAggggAACCCCAAAIIIFCNgP4oSg1cbSirpk/ZaiUgIZsXVyOAAAIItFBgdkRDMj5XIq9b2H26XAMBLfL7fhicuGhqOQEJX1t+IUr69z/OR3F8LKL+cNEvykQAAQQQQAABBBBAAAEEEEAAAQQQQAABBMoT0Nda5PQuCAaujt8try/ZaiIgIZsXVyOAAAIItExgcYa9SYX/omVdp7v1EriIwqDnosklByQsujD/ca5ETsiO4GJUKRMBBBBAAAEEEEAAAQQQQAABBBBAAAEEqhNoV9YEAhKqm2nUjAACCCDguQDBCJ4PEM17JBCFgZPfddUEJDC4CCCAAAIIIIAAAggggAACCCCAAAIIIIBA0wXakTXByYPrpk8N+ocAAggg0HwBghGaP8ZN6+FE9A/Pw/DSdr8ISLAtSnkIIIAAAggggAACCCCAAAIIIIAAAggggMCyQHOzJhCQwGxHAAEEEEBgSYBgBKZEPQX0L1EYDmy3nYAE26KUhwACCCCAAAIIIIAAAggggAACCCCAAAIIrBNoXtYEAhKY7QgggAACCDwQ+Kz1wV4yPlcir4FBoE4CWuT3/TA4sd1mAhJsi1IeAggggAACCCCAAAIIIIAAAggggAACCCCQRqAZWRMISEgz1lyDAAIIINAagVEcD0TU29Z0mI42SeAiCoOe7Q4RkGBblPIQQAABBBBAAAEEEEAAAQQQQAABBBBAAIEsAvXOmkBAQpax5loEEEAAgUYL/Hc3PtpR+s9Gd5LONVogCgPrv+0ISGj0lKFzCCCAAAIIIIAAAggggAACCCCAAAIIIFArgfplTbD+0LpW40VjEUAAAQQQWAiYoxq+S5JLEfUKFATqKjAR/cPzMLy02X4CEmxqUhYCCCCAAAIIIIAAAggggAACCCCAAAIIIFBcwNURvsVb9rQEAhJcqFImAggggEDtBEZ3SV+UvK9dw2kwAg8EtOh3+2F4ahtlFCfadpmUhwACCCCAAAIIIIAAAggggAACCCCAAAIIIJBPwMXmtHwt2X4XAQnbjbgCAQQQQKAFAqM4+SIiL1rQVbrYaAH9MQrDY9tdJCDBtijlIYAAAggggAACCCCAAAIIIIAAAggggAAC+QS0yD/7YdDNd3f5dxGQUL45NSKAAAIIeCYwiuNjEfWHZ82iOQjkENDXURge5rhx4y0EJNgWpTwEEEAAAQQQQAABBBBAAAEEEEAAAQQQQCCvgP4lCsNB3rvLvo+AhLLFqQ8BBBBAwDuBmyQ5U1p+8q5hNAiBPAKT8fdRFF3luXXdPQQk2NSkLAQQQAABBBBAAAEEEEAAAQQQQAABBBBAILfA8DboHL5UymR9rsWLgIRaDBONRAABBBBwJfBZ64PvkvFnV+VTLgLlC9iPjiUgofxRpEYEEEAAAQQQQAABBBBAAAEEEEAAAQQQQOCpgJtje11KE5DgUpeyEUAAAQS8F/jvbny0o/Sf3jeUBiKQUkCL/L4fBicpL091GQEJqZi4CAEEEEAAAQQQQAABBBBAAAEEEEAAAQQQcCowEf3D8zC8dFqJ5cIJSLAMSnEIIIAAAvUSGN0lfVHyvl6tprUIrBfQIv/sh0HXphEBCTY1KQsBBBBAAAEEEEAAAQQQQAABBBBAAAEEEMgu4OLZb/ZWZL+DgITsZtyBAAIIIFBzgVGS9LTWXSXSFVFHIvKi5l2i+Qg8ErgNOi9tniFGQAITDAEEEEAAAQQQQAABBBBAAAEEEEAAAQQQcC4wFJFv2Q+0nD+qcUfOoyB4/P85b1LxCghIKG5ICQgggAACngv8L467u1odiZKeiLzxvLk0D4HCAlOtfn621zkrXNCiAAISbElSDgIIIIAAAggggAACCCCAAAIIIIAAAgi0WGAWcKBFLpWWL1NRlzs7+sttp3Npc4OZb74EJPg2IrQHAQQQQKCwwGetD75LkiOt1JHSsyAEMiAUVqWAOglokd/3w+DEVpsJSLAlSTkIIIAAAggggAACCCCAAAIIIIAAAggg0A4Bfa2VulRTuZQdOW960MGmMSUgoR0znl4igAACjRe4z4KglRwpkdeN7zAdRGCDgO2zxAhIYLohgAACCCCAAAIIIIAAAggggAACCCCAAAKbBPS1FnWmtTrfmSaXURRd4TUXICCBmYAAAgggUEuB+ywIIiYDgjoiC0Ith5FGOxS4DTovbaX5IiDB4UBRNAIIIIAAAggggAACCCCAAAIIIIAAAgjUUkAr+UtpfSaTyTkBCOuHkICEWk5vGo0AAgi0T8AEIITxpKeUNkcw9MiC0L45QI+zCUy1+vnZXucs212rryYgwYYiZSCAAAIIIIAAAggggAACCCCAAAIIIIBA3QXugxBug+DM1oawuptsaz8BCduE+DsCCCCAQCGBUZL0sp6NNBqNDqXTOZSp9PSOdJXWXRH1qlBDuBmB1gnoj1EYHtvoNgEJNhQpAwEEEEAAAQQQQAABBBBAAAEEEEAAAQTqKWCOY5DTuyAYEISQfQQJSMhuxh0IIIAAAhkERnFyLiJvRGQoIpfzW/WVaDU7P0krOVAi3dn/ltn/fp2heC5FAIG1Avo6CsNDG0AEJNhQpAwEEEAAAQQQQAABBBBAAAEEEEAAAQQQqJnAxVSrU1uZaGvWd2vNJSDBGiUFIYAAAgisEhjF8UBEvUUHAQQqEJiMv7dxdhkBCRWMHVUigAACCCCAAAIIIIAAAggggAACCCCAQFUCF6KkHwWB2XDp7et/cdzdEemJUj3RcqVEX8pkcm7jmbDNThOQYFOTshBAAAEEngiM7pK+KHkPDQIIVCGgf4nCcFC0ZgISigpyPwIIIIAAAggggAACCCCAAAIIIIAAAgj4L6CvRaljXwMRHgYgKC09EXmx2lRfi4gJpji/DYKzqo+ZICDB/5lPCxFAAIFaC4ySxETm/V3rTtB4BOor8H+jMPg/RZtPQEJRQe5HAAEEEEAAAQQQQAABBBBAAAEEEEAAAa8FtHyI9oK+T21MH4CwudVa5B+l5Wyi9NnzMFwcrV1eTwlIKM+amhBAAIFWCoxGo0PZ7fzbys7TaQSqF/h/ouSnohG9BCRUP5C0AAEEEEAAAQQQQAABBBBAAAEEEEAAAQRcCOjrichRFQv1y72Zr6fsmswHi/+oV7Z7bIITRPTgLggGZWVOICDB9ihSHgIIIIDAEwEWM5kUCFQnMBH9Q9Ef07yHqxs/akYAAQQQQAABBBBAAAEEEEAAAQQQQAABZwIXt0HnqKyF+eVelBGAsFlOf5TJpB9F0ZUzYREhIMGlLmUjgAACCMwERnFizip6AwcCCJQvoEW/2w/D0yI1E5BQRI97EUAAAQQQQAABBBBAAAEEEEAAAQQQQMA/Af0xCsPjMttVfQDCut66DUwgIKHMWUZdCCCAQEsFRnE8EFFvW9p9uo1A1QIXURiYFF+5XzdxcqlEXucugBsRQAABBBBAAAEEEEAAAQQQQAABBBBAAAFvBMoJRvis9UEYT3pK6dkRDJ4/Yx2KltNoL+jbHiYCEmyLUh4CCCCAwBOB0V3SFyXvoUEAgWoEojAo9JuPLCfVjBu1IoAAAggggAACCCCAAAIIIIAAAggggIBdAS3yz34YdO2WOi+tZgEIKwmMj5qMj2we41Do4bSLgaJMBBBAAIFmCZgv4O+S5JQMCc0aV3pTL4GpVj8/2+uc5W01AQl55bgPAQQQQAABBBBAAAEEEEAAAQQQQAABBDwSGN4GncOXSn2x1aZRkvS0lqMaZEDI0uWhiD6JwnCQ5aZ11xKQYEORMhBAAAEEVgqYL2LR2hzX8AoiBBCoTkCL/L4fBid5W0BAQl457kMAAQQQQAABBBBAAAEEEEAAAQQQQAABfwT0L0UX2WfrHlPpiRJzDMMbf/pmvyVFnyvft4iABPtjQ4kIIIBA6wTmgQfy9+OO62sCEVo3FeiwpwJF05ARkODpwNIsBBBAAAEEEEAAAQQQQAABBBBAAAEEEEgpoK+jMDxMefHXy9oUgLDG5uI26BwVySpBQELWWcf1CCCAAAJPBFYHJACFAAJeCUzG3+c994uABK9GksYggAACCCCAAAIIIIAAAggggAACCCCAQGaBdNkR/hfH3R0xGRBUT+lZFoQXmatq2A1FN7wRkNCwCUF3EEAAgSoEbuL4RIn6rYq6qRMBBNIKpPvBvao0AhLSGnMdAggggAACCCCAAAIIIIAAAggggAACCPgocBt0Xq7a5U8AwvbR0kr+2g+Co+1Xrr6CgIS8ctyHAAIIIPBVgMVKJgMC/gsU+dHIe9z/8aWFCCCAAAIIIIAAAggggAACCCCAAAIIILBa4OEO/9FodCi7uybzweI/6hVu2wTyb3YzJROQsM2XvyOAAAIIbBSYf3l3/oUJAQS8FxhGYXCQp5UEJORR4x4EEEAAAQQQQAABBBBAAAEEEEAAAQQQ8ETgQv4/e/ebFEmx9g34TugqbDTCmW/PN3EFgysQVyCuYHAFjisQV3BwBTIrEFcgs4KDKzjMt/fbDBFKQ3VDvlHAjMzIn/7f1d1XRzzxqFRm3nllTTNx6leZkY+vQwgCCIOuyX27S/Tbj0BCv1KuI0CAAIE7BTpVtR+RnuMhQKD5AheRv/qsLI8GrVQgYVAx1xMgQIAAAQIECBAgQIAAAQIECBAgQGD+BUbZeffd7AUS5v8+MAMCBAjMTKDT7W5Fjj9mVoCBCRAYTCDHz+21YnewRhECCYOKuZ4AAQIECBAgQIAAAQIECBAgQIAAAQKLIDDacQ21gEDCItwH5kCAAIEZCZxW3aMU8WxGwxuWAIEBBW6flTZIU4GEQbRcS4AAAQIECBAgQIAAAQIECBAgQIAAgUUQyC/bZbkz6kwEEkYV1J4AAQJLKnBadfdSxA9LOn3TJjC3AsOc9yWQMLfLrXACBAgQIECAAAECBAgQIECAAAECBAgMLFC/3HZetLaepvR24MYfNRBIGFVQewIECCyhwN/nve2VlH9bwqmbMoG5F7jM6btP11oHg0xEIGEQLdcSIECAAAECBAgQIECAAAECBAgQIEBgrgVO4qK32W63j8cxC4GEcSjqgwABAksk8FdVba5GOoyIz5do2qZKYIEEBt9mSyBhgZbfVAgQIECAAAECBAgQIECAAAECBAgQIPCQQIpv2kVRPwcay0cgYSyMOiFAgMByCLzJ+clat3eYIp4tx4zNksAiCuTX7bLcGGRmAgmDaLmWAAECBAgQIECAAAECBAgQIECAAAEC8yqQv2+X5f44qxdIGKemvggQILDAAsIIC7y4prZ8Ahe9LwfZbuu06u6liB+WD8qMCRAgQIAAAQIECBAgQIAAAQIECBAgsCwCg++u24+MQEI/Sq4hQIAAgfCGtJuAwOII5Mg/rpflXr8z6px3dyPFT/1e7zoCBAgQIECAAAECBAgQIECAAAECBAgQmB+BnOL39aLYnkTFAgmTUNUnAQIEFkygU1X7Een5gk3LdAgsrcCgf7kUSFjaW8XECRAgQIAAAQIECBAgQIAAAQIECBBYcIEc8ed50dp6mtLbSUxVIGESqvokQIDAggjUxzR80u3uCSMsyIKaBoF/BE7aZfGkXxCBhH6lXEeAAAECBAgQIECAAAECBAgQIECAAIH5EZh0GKGWEEiYn/tBpQQIEJiqQB1GWOv2DlPEs6kObDACBKYjkOKbdlEc9jOYQEI/Sq4hQIAAAQIECBAgQIAAAQIECBAgQIDAXAmcxEVvs91uH0+yaoGESerqmwABAnMqIIwwpwunbAKDCOT4ub1W7PbTRCChHyXXECBAgAABAgQIECBAgAABAgQIECBAYG4ETi4ib31WlkeTrlggYdLC+idAgMCcCfxVVZurkeq3pj+fs9KVS4DAYAKv2mWx1U8TgYR+lFxDgAABAgQIECBAgAABAgQIECBAgACBuRCYWhih1hBImIt7QpEECBCYjkCnqnYi0p4wwnS8jUJg1gJnRevp05TePlaHQMJjQn5OgAABAgQIECBAgAABAgQIECBAgACBuRCYahihFhFImIv7QpEECBCYrEB9RMMn3e5eRHo+2ZH0ToBAkwQuc/ru07XWwWM1CSQ8JuTnBAgQIECAAAECBAgQIECAAAECBAgQaLZAjvjzvGht9fOS2jhnIpAwTk19ESBAYA4F6iMaViLtp4hnc1i+kgkQGEEgR/yyXhYvHuui0+1uRY4/HrvOzwkQIECAAAECBAgQIECAAAECBAgQIECgkQKvzorW9rTDCLWEQEIj7wdFESBAYPICV7siVL0XkeKnyY9mBAIEmihQJ2LXy2LzsdoEEh4T8nMCBAgQIECAAAECBAgQIECAAAECBAg0VCDHz+21YndW1QkkzEreuAQIEJihQKeqdiJiNyJ9McMyDE2AQAMEzorW08dSsQIJDVgoJRAgQIAAAQIECBAgQIAAAQIECBAgQGAggfw6UtppF8XhQM3GfLFAwphBdUeAAIGmC9RHNKxG+m/T61QfAQLTEbjM6btP11oHD40mkDCdtTAKAQIECBAgQIAAAQIECBAgQIAAAQIExiFQH9d7XrR2H3sZbRxjPdaHQMJjQn5OgACBBRToVNWx3REWcGFNicAQAvVfTNfL4sVDTQUShoDVhAABAgQIECBAgAABAgQIECBAgAABAlMXyC/j4mK33W4fT33oewYUSGjKSqiDAAECUxToVNV+RHo+xSENRYBAQwVyxJ/rZbH5UHmdTmcjVlv/a+gUlEWAAAECBAgQIECAAAECBAgQIECAAIGlFaj/N96IvJ8uLg6aFER4tyACCUt7a5o4AQLLLNCpqp2I9OsyG5g7AQL/CJwVraePbd3VqbqZGQECBAgQIECAAAECBAgQIECAAAECBAjMXOBVRK53QDiMi4vDJoYQbgsJJMz8flEAAQIEpi/wJucnn3R7b6Y/shEJEGiiwGVO33261jp4qDaBhCaunJoIECBAgAABAgQIECBAgAABAgQIEJhvgfw6In14vEKOw3dzyim/TSkd1f9+1modPfZiWRMtBBKauCpqIkCAwBQETrvdg5Tj2ykMZQgCBBoukCN+WS+LFw+VKZDQ8EVUHgECBAgQIECAAAECBAgQIECAAAECTRF4VReSI45Sjre3QwUXOb/9rCyvAgbL8hFIWJaVNk8CBAh8JODYhqW+JU4iYui/8OSIJyni2VILLt7kX7XLYuuhaXWq7tuI+Hzxpm5GBAgQIECAAAECBAgQIECAAAECBAgQGFjg+tiEnI4vIx2trOS37aJ4v7PBwL0tcAOBhAVeXFMjQIDAQwI3xzbU2wB5wLh0t0p+2S7LnWGn7d4ZVq7Z7dpl8eDfCztVt/7L9NfNnoXqCBAgQIAAAQIECBAgQIAAAQIECBAgME6B/DqndJQu4+gqeHDZPWq32x8esTDO4RawL4GEBVxUUyJAgEC/Ap3z7m6k+Knf6123IAI5fm6vFbujzMa9M4peQ9um+OahBK9AQkPXTVkECBAgQIAAAQIECBAgQIAAAQIECExAIL88K4oXT1Oqd471GUFAIGEEPE0JECDQFIH6jfVhfil6070pKzjdOi5z+u7TtdbBKKPe3DtvRulD22YJ5Mg/rpfl3n1VnXa7BynHt82qWjUECBAgQIAAAQIECBAgQIAAAQIECBCYgMAYXuybQFVz2aVAwlwum6IJECDwoUCn292KXu94mG2CTqvqRYr0H6bLI3AR+avPyvJo1Bl3qmo/Ij0ftR/tmyGQU/y+XhTb91VjV4xmrJMqCBAgQIAAAQIECBAgQIAAAQIECBCYgoBAwtiQBRLGRqkjAgQIzFagU1U77bLcH6aK06p7lCKeDdNWm/kTaJfFWH7//33e215J+bf5E1Dx3QL5dbssN+7TEUhw3xAgQIAAAQIECBAgQIAAAQIECBAgsDQCAgljW+qxPJAYWzU6IkCAAIFHBe47nqHeJSFfpv9LK/n/XXUywI4Jf1XV5mqkw4j4/NECXDDvAq/aZbE1rkl0qm4eV1/6mb3AWdF6et/xLwIos18fFRAgQIAAAQIECBAgQIAAAQIECBAgMC2B/DJSevAl0HZR1M9VfB4REEhwixAgQGDOBK62yU9p/+NfdFfHNuT44/10UnwzyC/DeoeFiPTrnHEod0CBHPHLelm8GLDZvZd3qm79F66vx9WffmYs8MD3xr++Y2ZcquEJECBAgAABAgQIECBAgAABAgQIECDQIIGTiLg6KjmneJsur/85VuIqtHDWah3d9zJYg+YwkVIEEibCqlMCBAhMRqDT6WzEaut/EfGvt9xvPxjOkX9cL8u9Qau4CjtEej5oO9fPj8BlTt99utY6GFfFtvEfl2RD+nlkGzI7YjRknZRBgAABAgQIECBAgAABAgQIECBAgMCcCuTXEek4Ih9HTseR8nGkdDzIrtfzNnGBhHlbMfUSILDUAh8EBm69yXzz5vJBRD64zCsHwz5wro+DWOv2DlPEs6WGXuDJt8tirL/7vTW/WDdLTvH7elFs3zerTtV962iXxVpzsyFAgAABAgQIECBAgAABAgQIECBAoFECVzstvNtlIaf8NqV0tdvCILtiN2lGY30o0aSJqYUAAQKLIFAHBD7p9TbfzSWl9FnO+a+rf+/1jtvt9nH9j/XOCWeffPJ2mO1+3o9xGVt5JTZTzpsR6YtF8DOHDwUee9g8jNfV/dPtvRmmrTbNE8gRf66XxfvvnI8rdERH89ZMRQQIECBAgAABAgQIECBAgAABAgQILJvAu10WInLEUcpRv0gWt8MLfYlcxtZVu6tnQ/EkRz4YZvftx8YSSHhMyM8JECCwQALCBwu0mENNJX/fLsv9oZo+0Mg2/uMWnW1/D+2i4YiO2a6N0QkQIECAAAECBAgQIECAAAECBAgQIDAhgZOzorUxzIuvj9UjkPCYkJ8TIEBgTgWED+Z04SZX9km7LJ5MontvzU9CdYZ93joO5uMqHNExw3UxNAECBAgQIECAAAECBAgQIECAAAECBCYlkOPn9lqxO4nuBRImoapPAgQIzFDg+oFh3nfswgwXoYFD54hf1svixSRKE0iYhOrs+rzM6btP11oHd1UgkDC7dTEyAQIECBAgQIAAAQIECBAgQIAAAQIEJiQwsd0R6noFEia0arolQIDArAROq+5eivhhVuMbt6ECF70v2+328SSqE0iYhOoM+3wgCSuQMMN1MTQBAgQIECBAgAABAgQIECBAgAABAgQmITDB3RHqcgUSJrFo+iRAgMAMBU6r7lGKeDbDEgzdOIH8sl2WO5MqSwhmUrKz6Ten+H29KLbvGl0gYTZrYlQCBAgQIECAAAECBAgQIECAAAECBAhMSGCiuyPUNQskTGjldEuAAIFZCLzJ+ckn3d6bWYz9bswc8adAxCxX4I70RJLeAAAgAElEQVSxJ7g7Qj1a57y7Gyl+atislTO8wKt2WWzd1VwgYXhULQkQIECAAAECBAgQIECAAAECBAgQINA4gQnvjlDPVyChcauuIAIECAwv8Pd5b3sl5d+G72Gglq9yxFGKfBQpHbeL4rBu/VdVba5G+u9APbl4ggKT3R2hLlwgYYLLN5uuT9pl8eSuoQUSZrMgRiVAgAABAgQIECBAgAABAgQIECBAgMAEBCa+O0Jds0DCBFZOlwQIEJiVwAS3zj/JKQ4j58PLiMPPyvLooTl2qm6elYFxPxCYyl8mJnjfWc4ZCbTL4s6/IwokzGhBDEuAAAECBAgQIECAAAECBAgQIECAAIFxC0xhd4S6ZIGEcS+c/ggQIDBDgdOqezSm4xIGCiB8POVOVR1HpC9mSGHoiMiRf1wvy71JY3Sqbr07xteTHkf/UxS455gPgYQproGhCBAgQIAAAQIECBAgQIAAAQIECBAgMDmBib3QWB8v/jSlt+9KF0iY3CLqmQABAjMRuH5gmDcip41IeSMibVwXcvXPt0MCJxFxs9NBPo6cji8jHa1cdo/a7fbxKMV3qmo/Ij0fpQ9tRxZ41S6LrZF76aMDgYQ+kObtkhTfvDuG5XbpAgnztpDqJUCAAAECBAgQIECAAAECBAgQIECAwB0CE9odoVNVOznS5npZvHg3qkCCO5AAAQIzEqi/lNtluT+j4Sc6rIeWE+Xtp/OJJRvvGlwgoZ8lmbNrBBLmbMGUS4AAAQIECBAgQIAAAQIECBAgQIAAgb4FJvYM4XoH7Yh2Wd68LOvIhr5XxYUECBAYp0AdRohIe2dFa+P2tjXjHGPWfXlIPcMVuOdh8qQq6lTdeuulzyfVv36nL3CZ03efrrUOPh5Z2Gj6a2FEAgQIECBAgAABAgQIECBAgAABAgQIjFVggrsjRKRf61ovIn/1WVle7dJth4Sxrp7OCBAg0J/AdUIsfRET+tK/r4q/qmpzNaUnt39+1modTSIUcTVWpP/2J+Kq8Qnk76e980an6ubx1a+nRgjc890kkNCI1VEEAQIECBAgQIAAAQIECBAgQIAAAQIEhhLIEX+eF62tCT4X2ouIr3PEL++ObRBIGGqpNCJAgMDwAjcP9HbrHnKKt+tFsT18b81u2Tnv7kaKn5pd5SJVl1+2y3JnmjMSPJmm9lTHehU5Dv81YsobEen5VCsxGAECBAgQIECAAAECBAgQIECAAAECBAiMLDDJMMLt4q6eg13GVnutuHoWJpAw8tLpgAABAgQeEuhU1b4HmNO4R6YfRqhn9fd5b3sl5d+mMUNjECBAgAABAgQIECBAgAABAgQIECBAgAABAgMLnOSI/fOitTuJnREeq0Yg4TEhPydAgACBkQTe5Pxkrds7TBHPRupI4wcEZhNGqAuyC4YbkwABAgQIECBAgAABAgQIECBAgAABAgQIzFogv45IxxH5OHL9/28+K3HYLop/74Y7xXIFEqaIbSgCBAgsq0AdSvik292zU8L474Ac+cf1sqzPZJrJp1N167/IfD2TwQ1KgAABAgQIECBAgAABAgQIECBAgAABAgSWWiC/jIuL3Xa7/U8IYYoe9bHOn5Xl0UNDCiRMcUEMRYAAgWUXOK26eynih2V3GNP8Ty5z2vl0rXUwpv6G6qZTdd9GxOdDNdaIAAECBAgQIECAAAECBAgQIECAAAECBAgQGFIgf98uy/0hG4/crNPtbkWOPyLiVaTYvW8nBoGEkal1QIAAAQKDCPx93tteSbn+Bekh9iBwt67NEX9eRt55LHU4ZPd9N+t0Ohux2vpf3w1cSIAAAQIECBAgQIAAAQIECBAgQIAAAQIECIwukOPn9lqxO3pHw/fw7x2U7z5eWiBheGMtCRAgQGBIgfoIh7Vebz/l+HbILpa2WY745bxo7T5Nqd6ZYKafTlXtRKRfZ1qEwQkQIECAAAECBAgQIECAAAECBAgQIECAwFIJ5NdnRbE5y+cEt3ZH+Ef+npCEQMJS3ZwmS4DAsgrUuxJU5erhLH853WV//Qur3i0hfbGsa9P/vPPrSGnnvi2P+u9nfFeedrsHQiXj89QTAQIECBAgQIAAAQIECBAgQIAAAQIECBB4VKABuyPc+XxAIOHRpXMBAQIEFlqgfpt9lmcJPYR7/aZ97Aom3Kl0Ejn2Zr310l2VdapuvUuDozcW+pvD5AgQIECAAAECBAgQIECAAAECBAgQIECgUQI5fo6VOKxrmsVLjPce5yyQ0KjbRDEECBCYukBTd0m4DSGY8MFtcRVEOCtbe03b2aKusr6fVlL+beo3sgEJECBAgAABAgQIECBAgAABAgQIECBAgACBjwTy64h0fPUf83VYIVI+jnT938YZXOicd3cjxU//WgKBBHclAQIECPxVVZufleVR0yXqoxxyxIslPQ6g0UGEd/fOadXdSxE/NP1eUh8BAgQIECBAgAABAgQIECBAgAABAgQIECBwLZAj/lwvi81RPO7dPVkgYRRWbQkQIEBgFgL1tj95dXU7Iu2kiGezqGFaY9Z/CUiR986K4qCJOyJ87OC4hmndGcYhQIAAAQIECBAgQIAAAQIECBAgQIAAAQJjErgnNNBv7w/uniyQ0C+j6wgQIECgiQL17g4rEVuLFU7Ir3Okg8vI+/Owc8W7+8JxDU38E6ImAgQIECBAgAABAgQIECBAgAABAgQIECDwkEB+fVYUm6O8FHna7R7cu7u1QILbjwABAgQWRaDeOSFWV7fiKqBwFVL4Yl7mVu+EEBGH8xZCuO374F845mUh1EmAAAECBAgQIECAAAECBAgQIECAAAECBJZKIH/fLsv9Yad8/Wym9b972wskDEurHQECBAg0XeBdQCFH2kwR9dlHXzel5ncBhJzTYVWuHo6SPGzCnB79C0cTilQDAQIECBAgQIAAAQIECBAgQIAAAQIECBAgcFvgVbss6pc8h/50zru7keKn+zrIEb+sl8WLj3+ehh5RQwIECBAg0GCB+oiHlFc2ViJvRsobEWkjrsMKn0+i7Dp4kCLeRo7DSPk4UjpuF8XhJMaaZZ+P/YVjlrUZmwABAgQIECBAgAABAgQIECBAgAABAgQIELhDIMU3oz6z6FTV8SM7Vt8ZehBIcEcSIECAwNIJXL3l32rVAYWInDciX4UV+v5cRjpaWclv6waj/gLve9AGXPgm5yefdHvHkwp1NGCKSiBAgAABAgQIECBAgAABAgQIECBAgAABAgsmkF+2y3JnlEl1qmonIv36SB8CCaMga0uAAAECBJZdoM+/cCw7k/kTIECAAAECBAgQIECAAAECBAgQIECAAIGmCJzERW+z3W7XLxsO/Tmtukcp4tkjHQgkDC2sIQECBGYkcPVGeq9XHzNw9TlrtY6epnT1Zr4PgWkKXO+O0D16ZDumaZZkLAIECBAgQIAAAQIECBAgQIAAAQIECBAgQOAhgRw/t9eK3Y8vqXeSvlwpNlPKW5FiY70otu/rptPtbkWOP/qAFkjoA8klBAgQIECAwB0CnfPubqT4CQ4BAgQIECBAgAABAgQIECBAgAABAgQIECAwDwL59VlRbH5ydvakDh+sRN6MFFsRUb8I+/m7GeQUvz8YSKiq4/5eVsyv22X5ryOy0zxQqZEAAQIECBCYncD17gi9ejun939BmV01RiZAgAABAgQIECBAgAABAgQIECBAgAABAgQeFcjxc6S8EZGeP3xt/r5dlvt3XTPoy4rtsvhX/kAg4dGVcgEBAgQIEFhugU5V7T/+F5blNjJ7AgQIECBAgAABAgQIECBAgAABAgQIECAwlwIXvS/b7Xb9UuIHn7+qanM10n8HmZNAwiBariVAgAABAgRigLOhaBEgQIAAAQIECBAgQIAAAQIECBAgQIAAAQJzJJAj/lwvi/oIhw8+N2GEw4F3Tk7xTbso6nbvP3ZImKMbQqkECBAgQGCaAvVRDWvd3mGKeDbNcY1FgAABAgQIECBAgAABAgQIECBAgAABAgQITF4gR/yyXhYvbo/093lveyXl+giHwY9xFkiY/KIZgQABAgQILIrAadXdSxE/LMp8zIMAAQIECBAgQIAAAQIECBAgQIAAAQIECBD4RyBH/nG9LPfq/9Kpqp0c6cVILynm+Lm9VuzeNrZDgjuOAAECBAgQ+JfATQLyNzQECBAgQIAAAQIECBAgQIAAAQIECBAgQIDAggrc2tGgU3XfDrUrwi2au3ZcEEhY0HvHtAgQIHCfQP2gOafL48/K8ogSgbsEhj4bCicBAgQIECBAgAABAgQIECBAgAABAgQIECAwPwI3gYSb5wL/HUPhr9plsXW7H4GEMajqggABAvMk0Km6hxGxeVa0Np6mVKfdfAi8F3iT85O1bu9wpC2ZeBIgQIAAAQIECBAgQIAAAQIECBAgQIAAAQLNF7gJJHS63a3I8ccYCj5pl8WT2/0IJIxBVRcECBCYF4FOp7MRq63/3dT7r5TavMxDnZMREEaYjKteCRAgQIAAAQIECBAgQIAAAQIECBAgQIBAIwVSfJNz3kyRdkc9ruH9/C56X7bb7eN3/y6Q0MiVVxQBAgQmI3BadfdSxA/ves+Rf1wvy727RqsfTn/S7W7HxcXh7V8ck6lMr7MWEEaY9QoYnwABAgQIECBAgAABAgQIECBAgAABAgQITF3gZGxBhJvSL3P67tO11sG7mQgkTH1NDUiAAIHZCXSqbn1Ew+cfVpC/b5fl/u3/dlpVL1Kk/1z9txw/t9eKOhnns6AC9c4ZebV14JiGBV1g0yJAgAABAgQIECBAgAABAgQIECBAgAABAtMS+Oi5kkDCtOCNQ4AAgRkLdKpqJyL9ek8Zry5z2nuXWDvtdg9Sjm9vrnW0w4zXbpLD35wLVScVPwqqTHJUfRMgQIAAAQIECBAgQIAAAQIECBAgQIAAAQILKvDBcyWBhAVdZdMiQGByAvXb5NFqbbwboV0Uh5MbbXw9d6puXefXD/eYX+dI9Zvy7491qK9vl4XfF+Nbikb0dHNEw+7Ha92I4hRBgAABAgQIECBAgAABAgQIECBAgAABAgQIzK3A7edKHjDN7TIqnAABAv0LXIUoVlv/67/FR1em+GZeghdDz3FJGl4HEbo7KVJ9DIddEZZk3U2TAAECBAgQIECAAAECBAgQIECAAAECBAhMS+Ai8lefleVRPZ5AwrTUjUOAAIEZCnTOu7uR4qfBSsivI9IXV20+Ou9nsH5c3RSBOozwSbd3LIjQlBVRBwECBAgQIECAAAECBAgQIECAAAECBAgQWDyBHPnH9bLcq2cmkLB462tGBAgQ+JfAEIGEk7OitfHJ2dmTWF3djUgb7bLYQjv/AkPcC/M/aTMgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIEpiaQU/y+XhTb9YACCVNjNxABAosmcL31fe8wRTz799zy9+2y3G/KnK+ObGi1Nup6Li/Tk5XIm/U/55XYTDnqoMEHW/df5vTdp2utg3f11+3b7Xb9Zr3PAgicVt2ju+/bBZicKRAgQIAAAQIECBAgQIAAAQIECBAgQIDA0gvkiF9S5O33O0EvvcjUAU7aZfGkHlUgYer2BiRAYFEEOlW1H5Ge3z+fZoUS7qvzKljR6+2nHN/W19xOrS3KWpnHhwJ/VdXmaqT/ciFAgAABAgQIECBAgAABAgQIECBAgAABAoso0C6Lq+fgnaraiUg713PMGwIK01vti8hffVaW9QuSPgQIECAwqMBp1d1LET883m4+Qgk3v5TrgMV2fVTD05TePj43V8yzgKMb5nn11E6AAAECBAgQIECAAAECBAgQIECAAAECDwi8eugY6k63u5Vz3oyUtt69rElz/AI58o/rZVk/T/MhQIAAgUEEbtJ0v/bfZo5CCY5m6H9ZF+BKRzcswCKaAgECBAgQIECAAAECBAgQIECAAAECBAh8KJDj5/ZasdsPS72L9Cfd7naO9MJRx/2I9X/Nux25BRL6N3MlAQIEok7NRY4/BqeYn1DC4HPTYl4FHN0wryunbgIECBAgQIAAAQIECBAgQIAAAQIECBC4VyDFN+2iOBxU6GrnhIgXdk0YVO7+6+ujMwQSxuepJwIEFlzg5uFt/Qvs8+GmKpQwnJtWkxRwdMMkdfVNgAABAgQIECBAgAABAgQIECBAgAABAtMWqB+CjzLmzcup9Q4LX4/Sj7YRkeKbkRYDIgECBJZF4GbLnqOI9MUoc76I/NVnZXk0Sh/aEhi3gKMbxi2qPwIECBAgQIAAAQIECBAgQIAAAQIECBCYjUB+fZlXXny61joYdfy/z3vbK+lyb9RnQ6PWMcftTy5z2hFImOMVVDoBAtMRqMMIa93e4RjODjppl8WT6VRtFAL9Czi6oX8rVxIgQIAAAQIECBAgQIAAAQIECBAgQIDAPAjkl+2y3Bm10ptnRLsp4odR+1qi9ieRY++sbO09TemtQMISrbypEiAwnECnqvYj0vPhWv/TKqf4fb0otkftR3sCkxBwdMMkVPVJgAABAgQIECBAgAABAgQIECBAgAABArMTGE8ooa7/5hiHeteFIY/1np3CNEfOEb+cF63dOojwblyBhGmugLEIEJg7gdOquze21FuOn9trRX3m0NQ+nU5nI1ZXty4ijhwVMTX2uR3I0Q1zu3QKJ0CAAAECBAgQIECAAAECBAgQIECAAIE7BC5z+m4cxzfUXV8f792rQwlfw/5QIEf8eRl5565nUQIJ7hYCBAjcI9Cpqp2I9OvYgFJ80y6Kw7H110dHp93uQcrx7UeXvnr/7zne13MZ6WhlJb9PrE271j6m45IJCzi6YcLAuidAgAABAgQIECBAgAABAgQIECBAgACBKQvk1+2y3BjnoHYc/kjzkRdyBRLGeffpiwCBhRG42Xrnj7FO6KL3ZbvdPh5rnw90Nu5ARZ1uSxHvAwtXQ98KNLwvZeWfkMO7/3bWah3d3p5nWgbGGVzAX6QGN9OCAAECBAgQIECAAAECBAgQIECAAAECBJoskL9vl+X+OCu8eQazt9xHOOTXFxHbj+3QLZAwzjtPXwQILITAzVvi9c4BYz0HqF0WU/vOndQcxrzAJxFxdGefdwUd6vxDym9TSh+26fWOpxn0GLNBI7tzdEMjl0VRBAgQIECAAAECBAgQIECAAAECBAgQIDCEQP3C5XpZbA7R9MEmc/IsZtzTftffq7Oitd3Py6hTezg2qZnqlwABAuMUuD7/p3sUkb4YZ791X9MKJNRzWOv2DlPEs3HPoYn95RS/rxfFdhNrm8eabs7AqnfyGGsgZx4t1EyAAAECBAgQIECAAAECBAgQIECAAAECCyIwoV2s61DCSqT9ZXkmc3035Jftstzp984QSOhXynUECCy8wIQf5L9ql8XWpBEnPIdJlz9s/yftsngybGPtPhRwZIM7ggABAgQIECBAgAABAgQIECBAgAABAgQWTSBH/nG9LOsjFsb+WaZnM8M4CiSM/ZbTIQEC8yrQqar9iPR8QvVPJZBw2u0epBzfTmgOje32IvJXj51R1NjiG1bYst5DDVsG5RAgQIAAAQIECBAgQIAAAQIECBAgQIDAGAUmvdvycoQS8vftstwfdFkEEgYVcz0BAgspcFp191LEDxOc3EQDCTfb7B9ExNcTnENzu87x81nZ2uvnrKLmTmL2lXW63a3IUd9HjmuY/XKogAABAgQIECBAgAABAgQIECBAgAABAgTuEcgRf6aItzniKOV4+/FleSU2I8fGraMUJr7b8mKHEoYLI9TrIpDgjzEBAksv0KmqnYj064QhJhZIWOxfcAOuimDCgGD/XO6ohqHpNCRAgAABAgQIECBAgAABAgQIECBAgACByQmcRMRR5Di8jHSU0+XxoDsm/33e215Jl9tnRfFi0i82LuYzm+HDCAIJk/uDoWcCBOZE4OaN8D+mUO5EAgneaL9z5U4icv2W/2GkdNwuisMprO/cD9GpurXTcu6wMferZwIECBAgQIAAAQIECBAgQIAAAQIECBBYCIEPwgcrl92jdrt9PG8z+6uqNlcj1f+b+wLsRpxftstyZ5Q1sEPCKHraEiAwNwLX6bf84qrgFLv1Q+op/0IY61ZANwm73QkfMzE369tPoe+2b6qvzSnepss4uqtdTvltSunOn/UzzqSuOWu1jiaZ3BRImNTK6ZcAAQIECBAgQIAAAQIECBAgQIAAAQKLK5BT/J5yPBnkhbfbxy1E5OP6f5Of9P8GPu0VmPIzqElNbywv2wokTGp59EuAQOME6lDCu6186gf6n3S7RxHpi2kV2i6LsXznXu+KkPenWfu0jIwzrEB+HZHep0RvBy5uBywe2i1CIGFYe+0IECBAgAABAgQIECBAgAABAgQIECCwxAI5fm6vFbvvBDqdzka0Whv/Eun1judxt4NRVvbmZdnfRuljdm3z67Oi2BzHi5JjeTg2OwgjEyBAYHCBWZ3fM2og4eqX+Gprf5CU4eA6WiyBwPWWV5GPc8TRZcRhfd6WQMISrLwpEiBAgAABAgQIECBAgAABAgQIECBAYBICF70vly1s0C/jaVW9SJH+0+/1TbnuIvJX9bODcdQjkDAORX0QIDBXAlc7DFzG1n1vjr/7eaS8M9ZdCIb8hXwdRFjdjUjP5wpasfMkUIcU6s8CnGc1T+xqJUCAAAECBAgQIECAAAECBAgQIECAwEIIjGVr/4WQuGMSnaqqd72en2c8H+16Meq6CCSMKqg9AQILLdCpqp2IqMMAox/tkOKbh7bM/xhSEGGhby2TI0CAAAECBAgQIECAAAECBAgQIECAAAECCyNwmdN3n661DhZmQmOcyKx27h5uCvl1uyz/feTGcJ1dtRJIGAFPUwIElkfgtOoepYhno8x40F/Gp93uQcrx7ShjakuAAAECBAgQIECAAAECBAgQIECAAAECBAgQmLxAfn1WFJtPU3o7+bHmb4S/qmpzNdJh43cqHvDl2n5WQiChHyXXECCw1AL1L4mVSPujBhJiwC1u5vVcoaW+WUyeAAECBAgQIECAAAECBAgQIECAAAECBAgsq8CAz0HuY6p3FPik19t8iPEi57efleXRPFE3/7nP+HdHqNdHIGGe7lK1EiAwNYG/z3vbK+lyOyK2xnJcQ0TkiF/Wy+JFv5O4Scv9t9/rXUeAAAECBAgQIECAAAECBAgQIECAAAECBAgQmKnARe/Ldrt9XNdwdTR1q3W9/f9l/bwlIqd4kiJuhw3qf/58HDXniD9TxPUODTnq3QgiVuKwSeGF5u+OnV9fRGyPM+whkDCOu1sfBBou0Ol2tyLnnbi42H33S6DhJU+9vKu0Xbe7nVPanuAxCa/aZXH1C7ffT6fq1r84x/KLuN8xXUeAAAECBAgQIECAAAECBAgQIECAAAECBAgQGE4gvx7Xi57DjX9/q+vAQj7KEUeXEYfjfOjeb63Xz6N6dWCjyc9+Ti4ib43LRyCh37vDdQTmWKBTdesU2Nf1FHKK3/Nl2v90rXUwx1MaW+n/7ISQno+t0/s7GjiQ0Pyk3BTUDEGAAAECBAgQIECAAAECBAgQIECAAAECBAgQGL/ASU5xmHI+OCuKg6cpXe+uMOFPp6p2ItKvEx5mpO7r54nrRVHvJD7yRyBhZEIdEGi2wPXuCPHHv6vMryOn/bjs7S/brglXWwSttHYi5foL/4tprmC7LAb63m3+eULT1DMWAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQGAyAvVD+GmFE26/TDyZ2Yze66DPtO4bcaAHY6OXrQcCBKYt0M8X2s0WNXvTTH/14/BXVW2uRGytl+VeP9c/dk3d32rEi4ip7IZwZzmDfnlf15z++9jc/JwAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQGAsAic5Yj9d9PYm9VLvPDz/GfSZ1n3yAgljuSd1QqCZAvfvjnB/vXU4ISLvp4uLg0l9yT6kdR1CSDsp8vb73QtSfNMuivrYiaE+Nw67746tGKqTMTUa5su7U3XrLYKafJbQmHR0Q4AAAQIECBAgQIAAAQIECBAgQIAAAQIECBBokkB+eVYULyZxnEOnqvZn+RLtY8rDPNO6q0+BhMek/ZzAHAv0szvCQ9MbVzjhJmSwf160tu76wr4zhPBhYa/aZbE16FJcHc2w2tpvQhDhfe1DhCtOu92DlOPbQefvegIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAgZEFTiLHXnutqF9+HdvnTc5PPun2jpv6UqpAwtiWWkcEFlNgmN0RHpJ4d6xDuyzrB/wDfd4lvOo+3oUS/j7vba+ky3oXhO2+vmgHeJBff4GvdXu7KeKHgQqdwsU58o+DHkFxWlUvUqT/TKE8QxAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECNwhUD/nuoy881lZHo0LqHPe3Y0UP42rv3H2I5AwTk19EVhAgVF3R7iTJMfPg6a/btJdb27192rIHQv62iXhOuiQ69BEo484yCl+TzkfnBXFwWPb/MzDOUIL+EfIlAgQIECAAAECBAgQIECAAAECBAgQIECAAAEC/xIY5uXT+xibu0tCft0uy41xLL8jG8ahqA8CDRMY9+4IN9M7OStaG489PP+YYqzJrgd2Sbj5wj4YMuwwyxU8icgHcXGx226362157vx0qu7bpocsZolobAIECBAgQIAAAQIECBAgQIAAAQIECBAgQIDAtATqF0/PW62dQZ+b3VXfu53Gp1V7X+MM8ZLyff0KJPQl7iIC8yUwid0RcsQv62XxYlCJTlUdR6QvBm13z/V37pIwL7siPG6QX94XTDjtdg9Sjm8f78MVBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECkxfIry8itkc9wqHT6WzEaut/k6/30RFOIsfeWdnaG0fQ4t1oAgmPuruAwHwJdKpqJyL9OvaqL3pfPvQG/13jTaSWj3ZJOK26eynih7HPd3Yd3iAjOXMAACAASURBVPllPxHL2c3RyAQIECBAgAABAgQIECBAgAABAgQIECBAgACBRRA4uYi8NWoo4bTqHqWIZ7MBya8jYrddlvWR6GP/CCSMnVSHBGYrMOYdCW4mk1+2y3Jn0JlNYqeGiLjaJWGOj2gYgDG/vIjYe/dLbDJrO0A5LiVAgAABAgQIECBAgAABAgQIECBAgAABAgQIELhDIH8/ygP9Gb2Y+ipS7LaL4nCSSyqQMEldfROYssDEvqyG2B3hr6raXI3030kQ5Mg/pogXYzwKYhJljrHP/DpHOqg7XLDdIMZopCsCBAgQIECAAAECBAgQIECAAAECBAgQIECAwCwFhg8lfHhsQ71jQTqOHNdBgZWb/3/P1HLOmxFpI0VsRsTXjwvcf4T4420Hv0IgYXAzLQg0VuC0ql6kSP8ZZ4E5xe/rRbE9aJ+dqtqPSM8Hbed6AgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAvMpMEIoodvdOmu1jp6m9HbYuV/vMN6tn+vtfvRi751Hhg87ziDtBBIG0XItgYYL3BxjcBwRn4+t1BTfDLpVy00db8ZWg44IECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIzIHAZU7ffbrWutr5epafznl3N1Kuj2TfHeU4iVHnIJAwqqD2BBomcP3lEj+NqaxX7bLYGrSvMdcw6PCuJ0CAAAECBAgQIECAAAECBAgQIECAAAECBAgQIDArgZOLyFufleXRrApo0rgCCU1aDbUQGIPAh2fMjNjhELsj1COedrsHKce3I46uOQECBAgQIECAAAECBAgQIECAAAECBAgQIECAAIF5FBBKuFk1gYR5vH3VTOARgfEEAvLrdlluDIM9kaMjhilEGwIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIzEMgRf54Xra2nKb2dwfCNGVIgoTFLoRAC4xPoVNVORPp1tB7z96OcJ/NXVW2uRjqMiM9Hq0NrAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAnMpMNTx6HM503uKFkhYpNU0l7kQuAoLXFwcttvt40kVfLNDwZvh+x9+d4TbY44nGDH8LLQkQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgMFuB/LJdljuzrWF2owskzM7eyEsk0Ol0NvJq60WKqL9sPo8U37SLot49YGKf06p7lCKeDTfAaLsj3B6zc97djRQ/DVeHVgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgTmXWB8z97mTUIgYd5WTL1zJXCzQ0AdQvj6g8KnEEjoVNV+RHo+BNjJWdHaGOd5NiPUMkT5mhAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBBolsBF5K8+K8ujZlU1+WoEEiZvbIQlE6iPS1jr9nbf74Zw1/ynEEg4raoXKdJ/BubP8XN7rdgduN0DDW5MDoffsWGc1eiLAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAwNQFxv5S8NRnMMSAAglDoGlC4DGBx45LyBF/nhetrXHuQvBxTZ1udyty/PFYrR/9fGJfhHUo4ZNu7/jqyAofAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAksmMI1nhE0jFUho2oqoZyEE/qqqzdVI/314Mvlluyzr4xwm8umvhg+HzhG/rJfFi4kUFBE3NR0KJUxKWL8ECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQLNFpjsM8KmzV0goWkrop6FEehU1X5Eev7whCb7hdOpunkg0Ivel+12u97FYGKfTlXtRKRfJzaAjgkQIECAAAECBAgQIECAAAECBAgQIECAAAECBAg0WWACR6g3dboCCU1dGXXNvcDf573tlZR/e2wiOfKP62W599h1w/x8sEBC/+GITtWtdzn4epiatCFAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAIH/fLsv9RXcQSFj0FTa/mQr0HwiYzBdO/+NHxAC7IwgkzPS2MjgBAgQIECBAgAABAgQIECBAgAABAgQIECBAgMBCCEzmGWGTaAQSmrQaalk4gdOqe5QinvUzsYvIX31Wlkf9XNvvNf2On1P8vl4U2/32K5DQr5TrCBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECDwksNihBIEEdz+BCQqcVtWLFOk/fQ5xchF5a5yhhL6DAym+aRdFfQxDX5/TqruXIn7o62IXESBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECDwgMDihhIEEtz4BB4QeJPzk096vc2hkXLeiEi/9t8+vz4ris2nKb3tv839V/YTSMgRf66XxUBz7Jx3dyPFT+OoUR8ECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIEll4gx8/ttWJ30RwEEhZtRc1nbAJ/VdXmSqT9fo9cGNfAdUDgvGhtjSOU0E8gISIG3plBIGFcq60fAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAtcC9THr563WzjieEzbFVCChKSuhjkYJdKpqJyLtRcTnsyis/rJZL4rtUcfuM5AQg4YgbnwG2Plh1JloT4AAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQGApBE4uc9r5dK11sAizFUhYhFU0h7EKnFbdvRTxw1g7Haqz/LJdljtDNb1pNMhccsQv62Xxop/xOt3uVuT4o59rXUOAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAwMACryLFbrsoDgdu2aAGAgkNWgylzFbgTc5P1rq9w2kf0fDQrHPkH9fLst6pYajPwEcrpPimny81gYShlkMjAgQIECBAgAABAgQIECBAgAABAgQIECBAgACByQq8isjHEen5ZIeZXu/1Tucp8t5ZURzM41EOAgnTu1eM1GCBmwfs9bYnMzmi4UGaPkMCd/UxcCAh8uuzoth87Mvsr6raXI303wYvqdIIECBAgAABAgQIECBAgAABAgQIECBAgAABAgSWTiB/3y7L/U6nsxErrZ1IuT6m/YtFYajDCRFxmCIfRUrHFzm//awsj27P7+q5Z/3JeSMuLg7b7fbxLOcvkDBLfWM3QuC0ql6kSP9pRDEfFJG/HzXp9Pd5b3sl5d8GmVtO8ft6UWw/1qZTdfNj1/g5AQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAgakJXPS+/PgB/PXzssvtRdo1oV/Ps6L19LEXkfvta9jrBBKGldNu7gWujmjo9fZTjm+bOJmLyF99nGgatM5hj1a4zOm7T9da9Y4R934EEgZdDdcTIECAAAECBAgQIECAAAECBAgQIECAAAECBAhMTiC/bpflxn39188GP+l2t3NK2019PjhOm3o3hfWy2Bxnn8P0JZAwjNoCtam3K5n1Nh2z4KyPHFiJtJ8ins1i/L7GHOGohnf9X21Hs9r6X1/jfXjRSVz0Nh+6NwQShlDVhAABAgQIECBAgAABAgQIECBAgAABAgQIECBAYEIC+WW7LHf66bwOJ5TVxdb1zgmxtUjHOryff46f22vFbj8ek7xGIGGSug3vu3Pe3Y0UP0XEq4vIL0Z9G7/h031fXqeq6rNi9iLi80bXPIZAQj2/EYIDr9plcX3GzB2fTtU9jIivG22oOAIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAgSURyN+3y3J/mMlev8wcW5HS1qLsnjCO3diHsfy4jUDCOBTnrI/7dgfIEb+cF63dWZ8jMknO06q7lyJ+mOQYY+r7pF0WTwbpq17X1ZSu2uScN1O+/udIuQ5gfDFIX++ure+J9bJ4cVdbgYRhRLUhQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBCYjEB+GTkdX/W9Eoftoqhfrh3q82FAIW8O+6xtqMHH02jgZ43jGfbfvQgkTEq2of3e2hXhvgpPIsfeWdnaW6RgwvWZML2DuXmjP8fPFykf3BUwyCuxmXK8CyvU575MeKeHu9NkAgkN/UOuLAIECBAgQIAAAQIECBAgQIAAAQIECBAgQIDAkgvkiD/Xy6J+jjaWT31M+uVKsbkSeTNSfcRD3mh2SKH/4yvGAvRAJwIJkxZuSP/1H5JYbdVblPS7xf7CBBOudg6IVCegJvzgviGLPZEy/h1KmKPdJiYiolMCBAgQIECAAAECBAgQIECAAAECBAgQIECAAIEmC+SXZ0XxYlIvYV+9EN3rbdY7l0ekjRSx2ZygwvDHV4x7RQUSxi3awP7+Pu9tr6RchxGGeSA/18GETlXVxxX82sBlmcOSPvzi6mO3jTmco5IJECBAgAABAgQIECBAgAABAgQIECBAgAABAgQWRaDeKeEy8s5nZXk0zTl1ut2ty8v0pN5RIad4Mu2wwlnRejqpIMagjgIJg4rN0fV1Kmet29tNET+Mp+z88iJib9p/YIep/fqIhu5eRHo+THtt7hHI8XN7rditfyqQ4C4hQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBCYB4Ec8ct50dptwkP6q53tW62NjwMLOa6CC89G9Rz3cRWj1iOQMKpgQ9vXxxSsRNofx0378RTrmzhF3jsrioMm/KH9uL76D3FebR1MYu4NXe5pl/UqLno7sbq6ZfeJadMbjwABAgQIECBAgAABAgQIECBAgAABAgQIECBAYEiBkxyxny56e+12+3jIPqbSrN5hoR6oPg4i5fQkr8RmyvEkro6FeGRX/FsvGE+l2EcGEUhowiqMuYabYwr2Hr0ZRx/3JCIfNGnXhKs/nDkOpjD30fXmu4eTnOIw5fh2vqehegIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAgeUTyC8jpf12URzO49zrl9NXU3oSl3EVXIhU//+8EZG+uIj8VZN2vBdImMc77J6aZ3tMQX6dI/bSxcXBrBJFp1X1IkX6zwItqakQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIDAxgdk/45zY1BrSsUBCQxZi1DKuUjBR7wyQvhi1r1Hb5xS/p5wPpnWkw2yDGKNqaU+AAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAwKwF3j3jbJfl/qxrWaTxBRIWYDU7593dSPFTA6dydaTDJLc76XQ6G3m1dZAinjVw/koiQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQGC+BBp3bP188X1YrUDCHK9e/TA+Vlt1Qufr5k8jv46c9uOytz+uIx063e5W5HpXiPi8+fNXIQECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAEC8yUw/mec8zX/0asVSBjdcCY9nFbVixRpdx4fxo9ju5NOVe1EpF9ngm9QAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgSWSiBH/Jki703r2PpFwRVImLOV/KuqNlcj7c3HrgiP4p5Ejr1Bd03oVNV+RHr+aO8uIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAwNgF8stJHls/9nJn2KFAwgzxBxn6Tc5P1rq93RTxwyDt5ufax//Q3hgcpohn8zMvlRIgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgsJgCjnR4bF0FEh4TasDPO+fd3UjxYh6PZxiC71VE3m+X5f7ttvXOECuR9oURhhDVhAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgACBCQs8/gL2hAtoZPcCCY1cluuiOlW1ExG7EemLBpc5odLy63rudTDh5piKwyUJZEzIU7cECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECExaIEf8mSLvffwC9qTHbWr/AgkNXJnlDiJ8vCB1MCE9EUZo4I2qJAIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIE7hG4Ps7hrGztPU3p7bIyCSQ0ZOXf5Pzkk6r3YomOZmiIvDIIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECAwMYGTyLG3rMEEgYSJ3Vf9dXx9HEG8iEjP+2vhKgIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBCYM4GTHHl3vSz35qzukcoVSBiJb7jGV7shdLvbOdKLFPFsuF60IkCAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAIH5EsivL/PKi0/XWgfzVfdw1QokDOc2VKu/z3vbK+ly224IQ/FpRIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAgUUReBUXvZ12u328KBO6ax4CCVNa3dOqe2Q3hClhG4YAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQLNF1j4YxwEEqZ0E3bOu7uR4qcpDWcYAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIEJgDgZzi9/NWa+dpSm/noNyBShRIGIhr+Ivf5Pzkk27vzfA9aEmAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECiyiQI/68jLzzWVkeLdL8BBKmuJqdqtqPSM+nOKShCBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQGA+BE4uIm8tUihBIGGKN16n09mI1db/pjikoQgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIEBgfgQWKpQgkDDlG69TdQ8j4uspD2s4AgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIEJgPgYUJJQgkTPmG+/u8t72S8m9THtZwBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIDA/Aidx0dtst9vH81PyvysVSJjB6nWq6jgifTGDoQ1JgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAs0XODkrWhtPU3rb/FLvr1AgYQar1znv7kaKn2YwtCEJECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAoOECOeKX9bJ40fAyHy1PIOFRovFf0Ol0NmK19b/x96xHAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIEJh7gYvel/N+XEO9BgIJM7oTT7vdg5Tj2xkNb1gCBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQaKBAjvhzvSw2G1jawCUJJAxMNp4GnaraiUi/jqc3vRAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIDAggi8apfF1iLMRSBhRqv4Jucnn3R7xxHx+YxKMCwBAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQINEwgp/h9vSi2G1bWUOUIJAzFNp5Gnaraj0jPx9ObXggQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIEBgzgVOLnPa+XStdTDn87gqXyBhhqv493lveyXl32ZYgqEJECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAoBkCr+Kit9Nut+ud9hfiI5Aw42XsVNVxRPpixmUYngABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgRmI3CSI++ul+XebIaf3KgCCZOz7avn06q7lyJ+6OtiFxEgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIDA2AVyxJ8pYiMiPh975w93uHC7ItyerkDClO+mj4f7q6o2VyP9d8ZlGJ4AAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQLLK5Dim3ZRHL7J+cknvd7mFcRlbN0GySuxmXI8uflv9TWjhBcWdleE22YCCQ34I+XYhgYsghIIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIEFhegZtAwiAAdXihrC62VtLldkR6PkDbhd4V4baDQMIAd8WkLj2tqhcp0n8m1b9+CRAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQOABgSECCbd763Q6G7Ha2o+Irx8YZSl2Rbg9f4GEBvypu7k5/9eAUpRAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgACB5RMYMZDwDqxz3t2NFD/dAbg0uyLcnrtAQkP+KJ1W3aMU8awh5Shj7AL5deRUJ6KuP+nD82YeSUqNvRodEiBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECDwj0CO+DNFvP3YJKd4u14U24NYdapqJyL9etNm6XZFuG0lkDDInTPBax3bMEHcBnSdI/+4XpZ7/ZbS6Xa3Prj28qMAg0BDv5SuI0CAAAECBAgQIECAAAECBAgQIECAAAECBAgQIDCSwKDP+urBTqvuXorYjIveTrvdPh6pgDluLJDQkMV7k/OTT7q9Nw0pRxnjFTg5K1obT1P6V6JqvMNEXN9H3TqhtRWR6v//+bjH0B8BAgQIECBAgAABAgQIECBAgAABAgQIECBAgACBJRM4uYi89VlZHi3ZvEeerkDCyITj6+C02z1IOb4dX496aoZAftkuy51Z1FLvtJBzbKfI2xHpi1nUYEwCBAgQIECAAAECBAgQIECAAAECBAgQIECAAAEC8y5QH+lwXrS2pvES8rxb3a5fIKFBq/nRWSINqkwpIwlc9L5swjYsnU5nI6+ubkdKW4IvI62oxgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAksoIJQw+KILJAxuNtEWnapbb+tvm/2JKk+181ftstia6oh9Dvb3eW87pVzXtpUinvXZzGUECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIEllagDiVcRt5xfEN/t4BAQn9OU7uqU1X7Een51AY00EQFLnP67tO11sFEBxlD5/XuCbG6ehVOuP4/xzuMgVUXBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECiyqQ4+ezsrXnCIeHF1ggoWF/ADrd7lbk+KNhZSlnKIH8ul2WG0M1nXGjv6pqc6UOJlwf71CHFOzaMeM1MTwBAgQIECBAgAABAgQIECBAgAABAgQIECBAgEDTBPLriNhtl+V+0yprSj0CCU1ZiVt1dKrq2BvqDVyYAUvKkX9cL8u9AZs18vJ3AYUUsWkHhUYu0QNF1b8I03FEfD1vlauXAAECBAgQIECAAAECBAgQIECAAAECBAgQIDAfAoIJ962TQEID7+DTqnqRIv2ngaUpqX+Bk7OitbGoW7TURzxcrhSbKeWtm5CCh9393xtTvDK/PCuKF/V92KmqnTqhJ+w0RX5DESBAgAABAgQIECBAgAABAgQIECBAgAABAkslkCP+TBe97Xa7Xb8sevV5k/OTRX1m2M/iCiT0ozTla+qHvbHa+t+Uh12E4U5yisN0GUexEocXOb/9rCyPbk+sPhLj8jI9WYm8GenqKIIJPUjPL9tlWT8AXprP+2MeIm0IKXyw7CcRcRSRjyOn4/revPppjoMJHoVxEpFf3LU90PWxMLm+N7eEE5bmj6eJEiBAgAABAgQIECBAgAABAgQIECBAgAABAtMTOLmIvPXuOeXVs5le7/h2SGF6pcx+JIGE2a/BnRWcdrsHKce3DS2vYWXll5d55eDTtVb9gHfgz9/nve2VdLkdkZ4P3PifBieRY69+2JxzbKeL3t6yfqncNqxDCimvbNQBkLwSm5GjDis8G8G5yU1f5RRvrwIxKR9HSsdnrdbRfYm3Ce6E8sEvucfArgJQrdbGB9ddxla9Xr6DHtPzcwIECBAgQIAAAQIECBAgQIAAAQIECBAgQIDA1fHZTz56EfXDUEJV7dz1Iuky2AkkNHSVrx+S598aWl4TyroKAJyVrb1xbXFSb5ey1u3upIgXA745PtAD4CbgzbqGOqiwmtKTuLzapSJudquo/2lCO1aMPOObXQ6udja42uHgMtLRykp++1Do4LFRO1V1POC99mCX9TZA50Vra1x/JurBro96SPWOCk1dm8eY/ZwAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgMCmB988J3+8mntJWyrGVI47Xy2Lz6nnLEu+SIJAwqVtvDP2O+2HlGEpqRBeTeOj68cSuH8LGbj8Pi3PkH9fLcq8ROAtSxPvAQj2fd6GFOgtw/dZ+nTC7/am/yD/vb+pXCbX3Z/bUbd7vanDTwbugQf2vo4QN+qlnzLskTDQYc33Uw0SPmeiHzDUECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAgQYJ5O/v2/mgft51+3j5+uXocb5U2iCEB0sRSGjwSo35YWWDZzpwaa/aZXH9Zv2EP48HE/Lrdll+uN39hGvS/eIIXB2XsNr63zhmdJnTd8MeW9Lv+De7Jfza7/WuI0CAAAECBAgQIECAAAECBAgQIECAAAECBAgsqMBJpNhuF8XVzto+9wsIJDT47qhTMp90e/Xb3H2+/d3gyYyxtJzi9/Wi2B5jl492dV8wwe4Ij9K54BGB06p7lCKejQg1xZBOt/7F6viGERdMcwIECBAgQIAAAQIECBAgQIAAAQIECBAgQGA+BXLEL+dFa3cZdzsYZsUEEoZRm2Kb06q7lyJ+mOKQzR8qx8/ttWJ32oVeBUSq3otI8eJ9SOSi92W73f7gCIBp12W8+RYYy04oKb6ZVgLPLgnzfb+pngABAgQIECBAgAABAgQIECBAgAABAgQIzK1Ajp//Od47b/Rz9Pq45lofKR+R98+LYl8QYTBVgYTBvKZ+9Ti3dJ968ZMacIoPX++awvXOFd29HGlzvSw2JzVN/S6HQH1+0Gqk/w4/2+keG3Kzc8ub4evVkgABAgQIECBAgAABAgQIECBAgAABAgQIECAwuEC7LO58tt3pdq+Pes95I3K6Omr9n+BCRI540u9u1XXwIEW8jcjHkdNxrMThWat1JIQw+Hq9ayGQMLzd1Fp2qmo/Ij2f2oANH+i+L5uGl608AvcKdKpuHpan3hZovSzqXTum9hnTMRNTq9dABAgQIECAAAECBAgQ6aKYiAAAIABJREFUIECAAAECBAgQIECAwPwLeEY4n2sokDAH62aXhH8WKaf4fb0otudg2ZRIoG+BTtU9jIiv+25w68LLnL77dK11MEzbYduMUu+wY2pHgAABAgQIECBAgAABAgQIECBAgAABAgQILLeAQMJ8rr9Awpysm10SrhdqFg9f5+QWUeYcC3TOu7uR4qdhpnBWtJ5Oe5ugUeodZo7aECBAgAABAgQIECBAgAABAgQIECBAgAABAgQEEubzHhBImJN1s0tCvVD5dbssr8598SHQVIG/z3vbg+5Y0KmqnYj06xBzOmmXxZNhxhxirPdNBBJG0dOWAAECBAgQIECAAAECBAgQIECAAAECBAgQGEZAIGEYtdm3EUiY/Rr0XcHSPwTM8XN7rdjtG8yFBGYgUIcL2mW5f9/QnW536+OfXeT8djXSf4co91W7LLYeG3OIfh9ssvTfReMG1R8BAgQIECBAgAABAgQIECBAgAABAgQIECDwqIBAwqNEjbxAIKGRy3J3UW9yfvJJt3ccEZ/PUdnjKvXkrGhtTHtr+nEVr5/lEaj/nJbVxdZ9uyTc9TC//gXaqbr530r5dUSq/8zffPJGRPri/b+l+H29KLYfG3Pc+gIJ4xbVHwECBAgQIECAAAECBAgQIECAAAECBAgQ+FAgR/yZUrzIOfZSxDM+EQIJ83kXCCTM2bqNsLX7nM3043Lz9w+9dT7nk1P+ggn8VVWbn5Xl0X3TOq26e/XPck6HK5E3650/Tqvu0c1fKE5yxH666O212+1bYYTr3q6CSb3eZs55M6V01C6Kw/q/PzbmOIkFEsapqS8CBAgQIECAAAECBAgQIECAAAECBAgQIPChQB1GOC9aW/WLuvVzgbVebz/l+JZTfpkjjtLFxcFdz1D4NFNAIKGZ6/JgVZ2qWz+A/HoOSx+q5PpLd70sNodqrBGBORG4/nOdj8+K4kXTdwL5+7y3vZLyb3NCq0wCBAgQIECAAAECBAgQIECAAAECBAgQIDA3ArfDCLeLrl92TBE/zM1EJlzo1Q4Skfe80Dxh6DF0L5AwBsRpd9HpdDZitVW/fb0URzdcRP7qobfNp+1vPALLLtDpdrcixx/L7mD+BAgQIECAAAECBAgQIECAAAECBAgQIEBgnAL3hRHejbG8O6nfr1ybXUbe8SxxnHfiePsSSBiv59R6W5Y3lHPkH9fL8mp7ex8CBJohUB8PsRpp1D+XS7PLSzNWTRUECBAgQIAAAQIECBAgQIAAAQIECBAg0GyB/PqsKDYf20X55hnh/rK8uNz/mjn+vX+r6V4pkDBd77GOtvjnuOeX7bLcGSuazggQaITA4n9/NYJZEQQIECBAgAABAgQIECBAgAABAgQIECAwJwI5xe/rRbHdT7k3Lw7WR7wvxW7q/ZhcXyOU0L/V9K4USJie9URG6lTVfkR6PpHOZ9jpY1vSzLA0QxMgMAaBNzk/+aTbO/aXpTFg6oIAAQIECBAgQIAAAQIECBAgQIAAAQIEFkHgVbsstvqdiFDCfVJCCf3eQ9O6TiBhWtITHGfRQgnCCBO8WXRNoEECi/bd1SBapRAgQIAAAQIECBAgQIAAAQIECBAgQIDA/AkMFEiopyeUcOcin8RFb7PdbtcvRfo0QEAgoQGLMI4SFujBni+JcdwQ+iAwBwI351z9NgelKpEAAQIECBAgQIAAAQIECBAgQIAAAQIECExcoF0WAz+7FUq4c1kGDndMfHGXeICBb+oltmr81DtVtRORfm18ofcUaGeEeV05dRMYTuDm2IY3w7XWigABAgQIECBAgAABAgQIECBAgAABAgQILJbAReSvPivLo0FnJZRwl5ijGwa9jyZ1vUDCpGRn1G+n6h5GxNczGn7oYYURhqbTkMBcC3Sqbp7rCSieAAECBAgQIECAAAECBAgQIECAAAECBAiMSyDHz+21YneY7oQSPlbLr8+KYvNpSm+H8dRmfAICCeOzbERPnU5nI1ZbdXLq80YU1FcR+eVZUbzwhdAXlosILJSAQMJCLafJECBAgAABAgQIECBAgAABAgQIECBAgMBIAvl1uyw3hu1i3ndTH3be97YbIeAx9lqWuEOBhAVc/Dk6l/0kR95dL8u9BVwGUyJAoA8BgYQ+kFxCgAABAgQIECBAgAABAgQIECBAgAABAssjkOKbdlHUO6IP9RFK+IDt5KxobXgpeqhbaWyNBBLGRtmsjpr+ZVMf0XAZeWeYc3CaJa0aAgRGERBIGEVPWwIECBAgQIAAAQIECBAgQIAAAQIECBBYPIH8sl2WO6PMq1NV+xHp+Sh9LExbuyTMfCkFEma+BJMr4LSqXqRI/5ncCEP1fBI59oY9/2aoETUiQKCxAgIJjV0ahREgQIAAAQIECBAgQIAAAQIECBAgQIDArAQuel+22+3jUYY/7XYPUo5vR+ljQdqexEVvc1TPBbGYyTQEEmbCPr1Bm7VTQn4ZFxe7/sBPb/2NRKDJAp1udyty/NHkGtVGgAABAgQIECBAgAABAgQIECBAgAABAgSmLzD6Lglvcn6y1u0dpohn06+/aSOO7tm0Gc1TPQIJ87RaQ9Z689DvICI+H7KLUZu9ihS7o5x3M2oB2hMg0DyBhu7i0jwoFREgQIAAAQIECBAgQIAAAQIECBAgQIDA8gmk+GbUZ2udTmcjVltHM3xG2Jx1G8OuE82ZzHxVIpAwX+s1dLU3KajdFPHD0J0M3DC/vIjY+6ws6y86HwIECHwgYLsoNwQBAgQIECBAgAABAgQIECBAgAABAgQIELhX4FW7LLZG9bFb8XvBsXiOuh7L2F4gYclW/ToJtbobkZ5PYuo54s+IvH9eFPtPU3o7iTH0SYDAYgh0qm79HTGrnVsWA9EsCBAgQIAAAQIECBAgQIAAAQIECBAgQGCBBfL37bLcH3WCzTrifdTZDN/+MqfvPl1r1bvK+0xRQCBhithNGqoOJuTV1e2ItDPi2TEnOcVh5HyYLi4O2u32cZPmqRYCBJop4C8/zVwXVREgQIAAAQIECBAgQOD/s3fHSXEc2R6oT4quQoX1QtIKzKzAzAqEV2C8AuN4CzCzAuMVWLMCoxUYr8Ao4v0/eAUXrUAiwlaL6oZ8UUiyZRlJDVR3V3V9HXHj3jFVmed8WZ4L3b/OJECAAAECBAgQINApgdNXxWizjS8Bj+v6YF5fWO6U2MeLac2zRz0vvVSBhKUvwfILaI5zKOvz7TuRt/Kd2Eo5HuSIB+8GFZqdD1LE6x0PchxFyifnEceOY1j++qmAQB8FxvXkKCIe9bF2NRMgQIAAAQIECBAgQIAAAQIECBAgQIAAgUUJ5BS/bBTFThvzvawnx7f8onIbZSx1jDY9l9pIjyYXSOjRYimVAAECqyDgvKpVWEU9ECBAgAABAgQIECBAgAABAgQIECBAgMCiBNo6aqD5kvLdybTZ7Xyoxymfnkfe9oXrRT25r+cRSFist9kIECAweAEJzME/AgAIECBAgAABAgQIECBAgAABAgQIECBA4HoCp3E+3Wrj6PTf63prLdL/rjf9SlwtjLCkZRRIWBK8aQkQIDBEgfHZZD9SfD/E3vVMgAABAgQIECBAgAABAgQIECBAgAABAgRuIfC0KovtW9z/563jut6NSD+1MVYfxmiOpj8rRtsPU3p9PL3XQgUEEhbKbTICBAgMV2Bov+AMd6V1ToAAAQIECBAgQIAAAQIECBAgQIAAAQJzEcjxQ7Ve7Lcx9riuDyLSN22M1eUxhBGWvzoCCctfAxUQIEBg5QXGk8l25Ph15RvVIAECBAgQIECAAAECBAgQIECAAAECBAgQmKPARU5ff7Y+OmxjitU/Yjk/qcpytw0rY9xcQCDh5nbuJECAAIEZBcb15CgiHs14ucsIECBAgAABAgQIECBAgAABAgQIECBAgACBqwVOzyNv3yvL49sCPc/5wd3J5DgifX7bsTp2/2lE3qvK8qBjdQ2yHIGEQS67pgkQILA4AUc1LM7aTAQIECBAgAABAgQIECBAgAABAgQIECCw+gJtHkPwe11vrUVqvlR4fxXkGpuLyLttBDZWwaMLPQgkdGEV1ECAAIEVFVi1X2RWdJm0RYAAAQIECBAgQIAAAQIECBAgQIAAAQI9E8gpftkoip02yv7jbLpzJ+Wf2xhrqWPk+KFaL/aXWoPJ/yEgkOChIECAAIG5CAgjzIXVoAQIECBAgAABAgQIECBAgAABAgQIECBA4FIgR/x3oyz22uB4Wdd7KdKPbYy1hDGenkfesyvCEuRnmFIgYQYklxAgQIDA9QSEEa7n5WoCBAgQIECAAAECBAgQIECAAAECBAgQIHAzgfxtVZYHN7v373eN6/ogIn3TxliLGSM/i4j9tvpfTM3Dm0UgYXhrrmMCBAjMVUAYYa68BidAgAABAgQIECBAgAABAgQIECBAgAABAn8TuMjp68/WR4dtsIzryVFEPGpjrPmNIYgwP9v2RxZIaN/UiAQIEBiswPOcH9ydTI4j0ueDRdA4AQIECBAgQIAAAQIECBAgQIAAAQIECBBYrMDpeeTtNo4saN7nX59Mj1LEF4ttYZbZBBFmUeraNQIJXVsR9RAgQKDHAi8nk8OU46set6B0AgQIECBAgAABAgQIECBAgAABAgQIECDQR4EVDiXkJ5HSQVUUze4NXj0TEEjo2YIplwABAl0W6MdWTl0WVBsBAgQIECBAgAABAgQIECBAgAABAgQIELixwOmrYrT5MKUXNx7hzY3LPp45p/gl5Xz4qigO2+jnth7uv7mAQMLN7dxJgAABAu8JjOt6NyL9BIYAAQIECBAgQIAAAQIECBAgQIAAAQIECBBYvECO+O2sGG238SH+gkMJpznFkRDC4p+Zec8okDBvYeMTIEBgYALjyWQ7chxGxP2Bta5dAgQIECBAgAABAgQIECBAgAABAgQIECCwdIEehRKeRo6juBNHjmNY+mMztwIEEuZGa2ACBAgMV2DBqcnhQuucAAECBAgQIECAAAECBAgQIECAAAECBAhcIdBmKOGPs+nOnZR/vg10U0+KfJwjji8iju6V5fFtxnNvfwQEEvqzViolQIBAJwVe1pPHKWLrbXHNLxNnxWi/+c93p9M//3nkvBkR+xHp8042oigCBAgQIECAAAECBAgQIECAAAECBAgQILBCAm2GEq5xZPNpRFwGDyLySUrp2O4HK/RQ3aAVgYQboLmFAAECBP4SeJ7zg7uTyeOI9E3k+KFaLy7DCFe9XtaT4xTxBT8CBAgQIECAAAECBAgQIECAAAECBAgQIEBg/gJzDCU8zSlepIs4jpRPIqWTV6PR8cOUXsy/KzP0SUAgoU+rpVYCBAh0WGA8mWx/KuU4rie5wy0ojQABAgQIECBAgAABAgQIECBAgAABAgQIrJxAm6GElcPR0NwFBBLmTmwCAgQIrJbAeDzePF9be3CT850EElbrWdANAQIECBAgQIAAAQIECBAgQIAAAQIECPRDQCihH+u0ilUKJKziquqJAAECcxRodkKIHIfnkbevE0r4va631iL9b46lGZoAAQIECBAgQIAAAQIECBAgQIAAAQIECBD4gIBQgkdjGQICCctQNycBAgR6LPAmkPBrRJxeJ5Twzn097l7pBAgQIECAAAECBAgQIECAAAECBAgQIECgvwJCCf1du75WLpDQ15VTNwECBJYk8F6wYOZQwh9n0507Kf+8pLJNS4AAAQIECBAgQIAAAQIECBAgQIAAAQIECESEUILHYJECAgmL1DYXAQIEVkDgip0OZgoljM8m+5Hi+xUg0AIBAgQIECBAgAABAgQIECBAgAABAgQIEOi1gFBCr5evV8ULJPRquRRLgACB5QuMx+PNuDPafbeSnPKLjbJ8/LHqBBKWv3YqIECAAAECBAgQIECAAAECBAgQIECAAAECfwnkZ+cRO/fK8pgKgXkJCCTMS9a4BAgQIPA3gXFdH0Skb7AQIECAAAECBAgQIECAAAECBAgQIECAAAECnRGYaRfkzlSrkN4JCCT0bskUTIAAgX4KjOvJUUQ86mf1qiZAgAABAgQIECBAgAABAgQIECBAgAABAisrIJSwsku7/MYEEpa/BiogQIDAIAQEEgaxzJokQIAAAQIECBAgQIAAAQIECBAgQIAAgX4KnEbkvaosD94v//e63nKsQz8XtQtVCyR0YRXUQIAAgQEIjOvJi4i4P4BWtUiAAAECBAgQIECAAAECBAgQIECAAAECBHoqkL99P5Qwruvdq4IKPW1Q2QsWEEhYMLjpCBAgMFSBcT3JQ+1d3wQIECBAgAABAgQIECBAgAABAgQIECBAoDcCOX6o1ov9t/WOx+PNGI02q6Jojmb2InAtAYGEa3G5mAABAgRuKiCQcFM59xEgQIAAAQIECBAgQIAAAQIECBAgQIAAgUUL5CdVWe6+ndUuCYv2X535BBJWZy11QoAAgc4KjCeT7cjxa2cLVBgBAgQIECBAgAABAgQIECBAgAABAgQIECDwvsDTV8Vo52FKzZHMXgRuJCCQcCM2NxEgQIDAdQQEEq6j5VoCBAgQIECAAAECBAgQIECAAAECBAgQGIjA08gx2zEIKW9GpM3XLpf/9+eLMMoRv50Vo22hhEVor+YcAgmrua66IkCAQKcEBBI6tRyKIUCAAAECBAgQIECAAAECBAgQIECAAIEuCOT4oVov9m9ayvOcH9ydTrci583IaTNSbM8prHB6Hnn7Xlke37RW9w1XQCBhuGuvcwIECCxMYHw22Y8U3y9sQhMRIECAAAECBAgQIECAAAECBAgQIECAAIGuC9wykPCh9v4MKlzE9uuQQjxqgeI0Iu9VZXnQwliGGJCAQMKAFlurBAgQWJaAQMKy5M1LgAABAgQIECBAgAABAgQIECBAgAABAp0VmFMg4ap+L3cybiGgcJHT15+tjw47a6qwzgkIJHRuSRREgACB1RMQSFi9NdURAQIECBAgQIAAAQIECBAgQIAAAQIECNxSYIGBhPcr/eNsupNSbnZP2E4RX8zSSY747awYbT9M6cUs17uGQCMgkOA5IECAAIG5C4zryVFLW0LNvVYTECBAgAABAgQIECBAgAABAgQIECBAgACBhQgsMZDwbn/j8Xgz1tYuwwmv/yd9/n7/wggLeSJWchKBhJVcVk0RIECgWwICCd1aD9UQIECAAAECBAgQIECAAAECBAgQIECAwPIFcsR/N8pib/mV/L2C9wMKOdILOyN0bZX6U49AQn/WSqUECBDorYBAQm+XTuEECBAgQIAAAQIECBAgQIAAAQIECBAgMF+BpxH5oCrLg/lOY3QCyxEQSFiOu1kJECAwKIFxPWnOk7o/qKY1S4AAAQIECBAgQIAAAQIECBAgQIAAAQIEZhbIzyKng1fl6PHDlJr31L0IrISAQMJKLKMmCBAg0G2BcT3J3a5QdQQIECBAgAABAgQIECBAgAABAgQIECBAoCsC+cl5xON7ZXnclYrUQeCmAgIJN5VzHwECBAjMLCCQMDOVCwkQIECAAAECBAgQIECAAAECBAgQIECAwFuBp5FivyqKIyQE+iogkNDXlVM3AQIEeiLwe11vrUX6X0/KVSYBAgQIECBAgAABAgQIECBAgAABAgQIEOiUQE7xy9lotOsoh04ti2JmFBBImBHKZQQIECBwM4HxZLIdOX692d3uIkCAAAECBAgQIECAAAECBAgQIECAAAECBHLEb2fFaFsowbPQNwGBhL6tmHoJECDQMwGBhJ4tmHIJECBAgAABAgQIECBAgAABAgQIECBAoKsCT6uy2O5qceoicJWAQILnggABAgTmKvCyrvdSpB/nOonBCRAgQIAAAQIECBAgQIAAAQIECBAgQIDAAAQucvr6s/XR4QBa1eKKCAgkrMhCaoMAAQJdFRifTfYjxfddrU9dBAgQIECAAAECBAgQIECAAAECBAgQIECgRwJ2SejRYik1QiDBU0CAAAECcxUQSJgrr8EJECBAgAABAgQIECBAgAABAgQIECBAYGACr4rRw4cpvRhY29rtqYBAQk8XTtkECBDoi8C4rg8i0jd9qVedBAgQIECAAAECBAgQIECAAAECBAgQIECgywKObejy6qjtfQGBBM8EAQIECMxVYFxPjiLi0VwnMTgBAgQIECBAgAABAgQIECBAgAABAgQIEBiKQI4fqvVifyjt6rPfAgIJ/V4/1RMgQKDzAgIJnV8iBRIgQIAAAQIECBAgQIAAAQIECBAgQIBAjwRyil82imKnRyUrdcACAgkDXnytEyBAYBECL+vJcYr4YhFzmYMAAQIECBAgQIAAAQIECBAgQIAAAQIECAxA4GlVFtsD6FOLKyAgkLACi6gFAgQIdFlgXE9yl+tTGwECBAgQIECAAAECBAgQIECAAAECBAgQ6JNAjvhtoyy2+lSzWocrIJAw3LXXOQECBBYiIJCwEGaTECBAgAABAgQIECBAgAABAgQIECBAgMCABKqy8DnvgNa7z616UPu8emonQIBADwQEEnqwSEokQIAAAQIECBAgQIAAAQIECBAgQIAAgd4I5Ij/bpTFXm8KVuigBQQSBr38midAgMB8BcaTyXbk+HW+sxidAAECBAgQIECAAAECBAgQIECAAAECBAgMRSA/e1UUWw9TetGXjsdnk/1/1HoxPaiq6qQvPajz5gICCTe3cycBAgQIfEJAIMEjQoAAAQIECBAgQIAAAQIECBAgQIAAAQIEWhRI8WVVFEctjjjXof44m+7cSfnnf0zSsz7mirTigwskrPgCa48AAQLLFBBIWKa+uQkQIECAAAECBAgQIECAAAECBAgQIEBglQT6eFTDuK4PItI3Agmr9CRerxeBhOt5uZoAAQIEriHwsq73UqQfr3GLSwkQIECAAAECBAgQIECAAAECBAgQIECAwEoI5IjfUsSLyPHhHQ1S3oxIm+82nCMepIgv3kN4+qoY7fTpqIam/nE9aY6WuP+PBbVDwko847M0IZAwi5JrCBAgQOBGApfnQqX4/kY3u4kAAQIECBAgQIAAAQIECBAgQIAAAQIECPROID+5yHcOP1sfHfau9JYL/uBxDc08Agkta3d3OIGE7q6NyggQINB7AYGE3i+hBggQIECAAAECBAgQIECAAAECBAgQIEBgBoGc4pc0ne5VVXUyw+WDuKQ51jlH7KUc2//YJUEgYRDPQNOkQMJgllqjBAgQWLzAB8+GWnwpZiRAgAABAgQIECBAgAABAgQIECBAgAABAnMRyJH/s1GWj+cy+IoM+ntdb92J2I6Uti8DCil2qqL48FEWK9K3NgQSPAMECBAgMEeBcT1pfpl4NMcpDN26QH4S0Zxnlppfnv95rlfr8xmQAAECBAgQIECAAAECBAgQIECAAAECfRbI31ZledDnDtROYJ4CdkiYp66xCRAgMHABgYTePACnEfkwzs/3324n1qRV1yI1gRKhhN4so0IJECBAgAABAgQIECBAgAABAgQIEFikgJ0RFqltrr4KCCT0deXUTYAAgR4IvKwnxyniix6UOtQSTyPH41fl6PHDlF68jyCUMNTHQt8ECBAgQIAAAQIECBAgQIAAAQIECMwg8LQqi+0ZrnMJgUELCCQMevk1T4AAgfkKjOtJnu8MRr+ZQH4WEfuzbCP2cjI5TDm+utk87iJAgAABAgQIECBAgAABAgQIECBAgMCKCpxP//V2x9kV7VBbBFoREEhohdEgBAgQIHCVgEBC156L2YMITeXjs8l+pPi+a12ohwABAgQIECBAgAABAgQIECBAgAABAssVyE+qstxdbg1mJ9APAYGEfqyTKgkQINBLgdsGEnLEbyny4zg/P4q10f/1EqETRV8viNCUPK7r3Yj0UyfKVwQBAgQIECBAgAABAgQIECBAgAABAgS6JGB3hC6thlo6LiCQ0PEFUh4BAgT6KjCeTLYjx683rP9ppNiviuLo7f3jevIiIu7fcLyh3naaI+9vlOXj6wD8Xtdba5Eae97XgXMtAQIECBAgQIAAAQIECBAgQIAAAQIrL5BT/LJRFDsr36gGCbQkIJDQEqRhCBAgQODvAjcMJJxG5L2qLA/e9xzXk+YD8kecZxPIEf89K0b7D1Nqghwzv57n/ODuZHoijDAzmQsJECBAgAABAgQIECBAgAABAgQIEBiUQP72qvewB0WgWQLXEBBIuAaWSwkQIEBgdoHrBhIuj2c4n+5UVdV8GP6P1/hssh8pvp+9gmFeeemYYu/d3SVmlWjCCOuT6VGK+GLWe1xHgAABAgQIECBAgAABAgQIECBAgACBAQo8fVWMdq77hbABOmmZQAgkeAgIECBAYC4C47rejUg/zTJ4s8XV2Wi0+7Ff3q4z3ixzruI1N90V4a3FuK4PItI3q2ijJwIECBAgQIAAAQIECBAgQIAAAQIECLQs8LQqi+2WxzQcgZUTEEhYuSXVEAECBLohMOuOBs03+jfKYutTVV93x4VPjbdiP//gURez9jnres06nusIECBAgAABAgQIECBAgAABAgQIECCw6gLnkf99ryyPV71P/RG4jYBAwm303EuAAAECHxT442y6cyflnz9OlJ+9KoqtWbe1GteTjPwfAqfnkbdv80uv3Sc8VQQIECBAgAABAgQIECBAgAABAgQIELiBQI4fqvVi/wZ3uoXAYAQEEgaz1BolQIDA4gU++UF3ii+rojiatbJxXZ9EpM9nvX4A190+jDAeb8baqEnw3h+AlxYJECBAgAABAgQIECBAgAABAgQIECDQokB+UpXlbosDGorAygkIJKzckmqIAAEC3RL4cCjh+r+ojetJE1541K0Ol1fNRU5ff7Y+OrxNBc9zfrA+mR6liC9uM457CRAgQIAAAQIECBAgQIAAAQIECBAgMECBp1VZbA+wby0TmFlAIGFmKhcSIECAwE0FrgwlnE//VVXVyXXGfFlPHqeI765zT1+uzRG/XS8UcP0KX6V/AAAgAElEQVRAx4csxpPJduT4tS9W6iRAgAABAgQIECBAgAABAgQIECBAgEA3BNp7n7Yb/aiCQPsCAgntmxqRAAECBK4QeDeU0Hz4vlEWW9eFelnXeynSj9e9rw/XvypGD+++evUgr432UkSzxdfHj1C4QaDjYw4v68nx9QIRfVBVIwECBAgQIECAAAECBAgQIECAAAECBOYokOOHar3Yn+MMhibQewGBhN4voQYIECDQH4G3oYQc+T8bZfn4upWv6jf5c4pfNopi561Hc4zC3cmk+c/7EenzK5xutQ3YH2fTnbpcO3qY0ou3Y4/r+iAifXPdNXE9AQIECBAgQIAAAQIECBAgQIAAAQIEhipw0/e6h+ql72EKCCQMc911TYAAgaUJNKGE84jje2V5/LEixuPxZoxGm2+vqYri6PUH9dPnSyt+bhPnb6uyPLhq+CaEkSP2Uo6v/vx5C6nbZh3en/NtECJHanZp+GJu7RqYAAECBAgQIECAAAECBAgQIECAAAECqyCQ4svmvevbtNK8F/7q7t0X736B7DbjuZdA1wQEErq2IuohQIAAgY8KjOtJXi2i/Kwqyz+DFx/qrfml9M/jHHI8vu02YFftkvB27vHZZD9SfL9azrohQIAAAQIECBAgQIAAAQIECBAgQIBAuwJVWbTyWetVXyBrt1KjEVieQCv/kiyvfDMTIECAwNAExvWkSZs+Wp2+P7w7wlU9Xu5i8OrVg6qqTm5r0Ix1VepWIOG2su4nQIAAAQIECBAgQIAAAQIECBAgQGAAArc6Wvddn499gWwAjlpccQGBhBVfYO0RIEBg1QTGdX0Qkb5Zhb5yxG8bZbHVtV4EErq2IuohQIAAAQIECBAgQIAAAQIECBAgQKBrAjnyfzbK8vEsdf1e11trKT24vPYituNOvD7mYTo9efvlM7skzCLpmj4KCCT0cdXUTIAAgQELrNCH5adxPt1qY6eDth+HFTJum8Z4BAgQIECAAAECBAgQIECAAAECBAgQeC1wPv3Xx97fbY7hjbW1/Yi0ExH3r2LLEf/dKIs9pARWWUAgYZVXV28ECBDokMB4Mtm+uEgPPlsfHd6mrGbrqjsp/3ybMTpw7+l55O17ZXncgVr+VsLrX5JHB6t1LEbXlNVDgAABAgQIECBAgAABAgQIECBAgEDfBZodEtL5+eH7oYTmvfDIsT/je6ytHfvQd0/1r66AQMLqrq3OCBAg0AmBv/3yleOHar1ofhG78evNeL/eeIDl39jJMMI1f0levqIKCBAgQIAAAQIECBAgQIAAAQIECBAg0AGB5mjeiHyQUjrOEXspx1ezl5WfVWW5Ofv1riTQPwGBhP6tmYoJECDQG4HmzKuI9NOfBbcQSGjGGteT3BWE5pfNFPn4Y9tuvVNr58IIgghdeZLUQYAAAQIECBAgQIAAAQIECBAgQIDAEAWqsvB57RAXfkA9e8AHtNhaJUCAwCIFrjxaobVAQn0SkT5fZD8fmevPLbV+r+uttZx2IuUmiPF+fZ0KIwgidOTpUQYBAgQIECBAgAABAgQIECBAgAABAoMWEEgY9PIPonmBhEEssyYJECCwHIHx2WQ/UuxFxP3LCloLJEyOZjx/axGN/+OMr+c5P1ifTI9SxBd/FZC/rcryYBEFfWwOQYRlr4D5CRAgQIAAAQIECBAgQIAAAQIECBAg8I7A+fRfVVWdMCGwqgICCau6svoiQIBARwTG4/FmrI2aD+IftRZIeB10+L4jLf4jkNDU9W4oIaf4ZaModpZZ7+vjM2K/QztLLJPD3AQIECBAgAABAgQIECBAgAABAgQIEOiGQIovq6JovoTnRWAlBQQSVnJZNUWAAIHlClx+C//N69VodPwwpRcv67rZKSE2yvLxbatrxkqRfrztOG3cnyP+u1EWl729/3odxlg7elUUW41BG/NddwxBhOuKuZ4AAQIECBAgQIAAAQIECBAgQIAAAQILFBBIWCC2qZYhIJCwDHVzEiBAgMCtBN4cO/DrrQZp6+aWjqFoq5y34wgitC1qPAIECBAgQIAAAQIECBAgQIAAAQIECMxBQCBhDqiG7JKAQEKXVkMtBAgQIDCTQHMcwt3J9PlMF8/7oo4FEgQR5r3gxidAgAABAgQIECBAgAABAgQIECBAgEB7AlVZ+Ly2PU4jdVDAA97BRVESAQIECHxaYFxPmiMQ7n/6yjlf0ZH0qiDCnNfZ8AQIECBAgAABAgQIECBAgAABAgQIEJiDgEDCHFAN2SkBgYROLYdiCBAgQGBWgXE9OYqIR7NeP6/rziP/+15ZHs9r/E+NK4jwKSE/J0CAAAECBAgQIECAAAECBAgQIECAQHcFBBK6uzYqa0dAIKEdR6MQIECAwIIFXtaTxyniuwVP+4/plvXL4ngy2Y4c+10IZSx7DcxPgAABAgQIECBAgAABAgQIECBAgACBPgrkiN82ymKrj7WrmcCsAgIJs0q5jgABAgQ6JfCyrvdSpB+XWdQyfll8nvODu5PJ44j0zTJ7NzcBAgQIECBAgAABAgQIECBAgAABAgQI3FrgaVUW27cexQAEOiwgkNDhxVEaAQIECHxY4M0OAb8u1yg/qcpyd1E1/HE23bmT8kFE3F/UnOYhQIAAAQIECBAgQIAAAQIECBAgQIAAgTkJ5PihWi+anXC9CKysgEDCyi6txggQILDaAq93Cpg+X26X+duqLJuAwFxfTa/r0+lByvHVXCcyOAECBAgQIECAAAECBAgQIECAAAECBAgsUGAx7zEvsCFTEfiHgECCh4IAAQIEeiswricvlrlbwHnkf98ry+N5Av5e11trEYcR6fN5zmNsAgQIECBAgAABAgQIECBAgAABAgQIEFiwQIovq6I4WvCspiOwUAGBhIVym4wAAQIE2hQY15PmF7VHbY45+1j5WVWWm7Nff/0rx3W9G5EeLzN0cf2q3UGAAAECBAgQIECAAAECBAgQIECAAAECswhUZeGz2lmgXNNrAQ95r5dP8QQIEBi2wMt68jhFfLcchfykKsvdec39Jozw07zGNy4BAgQIECBAgAABAgQIECBAgAABAgQILFXgaVUW20utwOQEFiAgkLAAZFMQIECAwHwElvmh/UVOX3+2PjqcR2fL7Gse/RiTAAECBAgQIECAAAECBAgQIECAAAECBP4ukCP+u1EWe1wIrLqAQMKqr7D+CBAgsMIC48lkO3L8uowWXxWjhw9TetH23H+cTXfupPxz2+MajwABAgQIECBAgAABAgQIECBAgAABAgS6IzDPL711p0uVEIgQSPAUECBAgECvBcb1JC+6gZzil42i2Gl73t/remst0lFE3G97bOMRIECAAAECBAgQIECAAAECBAgQIECAQIcEzqf/qqrqpEMVKYXAXAQEEubCalACBAgQWJTAy3pynCK+WNR8r+fJ31ZledDmnM9zfrA+mR4tvpc2uzAWAQIECBAgQIAAAQIECBAgQIAAAQIECHxaID+rynLz09e5gkD/BQQS+r+GOiBAgMCgBcZ1fRCRvlkkwjyOa3hZTx6niO8W2Ye5CBAgQIAAAQIECBAgQIAAAQIECBAgQGAZAvlJVZa7y5jZnAQWLSCQsGhx8xEgQIBAqwIv63ovRfqx1UE/Olj7vyiOJ5PtyPHr4nowEwECBAgQIECAAAECBAgQIECAAAECBAgsT6D9XXiX14uZCXxcQCDBE0KAAAECvRZY9If5Fzl9/dn66LBNtOUcO9FmB8YiQIAAAQIECBAgQIAAAQIECBAgQIAAgVkFziP/+15ZHs96vesI9FlAIKHPq6d2AgQIELgUGNeTvBiK9s/1Gtf1bkT6aTH1m4UAAQIECBAgQIAAAQIECBAgQIAAAQIElixwWpXFgyXXYHoCCxMQSFgYtYkIECBAYF4CC9thIMcP1Xqx32Yf47o+iUiftzmmsQgQIECAAAECBAgQIECAAAECBAgQIECgswJPq7LY7mx1CiPQsoBAQsughiNAgACBxQu8rCePU8R3c5/5fPqvqqpO2prH7ghtSRqHAAECBAgQIECAAAECBAgQIECAAAECPRGYwxffetK5MgcqIJAw0IXXNgECBFZJYDEf7OcnVVnutulmd4Q2NY1FgAABAgQIECBAgAABAgQIECBAgACBPgjkb6uyPOhDpWok0IaAQEIbisYgQIAAgaUKjMfjzbgzajUs8H5D5ykf3ivL47YaXUyIoq1qjUOAAAECBAgQIECAAAECBAgQIECAAAECrQik+LIqiqNWxjIIgR4ICCT0YJGUSIAAAQKrJzCuJ80vnI9WrzMdESBAgAABAgQIECBAgAABAgQIECBAgMCHBF4Vo4cPU3pBiMBQBAQShrLS+iRAgACBzgj8Xtdba5H+15mCFEKAAAECBAgQIECAAAECBAgQIECAAAECCxGoysLnswuRNklXBDzwXVkJdRAgQIDAYATGdX0Qkb4ZTMMaJUCAAAECBAgQIECAAAECBAgQIECAAIFLAYEED8LQBAQShrbi+iVAgACBpQo8z/nB3cn0JCLuL7UQkxMgQIAAAQIECBAgQIAAAQIECBAgQIDAwgUEEhZObsIlCwgkLHkBTE+AAAECwxIY1/VuRPppWF3rlgABAgQIECBAgAABAgQIECBAgAABAgQaAYEEz8HQBAQShrbi+iVAgACBpQqM68lRRDxaahEmJ0CAAAECBAgQIECAAAECBAgQIECAAIGlCAgkLIXdpEsUEEhYIr6pCRAgQGBYAuPxeDPWRv83rK51S4AAAQIECBAgQIAAAQIECBAgQIAAAQJvBQQSPAtDExBIGNqK65cAAQIElibwsq73UqQfl1aAiQkQIECAAAECBAgQIECAAAECBAgQIEBgqQLnkf99ryyPl1qEyQksUEAgYYHYpiJAgACBYQu8rCfHKeKLYSvongABAgQIECBAgAABAgQIECBAgAABAsMVuMjp68/WR4fDFdD50AQEEoa24volQIAAgaUIOK5hKewmJUCAAAECBAgQIECAAAECBAgQIECAQLcEcvxQrRf73SpKNQTmJyCQMD9bIxMgQIAAgT8FHNfgYSBAgAABAgQIECBAgAABAgQIECBAgACBHPHbRllskSAwFAGBhKGstD4JECBAYKkCjmtYKr/JCRAgQIAAAQIECBAgQIAAAQIECBAg0BmBV8Xo4cOUXnSmIIUQmKOAQMIccQ1NgAABAgQaAcc1eA4IECBAgAABAgQIECBAgAABAgQIECBA4C+B/G1VlgdECAxBQCBhCKusRwIECBBYqoDjGpbKb3ICBAgQIECAAAECBAgQIECAAAECBAh0SiCn+GWjKHY6VZRiCMxJQCBhTrCGJUCAAAECbwVeTiaHKcdXRAgQIECAAAECBAgQIECAAAECBAgQIEBgqAL5WY50mFIcVkVxNFQFfQ9PQCBheGuuYwIECBBYoMDznB/cnUyfL3BKUxEgQIAAAQIECBAgQIAAAQIECBAgQIBAhwRy5P9slOXjDpWkFAILExBIWBi1iQgQIEBgiALjut6NSD8NsXc9EyBAgAABAgQIECBAgAABAgQIECBAgED+tirLAw4EhiogkDDUldc3AQIECCxEYFzXBxHpm4VMZhICBAgQIECAAAECBAgQIECAAAECBAgQuI3A08hxdBHp+E7KTYjg/m0Gi8hPqrLcvd0Y7ibQbwGBhH6vn+oJECBAoOMC43ry4va/tHa8SeURIECAAAECBAgQIECAAAECBAgQIECg2wKnV7xP+zQin+SI45TScVUUR++28MfZdOdOyj/fpq2LnL7+bH10eJsx3Eug7wICCX1fQfUTIECAQGcFxpPJduT4tbMFKowAAQIECBAgQIAAAQIECBAgQIAAAQIrLpAjftsoi63f63prLaUH7wcPPtb+myN5H9/0S2dVWfgsdsWfL+19WsC/BJ82cgUBAgQIELiRwMt68jhFfHejm91EgAABAgQIECBAgAABAgQIECBAgAABArcVOI3z6VZVVSc3HegyyBBxGJE+v+YYT6uy2L7mPS4nsHICAgkrt6QaIkCAAIGuCLysJ8cp4ouu1KMOAgQIECBAgAABAgQIECBAgAABAgQIDEkgR/7PRlk2Oxzc+vV6t4TYzpG2ZnzfVyDh1uoGWAUBgYRVWEU9ECBAgEDnBMbj8Wasjf6vc4UpiAABAgQIECBAgAABAgQIECBAgAABAgMQyCl+2SiKnbZbfb1jQjr65DEOOX6o1ov9tuc3HoG+CQgk9G3F1EuAAAECvRB4Wdd7KdKPvShWkQQIECBAgAABAgQIECBAgAABAgQIEFgtgdNXxWjzYUov2mzrec4P7k6mzfEP9z85rkDCJ4lcMAwBgYRhrLMuCRAgQGDBAi8nk8OU46sFT2s6AgQIECBAgAABAgQIECBAgAABAgQIEEjxZVUUzS4Grb2aXXHz2uhwxuMa4iKnrz9bHx22VoCBCPRUQCChpwunbAIECBDotsC4nuRuV6g6AgQIECBAgAABAgQIECBAgAABAgQIrJ5AjvjvRlnstdnZH2fTnTspH8y0M8LbiecQimizJ2MRWJSAQMKipM1DgAABAoMRePPL6c+DaVijBAgQIECAAAECBAgQIECAAAECBAgQ6IBAjvjtrBhtt3FUw+vjGSY7OdLerLsi/I3gfPqvqqqa4x28CAxaQCBh0MuveQIECBCYh8DLevI4RXw3j7GNSYAAAQIECBAgQIAAAQIECBAgQIAAAQJXC5xH/ve9sjy+rk9zHEOMRps5560UsZUjNf/7i+uO8+71VVn4HPY2gO5dGQH/IqzMUmqEAAECBLoiIJDQlZVQBwECBAgQIECAAAECBAgQIECAAAECQxHIkf+zUZaPr9PvuK53I6fN69wz07Upn1Rl2Rzx4EVg8AICCYN/BAAQIECAwDwExnV9EJG+mcfYxiRAgAABAgQIECBAgAABAgQIECBAgACBvwk8rcpimwkBAt0TEEjo3pqoiAABAgRWRGB8NtmPFN+vSDvaIECAAAECBAgQIECAAAECBAgQIECAQBcFTl8Vo82HKb3oYnFqIjB0AYGEoT8B+idAgACBuQr8Xtdba5GabcIefWKi05ziKHI+SikdV0Vx1Fz/POcHZX2+fSdd7Axgx4WnOcWLdBGvz3hL+SRSOnnX7dVodHydPyzGk8nHU9E5b35oS7acYue258TN9eEyOAECBAgQIECAAAECBAgQIECAAAECcZHT15+tjw4/RNG8RzspipPrvK+IlQCB9gQEEtqzNBIBAgQIEPigwGUwIaedSPHnB+R/fvh+J47eBhA+RjgejzfzaPQ45fiq59SnEXEcOY7iThxdN2SwyN4dvbFIbXMRIECAAAECBAgQIECAAAECBAishECOHxa3c2x+UpXl7qfcXtb13llRHAglfErKzwm0LyCQ0L6pEQkQIECAwFwFml+eU6Qf5zpJ64PnZznSYUpxOEv4ovXpbzjguK53I9JPN7zdbQQIECBAgAABAgQIECBAgAABAgQGKJC/fd30vN9Xy89eFcXWuyGD5ktdsTb6v3fRc8R/N8piTyhhgI+iljshIJDQiWVQBAECBAgQuJ7Amw/K303+bkXE/euNsoir85NI6aBPIYS3KsIIi3g+zEGAAAECBAgQIECAAAECBAgQILBqAjnFLxtFsfPmONvmaNq5vG95Hvnfjd29snx9BOyb1993Pf37DgrNe35VWR6smrl+CHRZQCChy6ujNgIECBAgMKPAuJ40v9g/mvHyBVyWn8T5+X5VVScLmKz1Ka4KIzR/SKXpdC+vre2kSDvd8m6dwIAECBAgQIAAAQIECBAgQIAAAQIEbipwWpXFg+bmuYUScvxQrRf7f5xNd3K6OHk3lPDXLgmzHedw0ybdR4DAbAICCbM5uYoAAQIECHRaoDuBhH4HEZpFvnpnhKv/eHl9bexHpM87/YAojgABAgQIECBAgAABAgQIECBAgMACBS5y+vqz9dFhM+XznB+sT6ZHKeKLNkrIEb9tlEWzY+zl66pQQvPP3s7fxpzGIEDg5gICCTe3cycBAgQIEOiMwLIDCc0fASnFXh+PZnh3Ea8TRnjvvoOI9E1nHgiFECBAgAABAgQIECBAgAABAgQIEFiqwN+/4NNiKOE0zqdb7+/MelUoYantm5wAgT8FBBI8DAQIECBAYAUElhpIeLM9Wt8ZrzymIeK/G2WxN0tvfz+bbpY7XEOAAAECBAgQIECAAAECBAgQIEBgZQX+PLbh3Q5v/x5a/rYqy4OVVdMYgRUUEEhYwUXVEgECBAgMS2A8mWxHzs039Bd6bECzK8JF5N13z2dbhPzLut7bKMvHbc715iy7//01Zn4WKe1+bMeHy7Po7ox2I8X2O7U8arMuYxEgQIAAAQIECBAgQIAAAQIECBDoq8B55H9f9d7hTUMJOcUvG0Wx01cPdRMYqoBAwlBXXt8ECBAg0HuB10GE2I+IJXwInp+8Koq9hym9WBTk2+BFjvTi3TPi2pj/jeWvzR81+SIdfOp8uTe7KTShiPttzG8MAgQIECBAgAABAgQIECBAgAABAqsmkD+y++jVR6d+VOD0VTHaXOT7kau2HvohsCwBgYRlyZuXAAECBAjcUGC5QYSm6MVui9bsRJBHo8cpx1evyf5+/twNGeNyh4PRaLO5P6V0b7y29v/N8gfNDf5YummJ7iNAgAABAgQIECBAgAABAgQIECDQW4Fmh9WPfbHoWu+zpfjyY7uZ9hZJ4QQGICCQMIBF1iIBAgQI9F/gec4P7k4mzXZk+4s+muEdvdPzyNuLPKJhfDbZjxR77+5EkCP/p+0jG2Z9Ql7Wk8cp4rtZr3cdAQIECBAgQIAAAQIECBAgQIAAgSELvCpGDz/2JaA3R6kefWwn0o/ttDBkW70T6IuAQEJfVkqdBAgQIDBIgTfHFOxGpCaMsLTjAZo0czqf7lRVdbKIhXh7PMOV4YslpaH/OJvu3En550X0bw4CBAgQIECAAAECBAgQIECAAAECKyEww3t5HwslfGqXhZUw0gSBFRcQSFjxBdYeAQIECPRP4PIogTuj3Ui5CSJ8vuwOml/6z4rR9izHGdy21n8ez/DPEauyWMrvL6//MIrDLqzJbZ3dT4AAAQIECBAgQIAAAQIECBBYYYHTZX6xZ4Vdb9Zajh+q9WL/Uzdf7hBbT5udUv/2Ok/5cJE7tn6qTj8nQOD6Akt5Q//6ZbqDAAECBAistsDlB/FrazsRaTdFfNGdbvOTqix3F1HPVcczvD/vshPR43rSbB/3aBEe5iBAgAABAgQIECBAgAABAgQIELiBQI4f4k4cRW6OPvU+zg0E271lxkBCu5MajQCBLgkIJHRpNdRCgAABAoMTGNf1bk5pJ+X4qnvNLyaM8NHjGf6BspiaPrQWAgnde0pVRIAAAQIECBAgQIAAAQIECBB4VyCn+GWjKJrjT+P1+06CCUt9QgQSlspvcgJdEBBI6MIqqIEAAQIEBiXwZuv/vYjU/GF0v5PNt/yHwuUff9PpSVVVJ2/7neV4hitsnkaOZpeCyCm/SCkdv3vNec4v5rmFm0BCJ59WRREgQIAAAQIECBAgQIAAAQIE3hV4WpXF9rv/QDBhiQ9Iy+8zLrETUxMgcEMBgYQbwrmNAAECBAhcV6A/f/jkb6uyPLhufx+7/k3vv0bkJ3F+vh93RruRojkTbhGBjObcwL8FF3KKF+ni/X/26YCDQEKbT4WxCBAgQIAAAQIECBAgQIAAAQLzEajK4srPv663U+d8ahvaqDnyfzbK8vHQ+tYvAQJ/CQgkeBoIECBAgMCcBZo/dHKOxyniizlP1cLw7YcR3hb1sp4c98OgBUZDECBAgAABAgQIECBAgAABAgQILE3gPPK/P7SL5vOcH6xPpwfdPEJ1aWTzmzjFl1VRXO546kWAwDAFBBKGue66JkCAAIEFCNzwSIIFVPahKeYXRmhmHNf1bkT6aYkNmpoAAQIECBAgQIAAAQIECBAgQGAAAhc5ff3Z+ujwY62O6/ogIn0zAI6ltvih3SqWWpTJCRBYqIBAwkK5TUaAAAECQxH442y6cyfl5tiDRRxJ0ALrfMMITYFN+vzuZPq8hWINQYAAAQIECBAgQIAAAQIECBAgQODDAjl+qNaL/U8ROZ7zU0K3/Xl+UpXl7m1HcT8BAv0WEEjo9/qpngABAgQ6KDA+m+xHiu87WNpVJZ1e5LT7qcR4W728rOu9FLEVOZ38bcwU2xHxqK15jEOAAAECBAgQIECAAAECBAgQIDBogadVWTTvN3309eYLNM37VD35UtGnOurYzx3X0LEFUQ6B5QgIJCzH3awECBAgsKICL+vJ4xTxXU/aOz2PvP2h8/QW2UPPQhyLpDEXAQIECBAgQIAAAQIECBAgQIDA9QVOq7J4MMttb3Y6/XmWa11zLYGZQiHXGtHFBAj0UkAgoZfLpmgCBAgQ6KLAuK53I9JPXaztipo6E0ZoahNI6MlTo0wCBAgQIECAAAECBAgQIECAQF8Ezqf/qqrq77t0fqB2Rze0uaj5WeR0EBfTg1n925zdWAQIdE9AIKF7a6IiAgQIEOihwHg83oy10XFPtne7VRjh97reantXBYGEHj70SiZAgAABAgQIECBAgAABAgQIdFjgIqevZz2m1C4JbSxkfhYR+1VZHrQxmjEIEFgdAYGE1VlLnRAgQIDAEgV6lKK+VRihIb4MX4xGm1VRHLVFLpDQlqRxCBAgQIAAAQIECBAgQIAAAQIELgVy/FCtF/uzaozryYuefNlo1pYWdJ0gwoKgTUOgtwICCb1dOoUTIECAQFcExpPJduT4tSv1fKSOW4cR3o7dHE/xobTz28DCh+q4KsggkNCDp0eJBAgQIECAAAECBAgQIECAAIEeCeQUv2wUxc6sJY/r+iAifTPr9a57Hfp4VY4eP0ypCXN4ESBA4EoBgQQPBgECBAgQuKVAT/5YacinpvUAACAASURBVC2M0HD9GTqYTk9ibW07IrZzpK0U8cWsnDnitxTxInIc5TuxlXJ8Neu9riNAgAABAgQIECBAgAABAgQIECDwcYH8rCrLzVmVmi/gRKSfZr1+yNc17+tdRN5t+1jXIZvqncAqCwgkrPLq6o0AAQIEFiLQg+3cWg0jNKhv/kDbjYhHC0E2CQECBAgQIECAAAECBAgQIECAAIFrCrwqRg9n/fb+73W9tRbpf9ecYnCXNztPnI1Gu7O6Dg5IwwQI/ENAIMFDQYAAAQIEbiHQg+MaWg0jvA4ixH5E+vwWbG4lQIAAAQIECBAgQIAAAQIECBAgMH+BFF9edXzohyYe15M8/6L6PEN+UpVl8/6gFwECBGYWEEiYmcqFBAgQIEDgnwLjs8l+pPi+ozathREuj2hYGx3YEaGjK60sAgQIECBAgAABAgQIECBAgACBfwrk+KFaL/ZnpRFI+JiUMMKsz5HrCBD4u4BAgieCAAECBAjcUODNNm5HEXH/hkPM87b2wgivz8973NE+52lobAIECBAgQIAAAQIECBAgQIAAgR4L5Ij/bpTF3qwtCCRcLdUc07BRFDuzOrqOAAEC7woIJHgeCBAgQIDADQQGE0bo9g4QN1g5txAgQIAAAQIECBAgQIAAAQIECAxI4GlVFtuz9iuQcJVUfvaqKLYepvRiVkfXESBA4F0BgQTPAwECBAgQuKbAYMIIdX0Qkb65Jo/LCRAgQIAAAQIECBAgQIAAAQIECHRF4LQqiwezFiOQcIVUii+romh2ifUiQIDAjQQEEm7E5iYCBAgQGLLAuLu7BrR2TMPLut5LkX4c8jrrnQABAgQIECBAgAABAgQIECBAoP8CVVnM/FmYQML7652fVGW52/+nQAcECCxTYOb/El5mkeYmQIAAAQLLErjcDSGlyxT1ec4v7pXlcfN/v9kl4XFEPFpWbe/OmyN+OytG221snfbH2XTnTso/d6EvNRAgQIAAAQIECBAgQIAAAQIECBC4lcD59F9VVZ18aow37/f971PXDernM9oNykSzBAhcW0Ag4dpkbiBAgAABAn8JjOt6NyI1wYT7y3JpM4wwHo83Y23UhC6W1s+yHM1LgAABAgQIECBAgAABAgQIECCwggIzHjngSzrvr73dEVbw3wYtEViKgEDCUthNSoAAAQKrJPA85wfrk+l+ivhu0X21GUZoan9ZT45TxBeL7sN8BAgQIECAAAECBAgQIECAAAECBOYiMGMg4WU9ebyM9/fm0nMLg17k9PVn66PDFoYyBAECAxcQSBj4A6B9AgQIEGhPYOHHOOT44VU5etzGMQ2Nwvhssh8pvm9PxEgECBAgQIAAAQIECBAgQIAAAQIEliwweyDBF3X+WqrTqiwuj7H1IkCAwG0FBBJuK+h+AgQIECDwnsC4rg8i0jfzgGl2RIjIB2dFcdBWEKGp01EN81gtYxIgQIAAAQIECBAgQIAAAQIECCxdYIZAQrMD6t3J9PnSa+1MAY5r6MxSKITACggIJKzAImqBAAECBLon0Jw5l1JujnG41fEHTQAhRT6OiKM4Pz+qqupkHt2O68lRRDyax9jGJECAAAECBAgQIECAAAECBAgQILA0gRkCCeO63o1IPy2txs5NnL+tyvKgc2UpiACBXgoIJPRy2RRNgAABAn0RaHYeuLhTbN2JvBUpb0akzatqzylepItoggcRd+LoPOcX98ry9X+e82s8mWxHjl/nPI3hCRAgQIAAAQIECBAgQIAAAQIECCxc4Dzyvz/1PtvLeuK4hndXZoYQx8IX0oQECPRWQCCht0uncAIECBAg0I6AP7jacTQKAQIECBAgQIAAAQIECBAgQIBA9wSqsvjkZ2Hjs8n+n5W//lLRXI5j7Z7O1RXNYtaXXtRJgMDyBT75X8LLL1EFBAgQIECAwLwEbEc3L1njEiBAgAABAgQIECBAgAABAgQILF8gP6vK8sodSz9W2/OcH9ydTHZypK0UsRVxGVL4fPn9LKSC06osHixkJpMQIDAIAYGEQSyzJgkQIECAwNUC47o+GdAfUx4DAgQIECBAgAABAgQIECBAgACBAQnkFL9sFMXOPFpujmqN0egy7PBqNDp+mNKLq+Z5HW6YPp9HDXMa82lVFttzGtuwBAgMUEAgYYCLrmUCBAgQINAI2B3Bc0CAAAECBAgQIECAAAECBAgQILDaAvnbqiwPltnjH2fTnTsp/7zMGq4592lEHL93z6OIuPznOeI4nU8fV1V1cs1xXU6AwEAFBBIGuvDaJkCAAAECdkfwDBAgQIAAAQIECBAgQIAAAQIECKy0wPn0X8v+4Hx8NtmPFN+vnvPywx6rZ6ojAqspIJCwmuuqKwIECBAg8FEBuyN4QAgQIECAAAECBAgQIECAAAECBFZZYJ7HNVzHbVxPjiKi2WGgxVd+FpFOIsdRpHySU9pJOb5qcYLZhsrxQ7Ve7M92sasIEBiqgEDCUFde3wQIECAwaAG7Iwx6+TVPgAABAgQIECBAgAABAgQIEFh9gRRfVkXRhAGW+hrXk3y7AprwQRxdHpWQ0vFVPT3P+cH6ZHqUIr643Vw3udtOCTdRcw+BIQkIJAxptfVKgAABAgQiwu4IHgMCBAgQIECAAAECBAgQIECAAIEVF3halcX2snv8va631iL975p1nEbkwyaEEOfnR7MeObHEUMLpeeTte2V5fM0+XU6AwEAEBBIGstDaJECAAAECbwXsjuBZIECAAAECBAgQIECAAAECBAgQWGmB8+m/Zv0gf54OL+t6L0X6ccY5nkbkg6osD2a8/h+XNaGEu5NpE2Zo+YiID1Z0mlM0OzM87sJuFDd1cx8BAvMVEEiYr6/RCRAgQIBApwTsjtCp5VAMAQIECBAgQIAAAQIECBAgQIBAywI58n82yvJxy8PeaLhxXR9EpG8+cfPTSLHf5gf6L+vJ4xTx3Y2Knummy2Mk9m8TnphpGhcRILASAgIJK7GMmiBAgAABArMJ2B1hNidXESBAgAABAgQIECBAgAABAgQI9E8gp/hloyh2ulL5J96LO82R9+cVnpjfF5Pyk1dFsfcwpRddcVYHAQLdFhBI6Pb6qI4AAQIECLQmML8/Qlor0UAECBAgQIAAAQIECBAgQIAAAQIEbiSQI347K0bbXfmg/M3xCc8/0MzpeeTte2V5fKNmZ7xpPJlsR47mCIf7M97yicvyt3ZFaEfSKASGJCCQMKTV1isBAgQIDFbg9R9Ak+OI9PlgETROgAABAgQIECBAgAABAgQIECCwugIpvmzz2IPbQv1xNt25k/LPV4xz+qoYbS4qOPGROq7XYo4fqvVi/3o3uZoAAQIRAgmeAgIECBAgMACB8dlkP1J8P4BWtUiAAAECBAgQIECAAAECBAgQIDA4ge59c/8D78ctZGeE95f/ZV3vpUg/3vSx6NpRGDftw30ECCxHQCBhOe5mJUCAAAECCxMYj8ebsTZqtn9raWu2hZVuIgIECBAgQIAAAQIECBAgQIAAAQKfEOheGKEpeFxPjiLi0bvF58j/2SjLx8tY0qvqmbGOhe7oMGNNLiNAoEcCAgk9WiylEiBAgACBmwjc4o+Nm0znHgIECBAgQIAAAQIECBAgQIAAAQKLEDiNyHtVWR4sYrLrzjGuJ/nv9+RnVVluXnectq4fTybbkePX6463zBDFdWt1PQEC3RQQSOjmuqiKAAECBAi0InDb7dhaKcIgBAgQIECAAAECBAgQIECAAAECBNoVWMrRB7O28DznB3cn05O/71i6/J0crv/FpeWGKGb1dh0BAt0WEEjo9vqojgABAgQI3FjAUQ03pnMjAQIECBAgQIAAAQIECBAgQIBARwVyxG9nxWj7YUovOlriZVm/1/XWWqTm2IbmGNXTqiweLLveP86mO3dS/nnWOuyOMKuU6wgQ+JiAQILngwABAgQIrKBAk8Jen0yPUsQXK9ielggQIECAAAECBAgQIECAAAECBAYo0Jcwwtul+SuUkA+rstztwpKN6/okIn0+Qy2nr4rRZteDHzP04RICBJYsIJCw5AUwPQECBAgQmIfAuK4PItI38xjbmAQIECBAgAABAgQIECBAgAABAgQWLdC3MMJbnyaUkPKdzc/WR4eLNnt/vtcBiTicLZCQn3QlRLFsN/MTIHA7AYGE2/m5mwABAgQIdE5AGKFzS6IgAgQIECBAgAABAgQIECBAgACBWwnkZ6+KYsu39a+P2BzrmtfWdlLE3mxBhNdzXOT0dRdCFNfv2B0ECHRNQCChayuiHgIECBAgcAsBYYRb4LmVAAECBAgQIECAAAECBAgQIECgiwKn55G375XlcReL62JNzXGudyeTnRxp76ZHulZl4TPELi6umgj0UMB/mfRw0ZRMgAABAgTeF2j+yFifTg9Sjq/oECBAgAABAgQIECBAgAABAgQIEFgVgRz5Pxtl+XhV+plXH293QoiUtlt4j/BpVRbb86rVuAQIDEtAIGFY661bAgQIEFhBgfFksh05H1xny7UVZNASAQIECBAgQIAAAQIECBAgQIDA6gn4YPy9Nb3c/WA63bq4SA/uRN7Kd2Ir5bzV6nuDOX6o1ov91XucdESAwDIEBBKWoW5OAgQIECDQgkCTeo61tf2I9E0LwxmCAAECBAgQIECAAAECBAgQIECAQLcEUnxZFcVRt4qabzW/1/XWnYjtlNODnOJBitiKyJutBg4+1cIA3T9F4ucECNxcQCDh5nbuJECAAAECSxEQRFgKu0kJECBAgAABAgQIECBAgAABAgQWK2B3hHe8m6DCWkoP3u6M0Pzo9e4I8SDHZXDhi7aW51UxevgwpRdtjWccAgSGLSCQMOz11z0BAgQI9FDg9RENcRgR93tYvpIJECBAgAABAgQIECBAgAABAgQIfFLgIqevP1sfNe+BreTr8j2+915t7AbRQnDhtCqLByuJrikCBJYiIJCwFHaTEiBAgACB2wm83rotHVyVfM4pfkkXcfx2htdbu+WdhW7rdrv23E2AAAECBAgQIECAAAECBAgQIDAwgRzxW4r481v5VVn84wP7gZHMtd3LXVhHo83LSS7itXXKmznSi42y2Jvr5AYnQGBQAgIJg1puzRIgQIDAKgk8z/nB3Xq6FynvRqQHEfkwzs/3q6o6eb/Py2snk8cR6ZtVMtALAQIECBAgQIAAAQIECBAgQIBA7wSeRuSTHHGcUjp+NRodOx6gd2uoYAIECMwsIJAwM5ULCRAgQIBA/wXGdd2EF37qfyc6IECAAAECBAgQIECAAAECBAgQ6L5AfhYRR2/DB20cSdD9nlVIgAABAu8KCCR4HggQIECAwMAEhBIGtuDaJUCAAAECBAgQIECAAAECBAgsSKA5duEygJDT0Z2LyfFVO3kuqBTTECBAgEBHBAQSOrIQyiBAgAABAosUGNf1geMbFiluLgIECBAgQIAAAQIECBAgQIDAKgrkZznSYRNAqMu1I0cvrOIa64kAAQK3ExBIuJ2fuwkQIECAQC8F/jib7txJ+edeFq9oAgQIECBAgAABAgQIECBAgACBZQmcRuTDZheEOD8/sgPCspbBvAQIEOiPgEBCf9ZKpQQIECBAoDWB8WSyHTl+bW1AAxEgQIAAAQIECBAgQIAAAQIECKyqwNMc+fAi4uheWR6vapP6IkCAAIH5CAgkzMfVqAQIECBAoNMCdkjo9PIojgABAgQIECBAgAABAgQIECCwRIG/jmH4bH3U7IbgRYAAAQIEbiwgkHBjOjcSIECAAIH+CrysJ49TxHf97UDlBAgQIECAAAECBAgQIECAAAECLQpc7oKQzs8PHcPQoqqhCBAgQCAEEjwEBAgQIEBggAIv68lxivhigK1rmQABAgQIECBAgAABAgQIECBAIOI0mmMY8p3Dulw7epjSCygECBAgQGAeAgIJ81A1JgECBAgQ6LDAeDzejLXR/3W4RKURIECAAAECBAgQIECAAAECBAjMRSA/OY94fK8sj+cyvEEJECBAgMB7AgIJHgkCBAgQIDAwgZd1vZci/TiwtrVLgAABAgQIECBAgAABAgQIEBisQI74LaXYq4riaLAIGidAgACBpQgIJCyF3aQECBAgQGD5AuPJZLup4uIiPbgTeeuyopQ3I9Lmm+qaf3Z/+ZWqgAABAgQIECBAgAABAgQIECBA4KYCOeK/G2Wxd9P73UeAAAECBG4jIJBwGz33EiBAgACBgQhcHV6I7wfSvjYJECBAgAABAgQIECBAgAABAn0UOL3Iafez9dFhH4tXMwECBAishoBAwmqsoy4IECBAgMBCBS4DCjl+XeikJiNAgAABAgQIECBAgAABAgQIEJhV4PQ88va9sjye9QbXESBAgACBeQgIJMxD1ZgECBAgQGDFBcZ1fRCRvlnxNrVHgAABAgQIECBAgAABAgQIEOidQI747awYbT9M6UXvilcwAQIECKycgEDCyi2phggQIECAwHwFnuf84O5kehIR9+c7k9EJECBAgAABAgQIECBAgAABAgSuIyCMcB0t1xIgQIDAIgQEEhahbA4CBAgQILBCAuOzyX6k+H6FWtIKAQIECBAgQIAAAQIECBAgQKD3AsIIvV9CDRAgQGAlBQQSVnJZNUWAAAECBG4uMK7r3Yi024yQI45T5OM4Pz+qqurk97reWot0ZHeEm/u6kwABAgQIECBAgAABAgQIECAwB4HTV8Vo0zENc5A1JAECBAjcSkAg4VZ8biZAgAABAqsnMJ5MtiPHr6vXmY4IECBAgAABAgQIECBAgAABAispcHoeefteWR6vZHeaIkCAAIFeCwgk9Hr5FE+AAAECBNoXeJ7zg7uT6fP2RzYiAQIECBAgQIAAAQIECBAgQIBA2wIXOX392frosO1xjUeAAAECBNoQEEhoQ9EYBAgQIEBgxQReTiaHKcdXK9aWdggQIECAAAECBAgQIECAAAECqyWQ44dqvdhfraZ0Q4AAAQKrJCCQsEqrqRcCBAgQINCSwB9n0507Kf/c0nCGIUCAAAECBAgQIECAAAECBAgQaFkgR/y2URZbLQ9rOAIECBAg0KqAQEKrnAYjQIAAAQL9FPi9rrfWUnrQVH+e84s7kXZTxHf97EbVBAgQIECAAAECBAgQIECAAIEBCJxP/1VV1ckAOtUiAQIECPRYQCChx4undAIECBAgMC+BcT15ERH35zW+cQkQIECAAAECBAgQIECAAAECBG4h4KiGW+C5lQABAgQWKSCQsEhtcxEgQIAAgR4IOK6hB4ukRAIECBAgQIAAAQIECBAgQGDIAqevitHmw5SaL5R4ESBAgACBTgsIJHR6eRRHgAABAgRmF3ie84O70+lWVRRHs9/1zyvHk8l2XMT2B8dIlz97dJs53EuAAAECBAgQIECAAAECBAgQIHBDAbsj3BDObQQIECCwDAGBhGWom5MAAQIECNxAoAkcfCr5Pq7r3aosD24w/My3jM8m+5Hi+5lvcCEBAgQIECBAgAABAgQIECBAgEBrAhc5fX3nTv747gjT6UlVVSetTWogAgQIECBwQwGBhBvCuY0AAQIECCxaYFzXB1VZ7n5s3vF4vBmj0eZtd0n46BwCCYteevMRIECAAAECBAgQIECAAAECBP4hkCN+SxEvIvJJ5HSSU36RUjpuLpzne0OWggABAgQIXEdAIOE6Wq4lQIAAAQJLErgMGqyN/q8qi0/+/+7myIV5/tFph4QlPQSmJUCAAAECBAgQIECAAAECBAYmkJ9FxJGwwcCWXbsECBBYMYFPfqixYv1qhwABAgQI9FKg2R2h+QN03scxzIIjkDCLkmsIECBAgAABAgQIECBAgAABAjcVuAwi7HfhfaCbduA+AgQIECDwVkAgwbNAgAABAgR6IPA85wcPU/r42YA36KPZeeHiTrH12fro8FO3NzXcrad7kWIvIu5/6no/J0CAAAECBAgQIECAAAECBAgQuI6AIMJ1tFxLgAABAv0QEEjoxzqpkgABAgR6LvB7XW/dK8vLM/y69mpqS/nO5odCCc0REJHzbkT6pmu1q4cAAQIECBAgQIAAAQIECBAgsAICpxF5z44IK7CSWiBAgACBfwgIJHgoCBAgQIDAnAVeH3GQd18VxdY8djloo/z3QwnNbgjrk8luimY3hPR5G3MYgwABAgQIECBAgAABAgQIECBA4G8Cp5Hj8aty9Lir7xlZLwIECBAgcFsBgYTbCrqfAAECBAh8RKD5oH8t0v+aS3Lk/2yU5eOugl3WmtL/Ezn/v3ZD6OoqqYsAAQIECBAgQIAAAQIECBBYDYH8JM7P96uqOlmNfnRBgAABAgSuFhBI8GQQIECAAIE5CrysJ8cp4otmilkCCePxeDNGo82YTk8W+Qfp62MZYj8iHs2Rw9AECBAgQIAAAQIECBAgQIAAgUEL5IjfUoq9qiiOBg2heQIECBAYjIBAwmCWWqMECBAgsGiBt0c15EiHF5EP7pXl8YdquCIQ8LQqi+151/z6aIbpfor4bt5zGZ8AAQIECBAgQIAAAQIECBAgMGCB04i8V5XlwYANtE6AAAECAxQQSBjgomuZAAECBOYv8PqD/snup45ouNwRYW3U/CH6t50JcsR/N8pib56VvgkjHL3dwWGecxmbAAECBAgQIECAAAECBAgQIDBUgeZ9nrNitP8wpRdDNdA3AQIECAxXQCBhuGuvcwIECBBYssC4rncj0uOIuP9eKadxPt2a55ENwghLXnzTEyBAgAABAgQIECBAgAABAkMQeBrn0915vsczBEQ9EiBAgEC/BQQS+r1+qidAgACBngqM6/ogIn3z4fLzs4h08vbnOeI45fgrRZ/ySaS/fn6e84uPHQnx/jyvj5OI73vKp2wCBAgQIECAAAECBAgQIECAQIcF8rNIabcqiqMOF6k0AgQIECCwEAGBhIUwm4QAAQIECPwl0IQBcoqdOR6V8DQinzQhhouIo/eDCs3uCHcn0ybs8P7ODJaJAAECBAgQIECAAAECBAgQIEDgxgLNF0xivyrL5nhOLwIECBAgQCAiBBI8BgQIECBAYEkCr4MBk50PHNvQZlWnOcVRyvkwzs+PYm1tOyL91OYExiJAgAABAgQIECBAgAABAgQIDFdAEGG4a69zAgQIEPiUgEDCp4T8nAABAgQIzFlgPB5v5rXR4Rx3THi/g1O7I8x5UQ1PgAABAgQIECBAgAABAgQIrLxATvFLvkgHn62PDle+WQ0SIECAAIEbCggk3BDObQQIECBAoE2BJpQQa6NjQYE2VY1FgAABAgQIECBAgAABAgQIEGhd4GmOfJjOzw+rqmqOxPQiQIAAAQIEPiIgkODxIECAAAECHRH442y6cyflnztSjjIIECBAgAABAgQIECBAgAABAkMSOI0UOznnrZTTg781nvJJpHRSFcXRkED0SoAAAQIE2hAQSGhD0RgECBAgQKAlgXE9af6wfdTScIYhQIAAAQIECBAgQIAAAQIECBCYSSA/qcpyd6ZLXUSAAAECBAjMLCCQMDOVCwkQIECAwPwFfq/rrbVI/5v/TGYgQIAAAQIECBAgQIAAAQIECBD4U+B8+i9HMHgeCBAgQIBA+wICCe2bGpEAAQIECNxK4OVkcphyfHWrQdxMgAABAgQIECBAgAABAgQIECAwk0BO8ctGUezMdLGLCBAgQIAAgWsJCCRci8vFBAgQIEBg/gLjyWQ7cvw6/5nMQIAAAQIECBAgQIAAAQIECBAgECm+fDUaHd+dTrfeajT/+WFKL+gQIECAAAECtxMQSLidn7sJECBAgMBcBMZ1fRKRPp/L4AYlQIAAAQIECBAgQIAAAQIECBB4I5CfVGW5i4MAAQIECBCYj4BAwnxcjUqAAAECBG4lMK7r3Yj0060GcTMBAgQIECBAgAABAgQIECBAgMDHBc6n/6qq6gQTAQIECBAgMB8BgYT5uBqVAAECBAjcSuB5zg/uTqbNH8P3bzWQmwkQIECAAAECBAgQIECAAAECBK4WyPFDtV7s4yFAgAABAgTmJyCQMD9bIxMgQIAAgVsJjM8m+5Hi+1sN4mYCBAgQIECAAAECBAgQIECAAIErBPKzV0Wx9TClF3gIECBAgACB+QkIJMzP1sgECBAgQOBvAuPJZPs85xf3yvJ4VpqX9eQ4RXwx6/WuI0Dg/2fvfpPauNL/Yd/H0E1EUmV7BSYrCLMCkxWEWUHICsKsIGQFISsIXkFI1fM++P1TFbKCr70Cm6rEMi3B+VXzJ8FYGEnoX6svqqZmJu4+576v03Eh6aNzCBAgQIAAAQIECBAgQIAAgfsFznP67+drq4f3X+kKAgQIECBA4CECAgkP0XMvAQIECBAYQuBdVe2mSPX2f1fHL+TX5/nR7jAvev8+7W8/SvnXIaZxCQECBAgQIECAAAECBAgQIECAwBACOcVv60WxPcSlLiFAgAABAgQeKCCQ8EBAtxMgQIAAgbsE3uT8ZK3fP0g5vhl0TY74eb0sdj8l+FdVba5E+oMyAQIECBAgQIAAAQIECBAgQIDARARO3herG45qmIilQQgQIECAwL0CAgn3ErmAAAECBAiMLnARRuj1j+4/biG/6JTlzqdm6Fa9PHoF7iBAgAABAgQIECBAgAABAgQIELgt4KgGzwQBAgQIEJitgEDCbL3NRoAAAQItEBg+jPAPxss46+90Op1Xg3jeVb3j+4MNLYDVIgECBAgQIECAAAECBAgQIEDgAQLD7Fb5gOHdSoAAAQIECAwQEEjwWBAgQIAAgQkKjBFGuJ79JEfeWy/L/dvlvOv1Du869mGCpRuKAAECBAgQIECAAAECBAgQILC0Ajniz/Wy2FzaBjVGgAABAgQWVEAgYUEXRlkECBAg0DyBB4QRbjb70W4J3dPeXqT4oXkiKiZAgAABAgQIECBAgAABAgQILITAyVnkrS/K8nghqlEEAQIECBBokYBAQosWW6sECBAgMF2BAPsbSAAAIABJREFUy0BCbyci7TzwiIUPdkv4+7S//SjlX6dbvdEJECBAgAABAgQIECBAgAABAsspcJ7Tfz9fWz1czu50RYAAAQIEFltAIGGx10d1BAgQINBQgW6vtxU59iLi+QNauNgt4Wxl5clKpD8eMI5bCRAgQIAAAQIECBAgQIAAAQKtFMgRP6+XxW4rm9c0AQIECBBYAAGBhAVYBCUQIECAwPIKXO1ucBARj8fs8mK3hBTppzHvdxsBAgQIECBAgAABAgQIECBAoK0CLztlsdXW5vVNgAABAgQWQUAgYRFWQQ0ECBAgsNQCF0c59PsHKcc3S92o5ggQIECAAAECBAgQIECAAAECCyKQI/48LVa3nqb0dkFKUgYBAgQIEGilgEBCK5dd0wQIECAwD4HuaW8vUvwwj7nNSYAAAQIECBAgQIAAAQIECBBokcDJWeStL8ryuEU9a5UAAQIECCykgEDCQi6LoggQIEBgWQW6VbUTkX5Z1v70RYAAAQIECBAgQIAAAQIECBCYt8BZ5P8II8x7FcxPgAABAgQuBQQSPAkECBAgQGDGAkIJMwY3HQECBAgQIECAAAECBAgQINAigfxdpywPWtSwVgkQIECAwEILCCQs9PIojgABAgSWVUAoYVlXVl8ECBAgQIAAAQIECBAgQIDA/ASEEeZnb2YCBAgQIDBYQCDBk0GAAIEZCLzJ+cln/f5mnMdWfhSbKefNyOmgs1bszWB6UyyogFDCgi6MsggQIECAAAECBAgQIECAAIHGCeSIn9fLYrdxhSuYAAECBAgsuYBAwpIvsPYIEJifQP1hc05p+yJ8EOnZR5Xk+FEgYX7rsygzv6t6+yni+0WpRx0ECBAgQIAAAQIECBAgQIAAgeYJ5BedstxpXt0qJkCAAAECyy8gkLD8a6xDAgTmJNCtekcR8fzO6QUS5rQyizdtt6oOItK3i1eZiggQIECAAAECBAgQIECAAAECiy4gjLDoK6Q+AgQIEGi3gEBCu9df9wQITFHgvg+Zc8Sfp8Xq1tOU3k6xDEM3QODiSI9e/00DSlUiAQIECBAgQIAAAQIECBAgQGCBBIQRFmgxlEKAAAECBAYKCCR4MAgQIDAlge5pby9S/HDP8CeRYrtTFPVuCn5aLNCternF7WudAAECBAgQIECAAAECBAgQIDCigDDCiGAuJ0CAAAECcxEQSJgLu0kJEGiDwJCBhCuK/F2nLA/a4KLHwQICCZ4MAgQIECBAgAABAgQIECBAgMCwAsIIw0q5jgABAgQIzFtAIGHeK2B+AgSWVmC0QELN4IXU0j4MQzQmkDAEkksIECBAgAABAgQIECBAgAABAt5D8wwQIECAAIFGCQgkNGq5FEuAQJME3lXVbor002g1CyWM5rU8VwskLM9a6oQAAQIECBAgQIAAAQIECBCYloD3zqYla1wCBAgQIDAtAYGEackalwCB1gt0e72tyPH76BBeWI1u1qw7ut3uRqys1kd0PG9W5aolQIAAAQIECBAgQIAAAQIECMxLwJGn85I3LwECBAgQeIiAQMJD9NxLgACBTwiMH0ioBxVKWNaH6+ooj92IeLysPeqLAAECBAgQIECAAAECBAgQIDBZAWGEyXoajQABAgQIzE5AIGF21mYiQKBlAg8LJNRYQgnL9MjUz0POsZ8ivlqmvvRCgAABAgQIECBAgAABAgQIEJiiwMlZ5K0vyvJ4inMYmgABAgQIEJiigEDCFHENTYBAuwUeHkioMwnxY2et2Gu3ZLO7f5Pzk7Vefy9FfN/sTlRPgAABAgQIECBAgAABAgQIEJicQE7xW8r5bUT6dtCoOeLP88g7wgiTMzcSAQIECBCYh4BAwjzUzUmAQCsErrbm/+HhzdqS7uGG8xmhW1U7EWnf8Qzz8TcrAQIECBAgQIAAAQIECBAgsJgCddhgvSw26+qu3j/55WaldVjhdHV152lKbxezA1URIECAAAECwwoIJAwr5ToCBAiMKDC5QELYmm5E+3lf/ldVba5cBhGez7sW8xMgQIAAAQIECBAgQIAAAQIEFk3gLPJ/bu588EEowY6hi7Zc6iFAgAABAg8SEEh4EJ+bCRAgcLfABAMJcTM1znxxBerjGT7r9fbv2mpwcStXGQECBAgQIECAAAECBAgQIEBgVgL5Racsd27P9q6qdlNKx52iOJpVJeYhQIAAAQIEpi8gkDB9YzMQINBSgUkGEmrCHPHzelnstpRz4du+Wu96fR4vfLEKJECAAAECBAgQIECAAAECBAjMS+Cs/2Wn03k1r+nNS4AAAQIECMxWQCBhtt5mI0CgRQLvqt5+ivh+oi2n+FpKfKKiDx7sckvB2ItIzx48mAEIECBAgAABAgQIECBAgAABAkstMHh3hKVuWXMECBAgQKDlAgIJLX8AtE+AwPQEulWv3l7u+SRncHTDJDUfNla319vKOerQyVcPG8ndBAgQIECAAAECBAgQIECAAIF2COTI/0s5PYmUN3JKT85z3vuiLI/b0b0uCRAgQIBAOwUEEtq57romQGAGAtMIJNRl1y/c1styfwYtmGKAQB1EiFzviDDZsAlsAgQIECBAgAABAgQIECBAgEALBU4i8m6nLA9a2LuWCRAgQIBAKwQEElqxzJokQGAeAt2q9zYiHk9h7pP3xerG05Tq8f3MSEAQYUbQpiFAgAABAgQIECBAgAABAgTaIHASOf79ws15/6DT6bxqQ+N6JECAAAECbRMQSGjbiuuXAIGZCXSrXp7aZDl+7KwV9bf0/UxZ4O/T/vajlHftiDBlaMMTIECAAAECBAgQIECAAAECrRE4z+m/n6+tHramYY0SIECAAIEWCwgktHjxtU6AwPQE/qqqzZVIf0xvhrBLwhRx3+T85LNebzuiPpohPZviVIYmQIAAAQIECBAgQIAAAQIECLRMIH/niIaWLbl2CRAgQKDVAgIJrV5+zRMgMC2Bq+39f5/W+Bfj2iUhut3uxvmjYnNSifp6vLyyupsidqZ03MZUHwmDEyBAgAABAgQIECBAgAABAgQWW0AYYbHXR3UECBAgQGDyAgIJkzc1IgECBKJ72tuLFD9MlyK/7pTlxnTnWMzRL3egiN2I9G1d4Vnk/3xRlsfjVPvvbgipDiE8H2cM9xAgQIAAAQIECBAgQIAAAQIECHxS4CQi79oZwVNCgAABAgTaJyCQ0L411zEBAjMQeNfrHaYc30x/qnalyq92ntgbEBw4Oc9pZ9idEuqdEGJlZSuntD2bdZr+k2AGAgQIECBAgAABAgQIECBAgMAiCuSIP88j74z7ZZJF7ElNBAgQIECAwPACAgnDW7mSAAECQwt0q+pVRHo29A3jX/iyUxZb49/ejDs/EUT4oIH6BW7KcRiP4uijzs5jKz+KzZTz5ozWphm4qiRAgAABAgQIECBAgAABAgQITEfgJHLsd9aK+sslfggQIECAAIGWCggktHThtU2AwPQELo8A6L+Z3gy3Rj7rf9npdF7NbL4ZTtStqvoYhT0Bghmim4oAAQIECBAgQIAAAQIECBAg8GCB/CLOzvaW9T2rB/MYgAABAgQItEhAIKFFi61VAgRmI/D3aX/7Ucq/zma2iMjx4zIlzevjFPLK6m6KqMMIj2fmaCICBAgQIECAAAECBAgQIECAAIGHCrw8i7zreIaHMrqfAAECBAgsj4BAwvKspU4IEFgQgXdVbz9FfD+7cvLrTlluzG6+6cxU74aQU9pOOb6ZzgxGJUCAAAECBAgQIECAAAECBAgQmI5Afh0p7XSK4uNjNKczoVEJECBAgACBhggIJDRkoZRJgEBzBN5VveMU8dUsKz6L/J8mJs8vd5M4345I23ZDmOUTYy4CBAgQIECAAAECBAgQIECAwIQElmz3zgmpGIYAAQIECBC4EhBI8CgQIEBgggL1cQOxsvp/ExxyqKFyxM/rZbE71MVzvOhNzk/K6mxLCGGOi2BqAgQIECBAgAABAgQIECBAgMBkBE4ixbZdESaDaRQCBAgQILCsAgIJy7qy+iJAYC4C76pqN0X6afaTL+axDdcBhJTyVkRszXrniNmvgxkJECBAgAABAgQIECBAgAABAq0QODmLvNXEHTtbsTqaJECAAAECCyQgkLBAi6EUAgSaL9CtqlcR6dk8Olm0YxvmcXTFPNzNSYAAAQIECBAgQIAAAQIECBBomYAwQssWXLsECBAgQOAhAgIJD9FzLwECBG4IdHu9rcjx+7xQFunYhndVbz9FfD8vC/MSIECAAAECBAgQIECAAAECBAhMR+A8p/9+vrZ6OJ3RjUqAAAECBAgsm4BAwrKtqH4IEJibQLeqDiLSt3MrIBbj2Ia/qmpzJdIf83MwMwECBAgQIECAAAECBAgQIECAwDQEFukLMdPoz5gECBAgQIDA5AUEEiZvakQCBFoo0O12N2Jl9f/m3foiHNvQrXpHEfF83hbmJ0CAAAECBAgQIECAAAECBAgQuFfgZeSo38v58CflnY+PJc2v3xfF5tOU3t47qgsIECBAgAABAlcCAgkeBQIECExA4F2vd5hyfDOBoR40xLxT6vM+tuJBeG4mQIAAAQIECBAgQIAAAQIECLRM4K7jF97k/GSt1z9KEV/9S5K/65TlQcuItEuAAAECBAg8UEAg4YGAbidAgMDfp/3tRyn/uhgS8z22we4Ii/EUqIIAAQIECBAgQIAAAQIECBAgMIzA+2L16V07HtShhM96vf2rI0pfdspia5gxXUOAAAECBAgQuCkgkOB5IECAwAMELl+Y9V9FxOMHDDPZW1N83SmKj7fam+wsH432V1VtrkT6Y8rTGJ4AAQIECBAgQIAAAQIECBAgQGAyAkOFDN5V1W7Oj159vrZ6OJlpjUKAAAECBAi0SUAgoU2rrVcCBCYqMHjruolOMeZg+UWnLHfGvHns295Vvf0U8f3YA7iRAAECBAgQIECAAAECBAgQIEBgZgI58v/Wy3J/ZhOaiAABAgQIEGilgEBCK5dd0wQIPFRgccMIF52dvC9WN+7abu+hvd91f7eqXkWkZ9Ma37gECBAgQIAAAQIECBAgQIAAAQITFDjrf9npdOqdP/0QIECAAAECBKYmIJAwNVoDEyCwrAKXRxPE4SJ/+D7rhLvjGpb1adcXAQIECBAgQIAAAQIECBAgsIwCOeLP9bLYXMbe9ESAAAECBAgsloBAwmKth2oIEGiAQH1uXor002KXml93ynJjVjU6rmFW0uYhQIAAAQIECBAgQIAAAQIECExCIH/XKcuDSYxkDAIECBAgQIDApwQEEjwfBAgQGFGg2+ttRY7fR7xtDpfP7oWl4xrmsLymJECAAAECBAgQIECAAAECBAiMJzCX4z7HK9VdBAgQIECAQNMFBBKavoLqJ0BgLgLdqpfnMvFIk+bX74ti82lKb0e6bcSLHdcwIpjLCRAgQIAAAQIECBAgQIAAAQJzFcgvOmW5M9cSTE6AAAECBAi0RkAgoTVLrVECBCYp8K7XO0w5vpnkmFMZK8ePnbVibypjXw3quIZp6hqbAAECBAgQIECAAAECBAgQIDBhgbP+l51O59WERzUcAQIECBAgQGCggECCB4MAAQJjCHSraici/TLGrbO/JcePU5005dri2VTnMDgBAgQIECBAgAABAgQIECBAgMAkBF52ymJrEgMZgwABAgQIECAwjIBAwjBKriFAgMAtgTc5P/ms16+T5I/hECBAgAABAgQIECBAgAABAgQIEGiEQIqvO0Vx1IhaFUmAAAECBAgshYBAwlIsoyYIEJiHQPe0txcpfpjH3OYkQIAAAQIECBAgQIAAAQIECBAgMKKA3RFGBHM5AQIECBAg8HABgYSHGxqBAIGWCtgloaULr20CBAgQIECAAAECBAgQIECAQBMF7I7QxFVTMwECBAgQaLyAQELjl1ADBAjMU+Dv0/72o5R/nWcN5iZAgAABAgQIECBAgAABAgQIECDwaYH8olOWO5QIECBAgAABArMWEEiYtbj5CBBYOoF3VW8/RXy/dI1piAABAgQIECBAgAABAgQIECBAYBkETuKsv9npdF4tQzN6IECAAAECBJolIJDQrPVSLQECCyrQraqDiPTtgpanLAIECBAgQIAAAQIECBAgQIAAgbYK5Pixs1bstbV9fRMgQIAAAQLzFRBImK+/2QkQWCIBOyUs0WJqhQABAgQIECBAgAABAgQIECCwFAL5dacsN5aiFU0QIECAAAECjRQQSGjksimaAIFFFfj7tL/9KOWDiHi8qDWqiwABAgQIECBAgAABAgQIECBAoCUCKb7uFMVRS7rVJgECBAgQILCAAgIJC7goSiJAoNkCb3J+8lnV340Uu4IJzV5L1RMgQIAAAQIECBAgQIAAAQIEmiqQI35eL4v6/Sk/BAgQIECAAIG5CQgkzI3exAQILLvARTCh19uOSDsR8XzZ+9UfAQIECBAgQIAAAQIECBAgQIDAYgjkiD/Xy2JzMapRBQECBAgQINBmAYGENq++3gkQmJlAHU4oq7OtR5E386PYTDmeCCnMjN9EBAgQIECAAAECBAgQIECAAIE2CZycRd76oiyP29S0XgkQIECAAIHFFBBIWMx1URUBAi0T6FbVq4j0rGVta5cAAQIECBAgQIAAAQIECBAgQGDiAvm7TlkeTHxYAxIgQIAAAQIExhAQSBgDzS0ECBCYpEC3qnYi0i+THNNYBAgQIECAAAECBAgQIECAAAECbRTILzplWR8f6ocAAQIECBAgsBACAgkLsQyKIECgzQJ2R2jz6uudAAECBAgQIECAAAECBAgQIDAZgRzx53pZbE5mNKMQIECAAAECBCYjIJAwGUejECBAYCyB7mlvL1L8MNbNbiJAgAABAgQIECBAgAABAgQIECBwKXDyvljdeJrSWyAECBAgQIAAgUUSEEhYpNVQCwECrRJ4k/OTz3r9VxHxuFWNa5YAAQIECBAgQIAAAQIECBAgQGCSAidnkbe+KMvjSQ5qLAIECBAgQIDAJAQEEiahaAwCBAiMIfCu1ztMOb4Z41a3ECDQCoH8XZydHcXKylZEXP0nPfu39fw6IvYi0r5gUyseCE0SIECAAAECBAgQIEBgoMB5Tv/9fG31EA8BAgQIECBAYBEFBBIWcVXURIDA0gv8fdrffpTyr0vfqAYJEBhTIH/XKcuD2zd3u92Nq4BC1H/+V1VtrkT6Y8xJ3EaAAAECBAgQIECAAIEBAvl15PTR65FIeSMifYts0QQGv35ctCrVQ4AAAQIECLRXQCChvWuvcwIE5iRweVRD7zji5jed51SMaQkQWECB4d9MEm5awOVTEgECBAgQIECAAIHmC7zslEW9S9sHP91ebyty/N789papg+FfPy5T13ohQIAAAQIEmiUgkNCs9VItAQJLIPCu6u2niO+XoBUtECAwcYHR3kzqnvb2IsUPEy/DgAQIECBAgAABAgQItFlgcCChqnYi0i9thlmk3nPk/62XZX2Enx8CBAgQIECAwEILCCQs9PIojgCBZRPwbYJlW1H9EJikwGhhhHpmgYRJ+huLAAECBAgQIECAAIFrgU5ZfPS+sdcfi/R85BedstxZpIrUQoAAAQIECBC4S0AgwbNBgACBGQlcHtXQfxURj2c0pWkIEGiMwOhhhLo1bwg2ZoEVSoAAAQIECBAgQKBRAgIJi7tcOeLn9bLYXdwKVUaAAAECBAgQ+FBAIMETQYAAgRkJvOv1DlOOb2Y0nWkIEGiMwHhhhLq9ri1TG7PKCiVAgAABAgQIECDQJIFBgQTvayzCCo7/+nERqlcDAQIECBAg0E4BgYR2rruuCRCYsYAPDWcMbjoCjRF42JtJjoFpzEIrlAABAgQIECBAgECjBAbukFD1jiLieaMaWapiH/b6cakoNEOAAAECBAg0SkAgoVHLpVgCBJoo8FdVba5Eql+0O6qhiQuoZgJTE5jMm0ndqpenVqKBCRAgQIAAAQIECBBopYBAwqIt+2RePy5aV+ohQIAAAQIE2iEgkNCOddYlAQJzEniT85O1Xv8oRXw1pxJMS4DAAgrkyP9bL8v9SZT2ruod+ztmEpLGIECAAAECBAgQIEDgWuCOQIIw9OwfkZNIsd0pivqLLn4IECBAgAABAo0UEEho5LIpmgCBpgh0q+ogIn3blHrVSYDAjARSfD2pN5T8PTOjNTMNAQIECBAgQIAAgRYJCCQsxGKfnEXe+qIsjxeiGkUQIECAAAECBMYUEEgYE85tBAgQuE+gW1U7EemX+67z5wQILJXASU5xFDnXO6Ns3hlIyvFjZ63Ym0Tn/q6ZhKIxCBAgQIAAAQIECBC4KXA7kFDvAPlZr/+G0mwEcsSfp8Xq1tOU3s5mRrMQIECAAAECBKYnIJAwPVsjEyDQYoG/qmpzJVK9nd7jFjNonUBbBE4i8uF5fnT4+drq4XXT3apX/x3wfCDCBAMJV3/f/NEWbH0SIECAAAECBAgQIDBtgfy6U5YbN2fp9npbkeP3ac9s/Iic4rfT1dUdYQRPAwECBAgQILAsAgIJy7KS+iBAYGEErr418EoYYWGWRCEEpiXwMiIfdMryYNAE3ap6FZGe3TH5y05ZbE2qsG7Vq781IwA1KVDjECBAgAABAgQIEGi3wEevVwQSZvNA5Iif18tidzazmYUAAQIECBAgMBsBgYTZOJuFAIGWCNRhhLVev96q/auWtKxNAm0TOMkRB+msv9/pdOrg0Z0/3aqXP/HHJ52yeDIpvE/uxjCpSYxDgAABAgQIECBAgEBbBD4OJDiWctprX++8t3tX4H3akxufAAECBAgQIDBNAYGEaeoamwCB1gl0q+rgzjPjW6ehYQLLJJBfR8Te+6I4HGbbzGG+PZQj/2+9LPcnoeTvnkkoGoMAAQIECBAgQIAAgVpg0Lf0u6e9vUjxA6FpCOTXZxHbX5Tl8TRGNyYBAgQIECBAYN4CAgnzXgHzEyCwNAI+EFyapdQIgZsCnzyW4S6q7nDfHjo5i7w1iTedvDnooSVAgAABAgQIECBAYGICOX7srBV7N8fzmmNiuh8MlFP8drq6ujNM8H06FRiVAAECBAgQIDB9AYGE6RubgQCBFggII7RgkbXYNoGXkWKvUxRH4zQ+wpt1EwkljDDfOO24hwABAgQIECBAgACBNgmk+Pr2a6F3vd5hyvFNmxim3eskd82bdq3GJ0CAAAECBAg8REAg4SF67iVAoPUCb3J+stbvH3hR3vpHAcDSCOQXcXa21+l0Xj2kpW7Vq4MMz4cc4+Q8p53P11YPh7z+o8sEEsaVcx8BAgQIECBAgAABAh8JnPW/vP2aaMTXOFA/KeCIBg8IAQIECBAg0C4BgYR2rbduCRCYsMBfVbW5EumPCQ9rOAIEZi4wmSDCddndqnoVkZ6N1kb+rlOWB6Pdc3n1u6q3nyK+H+de94wvkCP+TJGPc8RxRNqwBuNbupMAAQIECBAgQGCWAvl1jthPkX4aMOtJpyye3P7nF+9/pPTk/Dw9eZTOtyPSdkQ8nmXVyzCXIxqWYRX1QIAAAQIECIwqIJAwqpjrCRAgcEtgvA8eMRIgsBgCkw0iXPd09e2hkVvMKf6/FPH/X9847JERvq00MvU4N5xE5MM6fJBSOr69Nt1udyNWVv9vnIHdQ4AAAQIECBAgQGA2Avl1ROxdB6G7VS/fnrf+wHy9KOqwwSd/6h0jP6v6u5Hih/uu9eeXAo5o8CQQIECAAAECbRUQSGjryuubAIGJCfhm8sQoDURghgLTCSLMsIEPphr0RuK8alnieV92ymLrU/29q3rHKeKrJTbQGgECBAgQIECAQFMFcvz4vlzdf5rS2+sWBgYSIv9vvSz3h23zaufI+sg6uyXcgVbvrHYeeeeLsjwe1tV1BAgQIECAAIFlEhBIWKbV1AsBAnMR8K3YubCblMCYAssVRKgR/j7tbz9K+dcxQdw2tEB+3SnLjU9dLqA2NKYLCRAgQIAAAQIEBgrUOxikVxe7cuX4Jzjwz6Upb0Skb0fEO4kU24N2XxsUSDiL/J9RPzgXSrh7RXLEz6fF6t7NIMiI6+dyAgQIECBAgEDjBQQSGr+EGiBAYBEEbJe+CKugBgKfEli+IMJ1t92qOhjjTUmPyxgCnbL45O/O3V5vK3L8PsbQbiFAgAABAgQIEGi3wJ2hgZsso/6+WX8z/7RY3brrw/ABgYSTTlk8GWcpBKU/UhtqTcexdg8BAgQIECBAoGkCAglNWzH1EiCwkAKjvimwkE0oisBSCixvEOF6uepdWvLq6n7K8c1SLuECNTXMt8Ucn7FAC6YUAgQIECBAgEBDBOrgwHpZbN5X7ijvPdwXRqjn+vh31/yiU5Y799Vx159/+ssa+UWOtNmGI85yit9OV1d37Iow7pPkPgIECBAgQGDZBAQSlm1F9UOAwNwEnB0+N3oTz0/gJCIuzsD8YEvRFFsR8Xx+ZV1U9CLOzvY6nc6rSddxcUzLo9WdOO8fTGP8ceu9enNyb/7243aw+Ped5/Tfz9dWDz9VqR1zFn8dVUiAAAECBAgQWEiBs/6X972+GDaQMEwYoTa4HUgY5vfd+r56N4SqXDm6/YH7p+q7HnvJd3g7Oc9p577XDAv5/CmKAAECBAgQIDBFAYGEKeIamgCBdgl0q2onIv3Srq512x6B/DqndJzO4zgexdH71dXjO7f9PO3tRYof5mMzvSDCdT8332Sr3+hLKXYHncc6n/7rNxXrv4tiLyI9m1cNSztvjh87a0Ud+rjz513V208R3y+tgcYIECBAgAABAgSmIDDczgTDBBKGDSPUTdwKJAx9XEP38jXfVqcs6jD6Bz93BXRv7jb2rtc7XMId3l7GWX/nvlDJFB4eQxIgQIAAAQIEFl5AIGHhl0iBBAg0ScAuCU1aLbV+WiC/joiji/+cnR2N8qbK1ZtTMw4kTD+IcO01oL+TOOtvjmI0i6fvqs7diHg8i/naMcf9bxQ7O7eG6wa4AAAgAElEQVQdT4IuCRAgQIAAAQITFRhid4R6viECCSO9NvkwkHD/77ofvSYaENi968sanbL4533oNzk/Wev1j5bk+IaTHHlvvSz3J/pMGIwAAQIECBAgsEQCAglLtJhaIUBg/gJDvDkw/yJVQOAOgfqcy8j56Dzi6IuyvDiKYZyf2QYSZhdE+OfNt6o6iEjf3rJ5OejbQeP4TfKeqzf69nxjf2Kq967zX1W1uRLpj4nNaCACBAgQIECAAIGlFqhfh60XxfYwTd73nsOnjlyoj567HaL+IJCQ4uthd3774DXfrTDFxRF3K6v/d7OfeteG9bLYvPnPrq6rX3c2OUBtV4RhHlzXECBAgAABAq0XEEho/SMAgACBSQs4P3zSosabnkB+nSMd5pyOJnnG5Qy23zyJHPtx3j+Yx64EN/8dX8QjGwY9L/WbfXl1dX8Jt0Wd3r8ed4x885tdd01++yzemRdpQgIECBAgQIAAgcYI5Mj/G/bb9Z8KJOSIn9fLot4hbeBPvaPjR6GAqpcvL86vO2W5MSzahyH0j3dW6FbVq5tHyN0Vumjw7mJ2RRj2YXEdAQIECBAgQCAiBBI8BgQIEJiwwH3fWJjwdIYjMJJA/QF6RD5IZ2eH0/gwv/5G/me9/puRihr+4osgwvtydf9pSm+Hv22yV978sHmUNw8nW8V4o9V/P+Uc+0uyNep4CA+86+bZt3cN5fieByK7nQABAgQIECDQIoFhfr+85rj7/Yb8+n1RbH7qdVL9Oub2XNevbUZ9XfPRrni3d0moevXxf8//WcYBRztc/9m7qle/Pvm+QUtuV4QGLZZSCRAgQIAAgcUQEEhYjHVQBQECSyZgl4QlW9CGt1N/GyXlfPi+KA6n/UH+XeeFPpBwIYIIdQ+3tx8dZXvVBxpM9PbLdYq9m99amugESzzYp7bB/eeN4ttvwC6xh9YIECBAgAABAgQeJjDMDlz//J7Z621Fjt8/mnGI4xYuwwcf7mZwHUh4X6w+HeW14ruq2k2Rfrqu43ag4XZg4VO/Q1+G2nvHDXhtYleEhz3q7iZAgAABAgRaLCCQ0OLF1zoBAtMTmNKHstMr2MjLJnASkQ/P86PDSR7FMAzSZI9ryK/rD81nEaQYprf6mkHfSBrlDcRh55nFdRdv/FX93UhRb+va5HNbZ8H17xyf+HbX9UUN/JbXbA3NRoAAAQIECBAgcC3wslMWW8NyDHo9MmxI+ip8cNIpiyfDznfXdbfrqHfiu3kcxO3XGvftAtGAnSbtivDQh8b9BAgQIECAQKsFBBJavfyaJ0BgmgK3z0yc5lzGJhARcwshXOvf3j3gAavysj5WolOWBw8YYyq3frQ1aUQ0NZBwDXT1jaT9iPTtVNCWbNBh3vAd9JwsGYN2CBAgQIAAAQIEJiLw4Y4F9w058IP7W8cl3DXG9W4Iw+z4NU4dg3ZZuA4mdNaKvfvGnGy4/b7Zhv5zuyIMTeVCAgQIECBAgMDdAgIJng4CBAhMScAHUlOCNewNgfw6Rzo8j3zwRVkez5umW1UHD/tQO7+IlA46RVGfN7qQP4N6bHog4Rr6KlBSh0D+Pet1IVdh3kXl152y3PhUFf7+n/camZ8AAQIECBAg0BCBIXbfutnJR4GEIe+/eV+O+Hm9LOpd0sb+GRSMeGjQ4TIo3X+1QLu32RVh7CfEjQQIECBAgACBDwUEEjwRBAgQmJLABL8tPqUKpzhsiq8Hjp7zRuS0kVM8SRGbEXmjAedEThFqnKEXK4TwwZtjF2eSxklOcZTO4zhSfpWjXut/zxb9uOO6n9g/LYqDUc4sHUfuofcMfoNstG80PbSGWdxfv7mYc+yniK9mMV8T57gvhOLYniauqpoJECBAgAABAvMQyN+NsjPcrSDAyftidWOY11G3AgkfHK8wTtcDd2oYMhzxqfkWJNhrV4RxHgr3ECBAgAABAgQ+ISCQ4PEgQIDAFAXaeGzD7bMjh+G9/AA0b16GFGJLSOG22uKGEO5b36tgTr17w+Pra+tnJOU4PEv5cBF2drivh+s/H/Dm2Emc9Tc7nU79LZ6l+7n8UD32/Ps4YGlTfP2pnTwacAbu0j2vGiJAgAABAgQINFLgnt8rb/f0we+ZIwQAbv9+Ouh4hVH8Bv2+O+hos79P+9ufr60ejjR2Vb2a42sQuyKMsliuJUCAAAECBAgMKSCQMCSUywgQIDCOQLfq1VvPt2v78xHeFLnL9PJD7JWty3BCWwMKzQ0h3F7Xi50F+v06bBKLfBzDp/4dH7A7wslZ5K0mBSrG+Tvs+szXSFFv6fpPqGScsZbpnhz5f+tluX/n32G93lbk+H2ZetYLAQIECBAgQIDAFATO+l+OEnC+EQQYeneEuuqPAgQjBiFud35HAPdlpyzq1/D//HQvdtHLL94Xxe4wOzlc1HoRjE6/TEH7U0PaFWHG4KYjQIAAAQIE2iUgkNCu9dYtAQIzFliQ7QZn2vVZ5P9M+kPav6pq89FlMGFnybeRP4nIh+f50eGo3yKZ6SK3cLJ/QjIpvco5ts8jH0z6OV9k1stARm8/In27yHXOqrb7zt21Q8KsVsI8BAgQIECAAIFmC9x3FNjt7v75PXPELwLUOxU8SvnXf8Yb8f476/jwD046ZfHk5j+6DCRE1LvknRarW8OHEmb35Y66tvPIO216fdfsf2tUT4AAAQIECDRRQCChiaumZgIEGiPwrtc7TDm+aUzBDy/0ozcgHj7khyNcfTC6nVPaXhJbIYRJPyTGm5pAHQ5aiVTvDNCunV8+Fv3o218fvPFqh4SpPYMGJkCAAAECBAgsj0B+3SnLjVH6uQokHL4vVjeG/XC/Hv/jL0vkF52yrI9oG+vnrgDu7YDFdSDhapJP/g49l9+nHxjMGAvPTQQIECBAgACBFgoIJLRw0bVMgMDsBLrzPftwdo3+M9PD3tQYteAGhxOEEEZdbNcvlMDlG5D5YI5nu87b45PhKzskzHt5zE+AAAECBAgQaITA0B/QX3dz8XvmeWx11oq9UTocsHvjyHPfnG/MQELcd/TZB3NM9QjM/PosYtuuCKM8Ra4lQIAAAQIECIwvIJAwvp07CRAg8EmBOZ17OOdVyd91yvJgHkVchxPqYx0W9dvbOcVvKefDeRnNY13MudwCV3/P1TsmPF7uTj/u7lPb676rqt0U6ae2meiXAAECBAgQIEBgFIHRA/31jmW9ong1yu4IdUUDAgkP3t3w1u4HF43fs0NCfcnJsLs7TC/km1+8L4rdUQ1HWVnXEiBAgAABAgQIfCggkOCJIECAwBQELs+bXz1u24d074vVp4vwor72zysr23U4IUV8NYUlHnrI6xDC+6I4XASboQt3IYEhBS7CQFV/N1LstujvvE8f2XDa24sUPwxJ6DICBAgQIECAAIE2CszwuIABgYSPwgOjLMG4OyTUc8xxl4R6p8JdXxAYZaVdS4AAAQIECBCYjIBAwmQcjUKAAIF/BC7PWI/Dtm1lniP+XC+LzUV7FOYUTngZkQ/aFEL4+7S/ndP5q5tbXnY/2GJzfrtnLNozuaz1XAaxVvYi0rfL2uN1Xzni5/WyqAMYA38GveG77Cb6I0CAAAECBAgQGFVgdq+RBv1++pAvFDwskDD8eweT2iWhfr/iPPKOIxpGfUZdT4AAAQIECBCYjIBAwmQcjUKAAIELgasX+U3+lvDLHHEckV+llOodHv79yXkjR6oDB1sDdx2Y4bc7xn3cphlOqN/gqEMI6ezssNPpvBq3xibfdzuU8G8gYXZvtDXZb1lqvwxlpfoYh+fL0tPtPu77Vle3qg7aEMxY1vXVFwECBAgQIEBgJgIpvu4UxdEs5vowLH414wPmf0ggoZ79U8ef3fboVtWrh33hwxENs3jGzEGAAAECBAgQ+JSAQILngwABAg8UqLcrX+v16qMBdh/2IvmBhXz69ovtxS/eNBjwc5bz21G+KXCxRXuvt51T2k45vqmHPIv8n1HGmGq3Qwx+9W3uraseapfHQ9z2wSVCCB+L3QwlXL7plQ9siTnqk7Uc11++SZnrD+afLUdH/3Zx3993A9/wXTYE/RAgQIAAAQIECDxM4Kz/5azC7A0PJOxEpF/GwxaOH8/NXQQIECBAgACByQoIJEzW02gECLRM4PJD7dX/a0Dbnzzv/CH1Xwcy1suy/kZ0Y3/qb3U/utz9YTMibcTFfw8MKbzMkQ/bvBPCfYtcW9bhlOv/vu96f77cAt2qqt9ArP9+GDn0s6AyJ52yePKp2h7+La4F7VxZBAgQIECAAAECExMYZZeAh046o0DCR78nd6teHlT7KL1ffiGiX+9COMrriZOzyFtN+tLEQ9fY/QQIECBAgACBRRYQSFjk1VEbAQKNEGjIN2GnFkhoxCIpkgCBuQpcvIlY9XcjxQ9zLWQik+cXnbLc+dRQd73xOpHpDUKAAAECBAgQILAMAjN9jT7pQEK9M96jlH+9tRAf9TSJQEI9xyhHotU7Gaaz/vasdp9YhodRDwQIECBAgACBaQsIJExb2PgECCy9wF1nJy5Y4zN9s2PBelcOAQILInB1VMpeRPp2QUoauYzznP77+drq4V031juDrET6Y+SB3UCAAAECBAgQINAagRzx83pZ7M6q4UkHErqnvb0BYeOhAgl1YGC9LOodCYf+GfZ9l3rs02J162lKb4ce3IUECBAgQIAAAQJTFxBImDqxCQgQaINAA3ZJEEhow4OoRwINEbh6Q3EvIp43pOSrMvPrTlnWR7rc+XN1RMWYZ9w2S0O1BAgQIECAAAEC4wrk7zpleTDu3aPeN3CnghRfd4riaNSx6usHBhJy/NhZK+rf8f/5GTTvuGGMbtWrQwafOLbh/p3MxunVPQQIECBAgAABAg8XEEh4uKERCBAgEMOm9edHNds3O+bXp5kJEGiSwOVWr+f7EelZI+oe8Cbr7brfVb39FPF9I/pRJAECBAgQIECAwFwEziL/54uyPJ7V5JMOJLzr9Q5Tjm9u1p8j/2+9LPdv/rOB8571vxznOIVBc/47lzDCrJ4l8xAgQIAAAQIExhEQSBhHzT0ECBAYIDClXRJefjBVjqNIeSMi3fiG7sX//8SHefd/o9eCEiBAYJ4C76pqN0Wqv031iW88zbPCi7lP3herG/dt//qu6h2niK/mXq0CCBAgQIAAAQIEFlRg9q/RJx5IGPQ774AdF27PO+7uCPVCXoaZ868fL6owwoI+6MoiQIAAAQIECPwjIJDgYSBAgMCEBB64S8LLHHGcIh9HSq/er64e3/eh1+2y3+T85LN+fzNy3oicNvKj2Ew51+cy7s1yK8gJcRqGAIGWCVz8HVb1dwecRbsQEoO+8TXw7+Fe/81CFKwIAgQIECBAgACBBRWY/QfogwIJ74vVp6O+73ANOux4N6/LEX+eFqtb485Zz/3x8Wizt1zQh0pZBAgQIECAAIGFFhBIWOjlURwBAk0TGHKXhJOc4ihyPkopHY97ZmPTbNRLgACBYQS63e5GrKzsRaRvh7l+FtfUb56ul0Ud8Prkz93f2rrvTn9OgAABAgQIECDQGoEBOwlMs/eL4O+A0GynLMZ6X/ivqtpcifTHhzUP3vXhZiBhUsdU3AglvOyUxdY07YxNgAABAgQIECAwGYGxfvGczNRGIUCAwPIJ3LVLQv1hVspxGI/iSABh+dZdRwQITF7g6u/T+hiH55MffaQRT84ibw1zxm+3qg4WKUgxUpcuJkCAAAECBAgQmInAQ3YmGKfAO96nOOmUxZOxxquqnYj0y4f3Dt6p4J9AQo4fO2tF/bv9RH7qIHBVrhw9ZLeFiRRiEAIECBAgQIAAgaEEBBKGYnIRAQIEhhe42iVhMyIfRsTR+6I49CJ5eD9XEiBA4KbA5Tegot4x4dk8ZM5z+u/na6v13+f3/nSr6tW86ry3OBcQIECAAAECBAgsisBMv9l/RyBh7BoGh3Dzd4OOiqwDCcPuNrYoi6MOAgQIECBAgACByQsIJEze1IgECLRcoN4OUQCh5Q+B9gkQmLhA97S3Fyl2I+LxxAe/c8DBb6wOunzw1rWzq9RMBAgQIECAAAECzRHIkf+3Xpb7s6h4UCAhp/htvSi2x5l/YAj3rP9lp9N5dXu8OpAwqaMarseuA8uDwg/j9OIeAgQIECBAgACB2QgIJMzG2SwECBAgQIAAAQIPFKgDX2u9/l6K+P6BQw1x+/BhhHowxzUMQeoSAgQIECBAgACBa4GTOOtvDvoQf9JEA3dIGPMIhUEh3E/tgPCuqnbT2dnh+88+ezupL25c9NPvv5qF3aTXwngECBAgQIAAgbYKCCS0deX1TYAAAQIECBBoqEC3293Iq6v7Kcc3k28hvz6L2P6iLI9HGbtb9d7OdveGUapzLQECBAgQIECAwKIJ1B/knxarW5P6oP6u/v4+7W8/SvnXm38+yrFkN++7CBhE+unmPxtmt4dJ72ow6fEW7dlQDwECBAgQIEBg2QQEEpZtRfVDgAABAgQIEGiJwNW3vfYi4vkkWs4RP58Wq3ujvilcvyEakX6ZRA3GIECAAAECBAgQaI9AfXTC6erqzqi/f44idHX02Q837xn3GIV3Ve84RXz1wfx3HNdw85o6FFGVK0eT6rMOKNshYZSnwLUECBAgQIAAgfkKCCTM19/sBAgQIECAAAECDxS4DATEXkR6Nt5Q+UWcne2N+6Zmt+odTSoUMV797iJAgAABAgQIEGiuQH6dI/ZTSh/s0NUpivp3zAf/DAgknHTK4smoA9chgFhZ/b+b99WBivWi2B5mrDqU8Pna6uEw17qGAAECBAgQIEBguQQEEpZrPXVDgAABAgQIEGitwNWbrbtDHp3wMkc+rM+0HTeIUEMPPJO3tSugcQIECBAgQIAAgQkKnETkw/P86PAhH+S/yfnJWq9/dGNng5edstgatc5BxzVEiq8nFZwYtR7XEyBAgAABAgQINEdAIKE5a6VSAgQIECBAgACBewQu33Dt7aSIzYi0cXF5jotvl+WU39bfPJvkm6Z2R/BIEiBAgAABAgQIzEDg5Czy1hdl+cEuCsPO+0EoIcePnbWiPvZspJ93vd5hyvHNjZvGCjaMNKmLCRAgQIAAAQIElkJAIGEpllETBAgQIECAAAECsxawO8Ksxc1HgAABAgQIEGirQH7dKcvLsO2YP9ehhPPIO+MEG27/7nsW+T/jjDNm+W4jQIAAAQIECBBosIBAQoMXT+kECBAgQIAAAQLzE7A7wvzszUyAAAECBAgQaJdA/q5TlgcP7bkOJTxN6e244/zz+++YuyyMO6/7CBAgQIAAAQIEmi0gkNDs9VM9AQIECBAgQIDADAS63e5Gp9N5dT1Vt6p2ItIvM5jaFAQIECBAgAABAgsskCP+TBEXH/LniOOUL//3xf+/OjLsvvJzzpsppyc3r8uPYjPleJJTvF0viu37xpjFn1/sknAeW+Mc+TCL+sxBgAABAgQIECCwmAICCYu5LqoiQIAAAQIECBBYIIGLN1/7/Vd1KKH+ZtlnvX4dTni8QCUqhQABAgQIECBAYHoCLyPyq8jp1Xmk40eP8ttOURxNbzojEyBAgAABAgQIEFgeAYGE5VlLnRAgQIAAAQIECExRoN4Vod4q9+/T/vajlH+d4lSGJkCAAAECBAgQmI/ASUQcR46ji+DBee/45i5Z8ynJrAQIECBAgAABAgSaLSCQ0Oz1Uz0BAgQIECBAgMCMBG7ukuDIhhmhm4YAAQIECBAgMF2Bk5ziKHI+Oo84+qIsj6c7ndEJECBAgAABAgQItE9AIKF9a65jAgQIECBAgACBCQgIJUwA0RAECBAgQIAAgRkL5Ig/U47Ds5QPBRBmjG86AgQIECBAgACBVgoIJLRy2TVNgAABAgQIECAwCYHuaW8vUvwwibGMQYAAAQIECBAgMB2BOoQQkQ/S2dmhIximY2xUAgQIECBAgAABAncJCCR4NggQIECAAAECBAg8QKBbVQcR6dsHDOFWAgQIECBAgACBCQsIIUwY1HAECBAgQIAAAQIExhQQSBgTzm0ECBAgQIAAAQIErgWEEjwLBAgQIECAAIGFEDjJEQfnkQ8cx7AQ66EIAgQIECBAgAABAiGQ4CEgQIAAAQIECBAgMAEBoYQJIBqCAAECBAgQIDCGQL0bQoq83ynLgzFudwsBAgQIECBAgAABAlMUEEiYIq6hCRAgQIAAAQIE2iXwruodp4iv5tD1y8hxFCl+mMPcpiRAgAABAgQIzEkgvziL2Lcbwpz4TUuAAAECBAgQIEBgCAGBhCGQXEKAAAECBAgQIEBgGIE3OT9Z6/WPZhpKSPF1pyiO3vV6hynHN8PU6RoCBAgQIECAQIMFTiLHfpz3DzqdzqsG96F0AgQIECBAgAABAq0QEEhoxTJrkgABAgQIECBAYFYCswwl5Iif18tit9vtbsTK6v/NqkfzECBAgAABAgRmL5Bf54j906I4eJrS29nPb0YCBAgQIECAAAECBMYREEgYR809BAgQIECAAAECBD4hMKNQwsn7YnWjfkO+W1UHEelbi0KAAAECBAgQWD6B/Doi9jplebB8vemIAAECBAgQIECAwPILCCQs/xrrkAABAgQIECBAYA4CV7sWHEfE42lMf57Tfz9fWz20O8I0dI1JgAABAgQIzF9AEGH+a6ACAgQIECBAgAABAg8XEEh4uKERCBAgQIAAAQIECAwU+KuqNlciHU0hlPCyUxZb9aTd095epPjBEhAgQIAAAQIElkNAEGE51lEXBAgQIECAAAECBC4FBBI8CQQIECBAgAABAgSmKDCFUMJJnPU3O53Oq/poiM96/VdTCDxMUcTQBAgQIECAAIFBAoIIngsCBAgQIECAAAECyyggkLCMq6onAgQIECBAgACBhRKYZCghR/7felnu1w12q2onIv2yUM0qhgABAgQIECAwkoAgwkhcLiZAgAABAgQIECDQMAGBhIYtmHIJECBAgAABAgSaKTCJ8EBO8dt6UWxfC3Sr6lVEetZMEVUTIECAAAEC7RYQRGj3+uueAAECBAgQIECgLQICCW1ZaX0SIECAAAECBAjMXeCBoYST98XqxtOU3taNdHu9rcjx+9ybUgABAgQIECBAYCQBQYSRuFxMgAABAgQIECBAoOECAgkNX0DlEyBAgAABAgQINEtg7FBCiq87RXF03W23qg4i0rfN6l61BAgQIECAQFsFcsSfKfJ+pywP2mqgbwIECBAgQIAAAQJtFBBIaOOq65kAAQIECBAgQGCuAu+qajdF+mnoInL82Fkr9q6vf5Pzk896/TdD3+9CAgQIECBAgMD8BF5Gir2bwcr5lWJmAgQIECBAgAABAgRmLSCQMGtx8xEgQIAAAQIECBCoj1wYeoeD/KJTljs30cbeZYE8AQIECBAgQGB2AoIIs7M2EwECBAgQIECAAIGFFRBIWNilURgBAgQIECBAgMCyC9wXSqi3Nj4tVreepvT2psW7Xu8w5fhm2X30R4AAAQIECDRRIL+IlA7siNDEtVMzAQIECBAgQIAAgckLCCRM3tSIBAgQIECAAAECBIYWuCuUcFcYwXENQ9O6kAABAgQItFngJCK/jUjPZoRQz3cYZ2d7nU7n1YzmNA0BAgQIECBAgAABAg0QEEhowCIpkQABAgQIECBAYLkFulXvKCKeX3d5Vxih/vO/T/vbj1L+dblFdEeAAAECBAiMKVAHA3Y7ZXlQ39/t9bYi54PpBRPy6xyxf1oUB7d3dBqzfrcRIECAAAECBAgQILBkAgIJS7ag2iFAgAABAgQIEGieQL3rwVqvf5QivoqIl++L1e273tR/V/X2U8T3zetSxQQIECBAgMA0BepAYzrrb9/eoeBqd6V614LHk5o/p/gtn6eDz9dWDyc1pnEIECBAgAABAgQIEFhOAYGE5VxXXREgQIAAAQIECDRM4PLDgt729Tca7yr/XdU7vgouNKxD5RIgQIAAAQJTFDg5z2nnroDAX1W1uRLpj4fNn19HTgdx3j9wLMPDJN1NgAABAgQIECBAoE0CAgltWm29EiBAgAABAgQINF6gW/Vy45vQAAECBAgQIDAlgfzifVHsDtppqXva24sUP4w+cX5xnh8d2g1hdDl3ECBAgAABAgQIECAQIZDgKSBAgAABAgQIECDQEIHLc6Dj94aUq0wCBAgQIEBgPgInOfLeelnu356+W1WvItKz+8qqj2RIOR++L4rDu46Rum8Mf06AAAECBAgQIECAAIFaQCDBc0CAAAECBAgQIECgIQLvqmo3RfqpIeUqkwABAgQIEJijQI74M6XY7RTF0XUZnwo3CiHMcbFMTYAAAQIECBAgQGCJBQQSlnhxtUaAAAECBAgQILBcAuNvtbxcDrohQIAAAQIERhH48BiHbtWrAwrPI/LriDhyHMMolq4lQIAAAQIECBAgQGBUAYGEUcVcT4AAAQIECBAgQGBOAv9+gDCnAkxLgAABAgQINFQgv+iU5U5dfLfb3aj/u9PpvGpoM8omQIAAAQIECBAgQKBBAgIJDVospRIgQIAAAQIECLRbQCCh3euvewIECBAgMK7AeU7//Xxt9XDc+91HgAABAgQIECBAgACBcQUEEsaVcx8BAgQIECBAgACBGQu8yfnJWq+3kyJ2I9KzGU9vOgIECBAgQKCRAvl1pywvdkXwQ4AAAQIECBAgQIAAgVkLCCTMWtx8BAgQIECAAAECBCYg0K2qnYi0HxGPJzCcIQgQIECAAIElFcgRP6+Xxe6StqctAgQIECBAgAABAgQWXEAgYcEXSHkECBAgQIAAAQIE7hK43DGhv5civqdEgAABAgQIEBgkcBb5P1+U5TEdAgQIECBAgAABAgQIzENAIGEe6uYkQIAAAQIECBAgMEGBv6pq81GkgxTx1QSHNRQBAgQIECDQeAHHNTR+CTVAgAABAgQIECBAoOECAgkNX0DlEyBAgAABAgQIEKgF6uRQkU0AACAASURBVN0SPuv19iPSt0QIECBAgAABArVAjvy/9bKsj3jyQ4AAAQIECBAgQIAAgbkICCTMhd2kBAgQIECAAAECBKYj0K2qnYj0y3RGNyoBAgQIECDQKIGz/pedTudVo2pWLAECBAgQIECAAAECSyUgkLBUy6kZAgQIECBAgAABAhH1EQ4rkY4i4jEPAgQIECBAoJ0COcVv60Wx3c7udU2AAAECBAgQIECAwKIICCQsykqogwABAgQIECBAgMAEBS5DCXEYkZ5NcFhDESBAgAABAo0RyN91yvKgMeUqlAABAgQIECBAgACBpRQQSFjKZdUUAQIECBAgQIAAgYg3OT9Z6/WPUsRXPAgQIECAAIFWCZx0yuJJqzrWLAECBAgQIECAAAECCykgkLCQy6IoAgQIECBAgAABApMREEqYjKNRCBAgQIBAswTyi05Z7jSrZtUSIECAAAECBAgQILCMAgIJy7iqeiJAgAABAgQIECBwQ6AOJXzW6x07vsFjQYAAAQIE2iFwFvk/X5TlcTu61SUBAgQIECBAgAABAossIJCwyKujNgIECBAgQIAAAQITEvirqjZXIh1FxOMJDWkYAgQIECBAYAEFcsSf62WxuYClKYkAAQIECBAgQIAAgRYKCCS0cNG1TIAAAQIECBAg0E4BoYR2rruuCRAgQKBtAvm7TlketK1r/RIgQIAAAQIECBAgsJgCAgmLuS6qIkCAAAECBAgQIDAVgb9P+9uPUv51KoMblAABAgQIEJi3wMn7YnXjaUpv512I+QkQIECAAAECBAgQIFALCCR4DggQIECAAAECBAi0TOBdVe2mSD+1rG3tEiBAgACBFgjkF52y3GlBo1okQIAAAQIECBAgQKAhAgIJDVkoZRIgQIAAAQIECBCYpEC3qg4i0reTHNNYBAgQIECAwHwFziL/54uyPJ5vFWYnQIAAAQIECBAgQIDAvwICCZ4GAgQIECBAgAABAi0VeFf1jlPEVy1tX9sECBAgQGCpBHLEn+tlsblUTWmGAAECBAgQIECAAIHGCwgkNH4JNUCAAAECBAgQIEBgPIFut7sRK6v1tygfjzeCuwgQIECAAIHFEcjfdcryYHHqUQkBAgQIECBAgAABAgQiBBI8BQQIECBAgAABAgRaLNDt9bYix+8tJtA6AQIECBBYBoGT98XqxtOU3i5DM3ogQIAAAQIECBAgQGB5BAQSlmctdUKAAAECBAgQIEBgLIHuaW8vUvww1s1uIkCAAAECBOYukCN+Xi+L3bkXogACBAgQIECAAAECBAjcEhBI8EgQIECAAAECBAgQIBDdqncUEc9RECBAgAABAg0UOOt/2el0XjWwciUTIECAAAECBAgQILDkAgIJS77A2iNAgAABAgQIECAwjMCbnJ981uvXH2Q8HuZ61xAgQIAAAQKLIZBT/LZeFNuLUY0qCBAgQIAAAQIECBAg8KGAQIInggABAgQIECBAgACBC4G/T/vbj1L+FQcBAgQIECDQIIEUX3eKot7pyA8BAgQIECBAgAABAgQWTkAgYeGWREEECBAgQIAAAQIE5ifwrurtp4jv51eBmQkQIECAAIHhBfLrTlluDH+9KwkQIECAAAECBAgQIDBbAYGE2XqbjQABAgQIECBAgMBCC9RHN6z1+kcp4quFLlRxBAgQIECAQETk7zpleYCCAAECBAgQIECAAAECiyogkLCoK6MuAgQIECBAgAABAnMS+KuqNlci/TGn6U1LgAABAgQIDCdw8r5Y3Xia0tvhLncVAQIECBAgQIAAAQIEZi8gkDB7czMSIECAAAECBAgQWHiBd1W1myL9tPCFKpAAAQIECLRVIMePnbVir63t65sAAQIECBAgQIAAgWYICCQ0Y51USYAAAQIECBAgQGDmAt2qdxQRz2c+sQkJECBAgACB+wXO+l92Op1X91/oCgIECBAgQIAAAQIECMxPQCBhfvZmJkCAAAECBAgQILDQAt1udyNWVo8j4vFCF6o4AgQIECDQOoH8olOWO61rW8MECBAgQIAAAQIECDROQCChcUumYAIECBAgQIAAAQKzE/j7tL/9KOVfZzejmQgQIECAAIF7BeyOcC+RCwgQIECAAAECBAgQWAwBgYTFWAdVECBAgAABAgQIEFhYgXe93mHK8c3CFqgwAgQIECDQLoGXnbLYalfLuiVAgAABAgQIECBAoKkCAglNXTl1EyBAgAABAgQIEJiRwJucn3zW6x1HpGczmtI0BAgQIECAwF0CKb7uFMURIAIECBAgQIAAAQIECDRBQCChCaukRgIECBAgQIAAAQJzFuj2eluR4/c5l2F6AgQIECDQdgG7I7T9CdA/AQIECBAgQIAAgYYJCCQ0bMGUS4AAAQIECBAgQGBeAt3T3l6k+GFe85uXAAECBAi0XsDuCK1/BAAQIECAAAECBAgQaJqAQELTVky9BAgQIECAAAECBOYo0K169RbRz+dYgqkJECBAgEBLBfLrTllutLR5bRMgQIAAAQIECBAg0FABgYSGLpyyCRAgQIAAAQIECMxDoNvtbsTK6nFEPJ7H/OYkQIAAAQLtFcjfdcryoL3965wAAQIECBAgQIAAgSYKCCQ0cdXUTIAAAQIECBAgQGCOAn+f9rcfpfzrHEswNQECBAgQaJmA3RFatuDaJUCAAAECBAgQILA0AgIJS7OUGiFAgAABAgQIECAwO4HuaW8vUvwwuxnNRIAAAQIE2ixgd4Q2r77eCRAgQIAAAQIECDRZQCChyaundgIECBAgQIAAAQJzFOhWvaOIeD7HEkxNgAABAgRaIGB3hBYsshYJECBAgAABAgQILK2AQMLSLq3GCBAgQIAAAQIECExX4E3OTz7r9Y4j0rPpzmR0AgQIECDQZgG7I7R59fVOgAABAgQIECBAoOkCAglNX0H1EyBAgAABAgQIEJijwF9VtbkSqd4p4fEcyzA1AQIECBBYUgG7IyzpwmqLAAECBAgQIECAQGsEBBJas9QaJUCAAAECBAgQIDAdgW6vtxU5fp/O6EYlQIAAAQJtFrA7QptXX+8ECBAgQIAAAQIElkFAIGEZVlEPBAgQIECAAAECBOYs0K2qnYj0y5zLMD0BAgQIEFgmgZedsthapob0QoAAAQIECBAgQIBA+wQEEtq35jomQIAAAQIECBAgMBUBoYSpsBqUAAECBNoqkOLrTlHUxyL5IUCAAAECBAgQIECAQGMFBBIau3QKJ0CAAAECBAgQILB4AkIJi7cmKiJAgACBRgrYHaGRy6ZoAgQIECBAgAABAgRuCwgkeCYIECBAgAABAgQIEJiogFDCRDkNRoAAAQJtFLA7QhtXXc8ECBAgQIAAAQIEllJAIGEpl1VTBAgQIECAAAECBOYrIJQwX3+zEyBAgECTBfKLTlnuNLkDtRMgQIAAAQIECBAgQOBaQCDBs0CAAAECBAgQIECAwFQE/qqqzZVI9dnXj6cygUEJECBAgMAyCpz1v+x0Oq+WsTU9ESBAgAABAgQIECDQPgGBhPatuY4JECBAgAABAgQIzEzgMpQQhxHp2cwmNREBAgQIEGioQI74eb0sdhtavrIJECBAgAABAgQIECDwkYBAgoeCAAECBAgQIECAAIGpCrzJ+clar3+UIr6a6kQGJ0CAAAECzRY4eV+sbjxN6W2z21A9AQIECBAgQIAAAQIE/hUQSPA0ECBAgAABAgQIECAwdYE6lPBZr7cfkb6d+mQmIECAAAECDRTIkf+3Xpb7DSxdyQQIECBAgAABAgQIELhTQCDBw0GAAAECBAgQIECAwMwE3lXVbor008wmNBEBAgQIEGiEQH7dKcuNRpSqSAIECBAgQIAAAQIECIwgIJAwApZLCRAgQIAAAQIECBB4uEC319uKHIcR8fjhoxmBAAECBAgsgUCKrztFcbQEnWiBAAECBAgQIECAAAECHwgIJHggCBAgQIAAAQIECBCYucDlEQ79OpTwfOaTm5AAAQIECCyQQE7x23pRbC9QSUohQIAAAQIECBAgQIDAxAQEEiZGaSACBAgQIECAAAECBEYVcITDqGKuJ0CAAIElEziJs/5mp9N5tWR9aYcAAQIECBAgQIAAAQIXAgIJHgQCBAgQIECAAAECBOYq8FdVbT6KdJAivpprISYnQIAAAQKzFsjxY2et2Jv1tOYjQIAAAQIECBAgQIDArAQEEmYlbR4CBAgQIECAAAECBD4pcLVbQv2hzGNUBAgQIEBg+QXy605Zbix/nzokQIAAAQIECBAgQKDNAgIJbV59vRMgQIAAAQIECBBYMIFut7uRV1f3U45vFqw05RAgQIAAgckKpPi6UxRHkx3UaAQIECBAgAABAgQIEFgsAYGExVoP1RAgQIAAAQIECBAgEBHdXm8rcj6ISM+AECBAgACB5RPILzplubN8femIAAECBAgQIECAAAECHwoIJHgiCBAgQIAAAQIECBBYWIFuVdUf1uwJJizsEimMAAECBEYXOHlfrG48Tent6Le6gwABAgQIECBAgAABAs0SEEho1nqplgABAgQIECBAgEArBQQTWrnsmiZAgMBSCpzn9N/P11YPl7I5TREgQIAAAQIECBAgQOCWgECCR4IAAQIECBAgQIAAgcYIXAYTUr1rwvPGFK1QAgQIECBwJZBT/LZeFNtACBAgQIAAAQIECBAg0BYBgYS2rLQ+CRAgQIAAAQIECCyRwF9VtbkSsRuR6g91Hi9Ra1ohQIAAgeUVcFTD8q6tzggQIECAAAECBAgQuENAIMGjQYAAAQIECBAgQIBAYwXe5Pzks15vO6e0nXJ809hGFE6AAAECSy/gqIalX2INEiBAgAABAgQIECAwQEAgwWNBgAABAgQIECBAgMBSCFyHEyJiy84JS7GkmiBAgMDSCDiqYWmWUiMECBAgQIAAAQIECIwoIJAwIpjLCRAgQIAAAQIECBBohkB9rMOjOpyQ0lbKeTMiPWtG5aokQIAAgSUTcFTDki2odggQIECAAAECBAgQGF5AIGF4K1cSIECAAAECBAgQINBggYsdFPr9zTivQwp5IyJtRMTzBrekdAIECBBogkCKrztFcdSEUtVIgAABAgQIECBAgACBSQsIJExa1HgECBAgQIAAAQIECDRK4J+gQl11HVaIiJziSYrYvNFI/b8fN6oxxRIgQIDA3AVyxM/rZbE790IUQIAAAQIECBAgQIAAgTkJCCTMCd60BAgQIECAAAECBAg0X6Db7W7E6mq908Jcf87P05NHUR9LMfhnQMDi+kI7RMx15UxOgMAyC+SIP9fL4s6/m5e5d70RIECAAAECBAgQIEDgWkAgwbNAgAABAgQIECBAgAABAnERrni0uhMp6m/y2g3CM0GAAIGHCZzEWX+z0+m8etgw7iZAgAABAgQIECBAgECzBQQSmr1+qidAgAABAgQIECBAgMBEBeojLNZ6/b0U8f1EBzYYAQIEWiRwntN/P19bPWxRy1olQIAAAQIECBAgQIDAQAGBBA8GAQIECBAgQIAAAQIECHwkcLFjwsrqQUQ41sHzQYAAgREEcsTP62VR7zbjhwABAgQIECBAgAABAq0XEEho/SMAgAABAgQIECBAgAABAncLvKuq3RRpzzEOnhICBAjcL5Aj/lwvi837r3QFAQIECBAgQIAAAQIE2iEgkNCOddYlAQIECBAgQIAAAQIExhawW8LYdG4kQKBdAifvi9WNpym9bVfbuiVAgAABAgQIECBAgMDdAgIJng4CBAgQIECAAAECBAgQGErAbglDMbmIAIF2CpycRd76oiyP29m+rgkQIECAAAECBAgQIDBYQCDBk0GAAAECBAgQIECAAAECQwvUuyXkldXDFPHV0De5kACBVgjUxxXUjbbz74f8XacsD1qx0JokQIAAAQIECBAgQIDACAICCSNguZQAAQIECBAgQIAAAQIELgW6p729SPEDDwIECPwrcPmhfLfX24ocexHxvBU6OX7srBV1v34IECBAgAABAgQIECBA4JaAQIJHggABAgQIECBAgAABAgTGErj80DEfRKRnYw3gJgIElkrgfbH69GlKb6+bascxL/lFpyx3lmohNUOAAAECBAgQIECAAIEJCggkTBDTUAQIECBAgAABAgQIEGibwJucn6z1+wcpxzdt612/BAj8K5BT/LZeFNu3TZb8mJeXnbLY8hwQIECAAAECBAgQIECAwN0CAgmeDgIECBAgQIAAAQIECBB4sEC3qnYi0n5EPH7wYAYgQKCBApfHNQwqvA4ufdbrHy7TEQ454s/TYnXr5o4QDVw0JRMgQIAAAQIECBAgQGDqAgIJUyc2AQECBAgQIECAAAECBNoh8FdVbT6KdJAivmpHx7okQOCGwL27BXSrqj7i5dumqwkjNH0F1U+AAAECBAgQIECAwCwFBBJmqW0uAgQIECBAgAABAgQILLnA5Tehe/uz+dAxv45Ir8YjzRsR6dl497qLAIFBAjni5/Wy2L1L5+KIl17/qMmhJWEEzz4BAgQIECBAgAABAgRGExBIGM3L1QQIECBAgAABAgQIECAwhMDfp/3tRynX27ePe4TDSUQcR46jnPLblNLxWc5vvyjL4yGmH+mSbq+3FTl+H+kmFxMgMFjgrP9lp9O5Myh0FVo6bmgg6OR9sbrhmAYPPwECBAgQIECAAAECBIYXEEgY3sqVBAgQIECAAAECBAgQIDCCQLfb3cgrq4fDfhs6p/gtcj5KZ2eHn/pAc4QSPri0PlJiJaUn9T+8GW4QSBhX1H0EBgnkF52y3PmUzcW/i5GOHhBYmjl9vTPCeeSdaYSiZt6MCQkQIECAAAECBAgQIDBDAYGEGWKbigABAgQIECBAgAABAm0UeFf19lPE94N7r49diL33RXE4z28dd6tebuPa6JnAVATu2SWhnvNdVe2mSD9NZf4JD+qYhgmDGo4AAQIECBAgQIAAgVYJCCS0ark1S4AAAQIECBAgQIAAgfkIXO5CUB/hkJ5dVfAyUux1iqL+lvTcfwQS5r4EClgmgRw/dtaKvfta6la9+t//5/ddN88/F0aYp765CRAgQIAAAQIECBBYBgGBhGVYRT0QIECAAAECBAgQIECgAQL12fFrvf5einzcKcuDRSpZIGGRVkMtzRfIrztluXFfH1dHN/xx33Xz+nNhhHnJm5cAAQIECBAgQIAAgWUSEEhYptXUCwECBAgQIECAAAECBAiMJdCtem+bdJ79WE26icAMBc5z+u/na6uH903Zrap655Rv77tu9n+eX3TKcmf285qRAAECBAgQIECAAAECyyUgkLBc66kbAgQIECBAgAABAgQIEBhDoAlbx4/RllsIzFFguA/0u93uRqys/t8cC/146iGPnFiomhVDgAABAgQIECBAgACBBRUQSFjQhVEWAQIECBAgQIAAAQIECMxOQCBhdtZmao3ASacsngzT7QLtknASkXcX7UiZYQxdQ4AAAQIECBAgQIAAgUUVEEhY1JVRFwECBAgQIECAAAECBAjMTEAg4f+1dz/GbRxXHIDfkjxIp3jGUgVSB5IrEF1B2IGZDpAKDFdguoJQFQSpwGQFgSsIWYHImVgQD382cxQVJR6JOIKAeMB9nNHYM9jbe+/bg2ZE/LD71ajdqEMCjY9taMEuCTnit3nkw296vVGHlkirBAgQIECAAAECBAgQWLuAQMLaid2AAAECBAgQIECAAAECBNou0KJvaLedSn0EGgvkiF+e9Ip+kwveVZNRinjZZOzqx+Q374ui/yyli9XPbUYCBAgQIECAAAECBAh0W0Agodvrr3sCBAgQIECAAAECBAgQiIjx1WQQKX6EQYDAKgXyednrvWgy47uq6qdIPzcZu8IxjmhYIaapCBAgQIAAAQIECBAg8DkBgQTPBQECBAgQIECAAAECBAh0XkAgofOPAIA1Ccwif9fkGITx1z+24TRm08OyLM/W1LppCRAgQIAAAQIECBAgQCAiBBI8BgQIECBAgAABAgQIECDQeQGBhM4/AgDWJJAj//VJr3fUZPpxVZ1FpOdNxt5jjF0R7oHnUgIECBAgQIAAAQIECNxVQCDhrmLGEyBAgAABAgQIECBAgMDWCfx+NT3YSfnvW9eYhgg8vMBp2Sv2m5QxrqrjiPRDk7HLjMkRv1wVe4NnKV0sc71rCBAgQIAAAQIECBAgQODuAgIJdzdzBQECBAgQIECAAAECBAhsmcB4MtmPHL9uWVvaIdAKgbJXNPr907uq6qdIP6+haMczrAHVlAQIECBAgAABAgQIEGgi0OgfhE0mMoYAAQIECBAgQIAAAQIECGyqgEDCpq6cujdCIMX3ZVGcLKp1De/D00gxaHLvRbV5nQABAgQIECBAgAABAgSWExBIWM7NVQQIECBAgAABAgQIECCwRQJr+CB0i3S0QuB+AvVRCU96RX/RLKt7H+Y3s4ijb3q90aJ7ep0AAQIECBAgQIAAAQIE1isgkLBeX7MTIECAAAECBAgQIECAwIYIjKtJ3pBSlUlgowRyxG9PesWrRUXfL5CQz3PE0VVRHD9L6WLRvbxOgAABAgQIECBAgAABAl9HQCDh6zi7CwECBAgQIECAAAECBAi0XEAgoeULpLyNFih7xcLfQd09kFCHENJwHvnYbggb/XgongABAgQIECBAgACBLRZY+I/BLe5dawQIECBAgAABAgQIECBA4L8CAgkeBgJrFEjxfVkUJ7fdYVEgod5pIUWuj2E4idnspCzLszVWbGoCBAgQIECAAAECBAgQWIGAQMIKEE1BgAABAgQIECBAgAABApsvMK4m9Tbv325+Jzog0EKBHD+Vj4rBbZX9fjU92Em5fz0mx3V4YR5ptLOTLxaFGVrYsZIIECBAgAABAgQIECBAICIEEjwGBAgQIECAAAECBAgQIEAgIsbVpP4A9DUMAgTWInBa9or9tcxsUgIECBAgQIAAAQIECBBorYBAQmuXRmEECBAgQIAAAQIECBAg8DUFBBK+prZ7dVDgsuwVTzvYt5YJECBAgAABAgQIECDQaQGBhE4vv+YJECBAgAABAgQIECBA4KPAu8lkWP9/mkd9Rn3kFE9TxKv48MdRDh4VAvcUmEX+7pte7/r95YcAAQIECBAgQIAAAQIEuiEgkNCNddYlAQIECBAgQIAAAQIECNxDYDwev4jd3Xq7+Zs/6fk9pnMpgY4K5L+Uvd5xR5vXNgECBAgQIECAAAECBDopIJDQyWXXNAECBAgQIECAAIH2CIyr6rCuxodU7VkTlSwW+HdVvdqJdJgiH0QIJywWM4JARI745Umv6LMgQIAAAQIECBAgQIAAge4ICCR0Z611SoAAAQIECBAgQKBVAm9zfvp4MjmKSD9ExOUs8r6tvFu1RIppKPApnBB1uMbRDg3dDOukwGnZK+pdRvwQIECAAAECBAgQIECAQEcEBBI6stDaJECAAAECBAgQINAmgXr7+7y7N0wRLz/Vlc/fF8WrZyldtKlWtRC4i8CHHT9SHUx4fZfrjCXQcoHT6/pynNT/mUca7ezk67+r3+/tjZr8vV2H0IrJ5IXgWctXWnkECBAgQIAAAQIECBBYsYBAwopBTUeAAAECBAgQIECAwO0C48lkP3IMP/dNctt5e3q2ReAmdNNPYdeEbVnTjvRxmiNGEfkspTRqGjboiI02CRAgQIAAAQIECBAgQGAJAYGEJdBcQoAAAQIECBAgQIDAcgI33x7/261Xp/i+LIrrb+H6IbDpAjdHkxxExCAiPd/0ftS/VQLX4YOc08nOfDIqy/Jsq7rTDAECBAgQIECAAAECBAi0QkAgoRXLoAgCBAgQIECAAAEC2y/w+9X0YCflvzfo1BnjDZAM2TyBOpCTI9W7JvzPUSWb14eKN1LgMqc4SfMYxU6cCH1t5BoqmgABAgQIECBAgAABAhspIJCwkcumaAIECBAgQIAAAQKbJzCuqrOm3xCfRf7OOeObt8YqbiZwc2zJICJeN7vCKAJLCZxGjhMBhKXsXESAAAECBAgQIECAAAECKxIQSFgRpGkIECBAgAABAgQIEPiywM0HsL82NsrxU/moqD+w9UNgawUEE7Z2aR+qscuIPJznnWHV2z15ltLFQxXivgQIECBAgAABAgQIECBA4KOAQIJngQABAgQIECBAgACBtQu8q6p+ivRzwxudxmx66DzzhlqGbbyAYMLGL+EDNpDPc6ThPPKxXWUecBncmgABAgQIECBAgAABAgS+KCCQ4OEgQIAAAQIECBAgQGDtAuOrySBS/NjkRu+LvWe+2dtEyphtE/gQTMjHTY822bb+9dNMIEf8FpGP02w2FNxqZmYUAQIECBAgQIAAAQIECDycgEDCw9m7MwECBAgQIECAAIHOCDQPJOQ3Za932BkYjRL4jMC4qur3wGD5YEJ+E5FeRMRrwNsi8GEnhDSbHgkhbMua6oMAAQIECBAgQIAAAQLdEBBI6MY665IAAQIECBAgQIDAgwqMq8lJow9HU3xfFkU91g+BTgu8zfnp42rajxT9iPj2LhgfdxkZj8cv8u5eP0XUAYc7zXGX+xm7NoHLiDycRRw5jmFtxiYmQIAAAQIECBAgQIAAgTULCCSsGdj0BAgQIECAAAECBAhENAwknJa9Yp8XAQKfBOpQQezu1rsl/NDEJaf4x5OiOPjj2A+7LqQ6mGDXhCaQDzimXsM8T8d/erQ3fMAy3JoAAQIECBAgQIAAAQIECKxEQCBhJYwmIUCAAAECBAgQIEDgNoFxNcmLhGaRv/Mt4EVKXu+qwHgy2c85jlLEy9sN8l/KXu/4S2PsmtDWJyifR07HMZ8eO5KhrWukLgIECBAgQIAAAQIECBBYRkAgYRk11xAgQIAAAQIECBAg0Fjgwze89/51nw9RG9/MQAJbLjC+mgxuO8bh43ENTRjsmtBEab1j7IawXl+zEyBAgAABAgQIECBAgMDDCwgkPPwaqIAAAQIEd0FP7QAABKlJREFUCBAgQIDAVgu8zfnp48n07Atn2J/OIvftjLDVj4DmVixwE/Kpd0H44/ELSx17YteEFS/Q4ukuc8Rxmk2P7IawGMsIAgQIECBAgAABAgQIENhsAYGEzV4/1RMgQIAAAQIECBDYCIGbb3X/+KnY/GYWcSSIsBHLp8iWCryrqn6KNPgU9snnOeIozWbDZT/ovtk14egLAaLGEjnit0hxluYxyilfpJRG/3fxPPYj5cOI9LzxpBs/MJ9HxOB9UQyfpXSx8e1ogAABAgQIECBAgAABAgQINBAQSGiAZAgBAgQIECBAgAABAvcT+LhLQk5xkqbT/rIflt6vClcT2D6Bm90Nhini5f93V4cT0jClGJZFcdK0839X1avdSP9sOj4iLiNiFDlO5pFGOc3P7hI0Gk8m+5GjDlX8cbeHO5TQ+qGnkWJwl3VofUcKJECAAAECBAgQIECAAAECDQUEEhpCGUaAAAECBAgQIECAwP0E6g9OBRHuZ+hqAl8SGFfVcUT64QuvX16HgXIexmx2ctv78PZAQj7PKY3qXQ/q8MHOfDJa1Xt6O4MJ+U2kdCyI4H1LgAABAgQIECBAgAABAl0WEEjo8urrnQABAgQIECBAgAABAgS2RuDmuIW/LWro+jiFiJMnvaL/ubF1eCj29l58fG2W88Vddj1YdP/bXt+OYEJ+E7PZYFVhjft4upYAAQIECBAgQIAAAQIECDy0gEDCQ6+A+xMgQIAAAQIECBAgQIAAgRUJ3HygP4yIbxdNWfaK1v5OoO4jR/RTjj8v6qM9rwsitGctVEKAAAECBAgQIECAAAECbRFo7S8f2gKkDgIECBAgQIAAAQIECBAgsEkCN6GEX79Uc71DQoo8Knu9w7b3db1bw+7u4JbjKFrQgiBCCxZBCQQIECBAgAABAgQIECDQUgGBhJYujLIIECBAgAABAgQIbJvAH7eBd676tq2wftokML6aDCLFjxFxmiNGdQBhFjH6WkcvrNribc5PH1fTfqSoj5lYuPvDqu//uflyin+k6bTvaIavoe0eBAgQIECAAAECBAgQILCpAgIJm7py6iZAgAABAgQIECBAgAABAh0UGFfVYUSqd3d4/UDtn0aKgVDVA+m7LQECBAgQIECAAAECBAhslIBAwkYtl2IJECBAgAABAgQIECBAgACBWqDedSXv7vVT5IOI9Hz9Kvl8nnf6f3q0N1z/vdyBAAECBAgQIECAAAECBAhsh4BAwnasoy4IECBAgAABAgQIECBAgEBnBX6/mh7spHkdTDhYw5EOl5HjqHxUDDoLrHECBAgQIECAAAECBAgQILCkgEDCknAuI0CAAAECBAgQIECAAAECBNonMJ5M9nOOOpiwnyJe3q/C/CZms0FZlmf3m8fVBAgQIECAAAECBAgQIECgmwICCd1cd10TIECAAAECBAgQIECAAIGtF3ib89NeNdvfifwqUuxH5BcLjne4jIhRjjxMs9lQEGHrHxENEiBAgAABAgQIECBAgMCaBQQS1gxsegIECBAgQIAAAQIECBAgQKBdAnVQ4fF0+up/qyqL4qRdVaqGAAECBAgQIECAAAECBAhsvsB/ALFB+fuDnFX3AAAAAElFTkSuQmCC"
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-illustrations-virtual-f4c8d3dc38/1/packages/lib-illustrations/src/index.ts


















/***/ }),

/***/ 63930:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "jQ": function() { return /* reexport */ footer_happy_scale; },
  "nz": function() { return /* reexport */ my_account_banner; },
  "p4": function() { return /* reexport */ my_company_banner; },
  "l5": function() { return /* reexport */ my_impersonate_banner; }
});

// UNUSED EXPORTS: Logo

// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(91987);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-images-virtual-95769406cb/1/packages/lib-images/src/logo.svg
var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgLogo = function SvgLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 136,
    height: 39,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.71 7.217h7.713c2.066 0 2.532.689 2.532 1.634s-.466 1.704-2.532 1.704H10.71V7.217Zm0 9.207h8.752c2.024 0 2.643.904 2.643 2.03 0 1.127-.619 2.03-2.643 2.03H10.71v-4.06Zm-10 10.362h22.13c7.585 0 10.105-3.331 10.105-8.402 0-1.925-1.085-5.04-4.416-5.91v-.07c1.954-.764 3.074-2.76 3.074-5.04 0-4.132-2.334-6.448-7.637-6.448H.71v25.87Zm42.679 0h9.82v-7.281L64.876.916H54.02l-5.77 9.388L42.6.916H31.708l11.67 18.589.011 7.281Zm44.506 0h12.783L89.592 10.83 100.322.91H86.774L76.272 10.83V.91h-9.82v25.87h9.814v-6.552l4.569-3.769 7.06 10.327ZM99.44 13.851c0 13.42 11.482 13.845 17.679 13.845 6.196 0 17.672-.437 17.672-13.845C134.792.443 123.31 0 117.12 0c-6.191 0-17.679.438-17.679 13.845v.006Zm10.864-.006c0-5.25 2.649-7.316 6.815-7.316 4.165 0 6.803 2.06 6.803 7.316 0 5.257-2.643 7.323-6.803 7.323s-6.838-2.06-6.838-7.317",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M132.779 33.928a.984.984 0 0 0 .455-.07s-7.888-.047-7.888 0c0 .046 4.02.076 3.88.081h3.553M110.673 32.091a91.236 91.236 0 0 1 2.713-.082l.875-.11h-.251l-4.358.07c-.584 0-1.552.064-1.558.087-.006.023 1.75 0 2.579.04",
    fill: "#FFD330"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M135.323 34.85a1.835 1.835 0 0 0-.338 0h-.175l-2.13-.046c-.192 0 .403-.45.858-.484.315.021.631-.002.939-.07l-1.435-.065c-.134-.005 0 .07-.163.076a10.974 10.974 0 0 0-1.167-.07c-.053-.064 1.75 0 1.75-.04-.6-.045-1.203-.045-1.803 0-.706-.041.082-.076-.764-.123-.584 0-1.406.047-2.101 0 0 0-2.66.035-4.2-.058h.25c.123-.035-1.382-.03-2.269-.065 0 0 11.255-.215 11.255-.239 0-.023-1.558 0-4.23-.064-.07-.04.951 0 .752-.1h-3.553c.14 0 .123 0 .128-.04h-4.632c2.474-.093 5.49-.053 8.512 0 .28.04.636-.053.42-.082-6.26-.134-18.868 0-18.839-.116.029-.117 2.083-.041 3.127-.059 4.954-.07 10.741.053 16.062.076.158-.07.181-.14 0-.222-5.776-.163-11.558-.11-17.328-.221h-.14c-2.474.116-6.482 0-9.574.116-2.334.088-4.983.111-7.469.158l3.46-.146c2.468-.076 4.936 0 7.101-.128.618-.041 1.855 0 2.777 0l1.249-.047-1.366-.04c-.309-.036 7.836-.065 7.533-.164l-11.424-.03c-.922-.081.811-.35 1.435-.367h.158c-.012 0-.584 0-1.068-.03l2.789-.052h.093c-1.564 0-4.755-.052-4.714-.075.041-.024 5.42-.082 8.051-.117-1.791 0-3.839-.041-5.612-.041-7.148.052-13.659.122-20.293.222-.799.052-1.61.087-2.415.099-1.255 0-2.696.052-4.043.064 2.158-.058 4.597-.216 6.727-.25.173-.004.345-.038.507-.1 0 0-6.89.14-10.018.268-.618 0-1.546.1-2.164.1-2.76 0-5.496.134-4.668.122-.992.053-2.818.058-4.562.14-.28 0 .315.123.315.123 1.08.268-2.433.18-6.885.28-3.74.07-7.853.134-9.995.344-.373.046-.75.07-1.126.07a73.042 73.042 0 0 1 8.396-.735c1.786 0 5.374.07 5.38-.064 0-.52-8.25.099-10.724.169-4.936.146-9.627.583-14.242.858-1.885.116-3.775.175-5.66.245l.461-.065c-2.333.094-4.597.187-7.001.35l-.648.041c-4.924.333-9.142.619-14.148 1.004-1.226.099-2.45.227-3.676.332-.916.111.636.059-.887.222 0 0-.583.117 2.754-.187.18 0 .122.088-.228.1-1.808.11-3.955.25-5.887.495 0 0-1.598.041-1.785.035-.187-.005-.257.041-.257.041s-.11.105-.245.257l-.099.117c-.183.21-.319.456-.397.723a.846.846 0 0 0 0 .321c.01.04.022.079.035.117.152.356.665.624 1.937.63h.642c.187 0 .543-.035.467 0-.168.02-.334.053-.496.1.223.024.448.024.671 0 .443-.065 1.103-.228 1.657-.258.858-.07.064.082 1.068 0 5.297-.414 10.467-.67 15.858-.95.128 0 0 0-.175.04l1.785-.105 80.108-1.05c4.084.064 8.11.134 9.335.187.98.058-.98.14-.992.151h2.661c.274 0 1.277.117 1.231 0a6.434 6.434 0 0 1-1.074-.175l1.307.03c.657.042 1.316.042 1.972 0 2.177-.111 4.528.105 6.71.157-.658.078-1.321.115-1.984.11-.292.141 6.214 0 7.626-.057.257 0 1.429-.473 1.61-.485l.963-.274h1.237c1.278.093.927-.35 1.826-.66a2.755 2.755 0 0 0-.659-.075l-.018-.198ZM97.65 32.249c2.094-.18 7.001-.128 7.054-.081.052.046-5.584.116-8.53.169l1.476-.088Zm-5.496.66c-4.014.07-8.338.076-12.352.245h-2.159c2.13-.088 4.05-.199 6.173-.251h.928c.413.003.826-.016 1.237-.059h-.77s3.022-.075 5.437-.087c.164 0 .129 0 .21.047 2.673 0 6.844-.146 7.002-.14l.344-.047c.91.03 1.797.163 2.877.187h.309v-.129c-2.777.146-6.173 0-9.26.053l.024.18Zm14.86.32c-.373 0-7.147-.122-10.572-.064H94.546c.222 0 .445-.016.665-.046h.362c4.037 0 8.267 0 12.252.058a2.21 2.21 0 0 1-.799.082l-.012-.03Zm15.112.695h-1.167l1.452-.035c.152 0 .17.052-.268.047l-.017-.012Zm13.186 1.085a3.692 3.692 0 0 0-.695-.1h.584c.344 0 .443.083.116.106",
    fill: "#FFD330"
  })));
};
/* harmony default export */ var logo = ((/* unused pure expression or super */ null && (SvgLogo)));
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-images-virtual-95769406cb/1/packages/lib-images/src/my-account-banner.svg
var my_account_banner_path, my_account_banner_path2, my_account_banner_path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90;
function my_account_banner_extends() { my_account_banner_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return my_account_banner_extends.apply(this, arguments); }

var SvgMyAccountBanner = function SvgMyAccountBanner(props) {
  return /*#__PURE__*/react.createElement("svg", my_account_banner_extends({
    width: 591,
    height: 345,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), my_account_banner_path || (my_account_banner_path = /*#__PURE__*/react.createElement("path", {
    d: "M252.63 26.16c-29.25-18.91-62.12-5.22-63.51 21.88-24.79 0-47 29.57-30.06 54-30.06 20.52-13.85 74.45 17.3 69.66.38 33.18 44.4 59.16 76.27 41.47 33-18.31 82.06-133.87 82.06-133.87s-33.33-75.13-82.06-53.14Z",
    fill: "#D9EEE8"
  })), my_account_banner_path2 || (my_account_banner_path2 = /*#__PURE__*/react.createElement("path", {
    d: "M283.09 249.33c-13.29-61-54.88-95.26-87.44-113.26-35.34-19.54-68-24.68-68.3-24.73l.32-2.11c.33.05 33.28 5.24 68.95 24.95 33 18.21 75.09 52.89 88.55 114.7l-2.08.45Z",
    fill: "#fff"
  })), my_account_banner_path3 || (my_account_banner_path3 = /*#__PURE__*/react.createElement("path", {
    d: "m171.084 48.166-1.996.742 33.925 91.173 1.996-.742-33.925-91.173ZM306.3 175.83c-54.74-36.1-75.87-81.85-84-113.88-8.76-34.72-4.5-61.29-4.46-61.56l2.1.35c0 .26-4.23 26.47 4.45 60.78 8 31.64 28.9 76.84 83 112.53l-1.09 1.78Z",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/react.createElement("path", {
    d: "M275.425 8.254 229.369 83.54l1.81 1.107 46.057-75.284-1.811-1.108ZM221.76 59.94c-45 0-47.22-41.4-47.24-41.82l2.13-.09a48.303 48.303 0 0 0 6.42 20.2c7.9 13.23 21.25 19.82 39.65 19.57v2.13l-.96.01ZM144.13 160.15l-.87-1.94c.25-.11 24.33-11.07 35.57-31.79l1.88 1c-11.6 21.38-36.33 32.62-36.58 32.73Z",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/react.createElement("path", {
    d: "M51.35 221.91c27.9-21.95 66.22-9.31 80.62 12.82 14.4 22.13 47 30.47 88.48 4.26 41.48-26.21 109.69 2 71.32 75.13H33.93s-32.84-52.64 17.42-92.21Z",
    fill: "#D9EEE8"
  })), _path6 || (_path6 = /*#__PURE__*/react.createElement("path", {
    d: "M536.81 90.1H247.93v202.98h288.88V90.1Z",
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/react.createElement("path", {
    d: "M415.53 68.01s-31.52 21-27.21 48.9c3.38 21.87 26.27 38.72 71.45 33.29 36.17-4.34 39.56 23.57 28.67 53.16-7.09 19.25-14.09 67.79 24 89.72h24.38V59.28l-121.29 8.73Z",
    fill: "#D9D9D9"
  })), _path8 || (_path8 = /*#__PURE__*/react.createElement("path", {
    d: "M450.72 215.45h-120.3v-14.43l53.05-73.04h67.25v87.47Z",
    fill: "#E5F0F6"
  })), _path9 || (_path9 = /*#__PURE__*/react.createElement("path", {
    d: "m411.136 133.685-41.257 55.432 1.709 1.272 41.257-55.432-1.709-1.272ZM394.357 142.803l-23.459 31.519 1.709 1.271 23.459-31.518-1.709-1.272Z",
    fill: "#fff"
  })), _path10 || (_path10 = /*#__PURE__*/react.createElement("path", {
    d: "M451.79 216.51H329.35v-89.59h122.44v89.59Zm-120.31-2.13h118.18v-85.33H331.48v85.33Z",
    fill: "#003C71"
  })), _path11 || (_path11 = /*#__PURE__*/react.createElement("path", {
    d: "M458.55 212H324.16v10.85h134.39V212Z",
    fill: "#003C71"
  })), _path12 || (_path12 = /*#__PURE__*/react.createElement("path", {
    d: "M364.26 128.22h-2.13v85.66h2.13v-85.66Z",
    fill: "#003C71"
  })), _path13 || (_path13 = /*#__PURE__*/react.createElement("path", {
    d: "M363.2 150.57h-23.99v2.13h23.99v-2.13ZM305.75 294.15h-58.58V112.84h2.13v179.18h56.45v2.13ZM519.98 292.02H330.42v2.13h189.56v-2.13Z",
    fill: "#003C71"
  })), _path14 || (_path14 = /*#__PURE__*/react.createElement("path", {
    d: "M302.61 10.41 213 91.61a10.792 10.792 0 0 0 10.79 10.79 10.805 10.805 0 0 0 4.132-.818 10.806 10.806 0 0 0 5.846-5.84c.543-1.31.822-2.714.822-4.132a10.792 10.792 0 0 0 10.79 10.79 10.792 10.792 0 0 0 10.79-10.79 10.798 10.798 0 0 0 18.315 7.424 10.798 10.798 0 0 0 3.275-7.424 10.802 10.802 0 0 0 10.8 10.79 10.792 10.792 0 0 0 10.79-10.79 10.798 10.798 0 0 0 18.315 7.424 10.798 10.798 0 0 0 3.275-7.424 10.792 10.792 0 0 0 10.79 10.79 10.792 10.792 0 0 0 10.79-10.79 10.801 10.801 0 0 0 10.78 10.79 10.792 10.792 0 0 0 10.79-10.79 10.798 10.798 0 0 0 18.315 7.424 10.798 10.798 0 0 0 3.275-7.424 10.798 10.798 0 0 0 18.315 7.424 10.798 10.798 0 0 0 3.275-7.424 10.792 10.792 0 0 0 10.79 10.79 10.792 10.792 0 0 0 10.79-10.79 10.798 10.798 0 0 0 18.315 7.424 10.798 10.798 0 0 0 3.275-7.424 10.798 10.798 0 0 0 18.315 7.424 10.798 10.798 0 0 0 3.275-7.424 10.792 10.792 0 0 0 10.79 10.79 10.797 10.797 0 0 0 10.8-10.79 10.792 10.792 0 0 0 10.79 10.79 10.792 10.792 0 0 0 10.79-10.79 10.798 10.798 0 0 0 18.315 7.424 10.798 10.798 0 0 0 3.275-7.424v-81.2H302.61Z",
    fill: "#FF7D20"
  })), _path15 || (_path15 = /*#__PURE__*/react.createElement("path", {
    d: "M527.22 5.08h-219.2v2.13h219.2V5.08ZM526.02 103.47a11.898 11.898 0 0 1-10.8-6.95 11.855 11.855 0 0 1-10.79 6.951 11.85 11.85 0 0 1-10.79-6.951 11.862 11.862 0 0 1-17.214 5.061 11.862 11.862 0 0 1-4.376-5.061 11.862 11.862 0 0 1-17.214 5.061 11.862 11.862 0 0 1-4.376-5.061 11.855 11.855 0 0 1-10.79 6.951 11.85 11.85 0 0 1-10.79-6.951 11.862 11.862 0 0 1-17.214 5.061 11.862 11.862 0 0 1-4.376-5.061 11.862 11.862 0 0 1-17.214 5.061 11.862 11.862 0 0 1-4.376-5.061 11.862 11.862 0 0 1-17.214 5.061 11.862 11.862 0 0 1-4.376-5.061 11.862 11.862 0 0 1-17.214 5.061 11.862 11.862 0 0 1-4.376-5.061 11.855 11.855 0 0 1-10.79 6.951 11.85 11.85 0 0 1-10.79-6.951 11.862 11.862 0 0 1-17.214 5.061 11.862 11.862 0 0 1-4.376-5.061 11.862 11.862 0 0 1-17.214 5.061 11.862 11.862 0 0 1-4.376-5.061 11.855 11.855 0 0 1-10.79 6.951 11.85 11.85 0 0 1-10.79-6.951 11.862 11.862 0 0 1-17.214 5.061 11.862 11.862 0 0 1-4.376-5.061 11.861 11.861 0 0 1-22.65-4.91h2.13a9.725 9.725 0 0 0 5.93 9.271 9.72 9.72 0 0 0 7.59 0 9.733 9.733 0 0 0 5.93-9.271h2.13a9.729 9.729 0 1 0 19.46 0h2.13a9.73 9.73 0 0 0 19.46 0h2.13a9.729 9.729 0 1 0 19.46 0h2.13a9.725 9.725 0 0 0 5.93 9.271 9.72 9.72 0 0 0 7.591 0 9.733 9.733 0 0 0 5.929-9.271H322a9.729 9.729 0 1 0 19.46 0h2.13a9.729 9.729 0 1 0 19.46 0h2.13a9.725 9.725 0 0 0 5.93 9.271 9.72 9.72 0 0 0 7.591 0 9.733 9.733 0 0 0 5.929-9.271h2.13a9.729 9.729 0 1 0 19.46 0h2.13a9.729 9.729 0 1 0 19.46 0h2.13a9.729 9.729 0 1 0 19.46 0h2.13a9.729 9.729 0 1 0 19.46 0h2.13a9.725 9.725 0 0 0 5.93 9.271 9.72 9.72 0 0 0 7.591 0 9.733 9.733 0 0 0 5.929-9.271h2.13a9.729 9.729 0 1 0 19.46 0h2.14a9.729 9.729 0 1 0 19.46 0h2.13a11.87 11.87 0 0 1-11.87 11.86ZM526.02 81.88a11.888 11.888 0 0 1-10.8-6.95 11.852 11.852 0 0 1-17.208 5.063 11.852 11.852 0 0 1-4.372-5.063 11.862 11.862 0 0 1-17.214 5.06 11.862 11.862 0 0 1-4.376-5.06 11.862 11.862 0 0 1-17.214 5.06 11.862 11.862 0 0 1-4.376-5.06 11.852 11.852 0 0 1-17.208 5.063 11.852 11.852 0 0 1-4.372-5.063 11.862 11.862 0 0 1-17.214 5.06 11.862 11.862 0 0 1-4.376-5.06 11.862 11.862 0 0 1-17.214 5.06 11.862 11.862 0 0 1-4.376-5.06 11.862 11.862 0 0 1-17.214 5.06 11.862 11.862 0 0 1-4.376-5.06 11.862 11.862 0 0 1-17.214 5.06 11.862 11.862 0 0 1-4.376-5.06 11.852 11.852 0 0 1-17.208 5.063 11.852 11.852 0 0 1-4.372-5.063 11.862 11.862 0 0 1-17.214 5.06 11.862 11.862 0 0 1-4.376-5.06 11.862 11.862 0 0 1-17.214 5.06 11.862 11.862 0 0 1-4.376-5.06 11.852 11.852 0 0 1-17.208 5.063 11.852 11.852 0 0 1-4.372-5.063 11.859 11.859 0 0 1-22.66-4.91h2.13a9.73 9.73 0 1 0 19.46 0h2.13a9.73 9.73 0 0 0 19.46 0h2.13a9.73 9.73 0 1 0 19.46 0h2.13a9.725 9.725 0 0 0 2.735 7.08 9.739 9.739 0 0 0 6.99 2.962 9.725 9.725 0 0 0 6.99-2.961 9.732 9.732 0 0 0 2.735-7.081H322a9.73 9.73 0 1 0 19.46 0h2.13a9.73 9.73 0 1 0 19.46 0h2.13a9.725 9.725 0 0 0 2.735 7.08 9.739 9.739 0 0 0 6.99 2.962 9.725 9.725 0 0 0 6.99-2.961 9.732 9.732 0 0 0 2.735-7.081h2.13a9.73 9.73 0 1 0 19.46 0h2.13a9.73 9.73 0 1 0 19.46 0h2.13a9.73 9.73 0 1 0 19.46 0h2.13a9.73 9.73 0 1 0 19.46 0h2.13a9.725 9.725 0 0 0 2.735 7.08 9.739 9.739 0 0 0 6.99 2.962 9.725 9.725 0 0 0 6.99-2.961 9.732 9.732 0 0 0 2.735-7.081h2.13a9.73 9.73 0 1 0 19.46 0h2.14a9.73 9.73 0 1 0 19.46 0h2.13a11.87 11.87 0 0 1-11.87 11.86ZM526.02 60.94a11.89 11.89 0 0 1-10.8-6.95 11.853 11.853 0 0 1-10.79 6.951 11.847 11.847 0 0 1-10.79-6.95 11.862 11.862 0 0 1-21.59 0 11.862 11.862 0 0 1-21.59 0 11.853 11.853 0 0 1-10.79 6.95 11.847 11.847 0 0 1-10.79-6.95 11.862 11.862 0 0 1-21.59 0 11.862 11.862 0 0 1-21.59 0 11.862 11.862 0 0 1-21.59 0 11.862 11.862 0 0 1-21.59 0 11.853 11.853 0 0 1-17.208 5.062 11.853 11.853 0 0 1-4.372-5.063 11.862 11.862 0 0 1-21.59 0 11.862 11.862 0 0 1-21.59 0 11.86 11.86 0 0 1-22.65-4.91h2.13a9.73 9.73 0 0 0 19.46 0h2.13a9.729 9.729 0 1 0 19.46 0h2.13a9.725 9.725 0 0 0 2.736 7.08 9.725 9.725 0 0 0 10.785 2.191 9.731 9.731 0 0 0 5.929-9.271H322a9.729 9.729 0 1 0 19.46 0h2.13a9.729 9.729 0 1 0 19.46 0h2.13a9.725 9.725 0 0 0 2.736 7.08 9.725 9.725 0 0 0 10.785 2.191 9.731 9.731 0 0 0 5.929-9.271h2.13a9.729 9.729 0 1 0 19.46 0h2.13a9.729 9.729 0 1 0 19.46 0h2.13a9.729 9.729 0 1 0 19.46 0h2.13a9.729 9.729 0 1 0 19.46 0h2.13a9.725 9.725 0 0 0 2.736 7.08 9.725 9.725 0 0 0 10.785 2.191 9.731 9.731 0 0 0 5.929-9.271h2.13a9.729 9.729 0 1 0 19.46 0h2.14a9.729 9.729 0 1 0 19.46 0h2.13a11.87 11.87 0 0 1-11.87 11.86ZM526.02 40.01a11.9 11.9 0 0 1-10.8-6.95 11.852 11.852 0 0 1-17.208 5.063 11.852 11.852 0 0 1-4.372-5.063 11.862 11.862 0 0 1-17.214 5.06 11.862 11.862 0 0 1-4.376-5.06 11.862 11.862 0 0 1-17.214 5.06 11.862 11.862 0 0 1-4.376-5.06 11.852 11.852 0 0 1-17.208 5.063 11.852 11.852 0 0 1-4.372-5.063 11.862 11.862 0 0 1-17.214 5.06 11.862 11.862 0 0 1-4.376-5.06 11.862 11.862 0 0 1-17.214 5.06 11.862 11.862 0 0 1-4.376-5.06 11.862 11.862 0 0 1-17.214 5.06 11.862 11.862 0 0 1-4.376-5.06 11.862 11.862 0 0 1-17.214 5.06 11.862 11.862 0 0 1-4.376-5.06 11.852 11.852 0 0 1-17.208 5.063 11.852 11.852 0 0 1-4.372-5.063 11.862 11.862 0 0 1-17.214 5.06 11.862 11.862 0 0 1-4.376-5.06 11.86 11.86 0 0 1-22.65-4.91h2.13a9.729 9.729 0 1 0 19.46 0h2.13a9.725 9.725 0 0 0 2.736 7.08 9.724 9.724 0 0 0 6.989 2.962 9.733 9.733 0 0 0 9.076-6.224 9.725 9.725 0 0 0 .649-3.818H322a9.729 9.729 0 1 0 19.46 0h2.13a9.729 9.729 0 1 0 19.46 0h2.13a9.725 9.725 0 0 0 2.736 7.08 9.724 9.724 0 0 0 6.989 2.962 9.733 9.733 0 0 0 9.076-6.224 9.725 9.725 0 0 0 .649-3.818h2.13a9.729 9.729 0 1 0 19.46 0h2.13a9.729 9.729 0 1 0 19.46 0h2.13a9.729 9.729 0 1 0 19.46 0h2.13a9.729 9.729 0 1 0 19.46 0h2.13a9.725 9.725 0 0 0 2.736 7.08 9.724 9.724 0 0 0 6.989 2.962 9.733 9.733 0 0 0 9.076-6.224 9.725 9.725 0 0 0 .649-3.818h2.13a9.729 9.729 0 1 0 19.46 0h2.14a9.729 9.729 0 1 0 19.46 0h2.13a11.87 11.87 0 0 1-11.87 11.86ZM526.02 19.07a11.888 11.888 0 0 1-10.8-6.95 11.853 11.853 0 0 1-17.208 5.063 11.853 11.853 0 0 1-4.372-5.063 11.862 11.862 0 0 1-17.214 5.06 11.862 11.862 0 0 1-4.376-5.06 11.862 11.862 0 0 1-17.214 5.06 11.862 11.862 0 0 1-4.376-5.06 11.853 11.853 0 0 1-17.208 5.063 11.853 11.853 0 0 1-4.372-5.063 11.862 11.862 0 0 1-17.214 5.06 11.862 11.862 0 0 1-4.376-5.06 11.862 11.862 0 0 1-17.214 5.06 11.862 11.862 0 0 1-4.376-5.06 11.862 11.862 0 0 1-17.214 5.06 11.862 11.862 0 0 1-4.376-5.06 11.862 11.862 0 0 1-17.214 5.06 11.862 11.862 0 0 1-4.376-5.06 11.853 11.853 0 0 1-17.208 5.063 11.853 11.853 0 0 1-4.372-5.063 11.86 11.86 0 0 1-22.64-4.91h2.13a9.725 9.725 0 0 0 2.735 7.08 9.739 9.739 0 0 0 6.99 2.962 9.735 9.735 0 0 0 6.99-2.961 9.731 9.731 0 0 0 2.735-7.081h2.13a9.729 9.729 0 1 0 19.46 0h2.13a9.729 9.729 0 1 0 19.46 0h2.13a9.725 9.725 0 0 0 2.736 7.08 9.725 9.725 0 0 0 10.784 2.191 9.739 9.739 0 0 0 5.281-5.453 9.725 9.725 0 0 0 .649-3.818h2.13a9.729 9.729 0 1 0 19.46 0h2.13a9.729 9.729 0 1 0 19.46 0h2.13a9.729 9.729 0 1 0 19.46 0h2.13a9.729 9.729 0 1 0 19.46 0h2.13a9.725 9.725 0 0 0 2.735 7.08 9.739 9.739 0 0 0 6.99 2.962 9.735 9.735 0 0 0 6.99-2.961 9.731 9.731 0 0 0 2.735-7.081h2.13a9.729 9.729 0 1 0 19.46 0h2.13a9.729 9.729 0 1 0 19.46 0h2.13a11.87 11.87 0 0 1-11.87 11.86Z",
    fill: "#003C71"
  })), _path16 || (_path16 = /*#__PURE__*/react.createElement("path", {
    d: "M536.81 90.51a9.73 9.73 0 0 1-9.13-9.7h-2.13a9.726 9.726 0 0 1-5.93 9.271 9.726 9.726 0 0 1-10.784-2.19 9.719 9.719 0 0 1-2.736-7.08h-2.13a9.729 9.729 0 1 1-19.46 0h-2.13a9.729 9.729 0 1 1-19.46 0h-2.13a9.729 9.729 0 1 1-19.46 0h-2.13a9.726 9.726 0 0 1-5.93 9.27 9.726 9.726 0 0 1-10.784-2.19 9.719 9.719 0 0 1-2.736-7.08h-2.13a9.729 9.729 0 1 1-19.46 0h-2.13a9.729 9.729 0 1 1-19.46 0h-2.13a9.729 9.729 0 1 1-19.46 0h-2.13a9.726 9.726 0 0 1-2.735 7.08 9.735 9.735 0 0 1-13.98 0 9.731 9.731 0 0 1-2.735-7.08h-2.1a9.729 9.729 0 1 1-19.46 0h-2.13a9.729 9.729 0 1 1-19.46 0h-2.13a9.729 9.729 0 1 1-19.46 0h-2.16a9.726 9.726 0 0 1-5.93 9.27 9.726 9.726 0 0 1-10.785-2.19 9.731 9.731 0 0 1-2.735-7.08h-2.13a9.729 9.729 0 1 1-19.46 0h-2.16A11.862 11.862 0 0 0 240.475 91.4a11.864 11.864 0 0 0 5.475-5.68 11.862 11.862 0 0 0 17.214 5.06 11.862 11.862 0 0 0 4.376-5.06 11.862 11.862 0 0 0 17.214 5.06 11.862 11.862 0 0 0 4.376-5.06 11.853 11.853 0 0 0 17.208 5.063 11.853 11.853 0 0 0 4.372-5.063 11.862 11.862 0 0 0 17.214 5.06 11.862 11.862 0 0 0 4.376-5.06 11.862 11.862 0 0 0 17.214 5.06 11.862 11.862 0 0 0 4.376-5.06 11.862 11.862 0 0 0 17.214 5.06 11.862 11.862 0 0 0 4.376-5.06 11.853 11.853 0 0 0 17.208 5.063 11.853 11.853 0 0 0 4.372-5.063 11.862 11.862 0 0 0 17.214 5.06 11.862 11.862 0 0 0 4.376-5.06 11.862 11.862 0 0 0 17.214 5.06 11.862 11.862 0 0 0 4.376-5.06 11.853 11.853 0 0 0 17.208 5.063 11.853 11.853 0 0 0 4.372-5.063 11.862 11.862 0 0 0 17.214 5.06 11.862 11.862 0 0 0 4.376-5.06 11.862 11.862 0 0 0 17.214 5.06A11.862 11.862 0 0 0 505 85.72a11.862 11.862 0 0 0 17.214 5.06 11.862 11.862 0 0 0 4.376-5.06 11.863 11.863 0 0 0 10.19 6.93l.03-2.14ZM527.68 59.88h-2.13a9.725 9.725 0 0 1-2.735 7.08 9.74 9.74 0 0 1-6.99 2.962 9.725 9.725 0 0 1-6.989-2.961 9.72 9.72 0 0 1-2.736-7.081h-2.13a9.729 9.729 0 1 1-19.46 0h-2.13a9.729 9.729 0 1 1-19.46 0h-2.13a9.729 9.729 0 1 1-19.46 0h-2.13a9.725 9.725 0 0 1-2.735 7.08 9.74 9.74 0 0 1-6.99 2.962 9.725 9.725 0 0 1-6.989-2.961 9.72 9.72 0 0 1-2.736-7.081h-2.13a9.729 9.729 0 1 1-19.46 0h-2.13a9.729 9.729 0 1 1-19.46 0h-2.13a9.729 9.729 0 1 1-19.46 0h-2.13a9.725 9.725 0 0 1-2.735 7.08 9.733 9.733 0 0 1-16.066-3.263 9.725 9.725 0 0 1-.649-3.817h-2.1a9.729 9.729 0 1 1-19.46 0h-2.13a9.729 9.729 0 1 1-19.46 0h-2.13a9.729 9.729 0 1 1-19.46 0h-2.16a9.725 9.725 0 0 1-2.735 7.08 9.74 9.74 0 0 1-6.99 2.962 9.725 9.725 0 0 1-6.99-2.961 9.733 9.733 0 0 1-2.735-7.081h-2.13a11.862 11.862 0 0 0 17.175 10.59 11.865 11.865 0 0 0 5.475-5.68 11.862 11.862 0 0 0 17.214 5.06 11.862 11.862 0 0 0 4.376-5.06 11.853 11.853 0 0 0 10.79 6.951 11.853 11.853 0 0 0 10.79-6.951 11.862 11.862 0 0 0 17.214 5.06 11.862 11.862 0 0 0 4.376-5.06 11.862 11.862 0 0 0 17.214 5.06 11.862 11.862 0 0 0 4.376-5.06 11.862 11.862 0 0 0 17.214 5.06 11.862 11.862 0 0 0 4.376-5.06 11.853 11.853 0 0 0 10.79 6.951 11.853 11.853 0 0 0 10.79-6.951 11.862 11.862 0 0 0 17.214 5.06 11.862 11.862 0 0 0 4.376-5.06 11.862 11.862 0 0 0 17.214 5.06 11.862 11.862 0 0 0 4.376-5.06 11.853 11.853 0 0 0 10.79 6.951 11.853 11.853 0 0 0 10.79-6.951 11.862 11.862 0 0 0 17.214 5.06 11.862 11.862 0 0 0 4.376-5.06 11.862 11.862 0 0 0 17.214 5.06 11.862 11.862 0 0 0 4.376-5.06 11.862 11.862 0 0 0 17.214 5.06 11.862 11.862 0 0 0 4.376-5.06 11.86 11.86 0 0 0 10.19 6.92v-2.13a9.751 9.751 0 0 1-9.13-9.7ZM536.81 48.64a9.738 9.738 0 0 1-9.13-9.7h-2.13a9.725 9.725 0 0 1-2.735 7.08 9.739 9.739 0 0 1-6.99 2.962 9.726 9.726 0 0 1-9.076-6.224 9.725 9.725 0 0 1-.649-3.818h-2.13a9.729 9.729 0 1 1-19.46 0h-2.13a9.729 9.729 0 1 1-19.46 0h-2.13a9.729 9.729 0 1 1-19.46 0h-2.13a9.725 9.725 0 0 1-2.735 7.08 9.739 9.739 0 0 1-6.99 2.962 9.726 9.726 0 0 1-9.076-6.224 9.725 9.725 0 0 1-.649-3.818h-2.13a9.729 9.729 0 1 1-19.46 0h-2.13a9.729 9.729 0 1 1-19.46 0h-2.13a9.729 9.729 0 1 1-19.46 0h-2.13a9.725 9.725 0 0 1-2.735 7.08 9.739 9.739 0 0 1-6.99 2.962 9.726 9.726 0 0 1-9.076-6.224 9.725 9.725 0 0 1-.649-3.818h-2.1a9.729 9.729 0 1 1-19.46 0h-2.13a9.729 9.729 0 1 1-19.46 0h-2.13a9.729 9.729 0 1 1-19.46 0h-2.16a11.86 11.86 0 0 0 22.66 4.91 11.853 11.853 0 0 0 17.208 5.063 11.853 11.853 0 0 0 4.372-5.063 11.862 11.862 0 0 0 17.214 5.06 11.862 11.862 0 0 0 4.376-5.06 11.862 11.862 0 0 0 17.214 5.06 11.862 11.862 0 0 0 4.376-5.06 11.862 11.862 0 0 0 17.214 5.06 11.862 11.862 0 0 0 4.376-5.06 11.853 11.853 0 0 0 17.208 5.063 11.853 11.853 0 0 0 4.372-5.063 11.862 11.862 0 0 0 17.214 5.06 11.862 11.862 0 0 0 4.376-5.06 11.862 11.862 0 0 0 17.214 5.06 11.862 11.862 0 0 0 4.376-5.06 11.853 11.853 0 0 0 17.208 5.063 11.853 11.853 0 0 0 4.372-5.063 11.862 11.862 0 0 0 17.214 5.06 11.862 11.862 0 0 0 4.376-5.06 11.862 11.862 0 0 0 17.214 5.06 11.862 11.862 0 0 0 4.376-5.06 11.862 11.862 0 0 0 17.214 5.06 11.862 11.862 0 0 0 4.376-5.06 11.881 11.881 0 0 0 10.19 6.93v-2.14ZM536.81 27.7a9.729 9.729 0 0 1-9.13-9.7h-2.13a9.725 9.725 0 0 1-2.735 7.08 9.733 9.733 0 0 1-16.066-3.263 9.725 9.725 0 0 1-.649-3.817h-2.13a9.729 9.729 0 1 1-19.46 0h-2.13a9.729 9.729 0 1 1-19.46 0h-2.13a9.729 9.729 0 1 1-19.46 0h-2.13a9.725 9.725 0 0 1-2.735 7.08 9.733 9.733 0 0 1-16.066-3.263 9.725 9.725 0 0 1-.649-3.817h-2.13a9.729 9.729 0 1 1-19.46 0h-2.13a9.729 9.729 0 1 1-19.46 0h-2.13a9.729 9.729 0 1 1-19.46 0h-2.13a9.725 9.725 0 0 1-2.735 7.08 9.733 9.733 0 0 1-16.066-3.263 9.725 9.725 0 0 1-.649-3.817h-2.1a9.729 9.729 0 1 1-19.46 0h-2.13a9.729 9.729 0 1 1-19.46 0h-2.13a11.864 11.864 0 0 0 17.172 10.6 11.86 11.86 0 0 0 5.478-5.68 11.87 11.87 0 0 0 21.59 0 11.87 11.87 0 0 0 21.59 0 11.87 11.87 0 0 0 21.59 0 11.86 11.86 0 0 0 21.58 0 11.87 11.87 0 0 0 21.59 0 11.87 11.87 0 0 0 21.59 0 11.86 11.86 0 0 0 21.58 0 11.87 11.87 0 0 0 21.59 0 11.87 11.87 0 0 0 21.59 0 11.87 11.87 0 0 0 21.59 0 11.876 11.876 0 0 0 10.19 6.92l-.03-2.14ZM281.6 166.63c1.57.16 2.26-.34 3.62-2 1.57-1.91 4.41-1.26 4.93.27a5.004 5.004 0 0 0 3.57 3.56c2.4.77 3.84 3.68 2.13 5.68a6.815 6.815 0 0 0-1.88 5.18c0 3-5.56 5.48-8 1.36-2.44-4.12-3.48-9.29-5.11-10.68-1.63-1.39-1.4-3.59.74-3.37Z",
    fill: "#003C71"
  })), _path17 || (_path17 = /*#__PURE__*/react.createElement("path", {
    d: "M286.43 166.87c-3.65.55-9 6.37-8.07 10.74.93 4.37 10.76 4.81 13.46.26 2.7-4.55 1.05-11.96-5.39-11Z",
    fill: "#FDC498"
  })), _path18 || (_path18 = /*#__PURE__*/react.createElement("path", {
    d: "M286.79 179.15c-.3.08-3.56 6-3 7.86.299.886.523 1.796.67 2.72l-10.45-5.93a11.499 11.499 0 0 0 6.53-5c2.7-4.15 6.25.35 6.25.35Z",
    fill: "#FDC498"
  })), _path19 || (_path19 = /*#__PURE__*/react.createElement("path", {
    d: "M303.68 226.28c-1.8-6.36-3.81-8.17-3.81-8.17s-12 5.11-14.46 4.36c-2.69-.81-2.22-8.15-2-12.14a13.061 13.061 0 0 0-2.16-7.29c.37-.68 5.3-1.16 5.62-1.81 3.35-2.88 5.39-6.5 3.09-10.74-3.28-6-8.81-6.34-15.24-9.54-6.43-3.2-6.26-8.94-5-15.33 1.26-6.39-2-9.9-2-9.9-1-1.22-2-1.18-2.36-.86-.57 2.13 1.63 4.68.94 5-.36.17-1.17-.45-1.87-1.09-.71.2.36 1.66.89 2.13a4.669 4.669 0 0 1 1.74 3.85 28.402 28.402 0 0 0-3 12.1c0 3.82 2.66 7.14 6.15 9.85a67.717 67.717 0 0 0-6.63 37.27c.86 6.56 4.09 13 9.71 20.05 0 0-3.17 6-4.59 9 2.81 3.36 9.45-5.59 11.53-9.58-7.3-5.6-9.94-19.86-6.53-25.18 1.29 3 3.24 6.69 6.72 8.67 6.4 3.65 17.06-2.36 17.06-2.36l4.28 7.22s3.36-.36 1.92-5.51Z",
    fill: "#FDC498"
  })), _path20 || (_path20 = /*#__PURE__*/react.createElement("path", {
    d: "M264.06 201.33s-3.92 11.29-1.83 22.42l22.36-4.29s1.48-14.33-4.53-17.86c-6.01-3.53-16-.27-16-.27Z",
    fill: "#0067A5"
  })), _path21 || (_path21 = /*#__PURE__*/react.createElement("path", {
    d: "M280.24 174.33c-1.15-1-4.78-4.67 5.52-5.62 10.3-.95-.07 7.57-.07 7.57l-5.45-1.95Z",
    fill: "#FDC498"
  })), _path22 || (_path22 = /*#__PURE__*/react.createElement("path", {
    d: "M282.44 167.62s.26 1.74 3.59 2.15c3.33.41 1 2.16 2 3.34a1.888 1.888 0 0 1 1.954 1.36c.08.276.095.567.046.85-.19 1-2.52 1.06-2.52 1.06s-3.71 4.23-.9 5.89c2.81 1.66 7.5 1.13 7.35-3-.15-4.13 0-7.6 0-7.6l-.66-2.39-5.18-3.89-5.68 2.23Z",
    fill: "#003C71"
  })), _path23 || (_path23 = /*#__PURE__*/react.createElement("path", {
    d: "m264.01 175.99 5.93.32s1.35 3.37 6.13 5.31c-2 2.18 2 3.61 7.94 3.31 6.6 3.13 8.89 9.06 7.72 13-1.17 3.94-9.44 5.59-15 5.59-5.56 0-14.24-.38-14.24-.38s2.81-10.55 5.67-15.12c0 0-5.76-4.62-6.15-12.14l2 .11Z",
    fill: "#FF7D20"
  })), _path24 || (_path24 = /*#__PURE__*/react.createElement("path", {
    d: "m282.144 195.03-.132 2.397 2.127.116.131-2.396-2.126-.117ZM272.126 211.611l-.07 10.29 2.13.014.07-10.289-2.13-.015ZM261.308 211.416l-.117 2.127 4.084.223.117-2.127-4.084-.223Z",
    fill: "#003C71"
  })), _path25 || (_path25 = /*#__PURE__*/react.createElement("path", {
    d: "m275.78 200.56-5.62-2.75s-.77 1.16.88 2.25.11 1.8-1.24 1.73l-2.55-.14a3.337 3.337 0 0 0 2.34 2.93c1.779.435 3.62.556 5.44.36l.75-4.38Z",
    fill: "#FDC498"
  })), _path26 || (_path26 = /*#__PURE__*/react.createElement("path", {
    d: "M278.96 205.28a25.844 25.844 0 0 1-3.92-.28l.33-2.1c.12 0 12.37 1.88 15.38-5.36l2 .81c-2.45 5.93-9.36 6.93-13.79 6.93ZM272.16 243.11l4.43-4.12 3.58 4.55s-6.09 13-11.81 9.82l4.64-8.84-.84-1.41ZM296.11 225.72l-1.73-6 5.68-1.78s7.55 11.76 2 15.27l-4.62-8-1.33.51ZM283.24 171.89a.57.57 0 1 0 0-1.14.57.57 0 0 0 0 1.14Z",
    fill: "#003C71"
  })), _path27 || (_path27 = /*#__PURE__*/react.createElement("path", {
    d: "M239.01 173.82h-19.24l-4.26-25.92h27.76l-4.26 25.92Z",
    fill: "#80B3D2"
  })), _path28 || (_path28 = /*#__PURE__*/react.createElement("path", {
    d: "M247.93 146.83h-33.88v2.13h33.88v-2.13ZM228.6 172.75h-9.62v2.13h9.62v-2.13Z",
    fill: "#003C71"
  })), _path29 || (_path29 = /*#__PURE__*/react.createElement("path", {
    d: "M232.69 140.43a8.89 8.89 0 0 0 8.89-8.89 8.89 8.89 0 0 0-8.89-8.89 8.89 8.89 0 0 0-8.89 8.89 8.89 8.89 0 0 0 8.89 8.89Z",
    fill: "#FF7D20"
  })), _path30 || (_path30 = /*#__PURE__*/react.createElement("path", {
    d: "m239.058 125.251-14.09 10.827 1.298 1.689 14.09-10.827-1.298-1.689Z",
    fill: "#003C71"
  })), _path31 || (_path31 = /*#__PURE__*/react.createElement("path", {
    d: "M232.69 141.5a10.001 10.001 0 0 1-10.893-9.96 9.996 9.996 0 0 1 3.252-7.38 10.001 10.001 0 0 1 7.641-2.58v2.13a7.825 7.825 0 0 0-7.234 4.834 7.828 7.828 0 0 0 5.707 10.676 7.825 7.825 0 0 0 8.037-3.33 7.823 7.823 0 0 0 1.32-4.35h2.13a9.995 9.995 0 0 1-2.929 7.031 9.995 9.995 0 0 1-7.031 2.929ZM421.12 319.96v13.75h35.61a4.541 4.541 0 0 0-3.77-4.52c-4-.94-12.94-.94-18.62-7.16-5.68-6.22-13.22-2.07-13.22-2.07ZM384.1 313.93l-8.32 19.78h33.1a4.562 4.562 0 0 0-3.77-4.52c-4-.94-13.23-2.11-11.25-10.59 1.9-8.2-9.76-4.67-9.76-4.67ZM479.44 154.81l-1.6-1.41 13-14.82c-1.93-1.35-5.87-4.49-6.41-7.85a4.695 4.695 0 0 1 1.14-3.94 5.01 5.01 0 0 1 1.687-1.337 5.014 5.014 0 0 1 2.093-.503h.2c4.47 0 9.5 5.08 9.71 5.3l-1.52 1.49c-1.28-1.31-5.22-4.66-8.18-4.66h-.14a3.008 3.008 0 0 0-2.23 1.1 2.643 2.643 0 0 0-.66 2.22c.46 2.85 4.83 6.07 6.47 7.06l1.08.66-14.64 16.69Z",
    fill: "#003C71"
  })), _path32 || (_path32 = /*#__PURE__*/react.createElement("path", {
    d: "M472.48 147.78c3 2.39 8.34 3.22 10.77 3.49a2.411 2.411 0 0 0 2.06-.81c1.82-2.06 6-7 6.18-9 .19-2.51-6-1.49-15 1.08-9 2.57-4.01 5.24-4.01 5.24Z",
    fill: "#FDC498"
  })), _path33 || (_path33 = /*#__PURE__*/react.createElement("path", {
    d: "M474.35 154.11c.1-.3 3.1-6.39 3.1-6.39l8.25-7.38s-12 .95-14.57 4.77l-2.55 3.82 5.77 5.18ZM425.94 147.72s6 2.87 7.51 8.19c1.51 5.32-.22 5.38-1.54 5-1.32-.38-.7 3.51-3.62 5.1-2.92 1.59-9.39 1.34-9.39 1.34s-2.5-5.84-1.11-11.05c1.39-5.21 8.15-8.58 8.15-8.58Z",
    fill: "#FDC498"
  })), _path34 || (_path34 = /*#__PURE__*/react.createElement("path", {
    d: "m425.71 163.89-3.41 12.39h-10s-1.44-29.09 13.7-28.59a59.595 59.595 0 0 1-.29 16.2Z",
    fill: "#FDC498"
  })), _path35 || (_path35 = /*#__PURE__*/react.createElement("path", {
    d: "m435.1 183.95 5.3 141.26h-18.1s-10.24-30.21-5.71-45.63l-21.47 45.63-13.75-10.93s3.87-34.52 19.95-51.35c0 0-11.07-34.23-.28-48.1l34.06-30.88Z",
    fill: "#008B66"
  })), _path36 || (_path36 = /*#__PURE__*/react.createElement("path", {
    d: "m454.85 170.03 14.52-22.31 7 3.2s-6.23 28.54-12.63 33c-9.21 6.46-24.47 5.73-24.47 5.73l-3.9 27.63-33.88-.75-5.08-35.72a9.076 9.076 0 0 1 2.039-7.383 9.079 9.079 0 0 1 6.961-3.197l49.44-.2Z",
    fill: "#008B66"
  })), _path37 || (_path37 = /*#__PURE__*/react.createElement("path", {
    d: "m514.906 137.845-18.991-13.91-4.981 6.801 18.991 13.909 4.981-6.8Z",
    fill: "#fff"
  })), _path38 || (_path38 = /*#__PURE__*/react.createElement("path", {
    d: "M412.86 164.91s7.32.66 10.92-5c0 0-2.9-.79-2-2.94 1.13-2.7 3.93-.6 3.93-.6s2.35-3.9 6.49-3.21c5 .84 6.18-4.21 3.23-5.67a4.362 4.362 0 0 1-1.51-1.1c-2.63-3.23-6.94-4.78-10.37-3.35a6.004 6.004 0 0 1-3.28.33c-3.51-.54-8.07 2-8.07 6.61s-1.41 5.7-2.91 6.89c-2.9 2.33-1.25 8.05 3.57 8.04ZM421.3 327.47c-8.36-23.92-7-36.81-5.85-47.17l.09-.83c.18-1.68.44-3.49.71-5.42 1.45-10.16 3.24-22.81-4.5-28.76-10.17-7.81-7.74-21-7.63-21.53l2.09.4c0 .13-2.27 12.45 6.83 19.44 8.73 6.7 6.84 20 5.32 30.75-.27 1.91-.52 3.7-.7 5.34l-.09.83c-1.15 10.68-2.46 22.78 5.75 46.24l-2.02.71ZM436.39 212.46h-30.9v2.13h30.9v-2.13Z",
    fill: "#003C71"
  })), _path39 || (_path39 = /*#__PURE__*/react.createElement("path", {
    d: "m432.554 235.988-7.018 3.692.553 1.053 7.019-3.691-.554-1.054ZM418.684 223.212l-7.018 3.691.554 1.053 7.018-3.691-.554-1.053ZM429.283 256.592l-7.019 3.691.554 1.053 7.019-3.691-.554-1.053ZM436.348 269.287l-7.018 3.691.554 1.054 7.018-3.692-.554-1.053ZM426.877 283.16l-7.018 3.691.554 1.053 7.018-3.691-.554-1.053Z",
    fill: "#47AC91"
  })), _path40 || (_path40 = /*#__PURE__*/react.createElement("path", {
    d: "m394.124 295.716-7.019 3.691.554 1.053 7.019-3.691-.554-1.053Z",
    fill: "#00614F"
  })), _path41 || (_path41 = /*#__PURE__*/react.createElement("path", {
    d: "m436.351 300.464-7.018 3.691.554 1.053 7.018-3.691-.554-1.053ZM435.197 294.709l-7.148-3.433-.515 1.073 7.148 3.433.515-1.073Z",
    fill: "#47AC91"
  })), _path42 || (_path42 = /*#__PURE__*/react.createElement("path", {
    d: "m397.72 310.053-7.148-3.433-.515 1.073 7.148 3.433.515-1.073Z",
    fill: "#00614F"
  })), _path43 || (_path43 = /*#__PURE__*/react.createElement("path", {
    d: "m424.15 272.29-3.83-2.26-.52 1.08 3.83 2.26.52-1.08ZM433.51 251.36l-3.84-2.25-.51 1.07 3.83 2.26.52-1.08ZM419.8 236.98l-3.83-2.25-.52 1.07 3.83 2.26.52-1.08Z",
    fill: "#47AC91"
  })), _path44 || (_path44 = /*#__PURE__*/react.createElement("path", {
    d: "m409.21 243.898-7.019 3.691.554 1.053 7.018-3.691-.553-1.053ZM405.939 264.501l-7.019 3.691.554 1.054 7.018-3.691-.553-1.054ZM412.994 277.197l-7.019 3.691.554 1.053 7.019-3.691-.554-1.053ZM400.8 280.2l-3.84-2.25-.51 1.07 3.83 2.26.52-1.08ZM410.15 259.27l-3.83-2.25-.52 1.07 3.84 2.26.51-1.08ZM402.97 291.33l-3.83-2.26-.52 1.08 3.83 2.26.52-1.08Z",
    fill: "#00614F"
  })), _path45 || (_path45 = /*#__PURE__*/react.createElement("path", {
    d: "m430.68 224.55-3.84-2.26-.51 1.08 3.83 2.26.52-1.08ZM426.33 311.15l-3.84-2.26-.51 1.08 3.83 2.25.52-1.07Z",
    fill: "#47AC91"
  })), _path46 || (_path46 = /*#__PURE__*/react.createElement("path", {
    d: "M443.19 190.6a61.302 61.302 0 0 1-9.52-.72l.35-2.1c.2 0 19.39 3.19 29.08-4.66 8.75-7.09 11.65-27.38 12.16-31.55l-6.34-2.88.89-1.94 7.73 3.52-.08.76c-.1 1-2.61 25.31-13 33.75-5.88 4.75-14.6 5.82-21.27 5.82ZM429.64 157.54a.81.81 0 1 0 0-1.62.81.81 0 0 0 0 1.62Z",
    fill: "#003C71"
  })), _path47 || (_path47 = /*#__PURE__*/react.createElement("path", {
    d: "M520.3 162.38a4.792 4.792 0 0 1-8.094 3.245 4.792 4.792 0 0 1-1.476-3.245c0-2.65 4.79-10.44 4.79-10.44s4.78 7.79 4.78 10.44ZM509.66 174.75a3.182 3.182 0 0 1-3.175 3.002 3.18 3.18 0 0 1-3.175-3.002c0-1.75 3.17-6.91 3.17-6.91s3.18 5.16 3.18 6.91Z",
    fill: "#fff"
  })), _path48 || (_path48 = /*#__PURE__*/react.createElement("path", {
    d: "m191.936 256.418-1.798 1.142 5.997 9.436 1.798-1.143-5.997-9.435Z",
    fill: "#003C71"
  })), _path49 || (_path49 = /*#__PURE__*/react.createElement("path", {
    d: "M236.52 280.33a4.79 4.79 0 1 0-.001-9.581 4.79 4.79 0 0 0 .001 9.581ZM23.39 279a5.87 5.87 0 1 0 0-11.74 5.87 5.87 0 0 0 0 11.74Z",
    fill: "#47AC91"
  })), _path50 || (_path50 = /*#__PURE__*/react.createElement("path", {
    d: "M23.35 276.04a2.91 2.91 0 1 0 0-5.82 2.91 2.91 0 0 0 0 5.82Z",
    fill: "#FFE047"
  })), _path51 || (_path51 = /*#__PURE__*/react.createElement("path", {
    d: "M33.64 292.49a4.37 4.37 0 1 0 0-8.74 4.37 4.37 0 0 0 0 8.74Z",
    fill: "#47AC91"
  })), _path52 || (_path52 = /*#__PURE__*/react.createElement("path", {
    d: "M33.61 290.29a2.17 2.17 0 1 0 0-4.34 2.17 2.17 0 0 0 0 4.34Z",
    fill: "#FFE047"
  })), _path53 || (_path53 = /*#__PURE__*/react.createElement("path", {
    d: "M7.57 304.14a6.65 6.65 0 1 0 0-13.3 6.65 6.65 0 0 0 0 13.3Z",
    fill: "#47AC91"
  })), _path54 || (_path54 = /*#__PURE__*/react.createElement("path", {
    d: "M7.52 300.79a3.3 3.3 0 1 0 0-6.6 3.3 3.3 0 0 0 0 6.6Z",
    fill: "#FFE047"
  })), _path55 || (_path55 = /*#__PURE__*/react.createElement("path", {
    d: "M183.04 313.17s6.69-27.06 35.94-27.59c29.25-.53 40.12-1.67 66.68-16.72 34.88-19.75 85.06 0 77.24 45.26l-179.86-.95Z",
    fill: "#47AC91"
  })), _path56 || (_path56 = /*#__PURE__*/react.createElement("path", {
    d: "M254.98 298.12c18.32-10.65 31.32-27.12 48.52-35.84a58.66 58.66 0 0 0-17.84 6.54c-26.56 15.05-37.42 16.18-66.68 16.72-29.26.54-35.93 27.59-35.93 27.59l55.4.3c3.28-5.15 8.45-10.62 16.53-15.31Z",
    fill: "#269D7D"
  })), _path57 || (_path57 = /*#__PURE__*/react.createElement("path", {
    d: "M220.55 298.36c-4.39-19.18-13.95-30.64-14.05-30.76l1.63-1.37c.4.47 10 11.94 14.49 31.66l-2.07.47ZM229.93 304.82c-4.67-31.45 5.49-58.62 5.6-58.9l2 .76c-.1.27-10.07 27-5.48 57.83l-2.12.31Z",
    fill: "#003C71"
  })), _path58 || (_path58 = /*#__PURE__*/react.createElement("path", {
    d: "M223.28 260.35a4.79 4.79 0 1 0-.001-9.581 4.79 4.79 0 0 0 .001 9.581Z",
    fill: "#47AC91"
  })), _path59 || (_path59 = /*#__PURE__*/react.createElement("path", {
    d: "M223.25 257.94a2.38 2.38 0 1 0 0-4.76 2.38 2.38 0 0 0 0 4.76ZM236.52 277.92a2.38 2.38 0 1 0-.001-4.761 2.38 2.38 0 0 0 .001 4.761Z",
    fill: "#FFE047"
  })), _path60 || (_path60 = /*#__PURE__*/react.createElement("path", {
    d: "M208.04 282.7a4.79 4.79 0 1 0-.001-9.581 4.79 4.79 0 0 0 .001 9.581Z",
    fill: "#47AC91"
  })), _path61 || (_path61 = /*#__PURE__*/react.createElement("path", {
    d: "M208.04 280.29a2.38 2.38 0 1 0-.001-4.761 2.38 2.38 0 0 0 .001 4.761Z",
    fill: "#FFE047"
  })), _path62 || (_path62 = /*#__PURE__*/react.createElement("path", {
    d: "M200.41 293.08a2.38 2.38 0 1 0 0-4.76 2.38 2.38 0 0 0 0 4.76ZM211.81 300.62a3.77 3.77 0 1 0 0-7.54 3.77 3.77 0 0 0 0 7.54Z",
    fill: "#008B66"
  })), _path63 || (_path63 = /*#__PURE__*/react.createElement("path", {
    d: "M197.48 308.24a3.22 3.22 0 1 0 0-6.44 3.22 3.22 0 0 0 0 6.44Z",
    fill: "#FFD400"
  })), _path64 || (_path64 = /*#__PURE__*/react.createElement("path", {
    d: "M215.87 262.06c-6.83-10-17.84-3.5-18.31-3.21l-1.11-1.82c.14-.08 13.2-7.87 21.18 3.83l-1.76 1.2Z",
    fill: "#fff"
  })), _path65 || (_path65 = /*#__PURE__*/react.createElement("path", {
    d: "M210.23 264.77c-2.17-3.06-5.65-1.56-5.79-1.5l-.87-1.94a6.86 6.86 0 0 1 8.4 2.21l-1.74 1.23Z",
    fill: "#fff"
  })), _path66 || (_path66 = /*#__PURE__*/react.createElement("path", {
    d: "m30.15 231.07-1.77-1.18c.26-.4 26.78-39.41 68-25.87l-.66 2c-39.68-13-65.31 24.66-65.57 25.05Z",
    fill: "#D9EEE8"
  })), _path67 || (_path67 = /*#__PURE__*/react.createElement("path", {
    d: "M531.72 344.32c32.248 0 58.39-26.142 58.39-58.39 0-32.248-26.142-58.39-58.39-58.39-32.248 0-58.39 26.142-58.39 58.39 0 32.248 26.142 58.39 58.39 58.39Z",
    fill: "#FFD400"
  })), _path68 || (_path68 = /*#__PURE__*/react.createElement("path", {
    d: "M566.84 300.8h-22.92v16.45h22.92V300.8Z",
    fill: "#fff"
  })), _path69 || (_path69 = /*#__PURE__*/react.createElement("path", {
    d: "M543.92 311.99a19.759 19.759 0 0 1 12.55-5c7.7-.18 9.9-3.31 10.38-6.21.48-2.9-22.93-2.34-22.93-2.34v13.55Z",
    fill: "#ADCEE2"
  })), _path70 || (_path70 = /*#__PURE__*/react.createElement("path", {
    d: "M525.77 259.99h38.28v25.68a3.83 3.83 0 0 1-3.83 3.83H529.6a3.823 3.823 0 0 1-2.708-1.122 3.823 3.823 0 0 1-1.122-2.708v-25.68Z",
    fill: "#63A2C8"
  })), _path71 || (_path71 = /*#__PURE__*/react.createElement("path", {
    d: "M564.05 256.49h-38.28v7.68h38.28v-7.68ZM498.13 269.23h38.28v41.3a3.833 3.833 0 0 1-3.83 3.83h-30.62a3.83 3.83 0 0 1-3.83-3.83v-41.3Z",
    fill: "#0067A5"
  })), _path72 || (_path72 = /*#__PURE__*/react.createElement("path", {
    d: "M536.41 273.68h-38.28v2.13h38.28v-2.13ZM536.41 278.8h-38.28v2.13h38.28v-2.13ZM536.41 283.91h-38.28v2.13h38.28v-2.13Z",
    fill: "#63A2C8"
  })), _path73 || (_path73 = /*#__PURE__*/react.createElement("path", {
    d: "M517.72 298.28a23.638 23.638 0 0 1-23.62-23.61v-1.07h4v2.13h-1.8a21.483 21.483 0 0 0 36.273 14.515 21.484 21.484 0 0 0 6.637-14.515h-2.76v-2.13h4.85v1.07a23.627 23.627 0 0 1-23.58 23.61Z",
    fill: "#003C71"
  })), _path74 || (_path74 = /*#__PURE__*/react.createElement("path", {
    d: "M498.13 269.28s1.12 14.24 10.33 15.29c9.21 1.05 7.94-9.62 15.21-9.54 7.27.08 12.19-5.75 12.19-5.75h-37.73Z",
    fill: "#fff"
  })), _path75 || (_path75 = /*#__PURE__*/react.createElement("path", {
    d: "M517.59 300.1a2.89 2.89 0 1 0 0-5.78 2.89 2.89 0 0 0 0 5.78Z",
    fill: "#003C71"
  })), _path76 || (_path76 = /*#__PURE__*/react.createElement("path", {
    d: "M560.97 261.17h-2.13a13.452 13.452 0 0 0-13.46-13.46 13.452 13.452 0 0 0-13.46 13.46h-2.13a15.58 15.58 0 0 1 4.566-11.024 15.601 15.601 0 0 1 11.024-4.566 15.58 15.58 0 0 1 11.024 4.566 15.58 15.58 0 0 1 4.566 11.024Z",
    fill: "#0067A5"
  })), _path77 || (_path77 = /*#__PURE__*/react.createElement("path", {
    d: "M559.06 284.97h-7.09v12.07h7.09v-12.07Z",
    fill: "#003C71"
  })), _path78 || (_path78 = /*#__PURE__*/react.createElement("path", {
    d: "M555.47 277.18a5.075 5.075 0 0 0-4.694 3.138 5.082 5.082 0 1 0 6.637-2.755 5.076 5.076 0 0 0-1.943-.383Zm0 6.1a.997.997 0 0 1-.707-1.707 1.003 1.003 0 0 1 1.09-.217 1.004 1.004 0 0 1 .617.924.998.998 0 0 1-1.01 1h.01ZM565.85 294.8h-20.94a3.44 3.44 0 0 0-3.44 3.44v.44c0 1.9 1.54 3.44 3.44 3.44h20.94c1.9 0 3.44-1.54 3.44-3.44v-.44c0-1.9-1.54-3.44-3.44-3.44Z",
    fill: "#0067A5"
  })), _path79 || (_path79 = /*#__PURE__*/react.createElement("path", {
    d: "M548.97 307.01h-2.13v12.6h2.13v-12.6ZM553.04 311.99h-2.13v7.61h2.13v-7.61Z",
    fill: "#FFD400"
  })), _path80 || (_path80 = /*#__PURE__*/react.createElement("path", {
    d: "M550.56 329.73a2.66 2.66 0 0 1-5.31 0c0-1.47 2.65-7.17 2.65-7.17s2.66 5.72 2.66 7.17Z",
    fill: "#fff"
  })), _path81 || (_path81 = /*#__PURE__*/react.createElement("path", {
    d: "M505.5 339.28a59.459 59.459 0 0 1 16.446-112.009A59.456 59.456 0 0 1 589.7 272.68l-2.08.47a57.33 57.33 0 1 0-81.18 64.22l-.94 1.91ZM471.13 332.64H330.42v2.13h140.71v-2.13ZM122.11 313.65h48s-1.69-8.83-19.08-6.54c-7.32-5.87-23.3 0-30.77-1.43-7.6 2.6 1.85 7.97 1.85 7.97ZM182.5 256.31l-13.48 39.15-26.76-16.74 26.65-30.36 13.59 7.95Z",
    fill: "#003C71"
  })), _path82 || (_path82 = /*#__PURE__*/react.createElement("path", {
    d: "M157.2 266.17a11.31 11.31 0 1 1 11.3-11.89 11.31 11.31 0 0 1-10.72 11.86l-.58.03Zm0-20.49h-.47a9.24 9.24 0 1 0 .47 0ZM168.97 284.57c.86-1 26.3-20.25 26.3-20.25l-2.97-4.79-23.91 14 .58 11.04Z",
    fill: "#003C71"
  })), _path83 || (_path83 = /*#__PURE__*/react.createElement("path", {
    d: "M121.3 257.5h35.12a13.62 13.62 0 0 1 12.38 19.3l-17.82 30.31h-23.3l17.19-28.68H94.5a13.147 13.147 0 0 1-13.15-13.15 13.172 13.172 0 0 1 4.67-10.06l38.9-32.82h15.84s9.37 17.25 2.71 23.63c-7.17 6.89-22.17 11.47-22.17 11.47Z",
    fill: "#FF7D20"
  })), _path84 || (_path84 = /*#__PURE__*/react.createElement("path", {
    d: "m110.13 270.52 18.55 31.67a7.615 7.615 0 0 1-2.752 10.436 7.604 7.604 0 0 1-3.818 1.024H72.95v-15h31.23L83.3 272.18l26.83-1.66Z",
    fill: "#FF7D20"
  })), _path85 || (_path85 = /*#__PURE__*/react.createElement("path", {
    d: "M125.72 238.87s-2.42 34.67 44.38 41.26v-8s-29.34-.27-32-33.64l-12.38.38ZM165.75 210.97s-15.17-10.22-40.83 11.43c9 8 15.84 0 15.84 0s4.4-4.9 6 .93c1.6 5.83 12.39.9 12.39.9s1.4 4.26 4 1.8 7-8.26 2.6-15.06Z",
    fill: "#FDC498"
  })), _path86 || (_path86 = /*#__PURE__*/react.createElement("path", {
    d: "M140.97 215.97s-1.71-9.54 6-12c0 0 1.75-7.29 10.55-7.26 7.19-1.19 13.48 4.21 12.54 8 6.25 5.21 3.78 13.8-2.48 15 0 0-5.07 0-6.66-4.19-1.59-4.19-6.4-3.4-6.2-.6.2 2.8-10.35 8.84-13.75 1.05Z",
    fill: "#003C71"
  })), _path87 || (_path87 = /*#__PURE__*/react.createElement("path", {
    d: "M158.3 201.55a8.8 8.8 0 1 0 0-17.6 8.8 8.8 0 0 0 0 17.6Z",
    fill: "#003C71"
  })), _path88 || (_path88 = /*#__PURE__*/react.createElement("path", {
    d: "M170.1 272.18a22.008 22.008 0 0 0 10.42-3.19.93.93 0 0 1 1.37 1 4.991 4.991 0 0 1-1.42 1.89c-2.85 2.64-3.6 2.79-3.6 2.79a6.82 6.82 0 0 0 5.63-.66c1.42 2.16 0 5.31-3.45 6.51-2.4.83-15.25-1-20.75-2.92 4.08-2.62 11.8-5.42 11.8-5.42Z",
    fill: "#FDC498"
  })), _path89 || (_path89 = /*#__PURE__*/react.createElement("path", {
    d: "M161.43 220.86a19.96 19.96 0 0 1-3.56-1.2l.87-1.95c.995.448 2.03.803 3.09 1.06l-.4 2.09ZM81.35 313.65H39.9s3.2-7.33 13.59-8c10.39-.67 11.06-8.19 19.68-8.19 9.72.03 8.18 16.19 8.18 16.19ZM146.97 280.07h-44.35a13.62 13.62 0 0 1-13.61-13.61h2.13a11.492 11.492 0 0 0 11.48 11.48h44.35v2.13Z",
    fill: "#003C71"
  })), _path90 || (_path90 = /*#__PURE__*/react.createElement("path", {
    d: "M113.86 297.54H72.95v2.13h40.91v-2.13ZM275.78 313.06H18.15v2.13h257.63v-2.13Z",
    fill: "#003C71"
  })));
};
/* harmony default export */ var my_account_banner = (SvgMyAccountBanner);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-images-virtual-95769406cb/1/packages/lib-images/src/my-company-banner.svg
var my_company_banner_path, my_company_banner_path2, my_company_banner_path3, my_company_banner_path4, my_company_banner_path5, my_company_banner_path6, my_company_banner_path7, my_company_banner_path8, my_company_banner_path9, my_company_banner_path10, my_company_banner_path11, my_company_banner_path12, my_company_banner_path13, my_company_banner_path14, my_company_banner_path15, my_company_banner_path16, my_company_banner_path17, my_company_banner_path18, my_company_banner_path19, my_company_banner_path20, my_company_banner_path21, my_company_banner_path22, my_company_banner_path23, my_company_banner_path24, my_company_banner_path25, my_company_banner_path26, my_company_banner_path27, my_company_banner_path28, my_company_banner_path29, my_company_banner_path30, my_company_banner_path31, my_company_banner_path32, my_company_banner_path33, my_company_banner_path34, my_company_banner_path35, my_company_banner_path36, my_company_banner_path37, my_company_banner_path38, my_company_banner_path39, my_company_banner_path40, my_company_banner_path41, my_company_banner_path42, my_company_banner_path43, my_company_banner_path44, my_company_banner_path45, my_company_banner_path46, my_company_banner_path47, my_company_banner_path48, my_company_banner_path49, my_company_banner_path50, my_company_banner_path51, my_company_banner_path52, my_company_banner_path53, my_company_banner_path54, my_company_banner_path55, my_company_banner_path56, my_company_banner_path57, my_company_banner_path58, my_company_banner_path59, my_company_banner_path60, my_company_banner_path61, my_company_banner_path62, my_company_banner_path63, my_company_banner_path64, my_company_banner_path65, my_company_banner_path66, my_company_banner_path67, my_company_banner_path68, my_company_banner_path69, my_company_banner_path70, my_company_banner_path71, my_company_banner_path72, my_company_banner_path73, my_company_banner_path74, my_company_banner_path75, my_company_banner_path76, my_company_banner_path77, my_company_banner_path78, my_company_banner_path79, my_company_banner_path80, my_company_banner_path81, my_company_banner_path82, my_company_banner_path83, my_company_banner_path84, my_company_banner_path85, my_company_banner_path86, my_company_banner_path87, my_company_banner_path88, my_company_banner_path89, my_company_banner_path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108;
function my_company_banner_extends() { my_company_banner_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return my_company_banner_extends.apply(this, arguments); }

var SvgMyCompanyBanner = function SvgMyCompanyBanner(props) {
  return /*#__PURE__*/react.createElement("svg", my_company_banner_extends({
    width: 624,
    height: 355,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), my_company_banner_path || (my_company_banner_path = /*#__PURE__*/react.createElement("path", {
    d: "M553.612 248.495s-20.039-24.499-59.589-18.988c-39.549 5.512-60.769-18.895-77.275-48.781-16.505-29.886-69.332 23.93-69.332 23.93s7.801 27.591-22.695 49.117c-30.497 21.527-16.152 40.997-16.152 40.997h212.924l32.119-46.275Z",
    fill: "#D9EEE8"
  })), my_company_banner_path2 || (my_company_banner_path2 = /*#__PURE__*/react.createElement("path", {
    d: "M347.416 204.655s-3.555-16.817-19.827-10.394c-16.271 6.423-33.85-13.871-20.915-28.66 12.935-14.788 30.001-8.306 38.221-4.741 8.22 3.564 16.609-10.449 1.693-29.431-14.916-18.982 13.719-49.807 41.738-16.47 28.019 33.336 28.395 65.745 28.395 65.745l-69.305 23.951Z",
    fill: "#D9EEE8"
  })), my_company_banner_path3 || (my_company_banner_path3 = /*#__PURE__*/react.createElement("path", {
    d: "M453.701 306.45c-19.717-12.776-36.109-32.398-47.394-56.74-9.042-19.503-14.519-41.528-15.025-60.418-.806-30.244-14.426-49.91-25.716-61.074-12.227-12.104-24.389-17.111-24.498-17.16l.485-1.182c.125.049 12.521 5.153 24.933 17.436 11.432 11.332 25.275 31.28 26.097 61.948.501 18.721 5.934 40.562 14.905 59.913 11.182 24.125 27.41 43.563 46.926 56.203l-.713 1.074ZM337.094 300.249l-.827-.976c49.648-41.87 43.24-83.843 32.919-100.183-11.792-18.662-31.063-22.747-45.151-22.894a93.28 93.28 0 0 0-28.194 4.242l-.419-1.209a95.68 95.68 0 0 1 28.585-4.308c14.427.141 34.155 4.34 46.273 23.49 10.517 16.666 17.137 59.399-33.186 101.838ZM321.213 151.532l-1.213.422 7.997 22.845 1.213-.421-7.997-22.846Z",
    fill: "#fff"
  })), my_company_banner_path4 || (my_company_banner_path4 = /*#__PURE__*/react.createElement("path", {
    d: "m366.986 127.534-1.225-.374c4.698-15.277-.147-29.745-.201-29.892l1.214-.412c.054.152 5.013 15.011.212 30.678ZM336.727 222.405l-.776 1.013 36.58 27.831.777-1.013-36.581-27.831Z",
    fill: "#fff"
  })), my_company_banner_path5 || (my_company_banner_path5 = /*#__PURE__*/react.createElement("path", {
    d: "m359.085 240.262-18.17 12.992.749 1.04 18.17-12.992-.749-1.04ZM486.038 304.041l-.877-.922c32.663-30.206 39.381-77.306 39.446-77.778l1.268.174c-.065.461-6.837 48-39.837 78.526Z",
    fill: "#fff"
  })), my_company_banner_path6 || (my_company_banner_path6 = /*#__PURE__*/react.createElement("path", {
    d: "m497.945 222.567-1.119.63 19.109 33.699 1.119-.63-19.109-33.699Z",
    fill: "#fff"
  })), my_company_banner_path7 || (my_company_banner_path7 = /*#__PURE__*/react.createElement("path", {
    d: "M556.083 170.576c20.015 0 36.24-16.169 36.24-36.114 0-19.945-16.225-36.114-36.24-36.114-20.014 0-36.239 16.169-36.239 36.114 0 19.945 16.225 36.114 36.239 36.114Z",
    fill: "#D9EEE8"
  })), my_company_banner_path8 || (my_company_banner_path8 = /*#__PURE__*/react.createElement("path", {
    d: "m562.355 129.493-4.023 1.019-.425-4.117 7.366-10.503 4.447 3.092-7.365 10.509Z",
    fill: "#408DBC"
  })), my_company_banner_path9 || (my_company_banner_path9 = /*#__PURE__*/react.createElement("path", {
    d: "M572.752 121.496a6.617 6.617 0 0 0 .788-4.79 6.635 6.635 0 0 0-2.693-4.045 6.679 6.679 0 0 0-8.983 1.24l10.888 7.595Z",
    fill: "#408DBC"
  })), my_company_banner_path10 || (my_company_banner_path10 = /*#__PURE__*/react.createElement("path", {
    d: "m570.199 112.423-1.677 2.393 1.049.73 1.677-2.393-1.049-.73Z",
    fill: "#003C71"
  })), my_company_banner_path11 || (my_company_banner_path11 = /*#__PURE__*/react.createElement("path", {
    d: "m563.043 116.412-.732 1.046 6.885 4.794.733-1.045-6.886-4.795ZM561.592 118.415l-.733 1.045 6.887 4.793.733-1.045-6.887-4.793ZM560.189 120.482l-.733 1.045 6.886 4.794.732-1.045-6.885-4.794ZM558.744 122.484l-.732 1.045 6.886 4.793.733-1.045-6.887-4.793ZM568.098 152.505l-4.045.923-.326-4.123 8.922-11.859 4.371 3.2-8.922 11.859Z",
    fill: "#408DBC"
  })), my_company_banner_path12 || (my_company_banner_path12 = /*#__PURE__*/react.createElement("path", {
    d: "M579.992 143.234a6.618 6.618 0 0 0 .9-4.771 6.636 6.636 0 0 0-2.599-4.106 6.682 6.682 0 0 0-9.009 1.033l10.708 7.844Z",
    fill: "#408DBC"
  })), my_company_banner_path13 || (my_company_banner_path13 = /*#__PURE__*/react.createElement("path", {
    d: "m577.556 132.578-1.728 2.365 1.036.752 1.728-2.364-1.036-.753Z",
    fill: "#003C71"
  })), my_company_banner_path14 || (my_company_banner_path14 = /*#__PURE__*/react.createElement("path", {
    d: "m571.058 137.289-1.15.57 4.345 8.699 1.15-.571-4.345-8.698ZM569.068 139.402l-1.15.57 4.344 8.699 1.15-.571-4.344-8.698ZM567.086 141.524l-1.15.57 4.344 8.698 1.15-.57-4.344-8.698ZM565.1 143.685l-1.15.571 4.344 8.698 1.151-.57-4.345-8.699Z",
    fill: "#D9EEE8"
  })), my_company_banner_path15 || (my_company_banner_path15 = /*#__PURE__*/react.createElement("path", {
    d: "M536.153 139.48h-4.513l-2.259 3.9 2.259 3.896h4.513l2.259-3.896-2.259-3.9Z",
    fill: "#408DBC"
  })), my_company_banner_path16 || (my_company_banner_path16 = /*#__PURE__*/react.createElement("path", {
    d: "M533.899 145.485a2.109 2.109 0 0 0 2.113-2.105 2.109 2.109 0 0 0-2.113-2.104 2.108 2.108 0 0 0-2.112 2.104c0 1.163.946 2.105 2.112 2.105Z",
    fill: "#D9EEE8"
  })), my_company_banner_path17 || (my_company_banner_path17 = /*#__PURE__*/react.createElement("path", {
    d: "M554.39 143.25h-5.498l-2.744 4.742 2.744 4.741h5.498l2.744-4.741-2.744-4.742Z",
    fill: "#408DBC"
  })), my_company_banner_path18 || (my_company_banner_path18 = /*#__PURE__*/react.createElement("path", {
    d: "M551.641 150.552a2.564 2.564 0 0 0 2.569-2.56 2.565 2.565 0 0 0-2.569-2.561 2.566 2.566 0 0 0-2.57 2.561 2.565 2.565 0 0 0 2.57 2.56Z",
    fill: "#D9EEE8"
  })), my_company_banner_path19 || (my_company_banner_path19 = /*#__PURE__*/react.createElement("path", {
    d: "M549.284 127.626h-6.156l-3.076 5.311 3.076 5.311h6.156l3.076-5.311-3.076-5.311Z",
    fill: "#408DBC"
  })), my_company_banner_path20 || (my_company_banner_path20 = /*#__PURE__*/react.createElement("path", {
    d: "M546.208 135.802a2.87 2.87 0 0 0 2.875-2.865 2.87 2.87 0 0 0-2.875-2.864 2.869 2.869 0 0 0-2.874 2.864 2.87 2.87 0 0 0 2.874 2.865Z",
    fill: "#D9EEE8"
  })), my_company_banner_path21 || (my_company_banner_path21 = /*#__PURE__*/react.createElement("path", {
    d: "M503.604 49.338h-39.233a4.554 4.554 0 0 0-4.562 4.547v1.61a4.554 4.554 0 0 0 4.562 4.547h39.233a4.554 4.554 0 0 0 4.562-4.546v-1.611a4.554 4.554 0 0 0-4.562-4.547Z",
    fill: "#FF9D57"
  })), my_company_banner_path22 || (my_company_banner_path22 = /*#__PURE__*/react.createElement("path", {
    d: "M514.895 56.955a3.72 3.72 0 0 1-3.434-2.28 3.692 3.692 0 0 1 .801-4.034 3.718 3.718 0 0 1 4.047-.804 3.692 3.692 0 0 1 2.293 3.419 3.696 3.696 0 0 1-1.087 2.612 3.725 3.725 0 0 1-2.62 1.087Zm0-6.12a2.434 2.434 0 0 0-2.243 1.494 2.415 2.415 0 0 0 .526 2.637 2.431 2.431 0 0 0 4.145-1.71 2.416 2.416 0 0 0-.719-1.698 2.433 2.433 0 0 0-1.709-.7v-.022Z",
    fill: "#003C71"
  })), my_company_banner_path23 || (my_company_banner_path23 = /*#__PURE__*/react.createElement("path", {
    d: "m517.618 54.719-.799 1.003 4.282 3.385.798-1.003-4.281-3.385Z",
    fill: "#003C71"
  })), my_company_banner_path24 || (my_company_banner_path24 = /*#__PURE__*/react.createElement("path", {
    d: "M468.203 56.185c.893 0 1.617-.722 1.617-1.612 0-.89-.724-1.61-1.617-1.61s-1.617.72-1.617 1.61c0 .89.724 1.612 1.617 1.612ZM473.816 56.185c.893 0 1.617-.722 1.617-1.612 0-.89-.724-1.61-1.617-1.61s-1.617.72-1.617 1.61c0 .89.724 1.612 1.617 1.612ZM479.433 56.185c.893 0 1.617-.722 1.617-1.612 0-.89-.724-1.61-1.617-1.61s-1.617.72-1.617 1.61c0 .89.724 1.612 1.617 1.612Z",
    fill: "#FFD400"
  })), my_company_banner_path25 || (my_company_banner_path25 = /*#__PURE__*/react.createElement("path", {
    d: "M417.549 121.285c6.058-1.444 14.366 2.891 15.683 3.797 1.318.906 0 2.761-1.845 3.022 2.379 2.105 3.043 4.996 2.379 6.569-.664 1.574-3.811 1.579-5.673.787 0 0-.925 4.996 1.187 7.752 2.112 2.756 9.619 4.074 9.619 4.074s-3.032 5.778-12.521 5.778c-9.488 0-11.584-6.032-11.584-6.032l8.95-11.545-6.195-14.202ZM482.297 116.825s-2.33 5.224-.958 9.635c1.372 4.41 4.257 0 4.257 0l-3.299-9.635Z",
    fill: "#FDC498"
  })), my_company_banner_path26 || (my_company_banner_path26 = /*#__PURE__*/react.createElement("path", {
    d: "M531.618 77.37h-42.2c-3.719 0-6.734 3.004-6.734 6.71v35.029c0 3.706 3.015 6.711 6.734 6.711h42.2c3.719 0 6.734-3.005 6.734-6.711V84.08c0-3.706-3.015-6.71-6.734-6.71Z",
    fill: "#408DBC"
  })), my_company_banner_path27 || (my_company_banner_path27 = /*#__PURE__*/react.createElement("path", {
    d: "m413.024 170.598 4.094-25.856a6.317 6.317 0 0 1 2.145-3.815 6.356 6.356 0 0 1 4.116-1.518h35.559l22.406-12.949 6.179-8.615s4.943 3.369 2.423 7.628c-4.072 6.862-17.627 21.738-31.422 24.412-13.795 2.675-24.296 9.027-26.561 20.723l-18.939-.01Z",
    fill: "#FDC498"
  })), my_company_banner_path28 || (my_company_banner_path28 = /*#__PURE__*/react.createElement("path", {
    d: "M499.772 90.41H488.22v1.281h11.552v-1.28Z",
    fill: "#fff"
  })), my_company_banner_path29 || (my_company_banner_path29 = /*#__PURE__*/react.createElement("path", {
    d: "M501.214 87.454h3.315v6.836h-3.315a2.917 2.917 0 0 1-2.059-.85 2.898 2.898 0 0 1-.853-2.052v-1.031c0-.77.307-1.508.853-2.053a2.917 2.917 0 0 1 2.059-.85Z",
    fill: "#A8CBE1"
  })), my_company_banner_path30 || (my_company_banner_path30 = /*#__PURE__*/react.createElement("path", {
    d: "M519.723 111.01h4.573v2.235c0 .513-.205 1.006-.569 1.369a1.949 1.949 0 0 1-1.374.567h-.692c-.515 0-1.01-.204-1.374-.567a1.935 1.935 0 0 1-.569-1.369v-2.219l.005-.016ZM514.998 103.382h-.974a2.729 2.729 0 0 1-1.925-.794 2.71 2.71 0 0 1-.797-1.918v-6.38h1.279v6.369a1.458 1.458 0 0 0 1.454 1.448h.974l-.011 1.275Z",
    fill: "#003C71"
  })), my_company_banner_path31 || (my_company_banner_path31 = /*#__PURE__*/react.createElement("path", {
    d: "M529.135 85.474h-23.947a2.01 2.01 0 0 0-2.014 2.007v7.14a2.01 2.01 0 0 0 2.014 2.007h23.947a2.011 2.011 0 0 0 2.015-2.007v-7.14a2.011 2.011 0 0 0-2.015-2.007Z",
    fill: "#FFD400"
  })), my_company_banner_path32 || (my_company_banner_path32 = /*#__PURE__*/react.createElement("path", {
    d: "M516.713 94.29h10.381v16.074a2.81 2.81 0 0 1-.827 1.991 2.832 2.832 0 0 1-1.998.825h-4.731a2.832 2.832 0 0 1-1.998-.825 2.813 2.813 0 0 1-.827-1.991V94.29Z",
    fill: "#FFD400"
  })), my_company_banner_path33 || (my_company_banner_path33 = /*#__PURE__*/react.createElement("path", {
    d: "M512.576 88.024h-1.285v3.027h1.285v-3.027ZM515.64 88.024h-1.285v3.027h1.285v-3.027ZM518.711 88.024h-1.285v3.027h1.285v-3.027ZM503.816 90.872h-1.285v-2.886a3.154 3.154 0 0 1 .928-2.227 3.175 3.175 0 0 1 2.235-.925h6.233v1.286h-6.222a1.883 1.883 0 0 0-1.878 1.871l-.011 2.881ZM516.522 119.999a9.77 9.77 0 0 1-7.589-3.922c-2.591-3.255-5.879-4.736-9.009-4.015-3.13.722-5.558 3.537-6.424 7.503l-1.252-.271c.974-4.465 3.735-7.633 7.387-8.474 3.653-.841 7.393.786 10.305 4.464 2.521 3.18 5.989 3.896 8.313 3.196a4.27 4.27 0 0 0 2.197-1.437 4.234 4.234 0 0 0 .933-2.447l1.28.103a5.544 5.544 0 0 1-4.04 5.001 7.183 7.183 0 0 1-2.101.299Z",
    fill: "#003C71"
  })), my_company_banner_path34 || (my_company_banner_path34 = /*#__PURE__*/react.createElement("path", {
    d: "M421.228 140.077c3.397-.63 13.659-2.046 37.71-.668l9.755 6.51s-3.92 3.955-16.332 6.179c-12.411 2.225-20.31 13.52-20.419 18.521h-18.918l2.641-20.229 5.563-10.313Z",
    fill: "#40A88D"
  })), my_company_banner_path35 || (my_company_banner_path35 = /*#__PURE__*/react.createElement("path", {
    d: "m391.788 272.511 17.616 6.695-1.018 2.436c-.849 2.039 0 5.246 1.563 6.732l.25.239a9.168 9.168 0 0 0 3.898 2.17c4.6 1.28 4.638 4.009 4.638 4.009h-10.632l-21.367-15.217 5.052-7.064ZM484.757 294.77s-3.974-4.139-11.66-6.396c-7.687-2.257-23.131-2.257-23.131-2.257v8.68l34.791-.027Z",
    fill: "#003C71"
  })), my_company_banner_path36 || (my_company_banner_path36 = /*#__PURE__*/react.createElement("path", {
    d: "m431.963 170.598 41.134 117.776h-34.198s7.284-27.347-11.465-58.888c1.421 15.472-4.115 35.496-15.645 53.55l-24.296-8.615s-2.978-9.434 10.294-18.038c12.684-8.224 11.062-19.866 9.472-26.897-7.251-32.067-.822-43.704 5.765-58.888h18.939Z",
    fill: "#FFD400"
  })), my_company_banner_path37 || (my_company_banner_path37 = /*#__PURE__*/react.createElement("path", {
    d: "m411.767 146.858-3.179 34.156 7.512.206 3.958-40.997-8.291 6.635Z",
    fill: "#FFD400"
  })), my_company_banner_path38 || (my_company_banner_path38 = /*#__PURE__*/react.createElement("path", {
    d: "M414.777 153.075h17.878l-2.504 21.505h-17.127l1.753-21.505Z",
    fill: "#FFD400"
  })), my_company_banner_path39 || (my_company_banner_path39 = /*#__PURE__*/react.createElement("path", {
    d: "M423.743 135.487s-10.948-2.539-9.875-10.953c.664-5.203 9.51-3.217 9.51-3.217v4.579c-2.929-1.178-4.191 2.875 0 4.464l.365 5.127ZM459.661 289.014h-21.53l.141-.759c3.849-20.648-.19-41.393-11.372-58.416-15.825-21.89-13.92-36.169-13.832-36.766l1.268.185c0 .146-1.884 14.414 13.61 35.854 11.241 17.121 15.384 37.899 11.709 58.622h19.995l.011 1.28ZM511.117 293.463h-149.51v1.28h149.51v-1.28ZM426.873 126.503a.831.831 0 1 0 0-1.66.831.831 0 1 0 0 1.66Z",
    fill: "#003C71"
  })), my_company_banner_path40 || (my_company_banner_path40 = /*#__PURE__*/react.createElement("path", {
    d: "M423.362 132.72s-5.939-2.826-9.636.19c-3.696 3.016 1.873 10.134-8.519 13.21-10.393 3.076-10.648 16.08-10.648 16.08l23.871-.592s-4.306-4.416 1.96-8.067c6.265-3.651 5.106-10.801 3.07-12.987s.261-4.769.261-4.769l-.359-3.065Z",
    fill: "#003C71"
  })), my_company_banner_path41 || (my_company_banner_path41 = /*#__PURE__*/react.createElement("path", {
    d: "m401.255 150.39-.468-1.194c5.194-2.007 5.373-4.964 5.575-8.382.168-2.788.359-5.967 3.886-8.218 7.045-4.525 11.465 1.345 11.509 1.405l-1.035.754c-.152-.201-3.767-4.953-9.798-1.085-2.984 1.915-3.142 4.492-3.305 7.22-.18 3.375-.408 7.194-6.364 9.5ZM421.664 160.876c-.103 0-2.651-.602-3.626-2.892-.783-1.839-.304-4.171 1.416-6.943l1.089.672c-1.487 2.393-1.933 4.34-1.329 5.762.708 1.681 2.722 2.17 2.722 2.17l-.272 1.231Z",
    fill: "#003C71"
  })), my_company_banner_path42 || (my_company_banner_path42 = /*#__PURE__*/react.createElement("path", {
    d: "m413.977 134.858 14.285-18.033a3.078 3.078 0 0 0-4.056.798l-10.539 13.171.31 4.064Z",
    fill: "#FFD400"
  })), my_company_banner_path43 || (my_company_banner_path43 = /*#__PURE__*/react.createElement("path", {
    d: "M413.977 134.858s-7.588-6.51-3.233-13.926c4.034-6.895 12.395-4.047 14.622-2.17l-9.222 13.606-2.167 2.49ZM438.898 138.829s-3.783 29.382-4.028 58.758c-16.081-5.154-7.164-20.615-7.164-20.615a237.01 237.01 0 0 1 4.039-37.899l7.153-.244Z",
    fill: "#FFD400"
  })), my_company_banner_path44 || (my_company_banner_path44 = /*#__PURE__*/react.createElement("path", {
    d: "M437.663 187.03h-33.469l1.492-6.016h31.977v6.016Z",
    fill: "#40A88D"
  })), my_company_banner_path45 || (my_company_banner_path45 = /*#__PURE__*/react.createElement("path", {
    d: "m405.561 184.176-1.247-.309.871-3.493h32.478v1.28h-31.476l-.626 2.522ZM437.668 186.39h-33.474v1.28h33.474v-1.28Z",
    fill: "#003C71"
  })), my_company_banner_path46 || (my_company_banner_path46 = /*#__PURE__*/react.createElement("path", {
    d: "M422.85 203.533h1.623v-10.715h-1.623v10.715Z",
    fill: "#fff"
  })), my_company_banner_path47 || (my_company_banner_path47 = /*#__PURE__*/react.createElement("path", {
    d: "M422.186 207.672h2.951v-5.485h-2.951v5.485ZM430.951 196.442v3.537h-.67l-1.05-1.182h-1.144a.76.76 0 0 0-.762.759v2.805a.758.758 0 0 0 .762.759h1.051l1.051-1.014h.762v1.014s5.787.63 7.017-3.428a.39.39 0 0 0-.007-.241.39.39 0 0 0-.146-.193.4.4 0 0 0-.506 0c-.648.569-2.482 1.996-3.457.732-.593-.77-.495-3.564-.495-3.564l-2.406.016Z",
    fill: "#fff"
  })), my_company_banner_path48 || (my_company_banner_path48 = /*#__PURE__*/react.createElement("path", {
    d: "M433.374 192.151h-2.423v4.975h2.423v-4.975Z",
    fill: "#fff"
  })), my_company_banner_path49 || (my_company_banner_path49 = /*#__PURE__*/react.createElement("path", {
    d: "M434.724 192.824h-5.128v-16.275a2.168 2.168 0 0 1 2.177-2.17h.773c.578 0 1.131.228 1.54.635.408.407.638.959.638 1.535v16.275ZM426.226 192.824h-5.129v-16.275c0-.576.23-1.128.638-1.535a2.183 2.183 0 0 1 1.54-.635h.773c.578 0 1.131.228 1.54.635.408.407.638.959.638 1.535v16.275ZM424.304 205.524h-1.284v2.148h1.284v-2.148ZM387.712 273.81l-.431 1.206 24.295 8.616.431-1.206-24.295-8.616Z",
    fill: "#003C71"
  })), my_company_banner_path50 || (my_company_banner_path50 = /*#__PURE__*/react.createElement("path", {
    d: "m472.155 131.771 4.061 8.886s-6.881 8.441-26.326 12c-2.472-6.244 9.047-13.248 9.047-13.248l13.218-7.638Z",
    fill: "#40A88D"
  })), my_company_banner_path51 || (my_company_banner_path51 = /*#__PURE__*/react.createElement("path", {
    d: "m424.631 117.541-2.978-1.844-1.9 3.103 2.847.944 2.031-2.203Z",
    fill: "#FFD400"
  })), my_company_banner_path52 || (my_company_banner_path52 = /*#__PURE__*/react.createElement("path", {
    d: "M412.616 131.012c-.419-3.798.305-6.917 2.151-9.223a10.349 10.349 0 0 1 6.396-3.591l.136 1.275-.065-.635.065.635c-.348.038-8.541 1.085-7.409 11.392l-1.274.147Z",
    fill: "#FF7D20"
  })), my_company_banner_path53 || (my_company_banner_path53 = /*#__PURE__*/react.createElement("path", {
    d: "M530.421 126.46h-33.425v-1.28h33.425a7.313 7.313 0 0 0 5.154-2.129 7.257 7.257 0 0 0 2.14-5.135V85.274a7.257 7.257 0 0 0-2.14-5.136 7.31 7.31 0 0 0-5.154-2.129h-39.806a7.314 7.314 0 0 0-5.151 2.131 7.264 7.264 0 0 0-2.138 5.133v19.677h-1.279V85.273a8.532 8.532 0 0 1 2.513-6.034 8.593 8.593 0 0 1 6.055-2.504h39.806a8.596 8.596 0 0 1 6.059 2.502 8.537 8.537 0 0 1 2.515 6.037v32.642a8.536 8.536 0 0 1-2.515 6.038 8.598 8.598 0 0 1-6.059 2.506Z",
    fill: "#003C71"
  })), my_company_banner_path54 || (my_company_banner_path54 = /*#__PURE__*/react.createElement("path", {
    d: "M550.932 159.428h-62.315c-3.259 0-5.901 2.632-5.901 5.88v32.371c0 3.248 2.642 5.881 5.901 5.881h62.315c3.259 0 5.901-2.633 5.901-5.881v-32.371c0-3.248-2.642-5.88-5.901-5.88Z",
    fill: "#F09D61"
  })), my_company_banner_path55 || (my_company_banner_path55 = /*#__PURE__*/react.createElement("path", {
    d: "M550.927 159.428h-7.256l-33.779 44.132h41.035c1.565 0 3.066-.62 4.173-1.723a5.866 5.866 0 0 0 1.728-4.158v-32.354a5.876 5.876 0 0 0-3.639-5.448 5.911 5.911 0 0 0-2.262-.449Z",
    fill: "#EB7C2D"
  })), my_company_banner_path56 || (my_company_banner_path56 = /*#__PURE__*/react.createElement("path", {
    d: "M544.514 177.308c3.395 0 6.146-2.742 6.146-6.124 0-3.383-2.751-6.125-6.146-6.125-3.394 0-6.146 2.742-6.146 6.125 0 3.382 2.752 6.124 6.146 6.124Z",
    fill: "#F6D330"
  })), my_company_banner_path57 || (my_company_banner_path57 = /*#__PURE__*/react.createElement("path", {
    d: "M505.329 193.328h-15.885v4.064h15.885v-4.064ZM495.356 187.583h-5.912v4.064h5.912v-4.064ZM509.358 187.583h-9.946v4.064h9.946v-4.064ZM523.866 187.583h-9.946v4.064h9.946v-4.064ZM531.27 187.583h-2.847v4.064h2.847v-4.064ZM525.243 193.328h-15.885v4.064h15.885v-4.064ZM499.881 183.026h-6.565a4.52 4.52 0 0 1-3.19-1.319 4.492 4.492 0 0 1-1.323-3.178v-.7a4.492 4.492 0 0 1 1.323-3.178 4.525 4.525 0 0 1 3.19-1.319h6.565a4.525 4.525 0 0 1 3.189 1.319 4.497 4.497 0 0 1 1.324 3.178v.7a4.497 4.497 0 0 1-1.324 3.178 4.52 4.52 0 0 1-3.189 1.319Zm-6.565-8.414a3.24 3.24 0 0 0-2.285.942 3.215 3.215 0 0 0-.949 2.275v.7c.001.854.343 1.672.949 2.275a3.24 3.24 0 0 0 2.285.942h6.565a3.274 3.274 0 0 0 2.275-.951 3.25 3.25 0 0 0 .959-2.266v-.7a3.25 3.25 0 0 0-.959-2.266 3.274 3.274 0 0 0-2.275-.951h-6.565Z",
    fill: "#00416A"
  })), my_company_banner_path58 || (my_company_banner_path58 = /*#__PURE__*/react.createElement("path", {
    d: "M452.28 115.724c11.879 0 21.509-9.596 21.509-21.434 0-11.838-9.63-21.434-21.509-21.434s-21.509 9.596-21.509 21.434c0 11.838 9.63 21.434 21.509 21.434Z",
    fill: "#D9EEE8"
  })), my_company_banner_path59 || (my_company_banner_path59 = /*#__PURE__*/react.createElement("path", {
    d: "M417.804 103.339h-1.284v-4.574h44.296v1.275h-43.012v3.299Z",
    fill: "#003C71"
  })), my_company_banner_path60 || (my_company_banner_path60 = /*#__PURE__*/react.createElement("path", {
    d: "M461.997 101.369H441.12v-9.998c0-2.034.811-3.985 2.255-5.424a7.71 7.71 0 0 1 5.443-2.247h5.481c2.042 0 4 .808 5.444 2.247a7.66 7.66 0 0 1 2.254 5.424v9.998Z",
    fill: "#003C71"
  })), my_company_banner_path61 || (my_company_banner_path61 = /*#__PURE__*/react.createElement("path", {
    d: "M451.681 97.664c2.541 0 4.6-2.052 4.6-4.584a4.592 4.592 0 0 0-4.6-4.584c-2.54 0-4.6 2.052-4.6 4.584 0 2.532 2.06 4.584 4.6 4.584Z",
    fill: "#408DBC"
  })), my_company_banner_path62 || (my_company_banner_path62 = /*#__PURE__*/react.createElement("path", {
    d: "m212.951 192.43-3.882-3.264s-2.667 3.747-1.091 7.011c1.576 3.264 8.025 9.309 17.779 7.744 9.754-1.565 2.475-5.568 2.475-5.568l-6.187-5.097-9.094-.826Z",
    fill: "#F4B587"
  })), my_company_banner_path63 || (my_company_banner_path63 = /*#__PURE__*/react.createElement("path", {
    d: "M225.757 194.914s21.521 6.005 46.509-11.893l9.508 19.131s-22.256 18.514-56.035 1.746l.018-8.984Z",
    fill: "#D9E8F2"
  })), my_company_banner_path64 || (my_company_banner_path64 = /*#__PURE__*/react.createElement("path", {
    d: "M255.234 211.496c-15.76 0-29.669-6.714-29.856-6.807l-.525-.256.63-7.832 1.716.14-.537 6.65c3.73 1.694 26.512 11.306 45.423 3.166l.683 1.576a44.125 44.125 0 0 1-17.534 3.363Z",
    fill: "#003C71"
  })), my_company_banner_path65 || (my_company_banner_path65 = /*#__PURE__*/react.createElement("path", {
    d: "M201.084 209.541h-57.056a22.76 22.76 0 0 1-16.045-6.634 22.612 22.612 0 0 1-6.655-15.993V157.88h11.201v29.034a11.458 11.458 0 0 0 3.373 8.1 11.537 11.537 0 0 0 8.126 3.362h57.056a11.531 11.531 0 0 0 8.124-3.363 11.45 11.45 0 0 0 3.369-8.099v-56.228a21.043 21.043 0 0 1 6.192-14.873 21.175 21.175 0 0 1 14.921-6.172h26.056a9.94 9.94 0 0 0 7.017-2.897 9.88 9.88 0 0 0 2.906-6.995V60.767h11.201v38.982a21.027 21.027 0 0 1-6.189 14.888 21.163 21.163 0 0 1-14.935 6.169h-26.033a9.94 9.94 0 0 0-7.017 2.897 9.879 9.879 0 0 0-2.906 6.994v56.229a22.61 22.61 0 0 1-6.66 15.989 22.755 22.755 0 0 1-16.046 6.626Z",
    fill: "#E5E5E5"
  })), my_company_banner_path66 || (my_company_banner_path66 = /*#__PURE__*/react.createElement("path", {
    d: "M272.937 158.142s-5.282 4.527-5.533 11.241c-.053 2.386 3.164 1.327 3.788.931.251 2.665 2.195 5.429 5.779 5.446 3.584.018 11.09-6.324 11.826-10.298.735-3.974-6.585-14.185-15.86-7.32Z",
    fill: "#F4B587"
  })), my_company_banner_path67 || (my_company_banner_path67 = /*#__PURE__*/react.createElement("path", {
    d: "M273.235 166.206a.804.804 0 0 0 .806-.802.804.804 0 0 0-.806-.803.803.803 0 1 0 0 1.605Z",
    fill: "#003C71"
  })), my_company_banner_path68 || (my_company_banner_path68 = /*#__PURE__*/react.createElement("path", {
    d: "M279.323 170.192s1.646 7.494-.053 12.347c-1.698 4.852 15.994.488 15.994.488l-.246-3.409s-4.336-20.3-12.561-23.105c-8.224-2.804-3.134 13.679-3.134 13.679Z",
    fill: "#F4B587"
  })), my_company_banner_path69 || (my_company_banner_path69 = /*#__PURE__*/react.createElement("path", {
    d: "M279.896 158.509s1.546 2.979 2.544 4.742c0 0 2.983-.541 3.427 2.153a2.23 2.23 0 0 1-1.547 2.164s2.533 2.583 8.014 2.944h2.376s-1.71-4.201-3.59-8.373a9.405 9.405 0 0 0-3.488-4.102 9.448 9.448 0 0 0-5.174-1.524c-1.564 1.664-2.562 1.996-2.562 1.996Z",
    fill: "#003C71"
  })), my_company_banner_path70 || (my_company_banner_path70 = /*#__PURE__*/react.createElement("path", {
    d: "M271.204 223.866h29.769c11.96 11.136 1.675 60.4-63.874 10.915l19.845 46.623H239.72l-20.879-50.469a10.435 10.435 0 0 1 1.767-10.333 10.532 10.532 0 0 1 9.866-3.631l40.73 6.895Z",
    fill: "#FF7D20"
  })), my_company_banner_path71 || (my_company_banner_path71 = /*#__PURE__*/react.createElement("path", {
    d: "M269.085 249.112v20.411a11.845 11.845 0 0 0 3.487 8.401 11.949 11.949 0 0 0 8.426 3.48h45.815v-13.929H287.08l3.87-22.354-21.865 3.991Z",
    fill: "#FF7D20"
  })), my_company_banner_path72 || (my_company_banner_path72 = /*#__PURE__*/react.createElement("path", {
    d: "M292.538 180.572c-2.702.972-5.51 2.665-7.774 2.455h-12.497v40.839h30.404v-30.884c0-7.272-3.041-13.137-10.133-12.41Z",
    fill: "#D9E8F2"
  })), my_company_banner_path73 || (my_company_banner_path73 = /*#__PURE__*/react.createElement("path", {
    d: "M279.323 172.322h-.052v.029l.052-.029Z",
    fill: "#82B5D3"
  })), my_company_banner_path74 || (my_company_banner_path74 = /*#__PURE__*/react.createElement("path", {
    d: "M295.019 179.618a1.658 1.658 0 0 1-.233-.047c-6.147 3.305-14.143 1.996-17.009.937-2.866.081-3.222.809-6.777 3.404l19.449 1.221c-2.288 13.761-4.028 38.733-4.028 38.733s17.564 9.641 31.561 0c10.232-7.046 10.898-38.541-22.963-44.248Z",
    fill: "#D9E8F2"
  })), my_company_banner_path75 || (my_company_banner_path75 = /*#__PURE__*/react.createElement("path", {
    d: "M278.127 162.122h12.993s-3.426-9.431-12.993-9.431-8.429 9.431-8.429 9.431h8.429Z",
    fill: "#408DBC"
  })), my_company_banner_path76 || (my_company_banner_path76 = /*#__PURE__*/react.createElement("path", {
    d: "M269.698 162.122s-12.258-3.404-9.596-8.373c2.662-4.968 21.673 8.373 21.673 8.373h-12.077Z",
    fill: "#82B5D3"
  })), my_company_banner_path77 || (my_company_banner_path77 = /*#__PURE__*/react.createElement("path", {
    d: "M278.197 178.984h-5.93v44.882h5.93v-44.882ZM297.237 178.984h-5.93v44.882h5.93v-44.882Z",
    fill: "#FF7D20"
  })), my_company_banner_path78 || (my_company_banner_path78 = /*#__PURE__*/react.createElement("path", {
    d: "M297.231 191.353h-22.017v42.434h22.017v-42.434Z",
    fill: "#FF7D20"
  })), my_company_banner_path79 || (my_company_banner_path79 = /*#__PURE__*/react.createElement("path", {
    d: "M293.997 202.187s16.256.151 14.312 10.386c-1.325 6.982-10.71 6.348-14.312 4.247-3.601-2.1 0-14.633 0-14.633Z",
    fill: "#FF7D20"
  })), my_company_banner_path80 || (my_company_banner_path80 = /*#__PURE__*/react.createElement("path", {
    d: "M286.76 257.444c-28.158 0-53.759-25.432-54.028-25.694l1.226-1.21c.269.267 27.02 26.881 55.504 25.106l.105 1.711a45.36 45.36 0 0 1-2.807.087Z",
    fill: "#003C71"
  })), my_company_banner_path81 || (my_company_banner_path81 = /*#__PURE__*/react.createElement("path", {
    d: "M225.757 194.914s-.31-7.255-9.923-7.255h-5.143s.672 3.747 5.143 3.689c2.241 0 3.07 1.844 3.339 3.729a4.301 4.301 0 0 0 1.419 2.678 4.336 4.336 0 0 0 2.836 1.087h2.335l-.006-3.928Z",
    fill: "#F4B587"
  })), my_company_banner_path82 || (my_company_banner_path82 = /*#__PURE__*/react.createElement("path", {
    d: "M171.555 283.05h-11.201V102.344c0-3.703 1.475-7.255 4.103-9.874a14.03 14.03 0 0 1 9.905-4.09h13.309v11.166h-13.32a2.807 2.807 0 0 0-1.976.818 2.784 2.784 0 0 0-.82 1.969V283.05Z",
    fill: "#CBCBCB"
  })), my_company_banner_path83 || (my_company_banner_path83 = /*#__PURE__*/react.createElement("path", {
    d: "M241.897 105.451h-1.722c-1 0-1.81.808-1.81 1.804v13.976c0 .996.81 1.803 1.81 1.803h1.722c.999 0 1.809-.807 1.809-1.803v-13.976c0-.996-.81-1.804-1.809-1.804ZM174.776 135.672v-1.717c0-.996-.81-1.803-1.809-1.803h-14.021c-.999 0-1.809.807-1.809 1.803v1.717c0 .996.81 1.804 1.809 1.804h14.021c.999 0 1.809-.808 1.809-1.804ZM227.035 148.449v-1.716c0-.997-.81-1.804-1.809-1.804h-14.021c-.999 0-1.809.807-1.809 1.804v1.716c0 .996.81 1.804 1.809 1.804h14.021c.999 0 1.809-.808 1.809-1.804ZM135.751 157.892v-1.716c0-.996-.81-1.804-1.81-1.804h-14.02c-.999 0-1.809.808-1.809 1.804v1.716c0 .996.81 1.804 1.809 1.804h14.02c1 0 1.81-.808 1.81-1.804ZM174.776 184.499v-1.716c0-.996-.81-1.804-1.809-1.804h-14.021c-.999 0-1.809.808-1.809 1.804v1.716c0 .996.81 1.804 1.809 1.804h14.021c.999 0 1.809-.808 1.809-1.804ZM174.771 224.727v-1.716c0-.996-.811-1.804-1.81-1.804h-14.02c-1 0-1.81.808-1.81 1.804v1.716c0 .997.81 1.804 1.81 1.804h14.02c.999 0 1.81-.807 1.81-1.804Z",
    fill: "#989898"
  })), my_company_banner_path84 || (my_company_banner_path84 = /*#__PURE__*/react.createElement("path", {
    d: "M186.112 209.6h-41.11l.041-11.247h41.11l-.041 11.247Z",
    fill: "#CBCBCB"
  })), my_company_banner_path85 || (my_company_banner_path85 = /*#__PURE__*/react.createElement("path", {
    d: "M146.637 194.967h-1.722c-.999 0-1.81.807-1.81 1.803v13.976c0 .996.811 1.804 1.81 1.804h1.722c.999 0 1.809-.808 1.809-1.804V196.77c0-.996-.81-1.803-1.809-1.803ZM186.993 194.967h-1.722c-.999 0-1.809.807-1.809 1.803v13.976c0 .996.81 1.804 1.809 1.804h1.722c1 0 1.81-.808 1.81-1.804V196.77c0-.996-.81-1.803-1.81-1.803Z",
    fill: "#989898"
  })), my_company_banner_path86 || (my_company_banner_path86 = /*#__PURE__*/react.createElement("path", {
    d: "M298.095 178.984h-1.722v27.247h1.722v-27.247ZM230.611 216.113l-.313 1.688 47.721 8.79.312-1.688-47.72-8.79ZM225.757 193.124l-.863 10.718 1.716.138.863-10.718-1.716-.138Z",
    fill: "#003C71"
  })), my_company_banner_path87 || (my_company_banner_path87 = /*#__PURE__*/react.createElement("path", {
    d: "M297.236 227.538v-6.168s.66-5.487-4.839-6.452c-5.498-.966-9.701-1.292-9.701-1.292s-.326 3.602 5.983 4.626c.672 1.873-6.245 1.809-9.129-1.577a1.427 1.427 0 0 0-1.498-.409 1.425 1.425 0 0 0-.988 1.194c-.572 4.829 2.434 11.201 20.172 10.078Z",
    fill: "#F4B587"
  })), my_company_banner_path88 || (my_company_banner_path88 = /*#__PURE__*/react.createElement("path", {
    d: "M298.795 228.998h-1.728v-12.12h15.632v1.717h-13.904v10.403ZM256.862 281.357v12.614h-34.409s2.183-7.156 15.036-6.737c5.341.43 2.148-5.877 2.148-5.877h17.225ZM332.627 287.816c-.089 2.063.07 4.129.473 6.155h6.286v-26.543h-12.655v13.929s6.328 1.135 5.896 6.459Z",
    fill: "#003C71"
  })), my_company_banner_path89 || (my_company_banner_path89 = /*#__PURE__*/react.createElement("path", {
    d: "M326.731 293.971s.584-5.347 7.98-5.347l4.669 5.347h-12.649Z",
    fill: "#003C71"
  })), my_company_banner_path90 || (my_company_banner_path90 = /*#__PURE__*/react.createElement("path", {
    d: "M357.323 293.744H211.906v1.717h145.417v-1.717Z",
    fill: "#003C71"
  })), _path91 || (_path91 = /*#__PURE__*/react.createElement("path", {
    d: "M131.613 60.778h-1.722v87.735h1.722V60.778ZM127.731 60.778h-1.722v87.735h1.722V60.778ZM123.855 60.778h-1.722v87.735h1.722V60.778ZM206.291 96.986h-14.599v1.716h14.599v-1.716ZM206.291 93.117h-14.599v1.716h14.599v-1.716ZM206.291 89.253h-14.599v1.717h14.599v-1.717Z",
    fill: "#E5F0F6"
  })), _path92 || (_path92 = /*#__PURE__*/react.createElement("path", {
    d: "M83.206 291.772c26.16 0 47.367-21.139 47.367-47.216 0-26.076-21.207-47.215-47.367-47.215-26.16 0-47.367 21.139-47.367 47.215 0 26.077 21.207 47.216 47.367 47.216Z",
    fill: "#FFD400"
  })), _path93 || (_path93 = /*#__PURE__*/react.createElement("path", {
    d: "M103.63 221.673h-6.62v33.671h6.62v-33.671Z",
    fill: "#408DBC"
  })), _path94 || (_path94 = /*#__PURE__*/react.createElement("path", {
    d: "M103.787 210.001v7.739h-6.934v-7.739a7.705 7.705 0 0 0-3.528 3.624 7.67 7.67 0 0 0 2.21 9.282 7.73 7.73 0 0 0 9.57 0 7.673 7.673 0 0 0 2.21-9.282 7.702 7.702 0 0 0-3.528-3.624Z",
    fill: "#408DBC"
  })), _path95 || (_path95 = /*#__PURE__*/react.createElement("path", {
    d: "M100.729 225.49h-.701c-.831 0-1.506.672-1.506 1.501v23.261c0 .83.675 1.502 1.506 1.502h.701c.832 0 1.506-.672 1.506-1.502v-23.261c0-.829-.674-1.501-1.506-1.501Z",
    fill: "#003C71"
  })), _path96 || (_path96 = /*#__PURE__*/react.createElement("path", {
    d: "m80.416 221.161 3.17-2.717-4.203-4.911 1.273-1.03 6.187 3.002a3.681 3.681 0 0 1 1.997 4.118 3.682 3.682 0 0 1-.701 1.474l-3.187 4.073 2.002 27.776a5.073 5.073 0 0 1-1.354 3.825 5.103 5.103 0 0 1-3.73 1.621 5.111 5.111 0 0 1-3.77-1.66 5.084 5.084 0 0 1-1.308-3.896l2.375-25.182-1.873-1.862a4.65 4.65 0 0 1-1.331-2.694l-.806-6.103.987-.797 4.272 4.963Z",
    fill: "#408DBC"
  })), _path97 || (_path97 = /*#__PURE__*/react.createElement("path", {
    d: "M78.934 229.929h6.344l1.658 23a5.069 5.069 0 0 1-1.36 3.869 5.103 5.103 0 0 1-3.782 1.612 5.113 5.113 0 0 1-3.745-1.694 5.082 5.082 0 0 1-1.275-3.898l2.16-22.889ZM83.2 218.019l-4.889 4.637.79.826 4.887-4.637-.788-.826ZM110.296 228.76h-54.18v1.14h54.18v-1.14Z",
    fill: "#003C71"
  })), _path98 || (_path98 = /*#__PURE__*/react.createElement("path", {
    d: "M112.426 252.789H53.799v12.882h58.627v-12.882ZM112.426 236.888H53.799v12.882h58.627v-12.882Z",
    fill: "#FFF6CC"
  })), _path99 || (_path99 = /*#__PURE__*/react.createElement("path", {
    d: "M58.434 224.349h-4.635v41.328h4.635v-41.328ZM112.613 224.349h-4.634v41.328h4.634v-41.328Z",
    fill: "#FFF6CC"
  })), _path100 || (_path100 = /*#__PURE__*/react.createElement("path", {
    d: "M112.613 265.101H53.799v1.14h58.814v-1.14ZM74.41 252.219H53.8v1.141h20.61v-1.141ZM103.624 249.199H53.799v1.141h49.825v-1.141ZM89.072 236.312H53.8v1.14h35.273v-1.14ZM36.417 244.556h-1.168a47.705 47.705 0 0 1 10.416-29.725 47.974 47.974 0 0 1 26.702-16.821l.257 1.117a46.818 46.818 0 0 0-26.07 16.422 46.558 46.558 0 0 0-10.16 29.025l.023-.018Z",
    fill: "#003C71"
  })), _path101 || (_path101 = /*#__PURE__*/react.createElement("path", {
    d: "M83.206 292.342v-1.163a46.889 46.889 0 0 0 27.838-9.146 46.643 46.643 0 0 0 16.917-23.861 46.49 46.49 0 0 0-.643-29.21 46.66 46.66 0 0 0-17.951-23.098l.643-.948a47.809 47.809 0 0 1 18.389 23.665 47.637 47.637 0 0 1 .658 29.926 47.786 47.786 0 0 1-17.331 24.446 48.042 48.042 0 0 1-28.52 9.372v.017Z",
    fill: "#003C71"
  })), _path102 || (_path102 = /*#__PURE__*/react.createElement("path", {
    d: "M83.469 302.833a58.035 58.035 0 0 1-24.5-5.319 57.844 57.844 0 0 1-19.943-15.15l.875-.739a56.701 56.701 0 0 0 19.55 14.85 56.884 56.884 0 0 0 24.018 5.212 58.71 58.71 0 0 0 23.645-5.009 58.562 58.562 0 0 0 19.599-14.105 58.314 58.314 0 0 0 12.21-20.796 58.16 58.16 0 0 0 2.74-23.941l1.168-.11a59.32 59.32 0 0 1-2.797 24.416 59.47 59.47 0 0 1-12.457 21.208 59.687 59.687 0 0 1-19.991 14.381 59.87 59.87 0 0 1-24.117 5.102Z",
    fill: "#003C71"
  })), _path103 || (_path103 = /*#__PURE__*/react.createElement("path", {
    d: "M67.517 222.726h.776c.44 0 .861.174 1.172.484.311.31.486.73.486 1.168v39.094h-4.086v-39.094a1.657 1.657 0 0 1 1.652-1.652Z",
    fill: "#408DBC"
  })), _path104 || (_path104 = /*#__PURE__*/react.createElement("path", {
    d: "M67.126 262.407h1.552c.878 0 1.72.348 2.34.966.621.619.97 1.458.97 2.333v1.268h-8.172v-1.268c0-.875.349-1.714.97-2.333a3.317 3.317 0 0 1 2.34-.966Z",
    fill: "#FF7D20"
  })), _path105 || (_path105 = /*#__PURE__*/react.createElement("path", {
    d: "M67.907 265.997a10.64 10.64 0 0 0-7.511 3.102 10.57 10.57 0 0 0-3.112 7.487h21.247a10.57 10.57 0 0 0-3.112-7.487 10.64 10.64 0 0 0-7.511-3.102Z",
    fill: "#FF9B53"
  })), _path106 || (_path106 = /*#__PURE__*/react.createElement("path", {
    d: "M78.356 276.586H57.459c-.85 0-1.54.688-1.54 1.536v.716c0 .848.69 1.536 1.54 1.536h20.897c.85 0 1.54-.688 1.54-1.536v-.716c0-.848-.69-1.536-1.54-1.536Z",
    fill: "#FF7D20"
  })), _path107 || (_path107 = /*#__PURE__*/react.createElement("path", {
    d: "M57.856 276.586H56.69c0-2.025.554-4.011 1.6-5.747a11.183 11.183 0 0 1 4.34-4.106 11.232 11.232 0 0 1 11.518.596l-.6.949a10.076 10.076 0 0 0-14.235 3.15 10.004 10.004 0 0 0-1.438 5.158h-.018Z",
    fill: "#003C71"
  })), _path108 || (_path108 = /*#__PURE__*/react.createElement("path", {
    d: "M79.897 276.016H55.52v1.14h24.376v-1.14ZM79.897 279.897H55.52v1.14h24.376v-1.14ZM68.48 227.206h-1.145v31.169h1.145v-31.169Z",
    fill: "#003C71"
  })));
};
/* harmony default export */ var my_company_banner = (SvgMyCompanyBanner);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-images-virtual-95769406cb/1/packages/lib-images/src/my-impersonate-banner.svg
var my_impersonate_banner_path, my_impersonate_banner_path2, my_impersonate_banner_path3, my_impersonate_banner_path4, my_impersonate_banner_path5, my_impersonate_banner_path6, my_impersonate_banner_path7, my_impersonate_banner_path8, my_impersonate_banner_path9, my_impersonate_banner_path10, my_impersonate_banner_path11, my_impersonate_banner_path12, my_impersonate_banner_path13, my_impersonate_banner_path14, my_impersonate_banner_path15, my_impersonate_banner_path16, my_impersonate_banner_path17, my_impersonate_banner_path18, my_impersonate_banner_path19, my_impersonate_banner_path20, my_impersonate_banner_path21, my_impersonate_banner_path22, my_impersonate_banner_path23, my_impersonate_banner_path24, my_impersonate_banner_path25, my_impersonate_banner_path26, my_impersonate_banner_path27, my_impersonate_banner_path28, my_impersonate_banner_path29, my_impersonate_banner_path30, my_impersonate_banner_path31, my_impersonate_banner_path32, my_impersonate_banner_path33, my_impersonate_banner_path34, my_impersonate_banner_path35, my_impersonate_banner_path36, my_impersonate_banner_path37, my_impersonate_banner_path38, my_impersonate_banner_path39, my_impersonate_banner_path40, my_impersonate_banner_path41, my_impersonate_banner_path42, my_impersonate_banner_path43, my_impersonate_banner_path44, my_impersonate_banner_path45, my_impersonate_banner_path46;
function my_impersonate_banner_extends() { my_impersonate_banner_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return my_impersonate_banner_extends.apply(this, arguments); }

var SvgMyImpersonateBanner = function SvgMyImpersonateBanner(props) {
  return /*#__PURE__*/react.createElement("svg", my_impersonate_banner_extends({
    width: 662,
    height: 611,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), my_impersonate_banner_path || (my_impersonate_banner_path = /*#__PURE__*/react.createElement("path", {
    d: "M479.72 95.12H190.77c-14.243 0-25.79 11.547-25.79 25.79v54.1c0 14.243 11.547 25.79 25.79 25.79h288.95c14.243 0 25.79-11.547 25.79-25.79v-54.1c0-14.243-11.547-25.79-25.79-25.79Z",
    fill: "#FFD400"
  })), my_impersonate_banner_path2 || (my_impersonate_banner_path2 = /*#__PURE__*/react.createElement("path", {
    d: "M480.86 201.8H425.1v-2h55.76c13 0 23.65-11.12 23.65-24.79v-54.1c0-13.67-10.61-24.79-23.65-24.79v-2c14.14 0 25.65 12 25.65 26.79V175c0 14.78-11.51 26.8-25.65 26.8ZM169.3 191.35A27.32 27.32 0 0 1 164 175v-54.1c0-14.78 11.5-26.79 25.65-26.79h238.1v2H189.63c-13 0-23.65 11.12-23.65 24.79V175a25.287 25.287 0 0 0 4.93 15.15l-1.61 1.2Z",
    fill: "#003C71"
  })), my_impersonate_banner_path3 || (my_impersonate_banner_path3 = /*#__PURE__*/react.createElement("path", {
    d: "M190.36 217.65c-22.63 0-41-19.24-41-42.89v-54.61c0-23.65 18.41-42.89 41-42.89h40.88v2h-40.88c-21.53 0-39 18.34-39 40.89v54.61c0 22.55 17.51 40.89 39 40.89v2ZM480.13 217.65v-2c21.53 0 39-18.34 39-40.89v-54.61c0-22.55-17.51-40.89-39-40.89H367v-2h113.13c22.63 0 41 19.24 41 42.89v54.61c.04 23.65-18.37 42.89-41 42.89Z",
    fill: "#80B3D2"
  })), my_impersonate_banner_path4 || (my_impersonate_banner_path4 = /*#__PURE__*/react.createElement("path", {
    d: "M111.27 495.16c-43.08 1.26-80.55-88-16.13-147.94 65.12-60.55 102.26-13.83 94.78 14.89-7.48 28.72 76.68 15.95 157.75-51.92 104.64-87.6 196.07-43.86 182.64 11.5-10.33 42.6-36.39 66.54 12.87 79.14 71.52 18.31 44.49 90.87-38.29 115.17-24.16 7.11-76.74-11.51-136.56-15.61-104.33-7.11-229.68-6.03-257.06-5.23Z",
    fill: "#E5E5E5"
  })), my_impersonate_banner_path5 || (my_impersonate_banner_path5 = /*#__PURE__*/react.createElement("path", {
    d: "m545.17 335.26-1.94-.49c7.69-30.22 3.89-53.2-11.28-68.3-22.35-22.25-63.35-21.06-78.62-17.1l-.5-1.93c15.62-4.05 57.57-5.24 80.53 17.61 15.71 15.64 19.64 39.26 11.81 70.21ZM51.79 463.72c-15.4-40.81-7.85-72.23 1.19-91.39 9.8-20.78 23.47-32.07 23.6-32.18l1.27 1.55c-.14.11-13.5 11.17-23.1 31.57-8.85 18.8-16.22 49.63-1.09 89.73l-1.87.72Z",
    fill: "#E5E5E5"
  })), my_impersonate_banner_path6 || (my_impersonate_banner_path6 = /*#__PURE__*/react.createElement("path", {
    d: "M342.25 369.52c-24.86-21.35-28.16-143.34 66.82-123.66 41.67 11 49 53.8 47.94 85.41-1.2 36.75 5.56 48 41.41 55.15 26.8 5.33 27.78 50.3-5.63 57.06-33.41 6.76-125.69-52.6-150.54-73.96Z",
    fill: "#FF7D20"
  })), my_impersonate_banner_path7 || (my_impersonate_banner_path7 = /*#__PURE__*/react.createElement("path", {
    d: "M266.87 330.78c-4.71 6.55-26.93 12.61-36.31 16.44-34.35 14-131.77 45.58-134.59 121C94.27 514 125.31 530 150 535.42a119.798 119.798 0 0 0 16.09 2.38v-55.47l114.59-8.44s109.24-81.12 74.89-101.09c-25.76-15-55.84-33.06-60.38-52.69-1.51-6.54-15.77-6.77-28.32 10.67Z",
    fill: "#0067A5"
  })), my_impersonate_banner_path8 || (my_impersonate_banner_path8 = /*#__PURE__*/react.createElement("path", {
    d: "M198.43 387.14h2.3c.61 0 .75.2.75.48 0 .28-.14.51-.75.51h-2.3v-.99Zm0 2.74H201c.6 0 .79.27.79.6 0 .33-.19.61-.79.61h-2.6l.03-1.21Zm-3 3.09H202c2.26 0 3-1 3-2.51a1.802 1.802 0 0 0-1.31-1.76 1.53 1.53 0 0 0 .91-1.5c0-1.23-.7-1.92-2.27-1.92h-6.93l.03 7.69Zm12.71 0h2.92v-2.17l3.48-5.54h-3.23l-1.72 2.8-1.69-2.8h-3.24l3.48 5.54v2.17Zm13.26 0h3.8l-3.3-4.76 3.2-2.95h-4l-3.1 2.95v-2.95h-3V393h3v-2l1.36-1.12 2.04 3.09Zm3.43-3.86c0 4 3.42 4.13 5.27 4.13 1.85 0 5.26-.13 5.26-4.13S232 385 230.12 385c-1.88 0-5.27.13-5.27 4.12l-.02-.01Zm3.26.01c0-1.56.79-2.18 2-2.18s2 .62 2 2.18-.78 2.18-2 2.18-2-.61-2-2.18Z",
    fill: "#fff"
  })), my_impersonate_banner_path9 || (my_impersonate_banner_path9 = /*#__PURE__*/react.createElement("path", {
    d: "M235.54 395.37h-.79c-.06 0 .12-.13.26-.14h.28-.48a1.86 1.86 0 0 0-.35 0h.51c-.18-.01-.36-.01-.54 0h-2.1.07-.67l3.35-.07h-1.26.23H231.62 234.28h-5.61c.309-.023.62-.023.93 0h4.78c.05 0 .05 0 0-.07-1.72-.05-3.44 0-5.16-.06h-2.86c-.7 0-1.48 0-2.22.05h6.15-3.4c-.28 0 .24-.1.42-.11a1.9 1.9 0 0 0-.32 0h.83-1.4 2.4-1.68c-2.12 0-4.06 0-6 .07h-1.92c.64 0 1.37-.06 2-.07h.15s-2.05 0-3 .08H214.98h.1c.32.08-.73.06-2 .09-1.12 0-2.34 0-3 .1h-.33a21.792 21.792 0 0 1 2.5-.22h1.6a20.973 20.973 0 0 0-3.2.05c-1.47.05-2.86.18-4.24.26l-1.68.07h.14c-.7 0-1.37.06-2.08.11h-.2c-1.46.1-2.72.18-4.21.3l-1.1.1c-.27 0 .2 0-.26.06 0 0-.17 0 .82-.05h-.07c-.54 0-1.18.07-1.75.14h-.61l-.07.07a.637.637 0 0 0-.12.21.335.335 0 0 0 0 .1c.05.11.2.19.58.19h.33-.15.2c.13 0 .33-.07.49-.08.16-.01 0 0 .32 0 1.58-.12 3.12-.2 4.73-.28h-.06.53l23.86-.31c1.21 0 2.42 0 2.78.05.36.05-.29 0-.3.05H229.69a1.652 1.652 0 0 1-.32-.05h.39c.196.016.394.016.59 0 .65 0 1.35 0 2 .05a3.873 3.873 0 0 1-.59 0c-.09.05 1.85 0 2.27 0 .07 0 .42-.14.48-.15l.28-.08h.37c.38 0 .28-.11.55-.2a.836.836 0 0 0-.2 0l.03-.26Zm-11.25-.58h2.1l-2.54.05h.44v-.05Zm-1.64.25c-1.2 0-2.48 0-3.68.07h-.64c.63 0 1.2-.06 1.84-.07h.27c.123.006.247.006.37 0h-.23 3.88c.27 0 .53.05.85.06h.1c-.83.05-1.84 0-2.76 0v-.06Zm4.43.21h-3.71 3.95-.24Zm4.5.2h.08-.08Zm3.93.34a.672.672 0 0 0-.21 0h.17c.1 0 .13 0 0 0",
    fill: "#FFD400"
  })), my_impersonate_banner_path10 || (my_impersonate_banner_path10 = /*#__PURE__*/react.createElement("path", {
    d: "M284.45 358.91a145.981 145.981 0 0 0 38.21-6.85c-15.76-12.24-24-26-17.2-48.23 10.69-34.92-42.8-12.39-42.8-12.39s2.25 41.75-32.1 55.78c-.32.14-.66.27-1 .4 11.67 6.09 30.27 12.66 54.89 11.29Z",
    fill: "#FDC498"
  })), my_impersonate_banner_path11 || (my_impersonate_banner_path11 = /*#__PURE__*/react.createElement("path", {
    d: "M250.4 286.67s-2.59 38.27 29.15 40.95c34.72 2.92 38.83-34.48 38.83-34.48l-67.98-6.47Z",
    fill: "#003C71"
  })), my_impersonate_banner_path12 || (my_impersonate_banner_path12 = /*#__PURE__*/react.createElement("path", {
    d: "M255 262.27s-15.63-4.25-17.32 7c-1 6.93 8.64 12.2 14.83 10.88 6.19-1.32 2.49-17.88 2.49-17.88ZM320.85 263.84s12.76-3.19 13.9 6.41c.83 7-8.63 12.2-14.83 10.88-6.2-1.32.93-17.29.93-17.29Z",
    fill: "#FDC498"
  })), my_impersonate_banner_path13 || (my_impersonate_banner_path13 = /*#__PURE__*/react.createElement("path", {
    d: "M251.77 252.77s-13.89 57.81 26.28 64.57c40.17 6.76 48.43-46.18 49.55-60.44l-75.83-4.13Z",
    fill: "#FDC498"
  })), my_impersonate_banner_path14 || (my_impersonate_banner_path14 = /*#__PURE__*/react.createElement("path", {
    d: "M246.86 246.11s-7.71 15.38 4.54 18c10.08 2.17 12.1-7.23 12.1-7.23s2.3 6.81 10.84 5.82c7.6-.88 10.11-10 10.11-10s-.05 8.33 4.08 10c5.66 2.32 9.89-2.23 9.6-10 1.41 10.3 9.71 10.76 10.72 3.11 1.39 7.19 9.54 8.84 9.55.52 2.54 6.67 11.64 6.51 9.2.5-17.92-13.26-80.74-10.72-80.74-10.72Z",
    fill: "#003C71"
  })), my_impersonate_banner_path15 || (my_impersonate_banner_path15 = /*#__PURE__*/react.createElement("path", {
    d: "M251.4 232.87s73.2-46.92 76.2 24c-59.69-5.98-76.2-24-76.2-24Z",
    fill: "#408DBC"
  })), my_impersonate_banner_path16 || (my_impersonate_banner_path16 = /*#__PURE__*/react.createElement("path", {
    d: "M327.6 256.9s-80.33-41.67-107-35.29c-15.5 3.71-2.43 13.65 11.22 21.31a85.99 85.99 0 0 0 37.34 10.8l58.44 3.18Z",
    fill: "#0067A5"
  })), my_impersonate_banner_path17 || (my_impersonate_banner_path17 = /*#__PURE__*/react.createElement("path", {
    d: "M248.79 274.35a4.938 4.938 0 0 1-2-4 5.789 5.789 0 0 1 2.3-3.91l1.17 1.63-.58-.82.58.81a3.78 3.78 0 0 0-1.47 2.4 3.107 3.107 0 0 0 1.29 2.36l-1.29 1.53ZM325.05 276.68l-1.27-1.55a5.053 5.053 0 0 0 2.12-3.32 3.492 3.492 0 0 0-.69-2.32l1.5-1.31a5.35 5.35 0 0 1 1.19 3.82 6.991 6.991 0 0 1-2.85 4.68Z",
    fill: "#003C71"
  })), my_impersonate_banner_path18 || (my_impersonate_banner_path18 = /*#__PURE__*/react.createElement("path", {
    d: "M286 267.61c4.9-.24 3.75 6.81 5.52 11.39 1.77 4.58 5.23 4.31 6.33 7.15 1.1 2.84-2.5 5-4.69 5.12-2.19.12-4.5 3.92-9.88.33-4.95-3.3-7.63-2.41-7.9-5.66-.44-5.48 5.56-3.58 6.61-9.6.82-4.48.9-8.57 4.01-8.73Z",
    fill: "#FFEEE0"
  })), my_impersonate_banner_path19 || (my_impersonate_banner_path19 = /*#__PURE__*/react.createElement("path", {
    d: "M284.34 308.14c-9 0-14.52-3.51-17.63-6.66a20.292 20.292 0 0 1-5-8.07l1.93-.53c.17.61 4.35 14.93 24 13.11l.18 2c-1.24.1-2.39.15-3.48.15ZM301.46 274.47a2.01 2.01 0 1 0 0-4.02 2.01 2.01 0 0 0 0 4.02ZM272.61 272.94a2.01 2.01 0 1 0 0-4.02 2.01 2.01 0 0 0 0 4.02Z",
    fill: "#003C71"
  })), my_impersonate_banner_path20 || (my_impersonate_banner_path20 = /*#__PURE__*/react.createElement("path", {
    d: "M275.4 457.73s-12.71-62.63 59.4-97.43c14.8-3.73 27.72-5.84 30.63-17.5.73-2.92 26.91-8.51 28.15 0 1.24 8.51 10.89 19 21.87 24.09 22 10.14 104 56.69 104 117.13 0 23.09-19.71 42.24-39.42 43.93l-16.33-46.18-118.25 5.07-70.05-29.11Z",
    fill: "#408DBC"
  })), my_impersonate_banner_path21 || (my_impersonate_banner_path21 = /*#__PURE__*/react.createElement("path", {
    d: "M402.87 326.07s-11.9 21 .95 33c-5.26 18.22-16.71 30.05-30.23 30.89-13.52.84-23.82-19-21.62-34.4 0 0 12.61-5.16 13.18-17.06.57-11.9.28-20.59.28-20.59l37.44 8.16Z",
    fill: "#fff"
  })), my_impersonate_banner_path22 || (my_impersonate_banner_path22 = /*#__PURE__*/react.createElement("path", {
    d: "M365.36 332.92s4.32 20.84 19.89 25.34a21.588 21.588 0 0 0 16.19-1.88c-8.81-12.22 1.43-30.31 1.43-30.31l-37.44-8.14s.19 6.07-.07 14.99Z",
    fill: "#FFEBDD"
  })), my_impersonate_banner_path23 || (my_impersonate_banner_path23 = /*#__PURE__*/react.createElement("path", {
    d: "m514.54 429.89-1.69-1.07a27.512 27.512 0 0 0 1.31-28.2c-6.76-12.89-22.29-21-41.53-21.76-10.81-.42-25.78-3.47-35.7-15.68a35 35 0 0 1-7.27-14.7l2-.34c.05.27 5.18 27.34 41.08 28.72 20 .76 36.12 9.3 43.22 22.83a29.48 29.48 0 0 1-1.42 30.2Z",
    fill: "#003C71"
  })), my_impersonate_banner_path24 || (my_impersonate_banner_path24 = /*#__PURE__*/react.createElement("path", {
    d: "M376.38 256.9c-16.46 10.76-30.94 64.79-3.26 78.84 26.36 13.39 55.1-24.55 58.47-49.07 3.37-24.52-26.52-48.54-55.21-29.77Z",
    fill: "#fff"
  })), my_impersonate_banner_path25 || (my_impersonate_banner_path25 = /*#__PURE__*/react.createElement("path", {
    d: "M375.74 298.37a2.01 2.01 0 1 0 0-4.02 2.01 2.01 0 0 0 0 4.02ZM401.81 306.4a2.01 2.01 0 1 0 0-4.02 2.01 2.01 0 0 0 0 4.02Z",
    fill: "#003C71"
  })), my_impersonate_banner_path26 || (my_impersonate_banner_path26 = /*#__PURE__*/react.createElement("path", {
    d: "M386.83 299.36a20.991 20.991 0 0 1-6.48 7.2c-3 2.23-1.77 6.3 3 5.95 4.13-.31 7.06 1.06 8.13-.26 1.38-1.72-2.5-4.95-1.35-8.81 1.7-5.64-1.79-6.78-3.3-4.08Z",
    fill: "#FFB784"
  })), my_impersonate_banner_path27 || (my_impersonate_banner_path27 = /*#__PURE__*/react.createElement("path", {
    d: "M386.37 329.82a27.072 27.072 0 0 1-11.09-2.44l.91-1.78c.59.3 14.62 7.22 24.87-4.57l1.51 1.32a20.777 20.777 0 0 1-16.2 7.47Z",
    fill: "#003C71"
  })), my_impersonate_banner_path28 || (my_impersonate_banner_path28 = /*#__PURE__*/react.createElement("path", {
    d: "M413.57 274.47s-9.75 25.46 18.29 34.11c29.56 9.12 11.28-23.53 11.28-23.53s-5.14-18.79-19.62-28.15c-18.21-11.75-49.79-7.89-49.79-7.89l-20.41 28.54s48.47 20.01 60.25-3.08Z",
    fill: "#FF7D20"
  })), my_impersonate_banner_path29 || (my_impersonate_banner_path29 = /*#__PURE__*/react.createElement("path", {
    d: "M417.26 259.19c11.195 0 20.27-9.075 20.27-20.27s-9.075-20.27-20.27-20.27-20.27 9.075-20.27 20.27 9.075 20.27 20.27 20.27Z",
    fill: "#FF7D20"
  })), my_impersonate_banner_path30 || (my_impersonate_banner_path30 = /*#__PURE__*/react.createElement("path", {
    d: "m346.41 292.22-2-.44c.07-.28 1.64-6.92 7.2-10.37 3.26-2 7.18-2.51 11.65-1.45l1.94.47c14.14 3.41 40.47 9.77 47.41-6.36 2.79-6.5 4.82-11.16 6-13.86 1.32-2.95 1.46-3.26 2.39-2.92l.89.33-.28.93-.87-.27.74.5c-.13.22-1 2.05-7.07 16.08-7.61 17.67-35 11.07-49.71 7.52l-1.94-.47c-3.92-.94-7.32-.54-10.11 1.19-4.77 3-6.23 9.06-6.24 9.12Z",
    fill: "#003C71"
  })), my_impersonate_banner_path31 || (my_impersonate_banner_path31 = /*#__PURE__*/react.createElement("path", {
    d: "M415.45 316.78s9.76 6.38 14.08 0-4.88-13.33-10.7-12.39c-5.82.94-3.38 12.39-3.38 12.39Z",
    fill: "#fff"
  })), my_impersonate_banner_path32 || (my_impersonate_banner_path32 = /*#__PURE__*/react.createElement("path", {
    d: "m431.6 325.56-1.91-.58c2.67-8.73.57-15.1-6.23-18.92-10.6-5.95-11.82-15.27-11.87-15.66l2-.24-1 .12 1-.12c0 .09 1.18 8.72 10.86 14.16 5.3 2.98 10.86 9.09 7.15 21.24ZM417.26 259.26v-2a18.342 18.342 0 0 0 17.987-21.918 18.345 18.345 0 0 0-25.006-13.366 18.338 18.338 0 0 0-11.321 16.944h-2a20.339 20.339 0 1 1 20.34 20.34Z",
    fill: "#003C71"
  })), my_impersonate_banner_path33 || (my_impersonate_banner_path33 = /*#__PURE__*/react.createElement("path", {
    d: "M417.1 253.67a14.292 14.292 0 0 1-14.28-14.28h2a12.287 12.287 0 0 0 12.28 12.28v2Z",
    fill: "#003C71"
  })), my_impersonate_banner_path34 || (my_impersonate_banner_path34 = /*#__PURE__*/react.createElement("path", {
    d: "M369.65 303.03a2.53 2.53 0 1 0 0-5.06 2.53 2.53 0 0 0 0 5.06ZM403.82 313.56a2.56 2.56 0 1 0 0-5.12 2.56 2.56 0 0 0 0 5.12Z",
    fill: "#FFB784"
  })), my_impersonate_banner_path35 || (my_impersonate_banner_path35 = /*#__PURE__*/react.createElement("path", {
    d: "M361.39 302.33s-12.85-2.44-10.59-11c2.52-9.65 13.61-3.07 13.61-3.07l-3.02 14.07Z",
    fill: "#fff"
  })), my_impersonate_banner_path36 || (my_impersonate_banner_path36 = /*#__PURE__*/react.createElement("path", {
    d: "M369.79 391c-23.15-5.57-18.86-35.25-18.81-35.55l2 .31a46.118 46.118 0 0 0 .58 14.87c2.17 10.08 7.8 16.28 16.72 18.43l-.49 1.94ZM520.44 484.05l-2-.05c.35-15.06-9.91-42.48-33.28-67.11-22.3-23.51-81.23-56.59-81.83-56.92l1-1.75c.6.33 59.79 33.57 82.3 57.3 23.74 25.04 34.17 53.07 33.81 68.53ZM274.42 457.94c-.12-.56-2.94-14 1-31.79 3.6-16.43 13.89-39.73 42.46-57.4l1 1.7c-27.94 17.28-38 40-41.54 56-3.84 17.4-1 30.9-1 31l-1.92.49Z",
    fill: "#003C71"
  })), my_impersonate_banner_path37 || (my_impersonate_banner_path37 = /*#__PURE__*/react.createElement("path", {
    d: "M174.68 444s18.29 1.32 9.76 35-30.28 7.24-30.28 7.24 10.01-45.46 20.52-42.24Z",
    fill: "#FDC498"
  })), my_impersonate_banner_path38 || (my_impersonate_banner_path38 = /*#__PURE__*/react.createElement("path", {
    d: "m204.867 458.343 217.898-21.941a22.681 22.681 0 0 1 24.838 20.293l4.861 48.266-263.03 26.486-4.86-48.266a22.677 22.677 0 0 1 20.293-24.838Z",
    fill: "#FFD400"
  })), my_impersonate_banner_path39 || (my_impersonate_banner_path39 = /*#__PURE__*/react.createElement("path", {
    d: "m480 528-5.69-16.09-21.47-64.44s-13.52 2.25-7.76 26.13c4.84 20.07-4.07 27.64-20.4 30.32-16.33 2.68-53.19 8.81-53.19 8.81s.65 14 26.82 12.18c4.23 4.36 12.91 9.21 29.6 5.59 6.4 4.7 20.61 8.12 52.09-2.5Z",
    fill: "#fff"
  })), my_impersonate_banner_path40 || (my_impersonate_banner_path40 = /*#__PURE__*/react.createElement("path", {
    d: "M445.24 535.94c-8.67 0-14.12-2-17.54-4.42-8.89 1.87-16.47 1.55-22.54-.94l.75-1.85c5.8 2.37 13.13 2.62 21.8.74l.45-.09.36.27c5.07 3.77 18.52 8.42 51.66-2.81l.47-.16.64 1.89-.47.16c-15.64 5.27-27.14 7.21-35.58 7.21ZM389.89 526.11c-5.12 0-9.4-1.18-12.78-3.53a15.997 15.997 0 0 1-6.58-9.74l2-.32a14.27 14.27 0 0 0 5.79 8.44c4.56 3.16 11.06 3.95 19.31 2.34 23.33-4.54 42.91-9.15 43.11-9.2l.46 1.95c-.2 0-19.81 4.67-43.19 9.22-2.674.539-5.393.82-8.12.84Z",
    fill: "#003C71"
  })), my_impersonate_banner_path41 || (my_impersonate_banner_path41 = /*#__PURE__*/react.createElement("path", {
    d: "m216.63 529.71-.2-2 155-16c.62-.06 61.62-6 70.71-17.17 3.54-4.33 2.59-12.75 1.67-20.89-1.35-12-2.75-24.37 8.83-27.18l.47 1.94c-9.87 2.4-8.63 13.38-7.31 25 1 9 2 17.41-2.11 22.39-9.62 11.77-69.51 17.64-72.06 17.89l-155 16.02ZM459.766 465.015l-1.894.641 21.196 62.62 1.894-.641-21.196-62.62Z",
    fill: "#003C71"
  })), my_impersonate_banner_path42 || (my_impersonate_banner_path42 = /*#__PURE__*/react.createElement("path", {
    d: "m398.43 411.63 2.29-.23c.61-.06.77.13.79.41.02.28-.08.52-.7.58l-2.28.23-.1-.99Zm.27 2.73 2.59-.26c.6-.06.81.19.84.52.03.33-.12.62-.72.68l-2.59.26-.12-1.2Zm-2.65 3.37 6.56-.66c2.24-.23 2.89-1.29 2.74-2.79a1.811 1.811 0 0 0-1.48-1.62 1.564 1.564 0 0 0 .77-1.59c-.13-1.22-.89-1.84-2.46-1.68l-6.89.69.76 7.65Zm12.65-1.27 2.91-.3-.22-2.15 2.9-5.86-3.21.32-1.44 3-2-2.62-3.22.33 4 5.16.28 2.12Zm13.18-1.33 3.79-.38-3.76-4.4 2.88-3.26-4 .41-2.79 3.25-.29-2.94-2.91.29.77 7.67 2.91-.29-.2-2 1.24-1.25 2.36 2.9Zm3-4.18c.4 4 3.81 3.76 5.65 3.58 1.84-.18 5.22-.66 4.82-4.63-.4-3.97-3.81-3.76-5.65-3.58-1.84.18-5.22.66-4.82 4.63Zm3.22-.32c-.16-1.56.56-2.25 1.8-2.37 1.24-.12 2.08.4 2.23 2 .15 1.6-.56 2.25-1.79 2.37-1.23.12-2.08-.41-2.24-2Z",
    fill: "#fff"
  })), my_impersonate_banner_path43 || (my_impersonate_banner_path43 = /*#__PURE__*/react.createElement("path", {
    d: "M436.18 416.1H436l-.64.05c-.06 0 .11-.14.24-.16.094-.009.188-.026.28-.05h-.43a2.403 2.403 0 0 0-.36 0s.51-.05.51-.06a3.906 3.906 0 0 0-.53 0h-.23a6.047 6.047 0 0 1-.63.06s-.78.09-1.24.11h.07l-.67.05 3.32-.41-1.25.11s.28 0 .22-.05l-1 .11-1.37.14c.73-.11 1.63-.18 2.52-.26h.12c-1.86.15-5.59.57-5.58.53a4.74 4.74 0 0 1 .92-.11c1.47-.17 3.19-.31 4.76-.46.05 0 .05-.05 0-.07-1.71.13-3.42.32-5.14.46-.73.11-1.92.2-2.83.32-.7.1-1.48.18-2.21.27l1-.15c.73-.09 1.46-.14 2.1-.24.18 0 .55-.06.82-.09l.37-.05h-.4c-.1 0 2.32-.25 2.22-.27l-3.38.33c-.28 0 .23-.12.41-.15h.05-.32l.82-.09-1.4.12 2.39-.28-1.67.16c-2.11.23-4 .44-6 .67-.24 0-.48.08-.72.1l-1.19.14c.63-.08 1.35-.2 2-.27h.15c-.01 0-2 .25-3 .38l-.64.1c-.82.09-1.62.2-1.37.17-.29 0-.83.1-1.35.18h.1c.33.05-.72.13-2 .29-1.11.14-2.32.28-2.95.4-.2.05-.24 0-.33.06.81-.204 1.632-.361 2.46-.47.53-.06 1.6-.14 1.59-.18a21.233 21.233 0 0 0-3.17.37c-1.46.19-2.83.46-4.19.68l-1.67.24h.13c-.69.09-1.36.19-2.06.31h-.19l-4.16.72-1.08.21c-.27.06.19 0-.26.09 0 0-.16.05.82-.14h-.07c-.53.09-1.17.19-1.73.32l-.53.07h-.07l-.07.08a.443.443 0 0 0-.1.22.28.28 0 0 0 0 .1c.06.1.22.17.6.13h.33-.15.2c.13 0 .32-.1.48-.13.16-.03 0 0 .32 0 1.56-.28 3.08-.51 4.67-.75h-.05l.52-.08 23.71-2.7 2.77-.23c.29 0-.29.08-.29.08.36 0 .49-.06.79-.08h.36-.32.39c.195-.01.388-.034.58-.07.64-.09 1.35-.1 2-.15-.19.049-.384.08-.58.09-.08.05 1.84-.18 2.26-.24.07 0 .41-.18.46-.19l.28-.11c.12-.012.24-.012.36 0 .39 0 .27-.14.52-.25h-.19l-.05-.03Zm-11.2.33c.61-.12 2.08-.25 2.08-.24 0 .01-1.65.2-2.52.31l.44-.07Zm-1.61.36c-1.19.14-2.47.27-3.65.44l-.64.06 1.82-.26h.27c.09 0 .37-.05.37-.05h-.23s.89-.12 1.61-.19h.06c.79-.08 2-.24 2.08-.25h1.05c-.82.12-1.83.18-2.74.29v-.04Zm4.42-.26c-.11 0-2.12.18-3.13.3l-.53.05h.3c1.19-.11 2.45-.25 3.63-.35h-.27Zm4.53-.25h-.35l.43-.05h-.08v.05Zm3.94-.11H436h.17c.1 0 .14 0 0 0",
    fill: "#FFD400"
  })), my_impersonate_banner_path44 || (my_impersonate_banner_path44 = /*#__PURE__*/react.createElement("path", {
    d: "M184.44 479s9.79-1.06 20.36-2.25c11.73-1.3 13.52 13.41 1.13 14.54l-6.76.75s16.52-1.86 17.54 5.65c1.02 7.51-16.41 7.81-16.41 7.81s18-3.33 18 4.56-18 7.61-18 7.61 18.86-3.65 20.27 3.54c1.91 9.73-7.16 12.48-18.11 15.14-20.46 5-47.83 0-47.83 0s-7.84-21.16.46-54 19.91-2.97 29.35-3.35Z",
    fill: "#FDC498"
  })), my_impersonate_banner_path45 || (my_impersonate_banner_path45 = /*#__PURE__*/react.createElement("path", {
    d: "M200.68 493.11h-1.55l.08-2c7 .26 12.16-1.44 14.14-4.69a5.205 5.205 0 0 0 .12-5.41 6.572 6.572 0 0 0-2.528-2.405 6.572 6.572 0 0 0-3.402-.775c-9 0-32.75 3.81-33 3.84l-.31-2c1-.16 24.18-3.87 33.3-3.87a8.584 8.584 0 0 1 7.68 4.2 7.302 7.302 0 0 1-.16 7.44c-1.32 2.16-4.93 5.67-14.37 5.67ZM180.19 539.67c-2.32 0-4.72-.05-7.2-.15a195.127 195.127 0 0 1-22.53-2.2l.33-2c.39.07 39.23 6.55 60.94-2.56.13 0 8.43-3.1 8.21-9l2-.08c.28 7.41-9.09 10.83-9.49 11-7.94 3.32-18.78 4.99-32.26 4.99ZM154.1 491.73l-2-.31c3.23-20.5 7.89-34.84 13.87-42.62 4.64-6 8.39-5.82 8.79-5.78l-.21 2 .11-1-.09 1c-.13-.02-13.07-.33-20.47 46.71ZM113.26 518.49C98.38 499.75 92.24 480 95 459.86c5.41-39.22 43.27-67 43.65-67.26l1.17 1.62c-.37.27-37.55 27.56-42.84 65.93-2.7 19.59 3.3 38.8 17.83 57.1l-1.55 1.24ZM200.73 506.54h-.44v-2c9.94.06 13.55-2 14.85-3.79a3.182 3.182 0 0 0 .61-2.71l1.9-.64a5.197 5.197 0 0 1-.86 4.48c-2.21 3.12-7.62 4.66-16.06 4.66ZM200.3 518.71v-2c11.57-.05 15.24-2.58 16.4-4.09a2.747 2.747 0 0 0 .67-2.25l1.92-.56a4.759 4.759 0 0 1-.93 3.94c-2.42 3.25-8.49 4.92-18.06 4.96Z",
    fill: "#003C71"
  })), my_impersonate_banner_path46 || (my_impersonate_banner_path46 = /*#__PURE__*/react.createElement("path", {
    d: "m273.38 500.48.12-.14h-.5l-.17-.37.48-.37-.14-.11-.29.28h-.26l-.14-.12-.11-.44h.46v-.25l-.34-.16v-.27l-.49-.4.11-.2h-.33v.32l-.14-.11-.11-.51.17-.21.57-.05.18-.15-.73-.25-.37.17-.21-.18.28-.35-.35-.35.6-.38-.28-.3-.48.44-.23-.37.05-.19h.38l-.42-.35-.31.16-.2-.11v-.25l.37-.23-.15-.18-.63.13.13-.6-.35-.22.66-.52-.2-.11-.42.37-.42-.35h-.26l-.19-.62.21-.41h-.2l-.42.3-.3-.42.23-.34-.15-.12-.44.11-.11-.5.18-.15h-.2l-.12.14-.21-.18v-.39l-.16-.24-.4-.22v-.19l-.36-.29v-.12l-2-2.06-.18-.43-1-1.2-.85-1.4-.42-.34V484l-.82-1v-.46l-.36-.41v-.32l-.35-.22-.18-.5v-.39l-.24.15-.31-.42v-.52l-.49-1v-.33l-.27-.1v-.45l.11-.2-.48-.86v-.26l.29-.35-.21-.18-.16.41-.14-.12v-.45h.39v-.2l-.54-.27v-.2l-.28-.22.08-.53h.39l-.44-.48.05-.19-.24-.43.28-.42.16.24.18-.08-.15-.24-.12.08-.36-.36v-.26l-.16-.24v-.9l.55-.32-.09-.25h-.27l.17-.28v-1.16l.48-.37-.23-.3.09-.46.31-.09.08-.46-.08-.19.36-.87.46-.63.18-.08v-.33l.79-.53v-.39l.38-.1.1-.34 1.65-.87h.27l.67-.39.56-.13.23-.34.31-.1.1.31.35.29.14-.53h.26l.3.36.37-.11.15.18 1-.1.36.35.19-.08v.26l.21.17.75-.2.06.57.21.18h.32l.05.52.32-.1.2.11.1.37.55.27-.14.53.59.14v.45l.43.41-.11.2.18.44-.29.35.08.19.43-.24.2.11-.08.46.22.23v.26h-.25l.27.1.15.24v.51l.15.18-.1.27.16.95.34.23-.09.39.16.24v.27l.28.23-.05.78.23.36-.06.65.21.24-.15.4.2.69-.07.59.24 1.07.21.18-.06 2-.18.15-.65-.13-.57.19-2 .2-.4-.15-.07-.64.09-.4-.5-2.47v-.52l-.23-.94v-1l-.16-.31v-.83l-.41-.87.09-.33-.41-.22v-.26l-.15-.24.08-.46-.22-.24-.06-.57-.48-.28-.15-.24v-.7l-.55-.33v-.26h-.19l-.76-.51h-.19l-.21-.17-1.24-.14-.43.3-.56.19-.21.41h-.27l-.25.67h-.26l-.11.14.11.5-.36.23.09.25-.22.41.27.11-.35.35.14.76-.15.47.21.75-.11.21-.2-.11-.09.4h.25l.18.5-.31.81.42.28.08.18-.1.27.22.3-.3.16.38.54-.16.34.4.16-.22.4.37.42-.17.28.54.26-.26.55.39.09.09.18-.38.17.41.21v.4l.15.17h.51l-.14.53.6.19-.09.34.08.18.32-.09.29.35.1.32.26.1.1.25h-.33v.19l.29.36v.26l.15.18.4.15-.09.4.66.12-.14.53.67.2v.32l.18.56.37.48v.39l.59.07-.27.54.21.11.48-.31.21.11v.45l-.18.22.15.11.5-.12.08.13-.09.46.53.07.16.37-.17.21.14.12.32-.1.16.37-.18.15.55.27v.33l.41.28v.25l.23.37-.16.4.6.13-.09.4.4.15.09.25-.11.21.56.39-.27-.1-.29.29.14.11h.25l.11-.21.23.3-.16.41.21.1.31-.09.16.3v.27h-.26l-.11.14.21.17.31-.09.42.28-.16.33.41.29v.26l-.35-.29-.23.28.21.17h.58l-.07.59.34.09.14.18-.23.87.39.09.29.29-.21.47.46.08.16.31-.09.4-.17.21.15.18.4.15v.39l.43.41-.16.34.16.31-.15.34.42.4-.16.34.25.49.2.11.27.75-.19.67.1.31-.12.79.24.42-.05.2-.24.15.07.71-.34.42v.32L276 508v.25l-.47.44v.32l-.46.62-.31.1-.53.51-.52-.08-.11.27-.36.23-.15-.18-.26.54h-.46l-1.44.46-.27-.1-.49.24-.35-.28-.63.19-.09-.31-.44.17-.15-.24-.79-.12-.08-.18-.5.11-.29-.29-.12.07-.64-.58-.4-.09-.77-.63-.24-.43-.5-.46v-.32l-.47-.21-.09-.19.11-.27-.09-.25-.32.1v-.52l-.34-.22.18-.15-.34-.16-.42-.93h-.26l.08-.46-.42-.35h.38l-.3-.42-.05-.51-.61-.32.28-.42-.15-.24v-.52l-.35-.29h.25l-.07-.71-.36-.35.09-.46-.15-.82-.21-.18-.05-.44-.46-.15.33-.49-.28-.23v-.32l-.29-.36.15-.4-.15-.25v-.26l-.23-.3.09-.39-.22-.31.1-.26-.24-.43-.08-.83.11-.21.49-.24 1.67-.1.23-.29 1.13-.3.28.16v.71l.24.43-.1.27.18.56v.26l.36.36v.83l.25.56v.77l.39.67-.11.27.23.37.11 1 .54 1.56v.26l1 2.55.3.42v.32l.22.24.12.5.93.94h.26l.15.18.53.14.29.36.32-.1.27.1.25-.09 1 .16.44-.17h.32l.42-.3v-.33l.43-.3v-.26l.06-.07.3-.29v-.38l.24-.15.29-.94-.09-.25.23-.28-.37-.48.37-.23-.24-.43v-.39l-.4-.15.61-.38-.35-.29v-.26h.26l.11-.21-.09-.25-.36.3-.41-.22.34-.48.2.1.21-.01Zm-15.34-28 .16-.28-.27-.1-.16.28.27.1Zm0-.58.29-.35-.37.16.08.19Zm.71 1.22.11-.21h-.27l-.1.26.26-.05Zm.14-2.41h-.19l.08.19.11-.19Zm0-3.29.05-.13-.18.08.13.05Zm.29 4.75h-.19l-.06.14.25-.14Zm1.24 27.83v.19l-.15-.17.15-.02Zm.41 1.51-.22-.24h.19l.22.17-.19.07Zm.39-29.48.2.11.18-.15-.55-.33v.2l.17.17Zm.72 11.68v-.07l-.06.07h.06Zm1-3 .05-.2h-.26v.26l.21-.06Zm2.47 7.24v-.06l-.18.15.18-.09Zm.49-6.05-.11.14v-.19l.11.05Zm.46-19.22-.34-.1.47.15-.13-.05Zm.34 2.16-.27-.17.08.19.19-.02Zm1.45-1.69h-.33l.05-.13h.26l.02.13Zm0 .77-.2-.05v.2l.2-.15Zm.21 21.93-.08-.12h.19l-.11.12Zm.76 7-.12.15.27.1.36-.29-.22-.24-.29.28Zm.25-27.66L269 465h.07l.3.19ZM270.6 494l.2.1.05-.19-.21-.18-.18.15.14.12Zm.5-.76v-.2l-.19.08.19.12Zm.13 1.27v-.12h-.13l.13.12Zm.39-.68.24-.09-.08-.19h-.26l-.11.14.21.14Zm.19 2.63-.3.22h.27l.56-.19-.35-.22-.18.19Zm0 14.33v-.13l-.12.14.12-.01Zm.42-11.8-.18.15h-.19l.16-.28h.26l-.05.13Zm-.09-6.06h-.2l-.05.13.25-.13Zm0-1.29v-.13h-.2v.19l.2-.06Zm-.04 6.36.5-.12-.14-.18h-.2l-.16.3Zm.42-2.24.1-.27h-.2l-.16.34.26-.07Zm.05 4.32-.18.15v-.2l.18.05Zm.13-6.34.1-.27h-.25l-.11.2.26.07Zm.25 4.43-.24.15v.33l.43-.17v-.2l-.19-.11Zm-.07-3.29v-.12l-.17.27.17-.15Zm.16 1.54v-.14l-.14-.11-.05.13.19.12Zm-.06 3.94-.07-.06.08.13.05-.07h-.06Zm.26-1.25h-.13v.13l.13-.13Zm.09-4.85h.2v-.38h-.19l-.11.2.1.18Zm.1 3.54.19-.08-.21-.18-.18.15.2.11Zm0-.58-.08-.12-.05.13.13-.01Zm.16-1.57.11-.2h-.38v.2h.27Zm.09 9.81v-.2l-.19.09v.25l.19-.14Zm.13-3.18-.2-.11-.11.2.14.18.25-.09-.08-.18Zm.06 2.51-.09-.25-.11.21.2.04Zm0-6.39v-.13l-.12.14.12-.01Zm.13 4.6h-.19v.19l.19-.19Zm-.14.53v.26h.26v-.38l-.26.12Zm.24-7.26.35-.35h-.38l-.22.41.25-.06Zm.16 5.41v-.13l-.2-.05v.2l.2-.02Zm.16-4.15.11-.14h-.2l-.11.14h.2Zm.32 1.26-.08-.12v.13l.08-.01Zm.46-2.43v.19h-.2l-.08-.18.18-.15.1.14Zm1.89 5.23v.26l-.22-.3.22.04ZM288 499.4l.18-.08v.45l-.2.54.3.42-.16 1-.17.21.28.3v.9l.22.24-.12.78.18.5v.33l.23 1v.52l.18.49v.46l.27.75-.08.46-.85-.05-.5.18-.58-.07-.3.23-.21-.11-1.11-.09-.24-.49v-.83l-.16-.31-.08-1.48-.16-.24-.2-1.4-.24-.43.13-.59-.32-.68-.18-1.79.08-.46-.53-5.31-.27-1.39.1-.27v-.38l-.15-.24v-.52l.17-.21-.28-.23.1-.27-.11-.51.15-.4-.15-.24v-.26l-.19-.57.17-.27-.22-.17-.11-.51.07-.59-.09-.25.1-.33-.2-.63h.27l.37.55.13-.08-.17-.37.17-.21h-.33l-.32-.62-.28-.23V485l.36.28.3-.22-.27-.1-.05-.45.1-.33-.08-.13-.3.17-.06-.58.18-.15-.22-.23-.11-.44.26-.68-.39-.6v-.39l.24-.21v-.45l-.39-.61.46.08.23.37.14-.6-.15-.11-.3.16-.07-.64.44-.17-.15-.18-.49.24-.19-.56.3-.23-.38-.24v-.26l-.18-.5.17-.21-.1-.37.1-.27-.11-1.09-.25-.55.15-.41-.21-1.46.11-.2v-.84l-.15-.25v-.32l.31-.1-.21-.23v-1l.24-.15-.29-.29v-.26l.42-.24v-.77l.15-1 .29-.35v-.51h.32l.12-.78.25-.09v-.26l.18-.15v-.26l.25-.09.11-.21v-.32l.33-.21v-.25l.28-.48.3-.16.4-.56 1.71-.95.46.09.28-.42.37-.17.27.11 1.07-.3.47.21.1-.27.45-.05.21.17h.33l.23-.29.55.4.37-.17v.2l.21.1h.44l.22.17-.09.4.37-.17.65.07.49 1 .23-.34.14.11-.05.2.15.18h.45l.25.62.41.16-.1.33.15.18.37-.1.06.57.47.15v.25l-.34-.09-.66.45.2.11.49-.24.54.2-.17.21-.31.1-.11.2.15.25.24-.16.53.08-.46.56-.14.53-.25.16.22.17.5-.12v-.39h-.2l-.09-.19.77-.07.05.44.41.29-.15.4.42.34h-.32l-.29.35.21.18.51-.06-.09.4-.31.16.21.11.31-.1.21.18v.25l-.65-.06-.41.43v.12l.83-.08-.22.41.09.19.37-.11.15.18v.26l-.25.09-.4-.21-.22.41h.45l.53.14-.37.17-.06.13.16.24h.32l.09.24-.11.15-.59-.08-.3.17-.05.19.2.11.51-.11.2.11.25-.16v.38l-.34-.09-.28.42.51-.06.06.51.28.3-.21 1.05.42.35-.23.34.09.25-.15.41.48.27-.27.48.14.18-.52.57.08.12.23-.28.47.21-.27.54-.07.59.33.1.17.37-.29.29.27.1.15.24h-.33v.2h.26l.17 1-.11.2.23.37-.15.4.16.37.07.71-.09.39.28.81-.15.47.1.31-.28.42.33.09v.32l-.44.11h.33l.23.36-.11.2.11.44-.49.31.41.16v.51l-.37.16.14.18.34.1v.71l.22.88-.11.79.16.37.15 2.11.24.49-.15.34.21.88-.07.53.39 1.05-.17.27.24.43.05.51-.23.28v.32l.24.43v.39l-.17.21.08.19.22 2.1-.16.34.15.25.14.69v1.1l.11.51-.1.27.12.56v.78l.22.89-.61.32-.6-.14-2.24.16-.4-.15-.11-1.08.07-.53-.11-1.09.11-.2-.64-6.39v-.91l-.17-.37.09-.4-.17-.37h-.25l-.16.4-.62-.39h-.32l-.22.35-.68-.32-.15.4-.6-.2-.31.1-.18.21-.28-.23-.57.12-.36.23-.47-.14-.61.32-.62-.39-.1-.32-.47-.14v.52l-.37.16-.24-.49-.31.1v.26l.15.24.34.16-.11.21h-.19l-.35-.28h-.33l-.11-.51-.21-.11-.11.14.08.19-.11.2.42.28-.05.2-.25.09-.49-.4-.28.42-.51.05-.18.14.35.29v.26l-.23.28.23.37-.23.22.1.04Zm-5.65-24.61-.09-.25-.09.4.21.1-.03-.25Zm0 3 .25-.15-.14-.11-.19.08.08.18Zm.05-1.48v-.2l-.1.34.1-.14Zm0 2.19.09.25.11-.2v-.32h-.13l-.07.27Zm.19 6.38h-.13l.1-.21.03.21Zm.39-3.14-.14-.18-.18.15.32.03Zm0-.65h-.25v.19l.25-.19Zm-.16 1.57.15.18.15-.41h-.33l.03.23Zm.32-4.49H283l.08.13.06-.13Zm0 2.2.13.63.21.11.11-.14-.2-.69-.25.09Zm.3 1.65v.26l.18-.09v-.32l.35-.36-.68.26.15.25Zm.3 3 .18-.14-.27-.11-.23.22.32.03Zm-.12 3.24-.14-.05-.05.14.19-.09Zm.09 1-.21-.17v.2l.21-.03Zm-.22-6 .17-.22-.17.15v.07Zm.26 1.33.05-.2h-.2v.2h.15Zm.19 1.14-.2-.05-.06.14.26-.09Zm-.15-4.63h.07v-.13l-.07.13Zm.15 13.67v-.07l-.12.08.12-.01Zm0-6.26.18.5v-.52l.3-.29h-.39l-.09.31Zm0-4.72.21.11.23-.28h.26l.11-.21h-.26l-.57.18.02.2Zm.31 6.3v-.39h-.19l-.11.2.3.42v-.23Zm0-4.9.12-.15h-.26l.14.15Zm0-6.08-.14-.05v.19l.14-.14Zm.11.45-.09-.19-.11.14.2.05Zm.13 1.27h-.2v.13l.2-.13Zm7.69-15.3h-.32l-.5-.4h-.26l-.15-.24-.74-.25-.31.1-.65-.07-.24.22-.57.06-.6.45h-.2l-.16.34-.48.26v.33l-.24.21-.6 1.1.09.25-.09.33-.5.24.23.3-.16.34h-.14v.71l.15.24-.1.27-.25.09v.2l.3.42-.22.41v.39l.14.18-.06 1.94.15.24v.27h-.45v.2l.4.15-.08.53h-.19l.28.87.14.12-.52.63-.21.47v.32l.14.18.25-.09-.09-.31.14-.47.19.56-.23.35.08.7.14.18h.27l.07.12-.11.21-.69.2.42.28v.26l-.25.09-.1.27h.2l.18-.15.14.18v.2l-.9.09-.17.21.1.32-.1.26-.31.16.27.11.3-.16.46.08.18-.21h-.39l-.16-.37.11-.21.5-.11.19.56.48.27-.43.24h-.26l-.12.14h.26l.18.43-.43.3v.26h.19l.23-.35h.26l.14.18v.32l-.38.1-.28-.22-.17.21-.51.11v.2l.2.11.23-.28h.38l.24.43v.19h.38l.11.44-.18.14-.4-.09-.87.29-.33-.1.15.24.54.27.05-.2.23-.21.48.21v.19l-.43.18-.33-.1.09.32.27.1.48-.31.27.1.09.25-.11.21-.24.09-.11.26.14.06.3-.16.15.17-.37.17v.2h.26l.15.18-.05.19-.36.3.06.57h.39l.1.31-.11.21h-.26v.33l.38-.1.15.18-.16.4.11.44-.41.43.45-.05.21.17-.38.84-.41.49.31-.16.3.43-.22.34.15.24.1 1-.11.21.16.24-.1.27.37-.1.34.8h.33l.44.53h.26l-.25-.49-.42-.35v-.26l.3-.22.21.11.24.43h.26l.39.67h.2l.09.25.35.35.09-.39-.57-.53.09-.4h.32l.22.24.11-.21-.21-.1-.14-.83.39.09.18.5-.16.34h.2l.17-.21.35.22v.32l.49-.24v-.25l-.25.09-.21-.11.23-.29-.29-.35h.32l.17.43h.38l.49.34-.25-.62v.13l-.21-.17.1-.27.27.1.23.36.37-.1.14-.59.46.14.16.25h.32l-.3-.35.18-.22.27.11.68-.27.46.09.61-.32.28.16.61-.32-.35-.28h.45l.3.43v-1.1l.17-.21-.22-.3.1-.27-.22-.3.2-.54-.21-.17.16-.34-.27-.17-.09-.25.22-.34v-.46l-.28-.16-.09-.25.28-.48v-.52l-.35-.29v-.32l.36-.29-.15-.18v-.26l-.37-.48.21-.41.07-.59-.23-.43.16-.34-.06-.51-.22-.3.15-.4-.17-.43-.11-1.09-.14-.12.1-.33-.16-.3.22-.35-.33-.1V479l.29-.35v-.44l-.41-.22v-.46l.11-.14h.26l.05-.13-.23-.37v-.26l-.36-.35.11-.2.25-.09v-.27h-.32l-.21-.82.1-.27h.26l.12-.14-.21-.18-.24.22-.17-1.08-.16-.24.15-.47h.26l.25-.15.44-.05.21.11.11-.14-.54-.27-.68.33-.17-.37.11-.21.44-.11-.09-.25-.2-.1-.35.35-.35-.22v-.33l.24-.08.11-.27-.34-.16.29-.29-.46-.08-.08-.19.39-.56h-.2l-.29.29-.25-.56.16-.34-.33-.09-.28-.88.48-.31-.76.15-.11-.44.3-.29-.48-.21v.19l-.25.09-.05-.51.1-.27-.25.09-.36-.41v-.33h-.26l-.15-.17v-.32l.01.15Zm-7.41 18.76-.15-.24-.25.15v.19l.21.11.19-.21Zm-.37-1.29.18-.15-.25.09.07.06Zm.29 8-.22-.23-.1.2.32.03Zm0-2-.2-.11-.11.21.31-.1Zm-.11-10.7-.13-.06v.07l.13-.01Zm0 1.48.18-.15h-.19l.01.15Zm.08 5.93.18-.21h-.26l.08.21Zm.42-3 .11-.14H285l-.18.15.26-.01Zm-.09 6.15.17-.15-.13-.12-.19.09.15.18Zm0-17.56h.19-.2.01Zm.16 8 .13-.6-.3.23.17.37Zm0-2.65-.14-.11v.12l.14-.01Zm-.09 7.43.24-.15h-.25l.01.15Zm.15 5.93h-.13l.14.12-.01-.12Zm.2-16-.09-.18-.18.14.09.25.18-.21Zm.11 12.71.22.17.18-.08-.15-.18-.46-.08v.13l.21.04Zm0-.65h-.19l.09.19.1-.19Zm0-17-.14-.11v.12l.14-.01Zm.06 21.82.11-.21-.22-.23-.08.46.19-.02Zm0-6.65.24-.15-.14-.12h-.25l.15.27Zm.35 6v-.26l-.31.16.31.1Zm-.06-13.42v.19h-.13v-.19h.13Zm.2 2.69v.26l-.07.23v-.39l.07-.1Zm0 11.37h.26l-.09-.25h-.26l.09.25Zm.27 1.45.18-.21h-.2l-.18.15.2.06Zm0-10.26v.12h-.12v-.13l.12.01Zm.16 1.53-.13.08-.08-.19.21.11Zm-.17 9.9.15.18.23-.29.31-.09-.27-.11-.17.22-.25.09Zm.34-4.36h-.27v.19l.27-.19Zm.08-1.75v.26l-.15-.25.15-.01Zm.1 5.54.05-.2-.12.08.07.12Zm1.57 4v-.26h-.13v.32l.13-.06Zm.41-.43.05-.14h-.25l.2.14Zm1-2.36-.16.34-.36-.35.1-.27h.33l.09.28Zm-.35 2.29h.46l-.12-.44h-.38l.04.44Zm1.05-1.72v.27l.81.43-.1-.38-.27-.1-.44-.22Zm.72 2.58v-.19l.18-.09.15.18-.33.1Zm.67-1v-.45l-.46-.15.12.57.34.03Zm-.33-34.64-.11.14.07.12.04-.26Zm.7 33.83.1-.2-.15-.25h-.26l.31.45Zm-.06 1.36.24-.15.05-.2-.14-.12-.25.16.1.31Zm.48-2.31-.19.09.14.11.05-.2Zm-.06 1.37h.26v-.25l-.21-.11-.12.08.07.28Zm.7.51h.13l.12-.14-.15-.18-.43.17.33.15Zm.05-31.52h-.13v.11l.13-.11Zm.34 29.6.11-.14-.2-.11-.18.22.27.03Zm-.16-28.45.05-.14-.12.08.07.06Zm.19-3.25v-.19h-.19l.08.18.11.01Zm.08 32.85h-.07v.06l.07-.06Zm.33-28.82.11-.14h-.19l-.1.32.18-.18Zm-.08-1.42.24-.21-.21-.11-.11.2.08.12Zm.08 30.92h.26l.1-.21h-.26l-.24.16.14.05Zm.23-31.66h-.19v.13l.19-.13Zm.07-1.3.44-.1-.35-.23-.17.21.08.12Zm.27 2.69.11-.21h-.26l-.11.2.26.01Zm0-1.42.19-.08-.21-.18-.18.22.2.04Zm.31-.81h-.26l-.05.19.31-.19Zm0 5-.14-.12v.2l.14-.08Zm0-3.49-.14-.11v.13l.14-.02Zm0 2v-.19.2-.01Zm.12 26.21h.2v-.14H295l.18.14Zm-.1-24.08.69-.2-.33-.09-.36.29Zm.25 26.77.23-.21h-.45l.22.21Zm.51-32.07-.59.51.57-.06.23-.28-.21-.17Zm-.41 1 .05-.14h-.2l.15.14Zm.15 2.82v-.19l-.24.15.24.04Zm0-2.13-.11.14.26.11.36-.36h-.33l-.18.11Zm.23 4.89h.26l-.15-.24h-.2l-.1.2.19.04Zm.39-.62.3-.29-.21-.17-.19.08-.22.41.32-.03Zm-.09-2.83.05-.2h-.2l-.05.2h.2Zm0 1.41.17-.21-.08-.12h-.25v.26l.16.07Zm.23-.92-.43.3.71-.07.15-.41h-.2l-.23.18Zm-.23 3.57h.19l.11-.2h-.32l-.17.15.19.05Zm0 2.13h.2l-.16-.24h-.2v.26l.16-.02Zm.19 22.52h-.19l-.12.14.31-.14Zm-.3-26.59.2.11.62-.26v-.19l-.2-.11-.43.3-.19.15Zm.23 6.18v-.13h-.2l.2.13Zm.08-8.86.15-.4h-.26l-.08.46.19-.06Zm.21 5.27h-.32l.26.1.45-.05.11-.2-.09-.25h-.2l-.21.4Zm.14 2.06-.09-.25-.25.09v.25l.22.18.12-.27Zm0 1.42v-.27h-.2v.26l.2.01Zm.16-4.8.19-.08-.16-.31-.28.42.25-.03Zm.09 7.23-.2-.05-.05.13.25-.08Zm0-10-.11.14.19.05.43-.24h.39l-.16-.24h-.2l-.35.29h-.19Zm0 5.55.12-.14-.08-.12-.18.08.14.18Zm.05-3.36.44-.11-.23-.36-.25.09-.15.4.19-.02Zm0 4.58.11-.2-.24.15.13.05Zm.22-6.15-.2-.11-.12.14.32-.03Zm.06 27.56.11-.2-.33-.1v.26l.22.04Zm-.26-25v.19l.6.13.17-.21-.54-.27-.23.16Zm.24 1.65h.78v-.13l-.48-.21-.3.16v.18Zm-.14 3.18.14.05-.08-.12-.06.07Zm.53-7-.43.17v.2l.51-.05.11-.21-.19-.11Zm-.28 3-.18.14.2.05.56-.19v-.26h-.39l-.19.26Zm-.07 1.81v.19l.21.11.11-.2-.09-.19-.23.09Zm.4 1.51-.2-.11-.11.14.31-.03Zm-.11-5-.1.27.51-.05-.16-.31-.25.09Zm.16 2.82v.27h.26l.11-.14-.09-.25-.28.12Zm.46 1.38-.15-.25-.18.15.08.19.25-.09Zm.14-2.47.11-.2h-.32l.21.2Zm0 5-.2-.11-.05.2.25-.09Zm.07-3.17.19-.08-.21-.18-.18.15.2.11Zm.13 1.28h.26l-.23-.3-.23.28.2.02Zm0 1.29.13.05v-.26l-.12.15-.01.06Zm.26 1.33v-.19l-.23.22.23-.03Zm.19-3.31.1-.27-.21-.11-.18.15v.25l.29-.02Zm.1 1h-.19v.2l.19-.2Zm.22 1.59.06-.13h-.27l.21.13Zm-.06 1.3h.2v-.12l-.2.12Zm.57 5.62.11-.2-.25.15.14.05Zm.18 3.15.19-.09h-.26l.07.09Zm.13-8.41h-.13v-.2l.13.2Zm.17 5-.14-.12-.11.14.25-.02Zm-.05-.58h-.2l.09.19.11-.19Zm.12 1.86.05-.13-.25.09.2.04Zm.46 4h-.25v.19l.25-.19ZM312.49 458l.41.22.35-.36.25-.09.18.44h.38l.31.48-.11.21.28.23v-.33l.38-.1.11.5.35.23.09-.34.46.09-.09.33.39.09-.09.33.3.42.53.14v.45h.26l.31.48-.31.1-.11.2.21.24h.46l.54.85-.23.34.15.18h.33l.16.37-.5.18v.32l.21.17.16-.27.36.29.05.51h-.46v.38l.19-.08.4.15.09.25.5.53-.34.42.15.25h.26l.24.43-.37.23.15.18.33.09.07.71.34.8.28.17.08.18-.15.47.65.65h.38l-.11-.51v-1l.11-.21.33.1v-.19l-.21-.18.23-.92-.15-.25.07-.52.18-.15-.09-.25.16-.4-.15-.18.2-.54-.14-.17v-.59l.29.3.11-.21-.17-.43v-1.23l.35.29.1-.33-.27-.11v-.32l.14-.53-.16-.24.18-.79.28-.48-.09-.25.09-1h.32l.18-.14.21.17.25.56.24-.16-.26-.68-.48-.21v-.26l.41.22v-.77l.11-.21.43.41.11-.14-.1-.44.09-.33.48.27v-.58l.17-.21.42.34.46.09.23.36-.21.41.42.34-.14.6.35.22.11-.14-.05-.57-.36-.36.14-.53.47.15.07.7.14.18.18-.15v-.64l.28.23.46-.56h.26l.11-.2v-.52l.42.34-.06.72.67-.45.23.36-.09.4-.12.07-.16-.24-.16.34.15.18.5-.18.29-.29.15.18v.2h-.39l.13.63.15.18v-.26l.44-.17.15.18v.45l.14.12.2.69-.05.2.22.23-.08.46.34.23-.08.52.1.31.21.18-.26.6.35.29v.26h-.13v.32l.31.49-.31.22.15.18.3 1-.14-.12-.05.14.15.24.22.94-.14.47.15.25v1l.17.44-.16.27.17.44-.1.33h-.25l-.11.2.17.37h.32l.1.44-.25.09-.09.33.47.15.1.44-.44.11.23.3.19.63-.1.26.11.51h-.25l-.17.22.2.1.24-.15.25.49-.11.27-.18.08-.09-.25-.18.15.11.44h.33l.08.25-.1.21h-.26l.4.8h-.19l.12.57.21.17.23 2.24h-.45l.08.19.38-.11.11.51-.1.27-.21-.18-.18.15.22.3.18-.15.06.58-.17.21.15.24.05.52-.17.21.35.87-.11.27.26 1.26-.09.33.22.3-.15.47-.3.16.26.1.24.43-.1.27-.25.09-.05.13.35.29v.51l-.09.4.3 1.65v.58l.17.43-.09.33.19.57v.32l.22.82h-.27l.14.12.38 2.48.16.24v.52l.27 2.62.18.56.11 1-.23.29.36 1.64v.45l.22.3-.07.59.09.25-.18.15-.75.2-.34-.09-2.56.13-.25-1.4v-.58l-.25-1.27-.19-1.85-.18-.5.07-.59-.18-.5v-.45l-.18-.5.1-.33-.33-2 .09-.4-.24-.49.16-.27-.12-.57.36-.29-.64-.59.08-.46-.29-.35v-.26l.28-.48-.18-.43.11-.27v-.39l-.16-.24.09-1.11-.17-.37-.09-1.54.36-.23-.4-.15-.17-.43.09-.4.24-.15-.42-.28-.09-.25h.33l.08-.46-.35-.29.13-.59-.15-.25v-1.62l-.15-.24.21-.47-.14-.12v-.19l-.21-.18.15-.46-.17-.37-.34-.23.24-.15v-.39l-.23-.43.14-.53-.15-.18-.05-.51.11-.2-.17-.37.11-.21.28.17.17-.21h-.26l-.43-.41v-.33l.27.17.05-.2-.15-.18v-.32l-.15-.18-.09-1 .07-.52-.15-.24-.11-1.67-.15-.24v-.27l.28.23v-.45l-.14-.11-.25.09v-.27l-.22-.23-.11-.44.18-.15-.3-.42-.1-1.61.27.1.13-.65-.12-.51h-.12l-.11.27.12.51-.12.14-.14-.18.06-.48-.16-.3-.05-1.74.21.11.09.89.14.18.11-.2-.13-1.35-.39-.6-.1.2.29.36-.37.23v-.39l-.15-.24v-.58l-.15-.25.1-.91-.56.18-.3-.42-.3.23-.58-.59.35.87-.3.22.09.31.37.42h.32l-.05.2-.25.09-.74-.32-.09-.25-.14.47.29.36v.25l.15.12.15-.4h.19l.24.42-.05.2-.46-.08-.18.15.11.37-.58.06.05.45h.32l.35.23v.51l.15.24-.1.27.09.25-.1.33-.25-.62h-.26l-.11.15.41.86-.1.27.17.43-.22.41.05-.13-.35-.29-.12.08v.25l.28.3.18-.15.21.17.1.31-.18.15h-.52l.25.49-.23.28.39.67-.11.21h-.52l.25.55-.09.4.12.57-.11.14v.83l-.44.18.3.42v.84l-.18.15h-.32l-.11.21.56.46v.25l-.43.18-.05.19.28.23-.23.29.16.24.05.57-.16.92-.18.15.2 1.34-.21.47.15.24v.26l-.42.24.36.42-.23.28.07.7-.21.47.16.31-.36.23-.57.12-.18.15-.33-.09-1.46.33-.72-.12-.24.16-.14-.12V483l-.33-1.9-.69-3v-.39l-.59-.72.18-.15-.19-.56-.21-.17.15-.4-.36-.42-.09-.89-.58-2.59-.16-.25v-.38l-.36-.41-.05-.52-.21-.1.11-.27-.41-.16-.41-1.57.09-.33-.43-.47.07-.59-.34-.16v-.71l.11-.2-.34-.17-.05.14-.47-.79-.25.09-.36-.35-.1-.44h.25v-.26l-.15-.11v.26l-.21-.11-.24-.49.18-.15-.45-.6v-.38h-.26l-.56-.46-.28.42.17.43-.21.47-.21-.19v.2l.21.17.17.5-.17.21-.07.53.21.23v.14l.15.18-.14.53-.25.09v.58h.32l.08.12-.37.16v.32l.27.11-.29.35.42.92-.11.21.17 1.72-.17.22-.15-.18v.26l.62.39-.28.41-.1-.31-.18.15.45.6v.19l-.31.16.41.86-.08.46.17 1-.11.2h-.2l.31.48-.27-.1.16.37-.1.27.31.49v.32l-.16.34.21.75-.11.2.19 1.21-.09.46.12.57-.16.28.15.82-.12.14.46 3.25-.1.33.12.57-.2.54.09.25-.13.66.22.88-.11.2.27.81-.05.72.16.31v2.51l-.23.28.24.49v.52l.2.69-.08.52.23.95-.1.33.19.56-.16.41.19.56-.19.66v1.1l.18.5v.58l.32 2-.09.33.13.69-.14.47.21 2.11-.46-.08-.28.02-2.06.08-.2-.11-.64.06-.24-.43.14-.6-.28-2.1.23-.34-.16-.25.06-.71-.17-1.08.1-.92-.15-.17.06-.66-.22-.3-.07-1.34.17-.22-.29-.35.12-.66-.19-.63.14-.59-.1-.32-.09-2.18-.16-.18v-.52l.17-.27-.31-.55.31-.1-.25-.56.08-.46-.1-.37-.06-1.87-.17-.43.16-.28-.13-.7.11-.2-.24-.43-.17-1 .27-.55-.34-.22.27-.55-.16-1.53.23-.28-.5-.53v-.26l.44-.18-.22-.23v-.26l-.36-.29.27.11.24-.22-.1-.31-.36-.36.07-.65.48-.37-.18-.43h-.25l-.15-.18.06-.71-.11-.26.34-.49-.29-.23v-.25l.17-.21-.32-.62.05-.2.25-.09-.33-.67.2-.6-.36-.35h.39l-.32-.61.22-.68-.09-.25v-1.42l-.24-.42v-.59l.24-.15-.28-.17v-.44l.27.16.11-.2-.09-.25h-.26v-.32l.18-.15v-.26l-.25-.55.1-.27-.15-.18v-.46l.17-.21.35.23.11-.21-.09-.25h-.33l-.48-.27v-.26l.18-.15.49.4-.21-.75-.42-.35h.26l.11-.14-.23-.37v-1.16l.52.07-.17-.37.07-.59h.26l.29.36.11-.21-.24-.49h-.32l-.21-.17V460l.18-.15.34.16.19-.66.41.21.17-.85.34.22v-.45l.3-.22.27.16.37-.23.29.36v-.32l.36-.36.26.1.19-.08.06.11Zm-3.55 4.43.26.1-.1-.38h-.32l.16.28Zm.23 6.17-.15-.24v.26l.14.18.01-.2Zm0-2.64v-.2l-.13-.05v.26l.13-.01Zm0 .77h-.06l.14.05-.08-.05Zm0-3.36.15.25h.2l-.09-.31-.21-.18-.05.24Zm.26-1.9.21.18v-.32h-.19l-.02.14Zm.2 2.63h-.2l.09.18.19.05-.08-.23Zm0 7.36-.08-.12v.13l.08-.01Zm.1-2.78-.07-.12.09.25-.02-.13Zm.17-6-.2-.11.09.25h.2l-.09-.14Zm.2-2.54-.35-.29v.26l.16.31.27.1-.08-.38Zm0 1-.09-.25-.11.2.2.05Zm-.14 2.47.1.31.21.17v-.38l-.16-.25.11-.2-.25.09-.01.26ZM310 487l.12-.08H310v.08Zm.25-19.33-.24-.43.06.57.18-.14Zm.13-6.35-.27-.16v.25l.14.06.13-.15Zm.07.71h-.26l.09.25h.26l-.09-.25Zm-.17 7.25-.08-.13v.07l.08.06Zm.07-6.34.24.43h.2l-.32-.61h-.13l.01.18Zm.09-3.62.18-.09-.08-.18h-.19l.09.27Zm.24 11.34v-.2h-.13v.19l.13.01Zm-.07-10.33.11-.14-.08-.18-.09.39.15.18-.09-.25Zm.5-1.4-.09-.25-.25.09.09.25.25-.09Zm-.05 5.3-.07-.13-.18.15.25-.02Zm0-2.26h-.13l.09.25h.2l-.16-.25Zm0-2.13.21.17v-.38h-.2l-.01.21Zm.31 3.71.29.3v-.26l-.21-.18.12-.14h-.39l.19.28Zm0-.9v-.07l-.06.07h.06Zm.13 4.44h-.13v.26h.2l-.07-.26Zm.06-6.46-.14-.06v.13l.14-.07Zm.08 4v.26l.21.1.17-.21-.23-.36h-.32l.17.21Zm0 .77-.14-.17v.19l.14-.02Zm.39-3.2-.24-.49-.21-.11v.26l.18.44.2.11.07-.21Zm-.18-3v-.46l-.21-.17-.07.52.08.19.2-.08Zm0 12.52h-.2l.08.12.12-.12Zm0-2.51-.13-.06v.2l.13-.14Zm.12-9.06h-.19l.21.18-.02-.18Zm.43-1.52.08-.46-.2-.05-.07.59.19-.08Zm0 15.49.1-.27-.25.09.15.18Zm.13-14.73-.1.27.28-.42-.08-.19-.13.08.03.26Zm.65-.65-.18.21.21.17-.03-.38Zm.56-.12v-.26l-.25.09.25.17Zm.85-.6h.19l.08.18-.27-.18Zm.21 6.63-.2-.11.08.18.12-.07Zm.61 1.55-.18.08.05-.13.13.05Zm.37-6v-.26l-.48-.21v.25l.23.37h.2l.05-.15Zm.38 5.13v-.26l-.17.21.17.05Zm.21-4.41.08-.4-.29.29.21.11Zm.93 3.46v-.32h-.13v.32h.13Zm.15-1.7.18-.08v-.2l-.31.16.13.12Zm.65 2v-.19l-.24.15.15.25.09-.21Zm.32 8.94v.19-.19Zm1.87-3.86v-.39l-.11.21.11.18Zm1.11 1.43.44-.17v-.19l-.12.07-.09-.18-.31.1-.17.21.25.16Zm.62-.32v-.13l-.05.14.05-.01Zm.25-1.31v-.07l-.06.07h.06Zm.66-3.69v-.32l-.25.09.25.23Zm.14 3.28-.13-.05-.11.21.14.11.1-.27Zm.13-2.59-.2-.05v.26l.21.11-.01-.32Zm.44-1.34v-.26l-.49-.33v.19l.38.61.11-.21Zm-.19-3.85h-.26l.23.36.03-.36Zm.24 1.13-.41-.28.37.55.04-.27Zm-.26-2.62.36.42.09-.46-.41-.16-.04.2Zm.2 9.09v-.27h-.19v.2l.19.07Zm-.1 6.66v.19-.2.01Zm.32-12.24-.25.09.09.25.2.11-.04-.45Zm-.05 2.72h-.13l.15.24-.02-.24Zm.2-5.11-.36-.35.11.51.21.1.04-.26Zm-.2.67h.2l-.09-.19h-.19l.08.19Zm.15 5.28h-.19l.08.18.11-.18Zm0 3.67-.15-.11v.2l.14.11.01-.2Zm-.1-2.83v-.06l-.06.07.06-.01Zm.29.29-.08-.18h-.26l.23.37.11-.19Zm0-5.74v-.32l-.2-.11.09.31.11.12Zm-.1 4.14.23.43.21.11.11-.14-.22-.3v-.2l-.35-.29-.11.14.13.25Zm.27 2.68-.36-.35.18.57.18-.22Zm.07-6.27-.41-.28v.26l.29.29.12-.27Zm-.39 9.53v.26l.22.17v-.32l-.22-.11Zm.22-6.73v-.26h-.13v.26l.14.11-.01-.11Zm-.13 14.09v.19l.18-.15-.18-.04Zm.05-9.82h.26l-.29-.29.03.29Zm.41-9.41-.16-.24-.27-.1.11.44.14.12.18-.22Zm0 1.17.24-.16-.39-.67-.19.09.26.68.08.06Zm0 6.06.16-.33-.3-.43-.16.28.3.48Zm-.13 9.57v-.19l-.13-.12v.33l.13-.02Zm0-18.85v.2l.3.42.74.25.22.3v-.26l-.24-.49-.2-.05-.23.13-.31-.55-.28.05Zm.13 3.8.09.25.28.23v-.33l-.23-.43-.32.1.18.18Zm0 8.85.14.18.11-.21-.09-.25h-.25l.09.28Zm0-.84v-.07l-.06.08.06-.01Zm.09-6.14.05-.14h-.19l.14.14Zm-.06.71.09.25h.2v-.52h-.32l.03.27Zm-.06 3.24.22.3v-.26l-.22-.04Zm.43-8.57-.21-.11-.11.21.17.3.26.11v-.33l-.11-.18Zm-.09 10 .21.17.1-.27-.15-.18h-.38l.22.28Zm.13 2.63v-.26h-.26l.05.45.2.11.01-.3Zm-.22-3.46.21.1-.17-.37-.04.27Zm.31-5.26-.21-.18v.32l.27.1-.06-.24Zm-.18 3.31.37.41.09-.33-.48-.34.02.26Zm.53-8.19v-.26l-.29-.36v-.26l-.18.08-.05.2.39.6h.13Zm-.09 2.33-.08-.25h-.2v.2l.29.29-.01-.24Zm.06 1.22.11-.27-.25-.49-.18.15.32.61Zm0 3.42.13-.08-.16-.24-.11.14.14.18Zm.12-5.3.35.35-.12-.57-.21-.17-.17.21.15.18Zm.79-1.05-.11-.51-.23-.36.09-.4-.3-.42v-.25h-.13l-.16.34.36.28-.2.67.37.41v.52l.3.42.19.05-.11-.51-.07-.24Zm-.16 5.37h-.32l.1-.21.2.05.02.16Zm.24-4 .27.1-.3-.42-.17.21.2.11Zm-.2 1.18.1-.27.42.29-.05.19h-.45l-.02-.21Zm.9-5.19h.19l.36.35.18-.08v-.45l.33.09.15.18-.27.48h-.2l-.35.42h-.25l-.26-.62-.28.42-.36-.35-.09-.25.17-.21h.33l.22.24.13-.22Zm.05 3.1v-.32l-.21-.11-.09.39.15.18.15-.14Zm.16-3.51.09.19-.12.14-.14-.12.05-.19.12-.02Zm.39 3.19v-.64l-.21-.18v.78l.21.04Zm0 3.1h.19l-.21-.11.02.11Zm.26-2.54-.15-.18-.1.27.27.16-.02-.25Zm0-1.49v.26l.21.11.21-.47-.35-.23-.07.33Zm.33 7.07v-.32l-.19.08v.26l.19-.02Zm0-4h-.13l.09.25.04-.25Zm.36 6.8v-.25l-.18.21.1.25.08-.21Zm-.18-10.11h.27l.1-.27-.24-.49v.33l-.13.43Zm.23 5.46-.09-.31-.11.27.09.18.11-.14Zm.18 1.14v-.38l-.16.28.16.1Zm.15-3.63-.27-.1v.19l.21.11.06-.2Zm0 4.33-.14-.05v.06l.14-.01Zm0 1.36.18-.15-.14-.12-.11.21.07.06Zm.18 4.3h-.13l.09.25.04-.25Zm.09-3.62-.19.08.15.25.04-.33Zm.07 4.58-.2-.11v.25l.21.18-.01-.32Zm.12-15.45v.26l-.12.14-.17-.44.29.04Zm0 7.49-.09-.24v.26l.09-.02Zm.19-4.6h-.2l.09.19.11-.19Zm0 13.75-.14-.18v.32l.2.11-.06-.25Zm.06-11.63-.15-.24.09.25.06-.01Zm.06 4.45v-.19l-.18.15.16.24.02-.2Zm0 4.72v-.39h-.12v.33l.12.06Zm0 6.13h.2v-.31l-.15-.18-.18.14.13.35Zm0-.9-.08-.12v.13l.08-.01Zm.08-1.75.14.11-.1-.38-.19.09.15.18Zm-.11-6.25.08.18.2.05-.17-.37-.11.14Zm.13-5.7h-.12l.14.18-.02-.18Zm0 9.56h.13l-.09-.25-.11.21.07.04Zm.17-8.54h-.19l.09.31.25-.15-.15-.16Zm.13 5.79-.09-.24-.11.2.15.12.05-.08Zm.17 6.12v-.26h-.27l-.11.14.23.37.15-.25Zm-.16 2.28-.12.07.14.12-.02-.19Zm0-4.65.19-.08-.15-.18-.11.2.07.06Zm0 9.1.17-.14-.25.09.08.05Zm.07-21.05h-.13l.09.19.04-.19Zm.24 17.73-.09-.19h-.26l.1.31.27.1-.02-.22Zm-.25-7.6v.26l.44-.17v-.26h-.46l.02.17Zm.16-.92h-.12l.07.12.05-.12Zm.09 3.42-.2-.05.08.19.12-.14Zm0-11.75v-.13h-.13v.13h.13Zm-.09 14.53.19-.08-.21-.17.02.25Zm.3-16.88-.21-.23v.26l.15.18.06-.21Zm.1 13.1h-.2v.06l.2-.06Zm-.06-.57.11-.15-.25.09.14.06Zm.1-8V464l-.18.14.18-.12Zm-.06 19.25v-.19l-.11.2.11-.01Zm.09 7.35-.14-.18v.26l.14-.08Zm.22-12.61h-.19l.08.18.11-.18Zm-.16-7.35h.2l.1-.27-.15-.18-.18.09.03.36Zm.37.48h-.26l.22.24.04-.24Zm0 17.63-.21-.17v.26l.21-.09Zm.13-14.67v-.25l-.25.09v.26l.21.11.04-.21Zm-.07 2.46-.15-.24v.26l.21.24-.06-.26Zm0-13v-.32h-.13v.32h.13Zm.18 13.93h-.26l.21.23.05-.23Zm0-4.91v-.27l-.19.09v.19l.19-.01Zm-.14-7.8.18-.09v-.38l-.15-.18.05.51-.08.14Zm.21 10.37v-.26l-.18.08v.2l.18-.02Zm.14-9.5-.18-.5-.06.72.24-.22Zm.05 12.71-.25.09.15.18.1-.27Zm.08-5h-.2l-.05.13.2.11.05-.24Zm-.18-2.43.15.18.5-.12-.54-.27-.11.21Zm.22-3.58-.15-.17v.26l.15.18v-.27Zm0 8.79v-.19l-.13-.06v.2l.13.05Zm0 3.54v-.31l-.12.07v.26l.12-.02Zm.42-11.21-.29-.35-.17.21.09.24.2.11.17-.21Zm-.1 3.5-.15-.24-.11.2.09.25.17-.21Zm-.05 2.65-.08-.18-.12.14.2.04Zm.11-5.3.05-.2h-.26v.27l.21.17v-.24Zm-.09 6.14.22.24.11-.21-.16-.24h-.26l.09.21Zm.2-2.48v-.19l-.2-.11.18.5.02-.2Zm.1 6.13.05-.2h-.2l.15.2Zm.06 7v-.19l-.17.14.17.05Zm.37-8.56h-.13l.14.12-.01-.12Zm.18 4.37v-.19l-.18.08.18.11Zm.12 1.22.36-.3-.57.06.14.12.07.12Zm-.07-4.58h-.13l.14.12-.01-.12ZM347.76 493.38l.18-.08v.45l-.2.54.3.42-.16 1-.17.21.29.29v.9l.22.24-.11.79.17.49v.33l.23 1v.52l.18.5v.45l.27.75-.08.46-.85-.05-.49.18-.59-.07-.3.23-.21-.11-1.1-.08-.25-.5v-.83l-.16-.31-.08-1.48-.15-.24-.21-1.4-.24-.43.14-.59-.33-.68-.18-1.79.08-.46-.53-5.3-.27-1.4.1-.27v-.38l-.15-.24v-.52l.17-.21-.28-.23.11-.27-.12-.5.15-.41-.15-.24v-.26l-.19-.56.17-.28-.21-.17-.12-.51.07-.58-.09-.25.1-.34-.19-.62h.26l.37.54.13-.08-.17-.37.17-.21h-.32l-.32-.61-.29-.23v-.52l.35.28.3-.22-.27-.1v-.45l.09-.33-.08-.12-.3.16-.06-.58.18-.15-.22-.23-.11-.44.26-.67-.39-.61v-.38l.23-.22v-.45l-.39-.61.46.09.23.36.14-.59-.14-.12-.31.16-.06-.64.43-.17-.15-.18-.49.24-.19-.56.3-.22-.22-.3v-.27l-.18-.49.17-.21-.1-.38.1-.27-.11-1.09-.25-.55.16-.41-.22-1.46.11-.2v-.84l-.15-.24v-.33l.31-.1-.21-.23v-1l.24-.16-.29-.29v-.26l.29-.29v-.77l.16-1 .28-.35v-.52h.32l.11-.79.25-.09v-.26l.18-.15v-.26l.24-.09.11-.21v-.32l.31-.16v-.25l.28-.48.3-.16.4-.56 1.71-.94.46.08.28-.42.37-.16.27.1 1.07-.3.47.21.1-.27.45-.05.21.18h.33l.23-.28.56.39.36-.16v.19l.21.11h.45l.21.17-.09.4.37-.17.65.07.49 1 .23-.34.14.12-.05.19.15.18h.45l.25.62.41.15-.1.33.15.18.38-.1.05.57.47.15v.26l-.34-.1-.66.46.2.1.49-.24.54.2-.17.22-.31.09-.11.21.15.24.24-.15.53.07-.46.57-.14.52-.24.16.21.17.5-.11v-.39h-.2l-.08-.18.76-.08.05.45.41.28-.15.4.42.35h-.32l-.29.36.21.17.51-.05-.09.39-.3.16.2.11.31-.1.22.18v.25l-.65-.06-.41.43v.13l.83-.09-.21.41.08.19.38-.11.14.18v.27l-.25.08-.41-.21-.22.41.45-.05.53.14-.37.17-.05.13.15.25h.33l.09.25-.12.14-.59-.07-.3.16-.05.2.21.1.5-.11.21.11.24-.16v.39l-.34-.1-.28.42.51-.05.06.51.28.29-.21 1.06.42.34-.22.35.09.24-.16.41.48.27-.27.48.15.18-.53.57.08.12.23-.28.47.21-.27.54-.07.59.34.1.16.37-.29.29.27.1.15.24h-.33v.2h.26l.17 1-.11.21.23.36-.15.4.16.37.07.71-.08.39.27.82-.15.46.1.32-.28.41.33.1v.32l-.44.11h.33l.23.36-.11.21.11.44-.49.3.41.16.05.51-.37.17.15.17.33.1v.71l.22.88-.11.79.16.37.15 2.11.25.5-.16.33.21.89-.07.52.3 1.07-.17.27.24.43v.51l-.23.28v.32l.24.43v.39l-.18.21.09.19.21 2.11-.16.34.15.24.14.7v1.1l.11.5-.1.27.12.57v.78l.22.88-.61.32-.6-.14-2.24.17-.4-.16-.11-1.08.07-.53-.1-1.08.1-.21-.64-6.39v-.91l-.17-.37.09-.39-.17-.38h-.25l-.16.4-.62-.39h-.32l-.22.34-.68-.32-.15.41-.6-.2-.31.09-.18.21-.28-.23-.57.13-.36.23-.47-.15-.61.32-.62-.39-.1-.31-.46-.15v.52l-.37.16-.24-.49-.31.1v.26l.15.24.34.16-.11.21h-.19l-.35-.29h-.33l-.11-.51-.21-.1-.11.13.08.19-.11.2.42.29-.05.19-.24.09-.5-.4-.28.42h-.51l-.18.15.35.28v.27l-.23.28.23.36-.23.22.17.15Zm-5.64-24.61-.1-.25-.08.4.2.11-.02-.26Zm0 3 .24-.16-.14-.11-.19.08.09.19Zm0-1.49v-.19l-.1.33.1-.14Zm0 2.2.09.25.11-.21v-.32h-.13l-.07.28Zm.19 6.37-.13-.05.11-.21.02.26Zm.4-3.14-.15-.18-.18.15.33.03Zm0-.64h-.26v.19l.26-.19Zm-.17 1.56.15.18.15-.4h-.33l.03.22Zm.32-4.49h-.12l.07.12.05-.12Zm0 2.2.12.64.21.1.11-.14-.19-.69-.25.09Zm.29 1.65v.26l.18-.09v-.32l.36-.36-.69.26.15.25Zm.3 3 .18-.14-.27-.1-.23.21.32.03Zm-.12 3.25-.14-.06-.05.14.19-.08Zm.09 1-.21-.18v.2l.21-.02Zm-.22-6.05.18-.21-.18.14v.07Zm.27 1.33v-.2h-.2v.19l.2.01Zm.18 1.14h-.2v.13l.2-.13Zm-.15-4.63.07.05v-.12l-.07.07Zm.15 13.67v-.06l-.12.07.12-.01Zm-.05-6.26.18.5v-.52l.3-.29h-.39l-.09.31Zm0-4.71.21.1.23-.28h.26l.11-.21h-.26l-.57.18.02.21Zm.4 6.27v-.39h-.19l-.11.21.3.42V484Zm-.05-4.9.12-.14h-.26l.14.14Zm0-6.07-.14-.06v.2l.14-.14Zm.11.44-.09-.19-.11.14.2.05Zm.13 1.27h-.2v.13l.2-.13Zm7.69-15.3h-.32l-.49-.41h-.27l-.15-.24-.74-.25-.31.1-.65-.06-.24.21-.57.06-.6.45h-.19l-.16.34-.42.36v.33l-.24.22-.6 1.09.09.25-.09.33-.49.24.22.3-.16.34-.14-.05v.71l.16.24-.11.27-.25.09v.2l.3.42-.22.41v.39l.14.18-.06 1.94.16.25v.26h-.45v.2l.4.16-.08.52h-.19l.28.87.14.12-.51.63-.21.48v.32l.14.17.25-.09-.09-.31.14-.47.19.57-.22.34.07.71.14.17h.27l.07.12-.11.21-.69.2.42.28v.26l-.44.13-.1.27h.2l.18-.14.15.18v.19l-.89.09-.18.21.1.32-.1.27-.31.16.27.1.31-.16.46.08.17-.21h-.39l-.16-.37.11-.21.5-.11.19.56.48.27-.43.24h-.26l-.12.14h.26l.18.44-.43.3v.25h.19l.23-.34h.26l.15.18v.31l-.38.11-.28-.23-.17.21-.51.11v.2l.2.11.23-.28h.39l.23.43v.2h.38l.11.44-.18.15-.39-.09-.88.28-.33-.1.15.25.54.26.05-.19.23-.22.48.21-.05.2-.43.17-.33-.1.09.32.27.1.49-.31.27.11.09.24-.11.21-.25.09-.1.27h.13l.31-.16.14.18-.37.16v.2h.26l.15.18-.05.2-.36.29.06.58h.39l.1.31-.11.21h-.26v.33l.38-.1.15.18-.16.4.11.44-.41.43.45-.05.21.18v.71l-.41.49.31-.16.3.43-.22.34.15.25.1 1-.1.2.15.25-.1.26.37-.1.34.81h.33l.44.53h.26l-.25-.49-.42-.35v-.25l.3-.23.2.11.24.43h.26l.39.67h.2l.09.25.35.35.09-.39-.56-.53.08-.39h.32l.22.24.11-.2-.2-.11-.15-.83.39.09.18.5-.16.34h.2l.18-.21.34.23v.32l.49-.25v-.25l-.25.09-.21-.11.23-.28-.29-.36h.32l.17.43h.39l.48.34-.25-.62v.32l-.21-.17.1-.27.27.1.23.36.38-.1.13-.59.47.14.15.25h.32l-.29-.35.17-.21.27.1.68-.26.46.08.61-.32.28.17.61-.33-.35-.28h.45l.31.42v-1.1l.18-.21-.23-.3.1-.27-.22-.3.2-.54-.21-.17.16-.34-.27-.17-.09-.25.22-.34v-.46l-.27-.16-.09-.25.27-.48v-.52l-.35-.28v-.32l.36-.3-.15-.18v-.26l-.37-.48.21-.41.07-.59-.23-.42.16-.34-.06-.51-.22-.3.15-.41-.17-.43-.11-1.09-.14-.11.1-.34-.16-.3.22-.35-.33-.09v-.32l.28-.35v-.45l-.41-.22v-.45l.11-.14h.26l.06-.13-.42-.31v-.27l-.35-.35.1-.2.25-.09v-.26h-.32l-.21-.82.1-.27h.26l.12-.14-.21-.17-.24.22-.17-1.09-.15-.24.14-.46h.26l.25-.15.44-.05.21.11.11-.14-.54-.27-.68.33-.16-.37.1-.2.45-.11-.09-.25-.21-.11-.35.36-.34-.23v-.32l.25-.09.1-.27-.34-.16.29-.29-.46-.08-.08-.19.4-.55-.2-.05-.3.29-.25-.55.16-.34-.33-.1-.28-.88.48-.3-.76.14-.11-.44.3-.29-.47-.21-.05.2-.25.09.13-.39.1-.27-.25.09-.36-.42v-.32h-.26l-.15-.18v-.32l-.2-.14Zm-7.41 18.76-.15-.24-.25.15v.2l.21.1.19-.21Zm-.31-1.19.17-.15-.24.09.07.06Zm.28 8-.22-.23-.1.2.32.03Zm0-2-.2-.1-.11.2.31-.1Zm-.11-10.7-.13-.05v.06l.13-.01Zm0 1.48.18-.15h-.2l.02.15Zm.08 5.93.17-.21h-.26l.09.21Zm.41-2.95.11-.14h-.19l-.18.15.26-.01Zm-.09 6.15.18-.15-.14-.11-.19.08.15.18Zm0-17.56h.19l-.19-.05v.05Zm.16 8 .14-.6-.3.23.16.37Zm0-2.65-.14-.11v.12l.14-.01Zm-.09 7.44.25-.16h-.26l.01.16Zm.15 5.92h-.13l.14.11-.01-.11Zm.2-16-.09-.19-.18.15.09.25.18-.21Zm.12 12.7.21.17.18-.08-.15-.18-.46-.08v.13l.22.04Zm0-.64h-.19l.09.18.1-.18Zm0-17-.14-.11v.13l.14-.02Zm.06 21.82.11-.21-.21-.23-.09.46.19-.02Zm0-6.65.24-.15-.14-.12h-.25l.15.27Zm.35 6v-.27l-.31.16.31.11Zm-.06-13.43v.19h-.13v-.2l.13.01Zm.21 2.69v.26l-.11.14v-.38l.11-.02Zm0 11.37h.26l-.09-.25h-.26l.09.25Zm.27 1.45.18-.21h-.2l-.18.15.2.06Zm0-10.26v.13h-.1v-.13h.1Zm.16 1.53-.12.08-.09-.19.21.11Zm-.17 9.9.15.18.23-.28.31-.1-.27-.1-.17.21-.25.09Zm.34-4.36h-.26v.19l.26-.19Zm.08-1.75v.26l-.15-.24.15-.02Zm.1 5.54.05-.2-.12.08.07.12Zm1.57 4v-.26h-.13v.31l.13-.05Zm.41-.43.05-.14h-.25l.2.14Zm1-2.36-.16.34-.36-.35.11-.27h.32l.09.28Zm-.35 2.29h.46l-.11-.44h-.39l.04.44Zm1.05-1.72v.27l.82.43-.11-.38-.27-.1-.44-.22Zm.72 2.58v-.19l.18-.09.15.18-.33.1Zm.67-1v-.45l-.47-.15.12.57.35.03Zm-.33-34.63-.11.14.08.12.03-.26Zm.7 33.82.11-.2-.16-.25h-.26l.31.45Zm-.06 1.36.24-.15.05-.2-.14-.11-.24.15.09.31Zm.48-2.3-.19.08.14.11.05-.19Zm-.06 1.36h.26v-.26l-.21-.11-.12.08.07.29Zm.7.51.13.05.12-.14-.15-.18-.43.17.33.1Zm.05-31.51-.13-.06v.11l.13-.05Zm.34 29.6.11-.14-.2-.11-.17.21.26.04Zm-.16-28.46.06-.13-.13.07.07.06Zm.19-3.25v-.19h-.19l.09.19h.1Zm.08 32.86-.07-.06v.06h.07Zm.33-28.83.11-.14h-.19l-.11.2.19-.06Zm-.08-1.41.24-.22-.21-.11-.11.21.08.12Zm.08 30.92h.26l.1-.21h-.26l-.24.15.14.06Zm.23-31.67h-.19v.13l.19-.13Zm.07-1.29.44-.11-.35-.22-.17.21.08.12Zm.27 2.68.11-.2h-.26l-.11.21.26-.01Zm0-1.42.19-.08-.21-.17-.18.21.2.04Zm.31-.8h-.26l-.05.2.31-.2Zm0 5-.14-.12v.2l.14-.08Zm0-3.48-.14-.12v.13l.14-.01Zm0 2v-.19.19Zm.12 26.2h.2l.05-.14h-.39l.14.14Zm-.1-24.07.7-.2-.34-.1-.36.3Zm.25 26.77.23-.22h-.44l.21.22Zm.51-32.08-.59.51.57-.06.23-.28-.21-.17Zm-.41 1v-.13H355l.19.13Zm.15 2.83v-.2l-.34.15.34.05Zm0-2.13-.11.14.26.1.36-.36h-.33l-.18.12Zm.23 4.88h.26l-.15-.24h-.19l-.11.2.19.04Zm.39-.62.3-.29-.21-.17-.19.08-.21.41.31-.03Zm-.09-2.83.05-.2h-.2l-.05.19.2.01Zm0 1.42.17-.21-.08-.13h-.25v.26l.16.08Zm.23-.93-.43.3.71-.07.15-.4h-.2l-.23.17Zm-.22 3.57h.19l.1-.2h-.31l-.18.15.2.05Zm0 2.13h.19l-.16-.24-.19-.05v.27l.16.02Zm.25 22.44h-.19l-.12.14.31-.14Zm-.28-26.57.2.11.62-.26v-.19l-.2-.11-.42.31-.2.14Zm.23 6.18v-.13h-.19l.19.13Zm.08-8.86.15-.4h-.25l-.09.46.19-.06Zm.21 5.28h-.32l.27.1h.44l.11-.21-.09-.25h-.2l-.21.36Zm.14 2.05-.09-.25-.25.09v.25l.21.18.13-.27Zm0 1.42v-.26l-.2-.05v.26l.2.05Zm.17-4.8.18-.08-.16-.31-.28.42.26-.03Zm.08 7.23-.2-.05-.05.14.25-.09Zm0-10-.11.14h.2l.42-.23h.39l-.16-.25h-.2l-.35.29-.19.05Zm0 5.55.12-.15-.08-.12-.18.09.14.18Zm.05-3.37.44-.11-.23-.36-.25.09-.15.4.19-.02Zm0 4.59.11-.21-.24.15.13.06Zm.22-6.16-.2-.11-.12.14.32-.03Zm.07 27.56.1-.2-.33-.1v.26l.23.04Zm-.26-25v.19l.59.13.17-.21-.54-.27-.22.16Zm.23 1.65h.64v-.13l-.47-.21-.31.16.14.18Zm-.14 3.18.14.05-.08-.12-.06.07Zm.53-7-.43.17-.05.2h.51l.11-.21-.14-.16Zm-.28 3-.18.09h.2l.56-.19v-.26h-.39l-.19.36Zm-.07 1.81v.19l.21.11.11-.2-.08-.19-.24.09Zm.41 1.51-.21-.11-.11.14.32-.03Zm-.12-5-.1.27h.51l-.16-.31-.25.04Zm.16 2.83v.26h.26l.11-.14-.09-.25-.28.13Zm.46 1.37-.15-.24-.18.14.08.19.25-.09Zm.14-2.47.11-.2h-.32l.21.2Zm.05 5-.2-.11v.2l.2-.09Zm.07-3.17.19-.08-.21-.17-.18.14.2.11Zm.13 1.28h.26l-.23-.3-.23.29.2.01Zm0 1.29.14.05v-.25l-.11.14-.03.06Zm.26 1.33v-.19l-.24.22.24-.03Zm.19-3.31.1-.27-.21-.11-.17.15v.26l.28-.03Zm.1 1h-.19v.2l.19-.2Zm.23 1.59.05-.13h-.27l.22.13Zm-.07 1.3h.2v-.13l-.2.13Zm.57 5.63.11-.21-.25.15.14.06Zm.19 3.14.18-.08h-.26l.08.08Zm.12-8.4h-.13v-.2l.13.2Zm.18 4.95-.15-.12-.11.14.26-.02Zm-.06-.58h-.19l.08.19.11-.19Zm.12 1.86.05-.13-.25.09.2.04Zm.46 4h-.25v.19l.25-.19ZM375.88 476.48l-.17-.44.4-.56v-.19l-.18.21-.2-.1v-.59l-.29-.29h-.26v-.26l.28-.35-.41-.28.25-.74h.25l-.15-.18-.24.09-.5-.47.42-.3-.56-.4h-.25l.14-.53.3-.22-.53-.08.13-.72h.25l.05-.2-.22-.17-.24.09v.32l-.21-.11v-.32l.11-.2-.33-.68v-.26l-.31-.55v-.33l-.25-.55.07-.59-.35-.23.11-.26-.13-.57-.21-.18v-.31l-.21-.18v-.26l-.42-.93v-1l-.18-.5h-.32l-.18.14.23.37-.37.16h-.2l-.18.14.29.36.32-.09.38.6-.52-.07-.24.22.29.29.31-.16.14.11v1l.16.24-.17.28.47.79-.11.2.15.18-.18.21.23.37-.69.13.15.25.47.21.16.24-.18.21h-.26l-.18.15.54.78-.36.3.32.68-.16.27.15.24v.27l.09.89.16.31v.62l.22.3-.06.65.28.23-.16.27.25.62-.07.53.32 1.9-.17.28.15.18.11 1.08.14.18.06.51-.11.21.3.42-.09.46.08.7-.43.3.15.18.47.21-.07.53.26.68-.16.34.16.31v.84l.17.44-.18.14.29.94-.1.27.3.42-.05.85.18.43-.1.33.09.25-.11.21.16.3v.33l.18.5-.12.14.23 2.24.18.49-.15.47.06.58h-.26l.45.54.05 1.22-.11.14.21.82-.11.2.17.37.22 2.18-.17.27-2.22.42-1.44-.24-.12-.51-.14-.18v-1l-.4-4-.48-3.44-.17-.43v-.33l-.18-.5.21-.53-.3-2.3-.2-.69v-.45l-.15-.24-.08-2.06-.33-.68.24-.22-.28-1.52.12-.08v-.32l-.3-.42.24-.8-.35-.28.13-.6-.28-.23.15-.47-.1-1.54h.2v-.51l-.27-.1v.45l-.15-.18.11-.2-.2-.76v-.91l.11-.14-.18-.56.16-.27-.26-1.33.11-.21v-.32l-.23-.43v-.45l-.25-.49.09-.4h.19l-.37-.48v-.32l.25-.09-.17-.44-.37-.2.22-.34-.09-.25.11-.27-.2-.63.11-.27-.36-1 .16-.28-.14-.76.11-.2.3.36h.26l-.09-.24-.35-.23.17-.27-.46-.09-.13-1.27.08-.47-.21-.17v-.32l-.2-.76-.11-1.08.07-.53-.15-.24v-.65l.11-.14-.16-.37.11-.14-.14-.18-.11-1-.15-.24.06-.66-.14-.75.09-.46.82-.15.24-.16h1l.44-.17 1.21-.12.34.16.25-.09.53.14.3-.22.45-.05.55.33v.26l.17.44.44.54v.45l.37.41-.1.34.09.25h.26l.15.18-.18.09.11.44.18-.09.08.19-.17.21.3.36v.32l-.15.4.42.41.27 1.33-.11.2.27.11v.38l.31.49-.16.33.47.8-.1.33.28.23v.64l.22.3.06.58.14.18v.39l.29.29-.05.78.42.35-.18.32.57.59-.29.29v.38h.31l.15.18v.26l-.3.22.17.37h.33v.44l-.25.09v.26l.46.08.13.63-.36.3h.52l.12.63-.43.18-.1.26.64-.06.09.25-.2.6-.25.09.14.12.43-.24.06.64-.48.3.2.11.31-.09.06-.14.15.25v.32l.28.23-.07.59.09.25.4.15.07.64-.14-.05v.38l.25-.09.15.18v.52l.24.42.14 1.47.43 1.06.54 2.14-.09.33.38.61-.22.34.55.4-.1-1 .31-.16-.3-.36.15-.47-.29-.29v-1.61l-.32-.62.21-.41v-.25l-.29-.29.13-.6-.15-.24V477l-.19-.57.15-.46-.16-.25v-.45l-.3-1.71.16-.34-.15-.18.11-.85-.3-.49.05-.78-.15-.18.1-.26-.29-.94-.09-.9.15-.47-.22-.23v-.46l-.22-.88v-.45l-.27-1.46.06-.65-.15-.18-.22-.94v-.46l.27.1.11-.14-.37-.48.15-.46-.25-.49.21-.48-.27-.16-.11-.45.18-.14-.32-.62.24-.15.1-.27-.32-.67.08-.47-.31-.55.16-.33-.48-.21.37-.17-.12-1.22.35.29.19-.08-.1-.31-.27-.11v-.25l.34-.49-.59-.07v-.33l-.32-.61.11-.2-.3-1.07.54.27.42-.3.34.16h.52v.33l.39-.62.28.29.43-.24.37.42.14-.53.43-.18.45.61-.05.13h-.26l-.11.15.14.17.32-.09.29.36-.08.46-.34-.16-.19.08.17.37h.26l.23.37-.44.11v.45l.25-.09.24.42h-.26l-.08.46.15.24h.32l.18.5-.55.25v.2l.15.18.45-.05-.1.33-.47-.14.41.86-.3.22.47.8-.08.52.14.7-.08.52.14.12.08.76-.18.15-.5.12.09.31.21.11.5-.18v.64h-.65v.32l.21.11.37-.1.3.42-.08.46.16.95-.1.27.25.56-.44.11-.11.2.24.43h.25l.24.43-.31.1v.45l.21.17v.26l-.23.22v.26l.38.54-.3.23.25.55v.78l.37.48-.23.28.23.43-.09.33.29 1-.11.2.2 1.27-.17.28.33.68.16 1.59-.1 1.56.15.25.28 1.45.1 1 .14 2.63.26.75-.16.34.27.74-.08.4.09.25.22 2.88.34 1.45V492l.21.76.13 2 .18.49v.33l.16.24-.06.78.13.57-.09.46.07.7-.33-.09-.89.09-.25.15h-1l-.57.12-.42.24h-.9l-.31.16-.16-.31-.35-.29.16-.34-.1-.31-.27-.1.05-.78-.21-.17-.06-.58h-.32l.3-.22-.07-.12-.18.15-.15-.18v-.32l-.21-.11-.23-1v-.26l-.18-.5.05-.2-.22-.24.1-.27-.15-.24v-.32l-.33-.1-.11-.44.18-.15-.09-.25-.32.1-.05-.51.1-.27-.31.1-.09-.25.2-.61h-.33l-.17-.43.08-.46-.2-.11-.1-.38.17-.21-.32-.55v-.57l-.24-.43.22-.41v-.26l-.41-.21v-.32l.18-.15-.09-.25-.35-.29v-.25l.24-.16-.1-.44-.24.22v.32l-.25-.56v-.26l-.24-.49.09-.4-.3-.42.15-.4.25-.09-.68-.32v-.39l-.15-.24.09-.4h-.26l.2-.6-.34-.16.11-.14-.15-.18.21-.53-.35-.23.13-.66-.15-.17-.25.08v-.26l.14.05-.23-.3.25-.09v-.44h-.27v.25l-.16.28-.15-.18v-.26l.18-.15-.11-.44-.15.01Zm-8.45-17.88.12-.14-.09-.25-.12.08.09.31Zm.46 8.35-.14-.11.12-.08.02.19Zm.44-3.92-.08-.12-.05.14.13-.02Zm.69 4.26h-.13l.08.12.05-.12Zm.19-3.83h-.25l.21.23.04-.23Zm0-3.23.05-.2-.14-.11-.11.2.14.12.06-.01Zm.28 16.83-.15-.18v.26l.15.24v-.32Zm.07.7-.18.15.14.11.04-.26Zm.87-18.88h-.13l.16.31-.03-.31Zm.32 1.2h.26v-.26h-.44v.26h.18Zm.11 1.08-.11-.44-.17.28.09.25.19-.09Zm.13.7-.15-.18h-.26l.17.37.2.11.04-.3Zm.2-.6.09.25.27.1.1-.27-.57-.46-.08.12.19.26Zm.17 3.66v-.32h-.25v.32h.25Zm.72 2-.29-.3h-.39l.37.41.31-.11Zm-.54 2.37-.13-.05v.07l.13-.02Zm1.27-4.77v-.19l-.05.19h.05Zm.3 14.56.17-.21-.27-.17-.17.21.27.17Zm.28.88-.22-.24v.26l.14.18.08-.2Zm0 .9v-.13l-.18.15.18-.02Zm.82-11.77v-.26h-.19l.19.26Zm.05 1.8-.19.08v-.13l.19.05Zm.67 18.2v.07l-.06-.06.06-.01Zm.41-17.66.1-.34h-.26v.19l.16.15Zm.1 1 .21.17.11-.27-.27-.1-.05.2Zm.26 1.26.18-.15-.05-.44h-.13l-.07.52.07.07Zm.48-8.7-.15-.18-.12.08.27.1Zm.19 5.79-.08-.18-.11.2.19-.02Zm.08 2h-.13l-.05.2.18-.2Zm.42-4.11-.21-.18-.3.23.4.15.11-.2Zm-.25 5.19.31-.1v-.26h-.2l-.24.15-.05.2.18.01Zm-.09-3.42v-.06l-.06.07.06-.01Zm.28.88-.14-.12v.2l.14-.08Zm.28 2v-.13l-.18.15.18-.02Zm.37-2.69v-.26l-.24.22.24.04Zm-.1 7.95.2.11.05-.2-.28-.16.03.25Zm.13-7.05v-.06l-.12.08.12-.02Zm.17 8.18.11-.2v-.32l-.13-.05.09.25-.07.32Zm.28-6.22h-.26l.08.19.18-.19Zm.17 8.05h-.27l.15.17.12-.17Zm0-7-.09-.24h-.13l.17.37.05-.13Zm0 6.66H378v.13l.11-.13Zm.15 1.53v-.26l-.21-.17v.39l.21.04Zm.12.51-.19.08v.32l.32-.1-.13-.3ZM379 475l-.21-.17v.26l.21-.09Zm-.12 3.31-.07-.12v.13l.07-.01Zm0-25.37.1.38.35.22.41-.37-.6-.19-.15-.18-.11.14Zm.16 29.81-.08-.12-.05.13.13-.01Zm.25-30.24-.09-.19h-.13l.1.25.12-.06Zm-.07 26.87-.14-.06.08.13.06-.07Zm.16.95-.15-.18v.25l.15-.07Zm.22.94-.2-.1.15.24.05-.14Zm.05 4.32-.08-.12v.13l.08-.01Zm.22-29.2.05-.2-.16-.24-.11.14v.25l.14.12.08-.07Zm0-3.55.12-.08-.22-.24-.11.14.21.18Zm-.11.84.15.18.11-.2-.21-.17-.05.19Zm.37 23.53L380 477l-.18.15.31.06Zm0-22.33.23-.28-.28-.17-.12.08.17.37Zm0 2.58-.08-.12v.14l.08-.02Zm.07.71v-.2l-.18.14.18.06Zm0 20.07.2.11.05-.2-.15-.18-.19.09.09.18Zm.23 11.28-.15-.18h-.12v.2l.2.1.07-.12Zm-.09-30.4V459l-.12.08.12.04Zm0 20.2h.13v-.39l-.14-.05-.11.14.12.3Zm.25-22.55v-.2h-.32l.32.2Zm0 31.31.2.05-.09-.25h-.26l.15.2Zm.09-8.08-.08-.18-.11.2.21.17-.02-.19Zm.07-22.35.17-.21h-.26l-.05.13.14.08Zm0-2.45.21.11-.05-.45-.25.09.09.25Zm.05 33.76.1-.2-.17.15.07.05Zm.08-4.33v-.13h-.12l.12.13Zm.35-31.8-.18-.44v.33l.18.11Zm-.08.52v.32l.21.11.11-.14-.1-.31-.22.02Zm.2 11.6-.19.09v.19l.19-.28Zm.32-10.3-.17-.43-.25.09v.26l.34.23.08-.15Zm.07.71-.41-.15.31.42.1-.27Zm-.11 7.89-.14-.05.09.24.05-.19Zm.35-6.82-.21-.11-.11.21.21.17.11-.27Zm-.15-3.4.2.1v-.26l-.15-.18-.18.09.13.25Zm.24 4.36h-.19l.15.18.04-.18Zm.17-3.44h-.26v.05l.26-.05Zm.12 1.8-.19.08.35.22-.16-.3Zm-.16-.89v.19l.27.1-.11-.44-.16.15Zm.41 6.54v-.25l-.18.15.18.1Zm0 37.51-.12.14v-.19l.12.05Zm0-41.7.13-.08-.08-.12-.12.07.07.13Zm.21.75-.09-.25-.11.2.2.05Zm.22.88-.27-.1.15.18.12-.08Zm.11 1.73-.12.14.09.19h.26v-.33h-.23Zm.46-2.5h-.26l.24-.15.02.15Zm.3 6.88v-.25h-.13l.13.25Zm.4 6.48h-.2l.21.11-.01-.11ZM406.9 458.66l.17.5v.2l.2.11-.1.27-.05 1.36-.31.16h-.26l-.22.41-.61-.33-.42.37h-.52l-.21-.18-.23.28-.25-.61-.19.08-.15.4h-.26l-.74-.31v.46l-.18.08-.42-.28h-.19v.26l-.18.15-.15-.24h-.39l-.15.41-.15-.18v-.26l-.29-.36h-.19l.05.57-.24.16-.28-.23-.19.08v.26l-.18.15-.21-.17v-.52l-.47-.15-.18.09.28.22-.51.06.09.31-.18.08-.27-.1-.94.29h-.45l-.44.17-.32-.61.09-.4-.06-.64-.21-.11.05-.77-.09-.25.12-.73.21-.47h.32l.21.11 1.08-.11.21.11.18-.15.2.11.76-.21.18-.15.35.29.23-.28h.58l.24-.22h.25l.21.18.42-.3.59.07.11-.21.44-.17.53.14.17-.21.38.6.32-.67h.26l.37.47.22-.41.44-.17.28.23.36-.23.35.29-.16.34.47.14-.3-.42.17-.21h.19l.15.18v.33l.15.18-.14.31Zm-7.18 1.18v-.14l-.12.08.12.06Zm2.2 1.33.21.17.11-.14-.15-.25h-.19l.02.22Zm1.74-.7.2.11v-.26l-.15-.18-.18.15.13.18Zm1 .87.46.09-.09-.25h-.39l.02.16Zm.83-.73.09.25.34.22-.1-.37.08-.52-.3.28-.14-.11.03.25Zm.71-.65v.19l.56-.12v-.33l-.36-.35-.08.46-.12.15Zm.17-.86.08.13v-.39l-.08.26ZM410 485.88l.18.49v.2l.2.11-.1.27-.06 1.36-.3.16h-.26l-.22.41-.61-.32-.42.36h-.52l-.21-.17-.23.28-.25-.62-.19.08-.15.4h-.26l-.74-.31v.45l-.18.08-.42-.28h-.19v.26l-.18.15-.15-.24h-.39l-.15.4-.15-.18v-.26l-.29-.36h-.19l.05.58-.24.15-.28-.23-.19.08v.27l-.18.14-.21-.17V489l-.47-.14-.18.08.28.23-.51.05.09.31-.18.09-.27-.11-.94.29h-.45l-.44.18-.32-.62.09-.39-.06-.64-.21-.11v-.78l-.09-.25.12-.72.21-.48h.32l.21.11 1.08-.11.21.11.18-.15.2.11.76-.2.17-.15.36.29.23-.28h.58l.24-.22h.25l.21.17.42-.3.59.07.11-.2.43-.18.53.14.18-.21.38.61.32-.68h.26l.37.48.22-.41.44-.17.28.23.36-.23.35.28-.16.34.47.15-.3-.42.17-.21h.19l.15.17v.33l.15.18-.1.24Zm-7.17 1.17.05-.13-.12.07.07.06Zm2.2 1.33.21.17.11-.14-.15-.24h-.19l.02.21Zm1.74-.69.2.11v-.27l-.15-.18-.18.15.13.19Zm1 .87.46.08-.09-.25h-.39l.02.17Zm.83-.73.09.25.34.22-.1-.38.08-.52-.3.29-.14-.12.03.26Zm.71-.66v.2l.56-.13v-.32l-.36-.35-.09.46-.11.14Zm.17-.85.07.12v-.38l-.07.26ZM243.82 474.54l.18.5-.05.2.21.11-.1.27L244 477l-.31.16h-.26l-.21.41-.62-.32-.41.36h-.52l-.21-.17-.23.28-.23-.72-.18.08-.16.4h-.25l-.74-.31v.45l-.19.08-.41-.28h-.2v.26l-.18.15-.16-.24h-.38l-.15.4-.15-.18v-.26l-.3-.36h-.19l.06.57-.24.16-.28-.23-.19.08v.26l-.18.15-.21-.17v-.52l-.46-.15-.19.09.28.23-.51.05.1.31-.19.09-.26-.11-.94.29h-.46l-.43.18-.32-.62.09-.39-.07-.64-.2-.11.05-.78-.09-.25.12-.72.21-.48h.32l.2.11 1.09-.11.21.11.17-.15.21.11.75-.2.18-.15.35.29.23-.29h.58l.24-.22h.26l.21.17.42-.3.59.07.11-.21.43-.17.53.14.17-.21.39.61.32-.68h.26l.37.48.22-.41.43-.17.28.22.37-.23.35.29-.16.34.47.15-.3-.42.17-.22h.19l.15.18v.33l.15.18-.14.42Zm-7.18 1.18.05-.14-.12.08.07.06Zm2.2 1.33.21.17.12-.14-.15-.24h-.2l.02.21Zm1.74-.69.21.11v-.27l-.14-.18-.18.15.11.19Zm1 .86.46.09-.09-.25h-.39l.02.16Zm.83-.72.09.24.35.23-.11-.38.08-.52-.29.29-.14-.12.02.26Zm.71-.66v.2l.57-.13v-.32l-.36-.35-.08.46-.13.14Zm.17-.85.08.12v-.39l-.08.27ZM247 501.76l.18.5-.05.2.21.11-.1.26-.06 1.36-.31.17h-.26l-.22.41-.61-.33-.41.36h-.52l-.21-.17-.23.28-.26-.62-.18.08-.16.41h-.25l-.74-.31v.45l-.19.09-.42-.28H242v.27l-.18.15-.16-.25h-.38l-.15.4-.15-.18v-.26l-.3-.36h-.19l.06.58-.24.15-.31-.23-.19.09v.26l-.18.15-.21-.18v-.52l-.46-.14-.19.08.28.23-.51.05.1.32-.19.08-.27-.1-.93.29h-.46l-.43.17-.32-.61.09-.4-.07-.64-.2-.11v-.78l-.09-.25.12-.72.21-.47h.32l.2.1 1.09-.1.2.1.18-.14.21.1.75-.2.18-.15.35.29.23-.28h.58l.24-.21h.26l.21.17.42-.3.59.07.11-.2.43-.17.53.14.17-.22.39.61.32-.68h.26l.37.48.22-.41.43-.17.28.23.37-.23.35.29-.16.33.47.15-.31-.42.18-.21h.19l.15.18v.32l.15.18-.01.31Zm-7.18 1.17.05-.13-.12.08.07.05Zm2.2 1.33.21.17.12-.14-.16-.24H242l.02.21Zm1.74-.69.21.11v-.26l-.14-.18-.18.14.11.19Zm1 .87.46.08-.09-.25h-.39l.02.17Zm.83-.73.09.25.35.22-.11-.37.08-.53-.29.29-.14-.12.02.26Zm.71-.65v.19l.57-.12v-.33l-.36-.35-.08.46-.13.15Zm.17-.86.08.12v-.38l-.08.26ZM412.23 471.28l1.28-.13.2.1-.36.3.24.43h.32l-.12-.56.93-.36.48.21.29-.22 1 .29v-.32l.18-.15.35.29h.26l.17-.21.77-.08.43-.17.6.2.36-.29.21.17.72.05v.65l-.3.22v.46l.22.23v.46l-.22.41.35.28-.06.72-.2-.11-.16-.3-.31.09v.46l-.54-.21v-.38l-.54-.27.07.7-.3.23-.69-.45-.16.4h-.26l-.44-.53-.25.09.12.5.4.16-.24.15-.22-.24-.46-.08-.35-.47h-.26l-.07.52h.38l.08.18-.25.09-.21-.24-.25.16-.26-.1-.17.27-.34-.22-.25.15-.2-.11-.24-.42.07.63h-.26l-.15-.18-.51.05v.2h-.33l-.21-.17h-.26l-.43-.41-.17.15.08.19.34.22-.17.15-.41-.22-.5.24h-.32l-.28-.23-.59-.14-.06.07.16.31h-.25l-.22-.23h-.39l-.21-.18-.18.09-.28.41-.27-.1-.24.15-.67-.19-.31-.48h-.32l.05.45.23.36-.4-.09-.62.26-.72-.12-.23.28-.42-.28-.68.26-.6-.2-.23.47-.53-.15-1 .3h-.26l-.5.18-.22-.24-.47.44-1.28.13-.48-.28-.24.16v.25l-.79-.11-.27-.17.08-.52-.16-.31v-.52l-.15-.24-.1-1 .15-.47-.13-.56 1.86-.13 3.12-.44.4.09.5-.12.59.07.31-.16 1-.1.4.09 1.47-.15.5-.18h.26l1.58-.29.34.16.49-.24.67.19.43-.24.4.16.81-.28.27.1.18-.14Zm1.94 1.28.21-.4h-.26l-.17.21.22.19Zm.51-.69h.19l-.12-.51h-.26l.17.38.02.13Zm0 1.22.14.12.09-.4h-.26l-.12.14.15.14Zm.4 1.45-.2-.11v.13l.2-.02Zm-.09-2.25.21.17v-.26l-.2-.2-.01.29Zm.33 1.32v-.2l-.18.15.18.05Zm.25-2v-.2h-.26v.32l.26-.12Zm1 .68-.18.08.14.11.04-.19Zm.39.67-.22-.3-.05.2.22.17.05-.07Zm1.19 1.56h-.25v-.12l.25.12Zm.26-1.32.05-.13h-.19l.14.13Zm.42-.3.25-.09-.17-.44h-.26l.18.53Zm.07-1.82h-.19l.09.19.1-.19Zm.16 3.47-.14-.11.11-.14.21.11-.18.14Zm.57-1.34-.13-.06v.26l.13-.2Zm.26-.68.2.05-.29-.3-.11.15.2.1Zm-.07-1.34v.19-.2.01ZM237.82 488.46l1.28-.13.21.11-.36.29.24.43h.31l-.12-.57.94-.35.47.21.3-.23 1 .29v-.32l.18-.15.36.29h.25l.17-.21.77-.07.43-.18.61.2.35-.29.21.17.72.06v.64l-.3.23v.45l.22.24v.45l-.22.41.36.29-.06.71-.21-.11-.16-.3-.31.09v.46l-.54-.21v-.38l-.55-.27.07.7-.3.23-.69-.45-.15.4h-.26l-.44-.54-.25.09.11.5.4.16-.24.15-.22-.24-.46-.08-.23-.36h-.25l-.08.53h.38l.09.18-.25.09-.22-.23-.24.15-.27-.1-.17.27-.34-.22-.36.06-.21-.1-.24-.43.07.64h-.26l-.14-.18-.51.05v.2h-.33l-.21-.17h-.25l-.43-.41-.18.14.08.19.35.22-.18.15-.41-.22-.49.25h-.32l-.28-.23-.6-.14-.05.07.16.31h-.26l-.22-.24h-.38l-.21-.17-.19.08-.28.42-.27-.11-.24.16-.67-.19-.3-.49h-.32v.45l.23.36-.39-.09-.62.26-.72-.12-.24.28-.41-.28-.68.26-.6-.2-.24.29-.56-.01-1 .29h-.26l-.5.18-.22-.23-.47.43-1.28.13-.48-.28-.24.16v.25l-.79-.11-.28-.17.08-.52-.16-.31v-.52l-.15-.24-.1-1 .15-.46-.12-.57 1.86-.13 3.12-.44.39.09.51-.12.59.08.3-.16 1-.11.39.09 1.47-.15.5-.18h.26l1.59-.29.34.16.49-.24.66.19.43-.24.4.16.82-.28.26.1.26-.1Zm1.94 1.29.22-.41h-.26l-.18.21.22.2Zm.51-.7h.19l-.11-.5h-.26l.16.37.02.13Zm0 1.23.14.11.09-.39h-.27l-.11.14.15.14Zm.4 1.44-.21-.11v.13l.21-.02Zm-.1-2.25.21.17v-.26l-.21-.17v.26Zm.33 1.32v-.19l-.18.14.18.05Zm.25-2v-.2h-.26v.32l.26-.12Zm1 .68-.19.08.14.12.05-.2Zm.39.67-.23-.3v.2l.21.17.02-.07Zm1.19 1.56h-.26v-.12l.26.12Zm.25-1.32v-.13h-.19l.19.13Zm.42-.3.25-.09-.17-.43h-.26l.18.52Zm.08-1.81h-.19l.08.19.11-.19Zm.15 3.47-.14-.12.12-.14.2.11-.18.15Zm.58-1.35-.14-.05v.25l.14-.2Zm.25-.67h.2l-.29-.29-.11.14.2.15Zm-.07-1.35v.19l.05-.2-.05.01ZM210.88 138.69l.45.26-.32.25-.51-.12-.07.19.13.13.26-.07.06.26-.19.45.58.06.06.26-.13.26-.25.06-.26-.32-.19.19.51.45-.13.26-.32-.06-.19.12.13.26.51-.13.13.13v.26l-.14.16-.45-.2-.13.2.13.19.45.13-.71.51.13.19.65-.06-.07.32-.51-.13-.07.26.19.19h.2v.4l-.26-.13-.19.32.06.13h.58l-.06.32h-.58l-.13.2.19.19.26-.13.19.19v.2l-.19.13-.45-.07-.26-.26.2-.25-.58-.2-.26.07.19.26.2-.07.19.19v.58l.26-.13.32.26-.2.39.13.19.26-.13.19.19-.06.26-.2.13-.57-.19-.13.32.26-.07.25.13h.45l.13.19-.13.13-.32-.19-.19.13v.26l.13.12h.32l-.07.32-.38.26-.13.64.26.07.25-.13.07.45-.45.39.06.12.52-.12.13.45-.33.12.07.65.26.38-.33.32.13.32-.13.32.26.33.26.06-.45.39.45.25-.52.26.39.32.06.19-.38.32.38.39-.25.06-.13.2.45.32v.26l-.52.19.33.06.19.19-.07.65-.19.38.39.32-.13.2h-.19l.25.38-.13.39.2.38-.13.32.19.39-.06.19-.26.07-.06.19.32-.19.19.19.06.32-.25.19.45 1-.33.32.39.38-.32.13.38.19v.26l-.12.13.44.39-.19.38.26.26-.07.26-.32.06.58-.06.07.57-.58.26.25.06.2-.12.38.06-.06.58.26.45.25.13-.25.25.57.58-.19.13.13.19h.19l.45.39.07.19-.39.07.84.25.13.39.44-.07-.12.32.45.07.12-.19.39-.07.13.26.26.13.19-.39h.38l.2.45.19.07.26-.2.06-.25-.32-.2.13-.13.32.2.19-.07.19-.25 1-.13.06-.19.19-.07-.06-.19.13-.19.51-.2.26.2.13-.07-.39-.58.2-.19.57.06-.19-.7.07-.45.38-.26-.06-.19-.26-.07.19-.38.39-.19-.2-.39.45-.45-.12-.26.25-.25-.25-.26v-.32l.32-.77-.2-.26.07-.32.26-.06h-.2v-1.36l.2-.9-.26-.13-.07-.58.2-.45-.2-.19.2-.71v-.45l-.13-.32.13-1.22-.39-.13.39-.45-.26-.7-.26.19-.25-.32.12-.26-.24-.08-.19.12.19.26-.19-.06-.13-.26-.45-.06-.26.45-.45-.26h-.38l-.19.26-.52-.13-.19-.2-.19.26-.26.07-.19-.2-.52-.06-.57.13-.33-.13-.32.38-.83-.32-.45.07-.52-.13.07-.19-.26-.39-.06-.51-.26-.32.13-.26.06-1 .2-.77.57-.38h1.61l1.8-.13 1.15.06.58-.19.32.13.9-.13.39.13.19-.26h.77v.32l.2-.12.19-.39 1.28-.06.45.64.52-.13.51 2.06-.13.25.32 1.29-.06.45.19 1.35-.13.25.07.45.19.2.06.51-.19.26.13.19-.13.26.26.19-.19 1.09.06.26-.13.19.07.58-.13 1-.2.19.13.26v1l-.13.2.07.38-.19.58-.45.26.38.06.07.32-.26.39v.51l-.32.13.25.39-.38.89.13.26-.52 1.54-.45.39-.12.58-.2.19-.19.71h-.45l.06.25-.19.39h-.25l-.33.45-.45.26-.32.57-.32-.12-.32.45-.26.06-.06.32-.77-.26-.26.45-.58-.25-.06.51-.19.19-.58-.13-.52.13-1.41.07-1.54-.2-.51-.38-.13.06-1.22-.45-.26-.45-.26.13-1-1-.2-.64-.38-.32-.07-.26-.32-.19-.71-1.42v-.32l-.25-.06v-.65l-.71-1.41-.19-.77.06-.26-.13-.25.2-.26-.45-.45-.26-1.16.19-.32-.25-.13-.13-.32.19-.32v-.45l-.19-.45h-.26v-.25l.39-.13-.07-.32.19-.2-.32-.25.13-1-.19-.26.13-.58-.07-.25.2-.39-.26-.26.19-.45v-.57l-.26-.13v-.32l.33-.39-.13-.19.06-.26-.32-.51.32-.9-.38-.45.32-.39-.07-.64-.13.13v.26l-.12-.26v-.45l.38-.39-.06-.25-.39.25-.06-.32.13-.25.38.06-.32-.51.45-.39-.19-.19-.26.13-.06-.26.12-.13-.06-.26.26-.64-.32-.06-.07-.2.77-.25.58.06-.32-.38-.77.19-.13-.26.06-.32.2.07.19-.13-.13-.13-.45.13-.19-.2.06-.32.26-.19-.13-.13.52-.51-.2-.26-.32.19-.06-.19.13-.26.25.13.2-.13-.45-.45.12-.19.58-.26-.32-.25-.38.13-.13-.13.19-.2.26.07.19-.13.51-.06.32.12.2-.12-.64-.39-.45.26-.39-.13.45-.45.45.19.26-.06.38-.32-.26-.2-.32.26-.7-.06-.32.12.19-1.09.45-.25v-.33l-.45.07.26-.32-.26-.26.06-.45.26-.06.13-.2-.13-.25.51-.32-.12-.2-.45.2-.07-.26.13-.26h.39l-.2-.25v-.26l.32-.32-.12-.13-.2.06-.13-.38.26.06.19-.13-.25-.13-.07-.38.26-.13.45.13.13-.13-.64-.45.19-.26-.32-.45.51-.38-.19-.26.51-.51-.19-.19-.26.19-.13-.19.07-.26.51.06.58-.19-.19-.26-.26.2h-.32l-.19-.2.32-.45.06-.83-.32.06.26-.38.32.06.32-.9-.06-.32.45-.38-.13-.2-.39.2-.06-.2.19-.19.26.06.19-.12-.26-.13-.06-.45.32-.2.39.2v-.2l-.39-.25.26-.52.45.13.12-.19-.06-.13-.38.07.38-.52.58.19.26-.06-.39-.45h-.32l.19-.06.2-.33.57.13.13-.06-.38-.39.12-.25.26-.13.32.13-.06-.32.32-.26.26.26.38-.33-.19-.19.06-.19h.26l.45-.26.26.07.32-.39.26-.06.83.19.39-.32h.37l.52.26 1 .12.51-.12 1 .12.38-.19.19.26.52.06.38.26-.51.45h.26l.45-.32h.25l-.12.45.57-.13.39.26-.26.32.13.19.32-.26.71.45.32.58v.24l.32.32.32.06.19.2-.06.19.45.58v.32l.51.77v.32l-.25.07.06.12.26.07.13.19-.13.45.25.26-.12.19.25.19.2 1-.13.39.13.45.25.25.13 1.09-.13.2v1.8l.13.51-.13.32-.13 1.86-.25.26v.45l.25.19-.25.65-.07.51-.19.39-.06.51-.71.13-.45-.2-2.06-.12-.12-.2-.52-.19-.13.39-.12-.2.06-.25-.19-.2.45-.7-.13-.77.32-.32-.19-.26.19-1.74.13-.25-.26-1.22.19-1.61-.13-1.16.2-.19-.32-.51-.2-1.54-.9-1.87-.38-.06-.13-.26-.26-.13-.32-.45-.25.07-.33-.2-.38.26-.26-.26-.19.26h-.45l.13-.19-.13-.26-.19-.06-.52.25-.06.26-.58-.58v.71l-.26.13-.32-.07-.25.39-.26.13-.32-.07-.2.52-.25.06-.26.45-.39.2-.12.19.06.51-.32-.06-.45.32-.39-.19-.38.12.38.39-.06.26-.45.06-.13-.19.07-.52.19-.38.26-.13-.39-.32-.19.13v.56l-.39.26.07.32-.2.51-.13-.12.2.25.51-.25.32.19.26-.26.32.07.26.44-.13.13-.77-.19-.13.19.06.2.33-.07.44.19-.44.33h-.26l-.13.12.39.13.19-.19.19.19v.2l-.19.12-.39-.12-.19.06.06.26.45.32-.12.38-.26.07-.19.51.45.19.06.33-.13.19-.32-.26-.51.07-.39.25.19.2.2-.13.64.19-.26.32-.25.06-.07.58.32.13.13.45-.13.13H211v.38l-.12.37Zm-3.47 7.13.2-.19-.33-.07.13.26Zm.65-4.62h-.26l-.13.25h.58l.19.26.32-.39h-.45l-.25-.12ZM208 140l-.19-.13-.07.32.26-.19Zm-.06.77-.13.12.19.07.71-.13v-.19l-.2-.07-.38.2h-.19Zm0 2.95h.19l.13-.19h-.45l.13.19Zm.06 10.73-.19-.07.06.2.13-.13Zm.13-9.32.19-.12-.25-.07-.2.13.26.06Zm.06.39-.19-.13-.13.19.32-.06Zm-.32 2.25h.2l-.2-.13v.13Zm.26-8.16.19-.13-.19-.13-.19.13.19.13Zm-.06.39.19-.13-.19-.13-.13.13.13.13Zm-.07 4.36.19-.19-.19-.17-.06.26.06.1Zm.19 18.12-.19-.19v.19h.19Zm.45-25.7.13-.25-.26-.07-.12.26.25.06Zm-.19 1.22.32-.06-.38-.13.06.19Zm.06 5.59.2-.06.06-.26h-.26l-.12.19.12.13Zm.13 1.29-.19-.2-.06.2h.25Zm-.06-7.33h.19l.13-.19-.26-.06-.19.13.13.12Zm.13 1.87.06-.2h-.19l-.13.2h.26Zm-.13 6.81-.13-.07.06.13.07-.06Zm.39-7.78-.39.39.26.06.38-.32-.25-.13Zm.12 4.37.2-.26-.32-.06-.13.26.25.06Zm0-11.88-.19.06.07-.19.12.13Zm-.09 15.4h-.13l.13.12v-.12Zm.13-12.4-.19.13.19.12.51-.19.07-.26-.33.2h-.25Zm-.13 6.23.32-.13-.19-.13-.19.19.06.07Zm.13-5.53.19-.06-.19-.19-.13.19.13.06Zm0 1.35-.07-.19-.06.2.13-.01Zm.06.84-.19-.13v.13h.19Zm.13.45v-.2h-.26l-.06.2h.32Zm-.32 2.25.32-.13-.19-.07-.13.13v.07Zm.19 1.86-.19-.19.13.19h.06Zm0-.45v-.13l-.06.13h.06Zm.13 2.44-.19.19.64-.06v-.26l-.19-.06-.26.19Zm.06 4-.12.13.19.19.13-.19-.2-.13Zm.26-1.22-.13-.13-.19.07.06.26.26-.2Zm-.06-8.61.19-.19h-.39l.2.19Zm.25 5.08-.32.06-.13.26.78-.19.06-.2-.19-.06-.2.13Zm-.38-6 .19.19.13-.19-.06-.19-.2-.07-.06.26Zm.13 2.89h.45l-.13-.26-.26-.06-.19.13.13.19Zm.06 1.09-.19-.06v.26l.19-.2Zm.13.65-.32.25.19.07.45-.13.07-.26-.13-.06-.26.13Zm-.13.89.07-.25-.26.06.06.19h.13Zm0 7.59-.13-.13-.06.13h.19Zm0 .38-.19.07.19.12v-.19Zm0-18-.13-.06v.13l.13-.07Zm-.06 12-.07.19h.26l-.19-.19Zm.06 1.54-.13-.07v.2l.13-.13Zm0-13v-.13l-.06.13h.06Zm.07-1.93.06-.12-.13.06.07.06Zm0 2.57h-.07l.07.13v-.13Zm.32 9.06.25-.26-.25-.06-.2.19.2.13Zm0-5.39-.13.19.26.26.19-.2-.07-.25.13-.33h-.38v.33Zm.06 3-.06-.13-.13.13h.19Zm.13 3.53-.32-.13v.13h.32Zm-.19 2.76-.07-.13-.06.13h.13Zm.06-15.61.19-.26-.32.07.13.19Zm0 1.41.32-.25-.13-.13-.25.06-.03.26.09.06Zm.13.71-.19-.19-.07.13.26.06Zm.06 2.63-.19-.19-.13.19h.32Zm-.12 2.83.12-.19h-.19l-.13.19h.2Zm-.2 5.85h.13v-.2H210l-.04.2Zm.07-14.07.25.06-.06-.13h-.19v.07Zm.13 1.28h-.13l.13.13v-.13Zm-.07 2.7v-.06l-.06.06h.06Zm.13.64-.13-.19-.06.19h.19Zm.32 23.26-.45-.07.39.07h.06Zm0-7.65V150l-.26.13.07.19.19-.08Zm0 .84.06-.13-.25.06.19.07Zm-.06 3.27v-.19l-.13.13.13.06Zm.12-16.83.13-.12-.13-.13-.19.13.19.12Zm-.06.52.19-.13-.19-.13-.13.13.13.13Zm.06.83.26-.19-.45.06.19.13Zm-.06-3.72.19.13.26-.07-.39-.32-.06.26Zm.26-2.51.26.13.12-.06-.19-.26-.19-.07-.2.13.2.13Zm0 2.12.13-.19-.26.06-.07.2.2-.07Zm0 11.18-.2-.06.33-.13-.13.19Zm.13 2.7-.13.13-.2-.2.07-.19.26.06v.2Zm-.13-18.76-.13-.13v.13h.13Zm0 3.34-.13.19.45-.13.13-.19-.25-.09-.2.22Zm0 3.28-.13-.07v.19l.13-.12Zm.19-7.78-.06-.25-.2.06.26.19Zm0 29.94.13-.26h-.26l-.06.19.19.07Zm.01 1.74h.25l.13-.12-.25-.13-.2.06.07.19Zm.06-30.32h.26l.06-.13-.38-.06.06.19Zm.07 31 .25-.06-.25-.07v.13Zm.38-33.15h.26l-.2-.19-.25.06.19.13Zm0 1.35.26.07v-.13l-.32-.2-.13.2.19.06Zm0 7.71-.19-.06.06-.13h.26l-.13.19Zm.51-10-.19-.06-.13.13.32-.07Zm-.06 2.44-.26.33.13.19.45.06.13-.19-.32-.19-.13-.2Zm.38-.64-.12.45h.45l-.07-.51-.64-.45-.19.13.57.38Zm0-1.73H212l.19.19.15-.19Zm-.06 3.53.19.13.26-.07-.13-.25-.26-.13-.19.19.13.13Zm.52.9-.2.13-.26-.13.07-.19h.45l-.06.19Zm-.07-5.08-.19-.06.19.19v-.13Zm.07 1.61-.07-.19-.13.13.2.06Zm.06 1.86.26.13.19-.06-.32-.45-.26.06-.06.26.19.06Zm.32-2.69-.13-.2-.06.13.13.13.06-.06Zm.19 1.47-.19-.19-.06.13.25.06Zm0 .39-.06.26h.45l.19-.13-.45-.32-.13.19Zm.39-1.22h-.19l.12.19.07-.19Zm-.07-1.22.26-.2-.19-.06-.13.13.06.13Zm0-1.35.26.06v-.25l-.26-.07v.26Zm.65.58.06-.2h-.26v.36l.2-.16Zm0 1.47v-.25l-.2.06.13.39.07-.2Zm.06 1.29-.13-.19-.13.19h.26Zm1.22-3.28.32.07-.19-.26-.13.19Zm1.48 46.9-.13-.13-.06.19.19-.06Zm.83.13.26-.13v-.13l-.32-.13-.13.26.19.13Zm.52-3.67-.07-.25-.12.19.19.06Zm.83-15.8-.13-.06-.06.32.19-.26Zm.84 14.91-.26-.07v.26l.26-.19Zm.83-2.19.32.06.39.33.06-.2-.57-.32-.2.13Zm.58-38.41.19-.07-.06-.26h-.26l-.06.26.19.07Zm0 26.78-.19-.06.06-.19.13.25Zm.45 15.42v-.26l-.19.13.19.13Zm.26-5.07-.13-.2-.06.2h.19Zm.13-38 .13-.07-.26.07h.13Zm.13 42.39v-.12h-.13l.13.12Zm.32.65-.45-.07.32.07h.13Zm-.32-6.3.19-.13h-.19v.13Zm.19 1.54-.13-.19-.06.19h.19Zm.83 2.51-.25-.07.06.26h.26l-.07-.19Zm.2-38.55-.13-.19h-.26v.19h.39Zm-.07 31.87v-.13l-.06.13h.06Zm.52-31.29v-.06l-.26.06v.2l.26-.2Zm.7 34.44-.19-.13v.19l.19-.06Zm.39-1.16-.2-.13v.13h.2Zm.06-28.27.26.2V134h-.32l.06.15ZM234 138.05h.26l.44.38.2-.19-.84-.51.26-.2-.13-.19h-.26l-.25-.26.13-.32-.13-.19.06-.45.26-.38-.26-.07.13-.38.32-.2-.13-.13.26-.32-.45-.06v.51h-.26l-.13-.13.07-.25.26-.13-.2-.26.2-.25-.33-.26v-.45l.33-.07.19.26h.26l.06-.13-.64-.32.19-.32-.58-.51.07-.26-.2-.39.13-.25.32.19-.25-.51-.07-.52-.19-.32.19-.19.26.13.26-.07-.71-.64-.19-.64-.2-.13.13-.19.45-.13-.51-.9.38-.45-.13-.58.07-.26-.26-.32.32-.19-.13-.39.26-.12.45.19.64-.19.58.06.39-.19.58.32.44-.32.45.13.07.12.51-.25.32.38.39.13.06-.45.39.07.32.45.19-.13.07-.32.38-.2.13.32.45.13.32-.38.64.51.13-.51.26-.07.26.13.06.32.26.13.13-.19V125l.19-.07.45.2.06.25.32.13V125l.39-.07.32.39.26-.13.06-.32.58.13-.06.25.12.26.45-.58h.33l-.13 1-.13-.2-.07.26.13.19.26.07v.58l-.32.06-.13.26.19.25.32-.06v1l-.25-.13-.26.13-.13.51-.38-.06-.13-.45-.19-.13-.2.06-.13.45-.38.07-.13-.32h-.45l-.13.32-.19-.13-.19-.39-.45.2v.25l-.45.07-.32-.39-.26-.06v.38l-.19.13-.26-.06-.32-.71-.13.19-.07.52-.44.06-.26-.51-.26.45-.9.13-.45-.07-.83.26-.13.83.38.07-.12.45-.33-.07-.19.13.26.07.38.7.07.45-.19.07-.26-.2v-.38l-.39-.07.2.58-.2.2.52.19.06.19-.64.39.32.25-.19.26.45.39-.13.19h-.32l-.07.26.26.64.32.32-.19.19h.38l.2.39-.13.19-.64.06.32.45.32.07v.9l-.52-.07.2.32h.32l.19.2-.13.19v.32l.2.45v.45l-.26.26v.7l.32.26-.19.51.32 1-.07.32.13.2.13-.26h.39l.06.38.84.65.12-.32-.44-.2.06-.58h.26l.38.84.26-.26.25.32.26.07-.26-.52h-.25l.13-.06.06-.26.19-.06.2.13v.32l.32.26.25.51.13-.19-.19-.71.06-.26.45.2.13.38h.2l.38.71.26.06v-.51l.13-.19h.25l.07.25.38.39.26.06.13.52.19.12.11-.17-.07-.26-.38-.26-.06-.45.51-.64h.19l.07.32-.33.65.52.83-.52.26.2.45.26.13.19.64-.39-.19-.26.06-.19-.58h-.19l-.32-.64-.26-.07v-.57l-.45-.07v.2l.26.06.26.71v.32l.45.06.06.71-.45-.13-.26.32-.64-.19-.38.26-.45-.07.06-.19.26-.07.06-.45-.19-.12-.13.45-.39.12-.32-.32-.19.13.26.39-.45.06-.39-.19-.13-.26-.25.13.06.32-.51-.13-.77.07-.2-.13-.25.13-.2.45-.32.19.2.26-.2.19.39.26.06 1.67-.13.25.13.39-.32.13.26.19.13 1-.07.51.26 1-.19.2.13.19.12.77-.19.26.26.38-.07.77-.19.39.32.64v.26l-.32.38.32.2v1.92l-.13.33.2.64-.07.77.13 1.8-.06.45.12.9-.06.51.19.9-.1 1.05.13.45-.19.64.19.45.33.33.77-.13.44.25.2-.19h.9l.38-.19.2.13.06.25.19.13.19-.13.07-.25.45-.13.19.38h.26l.13-.38h.32l.19.13.06.25h.26l.26-.45h.26l.32.45.25.13.33.58.25.06v.24l.19.39.2.06.38 1-.06.26-.19-.13-.13-.58-.39-.06-.06-.71-.39.33.07.19.38.25.07.58.38.32.39.71-.19.07-.52-.2-.26.2-.51-.13.13-.13.26.06.19-.45-.32-.45-.2.2-.06.51h-.39l-.12-.45-.58-.39V170l-.26.13.06.25.33.33v.29l.57.52-.19.19-.32-.06-.06-.26-.45-.07-.07-.45-.19-.12-.19.19.13.38.25-.06.07.51-.45-.06-.32-.32-.39.32-.39-.06-.06-.33-.45.33-.51-.07-.32-.19-.2.26-.25.06-2.51-.06-1.61-.26-.32.06-.32-.13-.45.2-.38-.2h-.32l-.13-.19.25-.19-.06-.64.13-.45-.19-.45.06-.2-.13-.25.13-.52-.06-1 .12-.51-.12-.9.12-.39-.12-2v-2.13l-.13-.58.13-.9-.2-.58.2-.32.06-.45-.26-.64.2-.84-.32-.51.25-.32-.25-.26.06-.84-.13-.25.13-.77-.13-.9.13-.26-.13-1 .07-1-.13-.32.13-.45-.13-.26.06-.26-.19-.7.19-.2v-.51l-.19-.51.19-.2.32.2.19-.2-.64-.32-.13-.83.26-.26-.32-.77v-.26l.32-.45v-.32l.13-.19-.45-.45v-.26l.26-.13-.07-.45-.19-.32-.06-.9.45-.06-.13-.26-.26-.13v-.45l-.19-.64.51.07-.38-.65.06-.32-.19-.19.06-.32h.64l-.57-.39-.13-.83.38.06-.19.2.12.2Zm-.52-5-.19-.13.19-.06v.19Zm.58 3.66.2-.06.25.19.26-.13-.13-.25-.64-.07-.13.19.19.13Zm.13-4.56.19-.06-.19-.19-.19.19.19.06Zm0 1.61h-.13l.13.19v-.19Zm.39 12.65-.07-.19-.19.07.26.12Zm-.13-1.28.25-.07.07-.19h-.39l.07.26Zm.19-11.18-.19.07.25.12-.06-.19Zm.13 1.35-.32-.06.13.19.19-.13Zm-.07 4h-.19l-.06.2.25.19.13-.19-.13-.2Zm-.06 3 .19-.19-.25-.07-.13.13.19.13Zm.06 1.35.07-.19-.19-.07-.13.2.25.06Zm-.19-12.27.26.07.13-.2h-.39v.13Zm.19 1.48.2-.07-.2-.19-.19.13.19.13Zm.07 4.5.26.19.19-.26-.45-.19-.19.13.19.13Zm.13 6.87.25.13.07-.2-.52-.19.2.26Zm.38-9.64-.38-.19.06.26.32.32v.26l.2.19v.32l-.33-.13-.19.26v.19l.19.13.65-.32.38.13-.38-.84-.52-.26v-.32Zm-.13 11.12.07-.07-.19-.13-.13.13.25.07Zm.07-13.62.13-.13-.2-.06-.19.12.26.07Zm.06 1.35-.13-.2-.19.07.32.13Zm0 4.56.39.19.19-.13-.71-.19-.19.13h.32Zm-.19 9H235v.19l.09-.19Zm.13-8.35H235v.19l.22-.19Zm-.13 1.61.19-.13-.13-.07-.12.13.06.07Zm.32-3.47.26.13.26-.13-.39-.32-.26.06.13.26Zm.19 4.17.2-.13-.2-.19-.19.19.19.13Zm-.06 4.05h.19v-.13l-.32-.06.13.19Zm.19-11-.19-.13v.25l.19-.12Zm.07 5.39-.2-.06-.06.19.26-.13Zm-.07-6.62.13-.12h-.19l.06.12Zm.45 7.26L236 140l-.06.19.24-.15Zm-.13-2.63.13-.13-.13.07v.06Zm.39-5.46-.19-.06v.19l.19-.13Zm0 3.47.19.13.19-.26-.38-.19-.19.13.19.19Zm.13 3.79-.32-.13v.26l.38.25.13-.19-.19-.19Zm-.2-1.16.26.07-.06-.26-.2-.06v.25Zm.26-1.22.13-.13-.19-.06-.13.13.19.06Zm0 4.05-.19-.26v.19l.19.07Zm0-10.86.07-.13-.13-.12-.07.19.13.06Zm.52 18.44-.52-.13.26.13h.26Zm.25-14.13v.19l-.64-.13.13-.45.45.19.06.2Zm-.38-8.8v-.2l-.2-.06.2.26Zm-.13 14.71.26.06.19-.13-.19-.13h-.33l.07.2Zm.19 1.28h.26l-.13-.26-.32-.06-.07.26.26.06Zm-.06-2.7h.25v-.25l-.19-.07-.19.13.13.19Zm.13 1.87-.2-.13v.13h.2Zm0 10.4-.2-.06v.13l.2-.07Zm.25-18.05-.25.07-.15-.11v-.26l.13-.13.25.13.02.3Zm-.19 4.82-.19-.06v.2l.19-.14Zm.64-13v.14l-.06-.07.06-.07Zm.32 18.12.13-.26-.19-.13-.13.26.19.13Zm.52 2.25.13-.26-.07-.13h-.26l-.12.26.06.26.19.12.07-.25Zm.45-.84v.32l.19-.06.06-.19-.25-.07Zm.83-.7-.38-.39.19.58.19-.19Zm-.19 1.41.06-.19-.25.06.19.13Zm.19-.26.19-.19-.25.13.06.06Zm.19-.38.07.19.19-.07-.13-.38h-.25v.13l.12.13Zm-.06-1.1h.26v-.19l-.26-.06v.25Zm.45-17.6h-.13l.13.13v-.13Zm.13 18h.32l-.13-.32h-.26l.07.32Zm.64.71-.06-.26-.2.07.26.19Zm0-18.89h-.13l.13.13v-.13Zm.07 17.8.12-.26h-.19l.07.26Zm.19 27.88h.19l-.06-.19h-.26l.13.19Zm.13-27.18.13-.12h.16v-.26l-.19-.13-.06.19.13.2-.33-.13.16.25Zm.06-17.66.26-.07.06-.19-.13-.13-.25.13v.26h.06Zm.32 43.75v-.2l-.25.2h.25Zm0-27.56-.13-.32.13-.13.39.13v.32h-.39Zm.32 1.92h-.13l.07.2.06-.2Zm.26 23.84.13-.2-.19-.19h-.26l.19.52.13-.13Zm.13-22.87-.13-.26-.06.19.19.07Zm.51 24.67-.06-.2-.25.03.07.45h.25l-.01-.28Zm-.06-27.88.06.25h-.25v-.38l.19.13Zm.06 27 .2.13-.2-.39-.19.06.19.2Zm.07-1 .13.19.38.19.19.45.26.13v.26l.26.38.19-.06v-.32l-.19-.26-.26-.06-.13-.52-.32-.12-.13-.52h-.45l.07.26Zm.45-26.21-.2-.07.26-.12-.06.19Zm.19-15.61-.26.06.13.2.13-.2v-.06Zm.32-.71.07.26h.19l.06-.45-.25-.13-.2.13.13.19Zm-.06 1.16v.26l.25.19v-.52l-.25.07Zm.38 41.43.19-.25-.12-.13-.26.06-.06.19.25.13Zm.52 1.61-.18.04-.06.26.24-.3Zm.25-.84-.13-.19v.19h.13ZM246 168l.39.13.06.52.19.38-.12.26-.2-.07v-.32l-.13-.19H246l-.13-.58-.39-.25-.06-.2.13-.13.32.13.13.32Zm-.13-39.31v.13l-.13-.13h.13Zm.84 39.06-.07.19h-.25l.06-.45h.26v.26ZM258.87 124.75l.19.13.26-.07.13-.19.45.13.25.26.33-.2.57.07.13.19.39-.19.7.19.26-.06.19.32h.71l.13.13.9.19.06.19.32-.06.9.45-.06.25.83.33.26.45.45.06-.13.19-.45.2.13.19.26-.19.45-.07.32.32.32.07.19.38v.26l-.51.19-.19.19.19.13.51-.13.32.26-.12.19-.45.26-.26-.32h-.19l-.39.32 1.09.13.26-.13.45.32-.13.26-.26.13.26.13h.58l-.45.45.13.19.64.19-.19.32-.45-.25-.19.12v.38l.51-.13.32.25-.58.45.45-.06.32.26-.13.25.2.2.51.19-.32.38.06.26-.32.39.65.32-.07.25-.32.26.64.19-.38.26-.26-.19-.26.19.07.13.45-.06.19.25-.13.32.19.26-.19.45-.06.64.32.32v.32l-.39.07v.77l.13.19.26-.06-.52.38.07.58-.26.19.13.26-.24.27.45.26-.06.26-.45.13-.07.19.13.19-.38.45.25-.13.2.13v.26l-.52.06-.12.32.19.2-.19.19h-.26l-.13.13v.25l.13.13.19-.06v.25h-.71l-.19.65-.26.06-.06.45-.45.19v.33l-.19.25h-.32v.39l-.13.19-.19-.06-.33.57-.25.07v.19h-.2l-.19.32-.58.39.07.32-.32-.13-.26.32.19.77-.13.65.52.57v.3l.26.52-.26.32.38.13-.25.25.38.33v.25l.32.39v.32l-.32.19.19.26.26.06v.2l-.26.06.07.19.26-.19.12.13-.19.45.39.38.06.33-.38.19.64.38-.07.32.13.2-.25.32.12.13.39-.07v.45l.32.58-.13.26.13.32-.26.06-.12.2.38.19.13.19-.26.39h.39l.19.19-.19.51.19.26-.32.06-.32.39.06.13.71-.32.19.32-.32.38.13.13.26-.13.12.26-.19.45.39.32h-.32l-.2.45.39-.13.19.2-.13.51.39.13-.13.58.13.19-.07.19.45.52-.12.25.32.32v.2l-.32.32.44.32-.51.13.07.19.44-.13.13.19-.25.65.19.13.32-.07.06.26-.25.38.38.2-.13.32.07.38-.13.32.58.13v.32l.26.45v.26l.19.19-.52.07.26.13.32-.07.07.19-.2.2-.51.13-.26-.13-.25.06-.45-.13-.32.07h-1.48l.06-.2-.38.26-.45.07-.13-.45.51-.2.13-.19-.19-.13-.52.26-.25-.13v-.32l.45-.26-.07-.19-.19-.07-.26.2-.25-.07v-.25l.38-.26-.19-.32h-.39l.07-.45-.2-.26.52-.26-.19-.25-.33.19-.25-.19.06-.19.32-.26-.51-.19-.13-.26.26-.26-.13-.26-.26-.12.13-.2-.32-.25.06-.33.45-.32-.57-.12-.13-.2.06-.25-.13-.26.13-.19-.32-.39.13-.38-.26-.39V163l.26-.07-.26-.45v-.25l-.38-.13v-.45l.25-.26-.45-.06.07-.39-.45-.77.13-.77-.32-.06.12-.58-.45-.65v-.32l-.19-.45v-.45l-.13-.25-.38-1.48.06-.45-.32-.26v-.25l-.13-.13-.06-.45-.26-.13v-.39l-.19-.25v-1.05l-.32-.2v-.45l-.13-.13-.71.39-.19-.19-.26.19-.77.19v-.25l-.9.38-.51.58-.26-.19h-.26l.45.25.13.2.13.9-.13.19.13 1.73-.26.26.26.19.07.45-.26.58.32.58-.19.19-.39-.13-.19.13.58.39-.13.32.38.38-.32.9.26.45-.13.26.07.32-.26.32.32.19.06.26-.25.13.19.38-.84.39.13.13.45-.13.26.13.06.26-.18.28-.33.13.33.26-.33.26.39.06.13.39-.07.25-.7-.19.32.38h.32l-.19.26.32.39v.25l-.32.26.19.32-.32.07-.13.19.13.13h.26l.25.38-.32.32.32.2v.19h-.58l.2.19.25-.06.07.64-.32.06.32.39-.26-.06-.19.12.06.26h.32l.07.9-.13.13-.06-.32-.58-.39-.2.13.52.45.13.32h.25l.07 1.22-.13-.32-.32-.13-.32-.32-.2.19.45.26-.19.45-.32.07-.26-.33-.45.33-.64-.33-.26.26h-.45l-.19.32-.32-.06-.13-.26-.25.07-.13-.33-.33-.06.33-.26-.13-.19h-.26l.13-.26.26-.13.25.2.58-.77-.58-.52.39-.25h.32l-.13-.33-.38.13-.32-.06-.13-.26.57-.06.2.13.19-.2h-.32l-.32-.45.13-.19h.77l.19-.13h-.32l-.19-.25v-.26l-.33-.13-.32-.39.26-.32-.38.13.06.26-.13.19-.51.07-.07-.26.13-.26.39-.06v-.58l.57.13.26-.07-.58-.51-.38.38-.2-.06-.19-.45.52-.06.19.13.19-.26-.38-.13-.07-.26.58-.25-.13-.26-.45.26-.38-.2-.07-.25.52-.26-.13-.26.26-.38.38.06-.32-.45-.52.45-.12-.06-.07-.45.13-.2.26.07.13-.19v-.45l-.39-.32-.06-.2.12-.19.65.13-.58-.52.13-.19-.32-.25V160l.38-.19.13-.2-.13-.25.13-.2.51-.19-.19-.26.19-.25-.32.12.07.2-.4.22-.39-.19.13-.26.26.06.19-.19-.45-.38.52-.26.44-.06-.12-.2-.71.2-.19-.13.06-.45h.32v-.65l-.32-.32.45-.45-.39-.19.33-.38-.39-.26-.06-.19.12-.13h.33v-.26l-.33-.32.46-.32.19.06.13-.13-.13-.12-.26.19h-.39l-.06-.39.45-.19-.39-.39.65-.51-.32.13-.39-.07-.06-.38.45-.26-.26-.32.19-.19-.32-.19-.06-.26.12-.32h.26l.07-.13-.2-.32-.13.13v-.13l.26-.13-.32-.19-.06-.32.32-.24v-.26l-.26-.38v-.65l.26-.12-.2-.26-.12-.71.06-.25.32-.07-.26-.19.07-.26-.13-.19v-.45l.32-.13-.32-.26.26-.25-.26-.13-.06-.32.12-.26.33-.13-.33-.13v-.51l-.06-3 .13-.19-.07-.45.26-.19-.26-.19-.06-.33.19-.7-.13-.26v-.9l.13-.19-.13-.32v-2.57l-.19-.77.13-1-.13-.26.07-1-.13-1 .06-.58-.13-.25.13-.78-.13-.51.2-.51-.2-.77.07-.58-.19-.58.12-.13h1.29l.38-.13.45.13.39-.19.71.06.25-.13.58.07.45-.13.58.06.45-.19-.14.12Zm-4.69 43.43-.13.12-.38-.25.12-.19.46.06-.07.26Zm-.06 1.41h-.2l-.19-.19.13-.13.45.06-.19.26Zm0-2.06v-.32l.19-.13.51.13-.19.32-.45.26-.06-.26Zm.32 2.44.19-.06.13.13-.58.32v-.45l.26.06Zm0-18.95.25-.06-.25-.13-.19.07.19.12Zm.06 5.21h-.25v.19l.25-.19Zm-.06 4.3.25-.06-.12-.26-.2-.06-.12.25.19.13Zm.13-14.84.06-.19-.26.13.2.06Zm.12 9.32-.12-.2-.13.13.25.07Zm-.25 2v.19l.51-.32-.32.13h-.19Zm0 4.43v.19h.19l-.19-.19Zm.06 9.38v.26l.19.13.71-.2.52.13.08-.14-.32-.06-.19-.26-.71.26-.28-.12Zm.52-4.43.06-.26-.26-.06-.19.19.39.13Zm-.13-4 .13-.19h-.26l-.07.19h.2Zm.13 1.41.06-.19-.26-.06-.13.19.33.06Zm-.13-.57-.13-.07.13.19v-.12Zm0 1.79.19-.06-.13-.19-.19.13.13.12Zm.06-3.14v-.13l-.13.13h.13Zm.45 6.68.06-.26-.19-.06-.19.19.32.13Zm-.19 1.28.25-.06.13-.19-.32-.13-.13.25.07.13Zm.19-14.71.19-.13-.19-.06-.19.13.19.06Zm-.06 10.79.51.07.13-.13-.64-.32-.13.19.13.19Zm.12-12.14v-.25l-.19.19.19.06Zm-.12 5.33.19-.12h-.26l.07.12Zm.19 5.21.13-.26-.2-.19-.19.45h.26Zm0-11.89.06-.13-.13-.12-.12.19.19.06Zm-.07 10.6.13-.06-.13-.32-.12.25.12.13Zm-.06 6.17.13-.13h-.19l.06.13Zm.06-11.43v-.13l-.06.13h.06Zm.07 2.69v-.19h-.13l.13.19Zm.13 6 .45-.26-.26-.12-.45.32.26.06Zm.19 3.92.39.32-.13.19.45.2.44-.09v-.19l-.32.06-.68-.87-.38.13-.07.26.3-.01Zm-.13-1.61v.2l.26.06.13-.19-.19-.39-.26.07.06.25Zm.2-3.72.19-.13-.19-.13-.2.13.2.13Zm-.07-1.35.26-.06-.19-.13-.13.19h.06Zm.58 6h.26l-.07-.26-.19-.13-.19.07-.07.25.26.07Zm.06-1.48-.25-.06.12.19.33-.07-.2-.06Zm.07-13.36-.07-.13-.06.19.13-.06Zm.38 10.15.2-.13-.2-.13-.32.13.32.13Zm-.19-6.75v-.06l-.06.06h.06Zm-.06 1.35.32.07v-.2l-.32.07v.06Zm.06 4.05.26-.06-.32-.07.06.13Zm.26 6.62.13-.2-.39-.06-.06.19.32.07Zm0-3.92.06-.2-.19-.06-.13.19.26.07Zm-.07 2.63.2-.06-.07-.2-.19-.06-.13.19.19.13Zm.07-1.22.13-.19-.33-.07.2.26Zm-.13-11v.23l.19-.07-.19-.16Zm.12 11.53h-.13l.13.13v-.13Zm.38-7.9.26-.19h-.32l-.19.13.25.06Zm.07 6.62.19-.19-.19-.13-.2.06-.12.26h.32Zm.06-12.08-.13-.13-.19.07.32.06Zm-.06 8 .06-.19h-.26l-.06.19h.26Zm-.13 2.7.25.06.07-.25-.19-.19-.26.12.13.26Zm0-12h.25l.13-.19-.25-.07-.2.19.07.07Zm.25 14.64-.19-.19-.13.19h.32Zm-.19-30.51h.26v-.13l-.26.07v.06Zm.13 28.72.06-.2-.19.07.13.13Zm.06 3.91-.19-.12.07.19.12-.07Zm3.73-41.82-.71.07-.25-.19-.64.12-.52-.12-.83.12-.2-.12-.45.19.13 1V131h-.38l.32.32.13.52-.07 1.92-.26.07.2.26.13 1-.13.2.19 1.34-.19.45.13.2-.13 1.15.19.65-.06 1.47-.2.52.13.19.07.51-.13.26.06.84-.38.12.32.2v.81l.13.45-.13.25.13 2.06-.2.45.26.77.45.13.26-.26.45-.19.19-.39.19.26.13-.13.26.13.25-.06.58-.45.2-.32.25.19.39-.32v-.32h-.26l.9-.13.06-.32 1-.84.13-.26.26.07.19-.19.16-.58h.38l.13-.19-.07-.32.13-.19.45.12.13-.19-.19-.45h.19l.19-.19.84-1.48.13.07.19-1-.13-.19.19-.52.39-.19-.06-.64-.2-.33.32-.51-.25-1 .19-.32-.26-.45.58-.2.13-.19-.19-.06-.39.19-.13-.26.26-.45-.32-.25.26-.2.38-.06-.06-.19h-.26l-.06.19-.33-.07-.12-.25.51-.58-.19-.32.06-.19h-.32l.13.19-.19.32-.26-.39.32-.25-.51-.13-.13-.19.06-.33-.25-.25-.26-.64.45-.2.13-.19-.07-.19-.25-.07-.39.32H265l-.13-.51.45-.13-.32-.32-.45.32-.19-.19.06-.58-.57.13-.26-.26-.64-.19-.2-.32-.51.06-.13-.32-.32.13-.26-.06-.23-.32Zm-3.66 8 .06-.13-.13-.13-.06.13.13.13Zm.9 11.05-.13.13v-.26l.13.13Zm1 3.08-.13-.13v.26l.13-.13Zm1-22.61.07.19.19-.13-.06-.32h-.26l.06.26Zm.07 22.55h-.13v.13l.13-.13Zm2.44 5v-.06l-.06.06h.06Zm.71-26.4.25-.13v-.19h-.25l-.2.19.2.13Zm.25-1.8-.19.13.07.25.25-.19-.13-.19Zm.39 1 .32-.19h-.39l.07.19Zm.38 1.35-.12-.06.06.13.06-.07Zm.2-.64.38-.32-.51.06-.13.19.26.07Zm0-2.57.06-.13-.13.06.07.07Zm.38.77.26-.45h-.19l-.26.39.19.06Zm.2 33-.2-.2-.06.2h.26Zm-.07-31.87.13.13.13-.06-.13-.39-.19.06.06.26Zm.26 1.42.06-.07-.19-.19-.19.19.32.07Zm-.32 27.81.19-.19h-.19v.19Zm.38-28.39.71-.13-.39-.32-.25.06-.13.19.06.2Zm.19 2.82V132l-.25.06.25.09Zm0 30.18v-.19l-.19.06.19.13Zm.19-2.83H266l-.06.13.25-.13Zm-.13 1.35v-.19l-.12.19h.12Zm.2-30.38.13-.13h-.2l-.19.19.26-.06Zm.06.77.52-.13.06-.26-.26-.06-.51.38.19.07Zm.13-1.35.26-.19-.2-.13-.32.26.26.06Zm0-1.48.45-.06-.19-.2-.32.07-.13.19h.19Zm.19 34.5-.06-.19h-.19l-.07.19h.32Zm-.13 1.35.71-.26-.9.19.19.07Zm.13-31.93h-.19l.06.19.13-.19Zm0 34.56v-.13l-.06.13h.06Zm.13-26.4.07-.19h-.2l.13.19Zm.26 24.22h-.19l-.07.25.26-.25Zm-.13-34.18 1 .07.13-.13h-.32l-.45-.32-.33.06-.12.26.09.06Zm.06 38.29-.12-.07v.13l.12-.06Zm0-39.57.45-.26-.19-.19-.26.06-.06.32.06.07Zm.26 3.92.13-.2-.13-.06-.32.26h.32Zm-.06 5.46.19-.2-.26-.13-.19.2.26.13Zm-.07 19.72.07-.2H267l-.13.2h.22Zm-.13 3.92.2-.07-.26-.06.06.13Zm.26-30.52-.26-.06v.19l.26-.13ZM267 159.7l.19-.2-.19-.06-.07.19.07.07Zm-.07 7.9.2-.13H267l-.07.13Zm.26-30.39.13-.25-.19-.07-.13.26.19.06Zm0 2.57v-.13l-.13.07.13.06Zm.13-1.92-.19-.2.06.2h.13Zm-.13-9.38.52-.2v-.13h-.2l-.13.2-.19.13Zm.32 34.49.13-.13-.32-.12-.13.25h.32Zm-.06 4 .06-.26-.25.13-.07.25.26-.12Zm0 1.28h.19l.07-.13-.45.19.19-.06Zm.19-6.74-.19-.07-.13.13.26.06.06-.12Zm-.26-29.17.07.26.45-.13-.13-.26-.26-.06-.13.19Zm.26 2.89.07-.19h-.26l-.07.19h.26Zm.07-4.17-.2-.2-.06.2h.26Zm0 6.74.06-.13-.19-.06-.13.13.26.06Zm.12-4.11-.12-.06-.13.12.25-.06Zm.26 35.14-.19-.13-.07.19.26-.06Zm.13-36.94.13-.26h-.26l-.13.26h.26Zm.13-1.48-.2-.12-.12.12h.32Zm-.07 2.25v-.19l-.25.06.25.13Zm0 .52.07-.2-.2-.06-.12.13.25.13Zm-.13 32.63.33-.32-.45.19.12.13Zm.13-31.29.07-.19-.26.13.19.06Zm0-3.27.39-.32.13.13.2-.06-.45-.13-.39.26.12.12Zm.13 35.84.19-.06-.25-.32-.13.32.19.06Zm.13 3.79.64-.12-.9.12h.26Zm0-38.48.13.13.19-.19-.32-.19-.06.06.06.19Zm.45 36.69.26-.07-.13-.26h-.26l-.13.26.26.07Zm0-1.61-.19.06.06.26.13-.32Zm.06-1.09.26-.2h-.45l.19.2Zm.13-33.28.07-.13-.2-.06-.12.19h.25Zm.39 37.58-.26-.06-.06.19.32-.13Zm.19-1.15-.19-.2-.26.13.26.19.19-.12Zm0-1.29-.19-.13-.13.13.06.19.26-.19Zm-.19 2.18.13-.12h-.2l.07.12Zm.45-.12-.07-.2-.13.13.2.07Zm.13-38.16H270V132h.2l-.05.15Zm.32 8.67-.07-.26.2.07-.13.19Zm.06 29.94v-.13l-.13.13h.13ZM282 125l.06 1.28v2l-.13.52.13.7-.13.33-.06 1.54.13.58v1.47l.12.2-.19.38.13.19.06.58-.19.45.13.19-.13 1.35.13.26-.19.51v.65l.13.45-.13.25v.45l.19.39v.28l-.19.25.13.26-.2.26.26.32-.13.58.07.25-.2.39.26.19-.13 1 .19.26v.38l-.19.26.07.19-.13.19.25.32-.32 1.16.32.32-.32 1 .32.32-.12.51.06.26-.13.25.19.33v.32l-.25.25.19.26-.13.19.32.39-.25.9.32.45v.25l-.2.2.07.25-.26.33.45.38-.26.52.32.38-.25.06.32.45-.26.45.19.07v.26l-.12-.13-.13.13.25.38-.25.64.38.07-.06.25-.32.13.38.26-.13.39-.32.25.07.13.38-.06.13.19-.06.71-.13.25.32.52-.19.32.06.45.32.51-.32.45.26.07.13.19h-.26l-.13.13.39.32v.25l-.32.39.38.06.07.9-.39.39.64.26v.19l-.19.19v.52l.45.25.06.26-.38.32.06.13.26-.13.51.19-.06.26.13.32.38.19-.25.45.06.39-.51.13-.13.25.06.13.26-.13.13.13.25-.19.2.19v.45l.13-.45.25-.32h-.38l-.13-.32.13-.26.51.33-.06.19.51.19.07.39.19.12.19-.06.19-.58.52.26v.32l.32.06.06-.45.58-.25h.58l.51.32.2-.19-.33-.2.07-.38.26-.07.51.13.13-.06-.13-.45.06-.26.26.13.32-.32.26-.07-.07-.25.58-.52-.38-.06.13-.32.45-.07-.25-.43.06-.32.26-.2.06-.51.26-.13-.06-.32.51-.38-.51-.07.13-.19.44-.26-.32-.26v-.32l.32-.32v-.9l.52-.25-.45-.32V160l.38-.19-.06-.26.19-.45-.45-.13.32-.58v-.51l-.19-.39.07-.25.19.12.13-.19-.2-.45.2-.38-.32-.2.12-.38.13.06-.13-.51.26-.32-.13-.26.13-.26-.26-.38.52-.52-.26-.19v-.26l-.26-.32-.06-.32.51-.32-.32-.26.2-.25-.39-.45.19-.32.26-.07-.19-.26.13-.25-.33-.45.2-.32-.07-.58-.19-.13.45-.64-.32-.32.13-.2-.26-.25V147l.26-.19-.13-.32.19-.26-.38-.26-.07-.25.32-.39-.25-.32v-.71l.19-.32-.26-.19v-.64l.26-.39-.39-.13v-.38l.32-.26-.25-.26v-.25l-.26-.32.06-.26.33-.07.19-.19-.39-.19-.13-.19-.06-.58.13-.26.26.07.12-.26-.45-.19v-.71l.26-.45-.26-.19-.06-2.12-.19-1.87v-1.92l-.26-1.22.07-.32-.2-.65.13-1.15-.13-1 .13-.45-.26-1.54.13-.13h.84l.45-.26h1.2l.83.13.45-.19.32.06.13.19-.06.39.25.39v.7l-.19.19.32.26.07.26-.32.45.19.25.19.71-.13.26.07.32-.26.32.26.13v1l-.2.2.26.19-.06.71.13.38-.33.13.39.32-.13.58.13.19-.26.26.32.19v.64l-.25.07.25.06.07.13-.26.32.39.52-.13.32.06.32-.06-.13-.19.26.25-.07.2.58-.13.84h-.2l.2.12.13.45-.07.32.13.33v.77l-.19.32.25.25-.19.9.19.45-.19.45.13.2-.26.32.32.38-.25 1 .25.38-.12.45.19.26-.19.26.25.57-.19.33.13.25-.26.26.19.19.2-.06v.58l.13.25-.13.45.13.32-.07.2.13 1.09-.13.26.13.44-.13 1 .13.19v.58l-.26-.13-.06.13.26.13.12 1.09H297l.2.13.12.58-.06.51-.19.13.19.51v.52l-.19.45.06.32-.13.9.13.45-.19.39v1l-.13.45.06.58-.25-.07-.2.2.13.25-.13.52.13.13v.25l-.19.32.06.26-.19.19.07.39-.2.19v.77l-.25.07-.13-.13-.07.19.2.07.06.32-.26.32.13.25-.19.33.13.51-.13.26-.19.06-.07.51-.45.13.07.71-.13.39-.26.12-.06.52-.32.13v.25l-.58.45-.07.32-.53.28-.13.32-.19.06V170l-.32.19v.58l-.2-.13-.12.19-.39-.25-.13.13.13.19-.32.38-.77.52-.56.2-.13-.26-.26.2.06.19-.45.38h-.64l-.19.13-.19-.13.06-.32-.13-.19h-.25l-.2-.19-.19.19.26.13.13.26-.07.25-.26.07-.45-.2.07-.32-.32.13v.26l-.13.13-1.09-.26.19-.13.19.13.19-.19-.32-.07-.06-.51-.13-.19-.38-.07-.13-.45-.45-.19v-.58l-.26-.06-.26.19.07.32-.45.19-.19-.32-.78.32-.12.26.32.07v.19l-.45-.19-.26-.39h-.58l-.13-.19.07-.26.19.26.19-.26.07-.39.32-.51-.45-.26-.32.52.38.32-.7.06-.13.2-.45-.39.13-.13.19.07.51-.26-.38-.32-.26.06-.06-.25.13-.26-.26-.26-.58.19-.13-.32 1.29-.13.12-.19-.32-.19-.51.13-.45-.26-.39.32-.19-.13.45-.64-.19-.19.58-.39-.13-.19-.64.26-.2-.45.45-.32-.19-.13-.58.13-.06-.2.13-.25.57.12.2-.06.06-.26-.26-.06-.19.13-.32-.26-.26.07-.19-.13.12-.13h.32l.19-.26h-.26l-.25-.38.64-.2-.13-.25-.26-.13-.25.13-.33-.2.45-.32.2.13.13-.13h-.26l-.32-.38.64-.39-.13-.13-.51.13-.26-.06v-.26l.45-.26-.13-.32-.32.07v-.26l.71-.13.19-.19-.19-.13-.39.13-.38-.07.12-.45h.33l-.2-.38-.45.13-.06-.45.19-.13.13.26h.26l.06-.13-.13-.19h-.25v-.39l.38-.26-.13-.51-.25-.07.12.33-.32.19-.12-.19.25-.39-.13-.13-.19-.77.26-.26.25.13.33-.25-.52.06-.25-.39.32-.38h.25l.07-.19-.2-.13-.44.19-.26-.13.13-.32.32-.13-.07-.45.45-.38-.06-.13-.58.26-.32-.2.51-.45v-.64l-.38-.19.06-.26.39-.26-.19-.38.12-.32-.19-.13-.16-.28.26-.32-.39-.84.39-.51-.13-.19.13-.2-.26-.64.13-.45-.19-.9.13-.32-.13-.26.13-.25-.33-.52.33-.32-.2-1.09.13-.26-.13-.19.13-.26-.19-.38.26-.58-.26-.71.13-.64-.13-1 .19-.32-.26-.83.2-.78-.13-.7.13-.45-.13-1.16.13-.51-.13-1 .13-.19-.13-1 .19-.23v-1.86l-.13-.52.06-1.09-.13-.25.39-3v-1.41l-.13-.52.13-.45 1.73-.06.2-.13.58.06.38-.12h1l-.08.35Zm-3.35 27.36.2-.13-.2-.12-.25.32.25-.07Zm0 1.42.13-.2-.32.13.19.07Zm.33-4.69.02-.09h-.19l.17.09Zm.19 9.57.26.06-.07-.25-.19-.13-.19.19.19.13Zm.13 1.35.19-.19-.19-.13-.26.13-.04.18.3.01Zm-.07-9.7-.19-.13v.19l.19-.06Zm-.06 6.36.13-.2-.26.13.13.07Zm-.07 1.41.2-.13-.3.05.1.08Zm.13 1.35v-.13l-.13.13h.13Zm.07 1.41.06-.13h-.19l-.07.13h.2Zm.25-4.37.32-.12-.19-.13-.19.19.06.06Zm.07 5.59.06-.19-.19.06.13.13Zm.06 2.77.19-.07-.12-.19h-.13l-.13.19.19.07Zm-.19 2.18h.19v.13l-.19-.13Zm.38-6.49-.19-.19-.13.19h.32Zm-.19 3h.19l.13-.2-.19-.06-.19.19.06.07Zm.19.64-.12.19.58-.19.06-.19h-.32l-.2.19Zm.33-4.24.13-.19-.2-.07-.19.2.26.06Zm.45 3.4-.52.2.32.13.52-.2-.07-.19-.25.06Zm-.32 1.67.06-.19h-.26l.2.19Zm.12-7-.12-.06-.13.19.25-.13Zm-.25 8.35.25.07.26-.2.32.07.07-.13-.13-.19-.32-.07-.45.45Zm.25 1.35.32-.13.13-.19-.25-.06-.45.32.25.06Zm.13-5.52.07-.2-.26.13.19.07Zm-.06 7.13-.07-.19h.26v.25l-.19-.06Zm.25-11.37.13-.13h-.25l-.13.13h.25Zm-.19 2.7.19-.13-.19.06v.07Zm.64 6.29.07-.26-.39.26h.32Zm0-5.46.2-.13-.32-.13-.13.2.25.06Zm0 1.35.26-.13-.26-.13-.19.13.19.13Zm.13 1.41.19-.19-.44-.06-.07.19.32.06Zm.77-.83-.32-.26-.26.32-.38.07.13.13.45-.2.77.2.51-.39-.19-.13-.39.26h-.32Zm-.7 2-.26-.12v.12h.26Zm.12 2.25h.26l.32-.32-.19-.13-.58.39.19.06Zm0-22-.06-.26-.06.19.12.07Zm0 6.23.07-.19-.19.13.12.06Zm.07 13 .45-.19-.13-.2-.45.13-.06.26h.19Zm-.07 4 .46.13.19-.33-.19-.12-.58.12.12.2Zm.26-16.51v-.26l-.19-.06-.13.19.32.13Zm-.13 1.35.2-.13-.2-.07-.19.13.19.07Zm-.06-3.34h-.07l.07.12v-.12Zm.13 4.69.19-.07-.19-.13-.2.13.2.07Zm-.07 1.15-.13-.06v.19l.13-.13Zm.13 10 .32-.32-.25-.07-.26.2-.07.19h.26Zm0-8.22.2-.2-.07-.19-.26.07-.06.25.19.07Zm0 .83-.19-.06.13.19.06-.13Zm.07 3.15.13-.13-.26-.06-.13.19h.26Zm.19-1.29-.19-.25-.13.19.32.06Zm.45 4.5-.51.13-.13.26.64-.13.13-.13-.13-.13Zm-.39 3.28.39-.2.06-.25-.19-.13-.26.06-.25.32.25.2Zm.07-7.13.25.06.07-.19-.13-.19-.45.12v.26l.26-.06Zm.13 1.41.25-.06v-.26h-.45l-.06.19.26.13Zm-.13 1.35.19.13.19-.26h-.51l.13.13Zm.13-3.41.12-.19-.32.19h.2Zm.12 6.17.2-.13-.13-.19-.26.06-.06.26h.25Zm0 .77.52-.32h-.52l-.12.19.12.13Zm-.12 2.7.32.39.25-.13.33-.58-.78-.07-.12.39Zm.25-1.28h.26l.06-.39-.45.26.13.13Zm.2-4.24.25-.07-.13-.26-.25.13-.07.2h.2Zm-.13 1.34h.19l.17-.14-.26-.13-.13.26.03.01Zm.25 3.15-.12.39.45.06.38-.45h-.71Zm.07-3.85-.13-.07v.07h.13Zm.38 2.89.26-.32h-.45l-.32.32h.51Zm.45 2.76-.12.39-.39.06-.13-.13.26-.45.26-.06.12.19Zm-.51-4.24.26-.06v-.26l-.32.26.06.06Zm.06.77.52-.19.13-.19-.13-.2-.58.45.06.13Zm-.06 1.42.26-.07.32-.32-.58.13v.26Zm.39 1.34-.13-.19.06.26.07-.07Zm.12-.7.26-.07.32-.32-.19-.06-.45.19.06.26Zm.26.45V170l-.19.13h.19Zm.07 1.73-.26.07.13-.26.25-.06-.12.25Zm.32-1 .32.39v.26l-.45-.07-.13-.45.06-.25.2.12Zm.32-1.73h-.13v.13l.13-.13Zm3.15-.71h-.33v.26l-.38.64-.39.07-.06-.45-.45-.13-.13.51-.19.13-.19-.13-.13-.51-.32.13v.32l-.58.38.32.13-.08.23.19.13.13-.2v-.32l.13-.19h.19l.13.58-.38.26.12.51.2.06.13-.19v-.45h.32l.19-.26v-.32l.45-.12.19.7-.06.19-.2-.19h-.32l.07.71.32-.13.06.58.45.13.13-.77-.26-.39.13-.13.2.19v.26l.38.07-.06-.52-.32-.32v-.26l.38-.32-.13-.64.64.13v.51h.13l.2-.58h-.26l-.32-.51-.24.22Zm-2.57 3.92-.33-.58-.06.45-.13-.13-.06-.44.51-.2.26 1-.19-.1Zm-.2-3.72.13-.07h-.13v.07Zm.71-.58-.06-.13.12-.13-.06.26Zm.38 3.08v-.32H286l-.13.19.19.52.26-.13-.09-.26Zm.13.58.07.51h.25l.13-.19-.06-.45-.26-.06-.13.19Zm.26-.39-.06-.25-.07.25h.13Zm1.54-1.15.19.06v-.32l-.19-.45-.25.13-.07.32.13.26h.19Zm.13 1.54.06.38.26.13.26-.06.13.19.19-.06v-.13l-.26-.07-.06-.44.45-.26v-.26l-.26.07-.38.32-.26-.13-.07-.26-.35-.12.07.77.22-.07Zm.51-1-.06-.26-.26-.06.07.45.25-.13Zm.45-1.93.07-.12-.32.06.25.06Zm-.06 1.55.13-.26h-.19l-.13.19.19.07Zm.19-2.32.13.26.32.06-.13-.51-.32.19Zm.39 1.42.06-.2h-.25v.26l.19-.06Zm0 1.6.13-.45-.2-.06-.12.45.19.06Zm.45.52.25.06-.06-.32-.19-.19-.26.45h.26Zm.58-.58-.13-.19-.07.19h.2Zm.83-6.17.07-.19h-.2l-.06.19h.19Zm1-3.66-.12-.06-.13.12.19.13.06-.19Zm.78-8.8h-.2l.26.19-.06-.19Zm.06 1.67-.06-.19h-.2l.26.19Zm.06-1-.12-.2-.13.2h.25Zm-.06 1.41-.13-.13v.13h.13Zm.64 13.94-.06-.26-.19.13.25.13Zm.39-3.73h-.07l.07.13v-.13Zm.9 1.35v-.13h-.13v.16l.13-.03Zm.45-2.7h-.13v.2l.13-.2Zm.19-1.35h.26l-.13-.19h-.2l.07.19Zm.38-19.85-.06-.19-.13.19h.19Zm0-4.56.13-.06h-.19l.06.06Zm.07 1.93v-.06l-.07.06h.07Zm.38 21.33v.13l-.12-.13h.12ZM311.1 123.72l.38.26.39-.32.25-.07.13.45h.39l.25.52-.12.19.25.26.07-.32.38-.07.07.52.32.25.13-.32.45.13-.13.32.38.13-.13.32.26.45.51.19v.45h.26l.26.52-.32.06-.13.19.19.26.45.06.45.9-.26.33.13.19.32.06.13.39-.51.13v.32l.19.19.19-.26.33.32v.52l-.45-.07v.39l.19-.06.38.19.07.26.45.57-.39.39.13.26h.26l.19.45-.38.19.12.19.33.13v.71l.25.83.26.19.06.2-.19.45.58.7h.38l-.06-.51.13-1 .13-.19.32.13v-.2l-.19-.19.32-.9-.13-.25.13-.52.19-.13-.07-.25.2-.39-.13-.19.26-.52-.13-.19.06-.58.26.32.13-.19-.13-.45.13-1.22.32.32.13-.32-.26-.13v-.32l.19-.51-.13-.26.26-.77.32-.45-.06-.26.19-1h.37l.19-.13.2.19.19.58.26-.13-.2-.71-.45-.25v-.26l.39.26.06-.78.13-.19.39.45.13-.13-.07-.45.13-.32.45.32.06-.57.2-.2.38.39.45.13.2.38-.26.39.38.38-.21.56.32.26.13-.13v-.58l-.32-.38.19-.52.45.19v.71l.13.19.19-.12.07-.65.25.26.52-.51h.26l.12-.2.07-.51.38.38-.12.71.7-.38.19.38-.12.39-.13.06-.13-.26-.19.33.12.19.52-.13.32-.26.13.2-.07.19h-.38l.06.64.13.19v-.25l.45-.13.13.19-.06.45.12.13.13.71-.06.19.19.25-.13.45.32.26-.13.52.07.32.19.19-.32.58.32.32v.26h-.13l-.06.32.26.51-.33.19.13.2.2 1-.13-.12-.07.12.13.26.13 1-.19.45.13.26-.07 1 .13.45-.19.26.13.45-.13.32h-.26l-.13.19.13.38h.31l.07.45-.26.07-.13.32.45.19.06.45-.45.07.2.32.13.64-.13.26.06.51h-.26l-.19.19.19.13.26-.13.19.52-.12.25-.2.07-.06-.26-.19.13.06.45.32.06.07.26-.13.19h-.26l.32.84h-.19l.06.58.2.19v2.25l-.45-.07.06.2.39-.07.06.52-.13.25-.19-.19-.19.13.19.32.19-.13v.58l-.19.19.13.26v.51l-.2.2.26.9-.13.25.13 1.29-.13.32.2.32-.2.45-.32.13.26.13.19.45-.13.25-.25.07-.07.13.32.32v.51l-.13.39.13 1.67-.06.57.13.45-.13.33.13.57-.07.33.13.83-.26-.06.13.12.13 2.51.13.26-.06.51v2.63l.12.58v1l-.25.26.19 1.67-.06.45.19.32-.13.58.06.25-.19.13-.77.13-.32-.13-2.57-.13-.13-1.28.07-.58-.13-1.28v-1.87l-.13-.51.13-.58-.13-.51.06-.45-.13-.52.13-.32-.13-2 .13-.38-.19-.52.19-.26-.06-.57.38-.26-.57-.64.12-.45-.25-.39v-.26l.32-.44-.13-.45.11-.24v-.39l-.13-.25.19-1.1-.13-.38.07-1.54.38-.2-.38-.14-.13-.45.13-.38.26-.13-.39-.32-.06-.26.32.06.13-.45-.33-.32.2-.57-.13-.26.19-1.61-.13-.26.26-.44-.13-.13.07-.2-.2-.19.2-.45-.13-.38-.32-.26.25-.13.07-.38-.2-.45.2-.52-.13-.19v-.51l.13-.2-.13-.38.13-.2.25.2.2-.2-.26-.06-.39-.45.07-.32.26.19.06-.19-.13-.19v-.32l-.13-.2v-1l.13-.51-.13-.26.07-1.67-.13-.26.06-.26.26.26.06-.45-.12-.13-.26.07.06-.26-.19-.26-.06-.45.19-.12-.26-.45.07-1.61.25.13.2-.64-.07-.52h-.13l-.13.26.07.51-.13.13-.13-.19v-.58l-.13-.32.13-1.74.19.13v.9l.13.19.13-.19v-1.35l-.32-.64-.13.19.26.39-.39.19.07-.38-.13-.26.06-.58-.12-.26.19-.9-.58.13-.26-.45-.32.2-.51-.65.25.9-.32.2.07.32.32.45h.32l-.06.19-.26.06-.71-.38-.06-.26-.19.45.25.39v.25l.13.13.19-.38h.2l.19.45-.07.19-.45-.13-.19.13.07.38h-.58v.45l.32.07.32.26v.51l.13.26-.13.25.06.26-.12.32-.2-.64h-.25l-.13.13.32.9-.13.25.13.45-.26.39.07-.13-.32-.32-.13.06v.26l.25.32.2-.13.19.2.06.32-.19.13-.51-.07.19.52-.26.25.32.71-.12.19-.52-.06.19.58-.12.38.06.58-.13.13-.06.83-.45.13.25.45-.12.84-.2.12h-.32l-.13.2.52.51v.26l-.45.13-.07.19.26.26-.26.25.13.26v.61l-.25.9-.2.13.07 1.35-.26.44.13.26-.07.26-.45.19.33.45-.26.26v.7l-.26.45.13.33-.39.19-.57.06-.2.13-.32-.13-1.47.2-.71-.2-.26.13-.13-.13.07-.58-.13-1.92-.39-3.09.09-.38-.52-.77.2-.13-.13-.58-.2-.19.2-.39-.32-.45v-.9l-.32-2.63-.13-.26v-.38l-.32-.45v-.52l-.2-.12.13-.26-.38-.19-.26-1.61.13-.32-.39-.52.13-.57-.32-.2.06-.7.13-.2-.32-.19-.06.13-.39-.84-.26.07-.32-.39-.06-.45h.26v-.25l-.13-.13-.07.26-.19-.13-.19-.52.19-.13-.39-.64V128l-.25-.07-.52-.51-.32.38.13.45-.26.45-.25-.13-.07.2.2.19.12.51-.19.2-.13.51.2.26-.07.13.13.19-.19.51-.26.07-.06.58h.32l.06.12-.38.13v.32l.25.13-.32.32.32 1-.13.19v1.73l-.19.2-.13-.2-.06.26.58.45-.32.39-.07-.33-.19.13.38.65v.19l-.32.13.32.9-.12.45.06 1-.13.2-.19-.07.26.52-.26-.13.13.38-.13.26.26.51v.32l-.2.33.13.77-.13.19.07 1.22-.13.45.06.58-.19.26.07.83-.13.13.13 3.28-.13.32.06.57-.26.52.07.26-.19.64.12.9-.12.19.19.83-.13.71.13.32v.45l-.19 2.08-.26.25.19.52-.06.51.13.71-.13.51.13 1-.13.32.13.58-.2.38.13.58-.26.64-.06 1.09.13.52-.07.58.13 2-.13.32.07.71-.19.45v2.12l-.45-.13-.33.13-2.05-.13-.19-.13h-.65l-.19-.45.19-.64-.06-2.12.26-.32-.13-.26.13-.71-.08-1.13.2-.9-.13-.19.13-.64-.2-.33.07-1.35.19-.19-.26-.38.2-.65-.13-.64.19-.58-.06-.32.12-2.18-.12-.19.06-.52.19-.26-.25-.57.32-.07-.2-.58.13-.45-.06-.38.13-1.86-.13-.45.19-.26-.06-.71.12-.19-.19-.45-.06-1 .32-.51-.32-.26.32-.51v-1.54l.26-.26-.45-.58.06-.26.45-.12-.19-.26v-.26l-.32-.32.25.13.26-.19-.06-.33-.33-.38.13-.64.52-.32-.13-.45h-.26l-.13-.2.13-.7-.06-.26.38-.45-.25-.26v-.25l.19-.2-.26-.64.07-.19.25-.07-.25-.7.25-.58-.32-.39.39.07-.29-.63.26-.65-.07-.25.13-1.42-.19-.45.06-.57.26-.13-.26-.2v-.45l.26.2.13-.2-.07-.25-.25-.07v-.32l.19-.13.06-.25-.19-.58.13-.26-.13-.19.07-.45.19-.19.32.25.13-.19-.03-.25-.32-.06-.45-.32.07-.26.19-.13.45.45-.13-.77-.38-.38h.25l.13-.13-.19-.39.13-1.15.51.12-.13-.38.13-.58h.26l.25.39.13-.2-.19-.51h-.32l-.19-.19v-.2l.19-.12.32.19.26-.64.38.25.26-.83.32.25v-.44l.32-.2.26.2.38-.2.26.39.07-.32.38-.32.26.12.19-.06.05.14Zm-5.4 28.59.13-.07h-.13v.07Zm1-18.37-.13-.26-.07.26.13.19.07-.19Zm.13 2.89-.07-.13v.13h.07Zm.12-5.53v-.19l-.12-.06v.25h.12Zm-.06.77h-.06l.12.07-.06-.07Zm.19-4.3.26.13-.06-.39H307l.08.26Zm.13 6.3-.06-.13.06.25v-.12Zm0-5.34.13.26.19.06-.06-.32-.19-.19-.07.19Zm.39.77-.2-.06.07.19.19.07-.06-.2Zm.06-2.63.19.19v-.32h-.19v.13Zm.19 6.23-.19-.45v.58l.19-.13Zm-.13 1.61-.06-.13v.06l.06.07Zm.26-6.62-.19-.13.06.26.2.06-.07-.19Zm0 8v-.19h-.13v.19h.13Zm0-7.07.07.33.19.19v-.39l-.13-.25.13-.2-.26.07v.25Zm.45-3.46-.32-.33-.06.26.13.32.25.13v-.38Zm-.06 1-.07-.25-.12.19.19.06Zm.25.2-.25-.2v.26l.13.06.12-.12Zm0 .7-.25-.06.06.26h.26l-.07-.2Zm-.19.9.19.45.2.07-.26-.65h-.13v.13Zm.58 1.35-.06-.13-.2.13h.26Zm-.13-4.95.19-.06-.06-.19h-.19l.06.25Zm.13 12.47h-.19l.06.13.13-.13Zm-.01-11.39.12-.13-.06-.19-.13.39.13.19-.06-.26Zm.19 6.81H309v.26l.19.06v-.32Zm.06-5.14h-.13l.07.26.19.06-.13-.32Zm.07 7.26-.13-.06v.19l.13-.13Zm.06-5.65.26.32.06-.26-.19-.19.13-.13h-.39l.13.26Zm0 10.6.13-.26-.26.07.13.19Zm.26-15.23-.07-.25-.25.06.06.26.26-.07Zm-.13 6.49-.13-.19v.21l.13-.02Zm-.06-5.59.19.2v-.39l-.19-.06v.25Zm.06 2.83v-.07l-.06.07h.06Zm.06 2v.26l.2.13.19-.2-.19-.38h-.32l.12.19Zm.32-4-.12-.07v.13l.12-.06Zm.33 1.6-.2-.51-.19-.13-.06.26.12.45.2.13.13-.2Zm.12-3 .07-.45-.19-.19-.13.52.06.19.19-.07Zm0 1h-.19l.19.19v-.19Zm.58-1.48.13-.45-.19-.06-.13.57.19-.06Zm.07.77-.13.26.32-.39-.06-.19-.13.06v.26Zm.7-.58-.19.2.19.19v-.39Zm.58-.06.07-.26-.26.07.19.19Zm.45 6.1-.19-.13.06.2.13-.07Zm.45 1.61-.19.06.06-.13.13.07Zm0-8.22h.19l.07.19-.26-.19Zm1 2.31.06-.26-.45-.26v.25l.19.39.2.06v-.18Zm-.13 5.14v-.26l-.2.19.2.07Zm.64-4.37.13-.39-.32.26.19.13Zm.58 3.53v-.32h-.13l-.07.32h.2Zm.19 9.32v.11l.06-.19-.06.08Zm.13-11 .19-.06.07-.2-.33.13.07.13Zm.45 2.06v-.2l-.26.13.13.26.13-.19Zm1.67 5.27v-.39l-.13.19.13.2Zm1 1.54.45-.13v-.19l-.13.06-.06-.19-.32.06-.2.19.26.2Zm.64-.26v-.13l-.06.13h.06Zm.39-1.28v-.07l-.06.07h.06Zm.83-.33-.12-.06-.13.19.13.13.12-.26Zm-.19 6.49v.19l.07-.19h-.07Zm.39-9.76.06-.32-.26.06.2.26Zm-.13 13.94v.19l.19-.13-.19-.06Zm.32-13.24-.19-.06v.26l.19.13v-.33Zm.58-1.28v-.26l-.45-.38-.07.19.33.64.19-.19Zm-.39 3.73.07-.26h-.2v.19l.13.07Zm.07 8.41.06-.19-.13-.13-.06.32h.13Zm.19-6.74-.13-.13-.06.19.13.13.06-.19Zm-.13 1.79v.26l.19.19.07-.32-.26-.13Zm.45-11-.26-.06.2.39.06-.33Zm.13 1.16-.39-.32.33.58.06-.26Zm-.26 3.6h-.13l.13.26v-.26Zm.13.83h-.19l.06.2.13-.2Zm-.13.84v-.07l-.06.07h.06Zm.26.32-.06-.19h-.26l.19.38.13-.19Zm.06 1.09-.32-.38.13.58.19-.2Zm0-5.78-.25.07.06.25.19.13v-.45Zm-.25 6.55.25.07-.25-.32v.25Zm.19-10.08.32.45.13-.45-.39-.2-.06.2Zm.06 6.61.2.45.19.13.13-.13-.2-.32.07-.19-.32-.32-.13.13.06.25Zm0 4.69.13.2.13-.2-.06-.25h-.26l.06.25Zm.07-.83v-.07l-.07.07h.07Zm.19-4.63v-.25H322l-.06.25.13.13.1-.13Zm.19-4.69-.32-.38.07.51.19.13.06-.26Zm-.25.65h.19l-.07-.2H322l.11.2Zm.19 6.16.19-.32-.26-.45-.19.26.26.51Zm-.07 4.44.07-.26-.26-.07v.45l.19.13v-.25Zm-.06-4.12.19.33v-.07l.07-.19-.26-.07Zm.19 1.48.2.19.12-.25-.12-.19h-.39l.19.25Zm.07-7.26v-.32l-.2-.13.07.32.13.13Zm.19.58-.39-.32v.26l.26.32.13-.26Zm-.26 5.85.2.13-.13-.39-.07.26Zm.2-3.86.06.26.19.06v-.51h-.32l.07.19Zm.12-.7.07-.13h-.19l.12.13Zm.33-3.6-.13-.26-.26-.13.06.45.13.13.2-.19Zm-.13 1.15.25-.12-.32-.71-.19.06.19.71.07.06Zm-.07.58.07.26.25.26.07-.32-.19-.45-.33.06.13.19Zm-.13 4.5.33.45.12-.32-.45-.39v.26Zm.39-8.29-.06.2.25.45.71.32.19.32.07-.26-.2-.51-.19-.07-.32.13-.26-.58h-.19Zm.13 5-.19-.19v.32l.25.13-.06-.26Zm.26-3.92-.2-.12-.13.19.13.32.26.13.06-.32-.12-.2Zm-.13 6 .13-.06-.13-.26-.13.13.13.19Zm.38-4.62-.06-.26-.19-.06-.07.19.26.32.06-.19Zm-.06 1.22.13-.26-.2-.51-.19.13.26.64Zm.38-3.53.07-.26-.26-.39.06-.25-.19.06-.06.19.32.65h.06Zm-.06 1.67.32.38-.06-.58-.2-.19-.19.19.13.2Zm.19 4.36h-.32l.13-.19.19.07v.12Zm.71-5.33-.07-.51-.19-.39.13-.38-.26-.45v-.26h-.13l-.19.32.32.32-.25.65.32.45-.07.51.26.45.19.06-.06-.51v-.26Zm-.39 2.57.13-.26.39.33-.07.19-.45-.07v-.19Zm.32-1.15.26.12-.26-.45-.19.2.19.13Zm1.1-3.92h.1l.32.38.19-.06.07-.45.32.13.13.19-.32.45-.2-.07-.38.39h-.26l-.19-.64-.32.38-.32-.38-.07-.26.19-.19.33.06.19.26.22-.19Zm-.26 3.08v-.32l-.19-.13-.13.39.13.19.19-.13Zm.26 2.83h.1l-.19-.13.09.13Zm.25-6.3.07.19-.13.13-.13-.13.06-.19h.13Zm.07 3.21.06-.64-.19-.19-.13.77.26.06Zm0 6.17v-.32l-.2.06v.26h.2Zm.06 2.83v-.26l-.19.19.06.26.13-.19Zm-.06 22.48-.13-.19v.25l.13-.06Zm.19-30.9-.13-.19-.13.26.26.19v-.26Zm0 22.23.19-.13-.25.06.06.07Zm.13-10.92h-.13l.06.25.07-.25Zm.06 1-.19-.13v.26l.19.19v-.32Zm-.06 4.88.19.07v-.32l-.13-.2-.19.13.13.32Zm.06-15.54h-.13l.07.25.06-.25Zm0-3.09-.06.26.19.13.26-.45-.32-.26-.07.32Zm0 17.73-.06-.12v.12h.06Zm.2-12.46-.07-.32-.13.26.07.19.13-.13Zm0 25.31-.2-.19v.26l.2-.07Zm.06-24.15v-.39l-.19.26.19.13Zm-.06 8.54-.13-.19v.32l.19.13-.06-.26Zm0-6.49.19-.12-.13-.13-.13.19.07.06Zm.06 7.52.13.13-.07-.39-.19.07.13.19Zm0 3.28-.13.06.13.13v-.19Zm.19 1.15-.06-.19-.26-.06.07.32.25.13v-.2Zm-.19 4.63v-.2l-.13.2h.13Zm.06-17.93-.12-.06v.06h.12Zm.07 2.06-.19.06.12.26.07-.32Zm.26 7.84.06-.26-.26-.06-.13.12.2.39.13-.19Zm-.13-4.5.06-.38H327l-.06.32.18.06Zm0 1.09h.13l-.07-.25-.13.19.07.06Zm0-13.81.25.07.13-.26-.19-.52-.06.33-.13.38Zm.25 3-.25-.13v.19l.19.13.06-.19Zm-.19 15.29.19-.06-.19-.2v.26Zm.13-3.47.19-.06-.13-.2-.12.2.06.06Zm.19-8.8-.06-.26-.07.26h.13Zm-.13 3.92.07.19.19.07-.13-.39-.13.13Zm.2 5.59-.2-.07.07.2.13-.13Zm.06-7.52v-.19l-.19.13.13.25.06-.19Zm.07 3.08-.07-.25-.13.19.13.13.07-.07Zm0 8.93h-.2l.07.2.13-.2Zm-.13-7v.26l.45-.13.06-.26-.45-.06-.06.19Zm.25-.9h-.12l.06.13.06-.13Zm.13 2.44-.19-.06v.06h.19Zm0-.57.13-.13-.26.06.13.07Zm.07-10.41-.13-.26.06.26h.07Zm.06 15-.13-.26-.06.26.19.26v-.26Zm.06-17.15h-.19l.07.19.12-.19Zm-.06 2.83h-.13l.13.19v-.19Zm.06 1h-.19l.07.32.25-.12-.13-.2Zm.07 14.2-.26-.06.19.25.07-.19Zm.06-20.94v.25l-.13.13-.12-.45.25.07Zm.13 17.6v-.26l-.26.07-.06.25.19.13.13-.19Zm0 4.24-.26.06.13.2.13-.26Zm0 7.84v-.2l-.19.13.19.07Zm-.13-15.55.2.06.12-.25-.12-.19-.2.06v.32Zm.13 9.06v-.3l-.13.06v.26l.13-.02Zm.19-8.55h-.25l.19.26.06-.26Zm-.06 4 .06-.26-.19.06v.2h.13Zm.06-14.26h-.12l.06.19.06-.19Zm.13.9v-.13h-.13v.13h.13Zm0 10.79.07-.26-.2.07v.19h.13Zm0 3.6v-.2l-.13-.06v.19l.13.07Zm.13-12.15v-.12l-.19.12h.19Zm.13 9.38-.19-.06-.07.13.2.13.06-.2Zm.19-13.94-.19-.25-.06.25.12.2.13-.2Zm-.17 19.71.07-.19h-.19l.12.19Zm.13-4.49-.06-.2-.13.13.19.07Zm-.13-3.73.13.19.52-.06-.52-.32-.13.19Zm.07 4.56.19.26.13-.19-.13-.26-.26-.06.07.25Zm.26 6.56v-.2l-.2.07.2.13Zm0 1.22.38-.26h-.58l.13.13.07.13Zm.12-11.25-.12-.25-.13.19.06.26.19-.2Zm-.06-8.48v-.32h-.13v.32h.13Zm-.06 1.22.19-.06V132l-.13-.2v.52l-.06.07Zm.25.9-.13-.51-.12.71.25-.2Zm-.06 7.39v-.19l-.19-.13.12.51.07-.19Zm.06-5.65-.13-.19-.06.25.13.2.06-.26Zm.32 1.16-.25-.39-.2.19.07.26.19.13.19-.19Zm-.32 9.12h-.13l.13.13v-.13Zm.19-8.29.07-.19h-.26l-.06.25.19.2.06-.26Zm-.06 9.32h-.13l.13.12v-.12ZM367.3 152.44l-.06.19.71.26-.2.32.58.38-.13.2h-1l.51.45.58-.26.58.32.58-.06.13.19-.2.13-.38-.2-.58.33-.45-.33-.26.2.58.51-.19.19-.71-.19.19-.26-.06-.25-.51-.2-.2.2.33.13.12.38-.19.26v.26l.32-.2.19.07.2.7.45.26v.26l-.45.06-.26-.32.06-.19-.12-.2-.45-.19-.26.07.06.38.33-.06.12.19-.12.45-.52-.26v.45l.32.07-.19.45.13.32h-.52v.45l-.32-.07-.19.26.07-.32-.33-.39-.25.07-.13.19.32.13.13.26-.07.25h-.25l-.32-.25.12-.26-.64-.39-.25.13.12.26.26-.13.13.19-.13.39-.38.06v.2l.83-.07.19.26-.13.19-.83-.26-.13.39-.39-.26h-.19l.07-.32-.13-.19h-.32l-.45-.71-.13.26.06.26.45.32.07.38.25.13.26.84-.38-.2-.33.39-.32.06-.19-.32-.71.32-.19-.19V160l-.45-.19-.13-.26.07-.19-.2-.19-.19.13-.06.45.13.19.32.06.06.45.32.45-.13.13-.32-.45-.38-.25h-.32l.13-.39-.26-.13-.13.64h-.39l-.06-.51h-.32l.13.26-.2.06.33.26-.07.32-.19.13-.26-.45-.32-.07-.13-.45-.32-.19-.19.19.13.2v.32l.51.25-.19.2-.07-.2-.64-.19-.26.39-.38-.13-.07-.26-.51-.19v-.51l-.19-.13-.32.38.12.32h.33l.06.52-.13.19-.19-.06v-.26l-.45-.58v.26l-.32.51.13.58-.32-.39-.26.58h.38l.13.19-.06.2-.32.25.06.13h.26l.19.32-.13.26.2 1-.33-.13-.77.45.13.13.71-.13.19.45-.19.19-.58-.25-.19.12.51.39.32-.13.2.13.06.26-.39-.07-.51.26h-.32l.19.19.45-.19.52.26-.13.32.38.32-.32.26-.32-.13-.19.25.32.07.38.32-.25.32.38.32-.51.32.32.39-.19.26-.77-.33-.33.26h-.38l.13.26.45-.19.77.19.19-.13.19.19-.06.26-.39-.06-.12.19.45.45-.33.45h.33l.06.32-.39-.07-.45.26h-.32l-.32-.19v.13l.45.32.77-.13.13.26-.58.06-.83-.13-.26.13-.45-.13-.83.13-.26-.13-.51.07.12-.32-.38-.45.13-.2.7-.06-.45-.39.07-.38-.52-.32.07-.2.26-.12.38.19.13-.13-.45-.32-.06-.26.57-.26-.19-.12-.26.06-.45-.26.2-.12.51.12.19-.12-.51-.39.06-.32-.45-.39v-.19l.26-.13.32.13.26-.13-.13-.19-.26-.07-.1-.2.06-.26-.32-.32v-.25l.32-.13.19.32.84-.45-.13-.13-.84.13-.12-.26.12-.25.52-.07.25.19.33-.06.19-.19-.13-.13-.77-.06-.13-.2.58-.25-.13-.2-.26.13-.51-.19.06-.58-.32.06-.06-.25.32-.32.19.19v.26l.19.25.13-.19v-.39l-.45-.32.07-.45h.19l.19-.64.2.07.19-.2-.13-.19-.26.26-.38.06-.07.45-.25.07-.07-.26.32-.39-.25-.32.64-.32.32.26.32-.19.19.06.13-.19-.13-.13-.32.19-.38-.06-.2-.26-.44.19-.2-.13-.06-.25.26-.07.44.2.71-.26-.32-.32-.64.19-.19-.39.57-.25-.13-.26.45-.32h.26l-.38-.32-.52.25-.13-.19.32-.32.26.13.64-.26.07-.19-.71.19-.26-.45.45-.19.2.19.45-.06-.32-.07-.2-.25-.32-.07-.32.2-.38-.33.12-.19.77.07.58-.13.26.19.77-.26.26.26.51-.13.19.13.13.51.2.13.32-.25.12.12v.52l.2.19.19-.32-.06-.26.19-.13.19.13.19.58h.45l.07.64.45-.06-.26-.19.13-.13-.07-.19-.25-.13v-.32l.13-.2.25-.06.13.45.13.06.13-.19.13.13.38-.39.26.65.26.06.32-.58h.23l.33.39.25-.13-.19-.45.13-.19.13.12v.26h.38l.26.71.19-.07.07-.45-.39-.32.13-.45.19.07.39.58.32-.13.13.83h.32l.06-.25-.13-.52-.32-.06-.06-.39.19-.19.19.13.07.51.26.07.51.83.26.13-.07-.77-.38-.19v-.39l.45-.13.06.58.19.19.52.2.25-.13-.19-.52-.19.2-.32-.2.19-.32-.39-.26v-.19h.39v.26l.19.19.32.07v-.71l-.19-.39.07-.19.51.07-.26.06.07.45.45.06-.2-.64.07-.26h.38l.2.33.25-.26-.45-.39-.25.07.25-.32-.06-.45.71-.26h.32l.13.13.38-.13-.71-.45.13-.13.45-.06.45.19.19-.13-.7-.51.06-.2-.25-.12-.13-.26.06-.19.77.12-.09.19Zm-15.54 6.49v.12l-.07-.12h.07Zm.26-7.13-.13.06-.13-.13.13-.19.25.06-.12.2Zm-.13 1.34-.13-.12.13-.13.19.06-.19.19Zm0 4.18-.13-.06.13-.26.25.13-.25.19Zm.19 1.28-.19.13-.13-.19.13-.32.19.13v.25Zm-.06 5.53-.26-.13.06-.26.2-.12.19.12v.26l-.19.13Zm4-38.74-.13 1-.13.19.13 1.28v3.34l.13.84v1.35l-.13.9.06.32-.32.26.45.7.32.07.52-.2.38.26.26-.19.64-.19.13.06.51-.13.58.32.13-.13v-.25l.45-.19v.32l.65-.32h.35l.13.32h.25l.39-.26h.23l.32.32.58-.25.26.06.38.58.26-.39.19.13v.26h-.38l-.07.19.32.39.14-.35.9.32.52-.19v.45l-.39.19.45.26.19-.19h.33l.77.38v.26l.64.45-.32.19v.26l-.45.38.19.13h1l.64.32-.26.13-.45-.13-.45.07-.12.19.06.13.26.06.25-.25.39.32v.45l.51.32-.06.26-.39.25.13.13h.58l.13.19-.39.45-.13.45h-.44l.06-.38.26-.07v-.38l-.78.32.13.26-.13.45.46-.13-.07.25.32.07.71-.39-.19-.32h.7l.07.19-.45.39.06.32-.32.26-.51-.32-.32.06-.46.32.26.2-.19.25.19.13.26-.13v-.25l.32-.2.32.2.19-.13h.58l.13.19v.32l-.38.13.06.26-.71.45.13.25-.13.2-1-.13-.44.19.12.19.39-.19.77.32.32-.19.64.26.26-.13h.45l.13.32-.51.06-.2-.13-.32.07-.19.19-.39.13.2.13.64-.19.32.25-.32.26-.45-.13-.39.07-.13.19-.64-.52.45-.19.13-.19-.06-.13-.65.26-.13.51.07.19h.27l.38.26.64-.26.33.32.77-.12v.33l-.77-.06-.45.13-.65-.2-.25.2-.58-.39-.26.39-.26-.07-.38-.38.45-.2.13-.19-.13-.26.13-.19.25.07.2-.2-.2-.25-.25.25-.39-.06-.26-.39.58-.38-.19-.13-.39.19-.25-.06v-.26l.19-.26.19.13 1.22.19.45-.06.39-.32-.13-.13-.38.26-.52-.39-.58.32-.64-.38-.39.08v-.19l.26-.06-.26-.39.06-.19.39-.32-.13-.2-.71.07-.06-.2.32-.19V142l-.13-.19.2-.19-.07-.2-.26.13-.19.39-.26.06v-.26l.26-.25-.13-.2-.38-.19.13-.13.7-.06.07-.19-.13-.2-.19.13-.45-.06-.2-.2-.38.2-.39-.07-.19-.77-.32-.06-.19-.19-.65.06-.19-.19.06-.26-.25-.06-.77.12-.58-.32v-.25l-.19-.2-.26.07-.13.45-.45-.2-.13-.32-.19-.13-.19.13-.07.52-.45-.13-.06-.58h-.26l.13.39-.64.25-.45-.64-.19.19v.45l-.39.07.06.32-.51.19-.58-.45-.06.52-.52.19.39.26-.45.25-.13.19.26-.06.19.13.19.38-.45.26.26.32-.06.2.19.44-.19.39.13.26-.13.25.13.52-.13.26-.39-.26-.19.13.13.19.45.19-.52.64h.58l.19.45-.19.13-.19.45.45.65-.07.19-.25.06-.39-.25-.19.19.58.38-.13.26.26.32v.26l-.26.32.19.19-.19.32.26.45v.26l-.33-.19-.77.13-.19.12 1.16.39-.2.32-.25.07-.39-.13.32.38.39-.13.19.2-.19.45.06.38-.25.19-.07.2.32-.07.13.13-.06.19h-.26l-.06.2.19.38-.19.13-.39-.19-.45.19-.51-.06v.19l.25.13.32-.07.78.26.19-.13.19.19-.06.26-.26-.13-.51.2-.33.64-.89-.26-.2.13-.7-.19-.45.19-.2-.19.07-.32.51.12.77-.25-.13-.26-.38.13-.64-.19.12-.2.84.07.19-.26-.9-.19-.25.06-.2-.26h.77l.58-.38-.32-.13-.19.13-.71-.06.32-.33.45-.06.39.13-.07-.19-.19.06-.26-.32-.64.26-.25-.32.19-.19.52.07.45-.2.7.13.65-.13-.13-.25-.71.25-.26-.25-.51.19-.39-.32.33-.26.45.19.06-.12-.45-.39-.45.19-.19-.06-.07-.32h.58l.19-.13-.32-.13-.13-.32-.51.05-.06-.19.25.06.45-.25.65.19.32-.19.57.19.26-.13-.64-.38-.51.25-.33-.25-.7.19-.19-.45h.83l.19-.13-.32-.06-.32-.52.55-.33-.13-.13-.7.13-.19-.45.57-.13.26.26.58-.32-.13-.13-.51.19-.75-.42.44-.13h.71l-.13-.19-.45-.19-.38.12-.19-.12.38-.39-.13-.26.52-.19.51.06-.45-.38-.71.13-.12-.26.06-.32.38-.13-.19-.26-.45-.06.26-.45-.13-.45.45-.26v-.45l-.38-.32.06-.25.64-.13-.7-.52.38-.19-.32-.26-.06-.32.25-.13.45.13.19-.06-.57-.32h-.26l-.13-.13.51-.13.45-.32-.38-.13-.32.26H352l.13-.65V137l.32-.19-.45-.26.07-.83.12-.2.26-.06-.38-1 .32-.32-.2-.32.58-.32.58.06-.58-.32-.38.13V133l.51-.13-.32-.13-.13-.26.06-.25.2-.13.45.19.25-.13-.12-.19-.52-.13-.38.13-.07-.26.32-.25-.25-.39.06-.19.39-.32-.07-.13h-.38l.06-1 .32-.19h-.38v-.39l.25.07-.06-.26-.19-.13-.07-.9.13-.26-.13-.7.07-.45.32-.13-.32-.39.32-.64 2-.19.2.13.32-.07.77.2.02.26Zm-4.18 25v-.19h.16l.07.19h-.23Zm.2-5.72.06.2h-.19v-.2h.13Zm0 2.83-.13.13v-.13h.13Zm.12 6.87-.25.2v-.32l.25.12Zm1.55-.19.25-.06.45.19.26-.13.58.19.32-.06.13.13-.13.13h-.26l-.32.25-.19-.06-.13.13.13.13.45-.13.45.26-.13.45-.84-.33-.38.2-.45-.26-.39.32h-.25l.12.19 1.29-.12.51.32-.13.19h-.45l-.19-.26-.32.26h-.45l-.19-.19-.52.19-.32-.19v-.2l.26-.38-.45.13-.19-.07v-.51l.51.13.32-.2-.83-.45.64-.25.51.19.33-.13Zm-1.16 12.91.51.2.13-.13-.71-.32-.19.19.26.06Zm-.19 2.57.51.32.26-.06-.07-.19-.7-.19v.12Zm.12-34.11.13.2.2-.2h-.33Zm.26 4.76.19-.13-.19-.13-.19.19.19.07Zm-.13 5h.26v-.2h-.32l.06.2Zm.26-10.54-.13-.13-.13.13h.26Zm-.06 24.28.19-.12h-.39l.2.12Zm0-22.16h-.13l.06.13.07-.13Zm0 5.59-.07-.13-.06.13h.13Zm0 .19h-.13v.26l.25.06-.12-.32Zm-.07 19.66.26-.19h-.26v.19Zm0 3.47.13.13.26-.07-.32-.25-.07.19Zm.19-29.74-.12-.07v.13l.12-.06Zm0 7.77.07-.13-.19.07.12.06Zm.07 27.37-.25-.07v.13l.25-.06Zm0-4.95.13-.19-.32.19h.19Zm.2 1.48-.13-.2-.2.13.33.07Zm-.26.83.19-.06.07-.2-.33.07.07.19Zm.32.77.26-.06.25-.26h-.45l-.25-.19-.2.13.39.38Zm-.19-10.4.32-.13-.13-.13-.26.06.07.2Zm.13-17.93-.07-.19-.06.19h.13Zm.19 13.81-.07-.32-.19.07-.06.19.32.06Zm-.26-9.63.19-.19h-.19v.19Zm.19 2.7.13-.2-.19-.12-.13.25.19.07Zm-.19 1.47.19.13h.52l.38-.19-.32.06-.64-.25-.13.25Zm.26-5.58.26.06-.39-.32-.06.13.19.13Zm.13 19.91-.26-.06-.06.12.19.13.13-.19Zm-.26-2.12h.26l-.13-.19h-.13v.19Zm.19 4.88-.19-.13.06.13h.13Zm-.06 4.18.13-.13-.26.06.13.07Zm-.07-1 .2.26.32.13.13-.19-.32-.07-.33-.13Zm.2 1.35-.13-.06-.07.19.2-.13Zm.25-5.84.13-.26-.32.06-.13.2h.32Zm0-15.29-.19-.07v.26l.19-.19Zm.2 1.28h-.2l-.19.2.07.12h.64l-.26-.12-.06-.2Zm-.13 1.09.06-.19h-.25l-.07.19h.26Zm-.19 1.35h.35l.45-.32-.2-.13-.64.26.04.19Zm.19 1.48.06-.19h-.25l.19.19Zm.06 9.06-.25.26.19.19.64-.26v-.25l-.32.12-.26-.06Zm-.06 2.25.25-.07-.25-.13-.19.13.19.07Zm.19-4.69-.19-.13-.13.13.13.19.19-.19Zm-.06 4.17v-.13l-.26.07.26.06Zm0 1.29-.26-.07v.26l.26-.19Zm-.07-20-.13-.07.07.19.06-.12Zm.19 15.93.26-.2-.58.07.07.26.25-.13Zm0 .51-.25-.13-.07.2.2.12.12-.19ZM354 169l-.07-.13-.06.13h.13Zm.06 1.41-.13-.12v.12h.13Zm.26-25.76.13-.25H354l.12.13.2.12Zm-.26 23v-.06l-.06.06h.06Zm.19-19.72.13-.19-.19-.07-.13.2.19.06Zm.13 6.94.07-.13-.2-.13-.13.26h.26Zm0 11.5-.26-.07.2.26.19-.13-.13-.06Zm.07-14.26.38.19.13-.19-.19-.13-.32.06-.13-.19-.13.19.26.07Zm.06 4.94-.13-.13-.13.13h.26Zm-.13 4.24.13-.06-.06-.19-.2.06.13.19Zm.13 1.09-.13-.12-.13.19.26-.07Zm-.06-2.11-.07-.2-.06.2h.13Zm.06 1.28-.19-.06v.19l.19-.13Zm.13 2.25-.13-.13-.13.13h.26Zm-.07 3.27v-.19l-.19.13.19.06Zm-.12 2.7.25.07-.13-.26-.19.06.07.13Zm.12-21.58.2-.2h-.2v.2Zm.13.38-.13-.06v.06h.13Zm.13 2.89.26-.12-.13-.2-.39.2.26.12Zm0 18.89h-.13l-.06.19.19-.19Zm.26-6.74-.07-.2-.19.2h.26Zm.06-15.55.2-.26-.26.07-.19.25.25-.06Zm.45 5.78-.13.19h-.19l-.32-.38h.51l.13.19Zm-.45 14.65-.06-.13-.13.13h.19Zm-.06-19.6.26-.06.06-.19h-.26l-.13.13.07.12Zm.06 17.54.26.19.19-.19-.38-.26-.2.07.13.19Zm.2-20.43v-.19l-.26.07.06.19.2-.07Zm.06 4.69-.26-.13-.06.2.32-.07Zm0-9.7-.13-.19-.13.19h.26Zm-.13 4.18.07-.19-.2.12.13.07Zm.07 11.88V157l-.2.13.2-.08Zm0-1.28v.13l-.13-.13h.13Zm0 12h-.13l.06.19.07-.19Zm.32-12-.07.19-.06-.26.13.07Zm.06-23.77-.13.06.13-.06Zm.19 26.14.2-.25-.45.32.25-.07Zm.2 1.29v-.32H356l-.13.38.25-.06Zm.19-.71.26.07-.07-.39-.32.07.13.25Zm.26.39.13.58.25.06.39.58.25.06.07-.25-.13-.32-.32-.2-.07-.51-.44-.26-.13.26Zm.25-21.91-.06-.19-.06.19h.12Zm.07 21 .19-.13-.13-.38-.19.38.13.13Zm.32.51.13.2.25.06.07.39.51.25-.19-.25-.07-.45h-.25l-.13-.65-.26.07-.13.19.07.19Zm.32-19.53-.06-.19.25-.06.13.25h-.32Zm.19-3.4h-.06l.06.13v-.13Zm.77 21.2-.19-.13.19-.13.2.07-.2.19Zm-.19 1.8.06.25.26-.12.07-.45-.2-.07-.19.13v.26Zm.51-21.59.07-.25h-.26l.19.25Zm-.06 20.88.06.26.39.06.13.58.32.13.13.58.19.13.19-.13-.06-.45-.39-.26-.06-.58.64-.06-.38-.52-.2-.06-.12.64h-.26l-.45-.77-.19.13.06.32Zm0 1.41.26.07.13-.26-.2-.26h-.25v.26l.06.19Zm.13-23.38-.13-.19v.19h.13Zm.64 20.88-.19-.07.19-.19v.26Zm0-20.94.26.13v-.45l-.19-.07-.13.19.06.2Zm.32 3.08-.19-.13h.19v.13Zm.39 21.65v-.26h.26v.26l-.2.13-.06-.13Zm.38-2.19.07.26.25-.45-.19-.06-.13.25Zm.65-20.74-.07-.13-.13.13h.2Zm.32 21v-.13l-.26-.06.13.26.13-.07Zm.12-22.8.33-.26h-.33l-.19.13.19.13Zm0 2.37-.12-.06v.19l.12-.13Zm0 20.75-.12.2.06.25.26-.32-.2-.13Zm.13-22.1h-.13v.13l.13-.13Zm0 21-.13-.06.07.19.06-.13Zm1-20.88-.2.2.2.12v-.32Zm0 1.87V139l-.13.06.13-.01Zm0 20.49h.32l-.07-.19-.25-.07-.13.13.13.13Zm.13-20.88-.2-.13.07.19.13-.06Zm.83-1.22.13-.13-.07-.13-.19.13.19.39-.06-.26Zm.19 1.16-.19-.07v.19l.19-.12Zm.45-.45.07-.2-.19-.12-.2.12.32.2Zm-.06 1.41-.19.26.19.06.13-.19-.07-.19.32-.33-.44.13.06.26Zm.13 20h-.07l.07-.13v.13Zm.25-22.16.2-.06-.13-.2-.26.07.19.19Zm-.06 1.35.26.06.06-.19-.19-.13-.26.07.13.19Zm-.06 1.35.06.13.77-.32h-.71l-.12.19Zm.25 17.15.13.19.52.13v-.32l-.2-.13-.19-.38h-.32l.26.25-.2.26Zm.32-17.79.2.06.38-.32h-.64l.06.26Zm.71 17.53h.09l-.19.32.45.45.25-.06.13-.19-.58-.52.07-.25-.19-.26h-.45l.12.45.3.06Zm-.19-18.18.26-.19-.13-.26-.2.07-.06.25.13.13Zm.45 1.29.13-.19-.58.12v.13l.26.13.19-.19Zm-.26 3v.13h-.13v-.13h.13Zm.19 13 .26.39.19-.45-.38-.32-.32.25.25.13Zm.07-2.44-.26-.19h.39l-.13.19Zm.38.84-.57-.2v.26l.51.26.13-.13-.07-.19Zm-.25-16.32.51-.19-.19-.13-.52.13.2.19Zm-.07 1.35.26.13.32-.39-.19-.13-.45.07-.07.19.13.13Zm.58.9.06.19-.19-.06-.51.13v.31l.25.07.45-.26.52-.77-.52-.13-.25.39.19.13Zm-.32 1.93.38-.13-.06-.32-.64.25.06.26.26-.06Zm0-1-.19-.06-.07.13.26-.07Zm-.26 4.76V146l.32-.26.13.2-.06.32-.2.13-.19-.27Zm.58 6.81-.19.12-.32-.25.19-.13h.32v.26Zm-.39-13h-.06l.06.06v-.06Zm.65 7.19.19.13h1.35v.45l-.39.19.13.26-.38.25-.52-.25-.32.25-.45-.19-.06-.26.51-.19.32.26.55-.02.19-.19-.32-.32-.32.26h-.32l-.13-.26-.19-.06-.45.19-.13-.32.19-.13.39.13.16-.18Zm-.65 4.37.13-.19.2.12-.07.26-.26-.19Zm.13 4h.26l-.13-.38-.26.06.13.32Zm.71-12.78-.58.32.13.26-.26.38.32.07.26-.52.32-.32-.19-.19Zm.26 6.36-.32.13.19.19.38-.13.58.26-.13.32.13.19.19-.06.2.19-.07.32-.25.06-.26-.25-.26-.07.1-.22-.13-.2-.45-.12-.45.06-.19-.19.39-.45-.2-.2-.32.13-.13-.19.07-.19.25.13.45-.2.39.32-.16.17Zm-.84 9.38.07.25-.2-.06.07-.19h.06Zm-.06-16.77.25.19.52-.19.19-.26-.45-.13-.45.13-.06.26Zm.19 8.61-.19.06.13-.19.06.13Zm.19.38h.32l-.12.32-.26.07-.32-.39.13-.19.25.19Zm.26-9.57.74-.1.13-.19-.2-.19h-.32l-.45.19-.06.26.16.03Zm0 1.41.13-.12-.19-.13-.13.13.19.12Zm.38 7.91h-.44l-.13-.26.45-.13.25.13-.13.26Zm.07 1.35-.19.12-.39-.19-.06-.19.45-.13.19.06v.33Zm0-13.05-.51-.32v-.13h.57l.13.2-.19.25Zm-.26 5.21.07-.19-.2-.07-.12.19.25.07Zm-.13 2.63.07-.13h-.19l.12.13Zm.39 10.79h-.19l.06-.25.13.25Zm2.38-6.16-.9-.07-.26.13-.39-.26-.25.2-.29-.19-.39-.06-.06-.26h.26l.58.26.7-.19.45.25.45-.12.2.12-.1.19Zm-2.19-10.86.2-.19h-.33l-.13.13.26.06Zm-.19 11.82.32.13 1.16-.07.19.13-.26.32-.7-.25-.58.32-.2-.58h.07Zm2.44-3.08-.64.25-.58-.32-.39.2-.64-.33.52-.25.51.25.51-.19.84.19.13.13-.26.07Zm-1.63 6.93-.57-.19v-.19l.13.06.25-.12.26.06.13.19-.2.19Zm.84-4-.39-.32-.38.19-.58-.25.39-.26.51.19.45-.06.39.38-.39.13Zm-.06 1h.32l-.2.45-.25-.45-.65.32-.38-.26-.13-.26 1 .13.2-.13.09.2Zm-.84-9 .26-.06.32-.32-.26-.13-.45.32.13.19Zm1.8 5.53-.06.25-.26.13-.45-.19-.39.32.26.13.26-.06.58.12.12.13h-.45l-.32.26-.77-.39-.32-.7.71-.13.25.13.78-.07.06.07Zm-1.09 4.37h-.26l-.45-.26.19-.19.52.06.13.19-.13.2Zm.7-6.17-.51.19-.06.32-.52.19-.26-.38.45-.13.2-.19-.13-.26.26-.13.64.2-.07.19Zm-1 7.26h.25l-.06.19-.52-.06.07-.2.26-.06v.13Zm-.13-15.1-.13.07v-.2l.13.13Zm.58 5.14-.2-.45h.52l.13.26-.13.25-.32-.06Zm.06-4.3-.19.06.06-.19.19-.07-.06.2Zm.64 7.77-.64-.26.64-.13.2.32-.2.07Zm-.19-4.18-.32-.25.26-.13.25.13-.19.25Zm.19 8.1-.13.13-.19-.13.19-.2.13.2Zm.39-6.1h-.13v-.2l.13.2Zm.06 1.34-.06.2-.07-.2h.13ZM377.9 138.05h.26l.45.38.19-.19-.83-.51.25-.2-.12-.19h-.26l-.26-.26.13-.32-.13-.19.07-.45.25-.38-.25-.07.12-.38.33-.2-.1-.09.25-.32-.45-.06v.51h-.25l-.13-.13.06-.25.26-.13-.19-.26.19-.25-.32-.26v-.45l.32-.07.19.26h.26l.06-.13-.64-.32.19-.32-.57-.51.06-.26-.19-.39.13-.25.32.19-.26-.51-.06-.52-.2-.32.2-.19.25.13.26-.07-.71-.64-.19-.64-.19-.13.13-.19.45-.13-.52-.9.39-.45-.13-.58.06-.26-.25-.32.32-.19-.13-.39.26-.12.45.19.64-.19.58.06.38-.19.58.32.45-.32.45.13.06.12.52-.25.32.38.38.13.07-.45.38.07.33.45.19-.13.06-.32.39-.2.13.32.45.13.32-.38.64.51.13-.51.25-.07.26.13.07.32.25.13.13-.19V125l.19-.07.45.2.07.25.32.13V125l.38-.07.33.39.25-.13.07-.32.58.13-.07.25.13.26.45-.58h.32l-.13 1-.13-.2-.06.26.13.19.25.07v.58l-.32.06-.13.26.2.25.32-.06v1l-.26-.13-.26.13-.12.51-.39-.06-.13-.45-.19-.13-.19.06-.13.45-.39.07-.13-.32h-.5l-.12.32-.2-.13-.19-.39-.45.2v.25l-.45.07-.32-.39-.26-.06v.38l-.19.13-.26-.06-.32-.71-.13.19-.06.52-.45.06-.26-.51-.25.45-.9.13-.45-.07-.84.26-.13.83.39.07-.13.45-.32-.07-.19.13.25.07.39.7.06.45-.19.07-.26-.2v-.38l-.38-.07.19.58-.19.2.51.19.07.19-.65.39.33.25-.2.26.45.39-.13.19h-.32l-.06.26.26.64.32.32-.2.19h.39l.19.39-.13.19-.64.06.32.45.32.07v.9l-.51-.07.19.32h.32l.2.2-.13.19v.32l.19.45v.45l-.26.26v.7l.32.26-.19.51.32 1-.06.32.13.2.13-.26h.38l.06.38.84.65.13-.32-.45-.2.06-.58h.26l.39.84.25-.26.26.32.26.07-.26-.52h-.26l.13-.06.07-.26.19-.06.19.13v.32l.32.26.26.51.13-.19-.19-.71.06-.26.45.2.13.38h.19l.38.71.26.06v-.51l.13-.19h.26l.06.25.39.39.25.06.13.52.2.12.12-.25-.06-.26-.39-.26-.06-.45.51-.64h.2l.06.32-.32.65.51.83-.51.26.19.45.26.13.19.64-.38-.19-.26.06-.19-.58h-.2l-.32-.64-.25-.07v-.57l-.45-.07v.2l.25.06.26.71v.32l.45.06.06.71-.45-.13-.25.32-.65-.19-.38.26-.45-.07.06-.19.26-.07.07-.45-.2-.12-.13.45-.38.12-.32-.32-.19.13.25.39-.45.06-.38-.19-.13-.26-.26.13.07.32-.52-.13-.77.07-.19-.13-.26.13-.19.45-.32.19.19.26-.19.19.38.26.07 1.67-.13.25.13.39-.32.13.25.19.13 1-.06.51.25 1-.19.2.13.19.13.77-.19.26.25.38-.06.77-.19.39.32.64v.26l-.32.38.32.2v1.92l-.13.33.19.64-.06.77.12 1.8-.06.45.13.9-.07.51.2.9-.11 1.13.13.45-.2.64.2.45.32.33.77-.13.45.25.19-.19h.9l.39-.19.19.13.06.25.2.13.19-.13.06-.25.45-.13.2.38h.25l.13-.38h.32l.2.13.06.25h.26l.25-.45h.26l.32.45.26.13.32.58.26.06v.24l.19.39.19.06.39 1-.07.26-.19-.13-.13-.58-.38-.06-.07-.71-.38.33.06.19.39.25.06.58.39.32.38.71-.19.07-.51-.2-.26.2-.52-.13.13-.13.26.06.19-.45-.32-.45-.19.2-.07.51h-.38l-.13-.45-.58-.39V170l-.25.13.06.25.32.33v.29l.58.52-.19.19-.32-.06-.07-.26-.45-.07-.06-.45-.2-.12-.19.19.13.38.26-.06.06.51-.45-.06-.32-.32-.38.32-.39-.06-.07-.33-.44.33-.52-.07-.32-.19-.19.26-.26.06-2.5-.06-1.61-.26-.32.06-.32-.13-.45.2-.39-.2h-.32l-.13-.19.26-.19-.07-.64.13-.45-.19-.45.06-.2-.12-.25.12-.52-.06-1 .13-.51-.13-.9.13-.39-.13-2v-2.13l-.13-.58.13-.9-.19-.58.19-.32.06-.45-.25-.64.19-.84-.32-.51.26-.32-.26-.26.06-.84-.12-.25.12-.77-.12-.9.12-.26-.12-1 .06-1-.13-.32.13-.45-.13-.26.07-.26-.2-.7.2-.2v-.51l-.2-.51.2-.2.32.2.19-.2-.64-.32-.13-.83.26-.26-.33-.77v-.26l.33-.45v-.32l.12-.19-.45-.45v-.26l.26-.13-.03-.43-.2-.32-.06-.9.45-.06-.13-.26-.26-.13v-.45l-.19-.64.52.07-.39-.65.06-.32-.19-.19.07-.32h.64l-.58-.39-.13-.83.39.06-.2.2.1.18Zm-.51-5-.19-.13.19-.06v.19Zm.58 3.66.19-.06.26.19.25-.13-.13-.25-.64-.07-.13.19.2.13Zm.13-4.56.19-.06-.19-.19-.2.19.2.06Zm0 1.61h-.1l.13.19-.03-.19Zm.38 12.65-.06-.19-.2.07.26.12Zm-.13-1.28.26-.07.06-.19h-.38l.06.26Zm.19-11.18-.19.07.26.12-.07-.19Zm.13 1.35-.32-.06.13.19.19-.13Zm-.06 4h-.19l-.07.2.26.19.13-.19-.13-.2Zm-.07 3 .2-.19-.26-.07-.13.13.19.13Zm.07 1.35.06-.19-.19-.07-.13.2.26.06Zm-.19-12.27.25.07.13-.2h-.38v.13Zm.19 1.48.19-.07-.19-.19-.19.13.19.13Zm.06 4.5.26.19.19-.26-.45-.19-.19.13.19.13Zm.13 6.87.26.13.06-.2-.51-.19.19.26Zm.39-9.64-.39-.19.07.26.32.32v.26l.19.19v.32l-.32-.13-.19.26v.19l.19.13.64-.32.39.13-.39-.84-.51-.26v-.32Zm-.13 11.12.06-.07-.19-.13-.13.13.26.07Zm.06-13.62.13-.13-.19-.06-.19.12.25.07Zm.07 1.35-.13-.2-.19.07.32.13Zm0 4.56.38.19.2-.13-.71-.19-.19.13h.32Zm-.19 9-.13-.06v.19l.13-.13Zm.12-8.35h-.19v.19l.19-.19Zm-.12 1.65.19-.13-.13-.07-.13.13.07.07Zm.32-3.47.25.13.26-.13-.39-.32-.25.06.13.26Zm.19 4.17.19-.13-.19-.19-.19.19.19.13Zm-.07 4.05h.2v-.13l-.32-.06.12.19Zm.2-11-.2-.13v.25l.2-.12Zm.06 5.39-.19-.06-.07.19.26-.13Zm-.06-6.62.13-.12h-.2l.07.12Zm.45 7.26-.2-.06-.06.19.26-.13Zm-.13-2.63.13-.13-.13.07v.06Zm.38-5.46-.19-.06v.19l.19-.13Zm0 3.47.2.13.19-.26-.39-.19-.19.13.19.19Zm.13 3.79-.32-.13v.26l.39.25.13-.19-.2-.19Zm-.19-1.16.26.07-.07-.26-.19-.06v.25Zm.26-1.22.13-.13-.2-.06-.13.13.2.06Zm0 4.05-.2-.26v.19l.2.07Zm0-10.86.06-.13-.13-.12-.06.19.13.06Zm.51 18.44-.51-.13.25.13h.26Zm.26-14.13v.19l-.64-.13.12-.45.45.19.07.2Zm-.39-8.8v-.2l-.19-.06.19.26Zm-.13 14.71.26.06.19-.13-.19-.13h-.32l.06.2Zm.2 1.28h.25l-.13-.26-.32-.06-.06.26.26.06Zm-.07-2.7h.26v-.25l-.19-.07-.2.13.13.19Zm.13 1.87-.19-.13v.13h.19Zm0 10.4-.19-.06v.13l.19-.07Zm.26-18.05-.26.07-.13-.13v-.26l.13-.13.26.13v.32Zm-.2 4.82-.19-.06v.16l.19-.1Zm.65-13v.1l-.07-.07.07-.03Zm.32 18.12.13-.26-.2-.13-.12.26.19.13Zm.51 2.25.13-.26-.06-.13h-.26l-.13.26.06.26.2.12.06-.25Zm.45-.84v.32l.19-.06.07-.19-.26-.07Zm.84-.7-.39-.39.19.58.2-.19Zm-.2 1.41.07-.19-.26.06.19.13Zm.2-.26.19-.19-.26.13.07.06Zm.19-.38.06.19.2-.07-.13-.38h-.26v.13l.13.13Zm-.06-1.1h.25v-.19l-.25-.06v.25Zm.45-17.6h-.13l.13.13v-.13Zm.12 18h.26l-.13-.32h-.25l.12.32Zm.65.71-.07-.26-.19.07.26.19Zm0-18.89h-.13l.13.13v-.13Zm.06 17.8.13-.26h-.19l.06.26Zm.19 27.88h.2l-.07-.19h-.26l.13.19Zm.13-27.18.13-.12h.13v-.26l-.19-.13-.07.19.13.2-.32-.13.19.25Zm.07-17.66.25-.07.07-.19-.13-.13-.26.13v.26h.07Zm.32 43.84v-.2l-.26.2h.26Zm0-27.56-.13-.32.13-.13.38.13v.32H386Zm.32 1.92h-.13l.06.2.07-.2Zm.26 23.84.12-.2-.19-.19h-.26l.2.52.13-.13Zm.12-22.87-.12-.26-.07.19.19.07Zm.52 24.67-.07-.2-.25-.06.06.45h.26v-.19Zm-.07-27.88.07.25H387v-.38l.15.13Zm.07 27 .19.13-.19-.39-.2.06.2.2Zm.06-1 .13.19.39.19.19.45.26.13v.26l.25.38.2-.06v-.32l-.2-.26-.25-.06-.13-.52-.32-.12-.13-.52h-.45l.06.26Zm.45-26.21-.19-.07.26-.12-.07.19Zm.19-15.61-.25.06.13.2.12-.2v-.06Zm.33-.71.06.26h.19l.07-.45-.26-.13-.19.13.13.19Zm-.07 1.16v.26l.26.19v-.52l-.26.07Zm.39 41.43.19-.25-.13-.13-.26.06-.06.19.26.13Zm.51 1.61-.19-.07-.07.26.26-.19Zm.26-.84-.13-.19v.19h.13Zm.58-1.22.38.13.07.52.19.38-.13.26-.19-.07v-.32l-.13-.19h-.26l-.13-.58-.38-.25-.07-.2.13-.13.32.13.2.32Zm-.13-39.31v.13l-.13-.13h.13Zm.83 39.06-.06.19h-.26l.07-.45h.25v.26ZM415.68 126l.12.39-.06 1.09-.13.32.19.19-.06.45.13.45-1 .19-.58-.12-.38.12-.32-.12-.77.12-.65-.12-.25.06-.2-.19h-.51l-.26.13-.83.06-1.09-.13-.26.13-.45-.06-.45.19-.19.45v.4l-.2.45.13.19-.06 1.09.13.45-.07 2 .19.32-.06 2.06.13.32-.13.58.19 1-.25.84.25.77-.19.26.19.7-.25 1 .12 1-.19.45.19.45-.12.45.12 1.22-.12.19.06.26-.26.19.26.32v1.74l-.26.77.2.71-.2.45.2.38-.13.58.13 1.22-.2.19.13.32-.26.26.39.26v.32l-.19.19.13.39-.39.12.39.2.12 1-.32.19.26.39v.19l-.32.32.32.2-.19.38.19.71v.51l-.13.19.13.33-.13.25.07.58-.39-.19-.13.13.13.19.39.19-.13.52-.39.06.26.13.26-.07v.45l-.33-.12-.12.12.38.39-.06.32-.26.19.32.07v.38l-.45-.06v.13l.39.32.13.83-.13.2-.32-.07.38.26-.13.45.2.45-.2.38.2.26-.2.26.32.45-.06.32-.26.13.07.19-.32.45h.51l.13.19-.13.45-.64-.19-.13.06.13.2.45.12.32-.06.06.26-.13.25h-.38l.32.2.19 1-.06.26.13 1h-.32l-.26.45-2.38.06-.13-.26-.25.26-.39.13-.13-.45.58.06-.06-.25-.32-.13-.26.13-.32-.07-.52-.77.45-.26.07.52.13.19.25-.26-.06-.51-.32-.07-.13-.38.58-.32v-.52l.25.07.26-.13-.13-.26-.45.2-.45-.13v-.39l.77.13-.06-.26-.45-.32.45-.19.58-.06-.39-.39-.45.26h-.25l-.33-.32.26-.13h.71l-.13-.07-.19-.45-.65.26-.19-.13v-.38l.26-.07.58.19.13-.19-.78-.45.78-.38-.2-.2-.45.2-.32-.07-.06-.25.13-.2.19.07.19-.13.07-.51.51-.07-.19-.38-.71.51-.13-.32.13-.52.39-.25-.13-.2.06-.25h-.26l-.19-.26.07-.32.57-.07-.25-.44.64-.45-.26-.07-.51.19-.19-.19.06-.32.77.13.13-.07-.58-.51-.45.13.07-.19.45-.32-.39-.33.06-.19.39-.26-.19-.12-.26.12-.13-.12.07-.26.57-.07.2-.19.38-.06-.06-.13-.52.19h-.32l-.19-.19.06-.26.33-.06.19-.19-.19-.2-.45.13-.07-.19.19-.39v-1l.2-.26-.2-.45.13-.25h.26l.13-.2-.58-.06-.06-.19.12-.2.33.07-.2-.13-.13-.39.84-.25-.45-.32.06-.26-.51-.58.45-.32-.06-.19-.2.25-.13-.13-.06-.51.13-.19-.13-1 .19-.38-.13-.26.07-.32-.32-.39.25-.32v-.51l-.19-.26v-.32l.32-.26-.13-.32v-.77l.26-.26-.26-.38.2-.26-.39-.19.07-.32.38-.39-.26-.19V144l.33-1-.26-.32v-.26l.32-.38-.19-.32v-1.62l-.13-.12-.07-.52.33-.38.06-.26-.26-.32.26-.58-.19-1 .13-.32v-.45l-.2-.26.2-1.15-.33-.26.26-.58-.06-.19.19-.26-.26-1v-2.83l-.19-.32.13-.58-.52-.06-.25.13-.58-.2-1.35.2-.19-.13h-.77l-.58-.13-.52.26-.44-.2-.26.07-.39.38-.06-.45-.77.2.06.25-.26-.06-.06-.26h-.77l-.06-.83-.26-.39.13-.25-.45-.33.51-.12-.19-1 .19-.32-.13-.26.26-.26.77.13.19-.13.58.2.54-.16.64.13.77-.2.32.07.33-.13.57.13.39-.13.58.13.45-.07.19.13 1.48-.06.25-.13 1.1.19.32-.13 1.35.07.25-.13.32.06.2.2.51-.26.45.19.53-.06.32.19h.7l.19-.13 1.55.13.51-.13.45.13h.77l.26-.13 1.8.26.32.38-.19.3Zm-19.53 2v-.2l-.13.07.13.13Zm6.55-.65h-.19v.2l.19-.2Zm.58 37.13-.13-.25.19-.07v.26l-.06.06Zm.32 4.69-.39-.06.13-.19h.39l-.13.25Zm-.19-7.58-.13-.06.19-.06-.06.12Zm.38 6-.19.26-.32-.19.13-.2.25-.06.13.19Zm-.26 4.05-.12-.13h.25l-.13.13Zm.2-18.31-.13.26-.07-.26h.2Zm.19 3.08.19-.12-.32-.2-.06.26.19.06Zm.13-4.56v-.12l-.26-.07v.19h.26Zm-.07-2.63-.12-.06.06.19.06-.13Zm.13 1.61v-.13l-.19.13h.19Zm.2 11.69.06-.26-.26-.06-.06.19.26.13Zm0-2.83h.19l-.19-.19-.2.13.2.06Zm.06-2.57.13-.13h-.32l.19.13Zm-.06 12.46.19-.19h-.32l.13.19Zm0 1.22.19-.12-.19.06v.06Zm.06-4.94.83.13-.19-.2-.58-.06-.06.13Zm.32-10.09-.13-.19-.13.06.26.13Zm-.13 8.8.19-.13-.19-.06-.13.13.13.06Zm0-1.35.45.13.19-.13-.51-.25-.19.06.06.19Zm.26-1.47.13.19.25.06.13-.13-.25-.19h-.52l.26.07Zm-.13 8.54.26.19v-.19l-.32-.26.06.26Zm.32-18v-.19l-.19.13.19.06ZM405 165l-.13.26.45-.07-.13-.32-.19.13Zm.06 1.67.26-.13-.19-.13-.2.19.13.07Zm.07-4 .25-.19-.19-.13-.19.19.13.13Zm0-15.93-.07.19.19.07-.12-.26Zm.12 17-.19.13.13.2.13-.07-.07-.26Zm0-4h.2l-.13-.19-.19.06.12.13Zm.33 9.83-.45-.06.32.06h.13Zm-.07-13.81v-.19l-.19.12.19.07Zm-.13 5.33-.06-.06v.06h.06Zm.13 9.89-.19.2.06.25.26-.13-.13-.32Zm.13-4.94.19-.2-.13-.13-.32.26.26.07Zm-.26 2.63.32.06-.06-.25-.26.13v.06Zm.58-6.68-.06-.26-.26-.13-.19.13.51.26Zm-.13 4.69.45.13v-.32l-.32-.13-.26.38.13-.06Zm.07-7.58.19-.19-.32.12.13.07Zm.1 8.9.25-.12-.32-.13-.13.19.2.06Zm.06 2.64-.19-.13v.19l.19-.06Zm.13-9.45.19-.12-.19-.13-.19.13.19.12Zm.06 1.35v-.13l-.25.13h.25Zm-.06 1.42.13-.2-.2-.06-.12.19.19.07Zm.06-4.18h.19v-.26l-.32.07.13.19Zm.19-4-.06-.19-.13.13.19.06Zm0 14.39h.2V170l-.2-.12-.19.19.19.1Zm-.06-2.82.19.13.2-.2-.45-.13.06.2Zm.26 1.54.19-.07-.45-.12v.12l.26.07Zm0-4 .19-.13-.26-.19-.13.13.2.19Zm-.07 4.63h-.13l.13.19v-.19Zm.13-6.23V163l-.19.13.19.16Zm-.13 1 .13-.13-.19.07.06.06Zm.26 1.8h.06l-.19-.26-.13.13.26.13Zm0-6.75.26-.13-.32-.12-.13.12.19.13Zm.13 1.42-.13-.26v.13l.13.13Zm.06 5.91-.19.19.45.06v-.32l-.13-.13-.13.2Zm0 4.36.07-.25h-.13l-.13.19.19.06Zm-.08-16.03.13.06v-.13h-.13v.07Zm.06-2.57.13-.13H407v.13Zm.32 12.78-.19-.19-.13.19h.32Zm.26 4.63-.38.25.25.13.26-.19-.13-.19Zm.19-40.86-.12-.13-.07.13h.19Zm27.43-.71-.64.39-.19-.45-.51.51-.26.07-.26.25-.34-.04-.45-.39-.19.39-.84.26-.13.19-.32-.06-.07.61.9.33-.77.44.2.2.64-.2.06.26-.32.39.19.32-.77.38.2.26-.26.32.45.13.13.19-.13.26-.26.13.19.32.26-.19.19.25-.19.2-.19-.2-.45.2.45.25.13.39-.39.26.19.12.33-.06-.13.39h-.45l.38.32.2 1-.26.19.19.39-.32.38.13.13h.26l-.13.32-.32.13.32.07.06.12-.32.58.13.26-.07.32.13.26v.38l-.19.2.39.19v.13l-.39.19.19.19.07.32-.26.33.32.19-.32.19.32.45-.26.51.07.26-.19.26.32.32.06.26-.26.32.07.25-.13.2-.45.19.13.19.38-.19.2.06.06.26-.26 1 .2.12v.26l-.2.39.07.32-.13.32-.45.13.19.12.39-.06-.07.84-.25.12.32.26.06.45-.13.19v.58l-.32.07.13.25.26.13-.19 1 .19.19v.32l-.26.39.32.19-.38.19-.13.2.45-.07v.65l-.26.19.26.32-.26.13h.26l.06.25-.32.58v.52l.32.06-.06.51-.26.39.26.19-.19.32.19.2v.32l-.19.38.06.26-.13.19.26.26-.13.45.13 1.41-.13.32.13.77-.13.45.13.9-.13.52v1.67l.13.64-.13 3.92.13.26-.19.83.12.45-.64.07-.45-.13h-1.67l-.45.19h-.77V169l.19-.9-.12-.25.06-.2v-2.44l-.13-.83V163l.13-.45v-1.09l-.13-.58.07-1.41-.13-.51.06-.26-.13-1.16h.26l-.06-.58.25-.32V156l-.32-.06.13-1.09-.06-.52.19-.51-.26-1 .19-.32-.12-.26.19-.19-.07-.19.2-.26-.07-.58-.13-.19-.25.07v-.52h.25l.13-.13-.25-.19.19-.32-.32-.26.38-.64v-.45l-.19-.19v-.26l.19-.06.07-.26-.13-.45.06-.26-.13-.25.07-.9.32-.32-.39-.13.13-.58-.06-.26v-1.28l.45-.32-.45-.26.13-.32-.13-.2.06-.51.26-.13-.32-.19.19-.32-.26-.58.07-.19.27-.17-.13-.19.06-.26-.19-.26-.07-.45.33-.25v-.45l-.26-.32v-.33l.32-.32-.19-.19.13-.32-.39-.51.32-.71-.26-.19-.12-.52.45-.19-.2-.26.32-.32h.32l-.19-.26h-.64l-.13-.19.13-.38.26-.07-.07-.19.13-.19-.32-.33-.06-.25.32-.13-.07-.32.2-.52-.45-.12.12-.26h.52l.13-.13-.32-.06-.26-.32.26-.24.32-.12-.26-.13-.19.13-.26-.13-.13-.26.39-.13.06-.64h-.19l-.39.32-.19-.13.19-.45v-.32l-.19-.13-.26.58-.57.32-.39-.06v-.26l-.9.32-.51-.26-.39.33-.51-.39-.58.39-.32-.26-.45.32-.52-.32-.45.32-.45.13-.19-.26-.32.26-.45-.07-.38-.25-.33.19h-.25l-.19.19h-.39l-.45-.25.06-1-.12-.25.12-.33-.12-1.09.12-.19-.06-.51.19-.65h.65l.32.39.32-.26.51.19.07.45.19-.19.06-.32.52-.19h2.63l.26.13.25-.2.58-.06.19.19.33-.19h.32l.32.32.26-.32h.25l.39.26h.19l.26-.33.25.07.33.32.12-.13v-.26l1.48.07.26-.13.45.06.13.13.77-.13.58.2.12-.26.39.51.26-.32.77.32.12-.28.51-.07.07.39.38-.45h.32l.45.51.26-.06-.06-.39.32-.06.32.38.32.07.13-.13v-.26l.77-.13-.13.26-.45.32v.32l-.13.2.2.06.32-.71.32.07.06-.39.45-.06.07.26.32.12.25-.38.71.06-.13.39.45.38h.2l-.65.71v.19l.2.13.19-.06v-.58l.26.19.25-.13v.26l.2.39.32-.2-.2-.51h-.25v-.32l.19-.52-.06-.32.25-.13.19.2.07.32-.13.38.13.2-.07.51.26.39h-.26l-.06.25.19.2.2 1-.2-.07-.06.26.26.32v.45l-.45-.45-.58.26-.19-.06-.07.19-.19-.13-.19-.39-.26.07-.07-.58h.26l.19-.19v-.26l-.19-.19-.26.58-.45.32v.25l-.32.26-.38-.64-.26-.07-.13.13.39.58-.13.32-.39-.38h-.19l-.19.19-.64-.32-.32.06v.24l-.39.13-.13-.39h.45l-.06-.58-.18.11Zm-16.63.71.06-.19-.19-.07v.2l.13.06Zm3.47-3.6.06-.19h-.19l-.13.26.26-.07Zm2.12 2.76-.07-.19h-.19l.19.26.07-.07Zm.06-2.76h-.13l-.06.2.13.12.06-.32Zm1.09 3h-.13v.13l.13-.13Zm.84.07.19-.13-.45.13h.26Zm1.35 22.8v.13l-.13-.13h.13Zm.57-7.45-.12.32h.25l-.06-.45h-.26l.19.13Zm-.07-15.2.19-.12H428v.12Zm.38 16.32.06-.13-.12-.19v-.13h-.13l.13.13.06.32Zm.26-2-.26.13.26.13v-.26Zm-.07-2.12.13-.13-.19.13h.06Zm.13 1 .13-.19h-.19l-.13.19h.19Zm.39 3.79-.07-.12-.06.12h.13Zm.32-15.67-.13-.13-.13.13h.26Zm.06 11.88.39-.25-.39.13v.12Zm.07-8.93.19-.06-.19-.06v.12Zm.32.45-.19-.25-.13.32.32-.07Zm-.19-8 .25-.12-.19-.13-.13.13.07.12Zm.06 5.34.13-.2-.26.13.13.07Zm.06 1.28.13-.26h-.19l-.13.26h.19Zm.21 11.76h-.13v.13l.13-.13Zm.13-12.53H430v.13l.13-.13Zm.19 1.55.32-.2-.57.07.25.13Zm0-2.89h-.19l.06.12.13-.12Zm-.06 3.79v-.2h-.13l.13.2Zm.38 14.83-.13-.06v.19l.13-.13Zm.26-16.89.06-.13-.38-.06v.13l.32.06Zm-.13 1.28v-.19h-.19l.19.19Zm-.13 20.69.26-.13-.19-.13-.13.2.06.06Zm.13-20.11.19-.13-.25.07.06.06Zm.13 1.22v-.13l-.19.13h.19Zm-.13 16.58v-.07l-.06.07h.06Zm.13-20.75-.13-.13v.19l.13-.06Zm.13 10.6.19-.07-.26-.13-.12.2h.19Zm.06 1.47.13-.12-.06-.13h-.32l.25.25Zm.07.26h-.26l.13.13.13-.13Zm-.07.77-.13-.06.07.19.06-.13Zm.13 3-.19-.19-.07.19h.26Zm.13-15.29-.13-.07-.19.13.32-.06Zm-.13 16.89h-.13v.2l.13-.2Zm0 3v-.19l-.13.12.13.07Zm.07-22.55v-.13l-.07.13h.07Zm.45 3.53.32.2-.26.32-.26.06-.19-.38.13-.26.26.06Zm.06-2.24-.19.12-.13-.12v-.26l.26-.07.19.13-.13.2Zm.32-1.42.13.19.19-.19-.32-.26v.26Zm1.22.26v-.58l-.19.45.19.13Zm.26-2.12v.19l.19-.13.13-.57h-.32l-.13.19.13.32Zm.19 1.48.13-.2-.13-.45-.19.07-.07.51.26.07Zm.39-2.06.25-.06-.06-.13h-.26l-.19.19h.26Zm-.13 1.09.06.2.26-.33-.13-.19-.26.07.07.25Zm.19 1.74h.19l.07.13-.45.06v-.26l.19.07Zm.71-2.19v-.7l-.45.45.06.19.26.13.13-.07Zm.19.71.26-.06.13-.26-.07-.26-.46.18.14.4Zm.26-1.67-.07-.19-.32-.07.13.2.26.06Zm0 .32.06-.26-.26.07-.12.19h.32Zm.25.64.26.07-.06-.26-.2.06v.13Zm.39 1.22-.19-.06.06.19.13-.13Zm.32.52v-.2h-.19l.19.2Zm.39-2 .12.12-.06.26.19.13.07.32.19.19.19-.06.07-.32-.13-.26h-.26l-.19-.58h-.26l.07.2Zm.25 1.47-.06-.19-.26-.13v.42l.19.07.13-.17Zm.45-1.92-.25-.07v.2l.25-.13Zm.13.64.26.13.19-.07-.06-.25h-.45l.06.19Zm.07 1.35.19.25.25-.19-.06-.51-.19.13-.07.25-.12.07Zm.7-2.44-.19-.07-.13.26.26.13-.2.19.13.19.26-.12.06-.33-.19-.25Zm-.26 1.73.07.19h.26l.12-.45-.25-.12-.26.12.06.26Zm.26 1.61.13.13-.13.12-.19-.06-.07-.26.26.07Zm.71-3.6-.07-.26.13-.13.26.13.06.26-.25.26-.13-.26Zm.13 3.34v.19l.19.13.13-.26-.07-.57-.25.06-.07.19.07.26Zm.38-1.35-.06-.26-.07.26h.13Zm.32.45-.19-.26-.13.26.32.39.13-.2-.13-.19ZM449.34 162.46l.19-.07-.06.45-.26.52.26.45-.26 1-.21.19.25.33-.06.89.19.26-.19.77.13.52-.07.32.13 1-.06.51.13.51-.07.45.2.77-.13.45-.84-.12-.51.12-.58-.12-.32.19-.19-.13-1.1-.19-.19-.52.06-.83-.12-.32.06-1.48-.13-.26-.06-1.41-.19-.45.19-.58-.26-.71v-1.79l.13-.45v-5.34l-.13-1.41.13-.26v-.38l-.13-.26.07-.51.19-.2-.26-.25.13-.26-.06-.51.19-.39-.13-.26.06-.25-.12-.58.19-.26-.19-.19-.07-.51.13-.58-.06-.26.12-.32-.12-.64.25.06.32.58.13-.06-.13-.39.2-.19-.33-.07-.25-.64-.26-.26.07-.51.32.32.32-.19-.26-.13v-.45l.13-.32-.07-.13-.32.13v-.58l.2-.13-.2-.25-.06-.45.32-.65-.32-.64v-.38l.26-.2v-.45l-.32-.64.44.13.2.38.19-.57-.13-.13-.32.13v-.65l.45-.12-.13-.2-.51.2-.13-.58.32-.2-.19-.32.06-.25-.13-.52.2-.19-.07-.39.13-.25v-1.09l-.19-.58.19-.39-.06-1.48.12-.19.07-.83-.13-.26.06-.32.33-.07-.2-.25.13-1 .26-.13-.26-.32v-.25l.32-.26.07-.77.25-1 .33-.33.06-.51h.32l.19-.77.26-.07.06-.25.2-.13.06-.26.26-.06.13-.19v-.33l.32-.12v-.26l.32-.45.32-.13.45-.51 1.8-.77.45.12.32-.38.39-.13.25.13 1.1-.19.44.25.13-.25h.45l.19.19.33.06.25-.25.52.45.38-.13v.19l.2.13h.44l.2.19-.13.39.39-.13.64.13.38 1.09.26-.32.13.13-.07.19.13.19h.47l.19.64.39.2-.13.32.13.19.42-.03v.57l.45.2v.25l-.33-.12-.7.38.19.13.51-.19.52.25-.19.2-.33.06-.12.27.12.26.26-.13.52.13-.52.51-.19.52-.26.13.19.19.52-.06.06-.39-.19-.06-.06-.2h.77v.45l.38.32-.19.39.38.38-.32-.06-.32.32.19.19h.52l-.13.39-.32.13.19.13.32-.07.2.2v.25l-.65-.13-.45.39v.13h.84l-.26.38.07.2.38-.07.13.19-.06.26-.26.07-.39-.26-.25.38h.45l.51.2-.39.13-.06.12.13.26.32.07.06.25-.12.13-.58-.13-.32.13-.07.19.19.13.52-.06.19.13.26-.13v.38l-.32-.13-.32.39h.51v.48l.26.32-.32 1 .38.39-.26.32.07.26-.19.38.45.32-.33.45.13.2-.58.51.07.13.26-.26.45.26-.33.51-.12.58.32.13.13.38-.33.26.26.13.13.26-.32-.07-.07.19.26.07.07 1-.13.19.19.39-.19.38.13.39v.7l-.13.39.19.83-.19.45.06.32-.32.39.32.13v.32l-.45.06.32.07.2.38-.13.2.06.45-.51.25.38.19v.52l-.38.13.13.19.32.13-.07.71.13.89-.19.78.13.38-.07 2.12.2.51-.2.33.13.9-.13.51.2 1.09-.2.26.2.45v.51l-.26.26v.32l.19.45-.06.39-.2.19.07.19v2.12l-.19.32.12.26.07.71-.13 1.09.06.51-.12.26.06.58-.13.77.13.9-.64.25-.58-.19-2.25-.06-.39-.2v-1.09l.13-.51v-1.09l.13-.2v-6.42l.13-.9-.13-.39.13-.38-.13-.39h-.26l-.19.39-.58-.45h-.32l-.25.32-.65-.38-.19.38-.58-.26-.32.07-.19.19-.26-.26-.58.07-.38.19-.45-.19-.64.25-.58-.44-.07-.33-.45-.19-.06.52-.38.12-.2-.51-.32.06-.06.26.12.26.33.19-.13.19h-.2l-.32-.32-.32-.06-.1-.43-.19-.12-.13.12.06.2-.13.19.39.32-.07.19-.25.07-.45-.45-.32.38h-.52l-.19.13.32.32-.06.26-.26.26.19.38-.25.19.2.02Zm-3.92-15-.13-.07.13-.19v.26Zm.32 9.89v-.06l-.13.06h.13Zm.39-13-.13-.19-.2.13.33.06Zm-.07 7.52-.19-.19-.07.19h.26Zm-.13-11.5.26-.13-.13-.13-.19.07.06.19Zm-.06.71.06.25.13-.19v-.32h-.13l-.06.26Zm0 4.17.13.2.19-.39-.32-.06v.25Zm.19 5.66-.13-.07-.06.13.19-.06Zm.13-7.2h-.26v.19l.26-.19Zm0-6.29-.06-.26-.13.38.19.13v-.25Zm-.06 1.47v-.19l-.13.3.13-.11Zm.38 8.8.19-.12-.25-.13-.26.19.32.06Zm0 5 .07-.38h-.2l-.13.19.26.45v-.26Zm-.19-1.6.13.51.06-.51.32-.26h-.38l-.13.26Zm.06-8.1.07.65.19.13.13-.13-.13-.71-.26.06Zm.2 4.18.06-.19-.19-.07-.07.2.2.06Zm.06 1.16-.19-.07-.07.13.26-.06Zm-.13-3.67v.26l.19-.06.07-.32.38-.33-.7.2.06.25Zm-.06 1.16.19-.19-.19.13v.06Zm.19-5h-.13l.07.13.06-.13Zm.26 12.91-.2-.25-.12.19.32.06Zm.19-2-.19-.13-.13.2.32-.07Zm-.26-5.33.2.13.25-.26.26.07.13-.2-.26-.06-.58.13v.19Zm.13 1.41.13-.13h-.26l.13.13Zm0-4.11.07.07v-.13l-.07.06Zm.64 3.28-.12-.26-.26.13v.15l.19.13.19-.15Zm-.19 4.69.19-.13-.12-.13-.2.06.13.2Zm0-5.91.19-.13-.25.06.06.07Zm0 2.69.19-.19h-.25l.06.19Zm.07 4.37h-.13l.13.13v-.13Zm9.37-23.77h-.32l-.45-.45-.25-.06-.13-.26-.7-.28-.32.07-.64-.13-.26.19h-.58l-.64.39h-.19l-.19.32-.46.32-.06.32-.26.19-.7 1 .06.26-.13.32-.51.19.19.32-.19.32-.12-.08-.06.71.12.25-.12.26-.26.06-.06.2.25.45-.25.38-.07.39.13.19-.26 1.93.13.25-.06.26H449l-.07.19.39.2-.13.51H449l.19.9.13.13-.58.58-.26.45v.32l.13.19.26-.06-.07-.33.2-.44.13.57-.26.32v.71l.13.19.25.07.07.13-.13.19-.71.13.39.32-.07.26-.25.06-.13.26.19.06.19-.13.13.2-.06.19H448l-.19.19.06.32-.13.26-.32.13.26.13.32-.13.45.13.19-.2h-.38l-.13-.38.13-.19.51-.07.13.58.45.32-.45.19-.26-.06-.13.13.26.06.13.45-.45.26v.26h.19l.26-.33.26.07.12.19v.32l-.38.07-.26-.26-.19.19-.52.07-.06.19.19.13.26-.26h.39l.19.45-.07.19h.39l.06.45-.19.13-.38-.13-.9.2-.32-.13.12.25.52.32.06-.19.26-.19.45.26-.07.19-.45.13-.32-.13.07.32.25.13.52-.26.26.13.06.26-.13.19-.26.06-.12.26.12.07.33-.13.12.19-.38.13-.07.19.26.07.13.19-.06.19-.39.26v.58l.39.06.06.32-.13.19h-.26l-.06.33.39-.07.12.19-.19.39.07.45-.45.38h.45l.19.2-.13.7-.45.45.32-.13.26.45-.26.33.13.25v1l-.13.19.13.26-.13.26.39-.07.25.84.32.06.39.58h.26l-.2-.51-.38-.39v-.26l.32-.19.19.13.2.45.25.06.32.71.2.06.06.26.32.39.13-.39-.51-.58.12-.38h.28l.19.25.13-.19-.19-.13-.07-.83.39.13.12.51-.19.32.19.07.2-.2.32.26v.32l.51-.19V158l-.25.07-.2-.13.26-.26-.26-.38h.32l.13.45h.4l.45.38-.19-.64v.13l-.2-.2.13-.25.26.13.19.38.39-.06.19-.58.45.19.13.26h.32l-.26-.39.19-.19.26.13.71-.19.45.12.64-.25.26.19.64-.26-.32-.32.45.07.25.45.13-1.1.2-.19-.2-.32.13-.26-.19-.32.26-.51-.2-.19.2-.33-.26-.19-.07-.26.26-.32.07-.45-.26-.19-.07-.26.33-.45.06-.51-.32-.32v-.32l.38-.26-.12-.19.06-.26-.32-.51.26-.39.12-.58-.19-.45.19-.32v-.51l-.19-.32.19-.39-.12-.45v-1.13l-.13-.13.13-.32-.13-.32.25-.32-.32-.13v-.32l.32-.32v-.45l-.38-.26.06-.45.13-.13.26.07.06-.13-.19-.39.06-.25-.32-.39.13-.19.26-.07.06-.25h-.32l-.13-.84.13-.26.26.07.13-.13-.2-.19-.25.19-.07-1.09-.13-.26.2-.45.25.07.26-.13h.45l.19.13.13-.13-.51-.32-.71.25-.13-.38.13-.19.45-.07-.06-.26-.2-.12-.38.32-.32-.26.06-.32.26-.07.13-.25-.33-.2.33-.25-.45-.13-.07-.19.45-.52-.19-.06-.32.26-.19-.58.19-.32-.32-.13-.2-.9.52-.26-.77.07-.07-.45.32-.26-.44-.26-.07.19-.26.07v-.52l.13-.25-.26.06-.32-.45.07-.32-.26-.06-.13-.2v-.32l-.1-.13Zm-9.25 12.72-.12-.06v.19l.12-.13Zm.07.45-.07-.19-.12.13.19.06Zm0 1.29-.19-.07v.13l.19-.06Zm.13 10.28.12-.2-.19-.25-.13.45h.2Zm.32-8.23.13-.12-.2-.07-.19.13.26.06Zm-.07-4.49-.13-.07v.07h.13Zm-.13 1.47.2-.12h-.2v.12Zm0 4.37.26-.13h-.26v.13Zm.2 2.7.19.19.19-.06-.13-.19-.45-.13v.13l.2.06Zm.06 3.6.07-.26-.33.13.26.13Zm0-4.24H448l.06.19.12-.19Zm.07 4.88.25.07-.06-.26h-.26l.07.19Zm.12 1.48.2-.19-.2-.07-.19.13.19.13Zm-.12 1.15.12.2.26-.26.32-.06-.25-.13-.2.19-.25.06Zm.19-9.31.26-.13-.13-.13h-.26l.13.26Zm.06-5 .2-.58-.33.19.13.39Zm.26-2.63-.13-.13v.13h.13Zm.26 12.65-.26-.06v.19l.26-.13Zm-.2 3.79.07-.19-.13.06.06.13Zm.45-19-.06-.2-.19.13.06.26.19-.19Zm0 13.49-.06.25-.13-.25h.19Zm-.12-16.26h.19l-.19-.06v.06Zm.25 12.47-.13.06-.06-.19.19.13Zm0-4.12v.26l-.13.13v-.39h.13Zm0 2.57v.13h-.13v-.13h.13Zm.07-5.26v.13h-.13v-.19l.13.06Zm.45-7.78-.13-.12v.12h.13Zm.06 28.08v-.26h-.13v.32l.13-.06Zm.45-.39.06-.13h-.25l.19.13Zm.64 0 .45.07-.06-.45-.39-.07v.45Zm.58-2.25-.19.32-.32-.38.13-.26.32.07.06.25Zm.64.64-.06.26.77.52-.06-.39-.26-.13-.39-.26Zm.45 2.64v-.19l.2-.07.12.19-.32.07Zm.77-1 .07-.45-.45-.2.06.58.32.07Zm.45-.78.13-.19-.13-.26-.25-.06.25.51Zm-.19 1.35.26-.12.06-.2-.09-.06-.25.13.02.25Zm.52-.9.25.07v-.26l-.19-.13-.13.07.07.25Zm.19-1.35-.19.07.12.13.07-.2Zm.45 1.93.13.07.12-.13-.12-.19-.45.12.32.13Zm.57-1.86.13-.13-.19-.13-.19.19.25.07Zm0 1.16-.06-.07v.07h.06Zm.26.7h.24l.13-.19-.26-.06-.26.12.15.13Zm.9-34.75-.13.13.07.13.06-.26Zm.19 34.75.26-.19h-.45l.19.19Zm.13-2.7h.2l.06-.12-.39-.07.13.19Zm1 2.51-.2-.06-.13.12.33-.06Zm.19-31.16-.13-.06v.06h.13Zm.06 1.16.07-.13-.13.07.06.06Zm.52-3.21v-.2h-.2l.07.2h.13Zm0 4 .13-.12h-.2l-.13.19.2-.07Zm.06-1.41.26-.19-.19-.13-.13.19.06.13Zm.19 30.77.13-.19-.32-.13-.06.26.25.06Zm.2-31.48h-.2v.13l.2-.13Zm.19 1.42.13-.19h-.26l-.13.19h.26Zm0 2.76-.13-.13-.06.19.19-.06Zm0-5.46.45-.06-.32-.26-.2.19.07.13Zm.13 1.28.19-.06-.19-.19-.2.19.2.06Zm-.2 4.82.71-.13-.32-.12-.39.25Zm.2-2.12v-.19l-.07.19h.07Zm.38-3.47-.25-.06-.07.19.32-.13Zm-.19 1.48-.13-.13v.13h.13Zm.26 2.7v-.19l-.26.13.26.06Zm-.07 2.76h.26l-.13-.26h-.19l-.13.2.19.06Zm.07 2.76h.19l-.13-.25-.19-.07-.06.26.19.06Zm0 2.06v-.13h-.19l.19.13Zm.64-11.37-.64.45h.58l.25-.26-.19-.19Zm-.51 1 .06-.13h-.19l.13.13Zm.06 6.23h.19l.13-.19h-.32l-.19.13.19.06Zm0-5.52-.16.13.26.13.38-.32-.32-.07-.16.13Zm.19 4.3.32-.25-.19-.2-.19.07-.26.38h.32Zm.07 7.78-.2-.07-.06.13.26-.06Zm0-9.19.19-.19-.06-.13h-.26l-.07.26.2.06Zm.13 5.33-.07-.25-.26.06v.26l.2.19.13-.26Zm-.13 1.42.06-.26-.19-.07-.07.26.2.07Zm.32-7.65-.45.26h.71l.19-.39-.19-.06-.26.19Zm-.13 4.18h-.32l.26.13h.45l.12-.2-.06-.25-.19-.07-.26.39Zm-.06-4.69.06-.2-.19-.06-.07.19.2.07Zm-.2 2 .2.13.64-.19v-.19l-.19-.1-.45.25-.2.1Zm.58-2.63.19-.39h-.25l-.13.45.19-.06Zm-.06 8 .13-.19-.26.13.13.06Zm.19-4 .19-.06-.13-.32-.32.38h.26Zm-.13 2.76.13-.12-.06-.13-.2.06.13.19Zm-.06 2.45.13.06-.07-.13-.06.07Zm.45-5.79.45-.06-.2-.39-.25.07-.2.38h.2Zm0 2.64.64.06v-.13l-.45-.25-.32.12.13.2Zm.19 2.57-.19-.13-.13.13h.32Zm-.26-4.24v.19l.58.19.19-.19-.51-.32-.26.13Zm0 2.7v.19l.2.13.12-.2-.06-.19-.26.07Zm.2-5.85-.13.13.19.06.45-.19h.38l-.12-.26-.2-.06-.38.26-.19.06Zm.06 4.05-.19.13.19.06.58-.13.06-.26-.38-.06-.26.26Zm.19-3.41-.19-.13-.13.13h.32Zm.39.45-.45.13-.07.19h.52l.13-.19-.13-.13Zm-.32 4.18-.07.25h.26l.13-.12-.07-.26-.25.13Zm.13-2.83-.13.26h.51l-.13-.32-.25.06Zm.19 4.24-.13-.26-.19.13.06.19.26-.06Zm-.07 2.57-.19-.13-.06.19.25-.06Zm.39.77v-.19l-.26.19h.26Zm0-3.92.19-.06-.19-.19-.19.12.19.13Zm0 1.29h.26l-.2-.32-.25.25.19.07Zm.06-3.15.13-.19h-.32l.19.19Zm-.19 4.43.13.07v-.26l-.13.13v.06Zm.39 10.79.19-.06-.26-.06.07.12Zm.25-12.72.13-.25-.19-.13-.19.13v.25h.25Zm0 1h-.19l-.06.2.25-.2Zm-.13 8.55.13-.2-.25.13.12.07Zm.2-6.94.06-.13-.26-.06.2.19Zm-.2 1.28.2.07v-.13l-.2.06Zm.52 5.4-.13-.13-.13.13h.26Zm-.07 1.28.07-.12-.26.06.19.06Zm.07 4H463v.19l.31-.19Zm0-5.85h-.19l.06.19.13-.19Zm.32-4.37h-.13l.07-.19.06.19Z",
    fill: "#0067A5"
  })));
};
/* harmony default export */ var my_impersonate_banner = (SvgMyImpersonateBanner);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-images-virtual-95769406cb/1/packages/lib-images/src/footer-happy-scale.svg
var footer_happy_scale_path, _defs;
function footer_happy_scale_extends() { footer_happy_scale_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return footer_happy_scale_extends.apply(this, arguments); }

var SvgFooterHappyScale = function SvgFooterHappyScale(props) {
  return /*#__PURE__*/react.createElement("svg", footer_happy_scale_extends({
    width: 96,
    height: 148,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), footer_happy_scale_path || (footer_happy_scale_path = /*#__PURE__*/react.createElement("path", {
    fill: "url(#a)",
    d: "M0 0h96v148H0z"
  })), _defs || (_defs = /*#__PURE__*/react.createElement("defs", null, /*#__PURE__*/react.createElement("pattern", {
    id: "a",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/react.createElement("use", {
    xlinkHref: "#b",
    transform: "matrix(.00148 0 0 .00096 -.009 0)"
  })), /*#__PURE__*/react.createElement("image", {
    id: "b",
    width: 688,
    height: 1042,
    xlinkHref: "data:image/png;base64,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"
  }))));
};
/* harmony default export */ var footer_happy_scale = (SvgFooterHappyScale);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-images-virtual-95769406cb/1/packages/lib-images/src/index.ts
// Force inclusion of type.
// Skipping this makes the type being weird in some packages.
// eslint-disable-next-line @typescript-eslint/triple-slash-reference
/// <reference path="../../lib-core/src/index.d.ts" />







/***/ }),

/***/ 27105:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$P": function() { return /* reexport safe */ recoil__WEBPACK_IMPORTED_MODULE_0__.$P; },
/* harmony export */   "CG": function() { return /* reexport safe */ recoil__WEBPACK_IMPORTED_MODULE_0__.CG; },
/* harmony export */   "FV": function() { return /* reexport safe */ recoil__WEBPACK_IMPORTED_MODULE_0__.FV; },
/* harmony export */   "Wh": function() { return /* reexport safe */ recoil__WEBPACK_IMPORTED_MODULE_0__.Wh; },
/* harmony export */   "Zl": function() { return /* reexport safe */ recoil__WEBPACK_IMPORTED_MODULE_0__.Zl; },
/* harmony export */   "_8": function() { return /* reexport safe */ recoil__WEBPACK_IMPORTED_MODULE_0__._8; },
/* harmony export */   "cn": function() { return /* reexport safe */ recoil__WEBPACK_IMPORTED_MODULE_0__.cn; },
/* harmony export */   "nY": function() { return /* reexport safe */ recoil__WEBPACK_IMPORTED_MODULE_0__.nY; },
/* harmony export */   "nZ": function() { return /* reexport safe */ recoil__WEBPACK_IMPORTED_MODULE_0__.nZ; },
/* harmony export */   "sJ": function() { return /* reexport safe */ recoil__WEBPACK_IMPORTED_MODULE_0__.sJ; },
/* harmony export */   "xu": function() { return /* reexport safe */ recoil__WEBPACK_IMPORTED_MODULE_0__.xu; }
/* harmony export */ });
/* harmony import */ var recoil__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(30822);



/***/ }),

/***/ 52203:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "nz": function() { return /* reexport */ GlobalStyles; },
  "Lb": function() { return /* reexport */ MotionWrapper; },
  "YT": function() { return /* reexport */ globalCustomListStyles; },
  "k": function() { return /* reexport */ grid_theme_gridTheme; },
  "AD": function() { return /* reexport */ handleColorType; },
  "yB": function() { return /* reexport */ saleInvoiceCustomListStyles; },
  "vh": function() { return /* reexport */ scrollStyle; },
  "rS": function() { return /* reexport */ theme_theme; },
  "iP": function() { return /* reexport */ useWindowSize; }
});

// UNUSED EXPORTS: BackgroundImageContain, BackgroundImageCover, PreloadFonts, ResetStyle, TriggerColorsEnum, clickAnimation, hoverShadowStyles, lineStyles, pageContainerPaddingLeft, pageContainerPaddingRight, shadowStyles

// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(61261);
// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(91987);
// EXTERNAL MODULE: ../../.yarn/__virtual__/styled-components-virtual-29066d9421/0/cache/styled-components-npm-5.3.5-88e3937b59-05a664dfe4.zip/node_modules/styled-components/dist/styled-components.browser.cjs.js
var styled_components_browser_cjs = __webpack_require__(33982);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-styles-virtual-b3f1d479f2/1/packages/lib-styles/src/fonts/Nobel-Black.woff2
var Nobel_Black_woff2_namespaceObject = __webpack_require__.p + "static/assets/c30f827c8d5e60f2Nobel-Black.woff2";
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-styles-virtual-b3f1d479f2/1/packages/lib-styles/src/fonts/Nobel-Black_Italic.woff2
var Nobel_Black_Italic_woff2_namespaceObject = __webpack_require__.p + "static/assets/fbb932349a0f6593Nobel-Black_Italic.woff2";
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-styles-virtual-b3f1d479f2/1/packages/lib-styles/src/fonts/Nobel-Book.woff2
var Nobel_Book_woff2_namespaceObject = __webpack_require__.p + "static/assets/542656be78d83545Nobel-Book.woff2";
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-styles-virtual-b3f1d479f2/1/packages/lib-styles/src/variables.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    const data = _taggedTemplateLiteral([
        '\n  :root {\n    --font-main: "Nobel";\n    --fz-xxs: 10px;\n    --fz-xs: 12px;\n    --fz-sm: 14px;\n    --fz-md: 16px;\n    --fz-lg: 18px;\n    --fz-xl: 20px;\n    --fz-xxl: 22px;\n    --white: #fff;\n    --black: #000;\n    --gray: #7f7f7f;\n    --bluelightest: "#80B3D2";\n    --blue: #057dcd;\n    --bluedark: #0a3a5c;\n    --background: #f6f6f6;\n    --disable: #c6c6c6;\n    --transition: all 0.25s ease-in-out;\n  }\n'
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}

const Variables = (0,styled_components_browser_cjs.css)(_templateObject());

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-styles-virtual-b3f1d479f2/1/packages/lib-styles/src/global-styles.tsx
/* eslint-disable max-len */ /* stylelint-disable */ /* eslint-disable react/no-array-index-key */ /* eslint-disable react/no-danger */ function global_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function global_styles_templateObject() {
    const data = global_styles_taggedTemplateLiteral([
        "\n  html, body, div, span, applet, object, iframe,\n  h1, h2, h3, h4, h5, h6, p, blockquote, pre,\n  a, abbr, acronym, address, big, cite, code,\n  del, dfn, em, img, ins, kbd, q, s, samp,\n  small, strike, strong, sub, sup, tt, var,\n  b, u, i, center,\n  dl, dt, dd, ol, ul, li,\n  fieldset, form, label, legend,\n  table, caption, tbody, tfoot, thead, tr, th, td,\n  article, aside, canvas, details, embed,\n  figure, figcaption, footer, header, hgroup,\n  menu, nav, output, ruby, section, summary,\n  time, mark, audio, video {\n    padding: 0;\n    border: 0;\n    margin: 0;\n    font: inherit;\n    font-size: 100%;\n    vertical-align: baseline;\n  }\n\n  article, aside, details, figcaption, figure,\n  footer, header, hgroup, menu, nav, section {\n    display: block;\n  }\n  html {\n    height: fill-available;\n  }\n\n  body {\n    min-height: fill-available;\n    line-height: 1;\n  }\n\n  ol, ul {\n    list-style: none;\n  }\n  blockquote, q {\n    quotes: none;\n  }\n  blockquote:before, blockquote:after,\n  q:before, q:after {\n    content: '';\n    content: none;\n  }\n  table {\n    border-collapse: collapse;\n    border-spacing: 0;\n  }\n\n"
    ]);
    global_styles_templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = global_styles_taggedTemplateLiteral([
        "\n",
        ';\n*,\n*::before,\n*::after {\n  box-sizing: border-box;\n  padding: 0;\n  margin: 0;\n}\n* {\nfont-family: var(--font-main);\n}\n*:focus-visible {\n  outline: none;\n}\n\n.ch2 {\n  position: relative;\n  z-index: 1;\n}\n\nhtml {\n  width: 100%;\n  max-width: 100%;\n  box-sizing: inherit;\n  overflow-x: hidden;\n  /* Scrollbar styles */\n  scroll-behavior: smooth;\n  scrollbar-color: var(--bluedark);\n  scrollbar-width: thin;\n}\nbody::-webkit-scrollbar {\n  width: 6px;\n}\nbody::-webkit-scrollbar-thumb {\n  border-radius: 10px;\n  background-color: var(--bluedark);\n}\n\nbody {\n  max-width: var(--max-width);\n  min-height: 100vh;\n  padding: 0 !important;\n  margin: 0 auto;\n  background-color: var(--background);\n  color: var(--black);\n  font-family: var(--font-main);\n}\ninput, textarea {\n    font-family: var(--font-main);\n}\nul, li, ol {\n  list-style: none;\n}\na {\n  color: var(--black);\n  text-decoration: none;\n  transition: var(--transition);\n  :hover {\n    color: var(--blue)\n  }\n}\n\nbutton {\n  padding: 0;\n  border: none;\n  background: none;\n  color: inherit;\n  cursor: pointer;\n  font: inherit;\n  outline: inherit;\n}\n\n.rdt_TableHead {\n  z-index: 0 !important;\n}\n\n.rdt_TableRow.disabled {\n  color: var(--disable);\n}\n\n.rdt_Pagination {\n  font-size: 16px;\n  span {\n    margin: 5px 10px 0 10px;\n  }\n\n}\n\n/* stylelint-disable-next-line, no-duplicate-selectors */\n* {\n  transition-timing-function: ease-out;\n\n  /* for debug purposes */\n  /* outline: 1px solid firebrick !important; */\n}\n\n.ch2-learn-more:focus-visible {\n  outline: none;\n}\n\ninput[type=\'number\'] {\n  appearance:textfield;\n}\n\ninput::-webkit-outer-spin-button,\ninput::-webkit-inner-spin-button {\n    appearance: none;\n}\n.no-scroll {\n  overflow: hidden;\n  height: 100%;\n  margin: 0;\n}\ninput {\n  border-radius: 0;\n}\ninput[type="search"] {\n  appearance: none;\n}\nimg {\n  user-select: none;\n}\n.cx-widget.cx-theme-byko {\n  background-color: #fdfdfd;\n  color: #444a52;\n  scrollbar-face-color: #ccc\n}\n\nbody .cx-widget.cx-theme-byko [aria-hidden="true"] {\n    display: inline;\n}\n\n\n.cx-widget.cx-theme-byko .cx-theme {\n    border-color: #dae1e8 !important;\n    background-color: #fdfdfd;\n    color: #444a52\n}\n\n.cx-widget.cx-theme-byko .cx-overlay {\n    background-color: #fdfdfd\n}\n\n.cx-widget.cx-theme-byko .cx-svg-icon-tone1 {\n    fill: #00416A\n}\n\n.cx-widget.cx-theme-byko .cx-svg-icon-tone2 {\n    fill: #971f82\n}\n\n.cx-widget.cx-theme-byko .cx-svg-icon-shadow1 {\n    fill: #000;\n    opacity: 0.2\n}\n\n.cx-widget.cx-theme-byko .cx-svg-icon-shadow2 {\n    fill: #000;\n    opacity: 0.1\n}\n\n.cx-widget.cx-theme-byko * {\n    border-color: #dae1e8\n}\n\n.cx-widget.cx-theme-byko .cx-titlebar .cx-title {\n    color: #444a52\n}\n\n.cx-widget.cx-theme-byko .cx-buttons-window-control .cx-svg-icon-tone1 {\n    fill: rgb(255, 217, 0)\n}\n\n.cx-widget.cx-theme-byko .cx-input-icon-overlay .cx-svg-icon-tone1 {\n    fill: #f5a623\n}\n\n.cx-widget.cx-theme-byko .cx-input-group-btn .cx-svg-icon-tone1 {\n    fill: #fdfdfd\n}\n\n.cx-widget.cx-theme-byko label {\n    color: #444a52\n}\n\n.cx-widget.cx-theme-byko a {\n    color: #000\n}\n\n    .cx-widget.cx-theme-byko a:hover {\n        color: #000\n    }\n\n.cx-widget.cx-theme-byko .cx-icon-alert-circle {\n    color: #f53131\n}\n\n.cx-widget.cx-theme-byko .cx-footer, .cx-widget.cx-theme-byko .cx-branding {\n    color: #66759b\n}\n\n    .cx-widget.cx-theme-byko .cx-footer *, .cx-widget.cx-theme-byko .cx-branding * {\n        fill: #66759b\n    }\n\n.cx-widget.cx-theme-byko .cx-form-control.cx-error {\n    border-color: #f53131\n}\n\n.cx-widget.cx-theme-byko .cx-form-control::placeholder {\n    color: #6f7491\n}\n\n.cx-widget.cx-theme-byko .cx-form-control:-moz-placeholder {\n    color: #6f7491\n}\n\n.cx-widget.cx-theme-byko .cx-form-control::-moz-placeholder {\n    color: #6f7491\n}\n\n.cx-widget.cx-theme-byko .cx-form-control:-ms-input-placeholder {\n    color: #6f7491\n}\n\n.cx-widget.cx-theme-byko .cx-form-control::-webkit-input-placeholder {\n    color: #6f7491\n}\n\n.cx-widget.cx-theme-byko input:focus, .cx-widget.cx-theme-byko textarea:focus, .cx-widget.cx-theme-byko .cx-btn:focus, .cx-widget.cx-theme-byko .cx-button-group button:focus, .cx-widget.cx-theme-byko .cx-form-control:not(.cx-error):focus {\n    border-color: #5791fd !important\n}\n\n.cx-widget.cx-theme-byko input[type="text"], .cx-widget.cx-theme-byko input[type="email"], .cx-widget.cx-theme-byko input[type="tel"], .cx-widget.cx-theme-byko select, .cx-widget.cx-theme-byko textarea {\n    border-color: #94948a;\n    background-color: #fdfdfd;\n    color: #444a52\n}\n\n.cx-widget.cx-theme-byko .cx-btn-default {\n    border-color: #dae1e8 !important;\n    background: none;\n    background-color: rgb(239, 239, 239);\n    color: #000;\n}\n\n.cx-widget.cx-theme-byko .cx-btn.cx-disabled {\n    background: #ccc\n}\n\n.cx-widget.cx-theme-byko .cx-btn-primary {\n    border-color: #2e69db !important;\n    background: #00416A;\n    background: linear-gradient(to bottom,#00416A 0%,#00416A 100%);\n    background-color: #00416A;\n    color: #fdfdfd;\n    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr=\'@bg_color_4\',endColorstr=\'@bg_color_5\',GradientType=0)\n}\n\n    .cx-widget.cx-theme-byko .cx-button-group .cx-btn-primary:focus, .cx-widget.cx-theme-byko .cx-btn-primary:focus, .cx-widget.cx-theme-byko .cx-button-group .cx-btn-default:focus, .cx-widget.cx-theme-byko .cx-btn-default:focus {\n        border-color: #000 !important\n    }\n\n.cx-widget.cx-theme-byko .cx-ac-dropdown-menu {\n    border-color: #dae1e8 !important;\n    background: #fdfdfd\n}\n\n.cx-widget.cx-theme-byko .cx-ac-suggestion:hover, .cx-widget.cx-theme-byko .cx-ac-suggestion.cx-active {\n    background-color: #5791fd;\n    color: #fdfdfd\n}\n\n.cx-widget.cx-theme-byko ::-webkit-scrollbar-thumb {\n    background: #939399\n}\n\n.cx-widget.cx-theme-byko .cx-smokescreen {\n    background-color: #fdfdfd;\n    opacity: 0.7\n}\n\n.cx-widget.cx-theme-byko .cx-dialog-container .cx-dialog {\n    border-color: #dae1e8 !important;\n    background-color: #fdfdfd\n}\n\n.cx-widget.cx-theme-byko .cx-theme-background {\n    background-color: #fdfdfd\n}\n\n.cx-widget.cx-theme-byko .cx-theme-border {\n    border: 1px solid #dae1e8 !important\n}\n\n.cx-widget.cx-theme-byko .cx-theme-text {\n    color: #444a52\n}\n\n.cx-widget.cx-theme-byko .cx-theme-icon-interactive1 svg .cx-svg-icon-tone1 {\n    fill: #5081e1\n}\n\n.cx-widget.cx-theme-byko .cx-theme-icon-positive svg .cx-svg-icon-tone1 {\n    fill: #34a84f\n}\n\n.cx-widget.cx-theme-byko .cx-theme-icon-negative svg .cx-svg-icon-tone1 {\n    fill: #f53131\n}\n\n.cx-widget.cx-theme-byko .cx-theme-icon-warning svg .cx-svg-icon-tone1 {\n    fill: #d47f2f\n}\n\n.cx-widget.cx-theme-byko .cx-warning {\n    color: #f53131 !important\n}\n\n    .cx-widget.cx-theme-byko .cx-warning .cx-icon svg * {\n        fill: #f53131 !important\n    }\n\n.cx-widget.cx-theme-byko .cx-countdown {\n    color: #444a52\n}\n\n    .cx-widget.cx-theme-byko .cx-countdown .cx-icon svg * {\n        fill: #444a52\n    }\n\n.cx-widget.cx-theme-byko .cx-loading-screen .cx-loading-icon svg g g, .cx-widget.cx-theme-byko .cx-loading-container .cx-loading-icon svg g g {\n    stroke: #2b74ff\n}\n\n.cx-widget.cx-theme-byko .cx-loading-screen .cx-loading-icon svg g:first-child g, .cx-widget.cx-theme-byko .cx-loading-container .cx-loading-icon svg g:first-child g {\n    stroke: #72799d\n}\n\n.cx-webchat.cx-theme-byko .cx-transcript .cx-message.cx-them .cx-bubble {\n    background-color: #e4bada\n}\n\n.cx-webchat.cx-theme-byko .cx-transcript .cx-message.cx-you .cx-bubble {\n    background-color: #a0ddea\n}\n#chat-button {\n    position: fixed;\n    z-index: 99999;\n    right: 32px;\n    bottom: 32px;\n    display: flex;\n    width: 64px;\n    height: 64px;\n    align-items: center;\n    justify-content: center;\n    border-width: 3px;\n    border-style: solid;\n    border-color: #fff;\n    border-radius: 50%;\n    background-position: center;\n    background-repeat: no-repeat;\n    box-shadow: 0 2px 8px rgba(0,0,0,.5);\n    cursor: pointer;\n}\n'
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}







const woffFonts = [
    Nobel_Black_woff2_namespaceObject,
    Nobel_Book_woff2_namespaceObject,
    Nobel_Black_Italic_woff2_namespaceObject
];
const html = {
    __html: "\n  @font-face {\n    ascent-override: 75%;\n    descent-override: 17%;\n    font-family: 'FallbackFont';\n    line-gap-override: 37%;\n    size-adjust: 95%;\n    src: local(Arial);\n  }\n  @font-face {\n      font-family: \"Nobel\";\n      font-style: normal;\n      font-weight: 400;\n      src: url(".concat("/".concat(Nobel_Book_woff2_namespaceObject).replace(/\/{2,}/g, "/"), ") format('woff2');\n  }\n  @font-face {\n      font-family: \"Nobel\";\n      font-style: normal;\n      font-weight: 500;\n      src: url(").concat("/".concat(Nobel_Black_woff2_namespaceObject).replace(/\/{2,}/g, "/"), ") format('woff2');\n  }\n    @font-face {\n      font-family: \"Nobel\";\n      font-stretch: condensed;\n      font-style: normal;\n      font-weight: 500;\n      src: url(").concat("/".concat(Nobel_Black_woff2_namespaceObject).replace(/\/{2,}/g, "/"), ") format('woff2');\n  }\n  @font-face {\n      font-family: \"Nobel\";\n      font-style: normal;\n      font-weight: 300;\n      src: url(").concat("/".concat(Nobel_Book_woff2_namespaceObject).replace(/\/{2,}/g, "/"), ") format('woff2');\n  }")
};
const PreloadWoffFont = (param)=>{
    let { font , url  } = param;
    const fontUrl = "".concat(url).concat(font.replace("//", "/"));
    return /*#__PURE__*/ _jsx("link", {
        as: "font",
        crossOrigin: "",
        href: fontUrl,
        rel: "preload",
        type: "font/woff2"
    });
};
const PreloadFonts = (param)=>{
    let { url = false ? 0 : window.__APP__CONFIG__.BASE_URL  } = param;
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx("style", {
                dangerouslySetInnerHTML: html,
                type: "text/css"
            }),
            woffFonts.map((font, index)=>/*#__PURE__*/ _jsx(PreloadWoffFont, {
                    font: font,
                    url: url
                }, index))
        ]
    });
};
const ResetStyle = (0,styled_components_browser_cjs.createGlobalStyle)(global_styles_templateObject());
const GlobalStyles = (0,styled_components_browser_cjs.createGlobalStyle)(_templateObject1(), Variables);

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-styles-virtual-b3f1d479f2/1/packages/lib-styles/src/theme.ts
var TriggerColorsEnum;
(function(TriggerColorsEnum) {
    TriggerColorsEnum["WarningMainColor"] = "#FF4E43";
    TriggerColorsEnum["WarningLightestColor"] = "#FFE7E5";
    TriggerColorsEnum["AttentionMainColor"] = "#FFA51F";
    TriggerColorsEnum["AttentionLightestColor"] = "#FFE5BF";
    TriggerColorsEnum["SuccessMainColor"] = "#3FC12A";
    TriggerColorsEnum["SuccessLightestColor"] = "#D3F2CE";
    TriggerColorsEnum["InfoMainColor"] = "#00416A";
    TriggerColorsEnum["InfoLightestColor"] = "#E5F0F6";
})(TriggerColorsEnum || (TriggerColorsEnum = {}));
var BlueColorsEnum;
(function(BlueColorsEnum) {
    BlueColorsEnum["BlueDarkColor"] = "#0A3A5C";
    BlueColorsEnum["BlueMainColor"] = "#00416A";
    BlueColorsEnum["BlueLightColor"] = "#5995BE";
    BlueColorsEnum["BlueLighterColor"] = "#80B3D2";
    BlueColorsEnum["BlueLightestColor"] = "#E5F0F6";
})(BlueColorsEnum || (BlueColorsEnum = {}));
var YellowColorsEnum;
(function(YellowColorsEnum) {
    YellowColorsEnum["YellowDarkColor"] = "#D6B200";
    YellowColorsEnum["YellowMainColor"] = "#FFD330";
    YellowColorsEnum["YellowLightColor"] = "#FFE24D";
    YellowColorsEnum["YellowLighterColor"] = "#FFEC8E";
    YellowColorsEnum["YellowLightestColor"] = "#FFF6CC";
})(YellowColorsEnum || (YellowColorsEnum = {}));
var OrangeColorsEnum;
(function(OrangeColorsEnum) {
    OrangeColorsEnum["OrangeDarkColor"] = "#C74B00";
    OrangeColorsEnum["OrangeMainColor"] = "#F85E00";
    OrangeColorsEnum["OrangeLightColor"] = "#FA8E4D";
    OrangeColorsEnum["OrangeLighterColor"] = "#FFB784";
    OrangeColorsEnum["OrangeLightestColor"] = "#FFEBDD";
})(OrangeColorsEnum || (OrangeColorsEnum = {}));
var GreenColorsEnum;
(function(GreenColorsEnum) {
    GreenColorsEnum["GreenDarkColor"] = "#008F69";
    GreenColorsEnum["GreenMainColor"] = "#04B485";
    GreenColorsEnum["GreenLightColor"] = "#52C6A8";
    GreenColorsEnum["GreenLighterColor"] = "#8FDBC7";
    GreenColorsEnum["GreenLightestColor"] = "#D9EEE8";
})(GreenColorsEnum || (GreenColorsEnum = {}));
var GrayColorsEnum;
(function(GrayColorsEnum) {
    GrayColorsEnum["Gray90Color"] = "#191919";
    GrayColorsEnum["Gray80Color"] = "#323232";
    GrayColorsEnum["Gray70Color"] = "#4A4A4A";
    GrayColorsEnum["Gray60Color"] = "#636363";
    GrayColorsEnum["Gray50Color"] = "#7C7C7C";
    GrayColorsEnum["Gray40Color"] = "#959595";
    GrayColorsEnum["Gray30Color"] = "#AEAEAE";
    GrayColorsEnum["Gray20Color"] = "#C6C6C6";
    GrayColorsEnum["Gray10Color"] = "#E6E7E8";
    GrayColorsEnum["Gray5Color"] = "#F6F6F6";
})(GrayColorsEnum || (GrayColorsEnum = {}));
var WhiteColorsEnum;
(function(WhiteColorsEnum) {
    WhiteColorsEnum["WhiteMainColor"] = "#FFFFFF";
})(WhiteColorsEnum || (WhiteColorsEnum = {}));
var BlackColorsEnum;
(function(BlackColorsEnum) {
    BlackColorsEnum["BlackMainColor"] = "#000000";
})(BlackColorsEnum || (BlackColorsEnum = {}));
var TransparentColorsEnum;
(function(TransparentColorsEnum) {
    TransparentColorsEnum["TransparentMainColor"] = "rgba(0, 0, 0, 0)";
})(TransparentColorsEnum || (TransparentColorsEnum = {}));
var ShadowColorsEnum;
(function(ShadowColorsEnum) {
    ShadowColorsEnum["ShadowMainColor"] = "rgba(0, 0, 0, 0.09)";
})(ShadowColorsEnum || (ShadowColorsEnum = {}));
var BoxShadowInput;
(function(BoxShadowInput) {
    BoxShadowInput["BoxShadowInput"] = "0px 18px 45px rgba(0, 0, 0, 0.09)";
})(BoxShadowInput || (BoxShadowInput = {}));
const theme_theme = {
    palette: {
        blue: {
            dark: BlueColorsEnum.BlueDarkColor,
            main: BlueColorsEnum.BlueMainColor,
            light: BlueColorsEnum.BlueLightColor,
            lighter: BlueColorsEnum.BlueLighterColor,
            lightest: BlueColorsEnum.BlueLightestColor
        },
        yellow: {
            dark: "#D6B200",
            main: "#FFD330",
            light: "#FFE24D",
            lighter: "#FFEC8E",
            lightest: "#FFF6CC"
        },
        orange: {
            dark: "#C74B00",
            main: "#F85E00",
            light: "#FA8E4D",
            lighter: "#FFB784",
            lightest: "#FFEBDD"
        },
        green: {
            dark: "#008F69",
            main: "#04B485",
            light: "#52C6A8",
            lighter: "#8FDBC7",
            lightest: "#D9EEE8"
        },
        black: {
            main: "#000000"
        },
        gray: {
            90: "#191919",
            80: "#323232",
            70: "#4A4A4A",
            60: "#636363",
            50: "#7C7C7C",
            40: "#959595",
            30: "#AEAEAE",
            20: "#C6C6C6",
            10: "#E6E7E8",
            5: "#F6F6F6"
        },
        shadow: {
            main: "rgba(0, 0, 0, 0.09)"
        },
        transparent: {
            main: "rgba(0, 0, 0, 0)"
        },
        white: {
            main: "#FFFFFF"
        },
        triggers: {
            warning: {
                main: "#FF4E43",
                lightest: "#FFE7E5"
            },
            attention: {
                main: "#FFA51F",
                lightest: "#FFE5BF"
            },
            success: {
                main: "#3FC12A",
                lightest: "#D3F2CE"
            }
        },
        boxShadow: {
            input: "0px 18px 45px rgba(0, 0, 0, 0.09)"
        }
    }
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-styles-virtual-b3f1d479f2/1/packages/lib-styles/src/shadow-styles.ts
function shadow_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function shadow_styles_templateObject() {
    const data = shadow_styles_taggedTemplateLiteral([
        "\n    &:hover {\n      transform: translateY(-",
        "px) translateX(",
        "px);\n\n      &:before {\n        transform: translateY(",
        "px) translateX(-",
        "px) translateZ(-1em);\n      }\n      &:disabled {\n        transform: none;\n        &:before {\n          transform: none;\n        }\n      }\n    }\n  "
    ]);
    shadow_styles_templateObject = function() {
        return data;
    };
    return data;
}
function shadow_styles_templateObject1() {
    const data = shadow_styles_taggedTemplateLiteral([
        "\n    &:active&:not(:disabled) {\n      font-size: 1rem;\n      transform: translateY(-6px) translateX(6px);\n\n      &::before {\n        transform: translateY(6px) translateX(-6px) translateZ(-1em);\n      }\n    }\n  "
    ]);
    shadow_styles_templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = shadow_styles_taggedTemplateLiteral([
        "\n    position: relative;\n    transform-style: preserve-3d;\n    transition: transform 0.5s;\n\n    &:before {\n      position: absolute;\n      top: 0;\n      right: 0;\n      bottom: 0;\n      left: 0;\n      border: 1px solid ",
        ";\n      background-color: ",
        ';\n      content: "";\n      transform: ',
        " translateZ(-1em);\n      transform-style: preserve-3d;\n      transition: transform 0.5s;\n    }\n\n    ",
        "\n\n    ",
        "\n  "
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}


const hoverShadowStyles = (param)=>{
    let { length  } = param;
    return css(shadow_styles_templateObject(), length, length, length, length);
};
const clickAnimation = ()=>{
    return css(shadow_styles_templateObject1());
};
const shadowStyles = (param)=>{
    let { color , outlined , length , showOnHover =false  } = param;
    return css(_templateObject2(), color || theme.palette.blue.main, outlined ? theme.palette.white.main : color || theme.palette.blue.main, !showOnHover && "translateY(".concat(length, "px) translateX(-").concat(length, "px)"), showOnHover && hoverShadowStyles({
        length
    }), showOnHover && clickAnimation());
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-styles-virtual-b3f1d479f2/1/packages/lib-styles/src/scroll-styles.ts
/* eslint-disable @typescript-eslint/no-explicit-any */ function scroll_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function scroll_styles_templateObject() {
    const data = scroll_styles_taggedTemplateLiteral([
        "\n    overflow-y: auto;\n\n    /* width */\n    ::-webkit-scrollbar {\n      width: 6px;\n    }\n\n    /* Track */\n    ::-webkit-scrollbar-track {\n      border: none;\n      background: ",
        ";\n    }\n\n    /* Handle */\n    ::-webkit-scrollbar-thumb {\n      background: ",
        ";\n    }\n\n    &:focus {\n      outline: none;\n    }\n  "
    ]);
    scroll_styles_templateObject = function() {
        return data;
    };
    return data;
}


const scrollStyle = (param)=>{
    let { color ="dark-blue"  } = param;
    return (0,styled_components_browser_cjs.css)(scroll_styles_templateObject(), theme_theme.palette.white.main, color === "dark-blue" ? theme_theme.palette.blue.dark : color === "light-blue" ? theme_theme.palette.blue.lightest : theme_theme.palette.black.main);
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-styles-virtual-b3f1d479f2/1/packages/lib-styles/src/line-styles.ts
/* eslint-disable @typescript-eslint/no-explicit-any */ function line_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function line_styles_templateObject() {
    const data = line_styles_taggedTemplateLiteral([
        "\n    position: relative;\n\n    &:before {\n      position: absolute;\n      top: 0px;\n      width: 20px;\n      border-top: 1px solid ",
        ';\n      content: "";\n    }\n  '
    ]);
    line_styles_templateObject = function() {
        return data;
    };
    return data;
}


const lineStyles = ()=>{
    return css(line_styles_templateObject(), theme.palette.triggers.warning.main);
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-styles-virtual-b3f1d479f2/1/packages/lib-styles/src/image-styles.ts
/* eslint-disable @typescript-eslint/explicit-function-return-type */ function image_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function image_styles_templateObject() {
    const data = image_styles_taggedTemplateLiteral([
        '\n  width: 100%;\n  height: 100%;\n  background-image: url("',
        '");\n  background-position: center;\n  background-repeat: no-repeat;\n  background-size: cover;\n'
    ]);
    image_styles_templateObject = function() {
        return data;
    };
    return data;
}
function image_styles_templateObject1() {
    const data = image_styles_taggedTemplateLiteral([
        '\n  width: 100%;\n  height: 100%;\n  background-image: url("',
        '");\n  background-position: center;\n  background-repeat: no-repeat;\n  background-size: contain;\n'
    ]);
    image_styles_templateObject1 = function() {
        return data;
    };
    return data;
}

const BackgroundImageCover = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-6188355f-0"
})(image_styles_templateObject(), (p)=>p.src.replace("//", ""));
const BackgroundImageContain = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-6188355f-1"
})(image_styles_templateObject1(), (p)=>p.src.replace("//", ""));

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-styles-virtual-b3f1d479f2/1/packages/lib-styles/src/grid-theme.ts
const grid_theme_gridTheme = {
    maxContentWidth: 1616,
    breakpoints: {
        lg: 1999,
        md: 1439,
        sm: 1079,
        s: 970,
        xs: 670,
        xxs: 399
    },
    container: {
        navHeight: {
            xl: 88,
            lg: 88,
            md: 56,
            sm: 56,
            s: 24,
            xs: 24
        },
        minWidth: {
            xl: 2000,
            lg: 1440,
            md: 1080,
            mm: 950,
            m: 900,
            sm: 700,
            s: 400,
            xs: 0
        },
        maxWidth: {
            lg: 1999,
            md: 1439,
            mm: 1300,
            m: 1079,
            sm: 899,
            s: 699,
            xs: 399
        }
    }
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-styles-virtual-b3f1d479f2/1/packages/lib-styles/src/table-styles.ts

// styles for all tables EXCEPT the sale invoice table
const globalCustomListStyles = {
    pagination: {
        style: {
            color: theme_theme.palette.blue.dark
        },
        pageButtonsStyle: {
            fill: theme_theme.palette.blue.dark
        }
    },
    rows: {
        style: {
            minHeight: "72px",
            backgroundColor: theme_theme.palette.white.main,
            borderWidth: "1px",
            borderStyle: "solid",
            borderTopColor: theme_theme.palette.transparent.main,
            borderBottomColor: theme_theme.palette.gray[5],
            borderLeftColor: theme_theme.palette.transparent.main,
            borderRightColor: theme_theme.palette.transparent.main
        },
        highlightOnHoverStyle: {
            fontWeight: "normal",
            borderWidth: "1px",
            borderStyle: "solid",
            backgroundColor: theme_theme.palette.gray[5],
            borderTopColor: theme_theme.palette.blue.dark,
            borderBottomColor: theme_theme.palette.blue.dark,
            borderLeftColor: theme_theme.palette.white.main,
            borderRightColor: theme_theme.palette.white.main,
            color: theme_theme.palette.blue.dark
        }
    },
    expanderButton: {
        style: {
            color: theme_theme.palette.blue.main,
            backgroundColor: theme_theme.palette.white.main,
            "&:hover:enabled": {
                cursor: "pointer"
            },
            "&:disabled": {
                color: theme_theme.palette.gray[10]
            },
            "&:hover:not(:disabled)": {
                cursor: "pointer",
                backgroundColor: theme_theme.palette.white.main
            },
            "&:focus": {
                outline: "none",
                backgroundColor: theme_theme.palette.white.main
            }
        }
    },
    headCells: {
        style: {
            fontSize: 16,
            fontWeight: "800",
            height: "56px",
            paddingLeft: "24px",
            paddingRight: "24px",
            color: theme_theme.palette.blue.dark,
            backgroundColor: theme_theme.palette.white.main
        }
    },
    cells: {
        style: {
            fontSize: 16,
            paddingLeft: "24px",
            paddingRight: "24px"
        }
    }
};
// Styles JUST for the sale invoice table
const saleInvoiceCustomListStyles = {
    pagination: {
        style: {
            color: theme_theme.palette.blue.dark
        },
        pageButtonsStyle: {
            fill: theme_theme.palette.blue.dark
        }
    },
    rows: {
        style: {
            minHeight: "72px",
            borderTopWidth: "16px",
            borderTopStyle: "solid",
            borderTopColor: theme_theme.palette.gray[5],
            backgroundColor: theme_theme.palette.white.main,
            color: theme_theme.palette.blue.dark,
            "&:not(:last-of-type)": {
                borderBottomStyle: "solid",
                borderBottomWidth: "1px",
                borderBottomColor: theme_theme.palette.white.main
            }
        }
    },
    expanderButton: {
        style: {
            color: theme_theme.palette.blue.main,
            backgroundColor: theme_theme.palette.white.main,
            "&:hover:enabled": {
                cursor: "pointer"
            },
            "&:disabled": {
                color: theme_theme.palette.gray[10]
            },
            "&:hover:not(:disabled)": {
                cursor: "pointer",
                backgroundColor: theme_theme.palette.white.main
            },
            "&:focus": {
                outline: "none",
                backgroundColor: theme_theme.palette.white.main
            }
        }
    },
    headCells: {
        style: {
            fontSize: 16,
            fontWeight: "800",
            height: "56px",
            paddingLeft: "24px",
            paddingRight: "24px",
            color: theme_theme.palette.blue.dark,
            backgroundColor: theme_theme.palette.white.main,
            borderBottomColor: theme_theme.palette.white.main
        }
    },
    cells: {
        style: {
            fontSize: 16,
            paddingLeft: "24px",
            paddingRight: "24px"
        }
    }
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-styles-virtual-b3f1d479f2/1/packages/lib-styles/src/button-styles.ts

const handleColorType = (buttonColor)=>{
    switch(buttonColor){
        case "whiteButton":
            return "p {color: ".concat(theme_theme.palette.blue.dark, "}; \n              background-color: ").concat(theme_theme.palette.white.main, "; \n              border-color: ").concat(theme_theme.palette.gray[10], ";              \n              :hover {\n                box-shadow: 0px 18px 45px rgba(0, 0, 0, 0.09);\n                border-color: ").concat(theme_theme.palette.transparent.main, ";\n              };");
        case "blueButton":
            return "p {color: ".concat(theme_theme.palette.white.main, "}; \n              background-color: ").concat(theme_theme.palette.blue.main, ";\n              :hover {background-color:  ").concat(theme_theme.palette.blue.dark, "};\n              :disabled {background-color: ").concat(theme_theme.palette.blue.lightest, ";              \n              border-color: ").concat(theme_theme.palette.blue.lightest, "};");
        case "yellowButton":
            return "p {color: ".concat(theme_theme.palette.blue.dark, "};\n              background-color: ").concat(theme_theme.palette.yellow.main, ";\n              border-color: ").concat(theme_theme.palette.yellow.main, "};\n              :hover {background-color:  ").concat(theme_theme.palette.yellow.dark, "};");
        case "orangeButton":
            return "p {color: ".concat(theme_theme.palette.white.main, "};\n              background-color: ").concat(theme_theme.palette.orange.main, ";\n              border-color: ").concat(theme_theme.palette.orange.main, "};\n              :hover {background-color:  ").concat(theme_theme.palette.orange.dark, "};");
        case "greenButton":
            return "p {color: ".concat(theme_theme.palette.white.main, "};\n              background-color: ").concat(theme_theme.palette.green.main, ";\n              border-color: ").concat(theme_theme.palette.green.main, "};\n              :hover {background-color:  ").concat(theme_theme.palette.green.dark, "};");
        case "redButton":
            return "p {color: ".concat(theme_theme.palette.triggers.warning.main, "};\n              border-color: ").concat(theme_theme.palette.triggers.warning.main, ";\n              background-color: ").concat(theme_theme.palette.white.main, ";\n              :hover {background-color:  ").concat(theme_theme.palette.triggers.warning.main, ";\n              svg {path {stroke: ").concat(theme_theme.palette.white.main, "}};\n              p {color: ").concat(theme_theme.palette.white.main, "}};");
        default:
            return "p {color: ".concat(theme_theme.palette.blue.dark, "}; \n              background-color: ").concat(theme_theme.palette.white.main, ";");
    }
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-styles-virtual-b3f1d479f2/1/packages/lib-styles/src/page-container-padding-left.ts
/* eslint-disable @typescript-eslint/no-explicit-any */ function page_container_padding_left_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function page_container_padding_left_templateObject() {
    const data = page_container_padding_left_taggedTemplateLiteral([
        "\n    @media screen and (min-width: ",
        "px) and (max-width: ",
        "px) {\n      padding-left: 24px;\n    }\n\n    @media screen and (min-width: ",
        "px) and (max-width: ",
        "px) {\n      padding-left: 24px;\n    }\n\n    @media screen and (min-width: ",
        "px) and (max-width: ",
        "px) {\n      padding-left: 48px;\n    }\n\n    @media screen and (min-width: ",
        "px) and (max-width: ",
        "px) {\n      padding-left: 48px;\n    }\n\n    @media screen and (min-width: ",
        "px) and (max-width: ",
        "px) {\n      padding-left: 48px;\n    }\n\n    @media screen and (min-width: ",
        "px) and (max-width: ",
        "px) {\n      padding-left: 56px;\n    }\n\n    @media screen and (min-width: ",
        "px) and (max-width: ",
        "px) {\n      padding-left: 56px;\n    }\n\n    @media screen and (min-width: ",
        "px) {\n      padding-left: 56px;\n    }\n  "
    ]);
    page_container_padding_left_templateObject = function() {
        return data;
    };
    return data;
}


const pageContainerPaddingLeft = ()=>{
    return css(page_container_padding_left_templateObject(), gridTheme.container.minWidth.xs, gridTheme.container.maxWidth.xs, gridTheme.container.minWidth.s, gridTheme.container.maxWidth.s, gridTheme.container.minWidth.sm, gridTheme.container.maxWidth.sm, gridTheme.container.minWidth.m, gridTheme.container.maxWidth.m, gridTheme.container.minWidth.mm, gridTheme.container.maxWidth.mm, gridTheme.container.minWidth.md, gridTheme.container.maxWidth.md, gridTheme.container.minWidth.lg, gridTheme.container.maxWidth.lg, gridTheme.container.minWidth.xl);
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-styles-virtual-b3f1d479f2/1/packages/lib-styles/src/page-container-padding-right.ts
/* eslint-disable @typescript-eslint/no-explicit-any */ function page_container_padding_right_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function page_container_padding_right_templateObject() {
    const data = page_container_padding_right_taggedTemplateLiteral([
        "\n    @media screen and (min-width: ",
        "px) and (max-width: ",
        "px) {\n      padding-right: 24px;\n    }\n\n    @media screen and (min-width: ",
        "px) and (max-width: ",
        "px) {\n      padding-right: 24px;\n    }\n\n    @media screen and (min-width: ",
        "px) and (max-width: ",
        "px) {\n      padding-right: 48px;\n    }\n\n    @media screen and (min-width: ",
        "px) and (max-width: ",
        "px) {\n      padding-right: 48px;\n    }\n\n    @media screen and (min-width: ",
        "px) and (max-width: ",
        "px) {\n      padding-right: 48px;\n    }\n\n    @media screen and (min-width: ",
        "px) and (max-width: ",
        "px) {\n      padding-right: 56px;\n    }\n\n    @media screen and (min-width: ",
        "px) and (max-width: ",
        "px) {\n      padding-right: 56px;\n    }\n\n    @media screen and (min-width: ",
        "px) {\n      padding-right: 56px;\n    }\n  "
    ]);
    page_container_padding_right_templateObject = function() {
        return data;
    };
    return data;
}


const pageContainerPaddingRight = ()=>{
    return css(page_container_padding_right_templateObject(), gridTheme.container.minWidth.xs, gridTheme.container.maxWidth.xs, gridTheme.container.minWidth.s, gridTheme.container.maxWidth.s, gridTheme.container.minWidth.sm, gridTheme.container.maxWidth.sm, gridTheme.container.minWidth.m, gridTheme.container.maxWidth.m, gridTheme.container.minWidth.mm, gridTheme.container.maxWidth.mm, gridTheme.container.minWidth.md, gridTheme.container.maxWidth.md, gridTheme.container.minWidth.lg, gridTheme.container.maxWidth.lg, gridTheme.container.minWidth.xl);
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-styles-virtual-b3f1d479f2/1/packages/lib-styles/src/animate.tsx
function animate_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function animate_templateObject() {
    const data = animate_taggedTemplateLiteral([
        "\n  position: relative;\n  opacity: 0;\n  transform: translateY(80px);\n  transition: opacity 0.6s, transform 0.6s;\n\n  &.visible {\n    opacity: 1;\n    transform: translateY(0);\n  }\n"
    ]);
    animate_templateObject = function() {
        return data;
    };
    return data;
}



const Wrapper = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-9c7dca4a-0"
})(animate_templateObject());
const MotionWrapper = (param)=>{
    let { children  } = param;
    const [isVisible, setIsVisible] = (0,react.useState)(false);
    const domRef = (0,react.useRef)(null);
    (0,react.useEffect)(()=>{
        if ( false || !("IntersectionObserver" in window)) {
            // If we're server-side rendering or the browser doesn't support IntersectionObserver,
            // skip setting up the observer and default to showing the component
            setIsVisible(true);
            return;
        }
        const observer = new IntersectionObserver((entries)=>{
            entries.forEach((entry)=>{
                if (entry.isIntersecting) {
                    setIsVisible(true);
                    if (domRef.current) {
                        observer.unobserve(domRef.current);
                    }
                }
            });
        });
        const node = domRef.current;
        if (node) {
            observer.observe(node);
        }
        return ()=>{
            if (node) {
                observer.unobserve(node);
            }
        };
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Wrapper, {
        ref: domRef,
        className: isVisible ? "visible" : "",
        children: children
    });
};


;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-styles-virtual-b3f1d479f2/1/packages/lib-styles/src/use-window-size/use-window-size.ts


const useWindowSize = ()=>{
    const [windowSize, setWindowSize] = (0,react.useState)({
        width: 0,
        height: 0,
        activeBreakPoint: "lg"
    });
    (0,react.useEffect)(()=>{
        const handleResize = ()=>{
            if (true) {
                let activeBreakpoint = "lg";
                if (window.innerWidth <= grid_theme_gridTheme.breakpoints.md) {
                    activeBreakpoint = "md";
                }
                if (window.innerWidth <= grid_theme_gridTheme.breakpoints.sm) {
                    activeBreakpoint = "sm";
                }
                if (window.innerWidth <= grid_theme_gridTheme.breakpoints.s) {
                    activeBreakpoint = "s";
                }
                if (window.innerWidth <= grid_theme_gridTheme.breakpoints.xs) {
                    activeBreakpoint = "xs";
                }
                if (window.innerWidth <= grid_theme_gridTheme.breakpoints.xxs) {
                    activeBreakpoint = "xs";
                }
                setWindowSize({
                    width: window.innerWidth,
                    height: window.innerHeight,
                    activeBreakPoint: activeBreakpoint
                });
            }
        };
        window.addEventListener("resize", handleResize);
        handleResize();
        return ()=>window.removeEventListener("resize", handleResize);
    }, []);
    return windowSize;
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-styles-virtual-b3f1d479f2/1/packages/lib-styles/src/use-window-size/index.ts


;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-styles-virtual-b3f1d479f2/1/packages/lib-styles/src/index.ts
















/***/ }),

/***/ 65582:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "EF": function() { return /* reexport */ POSTAL_CODES; },
  "my": function() { return /* reexport */ VALID_POSTAL_CODE_LIST; },
  "D6": function() { return /* reexport */ emailValidation; },
  "fL": function() { return /* reexport */ ensureList; },
  "Sg": function() { return /* reexport */ formatPriceNumber; },
  "om": function() { return /* reexport */ formatPriceString; },
  "Hp": function() { return /* reexport */ getBykoConfig; },
  "_m": function() { return /* reexport */ maxCharacterLength; },
  "A9": function() { return /* reexport */ paginationComponentOptions; },
  "Nr": function() { return /* reexport */ useDebounce; },
  "O_": function() { return /* reexport */ useIsClient; },
  "Kr": function() { return /* reexport */ useKeyPress; },
  "RO": function() { return /* reexport */ useOnScreen; },
  "D9": function() { return /* reexport */ usePrevious; }
});

// UNUSED EXPORTS: debounce, licencePlateValidation, maskValidation, monthValidation, numberOverZero, passwordValidation, removeExtraSpaces, setDiff, stringValidation, useHasCondition

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-utils-virtual-08ae943915/1/packages/lib-utils/src/format-price/format-price.ts
// Helper function to handle the common formatting logic
// This was taken from packages/lib-api-price/src/store.ts
const formatPrice = (amount)=>{
    return "".concat(new Intl.NumberFormat("is-IS", {
        style: "currency",
        currency: "ISK"
    }).format(Math.ceil(amount)).replace("ISK", "").split("").filter((x)=>x.trim() !== "").join("").replaceAll(/,/g, "."), " kr.").replace("&nbsp;", "").replace(/kr\. kr\./g, " kr.");
};
const formatPriceString = (price)=>{
    return formatPrice(parseFloat(price));
};
const formatPriceNumber = (price)=>{
    return formatPrice(price);
};

// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(91987);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-utils-virtual-08ae943915/1/packages/lib-utils/src/use-previous/use-previous.tsx

const usePrevious = function() {
    let value = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
    const ref = (0,react.useRef)(null);
    (0,react.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]);
    var _current;
    return (_current = ref.current) !== null && _current !== void 0 ? _current : null;
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-utils-virtual-08ae943915/1/packages/lib-utils/src/use-previous/index.ts


;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-utils-virtual-08ae943915/1/packages/lib-utils/src/max-character-length/max-character-length.tsx
const maxCharacterLength = (str, len)=>{
    if (!str) {
        return "";
    }
    const defaultLength = len || 28;
    return str.length > defaultLength + 5 ? "".concat(str.substring(0, defaultLength), "...") : str;
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-utils-virtual-08ae943915/1/packages/lib-utils/src/custom-react-data-table-component/pagination-component-options.ts
const paginationComponentOptions = {
    rowsPerPageText: "Ra\xf0ir \xe1 s\xed\xf0u",
    rangeSeparatorText: "af ",
    selectAllRowsItemText: "Allt",
    selectAllRowsItem: true
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-utils-virtual-08ae943915/1/packages/lib-utils/src/custom-react-data-table-component/index.ts


;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-utils-virtual-08ae943915/1/packages/lib-utils/src/form/validation.ts
// Validate that an email format is being used something@something.something
const emailValidation = /^([\wÀ-Úá-úþÞÝý+-.]+@[\wÀ-Úá-úþÞÝý+-]+\.[\wÀ-Úá-úþÞÝý+-.]+)$/;
// Validate that only letters are being used
const stringValidation = /^([\sA-Za-zÁ-Úá-úþÞÝý]*)$/;
// Validate that only letters are being used
const licencePlateValidation = /^([\sA-Za-zÁ-Úá-úþÞÝý0-9]*)$/;
// Ensure the mask in formik is not being confused with user input
const maskValidation = /^([^_]*)$/;
// Validate a number between 01-12 can be used for months
const monthValidation = /^([0-9]|0[1-9]|1[012])$/;
const numberOverZero = /^[1-9]\d*$/;
// Removes more than one spaces in a string
const passwordValidation = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,})/;
// Removes more than one spaces in a string
const removeExtraSpaces = (param)=>param.replace(/\s+/g, " ").trim();

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-utils-virtual-08ae943915/1/packages/lib-utils/src/debounce/debounce.ts
const debounce = (func, waitFor)=>{
    let timeout;
    const debounced = function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        window.clearTimeout(timeout);
        timeout = window.setTimeout(()=>func(...args), waitFor);
    };
    debounced.cancel = ()=>{
        window.clearTimeout(timeout);
    };
    return debounced;
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-utils-virtual-08ae943915/1/packages/lib-utils/src/debounce/use-debounce.ts


const useDebounce = (func, waitFor)=>{
    return (0,react.useMemo)(()=>{
        return debounce(func, waitFor);
    }, [
        func,
        waitFor
    ]);
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-utils-virtual-08ae943915/1/packages/lib-utils/src/debounce/index.ts



// EXTERNAL MODULE: ../../packages/types-utils/src/index.ts + 3 modules
var src = __webpack_require__(71612);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-utils-virtual-08ae943915/1/packages/lib-utils/src/get-byko-config.ts
/* provided dependency */ var process = __webpack_require__(97441);

const getBykoConfig = (key)=>{
    if ((0,src/* isSSR */.yF)()) {
        return process.env[key];
    }
    return window.__APP__CONFIG__[key];
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-utils-virtual-08ae943915/1/packages/lib-utils/src/use-key-press.ts

const useKeyPress = function(targetKey) {
    let log = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    // State for keeping track of whether key is pressed
    const [keyPressed, setKeyPressed] = (0,react.useState)(false);
    // If pressed key is our target key then set to true
    const downHandler = (0,react.useCallback)((param)=>{
        let { key  } = param;
        if (log) {
            // eslint-disable-next-line no-console
            console.log({
                target: targetKey,
                youPressed: key
            });
        }
        if (key === targetKey) {
            setKeyPressed(true);
        }
    }, [
        log,
        targetKey
    ]);
    // If released key is our target key then set to false
    const upHandler = (0,react.useCallback)((param)=>{
        let { key  } = param;
        if (key === targetKey) {
            setKeyPressed(false);
        }
    }, [
        targetKey
    ]);
    // Add event listeners
    (0,react.useEffect)(()=>{
        if (true) {
            window.addEventListener("keydown", downHandler);
            window.addEventListener("keyup", upHandler);
        // Remove event listeners on cleanup
        }
        return ()=>{
            if (true) {
                window.removeEventListener("keydown", downHandler);
                window.removeEventListener("keyup", upHandler);
            }
        };
    }, [
        downHandler,
        upHandler
    ]);
    return keyPressed;
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-utils-virtual-08ae943915/1/packages/lib-utils/src/use-is-check/use-is-client.ts
/**
 * Returns true if run from client.
 *
 * Avoids hydrations errors
 */ 
const useIsClient = ()=>{
    const [isClient, setIsClient] = (0,react.useState)(false);
    (0,react.useEffect)(()=>{
        setIsClient(true);
    }, []);
    return isClient;
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-utils-virtual-08ae943915/1/packages/lib-utils/src/use-is-check/use-has-condition.ts
/**
 * Returns true if condition is met.
 *
 * Avoids hydrations errors
 */ 
const useHasCondition = (fn, deps)=>{
    const [hasCondition, setHasCondition] = useState(false);
    const currentRun = useRef(0);
    useEffect(()=>{
        const myRun = currentRun.current + 1;
        currentRun.current = myRun;
        const promiseFn = async ()=>{
            if (currentRun.current !== myRun) {
                return;
            }
            const newCondition = await fn();
            setHasCondition(newCondition);
        };
        promiseFn();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, deps);
    return hasCondition;
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-utils-virtual-08ae943915/1/packages/lib-utils/src/use-is-check/index.ts



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-utils-virtual-08ae943915/1/packages/lib-utils/src/use-on-screen.tsx

function useOnScreen(ref) {
    const [isIntersecting, setIntersecting] = (0,react.useState)(false);
    (0,react.useEffect)(()=>{
        if ( false || typeof document === "undefined") {
            return;
        }
        // this is to ensure the cleanup method is called
        // using the same ref, in case the ref changes
        const refCopy = ref.current;
        const observer = new IntersectionObserver((param)=>{
            let [entry] = param;
            if (entry) {
                setIntersecting(entry.isIntersecting);
            }
        }, {
            root: null,
            rootMargin: "0px",
            threshold: 1.0
        });
        if (refCopy) {
            observer.observe(refCopy);
        }
        return ()=>{
            if (refCopy) {
                observer.unobserve(refCopy);
            }
        };
    }, [
        ref
    ]);
    return isIntersecting;
}

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-utils-virtual-08ae943915/1/packages/lib-utils/src/postal-codes.ts
const POSTAL_CODES = {
    "101": {
        value: "101",
        city: "Reykjav\xedk"
    },
    "102": {
        value: "102",
        city: "Reykjav\xedk"
    },
    "103": {
        value: "103",
        city: "Reykjav\xedk"
    },
    "104": {
        value: "104",
        city: "Reykjav\xedk"
    },
    "105": {
        value: "105",
        city: "Reykjav\xedk"
    },
    "107": {
        value: "107",
        city: "Reykjav\xedk"
    },
    "108": {
        value: "108",
        city: "Reykjav\xedk"
    },
    "109": {
        value: "109",
        city: "Reykjav\xedk"
    },
    "110": {
        value: "110",
        city: "Reykjav\xedk"
    },
    "111": {
        value: "111",
        city: "Reykjav\xedk"
    },
    "112": {
        value: "112",
        city: "Reykjav\xedk"
    },
    "113": {
        value: "113",
        city: "Reykjav\xedk"
    },
    "116": {
        value: "116",
        city: "Reykjav\xedk"
    },
    "121": {
        value: "121",
        city: "Reykjav\xedk"
    },
    "123": {
        value: "123",
        city: "Reykjav\xedk"
    },
    "124": {
        value: "124",
        city: "Reykjav\xedk"
    },
    "125": {
        value: "125",
        city: "Reykjav\xedk"
    },
    "127": {
        value: "127",
        city: "Reykjav\xedk"
    },
    "128": {
        value: "128",
        city: "Reykjav\xedk"
    },
    "129": {
        value: "129",
        city: "Reykjav\xedk"
    },
    "130": {
        value: "130",
        city: "Reykjav\xedk"
    },
    "132": {
        value: "132",
        city: "Reykjav\xedk"
    },
    "150": {
        value: "150",
        city: "(Opinberar"
    },
    "155": {
        value: "155",
        city: "Reykjav\xedk"
    },
    "161": {
        value: "161",
        city: "Reykjav\xedk"
    },
    "162": {
        value: "162",
        city: "Dreifb\xfdli"
    },
    "170": {
        value: "170",
        city: "Seltjarnarnesi"
    },
    "172": {
        value: "172",
        city: "Seltjarnarnesi"
    },
    "190": {
        value: "190",
        city: "Vogum"
    },
    "191": {
        value: "191",
        city: "Vogum"
    },
    "200": {
        value: "200",
        city: "K\xf3pavogi"
    },
    "201": {
        value: "201",
        city: "K\xf3pavogi"
    },
    "202": {
        value: "202",
        city: "K\xf3pavogi"
    },
    "203": {
        value: "203",
        city: "K\xf3pavogi"
    },
    "206": {
        value: "206",
        city: "K\xf3pavogi"
    },
    "210": {
        value: "210",
        city: "Gar\xf0ab\xe6"
    },
    "212": {
        value: "212",
        city: "Gar\xf0ab\xe6"
    },
    "220": {
        value: "220",
        city: "Hafnarfir\xf0i"
    },
    "221": {
        value: "221",
        city: "Hafnarfir\xf0i"
    },
    "222": {
        value: "222",
        city: "Hafnarfir\xf0i"
    },
    "225": {
        value: "225",
        city: "Gar\xf0ab\xe6"
    },
    "230": {
        value: "230",
        city: "Reykjanesb\xe6"
    },
    "232": {
        value: "232",
        city: "Reykjanesb\xe6"
    },
    "233": {
        value: "233",
        city: "Reykjanesb\xe6"
    },
    "235": {
        value: "235",
        city: "Keflav\xedkurflugvelli"
    },
    "240": {
        value: "240",
        city: "Grindav\xedk"
    },
    "241": {
        value: "241",
        city: "Grindav\xedk"
    },
    "245": {
        value: "245",
        city: "Su\xf0urnesjab\xe6"
    },
    "246": {
        value: "246",
        city: "Su\xf0urnesjab\xe6"
    },
    "250": {
        value: "250",
        city: "Su\xf0urnesjab\xe6"
    },
    "251": {
        value: "251",
        city: "Su\xf0urnesjab\xe6"
    },
    "260": {
        value: "260",
        city: "Reykjanesb\xe6"
    },
    "262": {
        value: "262",
        city: "Reykjanesb\xe6"
    },
    "270": {
        value: "270",
        city: "Mosfellsb\xe6"
    },
    "271": {
        value: "271",
        city: "Mosfellsb\xe6"
    },
    "276": {
        value: "276",
        city: "Mosfellsb\xe6"
    },
    "300": {
        value: "300",
        city: "Akranesi"
    },
    "301": {
        value: "301",
        city: "Akranesi"
    },
    "302": {
        value: "302",
        city: "Akranesi"
    },
    "310": {
        value: "310",
        city: "Borgarnesi"
    },
    "311": {
        value: "311",
        city: "Borgarnesi"
    },
    "320": {
        value: "320",
        city: "Borgarfir\xf0i"
    },
    "340": {
        value: "340",
        city: "Stykkish\xf3lmi"
    },
    "341": {
        value: "341",
        city: "Stykkish\xf3lmi"
    },
    "342": {
        value: "342",
        city: "Stykkish\xf3lmi"
    },
    "345": {
        value: "345",
        city: "Brei\xf0afir\xf0i"
    },
    "350": {
        value: "350",
        city: "Grundarfir\xf0i"
    },
    "351": {
        value: "351",
        city: "Grundarfir\xf0i"
    },
    "355": {
        value: "355",
        city: "\xd3lafsv\xedk"
    },
    "356": {
        value: "356",
        city: "Sn\xe6fellsb\xe6"
    },
    "360": {
        value: "360",
        city: "Hellissandi"
    },
    "370": {
        value: "370",
        city: "B\xfa\xf0ardal"
    },
    "371": {
        value: "371",
        city: "B\xfa\xf0ardal"
    },
    "380": {
        value: "380",
        city: "Reykh\xf3lahreppi"
    },
    "381": {
        value: "381",
        city: "Reykh\xf3lahreppi"
    },
    "400": {
        value: "400",
        city: "\xcdsafir\xf0i"
    },
    "401": {
        value: "401",
        city: "\xcdsafir\xf0i"
    },
    "410": {
        value: "410",
        city: "Hn\xedfsdal"
    },
    "415": {
        value: "415",
        city: "Bolungarv\xedk"
    },
    "416": {
        value: "416",
        city: "Bolungarv\xedk"
    },
    "420": {
        value: "420",
        city: "S\xfa\xf0av\xedk"
    },
    "421": {
        value: "421",
        city: "S\xfa\xf0av\xedk"
    },
    "425": {
        value: "425",
        city: "Flateyri"
    },
    "426": {
        value: "426",
        city: "Flateyri"
    },
    "430": {
        value: "430",
        city: "Su\xf0ureyri"
    },
    "431": {
        value: "431",
        city: "Su\xf0ureyri"
    },
    "450": {
        value: "450",
        city: "Patreksfir\xf0i"
    },
    "451": {
        value: "451",
        city: "Patreksfir\xf0i"
    },
    "460": {
        value: "460",
        city: "T\xe1lknafir\xf0i"
    },
    "461": {
        value: "461",
        city: "T\xe1lknafir\xf0i"
    },
    "465": {
        value: "465",
        city: "B\xedldudal"
    },
    "466": {
        value: "466",
        city: "B\xedldudal"
    },
    "470": {
        value: "470",
        city: "\xdeingeyri"
    },
    "471": {
        value: "471",
        city: "\xdeingeyri"
    },
    "500": {
        value: "500",
        city: "Sta\xf0"
    },
    "510": {
        value: "510",
        city: "H\xf3lmav\xedk"
    },
    "511": {
        value: "511",
        city: "H\xf3lmav\xedk"
    },
    "512": {
        value: "512",
        city: "H\xf3lmav\xedk"
    },
    "520": {
        value: "520",
        city: "Drangsnesi"
    },
    "524": {
        value: "524",
        city: "\xc1rneshreppi"
    },
    "530": {
        value: "530",
        city: "Hvammstanga"
    },
    "531": {
        value: "531",
        city: "Hvammstanga"
    },
    "540": {
        value: "540",
        city: "Bl\xf6ndu\xf3si"
    },
    "541": {
        value: "541",
        city: "Bl\xf6ndu\xf3si"
    },
    "545": {
        value: "545",
        city: "Skagastr\xf6nd"
    },
    "546": {
        value: "546",
        city: "Skagastr\xf6nd"
    },
    "550": {
        value: "550",
        city: "Sau\xf0\xe1rkr\xf3ki"
    },
    "551": {
        value: "551",
        city: "Sau\xf0\xe1rkr\xf3ki"
    },
    "560": {
        value: "560",
        city: "Varmahl\xed\xf0"
    },
    "561": {
        value: "561",
        city: "Varmahl\xed\xf0"
    },
    "565": {
        value: "565",
        city: "Hofs\xf3si"
    },
    "566": {
        value: "566",
        city: "Hofs\xf3si"
    },
    "570": {
        value: "570",
        city: "Flj\xf3tum"
    },
    "580": {
        value: "580",
        city: "Siglufir\xf0i"
    },
    "581": {
        value: "581",
        city: "Siglufir\xf0i"
    },
    "600": {
        value: "600",
        city: "Akureyri"
    },
    "601": {
        value: "601",
        city: "Akureyri"
    },
    "602": {
        value: "602",
        city: "Akureyri"
    },
    "603": {
        value: "603",
        city: "Akureyri"
    },
    "604": {
        value: "604",
        city: "Akureyri"
    },
    "605": {
        value: "605",
        city: "Akureyri"
    },
    "606": {
        value: "606",
        city: "Akureyri"
    },
    "607": {
        value: "607",
        city: "Akureyri"
    },
    "610": {
        value: "610",
        city: "Greniv\xedk"
    },
    "611": {
        value: "611",
        city: "Gr\xedmsey"
    },
    "616": {
        value: "616",
        city: "Greniv\xedk"
    },
    "620": {
        value: "620",
        city: "Dalv\xedk"
    },
    "621": {
        value: "621",
        city: "Dalv\xedk"
    },
    "625": {
        value: "625",
        city: "\xd3lafsfir\xf0i"
    },
    "626": {
        value: "626",
        city: "\xd3lafsfir\xf0i"
    },
    "630": {
        value: "630",
        city: "Hr\xedsey"
    },
    "640": {
        value: "640",
        city: "H\xfasav\xedk"
    },
    "641": {
        value: "641",
        city: "H\xfasav\xedk"
    },
    "645": {
        value: "645",
        city: "Fossh\xf3li"
    },
    "650": {
        value: "650",
        city: "Laugum"
    },
    "660": {
        value: "660",
        city: "M\xfdvatni"
    },
    "670": {
        value: "670",
        city: "K\xf3paskeri"
    },
    "671": {
        value: "671",
        city: "K\xf3paskeri"
    },
    "675": {
        value: "675",
        city: "Raufarh\xf6fn"
    },
    "676": {
        value: "676",
        city: "Raufarh\xf6fn"
    },
    "680": {
        value: "680",
        city: "\xde\xf3rsh\xf6fn"
    },
    "681": {
        value: "681",
        city: "\xde\xf3rsh\xf6fn"
    },
    "685": {
        value: "685",
        city: "Bakkafir\xf0i"
    },
    "686": {
        value: "686",
        city: "Bakkafir\xf0i"
    },
    "690": {
        value: "690",
        city: "Vopnafir\xf0i"
    },
    "691": {
        value: "691",
        city: "Vopnafir\xf0i"
    },
    "700": {
        value: "700",
        city: "Egilsst\xf6\xf0um"
    },
    "701": {
        value: "701",
        city: "Egilsst\xf6\xf0um"
    },
    "710": {
        value: "710",
        city: "Sey\xf0isfir\xf0i"
    },
    "711": {
        value: "711",
        city: "Sey\xf0isfir\xf0i"
    },
    "715": {
        value: "715",
        city: "Mj\xf3afir\xf0i"
    },
    "720": {
        value: "720",
        city: "eystri"
    },
    "721": {
        value: "721",
        city: "eystri"
    },
    "730": {
        value: "730",
        city: "Rey\xf0arfir\xf0i"
    },
    "731": {
        value: "731",
        city: "Rey\xf0arfir\xf0i"
    },
    "735": {
        value: "735",
        city: "Eskifir\xf0i"
    },
    "736": {
        value: "736",
        city: "Eskifir\xf0i"
    },
    "740": {
        value: "740",
        city: "Neskaupsta\xf0"
    },
    "741": {
        value: "741",
        city: "Neskaupsta\xf0"
    },
    "750": {
        value: "750",
        city: "F\xe1skr\xfa\xf0sfir\xf0i"
    },
    "751": {
        value: "751",
        city: "F\xe1skr\xfa\xf0sfir\xf0i"
    },
    "755": {
        value: "755",
        city: "St\xf6\xf0varfir\xf0i"
    },
    "756": {
        value: "756",
        city: "St\xf6\xf0varfir\xf0i"
    },
    "760": {
        value: "760",
        city: "Brei\xf0dalsv\xedk"
    },
    "761": {
        value: "761",
        city: "Brei\xf0dalsv\xedk"
    },
    "765": {
        value: "765",
        city: "Dj\xfapavogi"
    },
    "766": {
        value: "766",
        city: "Dj\xfapavogi"
    },
    "780": {
        value: "780",
        city: "Hornafir\xf0i"
    },
    "781": {
        value: "781",
        city: "Hornafir\xf0i"
    },
    "785": {
        value: "785",
        city: "\xd6r\xe6fum"
    },
    "800": {
        value: "800",
        city: "Selfossi"
    },
    "801": {
        value: "801",
        city: "Selfossi"
    },
    "802": {
        value: "802",
        city: "Selfossi"
    },
    "803": {
        value: "803",
        city: "Selfossi"
    },
    "804": {
        value: "804",
        city: "Selfossi"
    },
    "805": {
        value: "805",
        city: "Selfossi"
    },
    "806": {
        value: "806",
        city: "Selfossi"
    },
    "810": {
        value: "810",
        city: "Hverager\xf0i"
    },
    "815": {
        value: "815",
        city: "\xdeorl\xe1ksh\xf6fn"
    },
    "816": {
        value: "816",
        city: "\xd6lfus"
    },
    "820": {
        value: "820",
        city: "Eyrarbakka"
    },
    "825": {
        value: "825",
        city: "Stokkseyri"
    },
    "840": {
        value: "840",
        city: "Laugarvatni"
    },
    "845": {
        value: "845",
        city: "Fl\xfa\xf0um"
    },
    "846": {
        value: "846",
        city: "Fl\xfa\xf0um"
    },
    "850": {
        value: "850",
        city: "Hellu"
    },
    "851": {
        value: "851",
        city: "Hellu"
    },
    "860": {
        value: "860",
        city: "Hvolsvelli"
    },
    "861": {
        value: "861",
        city: "Hvolsvelli"
    },
    "870": {
        value: "870",
        city: "V\xedk"
    },
    "871": {
        value: "871",
        city: "V\xedk"
    },
    "880": {
        value: "880",
        city: "Kirkjub\xe6jarklaustri"
    },
    "881": {
        value: "881",
        city: "Kirkjub\xe6jarklaustri"
    },
    "900": {
        value: "900",
        city: "Vestmannaeyjum"
    },
    "902": {
        value: "902",
        city: "Vestmannaeyjum"
    }
};
const VALID_POSTAL_CODE_LIST = [
    "101",
    "102",
    "103",
    "104",
    "105",
    "107",
    "108",
    "109",
    "110",
    "111",
    "112",
    "113",
    "116",
    "121",
    "123",
    "124",
    "125",
    "127",
    "128",
    "129",
    "130",
    "132",
    "150",
    "155",
    "161",
    "162",
    "170",
    "172",
    "190",
    "191",
    "200",
    "201",
    "202",
    "203",
    "206",
    "210",
    "212",
    "220",
    "221",
    "222",
    "225",
    "230",
    "232",
    "233",
    "235",
    "240",
    "241",
    "245",
    "246",
    "250",
    "251",
    "260",
    "262",
    "270",
    "271",
    "276",
    "300",
    "301",
    "302",
    "310",
    "311",
    "320",
    "340",
    "341",
    "342",
    "345",
    "350",
    "351",
    "355",
    "356",
    "360",
    "370",
    "371",
    "380",
    "381",
    "400",
    "401",
    "410",
    "415",
    "416",
    "420",
    "421",
    "425",
    "426",
    "430",
    "431",
    "450",
    "451",
    "460",
    "461",
    "465",
    "466",
    "470",
    "471",
    "500",
    "510",
    "511",
    "512",
    "520",
    "524",
    "530",
    "531",
    "540",
    "541",
    "545",
    "546",
    "550",
    "551",
    "560",
    "561",
    "565",
    "566",
    "570",
    "580",
    "581",
    "600",
    "601",
    "602",
    "603",
    "604",
    "605",
    "606",
    "607",
    "610",
    "611",
    "616",
    "620",
    "621",
    "625",
    "626",
    "630",
    "640",
    "641",
    "645",
    "650",
    "660",
    "670",
    "671",
    "675",
    "676",
    "680",
    "681",
    "685",
    "686",
    "690",
    "691",
    "700",
    "701",
    "710",
    "711",
    "715",
    "720",
    "721",
    "730",
    "731",
    "735",
    "736",
    "740",
    "741",
    "750",
    "751",
    "755",
    "756",
    "760",
    "761",
    "765",
    "766",
    "780",
    "781",
    "785",
    "800",
    "801",
    "802",
    "803",
    "804",
    "805",
    "806",
    "810",
    "815",
    "816",
    "820",
    "825",
    "840",
    "845",
    "846",
    "850",
    "851",
    "860",
    "861",
    "870",
    "871",
    "880",
    "881",
    "900",
    "902"
];

// EXTERNAL MODULE: ../../.yarn/cache/lodash-npm-4.17.21-6382451519-eb835a2e51.zip/node_modules/lodash/lodash.js
var lodash = __webpack_require__(35735);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-utils-virtual-08ae943915/1/packages/lib-utils/src/ensure-list/ensure-list.ts
/* eslint-disable @typescript-eslint/explicit-function-return-type */ 
/**
 * Always returns a list with `null` and `undefined` values removed.
 *
 * ```typescript
 * ensureList() // => []
 * ensureList(null) // => []
 * ensureList([null, undefined, true, false, '', 0]) // => [true, false, '', 0]
 * ```
 */ function ensureList(list) {
    return (0,lodash.filter)((0,lodash.isArray)(list) ? list : [
        list
    ], (x)=>x != null);
}

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-utils-virtual-08ae943915/1/packages/lib-utils/src/ensure-list/index.ts


;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-lib-utils-virtual-08ae943915/1/packages/lib-utils/src/index.ts















/***/ }),

/***/ 71667:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "p": function() { return /* reexport */ TextBlockVariantOne; }
});

// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(61261);
// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(91987);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-component-buttons-virtual-1a577fdc8c/1/packages/component-buttons/src/index.ts + 16 modules
var src = __webpack_require__(80620);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-component-typography-virtual-537720fdd1/1/packages/component-typography/src/index.ts + 2 modules
var component_typography_src = __webpack_require__(91371);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-lib-icons-virtual-412b14e947/1/packages/lib-icons/src/index.ts + 181 modules
var lib_icons_src = __webpack_require__(45628);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-lib-styles-virtual-b3f1d479f2/1/packages/lib-styles/src/index.ts + 18 modules
var lib_styles_src = __webpack_require__(52203);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-text-block-variant-one-virtual-a533df4313/1/packages/component-text-block-variant-one/src/components/paragraph.tsx

const Paragraph = (param)=>{
    let { paragraph  } = param;
    const localParagraph = (0,react.useMemo)(()=>{
        try {
            // Removes all instances of h1 and h2 tags, data originates from DatoCMS
            const children = paragraph.props.data.value.document.children.filter((child)=>{
                return !(child.type === "heading" && child.level === 1) && !(child.type === "heading" && child.level === 2);
            });
            return {
                ...paragraph,
                props: {
                    ...paragraph.props,
                    data: {
                        ...paragraph.props.data,
                        value: {
                            ...paragraph.props.data.value,
                            document: {
                                ...paragraph.props.data.value.document,
                                children
                            }
                        }
                    }
                }
            };
        } catch (e) {
            return paragraph;
        }
    }, [
        paragraph
    ]);
    return localParagraph;
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-text-block-variant-one-virtual-a533df4313/1/packages/component-text-block-variant-one/src/components/index.ts


// EXTERNAL MODULE: ../../.yarn/__virtual__/styled-components-virtual-29066d9421/0/cache/styled-components-npm-5.3.5-88e3937b59-05a664dfe4.zip/node_modules/styled-components/dist/styled-components.browser.cjs.js
var styled_components_browser_cjs = __webpack_require__(33982);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-text-block-variant-one-virtual-a533df4313/1/packages/component-text-block-variant-one/src/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    const data = _taggedTemplateLiteral([
        "\n  position: relative;\n  margin-bottom: 60px;\n  color: ",
        ";\n  font-size: 20px;\n  line-height: 150%;\n\n  p {\n    margin: 0;\n    margin-bottom: 16px;\n    color: ",
        ';\n    line-height: 170%;\n    overflow-wrap: break-word;\n    text-align: "inherit";\n    strong {\n      margin-top: 16px;\n      font-weight: bold;\n    }\n  }\n\n  a {\n    color: ',
        ";\n    font-weight: bold;\n  }\n\n  h3,\n  h4,\n  h5,\n  h6 {\n    ",
        ";\n    margin-top: 16px;\n    margin-bottom: 16px;\n    color: ",
        ";\n    font-weight: normal;\n  }\n\n  h3 {\n    font-size: 18px;\n    @media screen and (max-width: 375px) {\n      font-size: 18px;\n    }\n  }\n\n  h4 {\n    font-size: 16px;\n    font-weight: normal;\n    @media screen and (max-width: 375px) {\n      font-size: 16px;\n    }\n  }\n\n  h5 {\n    font-size: 16px;\n    font-weight: normal;\n    @media screen and (max-width: 375px) {\n      font-size: 16px;\n    }\n  }\n\n  h6 {\n    font-size: 14px;\n    font-weight: normal;\n    @media screen and (max-width: 375px) {\n      font-size: 14px;\n    }\n  }\n  h1,\n  h2 {\n    display: none;\n  }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _taggedTemplateLiteral([
        "\n  margin-bottom: 16px;\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = _taggedTemplateLiteral([
        "\n  position: relative;\n  ",
        " {\n    p {\n      column-count: ",
        ";\n      column-gap: 16px;\n      column-width: ",
        ";\n      line-height: 170%;\n      white-space: pre-line;\n      &::selection {\n        background-color: ",
        ";\n      }\n    }\n  }\n  h4 {\n    padding: 0;\n    margin: 0;\n    line-height: 120%;\n    transform: translate3d(0, 18px, 0);\n  }\n"
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = _taggedTemplateLiteral([
        "\n  width: 96px;\n  height: 2px;\n  margin-top: 24px;\n  margin-bottom: 24px;\n  background-color: ",
        ";\n"
    ]);
    _templateObject3 = function() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  margin-bottom: ",
        ";\n  svg {\n    margin-right: 32px;\n    margin-left: 24px;\n  }\n"
    ]);
    _templateObject4 = function() {
        return data;
    };
    return data;
}
function _templateObject5() {
    const data = _taggedTemplateLiteral([
        "\n  padding: 48px;\n  background-color: ",
        ";\n"
    ]);
    _templateObject5 = function() {
        return data;
    };
    return data;
}



const MainParagraphContainer = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-adc88a9-0"
})(_templateObject(), (props)=>props.textColor, (props)=>props.textColor, lib_styles_src/* theme.palette.blue.main */.rS.palette.blue.main, component_typography_src/* HeadingsStyles */.ZA, (param)=>{
    let { textColor  } = param;
    return textColor ? textColor : lib_styles_src/* theme.palette.blue.dark */.rS.palette.blue.dark;
});
const IntroParagraphContainer = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-adc88a9-1"
})(_templateObject1());
var ref;
const Container = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-adc88a9-2"
})(_templateObject2(), MainParagraphContainer, (props)=>{
    var ref1;
    return (ref = (ref1 = props.columns) === null || ref1 === void 0 ? void 0 : ref1.toString()) !== null && ref !== void 0 ? ref : "1";
}, (props)=>props.columns === 3 ? "430px" : "544px", lib_styles_src/* theme.palette.yellow.main */.rS.palette.yellow.main);
const BlockLine = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-adc88a9-3"
})(_templateObject3(), (props)=>props.color);
const HeadingContainer = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-adc88a9-4"
})(_templateObject4(), (props)=>props.showUnderline ? "0" : "24px");
const SBBackdrop = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-adc88a9-5"
})(_templateObject5(), (props)=>props.darkMode ? lib_styles_src/* theme.palette.blue.dark */.rS.palette.blue.dark : lib_styles_src/* theme.palette.white.main */.rS.palette.white.main);

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-text-block-variant-one-virtual-a533df4313/1/packages/component-text-block-variant-one/src/text-block-variant-one.tsx










const TextBlockVariantOne = (param)=>{
    let { heading , introText , paragraph , darkMode =false , headingUnderlineColor ="blueLine" , showUnderline =true , headingDecoration: Icon , maxColumns =1 , headingSize =2 , headingTextColor =lib_styles_src/* theme.palette.blue.dark */.rS.palette.blue.dark , buttonLabel , buttonLink , buttonColor ="blueButton"  } = param;
    const { activeBreakPoint  } = (0,lib_styles_src/* useWindowSize */.iP)();
    const sanitizedHeading = (0,react.useMemo)(()=>{
        // remove nbsp
        return heading.replace(/\u00A0/, " ");
    }, [
        heading
    ]);
    const Heading = (0,react.useMemo)(()=>{
        switch(headingSize){
            case 1:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(component_typography_src.H1, {
                    maxFontSize: "42px",
                    textColor: darkMode ? lib_styles_src/* theme.palette.white.main */.rS.palette.white.main : headingTextColor !== null && headingTextColor !== void 0 ? headingTextColor : lib_styles_src/* theme.palette.blue.dark */.rS.palette.blue.dark,
                    uppercase: true,
                    children: sanitizedHeading
                });
            case 2:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(component_typography_src.H2, {
                    maxFontSize: "32px",
                    textColor: darkMode ? lib_styles_src/* theme.palette.white.main */.rS.palette.white.main : headingTextColor !== null && headingTextColor !== void 0 ? headingTextColor : lib_styles_src/* theme.palette.blue.dark */.rS.palette.blue.dark,
                    uppercase: true,
                    children: sanitizedHeading
                });
            case 3:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(component_typography_src.H3, {
                    textColor: darkMode ? lib_styles_src/* theme.palette.white.main */.rS.palette.white.main : headingTextColor !== null && headingTextColor !== void 0 ? headingTextColor : lib_styles_src/* theme.palette.blue.dark */.rS.palette.blue.dark,
                    uppercase: true,
                    children: sanitizedHeading
                });
            case 4:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(component_typography_src.H4, {
                    textColor: darkMode ? lib_styles_src/* theme.palette.white.main */.rS.palette.white.main : headingTextColor !== null && headingTextColor !== void 0 ? headingTextColor : lib_styles_src/* theme.palette.blue.dark */.rS.palette.blue.dark,
                    uppercase: true,
                    children: sanitizedHeading
                });
            case 5:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(component_typography_src.H5, {
                    textColor: darkMode ? lib_styles_src/* theme.palette.white.main */.rS.palette.white.main : headingTextColor !== null && headingTextColor !== void 0 ? headingTextColor : lib_styles_src/* theme.palette.blue.dark */.rS.palette.blue.dark,
                    uppercase: true,
                    children: sanitizedHeading
                });
            case 6:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(component_typography_src.H6, {
                    textColor: darkMode ? lib_styles_src/* theme.palette.white.main */.rS.palette.white.main : headingTextColor !== null && headingTextColor !== void 0 ? headingTextColor : lib_styles_src/* theme.palette.blue.dark */.rS.palette.blue.dark,
                    uppercase: true,
                    children: sanitizedHeading
                });
            default:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(component_typography_src.H4, {
                    textColor: darkMode ? lib_styles_src/* theme.palette.white.main */.rS.palette.white.main : headingTextColor !== null && headingTextColor !== void 0 ? headingTextColor : lib_styles_src/* theme.palette.blue.dark */.rS.palette.blue.dark,
                    children: sanitizedHeading
                });
        }
    }, [
        headingSize,
        darkMode,
        headingTextColor,
        sanitizedHeading
    ]);
    const lineColor = (0,react.useMemo)(()=>{
        if (darkMode) {
            return lib_styles_src/* theme.palette.yellow.main */.rS.palette.yellow.main;
        }
        switch(headingUnderlineColor){
            case "blueLine":
                return lib_styles_src/* theme.palette.blue.main */.rS.palette.blue.main;
            case "yellowLine":
                return lib_styles_src/* theme.palette.yellow.main */.rS.palette.yellow.main;
            default:
                return lib_styles_src/* theme.palette.blue.main */.rS.palette.blue.main;
        }
    }, [
        darkMode,
        headingUnderlineColor
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container, {
        className: "text-block-variant-one",
        columns: maxColumns,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(HeadingContainer, {
                showUnderline: showUnderline !== null && showUnderline !== void 0 ? showUnderline : true,
                children: [
                    Icon && !darkMode && /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon, {
                        size: 48
                    }),
                    Heading
                ]
            }),
            showUnderline && /*#__PURE__*/ (0,jsx_runtime.jsx)(BlockLine, {
                color: lineColor
            }),
            introText && introText.length && /*#__PURE__*/ (0,jsx_runtime.jsxs)(IntroParagraphContainer, {
                children: [
                    [
                        "md",
                        "lg",
                        "xl"
                    ].includes(activeBreakPoint) && /*#__PURE__*/ (0,jsx_runtime.jsx)(component_typography_src/* PLargeBold */.ej, {
                        textColor: darkMode ? lib_styles_src/* theme.palette.white.main */.rS.palette.white.main : lib_styles_src/* theme.palette.blue.dark */.rS.palette.blue.dark,
                        children: introText
                    }),
                    [
                        "s",
                        "sm",
                        "xs"
                    ].includes(activeBreakPoint) && /*#__PURE__*/ (0,jsx_runtime.jsx)(component_typography_src/* PMediumBold */.zo, {
                        textColor: darkMode ? lib_styles_src/* theme.palette.white.main */.rS.palette.white.main : lib_styles_src/* theme.palette.blue.dark */.rS.palette.blue.dark,
                        children: introText
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MainParagraphContainer, {
                textColor: darkMode ? lib_styles_src/* theme.palette.white.main */.rS.palette.white.main : lib_styles_src/* theme.palette.blue.dark */.rS.palette.blue.dark,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph, {
                    paragraph: paragraph
                })
            }),
            buttonLabel && /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* Button */.zx, {
                as: "href",
                buttonColor: buttonColor,
                href: buttonLink,
                icon: lib_icons_src.LongArrowSideIcons,
                label: buttonLabel
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-text-block-variant-one-virtual-a533df4313/1/packages/component-text-block-variant-one/src/index.ts



/***/ }),

/***/ 8462:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Hy": function() { return /* reexport safe */ formik__WEBPACK_IMPORTED_MODULE_0__.FormikProvider; },
/* harmony export */   "J9": function() { return /* reexport safe */ formik__WEBPACK_IMPORTED_MODULE_0__.Formik; },
/* harmony export */   "TA": function() { return /* reexport safe */ formik__WEBPACK_IMPORTED_MODULE_0__.useFormik; },
/* harmony export */   "U$": function() { return /* reexport safe */ formik__WEBPACK_IMPORTED_MODULE_0__.useField; },
/* harmony export */   "gN": function() { return /* reexport safe */ formik__WEBPACK_IMPORTED_MODULE_0__.Field; },
/* harmony export */   "l0": function() { return /* reexport safe */ formik__WEBPACK_IMPORTED_MODULE_0__.Form; }
/* harmony export */ });
/* harmony import */ var formik__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(20097);



/***/ }),

/***/ 71612:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "V5": function() { return /* reexport */ isJest; },
  "K0": function() { return /* reexport */ isNotNull; },
  "yF": function() { return /* reexport */ isSSR; }
});

;// CONCATENATED MODULE: ../../packages/types-utils/src/is-not-null.ts
const isNotNull = (value)=>{
    return typeof value !== "undefined" && value !== null;
};

;// CONCATENATED MODULE: ../../packages/types-utils/src/is-ssr.ts
const isSSR = ()=>{
    return "object" === "undefined";
};

;// CONCATENATED MODULE: ../../packages/types-utils/src/is-jest.ts
/* provided dependency */ var process = __webpack_require__(97441);
const isJest = ()=>{
    return process.env["JEST_WORKER_ID"] !== undefined;
};

;// CONCATENATED MODULE: ../../packages/types-utils/src/index.ts





/***/ }),

/***/ 85474:
/***/ (function(module) {

var __dirname = "/";
(function(){var e={675:function(e,r){"use strict";r.byteLength=byteLength;r.toByteArray=toByteArray;r.fromByteArray=fromByteArray;var t=[];var f=[];var n=typeof Uint8Array!=="undefined"?Uint8Array:Array;var i="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";for(var o=0,u=i.length;o<u;++o){t[o]=i[o];f[i.charCodeAt(o)]=o}f["-".charCodeAt(0)]=62;f["_".charCodeAt(0)]=63;function getLens(e){var r=e.length;if(r%4>0){throw new Error("Invalid string. Length must be a multiple of 4")}var t=e.indexOf("=");if(t===-1)t=r;var f=t===r?0:4-t%4;return[t,f]}function byteLength(e){var r=getLens(e);var t=r[0];var f=r[1];return(t+f)*3/4-f}function _byteLength(e,r,t){return(r+t)*3/4-t}function toByteArray(e){var r;var t=getLens(e);var i=t[0];var o=t[1];var u=new n(_byteLength(e,i,o));var a=0;var s=o>0?i-4:i;var h;for(h=0;h<s;h+=4){r=f[e.charCodeAt(h)]<<18|f[e.charCodeAt(h+1)]<<12|f[e.charCodeAt(h+2)]<<6|f[e.charCodeAt(h+3)];u[a++]=r>>16&255;u[a++]=r>>8&255;u[a++]=r&255}if(o===2){r=f[e.charCodeAt(h)]<<2|f[e.charCodeAt(h+1)]>>4;u[a++]=r&255}if(o===1){r=f[e.charCodeAt(h)]<<10|f[e.charCodeAt(h+1)]<<4|f[e.charCodeAt(h+2)]>>2;u[a++]=r>>8&255;u[a++]=r&255}return u}function tripletToBase64(e){return t[e>>18&63]+t[e>>12&63]+t[e>>6&63]+t[e&63]}function encodeChunk(e,r,t){var f;var n=[];for(var i=r;i<t;i+=3){f=(e[i]<<16&16711680)+(e[i+1]<<8&65280)+(e[i+2]&255);n.push(tripletToBase64(f))}return n.join("")}function fromByteArray(e){var r;var f=e.length;var n=f%3;var i=[];var o=16383;for(var u=0,a=f-n;u<a;u+=o){i.push(encodeChunk(e,u,u+o>a?a:u+o))}if(n===1){r=e[f-1];i.push(t[r>>2]+t[r<<4&63]+"==")}else if(n===2){r=(e[f-2]<<8)+e[f-1];i.push(t[r>>10]+t[r>>4&63]+t[r<<2&63]+"=")}return i.join("")}},72:function(e,r,t){"use strict";
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */var f=t(675);var n=t(783);var i=typeof Symbol==="function"&&typeof Symbol.for==="function"?Symbol.for("nodejs.util.inspect.custom"):null;r.Buffer=Buffer;r.SlowBuffer=SlowBuffer;r.INSPECT_MAX_BYTES=50;var o=2147483647;r.kMaxLength=o;Buffer.TYPED_ARRAY_SUPPORT=typedArraySupport();if(!Buffer.TYPED_ARRAY_SUPPORT&&typeof console!=="undefined"&&typeof console.error==="function"){console.error("This browser lacks typed array (Uint8Array) support which is required by "+"`buffer` v5.x. Use `buffer` v4.x if you require old browser support.")}function typedArraySupport(){try{var e=new Uint8Array(1);var r={foo:function(){return 42}};Object.setPrototypeOf(r,Uint8Array.prototype);Object.setPrototypeOf(e,r);return e.foo()===42}catch(e){return false}}Object.defineProperty(Buffer.prototype,"parent",{enumerable:true,get:function(){if(!Buffer.isBuffer(this))return undefined;return this.buffer}});Object.defineProperty(Buffer.prototype,"offset",{enumerable:true,get:function(){if(!Buffer.isBuffer(this))return undefined;return this.byteOffset}});function createBuffer(e){if(e>o){throw new RangeError('The value "'+e+'" is invalid for option "size"')}var r=new Uint8Array(e);Object.setPrototypeOf(r,Buffer.prototype);return r}function Buffer(e,r,t){if(typeof e==="number"){if(typeof r==="string"){throw new TypeError('The "string" argument must be of type string. Received type number')}return allocUnsafe(e)}return from(e,r,t)}Buffer.poolSize=8192;function from(e,r,t){if(typeof e==="string"){return fromString(e,r)}if(ArrayBuffer.isView(e)){return fromArrayLike(e)}if(e==null){throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, "+"or Array-like Object. Received type "+typeof e)}if(isInstance(e,ArrayBuffer)||e&&isInstance(e.buffer,ArrayBuffer)){return fromArrayBuffer(e,r,t)}if(typeof SharedArrayBuffer!=="undefined"&&(isInstance(e,SharedArrayBuffer)||e&&isInstance(e.buffer,SharedArrayBuffer))){return fromArrayBuffer(e,r,t)}if(typeof e==="number"){throw new TypeError('The "value" argument must not be of type number. Received type number')}var f=e.valueOf&&e.valueOf();if(f!=null&&f!==e){return Buffer.from(f,r,t)}var n=fromObject(e);if(n)return n;if(typeof Symbol!=="undefined"&&Symbol.toPrimitive!=null&&typeof e[Symbol.toPrimitive]==="function"){return Buffer.from(e[Symbol.toPrimitive]("string"),r,t)}throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, "+"or Array-like Object. Received type "+typeof e)}Buffer.from=function(e,r,t){return from(e,r,t)};Object.setPrototypeOf(Buffer.prototype,Uint8Array.prototype);Object.setPrototypeOf(Buffer,Uint8Array);function assertSize(e){if(typeof e!=="number"){throw new TypeError('"size" argument must be of type number')}else if(e<0){throw new RangeError('The value "'+e+'" is invalid for option "size"')}}function alloc(e,r,t){assertSize(e);if(e<=0){return createBuffer(e)}if(r!==undefined){return typeof t==="string"?createBuffer(e).fill(r,t):createBuffer(e).fill(r)}return createBuffer(e)}Buffer.alloc=function(e,r,t){return alloc(e,r,t)};function allocUnsafe(e){assertSize(e);return createBuffer(e<0?0:checked(e)|0)}Buffer.allocUnsafe=function(e){return allocUnsafe(e)};Buffer.allocUnsafeSlow=function(e){return allocUnsafe(e)};function fromString(e,r){if(typeof r!=="string"||r===""){r="utf8"}if(!Buffer.isEncoding(r)){throw new TypeError("Unknown encoding: "+r)}var t=byteLength(e,r)|0;var f=createBuffer(t);var n=f.write(e,r);if(n!==t){f=f.slice(0,n)}return f}function fromArrayLike(e){var r=e.length<0?0:checked(e.length)|0;var t=createBuffer(r);for(var f=0;f<r;f+=1){t[f]=e[f]&255}return t}function fromArrayBuffer(e,r,t){if(r<0||e.byteLength<r){throw new RangeError('"offset" is outside of buffer bounds')}if(e.byteLength<r+(t||0)){throw new RangeError('"length" is outside of buffer bounds')}var f;if(r===undefined&&t===undefined){f=new Uint8Array(e)}else if(t===undefined){f=new Uint8Array(e,r)}else{f=new Uint8Array(e,r,t)}Object.setPrototypeOf(f,Buffer.prototype);return f}function fromObject(e){if(Buffer.isBuffer(e)){var r=checked(e.length)|0;var t=createBuffer(r);if(t.length===0){return t}e.copy(t,0,0,r);return t}if(e.length!==undefined){if(typeof e.length!=="number"||numberIsNaN(e.length)){return createBuffer(0)}return fromArrayLike(e)}if(e.type==="Buffer"&&Array.isArray(e.data)){return fromArrayLike(e.data)}}function checked(e){if(e>=o){throw new RangeError("Attempt to allocate Buffer larger than maximum "+"size: 0x"+o.toString(16)+" bytes")}return e|0}function SlowBuffer(e){if(+e!=e){e=0}return Buffer.alloc(+e)}Buffer.isBuffer=function isBuffer(e){return e!=null&&e._isBuffer===true&&e!==Buffer.prototype};Buffer.compare=function compare(e,r){if(isInstance(e,Uint8Array))e=Buffer.from(e,e.offset,e.byteLength);if(isInstance(r,Uint8Array))r=Buffer.from(r,r.offset,r.byteLength);if(!Buffer.isBuffer(e)||!Buffer.isBuffer(r)){throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array')}if(e===r)return 0;var t=e.length;var f=r.length;for(var n=0,i=Math.min(t,f);n<i;++n){if(e[n]!==r[n]){t=e[n];f=r[n];break}}if(t<f)return-1;if(f<t)return 1;return 0};Buffer.isEncoding=function isEncoding(e){switch(String(e).toLowerCase()){case"hex":case"utf8":case"utf-8":case"ascii":case"latin1":case"binary":case"base64":case"ucs2":case"ucs-2":case"utf16le":case"utf-16le":return true;default:return false}};Buffer.concat=function concat(e,r){if(!Array.isArray(e)){throw new TypeError('"list" argument must be an Array of Buffers')}if(e.length===0){return Buffer.alloc(0)}var t;if(r===undefined){r=0;for(t=0;t<e.length;++t){r+=e[t].length}}var f=Buffer.allocUnsafe(r);var n=0;for(t=0;t<e.length;++t){var i=e[t];if(isInstance(i,Uint8Array)){i=Buffer.from(i)}if(!Buffer.isBuffer(i)){throw new TypeError('"list" argument must be an Array of Buffers')}i.copy(f,n);n+=i.length}return f};function byteLength(e,r){if(Buffer.isBuffer(e)){return e.length}if(ArrayBuffer.isView(e)||isInstance(e,ArrayBuffer)){return e.byteLength}if(typeof e!=="string"){throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. '+"Received type "+typeof e)}var t=e.length;var f=arguments.length>2&&arguments[2]===true;if(!f&&t===0)return 0;var n=false;for(;;){switch(r){case"ascii":case"latin1":case"binary":return t;case"utf8":case"utf-8":return utf8ToBytes(e).length;case"ucs2":case"ucs-2":case"utf16le":case"utf-16le":return t*2;case"hex":return t>>>1;case"base64":return base64ToBytes(e).length;default:if(n){return f?-1:utf8ToBytes(e).length}r=(""+r).toLowerCase();n=true}}}Buffer.byteLength=byteLength;function slowToString(e,r,t){var f=false;if(r===undefined||r<0){r=0}if(r>this.length){return""}if(t===undefined||t>this.length){t=this.length}if(t<=0){return""}t>>>=0;r>>>=0;if(t<=r){return""}if(!e)e="utf8";while(true){switch(e){case"hex":return hexSlice(this,r,t);case"utf8":case"utf-8":return utf8Slice(this,r,t);case"ascii":return asciiSlice(this,r,t);case"latin1":case"binary":return latin1Slice(this,r,t);case"base64":return base64Slice(this,r,t);case"ucs2":case"ucs-2":case"utf16le":case"utf-16le":return utf16leSlice(this,r,t);default:if(f)throw new TypeError("Unknown encoding: "+e);e=(e+"").toLowerCase();f=true}}}Buffer.prototype._isBuffer=true;function swap(e,r,t){var f=e[r];e[r]=e[t];e[t]=f}Buffer.prototype.swap16=function swap16(){var e=this.length;if(e%2!==0){throw new RangeError("Buffer size must be a multiple of 16-bits")}for(var r=0;r<e;r+=2){swap(this,r,r+1)}return this};Buffer.prototype.swap32=function swap32(){var e=this.length;if(e%4!==0){throw new RangeError("Buffer size must be a multiple of 32-bits")}for(var r=0;r<e;r+=4){swap(this,r,r+3);swap(this,r+1,r+2)}return this};Buffer.prototype.swap64=function swap64(){var e=this.length;if(e%8!==0){throw new RangeError("Buffer size must be a multiple of 64-bits")}for(var r=0;r<e;r+=8){swap(this,r,r+7);swap(this,r+1,r+6);swap(this,r+2,r+5);swap(this,r+3,r+4)}return this};Buffer.prototype.toString=function toString(){var e=this.length;if(e===0)return"";if(arguments.length===0)return utf8Slice(this,0,e);return slowToString.apply(this,arguments)};Buffer.prototype.toLocaleString=Buffer.prototype.toString;Buffer.prototype.equals=function equals(e){if(!Buffer.isBuffer(e))throw new TypeError("Argument must be a Buffer");if(this===e)return true;return Buffer.compare(this,e)===0};Buffer.prototype.inspect=function inspect(){var e="";var t=r.INSPECT_MAX_BYTES;e=this.toString("hex",0,t).replace(/(.{2})/g,"$1 ").trim();if(this.length>t)e+=" ... ";return"<Buffer "+e+">"};if(i){Buffer.prototype[i]=Buffer.prototype.inspect}Buffer.prototype.compare=function compare(e,r,t,f,n){if(isInstance(e,Uint8Array)){e=Buffer.from(e,e.offset,e.byteLength)}if(!Buffer.isBuffer(e)){throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. '+"Received type "+typeof e)}if(r===undefined){r=0}if(t===undefined){t=e?e.length:0}if(f===undefined){f=0}if(n===undefined){n=this.length}if(r<0||t>e.length||f<0||n>this.length){throw new RangeError("out of range index")}if(f>=n&&r>=t){return 0}if(f>=n){return-1}if(r>=t){return 1}r>>>=0;t>>>=0;f>>>=0;n>>>=0;if(this===e)return 0;var i=n-f;var o=t-r;var u=Math.min(i,o);var a=this.slice(f,n);var s=e.slice(r,t);for(var h=0;h<u;++h){if(a[h]!==s[h]){i=a[h];o=s[h];break}}if(i<o)return-1;if(o<i)return 1;return 0};function bidirectionalIndexOf(e,r,t,f,n){if(e.length===0)return-1;if(typeof t==="string"){f=t;t=0}else if(t>2147483647){t=2147483647}else if(t<-2147483648){t=-2147483648}t=+t;if(numberIsNaN(t)){t=n?0:e.length-1}if(t<0)t=e.length+t;if(t>=e.length){if(n)return-1;else t=e.length-1}else if(t<0){if(n)t=0;else return-1}if(typeof r==="string"){r=Buffer.from(r,f)}if(Buffer.isBuffer(r)){if(r.length===0){return-1}return arrayIndexOf(e,r,t,f,n)}else if(typeof r==="number"){r=r&255;if(typeof Uint8Array.prototype.indexOf==="function"){if(n){return Uint8Array.prototype.indexOf.call(e,r,t)}else{return Uint8Array.prototype.lastIndexOf.call(e,r,t)}}return arrayIndexOf(e,[r],t,f,n)}throw new TypeError("val must be string, number or Buffer")}function arrayIndexOf(e,r,t,f,n){var i=1;var o=e.length;var u=r.length;if(f!==undefined){f=String(f).toLowerCase();if(f==="ucs2"||f==="ucs-2"||f==="utf16le"||f==="utf-16le"){if(e.length<2||r.length<2){return-1}i=2;o/=2;u/=2;t/=2}}function read(e,r){if(i===1){return e[r]}else{return e.readUInt16BE(r*i)}}var a;if(n){var s=-1;for(a=t;a<o;a++){if(read(e,a)===read(r,s===-1?0:a-s)){if(s===-1)s=a;if(a-s+1===u)return s*i}else{if(s!==-1)a-=a-s;s=-1}}}else{if(t+u>o)t=o-u;for(a=t;a>=0;a--){var h=true;for(var c=0;c<u;c++){if(read(e,a+c)!==read(r,c)){h=false;break}}if(h)return a}}return-1}Buffer.prototype.includes=function includes(e,r,t){return this.indexOf(e,r,t)!==-1};Buffer.prototype.indexOf=function indexOf(e,r,t){return bidirectionalIndexOf(this,e,r,t,true)};Buffer.prototype.lastIndexOf=function lastIndexOf(e,r,t){return bidirectionalIndexOf(this,e,r,t,false)};function hexWrite(e,r,t,f){t=Number(t)||0;var n=e.length-t;if(!f){f=n}else{f=Number(f);if(f>n){f=n}}var i=r.length;if(f>i/2){f=i/2}for(var o=0;o<f;++o){var u=parseInt(r.substr(o*2,2),16);if(numberIsNaN(u))return o;e[t+o]=u}return o}function utf8Write(e,r,t,f){return blitBuffer(utf8ToBytes(r,e.length-t),e,t,f)}function asciiWrite(e,r,t,f){return blitBuffer(asciiToBytes(r),e,t,f)}function latin1Write(e,r,t,f){return asciiWrite(e,r,t,f)}function base64Write(e,r,t,f){return blitBuffer(base64ToBytes(r),e,t,f)}function ucs2Write(e,r,t,f){return blitBuffer(utf16leToBytes(r,e.length-t),e,t,f)}Buffer.prototype.write=function write(e,r,t,f){if(r===undefined){f="utf8";t=this.length;r=0}else if(t===undefined&&typeof r==="string"){f=r;t=this.length;r=0}else if(isFinite(r)){r=r>>>0;if(isFinite(t)){t=t>>>0;if(f===undefined)f="utf8"}else{f=t;t=undefined}}else{throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported")}var n=this.length-r;if(t===undefined||t>n)t=n;if(e.length>0&&(t<0||r<0)||r>this.length){throw new RangeError("Attempt to write outside buffer bounds")}if(!f)f="utf8";var i=false;for(;;){switch(f){case"hex":return hexWrite(this,e,r,t);case"utf8":case"utf-8":return utf8Write(this,e,r,t);case"ascii":return asciiWrite(this,e,r,t);case"latin1":case"binary":return latin1Write(this,e,r,t);case"base64":return base64Write(this,e,r,t);case"ucs2":case"ucs-2":case"utf16le":case"utf-16le":return ucs2Write(this,e,r,t);default:if(i)throw new TypeError("Unknown encoding: "+f);f=(""+f).toLowerCase();i=true}}};Buffer.prototype.toJSON=function toJSON(){return{type:"Buffer",data:Array.prototype.slice.call(this._arr||this,0)}};function base64Slice(e,r,t){if(r===0&&t===e.length){return f.fromByteArray(e)}else{return f.fromByteArray(e.slice(r,t))}}function utf8Slice(e,r,t){t=Math.min(e.length,t);var f=[];var n=r;while(n<t){var i=e[n];var o=null;var u=i>239?4:i>223?3:i>191?2:1;if(n+u<=t){var a,s,h,c;switch(u){case 1:if(i<128){o=i}break;case 2:a=e[n+1];if((a&192)===128){c=(i&31)<<6|a&63;if(c>127){o=c}}break;case 3:a=e[n+1];s=e[n+2];if((a&192)===128&&(s&192)===128){c=(i&15)<<12|(a&63)<<6|s&63;if(c>2047&&(c<55296||c>57343)){o=c}}break;case 4:a=e[n+1];s=e[n+2];h=e[n+3];if((a&192)===128&&(s&192)===128&&(h&192)===128){c=(i&15)<<18|(a&63)<<12|(s&63)<<6|h&63;if(c>65535&&c<1114112){o=c}}}}if(o===null){o=65533;u=1}else if(o>65535){o-=65536;f.push(o>>>10&1023|55296);o=56320|o&1023}f.push(o);n+=u}return decodeCodePointsArray(f)}var u=4096;function decodeCodePointsArray(e){var r=e.length;if(r<=u){return String.fromCharCode.apply(String,e)}var t="";var f=0;while(f<r){t+=String.fromCharCode.apply(String,e.slice(f,f+=u))}return t}function asciiSlice(e,r,t){var f="";t=Math.min(e.length,t);for(var n=r;n<t;++n){f+=String.fromCharCode(e[n]&127)}return f}function latin1Slice(e,r,t){var f="";t=Math.min(e.length,t);for(var n=r;n<t;++n){f+=String.fromCharCode(e[n])}return f}function hexSlice(e,r,t){var f=e.length;if(!r||r<0)r=0;if(!t||t<0||t>f)t=f;var n="";for(var i=r;i<t;++i){n+=s[e[i]]}return n}function utf16leSlice(e,r,t){var f=e.slice(r,t);var n="";for(var i=0;i<f.length;i+=2){n+=String.fromCharCode(f[i]+f[i+1]*256)}return n}Buffer.prototype.slice=function slice(e,r){var t=this.length;e=~~e;r=r===undefined?t:~~r;if(e<0){e+=t;if(e<0)e=0}else if(e>t){e=t}if(r<0){r+=t;if(r<0)r=0}else if(r>t){r=t}if(r<e)r=e;var f=this.subarray(e,r);Object.setPrototypeOf(f,Buffer.prototype);return f};function checkOffset(e,r,t){if(e%1!==0||e<0)throw new RangeError("offset is not uint");if(e+r>t)throw new RangeError("Trying to access beyond buffer length")}Buffer.prototype.readUIntLE=function readUIntLE(e,r,t){e=e>>>0;r=r>>>0;if(!t)checkOffset(e,r,this.length);var f=this[e];var n=1;var i=0;while(++i<r&&(n*=256)){f+=this[e+i]*n}return f};Buffer.prototype.readUIntBE=function readUIntBE(e,r,t){e=e>>>0;r=r>>>0;if(!t){checkOffset(e,r,this.length)}var f=this[e+--r];var n=1;while(r>0&&(n*=256)){f+=this[e+--r]*n}return f};Buffer.prototype.readUInt8=function readUInt8(e,r){e=e>>>0;if(!r)checkOffset(e,1,this.length);return this[e]};Buffer.prototype.readUInt16LE=function readUInt16LE(e,r){e=e>>>0;if(!r)checkOffset(e,2,this.length);return this[e]|this[e+1]<<8};Buffer.prototype.readUInt16BE=function readUInt16BE(e,r){e=e>>>0;if(!r)checkOffset(e,2,this.length);return this[e]<<8|this[e+1]};Buffer.prototype.readUInt32LE=function readUInt32LE(e,r){e=e>>>0;if(!r)checkOffset(e,4,this.length);return(this[e]|this[e+1]<<8|this[e+2]<<16)+this[e+3]*16777216};Buffer.prototype.readUInt32BE=function readUInt32BE(e,r){e=e>>>0;if(!r)checkOffset(e,4,this.length);return this[e]*16777216+(this[e+1]<<16|this[e+2]<<8|this[e+3])};Buffer.prototype.readIntLE=function readIntLE(e,r,t){e=e>>>0;r=r>>>0;if(!t)checkOffset(e,r,this.length);var f=this[e];var n=1;var i=0;while(++i<r&&(n*=256)){f+=this[e+i]*n}n*=128;if(f>=n)f-=Math.pow(2,8*r);return f};Buffer.prototype.readIntBE=function readIntBE(e,r,t){e=e>>>0;r=r>>>0;if(!t)checkOffset(e,r,this.length);var f=r;var n=1;var i=this[e+--f];while(f>0&&(n*=256)){i+=this[e+--f]*n}n*=128;if(i>=n)i-=Math.pow(2,8*r);return i};Buffer.prototype.readInt8=function readInt8(e,r){e=e>>>0;if(!r)checkOffset(e,1,this.length);if(!(this[e]&128))return this[e];return(255-this[e]+1)*-1};Buffer.prototype.readInt16LE=function readInt16LE(e,r){e=e>>>0;if(!r)checkOffset(e,2,this.length);var t=this[e]|this[e+1]<<8;return t&32768?t|4294901760:t};Buffer.prototype.readInt16BE=function readInt16BE(e,r){e=e>>>0;if(!r)checkOffset(e,2,this.length);var t=this[e+1]|this[e]<<8;return t&32768?t|4294901760:t};Buffer.prototype.readInt32LE=function readInt32LE(e,r){e=e>>>0;if(!r)checkOffset(e,4,this.length);return this[e]|this[e+1]<<8|this[e+2]<<16|this[e+3]<<24};Buffer.prototype.readInt32BE=function readInt32BE(e,r){e=e>>>0;if(!r)checkOffset(e,4,this.length);return this[e]<<24|this[e+1]<<16|this[e+2]<<8|this[e+3]};Buffer.prototype.readFloatLE=function readFloatLE(e,r){e=e>>>0;if(!r)checkOffset(e,4,this.length);return n.read(this,e,true,23,4)};Buffer.prototype.readFloatBE=function readFloatBE(e,r){e=e>>>0;if(!r)checkOffset(e,4,this.length);return n.read(this,e,false,23,4)};Buffer.prototype.readDoubleLE=function readDoubleLE(e,r){e=e>>>0;if(!r)checkOffset(e,8,this.length);return n.read(this,e,true,52,8)};Buffer.prototype.readDoubleBE=function readDoubleBE(e,r){e=e>>>0;if(!r)checkOffset(e,8,this.length);return n.read(this,e,false,52,8)};function checkInt(e,r,t,f,n,i){if(!Buffer.isBuffer(e))throw new TypeError('"buffer" argument must be a Buffer instance');if(r>n||r<i)throw new RangeError('"value" argument is out of bounds');if(t+f>e.length)throw new RangeError("Index out of range")}Buffer.prototype.writeUIntLE=function writeUIntLE(e,r,t,f){e=+e;r=r>>>0;t=t>>>0;if(!f){var n=Math.pow(2,8*t)-1;checkInt(this,e,r,t,n,0)}var i=1;var o=0;this[r]=e&255;while(++o<t&&(i*=256)){this[r+o]=e/i&255}return r+t};Buffer.prototype.writeUIntBE=function writeUIntBE(e,r,t,f){e=+e;r=r>>>0;t=t>>>0;if(!f){var n=Math.pow(2,8*t)-1;checkInt(this,e,r,t,n,0)}var i=t-1;var o=1;this[r+i]=e&255;while(--i>=0&&(o*=256)){this[r+i]=e/o&255}return r+t};Buffer.prototype.writeUInt8=function writeUInt8(e,r,t){e=+e;r=r>>>0;if(!t)checkInt(this,e,r,1,255,0);this[r]=e&255;return r+1};Buffer.prototype.writeUInt16LE=function writeUInt16LE(e,r,t){e=+e;r=r>>>0;if(!t)checkInt(this,e,r,2,65535,0);this[r]=e&255;this[r+1]=e>>>8;return r+2};Buffer.prototype.writeUInt16BE=function writeUInt16BE(e,r,t){e=+e;r=r>>>0;if(!t)checkInt(this,e,r,2,65535,0);this[r]=e>>>8;this[r+1]=e&255;return r+2};Buffer.prototype.writeUInt32LE=function writeUInt32LE(e,r,t){e=+e;r=r>>>0;if(!t)checkInt(this,e,r,4,4294967295,0);this[r+3]=e>>>24;this[r+2]=e>>>16;this[r+1]=e>>>8;this[r]=e&255;return r+4};Buffer.prototype.writeUInt32BE=function writeUInt32BE(e,r,t){e=+e;r=r>>>0;if(!t)checkInt(this,e,r,4,4294967295,0);this[r]=e>>>24;this[r+1]=e>>>16;this[r+2]=e>>>8;this[r+3]=e&255;return r+4};Buffer.prototype.writeIntLE=function writeIntLE(e,r,t,f){e=+e;r=r>>>0;if(!f){var n=Math.pow(2,8*t-1);checkInt(this,e,r,t,n-1,-n)}var i=0;var o=1;var u=0;this[r]=e&255;while(++i<t&&(o*=256)){if(e<0&&u===0&&this[r+i-1]!==0){u=1}this[r+i]=(e/o>>0)-u&255}return r+t};Buffer.prototype.writeIntBE=function writeIntBE(e,r,t,f){e=+e;r=r>>>0;if(!f){var n=Math.pow(2,8*t-1);checkInt(this,e,r,t,n-1,-n)}var i=t-1;var o=1;var u=0;this[r+i]=e&255;while(--i>=0&&(o*=256)){if(e<0&&u===0&&this[r+i+1]!==0){u=1}this[r+i]=(e/o>>0)-u&255}return r+t};Buffer.prototype.writeInt8=function writeInt8(e,r,t){e=+e;r=r>>>0;if(!t)checkInt(this,e,r,1,127,-128);if(e<0)e=255+e+1;this[r]=e&255;return r+1};Buffer.prototype.writeInt16LE=function writeInt16LE(e,r,t){e=+e;r=r>>>0;if(!t)checkInt(this,e,r,2,32767,-32768);this[r]=e&255;this[r+1]=e>>>8;return r+2};Buffer.prototype.writeInt16BE=function writeInt16BE(e,r,t){e=+e;r=r>>>0;if(!t)checkInt(this,e,r,2,32767,-32768);this[r]=e>>>8;this[r+1]=e&255;return r+2};Buffer.prototype.writeInt32LE=function writeInt32LE(e,r,t){e=+e;r=r>>>0;if(!t)checkInt(this,e,r,4,2147483647,-2147483648);this[r]=e&255;this[r+1]=e>>>8;this[r+2]=e>>>16;this[r+3]=e>>>24;return r+4};Buffer.prototype.writeInt32BE=function writeInt32BE(e,r,t){e=+e;r=r>>>0;if(!t)checkInt(this,e,r,4,2147483647,-2147483648);if(e<0)e=4294967295+e+1;this[r]=e>>>24;this[r+1]=e>>>16;this[r+2]=e>>>8;this[r+3]=e&255;return r+4};function checkIEEE754(e,r,t,f,n,i){if(t+f>e.length)throw new RangeError("Index out of range");if(t<0)throw new RangeError("Index out of range")}function writeFloat(e,r,t,f,i){r=+r;t=t>>>0;if(!i){checkIEEE754(e,r,t,4,34028234663852886e22,-34028234663852886e22)}n.write(e,r,t,f,23,4);return t+4}Buffer.prototype.writeFloatLE=function writeFloatLE(e,r,t){return writeFloat(this,e,r,true,t)};Buffer.prototype.writeFloatBE=function writeFloatBE(e,r,t){return writeFloat(this,e,r,false,t)};function writeDouble(e,r,t,f,i){r=+r;t=t>>>0;if(!i){checkIEEE754(e,r,t,8,17976931348623157e292,-17976931348623157e292)}n.write(e,r,t,f,52,8);return t+8}Buffer.prototype.writeDoubleLE=function writeDoubleLE(e,r,t){return writeDouble(this,e,r,true,t)};Buffer.prototype.writeDoubleBE=function writeDoubleBE(e,r,t){return writeDouble(this,e,r,false,t)};Buffer.prototype.copy=function copy(e,r,t,f){if(!Buffer.isBuffer(e))throw new TypeError("argument should be a Buffer");if(!t)t=0;if(!f&&f!==0)f=this.length;if(r>=e.length)r=e.length;if(!r)r=0;if(f>0&&f<t)f=t;if(f===t)return 0;if(e.length===0||this.length===0)return 0;if(r<0){throw new RangeError("targetStart out of bounds")}if(t<0||t>=this.length)throw new RangeError("Index out of range");if(f<0)throw new RangeError("sourceEnd out of bounds");if(f>this.length)f=this.length;if(e.length-r<f-t){f=e.length-r+t}var n=f-t;if(this===e&&typeof Uint8Array.prototype.copyWithin==="function"){this.copyWithin(r,t,f)}else if(this===e&&t<r&&r<f){for(var i=n-1;i>=0;--i){e[i+r]=this[i+t]}}else{Uint8Array.prototype.set.call(e,this.subarray(t,f),r)}return n};Buffer.prototype.fill=function fill(e,r,t,f){if(typeof e==="string"){if(typeof r==="string"){f=r;r=0;t=this.length}else if(typeof t==="string"){f=t;t=this.length}if(f!==undefined&&typeof f!=="string"){throw new TypeError("encoding must be a string")}if(typeof f==="string"&&!Buffer.isEncoding(f)){throw new TypeError("Unknown encoding: "+f)}if(e.length===1){var n=e.charCodeAt(0);if(f==="utf8"&&n<128||f==="latin1"){e=n}}}else if(typeof e==="number"){e=e&255}else if(typeof e==="boolean"){e=Number(e)}if(r<0||this.length<r||this.length<t){throw new RangeError("Out of range index")}if(t<=r){return this}r=r>>>0;t=t===undefined?this.length:t>>>0;if(!e)e=0;var i;if(typeof e==="number"){for(i=r;i<t;++i){this[i]=e}}else{var o=Buffer.isBuffer(e)?e:Buffer.from(e,f);var u=o.length;if(u===0){throw new TypeError('The value "'+e+'" is invalid for argument "value"')}for(i=0;i<t-r;++i){this[i+r]=o[i%u]}}return this};var a=/[^+/0-9A-Za-z-_]/g;function base64clean(e){e=e.split("=")[0];e=e.trim().replace(a,"");if(e.length<2)return"";while(e.length%4!==0){e=e+"="}return e}function utf8ToBytes(e,r){r=r||Infinity;var t;var f=e.length;var n=null;var i=[];for(var o=0;o<f;++o){t=e.charCodeAt(o);if(t>55295&&t<57344){if(!n){if(t>56319){if((r-=3)>-1)i.push(239,191,189);continue}else if(o+1===f){if((r-=3)>-1)i.push(239,191,189);continue}n=t;continue}if(t<56320){if((r-=3)>-1)i.push(239,191,189);n=t;continue}t=(n-55296<<10|t-56320)+65536}else if(n){if((r-=3)>-1)i.push(239,191,189)}n=null;if(t<128){if((r-=1)<0)break;i.push(t)}else if(t<2048){if((r-=2)<0)break;i.push(t>>6|192,t&63|128)}else if(t<65536){if((r-=3)<0)break;i.push(t>>12|224,t>>6&63|128,t&63|128)}else if(t<1114112){if((r-=4)<0)break;i.push(t>>18|240,t>>12&63|128,t>>6&63|128,t&63|128)}else{throw new Error("Invalid code point")}}return i}function asciiToBytes(e){var r=[];for(var t=0;t<e.length;++t){r.push(e.charCodeAt(t)&255)}return r}function utf16leToBytes(e,r){var t,f,n;var i=[];for(var o=0;o<e.length;++o){if((r-=2)<0)break;t=e.charCodeAt(o);f=t>>8;n=t%256;i.push(n);i.push(f)}return i}function base64ToBytes(e){return f.toByteArray(base64clean(e))}function blitBuffer(e,r,t,f){for(var n=0;n<f;++n){if(n+t>=r.length||n>=e.length)break;r[n+t]=e[n]}return n}function isInstance(e,r){return e instanceof r||e!=null&&e.constructor!=null&&e.constructor.name!=null&&e.constructor.name===r.name}function numberIsNaN(e){return e!==e}var s=function(){var e="0123456789abcdef";var r=new Array(256);for(var t=0;t<16;++t){var f=t*16;for(var n=0;n<16;++n){r[f+n]=e[t]+e[n]}}return r}()},783:function(e,r){
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
r.read=function(e,r,t,f,n){var i,o;var u=n*8-f-1;var a=(1<<u)-1;var s=a>>1;var h=-7;var c=t?n-1:0;var l=t?-1:1;var p=e[r+c];c+=l;i=p&(1<<-h)-1;p>>=-h;h+=u;for(;h>0;i=i*256+e[r+c],c+=l,h-=8){}o=i&(1<<-h)-1;i>>=-h;h+=f;for(;h>0;o=o*256+e[r+c],c+=l,h-=8){}if(i===0){i=1-s}else if(i===a){return o?NaN:(p?-1:1)*Infinity}else{o=o+Math.pow(2,f);i=i-s}return(p?-1:1)*o*Math.pow(2,i-f)};r.write=function(e,r,t,f,n,i){var o,u,a;var s=i*8-n-1;var h=(1<<s)-1;var c=h>>1;var l=n===23?Math.pow(2,-24)-Math.pow(2,-77):0;var p=f?0:i-1;var y=f?1:-1;var g=r<0||r===0&&1/r<0?1:0;r=Math.abs(r);if(isNaN(r)||r===Infinity){u=isNaN(r)?1:0;o=h}else{o=Math.floor(Math.log(r)/Math.LN2);if(r*(a=Math.pow(2,-o))<1){o--;a*=2}if(o+c>=1){r+=l/a}else{r+=l*Math.pow(2,1-c)}if(r*a>=2){o++;a/=2}if(o+c>=h){u=0;o=h}else if(o+c>=1){u=(r*a-1)*Math.pow(2,n);o=o+c}else{u=r*Math.pow(2,c-1)*Math.pow(2,n);o=0}}for(;n>=8;e[t+p]=u&255,p+=y,u/=256,n-=8){}o=o<<n|u;s+=n;for(;s>0;e[t+p]=o&255,p+=y,o/=256,s-=8){}e[t+p-y]|=g*128}}};var r={};function __nccwpck_require__(t){var f=r[t];if(f!==undefined){return f.exports}var n=r[t]={exports:{}};var i=true;try{e[t](n,n.exports,__nccwpck_require__);i=false}finally{if(i)delete r[t]}return n.exports}if(typeof __nccwpck_require__!=="undefined")__nccwpck_require__.ab=__dirname+"/";var t=__nccwpck_require__(72);module.exports=t})();

/***/ }),

/***/ 946:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 30383:
/***/ (function(module) {

var __dirname = "/";
(function(){var e={229:function(e){var t=e.exports={};var r;var n;function defaultSetTimout(){throw new Error("setTimeout has not been defined")}function defaultClearTimeout(){throw new Error("clearTimeout has not been defined")}(function(){try{if(typeof setTimeout==="function"){r=setTimeout}else{r=defaultSetTimout}}catch(e){r=defaultSetTimout}try{if(typeof clearTimeout==="function"){n=clearTimeout}else{n=defaultClearTimeout}}catch(e){n=defaultClearTimeout}})();function runTimeout(e){if(r===setTimeout){return setTimeout(e,0)}if((r===defaultSetTimout||!r)&&setTimeout){r=setTimeout;return setTimeout(e,0)}try{return r(e,0)}catch(t){try{return r.call(null,e,0)}catch(t){return r.call(this,e,0)}}}function runClearTimeout(e){if(n===clearTimeout){return clearTimeout(e)}if((n===defaultClearTimeout||!n)&&clearTimeout){n=clearTimeout;return clearTimeout(e)}try{return n(e)}catch(t){try{return n.call(null,e)}catch(t){return n.call(this,e)}}}var i=[];var o=false;var u;var a=-1;function cleanUpNextTick(){if(!o||!u){return}o=false;if(u.length){i=u.concat(i)}else{a=-1}if(i.length){drainQueue()}}function drainQueue(){if(o){return}var e=runTimeout(cleanUpNextTick);o=true;var t=i.length;while(t){u=i;i=[];while(++a<t){if(u){u[a].run()}}a=-1;t=i.length}u=null;o=false;runClearTimeout(e)}t.nextTick=function(e){var t=new Array(arguments.length-1);if(arguments.length>1){for(var r=1;r<arguments.length;r++){t[r-1]=arguments[r]}}i.push(new Item(e,t));if(i.length===1&&!o){runTimeout(drainQueue)}};function Item(e,t){this.fun=e;this.array=t}Item.prototype.run=function(){this.fun.apply(null,this.array)};t.title="browser";t.browser=true;t.env={};t.argv=[];t.version="";t.versions={};function noop(){}t.on=noop;t.addListener=noop;t.once=noop;t.off=noop;t.removeListener=noop;t.removeAllListeners=noop;t.emit=noop;t.prependListener=noop;t.prependOnceListener=noop;t.listeners=function(e){return[]};t.binding=function(e){throw new Error("process.binding is not supported")};t.cwd=function(){return"/"};t.chdir=function(e){throw new Error("process.chdir is not supported")};t.umask=function(){return 0}}};var t={};function __nccwpck_require__(r){var n=t[r];if(n!==undefined){return n.exports}var i=t[r]={exports:{}};var o=true;try{e[r](i,i.exports,__nccwpck_require__);o=false}finally{if(o)delete t[r]}return i.exports}if(typeof __nccwpck_require__!=="undefined")__nccwpck_require__.ab=__dirname+"/";var r=__nccwpck_require__(229);module.exports=r})();

/***/ }),

/***/ 89976:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(2125)


/***/ }),

/***/ 58804:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(44965)


/***/ }),

/***/ 87347:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(10317)


/***/ }),

/***/ 43285:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports =
   false
    ? 0
    : __webpack_require__(36369)


/***/ }),

/***/ 43960:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "j": function() { return /* binding */ focusManager; }
/* harmony export */ });
/* unused harmony export FocusManager */
/* harmony import */ var _babel_runtime_helpers_esm_inheritsLoose__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(48848);
/* harmony import */ var _subscribable__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(57239);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89107);



var FocusManager = /*#__PURE__*/function (_Subscribable) {
  (0,_babel_runtime_helpers_esm_inheritsLoose__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(FocusManager, _Subscribable);

  function FocusManager() {
    var _this;

    _this = _Subscribable.call(this) || this;

    _this.setup = function (onFocus) {
      var _window;

      if (!_utils__WEBPACK_IMPORTED_MODULE_1__/* .isServer */ .sk && ((_window = window) == null ? void 0 : _window.addEventListener)) {
        var listener = function listener() {
          return onFocus();
        }; // Listen to visibillitychange and focus


        window.addEventListener('visibilitychange', listener, false);
        window.addEventListener('focus', listener, false);
        return function () {
          // Be sure to unsubscribe if a new handler is set
          window.removeEventListener('visibilitychange', listener);
          window.removeEventListener('focus', listener);
        };
      }
    };

    return _this;
  }

  var _proto = FocusManager.prototype;

  _proto.onSubscribe = function onSubscribe() {
    if (!this.cleanup) {
      this.setEventListener(this.setup);
    }
  };

  _proto.onUnsubscribe = function onUnsubscribe() {
    if (!this.hasListeners()) {
      var _this$cleanup;

      (_this$cleanup = this.cleanup) == null ? void 0 : _this$cleanup.call(this);
      this.cleanup = undefined;
    }
  };

  _proto.setEventListener = function setEventListener(setup) {
    var _this$cleanup2,
        _this2 = this;

    this.setup = setup;
    (_this$cleanup2 = this.cleanup) == null ? void 0 : _this$cleanup2.call(this);
    this.cleanup = setup(function (focused) {
      if (typeof focused === 'boolean') {
        _this2.setFocused(focused);
      } else {
        _this2.onFocus();
      }
    });
  };

  _proto.setFocused = function setFocused(focused) {
    this.focused = focused;

    if (focused) {
      this.onFocus();
    }
  };

  _proto.onFocus = function onFocus() {
    this.listeners.forEach(function (listener) {
      listener();
    });
  };

  _proto.isFocused = function isFocused() {
    if (typeof this.focused === 'boolean') {
      return this.focused;
    } // document global can be unavailable in react native


    if (typeof document === 'undefined') {
      return true;
    }

    return [undefined, 'visible', 'prerender'].includes(document.visibilityState);
  };

  return FocusManager;
}(_subscribable__WEBPACK_IMPORTED_MODULE_2__/* .Subscribable */ .l);
var focusManager = new FocusManager();

/***/ }),

/***/ 71177:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ dehydrate; },
/* harmony export */   "Z": function() { return /* binding */ hydrate; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(37997);


// TYPES
// FUNCTIONS
function dehydrateMutation(mutation) {
  return {
    mutationKey: mutation.options.mutationKey,
    state: mutation.state
  };
} // Most config is not dehydrated but instead meant to configure again when
// consuming the de/rehydrated data, typically with useQuery on the client.
// Sometimes it might make sense to prefetch data on the server and include
// in the html-payload, but not consume it on the initial render.


function dehydrateQuery(query) {
  return {
    state: query.state,
    queryKey: query.queryKey,
    queryHash: query.queryHash
  };
}

function defaultShouldDehydrateMutation(mutation) {
  return mutation.state.isPaused;
}

function defaultShouldDehydrateQuery(query) {
  return query.state.status === 'success';
}

function dehydrate(client, options) {
  var _options, _options2;

  options = options || {};
  var mutations = [];
  var queries = [];

  if (((_options = options) == null ? void 0 : _options.dehydrateMutations) !== false) {
    var shouldDehydrateMutation = options.shouldDehydrateMutation || defaultShouldDehydrateMutation;
    client.getMutationCache().getAll().forEach(function (mutation) {
      if (shouldDehydrateMutation(mutation)) {
        mutations.push(dehydrateMutation(mutation));
      }
    });
  }

  if (((_options2 = options) == null ? void 0 : _options2.dehydrateQueries) !== false) {
    var shouldDehydrateQuery = options.shouldDehydrateQuery || defaultShouldDehydrateQuery;
    client.getQueryCache().getAll().forEach(function (query) {
      if (shouldDehydrateQuery(query)) {
        queries.push(dehydrateQuery(query));
      }
    });
  }

  return {
    mutations: mutations,
    queries: queries
  };
}
function hydrate(client, dehydratedState, options) {
  if (typeof dehydratedState !== 'object' || dehydratedState === null) {
    return;
  }

  var mutationCache = client.getMutationCache();
  var queryCache = client.getQueryCache();
  var mutations = dehydratedState.mutations || [];
  var queries = dehydratedState.queries || [];
  mutations.forEach(function (dehydratedMutation) {
    var _options$defaultOptio;

    mutationCache.build(client, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, options == null ? void 0 : (_options$defaultOptio = options.defaultOptions) == null ? void 0 : _options$defaultOptio.mutations, {
      mutationKey: dehydratedMutation.mutationKey
    }), dehydratedMutation.state);
  });
  queries.forEach(function (dehydratedQuery) {
    var _options$defaultOptio2;

    var query = queryCache.get(dehydratedQuery.queryHash); // Do not hydrate if an existing query exists with newer data

    if (query) {
      if (query.state.dataUpdatedAt < dehydratedQuery.state.dataUpdatedAt) {
        query.setState(dehydratedQuery.state);
      }

      return;
    } // Restore query


    queryCache.build(client, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, options == null ? void 0 : (_options$defaultOptio2 = options.defaultOptions) == null ? void 0 : _options$defaultOptio2.queries, {
      queryKey: dehydratedQuery.queryKey,
      queryHash: dehydratedQuery.queryHash
    }), dehydratedQuery.state);
  });
}

/***/ }),

/***/ 75047:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "QueryClient": function() { return /* reexport safe */ _queryClient__WEBPACK_IMPORTED_MODULE_0__.S; },
/* harmony export */   "dehydrate": function() { return /* reexport safe */ _hydration__WEBPACK_IMPORTED_MODULE_2__.D; },
/* harmony export */   "hashQueryKey": function() { return /* reexport safe */ _utils__WEBPACK_IMPORTED_MODULE_1__.yF; }
/* harmony export */ });
/* harmony import */ var _queryClient__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(21552);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89107);
/* harmony import */ var _hydration__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(71177);
/* harmony import */ var _types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(92885);
/* harmony import */ var _types__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_types__WEBPACK_IMPORTED_MODULE_3__);
/* harmony reexport (checked) */ if(__webpack_require__.o(_types__WEBPACK_IMPORTED_MODULE_3__, "Hydrate")) __webpack_require__.d(__webpack_exports__, { "Hydrate": function() { return _types__WEBPACK_IMPORTED_MODULE_3__.Hydrate; } });
/* harmony reexport (checked) */ if(__webpack_require__.o(_types__WEBPACK_IMPORTED_MODULE_3__, "QueryClientProvider")) __webpack_require__.d(__webpack_exports__, { "QueryClientProvider": function() { return _types__WEBPACK_IMPORTED_MODULE_3__.QueryClientProvider; } });
/* harmony reexport (checked) */ if(__webpack_require__.o(_types__WEBPACK_IMPORTED_MODULE_3__, "useInfiniteQuery")) __webpack_require__.d(__webpack_exports__, { "useInfiniteQuery": function() { return _types__WEBPACK_IMPORTED_MODULE_3__.useInfiniteQuery; } });
/* harmony reexport (checked) */ if(__webpack_require__.o(_types__WEBPACK_IMPORTED_MODULE_3__, "useMutation")) __webpack_require__.d(__webpack_exports__, { "useMutation": function() { return _types__WEBPACK_IMPORTED_MODULE_3__.useMutation; } });
/* harmony reexport (checked) */ if(__webpack_require__.o(_types__WEBPACK_IMPORTED_MODULE_3__, "useQuery")) __webpack_require__.d(__webpack_exports__, { "useQuery": function() { return _types__WEBPACK_IMPORTED_MODULE_3__.useQuery; } });
/* harmony reexport (checked) */ if(__webpack_require__.o(_types__WEBPACK_IMPORTED_MODULE_3__, "useQueryClient")) __webpack_require__.d(__webpack_exports__, { "useQueryClient": function() { return _types__WEBPACK_IMPORTED_MODULE_3__.useQueryClient; } });














 // Types



/***/ }),

/***/ 78831:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Gm": function() { return /* binding */ infiniteQueryBehavior; },
/* harmony export */   "Qy": function() { return /* binding */ hasNextPage; },
/* harmony export */   "ZF": function() { return /* binding */ hasPreviousPage; }
/* harmony export */ });
/* unused harmony exports getNextPageParam, getPreviousPageParam */
/* harmony import */ var _retryer__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(54105);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89107);


function infiniteQueryBehavior() {
  return {
    onFetch: function onFetch(context) {
      context.fetchFn = function () {
        var _context$fetchOptions, _context$fetchOptions2, _context$fetchOptions3, _context$fetchOptions4, _context$state$data, _context$state$data2;

        var refetchPage = (_context$fetchOptions = context.fetchOptions) == null ? void 0 : (_context$fetchOptions2 = _context$fetchOptions.meta) == null ? void 0 : _context$fetchOptions2.refetchPage;
        var fetchMore = (_context$fetchOptions3 = context.fetchOptions) == null ? void 0 : (_context$fetchOptions4 = _context$fetchOptions3.meta) == null ? void 0 : _context$fetchOptions4.fetchMore;
        var pageParam = fetchMore == null ? void 0 : fetchMore.pageParam;
        var isFetchingNextPage = (fetchMore == null ? void 0 : fetchMore.direction) === 'forward';
        var isFetchingPreviousPage = (fetchMore == null ? void 0 : fetchMore.direction) === 'backward';
        var oldPages = ((_context$state$data = context.state.data) == null ? void 0 : _context$state$data.pages) || [];
        var oldPageParams = ((_context$state$data2 = context.state.data) == null ? void 0 : _context$state$data2.pageParams) || [];
        var abortController = (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .getAbortController */ .G9)();
        var abortSignal = abortController == null ? void 0 : abortController.signal;
        var newPageParams = oldPageParams;
        var cancelled = false; // Get query function

        var queryFn = context.options.queryFn || function () {
          return Promise.reject('Missing queryFn');
        };

        var buildNewPages = function buildNewPages(pages, param, page, previous) {
          newPageParams = previous ? [param].concat(newPageParams) : [].concat(newPageParams, [param]);
          return previous ? [page].concat(pages) : [].concat(pages, [page]);
        }; // Create function to fetch a page


        var fetchPage = function fetchPage(pages, manual, param, previous) {
          if (cancelled) {
            return Promise.reject('Cancelled');
          }

          if (typeof param === 'undefined' && !manual && pages.length) {
            return Promise.resolve(pages);
          }

          var queryFnContext = {
            queryKey: context.queryKey,
            signal: abortSignal,
            pageParam: param,
            meta: context.meta
          };
          var queryFnResult = queryFn(queryFnContext);
          var promise = Promise.resolve(queryFnResult).then(function (page) {
            return buildNewPages(pages, param, page, previous);
          });

          if ((0,_retryer__WEBPACK_IMPORTED_MODULE_1__/* .isCancelable */ .LE)(queryFnResult)) {
            var promiseAsAny = promise;
            promiseAsAny.cancel = queryFnResult.cancel;
          }

          return promise;
        };

        var promise; // Fetch first page?

        if (!oldPages.length) {
          promise = fetchPage([]);
        } // Fetch next page?
        else if (isFetchingNextPage) {
            var manual = typeof pageParam !== 'undefined';
            var param = manual ? pageParam : getNextPageParam(context.options, oldPages);
            promise = fetchPage(oldPages, manual, param);
          } // Fetch previous page?
          else if (isFetchingPreviousPage) {
              var _manual = typeof pageParam !== 'undefined';

              var _param = _manual ? pageParam : getPreviousPageParam(context.options, oldPages);

              promise = fetchPage(oldPages, _manual, _param, true);
            } // Refetch pages
            else {
                (function () {
                  newPageParams = [];
                  var manual = typeof context.options.getNextPageParam === 'undefined';
                  var shouldFetchFirstPage = refetchPage && oldPages[0] ? refetchPage(oldPages[0], 0, oldPages) : true; // Fetch first page

                  promise = shouldFetchFirstPage ? fetchPage([], manual, oldPageParams[0]) : Promise.resolve(buildNewPages([], oldPageParams[0], oldPages[0])); // Fetch remaining pages

                  var _loop = function _loop(i) {
                    promise = promise.then(function (pages) {
                      var shouldFetchNextPage = refetchPage && oldPages[i] ? refetchPage(oldPages[i], i, oldPages) : true;

                      if (shouldFetchNextPage) {
                        var _param2 = manual ? oldPageParams[i] : getNextPageParam(context.options, pages);

                        return fetchPage(pages, manual, _param2);
                      }

                      return Promise.resolve(buildNewPages(pages, oldPageParams[i], oldPages[i]));
                    });
                  };

                  for (var i = 1; i < oldPages.length; i++) {
                    _loop(i);
                  }
                })();
              }

        var finalPromise = promise.then(function (pages) {
          return {
            pages: pages,
            pageParams: newPageParams
          };
        });
        var finalPromiseAsAny = finalPromise;

        finalPromiseAsAny.cancel = function () {
          cancelled = true;
          abortController == null ? void 0 : abortController.abort();

          if ((0,_retryer__WEBPACK_IMPORTED_MODULE_1__/* .isCancelable */ .LE)(promise)) {
            promise.cancel();
          }
        };

        return finalPromise;
      };
    }
  };
}
function getNextPageParam(options, pages) {
  return options.getNextPageParam == null ? void 0 : options.getNextPageParam(pages[pages.length - 1], pages);
}
function getPreviousPageParam(options, pages) {
  return options.getPreviousPageParam == null ? void 0 : options.getPreviousPageParam(pages[0], pages);
}
/**
 * Checks if there is a next page.
 * Returns `undefined` if it cannot be determined.
 */

function hasNextPage(options, pages) {
  if (options.getNextPageParam && Array.isArray(pages)) {
    var nextPageParam = getNextPageParam(options, pages);
    return typeof nextPageParam !== 'undefined' && nextPageParam !== null && nextPageParam !== false;
  }
}
/**
 * Checks if there is a previous page.
 * Returns `undefined` if it cannot be determined.
 */

function hasPreviousPage(options, pages) {
  if (options.getPreviousPageParam && Array.isArray(pages)) {
    var previousPageParam = getPreviousPageParam(options, pages);
    return typeof previousPageParam !== 'undefined' && previousPageParam !== null && previousPageParam !== false;
  }
}

/***/ }),

/***/ 73082:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ setLogger; },
/* harmony export */   "j": function() { return /* binding */ getLogger; }
/* harmony export */ });
// TYPES
// FUNCTIONS
var logger = console;
function getLogger() {
  return logger;
}
function setLogger(newLogger) {
  logger = newLogger;
}

/***/ }),

/***/ 86402:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ getDefaultState; },
/* harmony export */   "m": function() { return /* binding */ Mutation; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(37997);
/* harmony import */ var _logger__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(73082);
/* harmony import */ var _notifyManager__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(38203);
/* harmony import */ var _retryer__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(54105);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89107);




 // TYPES

// CLASS
var Mutation = /*#__PURE__*/function () {
  function Mutation(config) {
    this.options = (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, config.defaultOptions, config.options);
    this.mutationId = config.mutationId;
    this.mutationCache = config.mutationCache;
    this.observers = [];
    this.state = config.state || getDefaultState();
    this.meta = config.meta;
  }

  var _proto = Mutation.prototype;

  _proto.setState = function setState(state) {
    this.dispatch({
      type: 'setState',
      state: state
    });
  };

  _proto.addObserver = function addObserver(observer) {
    if (this.observers.indexOf(observer) === -1) {
      this.observers.push(observer);
    }
  };

  _proto.removeObserver = function removeObserver(observer) {
    this.observers = this.observers.filter(function (x) {
      return x !== observer;
    });
  };

  _proto.cancel = function cancel() {
    if (this.retryer) {
      this.retryer.cancel();
      return this.retryer.promise.then(_utils__WEBPACK_IMPORTED_MODULE_1__/* .noop */ .ZT).catch(_utils__WEBPACK_IMPORTED_MODULE_1__/* .noop */ .ZT);
    }

    return Promise.resolve();
  };

  _proto.continue = function _continue() {
    if (this.retryer) {
      this.retryer.continue();
      return this.retryer.promise;
    }

    return this.execute();
  };

  _proto.execute = function execute() {
    var _this = this;

    var data;
    var restored = this.state.status === 'loading';
    var promise = Promise.resolve();

    if (!restored) {
      this.dispatch({
        type: 'loading',
        variables: this.options.variables
      });
      promise = promise.then(function () {
        // Notify cache callback
        _this.mutationCache.config.onMutate == null ? void 0 : _this.mutationCache.config.onMutate(_this.state.variables, _this);
      }).then(function () {
        return _this.options.onMutate == null ? void 0 : _this.options.onMutate(_this.state.variables);
      }).then(function (context) {
        if (context !== _this.state.context) {
          _this.dispatch({
            type: 'loading',
            context: context,
            variables: _this.state.variables
          });
        }
      });
    }

    return promise.then(function () {
      return _this.executeMutation();
    }).then(function (result) {
      data = result; // Notify cache callback

      _this.mutationCache.config.onSuccess == null ? void 0 : _this.mutationCache.config.onSuccess(data, _this.state.variables, _this.state.context, _this);
    }).then(function () {
      return _this.options.onSuccess == null ? void 0 : _this.options.onSuccess(data, _this.state.variables, _this.state.context);
    }).then(function () {
      return _this.options.onSettled == null ? void 0 : _this.options.onSettled(data, null, _this.state.variables, _this.state.context);
    }).then(function () {
      _this.dispatch({
        type: 'success',
        data: data
      });

      return data;
    }).catch(function (error) {
      // Notify cache callback
      _this.mutationCache.config.onError == null ? void 0 : _this.mutationCache.config.onError(error, _this.state.variables, _this.state.context, _this); // Log error

      (0,_logger__WEBPACK_IMPORTED_MODULE_2__/* .getLogger */ .j)().error(error);
      return Promise.resolve().then(function () {
        return _this.options.onError == null ? void 0 : _this.options.onError(error, _this.state.variables, _this.state.context);
      }).then(function () {
        return _this.options.onSettled == null ? void 0 : _this.options.onSettled(undefined, error, _this.state.variables, _this.state.context);
      }).then(function () {
        _this.dispatch({
          type: 'error',
          error: error
        });

        throw error;
      });
    });
  };

  _proto.executeMutation = function executeMutation() {
    var _this2 = this,
        _this$options$retry;

    this.retryer = new _retryer__WEBPACK_IMPORTED_MODULE_3__/* .Retryer */ .m4({
      fn: function fn() {
        if (!_this2.options.mutationFn) {
          return Promise.reject('No mutationFn found');
        }

        return _this2.options.mutationFn(_this2.state.variables);
      },
      onFail: function onFail() {
        _this2.dispatch({
          type: 'failed'
        });
      },
      onPause: function onPause() {
        _this2.dispatch({
          type: 'pause'
        });
      },
      onContinue: function onContinue() {
        _this2.dispatch({
          type: 'continue'
        });
      },
      retry: (_this$options$retry = this.options.retry) != null ? _this$options$retry : 0,
      retryDelay: this.options.retryDelay
    });
    return this.retryer.promise;
  };

  _proto.dispatch = function dispatch(action) {
    var _this3 = this;

    this.state = reducer(this.state, action);
    _notifyManager__WEBPACK_IMPORTED_MODULE_4__/* .notifyManager.batch */ .V.batch(function () {
      _this3.observers.forEach(function (observer) {
        observer.onMutationUpdate(action);
      });

      _this3.mutationCache.notify(_this3);
    });
  };

  return Mutation;
}();
function getDefaultState() {
  return {
    context: undefined,
    data: undefined,
    error: null,
    failureCount: 0,
    isPaused: false,
    status: 'idle',
    variables: undefined
  };
}

function reducer(state, action) {
  switch (action.type) {
    case 'failed':
      return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, state, {
        failureCount: state.failureCount + 1
      });

    case 'pause':
      return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, state, {
        isPaused: true
      });

    case 'continue':
      return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, state, {
        isPaused: false
      });

    case 'loading':
      return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, state, {
        context: action.context,
        data: undefined,
        error: null,
        isPaused: false,
        status: 'loading',
        variables: action.variables
      });

    case 'success':
      return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, state, {
        data: action.data,
        error: null,
        status: 'success',
        isPaused: false
      });

    case 'error':
      return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, state, {
        data: undefined,
        error: action.error,
        failureCount: state.failureCount + 1,
        isPaused: false,
        status: 'error'
      });

    case 'setState':
      return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, state, action.state);

    default:
      return state;
  }
}

/***/ }),

/***/ 38203:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": function() { return /* binding */ notifyManager; }
/* harmony export */ });
/* unused harmony export NotifyManager */
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89107);
 // TYPES

// CLASS
var NotifyManager = /*#__PURE__*/function () {
  function NotifyManager() {
    this.queue = [];
    this.transactions = 0;

    this.notifyFn = function (callback) {
      callback();
    };

    this.batchNotifyFn = function (callback) {
      callback();
    };
  }

  var _proto = NotifyManager.prototype;

  _proto.batch = function batch(callback) {
    var result;
    this.transactions++;

    try {
      result = callback();
    } finally {
      this.transactions--;

      if (!this.transactions) {
        this.flush();
      }
    }

    return result;
  };

  _proto.schedule = function schedule(callback) {
    var _this = this;

    if (this.transactions) {
      this.queue.push(callback);
    } else {
      (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .scheduleMicrotask */ .A4)(function () {
        _this.notifyFn(callback);
      });
    }
  }
  /**
   * All calls to the wrapped function will be batched.
   */
  ;

  _proto.batchCalls = function batchCalls(callback) {
    var _this2 = this;

    return function () {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this2.schedule(function () {
        callback.apply(void 0, args);
      });
    };
  };

  _proto.flush = function flush() {
    var _this3 = this;

    var queue = this.queue;
    this.queue = [];

    if (queue.length) {
      (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .scheduleMicrotask */ .A4)(function () {
        _this3.batchNotifyFn(function () {
          queue.forEach(function (callback) {
            _this3.notifyFn(callback);
          });
        });
      });
    }
  }
  /**
   * Use this method to set a custom notify function.
   * This can be used to for example wrap notifications with `React.act` while running tests.
   */
  ;

  _proto.setNotifyFunction = function setNotifyFunction(fn) {
    this.notifyFn = fn;
  }
  /**
   * Use this method to set a custom function to batch notifications together into a single tick.
   * By default React Query will use the batch function provided by ReactDOM or React Native.
   */
  ;

  _proto.setBatchNotifyFunction = function setBatchNotifyFunction(fn) {
    this.batchNotifyFn = fn;
  };

  return NotifyManager;
}(); // SINGLETON

var notifyManager = new NotifyManager();

/***/ }),

/***/ 22451:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ onlineManager; }
/* harmony export */ });
/* unused harmony export OnlineManager */
/* harmony import */ var _babel_runtime_helpers_esm_inheritsLoose__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(48848);
/* harmony import */ var _subscribable__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(57239);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89107);



var OnlineManager = /*#__PURE__*/function (_Subscribable) {
  (0,_babel_runtime_helpers_esm_inheritsLoose__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(OnlineManager, _Subscribable);

  function OnlineManager() {
    var _this;

    _this = _Subscribable.call(this) || this;

    _this.setup = function (onOnline) {
      var _window;

      if (!_utils__WEBPACK_IMPORTED_MODULE_1__/* .isServer */ .sk && ((_window = window) == null ? void 0 : _window.addEventListener)) {
        var listener = function listener() {
          return onOnline();
        }; // Listen to online


        window.addEventListener('online', listener, false);
        window.addEventListener('offline', listener, false);
        return function () {
          // Be sure to unsubscribe if a new handler is set
          window.removeEventListener('online', listener);
          window.removeEventListener('offline', listener);
        };
      }
    };

    return _this;
  }

  var _proto = OnlineManager.prototype;

  _proto.onSubscribe = function onSubscribe() {
    if (!this.cleanup) {
      this.setEventListener(this.setup);
    }
  };

  _proto.onUnsubscribe = function onUnsubscribe() {
    if (!this.hasListeners()) {
      var _this$cleanup;

      (_this$cleanup = this.cleanup) == null ? void 0 : _this$cleanup.call(this);
      this.cleanup = undefined;
    }
  };

  _proto.setEventListener = function setEventListener(setup) {
    var _this$cleanup2,
        _this2 = this;

    this.setup = setup;
    (_this$cleanup2 = this.cleanup) == null ? void 0 : _this$cleanup2.call(this);
    this.cleanup = setup(function (online) {
      if (typeof online === 'boolean') {
        _this2.setOnline(online);
      } else {
        _this2.onOnline();
      }
    });
  };

  _proto.setOnline = function setOnline(online) {
    this.online = online;

    if (online) {
      this.onOnline();
    }
  };

  _proto.onOnline = function onOnline() {
    this.listeners.forEach(function (listener) {
      listener();
    });
  };

  _proto.isOnline = function isOnline() {
    if (typeof this.online === 'boolean') {
      return this.online;
    }

    if (typeof navigator === 'undefined' || typeof navigator.onLine === 'undefined') {
      return true;
    }

    return navigator.onLine;
  };

  return OnlineManager;
}(_subscribable__WEBPACK_IMPORTED_MODULE_2__/* .Subscribable */ .l);
var onlineManager = new OnlineManager();

/***/ }),

/***/ 21552:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "S": function() { return /* binding */ QueryClient; }
});

// EXTERNAL MODULE: ../../.yarn/cache/@babel-runtime-npm-7.20.1-8f9256f2ed-00567a333d.zip/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(37997);
// EXTERNAL MODULE: ../../.yarn/__virtual__/react-query-virtual-9ac5b1aaa1/0/cache/react-query-npm-3.39.1-7899b170b9-9273b7c2ad.zip/node_modules/react-query/es/core/utils.js
var utils = __webpack_require__(89107);
// EXTERNAL MODULE: ../../.yarn/cache/@babel-runtime-npm-7.20.1-8f9256f2ed-00567a333d.zip/node_modules/@babel/runtime/helpers/esm/inheritsLoose.js
var inheritsLoose = __webpack_require__(48848);
// EXTERNAL MODULE: ../../.yarn/__virtual__/react-query-virtual-9ac5b1aaa1/0/cache/react-query-npm-3.39.1-7899b170b9-9273b7c2ad.zip/node_modules/react-query/es/core/notifyManager.js
var notifyManager = __webpack_require__(38203);
// EXTERNAL MODULE: ../../.yarn/__virtual__/react-query-virtual-9ac5b1aaa1/0/cache/react-query-npm-3.39.1-7899b170b9-9273b7c2ad.zip/node_modules/react-query/es/core/logger.js
var logger = __webpack_require__(73082);
// EXTERNAL MODULE: ../../.yarn/__virtual__/react-query-virtual-9ac5b1aaa1/0/cache/react-query-npm-3.39.1-7899b170b9-9273b7c2ad.zip/node_modules/react-query/es/core/retryer.js
var retryer = __webpack_require__(54105);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/react-query-virtual-9ac5b1aaa1/0/cache/react-query-npm-3.39.1-7899b170b9-9273b7c2ad.zip/node_modules/react-query/es/core/query.js




 // TYPES

// CLASS
var Query = /*#__PURE__*/function () {
  function Query(config) {
    this.abortSignalConsumed = false;
    this.hadObservers = false;
    this.defaultOptions = config.defaultOptions;
    this.setOptions(config.options);
    this.observers = [];
    this.cache = config.cache;
    this.queryKey = config.queryKey;
    this.queryHash = config.queryHash;
    this.initialState = config.state || this.getDefaultState(this.options);
    this.state = this.initialState;
    this.meta = config.meta;
    this.scheduleGc();
  }

  var _proto = Query.prototype;

  _proto.setOptions = function setOptions(options) {
    var _this$options$cacheTi;

    this.options = (0,esm_extends/* default */.Z)({}, this.defaultOptions, options);
    this.meta = options == null ? void 0 : options.meta; // Default to 5 minutes if not cache time is set

    this.cacheTime = Math.max(this.cacheTime || 0, (_this$options$cacheTi = this.options.cacheTime) != null ? _this$options$cacheTi : 5 * 60 * 1000);
  };

  _proto.setDefaultOptions = function setDefaultOptions(options) {
    this.defaultOptions = options;
  };

  _proto.scheduleGc = function scheduleGc() {
    var _this = this;

    this.clearGcTimeout();

    if ((0,utils/* isValidTimeout */.PN)(this.cacheTime)) {
      this.gcTimeout = setTimeout(function () {
        _this.optionalRemove();
      }, this.cacheTime);
    }
  };

  _proto.clearGcTimeout = function clearGcTimeout() {
    clearTimeout(this.gcTimeout);
    this.gcTimeout = undefined;
  };

  _proto.optionalRemove = function optionalRemove() {
    if (!this.observers.length) {
      if (this.state.isFetching) {
        if (this.hadObservers) {
          this.scheduleGc();
        }
      } else {
        this.cache.remove(this);
      }
    }
  };

  _proto.setData = function setData(updater, options) {
    var _this$options$isDataE, _this$options;

    var prevData = this.state.data; // Get the new data

    var data = (0,utils/* functionalUpdate */.SE)(updater, prevData); // Use prev data if an isDataEqual function is defined and returns `true`

    if ((_this$options$isDataE = (_this$options = this.options).isDataEqual) == null ? void 0 : _this$options$isDataE.call(_this$options, prevData, data)) {
      data = prevData;
    } else if (this.options.structuralSharing !== false) {
      // Structurally share data between prev and new data if needed
      data = (0,utils/* replaceEqualDeep */.Q$)(prevData, data);
    } // Set data and mark it as cached


    this.dispatch({
      data: data,
      type: 'success',
      dataUpdatedAt: options == null ? void 0 : options.updatedAt
    });
    return data;
  };

  _proto.setState = function setState(state, setStateOptions) {
    this.dispatch({
      type: 'setState',
      state: state,
      setStateOptions: setStateOptions
    });
  };

  _proto.cancel = function cancel(options) {
    var _this$retryer;

    var promise = this.promise;
    (_this$retryer = this.retryer) == null ? void 0 : _this$retryer.cancel(options);
    return promise ? promise.then(utils/* noop */.ZT).catch(utils/* noop */.ZT) : Promise.resolve();
  };

  _proto.destroy = function destroy() {
    this.clearGcTimeout();
    this.cancel({
      silent: true
    });
  };

  _proto.reset = function reset() {
    this.destroy();
    this.setState(this.initialState);
  };

  _proto.isActive = function isActive() {
    return this.observers.some(function (observer) {
      return observer.options.enabled !== false;
    });
  };

  _proto.isFetching = function isFetching() {
    return this.state.isFetching;
  };

  _proto.isStale = function isStale() {
    return this.state.isInvalidated || !this.state.dataUpdatedAt || this.observers.some(function (observer) {
      return observer.getCurrentResult().isStale;
    });
  };

  _proto.isStaleByTime = function isStaleByTime(staleTime) {
    if (staleTime === void 0) {
      staleTime = 0;
    }

    return this.state.isInvalidated || !this.state.dataUpdatedAt || !(0,utils/* timeUntilStale */.Kp)(this.state.dataUpdatedAt, staleTime);
  };

  _proto.onFocus = function onFocus() {
    var _this$retryer2;

    var observer = this.observers.find(function (x) {
      return x.shouldFetchOnWindowFocus();
    });

    if (observer) {
      observer.refetch();
    } // Continue fetch if currently paused


    (_this$retryer2 = this.retryer) == null ? void 0 : _this$retryer2.continue();
  };

  _proto.onOnline = function onOnline() {
    var _this$retryer3;

    var observer = this.observers.find(function (x) {
      return x.shouldFetchOnReconnect();
    });

    if (observer) {
      observer.refetch();
    } // Continue fetch if currently paused


    (_this$retryer3 = this.retryer) == null ? void 0 : _this$retryer3.continue();
  };

  _proto.addObserver = function addObserver(observer) {
    if (this.observers.indexOf(observer) === -1) {
      this.observers.push(observer);
      this.hadObservers = true; // Stop the query from being garbage collected

      this.clearGcTimeout();
      this.cache.notify({
        type: 'observerAdded',
        query: this,
        observer: observer
      });
    }
  };

  _proto.removeObserver = function removeObserver(observer) {
    if (this.observers.indexOf(observer) !== -1) {
      this.observers = this.observers.filter(function (x) {
        return x !== observer;
      });

      if (!this.observers.length) {
        // If the transport layer does not support cancellation
        // we'll let the query continue so the result can be cached
        if (this.retryer) {
          if (this.retryer.isTransportCancelable || this.abortSignalConsumed) {
            this.retryer.cancel({
              revert: true
            });
          } else {
            this.retryer.cancelRetry();
          }
        }

        if (this.cacheTime) {
          this.scheduleGc();
        } else {
          this.cache.remove(this);
        }
      }

      this.cache.notify({
        type: 'observerRemoved',
        query: this,
        observer: observer
      });
    }
  };

  _proto.getObserversCount = function getObserversCount() {
    return this.observers.length;
  };

  _proto.invalidate = function invalidate() {
    if (!this.state.isInvalidated) {
      this.dispatch({
        type: 'invalidate'
      });
    }
  };

  _proto.fetch = function fetch(options, fetchOptions) {
    var _this2 = this,
        _this$options$behavio,
        _context$fetchOptions,
        _abortController$abor;

    if (this.state.isFetching) {
      if (this.state.dataUpdatedAt && (fetchOptions == null ? void 0 : fetchOptions.cancelRefetch)) {
        // Silently cancel current fetch if the user wants to cancel refetches
        this.cancel({
          silent: true
        });
      } else if (this.promise) {
        var _this$retryer4;

        // make sure that retries that were potentially cancelled due to unmounts can continue
        (_this$retryer4 = this.retryer) == null ? void 0 : _this$retryer4.continueRetry(); // Return current promise if we are already fetching

        return this.promise;
      }
    } // Update config if passed, otherwise the config from the last execution is used


    if (options) {
      this.setOptions(options);
    } // Use the options from the first observer with a query function if no function is found.
    // This can happen when the query is hydrated or created with setQueryData.


    if (!this.options.queryFn) {
      var observer = this.observers.find(function (x) {
        return x.options.queryFn;
      });

      if (observer) {
        this.setOptions(observer.options);
      }
    }

    var queryKey = (0,utils/* ensureQueryKeyArray */.mc)(this.queryKey);
    var abortController = (0,utils/* getAbortController */.G9)(); // Create query function context

    var queryFnContext = {
      queryKey: queryKey,
      pageParam: undefined,
      meta: this.meta
    };
    Object.defineProperty(queryFnContext, 'signal', {
      enumerable: true,
      get: function get() {
        if (abortController) {
          _this2.abortSignalConsumed = true;
          return abortController.signal;
        }

        return undefined;
      }
    }); // Create fetch function

    var fetchFn = function fetchFn() {
      if (!_this2.options.queryFn) {
        return Promise.reject('Missing queryFn');
      }

      _this2.abortSignalConsumed = false;
      return _this2.options.queryFn(queryFnContext);
    }; // Trigger behavior hook


    var context = {
      fetchOptions: fetchOptions,
      options: this.options,
      queryKey: queryKey,
      state: this.state,
      fetchFn: fetchFn,
      meta: this.meta
    };

    if ((_this$options$behavio = this.options.behavior) == null ? void 0 : _this$options$behavio.onFetch) {
      var _this$options$behavio2;

      (_this$options$behavio2 = this.options.behavior) == null ? void 0 : _this$options$behavio2.onFetch(context);
    } // Store state in case the current fetch needs to be reverted


    this.revertState = this.state; // Set to fetching state if not already in it

    if (!this.state.isFetching || this.state.fetchMeta !== ((_context$fetchOptions = context.fetchOptions) == null ? void 0 : _context$fetchOptions.meta)) {
      var _context$fetchOptions2;

      this.dispatch({
        type: 'fetch',
        meta: (_context$fetchOptions2 = context.fetchOptions) == null ? void 0 : _context$fetchOptions2.meta
      });
    } // Try to fetch the data


    this.retryer = new retryer/* Retryer */.m4({
      fn: context.fetchFn,
      abort: abortController == null ? void 0 : (_abortController$abor = abortController.abort) == null ? void 0 : _abortController$abor.bind(abortController),
      onSuccess: function onSuccess(data) {
        _this2.setData(data); // Notify cache callback


        _this2.cache.config.onSuccess == null ? void 0 : _this2.cache.config.onSuccess(data, _this2); // Remove query after fetching if cache time is 0

        if (_this2.cacheTime === 0) {
          _this2.optionalRemove();
        }
      },
      onError: function onError(error) {
        // Optimistically update state if needed
        if (!((0,retryer/* isCancelledError */.DV)(error) && error.silent)) {
          _this2.dispatch({
            type: 'error',
            error: error
          });
        }

        if (!(0,retryer/* isCancelledError */.DV)(error)) {
          // Notify cache callback
          _this2.cache.config.onError == null ? void 0 : _this2.cache.config.onError(error, _this2); // Log error

          (0,logger/* getLogger */.j)().error(error);
        } // Remove query after fetching if cache time is 0


        if (_this2.cacheTime === 0) {
          _this2.optionalRemove();
        }
      },
      onFail: function onFail() {
        _this2.dispatch({
          type: 'failed'
        });
      },
      onPause: function onPause() {
        _this2.dispatch({
          type: 'pause'
        });
      },
      onContinue: function onContinue() {
        _this2.dispatch({
          type: 'continue'
        });
      },
      retry: context.options.retry,
      retryDelay: context.options.retryDelay
    });
    this.promise = this.retryer.promise;
    return this.promise;
  };

  _proto.dispatch = function dispatch(action) {
    var _this3 = this;

    this.state = this.reducer(this.state, action);
    notifyManager/* notifyManager.batch */.V.batch(function () {
      _this3.observers.forEach(function (observer) {
        observer.onQueryUpdate(action);
      });

      _this3.cache.notify({
        query: _this3,
        type: 'queryUpdated',
        action: action
      });
    });
  };

  _proto.getDefaultState = function getDefaultState(options) {
    var data = typeof options.initialData === 'function' ? options.initialData() : options.initialData;
    var hasInitialData = typeof options.initialData !== 'undefined';
    var initialDataUpdatedAt = hasInitialData ? typeof options.initialDataUpdatedAt === 'function' ? options.initialDataUpdatedAt() : options.initialDataUpdatedAt : 0;
    var hasData = typeof data !== 'undefined';
    return {
      data: data,
      dataUpdateCount: 0,
      dataUpdatedAt: hasData ? initialDataUpdatedAt != null ? initialDataUpdatedAt : Date.now() : 0,
      error: null,
      errorUpdateCount: 0,
      errorUpdatedAt: 0,
      fetchFailureCount: 0,
      fetchMeta: null,
      isFetching: false,
      isInvalidated: false,
      isPaused: false,
      status: hasData ? 'success' : 'idle'
    };
  };

  _proto.reducer = function reducer(state, action) {
    var _action$meta, _action$dataUpdatedAt;

    switch (action.type) {
      case 'failed':
        return (0,esm_extends/* default */.Z)({}, state, {
          fetchFailureCount: state.fetchFailureCount + 1
        });

      case 'pause':
        return (0,esm_extends/* default */.Z)({}, state, {
          isPaused: true
        });

      case 'continue':
        return (0,esm_extends/* default */.Z)({}, state, {
          isPaused: false
        });

      case 'fetch':
        return (0,esm_extends/* default */.Z)({}, state, {
          fetchFailureCount: 0,
          fetchMeta: (_action$meta = action.meta) != null ? _action$meta : null,
          isFetching: true,
          isPaused: false
        }, !state.dataUpdatedAt && {
          error: null,
          status: 'loading'
        });

      case 'success':
        return (0,esm_extends/* default */.Z)({}, state, {
          data: action.data,
          dataUpdateCount: state.dataUpdateCount + 1,
          dataUpdatedAt: (_action$dataUpdatedAt = action.dataUpdatedAt) != null ? _action$dataUpdatedAt : Date.now(),
          error: null,
          fetchFailureCount: 0,
          isFetching: false,
          isInvalidated: false,
          isPaused: false,
          status: 'success'
        });

      case 'error':
        var error = action.error;

        if ((0,retryer/* isCancelledError */.DV)(error) && error.revert && this.revertState) {
          return (0,esm_extends/* default */.Z)({}, this.revertState);
        }

        return (0,esm_extends/* default */.Z)({}, state, {
          error: error,
          errorUpdateCount: state.errorUpdateCount + 1,
          errorUpdatedAt: Date.now(),
          fetchFailureCount: state.fetchFailureCount + 1,
          isFetching: false,
          isPaused: false,
          status: 'error'
        });

      case 'invalidate':
        return (0,esm_extends/* default */.Z)({}, state, {
          isInvalidated: true
        });

      case 'setState':
        return (0,esm_extends/* default */.Z)({}, state, action.state);

      default:
        return state;
    }
  };

  return Query;
}();
// EXTERNAL MODULE: ../../.yarn/__virtual__/react-query-virtual-9ac5b1aaa1/0/cache/react-query-npm-3.39.1-7899b170b9-9273b7c2ad.zip/node_modules/react-query/es/core/subscribable.js
var subscribable = __webpack_require__(57239);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/react-query-virtual-9ac5b1aaa1/0/cache/react-query-npm-3.39.1-7899b170b9-9273b7c2ad.zip/node_modules/react-query/es/core/queryCache.js





// CLASS
var QueryCache = /*#__PURE__*/function (_Subscribable) {
  (0,inheritsLoose/* default */.Z)(QueryCache, _Subscribable);

  function QueryCache(config) {
    var _this;

    _this = _Subscribable.call(this) || this;
    _this.config = config || {};
    _this.queries = [];
    _this.queriesMap = {};
    return _this;
  }

  var _proto = QueryCache.prototype;

  _proto.build = function build(client, options, state) {
    var _options$queryHash;

    var queryKey = options.queryKey;
    var queryHash = (_options$queryHash = options.queryHash) != null ? _options$queryHash : (0,utils/* hashQueryKeyByOptions */.Rm)(queryKey, options);
    var query = this.get(queryHash);

    if (!query) {
      query = new Query({
        cache: this,
        queryKey: queryKey,
        queryHash: queryHash,
        options: client.defaultQueryOptions(options),
        state: state,
        defaultOptions: client.getQueryDefaults(queryKey),
        meta: options.meta
      });
      this.add(query);
    }

    return query;
  };

  _proto.add = function add(query) {
    if (!this.queriesMap[query.queryHash]) {
      this.queriesMap[query.queryHash] = query;
      this.queries.push(query);
      this.notify({
        type: 'queryAdded',
        query: query
      });
    }
  };

  _proto.remove = function remove(query) {
    var queryInMap = this.queriesMap[query.queryHash];

    if (queryInMap) {
      query.destroy();
      this.queries = this.queries.filter(function (x) {
        return x !== query;
      });

      if (queryInMap === query) {
        delete this.queriesMap[query.queryHash];
      }

      this.notify({
        type: 'queryRemoved',
        query: query
      });
    }
  };

  _proto.clear = function clear() {
    var _this2 = this;

    notifyManager/* notifyManager.batch */.V.batch(function () {
      _this2.queries.forEach(function (query) {
        _this2.remove(query);
      });
    });
  };

  _proto.get = function get(queryHash) {
    return this.queriesMap[queryHash];
  };

  _proto.getAll = function getAll() {
    return this.queries;
  };

  _proto.find = function find(arg1, arg2) {
    var _parseFilterArgs = (0,utils/* parseFilterArgs */.I6)(arg1, arg2),
        filters = _parseFilterArgs[0];

    if (typeof filters.exact === 'undefined') {
      filters.exact = true;
    }

    return this.queries.find(function (query) {
      return (0,utils/* matchQuery */._x)(filters, query);
    });
  };

  _proto.findAll = function findAll(arg1, arg2) {
    var _parseFilterArgs2 = (0,utils/* parseFilterArgs */.I6)(arg1, arg2),
        filters = _parseFilterArgs2[0];

    return Object.keys(filters).length > 0 ? this.queries.filter(function (query) {
      return (0,utils/* matchQuery */._x)(filters, query);
    }) : this.queries;
  };

  _proto.notify = function notify(event) {
    var _this3 = this;

    notifyManager/* notifyManager.batch */.V.batch(function () {
      _this3.listeners.forEach(function (listener) {
        listener(event);
      });
    });
  };

  _proto.onFocus = function onFocus() {
    var _this4 = this;

    notifyManager/* notifyManager.batch */.V.batch(function () {
      _this4.queries.forEach(function (query) {
        query.onFocus();
      });
    });
  };

  _proto.onOnline = function onOnline() {
    var _this5 = this;

    notifyManager/* notifyManager.batch */.V.batch(function () {
      _this5.queries.forEach(function (query) {
        query.onOnline();
      });
    });
  };

  return QueryCache;
}(subscribable/* Subscribable */.l);
// EXTERNAL MODULE: ../../.yarn/__virtual__/react-query-virtual-9ac5b1aaa1/0/cache/react-query-npm-3.39.1-7899b170b9-9273b7c2ad.zip/node_modules/react-query/es/core/mutation.js
var core_mutation = __webpack_require__(86402);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/react-query-virtual-9ac5b1aaa1/0/cache/react-query-npm-3.39.1-7899b170b9-9273b7c2ad.zip/node_modules/react-query/es/core/mutationCache.js




 // TYPES

// CLASS
var MutationCache = /*#__PURE__*/function (_Subscribable) {
  (0,inheritsLoose/* default */.Z)(MutationCache, _Subscribable);

  function MutationCache(config) {
    var _this;

    _this = _Subscribable.call(this) || this;
    _this.config = config || {};
    _this.mutations = [];
    _this.mutationId = 0;
    return _this;
  }

  var _proto = MutationCache.prototype;

  _proto.build = function build(client, options, state) {
    var mutation = new core_mutation/* Mutation */.m({
      mutationCache: this,
      mutationId: ++this.mutationId,
      options: client.defaultMutationOptions(options),
      state: state,
      defaultOptions: options.mutationKey ? client.getMutationDefaults(options.mutationKey) : undefined,
      meta: options.meta
    });
    this.add(mutation);
    return mutation;
  };

  _proto.add = function add(mutation) {
    this.mutations.push(mutation);
    this.notify(mutation);
  };

  _proto.remove = function remove(mutation) {
    this.mutations = this.mutations.filter(function (x) {
      return x !== mutation;
    });
    mutation.cancel();
    this.notify(mutation);
  };

  _proto.clear = function clear() {
    var _this2 = this;

    notifyManager/* notifyManager.batch */.V.batch(function () {
      _this2.mutations.forEach(function (mutation) {
        _this2.remove(mutation);
      });
    });
  };

  _proto.getAll = function getAll() {
    return this.mutations;
  };

  _proto.find = function find(filters) {
    if (typeof filters.exact === 'undefined') {
      filters.exact = true;
    }

    return this.mutations.find(function (mutation) {
      return (0,utils/* matchMutation */.X7)(filters, mutation);
    });
  };

  _proto.findAll = function findAll(filters) {
    return this.mutations.filter(function (mutation) {
      return (0,utils/* matchMutation */.X7)(filters, mutation);
    });
  };

  _proto.notify = function notify(mutation) {
    var _this3 = this;

    notifyManager/* notifyManager.batch */.V.batch(function () {
      _this3.listeners.forEach(function (listener) {
        listener(mutation);
      });
    });
  };

  _proto.onFocus = function onFocus() {
    this.resumePausedMutations();
  };

  _proto.onOnline = function onOnline() {
    this.resumePausedMutations();
  };

  _proto.resumePausedMutations = function resumePausedMutations() {
    var pausedMutations = this.mutations.filter(function (x) {
      return x.state.isPaused;
    });
    return notifyManager/* notifyManager.batch */.V.batch(function () {
      return pausedMutations.reduce(function (promise, mutation) {
        return promise.then(function () {
          return mutation.continue().catch(utils/* noop */.ZT);
        });
      }, Promise.resolve());
    });
  };

  return MutationCache;
}(subscribable/* Subscribable */.l);
// EXTERNAL MODULE: ../../.yarn/__virtual__/react-query-virtual-9ac5b1aaa1/0/cache/react-query-npm-3.39.1-7899b170b9-9273b7c2ad.zip/node_modules/react-query/es/core/focusManager.js
var focusManager = __webpack_require__(43960);
// EXTERNAL MODULE: ../../.yarn/__virtual__/react-query-virtual-9ac5b1aaa1/0/cache/react-query-npm-3.39.1-7899b170b9-9273b7c2ad.zip/node_modules/react-query/es/core/onlineManager.js
var onlineManager = __webpack_require__(22451);
// EXTERNAL MODULE: ../../.yarn/__virtual__/react-query-virtual-9ac5b1aaa1/0/cache/react-query-npm-3.39.1-7899b170b9-9273b7c2ad.zip/node_modules/react-query/es/core/infiniteQueryBehavior.js
var infiniteQueryBehavior = __webpack_require__(78831);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/react-query-virtual-9ac5b1aaa1/0/cache/react-query-npm-3.39.1-7899b170b9-9273b7c2ad.zip/node_modules/react-query/es/core/queryClient.js








// CLASS
var QueryClient = /*#__PURE__*/function () {
  function QueryClient(config) {
    if (config === void 0) {
      config = {};
    }

    this.queryCache = config.queryCache || new QueryCache();
    this.mutationCache = config.mutationCache || new MutationCache();
    this.defaultOptions = config.defaultOptions || {};
    this.queryDefaults = [];
    this.mutationDefaults = [];
  }

  var _proto = QueryClient.prototype;

  _proto.mount = function mount() {
    var _this = this;

    this.unsubscribeFocus = focusManager/* focusManager.subscribe */.j.subscribe(function () {
      if (focusManager/* focusManager.isFocused */.j.isFocused() && onlineManager/* onlineManager.isOnline */.N.isOnline()) {
        _this.mutationCache.onFocus();

        _this.queryCache.onFocus();
      }
    });
    this.unsubscribeOnline = onlineManager/* onlineManager.subscribe */.N.subscribe(function () {
      if (focusManager/* focusManager.isFocused */.j.isFocused() && onlineManager/* onlineManager.isOnline */.N.isOnline()) {
        _this.mutationCache.onOnline();

        _this.queryCache.onOnline();
      }
    });
  };

  _proto.unmount = function unmount() {
    var _this$unsubscribeFocu, _this$unsubscribeOnli;

    (_this$unsubscribeFocu = this.unsubscribeFocus) == null ? void 0 : _this$unsubscribeFocu.call(this);
    (_this$unsubscribeOnli = this.unsubscribeOnline) == null ? void 0 : _this$unsubscribeOnli.call(this);
  };

  _proto.isFetching = function isFetching(arg1, arg2) {
    var _parseFilterArgs = (0,utils/* parseFilterArgs */.I6)(arg1, arg2),
        filters = _parseFilterArgs[0];

    filters.fetching = true;
    return this.queryCache.findAll(filters).length;
  };

  _proto.isMutating = function isMutating(filters) {
    return this.mutationCache.findAll((0,esm_extends/* default */.Z)({}, filters, {
      fetching: true
    })).length;
  };

  _proto.getQueryData = function getQueryData(queryKey, filters) {
    var _this$queryCache$find;

    return (_this$queryCache$find = this.queryCache.find(queryKey, filters)) == null ? void 0 : _this$queryCache$find.state.data;
  };

  _proto.getQueriesData = function getQueriesData(queryKeyOrFilters) {
    return this.getQueryCache().findAll(queryKeyOrFilters).map(function (_ref) {
      var queryKey = _ref.queryKey,
          state = _ref.state;
      var data = state.data;
      return [queryKey, data];
    });
  };

  _proto.setQueryData = function setQueryData(queryKey, updater, options) {
    var parsedOptions = (0,utils/* parseQueryArgs */._v)(queryKey);
    var defaultedOptions = this.defaultQueryOptions(parsedOptions);
    return this.queryCache.build(this, defaultedOptions).setData(updater, options);
  };

  _proto.setQueriesData = function setQueriesData(queryKeyOrFilters, updater, options) {
    var _this2 = this;

    return notifyManager/* notifyManager.batch */.V.batch(function () {
      return _this2.getQueryCache().findAll(queryKeyOrFilters).map(function (_ref2) {
        var queryKey = _ref2.queryKey;
        return [queryKey, _this2.setQueryData(queryKey, updater, options)];
      });
    });
  };

  _proto.getQueryState = function getQueryState(queryKey, filters) {
    var _this$queryCache$find2;

    return (_this$queryCache$find2 = this.queryCache.find(queryKey, filters)) == null ? void 0 : _this$queryCache$find2.state;
  };

  _proto.removeQueries = function removeQueries(arg1, arg2) {
    var _parseFilterArgs2 = (0,utils/* parseFilterArgs */.I6)(arg1, arg2),
        filters = _parseFilterArgs2[0];

    var queryCache = this.queryCache;
    notifyManager/* notifyManager.batch */.V.batch(function () {
      queryCache.findAll(filters).forEach(function (query) {
        queryCache.remove(query);
      });
    });
  };

  _proto.resetQueries = function resetQueries(arg1, arg2, arg3) {
    var _this3 = this;

    var _parseFilterArgs3 = (0,utils/* parseFilterArgs */.I6)(arg1, arg2, arg3),
        filters = _parseFilterArgs3[0],
        options = _parseFilterArgs3[1];

    var queryCache = this.queryCache;

    var refetchFilters = (0,esm_extends/* default */.Z)({}, filters, {
      active: true
    });

    return notifyManager/* notifyManager.batch */.V.batch(function () {
      queryCache.findAll(filters).forEach(function (query) {
        query.reset();
      });
      return _this3.refetchQueries(refetchFilters, options);
    });
  };

  _proto.cancelQueries = function cancelQueries(arg1, arg2, arg3) {
    var _this4 = this;

    var _parseFilterArgs4 = (0,utils/* parseFilterArgs */.I6)(arg1, arg2, arg3),
        filters = _parseFilterArgs4[0],
        _parseFilterArgs4$ = _parseFilterArgs4[1],
        cancelOptions = _parseFilterArgs4$ === void 0 ? {} : _parseFilterArgs4$;

    if (typeof cancelOptions.revert === 'undefined') {
      cancelOptions.revert = true;
    }

    var promises = notifyManager/* notifyManager.batch */.V.batch(function () {
      return _this4.queryCache.findAll(filters).map(function (query) {
        return query.cancel(cancelOptions);
      });
    });
    return Promise.all(promises).then(utils/* noop */.ZT).catch(utils/* noop */.ZT);
  };

  _proto.invalidateQueries = function invalidateQueries(arg1, arg2, arg3) {
    var _ref3,
        _filters$refetchActiv,
        _filters$refetchInact,
        _this5 = this;

    var _parseFilterArgs5 = (0,utils/* parseFilterArgs */.I6)(arg1, arg2, arg3),
        filters = _parseFilterArgs5[0],
        options = _parseFilterArgs5[1];

    var refetchFilters = (0,esm_extends/* default */.Z)({}, filters, {
      // if filters.refetchActive is not provided and filters.active is explicitly false,
      // e.g. invalidateQueries({ active: false }), we don't want to refetch active queries
      active: (_ref3 = (_filters$refetchActiv = filters.refetchActive) != null ? _filters$refetchActiv : filters.active) != null ? _ref3 : true,
      inactive: (_filters$refetchInact = filters.refetchInactive) != null ? _filters$refetchInact : false
    });

    return notifyManager/* notifyManager.batch */.V.batch(function () {
      _this5.queryCache.findAll(filters).forEach(function (query) {
        query.invalidate();
      });

      return _this5.refetchQueries(refetchFilters, options);
    });
  };

  _proto.refetchQueries = function refetchQueries(arg1, arg2, arg3) {
    var _this6 = this;

    var _parseFilterArgs6 = (0,utils/* parseFilterArgs */.I6)(arg1, arg2, arg3),
        filters = _parseFilterArgs6[0],
        options = _parseFilterArgs6[1];

    var promises = notifyManager/* notifyManager.batch */.V.batch(function () {
      return _this6.queryCache.findAll(filters).map(function (query) {
        return query.fetch(undefined, (0,esm_extends/* default */.Z)({}, options, {
          meta: {
            refetchPage: filters == null ? void 0 : filters.refetchPage
          }
        }));
      });
    });
    var promise = Promise.all(promises).then(utils/* noop */.ZT);

    if (!(options == null ? void 0 : options.throwOnError)) {
      promise = promise.catch(utils/* noop */.ZT);
    }

    return promise;
  };

  _proto.fetchQuery = function fetchQuery(arg1, arg2, arg3) {
    var parsedOptions = (0,utils/* parseQueryArgs */._v)(arg1, arg2, arg3);
    var defaultedOptions = this.defaultQueryOptions(parsedOptions); // https://github.com/tannerlinsley/react-query/issues/652

    if (typeof defaultedOptions.retry === 'undefined') {
      defaultedOptions.retry = false;
    }

    var query = this.queryCache.build(this, defaultedOptions);
    return query.isStaleByTime(defaultedOptions.staleTime) ? query.fetch(defaultedOptions) : Promise.resolve(query.state.data);
  };

  _proto.prefetchQuery = function prefetchQuery(arg1, arg2, arg3) {
    return this.fetchQuery(arg1, arg2, arg3).then(utils/* noop */.ZT).catch(utils/* noop */.ZT);
  };

  _proto.fetchInfiniteQuery = function fetchInfiniteQuery(arg1, arg2, arg3) {
    var parsedOptions = (0,utils/* parseQueryArgs */._v)(arg1, arg2, arg3);
    parsedOptions.behavior = (0,infiniteQueryBehavior/* infiniteQueryBehavior */.Gm)();
    return this.fetchQuery(parsedOptions);
  };

  _proto.prefetchInfiniteQuery = function prefetchInfiniteQuery(arg1, arg2, arg3) {
    return this.fetchInfiniteQuery(arg1, arg2, arg3).then(utils/* noop */.ZT).catch(utils/* noop */.ZT);
  };

  _proto.cancelMutations = function cancelMutations() {
    var _this7 = this;

    var promises = notifyManager/* notifyManager.batch */.V.batch(function () {
      return _this7.mutationCache.getAll().map(function (mutation) {
        return mutation.cancel();
      });
    });
    return Promise.all(promises).then(utils/* noop */.ZT).catch(utils/* noop */.ZT);
  };

  _proto.resumePausedMutations = function resumePausedMutations() {
    return this.getMutationCache().resumePausedMutations();
  };

  _proto.executeMutation = function executeMutation(options) {
    return this.mutationCache.build(this, options).execute();
  };

  _proto.getQueryCache = function getQueryCache() {
    return this.queryCache;
  };

  _proto.getMutationCache = function getMutationCache() {
    return this.mutationCache;
  };

  _proto.getDefaultOptions = function getDefaultOptions() {
    return this.defaultOptions;
  };

  _proto.setDefaultOptions = function setDefaultOptions(options) {
    this.defaultOptions = options;
  };

  _proto.setQueryDefaults = function setQueryDefaults(queryKey, options) {
    var result = this.queryDefaults.find(function (x) {
      return (0,utils/* hashQueryKey */.yF)(queryKey) === (0,utils/* hashQueryKey */.yF)(x.queryKey);
    });

    if (result) {
      result.defaultOptions = options;
    } else {
      this.queryDefaults.push({
        queryKey: queryKey,
        defaultOptions: options
      });
    }
  };

  _proto.getQueryDefaults = function getQueryDefaults(queryKey) {
    var _this$queryDefaults$f;

    return queryKey ? (_this$queryDefaults$f = this.queryDefaults.find(function (x) {
      return (0,utils/* partialMatchKey */.to)(queryKey, x.queryKey);
    })) == null ? void 0 : _this$queryDefaults$f.defaultOptions : undefined;
  };

  _proto.setMutationDefaults = function setMutationDefaults(mutationKey, options) {
    var result = this.mutationDefaults.find(function (x) {
      return (0,utils/* hashQueryKey */.yF)(mutationKey) === (0,utils/* hashQueryKey */.yF)(x.mutationKey);
    });

    if (result) {
      result.defaultOptions = options;
    } else {
      this.mutationDefaults.push({
        mutationKey: mutationKey,
        defaultOptions: options
      });
    }
  };

  _proto.getMutationDefaults = function getMutationDefaults(mutationKey) {
    var _this$mutationDefault;

    return mutationKey ? (_this$mutationDefault = this.mutationDefaults.find(function (x) {
      return (0,utils/* partialMatchKey */.to)(mutationKey, x.mutationKey);
    })) == null ? void 0 : _this$mutationDefault.defaultOptions : undefined;
  };

  _proto.defaultQueryOptions = function defaultQueryOptions(options) {
    if (options == null ? void 0 : options._defaulted) {
      return options;
    }

    var defaultedOptions = (0,esm_extends/* default */.Z)({}, this.defaultOptions.queries, this.getQueryDefaults(options == null ? void 0 : options.queryKey), options, {
      _defaulted: true
    });

    if (!defaultedOptions.queryHash && defaultedOptions.queryKey) {
      defaultedOptions.queryHash = (0,utils/* hashQueryKeyByOptions */.Rm)(defaultedOptions.queryKey, defaultedOptions);
    }

    return defaultedOptions;
  };

  _proto.defaultQueryObserverOptions = function defaultQueryObserverOptions(options) {
    return this.defaultQueryOptions(options);
  };

  _proto.defaultMutationOptions = function defaultMutationOptions(options) {
    if (options == null ? void 0 : options._defaulted) {
      return options;
    }

    return (0,esm_extends/* default */.Z)({}, this.defaultOptions.mutations, this.getMutationDefaults(options == null ? void 0 : options.mutationKey), options, {
      _defaulted: true
    });
  };

  _proto.clear = function clear() {
    this.queryCache.clear();
    this.mutationCache.clear();
  };

  return QueryClient;
}();

/***/ }),

/***/ 54105:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DV": function() { return /* binding */ isCancelledError; },
/* harmony export */   "LE": function() { return /* binding */ isCancelable; },
/* harmony export */   "m4": function() { return /* binding */ Retryer; }
/* harmony export */ });
/* unused harmony export CancelledError */
/* harmony import */ var _focusManager__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(43960);
/* harmony import */ var _onlineManager__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(22451);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89107);




function defaultRetryDelay(failureCount) {
  return Math.min(1000 * Math.pow(2, failureCount), 30000);
}

function isCancelable(value) {
  return typeof (value == null ? void 0 : value.cancel) === 'function';
}
var CancelledError = function CancelledError(options) {
  this.revert = options == null ? void 0 : options.revert;
  this.silent = options == null ? void 0 : options.silent;
};
function isCancelledError(value) {
  return value instanceof CancelledError;
} // CLASS

var Retryer = function Retryer(config) {
  var _this = this;

  var cancelRetry = false;
  var cancelFn;
  var continueFn;
  var promiseResolve;
  var promiseReject;
  this.abort = config.abort;

  this.cancel = function (cancelOptions) {
    return cancelFn == null ? void 0 : cancelFn(cancelOptions);
  };

  this.cancelRetry = function () {
    cancelRetry = true;
  };

  this.continueRetry = function () {
    cancelRetry = false;
  };

  this.continue = function () {
    return continueFn == null ? void 0 : continueFn();
  };

  this.failureCount = 0;
  this.isPaused = false;
  this.isResolved = false;
  this.isTransportCancelable = false;
  this.promise = new Promise(function (outerResolve, outerReject) {
    promiseResolve = outerResolve;
    promiseReject = outerReject;
  });

  var resolve = function resolve(value) {
    if (!_this.isResolved) {
      _this.isResolved = true;
      config.onSuccess == null ? void 0 : config.onSuccess(value);
      continueFn == null ? void 0 : continueFn();
      promiseResolve(value);
    }
  };

  var reject = function reject(value) {
    if (!_this.isResolved) {
      _this.isResolved = true;
      config.onError == null ? void 0 : config.onError(value);
      continueFn == null ? void 0 : continueFn();
      promiseReject(value);
    }
  };

  var pause = function pause() {
    return new Promise(function (continueResolve) {
      continueFn = continueResolve;
      _this.isPaused = true;
      config.onPause == null ? void 0 : config.onPause();
    }).then(function () {
      continueFn = undefined;
      _this.isPaused = false;
      config.onContinue == null ? void 0 : config.onContinue();
    });
  }; // Create loop function


  var run = function run() {
    // Do nothing if already resolved
    if (_this.isResolved) {
      return;
    }

    var promiseOrValue; // Execute query

    try {
      promiseOrValue = config.fn();
    } catch (error) {
      promiseOrValue = Promise.reject(error);
    } // Create callback to cancel this fetch


    cancelFn = function cancelFn(cancelOptions) {
      if (!_this.isResolved) {
        reject(new CancelledError(cancelOptions));
        _this.abort == null ? void 0 : _this.abort(); // Cancel transport if supported

        if (isCancelable(promiseOrValue)) {
          try {
            promiseOrValue.cancel();
          } catch (_unused) {}
        }
      }
    }; // Check if the transport layer support cancellation


    _this.isTransportCancelable = isCancelable(promiseOrValue);
    Promise.resolve(promiseOrValue).then(resolve).catch(function (error) {
      var _config$retry, _config$retryDelay;

      // Stop if the fetch is already resolved
      if (_this.isResolved) {
        return;
      } // Do we need to retry the request?


      var retry = (_config$retry = config.retry) != null ? _config$retry : 3;
      var retryDelay = (_config$retryDelay = config.retryDelay) != null ? _config$retryDelay : defaultRetryDelay;
      var delay = typeof retryDelay === 'function' ? retryDelay(_this.failureCount, error) : retryDelay;
      var shouldRetry = retry === true || typeof retry === 'number' && _this.failureCount < retry || typeof retry === 'function' && retry(_this.failureCount, error);

      if (cancelRetry || !shouldRetry) {
        // We are done if the query does not need to be retried
        reject(error);
        return;
      }

      _this.failureCount++; // Notify on fail

      config.onFail == null ? void 0 : config.onFail(_this.failureCount, error); // Delay

      (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .sleep */ .Gh)(delay) // Pause if the document is not visible or when the device is offline
      .then(function () {
        if (!_focusManager__WEBPACK_IMPORTED_MODULE_1__/* .focusManager.isFocused */ .j.isFocused() || !_onlineManager__WEBPACK_IMPORTED_MODULE_2__/* .onlineManager.isOnline */ .N.isOnline()) {
          return pause();
        }
      }).then(function () {
        if (cancelRetry) {
          reject(error);
        } else {
          run();
        }
      });
    });
  }; // Start loop


  run();
};

/***/ }),

/***/ 57239:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "l": function() { return /* binding */ Subscribable; }
/* harmony export */ });
var Subscribable = /*#__PURE__*/function () {
  function Subscribable() {
    this.listeners = [];
  }

  var _proto = Subscribable.prototype;

  _proto.subscribe = function subscribe(listener) {
    var _this = this;

    var callback = listener || function () {
      return undefined;
    };

    this.listeners.push(callback);
    this.onSubscribe();
    return function () {
      _this.listeners = _this.listeners.filter(function (x) {
        return x !== callback;
      });

      _this.onUnsubscribe();
    };
  };

  _proto.hasListeners = function hasListeners() {
    return this.listeners.length > 0;
  };

  _proto.onSubscribe = function onSubscribe() {// Do nothing
  };

  _proto.onUnsubscribe = function onUnsubscribe() {// Do nothing
  };

  return Subscribable;
}();

/***/ }),

/***/ 92885:
/***/ (function() {



/***/ }),

/***/ 89107:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A4": function() { return /* binding */ scheduleMicrotask; },
/* harmony export */   "G9": function() { return /* binding */ getAbortController; },
/* harmony export */   "Gh": function() { return /* binding */ sleep; },
/* harmony export */   "I6": function() { return /* binding */ parseFilterArgs; },
/* harmony export */   "Kp": function() { return /* binding */ timeUntilStale; },
/* harmony export */   "PN": function() { return /* binding */ isValidTimeout; },
/* harmony export */   "Q$": function() { return /* binding */ replaceEqualDeep; },
/* harmony export */   "Rm": function() { return /* binding */ hashQueryKeyByOptions; },
/* harmony export */   "SE": function() { return /* binding */ functionalUpdate; },
/* harmony export */   "VS": function() { return /* binding */ shallowEqualObjects; },
/* harmony export */   "X7": function() { return /* binding */ matchMutation; },
/* harmony export */   "ZT": function() { return /* binding */ noop; },
/* harmony export */   "_v": function() { return /* binding */ parseQueryArgs; },
/* harmony export */   "_x": function() { return /* binding */ matchQuery; },
/* harmony export */   "lV": function() { return /* binding */ parseMutationArgs; },
/* harmony export */   "mc": function() { return /* binding */ ensureQueryKeyArray; },
/* harmony export */   "sk": function() { return /* binding */ isServer; },
/* harmony export */   "to": function() { return /* binding */ partialMatchKey; },
/* harmony export */   "yF": function() { return /* binding */ hashQueryKey; }
/* harmony export */ });
/* unused harmony exports difference, replaceAt, parseMutationFilterArgs, mapQueryStatusFilter, stableValueHash, partialDeepEqual, isPlainObject, isQueryKey, isError */
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(37997);

// TYPES
// UTILS
var isServer = typeof window === 'undefined';
function noop() {
  return undefined;
}
function functionalUpdate(updater, input) {
  return typeof updater === 'function' ? updater(input) : updater;
}
function isValidTimeout(value) {
  return typeof value === 'number' && value >= 0 && value !== Infinity;
}
function ensureQueryKeyArray(value) {
  return Array.isArray(value) ? value : [value];
}
function difference(array1, array2) {
  return array1.filter(function (x) {
    return array2.indexOf(x) === -1;
  });
}
function replaceAt(array, index, value) {
  var copy = array.slice(0);
  copy[index] = value;
  return copy;
}
function timeUntilStale(updatedAt, staleTime) {
  return Math.max(updatedAt + (staleTime || 0) - Date.now(), 0);
}
function parseQueryArgs(arg1, arg2, arg3) {
  if (!isQueryKey(arg1)) {
    return arg1;
  }

  if (typeof arg2 === 'function') {
    return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, arg3, {
      queryKey: arg1,
      queryFn: arg2
    });
  }

  return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, arg2, {
    queryKey: arg1
  });
}
function parseMutationArgs(arg1, arg2, arg3) {
  if (isQueryKey(arg1)) {
    if (typeof arg2 === 'function') {
      return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, arg3, {
        mutationKey: arg1,
        mutationFn: arg2
      });
    }

    return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, arg2, {
      mutationKey: arg1
    });
  }

  if (typeof arg1 === 'function') {
    return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, arg2, {
      mutationFn: arg1
    });
  }

  return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, arg1);
}
function parseFilterArgs(arg1, arg2, arg3) {
  return isQueryKey(arg1) ? [(0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, arg2, {
    queryKey: arg1
  }), arg3] : [arg1 || {}, arg2];
}
function parseMutationFilterArgs(arg1, arg2) {
  return isQueryKey(arg1) ? _extends({}, arg2, {
    mutationKey: arg1
  }) : arg1;
}
function mapQueryStatusFilter(active, inactive) {
  if (active === true && inactive === true || active == null && inactive == null) {
    return 'all';
  } else if (active === false && inactive === false) {
    return 'none';
  } else {
    // At this point, active|inactive can only be true|false or false|true
    // so, when only one value is provided, the missing one has to be the negated value
    var isActive = active != null ? active : !inactive;
    return isActive ? 'active' : 'inactive';
  }
}
function matchQuery(filters, query) {
  var active = filters.active,
      exact = filters.exact,
      fetching = filters.fetching,
      inactive = filters.inactive,
      predicate = filters.predicate,
      queryKey = filters.queryKey,
      stale = filters.stale;

  if (isQueryKey(queryKey)) {
    if (exact) {
      if (query.queryHash !== hashQueryKeyByOptions(queryKey, query.options)) {
        return false;
      }
    } else if (!partialMatchKey(query.queryKey, queryKey)) {
      return false;
    }
  }

  var queryStatusFilter = mapQueryStatusFilter(active, inactive);

  if (queryStatusFilter === 'none') {
    return false;
  } else if (queryStatusFilter !== 'all') {
    var isActive = query.isActive();

    if (queryStatusFilter === 'active' && !isActive) {
      return false;
    }

    if (queryStatusFilter === 'inactive' && isActive) {
      return false;
    }
  }

  if (typeof stale === 'boolean' && query.isStale() !== stale) {
    return false;
  }

  if (typeof fetching === 'boolean' && query.isFetching() !== fetching) {
    return false;
  }

  if (predicate && !predicate(query)) {
    return false;
  }

  return true;
}
function matchMutation(filters, mutation) {
  var exact = filters.exact,
      fetching = filters.fetching,
      predicate = filters.predicate,
      mutationKey = filters.mutationKey;

  if (isQueryKey(mutationKey)) {
    if (!mutation.options.mutationKey) {
      return false;
    }

    if (exact) {
      if (hashQueryKey(mutation.options.mutationKey) !== hashQueryKey(mutationKey)) {
        return false;
      }
    } else if (!partialMatchKey(mutation.options.mutationKey, mutationKey)) {
      return false;
    }
  }

  if (typeof fetching === 'boolean' && mutation.state.status === 'loading' !== fetching) {
    return false;
  }

  if (predicate && !predicate(mutation)) {
    return false;
  }

  return true;
}
function hashQueryKeyByOptions(queryKey, options) {
  var hashFn = (options == null ? void 0 : options.queryKeyHashFn) || hashQueryKey;
  return hashFn(queryKey);
}
/**
 * Default query keys hash function.
 */

function hashQueryKey(queryKey) {
  var asArray = ensureQueryKeyArray(queryKey);
  return stableValueHash(asArray);
}
/**
 * Hashes the value into a stable hash.
 */

function stableValueHash(value) {
  return JSON.stringify(value, function (_, val) {
    return isPlainObject(val) ? Object.keys(val).sort().reduce(function (result, key) {
      result[key] = val[key];
      return result;
    }, {}) : val;
  });
}
/**
 * Checks if key `b` partially matches with key `a`.
 */

function partialMatchKey(a, b) {
  return partialDeepEqual(ensureQueryKeyArray(a), ensureQueryKeyArray(b));
}
/**
 * Checks if `b` partially matches with `a`.
 */

function partialDeepEqual(a, b) {
  if (a === b) {
    return true;
  }

  if (typeof a !== typeof b) {
    return false;
  }

  if (a && b && typeof a === 'object' && typeof b === 'object') {
    return !Object.keys(b).some(function (key) {
      return !partialDeepEqual(a[key], b[key]);
    });
  }

  return false;
}
/**
 * This function returns `a` if `b` is deeply equal.
 * If not, it will replace any deeply equal children of `b` with those of `a`.
 * This can be used for structural sharing between JSON values for example.
 */

function replaceEqualDeep(a, b) {
  if (a === b) {
    return a;
  }

  var array = Array.isArray(a) && Array.isArray(b);

  if (array || isPlainObject(a) && isPlainObject(b)) {
    var aSize = array ? a.length : Object.keys(a).length;
    var bItems = array ? b : Object.keys(b);
    var bSize = bItems.length;
    var copy = array ? [] : {};
    var equalItems = 0;

    for (var i = 0; i < bSize; i++) {
      var key = array ? i : bItems[i];
      copy[key] = replaceEqualDeep(a[key], b[key]);

      if (copy[key] === a[key]) {
        equalItems++;
      }
    }

    return aSize === bSize && equalItems === aSize ? a : copy;
  }

  return b;
}
/**
 * Shallow compare objects. Only works with objects that always have the same properties.
 */

function shallowEqualObjects(a, b) {
  if (a && !b || b && !a) {
    return false;
  }

  for (var key in a) {
    if (a[key] !== b[key]) {
      return false;
    }
  }

  return true;
} // Copied from: https://github.com/jonschlinkert/is-plain-object

function isPlainObject(o) {
  if (!hasObjectPrototype(o)) {
    return false;
  } // If has modified constructor


  var ctor = o.constructor;

  if (typeof ctor === 'undefined') {
    return true;
  } // If has modified prototype


  var prot = ctor.prototype;

  if (!hasObjectPrototype(prot)) {
    return false;
  } // If constructor does not have an Object-specific method


  if (!prot.hasOwnProperty('isPrototypeOf')) {
    return false;
  } // Most likely a plain Object


  return true;
}

function hasObjectPrototype(o) {
  return Object.prototype.toString.call(o) === '[object Object]';
}

function isQueryKey(value) {
  return typeof value === 'string' || Array.isArray(value);
}
function isError(value) {
  return value instanceof Error;
}
function sleep(timeout) {
  return new Promise(function (resolve) {
    setTimeout(resolve, timeout);
  });
}
/**
 * Schedules a microtask.
 * This can be useful to schedule state updates after rendering.
 */

function scheduleMicrotask(callback) {
  Promise.resolve().then(callback).catch(function (error) {
    return setTimeout(function () {
      throw error;
    });
  });
}
function getAbortController() {
  if (typeof AbortController === 'function') {
    return new AbortController();
  }
}

/***/ }),

/***/ 85166:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Hydrate": function() { return /* reexport safe */ _react__WEBPACK_IMPORTED_MODULE_1__.Hydrate; },
/* harmony export */   "QueryClient": function() { return /* reexport safe */ _core__WEBPACK_IMPORTED_MODULE_0__.QueryClient; },
/* harmony export */   "QueryClientProvider": function() { return /* reexport safe */ _react__WEBPACK_IMPORTED_MODULE_1__.QueryClientProvider; },
/* harmony export */   "dehydrate": function() { return /* reexport safe */ _core__WEBPACK_IMPORTED_MODULE_0__.dehydrate; },
/* harmony export */   "hashQueryKey": function() { return /* reexport safe */ _core__WEBPACK_IMPORTED_MODULE_0__.hashQueryKey; },
/* harmony export */   "useInfiniteQuery": function() { return /* reexport safe */ _react__WEBPACK_IMPORTED_MODULE_1__.useInfiniteQuery; },
/* harmony export */   "useMutation": function() { return /* reexport safe */ _react__WEBPACK_IMPORTED_MODULE_1__.useMutation; },
/* harmony export */   "useQuery": function() { return /* reexport safe */ _react__WEBPACK_IMPORTED_MODULE_1__.useQuery; },
/* harmony export */   "useQueryClient": function() { return /* reexport safe */ _react__WEBPACK_IMPORTED_MODULE_1__.useQueryClient; }
/* harmony export */ });
/* harmony import */ var _core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(75047);
/* harmony reexport (checked) */ if(__webpack_require__.o(_core__WEBPACK_IMPORTED_MODULE_0__, "Hydrate")) __webpack_require__.d(__webpack_exports__, { "Hydrate": function() { return _core__WEBPACK_IMPORTED_MODULE_0__.Hydrate; } });
/* harmony reexport (checked) */ if(__webpack_require__.o(_core__WEBPACK_IMPORTED_MODULE_0__, "QueryClientProvider")) __webpack_require__.d(__webpack_exports__, { "QueryClientProvider": function() { return _core__WEBPACK_IMPORTED_MODULE_0__.QueryClientProvider; } });
/* harmony reexport (checked) */ if(__webpack_require__.o(_core__WEBPACK_IMPORTED_MODULE_0__, "useInfiniteQuery")) __webpack_require__.d(__webpack_exports__, { "useInfiniteQuery": function() { return _core__WEBPACK_IMPORTED_MODULE_0__.useInfiniteQuery; } });
/* harmony reexport (checked) */ if(__webpack_require__.o(_core__WEBPACK_IMPORTED_MODULE_0__, "useMutation")) __webpack_require__.d(__webpack_exports__, { "useMutation": function() { return _core__WEBPACK_IMPORTED_MODULE_0__.useMutation; } });
/* harmony reexport (checked) */ if(__webpack_require__.o(_core__WEBPACK_IMPORTED_MODULE_0__, "useQuery")) __webpack_require__.d(__webpack_exports__, { "useQuery": function() { return _core__WEBPACK_IMPORTED_MODULE_0__.useQuery; } });
/* harmony reexport (checked) */ if(__webpack_require__.o(_core__WEBPACK_IMPORTED_MODULE_0__, "useQueryClient")) __webpack_require__.d(__webpack_exports__, { "useQueryClient": function() { return _core__WEBPACK_IMPORTED_MODULE_0__.useQueryClient; } });
/* harmony import */ var _react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(192);



/***/ }),

/***/ 192:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Hydrate": function() { return /* reexport */ Hydrate; },
  "QueryClientProvider": function() { return /* reexport */ QueryClientProvider; },
  "useInfiniteQuery": function() { return /* reexport */ useInfiniteQuery; },
  "useMutation": function() { return /* reexport */ useMutation; },
  "useQuery": function() { return /* reexport */ useQuery; },
  "useQueryClient": function() { return /* reexport */ useQueryClient; }
});

// UNUSED EXPORTS: QueryErrorResetBoundary, useHydrate, useIsFetching, useIsMutating, useQueries, useQueryErrorResetBoundary

// EXTERNAL MODULE: ../../.yarn/__virtual__/react-query-virtual-9ac5b1aaa1/0/cache/react-query-npm-3.39.1-7899b170b9-9273b7c2ad.zip/node_modules/react-query/es/core/notifyManager.js
var notifyManager = __webpack_require__(38203);
// EXTERNAL MODULE: ../../.yarn/__virtual__/react-dom-virtual-60cbd4834f/0/cache/react-dom-npm-18.2.0-dd675bca1c-7d323310be.zip/node_modules/react-dom/index.js
var react_dom = __webpack_require__(13137);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/react-query-virtual-9ac5b1aaa1/0/cache/react-query-npm-3.39.1-7899b170b9-9273b7c2ad.zip/node_modules/react-query/es/react/reactBatchedUpdates.js

var unstable_batchedUpdates = react_dom.unstable_batchedUpdates;
;// CONCATENATED MODULE: ../../.yarn/__virtual__/react-query-virtual-9ac5b1aaa1/0/cache/react-query-npm-3.39.1-7899b170b9-9273b7c2ad.zip/node_modules/react-query/es/react/setBatchUpdatesFn.js


notifyManager/* notifyManager.setBatchNotifyFunction */.V.setBatchNotifyFunction(unstable_batchedUpdates);
// EXTERNAL MODULE: ../../.yarn/__virtual__/react-query-virtual-9ac5b1aaa1/0/cache/react-query-npm-3.39.1-7899b170b9-9273b7c2ad.zip/node_modules/react-query/es/core/logger.js
var logger = __webpack_require__(73082);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/react-query-virtual-9ac5b1aaa1/0/cache/react-query-npm-3.39.1-7899b170b9-9273b7c2ad.zip/node_modules/react-query/es/react/logger.js
var logger_logger = console;
;// CONCATENATED MODULE: ../../.yarn/__virtual__/react-query-virtual-9ac5b1aaa1/0/cache/react-query-npm-3.39.1-7899b170b9-9273b7c2ad.zip/node_modules/react-query/es/react/setLogger.js


(0,logger/* setLogger */.E)(logger_logger);
// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(91987);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/react-query-virtual-9ac5b1aaa1/0/cache/react-query-npm-3.39.1-7899b170b9-9273b7c2ad.zip/node_modules/react-query/es/react/QueryClientProvider.js

var defaultContext = /*#__PURE__*/react.createContext(undefined);
var QueryClientSharingContext = /*#__PURE__*/react.createContext(false); // if contextSharing is on, we share the first and at least one
// instance of the context across the window
// to ensure that if React Query is used across
// different bundles or microfrontends they will
// all use the same **instance** of context, regardless
// of module scoping.

function getQueryClientContext(contextSharing) {
  if (contextSharing && typeof window !== 'undefined') {
    if (!window.ReactQueryClientContext) {
      window.ReactQueryClientContext = defaultContext;
    }

    return window.ReactQueryClientContext;
  }

  return defaultContext;
}

var useQueryClient = function useQueryClient() {
  var queryClient = react.useContext(getQueryClientContext(react.useContext(QueryClientSharingContext)));

  if (!queryClient) {
    throw new Error('No QueryClient set, use QueryClientProvider to set one');
  }

  return queryClient;
};
var QueryClientProvider = function QueryClientProvider(_ref) {
  var client = _ref.client,
      _ref$contextSharing = _ref.contextSharing,
      contextSharing = _ref$contextSharing === void 0 ? false : _ref$contextSharing,
      children = _ref.children;
  react.useEffect(function () {
    client.mount();
    return function () {
      client.unmount();
    };
  }, [client]);
  var Context = getQueryClientContext(contextSharing);
  return /*#__PURE__*/react.createElement(QueryClientSharingContext.Provider, {
    value: contextSharing
  }, /*#__PURE__*/react.createElement(Context.Provider, {
    value: client
  }, children));
};
// EXTERNAL MODULE: ../../.yarn/cache/@babel-runtime-npm-7.20.1-8f9256f2ed-00567a333d.zip/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(37997);
// EXTERNAL MODULE: ../../.yarn/__virtual__/react-query-virtual-9ac5b1aaa1/0/cache/react-query-npm-3.39.1-7899b170b9-9273b7c2ad.zip/node_modules/react-query/es/core/utils.js
var utils = __webpack_require__(89107);
// EXTERNAL MODULE: ../../.yarn/cache/@babel-runtime-npm-7.20.1-8f9256f2ed-00567a333d.zip/node_modules/@babel/runtime/helpers/esm/inheritsLoose.js
var inheritsLoose = __webpack_require__(48848);
// EXTERNAL MODULE: ../../.yarn/__virtual__/react-query-virtual-9ac5b1aaa1/0/cache/react-query-npm-3.39.1-7899b170b9-9273b7c2ad.zip/node_modules/react-query/es/core/mutation.js
var mutation = __webpack_require__(86402);
// EXTERNAL MODULE: ../../.yarn/__virtual__/react-query-virtual-9ac5b1aaa1/0/cache/react-query-npm-3.39.1-7899b170b9-9273b7c2ad.zip/node_modules/react-query/es/core/subscribable.js
var subscribable = __webpack_require__(57239);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/react-query-virtual-9ac5b1aaa1/0/cache/react-query-npm-3.39.1-7899b170b9-9273b7c2ad.zip/node_modules/react-query/es/core/mutationObserver.js





// CLASS
var MutationObserver = /*#__PURE__*/function (_Subscribable) {
  (0,inheritsLoose/* default */.Z)(MutationObserver, _Subscribable);

  function MutationObserver(client, options) {
    var _this;

    _this = _Subscribable.call(this) || this;
    _this.client = client;

    _this.setOptions(options);

    _this.bindMethods();

    _this.updateResult();

    return _this;
  }

  var _proto = MutationObserver.prototype;

  _proto.bindMethods = function bindMethods() {
    this.mutate = this.mutate.bind(this);
    this.reset = this.reset.bind(this);
  };

  _proto.setOptions = function setOptions(options) {
    this.options = this.client.defaultMutationOptions(options);
  };

  _proto.onUnsubscribe = function onUnsubscribe() {
    if (!this.listeners.length) {
      var _this$currentMutation;

      (_this$currentMutation = this.currentMutation) == null ? void 0 : _this$currentMutation.removeObserver(this);
    }
  };

  _proto.onMutationUpdate = function onMutationUpdate(action) {
    this.updateResult(); // Determine which callbacks to trigger

    var notifyOptions = {
      listeners: true
    };

    if (action.type === 'success') {
      notifyOptions.onSuccess = true;
    } else if (action.type === 'error') {
      notifyOptions.onError = true;
    }

    this.notify(notifyOptions);
  };

  _proto.getCurrentResult = function getCurrentResult() {
    return this.currentResult;
  };

  _proto.reset = function reset() {
    this.currentMutation = undefined;
    this.updateResult();
    this.notify({
      listeners: true
    });
  };

  _proto.mutate = function mutate(variables, options) {
    this.mutateOptions = options;

    if (this.currentMutation) {
      this.currentMutation.removeObserver(this);
    }

    this.currentMutation = this.client.getMutationCache().build(this.client, (0,esm_extends/* default */.Z)({}, this.options, {
      variables: typeof variables !== 'undefined' ? variables : this.options.variables
    }));
    this.currentMutation.addObserver(this);
    return this.currentMutation.execute();
  };

  _proto.updateResult = function updateResult() {
    var state = this.currentMutation ? this.currentMutation.state : (0,mutation/* getDefaultState */.R)();

    var result = (0,esm_extends/* default */.Z)({}, state, {
      isLoading: state.status === 'loading',
      isSuccess: state.status === 'success',
      isError: state.status === 'error',
      isIdle: state.status === 'idle',
      mutate: this.mutate,
      reset: this.reset
    });

    this.currentResult = result;
  };

  _proto.notify = function notify(options) {
    var _this2 = this;

    notifyManager/* notifyManager.batch */.V.batch(function () {
      // First trigger the mutate callbacks
      if (_this2.mutateOptions) {
        if (options.onSuccess) {
          _this2.mutateOptions.onSuccess == null ? void 0 : _this2.mutateOptions.onSuccess(_this2.currentResult.data, _this2.currentResult.variables, _this2.currentResult.context);
          _this2.mutateOptions.onSettled == null ? void 0 : _this2.mutateOptions.onSettled(_this2.currentResult.data, null, _this2.currentResult.variables, _this2.currentResult.context);
        } else if (options.onError) {
          _this2.mutateOptions.onError == null ? void 0 : _this2.mutateOptions.onError(_this2.currentResult.error, _this2.currentResult.variables, _this2.currentResult.context);
          _this2.mutateOptions.onSettled == null ? void 0 : _this2.mutateOptions.onSettled(undefined, _this2.currentResult.error, _this2.currentResult.variables, _this2.currentResult.context);
        }
      } // Then trigger the listeners


      if (options.listeners) {
        _this2.listeners.forEach(function (listener) {
          listener(_this2.currentResult);
        });
      }
    });
  };

  return MutationObserver;
}(subscribable/* Subscribable */.l);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/react-query-virtual-9ac5b1aaa1/0/cache/react-query-npm-3.39.1-7899b170b9-9273b7c2ad.zip/node_modules/react-query/es/react/utils.js
function shouldThrowError(suspense, _useErrorBoundary, params) {
  // Allow useErrorBoundary function to override throwing behavior on a per-error basis
  if (typeof _useErrorBoundary === 'function') {
    return _useErrorBoundary.apply(void 0, params);
  } // Allow useErrorBoundary to override suspense's throwing behavior


  if (typeof _useErrorBoundary === 'boolean') return _useErrorBoundary; // If suspense is enabled default to throwing errors

  return !!suspense;
}
;// CONCATENATED MODULE: ../../.yarn/__virtual__/react-query-virtual-9ac5b1aaa1/0/cache/react-query-npm-3.39.1-7899b170b9-9273b7c2ad.zip/node_modules/react-query/es/react/useMutation.js






 // HOOK

function useMutation(arg1, arg2, arg3) {
  var mountedRef = react.useRef(false);

  var _React$useState = react.useState(0),
      forceUpdate = _React$useState[1];

  var options = (0,utils/* parseMutationArgs */.lV)(arg1, arg2, arg3);
  var queryClient = useQueryClient();
  var obsRef = react.useRef();

  if (!obsRef.current) {
    obsRef.current = new MutationObserver(queryClient, options);
  } else {
    obsRef.current.setOptions(options);
  }

  var currentResult = obsRef.current.getCurrentResult();
  react.useEffect(function () {
    mountedRef.current = true;
    var unsubscribe = obsRef.current.subscribe(notifyManager/* notifyManager.batchCalls */.V.batchCalls(function () {
      if (mountedRef.current) {
        forceUpdate(function (x) {
          return x + 1;
        });
      }
    }));
    return function () {
      mountedRef.current = false;
      unsubscribe();
    };
  }, []);
  var mutate = react.useCallback(function (variables, mutateOptions) {
    obsRef.current.mutate(variables, mutateOptions).catch(utils/* noop */.ZT);
  }, []);

  if (currentResult.error && shouldThrowError(undefined, obsRef.current.options.useErrorBoundary, [currentResult.error])) {
    throw currentResult.error;
  }

  return (0,esm_extends/* default */.Z)({}, currentResult, {
    mutate: mutate,
    mutateAsync: currentResult.mutate
  });
}
// EXTERNAL MODULE: ../../.yarn/__virtual__/react-query-virtual-9ac5b1aaa1/0/cache/react-query-npm-3.39.1-7899b170b9-9273b7c2ad.zip/node_modules/react-query/es/core/focusManager.js
var focusManager = __webpack_require__(43960);
// EXTERNAL MODULE: ../../.yarn/__virtual__/react-query-virtual-9ac5b1aaa1/0/cache/react-query-npm-3.39.1-7899b170b9-9273b7c2ad.zip/node_modules/react-query/es/core/retryer.js
var retryer = __webpack_require__(54105);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/react-query-virtual-9ac5b1aaa1/0/cache/react-query-npm-3.39.1-7899b170b9-9273b7c2ad.zip/node_modules/react-query/es/core/queryObserver.js








var QueryObserver = /*#__PURE__*/function (_Subscribable) {
  (0,inheritsLoose/* default */.Z)(QueryObserver, _Subscribable);

  function QueryObserver(client, options) {
    var _this;

    _this = _Subscribable.call(this) || this;
    _this.client = client;
    _this.options = options;
    _this.trackedProps = [];
    _this.selectError = null;

    _this.bindMethods();

    _this.setOptions(options);

    return _this;
  }

  var _proto = QueryObserver.prototype;

  _proto.bindMethods = function bindMethods() {
    this.remove = this.remove.bind(this);
    this.refetch = this.refetch.bind(this);
  };

  _proto.onSubscribe = function onSubscribe() {
    if (this.listeners.length === 1) {
      this.currentQuery.addObserver(this);

      if (shouldFetchOnMount(this.currentQuery, this.options)) {
        this.executeFetch();
      }

      this.updateTimers();
    }
  };

  _proto.onUnsubscribe = function onUnsubscribe() {
    if (!this.listeners.length) {
      this.destroy();
    }
  };

  _proto.shouldFetchOnReconnect = function shouldFetchOnReconnect() {
    return shouldFetchOn(this.currentQuery, this.options, this.options.refetchOnReconnect);
  };

  _proto.shouldFetchOnWindowFocus = function shouldFetchOnWindowFocus() {
    return shouldFetchOn(this.currentQuery, this.options, this.options.refetchOnWindowFocus);
  };

  _proto.destroy = function destroy() {
    this.listeners = [];
    this.clearTimers();
    this.currentQuery.removeObserver(this);
  };

  _proto.setOptions = function setOptions(options, notifyOptions) {
    var prevOptions = this.options;
    var prevQuery = this.currentQuery;
    this.options = this.client.defaultQueryObserverOptions(options);

    if (typeof this.options.enabled !== 'undefined' && typeof this.options.enabled !== 'boolean') {
      throw new Error('Expected enabled to be a boolean');
    } // Keep previous query key if the user does not supply one


    if (!this.options.queryKey) {
      this.options.queryKey = prevOptions.queryKey;
    }

    this.updateQuery();
    var mounted = this.hasListeners(); // Fetch if there are subscribers

    if (mounted && shouldFetchOptionally(this.currentQuery, prevQuery, this.options, prevOptions)) {
      this.executeFetch();
    } // Update result


    this.updateResult(notifyOptions); // Update stale interval if needed

    if (mounted && (this.currentQuery !== prevQuery || this.options.enabled !== prevOptions.enabled || this.options.staleTime !== prevOptions.staleTime)) {
      this.updateStaleTimeout();
    }

    var nextRefetchInterval = this.computeRefetchInterval(); // Update refetch interval if needed

    if (mounted && (this.currentQuery !== prevQuery || this.options.enabled !== prevOptions.enabled || nextRefetchInterval !== this.currentRefetchInterval)) {
      this.updateRefetchInterval(nextRefetchInterval);
    }
  };

  _proto.getOptimisticResult = function getOptimisticResult(options) {
    var defaultedOptions = this.client.defaultQueryObserverOptions(options);
    var query = this.client.getQueryCache().build(this.client, defaultedOptions);
    return this.createResult(query, defaultedOptions);
  };

  _proto.getCurrentResult = function getCurrentResult() {
    return this.currentResult;
  };

  _proto.trackResult = function trackResult(result, defaultedOptions) {
    var _this2 = this;

    var trackedResult = {};

    var trackProp = function trackProp(key) {
      if (!_this2.trackedProps.includes(key)) {
        _this2.trackedProps.push(key);
      }
    };

    Object.keys(result).forEach(function (key) {
      Object.defineProperty(trackedResult, key, {
        configurable: false,
        enumerable: true,
        get: function get() {
          trackProp(key);
          return result[key];
        }
      });
    });

    if (defaultedOptions.useErrorBoundary || defaultedOptions.suspense) {
      trackProp('error');
    }

    return trackedResult;
  };

  _proto.getNextResult = function getNextResult(options) {
    var _this3 = this;

    return new Promise(function (resolve, reject) {
      var unsubscribe = _this3.subscribe(function (result) {
        if (!result.isFetching) {
          unsubscribe();

          if (result.isError && (options == null ? void 0 : options.throwOnError)) {
            reject(result.error);
          } else {
            resolve(result);
          }
        }
      });
    });
  };

  _proto.getCurrentQuery = function getCurrentQuery() {
    return this.currentQuery;
  };

  _proto.remove = function remove() {
    this.client.getQueryCache().remove(this.currentQuery);
  };

  _proto.refetch = function refetch(options) {
    return this.fetch((0,esm_extends/* default */.Z)({}, options, {
      meta: {
        refetchPage: options == null ? void 0 : options.refetchPage
      }
    }));
  };

  _proto.fetchOptimistic = function fetchOptimistic(options) {
    var _this4 = this;

    var defaultedOptions = this.client.defaultQueryObserverOptions(options);
    var query = this.client.getQueryCache().build(this.client, defaultedOptions);
    return query.fetch().then(function () {
      return _this4.createResult(query, defaultedOptions);
    });
  };

  _proto.fetch = function fetch(fetchOptions) {
    var _this5 = this;

    return this.executeFetch(fetchOptions).then(function () {
      _this5.updateResult();

      return _this5.currentResult;
    });
  };

  _proto.executeFetch = function executeFetch(fetchOptions) {
    // Make sure we reference the latest query as the current one might have been removed
    this.updateQuery(); // Fetch

    var promise = this.currentQuery.fetch(this.options, fetchOptions);

    if (!(fetchOptions == null ? void 0 : fetchOptions.throwOnError)) {
      promise = promise.catch(utils/* noop */.ZT);
    }

    return promise;
  };

  _proto.updateStaleTimeout = function updateStaleTimeout() {
    var _this6 = this;

    this.clearStaleTimeout();

    if (utils/* isServer */.sk || this.currentResult.isStale || !(0,utils/* isValidTimeout */.PN)(this.options.staleTime)) {
      return;
    }

    var time = (0,utils/* timeUntilStale */.Kp)(this.currentResult.dataUpdatedAt, this.options.staleTime); // The timeout is sometimes triggered 1 ms before the stale time expiration.
    // To mitigate this issue we always add 1 ms to the timeout.

    var timeout = time + 1;
    this.staleTimeoutId = setTimeout(function () {
      if (!_this6.currentResult.isStale) {
        _this6.updateResult();
      }
    }, timeout);
  };

  _proto.computeRefetchInterval = function computeRefetchInterval() {
    var _this$options$refetch;

    return typeof this.options.refetchInterval === 'function' ? this.options.refetchInterval(this.currentResult.data, this.currentQuery) : (_this$options$refetch = this.options.refetchInterval) != null ? _this$options$refetch : false;
  };

  _proto.updateRefetchInterval = function updateRefetchInterval(nextInterval) {
    var _this7 = this;

    this.clearRefetchInterval();
    this.currentRefetchInterval = nextInterval;

    if (utils/* isServer */.sk || this.options.enabled === false || !(0,utils/* isValidTimeout */.PN)(this.currentRefetchInterval) || this.currentRefetchInterval === 0) {
      return;
    }

    this.refetchIntervalId = setInterval(function () {
      if (_this7.options.refetchIntervalInBackground || focusManager/* focusManager.isFocused */.j.isFocused()) {
        _this7.executeFetch();
      }
    }, this.currentRefetchInterval);
  };

  _proto.updateTimers = function updateTimers() {
    this.updateStaleTimeout();
    this.updateRefetchInterval(this.computeRefetchInterval());
  };

  _proto.clearTimers = function clearTimers() {
    this.clearStaleTimeout();
    this.clearRefetchInterval();
  };

  _proto.clearStaleTimeout = function clearStaleTimeout() {
    clearTimeout(this.staleTimeoutId);
    this.staleTimeoutId = undefined;
  };

  _proto.clearRefetchInterval = function clearRefetchInterval() {
    clearInterval(this.refetchIntervalId);
    this.refetchIntervalId = undefined;
  };

  _proto.createResult = function createResult(query, options) {
    var prevQuery = this.currentQuery;
    var prevOptions = this.options;
    var prevResult = this.currentResult;
    var prevResultState = this.currentResultState;
    var prevResultOptions = this.currentResultOptions;
    var queryChange = query !== prevQuery;
    var queryInitialState = queryChange ? query.state : this.currentQueryInitialState;
    var prevQueryResult = queryChange ? this.currentResult : this.previousQueryResult;
    var state = query.state;
    var dataUpdatedAt = state.dataUpdatedAt,
        error = state.error,
        errorUpdatedAt = state.errorUpdatedAt,
        isFetching = state.isFetching,
        status = state.status;
    var isPreviousData = false;
    var isPlaceholderData = false;
    var data; // Optimistically set result in fetching state if needed

    if (options.optimisticResults) {
      var mounted = this.hasListeners();
      var fetchOnMount = !mounted && shouldFetchOnMount(query, options);
      var fetchOptionally = mounted && shouldFetchOptionally(query, prevQuery, options, prevOptions);

      if (fetchOnMount || fetchOptionally) {
        isFetching = true;

        if (!dataUpdatedAt) {
          status = 'loading';
        }
      }
    } // Keep previous data if needed


    if (options.keepPreviousData && !state.dataUpdateCount && (prevQueryResult == null ? void 0 : prevQueryResult.isSuccess) && status !== 'error') {
      data = prevQueryResult.data;
      dataUpdatedAt = prevQueryResult.dataUpdatedAt;
      status = prevQueryResult.status;
      isPreviousData = true;
    } // Select data if needed
    else if (options.select && typeof state.data !== 'undefined') {
        // Memoize select result
        if (prevResult && state.data === (prevResultState == null ? void 0 : prevResultState.data) && options.select === this.selectFn) {
          data = this.selectResult;
        } else {
          try {
            this.selectFn = options.select;
            data = options.select(state.data);

            if (options.structuralSharing !== false) {
              data = (0,utils/* replaceEqualDeep */.Q$)(prevResult == null ? void 0 : prevResult.data, data);
            }

            this.selectResult = data;
            this.selectError = null;
          } catch (selectError) {
            (0,logger/* getLogger */.j)().error(selectError);
            this.selectError = selectError;
          }
        }
      } // Use query data
      else {
          data = state.data;
        } // Show placeholder data if needed


    if (typeof options.placeholderData !== 'undefined' && typeof data === 'undefined' && (status === 'loading' || status === 'idle')) {
      var placeholderData; // Memoize placeholder data

      if ((prevResult == null ? void 0 : prevResult.isPlaceholderData) && options.placeholderData === (prevResultOptions == null ? void 0 : prevResultOptions.placeholderData)) {
        placeholderData = prevResult.data;
      } else {
        placeholderData = typeof options.placeholderData === 'function' ? options.placeholderData() : options.placeholderData;

        if (options.select && typeof placeholderData !== 'undefined') {
          try {
            placeholderData = options.select(placeholderData);

            if (options.structuralSharing !== false) {
              placeholderData = (0,utils/* replaceEqualDeep */.Q$)(prevResult == null ? void 0 : prevResult.data, placeholderData);
            }

            this.selectError = null;
          } catch (selectError) {
            (0,logger/* getLogger */.j)().error(selectError);
            this.selectError = selectError;
          }
        }
      }

      if (typeof placeholderData !== 'undefined') {
        status = 'success';
        data = placeholderData;
        isPlaceholderData = true;
      }
    }

    if (this.selectError) {
      error = this.selectError;
      data = this.selectResult;
      errorUpdatedAt = Date.now();
      status = 'error';
    }

    var result = {
      status: status,
      isLoading: status === 'loading',
      isSuccess: status === 'success',
      isError: status === 'error',
      isIdle: status === 'idle',
      data: data,
      dataUpdatedAt: dataUpdatedAt,
      error: error,
      errorUpdatedAt: errorUpdatedAt,
      failureCount: state.fetchFailureCount,
      errorUpdateCount: state.errorUpdateCount,
      isFetched: state.dataUpdateCount > 0 || state.errorUpdateCount > 0,
      isFetchedAfterMount: state.dataUpdateCount > queryInitialState.dataUpdateCount || state.errorUpdateCount > queryInitialState.errorUpdateCount,
      isFetching: isFetching,
      isRefetching: isFetching && status !== 'loading',
      isLoadingError: status === 'error' && state.dataUpdatedAt === 0,
      isPlaceholderData: isPlaceholderData,
      isPreviousData: isPreviousData,
      isRefetchError: status === 'error' && state.dataUpdatedAt !== 0,
      isStale: isStale(query, options),
      refetch: this.refetch,
      remove: this.remove
    };
    return result;
  };

  _proto.shouldNotifyListeners = function shouldNotifyListeners(result, prevResult) {
    if (!prevResult) {
      return true;
    }

    var _this$options = this.options,
        notifyOnChangeProps = _this$options.notifyOnChangeProps,
        notifyOnChangePropsExclusions = _this$options.notifyOnChangePropsExclusions;

    if (!notifyOnChangeProps && !notifyOnChangePropsExclusions) {
      return true;
    }

    if (notifyOnChangeProps === 'tracked' && !this.trackedProps.length) {
      return true;
    }

    var includedProps = notifyOnChangeProps === 'tracked' ? this.trackedProps : notifyOnChangeProps;
    return Object.keys(result).some(function (key) {
      var typedKey = key;
      var changed = result[typedKey] !== prevResult[typedKey];
      var isIncluded = includedProps == null ? void 0 : includedProps.some(function (x) {
        return x === key;
      });
      var isExcluded = notifyOnChangePropsExclusions == null ? void 0 : notifyOnChangePropsExclusions.some(function (x) {
        return x === key;
      });
      return changed && !isExcluded && (!includedProps || isIncluded);
    });
  };

  _proto.updateResult = function updateResult(notifyOptions) {
    var prevResult = this.currentResult;
    this.currentResult = this.createResult(this.currentQuery, this.options);
    this.currentResultState = this.currentQuery.state;
    this.currentResultOptions = this.options; // Only notify if something has changed

    if ((0,utils/* shallowEqualObjects */.VS)(this.currentResult, prevResult)) {
      return;
    } // Determine which callbacks to trigger


    var defaultNotifyOptions = {
      cache: true
    };

    if ((notifyOptions == null ? void 0 : notifyOptions.listeners) !== false && this.shouldNotifyListeners(this.currentResult, prevResult)) {
      defaultNotifyOptions.listeners = true;
    }

    this.notify((0,esm_extends/* default */.Z)({}, defaultNotifyOptions, notifyOptions));
  };

  _proto.updateQuery = function updateQuery() {
    var query = this.client.getQueryCache().build(this.client, this.options);

    if (query === this.currentQuery) {
      return;
    }

    var prevQuery = this.currentQuery;
    this.currentQuery = query;
    this.currentQueryInitialState = query.state;
    this.previousQueryResult = this.currentResult;

    if (this.hasListeners()) {
      prevQuery == null ? void 0 : prevQuery.removeObserver(this);
      query.addObserver(this);
    }
  };

  _proto.onQueryUpdate = function onQueryUpdate(action) {
    var notifyOptions = {};

    if (action.type === 'success') {
      notifyOptions.onSuccess = true;
    } else if (action.type === 'error' && !(0,retryer/* isCancelledError */.DV)(action.error)) {
      notifyOptions.onError = true;
    }

    this.updateResult(notifyOptions);

    if (this.hasListeners()) {
      this.updateTimers();
    }
  };

  _proto.notify = function notify(notifyOptions) {
    var _this8 = this;

    notifyManager/* notifyManager.batch */.V.batch(function () {
      // First trigger the configuration callbacks
      if (notifyOptions.onSuccess) {
        _this8.options.onSuccess == null ? void 0 : _this8.options.onSuccess(_this8.currentResult.data);
        _this8.options.onSettled == null ? void 0 : _this8.options.onSettled(_this8.currentResult.data, null);
      } else if (notifyOptions.onError) {
        _this8.options.onError == null ? void 0 : _this8.options.onError(_this8.currentResult.error);
        _this8.options.onSettled == null ? void 0 : _this8.options.onSettled(undefined, _this8.currentResult.error);
      } // Then trigger the listeners


      if (notifyOptions.listeners) {
        _this8.listeners.forEach(function (listener) {
          listener(_this8.currentResult);
        });
      } // Then the cache listeners


      if (notifyOptions.cache) {
        _this8.client.getQueryCache().notify({
          query: _this8.currentQuery,
          type: 'observerResultsUpdated'
        });
      }
    });
  };

  return QueryObserver;
}(subscribable/* Subscribable */.l);

function shouldLoadOnMount(query, options) {
  return options.enabled !== false && !query.state.dataUpdatedAt && !(query.state.status === 'error' && options.retryOnMount === false);
}

function shouldFetchOnMount(query, options) {
  return shouldLoadOnMount(query, options) || query.state.dataUpdatedAt > 0 && shouldFetchOn(query, options, options.refetchOnMount);
}

function shouldFetchOn(query, options, field) {
  if (options.enabled !== false) {
    var value = typeof field === 'function' ? field(query) : field;
    return value === 'always' || value !== false && isStale(query, options);
  }

  return false;
}

function shouldFetchOptionally(query, prevQuery, options, prevOptions) {
  return options.enabled !== false && (query !== prevQuery || prevOptions.enabled === false) && (!options.suspense || query.state.status !== 'error') && isStale(query, options);
}

function isStale(query, options) {
  return query.isStaleByTime(options.staleTime);
}
;// CONCATENATED MODULE: ../../.yarn/__virtual__/react-query-virtual-9ac5b1aaa1/0/cache/react-query-npm-3.39.1-7899b170b9-9273b7c2ad.zip/node_modules/react-query/es/react/QueryErrorResetBoundary.js
 // CONTEXT

function createValue() {
  var _isReset = false;
  return {
    clearReset: function clearReset() {
      _isReset = false;
    },
    reset: function reset() {
      _isReset = true;
    },
    isReset: function isReset() {
      return _isReset;
    }
  };
}

var QueryErrorResetBoundaryContext = /*#__PURE__*/react.createContext(createValue()); // HOOK

var useQueryErrorResetBoundary = function useQueryErrorResetBoundary() {
  return react.useContext(QueryErrorResetBoundaryContext);
}; // COMPONENT

var QueryErrorResetBoundary = function QueryErrorResetBoundary(_ref) {
  var children = _ref.children;
  var value = React.useMemo(function () {
    return createValue();
  }, []);
  return /*#__PURE__*/React.createElement(QueryErrorResetBoundaryContext.Provider, {
    value: value
  }, typeof children === 'function' ? children(value) : children);
};
;// CONCATENATED MODULE: ../../.yarn/__virtual__/react-query-virtual-9ac5b1aaa1/0/cache/react-query-npm-3.39.1-7899b170b9-9273b7c2ad.zip/node_modules/react-query/es/react/useBaseQuery.js





function useBaseQuery(options, Observer) {
  var mountedRef = react.useRef(false);

  var _React$useState = react.useState(0),
      forceUpdate = _React$useState[1];

  var queryClient = useQueryClient();
  var errorResetBoundary = useQueryErrorResetBoundary();
  var defaultedOptions = queryClient.defaultQueryObserverOptions(options); // Make sure results are optimistically set in fetching state before subscribing or updating options

  defaultedOptions.optimisticResults = true; // Include callbacks in batch renders

  if (defaultedOptions.onError) {
    defaultedOptions.onError = notifyManager/* notifyManager.batchCalls */.V.batchCalls(defaultedOptions.onError);
  }

  if (defaultedOptions.onSuccess) {
    defaultedOptions.onSuccess = notifyManager/* notifyManager.batchCalls */.V.batchCalls(defaultedOptions.onSuccess);
  }

  if (defaultedOptions.onSettled) {
    defaultedOptions.onSettled = notifyManager/* notifyManager.batchCalls */.V.batchCalls(defaultedOptions.onSettled);
  }

  if (defaultedOptions.suspense) {
    // Always set stale time when using suspense to prevent
    // fetching again when directly mounting after suspending
    if (typeof defaultedOptions.staleTime !== 'number') {
      defaultedOptions.staleTime = 1000;
    } // Set cache time to 1 if the option has been set to 0
    // when using suspense to prevent infinite loop of fetches


    if (defaultedOptions.cacheTime === 0) {
      defaultedOptions.cacheTime = 1;
    }
  }

  if (defaultedOptions.suspense || defaultedOptions.useErrorBoundary) {
    // Prevent retrying failed query if the error boundary has not been reset yet
    if (!errorResetBoundary.isReset()) {
      defaultedOptions.retryOnMount = false;
    }
  }

  var _React$useState2 = react.useState(function () {
    return new Observer(queryClient, defaultedOptions);
  }),
      observer = _React$useState2[0];

  var result = observer.getOptimisticResult(defaultedOptions);
  react.useEffect(function () {
    mountedRef.current = true;
    errorResetBoundary.clearReset();
    var unsubscribe = observer.subscribe(notifyManager/* notifyManager.batchCalls */.V.batchCalls(function () {
      if (mountedRef.current) {
        forceUpdate(function (x) {
          return x + 1;
        });
      }
    })); // Update result to make sure we did not miss any query updates
    // between creating the observer and subscribing to it.

    observer.updateResult();
    return function () {
      mountedRef.current = false;
      unsubscribe();
    };
  }, [errorResetBoundary, observer]);
  react.useEffect(function () {
    // Do not notify on updates because of changes in the options because
    // these changes should already be reflected in the optimistic result.
    observer.setOptions(defaultedOptions, {
      listeners: false
    });
  }, [defaultedOptions, observer]); // Handle suspense

  if (defaultedOptions.suspense && result.isLoading) {
    throw observer.fetchOptimistic(defaultedOptions).then(function (_ref) {
      var data = _ref.data;
      defaultedOptions.onSuccess == null ? void 0 : defaultedOptions.onSuccess(data);
      defaultedOptions.onSettled == null ? void 0 : defaultedOptions.onSettled(data, null);
    }).catch(function (error) {
      errorResetBoundary.clearReset();
      defaultedOptions.onError == null ? void 0 : defaultedOptions.onError(error);
      defaultedOptions.onSettled == null ? void 0 : defaultedOptions.onSettled(undefined, error);
    });
  } // Handle error boundary


  if (result.isError && !errorResetBoundary.isReset() && !result.isFetching && shouldThrowError(defaultedOptions.suspense, defaultedOptions.useErrorBoundary, [result.error, observer.getCurrentQuery()])) {
    throw result.error;
  } // Handle result property usage tracking


  if (defaultedOptions.notifyOnChangeProps === 'tracked') {
    result = observer.trackResult(result, defaultedOptions);
  }

  return result;
}
;// CONCATENATED MODULE: ../../.yarn/__virtual__/react-query-virtual-9ac5b1aaa1/0/cache/react-query-npm-3.39.1-7899b170b9-9273b7c2ad.zip/node_modules/react-query/es/react/useQuery.js


 // HOOK

function useQuery(arg1, arg2, arg3) {
  var parsedOptions = (0,utils/* parseQueryArgs */._v)(arg1, arg2, arg3);
  return useBaseQuery(parsedOptions, QueryObserver);
}
// EXTERNAL MODULE: ../../.yarn/__virtual__/react-query-virtual-9ac5b1aaa1/0/cache/react-query-npm-3.39.1-7899b170b9-9273b7c2ad.zip/node_modules/react-query/es/core/infiniteQueryBehavior.js
var infiniteQueryBehavior = __webpack_require__(78831);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/react-query-virtual-9ac5b1aaa1/0/cache/react-query-npm-3.39.1-7899b170b9-9273b7c2ad.zip/node_modules/react-query/es/core/infiniteQueryObserver.js




var InfiniteQueryObserver = /*#__PURE__*/function (_QueryObserver) {
  (0,inheritsLoose/* default */.Z)(InfiniteQueryObserver, _QueryObserver);

  // Type override
  // Type override
  // Type override
  // eslint-disable-next-line @typescript-eslint/no-useless-constructor
  function InfiniteQueryObserver(client, options) {
    return _QueryObserver.call(this, client, options) || this;
  }

  var _proto = InfiniteQueryObserver.prototype;

  _proto.bindMethods = function bindMethods() {
    _QueryObserver.prototype.bindMethods.call(this);

    this.fetchNextPage = this.fetchNextPage.bind(this);
    this.fetchPreviousPage = this.fetchPreviousPage.bind(this);
  };

  _proto.setOptions = function setOptions(options, notifyOptions) {
    _QueryObserver.prototype.setOptions.call(this, (0,esm_extends/* default */.Z)({}, options, {
      behavior: (0,infiniteQueryBehavior/* infiniteQueryBehavior */.Gm)()
    }), notifyOptions);
  };

  _proto.getOptimisticResult = function getOptimisticResult(options) {
    options.behavior = (0,infiniteQueryBehavior/* infiniteQueryBehavior */.Gm)();
    return _QueryObserver.prototype.getOptimisticResult.call(this, options);
  };

  _proto.fetchNextPage = function fetchNextPage(options) {
    var _options$cancelRefetc;

    return this.fetch({
      // TODO consider removing `?? true` in future breaking change, to be consistent with `refetch` API (see https://github.com/tannerlinsley/react-query/issues/2617)
      cancelRefetch: (_options$cancelRefetc = options == null ? void 0 : options.cancelRefetch) != null ? _options$cancelRefetc : true,
      throwOnError: options == null ? void 0 : options.throwOnError,
      meta: {
        fetchMore: {
          direction: 'forward',
          pageParam: options == null ? void 0 : options.pageParam
        }
      }
    });
  };

  _proto.fetchPreviousPage = function fetchPreviousPage(options) {
    var _options$cancelRefetc2;

    return this.fetch({
      // TODO consider removing `?? true` in future breaking change, to be consistent with `refetch` API (see https://github.com/tannerlinsley/react-query/issues/2617)
      cancelRefetch: (_options$cancelRefetc2 = options == null ? void 0 : options.cancelRefetch) != null ? _options$cancelRefetc2 : true,
      throwOnError: options == null ? void 0 : options.throwOnError,
      meta: {
        fetchMore: {
          direction: 'backward',
          pageParam: options == null ? void 0 : options.pageParam
        }
      }
    });
  };

  _proto.createResult = function createResult(query, options) {
    var _state$data, _state$data2, _state$fetchMeta, _state$fetchMeta$fetc, _state$fetchMeta2, _state$fetchMeta2$fet;

    var state = query.state;

    var result = _QueryObserver.prototype.createResult.call(this, query, options);

    return (0,esm_extends/* default */.Z)({}, result, {
      fetchNextPage: this.fetchNextPage,
      fetchPreviousPage: this.fetchPreviousPage,
      hasNextPage: (0,infiniteQueryBehavior/* hasNextPage */.Qy)(options, (_state$data = state.data) == null ? void 0 : _state$data.pages),
      hasPreviousPage: (0,infiniteQueryBehavior/* hasPreviousPage */.ZF)(options, (_state$data2 = state.data) == null ? void 0 : _state$data2.pages),
      isFetchingNextPage: state.isFetching && ((_state$fetchMeta = state.fetchMeta) == null ? void 0 : (_state$fetchMeta$fetc = _state$fetchMeta.fetchMore) == null ? void 0 : _state$fetchMeta$fetc.direction) === 'forward',
      isFetchingPreviousPage: state.isFetching && ((_state$fetchMeta2 = state.fetchMeta) == null ? void 0 : (_state$fetchMeta2$fet = _state$fetchMeta2.fetchMore) == null ? void 0 : _state$fetchMeta2$fet.direction) === 'backward'
    });
  };

  return InfiniteQueryObserver;
}(QueryObserver);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/react-query-virtual-9ac5b1aaa1/0/cache/react-query-npm-3.39.1-7899b170b9-9273b7c2ad.zip/node_modules/react-query/es/react/useInfiniteQuery.js


 // HOOK

function useInfiniteQuery(arg1, arg2, arg3) {
  var options = (0,utils/* parseQueryArgs */._v)(arg1, arg2, arg3);
  return useBaseQuery(options, InfiniteQueryObserver);
}
// EXTERNAL MODULE: ../../.yarn/__virtual__/react-query-virtual-9ac5b1aaa1/0/cache/react-query-npm-3.39.1-7899b170b9-9273b7c2ad.zip/node_modules/react-query/es/core/hydration.js
var hydration = __webpack_require__(71177);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/react-query-virtual-9ac5b1aaa1/0/cache/react-query-npm-3.39.1-7899b170b9-9273b7c2ad.zip/node_modules/react-query/es/react/Hydrate.js



function useHydrate(state, options) {
  var queryClient = useQueryClient();
  var optionsRef = react.useRef(options);
  optionsRef.current = options; // Running hydrate again with the same queries is safe,
  // it wont overwrite or initialize existing queries,
  // relying on useMemo here is only a performance optimization.
  // hydrate can and should be run *during* render here for SSR to work properly

  react.useMemo(function () {
    if (state) {
      (0,hydration/* hydrate */.Z)(queryClient, state, optionsRef.current);
    }
  }, [queryClient, state]);
}
var Hydrate = function Hydrate(_ref) {
  var children = _ref.children,
      options = _ref.options,
      state = _ref.state;
  useHydrate(state, options);
  return children;
};
;// CONCATENATED MODULE: ../../.yarn/__virtual__/react-query-virtual-9ac5b1aaa1/0/cache/react-query-npm-3.39.1-7899b170b9-9273b7c2ad.zip/node_modules/react-query/es/react/index.js
// Side effects










 // Types



/***/ }),

/***/ 19633:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91987);

var useEffectOnce = function (effect) {
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(effect, []);
};
/* harmony default export */ __webpack_exports__["Z"] = (useEffectOnce);


/***/ }),

/***/ 78159:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ esm_useThrottle; }
});

// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(91987);
// EXTERNAL MODULE: ../../.yarn/__virtual__/react-use-virtual-6cd4a83c3e/0/cache/react-use-npm-17.4.0-0ef4521544-0889da919b.zip/node_modules/react-use/esm/useEffectOnce.js
var useEffectOnce = __webpack_require__(19633);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/react-use-virtual-6cd4a83c3e/0/cache/react-use-npm-17.4.0-0ef4521544-0889da919b.zip/node_modules/react-use/esm/useUnmount.js


var useUnmount = function (fn) {
    var fnRef = (0,react.useRef)(fn);
    // update the ref each render so if it change the newest callback will be invoked
    fnRef.current = fn;
    (0,useEffectOnce/* default */.Z)(function () { return function () { return fnRef.current(); }; });
};
/* harmony default export */ var esm_useUnmount = (useUnmount);

;// CONCATENATED MODULE: ../../.yarn/__virtual__/react-use-virtual-6cd4a83c3e/0/cache/react-use-npm-17.4.0-0ef4521544-0889da919b.zip/node_modules/react-use/esm/useThrottle.js


var useThrottle = function (value, ms) {
    if (ms === void 0) { ms = 200; }
    var _a = (0,react.useState)(value), state = _a[0], setState = _a[1];
    var timeout = (0,react.useRef)();
    var nextValue = (0,react.useRef)(null);
    var hasNextValue = (0,react.useRef)(0);
    (0,react.useEffect)(function () {
        if (!timeout.current) {
            setState(value);
            var timeoutCallback_1 = function () {
                if (hasNextValue.current) {
                    hasNextValue.current = false;
                    setState(nextValue.current);
                    timeout.current = setTimeout(timeoutCallback_1, ms);
                }
                else {
                    timeout.current = undefined;
                }
            };
            timeout.current = setTimeout(timeoutCallback_1, ms);
        }
        else {
            nextValue.current = value;
            hasNextValue.current = true;
        }
    }, [value]);
    esm_useUnmount(function () {
        timeout.current && clearTimeout(timeout.current);
    });
    return state;
};
/* harmony default export */ var esm_useThrottle = (useThrottle);


/***/ }),

/***/ 30822:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;
/* provided dependency */ var process = __webpack_require__(97441);


__webpack_unused_export__ = ({ value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var react = _interopDefault(__webpack_require__(91987));
var reactDom = _interopDefault(__webpack_require__(13137));

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */

function err(message) {
  const error = new Error(message); // In V8, Error objects keep the closure scope chain alive until the
  // err.stack property is accessed.

  if (error.stack === undefined) {
    // IE sets the stack only if error is thrown
    try {
      throw error;
    } catch (_) {} // eslint-disable-line fb-www/no-unused-catch-bindings, no-empty

  }

  return error;
}

var err_1 = err;

// @oss-only


var Recoil_err = err_1;

/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */

// Split declaration and implementation to allow this function to pretend to
// check for actual instance of Promise instead of something with a `then`
// method.
// eslint-disable-next-line no-redeclare
function isPromise(p) {
  return !!p && typeof p.then === 'function';
}

var Recoil_isPromise = isPromise;

function nullthrows(x, message) {
  if (x != null) {
    return x;
  }

  throw Recoil_err(message !== null && message !== void 0 ? message : 'Got unexpected null or undefined');
}

var Recoil_nullthrows = nullthrows;

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

class BaseLoadable {
  getValue() {
    throw Recoil_err('BaseLoadable');
  }

  toPromise() {
    throw Recoil_err('BaseLoadable');
  }

  valueMaybe() {
    throw Recoil_err('BaseLoadable');
  }

  valueOrThrow() {
    // $FlowFixMe[prop-missing]
    throw Recoil_err(`Loadable expected value, but in "${this.state}" state`);
  }

  promiseMaybe() {
    throw Recoil_err('BaseLoadable');
  }

  promiseOrThrow() {
    // $FlowFixMe[prop-missing]
    throw Recoil_err(`Loadable expected promise, but in "${this.state}" state`);
  }

  errorMaybe() {
    throw Recoil_err('BaseLoadable');
  }

  errorOrThrow() {
    // $FlowFixMe[prop-missing]
    throw Recoil_err(`Loadable expected error, but in "${this.state}" state`);
  }

  is(other) {
    // $FlowFixMe[prop-missing]
    return other.state === this.state && other.contents === this.contents;
  }

  map(_map) {
    throw Recoil_err('BaseLoadable');
  }

}

class ValueLoadable extends BaseLoadable {
  constructor(value) {
    super();

    _defineProperty(this, "state", 'hasValue');

    _defineProperty(this, "contents", void 0);

    this.contents = value;
  }

  getValue() {
    return this.contents;
  }

  toPromise() {
    return Promise.resolve(this.contents);
  }

  valueMaybe() {
    return this.contents;
  }

  valueOrThrow() {
    return this.contents;
  }

  promiseMaybe() {
    return undefined;
  }

  errorMaybe() {
    return undefined;
  }

  map(map) {
    try {
      const next = map(this.contents);
      return Recoil_isPromise(next) ? loadableWithPromise(next) : isLoadable(next) ? next : loadableWithValue(next);
    } catch (e) {
      return Recoil_isPromise(e) ? // If we "suspended", then try again.
      // errors and subsequent retries will be handled in 'loading' case
      // $FlowFixMe[prop-missing]
      loadableWithPromise(e.next(() => this.map(map))) : loadableWithError(e);
    }
  }

}

class ErrorLoadable extends BaseLoadable {
  constructor(error) {
    super();

    _defineProperty(this, "state", 'hasError');

    _defineProperty(this, "contents", void 0);

    this.contents = error;
  }

  getValue() {
    throw this.contents;
  }

  toPromise() {
    return Promise.reject(this.contents);
  }

  valueMaybe() {
    return undefined;
  }

  promiseMaybe() {
    return undefined;
  }

  errorMaybe() {
    return this.contents;
  }

  errorOrThrow() {
    return this.contents;
  }

  map(_map) {
    // $FlowIssue[incompatible-return]
    return this;
  }

}

class LoadingLoadable extends BaseLoadable {
  constructor(promise) {
    super();

    _defineProperty(this, "state", 'loading');

    _defineProperty(this, "contents", void 0);

    this.contents = promise;
  }

  getValue() {
    throw this.contents;
  }

  toPromise() {
    return this.contents;
  }

  valueMaybe() {
    return undefined;
  }

  promiseMaybe() {
    return this.contents;
  }

  promiseOrThrow() {
    return this.contents;
  }

  errorMaybe() {
    return undefined;
  }

  map(map) {
    return loadableWithPromise(this.contents.then(value => {
      const next = map(value);

      if (isLoadable(next)) {
        const nextLoadable = next;

        switch (nextLoadable.state) {
          case 'hasValue':
            return nextLoadable.contents;

          case 'hasError':
            throw nextLoadable.contents;

          case 'loading':
            return nextLoadable.contents;
        }
      } // $FlowIssue[incompatible-return]


      return next;
    }).catch(e => {
      if (Recoil_isPromise(e)) {
        // we were "suspended," try again
        return e.then(() => this.map(map).contents);
      }

      throw e;
    }));
  }

}

function loadableWithValue(value) {
  return Object.freeze(new ValueLoadable(value));
}

function loadableWithError(error) {
  return Object.freeze(new ErrorLoadable(error));
}

function loadableWithPromise(promise) {
  return Object.freeze(new LoadingLoadable(promise));
}

function loadableLoading() {
  return Object.freeze(new LoadingLoadable(new Promise(() => {})));
}

function loadableAllArray(inputs) {
  return inputs.every(i => i.state === 'hasValue') ? loadableWithValue(inputs.map(i => i.contents)) : inputs.some(i => i.state === 'hasError') ? loadableWithError(Recoil_nullthrows(inputs.find(i => i.state === 'hasError'), 'Invalid loadable passed to loadableAll').contents) : loadableWithPromise(Promise.all(inputs.map(i => i.contents)));
}

function loadableAll(inputs) {
  const unwrapedInputs = Array.isArray(inputs) ? inputs : Object.getOwnPropertyNames(inputs).map(key => inputs[key]);
  const normalizedInputs = unwrapedInputs.map(x => isLoadable(x) ? x : Recoil_isPromise(x) ? loadableWithPromise(x) : loadableWithValue(x));
  const output = loadableAllArray(normalizedInputs);
  return Array.isArray(inputs) ? // $FlowIssue[incompatible-return]
  output : // Object.getOwnPropertyNames() has consistent key ordering with ES6
  // $FlowIssue[incompatible-call]
  output.map(outputs => Object.getOwnPropertyNames(inputs).reduce((out, key, idx) => ({ ...out,
    [key]: outputs[idx]
  }), {}));
}

function isLoadable(x) {
  return x instanceof BaseLoadable;
}

const LoadableStaticInterface = {
  of: value => Recoil_isPromise(value) ? loadableWithPromise(value) : isLoadable(value) ? value : loadableWithValue(value),
  error: error => loadableWithError(error),
  // $FlowIssue[incompatible-return]
  loading: () => loadableLoading(),
  // $FlowIssue[unclear-type]
  all: loadableAll,
  isLoadable
};
var Recoil_Loadable = {
  loadableWithValue,
  loadableWithError,
  loadableWithPromise,
  loadableLoading,
  loadableAll,
  isLoadable,
  RecoilLoadable: LoadableStaticInterface
};

var Recoil_Loadable_1 = Recoil_Loadable.loadableWithValue;
var Recoil_Loadable_2 = Recoil_Loadable.loadableWithError;
var Recoil_Loadable_3 = Recoil_Loadable.loadableWithPromise;
var Recoil_Loadable_4 = Recoil_Loadable.loadableLoading;
var Recoil_Loadable_5 = Recoil_Loadable.loadableAll;
var Recoil_Loadable_6 = Recoil_Loadable.isLoadable;
var Recoil_Loadable_7 = Recoil_Loadable.RecoilLoadable;

var Recoil_Loadable$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  loadableWithValue: Recoil_Loadable_1,
  loadableWithError: Recoil_Loadable_2,
  loadableWithPromise: Recoil_Loadable_3,
  loadableLoading: Recoil_Loadable_4,
  loadableAll: Recoil_Loadable_5,
  isLoadable: Recoil_Loadable_6,
  RecoilLoadable: Recoil_Loadable_7
});

/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */

const gks = new Map().set('recoil_hamt_2020', true).set('recoil_sync_external_store', true).set('recoil_suppress_rerender_in_callback', true).set('recoil_memory_managament_2020', true);

function Recoil_gkx_OSS(gk) {
  var _gks$get;

  return (_gks$get = gks.get(gk)) !== null && _gks$get !== void 0 ? _gks$get : false;
}

Recoil_gkx_OSS.setPass = gk => {
  gks.set(gk, true);
};

Recoil_gkx_OSS.setFail = gk => {
  gks.set(gk, false);
};

Recoil_gkx_OSS.clear = () => {
  gks.clear();
};

var Recoil_gkx = Recoil_gkx_OSS; // @oss-only

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */

function recoverableViolation(message, _projectName, {
  error
} = {}) {
  if (false) {}

  return null;
}

var recoverableViolation_1 = recoverableViolation;

// @oss-only


var Recoil_recoverableViolation = recoverableViolation_1;

var _createMutableSource, _useMutableSource, _useSyncExternalStore;







const createMutableSource = // flowlint-next-line unclear-type:off
(_createMutableSource = react.createMutableSource) !== null && _createMutableSource !== void 0 ? _createMutableSource : react.unstable_createMutableSource;
const useMutableSource = // flowlint-next-line unclear-type:off
(_useMutableSource = react.useMutableSource) !== null && _useMutableSource !== void 0 ? _useMutableSource : react.unstable_useMutableSource; // https://github.com/reactwg/react-18/discussions/86

const useSyncExternalStore = // flowlint-next-line unclear-type:off
(_useSyncExternalStore = react.useSyncExternalStore) !== null && _useSyncExternalStore !== void 0 ? _useSyncExternalStore : // flowlint-next-line unclear-type:off
react.unstable_useSyncExternalStore;
let ReactRendererVersionMismatchWarnOnce = false; // Check if the current renderer supports `useSyncExternalStore()`.
// Since React goes through a proxy dispatcher and the current renderer can
// change we can't simply check if `React.useSyncExternalStore()` is defined.

function currentRendererSupportsUseSyncExternalStore() {
  var _ReactCurrentDispatch;

  // $FlowFixMe[incompatible-use]
  const {
    ReactCurrentDispatcher,
    ReactCurrentOwner
  } =
  /* $FlowFixMe[prop-missing] This workaround was approved as a safer mechanism
   * to detect if the current renderer supports useSyncExternalStore()
   * https://fb.workplace.com/groups/reactjs/posts/9558682330846963/ */
  react.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
  const dispatcher = (_ReactCurrentDispatch = ReactCurrentDispatcher === null || ReactCurrentDispatcher === void 0 ? void 0 : ReactCurrentDispatcher.current) !== null && _ReactCurrentDispatch !== void 0 ? _ReactCurrentDispatch : ReactCurrentOwner.currentDispatcher;
  const isUseSyncExternalStoreSupported = dispatcher.useSyncExternalStore != null;

  if (useSyncExternalStore && !isUseSyncExternalStoreSupported && !ReactRendererVersionMismatchWarnOnce) {
    ReactRendererVersionMismatchWarnOnce = true;
    Recoil_recoverableViolation('A React renderer without React 18+ API support is being used with React 18+.');
  }

  return isUseSyncExternalStoreSupported;
}

/**
 * mode: The React API and approach to use for syncing state with React
 * early: Re-renders from Recoil updates occur:
 *    1) earlier
 *    2) in sync with React updates in the same batch
 *    3) before transaction observers instead of after.
 * concurrent: Is the current mode compatible with Concurrent Mode and useTransition()
 */
function reactMode() {
  // NOTE: This mode is currently broken with some Suspense cases
  // see Recoil_selector-test.js
  if (Recoil_gkx('recoil_transition_support')) {
    return {
      mode: 'TRANSITION_SUPPORT',
      early: true,
      concurrent: true
    };
  }

  if (Recoil_gkx('recoil_sync_external_store') && useSyncExternalStore != null) {
    return {
      mode: 'SYNC_EXTERNAL_STORE',
      early: true,
      concurrent: false
    };
  }

  if (Recoil_gkx('recoil_mutable_source') && useMutableSource != null && typeof window !== 'undefined' && !window.$disableRecoilValueMutableSource_TEMP_HACK_DO_NOT_USE) {
    return Recoil_gkx('recoil_suppress_rerender_in_callback') ? {
      mode: 'MUTABLE_SOURCE',
      early: true,
      concurrent: true
    } : {
      mode: 'MUTABLE_SOURCE',
      early: false,
      concurrent: false
    };
  }

  return Recoil_gkx('recoil_suppress_rerender_in_callback') ? {
    mode: 'LEGACY',
    early: true,
    concurrent: false
  } : {
    mode: 'LEGACY',
    early: false,
    concurrent: false
  };
} // TODO Need to figure out if there is a standard/open-source equivalent to see if hot module replacement is happening:


function isFastRefreshEnabled() {
  // @fb-only: const {isAcceptingUpdate} = require('__debug');
  // @fb-only: return typeof isAcceptingUpdate === 'function' && isAcceptingUpdate();
  return false; // @oss-only
}

var Recoil_ReactMode = {
  createMutableSource,
  useMutableSource,
  useSyncExternalStore,
  currentRendererSupportsUseSyncExternalStore,
  reactMode,
  isFastRefreshEnabled
};

const env = {
  RECOIL_DUPLICATE_ATOM_KEY_CHECKING_ENABLED: true
};
/**
 * Allow NodeJS/NextJS/etc to set the initial state through process.env variable
 * Note:  we don't assume 'process' is available in all runtime environments
 *
 * @see https://github.com/facebookexperimental/Recoil/issues/733
 */

function applyProcessEnvFlagOverrides() {
  var _process, _process$env$RECOIL_D, _process$env$RECOIL_D2;

  // note: this check is needed in addition to the check below, runtime error will occur without it!
  // eslint-disable-next-line fb-www/typeof-undefined
  if (typeof process === 'undefined') {
    return;
  }

  if (((_process = process) === null || process === void 0 ? void 0 : process.env) == null) {
    return;
  }

  const sanitizedValue = (_process$env$RECOIL_D = process.env.RECOIL_DUPLICATE_ATOM_KEY_CHECKING_ENABLED) === null || _process$env$RECOIL_D === void 0 ? void 0 : (_process$env$RECOIL_D2 = _process$env$RECOIL_D.toLowerCase()) === null || _process$env$RECOIL_D2 === void 0 ? void 0 : _process$env$RECOIL_D2.trim();

  if (sanitizedValue == null || sanitizedValue === '') {
    return;
  }

  const allowedValues = ['true', 'false'];

  if (!allowedValues.includes(sanitizedValue)) {
    throw Recoil_err(`process.env.RECOIL_DUPLICATE_ATOM_KEY_CHECKING_ENABLED value must be 'true', 'false', or empty: ${sanitizedValue}`);
  }

  env.RECOIL_DUPLICATE_ATOM_KEY_CHECKING_ENABLED = sanitizedValue === 'true';
}

applyProcessEnvFlagOverrides();
var Recoil_RecoilEnv = env;

/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */

// eslint-disable-next-line no-unused-vars
class AbstractRecoilValue {
  constructor(newKey) {
    _defineProperty(this, "key", void 0);

    this.key = newKey;
  }

  toJSON() {
    return {
      key: this.key
    };
  }

}

class RecoilState extends AbstractRecoilValue {}

class RecoilValueReadOnly extends AbstractRecoilValue {}

function isRecoilValue(x) {
  return x instanceof RecoilState || x instanceof RecoilValueReadOnly;
}

var Recoil_RecoilValue = {
  AbstractRecoilValue,
  RecoilState,
  RecoilValueReadOnly,
  isRecoilValue
};

var Recoil_RecoilValue_1 = Recoil_RecoilValue.AbstractRecoilValue;
var Recoil_RecoilValue_2 = Recoil_RecoilValue.RecoilState;
var Recoil_RecoilValue_3 = Recoil_RecoilValue.RecoilValueReadOnly;
var Recoil_RecoilValue_4 = Recoil_RecoilValue.isRecoilValue;

var Recoil_RecoilValue$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  AbstractRecoilValue: Recoil_RecoilValue_1,
  RecoilState: Recoil_RecoilValue_2,
  RecoilValueReadOnly: Recoil_RecoilValue_3,
  isRecoilValue: Recoil_RecoilValue_4
});

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */

function sprintf(format, ...args) {
  let index = 0;
  return format.replace(/%s/g, () => String(args[index++]));
}

var sprintf_1 = (/* unused pure expression or super */ null && (sprintf));

function expectationViolation(format, ...args) {
  if (false) {}
}

var expectationViolation_1 = expectationViolation;

// @oss-only


var Recoil_expectationViolation = expectationViolation_1;

/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */
/**
 * Creates a new iterable whose output is generated by passing the input
 * iterable's values through the mapper function.
 */

function mapIterable(iterable, callback) {
  // Use generator to create iterable/iterator
  return function* () {
    let index = 0;

    for (const value of iterable) {
      yield callback(value, index++);
    }
  }();
}

var Recoil_mapIterable = mapIterable;

const {
  isFastRefreshEnabled: isFastRefreshEnabled$1
} = Recoil_ReactMode;















class DefaultValue {}

const DEFAULT_VALUE = new DefaultValue();
// flowlint-next-line unclear-type:off
const nodes = new Map(); // flowlint-next-line unclear-type:off

const recoilValues = new Map();
/* eslint-disable no-redeclare */

function recoilValuesForKeys(keys) {
  return Recoil_mapIterable(keys, key => Recoil_nullthrows(recoilValues.get(key)));
}

function checkForDuplicateAtomKey(key) {
  if (nodes.has(key)) {
    const message = `Duplicate atom key "${key}". This is a FATAL ERROR in
      production. But it is safe to ignore this warning if it occurred because of
      hot module replacement.`;

    if (false) {} else {
      // @fb-only: recoverableViolation(message, 'recoil');
      console.warn(message); // @oss-only
    }
  }
}

function registerNode(node) {
  if (Recoil_RecoilEnv.RECOIL_DUPLICATE_ATOM_KEY_CHECKING_ENABLED) {
    checkForDuplicateAtomKey(node.key);
  }

  nodes.set(node.key, node);
  const recoilValue = node.set == null ? new Recoil_RecoilValue$1.RecoilValueReadOnly(node.key) : new Recoil_RecoilValue$1.RecoilState(node.key);
  recoilValues.set(node.key, recoilValue);
  return recoilValue;
}
/* eslint-enable no-redeclare */


class NodeMissingError extends Error {} // flowlint-next-line unclear-type:off


function getNode(key) {
  const node = nodes.get(key);

  if (node == null) {
    throw new NodeMissingError(`Missing definition for RecoilValue: "${key}""`);
  }

  return node;
} // flowlint-next-line unclear-type:off


function getNodeMaybe(key) {
  return nodes.get(key);
}

const configDeletionHandlers = new Map();

function deleteNodeConfigIfPossible(key) {
  var _node$shouldDeleteCon;

  if (!Recoil_gkx('recoil_memory_managament_2020')) {
    return;
  }

  const node = nodes.get(key);

  if (node !== null && node !== void 0 && (_node$shouldDeleteCon = node.shouldDeleteConfigOnRelease) !== null && _node$shouldDeleteCon !== void 0 && _node$shouldDeleteCon.call(node)) {
    var _getConfigDeletionHan;

    nodes.delete(key);
    (_getConfigDeletionHan = getConfigDeletionHandler(key)) === null || _getConfigDeletionHan === void 0 ? void 0 : _getConfigDeletionHan();
    configDeletionHandlers.delete(key);
  }
}

function setConfigDeletionHandler(key, fn) {
  if (!Recoil_gkx('recoil_memory_managament_2020')) {
    return;
  }

  if (fn === undefined) {
    configDeletionHandlers.delete(key);
  } else {
    configDeletionHandlers.set(key, fn);
  }
}

function getConfigDeletionHandler(key) {
  return configDeletionHandlers.get(key);
}

var Recoil_Node = {
  nodes,
  recoilValues,
  registerNode,
  getNode,
  getNodeMaybe,
  deleteNodeConfigIfPossible,
  setConfigDeletionHandler,
  getConfigDeletionHandler,
  recoilValuesForKeys,
  NodeMissingError,
  DefaultValue,
  DEFAULT_VALUE
};

/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */

function enqueueExecution(s, f) {
  f();
}

var Recoil_Queue = {
  enqueueExecution
};

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var hamt_1 = createCommonjsModule(function (module) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
/**
    @fileOverview Hash Array Mapped Trie.

    Code based on: https://github.com/exclipy/pdata
*/


var hamt = {}; // export

/* Configuration
 ******************************************************************************/

var SIZE = 5;
var BUCKET_SIZE = Math.pow(2, SIZE);
var MASK = BUCKET_SIZE - 1;
var MAX_INDEX_NODE = BUCKET_SIZE / 2;
var MIN_ARRAY_NODE = BUCKET_SIZE / 4;
/*
 ******************************************************************************/

var nothing = {};

var constant = function constant(x) {
  return function () {
    return x;
  };
};
/**
    Get 32 bit hash of string.

    Based on:
    http://stackoverflow.com/questions/7616461/generate-a-hash-from-string-in-javascript-jquery
*/


var hash = hamt.hash = function (str) {
  var type = typeof str === 'undefined' ? 'undefined' : _typeof(str);
  if (type === 'number') return str;
  if (type !== 'string') str += '';
  var hash = 0;

  for (var i = 0, len = str.length; i < len; ++i) {
    var c = str.charCodeAt(i);
    hash = (hash << 5) - hash + c | 0;
  }

  return hash;
};
/* Bit Ops
 ******************************************************************************/

/**
    Hamming weight.

    Taken from: http://jsperf.com/hamming-weight
*/


var popcount = function popcount(x) {
  x -= x >> 1 & 0x55555555;
  x = (x & 0x33333333) + (x >> 2 & 0x33333333);
  x = x + (x >> 4) & 0x0f0f0f0f;
  x += x >> 8;
  x += x >> 16;
  return x & 0x7f;
};

var hashFragment = function hashFragment(shift, h) {
  return h >>> shift & MASK;
};

var toBitmap = function toBitmap(x) {
  return 1 << x;
};

var fromBitmap = function fromBitmap(bitmap, bit) {
  return popcount(bitmap & bit - 1);
};
/* Array Ops
 ******************************************************************************/

/**
    Set a value in an array.

    @param mutate Should the input array be mutated?
    @param at Index to change.
    @param v New value
    @param arr Array.
*/


var arrayUpdate = function arrayUpdate(mutate, at, v, arr) {
  var out = arr;

  if (!mutate) {
    var len = arr.length;
    out = new Array(len);

    for (var i = 0; i < len; ++i) {
      out[i] = arr[i];
    }
  }

  out[at] = v;
  return out;
};
/**
    Remove a value from an array.

    @param mutate Should the input array be mutated?
    @param at Index to remove.
    @param arr Array.
*/


var arraySpliceOut = function arraySpliceOut(mutate, at, arr) {
  var newLen = arr.length - 1;
  var i = 0;
  var g = 0;
  var out = arr;

  if (mutate) {
    i = g = at;
  } else {
    out = new Array(newLen);

    while (i < at) {
      out[g++] = arr[i++];
    }
  }

  ++i;

  while (i <= newLen) {
    out[g++] = arr[i++];
  }

  if (mutate) {
    out.length = newLen;
  }

  return out;
};
/**
    Insert a value into an array.

    @param mutate Should the input array be mutated?
    @param at Index to insert at.
    @param v Value to insert,
    @param arr Array.
*/


var arraySpliceIn = function arraySpliceIn(mutate, at, v, arr) {
  var len = arr.length;

  if (mutate) {
    var _i = len;

    while (_i >= at) {
      arr[_i--] = arr[_i];
    }

    arr[at] = v;
    return arr;
  }

  var i = 0,
      g = 0;
  var out = new Array(len + 1);

  while (i < at) {
    out[g++] = arr[i++];
  }

  out[at] = v;

  while (i < len) {
    out[++g] = arr[i++];
  }

  return out;
};
/* Node Structures
 ******************************************************************************/


var LEAF = 1;
var COLLISION = 2;
var INDEX = 3;
var ARRAY = 4;
/**
    Empty node.
*/

var empty = {
  __hamt_isEmpty: true
};

var isEmptyNode = function isEmptyNode(x) {
  return x === empty || x && x.__hamt_isEmpty;
};
/**
    Leaf holding a value.

    @member edit Edit of the node.
    @member hash Hash of key.
    @member key Key.
    @member value Value stored.
*/


var Leaf = function Leaf(edit, hash, key, value) {
  return {
    type: LEAF,
    edit: edit,
    hash: hash,
    key: key,
    value: value,
    _modify: Leaf__modify
  };
};
/**
    Leaf holding multiple values with the same hash but different keys.

    @member edit Edit of the node.
    @member hash Hash of key.
    @member children Array of collision children node.
*/


var Collision = function Collision(edit, hash, children) {
  return {
    type: COLLISION,
    edit: edit,
    hash: hash,
    children: children,
    _modify: Collision__modify
  };
};
/**
    Internal node with a sparse set of children.

    Uses a bitmap and array to pack children.

  @member edit Edit of the node.
    @member mask Bitmap that encode the positions of children in the array.
    @member children Array of child nodes.
*/


var IndexedNode = function IndexedNode(edit, mask, children) {
  return {
    type: INDEX,
    edit: edit,
    mask: mask,
    children: children,
    _modify: IndexedNode__modify
  };
};
/**
    Internal node with many children.

    @member edit Edit of the node.
    @member size Number of children.
    @member children Array of child nodes.
*/


var ArrayNode = function ArrayNode(edit, size, children) {
  return {
    type: ARRAY,
    edit: edit,
    size: size,
    children: children,
    _modify: ArrayNode__modify
  };
};
/**
    Is `node` a leaf node?
*/


var isLeaf = function isLeaf(node) {
  return node === empty || node.type === LEAF || node.type === COLLISION;
};
/* Internal node operations.
 ******************************************************************************/

/**
    Expand an indexed node into an array node.

  @param edit Current edit.
    @param frag Index of added child.
    @param child Added child.
    @param mask Index node mask before child added.
    @param subNodes Index node children before child added.
*/


var expand = function expand(edit, frag, child, bitmap, subNodes) {
  var arr = [];
  var bit = bitmap;
  var count = 0;

  for (var i = 0; bit; ++i) {
    if (bit & 1) arr[i] = subNodes[count++];
    bit >>>= 1;
  }

  arr[frag] = child;
  return ArrayNode(edit, count + 1, arr);
};
/**
    Collapse an array node into a indexed node.

  @param edit Current edit.
    @param count Number of elements in new array.
    @param removed Index of removed element.
    @param elements Array node children before remove.
*/


var pack = function pack(edit, count, removed, elements) {
  var children = new Array(count - 1);
  var g = 0;
  var bitmap = 0;

  for (var i = 0, len = elements.length; i < len; ++i) {
    if (i !== removed) {
      var elem = elements[i];

      if (elem && !isEmptyNode(elem)) {
        children[g++] = elem;
        bitmap |= 1 << i;
      }
    }
  }

  return IndexedNode(edit, bitmap, children);
};
/**
    Merge two leaf nodes.

    @param shift Current shift.
    @param h1 Node 1 hash.
    @param n1 Node 1.
    @param h2 Node 2 hash.
    @param n2 Node 2.
*/


var mergeLeaves = function mergeLeaves(edit, shift, h1, n1, h2, n2) {
  if (h1 === h2) return Collision(edit, h1, [n2, n1]);
  var subH1 = hashFragment(shift, h1);
  var subH2 = hashFragment(shift, h2);
  return IndexedNode(edit, toBitmap(subH1) | toBitmap(subH2), subH1 === subH2 ? [mergeLeaves(edit, shift + SIZE, h1, n1, h2, n2)] : subH1 < subH2 ? [n1, n2] : [n2, n1]);
};
/**
    Update an entry in a collision list.

    @param mutate Should mutation be used?
    @param edit Current edit.
    @param keyEq Key compare function.
    @param hash Hash of collision.
    @param list Collision list.
    @param f Update function.
    @param k Key to update.
    @param size Size ref.
*/


var updateCollisionList = function updateCollisionList(mutate, edit, keyEq, h, list, f, k, size) {
  var len = list.length;

  for (var i = 0; i < len; ++i) {
    var child = list[i];

    if (keyEq(k, child.key)) {
      var value = child.value;

      var _newValue = f(value);

      if (_newValue === value) return list;

      if (_newValue === nothing) {
        --size.value;
        return arraySpliceOut(mutate, i, list);
      }

      return arrayUpdate(mutate, i, Leaf(edit, h, k, _newValue), list);
    }
  }

  var newValue = f();
  if (newValue === nothing) return list;
  ++size.value;
  return arrayUpdate(mutate, len, Leaf(edit, h, k, newValue), list);
};

var canEditNode = function canEditNode(edit, node) {
  return edit === node.edit;
};
/* Editing
 ******************************************************************************/


var Leaf__modify = function Leaf__modify(edit, keyEq, shift, f, h, k, size) {
  if (keyEq(k, this.key)) {
    var _v = f(this.value);

    if (_v === this.value) return this;else if (_v === nothing) {
      --size.value;
      return empty;
    }

    if (canEditNode(edit, this)) {
      this.value = _v;
      return this;
    }

    return Leaf(edit, h, k, _v);
  }

  var v = f();
  if (v === nothing) return this;
  ++size.value;
  return mergeLeaves(edit, shift, this.hash, this, h, Leaf(edit, h, k, v));
};

var Collision__modify = function Collision__modify(edit, keyEq, shift, f, h, k, size) {
  if (h === this.hash) {
    var canEdit = canEditNode(edit, this);
    var list = updateCollisionList(canEdit, edit, keyEq, this.hash, this.children, f, k, size);
    if (list === this.children) return this;
    return list.length > 1 ? Collision(edit, this.hash, list) : list[0]; // collapse single element collision list
  }

  var v = f();
  if (v === nothing) return this;
  ++size.value;
  return mergeLeaves(edit, shift, this.hash, this, h, Leaf(edit, h, k, v));
};

var IndexedNode__modify = function IndexedNode__modify(edit, keyEq, shift, f, h, k, size) {
  var mask = this.mask;
  var children = this.children;
  var frag = hashFragment(shift, h);
  var bit = toBitmap(frag);
  var indx = fromBitmap(mask, bit);
  var exists = mask & bit;
  var current = exists ? children[indx] : empty;

  var child = current._modify(edit, keyEq, shift + SIZE, f, h, k, size);

  if (current === child) return this;
  var canEdit = canEditNode(edit, this);
  var bitmap = mask;
  var newChildren = void 0;

  if (exists && isEmptyNode(child)) {
    // remove
    bitmap &= ~bit;
    if (!bitmap) return empty;
    if (children.length <= 2 && isLeaf(children[indx ^ 1])) return children[indx ^ 1]; // collapse

    newChildren = arraySpliceOut(canEdit, indx, children);
  } else if (!exists && !isEmptyNode(child)) {
    // add
    if (children.length >= MAX_INDEX_NODE) return expand(edit, frag, child, mask, children);
    bitmap |= bit;
    newChildren = arraySpliceIn(canEdit, indx, child, children);
  } else {
    // modify
    newChildren = arrayUpdate(canEdit, indx, child, children);
  }

  if (canEdit) {
    this.mask = bitmap;
    this.children = newChildren;
    return this;
  }

  return IndexedNode(edit, bitmap, newChildren);
};

var ArrayNode__modify = function ArrayNode__modify(edit, keyEq, shift, f, h, k, size) {
  var count = this.size;
  var children = this.children;
  var frag = hashFragment(shift, h);
  var child = children[frag];

  var newChild = (child || empty)._modify(edit, keyEq, shift + SIZE, f, h, k, size);

  if (child === newChild) return this;
  var canEdit = canEditNode(edit, this);
  var newChildren = void 0;

  if (isEmptyNode(child) && !isEmptyNode(newChild)) {
    // add
    ++count;
    newChildren = arrayUpdate(canEdit, frag, newChild, children);
  } else if (!isEmptyNode(child) && isEmptyNode(newChild)) {
    // remove
    --count;
    if (count <= MIN_ARRAY_NODE) return pack(edit, count, frag, children);
    newChildren = arrayUpdate(canEdit, frag, empty, children);
  } else {
    // modify
    newChildren = arrayUpdate(canEdit, frag, newChild, children);
  }

  if (canEdit) {
    this.size = count;
    this.children = newChildren;
    return this;
  }

  return ArrayNode(edit, count, newChildren);
};

empty._modify = function (edit, keyEq, shift, f, h, k, size) {
  var v = f();
  if (v === nothing) return empty;
  ++size.value;
  return Leaf(edit, h, k, v);
};
/*
 ******************************************************************************/


function Map(editable, edit, config, root, size) {
  this._editable = editable;
  this._edit = edit;
  this._config = config;
  this._root = root;
  this._size = size;
}

Map.prototype.setTree = function (newRoot, newSize) {
  if (this._editable) {
    this._root = newRoot;
    this._size = newSize;
    return this;
  }

  return newRoot === this._root ? this : new Map(this._editable, this._edit, this._config, newRoot, newSize);
};
/* Queries
 ******************************************************************************/

/**
    Lookup the value for `key` in `map` using a custom `hash`.

    Returns the value or `alt` if none.
*/


var tryGetHash = hamt.tryGetHash = function (alt, hash, key, map) {
  var node = map._root;
  var shift = 0;
  var keyEq = map._config.keyEq;

  while (true) {
    switch (node.type) {
      case LEAF:
        {
          return keyEq(key, node.key) ? node.value : alt;
        }

      case COLLISION:
        {
          if (hash === node.hash) {
            var children = node.children;

            for (var i = 0, len = children.length; i < len; ++i) {
              var child = children[i];
              if (keyEq(key, child.key)) return child.value;
            }
          }

          return alt;
        }

      case INDEX:
        {
          var frag = hashFragment(shift, hash);
          var bit = toBitmap(frag);

          if (node.mask & bit) {
            node = node.children[fromBitmap(node.mask, bit)];
            shift += SIZE;
            break;
          }

          return alt;
        }

      case ARRAY:
        {
          node = node.children[hashFragment(shift, hash)];

          if (node) {
            shift += SIZE;
            break;
          }

          return alt;
        }

      default:
        return alt;
    }
  }
};

Map.prototype.tryGetHash = function (alt, hash, key) {
  return tryGetHash(alt, hash, key, this);
};
/**
    Lookup the value for `key` in `map` using internal hash function.

    @see `tryGetHash`
*/


var tryGet = hamt.tryGet = function (alt, key, map) {
  return tryGetHash(alt, map._config.hash(key), key, map);
};

Map.prototype.tryGet = function (alt, key) {
  return tryGet(alt, key, this);
};
/**
    Lookup the value for `key` in `map` using a custom `hash`.

    Returns the value or `undefined` if none.
*/


var getHash = hamt.getHash = function (hash, key, map) {
  return tryGetHash(undefined, hash, key, map);
};

Map.prototype.getHash = function (hash, key) {
  return getHash(hash, key, this);
};
/**
    Lookup the value for `key` in `map` using internal hash function.

    @see `get`
*/


var get = hamt.get = function (key, map) {
  return tryGetHash(undefined, map._config.hash(key), key, map);
};

Map.prototype.get = function (key, alt) {
  return tryGet(alt, key, this);
};
/**
    Does an entry exist for `key` in `map`? Uses custom `hash`.
*/


var hasHash = hamt.has = function (hash, key, map) {
  return tryGetHash(nothing, hash, key, map) !== nothing;
};

Map.prototype.hasHash = function (hash, key) {
  return hasHash(hash, key, this);
};
/**
    Does an entry exist for `key` in `map`? Uses internal hash function.
*/


var has = hamt.has = function (key, map) {
  return hasHash(map._config.hash(key), key, map);
};

Map.prototype.has = function (key) {
  return has(key, this);
};

var defKeyCompare = function defKeyCompare(x, y) {
  return x === y;
};
/**
    Create an empty map.

    @param config Configuration.
*/


hamt.make = function (config) {
  return new Map(0, 0, {
    keyEq: config && config.keyEq || defKeyCompare,
    hash: config && config.hash || hash
  }, empty, 0);
};
/**
    Empty map.
*/


hamt.empty = hamt.make();
/**
    Does `map` contain any elements?
*/

var isEmpty = hamt.isEmpty = function (map) {
  return map && !!isEmptyNode(map._root);
};

Map.prototype.isEmpty = function () {
  return isEmpty(this);
};
/* Updates
 ******************************************************************************/

/**
    Alter the value stored for `key` in `map` using function `f` using
    custom hash.

    `f` is invoked with the current value for `k` if it exists,
    or no arguments if no such value exists. `modify` will always either
    update or insert a value into the map.

    Returns a map with the modified value. Does not alter `map`.
*/


var modifyHash = hamt.modifyHash = function (f, hash, key, map) {
  var size = {
    value: map._size
  };

  var newRoot = map._root._modify(map._editable ? map._edit : NaN, map._config.keyEq, 0, f, hash, key, size);

  return map.setTree(newRoot, size.value);
};

Map.prototype.modifyHash = function (hash, key, f) {
  return modifyHash(f, hash, key, this);
};
/**
    Alter the value stored for `key` in `map` using function `f` using
    internal hash function.

    @see `modifyHash`
*/


var modify = hamt.modify = function (f, key, map) {
  return modifyHash(f, map._config.hash(key), key, map);
};

Map.prototype.modify = function (key, f) {
  return modify(f, key, this);
};
/**
    Store `value` for `key` in `map` using custom `hash`.

    Returns a map with the modified value. Does not alter `map`.
*/


var setHash = hamt.setHash = function (hash, key, value, map) {
  return modifyHash(constant(value), hash, key, map);
};

Map.prototype.setHash = function (hash, key, value) {
  return setHash(hash, key, value, this);
};
/**
    Store `value` for `key` in `map` using internal hash function.

    @see `setHash`
*/


var set = hamt.set = function (key, value, map) {
  return setHash(map._config.hash(key), key, value, map);
};

Map.prototype.set = function (key, value) {
  return set(key, value, this);
};
/**
    Remove the entry for `key` in `map`.

    Returns a map with the value removed. Does not alter `map`.
*/


var del = constant(nothing);

var removeHash = hamt.removeHash = function (hash, key, map) {
  return modifyHash(del, hash, key, map);
};

Map.prototype.removeHash = Map.prototype.deleteHash = function (hash, key) {
  return removeHash(hash, key, this);
};
/**
    Remove the entry for `key` in `map` using internal hash function.

    @see `removeHash`
*/


var remove = hamt.remove = function (key, map) {
  return removeHash(map._config.hash(key), key, map);
};

Map.prototype.remove = Map.prototype.delete = function (key) {
  return remove(key, this);
};
/* Mutation
 ******************************************************************************/

/**
    Mark `map` as mutable.
 */


var beginMutation = hamt.beginMutation = function (map) {
  return new Map(map._editable + 1, map._edit + 1, map._config, map._root, map._size);
};

Map.prototype.beginMutation = function () {
  return beginMutation(this);
};
/**
    Mark `map` as immutable.
 */


var endMutation = hamt.endMutation = function (map) {
  map._editable = map._editable && map._editable - 1;
  return map;
};

Map.prototype.endMutation = function () {
  return endMutation(this);
};
/**
    Mutate `map` within the context of `f`.
    @param f
    @param map HAMT
*/


var mutate = hamt.mutate = function (f, map) {
  var transient = beginMutation(map);
  f(transient);
  return endMutation(transient);
};

Map.prototype.mutate = function (f) {
  return mutate(f, this);
};
/* Traversal
 ******************************************************************************/

/**
    Apply a continuation.
*/


var appk = function appk(k) {
  return k && lazyVisitChildren(k[0], k[1], k[2], k[3], k[4]);
};
/**
    Recursively visit all values stored in an array of nodes lazily.
*/


var lazyVisitChildren = function lazyVisitChildren(len, children, i, f, k) {
  while (i < len) {
    var child = children[i++];
    if (child && !isEmptyNode(child)) return lazyVisit(child, f, [len, children, i, f, k]);
  }

  return appk(k);
};
/**
    Recursively visit all values stored in `node` lazily.
*/


var lazyVisit = function lazyVisit(node, f, k) {
  switch (node.type) {
    case LEAF:
      return {
        value: f(node),
        rest: k
      };

    case COLLISION:
    case ARRAY:
    case INDEX:
      var children = node.children;
      return lazyVisitChildren(children.length, children, 0, f, k);

    default:
      return appk(k);
  }
};

var DONE = {
  done: true
};
/**
    Javascript iterator over a map.
*/

function MapIterator(v) {
  this.v = v;
}

MapIterator.prototype.next = function () {
  if (!this.v) return DONE;
  var v0 = this.v;
  this.v = appk(v0.rest);
  return v0;
};

MapIterator.prototype[Symbol.iterator] = function () {
  return this;
};
/**
    Lazily visit each value in map with function `f`.
*/


var visit = function visit(map, f) {
  return new MapIterator(lazyVisit(map._root, f));
};
/**
    Get a Javascsript iterator of `map`.

    Iterates over `[key, value]` arrays.
*/


var buildPairs = function buildPairs(x) {
  return [x.key, x.value];
};

var entries = hamt.entries = function (map) {
  return visit(map, buildPairs);
};

Map.prototype.entries = Map.prototype[Symbol.iterator] = function () {
  return entries(this);
};
/**
    Get array of all keys in `map`.

    Order is not guaranteed.
*/


var buildKeys = function buildKeys(x) {
  return x.key;
};

var keys = hamt.keys = function (map) {
  return visit(map, buildKeys);
};

Map.prototype.keys = function () {
  return keys(this);
};
/**
    Get array of all values in `map`.

    Order is not guaranteed, duplicates are preserved.
*/


var buildValues = function buildValues(x) {
  return x.value;
};

var values = hamt.values = Map.prototype.values = function (map) {
  return visit(map, buildValues);
};

Map.prototype.values = function () {
  return values(this);
};
/* Fold
 ******************************************************************************/

/**
    Visit every entry in the map, aggregating data.

    Order of nodes is not guaranteed.

    @param f Function mapping accumulated value, value, and key to new value.
    @param z Starting value.
    @param m HAMT
*/


var fold = hamt.fold = function (f, z, m) {
  var root = m._root;
  if (root.type === LEAF) return f(z, root.value, root.key);
  var toVisit = [root.children];
  var children = void 0;

  while (children = toVisit.pop()) {
    for (var i = 0, len = children.length; i < len;) {
      var child = children[i++];

      if (child && child.type) {
        if (child.type === LEAF) z = f(z, child.value, child.key);else toVisit.push(child.children);
      }
    }
  }

  return z;
};

Map.prototype.fold = function (f, z) {
  return fold(f, z, this);
};
/**
    Visit every entry in the map, aggregating data.

    Order of nodes is not guaranteed.

    @param f Function invoked with value and key
    @param map HAMT
*/


var forEach = hamt.forEach = function (f, map) {
  return fold(function (_, value, key) {
    return f(value, key, map);
  }, null, map);
};

Map.prototype.forEach = function (f) {
  return forEach(f, this);
};
/* Aggregate
 ******************************************************************************/

/**
    Get the number of entries in `map`.
*/


var count = hamt.count = function (map) {
  return map._size;
};

Map.prototype.count = function () {
  return count(this);
};

Object.defineProperty(Map.prototype, 'size', {
  get: Map.prototype.count
});
/* Export
 ******************************************************************************/

if ( module.exports) {
  module.exports = hamt;
} else {
  undefined.hamt = hamt;
}
});

class BuiltInMap {
  constructor(existing) {
    _defineProperty(this, "_map", void 0);

    this._map = new Map(existing === null || existing === void 0 ? void 0 : existing.entries());
  }

  keys() {
    return this._map.keys();
  }

  entries() {
    return this._map.entries();
  }

  get(k) {
    return this._map.get(k);
  }

  has(k) {
    return this._map.has(k);
  }

  set(k, v) {
    this._map.set(k, v);

    return this;
  }

  delete(k) {
    this._map.delete(k);

    return this;
  }

  clone() {
    return persistentMap(this);
  }

  toMap() {
    return new Map(this._map);
  }

}

class HashArrayMappedTrieMap {
  // Because hamt.empty is not a function there is no way to introduce type
  // parameters on it, so empty is typed as HAMTPlusMap<string, mixed>.
  // $FlowIssue
  constructor(existing) {
    _defineProperty(this, "_hamt", hamt_1.empty.beginMutation());

    if (existing instanceof HashArrayMappedTrieMap) {
      const h = existing._hamt.endMutation();

      existing._hamt = h.beginMutation();
      this._hamt = h.beginMutation();
    } else if (existing) {
      for (const [k, v] of existing.entries()) {
        this._hamt.set(k, v);
      }
    }
  }

  keys() {
    return this._hamt.keys();
  }

  entries() {
    return this._hamt.entries();
  }

  get(k) {
    return this._hamt.get(k);
  }

  has(k) {
    return this._hamt.has(k);
  }

  set(k, v) {
    this._hamt.set(k, v);

    return this;
  }

  delete(k) {
    this._hamt.delete(k);

    return this;
  }

  clone() {
    return persistentMap(this);
  }

  toMap() {
    return new Map(this._hamt);
  }

}

function persistentMap(existing) {
  if (Recoil_gkx('recoil_hamt_2020')) {
    return new HashArrayMappedTrieMap(existing);
  } else {
    return new BuiltInMap(existing);
  }
}

var Recoil_PersistentMap = {
  persistentMap
};

var Recoil_PersistentMap_1 = Recoil_PersistentMap.persistentMap;

var Recoil_PersistentMap$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  persistentMap: Recoil_PersistentMap_1
});

/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */
/**
 * Returns a set containing all of the values from the first set that are not
 * present in any of the subsequent sets.
 *
 * Note: this is written procedurally (i.e., without filterSet) for performant
 * use in tight loops.
 */

function differenceSets(set, ...setsWithValuesToRemove) {
  const ret = new Set();

  FIRST: for (const value of set) {
    for (const otherSet of setsWithValuesToRemove) {
      if (otherSet.has(value)) {
        continue FIRST;
      }
    }

    ret.add(value);
  }

  return ret;
}

var Recoil_differenceSets = differenceSets;

/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */
/**
 * Returns a new Map object with the same keys as the original, but with the
 * values replaced with the output of the given callback function.
 */

function mapMap(map, callback) {
  const result = new Map();
  map.forEach((value, key) => {
    result.set(key, callback(value, key));
  });
  return result;
}

var Recoil_mapMap = mapMap;

function makeGraph() {
  return {
    nodeDeps: new Map(),
    nodeToNodeSubscriptions: new Map()
  };
}

function cloneGraph(graph) {
  return {
    nodeDeps: Recoil_mapMap(graph.nodeDeps, s => new Set(s)),
    nodeToNodeSubscriptions: Recoil_mapMap(graph.nodeToNodeSubscriptions, s => new Set(s))
  };
} // Note that this overwrites the deps of existing nodes, rather than unioning
// the new deps with the old deps.


function mergeDepsIntoGraph(key, newDeps, graph, // If olderGraph is given then we will not overwrite changes made to the given
// graph compared with olderGraph:
olderGraph) {
  const {
    nodeDeps,
    nodeToNodeSubscriptions
  } = graph;
  const oldDeps = nodeDeps.get(key);

  if (oldDeps && olderGraph && oldDeps !== olderGraph.nodeDeps.get(key)) {
    return;
  } // Update nodeDeps:


  nodeDeps.set(key, newDeps); // Add new deps to nodeToNodeSubscriptions:

  const addedDeps = oldDeps == null ? newDeps : Recoil_differenceSets(newDeps, oldDeps);

  for (const dep of addedDeps) {
    if (!nodeToNodeSubscriptions.has(dep)) {
      nodeToNodeSubscriptions.set(dep, new Set());
    }

    const existing = Recoil_nullthrows(nodeToNodeSubscriptions.get(dep));
    existing.add(key);
  } // Remove removed deps from nodeToNodeSubscriptions:


  if (oldDeps) {
    const removedDeps = Recoil_differenceSets(oldDeps, newDeps);

    for (const dep of removedDeps) {
      if (!nodeToNodeSubscriptions.has(dep)) {
        return;
      }

      const existing = Recoil_nullthrows(nodeToNodeSubscriptions.get(dep));
      existing.delete(key);

      if (existing.size === 0) {
        nodeToNodeSubscriptions.delete(dep);
      }
    }
  }
}

function saveDepsToStore(key, deps, store, version) {
  var _storeState$nextTree, _storeState$previousT, _storeState$previousT2, _storeState$previousT3;

  const storeState = store.getState();

  if (!(version === storeState.currentTree.version || version === ((_storeState$nextTree = storeState.nextTree) === null || _storeState$nextTree === void 0 ? void 0 : _storeState$nextTree.version) || version === ((_storeState$previousT = storeState.previousTree) === null || _storeState$previousT === void 0 ? void 0 : _storeState$previousT.version))) {
    Recoil_recoverableViolation('Tried to save dependencies to a discarded tree');
  } // Merge the dependencies discovered into the store's dependency map
  // for the version that was read:


  const graph = store.getGraph(version);
  mergeDepsIntoGraph(key, deps, graph); // If this version is not the latest version, also write these dependencies
  // into later versions if they don't already have their own:

  if (version === ((_storeState$previousT2 = storeState.previousTree) === null || _storeState$previousT2 === void 0 ? void 0 : _storeState$previousT2.version)) {
    const currentGraph = store.getGraph(storeState.currentTree.version);
    mergeDepsIntoGraph(key, deps, currentGraph, graph);
  }

  if (version === ((_storeState$previousT3 = storeState.previousTree) === null || _storeState$previousT3 === void 0 ? void 0 : _storeState$previousT3.version) || version === storeState.currentTree.version) {
    var _storeState$nextTree2;

    const nextVersion = (_storeState$nextTree2 = storeState.nextTree) === null || _storeState$nextTree2 === void 0 ? void 0 : _storeState$nextTree2.version;

    if (nextVersion !== undefined) {
      const nextGraph = store.getGraph(nextVersion);
      mergeDepsIntoGraph(key, deps, nextGraph, graph);
    }
  }
}

var Recoil_Graph = {
  cloneGraph,
  graph: makeGraph,
  saveDepsToStore
};

/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */

let nextTreeStateVersion = 0;

const getNextTreeStateVersion = () => nextTreeStateVersion++;

let nextStoreID = 0;

const getNextStoreID = () => nextStoreID++;

let nextComponentID = 0;

const getNextComponentID = () => nextComponentID++;

var Recoil_Keys = {
  getNextTreeStateVersion,
  getNextStoreID,
  getNextComponentID
};

const {
  persistentMap: persistentMap$1
} = Recoil_PersistentMap$1;

const {
  graph
} = Recoil_Graph;

const {
  getNextTreeStateVersion: getNextTreeStateVersion$1
} = Recoil_Keys;

function makeEmptyTreeState() {
  const version = getNextTreeStateVersion$1();
  return {
    version,
    stateID: version,
    transactionMetadata: {},
    dirtyAtoms: new Set(),
    atomValues: persistentMap$1(),
    nonvalidatedAtoms: persistentMap$1()
  };
}

function makeEmptyStoreState() {
  const currentTree = makeEmptyTreeState();
  return {
    currentTree,
    nextTree: null,
    previousTree: null,
    commitDepth: 0,
    knownAtoms: new Set(),
    knownSelectors: new Set(),
    transactionSubscriptions: new Map(),
    nodeTransactionSubscriptions: new Map(),
    nodeToComponentSubscriptions: new Map(),
    queuedComponentCallbacks_DEPRECATED: [],
    suspendedComponentResolvers: new Set(),
    graphsByVersion: new Map().set(currentTree.version, graph()),
    retention: {
      referenceCounts: new Map(),
      nodesRetainedByZone: new Map(),
      retainablesToCheckForRelease: new Set()
    },
    nodeCleanupFunctions: new Map()
  };
}

var Recoil_State = {
  makeEmptyTreeState,
  makeEmptyStoreState,
  getNextTreeStateVersion: getNextTreeStateVersion$1
};

/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */

class RetentionZone {}

function retentionZone() {
  return new RetentionZone();
}

var Recoil_RetentionZone = {
  RetentionZone,
  retentionZone
};

/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * Utilities for working with built-in Maps and Sets without mutating them.
 *
 * 
 * @format
 * @oncall recoil
 */

function setByAddingToSet(set, v) {
  const next = new Set(set);
  next.add(v);
  return next;
}

function setByDeletingFromSet(set, v) {
  const next = new Set(set);
  next.delete(v);
  return next;
}

function mapBySettingInMap(map, k, v) {
  const next = new Map(map);
  next.set(k, v);
  return next;
}

function mapByUpdatingInMap(map, k, updater) {
  const next = new Map(map);
  next.set(k, updater(next.get(k)));
  return next;
}

function mapByDeletingFromMap(map, k) {
  const next = new Map(map);
  next.delete(k);
  return next;
}

function mapByDeletingMultipleFromMap(map, ks) {
  const next = new Map(map);
  ks.forEach(k => next.delete(k));
  return next;
}

var Recoil_CopyOnWrite = {
  setByAddingToSet,
  setByDeletingFromSet,
  mapBySettingInMap,
  mapByUpdatingInMap,
  mapByDeletingFromMap,
  mapByDeletingMultipleFromMap
};

/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */
/**
 * Creates a new iterable whose output is generated by passing the input
 * iterable's values through the filter function.
 */

function* filterIterable(iterable, predicate) {
  // Use generator to create iterable/iterator
  let index = 0;

  for (const value of iterable) {
    if (predicate(value, index++)) {
      yield value;
    }
  }
}

var Recoil_filterIterable = filterIterable;

/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */
/**
 * Return a proxy object based on the provided base and factories objects.
 * The proxy will include all properties of the base object as-is.
 * The factories object contains callbacks to obtain the values of the properies
 * for its keys.
 *
 * This is useful for providing users an object where some properties may be
 * lazily computed only on first access.
 */
// $FlowIssue[unclear-type]

function lazyProxy(base, factories) {
  const proxy = new Proxy(base, {
    // Compute and cache lazy property if not already done.
    get: (target, prop) => {
      if (!(prop in target) && prop in factories) {
        target[prop] = factories[prop]();
      }

      return target[prop];
    },
    // This method allows user to iterate keys as normal
    ownKeys: target => {

      return Object.keys(target);
    }
  }); // $FlowIssue[incompatible-return]

  return proxy;
}

var Recoil_lazyProxy = lazyProxy;

const {
  getNode: getNode$1,
  getNodeMaybe: getNodeMaybe$1,
  recoilValuesForKeys: recoilValuesForKeys$1
} = Recoil_Node;

const {
  RetentionZone: RetentionZone$1
} = Recoil_RetentionZone;

const {
  setByAddingToSet: setByAddingToSet$1
} = Recoil_CopyOnWrite;







 // flowlint-next-line unclear-type:off


const emptySet = Object.freeze(new Set());

class ReadOnlyRecoilValueError extends Error {}

function initializeRetentionForNode(store, nodeKey, retainedBy) {
  if (!Recoil_gkx('recoil_memory_managament_2020')) {
    return () => undefined;
  }

  const {
    nodesRetainedByZone
  } = store.getState().retention;

  function addToZone(zone) {
    let set = nodesRetainedByZone.get(zone);

    if (!set) {
      nodesRetainedByZone.set(zone, set = new Set());
    }

    set.add(nodeKey);
  }

  if (retainedBy instanceof RetentionZone$1) {
    addToZone(retainedBy);
  } else if (Array.isArray(retainedBy)) {
    for (const zone of retainedBy) {
      addToZone(zone);
    }
  }

  return () => {
    if (!Recoil_gkx('recoil_memory_managament_2020')) {
      return;
    }

    const {
      retention
    } = store.getState();

    function deleteFromZone(zone) {
      const set = retention.nodesRetainedByZone.get(zone);
      set === null || set === void 0 ? void 0 : set.delete(nodeKey);

      if (set && set.size === 0) {
        retention.nodesRetainedByZone.delete(zone);
      }
    }

    if (retainedBy instanceof RetentionZone$1) {
      deleteFromZone(retainedBy);
    } else if (Array.isArray(retainedBy)) {
      for (const zone of retainedBy) {
        deleteFromZone(zone);
      }
    }
  };
}

function initializeNodeIfNewToStore(store, treeState, key, trigger) {
  const storeState = store.getState();

  if (storeState.nodeCleanupFunctions.has(key)) {
    return;
  }

  const node = getNode$1(key);
  const retentionCleanup = initializeRetentionForNode(store, key, node.retainedBy);
  const nodeCleanup = node.init(store, treeState, trigger);
  storeState.nodeCleanupFunctions.set(key, () => {
    nodeCleanup();
    retentionCleanup();
  });
}

function initializeNode(store, key, trigger) {
  initializeNodeIfNewToStore(store, store.getState().currentTree, key, trigger);
}

function cleanUpNode(store, key) {
  var _state$nodeCleanupFun;

  const state = store.getState();
  (_state$nodeCleanupFun = state.nodeCleanupFunctions.get(key)) === null || _state$nodeCleanupFun === void 0 ? void 0 : _state$nodeCleanupFun();
  state.nodeCleanupFunctions.delete(key);
} // Get the current value loadable of a node and update the state.
// Update dependencies and subscriptions for selectors.
// Update saved value validation for atoms.


function getNodeLoadable(store, state, key) {
  initializeNodeIfNewToStore(store, state, key, 'get');
  return getNode$1(key).get(store, state);
} // Peek at the current value loadable for a node without any evaluation or state change


function peekNodeLoadable(store, state, key) {
  return getNode$1(key).peek(store, state);
} // Write value directly to state bypassing the Node interface as the node
// definitions may not have been loaded yet when processing the initial snapshot.


function setUnvalidatedAtomValue_DEPRECATED(state, key, newValue) {
  var _node$invalidate;

  const node = getNodeMaybe$1(key);
  node === null || node === void 0 ? void 0 : (_node$invalidate = node.invalidate) === null || _node$invalidate === void 0 ? void 0 : _node$invalidate.call(node, state);
  return { ...state,
    atomValues: state.atomValues.clone().delete(key),
    nonvalidatedAtoms: state.nonvalidatedAtoms.clone().set(key, newValue),
    dirtyAtoms: setByAddingToSet$1(state.dirtyAtoms, key)
  };
} // Return the discovered dependencies and values to be written by setting
// a node value. (Multiple values may be written due to selectors getting to
// set upstreams; deps may be discovered because of reads in updater functions.)


function setNodeValue(store, state, key, newValue) {
  const node = getNode$1(key);

  if (node.set == null) {
    throw new ReadOnlyRecoilValueError(`Attempt to set read-only RecoilValue: ${key}`);
  }

  const set = node.set; // so flow doesn't lose the above refinement.

  initializeNodeIfNewToStore(store, state, key, 'set');
  return set(store, state, newValue);
}

function peekNodeInfo(store, state, key) {
  const storeState = store.getState();
  const graph = store.getGraph(state.version);
  const type = getNode$1(key).nodeType;
  return Recoil_lazyProxy({
    type
  }, {
    loadable: () => peekNodeLoadable(store, state, key),
    isActive: () => storeState.knownAtoms.has(key) || storeState.knownSelectors.has(key),
    isSet: () => type === 'selector' ? false : state.atomValues.has(key),
    isModified: () => state.dirtyAtoms.has(key),
    // Report current dependencies.  If the node hasn't been evaluated, then
    // dependencies may be missing based on the current state.
    deps: () => {
      var _graph$nodeDeps$get;

      return recoilValuesForKeys$1((_graph$nodeDeps$get = graph.nodeDeps.get(key)) !== null && _graph$nodeDeps$get !== void 0 ? _graph$nodeDeps$get : []);
    },
    // Reports all "current" subscribers.  Evaluating other nodes or
    // previous in-progress async evaluations may introduce new subscribers.
    subscribers: () => {
      var _storeState$nodeToCom, _storeState$nodeToCom2;

      return {
        nodes: recoilValuesForKeys$1(Recoil_filterIterable(getDownstreamNodes(store, state, new Set([key])), nodeKey => nodeKey !== key)),
        components: Recoil_mapIterable((_storeState$nodeToCom = (_storeState$nodeToCom2 = storeState.nodeToComponentSubscriptions.get(key)) === null || _storeState$nodeToCom2 === void 0 ? void 0 : _storeState$nodeToCom2.values()) !== null && _storeState$nodeToCom !== void 0 ? _storeState$nodeToCom : [], ([name]) => ({
          name
        }))
      };
    }
  });
} // Find all of the recursively dependent nodes


function getDownstreamNodes(store, state, keys) {
  const visitedNodes = new Set();
  const visitingNodes = Array.from(keys);
  const graph = store.getGraph(state.version);

  for (let key = visitingNodes.pop(); key; key = visitingNodes.pop()) {
    var _graph$nodeToNodeSubs;

    visitedNodes.add(key);
    const subscribedNodes = (_graph$nodeToNodeSubs = graph.nodeToNodeSubscriptions.get(key)) !== null && _graph$nodeToNodeSubs !== void 0 ? _graph$nodeToNodeSubs : emptySet;

    for (const downstreamNode of subscribedNodes) {
      if (!visitedNodes.has(downstreamNode)) {
        visitingNodes.push(downstreamNode);
      }
    }
  }

  return visitedNodes;
}

var Recoil_FunctionalCore = {
  getNodeLoadable,
  peekNodeLoadable,
  setNodeValue,
  initializeNode,
  cleanUpNode,
  setUnvalidatedAtomValue_DEPRECATED,
  peekNodeInfo,
  getDownstreamNodes
};

/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */

let _invalidateMemoizedSnapshot = null;

function setInvalidateMemoizedSnapshot(invalidate) {
  _invalidateMemoizedSnapshot = invalidate;
}

function invalidateMemoizedSnapshot() {
  var _invalidateMemoizedSn;

  (_invalidateMemoizedSn = _invalidateMemoizedSnapshot) === null || _invalidateMemoizedSn === void 0 ? void 0 : _invalidateMemoizedSn();
}

var Recoil_SnapshotCache = {
  setInvalidateMemoizedSnapshot,
  invalidateMemoizedSnapshot
};

const {
  getDownstreamNodes: getDownstreamNodes$1,
  getNodeLoadable: getNodeLoadable$1,
  setNodeValue: setNodeValue$1
} = Recoil_FunctionalCore;

const {
  getNextComponentID: getNextComponentID$1
} = Recoil_Keys;

const {
  getNode: getNode$2,
  getNodeMaybe: getNodeMaybe$2
} = Recoil_Node;

const {
  DefaultValue: DefaultValue$1
} = Recoil_Node;

const {
  reactMode: reactMode$1
} = Recoil_ReactMode;

const {
  AbstractRecoilValue: AbstractRecoilValue$1,
  RecoilState: RecoilState$1,
  RecoilValueReadOnly: RecoilValueReadOnly$1,
  isRecoilValue: isRecoilValue$1
} = Recoil_RecoilValue$1;

const {
  invalidateMemoizedSnapshot: invalidateMemoizedSnapshot$1
} = Recoil_SnapshotCache;







function getRecoilValueAsLoadable(store, {
  key
}, treeState = store.getState().currentTree) {
  var _storeState$nextTree, _storeState$previousT;

  // Reading from an older tree can cause bugs because the dependencies that we
  // discover during the read are lost.
  const storeState = store.getState();

  if (!(treeState.version === storeState.currentTree.version || treeState.version === ((_storeState$nextTree = storeState.nextTree) === null || _storeState$nextTree === void 0 ? void 0 : _storeState$nextTree.version) || treeState.version === ((_storeState$previousT = storeState.previousTree) === null || _storeState$previousT === void 0 ? void 0 : _storeState$previousT.version))) {
    Recoil_recoverableViolation('Tried to read from a discarded tree');
  }

  const loadable = getNodeLoadable$1(store, treeState, key);

  if (loadable.state === 'loading') {
    loadable.contents.catch(() => {
      /**
       * HACK: intercept thrown error here to prevent an uncaught promise exception. Ideally this would happen closer to selector
       * execution (perhaps introducing a new ERROR class to be resolved by async selectors that are in an error state)
       */
      return;
    });
  }

  return loadable;
}

function applyAtomValueWrites(atomValues, writes) {
  const result = atomValues.clone();
  writes.forEach((v, k) => {
    if (v.state === 'hasValue' && v.contents instanceof DefaultValue$1) {
      result.delete(k);
    } else {
      result.set(k, v);
    }
  });
  return result;
}

function valueFromValueOrUpdater(store, state, {
  key
}, valueOrUpdater) {
  if (typeof valueOrUpdater === 'function') {
    // Updater form: pass in the current value. Throw if the current value
    // is unavailable (namely when updating an async selector that's
    // pending or errored):
    const current = getNodeLoadable$1(store, state, key);

    if (current.state === 'loading') {
      const msg = `Tried to set atom or selector "${key}" using an updater function while the current state is pending, this is not currently supported.`;
      Recoil_recoverableViolation(msg);
      throw Recoil_err(msg);
    } else if (current.state === 'hasError') {
      throw current.contents;
    } // T itself may be a function, so our refinement is not sufficient:


    return valueOrUpdater(current.contents); // flowlint-line unclear-type:off
  } else {
    return valueOrUpdater;
  }
}

function applyAction(store, state, action) {
  if (action.type === 'set') {
    const {
      recoilValue,
      valueOrUpdater
    } = action;
    const newValue = valueFromValueOrUpdater(store, state, recoilValue, valueOrUpdater);
    const writes = setNodeValue$1(store, state, recoilValue.key, newValue);

    for (const [key, loadable] of writes.entries()) {
      writeLoadableToTreeState(state, key, loadable);
    }
  } else if (action.type === 'setLoadable') {
    const {
      recoilValue: {
        key
      },
      loadable
    } = action;
    writeLoadableToTreeState(state, key, loadable);
  } else if (action.type === 'markModified') {
    const {
      recoilValue: {
        key
      }
    } = action;
    state.dirtyAtoms.add(key);
  } else if (action.type === 'setUnvalidated') {
    var _node$invalidate;

    // Write value directly to state bypassing the Node interface as the node
    // definitions may not have been loaded yet when processing the initial snapshot.
    const {
      recoilValue: {
        key
      },
      unvalidatedValue
    } = action;
    const node = getNodeMaybe$2(key);
    node === null || node === void 0 ? void 0 : (_node$invalidate = node.invalidate) === null || _node$invalidate === void 0 ? void 0 : _node$invalidate.call(node, state);
    state.atomValues.delete(key);
    state.nonvalidatedAtoms.set(key, unvalidatedValue);
    state.dirtyAtoms.add(key);
  } else {
    Recoil_recoverableViolation(`Unknown action ${action.type}`);
  }
}

function writeLoadableToTreeState(state, key, loadable) {
  if (loadable.state === 'hasValue' && loadable.contents instanceof DefaultValue$1) {
    state.atomValues.delete(key);
  } else {
    state.atomValues.set(key, loadable);
  }

  state.dirtyAtoms.add(key);
  state.nonvalidatedAtoms.delete(key);
}

function applyActionsToStore(store, actions) {
  store.replaceState(state => {
    const newState = copyTreeState(state);

    for (const action of actions) {
      applyAction(store, newState, action);
    }

    invalidateDownstreams(store, newState);
    invalidateMemoizedSnapshot$1();
    return newState;
  });
}

function queueOrPerformStateUpdate(store, action) {
  if (batchStack.length) {
    const actionsByStore = batchStack[batchStack.length - 1];
    let actions = actionsByStore.get(store);

    if (!actions) {
      actionsByStore.set(store, actions = []);
    }

    actions.push(action);
  } else {
    applyActionsToStore(store, [action]);
  }
}

const batchStack = [];

function batchStart() {
  const actionsByStore = new Map();
  batchStack.push(actionsByStore);
  return () => {
    for (const [store, actions] of actionsByStore) {
      applyActionsToStore(store, actions);
    }

    const popped = batchStack.pop();

    if (popped !== actionsByStore) {
      Recoil_recoverableViolation('Incorrect order of batch popping');
    }
  };
}

function copyTreeState(state) {
  return { ...state,
    atomValues: state.atomValues.clone(),
    nonvalidatedAtoms: state.nonvalidatedAtoms.clone(),
    dirtyAtoms: new Set(state.dirtyAtoms)
  };
}

function invalidateDownstreams(store, state) {
  // Inform any nodes that were changed or downstream of changes so that they
  // can clear out any caches as needed due to the update:
  const downstreams = getDownstreamNodes$1(store, state, state.dirtyAtoms);

  for (const key of downstreams) {
    var _getNodeMaybe, _getNodeMaybe$invalid;

    (_getNodeMaybe = getNodeMaybe$2(key)) === null || _getNodeMaybe === void 0 ? void 0 : (_getNodeMaybe$invalid = _getNodeMaybe.invalidate) === null || _getNodeMaybe$invalid === void 0 ? void 0 : _getNodeMaybe$invalid.call(_getNodeMaybe, state);
  }
}

function setRecoilValue(store, recoilValue, valueOrUpdater) {
  queueOrPerformStateUpdate(store, {
    type: 'set',
    recoilValue,
    valueOrUpdater
  });
}

function setRecoilValueLoadable(store, recoilValue, loadable) {
  if (loadable instanceof DefaultValue$1) {
    return setRecoilValue(store, recoilValue, loadable);
  }

  queueOrPerformStateUpdate(store, {
    type: 'setLoadable',
    recoilValue,
    loadable: loadable
  });
}

function markRecoilValueModified(store, recoilValue) {
  queueOrPerformStateUpdate(store, {
    type: 'markModified',
    recoilValue
  });
}

function setUnvalidatedRecoilValue(store, recoilValue, unvalidatedValue) {
  queueOrPerformStateUpdate(store, {
    type: 'setUnvalidated',
    recoilValue,
    unvalidatedValue
  });
}

function subscribeToRecoilValue(store, {
  key
}, callback, componentDebugName = null) {
  const subID = getNextComponentID$1();
  const storeState = store.getState();

  if (!storeState.nodeToComponentSubscriptions.has(key)) {
    storeState.nodeToComponentSubscriptions.set(key, new Map());
  }

  Recoil_nullthrows(storeState.nodeToComponentSubscriptions.get(key)).set(subID, [componentDebugName !== null && componentDebugName !== void 0 ? componentDebugName : '<not captured>', callback]); // Handle the case that, during the same tick that we are subscribing, an atom
  // has been updated by some effect handler. Otherwise we will miss the update.

  const mode = reactMode$1();

  if (mode.early && (mode.mode === 'LEGACY' || mode.mode === 'MUTABLE_SOURCE')) {
    const nextTree = store.getState().nextTree;

    if (nextTree && nextTree.dirtyAtoms.has(key)) {
      callback(nextTree);
    }
  }

  return {
    release: () => {
      const releaseStoreState = store.getState();
      const subs = releaseStoreState.nodeToComponentSubscriptions.get(key);

      if (subs === undefined || !subs.has(subID)) {
        Recoil_recoverableViolation(`Subscription missing at release time for atom ${key}. This is a bug in Recoil.`);
        return;
      }

      subs.delete(subID);

      if (subs.size === 0) {
        releaseStoreState.nodeToComponentSubscriptions.delete(key);
      }
    }
  };
}

function refreshRecoilValue(store, recoilValue) {
  var _node$clearCache;

  const {
    currentTree
  } = store.getState();
  const node = getNode$2(recoilValue.key);
  (_node$clearCache = node.clearCache) === null || _node$clearCache === void 0 ? void 0 : _node$clearCache.call(node, store, currentTree);
}

var Recoil_RecoilValueInterface = {
  RecoilValueReadOnly: RecoilValueReadOnly$1,
  AbstractRecoilValue: AbstractRecoilValue$1,
  RecoilState: RecoilState$1,
  getRecoilValueAsLoadable,
  setRecoilValue,
  setRecoilValueLoadable,
  markRecoilValueModified,
  setUnvalidatedRecoilValue,
  subscribeToRecoilValue,
  isRecoilValue: isRecoilValue$1,
  applyAtomValueWrites,
  // TODO Remove export when deprecating initialStoreState_DEPRECATED in RecoilRoot
  batchStart,
  writeLoadableToTreeState,
  invalidateDownstreams,
  copyTreeState,
  refreshRecoilValue
};

/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */
/**
 * The someSet() method tests whether some elements in the given Set pass the
 * test implemented by the provided function.
 */

function someSet(set, callback, context) {
  const iterator = set.entries();
  let current = iterator.next();

  while (!current.done) {
    const entry = current.value;

    if (callback.call(context, entry[1], entry[0], set)) {
      return true;
    }

    current = iterator.next();
  }

  return false;
}

var Recoil_someSet = someSet;

const {
  cleanUpNode: cleanUpNode$1
} = Recoil_FunctionalCore;

const {
  deleteNodeConfigIfPossible: deleteNodeConfigIfPossible$1,
  getNode: getNode$3
} = Recoil_Node;

const {
  RetentionZone: RetentionZone$2
} = Recoil_RetentionZone;







 // Components that aren't mounted after suspending for this long will be assumed
// to be discarded and their resources released.


const SUSPENSE_TIMEOUT_MS = 120000;
const emptySet$1 = new Set();

function releaseRetainablesNowOnCurrentTree(store, retainables) {
  const storeState = store.getState();
  const treeState = storeState.currentTree;

  if (storeState.nextTree) {
    Recoil_recoverableViolation('releaseNodesNowOnCurrentTree should only be called at the end of a batch');
    return; // leak memory rather than erase something that's about to be used.
  }

  const nodes = new Set();

  for (const r of retainables) {
    if (r instanceof RetentionZone$2) {
      for (const n of nodesRetainedByZone(storeState, r)) {
        nodes.add(n);
      }
    } else {
      nodes.add(r);
    }
  }

  const releasableNodes = findReleasableNodes(store, nodes);

  for (const node of releasableNodes) {
    releaseNode(store, treeState, node);
  }
}

function findReleasableNodes(store, searchFromNodes) {
  const storeState = store.getState();
  const treeState = storeState.currentTree;
  const graph = store.getGraph(treeState.version);
  const releasableNodes = new Set(); // mutated to collect answer

  const nonReleasableNodes = new Set();
  findReleasableNodesInner(searchFromNodes);
  return releasableNodes;

  function findReleasableNodesInner(searchFromNodes) {
    const releasableNodesFoundThisIteration = new Set();
    const downstreams = getDownstreamNodesInTopologicalOrder(store, treeState, searchFromNodes, releasableNodes, // don't descend into these
    nonReleasableNodes // don't descend into these
    ); // Find which of the downstream nodes are releasable and which are not:

    for (const node of downstreams) {
      var _storeState$retention;

      // Not releasable if configured to be retained forever:
      if (getNode$3(node).retainedBy === 'recoilRoot') {
        nonReleasableNodes.add(node);
        continue;
      } // Not releasable if retained directly by a component:


      if (((_storeState$retention = storeState.retention.referenceCounts.get(node)) !== null && _storeState$retention !== void 0 ? _storeState$retention : 0) > 0) {
        nonReleasableNodes.add(node);
        continue;
      } // Not releasable if retained by a zone:


      if (zonesThatCouldRetainNode(node).some(z => storeState.retention.referenceCounts.get(z))) {
        nonReleasableNodes.add(node);
        continue;
      } // Not releasable if it has a non-releasable child (which will already be in
      // nonReleasableNodes because we are going in topological order):


      const nodeChildren = graph.nodeToNodeSubscriptions.get(node);

      if (nodeChildren && Recoil_someSet(nodeChildren, child => nonReleasableNodes.has(child))) {
        nonReleasableNodes.add(node);
        continue;
      }

      releasableNodes.add(node);
      releasableNodesFoundThisIteration.add(node);
    } // If we found any releasable nodes, we need to walk UP from those nodes to
    // find whether their parents can now be released as well:


    const parents = new Set();

    for (const node of releasableNodesFoundThisIteration) {
      for (const parent of (_graph$nodeDeps$get = graph.nodeDeps.get(node)) !== null && _graph$nodeDeps$get !== void 0 ? _graph$nodeDeps$get : emptySet$1) {
        var _graph$nodeDeps$get;

        if (!releasableNodes.has(parent)) {
          parents.add(parent);
        }
      }
    }

    if (parents.size) {
      findReleasableNodesInner(parents);
    }
  }
} // Children before parents


function getDownstreamNodesInTopologicalOrder(store, treeState, nodes, // Mutable set is destroyed in place
doNotDescendInto1, doNotDescendInto2) {
  const graph = store.getGraph(treeState.version);
  const answer = [];
  const visited = new Set();

  while (nodes.size > 0) {
    visit(Recoil_nullthrows(nodes.values().next().value));
  }

  return answer;

  function visit(node) {
    if (doNotDescendInto1.has(node) || doNotDescendInto2.has(node)) {
      nodes.delete(node);
      return;
    }

    if (visited.has(node)) {
      return;
    }

    const children = graph.nodeToNodeSubscriptions.get(node);

    if (children) {
      for (const child of children) {
        visit(child);
      }
    }

    visited.add(node);
    nodes.delete(node);
    answer.push(node);
  }
}

function releaseNode(store, treeState, node) {
  if (!Recoil_gkx('recoil_memory_managament_2020')) {
    return;
  } // Atom effects, in-closure caches, etc.:


  cleanUpNode$1(store, node); // Delete from store state:

  const storeState = store.getState();
  storeState.knownAtoms.delete(node);
  storeState.knownSelectors.delete(node);
  storeState.nodeTransactionSubscriptions.delete(node);
  storeState.retention.referenceCounts.delete(node);
  const zones = zonesThatCouldRetainNode(node);

  for (const zone of zones) {
    var _storeState$retention2;

    (_storeState$retention2 = storeState.retention.nodesRetainedByZone.get(zone)) === null || _storeState$retention2 === void 0 ? void 0 : _storeState$retention2.delete(node);
  } // Note that we DO NOT delete from nodeToComponentSubscriptions because this
  // already happens when the last component that was retaining the node unmounts,
  // and this could happen either before or after that.
  // Delete from TreeState and dep graph:


  treeState.atomValues.delete(node);
  treeState.dirtyAtoms.delete(node);
  treeState.nonvalidatedAtoms.delete(node);
  const graph = storeState.graphsByVersion.get(treeState.version);

  if (graph) {
    const deps = graph.nodeDeps.get(node);

    if (deps !== undefined) {
      graph.nodeDeps.delete(node);

      for (const dep of deps) {
        var _graph$nodeToNodeSubs;

        (_graph$nodeToNodeSubs = graph.nodeToNodeSubscriptions.get(dep)) === null || _graph$nodeToNodeSubs === void 0 ? void 0 : _graph$nodeToNodeSubs.delete(node);
      }
    } // No need to delete sub's deps as there should be no subs at this point.
    // But an invariant would require deleting nodes in topological order.


    graph.nodeToNodeSubscriptions.delete(node);
  } // Node config (for family members only as their configs can be recreated, and
  // only if they are not retained within any other Stores):


  deleteNodeConfigIfPossible$1(node);
}

function nodesRetainedByZone(storeState, zone) {
  var _storeState$retention3;

  return (_storeState$retention3 = storeState.retention.nodesRetainedByZone.get(zone)) !== null && _storeState$retention3 !== void 0 ? _storeState$retention3 : emptySet$1;
}

function zonesThatCouldRetainNode(node) {
  const retainedBy = getNode$3(node).retainedBy;

  if (retainedBy === undefined || retainedBy === 'components' || retainedBy === 'recoilRoot') {
    return [];
  } else if (retainedBy instanceof RetentionZone$2) {
    return [retainedBy];
  } else {
    return retainedBy; // it's an array of zones
  }
}

function scheduleOrPerformPossibleReleaseOfRetainable(store, retainable) {
  const state = store.getState();

  if (state.nextTree) {
    state.retention.retainablesToCheckForRelease.add(retainable);
  } else {
    releaseRetainablesNowOnCurrentTree(store, new Set([retainable]));
  }
}

function updateRetainCount(store, retainable, delta) {
  var _map$get;

  if (!Recoil_gkx('recoil_memory_managament_2020')) {
    return;
  }

  const map = store.getState().retention.referenceCounts;
  const newCount = ((_map$get = map.get(retainable)) !== null && _map$get !== void 0 ? _map$get : 0) + delta;

  if (newCount === 0) {
    updateRetainCountToZero(store, retainable);
  } else {
    map.set(retainable, newCount);
  }
}

function updateRetainCountToZero(store, retainable) {
  if (!Recoil_gkx('recoil_memory_managament_2020')) {
    return;
  }

  const map = store.getState().retention.referenceCounts;
  map.delete(retainable);
  scheduleOrPerformPossibleReleaseOfRetainable(store, retainable);
}

function releaseScheduledRetainablesNow(store) {
  if (!Recoil_gkx('recoil_memory_managament_2020')) {
    return;
  }

  const state = store.getState();
  releaseRetainablesNowOnCurrentTree(store, state.retention.retainablesToCheckForRelease);
  state.retention.retainablesToCheckForRelease.clear();
}

function retainedByOptionWithDefault(r) {
  // The default will change from 'recoilRoot' to 'components' in the future.
  return r === undefined ? 'recoilRoot' : r;
}

var Recoil_Retention = {
  SUSPENSE_TIMEOUT_MS,
  updateRetainCount,
  updateRetainCountToZero,
  releaseScheduledRetainablesNow,
  retainedByOptionWithDefault
};

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * This is to export esstiential functions from react-dom
 * for our web build
 *
 * 
 * @format
 * @oncall recoil
 */
const {
  unstable_batchedUpdates
} = reactDom;

var ReactBatchedUpdates = {
  unstable_batchedUpdates
};

/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * This is to export esstiential functions from react-dom
 * for our web build
 *
 * 
 * @format
 * @oncall recoil
 */
// @fb-only: const {unstable_batchedUpdates} = require('ReactDOMComet');
// prettier-ignore
const {
  unstable_batchedUpdates: unstable_batchedUpdates$1
} = ReactBatchedUpdates; // @oss-only


var Recoil_ReactBatchedUpdates = {
  unstable_batchedUpdates: unstable_batchedUpdates$1
};

/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */
const {
  batchStart: batchStart$1
} = Recoil_RecoilValueInterface;

const {
  unstable_batchedUpdates: unstable_batchedUpdates$2
} = Recoil_ReactBatchedUpdates;

let batcher = unstable_batchedUpdates$2; // flowlint-next-line unclear-type:off

/**
 * Sets the provided batcher function as the batcher function used by Recoil.
 *
 * Set the batcher to a custom batcher for your renderer,
 * if you use a renderer other than React DOM or React Native.
 */
const setBatcher = newBatcher => {
  batcher = newBatcher;
};
/**
 * Returns the current batcher function.
 */


const getBatcher = () => batcher;
/**
 * Calls the current batcher function and passes the
 * provided callback function.
 */


const batchUpdates = callback => {
  batcher(() => {
    let batchEnd = () => undefined;

    try {
      batchEnd = batchStart$1();
      callback();
    } finally {
      batchEnd();
    }
  });
};

var Recoil_Batching = {
  getBatcher,
  setBatcher,
  batchUpdates
};

/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */
/**
 * Combines multiple Iterables into a single Iterable.
 * Traverses the input Iterables in the order provided and maintains the order
 * of their elements.
 *
 * Example:
 * ```
 * const r = Array.from(concatIterables(['a', 'b'], ['c'], ['d', 'e', 'f']));
 * r == ['a', 'b', 'c', 'd', 'e', 'f'];
 * ```
 */

function* concatIterables(iters) {
  for (const iter of iters) {
    for (const val of iter) {
      yield val;
    }
  }
}

var Recoil_concatIterables = concatIterables;

/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */
/* eslint-disable fb-www/typeof-undefined */

const isSSR = // $FlowFixMe(site=recoil) Window does not have a FlowType definition https://github.com/facebook/flow/issues/6709
typeof Window === 'undefined' || typeof window === 'undefined';
/* eslint-enable fb-www/typeof-undefined */

const isWindow = value => !isSSR && ( // $FlowFixMe(site=recoil) Window does not have a FlowType definition https://github.com/facebook/flow/issues/6709
value === window || value instanceof Window);

const isReactNative = typeof navigator !== 'undefined' && navigator.product === 'ReactNative'; // eslint-disable-line fb-www/typeof-undefined

var Recoil_Environment = {
  isSSR,
  isReactNative,
  isWindow
};

/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */
/**
 * Caches a function's results based on the key returned by the passed
 * hashFunction.
 */

function memoizeWithArgsHash(fn, hashFunction) {
  let cache;

  const memoizedFn = (...args) => {
    if (!cache) {
      cache = {};
    }

    const key = hashFunction(...args);

    if (!Object.hasOwnProperty.call(cache, key)) {
      cache[key] = fn(...args);
    }

    return cache[key];
  };

  return memoizedFn;
}
/**
 * Caches a function's results based on a comparison of the arguments.
 * Only caches the last return of the function.
 * Defaults to reference equality
 */


function memoizeOneWithArgsHash(fn, hashFunction) {
  let lastKey;
  let lastResult; // breaking cache when arguments change

  const memoizedFn = (...args) => {
    const key = hashFunction(...args);

    if (lastKey === key) {
      return lastResult;
    }

    lastKey = key;
    lastResult = fn(...args);
    return lastResult;
  };

  return memoizedFn;
}
/**
 * Caches a function's results based on a comparison of the arguments.
 * Only caches the last return of the function.
 * Defaults to reference equality
 */


function memoizeOneWithArgsHashAndInvalidation(fn, hashFunction) {
  let lastKey;
  let lastResult; // breaking cache when arguments change

  const memoizedFn = (...args) => {
    const key = hashFunction(...args);

    if (lastKey === key) {
      return lastResult;
    }

    lastKey = key;
    lastResult = fn(...args);
    return lastResult;
  };

  const invalidate = () => {
    lastKey = null;
  };

  return [memoizedFn, invalidate];
}

var Recoil_Memoize = {
  memoizeWithArgsHash,
  memoizeOneWithArgsHash,
  memoizeOneWithArgsHashAndInvalidation
};

const {
  batchUpdates: batchUpdates$1
} = Recoil_Batching;

const {
  initializeNode: initializeNode$1,
  peekNodeInfo: peekNodeInfo$1
} = Recoil_FunctionalCore;

const {
  graph: graph$1
} = Recoil_Graph;

const {
  getNextStoreID: getNextStoreID$1
} = Recoil_Keys;

const {
  DEFAULT_VALUE: DEFAULT_VALUE$1,
  recoilValues: recoilValues$1,
  recoilValuesForKeys: recoilValuesForKeys$2
} = Recoil_Node;

const {
  AbstractRecoilValue: AbstractRecoilValue$2,
  getRecoilValueAsLoadable: getRecoilValueAsLoadable$1,
  setRecoilValue: setRecoilValue$1,
  setUnvalidatedRecoilValue: setUnvalidatedRecoilValue$1
} = Recoil_RecoilValueInterface;

const {
  updateRetainCount: updateRetainCount$1
} = Recoil_Retention;

const {
  setInvalidateMemoizedSnapshot: setInvalidateMemoizedSnapshot$1
} = Recoil_SnapshotCache;

const {
  getNextTreeStateVersion: getNextTreeStateVersion$2,
  makeEmptyStoreState: makeEmptyStoreState$1
} = Recoil_State;



const {
  isSSR: isSSR$1
} = Recoil_Environment;









const {
  memoizeOneWithArgsHashAndInvalidation: memoizeOneWithArgsHashAndInvalidation$1
} = Recoil_Memoize;



 // Opaque at this surface because it's part of the public API from here.


const retainWarning = (/* unused pure expression or super */ null && (`
Recoil Snapshots only last for the duration of the callback they are provided to. To keep a Snapshot longer, do this:

  const release = snapshot.retain();
  try {
    await doSomethingWithSnapshot(snapshot);
  } finally {
    release();
  }

This is currently a DEV-only warning but will become a thrown exception in the next release of Recoil.
`)); // A "Snapshot" is "read-only" and captures a specific set of values of atoms.
// However, the data-flow-graph and selector values may evolve as selector
// evaluation functions are executed and async selectors resolve.

class Snapshot {
  // eslint-disable-next-line fb-www/no-uninitialized-properties
  constructor(storeState, parentStoreID) {
    _defineProperty(this, "_store", void 0);

    _defineProperty(this, "_refCount", 1);

    _defineProperty(this, "getLoadable", recoilValue => {
      this.checkRefCount_INTERNAL();
      return getRecoilValueAsLoadable$1(this._store, recoilValue);
    });

    _defineProperty(this, "getPromise", recoilValue => {
      this.checkRefCount_INTERNAL();
      return this.getLoadable(recoilValue).toPromise();
    });

    _defineProperty(this, "getNodes_UNSTABLE", opt => {
      this.checkRefCount_INTERNAL(); // TODO Deal with modified selectors

      if ((opt === null || opt === void 0 ? void 0 : opt.isModified) === true) {
        if ((opt === null || opt === void 0 ? void 0 : opt.isInitialized) === false) {
          return [];
        }

        const state = this._store.getState().currentTree;

        return recoilValuesForKeys$2(state.dirtyAtoms);
      }

      const knownAtoms = this._store.getState().knownAtoms;

      const knownSelectors = this._store.getState().knownSelectors;

      return (opt === null || opt === void 0 ? void 0 : opt.isInitialized) == null ? recoilValues$1.values() : opt.isInitialized === true ? recoilValuesForKeys$2(Recoil_concatIterables([knownAtoms, knownSelectors])) : Recoil_filterIterable(recoilValues$1.values(), ({
        key
      }) => !knownAtoms.has(key) && !knownSelectors.has(key));
    });

    _defineProperty(this, "getInfo_UNSTABLE", ({
      key
    }) => {
      this.checkRefCount_INTERNAL();
      return peekNodeInfo$1(this._store, this._store.getState().currentTree, key);
    });

    _defineProperty(this, "map", mapper => {
      this.checkRefCount_INTERNAL();
      const mutableSnapshot = new MutableSnapshot(this, batchUpdates$1);
      mapper(mutableSnapshot); // if removing batchUpdates from `set` add it here

      return mutableSnapshot;
    });

    _defineProperty(this, "asyncMap", async mapper => {
      this.checkRefCount_INTERNAL();
      const mutableSnapshot = new MutableSnapshot(this, batchUpdates$1);
      mutableSnapshot.retain(); // Retain new snapshot during async mapper

      await mapper(mutableSnapshot); // Continue to retain the new snapshot for the user, but auto-release it
      // after the next tick, the same as a new synchronous snapshot.

      mutableSnapshot.autoRelease_INTERNAL();
      return mutableSnapshot;
    });

    this._store = {
      storeID: getNextStoreID$1(),
      parentStoreID,
      getState: () => storeState,
      replaceState: replacer => {
        // no batching, so nextTree is never active
        storeState.currentTree = replacer(storeState.currentTree);
      },
      getGraph: version => {
        const graphs = storeState.graphsByVersion;

        if (graphs.has(version)) {
          return Recoil_nullthrows(graphs.get(version));
        }

        const newGraph = graph$1();
        graphs.set(version, newGraph);
        return newGraph;
      },
      subscribeToTransactions: () => ({
        release: () => {}
      }),
      addTransactionMetadata: () => {
        throw Recoil_err('Cannot subscribe to Snapshots');
      }
    }; // Initialize any nodes that are live in the parent store (primarily so that
    // this snapshot gets counted towards the node's live stores count).
    // TODO Optimize this when cloning snapshots for callbacks

    for (const nodeKey of this._store.getState().knownAtoms) {
      initializeNode$1(this._store, nodeKey, 'get');
      updateRetainCount$1(this._store, nodeKey, 1);
    }

    this.autoRelease_INTERNAL();
  }

  retain() {
    if (this._refCount <= 0) {
      if (false) {} else {
        Recoil_recoverableViolation('Attempt to retain() Snapshot that was already released.');
      }
    }

    this._refCount++;
    let released = false;
    return () => {
      if (!released) {
        released = true;

        this._release();
      }
    };
  }
  /**
   * Release the snapshot on the next tick.  This means the snapshot is retained
   * during the execution of the current function using it.
   */


  autoRelease_INTERNAL() {
    if (!isSSR$1) {
      // Use timeout of 10 to workaround Firefox issue: https://github.com/facebookexperimental/Recoil/issues/1936
      window.setTimeout(() => this._release(), 10);
    }
  }

  _release() {
    this._refCount--;

    if (this._refCount === 0) {
      this._store.getState().nodeCleanupFunctions.forEach(cleanup => cleanup());

      this._store.getState().nodeCleanupFunctions.clear();

      if (!Recoil_gkx('recoil_memory_managament_2020')) {
        return;
      } // Temporarily nerfing this to allow us to find broken call sites without
      // actually breaking anybody yet.
      // for (const k of this._store.getState().knownAtoms) {
      //   updateRetainCountToZero(this._store, k);
      // }

    } else if (this._refCount < 0) {
      if (false) {}
    }
  }

  isRetained() {
    return this._refCount > 0;
  }

  checkRefCount_INTERNAL() {
    if (Recoil_gkx('recoil_memory_managament_2020') && this._refCount <= 0) {
      if (false) {} // What we will ship later:
      // throw err(retainWarning);

    }
  }

  getStore_INTERNAL() {
    this.checkRefCount_INTERNAL();
    return this._store;
  }

  getID() {
    this.checkRefCount_INTERNAL();
    return this._store.getState().currentTree.stateID;
  }

  getStoreID() {
    this.checkRefCount_INTERNAL();
    return this._store.storeID;
  } // We want to allow the methods to be destructured and used as accessors

  /* eslint-disable fb-www/extra-arrow-initializer */

  /* eslint-enable fb-www/extra-arrow-initializer */


}

function cloneStoreState(store, treeState, bumpVersion = false) {
  const storeState = store.getState();
  const version = bumpVersion ? getNextTreeStateVersion$2() : treeState.version;
  return {
    // Always clone the TreeState to isolate stores from accidental mutations.
    // For example, reading a selector from a cloned snapshot shouldn't cache
    // in the original treestate which may cause the original to skip
    // initialization of upstream atoms.
    currentTree: {
      // TODO snapshots shouldn't really have versions because a new version number
      // is always assigned when the snapshot is gone to.
      version: bumpVersion ? version : treeState.version,
      stateID: bumpVersion ? version : treeState.stateID,
      transactionMetadata: { ...treeState.transactionMetadata
      },
      dirtyAtoms: new Set(treeState.dirtyAtoms),
      atomValues: treeState.atomValues.clone(),
      nonvalidatedAtoms: treeState.nonvalidatedAtoms.clone()
    },
    commitDepth: 0,
    nextTree: null,
    previousTree: null,
    knownAtoms: new Set(storeState.knownAtoms),
    // FIXME here's a copy
    knownSelectors: new Set(storeState.knownSelectors),
    // FIXME here's a copy
    transactionSubscriptions: new Map(),
    nodeTransactionSubscriptions: new Map(),
    nodeToComponentSubscriptions: new Map(),
    queuedComponentCallbacks_DEPRECATED: [],
    suspendedComponentResolvers: new Set(),
    graphsByVersion: new Map().set(version, store.getGraph(treeState.version)),
    retention: {
      referenceCounts: new Map(),
      nodesRetainedByZone: new Map(),
      retainablesToCheckForRelease: new Set()
    },
    // FIXME here's a copy
    // Create blank cleanup handlers for atoms so snapshots don't re-run
    // atom effects.
    nodeCleanupFunctions: new Map(Recoil_mapIterable(storeState.nodeCleanupFunctions.entries(), ([key]) => [key, () => {}]))
  };
} // Factory to build a fresh snapshot


function freshSnapshot(initializeState) {
  const snapshot = new Snapshot(makeEmptyStoreState$1());
  return initializeState != null ? snapshot.map(initializeState) : snapshot;
} // Factory to clone a snapshot state


const [memoizedCloneSnapshot, invalidateMemoizedSnapshot$2] = memoizeOneWithArgsHashAndInvalidation$1((store, version) => {
  var _storeState$nextTree;

  const storeState = store.getState();
  const treeState = version === 'latest' ? (_storeState$nextTree = storeState.nextTree) !== null && _storeState$nextTree !== void 0 ? _storeState$nextTree : storeState.currentTree : Recoil_nullthrows(storeState.previousTree);
  return new Snapshot(cloneStoreState(store, treeState), store.storeID);
}, (store, version) => {
  var _store$getState$nextT, _store$getState$previ;

  return String(version) + String(store.storeID) + String((_store$getState$nextT = store.getState().nextTree) === null || _store$getState$nextT === void 0 ? void 0 : _store$getState$nextT.version) + String(store.getState().currentTree.version) + String((_store$getState$previ = store.getState().previousTree) === null || _store$getState$previ === void 0 ? void 0 : _store$getState$previ.version);
}); // Avoid circular dependencies

setInvalidateMemoizedSnapshot$1(invalidateMemoizedSnapshot$2);

function cloneSnapshot(store, version = 'latest') {
  const snapshot = memoizedCloneSnapshot(store, version);

  if (!snapshot.isRetained()) {
    invalidateMemoizedSnapshot$2();
    return memoizedCloneSnapshot(store, version);
  }

  return snapshot;
}

class MutableSnapshot extends Snapshot {
  constructor(snapshot, batch) {
    super(cloneStoreState(snapshot.getStore_INTERNAL(), snapshot.getStore_INTERNAL().getState().currentTree, true), snapshot.getStoreID());

    _defineProperty(this, "_batch", void 0);

    _defineProperty(this, "set", (recoilState, newValueOrUpdater) => {
      this.checkRefCount_INTERNAL();
      const store = this.getStore_INTERNAL(); // This batchUpdates ensures this `set` is applied immediately and you can
      // read the written value after calling `set`. I would like to remove this
      // behavior and only batch in `Snapshot.map`, but this would be a breaking
      // change potentially.

      this._batch(() => {
        updateRetainCount$1(store, recoilState.key, 1);
        setRecoilValue$1(this.getStore_INTERNAL(), recoilState, newValueOrUpdater);
      });
    });

    _defineProperty(this, "reset", recoilState => {
      this.checkRefCount_INTERNAL();
      const store = this.getStore_INTERNAL(); // See note at `set` about batched updates.

      this._batch(() => {
        updateRetainCount$1(store, recoilState.key, 1);
        setRecoilValue$1(this.getStore_INTERNAL(), recoilState, DEFAULT_VALUE$1);
      });
    });

    _defineProperty(this, "setUnvalidatedAtomValues_DEPRECATED", values => {
      this.checkRefCount_INTERNAL();
      const store = this.getStore_INTERNAL(); // See note at `set` about batched updates.

      batchUpdates$1(() => {
        for (const [k, v] of values.entries()) {
          updateRetainCount$1(store, k, 1);
          setUnvalidatedRecoilValue$1(store, new AbstractRecoilValue$2(k), v);
        }
      });
    });

    this._batch = batch;
  }

}

var Recoil_Snapshot = {
  Snapshot,
  MutableSnapshot,
  freshSnapshot,
  cloneSnapshot
};

var Recoil_Snapshot_1 = Recoil_Snapshot.Snapshot;
var Recoil_Snapshot_2 = Recoil_Snapshot.MutableSnapshot;
var Recoil_Snapshot_3 = Recoil_Snapshot.freshSnapshot;
var Recoil_Snapshot_4 = Recoil_Snapshot.cloneSnapshot;

var Recoil_Snapshot$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  Snapshot: Recoil_Snapshot_1,
  MutableSnapshot: Recoil_Snapshot_2,
  freshSnapshot: Recoil_Snapshot_3,
  cloneSnapshot: Recoil_Snapshot_4
});

/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */

function unionSets(...sets) {
  const result = new Set();

  for (const set of sets) {
    for (const value of set) {
      result.add(value);
    }
  }

  return result;
}

var Recoil_unionSets = unionSets;

const {
  useRef
} = react;
/**
 * The same as `useRef()` except that if a function is specified then it will
 * call that function to get the value to initialize the reference with.
 * This is similar to how `useState()` behaves when given a function.  It allows
 * the user to avoid generating the initial value for subsequent renders.
 * The tradeoff is that to set the reference to a function itself you need to
 * nest it: useRefInitOnce(() => () => {...});
 */


function useRefInitOnce(initialValue) {
  // $FlowExpectedError[incompatible-call]
  const ref = useRef(initialValue);

  if (ref.current === initialValue && typeof initialValue === 'function') {
    // $FlowExpectedError[incompatible-use]
    ref.current = initialValue();
  }

  return ref;
}

var Recoil_useRefInitOnce = useRefInitOnce;

// @fb-only: const RecoilusagelogEvent = require('RecoilusagelogEvent');
// @fb-only: const RecoilUsageLogFalcoEvent = require('RecoilUsageLogFalcoEvent');
// @fb-only: const URI = require('URI');


const {
  getNextTreeStateVersion: getNextTreeStateVersion$3,
  makeEmptyStoreState: makeEmptyStoreState$2
} = Recoil_State;

const {
  cleanUpNode: cleanUpNode$2,
  getDownstreamNodes: getDownstreamNodes$2,
  initializeNode: initializeNode$2,
  setNodeValue: setNodeValue$2,
  setUnvalidatedAtomValue_DEPRECATED: setUnvalidatedAtomValue_DEPRECATED$1
} = Recoil_FunctionalCore;

const {
  graph: graph$2
} = Recoil_Graph;

const {
  cloneGraph: cloneGraph$1
} = Recoil_Graph;

const {
  getNextStoreID: getNextStoreID$2
} = Recoil_Keys;

const {
  createMutableSource: createMutableSource$1,
  reactMode: reactMode$2
} = Recoil_ReactMode;

const {
  applyAtomValueWrites: applyAtomValueWrites$1
} = Recoil_RecoilValueInterface;

const {
  releaseScheduledRetainablesNow: releaseScheduledRetainablesNow$1
} = Recoil_Retention;

const {
  freshSnapshot: freshSnapshot$1
} = Recoil_Snapshot$1;



const {
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useRef: useRef$1,
  useState
} = react;















function notInAContext() {
  throw Recoil_err('This component must be used inside a <RecoilRoot> component.');
}

const defaultStore = Object.freeze({
  storeID: getNextStoreID$2(),
  getState: notInAContext,
  replaceState: notInAContext,
  getGraph: notInAContext,
  subscribeToTransactions: notInAContext,
  addTransactionMetadata: notInAContext
});
let stateReplacerIsBeingExecuted = false;

function startNextTreeIfNeeded(store) {
  if (stateReplacerIsBeingExecuted) {
    throw Recoil_err('An atom update was triggered within the execution of a state updater function. State updater functions provided to Recoil must be pure functions.');
  }

  const storeState = store.getState();

  if (storeState.nextTree === null) {
    if (Recoil_gkx('recoil_memory_managament_2020') && Recoil_gkx('recoil_release_on_cascading_update_killswitch_2021')) {
      // If this is a cascading update (that is, rendering due to one state change
      // invokes a second state change), we won't have cleaned up retainables yet
      // because this normally happens after notifying components. Do it before
      // proceeding with the cascading update so that it remains predictable:
      if (storeState.commitDepth > 0) {
        releaseScheduledRetainablesNow$1(store);
      }
    }

    const version = storeState.currentTree.version;
    const nextVersion = getNextTreeStateVersion$3();
    storeState.nextTree = { ...storeState.currentTree,
      version: nextVersion,
      stateID: nextVersion,
      dirtyAtoms: new Set(),
      transactionMetadata: {}
    };
    storeState.graphsByVersion.set(nextVersion, cloneGraph$1(Recoil_nullthrows(storeState.graphsByVersion.get(version))));
  }
}

const AppContext = react.createContext({
  current: defaultStore
});

const useStoreRef = () => useContext(AppContext); // $FlowExpectedError[incompatible-call]


const MutableSourceContext = react.createContext(null);

function useRecoilMutableSource() {
  const mutableSource = useContext(MutableSourceContext);

  if (mutableSource == null) {
    Recoil_expectationViolation('Attempted to use a Recoil hook outside of a <RecoilRoot>. ' + '<RecoilRoot> must be an ancestor of any component that uses ' + 'Recoil hooks.');
  }

  return mutableSource;
}

function notifyComponents(store, storeState, treeState) {
  const dependentNodes = getDownstreamNodes$2(store, treeState, treeState.dirtyAtoms);

  for (const key of dependentNodes) {
    const comps = storeState.nodeToComponentSubscriptions.get(key);

    if (comps) {
      for (const [_subID, [_debugName, callback]] of comps) {
        callback(treeState);
      }
    }
  }
}

function sendEndOfBatchNotifications(store) {
  const storeState = store.getState();
  const treeState = storeState.currentTree; // Inform transaction subscribers of the transaction:

  const dirtyAtoms = treeState.dirtyAtoms;

  if (dirtyAtoms.size) {
    // Execute Node-specific subscribers before global subscribers
    for (const [key, subscriptions] of storeState.nodeTransactionSubscriptions) {
      if (dirtyAtoms.has(key)) {
        for (const [_, subscription] of subscriptions) {
          subscription(store);
        }
      }
    }

    for (const [_, subscription] of storeState.transactionSubscriptions) {
      subscription(store);
    }

    if (!reactMode$2().early || storeState.suspendedComponentResolvers.size > 0) {
      // Notifying components is needed to wake from suspense, even when using
      // early rendering.
      notifyComponents(store, storeState, treeState); // Wake all suspended components so the right one(s) can try to re-render.
      // We need to wake up components not just when some asynchronous selector
      // resolved, but also when changing synchronous values because this may cause
      // a selector to change from asynchronous to synchronous, in which case there
      // would be no follow-up asynchronous resolution to wake us up.
      // TODO OPTIMIZATION Only wake up related downstream components

      storeState.suspendedComponentResolvers.forEach(cb => cb());
      storeState.suspendedComponentResolvers.clear();
    }
  } // Special behavior ONLY invoked by useInterface.
  // FIXME delete queuedComponentCallbacks_DEPRECATED when deleting useInterface.


  storeState.queuedComponentCallbacks_DEPRECATED.forEach(cb => cb(treeState));
  storeState.queuedComponentCallbacks_DEPRECATED.splice(0, storeState.queuedComponentCallbacks_DEPRECATED.length);
}

function endBatch(store) {
  const storeState = store.getState();
  storeState.commitDepth++;

  try {
    const {
      nextTree
    } = storeState; // Ignore commits that are not because of Recoil transactions -- namely,
    // because something above RecoilRoot re-rendered:

    if (nextTree == null) {
      return;
    } // nextTree is now committed -- note that copying and reset occurs when
    // a transaction begins, in startNextTreeIfNeeded:


    storeState.previousTree = storeState.currentTree;
    storeState.currentTree = nextTree;
    storeState.nextTree = null;
    sendEndOfBatchNotifications(store);

    if (storeState.previousTree != null) {
      storeState.graphsByVersion.delete(storeState.previousTree.version);
    } else {
      Recoil_recoverableViolation('Ended batch with no previous state, which is unexpected', 'recoil');
    }

    storeState.previousTree = null;

    if (Recoil_gkx('recoil_memory_managament_2020')) {
      // Only release retainables if there were no writes during the end of the
      // batch.  This avoids releasing something we might be about to use.
      if (nextTree == null) {
        releaseScheduledRetainablesNow$1(store);
      }
    }
  } finally {
    storeState.commitDepth--;
  }
}
/*
 * The purpose of the Batcher is to observe when React batches end so that
 * Recoil state changes can be batched. Whenever Recoil state changes, we call
 * setState on the batcher. Then we wait for that change to be committed, which
 * signifies the end of the batch. That's when we respond to the Recoil change.
 */


function Batcher({
  setNotifyBatcherOfChange
}) {
  const storeRef = useStoreRef();
  const [, setState] = useState([]);
  setNotifyBatcherOfChange(() => setState({}));
  useEffect(() => {
    setNotifyBatcherOfChange(() => setState({})); // If an asynchronous selector resolves after the Batcher is unmounted,
    // notifyBatcherOfChange will still be called. An error gets thrown whenever
    // setState is called after a component is already unmounted, so this sets
    // notifyBatcherOfChange to be a no-op.

    return () => {
      setNotifyBatcherOfChange(() => {});
    };
  }, [setNotifyBatcherOfChange]);
  useEffect(() => {
    // enqueueExecution runs this function immediately; it is only used to
    // manipulate the order of useEffects during tests, since React seems to
    // call useEffect in an unpredictable order sometimes.
    Recoil_Queue.enqueueExecution('Batcher', () => {
      endBatch(storeRef.current);
    });
  });
  return null;
}

if (false) {} // When removing this deprecated function, remove stateBySettingRecoilValue
// which will no longer be needed.


function initialStoreState_DEPRECATED(store, initializeState) {
  const initial = makeEmptyStoreState$2();
  initializeState({
    set: (atom, value) => {
      const state = initial.currentTree;
      const writes = setNodeValue$2(store, state, atom.key, value);
      const writtenNodes = new Set(writes.keys());
      const nonvalidatedAtoms = state.nonvalidatedAtoms.clone();

      for (const n of writtenNodes) {
        nonvalidatedAtoms.delete(n);
      }

      initial.currentTree = { ...state,
        dirtyAtoms: Recoil_unionSets(state.dirtyAtoms, writtenNodes),
        atomValues: applyAtomValueWrites$1(state.atomValues, writes),
        // NB: PLEASE un-export applyAtomValueWrites when deleting this code
        nonvalidatedAtoms
      };
    },
    setUnvalidatedAtomValues: atomValues => {
      // FIXME replace this with a mutative loop
      atomValues.forEach((v, k) => {
        initial.currentTree = setUnvalidatedAtomValue_DEPRECATED$1(initial.currentTree, k, v);
      });
    }
  });
  return initial;
} // Initialize state snapshot for <RecoilRoot> for the initializeState prop.
// Atom effect initialization takes precedence over this prop.
// Any atom effects will be run before initialization, but then cleaned up,
// they are then re-run when used as part of rendering.  These semantics are
// compatible with React StrictMode where effects may be re-run multiple times
// but state initialization only happens once the first time.


function initialStoreState(initializeState) {
  // Initialize a snapshot and get its store
  const snapshot = freshSnapshot$1(initializeState);
  const storeState = snapshot.getStore_INTERNAL().getState(); // Counteract the snapshot auto-release

  snapshot.retain(); // Cleanup any effects run during initialization and clear the handlers so
  // they will re-initialize if used during rendering.  This allows atom effect
  // initialization to take precedence over initializeState and be compatible
  // with StrictMode semantics.

  storeState.nodeCleanupFunctions.forEach(cleanup => cleanup());
  storeState.nodeCleanupFunctions.clear();
  return storeState;
}

let nextID = 0;

function RecoilRoot_INTERNAL({
  initializeState_DEPRECATED,
  initializeState,
  store_INTERNAL: storeProp,
  // For use with React "context bridging"
  children
}) {
  // prettier-ignore
  // @fb-only: useEffect(() => {
  // @fb-only: if (gkx('recoil_usage_logging')) {
  // @fb-only: try {
  // @fb-only: RecoilUsageLogFalcoEvent.log(() => ({
  // @fb-only: type: RecoilusagelogEvent.RECOIL_ROOT_MOUNTED,
  // @fb-only: path: URI.getRequestURI().getPath(),
  // @fb-only: }));
  // @fb-only: } catch {
  // @fb-only: recoverableViolation(
  // @fb-only: 'Error when logging Recoil Usage event',
  // @fb-only: 'recoil',
  // @fb-only: );
  // @fb-only: }
  // @fb-only: }
  // @fb-only: }, []);
  let storeStateRef; // eslint-disable-line prefer-const

  const getGraph = version => {
    const graphs = storeStateRef.current.graphsByVersion;

    if (graphs.has(version)) {
      return Recoil_nullthrows(graphs.get(version));
    }

    const newGraph = graph$2();
    graphs.set(version, newGraph);
    return newGraph;
  };

  const subscribeToTransactions = (callback, key) => {
    if (key == null) {
      // Global transaction subscriptions
      const {
        transactionSubscriptions
      } = storeRef.current.getState();
      const id = nextID++;
      transactionSubscriptions.set(id, callback);
      return {
        release: () => {
          transactionSubscriptions.delete(id);
        }
      };
    } else {
      // Node-specific transaction subscriptions:
      const {
        nodeTransactionSubscriptions
      } = storeRef.current.getState();

      if (!nodeTransactionSubscriptions.has(key)) {
        nodeTransactionSubscriptions.set(key, new Map());
      }

      const id = nextID++;
      Recoil_nullthrows(nodeTransactionSubscriptions.get(key)).set(id, callback);
      return {
        release: () => {
          const subs = nodeTransactionSubscriptions.get(key);

          if (subs) {
            subs.delete(id);

            if (subs.size === 0) {
              nodeTransactionSubscriptions.delete(key);
            }
          }
        }
      };
    }
  };

  const addTransactionMetadata = metadata => {
    startNextTreeIfNeeded(storeRef.current);

    for (const k of Object.keys(metadata)) {
      Recoil_nullthrows(storeRef.current.getState().nextTree).transactionMetadata[k] = metadata[k];
    }
  };

  const replaceState = replacer => {
    startNextTreeIfNeeded(storeRef.current); // Use replacer to get the next state:

    const nextTree = Recoil_nullthrows(storeStateRef.current.nextTree);
    let replaced;

    try {
      stateReplacerIsBeingExecuted = true;
      replaced = replacer(nextTree);
    } finally {
      stateReplacerIsBeingExecuted = false;
    }

    if (replaced === nextTree) {
      return;
    }

    if (false) {} // Save changes to nextTree and schedule a React update:


    storeStateRef.current.nextTree = replaced;

    if (reactMode$2().early) {
      notifyComponents(storeRef.current, storeStateRef.current, replaced);
    }

    Recoil_nullthrows(notifyBatcherOfChange.current)();
  };

  const notifyBatcherOfChange = useRef$1(null);
  const setNotifyBatcherOfChange = useCallback(x => {
    notifyBatcherOfChange.current = x;
  }, [notifyBatcherOfChange]);
  const storeRef = Recoil_useRefInitOnce(() => storeProp !== null && storeProp !== void 0 ? storeProp : {
    storeID: getNextStoreID$2(),
    getState: () => storeStateRef.current,
    replaceState,
    getGraph,
    subscribeToTransactions,
    addTransactionMetadata
  });

  if (storeProp != null) {
    storeRef.current = storeProp;
  }

  storeStateRef = Recoil_useRefInitOnce(() => initializeState_DEPRECATED != null ? initialStoreState_DEPRECATED(storeRef.current, initializeState_DEPRECATED) : initializeState != null ? initialStoreState(initializeState) : makeEmptyStoreState$2());
  const mutableSource = useMemo(() => createMutableSource$1 === null || createMutableSource$1 === void 0 ? void 0 : createMutableSource$1(storeStateRef, () => storeStateRef.current.currentTree.version), [storeStateRef]); // Cleanup when the <RecoilRoot> is unmounted

  useEffect(() => {
    // React is free to call effect cleanup handlers and effects at will, the
    // deps array is only an optimization.  For example, React strict mode
    // will execute each effect twice for testing.  Therefore, we need symmetry
    // to re-initialize all known atoms after they were cleaned up.
    const store = storeRef.current;

    for (const atomKey of new Set(store.getState().knownAtoms)) {
      initializeNode$2(store, atomKey, 'get');
    }

    return () => {
      for (const atomKey of store.getState().knownAtoms) {
        cleanUpNode$2(store, atomKey);
      }
    };
  }, [storeRef]);
  return /*#__PURE__*/react.createElement(AppContext.Provider, {
    value: storeRef
  }, /*#__PURE__*/react.createElement(MutableSourceContext.Provider, {
    value: mutableSource
  }, /*#__PURE__*/react.createElement(Batcher, {
    setNotifyBatcherOfChange: setNotifyBatcherOfChange
  }), children));
}

function RecoilRoot(props) {
  const {
    override,
    ...propsExceptOverride
  } = props;
  const ancestorStoreRef = useStoreRef();

  if (override === false && ancestorStoreRef.current !== defaultStore) {
    // If ancestorStoreRef.current !== defaultStore, it means that this
    // RecoilRoot is not nested within another.
    return props.children;
  }

  return /*#__PURE__*/react.createElement(RecoilRoot_INTERNAL, propsExceptOverride);
}

function useRecoilStoreID() {
  return useStoreRef().current.storeID;
}

var Recoil_RecoilRoot = {
  RecoilRoot,
  useStoreRef,
  useRecoilMutableSource,
  useRecoilStoreID,
  notifyComponents_FOR_TESTING: notifyComponents,
  sendEndOfBatchNotifications_FOR_TESTING: sendEndOfBatchNotifications
};

/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */

function shallowArrayEqual(a, b) {
  if (a === b) {
    return true;
  }

  if (a.length !== b.length) {
    return false;
  }

  for (let i = 0, l = a.length; i < l; i++) {
    if (a[i] !== b[i]) {
      return false;
    }
  }

  return true;
}

var Recoil_shallowArrayEqual = shallowArrayEqual;

const {
  useEffect: useEffect$1,
  useRef: useRef$2
} = react;

function usePrevious(value) {
  const ref = useRef$2();
  useEffect$1(() => {
    ref.current = value;
  });
  return ref.current;
}

var Recoil_usePrevious = usePrevious;

const {
  useStoreRef: useStoreRef$1
} = Recoil_RecoilRoot;

const {
  SUSPENSE_TIMEOUT_MS: SUSPENSE_TIMEOUT_MS$1
} = Recoil_Retention;

const {
  updateRetainCount: updateRetainCount$2
} = Recoil_Retention;

const {
  RetentionZone: RetentionZone$3
} = Recoil_RetentionZone;

const {
  useEffect: useEffect$2,
  useRef: useRef$3
} = react;

const {
  isSSR: isSSR$2
} = Recoil_Environment;





 // I don't see a way to avoid the any type here because we want to accept readable
// and writable values with any type parameter, but normally with writable ones
// RecoilState<SomeT> is not a subtype of RecoilState<mixed>.


// flowlint-line unclear-type:off
function useRetain(toRetain) {
  if (!Recoil_gkx('recoil_memory_managament_2020')) {
    return;
  } // eslint-disable-next-line fb-www/react-hooks


  return useRetain_ACTUAL(toRetain);
}

function useRetain_ACTUAL(toRetain) {
  const array = Array.isArray(toRetain) ? toRetain : [toRetain];
  const retainables = array.map(a => a instanceof RetentionZone$3 ? a : a.key);
  const storeRef = useStoreRef$1();
  useEffect$2(() => {
    if (!Recoil_gkx('recoil_memory_managament_2020')) {
      return;
    }

    const store = storeRef.current;

    if (timeoutID.current && !isSSR$2) {
      // Already performed a temporary retain on render, simply cancel the release
      // of that temporary retain.
      window.clearTimeout(timeoutID.current);
      timeoutID.current = null;
    } else {
      for (const r of retainables) {
        updateRetainCount$2(store, r, 1);
      }
    }

    return () => {
      for (const r of retainables) {
        updateRetainCount$2(store, r, -1);
      }
    }; // eslint-disable-next-line fb-www/react-hooks-deps
  }, [storeRef, ...retainables]); // We want to retain if the component suspends. This is terrible but the Suspense
  // API affords us no better option. If we suspend and never commit after some
  // seconds, then release. The 'actual' retain/release in the effect above
  // cancels this.

  const timeoutID = useRef$3();
  const previousRetainables = Recoil_usePrevious(retainables);

  if (!isSSR$2 && (previousRetainables === undefined || !Recoil_shallowArrayEqual(previousRetainables, retainables))) {
    const store = storeRef.current;

    for (const r of retainables) {
      updateRetainCount$2(store, r, 1);
    }

    if (previousRetainables) {
      for (const r of previousRetainables) {
        updateRetainCount$2(store, r, -1);
      }
    }

    if (timeoutID.current) {
      window.clearTimeout(timeoutID.current);
    }

    timeoutID.current = window.setTimeout(() => {
      timeoutID.current = null;

      for (const r of retainables) {
        updateRetainCount$2(store, r, -1);
      }
    }, SUSPENSE_TIMEOUT_MS$1);
  }
}

var Recoil_useRetain = useRetain;

/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */
/**
 * THIS CODE HAS BEEN COMMENTED OUT INTENTIONALLY
 *
 * This technique of getting the component name is imperfect, since it both only
 * works in a non-minified code base, and more importantly introduces performance
 * problems since it relies in throwing errors which is an expensive operation.
 *
 * At some point we may want to reevaluate this technique hence why we have commented
 * this code out, rather than delete it all together.
 */
// const {useRef} = require('react');
// const gkx = require('recoil-shared/util/Recoil_gkx');
// const stackTraceParser = require('recoil-shared/util/Recoil_stackTraceParser');

function useComponentName() {
  // const nameRef = useRef();
  // if (__DEV__) {
  //   if (gkx('recoil_infer_component_names')) {
  //     if (nameRef.current === undefined) {
  //       // There is no blessed way to determine the calling React component from
  //       // within a hook. This hack uses the fact that hooks must start with 'use'
  //       // and that hooks are either called by React Components or other hooks. It
  //       // follows therefore, that to find the calling component, you simply need
  //       // to look down the stack and find the first function which doesn't start
  //       // with 'use'. We are only enabling this in dev for now, since once the
  //       // codebase is minified, the naming assumptions no longer hold true.
  //       // eslint-disable-next-line fb-www/no-new-error
  //       const frames = stackTraceParser(new Error().stack);
  //       for (const {methodName} of frames) {
  //         // I observed cases where the frame was of the form 'Object.useXXX'
  //         // hence why I'm searching for hooks following a word boundary
  //         if (!methodName.match(/\buse[^\b]+$/)) {
  //           return (nameRef.current = methodName);
  //         }
  //       }
  //       nameRef.current = null;
  //     }
  //     return nameRef.current ?? '<unable to determine component name>';
  //   }
  // }
  // @fb-only: return "<component name only available when both in dev mode and when passing GK 'recoil_infer_component_names'>";
  return '<component name not available>'; // @oss-only
}

var Recoil_useComponentName = useComponentName;

const {
  batchUpdates: batchUpdates$2
} = Recoil_Batching;

const {
  DEFAULT_VALUE: DEFAULT_VALUE$2
} = Recoil_Node;

const {
  currentRendererSupportsUseSyncExternalStore: currentRendererSupportsUseSyncExternalStore$1,
  reactMode: reactMode$3,
  useMutableSource: useMutableSource$1,
  useSyncExternalStore: useSyncExternalStore$1
} = Recoil_ReactMode;

const {
  useRecoilMutableSource: useRecoilMutableSource$1,
  useStoreRef: useStoreRef$2
} = Recoil_RecoilRoot;

const {
  isRecoilValue: isRecoilValue$2
} = Recoil_RecoilValue$1;

const {
  AbstractRecoilValue: AbstractRecoilValue$3,
  getRecoilValueAsLoadable: getRecoilValueAsLoadable$2,
  setRecoilValue: setRecoilValue$2,
  setUnvalidatedRecoilValue: setUnvalidatedRecoilValue$2,
  subscribeToRecoilValue: subscribeToRecoilValue$1
} = Recoil_RecoilValueInterface;



const {
  useCallback: useCallback$1,
  useEffect: useEffect$3,
  useMemo: useMemo$1,
  useRef: useRef$4,
  useState: useState$1
} = react;

const {
  setByAddingToSet: setByAddingToSet$2
} = Recoil_CopyOnWrite;













function handleLoadable(loadable, recoilValue, storeRef) {
  // We can't just throw the promise we are waiting on to Suspense.  If the
  // upstream dependencies change it may produce a state in which the component
  // can render, but it would still be suspended on a Promise that may never resolve.
  if (loadable.state === 'hasValue') {
    return loadable.contents;
  } else if (loadable.state === 'loading') {
    const promise = new Promise(resolve => {
      storeRef.current.getState().suspendedComponentResolvers.add(resolve);
    }); // $FlowExpectedError Flow(prop-missing) for integrating with tools that inspect thrown promises @fb-only
    // @fb-only: promise.displayName = `Recoil State: ${recoilValue.key}`;

    throw promise;
  } else if (loadable.state === 'hasError') {
    throw loadable.contents;
  } else {
    throw Recoil_err(`Invalid value of loadable atom "${recoilValue.key}"`);
  }
}

function validateRecoilValue(recoilValue, hookName) {
  if (!isRecoilValue$2(recoilValue)) {
    throw Recoil_err(`Invalid argument to ${hookName}: expected an atom or selector but got ${String(recoilValue)}`);
  }
}

/**
 * Various things are broken with useRecoilInterface, particularly concurrent
 * mode, React strict mode, and memory management. They will not be fixed.
 * */
function useRecoilInterface_DEPRECATED() {
  const componentName = Recoil_useComponentName();
  const storeRef = useStoreRef$2(); // eslint-disable-next-line fb-www/react-no-unused-state-hook

  const [, forceUpdate] = useState$1([]);
  const recoilValuesUsed = useRef$4(new Set());
  recoilValuesUsed.current = new Set(); // Track the RecoilValues used just during this render

  const previousSubscriptions = useRef$4(new Set());
  const subscriptions = useRef$4(new Map());
  const unsubscribeFrom = useCallback$1(key => {
    const sub = subscriptions.current.get(key);

    if (sub) {
      sub.release();
      subscriptions.current.delete(key);
    }
  }, [subscriptions]);
  const updateState = useCallback$1((_state, key) => {
    if (subscriptions.current.has(key)) {
      forceUpdate([]);
    }
  }, []); // Effect to add/remove subscriptions as nodes are used

  useEffect$3(() => {
    const store = storeRef.current;
    Recoil_differenceSets(recoilValuesUsed.current, previousSubscriptions.current).forEach(key => {
      if (subscriptions.current.has(key)) {
        Recoil_expectationViolation(`Double subscription to RecoilValue "${key}"`);
        return;
      }

      const sub = subscribeToRecoilValue$1(store, new AbstractRecoilValue$3(key), state => updateState(state, key), componentName);
      subscriptions.current.set(key, sub);
      /**
       * Since we're subscribing in an effect we need to update to the latest
       * value of the atom since it may have changed since we rendered. We can
       * go ahead and do that now, unless we're in the middle of a batch --
       * in which case we should do it at the end of the batch, due to the
       * following edge case: Suppose an atom is updated in another useEffect
       * of this same component. Then the following sequence of events occur:
       * 1. Atom is updated and subs fired (but we may not be subscribed
       *    yet depending on order of effects, so we miss this) Updated value
       *    is now in nextTree, but not currentTree.
       * 2. This effect happens. We subscribe and update.
       * 3. From the update we re-render and read currentTree, with old value.
       * 4. Batcher's effect sets currentTree to nextTree.
       * In this sequence we miss the update. To avoid that, add the update
       * to queuedComponentCallback if a batch is in progress.
       */
      // FIXME delete queuedComponentCallbacks_DEPRECATED when deleting useInterface.

      const state = store.getState();

      if (state.nextTree) {
        store.getState().queuedComponentCallbacks_DEPRECATED.push(() => {
          updateState(store.getState(), key);
        });
      } else {
        updateState(store.getState(), key);
      }
    });
    Recoil_differenceSets(previousSubscriptions.current, recoilValuesUsed.current).forEach(key => {
      unsubscribeFrom(key);
    });
    previousSubscriptions.current = recoilValuesUsed.current;
  }); // Effect to unsubscribe from all when unmounting

  useEffect$3(() => {
    const currentSubscriptions = subscriptions.current; // Restore subscriptions that were cleared due to StrictMode running this effect twice

    Recoil_differenceSets(recoilValuesUsed.current, new Set(currentSubscriptions.keys())).forEach(key => {
      const sub = subscribeToRecoilValue$1(storeRef.current, new AbstractRecoilValue$3(key), state => updateState(state, key), componentName);
      currentSubscriptions.set(key, sub);
    });
    return () => currentSubscriptions.forEach((_, key) => unsubscribeFrom(key));
  }, [componentName, storeRef, unsubscribeFrom, updateState]);
  return useMemo$1(() => {
    // eslint-disable-next-line no-shadow
    function useSetRecoilState(recoilState) {
      if (false) {}

      return newValueOrUpdater => {
        setRecoilValue$2(storeRef.current, recoilState, newValueOrUpdater);
      };
    } // eslint-disable-next-line no-shadow


    function useResetRecoilState(recoilState) {
      if (false) {}

      return () => setRecoilValue$2(storeRef.current, recoilState, DEFAULT_VALUE$2);
    } // eslint-disable-next-line no-shadow


    function useRecoilValueLoadable(recoilValue) {
      var _storeState$nextTree;

      if (false) {}

      if (!recoilValuesUsed.current.has(recoilValue.key)) {
        recoilValuesUsed.current = setByAddingToSet$2(recoilValuesUsed.current, recoilValue.key);
      } // TODO Restore optimization to memoize lookup


      const storeState = storeRef.current.getState();
      return getRecoilValueAsLoadable$2(storeRef.current, recoilValue, reactMode$3().early ? (_storeState$nextTree = storeState.nextTree) !== null && _storeState$nextTree !== void 0 ? _storeState$nextTree : storeState.currentTree : storeState.currentTree);
    } // eslint-disable-next-line no-shadow


    function useRecoilValue(recoilValue) {
      if (false) {}

      const loadable = useRecoilValueLoadable(recoilValue);
      return handleLoadable(loadable, recoilValue, storeRef);
    } // eslint-disable-next-line no-shadow


    function useRecoilState(recoilState) {
      if (false) {}

      return [useRecoilValue(recoilState), useSetRecoilState(recoilState)];
    } // eslint-disable-next-line no-shadow


    function useRecoilStateLoadable(recoilState) {
      if (false) {}

      return [useRecoilValueLoadable(recoilState), useSetRecoilState(recoilState)];
    }

    return {
      getRecoilValue: useRecoilValue,
      getRecoilValueLoadable: useRecoilValueLoadable,
      getRecoilState: useRecoilState,
      getRecoilStateLoadable: useRecoilStateLoadable,
      getSetRecoilState: useSetRecoilState,
      getResetRecoilState: useResetRecoilState
    };
  }, [recoilValuesUsed, storeRef]);
}

const recoilComponentGetRecoilValueCount_FOR_TESTING = {
  current: 0
};

function useRecoilValueLoadable_SYNC_EXTERNAL_STORE(recoilValue) {
  const storeRef = useStoreRef$2();
  const componentName = Recoil_useComponentName();
  const getSnapshot = useCallback$1(() => {
    var _storeState$nextTree2;

    if (false) {}

    const store = storeRef.current;
    const storeState = store.getState();
    const treeState = reactMode$3().early ? (_storeState$nextTree2 = storeState.nextTree) !== null && _storeState$nextTree2 !== void 0 ? _storeState$nextTree2 : storeState.currentTree : storeState.currentTree;
    const loadable = getRecoilValueAsLoadable$2(store, recoilValue, treeState);
    return {
      loadable,
      key: recoilValue.key
    };
  }, [storeRef, recoilValue]); // Memoize the state to avoid unnecessary rerenders

  const memoizePreviousSnapshot = useCallback$1(getState => {
    let prevState;
    return () => {
      var _prevState, _prevState2;

      const nextState = getState();

      if ((_prevState = prevState) !== null && _prevState !== void 0 && _prevState.loadable.is(nextState.loadable) && ((_prevState2 = prevState) === null || _prevState2 === void 0 ? void 0 : _prevState2.key) === nextState.key) {
        return prevState;
      }

      prevState = nextState;
      return nextState;
    };
  }, []);
  const getMemoizedSnapshot = useMemo$1(() => memoizePreviousSnapshot(getSnapshot), [getSnapshot, memoizePreviousSnapshot]);
  const subscribe = useCallback$1(notify => {
    const store = storeRef.current;
    const subscription = subscribeToRecoilValue$1(store, recoilValue, notify, componentName);
    return subscription.release;
  }, [storeRef, recoilValue, componentName]);
  return useSyncExternalStore$1(subscribe, getMemoizedSnapshot, // getSnapshot()
  getMemoizedSnapshot // getServerSnapshot() for SSR support
  ).loadable;
}

function useRecoilValueLoadable_MUTABLE_SOURCE(recoilValue) {
  const storeRef = useStoreRef$2();
  const getLoadable = useCallback$1(() => {
    var _storeState$nextTree3;

    const store = storeRef.current;
    const storeState = store.getState();
    const treeState = reactMode$3().early ? (_storeState$nextTree3 = storeState.nextTree) !== null && _storeState$nextTree3 !== void 0 ? _storeState$nextTree3 : storeState.currentTree : storeState.currentTree;
    return getRecoilValueAsLoadable$2(store, recoilValue, treeState);
  }, [storeRef, recoilValue]);
  const getLoadableWithTesting = useCallback$1(() => {
    if (false) {}

    return getLoadable();
  }, [getLoadable]);
  const componentName = Recoil_useComponentName();
  const subscribe = useCallback$1((_storeState, notify) => {
    const store = storeRef.current;
    const subscription = subscribeToRecoilValue$1(store, recoilValue, () => {
      if (!Recoil_gkx('recoil_suppress_rerender_in_callback')) {
        return notify();
      } // Only re-render if the value has changed.
      // This will evaluate the atom/selector now as well as when the
      // component renders, but that may help with prefetching.


      const newLoadable = getLoadable();

      if (!prevLoadableRef.current.is(newLoadable)) {
        notify();
      } // If the component is suspended then the effect setting prevLoadableRef
      // will not run.  So, set the previous value here when its subscription
      // is fired to wake it up.  We can't just rely on this, though, because
      // this only executes when an atom/selector is dirty and the atom/selector
      // passed to the hook can dynamically change.


      prevLoadableRef.current = newLoadable;
    }, componentName);
    return subscription.release;
  }, [storeRef, recoilValue, componentName, getLoadable]);
  const source = useRecoilMutableSource$1();

  if (source == null) {
    throw Recoil_err('Recoil hooks must be used in components contained within a <RecoilRoot> component.');
  }

  const loadable = useMutableSource$1(source, getLoadableWithTesting, subscribe);
  const prevLoadableRef = useRef$4(loadable);
  useEffect$3(() => {
    prevLoadableRef.current = loadable;
  });
  return loadable;
}

function useRecoilValueLoadable_TRANSITION_SUPPORT(recoilValue) {
  const storeRef = useStoreRef$2();
  const componentName = Recoil_useComponentName(); // Accessors to get the current state

  const getLoadable = useCallback$1(() => {
    var _storeState$nextTree4;

    if (false) {}

    const store = storeRef.current;
    const storeState = store.getState();
    const treeState = reactMode$3().early ? (_storeState$nextTree4 = storeState.nextTree) !== null && _storeState$nextTree4 !== void 0 ? _storeState$nextTree4 : storeState.currentTree : storeState.currentTree;
    return getRecoilValueAsLoadable$2(store, recoilValue, treeState);
  }, [storeRef, recoilValue]);
  const getState = useCallback$1(() => ({
    loadable: getLoadable(),
    key: recoilValue.key
  }), [getLoadable, recoilValue.key]); // Memoize state snapshots

  const updateState = useCallback$1(prevState => {
    const nextState = getState();
    return prevState.loadable.is(nextState.loadable) && prevState.key === nextState.key ? prevState : nextState;
  }, [getState]); // Subscribe to Recoil state changes

  useEffect$3(() => {
    const subscription = subscribeToRecoilValue$1(storeRef.current, recoilValue, _state => {
      setState(updateState);
    }, componentName); // Update state in case we are using a different key

    setState(updateState);
    return subscription.release;
  }, [componentName, recoilValue, storeRef, updateState]); // Get the current state

  const [state, setState] = useState$1(getState); // If we changed keys, then return the state for the new key.
  // This is important in case the old key would cause the component to suspend.
  // We don't have to set the new state here since the subscribing effect above
  // will do that.

  return state.key !== recoilValue.key ? getState().loadable : state.loadable;
}

function useRecoilValueLoadable_LEGACY(recoilValue) {
  const storeRef = useStoreRef$2(); // eslint-disable-next-line fb-www/react-no-unused-state-hook

  const [, forceUpdate] = useState$1([]);
  const componentName = Recoil_useComponentName();
  const getLoadable = useCallback$1(() => {
    var _storeState$nextTree5;

    if (false) {}

    const store = storeRef.current;
    const storeState = store.getState();
    const treeState = reactMode$3().early ? (_storeState$nextTree5 = storeState.nextTree) !== null && _storeState$nextTree5 !== void 0 ? _storeState$nextTree5 : storeState.currentTree : storeState.currentTree;
    return getRecoilValueAsLoadable$2(store, recoilValue, treeState);
  }, [storeRef, recoilValue]);
  const loadable = getLoadable();
  const prevLoadableRef = useRef$4(loadable);
  useEffect$3(() => {
    prevLoadableRef.current = loadable;
  });
  useEffect$3(() => {
    const store = storeRef.current;
    const storeState = store.getState();
    const subscription = subscribeToRecoilValue$1(store, recoilValue, _state => {
      var _prevLoadableRef$curr;

      if (!Recoil_gkx('recoil_suppress_rerender_in_callback')) {
        return forceUpdate([]);
      }

      const newLoadable = getLoadable();

      if (!((_prevLoadableRef$curr = prevLoadableRef.current) !== null && _prevLoadableRef$curr !== void 0 && _prevLoadableRef$curr.is(newLoadable))) {
        forceUpdate(newLoadable);
      }

      prevLoadableRef.current = newLoadable;
    }, componentName);
    /**
     * Since we're subscribing in an effect we need to update to the latest
     * value of the atom since it may have changed since we rendered. We can
     * go ahead and do that now, unless we're in the middle of a batch --
     * in which case we should do it at the end of the batch, due to the
     * following edge case: Suppose an atom is updated in another useEffect
     * of this same component. Then the following sequence of events occur:
     * 1. Atom is updated and subs fired (but we may not be subscribed
     *    yet depending on order of effects, so we miss this) Updated value
     *    is now in nextTree, but not currentTree.
     * 2. This effect happens. We subscribe and update.
     * 3. From the update we re-render and read currentTree, with old value.
     * 4. Batcher's effect sets currentTree to nextTree.
     * In this sequence we miss the update. To avoid that, add the update
     * to queuedComponentCallback if a batch is in progress.
     */

    if (storeState.nextTree) {
      store.getState().queuedComponentCallbacks_DEPRECATED.push(() => {
        prevLoadableRef.current = null;
        forceUpdate([]);
      });
    } else {
      var _prevLoadableRef$curr2;

      if (!Recoil_gkx('recoil_suppress_rerender_in_callback')) {
        return forceUpdate([]);
      }

      const newLoadable = getLoadable();

      if (!((_prevLoadableRef$curr2 = prevLoadableRef.current) !== null && _prevLoadableRef$curr2 !== void 0 && _prevLoadableRef$curr2.is(newLoadable))) {
        forceUpdate(newLoadable);
      }

      prevLoadableRef.current = newLoadable;
    }

    return subscription.release;
  }, [componentName, getLoadable, recoilValue, storeRef]);
  return loadable;
}
/**
  Like useRecoilValue(), but either returns the value if available or
  just undefined if not available for any reason, such as pending or error.
*/


function useRecoilValueLoadable(recoilValue) {
  if (false) {}

  if (Recoil_gkx('recoil_memory_managament_2020')) {
    // eslint-disable-next-line fb-www/react-hooks
    Recoil_useRetain(recoilValue);
  }

  return {
    TRANSITION_SUPPORT: useRecoilValueLoadable_TRANSITION_SUPPORT,
    // Recoil will attemp to detect if `useSyncExternalStore()` is supported with
    // `reactMode()` before calling it.  However, sometimes the host React
    // environment supports it but uses additional React renderers (such as with
    // `react-three-fiber`) which do not.  While this is technically a user issue
    // by using a renderer with React 18+ that doesn't fully support React 18 we
    // don't want to break users if it can be avoided. As the current renderer can
    // change at runtime, we need to dynamically check and fallback if necessary.
    SYNC_EXTERNAL_STORE: currentRendererSupportsUseSyncExternalStore$1() ? useRecoilValueLoadable_SYNC_EXTERNAL_STORE : useRecoilValueLoadable_TRANSITION_SUPPORT,
    MUTABLE_SOURCE: useRecoilValueLoadable_MUTABLE_SOURCE,
    LEGACY: useRecoilValueLoadable_LEGACY
  }[reactMode$3().mode](recoilValue);
}
/**
  Returns the value represented by the RecoilValue.
  If the value is pending, it will throw a Promise to suspend the component,
  if the value is an error it will throw it for the nearest React error boundary.
  This will also subscribe the component for any updates in the value.
  */


function useRecoilValue(recoilValue) {
  if (false) {}

  const storeRef = useStoreRef$2();
  const loadable = useRecoilValueLoadable(recoilValue);
  return handleLoadable(loadable, recoilValue, storeRef);
}
/**
  Returns a function that allows the value of a RecoilState to be updated, but does
  not subscribe the component to changes to that RecoilState.
*/


function useSetRecoilState(recoilState) {
  if (false) {}

  const storeRef = useStoreRef$2();
  return useCallback$1(newValueOrUpdater => {
    setRecoilValue$2(storeRef.current, recoilState, newValueOrUpdater);
  }, [storeRef, recoilState]);
}
/**
  Returns a function that will reset the value of a RecoilState to its default
*/


function useResetRecoilState(recoilState) {
  if (false) {}

  const storeRef = useStoreRef$2();
  return useCallback$1(() => {
    setRecoilValue$2(storeRef.current, recoilState, DEFAULT_VALUE$2);
  }, [storeRef, recoilState]);
}
/**
  Equivalent to useState(). Allows the value of the RecoilState to be read and written.
  Subsequent updates to the RecoilState will cause the component to re-render. If the
  RecoilState is pending, this will suspend the component and initiate the
  retrieval of the value. If evaluating the RecoilState resulted in an error, this will
  throw the error so that the nearest React error boundary can catch it.
*/


function useRecoilState(recoilState) {
  if (false) {}

  return [useRecoilValue(recoilState), useSetRecoilState(recoilState)];
}
/**
  Like useRecoilState(), but does not cause Suspense or React error handling. Returns
  an object that indicates whether the RecoilState is available, pending, or
  unavailable due to an error.
*/


function useRecoilStateLoadable(recoilState) {
  if (false) {}

  return [useRecoilValueLoadable(recoilState), useSetRecoilState(recoilState)];
}

function useSetUnvalidatedAtomValues() {
  const storeRef = useStoreRef$2();
  return (values, transactionMetadata = {}) => {
    batchUpdates$2(() => {
      storeRef.current.addTransactionMetadata(transactionMetadata);
      values.forEach((value, key) => setUnvalidatedRecoilValue$2(storeRef.current, new AbstractRecoilValue$3(key), value));
    });
  };
}
/**
 * Experimental variants of hooks with support for useTransition()
 */


function useRecoilValueLoadable_TRANSITION_SUPPORT_UNSTABLE(recoilValue) {
  if (false) {}

  if (Recoil_gkx('recoil_memory_managament_2020')) {
    // eslint-disable-next-line fb-www/react-hooks
    Recoil_useRetain(recoilValue);
  }

  return useRecoilValueLoadable_TRANSITION_SUPPORT(recoilValue);
}

function useRecoilValue_TRANSITION_SUPPORT_UNSTABLE(recoilValue) {
  if (false) {}

  const storeRef = useStoreRef$2();
  const loadable = useRecoilValueLoadable_TRANSITION_SUPPORT_UNSTABLE(recoilValue);
  return handleLoadable(loadable, recoilValue, storeRef);
}

function useRecoilState_TRANSITION_SUPPORT_UNSTABLE(recoilState) {
  if (false) {}

  return [useRecoilValue_TRANSITION_SUPPORT_UNSTABLE(recoilState), useSetRecoilState(recoilState)];
}

var Recoil_Hooks = {
  recoilComponentGetRecoilValueCount_FOR_TESTING,
  useRecoilInterface: useRecoilInterface_DEPRECATED,
  useRecoilState,
  useRecoilStateLoadable,
  useRecoilValue,
  useRecoilValueLoadable,
  useResetRecoilState,
  useSetRecoilState,
  useSetUnvalidatedAtomValues,
  useRecoilValueLoadable_TRANSITION_SUPPORT_UNSTABLE,
  useRecoilValue_TRANSITION_SUPPORT_UNSTABLE,
  useRecoilState_TRANSITION_SUPPORT_UNSTABLE
};

/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */
/**
 * Returns a map containing all of the keys + values from the original map where
 * the given callback returned true.
 */

function filterMap(map, callback) {
  const result = new Map();

  for (const [key, value] of map) {
    if (callback(value, key)) {
      result.set(key, value);
    }
  }

  return result;
}

var Recoil_filterMap = filterMap;

/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */
/**
 * Returns a set containing all of the values from the original set where
 * the given callback returned true.
 */

function filterSet(set, callback) {
  const result = new Set();

  for (const value of set) {
    if (callback(value)) {
      result.add(value);
    }
  }

  return result;
}

var Recoil_filterSet = filterSet;

/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */

function mergeMaps(...maps) {
  const result = new Map();

  for (let i = 0; i < maps.length; i++) {
    const iterator = maps[i].keys();
    let nextKey;

    while (!(nextKey = iterator.next()).done) {
      // $FlowIssue[incompatible-call] - map/iterator knows nothing about flow types
      result.set(nextKey.value, maps[i].get(nextKey.value));
    }
  }

  return result;
}

var Recoil_mergeMaps = mergeMaps;

const {
  batchUpdates: batchUpdates$3
} = Recoil_Batching;

const {
  DEFAULT_VALUE: DEFAULT_VALUE$3,
  getNode: getNode$4,
  nodes: nodes$1
} = Recoil_Node;

const {
  useStoreRef: useStoreRef$3
} = Recoil_RecoilRoot;

const {
  AbstractRecoilValue: AbstractRecoilValue$4,
  setRecoilValueLoadable: setRecoilValueLoadable$1
} = Recoil_RecoilValueInterface;

const {
  SUSPENSE_TIMEOUT_MS: SUSPENSE_TIMEOUT_MS$2
} = Recoil_Retention;

const {
  cloneSnapshot: cloneSnapshot$1
} = Recoil_Snapshot$1;

const {
  useCallback: useCallback$2,
  useEffect: useEffect$4,
  useRef: useRef$5,
  useState: useState$2
} = react;

const {
  isSSR: isSSR$3
} = Recoil_Environment;















function useTransactionSubscription(callback) {
  const storeRef = useStoreRef$3();
  useEffect$4(() => {
    const sub = storeRef.current.subscribeToTransactions(callback);
    return sub.release;
  }, [callback, storeRef]);
}

function externallyVisibleAtomValuesInState(state) {
  const atomValues = state.atomValues.toMap();
  const persistedAtomContentsValues = Recoil_mapMap(Recoil_filterMap(atomValues, (v, k) => {
    const node = getNode$4(k);
    const persistence = node.persistence_UNSTABLE;
    return persistence != null && persistence.type !== 'none' && v.state === 'hasValue';
  }), v => v.contents); // Merge in nonvalidated atoms; we may not have defs for them but they will
  // all have persistence on or they wouldn't be there in the first place.

  return Recoil_mergeMaps(state.nonvalidatedAtoms.toMap(), persistedAtomContentsValues);
}

/**
  Calls the given callback after any atoms have been modified and the consequent
  component re-renders have been committed. This is intended for persisting
  the values of the atoms to storage. The stored values can then be restored
  using the useSetUnvalidatedAtomValues hook.

  The callback receives the following info:

  atomValues: The current value of every atom that is both persistable (persistence
              type not set to 'none') and whose value is available (not in an
              error or loading state).

  previousAtomValues: The value of every persistable and available atom before
               the transaction began.

  atomInfo: A map containing the persistence settings for each atom. Every key
            that exists in atomValues will also exist in atomInfo.

  modifiedAtoms: The set of atoms that were written to during the transaction.

  transactionMetadata: Arbitrary information that was added via the
          useSetUnvalidatedAtomValues hook. Useful for ignoring the useSetUnvalidatedAtomValues
          transaction, to avoid loops.
*/
function useTransactionObservation_DEPRECATED(callback) {
  useTransactionSubscription(useCallback$2(store => {
    let previousTree = store.getState().previousTree;
    const currentTree = store.getState().currentTree;

    if (!previousTree) {
      Recoil_recoverableViolation('Transaction subscribers notified without a previous tree being present -- this is a bug in Recoil');
      previousTree = store.getState().currentTree; // attempt to trundle on
    }

    const atomValues = externallyVisibleAtomValuesInState(currentTree);
    const previousAtomValues = externallyVisibleAtomValuesInState(previousTree);
    const atomInfo = Recoil_mapMap(nodes$1, node => {
      var _node$persistence_UNS, _node$persistence_UNS2, _node$persistence_UNS3, _node$persistence_UNS4;

      return {
        persistence_UNSTABLE: {
          type: (_node$persistence_UNS = (_node$persistence_UNS2 = node.persistence_UNSTABLE) === null || _node$persistence_UNS2 === void 0 ? void 0 : _node$persistence_UNS2.type) !== null && _node$persistence_UNS !== void 0 ? _node$persistence_UNS : 'none',
          backButton: (_node$persistence_UNS3 = (_node$persistence_UNS4 = node.persistence_UNSTABLE) === null || _node$persistence_UNS4 === void 0 ? void 0 : _node$persistence_UNS4.backButton) !== null && _node$persistence_UNS3 !== void 0 ? _node$persistence_UNS3 : false
        }
      };
    }); // Filter on existance in atomValues so that externally-visible rules
    // are also applied to modified atoms (specifically exclude selectors):

    const modifiedAtoms = Recoil_filterSet(currentTree.dirtyAtoms, k => atomValues.has(k) || previousAtomValues.has(k));
    callback({
      atomValues,
      previousAtomValues,
      atomInfo,
      modifiedAtoms,
      transactionMetadata: { ...currentTree.transactionMetadata
      }
    });
  }, [callback]));
}

function useRecoilTransactionObserver(callback) {
  useTransactionSubscription(useCallback$2(store => {
    const snapshot = cloneSnapshot$1(store, 'latest');
    const previousSnapshot = cloneSnapshot$1(store, 'previous');
    callback({
      snapshot,
      previousSnapshot
    });
  }, [callback]));
} // Return a snapshot of the current state and subscribe to all state changes


function useRecoilSnapshot() {
  const storeRef = useStoreRef$3();
  const [snapshot, setSnapshot] = useState$2(() => cloneSnapshot$1(storeRef.current));
  const previousSnapshot = Recoil_usePrevious(snapshot);
  const timeoutID = useRef$5();
  const releaseRef = useRef$5();
  useTransactionSubscription(useCallback$2(store => setSnapshot(cloneSnapshot$1(store)), [])); // Retain snapshot for duration component is mounted

  useEffect$4(() => {
    const release = snapshot.retain(); // Release the retain from the rendering call

    if (timeoutID.current && !isSSR$3) {
      var _releaseRef$current;

      window.clearTimeout(timeoutID.current);
      timeoutID.current = null;
      (_releaseRef$current = releaseRef.current) === null || _releaseRef$current === void 0 ? void 0 : _releaseRef$current.call(releaseRef);
      releaseRef.current = null;
    }

    return () => {
      // Defer the release.  If "Fast Refresh"" is used then the component may
      // re-render with the same state.  The previous cleanup will then run and
      // then the new effect will run. We don't want the snapshot to be released
      // by that cleanup before the new effect has a chance to retain it again.
      // Use timeout of 10 to workaround Firefox issue: https://github.com/facebookexperimental/Recoil/issues/1936
      window.setTimeout(release, 10);
    };
  }, [snapshot]); // Retain snapshot until above effect is run.
  // Release after a threshold in case component is suspended.

  if (previousSnapshot !== snapshot && !isSSR$3) {
    // Release the previous snapshot
    if (timeoutID.current) {
      var _releaseRef$current2;

      window.clearTimeout(timeoutID.current);
      timeoutID.current = null;
      (_releaseRef$current2 = releaseRef.current) === null || _releaseRef$current2 === void 0 ? void 0 : _releaseRef$current2.call(releaseRef);
      releaseRef.current = null;
    }

    releaseRef.current = snapshot.retain();
    timeoutID.current = window.setTimeout(() => {
      var _releaseRef$current3;

      timeoutID.current = null;
      (_releaseRef$current3 = releaseRef.current) === null || _releaseRef$current3 === void 0 ? void 0 : _releaseRef$current3.call(releaseRef);
      releaseRef.current = null;
    }, SUSPENSE_TIMEOUT_MS$2);
  }

  return snapshot;
}

function gotoSnapshot(store, snapshot) {
  var _storeState$nextTree;

  const storeState = store.getState();
  const prev = (_storeState$nextTree = storeState.nextTree) !== null && _storeState$nextTree !== void 0 ? _storeState$nextTree : storeState.currentTree;
  const next = snapshot.getStore_INTERNAL().getState().currentTree;
  batchUpdates$3(() => {
    const keysToUpdate = new Set();

    for (const keys of [prev.atomValues.keys(), next.atomValues.keys()]) {
      for (const key of keys) {
        var _prev$atomValues$get, _next$atomValues$get;

        if (((_prev$atomValues$get = prev.atomValues.get(key)) === null || _prev$atomValues$get === void 0 ? void 0 : _prev$atomValues$get.contents) !== ((_next$atomValues$get = next.atomValues.get(key)) === null || _next$atomValues$get === void 0 ? void 0 : _next$atomValues$get.contents) && getNode$4(key).shouldRestoreFromSnapshots) {
          keysToUpdate.add(key);
        }
      }
    }

    keysToUpdate.forEach(key => {
      setRecoilValueLoadable$1(store, new AbstractRecoilValue$4(key), next.atomValues.has(key) ? Recoil_nullthrows(next.atomValues.get(key)) : DEFAULT_VALUE$3);
    });
    store.replaceState(state => ({ ...state,
      stateID: snapshot.getID()
    }));
  });
}

function useGotoRecoilSnapshot() {
  const storeRef = useStoreRef$3();
  return useCallback$2(snapshot => gotoSnapshot(storeRef.current, snapshot), [storeRef]);
}

var Recoil_SnapshotHooks = {
  useRecoilSnapshot,
  gotoSnapshot,
  useGotoRecoilSnapshot,
  useRecoilTransactionObserver,
  useTransactionObservation_DEPRECATED,
  useTransactionSubscription_DEPRECATED: useTransactionSubscription
};

const {
  peekNodeInfo: peekNodeInfo$2
} = Recoil_FunctionalCore;

const {
  useStoreRef: useStoreRef$4
} = Recoil_RecoilRoot;

function useGetRecoilValueInfo() {
  const storeRef = useStoreRef$4();
  return ({
    key
  }) => peekNodeInfo$2(storeRef.current, storeRef.current.getState().currentTree, key);
}

var Recoil_useGetRecoilValueInfo = useGetRecoilValueInfo;

const {
  reactMode: reactMode$4
} = Recoil_ReactMode;

const {
  RecoilRoot: RecoilRoot$1,
  useStoreRef: useStoreRef$5
} = Recoil_RecoilRoot;



const {
  useMemo: useMemo$2
} = react;

function useRecoilBridgeAcrossReactRoots() {
  // The test fails when using useMutableSource(), but only if act() is used
  // for the nested root.  So, this may only be a testing environment issue.
  if (reactMode$4().mode === 'MUTABLE_SOURCE') {
    // eslint-disable-next-line fb-www/no-console
    console.warn('Warning: There are known issues using useRecoilBridgeAcrossReactRoots() in recoil_mutable_source rendering mode.  Please consider upgrading to recoil_sync_external_store mode.');
  }

  const store = useStoreRef$5().current;
  return useMemo$2(() => {
    // eslint-disable-next-line no-shadow
    function RecoilBridge({
      children
    }) {
      return /*#__PURE__*/react.createElement(RecoilRoot$1, {
        store_INTERNAL: store
      }, children);
    }

    return RecoilBridge;
  }, [store]);
}

var Recoil_useRecoilBridgeAcrossReactRoots = useRecoilBridgeAcrossReactRoots;

const {
  loadableWithValue: loadableWithValue$1
} = Recoil_Loadable$1;

const {
  initializeNode: initializeNode$3
} = Recoil_FunctionalCore;

const {
  DEFAULT_VALUE: DEFAULT_VALUE$4,
  getNode: getNode$5
} = Recoil_Node;

const {
  copyTreeState: copyTreeState$1,
  getRecoilValueAsLoadable: getRecoilValueAsLoadable$3,
  invalidateDownstreams: invalidateDownstreams$1,
  writeLoadableToTreeState: writeLoadableToTreeState$1
} = Recoil_RecoilValueInterface;



function isAtom(recoilValue) {
  return getNode$5(recoilValue.key).nodeType === 'atom';
}

class TransactionInterfaceImpl {
  constructor(store, treeState) {
    _defineProperty(this, "_store", void 0);

    _defineProperty(this, "_treeState", void 0);

    _defineProperty(this, "_changes", void 0);

    _defineProperty(this, "get", recoilValue => {
      if (this._changes.has(recoilValue.key)) {
        // $FlowIssue[incompatible-return]
        return this._changes.get(recoilValue.key);
      }

      if (!isAtom(recoilValue)) {
        throw Recoil_err('Reading selectors within atomicUpdate is not supported');
      }

      const loadable = getRecoilValueAsLoadable$3(this._store, recoilValue, this._treeState);

      if (loadable.state === 'hasValue') {
        return loadable.contents;
      } else if (loadable.state === 'hasError') {
        throw loadable.contents;
      } else {
        throw Recoil_err(`Expected Recoil atom ${recoilValue.key} to have a value, but it is in a loading state.`);
      }
    });

    _defineProperty(this, "set", (recoilState, valueOrUpdater) => {
      if (!isAtom(recoilState)) {
        throw Recoil_err('Setting selectors within atomicUpdate is not supported');
      }

      if (typeof valueOrUpdater === 'function') {
        const current = this.get(recoilState);

        this._changes.set(recoilState.key, valueOrUpdater(current)); // flowlint-line unclear-type:off

      } else {
        // Initialize atom and run effects if not initialized yet
        initializeNode$3(this._store, recoilState.key, 'set');

        this._changes.set(recoilState.key, valueOrUpdater);
      }
    });

    _defineProperty(this, "reset", recoilState => {
      this.set(recoilState, DEFAULT_VALUE$4);
    });

    this._store = store;
    this._treeState = treeState;
    this._changes = new Map();
  } // Allow destructing
  // eslint-disable-next-line fb-www/extra-arrow-initializer


  newTreeState_INTERNAL() {
    if (this._changes.size === 0) {
      return this._treeState;
    }

    const newState = copyTreeState$1(this._treeState);

    for (const [k, v] of this._changes) {
      writeLoadableToTreeState$1(newState, k, loadableWithValue$1(v));
    }

    invalidateDownstreams$1(this._store, newState);
    return newState;
  }

}

function atomicUpdater(store) {
  return fn => {
    store.replaceState(treeState => {
      const changeset = new TransactionInterfaceImpl(store, treeState);
      fn(changeset);
      return changeset.newTreeState_INTERNAL();
    });
  };
}

var Recoil_AtomicUpdates = {
  atomicUpdater
};

var Recoil_AtomicUpdates_1 = Recoil_AtomicUpdates.atomicUpdater;

var Recoil_AtomicUpdates$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  atomicUpdater: Recoil_AtomicUpdates_1
});

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */

function invariant(condition, message) {
  if (!condition) {
    throw new Error(message);
  }
}

var invariant_1 = invariant;

// @oss-only


var Recoil_invariant = invariant_1;

const {
  atomicUpdater: atomicUpdater$1
} = Recoil_AtomicUpdates$1;

const {
  batchUpdates: batchUpdates$4
} = Recoil_Batching;

const {
  DEFAULT_VALUE: DEFAULT_VALUE$5
} = Recoil_Node;

const {
  useStoreRef: useStoreRef$6
} = Recoil_RecoilRoot;

const {
  refreshRecoilValue: refreshRecoilValue$1,
  setRecoilValue: setRecoilValue$3
} = Recoil_RecoilValueInterface;

const {
  cloneSnapshot: cloneSnapshot$2
} = Recoil_Snapshot$1;

const {
  gotoSnapshot: gotoSnapshot$1
} = Recoil_SnapshotHooks;

const {
  useCallback: useCallback$3
} = react;









class Sentinel {}

const SENTINEL = new Sentinel();

function recoilCallback(store, fn, args, extraInterface) {
  let ret = SENTINEL;
  let releaseSnapshot;
  batchUpdates$4(() => {
    const errMsg = 'useRecoilCallback() expects a function that returns a function: ' + 'it accepts a function of the type (RecoilInterface) => (Args) => ReturnType ' + 'and returns a callback function (Args) => ReturnType, where RecoilInterface is ' + 'an object {snapshot, set, ...} and Args and ReturnType are the argument and return ' + 'types of the callback you want to create.  Please see the docs ' + 'at recoiljs.org for details.';

    if (typeof fn !== 'function') {
      throw Recoil_err(errMsg);
    } // Clone the snapshot lazily to avoid overhead if the callback does not use it.
    // Note that this means the snapshot may represent later state from when
    // the callback was called if it first accesses the snapshot asynchronously.


    const callbackInterface = Recoil_lazyProxy({ ...(extraInterface !== null && extraInterface !== void 0 ? extraInterface : {}),
      // flowlint-line unclear-type:off
      set: (node, newValue) => setRecoilValue$3(store, node, newValue),
      reset: node => setRecoilValue$3(store, node, DEFAULT_VALUE$5),
      refresh: node => refreshRecoilValue$1(store, node),
      gotoSnapshot: snapshot => gotoSnapshot$1(store, snapshot),
      transact_UNSTABLE: transaction => atomicUpdater$1(store)(transaction)
    }, {
      snapshot: () => {
        const snapshot = cloneSnapshot$2(store);
        releaseSnapshot = snapshot.retain();
        return snapshot;
      }
    });
    const callback = fn(callbackInterface);

    if (typeof callback !== 'function') {
      throw Recoil_err(errMsg);
    }

    ret = callback(...args);
  });
  !!(ret instanceof Sentinel) ?  false ? 0 : Recoil_invariant(false) : void 0;

  if (Recoil_isPromise(ret)) {
    ret.finally(() => {
      var _releaseSnapshot;

      (_releaseSnapshot = releaseSnapshot) === null || _releaseSnapshot === void 0 ? void 0 : _releaseSnapshot();
    });
  } else {
    var _releaseSnapshot2;

    (_releaseSnapshot2 = releaseSnapshot) === null || _releaseSnapshot2 === void 0 ? void 0 : _releaseSnapshot2();
  }

  return ret;
}

function useRecoilCallback(fn, deps) {
  const storeRef = useStoreRef$6();
  return useCallback$3( // $FlowIssue[incompatible-call]
  (...args) => {
    return recoilCallback(storeRef.current, fn, args);
  }, deps != null ? [...deps, storeRef] : undefined // eslint-disable-line fb-www/react-hooks-deps
  );
}

var Recoil_useRecoilCallback = {
  recoilCallback,
  useRecoilCallback
};

const {
  useStoreRef: useStoreRef$7
} = Recoil_RecoilRoot;

const {
  refreshRecoilValue: refreshRecoilValue$2
} = Recoil_RecoilValueInterface;

const {
  useCallback: useCallback$4
} = react;

function useRecoilRefresher(recoilValue) {
  const storeRef = useStoreRef$7();
  return useCallback$4(() => {
    const store = storeRef.current;
    refreshRecoilValue$2(store, recoilValue);
  }, [recoilValue, storeRef]);
}

var Recoil_useRecoilRefresher = useRecoilRefresher;

const {
  atomicUpdater: atomicUpdater$2
} = Recoil_AtomicUpdates$1;

const {
  useStoreRef: useStoreRef$8
} = Recoil_RecoilRoot;

const {
  useMemo: useMemo$3
} = react;

function useRecoilTransaction(fn, deps) {
  const storeRef = useStoreRef$8();
  return useMemo$3(() => (...args) => {
    const atomicUpdate = atomicUpdater$2(storeRef.current);
    atomicUpdate(transactionInterface => {
      fn(transactionInterface)(...args);
    });
  }, deps != null ? [...deps, storeRef] : undefined // eslint-disable-line fb-www/react-hooks-deps
  );
}

var Recoil_useRecoilTransaction = useRecoilTransaction;

/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */

class WrappedValue {
  constructor(value) {
    _defineProperty(this, "value", void 0);

    this.value = value;
  }

}

var Recoil_Wrapper = {
  WrappedValue
};

var Recoil_Wrapper_1 = Recoil_Wrapper.WrappedValue;

var Recoil_Wrapper$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  WrappedValue: Recoil_Wrapper_1
});

const {
  isFastRefreshEnabled: isFastRefreshEnabled$2
} = Recoil_ReactMode;



class ChangedPathError extends Error {}

class TreeCache {
  // $FlowIssue[unclear-type]
  constructor(options) {
    var _options$onHit, _options$onSet, _options$mapNodeValue;

    _defineProperty(this, "_name", void 0);

    _defineProperty(this, "_numLeafs", void 0);

    _defineProperty(this, "_root", void 0);

    _defineProperty(this, "_onHit", void 0);

    _defineProperty(this, "_onSet", void 0);

    _defineProperty(this, "_mapNodeValue", void 0);

    this._name = options === null || options === void 0 ? void 0 : options.name;
    this._numLeafs = 0;
    this._root = null;
    this._onHit = (_options$onHit = options === null || options === void 0 ? void 0 : options.onHit) !== null && _options$onHit !== void 0 ? _options$onHit : () => {};
    this._onSet = (_options$onSet = options === null || options === void 0 ? void 0 : options.onSet) !== null && _options$onSet !== void 0 ? _options$onSet : () => {};
    this._mapNodeValue = (_options$mapNodeValue = options === null || options === void 0 ? void 0 : options.mapNodeValue) !== null && _options$mapNodeValue !== void 0 ? _options$mapNodeValue : val => val;
  }

  size() {
    return this._numLeafs;
  } // $FlowIssue[unclear-type]


  root() {
    return this._root;
  }

  get(getNodeValue, handlers) {
    var _this$getLeafNode;

    return (_this$getLeafNode = this.getLeafNode(getNodeValue, handlers)) === null || _this$getLeafNode === void 0 ? void 0 : _this$getLeafNode.value;
  }

  getLeafNode(getNodeValue, handlers) {
    if (this._root == null) {
      return undefined;
    } // Iterate down the tree based on the current node values until we hit a leaf
    // $FlowIssue[unclear-type]


    let node = this._root;

    while (node) {
      handlers === null || handlers === void 0 ? void 0 : handlers.onNodeVisit(node);

      if (node.type === 'leaf') {
        this._onHit(node);

        return node;
      }

      const nodeValue = this._mapNodeValue(getNodeValue(node.nodeKey));

      node = node.branches.get(nodeValue);
    }

    return undefined;
  }

  set(route, value, handlers) {
    const addLeaf = () => {
      var _node2, _node3, _this$_root2, _handlers$onNodeVisit2;

      // First, setup the branch nodes for the route:
      // Iterate down the tree to find or add branch nodes following the route
      let node;
      let branchKey;

      for (const [nodeKey, nodeValue] of route) {
        var _node, _handlers$onNodeVisit, _this$_root;

        // If the previous root was a leaf, while we not have a get(), it means
        // the selector has inconsistent values or implementation changed.
        const root = this._root;

        if ((root === null || root === void 0 ? void 0 : root.type) === 'leaf') {
          throw this.invalidCacheError();
        } // node now refers to the next node down in the tree


        const parent = node; // $FlowFixMe[prop-missing]
        // $FlowFixMe[incompatible-type]

        node = parent ? parent.branches.get(branchKey) : root; // $FlowFixMe[prop-missing]
        // $FlowFixMe[incompatible-type]

        node = (_node = node) !== null && _node !== void 0 ? _node : {
          type: 'branch',
          nodeKey,
          parent,
          branches: new Map(),
          branchKey
        }; // If we found an existing node, confirm it has a consistent value

        if (node.type !== 'branch' || node.nodeKey !== nodeKey) {
          throw this.invalidCacheError();
        } // Add the branch node to the tree


        parent === null || parent === void 0 ? void 0 : parent.branches.set(branchKey, node);
        handlers === null || handlers === void 0 ? void 0 : (_handlers$onNodeVisit = handlers.onNodeVisit) === null || _handlers$onNodeVisit === void 0 ? void 0 : _handlers$onNodeVisit.call(handlers, node); // Prepare for next iteration and install root if it is new.

        branchKey = this._mapNodeValue(nodeValue);
        this._root = (_this$_root = this._root) !== null && _this$_root !== void 0 ? _this$_root : node;
      } // Second, setup the leaf node:
      // If there is an existing leaf for this route confirm it is consistent


      const oldLeaf = node ? (_node2 = node) === null || _node2 === void 0 ? void 0 : _node2.branches.get(branchKey) : this._root;

      if (oldLeaf != null && (oldLeaf.type !== 'leaf' || oldLeaf.branchKey !== branchKey)) {
        throw this.invalidCacheError();
      } // Create a new or replacement leaf.


      const leafNode = {
        type: 'leaf',
        value,
        parent: node,
        branchKey
      }; // Install the leaf and call handlers

      (_node3 = node) === null || _node3 === void 0 ? void 0 : _node3.branches.set(branchKey, leafNode);
      this._root = (_this$_root2 = this._root) !== null && _this$_root2 !== void 0 ? _this$_root2 : leafNode;
      this._numLeafs++;

      this._onSet(leafNode);

      handlers === null || handlers === void 0 ? void 0 : (_handlers$onNodeVisit2 = handlers.onNodeVisit) === null || _handlers$onNodeVisit2 === void 0 ? void 0 : _handlers$onNodeVisit2.call(handlers, leafNode);
    };

    try {
      addLeaf();
    } catch (error) {
      // If the cache was stale or observed inconsistent values, such as with
      // Fast Refresh, then clear it and rebuild with the new values.
      if (error instanceof ChangedPathError) {
        this.clear();
        addLeaf();
      } else {
        throw error;
      }
    }
  } // Returns true if leaf was actually deleted from the tree


  delete(leaf) {
    const root = this.root();

    if (!root) {
      return false;
    }

    if (leaf === root) {
      this._root = null;
      this._numLeafs = 0;
      return true;
    } // Iterate up from the leaf deleteing it from it's parent's branches.


    let node = leaf.parent;
    let branchKey = leaf.branchKey;

    while (node) {
      var _node4;

      node.branches.delete(branchKey); // Stop iterating if we hit the root.

      if (node === root) {
        if (node.branches.size === 0) {
          this._root = null;
          this._numLeafs = 0;
        } else {
          this._numLeafs--;
        }

        return true;
      } // Stop iterating if there are other branches since we don't need to
      // remove any more nodes.


      if (node.branches.size > 0) {
        break;
      } // Iterate up to our parent


      branchKey = (_node4 = node) === null || _node4 === void 0 ? void 0 : _node4.branchKey;
      node = node.parent;
    } // Confirm that the leaf we are deleting is actually attached to our tree


    for (; node !== root; node = node.parent) {
      if (node == null) {
        return false;
      }
    }

    this._numLeafs--;
    return true;
  }

  clear() {
    this._numLeafs = 0;
    this._root = null;
  }

  invalidCacheError() {
    const CHANGED_PATH_ERROR_MESSAGE = isFastRefreshEnabled$2() ? 'Possible Fast Refresh module reload detected.  ' + 'This may also be caused by an selector returning inconsistent values. ' + 'Resetting cache.' : 'Invalid cache values.  This happens when selectors do not return ' + 'consistent values for the same input dependency values.  That may also ' + 'be caused when using Fast Refresh to change a selector implementation.  ' + 'Resetting cache.';
    Recoil_recoverableViolation(CHANGED_PATH_ERROR_MESSAGE + (this._name != null ? ` - ${this._name}` : ''));
    throw new ChangedPathError();
  }

}

var Recoil_TreeCache = {
  TreeCache
};

var Recoil_TreeCache_1 = Recoil_TreeCache.TreeCache;

var Recoil_TreeCache$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  TreeCache: Recoil_TreeCache_1
});

class LRUCache {
  constructor(options) {
    var _options$mapKey;

    _defineProperty(this, "_maxSize", void 0);

    _defineProperty(this, "_size", void 0);

    _defineProperty(this, "_head", void 0);

    _defineProperty(this, "_tail", void 0);

    _defineProperty(this, "_map", void 0);

    _defineProperty(this, "_keyMapper", void 0);

    this._maxSize = options.maxSize;
    this._size = 0;
    this._head = null;
    this._tail = null;
    this._map = new Map();
    this._keyMapper = (_options$mapKey = options.mapKey) !== null && _options$mapKey !== void 0 ? _options$mapKey : v => v;
  }

  head() {
    return this._head;
  }

  tail() {
    return this._tail;
  }

  size() {
    return this._size;
  }

  maxSize() {
    return this._maxSize;
  }

  has(key) {
    return this._map.has(this._keyMapper(key));
  }

  get(key) {
    const mappedKey = this._keyMapper(key);

    const node = this._map.get(mappedKey);

    if (!node) {
      return undefined;
    }

    this.set(key, node.value);
    return node.value;
  }

  set(key, val) {
    const mappedKey = this._keyMapper(key);

    const existingNode = this._map.get(mappedKey);

    if (existingNode) {
      this.delete(key);
    }

    const head = this.head();
    const node = {
      key,
      right: head,
      left: null,
      value: val
    };

    if (head) {
      head.left = node;
    } else {
      this._tail = node;
    }

    this._map.set(mappedKey, node);

    this._head = node;
    this._size++;

    this._maybeDeleteLRU();
  }

  _maybeDeleteLRU() {
    if (this.size() > this.maxSize()) {
      this.deleteLru();
    }
  }

  deleteLru() {
    const tail = this.tail();

    if (tail) {
      this.delete(tail.key);
    }
  }

  delete(key) {
    const mappedKey = this._keyMapper(key);

    if (!this._size || !this._map.has(mappedKey)) {
      return;
    }

    const node = Recoil_nullthrows(this._map.get(mappedKey));
    const right = node.right;
    const left = node.left;

    if (right) {
      right.left = node.left;
    }

    if (left) {
      left.right = node.right;
    }

    if (node === this.head()) {
      this._head = right;
    }

    if (node === this.tail()) {
      this._tail = left;
    }

    this._map.delete(mappedKey);

    this._size--;
  }

  clear() {
    this._size = 0;
    this._head = null;
    this._tail = null;
    this._map = new Map();
  }

}

var Recoil_LRUCache = {
  LRUCache
};

var Recoil_LRUCache_1 = Recoil_LRUCache.LRUCache;

var Recoil_LRUCache$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  LRUCache: Recoil_LRUCache_1
});

const {
  LRUCache: LRUCache$1
} = Recoil_LRUCache$1;

const {
  TreeCache: TreeCache$1
} = Recoil_TreeCache$1;

function treeCacheLRU({
  name,
  maxSize,
  mapNodeValue = v => v
}) {
  const lruCache = new LRUCache$1({
    maxSize
  });
  const cache = new TreeCache$1({
    name,
    mapNodeValue,
    onHit: node => {
      lruCache.set(node, true);
    },
    onSet: node => {
      const lruNode = lruCache.tail();
      lruCache.set(node, true);

      if (lruNode && cache.size() > maxSize) {
        cache.delete(lruNode.key);
      }
    }
  });
  return cache;
}

var Recoil_treeCacheLRU = treeCacheLRU;

const TIME_WARNING_THRESHOLD_MS = 15;

function stringify(x, opt, key) {
  // A optimization to avoid the more expensive JSON.stringify() for simple strings
  // This may lose protection for u2028 and u2029, though.
  if (typeof x === 'string' && !x.includes('"') && !x.includes('\\')) {
    return `"${x}"`;
  } // Handle primitive types


  switch (typeof x) {
    case 'undefined':
      return '';
    // JSON.stringify(undefined) returns undefined, but we always want to return a string

    case 'boolean':
      return x ? 'true' : 'false';

    case 'number':
    case 'symbol':
      // case 'bigint': // BigInt is not supported in www
      return String(x);

    case 'string':
      // Add surrounding quotes and escape internal quotes
      return JSON.stringify(x);

    case 'function':
      if ((opt === null || opt === void 0 ? void 0 : opt.allowFunctions) !== true) {
        throw Recoil_err('Attempt to serialize function in a Recoil cache key');
      }

      return `__FUNCTION(${x.name})__`;
  }

  if (x === null) {
    return 'null';
  } // Fallback case for unknown types


  if (typeof x !== 'object') {
    var _JSON$stringify;

    return (_JSON$stringify = JSON.stringify(x)) !== null && _JSON$stringify !== void 0 ? _JSON$stringify : '';
  } // Deal with all promises as equivalent for now.


  if (Recoil_isPromise(x)) {
    return '__PROMISE__';
  } // Arrays handle recursive stringification


  if (Array.isArray(x)) {
    return `[${x.map((v, i) => stringify(v, opt, i.toString()))}]`;
  } // If an object defines a toJSON() method, then use that to override the
  // serialization.  This matches the behavior of JSON.stringify().
  // Pass the key for compatibility.
  // Immutable.js collections define this method to allow us to serialize them.


  if (typeof x.toJSON === 'function') {
    // flowlint-next-line unclear-type: off
    return stringify(x.toJSON(key), opt, key);
  } // For built-in Maps, sort the keys in a stable order instead of the
  // default insertion order.  Support non-string keys.


  if (x instanceof Map) {
    const obj = {};

    for (const [k, v] of x) {
      // Stringify will escape any nested quotes
      obj[typeof k === 'string' ? k : stringify(k, opt)] = v;
    }

    return stringify(obj, opt, key);
  } // For built-in Sets, sort the keys in a stable order instead of the
  // default insertion order.


  if (x instanceof Set) {
    return stringify(Array.from(x).sort((a, b) => stringify(a, opt).localeCompare(stringify(b, opt))), opt, key);
  } // Anything else that is iterable serialize as an Array.


  if (Symbol !== undefined && x[Symbol.iterator] != null && typeof x[Symbol.iterator] === 'function') {
    // flowlint-next-line unclear-type: off
    return stringify(Array.from(x), opt, key);
  } // For all other Objects, sort the keys in a stable order.


  return `{${Object.keys(x).filter(k => x[k] !== undefined).sort() // stringify the key to add quotes and escape any nested slashes or quotes.
  .map(k => `${stringify(k, opt)}:${stringify(x[k], opt, k)}`).join(',')}}`;
} // Utility similar to JSON.stringify() except:
// * Serialize built-in Sets as an Array
// * Serialize built-in Maps as an Object.  Supports non-string keys.
// * Serialize other iterables as arrays
// * Sort the keys of Objects and Maps to have a stable order based on string conversion.
//    This overrides their default insertion order.
// * Still uses toJSON() of any object to override serialization
// * Support Symbols (though don't guarantee uniqueness)
// * We could support BigInt, but Flow doesn't seem to like it.
// See Recoil_stableStringify-test.js for examples


function stableStringify(x, opt = {
  allowFunctions: false
}) {
  if (false) {}

  return stringify(x, opt);
}

var Recoil_stableStringify = stableStringify;

const {
  TreeCache: TreeCache$2
} = Recoil_TreeCache$1;









const defaultPolicy = {
  equality: 'reference',
  eviction: 'keep-all',
  maxSize: Infinity
};

function treeCacheFromPolicy({
  equality = defaultPolicy.equality,
  eviction = defaultPolicy.eviction,
  maxSize = defaultPolicy.maxSize
} = defaultPolicy, name) {
  const valueMapper = getValueMapper(equality);
  return getTreeCache(eviction, maxSize, valueMapper, name);
}

function getValueMapper(equality) {
  switch (equality) {
    case 'reference':
      return val => val;

    case 'value':
      return val => Recoil_stableStringify(val);
  }

  throw Recoil_err(`Unrecognized equality policy ${equality}`);
}

function getTreeCache(eviction, maxSize, mapNodeValue, name) {
  switch (eviction) {
    case 'keep-all':
      return new TreeCache$2({
        name,
        mapNodeValue
      });

    case 'lru':
      return Recoil_treeCacheLRU({
        name,
        maxSize: Recoil_nullthrows(maxSize),
        mapNodeValue
      });

    case 'most-recent':
      return Recoil_treeCacheLRU({
        name,
        maxSize: 1,
        mapNodeValue
      });
  }

  throw Recoil_err(`Unrecognized eviction policy ${eviction}`);
}

var Recoil_treeCacheFromPolicy = treeCacheFromPolicy;

/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */

function isNode(object) {
  var _ownerDocument, _doc$defaultView;

  if (typeof window === 'undefined') {
    return false;
  }

  const doc = object != null ? (_ownerDocument = object.ownerDocument) !== null && _ownerDocument !== void 0 ? _ownerDocument : object : document;
  const defaultView = (_doc$defaultView = doc.defaultView) !== null && _doc$defaultView !== void 0 ? _doc$defaultView : window;
  return !!(object != null && (typeof defaultView.Node === 'function' ? object instanceof defaultView.Node : typeof object === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string'));
}

var Recoil_isNode = (/* unused pure expression or super */ null && (isNode));

const {
  isReactNative: isReactNative$1,
  isWindow: isWindow$1
} = Recoil_Environment;





function shouldNotBeFrozen(value) {
  // Primitives and functions:
  if (value === null || typeof value !== 'object') {
    return true;
  } // React elements:


  switch (typeof value.$$typeof) {
    case 'symbol':
      return true;

    case 'number':
      return true;
  } // Immutable structures:


  if (value['@@__IMMUTABLE_ITERABLE__@@'] != null || value['@@__IMMUTABLE_KEYED__@@'] != null || value['@@__IMMUTABLE_INDEXED__@@'] != null || value['@@__IMMUTABLE_ORDERED__@@'] != null || value['@@__IMMUTABLE_RECORD__@@'] != null) {
    return true;
  } // DOM nodes:


  if (Recoil_isNode(value)) {
    return true;
  }

  if (Recoil_isPromise(value)) {
    return true;
  }

  if (value instanceof Error) {
    return true;
  }

  if (ArrayBuffer.isView(value)) {
    return true;
  } // Some environments, just as Jest, don't work with the instanceof check


  if (!isReactNative$1 && isWindow$1(value)) {
    return true;
  }

  return false;
} // Recursively freeze a value to enforce it is read-only.
// This may also have minimal performance improvements for enumerating
// objects (based on browser implementations, of course)


function deepFreezeValue(value) {
  if (typeof value !== 'object' || shouldNotBeFrozen(value)) {
    return;
  }

  Object.freeze(value); // Make all properties read-only

  for (const key in value) {
    // $FlowIssue[method-unbinding] added when improving typing for this parameters
    if (Object.prototype.hasOwnProperty.call(value, key)) {
      const prop = value[key]; // Prevent infinite recurssion for circular references.

      if (typeof prop === 'object' && prop != null && !Object.isFrozen(prop)) {
        deepFreezeValue(prop);
      }
    }
  }

  Object.seal(value); // This also makes existing properties non-configurable.
}

var Recoil_deepFreezeValue = (/* unused pure expression or super */ null && (deepFreezeValue));

/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * This is a stub for some integration into FB internal stuff
 *
 * 
 * @format
 * @oncall recoil
 */
function startPerfBlock(_id) {
  return () => null;
}

var Recoil_PerformanceTimings = {
  startPerfBlock
};

const {
  isLoadable: isLoadable$1,
  loadableWithError: loadableWithError$1,
  loadableWithPromise: loadableWithPromise$1,
  loadableWithValue: loadableWithValue$2
} = Recoil_Loadable$1;

const {
  WrappedValue: WrappedValue$1
} = Recoil_Wrapper$1;



const {
  getNodeLoadable: getNodeLoadable$2,
  peekNodeLoadable: peekNodeLoadable$1,
  setNodeValue: setNodeValue$3
} = Recoil_FunctionalCore;

const {
  saveDepsToStore: saveDepsToStore$1
} = Recoil_Graph;

const {
  DEFAULT_VALUE: DEFAULT_VALUE$6,
  getConfigDeletionHandler: getConfigDeletionHandler$1,
  getNode: getNode$6,
  registerNode: registerNode$1
} = Recoil_Node;

const {
  isRecoilValue: isRecoilValue$3
} = Recoil_RecoilValue$1;

const {
  markRecoilValueModified: markRecoilValueModified$1
} = Recoil_RecoilValueInterface;

const {
  retainedByOptionWithDefault: retainedByOptionWithDefault$1
} = Recoil_Retention;

const {
  recoilCallback: recoilCallback$1
} = Recoil_useRecoilCallback;



















const {
  startPerfBlock: startPerfBlock$1
} = Recoil_PerformanceTimings;



class Canceled {}

const CANCELED = new Canceled();
/**
 * An ExecutionID is an arbitrary ID that lets us distinguish executions from
 * each other. This is necessary as we need a way of solving this problem:
 * "given 3 async executions, only update state for the 'latest' execution when
 * it finishes running regardless of when the other 2 finish". ExecutionIDs
 * provide a convenient way of identifying executions so that we can track and
 * manage them over time.
 */

const dependencyStack = []; // for detecting circular dependencies.

const waitingStores = new Map();

const getNewExecutionID = (() => {
  let executionID = 0;
  return () => executionID++;
})();
/* eslint-disable no-redeclare */


function selector(options) {
  let recoilValue = null;
  const {
    key,
    get,
    cachePolicy_UNSTABLE: cachePolicy
  } = options;
  const set = options.set != null ? options.set : undefined; // flow

  if (false) {} // This is every discovered dependency across all executions


  const discoveredDependencyNodeKeys = new Set();
  const cache = Recoil_treeCacheFromPolicy(cachePolicy !== null && cachePolicy !== void 0 ? cachePolicy : {
    equality: 'reference',
    eviction: 'keep-all'
  }, key);
  const retainedBy = retainedByOptionWithDefault$1(options.retainedBy_UNSTABLE);
  const executionInfoMap = new Map();
  let liveStoresCount = 0;

  function selectorIsLive() {
    return !Recoil_gkx('recoil_memory_managament_2020') || liveStoresCount > 0;
  }

  function selectorInit(store) {
    store.getState().knownSelectors.add(key);
    liveStoresCount++;
    return () => {
      liveStoresCount--;
    };
  }

  function selectorShouldDeleteConfigOnRelease() {
    return getConfigDeletionHandler$1(key) !== undefined && !selectorIsLive();
  }

  function resolveAsync(store, state, executionID, loadable, depValues) {
    setCache(state, loadable, depValues);
    notifyStoresOfResolvedAsync(store, executionID);
  }

  function notifyStoresOfResolvedAsync(store, executionID) {
    if (isLatestExecution(store, executionID)) {
      clearExecutionInfo(store);
    }

    notifyWaitingStores(executionID, true);
  }
  /**
   * Notify stores to pull the selector again if a new async dep was discovered.
   * 1) Async selector adds a new dep but doesn't resolve yet.
   *    Note that deps for an async selector are based on the state when the
   *    evaluation started, in order to provide a consistent picture of state.
   * 2) But, new value of dep based on the current state might cause the selector
   *    to resolve or resolve differently.
   * 3) Therefore, this notification will pull the selector based on the current
   *    state for the components
   */


  function notifyStoresOfNewAsyncDep(store, executionID) {
    if (isLatestExecution(store, executionID)) {
      const executionInfo = Recoil_nullthrows(getExecutionInfo(store));
      executionInfo.stateVersions.clear();
      notifyWaitingStores(executionID, false);
    }
  }

  function notifyWaitingStores(executionID, clearWaitlist) {
    const stores = waitingStores.get(executionID);

    if (stores != null) {
      for (const waitingStore of stores) {
        markRecoilValueModified$1(waitingStore, Recoil_nullthrows(recoilValue));
      }

      if (clearWaitlist) {
        waitingStores.delete(executionID);
      }
    }
  }

  function markStoreWaitingForResolvedAsync(store, executionID) {
    let stores = waitingStores.get(executionID);

    if (stores == null) {
      waitingStores.set(executionID, stores = new Set());
    }

    stores.add(store);
  }
  /**
   * This function attaches a then() and a catch() to a promise that was
   * returned from a selector's get() (either explicitly or implicitly by
   * running a function that uses the "async" keyword). If a selector's get()
   * returns a promise, we have two possibilities:
   *
   * 1. The promise will resolve, in which case it will have completely finished
   *    executing without any remaining pending dependencies. No more retries
   *    are needed and we can proceed with updating the cache and notifying
   *    subscribers (if it is the latest execution, otherwise only the cache
   *    will be updated and subscriptions will not be fired). This is the case
   *    handled by the attached then() handler.
   *
   * 2. The promise will throw because it either has an error or it came across
   *    an async dependency that has not yet resolved, in which case we will
   *    call wrapDepdencyPromise(), whose responsibility is to handle dependency
   *    promises. This case is handled by the attached catch() handler.
   *
   * Both branches will eventually resolve to the final result of the selector
   * (or an error if a real error occurred).
   *
   * The execution will run to completion even if it is stale, and its value
   * will be cached. But stale executions will not update global state or update
   * executionInfo as that is the responsibility of the 'latest' execution.
   *
   * Note this function should not be passed a promise that was thrown--AKA a
   * dependency promise. Dependency promises should be passed to
   * wrapPendingDependencyPromise()).
   */


  function wrapResultPromise(store, promise, state, depValues, executionID, loadingDepsState) {
    return promise.then(value => {
      if (!selectorIsLive()) {
        // The selector was released since the request began; ignore the response.
        clearExecutionInfo(store);
        throw CANCELED;
      }

      const loadable = loadableWithValue$2(value);
      resolveAsync(store, state, executionID, loadable, depValues);
      return value;
    }).catch(errorOrPromise => {
      if (!selectorIsLive()) {
        // The selector was released since the request began; ignore the response.
        clearExecutionInfo(store);
        throw CANCELED;
      }

      if (Recoil_isPromise(errorOrPromise)) {
        return wrapPendingDependencyPromise(store, errorOrPromise, state, depValues, executionID, loadingDepsState);
      }

      const loadable = loadableWithError$1(errorOrPromise);
      resolveAsync(store, state, executionID, loadable, depValues);
      throw errorOrPromise;
    });
  }
  /**
   * This function attaches a then() and a catch() to a promise that was
   * thrown from a selector's get(). If a selector's get() throws a promise,
   * we have two possibilities:
   *
   * 1. The promise will resolve, meaning one of our selector's dependencies is
   *    now available and we should "retry" our get() by running it again. This
   *    is the case handled by the attached then() handler.
   *
   * 2. The promise will throw because something went wrong with the dependency
   *    promise (in other words a real error occurred). This case is handled by
   *    the attached catch() handler. If the dependency promise throws, it is
   *    _always_ a real error and not another dependency promise (any dependency
   *    promises would have been handled upstream).
   *
   * The then() branch will eventually resolve to the final result of the
   * selector (or an error if a real error occurs), and the catch() will always
   * resolve to an error because the dependency promise is a promise that was
   * wrapped upstream, meaning it will only resolve to its real value or to a
   * real error.
   *
   * The execution will run to completion even if it is stale, and its value
   * will be cached. But stale executions will not update global state or update
   * executionInfo as that is the responsibility of the 'latest' execution.
   *
   * Note this function should not be passed a promise that was returned from
   * get(). The intention is that this function is only passed promises that
   * were thrown due to a pending dependency. Promises returned by get() should
   * be passed to wrapResultPromise() instead.
   */


  function wrapPendingDependencyPromise(store, promise, state, existingDeps, executionID, loadingDepsState) {
    return promise.then(resolvedDep => {
      if (!selectorIsLive()) {
        // The selector was released since the request began; ignore the response.
        clearExecutionInfo(store);
        throw CANCELED;
      } // Check if we are handling a pending Recoil dependency or if the user
      // threw their own Promise to "suspend" a selector evaluation.  We need
      // to check that the loadingDepPromise actually matches the promise that
      // we caught in case the selector happened to catch the promise we threw
      // for a pending Recoil dependency from `getRecoilValue()` and threw
      // their own promise instead.


      if (loadingDepsState.loadingDepKey != null && loadingDepsState.loadingDepPromise === promise) {
        /**
         * Note for async atoms, this means we are changing the atom's value
         * in the store for the given version. This should be alright because
         * the version of state is now stale and a new version will have
         * already been triggered by the atom being resolved (see this logic
         * in Recoil_atom.js)
         */
        state.atomValues.set(loadingDepsState.loadingDepKey, loadableWithValue$2(resolvedDep));
      } else {
        /**
         * If resolvedDepKey is not defined, the promise was a user-thrown
         * promise. User-thrown promises are an advanced feature and they
         * should be avoided in almost all cases. Using `loadable.map()` inside
         * of selectors for loading loadables and then throwing that mapped
         * loadable's promise is an example of a user-thrown promise.
         *
         * When we hit a user-thrown promise, we have to bail out of an optimization
         * where we bypass calculating selector cache keys for selectors that
         * have been previously seen for a given state (these selectors are saved in
         * state.atomValues) to avoid stale state as we have no way of knowing
         * what state changes happened (if any) in result to the promise resolving.
         *
         * Ideally we would only bail out selectors that are in the chain of
         * dependencies for this selector, but there's currently no way to get
         * a full list of a selector's downstream nodes because the state that
         * is executing may be a discarded tree (so store.getGraph(state.version)
         * will be empty), and the full dep tree may not be in the selector
         * caches in the case where the selector's cache was cleared. To solve
         * for this we would have to keep track of all running selector
         * executions and their downstream deps. Because this only covers edge
         * cases, that complexity might not be justifyable.
         */
        store.getState().knownSelectors.forEach(nodeKey => {
          state.atomValues.delete(nodeKey);
        });
      }
      /**
       * Optimization: Now that the dependency has resolved, let's try hitting
       * the cache in case the dep resolved to a value we have previously seen.
       *
       * TODO:
       * Note this optimization is not perfect because it only prevents re-executions
       * _after_ the point where an async dependency is found. Any code leading
       * up to the async dependency may have run unnecessarily. The ideal case
       * would be to wait for the async dependency to resolve first, check the
       * cache, and prevent _any_ execution of the selector if the resulting
       * value of the dependency leads to a path that is found in the cache.
       * The ideal case is more difficult to implement as it would require that
       * we capture and wait for the the async dependency right after checking
       * the cache. The current approach takes advantage of the fact that running
       * the selector already has a code path that lets us exit early when
       * an async dep resolves.
       */


      const cachedLoadable = getLoadableFromCacheAndUpdateDeps(store, state);

      if (cachedLoadable && cachedLoadable.state !== 'loading') {
        /**
         * This has to notify stores of a resolved async, even if there is no
         * current pending execution for the following case:
         * 1) A component renders with this pending loadable.
         * 2) The upstream dependency resolves.
         * 3) While processing some other selector it reads this one, such as
         *    while traversing its dependencies.  At this point it gets the
         *    new resolved value synchronously and clears the current
         *    execution ID.  The component wasn't getting the value itself,
         *    though, so it still has the pending loadable.
         * 4) When this code executes the current execution id was cleared
         *    and it wouldn't notify the component of the new value.
         *
         * I think this is only an issue with "early" rendering since the
         * components got their value using the in-progress execution.
         * We don't have a unit test for this case yet.  I'm not sure it is
         * necessary with recoil_transition_support mode.
         */
        if (isLatestExecution(store, executionID) || getExecutionInfo(store) == null) {
          notifyStoresOfResolvedAsync(store, executionID);
        }

        if (cachedLoadable.state === 'hasValue') {
          return cachedLoadable.contents;
        } else {
          throw cachedLoadable.contents;
        }
      }
      /**
       * If this execution is stale, let's check to see if there is some in
       * progress execution with a matching state. If we find a match, then
       * we can take the value from that in-progress execution. Note this may
       * sound like an edge case, but may be very common in cases where a
       * loading dependency resolves from loading to having a value (thus
       * possibly triggering a re-render), and React re-renders before the
       * chained .then() functions run, thus starting a new execution as the
       * dep has changed value. Without this check we will run the selector
       * twice (once in the new execution and once again in this .then(), so
       * this check is necessary to keep unnecessary re-executions to a
       * minimum).
       *
       * Also note this code does not check across all executions that may be
       * running. It only optimizes for the _latest_ execution per store as
       * we currently do not maintain a list of all currently running executions.
       * This means in some cases we may run selectors more than strictly
       * necessary when there are multiple executions running for the same
       * selector. This may be a valid tradeoff as checking for dep changes
       * across all in-progress executions may take longer than just
       * re-running the selector. This will be app-dependent, and maybe in the
       * future we can make the behavior configurable. An ideal fix may be
       * to extend the tree cache to support caching loading states.
       */


      if (!isLatestExecution(store, executionID)) {
        const executionInfo = getInProgressExecutionInfo(store, state);

        if (executionInfo != null) {
          /**
           * Returning promise here without wrapping as the wrapper logic was
           * already done upstream when this promise was generated.
           */
          return executionInfo.loadingLoadable.contents;
        }
      } // Retry the selector evaluation now that the dependency has resolved


      const [loadable, depValues] = evaluateSelectorGetter(store, state, executionID);

      if (loadable.state !== 'loading') {
        resolveAsync(store, state, executionID, loadable, depValues);
      }

      if (loadable.state === 'hasError') {
        throw loadable.contents;
      }

      return loadable.contents;
    }).catch(error => {
      // The selector was released since the request began; ignore the response.
      if (error instanceof Canceled) {
        throw CANCELED;
      }

      if (!selectorIsLive()) {
        clearExecutionInfo(store);
        throw CANCELED;
      }

      const loadable = loadableWithError$1(error);
      resolveAsync(store, state, executionID, loadable, existingDeps);
      throw error;
    });
  }

  function updateDeps(store, state, deps, executionID) {
    var _store$getState, _store$getState$curre, _store$getState2, _store$getState2$next;

    if (isLatestExecution(store, executionID) || state.version === ((_store$getState = store.getState()) === null || _store$getState === void 0 ? void 0 : (_store$getState$curre = _store$getState.currentTree) === null || _store$getState$curre === void 0 ? void 0 : _store$getState$curre.version) || state.version === ((_store$getState2 = store.getState()) === null || _store$getState2 === void 0 ? void 0 : (_store$getState2$next = _store$getState2.nextTree) === null || _store$getState2$next === void 0 ? void 0 : _store$getState2$next.version)) {
      var _store$getState$nextT, _store$getState3, _store$getState3$next;

      saveDepsToStore$1(key, deps, store, (_store$getState$nextT = (_store$getState3 = store.getState()) === null || _store$getState3 === void 0 ? void 0 : (_store$getState3$next = _store$getState3.nextTree) === null || _store$getState3$next === void 0 ? void 0 : _store$getState3$next.version) !== null && _store$getState$nextT !== void 0 ? _store$getState$nextT : store.getState().currentTree.version);
    }

    for (const nodeKey of deps) {
      discoveredDependencyNodeKeys.add(nodeKey);
    }
  }

  function evaluateSelectorGetter(store, state, executionID) {
    const endPerfBlock = startPerfBlock$1(key); // TODO T63965866: use execution ID here

    let duringSynchronousExecution = true;
    let duringAsynchronousExecution = true;

    const finishEvaluation = () => {
      endPerfBlock();
      duringAsynchronousExecution = false;
    };

    let result;
    let resultIsError = false;
    let loadable;
    const loadingDepsState = {
      loadingDepKey: null,
      loadingDepPromise: null
    };
    /**
     * Starting a fresh set of deps that we'll be using to update state. We're
     * starting a new set versus adding it in existing state deps because
     * the version of state that we update deps for may be a more recent version
     * than the version the selector was called with. This is because the latest
     * execution will update the deps of the current/latest version of state
     * (This is safe to do because the fact that the selector is the latest
     * execution means the deps we discover below are our best guess at the
     * deps for the current/latest state in the store)
     */

    const depValues = new Map();

    function getRecoilValue({
      key: depKey
    }) {
      const depLoadable = getNodeLoadable$2(store, state, depKey);
      depValues.set(depKey, depLoadable); // We need to update asynchronous dependencies as we go so the selector
      // knows if it has to restart evaluation if one of them is updated before
      // the asynchronous selector completely resolves.

      if (!duringSynchronousExecution) {
        updateDeps(store, state, new Set(depValues.keys()), executionID);
        notifyStoresOfNewAsyncDep(store, executionID);
      }

      switch (depLoadable.state) {
        case 'hasValue':
          return depLoadable.contents;

        case 'hasError':
          throw depLoadable.contents;

        case 'loading':
          loadingDepsState.loadingDepKey = depKey;
          loadingDepsState.loadingDepPromise = depLoadable.contents;
          throw depLoadable.contents;
      }

      throw Recoil_err('Invalid Loadable state');
    }

    const getCallback = fn => {
      return (...args) => {
        if (duringAsynchronousExecution) {
          throw Recoil_err('Callbacks from getCallback() should only be called asynchronously after the selector is evalutated.  It can be used for selectors to return objects with callbacks that can work with Recoil state without a subscription.');
        }

        !(recoilValue != null) ?  false ? 0 : Recoil_invariant(false) : void 0;
        return recoilCallback$1(store, fn, args, {
          node: recoilValue
        } // flowlint-line unclear-type:off
        );
      };
    };

    try {
      result = get({
        get: getRecoilValue,
        getCallback
      });
      result = isRecoilValue$3(result) ? getRecoilValue(result) : result;

      if (isLoadable$1(result)) {
        if (result.state === 'hasError') {
          resultIsError = true;
        }

        result = result.contents;
      }

      if (Recoil_isPromise(result)) {
        result = wrapResultPromise(store, result, state, depValues, executionID, loadingDepsState).finally(finishEvaluation);
      } else {
        finishEvaluation();
      }

      result = result instanceof WrappedValue$1 ? result.value : result;
    } catch (errorOrDepPromise) {
      result = errorOrDepPromise;

      if (Recoil_isPromise(result)) {
        result = wrapPendingDependencyPromise(store, result, state, depValues, executionID, loadingDepsState).finally(finishEvaluation);
      } else {
        resultIsError = true;
        finishEvaluation();
      }
    }

    if (resultIsError) {
      loadable = loadableWithError$1(result);
    } else if (Recoil_isPromise(result)) {
      loadable = loadableWithPromise$1(result);
    } else {
      loadable = loadableWithValue$2(result);
    }

    duringSynchronousExecution = false;
    updateExecutionInfoDepValues(store, executionID, depValues);
    updateDeps(store, state, new Set(depValues.keys()), executionID);
    return [loadable, depValues];
  }

  function getLoadableFromCacheAndUpdateDeps(store, state) {
    // First, look up in the state cache
    // If it's here, then the deps in the store should already be valid.
    let cachedLoadable = state.atomValues.get(key);

    if (cachedLoadable != null) {
      return cachedLoadable;
    } // Second, look up in the selector cache and update the deps in the store


    const depsAfterCacheLookup = new Set();

    try {
      cachedLoadable = cache.get(nodeKey => {
        !(typeof nodeKey === 'string') ?  false ? 0 : Recoil_invariant(false) : void 0;
        return getNodeLoadable$2(store, state, nodeKey).contents;
      }, {
        onNodeVisit: node => {
          if (node.type === 'branch' && node.nodeKey !== key) {
            depsAfterCacheLookup.add(node.nodeKey);
          }
        }
      });
    } catch (error) {
      throw Recoil_err(`Problem with cache lookup for selector "${key}": ${error.message}`);
    }

    if (cachedLoadable) {
      var _getExecutionInfo;

      // Cache the results in the state to allow for cheaper lookup than
      // iterating the tree cache of dependencies.
      state.atomValues.set(key, cachedLoadable);
      /**
       * Ensure store contains correct dependencies if we hit the cache so that
       * the store deps and cache are in sync for a given state. This is important
       * because store deps are normally updated when new executions are created,
       * but cache hits don't trigger new executions but they still _may_ signify
       * a change in deps in the store if the store deps for this state are empty
       * or stale.
       */

      updateDeps(store, state, depsAfterCacheLookup, (_getExecutionInfo = getExecutionInfo(store)) === null || _getExecutionInfo === void 0 ? void 0 : _getExecutionInfo.executionID);
    }

    return cachedLoadable;
  }
  /**
   * Given a tree state, this function returns a Loadable of the current state.
   *
   * The selector's get() function will only be re-evaluated if _both_ of the
   * following statements are true:
   *
   * 1. The current dep values from the given state produced a cache key that
   *    was not found in the cache.
   * 2. There is no currently running async execution OR there is an
   *    async execution that is running, but after comparing the dep values in
   *    the given state with the dep values that the execution has discovered so
   *    far we find that at least one dep value has changed, in which case we
   *    start a new execution (the previously running execution will continue to
   *    run to completion, but only the new execution will be deemed the
   *    'latest' execution, meaning it will be the only execution that will
   *    update global state when it is finished. Any non-latest executions will
   *    run to completion and update the selector cache but not global state).
   */


  function getSelectorLoadableAndUpdateDeps(store, state) {
    // First, see if our current state is cached
    const cachedVal = getLoadableFromCacheAndUpdateDeps(store, state);

    if (cachedVal != null) {
      clearExecutionInfo(store);
      return cachedVal;
    } // Second, check if there is already an ongoing execution based on the current state


    const inProgressExecutionInfo = getInProgressExecutionInfo(store, state);

    if (inProgressExecutionInfo != null) {
      var _inProgressExecutionI;

      if (((_inProgressExecutionI = inProgressExecutionInfo.loadingLoadable) === null || _inProgressExecutionI === void 0 ? void 0 : _inProgressExecutionI.state) === 'loading') {
        markStoreWaitingForResolvedAsync(store, inProgressExecutionInfo.executionID);
      } // FIXME: check after the fact to see if we made the right choice by waiting


      return inProgressExecutionInfo.loadingLoadable;
    } // Third, start a new evaluation of the selector


    const newExecutionID = getNewExecutionID();
    const [loadable, newDepValues] = evaluateSelectorGetter(store, state, newExecutionID);
    /**
     * Conditionally updates the cache with a given loadable.
     *
     * We only cache loadables that are not loading because our cache keys are
     * based on dep values, which are in an unfinished state for loadables that
     * have a 'loading' state (new deps may be discovered while the selector
     * runs its async code). We never want to cache partial dependencies b/c it
     * could lead to errors, such as prematurely returning the result based on a
     * partial list of deps-- we need the full list of deps to ensure that we
     * are returning the correct result from cache.
     */

    if (loadable.state === 'loading') {
      setExecutionInfo(store, newExecutionID, loadable, newDepValues, state);
      markStoreWaitingForResolvedAsync(store, newExecutionID);
    } else {
      clearExecutionInfo(store);
      setCache(state, loadable, newDepValues);
    }

    return loadable;
  }
  /**
   * Searches execution info across all stores to see if there is an in-progress
   * execution whose dependency values match the values of the requesting store.
   */


  function getInProgressExecutionInfo(store, state) {
    // Sort the pending executions so that our current store is checked first.
    const pendingExecutions = Recoil_concatIterables([executionInfoMap.has(store) ? [Recoil_nullthrows(executionInfoMap.get(store))] : [], Recoil_mapIterable(Recoil_filterIterable(executionInfoMap, ([s]) => s !== store), ([, execInfo]) => execInfo)]);

    function anyDepChanged(execDepValues) {
      for (const [depKey, execLoadable] of execDepValues) {
        if (!getNodeLoadable$2(store, state, depKey).is(execLoadable)) {
          return true;
        }
      }

      return false;
    }

    for (const execInfo of pendingExecutions) {
      if ( // If this execution was already checked to be valid with this version
      // of state, then let's use it!
      execInfo.stateVersions.get(state.version) || // If the deps for the execution match our current state, then it's valid
      !anyDepChanged(execInfo.depValuesDiscoveredSoFarDuringAsyncWork)) {
        execInfo.stateVersions.set(state.version, true);
        return execInfo;
      } else {
        execInfo.stateVersions.set(state.version, false);
      }
    }

    return undefined;
  }

  function getExecutionInfo(store) {
    return executionInfoMap.get(store);
  }
  /**
   * This function will update the selector's execution info when the selector
   * has either finished running an execution or has started a new execution. If
   * the given loadable is in a 'loading' state, the intention is that a new
   * execution has started. Otherwise, the intention is that an execution has
   * just finished.
   */


  function setExecutionInfo(store, newExecutionID, loadable, depValues, state) {
    executionInfoMap.set(store, {
      depValuesDiscoveredSoFarDuringAsyncWork: depValues,
      executionID: newExecutionID,
      loadingLoadable: loadable,
      stateVersions: new Map([[state.version, true]])
    });
  }

  function updateExecutionInfoDepValues(store, executionID, depValues) {
    // We only need to bother updating the deps for the latest execution because
    // that's all getInProgressExecutionInfo() will be looking for.
    if (isLatestExecution(store, executionID)) {
      const executionInfo = getExecutionInfo(store);

      if (executionInfo != null) {
        executionInfo.depValuesDiscoveredSoFarDuringAsyncWork = depValues;
      }
    }
  }

  function clearExecutionInfo(store) {
    executionInfoMap.delete(store);
  }

  function isLatestExecution(store, executionID) {
    var _getExecutionInfo2;

    return executionID === ((_getExecutionInfo2 = getExecutionInfo(store)) === null || _getExecutionInfo2 === void 0 ? void 0 : _getExecutionInfo2.executionID);
  }
  /**
   * FIXME: dep keys should take into account the state of the loadable to
   * prevent the edge case where a loadable with an error and a loadable with
   * an error as a value are treated as the same thing incorrectly. For example
   * these two should be treated differently:
   *
   * selector({key: '', get: () => new Error('hi')});
   * selector({key: '', get () => {throw new Error('hi')}});
   *
   * With current implementation they are treated the same
   */


  function depValuesToDepRoute(depValues) {
    return Array.from(depValues.entries()).map(([depKey, valLoadable]) => [depKey, valLoadable.contents]);
  }

  function setCache(state, loadable, depValues) {
    if (false) {}

    state.atomValues.set(key, loadable);

    try {
      cache.set(depValuesToDepRoute(depValues), loadable);
    } catch (error) {
      throw Recoil_err(`Problem with setting cache for selector "${key}": ${error.message}`);
    }
  }

  function detectCircularDependencies(fn) {
    if (dependencyStack.includes(key)) {
      const message = `Recoil selector has circular dependencies: ${dependencyStack.slice(dependencyStack.indexOf(key)).join(' \u2192 ')}`;
      return loadableWithError$1(Recoil_err(message));
    }

    dependencyStack.push(key);

    try {
      return fn();
    } finally {
      dependencyStack.pop();
    }
  }

  function selectorPeek(store, state) {
    const cachedLoadable = state.atomValues.get(key);

    if (cachedLoadable != null) {
      return cachedLoadable;
    }

    return cache.get(nodeKey => {
      var _peekNodeLoadable;

      !(typeof nodeKey === 'string') ?  false ? 0 : Recoil_invariant(false) : void 0;
      return (_peekNodeLoadable = peekNodeLoadable$1(store, state, nodeKey)) === null || _peekNodeLoadable === void 0 ? void 0 : _peekNodeLoadable.contents;
    });
  }

  function selectorGet(store, state) {
    return detectCircularDependencies(() => getSelectorLoadableAndUpdateDeps(store, state));
  }

  function invalidateSelector(state) {
    state.atomValues.delete(key);
  }

  function clearSelectorCache(store, treeState) {
    !(recoilValue != null) ?  false ? 0 : Recoil_invariant(false) : void 0;

    for (const nodeKey of discoveredDependencyNodeKeys) {
      var _node$clearCache;

      const node = getNode$6(nodeKey);
      (_node$clearCache = node.clearCache) === null || _node$clearCache === void 0 ? void 0 : _node$clearCache.call(node, store, treeState);
    }

    discoveredDependencyNodeKeys.clear();
    invalidateSelector(treeState);
    cache.clear();
    markRecoilValueModified$1(store, recoilValue);
  }

  if (set != null) {
    /**
     * ES5 strict mode prohibits defining non-top-level function declarations,
     * so don't use function declaration syntax here
     */
    const selectorSet = (store, state, newValue) => {
      let syncSelectorSetFinished = false;
      const writes = new Map();

      function getRecoilValue({
        key: depKey
      }) {
        if (syncSelectorSetFinished) {
          throw Recoil_err('Recoil: Async selector sets are not currently supported.');
        }

        const loadable = getNodeLoadable$2(store, state, depKey);

        if (loadable.state === 'hasValue') {
          return loadable.contents;
        } else if (loadable.state === 'loading') {
          const msg = `Getting value of asynchronous atom or selector "${depKey}" in a pending state while setting selector "${key}" is not yet supported.`;
          Recoil_recoverableViolation(msg);
          throw Recoil_err(msg);
        } else {
          throw loadable.contents;
        }
      }

      function setRecoilState(recoilState, valueOrUpdater) {
        if (syncSelectorSetFinished) {
          const msg = 'Recoil: Async selector sets are not currently supported.';
          Recoil_recoverableViolation(msg);
          throw Recoil_err(msg);
        }

        const setValue = typeof valueOrUpdater === 'function' ? // cast to any because we can't restrict type S from being a function itself without losing support for opaque types
        // flowlint-next-line unclear-type:off
        valueOrUpdater(getRecoilValue(recoilState)) : valueOrUpdater;
        const upstreamWrites = setNodeValue$3(store, state, recoilState.key, setValue);
        upstreamWrites.forEach((v, k) => writes.set(k, v));
      }

      function resetRecoilState(recoilState) {
        setRecoilState(recoilState, DEFAULT_VALUE$6);
      }

      const ret = set({
        set: setRecoilState,
        get: getRecoilValue,
        reset: resetRecoilState
      }, newValue); // set should be a void method, but if the user makes it `async`, then it
      // will return a Promise, which we don't currently support.

      if (ret !== undefined) {
        throw Recoil_isPromise(ret) ? Recoil_err('Recoil: Async selector sets are not currently supported.') : Recoil_err('Recoil: selector set should be a void function.');
      }

      syncSelectorSetFinished = true;
      return writes;
    };

    return recoilValue = registerNode$1({
      key,
      nodeType: 'selector',
      peek: selectorPeek,
      get: selectorGet,
      set: selectorSet,
      init: selectorInit,
      invalidate: invalidateSelector,
      clearCache: clearSelectorCache,
      shouldDeleteConfigOnRelease: selectorShouldDeleteConfigOnRelease,
      dangerouslyAllowMutability: options.dangerouslyAllowMutability,
      shouldRestoreFromSnapshots: false,
      retainedBy
    });
  } else {
    return recoilValue = registerNode$1({
      key,
      nodeType: 'selector',
      peek: selectorPeek,
      get: selectorGet,
      init: selectorInit,
      invalidate: invalidateSelector,
      clearCache: clearSelectorCache,
      shouldDeleteConfigOnRelease: selectorShouldDeleteConfigOnRelease,
      dangerouslyAllowMutability: options.dangerouslyAllowMutability,
      shouldRestoreFromSnapshots: false,
      retainedBy
    });
  }
}
/* eslint-enable no-redeclare */
// $FlowIssue[incompatible-use]
// $FlowFixMe[missing-local-annot]


selector.value = value => new WrappedValue$1(value);

var Recoil_selector = selector;

// @fb-only: import type {ScopeRules} from 'Recoil_ScopedAtom';
// @fb-only: const {scopedAtom} = require('Recoil_ScopedAtom');
const {
  isLoadable: isLoadable$2,
  loadableWithError: loadableWithError$2,
  loadableWithPromise: loadableWithPromise$2,
  loadableWithValue: loadableWithValue$3
} = Recoil_Loadable$1;

const {
  WrappedValue: WrappedValue$2
} = Recoil_Wrapper$1;

const {
  peekNodeInfo: peekNodeInfo$3
} = Recoil_FunctionalCore;

const {
  DEFAULT_VALUE: DEFAULT_VALUE$7,
  DefaultValue: DefaultValue$2,
  getConfigDeletionHandler: getConfigDeletionHandler$2,
  registerNode: registerNode$2,
  setConfigDeletionHandler: setConfigDeletionHandler$1
} = Recoil_Node;

const {
  isRecoilValue: isRecoilValue$4
} = Recoil_RecoilValue$1;

const {
  getRecoilValueAsLoadable: getRecoilValueAsLoadable$4,
  markRecoilValueModified: markRecoilValueModified$2,
  setRecoilValue: setRecoilValue$4,
  setRecoilValueLoadable: setRecoilValueLoadable$2
} = Recoil_RecoilValueInterface;

const {
  retainedByOptionWithDefault: retainedByOptionWithDefault$2
} = Recoil_Retention;















const unwrap = x => x instanceof WrappedValue$2 ? x.value : x;

function baseAtom(options) {
  const {
    key,
    persistence_UNSTABLE: persistence
  } = options;
  const retainedBy = retainedByOptionWithDefault$2(options.retainedBy_UNSTABLE);
  let liveStoresCount = 0;

  function unwrapPromise(promise) {
    return loadableWithPromise$2(promise.then(value => {
      defaultLoadable = loadableWithValue$3(value);
      return value;
    }).catch(error => {
      defaultLoadable = loadableWithError$2(error);
      throw error;
    }));
  }

  let defaultLoadable = Recoil_isPromise(options.default) ? unwrapPromise(options.default) : isLoadable$2(options.default) ? options.default.state === 'loading' ? unwrapPromise(options.default.contents) : options.default : loadableWithValue$3(unwrap(options.default));
  maybeFreezeValueOrPromise(defaultLoadable.contents);
  let cachedAnswerForUnvalidatedValue = undefined; // Cleanup handlers for this atom
  // Rely on stable reference equality of the store to use it as a key per <RecoilRoot>

  const cleanupEffectsByStore = new Map();

  function maybeFreezeValueOrPromise(valueOrPromise) {
    if (false) {}

    return valueOrPromise;
  }

  function wrapPendingPromise(store, promise) {
    const wrappedPromise = promise.then(value => {
      var _store$getState$nextT, _state$atomValues$get;

      const state = (_store$getState$nextT = store.getState().nextTree) !== null && _store$getState$nextT !== void 0 ? _store$getState$nextT : store.getState().currentTree;

      if (((_state$atomValues$get = state.atomValues.get(key)) === null || _state$atomValues$get === void 0 ? void 0 : _state$atomValues$get.contents) === wrappedPromise) {
        setRecoilValue$4(store, node, value);
      }

      return value;
    }).catch(error => {
      var _store$getState$nextT2, _state$atomValues$get2;

      const state = (_store$getState$nextT2 = store.getState().nextTree) !== null && _store$getState$nextT2 !== void 0 ? _store$getState$nextT2 : store.getState().currentTree;

      if (((_state$atomValues$get2 = state.atomValues.get(key)) === null || _state$atomValues$get2 === void 0 ? void 0 : _state$atomValues$get2.contents) === wrappedPromise) {
        setRecoilValueLoadable$2(store, node, loadableWithError$2(error));
      }

      throw error;
    });
    return wrappedPromise;
  }

  function initAtom(store, initState, trigger) {
    var _options$effects;

    liveStoresCount++;

    const cleanupAtom = () => {
      var _cleanupEffectsByStor;

      liveStoresCount--;
      (_cleanupEffectsByStor = cleanupEffectsByStore.get(store)) === null || _cleanupEffectsByStor === void 0 ? void 0 : _cleanupEffectsByStor.forEach(cleanup => cleanup());
      cleanupEffectsByStore.delete(store);
    };

    store.getState().knownAtoms.add(key); // Setup async defaults to notify subscribers when they resolve

    if (defaultLoadable.state === 'loading') {
      const notifyDefaultSubscribers = () => {
        var _store$getState$nextT3;

        const state = (_store$getState$nextT3 = store.getState().nextTree) !== null && _store$getState$nextT3 !== void 0 ? _store$getState$nextT3 : store.getState().currentTree;

        if (!state.atomValues.has(key)) {
          markRecoilValueModified$2(store, node);
        }
      };

      defaultLoadable.contents.finally(notifyDefaultSubscribers);
    } ///////////////////
    // Run Atom Effects
    ///////////////////


    const effects = (_options$effects = options.effects) !== null && _options$effects !== void 0 ? _options$effects : options.effects_UNSTABLE;

    if (effects != null) {
      // This state is scoped by Store, since this is in the initAtom() closure
      let initValue = DEFAULT_VALUE$7;
      let isDuringInit = true;
      let isInitError = false;
      let pendingSetSelf = null;

      function getLoadable(recoilValue) {
        // Normally we can just get the current value of another atom.
        // But for our own value we need to check if there is a pending
        // initialized value or get the fallback default value.
        if (isDuringInit && recoilValue.key === key) {
          // Cast T to S
          const retValue = initValue; // flowlint-line unclear-type:off

          return retValue instanceof DefaultValue$2 ? peekAtom(store, initState) // flowlint-line unclear-type:off
          : Recoil_isPromise(retValue) ? loadableWithPromise$2(retValue.then(v => v instanceof DefaultValue$2 ? // Cast T to S
          defaultLoadable.toPromise() // flowlint-line unclear-type:off
          : v)) : loadableWithValue$3(retValue);
        }

        return getRecoilValueAsLoadable$4(store, recoilValue);
      }

      function getPromise(recoilValue) {
        return getLoadable(recoilValue).toPromise();
      }

      function getInfo_UNSTABLE(recoilValue) {
        var _store$getState$nextT4;

        const info = peekNodeInfo$3(store, (_store$getState$nextT4 = store.getState().nextTree) !== null && _store$getState$nextT4 !== void 0 ? _store$getState$nextT4 : store.getState().currentTree, recoilValue.key);
        return isDuringInit && recoilValue.key === key && !(initValue instanceof DefaultValue$2) ? { ...info,
          isSet: true,
          loadable: getLoadable(recoilValue)
        } : info;
      }

      const setSelf = effect => valueOrUpdater => {
        if (isDuringInit) {
          const currentLoadable = getLoadable(node);
          const currentValue = currentLoadable.state === 'hasValue' ? currentLoadable.contents : DEFAULT_VALUE$7;
          initValue = typeof valueOrUpdater === 'function' ? // cast to any because we can't restrict T from being a function without losing support for opaque types
          valueOrUpdater(currentValue) // flowlint-line unclear-type:off
          : valueOrUpdater;

          if (Recoil_isPromise(initValue)) {
            initValue = initValue.then(value => {
              // Avoid calling onSet() when setSelf() initializes with a Promise
              pendingSetSelf = {
                effect,
                value
              };
              return value;
            });
          }
        } else {
          if (Recoil_isPromise(valueOrUpdater)) {
            throw Recoil_err('Setting atoms to async values is not implemented.');
          }

          if (typeof valueOrUpdater !== 'function') {
            pendingSetSelf = {
              effect,
              value: unwrap(valueOrUpdater)
            };
          }

          setRecoilValue$4(store, node, typeof valueOrUpdater === 'function' ? currentValue => {
            const newValue = unwrap( // cast to any because we can't restrict T from being a function without losing support for opaque types
            valueOrUpdater(currentValue) // flowlint-line unclear-type:off
            );
            pendingSetSelf = {
              effect,
              value: newValue
            };
            return newValue;
          } : unwrap(valueOrUpdater));
        }
      };

      const resetSelf = effect => () => setSelf(effect)(DEFAULT_VALUE$7);

      const onSet = effect => handler => {
        var _cleanupEffectsByStor2;

        const {
          release
        } = store.subscribeToTransactions(currentStore => {
          var _currentTree$atomValu;

          // eslint-disable-next-line prefer-const
          let {
            currentTree,
            previousTree
          } = currentStore.getState();

          if (!previousTree) {
            Recoil_recoverableViolation('Transaction subscribers notified without a next tree being present -- this is a bug in Recoil');
            previousTree = currentTree; // attempt to trundle on
          }

          const newLoadable = (_currentTree$atomValu = currentTree.atomValues.get(key)) !== null && _currentTree$atomValu !== void 0 ? _currentTree$atomValu : defaultLoadable;

          if (newLoadable.state === 'hasValue') {
            var _previousTree$atomVal, _pendingSetSelf, _pendingSetSelf2, _pendingSetSelf3;

            const newValue = newLoadable.contents;
            const oldLoadable = (_previousTree$atomVal = previousTree.atomValues.get(key)) !== null && _previousTree$atomVal !== void 0 ? _previousTree$atomVal : defaultLoadable;
            const oldValue = oldLoadable.state === 'hasValue' ? oldLoadable.contents : DEFAULT_VALUE$7; // TODO This isn't actually valid, use as a placeholder for now.
            // Ignore atom value changes that were set via setSelf() in the same effect.
            // We will still properly call the handler if there was a subsequent
            // set from something other than an atom effect which was batched
            // with the `setSelf()` call.  However, we may incorrectly ignore
            // the handler if the subsequent batched call happens to set the
            // atom to the exact same value as the `setSelf()`.   But, in that
            // case, it was kind of a noop, so the semantics are debatable..

            if (((_pendingSetSelf = pendingSetSelf) === null || _pendingSetSelf === void 0 ? void 0 : _pendingSetSelf.effect) !== effect || ((_pendingSetSelf2 = pendingSetSelf) === null || _pendingSetSelf2 === void 0 ? void 0 : _pendingSetSelf2.value) !== newValue) {
              handler(newValue, oldValue, !currentTree.atomValues.has(key));
            } else if (((_pendingSetSelf3 = pendingSetSelf) === null || _pendingSetSelf3 === void 0 ? void 0 : _pendingSetSelf3.effect) === effect) {
              pendingSetSelf = null;
            }
          }
        }, key);
        cleanupEffectsByStore.set(store, [...((_cleanupEffectsByStor2 = cleanupEffectsByStore.get(store)) !== null && _cleanupEffectsByStor2 !== void 0 ? _cleanupEffectsByStor2 : []), release]);
      };

      for (const effect of effects) {
        try {
          const cleanup = effect({
            node,
            storeID: store.storeID,
            parentStoreID_UNSTABLE: store.parentStoreID,
            trigger,
            setSelf: setSelf(effect),
            resetSelf: resetSelf(effect),
            onSet: onSet(effect),
            getPromise,
            getLoadable,
            getInfo_UNSTABLE
          });

          if (cleanup != null) {
            var _cleanupEffectsByStor3;

            cleanupEffectsByStore.set(store, [...((_cleanupEffectsByStor3 = cleanupEffectsByStore.get(store)) !== null && _cleanupEffectsByStor3 !== void 0 ? _cleanupEffectsByStor3 : []), cleanup]);
          }
        } catch (error) {
          initValue = error;
          isInitError = true;
        }
      }

      isDuringInit = false; // Mutate initial state in place since we know there are no other subscribers
      // since we are the ones initializing on first use.

      if (!(initValue instanceof DefaultValue$2)) {
        var _store$getState$nextT5;

        const initLoadable = isInitError ? loadableWithError$2(initValue) : Recoil_isPromise(initValue) ? loadableWithPromise$2(wrapPendingPromise(store, initValue)) : loadableWithValue$3(unwrap(initValue));
        maybeFreezeValueOrPromise(initLoadable.contents);
        initState.atomValues.set(key, initLoadable); // If there is a pending transaction, then also mutate the next state tree.
        // This could happen if the atom was first initialized in an action that
        // also updated some other atom's state.

        (_store$getState$nextT5 = store.getState().nextTree) === null || _store$getState$nextT5 === void 0 ? void 0 : _store$getState$nextT5.atomValues.set(key, initLoadable);
      }
    }

    return cleanupAtom;
  }

  function peekAtom(_store, state) {
    var _ref, _state$atomValues$get3;

    return (_ref = (_state$atomValues$get3 = state.atomValues.get(key)) !== null && _state$atomValues$get3 !== void 0 ? _state$atomValues$get3 : cachedAnswerForUnvalidatedValue) !== null && _ref !== void 0 ? _ref : defaultLoadable;
  }

  function getAtom(_store, state) {
    if (state.atomValues.has(key)) {
      // Atom value is stored in state:
      return Recoil_nullthrows(state.atomValues.get(key));
    } else if (state.nonvalidatedAtoms.has(key)) {
      // Atom value is stored but needs validation before use.
      // We might have already validated it and have a cached validated value:
      if (cachedAnswerForUnvalidatedValue != null) {
        return cachedAnswerForUnvalidatedValue;
      }

      if (persistence == null) {
        Recoil_expectationViolation(`Tried to restore a persisted value for atom ${key} but it has no persistence settings.`);
        return defaultLoadable;
      }

      const nonvalidatedValue = state.nonvalidatedAtoms.get(key);
      const validatorResult = persistence.validator(nonvalidatedValue, DEFAULT_VALUE$7);
      const validatedValueLoadable = validatorResult instanceof DefaultValue$2 ? defaultLoadable : loadableWithValue$3(validatorResult);
      cachedAnswerForUnvalidatedValue = validatedValueLoadable;
      return cachedAnswerForUnvalidatedValue;
    } else {
      return defaultLoadable;
    }
  }

  function invalidateAtom() {
    cachedAnswerForUnvalidatedValue = undefined;
  }

  function setAtom(_store, state, newValue) {
    // Bail out if we're being set to the existing value, or if we're being
    // reset but have no stored value (validated or unvalidated) to reset from:
    if (state.atomValues.has(key)) {
      const existing = Recoil_nullthrows(state.atomValues.get(key));

      if (existing.state === 'hasValue' && newValue === existing.contents) {
        return new Map();
      }
    } else if (!state.nonvalidatedAtoms.has(key) && newValue instanceof DefaultValue$2) {
      return new Map();
    }

    maybeFreezeValueOrPromise(newValue);
    cachedAnswerForUnvalidatedValue = undefined; // can be released now if it was previously in use

    return new Map().set(key, loadableWithValue$3(newValue));
  }

  function shouldDeleteConfigOnReleaseAtom() {
    return getConfigDeletionHandler$2(key) !== undefined && liveStoresCount <= 0;
  }

  const node = registerNode$2({
    key,
    nodeType: 'atom',
    peek: peekAtom,
    get: getAtom,
    set: setAtom,
    init: initAtom,
    invalidate: invalidateAtom,
    shouldDeleteConfigOnRelease: shouldDeleteConfigOnReleaseAtom,
    dangerouslyAllowMutability: options.dangerouslyAllowMutability,
    persistence_UNSTABLE: options.persistence_UNSTABLE ? {
      type: options.persistence_UNSTABLE.type,
      backButton: options.persistence_UNSTABLE.backButton
    } : undefined,
    shouldRestoreFromSnapshots: true,
    retainedBy
  });
  return node;
} // prettier-ignore


function atom(options) {
  if (false) {}

  const { // @fb-only: scopeRules_APPEND_ONLY_READ_THE_DOCS,
    ...restOptions
  } = options;
  const optionsDefault = 'default' in options ? // $FlowIssue[incompatible-type] No way to refine in Flow that property is not defined
  options.default : new Promise(() => {});

  if (isRecoilValue$4(optionsDefault) // Continue to use atomWithFallback for promise defaults for scoped atoms
  // for now, since scoped atoms don't support async defaults
  // @fb-only: || (isPromise(optionsDefault) && scopeRules_APPEND_ONLY_READ_THE_DOCS)
  // @fb-only: || (isLoadable(optionsDefault) && scopeRules_APPEND_ONLY_READ_THE_DOCS)
  ) {
    return atomWithFallback({ ...restOptions,
      default: optionsDefault // @fb-only: scopeRules_APPEND_ONLY_READ_THE_DOCS,

    }); // @fb-only: } else if (scopeRules_APPEND_ONLY_READ_THE_DOCS
    // @fb-only: && !isPromise(optionsDefault)
    // @fb-only: && !isLoadable(optionsDefault)
    // @fb-only: ) {
    // @fb-only: return scopedAtom<T>({
    // @fb-only: ...restOptions,
    // @fb-only: default: unwrap<T>(optionsDefault),
    // @fb-only: scopeRules_APPEND_ONLY_READ_THE_DOCS,
    // @fb-only: });
  } else {
    return baseAtom({ ...restOptions,
      default: optionsDefault
    });
  }
}

function atomWithFallback(options) {
  const base = atom({ ...options,
    default: DEFAULT_VALUE$7,
    persistence_UNSTABLE: options.persistence_UNSTABLE === undefined ? undefined : { ...options.persistence_UNSTABLE,
      validator: storedValue => storedValue instanceof DefaultValue$2 ? storedValue : Recoil_nullthrows(options.persistence_UNSTABLE).validator(storedValue, DEFAULT_VALUE$7)
    },
    // TODO Hack for now.
    effects: options.effects,
    // flowlint-line unclear-type: off
    effects_UNSTABLE: options.effects_UNSTABLE // flowlint-line unclear-type: off

  });
  const sel = Recoil_selector({
    key: `${options.key}__withFallback`,
    get: ({
      get
    }) => {
      const baseValue = get(base);
      return baseValue instanceof DefaultValue$2 ? options.default : baseValue;
    },
    set: ({
      set
    }, newValue) => set(base, newValue),
    // This selector does not need to cache as it is a wrapper selector
    // and the selector within the wrapper selector will have a cache
    // option by default
    cachePolicy_UNSTABLE: {
      eviction: 'most-recent'
    },
    dangerouslyAllowMutability: options.dangerouslyAllowMutability
  });
  setConfigDeletionHandler$1(sel.key, getConfigDeletionHandler$2(options.key));
  return sel;
} // $FlowFixMe[missing-local-annot]


atom.value = value => new WrappedValue$2(value);

var Recoil_atom = atom;

/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */

class MapCache {
  constructor(options) {
    var _options$mapKey;

    _defineProperty(this, "_map", void 0);

    _defineProperty(this, "_keyMapper", void 0);

    this._map = new Map();
    this._keyMapper = (_options$mapKey = options === null || options === void 0 ? void 0 : options.mapKey) !== null && _options$mapKey !== void 0 ? _options$mapKey : v => v;
  }

  size() {
    return this._map.size;
  }

  has(key) {
    return this._map.has(this._keyMapper(key));
  }

  get(key) {
    return this._map.get(this._keyMapper(key));
  }

  set(key, val) {
    this._map.set(this._keyMapper(key), val);
  }

  delete(key) {
    this._map.delete(this._keyMapper(key));
  }

  clear() {
    this._map.clear();
  }

}

var Recoil_MapCache = {
  MapCache
};

var Recoil_MapCache_1 = Recoil_MapCache.MapCache;

var Recoil_MapCache$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  MapCache: Recoil_MapCache_1
});

const {
  LRUCache: LRUCache$2
} = Recoil_LRUCache$1;

const {
  MapCache: MapCache$1
} = Recoil_MapCache$1;







const defaultPolicy$1 = {
  equality: 'reference',
  eviction: 'none',
  maxSize: Infinity
};

function cacheFromPolicy({
  equality = defaultPolicy$1.equality,
  eviction = defaultPolicy$1.eviction,
  maxSize = defaultPolicy$1.maxSize
} = defaultPolicy$1) {
  const valueMapper = getValueMapper$1(equality);
  const cache = getCache(eviction, maxSize, valueMapper);
  return cache;
}

function getValueMapper$1(equality) {
  switch (equality) {
    case 'reference':
      return val => val;

    case 'value':
      return val => Recoil_stableStringify(val);
  }

  throw Recoil_err(`Unrecognized equality policy ${equality}`);
}

function getCache(eviction, maxSize, mapKey) {
  switch (eviction) {
    case 'keep-all':
      return new MapCache$1({
        mapKey
      });

    case 'lru':
      return new LRUCache$2({
        mapKey,
        maxSize: Recoil_nullthrows(maxSize)
      });

    case 'most-recent':
      return new LRUCache$2({
        mapKey,
        maxSize: 1
      });
  }

  throw Recoil_err(`Unrecognized eviction policy ${eviction}`);
}

var Recoil_cacheFromPolicy = cacheFromPolicy;

// @fb-only: import type {ScopeRules} from 'Recoil_ScopedAtom';


const {
  setConfigDeletionHandler: setConfigDeletionHandler$2
} = Recoil_Node;





// Process scopeRules to handle any entries which are functions taking parameters
// prettier-ignore
// @fb-only: function mapScopeRules<P>(
// @fb-only: scopeRules?: ParameterizedScopeRules<P>,
// @fb-only: param: P,
// @fb-only: ): ScopeRules | void {
// @fb-only: return scopeRules?.map(rule =>
// @fb-only: Array.isArray(rule)
// @fb-only: ? rule.map(entry => (typeof entry === 'function' ? entry(param) : entry))
// @fb-only: : rule,
// @fb-only: );
// @fb-only: }

/*
A function which returns an atom based on the input parameter.

Each unique parameter returns a unique atom. E.g.,

  const f = atomFamily(...);
  f({a: 1}) => an atom
  f({a: 2}) => a different atom

This allows components to persist local, private state using atoms.  Each
instance of the component may have a different key, which it uses as the
parameter for a family of atoms; in this way, each component will have
its own atom not shared by other instances.  These state keys may be composed
into children's state keys as well.
*/
function atomFamily(options) {
  var _options$cachePolicyF, _options$cachePolicyF2;

  const atomCache = Recoil_cacheFromPolicy({
    equality: (_options$cachePolicyF = (_options$cachePolicyF2 = options.cachePolicyForParams_UNSTABLE) === null || _options$cachePolicyF2 === void 0 ? void 0 : _options$cachePolicyF2.equality) !== null && _options$cachePolicyF !== void 0 ? _options$cachePolicyF : 'value',
    eviction: 'keep-all'
  }); // Simple atomFamily implementation to cache individual atoms based
  // on the parameter value equality.

  return params => {
    var _stableStringify, _options$effects;

    const cachedAtom = atomCache.get(params);

    if (cachedAtom != null) {
      return cachedAtom;
    }

    const {
      cachePolicyForParams_UNSTABLE,
      ...atomOptions
    } = options;
    const optionsDefault = 'default' in options ? // $FlowIssue[incompatible-type] No way to refine in Flow that property is not defined
    options.default : new Promise(() => {});
    const newAtom = Recoil_atom({ ...atomOptions,
      key: `${options.key}__${(_stableStringify = Recoil_stableStringify(params)) !== null && _stableStringify !== void 0 ? _stableStringify : 'void'}`,
      default: typeof optionsDefault === 'function' ? // The default was parameterized
      // Flow doesn't know that T isn't a function, so we need to case to any
      // $FlowIssue[incompatible-use]
      optionsDefault(params) : // Default may be a static value, promise, or RecoilValue
      optionsDefault,
      retainedBy_UNSTABLE: typeof options.retainedBy_UNSTABLE === 'function' ? options.retainedBy_UNSTABLE(params) : options.retainedBy_UNSTABLE,
      effects: typeof options.effects === 'function' ? options.effects(params) : typeof options.effects_UNSTABLE === 'function' ? options.effects_UNSTABLE(params) : (_options$effects = options.effects) !== null && _options$effects !== void 0 ? _options$effects : options.effects_UNSTABLE // prettier-ignore
      // @fb-only: scopeRules_APPEND_ONLY_READ_THE_DOCS: mapScopeRules(
      // @fb-only: options.scopeRules_APPEND_ONLY_READ_THE_DOCS,
      // @fb-only: params,
      // @fb-only: ),

    });
    atomCache.set(params, newAtom);
    setConfigDeletionHandler$2(newAtom.key, () => {
      atomCache.delete(params);
    });
    return newAtom;
  };
}

var Recoil_atomFamily = atomFamily;

const {
  setConfigDeletionHandler: setConfigDeletionHandler$3
} = Recoil_Node;





 // Keep in mind the parameter needs to be serializable as a cahche key
// using Recoil_stableStringify


// Add a unique index to each selector in case the cache implementation allows
// duplicate keys based on equivalent stringified parameters
let nextIndex = 0;
/* eslint-disable no-redeclare */

// Return a function that returns members of a family of selectors of the same type
// E.g.,
//
// const s = selectorFamily(...);
// s({a: 1}) => a selector
// s({a: 2}) => a different selector
//
// By default, the selectors are distinguished by distinct values of the
// parameter based on value equality, not reference equality.  This allows using
// object literals or other equivalent objects at callsites to not create
// duplicate cache entries.  This behavior may be overridden with the
// cacheImplementationForParams option.
function selectorFamily(options) {
  var _options$cachePolicyF, _options$cachePolicyF2;

  const selectorCache = Recoil_cacheFromPolicy({
    equality: (_options$cachePolicyF = (_options$cachePolicyF2 = options.cachePolicyForParams_UNSTABLE) === null || _options$cachePolicyF2 === void 0 ? void 0 : _options$cachePolicyF2.equality) !== null && _options$cachePolicyF !== void 0 ? _options$cachePolicyF : 'value',
    eviction: 'keep-all'
  });
  return params => {
    var _stableStringify;

    // Throw an error with selector key so that it is clear which
    // selector is causing an error
    let cachedSelector;

    try {
      cachedSelector = selectorCache.get(params);
    } catch (error) {
      throw Recoil_err(`Problem with cache lookup for selector ${options.key}: ${error.message}`);
    }

    if (cachedSelector != null) {
      return cachedSelector;
    }

    const myKey = `${options.key}__selectorFamily/${(_stableStringify = Recoil_stableStringify(params, {
      // It is possible to use functions in parameters if the user uses
      // a cache with reference equality thanks to the incrementing index.
      allowFunctions: true
    })) !== null && _stableStringify !== void 0 ? _stableStringify : 'void'}/${nextIndex++}`; // Append index in case values serialize to the same key string

    const myGet = callbacks => options.get(params)(callbacks);

    const myCachePolicy = options.cachePolicy_UNSTABLE;
    const retainedBy = typeof options.retainedBy_UNSTABLE === 'function' ? options.retainedBy_UNSTABLE(params) : options.retainedBy_UNSTABLE;
    let newSelector;

    if (options.set != null) {
      const set = options.set;

      const mySet = (callbacks, newValue) => set(params)(callbacks, newValue);

      newSelector = Recoil_selector({
        key: myKey,
        get: myGet,
        set: mySet,
        cachePolicy_UNSTABLE: myCachePolicy,
        dangerouslyAllowMutability: options.dangerouslyAllowMutability,
        retainedBy_UNSTABLE: retainedBy
      });
    } else {
      newSelector = Recoil_selector({
        key: myKey,
        get: myGet,
        cachePolicy_UNSTABLE: myCachePolicy,
        dangerouslyAllowMutability: options.dangerouslyAllowMutability,
        retainedBy_UNSTABLE: retainedBy
      });
    }

    selectorCache.set(params, newSelector);
    setConfigDeletionHandler$3(newSelector.key, () => {
      selectorCache.delete(params);
    });
    return newSelector;
  };
}
/* eslint-enable no-redeclare */


var Recoil_selectorFamily = selectorFamily;

// flowlint-next-line unclear-type:off


const constantSelector = Recoil_selectorFamily({
  key: '__constant',
  get: constant => () => constant,
  cachePolicyForParams_UNSTABLE: {
    equality: 'reference'
  }
}); // Function that returns a selector which always produces the
// same constant value.  It may be called multiple times with the
// same value, based on reference equality, and will provide the
// same selector.

function constSelector(constant) {
  return constantSelector(constant);
}

var Recoil_constSelector = constSelector;

// flowlint-next-line unclear-type:off


const throwingSelector = Recoil_selectorFamily({
  key: '__error',
  get: message => () => {
    throw Recoil_err(message);
  },
  // TODO Why?
  cachePolicyForParams_UNSTABLE: {
    equality: 'reference'
  }
}); // Function that returns a selector which always throws an error
// with the provided message.

function errorSelector(message) {
  return throwingSelector(message);
}

var Recoil_errorSelector = errorSelector;

/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * Wraps another recoil value and prevents writing to it.
 *
 * 
 * @format
 * @oncall recoil
 */

function readOnlySelector(atom) {
  // flowlint-next-line unclear-type: off
  return atom;
}

var Recoil_readOnlySelector = readOnlySelector;

const {
  loadableWithError: loadableWithError$3,
  loadableWithPromise: loadableWithPromise$3,
  loadableWithValue: loadableWithValue$4
} = Recoil_Loadable$1;





 /////////////////
//  TRUTH TABLE
/////////////////
// Dependencies        waitForNone         waitForAny        waitForAll       waitForAllSettled
//  [loading, loading]  [Promise, Promise]  Promise           Promise         Promise
//  [value, loading]    [value, Promise]    [value, Promise]  Promise         Promise
//  [value, value]      [value, value]      [value, value]    [value, value]  [value, value]
//
//  [error, loading]    [Error, Promise]    [Error, Promise]  Error           Promise
//  [error, error]      [Error, Error]      [Error, Error]    Error           [error, error]
//  [value, error]      [value, Error]      [value, Error]    Error           [value, error]
// Issue parallel requests for all dependencies and return the current
// status if they have results, have some error, or are still pending.


function concurrentRequests(getRecoilValue, deps) {
  const results = Array(deps.length).fill(undefined);
  const exceptions = Array(deps.length).fill(undefined);

  for (const [i, dep] of deps.entries()) {
    try {
      results[i] = getRecoilValue(dep);
    } catch (e) {
      // exceptions can either be Promises of pending results or real errors
      exceptions[i] = e;
    }
  }

  return [results, exceptions];
}

function isError(exp) {
  return exp != null && !Recoil_isPromise(exp);
}

function unwrapDependencies(dependencies) {
  return Array.isArray(dependencies) ? dependencies : Object.getOwnPropertyNames(dependencies).map(key => dependencies[key]);
}

function wrapResults(dependencies,
/* $FlowFixMe[missing-local-annot] The type annotation(s) required by Flow's
 * LTI update could not be added via codemod */
results) {
  return Array.isArray(dependencies) ? results : // Object.getOwnPropertyNames() has consistent key ordering with ES6
  Object.getOwnPropertyNames(dependencies).reduce((out, key, idx) => ({ ...out,
    [key]: results[idx]
  }), {});
}

function wrapLoadables(dependencies, results, exceptions) {
  const output = exceptions.map((exception, idx) => exception == null ? loadableWithValue$4(results[idx]) : Recoil_isPromise(exception) ? loadableWithPromise$3(exception) : loadableWithError$3(exception));
  return wrapResults(dependencies, output);
}

function combineAsyncResultsWithSyncResults(syncResults, asyncResults) {
  return asyncResults.map((result, idx) =>
  /**
   * it's important we use === undefined as opposed to == null, because the
   * resolved value of the async promise could be `null`, in which case we
   * don't want to use syncResults[idx], which would be undefined. If async
   * promise resolves to `undefined`, that's ok because `syncResults[idx]`
   * will also be `undefined`. That's a little hacky, but it works.
   */
  result === undefined ? syncResults[idx] : result);
} // Selector that requests all dependencies in parallel and immediately returns
// current results without waiting.


const waitForNone = Recoil_selectorFamily({
  key: '__waitForNone',
  get: dependencies => ({
    get
  }) => {
    // Issue requests for all dependencies in parallel.
    const deps = unwrapDependencies(dependencies);
    const [results, exceptions] = concurrentRequests(get, deps); // Always return the current status of the results; never block.

    return wrapLoadables(dependencies, results, exceptions);
  },
  dangerouslyAllowMutability: true
}); // Selector that requests all dependencies in parallel and waits for at least
// one to be available before returning results.  It will only error if all
// dependencies have errors.

const waitForAny = Recoil_selectorFamily({
  key: '__waitForAny',
  get: dependencies => ({
    get
  }) => {
    // Issue requests for all dependencies in parallel.
    // Exceptions can either be Promises of pending results or real errors
    const deps = unwrapDependencies(dependencies);
    const [results, exceptions] = concurrentRequests(get, deps); // If any results are available, value or error, return the current status

    if (exceptions.some(exp => !Recoil_isPromise(exp))) {
      return wrapLoadables(dependencies, results, exceptions);
    } // Otherwise, return a promise that will resolve when the next result is
    // available, whichever one happens to be next.  But, if all pending
    // dependencies end up with errors, then reject the promise.


    return new Promise(resolve => {
      for (const [i, exp] of exceptions.entries()) {
        if (Recoil_isPromise(exp)) {
          exp.then(result => {
            results[i] = result;
            exceptions[i] = undefined;
            resolve(wrapLoadables(dependencies, results, exceptions));
          }).catch(error => {
            exceptions[i] = error;
            resolve(wrapLoadables(dependencies, results, exceptions));
          });
        }
      }
    });
  },
  dangerouslyAllowMutability: true
}); // Selector that requests all dependencies in parallel and waits for all to be
// available before returning a value.  It will error if any dependencies error.

const waitForAll = Recoil_selectorFamily({
  key: '__waitForAll',
  get: dependencies => ({
    get
  }) => {
    // Issue requests for all dependencies in parallel.
    // Exceptions can either be Promises of pending results or real errors
    const deps = unwrapDependencies(dependencies);
    const [results, exceptions] = concurrentRequests(get, deps); // If all results are available, return the results

    if (exceptions.every(exp => exp == null)) {
      return wrapResults(dependencies, results);
    } // If we have any errors, throw the first error


    const error = exceptions.find(isError);

    if (error != null) {
      throw error;
    } // Otherwise, return a promise that will resolve when all results are available


    return Promise.all(exceptions).then(exceptionResults => wrapResults(dependencies, combineAsyncResultsWithSyncResults(results, exceptionResults)));
  },
  dangerouslyAllowMutability: true
});
const waitForAllSettled = Recoil_selectorFamily({
  key: '__waitForAllSettled',
  get: dependencies => ({
    get
  }) => {
    // Issue requests for all dependencies in parallel.
    // Exceptions can either be Promises of pending results or real errors
    const deps = unwrapDependencies(dependencies);
    const [results, exceptions] = concurrentRequests(get, deps); // If all results are available, return the results

    if (exceptions.every(exp => !Recoil_isPromise(exp))) {
      return wrapLoadables(dependencies, results, exceptions);
    } // Wait for all results to settle


    return Promise.all(exceptions.map((exp, i) => Recoil_isPromise(exp) ? exp.then(result => {
      results[i] = result;
      exceptions[i] = undefined;
    }).catch(error => {
      results[i] = undefined;
      exceptions[i] = error;
    }) : null)) // Then wrap them as loadables
    .then(() => wrapLoadables(dependencies, results, exceptions));
  },
  dangerouslyAllowMutability: true
});
const noWait = Recoil_selectorFamily({
  key: '__noWait',
  get: dependency => ({
    get
  }) => {
    try {
      return Recoil_selector.value(loadableWithValue$4(get(dependency)));
    } catch (exception) {
      return Recoil_selector.value(Recoil_isPromise(exception) ? loadableWithPromise$3(exception) : loadableWithError$3(exception));
    }
  },
  dangerouslyAllowMutability: true
});
var Recoil_WaitFor = {
  waitForNone,
  waitForAny,
  waitForAll,
  waitForAllSettled,
  noWait
};

const {
  RecoilLoadable
} = Recoil_Loadable$1;

const {
  DefaultValue: DefaultValue$3
} = Recoil_Node;



const {
  RecoilRoot: RecoilRoot$2,
  useRecoilStoreID: useRecoilStoreID$1
} = Recoil_RecoilRoot;

const {
  isRecoilValue: isRecoilValue$5
} = Recoil_RecoilValue$1;

const {
  retentionZone: retentionZone$1
} = Recoil_RetentionZone;

const {
  freshSnapshot: freshSnapshot$2
} = Recoil_Snapshot$1;

const {
  useRecoilState: useRecoilState$1,
  useRecoilState_TRANSITION_SUPPORT_UNSTABLE: useRecoilState_TRANSITION_SUPPORT_UNSTABLE$1,
  useRecoilStateLoadable: useRecoilStateLoadable$1,
  useRecoilValue: useRecoilValue$1,
  useRecoilValue_TRANSITION_SUPPORT_UNSTABLE: useRecoilValue_TRANSITION_SUPPORT_UNSTABLE$1,
  useRecoilValueLoadable: useRecoilValueLoadable$1,
  useRecoilValueLoadable_TRANSITION_SUPPORT_UNSTABLE: useRecoilValueLoadable_TRANSITION_SUPPORT_UNSTABLE$1,
  useResetRecoilState: useResetRecoilState$1,
  useSetRecoilState: useSetRecoilState$1
} = Recoil_Hooks;

const {
  useGotoRecoilSnapshot: useGotoRecoilSnapshot$1,
  useRecoilSnapshot: useRecoilSnapshot$1,
  useRecoilTransactionObserver: useRecoilTransactionObserver$1
} = Recoil_SnapshotHooks;





const {
  useRecoilCallback: useRecoilCallback$1
} = Recoil_useRecoilCallback;





















const {
  noWait: noWait$1,
  waitForAll: waitForAll$1,
  waitForAllSettled: waitForAllSettled$1,
  waitForAny: waitForAny$1,
  waitForNone: waitForNone$1
} = Recoil_WaitFor;

var Recoil_index = {
  // Types
  DefaultValue: DefaultValue$3,
  isRecoilValue: isRecoilValue$5,
  RecoilLoadable,
  // Global Recoil environment settiongs
  RecoilEnv: Recoil_RecoilEnv,
  // Recoil Root
  RecoilRoot: RecoilRoot$2,
  useRecoilStoreID: useRecoilStoreID$1,
  useRecoilBridgeAcrossReactRoots_UNSTABLE: Recoil_useRecoilBridgeAcrossReactRoots,
  // Atoms/Selectors
  atom: Recoil_atom,
  selector: Recoil_selector,
  // Convenience Atoms/Selectors
  atomFamily: Recoil_atomFamily,
  selectorFamily: Recoil_selectorFamily,
  constSelector: Recoil_constSelector,
  errorSelector: Recoil_errorSelector,
  readOnlySelector: Recoil_readOnlySelector,
  // Concurrency Helpers for Atoms/Selectors
  noWait: noWait$1,
  waitForNone: waitForNone$1,
  waitForAny: waitForAny$1,
  waitForAll: waitForAll$1,
  waitForAllSettled: waitForAllSettled$1,
  // Hooks for Atoms/Selectors
  useRecoilValue: useRecoilValue$1,
  useRecoilValueLoadable: useRecoilValueLoadable$1,
  useRecoilState: useRecoilState$1,
  useRecoilStateLoadable: useRecoilStateLoadable$1,
  useSetRecoilState: useSetRecoilState$1,
  useResetRecoilState: useResetRecoilState$1,
  useGetRecoilValueInfo_UNSTABLE: Recoil_useGetRecoilValueInfo,
  useRecoilRefresher_UNSTABLE: Recoil_useRecoilRefresher,
  useRecoilValueLoadable_TRANSITION_SUPPORT_UNSTABLE: useRecoilValueLoadable_TRANSITION_SUPPORT_UNSTABLE$1,
  useRecoilValue_TRANSITION_SUPPORT_UNSTABLE: useRecoilValue_TRANSITION_SUPPORT_UNSTABLE$1,
  useRecoilState_TRANSITION_SUPPORT_UNSTABLE: useRecoilState_TRANSITION_SUPPORT_UNSTABLE$1,
  // Hooks for complex operations
  useRecoilCallback: useRecoilCallback$1,
  useRecoilTransaction_UNSTABLE: Recoil_useRecoilTransaction,
  // Snapshots
  useGotoRecoilSnapshot: useGotoRecoilSnapshot$1,
  useRecoilSnapshot: useRecoilSnapshot$1,
  useRecoilTransactionObserver_UNSTABLE: useRecoilTransactionObserver$1,
  snapshot_UNSTABLE: freshSnapshot$2,
  // Memory Management
  useRetain: Recoil_useRetain,
  retentionZone: retentionZone$1
};
var Recoil_index_1 = Recoil_index.DefaultValue;
var Recoil_index_2 = Recoil_index.isRecoilValue;
var Recoil_index_3 = Recoil_index.RecoilLoadable;
var Recoil_index_4 = Recoil_index.RecoilEnv;
var Recoil_index_5 = Recoil_index.RecoilRoot;
var Recoil_index_6 = Recoil_index.useRecoilStoreID;
var Recoil_index_7 = Recoil_index.useRecoilBridgeAcrossReactRoots_UNSTABLE;
var Recoil_index_8 = Recoil_index.atom;
var Recoil_index_9 = Recoil_index.selector;
var Recoil_index_10 = Recoil_index.atomFamily;
var Recoil_index_11 = Recoil_index.selectorFamily;
var Recoil_index_12 = Recoil_index.constSelector;
var Recoil_index_13 = Recoil_index.errorSelector;
var Recoil_index_14 = Recoil_index.readOnlySelector;
var Recoil_index_15 = Recoil_index.noWait;
var Recoil_index_16 = Recoil_index.waitForNone;
var Recoil_index_17 = Recoil_index.waitForAny;
var Recoil_index_18 = Recoil_index.waitForAll;
var Recoil_index_19 = Recoil_index.waitForAllSettled;
var Recoil_index_20 = Recoil_index.useRecoilValue;
var Recoil_index_21 = Recoil_index.useRecoilValueLoadable;
var Recoil_index_22 = Recoil_index.useRecoilState;
var Recoil_index_23 = Recoil_index.useRecoilStateLoadable;
var Recoil_index_24 = Recoil_index.useSetRecoilState;
var Recoil_index_25 = Recoil_index.useResetRecoilState;
var Recoil_index_26 = Recoil_index.useGetRecoilValueInfo_UNSTABLE;
var Recoil_index_27 = Recoil_index.useRecoilRefresher_UNSTABLE;
var Recoil_index_28 = Recoil_index.useRecoilValueLoadable_TRANSITION_SUPPORT_UNSTABLE;
var Recoil_index_29 = Recoil_index.useRecoilValue_TRANSITION_SUPPORT_UNSTABLE;
var Recoil_index_30 = Recoil_index.useRecoilState_TRANSITION_SUPPORT_UNSTABLE;
var Recoil_index_31 = Recoil_index.useRecoilCallback;
var Recoil_index_32 = Recoil_index.useRecoilTransaction_UNSTABLE;
var Recoil_index_33 = Recoil_index.useGotoRecoilSnapshot;
var Recoil_index_34 = Recoil_index.useRecoilSnapshot;
var Recoil_index_35 = Recoil_index.useRecoilTransactionObserver_UNSTABLE;
var Recoil_index_36 = Recoil_index.snapshot_UNSTABLE;
var Recoil_index_37 = Recoil_index.useRetain;
var Recoil_index_38 = Recoil_index.retentionZone;

exports.nY = Recoil_index_1;
__webpack_unused_export__ = Recoil_index_4;
__webpack_unused_export__ = Recoil_index_3;
exports.Wh = Recoil_index_5;
exports.cn = Recoil_index_8;
exports.xu = Recoil_index_10;
__webpack_unused_export__ = Recoil_index_12;
__webpack_unused_export__ = Recoil_index;
__webpack_unused_export__ = Recoil_index_13;
__webpack_unused_export__ = Recoil_index_2;
__webpack_unused_export__ = Recoil_index_15;
__webpack_unused_export__ = Recoil_index_14;
__webpack_unused_export__ = Recoil_index_38;
exports.nZ = Recoil_index_9;
exports.CG = Recoil_index_11;
__webpack_unused_export__ = Recoil_index_36;
__webpack_unused_export__ = Recoil_index_26;
__webpack_unused_export__ = Recoil_index_33;
__webpack_unused_export__ = Recoil_index_7;
exports._8 = Recoil_index_31;
__webpack_unused_export__ = Recoil_index_27;
__webpack_unused_export__ = Recoil_index_34;
exports.FV = Recoil_index_22;
__webpack_unused_export__ = Recoil_index_23;
__webpack_unused_export__ = Recoil_index_30;
__webpack_unused_export__ = Recoil_index_6;
__webpack_unused_export__ = Recoil_index_35;
__webpack_unused_export__ = Recoil_index_32;
exports.sJ = Recoil_index_20;
exports.$P = Recoil_index_21;
__webpack_unused_export__ = Recoil_index_28;
__webpack_unused_export__ = Recoil_index_29;
__webpack_unused_export__ = Recoil_index_25;
__webpack_unused_export__ = Recoil_index_37;
exports.Zl = Recoil_index_24;
__webpack_unused_export__ = Recoil_index_18;
__webpack_unused_export__ = Recoil_index_19;
__webpack_unused_export__ = Recoil_index_17;
__webpack_unused_export__ = Recoil_index_16;


/***/ }),

/***/ 33982:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
/* provided dependency */ var process = __webpack_require__(97441);
function e(e){return e&&"object"==typeof e&&"default"in e?e.default:e}Object.defineProperty(exports, "__esModule", ({value:!0}));var t=__webpack_require__(3360),n=__webpack_require__(91987),r=e(n),o=e(__webpack_require__(88661)),s=e(__webpack_require__(90728)),i=e(__webpack_require__(26729)),a=e(__webpack_require__(64031)),u=e(__webpack_require__(26504));function c(){return(c=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e}).apply(this,arguments)}var l=function(e,t){for(var n=[e[0]],r=0,o=t.length;r<o;r+=1)n.push(t[r],e[r+1]);return n},d=function(e){return null!==e&&"object"==typeof e&&"[object Object]"===(e.toString?e.toString():Object.prototype.toString.call(e))&&!t.typeOf(e)},h=Object.freeze([]),p=Object.freeze({});function f(e){return"function"==typeof e}function m(e){return false||e.displayName||e.name||"Component"}function y(e){return e&&"string"==typeof e.styledComponentId}var v="undefined"!=typeof process&&(process.env.REACT_APP_SC_ATTR||process.env.SC_ATTR)||"data-styled",g="undefined"!=typeof window&&"HTMLElement"in window,S=Boolean("boolean"==typeof SC_DISABLE_SPEEDY?SC_DISABLE_SPEEDY:"undefined"!=typeof process&&void 0!==process.env.REACT_APP_SC_DISABLE_SPEEDY&&""!==process.env.REACT_APP_SC_DISABLE_SPEEDY?"false"!==process.env.REACT_APP_SC_DISABLE_SPEEDY&&process.env.REACT_APP_SC_DISABLE_SPEEDY:"undefined"!=typeof process&&void 0!==process.env.SC_DISABLE_SPEEDY&&""!==process.env.SC_DISABLE_SPEEDY?"false"!==process.env.SC_DISABLE_SPEEDY&&process.env.SC_DISABLE_SPEEDY:"production"!=="production"),w={},E= false?0:{};function b(){for(var e=arguments.length<=0?void 0:arguments[0],t=[],n=1,r=arguments.length;n<r;n+=1)t.push(n<0||arguments.length<=n?void 0:arguments[n]);return t.forEach((function(t){e=e.replace(/%[a-z]/,t)})),e}function _(e){for(var t=arguments.length,n=new Array(t>1?t-1:0),r=1;r<t;r++)n[r-1]=arguments[r];throw true?new Error("An error occurred. See https://git.io/JUIaE#"+e+" for more information."+(n.length>0?" Args: "+n.join(", "):"")):0}var N=function(){function e(e){this.groupSizes=new Uint32Array(512),this.length=512,this.tag=e}var t=e.prototype;return t.indexOfGroup=function(e){for(var t=0,n=0;n<e;n++)t+=this.groupSizes[n];return t},t.insertRules=function(e,t){if(e>=this.groupSizes.length){for(var n=this.groupSizes,r=n.length,o=r;e>=o;)(o<<=1)<0&&_(16,""+e);this.groupSizes=new Uint32Array(o),this.groupSizes.set(n),this.length=o;for(var s=r;s<o;s++)this.groupSizes[s]=0}for(var i=this.indexOfGroup(e+1),a=0,u=t.length;a<u;a++)this.tag.insertRule(i,t[a])&&(this.groupSizes[e]++,i++)},t.clearGroup=function(e){if(e<this.length){var t=this.groupSizes[e],n=this.indexOfGroup(e),r=n+t;this.groupSizes[e]=0;for(var o=n;o<r;o++)this.tag.deleteRule(n)}},t.getGroup=function(e){var t="";if(e>=this.length||0===this.groupSizes[e])return t;for(var n=this.groupSizes[e],r=this.indexOfGroup(e),o=r+n,s=r;s<o;s++)t+=this.tag.getRule(s)+"/*!sc*/\n";return t},e}(),C=new Map,A=new Map,I=1,P=function(e){if(C.has(e))return C.get(e);for(;A.has(I);)I++;var t=I++;return false&&0,C.set(e,t),A.set(t,e),t},x=function(e){return A.get(e)},O=function(e,t){t>=I&&(I=t+1),C.set(e,t),A.set(t,e)},R="style["+v+'][data-styled-version="5.3.5"]',D=new RegExp("^"+v+'\\.g(\\d+)\\[id="([\\w\\d-]+)"\\].*?"([^"]*)'),T=function(e,t,n){for(var r,o=n.split(","),s=0,i=o.length;s<i;s++)(r=o[s])&&e.registerName(t,r)},j=function(e,t){for(var n=(t.textContent||"").split("/*!sc*/\n"),r=[],o=0,s=n.length;o<s;o++){var i=n[o].trim();if(i){var a=i.match(D);if(a){var u=0|parseInt(a[1],10),c=a[2];0!==u&&(O(c,u),T(e,c,a[3]),e.getTag().insertRules(u,r)),r.length=0}else r.push(i)}}},k=function(){return"undefined"!=typeof window&&void 0!==window.__webpack_nonce__?window.__webpack_nonce__:null},V=function(e){var t=document.head,n=e||t,r=document.createElement("style"),o=function(e){for(var t=e.childNodes,n=t.length;n>=0;n--){var r=t[n];if(r&&1===r.nodeType&&r.hasAttribute(v))return r}}(n),s=void 0!==o?o.nextSibling:null;r.setAttribute(v,"active"),r.setAttribute("data-styled-version","5.3.5");var i=k();return i&&r.setAttribute("nonce",i),n.insertBefore(r,s),r},M=function(){function e(e){var t=this.element=V(e);t.appendChild(document.createTextNode("")),this.sheet=function(e){if(e.sheet)return e.sheet;for(var t=document.styleSheets,n=0,r=t.length;n<r;n++){var o=t[n];if(o.ownerNode===e)return o}_(17)}(t),this.length=0}var t=e.prototype;return t.insertRule=function(e,t){try{return this.sheet.insertRule(t,e),this.length++,!0}catch(e){return!1}},t.deleteRule=function(e){this.sheet.deleteRule(e),this.length--},t.getRule=function(e){var t=this.sheet.cssRules[e];return void 0!==t&&"string"==typeof t.cssText?t.cssText:""},e}(),B=function(){function e(e){var t=this.element=V(e);this.nodes=t.childNodes,this.length=0}var t=e.prototype;return t.insertRule=function(e,t){if(e<=this.length&&e>=0){var n=document.createTextNode(t),r=this.nodes[e];return this.element.insertBefore(n,r||null),this.length++,!0}return!1},t.deleteRule=function(e){this.element.removeChild(this.nodes[e]),this.length--},t.getRule=function(e){return e<this.length?this.nodes[e].textContent:""},e}(),z=function(){function e(e){this.rules=[],this.length=0}var t=e.prototype;return t.insertRule=function(e,t){return e<=this.length&&(this.rules.splice(e,0,t),this.length++,!0)},t.deleteRule=function(e){this.rules.splice(e,1),this.length--},t.getRule=function(e){return e<this.length?this.rules[e]:""},e}(),q=g,G={isServer:!g,useCSSOMInjection:!S},L=function(){function e(e,t,n){void 0===e&&(e=p),void 0===t&&(t={}),this.options=c({},G,{},e),this.gs=t,this.names=new Map(n),this.server=!!e.isServer,!this.server&&g&&q&&(q=!1,function(e){for(var t=document.querySelectorAll(R),n=0,r=t.length;n<r;n++){var o=t[n];o&&"active"!==o.getAttribute(v)&&(j(e,o),o.parentNode&&o.parentNode.removeChild(o))}}(this))}e.registerId=function(e){return P(e)};var t=e.prototype;return t.reconstructWithOptions=function(t,n){return void 0===n&&(n=!0),new e(c({},this.options,{},t),this.gs,n&&this.names||void 0)},t.allocateGSInstance=function(e){return this.gs[e]=(this.gs[e]||0)+1},t.getTag=function(){return this.tag||(this.tag=(n=(t=this.options).isServer,r=t.useCSSOMInjection,o=t.target,e=n?new z(o):r?new M(o):new B(o),new N(e)));var e,t,n,r,o},t.hasNameForId=function(e,t){return this.names.has(e)&&this.names.get(e).has(t)},t.registerName=function(e,t){if(P(e),this.names.has(e))this.names.get(e).add(t);else{var n=new Set;n.add(t),this.names.set(e,n)}},t.insertRules=function(e,t,n){this.registerName(e,t),this.getTag().insertRules(P(e),n)},t.clearNames=function(e){this.names.has(e)&&this.names.get(e).clear()},t.clearRules=function(e){this.getTag().clearGroup(P(e)),this.clearNames(e)},t.clearTag=function(){this.tag=void 0},t.toString=function(){return function(e){for(var t=e.getTag(),n=t.length,r="",o=0;o<n;o++){var s=x(o);if(void 0!==s){var i=e.names.get(s),a=t.getGroup(o);if(i&&a&&i.size){var u=v+".g"+o+'[id="'+s+'"]',c="";void 0!==i&&i.forEach((function(e){e.length>0&&(c+=e+",")})),r+=""+a+u+'{content:"'+c+'"}/*!sc*/\n'}}}return r}(this)},e}(),F=/(a)(d)/gi,Y=function(e){return String.fromCharCode(e+(e>25?39:97))};function H(e){var t,n="";for(t=Math.abs(e);t>52;t=t/52|0)n=Y(t%52)+n;return(Y(t%52)+n).replace(F,"$1-$2")}var $=function(e,t){for(var n=t.length;n;)e=33*e^t.charCodeAt(--n);return e},W=function(e){return $(5381,e)};function U(e){for(var t=0;t<e.length;t+=1){var n=e[t];if(f(n)&&!y(n))return!1}return!0}var J=W("5.3.5"),X=function(){function e(e,t,n){this.rules=e,this.staticRulesId="",this.isStatic= true&&(void 0===n||n.isStatic)&&U(e),this.componentId=t,this.baseHash=$(J,t),this.baseStyle=n,L.registerId(t)}return e.prototype.generateAndInjectStyles=function(e,t,n){var r=this.componentId,o=[];if(this.baseStyle&&o.push(this.baseStyle.generateAndInjectStyles(e,t,n)),this.isStatic&&!n.hash)if(this.staticRulesId&&t.hasNameForId(r,this.staticRulesId))o.push(this.staticRulesId);else{var s=me(this.rules,e,t,n).join(""),i=H($(this.baseHash,s)>>>0);if(!t.hasNameForId(r,i)){var a=n(s,"."+i,void 0,r);t.insertRules(r,i,a)}o.push(i),this.staticRulesId=i}else{for(var u=this.rules.length,c=$(this.baseHash,n.hash),l="",d=0;d<u;d++){var h=this.rules[d];if("string"==typeof h)l+=h, false&&(0);else if(h){var p=me(h,e,t,n),f=Array.isArray(p)?p.join(""):p;c=$(c,f+d),l+=f}}if(l){var m=H(c>>>0);if(!t.hasNameForId(r,m)){var y=n(l,"."+m,void 0,r);t.insertRules(r,m,y)}o.push(m)}}return o.join(" ")},e}(),Z=/^\s*\/\/.*$/gm,K=[":","[",".","#"];function Q(e){var t,n,r,o,i=void 0===e?p:e,a=i.options,u=void 0===a?p:a,c=i.plugins,l=void 0===c?h:c,d=new s(u),f=[],m=function(e){function t(t){if(t)try{e(t+"}")}catch(e){}}return function(n,r,o,s,i,a,u,c,l,d){switch(n){case 1:if(0===l&&64===r.charCodeAt(0))return e(r+";"),"";break;case 2:if(0===c)return r+"/*|*/";break;case 3:switch(c){case 102:case 112:return e(o[0]+r),"";default:return r+(0===d?"/*|*/":"")}case-2:r.split("/*|*/}").forEach(t)}}}((function(e){f.push(e)})),y=function(e,r,s){return 0===r&&-1!==K.indexOf(s[n.length])||s.match(o)?e:"."+t};function v(e,s,i,a){void 0===a&&(a="&");var u=e.replace(Z,""),c=s&&i?i+" "+s+" { "+u+" }":u;return t=a,n=s,r=new RegExp("\\"+n+"\\b","g"),o=new RegExp("(\\"+n+"\\b){2,}"),d(i||!s?"":s,c)}return d.use([].concat(l,[function(e,t,o){2===e&&o.length&&o[0].lastIndexOf(n)>0&&(o[0]=o[0].replace(r,y))},m,function(e){if(-2===e){var t=f;return f=[],t}}])),v.hash=l.length?l.reduce((function(e,t){return t.name||_(15),$(e,t.name)}),5381).toString():"",v}var ee=r.createContext(),te=ee.Consumer,ne=r.createContext(),re=(ne.Consumer,new L),oe=Q();function se(){return n.useContext(ee)||re}function ie(){return n.useContext(ne)||oe}function ae(e){var t=n.useState(e.stylisPlugins),s=t[0],i=t[1],a=se(),u=n.useMemo((function(){var t=a;return e.sheet?t=e.sheet:e.target&&(t=t.reconstructWithOptions({target:e.target},!1)),e.disableCSSOMInjection&&(t=t.reconstructWithOptions({useCSSOMInjection:!1})),t}),[e.disableCSSOMInjection,e.sheet,e.target]),c=n.useMemo((function(){return Q({options:{prefix:!e.disableVendorPrefixes},plugins:s})}),[e.disableVendorPrefixes,s]);return n.useEffect((function(){o(s,e.stylisPlugins)||i(e.stylisPlugins)}),[e.stylisPlugins]),r.createElement(ee.Provider,{value:u},r.createElement(ne.Provider,{value:c}, false?0:e.children))}var ue=function(){function e(e,t){var n=this;this.inject=function(e,t){void 0===t&&(t=oe);var r=n.name+t.hash;e.hasNameForId(n.id,r)||e.insertRules(n.id,r,t(n.rules,r,"@keyframes"))},this.toString=function(){return _(12,String(n.name))},this.name=e,this.id="sc-keyframes-"+e,this.rules=t}return e.prototype.getName=function(e){return void 0===e&&(e=oe),this.name+e.hash},e}(),ce=/([A-Z])/,le=/([A-Z])/g,de=/^ms-/,he=function(e){return"-"+e.toLowerCase()};function pe(e){return ce.test(e)?e.replace(le,he).replace(de,"-ms-"):e}var fe=function(e){return null==e||!1===e||""===e};function me(e,n,r,o){if(Array.isArray(e)){for(var s,a=[],u=0,c=e.length;u<c;u+=1)""!==(s=me(e[u],n,r,o))&&(Array.isArray(s)?a.push.apply(a,s):a.push(s));return a}if(fe(e))return"";if(y(e))return"."+e.styledComponentId;if(f(e)){if("function"!=typeof(h=e)||h.prototype&&h.prototype.isReactComponent||!n)return e;var l=e(n);return false&&0,me(l,n,r,o)}var h;return e instanceof ue?r?(e.inject(r,o),e.getName(o)):e:d(e)?function e(t,n){var r,o,s=[];for(var a in t)t.hasOwnProperty(a)&&!fe(t[a])&&(Array.isArray(t[a])&&t[a].isCss||f(t[a])?s.push(pe(a)+":",t[a],";"):d(t[a])?s.push.apply(s,e(t[a],a)):s.push(pe(a)+": "+(r=a,null==(o=t[a])||"boolean"==typeof o||""===o?"":"number"!=typeof o||0===o||r in i?String(o).trim():o+"px")+";"));return n?[n+" {"].concat(s,["}"]):s}(e):e.toString()}var ye=function(e){return Array.isArray(e)&&(e.isCss=!0),e};function ve(e){for(var t=arguments.length,n=new Array(t>1?t-1:0),r=1;r<t;r++)n[r-1]=arguments[r];return f(e)||d(e)?ye(me(l(h,[e].concat(n)))):0===n.length&&1===e.length&&"string"==typeof e[0]?e:ye(me(l(e,n)))}var ge=/invalid hook call/i,Se=new Set,we=function(e,t){if(false){ var s, r, o; }},Ee=function(e,t,n){return void 0===n&&(n=p),e.theme!==n.theme&&e.theme||t||n.theme},be=/[!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~-]+/g,_e=/(^-|-$)/g;function Ne(e){return e.replace(be,"-").replace(_e,"")}var Ce=function(e){return H(W(e)>>>0)};function Ae(e){return"string"==typeof e&&( true||0)}var Ie=function(e){return"function"==typeof e||"object"==typeof e&&null!==e&&!Array.isArray(e)},Pe=function(e){return"__proto__"!==e&&"constructor"!==e&&"prototype"!==e};function xe(e,t,n){var r=e[n];Ie(t)&&Ie(r)?Oe(r,t):e[n]=t}function Oe(e){for(var t=arguments.length,n=new Array(t>1?t-1:0),r=1;r<t;r++)n[r-1]=arguments[r];for(var o=0,s=n;o<s.length;o++){var i=s[o];if(Ie(i))for(var a in i)Pe(a)&&xe(e,i[a],a)}return e}var Re=r.createContext(),De=Re.Consumer,Te={};function je(e,t,o){var s=y(e),i=!Ae(e),l=t.attrs,d=void 0===l?h:l,v=t.componentId,g=void 0===v?function(e,t){var n="string"!=typeof e?"sc":Ne(e);Te[n]=(Te[n]||0)+1;var r=n+"-"+Ce("5.3.5"+n+Te[n]);return t?t+"-"+r:r}(t.displayName,t.parentComponentId):v,S=t.displayName,w=void 0===S?function(e){return Ae(e)?"styled."+e:"Styled("+m(e)+")"}(e):S,E=t.displayName&&t.componentId?Ne(t.displayName)+"-"+t.componentId:t.componentId||g,b=s&&e.attrs?Array.prototype.concat(e.attrs,d).filter(Boolean):d,_=t.shouldForwardProp;s&&e.shouldForwardProp&&(_=t.shouldForwardProp?function(n,r,o){return e.shouldForwardProp(n,r,o)&&t.shouldForwardProp(n,r,o)}:e.shouldForwardProp);var N,C=new X(o,E,s?e.componentStyle:void 0),A=C.isStatic&&0===d.length,I=function(e,t){return function(e,t,r,o){var s=e.attrs,i=e.componentStyle,u=e.defaultProps,l=e.foldedComponentIds,d=e.shouldForwardProp,h=e.styledComponentId,m=e.target; false&&0;var y=function(e,t,n){void 0===e&&(e=p);var r=c({},t,{theme:e}),o={};return n.forEach((function(e){var t,n,s,i=e;for(t in f(i)&&(i=i(r)),i)r[t]=o[t]="className"===t?(n=o[t],s=i[t],n&&s?n+" "+s:n||s):i[t]})),[r,o]}(Ee(t,n.useContext(Re),u)||p,t,s),v=y[0],g=y[1],S=function(e,t,r,o){var s=se(),i=ie(),a=t?e.generateAndInjectStyles(p,s,i):e.generateAndInjectStyles(r,s,i);return false&&0, false&&0,a}(i,o,v, false?0:void 0),w=r,E=g.$as||t.$as||g.as||t.as||m,b=Ae(E),_=g!==t?c({},t,{},g):t,N={};for(var C in _)"$"!==C[0]&&"as"!==C&&("forwardedAs"===C?N.as=_[C]:(d?d(C,a,E):!b||a(C))&&(N[C]=_[C]));return t.style&&g.style!==t.style&&(N.style=c({},t.style,{},g.style)),N.className=Array.prototype.concat(l,h,S!==h?S:null,t.className,g.className).filter(Boolean).join(" "),N.ref=w,n.createElement(E,N)}(N,e,t,A)};return I.displayName=w,(N=r.forwardRef(I)).attrs=b,N.componentStyle=C,N.displayName=w,N.shouldForwardProp=_,N.foldedComponentIds=s?Array.prototype.concat(e.foldedComponentIds,e.styledComponentId):h,N.styledComponentId=E,N.target=s?e.target:e,N.withComponent=function(e){var n=t.componentId,r=function(e,t){if(null==e)return{};var n,r,o={},s=Object.keys(e);for(r=0;r<s.length;r++)n=s[r],t.indexOf(n)>=0||(o[n]=e[n]);return o}(t,["componentId"]),s=n&&n+"-"+(Ae(e)?e:Ne(m(e)));return je(e,c({},r,{attrs:b,componentId:s}),o)},Object.defineProperty(N,"defaultProps",{get:function(){return this._foldedDefaultProps},set:function(t){this._foldedDefaultProps=s?Oe({},e.defaultProps,t):t}}), false&&(0),N.toString=function(){return"."+N.styledComponentId},i&&u(N,e,{attrs:!0,componentStyle:!0,displayName:!0,foldedComponentIds:!0,shouldForwardProp:!0,styledComponentId:!0,target:!0,withComponent:!0}),N}var ke=function(e){return function e(n,r,o){if(void 0===o&&(o=p),!t.isValidElementType(r))return _(1,String(r));var s=function(){return n(r,o,ve.apply(void 0,arguments))};return s.withConfig=function(t){return e(n,r,c({},o,{},t))},s.attrs=function(t){return e(n,r,c({},o,{attrs:Array.prototype.concat(o.attrs,t).filter(Boolean)}))},s}(je,e)};["a","abbr","address","area","article","aside","audio","b","base","bdi","bdo","big","blockquote","body","br","button","canvas","caption","cite","code","col","colgroup","data","datalist","dd","del","details","dfn","dialog","div","dl","dt","em","embed","fieldset","figcaption","figure","footer","form","h1","h2","h3","h4","h5","h6","head","header","hgroup","hr","html","i","iframe","img","input","ins","kbd","keygen","label","legend","li","link","main","map","mark","marquee","menu","menuitem","meta","meter","nav","noscript","object","ol","optgroup","option","output","p","param","picture","pre","progress","q","rp","rt","ruby","s","samp","script","section","select","small","source","span","strong","style","sub","summary","sup","table","tbody","td","textarea","tfoot","th","thead","time","title","tr","track","u","ul","var","video","wbr","circle","clipPath","defs","ellipse","foreignObject","g","image","line","linearGradient","marker","mask","path","pattern","polygon","polyline","radialGradient","rect","stop","svg","text","textPath","tspan"].forEach((function(e){ke[e]=ke(e)}));var Ve=function(){function e(e,t){this.rules=e,this.componentId=t,this.isStatic=U(e),L.registerId(this.componentId+1)}var t=e.prototype;return t.createStyles=function(e,t,n,r){var o=r(me(this.rules,t,n,r).join(""),""),s=this.componentId+e;n.insertRules(s,s,o)},t.removeStyles=function(e,t){t.clearRules(this.componentId+e)},t.renderStyles=function(e,t,n,r){e>2&&L.registerId(this.componentId+e),this.removeStyles(e,n),this.createStyles(e,t,n,r)},e}(),Me=function(){function e(){var e=this;this._emitSheetCSS=function(){var t=e.instance.toString();if(!t)return"";var n=k();return"<style "+[n&&'nonce="'+n+'"',v+'="true"','data-styled-version="5.3.5"'].filter(Boolean).join(" ")+">"+t+"</style>"},this.getStyleTags=function(){return e.sealed?_(2):e._emitSheetCSS()},this.getStyleElement=function(){var t;if(e.sealed)return _(2);var n=((t={})[v]="",t["data-styled-version"]="5.3.5",t.dangerouslySetInnerHTML={__html:e.instance.toString()},t),o=k();return o&&(n.nonce=o),[r.createElement("style",c({},n,{key:"sc-0-0"}))]},this.seal=function(){e.sealed=!0},this.instance=new L({isServer:!0}),this.sealed=!1}var t=e.prototype;return t.collectStyles=function(e){return this.sealed?_(2):r.createElement(ae,{sheet:this.instance},e)},t.interleaveWithNodeStream=function(e){return _(3)},e}(),Be={StyleSheet:L,masterSheet:re}; false&&0, false&&(0),exports.ServerStyleSheet=Me,exports.StyleSheetConsumer=te,exports.StyleSheetContext=ee,exports.StyleSheetManager=ae,exports.ThemeConsumer=De,exports.ThemeContext=Re,exports.ThemeProvider=function(e){var t=n.useContext(Re),o=n.useMemo((function(){return function(e,t){if(!e)return _(14);if(f(e)){var n=e(t);return true?n:0}return Array.isArray(e)||"object"!=typeof e?_(8):t?c({},t,{},e):e}(e.theme,t)}),[e.theme,t]);return e.children?r.createElement(Re.Provider,{value:o},e.children):null},exports.__PRIVATE__=Be,exports.createGlobalStyle=function(e){for(var t=arguments.length,o=new Array(t>1?t-1:0),s=1;s<t;s++)o[s-1]=arguments[s];var i=ve.apply(void 0,[e].concat(o)),a="sc-global-"+Ce(JSON.stringify(i)),u=new Ve(i,a);function l(e){var t=se(),o=ie(),s=n.useContext(Re),c=n.useRef(t.allocateGSInstance(a)).current;return false&&0, false&&0,t.server&&d(c,e,t,s,o),n.useLayoutEffect((function(){if(!t.server)return d(c,e,t,s,o),function(){return u.removeStyles(c,t)}}),[c,e,t,s,o]),null}function d(e,t,n,r,o){if(u.isStatic)u.renderStyles(e,w,n,o);else{var s=c({},t,{theme:Ee(t,r,l.defaultProps)});u.renderStyles(e,s,n,o)}}return false&&0,r.memo(l)},exports.css=ve,exports["default"]=ke,exports.isStyledComponent=y,exports.keyframes=function(e){ false&&0;for(var t=arguments.length,n=new Array(t>1?t-1:0),r=1;r<t;r++)n[r-1]=arguments[r];var o=ve.apply(void 0,[e].concat(n)).join(""),s=Ce(o);return new ue(s,o)},exports.useTheme=function(){return n.useContext(Re)},exports.version="5.3.5",exports.withTheme=function(e){var t=r.forwardRef((function(t,o){var s=n.useContext(Re),i=e.defaultProps,a=Ee(t,s,i);return false&&0,r.createElement(e,c({},t,{theme:a,ref:o}))}));return u(t,e),t.displayName="WithTheme("+m(e)+")",t};
//# sourceMappingURL=styled-components.browser.cjs.js.map


/***/ }),

/***/ 99627:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useDebouncedCallback; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91987);

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked, or until the next browser frame is drawn. The debounced function
 * comes with a `cancel` method to cancel delayed `func` invocations and a
 * `flush` method to immediately invoke them. Provide `options` to indicate
 * whether `func` should be invoked on the leading and/or trailing edge of the
 * `wait` timeout. The `func` is invoked with the last arguments provided to the
 * debounced function. Subsequent calls to the debounced function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * If `wait` is omitted in an environment with `requestAnimationFrame`, `func`
 * invocation will be deferred until the next frame is drawn (typically about
 * 16ms).
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `debounce` and `throttle`.
 *
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0]
 *  The number of milliseconds to delay; if omitted, `requestAnimationFrame` is
 *  used (if available, otherwise it will be setTimeout(...,0)).
 * @param {Object} [options={}] The options object.
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.leading=false]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {number} [options.maxWait]
 *  Specify invoking on the trailing edge of the timeout.
 * @param {boolean} [options.trailing=true]
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * const resizeHandler = useDebouncedCallback(calculateLayout, 150);
 * window.addEventListener('resize', resizeHandler)
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * const clickHandler = useDebouncedCallback(sendMail, 300, {
 *   leading: true,
 *   trailing: false,
 * })
 * <button onClick={clickHandler}>click me</button>
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * const debounced = useDebouncedCallback(batchLog, 250, { 'maxWait': 1000 })
 * const source = new EventSource('/stream')
 * source.addEventListener('message', debounced)
 *
 * // Cancel the trailing debounced invocation.
 * window.addEventListener('popstate', debounced.cancel)
 *
 * // Check for pending invocations.
 * const status = debounced.pending() ? "Pending..." : "Ready"
 */
function useDebouncedCallback(func, wait, options) {
    var _this = this;
    var lastCallTime = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
    var lastInvokeTime = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(0);
    var timerId = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
    var lastArgs = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)([]);
    var lastThis = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)();
    var result = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)();
    var funcRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(func);
    var mounted = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(true);
    funcRef.current = func;
    // Bypass `requestAnimationFrame` by explicitly setting `wait=0`.
    var useRAF = !wait && wait !== 0 && typeof window !== 'undefined';
    if (typeof func !== 'function') {
        throw new TypeError('Expected a function');
    }
    wait = +wait || 0;
    options = options || {};
    var leading = !!options.leading;
    var trailing = 'trailing' in options ? !!options.trailing : true; // `true` by default
    var maxing = 'maxWait' in options;
    var maxWait = maxing ? Math.max(+options.maxWait || 0, wait) : null;
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
        mounted.current = true;
        return function () {
            mounted.current = false;
        };
    }, []);
    // You may have a question, why we have so many code under the useMemo definition.
    //
    // This was made as we want to escape from useCallback hell and
    // not to initialize a number of functions each time useDebouncedCallback is called.
    //
    // It means that we have less garbage for our GC calls which improves performance.
    // Also, it makes this library smaller.
    //
    // And the last reason, that the code without lots of useCallback with deps is easier to read.
    // You have only one place for that.
    var debounced = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function () {
        var invokeFunc = function (time) {
            var args = lastArgs.current;
            var thisArg = lastThis.current;
            lastArgs.current = lastThis.current = null;
            lastInvokeTime.current = time;
            return (result.current = funcRef.current.apply(thisArg, args));
        };
        var startTimer = function (pendingFunc, wait) {
            if (useRAF)
                cancelAnimationFrame(timerId.current);
            timerId.current = useRAF ? requestAnimationFrame(pendingFunc) : setTimeout(pendingFunc, wait);
        };
        var shouldInvoke = function (time) {
            if (!mounted.current)
                return false;
            var timeSinceLastCall = time - lastCallTime.current;
            var timeSinceLastInvoke = time - lastInvokeTime.current;
            // Either this is the first call, activity has stopped and we're at the
            // trailing edge, the system time has gone backwards and we're treating
            // it as the trailing edge, or we've hit the `maxWait` limit.
            return (!lastCallTime.current ||
                timeSinceLastCall >= wait ||
                timeSinceLastCall < 0 ||
                (maxing && timeSinceLastInvoke >= maxWait));
        };
        var trailingEdge = function (time) {
            timerId.current = null;
            // Only invoke if we have `lastArgs` which means `func` has been
            // debounced at least once.
            if (trailing && lastArgs.current) {
                return invokeFunc(time);
            }
            lastArgs.current = lastThis.current = null;
            return result.current;
        };
        var timerExpired = function () {
            var time = Date.now();
            if (shouldInvoke(time)) {
                return trailingEdge(time);
            }
            // https://github.com/xnimorz/use-debounce/issues/97
            if (!mounted.current) {
                return;
            }
            // Remaining wait calculation
            var timeSinceLastCall = time - lastCallTime.current;
            var timeSinceLastInvoke = time - lastInvokeTime.current;
            var timeWaiting = wait - timeSinceLastCall;
            var remainingWait = maxing ? Math.min(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
            // Restart the timer
            startTimer(timerExpired, remainingWait);
        };
        var func = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            var time = Date.now();
            var isInvoking = shouldInvoke(time);
            lastArgs.current = args;
            lastThis.current = _this;
            lastCallTime.current = time;
            if (isInvoking) {
                if (!timerId.current && mounted.current) {
                    // Reset any `maxWait` timer.
                    lastInvokeTime.current = lastCallTime.current;
                    // Start the timer for the trailing edge.
                    startTimer(timerExpired, wait);
                    // Invoke the leading edge.
                    return leading ? invokeFunc(lastCallTime.current) : result.current;
                }
                if (maxing) {
                    // Handle invocations in a tight loop.
                    startTimer(timerExpired, wait);
                    return invokeFunc(lastCallTime.current);
                }
            }
            if (!timerId.current) {
                startTimer(timerExpired, wait);
            }
            return result.current;
        };
        func.cancel = function () {
            if (timerId.current) {
                useRAF ? cancelAnimationFrame(timerId.current) : clearTimeout(timerId.current);
            }
            lastInvokeTime.current = 0;
            lastArgs.current = lastCallTime.current = lastThis.current = timerId.current = null;
        };
        func.isPending = function () {
            return !!timerId.current;
        };
        func.flush = function () {
            return !timerId.current ? result.current : trailingEdge(Date.now());
        };
        return func;
    }, [leading, maxing, wait, maxWait, trailing, useRAF]);
    return debounced;
}


/***/ }),

/***/ 78420:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "OR": function() { return /* reexport */ esm_useEventListener_useEventListener; },
  "XI": function() { return /* reexport */ useHover_useHover; },
  "LI": function() { return /* reexport */ esm_useIsomorphicLayoutEffect_useIsomorphicLayoutEffect; },
  "t$": function() { return /* reexport */ useOnClickOutside_useOnClickOutside; }
});

// UNUSED EXPORTS: useBoolean, useClickAnyWhere, useCopyToClipboard, useCountdown, useCounter, useDarkMode, useDebounce, useDocumentTitle, useEffectOnce, useElementSize, useEventCallback, useFetch, useImageOnLoad, useIntersectionObserver, useInterval, useIsClient, useIsFirstRender, useIsMounted, useLocalStorage, useLockedBody, useMap, useMediaQuery, useReadLocalStorage, useScreen, useScript, useSessionStorage, useSsr, useStep, useTernaryDarkMode, useTimeout, useToggle, useUpdateEffect, useWindowSize

// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(91987);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/usehooks-ts-virtual-e376d4cf26/0/cache/usehooks-ts-npm-2.9.1-14c625587f-36f1e4142c.zip/node_modules/usehooks-ts/dist/esm/useBoolean/useBoolean.js

function useBoolean_useBoolean(defaultValue) {
    const [value, setValue] = useState(!!defaultValue);
    const setTrue = useCallback(() => setValue(true), []);
    const setFalse = useCallback(() => setValue(false), []);
    const toggle = useCallback(() => setValue(x => !x), []);
    return { value, setValue, setTrue, setFalse, toggle };
}
/* harmony default export */ var esm_useBoolean_useBoolean = ((/* unused pure expression or super */ null && (useBoolean_useBoolean)));

;// CONCATENATED MODULE: ../../.yarn/__virtual__/usehooks-ts-virtual-e376d4cf26/0/cache/usehooks-ts-npm-2.9.1-14c625587f-36f1e4142c.zip/node_modules/usehooks-ts/dist/esm/useClickAnyWhere/useClickAnyWhere.js

function useClickAnyWhere(handler) {
    useEventListener('click', event => {
        handler(event);
    });
}
/* harmony default export */ var useClickAnyWhere_useClickAnyWhere = ((/* unused pure expression or super */ null && (useClickAnyWhere)));

;// CONCATENATED MODULE: ../../.yarn/__virtual__/usehooks-ts-virtual-e376d4cf26/0/cache/usehooks-ts-npm-2.9.1-14c625587f-36f1e4142c.zip/node_modules/usehooks-ts/dist/esm/useCopyToClipboard/useCopyToClipboard.js
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};

function useCopyToClipboard() {
    const [copiedText, setCopiedText] = useState(null);
    const copy = (text) => __awaiter(this, void 0, void 0, function* () {
        if (!(navigator === null || navigator === void 0 ? void 0 : navigator.clipboard)) {
            console.warn('Clipboard not supported');
            return false;
        }
        try {
            yield navigator.clipboard.writeText(text);
            setCopiedText(text);
            return true;
        }
        catch (error) {
            console.warn('Copy failed', error);
            setCopiedText(null);
            return false;
        }
    });
    return [copiedText, copy];
}
/* harmony default export */ var useCopyToClipboard_useCopyToClipboard = ((/* unused pure expression or super */ null && (useCopyToClipboard)));

;// CONCATENATED MODULE: ../../.yarn/__virtual__/usehooks-ts-virtual-e376d4cf26/0/cache/usehooks-ts-npm-2.9.1-14c625587f-36f1e4142c.zip/node_modules/usehooks-ts/dist/esm/useCountdown/useCountdown.js


function useCountdown(countdownOption) {
    let isDeprecated = false;
    let countStart, intervalMs, isIncrement, countStop;
    if ('seconds' in countdownOption) {
        console.warn('[useCountdown:DEPRECATED] new interface is already available (see https://usehooks-ts.com/react-hook/use-countdown), the old version will retire on usehooks-ts@3.');
        isDeprecated = true;
        countStart = countdownOption.seconds;
        intervalMs = countdownOption.interval;
        isIncrement = countdownOption.isIncrement;
    }
    else {
        ;
        ({ countStart, intervalMs, isIncrement, countStop } = countdownOption);
    }
    intervalMs = intervalMs !== null && intervalMs !== void 0 ? intervalMs : 1000;
    isIncrement = isIncrement !== null && isIncrement !== void 0 ? isIncrement : false;
    countStop = countStop !== null && countStop !== void 0 ? countStop : 0;
    const { count, increment, decrement, reset: resetCounter, } = useCounter(countStart);
    const { value: isCountdownRunning, setTrue: startCountdown, setFalse: stopCountdown, } = useBoolean(false);
    const resetCountdown = () => {
        stopCountdown();
        resetCounter();
    };
    const countdownCallback = useCallback(() => {
        if (count === countStop) {
            stopCountdown();
            return;
        }
        if (isIncrement) {
            increment();
        }
        else {
            decrement();
        }
    }, [count, countStop, decrement, increment, isIncrement, stopCountdown]);
    useInterval(countdownCallback, isCountdownRunning ? intervalMs : null);
    return isDeprecated
        ? [
            count,
            {
                start: startCountdown,
                stop: stopCountdown,
                reset: resetCountdown,
            },
        ]
        : [
            count,
            {
                startCountdown,
                stopCountdown,
                resetCountdown,
            },
        ];
}
/* harmony default export */ var useCountdown_useCountdown = ((/* unused pure expression or super */ null && (useCountdown)));

;// CONCATENATED MODULE: ../../.yarn/__virtual__/usehooks-ts-virtual-e376d4cf26/0/cache/usehooks-ts-npm-2.9.1-14c625587f-36f1e4142c.zip/node_modules/usehooks-ts/dist/esm/useCounter/useCounter.js

function useCounter_useCounter(initialValue) {
    const [count, setCount] = useState(initialValue || 0);
    const increment = () => setCount(x => x + 1);
    const decrement = () => setCount(x => x - 1);
    const reset = () => setCount(initialValue || 0);
    return {
        count,
        increment,
        decrement,
        reset,
        setCount,
    };
}
/* harmony default export */ var esm_useCounter_useCounter = ((/* unused pure expression or super */ null && (useCounter_useCounter)));

;// CONCATENATED MODULE: ../../.yarn/__virtual__/usehooks-ts-virtual-e376d4cf26/0/cache/usehooks-ts-npm-2.9.1-14c625587f-36f1e4142c.zip/node_modules/usehooks-ts/dist/esm/useDarkMode/useDarkMode.js

const COLOR_SCHEME_QUERY = '(prefers-color-scheme: dark)';
function useDarkMode(defaultValue) {
    var _a;
    const isDarkOS = useMediaQuery(COLOR_SCHEME_QUERY);
    const [isDarkMode, setDarkMode] = useLocalStorage('usehooks-ts-dark-mode', (_a = defaultValue !== null && defaultValue !== void 0 ? defaultValue : isDarkOS) !== null && _a !== void 0 ? _a : false);
    useUpdateEffect(() => {
        setDarkMode(isDarkOS);
    }, [isDarkOS]);
    return {
        isDarkMode,
        toggle: () => setDarkMode(prev => !prev),
        enable: () => setDarkMode(true),
        disable: () => setDarkMode(false),
    };
}
/* harmony default export */ var useDarkMode_useDarkMode = ((/* unused pure expression or super */ null && (useDarkMode)));

;// CONCATENATED MODULE: ../../.yarn/__virtual__/usehooks-ts-virtual-e376d4cf26/0/cache/usehooks-ts-npm-2.9.1-14c625587f-36f1e4142c.zip/node_modules/usehooks-ts/dist/esm/useDebounce/useDebounce.js

function useDebounce(value, delay) {
    const [debouncedValue, setDebouncedValue] = useState(value);
    useEffect(() => {
        const timer = setTimeout(() => setDebouncedValue(value), delay || 500);
        return () => {
            clearTimeout(timer);
        };
    }, [value, delay]);
    return debouncedValue;
}
/* harmony default export */ var useDebounce_useDebounce = ((/* unused pure expression or super */ null && (useDebounce)));

;// CONCATENATED MODULE: ../../.yarn/__virtual__/usehooks-ts-virtual-e376d4cf26/0/cache/usehooks-ts-npm-2.9.1-14c625587f-36f1e4142c.zip/node_modules/usehooks-ts/dist/esm/useDocumentTitle/useDocumentTitle.js

function useDocumentTitle(title) {
    useIsomorphicLayoutEffect(() => {
        window.document.title = title;
    }, [title]);
}
/* harmony default export */ var useDocumentTitle_useDocumentTitle = ((/* unused pure expression or super */ null && (useDocumentTitle)));

;// CONCATENATED MODULE: ../../.yarn/__virtual__/usehooks-ts-virtual-e376d4cf26/0/cache/usehooks-ts-npm-2.9.1-14c625587f-36f1e4142c.zip/node_modules/usehooks-ts/dist/esm/useEffectOnce/useEffectOnce.js

function useEffectOnce(effect) {
    useEffect(effect, []);
}
/* harmony default export */ var useEffectOnce_useEffectOnce = ((/* unused pure expression or super */ null && (useEffectOnce)));

;// CONCATENATED MODULE: ../../.yarn/__virtual__/usehooks-ts-virtual-e376d4cf26/0/cache/usehooks-ts-npm-2.9.1-14c625587f-36f1e4142c.zip/node_modules/usehooks-ts/dist/esm/useElementSize/useElementSize.js


function useElementSize() {
    const [ref, setRef] = useState(null);
    const [size, setSize] = useState({
        width: 0,
        height: 0,
    });
    const handleSize = useCallback(() => {
        setSize({
            width: (ref === null || ref === void 0 ? void 0 : ref.offsetWidth) || 0,
            height: (ref === null || ref === void 0 ? void 0 : ref.offsetHeight) || 0,
        });
    }, [ref === null || ref === void 0 ? void 0 : ref.offsetHeight, ref === null || ref === void 0 ? void 0 : ref.offsetWidth]);
    useEventListener('resize', handleSize);
    useIsomorphicLayoutEffect(() => {
        handleSize();
    }, [ref === null || ref === void 0 ? void 0 : ref.offsetHeight, ref === null || ref === void 0 ? void 0 : ref.offsetWidth]);
    return [setRef, size];
}
/* harmony default export */ var useElementSize_useElementSize = ((/* unused pure expression or super */ null && (useElementSize)));

;// CONCATENATED MODULE: ../../.yarn/__virtual__/usehooks-ts-virtual-e376d4cf26/0/cache/usehooks-ts-npm-2.9.1-14c625587f-36f1e4142c.zip/node_modules/usehooks-ts/dist/esm/useEventCallback/useEventCallback.js


function useEventCallback_useEventCallback(fn) {
    const ref = useRef(() => {
        throw new Error('Cannot call an event handler while rendering.');
    });
    useIsomorphicLayoutEffect(() => {
        ref.current = fn;
    }, [fn]);
    return useCallback((...args) => ref.current(...args), [ref]);
}

;// CONCATENATED MODULE: ../../.yarn/__virtual__/usehooks-ts-virtual-e376d4cf26/0/cache/usehooks-ts-npm-2.9.1-14c625587f-36f1e4142c.zip/node_modules/usehooks-ts/dist/esm/useEventListener/useEventListener.js


function useEventListener_useEventListener(eventName, handler, element, options) {
    const savedHandler = (0,react.useRef)(handler);
    esm_useIsomorphicLayoutEffect_useIsomorphicLayoutEffect(() => {
        savedHandler.current = handler;
    }, [handler]);
    (0,react.useEffect)(() => {
        var _a;
        const targetElement = (_a = element === null || element === void 0 ? void 0 : element.current) !== null && _a !== void 0 ? _a : window;
        if (!(targetElement && targetElement.addEventListener))
            return;
        const listener = event => savedHandler.current(event);
        targetElement.addEventListener(eventName, listener, options);
        return () => {
            targetElement.removeEventListener(eventName, listener, options);
        };
    }, [eventName, element, options]);
}
/* harmony default export */ var esm_useEventListener_useEventListener = (useEventListener_useEventListener);

;// CONCATENATED MODULE: ../../.yarn/__virtual__/usehooks-ts-virtual-e376d4cf26/0/cache/usehooks-ts-npm-2.9.1-14c625587f-36f1e4142c.zip/node_modules/usehooks-ts/dist/esm/useFetch/useFetch.js
var useFetch_awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};

function useFetch(url, options) {
    const cache = useRef({});
    const cancelRequest = useRef(false);
    const initialState = {
        error: undefined,
        data: undefined,
    };
    const fetchReducer = (state, action) => {
        switch (action.type) {
            case 'loading':
                return Object.assign({}, initialState);
            case 'fetched':
                return Object.assign(Object.assign({}, initialState), { data: action.payload });
            case 'error':
                return Object.assign(Object.assign({}, initialState), { error: action.payload });
            default:
                return state;
        }
    };
    const [state, dispatch] = useReducer(fetchReducer, initialState);
    useEffect(() => {
        if (!url)
            return;
        cancelRequest.current = false;
        const fetchData = () => useFetch_awaiter(this, void 0, void 0, function* () {
            dispatch({ type: 'loading' });
            if (cache.current[url]) {
                dispatch({ type: 'fetched', payload: cache.current[url] });
                return;
            }
            try {
                const response = yield fetch(url, options);
                if (!response.ok) {
                    throw new Error(response.statusText);
                }
                const data = (yield response.json());
                cache.current[url] = data;
                if (cancelRequest.current)
                    return;
                dispatch({ type: 'fetched', payload: data });
            }
            catch (error) {
                if (cancelRequest.current)
                    return;
                dispatch({ type: 'error', payload: error });
            }
        });
        void fetchData();
        return () => {
            cancelRequest.current = true;
        };
    }, [url]);
    return state;
}
/* harmony default export */ var useFetch_useFetch = ((/* unused pure expression or super */ null && (useFetch)));

;// CONCATENATED MODULE: ../../.yarn/__virtual__/usehooks-ts-virtual-e376d4cf26/0/cache/usehooks-ts-npm-2.9.1-14c625587f-36f1e4142c.zip/node_modules/usehooks-ts/dist/esm/useHover/useHover.js


function useHover(elementRef) {
    const [value, setValue] = (0,react.useState)(false);
    const handleMouseEnter = () => setValue(true);
    const handleMouseLeave = () => setValue(false);
    esm_useEventListener_useEventListener('mouseenter', handleMouseEnter, elementRef);
    esm_useEventListener_useEventListener('mouseleave', handleMouseLeave, elementRef);
    return value;
}
/* harmony default export */ var useHover_useHover = (useHover);

;// CONCATENATED MODULE: ../../.yarn/__virtual__/usehooks-ts-virtual-e376d4cf26/0/cache/usehooks-ts-npm-2.9.1-14c625587f-36f1e4142c.zip/node_modules/usehooks-ts/dist/esm/useImageOnLoad/useImageOnLoad.js

function useImageOnLoad() {
    const [isLoaded, setIsLoaded] = useState(false);
    const handleImageOnLoad = () => {
        setIsLoaded(true);
    };
    const css = {
        thumbnail: {
            visibility: isLoaded ? 'hidden' : 'visible',
            filter: 'blur(8px)',
            transition: 'visibility 0ms ease-out 500ms',
        },
        fullSize: {
            opacity: isLoaded ? 1 : 0,
            transition: 'opacity 500ms ease-in 0ms',
        },
    };
    return { handleImageOnLoad, css };
}
/* harmony default export */ var useImageOnLoad_useImageOnLoad = ((/* unused pure expression or super */ null && (useImageOnLoad)));

;// CONCATENATED MODULE: ../../.yarn/__virtual__/usehooks-ts-virtual-e376d4cf26/0/cache/usehooks-ts-npm-2.9.1-14c625587f-36f1e4142c.zip/node_modules/usehooks-ts/dist/esm/useIntersectionObserver/useIntersectionObserver.js

function useIntersectionObserver(elementRef, { threshold = 0, root = null, rootMargin = '0%', freezeOnceVisible = false, }) {
    const [entry, setEntry] = useState();
    const frozen = (entry === null || entry === void 0 ? void 0 : entry.isIntersecting) && freezeOnceVisible;
    const updateEntry = ([entry]) => {
        setEntry(entry);
    };
    useEffect(() => {
        const node = elementRef === null || elementRef === void 0 ? void 0 : elementRef.current;
        const hasIOSupport = !!window.IntersectionObserver;
        if (!hasIOSupport || frozen || !node)
            return;
        const observerParams = { threshold, root, rootMargin };
        const observer = new IntersectionObserver(updateEntry, observerParams);
        observer.observe(node);
        return () => observer.disconnect();
    }, [elementRef === null || elementRef === void 0 ? void 0 : elementRef.current, JSON.stringify(threshold), root, rootMargin, frozen]);
    return entry;
}
/* harmony default export */ var useIntersectionObserver_useIntersectionObserver = ((/* unused pure expression or super */ null && (useIntersectionObserver)));

;// CONCATENATED MODULE: ../../.yarn/__virtual__/usehooks-ts-virtual-e376d4cf26/0/cache/usehooks-ts-npm-2.9.1-14c625587f-36f1e4142c.zip/node_modules/usehooks-ts/dist/esm/useInterval/useInterval.js


function useInterval_useInterval(callback, delay) {
    const savedCallback = useRef(callback);
    useIsomorphicLayoutEffect(() => {
        savedCallback.current = callback;
    }, [callback]);
    useEffect(() => {
        if (!delay && delay !== 0) {
            return;
        }
        const id = setInterval(() => savedCallback.current(), delay);
        return () => clearInterval(id);
    }, [delay]);
}
/* harmony default export */ var esm_useInterval_useInterval = ((/* unused pure expression or super */ null && (useInterval_useInterval)));

;// CONCATENATED MODULE: ../../.yarn/__virtual__/usehooks-ts-virtual-e376d4cf26/0/cache/usehooks-ts-npm-2.9.1-14c625587f-36f1e4142c.zip/node_modules/usehooks-ts/dist/esm/useIsClient/useIsClient.js

function useIsClient() {
    const [isClient, setClient] = useState(false);
    useEffect(() => {
        setClient(true);
    }, []);
    return isClient;
}
/* harmony default export */ var useIsClient_useIsClient = ((/* unused pure expression or super */ null && (useIsClient)));

;// CONCATENATED MODULE: ../../.yarn/__virtual__/usehooks-ts-virtual-e376d4cf26/0/cache/usehooks-ts-npm-2.9.1-14c625587f-36f1e4142c.zip/node_modules/usehooks-ts/dist/esm/useIsFirstRender/useIsFirstRender.js

function useIsFirstRender_useIsFirstRender() {
    const isFirst = useRef(true);
    if (isFirst.current) {
        isFirst.current = false;
        return true;
    }
    return isFirst.current;
}
/* harmony default export */ var esm_useIsFirstRender_useIsFirstRender = ((/* unused pure expression or super */ null && (useIsFirstRender_useIsFirstRender)));

;// CONCATENATED MODULE: ../../.yarn/__virtual__/usehooks-ts-virtual-e376d4cf26/0/cache/usehooks-ts-npm-2.9.1-14c625587f-36f1e4142c.zip/node_modules/usehooks-ts/dist/esm/useIsMounted/useIsMounted.js

function useIsMounted() {
    const isMounted = useRef(false);
    useEffect(() => {
        isMounted.current = true;
        return () => {
            isMounted.current = false;
        };
    }, []);
    return useCallback(() => isMounted.current, []);
}
/* harmony default export */ var useIsMounted_useIsMounted = ((/* unused pure expression or super */ null && (useIsMounted)));

;// CONCATENATED MODULE: ../../.yarn/__virtual__/usehooks-ts-virtual-e376d4cf26/0/cache/usehooks-ts-npm-2.9.1-14c625587f-36f1e4142c.zip/node_modules/usehooks-ts/dist/esm/useIsomorphicLayoutEffect/useIsomorphicLayoutEffect.js

const useIsomorphicLayoutEffect_useIsomorphicLayoutEffect = typeof window !== 'undefined' ? react.useLayoutEffect : react.useEffect;
/* harmony default export */ var esm_useIsomorphicLayoutEffect_useIsomorphicLayoutEffect = (useIsomorphicLayoutEffect_useIsomorphicLayoutEffect);

;// CONCATENATED MODULE: ../../.yarn/__virtual__/usehooks-ts-virtual-e376d4cf26/0/cache/usehooks-ts-npm-2.9.1-14c625587f-36f1e4142c.zip/node_modules/usehooks-ts/dist/esm/useLocalStorage/useLocalStorage.js


function useLocalStorage_useLocalStorage(key, initialValue) {
    const readValue = useCallback(() => {
        if (typeof window === 'undefined') {
            return initialValue;
        }
        try {
            const item = window.localStorage.getItem(key);
            return item ? parseJSON(item) : initialValue;
        }
        catch (error) {
            console.warn(`Error reading localStorage key “${key}”:`, error);
            return initialValue;
        }
    }, [initialValue, key]);
    const [storedValue, setStoredValue] = useState(readValue);
    const setValue = useEventCallback(value => {
        if (typeof window === 'undefined') {
            console.warn(`Tried setting localStorage key “${key}” even though environment is not a client`);
        }
        try {
            const newValue = value instanceof Function ? value(storedValue) : value;
            window.localStorage.setItem(key, JSON.stringify(newValue));
            setStoredValue(newValue);
            window.dispatchEvent(new Event('local-storage'));
        }
        catch (error) {
            console.warn(`Error setting localStorage key “${key}”:`, error);
        }
    });
    useEffect(() => {
        setStoredValue(readValue());
    }, []);
    const handleStorageChange = useCallback((event) => {
        if ((event === null || event === void 0 ? void 0 : event.key) && event.key !== key) {
            return;
        }
        setStoredValue(readValue());
    }, [key, readValue]);
    useEventListener('storage', handleStorageChange);
    useEventListener('local-storage', handleStorageChange);
    return [storedValue, setValue];
}
/* harmony default export */ var esm_useLocalStorage_useLocalStorage = ((/* unused pure expression or super */ null && (useLocalStorage_useLocalStorage)));
function parseJSON(value) {
    try {
        return value === 'undefined' ? undefined : JSON.parse(value !== null && value !== void 0 ? value : '');
    }
    catch (_a) {
        console.log('parsing error on', { value });
        return undefined;
    }
}

;// CONCATENATED MODULE: ../../.yarn/__virtual__/usehooks-ts-virtual-e376d4cf26/0/cache/usehooks-ts-npm-2.9.1-14c625587f-36f1e4142c.zip/node_modules/usehooks-ts/dist/esm/useLockedBody/useLockedBody.js


function useLockedBody(initialLocked = false, rootId = '___gatsby') {
    const [locked, setLocked] = useState(initialLocked);
    useIsomorphicLayoutEffect(() => {
        if (!locked) {
            return;
        }
        const originalOverflow = document.body.style.overflow;
        const originalPaddingRight = document.body.style.paddingRight;
        document.body.style.overflow = 'hidden';
        const root = document.getElementById(rootId);
        const scrollBarWidth = root ? root.offsetWidth - root.scrollWidth : 0;
        if (scrollBarWidth) {
            document.body.style.paddingRight = `${scrollBarWidth}px`;
        }
        return () => {
            document.body.style.overflow = originalOverflow;
            if (scrollBarWidth) {
                document.body.style.paddingRight = originalPaddingRight;
            }
        };
    }, [locked]);
    useEffect(() => {
        if (locked !== initialLocked) {
            setLocked(initialLocked);
        }
    }, [initialLocked]);
    return [locked, setLocked];
}
/* harmony default export */ var useLockedBody_useLockedBody = ((/* unused pure expression or super */ null && (useLockedBody)));

;// CONCATENATED MODULE: ../../.yarn/__virtual__/usehooks-ts-virtual-e376d4cf26/0/cache/usehooks-ts-npm-2.9.1-14c625587f-36f1e4142c.zip/node_modules/usehooks-ts/dist/esm/useMap/useMap.js

function useMap(initialState = new Map()) {
    const [map, setMap] = useState(new Map(initialState));
    const actions = {
        set: useCallback((key, value) => {
            setMap(prev => {
                const copy = new Map(prev);
                copy.set(key, value);
                return copy;
            });
        }, []),
        setAll: useCallback(entries => {
            setMap(() => new Map(entries));
        }, []),
        remove: useCallback(key => {
            setMap(prev => {
                const copy = new Map(prev);
                copy.delete(key);
                return copy;
            });
        }, []),
        reset: useCallback(() => {
            setMap(() => new Map());
        }, []),
    };
    return [map, actions];
}
/* harmony default export */ var useMap_useMap = ((/* unused pure expression or super */ null && (useMap)));

;// CONCATENATED MODULE: ../../.yarn/__virtual__/usehooks-ts-virtual-e376d4cf26/0/cache/usehooks-ts-npm-2.9.1-14c625587f-36f1e4142c.zip/node_modules/usehooks-ts/dist/esm/useMediaQuery/useMediaQuery.js

function useMediaQuery_useMediaQuery(query) {
    const getMatches = (query) => {
        if (typeof window !== 'undefined') {
            return window.matchMedia(query).matches;
        }
        return false;
    };
    const [matches, setMatches] = useState(getMatches(query));
    function handleChange() {
        setMatches(getMatches(query));
    }
    useEffect(() => {
        const matchMedia = window.matchMedia(query);
        handleChange();
        if (matchMedia.addListener) {
            matchMedia.addListener(handleChange);
        }
        else {
            matchMedia.addEventListener('change', handleChange);
        }
        return () => {
            if (matchMedia.removeListener) {
                matchMedia.removeListener(handleChange);
            }
            else {
                matchMedia.removeEventListener('change', handleChange);
            }
        };
    }, [query]);
    return matches;
}
/* harmony default export */ var esm_useMediaQuery_useMediaQuery = ((/* unused pure expression or super */ null && (useMediaQuery_useMediaQuery)));

;// CONCATENATED MODULE: ../../.yarn/__virtual__/usehooks-ts-virtual-e376d4cf26/0/cache/usehooks-ts-npm-2.9.1-14c625587f-36f1e4142c.zip/node_modules/usehooks-ts/dist/esm/useOnClickOutside/useOnClickOutside.js

function useOnClickOutside(ref, handler, mouseEvent = 'mousedown') {
    esm_useEventListener_useEventListener(mouseEvent, event => {
        const el = ref === null || ref === void 0 ? void 0 : ref.current;
        if (!el || el.contains(event.target)) {
            return;
        }
        handler(event);
    });
}
/* harmony default export */ var useOnClickOutside_useOnClickOutside = (useOnClickOutside);

;// CONCATENATED MODULE: ../../.yarn/__virtual__/usehooks-ts-virtual-e376d4cf26/0/cache/usehooks-ts-npm-2.9.1-14c625587f-36f1e4142c.zip/node_modules/usehooks-ts/dist/esm/useReadLocalStorage/useReadLocalStorage.js


function useReadLocalStorage(key) {
    const readValue = useCallback(() => {
        if (typeof window === 'undefined') {
            return null;
        }
        try {
            const item = window.localStorage.getItem(key);
            return item ? JSON.parse(item) : null;
        }
        catch (error) {
            console.warn(`Error reading localStorage key “${key}”:`, error);
            return null;
        }
    }, [key]);
    const [storedValue, setStoredValue] = useState(readValue);
    useEffect(() => {
        setStoredValue(readValue());
    }, []);
    const handleStorageChange = useCallback((event) => {
        if ((event === null || event === void 0 ? void 0 : event.key) && event.key !== key) {
            return;
        }
        setStoredValue(readValue());
    }, [key, readValue]);
    useEventListener('storage', handleStorageChange);
    useEventListener('local-storage', handleStorageChange);
    return storedValue;
}
/* harmony default export */ var useReadLocalStorage_useReadLocalStorage = ((/* unused pure expression or super */ null && (useReadLocalStorage)));

;// CONCATENATED MODULE: ../../.yarn/__virtual__/usehooks-ts-virtual-e376d4cf26/0/cache/usehooks-ts-npm-2.9.1-14c625587f-36f1e4142c.zip/node_modules/usehooks-ts/dist/esm/useScreen/useScreen.js


function useScreen() {
    const getScreen = () => {
        if (typeof window !== 'undefined' && window.screen) {
            return window.screen;
        }
        return undefined;
    };
    const [screen, setScreen] = useState(getScreen());
    function handleSize() {
        setScreen(getScreen());
    }
    useEventListener('resize', handleSize);
    useIsomorphicLayoutEffect(() => {
        handleSize();
    }, []);
    return screen;
}
/* harmony default export */ var useScreen_useScreen = ((/* unused pure expression or super */ null && (useScreen)));

;// CONCATENATED MODULE: ../../.yarn/__virtual__/usehooks-ts-virtual-e376d4cf26/0/cache/usehooks-ts-npm-2.9.1-14c625587f-36f1e4142c.zip/node_modules/usehooks-ts/dist/esm/useScript/useScript.js

const cachedScriptStatuses = {};
function getScriptNode(src) {
    const node = document.querySelector(`script[src="${src}"]`);
    const status = node === null || node === void 0 ? void 0 : node.getAttribute('data-status');
    return {
        node,
        status,
    };
}
function useScript(src, options) {
    const [status, setStatus] = useState(() => {
        var _a;
        if (!src || (options === null || options === void 0 ? void 0 : options.shouldPreventLoad)) {
            return 'idle';
        }
        if (typeof window === 'undefined') {
            return 'loading';
        }
        return (_a = cachedScriptStatuses[src]) !== null && _a !== void 0 ? _a : 'loading';
    });
    useEffect(() => {
        var _a, _b;
        if (!src || (options === null || options === void 0 ? void 0 : options.shouldPreventLoad)) {
            return;
        }
        const cachedScriptStatus = cachedScriptStatuses[src];
        if (cachedScriptStatus === 'ready' || cachedScriptStatus === 'error') {
            setStatus(cachedScriptStatus);
            return;
        }
        const script = getScriptNode(src);
        let scriptNode = script.node;
        if (!scriptNode) {
            scriptNode = document.createElement('script');
            scriptNode.src = src;
            scriptNode.async = true;
            scriptNode.setAttribute('data-status', 'loading');
            document.body.appendChild(scriptNode);
            const setAttributeFromEvent = (event) => {
                const scriptStatus = event.type === 'load' ? 'ready' : 'error';
                scriptNode === null || scriptNode === void 0 ? void 0 : scriptNode.setAttribute('data-status', scriptStatus);
            };
            scriptNode.addEventListener('load', setAttributeFromEvent);
            scriptNode.addEventListener('error', setAttributeFromEvent);
        }
        else {
            setStatus((_b = (_a = script.status) !== null && _a !== void 0 ? _a : cachedScriptStatus) !== null && _b !== void 0 ? _b : 'loading');
        }
        const setStateFromEvent = (event) => {
            const newStatus = event.type === 'load' ? 'ready' : 'error';
            setStatus(newStatus);
            cachedScriptStatuses[src] = newStatus;
        };
        scriptNode.addEventListener('load', setStateFromEvent);
        scriptNode.addEventListener('error', setStateFromEvent);
        return () => {
            if (scriptNode) {
                scriptNode.removeEventListener('load', setStateFromEvent);
                scriptNode.removeEventListener('error', setStateFromEvent);
            }
            if (scriptNode && (options === null || options === void 0 ? void 0 : options.removeOnUnmount)) {
                scriptNode.remove();
            }
        };
    }, [src, options === null || options === void 0 ? void 0 : options.shouldPreventLoad, options === null || options === void 0 ? void 0 : options.removeOnUnmount]);
    return status;
}
/* harmony default export */ var useScript_useScript = ((/* unused pure expression or super */ null && (useScript)));

;// CONCATENATED MODULE: ../../.yarn/__virtual__/usehooks-ts-virtual-e376d4cf26/0/cache/usehooks-ts-npm-2.9.1-14c625587f-36f1e4142c.zip/node_modules/usehooks-ts/dist/esm/useSessionStorage/useSessionStorage.js


function useSessionStorage(key, initialValue) {
    const readValue = useCallback(() => {
        if (typeof window === 'undefined') {
            return initialValue;
        }
        try {
            const item = window.sessionStorage.getItem(key);
            return item ? useSessionStorage_parseJSON(item) : initialValue;
        }
        catch (error) {
            console.warn(`Error reading sessionStorage key “${key}”:`, error);
            return initialValue;
        }
    }, [initialValue, key]);
    const [storedValue, setStoredValue] = useState(readValue);
    const setValue = useEventCallback(value => {
        if (typeof window == 'undefined') {
            console.warn(`Tried setting sessionStorage key “${key}” even though environment is not a client`);
        }
        try {
            const newValue = value instanceof Function ? value(storedValue) : value;
            window.sessionStorage.setItem(key, JSON.stringify(newValue));
            setStoredValue(newValue);
            window.dispatchEvent(new Event('session-storage'));
        }
        catch (error) {
            console.warn(`Error setting sessionStorage key “${key}”:`, error);
        }
    });
    useEffect(() => {
        setStoredValue(readValue());
    }, []);
    const handleStorageChange = useCallback((event) => {
        if ((event === null || event === void 0 ? void 0 : event.key) && event.key !== key) {
            return;
        }
        setStoredValue(readValue());
    }, [key, readValue]);
    useEventListener('storage', handleStorageChange);
    useEventListener('session-storage', handleStorageChange);
    return [storedValue, setValue];
}
/* harmony default export */ var useSessionStorage_useSessionStorage = ((/* unused pure expression or super */ null && (useSessionStorage)));
function useSessionStorage_parseJSON(value) {
    try {
        return value === 'undefined' ? undefined : JSON.parse(value !== null && value !== void 0 ? value : '');
    }
    catch (_a) {
        console.log('parsing error on', { value });
        return undefined;
    }
}

;// CONCATENATED MODULE: ../../.yarn/__virtual__/usehooks-ts-virtual-e376d4cf26/0/cache/usehooks-ts-npm-2.9.1-14c625587f-36f1e4142c.zip/node_modules/usehooks-ts/dist/esm/useStep/useStep.js

function useStep(maxStep) {
    const [currentStep, setCurrentStep] = useState(1);
    const canGoToNextStep = useMemo(() => currentStep + 1 <= maxStep, [currentStep, maxStep]);
    const canGoToPrevStep = useMemo(() => currentStep - 1 >= 1, [currentStep]);
    const setStep = useCallback(step => {
        const newStep = step instanceof Function ? step(currentStep) : step;
        if (newStep >= 1 && newStep <= maxStep) {
            setCurrentStep(newStep);
            return;
        }
        throw new Error('Step not valid');
    }, [maxStep, currentStep]);
    const goToNextStep = useCallback(() => {
        if (canGoToNextStep) {
            setCurrentStep(step => step + 1);
        }
    }, [canGoToNextStep]);
    const goToPrevStep = useCallback(() => {
        if (canGoToPrevStep) {
            setCurrentStep(step => step - 1);
        }
    }, [canGoToPrevStep]);
    const reset = useCallback(() => {
        setCurrentStep(1);
    }, []);
    return [
        currentStep,
        {
            goToNextStep,
            goToPrevStep,
            canGoToNextStep,
            canGoToPrevStep,
            setStep,
            reset,
        },
    ];
}
/* harmony default export */ var useStep_useStep = ((/* unused pure expression or super */ null && (useStep)));

;// CONCATENATED MODULE: ../../.yarn/__virtual__/usehooks-ts-virtual-e376d4cf26/0/cache/usehooks-ts-npm-2.9.1-14c625587f-36f1e4142c.zip/node_modules/usehooks-ts/dist/esm/useTernaryDarkMode/useTernaryDarkMode.js


const useTernaryDarkMode_COLOR_SCHEME_QUERY = '(prefers-color-scheme: dark)';
function useTernaryDarkMode() {
    const isDarkOS = useMediaQuery(useTernaryDarkMode_COLOR_SCHEME_QUERY);
    const [ternaryDarkMode, setTernaryDarkMode] = useLocalStorage('usehooks-ts-ternary-dark-mode', 'system');
    const [isDarkMode, setDarkMode] = useState(isDarkOS);
    useUpdateEffect(() => {
        if (ternaryDarkMode === 'system') {
            setDarkMode(isDarkOS);
        }
    }, [isDarkOS]);
    useEffect(() => {
        switch (ternaryDarkMode) {
            case 'light':
                setDarkMode(false);
                break;
            case 'system':
                setDarkMode(isDarkOS);
                break;
            case 'dark':
                setDarkMode(true);
                break;
        }
    }, [ternaryDarkMode, isDarkOS]);
    function toggleTernaryDarkMode() {
        const toggleDict = {
            light: 'system',
            system: 'dark',
            dark: 'light',
        };
        setTernaryDarkMode(prevMode => toggleDict[prevMode]);
    }
    return {
        isDarkMode,
        ternaryDarkMode,
        setTernaryDarkMode,
        toggleTernaryDarkMode,
    };
}
/* harmony default export */ var useTernaryDarkMode_useTernaryDarkMode = ((/* unused pure expression or super */ null && (useTernaryDarkMode)));

;// CONCATENATED MODULE: ../../.yarn/__virtual__/usehooks-ts-virtual-e376d4cf26/0/cache/usehooks-ts-npm-2.9.1-14c625587f-36f1e4142c.zip/node_modules/usehooks-ts/dist/esm/useTimeout/useTimeout.js


function useTimeout(callback, delay) {
    const savedCallback = useRef(callback);
    useIsomorphicLayoutEffect(() => {
        savedCallback.current = callback;
    }, [callback]);
    useEffect(() => {
        if (!delay && delay !== 0) {
            return;
        }
        const id = setTimeout(() => savedCallback.current(), delay);
        return () => clearTimeout(id);
    }, [delay]);
}
/* harmony default export */ var useTimeout_useTimeout = ((/* unused pure expression or super */ null && (useTimeout)));

;// CONCATENATED MODULE: ../../.yarn/__virtual__/usehooks-ts-virtual-e376d4cf26/0/cache/usehooks-ts-npm-2.9.1-14c625587f-36f1e4142c.zip/node_modules/usehooks-ts/dist/esm/useToggle/useToggle.js

function useToggle(defaultValue) {
    const [value, setValue] = useState(!!defaultValue);
    const toggle = useCallback(() => setValue(x => !x), []);
    return [value, toggle, setValue];
}
/* harmony default export */ var useToggle_useToggle = ((/* unused pure expression or super */ null && (useToggle)));

;// CONCATENATED MODULE: ../../.yarn/__virtual__/usehooks-ts-virtual-e376d4cf26/0/cache/usehooks-ts-npm-2.9.1-14c625587f-36f1e4142c.zip/node_modules/usehooks-ts/dist/esm/useUpdateEffect/useUpdateEffect.js


function useUpdateEffect_useUpdateEffect(effect, deps) {
    const isFirst = useIsFirstRender();
    useEffect(() => {
        if (!isFirst) {
            return effect();
        }
    }, deps);
}
/* harmony default export */ var esm_useUpdateEffect_useUpdateEffect = ((/* unused pure expression or super */ null && (useUpdateEffect_useUpdateEffect)));

;// CONCATENATED MODULE: ../../.yarn/__virtual__/usehooks-ts-virtual-e376d4cf26/0/cache/usehooks-ts-npm-2.9.1-14c625587f-36f1e4142c.zip/node_modules/usehooks-ts/dist/esm/useWindowSize/useWindowSize.js


function useWindowSize() {
    const [windowSize, setWindowSize] = useState({
        width: 0,
        height: 0,
    });
    const handleSize = () => {
        setWindowSize({
            width: window.innerWidth,
            height: window.innerHeight,
        });
    };
    useEventListener('resize', handleSize);
    useIsomorphicLayoutEffect(() => {
        handleSize();
    }, []);
    return windowSize;
}
/* harmony default export */ var useWindowSize_useWindowSize = ((/* unused pure expression or super */ null && (useWindowSize)));

;// CONCATENATED MODULE: ../../.yarn/__virtual__/usehooks-ts-virtual-e376d4cf26/0/cache/usehooks-ts-npm-2.9.1-14c625587f-36f1e4142c.zip/node_modules/usehooks-ts/dist/esm/index.js












































































/***/ }),

/***/ 73592:
/***/ (function(module) {

// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

function EventEmitter() {
  this._events = this._events || {};
  this._maxListeners = this._maxListeners || undefined;
}
module.exports = EventEmitter;

// Backwards-compat with node 0.10.x
// EventEmitter.EventEmitter = EventEmitter;

EventEmitter.prototype._events = undefined;
EventEmitter.prototype._maxListeners = undefined;

// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
EventEmitter.defaultMaxListeners = 10;

// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
EventEmitter.prototype.setMaxListeners = function(n) {
  if (!isNumber(n) || n < 0 || isNaN(n))
    throw TypeError('n must be a positive number');
  this._maxListeners = n;
  return this;
};

EventEmitter.prototype.emit = function(type) {
  var er, handler, len, args, i, listeners;

  if (!this._events)
    this._events = {};

  // If there is no 'error' event listener then throw.
  if (type === 'error') {
    if (!this._events.error ||
        (isObject(this._events.error) && !this._events.error.length)) {
      er = arguments[1];
      if (er instanceof Error) {
        throw er; // Unhandled 'error' event
      } else {
        // At least give some kind of context to the user
        var err = new Error('Uncaught, unspecified "error" event. (' + er + ')');
        err.context = er;
        throw err;
      }
    }
  }

  handler = this._events[type];

  if (isUndefined(handler))
    return false;

  if (isFunction(handler)) {
    switch (arguments.length) {
      // fast cases
      case 1:
        handler.call(this);
        break;
      case 2:
        handler.call(this, arguments[1]);
        break;
      case 3:
        handler.call(this, arguments[1], arguments[2]);
        break;
      // slower
      default:
        args = Array.prototype.slice.call(arguments, 1);
        handler.apply(this, args);
    }
  } else if (isObject(handler)) {
    args = Array.prototype.slice.call(arguments, 1);
    listeners = handler.slice();
    len = listeners.length;
    for (i = 0; i < len; i++)
      listeners[i].apply(this, args);
  }

  return true;
};

EventEmitter.prototype.addListener = function(type, listener) {
  var m;

  if (!isFunction(listener))
    throw TypeError('listener must be a function');

  if (!this._events)
    this._events = {};

  // To avoid recursion in the case that type === "newListener"! Before
  // adding it to the listeners, first emit "newListener".
  if (this._events.newListener)
    this.emit('newListener', type,
              isFunction(listener.listener) ?
              listener.listener : listener);

  if (!this._events[type])
    // Optimize the case of one listener. Don't need the extra array object.
    this._events[type] = listener;
  else if (isObject(this._events[type]))
    // If we've already got an array, just append.
    this._events[type].push(listener);
  else
    // Adding the second element, need to change to array.
    this._events[type] = [this._events[type], listener];

  // Check for listener leak
  if (isObject(this._events[type]) && !this._events[type].warned) {
    if (!isUndefined(this._maxListeners)) {
      m = this._maxListeners;
    } else {
      m = EventEmitter.defaultMaxListeners;
    }

    if (m && m > 0 && this._events[type].length > m) {
      this._events[type].warned = true;
      console.error('(node) warning: possible EventEmitter memory ' +
                    'leak detected. %d listeners added. ' +
                    'Use emitter.setMaxListeners() to increase limit.',
                    this._events[type].length);
      if (typeof console.trace === 'function') {
        // not supported in IE 10
        console.trace();
      }
    }
  }

  return this;
};

EventEmitter.prototype.on = EventEmitter.prototype.addListener;

EventEmitter.prototype.once = function(type, listener) {
  if (!isFunction(listener))
    throw TypeError('listener must be a function');

  var fired = false;

  function g() {
    this.removeListener(type, g);

    if (!fired) {
      fired = true;
      listener.apply(this, arguments);
    }
  }

  g.listener = listener;
  this.on(type, g);

  return this;
};

// emits a 'removeListener' event iff the listener was removed
EventEmitter.prototype.removeListener = function(type, listener) {
  var list, position, length, i;

  if (!isFunction(listener))
    throw TypeError('listener must be a function');

  if (!this._events || !this._events[type])
    return this;

  list = this._events[type];
  length = list.length;
  position = -1;

  if (list === listener ||
      (isFunction(list.listener) && list.listener === listener)) {
    delete this._events[type];
    if (this._events.removeListener)
      this.emit('removeListener', type, listener);

  } else if (isObject(list)) {
    for (i = length; i-- > 0;) {
      if (list[i] === listener ||
          (list[i].listener && list[i].listener === listener)) {
        position = i;
        break;
      }
    }

    if (position < 0)
      return this;

    if (list.length === 1) {
      list.length = 0;
      delete this._events[type];
    } else {
      list.splice(position, 1);
    }

    if (this._events.removeListener)
      this.emit('removeListener', type, listener);
  }

  return this;
};

EventEmitter.prototype.removeAllListeners = function(type) {
  var key, listeners;

  if (!this._events)
    return this;

  // not listening for removeListener, no need to emit
  if (!this._events.removeListener) {
    if (arguments.length === 0)
      this._events = {};
    else if (this._events[type])
      delete this._events[type];
    return this;
  }

  // emit removeListener for all listeners on all events
  if (arguments.length === 0) {
    for (key in this._events) {
      if (key === 'removeListener') continue;
      this.removeAllListeners(key);
    }
    this.removeAllListeners('removeListener');
    this._events = {};
    return this;
  }

  listeners = this._events[type];

  if (isFunction(listeners)) {
    this.removeListener(type, listeners);
  } else if (listeners) {
    // LIFO order
    while (listeners.length)
      this.removeListener(type, listeners[listeners.length - 1]);
  }
  delete this._events[type];

  return this;
};

EventEmitter.prototype.listeners = function(type) {
  var ret;
  if (!this._events || !this._events[type])
    ret = [];
  else if (isFunction(this._events[type]))
    ret = [this._events[type]];
  else
    ret = this._events[type].slice();
  return ret;
};

EventEmitter.prototype.listenerCount = function(type) {
  if (this._events) {
    var evlistener = this._events[type];

    if (isFunction(evlistener))
      return 1;
    else if (evlistener)
      return evlistener.length;
  }
  return 0;
};

EventEmitter.listenerCount = function(emitter, type) {
  return emitter.listenerCount(type);
};

function isFunction(arg) {
  return typeof arg === 'function';
}

function isNumber(arg) {
  return typeof arg === 'number';
}

function isObject(arg) {
  return typeof arg === 'object' && arg !== null;
}

function isUndefined(arg) {
  return arg === void 0;
}


/***/ }),

/***/ 64031:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ emotion_is_prop_valid_esm; }
});

;// CONCATENATED MODULE: ../../.yarn/cache/@emotion-memoize-npm-0.8.0-c5dd451828-c87bb110b8.zip/node_modules/@emotion/memoize/dist/emotion-memoize.esm.js
function memoize(fn) {
  var cache = Object.create(null);
  return function (arg) {
    if (cache[arg] === undefined) cache[arg] = fn(arg);
    return cache[arg];
  };
}

/* harmony default export */ var emotion_memoize_esm = (memoize);

;// CONCATENATED MODULE: ../../.yarn/cache/@emotion-is-prop-valid-npm-1.2.0-332d343e3d-cc7a19850a.zip/node_modules/@emotion/is-prop-valid/dist/emotion-is-prop-valid.esm.js


var reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23

var isPropValid = /* #__PURE__ */emotion_memoize_esm(function (prop) {
  return reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111
  /* o */
  && prop.charCodeAt(1) === 110
  /* n */
  && prop.charCodeAt(2) < 91;
}
/* Z+1 */
);

/* harmony default export */ var emotion_is_prop_valid_esm = (isPropValid);


/***/ }),

/***/ 90728:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
function stylis_min (W) {
  function M(d, c, e, h, a) {
    for (var m = 0, b = 0, v = 0, n = 0, q, g, x = 0, K = 0, k, u = k = q = 0, l = 0, r = 0, I = 0, t = 0, B = e.length, J = B - 1, y, f = '', p = '', F = '', G = '', C; l < B;) {
      g = e.charCodeAt(l);
      l === J && 0 !== b + n + v + m && (0 !== b && (g = 47 === b ? 10 : 47), n = v = m = 0, B++, J++);

      if (0 === b + n + v + m) {
        if (l === J && (0 < r && (f = f.replace(N, '')), 0 < f.trim().length)) {
          switch (g) {
            case 32:
            case 9:
            case 59:
            case 13:
            case 10:
              break;

            default:
              f += e.charAt(l);
          }

          g = 59;
        }

        switch (g) {
          case 123:
            f = f.trim();
            q = f.charCodeAt(0);
            k = 1;

            for (t = ++l; l < B;) {
              switch (g = e.charCodeAt(l)) {
                case 123:
                  k++;
                  break;

                case 125:
                  k--;
                  break;

                case 47:
                  switch (g = e.charCodeAt(l + 1)) {
                    case 42:
                    case 47:
                      a: {
                        for (u = l + 1; u < J; ++u) {
                          switch (e.charCodeAt(u)) {
                            case 47:
                              if (42 === g && 42 === e.charCodeAt(u - 1) && l + 2 !== u) {
                                l = u + 1;
                                break a;
                              }

                              break;

                            case 10:
                              if (47 === g) {
                                l = u + 1;
                                break a;
                              }

                          }
                        }

                        l = u;
                      }

                  }

                  break;

                case 91:
                  g++;

                case 40:
                  g++;

                case 34:
                case 39:
                  for (; l++ < J && e.charCodeAt(l) !== g;) {
                  }

              }

              if (0 === k) break;
              l++;
            }

            k = e.substring(t, l);
            0 === q && (q = (f = f.replace(ca, '').trim()).charCodeAt(0));

            switch (q) {
              case 64:
                0 < r && (f = f.replace(N, ''));
                g = f.charCodeAt(1);

                switch (g) {
                  case 100:
                  case 109:
                  case 115:
                  case 45:
                    r = c;
                    break;

                  default:
                    r = O;
                }

                k = M(c, r, k, g, a + 1);
                t = k.length;
                0 < A && (r = X(O, f, I), C = H(3, k, r, c, D, z, t, g, a, h), f = r.join(''), void 0 !== C && 0 === (t = (k = C.trim()).length) && (g = 0, k = ''));
                if (0 < t) switch (g) {
                  case 115:
                    f = f.replace(da, ea);

                  case 100:
                  case 109:
                  case 45:
                    k = f + '{' + k + '}';
                    break;

                  case 107:
                    f = f.replace(fa, '$1 $2');
                    k = f + '{' + k + '}';
                    k = 1 === w || 2 === w && L('@' + k, 3) ? '@-webkit-' + k + '@' + k : '@' + k;
                    break;

                  default:
                    k = f + k, 112 === h && (k = (p += k, ''));
                } else k = '';
                break;

              default:
                k = M(c, X(c, f, I), k, h, a + 1);
            }

            F += k;
            k = I = r = u = q = 0;
            f = '';
            g = e.charCodeAt(++l);
            break;

          case 125:
          case 59:
            f = (0 < r ? f.replace(N, '') : f).trim();
            if (1 < (t = f.length)) switch (0 === u && (q = f.charCodeAt(0), 45 === q || 96 < q && 123 > q) && (t = (f = f.replace(' ', ':')).length), 0 < A && void 0 !== (C = H(1, f, c, d, D, z, p.length, h, a, h)) && 0 === (t = (f = C.trim()).length) && (f = '\x00\x00'), q = f.charCodeAt(0), g = f.charCodeAt(1), q) {
              case 0:
                break;

              case 64:
                if (105 === g || 99 === g) {
                  G += f + e.charAt(l);
                  break;
                }

              default:
                58 !== f.charCodeAt(t - 1) && (p += P(f, q, g, f.charCodeAt(2)));
            }
            I = r = u = q = 0;
            f = '';
            g = e.charCodeAt(++l);
        }
      }

      switch (g) {
        case 13:
        case 10:
          47 === b ? b = 0 : 0 === 1 + q && 107 !== h && 0 < f.length && (r = 1, f += '\x00');
          0 < A * Y && H(0, f, c, d, D, z, p.length, h, a, h);
          z = 1;
          D++;
          break;

        case 59:
        case 125:
          if (0 === b + n + v + m) {
            z++;
            break;
          }

        default:
          z++;
          y = e.charAt(l);

          switch (g) {
            case 9:
            case 32:
              if (0 === n + m + b) switch (x) {
                case 44:
                case 58:
                case 9:
                case 32:
                  y = '';
                  break;

                default:
                  32 !== g && (y = ' ');
              }
              break;

            case 0:
              y = '\\0';
              break;

            case 12:
              y = '\\f';
              break;

            case 11:
              y = '\\v';
              break;

            case 38:
              0 === n + b + m && (r = I = 1, y = '\f' + y);
              break;

            case 108:
              if (0 === n + b + m + E && 0 < u) switch (l - u) {
                case 2:
                  112 === x && 58 === e.charCodeAt(l - 3) && (E = x);

                case 8:
                  111 === K && (E = K);
              }
              break;

            case 58:
              0 === n + b + m && (u = l);
              break;

            case 44:
              0 === b + v + n + m && (r = 1, y += '\r');
              break;

            case 34:
            case 39:
              0 === b && (n = n === g ? 0 : 0 === n ? g : n);
              break;

            case 91:
              0 === n + b + v && m++;
              break;

            case 93:
              0 === n + b + v && m--;
              break;

            case 41:
              0 === n + b + m && v--;
              break;

            case 40:
              if (0 === n + b + m) {
                if (0 === q) switch (2 * x + 3 * K) {
                  case 533:
                    break;

                  default:
                    q = 1;
                }
                v++;
              }

              break;

            case 64:
              0 === b + v + n + m + u + k && (k = 1);
              break;

            case 42:
            case 47:
              if (!(0 < n + m + v)) switch (b) {
                case 0:
                  switch (2 * g + 3 * e.charCodeAt(l + 1)) {
                    case 235:
                      b = 47;
                      break;

                    case 220:
                      t = l, b = 42;
                  }

                  break;

                case 42:
                  47 === g && 42 === x && t + 2 !== l && (33 === e.charCodeAt(t + 2) && (p += e.substring(t, l + 1)), y = '', b = 0);
              }
          }

          0 === b && (f += y);
      }

      K = x;
      x = g;
      l++;
    }

    t = p.length;

    if (0 < t) {
      r = c;
      if (0 < A && (C = H(2, p, r, d, D, z, t, h, a, h), void 0 !== C && 0 === (p = C).length)) return G + p + F;
      p = r.join(',') + '{' + p + '}';

      if (0 !== w * E) {
        2 !== w || L(p, 2) || (E = 0);

        switch (E) {
          case 111:
            p = p.replace(ha, ':-moz-$1') + p;
            break;

          case 112:
            p = p.replace(Q, '::-webkit-input-$1') + p.replace(Q, '::-moz-$1') + p.replace(Q, ':-ms-input-$1') + p;
        }

        E = 0;
      }
    }

    return G + p + F;
  }

  function X(d, c, e) {
    var h = c.trim().split(ia);
    c = h;
    var a = h.length,
        m = d.length;

    switch (m) {
      case 0:
      case 1:
        var b = 0;

        for (d = 0 === m ? '' : d[0] + ' '; b < a; ++b) {
          c[b] = Z(d, c[b], e).trim();
        }

        break;

      default:
        var v = b = 0;

        for (c = []; b < a; ++b) {
          for (var n = 0; n < m; ++n) {
            c[v++] = Z(d[n] + ' ', h[b], e).trim();
          }
        }

    }

    return c;
  }

  function Z(d, c, e) {
    var h = c.charCodeAt(0);
    33 > h && (h = (c = c.trim()).charCodeAt(0));

    switch (h) {
      case 38:
        return c.replace(F, '$1' + d.trim());

      case 58:
        return d.trim() + c.replace(F, '$1' + d.trim());

      default:
        if (0 < 1 * e && 0 < c.indexOf('\f')) return c.replace(F, (58 === d.charCodeAt(0) ? '' : '$1') + d.trim());
    }

    return d + c;
  }

  function P(d, c, e, h) {
    var a = d + ';',
        m = 2 * c + 3 * e + 4 * h;

    if (944 === m) {
      d = a.indexOf(':', 9) + 1;
      var b = a.substring(d, a.length - 1).trim();
      b = a.substring(0, d).trim() + b + ';';
      return 1 === w || 2 === w && L(b, 1) ? '-webkit-' + b + b : b;
    }

    if (0 === w || 2 === w && !L(a, 1)) return a;

    switch (m) {
      case 1015:
        return 97 === a.charCodeAt(10) ? '-webkit-' + a + a : a;

      case 951:
        return 116 === a.charCodeAt(3) ? '-webkit-' + a + a : a;

      case 963:
        return 110 === a.charCodeAt(5) ? '-webkit-' + a + a : a;

      case 1009:
        if (100 !== a.charCodeAt(4)) break;

      case 969:
      case 942:
        return '-webkit-' + a + a;

      case 978:
        return '-webkit-' + a + '-moz-' + a + a;

      case 1019:
      case 983:
        return '-webkit-' + a + '-moz-' + a + '-ms-' + a + a;

      case 883:
        if (45 === a.charCodeAt(8)) return '-webkit-' + a + a;
        if (0 < a.indexOf('image-set(', 11)) return a.replace(ja, '$1-webkit-$2') + a;
        break;

      case 932:
        if (45 === a.charCodeAt(4)) switch (a.charCodeAt(5)) {
          case 103:
            return '-webkit-box-' + a.replace('-grow', '') + '-webkit-' + a + '-ms-' + a.replace('grow', 'positive') + a;

          case 115:
            return '-webkit-' + a + '-ms-' + a.replace('shrink', 'negative') + a;

          case 98:
            return '-webkit-' + a + '-ms-' + a.replace('basis', 'preferred-size') + a;
        }
        return '-webkit-' + a + '-ms-' + a + a;

      case 964:
        return '-webkit-' + a + '-ms-flex-' + a + a;

      case 1023:
        if (99 !== a.charCodeAt(8)) break;
        b = a.substring(a.indexOf(':', 15)).replace('flex-', '').replace('space-between', 'justify');
        return '-webkit-box-pack' + b + '-webkit-' + a + '-ms-flex-pack' + b + a;

      case 1005:
        return ka.test(a) ? a.replace(aa, ':-webkit-') + a.replace(aa, ':-moz-') + a : a;

      case 1e3:
        b = a.substring(13).trim();
        c = b.indexOf('-') + 1;

        switch (b.charCodeAt(0) + b.charCodeAt(c)) {
          case 226:
            b = a.replace(G, 'tb');
            break;

          case 232:
            b = a.replace(G, 'tb-rl');
            break;

          case 220:
            b = a.replace(G, 'lr');
            break;

          default:
            return a;
        }

        return '-webkit-' + a + '-ms-' + b + a;

      case 1017:
        if (-1 === a.indexOf('sticky', 9)) break;

      case 975:
        c = (a = d).length - 10;
        b = (33 === a.charCodeAt(c) ? a.substring(0, c) : a).substring(d.indexOf(':', 7) + 1).trim();

        switch (m = b.charCodeAt(0) + (b.charCodeAt(7) | 0)) {
          case 203:
            if (111 > b.charCodeAt(8)) break;

          case 115:
            a = a.replace(b, '-webkit-' + b) + ';' + a;
            break;

          case 207:
          case 102:
            a = a.replace(b, '-webkit-' + (102 < m ? 'inline-' : '') + 'box') + ';' + a.replace(b, '-webkit-' + b) + ';' + a.replace(b, '-ms-' + b + 'box') + ';' + a;
        }

        return a + ';';

      case 938:
        if (45 === a.charCodeAt(5)) switch (a.charCodeAt(6)) {
          case 105:
            return b = a.replace('-items', ''), '-webkit-' + a + '-webkit-box-' + b + '-ms-flex-' + b + a;

          case 115:
            return '-webkit-' + a + '-ms-flex-item-' + a.replace(ba, '') + a;

          default:
            return '-webkit-' + a + '-ms-flex-line-pack' + a.replace('align-content', '').replace(ba, '') + a;
        }
        break;

      case 973:
      case 989:
        if (45 !== a.charCodeAt(3) || 122 === a.charCodeAt(4)) break;

      case 931:
      case 953:
        if (!0 === la.test(d)) return 115 === (b = d.substring(d.indexOf(':') + 1)).charCodeAt(0) ? P(d.replace('stretch', 'fill-available'), c, e, h).replace(':fill-available', ':stretch') : a.replace(b, '-webkit-' + b) + a.replace(b, '-moz-' + b.replace('fill-', '')) + a;
        break;

      case 962:
        if (a = '-webkit-' + a + (102 === a.charCodeAt(5) ? '-ms-' + a : '') + a, 211 === e + h && 105 === a.charCodeAt(13) && 0 < a.indexOf('transform', 10)) return a.substring(0, a.indexOf(';', 27) + 1).replace(ma, '$1-webkit-$2') + a;
    }

    return a;
  }

  function L(d, c) {
    var e = d.indexOf(1 === c ? ':' : '{'),
        h = d.substring(0, 3 !== c ? e : 10);
    e = d.substring(e + 1, d.length - 1);
    return R(2 !== c ? h : h.replace(na, '$1'), e, c);
  }

  function ea(d, c) {
    var e = P(c, c.charCodeAt(0), c.charCodeAt(1), c.charCodeAt(2));
    return e !== c + ';' ? e.replace(oa, ' or ($1)').substring(4) : '(' + c + ')';
  }

  function H(d, c, e, h, a, m, b, v, n, q) {
    for (var g = 0, x = c, w; g < A; ++g) {
      switch (w = S[g].call(B, d, x, e, h, a, m, b, v, n, q)) {
        case void 0:
        case !1:
        case !0:
        case null:
          break;

        default:
          x = w;
      }
    }

    if (x !== c) return x;
  }

  function T(d) {
    switch (d) {
      case void 0:
      case null:
        A = S.length = 0;
        break;

      default:
        if ('function' === typeof d) S[A++] = d;else if ('object' === typeof d) for (var c = 0, e = d.length; c < e; ++c) {
          T(d[c]);
        } else Y = !!d | 0;
    }

    return T;
  }

  function U(d) {
    d = d.prefix;
    void 0 !== d && (R = null, d ? 'function' !== typeof d ? w = 1 : (w = 2, R = d) : w = 0);
    return U;
  }

  function B(d, c) {
    var e = d;
    33 > e.charCodeAt(0) && (e = e.trim());
    V = e;
    e = [V];

    if (0 < A) {
      var h = H(-1, c, e, e, D, z, 0, 0, 0, 0);
      void 0 !== h && 'string' === typeof h && (c = h);
    }

    var a = M(O, e, c, 0, 0);
    0 < A && (h = H(-2, a, e, e, D, z, a.length, 0, 0, 0), void 0 !== h && (a = h));
    V = '';
    E = 0;
    z = D = 1;
    return a;
  }

  var ca = /^\0+/g,
      N = /[\0\r\f]/g,
      aa = /: */g,
      ka = /zoo|gra/,
      ma = /([,: ])(transform)/g,
      ia = /,\r+?/g,
      F = /([\t\r\n ])*\f?&/g,
      fa = /@(k\w+)\s*(\S*)\s*/,
      Q = /::(place)/g,
      ha = /:(read-only)/g,
      G = /[svh]\w+-[tblr]{2}/,
      da = /\(\s*(.*)\s*\)/g,
      oa = /([\s\S]*?);/g,
      ba = /-self|flex-/g,
      na = /[^]*?(:[rp][el]a[\w-]+)[^]*/,
      la = /stretch|:\s*\w+\-(?:conte|avail)/,
      ja = /([^-])(image-set\()/,
      z = 1,
      D = 1,
      E = 0,
      w = 1,
      O = [],
      S = [],
      A = 0,
      R = null,
      Y = 0,
      V = '';
  B.use = T;
  B.set = U;
  void 0 !== W && U(W);
  return B;
}

/* harmony default export */ __webpack_exports__["default"] = (stylis_min);


/***/ }),

/***/ 26729:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
var unitlessKeys = {
  animationIterationCount: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
};

/* harmony default export */ __webpack_exports__["default"] = (unitlessKeys);


/***/ }),

/***/ 90936:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Gd": function() { return /* binding */ getCurrentHub; },
/* harmony export */   "cu": function() { return /* binding */ getMainCarrier; }
/* harmony export */ });
/* unused harmony exports API_VERSION, Hub, getHubFromCarrier, makeMain, setHubOnCarrier */
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3528);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(27447);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(23680);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(62000);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(70302);
/* harmony import */ var _scope_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(12584);
/* harmony import */ var _session_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(87943);




/**
 * API compatibility version of this hub.
 *
 * WARNING: This number should only be increased when the global interface
 * changes and new methods are introduced.
 *
 * @hidden
 */
const API_VERSION = 4;

/**
 * Default maximum number of breadcrumbs added to an event. Can be overwritten
 * with {@link Options.maxBreadcrumbs}.
 */
const DEFAULT_BREADCRUMBS = 100;

/**
 * A layer in the process stack.
 * @hidden
 */

/**
 * @inheritDoc
 */
class Hub  {
  /** Is a {@link Layer}[] containing the client and scope */
    __init() {this._stack = [{}];}

  /** Contains the last event id of a captured event.  */

  /**
   * Creates a new instance of the hub, will push one {@link Layer} into the
   * internal stack on creation.
   *
   * @param client bound to the hub.
   * @param scope bound to the hub.
   * @param version number, higher number means higher priority.
   */
   constructor(client, scope = new _scope_js__WEBPACK_IMPORTED_MODULE_0__/* .Scope */ .s(),   _version = API_VERSION) {this._version = _version;Hub.prototype.__init.call(this);
    this.getStackTop().scope = scope;
    if (client) {
      this.bindClient(client);
    }
  }

  /**
   * @inheritDoc
   */
   isOlderThan(version) {
    return this._version < version;
  }

  /**
   * @inheritDoc
   */
   bindClient(client) {
    const top = this.getStackTop();
    top.client = client;
    if (client && client.setupIntegrations) {
      client.setupIntegrations();
    }
  }

  /**
   * @inheritDoc
   */
   pushScope() {
    // We want to clone the content of prev scope
    const scope = _scope_js__WEBPACK_IMPORTED_MODULE_0__/* .Scope.clone */ .s.clone(this.getScope());
    this.getStack().push({
      client: this.getClient(),
      scope,
    });
    return scope;
  }

  /**
   * @inheritDoc
   */
   popScope() {
    if (this.getStack().length <= 1) return false;
    return !!this.getStack().pop();
  }

  /**
   * @inheritDoc
   */
   withScope(callback) {
    const scope = this.pushScope();
    try {
      callback(scope);
    } finally {
      this.popScope();
    }
  }

  /**
   * @inheritDoc
   */
   getClient() {
    return this.getStackTop().client ;
  }

  /** Returns the scope of the top stack. */
   getScope() {
    return this.getStackTop().scope;
  }

  /** Returns the scope stack for domains or the process. */
   getStack() {
    return this._stack;
  }

  /** Returns the topmost scope layer in the order domain > local > process. */
   getStackTop() {
    return this._stack[this._stack.length - 1];
  }

  /**
   * @inheritDoc
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
   captureException(exception, hint) {
    const eventId = (this._lastEventId = hint && hint.event_id ? hint.event_id : (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .uuid4 */ .DM)());
    const syntheticException = new Error('Sentry syntheticException');
    this._withClient((client, scope) => {
      client.captureException(
        exception,
        {
          originalException: exception,
          syntheticException,
          ...hint,
          event_id: eventId,
        },
        scope,
      );
    });
    return eventId;
  }

  /**
   * @inheritDoc
   */
   captureMessage(
    message,
    // eslint-disable-next-line deprecation/deprecation
    level,
    hint,
  ) {
    const eventId = (this._lastEventId = hint && hint.event_id ? hint.event_id : (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .uuid4 */ .DM)());
    const syntheticException = new Error(message);
    this._withClient((client, scope) => {
      client.captureMessage(
        message,
        level,
        {
          originalException: message,
          syntheticException,
          ...hint,
          event_id: eventId,
        },
        scope,
      );
    });
    return eventId;
  }

  /**
   * @inheritDoc
   */
   captureEvent(event, hint) {
    const eventId = hint && hint.event_id ? hint.event_id : (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .uuid4 */ .DM)();
    if (!event.type) {
      this._lastEventId = eventId;
    }

    this._withClient((client, scope) => {
      client.captureEvent(event, { ...hint, event_id: eventId }, scope);
    });
    return eventId;
  }

  /**
   * @inheritDoc
   */
   lastEventId() {
    return this._lastEventId;
  }

  /**
   * @inheritDoc
   */
   addBreadcrumb(breadcrumb, hint) {
    const { scope, client } = this.getStackTop();

    if (!scope || !client) return;

    const { beforeBreadcrumb = null, maxBreadcrumbs = DEFAULT_BREADCRUMBS } =
      (client.getOptions && client.getOptions()) || {};

    if (maxBreadcrumbs <= 0) return;

    const timestamp = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_2__/* .dateTimestampInSeconds */ .yW)();
    const mergedBreadcrumb = { timestamp, ...breadcrumb };
    const finalBreadcrumb = beforeBreadcrumb
      ? ((0,_sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .consoleSandbox */ .Cf)(() => beforeBreadcrumb(mergedBreadcrumb, hint)) )
      : mergedBreadcrumb;

    if (finalBreadcrumb === null) return;

    scope.addBreadcrumb(finalBreadcrumb, maxBreadcrumbs);
  }

  /**
   * @inheritDoc
   */
   setUser(user) {
    const scope = this.getScope();
    if (scope) scope.setUser(user);
  }

  /**
   * @inheritDoc
   */
   setTags(tags) {
    const scope = this.getScope();
    if (scope) scope.setTags(tags);
  }

  /**
   * @inheritDoc
   */
   setExtras(extras) {
    const scope = this.getScope();
    if (scope) scope.setExtras(extras);
  }

  /**
   * @inheritDoc
   */
   setTag(key, value) {
    const scope = this.getScope();
    if (scope) scope.setTag(key, value);
  }

  /**
   * @inheritDoc
   */
   setExtra(key, extra) {
    const scope = this.getScope();
    if (scope) scope.setExtra(key, extra);
  }

  /**
   * @inheritDoc
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
   setContext(name, context) {
    const scope = this.getScope();
    if (scope) scope.setContext(name, context);
  }

  /**
   * @inheritDoc
   */
   configureScope(callback) {
    const { scope, client } = this.getStackTop();
    if (scope && client) {
      callback(scope);
    }
  }

  /**
   * @inheritDoc
   */
   run(callback) {
    const oldHub = makeMain(this);
    try {
      callback(this);
    } finally {
      makeMain(oldHub);
    }
  }

  /**
   * @inheritDoc
   */
   getIntegration(integration) {
    const client = this.getClient();
    if (!client) return null;
    try {
      return client.getIntegration(integration);
    } catch (_oO) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && _sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .logger.warn */ .kg.warn(`Cannot retrieve integration ${integration.id} from the current Hub`);
      return null;
    }
  }

  /**
   * @inheritDoc
   */
   startTransaction(context, customSamplingContext) {
    return this._callExtensionMethod('startTransaction', context, customSamplingContext);
  }

  /**
   * @inheritDoc
   */
   traceHeaders() {
    return this._callExtensionMethod('traceHeaders');
  }

  /**
   * @inheritDoc
   */
   captureSession(endSession = false) {
    // both send the update and pull the session from the scope
    if (endSession) {
      return this.endSession();
    }

    // only send the update
    this._sendSessionUpdate();
  }

  /**
   * @inheritDoc
   */
   endSession() {
    const layer = this.getStackTop();
    const scope = layer && layer.scope;
    const session = scope && scope.getSession();
    if (session) {
      (0,_session_js__WEBPACK_IMPORTED_MODULE_4__/* .closeSession */ .RJ)(session);
    }
    this._sendSessionUpdate();

    // the session is over; take it off of the scope
    if (scope) {
      scope.setSession();
    }
  }

  /**
   * @inheritDoc
   */
   startSession(context) {
    const { scope, client } = this.getStackTop();
    const { release, environment } = (client && client.getOptions()) || {};

    // Will fetch userAgent if called from browser sdk
    const { userAgent } = _sentry_utils__WEBPACK_IMPORTED_MODULE_5__/* .GLOBAL_OBJ.navigator */ .n2.navigator || {};

    const session = (0,_session_js__WEBPACK_IMPORTED_MODULE_4__/* .makeSession */ .Hv)({
      release,
      environment,
      ...(scope && { user: scope.getUser() }),
      ...(userAgent && { userAgent }),
      ...context,
    });

    if (scope) {
      // End existing session if there's one
      const currentSession = scope.getSession && scope.getSession();
      if (currentSession && currentSession.status === 'ok') {
        (0,_session_js__WEBPACK_IMPORTED_MODULE_4__/* .updateSession */ .CT)(currentSession, { status: 'exited' });
      }
      this.endSession();

      // Afterwards we set the new session on the scope
      scope.setSession(session);
    }

    return session;
  }

  /**
   * Returns if default PII should be sent to Sentry and propagated in ourgoing requests
   * when Tracing is used.
   */
   shouldSendDefaultPii() {
    const client = this.getClient();
    const options = client && client.getOptions();
    return Boolean(options && options.sendDefaultPii);
  }

  /**
   * Sends the current Session on the scope
   */
   _sendSessionUpdate() {
    const { scope, client } = this.getStackTop();
    if (!scope) return;

    const session = scope.getSession();
    if (session) {
      if (client && client.captureSession) {
        client.captureSession(session);
      }
    }
  }

  /**
   * Internal helper function to call a method on the top client if it exists.
   *
   * @param method The method to call on the client.
   * @param args Arguments to pass to the client function.
   */
   _withClient(callback) {
    const { scope, client } = this.getStackTop();
    if (client) {
      callback(client, scope);
    }
  }

  /**
   * Calls global extension method and binding current instance to the function call
   */
  // @ts-ignore Function lacks ending return statement and return type does not include 'undefined'. ts(2366)
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
   _callExtensionMethod(method, ...args) {
    const carrier = getMainCarrier();
    const sentry = carrier.__SENTRY__;
    if (sentry && sentry.extensions && typeof sentry.extensions[method] === 'function') {
      return sentry.extensions[method].apply(this, args);
    }
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && _sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .logger.warn */ .kg.warn(`Extension method ${method} couldn't be found, doing nothing.`);
  }
}

/**
 * Returns the global shim registry.
 *
 * FIXME: This function is problematic, because despite always returning a valid Carrier,
 * it has an optional `__SENTRY__` property, which then in turn requires us to always perform an unnecessary check
 * at the call-site. We always access the carrier through this function, so we can guarantee that `__SENTRY__` is there.
 **/
function getMainCarrier() {
  _sentry_utils__WEBPACK_IMPORTED_MODULE_5__/* .GLOBAL_OBJ.__SENTRY__ */ .n2.__SENTRY__ = _sentry_utils__WEBPACK_IMPORTED_MODULE_5__/* .GLOBAL_OBJ.__SENTRY__ */ .n2.__SENTRY__ || {
    extensions: {},
    hub: undefined,
  };
  return _sentry_utils__WEBPACK_IMPORTED_MODULE_5__/* .GLOBAL_OBJ */ .n2;
}

/**
 * Replaces the current main hub with the passed one on the global object
 *
 * @returns The old replaced hub
 */
function makeMain(hub) {
  const registry = getMainCarrier();
  const oldHub = getHubFromCarrier(registry);
  setHubOnCarrier(registry, hub);
  return oldHub;
}

/**
 * Returns the default hub instance.
 *
 * If a hub is already registered in the global carrier but this module
 * contains a more recent version, it replaces the registered version.
 * Otherwise, the currently registered hub will be returned.
 */
function getCurrentHub() {
  // Get main carrier (global for every environment)
  const registry = getMainCarrier();

  // If there's no hub, or its an old API, assign a new one
  if (!hasHubOnCarrier(registry) || getHubFromCarrier(registry).isOlderThan(API_VERSION)) {
    setHubOnCarrier(registry, new Hub());
  }

  // Prefer domains over global if they are there (applicable only to Node environment)
  if ((0,_sentry_utils__WEBPACK_IMPORTED_MODULE_6__/* .isNodeEnv */ .KV)()) {
    return getHubFromActiveDomain(registry);
  }
  // Return hub that lives on a global object
  return getHubFromCarrier(registry);
}

/**
 * Try to read the hub from an active domain, and fallback to the registry if one doesn't exist
 * @returns discovered hub
 */
function getHubFromActiveDomain(registry) {
  try {
    const sentry = getMainCarrier().__SENTRY__;
    const activeDomain = sentry && sentry.extensions && sentry.extensions.domain && sentry.extensions.domain.active;

    // If there's no active domain, just return global hub
    if (!activeDomain) {
      return getHubFromCarrier(registry);
    }

    // If there's no hub on current domain, or it's an old API, assign a new one
    if (!hasHubOnCarrier(activeDomain) || getHubFromCarrier(activeDomain).isOlderThan(API_VERSION)) {
      const registryHubTopStack = getHubFromCarrier(registry).getStackTop();
      setHubOnCarrier(activeDomain, new Hub(registryHubTopStack.client, _scope_js__WEBPACK_IMPORTED_MODULE_0__/* .Scope.clone */ .s.clone(registryHubTopStack.scope)));
    }

    // Return hub that lives on a domain
    return getHubFromCarrier(activeDomain);
  } catch (_Oo) {
    // Return hub that lives on a global object
    return getHubFromCarrier(registry);
  }
}

/**
 * This will tell whether a carrier has a hub on it or not
 * @param carrier object
 */
function hasHubOnCarrier(carrier) {
  return !!(carrier && carrier.__SENTRY__ && carrier.__SENTRY__.hub);
}

/**
 * This will create a new {@link Hub} and add to the passed object on
 * __SENTRY__.hub.
 * @param carrier object
 * @hidden
 */
function getHubFromCarrier(carrier) {
  return (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_5__/* .getGlobalSingleton */ .YO)('hub', () => new Hub(), carrier);
}

/**
 * This will set passed {@link Hub} on the passed object's __SENTRY__.hub attribute
 * @param carrier object
 * @param hub Hub
 * @returns A boolean indicating success or failure
 */
function setHubOnCarrier(carrier, hub) {
  if (!carrier) return false;
  const __SENTRY__ = (carrier.__SENTRY__ = carrier.__SENTRY__ || {});
  __SENTRY__.hub = hub;
  return true;
}


//# sourceMappingURL=hub.js.map


/***/ }),

/***/ 12584:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "c": function() { return /* binding */ addGlobalEventProcessor; },
/* harmony export */   "s": function() { return /* binding */ Scope; }
/* harmony export */ });
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(33816);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(27447);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(31647);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(23680);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(3528);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(62000);
/* harmony import */ var _session_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87943);



/**
 * Default value for maximum number of breadcrumbs added to an event.
 */
const DEFAULT_MAX_BREADCRUMBS = 100;

/**
 * Holds additional event information. {@link Scope.applyToEvent} will be
 * called by the client before an event will be sent.
 */
class Scope  {
  /** Flag if notifying is happening. */

  /** Callback for client to receive scope changes. */

  /** Callback list that will be called after {@link applyToEvent}. */

  /** Array of breadcrumbs. */

  /** User */

  /** Tags */

  /** Extra */

  /** Contexts */

  /** Attachments */

  /**
   * A place to stash data which is needed at some point in the SDK's event processing pipeline but which shouldn't get
   * sent to Sentry
   */

  /** Fingerprint */

  /** Severity */
  // eslint-disable-next-line deprecation/deprecation

  /** Transaction Name */

  /** Span */

  /** Session */

  /** Request Mode Session Status */

  // NOTE: Any field which gets added here should get added not only to the constructor but also to the `clone` method.

   constructor() {
    this._notifyingListeners = false;
    this._scopeListeners = [];
    this._eventProcessors = [];
    this._breadcrumbs = [];
    this._attachments = [];
    this._user = {};
    this._tags = {};
    this._extra = {};
    this._contexts = {};
    this._sdkProcessingMetadata = {};
  }

  /**
   * Inherit values from the parent scope.
   * @param scope to clone.
   */
   static clone(scope) {
    const newScope = new Scope();
    if (scope) {
      newScope._breadcrumbs = [...scope._breadcrumbs];
      newScope._tags = { ...scope._tags };
      newScope._extra = { ...scope._extra };
      newScope._contexts = { ...scope._contexts };
      newScope._user = scope._user;
      newScope._level = scope._level;
      newScope._span = scope._span;
      newScope._session = scope._session;
      newScope._transactionName = scope._transactionName;
      newScope._fingerprint = scope._fingerprint;
      newScope._eventProcessors = [...scope._eventProcessors];
      newScope._requestSession = scope._requestSession;
      newScope._attachments = [...scope._attachments];
      newScope._sdkProcessingMetadata = { ...scope._sdkProcessingMetadata };
    }
    return newScope;
  }

  /**
   * Add internal on change listener. Used for sub SDKs that need to store the scope.
   * @hidden
   */
   addScopeListener(callback) {
    this._scopeListeners.push(callback);
  }

  /**
   * @inheritDoc
   */
   addEventProcessor(callback) {
    this._eventProcessors.push(callback);
    return this;
  }

  /**
   * @inheritDoc
   */
   setUser(user) {
    this._user = user || {};
    if (this._session) {
      (0,_session_js__WEBPACK_IMPORTED_MODULE_0__/* .updateSession */ .CT)(this._session, { user });
    }
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   getUser() {
    return this._user;
  }

  /**
   * @inheritDoc
   */
   getRequestSession() {
    return this._requestSession;
  }

  /**
   * @inheritDoc
   */
   setRequestSession(requestSession) {
    this._requestSession = requestSession;
    return this;
  }

  /**
   * @inheritDoc
   */
   setTags(tags) {
    this._tags = {
      ...this._tags,
      ...tags,
    };
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   setTag(key, value) {
    this._tags = { ...this._tags, [key]: value };
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   setExtras(extras) {
    this._extra = {
      ...this._extra,
      ...extras,
    };
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   setExtra(key, extra) {
    this._extra = { ...this._extra, [key]: extra };
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   setFingerprint(fingerprint) {
    this._fingerprint = fingerprint;
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   setLevel(
    // eslint-disable-next-line deprecation/deprecation
    level,
  ) {
    this._level = level;
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   setTransactionName(name) {
    this._transactionName = name;
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   setContext(key, context) {
    if (context === null) {
      // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
      delete this._contexts[key];
    } else {
      this._contexts[key] = context;
    }

    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   setSpan(span) {
    this._span = span;
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   getSpan() {
    return this._span;
  }

  /**
   * @inheritDoc
   */
   getTransaction() {
    // Often, this span (if it exists at all) will be a transaction, but it's not guaranteed to be. Regardless, it will
    // have a pointer to the currently-active transaction.
    const span = this.getSpan();
    return span && span.transaction;
  }

  /**
   * @inheritDoc
   */
   setSession(session) {
    if (!session) {
      delete this._session;
    } else {
      this._session = session;
    }
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   getSession() {
    return this._session;
  }

  /**
   * @inheritDoc
   */
   update(captureContext) {
    if (!captureContext) {
      return this;
    }

    if (typeof captureContext === 'function') {
      const updatedScope = (captureContext )(this);
      return updatedScope instanceof Scope ? updatedScope : this;
    }

    if (captureContext instanceof Scope) {
      this._tags = { ...this._tags, ...captureContext._tags };
      this._extra = { ...this._extra, ...captureContext._extra };
      this._contexts = { ...this._contexts, ...captureContext._contexts };
      if (captureContext._user && Object.keys(captureContext._user).length) {
        this._user = captureContext._user;
      }
      if (captureContext._level) {
        this._level = captureContext._level;
      }
      if (captureContext._fingerprint) {
        this._fingerprint = captureContext._fingerprint;
      }
      if (captureContext._requestSession) {
        this._requestSession = captureContext._requestSession;
      }
    } else if ((0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .isPlainObject */ .PO)(captureContext)) {
      // eslint-disable-next-line no-param-reassign
      captureContext = captureContext ;
      this._tags = { ...this._tags, ...captureContext.tags };
      this._extra = { ...this._extra, ...captureContext.extra };
      this._contexts = { ...this._contexts, ...captureContext.contexts };
      if (captureContext.user) {
        this._user = captureContext.user;
      }
      if (captureContext.level) {
        this._level = captureContext.level;
      }
      if (captureContext.fingerprint) {
        this._fingerprint = captureContext.fingerprint;
      }
      if (captureContext.requestSession) {
        this._requestSession = captureContext.requestSession;
      }
    }

    return this;
  }

  /**
   * @inheritDoc
   */
   clear() {
    this._breadcrumbs = [];
    this._tags = {};
    this._extra = {};
    this._user = {};
    this._contexts = {};
    this._level = undefined;
    this._transactionName = undefined;
    this._fingerprint = undefined;
    this._requestSession = undefined;
    this._span = undefined;
    this._session = undefined;
    this._notifyScopeListeners();
    this._attachments = [];
    return this;
  }

  /**
   * @inheritDoc
   */
   addBreadcrumb(breadcrumb, maxBreadcrumbs) {
    const maxCrumbs = typeof maxBreadcrumbs === 'number' ? maxBreadcrumbs : DEFAULT_MAX_BREADCRUMBS;

    // No data has been changed, so don't notify scope listeners
    if (maxCrumbs <= 0) {
      return this;
    }

    const mergedBreadcrumb = {
      timestamp: (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_2__/* .dateTimestampInSeconds */ .yW)(),
      ...breadcrumb,
    };
    this._breadcrumbs = [...this._breadcrumbs, mergedBreadcrumb].slice(-maxCrumbs);
    this._notifyScopeListeners();

    return this;
  }

  /**
   * @inheritDoc
   */
   getLastBreadcrumb() {
    return this._breadcrumbs[this._breadcrumbs.length - 1];
  }

  /**
   * @inheritDoc
   */
   clearBreadcrumbs() {
    this._breadcrumbs = [];
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   addAttachment(attachment) {
    this._attachments.push(attachment);
    return this;
  }

  /**
   * @inheritDoc
   */
   getAttachments() {
    return this._attachments;
  }

  /**
   * @inheritDoc
   */
   clearAttachments() {
    this._attachments = [];
    return this;
  }

  /**
   * Applies data from the scope to the event and runs all event processors on it.
   *
   * @param event Event
   * @param hint Object containing additional information about the original exception, for use by the event processors.
   * @hidden
   */
   applyToEvent(event, hint = {}) {
    if (this._extra && Object.keys(this._extra).length) {
      event.extra = { ...this._extra, ...event.extra };
    }
    if (this._tags && Object.keys(this._tags).length) {
      event.tags = { ...this._tags, ...event.tags };
    }
    if (this._user && Object.keys(this._user).length) {
      event.user = { ...this._user, ...event.user };
    }
    if (this._contexts && Object.keys(this._contexts).length) {
      event.contexts = { ...this._contexts, ...event.contexts };
    }
    if (this._level) {
      event.level = this._level;
    }
    if (this._transactionName) {
      event.transaction = this._transactionName;
    }

    // We want to set the trace context for normal events only if there isn't already
    // a trace context on the event. There is a product feature in place where we link
    // errors with transaction and it relies on that.
    if (this._span) {
      event.contexts = { trace: this._span.getTraceContext(), ...event.contexts };
      const transactionName = this._span.transaction && this._span.transaction.name;
      if (transactionName) {
        event.tags = { transaction: transactionName, ...event.tags };
      }
    }

    this._applyFingerprint(event);

    event.breadcrumbs = [...(event.breadcrumbs || []), ...this._breadcrumbs];
    event.breadcrumbs = event.breadcrumbs.length > 0 ? event.breadcrumbs : undefined;

    event.sdkProcessingMetadata = { ...event.sdkProcessingMetadata, ...this._sdkProcessingMetadata };

    return this._notifyEventProcessors([...getGlobalEventProcessors(), ...this._eventProcessors], event, hint);
  }

  /**
   * Add data which will be accessible during event processing but won't get sent to Sentry
   */
   setSDKProcessingMetadata(newData) {
    this._sdkProcessingMetadata = { ...this._sdkProcessingMetadata, ...newData };

    return this;
  }

  /**
   * This will be called after {@link applyToEvent} is finished.
   */
   _notifyEventProcessors(
    processors,
    event,
    hint,
    index = 0,
  ) {
    return new _sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .SyncPromise */ .cW((resolve, reject) => {
      const processor = processors[index];
      if (event === null || typeof processor !== 'function') {
        resolve(event);
      } else {
        const result = processor({ ...event }, hint) ;

        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
          processor.id &&
          result === null &&
          _sentry_utils__WEBPACK_IMPORTED_MODULE_4__/* .logger.log */ .kg.log(`Event processor "${processor.id}" dropped event`);

        if ((0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .isThenable */ .J8)(result)) {
          void result
            .then(final => this._notifyEventProcessors(processors, final, hint, index + 1).then(resolve))
            .then(null, reject);
        } else {
          void this._notifyEventProcessors(processors, result, hint, index + 1)
            .then(resolve)
            .then(null, reject);
        }
      }
    });
  }

  /**
   * This will be called on every set call.
   */
   _notifyScopeListeners() {
    // We need this check for this._notifyingListeners to be able to work on scope during updates
    // If this check is not here we'll produce endless recursion when something is done with the scope
    // during the callback.
    if (!this._notifyingListeners) {
      this._notifyingListeners = true;
      this._scopeListeners.forEach(callback => {
        callback(this);
      });
      this._notifyingListeners = false;
    }
  }

  /**
   * Applies fingerprint from the scope to the event if there's one,
   * uses message if there's one instead or get rid of empty fingerprint
   */
   _applyFingerprint(event) {
    // Make sure it's an array first and we actually have something in place
    event.fingerprint = event.fingerprint ? (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_5__/* .arrayify */ .lE)(event.fingerprint) : [];

    // If we have something on the scope, then merge it with event
    if (this._fingerprint) {
      event.fingerprint = event.fingerprint.concat(this._fingerprint);
    }

    // If we have no data at all, remove empty array default
    if (event.fingerprint && !event.fingerprint.length) {
      delete event.fingerprint;
    }
  }
}

/**
 * Returns the global event processors.
 */
function getGlobalEventProcessors() {
  return (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_6__/* .getGlobalSingleton */ .YO)('globalEventProcessors', () => []);
}

/**
 * Add a EventProcessor to be kept globally.
 * @param callback EventProcessor to add
 */
function addGlobalEventProcessor(callback) {
  getGlobalEventProcessors().push(callback);
}


//# sourceMappingURL=scope.js.map


/***/ }),

/***/ 87943:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CT": function() { return /* binding */ updateSession; },
/* harmony export */   "Hv": function() { return /* binding */ makeSession; },
/* harmony export */   "RJ": function() { return /* binding */ closeSession; }
/* harmony export */ });
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27447);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3528);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(71086);


/**
 * Creates a new `Session` object by setting certain default parameters. If optional @param context
 * is passed, the passed properties are applied to the session object.
 *
 * @param context (optional) additional properties to be applied to the returned session object
 *
 * @returns a new `Session` object
 */
function makeSession(context) {
  // Both timestamp and started are in seconds since the UNIX epoch.
  const startingTime = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_0__/* .timestampInSeconds */ .ph)();

  const session = {
    sid: (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .uuid4 */ .DM)(),
    init: true,
    timestamp: startingTime,
    started: startingTime,
    duration: 0,
    status: 'ok',
    errors: 0,
    ignoreDuration: false,
    toJSON: () => sessionToJSON(session),
  };

  if (context) {
    updateSession(session, context);
  }

  return session;
}

/**
 * Updates a session object with the properties passed in the context.
 *
 * Note that this function mutates the passed object and returns void.
 * (Had to do this instead of returning a new and updated session because closing and sending a session
 * makes an update to the session after it was passed to the sending logic.
 * @see BaseClient.captureSession )
 *
 * @param session the `Session` to update
 * @param context the `SessionContext` holding the properties that should be updated in @param session
 */
// eslint-disable-next-line complexity
function updateSession(session, context = {}) {
  if (context.user) {
    if (!session.ipAddress && context.user.ip_address) {
      session.ipAddress = context.user.ip_address;
    }

    if (!session.did && !context.did) {
      session.did = context.user.id || context.user.email || context.user.username;
    }
  }

  session.timestamp = context.timestamp || (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_0__/* .timestampInSeconds */ .ph)();

  if (context.ignoreDuration) {
    session.ignoreDuration = context.ignoreDuration;
  }
  if (context.sid) {
    // Good enough uuid validation. — Kamil
    session.sid = context.sid.length === 32 ? context.sid : (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .uuid4 */ .DM)();
  }
  if (context.init !== undefined) {
    session.init = context.init;
  }
  if (!session.did && context.did) {
    session.did = `${context.did}`;
  }
  if (typeof context.started === 'number') {
    session.started = context.started;
  }
  if (session.ignoreDuration) {
    session.duration = undefined;
  } else if (typeof context.duration === 'number') {
    session.duration = context.duration;
  } else {
    const duration = session.timestamp - session.started;
    session.duration = duration >= 0 ? duration : 0;
  }
  if (context.release) {
    session.release = context.release;
  }
  if (context.environment) {
    session.environment = context.environment;
  }
  if (!session.ipAddress && context.ipAddress) {
    session.ipAddress = context.ipAddress;
  }
  if (!session.userAgent && context.userAgent) {
    session.userAgent = context.userAgent;
  }
  if (typeof context.errors === 'number') {
    session.errors = context.errors;
  }
  if (context.status) {
    session.status = context.status;
  }
}

/**
 * Closes a session by setting its status and updating the session object with it.
 * Internally calls `updateSession` to update the passed session object.
 *
 * Note that this function mutates the passed session (@see updateSession for explanation).
 *
 * @param session the `Session` object to be closed
 * @param status the `SessionStatus` with which the session was closed. If you don't pass a status,
 *               this function will keep the previously set status, unless it was `'ok'` in which case
 *               it is changed to `'exited'`.
 */
function closeSession(session, status) {
  let context = {};
  if (status) {
    context = { status };
  } else if (session.status === 'ok') {
    context = { status: 'exited' };
  }

  updateSession(session, context);
}

/**
 * Serializes a passed session object to a JSON object with a slightly different structure.
 * This is necessary because the Sentry backend requires a slightly different schema of a session
 * than the one the JS SDKs use internally.
 *
 * @param session the session to be converted
 *
 * @returns a JSON object of the passed session
 */
function sessionToJSON(session) {
  return (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_2__/* .dropUndefinedKeys */ .Jr)({
    sid: `${session.sid}`,
    init: session.init,
    // Make sure that sec is converted to ms for date constructor
    started: new Date(session.started * 1000).toISOString(),
    timestamp: new Date(session.timestamp * 1000).toISOString(),
    status: session.status,
    errors: session.errors,
    did: typeof session.did === 'number' || typeof session.did === 'string' ? `${session.did}` : undefined,
    duration: session.duration,
    attrs: {
      release: session.release,
      environment: session.environment,
      ip_address: session.ipAddress,
      user_agent: session.userAgent,
    },
  });
}


//# sourceMappingURL=session.js.map


/***/ }),

/***/ 43157:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ro": function() { return /* binding */ addExtensionMethods; },
  "lb": function() { return /* binding */ startIdleTransaction; }
});

// UNUSED EXPORTS: _addTracingExtensions

// EXTERNAL MODULE: ../../.yarn/cache/@sentry-core-npm-7.32.1-f8255c7634-74ce787414.zip/node_modules/@sentry/core/esm/hub.js
var hub = __webpack_require__(90936);
// EXTERNAL MODULE: ../../.yarn/cache/@sentry-utils-npm-7.32.1-c99d3811fa-1b0d82cbcc.zip/node_modules/@sentry/utils/esm/logger.js
var logger = __webpack_require__(23680);
// EXTERNAL MODULE: ../../.yarn/cache/@sentry-utils-npm-7.32.1-c99d3811fa-1b0d82cbcc.zip/node_modules/@sentry/utils/esm/is.js
var is = __webpack_require__(33816);
// EXTERNAL MODULE: ../../.yarn/cache/@sentry-utils-npm-7.32.1-c99d3811fa-1b0d82cbcc.zip/node_modules/@sentry/utils/esm/node.js + 1 modules
var node = __webpack_require__(70302);
// EXTERNAL MODULE: ../../.yarn/cache/@sentry-utils-npm-7.32.1-c99d3811fa-1b0d82cbcc.zip/node_modules/@sentry/utils/esm/instrument.js
var instrument = __webpack_require__(49398);
// EXTERNAL MODULE: ../../.yarn/cache/@sentry-tracing-npm-7.32.1-60cc6371d2-b62b9cc4d4.zip/node_modules/@sentry/tracing/esm/utils.js
var utils = __webpack_require__(25808);
;// CONCATENATED MODULE: ../../.yarn/cache/@sentry-tracing-npm-7.32.1-60cc6371d2-b62b9cc4d4.zip/node_modules/@sentry/tracing/esm/errors.js



/**
 * Configures global error listeners
 */
function registerErrorInstrumentation() {
  (0,instrument/* addInstrumentationHandler */.o)('error', errorCallback);
  (0,instrument/* addInstrumentationHandler */.o)('unhandledrejection', errorCallback);
}

/**
 * If an error or unhandled promise occurs, we mark the active transaction as failed
 */
function errorCallback() {
  const activeTransaction = (0,utils/* getActiveTransaction */.x1)();
  if (activeTransaction) {
    const status = 'internal_error';
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.log */.kg.log(`[Tracing] Transaction: ${status} -> Global error occured`);
    activeTransaction.setStatus(status);
  }
}


//# sourceMappingURL=errors.js.map

// EXTERNAL MODULE: ../../.yarn/cache/@sentry-tracing-npm-7.32.1-60cc6371d2-b62b9cc4d4.zip/node_modules/@sentry/tracing/esm/idletransaction.js
var idletransaction = __webpack_require__(23511);
// EXTERNAL MODULE: ../../.yarn/cache/@sentry-tracing-npm-7.32.1-60cc6371d2-b62b9cc4d4.zip/node_modules/@sentry/tracing/esm/transaction.js
var esm_transaction = __webpack_require__(87328);
;// CONCATENATED MODULE: ../../.yarn/cache/@sentry-tracing-npm-7.32.1-60cc6371d2-b62b9cc4d4.zip/node_modules/@sentry/tracing/esm/hubextensions.js
/* module decorator */ module = __webpack_require__.hmd(module);







/** Returns all trace headers that are currently on the top scope. */
function traceHeaders() {
  const scope = this.getScope();
  if (scope) {
    const span = scope.getSpan();
    if (span) {
      return {
        'sentry-trace': span.toTraceparent(),
      };
    }
  }
  return {};
}

/**
 * Makes a sampling decision for the given transaction and stores it on the transaction.
 *
 * Called every time a transaction is created. Only transactions which emerge with a `sampled` value of `true` will be
 * sent to Sentry.
 *
 * @param transaction: The transaction needing a sampling decision
 * @param options: The current client's options, so we can access `tracesSampleRate` and/or `tracesSampler`
 * @param samplingContext: Default and user-provided data which may be used to help make the decision
 *
 * @returns The given transaction with its `sampled` value set
 */
function sample(
  transaction,
  options,
  samplingContext,
) {
  // nothing to do if tracing is not enabled
  if (!(0,utils/* hasTracingEnabled */.zu)(options)) {
    transaction.sampled = false;
    return transaction;
  }

  // if the user has forced a sampling decision by passing a `sampled` value in their transaction context, go with that
  if (transaction.sampled !== undefined) {
    transaction.setMetadata({
      sampleRate: Number(transaction.sampled),
    });
    return transaction;
  }

  // we would have bailed already if neither `tracesSampler` nor `tracesSampleRate` were defined, so one of these should
  // work; prefer the hook if so
  let sampleRate;
  if (typeof options.tracesSampler === 'function') {
    sampleRate = options.tracesSampler(samplingContext);
    transaction.setMetadata({
      sampleRate: Number(sampleRate),
    });
  } else if (samplingContext.parentSampled !== undefined) {
    sampleRate = samplingContext.parentSampled;
  } else {
    sampleRate = options.tracesSampleRate;
    transaction.setMetadata({
      sampleRate: Number(sampleRate),
    });
  }

  // Since this is coming from the user (or from a function provided by the user), who knows what we might get. (The
  // only valid values are booleans or numbers between 0 and 1.)
  if (!isValidSampleRate(sampleRate)) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.warn */.kg.warn('[Tracing] Discarding transaction because of invalid sample rate.');
    transaction.sampled = false;
    return transaction;
  }

  // if the function returned 0 (or false), or if `tracesSampleRate` is 0, it's a sign the transaction should be dropped
  if (!sampleRate) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
      logger/* logger.log */.kg.log(
        `[Tracing] Discarding transaction because ${
          typeof options.tracesSampler === 'function'
            ? 'tracesSampler returned 0 or false'
            : 'a negative sampling decision was inherited or tracesSampleRate is set to 0'
        }`,
      );
    transaction.sampled = false;
    return transaction;
  }

  // Now we roll the dice. Math.random is inclusive of 0, but not of 1, so strict < is safe here. In case sampleRate is
  // a boolean, the < comparison will cause it to be automatically cast to 1 if it's true and 0 if it's false.
  transaction.sampled = Math.random() < (sampleRate );

  // if we're not going to keep it, we're done
  if (!transaction.sampled) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
      logger/* logger.log */.kg.log(
        `[Tracing] Discarding transaction because it's not included in the random sample (sampling rate = ${Number(
          sampleRate,
        )})`,
      );
    return transaction;
  }

  (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.log */.kg.log(`[Tracing] starting ${transaction.op} transaction - ${transaction.name}`);
  return transaction;
}

/**
 * Checks the given sample rate to make sure it is valid type and value (a boolean, or a number between 0 and 1).
 */
function isValidSampleRate(rate) {
  // we need to check NaN explicitly because it's of type 'number' and therefore wouldn't get caught by this typecheck
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  if ((0,is/* isNaN */.i2)(rate) || !(typeof rate === 'number' || typeof rate === 'boolean')) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
      logger/* logger.warn */.kg.warn(
        `[Tracing] Given sample rate is invalid. Sample rate must be a boolean or a number between 0 and 1. Got ${JSON.stringify(
          rate,
        )} of type ${JSON.stringify(typeof rate)}.`,
      );
    return false;
  }

  // in case sampleRate is a boolean, it will get automatically cast to 1 if it's true and 0 if it's false
  if (rate < 0 || rate > 1) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
      logger/* logger.warn */.kg.warn(`[Tracing] Given sample rate is invalid. Sample rate must be between 0 and 1. Got ${rate}.`);
    return false;
  }
  return true;
}

/**
 * Creates a new transaction and adds a sampling decision if it doesn't yet have one.
 *
 * The Hub.startTransaction method delegates to this method to do its work, passing the Hub instance in as `this`, as if
 * it had been called on the hub directly. Exists as a separate function so that it can be injected into the class as an
 * "extension method."
 *
 * @param this: The Hub starting the transaction
 * @param transactionContext: Data used to configure the transaction
 * @param CustomSamplingContext: Optional data to be provided to the `tracesSampler` function (if any)
 *
 * @returns The new transaction
 *
 * @see {@link Hub.startTransaction}
 */
function _startTransaction(

  transactionContext,
  customSamplingContext,
) {
  const client = this.getClient();
  const options = (client && client.getOptions()) || {};

  const configInstrumenter = options.instrumenter || 'sentry';
  const transactionInstrumenter = transactionContext.instrumenter || 'sentry';

  if (configInstrumenter !== transactionInstrumenter) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
      logger/* logger.error */.kg.error(
        `A transaction was started with instrumenter=\`${transactionInstrumenter}\`, but the SDK is configured with the \`${configInstrumenter}\` instrumenter.
The transaction will not be sampled. Please use the ${configInstrumenter} instrumentation to start transactions.`,
      );

    transactionContext.sampled = false;
  }

  let transaction = new esm_transaction/* Transaction */.Y(transactionContext, this);
  transaction = sample(transaction, options, {
    parentSampled: transactionContext.parentSampled,
    transactionContext,
    ...customSamplingContext,
  });
  if (transaction.sampled) {
    transaction.initSpanRecorder(options._experiments && (options._experiments.maxSpans ));
  }
  return transaction;
}

/**
 * Create new idle transaction.
 */
function startIdleTransaction(
  hub,
  transactionContext,
  idleTimeout,
  finalTimeout,
  onScope,
  customSamplingContext,
  heartbeatInterval,
) {
  const client = hub.getClient();
  const options = (client && client.getOptions()) || {};

  let transaction = new idletransaction/* IdleTransaction */.io(transactionContext, hub, idleTimeout, finalTimeout, heartbeatInterval, onScope);
  transaction = sample(transaction, options, {
    parentSampled: transactionContext.parentSampled,
    transactionContext,
    ...customSamplingContext,
  });
  if (transaction.sampled) {
    transaction.initSpanRecorder(options._experiments && (options._experiments.maxSpans ));
  }
  return transaction;
}

/**
 * @private
 */
function _addTracingExtensions() {
  const carrier = (0,hub/* getMainCarrier */.cu)();
  if (!carrier.__SENTRY__) {
    return;
  }
  carrier.__SENTRY__.extensions = carrier.__SENTRY__.extensions || {};
  if (!carrier.__SENTRY__.extensions.startTransaction) {
    carrier.__SENTRY__.extensions.startTransaction = _startTransaction;
  }
  if (!carrier.__SENTRY__.extensions.traceHeaders) {
    carrier.__SENTRY__.extensions.traceHeaders = traceHeaders;
  }
}

/**
 * @private
 */
function _autoloadDatabaseIntegrations() {
  const carrier = (0,hub/* getMainCarrier */.cu)();
  if (!carrier.__SENTRY__) {
    return;
  }

  const packageToIntegrationMapping = {
    mongodb() {
      const integration = (0,node/* dynamicRequire */.l$)(module, './integrations/node/mongo')

;
      return new integration.Mongo();
    },
    mongoose() {
      const integration = (0,node/* dynamicRequire */.l$)(module, './integrations/node/mongo')

;
      return new integration.Mongo({ mongoose: true });
    },
    mysql() {
      const integration = (0,node/* dynamicRequire */.l$)(module, './integrations/node/mysql')

;
      return new integration.Mysql();
    },
    pg() {
      const integration = (0,node/* dynamicRequire */.l$)(module, './integrations/node/postgres')

;
      return new integration.Postgres();
    },
  };

  const mappedPackages = Object.keys(packageToIntegrationMapping)
    .filter(moduleName => !!(0,node/* loadModule */.$y)(moduleName))
    .map(pkg => {
      try {
        return packageToIntegrationMapping[pkg]();
      } catch (e) {
        return undefined;
      }
    })
    .filter(p => p) ;

  if (mappedPackages.length > 0) {
    carrier.__SENTRY__.integrations = [...(carrier.__SENTRY__.integrations || []), ...mappedPackages];
  }
}

/**
 * This patches the global object and injects the Tracing extensions methods
 */
function addExtensionMethods() {
  _addTracingExtensions();

  // Detect and automatically load specified integrations.
  if ((0,node/* isNodeEnv */.KV)()) {
    _autoloadDatabaseIntegrations();
  }

  // If an error happens globally, we should make sure transaction status is set to error.
  registerErrorInstrumentation();
}


//# sourceMappingURL=hubextensions.js.map


/***/ }),

/***/ 23511:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "hd": function() { return /* binding */ DEFAULT_HEARTBEAT_INTERVAL; },
/* harmony export */   "io": function() { return /* binding */ IdleTransaction; },
/* harmony export */   "mg": function() { return /* binding */ DEFAULT_FINAL_TIMEOUT; },
/* harmony export */   "nT": function() { return /* binding */ DEFAULT_IDLE_TIMEOUT; }
/* harmony export */ });
/* unused harmony export IdleTransactionSpanRecorder */
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27447);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(23680);
/* harmony import */ var _span_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(48372);
/* harmony import */ var _transaction_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87328);




const DEFAULT_IDLE_TIMEOUT = 1000;
const DEFAULT_FINAL_TIMEOUT = 30000;
const DEFAULT_HEARTBEAT_INTERVAL = 5000;

/**
 * @inheritDoc
 */
class IdleTransactionSpanRecorder extends _span_js__WEBPACK_IMPORTED_MODULE_0__/* .SpanRecorder */ .gB {
   constructor(
      _pushActivity,
      _popActivity,
     transactionSpanId,
    maxlen,
  ) {
    super(maxlen);this._pushActivity = _pushActivity;this._popActivity = _popActivity;this.transactionSpanId = transactionSpanId;  }

  /**
   * @inheritDoc
   */
   add(span) {
    // We should make sure we do not push and pop activities for
    // the transaction that this span recorder belongs to.
    if (span.spanId !== this.transactionSpanId) {
      // We patch span.finish() to pop an activity after setting an endTimestamp.
      span.finish = (endTimestamp) => {
        span.endTimestamp = typeof endTimestamp === 'number' ? endTimestamp : (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .timestampWithMs */ ._I)();
        this._popActivity(span.spanId);
      };

      // We should only push new activities if the span does not have an end timestamp.
      if (span.endTimestamp === undefined) {
        this._pushActivity(span.spanId);
      }
    }

    super.add(span);
  }
}

/**
 * An IdleTransaction is a transaction that automatically finishes. It does this by tracking child spans as activities.
 * You can have multiple IdleTransactions active, but if the `onScope` option is specified, the idle transaction will
 * put itself on the scope on creation.
 */
class IdleTransaction extends _transaction_js__WEBPACK_IMPORTED_MODULE_2__/* .Transaction */ .Y {
  // Activities store a list of active spans
   __init() {this.activities = {};}

  // Track state of activities in previous heartbeat

  // Amount of times heartbeat has counted. Will cause transaction to finish after 3 beats.
   __init2() {this._heartbeatCounter = 0;}

  // We should not use heartbeat if we finished a transaction
   __init3() {this._finished = false;}

    __init4() {this._beforeFinishCallbacks = [];}

  /**
   * Timer that tracks Transaction idleTimeout
   */

   constructor(
    transactionContext,
      _idleHub,
    /**
     * The time to wait in ms until the idle transaction will be finished. This timer is started each time
     * there are no active spans on this transaction.
     */
      _idleTimeout = DEFAULT_IDLE_TIMEOUT,
    /**
     * The final value in ms that a transaction cannot exceed
     */
      _finalTimeout = DEFAULT_FINAL_TIMEOUT,
      _heartbeatInterval = DEFAULT_HEARTBEAT_INTERVAL,
    // Whether or not the transaction should put itself on the scope when it starts and pop itself off when it ends
      _onScope = false,
  ) {
    super(transactionContext, _idleHub);this._idleHub = _idleHub;this._idleTimeout = _idleTimeout;this._finalTimeout = _finalTimeout;this._heartbeatInterval = _heartbeatInterval;this._onScope = _onScope;IdleTransaction.prototype.__init.call(this);IdleTransaction.prototype.__init2.call(this);IdleTransaction.prototype.__init3.call(this);IdleTransaction.prototype.__init4.call(this);
    if (_onScope) {
      // There should only be one active transaction on the scope
      clearActiveTransaction(_idleHub);

      // We set the transaction here on the scope so error events pick up the trace
      // context and attach it to the error.
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && _sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .logger.log */ .kg.log(`Setting idle transaction on scope. Span ID: ${this.spanId}`);
      _idleHub.configureScope(scope => scope.setSpan(this));
    }

    this._startIdleTimeout();
    setTimeout(() => {
      if (!this._finished) {
        this.setStatus('deadline_exceeded');
        this.finish();
      }
    }, this._finalTimeout);
  }

  /** {@inheritDoc} */
   finish(endTimestamp = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .timestampWithMs */ ._I)()) {
    this._finished = true;
    this.activities = {};

    if (this.spanRecorder) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
        _sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .logger.log */ .kg.log('[Tracing] finishing IdleTransaction', new Date(endTimestamp * 1000).toISOString(), this.op);

      for (const callback of this._beforeFinishCallbacks) {
        callback(this, endTimestamp);
      }

      this.spanRecorder.spans = this.spanRecorder.spans.filter((span) => {
        // If we are dealing with the transaction itself, we just return it
        if (span.spanId === this.spanId) {
          return true;
        }

        // We cancel all pending spans with status "cancelled" to indicate the idle transaction was finished early
        if (!span.endTimestamp) {
          span.endTimestamp = endTimestamp;
          span.setStatus('cancelled');
          (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
            _sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .logger.log */ .kg.log('[Tracing] cancelling span since transaction ended early', JSON.stringify(span, undefined, 2));
        }

        const keepSpan = span.startTimestamp < endTimestamp;
        if (!keepSpan) {
          (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
            _sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .logger.log */ .kg.log(
              '[Tracing] discarding Span since it happened after Transaction was finished',
              JSON.stringify(span, undefined, 2),
            );
        }
        return keepSpan;
      });

      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && _sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .logger.log */ .kg.log('[Tracing] flushing IdleTransaction');
    } else {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && _sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .logger.log */ .kg.log('[Tracing] No active IdleTransaction');
    }

    // if `this._onScope` is `true`, the transaction put itself on the scope when it started
    if (this._onScope) {
      clearActiveTransaction(this._idleHub);
    }

    return super.finish(endTimestamp);
  }

  /**
   * Register a callback function that gets excecuted before the transaction finishes.
   * Useful for cleanup or if you want to add any additional spans based on current context.
   *
   * This is exposed because users have no other way of running something before an idle transaction
   * finishes.
   */
   registerBeforeFinishCallback(callback) {
    this._beforeFinishCallbacks.push(callback);
  }

  /**
   * @inheritDoc
   */
   initSpanRecorder(maxlen) {
    if (!this.spanRecorder) {
      const pushActivity = (id) => {
        if (this._finished) {
          return;
        }
        this._pushActivity(id);
      };
      const popActivity = (id) => {
        if (this._finished) {
          return;
        }
        this._popActivity(id);
      };

      this.spanRecorder = new IdleTransactionSpanRecorder(pushActivity, popActivity, this.spanId, maxlen);

      // Start heartbeat so that transactions do not run forever.
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && _sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .logger.log */ .kg.log('Starting heartbeat');
      this._pingHeartbeat();
    }
    this.spanRecorder.add(this);
  }

  /**
   * Cancels the existing idletimeout, if there is one
   */
   _cancelIdleTimeout() {
    if (this._idleTimeoutID) {
      clearTimeout(this._idleTimeoutID);
      this._idleTimeoutID = undefined;
    }
  }

  /**
   * Creates an idletimeout
   */
   _startIdleTimeout(endTimestamp) {
    this._cancelIdleTimeout();
    this._idleTimeoutID = setTimeout(() => {
      if (!this._finished && Object.keys(this.activities).length === 0) {
        this.finish(endTimestamp);
      }
    }, this._idleTimeout);
  }

  /**
   * Start tracking a specific activity.
   * @param spanId The span id that represents the activity
   */
   _pushActivity(spanId) {
    this._cancelIdleTimeout();
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && _sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .logger.log */ .kg.log(`[Tracing] pushActivity: ${spanId}`);
    this.activities[spanId] = true;
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && _sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .logger.log */ .kg.log('[Tracing] new activities count', Object.keys(this.activities).length);
  }

  /**
   * Remove an activity from usage
   * @param spanId The span id that represents the activity
   */
   _popActivity(spanId) {
    if (this.activities[spanId]) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && _sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .logger.log */ .kg.log(`[Tracing] popActivity ${spanId}`);
      // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
      delete this.activities[spanId];
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && _sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .logger.log */ .kg.log('[Tracing] new activities count', Object.keys(this.activities).length);
    }

    if (Object.keys(this.activities).length === 0) {
      // We need to add the timeout here to have the real endtimestamp of the transaction
      // Remember timestampWithMs is in seconds, timeout is in ms
      const endTimestamp = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .timestampWithMs */ ._I)() + this._idleTimeout / 1000;
      this._startIdleTimeout(endTimestamp);
    }
  }

  /**
   * Checks when entries of this.activities are not changing for 3 beats.
   * If this occurs we finish the transaction.
   */
   _beat() {
    // We should not be running heartbeat if the idle transaction is finished.
    if (this._finished) {
      return;
    }

    const heartbeatString = Object.keys(this.activities).join('');

    if (heartbeatString === this._prevHeartbeatString) {
      this._heartbeatCounter++;
    } else {
      this._heartbeatCounter = 1;
    }

    this._prevHeartbeatString = heartbeatString;

    if (this._heartbeatCounter >= 3) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && _sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .logger.log */ .kg.log('[Tracing] Transaction finished because of no change for 3 heart beats');
      this.setStatus('deadline_exceeded');
      this.finish();
    } else {
      this._pingHeartbeat();
    }
  }

  /**
   * Pings the heartbeat
   */
   _pingHeartbeat() {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && _sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .logger.log */ .kg.log(`pinging Heartbeat -> current counter: ${this._heartbeatCounter}`);
    setTimeout(() => {
      this._beat();
    }, this._heartbeatInterval);
  }
}

/**
 * Reset transaction on scope to `undefined`
 */
function clearActiveTransaction(hub) {
  const scope = hub.getScope();
  if (scope) {
    const transaction = scope.getTransaction();
    if (transaction) {
      scope.setSpan(undefined);
    }
  }
}


//# sourceMappingURL=idletransaction.js.map


/***/ }),

/***/ 48372:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Dr": function() { return /* binding */ Span; },
/* harmony export */   "gB": function() { return /* binding */ SpanRecorder; }
/* harmony export */ });
/* unused harmony export spanStatusfromHttpCode */
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3528);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27447);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(23680);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(71086);


/**
 * Keeps track of finished spans for a given transaction
 * @internal
 * @hideconstructor
 * @hidden
 */
class SpanRecorder {
   __init() {this.spans = [];}

   constructor(maxlen = 1000) {SpanRecorder.prototype.__init.call(this);
    this._maxlen = maxlen;
  }

  /**
   * This is just so that we don't run out of memory while recording a lot
   * of spans. At some point we just stop and flush out the start of the
   * trace tree (i.e.the first n spans with the smallest
   * start_timestamp).
   */
   add(span) {
    if (this.spans.length > this._maxlen) {
      span.spanRecorder = undefined;
    } else {
      this.spans.push(span);
    }
  }
}

/**
 * Span contains all data about a span
 */
class Span  {
  /**
   * @inheritDoc
   */
   __init2() {this.traceId = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_0__/* .uuid4 */ .DM)();}

  /**
   * @inheritDoc
   */
   __init3() {this.spanId = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_0__/* .uuid4 */ .DM)().substring(16);}

  /**
   * @inheritDoc
   */

  /**
   * Internal keeper of the status
   */

  /**
   * @inheritDoc
   */

  /**
   * Timestamp in seconds when the span was created.
   */
   __init4() {this.startTimestamp = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .timestampWithMs */ ._I)();}

  /**
   * Timestamp in seconds when the span ended.
   */

  /**
   * @inheritDoc
   */

  /**
   * @inheritDoc
   */

  /**
   * @inheritDoc
   */
   __init5() {this.tags = {};}

  /**
   * @inheritDoc
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
   __init6() {this.data = {};}

  /**
   * List of spans that were finalized
   */

  /**
   * @inheritDoc
   */

  /**
   * The instrumenter that created this span.
   */
   __init7() {this.instrumenter = 'sentry';}

  /**
   * You should never call the constructor manually, always use `Sentry.startTransaction()`
   * or call `startChild()` on an existing span.
   * @internal
   * @hideconstructor
   * @hidden
   */
   constructor(spanContext) {Span.prototype.__init2.call(this);Span.prototype.__init3.call(this);Span.prototype.__init4.call(this);Span.prototype.__init5.call(this);Span.prototype.__init6.call(this);Span.prototype.__init7.call(this);
    if (!spanContext) {
      return this;
    }
    if (spanContext.traceId) {
      this.traceId = spanContext.traceId;
    }
    if (spanContext.spanId) {
      this.spanId = spanContext.spanId;
    }
    if (spanContext.parentSpanId) {
      this.parentSpanId = spanContext.parentSpanId;
    }
    // We want to include booleans as well here
    if ('sampled' in spanContext) {
      this.sampled = spanContext.sampled;
    }
    if (spanContext.op) {
      this.op = spanContext.op;
    }
    if (spanContext.description) {
      this.description = spanContext.description;
    }
    if (spanContext.data) {
      this.data = spanContext.data;
    }
    if (spanContext.tags) {
      this.tags = spanContext.tags;
    }
    if (spanContext.status) {
      this.status = spanContext.status;
    }
    if (spanContext.startTimestamp) {
      this.startTimestamp = spanContext.startTimestamp;
    }
    if (spanContext.endTimestamp) {
      this.endTimestamp = spanContext.endTimestamp;
    }
    if (spanContext.instrumenter) {
      this.instrumenter = spanContext.instrumenter;
    }
  }

  /**
   * @inheritDoc
   */
   startChild(
    spanContext,
  ) {
    const childSpan = new Span({
      ...spanContext,
      parentSpanId: this.spanId,
      sampled: this.sampled,
      traceId: this.traceId,
    });

    childSpan.spanRecorder = this.spanRecorder;
    if (childSpan.spanRecorder) {
      childSpan.spanRecorder.add(childSpan);
    }

    childSpan.transaction = this.transaction;

    if ((typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && childSpan.transaction) {
      const opStr = (spanContext && spanContext.op) || '< unknown op >';
      const nameStr = childSpan.transaction.name || '< unknown name >';
      const idStr = childSpan.transaction.spanId;

      const logMessage = `[Tracing] Starting '${opStr}' span on transaction '${nameStr}' (${idStr}).`;
      childSpan.transaction.metadata.spanMetadata[childSpan.spanId] = { logMessage };
      _sentry_utils__WEBPACK_IMPORTED_MODULE_2__/* .logger.log */ .kg.log(logMessage);
    }

    return childSpan;
  }

  /**
   * @inheritDoc
   */
   setTag(key, value) {
    this.tags = { ...this.tags, [key]: value };
    return this;
  }

  /**
   * @inheritDoc
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
   setData(key, value) {
    this.data = { ...this.data, [key]: value };
    return this;
  }

  /**
   * @inheritDoc
   */
   setStatus(value) {
    this.status = value;
    return this;
  }

  /**
   * @inheritDoc
   */
   setHttpStatus(httpStatus) {
    this.setTag('http.status_code', String(httpStatus));
    const spanStatus = spanStatusfromHttpCode(httpStatus);
    if (spanStatus !== 'unknown_error') {
      this.setStatus(spanStatus);
    }
    return this;
  }

  /**
   * @inheritDoc
   */
   isSuccess() {
    return this.status === 'ok';
  }

  /**
   * @inheritDoc
   */
   finish(endTimestamp) {
    if (
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
      // Don't call this for transactions
      this.transaction &&
      this.transaction.spanId !== this.spanId
    ) {
      const { logMessage } = this.transaction.metadata.spanMetadata[this.spanId];
      if (logMessage) {
        _sentry_utils__WEBPACK_IMPORTED_MODULE_2__/* .logger.log */ .kg.log((logMessage ).replace('Starting', 'Finishing'));
      }
    }

    this.endTimestamp = typeof endTimestamp === 'number' ? endTimestamp : (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .timestampWithMs */ ._I)();
  }

  /**
   * @inheritDoc
   */
   toTraceparent() {
    let sampledString = '';
    if (this.sampled !== undefined) {
      sampledString = this.sampled ? '-1' : '-0';
    }
    return `${this.traceId}-${this.spanId}${sampledString}`;
  }

  /**
   * @inheritDoc
   */
   toContext() {
    return (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .dropUndefinedKeys */ .Jr)({
      data: this.data,
      description: this.description,
      endTimestamp: this.endTimestamp,
      op: this.op,
      parentSpanId: this.parentSpanId,
      sampled: this.sampled,
      spanId: this.spanId,
      startTimestamp: this.startTimestamp,
      status: this.status,
      tags: this.tags,
      traceId: this.traceId,
    });
  }

  /**
   * @inheritDoc
   */
   updateWithContext(spanContext) {
    this.data = spanContext.data || {};
    this.description = spanContext.description;
    this.endTimestamp = spanContext.endTimestamp;
    this.op = spanContext.op;
    this.parentSpanId = spanContext.parentSpanId;
    this.sampled = spanContext.sampled;
    this.spanId = spanContext.spanId || this.spanId;
    this.startTimestamp = spanContext.startTimestamp || this.startTimestamp;
    this.status = spanContext.status;
    this.tags = spanContext.tags || {};
    this.traceId = spanContext.traceId || this.traceId;

    return this;
  }

  /**
   * @inheritDoc
   */
   getTraceContext() {
    return (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .dropUndefinedKeys */ .Jr)({
      data: Object.keys(this.data).length > 0 ? this.data : undefined,
      description: this.description,
      op: this.op,
      parent_span_id: this.parentSpanId,
      span_id: this.spanId,
      status: this.status,
      tags: Object.keys(this.tags).length > 0 ? this.tags : undefined,
      trace_id: this.traceId,
    });
  }

  /**
   * @inheritDoc
   */
   toJSON()

 {
    return (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .dropUndefinedKeys */ .Jr)({
      data: Object.keys(this.data).length > 0 ? this.data : undefined,
      description: this.description,
      op: this.op,
      parent_span_id: this.parentSpanId,
      span_id: this.spanId,
      start_timestamp: this.startTimestamp,
      status: this.status,
      tags: Object.keys(this.tags).length > 0 ? this.tags : undefined,
      timestamp: this.endTimestamp,
      trace_id: this.traceId,
    });
  }
}

/**
 * Converts a HTTP status code into a {@link SpanStatusType}.
 *
 * @param httpStatus The HTTP response status code.
 * @returns The span status or unknown_error.
 */
function spanStatusfromHttpCode(httpStatus) {
  if (httpStatus < 400 && httpStatus >= 100) {
    return 'ok';
  }

  if (httpStatus >= 400 && httpStatus < 500) {
    switch (httpStatus) {
      case 401:
        return 'unauthenticated';
      case 403:
        return 'permission_denied';
      case 404:
        return 'not_found';
      case 409:
        return 'already_exists';
      case 413:
        return 'failed_precondition';
      case 429:
        return 'resource_exhausted';
      default:
        return 'invalid_argument';
    }
  }

  if (httpStatus >= 500 && httpStatus < 600) {
    switch (httpStatus) {
      case 501:
        return 'unimplemented';
      case 503:
        return 'unavailable';
      case 504:
        return 'deadline_exceeded';
      default:
        return 'internal_error';
    }
  }

  return 'unknown_error';
}


//# sourceMappingURL=span.js.map


/***/ }),

/***/ 87328:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Y": function() { return /* binding */ Transaction; }
/* harmony export */ });
/* harmony import */ var _sentry_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(90936);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(27447);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(23680);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(71086);
/* harmony import */ var _span_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(48372);




/** JSDoc */
class Transaction extends _span_js__WEBPACK_IMPORTED_MODULE_0__/* .Span */ .Dr  {

  /**
   * The reference to the current hub.
   */

   __init() {this._measurements = {};}

   __init2() {this._contexts = {};}

   __init3() {this._frozenDynamicSamplingContext = undefined;}

  /**
   * This constructor should never be called manually. Those instrumenting tracing should use
   * `Sentry.startTransaction()`, and internal methods should use `hub.startTransaction()`.
   * @internal
   * @hideconstructor
   * @hidden
   */
   constructor(transactionContext, hub) {
    super(transactionContext);Transaction.prototype.__init.call(this);Transaction.prototype.__init2.call(this);Transaction.prototype.__init3.call(this);
    this._hub = hub || (0,_sentry_core__WEBPACK_IMPORTED_MODULE_1__/* .getCurrentHub */ .Gd)();

    this._name = transactionContext.name || '';

    this.metadata = {
      source: 'custom',
      ...transactionContext.metadata,
      spanMetadata: {},
      changes: [],
      propagations: 0,
    };

    this._trimEnd = transactionContext.trimEnd;

    // this is because transactions are also spans, and spans have a transaction pointer
    this.transaction = this;

    // If Dynamic Sampling Context is provided during the creation of the transaction, we freeze it as it usually means
    // there is incoming Dynamic Sampling Context. (Either through an incoming request, a baggage meta-tag, or other means)
    const incomingDynamicSamplingContext = this.metadata.dynamicSamplingContext;
    if (incomingDynamicSamplingContext) {
      // We shallow copy this in case anything writes to the original reference of the passed in `dynamicSamplingContext`
      this._frozenDynamicSamplingContext = { ...incomingDynamicSamplingContext };
    }
  }

  /** Getter for `name` property */
   get name() {
    return this._name;
  }

  /** Setter for `name` property, which also sets `source` as custom */
   set name(newName) {
    this.setName(newName);
  }

  /**
   * JSDoc
   */
   setName(name, source = 'custom') {
    // `source` could change without the name changing if we discover that an unparameterized route is actually
    // parameterized by virtue of having no parameters in its path
    if (name !== this.name || source !== this.metadata.source) {
      this.metadata.changes.push({
        // log previous source
        source: this.metadata.source,
        timestamp: (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_2__/* .timestampInSeconds */ .ph)(),
        propagations: this.metadata.propagations,
      });
    }

    this._name = name;
    this.metadata.source = source;
  }

  /**
   * Attaches SpanRecorder to the span itself
   * @param maxlen maximum number of spans that can be recorded
   */
   initSpanRecorder(maxlen = 1000) {
    if (!this.spanRecorder) {
      this.spanRecorder = new _span_js__WEBPACK_IMPORTED_MODULE_0__/* .SpanRecorder */ .gB(maxlen);
    }
    this.spanRecorder.add(this);
  }

  /**
   * @inheritDoc
   */
   setContext(key, context) {
    if (context === null) {
      // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
      delete this._contexts[key];
    } else {
      this._contexts[key] = context;
    }
  }

  /**
   * @inheritDoc
   */
   setMeasurement(name, value, unit = '') {
    this._measurements[name] = { value, unit };
  }

  /**
   * @inheritDoc
   */
   setMetadata(newMetadata) {
    this.metadata = { ...this.metadata, ...newMetadata };
  }

  /**
   * @inheritDoc
   */
   finish(endTimestamp) {
    // This transaction is already finished, so we should not flush it again.
    if (this.endTimestamp !== undefined) {
      return undefined;
    }

    if (!this.name) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && _sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .logger.warn */ .kg.warn('Transaction has no name, falling back to `<unlabeled transaction>`.');
      this.name = '<unlabeled transaction>';
    }

    // just sets the end timestamp
    super.finish(endTimestamp);

    if (this.sampled !== true) {
      // At this point if `sampled !== true` we want to discard the transaction.
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && _sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .logger.log */ .kg.log('[Tracing] Discarding transaction because its trace was not chosen to be sampled.');

      const client = this._hub.getClient();
      if (client) {
        client.recordDroppedEvent('sample_rate', 'transaction');
      }

      return undefined;
    }

    const finishedSpans = this.spanRecorder ? this.spanRecorder.spans.filter(s => s !== this && s.endTimestamp) : [];

    if (this._trimEnd && finishedSpans.length > 0) {
      this.endTimestamp = finishedSpans.reduce((prev, current) => {
        if (prev.endTimestamp && current.endTimestamp) {
          return prev.endTimestamp > current.endTimestamp ? prev : current;
        }
        return prev;
      }).endTimestamp;
    }

    const metadata = this.metadata;

    const transaction = {
      contexts: {
        ...this._contexts,
        // We don't want to override trace context
        trace: this.getTraceContext(),
      },
      spans: finishedSpans,
      start_timestamp: this.startTimestamp,
      tags: this.tags,
      timestamp: this.endTimestamp,
      transaction: this.name,
      type: 'transaction',
      sdkProcessingMetadata: {
        ...metadata,
        dynamicSamplingContext: this.getDynamicSamplingContext(),
      },
      ...(metadata.source && {
        transaction_info: {
          source: metadata.source,
          changes: metadata.changes,
          propagations: metadata.propagations,
        },
      }),
    };

    const hasMeasurements = Object.keys(this._measurements).length > 0;

    if (hasMeasurements) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
        _sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .logger.log */ .kg.log(
          '[Measurements] Adding measurements to transaction',
          JSON.stringify(this._measurements, undefined, 2),
        );
      transaction.measurements = this._measurements;
    }

    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && _sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .logger.log */ .kg.log(`[Tracing] Finishing ${this.op} transaction: ${this.name}.`);

    return this._hub.captureEvent(transaction);
  }

  /**
   * @inheritDoc
   */
   toContext() {
    const spanContext = super.toContext();

    return (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_4__/* .dropUndefinedKeys */ .Jr)({
      ...spanContext,
      name: this.name,
      trimEnd: this._trimEnd,
    });
  }

  /**
   * @inheritDoc
   */
   updateWithContext(transactionContext) {
    super.updateWithContext(transactionContext);

    this.name = transactionContext.name || '';

    this._trimEnd = transactionContext.trimEnd;

    return this;
  }

  /**
   * @inheritdoc
   *
   * @experimental
   */
   getDynamicSamplingContext() {
    if (this._frozenDynamicSamplingContext) {
      return this._frozenDynamicSamplingContext;
    }

    const hub = this._hub || (0,_sentry_core__WEBPACK_IMPORTED_MODULE_1__/* .getCurrentHub */ .Gd)();
    const client = hub && hub.getClient();

    if (!client) return {};

    const { environment, release } = client.getOptions() || {};
    const { publicKey: public_key } = client.getDsn() || {};

    const maybeSampleRate = this.metadata.sampleRate;
    const sample_rate = maybeSampleRate !== undefined ? maybeSampleRate.toString() : undefined;

    const scope = hub.getScope();
    const { segment: user_segment } = (scope && scope.getUser()) || {};

    const source = this.metadata.source;

    // We don't want to have a transaction name in the DSC if the source is "url" because URLs might contain PII
    const transaction = source && source !== 'url' ? this.name : undefined;

    const dsc = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_4__/* .dropUndefinedKeys */ .Jr)({
      environment,
      release,
      transaction,
      user_segment,
      public_key,
      trace_id: this.traceId,
      sample_rate,
    });

    // Uncomment if we want to make DSC immutable
    // this._frozenDynamicSamplingContext = dsc;

    return dsc;
  }
}


//# sourceMappingURL=transaction.js.map


/***/ }),

/***/ 25808:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "XL": function() { return /* binding */ msToSec; },
/* harmony export */   "x1": function() { return /* binding */ getActiveTransaction; },
/* harmony export */   "zu": function() { return /* binding */ hasTracingEnabled; }
/* harmony export */ });
/* harmony import */ var _sentry_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(90936);



/**
 * Determines if tracing is currently enabled.
 *
 * Tracing is enabled when at least one of `tracesSampleRate` and `tracesSampler` is defined in the SDK config.
 */
function hasTracingEnabled(
  maybeOptions,
) {
  const client = (0,_sentry_core__WEBPACK_IMPORTED_MODULE_0__/* .getCurrentHub */ .Gd)().getClient();
  const options = maybeOptions || (client && client.getOptions());
  return !!options && ('tracesSampleRate' in options || 'tracesSampler' in options);
}

/** Grabs active transaction off scope, if any */
function getActiveTransaction(maybeHub) {
  const hub = maybeHub || (0,_sentry_core__WEBPACK_IMPORTED_MODULE_0__/* .getCurrentHub */ .Gd)();
  const scope = hub.getScope();
  return scope && (scope.getTransaction() );
}

/**
 * Converts from milliseconds to seconds
 * @param time time in ms
 */
function msToSec(time) {
  return time / 1000;
}


//# sourceMappingURL=utils.js.map


/***/ }),

/***/ 53287:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Rt": function() { return /* binding */ htmlTreeAsString; },
/* harmony export */   "l4": function() { return /* binding */ getLocationHref; },
/* harmony export */   "qT": function() { return /* binding */ getDomElement; }
/* harmony export */ });
/* harmony import */ var _is_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(33816);
/* harmony import */ var _worldwide_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62000);



// eslint-disable-next-line deprecation/deprecation
const WINDOW = (0,_worldwide_js__WEBPACK_IMPORTED_MODULE_0__/* .getGlobalObject */ .Rf)();

const DEFAULT_MAX_STRING_LENGTH = 80;

/**
 * Given a child DOM element, returns a query-selector statement describing that
 * and its ancestors
 * e.g. [HTMLElement] => body > div > input#foo.btn[name=baz]
 * @returns generated DOM path
 */
function htmlTreeAsString(
  elem,
  options = {},
) {

  // try/catch both:
  // - accessing event.target (see getsentry/raven-js#838, #768)
  // - `htmlTreeAsString` because it's complex, and just accessing the DOM incorrectly
  // - can throw an exception in some circumstances.
  try {
    let currentElem = elem ;
    const MAX_TRAVERSE_HEIGHT = 5;
    const out = [];
    let height = 0;
    let len = 0;
    const separator = ' > ';
    const sepLength = separator.length;
    let nextStr;
    const keyAttrs = Array.isArray(options) ? options : options.keyAttrs;
    const maxStringLength = (!Array.isArray(options) && options.maxStringLength) || DEFAULT_MAX_STRING_LENGTH;

    while (currentElem && height++ < MAX_TRAVERSE_HEIGHT) {
      nextStr = _htmlElementAsString(currentElem, keyAttrs);
      // bail out if
      // - nextStr is the 'html' element
      // - the length of the string that would be created exceeds maxStringLength
      //   (ignore this limit if we are on the first iteration)
      if (nextStr === 'html' || (height > 1 && len + out.length * sepLength + nextStr.length >= maxStringLength)) {
        break;
      }

      out.push(nextStr);

      len += nextStr.length;
      currentElem = currentElem.parentNode;
    }

    return out.reverse().join(separator);
  } catch (_oO) {
    return '<unknown>';
  }
}

/**
 * Returns a simple, query-selector representation of a DOM element
 * e.g. [HTMLElement] => input#foo.btn[name=baz]
 * @returns generated DOM path
 */
function _htmlElementAsString(el, keyAttrs) {
  const elem = el

;

  const out = [];
  let className;
  let classes;
  let key;
  let attr;
  let i;

  if (!elem || !elem.tagName) {
    return '';
  }

  out.push(elem.tagName.toLowerCase());

  // Pairs of attribute keys defined in `serializeAttribute` and their values on element.
  const keyAttrPairs =
    keyAttrs && keyAttrs.length
      ? keyAttrs.filter(keyAttr => elem.getAttribute(keyAttr)).map(keyAttr => [keyAttr, elem.getAttribute(keyAttr)])
      : null;

  if (keyAttrPairs && keyAttrPairs.length) {
    keyAttrPairs.forEach(keyAttrPair => {
      out.push(`[${keyAttrPair[0]}="${keyAttrPair[1]}"]`);
    });
  } else {
    if (elem.id) {
      out.push(`#${elem.id}`);
    }

    // eslint-disable-next-line prefer-const
    className = elem.className;
    if (className && (0,_is_js__WEBPACK_IMPORTED_MODULE_1__/* .isString */ .HD)(className)) {
      classes = className.split(/\s+/);
      for (i = 0; i < classes.length; i++) {
        out.push(`.${classes[i]}`);
      }
    }
  }
  const allowedAttrs = ['type', 'name', 'title', 'alt'];
  for (i = 0; i < allowedAttrs.length; i++) {
    key = allowedAttrs[i];
    attr = elem.getAttribute(key);
    if (attr) {
      out.push(`[${key}="${attr}"]`);
    }
  }
  return out.join('');
}

/**
 * A safe form of location.href
 */
function getLocationHref() {
  try {
    return WINDOW.document.location.href;
  } catch (oO) {
    return '';
  }
}

/**
 * Gets a DOM element by using document.querySelector.
 *
 * This wrapper will first check for the existance of the function before
 * actually calling it so that we don't have to take care of this check,
 * every time we want to access the DOM.
 *
 * Reason: DOM/querySelector is not available in all environments.
 *
 * We have to cast to any because utils can be consumed by a variety of environments,
 * and we don't want to break TS users. If you know what element will be selected by
 * `document.querySelector`, specify it as part of the generic call. For example,
 * `const element = getDomElement<Element>('selector');`
 *
 * @param selector the selector string passed on to document.querySelector
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function getDomElement(selector) {
  if (WINDOW.document && WINDOW.document.querySelector) {
    return WINDOW.document.querySelector(selector) ;
  }
  return null;
}


//# sourceMappingURL=browser.js.map


/***/ }),

/***/ 49398:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "o": function() { return /* binding */ addInstrumentationHandler; }
/* harmony export */ });
/* harmony import */ var _is_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(33816);
/* harmony import */ var _logger_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23680);
/* harmony import */ var _object_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(71086);
/* harmony import */ var _stacktrace_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(15635);
/* harmony import */ var _supports_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(13081);
/* harmony import */ var _worldwide_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62000);







// eslint-disable-next-line deprecation/deprecation
const WINDOW = (0,_worldwide_js__WEBPACK_IMPORTED_MODULE_0__/* .getGlobalObject */ .Rf)();

/**
 * Instrument native APIs to call handlers that can be used to create breadcrumbs, APM spans etc.
 *  - Console API
 *  - Fetch API
 *  - XHR API
 *  - History API
 *  - DOM API (click/typing)
 *  - Error API
 *  - UnhandledRejection API
 */

const handlers = {};
const instrumented = {};

/** Instruments given API */
function instrument(type) {
  if (instrumented[type]) {
    return;
  }

  instrumented[type] = true;

  switch (type) {
    case 'console':
      instrumentConsole();
      break;
    case 'dom':
      instrumentDOM();
      break;
    case 'xhr':
      instrumentXHR();
      break;
    case 'fetch':
      instrumentFetch();
      break;
    case 'history':
      instrumentHistory();
      break;
    case 'error':
      instrumentError();
      break;
    case 'unhandledrejection':
      instrumentUnhandledRejection();
      break;
    default:
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && _logger_js__WEBPACK_IMPORTED_MODULE_1__/* .logger.warn */ .kg.warn('unknown instrumentation type:', type);
      return;
  }
}

/**
 * Add handler that will be called when given type of instrumentation triggers.
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */
function addInstrumentationHandler(type, callback) {
  handlers[type] = handlers[type] || [];
  (handlers[type] ).push(callback);
  instrument(type);
}

/** JSDoc */
function triggerHandlers(type, data) {
  if (!type || !handlers[type]) {
    return;
  }

  for (const handler of handlers[type] || []) {
    try {
      handler(data);
    } catch (e) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
        _logger_js__WEBPACK_IMPORTED_MODULE_1__/* .logger.error */ .kg.error(
          `Error while triggering instrumentation handler.\nType: ${type}\nName: ${(0,_stacktrace_js__WEBPACK_IMPORTED_MODULE_2__/* .getFunctionName */ .$P)(handler)}\nError:`,
          e,
        );
    }
  }
}

/** JSDoc */
function instrumentConsole() {
  if (!('console' in WINDOW)) {
    return;
  }

  _logger_js__WEBPACK_IMPORTED_MODULE_1__/* .CONSOLE_LEVELS.forEach */ .RU.forEach(function (level) {
    if (!(level in WINDOW.console)) {
      return;
    }

    (0,_object_js__WEBPACK_IMPORTED_MODULE_3__/* .fill */ .hl)(WINDOW.console, level, function (originalConsoleMethod) {
      return function (...args) {
        triggerHandlers('console', { args, level });

        // this fails for some browsers. :(
        if (originalConsoleMethod) {
          originalConsoleMethod.apply(WINDOW.console, args);
        }
      };
    });
  });
}

/** JSDoc */
function instrumentFetch() {
  if (!(0,_supports_js__WEBPACK_IMPORTED_MODULE_4__/* .supportsNativeFetch */ .t$)()) {
    return;
  }

  (0,_object_js__WEBPACK_IMPORTED_MODULE_3__/* .fill */ .hl)(WINDOW, 'fetch', function (originalFetch) {
    return function (...args) {
      const handlerData = {
        args,
        fetchData: {
          method: getFetchMethod(args),
          url: getFetchUrl(args),
        },
        startTimestamp: Date.now(),
      };

      triggerHandlers('fetch', {
        ...handlerData,
      });

      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
      return originalFetch.apply(WINDOW, args).then(
        (response) => {
          triggerHandlers('fetch', {
            ...handlerData,
            endTimestamp: Date.now(),
            response,
          });
          return response;
        },
        (error) => {
          triggerHandlers('fetch', {
            ...handlerData,
            endTimestamp: Date.now(),
            error,
          });
          // NOTE: If you are a Sentry user, and you are seeing this stack frame,
          //       it means the sentry.javascript SDK caught an error invoking your application code.
          //       This is expected behavior and NOT indicative of a bug with sentry.javascript.
          throw error;
        },
      );
    };
  });
}

/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/** Extract `method` from fetch call arguments */
function getFetchMethod(fetchArgs = []) {
  if ('Request' in WINDOW && (0,_is_js__WEBPACK_IMPORTED_MODULE_5__/* .isInstanceOf */ .V9)(fetchArgs[0], Request) && fetchArgs[0].method) {
    return String(fetchArgs[0].method).toUpperCase();
  }
  if (fetchArgs[1] && fetchArgs[1].method) {
    return String(fetchArgs[1].method).toUpperCase();
  }
  return 'GET';
}

/** Extract `url` from fetch call arguments */
function getFetchUrl(fetchArgs = []) {
  if (typeof fetchArgs[0] === 'string') {
    return fetchArgs[0];
  }
  if ('Request' in WINDOW && (0,_is_js__WEBPACK_IMPORTED_MODULE_5__/* .isInstanceOf */ .V9)(fetchArgs[0], Request)) {
    return fetchArgs[0].url;
  }
  return String(fetchArgs[0]);
}
/* eslint-enable @typescript-eslint/no-unsafe-member-access */

/** JSDoc */
function instrumentXHR() {
  if (!('XMLHttpRequest' in WINDOW)) {
    return;
  }

  const xhrproto = XMLHttpRequest.prototype;

  (0,_object_js__WEBPACK_IMPORTED_MODULE_3__/* .fill */ .hl)(xhrproto, 'open', function (originalOpen) {
    return function ( ...args) {
      // eslint-disable-next-line @typescript-eslint/no-this-alias
      const xhr = this;
      const url = args[1];
      const xhrInfo = (xhr.__sentry_xhr__ = {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        method: (0,_is_js__WEBPACK_IMPORTED_MODULE_5__/* .isString */ .HD)(args[0]) ? args[0].toUpperCase() : args[0],
        url: args[1],
      });

      // if Sentry key appears in URL, don't capture it as a request
      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
      if ((0,_is_js__WEBPACK_IMPORTED_MODULE_5__/* .isString */ .HD)(url) && xhrInfo.method === 'POST' && url.match(/sentry_key/)) {
        xhr.__sentry_own_request__ = true;
      }

      const onreadystatechangeHandler = function () {
        if (xhr.readyState === 4) {
          try {
            // touching statusCode in some platforms throws
            // an exception
            xhrInfo.status_code = xhr.status;
          } catch (e) {
            /* do nothing */
          }

          triggerHandlers('xhr', {
            args,
            endTimestamp: Date.now(),
            startTimestamp: Date.now(),
            xhr,
          });
        }
      };

      if ('onreadystatechange' in xhr && typeof xhr.onreadystatechange === 'function') {
        (0,_object_js__WEBPACK_IMPORTED_MODULE_3__/* .fill */ .hl)(xhr, 'onreadystatechange', function (original) {
          return function (...readyStateArgs) {
            onreadystatechangeHandler();
            return original.apply(xhr, readyStateArgs);
          };
        });
      } else {
        xhr.addEventListener('readystatechange', onreadystatechangeHandler);
      }

      return originalOpen.apply(xhr, args);
    };
  });

  (0,_object_js__WEBPACK_IMPORTED_MODULE_3__/* .fill */ .hl)(xhrproto, 'send', function (originalSend) {
    return function ( ...args) {
      if (this.__sentry_xhr__ && args[0] !== undefined) {
        this.__sentry_xhr__.body = args[0];
      }

      triggerHandlers('xhr', {
        args,
        startTimestamp: Date.now(),
        xhr: this,
      });

      return originalSend.apply(this, args);
    };
  });
}

let lastHref;

/** JSDoc */
function instrumentHistory() {
  if (!(0,_supports_js__WEBPACK_IMPORTED_MODULE_4__/* .supportsHistory */ .Bf)()) {
    return;
  }

  const oldOnPopState = WINDOW.onpopstate;
  WINDOW.onpopstate = function ( ...args) {
    const to = WINDOW.location.href;
    // keep track of the current URL state, as we always receive only the updated state
    const from = lastHref;
    lastHref = to;
    triggerHandlers('history', {
      from,
      to,
    });
    if (oldOnPopState) {
      // Apparently this can throw in Firefox when incorrectly implemented plugin is installed.
      // https://github.com/getsentry/sentry-javascript/issues/3344
      // https://github.com/bugsnag/bugsnag-js/issues/469
      try {
        return oldOnPopState.apply(this, args);
      } catch (_oO) {
        // no-empty
      }
    }
  };

  /** @hidden */
  function historyReplacementFunction(originalHistoryFunction) {
    return function ( ...args) {
      const url = args.length > 2 ? args[2] : undefined;
      if (url) {
        // coerce to string (this is what pushState does)
        const from = lastHref;
        const to = String(url);
        // keep track of the current URL state, as we always receive only the updated state
        lastHref = to;
        triggerHandlers('history', {
          from,
          to,
        });
      }
      return originalHistoryFunction.apply(this, args);
    };
  }

  (0,_object_js__WEBPACK_IMPORTED_MODULE_3__/* .fill */ .hl)(WINDOW.history, 'pushState', historyReplacementFunction);
  (0,_object_js__WEBPACK_IMPORTED_MODULE_3__/* .fill */ .hl)(WINDOW.history, 'replaceState', historyReplacementFunction);
}

const debounceDuration = 1000;
let debounceTimerID;
let lastCapturedEvent;

/**
 * Decide whether the current event should finish the debounce of previously captured one.
 * @param previous previously captured event
 * @param current event to be captured
 */
function shouldShortcircuitPreviousDebounce(previous, current) {
  // If there was no previous event, it should always be swapped for the new one.
  if (!previous) {
    return true;
  }

  // If both events have different type, then user definitely performed two separate actions. e.g. click + keypress.
  if (previous.type !== current.type) {
    return true;
  }

  try {
    // If both events have the same type, it's still possible that actions were performed on different targets.
    // e.g. 2 clicks on different buttons.
    if (previous.target !== current.target) {
      return true;
    }
  } catch (e) {
    // just accessing `target` property can throw an exception in some rare circumstances
    // see: https://github.com/getsentry/sentry-javascript/issues/838
  }

  // If both events have the same type _and_ same `target` (an element which triggered an event, _not necessarily_
  // to which an event listener was attached), we treat them as the same action, as we want to capture
  // only one breadcrumb. e.g. multiple clicks on the same button, or typing inside a user input box.
  return false;
}

/**
 * Decide whether an event should be captured.
 * @param event event to be captured
 */
function shouldSkipDOMEvent(event) {
  // We are only interested in filtering `keypress` events for now.
  if (event.type !== 'keypress') {
    return false;
  }

  try {
    const target = event.target ;

    if (!target || !target.tagName) {
      return true;
    }

    // Only consider keypress events on actual input elements. This will disregard keypresses targeting body
    // e.g.tabbing through elements, hotkeys, etc.
    if (target.tagName === 'INPUT' || target.tagName === 'TEXTAREA' || target.isContentEditable) {
      return false;
    }
  } catch (e) {
    // just accessing `target` property can throw an exception in some rare circumstances
    // see: https://github.com/getsentry/sentry-javascript/issues/838
  }

  return true;
}

/**
 * Wraps addEventListener to capture UI breadcrumbs
 * @param handler function that will be triggered
 * @param globalListener indicates whether event was captured by the global event listener
 * @returns wrapped breadcrumb events handler
 * @hidden
 */
function makeDOMEventHandler(handler, globalListener = false) {
  return (event) => {
    // It's possible this handler might trigger multiple times for the same
    // event (e.g. event propagation through node ancestors).
    // Ignore if we've already captured that event.
    if (!event || lastCapturedEvent === event) {
      return;
    }

    // We always want to skip _some_ events.
    if (shouldSkipDOMEvent(event)) {
      return;
    }

    const name = event.type === 'keypress' ? 'input' : event.type;

    // If there is no debounce timer, it means that we can safely capture the new event and store it for future comparisons.
    if (debounceTimerID === undefined) {
      handler({
        event: event,
        name,
        global: globalListener,
      });
      lastCapturedEvent = event;
    }
    // If there is a debounce awaiting, see if the new event is different enough to treat it as a unique one.
    // If that's the case, emit the previous event and store locally the newly-captured DOM event.
    else if (shouldShortcircuitPreviousDebounce(lastCapturedEvent, event)) {
      handler({
        event: event,
        name,
        global: globalListener,
      });
      lastCapturedEvent = event;
    }

    // Start a new debounce timer that will prevent us from capturing multiple events that should be grouped together.
    clearTimeout(debounceTimerID);
    debounceTimerID = WINDOW.setTimeout(() => {
      debounceTimerID = undefined;
    }, debounceDuration);
  };
}

/** JSDoc */
function instrumentDOM() {
  if (!('document' in WINDOW)) {
    return;
  }

  // Make it so that any click or keypress that is unhandled / bubbled up all the way to the document triggers our dom
  // handlers. (Normally we have only one, which captures a breadcrumb for each click or keypress.) Do this before
  // we instrument `addEventListener` so that we don't end up attaching this handler twice.
  const triggerDOMHandler = triggerHandlers.bind(null, 'dom');
  const globalDOMEventHandler = makeDOMEventHandler(triggerDOMHandler, true);
  WINDOW.document.addEventListener('click', globalDOMEventHandler, false);
  WINDOW.document.addEventListener('keypress', globalDOMEventHandler, false);

  // After hooking into click and keypress events bubbled up to `document`, we also hook into user-handled
  // clicks & keypresses, by adding an event listener of our own to any element to which they add a listener. That
  // way, whenever one of their handlers is triggered, ours will be, too. (This is needed because their handler
  // could potentially prevent the event from bubbling up to our global listeners. This way, our handler are still
  // guaranteed to fire at least once.)
  ['EventTarget', 'Node'].forEach((target) => {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    const proto = (WINDOW )[target] && (WINDOW )[target].prototype;
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, no-prototype-builtins
    if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty('addEventListener')) {
      return;
    }

    (0,_object_js__WEBPACK_IMPORTED_MODULE_3__/* .fill */ .hl)(proto, 'addEventListener', function (originalAddEventListener) {
      return function (

        type,
        listener,
        options,
      ) {
        if (type === 'click' || type == 'keypress') {
          try {
            const el = this ;
            const handlers = (el.__sentry_instrumentation_handlers__ = el.__sentry_instrumentation_handlers__ || {});
            const handlerForType = (handlers[type] = handlers[type] || { refCount: 0 });

            if (!handlerForType.handler) {
              const handler = makeDOMEventHandler(triggerDOMHandler);
              handlerForType.handler = handler;
              originalAddEventListener.call(this, type, handler, options);
            }

            handlerForType.refCount++;
          } catch (e) {
            // Accessing dom properties is always fragile.
            // Also allows us to skip `addEventListenrs` calls with no proper `this` context.
          }
        }

        return originalAddEventListener.call(this, type, listener, options);
      };
    });

    (0,_object_js__WEBPACK_IMPORTED_MODULE_3__/* .fill */ .hl)(
      proto,
      'removeEventListener',
      function (originalRemoveEventListener) {
        return function (

          type,
          listener,
          options,
        ) {
          if (type === 'click' || type == 'keypress') {
            try {
              const el = this ;
              const handlers = el.__sentry_instrumentation_handlers__ || {};
              const handlerForType = handlers[type];

              if (handlerForType) {
                handlerForType.refCount--;
                // If there are no longer any custom handlers of the current type on this element, we can remove ours, too.
                if (handlerForType.refCount <= 0) {
                  originalRemoveEventListener.call(this, type, handlerForType.handler, options);
                  handlerForType.handler = undefined;
                  delete handlers[type]; // eslint-disable-line @typescript-eslint/no-dynamic-delete
                }

                // If there are no longer any custom handlers of any type on this element, cleanup everything.
                if (Object.keys(handlers).length === 0) {
                  delete el.__sentry_instrumentation_handlers__;
                }
              }
            } catch (e) {
              // Accessing dom properties is always fragile.
              // Also allows us to skip `addEventListenrs` calls with no proper `this` context.
            }
          }

          return originalRemoveEventListener.call(this, type, listener, options);
        };
      },
    );
  });
}

let _oldOnErrorHandler = null;
/** JSDoc */
function instrumentError() {
  _oldOnErrorHandler = WINDOW.onerror;

  WINDOW.onerror = function (msg, url, line, column, error) {
    triggerHandlers('error', {
      column,
      error,
      line,
      msg,
      url,
    });

    if (_oldOnErrorHandler) {
      // eslint-disable-next-line prefer-rest-params
      return _oldOnErrorHandler.apply(this, arguments);
    }

    return false;
  };
}

let _oldOnUnhandledRejectionHandler = null;
/** JSDoc */
function instrumentUnhandledRejection() {
  _oldOnUnhandledRejectionHandler = WINDOW.onunhandledrejection;

  WINDOW.onunhandledrejection = function (e) {
    triggerHandlers('unhandledrejection', e);

    if (_oldOnUnhandledRejectionHandler) {
      // eslint-disable-next-line prefer-rest-params
      return _oldOnUnhandledRejectionHandler.apply(this, arguments);
    }

    return true;
  };
}


//# sourceMappingURL=instrument.js.map


/***/ }),

/***/ 33816:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Cy": function() { return /* binding */ isSyntheticEvent; },
/* harmony export */   "HD": function() { return /* binding */ isString; },
/* harmony export */   "J8": function() { return /* binding */ isThenable; },
/* harmony export */   "Kj": function() { return /* binding */ isRegExp; },
/* harmony export */   "PO": function() { return /* binding */ isPlainObject; },
/* harmony export */   "TX": function() { return /* binding */ isDOMError; },
/* harmony export */   "V9": function() { return /* binding */ isInstanceOf; },
/* harmony export */   "VW": function() { return /* binding */ isErrorEvent; },
/* harmony export */   "VZ": function() { return /* binding */ isError; },
/* harmony export */   "cO": function() { return /* binding */ isEvent; },
/* harmony export */   "fm": function() { return /* binding */ isDOMException; },
/* harmony export */   "i2": function() { return /* binding */ isNaN; },
/* harmony export */   "kK": function() { return /* binding */ isElement; },
/* harmony export */   "pt": function() { return /* binding */ isPrimitive; }
/* harmony export */ });
// eslint-disable-next-line @typescript-eslint/unbound-method
const objectToString = Object.prototype.toString;

/**
 * Checks whether given value's type is one of a few Error or Error-like
 * {@link isError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isError(wat) {
  switch (objectToString.call(wat)) {
    case '[object Error]':
    case '[object Exception]':
    case '[object DOMException]':
      return true;
    default:
      return isInstanceOf(wat, Error);
  }
}
/**
 * Checks whether given value is an instance of the given built-in class.
 *
 * @param wat The value to be checked
 * @param className
 * @returns A boolean representing the result.
 */
function isBuiltin(wat, className) {
  return objectToString.call(wat) === `[object ${className}]`;
}

/**
 * Checks whether given value's type is ErrorEvent
 * {@link isErrorEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isErrorEvent(wat) {
  return isBuiltin(wat, 'ErrorEvent');
}

/**
 * Checks whether given value's type is DOMError
 * {@link isDOMError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isDOMError(wat) {
  return isBuiltin(wat, 'DOMError');
}

/**
 * Checks whether given value's type is DOMException
 * {@link isDOMException}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isDOMException(wat) {
  return isBuiltin(wat, 'DOMException');
}

/**
 * Checks whether given value's type is a string
 * {@link isString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isString(wat) {
  return isBuiltin(wat, 'String');
}

/**
 * Checks whether given value is a primitive (undefined, null, number, boolean, string, bigint, symbol)
 * {@link isPrimitive}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isPrimitive(wat) {
  return wat === null || (typeof wat !== 'object' && typeof wat !== 'function');
}

/**
 * Checks whether given value's type is an object literal
 * {@link isPlainObject}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isPlainObject(wat) {
  return isBuiltin(wat, 'Object');
}

/**
 * Checks whether given value's type is an Event instance
 * {@link isEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isEvent(wat) {
  return typeof Event !== 'undefined' && isInstanceOf(wat, Event);
}

/**
 * Checks whether given value's type is an Element instance
 * {@link isElement}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isElement(wat) {
  return typeof Element !== 'undefined' && isInstanceOf(wat, Element);
}

/**
 * Checks whether given value's type is an regexp
 * {@link isRegExp}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isRegExp(wat) {
  return isBuiltin(wat, 'RegExp');
}

/**
 * Checks whether given value has a then function.
 * @param wat A value to be checked.
 */
function isThenable(wat) {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
  return Boolean(wat && wat.then && typeof wat.then === 'function');
}

/**
 * Checks whether given value's type is a SyntheticEvent
 * {@link isSyntheticEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isSyntheticEvent(wat) {
  return isPlainObject(wat) && 'nativeEvent' in wat && 'preventDefault' in wat && 'stopPropagation' in wat;
}

/**
 * Checks whether given value is NaN
 * {@link isNaN}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isNaN(wat) {
  return typeof wat === 'number' && wat !== wat;
}

/**
 * Checks whether given value's type is an instance of provided constructor.
 * {@link isInstanceOf}.
 *
 * @param wat A value to be checked.
 * @param base A constructor to be used in a check.
 * @returns A boolean representing the result.
 */
function isInstanceOf(wat, base) {
  try {
    return wat instanceof base;
  } catch (_e) {
    return false;
  }
}


//# sourceMappingURL=is.js.map


/***/ }),

/***/ 23680:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Cf": function() { return /* binding */ consoleSandbox; },
/* harmony export */   "RU": function() { return /* binding */ CONSOLE_LEVELS; },
/* harmony export */   "kg": function() { return /* binding */ logger; }
/* harmony export */ });
/* harmony import */ var _worldwide_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62000);


/** Prefix for logging strings */
const PREFIX = 'Sentry Logger ';

const CONSOLE_LEVELS = ['debug', 'info', 'warn', 'error', 'log', 'assert', 'trace'] ;

/**
 * Temporarily disable sentry console instrumentations.
 *
 * @param callback The function to run against the original `console` messages
 * @returns The results of the callback
 */
function consoleSandbox(callback) {
  if (!("console" in _worldwide_js__WEBPACK_IMPORTED_MODULE_0__/* .GLOBAL_OBJ */ .n2)) {
    return callback();
  }

  const originalConsole = _worldwide_js__WEBPACK_IMPORTED_MODULE_0__/* .GLOBAL_OBJ.console */ .n2.console ;
  const wrappedLevels = {};

  // Restore all wrapped console methods
  CONSOLE_LEVELS.forEach(level => {
    // TODO(v7): Remove this check as it's only needed for Node 6
    const originalWrappedFunc =
      originalConsole[level] && (originalConsole[level] ).__sentry_original__;
    if (level in originalConsole && originalWrappedFunc) {
      wrappedLevels[level] = originalConsole[level] ;
      originalConsole[level] = originalWrappedFunc ;
    }
  });

  try {
    return callback();
  } finally {
    // Revert restoration to wrapped state
    Object.keys(wrappedLevels).forEach(level => {
      originalConsole[level] = wrappedLevels[level ];
    });
  }
}

function makeLogger() {
  let enabled = false;
  const logger = {
    enable: () => {
      enabled = true;
    },
    disable: () => {
      enabled = false;
    },
  };

  if ((typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__)) {
    CONSOLE_LEVELS.forEach(name => {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      logger[name] = (...args) => {
        if (enabled) {
          consoleSandbox(() => {
            _worldwide_js__WEBPACK_IMPORTED_MODULE_0__/* .GLOBAL_OBJ.console */ .n2.console[name](`${PREFIX}[${name}]:`, ...args);
          });
        }
      };
    });
  } else {
    CONSOLE_LEVELS.forEach(name => {
      logger[name] = () => undefined;
    });
  }

  return logger ;
}

// Ensure we only have a single logger instance, even if multiple versions of @sentry/utils are being used
let logger;
if ((typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__)) {
  logger = (0,_worldwide_js__WEBPACK_IMPORTED_MODULE_0__/* .getGlobalSingleton */ .YO)('logger', makeLogger);
} else {
  logger = makeLogger();
}


//# sourceMappingURL=logger.js.map


/***/ }),

/***/ 3528:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DM": function() { return /* binding */ uuid4; },
/* harmony export */   "Db": function() { return /* binding */ addExceptionTypeValue; },
/* harmony export */   "EG": function() { return /* binding */ addExceptionMechanism; },
/* harmony export */   "YO": function() { return /* binding */ checkOrSetAlreadyCaught; },
/* harmony export */   "jH": function() { return /* binding */ getEventDescription; },
/* harmony export */   "lE": function() { return /* binding */ arrayify; }
/* harmony export */ });
/* unused harmony exports addContextToFrame, parseSemver */
/* harmony import */ var _object_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(71086);
/* harmony import */ var _worldwide_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62000);




/**
 * UUID4 generator
 *
 * @returns string Generated UUID4.
 */
function uuid4() {
  const gbl = _worldwide_js__WEBPACK_IMPORTED_MODULE_0__/* .GLOBAL_OBJ */ .n2 ;
  const crypto = gbl.crypto || gbl.msCrypto;

  if (crypto && crypto.randomUUID) {
    return crypto.randomUUID().replace(/-/g, '');
  }

  const getRandomByte =
    crypto && crypto.getRandomValues ? () => crypto.getRandomValues(new Uint8Array(1))[0] : () => Math.random() * 16;

  // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
  // Concatenating the following numbers as strings results in '10000000100040008000100000000000'
  return (([1e7] ) + 1e3 + 4e3 + 8e3 + 1e11).replace(/[018]/g, c =>
    // eslint-disable-next-line no-bitwise
    ((c ) ^ ((getRandomByte() & 15) >> ((c ) / 4))).toString(16),
  );
}

function getFirstException(event) {
  return event.exception && event.exception.values ? event.exception.values[0] : undefined;
}

/**
 * Extracts either message or type+value from an event that can be used for user-facing logs
 * @returns event's description
 */
function getEventDescription(event) {
  const { message, event_id: eventId } = event;
  if (message) {
    return message;
  }

  const firstException = getFirstException(event);
  if (firstException) {
    if (firstException.type && firstException.value) {
      return `${firstException.type}: ${firstException.value}`;
    }
    return firstException.type || firstException.value || eventId || '<unknown>';
  }
  return eventId || '<unknown>';
}

/**
 * Adds exception values, type and value to an synthetic Exception.
 * @param event The event to modify.
 * @param value Value of the exception.
 * @param type Type of the exception.
 * @hidden
 */
function addExceptionTypeValue(event, value, type) {
  const exception = (event.exception = event.exception || {});
  const values = (exception.values = exception.values || []);
  const firstException = (values[0] = values[0] || {});
  if (!firstException.value) {
    firstException.value = value || '';
  }
  if (!firstException.type) {
    firstException.type = type || 'Error';
  }
}

/**
 * Adds exception mechanism data to a given event. Uses defaults if the second parameter is not passed.
 *
 * @param event The event to modify.
 * @param newMechanism Mechanism data to add to the event.
 * @hidden
 */
function addExceptionMechanism(event, newMechanism) {
  const firstException = getFirstException(event);
  if (!firstException) {
    return;
  }

  const defaultMechanism = { type: 'generic', handled: true };
  const currentMechanism = firstException.mechanism;
  firstException.mechanism = { ...defaultMechanism, ...currentMechanism, ...newMechanism };

  if (newMechanism && 'data' in newMechanism) {
    const mergedData = { ...(currentMechanism && currentMechanism.data), ...newMechanism.data };
    firstException.mechanism.data = mergedData;
  }
}

// https://semver.org/#is-there-a-suggested-regular-expression-regex-to-check-a-semver-string
const SEMVER_REGEXP =
  /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/;

/**
 * Represents Semantic Versioning object
 */

/**
 * Parses input into a SemVer interface
 * @param input string representation of a semver version
 */
function parseSemver(input) {
  const match = input.match(SEMVER_REGEXP) || [];
  const major = parseInt(match[1], 10);
  const minor = parseInt(match[2], 10);
  const patch = parseInt(match[3], 10);
  return {
    buildmetadata: match[5],
    major: isNaN(major) ? undefined : major,
    minor: isNaN(minor) ? undefined : minor,
    patch: isNaN(patch) ? undefined : patch,
    prerelease: match[4],
  };
}

/**
 * This function adds context (pre/post/line) lines to the provided frame
 *
 * @param lines string[] containing all lines
 * @param frame StackFrame that will be mutated
 * @param linesOfContext number of context lines we want to add pre/post
 */
function addContextToFrame(lines, frame, linesOfContext = 5) {
  // When there is no line number in the frame, attaching context is nonsensical and will even break grouping
  if (frame.lineno === undefined) {
    return;
  }

  const maxLines = lines.length;
  const sourceLine = Math.max(Math.min(maxLines, frame.lineno - 1), 0);

  frame.pre_context = lines
    .slice(Math.max(0, sourceLine - linesOfContext), sourceLine)
    .map((line) => snipLine(line, 0));

  frame.context_line = snipLine(lines[Math.min(maxLines - 1, sourceLine)], frame.colno || 0);

  frame.post_context = lines
    .slice(Math.min(sourceLine + 1, maxLines), sourceLine + 1 + linesOfContext)
    .map((line) => snipLine(line, 0));
}

/**
 * Checks whether or not we've already captured the given exception (note: not an identical exception - the very object
 * in question), and marks it captured if not.
 *
 * This is useful because it's possible for an error to get captured by more than one mechanism. After we intercept and
 * record an error, we rethrow it (assuming we've intercepted it before it's reached the top-level global handlers), so
 * that we don't interfere with whatever effects the error might have had were the SDK not there. At that point, because
 * the error has been rethrown, it's possible for it to bubble up to some other code we've instrumented. If it's not
 * caught after that, it will bubble all the way up to the global handlers (which of course we also instrument). This
 * function helps us ensure that even if we encounter the same error more than once, we only record it the first time we
 * see it.
 *
 * Note: It will ignore primitives (always return `false` and not mark them as seen), as properties can't be set on
 * them. {@link: Object.objectify} can be used on exceptions to convert any that are primitives into their equivalent
 * object wrapper forms so that this check will always work. However, because we need to flag the exact object which
 * will get rethrown, and because that rethrowing happens outside of the event processing pipeline, the objectification
 * must be done before the exception captured.
 *
 * @param A thrown exception to check or flag as having been seen
 * @returns `true` if the exception has already been captured, `false` if not (with the side effect of marking it seen)
 */
function checkOrSetAlreadyCaught(exception) {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
  if (exception && (exception ).__sentry_captured__) {
    return true;
  }

  try {
    // set it this way rather than by assignment so that it's not ennumerable and therefore isn't recorded by the
    // `ExtraErrorData` integration
    (0,_object_js__WEBPACK_IMPORTED_MODULE_1__/* .addNonEnumerableProperty */ .xp)(exception , '__sentry_captured__', true);
  } catch (err) {
    // `exception` is a primitive, so we can't mark it seen
  }

  return false;
}

/**
 * Checks whether the given input is already an array, and if it isn't, wraps it in one.
 *
 * @param maybeArray Input to turn into an array, if necessary
 * @returns The input, if already an array, or an array with the input as the only element, if not
 */
function arrayify(maybeArray) {
  return Array.isArray(maybeArray) ? maybeArray : [maybeArray];
}


//# sourceMappingURL=misc.js.map


/***/ }),

/***/ 70302:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "l$": function() { return /* binding */ dynamicRequire; },
  "KV": function() { return /* binding */ isNodeEnv; },
  "$y": function() { return /* binding */ loadModule; }
});

;// CONCATENATED MODULE: ../../.yarn/cache/@sentry-utils-npm-7.32.1-c99d3811fa-1b0d82cbcc.zip/node_modules/@sentry/utils/esm/env.js
/*
 * This module exists for optimizations in the build process through rollup and terser.  We define some global
 * constants, which can be overridden during build. By guarding certain pieces of code with functions that return these
 * constants, we can control whether or not they appear in the final bundle. (Any code guarded by a false condition will
 * never run, and will hence be dropped during treeshaking.) The two primary uses for this are stripping out calls to
 * `logger` and preventing node-related code from appearing in browser bundles.
 *
 * Attention:
 * This file should not be used to define constants/flags that are intended to be used for tree-shaking conducted by
 * users. These fags should live in their respective packages, as we identified user tooling (specifically webpack)
 * having issues tree-shaking these constants across package boundaries.
 * An example for this is the __SENTRY_DEBUG__ constant. It is declared in each package individually because we want
 * users to be able to shake away expressions that it guards.
 */

/**
 * Figures out if we're building a browser bundle.
 *
 * @returns true if this is a browser bundle build.
 */
function isBrowserBundle() {
  return typeof __SENTRY_BROWSER_BUNDLE__ !== 'undefined' && !!__SENTRY_BROWSER_BUNDLE__;
}


//# sourceMappingURL=env.js.map

;// CONCATENATED MODULE: ../../.yarn/cache/@sentry-utils-npm-7.32.1-c99d3811fa-1b0d82cbcc.zip/node_modules/@sentry/utils/esm/node.js
/* module decorator */ module = __webpack_require__.hmd(module);
/* provided dependency */ var process = __webpack_require__(97441);


/**
 * NOTE: In order to avoid circular dependencies, if you add a function to this module and it needs to print something,
 * you must either a) use `console.log` rather than the logger, or b) put your function elsewhere.
 */

/**
 * Checks whether we're in the Node.js or Browser environment
 *
 * @returns Answer to given question
 */
function isNodeEnv() {
  // explicitly check for browser bundles as those can be optimized statically
  // by terser/rollup.
  return (
    !isBrowserBundle() &&
    Object.prototype.toString.call(typeof process !== 'undefined' ? process : 0) === '[object process]'
  );
}

/**
 * Requires a module which is protected against bundler minification.
 *
 * @param request The module path to resolve
 */
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
function dynamicRequire(mod, request) {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
  return mod.require(request);
}

/**
 * Helper for dynamically loading module that should work with linked dependencies.
 * The problem is that we _should_ be using `require(require.resolve(moduleName, { paths: [cwd()] }))`
 * However it's _not possible_ to do that with Webpack, as it has to know all the dependencies during
 * build time. `require.resolve` is also not available in any other way, so we cannot create,
 * a fake helper like we do with `dynamicRequire`.
 *
 * We always prefer to use local package, thus the value is not returned early from each `try/catch` block.
 * That is to mimic the behavior of `require.resolve` exactly.
 *
 * @param moduleName module name to require
 * @returns possibly required module
 */
function loadModule(moduleName) {
  let mod;

  try {
    mod = dynamicRequire(module, moduleName);
  } catch (e) {
    // no-empty
  }

  try {
    const { cwd } = dynamicRequire(module, 'process');
    mod = dynamicRequire(module, `${cwd()}/node_modules/${moduleName}`) ;
  } catch (e) {
    // no-empty
  }

  return mod;
}


//# sourceMappingURL=node.js.map


/***/ }),

/***/ 71086:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$Q": function() { return /* binding */ markFunctionWrapped; },
/* harmony export */   "HK": function() { return /* binding */ getOriginalFunction; },
/* harmony export */   "Jr": function() { return /* binding */ dropUndefinedKeys; },
/* harmony export */   "Sh": function() { return /* binding */ convertToPlainObject; },
/* harmony export */   "_j": function() { return /* binding */ urlEncode; },
/* harmony export */   "hl": function() { return /* binding */ fill; },
/* harmony export */   "xp": function() { return /* binding */ addNonEnumerableProperty; },
/* harmony export */   "zf": function() { return /* binding */ extractExceptionKeysForMessage; }
/* harmony export */ });
/* unused harmony export objectify */
/* harmony import */ var _browser_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(53287);
/* harmony import */ var _is_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(33816);
/* harmony import */ var _string_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(58298);




/**
 * Replace a method in an object with a wrapped version of itself.
 *
 * @param source An object that contains a method to be wrapped.
 * @param name The name of the method to be wrapped.
 * @param replacementFactory A higher-order function that takes the original version of the given method and returns a
 * wrapped version. Note: The function returned by `replacementFactory` needs to be a non-arrow function, in order to
 * preserve the correct value of `this`, and the original method must be called using `origMethod.call(this, <other
 * args>)` or `origMethod.apply(this, [<other args>])` (rather than being called directly), again to preserve `this`.
 * @returns void
 */
function fill(source, name, replacementFactory) {
  if (!(name in source)) {
    return;
  }

  const original = source[name] ;
  const wrapped = replacementFactory(original) ;

  // Make sure it's a function first, as we need to attach an empty prototype for `defineProperties` to work
  // otherwise it'll throw "TypeError: Object.defineProperties called on non-object"
  if (typeof wrapped === 'function') {
    try {
      markFunctionWrapped(wrapped, original);
    } catch (_Oo) {
      // This can throw if multiple fill happens on a global object like XMLHttpRequest
      // Fixes https://github.com/getsentry/sentry-javascript/issues/2043
    }
  }

  source[name] = wrapped;
}

/**
 * Defines a non-enumerable property on the given object.
 *
 * @param obj The object on which to set the property
 * @param name The name of the property to be set
 * @param value The value to which to set the property
 */
function addNonEnumerableProperty(obj, name, value) {
  Object.defineProperty(obj, name, {
    // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
    value: value,
    writable: true,
    configurable: true,
  });
}

/**
 * Remembers the original function on the wrapped function and
 * patches up the prototype.
 *
 * @param wrapped the wrapper function
 * @param original the original function that gets wrapped
 */
function markFunctionWrapped(wrapped, original) {
  const proto = original.prototype || {};
  wrapped.prototype = original.prototype = proto;
  addNonEnumerableProperty(wrapped, '__sentry_original__', original);
}

/**
 * This extracts the original function if available.  See
 * `markFunctionWrapped` for more information.
 *
 * @param func the function to unwrap
 * @returns the unwrapped version of the function if available.
 */
function getOriginalFunction(func) {
  return func.__sentry_original__;
}

/**
 * Encodes given object into url-friendly format
 *
 * @param object An object that contains serializable values
 * @returns string Encoded
 */
function urlEncode(object) {
  return Object.keys(object)
    .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(object[key])}`)
    .join('&');
}

/**
 * Transforms any `Error` or `Event` into a plain object with all of their enumerable properties, and some of their
 * non-enumerable properties attached.
 *
 * @param value Initial source that we have to transform in order for it to be usable by the serializer
 * @returns An Event or Error turned into an object - or the value argurment itself, when value is neither an Event nor
 *  an Error.
 */
function convertToPlainObject(value)

 {
  if ((0,_is_js__WEBPACK_IMPORTED_MODULE_0__/* .isError */ .VZ)(value)) {
    return {
      message: value.message,
      name: value.name,
      stack: value.stack,
      ...getOwnProperties(value),
    };
  } else if ((0,_is_js__WEBPACK_IMPORTED_MODULE_0__/* .isEvent */ .cO)(value)) {
    const newObj

 = {
      type: value.type,
      target: serializeEventTarget(value.target),
      currentTarget: serializeEventTarget(value.currentTarget),
      ...getOwnProperties(value),
    };

    if (typeof CustomEvent !== 'undefined' && (0,_is_js__WEBPACK_IMPORTED_MODULE_0__/* .isInstanceOf */ .V9)(value, CustomEvent)) {
      newObj.detail = value.detail;
    }

    return newObj;
  } else {
    return value;
  }
}

/** Creates a string representation of the target of an `Event` object */
function serializeEventTarget(target) {
  try {
    return (0,_is_js__WEBPACK_IMPORTED_MODULE_0__/* .isElement */ .kK)(target) ? (0,_browser_js__WEBPACK_IMPORTED_MODULE_1__/* .htmlTreeAsString */ .Rt)(target) : Object.prototype.toString.call(target);
  } catch (_oO) {
    return '<unknown>';
  }
}

/** Filters out all but an object's own properties */
function getOwnProperties(obj) {
  if (typeof obj === 'object' && obj !== null) {
    const extractedProps = {};
    for (const property in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, property)) {
        extractedProps[property] = (obj )[property];
      }
    }
    return extractedProps;
  } else {
    return {};
  }
}

/**
 * Given any captured exception, extract its keys and create a sorted
 * and truncated list that will be used inside the event message.
 * eg. `Non-error exception captured with keys: foo, bar, baz`
 */
function extractExceptionKeysForMessage(exception, maxLength = 40) {
  const keys = Object.keys(convertToPlainObject(exception));
  keys.sort();

  if (!keys.length) {
    return '[object has no keys]';
  }

  if (keys[0].length >= maxLength) {
    return (0,_string_js__WEBPACK_IMPORTED_MODULE_2__/* .truncate */ .$G)(keys[0], maxLength);
  }

  for (let includedKeys = keys.length; includedKeys > 0; includedKeys--) {
    const serialized = keys.slice(0, includedKeys).join(', ');
    if (serialized.length > maxLength) {
      continue;
    }
    if (includedKeys === keys.length) {
      return serialized;
    }
    return (0,_string_js__WEBPACK_IMPORTED_MODULE_2__/* .truncate */ .$G)(serialized, maxLength);
  }

  return '';
}

/**
 * Given any object, return a new object having removed all fields whose value was `undefined`.
 * Works recursively on objects and arrays.
 *
 * Attention: This function keeps circular references in the returned object.
 */
function dropUndefinedKeys(inputValue) {
  // This map keeps track of what already visited nodes map to.
  // Our Set - based memoBuilder doesn't work here because we want to the output object to have the same circular
  // references as the input object.
  const memoizationMap = new Map();

  // This function just proxies `_dropUndefinedKeys` to keep the `memoBuilder` out of this function's API
  return _dropUndefinedKeys(inputValue, memoizationMap);
}

function _dropUndefinedKeys(inputValue, memoizationMap) {
  if ((0,_is_js__WEBPACK_IMPORTED_MODULE_0__/* .isPlainObject */ .PO)(inputValue)) {
    // If this node has already been visited due to a circular reference, return the object it was mapped to in the new object
    const memoVal = memoizationMap.get(inputValue);
    if (memoVal !== undefined) {
      return memoVal ;
    }

    const returnValue = {};
    // Store the mapping of this value in case we visit it again, in case of circular data
    memoizationMap.set(inputValue, returnValue);

    for (const key of Object.keys(inputValue)) {
      if (typeof inputValue[key] !== 'undefined') {
        returnValue[key] = _dropUndefinedKeys(inputValue[key], memoizationMap);
      }
    }

    return returnValue ;
  }

  if (Array.isArray(inputValue)) {
    // If this node has already been visited due to a circular reference, return the array it was mapped to in the new object
    const memoVal = memoizationMap.get(inputValue);
    if (memoVal !== undefined) {
      return memoVal ;
    }

    const returnValue = [];
    // Store the mapping of this value in case we visit it again, in case of circular data
    memoizationMap.set(inputValue, returnValue);

    inputValue.forEach((item) => {
      returnValue.push(_dropUndefinedKeys(item, memoizationMap));
    });

    return returnValue ;
  }

  return inputValue;
}

/**
 * Ensure that something is an object.
 *
 * Turns `undefined` and `null` into `String`s and all other primitives into instances of their respective wrapper
 * classes (String, Boolean, Number, etc.). Acts as the identity function on non-primitives.
 *
 * @param wat The subject of the objectification
 * @returns A version of `wat` which can safely be used with `Object` class methods
 */
function objectify(wat) {
  let objectified;
  switch (true) {
    case wat === undefined || wat === null:
      objectified = new String(wat);
      break;

    // Though symbols and bigints do have wrapper classes (`Symbol` and `BigInt`, respectively), for whatever reason
    // those classes don't have constructors which can be used with the `new` keyword. We therefore need to cast each as
    // an object in order to wrap it.
    case typeof wat === 'symbol' || typeof wat === 'bigint':
      objectified = Object(wat);
      break;

    // this will catch the remaining primitives: `String`, `Number`, and `Boolean`
    case isPrimitive(wat):
      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
      objectified = new (wat ).constructor(wat);
      break;

    // by process of elimination, at this point we know that `wat` must already be an object
    default:
      objectified = wat;
      break;
  }
  return objectified;
}


//# sourceMappingURL=object.js.map


/***/ }),

/***/ 15635:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$P": function() { return /* binding */ getFunctionName; },
/* harmony export */   "Sq": function() { return /* binding */ stackParserFromStackParserOptions; },
/* harmony export */   "pE": function() { return /* binding */ createStackParser; }
/* harmony export */ });
/* unused harmony exports nodeStackLineParser, stripSentryFramesAndReverse */
const STACKTRACE_LIMIT = 50;

/**
 * Creates a stack parser with the supplied line parsers
 *
 * StackFrames are returned in the correct order for Sentry Exception
 * frames and with Sentry SDK internal frames removed from the top and bottom
 *
 */
function createStackParser(...parsers) {
  const sortedParsers = parsers.sort((a, b) => a[0] - b[0]).map(p => p[1]);

  return (stack, skipFirst = 0) => {
    const frames = [];

    for (const line of stack.split('\n').slice(skipFirst)) {
      // Ignore lines over 1kb as they are unlikely to be stack frames.
      // Many of the regular expressions use backtracking which results in run time that increases exponentially with
      // input size. Huge strings can result in hangs/Denial of Service:
      // https://github.com/getsentry/sentry-javascript/issues/2286
      if (line.length > 1024) {
        continue;
      }

      // https://github.com/getsentry/sentry-javascript/issues/5459
      // Remove webpack (error: *) wrappers
      const cleanedLine = line.replace(/\(error: (.*)\)/, '$1');

      for (const parser of sortedParsers) {
        const frame = parser(cleanedLine);

        if (frame) {
          frames.push(frame);
          break;
        }
      }
    }

    return stripSentryFramesAndReverse(frames);
  };
}

/**
 * Gets a stack parser implementation from Options.stackParser
 * @see Options
 *
 * If options contains an array of line parsers, it is converted into a parser
 */
function stackParserFromStackParserOptions(stackParser) {
  if (Array.isArray(stackParser)) {
    return createStackParser(...stackParser);
  }
  return stackParser;
}

/**
 * @hidden
 */
function stripSentryFramesAndReverse(stack) {
  if (!stack.length) {
    return [];
  }

  let localStack = stack;

  const firstFrameFunction = localStack[0].function || '';
  const lastFrameFunction = localStack[localStack.length - 1].function || '';

  // If stack starts with one of our API calls, remove it (starts, meaning it's the top of the stack - aka last call)
  if (firstFrameFunction.indexOf('captureMessage') !== -1 || firstFrameFunction.indexOf('captureException') !== -1) {
    localStack = localStack.slice(1);
  }

  // If stack ends with one of our internal API calls, remove it (ends, meaning it's the bottom of the stack - aka top-most call)
  if (lastFrameFunction.indexOf('sentryWrapped') !== -1) {
    localStack = localStack.slice(0, -1);
  }

  // The frame where the crash happened, should be the last entry in the array
  return localStack
    .slice(0, STACKTRACE_LIMIT)
    .map(frame => ({
      ...frame,
      filename: frame.filename || localStack[0].filename,
      function: frame.function || '?',
    }))
    .reverse();
}

const defaultFunctionName = '<anonymous>';

/**
 * Safely extract function name from itself
 */
function getFunctionName(fn) {
  try {
    if (!fn || typeof fn !== 'function') {
      return defaultFunctionName;
    }
    return fn.name || defaultFunctionName;
  } catch (e) {
    // Just accessing custom props in some Selenium environments
    // can cause a "Permission denied" exception (see raven-js#495).
    return defaultFunctionName;
  }
}

// eslint-disable-next-line complexity
function node(getModule) {
  const FILENAME_MATCH = /^\s*[-]{4,}$/;
  const FULL_MATCH = /at (?:async )?(?:(.+?)\s+\()?(?:(.+):(\d+):(\d+)?|([^)]+))\)?/;

  // eslint-disable-next-line complexity
  return (line) => {
    if (line.match(FILENAME_MATCH)) {
      return {
        filename: line,
      };
    }

    const lineMatch = line.match(FULL_MATCH);
    if (!lineMatch) {
      return undefined;
    }

    let object;
    let method;
    let functionName;
    let typeName;
    let methodName;

    if (lineMatch[1]) {
      functionName = lineMatch[1];

      let methodStart = functionName.lastIndexOf('.');
      if (functionName[methodStart - 1] === '.') {
        methodStart--;
      }

      if (methodStart > 0) {
        object = functionName.slice(0, methodStart);
        method = functionName.slice(methodStart + 1);
        const objectEnd = object.indexOf('.Module');
        if (objectEnd > 0) {
          functionName = functionName.slice(objectEnd + 1);
          object = object.slice(0, objectEnd);
        }
      }
      typeName = undefined;
    }

    if (method) {
      typeName = object;
      methodName = method;
    }

    if (method === '<anonymous>') {
      methodName = undefined;
      functionName = undefined;
    }

    if (functionName === undefined) {
      methodName = methodName || '<anonymous>';
      functionName = typeName ? `${typeName}.${methodName}` : methodName;
    }

    const filename = lineMatch[2] && lineMatch[2].startsWith('file://') ? lineMatch[2].slice(7) : lineMatch[2];
    const isNative = lineMatch[5] === 'native';
    const isInternal =
      isNative || (filename && !filename.startsWith('/') && !filename.startsWith('.') && filename.indexOf(':\\') !== 1);

    // in_app is all that's not an internal Node function or a module within node_modules
    // note that isNative appears to return true even for node core libraries
    // see https://github.com/getsentry/raven-node/issues/176
    const in_app = !isInternal && filename !== undefined && !filename.includes('node_modules/');

    return {
      filename,
      module: getModule ? getModule(filename) : undefined,
      function: functionName,
      lineno: parseInt(lineMatch[3], 10) || undefined,
      colno: parseInt(lineMatch[4], 10) || undefined,
      in_app,
    };
  };
}

/**
 * Node.js stack line parser
 *
 * This is in @sentry/utils so it can be used from the Electron SDK in the browser for when `nodeIntegration == true`.
 * This allows it to be used without referencing or importing any node specific code which causes bundlers to complain
 */
function nodeStackLineParser(getModule) {
  return [90, node(getModule)];
}


//# sourceMappingURL=stacktrace.js.map


/***/ }),

/***/ 58298:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$G": function() { return /* binding */ truncate; },
/* harmony export */   "U0": function() { return /* binding */ stringMatchesSomePattern; },
/* harmony export */   "nK": function() { return /* binding */ safeJoin; }
/* harmony export */ });
/* unused harmony exports escapeStringForRegex, isMatchingPattern, snipLine */
/* harmony import */ var _is_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(33816);


/**
 * Truncates given string to the maximum characters count
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string (0 = unlimited)
 * @returns string Encoded
 */
function truncate(str, max = 0) {
  if (typeof str !== 'string' || max === 0) {
    return str;
  }
  return str.length <= max ? str : `${str.slice(0, max)}...`;
}

/**
 * This is basically just `trim_line` from
 * https://github.com/getsentry/sentry/blob/master/src/sentry/lang/javascript/processor.py#L67
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string
 * @returns string Encoded
 */
function snipLine(line, colno) {
  let newLine = line;
  const lineLength = newLine.length;
  if (lineLength <= 150) {
    return newLine;
  }
  if (colno > lineLength) {
    // eslint-disable-next-line no-param-reassign
    colno = lineLength;
  }

  let start = Math.max(colno - 60, 0);
  if (start < 5) {
    start = 0;
  }

  let end = Math.min(start + 140, lineLength);
  if (end > lineLength - 5) {
    end = lineLength;
  }
  if (end === lineLength) {
    start = Math.max(end - 140, 0);
  }

  newLine = newLine.slice(start, end);
  if (start > 0) {
    newLine = `'{snip} ${newLine}`;
  }
  if (end < lineLength) {
    newLine += ' {snip}';
  }

  return newLine;
}

/**
 * Join values in array
 * @param input array of values to be joined together
 * @param delimiter string to be placed in-between values
 * @returns Joined values
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function safeJoin(input, delimiter) {
  if (!Array.isArray(input)) {
    return '';
  }

  const output = [];
  // eslint-disable-next-line @typescript-eslint/prefer-for-of
  for (let i = 0; i < input.length; i++) {
    const value = input[i];
    try {
      output.push(String(value));
    } catch (e) {
      output.push('[value cannot be serialized]');
    }
  }

  return output.join(delimiter);
}

/**
 * Checks if the given value matches a regex or string
 *
 * @param value The string to test
 * @param pattern Either a regex or a string against which `value` will be matched
 * @param requireExactStringMatch If true, `value` must match `pattern` exactly. If false, `value` will match
 * `pattern` if it contains `pattern`. Only applies to string-type patterns.
 */
function isMatchingPattern(
  value,
  pattern,
  requireExactStringMatch = false,
) {
  if (!(0,_is_js__WEBPACK_IMPORTED_MODULE_0__/* .isString */ .HD)(value)) {
    return false;
  }

  if ((0,_is_js__WEBPACK_IMPORTED_MODULE_0__/* .isRegExp */ .Kj)(pattern)) {
    return pattern.test(value);
  }
  if ((0,_is_js__WEBPACK_IMPORTED_MODULE_0__/* .isString */ .HD)(pattern)) {
    return requireExactStringMatch ? value === pattern : value.includes(pattern);
  }

  return false;
}

/**
 * Test the given string against an array of strings and regexes. By default, string matching is done on a
 * substring-inclusion basis rather than a strict equality basis
 *
 * @param testString The string to test
 * @param patterns The patterns against which to test the string
 * @param requireExactStringMatch If true, `testString` must match one of the given string patterns exactly in order to
 * count. If false, `testString` will match a string pattern if it contains that pattern.
 * @returns
 */
function stringMatchesSomePattern(
  testString,
  patterns = [],
  requireExactStringMatch = false,
) {
  return patterns.some(pattern => isMatchingPattern(testString, pattern, requireExactStringMatch));
}

/**
 * Given a string, escape characters which have meaning in the regex grammar, such that the result is safe to feed to
 * `new RegExp()`.
 *
 * Based on https://github.com/sindresorhus/escape-string-regexp. Vendored to a) reduce the size by skipping the runtime
 * type-checking, and b) ensure it gets down-compiled for old versions of Node (the published package only supports Node
 * 12+).
 *
 * @param regexString The string to escape
 * @returns An version of the string with all special regex characters escaped
 */
function escapeStringForRegex(regexString) {
  // escape the hyphen separately so we can also replace it with a unicode literal hyphen, to avoid the problems
  // discussed in https://github.com/sindresorhus/escape-string-regexp/issues/20.
  return regexString.replace(/[|\\{}()[\]^$+*?.]/g, '\\$&').replace(/-/g, '\\x2d');
}


//# sourceMappingURL=string.js.map


/***/ }),

/***/ 13081:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ak": function() { return /* binding */ supportsFetch; },
/* harmony export */   "Bf": function() { return /* binding */ supportsHistory; },
/* harmony export */   "Du": function() { return /* binding */ isNativeFetch; },
/* harmony export */   "t$": function() { return /* binding */ supportsNativeFetch; }
/* harmony export */ });
/* unused harmony exports supportsDOMError, supportsDOMException, supportsErrorEvent, supportsReferrerPolicy, supportsReportingObserver */
/* harmony import */ var _logger_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23680);
/* harmony import */ var _worldwide_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62000);



// eslint-disable-next-line deprecation/deprecation
const WINDOW = (0,_worldwide_js__WEBPACK_IMPORTED_MODULE_0__/* .getGlobalObject */ .Rf)();

/**
 * Tells whether current environment supports ErrorEvent objects
 * {@link supportsErrorEvent}.
 *
 * @returns Answer to the given question.
 */
function supportsErrorEvent() {
  try {
    new ErrorEvent('');
    return true;
  } catch (e) {
    return false;
  }
}

/**
 * Tells whether current environment supports DOMError objects
 * {@link supportsDOMError}.
 *
 * @returns Answer to the given question.
 */
function supportsDOMError() {
  try {
    // Chrome: VM89:1 Uncaught TypeError: Failed to construct 'DOMError':
    // 1 argument required, but only 0 present.
    // @ts-ignore It really needs 1 argument, not 0.
    new DOMError('');
    return true;
  } catch (e) {
    return false;
  }
}

/**
 * Tells whether current environment supports DOMException objects
 * {@link supportsDOMException}.
 *
 * @returns Answer to the given question.
 */
function supportsDOMException() {
  try {
    new DOMException('');
    return true;
  } catch (e) {
    return false;
  }
}

/**
 * Tells whether current environment supports Fetch API
 * {@link supportsFetch}.
 *
 * @returns Answer to the given question.
 */
function supportsFetch() {
  if (!('fetch' in WINDOW)) {
    return false;
  }

  try {
    new Headers();
    new Request('http://www.example.com');
    new Response();
    return true;
  } catch (e) {
    return false;
  }
}
/**
 * isNativeFetch checks if the given function is a native implementation of fetch()
 */
// eslint-disable-next-line @typescript-eslint/ban-types
function isNativeFetch(func) {
  return func && /^function fetch\(\)\s+\{\s+\[native code\]\s+\}$/.test(func.toString());
}

/**
 * Tells whether current environment supports Fetch API natively
 * {@link supportsNativeFetch}.
 *
 * @returns true if `window.fetch` is natively implemented, false otherwise
 */
function supportsNativeFetch() {
  if (!supportsFetch()) {
    return false;
  }

  // Fast path to avoid DOM I/O
  // eslint-disable-next-line @typescript-eslint/unbound-method
  if (isNativeFetch(WINDOW.fetch)) {
    return true;
  }

  // window.fetch is implemented, but is polyfilled or already wrapped (e.g: by a chrome extension)
  // so create a "pure" iframe to see if that has native fetch
  let result = false;
  const doc = WINDOW.document;
  // eslint-disable-next-line deprecation/deprecation
  if (doc && typeof (doc.createElement ) === 'function') {
    try {
      const sandbox = doc.createElement('iframe');
      sandbox.hidden = true;
      doc.head.appendChild(sandbox);
      if (sandbox.contentWindow && sandbox.contentWindow.fetch) {
        // eslint-disable-next-line @typescript-eslint/unbound-method
        result = isNativeFetch(sandbox.contentWindow.fetch);
      }
      doc.head.removeChild(sandbox);
    } catch (err) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
        _logger_js__WEBPACK_IMPORTED_MODULE_1__/* .logger.warn */ .kg.warn('Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ', err);
    }
  }

  return result;
}

/**
 * Tells whether current environment supports ReportingObserver API
 * {@link supportsReportingObserver}.
 *
 * @returns Answer to the given question.
 */
function supportsReportingObserver() {
  return 'ReportingObserver' in WINDOW;
}

/**
 * Tells whether current environment supports Referrer Policy API
 * {@link supportsReferrerPolicy}.
 *
 * @returns Answer to the given question.
 */
function supportsReferrerPolicy() {
  // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default'
  // (see https://caniuse.com/#feat=referrer-policy),
  // it doesn't. And it throws an exception instead of ignoring this parameter...
  // REF: https://github.com/getsentry/raven-js/issues/1233

  if (!supportsFetch()) {
    return false;
  }

  try {
    new Request('_', {
      referrerPolicy: 'origin' ,
    });
    return true;
  } catch (e) {
    return false;
  }
}

/**
 * Tells whether current environment supports History API
 * {@link supportsHistory}.
 *
 * @returns Answer to the given question.
 */
function supportsHistory() {
  // NOTE: in Chrome App environment, touching history.pushState, *even inside
  //       a try/catch block*, will cause Chrome to output an error to console.error
  // borrowed from: https://github.com/angular/angular.js/pull/13945/files
  /* eslint-disable @typescript-eslint/no-unsafe-member-access */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const chrome = (WINDOW ).chrome;
  const isChromePackagedApp = chrome && chrome.app && chrome.app.runtime;
  /* eslint-enable @typescript-eslint/no-unsafe-member-access */
  const hasHistoryApi = 'history' in WINDOW && !!WINDOW.history.pushState && !!WINDOW.history.replaceState;

  return !isChromePackagedApp && hasHistoryApi;
}


//# sourceMappingURL=supports.js.map


/***/ }),

/***/ 31647:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$2": function() { return /* binding */ rejectedSyncPromise; },
/* harmony export */   "WD": function() { return /* binding */ resolvedSyncPromise; },
/* harmony export */   "cW": function() { return /* binding */ SyncPromise; }
/* harmony export */ });
/* harmony import */ var _is_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(33816);


/* eslint-disable @typescript-eslint/explicit-function-return-type */

/** SyncPromise internal states */
var States; (function (States) {
  /** Pending */
  const PENDING = 0; States[States["PENDING"] = PENDING] = "PENDING";
  /** Resolved / OK */
  const RESOLVED = 1; States[States["RESOLVED"] = RESOLVED] = "RESOLVED";
  /** Rejected / Error */
  const REJECTED = 2; States[States["REJECTED"] = REJECTED] = "REJECTED";
})(States || (States = {}));

// Overloads so we can call resolvedSyncPromise without arguments and generic argument

/**
 * Creates a resolved sync promise.
 *
 * @param value the value to resolve the promise with
 * @returns the resolved sync promise
 */
function resolvedSyncPromise(value) {
  return new SyncPromise(resolve => {
    resolve(value);
  });
}

/**
 * Creates a rejected sync promise.
 *
 * @param value the value to reject the promise with
 * @returns the rejected sync promise
 */
function rejectedSyncPromise(reason) {
  return new SyncPromise((_, reject) => {
    reject(reason);
  });
}

/**
 * Thenable class that behaves like a Promise and follows it's interface
 * but is not async internally
 */
class SyncPromise {
   __init() {this._state = States.PENDING;}
   __init2() {this._handlers = [];}

   constructor(
    executor,
  ) {SyncPromise.prototype.__init.call(this);SyncPromise.prototype.__init2.call(this);SyncPromise.prototype.__init3.call(this);SyncPromise.prototype.__init4.call(this);SyncPromise.prototype.__init5.call(this);SyncPromise.prototype.__init6.call(this);
    try {
      executor(this._resolve, this._reject);
    } catch (e) {
      this._reject(e);
    }
  }

  /** JSDoc */
   then(
    onfulfilled,
    onrejected,
  ) {
    return new SyncPromise((resolve, reject) => {
      this._handlers.push([
        false,
        result => {
          if (!onfulfilled) {
            // TODO: ¯\_(ツ)_/¯
            // TODO: FIXME
            resolve(result );
          } else {
            try {
              resolve(onfulfilled(result));
            } catch (e) {
              reject(e);
            }
          }
        },
        reason => {
          if (!onrejected) {
            reject(reason);
          } else {
            try {
              resolve(onrejected(reason));
            } catch (e) {
              reject(e);
            }
          }
        },
      ]);
      this._executeHandlers();
    });
  }

  /** JSDoc */
   catch(
    onrejected,
  ) {
    return this.then(val => val, onrejected);
  }

  /** JSDoc */
   finally(onfinally) {
    return new SyncPromise((resolve, reject) => {
      let val;
      let isRejected;

      return this.then(
        value => {
          isRejected = false;
          val = value;
          if (onfinally) {
            onfinally();
          }
        },
        reason => {
          isRejected = true;
          val = reason;
          if (onfinally) {
            onfinally();
          }
        },
      ).then(() => {
        if (isRejected) {
          reject(val);
          return;
        }

        resolve(val );
      });
    });
  }

  /** JSDoc */
    __init3() {this._resolve = (value) => {
    this._setResult(States.RESOLVED, value);
  };}

  /** JSDoc */
    __init4() {this._reject = (reason) => {
    this._setResult(States.REJECTED, reason);
  };}

  /** JSDoc */
    __init5() {this._setResult = (state, value) => {
    if (this._state !== States.PENDING) {
      return;
    }

    if ((0,_is_js__WEBPACK_IMPORTED_MODULE_0__/* .isThenable */ .J8)(value)) {
      void (value ).then(this._resolve, this._reject);
      return;
    }

    this._state = state;
    this._value = value;

    this._executeHandlers();
  };}

  /** JSDoc */
    __init6() {this._executeHandlers = () => {
    if (this._state === States.PENDING) {
      return;
    }

    const cachedHandlers = this._handlers.slice();
    this._handlers = [];

    cachedHandlers.forEach(handler => {
      if (handler[0]) {
        return;
      }

      if (this._state === States.RESOLVED) {
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        handler[1](this._value );
      }

      if (this._state === States.REJECTED) {
        handler[2](this._value);
      }

      handler[0] = true;
    });
  };}
}


//# sourceMappingURL=syncpromise.js.map


/***/ }),

/***/ 27447:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z1": function() { return /* binding */ browserPerformanceTimeOrigin; },
/* harmony export */   "_I": function() { return /* binding */ timestampWithMs; },
/* harmony export */   "ph": function() { return /* binding */ timestampInSeconds; },
/* harmony export */   "yW": function() { return /* binding */ dateTimestampInSeconds; }
/* harmony export */ });
/* unused harmony exports _browserPerformanceTimeOriginMode, usingPerformanceAPI */
/* harmony import */ var _node_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(70302);
/* harmony import */ var _worldwide_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62000);
/* module decorator */ module = __webpack_require__.hmd(module);



// eslint-disable-next-line deprecation/deprecation
const WINDOW = (0,_worldwide_js__WEBPACK_IMPORTED_MODULE_0__/* .getGlobalObject */ .Rf)();

/**
 * An object that can return the current timestamp in seconds since the UNIX epoch.
 */

/**
 * A TimestampSource implementation for environments that do not support the Performance Web API natively.
 *
 * Note that this TimestampSource does not use a monotonic clock. A call to `nowSeconds` may return a timestamp earlier
 * than a previously returned value. We do not try to emulate a monotonic behavior in order to facilitate debugging. It
 * is more obvious to explain "why does my span have negative duration" than "why my spans have zero duration".
 */
const dateTimestampSource = {
  nowSeconds: () => Date.now() / 1000,
};

/**
 * A partial definition of the [Performance Web API]{@link https://developer.mozilla.org/en-US/docs/Web/API/Performance}
 * for accessing a high-resolution monotonic clock.
 */

/**
 * Returns a wrapper around the native Performance API browser implementation, or undefined for browsers that do not
 * support the API.
 *
 * Wrapping the native API works around differences in behavior from different browsers.
 */
function getBrowserPerformance() {
  const { performance } = WINDOW;
  if (!performance || !performance.now) {
    return undefined;
  }

  // Replace performance.timeOrigin with our own timeOrigin based on Date.now().
  //
  // This is a partial workaround for browsers reporting performance.timeOrigin such that performance.timeOrigin +
  // performance.now() gives a date arbitrarily in the past.
  //
  // Additionally, computing timeOrigin in this way fills the gap for browsers where performance.timeOrigin is
  // undefined.
  //
  // The assumption that performance.timeOrigin + performance.now() ~= Date.now() is flawed, but we depend on it to
  // interact with data coming out of performance entries.
  //
  // Note that despite recommendations against it in the spec, browsers implement the Performance API with a clock that
  // might stop when the computer is asleep (and perhaps under other circumstances). Such behavior causes
  // performance.timeOrigin + performance.now() to have an arbitrary skew over Date.now(). In laptop computers, we have
  // observed skews that can be as long as days, weeks or months.
  //
  // See https://github.com/getsentry/sentry-javascript/issues/2590.
  //
  // BUG: despite our best intentions, this workaround has its limitations. It mostly addresses timings of pageload
  // transactions, but ignores the skew built up over time that can aversely affect timestamps of navigation
  // transactions of long-lived web pages.
  const timeOrigin = Date.now() - performance.now();

  return {
    now: () => performance.now(),
    timeOrigin,
  };
}

/**
 * Returns the native Performance API implementation from Node.js. Returns undefined in old Node.js versions that don't
 * implement the API.
 */
function getNodePerformance() {
  try {
    const perfHooks = (0,_node_js__WEBPACK_IMPORTED_MODULE_1__/* .dynamicRequire */ .l$)(module, 'perf_hooks') ;
    return perfHooks.performance;
  } catch (_) {
    return undefined;
  }
}

/**
 * The Performance API implementation for the current platform, if available.
 */
const platformPerformance = (0,_node_js__WEBPACK_IMPORTED_MODULE_1__/* .isNodeEnv */ .KV)() ? getNodePerformance() : getBrowserPerformance();

const timestampSource =
  platformPerformance === undefined
    ? dateTimestampSource
    : {
        nowSeconds: () => (platformPerformance.timeOrigin + platformPerformance.now()) / 1000,
      };

/**
 * Returns a timestamp in seconds since the UNIX epoch using the Date API.
 */
const dateTimestampInSeconds = dateTimestampSource.nowSeconds.bind(dateTimestampSource);

/**
 * Returns a timestamp in seconds since the UNIX epoch using either the Performance or Date APIs, depending on the
 * availability of the Performance API.
 *
 * See `usingPerformanceAPI` to test whether the Performance API is used.
 *
 * BUG: Note that because of how browsers implement the Performance API, the clock might stop when the computer is
 * asleep. This creates a skew between `dateTimestampInSeconds` and `timestampInSeconds`. The
 * skew can grow to arbitrary amounts like days, weeks or months.
 * See https://github.com/getsentry/sentry-javascript/issues/2590.
 */
const timestampInSeconds = timestampSource.nowSeconds.bind(timestampSource);

// Re-exported with an old name for backwards-compatibility.
const timestampWithMs = timestampInSeconds;

/**
 * A boolean that is true when timestampInSeconds uses the Performance API to produce monotonic timestamps.
 */
const usingPerformanceAPI = platformPerformance !== undefined;

/**
 * Internal helper to store what is the source of browserPerformanceTimeOrigin below. For debugging only.
 */
let _browserPerformanceTimeOriginMode;

/**
 * The number of milliseconds since the UNIX epoch. This value is only usable in a browser, and only when the
 * performance API is available.
 */
const browserPerformanceTimeOrigin = (() => {
  // Unfortunately browsers may report an inaccurate time origin data, through either performance.timeOrigin or
  // performance.timing.navigationStart, which results in poor results in performance data. We only treat time origin
  // data as reliable if they are within a reasonable threshold of the current time.

  const { performance } = WINDOW;
  if (!performance || !performance.now) {
    _browserPerformanceTimeOriginMode = 'none';
    return undefined;
  }

  const threshold = 3600 * 1000;
  const performanceNow = performance.now();
  const dateNow = Date.now();

  // if timeOrigin isn't available set delta to threshold so it isn't used
  const timeOriginDelta = performance.timeOrigin
    ? Math.abs(performance.timeOrigin + performanceNow - dateNow)
    : threshold;
  const timeOriginIsReliable = timeOriginDelta < threshold;

  // While performance.timing.navigationStart is deprecated in favor of performance.timeOrigin, performance.timeOrigin
  // is not as widely supported. Namely, performance.timeOrigin is undefined in Safari as of writing.
  // Also as of writing, performance.timing is not available in Web Workers in mainstream browsers, so it is not always
  // a valid fallback. In the absence of an initial time provided by the browser, fallback to the current time from the
  // Date API.
  // eslint-disable-next-line deprecation/deprecation
  const navigationStart = performance.timing && performance.timing.navigationStart;
  const hasNavigationStart = typeof navigationStart === 'number';
  // if navigationStart isn't available set delta to threshold so it isn't used
  const navigationStartDelta = hasNavigationStart ? Math.abs(navigationStart + performanceNow - dateNow) : threshold;
  const navigationStartIsReliable = navigationStartDelta < threshold;

  if (timeOriginIsReliable || navigationStartIsReliable) {
    // Use the more reliable time origin
    if (timeOriginDelta <= navigationStartDelta) {
      _browserPerformanceTimeOriginMode = 'timeOrigin';
      return performance.timeOrigin;
    } else {
      _browserPerformanceTimeOriginMode = 'navigationStart';
      return navigationStart;
    }
  }

  // Either both timeOrigin and navigationStart are skewed or neither is available, fallback to Date.
  _browserPerformanceTimeOriginMode = 'dateNow';
  return dateNow;
})();


//# sourceMappingURL=time.js.map


/***/ }),

/***/ 62000:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Rf": function() { return /* binding */ getGlobalObject; },
/* harmony export */   "YO": function() { return /* binding */ getGlobalSingleton; },
/* harmony export */   "n2": function() { return /* binding */ GLOBAL_OBJ; }
/* harmony export */ });
/** Internal global with common properties and Sentry extensions  */

// The code below for 'isGlobalObj' and 'GLOBAL_OBJ' was copied from core-js before modification
// https://github.com/zloirock/core-js/blob/1b944df55282cdc99c90db5f49eb0b6eda2cc0a3/packages/core-js/internals/global.js
// core-js has the following licence:
//
// Copyright (c) 2014-2022 Denis Pushkarev
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.

/** Returns 'obj' if it's the global object, otherwise returns undefined */
function isGlobalObj(obj) {
  return obj && obj.Math == Math ? obj : undefined;
}

/** Get's the global object for the current JavaScript runtime */
const GLOBAL_OBJ =
  (typeof globalThis == 'object' && isGlobalObj(globalThis)) ||
  // eslint-disable-next-line no-restricted-globals
  (typeof window == 'object' && isGlobalObj(window)) ||
  (typeof self == 'object' && isGlobalObj(self)) ||
  (typeof __webpack_require__.g == 'object' && isGlobalObj(__webpack_require__.g)) ||
  (function () {
    return this;
  })() ||
  {};

/**
 * @deprecated Use GLOBAL_OBJ instead or WINDOW from @sentry/browser. This will be removed in v8
 */
function getGlobalObject() {
  return GLOBAL_OBJ ;
}

/**
 * Returns a global singleton contained in the global `__SENTRY__` object.
 *
 * If the singleton doesn't already exist in `__SENTRY__`, it will be created using the given factory
 * function and added to the `__SENTRY__` object.
 *
 * @param name name of the global singleton on __SENTRY__
 * @param creator creator Factory function to create the singleton if it doesn't already exist on `__SENTRY__`
 * @param obj (Optional) The global object on which to look for `__SENTRY__`, if not `GLOBAL_OBJ`'s return value
 * @returns the singleton
 */
function getGlobalSingleton(name, creator, obj) {
  const gbl = (obj || GLOBAL_OBJ) ;
  const __SENTRY__ = (gbl.__SENTRY__ = gbl.__SENTRY__ || {});
  const singleton = __SENTRY__[name] || (__SENTRY__[name] = creator());
  return singleton;
}


//# sourceMappingURL=worldwide.js.map


/***/ }),

/***/ 19705:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

var _global = (typeof window !== 'undefined' ? window : typeof __webpack_require__.g !== 'undefined' ? __webpack_require__.g : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"YxZKe8f07rocFl5miyBQr"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["storefront@byko"]={id:"YxZKe8f07rocFl5miyBQr"};
      

/***/ }),

/***/ 29775:
/***/ (function(module) {

/*! algoliasearch-lite.umd.js | 4.14.3 | © Algolia, inc. | https://github.com/algolia/algoliasearch-client-javascript */
!function(e,t){ true?module.exports=t():0}(this,(function(){"use strict";function e(e,t,r){return t in e?Object.defineProperty(e,t,{value:r,enumerable:!0,configurable:!0,writable:!0}):e[t]=r,e}function t(e,t){var r=Object.keys(e);if(Object.getOwnPropertySymbols){var n=Object.getOwnPropertySymbols(e);t&&(n=n.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),r.push.apply(r,n)}return r}function r(r){for(var n=1;n<arguments.length;n++){var o=null!=arguments[n]?arguments[n]:{};n%2?t(Object(o),!0).forEach((function(t){e(r,t,o[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(r,Object.getOwnPropertyDescriptors(o)):t(Object(o)).forEach((function(e){Object.defineProperty(r,e,Object.getOwnPropertyDescriptor(o,e))}))}return r}function n(e,t){if(null==e)return{};var r,n,o=function(e,t){if(null==e)return{};var r,n,o={},a=Object.keys(e);for(n=0;n<a.length;n++)r=a[n],t.indexOf(r)>=0||(o[r]=e[r]);return o}(e,t);if(Object.getOwnPropertySymbols){var a=Object.getOwnPropertySymbols(e);for(n=0;n<a.length;n++)r=a[n],t.indexOf(r)>=0||Object.prototype.propertyIsEnumerable.call(e,r)&&(o[r]=e[r])}return o}function o(e,t){return function(e){if(Array.isArray(e))return e}(e)||function(e,t){if(!(Symbol.iterator in Object(e)||"[object Arguments]"===Object.prototype.toString.call(e)))return;var r=[],n=!0,o=!1,a=void 0;try{for(var u,i=e[Symbol.iterator]();!(n=(u=i.next()).done)&&(r.push(u.value),!t||r.length!==t);n=!0);}catch(e){o=!0,a=e}finally{try{n||null==i.return||i.return()}finally{if(o)throw a}}return r}(e,t)||function(){throw new TypeError("Invalid attempt to destructure non-iterable instance")}()}function a(e){return function(e){if(Array.isArray(e)){for(var t=0,r=new Array(e.length);t<e.length;t++)r[t]=e[t];return r}}(e)||function(e){if(Symbol.iterator in Object(e)||"[object Arguments]"===Object.prototype.toString.call(e))return Array.from(e)}(e)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance")}()}function u(e){var t,r="algoliasearch-client-js-".concat(e.key),n=function(){return void 0===t&&(t=e.localStorage||window.localStorage),t},a=function(){return JSON.parse(n().getItem(r)||"{}")};return{get:function(e,t){var r=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{miss:function(){return Promise.resolve()}};return Promise.resolve().then((function(){var r=JSON.stringify(e),n=a()[r];return Promise.all([n||t(),void 0!==n])})).then((function(e){var t=o(e,2),n=t[0],a=t[1];return Promise.all([n,a||r.miss(n)])})).then((function(e){return o(e,1)[0]}))},set:function(e,t){return Promise.resolve().then((function(){var o=a();return o[JSON.stringify(e)]=t,n().setItem(r,JSON.stringify(o)),t}))},delete:function(e){return Promise.resolve().then((function(){var t=a();delete t[JSON.stringify(e)],n().setItem(r,JSON.stringify(t))}))},clear:function(){return Promise.resolve().then((function(){n().removeItem(r)}))}}}function i(e){var t=a(e.caches),r=t.shift();return void 0===r?{get:function(e,t){var r=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{miss:function(){return Promise.resolve()}},n=t();return n.then((function(e){return Promise.all([e,r.miss(e)])})).then((function(e){return o(e,1)[0]}))},set:function(e,t){return Promise.resolve(t)},delete:function(e){return Promise.resolve()},clear:function(){return Promise.resolve()}}:{get:function(e,n){var o=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{miss:function(){return Promise.resolve()}};return r.get(e,n,o).catch((function(){return i({caches:t}).get(e,n,o)}))},set:function(e,n){return r.set(e,n).catch((function(){return i({caches:t}).set(e,n)}))},delete:function(e){return r.delete(e).catch((function(){return i({caches:t}).delete(e)}))},clear:function(){return r.clear().catch((function(){return i({caches:t}).clear()}))}}}function s(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{serializable:!0},t={};return{get:function(r,n){var o=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{miss:function(){return Promise.resolve()}},a=JSON.stringify(r);if(a in t)return Promise.resolve(e.serializable?JSON.parse(t[a]):t[a]);var u=n(),i=o&&o.miss||function(){return Promise.resolve()};return u.then((function(e){return i(e)})).then((function(){return u}))},set:function(r,n){return t[JSON.stringify(r)]=e.serializable?JSON.stringify(n):n,Promise.resolve(n)},delete:function(e){return delete t[JSON.stringify(e)],Promise.resolve()},clear:function(){return t={},Promise.resolve()}}}function c(e){for(var t=e.length-1;t>0;t--){var r=Math.floor(Math.random()*(t+1)),n=e[t];e[t]=e[r],e[r]=n}return e}function l(e,t){return t?(Object.keys(t).forEach((function(r){e[r]=t[r](e)})),e):e}function f(e){for(var t=arguments.length,r=new Array(t>1?t-1:0),n=1;n<t;n++)r[n-1]=arguments[n];var o=0;return e.replace(/%s/g,(function(){return encodeURIComponent(r[o++])}))}var h={WithinQueryParameters:0,WithinHeaders:1};function d(e,t){var r=e||{},n=r.data||{};return Object.keys(r).forEach((function(e){-1===["timeout","headers","queryParameters","data","cacheable"].indexOf(e)&&(n[e]=r[e])})),{data:Object.entries(n).length>0?n:void 0,timeout:r.timeout||t,headers:r.headers||{},queryParameters:r.queryParameters||{},cacheable:r.cacheable}}var m={Read:1,Write:2,Any:3},p=1,v=2,y=3;function g(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:p;return r(r({},e),{},{status:t,lastUpdate:Date.now()})}function b(e){return"string"==typeof e?{protocol:"https",url:e,accept:m.Any}:{protocol:e.protocol||"https",url:e.url,accept:e.accept||m.Any}}var O="GET",P="POST";function q(e,t){return Promise.all(t.map((function(t){return e.get(t,(function(){return Promise.resolve(g(t))}))}))).then((function(e){var r=e.filter((function(e){return function(e){return e.status===p||Date.now()-e.lastUpdate>12e4}(e)})),n=e.filter((function(e){return function(e){return e.status===y&&Date.now()-e.lastUpdate<=12e4}(e)})),o=[].concat(a(r),a(n));return{getTimeout:function(e,t){return(0===n.length&&0===e?1:n.length+3+e)*t},statelessHosts:o.length>0?o.map((function(e){return b(e)})):t}}))}function w(e,t,n,o){var u=[],i=function(e,t){if(e.method===O||void 0===e.data&&void 0===t.data)return;var n=Array.isArray(e.data)?e.data:r(r({},e.data),t.data);return JSON.stringify(n)}(n,o),s=function(e,t){var n=r(r({},e.headers),t.headers),o={};return Object.keys(n).forEach((function(e){var t=n[e];o[e.toLowerCase()]=t})),o}(e,o),c=n.method,l=n.method!==O?{}:r(r({},n.data),o.data),f=r(r(r({"x-algolia-agent":e.userAgent.value},e.queryParameters),l),o.queryParameters),h=0,d=function t(r,a){var l=r.pop();if(void 0===l)throw{name:"RetryError",message:"Unreachable hosts - your application id may be incorrect. If the error persists, contact support@algolia.com.",transporterStackTrace:A(u)};var d={data:i,headers:s,method:c,url:S(l,n.path,f),connectTimeout:a(h,e.timeouts.connect),responseTimeout:a(h,o.timeout)},m=function(e){var t={request:d,response:e,host:l,triesLeft:r.length};return u.push(t),t},p={onSuccess:function(e){return function(e){try{return JSON.parse(e.content)}catch(t){throw function(e,t){return{name:"DeserializationError",message:e,response:t}}(t.message,e)}}(e)},onRetry:function(n){var o=m(n);return n.isTimedOut&&h++,Promise.all([e.logger.info("Retryable failure",x(o)),e.hostsCache.set(l,g(l,n.isTimedOut?y:v))]).then((function(){return t(r,a)}))},onFail:function(e){throw m(e),function(e,t){var r=e.content,n=e.status,o=r;try{o=JSON.parse(r).message}catch(e){}return function(e,t,r){return{name:"ApiError",message:e,status:t,transporterStackTrace:r}}(o,n,t)}(e,A(u))}};return e.requester.send(d).then((function(e){return function(e,t){return function(e){var t=e.status;return e.isTimedOut||function(e){var t=e.isTimedOut,r=e.status;return!t&&0==~~r}(e)||2!=~~(t/100)&&4!=~~(t/100)}(e)?t.onRetry(e):2==~~(e.status/100)?t.onSuccess(e):t.onFail(e)}(e,p)}))};return q(e.hostsCache,t).then((function(e){return d(a(e.statelessHosts).reverse(),e.getTimeout)}))}function j(e){var t={value:"Algolia for JavaScript (".concat(e,")"),add:function(e){var r="; ".concat(e.segment).concat(void 0!==e.version?" (".concat(e.version,")"):"");return-1===t.value.indexOf(r)&&(t.value="".concat(t.value).concat(r)),t}};return t}function S(e,t,r){var n=T(r),o="".concat(e.protocol,"://").concat(e.url,"/").concat("/"===t.charAt(0)?t.substr(1):t);return n.length&&(o+="?".concat(n)),o}function T(e){return Object.keys(e).map((function(t){return f("%s=%s",t,(r=e[t],"[object Object]"===Object.prototype.toString.call(r)||"[object Array]"===Object.prototype.toString.call(r)?JSON.stringify(e[t]):e[t]));var r})).join("&")}function A(e){return e.map((function(e){return x(e)}))}function x(e){var t=e.request.headers["x-algolia-api-key"]?{"x-algolia-api-key":"*****"}:{};return r(r({},e),{},{request:r(r({},e.request),{},{headers:r(r({},e.request.headers),t)})})}var N=function(e){var t=e.appId,n=function(e,t,r){var n={"x-algolia-api-key":r,"x-algolia-application-id":t};return{headers:function(){return e===h.WithinHeaders?n:{}},queryParameters:function(){return e===h.WithinQueryParameters?n:{}}}}(void 0!==e.authMode?e.authMode:h.WithinHeaders,t,e.apiKey),a=function(e){var t=e.hostsCache,r=e.logger,n=e.requester,a=e.requestsCache,u=e.responsesCache,i=e.timeouts,s=e.userAgent,c=e.hosts,l=e.queryParameters,f={hostsCache:t,logger:r,requester:n,requestsCache:a,responsesCache:u,timeouts:i,userAgent:s,headers:e.headers,queryParameters:l,hosts:c.map((function(e){return b(e)})),read:function(e,t){var r=d(t,f.timeouts.read),n=function(){return w(f,f.hosts.filter((function(e){return 0!=(e.accept&m.Read)})),e,r)};if(!0!==(void 0!==r.cacheable?r.cacheable:e.cacheable))return n();var a={request:e,mappedRequestOptions:r,transporter:{queryParameters:f.queryParameters,headers:f.headers}};return f.responsesCache.get(a,(function(){return f.requestsCache.get(a,(function(){return f.requestsCache.set(a,n()).then((function(e){return Promise.all([f.requestsCache.delete(a),e])}),(function(e){return Promise.all([f.requestsCache.delete(a),Promise.reject(e)])})).then((function(e){var t=o(e,2);t[0];return t[1]}))}))}),{miss:function(e){return f.responsesCache.set(a,e)}})},write:function(e,t){return w(f,f.hosts.filter((function(e){return 0!=(e.accept&m.Write)})),e,d(t,f.timeouts.write))}};return f}(r(r({hosts:[{url:"".concat(t,"-dsn.algolia.net"),accept:m.Read},{url:"".concat(t,".algolia.net"),accept:m.Write}].concat(c([{url:"".concat(t,"-1.algolianet.com")},{url:"".concat(t,"-2.algolianet.com")},{url:"".concat(t,"-3.algolianet.com")}]))},e),{},{headers:r(r(r({},n.headers()),{"content-type":"application/x-www-form-urlencoded"}),e.headers),queryParameters:r(r({},n.queryParameters()),e.queryParameters)}));return l({transporter:a,appId:t,addAlgoliaAgent:function(e,t){a.userAgent.add({segment:e,version:t})},clearCache:function(){return Promise.all([a.requestsCache.clear(),a.responsesCache.clear()]).then((function(){}))}},e.methods)},C=function(e){return function(t,r){return t.method===O?e.transporter.read(t,r):e.transporter.write(t,r)}},k=function(e){return function(t){var r=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},n={transporter:e.transporter,appId:e.appId,indexName:t};return l(n,r.methods)}},J=function(e){return function(t,n){var o=t.map((function(e){return r(r({},e),{},{params:T(e.params||{})})}));return e.transporter.read({method:P,path:"1/indexes/*/queries",data:{requests:o},cacheable:!0},n)}},E=function(e){return function(t,o){return Promise.all(t.map((function(t){var a=t.params,u=a.facetName,i=a.facetQuery,s=n(a,["facetName","facetQuery"]);return k(e)(t.indexName,{methods:{searchForFacetValues:R}}).searchForFacetValues(u,i,r(r({},o),s))})))}},I=function(e){return function(t,r,n){return e.transporter.read({method:P,path:f("1/answers/%s/prediction",e.indexName),data:{query:t,queryLanguages:r},cacheable:!0},n)}},F=function(e){return function(t,r){return e.transporter.read({method:P,path:f("1/indexes/%s/query",e.indexName),data:{query:t},cacheable:!0},r)}},R=function(e){return function(t,r,n){return e.transporter.read({method:P,path:f("1/indexes/%s/facets/%s/query",e.indexName,t),data:{facetQuery:r},cacheable:!0},n)}},D=1,W=2,H=3;function Q(e,t,n){var o,a={appId:e,apiKey:t,timeouts:{connect:1,read:2,write:30},requester:{send:function(e){return new Promise((function(t){var r=new XMLHttpRequest;r.open(e.method,e.url,!0),Object.keys(e.headers).forEach((function(t){return r.setRequestHeader(t,e.headers[t])}));var n,o=function(e,n){return setTimeout((function(){r.abort(),t({status:0,content:n,isTimedOut:!0})}),1e3*e)},a=o(e.connectTimeout,"Connection timeout");r.onreadystatechange=function(){r.readyState>r.OPENED&&void 0===n&&(clearTimeout(a),n=o(e.responseTimeout,"Socket timeout"))},r.onerror=function(){0===r.status&&(clearTimeout(a),clearTimeout(n),t({content:r.responseText||"Network request failed",status:r.status,isTimedOut:!1}))},r.onload=function(){clearTimeout(a),clearTimeout(n),t({content:r.responseText,status:r.status,isTimedOut:!1})},r.send(e.data)}))}},logger:(o=H,{debug:function(e,t){return D>=o&&console.debug(e,t),Promise.resolve()},info:function(e,t){return W>=o&&console.info(e,t),Promise.resolve()},error:function(e,t){return console.error(e,t),Promise.resolve()}}),responsesCache:s(),requestsCache:s({serializable:!1}),hostsCache:i({caches:[u({key:"".concat("4.14.3","-").concat(e)}),s()]}),userAgent:j("4.14.3").add({segment:"Browser",version:"lite"}),authMode:h.WithinQueryParameters};return N(r(r(r({},a),n),{},{methods:{search:J,searchForFacetValues:E,multipleQueries:J,multipleSearchForFacetValues:E,customRequest:C,initIndex:function(e){return function(t){return k(e)(t,{methods:{search:F,searchForFacetValues:R,findAnswers:I}})}}}}))}return Q.version="4.14.3",Q}));


/***/ }),

/***/ 22873:
/***/ (function(module) {

/*! algoliasearch.umd.js | 4.14.3 | © Algolia, inc. | https://github.com/algolia/algoliasearch-client-javascript */
!function(t,e){ true?module.exports=e():0}(this,(function(){"use strict";function t(t,e,r){return e in t?Object.defineProperty(t,e,{value:r,enumerable:!0,configurable:!0,writable:!0}):t[e]=r,t}function e(t,e){var r=Object.keys(t);if(Object.getOwnPropertySymbols){var n=Object.getOwnPropertySymbols(t);e&&(n=n.filter((function(e){return Object.getOwnPropertyDescriptor(t,e).enumerable}))),r.push.apply(r,n)}return r}function r(r){for(var n=1;n<arguments.length;n++){var a=null!=arguments[n]?arguments[n]:{};n%2?e(Object(a),!0).forEach((function(e){t(r,e,a[e])})):Object.getOwnPropertyDescriptors?Object.defineProperties(r,Object.getOwnPropertyDescriptors(a)):e(Object(a)).forEach((function(t){Object.defineProperty(r,t,Object.getOwnPropertyDescriptor(a,t))}))}return r}function n(t,e){if(null==t)return{};var r,n,a=function(t,e){if(null==t)return{};var r,n,a={},o=Object.keys(t);for(n=0;n<o.length;n++)r=o[n],e.indexOf(r)>=0||(a[r]=t[r]);return a}(t,e);if(Object.getOwnPropertySymbols){var o=Object.getOwnPropertySymbols(t);for(n=0;n<o.length;n++)r=o[n],e.indexOf(r)>=0||Object.prototype.propertyIsEnumerable.call(t,r)&&(a[r]=t[r])}return a}function a(t,e){return function(t){if(Array.isArray(t))return t}(t)||function(t,e){if(!(Symbol.iterator in Object(t)||"[object Arguments]"===Object.prototype.toString.call(t)))return;var r=[],n=!0,a=!1,o=void 0;try{for(var i,u=t[Symbol.iterator]();!(n=(i=u.next()).done)&&(r.push(i.value),!e||r.length!==e);n=!0);}catch(t){a=!0,o=t}finally{try{n||null==u.return||u.return()}finally{if(a)throw o}}return r}(t,e)||function(){throw new TypeError("Invalid attempt to destructure non-iterable instance")}()}function o(t){return function(t){if(Array.isArray(t)){for(var e=0,r=new Array(t.length);e<t.length;e++)r[e]=t[e];return r}}(t)||function(t){if(Symbol.iterator in Object(t)||"[object Arguments]"===Object.prototype.toString.call(t))return Array.from(t)}(t)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance")}()}function i(t){var e,r="algoliasearch-client-js-".concat(t.key),n=function(){return void 0===e&&(e=t.localStorage||window.localStorage),e},o=function(){return JSON.parse(n().getItem(r)||"{}")};return{get:function(t,e){var r=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{miss:function(){return Promise.resolve()}};return Promise.resolve().then((function(){var r=JSON.stringify(t),n=o()[r];return Promise.all([n||e(),void 0!==n])})).then((function(t){var e=a(t,2),n=e[0],o=e[1];return Promise.all([n,o||r.miss(n)])})).then((function(t){return a(t,1)[0]}))},set:function(t,e){return Promise.resolve().then((function(){var a=o();return a[JSON.stringify(t)]=e,n().setItem(r,JSON.stringify(a)),e}))},delete:function(t){return Promise.resolve().then((function(){var e=o();delete e[JSON.stringify(t)],n().setItem(r,JSON.stringify(e))}))},clear:function(){return Promise.resolve().then((function(){n().removeItem(r)}))}}}function u(t){var e=o(t.caches),r=e.shift();return void 0===r?{get:function(t,e){var r=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{miss:function(){return Promise.resolve()}},n=e();return n.then((function(t){return Promise.all([t,r.miss(t)])})).then((function(t){return a(t,1)[0]}))},set:function(t,e){return Promise.resolve(e)},delete:function(t){return Promise.resolve()},clear:function(){return Promise.resolve()}}:{get:function(t,n){var a=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{miss:function(){return Promise.resolve()}};return r.get(t,n,a).catch((function(){return u({caches:e}).get(t,n,a)}))},set:function(t,n){return r.set(t,n).catch((function(){return u({caches:e}).set(t,n)}))},delete:function(t){return r.delete(t).catch((function(){return u({caches:e}).delete(t)}))},clear:function(){return r.clear().catch((function(){return u({caches:e}).clear()}))}}}function s(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{serializable:!0},e={};return{get:function(r,n){var a=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{miss:function(){return Promise.resolve()}},o=JSON.stringify(r);if(o in e)return Promise.resolve(t.serializable?JSON.parse(e[o]):e[o]);var i=n(),u=a&&a.miss||function(){return Promise.resolve()};return i.then((function(t){return u(t)})).then((function(){return i}))},set:function(r,n){return e[JSON.stringify(r)]=t.serializable?JSON.stringify(n):n,Promise.resolve(n)},delete:function(t){return delete e[JSON.stringify(t)],Promise.resolve()},clear:function(){return e={},Promise.resolve()}}}function c(t,e,r){var n={"x-algolia-api-key":r,"x-algolia-application-id":e};return{headers:function(){return t===m.WithinHeaders?n:{}},queryParameters:function(){return t===m.WithinQueryParameters?n:{}}}}function f(t){var e=0;return t((function r(){return e++,new Promise((function(n){setTimeout((function(){n(t(r))}),Math.min(100*e,1e3))}))}))}function d(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:function(t,e){return Promise.resolve()};return Object.assign(t,{wait:function(r){return d(t.then((function(t){return Promise.all([e(t,r),t])})).then((function(t){return t[1]})))}})}function l(t){for(var e=t.length-1;e>0;e--){var r=Math.floor(Math.random()*(e+1)),n=t[e];t[e]=t[r],t[r]=n}return t}function p(t,e){return e?(Object.keys(e).forEach((function(r){t[r]=e[r](t)})),t):t}function h(t){for(var e=arguments.length,r=new Array(e>1?e-1:0),n=1;n<e;n++)r[n-1]=arguments[n];var a=0;return t.replace(/%s/g,(function(){return encodeURIComponent(r[a++])}))}var m={WithinQueryParameters:0,WithinHeaders:1};function y(t,e){var r=t||{},n=r.data||{};return Object.keys(r).forEach((function(t){-1===["timeout","headers","queryParameters","data","cacheable"].indexOf(t)&&(n[t]=r[t])})),{data:Object.entries(n).length>0?n:void 0,timeout:r.timeout||e,headers:r.headers||{},queryParameters:r.queryParameters||{},cacheable:r.cacheable}}var g={Read:1,Write:2,Any:3},v=1,b=2,P=3;function w(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:v;return r(r({},t),{},{status:e,lastUpdate:Date.now()})}function O(t){return"string"==typeof t?{protocol:"https",url:t,accept:g.Any}:{protocol:t.protocol||"https",url:t.url,accept:t.accept||g.Any}}var I="DELETE",x="GET",j="POST",D="PUT";function q(t,e){return Promise.all(e.map((function(e){return t.get(e,(function(){return Promise.resolve(w(e))}))}))).then((function(t){var r=t.filter((function(t){return function(t){return t.status===v||Date.now()-t.lastUpdate>12e4}(t)})),n=t.filter((function(t){return function(t){return t.status===P&&Date.now()-t.lastUpdate<=12e4}(t)})),a=[].concat(o(r),o(n));return{getTimeout:function(t,e){return(0===n.length&&0===t?1:n.length+3+t)*e},statelessHosts:a.length>0?a.map((function(t){return O(t)})):e}}))}function S(t,e,n,a){var i=[],u=function(t,e){if(t.method===x||void 0===t.data&&void 0===e.data)return;var n=Array.isArray(t.data)?t.data:r(r({},t.data),e.data);return JSON.stringify(n)}(n,a),s=function(t,e){var n=r(r({},t.headers),e.headers),a={};return Object.keys(n).forEach((function(t){var e=n[t];a[t.toLowerCase()]=e})),a}(t,a),c=n.method,f=n.method!==x?{}:r(r({},n.data),a.data),d=r(r(r({"x-algolia-agent":t.userAgent.value},t.queryParameters),f),a.queryParameters),l=0,p=function e(r,o){var f=r.pop();if(void 0===f)throw{name:"RetryError",message:"Unreachable hosts - your application id may be incorrect. If the error persists, contact support@algolia.com.",transporterStackTrace:R(i)};var p={data:u,headers:s,method:c,url:N(f,n.path,d),connectTimeout:o(l,t.timeouts.connect),responseTimeout:o(l,a.timeout)},h=function(t){var e={request:p,response:t,host:f,triesLeft:r.length};return i.push(e),e},m={onSuccess:function(t){return function(t){try{return JSON.parse(t.content)}catch(e){throw function(t,e){return{name:"DeserializationError",message:t,response:e}}(e.message,t)}}(t)},onRetry:function(n){var a=h(n);return n.isTimedOut&&l++,Promise.all([t.logger.info("Retryable failure",A(a)),t.hostsCache.set(f,w(f,n.isTimedOut?P:b))]).then((function(){return e(r,o)}))},onFail:function(t){throw h(t),function(t,e){var r=t.content,n=t.status,a=r;try{a=JSON.parse(r).message}catch(t){}return function(t,e,r){return{name:"ApiError",message:t,status:e,transporterStackTrace:r}}(a,n,e)}(t,R(i))}};return t.requester.send(p).then((function(t){return function(t,e){return function(t){var e=t.status;return t.isTimedOut||function(t){var e=t.isTimedOut,r=t.status;return!e&&0==~~r}(t)||2!=~~(e/100)&&4!=~~(e/100)}(t)?e.onRetry(t):2==~~(t.status/100)?e.onSuccess(t):e.onFail(t)}(t,m)}))};return q(t.hostsCache,e).then((function(t){return p(o(t.statelessHosts).reverse(),t.getTimeout)}))}function k(t){var e=t.hostsCache,r=t.logger,n=t.requester,o=t.requestsCache,i=t.responsesCache,u=t.timeouts,s=t.userAgent,c=t.hosts,f=t.queryParameters,d={hostsCache:e,logger:r,requester:n,requestsCache:o,responsesCache:i,timeouts:u,userAgent:s,headers:t.headers,queryParameters:f,hosts:c.map((function(t){return O(t)})),read:function(t,e){var r=y(e,d.timeouts.read),n=function(){return S(d,d.hosts.filter((function(t){return 0!=(t.accept&g.Read)})),t,r)};if(!0!==(void 0!==r.cacheable?r.cacheable:t.cacheable))return n();var o={request:t,mappedRequestOptions:r,transporter:{queryParameters:d.queryParameters,headers:d.headers}};return d.responsesCache.get(o,(function(){return d.requestsCache.get(o,(function(){return d.requestsCache.set(o,n()).then((function(t){return Promise.all([d.requestsCache.delete(o),t])}),(function(t){return Promise.all([d.requestsCache.delete(o),Promise.reject(t)])})).then((function(t){var e=a(t,2);e[0];return e[1]}))}))}),{miss:function(t){return d.responsesCache.set(o,t)}})},write:function(t,e){return S(d,d.hosts.filter((function(t){return 0!=(t.accept&g.Write)})),t,y(e,d.timeouts.write))}};return d}function T(t){var e={value:"Algolia for JavaScript (".concat(t,")"),add:function(t){var r="; ".concat(t.segment).concat(void 0!==t.version?" (".concat(t.version,")"):"");return-1===e.value.indexOf(r)&&(e.value="".concat(e.value).concat(r)),e}};return e}function N(t,e,r){var n=E(r),a="".concat(t.protocol,"://").concat(t.url,"/").concat("/"===e.charAt(0)?e.substr(1):e);return n.length&&(a+="?".concat(n)),a}function E(t){return Object.keys(t).map((function(e){return h("%s=%s",e,(r=t[e],"[object Object]"===Object.prototype.toString.call(r)||"[object Array]"===Object.prototype.toString.call(r)?JSON.stringify(t[e]):t[e]));var r})).join("&")}function R(t){return t.map((function(t){return A(t)}))}function A(t){var e=t.request.headers["x-algolia-api-key"]?{"x-algolia-api-key":"*****"}:{};return r(r({},t),{},{request:r(r({},t.request),{},{headers:r(r({},t.request.headers),e)})})}var C=function(t){return function(e,r){return t.transporter.write({method:j,path:"2/abtests",data:e},r)}},U=function(t){return function(e,r){return t.transporter.write({method:I,path:h("2/abtests/%s",e)},r)}},z=function(t){return function(e,r){return t.transporter.read({method:x,path:h("2/abtests/%s",e)},r)}},J=function(t){return function(e){return t.transporter.read({method:x,path:"2/abtests"},e)}},F=function(t){return function(e,r){return t.transporter.write({method:j,path:h("2/abtests/%s/stop",e)},r)}},H=function(t){return function(e){return t.transporter.read({method:x,path:"1/strategies/personalization"},e)}},M=function(t){return function(e,r){return t.transporter.write({method:j,path:"1/strategies/personalization",data:e},r)}};function K(t){return function e(r){return t.request(r).then((function(n){if(void 0!==t.batch&&t.batch(n.hits),!t.shouldStop(n))return n.cursor?e({cursor:n.cursor}):e({page:(r.page||0)+1})}))}({})}var W=function(t){return function(e,a){var o=a||{},i=o.queryParameters,u=n(o,["queryParameters"]),s=r({acl:e},void 0!==i?{queryParameters:i}:{});return d(t.transporter.write({method:j,path:"1/keys",data:s},u),(function(e,r){return f((function(n){return tt(t)(e.key,r).catch((function(t){if(404!==t.status)throw t;return n()}))}))}))}},B=function(t){return function(e,r,n){var a=y(n);return a.queryParameters["X-Algolia-User-ID"]=e,t.transporter.write({method:j,path:"1/clusters/mapping",data:{cluster:r}},a)}},Q=function(t){return function(e,r,n){return t.transporter.write({method:j,path:"1/clusters/mapping/batch",data:{users:e,cluster:r}},n)}},G=function(t){return function(e,r){return d(t.transporter.write({method:j,path:h("/1/dictionaries/%s/batch",e),data:{clearExistingDictionaryEntries:!0,requests:{action:"addEntry",body:[]}}},r),(function(e,r){return jt(t)(e.taskID,r)}))}},L=function(t){return function(e,r,n){return d(t.transporter.write({method:j,path:h("1/indexes/%s/operation",e),data:{operation:"copy",destination:r}},n),(function(r,n){return ut(t)(e,{methods:{waitTask:de}}).waitTask(r.taskID,n)}))}},V=function(t){return function(e,n,a){return L(t)(e,n,r(r({},a),{},{scope:[pe.Rules]}))}},_=function(t){return function(e,n,a){return L(t)(e,n,r(r({},a),{},{scope:[pe.Settings]}))}},X=function(t){return function(e,n,a){return L(t)(e,n,r(r({},a),{},{scope:[pe.Synonyms]}))}},Y=function(t){return function(e,r){return e.method===x?t.transporter.read(e,r):t.transporter.write(e,r)}},Z=function(t){return function(e,r){return d(t.transporter.write({method:I,path:h("1/keys/%s",e)},r),(function(r,n){return f((function(r){return tt(t)(e,n).then(r).catch((function(t){if(404!==t.status)throw t}))}))}))}},$=function(t){return function(e,r,n){var a=r.map((function(t){return{action:"deleteEntry",body:{objectID:t}}}));return d(t.transporter.write({method:j,path:h("/1/dictionaries/%s/batch",e),data:{clearExistingDictionaryEntries:!1,requests:a}},n),(function(e,r){return jt(t)(e.taskID,r)}))}},tt=function(t){return function(e,r){return t.transporter.read({method:x,path:h("1/keys/%s",e)},r)}},et=function(t){return function(e,r){return t.transporter.read({method:x,path:h("1/task/%s",e.toString())},r)}},rt=function(t){return function(e){return t.transporter.read({method:x,path:"/1/dictionaries/*/settings"},e)}},nt=function(t){return function(e){return t.transporter.read({method:x,path:"1/logs"},e)}},at=function(t){return function(e){return t.transporter.read({method:x,path:"1/clusters/mapping/top"},e)}},ot=function(t){return function(e,r){return t.transporter.read({method:x,path:h("1/clusters/mapping/%s",e)},r)}},it=function(t){return function(e){var r=e||{},a=r.retrieveMappings,o=n(r,["retrieveMappings"]);return!0===a&&(o.getClusters=!0),t.transporter.read({method:x,path:"1/clusters/mapping/pending"},o)}},ut=function(t){return function(e){var r=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},n={transporter:t.transporter,appId:t.appId,indexName:e};return p(n,r.methods)}},st=function(t){return function(e){return t.transporter.read({method:x,path:"1/keys"},e)}},ct=function(t){return function(e){return t.transporter.read({method:x,path:"1/clusters"},e)}},ft=function(t){return function(e){return t.transporter.read({method:x,path:"1/indexes"},e)}},dt=function(t){return function(e){return t.transporter.read({method:x,path:"1/clusters/mapping"},e)}},lt=function(t){return function(e,r,n){return d(t.transporter.write({method:j,path:h("1/indexes/%s/operation",e),data:{operation:"move",destination:r}},n),(function(r,n){return ut(t)(e,{methods:{waitTask:de}}).waitTask(r.taskID,n)}))}},pt=function(t){return function(e,r){return d(t.transporter.write({method:j,path:"1/indexes/*/batch",data:{requests:e}},r),(function(e,r){return Promise.all(Object.keys(e.taskID).map((function(n){return ut(t)(n,{methods:{waitTask:de}}).waitTask(e.taskID[n],r)})))}))}},ht=function(t){return function(e,r){return t.transporter.read({method:j,path:"1/indexes/*/objects",data:{requests:e}},r)}},mt=function(t){return function(e,n){var a=e.map((function(t){return r(r({},t),{},{params:E(t.params||{})})}));return t.transporter.read({method:j,path:"1/indexes/*/queries",data:{requests:a},cacheable:!0},n)}},yt=function(t){return function(e,a){return Promise.all(e.map((function(e){var o=e.params,i=o.facetName,u=o.facetQuery,s=n(o,["facetName","facetQuery"]);return ut(t)(e.indexName,{methods:{searchForFacetValues:ue}}).searchForFacetValues(i,u,r(r({},a),s))})))}},gt=function(t){return function(e,r){var n=y(r);return n.queryParameters["X-Algolia-User-ID"]=e,t.transporter.write({method:I,path:"1/clusters/mapping"},n)}},vt=function(t){return function(e,r,n){var a=r.map((function(t){return{action:"addEntry",body:t}}));return d(t.transporter.write({method:j,path:h("/1/dictionaries/%s/batch",e),data:{clearExistingDictionaryEntries:!0,requests:a}},n),(function(e,r){return jt(t)(e.taskID,r)}))}},bt=function(t){return function(e,r){return d(t.transporter.write({method:j,path:h("1/keys/%s/restore",e)},r),(function(r,n){return f((function(r){return tt(t)(e,n).catch((function(t){if(404!==t.status)throw t;return r()}))}))}))}},Pt=function(t){return function(e,r,n){var a=r.map((function(t){return{action:"addEntry",body:t}}));return d(t.transporter.write({method:j,path:h("/1/dictionaries/%s/batch",e),data:{clearExistingDictionaryEntries:!1,requests:a}},n),(function(e,r){return jt(t)(e.taskID,r)}))}},wt=function(t){return function(e,r,n){return t.transporter.read({method:j,path:h("/1/dictionaries/%s/search",e),data:{query:r},cacheable:!0},n)}},Ot=function(t){return function(e,r){return t.transporter.read({method:j,path:"1/clusters/mapping/search",data:{query:e}},r)}},It=function(t){return function(e,r){return d(t.transporter.write({method:D,path:"/1/dictionaries/*/settings",data:e},r),(function(e,r){return jt(t)(e.taskID,r)}))}},xt=function(t){return function(e,r){var a=Object.assign({},r),o=r||{},i=o.queryParameters,u=n(o,["queryParameters"]),s=i?{queryParameters:i}:{},c=["acl","indexes","referers","restrictSources","queryParameters","description","maxQueriesPerIPPerHour","maxHitsPerQuery"];return d(t.transporter.write({method:D,path:h("1/keys/%s",e),data:s},u),(function(r,n){return f((function(r){return tt(t)(e,n).then((function(t){return function(t){return Object.keys(a).filter((function(t){return-1!==c.indexOf(t)})).every((function(e){return t[e]===a[e]}))}(t)?Promise.resolve():r()}))}))}))}},jt=function(t){return function(e,r){return f((function(n){return et(t)(e,r).then((function(t){return"published"!==t.status?n():void 0}))}))}},Dt=function(t){return function(e,r){return d(t.transporter.write({method:j,path:h("1/indexes/%s/batch",t.indexName),data:{requests:e}},r),(function(e,r){return de(t)(e.taskID,r)}))}},qt=function(t){return function(e){return K(r(r({shouldStop:function(t){return void 0===t.cursor}},e),{},{request:function(r){return t.transporter.read({method:j,path:h("1/indexes/%s/browse",t.indexName),data:r},e)}}))}},St=function(t){return function(e){var n=r({hitsPerPage:1e3},e);return K(r(r({shouldStop:function(t){return t.hits.length<n.hitsPerPage}},n),{},{request:function(e){return se(t)("",r(r({},n),e)).then((function(t){return r(r({},t),{},{hits:t.hits.map((function(t){return delete t._highlightResult,t}))})}))}}))}},kt=function(t){return function(e){var n=r({hitsPerPage:1e3},e);return K(r(r({shouldStop:function(t){return t.hits.length<n.hitsPerPage}},n),{},{request:function(e){return ce(t)("",r(r({},n),e)).then((function(t){return r(r({},t),{},{hits:t.hits.map((function(t){return delete t._highlightResult,t}))})}))}}))}},Tt=function(t){return function(e,r,a){var o=a||{},i=o.batchSize,u=n(o,["batchSize"]),s={taskIDs:[],objectIDs:[]};return d(function n(){var a,o=arguments.length>0&&void 0!==arguments[0]?arguments[0]:0,c=[];for(a=o;a<e.length&&(c.push(e[a]),c.length!==(i||1e3));a++);return 0===c.length?Promise.resolve(s):Dt(t)(c.map((function(t){return{action:r,body:t}})),u).then((function(t){return s.objectIDs=s.objectIDs.concat(t.objectIDs),s.taskIDs.push(t.taskID),a++,n(a)}))}(),(function(e,r){return Promise.all(e.taskIDs.map((function(e){return de(t)(e,r)})))}))}},Nt=function(t){return function(e){return d(t.transporter.write({method:j,path:h("1/indexes/%s/clear",t.indexName)},e),(function(e,r){return de(t)(e.taskID,r)}))}},Et=function(t){return function(e){var r=e||{},a=r.forwardToReplicas,o=y(n(r,["forwardToReplicas"]));return a&&(o.queryParameters.forwardToReplicas=1),d(t.transporter.write({method:j,path:h("1/indexes/%s/rules/clear",t.indexName)},o),(function(e,r){return de(t)(e.taskID,r)}))}},Rt=function(t){return function(e){var r=e||{},a=r.forwardToReplicas,o=y(n(r,["forwardToReplicas"]));return a&&(o.queryParameters.forwardToReplicas=1),d(t.transporter.write({method:j,path:h("1/indexes/%s/synonyms/clear",t.indexName)},o),(function(e,r){return de(t)(e.taskID,r)}))}},At=function(t){return function(e,r){return d(t.transporter.write({method:j,path:h("1/indexes/%s/deleteByQuery",t.indexName),data:e},r),(function(e,r){return de(t)(e.taskID,r)}))}},Ct=function(t){return function(e){return d(t.transporter.write({method:I,path:h("1/indexes/%s",t.indexName)},e),(function(e,r){return de(t)(e.taskID,r)}))}},Ut=function(t){return function(e,r){return d(zt(t)([e],r).then((function(t){return{taskID:t.taskIDs[0]}})),(function(e,r){return de(t)(e.taskID,r)}))}},zt=function(t){return function(e,r){var n=e.map((function(t){return{objectID:t}}));return Tt(t)(n,le.DeleteObject,r)}},Jt=function(t){return function(e,r){var a=r||{},o=a.forwardToReplicas,i=y(n(a,["forwardToReplicas"]));return o&&(i.queryParameters.forwardToReplicas=1),d(t.transporter.write({method:I,path:h("1/indexes/%s/rules/%s",t.indexName,e)},i),(function(e,r){return de(t)(e.taskID,r)}))}},Ft=function(t){return function(e,r){var a=r||{},o=a.forwardToReplicas,i=y(n(a,["forwardToReplicas"]));return o&&(i.queryParameters.forwardToReplicas=1),d(t.transporter.write({method:I,path:h("1/indexes/%s/synonyms/%s",t.indexName,e)},i),(function(e,r){return de(t)(e.taskID,r)}))}},Ht=function(t){return function(e){return Lt(t)(e).then((function(){return!0})).catch((function(t){if(404!==t.status)throw t;return!1}))}},Mt=function(t){return function(e,r,n){return t.transporter.read({method:j,path:h("1/answers/%s/prediction",t.indexName),data:{query:e,queryLanguages:r},cacheable:!0},n)}},Kt=function(t){return function(e,o){var i=o||{},u=i.query,s=i.paginate,c=n(i,["query","paginate"]),f=0;return function n(){return ie(t)(u||"",r(r({},c),{},{page:f})).then((function(t){for(var r=0,o=Object.entries(t.hits);r<o.length;r++){var i=a(o[r],2),u=i[0],c=i[1];if(e(c))return{object:c,position:parseInt(u,10),page:f}}if(f++,!1===s||f>=t.nbPages)throw{name:"ObjectNotFoundError",message:"Object not found."};return n()}))}()}},Wt=function(t){return function(e,r){return t.transporter.read({method:x,path:h("1/indexes/%s/%s",t.indexName,e)},r)}},Bt=function(){return function(t,e){for(var r=0,n=Object.entries(t.hits);r<n.length;r++){var o=a(n[r],2),i=o[0];if(o[1].objectID===e)return parseInt(i,10)}return-1}},Qt=function(t){return function(e,a){var o=a||{},i=o.attributesToRetrieve,u=n(o,["attributesToRetrieve"]),s=e.map((function(e){return r({indexName:t.indexName,objectID:e},i?{attributesToRetrieve:i}:{})}));return t.transporter.read({method:j,path:"1/indexes/*/objects",data:{requests:s}},u)}},Gt=function(t){return function(e,r){return t.transporter.read({method:x,path:h("1/indexes/%s/rules/%s",t.indexName,e)},r)}},Lt=function(t){return function(e){return t.transporter.read({method:x,path:h("1/indexes/%s/settings",t.indexName),data:{getVersion:2}},e)}},Vt=function(t){return function(e,r){return t.transporter.read({method:x,path:h("1/indexes/%s/synonyms/%s",t.indexName,e)},r)}},_t=function(t){return function(e,r){return d(Xt(t)([e],r).then((function(t){return{objectID:t.objectIDs[0],taskID:t.taskIDs[0]}})),(function(e,r){return de(t)(e.taskID,r)}))}},Xt=function(t){return function(e,r){var a=r||{},o=a.createIfNotExists,i=n(a,["createIfNotExists"]),u=o?le.PartialUpdateObject:le.PartialUpdateObjectNoCreate;return Tt(t)(e,u,i)}},Yt=function(t){return function(e,i){var u=i||{},s=u.safe,c=u.autoGenerateObjectIDIfNotExist,f=u.batchSize,l=n(u,["safe","autoGenerateObjectIDIfNotExist","batchSize"]),p=function(e,r,n,a){return d(t.transporter.write({method:j,path:h("1/indexes/%s/operation",e),data:{operation:n,destination:r}},a),(function(e,r){return de(t)(e.taskID,r)}))},m=Math.random().toString(36).substring(7),y="".concat(t.indexName,"_tmp_").concat(m),g=ee({appId:t.appId,transporter:t.transporter,indexName:y}),v=[],b=p(t.indexName,y,"copy",r(r({},l),{},{scope:["settings","synonyms","rules"]}));return v.push(b),d((s?b.wait(l):b).then((function(){var t=g(e,r(r({},l),{},{autoGenerateObjectIDIfNotExist:c,batchSize:f}));return v.push(t),s?t.wait(l):t})).then((function(){var e=p(y,t.indexName,"move",l);return v.push(e),s?e.wait(l):e})).then((function(){return Promise.all(v)})).then((function(t){var e=a(t,3),r=e[0],n=e[1],i=e[2];return{objectIDs:n.objectIDs,taskIDs:[r.taskID].concat(o(n.taskIDs),[i.taskID])}})),(function(t,e){return Promise.all(v.map((function(t){return t.wait(e)})))}))}},Zt=function(t){return function(e,n){return ne(t)(e,r(r({},n),{},{clearExistingRules:!0}))}},$t=function(t){return function(e,n){return oe(t)(e,r(r({},n),{},{clearExistingSynonyms:!0}))}},te=function(t){return function(e,r){return d(ee(t)([e],r).then((function(t){return{objectID:t.objectIDs[0],taskID:t.taskIDs[0]}})),(function(e,r){return de(t)(e.taskID,r)}))}},ee=function(t){return function(e,r){var a=r||{},o=a.autoGenerateObjectIDIfNotExist,i=n(a,["autoGenerateObjectIDIfNotExist"]),u=o?le.AddObject:le.UpdateObject;if(u===le.UpdateObject){var s=!0,c=!1,f=void 0;try{for(var l,p=e[Symbol.iterator]();!(s=(l=p.next()).done);s=!0){if(void 0===l.value.objectID)return d(Promise.reject({name:"MissingObjectIDError",message:"All objects must have an unique objectID (like a primary key) to be valid. Algolia is also able to generate objectIDs automatically but *it's not recommended*. To do it, use the `{'autoGenerateObjectIDIfNotExist': true}` option."}))}}catch(t){c=!0,f=t}finally{try{s||null==p.return||p.return()}finally{if(c)throw f}}}return Tt(t)(e,u,i)}},re=function(t){return function(e,r){return ne(t)([e],r)}},ne=function(t){return function(e,r){var a=r||{},o=a.forwardToReplicas,i=a.clearExistingRules,u=y(n(a,["forwardToReplicas","clearExistingRules"]));return o&&(u.queryParameters.forwardToReplicas=1),i&&(u.queryParameters.clearExistingRules=1),d(t.transporter.write({method:j,path:h("1/indexes/%s/rules/batch",t.indexName),data:e},u),(function(e,r){return de(t)(e.taskID,r)}))}},ae=function(t){return function(e,r){return oe(t)([e],r)}},oe=function(t){return function(e,r){var a=r||{},o=a.forwardToReplicas,i=a.clearExistingSynonyms,u=a.replaceExistingSynonyms,s=y(n(a,["forwardToReplicas","clearExistingSynonyms","replaceExistingSynonyms"]));return o&&(s.queryParameters.forwardToReplicas=1),(u||i)&&(s.queryParameters.replaceExistingSynonyms=1),d(t.transporter.write({method:j,path:h("1/indexes/%s/synonyms/batch",t.indexName),data:e},s),(function(e,r){return de(t)(e.taskID,r)}))}},ie=function(t){return function(e,r){return t.transporter.read({method:j,path:h("1/indexes/%s/query",t.indexName),data:{query:e},cacheable:!0},r)}},ue=function(t){return function(e,r,n){return t.transporter.read({method:j,path:h("1/indexes/%s/facets/%s/query",t.indexName,e),data:{facetQuery:r},cacheable:!0},n)}},se=function(t){return function(e,r){return t.transporter.read({method:j,path:h("1/indexes/%s/rules/search",t.indexName),data:{query:e}},r)}},ce=function(t){return function(e,r){return t.transporter.read({method:j,path:h("1/indexes/%s/synonyms/search",t.indexName),data:{query:e}},r)}},fe=function(t){return function(e,r){var a=r||{},o=a.forwardToReplicas,i=y(n(a,["forwardToReplicas"]));return o&&(i.queryParameters.forwardToReplicas=1),d(t.transporter.write({method:D,path:h("1/indexes/%s/settings",t.indexName),data:e},i),(function(e,r){return de(t)(e.taskID,r)}))}},de=function(t){return function(e,r){return f((function(n){return function(t){return function(e,r){return t.transporter.read({method:x,path:h("1/indexes/%s/task/%s",t.indexName,e.toString())},r)}}(t)(e,r).then((function(t){return"published"!==t.status?n():void 0}))}))}},le={AddObject:"addObject",UpdateObject:"updateObject",PartialUpdateObject:"partialUpdateObject",PartialUpdateObjectNoCreate:"partialUpdateObjectNoCreate",DeleteObject:"deleteObject",DeleteIndex:"delete",ClearIndex:"clear"},pe={Settings:"settings",Synonyms:"synonyms",Rules:"rules"},he=1,me=2,ye=3;function ge(t,e,n){var a,o={appId:t,apiKey:e,timeouts:{connect:1,read:2,write:30},requester:{send:function(t){return new Promise((function(e){var r=new XMLHttpRequest;r.open(t.method,t.url,!0),Object.keys(t.headers).forEach((function(e){return r.setRequestHeader(e,t.headers[e])}));var n,a=function(t,n){return setTimeout((function(){r.abort(),e({status:0,content:n,isTimedOut:!0})}),1e3*t)},o=a(t.connectTimeout,"Connection timeout");r.onreadystatechange=function(){r.readyState>r.OPENED&&void 0===n&&(clearTimeout(o),n=a(t.responseTimeout,"Socket timeout"))},r.onerror=function(){0===r.status&&(clearTimeout(o),clearTimeout(n),e({content:r.responseText||"Network request failed",status:r.status,isTimedOut:!1}))},r.onload=function(){clearTimeout(o),clearTimeout(n),e({content:r.responseText,status:r.status,isTimedOut:!1})},r.send(t.data)}))}},logger:(a=ye,{debug:function(t,e){return he>=a&&console.debug(t,e),Promise.resolve()},info:function(t,e){return me>=a&&console.info(t,e),Promise.resolve()},error:function(t,e){return console.error(t,e),Promise.resolve()}}),responsesCache:s(),requestsCache:s({serializable:!1}),hostsCache:u({caches:[i({key:"".concat("4.14.3","-").concat(t)}),s()]}),userAgent:T("4.14.3").add({segment:"Browser"})},f=r(r({},o),n),d=function(){return function(t){return function(t){var e=t.region||"us",n=c(m.WithinHeaders,t.appId,t.apiKey),a=k(r(r({hosts:[{url:"personalization.".concat(e,".algolia.com")}]},t),{},{headers:r(r(r({},n.headers()),{"content-type":"application/json"}),t.headers),queryParameters:r(r({},n.queryParameters()),t.queryParameters)}));return p({appId:t.appId,transporter:a},t.methods)}(r(r(r({},o),t),{},{methods:{getPersonalizationStrategy:H,setPersonalizationStrategy:M}}))}};return function(t){var e=t.appId,n=c(void 0!==t.authMode?t.authMode:m.WithinHeaders,e,t.apiKey),a=k(r(r({hosts:[{url:"".concat(e,"-dsn.algolia.net"),accept:g.Read},{url:"".concat(e,".algolia.net"),accept:g.Write}].concat(l([{url:"".concat(e,"-1.algolianet.com")},{url:"".concat(e,"-2.algolianet.com")},{url:"".concat(e,"-3.algolianet.com")}]))},t),{},{headers:r(r(r({},n.headers()),{"content-type":"application/x-www-form-urlencoded"}),t.headers),queryParameters:r(r({},n.queryParameters()),t.queryParameters)}));return p({transporter:a,appId:e,addAlgoliaAgent:function(t,e){a.userAgent.add({segment:t,version:e})},clearCache:function(){return Promise.all([a.requestsCache.clear(),a.responsesCache.clear()]).then((function(){}))}},t.methods)}(r(r({},f),{},{methods:{search:mt,searchForFacetValues:yt,multipleBatch:pt,multipleGetObjects:ht,multipleQueries:mt,copyIndex:L,copySettings:_,copySynonyms:X,copyRules:V,moveIndex:lt,listIndices:ft,getLogs:nt,listClusters:ct,multipleSearchForFacetValues:yt,getApiKey:tt,addApiKey:W,listApiKeys:st,updateApiKey:xt,deleteApiKey:Z,restoreApiKey:bt,assignUserID:B,assignUserIDs:Q,getUserID:ot,searchUserIDs:Ot,listUserIDs:dt,getTopUserIDs:at,removeUserID:gt,hasPendingMappings:it,clearDictionaryEntries:G,deleteDictionaryEntries:$,getDictionarySettings:rt,getAppTask:et,replaceDictionaryEntries:vt,saveDictionaryEntries:Pt,searchDictionaryEntries:wt,setDictionarySettings:It,waitAppTask:jt,customRequest:Y,initIndex:function(t){return function(e){return ut(t)(e,{methods:{batch:Dt,delete:Ct,findAnswers:Mt,getObject:Wt,getObjects:Qt,saveObject:te,saveObjects:ee,search:ie,searchForFacetValues:ue,waitTask:de,setSettings:fe,getSettings:Lt,partialUpdateObject:_t,partialUpdateObjects:Xt,deleteObject:Ut,deleteObjects:zt,deleteBy:At,clearObjects:Nt,browseObjects:qt,getObjectPosition:Bt,findObject:Kt,exists:Ht,saveSynonym:ae,saveSynonyms:oe,getSynonym:Vt,searchSynonyms:ce,browseSynonyms:kt,deleteSynonym:Ft,clearSynonyms:Rt,replaceAllObjects:Yt,replaceAllSynonyms:$t,searchRules:se,getRule:Gt,deleteRule:Jt,saveRule:re,saveRules:ne,replaceAllRules:Zt,browseRules:St,clearRules:Et}})}},initAnalytics:function(){return function(t){return function(t){var e=t.region||"us",n=c(m.WithinHeaders,t.appId,t.apiKey),a=k(r(r({hosts:[{url:"analytics.".concat(e,".algolia.com")}]},t),{},{headers:r(r(r({},n.headers()),{"content-type":"application/json"}),t.headers),queryParameters:r(r({},n.queryParameters()),t.queryParameters)}));return p({appId:t.appId,transporter:a},t.methods)}(r(r(r({},o),t),{},{methods:{addABTest:C,getABTest:z,getABTests:J,stopABTest:F,deleteABTest:U}}))}},initPersonalization:d,initRecommendation:function(){return function(t){return f.logger.info("The `initRecommendation` method is deprecated. Use `initPersonalization` instead."),d()(t)}}}}))}return ge.version="4.14.3",ge}));


/***/ }),

/***/ 38805:
/***/ (function(module, exports) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;
	var nativeCodeString = '[native code]';

	function classNames() {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				if (arg.length) {
					var inner = classNames.apply(null, arg);
					if (inner) {
						classes.push(inner);
					}
				}
			} else if (argType === 'object') {
				if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) {
					classes.push(arg.toString());
					continue;
				}

				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if ( true && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {}
}());


/***/ }),

/***/ 67520:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
/*!
 * cookie
 * Copyright(c) 2012-2014 Roman Shtylman
 * Copyright(c) 2015 Douglas Christopher Wilson
 * MIT Licensed
 */



/**
 * Module exports.
 * @public
 */

exports.Q = parse;
exports.q = serialize;

/**
 * Module variables.
 * @private
 */

var __toString = Object.prototype.toString

/**
 * RegExp to match field-content in RFC 7230 sec 3.2
 *
 * field-content = field-vchar [ 1*( SP / HTAB ) field-vchar ]
 * field-vchar   = VCHAR / obs-text
 * obs-text      = %x80-FF
 */

var fieldContentRegExp = /^[\u0009\u0020-\u007e\u0080-\u00ff]+$/;

/**
 * Parse a cookie header.
 *
 * Parse the given cookie header string into an object
 * The object has the various cookies as keys(names) => values
 *
 * @param {string} str
 * @param {object} [options]
 * @return {object}
 * @public
 */

function parse(str, options) {
  if (typeof str !== 'string') {
    throw new TypeError('argument str must be a string');
  }

  var obj = {}
  var opt = options || {};
  var dec = opt.decode || decode;

  var index = 0
  while (index < str.length) {
    var eqIdx = str.indexOf('=', index)

    // no more cookie pairs
    if (eqIdx === -1) {
      break
    }

    var endIdx = str.indexOf(';', index)

    if (endIdx === -1) {
      endIdx = str.length
    } else if (endIdx < eqIdx) {
      // backtrack on prior semicolon
      index = str.lastIndexOf(';', eqIdx - 1) + 1
      continue
    }

    var key = str.slice(index, eqIdx).trim()

    // only assign once
    if (undefined === obj[key]) {
      var val = str.slice(eqIdx + 1, endIdx).trim()

      // quoted values
      if (val.charCodeAt(0) === 0x22) {
        val = val.slice(1, -1)
      }

      obj[key] = tryDecode(val, dec);
    }

    index = endIdx + 1
  }

  return obj;
}

/**
 * Serialize data into a cookie header.
 *
 * Serialize the a name value pair into a cookie string suitable for
 * http headers. An optional options object specified cookie parameters.
 *
 * serialize('foo', 'bar', { httpOnly: true })
 *   => "foo=bar; httpOnly"
 *
 * @param {string} name
 * @param {string} val
 * @param {object} [options]
 * @return {string}
 * @public
 */

function serialize(name, val, options) {
  var opt = options || {};
  var enc = opt.encode || encode;

  if (typeof enc !== 'function') {
    throw new TypeError('option encode is invalid');
  }

  if (!fieldContentRegExp.test(name)) {
    throw new TypeError('argument name is invalid');
  }

  var value = enc(val);

  if (value && !fieldContentRegExp.test(value)) {
    throw new TypeError('argument val is invalid');
  }

  var str = name + '=' + value;

  if (null != opt.maxAge) {
    var maxAge = opt.maxAge - 0;

    if (isNaN(maxAge) || !isFinite(maxAge)) {
      throw new TypeError('option maxAge is invalid')
    }

    str += '; Max-Age=' + Math.floor(maxAge);
  }

  if (opt.domain) {
    if (!fieldContentRegExp.test(opt.domain)) {
      throw new TypeError('option domain is invalid');
    }

    str += '; Domain=' + opt.domain;
  }

  if (opt.path) {
    if (!fieldContentRegExp.test(opt.path)) {
      throw new TypeError('option path is invalid');
    }

    str += '; Path=' + opt.path;
  }

  if (opt.expires) {
    var expires = opt.expires

    if (!isDate(expires) || isNaN(expires.valueOf())) {
      throw new TypeError('option expires is invalid');
    }

    str += '; Expires=' + expires.toUTCString()
  }

  if (opt.httpOnly) {
    str += '; HttpOnly';
  }

  if (opt.secure) {
    str += '; Secure';
  }

  if (opt.partitioned) {
    str += '; Partitioned'
  }

  if (opt.priority) {
    var priority = typeof opt.priority === 'string'
      ? opt.priority.toLowerCase()
      : opt.priority

    switch (priority) {
      case 'low':
        str += '; Priority=Low'
        break
      case 'medium':
        str += '; Priority=Medium'
        break
      case 'high':
        str += '; Priority=High'
        break
      default:
        throw new TypeError('option priority is invalid')
    }
  }

  if (opt.sameSite) {
    var sameSite = typeof opt.sameSite === 'string'
      ? opt.sameSite.toLowerCase() : opt.sameSite;

    switch (sameSite) {
      case true:
        str += '; SameSite=Strict';
        break;
      case 'lax':
        str += '; SameSite=Lax';
        break;
      case 'strict':
        str += '; SameSite=Strict';
        break;
      case 'none':
        str += '; SameSite=None';
        break;
      default:
        throw new TypeError('option sameSite is invalid');
    }
  }

  return str;
}

/**
 * URL-decode string value. Optimized to skip native call when no %.
 *
 * @param {string} str
 * @returns {string}
 */

function decode (str) {
  return str.indexOf('%') !== -1
    ? decodeURIComponent(str)
    : str
}

/**
 * URL-encode value.
 *
 * @param {string} val
 * @returns {string}
 */

function encode (val) {
  return encodeURIComponent(val)
}

/**
 * Determine if value is a Date.
 *
 * @param {*} val
 * @private
 */

function isDate (val) {
  return __toString.call(val) === '[object Date]' ||
    val instanceof Date
}

/**
 * Try decoding a string using a decoding function.
 *
 * @param {string} str
 * @param {function} decode
 * @private
 */

function tryDecode(str, decode) {
  try {
    return decode(str);
  } catch (e) {
    return str;
  }
}


/***/ }),

/***/ 2720:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(79662);

// -- Inlined from fbjs --

var emptyObject = {};

if (false) {}

var validateFormat = function validateFormat(format) {};

if (false) {}

function _invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

var warning = function(){};

if (false) { var printWarning; }

// /-- Inlined from fbjs --

var MIXINS_KEY = 'mixins';

// Helper function to allow the creation of anonymous functions which do not
// have .name set to the name of the variable being assigned to.
function identity(fn) {
  return fn;
}

var ReactPropTypeLocationNames;
if (false) {} else {
  ReactPropTypeLocationNames = {};
}

function factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
  /**
   * Policies that describe methods in `ReactClassInterface`.
   */

  var injectedMixins = [];

  /**
   * Composite components are higher-level components that compose other composite
   * or host components.
   *
   * To create a new type of `ReactClass`, pass a specification of
   * your new class to `React.createClass`. The only requirement of your class
   * specification is that you implement a `render` method.
   *
   *   var MyComponent = React.createClass({
   *     render: function() {
   *       return <div>Hello World</div>;
   *     }
   *   });
   *
   * The class specification supports a specific protocol of methods that have
   * special meaning (e.g. `render`). See `ReactClassInterface` for
   * more the comprehensive protocol. Any other properties and methods in the
   * class specification will be available on the prototype.
   *
   * @interface ReactClassInterface
   * @internal
   */
  var ReactClassInterface = {
    /**
     * An array of Mixin objects to include when defining your component.
     *
     * @type {array}
     * @optional
     */
    mixins: 'DEFINE_MANY',

    /**
     * An object containing properties and methods that should be defined on
     * the component's constructor instead of its prototype (static methods).
     *
     * @type {object}
     * @optional
     */
    statics: 'DEFINE_MANY',

    /**
     * Definition of prop types for this component.
     *
     * @type {object}
     * @optional
     */
    propTypes: 'DEFINE_MANY',

    /**
     * Definition of context types for this component.
     *
     * @type {object}
     * @optional
     */
    contextTypes: 'DEFINE_MANY',

    /**
     * Definition of context types this component sets for its children.
     *
     * @type {object}
     * @optional
     */
    childContextTypes: 'DEFINE_MANY',

    // ==== Definition methods ====

    /**
     * Invoked when the component is mounted. Values in the mapping will be set on
     * `this.props` if that prop is not specified (i.e. using an `in` check).
     *
     * This method is invoked before `getInitialState` and therefore cannot rely
     * on `this.state` or use `this.setState`.
     *
     * @return {object}
     * @optional
     */
    getDefaultProps: 'DEFINE_MANY_MERGED',

    /**
     * Invoked once before the component is mounted. The return value will be used
     * as the initial value of `this.state`.
     *
     *   getInitialState: function() {
     *     return {
     *       isOn: false,
     *       fooBaz: new BazFoo()
     *     }
     *   }
     *
     * @return {object}
     * @optional
     */
    getInitialState: 'DEFINE_MANY_MERGED',

    /**
     * @return {object}
     * @optional
     */
    getChildContext: 'DEFINE_MANY_MERGED',

    /**
     * Uses props from `this.props` and state from `this.state` to render the
     * structure of the component.
     *
     * No guarantees are made about when or how often this method is invoked, so
     * it must not have side effects.
     *
     *   render: function() {
     *     var name = this.props.name;
     *     return <div>Hello, {name}!</div>;
     *   }
     *
     * @return {ReactComponent}
     * @required
     */
    render: 'DEFINE_ONCE',

    // ==== Delegate methods ====

    /**
     * Invoked when the component is initially created and about to be mounted.
     * This may have side effects, but any external subscriptions or data created
     * by this method must be cleaned up in `componentWillUnmount`.
     *
     * @optional
     */
    componentWillMount: 'DEFINE_MANY',

    /**
     * Invoked when the component has been mounted and has a DOM representation.
     * However, there is no guarantee that the DOM node is in the document.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been mounted (initialized and rendered) for the first time.
     *
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */
    componentDidMount: 'DEFINE_MANY',

    /**
     * Invoked before the component receives new props.
     *
     * Use this as an opportunity to react to a prop transition by updating the
     * state using `this.setState`. Current props are accessed via `this.props`.
     *
     *   componentWillReceiveProps: function(nextProps, nextContext) {
     *     this.setState({
     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
     *     });
     *   }
     *
     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
     * transition may cause a state change, but the opposite is not true. If you
     * need it, you are probably looking for `componentWillUpdate`.
     *
     * @param {object} nextProps
     * @optional
     */
    componentWillReceiveProps: 'DEFINE_MANY',

    /**
     * Invoked while deciding if the component should be updated as a result of
     * receiving new props, state and/or context.
     *
     * Use this as an opportunity to `return false` when you're certain that the
     * transition to the new props/state/context will not require a component
     * update.
     *
     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
     *     return !equal(nextProps, this.props) ||
     *       !equal(nextState, this.state) ||
     *       !equal(nextContext, this.context);
     *   }
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @return {boolean} True if the component should update.
     * @optional
     */
    shouldComponentUpdate: 'DEFINE_ONCE',

    /**
     * Invoked when the component is about to update due to a transition from
     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
     * and `nextContext`.
     *
     * Use this as an opportunity to perform preparation before an update occurs.
     *
     * NOTE: You **cannot** use `this.setState()` in this method.
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @param {ReactReconcileTransaction} transaction
     * @optional
     */
    componentWillUpdate: 'DEFINE_MANY',

    /**
     * Invoked when the component's DOM representation has been updated.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been updated.
     *
     * @param {object} prevProps
     * @param {?object} prevState
     * @param {?object} prevContext
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */
    componentDidUpdate: 'DEFINE_MANY',

    /**
     * Invoked when the component is about to be removed from its parent and have
     * its DOM representation destroyed.
     *
     * Use this as an opportunity to deallocate any external resources.
     *
     * NOTE: There is no `componentDidUnmount` since your component will have been
     * destroyed by that point.
     *
     * @optional
     */
    componentWillUnmount: 'DEFINE_MANY',

    /**
     * Replacement for (deprecated) `componentWillMount`.
     *
     * @optional
     */
    UNSAFE_componentWillMount: 'DEFINE_MANY',

    /**
     * Replacement for (deprecated) `componentWillReceiveProps`.
     *
     * @optional
     */
    UNSAFE_componentWillReceiveProps: 'DEFINE_MANY',

    /**
     * Replacement for (deprecated) `componentWillUpdate`.
     *
     * @optional
     */
    UNSAFE_componentWillUpdate: 'DEFINE_MANY',

    // ==== Advanced methods ====

    /**
     * Updates the component's currently mounted DOM representation.
     *
     * By default, this implements React's rendering and reconciliation algorithm.
     * Sophisticated clients may wish to override this.
     *
     * @param {ReactReconcileTransaction} transaction
     * @internal
     * @overridable
     */
    updateComponent: 'OVERRIDE_BASE'
  };

  /**
   * Similar to ReactClassInterface but for static methods.
   */
  var ReactClassStaticInterface = {
    /**
     * This method is invoked after a component is instantiated and when it
     * receives new props. Return an object to update state in response to
     * prop changes. Return null to indicate no change to state.
     *
     * If an object is returned, its keys will be merged into the existing state.
     *
     * @return {object || null}
     * @optional
     */
    getDerivedStateFromProps: 'DEFINE_MANY_MERGED'
  };

  /**
   * Mapping from class specification keys to special processing functions.
   *
   * Although these are declared like instance properties in the specification
   * when defining classes using `React.createClass`, they are actually static
   * and are accessible on the constructor instead of the prototype. Despite
   * being static, they must be defined outside of the "statics" key under
   * which all other static methods are defined.
   */
  var RESERVED_SPEC_KEYS = {
    displayName: function(Constructor, displayName) {
      Constructor.displayName = displayName;
    },
    mixins: function(Constructor, mixins) {
      if (mixins) {
        for (var i = 0; i < mixins.length; i++) {
          mixSpecIntoComponent(Constructor, mixins[i]);
        }
      }
    },
    childContextTypes: function(Constructor, childContextTypes) {
      if (false) {}
      Constructor.childContextTypes = _assign(
        {},
        Constructor.childContextTypes,
        childContextTypes
      );
    },
    contextTypes: function(Constructor, contextTypes) {
      if (false) {}
      Constructor.contextTypes = _assign(
        {},
        Constructor.contextTypes,
        contextTypes
      );
    },
    /**
     * Special case getDefaultProps which should move into statics but requires
     * automatic merging.
     */
    getDefaultProps: function(Constructor, getDefaultProps) {
      if (Constructor.getDefaultProps) {
        Constructor.getDefaultProps = createMergedResultFunction(
          Constructor.getDefaultProps,
          getDefaultProps
        );
      } else {
        Constructor.getDefaultProps = getDefaultProps;
      }
    },
    propTypes: function(Constructor, propTypes) {
      if (false) {}
      Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
    },
    statics: function(Constructor, statics) {
      mixStaticSpecIntoComponent(Constructor, statics);
    },
    autobind: function() {}
  };

  function validateTypeDef(Constructor, typeDef, location) {
    for (var propName in typeDef) {
      if (typeDef.hasOwnProperty(propName)) {
        // use a warning instead of an _invariant so components
        // don't show up in prod but only in __DEV__
        if (false) {}
      }
    }
  }

  function validateMethodOverride(isAlreadyDefined, name) {
    var specPolicy = ReactClassInterface.hasOwnProperty(name)
      ? ReactClassInterface[name]
      : null;

    // Disallow overriding of base class methods unless explicitly allowed.
    if (ReactClassMixin.hasOwnProperty(name)) {
      _invariant(
        specPolicy === 'OVERRIDE_BASE',
        'ReactClassInterface: You are attempting to override ' +
          '`%s` from your class specification. Ensure that your method names ' +
          'do not overlap with React methods.',
        name
      );
    }

    // Disallow defining methods more than once unless explicitly allowed.
    if (isAlreadyDefined) {
      _invariant(
        specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED',
        'ReactClassInterface: You are attempting to define ' +
          '`%s` on your component more than once. This conflict may be due ' +
          'to a mixin.',
        name
      );
    }
  }

  /**
   * Mixin helper which handles policy validation and reserved
   * specification keys when building React classes.
   */
  function mixSpecIntoComponent(Constructor, spec) {
    if (!spec) {
      if (false) { var isMixinValid, typeofSpec; }

      return;
    }

    _invariant(
      typeof spec !== 'function',
      "ReactClass: You're attempting to " +
        'use a component class or function as a mixin. Instead, just use a ' +
        'regular object.'
    );
    _invariant(
      !isValidElement(spec),
      "ReactClass: You're attempting to " +
        'use a component as a mixin. Instead, just use a regular object.'
    );

    var proto = Constructor.prototype;
    var autoBindPairs = proto.__reactAutoBindPairs;

    // By handling mixins before any other properties, we ensure the same
    // chaining order is applied to methods with DEFINE_MANY policy, whether
    // mixins are listed before or after these methods in the spec.
    if (spec.hasOwnProperty(MIXINS_KEY)) {
      RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
    }

    for (var name in spec) {
      if (!spec.hasOwnProperty(name)) {
        continue;
      }

      if (name === MIXINS_KEY) {
        // We have already handled mixins in a special case above.
        continue;
      }

      var property = spec[name];
      var isAlreadyDefined = proto.hasOwnProperty(name);
      validateMethodOverride(isAlreadyDefined, name);

      if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
        RESERVED_SPEC_KEYS[name](Constructor, property);
      } else {
        // Setup methods on prototype:
        // The following member methods should not be automatically bound:
        // 1. Expected ReactClass methods (in the "interface").
        // 2. Overridden methods (that were mixed in).
        var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
        var isFunction = typeof property === 'function';
        var shouldAutoBind =
          isFunction &&
          !isReactClassMethod &&
          !isAlreadyDefined &&
          spec.autobind !== false;

        if (shouldAutoBind) {
          autoBindPairs.push(name, property);
          proto[name] = property;
        } else {
          if (isAlreadyDefined) {
            var specPolicy = ReactClassInterface[name];

            // These cases should already be caught by validateMethodOverride.
            _invariant(
              isReactClassMethod &&
                (specPolicy === 'DEFINE_MANY_MERGED' ||
                  specPolicy === 'DEFINE_MANY'),
              'ReactClass: Unexpected spec policy %s for key %s ' +
                'when mixing in component specs.',
              specPolicy,
              name
            );

            // For methods which are defined more than once, call the existing
            // methods before calling the new property, merging if appropriate.
            if (specPolicy === 'DEFINE_MANY_MERGED') {
              proto[name] = createMergedResultFunction(proto[name], property);
            } else if (specPolicy === 'DEFINE_MANY') {
              proto[name] = createChainedFunction(proto[name], property);
            }
          } else {
            proto[name] = property;
            if (false) {}
          }
        }
      }
    }
  }

  function mixStaticSpecIntoComponent(Constructor, statics) {
    if (!statics) {
      return;
    }

    for (var name in statics) {
      var property = statics[name];
      if (!statics.hasOwnProperty(name)) {
        continue;
      }

      var isReserved = name in RESERVED_SPEC_KEYS;
      _invariant(
        !isReserved,
        'ReactClass: You are attempting to define a reserved ' +
          'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' +
          'as an instance property instead; it will still be accessible on the ' +
          'constructor.',
        name
      );

      var isAlreadyDefined = name in Constructor;
      if (isAlreadyDefined) {
        var specPolicy = ReactClassStaticInterface.hasOwnProperty(name)
          ? ReactClassStaticInterface[name]
          : null;

        _invariant(
          specPolicy === 'DEFINE_MANY_MERGED',
          'ReactClass: You are attempting to define ' +
            '`%s` on your component more than once. This conflict may be ' +
            'due to a mixin.',
          name
        );

        Constructor[name] = createMergedResultFunction(Constructor[name], property);

        return;
      }

      Constructor[name] = property;
    }
  }

  /**
   * Merge two objects, but throw if both contain the same key.
   *
   * @param {object} one The first object, which is mutated.
   * @param {object} two The second object
   * @return {object} one after it has been mutated to contain everything in two.
   */
  function mergeIntoWithNoDuplicateKeys(one, two) {
    _invariant(
      one && two && typeof one === 'object' && typeof two === 'object',
      'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.'
    );

    for (var key in two) {
      if (two.hasOwnProperty(key)) {
        _invariant(
          one[key] === undefined,
          'mergeIntoWithNoDuplicateKeys(): ' +
            'Tried to merge two objects with the same key: `%s`. This conflict ' +
            'may be due to a mixin; in particular, this may be caused by two ' +
            'getInitialState() or getDefaultProps() methods returning objects ' +
            'with clashing keys.',
          key
        );
        one[key] = two[key];
      }
    }
    return one;
  }

  /**
   * Creates a function that invokes two functions and merges their return values.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */
  function createMergedResultFunction(one, two) {
    return function mergedResult() {
      var a = one.apply(this, arguments);
      var b = two.apply(this, arguments);
      if (a == null) {
        return b;
      } else if (b == null) {
        return a;
      }
      var c = {};
      mergeIntoWithNoDuplicateKeys(c, a);
      mergeIntoWithNoDuplicateKeys(c, b);
      return c;
    };
  }

  /**
   * Creates a function that invokes two functions and ignores their return vales.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */
  function createChainedFunction(one, two) {
    return function chainedFunction() {
      one.apply(this, arguments);
      two.apply(this, arguments);
    };
  }

  /**
   * Binds a method to the component.
   *
   * @param {object} component Component whose method is going to be bound.
   * @param {function} method Method to be bound.
   * @return {function} The bound method.
   */
  function bindAutoBindMethod(component, method) {
    var boundMethod = method.bind(component);
    if (false) { var _bind, componentName; }
    return boundMethod;
  }

  /**
   * Binds all auto-bound methods in a component.
   *
   * @param {object} component Component whose method is going to be bound.
   */
  function bindAutoBindMethods(component) {
    var pairs = component.__reactAutoBindPairs;
    for (var i = 0; i < pairs.length; i += 2) {
      var autoBindKey = pairs[i];
      var method = pairs[i + 1];
      component[autoBindKey] = bindAutoBindMethod(component, method);
    }
  }

  var IsMountedPreMixin = {
    componentDidMount: function() {
      this.__isMounted = true;
    }
  };

  var IsMountedPostMixin = {
    componentWillUnmount: function() {
      this.__isMounted = false;
    }
  };

  /**
   * Add more to the ReactClass base class. These are all legacy features and
   * therefore not already part of the modern ReactComponent.
   */
  var ReactClassMixin = {
    /**
     * TODO: This will be deprecated because state should always keep a consistent
     * type signature and the only use case for this, is to avoid that.
     */
    replaceState: function(newState, callback) {
      this.updater.enqueueReplaceState(this, newState, callback);
    },

    /**
     * Checks whether or not this composite component is mounted.
     * @return {boolean} True if mounted, false otherwise.
     * @protected
     * @final
     */
    isMounted: function() {
      if (false) {}
      return !!this.__isMounted;
    }
  };

  var ReactClassComponent = function() {};
  _assign(
    ReactClassComponent.prototype,
    ReactComponent.prototype,
    ReactClassMixin
  );

  /**
   * Creates a composite component class given a class specification.
   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
   *
   * @param {object} spec Class specification (which must define `render`).
   * @return {function} Component constructor function.
   * @public
   */
  function createClass(spec) {
    // To keep our warnings more understandable, we'll use a little hack here to
    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
    // unnecessarily identify a class without displayName as 'Constructor'.
    var Constructor = identity(function(props, context, updater) {
      // This constructor gets overridden by mocks. The argument is used
      // by mocks to assert on what gets mounted.

      if (false) {}

      // Wire up auto-binding
      if (this.__reactAutoBindPairs.length) {
        bindAutoBindMethods(this);
      }

      this.props = props;
      this.context = context;
      this.refs = emptyObject;
      this.updater = updater || ReactNoopUpdateQueue;

      this.state = null;

      // ReactClasses doesn't have constructors. Instead, they use the
      // getInitialState and componentWillMount methods for initialization.

      var initialState = this.getInitialState ? this.getInitialState() : null;
      if (false) {}
      _invariant(
        typeof initialState === 'object' && !Array.isArray(initialState),
        '%s.getInitialState(): must return an object or null',
        Constructor.displayName || 'ReactCompositeComponent'
      );

      this.state = initialState;
    });
    Constructor.prototype = new ReactClassComponent();
    Constructor.prototype.constructor = Constructor;
    Constructor.prototype.__reactAutoBindPairs = [];

    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));

    mixSpecIntoComponent(Constructor, IsMountedPreMixin);
    mixSpecIntoComponent(Constructor, spec);
    mixSpecIntoComponent(Constructor, IsMountedPostMixin);

    // Initialize the defaultProps property after all mixins have been merged.
    if (Constructor.getDefaultProps) {
      Constructor.defaultProps = Constructor.getDefaultProps();
    }

    if (false) {}

    _invariant(
      Constructor.prototype.render,
      'createClass(...): Class specification must implement a `render` method.'
    );

    if (false) {}

    // Reduce time spent doing lookups by setting these on the prototype.
    for (var methodName in ReactClassInterface) {
      if (!Constructor.prototype[methodName]) {
        Constructor.prototype[methodName] = null;
      }
    }

    return Constructor;
  }

  return createClass;
}

module.exports = factory;


/***/ }),

/***/ 77439:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var React = __webpack_require__(91987);
var factory = __webpack_require__(2720);

if (typeof React === 'undefined') {
  throw Error(
    'create-react-class could not find the React object. If you are using script tags, ' +
      'make sure that React is being loaded before create-react-class.'
  );
}

// Hack to grab NoopUpdateQueue from isomorphic React
var ReactNoopUpdateQueue = new React.Component().updater;

module.exports = factory(
  React.Component,
  React.isValidElement,
  ReactNoopUpdateQueue
);


/***/ }),

/***/ 22171:
/***/ (function(module, exports) {

var global = typeof self !== 'undefined' ? self : this;
var __self__ = (function () {
function F() {
this.fetch = false;
this.DOMException = global.DOMException
}
F.prototype = global;
return new F();
})();
(function(self) {

var irrelevant = (function (exports) {

  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob:
      'FileReader' in self &&
      'Blob' in self &&
      (function() {
        try {
          new Blob();
          return true
        } catch (e) {
          return false
        }
      })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  };

  function isDataView(obj) {
    return obj && DataView.prototype.isPrototypeOf(obj)
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ];

    var isArrayBufferView =
      ArrayBuffer.isView ||
      function(obj) {
        return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
      };
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name);
    }
    if (/[^a-z0-9\-#$%&'*+.^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value);
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift();
        return {done: value === undefined, value: value}
      }
    };

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator
      };
    }

    return iterator
  }

  function Headers(headers) {
    this.map = {};

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value);
      }, this);
    } else if (Array.isArray(headers)) {
      headers.forEach(function(header) {
        this.append(header[0], header[1]);
      }, this);
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name]);
      }, this);
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name);
    value = normalizeValue(value);
    var oldValue = this.map[name];
    this.map[name] = oldValue ? oldValue + ', ' + value : value;
  };

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)];
  };

  Headers.prototype.get = function(name) {
    name = normalizeName(name);
    return this.has(name) ? this.map[name] : null
  };

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  };

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value);
  };

  Headers.prototype.forEach = function(callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this);
      }
    }
  };

  Headers.prototype.keys = function() {
    var items = [];
    this.forEach(function(value, name) {
      items.push(name);
    });
    return iteratorFor(items)
  };

  Headers.prototype.values = function() {
    var items = [];
    this.forEach(function(value) {
      items.push(value);
    });
    return iteratorFor(items)
  };

  Headers.prototype.entries = function() {
    var items = [];
    this.forEach(function(value, name) {
      items.push([name, value]);
    });
    return iteratorFor(items)
  };

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries;
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true;
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result);
      };
      reader.onerror = function() {
        reject(reader.error);
      };
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader();
    var promise = fileReaderReady(reader);
    reader.readAsArrayBuffer(blob);
    return promise
  }

  function readBlobAsText(blob) {
    var reader = new FileReader();
    var promise = fileReaderReady(reader);
    reader.readAsText(blob);
    return promise
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf);
    var chars = new Array(view.length);

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i]);
    }
    return chars.join('')
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength);
      view.set(new Uint8Array(buf));
      return view.buffer
    }
  }

  function Body() {
    this.bodyUsed = false;

    this._initBody = function(body) {
      this._bodyInit = body;
      if (!body) {
        this._bodyText = '';
      } else if (typeof body === 'string') {
        this._bodyText = body;
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body;
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body;
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString();
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer);
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer]);
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body);
      } else {
        this._bodyText = body = Object.prototype.toString.call(body);
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8');
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type);
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8');
        }
      }
    };

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this);
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      };

      this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
        } else {
          return this.blob().then(readBlobAsArrayBuffer)
        }
      };
    }

    this.text = function() {
      var rejected = consumed(this);
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    };

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      };
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    };

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT'];

  function normalizeMethod(method) {
    var upcased = method.toUpperCase();
    return methods.indexOf(upcased) > -1 ? upcased : method
  }

  function Request(input, options) {
    options = options || {};
    var body = options.body;

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url;
      this.credentials = input.credentials;
      if (!options.headers) {
        this.headers = new Headers(input.headers);
      }
      this.method = input.method;
      this.mode = input.mode;
      this.signal = input.signal;
      if (!body && input._bodyInit != null) {
        body = input._bodyInit;
        input.bodyUsed = true;
      }
    } else {
      this.url = String(input);
    }

    this.credentials = options.credentials || this.credentials || 'same-origin';
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers);
    }
    this.method = normalizeMethod(options.method || this.method || 'GET');
    this.mode = options.mode || this.mode || null;
    this.signal = options.signal || this.signal;
    this.referrer = null;

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body);
  }

  Request.prototype.clone = function() {
    return new Request(this, {body: this._bodyInit})
  };

  function decode(body) {
    var form = new FormData();
    body
      .trim()
      .split('&')
      .forEach(function(bytes) {
        if (bytes) {
          var split = bytes.split('=');
          var name = split.shift().replace(/\+/g, ' ');
          var value = split.join('=').replace(/\+/g, ' ');
          form.append(decodeURIComponent(name), decodeURIComponent(value));
        }
      });
    return form
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers();
    // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
    // https://tools.ietf.org/html/rfc7230#section-3.2
    var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, ' ');
    preProcessedHeaders.split(/\r?\n/).forEach(function(line) {
      var parts = line.split(':');
      var key = parts.shift().trim();
      if (key) {
        var value = parts.join(':').trim();
        headers.append(key, value);
      }
    });
    return headers
  }

  Body.call(Request.prototype);

  function Response(bodyInit, options) {
    if (!options) {
      options = {};
    }

    this.type = 'default';
    this.status = options.status === undefined ? 200 : options.status;
    this.ok = this.status >= 200 && this.status < 300;
    this.statusText = 'statusText' in options ? options.statusText : 'OK';
    this.headers = new Headers(options.headers);
    this.url = options.url || '';
    this._initBody(bodyInit);
  }

  Body.call(Response.prototype);

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  };

  Response.error = function() {
    var response = new Response(null, {status: 0, statusText: ''});
    response.type = 'error';
    return response
  };

  var redirectStatuses = [301, 302, 303, 307, 308];

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  };

  exports.DOMException = self.DOMException;
  try {
    new exports.DOMException();
  } catch (err) {
    exports.DOMException = function(message, name) {
      this.message = message;
      this.name = name;
      var error = Error(message);
      this.stack = error.stack;
    };
    exports.DOMException.prototype = Object.create(Error.prototype);
    exports.DOMException.prototype.constructor = exports.DOMException;
  }

  function fetch(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init);

      if (request.signal && request.signal.aborted) {
        return reject(new exports.DOMException('Aborted', 'AbortError'))
      }

      var xhr = new XMLHttpRequest();

      function abortXhr() {
        xhr.abort();
      }

      xhr.onload = function() {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        };
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL');
        var body = 'response' in xhr ? xhr.response : xhr.responseText;
        resolve(new Response(body, options));
      };

      xhr.onerror = function() {
        reject(new TypeError('Network request failed'));
      };

      xhr.ontimeout = function() {
        reject(new TypeError('Network request failed'));
      };

      xhr.onabort = function() {
        reject(new exports.DOMException('Aborted', 'AbortError'));
      };

      xhr.open(request.method, request.url, true);

      if (request.credentials === 'include') {
        xhr.withCredentials = true;
      } else if (request.credentials === 'omit') {
        xhr.withCredentials = false;
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob';
      }

      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value);
      });

      if (request.signal) {
        request.signal.addEventListener('abort', abortXhr);

        xhr.onreadystatechange = function() {
          // DONE (success or failure)
          if (xhr.readyState === 4) {
            request.signal.removeEventListener('abort', abortXhr);
          }
        };
      }

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit);
    })
  }

  fetch.polyfill = true;

  if (!self.fetch) {
    self.fetch = fetch;
    self.Headers = Headers;
    self.Request = Request;
    self.Response = Response;
  }

  exports.Headers = Headers;
  exports.Request = Request;
  exports.Response = Response;
  exports.fetch = fetch;

  Object.defineProperty(exports, '__esModule', { value: true });

  return exports;

})({});
})(__self__);
__self__.fetch.ponyfill = true;
// Remove "polyfill" property added by whatwg-fetch
delete __self__.fetch.polyfill;
// Choose between native implementation (global) or custom implementation (__self__)
// var ctx = global.fetch ? global : __self__;
var ctx = __self__; // this line disable service worker support temporarily
exports = ctx.fetch // To enable: import fetch from 'cross-fetch'
exports["default"] = ctx.fetch // For TypeScript consumers without esModuleInterop.
exports.fetch = ctx.fetch // To enable: import {fetch} from 'cross-fetch'
exports.Headers = ctx.Headers
exports.Request = ctx.Request
exports.Response = ctx.Response
module.exports = exports


/***/ }),

/***/ 22836:
/***/ (function(module) {

"use strict";


function useNative() {
	if (typeof window.CustomEvent === 'function') {
		return true;
	}

	return false;
}

// https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent/CustomEvent
module.exports = useNative() ? window.CustomEvent : function (event, params) {
	var e = document.createEvent('CustomEvent');

	params = params || {
		bubbles: false,
		cancelable: false,
		detail: undefined
	};

	e.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);

	return e;
};


/***/ }),

/***/ 96687:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ requiredArgs; }
/* harmony export */ });
function requiredArgs(required, args) {
  if (args.length < required) {
    throw new TypeError(required + ' argument' + (required > 1 ? 's' : '') + ' required, but only ' + args.length + ' present');
  }
}

/***/ }),

/***/ 4049:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ toInteger; }
/* harmony export */ });
function toInteger(dirtyNumber) {
  if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) {
    return NaN;
  }

  var number = Number(dirtyNumber);

  if (isNaN(number)) {
    return number;
  }

  return number < 0 ? Math.ceil(number) : Math.floor(number);
}

/***/ }),

/***/ 19409:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ addMilliseconds; }
/* harmony export */ });
/* harmony import */ var _lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4049);
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47714);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96687);



/**
 * @name addMilliseconds
 * @category Millisecond Helpers
 * @summary Add the specified number of milliseconds to the given date.
 *
 * @description
 * Add the specified number of milliseconds to the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of milliseconds to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the milliseconds added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 750 milliseconds to 10 July 2014 12:45:30.000:
 * const result = addMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:30.750
 */

function addMilliseconds(dirtyDate, dirtyAmount) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(2, arguments);
  var timestamp = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(dirtyDate).getTime();
  var amount = (0,_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(dirtyAmount);
  return new Date(timestamp + amount);
}

/***/ }),

/***/ 48826:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ addSeconds; }
/* harmony export */ });
/* harmony import */ var _lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4049);
/* harmony import */ var _addMilliseconds_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19409);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96687);



/**
 * @name addSeconds
 * @category Second Helpers
 * @summary Add the specified number of seconds to the given date.
 *
 * @description
 * Add the specified number of seconds to the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of seconds to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the seconds added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 30 seconds to 10 July 2014 12:45:00:
 * const result = addSeconds(new Date(2014, 6, 10, 12, 45, 0), 30)
 * //=> Thu Jul 10 2014 12:45:30
 */

function addSeconds(dirtyDate, dirtyAmount) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(2, arguments);
  var amount = (0,_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(dirtyAmount);
  return (0,_addMilliseconds_index_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(dirtyDate, amount * 1000);
}

/***/ }),

/***/ 47714:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ toDate; }
/* harmony export */ });
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96687);

/**
 * @name toDate
 * @category Common Helpers
 * @summary Convert the given argument to an instance of Date.
 *
 * @description
 * Convert the given argument to an instance of Date.
 *
 * If the argument is an instance of Date, the function returns its clone.
 *
 * If the argument is a number, it is treated as a timestamp.
 *
 * If the argument is none of the above, the function returns Invalid Date.
 *
 * **Note**: *all* Date arguments passed to any *date-fns* function is processed by `toDate`.
 *
 * @param {Date|Number} argument - the value to convert
 * @returns {Date} the parsed date in the local time zone
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Clone the date:
 * const result = toDate(new Date(2014, 1, 11, 11, 30, 30))
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert the timestamp to date:
 * const result = toDate(1392098430000)
 * //=> Tue Feb 11 2014 11:30:30
 */

function toDate(argument) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(1, arguments);
  var argStr = Object.prototype.toString.call(argument); // Clone the date

  if (argument instanceof Date || typeof argument === 'object' && argStr === '[object Date]') {
    // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
  } else if (typeof argument === 'number' || argStr === '[object Number]') {
    return new Date(argument);
  } else {
    if ((typeof argument === 'string' || argStr === '[object String]') && typeof console !== 'undefined') {
      // eslint-disable-next-line no-console
      console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://git.io/fjule"); // eslint-disable-next-line no-console

      console.warn(new Error().stack);
    }

    return new Date(NaN);
  }
}

/***/ }),

/***/ 81767:
/***/ (function(module) {

"use strict";

var token = '%[a-f0-9]{2}';
var singleMatcher = new RegExp(token, 'gi');
var multiMatcher = new RegExp('(' + token + ')+', 'gi');

function decodeComponents(components, split) {
	try {
		// Try to decode the entire string first
		return decodeURIComponent(components.join(''));
	} catch (err) {
		// Do nothing
	}

	if (components.length === 1) {
		return components;
	}

	split = split || 1;

	// Split the array in 2 parts
	var left = components.slice(0, split);
	var right = components.slice(split);

	return Array.prototype.concat.call([], decodeComponents(left), decodeComponents(right));
}

function decode(input) {
	try {
		return decodeURIComponent(input);
	} catch (err) {
		var tokens = input.match(singleMatcher);

		for (var i = 1; i < tokens.length; i++) {
			input = decodeComponents(tokens, i).join('');

			tokens = input.match(singleMatcher);
		}

		return input;
	}
}

function customDecodeURIComponent(input) {
	// Keep track of all the replacements and prefill the map with the `BOM`
	var replaceMap = {
		'%FE%FF': '\uFFFD\uFFFD',
		'%FF%FE': '\uFFFD\uFFFD'
	};

	var match = multiMatcher.exec(input);
	while (match) {
		try {
			// Decode as big chunks as possible
			replaceMap[match[0]] = decodeURIComponent(match[0]);
		} catch (err) {
			var result = decode(match[0]);

			if (result !== match[0]) {
				replaceMap[match[0]] = result;
			}
		}

		match = multiMatcher.exec(input);
	}

	// Add `%C2` at the end of the map to make sure it does not replace the combinator before everything else
	replaceMap['%C2'] = '\uFFFD';

	var entries = Object.keys(replaceMap);

	for (var i = 0; i < entries.length; i++) {
		// Replace all decoded components
		var key = entries[i];
		input = input.replace(new RegExp(key, 'g'), replaceMap[key]);
	}

	return input;
}

module.exports = function (encodedURI) {
	if (typeof encodedURI !== 'string') {
		throw new TypeError('Expected `encodedURI` to be of type `string`, got `' + typeof encodedURI + '`');
	}

	try {
		encodedURI = encodedURI.replace(/\+/g, ' ');

		// Try the built in decoder first
		return decodeURIComponent(encodedURI);
	} catch (err) {
		// Fallback to a more advanced decoder
		return customDecodeURIComponent(encodedURI);
	}
};


/***/ }),

/***/ 11306:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
var isMergeableObject = function isMergeableObject(value) {
	return isNonNullObject(value)
		&& !isSpecial(value)
};

function isNonNullObject(value) {
	return !!value && typeof value === 'object'
}

function isSpecial(value) {
	var stringValue = Object.prototype.toString.call(value);

	return stringValue === '[object RegExp]'
		|| stringValue === '[object Date]'
		|| isReactElement(value)
}

// see https://github.com/facebook/react/blob/b5ac963fb791d1298e7f396236383bc955f916c1/src/isomorphic/classic/element/ReactElement.js#L21-L25
var canUseSymbol = typeof Symbol === 'function' && Symbol.for;
var REACT_ELEMENT_TYPE = canUseSymbol ? Symbol.for('react.element') : 0xeac7;

function isReactElement(value) {
	return value.$$typeof === REACT_ELEMENT_TYPE
}

function emptyTarget(val) {
	return Array.isArray(val) ? [] : {}
}

function cloneUnlessOtherwiseSpecified(value, options) {
	return (options.clone !== false && options.isMergeableObject(value))
		? deepmerge(emptyTarget(value), value, options)
		: value
}

function defaultArrayMerge(target, source, options) {
	return target.concat(source).map(function(element) {
		return cloneUnlessOtherwiseSpecified(element, options)
	})
}

function mergeObject(target, source, options) {
	var destination = {};
	if (options.isMergeableObject(target)) {
		Object.keys(target).forEach(function(key) {
			destination[key] = cloneUnlessOtherwiseSpecified(target[key], options);
		});
	}
	Object.keys(source).forEach(function(key) {
		if (!options.isMergeableObject(source[key]) || !target[key]) {
			destination[key] = cloneUnlessOtherwiseSpecified(source[key], options);
		} else {
			destination[key] = deepmerge(target[key], source[key], options);
		}
	});
	return destination
}

function deepmerge(target, source, options) {
	options = options || {};
	options.arrayMerge = options.arrayMerge || defaultArrayMerge;
	options.isMergeableObject = options.isMergeableObject || isMergeableObject;

	var sourceIsArray = Array.isArray(source);
	var targetIsArray = Array.isArray(target);
	var sourceAndTargetTypesMatch = sourceIsArray === targetIsArray;

	if (!sourceAndTargetTypesMatch) {
		return cloneUnlessOtherwiseSpecified(source, options)
	} else if (sourceIsArray) {
		return options.arrayMerge(target, source, options)
	} else {
		return mergeObject(target, source, options)
	}
}

deepmerge.all = function deepmergeAll(array, options) {
	if (!Array.isArray(array)) {
		throw new Error('first argument should be an array')
	}

	return array.reduce(function(prev, next) {
		return deepmerge(prev, next, options)
	}, {})
};

var deepmerge_1 = deepmerge;

/* harmony default export */ __webpack_exports__["default"] = (deepmerge_1);


/***/ }),

/***/ 81951:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var React = __webpack_require__(91987);
var config = __webpack_require__(41327);
var classNames = __webpack_require__(43226);
var createClass = __webpack_require__(77439);
var scriptLoader = __webpack_require__(40433);

var window = __webpack_require__(63573);

module.exports = function (scope) {
  return createClass({
    componentDidMount: function componentDidMount() {
      var t = this;
      var props = Object.assign({}, t.props);
      if (window.DemoUpPlaybuttonRenderer) {
        window.DemoUpPlaybuttonRenderer(t.$container, props);
      } else {
        scriptLoader(config.stage2Path(scope, this.props.mode), function () {
          t.forceUpdate(function () {
            window.DemoUpPlaybuttonRenderer && window.DemoUpPlaybuttonRenderer(t.$container, props);
          });
        });
      }
    },

    componentWillUnmount: function componentWillUnmount() {
      var CrossCustomEvent = __webpack_require__(22836);
      document.dispatchEvent(new CrossCustomEvent("demoup.unmounted", {
        detail: {
          node: this.$container
        }
      }));
    },

    setRef: function setRef(node) {
      this.$container = node;
    },

    render: function render() {
      var props = this.props;
      return React.createElement(
        "div",
        _extends({}, props.nodeAttrs, {
          className: classNames("demoup-trigger", props.className),
          id: "demoup_stage2_script",
          ref: this.setRef,
          src: config.stage3Path(scope)
        }),
        window && window.DemoUpPlaybuttonRenderer ? null : props.children
      );
    }
  });
};

/***/ }),

/***/ 41327:
/***/ (function(module) {

"use strict";


module.exports = {
  stage2Path: function stage2Path(scope, mode) {
    if (false) {} else if (mode === "local") {
      return "//localhost:8080/" + scope + "/playbuttonRenderer.min.js";
    } else {
      return "//static.demoup.com/" + scope + "/playbuttonRenderer.min.js";
    }
  },
  containerPath: function containerPath(scope, mode) {
    if (false) {} else if (false) {} else {
      return "//static.demoup.com/" + scope + "/playbuttonContainer.min.js";
    }
  },
  stage3Path: function stage3Path(scope) {
    if (false) {} else {
      return "//static.demoup.com/" + scope + "/stage3.min.js";
    }
  },
  playerRenderer: function playerRenderer(scope) {
    if (false) {} else {
      return "//static.demoup.com/" + scope + "/playerRenderer.min.js";
    }
  }
};

/***/ }),

/***/ 33170:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var React = __webpack_require__(91987);
var config = __webpack_require__(41327);
var classNames = __webpack_require__(43226);
var createClass = __webpack_require__(77439);
var scriptLoader = __webpack_require__(40433);

module.exports = function (scope) {
  return createClass({
    getInitialState: function getInitialState() {
      return {
        videosAvailable: 0,
        videos: []
      };
    },


    componentDidMount: function componentDidMount() {
      var t = this;

      if (window.DemoUpContainerRenderer) {
        return;
      } else {
        scriptLoader(config.containerPath(scope, this.props.mode), function () {
          if (window.DemoUpInfoFetcher) {
            window.DemoUpInfoFetcher(t.props, function (videos) {
              t.setState({ videosAvailable: videos.length });
              t.setState({ videos: videos });
            });
          }
        });
      }
    },

    componentWillUnmount: function componentWillUnmount() {
      document.dispatchEvent(new CustomEvent("demoup.unmounted"));
    },

    setRef: function setRef(node) {
      this.$container = node;
    },

    render: function render() {
      var _this = this;

      var props = this.props;
      var childrenWithProps = React.Children.map(this.props.children, function (child) {
        return React.cloneElement(child, {
          videosAvailable: _this.state.videosAvailable,
          videos: _this.state.videos,
          threed: props.threed
        });
      });

      return React.createElement(
        "div",
        _extends({}, props, {
          className: classNames("demoup-container", props.className),
          ref: this.setRef,
          src: config.stage3Path(scope)
        }),
        childrenWithProps
      );
    }
  });
};

/***/ }),

/***/ 78551:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


module.exports = function (scope) {
	var buttonCreator = __webpack_require__(81951);
	var playerCreator = __webpack_require__(99417);
	var containerCreator = __webpack_require__(33170);
	return {
		button: buttonCreator(scope),
		player: playerCreator(scope),
		container: containerCreator(scope)
	};
};

/***/ }),

/***/ 99417:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(91987);

var config = __webpack_require__(41327);
var classNames = __webpack_require__(43226);
var createClass = __webpack_require__(77439);
var scriptLoader = __webpack_require__(40433);

module.exports = function (scope) {
  return createClass({
    componentDidMount: function componentDidMount() {
      var t = this;
      if (window.DemoUpPlayerRenderer) {
        window.DemoUpPlayerRenderer(t.$container, t.props);
      } else {
        scriptLoader(config.playerRenderer(scope), function () {
          window.DemoUpPlayerRenderer && window.DemoUpPlayerRenderer(t.$container, t.props);
        });
      }
    },

    componentWillUnmount: function componentWillUnmount() {
      var CrossCustomEvent = __webpack_require__(22836);
      document.dispatchEvent(new CrossCustomEvent("demoup.unmounted"));
    },

    setRef: function setRef(node) {
      this.$container = node;
    },

    render: function render() {
      return React.createElement("div", {
        className: classNames("demoup-player", this.props.className),
        ref: this.setRef
      });
    }
  });
};

/***/ }),

/***/ 89381:
/***/ (function(module) {

"use strict";


module.exports = function ReactNativeFile(_ref) {
  var uri = _ref.uri,
    name = _ref.name,
    type = _ref.type;
  this.uri = uri;
  this.name = name;
  this.type = type;
};


/***/ }),

/***/ 98902:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var defaultIsExtractableFile = __webpack_require__(66458);

module.exports = function extractFiles(value, path, isExtractableFile) {
  if (path === void 0) {
    path = '';
  }

  if (isExtractableFile === void 0) {
    isExtractableFile = defaultIsExtractableFile;
  }

  var clone;
  var files = new Map();

  function addFile(paths, file) {
    var storedPaths = files.get(file);
    if (storedPaths) storedPaths.push.apply(storedPaths, paths);
    else files.set(file, paths);
  }

  if (isExtractableFile(value)) {
    clone = null;
    addFile([path], value);
  } else {
    var prefix = path ? path + '.' : '';
    if (typeof FileList !== 'undefined' && value instanceof FileList)
      clone = Array.prototype.map.call(value, function (file, i) {
        addFile(['' + prefix + i], file);
        return null;
      });
    else if (Array.isArray(value))
      clone = value.map(function (child, i) {
        var result = extractFiles(child, '' + prefix + i, isExtractableFile);
        result.files.forEach(addFile);
        return result.clone;
      });
    else if (value && value.constructor === Object) {
      clone = {};

      for (var i in value) {
        var result = extractFiles(value[i], '' + prefix + i, isExtractableFile);
        result.files.forEach(addFile);
        clone[i] = result.clone;
      }
    } else clone = value;
  }

  return {
    clone: clone,
    files: files,
  };
};


/***/ }),

/***/ 66458:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var ReactNativeFile = __webpack_require__(89381);

module.exports = function isExtractableFile(value) {
  return (
    (typeof File !== 'undefined' && value instanceof File) ||
    (typeof Blob !== 'undefined' && value instanceof Blob) ||
    value instanceof ReactNativeFile
  );
};


/***/ }),

/***/ 37689:
/***/ (function(module) {

"use strict";

module.exports = function (obj, predicate) {
	var ret = {};
	var keys = Object.keys(obj);
	var isArr = Array.isArray(predicate);

	for (var i = 0; i < keys.length; i++) {
		var key = keys[i];
		var val = obj[key];

		if (isArr ? predicate.indexOf(key) !== -1 : predicate(key, val, obj)) {
			ret[key] = val;
		}
	}

	return ret;
};


/***/ }),

/***/ 88388:
/***/ (function(module) {

/* eslint-env browser */
module.exports = typeof self == 'object' ? self.FormData : window.FormData;


/***/ }),

/***/ 63573:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var win;

if (typeof window !== "undefined") {
    win = window;
} else if (typeof __webpack_require__.g !== "undefined") {
    win = __webpack_require__.g;
} else if (typeof self !== "undefined"){
    win = self;
} else {
    win = {};
}

module.exports = win;


/***/ }),

/***/ 26504:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var reactIs = __webpack_require__(52744);

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
  childContextTypes: true,
  contextType: true,
  contextTypes: true,
  defaultProps: true,
  displayName: true,
  getDefaultProps: true,
  getDerivedStateFromError: true,
  getDerivedStateFromProps: true,
  mixins: true,
  propTypes: true,
  type: true
};
var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};
var FORWARD_REF_STATICS = {
  '$$typeof': true,
  render: true,
  defaultProps: true,
  displayName: true,
  propTypes: true
};
var MEMO_STATICS = {
  '$$typeof': true,
  compare: true,
  defaultProps: true,
  displayName: true,
  propTypes: true,
  type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;

function getStatics(component) {
  // React v16.11 and below
  if (reactIs.isMemo(component)) {
    return MEMO_STATICS;
  } // React v16.12 and above


  return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
}

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;
function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
  if (typeof sourceComponent !== 'string') {
    // don't hoist over string (html) components
    if (objectPrototype) {
      var inheritedComponent = getPrototypeOf(sourceComponent);

      if (inheritedComponent && inheritedComponent !== objectPrototype) {
        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
      }
    }

    var keys = getOwnPropertyNames(sourceComponent);

    if (getOwnPropertySymbols) {
      keys = keys.concat(getOwnPropertySymbols(sourceComponent));
    }

    var targetStatics = getStatics(targetComponent);
    var sourceStatics = getStatics(sourceComponent);

    for (var i = 0; i < keys.length; ++i) {
      var key = keys[i];

      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);

        try {
          // Avoid failures from read-only properties
          defineProperty(targetComponent, key, descriptor);
        } catch (e) {}
      }
    }
  }

  return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),

/***/ 40433:
/***/ (function(module) {


module.exports = function load (src, opts, cb) {
  var head = document.head || document.getElementsByTagName('head')[0]
  var script = document.createElement('script')

  if (typeof opts === 'function') {
    cb = opts
    opts = {}
  }

  opts = opts || {}
  cb = cb || function() {}

  script.type = opts.type || 'text/javascript'
  script.charset = opts.charset || 'utf8';
  script.async = 'async' in opts ? !!opts.async : true
  script.src = src

  if (opts.attrs) {
    setAttributes(script, opts.attrs)
  }

  if (opts.text) {
    script.text = '' + opts.text
  }

  var onend = 'onload' in script ? stdOnEnd : ieOnEnd
  onend(script, cb)

  // some good legacy browsers (firefox) fail the 'in' detection above
  // so as a fallback we always set onload
  // old IE will ignore this and new IE will set onload
  if (!script.onload) {
    stdOnEnd(script, cb);
  }

  head.appendChild(script)
}

function setAttributes(script, attrs) {
  for (var attr in attrs) {
    script.setAttribute(attr, attrs[attr]);
  }
}

function stdOnEnd (script, cb) {
  script.onload = function () {
    this.onerror = this.onload = null
    cb(null, script)
  }
  script.onerror = function () {
    // this.onload = null here is necessary
    // because even IE9 works not like others
    this.onerror = this.onload = null
    cb(new Error('Failed to load ' + this.src), script)
  }
}

function ieOnEnd (script, cb) {
  script.onreadystatechange = function () {
    if (this.readyState != 'complete' && this.readyState != 'loaded') return
    this.onreadystatechange = null
    cb(null, script) // there is no way to catch loading errors in IE8
  }
}


/***/ }),

/***/ 80194:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(92651),
    root = __webpack_require__(74329);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView');

module.exports = DataView;


/***/ }),

/***/ 19155:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var hashClear = __webpack_require__(16673),
    hashDelete = __webpack_require__(49605),
    hashGet = __webpack_require__(9687),
    hashHas = __webpack_require__(71972),
    hashSet = __webpack_require__(10863);

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

module.exports = Hash;


/***/ }),

/***/ 52970:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var listCacheClear = __webpack_require__(98886),
    listCacheDelete = __webpack_require__(26457),
    listCacheGet = __webpack_require__(78108),
    listCacheHas = __webpack_require__(7765),
    listCacheSet = __webpack_require__(9142);

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

module.exports = ListCache;


/***/ }),

/***/ 62602:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(92651),
    root = __webpack_require__(74329);

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map');

module.exports = Map;


/***/ }),

/***/ 97372:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var mapCacheClear = __webpack_require__(34692),
    mapCacheDelete = __webpack_require__(77238),
    mapCacheGet = __webpack_require__(39615),
    mapCacheHas = __webpack_require__(91336),
    mapCacheSet = __webpack_require__(5084);

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

module.exports = MapCache;


/***/ }),

/***/ 73057:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(92651),
    root = __webpack_require__(74329);

/* Built-in method references that are verified to be native. */
var Promise = getNative(root, 'Promise');

module.exports = Promise;


/***/ }),

/***/ 6559:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(92651),
    root = __webpack_require__(74329);

/* Built-in method references that are verified to be native. */
var Set = getNative(root, 'Set');

module.exports = Set;


/***/ }),

/***/ 56041:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var MapCache = __webpack_require__(97372),
    setCacheAdd = __webpack_require__(43312),
    setCacheHas = __webpack_require__(74201);

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

module.exports = SetCache;


/***/ }),

/***/ 34395:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var ListCache = __webpack_require__(52970),
    stackClear = __webpack_require__(77617),
    stackDelete = __webpack_require__(63783),
    stackGet = __webpack_require__(79935),
    stackHas = __webpack_require__(59236),
    stackSet = __webpack_require__(39346);

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

module.exports = Stack;


/***/ }),

/***/ 90877:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var root = __webpack_require__(74329);

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),

/***/ 99904:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var root = __webpack_require__(74329);

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

module.exports = Uint8Array;


/***/ }),

/***/ 74215:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(92651),
    root = __webpack_require__(74329);

/* Built-in method references that are verified to be native. */
var WeakMap = getNative(root, 'WeakMap');

module.exports = WeakMap;


/***/ }),

/***/ 96736:
/***/ (function(module) {

/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEach(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

module.exports = arrayEach;


/***/ }),

/***/ 39574:
/***/ (function(module) {

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

module.exports = arrayFilter;


/***/ }),

/***/ 46681:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseTimes = __webpack_require__(73803),
    isArguments = __webpack_require__(52441),
    isArray = __webpack_require__(24609),
    isBuffer = __webpack_require__(65211),
    isIndex = __webpack_require__(32850),
    isTypedArray = __webpack_require__(36603);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = arrayLikeKeys;


/***/ }),

/***/ 8106:
/***/ (function(module) {

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

module.exports = arrayMap;


/***/ }),

/***/ 83309:
/***/ (function(module) {

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

module.exports = arrayPush;


/***/ }),

/***/ 81785:
/***/ (function(module) {

/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */
function arrayReduce(array, iteratee, accumulator, initAccum) {
  var index = -1,
      length = array == null ? 0 : array.length;

  if (initAccum && length) {
    accumulator = array[++index];
  }
  while (++index < length) {
    accumulator = iteratee(accumulator, array[index], index, array);
  }
  return accumulator;
}

module.exports = arrayReduce;


/***/ }),

/***/ 40898:
/***/ (function(module) {

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

module.exports = arraySome;


/***/ }),

/***/ 97677:
/***/ (function(module) {

/**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function asciiToArray(string) {
  return string.split('');
}

module.exports = asciiToArray;


/***/ }),

/***/ 26586:
/***/ (function(module) {

/** Used to match words composed of alphanumeric characters. */
var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

/**
 * Splits an ASCII `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */
function asciiWords(string) {
  return string.match(reAsciiWord) || [];
}

module.exports = asciiWords;


/***/ }),

/***/ 887:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(20852),
    eq = __webpack_require__(18213);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

module.exports = assignValue;


/***/ }),

/***/ 35256:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var eq = __webpack_require__(18213);

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

module.exports = assocIndexOf;


/***/ }),

/***/ 45903:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var copyObject = __webpack_require__(99568),
    keys = __webpack_require__(28220);

/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssign(object, source) {
  return object && copyObject(source, keys(source), object);
}

module.exports = baseAssign;


/***/ }),

/***/ 52749:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var copyObject = __webpack_require__(99568),
    keysIn = __webpack_require__(57558);

/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssignIn(object, source) {
  return object && copyObject(source, keysIn(source), object);
}

module.exports = baseAssignIn;


/***/ }),

/***/ 20852:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var defineProperty = __webpack_require__(84257);

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && defineProperty) {
    defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

module.exports = baseAssignValue;


/***/ }),

/***/ 16554:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Stack = __webpack_require__(34395),
    arrayEach = __webpack_require__(96736),
    assignValue = __webpack_require__(887),
    baseAssign = __webpack_require__(45903),
    baseAssignIn = __webpack_require__(52749),
    cloneBuffer = __webpack_require__(85009),
    copyArray = __webpack_require__(91664),
    copySymbols = __webpack_require__(98143),
    copySymbolsIn = __webpack_require__(22147),
    getAllKeys = __webpack_require__(40147),
    getAllKeysIn = __webpack_require__(16349),
    getTag = __webpack_require__(63460),
    initCloneArray = __webpack_require__(74274),
    initCloneByTag = __webpack_require__(38053),
    initCloneObject = __webpack_require__(76409),
    isArray = __webpack_require__(24609),
    isBuffer = __webpack_require__(65211),
    isMap = __webpack_require__(10719),
    isObject = __webpack_require__(44411),
    isSet = __webpack_require__(63927),
    keys = __webpack_require__(28220),
    keysIn = __webpack_require__(57558);

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_FLAT_FLAG = 2,
    CLONE_SYMBOLS_FLAG = 4;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values supported by `_.clone`. */
var cloneableTags = {};
cloneableTags[argsTag] = cloneableTags[arrayTag] =
cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
cloneableTags[boolTag] = cloneableTags[dateTag] =
cloneableTags[float32Tag] = cloneableTags[float64Tag] =
cloneableTags[int8Tag] = cloneableTags[int16Tag] =
cloneableTags[int32Tag] = cloneableTags[mapTag] =
cloneableTags[numberTag] = cloneableTags[objectTag] =
cloneableTags[regexpTag] = cloneableTags[setTag] =
cloneableTags[stringTag] = cloneableTags[symbolTag] =
cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
cloneableTags[errorTag] = cloneableTags[funcTag] =
cloneableTags[weakMapTag] = false;

/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */
function baseClone(value, bitmask, customizer, key, object, stack) {
  var result,
      isDeep = bitmask & CLONE_DEEP_FLAG,
      isFlat = bitmask & CLONE_FLAT_FLAG,
      isFull = bitmask & CLONE_SYMBOLS_FLAG;

  if (customizer) {
    result = object ? customizer(value, key, object, stack) : customizer(value);
  }
  if (result !== undefined) {
    return result;
  }
  if (!isObject(value)) {
    return value;
  }
  var isArr = isArray(value);
  if (isArr) {
    result = initCloneArray(value);
    if (!isDeep) {
      return copyArray(value, result);
    }
  } else {
    var tag = getTag(value),
        isFunc = tag == funcTag || tag == genTag;

    if (isBuffer(value)) {
      return cloneBuffer(value, isDeep);
    }
    if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
      result = (isFlat || isFunc) ? {} : initCloneObject(value);
      if (!isDeep) {
        return isFlat
          ? copySymbolsIn(value, baseAssignIn(result, value))
          : copySymbols(value, baseAssign(result, value));
      }
    } else {
      if (!cloneableTags[tag]) {
        return object ? value : {};
      }
      result = initCloneByTag(value, tag, isDeep);
    }
  }
  // Check for circular references and return its corresponding clone.
  stack || (stack = new Stack);
  var stacked = stack.get(value);
  if (stacked) {
    return stacked;
  }
  stack.set(value, result);

  if (isSet(value)) {
    value.forEach(function(subValue) {
      result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });
  } else if (isMap(value)) {
    value.forEach(function(subValue, key) {
      result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
    });
  }

  var keysFunc = isFull
    ? (isFlat ? getAllKeysIn : getAllKeys)
    : (isFlat ? keysIn : keys);

  var props = isArr ? undefined : keysFunc(value);
  arrayEach(props || value, function(subValue, key) {
    if (props) {
      key = subValue;
      subValue = value[key];
    }
    // Recursively populate clone (susceptible to call stack limits).
    assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
  });
  return result;
}

module.exports = baseClone;


/***/ }),

/***/ 48412:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isObject = __webpack_require__(44411);

/** Built-in value references. */
var objectCreate = Object.create;

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate = (function() {
  function object() {}
  return function(proto) {
    if (!isObject(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object;
    object.prototype = undefined;
    return result;
  };
}());

module.exports = baseCreate;


/***/ }),

/***/ 76014:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var createBaseFor = __webpack_require__(31032);

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = createBaseFor();

module.exports = baseFor;


/***/ }),

/***/ 15876:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseFor = __webpack_require__(76014),
    keys = __webpack_require__(28220);

/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwn(object, iteratee) {
  return object && baseFor(object, iteratee, keys);
}

module.exports = baseForOwn;


/***/ }),

/***/ 63409:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var castPath = __webpack_require__(84702),
    toKey = __webpack_require__(42566);

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = castPath(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

module.exports = baseGet;


/***/ }),

/***/ 41999:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayPush = __webpack_require__(83309),
    isArray = __webpack_require__(24609);

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

module.exports = baseGetAllKeys;


/***/ }),

/***/ 13984:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Symbol = __webpack_require__(90877),
    getRawTag = __webpack_require__(71115),
    objectToString = __webpack_require__(17058);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),

/***/ 6227:
/***/ (function(module) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.has` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHas(object, key) {
  return object != null && hasOwnProperty.call(object, key);
}

module.exports = baseHas;


/***/ }),

/***/ 51016:
/***/ (function(module) {

/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHasIn(object, key) {
  return object != null && key in Object(object);
}

module.exports = baseHasIn;


/***/ }),

/***/ 98996:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetTag = __webpack_require__(13984),
    isObjectLike = __webpack_require__(38994);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

module.exports = baseIsArguments;


/***/ }),

/***/ 60241:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsEqualDeep = __webpack_require__(65024),
    isObjectLike = __webpack_require__(38994);

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

module.exports = baseIsEqual;


/***/ }),

/***/ 65024:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Stack = __webpack_require__(34395),
    equalArrays = __webpack_require__(16436),
    equalByTag = __webpack_require__(34112),
    equalObjects = __webpack_require__(71800),
    getTag = __webpack_require__(63460),
    isArray = __webpack_require__(24609),
    isBuffer = __webpack_require__(65211),
    isTypedArray = __webpack_require__(36603);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    objectTag = '[object Object]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = objIsArr ? arrayTag : getTag(object),
      othTag = othIsArr ? arrayTag : getTag(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

module.exports = baseIsEqualDeep;


/***/ }),

/***/ 2269:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getTag = __webpack_require__(63460),
    isObjectLike = __webpack_require__(38994);

/** `Object#toString` result references. */
var mapTag = '[object Map]';

/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */
function baseIsMap(value) {
  return isObjectLike(value) && getTag(value) == mapTag;
}

module.exports = baseIsMap;


/***/ }),

/***/ 62425:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Stack = __webpack_require__(34395),
    baseIsEqual = __webpack_require__(60241);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if ((noCustomizer && data[2])
          ? data[1] !== object[data[0]]
          : !(data[0] in object)
        ) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new Stack;
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === undefined
            ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
            : result
          )) {
        return false;
      }
    }
  }
  return true;
}

module.exports = baseIsMatch;


/***/ }),

/***/ 29532:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isFunction = __webpack_require__(30664),
    isMasked = __webpack_require__(43013),
    isObject = __webpack_require__(44411),
    toSource = __webpack_require__(1087);

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

module.exports = baseIsNative;


/***/ }),

/***/ 23497:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getTag = __webpack_require__(63460),
    isObjectLike = __webpack_require__(38994);

/** `Object#toString` result references. */
var setTag = '[object Set]';

/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */
function baseIsSet(value) {
  return isObjectLike(value) && getTag(value) == setTag;
}

module.exports = baseIsSet;


/***/ }),

/***/ 17934:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetTag = __webpack_require__(13984),
    isLength = __webpack_require__(22829),
    isObjectLike = __webpack_require__(38994);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

module.exports = baseIsTypedArray;


/***/ }),

/***/ 83571:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseMatches = __webpack_require__(32614),
    baseMatchesProperty = __webpack_require__(43688),
    identity = __webpack_require__(95314),
    isArray = __webpack_require__(24609),
    property = __webpack_require__(84774);

/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }
  if (value == null) {
    return identity;
  }
  if (typeof value == 'object') {
    return isArray(value)
      ? baseMatchesProperty(value[0], value[1])
      : baseMatches(value);
  }
  return property(value);
}

module.exports = baseIteratee;


/***/ }),

/***/ 31350:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isPrototype = __webpack_require__(13624),
    nativeKeys = __webpack_require__(1360);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeys;


/***/ }),

/***/ 68505:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isObject = __webpack_require__(44411),
    isPrototype = __webpack_require__(13624),
    nativeKeysIn = __webpack_require__(21166);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  if (!isObject(object)) {
    return nativeKeysIn(object);
  }
  var isProto = isPrototype(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeysIn;


/***/ }),

/***/ 32614:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsMatch = __webpack_require__(62425),
    getMatchData = __webpack_require__(43077),
    matchesStrictComparable = __webpack_require__(70508);

/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatches(source) {
  var matchData = getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
  }
  return function(object) {
    return object === source || baseIsMatch(object, source, matchData);
  };
}

module.exports = baseMatches;


/***/ }),

/***/ 43688:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(60241),
    get = __webpack_require__(32756),
    hasIn = __webpack_require__(27215),
    isKey = __webpack_require__(80692),
    isStrictComparable = __webpack_require__(5778),
    matchesStrictComparable = __webpack_require__(70508),
    toKey = __webpack_require__(42566);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatchesProperty(path, srcValue) {
  if (isKey(path) && isStrictComparable(srcValue)) {
    return matchesStrictComparable(toKey(path), srcValue);
  }
  return function(object) {
    var objValue = get(object, path);
    return (objValue === undefined && objValue === srcValue)
      ? hasIn(object, path)
      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
  };
}

module.exports = baseMatchesProperty;


/***/ }),

/***/ 50179:
/***/ (function(module) {

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

module.exports = baseProperty;


/***/ }),

/***/ 42308:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGet = __webpack_require__(63409);

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep(path) {
  return function(object) {
    return baseGet(object, path);
  };
}

module.exports = basePropertyDeep;


/***/ }),

/***/ 38917:
/***/ (function(module) {

/**
 * The base implementation of `_.propertyOf` without support for deep paths.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyOf(object) {
  return function(key) {
    return object == null ? undefined : object[key];
  };
}

module.exports = basePropertyOf;


/***/ }),

/***/ 3091:
/***/ (function(module) {

/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */
function baseSlice(array, start, end) {
  var index = -1,
      length = array.length;

  if (start < 0) {
    start = -start > length ? 0 : (length + start);
  }
  end = end > length ? length : end;
  if (end < 0) {
    end += length;
  }
  length = start > end ? 0 : ((end - start) >>> 0);
  start >>>= 0;

  var result = Array(length);
  while (++index < length) {
    result[index] = array[index + start];
  }
  return result;
}

module.exports = baseSlice;


/***/ }),

/***/ 73803:
/***/ (function(module) {

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

module.exports = baseTimes;


/***/ }),

/***/ 66399:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayMap = __webpack_require__(8106);

/**
 * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
 * of key-value pairs for `object` corresponding to the property names of `props`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} props The property names to get values for.
 * @returns {Object} Returns the key-value pairs.
 */
function baseToPairs(object, props) {
  return arrayMap(props, function(key) {
    return [key, object[key]];
  });
}

module.exports = baseToPairs;


/***/ }),

/***/ 13588:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Symbol = __webpack_require__(90877),
    arrayMap = __webpack_require__(8106),
    isArray = __webpack_require__(24609),
    isSymbol = __webpack_require__(59739);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = baseToString;


/***/ }),

/***/ 43452:
/***/ (function(module) {

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

module.exports = baseUnary;


/***/ }),

/***/ 94299:
/***/ (function(module) {

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

module.exports = cacheHas;


/***/ }),

/***/ 84702:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isArray = __webpack_require__(24609),
    isKey = __webpack_require__(80692),
    stringToPath = __webpack_require__(26731),
    toString = __webpack_require__(8553);

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if (isArray(value)) {
    return value;
  }
  return isKey(value, object) ? [value] : stringToPath(toString(value));
}

module.exports = castPath;


/***/ }),

/***/ 50729:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseSlice = __webpack_require__(3091);

/**
 * Casts `array` to a slice if it's needed.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {number} start The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the cast slice.
 */
function castSlice(array, start, end) {
  var length = array.length;
  end = end === undefined ? length : end;
  return (!start && end >= length) ? array : baseSlice(array, start, end);
}

module.exports = castSlice;


/***/ }),

/***/ 879:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Uint8Array = __webpack_require__(99904);

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
  return result;
}

module.exports = cloneArrayBuffer;


/***/ }),

/***/ 85009:
/***/ (function(module, exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
var root = __webpack_require__(74329);

/** Detect free variable `exports`. */
var freeExports =  true && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && "object" == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined,
    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var length = buffer.length,
      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

  buffer.copy(result);
  return result;
}

module.exports = cloneBuffer;


/***/ }),

/***/ 37423:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(879);

/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */
function cloneDataView(dataView, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}

module.exports = cloneDataView;


/***/ }),

/***/ 36611:
/***/ (function(module) {

/** Used to match `RegExp` flags from their coerced string values. */
var reFlags = /\w*$/;

/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */
function cloneRegExp(regexp) {
  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
  result.lastIndex = regexp.lastIndex;
  return result;
}

module.exports = cloneRegExp;


/***/ }),

/***/ 11712:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Symbol = __webpack_require__(90877);

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */
function cloneSymbol(symbol) {
  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
}

module.exports = cloneSymbol;


/***/ }),

/***/ 91550:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(879);

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

module.exports = cloneTypedArray;


/***/ }),

/***/ 91664:
/***/ (function(module) {

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

module.exports = copyArray;


/***/ }),

/***/ 99568:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var assignValue = __webpack_require__(887),
    baseAssignValue = __webpack_require__(20852);

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      baseAssignValue(object, key, newValue);
    } else {
      assignValue(object, key, newValue);
    }
  }
  return object;
}

module.exports = copyObject;


/***/ }),

/***/ 98143:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var copyObject = __webpack_require__(99568),
    getSymbols = __webpack_require__(28968);

/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbols(source, object) {
  return copyObject(source, getSymbols(source), object);
}

module.exports = copySymbols;


/***/ }),

/***/ 22147:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var copyObject = __webpack_require__(99568),
    getSymbolsIn = __webpack_require__(91481);

/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbolsIn(source, object) {
  return copyObject(source, getSymbolsIn(source), object);
}

module.exports = copySymbolsIn;


/***/ }),

/***/ 25637:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var root = __webpack_require__(74329);

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;


/***/ }),

/***/ 31032:
/***/ (function(module) {

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

module.exports = createBaseFor;


/***/ }),

/***/ 60052:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var castSlice = __webpack_require__(50729),
    hasUnicode = __webpack_require__(84923),
    stringToArray = __webpack_require__(13163),
    toString = __webpack_require__(8553);

/**
 * Creates a function like `_.lowerFirst`.
 *
 * @private
 * @param {string} methodName The name of the `String` case method to use.
 * @returns {Function} Returns the new case function.
 */
function createCaseFirst(methodName) {
  return function(string) {
    string = toString(string);

    var strSymbols = hasUnicode(string)
      ? stringToArray(string)
      : undefined;

    var chr = strSymbols
      ? strSymbols[0]
      : string.charAt(0);

    var trailing = strSymbols
      ? castSlice(strSymbols, 1).join('')
      : string.slice(1);

    return chr[methodName]() + trailing;
  };
}

module.exports = createCaseFirst;


/***/ }),

/***/ 71161:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayReduce = __webpack_require__(81785),
    deburr = __webpack_require__(49524),
    words = __webpack_require__(4851);

/** Used to compose unicode capture groups. */
var rsApos = "['\u2019]";

/** Used to match apostrophes. */
var reApos = RegExp(rsApos, 'g');

/**
 * Creates a function like `_.camelCase`.
 *
 * @private
 * @param {Function} callback The function to combine each word.
 * @returns {Function} Returns the new compounder function.
 */
function createCompounder(callback) {
  return function(string) {
    return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
  };
}

module.exports = createCompounder;


/***/ }),

/***/ 29384:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseToPairs = __webpack_require__(66399),
    getTag = __webpack_require__(63460),
    mapToArray = __webpack_require__(28628),
    setToPairs = __webpack_require__(67557);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    setTag = '[object Set]';

/**
 * Creates a `_.toPairs` or `_.toPairsIn` function.
 *
 * @private
 * @param {Function} keysFunc The function to get the keys of a given object.
 * @returns {Function} Returns the new pairs function.
 */
function createToPairs(keysFunc) {
  return function(object) {
    var tag = getTag(object);
    if (tag == mapTag) {
      return mapToArray(object);
    }
    if (tag == setTag) {
      return setToPairs(object);
    }
    return baseToPairs(object, keysFunc(object));
  };
}

module.exports = createToPairs;


/***/ }),

/***/ 95648:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var basePropertyOf = __webpack_require__(38917);

/** Used to map Latin Unicode letters to basic Latin letters. */
var deburredLetters = {
  // Latin-1 Supplement block.
  '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
  '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
  '\xc7': 'C',  '\xe7': 'c',
  '\xd0': 'D',  '\xf0': 'd',
  '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
  '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
  '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
  '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
  '\xd1': 'N',  '\xf1': 'n',
  '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
  '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
  '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
  '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
  '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
  '\xc6': 'Ae', '\xe6': 'ae',
  '\xde': 'Th', '\xfe': 'th',
  '\xdf': 'ss',
  // Latin Extended-A block.
  '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
  '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
  '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
  '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
  '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
  '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
  '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
  '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
  '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
  '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
  '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
  '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
  '\u0134': 'J',  '\u0135': 'j',
  '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
  '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
  '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
  '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
  '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
  '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
  '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
  '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
  '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
  '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
  '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
  '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
  '\u0163': 't',  '\u0165': 't', '\u0167': 't',
  '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
  '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
  '\u0174': 'W',  '\u0175': 'w',
  '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
  '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
  '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
  '\u0132': 'IJ', '\u0133': 'ij',
  '\u0152': 'Oe', '\u0153': 'oe',
  '\u0149': "'n", '\u017f': 's'
};

/**
 * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
 * letters to basic Latin letters.
 *
 * @private
 * @param {string} letter The matched letter to deburr.
 * @returns {string} Returns the deburred letter.
 */
var deburrLetter = basePropertyOf(deburredLetters);

module.exports = deburrLetter;


/***/ }),

/***/ 84257:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(92651);

var defineProperty = (function() {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

module.exports = defineProperty;


/***/ }),

/***/ 16436:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var SetCache = __webpack_require__(56041),
    arraySome = __webpack_require__(40898),
    cacheHas = __webpack_require__(94299);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Check that cyclic values are equal.
  var arrStacked = stack.get(array);
  var othStacked = stack.get(other);
  if (arrStacked && othStacked) {
    return arrStacked == other && othStacked == array;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

module.exports = equalArrays;


/***/ }),

/***/ 34112:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Symbol = __webpack_require__(90877),
    Uint8Array = __webpack_require__(99904),
    eq = __webpack_require__(18213),
    equalArrays = __webpack_require__(16436),
    mapToArray = __webpack_require__(28628),
    setToArray = __webpack_require__(58044);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

module.exports = equalByTag;


/***/ }),

/***/ 71800:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getAllKeys = __webpack_require__(40147);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Check that cyclic values are equal.
  var objStacked = stack.get(object);
  var othStacked = stack.get(other);
  if (objStacked && othStacked) {
    return objStacked == other && othStacked == object;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

module.exports = equalObjects;


/***/ }),

/***/ 52836:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof __webpack_require__.g == 'object' && __webpack_require__.g && __webpack_require__.g.Object === Object && __webpack_require__.g;

module.exports = freeGlobal;


/***/ }),

/***/ 40147:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(41999),
    getSymbols = __webpack_require__(28968),
    keys = __webpack_require__(28220);

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

module.exports = getAllKeys;


/***/ }),

/***/ 16349:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(41999),
    getSymbolsIn = __webpack_require__(91481),
    keysIn = __webpack_require__(57558);

/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeysIn(object) {
  return baseGetAllKeys(object, keysIn, getSymbolsIn);
}

module.exports = getAllKeysIn;


/***/ }),

/***/ 27864:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isKeyable = __webpack_require__(65668);

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

module.exports = getMapData;


/***/ }),

/***/ 43077:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isStrictComparable = __webpack_require__(5778),
    keys = __webpack_require__(28220);

/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData(object) {
  var result = keys(object),
      length = result.length;

  while (length--) {
    var key = result[length],
        value = object[key];

    result[length] = [key, value, isStrictComparable(value)];
  }
  return result;
}

module.exports = getMatchData;


/***/ }),

/***/ 92651:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsNative = __webpack_require__(29532),
    getValue = __webpack_require__(24428);

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

module.exports = getNative;


/***/ }),

/***/ 88711:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var overArg = __webpack_require__(76507);

/** Built-in value references. */
var getPrototype = overArg(Object.getPrototypeOf, Object);

module.exports = getPrototype;


/***/ }),

/***/ 71115:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Symbol = __webpack_require__(90877);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),

/***/ 28968:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayFilter = __webpack_require__(39574),
    stubArray = __webpack_require__(79874);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

module.exports = getSymbols;


/***/ }),

/***/ 91481:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayPush = __webpack_require__(83309),
    getPrototype = __webpack_require__(88711),
    getSymbols = __webpack_require__(28968),
    stubArray = __webpack_require__(79874);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
  var result = [];
  while (object) {
    arrayPush(result, getSymbols(object));
    object = getPrototype(object);
  }
  return result;
};

module.exports = getSymbolsIn;


/***/ }),

/***/ 63460:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var DataView = __webpack_require__(80194),
    Map = __webpack_require__(62602),
    Promise = __webpack_require__(73057),
    Set = __webpack_require__(6559),
    WeakMap = __webpack_require__(74215),
    baseGetTag = __webpack_require__(13984),
    toSource = __webpack_require__(1087);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = baseGetTag(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

module.exports = getTag;


/***/ }),

/***/ 24428:
/***/ (function(module) {

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;


/***/ }),

/***/ 81181:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var castPath = __webpack_require__(84702),
    isArguments = __webpack_require__(52441),
    isArray = __webpack_require__(24609),
    isIndex = __webpack_require__(32850),
    isLength = __webpack_require__(22829),
    toKey = __webpack_require__(42566);

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath(object, path, hasFunc) {
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      result = false;

  while (++index < length) {
    var key = toKey(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && isLength(length) && isIndex(key, length) &&
    (isArray(object) || isArguments(object));
}

module.exports = hasPath;


/***/ }),

/***/ 84923:
/***/ (function(module) {

/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsVarRange = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsZWJ = '\\u200d';

/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

/**
 * Checks if `string` contains Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
 */
function hasUnicode(string) {
  return reHasUnicode.test(string);
}

module.exports = hasUnicode;


/***/ }),

/***/ 60534:
/***/ (function(module) {

/** Used to detect strings that need a more robust regexp to match words. */
var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

/**
 * Checks if `string` contains a word composed of Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a word is found, else `false`.
 */
function hasUnicodeWord(string) {
  return reHasUnicodeWord.test(string);
}

module.exports = hasUnicodeWord;


/***/ }),

/***/ 16673:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var nativeCreate = __webpack_require__(20591);

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

module.exports = hashClear;


/***/ }),

/***/ 49605:
/***/ (function(module) {

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = hashDelete;


/***/ }),

/***/ 9687:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var nativeCreate = __webpack_require__(20591);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

module.exports = hashGet;


/***/ }),

/***/ 71972:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var nativeCreate = __webpack_require__(20591);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

module.exports = hashHas;


/***/ }),

/***/ 10863:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var nativeCreate = __webpack_require__(20591);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

module.exports = hashSet;


/***/ }),

/***/ 74274:
/***/ (function(module) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */
function initCloneArray(array) {
  var length = array.length,
      result = new array.constructor(length);

  // Add properties assigned by `RegExp#exec`.
  if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
    result.index = array.index;
    result.input = array.input;
  }
  return result;
}

module.exports = initCloneArray;


/***/ }),

/***/ 38053:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(879),
    cloneDataView = __webpack_require__(37423),
    cloneRegExp = __webpack_require__(36611),
    cloneSymbol = __webpack_require__(11712),
    cloneTypedArray = __webpack_require__(91550);

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneByTag(object, tag, isDeep) {
  var Ctor = object.constructor;
  switch (tag) {
    case arrayBufferTag:
      return cloneArrayBuffer(object);

    case boolTag:
    case dateTag:
      return new Ctor(+object);

    case dataViewTag:
      return cloneDataView(object, isDeep);

    case float32Tag: case float64Tag:
    case int8Tag: case int16Tag: case int32Tag:
    case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
      return cloneTypedArray(object, isDeep);

    case mapTag:
      return new Ctor;

    case numberTag:
    case stringTag:
      return new Ctor(object);

    case regexpTag:
      return cloneRegExp(object);

    case setTag:
      return new Ctor;

    case symbolTag:
      return cloneSymbol(object);
  }
}

module.exports = initCloneByTag;


/***/ }),

/***/ 76409:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseCreate = __webpack_require__(48412),
    getPrototype = __webpack_require__(88711),
    isPrototype = __webpack_require__(13624);

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return (typeof object.constructor == 'function' && !isPrototype(object))
    ? baseCreate(getPrototype(object))
    : {};
}

module.exports = initCloneObject;


/***/ }),

/***/ 32850:
/***/ (function(module) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

module.exports = isIndex;


/***/ }),

/***/ 80692:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isArray = __webpack_require__(24609),
    isSymbol = __webpack_require__(59739);

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

module.exports = isKey;


/***/ }),

/***/ 65668:
/***/ (function(module) {

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

module.exports = isKeyable;


/***/ }),

/***/ 43013:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var coreJsData = __webpack_require__(25637);

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

module.exports = isMasked;


/***/ }),

/***/ 13624:
/***/ (function(module) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

module.exports = isPrototype;


/***/ }),

/***/ 5778:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isObject = __webpack_require__(44411);

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable(value) {
  return value === value && !isObject(value);
}

module.exports = isStrictComparable;


/***/ }),

/***/ 98886:
/***/ (function(module) {

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

module.exports = listCacheClear;


/***/ }),

/***/ 26457:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(35256);

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

module.exports = listCacheDelete;


/***/ }),

/***/ 78108:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(35256);

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

module.exports = listCacheGet;


/***/ }),

/***/ 7765:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(35256);

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

module.exports = listCacheHas;


/***/ }),

/***/ 9142:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(35256);

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

module.exports = listCacheSet;


/***/ }),

/***/ 34692:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Hash = __webpack_require__(19155),
    ListCache = __webpack_require__(52970),
    Map = __webpack_require__(62602);

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

module.exports = mapCacheClear;


/***/ }),

/***/ 77238:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getMapData = __webpack_require__(27864);

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = mapCacheDelete;


/***/ }),

/***/ 39615:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getMapData = __webpack_require__(27864);

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

module.exports = mapCacheGet;


/***/ }),

/***/ 91336:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getMapData = __webpack_require__(27864);

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

module.exports = mapCacheHas;


/***/ }),

/***/ 5084:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getMapData = __webpack_require__(27864);

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

module.exports = mapCacheSet;


/***/ }),

/***/ 28628:
/***/ (function(module) {

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

module.exports = mapToArray;


/***/ }),

/***/ 70508:
/***/ (function(module) {

/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function matchesStrictComparable(key, srcValue) {
  return function(object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue &&
      (srcValue !== undefined || (key in Object(object)));
  };
}

module.exports = matchesStrictComparable;


/***/ }),

/***/ 74149:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var memoize = __webpack_require__(29872);

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = memoize(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

module.exports = memoizeCapped;


/***/ }),

/***/ 20591:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(92651);

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;


/***/ }),

/***/ 1360:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var overArg = __webpack_require__(76507);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;


/***/ }),

/***/ 21166:
/***/ (function(module) {

/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

module.exports = nativeKeysIn;


/***/ }),

/***/ 82824:
/***/ (function(module, exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
var freeGlobal = __webpack_require__(52836);

/** Detect free variable `exports`. */
var freeExports =  true && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && "object" == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;


/***/ }),

/***/ 17058:
/***/ (function(module) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),

/***/ 76507:
/***/ (function(module) {

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;


/***/ }),

/***/ 74329:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var freeGlobal = __webpack_require__(52836);

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),

/***/ 43312:
/***/ (function(module) {

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

module.exports = setCacheAdd;


/***/ }),

/***/ 74201:
/***/ (function(module) {

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

module.exports = setCacheHas;


/***/ }),

/***/ 58044:
/***/ (function(module) {

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

module.exports = setToArray;


/***/ }),

/***/ 67557:
/***/ (function(module) {

/**
 * Converts `set` to its value-value pairs.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the value-value pairs.
 */
function setToPairs(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = [value, value];
  });
  return result;
}

module.exports = setToPairs;


/***/ }),

/***/ 77617:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var ListCache = __webpack_require__(52970);

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

module.exports = stackClear;


/***/ }),

/***/ 63783:
/***/ (function(module) {

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

module.exports = stackDelete;


/***/ }),

/***/ 79935:
/***/ (function(module) {

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

module.exports = stackGet;


/***/ }),

/***/ 59236:
/***/ (function(module) {

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

module.exports = stackHas;


/***/ }),

/***/ 39346:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var ListCache = __webpack_require__(52970),
    Map = __webpack_require__(62602),
    MapCache = __webpack_require__(97372);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

module.exports = stackSet;


/***/ }),

/***/ 13163:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var asciiToArray = __webpack_require__(97677),
    hasUnicode = __webpack_require__(84923),
    unicodeToArray = __webpack_require__(28654);

/**
 * Converts `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function stringToArray(string) {
  return hasUnicode(string)
    ? unicodeToArray(string)
    : asciiToArray(string);
}

module.exports = stringToArray;


/***/ }),

/***/ 26731:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var memoizeCapped = __webpack_require__(74149);

/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoizeCapped(function(string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

module.exports = stringToPath;


/***/ }),

/***/ 42566:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isSymbol = __webpack_require__(59739);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = toKey;


/***/ }),

/***/ 1087:
/***/ (function(module) {

/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

module.exports = toSource;


/***/ }),

/***/ 28654:
/***/ (function(module) {

/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsVarRange = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsAstral = '[' + rsAstralRange + ']',
    rsCombo = '[' + rsComboRange + ']',
    rsFitz = '\\ud83c[\\udffb-\\udfff]',
    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
    rsNonAstral = '[^' + rsAstralRange + ']',
    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
    rsZWJ = '\\u200d';

/** Used to compose unicode regexes. */
var reOptMod = rsModifier + '?',
    rsOptVar = '[' + rsVarRange + ']?',
    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
    rsSeq = rsOptVar + reOptMod + rsOptJoin,
    rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

/**
 * Converts a Unicode `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function unicodeToArray(string) {
  return string.match(reUnicode) || [];
}

module.exports = unicodeToArray;


/***/ }),

/***/ 71638:
/***/ (function(module) {

/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsDingbatRange = '\\u2700-\\u27bf',
    rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
    rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
    rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
    rsPunctuationRange = '\\u2000-\\u206f',
    rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
    rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
    rsVarRange = '\\ufe0e\\ufe0f',
    rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

/** Used to compose unicode capture groups. */
var rsApos = "['\u2019]",
    rsBreak = '[' + rsBreakRange + ']',
    rsCombo = '[' + rsComboRange + ']',
    rsDigits = '\\d+',
    rsDingbat = '[' + rsDingbatRange + ']',
    rsLower = '[' + rsLowerRange + ']',
    rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
    rsFitz = '\\ud83c[\\udffb-\\udfff]',
    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
    rsNonAstral = '[^' + rsAstralRange + ']',
    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
    rsUpper = '[' + rsUpperRange + ']',
    rsZWJ = '\\u200d';

/** Used to compose unicode regexes. */
var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
    rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
    rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
    rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
    reOptMod = rsModifier + '?',
    rsOptVar = '[' + rsVarRange + ']?',
    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
    rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
    rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
    rsSeq = rsOptVar + reOptMod + rsOptJoin,
    rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq;

/** Used to match complex or compound words. */
var reUnicodeWord = RegExp([
  rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
  rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
  rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
  rsUpper + '+' + rsOptContrUpper,
  rsOrdUpper,
  rsOrdLower,
  rsDigits,
  rsEmoji
].join('|'), 'g');

/**
 * Splits a Unicode `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */
function unicodeWords(string) {
  return string.match(reUnicodeWord) || [];
}

module.exports = unicodeWords;


/***/ }),

/***/ 13874:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var capitalize = __webpack_require__(24346),
    createCompounder = __webpack_require__(71161);

/**
 * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the camel cased string.
 * @example
 *
 * _.camelCase('Foo Bar');
 * // => 'fooBar'
 *
 * _.camelCase('--foo-bar--');
 * // => 'fooBar'
 *
 * _.camelCase('__FOO_BAR__');
 * // => 'fooBar'
 */
var camelCase = createCompounder(function(result, word, index) {
  word = word.toLowerCase();
  return result + (index ? capitalize(word) : word);
});

module.exports = camelCase;


/***/ }),

/***/ 24346:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var toString = __webpack_require__(8553),
    upperFirst = __webpack_require__(51930);

/**
 * Converts the first character of `string` to upper case and the remaining
 * to lower case.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to capitalize.
 * @returns {string} Returns the capitalized string.
 * @example
 *
 * _.capitalize('FRED');
 * // => 'Fred'
 */
function capitalize(string) {
  return upperFirst(toString(string).toLowerCase());
}

module.exports = capitalize;


/***/ }),

/***/ 88208:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseClone = __webpack_require__(16554);

/** Used to compose bitmasks for cloning. */
var CLONE_SYMBOLS_FLAG = 4;

/**
 * Creates a shallow clone of `value`.
 *
 * **Note:** This method is loosely based on the
 * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
 * and supports cloning arrays, array buffers, booleans, date objects, maps,
 * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
 * arrays. The own enumerable properties of `arguments` objects are cloned
 * as plain objects. An empty object is returned for uncloneable values such
 * as error objects, functions, DOM nodes, and WeakMaps.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to clone.
 * @returns {*} Returns the cloned value.
 * @see _.cloneDeep
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var shallow = _.clone(objects);
 * console.log(shallow[0] === objects[0]);
 * // => true
 */
function clone(value) {
  return baseClone(value, CLONE_SYMBOLS_FLAG);
}

module.exports = clone;


/***/ }),

/***/ 72008:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseClone = __webpack_require__(16554);

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_SYMBOLS_FLAG = 4;

/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */
function cloneDeep(value) {
  return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
}

module.exports = cloneDeep;


/***/ }),

/***/ 49524:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var deburrLetter = __webpack_require__(95648),
    toString = __webpack_require__(8553);

/** Used to match Latin Unicode letters (excluding mathematical operators). */
var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

/** Used to compose unicode character classes. */
var rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange;

/** Used to compose unicode capture groups. */
var rsCombo = '[' + rsComboRange + ']';

/**
 * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
 * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
 */
var reComboMark = RegExp(rsCombo, 'g');

/**
 * Deburrs `string` by converting
 * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
 * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
 * letters to basic Latin letters and removing
 * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to deburr.
 * @returns {string} Returns the deburred string.
 * @example
 *
 * _.deburr('déjà vu');
 * // => 'deja vu'
 */
function deburr(string) {
  string = toString(string);
  return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
}

module.exports = deburr;


/***/ }),

/***/ 18213:
/***/ (function(module) {

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

module.exports = eq;


/***/ }),

/***/ 98235:
/***/ (function(module) {

/**
 * The inverse of `_.toPairs`; this method returns an object composed
 * from key-value `pairs`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} pairs The key-value pairs.
 * @returns {Object} Returns the new object.
 * @example
 *
 * _.fromPairs([['a', 1], ['b', 2]]);
 * // => { 'a': 1, 'b': 2 }
 */
function fromPairs(pairs) {
  var index = -1,
      length = pairs == null ? 0 : pairs.length,
      result = {};

  while (++index < length) {
    var pair = pairs[index];
    result[pair[0]] = pair[1];
  }
  return result;
}

module.exports = fromPairs;


/***/ }),

/***/ 32756:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGet = __webpack_require__(63409);

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

module.exports = get;


/***/ }),

/***/ 22656:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseHas = __webpack_require__(6227),
    hasPath = __webpack_require__(81181);

/**
 * Checks if `path` is a direct property of `object`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = { 'a': { 'b': 2 } };
 * var other = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.has(object, 'a');
 * // => true
 *
 * _.has(object, 'a.b');
 * // => true
 *
 * _.has(object, ['a', 'b']);
 * // => true
 *
 * _.has(other, 'a');
 * // => false
 */
function has(object, path) {
  return object != null && hasPath(object, path, baseHas);
}

module.exports = has;


/***/ }),

/***/ 27215:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseHasIn = __webpack_require__(51016),
    hasPath = __webpack_require__(81181);

/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn(object, path) {
  return object != null && hasPath(object, path, baseHasIn);
}

module.exports = hasIn;


/***/ }),

/***/ 95314:
/***/ (function(module) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),

/***/ 52441:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsArguments = __webpack_require__(98996),
    isObjectLike = __webpack_require__(38994);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

module.exports = isArguments;


/***/ }),

/***/ 24609:
/***/ (function(module) {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;


/***/ }),

/***/ 33527:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isFunction = __webpack_require__(30664),
    isLength = __webpack_require__(22829);

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

module.exports = isArrayLike;


/***/ }),

/***/ 65211:
/***/ (function(module, exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
var root = __webpack_require__(74329),
    stubFalse = __webpack_require__(25676);

/** Detect free variable `exports`. */
var freeExports =  true && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && "object" == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

module.exports = isBuffer;


/***/ }),

/***/ 30664:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetTag = __webpack_require__(13984),
    isObject = __webpack_require__(44411);

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;


/***/ }),

/***/ 22829:
/***/ (function(module) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;


/***/ }),

/***/ 10719:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsMap = __webpack_require__(2269),
    baseUnary = __webpack_require__(43452),
    nodeUtil = __webpack_require__(82824);

/* Node.js helper references. */
var nodeIsMap = nodeUtil && nodeUtil.isMap;

/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */
var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

module.exports = isMap;


/***/ }),

/***/ 44411:
/***/ (function(module) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),

/***/ 38994:
/***/ (function(module) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),

/***/ 13966:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetTag = __webpack_require__(13984),
    getPrototype = __webpack_require__(88711),
    isObjectLike = __webpack_require__(38994);

/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
    return false;
  }
  var proto = getPrototype(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

module.exports = isPlainObject;


/***/ }),

/***/ 63927:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsSet = __webpack_require__(23497),
    baseUnary = __webpack_require__(43452),
    nodeUtil = __webpack_require__(82824);

/* Node.js helper references. */
var nodeIsSet = nodeUtil && nodeUtil.isSet;

/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */
var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

module.exports = isSet;


/***/ }),

/***/ 59739:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetTag = __webpack_require__(13984),
    isObjectLike = __webpack_require__(38994);

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

module.exports = isSymbol;


/***/ }),

/***/ 36603:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsTypedArray = __webpack_require__(17934),
    baseUnary = __webpack_require__(43452),
    nodeUtil = __webpack_require__(82824);

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

module.exports = isTypedArray;


/***/ }),

/***/ 28220:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(46681),
    baseKeys = __webpack_require__(31350),
    isArrayLike = __webpack_require__(33527);

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = keys;


/***/ }),

/***/ 57558:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(46681),
    baseKeysIn = __webpack_require__(68505),
    isArrayLike = __webpack_require__(33527);

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}

module.exports = keysIn;


/***/ }),

/***/ 35735:
/***/ (function(module, exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
;(function() {

  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
  var undefined;

  /** Used as the semantic version number. */
  var VERSION = '4.17.21';

  /** Used as the size to enable large array optimizations. */
  var LARGE_ARRAY_SIZE = 200;

  /** Error message constants. */
  var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',
      FUNC_ERROR_TEXT = 'Expected a function',
      INVALID_TEMPL_VAR_ERROR_TEXT = 'Invalid `variable` option passed into `_.template`';

  /** Used to stand-in for `undefined` hash values. */
  var HASH_UNDEFINED = '__lodash_hash_undefined__';

  /** Used as the maximum memoize cache size. */
  var MAX_MEMOIZE_SIZE = 500;

  /** Used as the internal argument placeholder. */
  var PLACEHOLDER = '__lodash_placeholder__';

  /** Used to compose bitmasks for cloning. */
  var CLONE_DEEP_FLAG = 1,
      CLONE_FLAT_FLAG = 2,
      CLONE_SYMBOLS_FLAG = 4;

  /** Used to compose bitmasks for value comparisons. */
  var COMPARE_PARTIAL_FLAG = 1,
      COMPARE_UNORDERED_FLAG = 2;

  /** Used to compose bitmasks for function metadata. */
  var WRAP_BIND_FLAG = 1,
      WRAP_BIND_KEY_FLAG = 2,
      WRAP_CURRY_BOUND_FLAG = 4,
      WRAP_CURRY_FLAG = 8,
      WRAP_CURRY_RIGHT_FLAG = 16,
      WRAP_PARTIAL_FLAG = 32,
      WRAP_PARTIAL_RIGHT_FLAG = 64,
      WRAP_ARY_FLAG = 128,
      WRAP_REARG_FLAG = 256,
      WRAP_FLIP_FLAG = 512;

  /** Used as default options for `_.truncate`. */
  var DEFAULT_TRUNC_LENGTH = 30,
      DEFAULT_TRUNC_OMISSION = '...';

  /** Used to detect hot functions by number of calls within a span of milliseconds. */
  var HOT_COUNT = 800,
      HOT_SPAN = 16;

  /** Used to indicate the type of lazy iteratees. */
  var LAZY_FILTER_FLAG = 1,
      LAZY_MAP_FLAG = 2,
      LAZY_WHILE_FLAG = 3;

  /** Used as references for various `Number` constants. */
  var INFINITY = 1 / 0,
      MAX_SAFE_INTEGER = 9007199254740991,
      MAX_INTEGER = 1.7976931348623157e+308,
      NAN = 0 / 0;

  /** Used as references for the maximum length and index of an array. */
  var MAX_ARRAY_LENGTH = 4294967295,
      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;

  /** Used to associate wrap methods with their bit flags. */
  var wrapFlags = [
    ['ary', WRAP_ARY_FLAG],
    ['bind', WRAP_BIND_FLAG],
    ['bindKey', WRAP_BIND_KEY_FLAG],
    ['curry', WRAP_CURRY_FLAG],
    ['curryRight', WRAP_CURRY_RIGHT_FLAG],
    ['flip', WRAP_FLIP_FLAG],
    ['partial', WRAP_PARTIAL_FLAG],
    ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
    ['rearg', WRAP_REARG_FLAG]
  ];

  /** `Object#toString` result references. */
  var argsTag = '[object Arguments]',
      arrayTag = '[object Array]',
      asyncTag = '[object AsyncFunction]',
      boolTag = '[object Boolean]',
      dateTag = '[object Date]',
      domExcTag = '[object DOMException]',
      errorTag = '[object Error]',
      funcTag = '[object Function]',
      genTag = '[object GeneratorFunction]',
      mapTag = '[object Map]',
      numberTag = '[object Number]',
      nullTag = '[object Null]',
      objectTag = '[object Object]',
      promiseTag = '[object Promise]',
      proxyTag = '[object Proxy]',
      regexpTag = '[object RegExp]',
      setTag = '[object Set]',
      stringTag = '[object String]',
      symbolTag = '[object Symbol]',
      undefinedTag = '[object Undefined]',
      weakMapTag = '[object WeakMap]',
      weakSetTag = '[object WeakSet]';

  var arrayBufferTag = '[object ArrayBuffer]',
      dataViewTag = '[object DataView]',
      float32Tag = '[object Float32Array]',
      float64Tag = '[object Float64Array]',
      int8Tag = '[object Int8Array]',
      int16Tag = '[object Int16Array]',
      int32Tag = '[object Int32Array]',
      uint8Tag = '[object Uint8Array]',
      uint8ClampedTag = '[object Uint8ClampedArray]',
      uint16Tag = '[object Uint16Array]',
      uint32Tag = '[object Uint32Array]';

  /** Used to match empty string literals in compiled template source. */
  var reEmptyStringLeading = /\b__p \+= '';/g,
      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;

  /** Used to match HTML entities and HTML characters. */
  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
      reUnescapedHtml = /[&<>"']/g,
      reHasEscapedHtml = RegExp(reEscapedHtml.source),
      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);

  /** Used to match template delimiters. */
  var reEscape = /<%-([\s\S]+?)%>/g,
      reEvaluate = /<%([\s\S]+?)%>/g,
      reInterpolate = /<%=([\s\S]+?)%>/g;

  /** Used to match property names within property paths. */
  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
      reIsPlainProp = /^\w*$/,
      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

  /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */
  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
      reHasRegExpChar = RegExp(reRegExpChar.source);

  /** Used to match leading whitespace. */
  var reTrimStart = /^\s+/;

  /** Used to match a single whitespace character. */
  var reWhitespace = /\s/;

  /** Used to match wrap detail comments. */
  var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
      reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
      reSplitDetails = /,? & /;

  /** Used to match words composed of alphanumeric characters. */
  var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

  /**
   * Used to validate the `validate` option in `_.template` variable.
   *
   * Forbids characters which could potentially change the meaning of the function argument definition:
   * - "()," (modification of function parameters)
   * - "=" (default value)
   * - "[]{}" (destructuring of function parameters)
   * - "/" (beginning of a comment)
   * - whitespace
   */
  var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;

  /** Used to match backslashes in property paths. */
  var reEscapeChar = /\\(\\)?/g;

  /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */
  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;

  /** Used to match `RegExp` flags from their coerced string values. */
  var reFlags = /\w*$/;

  /** Used to detect bad signed hexadecimal string values. */
  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

  /** Used to detect binary string values. */
  var reIsBinary = /^0b[01]+$/i;

  /** Used to detect host constructors (Safari). */
  var reIsHostCtor = /^\[object .+?Constructor\]$/;

  /** Used to detect octal string values. */
  var reIsOctal = /^0o[0-7]+$/i;

  /** Used to detect unsigned integer values. */
  var reIsUint = /^(?:0|[1-9]\d*)$/;

  /** Used to match Latin Unicode letters (excluding mathematical operators). */
  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

  /** Used to ensure capturing order of template delimiters. */
  var reNoMatch = /($^)/;

  /** Used to match unescaped characters in compiled string literals. */
  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;

  /** Used to compose unicode character classes. */
  var rsAstralRange = '\\ud800-\\udfff',
      rsComboMarksRange = '\\u0300-\\u036f',
      reComboHalfMarksRange = '\\ufe20-\\ufe2f',
      rsComboSymbolsRange = '\\u20d0-\\u20ff',
      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
      rsDingbatRange = '\\u2700-\\u27bf',
      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
      rsPunctuationRange = '\\u2000-\\u206f',
      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
      rsVarRange = '\\ufe0e\\ufe0f',
      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

  /** Used to compose unicode capture groups. */
  var rsApos = "['\u2019]",
      rsAstral = '[' + rsAstralRange + ']',
      rsBreak = '[' + rsBreakRange + ']',
      rsCombo = '[' + rsComboRange + ']',
      rsDigits = '\\d+',
      rsDingbat = '[' + rsDingbatRange + ']',
      rsLower = '[' + rsLowerRange + ']',
      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
      rsFitz = '\\ud83c[\\udffb-\\udfff]',
      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
      rsNonAstral = '[^' + rsAstralRange + ']',
      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
      rsUpper = '[' + rsUpperRange + ']',
      rsZWJ = '\\u200d';

  /** Used to compose unicode regexes. */
  var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
      rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
      rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
      rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
      reOptMod = rsModifier + '?',
      rsOptVar = '[' + rsVarRange + ']?',
      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
      rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
      rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
      rsSeq = rsOptVar + reOptMod + rsOptJoin,
      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

  /** Used to match apostrophes. */
  var reApos = RegExp(rsApos, 'g');

  /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */
  var reComboMark = RegExp(rsCombo, 'g');

  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
  var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

  /** Used to match complex or compound words. */
  var reUnicodeWord = RegExp([
    rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
    rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
    rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
    rsUpper + '+' + rsOptContrUpper,
    rsOrdUpper,
    rsOrdLower,
    rsDigits,
    rsEmoji
  ].join('|'), 'g');

  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
  var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

  /** Used to detect strings that need a more robust regexp to match words. */
  var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

  /** Used to assign default `context` object properties. */
  var contextProps = [
    'Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array',
    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
    'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array',
    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
    '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'
  ];

  /** Used to make template sourceURLs easier to identify. */
  var templateCounter = -1;

  /** Used to identify `toStringTag` values of typed arrays. */
  var typedArrayTags = {};
  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
  typedArrayTags[uint32Tag] = true;
  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
  typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
  typedArrayTags[errorTag] = typedArrayTags[funcTag] =
  typedArrayTags[mapTag] = typedArrayTags[numberTag] =
  typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
  typedArrayTags[setTag] = typedArrayTags[stringTag] =
  typedArrayTags[weakMapTag] = false;

  /** Used to identify `toStringTag` values supported by `_.clone`. */
  var cloneableTags = {};
  cloneableTags[argsTag] = cloneableTags[arrayTag] =
  cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
  cloneableTags[boolTag] = cloneableTags[dateTag] =
  cloneableTags[float32Tag] = cloneableTags[float64Tag] =
  cloneableTags[int8Tag] = cloneableTags[int16Tag] =
  cloneableTags[int32Tag] = cloneableTags[mapTag] =
  cloneableTags[numberTag] = cloneableTags[objectTag] =
  cloneableTags[regexpTag] = cloneableTags[setTag] =
  cloneableTags[stringTag] = cloneableTags[symbolTag] =
  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
  cloneableTags[errorTag] = cloneableTags[funcTag] =
  cloneableTags[weakMapTag] = false;

  /** Used to map Latin Unicode letters to basic Latin letters. */
  var deburredLetters = {
    // Latin-1 Supplement block.
    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
    '\xc7': 'C',  '\xe7': 'c',
    '\xd0': 'D',  '\xf0': 'd',
    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
    '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
    '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
    '\xd1': 'N',  '\xf1': 'n',
    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
    '\xc6': 'Ae', '\xe6': 'ae',
    '\xde': 'Th', '\xfe': 'th',
    '\xdf': 'ss',
    // Latin Extended-A block.
    '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
    '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
    '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
    '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
    '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
    '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
    '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
    '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
    '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
    '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
    '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
    '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
    '\u0134': 'J',  '\u0135': 'j',
    '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
    '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
    '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
    '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
    '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
    '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
    '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
    '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
    '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
    '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
    '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
    '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
    '\u0163': 't',  '\u0165': 't', '\u0167': 't',
    '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
    '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
    '\u0174': 'W',  '\u0175': 'w',
    '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
    '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
    '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
    '\u0132': 'IJ', '\u0133': 'ij',
    '\u0152': 'Oe', '\u0153': 'oe',
    '\u0149': "'n", '\u017f': 's'
  };

  /** Used to map characters to HTML entities. */
  var htmlEscapes = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;'
  };

  /** Used to map HTML entities to characters. */
  var htmlUnescapes = {
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&#39;': "'"
  };

  /** Used to escape characters for inclusion in compiled string literals. */
  var stringEscapes = {
    '\\': '\\',
    "'": "'",
    '\n': 'n',
    '\r': 'r',
    '\u2028': 'u2028',
    '\u2029': 'u2029'
  };

  /** Built-in method references without a dependency on `root`. */
  var freeParseFloat = parseFloat,
      freeParseInt = parseInt;

  /** Detect free variable `global` from Node.js. */
  var freeGlobal = typeof __webpack_require__.g == 'object' && __webpack_require__.g && __webpack_require__.g.Object === Object && __webpack_require__.g;

  /** Detect free variable `self`. */
  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

  /** Used as a reference to the global object. */
  var root = freeGlobal || freeSelf || Function('return this')();

  /** Detect free variable `exports`. */
  var freeExports =  true && exports && !exports.nodeType && exports;

  /** Detect free variable `module`. */
  var freeModule = freeExports && "object" == 'object' && module && !module.nodeType && module;

  /** Detect the popular CommonJS extension `module.exports`. */
  var moduleExports = freeModule && freeModule.exports === freeExports;

  /** Detect free variable `process` from Node.js. */
  var freeProcess = moduleExports && freeGlobal.process;

  /** Used to access faster Node.js helpers. */
  var nodeUtil = (function() {
    try {
      // Use `util.types` for Node.js 10+.
      var types = freeModule && freeModule.require && freeModule.require('util').types;

      if (types) {
        return types;
      }

      // Legacy `process.binding('util')` for Node.js < 10.
      return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
  }());

  /* Node.js helper references. */
  var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
      nodeIsDate = nodeUtil && nodeUtil.isDate,
      nodeIsMap = nodeUtil && nodeUtil.isMap,
      nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
      nodeIsSet = nodeUtil && nodeUtil.isSet,
      nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

  /*--------------------------------------------------------------------------*/

  /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */
  function apply(func, thisArg, args) {
    switch (args.length) {
      case 0: return func.call(thisArg);
      case 1: return func.call(thisArg, args[0]);
      case 2: return func.call(thisArg, args[0], args[1]);
      case 3: return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
  }

  /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */
  function arrayAggregator(array, setter, iteratee, accumulator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      var value = array[index];
      setter(accumulator, value, iteratee(value), array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEach(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (iteratee(array[index], index, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEachRight(array, iteratee) {
    var length = array == null ? 0 : array.length;

    while (length--) {
      if (iteratee(array[length], length, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */
  function arrayEvery(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (!predicate(array[index], index, array)) {
        return false;
      }
    }
    return true;
  }

  /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */
  function arrayFilter(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (predicate(value, index, array)) {
        result[resIndex++] = value;
      }
    }
    return result;
  }

  /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && baseIndexOf(array, value, 0) > -1;
  }

  /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludesWith(array, value, comparator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (comparator(value, array[index])) {
        return true;
      }
    }
    return false;
  }

  /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */
  function arrayMap(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length,
        result = Array(length);

    while (++index < length) {
      result[index] = iteratee(array[index], index, array);
    }
    return result;
  }

  /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */
  function arrayPush(array, values) {
    var index = -1,
        length = values.length,
        offset = array.length;

    while (++index < length) {
      array[offset + index] = values[index];
    }
    return array;
  }

  /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1,
        length = array == null ? 0 : array.length;

    if (initAccum && length) {
      accumulator = array[++index];
    }
    while (++index < length) {
      accumulator = iteratee(accumulator, array[index], index, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
    var length = array == null ? 0 : array.length;
    if (initAccum && length) {
      accumulator = array[--length];
    }
    while (length--) {
      accumulator = iteratee(accumulator, array[length], length, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */
  function arraySome(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (predicate(array[index], index, array)) {
        return true;
      }
    }
    return false;
  }

  /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  var asciiSize = baseProperty('length');

  /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function asciiToArray(string) {
    return string.split('');
  }

  /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function asciiWords(string) {
    return string.match(reAsciiWord) || [];
  }

  /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */
  function baseFindKey(collection, predicate, eachFunc) {
    var result;
    eachFunc(collection, function(value, key, collection) {
      if (predicate(value, key, collection)) {
        result = key;
        return false;
      }
    });
    return result;
  }

  /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length,
        index = fromIndex + (fromRight ? 1 : -1);

    while ((fromRight ? index-- : ++index < length)) {
      if (predicate(array[index], index, array)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOf(array, value, fromIndex) {
    return value === value
      ? strictIndexOf(array, value, fromIndex)
      : baseFindIndex(array, baseIsNaN, fromIndex);
  }

  /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOfWith(array, value, fromIndex, comparator) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (comparator(array[index], value)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */
  function baseIsNaN(value) {
    return value !== value;
  }

  /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */
  function baseMean(array, iteratee) {
    var length = array == null ? 0 : array.length;
    return length ? (baseSum(array, iteratee) / length) : NAN;
  }

  /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */
  function baseProperty(key) {
    return function(object) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */
  function basePropertyOf(object) {
    return function(key) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */
  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
    eachFunc(collection, function(value, index, collection) {
      accumulator = initAccum
        ? (initAccum = false, value)
        : iteratee(accumulator, value, index, collection);
    });
    return accumulator;
  }

  /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */
  function baseSortBy(array, comparer) {
    var length = array.length;

    array.sort(comparer);
    while (length--) {
      array[length] = array[length].value;
    }
    return array;
  }

  /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */
  function baseSum(array, iteratee) {
    var result,
        index = -1,
        length = array.length;

    while (++index < length) {
      var current = iteratee(array[index]);
      if (current !== undefined) {
        result = result === undefined ? current : (result + current);
      }
    }
    return result;
  }

  /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */
  function baseTimes(n, iteratee) {
    var index = -1,
        result = Array(n);

    while (++index < n) {
      result[index] = iteratee(index);
    }
    return result;
  }

  /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */
  function baseToPairs(object, props) {
    return arrayMap(props, function(key) {
      return [key, object[key]];
    });
  }

  /**
   * The base implementation of `_.trim`.
   *
   * @private
   * @param {string} string The string to trim.
   * @returns {string} Returns the trimmed string.
   */
  function baseTrim(string) {
    return string
      ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
      : string;
  }

  /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */
  function baseUnary(func) {
    return function(value) {
      return func(value);
    };
  }

  /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */
  function baseValues(object, props) {
    return arrayMap(props, function(key) {
      return object[key];
    });
  }

  /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */
  function cacheHas(cache, key) {
    return cache.has(key);
  }

  /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */
  function charsStartIndex(strSymbols, chrSymbols) {
    var index = -1,
        length = strSymbols.length;

    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */
  function charsEndIndex(strSymbols, chrSymbols) {
    var index = strSymbols.length;

    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */
  function countHolders(array, placeholder) {
    var length = array.length,
        result = 0;

    while (length--) {
      if (array[length] === placeholder) {
        ++result;
      }
    }
    return result;
  }

  /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */
  var deburrLetter = basePropertyOf(deburredLetters);

  /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  var escapeHtmlChar = basePropertyOf(htmlEscapes);

  /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  function escapeStringChar(chr) {
    return '\\' + stringEscapes[chr];
  }

  /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */
  function getValue(object, key) {
    return object == null ? undefined : object[key];
  }

  /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */
  function hasUnicode(string) {
    return reHasUnicode.test(string);
  }

  /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */
  function hasUnicodeWord(string) {
    return reHasUnicodeWord.test(string);
  }

  /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */
  function iteratorToArray(iterator) {
    var data,
        result = [];

    while (!(data = iterator.next()).done) {
      result.push(data.value);
    }
    return result;
  }

  /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */
  function mapToArray(map) {
    var index = -1,
        result = Array(map.size);

    map.forEach(function(value, key) {
      result[++index] = [key, value];
    });
    return result;
  }

  /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */
  function overArg(func, transform) {
    return function(arg) {
      return func(transform(arg));
    };
  }

  /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */
  function replaceHolders(array, placeholder) {
    var index = -1,
        length = array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (value === placeholder || value === PLACEHOLDER) {
        array[index] = PLACEHOLDER;
        result[resIndex++] = index;
      }
    }
    return result;
  }

  /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */
  function setToArray(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = value;
    });
    return result;
  }

  /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */
  function setToPairs(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = [value, value];
    });
    return result;
  }

  /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (array[index] === value) {
        return index;
      }
    }
    return -1;
  }

  /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictLastIndexOf(array, value, fromIndex) {
    var index = fromIndex + 1;
    while (index--) {
      if (array[index] === value) {
        return index;
      }
    }
    return index;
  }

  /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */
  function stringSize(string) {
    return hasUnicode(string)
      ? unicodeSize(string)
      : asciiSize(string);
  }

  /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function stringToArray(string) {
    return hasUnicode(string)
      ? unicodeToArray(string)
      : asciiToArray(string);
  }

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the last non-whitespace character.
   */
  function trimmedEndIndex(string) {
    var index = string.length;

    while (index-- && reWhitespace.test(string.charAt(index))) {}
    return index;
  }

  /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */
  var unescapeHtmlChar = basePropertyOf(htmlUnescapes);

  /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  function unicodeSize(string) {
    var result = reUnicode.lastIndex = 0;
    while (reUnicode.test(string)) {
      ++result;
    }
    return result;
  }

  /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function unicodeToArray(string) {
    return string.match(reUnicode) || [];
  }

  /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function unicodeWords(string) {
    return string.match(reUnicodeWord) || [];
  }

  /*--------------------------------------------------------------------------*/

  /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */
  var runInContext = (function runInContext(context) {
    context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));

    /** Built-in constructor references. */
    var Array = context.Array,
        Date = context.Date,
        Error = context.Error,
        Function = context.Function,
        Math = context.Math,
        Object = context.Object,
        RegExp = context.RegExp,
        String = context.String,
        TypeError = context.TypeError;

    /** Used for built-in method references. */
    var arrayProto = Array.prototype,
        funcProto = Function.prototype,
        objectProto = Object.prototype;

    /** Used to detect overreaching core-js shims. */
    var coreJsData = context['__core-js_shared__'];

    /** Used to resolve the decompiled source of functions. */
    var funcToString = funcProto.toString;

    /** Used to check objects for own properties. */
    var hasOwnProperty = objectProto.hasOwnProperty;

    /** Used to generate unique IDs. */
    var idCounter = 0;

    /** Used to detect methods masquerading as native. */
    var maskSrcKey = (function() {
      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
      return uid ? ('Symbol(src)_1.' + uid) : '';
    }());

    /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */
    var nativeObjectToString = objectProto.toString;

    /** Used to infer the `Object` constructor. */
    var objectCtorString = funcToString.call(Object);

    /** Used to restore the original `_` reference in `_.noConflict`. */
    var oldDash = root._;

    /** Used to detect if a method is native. */
    var reIsNative = RegExp('^' +
      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
    );

    /** Built-in value references. */
    var Buffer = moduleExports ? context.Buffer : undefined,
        Symbol = context.Symbol,
        Uint8Array = context.Uint8Array,
        allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
        getPrototype = overArg(Object.getPrototypeOf, Object),
        objectCreate = Object.create,
        propertyIsEnumerable = objectProto.propertyIsEnumerable,
        splice = arrayProto.splice,
        spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined,
        symIterator = Symbol ? Symbol.iterator : undefined,
        symToStringTag = Symbol ? Symbol.toStringTag : undefined;

    var defineProperty = (function() {
      try {
        var func = getNative(Object, 'defineProperty');
        func({}, '', {});
        return func;
      } catch (e) {}
    }());

    /** Mocked built-ins. */
    var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
        ctxNow = Date && Date.now !== root.Date.now && Date.now,
        ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;

    /* Built-in method references for those with the same name as other `lodash` methods. */
    var nativeCeil = Math.ceil,
        nativeFloor = Math.floor,
        nativeGetSymbols = Object.getOwnPropertySymbols,
        nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
        nativeIsFinite = context.isFinite,
        nativeJoin = arrayProto.join,
        nativeKeys = overArg(Object.keys, Object),
        nativeMax = Math.max,
        nativeMin = Math.min,
        nativeNow = Date.now,
        nativeParseInt = context.parseInt,
        nativeRandom = Math.random,
        nativeReverse = arrayProto.reverse;

    /* Built-in method references that are verified to be native. */
    var DataView = getNative(context, 'DataView'),
        Map = getNative(context, 'Map'),
        Promise = getNative(context, 'Promise'),
        Set = getNative(context, 'Set'),
        WeakMap = getNative(context, 'WeakMap'),
        nativeCreate = getNative(Object, 'create');

    /** Used to store function metadata. */
    var metaMap = WeakMap && new WeakMap;

    /** Used to lookup unminified function names. */
    var realNames = {};

    /** Used to detect maps, sets, and weakmaps. */
    var dataViewCtorString = toSource(DataView),
        mapCtorString = toSource(Map),
        promiseCtorString = toSource(Promise),
        setCtorString = toSource(Set),
        weakMapCtorString = toSource(WeakMap);

    /** Used to convert symbols to primitives and strings. */
    var symbolProto = Symbol ? Symbol.prototype : undefined,
        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
        symbolToString = symbolProto ? symbolProto.toString : undefined;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */
    function lodash(value) {
      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
        if (value instanceof LodashWrapper) {
          return value;
        }
        if (hasOwnProperty.call(value, '__wrapped__')) {
          return wrapperClone(value);
        }
      }
      return new LodashWrapper(value);
    }

    /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */
    var baseCreate = (function() {
      function object() {}
      return function(proto) {
        if (!isObject(proto)) {
          return {};
        }
        if (objectCreate) {
          return objectCreate(proto);
        }
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
      };
    }());

    /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */
    function baseLodash() {
      // No operation performed.
    }

    /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */
    function LodashWrapper(value, chainAll) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__chain__ = !!chainAll;
      this.__index__ = 0;
      this.__values__ = undefined;
    }

    /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */
    lodash.templateSettings = {

      /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'escape': reEscape,

      /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'evaluate': reEvaluate,

      /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'interpolate': reInterpolate,

      /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */
      'variable': '',

      /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */
      'imports': {

        /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */
        '_': lodash
      }
    };

    // Ensure wrappers are instances of `baseLodash`.
    lodash.prototype = baseLodash.prototype;
    lodash.prototype.constructor = lodash;

    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
    LodashWrapper.prototype.constructor = LodashWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */
    function LazyWrapper(value) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__dir__ = 1;
      this.__filtered__ = false;
      this.__iteratees__ = [];
      this.__takeCount__ = MAX_ARRAY_LENGTH;
      this.__views__ = [];
    }

    /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */
    function lazyClone() {
      var result = new LazyWrapper(this.__wrapped__);
      result.__actions__ = copyArray(this.__actions__);
      result.__dir__ = this.__dir__;
      result.__filtered__ = this.__filtered__;
      result.__iteratees__ = copyArray(this.__iteratees__);
      result.__takeCount__ = this.__takeCount__;
      result.__views__ = copyArray(this.__views__);
      return result;
    }

    /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */
    function lazyReverse() {
      if (this.__filtered__) {
        var result = new LazyWrapper(this);
        result.__dir__ = -1;
        result.__filtered__ = true;
      } else {
        result = this.clone();
        result.__dir__ *= -1;
      }
      return result;
    }

    /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */
    function lazyValue() {
      var array = this.__wrapped__.value(),
          dir = this.__dir__,
          isArr = isArray(array),
          isRight = dir < 0,
          arrLength = isArr ? array.length : 0,
          view = getView(0, arrLength, this.__views__),
          start = view.start,
          end = view.end,
          length = end - start,
          index = isRight ? end : (start - 1),
          iteratees = this.__iteratees__,
          iterLength = iteratees.length,
          resIndex = 0,
          takeCount = nativeMin(length, this.__takeCount__);

      if (!isArr || (!isRight && arrLength == length && takeCount == length)) {
        return baseWrapperValue(array, this.__actions__);
      }
      var result = [];

      outer:
      while (length-- && resIndex < takeCount) {
        index += dir;

        var iterIndex = -1,
            value = array[index];

        while (++iterIndex < iterLength) {
          var data = iteratees[iterIndex],
              iteratee = data.iteratee,
              type = data.type,
              computed = iteratee(value);

          if (type == LAZY_MAP_FLAG) {
            value = computed;
          } else if (!computed) {
            if (type == LAZY_FILTER_FLAG) {
              continue outer;
            } else {
              break outer;
            }
          }
        }
        result[resIndex++] = value;
      }
      return result;
    }

    // Ensure `LazyWrapper` is an instance of `baseLodash`.
    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
    LazyWrapper.prototype.constructor = LazyWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Hash(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */
    function hashClear() {
      this.__data__ = nativeCreate ? nativeCreate(null) : {};
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function hashDelete(key) {
      var result = this.has(key) && delete this.__data__[key];
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function hashGet(key) {
      var data = this.__data__;
      if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
      }
      return hasOwnProperty.call(data, key) ? data[key] : undefined;
    }

    /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function hashHas(key) {
      var data = this.__data__;
      return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
    }

    /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */
    function hashSet(key, value) {
      var data = this.__data__;
      this.size += this.has(key) ? 0 : 1;
      data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
      return this;
    }

    // Add methods to `Hash`.
    Hash.prototype.clear = hashClear;
    Hash.prototype['delete'] = hashDelete;
    Hash.prototype.get = hashGet;
    Hash.prototype.has = hashHas;
    Hash.prototype.set = hashSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function ListCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */
    function listCacheClear() {
      this.__data__ = [];
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function listCacheDelete(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        return false;
      }
      var lastIndex = data.length - 1;
      if (index == lastIndex) {
        data.pop();
      } else {
        splice.call(data, index, 1);
      }
      --this.size;
      return true;
    }

    /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function listCacheGet(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      return index < 0 ? undefined : data[index][1];
    }

    /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function listCacheHas(key) {
      return assocIndexOf(this.__data__, key) > -1;
    }

    /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */
    function listCacheSet(key, value) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        ++this.size;
        data.push([key, value]);
      } else {
        data[index][1] = value;
      }
      return this;
    }

    // Add methods to `ListCache`.
    ListCache.prototype.clear = listCacheClear;
    ListCache.prototype['delete'] = listCacheDelete;
    ListCache.prototype.get = listCacheGet;
    ListCache.prototype.has = listCacheHas;
    ListCache.prototype.set = listCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function MapCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */
    function mapCacheClear() {
      this.size = 0;
      this.__data__ = {
        'hash': new Hash,
        'map': new (Map || ListCache),
        'string': new Hash
      };
    }

    /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function mapCacheDelete(key) {
      var result = getMapData(this, key)['delete'](key);
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function mapCacheGet(key) {
      return getMapData(this, key).get(key);
    }

    /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function mapCacheHas(key) {
      return getMapData(this, key).has(key);
    }

    /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */
    function mapCacheSet(key, value) {
      var data = getMapData(this, key),
          size = data.size;

      data.set(key, value);
      this.size += data.size == size ? 0 : 1;
      return this;
    }

    // Add methods to `MapCache`.
    MapCache.prototype.clear = mapCacheClear;
    MapCache.prototype['delete'] = mapCacheDelete;
    MapCache.prototype.get = mapCacheGet;
    MapCache.prototype.has = mapCacheHas;
    MapCache.prototype.set = mapCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */
    function SetCache(values) {
      var index = -1,
          length = values == null ? 0 : values.length;

      this.__data__ = new MapCache;
      while (++index < length) {
        this.add(values[index]);
      }
    }

    /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */
    function setCacheAdd(value) {
      this.__data__.set(value, HASH_UNDEFINED);
      return this;
    }

    /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */
    function setCacheHas(value) {
      return this.__data__.has(value);
    }

    // Add methods to `SetCache`.
    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
    SetCache.prototype.has = setCacheHas;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Stack(entries) {
      var data = this.__data__ = new ListCache(entries);
      this.size = data.size;
    }

    /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */
    function stackClear() {
      this.__data__ = new ListCache;
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function stackDelete(key) {
      var data = this.__data__,
          result = data['delete'](key);

      this.size = data.size;
      return result;
    }

    /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function stackGet(key) {
      return this.__data__.get(key);
    }

    /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function stackHas(key) {
      return this.__data__.has(key);
    }

    /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */
    function stackSet(key, value) {
      var data = this.__data__;
      if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
          pairs.push([key, value]);
          this.size = ++data.size;
          return this;
        }
        data = this.__data__ = new MapCache(pairs);
      }
      data.set(key, value);
      this.size = data.size;
      return this;
    }

    // Add methods to `Stack`.
    Stack.prototype.clear = stackClear;
    Stack.prototype['delete'] = stackDelete;
    Stack.prototype.get = stackGet;
    Stack.prototype.has = stackHas;
    Stack.prototype.set = stackSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */
    function arrayLikeKeys(value, inherited) {
      var isArr = isArray(value),
          isArg = !isArr && isArguments(value),
          isBuff = !isArr && !isArg && isBuffer(value),
          isType = !isArr && !isArg && !isBuff && isTypedArray(value),
          skipIndexes = isArr || isArg || isBuff || isType,
          result = skipIndexes ? baseTimes(value.length, String) : [],
          length = result.length;

      for (var key in value) {
        if ((inherited || hasOwnProperty.call(value, key)) &&
            !(skipIndexes && (
               // Safari 9 has enumerable `arguments.length` in strict mode.
               key == 'length' ||
               // Node.js 0.10 has enumerable non-index properties on buffers.
               (isBuff && (key == 'offset' || key == 'parent')) ||
               // PhantomJS 2 has enumerable non-index properties on typed arrays.
               (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
               // Skip index properties.
               isIndex(key, length)
            ))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */
    function arraySample(array) {
      var length = array.length;
      return length ? array[baseRandom(0, length - 1)] : undefined;
    }

    /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function arraySampleSize(array, n) {
      return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
    }

    /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function arrayShuffle(array) {
      return shuffleSelf(copyArray(array));
    }

    /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignMergeValue(object, key, value) {
      if ((value !== undefined && !eq(object[key], value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignValue(object, key, value) {
      var objValue = object[key];
      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */
    function assocIndexOf(array, key) {
      var length = array.length;
      while (length--) {
        if (eq(array[length][0], key)) {
          return length;
        }
      }
      return -1;
    }

    /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseAggregator(collection, setter, iteratee, accumulator) {
      baseEach(collection, function(value, key, collection) {
        setter(accumulator, value, iteratee(value), collection);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssign(object, source) {
      return object && copyObject(source, keys(source), object);
    }

    /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssignIn(object, source) {
      return object && copyObject(source, keysIn(source), object);
    }

    /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function baseAssignValue(object, key, value) {
      if (key == '__proto__' && defineProperty) {
        defineProperty(object, key, {
          'configurable': true,
          'enumerable': true,
          'value': value,
          'writable': true
        });
      } else {
        object[key] = value;
      }
    }

    /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */
    function baseAt(object, paths) {
      var index = -1,
          length = paths.length,
          result = Array(length),
          skip = object == null;

      while (++index < length) {
        result[index] = skip ? undefined : get(object, paths[index]);
      }
      return result;
    }

    /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */
    function baseClamp(number, lower, upper) {
      if (number === number) {
        if (upper !== undefined) {
          number = number <= upper ? number : upper;
        }
        if (lower !== undefined) {
          number = number >= lower ? number : lower;
        }
      }
      return number;
    }

    /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */
    function baseClone(value, bitmask, customizer, key, object, stack) {
      var result,
          isDeep = bitmask & CLONE_DEEP_FLAG,
          isFlat = bitmask & CLONE_FLAT_FLAG,
          isFull = bitmask & CLONE_SYMBOLS_FLAG;

      if (customizer) {
        result = object ? customizer(value, key, object, stack) : customizer(value);
      }
      if (result !== undefined) {
        return result;
      }
      if (!isObject(value)) {
        return value;
      }
      var isArr = isArray(value);
      if (isArr) {
        result = initCloneArray(value);
        if (!isDeep) {
          return copyArray(value, result);
        }
      } else {
        var tag = getTag(value),
            isFunc = tag == funcTag || tag == genTag;

        if (isBuffer(value)) {
          return cloneBuffer(value, isDeep);
        }
        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
          result = (isFlat || isFunc) ? {} : initCloneObject(value);
          if (!isDeep) {
            return isFlat
              ? copySymbolsIn(value, baseAssignIn(result, value))
              : copySymbols(value, baseAssign(result, value));
          }
        } else {
          if (!cloneableTags[tag]) {
            return object ? value : {};
          }
          result = initCloneByTag(value, tag, isDeep);
        }
      }
      // Check for circular references and return its corresponding clone.
      stack || (stack = new Stack);
      var stacked = stack.get(value);
      if (stacked) {
        return stacked;
      }
      stack.set(value, result);

      if (isSet(value)) {
        value.forEach(function(subValue) {
          result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
        });
      } else if (isMap(value)) {
        value.forEach(function(subValue, key) {
          result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
        });
      }

      var keysFunc = isFull
        ? (isFlat ? getAllKeysIn : getAllKeys)
        : (isFlat ? keysIn : keys);

      var props = isArr ? undefined : keysFunc(value);
      arrayEach(props || value, function(subValue, key) {
        if (props) {
          key = subValue;
          subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
      });
      return result;
    }

    /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */
    function baseConforms(source) {
      var props = keys(source);
      return function(object) {
        return baseConformsTo(object, source, props);
      };
    }

    /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */
    function baseConformsTo(object, source, props) {
      var length = props.length;
      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (length--) {
        var key = props[length],
            predicate = source[key],
            value = object[key];

        if ((value === undefined && !(key in object)) || !predicate(value)) {
          return false;
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    function baseDelay(func, wait, args) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return setTimeout(function() { func.apply(undefined, args); }, wait);
    }

    /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */
    function baseDifference(array, values, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          isCommon = true,
          length = array.length,
          result = [],
          valuesLength = values.length;

      if (!length) {
        return result;
      }
      if (iteratee) {
        values = arrayMap(values, baseUnary(iteratee));
      }
      if (comparator) {
        includes = arrayIncludesWith;
        isCommon = false;
      }
      else if (values.length >= LARGE_ARRAY_SIZE) {
        includes = cacheHas;
        isCommon = false;
        values = new SetCache(values);
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee == null ? value : iteratee(value);

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var valuesIndex = valuesLength;
          while (valuesIndex--) {
            if (values[valuesIndex] === computed) {
              continue outer;
            }
          }
          result.push(value);
        }
        else if (!includes(values, computed, comparator)) {
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEach = createBaseEach(baseForOwn);

    /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEachRight = createBaseEach(baseForOwnRight, true);

    /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */
    function baseEvery(collection, predicate) {
      var result = true;
      baseEach(collection, function(value, index, collection) {
        result = !!predicate(value, index, collection);
        return result;
      });
      return result;
    }

    /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */
    function baseExtremum(array, iteratee, comparator) {
      var index = -1,
          length = array.length;

      while (++index < length) {
        var value = array[index],
            current = iteratee(value);

        if (current != null && (computed === undefined
              ? (current === current && !isSymbol(current))
              : comparator(current, computed)
            )) {
          var computed = current,
              result = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */
    function baseFill(array, value, start, end) {
      var length = array.length;

      start = toInteger(start);
      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = (end === undefined || end > length) ? length : toInteger(end);
      if (end < 0) {
        end += length;
      }
      end = start > end ? 0 : toLength(end);
      while (start < end) {
        array[start++] = value;
      }
      return array;
    }

    /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */
    function baseFilter(collection, predicate) {
      var result = [];
      baseEach(collection, function(value, index, collection) {
        if (predicate(value, index, collection)) {
          result.push(value);
        }
      });
      return result;
    }

    /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */
    function baseFlatten(array, depth, predicate, isStrict, result) {
      var index = -1,
          length = array.length;

      predicate || (predicate = isFlattenable);
      result || (result = []);

      while (++index < length) {
        var value = array[index];
        if (depth > 0 && predicate(value)) {
          if (depth > 1) {
            // Recursively flatten arrays (susceptible to call stack limits).
            baseFlatten(value, depth - 1, predicate, isStrict, result);
          } else {
            arrayPush(result, value);
          }
        } else if (!isStrict) {
          result[result.length] = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseFor = createBaseFor();

    /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseForRight = createBaseFor(true);

    /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwn(object, iteratee) {
      return object && baseFor(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwnRight(object, iteratee) {
      return object && baseForRight(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */
    function baseFunctions(object, props) {
      return arrayFilter(props, function(key) {
        return isFunction(object[key]);
      });
    }

    /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */
    function baseGet(object, path) {
      path = castPath(path, object);

      var index = 0,
          length = path.length;

      while (object != null && index < length) {
        object = object[toKey(path[index++])];
      }
      return (index && index == length) ? object : undefined;
    }

    /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
      var result = keysFunc(object);
      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
    }

    /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    function baseGetTag(value) {
      if (value == null) {
        return value === undefined ? undefinedTag : nullTag;
      }
      return (symToStringTag && symToStringTag in Object(value))
        ? getRawTag(value)
        : objectToString(value);
    }

    /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */
    function baseGt(value, other) {
      return value > other;
    }

    /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHas(object, key) {
      return object != null && hasOwnProperty.call(object, key);
    }

    /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHasIn(object, key) {
      return object != null && key in Object(object);
    }

    /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */
    function baseInRange(number, start, end) {
      return number >= nativeMin(start, end) && number < nativeMax(start, end);
    }

    /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */
    function baseIntersection(arrays, iteratee, comparator) {
      var includes = comparator ? arrayIncludesWith : arrayIncludes,
          length = arrays[0].length,
          othLength = arrays.length,
          othIndex = othLength,
          caches = Array(othLength),
          maxLength = Infinity,
          result = [];

      while (othIndex--) {
        var array = arrays[othIndex];
        if (othIndex && iteratee) {
          array = arrayMap(array, baseUnary(iteratee));
        }
        maxLength = nativeMin(array.length, maxLength);
        caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
          ? new SetCache(othIndex && array)
          : undefined;
      }
      array = arrays[0];

      var index = -1,
          seen = caches[0];

      outer:
      while (++index < length && result.length < maxLength) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (!(seen
              ? cacheHas(seen, computed)
              : includes(result, computed, comparator)
            )) {
          othIndex = othLength;
          while (--othIndex) {
            var cache = caches[othIndex];
            if (!(cache
                  ? cacheHas(cache, computed)
                  : includes(arrays[othIndex], computed, comparator))
                ) {
              continue outer;
            }
          }
          if (seen) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseInverter(object, setter, iteratee, accumulator) {
      baseForOwn(object, function(value, key, object) {
        setter(accumulator, iteratee(value), key, object);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */
    function baseInvoke(object, path, args) {
      path = castPath(path, object);
      object = parent(object, path);
      var func = object == null ? object : object[toKey(last(path))];
      return func == null ? undefined : apply(func, object, args);
    }

    /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */
    function baseIsArguments(value) {
      return isObjectLike(value) && baseGetTag(value) == argsTag;
    }

    /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */
    function baseIsArrayBuffer(value) {
      return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
    }

    /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */
    function baseIsDate(value) {
      return isObjectLike(value) && baseGetTag(value) == dateTag;
    }

    /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */
    function baseIsEqual(value, other, bitmask, customizer, stack) {
      if (value === other) {
        return true;
      }
      if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
        return value !== value && other !== other;
      }
      return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
    }

    /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
      var objIsArr = isArray(object),
          othIsArr = isArray(other),
          objTag = objIsArr ? arrayTag : getTag(object),
          othTag = othIsArr ? arrayTag : getTag(other);

      objTag = objTag == argsTag ? objectTag : objTag;
      othTag = othTag == argsTag ? objectTag : othTag;

      var objIsObj = objTag == objectTag,
          othIsObj = othTag == objectTag,
          isSameTag = objTag == othTag;

      if (isSameTag && isBuffer(object)) {
        if (!isBuffer(other)) {
          return false;
        }
        objIsArr = true;
        objIsObj = false;
      }
      if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return (objIsArr || isTypedArray(object))
          ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
          : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
      }
      if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

        if (objIsWrapped || othIsWrapped) {
          var objUnwrapped = objIsWrapped ? object.value() : object,
              othUnwrapped = othIsWrapped ? other.value() : other;

          stack || (stack = new Stack);
          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
      }
      if (!isSameTag) {
        return false;
      }
      stack || (stack = new Stack);
      return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
    }

    /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */
    function baseIsMap(value) {
      return isObjectLike(value) && getTag(value) == mapTag;
    }

    /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */
    function baseIsMatch(object, source, matchData, customizer) {
      var index = matchData.length,
          length = index,
          noCustomizer = !customizer;

      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (index--) {
        var data = matchData[index];
        if ((noCustomizer && data[2])
              ? data[1] !== object[data[0]]
              : !(data[0] in object)
            ) {
          return false;
        }
      }
      while (++index < length) {
        data = matchData[index];
        var key = data[0],
            objValue = object[key],
            srcValue = data[1];

        if (noCustomizer && data[2]) {
          if (objValue === undefined && !(key in object)) {
            return false;
          }
        } else {
          var stack = new Stack;
          if (customizer) {
            var result = customizer(objValue, srcValue, key, object, source, stack);
          }
          if (!(result === undefined
                ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
                : result
              )) {
            return false;
          }
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */
    function baseIsNative(value) {
      if (!isObject(value) || isMasked(value)) {
        return false;
      }
      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
      return pattern.test(toSource(value));
    }

    /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */
    function baseIsRegExp(value) {
      return isObjectLike(value) && baseGetTag(value) == regexpTag;
    }

    /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */
    function baseIsSet(value) {
      return isObjectLike(value) && getTag(value) == setTag;
    }

    /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */
    function baseIsTypedArray(value) {
      return isObjectLike(value) &&
        isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
    }

    /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */
    function baseIteratee(value) {
      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
      if (typeof value == 'function') {
        return value;
      }
      if (value == null) {
        return identity;
      }
      if (typeof value == 'object') {
        return isArray(value)
          ? baseMatchesProperty(value[0], value[1])
          : baseMatches(value);
      }
      return property(value);
    }

    /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeys(object) {
      if (!isPrototype(object)) {
        return nativeKeys(object);
      }
      var result = [];
      for (var key in Object(object)) {
        if (hasOwnProperty.call(object, key) && key != 'constructor') {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeysIn(object) {
      if (!isObject(object)) {
        return nativeKeysIn(object);
      }
      var isProto = isPrototype(object),
          result = [];

      for (var key in object) {
        if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */
    function baseLt(value, other) {
      return value < other;
    }

    /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */
    function baseMap(collection, iteratee) {
      var index = -1,
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
      });
      return result;
    }

    /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatches(source) {
      var matchData = getMatchData(source);
      if (matchData.length == 1 && matchData[0][2]) {
        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
      }
      return function(object) {
        return object === source || baseIsMatch(object, source, matchData);
      };
    }

    /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatchesProperty(path, srcValue) {
      if (isKey(path) && isStrictComparable(srcValue)) {
        return matchesStrictComparable(toKey(path), srcValue);
      }
      return function(object) {
        var objValue = get(object, path);
        return (objValue === undefined && objValue === srcValue)
          ? hasIn(object, path)
          : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
      };
    }

    /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMerge(object, source, srcIndex, customizer, stack) {
      if (object === source) {
        return;
      }
      baseFor(source, function(srcValue, key) {
        stack || (stack = new Stack);
        if (isObject(srcValue)) {
          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
        }
        else {
          var newValue = customizer
            ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
            : undefined;

          if (newValue === undefined) {
            newValue = srcValue;
          }
          assignMergeValue(object, key, newValue);
        }
      }, keysIn);
    }

    /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
      var objValue = safeGet(object, key),
          srcValue = safeGet(source, key),
          stacked = stack.get(srcValue);

      if (stacked) {
        assignMergeValue(object, key, stacked);
        return;
      }
      var newValue = customizer
        ? customizer(objValue, srcValue, (key + ''), object, source, stack)
        : undefined;

      var isCommon = newValue === undefined;

      if (isCommon) {
        var isArr = isArray(srcValue),
            isBuff = !isArr && isBuffer(srcValue),
            isTyped = !isArr && !isBuff && isTypedArray(srcValue);

        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
          if (isArray(objValue)) {
            newValue = objValue;
          }
          else if (isArrayLikeObject(objValue)) {
            newValue = copyArray(objValue);
          }
          else if (isBuff) {
            isCommon = false;
            newValue = cloneBuffer(srcValue, true);
          }
          else if (isTyped) {
            isCommon = false;
            newValue = cloneTypedArray(srcValue, true);
          }
          else {
            newValue = [];
          }
        }
        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
          newValue = objValue;
          if (isArguments(objValue)) {
            newValue = toPlainObject(objValue);
          }
          else if (!isObject(objValue) || isFunction(objValue)) {
            newValue = initCloneObject(srcValue);
          }
        }
        else {
          isCommon = false;
        }
      }
      if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack['delete'](srcValue);
      }
      assignMergeValue(object, key, newValue);
    }

    /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */
    function baseNth(array, n) {
      var length = array.length;
      if (!length) {
        return;
      }
      n += n < 0 ? length : 0;
      return isIndex(n, length) ? array[n] : undefined;
    }

    /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */
    function baseOrderBy(collection, iteratees, orders) {
      if (iteratees.length) {
        iteratees = arrayMap(iteratees, function(iteratee) {
          if (isArray(iteratee)) {
            return function(value) {
              return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
            }
          }
          return iteratee;
        });
      } else {
        iteratees = [identity];
      }

      var index = -1;
      iteratees = arrayMap(iteratees, baseUnary(getIteratee()));

      var result = baseMap(collection, function(value, key, collection) {
        var criteria = arrayMap(iteratees, function(iteratee) {
          return iteratee(value);
        });
        return { 'criteria': criteria, 'index': ++index, 'value': value };
      });

      return baseSortBy(result, function(object, other) {
        return compareMultiple(object, other, orders);
      });
    }

    /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */
    function basePick(object, paths) {
      return basePickBy(object, paths, function(value, path) {
        return hasIn(object, path);
      });
    }

    /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */
    function basePickBy(object, paths, predicate) {
      var index = -1,
          length = paths.length,
          result = {};

      while (++index < length) {
        var path = paths[index],
            value = baseGet(object, path);

        if (predicate(value, path)) {
          baseSet(result, castPath(path, object), value);
        }
      }
      return result;
    }

    /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */
    function basePropertyDeep(path) {
      return function(object) {
        return baseGet(object, path);
      };
    }

    /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */
    function basePullAll(array, values, iteratee, comparator) {
      var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
          index = -1,
          length = values.length,
          seen = array;

      if (array === values) {
        values = copyArray(values);
      }
      if (iteratee) {
        seen = arrayMap(array, baseUnary(iteratee));
      }
      while (++index < length) {
        var fromIndex = 0,
            value = values[index],
            computed = iteratee ? iteratee(value) : value;

        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
          if (seen !== array) {
            splice.call(seen, fromIndex, 1);
          }
          splice.call(array, fromIndex, 1);
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */
    function basePullAt(array, indexes) {
      var length = array ? indexes.length : 0,
          lastIndex = length - 1;

      while (length--) {
        var index = indexes[length];
        if (length == lastIndex || index !== previous) {
          var previous = index;
          if (isIndex(index)) {
            splice.call(array, index, 1);
          } else {
            baseUnset(array, index);
          }
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */
    function baseRandom(lower, upper) {
      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
    }

    /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */
    function baseRange(start, end, step, fromRight) {
      var index = -1,
          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
          result = Array(length);

      while (length--) {
        result[fromRight ? length : ++index] = start;
        start += step;
      }
      return result;
    }

    /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */
    function baseRepeat(string, n) {
      var result = '';
      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
        return result;
      }
      // Leverage the exponentiation by squaring algorithm for a faster repeat.
      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
      do {
        if (n % 2) {
          result += string;
        }
        n = nativeFloor(n / 2);
        if (n) {
          string += string;
        }
      } while (n);

      return result;
    }

    /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */
    function baseRest(func, start) {
      return setToString(overRest(func, start, identity), func + '');
    }

    /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */
    function baseSample(collection) {
      return arraySample(values(collection));
    }

    /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function baseSampleSize(collection, n) {
      var array = values(collection);
      return shuffleSelf(array, baseClamp(n, 0, array.length));
    }

    /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseSet(object, path, value, customizer) {
      if (!isObject(object)) {
        return object;
      }
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          lastIndex = length - 1,
          nested = object;

      while (nested != null && ++index < length) {
        var key = toKey(path[index]),
            newValue = value;

        if (key === '__proto__' || key === 'constructor' || key === 'prototype') {
          return object;
        }

        if (index != lastIndex) {
          var objValue = nested[key];
          newValue = customizer ? customizer(objValue, key, nested) : undefined;
          if (newValue === undefined) {
            newValue = isObject(objValue)
              ? objValue
              : (isIndex(path[index + 1]) ? [] : {});
          }
        }
        assignValue(nested, key, newValue);
        nested = nested[key];
      }
      return object;
    }

    /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var baseSetData = !metaMap ? identity : function(func, data) {
      metaMap.set(func, data);
      return func;
    };

    /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var baseSetToString = !defineProperty ? identity : function(func, string) {
      return defineProperty(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': constant(string),
        'writable': true
      });
    };

    /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function baseShuffle(collection) {
      return shuffleSelf(values(collection));
    }

    /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseSlice(array, start, end) {
      var index = -1,
          length = array.length;

      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = end > length ? length : end;
      if (end < 0) {
        end += length;
      }
      length = start > end ? 0 : ((end - start) >>> 0);
      start >>>= 0;

      var result = Array(length);
      while (++index < length) {
        result[index] = array[index + start];
      }
      return result;
    }

    /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */
    function baseSome(collection, predicate) {
      var result;

      baseEach(collection, function(value, index, collection) {
        result = predicate(value, index, collection);
        return !result;
      });
      return !!result;
    }

    /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndex(array, value, retHighest) {
      var low = 0,
          high = array == null ? low : array.length;

      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
        while (low < high) {
          var mid = (low + high) >>> 1,
              computed = array[mid];

          if (computed !== null && !isSymbol(computed) &&
              (retHighest ? (computed <= value) : (computed < value))) {
            low = mid + 1;
          } else {
            high = mid;
          }
        }
        return high;
      }
      return baseSortedIndexBy(array, value, identity, retHighest);
    }

    /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndexBy(array, value, iteratee, retHighest) {
      var low = 0,
          high = array == null ? 0 : array.length;
      if (high === 0) {
        return 0;
      }

      value = iteratee(value);
      var valIsNaN = value !== value,
          valIsNull = value === null,
          valIsSymbol = isSymbol(value),
          valIsUndefined = value === undefined;

      while (low < high) {
        var mid = nativeFloor((low + high) / 2),
            computed = iteratee(array[mid]),
            othIsDefined = computed !== undefined,
            othIsNull = computed === null,
            othIsReflexive = computed === computed,
            othIsSymbol = isSymbol(computed);

        if (valIsNaN) {
          var setLow = retHighest || othIsReflexive;
        } else if (valIsUndefined) {
          setLow = othIsReflexive && (retHighest || othIsDefined);
        } else if (valIsNull) {
          setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
        } else if (valIsSymbol) {
          setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
        } else if (othIsNull || othIsSymbol) {
          setLow = false;
        } else {
          setLow = retHighest ? (computed <= value) : (computed < value);
        }
        if (setLow) {
          low = mid + 1;
        } else {
          high = mid;
        }
      }
      return nativeMin(high, MAX_ARRAY_INDEX);
    }

    /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseSortedUniq(array, iteratee) {
      var index = -1,
          length = array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        if (!index || !eq(computed, seen)) {
          var seen = computed;
          result[resIndex++] = value === 0 ? 0 : value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */
    function baseToNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      return +value;
    }

    /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */
    function baseToString(value) {
      // Exit early for strings to avoid a performance hit in some environments.
      if (typeof value == 'string') {
        return value;
      }
      if (isArray(value)) {
        // Recursively convert values (susceptible to call stack limits).
        return arrayMap(value, baseToString) + '';
      }
      if (isSymbol(value)) {
        return symbolToString ? symbolToString.call(value) : '';
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseUniq(array, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          length = array.length,
          isCommon = true,
          result = [],
          seen = result;

      if (comparator) {
        isCommon = false;
        includes = arrayIncludesWith;
      }
      else if (length >= LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : createSet(array);
        if (set) {
          return setToArray(set);
        }
        isCommon = false;
        includes = cacheHas;
        seen = new SetCache;
      }
      else {
        seen = iteratee ? [] : result;
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var seenIndex = seen.length;
          while (seenIndex--) {
            if (seen[seenIndex] === computed) {
              continue outer;
            }
          }
          if (iteratee) {
            seen.push(computed);
          }
          result.push(value);
        }
        else if (!includes(seen, computed, comparator)) {
          if (seen !== result) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */
    function baseUnset(object, path) {
      path = castPath(path, object);
      object = parent(object, path);
      return object == null || delete object[toKey(last(path))];
    }

    /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseUpdate(object, path, updater, customizer) {
      return baseSet(object, path, updater(baseGet(object, path)), customizer);
    }

    /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseWhile(array, predicate, isDrop, fromRight) {
      var length = array.length,
          index = fromRight ? length : -1;

      while ((fromRight ? index-- : ++index < length) &&
        predicate(array[index], index, array)) {}

      return isDrop
        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
    }

    /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */
    function baseWrapperValue(value, actions) {
      var result = value;
      if (result instanceof LazyWrapper) {
        result = result.value();
      }
      return arrayReduce(actions, function(result, action) {
        return action.func.apply(action.thisArg, arrayPush([result], action.args));
      }, result);
    }

    /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */
    function baseXor(arrays, iteratee, comparator) {
      var length = arrays.length;
      if (length < 2) {
        return length ? baseUniq(arrays[0]) : [];
      }
      var index = -1,
          result = Array(length);

      while (++index < length) {
        var array = arrays[index],
            othIndex = -1;

        while (++othIndex < length) {
          if (othIndex != index) {
            result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
          }
        }
      }
      return baseUniq(baseFlatten(result, 1), iteratee, comparator);
    }

    /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */
    function baseZipObject(props, values, assignFunc) {
      var index = -1,
          length = props.length,
          valsLength = values.length,
          result = {};

      while (++index < length) {
        var value = index < valsLength ? values[index] : undefined;
        assignFunc(result, props[index], value);
      }
      return result;
    }

    /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */
    function castArrayLikeObject(value) {
      return isArrayLikeObject(value) ? value : [];
    }

    /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */
    function castFunction(value) {
      return typeof value == 'function' ? value : identity;
    }

    /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */
    function castPath(value, object) {
      if (isArray(value)) {
        return value;
      }
      return isKey(value, object) ? [value] : stringToPath(toString(value));
    }

    /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    var castRest = baseRest;

    /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */
    function castSlice(array, start, end) {
      var length = array.length;
      end = end === undefined ? length : end;
      return (!start && end >= length) ? array : baseSlice(array, start, end);
    }

    /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */
    var clearTimeout = ctxClearTimeout || function(id) {
      return root.clearTimeout(id);
    };

    /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */
    function cloneBuffer(buffer, isDeep) {
      if (isDeep) {
        return buffer.slice();
      }
      var length = buffer.length,
          result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

      buffer.copy(result);
      return result;
    }

    /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */
    function cloneArrayBuffer(arrayBuffer) {
      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
      return result;
    }

    /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */
    function cloneDataView(dataView, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
    }

    /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */
    function cloneRegExp(regexp) {
      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
      result.lastIndex = regexp.lastIndex;
      return result;
    }

    /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */
    function cloneSymbol(symbol) {
      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
    }

    /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */
    function cloneTypedArray(typedArray, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
    }

    /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */
    function compareAscending(value, other) {
      if (value !== other) {
        var valIsDefined = value !== undefined,
            valIsNull = value === null,
            valIsReflexive = value === value,
            valIsSymbol = isSymbol(value);

        var othIsDefined = other !== undefined,
            othIsNull = other === null,
            othIsReflexive = other === other,
            othIsSymbol = isSymbol(other);

        if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
            (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
            (valIsNull && othIsDefined && othIsReflexive) ||
            (!valIsDefined && othIsReflexive) ||
            !valIsReflexive) {
          return 1;
        }
        if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
            (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
            (othIsNull && valIsDefined && valIsReflexive) ||
            (!othIsDefined && valIsReflexive) ||
            !othIsReflexive) {
          return -1;
        }
      }
      return 0;
    }

    /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */
    function compareMultiple(object, other, orders) {
      var index = -1,
          objCriteria = object.criteria,
          othCriteria = other.criteria,
          length = objCriteria.length,
          ordersLength = orders.length;

      while (++index < length) {
        var result = compareAscending(objCriteria[index], othCriteria[index]);
        if (result) {
          if (index >= ordersLength) {
            return result;
          }
          var order = orders[index];
          return result * (order == 'desc' ? -1 : 1);
        }
      }
      // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
      // that causes it, under certain circumstances, to provide the same value for
      // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
      // for more details.
      //
      // This also ensures a stable sort in V8 and other engines.
      // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
      return object.index - other.index;
    }

    /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgs(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersLength = holders.length,
          leftIndex = -1,
          leftLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(leftLength + rangeLength),
          isUncurried = !isCurried;

      while (++leftIndex < leftLength) {
        result[leftIndex] = partials[leftIndex];
      }
      while (++argsIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[holders[argsIndex]] = args[argsIndex];
        }
      }
      while (rangeLength--) {
        result[leftIndex++] = args[argsIndex++];
      }
      return result;
    }

    /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgsRight(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersIndex = -1,
          holdersLength = holders.length,
          rightIndex = -1,
          rightLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(rangeLength + rightLength),
          isUncurried = !isCurried;

      while (++argsIndex < rangeLength) {
        result[argsIndex] = args[argsIndex];
      }
      var offset = argsIndex;
      while (++rightIndex < rightLength) {
        result[offset + rightIndex] = partials[rightIndex];
      }
      while (++holdersIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[offset + holders[holdersIndex]] = args[argsIndex++];
        }
      }
      return result;
    }

    /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */
    function copyArray(source, array) {
      var index = -1,
          length = source.length;

      array || (array = Array(length));
      while (++index < length) {
        array[index] = source[index];
      }
      return array;
    }

    /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */
    function copyObject(source, props, object, customizer) {
      var isNew = !object;
      object || (object = {});

      var index = -1,
          length = props.length;

      while (++index < length) {
        var key = props[index];

        var newValue = customizer
          ? customizer(object[key], source[key], key, object, source)
          : undefined;

        if (newValue === undefined) {
          newValue = source[key];
        }
        if (isNew) {
          baseAssignValue(object, key, newValue);
        } else {
          assignValue(object, key, newValue);
        }
      }
      return object;
    }

    /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbols(source, object) {
      return copyObject(source, getSymbols(source), object);
    }

    /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbolsIn(source, object) {
      return copyObject(source, getSymbolsIn(source), object);
    }

    /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */
    function createAggregator(setter, initializer) {
      return function(collection, iteratee) {
        var func = isArray(collection) ? arrayAggregator : baseAggregator,
            accumulator = initializer ? initializer() : {};

        return func(collection, setter, getIteratee(iteratee, 2), accumulator);
      };
    }

    /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */
    function createAssigner(assigner) {
      return baseRest(function(object, sources) {
        var index = -1,
            length = sources.length,
            customizer = length > 1 ? sources[length - 1] : undefined,
            guard = length > 2 ? sources[2] : undefined;

        customizer = (assigner.length > 3 && typeof customizer == 'function')
          ? (length--, customizer)
          : undefined;

        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
          customizer = length < 3 ? undefined : customizer;
          length = 1;
        }
        object = Object(object);
        while (++index < length) {
          var source = sources[index];
          if (source) {
            assigner(object, source, index, customizer);
          }
        }
        return object;
      });
    }

    /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseEach(eachFunc, fromRight) {
      return function(collection, iteratee) {
        if (collection == null) {
          return collection;
        }
        if (!isArrayLike(collection)) {
          return eachFunc(collection, iteratee);
        }
        var length = collection.length,
            index = fromRight ? length : -1,
            iterable = Object(collection);

        while ((fromRight ? index-- : ++index < length)) {
          if (iteratee(iterable[index], index, iterable) === false) {
            break;
          }
        }
        return collection;
      };
    }

    /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseFor(fromRight) {
      return function(object, iteratee, keysFunc) {
        var index = -1,
            iterable = Object(object),
            props = keysFunc(object),
            length = props.length;

        while (length--) {
          var key = props[fromRight ? length : ++index];
          if (iteratee(iterable[key], key, iterable) === false) {
            break;
          }
        }
        return object;
      };
    }

    /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createBind(func, bitmask, thisArg) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return fn.apply(isBind ? thisArg : this, arguments);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */
    function createCaseFirst(methodName) {
      return function(string) {
        string = toString(string);

        var strSymbols = hasUnicode(string)
          ? stringToArray(string)
          : undefined;

        var chr = strSymbols
          ? strSymbols[0]
          : string.charAt(0);

        var trailing = strSymbols
          ? castSlice(strSymbols, 1).join('')
          : string.slice(1);

        return chr[methodName]() + trailing;
      };
    }

    /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */
    function createCompounder(callback) {
      return function(string) {
        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
      };
    }

    /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCtor(Ctor) {
      return function() {
        // Use a `switch` statement to work with class constructors. See
        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
        // for more details.
        var args = arguments;
        switch (args.length) {
          case 0: return new Ctor;
          case 1: return new Ctor(args[0]);
          case 2: return new Ctor(args[0], args[1]);
          case 3: return new Ctor(args[0], args[1], args[2]);
          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
        }
        var thisBinding = baseCreate(Ctor.prototype),
            result = Ctor.apply(thisBinding, args);

        // Mimic the constructor's `return` behavior.
        // See https://es5.github.io/#x13.2.2 for more details.
        return isObject(result) ? result : thisBinding;
      };
    }

    /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCurry(func, bitmask, arity) {
      var Ctor = createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length,
            placeholder = getHolder(wrapper);

        while (index--) {
          args[index] = arguments[index];
        }
        var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
          ? []
          : replaceHolders(args, placeholder);

        length -= holders.length;
        if (length < arity) {
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, undefined,
            args, holders, undefined, undefined, arity - length);
        }
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return apply(fn, this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */
    function createFind(findIndexFunc) {
      return function(collection, predicate, fromIndex) {
        var iterable = Object(collection);
        if (!isArrayLike(collection)) {
          var iteratee = getIteratee(predicate, 3);
          collection = keys(collection);
          predicate = function(key) { return iteratee(iterable[key], key, iterable); };
        }
        var index = findIndexFunc(collection, predicate, fromIndex);
        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
      };
    }

    /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */
    function createFlow(fromRight) {
      return flatRest(function(funcs) {
        var length = funcs.length,
            index = length,
            prereq = LodashWrapper.prototype.thru;

        if (fromRight) {
          funcs.reverse();
        }
        while (index--) {
          var func = funcs[index];
          if (typeof func != 'function') {
            throw new TypeError(FUNC_ERROR_TEXT);
          }
          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
            var wrapper = new LodashWrapper([], true);
          }
        }
        index = wrapper ? index : length;
        while (++index < length) {
          func = funcs[index];

          var funcName = getFuncName(func),
              data = funcName == 'wrapper' ? getData(func) : undefined;

          if (data && isLaziable(data[0]) &&
                data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
                !data[4].length && data[9] == 1
              ) {
            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
          } else {
            wrapper = (func.length == 1 && isLaziable(func))
              ? wrapper[funcName]()
              : wrapper.thru(func);
          }
        }
        return function() {
          var args = arguments,
              value = args[0];

          if (wrapper && args.length == 1 && isArray(value)) {
            return wrapper.plant(value).value();
          }
          var index = 0,
              result = length ? funcs[index].apply(this, args) : value;

          while (++index < length) {
            result = funcs[index].call(this, result);
          }
          return result;
        };
      });
    }

    /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
      var isAry = bitmask & WRAP_ARY_FLAG,
          isBind = bitmask & WRAP_BIND_FLAG,
          isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
          isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
          isFlip = bitmask & WRAP_FLIP_FLAG,
          Ctor = isBindKey ? undefined : createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length;

        while (index--) {
          args[index] = arguments[index];
        }
        if (isCurried) {
          var placeholder = getHolder(wrapper),
              holdersCount = countHolders(args, placeholder);
        }
        if (partials) {
          args = composeArgs(args, partials, holders, isCurried);
        }
        if (partialsRight) {
          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
        }
        length -= holdersCount;
        if (isCurried && length < arity) {
          var newHolders = replaceHolders(args, placeholder);
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, thisArg,
            args, newHolders, argPos, ary, arity - length
          );
        }
        var thisBinding = isBind ? thisArg : this,
            fn = isBindKey ? thisBinding[func] : func;

        length = args.length;
        if (argPos) {
          args = reorder(args, argPos);
        } else if (isFlip && length > 1) {
          args.reverse();
        }
        if (isAry && ary < length) {
          args.length = ary;
        }
        if (this && this !== root && this instanceof wrapper) {
          fn = Ctor || createCtor(fn);
        }
        return fn.apply(thisBinding, args);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */
    function createInverter(setter, toIteratee) {
      return function(object, iteratee) {
        return baseInverter(object, setter, toIteratee(iteratee), {});
      };
    }

    /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */
    function createMathOperation(operator, defaultValue) {
      return function(value, other) {
        var result;
        if (value === undefined && other === undefined) {
          return defaultValue;
        }
        if (value !== undefined) {
          result = value;
        }
        if (other !== undefined) {
          if (result === undefined) {
            return other;
          }
          if (typeof value == 'string' || typeof other == 'string') {
            value = baseToString(value);
            other = baseToString(other);
          } else {
            value = baseToNumber(value);
            other = baseToNumber(other);
          }
          result = operator(value, other);
        }
        return result;
      };
    }

    /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */
    function createOver(arrayFunc) {
      return flatRest(function(iteratees) {
        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
        return baseRest(function(args) {
          var thisArg = this;
          return arrayFunc(iteratees, function(iteratee) {
            return apply(iteratee, thisArg, args);
          });
        });
      });
    }

    /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */
    function createPadding(length, chars) {
      chars = chars === undefined ? ' ' : baseToString(chars);

      var charsLength = chars.length;
      if (charsLength < 2) {
        return charsLength ? baseRepeat(chars, length) : chars;
      }
      var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
      return hasUnicode(chars)
        ? castSlice(stringToArray(result), 0, length).join('')
        : result.slice(0, length);
    }

    /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */
    function createPartial(func, bitmask, thisArg, partials) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var argsIndex = -1,
            argsLength = arguments.length,
            leftIndex = -1,
            leftLength = partials.length,
            args = Array(leftLength + argsLength),
            fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;

        while (++leftIndex < leftLength) {
          args[leftIndex] = partials[leftIndex];
        }
        while (argsLength--) {
          args[leftIndex++] = arguments[++argsIndex];
        }
        return apply(fn, isBind ? thisArg : this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */
    function createRange(fromRight) {
      return function(start, end, step) {
        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
          end = step = undefined;
        }
        // Ensure the sign of `-0` is preserved.
        start = toFinite(start);
        if (end === undefined) {
          end = start;
          start = 0;
        } else {
          end = toFinite(end);
        }
        step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
        return baseRange(start, end, step, fromRight);
      };
    }

    /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */
    function createRelationalOperation(operator) {
      return function(value, other) {
        if (!(typeof value == 'string' && typeof other == 'string')) {
          value = toNumber(value);
          other = toNumber(other);
        }
        return operator(value, other);
      };
    }

    /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
      var isCurry = bitmask & WRAP_CURRY_FLAG,
          newHolders = isCurry ? holders : undefined,
          newHoldersRight = isCurry ? undefined : holders,
          newPartials = isCurry ? partials : undefined,
          newPartialsRight = isCurry ? undefined : partials;

      bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
      bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);

      if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
        bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
      }
      var newData = [
        func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
        newHoldersRight, argPos, ary, arity
      ];

      var result = wrapFunc.apply(undefined, newData);
      if (isLaziable(func)) {
        setData(result, newData);
      }
      result.placeholder = placeholder;
      return setWrapToString(result, func, bitmask);
    }

    /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */
    function createRound(methodName) {
      var func = Math[methodName];
      return function(number, precision) {
        number = toNumber(number);
        precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
        if (precision && nativeIsFinite(number)) {
          // Shift with exponential notation to avoid floating-point issues.
          // See [MDN](https://mdn.io/round#Examples) for more details.
          var pair = (toString(number) + 'e').split('e'),
              value = func(pair[0] + 'e' + (+pair[1] + precision));

          pair = (toString(value) + 'e').split('e');
          return +(pair[0] + 'e' + (+pair[1] - precision));
        }
        return func(number);
      };
    }

    /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */
    var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
      return new Set(values);
    };

    /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */
    function createToPairs(keysFunc) {
      return function(object) {
        var tag = getTag(object);
        if (tag == mapTag) {
          return mapToArray(object);
        }
        if (tag == setTag) {
          return setToPairs(object);
        }
        return baseToPairs(object, keysFunc(object));
      };
    }

    /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
      var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
      if (!isBindKey && typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var length = partials ? partials.length : 0;
      if (!length) {
        bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
        partials = holders = undefined;
      }
      ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
      arity = arity === undefined ? arity : toInteger(arity);
      length -= holders ? holders.length : 0;

      if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
        var partialsRight = partials,
            holdersRight = holders;

        partials = holders = undefined;
      }
      var data = isBindKey ? undefined : getData(func);

      var newData = [
        func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
        argPos, ary, arity
      ];

      if (data) {
        mergeData(newData, data);
      }
      func = newData[0];
      bitmask = newData[1];
      thisArg = newData[2];
      partials = newData[3];
      holders = newData[4];
      arity = newData[9] = newData[9] === undefined
        ? (isBindKey ? 0 : func.length)
        : nativeMax(newData[9] - length, 0);

      if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
        bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
      }
      if (!bitmask || bitmask == WRAP_BIND_FLAG) {
        var result = createBind(func, bitmask, thisArg);
      } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
        result = createCurry(func, bitmask, arity);
      } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
        result = createPartial(func, bitmask, thisArg, partials);
      } else {
        result = createHybrid.apply(undefined, newData);
      }
      var setter = data ? baseSetData : setData;
      return setWrapToString(setter(result, newData), func, bitmask);
    }

    /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsAssignIn(objValue, srcValue, key, object) {
      if (objValue === undefined ||
          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
        return srcValue;
      }
      return objValue;
    }

    /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
      if (isObject(objValue) && isObject(srcValue)) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, objValue);
        baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
        stack['delete'](srcValue);
      }
      return objValue;
    }

    /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */
    function customOmitClone(value) {
      return isPlainObject(value) ? undefined : value;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */
    function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          arrLength = array.length,
          othLength = other.length;

      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
        return false;
      }
      // Check that cyclic values are equal.
      var arrStacked = stack.get(array);
      var othStacked = stack.get(other);
      if (arrStacked && othStacked) {
        return arrStacked == other && othStacked == array;
      }
      var index = -1,
          result = true,
          seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

      stack.set(array, other);
      stack.set(other, array);

      // Ignore non-index properties.
      while (++index < arrLength) {
        var arrValue = array[index],
            othValue = other[index];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, arrValue, index, other, array, stack)
            : customizer(arrValue, othValue, index, array, other, stack);
        }
        if (compared !== undefined) {
          if (compared) {
            continue;
          }
          result = false;
          break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
          if (!arraySome(other, function(othValue, othIndex) {
                if (!cacheHas(seen, othIndex) &&
                    (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                  return seen.push(othIndex);
                }
              })) {
            result = false;
            break;
          }
        } else if (!(
              arrValue === othValue ||
                equalFunc(arrValue, othValue, bitmask, customizer, stack)
            )) {
          result = false;
          break;
        }
      }
      stack['delete'](array);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
      switch (tag) {
        case dataViewTag:
          if ((object.byteLength != other.byteLength) ||
              (object.byteOffset != other.byteOffset)) {
            return false;
          }
          object = object.buffer;
          other = other.buffer;

        case arrayBufferTag:
          if ((object.byteLength != other.byteLength) ||
              !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
            return false;
          }
          return true;

        case boolTag:
        case dateTag:
        case numberTag:
          // Coerce booleans to `1` or `0` and dates to milliseconds.
          // Invalid dates are coerced to `NaN`.
          return eq(+object, +other);

        case errorTag:
          return object.name == other.name && object.message == other.message;

        case regexpTag:
        case stringTag:
          // Coerce regexes to strings and treat strings, primitives and objects,
          // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
          // for more details.
          return object == (other + '');

        case mapTag:
          var convert = mapToArray;

        case setTag:
          var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
          convert || (convert = setToArray);

          if (object.size != other.size && !isPartial) {
            return false;
          }
          // Assume cyclic values are equal.
          var stacked = stack.get(object);
          if (stacked) {
            return stacked == other;
          }
          bitmask |= COMPARE_UNORDERED_FLAG;

          // Recursively compare objects (susceptible to call stack limits).
          stack.set(object, other);
          var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
          stack['delete'](object);
          return result;

        case symbolTag:
          if (symbolValueOf) {
            return symbolValueOf.call(object) == symbolValueOf.call(other);
          }
      }
      return false;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          objProps = getAllKeys(object),
          objLength = objProps.length,
          othProps = getAllKeys(other),
          othLength = othProps.length;

      if (objLength != othLength && !isPartial) {
        return false;
      }
      var index = objLength;
      while (index--) {
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
          return false;
        }
      }
      // Check that cyclic values are equal.
      var objStacked = stack.get(object);
      var othStacked = stack.get(other);
      if (objStacked && othStacked) {
        return objStacked == other && othStacked == object;
      }
      var result = true;
      stack.set(object, other);
      stack.set(other, object);

      var skipCtor = isPartial;
      while (++index < objLength) {
        key = objProps[index];
        var objValue = object[key],
            othValue = other[key];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, objValue, key, other, object, stack)
            : customizer(objValue, othValue, key, object, other, stack);
        }
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined
              ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
              : compared
            )) {
          result = false;
          break;
        }
        skipCtor || (skipCtor = key == 'constructor');
      }
      if (result && !skipCtor) {
        var objCtor = object.constructor,
            othCtor = other.constructor;

        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor &&
            ('constructor' in object && 'constructor' in other) &&
            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
          result = false;
        }
      }
      stack['delete'](object);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    function flatRest(func) {
      return setToString(overRest(func, undefined, flatten), func + '');
    }

    /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeys(object) {
      return baseGetAllKeys(object, keys, getSymbols);
    }

    /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeysIn(object) {
      return baseGetAllKeys(object, keysIn, getSymbolsIn);
    }

    /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */
    var getData = !metaMap ? noop : function(func) {
      return metaMap.get(func);
    };

    /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */
    function getFuncName(func) {
      var result = (func.name + ''),
          array = realNames[result],
          length = hasOwnProperty.call(realNames, result) ? array.length : 0;

      while (length--) {
        var data = array[length],
            otherFunc = data.func;
        if (otherFunc == null || otherFunc == func) {
          return data.name;
        }
      }
      return result;
    }

    /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */
    function getHolder(func) {
      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
      return object.placeholder;
    }

    /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */
    function getIteratee() {
      var result = lodash.iteratee || iteratee;
      result = result === iteratee ? baseIteratee : result;
      return arguments.length ? result(arguments[0], arguments[1]) : result;
    }

    /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */
    function getMapData(map, key) {
      var data = map.__data__;
      return isKeyable(key)
        ? data[typeof key == 'string' ? 'string' : 'hash']
        : data.map;
    }

    /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */
    function getMatchData(object) {
      var result = keys(object),
          length = result.length;

      while (length--) {
        var key = result[length],
            value = object[key];

        result[length] = [key, value, isStrictComparable(value)];
      }
      return result;
    }

    /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */
    function getNative(object, key) {
      var value = getValue(object, key);
      return baseIsNative(value) ? value : undefined;
    }

    /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */
    function getRawTag(value) {
      var isOwn = hasOwnProperty.call(value, symToStringTag),
          tag = value[symToStringTag];

      try {
        value[symToStringTag] = undefined;
        var unmasked = true;
      } catch (e) {}

      var result = nativeObjectToString.call(value);
      if (unmasked) {
        if (isOwn) {
          value[symToStringTag] = tag;
        } else {
          delete value[symToStringTag];
        }
      }
      return result;
    }

    /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
      if (object == null) {
        return [];
      }
      object = Object(object);
      return arrayFilter(nativeGetSymbols(object), function(symbol) {
        return propertyIsEnumerable.call(object, symbol);
      });
    };

    /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
      var result = [];
      while (object) {
        arrayPush(result, getSymbols(object));
        object = getPrototype(object);
      }
      return result;
    };

    /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    var getTag = baseGetTag;

    // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
    if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
        (Map && getTag(new Map) != mapTag) ||
        (Promise && getTag(Promise.resolve()) != promiseTag) ||
        (Set && getTag(new Set) != setTag) ||
        (WeakMap && getTag(new WeakMap) != weakMapTag)) {
      getTag = function(value) {
        var result = baseGetTag(value),
            Ctor = result == objectTag ? value.constructor : undefined,
            ctorString = Ctor ? toSource(Ctor) : '';

        if (ctorString) {
          switch (ctorString) {
            case dataViewCtorString: return dataViewTag;
            case mapCtorString: return mapTag;
            case promiseCtorString: return promiseTag;
            case setCtorString: return setTag;
            case weakMapCtorString: return weakMapTag;
          }
        }
        return result;
      };
    }

    /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */
    function getView(start, end, transforms) {
      var index = -1,
          length = transforms.length;

      while (++index < length) {
        var data = transforms[index],
            size = data.size;

        switch (data.type) {
          case 'drop':      start += size; break;
          case 'dropRight': end -= size; break;
          case 'take':      end = nativeMin(end, start + size); break;
          case 'takeRight': start = nativeMax(start, end - size); break;
        }
      }
      return { 'start': start, 'end': end };
    }

    /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */
    function getWrapDetails(source) {
      var match = source.match(reWrapDetails);
      return match ? match[1].split(reSplitDetails) : [];
    }

    /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */
    function hasPath(object, path, hasFunc) {
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          result = false;

      while (++index < length) {
        var key = toKey(path[index]);
        if (!(result = object != null && hasFunc(object, key))) {
          break;
        }
        object = object[key];
      }
      if (result || ++index != length) {
        return result;
      }
      length = object == null ? 0 : object.length;
      return !!length && isLength(length) && isIndex(key, length) &&
        (isArray(object) || isArguments(object));
    }

    /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */
    function initCloneArray(array) {
      var length = array.length,
          result = new array.constructor(length);

      // Add properties assigned by `RegExp#exec`.
      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
      }
      return result;
    }

    /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneObject(object) {
      return (typeof object.constructor == 'function' && !isPrototype(object))
        ? baseCreate(getPrototype(object))
        : {};
    }

    /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneByTag(object, tag, isDeep) {
      var Ctor = object.constructor;
      switch (tag) {
        case arrayBufferTag:
          return cloneArrayBuffer(object);

        case boolTag:
        case dateTag:
          return new Ctor(+object);

        case dataViewTag:
          return cloneDataView(object, isDeep);

        case float32Tag: case float64Tag:
        case int8Tag: case int16Tag: case int32Tag:
        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
          return cloneTypedArray(object, isDeep);

        case mapTag:
          return new Ctor;

        case numberTag:
        case stringTag:
          return new Ctor(object);

        case regexpTag:
          return cloneRegExp(object);

        case setTag:
          return new Ctor;

        case symbolTag:
          return cloneSymbol(object);
      }
    }

    /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */
    function insertWrapDetails(source, details) {
      var length = details.length;
      if (!length) {
        return source;
      }
      var lastIndex = length - 1;
      details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
      details = details.join(length > 2 ? ', ' : ' ');
      return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
    }

    /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */
    function isFlattenable(value) {
      return isArray(value) || isArguments(value) ||
        !!(spreadableSymbol && value && value[spreadableSymbol]);
    }

    /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */
    function isIndex(value, length) {
      var type = typeof value;
      length = length == null ? MAX_SAFE_INTEGER : length;

      return !!length &&
        (type == 'number' ||
          (type != 'symbol' && reIsUint.test(value))) &&
            (value > -1 && value % 1 == 0 && value < length);
    }

    /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */
    function isIterateeCall(value, index, object) {
      if (!isObject(object)) {
        return false;
      }
      var type = typeof index;
      if (type == 'number'
            ? (isArrayLike(object) && isIndex(index, object.length))
            : (type == 'string' && index in object)
          ) {
        return eq(object[index], value);
      }
      return false;
    }

    /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */
    function isKey(value, object) {
      if (isArray(value)) {
        return false;
      }
      var type = typeof value;
      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
          value == null || isSymbol(value)) {
        return true;
      }
      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
        (object != null && value in Object(object));
    }

    /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */
    function isKeyable(value) {
      var type = typeof value;
      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
        ? (value !== '__proto__')
        : (value === null);
    }

    /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */
    function isLaziable(func) {
      var funcName = getFuncName(func),
          other = lodash[funcName];

      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
        return false;
      }
      if (func === other) {
        return true;
      }
      var data = getData(other);
      return !!data && func === data[0];
    }

    /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */
    function isMasked(func) {
      return !!maskSrcKey && (maskSrcKey in func);
    }

    /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */
    var isMaskable = coreJsData ? isFunction : stubFalse;

    /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */
    function isPrototype(value) {
      var Ctor = value && value.constructor,
          proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

      return value === proto;
    }

    /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */
    function isStrictComparable(value) {
      return value === value && !isObject(value);
    }

    /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function matchesStrictComparable(key, srcValue) {
      return function(object) {
        if (object == null) {
          return false;
        }
        return object[key] === srcValue &&
          (srcValue !== undefined || (key in Object(object)));
      };
    }

    /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */
    function memoizeCapped(func) {
      var result = memoize(func, function(key) {
        if (cache.size === MAX_MEMOIZE_SIZE) {
          cache.clear();
        }
        return key;
      });

      var cache = result.cache;
      return result;
    }

    /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */
    function mergeData(data, source) {
      var bitmask = data[1],
          srcBitmask = source[1],
          newBitmask = bitmask | srcBitmask,
          isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);

      var isCombo =
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
        ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));

      // Exit early if metadata can't be merged.
      if (!(isCommon || isCombo)) {
        return data;
      }
      // Use source `thisArg` if available.
      if (srcBitmask & WRAP_BIND_FLAG) {
        data[2] = source[2];
        // Set when currying a bound function.
        newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
      }
      // Compose partial arguments.
      var value = source[3];
      if (value) {
        var partials = data[3];
        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
      }
      // Compose partial right arguments.
      value = source[5];
      if (value) {
        partials = data[5];
        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
      }
      // Use source `argPos` if available.
      value = source[7];
      if (value) {
        data[7] = value;
      }
      // Use source `ary` if it's smaller.
      if (srcBitmask & WRAP_ARY_FLAG) {
        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
      }
      // Use source `arity` if one is not provided.
      if (data[9] == null) {
        data[9] = source[9];
      }
      // Use source `func` and merge bitmasks.
      data[0] = source[0];
      data[1] = newBitmask;

      return data;
    }

    /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function nativeKeysIn(object) {
      var result = [];
      if (object != null) {
        for (var key in Object(object)) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */
    function objectToString(value) {
      return nativeObjectToString.call(value);
    }

    /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */
    function overRest(func, start, transform) {
      start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
      return function() {
        var args = arguments,
            index = -1,
            length = nativeMax(args.length - start, 0),
            array = Array(length);

        while (++index < length) {
          array[index] = args[start + index];
        }
        index = -1;
        var otherArgs = Array(start + 1);
        while (++index < start) {
          otherArgs[index] = args[index];
        }
        otherArgs[start] = transform(array);
        return apply(func, this, otherArgs);
      };
    }

    /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */
    function parent(object, path) {
      return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
    }

    /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */
    function reorder(array, indexes) {
      var arrLength = array.length,
          length = nativeMin(indexes.length, arrLength),
          oldArray = copyArray(array);

      while (length--) {
        var index = indexes[length];
        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
      }
      return array;
    }

    /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */
    function safeGet(object, key) {
      if (key === 'constructor' && typeof object[key] === 'function') {
        return;
      }

      if (key == '__proto__') {
        return;
      }

      return object[key];
    }

    /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var setData = shortOut(baseSetData);

    /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    var setTimeout = ctxSetTimeout || function(func, wait) {
      return root.setTimeout(func, wait);
    };

    /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var setToString = shortOut(baseSetToString);

    /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */
    function setWrapToString(wrapper, reference, bitmask) {
      var source = (reference + '');
      return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
    }

    /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */
    function shortOut(func) {
      var count = 0,
          lastCalled = 0;

      return function() {
        var stamp = nativeNow(),
            remaining = HOT_SPAN - (stamp - lastCalled);

        lastCalled = stamp;
        if (remaining > 0) {
          if (++count >= HOT_COUNT) {
            return arguments[0];
          }
        } else {
          count = 0;
        }
        return func.apply(undefined, arguments);
      };
    }

    /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */
    function shuffleSelf(array, size) {
      var index = -1,
          length = array.length,
          lastIndex = length - 1;

      size = size === undefined ? length : size;
      while (++index < size) {
        var rand = baseRandom(index, lastIndex),
            value = array[rand];

        array[rand] = array[index];
        array[index] = value;
      }
      array.length = size;
      return array;
    }

    /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */
    var stringToPath = memoizeCapped(function(string) {
      var result = [];
      if (string.charCodeAt(0) === 46 /* . */) {
        result.push('');
      }
      string.replace(rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
      });
      return result;
    });

    /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */
    function toKey(value) {
      if (typeof value == 'string' || isSymbol(value)) {
        return value;
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */
    function toSource(func) {
      if (func != null) {
        try {
          return funcToString.call(func);
        } catch (e) {}
        try {
          return (func + '');
        } catch (e) {}
      }
      return '';
    }

    /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */
    function updateWrapDetails(details, bitmask) {
      arrayEach(wrapFlags, function(pair) {
        var value = '_.' + pair[0];
        if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
          details.push(value);
        }
      });
      return details.sort();
    }

    /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */
    function wrapperClone(wrapper) {
      if (wrapper instanceof LazyWrapper) {
        return wrapper.clone();
      }
      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
      result.__actions__ = copyArray(wrapper.__actions__);
      result.__index__  = wrapper.__index__;
      result.__values__ = wrapper.__values__;
      return result;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */
    function chunk(array, size, guard) {
      if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
        size = 1;
      } else {
        size = nativeMax(toInteger(size), 0);
      }
      var length = array == null ? 0 : array.length;
      if (!length || size < 1) {
        return [];
      }
      var index = 0,
          resIndex = 0,
          result = Array(nativeCeil(length / size));

      while (index < length) {
        result[resIndex++] = baseSlice(array, index, (index += size));
      }
      return result;
    }

    /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */
    function compact(array) {
      var index = -1,
          length = array == null ? 0 : array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index];
        if (value) {
          result[resIndex++] = value;
        }
      }
      return result;
    }

    /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */
    function concat() {
      var length = arguments.length;
      if (!length) {
        return [];
      }
      var args = Array(length - 1),
          array = arguments[0],
          index = length;

      while (index--) {
        args[index - 1] = arguments[index];
      }
      return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
    }

    /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */
    var difference = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var differenceBy = baseRest(function(array, values) {
      var iteratee = last(values);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */
    var differenceWith = baseRest(function(array, values) {
      var comparator = last(values);
      if (isArrayLikeObject(comparator)) {
        comparator = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator)
        : [];
    });

    /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function drop(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function dropRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true, true)
        : [];
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true)
        : [];
    }

    /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */
    function fill(array, value, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
        start = 0;
        end = length;
      }
      return baseFill(array, value, start, end);
    }

    /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */
    function findIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index);
    }

    /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */
    function findLastIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length - 1;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = fromIndex < 0
          ? nativeMax(length + index, 0)
          : nativeMin(index, length - 1);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index, true);
    }

    /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */
    function flatten(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, 1) : [];
    }

    /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */
    function flattenDeep(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, INFINITY) : [];
    }

    /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */
    function flattenDepth(array, depth) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(array, depth);
    }

    /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */
    function fromPairs(pairs) {
      var index = -1,
          length = pairs == null ? 0 : pairs.length,
          result = {};

      while (++index < length) {
        var pair = pairs[index];
        result[pair[0]] = pair[1];
      }
      return result;
    }

    /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */
    function head(array) {
      return (array && array.length) ? array[0] : undefined;
    }

    /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */
    function indexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseIndexOf(array, value, index);
    }

    /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */
    function initial(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 0, -1) : [];
    }

    /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */
    var intersection = baseRest(function(arrays) {
      var mapped = arrayMap(arrays, castArrayLikeObject);
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped)
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */
    var intersectionBy = baseRest(function(arrays) {
      var iteratee = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      if (iteratee === last(mapped)) {
        iteratee = undefined;
      } else {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */
    var intersectionWith = baseRest(function(arrays) {
      var comparator = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      comparator = typeof comparator == 'function' ? comparator : undefined;
      if (comparator) {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, undefined, comparator)
        : [];
    });

    /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */
    function join(array, separator) {
      return array == null ? '' : nativeJoin.call(array, separator);
    }

    /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */
    function last(array) {
      var length = array == null ? 0 : array.length;
      return length ? array[length - 1] : undefined;
    }

    /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */
    function lastIndexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
      }
      return value === value
        ? strictLastIndexOf(array, value, index)
        : baseFindIndex(array, baseIsNaN, index, true);
    }

    /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */
    function nth(array, n) {
      return (array && array.length) ? baseNth(array, toInteger(n)) : undefined;
    }

    /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */
    var pull = baseRest(pullAll);

    /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */
    function pullAll(array, values) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values)
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */
    function pullAllBy(array, values, iteratee) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, getIteratee(iteratee, 2))
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */
    function pullAllWith(array, values, comparator) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, undefined, comparator)
        : array;
    }

    /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */
    var pullAt = flatRest(function(array, indexes) {
      var length = array == null ? 0 : array.length,
          result = baseAt(array, indexes);

      basePullAt(array, arrayMap(indexes, function(index) {
        return isIndex(index, length) ? +index : index;
      }).sort(compareAscending));

      return result;
    });

    /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */
    function remove(array, predicate) {
      var result = [];
      if (!(array && array.length)) {
        return result;
      }
      var index = -1,
          indexes = [],
          length = array.length;

      predicate = getIteratee(predicate, 3);
      while (++index < length) {
        var value = array[index];
        if (predicate(value, index, array)) {
          result.push(value);
          indexes.push(index);
        }
      }
      basePullAt(array, indexes);
      return result;
    }

    /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function reverse(array) {
      return array == null ? array : nativeReverse.call(array);
    }

    /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function slice(array, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
        start = 0;
        end = length;
      }
      else {
        start = start == null ? 0 : toInteger(start);
        end = end === undefined ? length : toInteger(end);
      }
      return baseSlice(array, start, end);
    }

    /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */
    function sortedIndex(array, value) {
      return baseSortedIndex(array, value);
    }

    /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */
    function sortedIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
    }

    /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */
    function sortedIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value);
        if (index < length && eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */
    function sortedLastIndex(array, value) {
      return baseSortedIndex(array, value, true);
    }

    /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */
    function sortedLastIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
    }

    /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */
    function sortedLastIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value, true) - 1;
        if (eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */
    function sortedUniq(array) {
      return (array && array.length)
        ? baseSortedUniq(array)
        : [];
    }

    /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */
    function sortedUniqBy(array, iteratee) {
      return (array && array.length)
        ? baseSortedUniq(array, getIteratee(iteratee, 2))
        : [];
    }

    /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */
    function tail(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 1, length) : [];
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */
    function take(array, n, guard) {
      if (!(array && array.length)) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */
    function takeRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */
    function takeRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), false, true)
        : [];
    }

    /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */
    function takeWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3))
        : [];
    }

    /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */
    var union = baseRest(function(arrays) {
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
    });

    /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    var unionBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var unionWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
    });

    /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */
    function uniq(array) {
      return (array && array.length) ? baseUniq(array) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    function uniqBy(array, iteratee) {
      return (array && array.length) ? baseUniq(array, getIteratee(iteratee, 2)) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */
    function uniqWith(array, comparator) {
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return (array && array.length) ? baseUniq(array, undefined, comparator) : [];
    }

    /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */
    function unzip(array) {
      if (!(array && array.length)) {
        return [];
      }
      var length = 0;
      array = arrayFilter(array, function(group) {
        if (isArrayLikeObject(group)) {
          length = nativeMax(group.length, length);
          return true;
        }
      });
      return baseTimes(length, function(index) {
        return arrayMap(array, baseProperty(index));
      });
    }

    /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */
    function unzipWith(array, iteratee) {
      if (!(array && array.length)) {
        return [];
      }
      var result = unzip(array);
      if (iteratee == null) {
        return result;
      }
      return arrayMap(result, function(group) {
        return apply(iteratee, undefined, group);
      });
    }

    /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */
    var without = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, values)
        : [];
    });

    /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */
    var xor = baseRest(function(arrays) {
      return baseXor(arrayFilter(arrays, isArrayLikeObject));
    });

    /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var xorBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var xorWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
    });

    /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */
    var zip = baseRest(unzip);

    /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */
    function zipObject(props, values) {
      return baseZipObject(props || [], values || [], assignValue);
    }

    /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */
    function zipObjectDeep(props, values) {
      return baseZipObject(props || [], values || [], baseSet);
    }

    /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */
    var zipWith = baseRest(function(arrays) {
      var length = arrays.length,
          iteratee = length > 1 ? arrays[length - 1] : undefined;

      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
      return unzipWith(arrays, iteratee);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */
    function chain(value) {
      var result = lodash(value);
      result.__chain__ = true;
      return result;
    }

    /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */
    function tap(value, interceptor) {
      interceptor(value);
      return value;
    }

    /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */
    function thru(value, interceptor) {
      return interceptor(value);
    }

    /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */
    var wrapperAt = flatRest(function(paths) {
      var length = paths.length,
          start = length ? paths[0] : 0,
          value = this.__wrapped__,
          interceptor = function(object) { return baseAt(object, paths); };

      if (length > 1 || this.__actions__.length ||
          !(value instanceof LazyWrapper) || !isIndex(start)) {
        return this.thru(interceptor);
      }
      value = value.slice(start, +start + (length ? 1 : 0));
      value.__actions__.push({
        'func': thru,
        'args': [interceptor],
        'thisArg': undefined
      });
      return new LodashWrapper(value, this.__chain__).thru(function(array) {
        if (length && !array.length) {
          array.push(undefined);
        }
        return array;
      });
    });

    /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */
    function wrapperChain() {
      return chain(this);
    }

    /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */
    function wrapperCommit() {
      return new LodashWrapper(this.value(), this.__chain__);
    }

    /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */
    function wrapperNext() {
      if (this.__values__ === undefined) {
        this.__values__ = toArray(this.value());
      }
      var done = this.__index__ >= this.__values__.length,
          value = done ? undefined : this.__values__[this.__index__++];

      return { 'done': done, 'value': value };
    }

    /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */
    function wrapperToIterator() {
      return this;
    }

    /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */
    function wrapperPlant(value) {
      var result,
          parent = this;

      while (parent instanceof baseLodash) {
        var clone = wrapperClone(parent);
        clone.__index__ = 0;
        clone.__values__ = undefined;
        if (result) {
          previous.__wrapped__ = clone;
        } else {
          result = clone;
        }
        var previous = clone;
        parent = parent.__wrapped__;
      }
      previous.__wrapped__ = value;
      return result;
    }

    /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function wrapperReverse() {
      var value = this.__wrapped__;
      if (value instanceof LazyWrapper) {
        var wrapped = value;
        if (this.__actions__.length) {
          wrapped = new LazyWrapper(this);
        }
        wrapped = wrapped.reverse();
        wrapped.__actions__.push({
          'func': thru,
          'args': [reverse],
          'thisArg': undefined
        });
        return new LodashWrapper(wrapped, this.__chain__);
      }
      return this.thru(reverse);
    }

    /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */
    function wrapperValue() {
      return baseWrapperValue(this.__wrapped__, this.__actions__);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */
    var countBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        ++result[key];
      } else {
        baseAssignValue(result, key, 1);
      }
    });

    /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */
    function every(collection, predicate, guard) {
      var func = isArray(collection) ? arrayEvery : baseEvery;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     *
     * // Combining several predicates using `_.overEvery` or `_.overSome`.
     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
     * // => objects for ['fred', 'barney']
     */
    function filter(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */
    var find = createFind(findIndex);

    /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */
    var findLast = createFind(findLastIndex);

    /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMap(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), 1);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMapDeep(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), INFINITY);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */
    function flatMapDepth(collection, iteratee, depth) {
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(map(collection, iteratee), depth);
    }

    /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forEach(collection, iteratee) {
      var func = isArray(collection) ? arrayEach : baseEach;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */
    function forEachRight(collection, iteratee) {
      var func = isArray(collection) ? arrayEachRight : baseEachRight;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */
    var groupBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        result[key].push(value);
      } else {
        baseAssignValue(result, key, [value]);
      }
    });

    /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */
    function includes(collection, value, fromIndex, guard) {
      collection = isArrayLike(collection) ? collection : values(collection);
      fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;

      var length = collection.length;
      if (fromIndex < 0) {
        fromIndex = nativeMax(length + fromIndex, 0);
      }
      return isString(collection)
        ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
        : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
    }

    /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */
    var invokeMap = baseRest(function(collection, path, args) {
      var index = -1,
          isFunc = typeof path == 'function',
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value) {
        result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
      });
      return result;
    });

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */
    var keyBy = createAggregator(function(result, value, key) {
      baseAssignValue(result, key, value);
    });

    /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */
    function map(collection, iteratee) {
      var func = isArray(collection) ? arrayMap : baseMap;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */
    function orderBy(collection, iteratees, orders, guard) {
      if (collection == null) {
        return [];
      }
      if (!isArray(iteratees)) {
        iteratees = iteratees == null ? [] : [iteratees];
      }
      orders = guard ? undefined : orders;
      if (!isArray(orders)) {
        orders = orders == null ? [] : [orders];
      }
      return baseOrderBy(collection, iteratees, orders);
    }

    /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */
    var partition = createAggregator(function(result, value, key) {
      result[key ? 0 : 1].push(value);
    }, function() { return [[], []]; });

    /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */
    function reduce(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduce : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
    }

    /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */
    function reduceRight(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduceRight : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
    }

    /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */
    function reject(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, negate(getIteratee(predicate, 3)));
    }

    /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */
    function sample(collection) {
      var func = isArray(collection) ? arraySample : baseSample;
      return func(collection);
    }

    /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */
    function sampleSize(collection, n, guard) {
      if ((guard ? isIterateeCall(collection, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      var func = isArray(collection) ? arraySampleSize : baseSampleSize;
      return func(collection, n);
    }

    /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */
    function shuffle(collection) {
      var func = isArray(collection) ? arrayShuffle : baseShuffle;
      return func(collection);
    }

    /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */
    function size(collection) {
      if (collection == null) {
        return 0;
      }
      if (isArrayLike(collection)) {
        return isString(collection) ? stringSize(collection) : collection.length;
      }
      var tag = getTag(collection);
      if (tag == mapTag || tag == setTag) {
        return collection.size;
      }
      return baseKeys(collection).length;
    }

    /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */
    function some(collection, predicate, guard) {
      var func = isArray(collection) ? arraySome : baseSome;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 30 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
     */
    var sortBy = baseRest(function(collection, iteratees) {
      if (collection == null) {
        return [];
      }
      var length = iteratees.length;
      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
        iteratees = [];
      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
        iteratees = [iteratees[0]];
      }
      return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */
    var now = ctxNow || function() {
      return root.Date.now();
    };

    /*------------------------------------------------------------------------*/

    /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */
    function after(n, func) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n < 1) {
          return func.apply(this, arguments);
        }
      };
    }

    /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */
    function ary(func, n, guard) {
      n = guard ? undefined : n;
      n = (func && n == null) ? func.length : n;
      return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
    }

    /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */
    function before(n, func) {
      var result;
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n > 0) {
          result = func.apply(this, arguments);
        }
        if (n <= 1) {
          func = undefined;
        }
        return result;
      };
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */
    var bind = baseRest(function(func, thisArg, partials) {
      var bitmask = WRAP_BIND_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bind));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(func, bitmask, thisArg, partials, holders);
    });

    /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */
    var bindKey = baseRest(function(object, key, partials) {
      var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bindKey));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(key, bitmask, object, partials, holders);
    });

    /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */
    function curry(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curry.placeholder;
      return result;
    }

    /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */
    function curryRight(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curryRight.placeholder;
      return result;
    }

    /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */
    function debounce(func, wait, options) {
      var lastArgs,
          lastThis,
          maxWait,
          result,
          timerId,
          lastCallTime,
          lastInvokeTime = 0,
          leading = false,
          maxing = false,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      wait = toNumber(wait) || 0;
      if (isObject(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }

      function invokeFunc(time) {
        var args = lastArgs,
            thisArg = lastThis;

        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
      }

      function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
      }

      function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime,
            timeWaiting = wait - timeSinceLastCall;

        return maxing
          ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
          : timeWaiting;
      }

      function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime;

        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
          (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
      }

      function timerExpired() {
        var time = now();
        if (shouldInvoke(time)) {
          return trailingEdge(time);
        }
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
      }

      function trailingEdge(time) {
        timerId = undefined;

        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) {
          return invokeFunc(time);
        }
        lastArgs = lastThis = undefined;
        return result;
      }

      function cancel() {
        if (timerId !== undefined) {
          clearTimeout(timerId);
        }
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
      }

      function flush() {
        return timerId === undefined ? result : trailingEdge(now());
      }

      function debounced() {
        var time = now(),
            isInvoking = shouldInvoke(time);

        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;

        if (isInvoking) {
          if (timerId === undefined) {
            return leadingEdge(lastCallTime);
          }
          if (maxing) {
            // Handle invocations in a tight loop.
            clearTimeout(timerId);
            timerId = setTimeout(timerExpired, wait);
            return invokeFunc(lastCallTime);
          }
        }
        if (timerId === undefined) {
          timerId = setTimeout(timerExpired, wait);
        }
        return result;
      }
      debounced.cancel = cancel;
      debounced.flush = flush;
      return debounced;
    }

    /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */
    var defer = baseRest(function(func, args) {
      return baseDelay(func, 1, args);
    });

    /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */
    var delay = baseRest(function(func, wait, args) {
      return baseDelay(func, toNumber(wait) || 0, args);
    });

    /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */
    function flip(func) {
      return createWrap(func, WRAP_FLIP_FLAG);
    }

    /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */
    function memoize(func, resolver) {
      if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var memoized = function() {
        var args = arguments,
            key = resolver ? resolver.apply(this, args) : args[0],
            cache = memoized.cache;

        if (cache.has(key)) {
          return cache.get(key);
        }
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
      };
      memoized.cache = new (memoize.Cache || MapCache);
      return memoized;
    }

    // Expose `MapCache`.
    memoize.Cache = MapCache;

    /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */
    function negate(predicate) {
      if (typeof predicate != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return function() {
        var args = arguments;
        switch (args.length) {
          case 0: return !predicate.call(this);
          case 1: return !predicate.call(this, args[0]);
          case 2: return !predicate.call(this, args[0], args[1]);
          case 3: return !predicate.call(this, args[0], args[1], args[2]);
        }
        return !predicate.apply(this, args);
      };
    }

    /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */
    function once(func) {
      return before(2, func);
    }

    /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */
    var overArgs = castRest(function(func, transforms) {
      transforms = (transforms.length == 1 && isArray(transforms[0]))
        ? arrayMap(transforms[0], baseUnary(getIteratee()))
        : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));

      var funcsLength = transforms.length;
      return baseRest(function(args) {
        var index = -1,
            length = nativeMin(args.length, funcsLength);

        while (++index < length) {
          args[index] = transforms[index].call(this, args[index]);
        }
        return apply(func, this, args);
      });
    });

    /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */
    var partial = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partial));
      return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
    });

    /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */
    var partialRight = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partialRight));
      return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
    });

    /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */
    var rearg = flatRest(function(func, indexes) {
      return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
    });

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */
    function rest(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start === undefined ? start : toInteger(start);
      return baseRest(func, start);
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */
    function spread(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start == null ? 0 : nativeMax(toInteger(start), 0);
      return baseRest(function(args) {
        var array = args[start],
            otherArgs = castSlice(args, 0, start);

        if (array) {
          arrayPush(otherArgs, array);
        }
        return apply(func, this, otherArgs);
      });
    }

    /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */
    function throttle(func, wait, options) {
      var leading = true,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      if (isObject(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }
      return debounce(func, wait, {
        'leading': leading,
        'maxWait': wait,
        'trailing': trailing
      });
    }

    /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */
    function unary(func) {
      return ary(func, 1);
    }

    /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */
    function wrap(value, wrapper) {
      return partial(castFunction(wrapper), value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */
    function castArray() {
      if (!arguments.length) {
        return [];
      }
      var value = arguments[0];
      return isArray(value) ? value : [value];
    }

    /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */
    function clone(value) {
      return baseClone(value, CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */
    function cloneWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */
    function cloneDeep(value) {
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */
    function cloneDeepWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */
    function conformsTo(object, source) {
      return source == null || baseConformsTo(object, source, keys(source));
    }

    /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */
    function eq(value, other) {
      return value === other || (value !== value && other !== other);
    }

    /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */
    var gt = createRelationalOperation(baseGt);

    /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */
    var gte = createRelationalOperation(function(value, other) {
      return value >= other;
    });

    /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */
    var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
      return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
        !propertyIsEnumerable.call(value, 'callee');
    };

    /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */
    var isArray = Array.isArray;

    /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */
    var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;

    /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */
    function isArrayLike(value) {
      return value != null && isLength(value.length) && !isFunction(value);
    }

    /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */
    function isArrayLikeObject(value) {
      return isObjectLike(value) && isArrayLike(value);
    }

    /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */
    function isBoolean(value) {
      return value === true || value === false ||
        (isObjectLike(value) && baseGetTag(value) == boolTag);
    }

    /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */
    var isBuffer = nativeIsBuffer || stubFalse;

    /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */
    var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;

    /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */
    function isElement(value) {
      return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
    }

    /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */
    function isEmpty(value) {
      if (value == null) {
        return true;
      }
      if (isArrayLike(value) &&
          (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
            isBuffer(value) || isTypedArray(value) || isArguments(value))) {
        return !value.length;
      }
      var tag = getTag(value);
      if (tag == mapTag || tag == setTag) {
        return !value.size;
      }
      if (isPrototype(value)) {
        return !baseKeys(value).length;
      }
      for (var key in value) {
        if (hasOwnProperty.call(value, key)) {
          return false;
        }
      }
      return true;
    }

    /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */
    function isEqual(value, other) {
      return baseIsEqual(value, other);
    }

    /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */
    function isEqualWith(value, other, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      var result = customizer ? customizer(value, other) : undefined;
      return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
    }

    /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */
    function isError(value) {
      if (!isObjectLike(value)) {
        return false;
      }
      var tag = baseGetTag(value);
      return tag == errorTag || tag == domExcTag ||
        (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
    }

    /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */
    function isFinite(value) {
      return typeof value == 'number' && nativeIsFinite(value);
    }

    /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */
    function isFunction(value) {
      if (!isObject(value)) {
        return false;
      }
      // The use of `Object#toString` avoids issues with the `typeof` operator
      // in Safari 9 which returns 'object' for typed arrays and other constructors.
      var tag = baseGetTag(value);
      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
    }

    /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */
    function isInteger(value) {
      return typeof value == 'number' && value == toInteger(value);
    }

    /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */
    function isLength(value) {
      return typeof value == 'number' &&
        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */
    function isObject(value) {
      var type = typeof value;
      return value != null && (type == 'object' || type == 'function');
    }

    /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */
    function isObjectLike(value) {
      return value != null && typeof value == 'object';
    }

    /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */
    var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

    /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */
    function isMatch(object, source) {
      return object === source || baseIsMatch(object, source, getMatchData(source));
    }

    /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */
    function isMatchWith(object, source, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseIsMatch(object, source, getMatchData(source), customizer);
    }

    /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */
    function isNaN(value) {
      // An `NaN` primitive is the only value that is not equal to itself.
      // Perform the `toStringTag` check first to avoid errors with some
      // ActiveX objects in IE.
      return isNumber(value) && value != +value;
    }

    /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */
    function isNative(value) {
      if (isMaskable(value)) {
        throw new Error(CORE_ERROR_TEXT);
      }
      return baseIsNative(value);
    }

    /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */
    function isNull(value) {
      return value === null;
    }

    /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */
    function isNil(value) {
      return value == null;
    }

    /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */
    function isNumber(value) {
      return typeof value == 'number' ||
        (isObjectLike(value) && baseGetTag(value) == numberTag);
    }

    /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */
    function isPlainObject(value) {
      if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
        return false;
      }
      var proto = getPrototype(value);
      if (proto === null) {
        return true;
      }
      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
      return typeof Ctor == 'function' && Ctor instanceof Ctor &&
        funcToString.call(Ctor) == objectCtorString;
    }

    /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */
    var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;

    /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */
    function isSafeInteger(value) {
      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */
    var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

    /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */
    function isString(value) {
      return typeof value == 'string' ||
        (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
    }

    /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */
    function isSymbol(value) {
      return typeof value == 'symbol' ||
        (isObjectLike(value) && baseGetTag(value) == symbolTag);
    }

    /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */
    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

    /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */
    function isUndefined(value) {
      return value === undefined;
    }

    /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */
    function isWeakMap(value) {
      return isObjectLike(value) && getTag(value) == weakMapTag;
    }

    /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */
    function isWeakSet(value) {
      return isObjectLike(value) && baseGetTag(value) == weakSetTag;
    }

    /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */
    var lt = createRelationalOperation(baseLt);

    /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */
    var lte = createRelationalOperation(function(value, other) {
      return value <= other;
    });

    /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */
    function toArray(value) {
      if (!value) {
        return [];
      }
      if (isArrayLike(value)) {
        return isString(value) ? stringToArray(value) : copyArray(value);
      }
      if (symIterator && value[symIterator]) {
        return iteratorToArray(value[symIterator]());
      }
      var tag = getTag(value),
          func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);

      return func(value);
    }

    /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */
    function toFinite(value) {
      if (!value) {
        return value === 0 ? value : 0;
      }
      value = toNumber(value);
      if (value === INFINITY || value === -INFINITY) {
        var sign = (value < 0 ? -1 : 1);
        return sign * MAX_INTEGER;
      }
      return value === value ? value : 0;
    }

    /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */
    function toInteger(value) {
      var result = toFinite(value),
          remainder = result % 1;

      return result === result ? (remainder ? result - remainder : result) : 0;
    }

    /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */
    function toLength(value) {
      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
    }

    /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */
    function toNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      if (isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = isObject(other) ? (other + '') : other;
      }
      if (typeof value != 'string') {
        return value === 0 ? value : +value;
      }
      value = baseTrim(value);
      var isBinary = reIsBinary.test(value);
      return (isBinary || reIsOctal.test(value))
        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
        : (reIsBadHex.test(value) ? NAN : +value);
    }

    /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */
    function toPlainObject(value) {
      return copyObject(value, keysIn(value));
    }

    /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */
    function toSafeInteger(value) {
      return value
        ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER)
        : (value === 0 ? value : 0);
    }

    /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */
    function toString(value) {
      return value == null ? '' : baseToString(value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */
    var assign = createAssigner(function(object, source) {
      if (isPrototype(source) || isArrayLike(source)) {
        copyObject(source, keys(source), object);
        return;
      }
      for (var key in source) {
        if (hasOwnProperty.call(source, key)) {
          assignValue(object, key, source[key]);
        }
      }
    });

    /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */
    var assignIn = createAssigner(function(object, source) {
      copyObject(source, keysIn(source), object);
    });

    /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keysIn(source), object, customizer);
    });

    /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keys(source), object, customizer);
    });

    /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */
    var at = flatRest(baseAt);

    /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */
    function create(prototype, properties) {
      var result = baseCreate(prototype);
      return properties == null ? result : baseAssign(result, properties);
    }

    /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var defaults = baseRest(function(object, sources) {
      object = Object(object);

      var index = -1;
      var length = sources.length;
      var guard = length > 2 ? sources[2] : undefined;

      if (guard && isIterateeCall(sources[0], sources[1], guard)) {
        length = 1;
      }

      while (++index < length) {
        var source = sources[index];
        var props = keysIn(source);
        var propsIndex = -1;
        var propsLength = props.length;

        while (++propsIndex < propsLength) {
          var key = props[propsIndex];
          var value = object[key];

          if (value === undefined ||
              (eq(value, objectProto[key]) && !hasOwnProperty.call(object, key))) {
            object[key] = source[key];
          }
        }
      }

      return object;
    });

    /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */
    var defaultsDeep = baseRest(function(args) {
      args.push(undefined, customDefaultsMerge);
      return apply(mergeWith, undefined, args);
    });

    /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */
    function findKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
    }

    /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */
    function findLastKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
    }

    /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */
    function forIn(object, iteratee) {
      return object == null
        ? object
        : baseFor(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */
    function forInRight(object, iteratee) {
      return object == null
        ? object
        : baseForRight(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forOwn(object, iteratee) {
      return object && baseForOwn(object, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */
    function forOwnRight(object, iteratee) {
      return object && baseForOwnRight(object, getIteratee(iteratee, 3));
    }

    /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */
    function functions(object) {
      return object == null ? [] : baseFunctions(object, keys(object));
    }

    /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */
    function functionsIn(object) {
      return object == null ? [] : baseFunctions(object, keysIn(object));
    }

    /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */
    function get(object, path, defaultValue) {
      var result = object == null ? undefined : baseGet(object, path);
      return result === undefined ? defaultValue : result;
    }

    /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */
    function has(object, path) {
      return object != null && hasPath(object, path, baseHas);
    }

    /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */
    function hasIn(object, path) {
      return object != null && hasPath(object, path, baseHasIn);
    }

    /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */
    var invert = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      result[value] = key;
    }, constant(identity));

    /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */
    var invertBy = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      if (hasOwnProperty.call(result, value)) {
        result[value].push(key);
      } else {
        result[value] = [key];
      }
    }, getIteratee);

    /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */
    var invoke = baseRest(baseInvoke);

    /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */
    function keys(object) {
      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
    }

    /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */
    function keysIn(object) {
      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
    }

    /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */
    function mapKeys(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, iteratee(value, key, object), value);
      });
      return result;
    }

    /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */
    function mapValues(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, key, iteratee(value, key, object));
      });
      return result;
    }

    /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */
    var merge = createAssigner(function(object, source, srcIndex) {
      baseMerge(object, source, srcIndex);
    });

    /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */
    var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
      baseMerge(object, source, srcIndex, customizer);
    });

    /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */
    var omit = flatRest(function(object, paths) {
      var result = {};
      if (object == null) {
        return result;
      }
      var isDeep = false;
      paths = arrayMap(paths, function(path) {
        path = castPath(path, object);
        isDeep || (isDeep = path.length > 1);
        return path;
      });
      copyObject(object, getAllKeysIn(object), result);
      if (isDeep) {
        result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
      }
      var length = paths.length;
      while (length--) {
        baseUnset(result, paths[length]);
      }
      return result;
    });

    /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */
    function omitBy(object, predicate) {
      return pickBy(object, negate(getIteratee(predicate)));
    }

    /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */
    var pick = flatRest(function(object, paths) {
      return object == null ? {} : basePick(object, paths);
    });

    /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */
    function pickBy(object, predicate) {
      if (object == null) {
        return {};
      }
      var props = arrayMap(getAllKeysIn(object), function(prop) {
        return [prop];
      });
      predicate = getIteratee(predicate);
      return basePickBy(object, props, function(value, path) {
        return predicate(value, path[0]);
      });
    }

    /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */
    function result(object, path, defaultValue) {
      path = castPath(path, object);

      var index = -1,
          length = path.length;

      // Ensure the loop is entered when path is empty.
      if (!length) {
        length = 1;
        object = undefined;
      }
      while (++index < length) {
        var value = object == null ? undefined : object[toKey(path[index])];
        if (value === undefined) {
          index = length;
          value = defaultValue;
        }
        object = isFunction(value) ? value.call(object) : value;
      }
      return object;
    }

    /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */
    function set(object, path, value) {
      return object == null ? object : baseSet(object, path, value);
    }

    /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */
    function setWith(object, path, value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseSet(object, path, value, customizer);
    }

    /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */
    var toPairs = createToPairs(keys);

    /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */
    var toPairsIn = createToPairs(keysIn);

    /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */
    function transform(object, iteratee, accumulator) {
      var isArr = isArray(object),
          isArrLike = isArr || isBuffer(object) || isTypedArray(object);

      iteratee = getIteratee(iteratee, 4);
      if (accumulator == null) {
        var Ctor = object && object.constructor;
        if (isArrLike) {
          accumulator = isArr ? new Ctor : [];
        }
        else if (isObject(object)) {
          accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
        }
        else {
          accumulator = {};
        }
      }
      (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
        return iteratee(accumulator, value, index, object);
      });
      return accumulator;
    }

    /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */
    function unset(object, path) {
      return object == null ? true : baseUnset(object, path);
    }

    /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */
    function update(object, path, updater) {
      return object == null ? object : baseUpdate(object, path, castFunction(updater));
    }

    /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */
    function updateWith(object, path, updater, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
    }

    /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */
    function values(object) {
      return object == null ? [] : baseValues(object, keys(object));
    }

    /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */
    function valuesIn(object) {
      return object == null ? [] : baseValues(object, keysIn(object));
    }

    /*------------------------------------------------------------------------*/

    /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */
    function clamp(number, lower, upper) {
      if (upper === undefined) {
        upper = lower;
        lower = undefined;
      }
      if (upper !== undefined) {
        upper = toNumber(upper);
        upper = upper === upper ? upper : 0;
      }
      if (lower !== undefined) {
        lower = toNumber(lower);
        lower = lower === lower ? lower : 0;
      }
      return baseClamp(toNumber(number), lower, upper);
    }

    /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */
    function inRange(number, start, end) {
      start = toFinite(start);
      if (end === undefined) {
        end = start;
        start = 0;
      } else {
        end = toFinite(end);
      }
      number = toNumber(number);
      return baseInRange(number, start, end);
    }

    /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */
    function random(lower, upper, floating) {
      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
        upper = floating = undefined;
      }
      if (floating === undefined) {
        if (typeof upper == 'boolean') {
          floating = upper;
          upper = undefined;
        }
        else if (typeof lower == 'boolean') {
          floating = lower;
          lower = undefined;
        }
      }
      if (lower === undefined && upper === undefined) {
        lower = 0;
        upper = 1;
      }
      else {
        lower = toFinite(lower);
        if (upper === undefined) {
          upper = lower;
          lower = 0;
        } else {
          upper = toFinite(upper);
        }
      }
      if (lower > upper) {
        var temp = lower;
        lower = upper;
        upper = temp;
      }
      if (floating || lower % 1 || upper % 1) {
        var rand = nativeRandom();
        return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
      }
      return baseRandom(lower, upper);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */
    var camelCase = createCompounder(function(result, word, index) {
      word = word.toLowerCase();
      return result + (index ? capitalize(word) : word);
    });

    /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */
    function capitalize(string) {
      return upperFirst(toString(string).toLowerCase());
    }

    /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */
    function deburr(string) {
      string = toString(string);
      return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
    }

    /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */
    function endsWith(string, target, position) {
      string = toString(string);
      target = baseToString(target);

      var length = string.length;
      position = position === undefined
        ? length
        : baseClamp(toInteger(position), 0, length);

      var end = position;
      position -= target.length;
      return position >= 0 && string.slice(position, end) == target;
    }

    /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */
    function escape(string) {
      string = toString(string);
      return (string && reHasUnescapedHtml.test(string))
        ? string.replace(reUnescapedHtml, escapeHtmlChar)
        : string;
    }

    /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */
    function escapeRegExp(string) {
      string = toString(string);
      return (string && reHasRegExpChar.test(string))
        ? string.replace(reRegExpChar, '\\$&')
        : string;
    }

    /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */
    var kebabCase = createCompounder(function(result, word, index) {
      return result + (index ? '-' : '') + word.toLowerCase();
    });

    /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */
    var lowerCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toLowerCase();
    });

    /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */
    var lowerFirst = createCaseFirst('toLowerCase');

    /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */
    function pad(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      if (!length || strLength >= length) {
        return string;
      }
      var mid = (length - strLength) / 2;
      return (
        createPadding(nativeFloor(mid), chars) +
        string +
        createPadding(nativeCeil(mid), chars)
      );
    }

    /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */
    function padEnd(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (string + createPadding(length - strLength, chars))
        : string;
    }

    /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */
    function padStart(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (createPadding(length - strLength, chars) + string)
        : string;
    }

    /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */
    function parseInt(string, radix, guard) {
      if (guard || radix == null) {
        radix = 0;
      } else if (radix) {
        radix = +radix;
      }
      return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
    }

    /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */
    function repeat(string, n, guard) {
      if ((guard ? isIterateeCall(string, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      return baseRepeat(toString(string), n);
    }

    /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */
    function replace() {
      var args = arguments,
          string = toString(args[0]);

      return args.length < 3 ? string : string.replace(args[1], args[2]);
    }

    /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */
    var snakeCase = createCompounder(function(result, word, index) {
      return result + (index ? '_' : '') + word.toLowerCase();
    });

    /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */
    function split(string, separator, limit) {
      if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
        separator = limit = undefined;
      }
      limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
      if (!limit) {
        return [];
      }
      string = toString(string);
      if (string && (
            typeof separator == 'string' ||
            (separator != null && !isRegExp(separator))
          )) {
        separator = baseToString(separator);
        if (!separator && hasUnicode(string)) {
          return castSlice(stringToArray(string), 0, limit);
        }
      }
      return string.split(separator, limit);
    }

    /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */
    var startCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + upperFirst(word);
    });

    /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */
    function startsWith(string, target, position) {
      string = toString(string);
      position = position == null
        ? 0
        : baseClamp(toInteger(position), 0, string.length);

      target = baseToString(target);
      return string.slice(position, position + target.length) == target;
    }

    /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */
    function template(string, options, guard) {
      // Based on John Resig's `tmpl` implementation
      // (http://ejohn.org/blog/javascript-micro-templating/)
      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
      var settings = lodash.templateSettings;

      if (guard && isIterateeCall(string, options, guard)) {
        options = undefined;
      }
      string = toString(string);
      options = assignInWith({}, options, settings, customDefaultsAssignIn);

      var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn),
          importsKeys = keys(imports),
          importsValues = baseValues(imports, importsKeys);

      var isEscaping,
          isEvaluating,
          index = 0,
          interpolate = options.interpolate || reNoMatch,
          source = "__p += '";

      // Compile the regexp to match each delimiter.
      var reDelimiters = RegExp(
        (options.escape || reNoMatch).source + '|' +
        interpolate.source + '|' +
        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
        (options.evaluate || reNoMatch).source + '|$'
      , 'g');

      // Use a sourceURL for easier debugging.
      // The sourceURL gets injected into the source that's eval-ed, so be careful
      // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
      // and escape the comment, thus injecting code that gets evaled.
      var sourceURL = '//# sourceURL=' +
        (hasOwnProperty.call(options, 'sourceURL')
          ? (options.sourceURL + '').replace(/\s/g, ' ')
          : ('lodash.templateSources[' + (++templateCounter) + ']')
        ) + '\n';

      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
        interpolateValue || (interpolateValue = esTemplateValue);

        // Escape characters that can't be included in string literals.
        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);

        // Replace delimiters with snippets.
        if (escapeValue) {
          isEscaping = true;
          source += "' +\n__e(" + escapeValue + ") +\n'";
        }
        if (evaluateValue) {
          isEvaluating = true;
          source += "';\n" + evaluateValue + ";\n__p += '";
        }
        if (interpolateValue) {
          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
        }
        index = offset + match.length;

        // The JS engine embedded in Adobe products needs `match` returned in
        // order to produce the correct `offset` value.
        return match;
      });

      source += "';\n";

      // If `variable` is not specified wrap a with-statement around the generated
      // code to add the data object to the top of the scope chain.
      var variable = hasOwnProperty.call(options, 'variable') && options.variable;
      if (!variable) {
        source = 'with (obj) {\n' + source + '\n}\n';
      }
      // Throw an error if a forbidden character was found in `variable`, to prevent
      // potential command injection attacks.
      else if (reForbiddenIdentifierChars.test(variable)) {
        throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
      }

      // Cleanup code by stripping empty strings.
      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
        .replace(reEmptyStringMiddle, '$1')
        .replace(reEmptyStringTrailing, '$1;');

      // Frame code as the function body.
      source = 'function(' + (variable || 'obj') + ') {\n' +
        (variable
          ? ''
          : 'obj || (obj = {});\n'
        ) +
        "var __t, __p = ''" +
        (isEscaping
           ? ', __e = _.escape'
           : ''
        ) +
        (isEvaluating
          ? ', __j = Array.prototype.join;\n' +
            "function print() { __p += __j.call(arguments, '') }\n"
          : ';\n'
        ) +
        source +
        'return __p\n}';

      var result = attempt(function() {
        return Function(importsKeys, sourceURL + 'return ' + source)
          .apply(undefined, importsValues);
      });

      // Provide the compiled function's source by its `toString` method or
      // the `source` property as a convenience for inlining compiled templates.
      result.source = source;
      if (isError(result)) {
        throw result;
      }
      return result;
    }

    /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */
    function toLower(value) {
      return toString(value).toLowerCase();
    }

    /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */
    function toUpper(value) {
      return toString(value).toUpperCase();
    }

    /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */
    function trim(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return baseTrim(string);
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          chrSymbols = stringToArray(chars),
          start = charsStartIndex(strSymbols, chrSymbols),
          end = charsEndIndex(strSymbols, chrSymbols) + 1;

      return castSlice(strSymbols, start, end).join('');
    }

    /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */
    function trimEnd(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.slice(0, trimmedEndIndex(string) + 1);
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;

      return castSlice(strSymbols, 0, end).join('');
    }

    /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */
    function trimStart(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrimStart, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          start = charsStartIndex(strSymbols, stringToArray(chars));

      return castSlice(strSymbols, start).join('');
    }

    /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */
    function truncate(string, options) {
      var length = DEFAULT_TRUNC_LENGTH,
          omission = DEFAULT_TRUNC_OMISSION;

      if (isObject(options)) {
        var separator = 'separator' in options ? options.separator : separator;
        length = 'length' in options ? toInteger(options.length) : length;
        omission = 'omission' in options ? baseToString(options.omission) : omission;
      }
      string = toString(string);

      var strLength = string.length;
      if (hasUnicode(string)) {
        var strSymbols = stringToArray(string);
        strLength = strSymbols.length;
      }
      if (length >= strLength) {
        return string;
      }
      var end = length - stringSize(omission);
      if (end < 1) {
        return omission;
      }
      var result = strSymbols
        ? castSlice(strSymbols, 0, end).join('')
        : string.slice(0, end);

      if (separator === undefined) {
        return result + omission;
      }
      if (strSymbols) {
        end += (result.length - end);
      }
      if (isRegExp(separator)) {
        if (string.slice(end).search(separator)) {
          var match,
              substring = result;

          if (!separator.global) {
            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
          }
          separator.lastIndex = 0;
          while ((match = separator.exec(substring))) {
            var newEnd = match.index;
          }
          result = result.slice(0, newEnd === undefined ? end : newEnd);
        }
      } else if (string.indexOf(baseToString(separator), end) != end) {
        var index = result.lastIndexOf(separator);
        if (index > -1) {
          result = result.slice(0, index);
        }
      }
      return result + omission;
    }

    /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */
    function unescape(string) {
      string = toString(string);
      return (string && reHasEscapedHtml.test(string))
        ? string.replace(reEscapedHtml, unescapeHtmlChar)
        : string;
    }

    /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */
    var upperCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toUpperCase();
    });

    /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */
    var upperFirst = createCaseFirst('toUpperCase');

    /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */
    function words(string, pattern, guard) {
      string = toString(string);
      pattern = guard ? undefined : pattern;

      if (pattern === undefined) {
        return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
      }
      return string.match(pattern) || [];
    }

    /*------------------------------------------------------------------------*/

    /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */
    var attempt = baseRest(function(func, args) {
      try {
        return apply(func, undefined, args);
      } catch (e) {
        return isError(e) ? e : new Error(e);
      }
    });

    /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */
    var bindAll = flatRest(function(object, methodNames) {
      arrayEach(methodNames, function(key) {
        key = toKey(key);
        baseAssignValue(object, key, bind(object[key], object));
      });
      return object;
    });

    /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */
    function cond(pairs) {
      var length = pairs == null ? 0 : pairs.length,
          toIteratee = getIteratee();

      pairs = !length ? [] : arrayMap(pairs, function(pair) {
        if (typeof pair[1] != 'function') {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
        return [toIteratee(pair[0]), pair[1]];
      });

      return baseRest(function(args) {
        var index = -1;
        while (++index < length) {
          var pair = pairs[index];
          if (apply(pair[0], this, args)) {
            return apply(pair[1], this, args);
          }
        }
      });
    }

    /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */
    function conforms(source) {
      return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */
    function constant(value) {
      return function() {
        return value;
      };
    }

    /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */
    function defaultTo(value, defaultValue) {
      return (value == null || value !== value) ? defaultValue : value;
    }

    /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */
    var flow = createFlow();

    /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */
    var flowRight = createFlow(true);

    /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */
    function identity(value) {
      return value;
    }

    /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */
    function iteratee(func) {
      return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matches(source) {
      return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matchesProperty(path, srcValue) {
      return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */
    var method = baseRest(function(path, args) {
      return function(object) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */
    var methodOf = baseRest(function(object, args) {
      return function(path) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */
    function mixin(object, source, options) {
      var props = keys(source),
          methodNames = baseFunctions(source, props);

      if (options == null &&
          !(isObject(source) && (methodNames.length || !props.length))) {
        options = source;
        source = object;
        object = this;
        methodNames = baseFunctions(source, keys(source));
      }
      var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
          isFunc = isFunction(object);

      arrayEach(methodNames, function(methodName) {
        var func = source[methodName];
        object[methodName] = func;
        if (isFunc) {
          object.prototype[methodName] = function() {
            var chainAll = this.__chain__;
            if (chain || chainAll) {
              var result = object(this.__wrapped__),
                  actions = result.__actions__ = copyArray(this.__actions__);

              actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
              result.__chain__ = chainAll;
              return result;
            }
            return func.apply(object, arrayPush([this.value()], arguments));
          };
        }
      });

      return object;
    }

    /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */
    function noConflict() {
      if (root._ === this) {
        root._ = oldDash;
      }
      return this;
    }

    /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */
    function noop() {
      // No operation performed.
    }

    /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */
    function nthArg(n) {
      n = toInteger(n);
      return baseRest(function(args) {
        return baseNth(args, n);
      });
    }

    /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */
    var over = createOver(arrayMap);

    /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */
    var overEvery = createOver(arrayEvery);

    /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     *
     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
     */
    var overSome = createOver(arraySome);

    /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */
    function property(path) {
      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
    }

    /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */
    function propertyOf(object) {
      return function(path) {
        return object == null ? undefined : baseGet(object, path);
      };
    }

    /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */
    var range = createRange();

    /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */
    var rangeRight = createRange(true);

    /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */
    function stubArray() {
      return [];
    }

    /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */
    function stubFalse() {
      return false;
    }

    /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */
    function stubObject() {
      return {};
    }

    /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */
    function stubString() {
      return '';
    }

    /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */
    function stubTrue() {
      return true;
    }

    /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */
    function times(n, iteratee) {
      n = toInteger(n);
      if (n < 1 || n > MAX_SAFE_INTEGER) {
        return [];
      }
      var index = MAX_ARRAY_LENGTH,
          length = nativeMin(n, MAX_ARRAY_LENGTH);

      iteratee = getIteratee(iteratee);
      n -= MAX_ARRAY_LENGTH;

      var result = baseTimes(length, iteratee);
      while (++index < n) {
        iteratee(index);
      }
      return result;
    }

    /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */
    function toPath(value) {
      if (isArray(value)) {
        return arrayMap(value, toKey);
      }
      return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
    }

    /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */
    function uniqueId(prefix) {
      var id = ++idCounter;
      return toString(prefix) + id;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */
    var add = createMathOperation(function(augend, addend) {
      return augend + addend;
    }, 0);

    /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */
    var ceil = createRound('ceil');

    /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */
    var divide = createMathOperation(function(dividend, divisor) {
      return dividend / divisor;
    }, 1);

    /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */
    var floor = createRound('floor');

    /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */
    function max(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseGt)
        : undefined;
    }

    /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */
    function maxBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseGt)
        : undefined;
    }

    /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */
    function mean(array) {
      return baseMean(array, identity);
    }

    /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */
    function meanBy(array, iteratee) {
      return baseMean(array, getIteratee(iteratee, 2));
    }

    /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */
    function min(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseLt)
        : undefined;
    }

    /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */
    function minBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseLt)
        : undefined;
    }

    /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */
    var multiply = createMathOperation(function(multiplier, multiplicand) {
      return multiplier * multiplicand;
    }, 1);

    /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */
    var round = createRound('round');

    /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */
    var subtract = createMathOperation(function(minuend, subtrahend) {
      return minuend - subtrahend;
    }, 0);

    /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */
    function sum(array) {
      return (array && array.length)
        ? baseSum(array, identity)
        : 0;
    }

    /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */
    function sumBy(array, iteratee) {
      return (array && array.length)
        ? baseSum(array, getIteratee(iteratee, 2))
        : 0;
    }

    /*------------------------------------------------------------------------*/

    // Add methods that return wrapped values in chain sequences.
    lodash.after = after;
    lodash.ary = ary;
    lodash.assign = assign;
    lodash.assignIn = assignIn;
    lodash.assignInWith = assignInWith;
    lodash.assignWith = assignWith;
    lodash.at = at;
    lodash.before = before;
    lodash.bind = bind;
    lodash.bindAll = bindAll;
    lodash.bindKey = bindKey;
    lodash.castArray = castArray;
    lodash.chain = chain;
    lodash.chunk = chunk;
    lodash.compact = compact;
    lodash.concat = concat;
    lodash.cond = cond;
    lodash.conforms = conforms;
    lodash.constant = constant;
    lodash.countBy = countBy;
    lodash.create = create;
    lodash.curry = curry;
    lodash.curryRight = curryRight;
    lodash.debounce = debounce;
    lodash.defaults = defaults;
    lodash.defaultsDeep = defaultsDeep;
    lodash.defer = defer;
    lodash.delay = delay;
    lodash.difference = difference;
    lodash.differenceBy = differenceBy;
    lodash.differenceWith = differenceWith;
    lodash.drop = drop;
    lodash.dropRight = dropRight;
    lodash.dropRightWhile = dropRightWhile;
    lodash.dropWhile = dropWhile;
    lodash.fill = fill;
    lodash.filter = filter;
    lodash.flatMap = flatMap;
    lodash.flatMapDeep = flatMapDeep;
    lodash.flatMapDepth = flatMapDepth;
    lodash.flatten = flatten;
    lodash.flattenDeep = flattenDeep;
    lodash.flattenDepth = flattenDepth;
    lodash.flip = flip;
    lodash.flow = flow;
    lodash.flowRight = flowRight;
    lodash.fromPairs = fromPairs;
    lodash.functions = functions;
    lodash.functionsIn = functionsIn;
    lodash.groupBy = groupBy;
    lodash.initial = initial;
    lodash.intersection = intersection;
    lodash.intersectionBy = intersectionBy;
    lodash.intersectionWith = intersectionWith;
    lodash.invert = invert;
    lodash.invertBy = invertBy;
    lodash.invokeMap = invokeMap;
    lodash.iteratee = iteratee;
    lodash.keyBy = keyBy;
    lodash.keys = keys;
    lodash.keysIn = keysIn;
    lodash.map = map;
    lodash.mapKeys = mapKeys;
    lodash.mapValues = mapValues;
    lodash.matches = matches;
    lodash.matchesProperty = matchesProperty;
    lodash.memoize = memoize;
    lodash.merge = merge;
    lodash.mergeWith = mergeWith;
    lodash.method = method;
    lodash.methodOf = methodOf;
    lodash.mixin = mixin;
    lodash.negate = negate;
    lodash.nthArg = nthArg;
    lodash.omit = omit;
    lodash.omitBy = omitBy;
    lodash.once = once;
    lodash.orderBy = orderBy;
    lodash.over = over;
    lodash.overArgs = overArgs;
    lodash.overEvery = overEvery;
    lodash.overSome = overSome;
    lodash.partial = partial;
    lodash.partialRight = partialRight;
    lodash.partition = partition;
    lodash.pick = pick;
    lodash.pickBy = pickBy;
    lodash.property = property;
    lodash.propertyOf = propertyOf;
    lodash.pull = pull;
    lodash.pullAll = pullAll;
    lodash.pullAllBy = pullAllBy;
    lodash.pullAllWith = pullAllWith;
    lodash.pullAt = pullAt;
    lodash.range = range;
    lodash.rangeRight = rangeRight;
    lodash.rearg = rearg;
    lodash.reject = reject;
    lodash.remove = remove;
    lodash.rest = rest;
    lodash.reverse = reverse;
    lodash.sampleSize = sampleSize;
    lodash.set = set;
    lodash.setWith = setWith;
    lodash.shuffle = shuffle;
    lodash.slice = slice;
    lodash.sortBy = sortBy;
    lodash.sortedUniq = sortedUniq;
    lodash.sortedUniqBy = sortedUniqBy;
    lodash.split = split;
    lodash.spread = spread;
    lodash.tail = tail;
    lodash.take = take;
    lodash.takeRight = takeRight;
    lodash.takeRightWhile = takeRightWhile;
    lodash.takeWhile = takeWhile;
    lodash.tap = tap;
    lodash.throttle = throttle;
    lodash.thru = thru;
    lodash.toArray = toArray;
    lodash.toPairs = toPairs;
    lodash.toPairsIn = toPairsIn;
    lodash.toPath = toPath;
    lodash.toPlainObject = toPlainObject;
    lodash.transform = transform;
    lodash.unary = unary;
    lodash.union = union;
    lodash.unionBy = unionBy;
    lodash.unionWith = unionWith;
    lodash.uniq = uniq;
    lodash.uniqBy = uniqBy;
    lodash.uniqWith = uniqWith;
    lodash.unset = unset;
    lodash.unzip = unzip;
    lodash.unzipWith = unzipWith;
    lodash.update = update;
    lodash.updateWith = updateWith;
    lodash.values = values;
    lodash.valuesIn = valuesIn;
    lodash.without = without;
    lodash.words = words;
    lodash.wrap = wrap;
    lodash.xor = xor;
    lodash.xorBy = xorBy;
    lodash.xorWith = xorWith;
    lodash.zip = zip;
    lodash.zipObject = zipObject;
    lodash.zipObjectDeep = zipObjectDeep;
    lodash.zipWith = zipWith;

    // Add aliases.
    lodash.entries = toPairs;
    lodash.entriesIn = toPairsIn;
    lodash.extend = assignIn;
    lodash.extendWith = assignInWith;

    // Add methods to `lodash.prototype`.
    mixin(lodash, lodash);

    /*------------------------------------------------------------------------*/

    // Add methods that return unwrapped values in chain sequences.
    lodash.add = add;
    lodash.attempt = attempt;
    lodash.camelCase = camelCase;
    lodash.capitalize = capitalize;
    lodash.ceil = ceil;
    lodash.clamp = clamp;
    lodash.clone = clone;
    lodash.cloneDeep = cloneDeep;
    lodash.cloneDeepWith = cloneDeepWith;
    lodash.cloneWith = cloneWith;
    lodash.conformsTo = conformsTo;
    lodash.deburr = deburr;
    lodash.defaultTo = defaultTo;
    lodash.divide = divide;
    lodash.endsWith = endsWith;
    lodash.eq = eq;
    lodash.escape = escape;
    lodash.escapeRegExp = escapeRegExp;
    lodash.every = every;
    lodash.find = find;
    lodash.findIndex = findIndex;
    lodash.findKey = findKey;
    lodash.findLast = findLast;
    lodash.findLastIndex = findLastIndex;
    lodash.findLastKey = findLastKey;
    lodash.floor = floor;
    lodash.forEach = forEach;
    lodash.forEachRight = forEachRight;
    lodash.forIn = forIn;
    lodash.forInRight = forInRight;
    lodash.forOwn = forOwn;
    lodash.forOwnRight = forOwnRight;
    lodash.get = get;
    lodash.gt = gt;
    lodash.gte = gte;
    lodash.has = has;
    lodash.hasIn = hasIn;
    lodash.head = head;
    lodash.identity = identity;
    lodash.includes = includes;
    lodash.indexOf = indexOf;
    lodash.inRange = inRange;
    lodash.invoke = invoke;
    lodash.isArguments = isArguments;
    lodash.isArray = isArray;
    lodash.isArrayBuffer = isArrayBuffer;
    lodash.isArrayLike = isArrayLike;
    lodash.isArrayLikeObject = isArrayLikeObject;
    lodash.isBoolean = isBoolean;
    lodash.isBuffer = isBuffer;
    lodash.isDate = isDate;
    lodash.isElement = isElement;
    lodash.isEmpty = isEmpty;
    lodash.isEqual = isEqual;
    lodash.isEqualWith = isEqualWith;
    lodash.isError = isError;
    lodash.isFinite = isFinite;
    lodash.isFunction = isFunction;
    lodash.isInteger = isInteger;
    lodash.isLength = isLength;
    lodash.isMap = isMap;
    lodash.isMatch = isMatch;
    lodash.isMatchWith = isMatchWith;
    lodash.isNaN = isNaN;
    lodash.isNative = isNative;
    lodash.isNil = isNil;
    lodash.isNull = isNull;
    lodash.isNumber = isNumber;
    lodash.isObject = isObject;
    lodash.isObjectLike = isObjectLike;
    lodash.isPlainObject = isPlainObject;
    lodash.isRegExp = isRegExp;
    lodash.isSafeInteger = isSafeInteger;
    lodash.isSet = isSet;
    lodash.isString = isString;
    lodash.isSymbol = isSymbol;
    lodash.isTypedArray = isTypedArray;
    lodash.isUndefined = isUndefined;
    lodash.isWeakMap = isWeakMap;
    lodash.isWeakSet = isWeakSet;
    lodash.join = join;
    lodash.kebabCase = kebabCase;
    lodash.last = last;
    lodash.lastIndexOf = lastIndexOf;
    lodash.lowerCase = lowerCase;
    lodash.lowerFirst = lowerFirst;
    lodash.lt = lt;
    lodash.lte = lte;
    lodash.max = max;
    lodash.maxBy = maxBy;
    lodash.mean = mean;
    lodash.meanBy = meanBy;
    lodash.min = min;
    lodash.minBy = minBy;
    lodash.stubArray = stubArray;
    lodash.stubFalse = stubFalse;
    lodash.stubObject = stubObject;
    lodash.stubString = stubString;
    lodash.stubTrue = stubTrue;
    lodash.multiply = multiply;
    lodash.nth = nth;
    lodash.noConflict = noConflict;
    lodash.noop = noop;
    lodash.now = now;
    lodash.pad = pad;
    lodash.padEnd = padEnd;
    lodash.padStart = padStart;
    lodash.parseInt = parseInt;
    lodash.random = random;
    lodash.reduce = reduce;
    lodash.reduceRight = reduceRight;
    lodash.repeat = repeat;
    lodash.replace = replace;
    lodash.result = result;
    lodash.round = round;
    lodash.runInContext = runInContext;
    lodash.sample = sample;
    lodash.size = size;
    lodash.snakeCase = snakeCase;
    lodash.some = some;
    lodash.sortedIndex = sortedIndex;
    lodash.sortedIndexBy = sortedIndexBy;
    lodash.sortedIndexOf = sortedIndexOf;
    lodash.sortedLastIndex = sortedLastIndex;
    lodash.sortedLastIndexBy = sortedLastIndexBy;
    lodash.sortedLastIndexOf = sortedLastIndexOf;
    lodash.startCase = startCase;
    lodash.startsWith = startsWith;
    lodash.subtract = subtract;
    lodash.sum = sum;
    lodash.sumBy = sumBy;
    lodash.template = template;
    lodash.times = times;
    lodash.toFinite = toFinite;
    lodash.toInteger = toInteger;
    lodash.toLength = toLength;
    lodash.toLower = toLower;
    lodash.toNumber = toNumber;
    lodash.toSafeInteger = toSafeInteger;
    lodash.toString = toString;
    lodash.toUpper = toUpper;
    lodash.trim = trim;
    lodash.trimEnd = trimEnd;
    lodash.trimStart = trimStart;
    lodash.truncate = truncate;
    lodash.unescape = unescape;
    lodash.uniqueId = uniqueId;
    lodash.upperCase = upperCase;
    lodash.upperFirst = upperFirst;

    // Add aliases.
    lodash.each = forEach;
    lodash.eachRight = forEachRight;
    lodash.first = head;

    mixin(lodash, (function() {
      var source = {};
      baseForOwn(lodash, function(func, methodName) {
        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
          source[methodName] = func;
        }
      });
      return source;
    }()), { 'chain': false });

    /*------------------------------------------------------------------------*/

    /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */
    lodash.VERSION = VERSION;

    // Assign default placeholders.
    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
      lodash[methodName].placeholder = lodash;
    });

    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
    arrayEach(['drop', 'take'], function(methodName, index) {
      LazyWrapper.prototype[methodName] = function(n) {
        n = n === undefined ? 1 : nativeMax(toInteger(n), 0);

        var result = (this.__filtered__ && !index)
          ? new LazyWrapper(this)
          : this.clone();

        if (result.__filtered__) {
          result.__takeCount__ = nativeMin(n, result.__takeCount__);
        } else {
          result.__views__.push({
            'size': nativeMin(n, MAX_ARRAY_LENGTH),
            'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
          });
        }
        return result;
      };

      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
        return this.reverse()[methodName](n).reverse();
      };
    });

    // Add `LazyWrapper` methods that accept an `iteratee` value.
    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
      var type = index + 1,
          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;

      LazyWrapper.prototype[methodName] = function(iteratee) {
        var result = this.clone();
        result.__iteratees__.push({
          'iteratee': getIteratee(iteratee, 3),
          'type': type
        });
        result.__filtered__ = result.__filtered__ || isFilter;
        return result;
      };
    });

    // Add `LazyWrapper` methods for `_.head` and `_.last`.
    arrayEach(['head', 'last'], function(methodName, index) {
      var takeName = 'take' + (index ? 'Right' : '');

      LazyWrapper.prototype[methodName] = function() {
        return this[takeName](1).value()[0];
      };
    });

    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
    arrayEach(['initial', 'tail'], function(methodName, index) {
      var dropName = 'drop' + (index ? '' : 'Right');

      LazyWrapper.prototype[methodName] = function() {
        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
      };
    });

    LazyWrapper.prototype.compact = function() {
      return this.filter(identity);
    };

    LazyWrapper.prototype.find = function(predicate) {
      return this.filter(predicate).head();
    };

    LazyWrapper.prototype.findLast = function(predicate) {
      return this.reverse().find(predicate);
    };

    LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
      if (typeof path == 'function') {
        return new LazyWrapper(this);
      }
      return this.map(function(value) {
        return baseInvoke(value, path, args);
      });
    });

    LazyWrapper.prototype.reject = function(predicate) {
      return this.filter(negate(getIteratee(predicate)));
    };

    LazyWrapper.prototype.slice = function(start, end) {
      start = toInteger(start);

      var result = this;
      if (result.__filtered__ && (start > 0 || end < 0)) {
        return new LazyWrapper(result);
      }
      if (start < 0) {
        result = result.takeRight(-start);
      } else if (start) {
        result = result.drop(start);
      }
      if (end !== undefined) {
        end = toInteger(end);
        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
      }
      return result;
    };

    LazyWrapper.prototype.takeRightWhile = function(predicate) {
      return this.reverse().takeWhile(predicate).reverse();
    };

    LazyWrapper.prototype.toArray = function() {
      return this.take(MAX_ARRAY_LENGTH);
    };

    // Add `LazyWrapper` methods to `lodash.prototype`.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
          isTaker = /^(?:head|last)$/.test(methodName),
          lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
          retUnwrapped = isTaker || /^find/.test(methodName);

      if (!lodashFunc) {
        return;
      }
      lodash.prototype[methodName] = function() {
        var value = this.__wrapped__,
            args = isTaker ? [1] : arguments,
            isLazy = value instanceof LazyWrapper,
            iteratee = args[0],
            useLazy = isLazy || isArray(value);

        var interceptor = function(value) {
          var result = lodashFunc.apply(lodash, arrayPush([value], args));
          return (isTaker && chainAll) ? result[0] : result;
        };

        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
          // Avoid lazy use if the iteratee has a "length" value other than `1`.
          isLazy = useLazy = false;
        }
        var chainAll = this.__chain__,
            isHybrid = !!this.__actions__.length,
            isUnwrapped = retUnwrapped && !chainAll,
            onlyLazy = isLazy && !isHybrid;

        if (!retUnwrapped && useLazy) {
          value = onlyLazy ? value : new LazyWrapper(this);
          var result = func.apply(value, args);
          result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
          return new LodashWrapper(result, chainAll);
        }
        if (isUnwrapped && onlyLazy) {
          return func.apply(this, args);
        }
        result = this.thru(interceptor);
        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
      };
    });

    // Add `Array` methods to `lodash.prototype`.
    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
      var func = arrayProto[methodName],
          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
          retUnwrapped = /^(?:pop|shift)$/.test(methodName);

      lodash.prototype[methodName] = function() {
        var args = arguments;
        if (retUnwrapped && !this.__chain__) {
          var value = this.value();
          return func.apply(isArray(value) ? value : [], args);
        }
        return this[chainName](function(value) {
          return func.apply(isArray(value) ? value : [], args);
        });
      };
    });

    // Map minified method names to their real names.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var lodashFunc = lodash[methodName];
      if (lodashFunc) {
        var key = lodashFunc.name + '';
        if (!hasOwnProperty.call(realNames, key)) {
          realNames[key] = [];
        }
        realNames[key].push({ 'name': methodName, 'func': lodashFunc });
      }
    });

    realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [{
      'name': 'wrapper',
      'func': undefined
    }];

    // Add methods to `LazyWrapper`.
    LazyWrapper.prototype.clone = lazyClone;
    LazyWrapper.prototype.reverse = lazyReverse;
    LazyWrapper.prototype.value = lazyValue;

    // Add chain sequence methods to the `lodash` wrapper.
    lodash.prototype.at = wrapperAt;
    lodash.prototype.chain = wrapperChain;
    lodash.prototype.commit = wrapperCommit;
    lodash.prototype.next = wrapperNext;
    lodash.prototype.plant = wrapperPlant;
    lodash.prototype.reverse = wrapperReverse;
    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;

    // Add lazy aliases.
    lodash.prototype.first = lodash.prototype.head;

    if (symIterator) {
      lodash.prototype[symIterator] = wrapperToIterator;
    }
    return lodash;
  });

  /*--------------------------------------------------------------------------*/

  // Export lodash.
  var _ = runInContext();

  // Some AMD build optimizers, like r.js, check for condition patterns like:
  if (true) {
    // Expose Lodash on the global object to prevent errors when Lodash is
    // loaded by a script tag in the presence of an AMD loader.
    // See http://requirejs.org/docs/errors.html#mismatch for more details.
    // Use `_.noConflict` to remove Lodash from the global object.
    root._ = _;

    // Define as an anonymous module so, through path mapping, it can be
    // referenced as the "underscore" module.
    !(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {
      return _;
    }).call(exports, __webpack_require__, exports, module),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  }
  // Check for `exports` after `define` in case a build optimizer adds it.
  else {}
}.call(this));


/***/ }),

/***/ 7576:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(20852),
    baseForOwn = __webpack_require__(15876),
    baseIteratee = __webpack_require__(83571);

/**
 * The opposite of `_.mapValues`; this method creates an object with the
 * same values as `object` and keys generated by running each own enumerable
 * string keyed property of `object` thru `iteratee`. The iteratee is invoked
 * with three arguments: (value, key, object).
 *
 * @static
 * @memberOf _
 * @since 3.8.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns the new mapped object.
 * @see _.mapValues
 * @example
 *
 * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
 *   return key + value;
 * });
 * // => { 'a1': 1, 'b2': 2 }
 */
function mapKeys(object, iteratee) {
  var result = {};
  iteratee = baseIteratee(iteratee, 3);

  baseForOwn(object, function(value, key, object) {
    baseAssignValue(result, iteratee(value, key, object), value);
  });
  return result;
}

module.exports = mapKeys;


/***/ }),

/***/ 18781:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(20852),
    baseForOwn = __webpack_require__(15876),
    baseIteratee = __webpack_require__(83571);

/**
 * Creates an object with the same keys as `object` and values generated
 * by running each own enumerable string keyed property of `object` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, key, object).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns the new mapped object.
 * @see _.mapKeys
 * @example
 *
 * var users = {
 *   'fred':    { 'user': 'fred',    'age': 40 },
 *   'pebbles': { 'user': 'pebbles', 'age': 1 }
 * };
 *
 * _.mapValues(users, function(o) { return o.age; });
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 *
 * // The `_.property` iteratee shorthand.
 * _.mapValues(users, 'age');
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 */
function mapValues(object, iteratee) {
  var result = {};
  iteratee = baseIteratee(iteratee, 3);

  baseForOwn(object, function(value, key, object) {
    baseAssignValue(result, key, iteratee(value, key, object));
  });
  return result;
}

module.exports = mapValues;


/***/ }),

/***/ 29872:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var MapCache = __webpack_require__(97372);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = MapCache;

module.exports = memoize;


/***/ }),

/***/ 84774:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseProperty = __webpack_require__(50179),
    basePropertyDeep = __webpack_require__(42308),
    isKey = __webpack_require__(80692),
    toKey = __webpack_require__(42566);

/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */
function property(path) {
  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}

module.exports = property;


/***/ }),

/***/ 65632:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var createCompounder = __webpack_require__(71161);

/**
 * Converts `string` to
 * [snake case](https://en.wikipedia.org/wiki/Snake_case).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the snake cased string.
 * @example
 *
 * _.snakeCase('Foo Bar');
 * // => 'foo_bar'
 *
 * _.snakeCase('fooBar');
 * // => 'foo_bar'
 *
 * _.snakeCase('--FOO-BAR--');
 * // => 'foo_bar'
 */
var snakeCase = createCompounder(function(result, word, index) {
  return result + (index ? '_' : '') + word.toLowerCase();
});

module.exports = snakeCase;


/***/ }),

/***/ 79874:
/***/ (function(module) {

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

module.exports = stubArray;


/***/ }),

/***/ 25676:
/***/ (function(module) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),

/***/ 65399:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var createToPairs = __webpack_require__(29384),
    keys = __webpack_require__(28220);

/**
 * Creates an array of own enumerable string keyed-value pairs for `object`
 * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
 * entries are returned.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @alias entries
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the key-value pairs.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.toPairs(new Foo);
 * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
 */
var toPairs = createToPairs(keys);

module.exports = toPairs;


/***/ }),

/***/ 94805:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayMap = __webpack_require__(8106),
    copyArray = __webpack_require__(91664),
    isArray = __webpack_require__(24609),
    isSymbol = __webpack_require__(59739),
    stringToPath = __webpack_require__(26731),
    toKey = __webpack_require__(42566),
    toString = __webpack_require__(8553);

/**
 * Converts `value` to a property path array.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Util
 * @param {*} value The value to convert.
 * @returns {Array} Returns the new property path array.
 * @example
 *
 * _.toPath('a.b.c');
 * // => ['a', 'b', 'c']
 *
 * _.toPath('a[0].b.c');
 * // => ['a', '0', 'b', 'c']
 */
function toPath(value) {
  if (isArray(value)) {
    return arrayMap(value, toKey);
  }
  return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
}

module.exports = toPath;


/***/ }),

/***/ 8553:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseToString = __webpack_require__(13588);

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

module.exports = toString;


/***/ }),

/***/ 51930:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var createCaseFirst = __webpack_require__(60052);

/**
 * Converts the first character of `string` to upper case.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.upperFirst('fred');
 * // => 'Fred'
 *
 * _.upperFirst('FRED');
 * // => 'FRED'
 */
var upperFirst = createCaseFirst('toUpperCase');

module.exports = upperFirst;


/***/ }),

/***/ 4851:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var asciiWords = __webpack_require__(26586),
    hasUnicodeWord = __webpack_require__(60534),
    toString = __webpack_require__(8553),
    unicodeWords = __webpack_require__(71638);

/**
 * Splits `string` into an array of its words.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to inspect.
 * @param {RegExp|string} [pattern] The pattern to match words.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the words of `string`.
 * @example
 *
 * _.words('fred, barney, & pebbles');
 * // => ['fred', 'barney', 'pebbles']
 *
 * _.words('fred, barney, & pebbles', /[^, ]+/g);
 * // => ['fred', 'barney', '&', 'pebbles']
 */
function words(string, pattern, guard) {
  string = toString(string);
  pattern = guard ? undefined : pattern;

  if (pattern === undefined) {
    return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
  }
  return string.match(pattern) || [];
}

module.exports = words;


/***/ }),

/***/ 65173:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(11591);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),

/***/ 22283:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) { var throwOnDirectAccess, ReactIs; } else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(65173)();
}


/***/ }),

/***/ 11591:
/***/ (function(module) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),

/***/ 83212:
/***/ (function(module) {

"use strict";
/**
 * Based on Kendo UI Core expression code <https://github.com/telerik/kendo-ui-core#license-information>
 */


function Cache(maxSize) {
  this._maxSize = maxSize
  this.clear()
}
Cache.prototype.clear = function () {
  this._size = 0
  this._values = Object.create(null)
}
Cache.prototype.get = function (key) {
  return this._values[key]
}
Cache.prototype.set = function (key, value) {
  this._size >= this._maxSize && this.clear()
  if (!(key in this._values)) this._size++

  return (this._values[key] = value)
}

var SPLIT_REGEX = /[^.^\]^[]+|(?=\[\]|\.\.)/g,
  DIGIT_REGEX = /^\d+$/,
  LEAD_DIGIT_REGEX = /^\d/,
  SPEC_CHAR_REGEX = /[~`!#$%\^&*+=\-\[\]\\';,/{}|\\":<>\?]/g,
  CLEAN_QUOTES_REGEX = /^\s*(['"]?)(.*?)(\1)\s*$/,
  MAX_CACHE_SIZE = 512

var pathCache = new Cache(MAX_CACHE_SIZE),
  setCache = new Cache(MAX_CACHE_SIZE),
  getCache = new Cache(MAX_CACHE_SIZE)

var config

module.exports = {
  Cache: Cache,

  split: split,

  normalizePath: normalizePath,

  setter: function (path) {
    var parts = normalizePath(path)

    return (
      setCache.get(path) ||
      setCache.set(path, function setter(obj, value) {
        var index = 0
        var len = parts.length
        var data = obj

        while (index < len - 1) {
          var part = parts[index]
          if (
            part === '__proto__' ||
            part === 'constructor' ||
            part === 'prototype'
          ) {
            return obj
          }

          data = data[parts[index++]]
        }
        data[parts[index]] = value
      })
    )
  },

  getter: function (path, safe) {
    var parts = normalizePath(path)
    return (
      getCache.get(path) ||
      getCache.set(path, function getter(data) {
        var index = 0,
          len = parts.length
        while (index < len) {
          if (data != null || !safe) data = data[parts[index++]]
          else return
        }
        return data
      })
    )
  },

  join: function (segments) {
    return segments.reduce(function (path, part) {
      return (
        path +
        (isQuoted(part) || DIGIT_REGEX.test(part)
          ? '[' + part + ']'
          : (path ? '.' : '') + part)
      )
    }, '')
  },

  forEach: function (path, cb, thisArg) {
    forEach(Array.isArray(path) ? path : split(path), cb, thisArg)
  },
}

function normalizePath(path) {
  return (
    pathCache.get(path) ||
    pathCache.set(
      path,
      split(path).map(function (part) {
        return part.replace(CLEAN_QUOTES_REGEX, '$2')
      })
    )
  )
}

function split(path) {
  return path.match(SPLIT_REGEX) || ['']
}

function forEach(parts, iter, thisArg) {
  var len = parts.length,
    part,
    idx,
    isArray,
    isBracket

  for (idx = 0; idx < len; idx++) {
    part = parts[idx]

    if (part) {
      if (shouldBeQuoted(part)) {
        part = '"' + part + '"'
      }

      isBracket = isQuoted(part)
      isArray = !isBracket && /^\d+$/.test(part)

      iter.call(thisArg, part, isBracket, isArray, idx, parts)
    }
  }
}

function isQuoted(str) {
  return (
    typeof str === 'string' && str && ["'", '"'].indexOf(str.charAt(0)) !== -1
  )
}

function hasLeadingNumber(part) {
  return part.match(LEAD_DIGIT_REGEX) && !part.match(DIGIT_REGEX)
}

function hasSpecialChars(part) {
  return SPEC_CHAR_REGEX.test(part)
}

function shouldBeQuoted(part) {
  return !isQuoted(part) && (hasLeadingNumber(part) || hasSpecialChars(part))
}


/***/ }),

/***/ 46757:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

const strictUriEncode = __webpack_require__(53676);
const decodeComponent = __webpack_require__(81767);
const splitOnFirst = __webpack_require__(25203);
const filterObject = __webpack_require__(37689);

const isNullOrUndefined = value => value === null || value === undefined;

const encodeFragmentIdentifier = Symbol('encodeFragmentIdentifier');

function encoderForArrayFormat(options) {
	switch (options.arrayFormat) {
		case 'index':
			return key => (result, value) => {
				const index = result.length;

				if (
					value === undefined ||
					(options.skipNull && value === null) ||
					(options.skipEmptyString && value === '')
				) {
					return result;
				}

				if (value === null) {
					return [...result, [encode(key, options), '[', index, ']'].join('')];
				}

				return [
					...result,
					[encode(key, options), '[', encode(index, options), ']=', encode(value, options)].join('')
				];
			};

		case 'bracket':
			return key => (result, value) => {
				if (
					value === undefined ||
					(options.skipNull && value === null) ||
					(options.skipEmptyString && value === '')
				) {
					return result;
				}

				if (value === null) {
					return [...result, [encode(key, options), '[]'].join('')];
				}

				return [...result, [encode(key, options), '[]=', encode(value, options)].join('')];
			};

		case 'colon-list-separator':
			return key => (result, value) => {
				if (
					value === undefined ||
					(options.skipNull && value === null) ||
					(options.skipEmptyString && value === '')
				) {
					return result;
				}

				if (value === null) {
					return [...result, [encode(key, options), ':list='].join('')];
				}

				return [...result, [encode(key, options), ':list=', encode(value, options)].join('')];
			};

		case 'comma':
		case 'separator':
		case 'bracket-separator': {
			const keyValueSep = options.arrayFormat === 'bracket-separator' ?
				'[]=' :
				'=';

			return key => (result, value) => {
				if (
					value === undefined ||
					(options.skipNull && value === null) ||
					(options.skipEmptyString && value === '')
				) {
					return result;
				}

				// Translate null to an empty string so that it doesn't serialize as 'null'
				value = value === null ? '' : value;

				if (result.length === 0) {
					return [[encode(key, options), keyValueSep, encode(value, options)].join('')];
				}

				return [[result, encode(value, options)].join(options.arrayFormatSeparator)];
			};
		}

		default:
			return key => (result, value) => {
				if (
					value === undefined ||
					(options.skipNull && value === null) ||
					(options.skipEmptyString && value === '')
				) {
					return result;
				}

				if (value === null) {
					return [...result, encode(key, options)];
				}

				return [...result, [encode(key, options), '=', encode(value, options)].join('')];
			};
	}
}

function parserForArrayFormat(options) {
	let result;

	switch (options.arrayFormat) {
		case 'index':
			return (key, value, accumulator) => {
				result = /\[(\d*)\]$/.exec(key);

				key = key.replace(/\[\d*\]$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				}

				if (accumulator[key] === undefined) {
					accumulator[key] = {};
				}

				accumulator[key][result[1]] = value;
			};

		case 'bracket':
			return (key, value, accumulator) => {
				result = /(\[\])$/.exec(key);
				key = key.replace(/\[\]$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				}

				if (accumulator[key] === undefined) {
					accumulator[key] = [value];
					return;
				}

				accumulator[key] = [].concat(accumulator[key], value);
			};

		case 'colon-list-separator':
			return (key, value, accumulator) => {
				result = /(:list)$/.exec(key);
				key = key.replace(/:list$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				}

				if (accumulator[key] === undefined) {
					accumulator[key] = [value];
					return;
				}

				accumulator[key] = [].concat(accumulator[key], value);
			};

		case 'comma':
		case 'separator':
			return (key, value, accumulator) => {
				const isArray = typeof value === 'string' && value.includes(options.arrayFormatSeparator);
				const isEncodedArray = (typeof value === 'string' && !isArray && decode(value, options).includes(options.arrayFormatSeparator));
				value = isEncodedArray ? decode(value, options) : value;
				const newValue = isArray || isEncodedArray ? value.split(options.arrayFormatSeparator).map(item => decode(item, options)) : value === null ? value : decode(value, options);
				accumulator[key] = newValue;
			};

		case 'bracket-separator':
			return (key, value, accumulator) => {
				const isArray = /(\[\])$/.test(key);
				key = key.replace(/\[\]$/, '');

				if (!isArray) {
					accumulator[key] = value ? decode(value, options) : value;
					return;
				}

				const arrayValue = value === null ?
					[] :
					value.split(options.arrayFormatSeparator).map(item => decode(item, options));

				if (accumulator[key] === undefined) {
					accumulator[key] = arrayValue;
					return;
				}

				accumulator[key] = [].concat(accumulator[key], arrayValue);
			};

		default:
			return (key, value, accumulator) => {
				if (accumulator[key] === undefined) {
					accumulator[key] = value;
					return;
				}

				accumulator[key] = [].concat(accumulator[key], value);
			};
	}
}

function validateArrayFormatSeparator(value) {
	if (typeof value !== 'string' || value.length !== 1) {
		throw new TypeError('arrayFormatSeparator must be single character string');
	}
}

function encode(value, options) {
	if (options.encode) {
		return options.strict ? strictUriEncode(value) : encodeURIComponent(value);
	}

	return value;
}

function decode(value, options) {
	if (options.decode) {
		return decodeComponent(value);
	}

	return value;
}

function keysSorter(input) {
	if (Array.isArray(input)) {
		return input.sort();
	}

	if (typeof input === 'object') {
		return keysSorter(Object.keys(input))
			.sort((a, b) => Number(a) - Number(b))
			.map(key => input[key]);
	}

	return input;
}

function removeHash(input) {
	const hashStart = input.indexOf('#');
	if (hashStart !== -1) {
		input = input.slice(0, hashStart);
	}

	return input;
}

function getHash(url) {
	let hash = '';
	const hashStart = url.indexOf('#');
	if (hashStart !== -1) {
		hash = url.slice(hashStart);
	}

	return hash;
}

function extract(input) {
	input = removeHash(input);
	const queryStart = input.indexOf('?');
	if (queryStart === -1) {
		return '';
	}

	return input.slice(queryStart + 1);
}

function parseValue(value, options) {
	if (options.parseNumbers && !Number.isNaN(Number(value)) && (typeof value === 'string' && value.trim() !== '')) {
		value = Number(value);
	} else if (options.parseBooleans && value !== null && (value.toLowerCase() === 'true' || value.toLowerCase() === 'false')) {
		value = value.toLowerCase() === 'true';
	}

	return value;
}

function parse(query, options) {
	options = Object.assign({
		decode: true,
		sort: true,
		arrayFormat: 'none',
		arrayFormatSeparator: ',',
		parseNumbers: false,
		parseBooleans: false
	}, options);

	validateArrayFormatSeparator(options.arrayFormatSeparator);

	const formatter = parserForArrayFormat(options);

	// Create an object with no prototype
	const ret = Object.create(null);

	if (typeof query !== 'string') {
		return ret;
	}

	query = query.trim().replace(/^[?#&]/, '');

	if (!query) {
		return ret;
	}

	for (const param of query.split('&')) {
		if (param === '') {
			continue;
		}

		let [key, value] = splitOnFirst(options.decode ? param.replace(/\+/g, ' ') : param, '=');

		// Missing `=` should be `null`:
		// http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
		value = value === undefined ? null : ['comma', 'separator', 'bracket-separator'].includes(options.arrayFormat) ? value : decode(value, options);
		formatter(decode(key, options), value, ret);
	}

	for (const key of Object.keys(ret)) {
		const value = ret[key];
		if (typeof value === 'object' && value !== null) {
			for (const k of Object.keys(value)) {
				value[k] = parseValue(value[k], options);
			}
		} else {
			ret[key] = parseValue(value, options);
		}
	}

	if (options.sort === false) {
		return ret;
	}

	return (options.sort === true ? Object.keys(ret).sort() : Object.keys(ret).sort(options.sort)).reduce((result, key) => {
		const value = ret[key];
		if (Boolean(value) && typeof value === 'object' && !Array.isArray(value)) {
			// Sort object keys, not values
			result[key] = keysSorter(value);
		} else {
			result[key] = value;
		}

		return result;
	}, Object.create(null));
}

exports.extract = extract;
exports.parse = parse;

exports.stringify = (object, options) => {
	if (!object) {
		return '';
	}

	options = Object.assign({
		encode: true,
		strict: true,
		arrayFormat: 'none',
		arrayFormatSeparator: ','
	}, options);

	validateArrayFormatSeparator(options.arrayFormatSeparator);

	const shouldFilter = key => (
		(options.skipNull && isNullOrUndefined(object[key])) ||
		(options.skipEmptyString && object[key] === '')
	);

	const formatter = encoderForArrayFormat(options);

	const objectCopy = {};

	for (const key of Object.keys(object)) {
		if (!shouldFilter(key)) {
			objectCopy[key] = object[key];
		}
	}

	const keys = Object.keys(objectCopy);

	if (options.sort !== false) {
		keys.sort(options.sort);
	}

	return keys.map(key => {
		const value = object[key];

		if (value === undefined) {
			return '';
		}

		if (value === null) {
			return encode(key, options);
		}

		if (Array.isArray(value)) {
			if (value.length === 0 && options.arrayFormat === 'bracket-separator') {
				return encode(key, options) + '[]';
			}

			return value
				.reduce(formatter(key), [])
				.join('&');
		}

		return encode(key, options) + '=' + encode(value, options);
	}).filter(x => x.length > 0).join('&');
};

exports.parseUrl = (url, options) => {
	options = Object.assign({
		decode: true
	}, options);

	const [url_, hash] = splitOnFirst(url, '#');

	return Object.assign(
		{
			url: url_.split('?')[0] || '',
			query: parse(extract(url), options)
		},
		options && options.parseFragmentIdentifier && hash ? {fragmentIdentifier: decode(hash, options)} : {}
	);
};

exports.stringifyUrl = (object, options) => {
	options = Object.assign({
		encode: true,
		strict: true,
		[encodeFragmentIdentifier]: true
	}, options);

	const url = removeHash(object.url).split('?')[0] || '';
	const queryFromUrl = exports.extract(object.url);
	const parsedQueryFromUrl = exports.parse(queryFromUrl, {sort: false});

	const query = Object.assign(parsedQueryFromUrl, object.query);
	let queryString = exports.stringify(query, options);
	if (queryString) {
		queryString = `?${queryString}`;
	}

	let hash = getHash(object.url);
	if (object.fragmentIdentifier) {
		hash = `#${options[encodeFragmentIdentifier] ? encode(object.fragmentIdentifier, options) : object.fragmentIdentifier}`;
	}

	return `${url}${queryString}${hash}`;
};

exports.pick = (input, filter, options) => {
	options = Object.assign({
		parseFragmentIdentifier: true,
		[encodeFragmentIdentifier]: false
	}, options);

	const {url, query, fragmentIdentifier} = exports.parseUrl(input, options);
	return exports.stringifyUrl({
		url,
		query: filterObject(query, filter),
		fragmentIdentifier
	}, options);
};

exports.exclude = (input, filter, options) => {
	const exclusionFilter = Array.isArray(filter) ? key => !filter.includes(key) : (key, value) => !filter(key, value);

	return exports.pick(input, exclusionFilter, options);
};


/***/ }),

/***/ 7539:
/***/ (function(module) {

"use strict";


var isArray = Array.isArray;
var keyList = Object.keys;
var hasProp = Object.prototype.hasOwnProperty;
var hasElementType = typeof Element !== 'undefined';

function equal(a, b) {
  // fast-deep-equal index.js 2.0.1
  if (a === b) return true;

  if (a && b && typeof a == 'object' && typeof b == 'object') {
    var arrA = isArray(a)
      , arrB = isArray(b)
      , i
      , length
      , key;

    if (arrA && arrB) {
      length = a.length;
      if (length != b.length) return false;
      for (i = length; i-- !== 0;)
        if (!equal(a[i], b[i])) return false;
      return true;
    }

    if (arrA != arrB) return false;

    var dateA = a instanceof Date
      , dateB = b instanceof Date;
    if (dateA != dateB) return false;
    if (dateA && dateB) return a.getTime() == b.getTime();

    var regexpA = a instanceof RegExp
      , regexpB = b instanceof RegExp;
    if (regexpA != regexpB) return false;
    if (regexpA && regexpB) return a.toString() == b.toString();

    var keys = keyList(a);
    length = keys.length;

    if (length !== keyList(b).length)
      return false;

    for (i = length; i-- !== 0;)
      if (!hasProp.call(b, keys[i])) return false;
    // end fast-deep-equal

    // start react-fast-compare
    // custom handling for DOM elements
    if (hasElementType && a instanceof Element && b instanceof Element)
      return a === b;

    // custom handling for React
    for (i = length; i-- !== 0;) {
      key = keys[i];
      if (key === '_owner' && a.$$typeof) {
        // React-specific: avoid traversing React elements' _owner.
        //  _owner contains circular references
        // and is not needed when comparing the actual elements (and not their owners)
        // .$$typeof and ._store on just reasonable markers of a react element
        continue;
      } else {
        // all other properties should be traversed as usual
        if (!equal(a[key], b[key])) return false;
      }
    }
    // end react-fast-compare

    // fast-deep-equal index.js 2.0.1
    return true;
  }

  return a !== a && b !== b;
}
// end fast-deep-equal

module.exports = function exportedEqual(a, b) {
  try {
    return equal(a, b);
  } catch (error) {
    if ((error.message && error.message.match(/stack|recursion/i)) || (error.number === -2146828260)) {
      // warn on circular references, don't crash
      // browsers give this different errors name and messages:
      // chrome/safari: "RangeError", "Maximum call stack size exceeded"
      // firefox: "InternalError", too much recursion"
      // edge: "Error", "Out of stack space"
      console.warn('Warning: react-fast-compare does not handle circular references.', error.name, error.message);
      return false;
    }
    // some other error. we should definitely know about these
    throw error;
  }
};


/***/ }),

/***/ 90244:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;exports.Lazy=t;exports.Memo=r;exports.Portal=d;
exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;exports.isAsyncMode=function(a){return A(a)||z(a)===l};exports.isConcurrentMode=A;exports.isContextConsumer=function(a){return z(a)===k};exports.isContextProvider=function(a){return z(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return z(a)===n};exports.isFragment=function(a){return z(a)===e};exports.isLazy=function(a){return z(a)===t};
exports.isMemo=function(a){return z(a)===r};exports.isPortal=function(a){return z(a)===d};exports.isProfiler=function(a){return z(a)===g};exports.isStrictMode=function(a){return z(a)===f};exports.isSuspense=function(a){return z(a)===p};
exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};exports.typeOf=z;


/***/ }),

/***/ 52744:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(90244);
} else {}


/***/ }),

/***/ 19900:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;
/** @license React v17.0.2
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var b=60103,c=60106,d=60107,e=60108,f=60114,g=60109,h=60110,k=60112,l=60113,m=60120,n=60115,p=60116,q=60121,r=60122,u=60117,v=60129,w=60131;
if("function"===typeof Symbol&&Symbol.for){var x=Symbol.for;b=x("react.element");c=x("react.portal");d=x("react.fragment");e=x("react.strict_mode");f=x("react.profiler");g=x("react.provider");h=x("react.context");k=x("react.forward_ref");l=x("react.suspense");m=x("react.suspense_list");n=x("react.memo");p=x("react.lazy");q=x("react.block");r=x("react.server.block");u=x("react.fundamental");v=x("react.debug_trace_mode");w=x("react.legacy_hidden")}
function y(a){if("object"===typeof a&&null!==a){var t=a.$$typeof;switch(t){case b:switch(a=a.type,a){case d:case f:case e:case l:case m:return a;default:switch(a=a&&a.$$typeof,a){case h:case k:case p:case n:case g:return a;default:return t}}case c:return t}}}var z=g,A=b,B=k,C=d,D=p,E=n,F=c,G=f,H=e,I=l;__webpack_unused_export__=h;__webpack_unused_export__=z;__webpack_unused_export__=A;__webpack_unused_export__=B;__webpack_unused_export__=C;__webpack_unused_export__=D;__webpack_unused_export__=E;__webpack_unused_export__=F;__webpack_unused_export__=G;__webpack_unused_export__=H;
__webpack_unused_export__=I;__webpack_unused_export__=function(){return!1};__webpack_unused_export__=function(){return!1};__webpack_unused_export__=function(a){return y(a)===h};__webpack_unused_export__=function(a){return y(a)===g};__webpack_unused_export__=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===b};__webpack_unused_export__=function(a){return y(a)===k};__webpack_unused_export__=function(a){return y(a)===d};__webpack_unused_export__=function(a){return y(a)===p};__webpack_unused_export__=function(a){return y(a)===n};
__webpack_unused_export__=function(a){return y(a)===c};__webpack_unused_export__=function(a){return y(a)===f};__webpack_unused_export__=function(a){return y(a)===e};__webpack_unused_export__=function(a){return y(a)===l};__webpack_unused_export__=function(a){return"string"===typeof a||"function"===typeof a||a===d||a===f||a===v||a===e||a===l||a===m||a===w||"object"===typeof a&&null!==a&&(a.$$typeof===p||a.$$typeof===n||a.$$typeof===g||a.$$typeof===h||a.$$typeof===k||a.$$typeof===u||a.$$typeof===q||a[0]===r)?!0:!1};
__webpack_unused_export__=y;


/***/ }),

/***/ 90215:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


if (true) {
  /* unused reexport */ __webpack_require__(19900);
} else {}


/***/ }),

/***/ 1357:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var b=Symbol.for("react.element"),c=Symbol.for("react.portal"),d=Symbol.for("react.fragment"),e=Symbol.for("react.strict_mode"),f=Symbol.for("react.profiler"),g=Symbol.for("react.provider"),h=Symbol.for("react.context"),k=Symbol.for("react.server_context"),l=Symbol.for("react.forward_ref"),m=Symbol.for("react.suspense"),n=Symbol.for("react.suspense_list"),p=Symbol.for("react.memo"),q=Symbol.for("react.lazy"),t=Symbol.for("react.offscreen"),u;u=Symbol.for("react.module.reference");
function v(a){if("object"===typeof a&&null!==a){var r=a.$$typeof;switch(r){case b:switch(a=a.type,a){case d:case f:case e:case m:case n:return a;default:switch(a=a&&a.$$typeof,a){case k:case h:case l:case q:case p:case g:return a;default:return r}}case c:return r}}}exports.ContextConsumer=h;exports.ContextProvider=g;exports.Element=b;exports.ForwardRef=l;exports.Fragment=d;exports.Lazy=q;exports.Memo=p;exports.Portal=c;exports.Profiler=f;exports.StrictMode=e;exports.Suspense=m;
exports.SuspenseList=n;exports.isAsyncMode=function(){return!1};exports.isConcurrentMode=function(){return!1};exports.isContextConsumer=function(a){return v(a)===h};exports.isContextProvider=function(a){return v(a)===g};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===b};exports.isForwardRef=function(a){return v(a)===l};exports.isFragment=function(a){return v(a)===d};exports.isLazy=function(a){return v(a)===q};exports.isMemo=function(a){return v(a)===p};
exports.isPortal=function(a){return v(a)===c};exports.isProfiler=function(a){return v(a)===f};exports.isStrictMode=function(a){return v(a)===e};exports.isSuspense=function(a){return v(a)===m};exports.isSuspenseList=function(a){return v(a)===n};
exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===d||a===f||a===e||a===m||a===n||a===t||"object"===typeof a&&null!==a&&(a.$$typeof===q||a.$$typeof===p||a.$$typeof===g||a.$$typeof===h||a.$$typeof===l||a.$$typeof===u||void 0!==a.getModuleId)?!0:!1};exports.typeOf=v;


/***/ }),

/***/ 3360:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(1357);
} else {}


/***/ }),

/***/ 53918:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
function objectAssignPolyfill(){"function"!=typeof Object.assign&&(Object.assign=function(e,t){var n=arguments;if(null==e)throw new TypeError("Cannot convert undefined or null to object");for(var i=Object(e),o=1;o<arguments.length;o++){var r=n[o];if(null!=r)for(var s in r)Object.prototype.hasOwnProperty.call(r,s)&&(i[s]=r[s])}return i})}function objectKeysPolyfill(){var e,t,n,i;Object.keys||(Object.keys=(e=Object.prototype.hasOwnProperty,t=!{toString:null}.propertyIsEnumerable("toString"),i=(n=["toString","toLocaleString","valueOf","hasOwnProperty","isPrototypeOf","propertyIsEnumerable","constructor"]).length,function(o){if("function"!=typeof o&&("object"!=typeof o||null===o))throw new TypeError("Object.keys called on non-object");var r,s,a=[];for(r in o)e.call(o,r)&&a.push(r);if(t)for(s=0;s<i;s++)e.call(o,n[s])&&a.push(n[s]);return a}))}function __rest(e,t){var n={};for(var i in e)Object.prototype.hasOwnProperty.call(e,i)&&t.indexOf(i)<0&&(n[i]=e[i]);if(null!=e&&"function"==typeof Object.getOwnPropertySymbols){var o=0;for(i=Object.getOwnPropertySymbols(e);o<i.length;o++)t.indexOf(i[o])<0&&Object.prototype.propertyIsEnumerable.call(e,i[o])&&(n[i[o]]=e[i[o]])}return n}Object.defineProperty(exports, "__esModule", ({value:!0}));var supportsCookies=function(){try{return Boolean(navigator.cookieEnabled)}catch(e){return!1}},supportsSendBeacon=function(){try{return Boolean(navigator.sendBeacon)}catch(e){return!1}},supportsXMLHttpRequest=function(){try{return Boolean(XMLHttpRequest)}catch(e){return!1}},isUndefined=function(e){return void 0===e},isString=function(e){return"string"==typeof e},isNumber=function(e){return"number"==typeof e},isFunction=function(e){return"function"==typeof e};function makeSendEvents(e){return function(t){var n=this;if(!this._userHasOptedOut){if(!this._hasCredentials)throw new Error("Before calling any methods on the analytics, you first need to call the 'init' function with appId and apiKey parameters");var i=t.map(function(e){var t,i,o=e.filters,r=__rest(e,["filters"]),s=Object.assign(Object.assign({},r),{userToken:(i=null===(t=e)||void 0===t?void 0:t.userToken,null!==i&&void 0!==i?i:n._userToken)});return isUndefined(o)||(s.filters=o.map(encodeURIComponent)),s});return sendRequest(e,this._appId,this._apiKey,this._ua,this._endpointOrigin,i)}}}function sendRequest(e,t,n,i,o,r){return e(o+"/1/events?X-Algolia-Application-Id="+t+"&X-Algolia-API-Key="+n+"&X-Algolia-Agent="+encodeURIComponent(i.join("; ")),{events:r})}var version="2.2.1",DEFAULT_ALGOLIA_AGENTS=["insights-js ("+version+")","insights-js-browser-cjs ("+version+")"];function addAlgoliaAgent(e){-1===this._ua.indexOf(e)&&this._ua.push(e)}var SUPPORTED_REGIONS=["de","us"],MONTH=2592e6;function init(e){var t;if(!e)throw new Error("Init function should be called with an object argument containing your apiKey and appId");if(isUndefined(e.apiKey)||!isString(e.apiKey))throw new Error("apiKey is missing, please provide it so we can authenticate the application");if(isUndefined(e.appId)||!isString(e.appId))throw new Error("appId is missing, please provide it, so we can properly attribute data to your application");if(!isUndefined(e.region)&&-1===SUPPORTED_REGIONS.indexOf(e.region))throw new Error("optional region is incorrect, please provide either one of: "+SUPPORTED_REGIONS.join(", ")+".");if(!(isUndefined(e.cookieDuration)||isNumber(e.cookieDuration)&&isFinite(e.cookieDuration)&&Math.floor(e.cookieDuration)===e.cookieDuration))throw new Error("optional cookieDuration is incorrect, expected an integer."); false&&0,this._apiKey=e.apiKey,this._appId=e.appId,this._userHasOptedOut=!!e.userHasOptedOut,this._region=e.region,this._endpointOrigin=e.region?"https://insights."+e.region+".algolia.io":"https://insights.algolia.io",this._useCookie=null!==(t=e.useCookie)&&void 0!==t&&t,this._cookieDuration=e.cookieDuration?e.cookieDuration:6*MONTH,this._hasCredentials=!0,this._ua=[].concat(DEFAULT_ALGOLIA_AGENTS),e.userToken?this.setUserToken(e.userToken):this._userToken||this._userHasOptedOut||!this._useCookie||this.setAnonymousUserToken()}function getVersion(e){isFunction(e)&&e(this.version)}function addEventType(e,t){return t.map(function(t){return Object.assign({eventType:e},t)})}function clickedObjectIDsAfterSearch(){for(var e=[],t=arguments.length;t--;)e[t]=arguments[t];return this.sendEvents(addEventType("click",e))}function clickedObjectIDs(){for(var e=[],t=arguments.length;t--;)e[t]=arguments[t];return this.sendEvents(addEventType("click",e))}function clickedFilters(){for(var e=[],t=arguments.length;t--;)e[t]=arguments[t];return this.sendEvents(addEventType("click",e))}function convertedObjectIDsAfterSearch(){for(var e=[],t=arguments.length;t--;)e[t]=arguments[t];return this.sendEvents(addEventType("conversion",e))}function convertedObjectIDs(){for(var e=[],t=arguments.length;t--;)e[t]=arguments[t];return this.sendEvents(addEventType("conversion",e))}function convertedFilters(){for(var e=[],t=arguments.length;t--;)e[t]=arguments[t];return this.sendEvents(addEventType("conversion",e))}function viewedObjectIDs(){for(var e=[],t=arguments.length;t--;)e[t]=arguments[t];return this.sendEvents(addEventType("view",e))}function viewedFilters(){for(var e=[],t=arguments.length;t--;)e[t]=arguments[t];return this.sendEvents(addEventType("view",e))}var createUUID=function(){return"xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g,function(e){var t=16*Math.random()|0;return("x"===e?t:3&t|8).toString(16)})},COOKIE_KEY="_ALGOLIA",setCookie=function(e,t,n){var i=new Date;i.setTime(i.getTime()+n);var o="expires="+i.toUTCString();document.cookie=e+"="+t+";"+o+";path=/"},getCookie=function(e){for(var t=e+"=",n=document.cookie.split(";"),i=0;i<n.length;i++){for(var o=n[i];" "===o.charAt(0);)o=o.substring(1);if(0===o.indexOf(t))return o.substring(t.length,o.length)}return""};function setAnonymousUserToken(){if(supportsCookies()){var e=getCookie(COOKIE_KEY);e&&""!==e&&0===e.indexOf("anonymous-")?this.setUserToken(e):(this.setUserToken("anonymous-"+createUUID()),setCookie(COOKIE_KEY,this._userToken,this._cookieDuration))}}function setUserToken(e){this._userToken=e,isFunction(this._onUserTokenChangeCallback)&&this._onUserTokenChangeCallback(this._userToken)}function getUserToken(e,t){return isFunction(t)&&t(null,this._userToken),this._userToken}function onUserTokenChange(e,t){this._onUserTokenChangeCallback=e,t&&t.immediate&&isFunction(this._onUserTokenChangeCallback)&&this._onUserTokenChangeCallback(this._userToken)}objectKeysPolyfill(),objectAssignPolyfill();var AlgoliaAnalytics=function(e){var t=e.requestFn;this._ua=[],this.version=version,this._hasCredentials=!1,this.sendEvents=makeSendEvents(t).bind(this),this.init=init.bind(this),this.addAlgoliaAgent=addAlgoliaAgent.bind(this),this.setUserToken=setUserToken.bind(this),this.setAnonymousUserToken=setAnonymousUserToken.bind(this),this.getUserToken=getUserToken.bind(this),this.onUserTokenChange=onUserTokenChange.bind(this),this.clickedObjectIDsAfterSearch=clickedObjectIDsAfterSearch.bind(this),this.clickedObjectIDs=clickedObjectIDs.bind(this),this.clickedFilters=clickedFilters.bind(this),this.convertedObjectIDsAfterSearch=convertedObjectIDsAfterSearch.bind(this),this.convertedObjectIDs=convertedObjectIDs.bind(this),this.convertedFilters=convertedFilters.bind(this),this.viewedObjectIDs=viewedObjectIDs.bind(this),this.viewedFilters=viewedFilters.bind(this),this.getVersion=getVersion.bind(this)};function getFunctionalInterface(e){return function(t){for(var n=[],i=arguments.length-1;i-- >0;)n[i]=arguments[i+1];t&&isFunction(e[t])?e[t].apply(e,n):console.warn("The method `"+t+"` doesn't exist.")}}var requestWithSendBeacon=function(e,t){var n=JSON.stringify(t);if(!navigator.sendBeacon(e,n))return requestWithXMLHttpRequest(e,t)},requestWithXMLHttpRequest=function(e,t){var n=JSON.stringify(t),i=new XMLHttpRequest;i.open("POST",e),i.send(n)};function getRequesterForBrowser(){if(supportsSendBeacon())return requestWithSendBeacon;if(supportsXMLHttpRequest())return requestWithXMLHttpRequest;throw new Error("Could not find a supported HTTP request client in this environment.")}function processQueue(e){var t=e.AlgoliaAnalyticsObject;if(t){var n=getFunctionalInterface(this),i=e[t];i.queue=i.queue||[];var o=i.queue;o.forEach(function(e){var t=[].slice.call(e),i=t[0],o=t.slice(1);n.apply(void 0,[i].concat(o))}),o.push=function(e){var t=[].slice.call(e),i=t[0],o=t.slice(1);n.apply(void 0,[i].concat(o))}}}function createInsightsClient(e){return getFunctionalInterface(new AlgoliaAnalytics({requestFn:e}))}var entryBrowserCjs=createInsightsClient(getRequesterForBrowser());exports.AlgoliaAnalytics=AlgoliaAnalytics,exports["default"]=entryBrowserCjs,exports.getFunctionalInterface=getFunctionalInterface,exports.getRequesterForBrowser=getRequesterForBrowser,exports.processQueue=processQueue;


/***/ }),

/***/ 88108:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const aa = __webpack_require__(53918);

module.exports = aa.default;
Object.keys(aa).forEach(key => {
  if (key !== "default") {
    module.exports[key] = aa[key];
  }
});


/***/ }),

/***/ 88661:
/***/ (function(module) {

//

module.exports = function shallowEqual(objA, objB, compare, compareContext) {
  var ret = compare ? compare.call(compareContext, objA, objB) : void 0;

  if (ret !== void 0) {
    return !!ret;
  }

  if (objA === objB) {
    return true;
  }

  if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);

  // Test for A's keys different from B.
  for (var idx = 0; idx < keysA.length; idx++) {
    var key = keysA[idx];

    if (!bHasOwnProperty(key)) {
      return false;
    }

    var valueA = objA[key];
    var valueB = objB[key];

    ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;

    if (ret === false || (ret === void 0 && valueA !== valueB)) {
      return false;
    }
  }

  return true;
};


/***/ }),

/***/ 25203:
/***/ (function(module) {

"use strict";


module.exports = (string, separator) => {
	if (!(typeof string === 'string' && typeof separator === 'string')) {
		throw new TypeError('Expected the arguments to be of type `string`');
	}

	if (separator === '') {
		return [string];
	}

	const separatorIndex = string.indexOf(separator);

	if (separatorIndex === -1) {
		return [string];
	}

	return [
		string.slice(0, separatorIndex),
		string.slice(separatorIndex + separator.length)
	];
};


/***/ }),

/***/ 53676:
/***/ (function(module) {

"use strict";

module.exports = str => encodeURIComponent(str).replace(/[!'()*]/g, x => `%${x.charCodeAt(0).toString(16).toUpperCase()}`);


/***/ }),

/***/ 25711:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "fq": function() { return /* reexport */ es_ifProp; }
});

// UNUSED EXPORTS: ifNotProp, palette, prop, switchProp, theme, withProp

;// CONCATENATED MODULE: ../../.yarn/cache/styled-tools-npm-1.7.2-97a33384f1-00cc179608.zip/node_modules/styled-tools/dist/es/prop.js
/**
 * Returns the value of `props[path]` or `defaultValue`
 * @example
 * import styled from "styled-components";
 * import { prop } from "styled-tools";
 *
 * const Button = styled.button`
 *   color: ${prop("color", "red")};
 * `;
 */
var prop = function prop(path, defaultValue) {
  return function () {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    if (typeof props[path] !== "undefined") {
      return props[path];
    }

    if (path && path.indexOf(".") > 0) {
      var paths = path.split(".");
      var length = paths.length;
      var object = props[paths[0]];
      var index = 1;

      while (object != null && index < length) {
        object = object[paths[index]];
        index += 1;
      }

      if (typeof object !== "undefined") {
        return object;
      }
    }

    return defaultValue;
  };
};

/* harmony default export */ var es_prop = (prop);
;// CONCATENATED MODULE: ../../.yarn/cache/styled-tools-npm-1.7.2-97a33384f1-00cc179608.zip/node_modules/styled-tools/dist/es/ifProp.js
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

/* eslint-disable no-use-before-define */


var parseFunction = function parseFunction(props, test) {
  return Boolean(test(props));
};

var parseObject = function parseObject(props, test) {
  var keys = Object.keys(test);
  var length = keys.length;

  for (var index = 0; index < length; index += 1) {
    var key = keys[index];
    var expected = test[key];
    var value = es_prop(key)(props);

    if (expected !== value) {
      return false;
    }
  }

  return true;
};

var parseString = function parseString(props, test) {
  return Boolean(es_prop(test)(props));
};

var parseMap = {
  function: parseFunction,
  object: parseObject,
  string: parseString
};
/**
 * Returns `pass` if prop is truthy. Otherwise returns `fail`
 * @example
 * import styled from "styled-components";
 * import { ifProp, palette } from "styled-tools";
 *
 * const Button = styled.button`
 *   background-color: ${ifProp("transparent", "transparent", palette(0))};
 *   color: ${ifProp(["transparent", "accent"], palette("secondary"))};
 *   font-size: ${ifProp({ size: "large" }, "20px", ifProp({ size: "medium" }, "16px", "12px"))};
 * `;
 */

var ifProp_ifProp = function ifProp(test) {
  var pass = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
  var fail = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "";
  return function () {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var result = true;

    if (Array.isArray(test)) {
      var length = test.length;
      var index = 0;

      while (result && index < length) {
        result = parseMap[_typeof(test[index])](props, test[index]);
        index += 1;
      }
    } else {
      result = parseMap[_typeof(test)](props, test);
    }

    var value = result ? pass : fail;
    return typeof value === "function" ? value(props) : value;
  };
};

/* harmony default export */ var es_ifProp = (ifProp_ifProp);
;// CONCATENATED MODULE: ../../.yarn/cache/styled-tools-npm-1.7.2-97a33384f1-00cc179608.zip/node_modules/styled-tools/dist/es/ifNotProp.js


/**
 * Returns `pass` if prop is falsy. Otherwise returns `fail`
 * @example
 * import styled from "styled-components";
 * import { ifNotProp } from "styled-tools";
 *
 * const Button = styled.button`
 *   font-size: ${ifNotProp("large", "20px", "30px")};
 * `;
 */
var ifNotProp = function ifNotProp(test, pass, fail) {
  return ifProp(test, fail, pass);
};

/* harmony default export */ var es_ifNotProp = ((/* unused pure expression or super */ null && (ifNotProp)));
;// CONCATENATED MODULE: ../../.yarn/cache/styled-tools-npm-1.7.2-97a33384f1-00cc179608.zip/node_modules/styled-tools/dist/es/index.js















/***/ }),

/***/ 91951:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
var isProduction = "production" === 'production';
function warning(condition, message) {
  if (!isProduction) {
    if (condition) {
      return;
    }

    var text = "Warning: " + message;

    if (typeof console !== 'undefined') {
      console.warn(text);
    }

    try {
      throw Error(text);
    } catch (x) {}
  }
}

/* harmony default export */ __webpack_exports__["default"] = (warning);


/***/ }),

/***/ 20059:
/***/ (function(module) {


/**
 * Topological sorting function
 *
 * @param {Array} edges
 * @returns {Array}
 */

module.exports = function(edges) {
  return toposort(uniqueNodes(edges), edges)
}

module.exports.array = toposort

function toposort(nodes, edges) {
  var cursor = nodes.length
    , sorted = new Array(cursor)
    , visited = {}
    , i = cursor
    // Better data structures make algorithm much faster.
    , outgoingEdges = makeOutgoingEdges(edges)
    , nodesHash = makeNodesHash(nodes)

  // check for unknown nodes
  edges.forEach(function(edge) {
    if (!nodesHash.has(edge[0]) || !nodesHash.has(edge[1])) {
      throw new Error('Unknown node. There is an unknown node in the supplied edges.')
    }
  })

  while (i--) {
    if (!visited[i]) visit(nodes[i], i, new Set())
  }

  return sorted

  function visit(node, i, predecessors) {
    if(predecessors.has(node)) {
      var nodeRep
      try {
        nodeRep = ", node was:" + JSON.stringify(node)
      } catch(e) {
        nodeRep = ""
      }
      throw new Error('Cyclic dependency' + nodeRep)
    }

    if (!nodesHash.has(node)) {
      throw new Error('Found unknown node. Make sure to provided all involved nodes. Unknown node: '+JSON.stringify(node))
    }

    if (visited[i]) return;
    visited[i] = true

    var outgoing = outgoingEdges.get(node) || new Set()
    outgoing = Array.from(outgoing)

    if (i = outgoing.length) {
      predecessors.add(node)
      do {
        var child = outgoing[--i]
        visit(child, nodesHash.get(child), predecessors)
      } while (i)
      predecessors.delete(node)
    }

    sorted[--cursor] = node
  }
}

function uniqueNodes(arr){
  var res = new Set()
  for (var i = 0, len = arr.length; i < len; i++) {
    var edge = arr[i]
    res.add(edge[0])
    res.add(edge[1])
  }
  return Array.from(res)
}

function makeOutgoingEdges(arr){
  var edges = new Map()
  for (var i = 0, len = arr.length; i < len; i++) {
    var edge = arr[i]
    if (!edges.has(edge[0])) edges.set(edge[0], new Set())
    if (!edges.has(edge[1])) edges.set(edge[1], new Set())
    edges.get(edge[0]).add(edge[1])
  }
  return edges
}

function makeNodesHash(arr){
  var res = new Map()
  for (var i = 0, len = arr.length; i < len; i++) {
    res.set(arr[i], i)
  }
  return res
}


/***/ }),

/***/ 99290:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Jh": function() { return /* binding */ __generator; },
/* harmony export */   "ZT": function() { return /* binding */ __extends; },
/* harmony export */   "_T": function() { return /* binding */ __rest; },
/* harmony export */   "ev": function() { return /* binding */ __spreadArray; },
/* harmony export */   "mG": function() { return /* binding */ __awaiter; },
/* harmony export */   "pi": function() { return /* binding */ __assign; }
/* harmony export */ });
/* unused harmony exports __decorate, __param, __metadata, __createBinding, __exportStar, __values, __read, __spread, __spreadArrays, __await, __asyncGenerator, __asyncDelegator, __asyncValues, __makeTemplateObject, __importStar, __importDefault, __classPrivateFieldGet, __classPrivateFieldSet, __classPrivateFieldIn */
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    if (typeof b !== "function" && b !== null)
        throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    }
    return __assign.apply(this, arguments);
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

var __createBinding = Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});

function __exportStar(m, o) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) __createBinding(o, m, p);
}

function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

/** @deprecated */
function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

/** @deprecated */
function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
}

function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

var __setModuleDefault = Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}

function __classPrivateFieldGet(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}

function __classPrivateFieldSet(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
}

function __classPrivateFieldIn(state, receiver) {
    if (receiver === null || (typeof receiver !== "object" && typeof receiver !== "function")) throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}


/***/ }),

/***/ 54106:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ esm_browser_v4; }
});

;// CONCATENATED MODULE: ../../.yarn/cache/uuid-npm-9.0.0-46c41e3e43-8dd2c83c43.zip/node_modules/uuid/dist/esm-browser/native.js
const randomUUID = typeof crypto !== 'undefined' && crypto.randomUUID && crypto.randomUUID.bind(crypto);
/* harmony default export */ var esm_browser_native = ({
  randomUUID
});
;// CONCATENATED MODULE: ../../.yarn/cache/uuid-npm-9.0.0-46c41e3e43-8dd2c83c43.zip/node_modules/uuid/dist/esm-browser/rng.js
// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
let getRandomValues;
const rnds8 = new Uint8Array(16);
function rng() {
  // lazy load so that environments that need to polyfill have a chance to do so
  if (!getRandomValues) {
    // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation.
    getRandomValues = typeof crypto !== 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto);

    if (!getRandomValues) {
      throw new Error('crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported');
    }
  }

  return getRandomValues(rnds8);
}
;// CONCATENATED MODULE: ../../.yarn/cache/uuid-npm-9.0.0-46c41e3e43-8dd2c83c43.zip/node_modules/uuid/dist/esm-browser/stringify.js

/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */

const byteToHex = [];

for (let i = 0; i < 256; ++i) {
  byteToHex.push((i + 0x100).toString(16).slice(1));
}

function unsafeStringify(arr, offset = 0) {
  // Note: Be careful editing this code!  It's been tuned for performance
  // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
  return (byteToHex[arr[offset + 0]] + byteToHex[arr[offset + 1]] + byteToHex[arr[offset + 2]] + byteToHex[arr[offset + 3]] + '-' + byteToHex[arr[offset + 4]] + byteToHex[arr[offset + 5]] + '-' + byteToHex[arr[offset + 6]] + byteToHex[arr[offset + 7]] + '-' + byteToHex[arr[offset + 8]] + byteToHex[arr[offset + 9]] + '-' + byteToHex[arr[offset + 10]] + byteToHex[arr[offset + 11]] + byteToHex[arr[offset + 12]] + byteToHex[arr[offset + 13]] + byteToHex[arr[offset + 14]] + byteToHex[arr[offset + 15]]).toLowerCase();
}

function stringify(arr, offset = 0) {
  const uuid = unsafeStringify(arr, offset); // Consistency check for valid UUID.  If this throws, it's likely due to one
  // of the following:
  // - One or more input array values don't map to a hex octet (leading to
  // "undefined" in the uuid)
  // - Invalid input values for the RFC `version` or `variant` fields

  if (!validate(uuid)) {
    throw TypeError('Stringified UUID is invalid');
  }

  return uuid;
}

/* harmony default export */ var esm_browser_stringify = ((/* unused pure expression or super */ null && (stringify)));
;// CONCATENATED MODULE: ../../.yarn/cache/uuid-npm-9.0.0-46c41e3e43-8dd2c83c43.zip/node_modules/uuid/dist/esm-browser/v4.js




function v4(options, buf, offset) {
  if (esm_browser_native.randomUUID && !buf && !options) {
    return esm_browser_native.randomUUID();
  }

  options = options || {};
  const rnds = options.random || (options.rng || rng)(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`

  rnds[6] = rnds[6] & 0x0f | 0x40;
  rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided

  if (buf) {
    offset = offset || 0;

    for (let i = 0; i < 16; ++i) {
      buf[offset + i] = rnds[i];
    }

    return buf;
  }

  return unsafeStringify(rnds);
}

/* harmony default export */ var esm_browser_v4 = (v4);

/***/ }),

/***/ 7007:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Xg": function() { return /* reexport */ boolean_create; },
  "O7": function() { return /* reexport */ boolean_create; },
  "Ry": function() { return /* reexport */ object_create; },
  "Z_": function() { return /* reexport */ string_create; }
});

// UNUSED EXPORTS: ArraySchema, BaseSchema, BooleanSchema, DateSchema, MixedSchema, NumberSchema, ObjectSchema, StringSchema, ValidationError, addMethod, array, date, isSchema, lazy, mixed, number, reach, ref, setLocale

;// CONCATENATED MODULE: ../../.yarn/cache/nanoclone-npm-0.2.1-972ee958a0-96b2954e22.zip/node_modules/nanoclone/src/index.js
// ES6 Map
var map
try {
  map = Map
} catch (_) { }
var set

// ES6 Set
try {
  set = Set
} catch (_) { }

function baseClone (src, circulars, clones) {
  // Null/undefined/functions/etc
  if (!src || typeof src !== 'object' || typeof src === 'function') {
    return src
  }

  // DOM Node
  if (src.nodeType && 'cloneNode' in src) {
    return src.cloneNode(true)
  }

  // Date
  if (src instanceof Date) {
    return new Date(src.getTime())
  }

  // RegExp
  if (src instanceof RegExp) {
    return new RegExp(src)
  }

  // Arrays
  if (Array.isArray(src)) {
    return src.map(clone)
  }

  // ES6 Maps
  if (map && src instanceof map) {
    return new Map(Array.from(src.entries()))
  }

  // ES6 Sets
  if (set && src instanceof set) {
    return new Set(Array.from(src.values()))
  }

  // Object
  if (src instanceof Object) {
    circulars.push(src)
    var obj = Object.create(src)
    clones.push(obj)
    for (var key in src) {
      var idx = circulars.findIndex(function (i) {
        return i === src[key]
      })
      obj[key] = idx > -1 ? clones[idx] : baseClone(src[key], circulars, clones)
    }
    return obj
  }

  // ???
  return src
}

function clone (src) {
  return baseClone(src, [], [])
}

;// CONCATENATED MODULE: ../../.yarn/cache/yup-npm-0.32.11-dbaff8ca9c-43a16786b4.zip/node_modules/yup/es/util/printValue.js
const printValue_toString = Object.prototype.toString;
const errorToString = Error.prototype.toString;
const regExpToString = RegExp.prototype.toString;
const symbolToString = typeof Symbol !== 'undefined' ? Symbol.prototype.toString : () => '';
const SYMBOL_REGEXP = /^Symbol\((.*)\)(.*)$/;

function printNumber(val) {
  if (val != +val) return 'NaN';
  const isNegativeZero = val === 0 && 1 / val < 0;
  return isNegativeZero ? '-0' : '' + val;
}

function printSimpleValue(val, quoteStrings = false) {
  if (val == null || val === true || val === false) return '' + val;
  const typeOf = typeof val;
  if (typeOf === 'number') return printNumber(val);
  if (typeOf === 'string') return quoteStrings ? `"${val}"` : val;
  if (typeOf === 'function') return '[Function ' + (val.name || 'anonymous') + ']';
  if (typeOf === 'symbol') return symbolToString.call(val).replace(SYMBOL_REGEXP, 'Symbol($1)');
  const tag = printValue_toString.call(val).slice(8, -1);
  if (tag === 'Date') return isNaN(val.getTime()) ? '' + val : val.toISOString(val);
  if (tag === 'Error' || val instanceof Error) return '[' + errorToString.call(val) + ']';
  if (tag === 'RegExp') return regExpToString.call(val);
  return null;
}

function printValue(value, quoteStrings) {
  let result = printSimpleValue(value, quoteStrings);
  if (result !== null) return result;
  return JSON.stringify(value, function (key, value) {
    let result = printSimpleValue(this[key], quoteStrings);
    if (result !== null) return result;
    return value;
  }, 2);
}
;// CONCATENATED MODULE: ../../.yarn/cache/yup-npm-0.32.11-dbaff8ca9c-43a16786b4.zip/node_modules/yup/es/locale.js

let mixed = {
  default: '${path} is invalid',
  required: '${path} is a required field',
  oneOf: '${path} must be one of the following values: ${values}',
  notOneOf: '${path} must not be one of the following values: ${values}',
  notType: ({
    path,
    type,
    value,
    originalValue
  }) => {
    let isCast = originalValue != null && originalValue !== value;
    let msg = `${path} must be a \`${type}\` type, ` + `but the final value was: \`${printValue(value, true)}\`` + (isCast ? ` (cast from the value \`${printValue(originalValue, true)}\`).` : '.');

    if (value === null) {
      msg += `\n If "null" is intended as an empty value be sure to mark the schema as \`.nullable()\``;
    }

    return msg;
  },
  defined: '${path} must be defined'
};
let string = {
  length: '${path} must be exactly ${length} characters',
  min: '${path} must be at least ${min} characters',
  max: '${path} must be at most ${max} characters',
  matches: '${path} must match the following: "${regex}"',
  email: '${path} must be a valid email',
  url: '${path} must be a valid URL',
  uuid: '${path} must be a valid UUID',
  trim: '${path} must be a trimmed string',
  lowercase: '${path} must be a lowercase string',
  uppercase: '${path} must be a upper case string'
};
let number = {
  min: '${path} must be greater than or equal to ${min}',
  max: '${path} must be less than or equal to ${max}',
  lessThan: '${path} must be less than ${less}',
  moreThan: '${path} must be greater than ${more}',
  positive: '${path} must be a positive number',
  negative: '${path} must be a negative number',
  integer: '${path} must be an integer'
};
let date = {
  min: '${path} field must be later than ${min}',
  max: '${path} field must be at earlier than ${max}'
};
let locale_boolean = {
  isValue: '${path} field must be ${value}'
};
let object = {
  noUnknown: '${path} field has unspecified keys: ${unknown}'
};
let array = {
  min: '${path} field must have at least ${min} items',
  max: '${path} field must have less than or equal to ${max} items',
  length: '${path} must have ${length} items'
};
/* harmony default export */ var es_locale = (Object.assign(Object.create(null), {
  mixed,
  string,
  number,
  date,
  object,
  array,
  boolean: locale_boolean
}));
// EXTERNAL MODULE: ../../.yarn/cache/lodash-npm-4.17.21-6382451519-eb835a2e51.zip/node_modules/lodash/has.js
var has = __webpack_require__(22656);
var has_default = /*#__PURE__*/__webpack_require__.n(has);
;// CONCATENATED MODULE: ../../.yarn/cache/yup-npm-0.32.11-dbaff8ca9c-43a16786b4.zip/node_modules/yup/es/util/isSchema.js
const isSchema_isSchema = obj => obj && obj.__isYupSchema__;

/* harmony default export */ var util_isSchema = (isSchema_isSchema);
;// CONCATENATED MODULE: ../../.yarn/cache/yup-npm-0.32.11-dbaff8ca9c-43a16786b4.zip/node_modules/yup/es/Condition.js



class Condition {
  constructor(refs, options) {
    this.fn = void 0;
    this.refs = refs;
    this.refs = refs;

    if (typeof options === 'function') {
      this.fn = options;
      return;
    }

    if (!has_default()(options, 'is')) throw new TypeError('`is:` is required for `when()` conditions');
    if (!options.then && !options.otherwise) throw new TypeError('either `then:` or `otherwise:` is required for `when()` conditions');
    let {
      is,
      then,
      otherwise
    } = options;
    let check = typeof is === 'function' ? is : (...values) => values.every(value => value === is);

    this.fn = function (...args) {
      let options = args.pop();
      let schema = args.pop();
      let branch = check(...args) ? then : otherwise;
      if (!branch) return undefined;
      if (typeof branch === 'function') return branch(schema);
      return schema.concat(branch.resolve(options));
    };
  }

  resolve(base, options) {
    let values = this.refs.map(ref => ref.getValue(options == null ? void 0 : options.value, options == null ? void 0 : options.parent, options == null ? void 0 : options.context));
    let schema = this.fn.apply(base, values.concat(base, options));
    if (schema === undefined || schema === base) return base;
    if (!util_isSchema(schema)) throw new TypeError('conditions must return a schema object');
    return schema.resolve(options);
  }

}

/* harmony default export */ var es_Condition = (Condition);
;// CONCATENATED MODULE: ../../.yarn/cache/yup-npm-0.32.11-dbaff8ca9c-43a16786b4.zip/node_modules/yup/es/util/toArray.js
function toArray(value) {
  return value == null ? [] : [].concat(value);
}
;// CONCATENATED MODULE: ../../.yarn/cache/yup-npm-0.32.11-dbaff8ca9c-43a16786b4.zip/node_modules/yup/es/ValidationError.js
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



let strReg = /\$\{\s*(\w+)\s*\}/g;
class ValidationError extends Error {
  static formatError(message, params) {
    const path = params.label || params.path || 'this';
    if (path !== params.path) params = _extends({}, params, {
      path
    });
    if (typeof message === 'string') return message.replace(strReg, (_, key) => printValue(params[key]));
    if (typeof message === 'function') return message(params);
    return message;
  }

  static isError(err) {
    return err && err.name === 'ValidationError';
  }

  constructor(errorOrErrors, value, field, type) {
    super();
    this.value = void 0;
    this.path = void 0;
    this.type = void 0;
    this.errors = void 0;
    this.params = void 0;
    this.inner = void 0;
    this.name = 'ValidationError';
    this.value = value;
    this.path = field;
    this.type = type;
    this.errors = [];
    this.inner = [];
    toArray(errorOrErrors).forEach(err => {
      if (ValidationError.isError(err)) {
        this.errors.push(...err.errors);
        this.inner = this.inner.concat(err.inner.length ? err.inner : err);
      } else {
        this.errors.push(err);
      }
    });
    this.message = this.errors.length > 1 ? `${this.errors.length} errors occurred` : this.errors[0];
    if (Error.captureStackTrace) Error.captureStackTrace(this, ValidationError);
  }

}
;// CONCATENATED MODULE: ../../.yarn/cache/yup-npm-0.32.11-dbaff8ca9c-43a16786b4.zip/node_modules/yup/es/util/runTests.js


const once = cb => {
  let fired = false;
  return (...args) => {
    if (fired) return;
    fired = true;
    cb(...args);
  };
};

function runTests(options, cb) {
  let {
    endEarly,
    tests,
    args,
    value,
    errors,
    sort,
    path
  } = options;
  let callback = once(cb);
  let count = tests.length;
  const nestedErrors = [];
  errors = errors ? errors : [];
  if (!count) return errors.length ? callback(new ValidationError(errors, value, path)) : callback(null, value);

  for (let i = 0; i < tests.length; i++) {
    const test = tests[i];
    test(args, function finishTestRun(err) {
      if (err) {
        // always return early for non validation errors
        if (!ValidationError.isError(err)) {
          return callback(err, value);
        }

        if (endEarly) {
          err.value = value;
          return callback(err, value);
        }

        nestedErrors.push(err);
      }

      if (--count <= 0) {
        if (nestedErrors.length) {
          if (sort) nestedErrors.sort(sort); //show parent errors after the nested ones: name.first, name

          if (errors.length) nestedErrors.push(...errors);
          errors = nestedErrors;
        }

        if (errors.length) {
          callback(new ValidationError(errors, value, path), value);
          return;
        }

        callback(null, value);
      }
    });
  }
}
// EXTERNAL MODULE: ../../.yarn/cache/lodash-npm-4.17.21-6382451519-eb835a2e51.zip/node_modules/lodash/mapValues.js
var mapValues = __webpack_require__(18781);
var mapValues_default = /*#__PURE__*/__webpack_require__.n(mapValues);
// EXTERNAL MODULE: ../../.yarn/cache/property-expr-npm-2.0.5-6f6bda4c65-4ebe82ce45.zip/node_modules/property-expr/index.js
var property_expr = __webpack_require__(83212);
;// CONCATENATED MODULE: ../../.yarn/cache/yup-npm-0.32.11-dbaff8ca9c-43a16786b4.zip/node_modules/yup/es/Reference.js

const prefixes = {
  context: '$',
  value: '.'
};
function create(key, options) {
  return new Reference(key, options);
}
class Reference {
  constructor(key, options = {}) {
    this.key = void 0;
    this.isContext = void 0;
    this.isValue = void 0;
    this.isSibling = void 0;
    this.path = void 0;
    this.getter = void 0;
    this.map = void 0;
    if (typeof key !== 'string') throw new TypeError('ref must be a string, got: ' + key);
    this.key = key.trim();
    if (key === '') throw new TypeError('ref must be a non-empty string');
    this.isContext = this.key[0] === prefixes.context;
    this.isValue = this.key[0] === prefixes.value;
    this.isSibling = !this.isContext && !this.isValue;
    let prefix = this.isContext ? prefixes.context : this.isValue ? prefixes.value : '';
    this.path = this.key.slice(prefix.length);
    this.getter = this.path && (0,property_expr.getter)(this.path, true);
    this.map = options.map;
  }

  getValue(value, parent, context) {
    let result = this.isContext ? context : this.isValue ? value : parent;
    if (this.getter) result = this.getter(result || {});
    if (this.map) result = this.map(result);
    return result;
  }
  /**
   *
   * @param {*} value
   * @param {Object} options
   * @param {Object=} options.context
   * @param {Object=} options.parent
   */


  cast(value, options) {
    return this.getValue(value, options == null ? void 0 : options.parent, options == null ? void 0 : options.context);
  }

  resolve() {
    return this;
  }

  describe() {
    return {
      type: 'ref',
      key: this.key
    };
  }

  toString() {
    return `Ref(${this.key})`;
  }

  static isRef(value) {
    return value && value.__isYupRef;
  }

} // @ts-ignore

Reference.prototype.__isYupRef = true;
;// CONCATENATED MODULE: ../../.yarn/cache/yup-npm-0.32.11-dbaff8ca9c-43a16786b4.zip/node_modules/yup/es/util/createValidation.js
function createValidation_extends() { createValidation_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return createValidation_extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }




function createValidation(config) {
  function validate(_ref, cb) {
    let {
      value,
      path = '',
      label,
      options,
      originalValue,
      sync
    } = _ref,
        rest = _objectWithoutPropertiesLoose(_ref, ["value", "path", "label", "options", "originalValue", "sync"]);

    const {
      name,
      test,
      params,
      message
    } = config;
    let {
      parent,
      context
    } = options;

    function resolve(item) {
      return Reference.isRef(item) ? item.getValue(value, parent, context) : item;
    }

    function createError(overrides = {}) {
      const nextParams = mapValues_default()(createValidation_extends({
        value,
        originalValue,
        label,
        path: overrides.path || path
      }, params, overrides.params), resolve);
      const error = new ValidationError(ValidationError.formatError(overrides.message || message, nextParams), value, nextParams.path, overrides.type || name);
      error.params = nextParams;
      return error;
    }

    let ctx = createValidation_extends({
      path,
      parent,
      type: name,
      createError,
      resolve,
      options,
      originalValue
    }, rest);

    if (!sync) {
      try {
        Promise.resolve(test.call(ctx, value, ctx)).then(validOrError => {
          if (ValidationError.isError(validOrError)) cb(validOrError);else if (!validOrError) cb(createError());else cb(null, validOrError);
        }).catch(cb);
      } catch (err) {
        cb(err);
      }

      return;
    }

    let result;

    try {
      var _ref2;

      result = test.call(ctx, value, ctx);

      if (typeof ((_ref2 = result) == null ? void 0 : _ref2.then) === 'function') {
        throw new Error(`Validation test of type: "${ctx.type}" returned a Promise during a synchronous validate. ` + `This test will finish after the validate call has returned`);
      }
    } catch (err) {
      cb(err);
      return;
    }

    if (ValidationError.isError(result)) cb(result);else if (!result) cb(createError());else cb(null, result);
  }

  validate.OPTIONS = config;
  return validate;
}
;// CONCATENATED MODULE: ../../.yarn/cache/yup-npm-0.32.11-dbaff8ca9c-43a16786b4.zip/node_modules/yup/es/util/reach.js


let trim = part => part.substr(0, part.length - 1).substr(1);

function getIn(schema, path, value, context = value) {
  let parent, lastPart, lastPartDebug; // root path: ''

  if (!path) return {
    parent,
    parentPath: path,
    schema
  };
  (0,property_expr.forEach)(path, (_part, isBracket, isArray) => {
    let part = isBracket ? trim(_part) : _part;
    schema = schema.resolve({
      context,
      parent,
      value
    });

    if (schema.innerType) {
      let idx = isArray ? parseInt(part, 10) : 0;

      if (value && idx >= value.length) {
        throw new Error(`Yup.reach cannot resolve an array item at index: ${_part}, in the path: ${path}. ` + `because there is no value at that index. `);
      }

      parent = value;
      value = value && value[idx];
      schema = schema.innerType;
    } // sometimes the array index part of a path doesn't exist: "nested.arr.child"
    // in these cases the current part is the next schema and should be processed
    // in this iteration. For cases where the index signature is included this
    // check will fail and we'll handle the `child` part on the next iteration like normal


    if (!isArray) {
      if (!schema.fields || !schema.fields[part]) throw new Error(`The schema does not contain the path: ${path}. ` + `(failed at: ${lastPartDebug} which is a type: "${schema._type}")`);
      parent = value;
      value = value && value[part];
      schema = schema.fields[part];
    }

    lastPart = part;
    lastPartDebug = isBracket ? '[' + _part + ']' : '.' + _part;
  });
  return {
    schema,
    parent,
    parentPath: lastPart
  };
}

const reach = (obj, path, value, context) => getIn(obj, path, value, context).schema;

/* harmony default export */ var util_reach = ((/* unused pure expression or super */ null && (reach)));
;// CONCATENATED MODULE: ../../.yarn/cache/yup-npm-0.32.11-dbaff8ca9c-43a16786b4.zip/node_modules/yup/es/util/ReferenceSet.js

class ReferenceSet {
  constructor() {
    this.list = void 0;
    this.refs = void 0;
    this.list = new Set();
    this.refs = new Map();
  }

  get size() {
    return this.list.size + this.refs.size;
  }

  describe() {
    const description = [];

    for (const item of this.list) description.push(item);

    for (const [, ref] of this.refs) description.push(ref.describe());

    return description;
  }

  toArray() {
    return Array.from(this.list).concat(Array.from(this.refs.values()));
  }

  resolveAll(resolve) {
    return this.toArray().reduce((acc, e) => acc.concat(Reference.isRef(e) ? resolve(e) : e), []);
  }

  add(value) {
    Reference.isRef(value) ? this.refs.set(value.key, value) : this.list.add(value);
  }

  delete(value) {
    Reference.isRef(value) ? this.refs.delete(value.key) : this.list.delete(value);
  }

  clone() {
    const next = new ReferenceSet();
    next.list = new Set(this.list);
    next.refs = new Map(this.refs);
    return next;
  }

  merge(newItems, removeItems) {
    const next = this.clone();
    newItems.list.forEach(value => next.add(value));
    newItems.refs.forEach(value => next.add(value));
    removeItems.list.forEach(value => next.delete(value));
    removeItems.refs.forEach(value => next.delete(value));
    return next;
  }

}
;// CONCATENATED MODULE: ../../.yarn/cache/yup-npm-0.32.11-dbaff8ca9c-43a16786b4.zip/node_modules/yup/es/schema.js
function schema_extends() { schema_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return schema_extends.apply(this, arguments); }

// @ts-ignore










 // const UNSET = 'unset' as const;

class BaseSchema {
  constructor(options) {
    this.deps = [];
    this.tests = void 0;
    this.transforms = void 0;
    this.conditions = [];
    this._mutate = void 0;
    this._typeError = void 0;
    this._whitelist = new ReferenceSet();
    this._blacklist = new ReferenceSet();
    this.exclusiveTests = Object.create(null);
    this.spec = void 0;
    this.tests = [];
    this.transforms = [];
    this.withMutation(() => {
      this.typeError(mixed.notType);
    });
    this.type = (options == null ? void 0 : options.type) || 'mixed';
    this.spec = schema_extends({
      strip: false,
      strict: false,
      abortEarly: true,
      recursive: true,
      nullable: false,
      presence: 'optional'
    }, options == null ? void 0 : options.spec);
  } // TODO: remove


  get _type() {
    return this.type;
  }

  _typeCheck(_value) {
    return true;
  }

  clone(spec) {
    if (this._mutate) {
      if (spec) Object.assign(this.spec, spec);
      return this;
    } // if the nested value is a schema we can skip cloning, since
    // they are already immutable


    const next = Object.create(Object.getPrototypeOf(this)); // @ts-expect-error this is readonly

    next.type = this.type;
    next._typeError = this._typeError;
    next._whitelistError = this._whitelistError;
    next._blacklistError = this._blacklistError;
    next._whitelist = this._whitelist.clone();
    next._blacklist = this._blacklist.clone();
    next.exclusiveTests = schema_extends({}, this.exclusiveTests); // @ts-expect-error this is readonly

    next.deps = [...this.deps];
    next.conditions = [...this.conditions];
    next.tests = [...this.tests];
    next.transforms = [...this.transforms];
    next.spec = clone(schema_extends({}, this.spec, spec));
    return next;
  }

  label(label) {
    let next = this.clone();
    next.spec.label = label;
    return next;
  }

  meta(...args) {
    if (args.length === 0) return this.spec.meta;
    let next = this.clone();
    next.spec.meta = Object.assign(next.spec.meta || {}, args[0]);
    return next;
  } // withContext<TContext extends AnyObject>(): BaseSchema<
  //   TCast,
  //   TContext,
  //   TOutput
  // > {
  //   return this as any;
  // }


  withMutation(fn) {
    let before = this._mutate;
    this._mutate = true;
    let result = fn(this);
    this._mutate = before;
    return result;
  }

  concat(schema) {
    if (!schema || schema === this) return this;
    if (schema.type !== this.type && this.type !== 'mixed') throw new TypeError(`You cannot \`concat()\` schema's of different types: ${this.type} and ${schema.type}`);
    let base = this;
    let combined = schema.clone();

    const mergedSpec = schema_extends({}, base.spec, combined.spec); // if (combined.spec.nullable === UNSET)
    //   mergedSpec.nullable = base.spec.nullable;
    // if (combined.spec.presence === UNSET)
    //   mergedSpec.presence = base.spec.presence;


    combined.spec = mergedSpec;
    combined._typeError || (combined._typeError = base._typeError);
    combined._whitelistError || (combined._whitelistError = base._whitelistError);
    combined._blacklistError || (combined._blacklistError = base._blacklistError); // manually merge the blacklist/whitelist (the other `schema` takes
    // precedence in case of conflicts)

    combined._whitelist = base._whitelist.merge(schema._whitelist, schema._blacklist);
    combined._blacklist = base._blacklist.merge(schema._blacklist, schema._whitelist); // start with the current tests

    combined.tests = base.tests;
    combined.exclusiveTests = base.exclusiveTests; // manually add the new tests to ensure
    // the deduping logic is consistent

    combined.withMutation(next => {
      schema.tests.forEach(fn => {
        next.test(fn.OPTIONS);
      });
    });
    combined.transforms = [...base.transforms, ...combined.transforms];
    return combined;
  }

  isType(v) {
    if (this.spec.nullable && v === null) return true;
    return this._typeCheck(v);
  }

  resolve(options) {
    let schema = this;

    if (schema.conditions.length) {
      let conditions = schema.conditions;
      schema = schema.clone();
      schema.conditions = [];
      schema = conditions.reduce((schema, condition) => condition.resolve(schema, options), schema);
      schema = schema.resolve(options);
    }

    return schema;
  }
  /**
   *
   * @param {*} value
   * @param {Object} options
   * @param {*=} options.parent
   * @param {*=} options.context
   */


  cast(value, options = {}) {
    let resolvedSchema = this.resolve(schema_extends({
      value
    }, options));

    let result = resolvedSchema._cast(value, options);

    if (value !== undefined && options.assert !== false && resolvedSchema.isType(result) !== true) {
      let formattedValue = printValue(value);
      let formattedResult = printValue(result);
      throw new TypeError(`The value of ${options.path || 'field'} could not be cast to a value ` + `that satisfies the schema type: "${resolvedSchema._type}". \n\n` + `attempted value: ${formattedValue} \n` + (formattedResult !== formattedValue ? `result of cast: ${formattedResult}` : ''));
    }

    return result;
  }

  _cast(rawValue, _options) {
    let value = rawValue === undefined ? rawValue : this.transforms.reduce((value, fn) => fn.call(this, value, rawValue, this), rawValue);

    if (value === undefined) {
      value = this.getDefault();
    }

    return value;
  }

  _validate(_value, options = {}, cb) {
    let {
      sync,
      path,
      from = [],
      originalValue = _value,
      strict = this.spec.strict,
      abortEarly = this.spec.abortEarly
    } = options;
    let value = _value;

    if (!strict) {
      // this._validating = true;
      value = this._cast(value, schema_extends({
        assert: false
      }, options)); // this._validating = false;
    } // value is cast, we can check if it meets type requirements


    let args = {
      value,
      path,
      options,
      originalValue,
      schema: this,
      label: this.spec.label,
      sync,
      from
    };
    let initialTests = [];
    if (this._typeError) initialTests.push(this._typeError);
    let finalTests = [];
    if (this._whitelistError) finalTests.push(this._whitelistError);
    if (this._blacklistError) finalTests.push(this._blacklistError);
    runTests({
      args,
      value,
      path,
      sync,
      tests: initialTests,
      endEarly: abortEarly
    }, err => {
      if (err) return void cb(err, value);
      runTests({
        tests: this.tests.concat(finalTests),
        args,
        path,
        sync,
        value,
        endEarly: abortEarly
      }, cb);
    });
  }

  validate(value, options, maybeCb) {
    let schema = this.resolve(schema_extends({}, options, {
      value
    })); // callback case is for nested validations

    return typeof maybeCb === 'function' ? schema._validate(value, options, maybeCb) : new Promise((resolve, reject) => schema._validate(value, options, (err, value) => {
      if (err) reject(err);else resolve(value);
    }));
  }

  validateSync(value, options) {
    let schema = this.resolve(schema_extends({}, options, {
      value
    }));
    let result;

    schema._validate(value, schema_extends({}, options, {
      sync: true
    }), (err, value) => {
      if (err) throw err;
      result = value;
    });

    return result;
  }

  isValid(value, options) {
    return this.validate(value, options).then(() => true, err => {
      if (ValidationError.isError(err)) return false;
      throw err;
    });
  }

  isValidSync(value, options) {
    try {
      this.validateSync(value, options);
      return true;
    } catch (err) {
      if (ValidationError.isError(err)) return false;
      throw err;
    }
  }

  _getDefault() {
    let defaultValue = this.spec.default;

    if (defaultValue == null) {
      return defaultValue;
    }

    return typeof defaultValue === 'function' ? defaultValue.call(this) : clone(defaultValue);
  }

  getDefault(options) {
    let schema = this.resolve(options || {});
    return schema._getDefault();
  }

  default(def) {
    if (arguments.length === 0) {
      return this._getDefault();
    }

    let next = this.clone({
      default: def
    });
    return next;
  }

  strict(isStrict = true) {
    let next = this.clone();
    next.spec.strict = isStrict;
    return next;
  }

  _isPresent(value) {
    return value != null;
  }

  defined(message = mixed.defined) {
    return this.test({
      message,
      name: 'defined',
      exclusive: true,

      test(value) {
        return value !== undefined;
      }

    });
  }

  required(message = mixed.required) {
    return this.clone({
      presence: 'required'
    }).withMutation(s => s.test({
      message,
      name: 'required',
      exclusive: true,

      test(value) {
        return this.schema._isPresent(value);
      }

    }));
  }

  notRequired() {
    let next = this.clone({
      presence: 'optional'
    });
    next.tests = next.tests.filter(test => test.OPTIONS.name !== 'required');
    return next;
  }

  nullable(isNullable = true) {
    let next = this.clone({
      nullable: isNullable !== false
    });
    return next;
  }

  transform(fn) {
    let next = this.clone();
    next.transforms.push(fn);
    return next;
  }
  /**
   * Adds a test function to the schema's queue of tests.
   * tests can be exclusive or non-exclusive.
   *
   * - exclusive tests, will replace any existing tests of the same name.
   * - non-exclusive: can be stacked
   *
   * If a non-exclusive test is added to a schema with an exclusive test of the same name
   * the exclusive test is removed and further tests of the same name will be stacked.
   *
   * If an exclusive test is added to a schema with non-exclusive tests of the same name
   * the previous tests are removed and further tests of the same name will replace each other.
   */


  test(...args) {
    let opts;

    if (args.length === 1) {
      if (typeof args[0] === 'function') {
        opts = {
          test: args[0]
        };
      } else {
        opts = args[0];
      }
    } else if (args.length === 2) {
      opts = {
        name: args[0],
        test: args[1]
      };
    } else {
      opts = {
        name: args[0],
        message: args[1],
        test: args[2]
      };
    }

    if (opts.message === undefined) opts.message = mixed["default"];
    if (typeof opts.test !== 'function') throw new TypeError('`test` is a required parameters');
    let next = this.clone();
    let validate = createValidation(opts);
    let isExclusive = opts.exclusive || opts.name && next.exclusiveTests[opts.name] === true;

    if (opts.exclusive) {
      if (!opts.name) throw new TypeError('Exclusive tests must provide a unique `name` identifying the test');
    }

    if (opts.name) next.exclusiveTests[opts.name] = !!opts.exclusive;
    next.tests = next.tests.filter(fn => {
      if (fn.OPTIONS.name === opts.name) {
        if (isExclusive) return false;
        if (fn.OPTIONS.test === validate.OPTIONS.test) return false;
      }

      return true;
    });
    next.tests.push(validate);
    return next;
  }

  when(keys, options) {
    if (!Array.isArray(keys) && typeof keys !== 'string') {
      options = keys;
      keys = '.';
    }

    let next = this.clone();
    let deps = toArray(keys).map(key => new Reference(key));
    deps.forEach(dep => {
      // @ts-ignore
      if (dep.isSibling) next.deps.push(dep.key);
    });
    next.conditions.push(new es_Condition(deps, options));
    return next;
  }

  typeError(message) {
    let next = this.clone();
    next._typeError = createValidation({
      message,
      name: 'typeError',

      test(value) {
        if (value !== undefined && !this.schema.isType(value)) return this.createError({
          params: {
            type: this.schema._type
          }
        });
        return true;
      }

    });
    return next;
  }

  oneOf(enums, message = mixed.oneOf) {
    let next = this.clone();
    enums.forEach(val => {
      next._whitelist.add(val);

      next._blacklist.delete(val);
    });
    next._whitelistError = createValidation({
      message,
      name: 'oneOf',

      test(value) {
        if (value === undefined) return true;
        let valids = this.schema._whitelist;
        let resolved = valids.resolveAll(this.resolve);
        return resolved.includes(value) ? true : this.createError({
          params: {
            values: valids.toArray().join(', '),
            resolved
          }
        });
      }

    });
    return next;
  }

  notOneOf(enums, message = mixed.notOneOf) {
    let next = this.clone();
    enums.forEach(val => {
      next._blacklist.add(val);

      next._whitelist.delete(val);
    });
    next._blacklistError = createValidation({
      message,
      name: 'notOneOf',

      test(value) {
        let invalids = this.schema._blacklist;
        let resolved = invalids.resolveAll(this.resolve);
        if (resolved.includes(value)) return this.createError({
          params: {
            values: invalids.toArray().join(', '),
            resolved
          }
        });
        return true;
      }

    });
    return next;
  }

  strip(strip = true) {
    let next = this.clone();
    next.spec.strip = strip;
    return next;
  }

  describe() {
    const next = this.clone();
    const {
      label,
      meta
    } = next.spec;
    const description = {
      meta,
      label,
      type: next.type,
      oneOf: next._whitelist.describe(),
      notOneOf: next._blacklist.describe(),
      tests: next.tests.map(fn => ({
        name: fn.OPTIONS.name,
        params: fn.OPTIONS.params
      })).filter((n, idx, list) => list.findIndex(c => c.name === n.name) === idx)
    };
    return description;
  }

} // eslint-disable-next-line @typescript-eslint/no-unused-vars

// @ts-expect-error
BaseSchema.prototype.__isYupSchema__ = true;

for (const method of ['validate', 'validateSync']) BaseSchema.prototype[`${method}At`] = function (path, value, options = {}) {
  const {
    parent,
    parentPath,
    schema
  } = getIn(this, path, value, options.context);
  return schema[method](parent && parent[parentPath], schema_extends({}, options, {
    parent,
    path
  }));
};

for (const alias of ['equals', 'is']) BaseSchema.prototype[alias] = BaseSchema.prototype.oneOf;

for (const alias of ['not', 'nope']) BaseSchema.prototype[alias] = BaseSchema.prototype.notOneOf;

BaseSchema.prototype.optional = BaseSchema.prototype.notRequired;
;// CONCATENATED MODULE: ../../.yarn/cache/yup-npm-0.32.11-dbaff8ca9c-43a16786b4.zip/node_modules/yup/es/mixed.js

const Mixed = BaseSchema;
/* harmony default export */ var es_mixed = ((/* unused pure expression or super */ null && (Mixed)));
function mixed_create() {
  return new Mixed();
} // XXX: this is using the Base schema so that `addMethod(mixed)` works as a base class

mixed_create.prototype = Mixed.prototype;
;// CONCATENATED MODULE: ../../.yarn/cache/yup-npm-0.32.11-dbaff8ca9c-43a16786b4.zip/node_modules/yup/es/util/isAbsent.js
const isAbsent = value => value == null;

/* harmony default export */ var util_isAbsent = (isAbsent);
;// CONCATENATED MODULE: ../../.yarn/cache/yup-npm-0.32.11-dbaff8ca9c-43a16786b4.zip/node_modules/yup/es/boolean.js



function boolean_create() {
  return new BooleanSchema();
}
class BooleanSchema extends BaseSchema {
  constructor() {
    super({
      type: 'boolean'
    });
    this.withMutation(() => {
      this.transform(function (value) {
        if (!this.isType(value)) {
          if (/^(true|1)$/i.test(String(value))) return true;
          if (/^(false|0)$/i.test(String(value))) return false;
        }

        return value;
      });
    });
  }

  _typeCheck(v) {
    if (v instanceof Boolean) v = v.valueOf();
    return typeof v === 'boolean';
  }

  isTrue(message = locale_boolean.isValue) {
    return this.test({
      message,
      name: 'is-value',
      exclusive: true,
      params: {
        value: 'true'
      },

      test(value) {
        return util_isAbsent(value) || value === true;
      }

    });
  }

  isFalse(message = locale_boolean.isValue) {
    return this.test({
      message,
      name: 'is-value',
      exclusive: true,
      params: {
        value: 'false'
      },

      test(value) {
        return util_isAbsent(value) || value === false;
      }

    });
  }

}
boolean_create.prototype = BooleanSchema.prototype;
;// CONCATENATED MODULE: ../../.yarn/cache/yup-npm-0.32.11-dbaff8ca9c-43a16786b4.zip/node_modules/yup/es/string.js


 // eslint-disable-next-line

let rEmail = /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i; // eslint-disable-next-line

let rUrl = /^((https?|ftp):)?\/\/(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(\#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/i; // eslint-disable-next-line

let rUUID = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;

let isTrimmed = value => util_isAbsent(value) || value === value.trim();

let objStringTag = {}.toString();
function string_create() {
  return new StringSchema();
}
class StringSchema extends BaseSchema {
  constructor() {
    super({
      type: 'string'
    });
    this.withMutation(() => {
      this.transform(function (value) {
        if (this.isType(value)) return value;
        if (Array.isArray(value)) return value;
        const strValue = value != null && value.toString ? value.toString() : value;
        if (strValue === objStringTag) return value;
        return strValue;
      });
    });
  }

  _typeCheck(value) {
    if (value instanceof String) value = value.valueOf();
    return typeof value === 'string';
  }

  _isPresent(value) {
    return super._isPresent(value) && !!value.length;
  }

  length(length, message = string.length) {
    return this.test({
      message,
      name: 'length',
      exclusive: true,
      params: {
        length
      },

      test(value) {
        return util_isAbsent(value) || value.length === this.resolve(length);
      }

    });
  }

  min(min, message = string.min) {
    return this.test({
      message,
      name: 'min',
      exclusive: true,
      params: {
        min
      },

      test(value) {
        return util_isAbsent(value) || value.length >= this.resolve(min);
      }

    });
  }

  max(max, message = string.max) {
    return this.test({
      name: 'max',
      exclusive: true,
      message,
      params: {
        max
      },

      test(value) {
        return util_isAbsent(value) || value.length <= this.resolve(max);
      }

    });
  }

  matches(regex, options) {
    let excludeEmptyString = false;
    let message;
    let name;

    if (options) {
      if (typeof options === 'object') {
        ({
          excludeEmptyString = false,
          message,
          name
        } = options);
      } else {
        message = options;
      }
    }

    return this.test({
      name: name || 'matches',
      message: message || string.matches,
      params: {
        regex
      },
      test: value => util_isAbsent(value) || value === '' && excludeEmptyString || value.search(regex) !== -1
    });
  }

  email(message = string.email) {
    return this.matches(rEmail, {
      name: 'email',
      message,
      excludeEmptyString: true
    });
  }

  url(message = string.url) {
    return this.matches(rUrl, {
      name: 'url',
      message,
      excludeEmptyString: true
    });
  }

  uuid(message = string.uuid) {
    return this.matches(rUUID, {
      name: 'uuid',
      message,
      excludeEmptyString: false
    });
  } //-- transforms --


  ensure() {
    return this.default('').transform(val => val === null ? '' : val);
  }

  trim(message = string.trim) {
    return this.transform(val => val != null ? val.trim() : val).test({
      message,
      name: 'trim',
      test: isTrimmed
    });
  }

  lowercase(message = string.lowercase) {
    return this.transform(value => !util_isAbsent(value) ? value.toLowerCase() : value).test({
      message,
      name: 'string_case',
      exclusive: true,
      test: value => util_isAbsent(value) || value === value.toLowerCase()
    });
  }

  uppercase(message = string.uppercase) {
    return this.transform(value => !util_isAbsent(value) ? value.toUpperCase() : value).test({
      message,
      name: 'string_case',
      exclusive: true,
      test: value => util_isAbsent(value) || value === value.toUpperCase()
    });
  }

}
string_create.prototype = StringSchema.prototype; //
// String Interfaces
//
;// CONCATENATED MODULE: ../../.yarn/cache/yup-npm-0.32.11-dbaff8ca9c-43a16786b4.zip/node_modules/yup/es/number.js




let number_isNaN = value => value != +value;

function number_create() {
  return new NumberSchema();
}
class NumberSchema extends BaseSchema {
  constructor() {
    super({
      type: 'number'
    });
    this.withMutation(() => {
      this.transform(function (value) {
        let parsed = value;

        if (typeof parsed === 'string') {
          parsed = parsed.replace(/\s/g, '');
          if (parsed === '') return NaN; // don't use parseFloat to avoid positives on alpha-numeric strings

          parsed = +parsed;
        }

        if (this.isType(parsed)) return parsed;
        return parseFloat(parsed);
      });
    });
  }

  _typeCheck(value) {
    if (value instanceof Number) value = value.valueOf();
    return typeof value === 'number' && !number_isNaN(value);
  }

  min(min, message = number.min) {
    return this.test({
      message,
      name: 'min',
      exclusive: true,
      params: {
        min
      },

      test(value) {
        return util_isAbsent(value) || value >= this.resolve(min);
      }

    });
  }

  max(max, message = number.max) {
    return this.test({
      message,
      name: 'max',
      exclusive: true,
      params: {
        max
      },

      test(value) {
        return util_isAbsent(value) || value <= this.resolve(max);
      }

    });
  }

  lessThan(less, message = number.lessThan) {
    return this.test({
      message,
      name: 'max',
      exclusive: true,
      params: {
        less
      },

      test(value) {
        return util_isAbsent(value) || value < this.resolve(less);
      }

    });
  }

  moreThan(more, message = number.moreThan) {
    return this.test({
      message,
      name: 'min',
      exclusive: true,
      params: {
        more
      },

      test(value) {
        return util_isAbsent(value) || value > this.resolve(more);
      }

    });
  }

  positive(msg = number.positive) {
    return this.moreThan(0, msg);
  }

  negative(msg = number.negative) {
    return this.lessThan(0, msg);
  }

  integer(message = number.integer) {
    return this.test({
      name: 'integer',
      message,
      test: val => util_isAbsent(val) || Number.isInteger(val)
    });
  }

  truncate() {
    return this.transform(value => !util_isAbsent(value) ? value | 0 : value);
  }

  round(method) {
    var _method;

    let avail = ['ceil', 'floor', 'round', 'trunc'];
    method = ((_method = method) == null ? void 0 : _method.toLowerCase()) || 'round'; // this exists for symemtry with the new Math.trunc

    if (method === 'trunc') return this.truncate();
    if (avail.indexOf(method.toLowerCase()) === -1) throw new TypeError('Only valid options for round() are: ' + avail.join(', '));
    return this.transform(value => !util_isAbsent(value) ? Math[method](value) : value);
  }

}
number_create.prototype = NumberSchema.prototype; //
// Number Interfaces
//
;// CONCATENATED MODULE: ../../.yarn/cache/yup-npm-0.32.11-dbaff8ca9c-43a16786b4.zip/node_modules/yup/es/util/isodate.js
/* eslint-disable */

/**
 *
 * Date.parse with progressive enhancement for ISO 8601 <https://github.com/csnover/js-iso8601>
 * NON-CONFORMANT EDITION.
 * © 2011 Colin Snover <http://zetafleet.com>
 * Released under MIT license.
 */
//              1 YYYY                 2 MM        3 DD              4 HH     5 mm        6 ss            7 msec         8 Z 9 ±    10 tzHH    11 tzmm
var isoReg = /^(\d{4}|[+\-]\d{6})(?:-?(\d{2})(?:-?(\d{2}))?)?(?:[ T]?(\d{2}):?(\d{2})(?::?(\d{2})(?:[,\.](\d{1,}))?)?(?:(Z)|([+\-])(\d{2})(?::?(\d{2}))?)?)?$/;
function parseIsoDate(date) {
  var numericKeys = [1, 4, 5, 6, 7, 10, 11],
      minutesOffset = 0,
      timestamp,
      struct;

  if (struct = isoReg.exec(date)) {
    // avoid NaN timestamps caused by “undefined” values being passed to Date.UTC
    for (var i = 0, k; k = numericKeys[i]; ++i) struct[k] = +struct[k] || 0; // allow undefined days and months


    struct[2] = (+struct[2] || 1) - 1;
    struct[3] = +struct[3] || 1; // allow arbitrary sub-second precision beyond milliseconds

    struct[7] = struct[7] ? String(struct[7]).substr(0, 3) : 0; // timestamps without timezone identifiers should be considered local time

    if ((struct[8] === undefined || struct[8] === '') && (struct[9] === undefined || struct[9] === '')) timestamp = +new Date(struct[1], struct[2], struct[3], struct[4], struct[5], struct[6], struct[7]);else {
      if (struct[8] !== 'Z' && struct[9] !== undefined) {
        minutesOffset = struct[10] * 60 + struct[11];
        if (struct[9] === '+') minutesOffset = 0 - minutesOffset;
      }

      timestamp = Date.UTC(struct[1], struct[2], struct[3], struct[4], struct[5] + minutesOffset, struct[6], struct[7]);
    }
  } else timestamp = Date.parse ? Date.parse(date) : NaN;

  return timestamp;
}
;// CONCATENATED MODULE: ../../.yarn/cache/yup-npm-0.32.11-dbaff8ca9c-43a16786b4.zip/node_modules/yup/es/date.js
// @ts-ignore





let invalidDate = new Date('');

let isDate = obj => Object.prototype.toString.call(obj) === '[object Date]';

function date_create() {
  return new DateSchema();
}
class DateSchema extends BaseSchema {
  constructor() {
    super({
      type: 'date'
    });
    this.withMutation(() => {
      this.transform(function (value) {
        if (this.isType(value)) return value;
        value = parseIsoDate(value); // 0 is a valid timestamp equivalent to 1970-01-01T00:00:00Z(unix epoch) or before.

        return !isNaN(value) ? new Date(value) : invalidDate;
      });
    });
  }

  _typeCheck(v) {
    return isDate(v) && !isNaN(v.getTime());
  }

  prepareParam(ref, name) {
    let param;

    if (!Reference.isRef(ref)) {
      let cast = this.cast(ref);
      if (!this._typeCheck(cast)) throw new TypeError(`\`${name}\` must be a Date or a value that can be \`cast()\` to a Date`);
      param = cast;
    } else {
      param = ref;
    }

    return param;
  }

  min(min, message = date.min) {
    let limit = this.prepareParam(min, 'min');
    return this.test({
      message,
      name: 'min',
      exclusive: true,
      params: {
        min
      },

      test(value) {
        return util_isAbsent(value) || value >= this.resolve(limit);
      }

    });
  }

  max(max, message = date.max) {
    let limit = this.prepareParam(max, 'max');
    return this.test({
      message,
      name: 'max',
      exclusive: true,
      params: {
        max
      },

      test(value) {
        return util_isAbsent(value) || value <= this.resolve(limit);
      }

    });
  }

}
DateSchema.INVALID_DATE = invalidDate;
date_create.prototype = DateSchema.prototype;
date_create.INVALID_DATE = invalidDate;
// EXTERNAL MODULE: ../../.yarn/cache/lodash-npm-4.17.21-6382451519-eb835a2e51.zip/node_modules/lodash/snakeCase.js
var snakeCase = __webpack_require__(65632);
var snakeCase_default = /*#__PURE__*/__webpack_require__.n(snakeCase);
// EXTERNAL MODULE: ../../.yarn/cache/lodash-npm-4.17.21-6382451519-eb835a2e51.zip/node_modules/lodash/camelCase.js
var camelCase = __webpack_require__(13874);
var camelCase_default = /*#__PURE__*/__webpack_require__.n(camelCase);
// EXTERNAL MODULE: ../../.yarn/cache/lodash-npm-4.17.21-6382451519-eb835a2e51.zip/node_modules/lodash/mapKeys.js
var mapKeys = __webpack_require__(7576);
var mapKeys_default = /*#__PURE__*/__webpack_require__.n(mapKeys);
// EXTERNAL MODULE: ../../.yarn/cache/toposort-npm-2.0.2-d472329c7d-d64c74b570.zip/node_modules/toposort/index.js
var toposort = __webpack_require__(20059);
var toposort_default = /*#__PURE__*/__webpack_require__.n(toposort);
;// CONCATENATED MODULE: ../../.yarn/cache/yup-npm-0.32.11-dbaff8ca9c-43a16786b4.zip/node_modules/yup/es/util/sortFields.js
 // @ts-expect-error





function sortFields(fields, excludedEdges = []) {
  let edges = [];
  let nodes = new Set();
  let excludes = new Set(excludedEdges.map(([a, b]) => `${a}-${b}`));

  function addNode(depPath, key) {
    let node = (0,property_expr.split)(depPath)[0];
    nodes.add(node);
    if (!excludes.has(`${key}-${node}`)) edges.push([key, node]);
  }

  for (const key in fields) if (has_default()(fields, key)) {
    let value = fields[key];
    nodes.add(key);
    if (Reference.isRef(value) && value.isSibling) addNode(value.path, key);else if (util_isSchema(value) && 'deps' in value) value.deps.forEach(path => addNode(path, key));
  }

  return toposort_default().array(Array.from(nodes), edges).reverse();
}
;// CONCATENATED MODULE: ../../.yarn/cache/yup-npm-0.32.11-dbaff8ca9c-43a16786b4.zip/node_modules/yup/es/util/sortByKeyOrder.js
function findIndex(arr, err) {
  let idx = Infinity;
  arr.some((key, ii) => {
    var _err$path;

    if (((_err$path = err.path) == null ? void 0 : _err$path.indexOf(key)) !== -1) {
      idx = ii;
      return true;
    }
  });
  return idx;
}

function sortByKeyOrder(keys) {
  return (a, b) => {
    return findIndex(keys, a) - findIndex(keys, b);
  };
}
;// CONCATENATED MODULE: ../../.yarn/cache/yup-npm-0.32.11-dbaff8ca9c-43a16786b4.zip/node_modules/yup/es/object.js
function object_extends() { object_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return object_extends.apply(this, arguments); }














let isObject = obj => Object.prototype.toString.call(obj) === '[object Object]';

function unknown(ctx, value) {
  let known = Object.keys(ctx.fields);
  return Object.keys(value).filter(key => known.indexOf(key) === -1);
}

const defaultSort = sortByKeyOrder([]);
class ObjectSchema extends BaseSchema {
  constructor(spec) {
    super({
      type: 'object'
    });
    this.fields = Object.create(null);
    this._sortErrors = defaultSort;
    this._nodes = [];
    this._excludedEdges = [];
    this.withMutation(() => {
      this.transform(function coerce(value) {
        if (typeof value === 'string') {
          try {
            value = JSON.parse(value);
          } catch (err) {
            value = null;
          }
        }

        if (this.isType(value)) return value;
        return null;
      });

      if (spec) {
        this.shape(spec);
      }
    });
  }

  _typeCheck(value) {
    return isObject(value) || typeof value === 'function';
  }

  _cast(_value, options = {}) {
    var _options$stripUnknown;

    let value = super._cast(_value, options); //should ignore nulls here


    if (value === undefined) return this.getDefault();
    if (!this._typeCheck(value)) return value;
    let fields = this.fields;
    let strip = (_options$stripUnknown = options.stripUnknown) != null ? _options$stripUnknown : this.spec.noUnknown;

    let props = this._nodes.concat(Object.keys(value).filter(v => this._nodes.indexOf(v) === -1));

    let intermediateValue = {}; // is filled during the transform below

    let innerOptions = object_extends({}, options, {
      parent: intermediateValue,
      __validating: options.__validating || false
    });

    let isChanged = false;

    for (const prop of props) {
      let field = fields[prop];
      let exists = has_default()(value, prop);

      if (field) {
        let fieldValue;
        let inputValue = value[prop]; // safe to mutate since this is fired in sequence

        innerOptions.path = (options.path ? `${options.path}.` : '') + prop; // innerOptions.value = value[prop];

        field = field.resolve({
          value: inputValue,
          context: options.context,
          parent: intermediateValue
        });
        let fieldSpec = 'spec' in field ? field.spec : undefined;
        let strict = fieldSpec == null ? void 0 : fieldSpec.strict;

        if (fieldSpec == null ? void 0 : fieldSpec.strip) {
          isChanged = isChanged || prop in value;
          continue;
        }

        fieldValue = !options.__validating || !strict ? // TODO: use _cast, this is double resolving
        field.cast(value[prop], innerOptions) : value[prop];

        if (fieldValue !== undefined) {
          intermediateValue[prop] = fieldValue;
        }
      } else if (exists && !strip) {
        intermediateValue[prop] = value[prop];
      }

      if (intermediateValue[prop] !== value[prop]) {
        isChanged = true;
      }
    }

    return isChanged ? intermediateValue : value;
  }

  _validate(_value, opts = {}, callback) {
    let errors = [];
    let {
      sync,
      from = [],
      originalValue = _value,
      abortEarly = this.spec.abortEarly,
      recursive = this.spec.recursive
    } = opts;
    from = [{
      schema: this,
      value: originalValue
    }, ...from]; // this flag is needed for handling `strict` correctly in the context of
    // validation vs just casting. e.g strict() on a field is only used when validating

    opts.__validating = true;
    opts.originalValue = originalValue;
    opts.from = from;

    super._validate(_value, opts, (err, value) => {
      if (err) {
        if (!ValidationError.isError(err) || abortEarly) {
          return void callback(err, value);
        }

        errors.push(err);
      }

      if (!recursive || !isObject(value)) {
        callback(errors[0] || null, value);
        return;
      }

      originalValue = originalValue || value;

      let tests = this._nodes.map(key => (_, cb) => {
        let path = key.indexOf('.') === -1 ? (opts.path ? `${opts.path}.` : '') + key : `${opts.path || ''}["${key}"]`;
        let field = this.fields[key];

        if (field && 'validate' in field) {
          field.validate(value[key], object_extends({}, opts, {
            // @ts-ignore
            path,
            from,
            // inner fields are always strict:
            // 1. this isn't strict so the casting will also have cast inner values
            // 2. this is strict in which case the nested values weren't cast either
            strict: true,
            parent: value,
            originalValue: originalValue[key]
          }), cb);
          return;
        }

        cb(null);
      });

      runTests({
        sync,
        tests,
        value,
        errors,
        endEarly: abortEarly,
        sort: this._sortErrors,
        path: opts.path
      }, callback);
    });
  }

  clone(spec) {
    const next = super.clone(spec);
    next.fields = object_extends({}, this.fields);
    next._nodes = this._nodes;
    next._excludedEdges = this._excludedEdges;
    next._sortErrors = this._sortErrors;
    return next;
  }

  concat(schema) {
    let next = super.concat(schema);
    let nextFields = next.fields;

    for (let [field, schemaOrRef] of Object.entries(this.fields)) {
      const target = nextFields[field];

      if (target === undefined) {
        nextFields[field] = schemaOrRef;
      } else if (target instanceof BaseSchema && schemaOrRef instanceof BaseSchema) {
        nextFields[field] = schemaOrRef.concat(target);
      }
    }

    return next.withMutation(() => next.shape(nextFields, this._excludedEdges));
  }

  getDefaultFromShape() {
    let dft = {};

    this._nodes.forEach(key => {
      const field = this.fields[key];
      dft[key] = 'default' in field ? field.getDefault() : undefined;
    });

    return dft;
  }

  _getDefault() {
    if ('default' in this.spec) {
      return super._getDefault();
    } // if there is no default set invent one


    if (!this._nodes.length) {
      return undefined;
    }

    return this.getDefaultFromShape();
  }

  shape(additions, excludes = []) {
    let next = this.clone();
    let fields = Object.assign(next.fields, additions);
    next.fields = fields;
    next._sortErrors = sortByKeyOrder(Object.keys(fields));

    if (excludes.length) {
      // this is a convenience for when users only supply a single pair
      if (!Array.isArray(excludes[0])) excludes = [excludes];
      next._excludedEdges = [...next._excludedEdges, ...excludes];
    }

    next._nodes = sortFields(fields, next._excludedEdges);
    return next;
  }

  pick(keys) {
    const picked = {};

    for (const key of keys) {
      if (this.fields[key]) picked[key] = this.fields[key];
    }

    return this.clone().withMutation(next => {
      next.fields = {};
      return next.shape(picked);
    });
  }

  omit(keys) {
    const next = this.clone();
    const fields = next.fields;
    next.fields = {};

    for (const key of keys) {
      delete fields[key];
    }

    return next.withMutation(() => next.shape(fields));
  }

  from(from, to, alias) {
    let fromGetter = (0,property_expr.getter)(from, true);
    return this.transform(obj => {
      if (obj == null) return obj;
      let newObj = obj;

      if (has_default()(obj, from)) {
        newObj = object_extends({}, obj);
        if (!alias) delete newObj[from];
        newObj[to] = fromGetter(obj);
      }

      return newObj;
    });
  }

  noUnknown(noAllow = true, message = object.noUnknown) {
    if (typeof noAllow === 'string') {
      message = noAllow;
      noAllow = true;
    }

    let next = this.test({
      name: 'noUnknown',
      exclusive: true,
      message: message,

      test(value) {
        if (value == null) return true;
        const unknownKeys = unknown(this.schema, value);
        return !noAllow || unknownKeys.length === 0 || this.createError({
          params: {
            unknown: unknownKeys.join(', ')
          }
        });
      }

    });
    next.spec.noUnknown = noAllow;
    return next;
  }

  unknown(allow = true, message = object.noUnknown) {
    return this.noUnknown(!allow, message);
  }

  transformKeys(fn) {
    return this.transform(obj => obj && mapKeys_default()(obj, (_, key) => fn(key)));
  }

  camelCase() {
    return this.transformKeys((camelCase_default()));
  }

  snakeCase() {
    return this.transformKeys((snakeCase_default()));
  }

  constantCase() {
    return this.transformKeys(key => snakeCase_default()(key).toUpperCase());
  }

  describe() {
    let base = super.describe();
    base.fields = mapValues_default()(this.fields, value => value.describe());
    return base;
  }

}
function object_create(spec) {
  return new ObjectSchema(spec);
}
object_create.prototype = ObjectSchema.prototype;
;// CONCATENATED MODULE: ../../.yarn/cache/yup-npm-0.32.11-dbaff8ca9c-43a16786b4.zip/node_modules/yup/es/array.js
function array_extends() { array_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return array_extends.apply(this, arguments); }








function array_create(type) {
  return new ArraySchema(type);
}
class ArraySchema extends BaseSchema {
  constructor(type) {
    super({
      type: 'array'
    }); // `undefined` specifically means uninitialized, as opposed to
    // "no subtype"

    this.innerType = void 0;
    this.innerType = type;
    this.withMutation(() => {
      this.transform(function (values) {
        if (typeof values === 'string') try {
          values = JSON.parse(values);
        } catch (err) {
          values = null;
        }
        return this.isType(values) ? values : null;
      });
    });
  }

  _typeCheck(v) {
    return Array.isArray(v);
  }

  get _subType() {
    return this.innerType;
  }

  _cast(_value, _opts) {
    const value = super._cast(_value, _opts); //should ignore nulls here


    if (!this._typeCheck(value) || !this.innerType) return value;
    let isChanged = false;
    const castArray = value.map((v, idx) => {
      const castElement = this.innerType.cast(v, array_extends({}, _opts, {
        path: `${_opts.path || ''}[${idx}]`
      }));

      if (castElement !== v) {
        isChanged = true;
      }

      return castElement;
    });
    return isChanged ? castArray : value;
  }

  _validate(_value, options = {}, callback) {
    var _options$abortEarly, _options$recursive;

    let errors = [];
    let sync = options.sync;
    let path = options.path;
    let innerType = this.innerType;
    let endEarly = (_options$abortEarly = options.abortEarly) != null ? _options$abortEarly : this.spec.abortEarly;
    let recursive = (_options$recursive = options.recursive) != null ? _options$recursive : this.spec.recursive;
    let originalValue = options.originalValue != null ? options.originalValue : _value;

    super._validate(_value, options, (err, value) => {
      if (err) {
        if (!ValidationError.isError(err) || endEarly) {
          return void callback(err, value);
        }

        errors.push(err);
      }

      if (!recursive || !innerType || !this._typeCheck(value)) {
        callback(errors[0] || null, value);
        return;
      }

      originalValue = originalValue || value; // #950 Ensure that sparse array empty slots are validated

      let tests = new Array(value.length);

      for (let idx = 0; idx < value.length; idx++) {
        let item = value[idx];
        let path = `${options.path || ''}[${idx}]`; // object._validate note for isStrict explanation

        let innerOptions = array_extends({}, options, {
          path,
          strict: true,
          parent: value,
          index: idx,
          originalValue: originalValue[idx]
        });

        tests[idx] = (_, cb) => innerType.validate(item, innerOptions, cb);
      }

      runTests({
        sync,
        path,
        value,
        errors,
        endEarly,
        tests
      }, callback);
    });
  }

  clone(spec) {
    const next = super.clone(spec);
    next.innerType = this.innerType;
    return next;
  }

  concat(schema) {
    let next = super.concat(schema);
    next.innerType = this.innerType;
    if (schema.innerType) next.innerType = next.innerType ? // @ts-expect-error Lazy doesn't have concat()
    next.innerType.concat(schema.innerType) : schema.innerType;
    return next;
  }

  of(schema) {
    // FIXME: this should return a new instance of array without the default to be
    let next = this.clone();
    if (!util_isSchema(schema)) throw new TypeError('`array.of()` sub-schema must be a valid yup schema not: ' + printValue(schema)); // FIXME(ts):

    next.innerType = schema;
    return next;
  }

  length(length, message = array.length) {
    return this.test({
      message,
      name: 'length',
      exclusive: true,
      params: {
        length
      },

      test(value) {
        return util_isAbsent(value) || value.length === this.resolve(length);
      }

    });
  }

  min(min, message) {
    message = message || array.min;
    return this.test({
      message,
      name: 'min',
      exclusive: true,
      params: {
        min
      },

      // FIXME(ts): Array<typeof T>
      test(value) {
        return util_isAbsent(value) || value.length >= this.resolve(min);
      }

    });
  }

  max(max, message) {
    message = message || array.max;
    return this.test({
      message,
      name: 'max',
      exclusive: true,
      params: {
        max
      },

      test(value) {
        return util_isAbsent(value) || value.length <= this.resolve(max);
      }

    });
  }

  ensure() {
    return this.default(() => []).transform((val, original) => {
      // We don't want to return `null` for nullable schema
      if (this._typeCheck(val)) return val;
      return original == null ? [] : [].concat(original);
    });
  }

  compact(rejector) {
    let reject = !rejector ? v => !!v : (v, i, a) => !rejector(v, i, a);
    return this.transform(values => values != null ? values.filter(reject) : values);
  }

  describe() {
    let base = super.describe();
    if (this.innerType) base.innerType = this.innerType.describe();
    return base;
  }

  nullable(isNullable = true) {
    return super.nullable(isNullable);
  }

  defined() {
    return super.defined();
  }

  required(msg) {
    return super.required(msg);
  }

}
array_create.prototype = ArraySchema.prototype; //
// Interfaces
//
;// CONCATENATED MODULE: ../../.yarn/cache/yup-npm-0.32.11-dbaff8ca9c-43a16786b4.zip/node_modules/yup/es/setLocale.js

function setLocale(custom) {
  Object.keys(custom).forEach(type => {
    // @ts-ignore
    Object.keys(custom[type]).forEach(method => {
      // @ts-ignore
      locale[type][method] = custom[type][method];
    });
  });
}
;// CONCATENATED MODULE: ../../.yarn/cache/yup-npm-0.32.11-dbaff8ca9c-43a16786b4.zip/node_modules/yup/es/index.js















function addMethod(schemaType, name, fn) {
  if (!schemaType || !isSchema(schemaType.prototype)) throw new TypeError('You must provide a yup schema constructor function');
  if (typeof name !== 'string') throw new TypeError('A Method name must be provided');
  if (typeof fn !== 'function') throw new TypeError('Method function must be provided');
  schemaType.prototype[name] = fn;
}




/***/ }),

/***/ 43226:
/***/ (function(module, exports) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = '';

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (arg) {
				classes = appendClass(classes, parseValue(arg));
			}
		}

		return classes;
	}

	function parseValue (arg) {
		if (typeof arg === 'string' || typeof arg === 'number') {
			return arg;
		}

		if (typeof arg !== 'object') {
			return '';
		}

		if (Array.isArray(arg)) {
			return classNames.apply(null, arg);
		}

		if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) {
			return arg.toString();
		}

		var classes = '';

		for (var key in arg) {
			if (hasOwn.call(arg, key) && arg[key]) {
				classes = appendClass(classes, key);
			}
		}

		return classes;
	}

	function appendClass (value, newClass) {
		if (!newClass) {
			return value;
		}
	
		if (value) {
			return value + ' ' + newClass;
		}
	
		return value + newClass;
	}

	if ( true && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {}
}());


/***/ }),

/***/ 26065:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "K": function() { return /* binding */ getApolloContext; }
/* harmony export */ });
/* unused harmony export resetApolloContext */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91987);
/* harmony import */ var _utilities_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(17182);


var contextKey = _utilities_index_js__WEBPACK_IMPORTED_MODULE_1__/* .canUseSymbol */ .aS
    ? Symbol.for('__APOLLO_CONTEXT__')
    : '__APOLLO_CONTEXT__';
function getApolloContext() {
    var context = react__WEBPACK_IMPORTED_MODULE_0__.createContext[contextKey];
    if (!context) {
        Object.defineProperty(react__WEBPACK_IMPORTED_MODULE_0__.createContext, contextKey, {
            value: context = react__WEBPACK_IMPORTED_MODULE_0__.createContext({}),
            enumerable: false,
            writable: false,
            configurable: true,
        });
        context.displayName = 'ApolloContext';
    }
    return context;
}

//# sourceMappingURL=ApolloContext.js.map

/***/ }),

/***/ 17182:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "JC": function() { return /* binding */ canUseLayoutEffect; },
/* harmony export */   "aS": function() { return /* binding */ canUseSymbol; },
/* harmony export */   "mr": function() { return /* binding */ canUseWeakMap; },
/* harmony export */   "sy": function() { return /* binding */ canUseWeakSet; }
/* harmony export */ });
/* unused harmony exports canUseAsyncIteratorSymbol, canUseDOM */
/* harmony import */ var _globals_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94896);

var canUseWeakMap = typeof WeakMap === 'function' &&
    (0,_globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .maybe */ .wY)(function () { return navigator.product; }) !== 'ReactNative';
var canUseWeakSet = typeof WeakSet === 'function';
var canUseSymbol = typeof Symbol === 'function' &&
    typeof Symbol.for === 'function';
var canUseAsyncIteratorSymbol = canUseSymbol && Symbol.asyncIterator;
var canUseDOM = typeof (0,_globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .maybe */ .wY)(function () { return window.document.createElement; }) === "function";
var usingJSDOM = (0,_globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .maybe */ .wY)(function () { return navigator.userAgent.indexOf("jsdom") >= 0; }) || false;
var canUseLayoutEffect = canUseDOM && !usingJSDOM;
//# sourceMappingURL=canUse.js.map

/***/ }),

/***/ 94896:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "kG": function() { return /* reexport */ invariant/* invariant */.kG; },
  "wY": function() { return /* reexport */ maybe; }
});

// UNUSED EXPORTS: DEV, InvariantError, checkDEV, global

// EXTERNAL MODULE: ../../.yarn/cache/ts-invariant-npm-0.10.3-4657a5b439-bb07d56fe4.zip/node_modules/ts-invariant/lib/invariant.js
var invariant = __webpack_require__(32218);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@apollo-client-virtual-e2a13f3a66/0/cache/@apollo-client-npm-3.7.1-a80032e019-95bb1f226f.zip/node_modules/@apollo/client/utilities/globals/maybe.js
function maybe(thunk) {
    try {
        return thunk();
    }
    catch (_a) { }
}
//# sourceMappingURL=maybe.js.map
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@apollo-client-virtual-e2a13f3a66/0/cache/@apollo-client-npm-3.7.1-a80032e019-95bb1f226f.zip/node_modules/@apollo/client/utilities/globals/global.js

/* harmony default export */ var globals_global = (maybe(function () { return globalThis; }) ||
    maybe(function () { return window; }) ||
    maybe(function () { return self; }) ||
    maybe(function () { return global; }) || maybe(function () { return maybe.constructor("return this")(); }));
//# sourceMappingURL=global.js.map
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@apollo-client-virtual-e2a13f3a66/0/cache/@apollo-client-npm-3.7.1-a80032e019-95bb1f226f.zip/node_modules/@apollo/client/utilities/globals/DEV.js


var __ = "__";
var GLOBAL_KEY = [__, __].join("DEV");
function getDEV() {
    try {
        return Boolean(__DEV__);
    }
    catch (_a) {
        Object.defineProperty(globals_global, GLOBAL_KEY, {
            value: maybe(function () { return "production"; }) !== "production",
            enumerable: false,
            configurable: true,
            writable: true,
        });
        return globals_global[GLOBAL_KEY];
    }
}
/* harmony default export */ var DEV = (getDEV());
//# sourceMappingURL=DEV.js.map
// EXTERNAL MODULE: ../../.yarn/cache/ts-invariant-npm-0.10.3-4657a5b439-bb07d56fe4.zip/node_modules/ts-invariant/process/index.js
var process = __webpack_require__(69368);
// EXTERNAL MODULE: ../../.yarn/cache/graphql-npm-16.5.0-348f68b718-a82a926d08.zip/node_modules/graphql/language/source.mjs + 1 modules
var source = __webpack_require__(81052);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@apollo-client-virtual-e2a13f3a66/0/cache/@apollo-client-npm-3.7.1-a80032e019-95bb1f226f.zip/node_modules/@apollo/client/utilities/globals/fix-graphql.js


function removeTemporaryGlobals() {
    return typeof source/* Source */.H === "function" ? (0,process/* remove */.O)() : (0,process/* remove */.O)();
}
//# sourceMappingURL=fix-graphql.js.map
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@apollo-client-virtual-e2a13f3a66/0/cache/@apollo-client-npm-3.7.1-a80032e019-95bb1f226f.zip/node_modules/@apollo/client/utilities/globals/index.js



function checkDEV() {
    __DEV__ ? (0,invariant/* invariant */.kG)("boolean" === typeof DEV, DEV) : (0,invariant/* invariant */.kG)("boolean" === typeof DEV, 38);
}

removeTemporaryGlobals();



checkDEV();
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 37997:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _extends; }
/* harmony export */ });
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}

/***/ }),

/***/ 48848:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _inheritsLoose; }
/* harmony export */ });
/* harmony import */ var _setPrototypeOf_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(86422);

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  (0,_setPrototypeOf_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(subClass, superClass);
}

/***/ }),

/***/ 86422:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _setPrototypeOf; }
/* harmony export */ });
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}

/***/ }),

/***/ 45747:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ devAssert; }
/* harmony export */ });
function devAssert(condition, message) {
  const booleanCondition = Boolean(condition);

  if (!booleanCondition) {
    throw new Error(message);
  }
}


/***/ }),

/***/ 40105:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ inspect; }
/* harmony export */ });
const MAX_ARRAY_LENGTH = 10;
const MAX_RECURSIVE_DEPTH = 2;
/**
 * Used to print values in error messages.
 */

function inspect(value) {
  return formatValue(value, []);
}

function formatValue(value, seenValues) {
  switch (typeof value) {
    case 'string':
      return JSON.stringify(value);

    case 'function':
      return value.name ? `[function ${value.name}]` : '[function]';

    case 'object':
      return formatObjectValue(value, seenValues);

    default:
      return String(value);
  }
}

function formatObjectValue(value, previouslySeenValues) {
  if (value === null) {
    return 'null';
  }

  if (previouslySeenValues.includes(value)) {
    return '[Circular]';
  }

  const seenValues = [...previouslySeenValues, value];

  if (isJSONable(value)) {
    const jsonValue = value.toJSON(); // check for infinite recursion

    if (jsonValue !== value) {
      return typeof jsonValue === 'string'
        ? jsonValue
        : formatValue(jsonValue, seenValues);
    }
  } else if (Array.isArray(value)) {
    return formatArray(value, seenValues);
  }

  return formatObject(value, seenValues);
}

function isJSONable(value) {
  return typeof value.toJSON === 'function';
}

function formatObject(object, seenValues) {
  const entries = Object.entries(object);

  if (entries.length === 0) {
    return '{}';
  }

  if (seenValues.length > MAX_RECURSIVE_DEPTH) {
    return '[' + getObjectTag(object) + ']';
  }

  const properties = entries.map(
    ([key, value]) => key + ': ' + formatValue(value, seenValues),
  );
  return '{ ' + properties.join(', ') + ' }';
}

function formatArray(array, seenValues) {
  if (array.length === 0) {
    return '[]';
  }

  if (seenValues.length > MAX_RECURSIVE_DEPTH) {
    return '[Array]';
  }

  const len = Math.min(MAX_ARRAY_LENGTH, array.length);
  const remaining = array.length - len;
  const items = [];

  for (let i = 0; i < len; ++i) {
    items.push(formatValue(array[i], seenValues));
  }

  if (remaining === 1) {
    items.push('... 1 more item');
  } else if (remaining > 1) {
    items.push(`... ${remaining} more items`);
  }

  return '[' + items.join(', ') + ']';
}

function getObjectTag(object) {
  const tag = Object.prototype.toString
    .call(object)
    .replace(/^\[object /, '')
    .replace(/]$/, '');

  if (tag === 'Object' && typeof object.constructor === 'function') {
    const name = object.constructor.name;

    if (typeof name === 'string' && name !== '') {
      return name;
    }
  }

  return tag;
}


/***/ }),

/***/ 27794:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "UG": function() { return /* binding */ isNode; },
/* harmony export */   "WU": function() { return /* binding */ Token; },
/* harmony export */   "Ye": function() { return /* binding */ Location; },
/* harmony export */   "h8": function() { return /* binding */ QueryDocumentKeys; },
/* harmony export */   "ku": function() { return /* binding */ OperationTypeNode; }
/* harmony export */ });
/**
 * Contains a range of UTF-8 character offsets and token references that
 * identify the region of the source from which the AST derived.
 */
class Location {
  /**
   * The character offset at which this Node begins.
   */

  /**
   * The character offset at which this Node ends.
   */

  /**
   * The Token at which this Node begins.
   */

  /**
   * The Token at which this Node ends.
   */

  /**
   * The Source document the AST represents.
   */
  constructor(startToken, endToken, source) {
    this.start = startToken.start;
    this.end = endToken.end;
    this.startToken = startToken;
    this.endToken = endToken;
    this.source = source;
  }

  get [Symbol.toStringTag]() {
    return 'Location';
  }

  toJSON() {
    return {
      start: this.start,
      end: this.end,
    };
  }
}
/**
 * Represents a range of characters represented by a lexical token
 * within a Source.
 */

class Token {
  /**
   * The kind of Token.
   */

  /**
   * The character offset at which this Node begins.
   */

  /**
   * The character offset at which this Node ends.
   */

  /**
   * The 1-indexed line number on which this Token appears.
   */

  /**
   * The 1-indexed column number at which this Token begins.
   */

  /**
   * For non-punctuation tokens, represents the interpreted value of the token.
   *
   * Note: is undefined for punctuation tokens, but typed as string for
   * convenience in the parser.
   */

  /**
   * Tokens exist as nodes in a double-linked-list amongst all tokens
   * including ignored tokens. <SOF> is always the first node and <EOF>
   * the last.
   */
  constructor(kind, start, end, line, column, value) {
    this.kind = kind;
    this.start = start;
    this.end = end;
    this.line = line;
    this.column = column; // eslint-disable-next-line @typescript-eslint/no-non-null-assertion

    this.value = value;
    this.prev = null;
    this.next = null;
  }

  get [Symbol.toStringTag]() {
    return 'Token';
  }

  toJSON() {
    return {
      kind: this.kind,
      value: this.value,
      line: this.line,
      column: this.column,
    };
  }
}
/**
 * The list of all possible AST node types.
 */

/**
 * @internal
 */
const QueryDocumentKeys = {
  Name: [],
  Document: ['definitions'],
  OperationDefinition: [
    'name',
    'variableDefinitions',
    'directives',
    'selectionSet',
  ],
  VariableDefinition: ['variable', 'type', 'defaultValue', 'directives'],
  Variable: ['name'],
  SelectionSet: ['selections'],
  Field: ['alias', 'name', 'arguments', 'directives', 'selectionSet'],
  Argument: ['name', 'value'],
  FragmentSpread: ['name', 'directives'],
  InlineFragment: ['typeCondition', 'directives', 'selectionSet'],
  FragmentDefinition: [
    'name', // Note: fragment variable definitions are deprecated and will removed in v17.0.0
    'variableDefinitions',
    'typeCondition',
    'directives',
    'selectionSet',
  ],
  IntValue: [],
  FloatValue: [],
  StringValue: [],
  BooleanValue: [],
  NullValue: [],
  EnumValue: [],
  ListValue: ['values'],
  ObjectValue: ['fields'],
  ObjectField: ['name', 'value'],
  Directive: ['name', 'arguments'],
  NamedType: ['name'],
  ListType: ['type'],
  NonNullType: ['type'],
  SchemaDefinition: ['description', 'directives', 'operationTypes'],
  OperationTypeDefinition: ['type'],
  ScalarTypeDefinition: ['description', 'name', 'directives'],
  ObjectTypeDefinition: [
    'description',
    'name',
    'interfaces',
    'directives',
    'fields',
  ],
  FieldDefinition: ['description', 'name', 'arguments', 'type', 'directives'],
  InputValueDefinition: [
    'description',
    'name',
    'type',
    'defaultValue',
    'directives',
  ],
  InterfaceTypeDefinition: [
    'description',
    'name',
    'interfaces',
    'directives',
    'fields',
  ],
  UnionTypeDefinition: ['description', 'name', 'directives', 'types'],
  EnumTypeDefinition: ['description', 'name', 'directives', 'values'],
  EnumValueDefinition: ['description', 'name', 'directives'],
  InputObjectTypeDefinition: ['description', 'name', 'directives', 'fields'],
  DirectiveDefinition: ['description', 'name', 'arguments', 'locations'],
  SchemaExtension: ['directives', 'operationTypes'],
  ScalarTypeExtension: ['name', 'directives'],
  ObjectTypeExtension: ['name', 'interfaces', 'directives', 'fields'],
  InterfaceTypeExtension: ['name', 'interfaces', 'directives', 'fields'],
  UnionTypeExtension: ['name', 'directives', 'types'],
  EnumTypeExtension: ['name', 'directives', 'values'],
  InputObjectTypeExtension: ['name', 'directives', 'fields'],
};
const kindValues = new Set(Object.keys(QueryDocumentKeys));
/**
 * @internal
 */

function isNode(maybeNode) {
  const maybeKind =
    maybeNode === null || maybeNode === void 0 ? void 0 : maybeNode.kind;
  return typeof maybeKind === 'string' && kindValues.has(maybeKind);
}
/** Name */

let OperationTypeNode;

(function (OperationTypeNode) {
  OperationTypeNode['QUERY'] = 'query';
  OperationTypeNode['MUTATION'] = 'mutation';
  OperationTypeNode['SUBSCRIPTION'] = 'subscription';
})(OperationTypeNode || (OperationTypeNode = {}));


/***/ }),

/***/ 14515:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "LZ": function() { return /* binding */ printBlockString; },
/* harmony export */   "wv": function() { return /* binding */ dedentBlockStringLines; }
/* harmony export */ });
/* unused harmony export isPrintableAsBlockString */
/* harmony import */ var _characterClasses_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(80897);

/**
 * Produces the value of a block string from its parsed raw value, similar to
 * CoffeeScript's block string, Python's docstring trim or Ruby's strip_heredoc.
 *
 * This implements the GraphQL spec's BlockStringValue() static algorithm.
 *
 * @internal
 */

function dedentBlockStringLines(lines) {
  var _firstNonEmptyLine2;

  let commonIndent = Number.MAX_SAFE_INTEGER;
  let firstNonEmptyLine = null;
  let lastNonEmptyLine = -1;

  for (let i = 0; i < lines.length; ++i) {
    var _firstNonEmptyLine;

    const line = lines[i];
    const indent = leadingWhitespace(line);

    if (indent === line.length) {
      continue; // skip empty lines
    }

    firstNonEmptyLine =
      (_firstNonEmptyLine = firstNonEmptyLine) !== null &&
      _firstNonEmptyLine !== void 0
        ? _firstNonEmptyLine
        : i;
    lastNonEmptyLine = i;

    if (i !== 0 && indent < commonIndent) {
      commonIndent = indent;
    }
  }

  return lines // Remove common indentation from all lines but first.
    .map((line, i) => (i === 0 ? line : line.slice(commonIndent))) // Remove leading and trailing blank lines.
    .slice(
      (_firstNonEmptyLine2 = firstNonEmptyLine) !== null &&
        _firstNonEmptyLine2 !== void 0
        ? _firstNonEmptyLine2
        : 0,
      lastNonEmptyLine + 1,
    );
}

function leadingWhitespace(str) {
  let i = 0;

  while (i < str.length && (0,_characterClasses_mjs__WEBPACK_IMPORTED_MODULE_0__/* .isWhiteSpace */ .FD)(str.charCodeAt(i))) {
    ++i;
  }

  return i;
}
/**
 * @internal
 */

function isPrintableAsBlockString(value) {
  if (value === '') {
    return true; // empty string is printable
  }

  let isEmptyLine = true;
  let hasIndent = false;
  let hasCommonIndent = true;
  let seenNonEmptyLine = false;

  for (let i = 0; i < value.length; ++i) {
    switch (value.codePointAt(i)) {
      case 0x0000:
      case 0x0001:
      case 0x0002:
      case 0x0003:
      case 0x0004:
      case 0x0005:
      case 0x0006:
      case 0x0007:
      case 0x0008:
      case 0x000b:
      case 0x000c:
      case 0x000e:
      case 0x000f:
        return false;
      // Has non-printable characters

      case 0x000d:
        //  \r
        return false;
      // Has \r or \r\n which will be replaced as \n

      case 10:
        //  \n
        if (isEmptyLine && !seenNonEmptyLine) {
          return false; // Has leading new line
        }

        seenNonEmptyLine = true;
        isEmptyLine = true;
        hasIndent = false;
        break;

      case 9: //   \t

      case 32:
        //  <space>
        hasIndent || (hasIndent = isEmptyLine);
        break;

      default:
        hasCommonIndent && (hasCommonIndent = hasIndent);
        isEmptyLine = false;
    }
  }

  if (isEmptyLine) {
    return false; // Has trailing empty lines
  }

  if (hasCommonIndent && seenNonEmptyLine) {
    return false; // Has internal indent
  }

  return true;
}
/**
 * Print a block string in the indented block form by adding a leading and
 * trailing blank line. However, if a block string starts with whitespace and is
 * a single-line, adding a leading blank line would strip that whitespace.
 *
 * @internal
 */

function printBlockString(value, options) {
  const escapedValue = value.replace(/"""/g, '\\"""'); // Expand a block string's raw value into independent lines.

  const lines = escapedValue.split(/\r\n|[\n\r]/g);
  const isSingleLine = lines.length === 1; // If common indentation is found we can fix some of those cases by adding leading new line

  const forceLeadingNewLine =
    lines.length > 1 &&
    lines
      .slice(1)
      .every((line) => line.length === 0 || (0,_characterClasses_mjs__WEBPACK_IMPORTED_MODULE_0__/* .isWhiteSpace */ .FD)(line.charCodeAt(0))); // Trailing triple quotes just looks confusing but doesn't force trailing new line

  const hasTrailingTripleQuotes = escapedValue.endsWith('\\"""'); // Trailing quote (single or double) or slash forces trailing new line

  const hasTrailingQuote = value.endsWith('"') && !hasTrailingTripleQuotes;
  const hasTrailingSlash = value.endsWith('\\');
  const forceTrailingNewline = hasTrailingQuote || hasTrailingSlash;
  const printAsMultipleLines =
    !(options !== null && options !== void 0 && options.minimize) && // add leading and trailing new lines only if it improves readability
    (!isSingleLine ||
      value.length > 70 ||
      forceTrailingNewline ||
      forceLeadingNewLine ||
      hasTrailingTripleQuotes);
  let result = ''; // Format a multi-line block quote to account for leading space.

  const skipLeadingNewLine = isSingleLine && (0,_characterClasses_mjs__WEBPACK_IMPORTED_MODULE_0__/* .isWhiteSpace */ .FD)(value.charCodeAt(0));

  if ((printAsMultipleLines && !skipLeadingNewLine) || forceLeadingNewLine) {
    result += '\n';
  }

  result += escapedValue;

  if (printAsMultipleLines || forceTrailingNewline) {
    result += '\n';
  }

  return '"""' + result + '"""';
}


/***/ }),

/***/ 80897:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "FD": function() { return /* binding */ isWhiteSpace; },
/* harmony export */   "HQ": function() { return /* binding */ isNameContinue; },
/* harmony export */   "LQ": function() { return /* binding */ isNameStart; },
/* harmony export */   "X1": function() { return /* binding */ isDigit; }
/* harmony export */ });
/* unused harmony export isLetter */
/**
 * ```
 * WhiteSpace ::
 *   - "Horizontal Tab (U+0009)"
 *   - "Space (U+0020)"
 * ```
 * @internal
 */
function isWhiteSpace(code) {
  return code === 0x0009 || code === 0x0020;
}
/**
 * ```
 * Digit :: one of
 *   - `0` `1` `2` `3` `4` `5` `6` `7` `8` `9`
 * ```
 * @internal
 */

function isDigit(code) {
  return code >= 0x0030 && code <= 0x0039;
}
/**
 * ```
 * Letter :: one of
 *   - `A` `B` `C` `D` `E` `F` `G` `H` `I` `J` `K` `L` `M`
 *   - `N` `O` `P` `Q` `R` `S` `T` `U` `V` `W` `X` `Y` `Z`
 *   - `a` `b` `c` `d` `e` `f` `g` `h` `i` `j` `k` `l` `m`
 *   - `n` `o` `p` `q` `r` `s` `t` `u` `v` `w` `x` `y` `z`
 * ```
 * @internal
 */

function isLetter(code) {
  return (
    (code >= 0x0061 && code <= 0x007a) || // A-Z
    (code >= 0x0041 && code <= 0x005a) // a-z
  );
}
/**
 * ```
 * NameStart ::
 *   - Letter
 *   - `_`
 * ```
 * @internal
 */

function isNameStart(code) {
  return isLetter(code) || code === 0x005f;
}
/**
 * ```
 * NameContinue ::
 *   - Letter
 *   - Digit
 *   - `_`
 * ```
 * @internal
 */

function isNameContinue(code) {
  return isLetter(code) || isDigit(code) || code === 0x005f;
}


/***/ }),

/***/ 65797:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ Kind; }
/* harmony export */ });
/**
 * The set of allowed kind values for AST nodes.
 */
let Kind;
/**
 * The enum type representing the possible kind values of AST nodes.
 *
 * @deprecated Please use `Kind`. Will be remove in v17.
 */

(function (Kind) {
  Kind['NAME'] = 'Name';
  Kind['DOCUMENT'] = 'Document';
  Kind['OPERATION_DEFINITION'] = 'OperationDefinition';
  Kind['VARIABLE_DEFINITION'] = 'VariableDefinition';
  Kind['SELECTION_SET'] = 'SelectionSet';
  Kind['FIELD'] = 'Field';
  Kind['ARGUMENT'] = 'Argument';
  Kind['FRAGMENT_SPREAD'] = 'FragmentSpread';
  Kind['INLINE_FRAGMENT'] = 'InlineFragment';
  Kind['FRAGMENT_DEFINITION'] = 'FragmentDefinition';
  Kind['VARIABLE'] = 'Variable';
  Kind['INT'] = 'IntValue';
  Kind['FLOAT'] = 'FloatValue';
  Kind['STRING'] = 'StringValue';
  Kind['BOOLEAN'] = 'BooleanValue';
  Kind['NULL'] = 'NullValue';
  Kind['ENUM'] = 'EnumValue';
  Kind['LIST'] = 'ListValue';
  Kind['OBJECT'] = 'ObjectValue';
  Kind['OBJECT_FIELD'] = 'ObjectField';
  Kind['DIRECTIVE'] = 'Directive';
  Kind['NAMED_TYPE'] = 'NamedType';
  Kind['LIST_TYPE'] = 'ListType';
  Kind['NON_NULL_TYPE'] = 'NonNullType';
  Kind['SCHEMA_DEFINITION'] = 'SchemaDefinition';
  Kind['OPERATION_TYPE_DEFINITION'] = 'OperationTypeDefinition';
  Kind['SCALAR_TYPE_DEFINITION'] = 'ScalarTypeDefinition';
  Kind['OBJECT_TYPE_DEFINITION'] = 'ObjectTypeDefinition';
  Kind['FIELD_DEFINITION'] = 'FieldDefinition';
  Kind['INPUT_VALUE_DEFINITION'] = 'InputValueDefinition';
  Kind['INTERFACE_TYPE_DEFINITION'] = 'InterfaceTypeDefinition';
  Kind['UNION_TYPE_DEFINITION'] = 'UnionTypeDefinition';
  Kind['ENUM_TYPE_DEFINITION'] = 'EnumTypeDefinition';
  Kind['ENUM_VALUE_DEFINITION'] = 'EnumValueDefinition';
  Kind['INPUT_OBJECT_TYPE_DEFINITION'] = 'InputObjectTypeDefinition';
  Kind['DIRECTIVE_DEFINITION'] = 'DirectiveDefinition';
  Kind['SCHEMA_EXTENSION'] = 'SchemaExtension';
  Kind['SCALAR_TYPE_EXTENSION'] = 'ScalarTypeExtension';
  Kind['OBJECT_TYPE_EXTENSION'] = 'ObjectTypeExtension';
  Kind['INTERFACE_TYPE_EXTENSION'] = 'InterfaceTypeExtension';
  Kind['UNION_TYPE_EXTENSION'] = 'UnionTypeExtension';
  Kind['ENUM_TYPE_EXTENSION'] = 'EnumTypeExtension';
  Kind['INPUT_OBJECT_TYPE_EXTENSION'] = 'InputObjectTypeExtension';
})(Kind || (Kind = {}));


/***/ }),

/***/ 85448:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Qc": function() { return /* binding */ parse; }
});

// UNUSED EXPORTS: Parser, parseConstValue, parseType, parseValue

;// CONCATENATED MODULE: ../../.yarn/cache/graphql-npm-16.5.0-348f68b718-a82a926d08.zip/node_modules/graphql/jsutils/isObjectLike.mjs
/**
 * Return true if `value` is object-like. A value is object-like if it's not
 * `null` and has a `typeof` result of "object".
 */
function isObjectLike(value) {
  return typeof value == 'object' && value !== null;
}

;// CONCATENATED MODULE: ../../.yarn/cache/graphql-npm-16.5.0-348f68b718-a82a926d08.zip/node_modules/graphql/jsutils/invariant.mjs
function invariant(condition, message) {
  const booleanCondition = Boolean(condition);

  if (!booleanCondition) {
    throw new Error(
      message != null ? message : 'Unexpected invariant triggered.',
    );
  }
}

;// CONCATENATED MODULE: ../../.yarn/cache/graphql-npm-16.5.0-348f68b718-a82a926d08.zip/node_modules/graphql/language/location.mjs

const LineRegExp = /\r\n|[\n\r]/g;
/**
 * Represents a location in a Source.
 */

/**
 * Takes a Source and a UTF-8 character offset, and returns the corresponding
 * line and column as a SourceLocation.
 */
function getLocation(source, position) {
  let lastLineStart = 0;
  let line = 1;

  for (const match of source.body.matchAll(LineRegExp)) {
    typeof match.index === 'number' || invariant(false);

    if (match.index >= position) {
      break;
    }

    lastLineStart = match.index + match[0].length;
    line += 1;
  }

  return {
    line,
    column: position + 1 - lastLineStart,
  };
}

;// CONCATENATED MODULE: ../../.yarn/cache/graphql-npm-16.5.0-348f68b718-a82a926d08.zip/node_modules/graphql/language/printLocation.mjs


/**
 * Render a helpful description of the location in the GraphQL Source document.
 */
function printLocation(location) {
  return printSourceLocation(
    location.source,
    getLocation(location.source, location.start),
  );
}
/**
 * Render a helpful description of the location in the GraphQL Source document.
 */

function printSourceLocation(source, sourceLocation) {
  const firstLineColumnOffset = source.locationOffset.column - 1;
  const body = ''.padStart(firstLineColumnOffset) + source.body;
  const lineIndex = sourceLocation.line - 1;
  const lineOffset = source.locationOffset.line - 1;
  const lineNum = sourceLocation.line + lineOffset;
  const columnOffset = sourceLocation.line === 1 ? firstLineColumnOffset : 0;
  const columnNum = sourceLocation.column + columnOffset;
  const locationStr = `${source.name}:${lineNum}:${columnNum}\n`;
  const lines = body.split(/\r\n|[\n\r]/g);
  const locationLine = lines[lineIndex]; // Special case for minified documents

  if (locationLine.length > 120) {
    const subLineIndex = Math.floor(columnNum / 80);
    const subLineColumnNum = columnNum % 80;
    const subLines = [];

    for (let i = 0; i < locationLine.length; i += 80) {
      subLines.push(locationLine.slice(i, i + 80));
    }

    return (
      locationStr +
      printPrefixedLines([
        [`${lineNum} |`, subLines[0]],
        ...subLines.slice(1, subLineIndex + 1).map((subLine) => ['|', subLine]),
        ['|', '^'.padStart(subLineColumnNum)],
        ['|', subLines[subLineIndex + 1]],
      ])
    );
  }

  return (
    locationStr +
    printPrefixedLines([
      // Lines specified like this: ["prefix", "string"],
      [`${lineNum - 1} |`, lines[lineIndex - 1]],
      [`${lineNum} |`, locationLine],
      ['|', '^'.padStart(columnNum)],
      [`${lineNum + 1} |`, lines[lineIndex + 1]],
    ])
  );
}

function printPrefixedLines(lines) {
  const existingLines = lines.filter(([_, line]) => line !== undefined);
  const padLen = Math.max(...existingLines.map(([prefix]) => prefix.length));
  return existingLines
    .map(([prefix, line]) => prefix.padStart(padLen) + (line ? ' ' + line : ''))
    .join('\n');
}

;// CONCATENATED MODULE: ../../.yarn/cache/graphql-npm-16.5.0-348f68b718-a82a926d08.zip/node_modules/graphql/error/GraphQLError.mjs




function toNormalizedOptions(args) {
  const firstArg = args[0];

  if (firstArg == null || 'kind' in firstArg || 'length' in firstArg) {
    return {
      nodes: firstArg,
      source: args[1],
      positions: args[2],
      path: args[3],
      originalError: args[4],
      extensions: args[5],
    };
  }

  return firstArg;
}
/**
 * A GraphQLError describes an Error found during the parse, validate, or
 * execute phases of performing a GraphQL operation. In addition to a message
 * and stack trace, it also includes information about the locations in a
 * GraphQL document and/or execution result that correspond to the Error.
 */

class GraphQLError extends Error {
  /**
   * An array of `{ line, column }` locations within the source GraphQL document
   * which correspond to this error.
   *
   * Errors during validation often contain multiple locations, for example to
   * point out two things with the same name. Errors during execution include a
   * single location, the field which produced the error.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   */

  /**
   * An array describing the JSON-path into the execution response which
   * corresponds to this error. Only included for errors during execution.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   */

  /**
   * An array of GraphQL AST Nodes corresponding to this error.
   */

  /**
   * The source GraphQL document for the first location of this error.
   *
   * Note that if this Error represents more than one node, the source may not
   * represent nodes after the first node.
   */

  /**
   * An array of character offsets within the source GraphQL document
   * which correspond to this error.
   */

  /**
   * The original error thrown from a field resolver during execution.
   */

  /**
   * Extension fields to add to the formatted error.
   */

  /**
   * @deprecated Please use the `GraphQLErrorOptions` constructor overload instead.
   */
  constructor(message, ...rawArgs) {
    var _this$nodes, _nodeLocations$, _ref;

    const { nodes, source, positions, path, originalError, extensions } =
      toNormalizedOptions(rawArgs);
    super(message);
    this.name = 'GraphQLError';
    this.path = path !== null && path !== void 0 ? path : undefined;
    this.originalError =
      originalError !== null && originalError !== void 0
        ? originalError
        : undefined; // Compute list of blame nodes.

    this.nodes = undefinedIfEmpty(
      Array.isArray(nodes) ? nodes : nodes ? [nodes] : undefined,
    );
    const nodeLocations = undefinedIfEmpty(
      (_this$nodes = this.nodes) === null || _this$nodes === void 0
        ? void 0
        : _this$nodes.map((node) => node.loc).filter((loc) => loc != null),
    ); // Compute locations in the source for the given nodes/positions.

    this.source =
      source !== null && source !== void 0
        ? source
        : nodeLocations === null || nodeLocations === void 0
        ? void 0
        : (_nodeLocations$ = nodeLocations[0]) === null ||
          _nodeLocations$ === void 0
        ? void 0
        : _nodeLocations$.source;
    this.positions =
      positions !== null && positions !== void 0
        ? positions
        : nodeLocations === null || nodeLocations === void 0
        ? void 0
        : nodeLocations.map((loc) => loc.start);
    this.locations =
      positions && source
        ? positions.map((pos) => getLocation(source, pos))
        : nodeLocations === null || nodeLocations === void 0
        ? void 0
        : nodeLocations.map((loc) => getLocation(loc.source, loc.start));
    const originalExtensions = isObjectLike(
      originalError === null || originalError === void 0
        ? void 0
        : originalError.extensions,
    )
      ? originalError === null || originalError === void 0
        ? void 0
        : originalError.extensions
      : undefined;
    this.extensions =
      (_ref =
        extensions !== null && extensions !== void 0
          ? extensions
          : originalExtensions) !== null && _ref !== void 0
        ? _ref
        : Object.create(null); // Only properties prescribed by the spec should be enumerable.
    // Keep the rest as non-enumerable.

    Object.defineProperties(this, {
      message: {
        writable: true,
        enumerable: true,
      },
      name: {
        enumerable: false,
      },
      nodes: {
        enumerable: false,
      },
      source: {
        enumerable: false,
      },
      positions: {
        enumerable: false,
      },
      originalError: {
        enumerable: false,
      },
    }); // Include (non-enumerable) stack trace.

    /* c8 ignore start */
    // FIXME: https://github.com/graphql/graphql-js/issues/2317

    if (
      originalError !== null &&
      originalError !== void 0 &&
      originalError.stack
    ) {
      Object.defineProperty(this, 'stack', {
        value: originalError.stack,
        writable: true,
        configurable: true,
      });
    } else if (Error.captureStackTrace) {
      Error.captureStackTrace(this, GraphQLError);
    } else {
      Object.defineProperty(this, 'stack', {
        value: Error().stack,
        writable: true,
        configurable: true,
      });
    }
    /* c8 ignore stop */
  }

  get [Symbol.toStringTag]() {
    return 'GraphQLError';
  }

  toString() {
    let output = this.message;

    if (this.nodes) {
      for (const node of this.nodes) {
        if (node.loc) {
          output += '\n\n' + printLocation(node.loc);
        }
      }
    } else if (this.source && this.locations) {
      for (const location of this.locations) {
        output += '\n\n' + printSourceLocation(this.source, location);
      }
    }

    return output;
  }

  toJSON() {
    const formattedError = {
      message: this.message,
    };

    if (this.locations != null) {
      formattedError.locations = this.locations;
    }

    if (this.path != null) {
      formattedError.path = this.path;
    }

    if (this.extensions != null && Object.keys(this.extensions).length > 0) {
      formattedError.extensions = this.extensions;
    }

    return formattedError;
  }
}

function undefinedIfEmpty(array) {
  return array === undefined || array.length === 0 ? undefined : array;
}
/**
 * See: https://spec.graphql.org/draft/#sec-Errors
 */

/**
 * Prints a GraphQLError to a string, representing useful location information
 * about the error's position in the source.
 *
 * @deprecated Please use `error.toString` instead. Will be removed in v17
 */
function printError(error) {
  return error.toString();
}
/**
 * Given a GraphQLError, format it according to the rules described by the
 * Response Format, Errors section of the GraphQL Specification.
 *
 * @deprecated Please use `error.toJSON` instead. Will be removed in v17
 */

function formatError(error) {
  return error.toJSON();
}

;// CONCATENATED MODULE: ../../.yarn/cache/graphql-npm-16.5.0-348f68b718-a82a926d08.zip/node_modules/graphql/error/syntaxError.mjs

/**
 * Produces a GraphQLError representing a syntax error, containing useful
 * descriptive information about the syntax error's position in the source.
 */

function syntaxError(source, position, description) {
  return new GraphQLError(`Syntax Error: ${description}`, {
    source,
    positions: [position],
  });
}

// EXTERNAL MODULE: ../../.yarn/cache/graphql-npm-16.5.0-348f68b718-a82a926d08.zip/node_modules/graphql/language/ast.mjs
var ast = __webpack_require__(27794);
;// CONCATENATED MODULE: ../../.yarn/cache/graphql-npm-16.5.0-348f68b718-a82a926d08.zip/node_modules/graphql/language/directiveLocation.mjs
/**
 * The set of allowed directive location values.
 */
let DirectiveLocation;
/**
 * The enum type representing the directive location values.
 *
 * @deprecated Please use `DirectiveLocation`. Will be remove in v17.
 */

(function (DirectiveLocation) {
  DirectiveLocation['QUERY'] = 'QUERY';
  DirectiveLocation['MUTATION'] = 'MUTATION';
  DirectiveLocation['SUBSCRIPTION'] = 'SUBSCRIPTION';
  DirectiveLocation['FIELD'] = 'FIELD';
  DirectiveLocation['FRAGMENT_DEFINITION'] = 'FRAGMENT_DEFINITION';
  DirectiveLocation['FRAGMENT_SPREAD'] = 'FRAGMENT_SPREAD';
  DirectiveLocation['INLINE_FRAGMENT'] = 'INLINE_FRAGMENT';
  DirectiveLocation['VARIABLE_DEFINITION'] = 'VARIABLE_DEFINITION';
  DirectiveLocation['SCHEMA'] = 'SCHEMA';
  DirectiveLocation['SCALAR'] = 'SCALAR';
  DirectiveLocation['OBJECT'] = 'OBJECT';
  DirectiveLocation['FIELD_DEFINITION'] = 'FIELD_DEFINITION';
  DirectiveLocation['ARGUMENT_DEFINITION'] = 'ARGUMENT_DEFINITION';
  DirectiveLocation['INTERFACE'] = 'INTERFACE';
  DirectiveLocation['UNION'] = 'UNION';
  DirectiveLocation['ENUM'] = 'ENUM';
  DirectiveLocation['ENUM_VALUE'] = 'ENUM_VALUE';
  DirectiveLocation['INPUT_OBJECT'] = 'INPUT_OBJECT';
  DirectiveLocation['INPUT_FIELD_DEFINITION'] = 'INPUT_FIELD_DEFINITION';
})(DirectiveLocation || (DirectiveLocation = {}));

// EXTERNAL MODULE: ../../.yarn/cache/graphql-npm-16.5.0-348f68b718-a82a926d08.zip/node_modules/graphql/language/kinds.mjs
var kinds = __webpack_require__(65797);
// EXTERNAL MODULE: ../../.yarn/cache/graphql-npm-16.5.0-348f68b718-a82a926d08.zip/node_modules/graphql/language/blockString.mjs
var blockString = __webpack_require__(14515);
// EXTERNAL MODULE: ../../.yarn/cache/graphql-npm-16.5.0-348f68b718-a82a926d08.zip/node_modules/graphql/language/characterClasses.mjs
var characterClasses = __webpack_require__(80897);
;// CONCATENATED MODULE: ../../.yarn/cache/graphql-npm-16.5.0-348f68b718-a82a926d08.zip/node_modules/graphql/language/tokenKind.mjs
/**
 * An exported enum describing the different kinds of tokens that the
 * lexer emits.
 */
let tokenKind_TokenKind;
/**
 * The enum type representing the token kinds values.
 *
 * @deprecated Please use `TokenKind`. Will be remove in v17.
 */

(function (TokenKind) {
  TokenKind['SOF'] = '<SOF>';
  TokenKind['EOF'] = '<EOF>';
  TokenKind['BANG'] = '!';
  TokenKind['DOLLAR'] = '$';
  TokenKind['AMP'] = '&';
  TokenKind['PAREN_L'] = '(';
  TokenKind['PAREN_R'] = ')';
  TokenKind['SPREAD'] = '...';
  TokenKind['COLON'] = ':';
  TokenKind['EQUALS'] = '=';
  TokenKind['AT'] = '@';
  TokenKind['BRACKET_L'] = '[';
  TokenKind['BRACKET_R'] = ']';
  TokenKind['BRACE_L'] = '{';
  TokenKind['PIPE'] = '|';
  TokenKind['BRACE_R'] = '}';
  TokenKind['NAME'] = 'Name';
  TokenKind['INT'] = 'Int';
  TokenKind['FLOAT'] = 'Float';
  TokenKind['STRING'] = 'String';
  TokenKind['BLOCK_STRING'] = 'BlockString';
  TokenKind['COMMENT'] = 'Comment';
})(tokenKind_TokenKind || (tokenKind_TokenKind = {}));

;// CONCATENATED MODULE: ../../.yarn/cache/graphql-npm-16.5.0-348f68b718-a82a926d08.zip/node_modules/graphql/language/lexer.mjs





/**
 * Given a Source object, creates a Lexer for that source.
 * A Lexer is a stateful stream generator in that every time
 * it is advanced, it returns the next token in the Source. Assuming the
 * source lexes, the final Token emitted by the lexer will be of kind
 * EOF, after which the lexer will repeatedly return the same EOF token
 * whenever called.
 */

class Lexer {
  /**
   * The previously focused non-ignored token.
   */

  /**
   * The currently focused non-ignored token.
   */

  /**
   * The (1-indexed) line containing the current token.
   */

  /**
   * The character offset at which the current line begins.
   */
  constructor(source) {
    const startOfFileToken = new ast/* Token */.WU(tokenKind_TokenKind.SOF, 0, 0, 0, 0);
    this.source = source;
    this.lastToken = startOfFileToken;
    this.token = startOfFileToken;
    this.line = 1;
    this.lineStart = 0;
  }

  get [Symbol.toStringTag]() {
    return 'Lexer';
  }
  /**
   * Advances the token stream to the next non-ignored token.
   */

  advance() {
    this.lastToken = this.token;
    const token = (this.token = this.lookahead());
    return token;
  }
  /**
   * Looks ahead and returns the next non-ignored token, but does not change
   * the state of Lexer.
   */

  lookahead() {
    let token = this.token;

    if (token.kind !== tokenKind_TokenKind.EOF) {
      do {
        if (token.next) {
          token = token.next;
        } else {
          // Read the next token and form a link in the token linked-list.
          const nextToken = readNextToken(this, token.end); // @ts-expect-error next is only mutable during parsing.

          token.next = nextToken; // @ts-expect-error prev is only mutable during parsing.

          nextToken.prev = token;
          token = nextToken;
        }
      } while (token.kind === tokenKind_TokenKind.COMMENT);
    }

    return token;
  }
}
/**
 * @internal
 */

function isPunctuatorTokenKind(kind) {
  return (
    kind === tokenKind_TokenKind.BANG ||
    kind === tokenKind_TokenKind.DOLLAR ||
    kind === tokenKind_TokenKind.AMP ||
    kind === tokenKind_TokenKind.PAREN_L ||
    kind === tokenKind_TokenKind.PAREN_R ||
    kind === tokenKind_TokenKind.SPREAD ||
    kind === tokenKind_TokenKind.COLON ||
    kind === tokenKind_TokenKind.EQUALS ||
    kind === tokenKind_TokenKind.AT ||
    kind === tokenKind_TokenKind.BRACKET_L ||
    kind === tokenKind_TokenKind.BRACKET_R ||
    kind === tokenKind_TokenKind.BRACE_L ||
    kind === tokenKind_TokenKind.PIPE ||
    kind === tokenKind_TokenKind.BRACE_R
  );
}
/**
 * A Unicode scalar value is any Unicode code point except surrogate code
 * points. In other words, the inclusive ranges of values 0x0000 to 0xD7FF and
 * 0xE000 to 0x10FFFF.
 *
 * SourceCharacter ::
 *   - "Any Unicode scalar value"
 */

function isUnicodeScalarValue(code) {
  return (
    (code >= 0x0000 && code <= 0xd7ff) || (code >= 0xe000 && code <= 0x10ffff)
  );
}
/**
 * The GraphQL specification defines source text as a sequence of unicode scalar
 * values (which Unicode defines to exclude surrogate code points). However
 * JavaScript defines strings as a sequence of UTF-16 code units which may
 * include surrogates. A surrogate pair is a valid source character as it
 * encodes a supplementary code point (above U+FFFF), but unpaired surrogate
 * code points are not valid source characters.
 */

function isSupplementaryCodePoint(body, location) {
  return (
    isLeadingSurrogate(body.charCodeAt(location)) &&
    isTrailingSurrogate(body.charCodeAt(location + 1))
  );
}

function isLeadingSurrogate(code) {
  return code >= 0xd800 && code <= 0xdbff;
}

function isTrailingSurrogate(code) {
  return code >= 0xdc00 && code <= 0xdfff;
}
/**
 * Prints the code point (or end of file reference) at a given location in a
 * source for use in error messages.
 *
 * Printable ASCII is printed quoted, while other points are printed in Unicode
 * code point form (ie. U+1234).
 */

function printCodePointAt(lexer, location) {
  const code = lexer.source.body.codePointAt(location);

  if (code === undefined) {
    return tokenKind_TokenKind.EOF;
  } else if (code >= 0x0020 && code <= 0x007e) {
    // Printable ASCII
    const char = String.fromCodePoint(code);
    return char === '"' ? "'\"'" : `"${char}"`;
  } // Unicode code point

  return 'U+' + code.toString(16).toUpperCase().padStart(4, '0');
}
/**
 * Create a token with line and column location information.
 */

function createToken(lexer, kind, start, end, value) {
  const line = lexer.line;
  const col = 1 + start - lexer.lineStart;
  return new ast/* Token */.WU(kind, start, end, line, col, value);
}
/**
 * Gets the next token from the source starting at the given position.
 *
 * This skips over whitespace until it finds the next lexable token, then lexes
 * punctuators immediately or calls the appropriate helper function for more
 * complicated tokens.
 */

function readNextToken(lexer, start) {
  const body = lexer.source.body;
  const bodyLength = body.length;
  let position = start;

  while (position < bodyLength) {
    const code = body.charCodeAt(position); // SourceCharacter

    switch (code) {
      // Ignored ::
      //   - UnicodeBOM
      //   - WhiteSpace
      //   - LineTerminator
      //   - Comment
      //   - Comma
      //
      // UnicodeBOM :: "Byte Order Mark (U+FEFF)"
      //
      // WhiteSpace ::
      //   - "Horizontal Tab (U+0009)"
      //   - "Space (U+0020)"
      //
      // Comma :: ,
      case 0xfeff: // <BOM>

      case 0x0009: // \t

      case 0x0020: // <space>

      case 0x002c:
        // ,
        ++position;
        continue;
      // LineTerminator ::
      //   - "New Line (U+000A)"
      //   - "Carriage Return (U+000D)" [lookahead != "New Line (U+000A)"]
      //   - "Carriage Return (U+000D)" "New Line (U+000A)"

      case 0x000a:
        // \n
        ++position;
        ++lexer.line;
        lexer.lineStart = position;
        continue;

      case 0x000d:
        // \r
        if (body.charCodeAt(position + 1) === 0x000a) {
          position += 2;
        } else {
          ++position;
        }

        ++lexer.line;
        lexer.lineStart = position;
        continue;
      // Comment

      case 0x0023:
        // #
        return readComment(lexer, position);
      // Token ::
      //   - Punctuator
      //   - Name
      //   - IntValue
      //   - FloatValue
      //   - StringValue
      //
      // Punctuator :: one of ! $ & ( ) ... : = @ [ ] { | }

      case 0x0021:
        // !
        return createToken(lexer, tokenKind_TokenKind.BANG, position, position + 1);

      case 0x0024:
        // $
        return createToken(lexer, tokenKind_TokenKind.DOLLAR, position, position + 1);

      case 0x0026:
        // &
        return createToken(lexer, tokenKind_TokenKind.AMP, position, position + 1);

      case 0x0028:
        // (
        return createToken(lexer, tokenKind_TokenKind.PAREN_L, position, position + 1);

      case 0x0029:
        // )
        return createToken(lexer, tokenKind_TokenKind.PAREN_R, position, position + 1);

      case 0x002e:
        // .
        if (
          body.charCodeAt(position + 1) === 0x002e &&
          body.charCodeAt(position + 2) === 0x002e
        ) {
          return createToken(lexer, tokenKind_TokenKind.SPREAD, position, position + 3);
        }

        break;

      case 0x003a:
        // :
        return createToken(lexer, tokenKind_TokenKind.COLON, position, position + 1);

      case 0x003d:
        // =
        return createToken(lexer, tokenKind_TokenKind.EQUALS, position, position + 1);

      case 0x0040:
        // @
        return createToken(lexer, tokenKind_TokenKind.AT, position, position + 1);

      case 0x005b:
        // [
        return createToken(lexer, tokenKind_TokenKind.BRACKET_L, position, position + 1);

      case 0x005d:
        // ]
        return createToken(lexer, tokenKind_TokenKind.BRACKET_R, position, position + 1);

      case 0x007b:
        // {
        return createToken(lexer, tokenKind_TokenKind.BRACE_L, position, position + 1);

      case 0x007c:
        // |
        return createToken(lexer, tokenKind_TokenKind.PIPE, position, position + 1);

      case 0x007d:
        // }
        return createToken(lexer, tokenKind_TokenKind.BRACE_R, position, position + 1);
      // StringValue

      case 0x0022:
        // "
        if (
          body.charCodeAt(position + 1) === 0x0022 &&
          body.charCodeAt(position + 2) === 0x0022
        ) {
          return readBlockString(lexer, position);
        }

        return readString(lexer, position);
    } // IntValue | FloatValue (Digit | -)

    if ((0,characterClasses/* isDigit */.X1)(code) || code === 0x002d) {
      return readNumber(lexer, position, code);
    } // Name

    if ((0,characterClasses/* isNameStart */.LQ)(code)) {
      return readName(lexer, position);
    }

    throw syntaxError(
      lexer.source,
      position,
      code === 0x0027
        ? 'Unexpected single quote character (\'), did you mean to use a double quote (")?'
        : isUnicodeScalarValue(code) || isSupplementaryCodePoint(body, position)
        ? `Unexpected character: ${printCodePointAt(lexer, position)}.`
        : `Invalid character: ${printCodePointAt(lexer, position)}.`,
    );
  }

  return createToken(lexer, tokenKind_TokenKind.EOF, bodyLength, bodyLength);
}
/**
 * Reads a comment token from the source file.
 *
 * ```
 * Comment :: # CommentChar* [lookahead != CommentChar]
 *
 * CommentChar :: SourceCharacter but not LineTerminator
 * ```
 */

function readComment(lexer, start) {
  const body = lexer.source.body;
  const bodyLength = body.length;
  let position = start + 1;

  while (position < bodyLength) {
    const code = body.charCodeAt(position); // LineTerminator (\n | \r)

    if (code === 0x000a || code === 0x000d) {
      break;
    } // SourceCharacter

    if (isUnicodeScalarValue(code)) {
      ++position;
    } else if (isSupplementaryCodePoint(body, position)) {
      position += 2;
    } else {
      break;
    }
  }

  return createToken(
    lexer,
    tokenKind_TokenKind.COMMENT,
    start,
    position,
    body.slice(start + 1, position),
  );
}
/**
 * Reads a number token from the source file, either a FloatValue or an IntValue
 * depending on whether a FractionalPart or ExponentPart is encountered.
 *
 * ```
 * IntValue :: IntegerPart [lookahead != {Digit, `.`, NameStart}]
 *
 * IntegerPart ::
 *   - NegativeSign? 0
 *   - NegativeSign? NonZeroDigit Digit*
 *
 * NegativeSign :: -
 *
 * NonZeroDigit :: Digit but not `0`
 *
 * FloatValue ::
 *   - IntegerPart FractionalPart ExponentPart [lookahead != {Digit, `.`, NameStart}]
 *   - IntegerPart FractionalPart [lookahead != {Digit, `.`, NameStart}]
 *   - IntegerPart ExponentPart [lookahead != {Digit, `.`, NameStart}]
 *
 * FractionalPart :: . Digit+
 *
 * ExponentPart :: ExponentIndicator Sign? Digit+
 *
 * ExponentIndicator :: one of `e` `E`
 *
 * Sign :: one of + -
 * ```
 */

function readNumber(lexer, start, firstCode) {
  const body = lexer.source.body;
  let position = start;
  let code = firstCode;
  let isFloat = false; // NegativeSign (-)

  if (code === 0x002d) {
    code = body.charCodeAt(++position);
  } // Zero (0)

  if (code === 0x0030) {
    code = body.charCodeAt(++position);

    if ((0,characterClasses/* isDigit */.X1)(code)) {
      throw syntaxError(
        lexer.source,
        position,
        `Invalid number, unexpected digit after 0: ${printCodePointAt(
          lexer,
          position,
        )}.`,
      );
    }
  } else {
    position = readDigits(lexer, position, code);
    code = body.charCodeAt(position);
  } // Full stop (.)

  if (code === 0x002e) {
    isFloat = true;
    code = body.charCodeAt(++position);
    position = readDigits(lexer, position, code);
    code = body.charCodeAt(position);
  } // E e

  if (code === 0x0045 || code === 0x0065) {
    isFloat = true;
    code = body.charCodeAt(++position); // + -

    if (code === 0x002b || code === 0x002d) {
      code = body.charCodeAt(++position);
    }

    position = readDigits(lexer, position, code);
    code = body.charCodeAt(position);
  } // Numbers cannot be followed by . or NameStart

  if (code === 0x002e || (0,characterClasses/* isNameStart */.LQ)(code)) {
    throw syntaxError(
      lexer.source,
      position,
      `Invalid number, expected digit but got: ${printCodePointAt(
        lexer,
        position,
      )}.`,
    );
  }

  return createToken(
    lexer,
    isFloat ? tokenKind_TokenKind.FLOAT : tokenKind_TokenKind.INT,
    start,
    position,
    body.slice(start, position),
  );
}
/**
 * Returns the new position in the source after reading one or more digits.
 */

function readDigits(lexer, start, firstCode) {
  if (!(0,characterClasses/* isDigit */.X1)(firstCode)) {
    throw syntaxError(
      lexer.source,
      start,
      `Invalid number, expected digit but got: ${printCodePointAt(
        lexer,
        start,
      )}.`,
    );
  }

  const body = lexer.source.body;
  let position = start + 1; // +1 to skip first firstCode

  while ((0,characterClasses/* isDigit */.X1)(body.charCodeAt(position))) {
    ++position;
  }

  return position;
}
/**
 * Reads a single-quote string token from the source file.
 *
 * ```
 * StringValue ::
 *   - `""` [lookahead != `"`]
 *   - `"` StringCharacter+ `"`
 *
 * StringCharacter ::
 *   - SourceCharacter but not `"` or `\` or LineTerminator
 *   - `\u` EscapedUnicode
 *   - `\` EscapedCharacter
 *
 * EscapedUnicode ::
 *   - `{` HexDigit+ `}`
 *   - HexDigit HexDigit HexDigit HexDigit
 *
 * EscapedCharacter :: one of `"` `\` `/` `b` `f` `n` `r` `t`
 * ```
 */

function readString(lexer, start) {
  const body = lexer.source.body;
  const bodyLength = body.length;
  let position = start + 1;
  let chunkStart = position;
  let value = '';

  while (position < bodyLength) {
    const code = body.charCodeAt(position); // Closing Quote (")

    if (code === 0x0022) {
      value += body.slice(chunkStart, position);
      return createToken(lexer, tokenKind_TokenKind.STRING, start, position + 1, value);
    } // Escape Sequence (\)

    if (code === 0x005c) {
      value += body.slice(chunkStart, position);
      const escape =
        body.charCodeAt(position + 1) === 0x0075 // u
          ? body.charCodeAt(position + 2) === 0x007b // {
            ? readEscapedUnicodeVariableWidth(lexer, position)
            : readEscapedUnicodeFixedWidth(lexer, position)
          : readEscapedCharacter(lexer, position);
      value += escape.value;
      position += escape.size;
      chunkStart = position;
      continue;
    } // LineTerminator (\n | \r)

    if (code === 0x000a || code === 0x000d) {
      break;
    } // SourceCharacter

    if (isUnicodeScalarValue(code)) {
      ++position;
    } else if (isSupplementaryCodePoint(body, position)) {
      position += 2;
    } else {
      throw syntaxError(
        lexer.source,
        position,
        `Invalid character within String: ${printCodePointAt(
          lexer,
          position,
        )}.`,
      );
    }
  }

  throw syntaxError(lexer.source, position, 'Unterminated string.');
} // The string value and lexed size of an escape sequence.

function readEscapedUnicodeVariableWidth(lexer, position) {
  const body = lexer.source.body;
  let point = 0;
  let size = 3; // Cannot be larger than 12 chars (\u{00000000}).

  while (size < 12) {
    const code = body.charCodeAt(position + size++); // Closing Brace (})

    if (code === 0x007d) {
      // Must be at least 5 chars (\u{0}) and encode a Unicode scalar value.
      if (size < 5 || !isUnicodeScalarValue(point)) {
        break;
      }

      return {
        value: String.fromCodePoint(point),
        size,
      };
    } // Append this hex digit to the code point.

    point = (point << 4) | readHexDigit(code);

    if (point < 0) {
      break;
    }
  }

  throw syntaxError(
    lexer.source,
    position,
    `Invalid Unicode escape sequence: "${body.slice(
      position,
      position + size,
    )}".`,
  );
}

function readEscapedUnicodeFixedWidth(lexer, position) {
  const body = lexer.source.body;
  const code = read16BitHexCode(body, position + 2);

  if (isUnicodeScalarValue(code)) {
    return {
      value: String.fromCodePoint(code),
      size: 6,
    };
  } // GraphQL allows JSON-style surrogate pair escape sequences, but only when
  // a valid pair is formed.

  if (isLeadingSurrogate(code)) {
    // \u
    if (
      body.charCodeAt(position + 6) === 0x005c &&
      body.charCodeAt(position + 7) === 0x0075
    ) {
      const trailingCode = read16BitHexCode(body, position + 8);

      if (isTrailingSurrogate(trailingCode)) {
        // JavaScript defines strings as a sequence of UTF-16 code units and
        // encodes Unicode code points above U+FFFF using a surrogate pair of
        // code units. Since this is a surrogate pair escape sequence, just
        // include both codes into the JavaScript string value. Had JavaScript
        // not been internally based on UTF-16, then this surrogate pair would
        // be decoded to retrieve the supplementary code point.
        return {
          value: String.fromCodePoint(code, trailingCode),
          size: 12,
        };
      }
    }
  }

  throw syntaxError(
    lexer.source,
    position,
    `Invalid Unicode escape sequence: "${body.slice(position, position + 6)}".`,
  );
}
/**
 * Reads four hexadecimal characters and returns the positive integer that 16bit
 * hexadecimal string represents. For example, "000f" will return 15, and "dead"
 * will return 57005.
 *
 * Returns a negative number if any char was not a valid hexadecimal digit.
 */

function read16BitHexCode(body, position) {
  // readHexDigit() returns -1 on error. ORing a negative value with any other
  // value always produces a negative value.
  return (
    (readHexDigit(body.charCodeAt(position)) << 12) |
    (readHexDigit(body.charCodeAt(position + 1)) << 8) |
    (readHexDigit(body.charCodeAt(position + 2)) << 4) |
    readHexDigit(body.charCodeAt(position + 3))
  );
}
/**
 * Reads a hexadecimal character and returns its positive integer value (0-15).
 *
 * '0' becomes 0, '9' becomes 9
 * 'A' becomes 10, 'F' becomes 15
 * 'a' becomes 10, 'f' becomes 15
 *
 * Returns -1 if the provided character code was not a valid hexadecimal digit.
 *
 * HexDigit :: one of
 *   - `0` `1` `2` `3` `4` `5` `6` `7` `8` `9`
 *   - `A` `B` `C` `D` `E` `F`
 *   - `a` `b` `c` `d` `e` `f`
 */

function readHexDigit(code) {
  return code >= 0x0030 && code <= 0x0039 // 0-9
    ? code - 0x0030
    : code >= 0x0041 && code <= 0x0046 // A-F
    ? code - 0x0037
    : code >= 0x0061 && code <= 0x0066 // a-f
    ? code - 0x0057
    : -1;
}
/**
 * | Escaped Character | Code Point | Character Name               |
 * | ----------------- | ---------- | ---------------------------- |
 * | `"`               | U+0022     | double quote                 |
 * | `\`               | U+005C     | reverse solidus (back slash) |
 * | `/`               | U+002F     | solidus (forward slash)      |
 * | `b`               | U+0008     | backspace                    |
 * | `f`               | U+000C     | form feed                    |
 * | `n`               | U+000A     | line feed (new line)         |
 * | `r`               | U+000D     | carriage return              |
 * | `t`               | U+0009     | horizontal tab               |
 */

function readEscapedCharacter(lexer, position) {
  const body = lexer.source.body;
  const code = body.charCodeAt(position + 1);

  switch (code) {
    case 0x0022:
      // "
      return {
        value: '\u0022',
        size: 2,
      };

    case 0x005c:
      // \
      return {
        value: '\u005c',
        size: 2,
      };

    case 0x002f:
      // /
      return {
        value: '\u002f',
        size: 2,
      };

    case 0x0062:
      // b
      return {
        value: '\u0008',
        size: 2,
      };

    case 0x0066:
      // f
      return {
        value: '\u000c',
        size: 2,
      };

    case 0x006e:
      // n
      return {
        value: '\u000a',
        size: 2,
      };

    case 0x0072:
      // r
      return {
        value: '\u000d',
        size: 2,
      };

    case 0x0074:
      // t
      return {
        value: '\u0009',
        size: 2,
      };
  }

  throw syntaxError(
    lexer.source,
    position,
    `Invalid character escape sequence: "${body.slice(
      position,
      position + 2,
    )}".`,
  );
}
/**
 * Reads a block string token from the source file.
 *
 * ```
 * StringValue ::
 *   - `"""` BlockStringCharacter* `"""`
 *
 * BlockStringCharacter ::
 *   - SourceCharacter but not `"""` or `\"""`
 *   - `\"""`
 * ```
 */

function readBlockString(lexer, start) {
  const body = lexer.source.body;
  const bodyLength = body.length;
  let lineStart = lexer.lineStart;
  let position = start + 3;
  let chunkStart = position;
  let currentLine = '';
  const blockLines = [];

  while (position < bodyLength) {
    const code = body.charCodeAt(position); // Closing Triple-Quote (""")

    if (
      code === 0x0022 &&
      body.charCodeAt(position + 1) === 0x0022 &&
      body.charCodeAt(position + 2) === 0x0022
    ) {
      currentLine += body.slice(chunkStart, position);
      blockLines.push(currentLine);
      const token = createToken(
        lexer,
        tokenKind_TokenKind.BLOCK_STRING,
        start,
        position + 3, // Return a string of the lines joined with U+000A.
        (0,blockString/* dedentBlockStringLines */.wv)(blockLines).join('\n'),
      );
      lexer.line += blockLines.length - 1;
      lexer.lineStart = lineStart;
      return token;
    } // Escaped Triple-Quote (\""")

    if (
      code === 0x005c &&
      body.charCodeAt(position + 1) === 0x0022 &&
      body.charCodeAt(position + 2) === 0x0022 &&
      body.charCodeAt(position + 3) === 0x0022
    ) {
      currentLine += body.slice(chunkStart, position);
      chunkStart = position + 1; // skip only slash

      position += 4;
      continue;
    } // LineTerminator

    if (code === 0x000a || code === 0x000d) {
      currentLine += body.slice(chunkStart, position);
      blockLines.push(currentLine);

      if (code === 0x000d && body.charCodeAt(position + 1) === 0x000a) {
        position += 2;
      } else {
        ++position;
      }

      currentLine = '';
      chunkStart = position;
      lineStart = position;
      continue;
    } // SourceCharacter

    if (isUnicodeScalarValue(code)) {
      ++position;
    } else if (isSupplementaryCodePoint(body, position)) {
      position += 2;
    } else {
      throw syntaxError(
        lexer.source,
        position,
        `Invalid character within String: ${printCodePointAt(
          lexer,
          position,
        )}.`,
      );
    }
  }

  throw syntaxError(lexer.source, position, 'Unterminated string.');
}
/**
 * Reads an alphanumeric + underscore name from the source.
 *
 * ```
 * Name ::
 *   - NameStart NameContinue* [lookahead != NameContinue]
 * ```
 */

function readName(lexer, start) {
  const body = lexer.source.body;
  const bodyLength = body.length;
  let position = start + 1;

  while (position < bodyLength) {
    const code = body.charCodeAt(position);

    if ((0,characterClasses/* isNameContinue */.HQ)(code)) {
      ++position;
    } else {
      break;
    }
  }

  return createToken(
    lexer,
    tokenKind_TokenKind.NAME,
    start,
    position,
    body.slice(start, position),
  );
}

// EXTERNAL MODULE: ../../.yarn/cache/graphql-npm-16.5.0-348f68b718-a82a926d08.zip/node_modules/graphql/language/source.mjs + 1 modules
var language_source = __webpack_require__(81052);
;// CONCATENATED MODULE: ../../.yarn/cache/graphql-npm-16.5.0-348f68b718-a82a926d08.zip/node_modules/graphql/language/parser.mjs







/**
 * Configuration options to control parser behavior
 */

/**
 * Given a GraphQL source, parses it into a Document.
 * Throws GraphQLError if a syntax error is encountered.
 */
function parse(source, options) {
  const parser = new Parser(source, options);
  return parser.parseDocument();
}
/**
 * Given a string containing a GraphQL value (ex. `[42]`), parse the AST for
 * that value.
 * Throws GraphQLError if a syntax error is encountered.
 *
 * This is useful within tools that operate upon GraphQL Values directly and
 * in isolation of complete GraphQL documents.
 *
 * Consider providing the results to the utility function: valueFromAST().
 */

function parseValue(source, options) {
  const parser = new Parser(source, options);
  parser.expectToken(TokenKind.SOF);
  const value = parser.parseValueLiteral(false);
  parser.expectToken(TokenKind.EOF);
  return value;
}
/**
 * Similar to parseValue(), but raises a parse error if it encounters a
 * variable. The return type will be a constant value.
 */

function parseConstValue(source, options) {
  const parser = new Parser(source, options);
  parser.expectToken(TokenKind.SOF);
  const value = parser.parseConstValueLiteral();
  parser.expectToken(TokenKind.EOF);
  return value;
}
/**
 * Given a string containing a GraphQL Type (ex. `[Int!]`), parse the AST for
 * that type.
 * Throws GraphQLError if a syntax error is encountered.
 *
 * This is useful within tools that operate upon GraphQL Types directly and
 * in isolation of complete GraphQL documents.
 *
 * Consider providing the results to the utility function: typeFromAST().
 */

function parseType(source, options) {
  const parser = new Parser(source, options);
  parser.expectToken(TokenKind.SOF);
  const type = parser.parseTypeReference();
  parser.expectToken(TokenKind.EOF);
  return type;
}
/**
 * This class is exported only to assist people in implementing their own parsers
 * without duplicating too much code and should be used only as last resort for cases
 * such as experimental syntax or if certain features could not be contributed upstream.
 *
 * It is still part of the internal API and is versioned, so any changes to it are never
 * considered breaking changes. If you still need to support multiple versions of the
 * library, please use the `versionInfo` variable for version detection.
 *
 * @internal
 */

class Parser {
  constructor(source, options) {
    const sourceObj = (0,language_source/* isSource */.T)(source) ? source : new language_source/* Source */.H(source);
    this._lexer = new Lexer(sourceObj);
    this._options = options;
  }
  /**
   * Converts a name lex token into a name parse node.
   */

  parseName() {
    const token = this.expectToken(tokenKind_TokenKind.NAME);
    return this.node(token, {
      kind: kinds/* Kind.NAME */.h.NAME,
      value: token.value,
    });
  } // Implements the parsing rules in the Document section.

  /**
   * Document : Definition+
   */

  parseDocument() {
    return this.node(this._lexer.token, {
      kind: kinds/* Kind.DOCUMENT */.h.DOCUMENT,
      definitions: this.many(
        tokenKind_TokenKind.SOF,
        this.parseDefinition,
        tokenKind_TokenKind.EOF,
      ),
    });
  }
  /**
   * Definition :
   *   - ExecutableDefinition
   *   - TypeSystemDefinition
   *   - TypeSystemExtension
   *
   * ExecutableDefinition :
   *   - OperationDefinition
   *   - FragmentDefinition
   *
   * TypeSystemDefinition :
   *   - SchemaDefinition
   *   - TypeDefinition
   *   - DirectiveDefinition
   *
   * TypeDefinition :
   *   - ScalarTypeDefinition
   *   - ObjectTypeDefinition
   *   - InterfaceTypeDefinition
   *   - UnionTypeDefinition
   *   - EnumTypeDefinition
   *   - InputObjectTypeDefinition
   */

  parseDefinition() {
    if (this.peek(tokenKind_TokenKind.BRACE_L)) {
      return this.parseOperationDefinition();
    } // Many definitions begin with a description and require a lookahead.

    const hasDescription = this.peekDescription();
    const keywordToken = hasDescription
      ? this._lexer.lookahead()
      : this._lexer.token;

    if (keywordToken.kind === tokenKind_TokenKind.NAME) {
      switch (keywordToken.value) {
        case 'schema':
          return this.parseSchemaDefinition();

        case 'scalar':
          return this.parseScalarTypeDefinition();

        case 'type':
          return this.parseObjectTypeDefinition();

        case 'interface':
          return this.parseInterfaceTypeDefinition();

        case 'union':
          return this.parseUnionTypeDefinition();

        case 'enum':
          return this.parseEnumTypeDefinition();

        case 'input':
          return this.parseInputObjectTypeDefinition();

        case 'directive':
          return this.parseDirectiveDefinition();
      }

      if (hasDescription) {
        throw syntaxError(
          this._lexer.source,
          this._lexer.token.start,
          'Unexpected description, descriptions are supported only on type definitions.',
        );
      }

      switch (keywordToken.value) {
        case 'query':
        case 'mutation':
        case 'subscription':
          return this.parseOperationDefinition();

        case 'fragment':
          return this.parseFragmentDefinition();

        case 'extend':
          return this.parseTypeSystemExtension();
      }
    }

    throw this.unexpected(keywordToken);
  } // Implements the parsing rules in the Operations section.

  /**
   * OperationDefinition :
   *  - SelectionSet
   *  - OperationType Name? VariableDefinitions? Directives? SelectionSet
   */

  parseOperationDefinition() {
    const start = this._lexer.token;

    if (this.peek(tokenKind_TokenKind.BRACE_L)) {
      return this.node(start, {
        kind: kinds/* Kind.OPERATION_DEFINITION */.h.OPERATION_DEFINITION,
        operation: ast/* OperationTypeNode.QUERY */.ku.QUERY,
        name: undefined,
        variableDefinitions: [],
        directives: [],
        selectionSet: this.parseSelectionSet(),
      });
    }

    const operation = this.parseOperationType();
    let name;

    if (this.peek(tokenKind_TokenKind.NAME)) {
      name = this.parseName();
    }

    return this.node(start, {
      kind: kinds/* Kind.OPERATION_DEFINITION */.h.OPERATION_DEFINITION,
      operation,
      name,
      variableDefinitions: this.parseVariableDefinitions(),
      directives: this.parseDirectives(false),
      selectionSet: this.parseSelectionSet(),
    });
  }
  /**
   * OperationType : one of query mutation subscription
   */

  parseOperationType() {
    const operationToken = this.expectToken(tokenKind_TokenKind.NAME);

    switch (operationToken.value) {
      case 'query':
        return ast/* OperationTypeNode.QUERY */.ku.QUERY;

      case 'mutation':
        return ast/* OperationTypeNode.MUTATION */.ku.MUTATION;

      case 'subscription':
        return ast/* OperationTypeNode.SUBSCRIPTION */.ku.SUBSCRIPTION;
    }

    throw this.unexpected(operationToken);
  }
  /**
   * VariableDefinitions : ( VariableDefinition+ )
   */

  parseVariableDefinitions() {
    return this.optionalMany(
      tokenKind_TokenKind.PAREN_L,
      this.parseVariableDefinition,
      tokenKind_TokenKind.PAREN_R,
    );
  }
  /**
   * VariableDefinition : Variable : Type DefaultValue? Directives[Const]?
   */

  parseVariableDefinition() {
    return this.node(this._lexer.token, {
      kind: kinds/* Kind.VARIABLE_DEFINITION */.h.VARIABLE_DEFINITION,
      variable: this.parseVariable(),
      type: (this.expectToken(tokenKind_TokenKind.COLON), this.parseTypeReference()),
      defaultValue: this.expectOptionalToken(tokenKind_TokenKind.EQUALS)
        ? this.parseConstValueLiteral()
        : undefined,
      directives: this.parseConstDirectives(),
    });
  }
  /**
   * Variable : $ Name
   */

  parseVariable() {
    const start = this._lexer.token;
    this.expectToken(tokenKind_TokenKind.DOLLAR);
    return this.node(start, {
      kind: kinds/* Kind.VARIABLE */.h.VARIABLE,
      name: this.parseName(),
    });
  }
  /**
   * ```
   * SelectionSet : { Selection+ }
   * ```
   */

  parseSelectionSet() {
    return this.node(this._lexer.token, {
      kind: kinds/* Kind.SELECTION_SET */.h.SELECTION_SET,
      selections: this.many(
        tokenKind_TokenKind.BRACE_L,
        this.parseSelection,
        tokenKind_TokenKind.BRACE_R,
      ),
    });
  }
  /**
   * Selection :
   *   - Field
   *   - FragmentSpread
   *   - InlineFragment
   */

  parseSelection() {
    return this.peek(tokenKind_TokenKind.SPREAD)
      ? this.parseFragment()
      : this.parseField();
  }
  /**
   * Field : Alias? Name Arguments? Directives? SelectionSet?
   *
   * Alias : Name :
   */

  parseField() {
    const start = this._lexer.token;
    const nameOrAlias = this.parseName();
    let alias;
    let name;

    if (this.expectOptionalToken(tokenKind_TokenKind.COLON)) {
      alias = nameOrAlias;
      name = this.parseName();
    } else {
      name = nameOrAlias;
    }

    return this.node(start, {
      kind: kinds/* Kind.FIELD */.h.FIELD,
      alias,
      name,
      arguments: this.parseArguments(false),
      directives: this.parseDirectives(false),
      selectionSet: this.peek(tokenKind_TokenKind.BRACE_L)
        ? this.parseSelectionSet()
        : undefined,
    });
  }
  /**
   * Arguments[Const] : ( Argument[?Const]+ )
   */

  parseArguments(isConst) {
    const item = isConst ? this.parseConstArgument : this.parseArgument;
    return this.optionalMany(tokenKind_TokenKind.PAREN_L, item, tokenKind_TokenKind.PAREN_R);
  }
  /**
   * Argument[Const] : Name : Value[?Const]
   */

  parseArgument(isConst = false) {
    const start = this._lexer.token;
    const name = this.parseName();
    this.expectToken(tokenKind_TokenKind.COLON);
    return this.node(start, {
      kind: kinds/* Kind.ARGUMENT */.h.ARGUMENT,
      name,
      value: this.parseValueLiteral(isConst),
    });
  }

  parseConstArgument() {
    return this.parseArgument(true);
  } // Implements the parsing rules in the Fragments section.

  /**
   * Corresponds to both FragmentSpread and InlineFragment in the spec.
   *
   * FragmentSpread : ... FragmentName Directives?
   *
   * InlineFragment : ... TypeCondition? Directives? SelectionSet
   */

  parseFragment() {
    const start = this._lexer.token;
    this.expectToken(tokenKind_TokenKind.SPREAD);
    const hasTypeCondition = this.expectOptionalKeyword('on');

    if (!hasTypeCondition && this.peek(tokenKind_TokenKind.NAME)) {
      return this.node(start, {
        kind: kinds/* Kind.FRAGMENT_SPREAD */.h.FRAGMENT_SPREAD,
        name: this.parseFragmentName(),
        directives: this.parseDirectives(false),
      });
    }

    return this.node(start, {
      kind: kinds/* Kind.INLINE_FRAGMENT */.h.INLINE_FRAGMENT,
      typeCondition: hasTypeCondition ? this.parseNamedType() : undefined,
      directives: this.parseDirectives(false),
      selectionSet: this.parseSelectionSet(),
    });
  }
  /**
   * FragmentDefinition :
   *   - fragment FragmentName on TypeCondition Directives? SelectionSet
   *
   * TypeCondition : NamedType
   */

  parseFragmentDefinition() {
    var _this$_options;

    const start = this._lexer.token;
    this.expectKeyword('fragment'); // Legacy support for defining variables within fragments changes
    // the grammar of FragmentDefinition:
    //   - fragment FragmentName VariableDefinitions? on TypeCondition Directives? SelectionSet

    if (
      ((_this$_options = this._options) === null || _this$_options === void 0
        ? void 0
        : _this$_options.allowLegacyFragmentVariables) === true
    ) {
      return this.node(start, {
        kind: kinds/* Kind.FRAGMENT_DEFINITION */.h.FRAGMENT_DEFINITION,
        name: this.parseFragmentName(),
        variableDefinitions: this.parseVariableDefinitions(),
        typeCondition: (this.expectKeyword('on'), this.parseNamedType()),
        directives: this.parseDirectives(false),
        selectionSet: this.parseSelectionSet(),
      });
    }

    return this.node(start, {
      kind: kinds/* Kind.FRAGMENT_DEFINITION */.h.FRAGMENT_DEFINITION,
      name: this.parseFragmentName(),
      typeCondition: (this.expectKeyword('on'), this.parseNamedType()),
      directives: this.parseDirectives(false),
      selectionSet: this.parseSelectionSet(),
    });
  }
  /**
   * FragmentName : Name but not `on`
   */

  parseFragmentName() {
    if (this._lexer.token.value === 'on') {
      throw this.unexpected();
    }

    return this.parseName();
  } // Implements the parsing rules in the Values section.

  /**
   * Value[Const] :
   *   - [~Const] Variable
   *   - IntValue
   *   - FloatValue
   *   - StringValue
   *   - BooleanValue
   *   - NullValue
   *   - EnumValue
   *   - ListValue[?Const]
   *   - ObjectValue[?Const]
   *
   * BooleanValue : one of `true` `false`
   *
   * NullValue : `null`
   *
   * EnumValue : Name but not `true`, `false` or `null`
   */

  parseValueLiteral(isConst) {
    const token = this._lexer.token;

    switch (token.kind) {
      case tokenKind_TokenKind.BRACKET_L:
        return this.parseList(isConst);

      case tokenKind_TokenKind.BRACE_L:
        return this.parseObject(isConst);

      case tokenKind_TokenKind.INT:
        this._lexer.advance();

        return this.node(token, {
          kind: kinds/* Kind.INT */.h.INT,
          value: token.value,
        });

      case tokenKind_TokenKind.FLOAT:
        this._lexer.advance();

        return this.node(token, {
          kind: kinds/* Kind.FLOAT */.h.FLOAT,
          value: token.value,
        });

      case tokenKind_TokenKind.STRING:
      case tokenKind_TokenKind.BLOCK_STRING:
        return this.parseStringLiteral();

      case tokenKind_TokenKind.NAME:
        this._lexer.advance();

        switch (token.value) {
          case 'true':
            return this.node(token, {
              kind: kinds/* Kind.BOOLEAN */.h.BOOLEAN,
              value: true,
            });

          case 'false':
            return this.node(token, {
              kind: kinds/* Kind.BOOLEAN */.h.BOOLEAN,
              value: false,
            });

          case 'null':
            return this.node(token, {
              kind: kinds/* Kind.NULL */.h.NULL,
            });

          default:
            return this.node(token, {
              kind: kinds/* Kind.ENUM */.h.ENUM,
              value: token.value,
            });
        }

      case tokenKind_TokenKind.DOLLAR:
        if (isConst) {
          this.expectToken(tokenKind_TokenKind.DOLLAR);

          if (this._lexer.token.kind === tokenKind_TokenKind.NAME) {
            const varName = this._lexer.token.value;
            throw syntaxError(
              this._lexer.source,
              token.start,
              `Unexpected variable "$${varName}" in constant value.`,
            );
          } else {
            throw this.unexpected(token);
          }
        }

        return this.parseVariable();

      default:
        throw this.unexpected();
    }
  }

  parseConstValueLiteral() {
    return this.parseValueLiteral(true);
  }

  parseStringLiteral() {
    const token = this._lexer.token;

    this._lexer.advance();

    return this.node(token, {
      kind: kinds/* Kind.STRING */.h.STRING,
      value: token.value,
      block: token.kind === tokenKind_TokenKind.BLOCK_STRING,
    });
  }
  /**
   * ListValue[Const] :
   *   - [ ]
   *   - [ Value[?Const]+ ]
   */

  parseList(isConst) {
    const item = () => this.parseValueLiteral(isConst);

    return this.node(this._lexer.token, {
      kind: kinds/* Kind.LIST */.h.LIST,
      values: this.any(tokenKind_TokenKind.BRACKET_L, item, tokenKind_TokenKind.BRACKET_R),
    });
  }
  /**
   * ```
   * ObjectValue[Const] :
   *   - { }
   *   - { ObjectField[?Const]+ }
   * ```
   */

  parseObject(isConst) {
    const item = () => this.parseObjectField(isConst);

    return this.node(this._lexer.token, {
      kind: kinds/* Kind.OBJECT */.h.OBJECT,
      fields: this.any(tokenKind_TokenKind.BRACE_L, item, tokenKind_TokenKind.BRACE_R),
    });
  }
  /**
   * ObjectField[Const] : Name : Value[?Const]
   */

  parseObjectField(isConst) {
    const start = this._lexer.token;
    const name = this.parseName();
    this.expectToken(tokenKind_TokenKind.COLON);
    return this.node(start, {
      kind: kinds/* Kind.OBJECT_FIELD */.h.OBJECT_FIELD,
      name,
      value: this.parseValueLiteral(isConst),
    });
  } // Implements the parsing rules in the Directives section.

  /**
   * Directives[Const] : Directive[?Const]+
   */

  parseDirectives(isConst) {
    const directives = [];

    while (this.peek(tokenKind_TokenKind.AT)) {
      directives.push(this.parseDirective(isConst));
    }

    return directives;
  }

  parseConstDirectives() {
    return this.parseDirectives(true);
  }
  /**
   * ```
   * Directive[Const] : @ Name Arguments[?Const]?
   * ```
   */

  parseDirective(isConst) {
    const start = this._lexer.token;
    this.expectToken(tokenKind_TokenKind.AT);
    return this.node(start, {
      kind: kinds/* Kind.DIRECTIVE */.h.DIRECTIVE,
      name: this.parseName(),
      arguments: this.parseArguments(isConst),
    });
  } // Implements the parsing rules in the Types section.

  /**
   * Type :
   *   - NamedType
   *   - ListType
   *   - NonNullType
   */

  parseTypeReference() {
    const start = this._lexer.token;
    let type;

    if (this.expectOptionalToken(tokenKind_TokenKind.BRACKET_L)) {
      const innerType = this.parseTypeReference();
      this.expectToken(tokenKind_TokenKind.BRACKET_R);
      type = this.node(start, {
        kind: kinds/* Kind.LIST_TYPE */.h.LIST_TYPE,
        type: innerType,
      });
    } else {
      type = this.parseNamedType();
    }

    if (this.expectOptionalToken(tokenKind_TokenKind.BANG)) {
      return this.node(start, {
        kind: kinds/* Kind.NON_NULL_TYPE */.h.NON_NULL_TYPE,
        type,
      });
    }

    return type;
  }
  /**
   * NamedType : Name
   */

  parseNamedType() {
    return this.node(this._lexer.token, {
      kind: kinds/* Kind.NAMED_TYPE */.h.NAMED_TYPE,
      name: this.parseName(),
    });
  } // Implements the parsing rules in the Type Definition section.

  peekDescription() {
    return this.peek(tokenKind_TokenKind.STRING) || this.peek(tokenKind_TokenKind.BLOCK_STRING);
  }
  /**
   * Description : StringValue
   */

  parseDescription() {
    if (this.peekDescription()) {
      return this.parseStringLiteral();
    }
  }
  /**
   * ```
   * SchemaDefinition : Description? schema Directives[Const]? { OperationTypeDefinition+ }
   * ```
   */

  parseSchemaDefinition() {
    const start = this._lexer.token;
    const description = this.parseDescription();
    this.expectKeyword('schema');
    const directives = this.parseConstDirectives();
    const operationTypes = this.many(
      tokenKind_TokenKind.BRACE_L,
      this.parseOperationTypeDefinition,
      tokenKind_TokenKind.BRACE_R,
    );
    return this.node(start, {
      kind: kinds/* Kind.SCHEMA_DEFINITION */.h.SCHEMA_DEFINITION,
      description,
      directives,
      operationTypes,
    });
  }
  /**
   * OperationTypeDefinition : OperationType : NamedType
   */

  parseOperationTypeDefinition() {
    const start = this._lexer.token;
    const operation = this.parseOperationType();
    this.expectToken(tokenKind_TokenKind.COLON);
    const type = this.parseNamedType();
    return this.node(start, {
      kind: kinds/* Kind.OPERATION_TYPE_DEFINITION */.h.OPERATION_TYPE_DEFINITION,
      operation,
      type,
    });
  }
  /**
   * ScalarTypeDefinition : Description? scalar Name Directives[Const]?
   */

  parseScalarTypeDefinition() {
    const start = this._lexer.token;
    const description = this.parseDescription();
    this.expectKeyword('scalar');
    const name = this.parseName();
    const directives = this.parseConstDirectives();
    return this.node(start, {
      kind: kinds/* Kind.SCALAR_TYPE_DEFINITION */.h.SCALAR_TYPE_DEFINITION,
      description,
      name,
      directives,
    });
  }
  /**
   * ObjectTypeDefinition :
   *   Description?
   *   type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition?
   */

  parseObjectTypeDefinition() {
    const start = this._lexer.token;
    const description = this.parseDescription();
    this.expectKeyword('type');
    const name = this.parseName();
    const interfaces = this.parseImplementsInterfaces();
    const directives = this.parseConstDirectives();
    const fields = this.parseFieldsDefinition();
    return this.node(start, {
      kind: kinds/* Kind.OBJECT_TYPE_DEFINITION */.h.OBJECT_TYPE_DEFINITION,
      description,
      name,
      interfaces,
      directives,
      fields,
    });
  }
  /**
   * ImplementsInterfaces :
   *   - implements `&`? NamedType
   *   - ImplementsInterfaces & NamedType
   */

  parseImplementsInterfaces() {
    return this.expectOptionalKeyword('implements')
      ? this.delimitedMany(tokenKind_TokenKind.AMP, this.parseNamedType)
      : [];
  }
  /**
   * ```
   * FieldsDefinition : { FieldDefinition+ }
   * ```
   */

  parseFieldsDefinition() {
    return this.optionalMany(
      tokenKind_TokenKind.BRACE_L,
      this.parseFieldDefinition,
      tokenKind_TokenKind.BRACE_R,
    );
  }
  /**
   * FieldDefinition :
   *   - Description? Name ArgumentsDefinition? : Type Directives[Const]?
   */

  parseFieldDefinition() {
    const start = this._lexer.token;
    const description = this.parseDescription();
    const name = this.parseName();
    const args = this.parseArgumentDefs();
    this.expectToken(tokenKind_TokenKind.COLON);
    const type = this.parseTypeReference();
    const directives = this.parseConstDirectives();
    return this.node(start, {
      kind: kinds/* Kind.FIELD_DEFINITION */.h.FIELD_DEFINITION,
      description,
      name,
      arguments: args,
      type,
      directives,
    });
  }
  /**
   * ArgumentsDefinition : ( InputValueDefinition+ )
   */

  parseArgumentDefs() {
    return this.optionalMany(
      tokenKind_TokenKind.PAREN_L,
      this.parseInputValueDef,
      tokenKind_TokenKind.PAREN_R,
    );
  }
  /**
   * InputValueDefinition :
   *   - Description? Name : Type DefaultValue? Directives[Const]?
   */

  parseInputValueDef() {
    const start = this._lexer.token;
    const description = this.parseDescription();
    const name = this.parseName();
    this.expectToken(tokenKind_TokenKind.COLON);
    const type = this.parseTypeReference();
    let defaultValue;

    if (this.expectOptionalToken(tokenKind_TokenKind.EQUALS)) {
      defaultValue = this.parseConstValueLiteral();
    }

    const directives = this.parseConstDirectives();
    return this.node(start, {
      kind: kinds/* Kind.INPUT_VALUE_DEFINITION */.h.INPUT_VALUE_DEFINITION,
      description,
      name,
      type,
      defaultValue,
      directives,
    });
  }
  /**
   * InterfaceTypeDefinition :
   *   - Description? interface Name Directives[Const]? FieldsDefinition?
   */

  parseInterfaceTypeDefinition() {
    const start = this._lexer.token;
    const description = this.parseDescription();
    this.expectKeyword('interface');
    const name = this.parseName();
    const interfaces = this.parseImplementsInterfaces();
    const directives = this.parseConstDirectives();
    const fields = this.parseFieldsDefinition();
    return this.node(start, {
      kind: kinds/* Kind.INTERFACE_TYPE_DEFINITION */.h.INTERFACE_TYPE_DEFINITION,
      description,
      name,
      interfaces,
      directives,
      fields,
    });
  }
  /**
   * UnionTypeDefinition :
   *   - Description? union Name Directives[Const]? UnionMemberTypes?
   */

  parseUnionTypeDefinition() {
    const start = this._lexer.token;
    const description = this.parseDescription();
    this.expectKeyword('union');
    const name = this.parseName();
    const directives = this.parseConstDirectives();
    const types = this.parseUnionMemberTypes();
    return this.node(start, {
      kind: kinds/* Kind.UNION_TYPE_DEFINITION */.h.UNION_TYPE_DEFINITION,
      description,
      name,
      directives,
      types,
    });
  }
  /**
   * UnionMemberTypes :
   *   - = `|`? NamedType
   *   - UnionMemberTypes | NamedType
   */

  parseUnionMemberTypes() {
    return this.expectOptionalToken(tokenKind_TokenKind.EQUALS)
      ? this.delimitedMany(tokenKind_TokenKind.PIPE, this.parseNamedType)
      : [];
  }
  /**
   * EnumTypeDefinition :
   *   - Description? enum Name Directives[Const]? EnumValuesDefinition?
   */

  parseEnumTypeDefinition() {
    const start = this._lexer.token;
    const description = this.parseDescription();
    this.expectKeyword('enum');
    const name = this.parseName();
    const directives = this.parseConstDirectives();
    const values = this.parseEnumValuesDefinition();
    return this.node(start, {
      kind: kinds/* Kind.ENUM_TYPE_DEFINITION */.h.ENUM_TYPE_DEFINITION,
      description,
      name,
      directives,
      values,
    });
  }
  /**
   * ```
   * EnumValuesDefinition : { EnumValueDefinition+ }
   * ```
   */

  parseEnumValuesDefinition() {
    return this.optionalMany(
      tokenKind_TokenKind.BRACE_L,
      this.parseEnumValueDefinition,
      tokenKind_TokenKind.BRACE_R,
    );
  }
  /**
   * EnumValueDefinition : Description? EnumValue Directives[Const]?
   */

  parseEnumValueDefinition() {
    const start = this._lexer.token;
    const description = this.parseDescription();
    const name = this.parseEnumValueName();
    const directives = this.parseConstDirectives();
    return this.node(start, {
      kind: kinds/* Kind.ENUM_VALUE_DEFINITION */.h.ENUM_VALUE_DEFINITION,
      description,
      name,
      directives,
    });
  }
  /**
   * EnumValue : Name but not `true`, `false` or `null`
   */

  parseEnumValueName() {
    if (
      this._lexer.token.value === 'true' ||
      this._lexer.token.value === 'false' ||
      this._lexer.token.value === 'null'
    ) {
      throw syntaxError(
        this._lexer.source,
        this._lexer.token.start,
        `${getTokenDesc(
          this._lexer.token,
        )} is reserved and cannot be used for an enum value.`,
      );
    }

    return this.parseName();
  }
  /**
   * InputObjectTypeDefinition :
   *   - Description? input Name Directives[Const]? InputFieldsDefinition?
   */

  parseInputObjectTypeDefinition() {
    const start = this._lexer.token;
    const description = this.parseDescription();
    this.expectKeyword('input');
    const name = this.parseName();
    const directives = this.parseConstDirectives();
    const fields = this.parseInputFieldsDefinition();
    return this.node(start, {
      kind: kinds/* Kind.INPUT_OBJECT_TYPE_DEFINITION */.h.INPUT_OBJECT_TYPE_DEFINITION,
      description,
      name,
      directives,
      fields,
    });
  }
  /**
   * ```
   * InputFieldsDefinition : { InputValueDefinition+ }
   * ```
   */

  parseInputFieldsDefinition() {
    return this.optionalMany(
      tokenKind_TokenKind.BRACE_L,
      this.parseInputValueDef,
      tokenKind_TokenKind.BRACE_R,
    );
  }
  /**
   * TypeSystemExtension :
   *   - SchemaExtension
   *   - TypeExtension
   *
   * TypeExtension :
   *   - ScalarTypeExtension
   *   - ObjectTypeExtension
   *   - InterfaceTypeExtension
   *   - UnionTypeExtension
   *   - EnumTypeExtension
   *   - InputObjectTypeDefinition
   */

  parseTypeSystemExtension() {
    const keywordToken = this._lexer.lookahead();

    if (keywordToken.kind === tokenKind_TokenKind.NAME) {
      switch (keywordToken.value) {
        case 'schema':
          return this.parseSchemaExtension();

        case 'scalar':
          return this.parseScalarTypeExtension();

        case 'type':
          return this.parseObjectTypeExtension();

        case 'interface':
          return this.parseInterfaceTypeExtension();

        case 'union':
          return this.parseUnionTypeExtension();

        case 'enum':
          return this.parseEnumTypeExtension();

        case 'input':
          return this.parseInputObjectTypeExtension();
      }
    }

    throw this.unexpected(keywordToken);
  }
  /**
   * ```
   * SchemaExtension :
   *  - extend schema Directives[Const]? { OperationTypeDefinition+ }
   *  - extend schema Directives[Const]
   * ```
   */

  parseSchemaExtension() {
    const start = this._lexer.token;
    this.expectKeyword('extend');
    this.expectKeyword('schema');
    const directives = this.parseConstDirectives();
    const operationTypes = this.optionalMany(
      tokenKind_TokenKind.BRACE_L,
      this.parseOperationTypeDefinition,
      tokenKind_TokenKind.BRACE_R,
    );

    if (directives.length === 0 && operationTypes.length === 0) {
      throw this.unexpected();
    }

    return this.node(start, {
      kind: kinds/* Kind.SCHEMA_EXTENSION */.h.SCHEMA_EXTENSION,
      directives,
      operationTypes,
    });
  }
  /**
   * ScalarTypeExtension :
   *   - extend scalar Name Directives[Const]
   */

  parseScalarTypeExtension() {
    const start = this._lexer.token;
    this.expectKeyword('extend');
    this.expectKeyword('scalar');
    const name = this.parseName();
    const directives = this.parseConstDirectives();

    if (directives.length === 0) {
      throw this.unexpected();
    }

    return this.node(start, {
      kind: kinds/* Kind.SCALAR_TYPE_EXTENSION */.h.SCALAR_TYPE_EXTENSION,
      name,
      directives,
    });
  }
  /**
   * ObjectTypeExtension :
   *  - extend type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
   *  - extend type Name ImplementsInterfaces? Directives[Const]
   *  - extend type Name ImplementsInterfaces
   */

  parseObjectTypeExtension() {
    const start = this._lexer.token;
    this.expectKeyword('extend');
    this.expectKeyword('type');
    const name = this.parseName();
    const interfaces = this.parseImplementsInterfaces();
    const directives = this.parseConstDirectives();
    const fields = this.parseFieldsDefinition();

    if (
      interfaces.length === 0 &&
      directives.length === 0 &&
      fields.length === 0
    ) {
      throw this.unexpected();
    }

    return this.node(start, {
      kind: kinds/* Kind.OBJECT_TYPE_EXTENSION */.h.OBJECT_TYPE_EXTENSION,
      name,
      interfaces,
      directives,
      fields,
    });
  }
  /**
   * InterfaceTypeExtension :
   *  - extend interface Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
   *  - extend interface Name ImplementsInterfaces? Directives[Const]
   *  - extend interface Name ImplementsInterfaces
   */

  parseInterfaceTypeExtension() {
    const start = this._lexer.token;
    this.expectKeyword('extend');
    this.expectKeyword('interface');
    const name = this.parseName();
    const interfaces = this.parseImplementsInterfaces();
    const directives = this.parseConstDirectives();
    const fields = this.parseFieldsDefinition();

    if (
      interfaces.length === 0 &&
      directives.length === 0 &&
      fields.length === 0
    ) {
      throw this.unexpected();
    }

    return this.node(start, {
      kind: kinds/* Kind.INTERFACE_TYPE_EXTENSION */.h.INTERFACE_TYPE_EXTENSION,
      name,
      interfaces,
      directives,
      fields,
    });
  }
  /**
   * UnionTypeExtension :
   *   - extend union Name Directives[Const]? UnionMemberTypes
   *   - extend union Name Directives[Const]
   */

  parseUnionTypeExtension() {
    const start = this._lexer.token;
    this.expectKeyword('extend');
    this.expectKeyword('union');
    const name = this.parseName();
    const directives = this.parseConstDirectives();
    const types = this.parseUnionMemberTypes();

    if (directives.length === 0 && types.length === 0) {
      throw this.unexpected();
    }

    return this.node(start, {
      kind: kinds/* Kind.UNION_TYPE_EXTENSION */.h.UNION_TYPE_EXTENSION,
      name,
      directives,
      types,
    });
  }
  /**
   * EnumTypeExtension :
   *   - extend enum Name Directives[Const]? EnumValuesDefinition
   *   - extend enum Name Directives[Const]
   */

  parseEnumTypeExtension() {
    const start = this._lexer.token;
    this.expectKeyword('extend');
    this.expectKeyword('enum');
    const name = this.parseName();
    const directives = this.parseConstDirectives();
    const values = this.parseEnumValuesDefinition();

    if (directives.length === 0 && values.length === 0) {
      throw this.unexpected();
    }

    return this.node(start, {
      kind: kinds/* Kind.ENUM_TYPE_EXTENSION */.h.ENUM_TYPE_EXTENSION,
      name,
      directives,
      values,
    });
  }
  /**
   * InputObjectTypeExtension :
   *   - extend input Name Directives[Const]? InputFieldsDefinition
   *   - extend input Name Directives[Const]
   */

  parseInputObjectTypeExtension() {
    const start = this._lexer.token;
    this.expectKeyword('extend');
    this.expectKeyword('input');
    const name = this.parseName();
    const directives = this.parseConstDirectives();
    const fields = this.parseInputFieldsDefinition();

    if (directives.length === 0 && fields.length === 0) {
      throw this.unexpected();
    }

    return this.node(start, {
      kind: kinds/* Kind.INPUT_OBJECT_TYPE_EXTENSION */.h.INPUT_OBJECT_TYPE_EXTENSION,
      name,
      directives,
      fields,
    });
  }
  /**
   * ```
   * DirectiveDefinition :
   *   - Description? directive @ Name ArgumentsDefinition? `repeatable`? on DirectiveLocations
   * ```
   */

  parseDirectiveDefinition() {
    const start = this._lexer.token;
    const description = this.parseDescription();
    this.expectKeyword('directive');
    this.expectToken(tokenKind_TokenKind.AT);
    const name = this.parseName();
    const args = this.parseArgumentDefs();
    const repeatable = this.expectOptionalKeyword('repeatable');
    this.expectKeyword('on');
    const locations = this.parseDirectiveLocations();
    return this.node(start, {
      kind: kinds/* Kind.DIRECTIVE_DEFINITION */.h.DIRECTIVE_DEFINITION,
      description,
      name,
      arguments: args,
      repeatable,
      locations,
    });
  }
  /**
   * DirectiveLocations :
   *   - `|`? DirectiveLocation
   *   - DirectiveLocations | DirectiveLocation
   */

  parseDirectiveLocations() {
    return this.delimitedMany(tokenKind_TokenKind.PIPE, this.parseDirectiveLocation);
  }
  /*
   * DirectiveLocation :
   *   - ExecutableDirectiveLocation
   *   - TypeSystemDirectiveLocation
   *
   * ExecutableDirectiveLocation : one of
   *   `QUERY`
   *   `MUTATION`
   *   `SUBSCRIPTION`
   *   `FIELD`
   *   `FRAGMENT_DEFINITION`
   *   `FRAGMENT_SPREAD`
   *   `INLINE_FRAGMENT`
   *
   * TypeSystemDirectiveLocation : one of
   *   `SCHEMA`
   *   `SCALAR`
   *   `OBJECT`
   *   `FIELD_DEFINITION`
   *   `ARGUMENT_DEFINITION`
   *   `INTERFACE`
   *   `UNION`
   *   `ENUM`
   *   `ENUM_VALUE`
   *   `INPUT_OBJECT`
   *   `INPUT_FIELD_DEFINITION`
   */

  parseDirectiveLocation() {
    const start = this._lexer.token;
    const name = this.parseName();

    if (Object.prototype.hasOwnProperty.call(DirectiveLocation, name.value)) {
      return name;
    }

    throw this.unexpected(start);
  } // Core parsing utility functions

  /**
   * Returns a node that, if configured to do so, sets a "loc" field as a
   * location object, used to identify the place in the source that created a
   * given parsed object.
   */

  node(startToken, node) {
    var _this$_options2;

    if (
      ((_this$_options2 = this._options) === null || _this$_options2 === void 0
        ? void 0
        : _this$_options2.noLocation) !== true
    ) {
      node.loc = new ast/* Location */.Ye(
        startToken,
        this._lexer.lastToken,
        this._lexer.source,
      );
    }

    return node;
  }
  /**
   * Determines if the next token is of a given kind
   */

  peek(kind) {
    return this._lexer.token.kind === kind;
  }
  /**
   * If the next token is of the given kind, return that token after advancing the lexer.
   * Otherwise, do not change the parser state and throw an error.
   */

  expectToken(kind) {
    const token = this._lexer.token;

    if (token.kind === kind) {
      this._lexer.advance();

      return token;
    }

    throw syntaxError(
      this._lexer.source,
      token.start,
      `Expected ${getTokenKindDesc(kind)}, found ${getTokenDesc(token)}.`,
    );
  }
  /**
   * If the next token is of the given kind, return "true" after advancing the lexer.
   * Otherwise, do not change the parser state and return "false".
   */

  expectOptionalToken(kind) {
    const token = this._lexer.token;

    if (token.kind === kind) {
      this._lexer.advance();

      return true;
    }

    return false;
  }
  /**
   * If the next token is a given keyword, advance the lexer.
   * Otherwise, do not change the parser state and throw an error.
   */

  expectKeyword(value) {
    const token = this._lexer.token;

    if (token.kind === tokenKind_TokenKind.NAME && token.value === value) {
      this._lexer.advance();
    } else {
      throw syntaxError(
        this._lexer.source,
        token.start,
        `Expected "${value}", found ${getTokenDesc(token)}.`,
      );
    }
  }
  /**
   * If the next token is a given keyword, return "true" after advancing the lexer.
   * Otherwise, do not change the parser state and return "false".
   */

  expectOptionalKeyword(value) {
    const token = this._lexer.token;

    if (token.kind === tokenKind_TokenKind.NAME && token.value === value) {
      this._lexer.advance();

      return true;
    }

    return false;
  }
  /**
   * Helper function for creating an error when an unexpected lexed token is encountered.
   */

  unexpected(atToken) {
    const token =
      atToken !== null && atToken !== void 0 ? atToken : this._lexer.token;
    return syntaxError(
      this._lexer.source,
      token.start,
      `Unexpected ${getTokenDesc(token)}.`,
    );
  }
  /**
   * Returns a possibly empty list of parse nodes, determined by the parseFn.
   * This list begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */

  any(openKind, parseFn, closeKind) {
    this.expectToken(openKind);
    const nodes = [];

    while (!this.expectOptionalToken(closeKind)) {
      nodes.push(parseFn.call(this));
    }

    return nodes;
  }
  /**
   * Returns a list of parse nodes, determined by the parseFn.
   * It can be empty only if open token is missing otherwise it will always return non-empty list
   * that begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */

  optionalMany(openKind, parseFn, closeKind) {
    if (this.expectOptionalToken(openKind)) {
      const nodes = [];

      do {
        nodes.push(parseFn.call(this));
      } while (!this.expectOptionalToken(closeKind));

      return nodes;
    }

    return [];
  }
  /**
   * Returns a non-empty list of parse nodes, determined by the parseFn.
   * This list begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */

  many(openKind, parseFn, closeKind) {
    this.expectToken(openKind);
    const nodes = [];

    do {
      nodes.push(parseFn.call(this));
    } while (!this.expectOptionalToken(closeKind));

    return nodes;
  }
  /**
   * Returns a non-empty list of parse nodes, determined by the parseFn.
   * This list may begin with a lex token of delimiterKind followed by items separated by lex tokens of tokenKind.
   * Advances the parser to the next lex token after last item in the list.
   */

  delimitedMany(delimiterKind, parseFn) {
    this.expectOptionalToken(delimiterKind);
    const nodes = [];

    do {
      nodes.push(parseFn.call(this));
    } while (this.expectOptionalToken(delimiterKind));

    return nodes;
  }
}
/**
 * A helper function to describe a token as a string for debugging.
 */

function getTokenDesc(token) {
  const value = token.value;
  return getTokenKindDesc(token.kind) + (value != null ? ` "${value}"` : '');
}
/**
 * A helper function to describe a token kind as a string for debugging.
 */

function getTokenKindDesc(kind) {
  return isPunctuatorTokenKind(kind) ? `"${kind}"` : kind;
}


/***/ }),

/***/ 64006:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "S": function() { return /* binding */ print; }
});

// EXTERNAL MODULE: ../../.yarn/cache/graphql-npm-16.5.0-348f68b718-a82a926d08.zip/node_modules/graphql/language/blockString.mjs
var blockString = __webpack_require__(14515);
;// CONCATENATED MODULE: ../../.yarn/cache/graphql-npm-16.5.0-348f68b718-a82a926d08.zip/node_modules/graphql/language/printString.mjs
/**
 * Prints a string as a GraphQL StringValue literal. Replaces control characters
 * and excluded characters (" U+0022 and \\ U+005C) with escape sequences.
 */
function printString(str) {
  return `"${str.replace(escapedRegExp, escapedReplacer)}"`;
} // eslint-disable-next-line no-control-regex

const escapedRegExp = /[\x00-\x1f\x22\x5c\x7f-\x9f]/g;

function escapedReplacer(str) {
  return escapeSequences[str.charCodeAt(0)];
} // prettier-ignore

const escapeSequences = [
  '\\u0000',
  '\\u0001',
  '\\u0002',
  '\\u0003',
  '\\u0004',
  '\\u0005',
  '\\u0006',
  '\\u0007',
  '\\b',
  '\\t',
  '\\n',
  '\\u000B',
  '\\f',
  '\\r',
  '\\u000E',
  '\\u000F',
  '\\u0010',
  '\\u0011',
  '\\u0012',
  '\\u0013',
  '\\u0014',
  '\\u0015',
  '\\u0016',
  '\\u0017',
  '\\u0018',
  '\\u0019',
  '\\u001A',
  '\\u001B',
  '\\u001C',
  '\\u001D',
  '\\u001E',
  '\\u001F',
  '',
  '',
  '\\"',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '', // 2F
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '', // 3F
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '', // 4F
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '\\\\',
  '',
  '',
  '', // 5F
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '', // 6F
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '\\u007F',
  '\\u0080',
  '\\u0081',
  '\\u0082',
  '\\u0083',
  '\\u0084',
  '\\u0085',
  '\\u0086',
  '\\u0087',
  '\\u0088',
  '\\u0089',
  '\\u008A',
  '\\u008B',
  '\\u008C',
  '\\u008D',
  '\\u008E',
  '\\u008F',
  '\\u0090',
  '\\u0091',
  '\\u0092',
  '\\u0093',
  '\\u0094',
  '\\u0095',
  '\\u0096',
  '\\u0097',
  '\\u0098',
  '\\u0099',
  '\\u009A',
  '\\u009B',
  '\\u009C',
  '\\u009D',
  '\\u009E',
  '\\u009F',
];

// EXTERNAL MODULE: ../../.yarn/cache/graphql-npm-16.5.0-348f68b718-a82a926d08.zip/node_modules/graphql/language/visitor.mjs
var visitor = __webpack_require__(69423);
;// CONCATENATED MODULE: ../../.yarn/cache/graphql-npm-16.5.0-348f68b718-a82a926d08.zip/node_modules/graphql/language/printer.mjs



/**
 * Converts an AST into a string, using one set of reasonable
 * formatting rules.
 */

function print(ast) {
  return (0,visitor/* visit */.Vn)(ast, printDocASTReducer);
}
const MAX_LINE_LENGTH = 80;
const printDocASTReducer = {
  Name: {
    leave: (node) => node.value,
  },
  Variable: {
    leave: (node) => '$' + node.name,
  },
  // Document
  Document: {
    leave: (node) => join(node.definitions, '\n\n'),
  },
  OperationDefinition: {
    leave(node) {
      const varDefs = wrap('(', join(node.variableDefinitions, ', '), ')');
      const prefix = join(
        [
          node.operation,
          join([node.name, varDefs]),
          join(node.directives, ' '),
        ],
        ' ',
      ); // Anonymous queries with no directives or variable definitions can use
      // the query short form.

      return (prefix === 'query' ? '' : prefix + ' ') + node.selectionSet;
    },
  },
  VariableDefinition: {
    leave: ({ variable, type, defaultValue, directives }) =>
      variable +
      ': ' +
      type +
      wrap(' = ', defaultValue) +
      wrap(' ', join(directives, ' ')),
  },
  SelectionSet: {
    leave: ({ selections }) => block(selections),
  },
  Field: {
    leave({ alias, name, arguments: args, directives, selectionSet }) {
      const prefix = wrap('', alias, ': ') + name;
      let argsLine = prefix + wrap('(', join(args, ', '), ')');

      if (argsLine.length > MAX_LINE_LENGTH) {
        argsLine = prefix + wrap('(\n', indent(join(args, '\n')), '\n)');
      }

      return join([argsLine, join(directives, ' '), selectionSet], ' ');
    },
  },
  Argument: {
    leave: ({ name, value }) => name + ': ' + value,
  },
  // Fragments
  FragmentSpread: {
    leave: ({ name, directives }) =>
      '...' + name + wrap(' ', join(directives, ' ')),
  },
  InlineFragment: {
    leave: ({ typeCondition, directives, selectionSet }) =>
      join(
        [
          '...',
          wrap('on ', typeCondition),
          join(directives, ' '),
          selectionSet,
        ],
        ' ',
      ),
  },
  FragmentDefinition: {
    leave: (
      { name, typeCondition, variableDefinitions, directives, selectionSet }, // Note: fragment variable definitions are experimental and may be changed
    ) =>
      // or removed in the future.
      `fragment ${name}${wrap('(', join(variableDefinitions, ', '), ')')} ` +
      `on ${typeCondition} ${wrap('', join(directives, ' '), ' ')}` +
      selectionSet,
  },
  // Value
  IntValue: {
    leave: ({ value }) => value,
  },
  FloatValue: {
    leave: ({ value }) => value,
  },
  StringValue: {
    leave: ({ value, block: isBlockString }) =>
      isBlockString ? (0,blockString/* printBlockString */.LZ)(value) : printString(value),
  },
  BooleanValue: {
    leave: ({ value }) => (value ? 'true' : 'false'),
  },
  NullValue: {
    leave: () => 'null',
  },
  EnumValue: {
    leave: ({ value }) => value,
  },
  ListValue: {
    leave: ({ values }) => '[' + join(values, ', ') + ']',
  },
  ObjectValue: {
    leave: ({ fields }) => '{' + join(fields, ', ') + '}',
  },
  ObjectField: {
    leave: ({ name, value }) => name + ': ' + value,
  },
  // Directive
  Directive: {
    leave: ({ name, arguments: args }) =>
      '@' + name + wrap('(', join(args, ', '), ')'),
  },
  // Type
  NamedType: {
    leave: ({ name }) => name,
  },
  ListType: {
    leave: ({ type }) => '[' + type + ']',
  },
  NonNullType: {
    leave: ({ type }) => type + '!',
  },
  // Type System Definitions
  SchemaDefinition: {
    leave: ({ description, directives, operationTypes }) =>
      wrap('', description, '\n') +
      join(['schema', join(directives, ' '), block(operationTypes)], ' '),
  },
  OperationTypeDefinition: {
    leave: ({ operation, type }) => operation + ': ' + type,
  },
  ScalarTypeDefinition: {
    leave: ({ description, name, directives }) =>
      wrap('', description, '\n') +
      join(['scalar', name, join(directives, ' ')], ' '),
  },
  ObjectTypeDefinition: {
    leave: ({ description, name, interfaces, directives, fields }) =>
      wrap('', description, '\n') +
      join(
        [
          'type',
          name,
          wrap('implements ', join(interfaces, ' & ')),
          join(directives, ' '),
          block(fields),
        ],
        ' ',
      ),
  },
  FieldDefinition: {
    leave: ({ description, name, arguments: args, type, directives }) =>
      wrap('', description, '\n') +
      name +
      (hasMultilineItems(args)
        ? wrap('(\n', indent(join(args, '\n')), '\n)')
        : wrap('(', join(args, ', '), ')')) +
      ': ' +
      type +
      wrap(' ', join(directives, ' ')),
  },
  InputValueDefinition: {
    leave: ({ description, name, type, defaultValue, directives }) =>
      wrap('', description, '\n') +
      join(
        [name + ': ' + type, wrap('= ', defaultValue), join(directives, ' ')],
        ' ',
      ),
  },
  InterfaceTypeDefinition: {
    leave: ({ description, name, interfaces, directives, fields }) =>
      wrap('', description, '\n') +
      join(
        [
          'interface',
          name,
          wrap('implements ', join(interfaces, ' & ')),
          join(directives, ' '),
          block(fields),
        ],
        ' ',
      ),
  },
  UnionTypeDefinition: {
    leave: ({ description, name, directives, types }) =>
      wrap('', description, '\n') +
      join(
        ['union', name, join(directives, ' '), wrap('= ', join(types, ' | '))],
        ' ',
      ),
  },
  EnumTypeDefinition: {
    leave: ({ description, name, directives, values }) =>
      wrap('', description, '\n') +
      join(['enum', name, join(directives, ' '), block(values)], ' '),
  },
  EnumValueDefinition: {
    leave: ({ description, name, directives }) =>
      wrap('', description, '\n') + join([name, join(directives, ' ')], ' '),
  },
  InputObjectTypeDefinition: {
    leave: ({ description, name, directives, fields }) =>
      wrap('', description, '\n') +
      join(['input', name, join(directives, ' '), block(fields)], ' '),
  },
  DirectiveDefinition: {
    leave: ({ description, name, arguments: args, repeatable, locations }) =>
      wrap('', description, '\n') +
      'directive @' +
      name +
      (hasMultilineItems(args)
        ? wrap('(\n', indent(join(args, '\n')), '\n)')
        : wrap('(', join(args, ', '), ')')) +
      (repeatable ? ' repeatable' : '') +
      ' on ' +
      join(locations, ' | '),
  },
  SchemaExtension: {
    leave: ({ directives, operationTypes }) =>
      join(
        ['extend schema', join(directives, ' '), block(operationTypes)],
        ' ',
      ),
  },
  ScalarTypeExtension: {
    leave: ({ name, directives }) =>
      join(['extend scalar', name, join(directives, ' ')], ' '),
  },
  ObjectTypeExtension: {
    leave: ({ name, interfaces, directives, fields }) =>
      join(
        [
          'extend type',
          name,
          wrap('implements ', join(interfaces, ' & ')),
          join(directives, ' '),
          block(fields),
        ],
        ' ',
      ),
  },
  InterfaceTypeExtension: {
    leave: ({ name, interfaces, directives, fields }) =>
      join(
        [
          'extend interface',
          name,
          wrap('implements ', join(interfaces, ' & ')),
          join(directives, ' '),
          block(fields),
        ],
        ' ',
      ),
  },
  UnionTypeExtension: {
    leave: ({ name, directives, types }) =>
      join(
        [
          'extend union',
          name,
          join(directives, ' '),
          wrap('= ', join(types, ' | ')),
        ],
        ' ',
      ),
  },
  EnumTypeExtension: {
    leave: ({ name, directives, values }) =>
      join(['extend enum', name, join(directives, ' '), block(values)], ' '),
  },
  InputObjectTypeExtension: {
    leave: ({ name, directives, fields }) =>
      join(['extend input', name, join(directives, ' '), block(fields)], ' '),
  },
};
/**
 * Given maybeArray, print an empty string if it is null or empty, otherwise
 * print all items together separated by separator if provided
 */

function join(maybeArray, separator = '') {
  var _maybeArray$filter$jo;

  return (_maybeArray$filter$jo =
    maybeArray === null || maybeArray === void 0
      ? void 0
      : maybeArray.filter((x) => x).join(separator)) !== null &&
    _maybeArray$filter$jo !== void 0
    ? _maybeArray$filter$jo
    : '';
}
/**
 * Given array, print each item on its own line, wrapped in an indented `{ }` block.
 */

function block(array) {
  return wrap('{\n', indent(join(array, '\n')), '\n}');
}
/**
 * If maybeString is not null or empty, then wrap with start and end, otherwise print an empty string.
 */

function wrap(start, maybeString, end = '') {
  return maybeString != null && maybeString !== ''
    ? start + maybeString + end
    : '';
}

function indent(str) {
  return wrap('  ', str.replace(/\n/g, '\n  '));
}

function hasMultilineItems(maybeArray) {
  var _maybeArray$some;

  // FIXME: https://github.com/graphql/graphql-js/issues/2203

  /* c8 ignore next */
  return (_maybeArray$some =
    maybeArray === null || maybeArray === void 0
      ? void 0
      : maybeArray.some((str) => str.includes('\n'))) !== null &&
    _maybeArray$some !== void 0
    ? _maybeArray$some
    : false;
}


/***/ }),

/***/ 81052:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "H": function() { return /* binding */ Source; },
  "T": function() { return /* binding */ isSource; }
});

// EXTERNAL MODULE: ../../.yarn/cache/graphql-npm-16.5.0-348f68b718-a82a926d08.zip/node_modules/graphql/jsutils/devAssert.mjs
var devAssert = __webpack_require__(45747);
// EXTERNAL MODULE: ../../.yarn/cache/graphql-npm-16.5.0-348f68b718-a82a926d08.zip/node_modules/graphql/jsutils/inspect.mjs
var inspect = __webpack_require__(40105);
;// CONCATENATED MODULE: ../../.yarn/cache/graphql-npm-16.5.0-348f68b718-a82a926d08.zip/node_modules/graphql/jsutils/instanceOf.mjs

/**
 * A replacement for instanceof which includes an error warning when multi-realm
 * constructors are detected.
 * See: https://expressjs.com/en/advanced/best-practice-performance.html#set-node_env-to-production
 * See: https://webpack.js.org/guides/production/
 */

const instanceOf =
  /* c8 ignore next 6 */
  // FIXME: https://github.com/graphql/graphql-js/issues/2317
  // eslint-disable-next-line no-undef
   true
    ? function instanceOf(value, constructor) {
        return value instanceof constructor;
      }
    : 0;

;// CONCATENATED MODULE: ../../.yarn/cache/graphql-npm-16.5.0-348f68b718-a82a926d08.zip/node_modules/graphql/language/source.mjs




/**
 * A representation of source input to GraphQL. The `name` and `locationOffset` parameters are
 * optional, but they are useful for clients who store GraphQL documents in source files.
 * For example, if the GraphQL input starts at line 40 in a file named `Foo.graphql`, it might
 * be useful for `name` to be `"Foo.graphql"` and location to be `{ line: 40, column: 1 }`.
 * The `line` and `column` properties in `locationOffset` are 1-indexed.
 */
class Source {
  constructor(
    body,
    name = 'GraphQL request',
    locationOffset = {
      line: 1,
      column: 1,
    },
  ) {
    typeof body === 'string' ||
      (0,devAssert/* devAssert */.a)(false, `Body must be a string. Received: ${(0,inspect/* inspect */.X)(body)}.`);
    this.body = body;
    this.name = name;
    this.locationOffset = locationOffset;
    this.locationOffset.line > 0 ||
      (0,devAssert/* devAssert */.a)(
        false,
        'line in locationOffset is 1-indexed and must be positive.',
      );
    this.locationOffset.column > 0 ||
      (0,devAssert/* devAssert */.a)(
        false,
        'column in locationOffset is 1-indexed and must be positive.',
      );
  }

  get [Symbol.toStringTag]() {
    return 'Source';
  }
}
/**
 * Test if the given value is a Source object.
 *
 * @internal
 */

function isSource(source) {
  return instanceOf(source, Source);
}


/***/ }),

/***/ 69423:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$_": function() { return /* binding */ BREAK; },
/* harmony export */   "Vn": function() { return /* binding */ visit; }
/* harmony export */ });
/* unused harmony exports visitInParallel, getEnterLeaveForKind, getVisitFn */
/* harmony import */ var _jsutils_devAssert_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45747);
/* harmony import */ var _jsutils_inspect_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(40105);
/* harmony import */ var _ast_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27794);
/* harmony import */ var _kinds_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(65797);




/**
 * A visitor is provided to visit, it contains the collection of
 * relevant functions to be called during the visitor's traversal.
 */

const BREAK = Object.freeze({});
/**
 * visit() will walk through an AST using a depth-first traversal, calling
 * the visitor's enter function at each node in the traversal, and calling the
 * leave function after visiting that node and all of its child nodes.
 *
 * By returning different values from the enter and leave functions, the
 * behavior of the visitor can be altered, including skipping over a sub-tree of
 * the AST (by returning false), editing the AST by returning a value or null
 * to remove the value, or to stop the whole traversal by returning BREAK.
 *
 * When using visit() to edit an AST, the original AST will not be modified, and
 * a new version of the AST with the changes applied will be returned from the
 * visit function.
 *
 * ```ts
 * const editedAST = visit(ast, {
 *   enter(node, key, parent, path, ancestors) {
 *     // @return
 *     //   undefined: no action
 *     //   false: skip visiting this node
 *     //   visitor.BREAK: stop visiting altogether
 *     //   null: delete this node
 *     //   any value: replace this node with the returned value
 *   },
 *   leave(node, key, parent, path, ancestors) {
 *     // @return
 *     //   undefined: no action
 *     //   false: no action
 *     //   visitor.BREAK: stop visiting altogether
 *     //   null: delete this node
 *     //   any value: replace this node with the returned value
 *   }
 * });
 * ```
 *
 * Alternatively to providing enter() and leave() functions, a visitor can
 * instead provide functions named the same as the kinds of AST nodes, or
 * enter/leave visitors at a named key, leading to three permutations of the
 * visitor API:
 *
 * 1) Named visitors triggered when entering a node of a specific kind.
 *
 * ```ts
 * visit(ast, {
 *   Kind(node) {
 *     // enter the "Kind" node
 *   }
 * })
 * ```
 *
 * 2) Named visitors that trigger upon entering and leaving a node of a specific kind.
 *
 * ```ts
 * visit(ast, {
 *   Kind: {
 *     enter(node) {
 *       // enter the "Kind" node
 *     }
 *     leave(node) {
 *       // leave the "Kind" node
 *     }
 *   }
 * })
 * ```
 *
 * 3) Generic visitors that trigger upon entering and leaving any node.
 *
 * ```ts
 * visit(ast, {
 *   enter(node) {
 *     // enter any node
 *   },
 *   leave(node) {
 *     // leave any node
 *   }
 * })
 * ```
 */

function visit(root, visitor, visitorKeys = _ast_mjs__WEBPACK_IMPORTED_MODULE_0__/* .QueryDocumentKeys */ .h8) {
  const enterLeaveMap = new Map();

  for (const kind of Object.values(_kinds_mjs__WEBPACK_IMPORTED_MODULE_1__/* .Kind */ .h)) {
    enterLeaveMap.set(kind, getEnterLeaveForKind(visitor, kind));
  }
  /* eslint-disable no-undef-init */

  let stack = undefined;
  let inArray = Array.isArray(root);
  let keys = [root];
  let index = -1;
  let edits = [];
  let node = root;
  let key = undefined;
  let parent = undefined;
  const path = [];
  const ancestors = [];
  /* eslint-enable no-undef-init */

  do {
    index++;
    const isLeaving = index === keys.length;
    const isEdited = isLeaving && edits.length !== 0;

    if (isLeaving) {
      key = ancestors.length === 0 ? undefined : path[path.length - 1];
      node = parent;
      parent = ancestors.pop();

      if (isEdited) {
        if (inArray) {
          node = node.slice();
          let editOffset = 0;

          for (const [editKey, editValue] of edits) {
            const arrayKey = editKey - editOffset;

            if (editValue === null) {
              node.splice(arrayKey, 1);
              editOffset++;
            } else {
              node[arrayKey] = editValue;
            }
          }
        } else {
          node = Object.defineProperties(
            {},
            Object.getOwnPropertyDescriptors(node),
          );

          for (const [editKey, editValue] of edits) {
            node[editKey] = editValue;
          }
        }
      }

      index = stack.index;
      keys = stack.keys;
      edits = stack.edits;
      inArray = stack.inArray;
      stack = stack.prev;
    } else if (parent) {
      key = inArray ? index : keys[index];
      node = parent[key];

      if (node === null || node === undefined) {
        continue;
      }

      path.push(key);
    }

    let result;

    if (!Array.isArray(node)) {
      var _enterLeaveMap$get, _enterLeaveMap$get2;

      (0,_ast_mjs__WEBPACK_IMPORTED_MODULE_0__/* .isNode */ .UG)(node) || (0,_jsutils_devAssert_mjs__WEBPACK_IMPORTED_MODULE_2__/* .devAssert */ .a)(false, `Invalid AST Node: ${(0,_jsutils_inspect_mjs__WEBPACK_IMPORTED_MODULE_3__/* .inspect */ .X)(node)}.`);
      const visitFn = isLeaving
        ? (_enterLeaveMap$get = enterLeaveMap.get(node.kind)) === null ||
          _enterLeaveMap$get === void 0
          ? void 0
          : _enterLeaveMap$get.leave
        : (_enterLeaveMap$get2 = enterLeaveMap.get(node.kind)) === null ||
          _enterLeaveMap$get2 === void 0
        ? void 0
        : _enterLeaveMap$get2.enter;
      result =
        visitFn === null || visitFn === void 0
          ? void 0
          : visitFn.call(visitor, node, key, parent, path, ancestors);

      if (result === BREAK) {
        break;
      }

      if (result === false) {
        if (!isLeaving) {
          path.pop();
          continue;
        }
      } else if (result !== undefined) {
        edits.push([key, result]);

        if (!isLeaving) {
          if ((0,_ast_mjs__WEBPACK_IMPORTED_MODULE_0__/* .isNode */ .UG)(result)) {
            node = result;
          } else {
            path.pop();
            continue;
          }
        }
      }
    }

    if (result === undefined && isEdited) {
      edits.push([key, node]);
    }

    if (isLeaving) {
      path.pop();
    } else {
      var _node$kind;

      stack = {
        inArray,
        index,
        keys,
        edits,
        prev: stack,
      };
      inArray = Array.isArray(node);
      keys = inArray
        ? node
        : (_node$kind = visitorKeys[node.kind]) !== null &&
          _node$kind !== void 0
        ? _node$kind
        : [];
      index = -1;
      edits = [];

      if (parent) {
        ancestors.push(parent);
      }

      parent = node;
    }
  } while (stack !== undefined);

  if (edits.length !== 0) {
    // New root
    return edits[edits.length - 1][1];
  }

  return root;
}
/**
 * Creates a new visitor instance which delegates to many visitors to run in
 * parallel. Each visitor will be visited for each node before moving on.
 *
 * If a prior visitor edits a node, no following visitors will see that node.
 */

function visitInParallel(visitors) {
  const skipping = new Array(visitors.length).fill(null);
  const mergedVisitor = Object.create(null);

  for (const kind of Object.values(Kind)) {
    let hasVisitor = false;
    const enterList = new Array(visitors.length).fill(undefined);
    const leaveList = new Array(visitors.length).fill(undefined);

    for (let i = 0; i < visitors.length; ++i) {
      const { enter, leave } = getEnterLeaveForKind(visitors[i], kind);
      hasVisitor || (hasVisitor = enter != null || leave != null);
      enterList[i] = enter;
      leaveList[i] = leave;
    }

    if (!hasVisitor) {
      continue;
    }

    const mergedEnterLeave = {
      enter(...args) {
        const node = args[0];

        for (let i = 0; i < visitors.length; i++) {
          if (skipping[i] === null) {
            var _enterList$i;

            const result =
              (_enterList$i = enterList[i]) === null || _enterList$i === void 0
                ? void 0
                : _enterList$i.apply(visitors[i], args);

            if (result === false) {
              skipping[i] = node;
            } else if (result === BREAK) {
              skipping[i] = BREAK;
            } else if (result !== undefined) {
              return result;
            }
          }
        }
      },

      leave(...args) {
        const node = args[0];

        for (let i = 0; i < visitors.length; i++) {
          if (skipping[i] === null) {
            var _leaveList$i;

            const result =
              (_leaveList$i = leaveList[i]) === null || _leaveList$i === void 0
                ? void 0
                : _leaveList$i.apply(visitors[i], args);

            if (result === BREAK) {
              skipping[i] = BREAK;
            } else if (result !== undefined && result !== false) {
              return result;
            }
          } else if (skipping[i] === node) {
            skipping[i] = null;
          }
        }
      },
    };
    mergedVisitor[kind] = mergedEnterLeave;
  }

  return mergedVisitor;
}
/**
 * Given a visitor instance and a node kind, return EnterLeaveVisitor for that kind.
 */

function getEnterLeaveForKind(visitor, kind) {
  const kindVisitor = visitor[kind];

  if (typeof kindVisitor === 'object') {
    // { Kind: { enter() {}, leave() {} } }
    return kindVisitor;
  } else if (typeof kindVisitor === 'function') {
    // { Kind() {} }
    return {
      enter: kindVisitor,
      leave: undefined,
    };
  } // { enter() {}, leave() {} }

  return {
    enter: visitor.enter,
    leave: visitor.leave,
  };
}
/**
 * Given a visitor instance, if it is leaving or not, and a node kind, return
 * the function the visitor runtime should call.
 *
 * @deprecated Please use `getEnterLeaveForKind` instead. Will be removed in v17
 */

/* c8 ignore next 8 */

function getVisitFn(visitor, kind, isLeaving) {
  const { enter, leave } = getEnterLeaveForKind(visitor, kind);
  return isLeaving ? leave : enter;
}


/***/ }),

/***/ 32218:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ej": function() { return /* binding */ InvariantError; },
/* harmony export */   "kG": function() { return /* binding */ invariant; }
/* harmony export */ });
/* unused harmony export setVerbosity */
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99290);

var genericMessage = "Invariant Violation";
var _a = Object.setPrototypeOf, setPrototypeOf = _a === void 0 ? function (obj, proto) {
    obj.__proto__ = proto;
    return obj;
} : _a;
var InvariantError = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__extends */ .ZT)(InvariantError, _super);
    function InvariantError(message) {
        if (message === void 0) { message = genericMessage; }
        var _this = _super.call(this, typeof message === "number"
            ? genericMessage + ": " + message + " (see https://github.com/apollographql/invariant-packages)"
            : message) || this;
        _this.framesToPop = 1;
        _this.name = genericMessage;
        setPrototypeOf(_this, InvariantError.prototype);
        return _this;
    }
    return InvariantError;
}(Error));

function invariant(condition, message) {
    if (!condition) {
        throw new InvariantError(message);
    }
}
var verbosityLevels = ["debug", "log", "warn", "error", "silent"];
var verbosityLevel = verbosityLevels.indexOf("log");
function wrapConsoleMethod(name) {
    return function () {
        if (verbosityLevels.indexOf(name) >= verbosityLevel) {
            // Default to console.log if this host environment happens not to provide
            // all the console.* methods we need.
            var method = console[name] || console.log;
            return method.apply(console, arguments);
        }
    };
}
(function (invariant) {
    invariant.debug = wrapConsoleMethod("debug");
    invariant.log = wrapConsoleMethod("log");
    invariant.warn = wrapConsoleMethod("warn");
    invariant.error = wrapConsoleMethod("error");
})(invariant || (invariant = {}));
function setVerbosity(level) {
    var old = verbosityLevels[verbosityLevel];
    verbosityLevel = Math.max(0, verbosityLevels.indexOf(level));
    return old;
}
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (invariant)));
//# sourceMappingURL=invariant.js.map

/***/ }),

/***/ 69368:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ remove; }
/* harmony export */ });
/* unused harmony export install */
/* provided dependency */ var process = __webpack_require__(97441);
function maybe(thunk) {
  try { return thunk() } catch (_) {}
}

var safeGlobal = (
  maybe(function() { return globalThis }) ||
  maybe(function() { return window }) ||
  maybe(function() { return self }) ||
  maybe(function() { return global }) ||
  // We don't expect the Function constructor ever to be invoked at runtime, as
  // long as at least one of globalThis, window, self, or global is defined, so
  // we are under no obligation to make it easy for static analysis tools to
  // detect syntactic usage of the Function constructor. If you think you can
  // improve your static analysis to detect this obfuscation, think again. This
  // is an arms race you cannot win, at least not in JavaScript.
  maybe(function() { return maybe.constructor("return this")() })
);

var needToRemove = false;

function install() {
  if (safeGlobal &&
      !maybe(function() { return "production" }) &&
      !maybe(function() { return process })) {
    Object.defineProperty(safeGlobal, "process", {
      value: {
        env: {
          // This default needs to be "production" instead of "development", to
          // avoid the problem https://github.com/graphql/graphql-js/pull/2894
          // will eventually solve, once merged and released.
          NODE_ENV: "production",
        },
      },
      // Let anyone else change global.process as they see fit, but hide it from
      // Object.keys(global) enumeration.
      configurable: true,
      enumerable: false,
      writable: true,
    });
    needToRemove = true;
  }
}

// Call install() at least once, when this module is imported.
install();

function remove() {
  if (needToRemove) {
    delete safeGlobal.process;
    needToRemove = false;
  }
}


/***/ }),

/***/ 13682:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "tq": function() { return /* reexport */ swiper_Swiper; },
  "o5": function() { return /* reexport */ SwiperSlide; },
  "oc": function() { return /* reexport */ useSwiper; }
});

// UNUSED EXPORTS: useSwiperSlide

// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(91987);
;// CONCATENATED MODULE: ../../.yarn/cache/ssr-window-npm-4.0.2-01f9c0151e-df18260092.zip/node_modules/ssr-window/ssr-window.esm.js
/**
 * SSR Window 4.0.2
 * Better handling for window object in SSR environment
 * https://github.com/nolimits4web/ssr-window
 *
 * Copyright 2021, Vladimir Kharlampidi
 *
 * Licensed under MIT
 *
 * Released on: December 13, 2021
 */
/* eslint-disable no-param-reassign */
function ssr_window_esm_isObject(obj) {
    return (obj !== null &&
        typeof obj === 'object' &&
        'constructor' in obj &&
        obj.constructor === Object);
}
function extend(target = {}, src = {}) {
    Object.keys(src).forEach((key) => {
        if (typeof target[key] === 'undefined')
            target[key] = src[key];
        else if (ssr_window_esm_isObject(src[key]) &&
            ssr_window_esm_isObject(target[key]) &&
            Object.keys(src[key]).length > 0) {
            extend(target[key], src[key]);
        }
    });
}

const ssrDocument = {
    body: {},
    addEventListener() { },
    removeEventListener() { },
    activeElement: {
        blur() { },
        nodeName: '',
    },
    querySelector() {
        return null;
    },
    querySelectorAll() {
        return [];
    },
    getElementById() {
        return null;
    },
    createEvent() {
        return {
            initEvent() { },
        };
    },
    createElement() {
        return {
            children: [],
            childNodes: [],
            style: {},
            setAttribute() { },
            getElementsByTagName() {
                return [];
            },
        };
    },
    createElementNS() {
        return {};
    },
    importNode() {
        return null;
    },
    location: {
        hash: '',
        host: '',
        hostname: '',
        href: '',
        origin: '',
        pathname: '',
        protocol: '',
        search: '',
    },
};
function ssr_window_esm_getDocument() {
    const doc = typeof document !== 'undefined' ? document : {};
    extend(doc, ssrDocument);
    return doc;
}

const ssrWindow = {
    document: ssrDocument,
    navigator: {
        userAgent: '',
    },
    location: {
        hash: '',
        host: '',
        hostname: '',
        href: '',
        origin: '',
        pathname: '',
        protocol: '',
        search: '',
    },
    history: {
        replaceState() { },
        pushState() { },
        go() { },
        back() { },
    },
    CustomEvent: function CustomEvent() {
        return this;
    },
    addEventListener() { },
    removeEventListener() { },
    getComputedStyle() {
        return {
            getPropertyValue() {
                return '';
            },
        };
    },
    Image() { },
    Date() { },
    screen: {},
    setTimeout() { },
    clearTimeout() { },
    matchMedia() {
        return {};
    },
    requestAnimationFrame(callback) {
        if (typeof setTimeout === 'undefined') {
            callback();
            return null;
        }
        return setTimeout(callback, 0);
    },
    cancelAnimationFrame(id) {
        if (typeof setTimeout === 'undefined') {
            return;
        }
        clearTimeout(id);
    },
};
function ssr_window_esm_getWindow() {
    const win = typeof window !== 'undefined' ? window : {};
    extend(win, ssrWindow);
    return win;
}



;// CONCATENATED MODULE: ../../.yarn/cache/dom7-npm-4.0.4-637bc4420a-b38604f74e.zip/node_modules/dom7/dom7.esm.js
/**
 * Dom7 4.0.4
 * Minimalistic JavaScript library for DOM manipulation, with a jQuery-compatible API
 * https://framework7.io/docs/dom7.html
 *
 * Copyright 2022, Vladimir Kharlampidi
 *
 * Licensed under MIT
 *
 * Released on: January 11, 2022
 */


/* eslint-disable no-proto */
function makeReactive(obj) {
  const proto = obj.__proto__;
  Object.defineProperty(obj, '__proto__', {
    get() {
      return proto;
    },

    set(value) {
      proto.__proto__ = value;
    }

  });
}

class Dom7 extends Array {
  constructor(items) {
    if (typeof items === 'number') {
      super(items);
    } else {
      super(...(items || []));
      makeReactive(this);
    }
  }

}

function arrayFlat(arr = []) {
  const res = [];
  arr.forEach(el => {
    if (Array.isArray(el)) {
      res.push(...arrayFlat(el));
    } else {
      res.push(el);
    }
  });
  return res;
}
function arrayFilter(arr, callback) {
  return Array.prototype.filter.call(arr, callback);
}
function arrayUnique(arr) {
  const uniqueArray = [];

  for (let i = 0; i < arr.length; i += 1) {
    if (uniqueArray.indexOf(arr[i]) === -1) uniqueArray.push(arr[i]);
  }

  return uniqueArray;
}
function toCamelCase(string) {
  return string.toLowerCase().replace(/-(.)/g, (match, group) => group.toUpperCase());
}

// eslint-disable-next-line

function qsa(selector, context) {
  if (typeof selector !== 'string') {
    return [selector];
  }

  const a = [];
  const res = context.querySelectorAll(selector);

  for (let i = 0; i < res.length; i += 1) {
    a.push(res[i]);
  }

  return a;
}

function dom7_esm_$(selector, context) {
  const window = ssr_window_esm_getWindow();
  const document = ssr_window_esm_getDocument();
  let arr = [];

  if (!context && selector instanceof Dom7) {
    return selector;
  }

  if (!selector) {
    return new Dom7(arr);
  }

  if (typeof selector === 'string') {
    const html = selector.trim();

    if (html.indexOf('<') >= 0 && html.indexOf('>') >= 0) {
      let toCreate = 'div';
      if (html.indexOf('<li') === 0) toCreate = 'ul';
      if (html.indexOf('<tr') === 0) toCreate = 'tbody';
      if (html.indexOf('<td') === 0 || html.indexOf('<th') === 0) toCreate = 'tr';
      if (html.indexOf('<tbody') === 0) toCreate = 'table';
      if (html.indexOf('<option') === 0) toCreate = 'select';
      const tempParent = document.createElement(toCreate);
      tempParent.innerHTML = html;

      for (let i = 0; i < tempParent.childNodes.length; i += 1) {
        arr.push(tempParent.childNodes[i]);
      }
    } else {
      arr = qsa(selector.trim(), context || document);
    } // arr = qsa(selector, document);

  } else if (selector.nodeType || selector === window || selector === document) {
    arr.push(selector);
  } else if (Array.isArray(selector)) {
    if (selector instanceof Dom7) return selector;
    arr = selector;
  }

  return new Dom7(arrayUnique(arr));
}

dom7_esm_$.fn = Dom7.prototype;

// eslint-disable-next-line

function addClass(...classes) {
  const classNames = arrayFlat(classes.map(c => c.split(' ')));
  this.forEach(el => {
    el.classList.add(...classNames);
  });
  return this;
}

function removeClass(...classes) {
  const classNames = arrayFlat(classes.map(c => c.split(' ')));
  this.forEach(el => {
    el.classList.remove(...classNames);
  });
  return this;
}

function toggleClass(...classes) {
  const classNames = arrayFlat(classes.map(c => c.split(' ')));
  this.forEach(el => {
    classNames.forEach(className => {
      el.classList.toggle(className);
    });
  });
}

function hasClass(...classes) {
  const classNames = arrayFlat(classes.map(c => c.split(' ')));
  return arrayFilter(this, el => {
    return classNames.filter(className => el.classList.contains(className)).length > 0;
  }).length > 0;
}

function attr(attrs, value) {
  if (arguments.length === 1 && typeof attrs === 'string') {
    // Get attr
    if (this[0]) return this[0].getAttribute(attrs);
    return undefined;
  } // Set attrs


  for (let i = 0; i < this.length; i += 1) {
    if (arguments.length === 2) {
      // String
      this[i].setAttribute(attrs, value);
    } else {
      // Object
      for (const attrName in attrs) {
        this[i][attrName] = attrs[attrName];
        this[i].setAttribute(attrName, attrs[attrName]);
      }
    }
  }

  return this;
}

function removeAttr(attr) {
  for (let i = 0; i < this.length; i += 1) {
    this[i].removeAttribute(attr);
  }

  return this;
}

function prop(props, value) {
  if (arguments.length === 1 && typeof props === 'string') {
    // Get prop
    if (this[0]) return this[0][props];
  } else {
    // Set props
    for (let i = 0; i < this.length; i += 1) {
      if (arguments.length === 2) {
        // String
        this[i][props] = value;
      } else {
        // Object
        for (const propName in props) {
          this[i][propName] = props[propName];
        }
      }
    }

    return this;
  }

  return this;
}

function data(key, value) {
  let el;

  if (typeof value === 'undefined') {
    el = this[0];
    if (!el) return undefined; // Get value

    if (el.dom7ElementDataStorage && key in el.dom7ElementDataStorage) {
      return el.dom7ElementDataStorage[key];
    }

    const dataKey = el.getAttribute(`data-${key}`);

    if (dataKey) {
      return dataKey;
    }

    return undefined;
  } // Set value


  for (let i = 0; i < this.length; i += 1) {
    el = this[i];
    if (!el.dom7ElementDataStorage) el.dom7ElementDataStorage = {};
    el.dom7ElementDataStorage[key] = value;
  }

  return this;
}

function removeData(key) {
  for (let i = 0; i < this.length; i += 1) {
    const el = this[i];

    if (el.dom7ElementDataStorage && el.dom7ElementDataStorage[key]) {
      el.dom7ElementDataStorage[key] = null;
      delete el.dom7ElementDataStorage[key];
    }
  }
}

function dataset() {
  const el = this[0];
  if (!el) return undefined;
  const dataset = {}; // eslint-disable-line

  if (el.dataset) {
    for (const dataKey in el.dataset) {
      dataset[dataKey] = el.dataset[dataKey];
    }
  } else {
    for (let i = 0; i < el.attributes.length; i += 1) {
      const attr = el.attributes[i];

      if (attr.name.indexOf('data-') >= 0) {
        dataset[toCamelCase(attr.name.split('data-')[1])] = attr.value;
      }
    }
  }

  for (const key in dataset) {
    if (dataset[key] === 'false') dataset[key] = false;else if (dataset[key] === 'true') dataset[key] = true;else if (parseFloat(dataset[key]) === dataset[key] * 1) dataset[key] *= 1;
  }

  return dataset;
}

function val(value) {
  if (typeof value === 'undefined') {
    // get value
    const el = this[0];
    if (!el) return undefined;

    if (el.multiple && el.nodeName.toLowerCase() === 'select') {
      const values = [];

      for (let i = 0; i < el.selectedOptions.length; i += 1) {
        values.push(el.selectedOptions[i].value);
      }

      return values;
    }

    return el.value;
  } // set value


  for (let i = 0; i < this.length; i += 1) {
    const el = this[i];

    if (Array.isArray(value) && el.multiple && el.nodeName.toLowerCase() === 'select') {
      for (let j = 0; j < el.options.length; j += 1) {
        el.options[j].selected = value.indexOf(el.options[j].value) >= 0;
      }
    } else {
      el.value = value;
    }
  }

  return this;
}

function value(value) {
  return this.val(value);
}

function transform(transform) {
  for (let i = 0; i < this.length; i += 1) {
    this[i].style.transform = transform;
  }

  return this;
}

function transition(duration) {
  for (let i = 0; i < this.length; i += 1) {
    this[i].style.transitionDuration = typeof duration !== 'string' ? `${duration}ms` : duration;
  }

  return this;
}

function on(...args) {
  let [eventType, targetSelector, listener, capture] = args;

  if (typeof args[1] === 'function') {
    [eventType, listener, capture] = args;
    targetSelector = undefined;
  }

  if (!capture) capture = false;

  function handleLiveEvent(e) {
    const target = e.target;
    if (!target) return;
    const eventData = e.target.dom7EventData || [];

    if (eventData.indexOf(e) < 0) {
      eventData.unshift(e);
    }

    if (dom7_esm_$(target).is(targetSelector)) listener.apply(target, eventData);else {
      const parents = dom7_esm_$(target).parents(); // eslint-disable-line

      for (let k = 0; k < parents.length; k += 1) {
        if (dom7_esm_$(parents[k]).is(targetSelector)) listener.apply(parents[k], eventData);
      }
    }
  }

  function handleEvent(e) {
    const eventData = e && e.target ? e.target.dom7EventData || [] : [];

    if (eventData.indexOf(e) < 0) {
      eventData.unshift(e);
    }

    listener.apply(this, eventData);
  }

  const events = eventType.split(' ');
  let j;

  for (let i = 0; i < this.length; i += 1) {
    const el = this[i];

    if (!targetSelector) {
      for (j = 0; j < events.length; j += 1) {
        const event = events[j];
        if (!el.dom7Listeners) el.dom7Listeners = {};
        if (!el.dom7Listeners[event]) el.dom7Listeners[event] = [];
        el.dom7Listeners[event].push({
          listener,
          proxyListener: handleEvent
        });
        el.addEventListener(event, handleEvent, capture);
      }
    } else {
      // Live events
      for (j = 0; j < events.length; j += 1) {
        const event = events[j];
        if (!el.dom7LiveListeners) el.dom7LiveListeners = {};
        if (!el.dom7LiveListeners[event]) el.dom7LiveListeners[event] = [];
        el.dom7LiveListeners[event].push({
          listener,
          proxyListener: handleLiveEvent
        });
        el.addEventListener(event, handleLiveEvent, capture);
      }
    }
  }

  return this;
}

function off(...args) {
  let [eventType, targetSelector, listener, capture] = args;

  if (typeof args[1] === 'function') {
    [eventType, listener, capture] = args;
    targetSelector = undefined;
  }

  if (!capture) capture = false;
  const events = eventType.split(' ');

  for (let i = 0; i < events.length; i += 1) {
    const event = events[i];

    for (let j = 0; j < this.length; j += 1) {
      const el = this[j];
      let handlers;

      if (!targetSelector && el.dom7Listeners) {
        handlers = el.dom7Listeners[event];
      } else if (targetSelector && el.dom7LiveListeners) {
        handlers = el.dom7LiveListeners[event];
      }

      if (handlers && handlers.length) {
        for (let k = handlers.length - 1; k >= 0; k -= 1) {
          const handler = handlers[k];

          if (listener && handler.listener === listener) {
            el.removeEventListener(event, handler.proxyListener, capture);
            handlers.splice(k, 1);
          } else if (listener && handler.listener && handler.listener.dom7proxy && handler.listener.dom7proxy === listener) {
            el.removeEventListener(event, handler.proxyListener, capture);
            handlers.splice(k, 1);
          } else if (!listener) {
            el.removeEventListener(event, handler.proxyListener, capture);
            handlers.splice(k, 1);
          }
        }
      }
    }
  }

  return this;
}

function once(...args) {
  const dom = this;
  let [eventName, targetSelector, listener, capture] = args;

  if (typeof args[1] === 'function') {
    [eventName, listener, capture] = args;
    targetSelector = undefined;
  }

  function onceHandler(...eventArgs) {
    listener.apply(this, eventArgs);
    dom.off(eventName, targetSelector, onceHandler, capture);

    if (onceHandler.dom7proxy) {
      delete onceHandler.dom7proxy;
    }
  }

  onceHandler.dom7proxy = listener;
  return dom.on(eventName, targetSelector, onceHandler, capture);
}

function trigger(...args) {
  const window = ssr_window_esm_getWindow();
  const events = args[0].split(' ');
  const eventData = args[1];

  for (let i = 0; i < events.length; i += 1) {
    const event = events[i];

    for (let j = 0; j < this.length; j += 1) {
      const el = this[j];

      if (window.CustomEvent) {
        const evt = new window.CustomEvent(event, {
          detail: eventData,
          bubbles: true,
          cancelable: true
        });
        el.dom7EventData = args.filter((data, dataIndex) => dataIndex > 0);
        el.dispatchEvent(evt);
        el.dom7EventData = [];
        delete el.dom7EventData;
      }
    }
  }

  return this;
}

function transitionEnd(callback) {
  const dom = this;

  function fireCallBack(e) {
    if (e.target !== this) return;
    callback.call(this, e);
    dom.off('transitionend', fireCallBack);
  }

  if (callback) {
    dom.on('transitionend', fireCallBack);
  }

  return this;
}

function animationEnd(callback) {
  const dom = this;

  function fireCallBack(e) {
    if (e.target !== this) return;
    callback.call(this, e);
    dom.off('animationend', fireCallBack);
  }

  if (callback) {
    dom.on('animationend', fireCallBack);
  }

  return this;
}

function width() {
  const window = getWindow();

  if (this[0] === window) {
    return window.innerWidth;
  }

  if (this.length > 0) {
    return parseFloat(this.css('width'));
  }

  return null;
}

function dom7_esm_outerWidth(includeMargins) {
  if (this.length > 0) {
    if (includeMargins) {
      const styles = this.styles();
      return this[0].offsetWidth + parseFloat(styles.getPropertyValue('margin-right')) + parseFloat(styles.getPropertyValue('margin-left'));
    }

    return this[0].offsetWidth;
  }

  return null;
}

function height() {
  const window = getWindow();

  if (this[0] === window) {
    return window.innerHeight;
  }

  if (this.length > 0) {
    return parseFloat(this.css('height'));
  }

  return null;
}

function dom7_esm_outerHeight(includeMargins) {
  if (this.length > 0) {
    if (includeMargins) {
      const styles = this.styles();
      return this[0].offsetHeight + parseFloat(styles.getPropertyValue('margin-top')) + parseFloat(styles.getPropertyValue('margin-bottom'));
    }

    return this[0].offsetHeight;
  }

  return null;
}

function offset() {
  if (this.length > 0) {
    const window = ssr_window_esm_getWindow();
    const document = ssr_window_esm_getDocument();
    const el = this[0];
    const box = el.getBoundingClientRect();
    const body = document.body;
    const clientTop = el.clientTop || body.clientTop || 0;
    const clientLeft = el.clientLeft || body.clientLeft || 0;
    const scrollTop = el === window ? window.scrollY : el.scrollTop;
    const scrollLeft = el === window ? window.scrollX : el.scrollLeft;
    return {
      top: box.top + scrollTop - clientTop,
      left: box.left + scrollLeft - clientLeft
    };
  }

  return null;
}

function hide() {
  for (let i = 0; i < this.length; i += 1) {
    this[i].style.display = 'none';
  }

  return this;
}

function show() {
  const window = getWindow();

  for (let i = 0; i < this.length; i += 1) {
    const el = this[i];

    if (el.style.display === 'none') {
      el.style.display = '';
    }

    if (window.getComputedStyle(el, null).getPropertyValue('display') === 'none') {
      // Still not visible
      el.style.display = 'block';
    }
  }

  return this;
}

function styles() {
  const window = ssr_window_esm_getWindow();
  if (this[0]) return window.getComputedStyle(this[0], null);
  return {};
}

function css(props, value) {
  const window = ssr_window_esm_getWindow();
  let i;

  if (arguments.length === 1) {
    if (typeof props === 'string') {
      // .css('width')
      if (this[0]) return window.getComputedStyle(this[0], null).getPropertyValue(props);
    } else {
      // .css({ width: '100px' })
      for (i = 0; i < this.length; i += 1) {
        for (const prop in props) {
          this[i].style[prop] = props[prop];
        }
      }

      return this;
    }
  }

  if (arguments.length === 2 && typeof props === 'string') {
    // .css('width', '100px')
    for (i = 0; i < this.length; i += 1) {
      this[i].style[props] = value;
    }

    return this;
  }

  return this;
}

function each(callback) {
  if (!callback) return this;
  this.forEach((el, index) => {
    callback.apply(el, [el, index]);
  });
  return this;
}

function filter(callback) {
  const result = arrayFilter(this, callback);
  return dom7_esm_$(result);
}

function html(html) {
  if (typeof html === 'undefined') {
    return this[0] ? this[0].innerHTML : null;
  }

  for (let i = 0; i < this.length; i += 1) {
    this[i].innerHTML = html;
  }

  return this;
}

function dom7_esm_text(text) {
  if (typeof text === 'undefined') {
    return this[0] ? this[0].textContent.trim() : null;
  }

  for (let i = 0; i < this.length; i += 1) {
    this[i].textContent = text;
  }

  return this;
}

function is(selector) {
  const window = ssr_window_esm_getWindow();
  const document = ssr_window_esm_getDocument();
  const el = this[0];
  let compareWith;
  let i;
  if (!el || typeof selector === 'undefined') return false;

  if (typeof selector === 'string') {
    if (el.matches) return el.matches(selector);
    if (el.webkitMatchesSelector) return el.webkitMatchesSelector(selector);
    if (el.msMatchesSelector) return el.msMatchesSelector(selector);
    compareWith = dom7_esm_$(selector);

    for (i = 0; i < compareWith.length; i += 1) {
      if (compareWith[i] === el) return true;
    }

    return false;
  }

  if (selector === document) {
    return el === document;
  }

  if (selector === window) {
    return el === window;
  }

  if (selector.nodeType || selector instanceof Dom7) {
    compareWith = selector.nodeType ? [selector] : selector;

    for (i = 0; i < compareWith.length; i += 1) {
      if (compareWith[i] === el) return true;
    }

    return false;
  }

  return false;
}

function index() {
  let child = this[0];
  let i;

  if (child) {
    i = 0; // eslint-disable-next-line

    while ((child = child.previousSibling) !== null) {
      if (child.nodeType === 1) i += 1;
    }

    return i;
  }

  return undefined;
}

function eq(index) {
  if (typeof index === 'undefined') return this;
  const length = this.length;

  if (index > length - 1) {
    return dom7_esm_$([]);
  }

  if (index < 0) {
    const returnIndex = length + index;
    if (returnIndex < 0) return dom7_esm_$([]);
    return dom7_esm_$([this[returnIndex]]);
  }

  return dom7_esm_$([this[index]]);
}

function append(...els) {
  let newChild;
  const document = ssr_window_esm_getDocument();

  for (let k = 0; k < els.length; k += 1) {
    newChild = els[k];

    for (let i = 0; i < this.length; i += 1) {
      if (typeof newChild === 'string') {
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = newChild;

        while (tempDiv.firstChild) {
          this[i].appendChild(tempDiv.firstChild);
        }
      } else if (newChild instanceof Dom7) {
        for (let j = 0; j < newChild.length; j += 1) {
          this[i].appendChild(newChild[j]);
        }
      } else {
        this[i].appendChild(newChild);
      }
    }
  }

  return this;
}

function appendTo(parent) {
  dom7_esm_$(parent).append(this);
  return this;
}

function prepend(newChild) {
  const document = ssr_window_esm_getDocument();
  let i;
  let j;

  for (i = 0; i < this.length; i += 1) {
    if (typeof newChild === 'string') {
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = newChild;

      for (j = tempDiv.childNodes.length - 1; j >= 0; j -= 1) {
        this[i].insertBefore(tempDiv.childNodes[j], this[i].childNodes[0]);
      }
    } else if (newChild instanceof Dom7) {
      for (j = 0; j < newChild.length; j += 1) {
        this[i].insertBefore(newChild[j], this[i].childNodes[0]);
      }
    } else {
      this[i].insertBefore(newChild, this[i].childNodes[0]);
    }
  }

  return this;
}

function prependTo(parent) {
  dom7_esm_$(parent).prepend(this);
  return this;
}

function insertBefore(selector) {
  const before = dom7_esm_$(selector);

  for (let i = 0; i < this.length; i += 1) {
    if (before.length === 1) {
      before[0].parentNode.insertBefore(this[i], before[0]);
    } else if (before.length > 1) {
      for (let j = 0; j < before.length; j += 1) {
        before[j].parentNode.insertBefore(this[i].cloneNode(true), before[j]);
      }
    }
  }
}

function insertAfter(selector) {
  const after = dom7_esm_$(selector);

  for (let i = 0; i < this.length; i += 1) {
    if (after.length === 1) {
      after[0].parentNode.insertBefore(this[i], after[0].nextSibling);
    } else if (after.length > 1) {
      for (let j = 0; j < after.length; j += 1) {
        after[j].parentNode.insertBefore(this[i].cloneNode(true), after[j].nextSibling);
      }
    }
  }
}

function next(selector) {
  if (this.length > 0) {
    if (selector) {
      if (this[0].nextElementSibling && dom7_esm_$(this[0].nextElementSibling).is(selector)) {
        return dom7_esm_$([this[0].nextElementSibling]);
      }

      return dom7_esm_$([]);
    }

    if (this[0].nextElementSibling) return dom7_esm_$([this[0].nextElementSibling]);
    return dom7_esm_$([]);
  }

  return dom7_esm_$([]);
}

function nextAll(selector) {
  const nextEls = [];
  let el = this[0];
  if (!el) return dom7_esm_$([]);

  while (el.nextElementSibling) {
    const next = el.nextElementSibling; // eslint-disable-line

    if (selector) {
      if (dom7_esm_$(next).is(selector)) nextEls.push(next);
    } else nextEls.push(next);

    el = next;
  }

  return dom7_esm_$(nextEls);
}

function prev(selector) {
  if (this.length > 0) {
    const el = this[0];

    if (selector) {
      if (el.previousElementSibling && dom7_esm_$(el.previousElementSibling).is(selector)) {
        return dom7_esm_$([el.previousElementSibling]);
      }

      return dom7_esm_$([]);
    }

    if (el.previousElementSibling) return dom7_esm_$([el.previousElementSibling]);
    return dom7_esm_$([]);
  }

  return dom7_esm_$([]);
}

function prevAll(selector) {
  const prevEls = [];
  let el = this[0];
  if (!el) return dom7_esm_$([]);

  while (el.previousElementSibling) {
    const prev = el.previousElementSibling; // eslint-disable-line

    if (selector) {
      if (dom7_esm_$(prev).is(selector)) prevEls.push(prev);
    } else prevEls.push(prev);

    el = prev;
  }

  return dom7_esm_$(prevEls);
}

function siblings(selector) {
  return this.nextAll(selector).add(this.prevAll(selector));
}

function dom7_esm_parent(selector) {
  const parents = []; // eslint-disable-line

  for (let i = 0; i < this.length; i += 1) {
    if (this[i].parentNode !== null) {
      if (selector) {
        if (dom7_esm_$(this[i].parentNode).is(selector)) parents.push(this[i].parentNode);
      } else {
        parents.push(this[i].parentNode);
      }
    }
  }

  return dom7_esm_$(parents);
}

function parents(selector) {
  const parents = []; // eslint-disable-line

  for (let i = 0; i < this.length; i += 1) {
    let parent = this[i].parentNode; // eslint-disable-line

    while (parent) {
      if (selector) {
        if (dom7_esm_$(parent).is(selector)) parents.push(parent);
      } else {
        parents.push(parent);
      }

      parent = parent.parentNode;
    }
  }

  return dom7_esm_$(parents);
}

function closest(selector) {
  let closest = this; // eslint-disable-line

  if (typeof selector === 'undefined') {
    return dom7_esm_$([]);
  }

  if (!closest.is(selector)) {
    closest = closest.parents(selector).eq(0);
  }

  return closest;
}

function find(selector) {
  const foundElements = [];

  for (let i = 0; i < this.length; i += 1) {
    const found = this[i].querySelectorAll(selector);

    for (let j = 0; j < found.length; j += 1) {
      foundElements.push(found[j]);
    }
  }

  return dom7_esm_$(foundElements);
}

function children(selector) {
  const children = []; // eslint-disable-line

  for (let i = 0; i < this.length; i += 1) {
    const childNodes = this[i].children;

    for (let j = 0; j < childNodes.length; j += 1) {
      if (!selector || dom7_esm_$(childNodes[j]).is(selector)) {
        children.push(childNodes[j]);
      }
    }
  }

  return dom7_esm_$(children);
}

function remove() {
  for (let i = 0; i < this.length; i += 1) {
    if (this[i].parentNode) this[i].parentNode.removeChild(this[i]);
  }

  return this;
}

function detach() {
  return this.remove();
}

function add(...els) {
  const dom = this;
  let i;
  let j;

  for (i = 0; i < els.length; i += 1) {
    const toAdd = dom7_esm_$(els[i]);

    for (j = 0; j < toAdd.length; j += 1) {
      dom.push(toAdd[j]);
    }
  }

  return dom;
}

function empty() {
  for (let i = 0; i < this.length; i += 1) {
    const el = this[i];

    if (el.nodeType === 1) {
      for (let j = 0; j < el.childNodes.length; j += 1) {
        if (el.childNodes[j].parentNode) {
          el.childNodes[j].parentNode.removeChild(el.childNodes[j]);
        }
      }

      el.textContent = '';
    }
  }

  return this;
}

// eslint-disable-next-line

function scrollTo(...args) {
  const window = getWindow();
  let [left, top, duration, easing, callback] = args;

  if (args.length === 4 && typeof easing === 'function') {
    callback = easing;
    [left, top, duration, callback, easing] = args;
  }

  if (typeof easing === 'undefined') easing = 'swing';
  return this.each(function animate() {
    const el = this;
    let currentTop;
    let currentLeft;
    let maxTop;
    let maxLeft;
    let newTop;
    let newLeft;
    let scrollTop; // eslint-disable-line

    let scrollLeft; // eslint-disable-line

    let animateTop = top > 0 || top === 0;
    let animateLeft = left > 0 || left === 0;

    if (typeof easing === 'undefined') {
      easing = 'swing';
    }

    if (animateTop) {
      currentTop = el.scrollTop;

      if (!duration) {
        el.scrollTop = top;
      }
    }

    if (animateLeft) {
      currentLeft = el.scrollLeft;

      if (!duration) {
        el.scrollLeft = left;
      }
    }

    if (!duration) return;

    if (animateTop) {
      maxTop = el.scrollHeight - el.offsetHeight;
      newTop = Math.max(Math.min(top, maxTop), 0);
    }

    if (animateLeft) {
      maxLeft = el.scrollWidth - el.offsetWidth;
      newLeft = Math.max(Math.min(left, maxLeft), 0);
    }

    let startTime = null;
    if (animateTop && newTop === currentTop) animateTop = false;
    if (animateLeft && newLeft === currentLeft) animateLeft = false;

    function render(time = new Date().getTime()) {
      if (startTime === null) {
        startTime = time;
      }

      const progress = Math.max(Math.min((time - startTime) / duration, 1), 0);
      const easeProgress = easing === 'linear' ? progress : 0.5 - Math.cos(progress * Math.PI) / 2;
      let done;
      if (animateTop) scrollTop = currentTop + easeProgress * (newTop - currentTop);
      if (animateLeft) scrollLeft = currentLeft + easeProgress * (newLeft - currentLeft);

      if (animateTop && newTop > currentTop && scrollTop >= newTop) {
        el.scrollTop = newTop;
        done = true;
      }

      if (animateTop && newTop < currentTop && scrollTop <= newTop) {
        el.scrollTop = newTop;
        done = true;
      }

      if (animateLeft && newLeft > currentLeft && scrollLeft >= newLeft) {
        el.scrollLeft = newLeft;
        done = true;
      }

      if (animateLeft && newLeft < currentLeft && scrollLeft <= newLeft) {
        el.scrollLeft = newLeft;
        done = true;
      }

      if (done) {
        if (callback) callback();
        return;
      }

      if (animateTop) el.scrollTop = scrollTop;
      if (animateLeft) el.scrollLeft = scrollLeft;
      window.requestAnimationFrame(render);
    }

    window.requestAnimationFrame(render);
  });
} // scrollTop(top, duration, easing, callback) {


function scrollTop(...args) {
  let [top, duration, easing, callback] = args;

  if (args.length === 3 && typeof easing === 'function') {
    [top, duration, callback, easing] = args;
  }

  const dom = this;

  if (typeof top === 'undefined') {
    if (dom.length > 0) return dom[0].scrollTop;
    return null;
  }

  return dom.scrollTo(undefined, top, duration, easing, callback);
}

function scrollLeft(...args) {
  let [left, duration, easing, callback] = args;

  if (args.length === 3 && typeof easing === 'function') {
    [left, duration, callback, easing] = args;
  }

  const dom = this;

  if (typeof left === 'undefined') {
    if (dom.length > 0) return dom[0].scrollLeft;
    return null;
  }

  return dom.scrollTo(left, undefined, duration, easing, callback);
}

// eslint-disable-next-line

function animate(initialProps, initialParams) {
  const window = getWindow();
  const els = this;
  const a = {
    props: Object.assign({}, initialProps),
    params: Object.assign({
      duration: 300,
      easing: 'swing' // or 'linear'

      /* Callbacks
      begin(elements)
      complete(elements)
      progress(elements, complete, remaining, start, tweenValue)
      */

    }, initialParams),
    elements: els,
    animating: false,
    que: [],

    easingProgress(easing, progress) {
      if (easing === 'swing') {
        return 0.5 - Math.cos(progress * Math.PI) / 2;
      }

      if (typeof easing === 'function') {
        return easing(progress);
      }

      return progress;
    },

    stop() {
      if (a.frameId) {
        window.cancelAnimationFrame(a.frameId);
      }

      a.animating = false;
      a.elements.each(el => {
        const element = el;
        delete element.dom7AnimateInstance;
      });
      a.que = [];
    },

    done(complete) {
      a.animating = false;
      a.elements.each(el => {
        const element = el;
        delete element.dom7AnimateInstance;
      });
      if (complete) complete(els);

      if (a.que.length > 0) {
        const que = a.que.shift();
        a.animate(que[0], que[1]);
      }
    },

    animate(props, params) {
      if (a.animating) {
        a.que.push([props, params]);
        return a;
      }

      const elements = []; // Define & Cache Initials & Units

      a.elements.each((el, index) => {
        let initialFullValue;
        let initialValue;
        let unit;
        let finalValue;
        let finalFullValue;
        if (!el.dom7AnimateInstance) a.elements[index].dom7AnimateInstance = a;
        elements[index] = {
          container: el
        };
        Object.keys(props).forEach(prop => {
          initialFullValue = window.getComputedStyle(el, null).getPropertyValue(prop).replace(',', '.');
          initialValue = parseFloat(initialFullValue);
          unit = initialFullValue.replace(initialValue, '');
          finalValue = parseFloat(props[prop]);
          finalFullValue = props[prop] + unit;
          elements[index][prop] = {
            initialFullValue,
            initialValue,
            unit,
            finalValue,
            finalFullValue,
            currentValue: initialValue
          };
        });
      });
      let startTime = null;
      let time;
      let elementsDone = 0;
      let propsDone = 0;
      let done;
      let began = false;
      a.animating = true;

      function render() {
        time = new Date().getTime();
        let progress;
        let easeProgress; // let el;

        if (!began) {
          began = true;
          if (params.begin) params.begin(els);
        }

        if (startTime === null) {
          startTime = time;
        }

        if (params.progress) {
          // eslint-disable-next-line
          params.progress(els, Math.max(Math.min((time - startTime) / params.duration, 1), 0), startTime + params.duration - time < 0 ? 0 : startTime + params.duration - time, startTime);
        }

        elements.forEach(element => {
          const el = element;
          if (done || el.done) return;
          Object.keys(props).forEach(prop => {
            if (done || el.done) return;
            progress = Math.max(Math.min((time - startTime) / params.duration, 1), 0);
            easeProgress = a.easingProgress(params.easing, progress);
            const {
              initialValue,
              finalValue,
              unit
            } = el[prop];
            el[prop].currentValue = initialValue + easeProgress * (finalValue - initialValue);
            const currentValue = el[prop].currentValue;

            if (finalValue > initialValue && currentValue >= finalValue || finalValue < initialValue && currentValue <= finalValue) {
              el.container.style[prop] = finalValue + unit;
              propsDone += 1;

              if (propsDone === Object.keys(props).length) {
                el.done = true;
                elementsDone += 1;
              }

              if (elementsDone === elements.length) {
                done = true;
              }
            }

            if (done) {
              a.done(params.complete);
              return;
            }

            el.container.style[prop] = currentValue + unit;
          });
        });
        if (done) return; // Then call

        a.frameId = window.requestAnimationFrame(render);
      }

      a.frameId = window.requestAnimationFrame(render);
      return a;
    }

  };

  if (a.elements.length === 0) {
    return els;
  }

  let animateInstance;

  for (let i = 0; i < a.elements.length; i += 1) {
    if (a.elements[i].dom7AnimateInstance) {
      animateInstance = a.elements[i].dom7AnimateInstance;
    } else a.elements[i].dom7AnimateInstance = a;
  }

  if (!animateInstance) {
    animateInstance = a;
  }

  if (initialProps === 'stop') {
    animateInstance.stop();
  } else {
    animateInstance.animate(a.props, a.params);
  }

  return els;
}

function stop() {
  const els = this;

  for (let i = 0; i < els.length; i += 1) {
    if (els[i].dom7AnimateInstance) {
      els[i].dom7AnimateInstance.stop();
    }
  }
}

const noTrigger = 'resize scroll'.split(' ');

function shortcut(name) {
  function eventHandler(...args) {
    if (typeof args[0] === 'undefined') {
      for (let i = 0; i < this.length; i += 1) {
        if (noTrigger.indexOf(name) < 0) {
          if (name in this[i]) this[i][name]();else {
            dom7_esm_$(this[i]).trigger(name);
          }
        }
      }

      return this;
    }

    return this.on(name, ...args);
  }

  return eventHandler;
}

const click = shortcut('click');
const dom7_esm_blur = shortcut('blur');
const dom7_esm_focus = shortcut('focus');
const focusin = shortcut('focusin');
const focusout = shortcut('focusout');
const keyup = shortcut('keyup');
const keydown = shortcut('keydown');
const keypress = shortcut('keypress');
const dom7_esm_submit = shortcut('submit');
const change = shortcut('change');
const mousedown = shortcut('mousedown');
const mousemove = shortcut('mousemove');
const mouseup = shortcut('mouseup');
const mouseenter = shortcut('mouseenter');
const mouseleave = shortcut('mouseleave');
const mouseout = shortcut('mouseout');
const mouseover = shortcut('mouseover');
const touchstart = shortcut('touchstart');
const touchend = shortcut('touchend');
const touchmove = shortcut('touchmove');
const resize = shortcut('resize');
const dom7_esm_scroll = shortcut('scroll');

/* harmony default export */ var dom7_esm = ((/* unused pure expression or super */ null && (dom7_esm_$)));


;// CONCATENATED MODULE: ../../.yarn/unplugged/swiper-npm-8.4.7-9971804532/node_modules/swiper/shared/dom.js

const Methods = {
  addClass: addClass,
  removeClass: removeClass,
  hasClass: hasClass,
  toggleClass: toggleClass,
  attr: attr,
  removeAttr: removeAttr,
  transform: transform,
  transition: transition,
  on: on,
  off: off,
  trigger: trigger,
  transitionEnd: transitionEnd,
  outerWidth: dom7_esm_outerWidth,
  outerHeight: dom7_esm_outerHeight,
  styles: styles,
  offset: offset,
  css: css,
  each: each,
  html: html,
  text: dom7_esm_text,
  is: is,
  index: index,
  eq: eq,
  append: append,
  prepend: prepend,
  next: next,
  nextAll: nextAll,
  prev: prev,
  prevAll: prevAll,
  parent: dom7_esm_parent,
  parents: parents,
  closest: closest,
  find: find,
  children: children,
  filter: filter,
  remove: remove
};
Object.keys(Methods).forEach(methodName => {
  Object.defineProperty(dom7_esm_$.fn, methodName, {
    value: Methods[methodName],
    writable: true
  });
});
/* harmony default export */ var dom = (dom7_esm_$);
;// CONCATENATED MODULE: ../../.yarn/unplugged/swiper-npm-8.4.7-9971804532/node_modules/swiper/shared/utils.js


function deleteProps(obj) {
  const object = obj;
  Object.keys(object).forEach(key => {
    try {
      object[key] = null;
    } catch (e) {// no getter for object
    }

    try {
      delete object[key];
    } catch (e) {// something got wrong
    }
  });
}

function utils_nextTick(callback, delay = 0) {
  return setTimeout(callback, delay);
}

function utils_now() {
  return Date.now();
}

function utils_getComputedStyle(el) {
  const window = ssr_window_esm_getWindow();
  let style;

  if (window.getComputedStyle) {
    style = window.getComputedStyle(el, null);
  }

  if (!style && el.currentStyle) {
    style = el.currentStyle;
  }

  if (!style) {
    style = el.style;
  }

  return style;
}

function utils_getTranslate(el, axis = 'x') {
  const window = ssr_window_esm_getWindow();
  let matrix;
  let curTransform;
  let transformMatrix;
  const curStyle = utils_getComputedStyle(el, null);

  if (window.WebKitCSSMatrix) {
    curTransform = curStyle.transform || curStyle.webkitTransform;

    if (curTransform.split(',').length > 6) {
      curTransform = curTransform.split(', ').map(a => a.replace(',', '.')).join(', ');
    } // Some old versions of Webkit choke when 'none' is passed; pass
    // empty string instead in this case


    transformMatrix = new window.WebKitCSSMatrix(curTransform === 'none' ? '' : curTransform);
  } else {
    transformMatrix = curStyle.MozTransform || curStyle.OTransform || curStyle.MsTransform || curStyle.msTransform || curStyle.transform || curStyle.getPropertyValue('transform').replace('translate(', 'matrix(1, 0, 0, 1,');
    matrix = transformMatrix.toString().split(',');
  }

  if (axis === 'x') {
    // Latest Chrome and webkits Fix
    if (window.WebKitCSSMatrix) curTransform = transformMatrix.m41; // Crazy IE10 Matrix
    else if (matrix.length === 16) curTransform = parseFloat(matrix[12]); // Normal Browsers
    else curTransform = parseFloat(matrix[4]);
  }

  if (axis === 'y') {
    // Latest Chrome and webkits Fix
    if (window.WebKitCSSMatrix) curTransform = transformMatrix.m42; // Crazy IE10 Matrix
    else if (matrix.length === 16) curTransform = parseFloat(matrix[13]); // Normal Browsers
    else curTransform = parseFloat(matrix[5]);
  }

  return curTransform || 0;
}

function utils_isObject(o) {
  return typeof o === 'object' && o !== null && o.constructor && Object.prototype.toString.call(o).slice(8, -1) === 'Object';
}

function isNode(node) {
  // eslint-disable-next-line
  if (typeof window !== 'undefined' && typeof window.HTMLElement !== 'undefined') {
    return node instanceof HTMLElement;
  }

  return node && (node.nodeType === 1 || node.nodeType === 11);
}

function utils_extend(...args) {
  const to = Object(args[0]);
  const noExtend = ['__proto__', 'constructor', 'prototype'];

  for (let i = 1; i < args.length; i += 1) {
    const nextSource = args[i];

    if (nextSource !== undefined && nextSource !== null && !isNode(nextSource)) {
      const keysArray = Object.keys(Object(nextSource)).filter(key => noExtend.indexOf(key) < 0);

      for (let nextIndex = 0, len = keysArray.length; nextIndex < len; nextIndex += 1) {
        const nextKey = keysArray[nextIndex];
        const desc = Object.getOwnPropertyDescriptor(nextSource, nextKey);

        if (desc !== undefined && desc.enumerable) {
          if (utils_isObject(to[nextKey]) && utils_isObject(nextSource[nextKey])) {
            if (nextSource[nextKey].__swiper__) {
              to[nextKey] = nextSource[nextKey];
            } else {
              utils_extend(to[nextKey], nextSource[nextKey]);
            }
          } else if (!utils_isObject(to[nextKey]) && utils_isObject(nextSource[nextKey])) {
            to[nextKey] = {};

            if (nextSource[nextKey].__swiper__) {
              to[nextKey] = nextSource[nextKey];
            } else {
              utils_extend(to[nextKey], nextSource[nextKey]);
            }
          } else {
            to[nextKey] = nextSource[nextKey];
          }
        }
      }
    }
  }

  return to;
}

function utils_setCSSProperty(el, varName, varValue) {
  el.style.setProperty(varName, varValue);
}

function animateCSSModeScroll({
  swiper,
  targetPosition,
  side
}) {
  const window = ssr_window_esm_getWindow();
  const startPosition = -swiper.translate;
  let startTime = null;
  let time;
  const duration = swiper.params.speed;
  swiper.wrapperEl.style.scrollSnapType = 'none';
  window.cancelAnimationFrame(swiper.cssModeFrameID);
  const dir = targetPosition > startPosition ? 'next' : 'prev';

  const isOutOfBound = (current, target) => {
    return dir === 'next' && current >= target || dir === 'prev' && current <= target;
  };

  const animate = () => {
    time = new Date().getTime();

    if (startTime === null) {
      startTime = time;
    }

    const progress = Math.max(Math.min((time - startTime) / duration, 1), 0);
    const easeProgress = 0.5 - Math.cos(progress * Math.PI) / 2;
    let currentPosition = startPosition + easeProgress * (targetPosition - startPosition);

    if (isOutOfBound(currentPosition, targetPosition)) {
      currentPosition = targetPosition;
    }

    swiper.wrapperEl.scrollTo({
      [side]: currentPosition
    });

    if (isOutOfBound(currentPosition, targetPosition)) {
      swiper.wrapperEl.style.overflow = 'hidden';
      swiper.wrapperEl.style.scrollSnapType = '';
      setTimeout(() => {
        swiper.wrapperEl.style.overflow = '';
        swiper.wrapperEl.scrollTo({
          [side]: currentPosition
        });
      });
      window.cancelAnimationFrame(swiper.cssModeFrameID);
      return;
    }

    swiper.cssModeFrameID = window.requestAnimationFrame(animate);
  };

  animate();
}


;// CONCATENATED MODULE: ../../.yarn/unplugged/swiper-npm-8.4.7-9971804532/node_modules/swiper/shared/get-support.js

let support;

function calcSupport() {
  const window = ssr_window_esm_getWindow();
  const document = ssr_window_esm_getDocument();
  return {
    smoothScroll: document.documentElement && 'scrollBehavior' in document.documentElement.style,
    touch: !!('ontouchstart' in window || window.DocumentTouch && document instanceof window.DocumentTouch),
    passiveListener: function checkPassiveListener() {
      let supportsPassive = false;

      try {
        const opts = Object.defineProperty({}, 'passive', {
          // eslint-disable-next-line
          get() {
            supportsPassive = true;
          }

        });
        window.addEventListener('testPassiveListener', null, opts);
      } catch (e) {// No support
      }

      return supportsPassive;
    }(),
    gestures: function checkGestures() {
      return 'ongesturestart' in window;
    }()
  };
}

function getSupport() {
  if (!support) {
    support = calcSupport();
  }

  return support;
}


;// CONCATENATED MODULE: ../../.yarn/unplugged/swiper-npm-8.4.7-9971804532/node_modules/swiper/shared/get-device.js


let deviceCached;

function calcDevice({
  userAgent
} = {}) {
  const support = getSupport();
  const window = ssr_window_esm_getWindow();
  const platform = window.navigator.platform;
  const ua = userAgent || window.navigator.userAgent;
  const device = {
    ios: false,
    android: false
  };
  const screenWidth = window.screen.width;
  const screenHeight = window.screen.height;
  const android = ua.match(/(Android);?[\s\/]+([\d.]+)?/); // eslint-disable-line

  let ipad = ua.match(/(iPad).*OS\s([\d_]+)/);
  const ipod = ua.match(/(iPod)(.*OS\s([\d_]+))?/);
  const iphone = !ipad && ua.match(/(iPhone\sOS|iOS)\s([\d_]+)/);
  const windows = platform === 'Win32';
  let macos = platform === 'MacIntel'; // iPadOs 13 fix

  const iPadScreens = ['1024x1366', '1366x1024', '834x1194', '1194x834', '834x1112', '1112x834', '768x1024', '1024x768', '820x1180', '1180x820', '810x1080', '1080x810'];

  if (!ipad && macos && support.touch && iPadScreens.indexOf(`${screenWidth}x${screenHeight}`) >= 0) {
    ipad = ua.match(/(Version)\/([\d.]+)/);
    if (!ipad) ipad = [0, 1, '13_0_0'];
    macos = false;
  } // Android


  if (android && !windows) {
    device.os = 'android';
    device.android = true;
  }

  if (ipad || iphone || ipod) {
    device.os = 'ios';
    device.ios = true;
  } // Export object


  return device;
}

function getDevice(overrides = {}) {
  if (!deviceCached) {
    deviceCached = calcDevice(overrides);
  }

  return deviceCached;
}


;// CONCATENATED MODULE: ../../.yarn/unplugged/swiper-npm-8.4.7-9971804532/node_modules/swiper/shared/get-browser.js

let browser;

function calcBrowser() {
  const window = ssr_window_esm_getWindow();

  function isSafari() {
    const ua = window.navigator.userAgent.toLowerCase();
    return ua.indexOf('safari') >= 0 && ua.indexOf('chrome') < 0 && ua.indexOf('android') < 0;
  }

  return {
    isSafari: isSafari(),
    isWebView: /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(window.navigator.userAgent)
  };
}

function getBrowser() {
  if (!browser) {
    browser = calcBrowser();
  }

  return browser;
}


;// CONCATENATED MODULE: ../../.yarn/unplugged/swiper-npm-8.4.7-9971804532/node_modules/swiper/core/modules/resize/resize.js

function Resize({
  swiper,
  on,
  emit
}) {
  const window = ssr_window_esm_getWindow();
  let observer = null;
  let animationFrame = null;

  const resizeHandler = () => {
    if (!swiper || swiper.destroyed || !swiper.initialized) return;
    emit('beforeResize');
    emit('resize');
  };

  const createObserver = () => {
    if (!swiper || swiper.destroyed || !swiper.initialized) return;
    observer = new ResizeObserver(entries => {
      animationFrame = window.requestAnimationFrame(() => {
        const {
          width,
          height
        } = swiper;
        let newWidth = width;
        let newHeight = height;
        entries.forEach(({
          contentBoxSize,
          contentRect,
          target
        }) => {
          if (target && target !== swiper.el) return;
          newWidth = contentRect ? contentRect.width : (contentBoxSize[0] || contentBoxSize).inlineSize;
          newHeight = contentRect ? contentRect.height : (contentBoxSize[0] || contentBoxSize).blockSize;
        });

        if (newWidth !== width || newHeight !== height) {
          resizeHandler();
        }
      });
    });
    observer.observe(swiper.el);
  };

  const removeObserver = () => {
    if (animationFrame) {
      window.cancelAnimationFrame(animationFrame);
    }

    if (observer && observer.unobserve && swiper.el) {
      observer.unobserve(swiper.el);
      observer = null;
    }
  };

  const orientationChangeHandler = () => {
    if (!swiper || swiper.destroyed || !swiper.initialized) return;
    emit('orientationchange');
  };

  on('init', () => {
    if (swiper.params.resizeObserver && typeof window.ResizeObserver !== 'undefined') {
      createObserver();
      return;
    }

    window.addEventListener('resize', resizeHandler);
    window.addEventListener('orientationchange', orientationChangeHandler);
  });
  on('destroy', () => {
    removeObserver();
    window.removeEventListener('resize', resizeHandler);
    window.removeEventListener('orientationchange', orientationChangeHandler);
  });
}
;// CONCATENATED MODULE: ../../.yarn/unplugged/swiper-npm-8.4.7-9971804532/node_modules/swiper/core/modules/observer/observer.js

function Observer({
  swiper,
  extendParams,
  on,
  emit
}) {
  const observers = [];
  const window = ssr_window_esm_getWindow();

  const attach = (target, options = {}) => {
    const ObserverFunc = window.MutationObserver || window.WebkitMutationObserver;
    const observer = new ObserverFunc(mutations => {
      // The observerUpdate event should only be triggered
      // once despite the number of mutations.  Additional
      // triggers are redundant and are very costly
      if (mutations.length === 1) {
        emit('observerUpdate', mutations[0]);
        return;
      }

      const observerUpdate = function observerUpdate() {
        emit('observerUpdate', mutations[0]);
      };

      if (window.requestAnimationFrame) {
        window.requestAnimationFrame(observerUpdate);
      } else {
        window.setTimeout(observerUpdate, 0);
      }
    });
    observer.observe(target, {
      attributes: typeof options.attributes === 'undefined' ? true : options.attributes,
      childList: typeof options.childList === 'undefined' ? true : options.childList,
      characterData: typeof options.characterData === 'undefined' ? true : options.characterData
    });
    observers.push(observer);
  };

  const init = () => {
    if (!swiper.params.observer) return;

    if (swiper.params.observeParents) {
      const containerParents = swiper.$el.parents();

      for (let i = 0; i < containerParents.length; i += 1) {
        attach(containerParents[i]);
      }
    } // Observe container


    attach(swiper.$el[0], {
      childList: swiper.params.observeSlideChildren
    }); // Observe wrapper

    attach(swiper.$wrapperEl[0], {
      attributes: false
    });
  };

  const destroy = () => {
    observers.forEach(observer => {
      observer.disconnect();
    });
    observers.splice(0, observers.length);
  };

  extendParams({
    observer: false,
    observeParents: false,
    observeSlideChildren: false
  });
  on('init', init);
  on('destroy', destroy);
}
;// CONCATENATED MODULE: ../../.yarn/unplugged/swiper-npm-8.4.7-9971804532/node_modules/swiper/core/events-emitter.js
/* eslint-disable no-underscore-dangle */
/* harmony default export */ var events_emitter = ({
  on(events, handler, priority) {
    const self = this;
    if (!self.eventsListeners || self.destroyed) return self;
    if (typeof handler !== 'function') return self;
    const method = priority ? 'unshift' : 'push';
    events.split(' ').forEach(event => {
      if (!self.eventsListeners[event]) self.eventsListeners[event] = [];
      self.eventsListeners[event][method](handler);
    });
    return self;
  },

  once(events, handler, priority) {
    const self = this;
    if (!self.eventsListeners || self.destroyed) return self;
    if (typeof handler !== 'function') return self;

    function onceHandler(...args) {
      self.off(events, onceHandler);

      if (onceHandler.__emitterProxy) {
        delete onceHandler.__emitterProxy;
      }

      handler.apply(self, args);
    }

    onceHandler.__emitterProxy = handler;
    return self.on(events, onceHandler, priority);
  },

  onAny(handler, priority) {
    const self = this;
    if (!self.eventsListeners || self.destroyed) return self;
    if (typeof handler !== 'function') return self;
    const method = priority ? 'unshift' : 'push';

    if (self.eventsAnyListeners.indexOf(handler) < 0) {
      self.eventsAnyListeners[method](handler);
    }

    return self;
  },

  offAny(handler) {
    const self = this;
    if (!self.eventsListeners || self.destroyed) return self;
    if (!self.eventsAnyListeners) return self;
    const index = self.eventsAnyListeners.indexOf(handler);

    if (index >= 0) {
      self.eventsAnyListeners.splice(index, 1);
    }

    return self;
  },

  off(events, handler) {
    const self = this;
    if (!self.eventsListeners || self.destroyed) return self;
    if (!self.eventsListeners) return self;
    events.split(' ').forEach(event => {
      if (typeof handler === 'undefined') {
        self.eventsListeners[event] = [];
      } else if (self.eventsListeners[event]) {
        self.eventsListeners[event].forEach((eventHandler, index) => {
          if (eventHandler === handler || eventHandler.__emitterProxy && eventHandler.__emitterProxy === handler) {
            self.eventsListeners[event].splice(index, 1);
          }
        });
      }
    });
    return self;
  },

  emit(...args) {
    const self = this;
    if (!self.eventsListeners || self.destroyed) return self;
    if (!self.eventsListeners) return self;
    let events;
    let data;
    let context;

    if (typeof args[0] === 'string' || Array.isArray(args[0])) {
      events = args[0];
      data = args.slice(1, args.length);
      context = self;
    } else {
      events = args[0].events;
      data = args[0].data;
      context = args[0].context || self;
    }

    data.unshift(context);
    const eventsArray = Array.isArray(events) ? events : events.split(' ');
    eventsArray.forEach(event => {
      if (self.eventsAnyListeners && self.eventsAnyListeners.length) {
        self.eventsAnyListeners.forEach(eventHandler => {
          eventHandler.apply(context, [event, ...data]);
        });
      }

      if (self.eventsListeners && self.eventsListeners[event]) {
        self.eventsListeners[event].forEach(eventHandler => {
          eventHandler.apply(context, data);
        });
      }
    });
    return self;
  }

});
;// CONCATENATED MODULE: ../../.yarn/unplugged/swiper-npm-8.4.7-9971804532/node_modules/swiper/core/update/updateSize.js
function updateSize() {
  const swiper = this;
  let width;
  let height;
  const $el = swiper.$el;

  if (typeof swiper.params.width !== 'undefined' && swiper.params.width !== null) {
    width = swiper.params.width;
  } else {
    width = $el[0].clientWidth;
  }

  if (typeof swiper.params.height !== 'undefined' && swiper.params.height !== null) {
    height = swiper.params.height;
  } else {
    height = $el[0].clientHeight;
  }

  if (width === 0 && swiper.isHorizontal() || height === 0 && swiper.isVertical()) {
    return;
  } // Subtract paddings


  width = width - parseInt($el.css('padding-left') || 0, 10) - parseInt($el.css('padding-right') || 0, 10);
  height = height - parseInt($el.css('padding-top') || 0, 10) - parseInt($el.css('padding-bottom') || 0, 10);
  if (Number.isNaN(width)) width = 0;
  if (Number.isNaN(height)) height = 0;
  Object.assign(swiper, {
    width,
    height,
    size: swiper.isHorizontal() ? width : height
  });
}
;// CONCATENATED MODULE: ../../.yarn/unplugged/swiper-npm-8.4.7-9971804532/node_modules/swiper/core/update/updateSlides.js

function updateSlides() {
  const swiper = this;

  function getDirectionLabel(property) {
    if (swiper.isHorizontal()) {
      return property;
    } // prettier-ignore


    return {
      'width': 'height',
      'margin-top': 'margin-left',
      'margin-bottom ': 'margin-right',
      'margin-left': 'margin-top',
      'margin-right': 'margin-bottom',
      'padding-left': 'padding-top',
      'padding-right': 'padding-bottom',
      'marginRight': 'marginBottom'
    }[property];
  }

  function getDirectionPropertyValue(node, label) {
    return parseFloat(node.getPropertyValue(getDirectionLabel(label)) || 0);
  }

  const params = swiper.params;
  const {
    $wrapperEl,
    size: swiperSize,
    rtlTranslate: rtl,
    wrongRTL
  } = swiper;
  const isVirtual = swiper.virtual && params.virtual.enabled;
  const previousSlidesLength = isVirtual ? swiper.virtual.slides.length : swiper.slides.length;
  const slides = $wrapperEl.children(`.${swiper.params.slideClass}`);
  const slidesLength = isVirtual ? swiper.virtual.slides.length : slides.length;
  let snapGrid = [];
  const slidesGrid = [];
  const slidesSizesGrid = [];
  let offsetBefore = params.slidesOffsetBefore;

  if (typeof offsetBefore === 'function') {
    offsetBefore = params.slidesOffsetBefore.call(swiper);
  }

  let offsetAfter = params.slidesOffsetAfter;

  if (typeof offsetAfter === 'function') {
    offsetAfter = params.slidesOffsetAfter.call(swiper);
  }

  const previousSnapGridLength = swiper.snapGrid.length;
  const previousSlidesGridLength = swiper.slidesGrid.length;
  let spaceBetween = params.spaceBetween;
  let slidePosition = -offsetBefore;
  let prevSlideSize = 0;
  let index = 0;

  if (typeof swiperSize === 'undefined') {
    return;
  }

  if (typeof spaceBetween === 'string' && spaceBetween.indexOf('%') >= 0) {
    spaceBetween = parseFloat(spaceBetween.replace('%', '')) / 100 * swiperSize;
  }

  swiper.virtualSize = -spaceBetween; // reset margins

  if (rtl) slides.css({
    marginLeft: '',
    marginBottom: '',
    marginTop: ''
  });else slides.css({
    marginRight: '',
    marginBottom: '',
    marginTop: ''
  }); // reset cssMode offsets

  if (params.centeredSlides && params.cssMode) {
    utils_setCSSProperty(swiper.wrapperEl, '--swiper-centered-offset-before', '');
    utils_setCSSProperty(swiper.wrapperEl, '--swiper-centered-offset-after', '');
  }

  const gridEnabled = params.grid && params.grid.rows > 1 && swiper.grid;

  if (gridEnabled) {
    swiper.grid.initSlides(slidesLength);
  } // Calc slides


  let slideSize;
  const shouldResetSlideSize = params.slidesPerView === 'auto' && params.breakpoints && Object.keys(params.breakpoints).filter(key => {
    return typeof params.breakpoints[key].slidesPerView !== 'undefined';
  }).length > 0;

  for (let i = 0; i < slidesLength; i += 1) {
    slideSize = 0;
    const slide = slides.eq(i);

    if (gridEnabled) {
      swiper.grid.updateSlide(i, slide, slidesLength, getDirectionLabel);
    }

    if (slide.css('display') === 'none') continue; // eslint-disable-line

    if (params.slidesPerView === 'auto') {
      if (shouldResetSlideSize) {
        slides[i].style[getDirectionLabel('width')] = ``;
      }

      const slideStyles = getComputedStyle(slide[0]);
      const currentTransform = slide[0].style.transform;
      const currentWebKitTransform = slide[0].style.webkitTransform;

      if (currentTransform) {
        slide[0].style.transform = 'none';
      }

      if (currentWebKitTransform) {
        slide[0].style.webkitTransform = 'none';
      }

      if (params.roundLengths) {
        slideSize = swiper.isHorizontal() ? slide.outerWidth(true) : slide.outerHeight(true);
      } else {
        // eslint-disable-next-line
        const width = getDirectionPropertyValue(slideStyles, 'width');
        const paddingLeft = getDirectionPropertyValue(slideStyles, 'padding-left');
        const paddingRight = getDirectionPropertyValue(slideStyles, 'padding-right');
        const marginLeft = getDirectionPropertyValue(slideStyles, 'margin-left');
        const marginRight = getDirectionPropertyValue(slideStyles, 'margin-right');
        const boxSizing = slideStyles.getPropertyValue('box-sizing');

        if (boxSizing && boxSizing === 'border-box') {
          slideSize = width + marginLeft + marginRight;
        } else {
          const {
            clientWidth,
            offsetWidth
          } = slide[0];
          slideSize = width + paddingLeft + paddingRight + marginLeft + marginRight + (offsetWidth - clientWidth);
        }
      }

      if (currentTransform) {
        slide[0].style.transform = currentTransform;
      }

      if (currentWebKitTransform) {
        slide[0].style.webkitTransform = currentWebKitTransform;
      }

      if (params.roundLengths) slideSize = Math.floor(slideSize);
    } else {
      slideSize = (swiperSize - (params.slidesPerView - 1) * spaceBetween) / params.slidesPerView;
      if (params.roundLengths) slideSize = Math.floor(slideSize);

      if (slides[i]) {
        slides[i].style[getDirectionLabel('width')] = `${slideSize}px`;
      }
    }

    if (slides[i]) {
      slides[i].swiperSlideSize = slideSize;
    }

    slidesSizesGrid.push(slideSize);

    if (params.centeredSlides) {
      slidePosition = slidePosition + slideSize / 2 + prevSlideSize / 2 + spaceBetween;
      if (prevSlideSize === 0 && i !== 0) slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
      if (i === 0) slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
      if (Math.abs(slidePosition) < 1 / 1000) slidePosition = 0;
      if (params.roundLengths) slidePosition = Math.floor(slidePosition);
      if (index % params.slidesPerGroup === 0) snapGrid.push(slidePosition);
      slidesGrid.push(slidePosition);
    } else {
      if (params.roundLengths) slidePosition = Math.floor(slidePosition);
      if ((index - Math.min(swiper.params.slidesPerGroupSkip, index)) % swiper.params.slidesPerGroup === 0) snapGrid.push(slidePosition);
      slidesGrid.push(slidePosition);
      slidePosition = slidePosition + slideSize + spaceBetween;
    }

    swiper.virtualSize += slideSize + spaceBetween;
    prevSlideSize = slideSize;
    index += 1;
  }

  swiper.virtualSize = Math.max(swiper.virtualSize, swiperSize) + offsetAfter;

  if (rtl && wrongRTL && (params.effect === 'slide' || params.effect === 'coverflow')) {
    $wrapperEl.css({
      width: `${swiper.virtualSize + params.spaceBetween}px`
    });
  }

  if (params.setWrapperSize) {
    $wrapperEl.css({
      [getDirectionLabel('width')]: `${swiper.virtualSize + params.spaceBetween}px`
    });
  }

  if (gridEnabled) {
    swiper.grid.updateWrapperSize(slideSize, snapGrid, getDirectionLabel);
  } // Remove last grid elements depending on width


  if (!params.centeredSlides) {
    const newSlidesGrid = [];

    for (let i = 0; i < snapGrid.length; i += 1) {
      let slidesGridItem = snapGrid[i];
      if (params.roundLengths) slidesGridItem = Math.floor(slidesGridItem);

      if (snapGrid[i] <= swiper.virtualSize - swiperSize) {
        newSlidesGrid.push(slidesGridItem);
      }
    }

    snapGrid = newSlidesGrid;

    if (Math.floor(swiper.virtualSize - swiperSize) - Math.floor(snapGrid[snapGrid.length - 1]) > 1) {
      snapGrid.push(swiper.virtualSize - swiperSize);
    }
  }

  if (snapGrid.length === 0) snapGrid = [0];

  if (params.spaceBetween !== 0) {
    const key = swiper.isHorizontal() && rtl ? 'marginLeft' : getDirectionLabel('marginRight');
    slides.filter((_, slideIndex) => {
      if (!params.cssMode) return true;

      if (slideIndex === slides.length - 1) {
        return false;
      }

      return true;
    }).css({
      [key]: `${spaceBetween}px`
    });
  }

  if (params.centeredSlides && params.centeredSlidesBounds) {
    let allSlidesSize = 0;
    slidesSizesGrid.forEach(slideSizeValue => {
      allSlidesSize += slideSizeValue + (params.spaceBetween ? params.spaceBetween : 0);
    });
    allSlidesSize -= params.spaceBetween;
    const maxSnap = allSlidesSize - swiperSize;
    snapGrid = snapGrid.map(snap => {
      if (snap < 0) return -offsetBefore;
      if (snap > maxSnap) return maxSnap + offsetAfter;
      return snap;
    });
  }

  if (params.centerInsufficientSlides) {
    let allSlidesSize = 0;
    slidesSizesGrid.forEach(slideSizeValue => {
      allSlidesSize += slideSizeValue + (params.spaceBetween ? params.spaceBetween : 0);
    });
    allSlidesSize -= params.spaceBetween;

    if (allSlidesSize < swiperSize) {
      const allSlidesOffset = (swiperSize - allSlidesSize) / 2;
      snapGrid.forEach((snap, snapIndex) => {
        snapGrid[snapIndex] = snap - allSlidesOffset;
      });
      slidesGrid.forEach((snap, snapIndex) => {
        slidesGrid[snapIndex] = snap + allSlidesOffset;
      });
    }
  }

  Object.assign(swiper, {
    slides,
    snapGrid,
    slidesGrid,
    slidesSizesGrid
  });

  if (params.centeredSlides && params.cssMode && !params.centeredSlidesBounds) {
    utils_setCSSProperty(swiper.wrapperEl, '--swiper-centered-offset-before', `${-snapGrid[0]}px`);
    utils_setCSSProperty(swiper.wrapperEl, '--swiper-centered-offset-after', `${swiper.size / 2 - slidesSizesGrid[slidesSizesGrid.length - 1] / 2}px`);
    const addToSnapGrid = -swiper.snapGrid[0];
    const addToSlidesGrid = -swiper.slidesGrid[0];
    swiper.snapGrid = swiper.snapGrid.map(v => v + addToSnapGrid);
    swiper.slidesGrid = swiper.slidesGrid.map(v => v + addToSlidesGrid);
  }

  if (slidesLength !== previousSlidesLength) {
    swiper.emit('slidesLengthChange');
  }

  if (snapGrid.length !== previousSnapGridLength) {
    if (swiper.params.watchOverflow) swiper.checkOverflow();
    swiper.emit('snapGridLengthChange');
  }

  if (slidesGrid.length !== previousSlidesGridLength) {
    swiper.emit('slidesGridLengthChange');
  }

  if (params.watchSlidesProgress) {
    swiper.updateSlidesOffset();
  }

  if (!isVirtual && !params.cssMode && (params.effect === 'slide' || params.effect === 'fade')) {
    const backFaceHiddenClass = `${params.containerModifierClass}backface-hidden`;
    const hasClassBackfaceClassAdded = swiper.$el.hasClass(backFaceHiddenClass);

    if (slidesLength <= params.maxBackfaceHiddenSlides) {
      if (!hasClassBackfaceClassAdded) swiper.$el.addClass(backFaceHiddenClass);
    } else if (hasClassBackfaceClassAdded) {
      swiper.$el.removeClass(backFaceHiddenClass);
    }
  }
}
;// CONCATENATED MODULE: ../../.yarn/unplugged/swiper-npm-8.4.7-9971804532/node_modules/swiper/core/update/updateAutoHeight.js

function updateAutoHeight(speed) {
  const swiper = this;
  const activeSlides = [];
  const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
  let newHeight = 0;
  let i;

  if (typeof speed === 'number') {
    swiper.setTransition(speed);
  } else if (speed === true) {
    swiper.setTransition(swiper.params.speed);
  }

  const getSlideByIndex = index => {
    if (isVirtual) {
      return swiper.slides.filter(el => parseInt(el.getAttribute('data-swiper-slide-index'), 10) === index)[0];
    }

    return swiper.slides.eq(index)[0];
  }; // Find slides currently in view


  if (swiper.params.slidesPerView !== 'auto' && swiper.params.slidesPerView > 1) {
    if (swiper.params.centeredSlides) {
      (swiper.visibleSlides || dom([])).each(slide => {
        activeSlides.push(slide);
      });
    } else {
      for (i = 0; i < Math.ceil(swiper.params.slidesPerView); i += 1) {
        const index = swiper.activeIndex + i;
        if (index > swiper.slides.length && !isVirtual) break;
        activeSlides.push(getSlideByIndex(index));
      }
    }
  } else {
    activeSlides.push(getSlideByIndex(swiper.activeIndex));
  } // Find new height from highest slide in view


  for (i = 0; i < activeSlides.length; i += 1) {
    if (typeof activeSlides[i] !== 'undefined') {
      const height = activeSlides[i].offsetHeight;
      newHeight = height > newHeight ? height : newHeight;
    }
  } // Update Height


  if (newHeight || newHeight === 0) swiper.$wrapperEl.css('height', `${newHeight}px`);
}
;// CONCATENATED MODULE: ../../.yarn/unplugged/swiper-npm-8.4.7-9971804532/node_modules/swiper/core/update/updateSlidesOffset.js
function updateSlidesOffset() {
  const swiper = this;
  const slides = swiper.slides;

  for (let i = 0; i < slides.length; i += 1) {
    slides[i].swiperSlideOffset = swiper.isHorizontal() ? slides[i].offsetLeft : slides[i].offsetTop;
  }
}
;// CONCATENATED MODULE: ../../.yarn/unplugged/swiper-npm-8.4.7-9971804532/node_modules/swiper/core/update/updateSlidesProgress.js

function updateSlidesProgress(translate = this && this.translate || 0) {
  const swiper = this;
  const params = swiper.params;
  const {
    slides,
    rtlTranslate: rtl,
    snapGrid
  } = swiper;
  if (slides.length === 0) return;
  if (typeof slides[0].swiperSlideOffset === 'undefined') swiper.updateSlidesOffset();
  let offsetCenter = -translate;
  if (rtl) offsetCenter = translate; // Visible Slides

  slides.removeClass(params.slideVisibleClass);
  swiper.visibleSlidesIndexes = [];
  swiper.visibleSlides = [];

  for (let i = 0; i < slides.length; i += 1) {
    const slide = slides[i];
    let slideOffset = slide.swiperSlideOffset;

    if (params.cssMode && params.centeredSlides) {
      slideOffset -= slides[0].swiperSlideOffset;
    }

    const slideProgress = (offsetCenter + (params.centeredSlides ? swiper.minTranslate() : 0) - slideOffset) / (slide.swiperSlideSize + params.spaceBetween);
    const originalSlideProgress = (offsetCenter - snapGrid[0] + (params.centeredSlides ? swiper.minTranslate() : 0) - slideOffset) / (slide.swiperSlideSize + params.spaceBetween);
    const slideBefore = -(offsetCenter - slideOffset);
    const slideAfter = slideBefore + swiper.slidesSizesGrid[i];
    const isVisible = slideBefore >= 0 && slideBefore < swiper.size - 1 || slideAfter > 1 && slideAfter <= swiper.size || slideBefore <= 0 && slideAfter >= swiper.size;

    if (isVisible) {
      swiper.visibleSlides.push(slide);
      swiper.visibleSlidesIndexes.push(i);
      slides.eq(i).addClass(params.slideVisibleClass);
    }

    slide.progress = rtl ? -slideProgress : slideProgress;
    slide.originalProgress = rtl ? -originalSlideProgress : originalSlideProgress;
  }

  swiper.visibleSlides = dom(swiper.visibleSlides);
}
;// CONCATENATED MODULE: ../../.yarn/unplugged/swiper-npm-8.4.7-9971804532/node_modules/swiper/core/update/updateProgress.js
function updateProgress(translate) {
  const swiper = this;

  if (typeof translate === 'undefined') {
    const multiplier = swiper.rtlTranslate ? -1 : 1; // eslint-disable-next-line

    translate = swiper && swiper.translate && swiper.translate * multiplier || 0;
  }

  const params = swiper.params;
  const translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
  let {
    progress,
    isBeginning,
    isEnd
  } = swiper;
  const wasBeginning = isBeginning;
  const wasEnd = isEnd;

  if (translatesDiff === 0) {
    progress = 0;
    isBeginning = true;
    isEnd = true;
  } else {
    progress = (translate - swiper.minTranslate()) / translatesDiff;
    isBeginning = progress <= 0;
    isEnd = progress >= 1;
  }

  Object.assign(swiper, {
    progress,
    isBeginning,
    isEnd
  });
  if (params.watchSlidesProgress || params.centeredSlides && params.autoHeight) swiper.updateSlidesProgress(translate);

  if (isBeginning && !wasBeginning) {
    swiper.emit('reachBeginning toEdge');
  }

  if (isEnd && !wasEnd) {
    swiper.emit('reachEnd toEdge');
  }

  if (wasBeginning && !isBeginning || wasEnd && !isEnd) {
    swiper.emit('fromEdge');
  }

  swiper.emit('progress', progress);
}
;// CONCATENATED MODULE: ../../.yarn/unplugged/swiper-npm-8.4.7-9971804532/node_modules/swiper/core/update/updateSlidesClasses.js
function updateSlidesClasses() {
  const swiper = this;
  const {
    slides,
    params,
    $wrapperEl,
    activeIndex,
    realIndex
  } = swiper;
  const isVirtual = swiper.virtual && params.virtual.enabled;
  slides.removeClass(`${params.slideActiveClass} ${params.slideNextClass} ${params.slidePrevClass} ${params.slideDuplicateActiveClass} ${params.slideDuplicateNextClass} ${params.slideDuplicatePrevClass}`);
  let activeSlide;

  if (isVirtual) {
    activeSlide = swiper.$wrapperEl.find(`.${params.slideClass}[data-swiper-slide-index="${activeIndex}"]`);
  } else {
    activeSlide = slides.eq(activeIndex);
  } // Active classes


  activeSlide.addClass(params.slideActiveClass);

  if (params.loop) {
    // Duplicate to all looped slides
    if (activeSlide.hasClass(params.slideDuplicateClass)) {
      $wrapperEl.children(`.${params.slideClass}:not(.${params.slideDuplicateClass})[data-swiper-slide-index="${realIndex}"]`).addClass(params.slideDuplicateActiveClass);
    } else {
      $wrapperEl.children(`.${params.slideClass}.${params.slideDuplicateClass}[data-swiper-slide-index="${realIndex}"]`).addClass(params.slideDuplicateActiveClass);
    }
  } // Next Slide


  let nextSlide = activeSlide.nextAll(`.${params.slideClass}`).eq(0).addClass(params.slideNextClass);

  if (params.loop && nextSlide.length === 0) {
    nextSlide = slides.eq(0);
    nextSlide.addClass(params.slideNextClass);
  } // Prev Slide


  let prevSlide = activeSlide.prevAll(`.${params.slideClass}`).eq(0).addClass(params.slidePrevClass);

  if (params.loop && prevSlide.length === 0) {
    prevSlide = slides.eq(-1);
    prevSlide.addClass(params.slidePrevClass);
  }

  if (params.loop) {
    // Duplicate to all looped slides
    if (nextSlide.hasClass(params.slideDuplicateClass)) {
      $wrapperEl.children(`.${params.slideClass}:not(.${params.slideDuplicateClass})[data-swiper-slide-index="${nextSlide.attr('data-swiper-slide-index')}"]`).addClass(params.slideDuplicateNextClass);
    } else {
      $wrapperEl.children(`.${params.slideClass}.${params.slideDuplicateClass}[data-swiper-slide-index="${nextSlide.attr('data-swiper-slide-index')}"]`).addClass(params.slideDuplicateNextClass);
    }

    if (prevSlide.hasClass(params.slideDuplicateClass)) {
      $wrapperEl.children(`.${params.slideClass}:not(.${params.slideDuplicateClass})[data-swiper-slide-index="${prevSlide.attr('data-swiper-slide-index')}"]`).addClass(params.slideDuplicatePrevClass);
    } else {
      $wrapperEl.children(`.${params.slideClass}.${params.slideDuplicateClass}[data-swiper-slide-index="${prevSlide.attr('data-swiper-slide-index')}"]`).addClass(params.slideDuplicatePrevClass);
    }
  }

  swiper.emitSlidesClasses();
}
;// CONCATENATED MODULE: ../../.yarn/unplugged/swiper-npm-8.4.7-9971804532/node_modules/swiper/core/update/updateActiveIndex.js
function updateActiveIndex(newActiveIndex) {
  const swiper = this;
  const translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
  const {
    slidesGrid,
    snapGrid,
    params,
    activeIndex: previousIndex,
    realIndex: previousRealIndex,
    snapIndex: previousSnapIndex
  } = swiper;
  let activeIndex = newActiveIndex;
  let snapIndex;

  if (typeof activeIndex === 'undefined') {
    for (let i = 0; i < slidesGrid.length; i += 1) {
      if (typeof slidesGrid[i + 1] !== 'undefined') {
        if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1] - (slidesGrid[i + 1] - slidesGrid[i]) / 2) {
          activeIndex = i;
        } else if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1]) {
          activeIndex = i + 1;
        }
      } else if (translate >= slidesGrid[i]) {
        activeIndex = i;
      }
    } // Normalize slideIndex


    if (params.normalizeSlideIndex) {
      if (activeIndex < 0 || typeof activeIndex === 'undefined') activeIndex = 0;
    }
  }

  if (snapGrid.indexOf(translate) >= 0) {
    snapIndex = snapGrid.indexOf(translate);
  } else {
    const skip = Math.min(params.slidesPerGroupSkip, activeIndex);
    snapIndex = skip + Math.floor((activeIndex - skip) / params.slidesPerGroup);
  }

  if (snapIndex >= snapGrid.length) snapIndex = snapGrid.length - 1;

  if (activeIndex === previousIndex) {
    if (snapIndex !== previousSnapIndex) {
      swiper.snapIndex = snapIndex;
      swiper.emit('snapIndexChange');
    }

    return;
  } // Get real index


  const realIndex = parseInt(swiper.slides.eq(activeIndex).attr('data-swiper-slide-index') || activeIndex, 10);
  Object.assign(swiper, {
    snapIndex,
    realIndex,
    previousIndex,
    activeIndex
  });
  swiper.emit('activeIndexChange');
  swiper.emit('snapIndexChange');

  if (previousRealIndex !== realIndex) {
    swiper.emit('realIndexChange');
  }

  if (swiper.initialized || swiper.params.runCallbacksOnInit) {
    swiper.emit('slideChange');
  }
}
;// CONCATENATED MODULE: ../../.yarn/unplugged/swiper-npm-8.4.7-9971804532/node_modules/swiper/core/update/updateClickedSlide.js

function updateClickedSlide(e) {
  const swiper = this;
  const params = swiper.params;
  const slide = dom(e).closest(`.${params.slideClass}`)[0];
  let slideFound = false;
  let slideIndex;

  if (slide) {
    for (let i = 0; i < swiper.slides.length; i += 1) {
      if (swiper.slides[i] === slide) {
        slideFound = true;
        slideIndex = i;
        break;
      }
    }
  }

  if (slide && slideFound) {
    swiper.clickedSlide = slide;

    if (swiper.virtual && swiper.params.virtual.enabled) {
      swiper.clickedIndex = parseInt(dom(slide).attr('data-swiper-slide-index'), 10);
    } else {
      swiper.clickedIndex = slideIndex;
    }
  } else {
    swiper.clickedSlide = undefined;
    swiper.clickedIndex = undefined;
    return;
  }

  if (params.slideToClickedSlide && swiper.clickedIndex !== undefined && swiper.clickedIndex !== swiper.activeIndex) {
    swiper.slideToClickedSlide();
  }
}
;// CONCATENATED MODULE: ../../.yarn/unplugged/swiper-npm-8.4.7-9971804532/node_modules/swiper/core/update/index.js









/* harmony default export */ var update = ({
  updateSize: updateSize,
  updateSlides: updateSlides,
  updateAutoHeight: updateAutoHeight,
  updateSlidesOffset: updateSlidesOffset,
  updateSlidesProgress: updateSlidesProgress,
  updateProgress: updateProgress,
  updateSlidesClasses: updateSlidesClasses,
  updateActiveIndex: updateActiveIndex,
  updateClickedSlide: updateClickedSlide
});
;// CONCATENATED MODULE: ../../.yarn/unplugged/swiper-npm-8.4.7-9971804532/node_modules/swiper/core/translate/getTranslate.js

function getSwiperTranslate(axis = this.isHorizontal() ? 'x' : 'y') {
  const swiper = this;
  const {
    params,
    rtlTranslate: rtl,
    translate,
    $wrapperEl
  } = swiper;

  if (params.virtualTranslate) {
    return rtl ? -translate : translate;
  }

  if (params.cssMode) {
    return translate;
  }

  let currentTranslate = utils_getTranslate($wrapperEl[0], axis);
  if (rtl) currentTranslate = -currentTranslate;
  return currentTranslate || 0;
}
;// CONCATENATED MODULE: ../../.yarn/unplugged/swiper-npm-8.4.7-9971804532/node_modules/swiper/core/translate/setTranslate.js
function setTranslate(translate, byController) {
  const swiper = this;
  const {
    rtlTranslate: rtl,
    params,
    $wrapperEl,
    wrapperEl,
    progress
  } = swiper;
  let x = 0;
  let y = 0;
  const z = 0;

  if (swiper.isHorizontal()) {
    x = rtl ? -translate : translate;
  } else {
    y = translate;
  }

  if (params.roundLengths) {
    x = Math.floor(x);
    y = Math.floor(y);
  }

  if (params.cssMode) {
    wrapperEl[swiper.isHorizontal() ? 'scrollLeft' : 'scrollTop'] = swiper.isHorizontal() ? -x : -y;
  } else if (!params.virtualTranslate) {
    $wrapperEl.transform(`translate3d(${x}px, ${y}px, ${z}px)`);
  }

  swiper.previousTranslate = swiper.translate;
  swiper.translate = swiper.isHorizontal() ? x : y; // Check if we need to update progress

  let newProgress;
  const translatesDiff = swiper.maxTranslate() - swiper.minTranslate();

  if (translatesDiff === 0) {
    newProgress = 0;
  } else {
    newProgress = (translate - swiper.minTranslate()) / translatesDiff;
  }

  if (newProgress !== progress) {
    swiper.updateProgress(translate);
  }

  swiper.emit('setTranslate', swiper.translate, byController);
}
;// CONCATENATED MODULE: ../../.yarn/unplugged/swiper-npm-8.4.7-9971804532/node_modules/swiper/core/translate/minTranslate.js
function minTranslate() {
  return -this.snapGrid[0];
}
;// CONCATENATED MODULE: ../../.yarn/unplugged/swiper-npm-8.4.7-9971804532/node_modules/swiper/core/translate/maxTranslate.js
function maxTranslate() {
  return -this.snapGrid[this.snapGrid.length - 1];
}
;// CONCATENATED MODULE: ../../.yarn/unplugged/swiper-npm-8.4.7-9971804532/node_modules/swiper/core/translate/translateTo.js

function translateTo(translate = 0, speed = this.params.speed, runCallbacks = true, translateBounds = true, internal) {
  const swiper = this;
  const {
    params,
    wrapperEl
  } = swiper;

  if (swiper.animating && params.preventInteractionOnTransition) {
    return false;
  }

  const minTranslate = swiper.minTranslate();
  const maxTranslate = swiper.maxTranslate();
  let newTranslate;
  if (translateBounds && translate > minTranslate) newTranslate = minTranslate;else if (translateBounds && translate < maxTranslate) newTranslate = maxTranslate;else newTranslate = translate; // Update progress

  swiper.updateProgress(newTranslate);

  if (params.cssMode) {
    const isH = swiper.isHorizontal();

    if (speed === 0) {
      wrapperEl[isH ? 'scrollLeft' : 'scrollTop'] = -newTranslate;
    } else {
      if (!swiper.support.smoothScroll) {
        animateCSSModeScroll({
          swiper,
          targetPosition: -newTranslate,
          side: isH ? 'left' : 'top'
        });
        return true;
      }

      wrapperEl.scrollTo({
        [isH ? 'left' : 'top']: -newTranslate,
        behavior: 'smooth'
      });
    }

    return true;
  }

  if (speed === 0) {
    swiper.setTransition(0);
    swiper.setTranslate(newTranslate);

    if (runCallbacks) {
      swiper.emit('beforeTransitionStart', speed, internal);
      swiper.emit('transitionEnd');
    }
  } else {
    swiper.setTransition(speed);
    swiper.setTranslate(newTranslate);

    if (runCallbacks) {
      swiper.emit('beforeTransitionStart', speed, internal);
      swiper.emit('transitionStart');
    }

    if (!swiper.animating) {
      swiper.animating = true;

      if (!swiper.onTranslateToWrapperTransitionEnd) {
        swiper.onTranslateToWrapperTransitionEnd = function transitionEnd(e) {
          if (!swiper || swiper.destroyed) return;
          if (e.target !== this) return;
          swiper.$wrapperEl[0].removeEventListener('transitionend', swiper.onTranslateToWrapperTransitionEnd);
          swiper.$wrapperEl[0].removeEventListener('webkitTransitionEnd', swiper.onTranslateToWrapperTransitionEnd);
          swiper.onTranslateToWrapperTransitionEnd = null;
          delete swiper.onTranslateToWrapperTransitionEnd;

          if (runCallbacks) {
            swiper.emit('transitionEnd');
          }
        };
      }

      swiper.$wrapperEl[0].addEventListener('transitionend', swiper.onTranslateToWrapperTransitionEnd);
      swiper.$wrapperEl[0].addEventListener('webkitTransitionEnd', swiper.onTranslateToWrapperTransitionEnd);
    }
  }

  return true;
}
;// CONCATENATED MODULE: ../../.yarn/unplugged/swiper-npm-8.4.7-9971804532/node_modules/swiper/core/translate/index.js





/* harmony default export */ var translate = ({
  getTranslate: getSwiperTranslate,
  setTranslate: setTranslate,
  minTranslate: minTranslate,
  maxTranslate: maxTranslate,
  translateTo: translateTo
});
;// CONCATENATED MODULE: ../../.yarn/unplugged/swiper-npm-8.4.7-9971804532/node_modules/swiper/core/transition/setTransition.js
function setTransition(duration, byController) {
  const swiper = this;

  if (!swiper.params.cssMode) {
    swiper.$wrapperEl.transition(duration);
  }

  swiper.emit('setTransition', duration, byController);
}
;// CONCATENATED MODULE: ../../.yarn/unplugged/swiper-npm-8.4.7-9971804532/node_modules/swiper/core/transition/transitionEmit.js
function transitionEmit({
  swiper,
  runCallbacks,
  direction,
  step
}) {
  const {
    activeIndex,
    previousIndex
  } = swiper;
  let dir = direction;

  if (!dir) {
    if (activeIndex > previousIndex) dir = 'next';else if (activeIndex < previousIndex) dir = 'prev';else dir = 'reset';
  }

  swiper.emit(`transition${step}`);

  if (runCallbacks && activeIndex !== previousIndex) {
    if (dir === 'reset') {
      swiper.emit(`slideResetTransition${step}`);
      return;
    }

    swiper.emit(`slideChangeTransition${step}`);

    if (dir === 'next') {
      swiper.emit(`slideNextTransition${step}`);
    } else {
      swiper.emit(`slidePrevTransition${step}`);
    }
  }
}
;// CONCATENATED MODULE: ../../.yarn/unplugged/swiper-npm-8.4.7-9971804532/node_modules/swiper/core/transition/transitionStart.js

function transitionStart(runCallbacks = true, direction) {
  const swiper = this;
  const {
    params
  } = swiper;
  if (params.cssMode) return;

  if (params.autoHeight) {
    swiper.updateAutoHeight();
  }

  transitionEmit({
    swiper,
    runCallbacks,
    direction,
    step: 'Start'
  });
}
;// CONCATENATED MODULE: ../../.yarn/unplugged/swiper-npm-8.4.7-9971804532/node_modules/swiper/core/transition/transitionEnd.js

function transitionEnd_transitionEnd(runCallbacks = true, direction) {
  const swiper = this;
  const {
    params
  } = swiper;
  swiper.animating = false;
  if (params.cssMode) return;
  swiper.setTransition(0);
  transitionEmit({
    swiper,
    runCallbacks,
    direction,
    step: 'End'
  });
}
;// CONCATENATED MODULE: ../../.yarn/unplugged/swiper-npm-8.4.7-9971804532/node_modules/swiper/core/transition/index.js



/* harmony default export */ var core_transition = ({
  setTransition: setTransition,
  transitionStart: transitionStart,
  transitionEnd: transitionEnd_transitionEnd
});
;// CONCATENATED MODULE: ../../.yarn/unplugged/swiper-npm-8.4.7-9971804532/node_modules/swiper/core/slide/slideTo.js

function slideTo(index = 0, speed = this.params.speed, runCallbacks = true, internal, initial) {
  if (typeof index !== 'number' && typeof index !== 'string') {
    throw new Error(`The 'index' argument cannot have type other than 'number' or 'string'. [${typeof index}] given.`);
  }

  if (typeof index === 'string') {
    /**
     * The `index` argument converted from `string` to `number`.
     * @type {number}
     */
    const indexAsNumber = parseInt(index, 10);
    /**
     * Determines whether the `index` argument is a valid `number`
     * after being converted from the `string` type.
     * @type {boolean}
     */

    const isValidNumber = isFinite(indexAsNumber);

    if (!isValidNumber) {
      throw new Error(`The passed-in 'index' (string) couldn't be converted to 'number'. [${index}] given.`);
    } // Knowing that the converted `index` is a valid number,
    // we can update the original argument's value.


    index = indexAsNumber;
  }

  const swiper = this;
  let slideIndex = index;
  if (slideIndex < 0) slideIndex = 0;
  const {
    params,
    snapGrid,
    slidesGrid,
    previousIndex,
    activeIndex,
    rtlTranslate: rtl,
    wrapperEl,
    enabled
  } = swiper;

  if (swiper.animating && params.preventInteractionOnTransition || !enabled && !internal && !initial) {
    return false;
  }

  const skip = Math.min(swiper.params.slidesPerGroupSkip, slideIndex);
  let snapIndex = skip + Math.floor((slideIndex - skip) / swiper.params.slidesPerGroup);
  if (snapIndex >= snapGrid.length) snapIndex = snapGrid.length - 1;
  const translate = -snapGrid[snapIndex]; // Normalize slideIndex

  if (params.normalizeSlideIndex) {
    for (let i = 0; i < slidesGrid.length; i += 1) {
      const normalizedTranslate = -Math.floor(translate * 100);
      const normalizedGrid = Math.floor(slidesGrid[i] * 100);
      const normalizedGridNext = Math.floor(slidesGrid[i + 1] * 100);

      if (typeof slidesGrid[i + 1] !== 'undefined') {
        if (normalizedTranslate >= normalizedGrid && normalizedTranslate < normalizedGridNext - (normalizedGridNext - normalizedGrid) / 2) {
          slideIndex = i;
        } else if (normalizedTranslate >= normalizedGrid && normalizedTranslate < normalizedGridNext) {
          slideIndex = i + 1;
        }
      } else if (normalizedTranslate >= normalizedGrid) {
        slideIndex = i;
      }
    }
  } // Directions locks


  if (swiper.initialized && slideIndex !== activeIndex) {
    if (!swiper.allowSlideNext && translate < swiper.translate && translate < swiper.minTranslate()) {
      return false;
    }

    if (!swiper.allowSlidePrev && translate > swiper.translate && translate > swiper.maxTranslate()) {
      if ((activeIndex || 0) !== slideIndex) return false;
    }
  }

  if (slideIndex !== (previousIndex || 0) && runCallbacks) {
    swiper.emit('beforeSlideChangeStart');
  } // Update progress


  swiper.updateProgress(translate);
  let direction;
  if (slideIndex > activeIndex) direction = 'next';else if (slideIndex < activeIndex) direction = 'prev';else direction = 'reset'; // Update Index

  if (rtl && -translate === swiper.translate || !rtl && translate === swiper.translate) {
    swiper.updateActiveIndex(slideIndex); // Update Height

    if (params.autoHeight) {
      swiper.updateAutoHeight();
    }

    swiper.updateSlidesClasses();

    if (params.effect !== 'slide') {
      swiper.setTranslate(translate);
    }

    if (direction !== 'reset') {
      swiper.transitionStart(runCallbacks, direction);
      swiper.transitionEnd(runCallbacks, direction);
    }

    return false;
  }

  if (params.cssMode) {
    const isH = swiper.isHorizontal();
    const t = rtl ? translate : -translate;

    if (speed === 0) {
      const isVirtual = swiper.virtual && swiper.params.virtual.enabled;

      if (isVirtual) {
        swiper.wrapperEl.style.scrollSnapType = 'none';
        swiper._immediateVirtual = true;
      }

      wrapperEl[isH ? 'scrollLeft' : 'scrollTop'] = t;

      if (isVirtual) {
        requestAnimationFrame(() => {
          swiper.wrapperEl.style.scrollSnapType = '';
          swiper._swiperImmediateVirtual = false;
        });
      }
    } else {
      if (!swiper.support.smoothScroll) {
        animateCSSModeScroll({
          swiper,
          targetPosition: t,
          side: isH ? 'left' : 'top'
        });
        return true;
      }

      wrapperEl.scrollTo({
        [isH ? 'left' : 'top']: t,
        behavior: 'smooth'
      });
    }

    return true;
  }

  swiper.setTransition(speed);
  swiper.setTranslate(translate);
  swiper.updateActiveIndex(slideIndex);
  swiper.updateSlidesClasses();
  swiper.emit('beforeTransitionStart', speed, internal);
  swiper.transitionStart(runCallbacks, direction);

  if (speed === 0) {
    swiper.transitionEnd(runCallbacks, direction);
  } else if (!swiper.animating) {
    swiper.animating = true;

    if (!swiper.onSlideToWrapperTransitionEnd) {
      swiper.onSlideToWrapperTransitionEnd = function transitionEnd(e) {
        if (!swiper || swiper.destroyed) return;
        if (e.target !== this) return;
        swiper.$wrapperEl[0].removeEventListener('transitionend', swiper.onSlideToWrapperTransitionEnd);
        swiper.$wrapperEl[0].removeEventListener('webkitTransitionEnd', swiper.onSlideToWrapperTransitionEnd);
        swiper.onSlideToWrapperTransitionEnd = null;
        delete swiper.onSlideToWrapperTransitionEnd;
        swiper.transitionEnd(runCallbacks, direction);
      };
    }

    swiper.$wrapperEl[0].addEventListener('transitionend', swiper.onSlideToWrapperTransitionEnd);
    swiper.$wrapperEl[0].addEventListener('webkitTransitionEnd', swiper.onSlideToWrapperTransitionEnd);
  }

  return true;
}
;// CONCATENATED MODULE: ../../.yarn/unplugged/swiper-npm-8.4.7-9971804532/node_modules/swiper/core/slide/slideToLoop.js
function slideToLoop(index = 0, speed = this.params.speed, runCallbacks = true, internal) {
  if (typeof index === 'string') {
    /**
     * The `index` argument converted from `string` to `number`.
     * @type {number}
     */
    const indexAsNumber = parseInt(index, 10);
    /**
     * Determines whether the `index` argument is a valid `number`
     * after being converted from the `string` type.
     * @type {boolean}
     */

    const isValidNumber = isFinite(indexAsNumber);

    if (!isValidNumber) {
      throw new Error(`The passed-in 'index' (string) couldn't be converted to 'number'. [${index}] given.`);
    } // Knowing that the converted `index` is a valid number,
    // we can update the original argument's value.


    index = indexAsNumber;
  }

  const swiper = this;
  let newIndex = index;

  if (swiper.params.loop) {
    newIndex += swiper.loopedSlides;
  }

  return swiper.slideTo(newIndex, speed, runCallbacks, internal);
}
;// CONCATENATED MODULE: ../../.yarn/unplugged/swiper-npm-8.4.7-9971804532/node_modules/swiper/core/slide/slideNext.js
/* eslint no-unused-vars: "off" */
function slideNext(speed = this.params.speed, runCallbacks = true, internal) {
  const swiper = this;
  const {
    animating,
    enabled,
    params
  } = swiper;
  if (!enabled) return swiper;
  let perGroup = params.slidesPerGroup;

  if (params.slidesPerView === 'auto' && params.slidesPerGroup === 1 && params.slidesPerGroupAuto) {
    perGroup = Math.max(swiper.slidesPerViewDynamic('current', true), 1);
  }

  const increment = swiper.activeIndex < params.slidesPerGroupSkip ? 1 : perGroup;

  if (params.loop) {
    if (animating && params.loopPreventsSlide) return false;
    swiper.loopFix(); // eslint-disable-next-line

    swiper._clientLeft = swiper.$wrapperEl[0].clientLeft;
  }

  if (params.rewind && swiper.isEnd) {
    return swiper.slideTo(0, speed, runCallbacks, internal);
  }

  return swiper.slideTo(swiper.activeIndex + increment, speed, runCallbacks, internal);
}
;// CONCATENATED MODULE: ../../.yarn/unplugged/swiper-npm-8.4.7-9971804532/node_modules/swiper/core/slide/slidePrev.js
/* eslint no-unused-vars: "off" */
function slidePrev(speed = this.params.speed, runCallbacks = true, internal) {
  const swiper = this;
  const {
    params,
    animating,
    snapGrid,
    slidesGrid,
    rtlTranslate,
    enabled
  } = swiper;
  if (!enabled) return swiper;

  if (params.loop) {
    if (animating && params.loopPreventsSlide) return false;
    swiper.loopFix(); // eslint-disable-next-line

    swiper._clientLeft = swiper.$wrapperEl[0].clientLeft;
  }

  const translate = rtlTranslate ? swiper.translate : -swiper.translate;

  function normalize(val) {
    if (val < 0) return -Math.floor(Math.abs(val));
    return Math.floor(val);
  }

  const normalizedTranslate = normalize(translate);
  const normalizedSnapGrid = snapGrid.map(val => normalize(val));
  let prevSnap = snapGrid[normalizedSnapGrid.indexOf(normalizedTranslate) - 1];

  if (typeof prevSnap === 'undefined' && params.cssMode) {
    let prevSnapIndex;
    snapGrid.forEach((snap, snapIndex) => {
      if (normalizedTranslate >= snap) {
        // prevSnap = snap;
        prevSnapIndex = snapIndex;
      }
    });

    if (typeof prevSnapIndex !== 'undefined') {
      prevSnap = snapGrid[prevSnapIndex > 0 ? prevSnapIndex - 1 : prevSnapIndex];
    }
  }

  let prevIndex = 0;

  if (typeof prevSnap !== 'undefined') {
    prevIndex = slidesGrid.indexOf(prevSnap);
    if (prevIndex < 0) prevIndex = swiper.activeIndex - 1;

    if (params.slidesPerView === 'auto' && params.slidesPerGroup === 1 && params.slidesPerGroupAuto) {
      prevIndex = prevIndex - swiper.slidesPerViewDynamic('previous', true) + 1;
      prevIndex = Math.max(prevIndex, 0);
    }
  }

  if (params.rewind && swiper.isBeginning) {
    const lastIndex = swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual ? swiper.virtual.slides.length - 1 : swiper.slides.length - 1;
    return swiper.slideTo(lastIndex, speed, runCallbacks, internal);
  }

  return swiper.slideTo(prevIndex, speed, runCallbacks, internal);
}
;// CONCATENATED MODULE: ../../.yarn/unplugged/swiper-npm-8.4.7-9971804532/node_modules/swiper/core/slide/slideReset.js
/* eslint no-unused-vars: "off" */
function slideReset(speed = this.params.speed, runCallbacks = true, internal) {
  const swiper = this;
  return swiper.slideTo(swiper.activeIndex, speed, runCallbacks, internal);
}
;// CONCATENATED MODULE: ../../.yarn/unplugged/swiper-npm-8.4.7-9971804532/node_modules/swiper/core/slide/slideToClosest.js
/* eslint no-unused-vars: "off" */
function slideToClosest(speed = this.params.speed, runCallbacks = true, internal, threshold = 0.5) {
  const swiper = this;
  let index = swiper.activeIndex;
  const skip = Math.min(swiper.params.slidesPerGroupSkip, index);
  const snapIndex = skip + Math.floor((index - skip) / swiper.params.slidesPerGroup);
  const translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;

  if (translate >= swiper.snapGrid[snapIndex]) {
    // The current translate is on or after the current snap index, so the choice
    // is between the current index and the one after it.
    const currentSnap = swiper.snapGrid[snapIndex];
    const nextSnap = swiper.snapGrid[snapIndex + 1];

    if (translate - currentSnap > (nextSnap - currentSnap) * threshold) {
      index += swiper.params.slidesPerGroup;
    }
  } else {
    // The current translate is before the current snap index, so the choice
    // is between the current index and the one before it.
    const prevSnap = swiper.snapGrid[snapIndex - 1];
    const currentSnap = swiper.snapGrid[snapIndex];

    if (translate - prevSnap <= (currentSnap - prevSnap) * threshold) {
      index -= swiper.params.slidesPerGroup;
    }
  }

  index = Math.max(index, 0);
  index = Math.min(index, swiper.slidesGrid.length - 1);
  return swiper.slideTo(index, speed, runCallbacks, internal);
}
;// CONCATENATED MODULE: ../../.yarn/unplugged/swiper-npm-8.4.7-9971804532/node_modules/swiper/core/slide/slideToClickedSlide.js


function slideToClickedSlide() {
  const swiper = this;
  const {
    params,
    $wrapperEl
  } = swiper;
  const slidesPerView = params.slidesPerView === 'auto' ? swiper.slidesPerViewDynamic() : params.slidesPerView;
  let slideToIndex = swiper.clickedIndex;
  let realIndex;

  if (params.loop) {
    if (swiper.animating) return;
    realIndex = parseInt(dom(swiper.clickedSlide).attr('data-swiper-slide-index'), 10);

    if (params.centeredSlides) {
      if (slideToIndex < swiper.loopedSlides - slidesPerView / 2 || slideToIndex > swiper.slides.length - swiper.loopedSlides + slidesPerView / 2) {
        swiper.loopFix();
        slideToIndex = $wrapperEl.children(`.${params.slideClass}[data-swiper-slide-index="${realIndex}"]:not(.${params.slideDuplicateClass})`).eq(0).index();
        utils_nextTick(() => {
          swiper.slideTo(slideToIndex);
        });
      } else {
        swiper.slideTo(slideToIndex);
      }
    } else if (slideToIndex > swiper.slides.length - slidesPerView) {
      swiper.loopFix();
      slideToIndex = $wrapperEl.children(`.${params.slideClass}[data-swiper-slide-index="${realIndex}"]:not(.${params.slideDuplicateClass})`).eq(0).index();
      utils_nextTick(() => {
        swiper.slideTo(slideToIndex);
      });
    } else {
      swiper.slideTo(slideToIndex);
    }
  } else {
    swiper.slideTo(slideToIndex);
  }
}
;// CONCATENATED MODULE: ../../.yarn/unplugged/swiper-npm-8.4.7-9971804532/node_modules/swiper/core/slide/index.js







/* harmony default export */ var slide = ({
  slideTo: slideTo,
  slideToLoop: slideToLoop,
  slideNext: slideNext,
  slidePrev: slidePrev,
  slideReset: slideReset,
  slideToClosest: slideToClosest,
  slideToClickedSlide: slideToClickedSlide
});
;// CONCATENATED MODULE: ../../.yarn/unplugged/swiper-npm-8.4.7-9971804532/node_modules/swiper/core/loop/loopCreate.js


function loopCreate() {
  const swiper = this;
  const document = ssr_window_esm_getDocument();
  const {
    params,
    $wrapperEl
  } = swiper; // Remove duplicated slides

  const $selector = $wrapperEl.children().length > 0 ? dom($wrapperEl.children()[0].parentNode) : $wrapperEl;
  $selector.children(`.${params.slideClass}.${params.slideDuplicateClass}`).remove();
  let slides = $selector.children(`.${params.slideClass}`);

  if (params.loopFillGroupWithBlank) {
    const blankSlidesNum = params.slidesPerGroup - slides.length % params.slidesPerGroup;

    if (blankSlidesNum !== params.slidesPerGroup) {
      for (let i = 0; i < blankSlidesNum; i += 1) {
        const blankNode = dom(document.createElement('div')).addClass(`${params.slideClass} ${params.slideBlankClass}`);
        $selector.append(blankNode);
      }

      slides = $selector.children(`.${params.slideClass}`);
    }
  }

  if (params.slidesPerView === 'auto' && !params.loopedSlides) params.loopedSlides = slides.length;
  swiper.loopedSlides = Math.ceil(parseFloat(params.loopedSlides || params.slidesPerView, 10));
  swiper.loopedSlides += params.loopAdditionalSlides;

  if (swiper.loopedSlides > slides.length && swiper.params.loopedSlidesLimit) {
    swiper.loopedSlides = slides.length;
  }

  const prependSlides = [];
  const appendSlides = [];
  slides.each((el, index) => {
    const slide = dom(el);
    slide.attr('data-swiper-slide-index', index);
  });

  for (let i = 0; i < swiper.loopedSlides; i += 1) {
    const index = i - Math.floor(i / slides.length) * slides.length;
    appendSlides.push(slides.eq(index)[0]);
    prependSlides.unshift(slides.eq(slides.length - index - 1)[0]);
  }

  for (let i = 0; i < appendSlides.length; i += 1) {
    $selector.append(dom(appendSlides[i].cloneNode(true)).addClass(params.slideDuplicateClass));
  }

  for (let i = prependSlides.length - 1; i >= 0; i -= 1) {
    $selector.prepend(dom(prependSlides[i].cloneNode(true)).addClass(params.slideDuplicateClass));
  }
}
;// CONCATENATED MODULE: ../../.yarn/unplugged/swiper-npm-8.4.7-9971804532/node_modules/swiper/core/loop/loopFix.js
function loopFix() {
  const swiper = this;
  swiper.emit('beforeLoopFix');
  const {
    activeIndex,
    slides,
    loopedSlides,
    allowSlidePrev,
    allowSlideNext,
    snapGrid,
    rtlTranslate: rtl
  } = swiper;
  let newIndex;
  swiper.allowSlidePrev = true;
  swiper.allowSlideNext = true;
  const snapTranslate = -snapGrid[activeIndex];
  const diff = snapTranslate - swiper.getTranslate(); // Fix For Negative Oversliding

  if (activeIndex < loopedSlides) {
    newIndex = slides.length - loopedSlides * 3 + activeIndex;
    newIndex += loopedSlides;
    const slideChanged = swiper.slideTo(newIndex, 0, false, true);

    if (slideChanged && diff !== 0) {
      swiper.setTranslate((rtl ? -swiper.translate : swiper.translate) - diff);
    }
  } else if (activeIndex >= slides.length - loopedSlides) {
    // Fix For Positive Oversliding
    newIndex = -slides.length + activeIndex + loopedSlides;
    newIndex += loopedSlides;
    const slideChanged = swiper.slideTo(newIndex, 0, false, true);

    if (slideChanged && diff !== 0) {
      swiper.setTranslate((rtl ? -swiper.translate : swiper.translate) - diff);
    }
  }

  swiper.allowSlidePrev = allowSlidePrev;
  swiper.allowSlideNext = allowSlideNext;
  swiper.emit('loopFix');
}
;// CONCATENATED MODULE: ../../.yarn/unplugged/swiper-npm-8.4.7-9971804532/node_modules/swiper/core/loop/loopDestroy.js
function loopDestroy() {
  const swiper = this;
  const {
    $wrapperEl,
    params,
    slides
  } = swiper;
  $wrapperEl.children(`.${params.slideClass}.${params.slideDuplicateClass},.${params.slideClass}.${params.slideBlankClass}`).remove();
  slides.removeAttr('data-swiper-slide-index');
}
;// CONCATENATED MODULE: ../../.yarn/unplugged/swiper-npm-8.4.7-9971804532/node_modules/swiper/core/loop/index.js



/* harmony default export */ var loop = ({
  loopCreate: loopCreate,
  loopFix: loopFix,
  loopDestroy: loopDestroy
});
;// CONCATENATED MODULE: ../../.yarn/unplugged/swiper-npm-8.4.7-9971804532/node_modules/swiper/core/grab-cursor/setGrabCursor.js
function setGrabCursor(moving) {
  const swiper = this;
  if (swiper.support.touch || !swiper.params.simulateTouch || swiper.params.watchOverflow && swiper.isLocked || swiper.params.cssMode) return;
  const el = swiper.params.touchEventsTarget === 'container' ? swiper.el : swiper.wrapperEl;
  el.style.cursor = 'move';
  el.style.cursor = moving ? 'grabbing' : 'grab';
}
;// CONCATENATED MODULE: ../../.yarn/unplugged/swiper-npm-8.4.7-9971804532/node_modules/swiper/core/grab-cursor/unsetGrabCursor.js
function unsetGrabCursor() {
  const swiper = this;

  if (swiper.support.touch || swiper.params.watchOverflow && swiper.isLocked || swiper.params.cssMode) {
    return;
  }

  swiper[swiper.params.touchEventsTarget === 'container' ? 'el' : 'wrapperEl'].style.cursor = '';
}
;// CONCATENATED MODULE: ../../.yarn/unplugged/swiper-npm-8.4.7-9971804532/node_modules/swiper/core/grab-cursor/index.js


/* harmony default export */ var grab_cursor = ({
  setGrabCursor: setGrabCursor,
  unsetGrabCursor: unsetGrabCursor
});
;// CONCATENATED MODULE: ../../.yarn/unplugged/swiper-npm-8.4.7-9971804532/node_modules/swiper/core/events/onTouchStart.js


 // Modified from https://stackoverflow.com/questions/54520554/custom-element-getrootnode-closest-function-crossing-multiple-parent-shadowd

function closestElement(selector, base = this) {
  function __closestFrom(el) {
    if (!el || el === ssr_window_esm_getDocument() || el === ssr_window_esm_getWindow()) return null;
    if (el.assignedSlot) el = el.assignedSlot;
    const found = el.closest(selector);

    if (!found && !el.getRootNode) {
      return null;
    }

    return found || __closestFrom(el.getRootNode().host);
  }

  return __closestFrom(base);
}

function onTouchStart(event) {
  const swiper = this;
  const document = ssr_window_esm_getDocument();
  const window = ssr_window_esm_getWindow();
  const data = swiper.touchEventsData;
  const {
    params,
    touches,
    enabled
  } = swiper;
  if (!enabled) return;

  if (swiper.animating && params.preventInteractionOnTransition) {
    return;
  }

  if (!swiper.animating && params.cssMode && params.loop) {
    swiper.loopFix();
  }

  let e = event;
  if (e.originalEvent) e = e.originalEvent;
  let $targetEl = dom(e.target);

  if (params.touchEventsTarget === 'wrapper') {
    if (!$targetEl.closest(swiper.wrapperEl).length) return;
  }

  data.isTouchEvent = e.type === 'touchstart';
  if (!data.isTouchEvent && 'which' in e && e.which === 3) return;
  if (!data.isTouchEvent && 'button' in e && e.button > 0) return;
  if (data.isTouched && data.isMoved) return; // change target el for shadow root component

  const swipingClassHasValue = !!params.noSwipingClass && params.noSwipingClass !== ''; // eslint-disable-next-line

  const eventPath = event.composedPath ? event.composedPath() : event.path;

  if (swipingClassHasValue && e.target && e.target.shadowRoot && eventPath) {
    $targetEl = dom(eventPath[0]);
  }

  const noSwipingSelector = params.noSwipingSelector ? params.noSwipingSelector : `.${params.noSwipingClass}`;
  const isTargetShadow = !!(e.target && e.target.shadowRoot); // use closestElement for shadow root element to get the actual closest for nested shadow root element

  if (params.noSwiping && (isTargetShadow ? closestElement(noSwipingSelector, $targetEl[0]) : $targetEl.closest(noSwipingSelector)[0])) {
    swiper.allowClick = true;
    return;
  }

  if (params.swipeHandler) {
    if (!$targetEl.closest(params.swipeHandler)[0]) return;
  }

  touches.currentX = e.type === 'touchstart' ? e.targetTouches[0].pageX : e.pageX;
  touches.currentY = e.type === 'touchstart' ? e.targetTouches[0].pageY : e.pageY;
  const startX = touches.currentX;
  const startY = touches.currentY; // Do NOT start if iOS edge swipe is detected. Otherwise iOS app cannot swipe-to-go-back anymore

  const edgeSwipeDetection = params.edgeSwipeDetection || params.iOSEdgeSwipeDetection;
  const edgeSwipeThreshold = params.edgeSwipeThreshold || params.iOSEdgeSwipeThreshold;

  if (edgeSwipeDetection && (startX <= edgeSwipeThreshold || startX >= window.innerWidth - edgeSwipeThreshold)) {
    if (edgeSwipeDetection === 'prevent') {
      event.preventDefault();
    } else {
      return;
    }
  }

  Object.assign(data, {
    isTouched: true,
    isMoved: false,
    allowTouchCallbacks: true,
    isScrolling: undefined,
    startMoving: undefined
  });
  touches.startX = startX;
  touches.startY = startY;
  data.touchStartTime = utils_now();
  swiper.allowClick = true;
  swiper.updateSize();
  swiper.swipeDirection = undefined;
  if (params.threshold > 0) data.allowThresholdMove = false;

  if (e.type !== 'touchstart') {
    let preventDefault = true;

    if ($targetEl.is(data.focusableElements)) {
      preventDefault = false;

      if ($targetEl[0].nodeName === 'SELECT') {
        data.isTouched = false;
      }
    }

    if (document.activeElement && dom(document.activeElement).is(data.focusableElements) && document.activeElement !== $targetEl[0]) {
      document.activeElement.blur();
    }

    const shouldPreventDefault = preventDefault && swiper.allowTouchMove && params.touchStartPreventDefault;

    if ((params.touchStartForcePreventDefault || shouldPreventDefault) && !$targetEl[0].isContentEditable) {
      e.preventDefault();
    }
  }

  if (swiper.params.freeMode && swiper.params.freeMode.enabled && swiper.freeMode && swiper.animating && !params.cssMode) {
    swiper.freeMode.onTouchStart();
  }

  swiper.emit('touchStart', e);
}
;// CONCATENATED MODULE: ../../.yarn/unplugged/swiper-npm-8.4.7-9971804532/node_modules/swiper/core/events/onTouchMove.js



function onTouchMove(event) {
  const document = ssr_window_esm_getDocument();
  const swiper = this;
  const data = swiper.touchEventsData;
  const {
    params,
    touches,
    rtlTranslate: rtl,
    enabled
  } = swiper;
  if (!enabled) return;
  let e = event;
  if (e.originalEvent) e = e.originalEvent;

  if (!data.isTouched) {
    if (data.startMoving && data.isScrolling) {
      swiper.emit('touchMoveOpposite', e);
    }

    return;
  }

  if (data.isTouchEvent && e.type !== 'touchmove') return;
  const targetTouch = e.type === 'touchmove' && e.targetTouches && (e.targetTouches[0] || e.changedTouches[0]);
  const pageX = e.type === 'touchmove' ? targetTouch.pageX : e.pageX;
  const pageY = e.type === 'touchmove' ? targetTouch.pageY : e.pageY;

  if (e.preventedByNestedSwiper) {
    touches.startX = pageX;
    touches.startY = pageY;
    return;
  }

  if (!swiper.allowTouchMove) {
    if (!dom(e.target).is(data.focusableElements)) {
      swiper.allowClick = false;
    }

    if (data.isTouched) {
      Object.assign(touches, {
        startX: pageX,
        startY: pageY,
        currentX: pageX,
        currentY: pageY
      });
      data.touchStartTime = utils_now();
    }

    return;
  }

  if (data.isTouchEvent && params.touchReleaseOnEdges && !params.loop) {
    if (swiper.isVertical()) {
      // Vertical
      if (pageY < touches.startY && swiper.translate <= swiper.maxTranslate() || pageY > touches.startY && swiper.translate >= swiper.minTranslate()) {
        data.isTouched = false;
        data.isMoved = false;
        return;
      }
    } else if (pageX < touches.startX && swiper.translate <= swiper.maxTranslate() || pageX > touches.startX && swiper.translate >= swiper.minTranslate()) {
      return;
    }
  }

  if (data.isTouchEvent && document.activeElement) {
    if (e.target === document.activeElement && dom(e.target).is(data.focusableElements)) {
      data.isMoved = true;
      swiper.allowClick = false;
      return;
    }
  }

  if (data.allowTouchCallbacks) {
    swiper.emit('touchMove', e);
  }

  if (e.targetTouches && e.targetTouches.length > 1) return;
  touches.currentX = pageX;
  touches.currentY = pageY;
  const diffX = touches.currentX - touches.startX;
  const diffY = touches.currentY - touches.startY;
  if (swiper.params.threshold && Math.sqrt(diffX ** 2 + diffY ** 2) < swiper.params.threshold) return;

  if (typeof data.isScrolling === 'undefined') {
    let touchAngle;

    if (swiper.isHorizontal() && touches.currentY === touches.startY || swiper.isVertical() && touches.currentX === touches.startX) {
      data.isScrolling = false;
    } else {
      // eslint-disable-next-line
      if (diffX * diffX + diffY * diffY >= 25) {
        touchAngle = Math.atan2(Math.abs(diffY), Math.abs(diffX)) * 180 / Math.PI;
        data.isScrolling = swiper.isHorizontal() ? touchAngle > params.touchAngle : 90 - touchAngle > params.touchAngle;
      }
    }
  }

  if (data.isScrolling) {
    swiper.emit('touchMoveOpposite', e);
  }

  if (typeof data.startMoving === 'undefined') {
    if (touches.currentX !== touches.startX || touches.currentY !== touches.startY) {
      data.startMoving = true;
    }
  }

  if (data.isScrolling) {
    data.isTouched = false;
    return;
  }

  if (!data.startMoving) {
    return;
  }

  swiper.allowClick = false;

  if (!params.cssMode && e.cancelable) {
    e.preventDefault();
  }

  if (params.touchMoveStopPropagation && !params.nested) {
    e.stopPropagation();
  }

  if (!data.isMoved) {
    if (params.loop && !params.cssMode) {
      swiper.loopFix();
    }

    data.startTranslate = swiper.getTranslate();
    swiper.setTransition(0);

    if (swiper.animating) {
      swiper.$wrapperEl.trigger('webkitTransitionEnd transitionend');
    }

    data.allowMomentumBounce = false; // Grab Cursor

    if (params.grabCursor && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) {
      swiper.setGrabCursor(true);
    }

    swiper.emit('sliderFirstMove', e);
  }

  swiper.emit('sliderMove', e);
  data.isMoved = true;
  let diff = swiper.isHorizontal() ? diffX : diffY;
  touches.diff = diff;
  diff *= params.touchRatio;
  if (rtl) diff = -diff;
  swiper.swipeDirection = diff > 0 ? 'prev' : 'next';
  data.currentTranslate = diff + data.startTranslate;
  let disableParentSwiper = true;
  let resistanceRatio = params.resistanceRatio;

  if (params.touchReleaseOnEdges) {
    resistanceRatio = 0;
  }

  if (diff > 0 && data.currentTranslate > swiper.minTranslate()) {
    disableParentSwiper = false;
    if (params.resistance) data.currentTranslate = swiper.minTranslate() - 1 + (-swiper.minTranslate() + data.startTranslate + diff) ** resistanceRatio;
  } else if (diff < 0 && data.currentTranslate < swiper.maxTranslate()) {
    disableParentSwiper = false;
    if (params.resistance) data.currentTranslate = swiper.maxTranslate() + 1 - (swiper.maxTranslate() - data.startTranslate - diff) ** resistanceRatio;
  }

  if (disableParentSwiper) {
    e.preventedByNestedSwiper = true;
  } // Directions locks


  if (!swiper.allowSlideNext && swiper.swipeDirection === 'next' && data.currentTranslate < data.startTranslate) {
    data.currentTranslate = data.startTranslate;
  }

  if (!swiper.allowSlidePrev && swiper.swipeDirection === 'prev' && data.currentTranslate > data.startTranslate) {
    data.currentTranslate = data.startTranslate;
  }

  if (!swiper.allowSlidePrev && !swiper.allowSlideNext) {
    data.currentTranslate = data.startTranslate;
  } // Threshold


  if (params.threshold > 0) {
    if (Math.abs(diff) > params.threshold || data.allowThresholdMove) {
      if (!data.allowThresholdMove) {
        data.allowThresholdMove = true;
        touches.startX = touches.currentX;
        touches.startY = touches.currentY;
        data.currentTranslate = data.startTranslate;
        touches.diff = swiper.isHorizontal() ? touches.currentX - touches.startX : touches.currentY - touches.startY;
        return;
      }
    } else {
      data.currentTranslate = data.startTranslate;
      return;
    }
  }

  if (!params.followFinger || params.cssMode) return; // Update active index in free mode

  if (params.freeMode && params.freeMode.enabled && swiper.freeMode || params.watchSlidesProgress) {
    swiper.updateActiveIndex();
    swiper.updateSlidesClasses();
  }

  if (swiper.params.freeMode && params.freeMode.enabled && swiper.freeMode) {
    swiper.freeMode.onTouchMove();
  } // Update progress


  swiper.updateProgress(data.currentTranslate); // Update translate

  swiper.setTranslate(data.currentTranslate);
}
;// CONCATENATED MODULE: ../../.yarn/unplugged/swiper-npm-8.4.7-9971804532/node_modules/swiper/core/events/onTouchEnd.js

function onTouchEnd(event) {
  const swiper = this;
  const data = swiper.touchEventsData;
  const {
    params,
    touches,
    rtlTranslate: rtl,
    slidesGrid,
    enabled
  } = swiper;
  if (!enabled) return;
  let e = event;
  if (e.originalEvent) e = e.originalEvent;

  if (data.allowTouchCallbacks) {
    swiper.emit('touchEnd', e);
  }

  data.allowTouchCallbacks = false;

  if (!data.isTouched) {
    if (data.isMoved && params.grabCursor) {
      swiper.setGrabCursor(false);
    }

    data.isMoved = false;
    data.startMoving = false;
    return;
  } // Return Grab Cursor


  if (params.grabCursor && data.isMoved && data.isTouched && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) {
    swiper.setGrabCursor(false);
  } // Time diff


  const touchEndTime = utils_now();
  const timeDiff = touchEndTime - data.touchStartTime; // Tap, doubleTap, Click

  if (swiper.allowClick) {
    const pathTree = e.path || e.composedPath && e.composedPath();
    swiper.updateClickedSlide(pathTree && pathTree[0] || e.target);
    swiper.emit('tap click', e);

    if (timeDiff < 300 && touchEndTime - data.lastClickTime < 300) {
      swiper.emit('doubleTap doubleClick', e);
    }
  }

  data.lastClickTime = utils_now();
  utils_nextTick(() => {
    if (!swiper.destroyed) swiper.allowClick = true;
  });

  if (!data.isTouched || !data.isMoved || !swiper.swipeDirection || touches.diff === 0 || data.currentTranslate === data.startTranslate) {
    data.isTouched = false;
    data.isMoved = false;
    data.startMoving = false;
    return;
  }

  data.isTouched = false;
  data.isMoved = false;
  data.startMoving = false;
  let currentPos;

  if (params.followFinger) {
    currentPos = rtl ? swiper.translate : -swiper.translate;
  } else {
    currentPos = -data.currentTranslate;
  }

  if (params.cssMode) {
    return;
  }

  if (swiper.params.freeMode && params.freeMode.enabled) {
    swiper.freeMode.onTouchEnd({
      currentPos
    });
    return;
  } // Find current slide


  let stopIndex = 0;
  let groupSize = swiper.slidesSizesGrid[0];

  for (let i = 0; i < slidesGrid.length; i += i < params.slidesPerGroupSkip ? 1 : params.slidesPerGroup) {
    const increment = i < params.slidesPerGroupSkip - 1 ? 1 : params.slidesPerGroup;

    if (typeof slidesGrid[i + increment] !== 'undefined') {
      if (currentPos >= slidesGrid[i] && currentPos < slidesGrid[i + increment]) {
        stopIndex = i;
        groupSize = slidesGrid[i + increment] - slidesGrid[i];
      }
    } else if (currentPos >= slidesGrid[i]) {
      stopIndex = i;
      groupSize = slidesGrid[slidesGrid.length - 1] - slidesGrid[slidesGrid.length - 2];
    }
  }

  let rewindFirstIndex = null;
  let rewindLastIndex = null;

  if (params.rewind) {
    if (swiper.isBeginning) {
      rewindLastIndex = swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual ? swiper.virtual.slides.length - 1 : swiper.slides.length - 1;
    } else if (swiper.isEnd) {
      rewindFirstIndex = 0;
    }
  } // Find current slide size


  const ratio = (currentPos - slidesGrid[stopIndex]) / groupSize;
  const increment = stopIndex < params.slidesPerGroupSkip - 1 ? 1 : params.slidesPerGroup;

  if (timeDiff > params.longSwipesMs) {
    // Long touches
    if (!params.longSwipes) {
      swiper.slideTo(swiper.activeIndex);
      return;
    }

    if (swiper.swipeDirection === 'next') {
      if (ratio >= params.longSwipesRatio) swiper.slideTo(params.rewind && swiper.isEnd ? rewindFirstIndex : stopIndex + increment);else swiper.slideTo(stopIndex);
    }

    if (swiper.swipeDirection === 'prev') {
      if (ratio > 1 - params.longSwipesRatio) {
        swiper.slideTo(stopIndex + increment);
      } else if (rewindLastIndex !== null && ratio < 0 && Math.abs(ratio) > params.longSwipesRatio) {
        swiper.slideTo(rewindLastIndex);
      } else {
        swiper.slideTo(stopIndex);
      }
    }
  } else {
    // Short swipes
    if (!params.shortSwipes) {
      swiper.slideTo(swiper.activeIndex);
      return;
    }

    const isNavButtonTarget = swiper.navigation && (e.target === swiper.navigation.nextEl || e.target === swiper.navigation.prevEl);

    if (!isNavButtonTarget) {
      if (swiper.swipeDirection === 'next') {
        swiper.slideTo(rewindFirstIndex !== null ? rewindFirstIndex : stopIndex + increment);
      }

      if (swiper.swipeDirection === 'prev') {
        swiper.slideTo(rewindLastIndex !== null ? rewindLastIndex : stopIndex);
      }
    } else if (e.target === swiper.navigation.nextEl) {
      swiper.slideTo(stopIndex + increment);
    } else {
      swiper.slideTo(stopIndex);
    }
  }
}
;// CONCATENATED MODULE: ../../.yarn/unplugged/swiper-npm-8.4.7-9971804532/node_modules/swiper/core/events/onResize.js
function onResize() {
  const swiper = this;
  const {
    params,
    el
  } = swiper;
  if (el && el.offsetWidth === 0) return; // Breakpoints

  if (params.breakpoints) {
    swiper.setBreakpoint();
  } // Save locks


  const {
    allowSlideNext,
    allowSlidePrev,
    snapGrid
  } = swiper; // Disable locks on resize

  swiper.allowSlideNext = true;
  swiper.allowSlidePrev = true;
  swiper.updateSize();
  swiper.updateSlides();
  swiper.updateSlidesClasses();

  if ((params.slidesPerView === 'auto' || params.slidesPerView > 1) && swiper.isEnd && !swiper.isBeginning && !swiper.params.centeredSlides) {
    swiper.slideTo(swiper.slides.length - 1, 0, false, true);
  } else {
    swiper.slideTo(swiper.activeIndex, 0, false, true);
  }

  if (swiper.autoplay && swiper.autoplay.running && swiper.autoplay.paused) {
    swiper.autoplay.run();
  } // Return locks after resize


  swiper.allowSlidePrev = allowSlidePrev;
  swiper.allowSlideNext = allowSlideNext;

  if (swiper.params.watchOverflow && snapGrid !== swiper.snapGrid) {
    swiper.checkOverflow();
  }
}
;// CONCATENATED MODULE: ../../.yarn/unplugged/swiper-npm-8.4.7-9971804532/node_modules/swiper/core/events/onClick.js
function onClick(e) {
  const swiper = this;
  if (!swiper.enabled) return;

  if (!swiper.allowClick) {
    if (swiper.params.preventClicks) e.preventDefault();

    if (swiper.params.preventClicksPropagation && swiper.animating) {
      e.stopPropagation();
      e.stopImmediatePropagation();
    }
  }
}
;// CONCATENATED MODULE: ../../.yarn/unplugged/swiper-npm-8.4.7-9971804532/node_modules/swiper/core/events/onScroll.js
function onScroll() {
  const swiper = this;
  const {
    wrapperEl,
    rtlTranslate,
    enabled
  } = swiper;
  if (!enabled) return;
  swiper.previousTranslate = swiper.translate;

  if (swiper.isHorizontal()) {
    swiper.translate = -wrapperEl.scrollLeft;
  } else {
    swiper.translate = -wrapperEl.scrollTop;
  } // eslint-disable-next-line


  if (swiper.translate === 0) swiper.translate = 0;
  swiper.updateActiveIndex();
  swiper.updateSlidesClasses();
  let newProgress;
  const translatesDiff = swiper.maxTranslate() - swiper.minTranslate();

  if (translatesDiff === 0) {
    newProgress = 0;
  } else {
    newProgress = (swiper.translate - swiper.minTranslate()) / translatesDiff;
  }

  if (newProgress !== swiper.progress) {
    swiper.updateProgress(rtlTranslate ? -swiper.translate : swiper.translate);
  }

  swiper.emit('setTranslate', swiper.translate, false);
}
;// CONCATENATED MODULE: ../../.yarn/unplugged/swiper-npm-8.4.7-9971804532/node_modules/swiper/core/events/index.js







let dummyEventAttached = false;

function dummyEventListener() {}

const events = (swiper, method) => {
  const document = ssr_window_esm_getDocument();
  const {
    params,
    touchEvents,
    el,
    wrapperEl,
    device,
    support
  } = swiper;
  const capture = !!params.nested;
  const domMethod = method === 'on' ? 'addEventListener' : 'removeEventListener';
  const swiperMethod = method; // Touch Events

  if (!support.touch) {
    el[domMethod](touchEvents.start, swiper.onTouchStart, false);
    document[domMethod](touchEvents.move, swiper.onTouchMove, capture);
    document[domMethod](touchEvents.end, swiper.onTouchEnd, false);
  } else {
    const passiveListener = touchEvents.start === 'touchstart' && support.passiveListener && params.passiveListeners ? {
      passive: true,
      capture: false
    } : false;
    el[domMethod](touchEvents.start, swiper.onTouchStart, passiveListener);
    el[domMethod](touchEvents.move, swiper.onTouchMove, support.passiveListener ? {
      passive: false,
      capture
    } : capture);
    el[domMethod](touchEvents.end, swiper.onTouchEnd, passiveListener);

    if (touchEvents.cancel) {
      el[domMethod](touchEvents.cancel, swiper.onTouchEnd, passiveListener);
    }
  } // Prevent Links Clicks


  if (params.preventClicks || params.preventClicksPropagation) {
    el[domMethod]('click', swiper.onClick, true);
  }

  if (params.cssMode) {
    wrapperEl[domMethod]('scroll', swiper.onScroll);
  } // Resize handler


  if (params.updateOnWindowResize) {
    swiper[swiperMethod](device.ios || device.android ? 'resize orientationchange observerUpdate' : 'resize observerUpdate', onResize, true);
  } else {
    swiper[swiperMethod]('observerUpdate', onResize, true);
  }
};

function attachEvents() {
  const swiper = this;
  const document = ssr_window_esm_getDocument();
  const {
    params,
    support
  } = swiper;
  swiper.onTouchStart = onTouchStart.bind(swiper);
  swiper.onTouchMove = onTouchMove.bind(swiper);
  swiper.onTouchEnd = onTouchEnd.bind(swiper);

  if (params.cssMode) {
    swiper.onScroll = onScroll.bind(swiper);
  }

  swiper.onClick = onClick.bind(swiper);

  if (support.touch && !dummyEventAttached) {
    document.addEventListener('touchstart', dummyEventListener);
    dummyEventAttached = true;
  }

  events(swiper, 'on');
}

function detachEvents() {
  const swiper = this;
  events(swiper, 'off');
}

/* harmony default export */ var core_events = ({
  attachEvents,
  detachEvents
});
;// CONCATENATED MODULE: ../../.yarn/unplugged/swiper-npm-8.4.7-9971804532/node_modules/swiper/core/breakpoints/setBreakpoint.js


const isGridEnabled = (swiper, params) => {
  return swiper.grid && params.grid && params.grid.rows > 1;
};

function setBreakpoint() {
  const swiper = this;
  const {
    activeIndex,
    initialized,
    loopedSlides = 0,
    params,
    $el
  } = swiper;
  const breakpoints = params.breakpoints;
  if (!breakpoints || breakpoints && Object.keys(breakpoints).length === 0) return; // Get breakpoint for window width and update parameters

  const breakpoint = swiper.getBreakpoint(breakpoints, swiper.params.breakpointsBase, swiper.el);
  if (!breakpoint || swiper.currentBreakpoint === breakpoint) return;
  const breakpointOnlyParams = breakpoint in breakpoints ? breakpoints[breakpoint] : undefined;
  const breakpointParams = breakpointOnlyParams || swiper.originalParams;
  const wasMultiRow = isGridEnabled(swiper, params);
  const isMultiRow = isGridEnabled(swiper, breakpointParams);
  const wasEnabled = params.enabled;

  if (wasMultiRow && !isMultiRow) {
    $el.removeClass(`${params.containerModifierClass}grid ${params.containerModifierClass}grid-column`);
    swiper.emitContainerClasses();
  } else if (!wasMultiRow && isMultiRow) {
    $el.addClass(`${params.containerModifierClass}grid`);

    if (breakpointParams.grid.fill && breakpointParams.grid.fill === 'column' || !breakpointParams.grid.fill && params.grid.fill === 'column') {
      $el.addClass(`${params.containerModifierClass}grid-column`);
    }

    swiper.emitContainerClasses();
  } // Toggle navigation, pagination, scrollbar


  ['navigation', 'pagination', 'scrollbar'].forEach(prop => {
    const wasModuleEnabled = params[prop] && params[prop].enabled;
    const isModuleEnabled = breakpointParams[prop] && breakpointParams[prop].enabled;

    if (wasModuleEnabled && !isModuleEnabled) {
      swiper[prop].disable();
    }

    if (!wasModuleEnabled && isModuleEnabled) {
      swiper[prop].enable();
    }
  });
  const directionChanged = breakpointParams.direction && breakpointParams.direction !== params.direction;
  const needsReLoop = params.loop && (breakpointParams.slidesPerView !== params.slidesPerView || directionChanged);

  if (directionChanged && initialized) {
    swiper.changeDirection();
  }

  utils_extend(swiper.params, breakpointParams);
  const isEnabled = swiper.params.enabled;
  Object.assign(swiper, {
    allowTouchMove: swiper.params.allowTouchMove,
    allowSlideNext: swiper.params.allowSlideNext,
    allowSlidePrev: swiper.params.allowSlidePrev
  });

  if (wasEnabled && !isEnabled) {
    swiper.disable();
  } else if (!wasEnabled && isEnabled) {
    swiper.enable();
  }

  swiper.currentBreakpoint = breakpoint;
  swiper.emit('_beforeBreakpoint', breakpointParams);

  if (needsReLoop && initialized) {
    swiper.loopDestroy();
    swiper.loopCreate();
    swiper.updateSlides();
    swiper.slideTo(activeIndex - loopedSlides + swiper.loopedSlides, 0, false);
  }

  swiper.emit('breakpoint', breakpointParams);
}
;// CONCATENATED MODULE: ../../.yarn/unplugged/swiper-npm-8.4.7-9971804532/node_modules/swiper/core/breakpoints/getBreakpoint.js

function getBreakpoint(breakpoints, base = 'window', containerEl) {
  if (!breakpoints || base === 'container' && !containerEl) return undefined;
  let breakpoint = false;
  const window = ssr_window_esm_getWindow();
  const currentHeight = base === 'window' ? window.innerHeight : containerEl.clientHeight;
  const points = Object.keys(breakpoints).map(point => {
    if (typeof point === 'string' && point.indexOf('@') === 0) {
      const minRatio = parseFloat(point.substr(1));
      const value = currentHeight * minRatio;
      return {
        value,
        point
      };
    }

    return {
      value: point,
      point
    };
  });
  points.sort((a, b) => parseInt(a.value, 10) - parseInt(b.value, 10));

  for (let i = 0; i < points.length; i += 1) {
    const {
      point,
      value
    } = points[i];

    if (base === 'window') {
      if (window.matchMedia(`(min-width: ${value}px)`).matches) {
        breakpoint = point;
      }
    } else if (value <= containerEl.clientWidth) {
      breakpoint = point;
    }
  }

  return breakpoint || 'max';
}
;// CONCATENATED MODULE: ../../.yarn/unplugged/swiper-npm-8.4.7-9971804532/node_modules/swiper/core/breakpoints/index.js


/* harmony default export */ var breakpoints = ({
  setBreakpoint: setBreakpoint,
  getBreakpoint: getBreakpoint
});
;// CONCATENATED MODULE: ../../.yarn/unplugged/swiper-npm-8.4.7-9971804532/node_modules/swiper/core/classes/addClasses.js
function prepareClasses(entries, prefix) {
  const resultClasses = [];
  entries.forEach(item => {
    if (typeof item === 'object') {
      Object.keys(item).forEach(classNames => {
        if (item[classNames]) {
          resultClasses.push(prefix + classNames);
        }
      });
    } else if (typeof item === 'string') {
      resultClasses.push(prefix + item);
    }
  });
  return resultClasses;
}

function addClasses() {
  const swiper = this;
  const {
    classNames,
    params,
    rtl,
    $el,
    device,
    support
  } = swiper; // prettier-ignore

  const suffixes = prepareClasses(['initialized', params.direction, {
    'pointer-events': !support.touch
  }, {
    'free-mode': swiper.params.freeMode && params.freeMode.enabled
  }, {
    'autoheight': params.autoHeight
  }, {
    'rtl': rtl
  }, {
    'grid': params.grid && params.grid.rows > 1
  }, {
    'grid-column': params.grid && params.grid.rows > 1 && params.grid.fill === 'column'
  }, {
    'android': device.android
  }, {
    'ios': device.ios
  }, {
    'css-mode': params.cssMode
  }, {
    'centered': params.cssMode && params.centeredSlides
  }, {
    'watch-progress': params.watchSlidesProgress
  }], params.containerModifierClass);
  classNames.push(...suffixes);
  $el.addClass([...classNames].join(' '));
  swiper.emitContainerClasses();
}
;// CONCATENATED MODULE: ../../.yarn/unplugged/swiper-npm-8.4.7-9971804532/node_modules/swiper/core/classes/removeClasses.js
function removeClasses() {
  const swiper = this;
  const {
    $el,
    classNames
  } = swiper;
  $el.removeClass(classNames.join(' '));
  swiper.emitContainerClasses();
}
;// CONCATENATED MODULE: ../../.yarn/unplugged/swiper-npm-8.4.7-9971804532/node_modules/swiper/core/classes/index.js


/* harmony default export */ var classes = ({
  addClasses: addClasses,
  removeClasses: removeClasses
});
;// CONCATENATED MODULE: ../../.yarn/unplugged/swiper-npm-8.4.7-9971804532/node_modules/swiper/core/images/loadImage.js


function loadImage(imageEl, src, srcset, sizes, checkForComplete, callback) {
  const window = ssr_window_esm_getWindow();
  let image;

  function onReady() {
    if (callback) callback();
  }

  const isPicture = dom(imageEl).parent('picture')[0];

  if (!isPicture && (!imageEl.complete || !checkForComplete)) {
    if (src) {
      image = new window.Image();
      image.onload = onReady;
      image.onerror = onReady;

      if (sizes) {
        image.sizes = sizes;
      }

      if (srcset) {
        image.srcset = srcset;
      }

      if (src) {
        image.src = src;
      }
    } else {
      onReady();
    }
  } else {
    // image already loaded...
    onReady();
  }
}
;// CONCATENATED MODULE: ../../.yarn/unplugged/swiper-npm-8.4.7-9971804532/node_modules/swiper/core/images/preloadImages.js
function preloadImages() {
  const swiper = this;
  swiper.imagesToLoad = swiper.$el.find('img');

  function onReady() {
    if (typeof swiper === 'undefined' || swiper === null || !swiper || swiper.destroyed) return;
    if (swiper.imagesLoaded !== undefined) swiper.imagesLoaded += 1;

    if (swiper.imagesLoaded === swiper.imagesToLoad.length) {
      if (swiper.params.updateOnImagesReady) swiper.update();
      swiper.emit('imagesReady');
    }
  }

  for (let i = 0; i < swiper.imagesToLoad.length; i += 1) {
    const imageEl = swiper.imagesToLoad[i];
    swiper.loadImage(imageEl, imageEl.currentSrc || imageEl.getAttribute('src'), imageEl.srcset || imageEl.getAttribute('srcset'), imageEl.sizes || imageEl.getAttribute('sizes'), true, onReady);
  }
}
;// CONCATENATED MODULE: ../../.yarn/unplugged/swiper-npm-8.4.7-9971804532/node_modules/swiper/core/images/index.js


/* harmony default export */ var core_images = ({
  loadImage: loadImage,
  preloadImages: preloadImages
});
;// CONCATENATED MODULE: ../../.yarn/unplugged/swiper-npm-8.4.7-9971804532/node_modules/swiper/core/check-overflow/index.js
function checkOverflow() {
  const swiper = this;
  const {
    isLocked: wasLocked,
    params
  } = swiper;
  const {
    slidesOffsetBefore
  } = params;

  if (slidesOffsetBefore) {
    const lastSlideIndex = swiper.slides.length - 1;
    const lastSlideRightEdge = swiper.slidesGrid[lastSlideIndex] + swiper.slidesSizesGrid[lastSlideIndex] + slidesOffsetBefore * 2;
    swiper.isLocked = swiper.size > lastSlideRightEdge;
  } else {
    swiper.isLocked = swiper.snapGrid.length === 1;
  }

  if (params.allowSlideNext === true) {
    swiper.allowSlideNext = !swiper.isLocked;
  }

  if (params.allowSlidePrev === true) {
    swiper.allowSlidePrev = !swiper.isLocked;
  }

  if (wasLocked && wasLocked !== swiper.isLocked) {
    swiper.isEnd = false;
  }

  if (wasLocked !== swiper.isLocked) {
    swiper.emit(swiper.isLocked ? 'lock' : 'unlock');
  }
}

/* harmony default export */ var check_overflow = ({
  checkOverflow
});
;// CONCATENATED MODULE: ../../.yarn/unplugged/swiper-npm-8.4.7-9971804532/node_modules/swiper/core/defaults.js
/* harmony default export */ var defaults = ({
  init: true,
  direction: 'horizontal',
  touchEventsTarget: 'wrapper',
  initialSlide: 0,
  speed: 300,
  cssMode: false,
  updateOnWindowResize: true,
  resizeObserver: true,
  nested: false,
  createElements: false,
  enabled: true,
  focusableElements: 'input, select, option, textarea, button, video, label',
  // Overrides
  width: null,
  height: null,
  //
  preventInteractionOnTransition: false,
  // ssr
  userAgent: null,
  url: null,
  // To support iOS's swipe-to-go-back gesture (when being used in-app).
  edgeSwipeDetection: false,
  edgeSwipeThreshold: 20,
  // Autoheight
  autoHeight: false,
  // Set wrapper width
  setWrapperSize: false,
  // Virtual Translate
  virtualTranslate: false,
  // Effects
  effect: 'slide',
  // 'slide' or 'fade' or 'cube' or 'coverflow' or 'flip'
  // Breakpoints
  breakpoints: undefined,
  breakpointsBase: 'window',
  // Slides grid
  spaceBetween: 0,
  slidesPerView: 1,
  slidesPerGroup: 1,
  slidesPerGroupSkip: 0,
  slidesPerGroupAuto: false,
  centeredSlides: false,
  centeredSlidesBounds: false,
  slidesOffsetBefore: 0,
  // in px
  slidesOffsetAfter: 0,
  // in px
  normalizeSlideIndex: true,
  centerInsufficientSlides: false,
  // Disable swiper and hide navigation when container not overflow
  watchOverflow: true,
  // Round length
  roundLengths: false,
  // Touches
  touchRatio: 1,
  touchAngle: 45,
  simulateTouch: true,
  shortSwipes: true,
  longSwipes: true,
  longSwipesRatio: 0.5,
  longSwipesMs: 300,
  followFinger: true,
  allowTouchMove: true,
  threshold: 0,
  touchMoveStopPropagation: false,
  touchStartPreventDefault: true,
  touchStartForcePreventDefault: false,
  touchReleaseOnEdges: false,
  // Unique Navigation Elements
  uniqueNavElements: true,
  // Resistance
  resistance: true,
  resistanceRatio: 0.85,
  // Progress
  watchSlidesProgress: false,
  // Cursor
  grabCursor: false,
  // Clicks
  preventClicks: true,
  preventClicksPropagation: true,
  slideToClickedSlide: false,
  // Images
  preloadImages: true,
  updateOnImagesReady: true,
  // loop
  loop: false,
  loopAdditionalSlides: 0,
  loopedSlides: null,
  loopedSlidesLimit: true,
  loopFillGroupWithBlank: false,
  loopPreventsSlide: true,
  // rewind
  rewind: false,
  // Swiping/no swiping
  allowSlidePrev: true,
  allowSlideNext: true,
  swipeHandler: null,
  // '.swipe-handler',
  noSwiping: true,
  noSwipingClass: 'swiper-no-swiping',
  noSwipingSelector: null,
  // Passive Listeners
  passiveListeners: true,
  maxBackfaceHiddenSlides: 10,
  // NS
  containerModifierClass: 'swiper-',
  // NEW
  slideClass: 'swiper-slide',
  slideBlankClass: 'swiper-slide-invisible-blank',
  slideActiveClass: 'swiper-slide-active',
  slideDuplicateActiveClass: 'swiper-slide-duplicate-active',
  slideVisibleClass: 'swiper-slide-visible',
  slideDuplicateClass: 'swiper-slide-duplicate',
  slideNextClass: 'swiper-slide-next',
  slideDuplicateNextClass: 'swiper-slide-duplicate-next',
  slidePrevClass: 'swiper-slide-prev',
  slideDuplicatePrevClass: 'swiper-slide-duplicate-prev',
  wrapperClass: 'swiper-wrapper',
  // Callbacks
  runCallbacksOnInit: true,
  // Internals
  _emitClasses: false
});
;// CONCATENATED MODULE: ../../.yarn/unplugged/swiper-npm-8.4.7-9971804532/node_modules/swiper/core/moduleExtendParams.js

function moduleExtendParams(params, allModulesParams) {
  return function extendParams(obj = {}) {
    const moduleParamName = Object.keys(obj)[0];
    const moduleParams = obj[moduleParamName];

    if (typeof moduleParams !== 'object' || moduleParams === null) {
      utils_extend(allModulesParams, obj);
      return;
    }

    if (['navigation', 'pagination', 'scrollbar'].indexOf(moduleParamName) >= 0 && params[moduleParamName] === true) {
      params[moduleParamName] = {
        auto: true
      };
    }

    if (!(moduleParamName in params && 'enabled' in moduleParams)) {
      utils_extend(allModulesParams, obj);
      return;
    }

    if (params[moduleParamName] === true) {
      params[moduleParamName] = {
        enabled: true
      };
    }

    if (typeof params[moduleParamName] === 'object' && !('enabled' in params[moduleParamName])) {
      params[moduleParamName].enabled = true;
    }

    if (!params[moduleParamName]) params[moduleParamName] = {
      enabled: false
    };
    utils_extend(allModulesParams, obj);
  };
}
;// CONCATENATED MODULE: ../../.yarn/unplugged/swiper-npm-8.4.7-9971804532/node_modules/swiper/core/core.js
/* eslint no-param-reassign: "off" */






















const prototypes = {
  eventsEmitter: events_emitter,
  update: update,
  translate: translate,
  transition: core_transition,
  slide: slide,
  loop: loop,
  grabCursor: grab_cursor,
  events: core_events,
  breakpoints: breakpoints,
  checkOverflow: check_overflow,
  classes: classes,
  images: core_images
};
const extendedDefaults = {};

class Swiper {
  constructor(...args) {
    let el;
    let params;

    if (args.length === 1 && args[0].constructor && Object.prototype.toString.call(args[0]).slice(8, -1) === 'Object') {
      params = args[0];
    } else {
      [el, params] = args;
    }

    if (!params) params = {};
    params = utils_extend({}, params);
    if (el && !params.el) params.el = el;

    if (params.el && dom(params.el).length > 1) {
      const swipers = [];
      dom(params.el).each(containerEl => {
        const newParams = utils_extend({}, params, {
          el: containerEl
        });
        swipers.push(new Swiper(newParams));
      }); // eslint-disable-next-line no-constructor-return

      return swipers;
    } // Swiper Instance


    const swiper = this;
    swiper.__swiper__ = true;
    swiper.support = getSupport();
    swiper.device = getDevice({
      userAgent: params.userAgent
    });
    swiper.browser = getBrowser();
    swiper.eventsListeners = {};
    swiper.eventsAnyListeners = [];
    swiper.modules = [...swiper.__modules__];

    if (params.modules && Array.isArray(params.modules)) {
      swiper.modules.push(...params.modules);
    }

    const allModulesParams = {};
    swiper.modules.forEach(mod => {
      mod({
        swiper,
        extendParams: moduleExtendParams(params, allModulesParams),
        on: swiper.on.bind(swiper),
        once: swiper.once.bind(swiper),
        off: swiper.off.bind(swiper),
        emit: swiper.emit.bind(swiper)
      });
    }); // Extend defaults with modules params

    const swiperParams = utils_extend({}, defaults, allModulesParams); // Extend defaults with passed params

    swiper.params = utils_extend({}, swiperParams, extendedDefaults, params);
    swiper.originalParams = utils_extend({}, swiper.params);
    swiper.passedParams = utils_extend({}, params); // add event listeners

    if (swiper.params && swiper.params.on) {
      Object.keys(swiper.params.on).forEach(eventName => {
        swiper.on(eventName, swiper.params.on[eventName]);
      });
    }

    if (swiper.params && swiper.params.onAny) {
      swiper.onAny(swiper.params.onAny);
    } // Save Dom lib


    swiper.$ = dom; // Extend Swiper

    Object.assign(swiper, {
      enabled: swiper.params.enabled,
      el,
      // Classes
      classNames: [],
      // Slides
      slides: dom(),
      slidesGrid: [],
      snapGrid: [],
      slidesSizesGrid: [],

      // isDirection
      isHorizontal() {
        return swiper.params.direction === 'horizontal';
      },

      isVertical() {
        return swiper.params.direction === 'vertical';
      },

      // Indexes
      activeIndex: 0,
      realIndex: 0,
      //
      isBeginning: true,
      isEnd: false,
      // Props
      translate: 0,
      previousTranslate: 0,
      progress: 0,
      velocity: 0,
      animating: false,
      // Locks
      allowSlideNext: swiper.params.allowSlideNext,
      allowSlidePrev: swiper.params.allowSlidePrev,
      // Touch Events
      touchEvents: function touchEvents() {
        const touch = ['touchstart', 'touchmove', 'touchend', 'touchcancel'];
        const desktop = ['pointerdown', 'pointermove', 'pointerup'];
        swiper.touchEventsTouch = {
          start: touch[0],
          move: touch[1],
          end: touch[2],
          cancel: touch[3]
        };
        swiper.touchEventsDesktop = {
          start: desktop[0],
          move: desktop[1],
          end: desktop[2]
        };
        return swiper.support.touch || !swiper.params.simulateTouch ? swiper.touchEventsTouch : swiper.touchEventsDesktop;
      }(),
      touchEventsData: {
        isTouched: undefined,
        isMoved: undefined,
        allowTouchCallbacks: undefined,
        touchStartTime: undefined,
        isScrolling: undefined,
        currentTranslate: undefined,
        startTranslate: undefined,
        allowThresholdMove: undefined,
        // Form elements to match
        focusableElements: swiper.params.focusableElements,
        // Last click time
        lastClickTime: utils_now(),
        clickTimeout: undefined,
        // Velocities
        velocities: [],
        allowMomentumBounce: undefined,
        isTouchEvent: undefined,
        startMoving: undefined
      },
      // Clicks
      allowClick: true,
      // Touches
      allowTouchMove: swiper.params.allowTouchMove,
      touches: {
        startX: 0,
        startY: 0,
        currentX: 0,
        currentY: 0,
        diff: 0
      },
      // Images
      imagesToLoad: [],
      imagesLoaded: 0
    });
    swiper.emit('_swiper'); // Init

    if (swiper.params.init) {
      swiper.init();
    } // Return app instance
    // eslint-disable-next-line no-constructor-return


    return swiper;
  }

  enable() {
    const swiper = this;
    if (swiper.enabled) return;
    swiper.enabled = true;

    if (swiper.params.grabCursor) {
      swiper.setGrabCursor();
    }

    swiper.emit('enable');
  }

  disable() {
    const swiper = this;
    if (!swiper.enabled) return;
    swiper.enabled = false;

    if (swiper.params.grabCursor) {
      swiper.unsetGrabCursor();
    }

    swiper.emit('disable');
  }

  setProgress(progress, speed) {
    const swiper = this;
    progress = Math.min(Math.max(progress, 0), 1);
    const min = swiper.minTranslate();
    const max = swiper.maxTranslate();
    const current = (max - min) * progress + min;
    swiper.translateTo(current, typeof speed === 'undefined' ? 0 : speed);
    swiper.updateActiveIndex();
    swiper.updateSlidesClasses();
  }

  emitContainerClasses() {
    const swiper = this;
    if (!swiper.params._emitClasses || !swiper.el) return;
    const cls = swiper.el.className.split(' ').filter(className => {
      return className.indexOf('swiper') === 0 || className.indexOf(swiper.params.containerModifierClass) === 0;
    });
    swiper.emit('_containerClasses', cls.join(' '));
  }

  getSlideClasses(slideEl) {
    const swiper = this;
    if (swiper.destroyed) return '';
    return slideEl.className.split(' ').filter(className => {
      return className.indexOf('swiper-slide') === 0 || className.indexOf(swiper.params.slideClass) === 0;
    }).join(' ');
  }

  emitSlidesClasses() {
    const swiper = this;
    if (!swiper.params._emitClasses || !swiper.el) return;
    const updates = [];
    swiper.slides.each(slideEl => {
      const classNames = swiper.getSlideClasses(slideEl);
      updates.push({
        slideEl,
        classNames
      });
      swiper.emit('_slideClass', slideEl, classNames);
    });
    swiper.emit('_slideClasses', updates);
  }

  slidesPerViewDynamic(view = 'current', exact = false) {
    const swiper = this;
    const {
      params,
      slides,
      slidesGrid,
      slidesSizesGrid,
      size: swiperSize,
      activeIndex
    } = swiper;
    let spv = 1;

    if (params.centeredSlides) {
      let slideSize = slides[activeIndex].swiperSlideSize;
      let breakLoop;

      for (let i = activeIndex + 1; i < slides.length; i += 1) {
        if (slides[i] && !breakLoop) {
          slideSize += slides[i].swiperSlideSize;
          spv += 1;
          if (slideSize > swiperSize) breakLoop = true;
        }
      }

      for (let i = activeIndex - 1; i >= 0; i -= 1) {
        if (slides[i] && !breakLoop) {
          slideSize += slides[i].swiperSlideSize;
          spv += 1;
          if (slideSize > swiperSize) breakLoop = true;
        }
      }
    } else {
      // eslint-disable-next-line
      if (view === 'current') {
        for (let i = activeIndex + 1; i < slides.length; i += 1) {
          const slideInView = exact ? slidesGrid[i] + slidesSizesGrid[i] - slidesGrid[activeIndex] < swiperSize : slidesGrid[i] - slidesGrid[activeIndex] < swiperSize;

          if (slideInView) {
            spv += 1;
          }
        }
      } else {
        // previous
        for (let i = activeIndex - 1; i >= 0; i -= 1) {
          const slideInView = slidesGrid[activeIndex] - slidesGrid[i] < swiperSize;

          if (slideInView) {
            spv += 1;
          }
        }
      }
    }

    return spv;
  }

  update() {
    const swiper = this;
    if (!swiper || swiper.destroyed) return;
    const {
      snapGrid,
      params
    } = swiper; // Breakpoints

    if (params.breakpoints) {
      swiper.setBreakpoint();
    }

    swiper.updateSize();
    swiper.updateSlides();
    swiper.updateProgress();
    swiper.updateSlidesClasses();

    function setTranslate() {
      const translateValue = swiper.rtlTranslate ? swiper.translate * -1 : swiper.translate;
      const newTranslate = Math.min(Math.max(translateValue, swiper.maxTranslate()), swiper.minTranslate());
      swiper.setTranslate(newTranslate);
      swiper.updateActiveIndex();
      swiper.updateSlidesClasses();
    }

    let translated;

    if (swiper.params.freeMode && swiper.params.freeMode.enabled) {
      setTranslate();

      if (swiper.params.autoHeight) {
        swiper.updateAutoHeight();
      }
    } else {
      if ((swiper.params.slidesPerView === 'auto' || swiper.params.slidesPerView > 1) && swiper.isEnd && !swiper.params.centeredSlides) {
        translated = swiper.slideTo(swiper.slides.length - 1, 0, false, true);
      } else {
        translated = swiper.slideTo(swiper.activeIndex, 0, false, true);
      }

      if (!translated) {
        setTranslate();
      }
    }

    if (params.watchOverflow && snapGrid !== swiper.snapGrid) {
      swiper.checkOverflow();
    }

    swiper.emit('update');
  }

  changeDirection(newDirection, needUpdate = true) {
    const swiper = this;
    const currentDirection = swiper.params.direction;

    if (!newDirection) {
      // eslint-disable-next-line
      newDirection = currentDirection === 'horizontal' ? 'vertical' : 'horizontal';
    }

    if (newDirection === currentDirection || newDirection !== 'horizontal' && newDirection !== 'vertical') {
      return swiper;
    }

    swiper.$el.removeClass(`${swiper.params.containerModifierClass}${currentDirection}`).addClass(`${swiper.params.containerModifierClass}${newDirection}`);
    swiper.emitContainerClasses();
    swiper.params.direction = newDirection;
    swiper.slides.each(slideEl => {
      if (newDirection === 'vertical') {
        slideEl.style.width = '';
      } else {
        slideEl.style.height = '';
      }
    });
    swiper.emit('changeDirection');
    if (needUpdate) swiper.update();
    return swiper;
  }

  changeLanguageDirection(direction) {
    const swiper = this;
    if (swiper.rtl && direction === 'rtl' || !swiper.rtl && direction === 'ltr') return;
    swiper.rtl = direction === 'rtl';
    swiper.rtlTranslate = swiper.params.direction === 'horizontal' && swiper.rtl;

    if (swiper.rtl) {
      swiper.$el.addClass(`${swiper.params.containerModifierClass}rtl`);
      swiper.el.dir = 'rtl';
    } else {
      swiper.$el.removeClass(`${swiper.params.containerModifierClass}rtl`);
      swiper.el.dir = 'ltr';
    }

    swiper.update();
  }

  mount(el) {
    const swiper = this;
    if (swiper.mounted) return true; // Find el

    const $el = dom(el || swiper.params.el);
    el = $el[0];

    if (!el) {
      return false;
    }

    el.swiper = swiper;

    const getWrapperSelector = () => {
      return `.${(swiper.params.wrapperClass || '').trim().split(' ').join('.')}`;
    };

    const getWrapper = () => {
      if (el && el.shadowRoot && el.shadowRoot.querySelector) {
        const res = dom(el.shadowRoot.querySelector(getWrapperSelector())); // Children needs to return slot items

        res.children = options => $el.children(options);

        return res;
      }

      if (!$el.children) {
        return dom($el).children(getWrapperSelector());
      }

      return $el.children(getWrapperSelector());
    }; // Find Wrapper


    let $wrapperEl = getWrapper();

    if ($wrapperEl.length === 0 && swiper.params.createElements) {
      const document = ssr_window_esm_getDocument();
      const wrapper = document.createElement('div');
      $wrapperEl = dom(wrapper);
      wrapper.className = swiper.params.wrapperClass;
      $el.append(wrapper);
      $el.children(`.${swiper.params.slideClass}`).each(slideEl => {
        $wrapperEl.append(slideEl);
      });
    }

    Object.assign(swiper, {
      $el,
      el,
      $wrapperEl,
      wrapperEl: $wrapperEl[0],
      mounted: true,
      // RTL
      rtl: el.dir.toLowerCase() === 'rtl' || $el.css('direction') === 'rtl',
      rtlTranslate: swiper.params.direction === 'horizontal' && (el.dir.toLowerCase() === 'rtl' || $el.css('direction') === 'rtl'),
      wrongRTL: $wrapperEl.css('display') === '-webkit-box'
    });
    return true;
  }

  init(el) {
    const swiper = this;
    if (swiper.initialized) return swiper;
    const mounted = swiper.mount(el);
    if (mounted === false) return swiper;
    swiper.emit('beforeInit'); // Set breakpoint

    if (swiper.params.breakpoints) {
      swiper.setBreakpoint();
    } // Add Classes


    swiper.addClasses(); // Create loop

    if (swiper.params.loop) {
      swiper.loopCreate();
    } // Update size


    swiper.updateSize(); // Update slides

    swiper.updateSlides();

    if (swiper.params.watchOverflow) {
      swiper.checkOverflow();
    } // Set Grab Cursor


    if (swiper.params.grabCursor && swiper.enabled) {
      swiper.setGrabCursor();
    }

    if (swiper.params.preloadImages) {
      swiper.preloadImages();
    } // Slide To Initial Slide


    if (swiper.params.loop) {
      swiper.slideTo(swiper.params.initialSlide + swiper.loopedSlides, 0, swiper.params.runCallbacksOnInit, false, true);
    } else {
      swiper.slideTo(swiper.params.initialSlide, 0, swiper.params.runCallbacksOnInit, false, true);
    } // Attach events


    swiper.attachEvents(); // Init Flag

    swiper.initialized = true; // Emit

    swiper.emit('init');
    swiper.emit('afterInit');
    return swiper;
  }

  destroy(deleteInstance = true, cleanStyles = true) {
    const swiper = this;
    const {
      params,
      $el,
      $wrapperEl,
      slides
    } = swiper;

    if (typeof swiper.params === 'undefined' || swiper.destroyed) {
      return null;
    }

    swiper.emit('beforeDestroy'); // Init Flag

    swiper.initialized = false; // Detach events

    swiper.detachEvents(); // Destroy loop

    if (params.loop) {
      swiper.loopDestroy();
    } // Cleanup styles


    if (cleanStyles) {
      swiper.removeClasses();
      $el.removeAttr('style');
      $wrapperEl.removeAttr('style');

      if (slides && slides.length) {
        slides.removeClass([params.slideVisibleClass, params.slideActiveClass, params.slideNextClass, params.slidePrevClass].join(' ')).removeAttr('style').removeAttr('data-swiper-slide-index');
      }
    }

    swiper.emit('destroy'); // Detach emitter events

    Object.keys(swiper.eventsListeners).forEach(eventName => {
      swiper.off(eventName);
    });

    if (deleteInstance !== false) {
      swiper.$el[0].swiper = null;
      deleteProps(swiper);
    }

    swiper.destroyed = true;
    return null;
  }

  static extendDefaults(newDefaults) {
    utils_extend(extendedDefaults, newDefaults);
  }

  static get extendedDefaults() {
    return extendedDefaults;
  }

  static get defaults() {
    return defaults;
  }

  static installModule(mod) {
    if (!Swiper.prototype.__modules__) Swiper.prototype.__modules__ = [];
    const modules = Swiper.prototype.__modules__;

    if (typeof mod === 'function' && modules.indexOf(mod) < 0) {
      modules.push(mod);
    }
  }

  static use(module) {
    if (Array.isArray(module)) {
      module.forEach(m => Swiper.installModule(m));
      return Swiper;
    }

    Swiper.installModule(module);
    return Swiper;
  }

}

Object.keys(prototypes).forEach(prototypeGroup => {
  Object.keys(prototypes[prototypeGroup]).forEach(protoMethod => {
    Swiper.prototype[protoMethod] = prototypes[prototypeGroup][protoMethod];
  });
});
Swiper.use([Resize, Observer]);
/* harmony default export */ var core = (Swiper);
;// CONCATENATED MODULE: ../../.yarn/unplugged/swiper-npm-8.4.7-9971804532/node_modules/swiper/modules/virtual/virtual.js


function Virtual({
  swiper,
  extendParams,
  on,
  emit
}) {
  extendParams({
    virtual: {
      enabled: false,
      slides: [],
      cache: true,
      renderSlide: null,
      renderExternal: null,
      renderExternalUpdate: true,
      addSlidesBefore: 0,
      addSlidesAfter: 0
    }
  });
  let cssModeTimeout;
  swiper.virtual = {
    cache: {},
    from: undefined,
    to: undefined,
    slides: [],
    offset: 0,
    slidesGrid: []
  };

  function renderSlide(slide, index) {
    const params = swiper.params.virtual;

    if (params.cache && swiper.virtual.cache[index]) {
      return swiper.virtual.cache[index];
    }

    const $slideEl = params.renderSlide ? $(params.renderSlide.call(swiper, slide, index)) : $(`<div class="${swiper.params.slideClass}" data-swiper-slide-index="${index}">${slide}</div>`);
    if (!$slideEl.attr('data-swiper-slide-index')) $slideEl.attr('data-swiper-slide-index', index);
    if (params.cache) swiper.virtual.cache[index] = $slideEl;
    return $slideEl;
  }

  function update(force) {
    const {
      slidesPerView,
      slidesPerGroup,
      centeredSlides
    } = swiper.params;
    const {
      addSlidesBefore,
      addSlidesAfter
    } = swiper.params.virtual;
    const {
      from: previousFrom,
      to: previousTo,
      slides,
      slidesGrid: previousSlidesGrid,
      offset: previousOffset
    } = swiper.virtual;

    if (!swiper.params.cssMode) {
      swiper.updateActiveIndex();
    }

    const activeIndex = swiper.activeIndex || 0;
    let offsetProp;
    if (swiper.rtlTranslate) offsetProp = 'right';else offsetProp = swiper.isHorizontal() ? 'left' : 'top';
    let slidesAfter;
    let slidesBefore;

    if (centeredSlides) {
      slidesAfter = Math.floor(slidesPerView / 2) + slidesPerGroup + addSlidesAfter;
      slidesBefore = Math.floor(slidesPerView / 2) + slidesPerGroup + addSlidesBefore;
    } else {
      slidesAfter = slidesPerView + (slidesPerGroup - 1) + addSlidesAfter;
      slidesBefore = slidesPerGroup + addSlidesBefore;
    }

    const from = Math.max((activeIndex || 0) - slidesBefore, 0);
    const to = Math.min((activeIndex || 0) + slidesAfter, slides.length - 1);
    const offset = (swiper.slidesGrid[from] || 0) - (swiper.slidesGrid[0] || 0);
    Object.assign(swiper.virtual, {
      from,
      to,
      offset,
      slidesGrid: swiper.slidesGrid
    });

    function onRendered() {
      swiper.updateSlides();
      swiper.updateProgress();
      swiper.updateSlidesClasses();

      if (swiper.lazy && swiper.params.lazy.enabled) {
        swiper.lazy.load();
      }

      emit('virtualUpdate');
    }

    if (previousFrom === from && previousTo === to && !force) {
      if (swiper.slidesGrid !== previousSlidesGrid && offset !== previousOffset) {
        swiper.slides.css(offsetProp, `${offset}px`);
      }

      swiper.updateProgress();
      emit('virtualUpdate');
      return;
    }

    if (swiper.params.virtual.renderExternal) {
      swiper.params.virtual.renderExternal.call(swiper, {
        offset,
        from,
        to,
        slides: function getSlides() {
          const slidesToRender = [];

          for (let i = from; i <= to; i += 1) {
            slidesToRender.push(slides[i]);
          }

          return slidesToRender;
        }()
      });

      if (swiper.params.virtual.renderExternalUpdate) {
        onRendered();
      } else {
        emit('virtualUpdate');
      }

      return;
    }

    const prependIndexes = [];
    const appendIndexes = [];

    if (force) {
      swiper.$wrapperEl.find(`.${swiper.params.slideClass}`).remove();
    } else {
      for (let i = previousFrom; i <= previousTo; i += 1) {
        if (i < from || i > to) {
          swiper.$wrapperEl.find(`.${swiper.params.slideClass}[data-swiper-slide-index="${i}"]`).remove();
        }
      }
    }

    for (let i = 0; i < slides.length; i += 1) {
      if (i >= from && i <= to) {
        if (typeof previousTo === 'undefined' || force) {
          appendIndexes.push(i);
        } else {
          if (i > previousTo) appendIndexes.push(i);
          if (i < previousFrom) prependIndexes.push(i);
        }
      }
    }

    appendIndexes.forEach(index => {
      swiper.$wrapperEl.append(renderSlide(slides[index], index));
    });
    prependIndexes.sort((a, b) => b - a).forEach(index => {
      swiper.$wrapperEl.prepend(renderSlide(slides[index], index));
    });
    swiper.$wrapperEl.children('.swiper-slide').css(offsetProp, `${offset}px`);
    onRendered();
  }

  function appendSlide(slides) {
    if (typeof slides === 'object' && 'length' in slides) {
      for (let i = 0; i < slides.length; i += 1) {
        if (slides[i]) swiper.virtual.slides.push(slides[i]);
      }
    } else {
      swiper.virtual.slides.push(slides);
    }

    update(true);
  }

  function prependSlide(slides) {
    const activeIndex = swiper.activeIndex;
    let newActiveIndex = activeIndex + 1;
    let numberOfNewSlides = 1;

    if (Array.isArray(slides)) {
      for (let i = 0; i < slides.length; i += 1) {
        if (slides[i]) swiper.virtual.slides.unshift(slides[i]);
      }

      newActiveIndex = activeIndex + slides.length;
      numberOfNewSlides = slides.length;
    } else {
      swiper.virtual.slides.unshift(slides);
    }

    if (swiper.params.virtual.cache) {
      const cache = swiper.virtual.cache;
      const newCache = {};
      Object.keys(cache).forEach(cachedIndex => {
        const $cachedEl = cache[cachedIndex];
        const cachedElIndex = $cachedEl.attr('data-swiper-slide-index');

        if (cachedElIndex) {
          $cachedEl.attr('data-swiper-slide-index', parseInt(cachedElIndex, 10) + numberOfNewSlides);
        }

        newCache[parseInt(cachedIndex, 10) + numberOfNewSlides] = $cachedEl;
      });
      swiper.virtual.cache = newCache;
    }

    update(true);
    swiper.slideTo(newActiveIndex, 0);
  }

  function removeSlide(slidesIndexes) {
    if (typeof slidesIndexes === 'undefined' || slidesIndexes === null) return;
    let activeIndex = swiper.activeIndex;

    if (Array.isArray(slidesIndexes)) {
      for (let i = slidesIndexes.length - 1; i >= 0; i -= 1) {
        swiper.virtual.slides.splice(slidesIndexes[i], 1);

        if (swiper.params.virtual.cache) {
          delete swiper.virtual.cache[slidesIndexes[i]];
        }

        if (slidesIndexes[i] < activeIndex) activeIndex -= 1;
        activeIndex = Math.max(activeIndex, 0);
      }
    } else {
      swiper.virtual.slides.splice(slidesIndexes, 1);

      if (swiper.params.virtual.cache) {
        delete swiper.virtual.cache[slidesIndexes];
      }

      if (slidesIndexes < activeIndex) activeIndex -= 1;
      activeIndex = Math.max(activeIndex, 0);
    }

    update(true);
    swiper.slideTo(activeIndex, 0);
  }

  function removeAllSlides() {
    swiper.virtual.slides = [];

    if (swiper.params.virtual.cache) {
      swiper.virtual.cache = {};
    }

    update(true);
    swiper.slideTo(0, 0);
  }

  on('beforeInit', () => {
    if (!swiper.params.virtual.enabled) return;
    swiper.virtual.slides = swiper.params.virtual.slides;
    swiper.classNames.push(`${swiper.params.containerModifierClass}virtual`);
    swiper.params.watchSlidesProgress = true;
    swiper.originalParams.watchSlidesProgress = true;

    if (!swiper.params.initialSlide) {
      update();
    }
  });
  on('setTranslate', () => {
    if (!swiper.params.virtual.enabled) return;

    if (swiper.params.cssMode && !swiper._immediateVirtual) {
      clearTimeout(cssModeTimeout);
      cssModeTimeout = setTimeout(() => {
        update();
      }, 100);
    } else {
      update();
    }
  });
  on('init update resize', () => {
    if (!swiper.params.virtual.enabled) return;

    if (swiper.params.cssMode) {
      setCSSProperty(swiper.wrapperEl, '--swiper-virtual-size', `${swiper.virtualSize}px`);
    }
  });
  Object.assign(swiper.virtual, {
    appendSlide,
    prependSlide,
    removeSlide,
    removeAllSlides,
    update
  });
}
;// CONCATENATED MODULE: ../../.yarn/unplugged/swiper-npm-8.4.7-9971804532/node_modules/swiper/modules/keyboard/keyboard.js
/* eslint-disable consistent-return */


function Keyboard({
  swiper,
  extendParams,
  on,
  emit
}) {
  const document = getDocument();
  const window = getWindow();
  swiper.keyboard = {
    enabled: false
  };
  extendParams({
    keyboard: {
      enabled: false,
      onlyInViewport: true,
      pageUpDown: true
    }
  });

  function handle(event) {
    if (!swiper.enabled) return;
    const {
      rtlTranslate: rtl
    } = swiper;
    let e = event;
    if (e.originalEvent) e = e.originalEvent; // jquery fix

    const kc = e.keyCode || e.charCode;
    const pageUpDown = swiper.params.keyboard.pageUpDown;
    const isPageUp = pageUpDown && kc === 33;
    const isPageDown = pageUpDown && kc === 34;
    const isArrowLeft = kc === 37;
    const isArrowRight = kc === 39;
    const isArrowUp = kc === 38;
    const isArrowDown = kc === 40; // Directions locks

    if (!swiper.allowSlideNext && (swiper.isHorizontal() && isArrowRight || swiper.isVertical() && isArrowDown || isPageDown)) {
      return false;
    }

    if (!swiper.allowSlidePrev && (swiper.isHorizontal() && isArrowLeft || swiper.isVertical() && isArrowUp || isPageUp)) {
      return false;
    }

    if (e.shiftKey || e.altKey || e.ctrlKey || e.metaKey) {
      return undefined;
    }

    if (document.activeElement && document.activeElement.nodeName && (document.activeElement.nodeName.toLowerCase() === 'input' || document.activeElement.nodeName.toLowerCase() === 'textarea')) {
      return undefined;
    }

    if (swiper.params.keyboard.onlyInViewport && (isPageUp || isPageDown || isArrowLeft || isArrowRight || isArrowUp || isArrowDown)) {
      let inView = false; // Check that swiper should be inside of visible area of window

      if (swiper.$el.parents(`.${swiper.params.slideClass}`).length > 0 && swiper.$el.parents(`.${swiper.params.slideActiveClass}`).length === 0) {
        return undefined;
      }

      const $el = swiper.$el;
      const swiperWidth = $el[0].clientWidth;
      const swiperHeight = $el[0].clientHeight;
      const windowWidth = window.innerWidth;
      const windowHeight = window.innerHeight;
      const swiperOffset = swiper.$el.offset();
      if (rtl) swiperOffset.left -= swiper.$el[0].scrollLeft;
      const swiperCoord = [[swiperOffset.left, swiperOffset.top], [swiperOffset.left + swiperWidth, swiperOffset.top], [swiperOffset.left, swiperOffset.top + swiperHeight], [swiperOffset.left + swiperWidth, swiperOffset.top + swiperHeight]];

      for (let i = 0; i < swiperCoord.length; i += 1) {
        const point = swiperCoord[i];

        if (point[0] >= 0 && point[0] <= windowWidth && point[1] >= 0 && point[1] <= windowHeight) {
          if (point[0] === 0 && point[1] === 0) continue; // eslint-disable-line

          inView = true;
        }
      }

      if (!inView) return undefined;
    }

    if (swiper.isHorizontal()) {
      if (isPageUp || isPageDown || isArrowLeft || isArrowRight) {
        if (e.preventDefault) e.preventDefault();else e.returnValue = false;
      }

      if ((isPageDown || isArrowRight) && !rtl || (isPageUp || isArrowLeft) && rtl) swiper.slideNext();
      if ((isPageUp || isArrowLeft) && !rtl || (isPageDown || isArrowRight) && rtl) swiper.slidePrev();
    } else {
      if (isPageUp || isPageDown || isArrowUp || isArrowDown) {
        if (e.preventDefault) e.preventDefault();else e.returnValue = false;
      }

      if (isPageDown || isArrowDown) swiper.slideNext();
      if (isPageUp || isArrowUp) swiper.slidePrev();
    }

    emit('keyPress', kc);
    return undefined;
  }

  function enable() {
    if (swiper.keyboard.enabled) return;
    $(document).on('keydown', handle);
    swiper.keyboard.enabled = true;
  }

  function disable() {
    if (!swiper.keyboard.enabled) return;
    $(document).off('keydown', handle);
    swiper.keyboard.enabled = false;
  }

  on('init', () => {
    if (swiper.params.keyboard.enabled) {
      enable();
    }
  });
  on('destroy', () => {
    if (swiper.keyboard.enabled) {
      disable();
    }
  });
  Object.assign(swiper.keyboard, {
    enable,
    disable
  });
}
;// CONCATENATED MODULE: ../../.yarn/unplugged/swiper-npm-8.4.7-9971804532/node_modules/swiper/modules/mousewheel/mousewheel.js
/* eslint-disable consistent-return */



function Mousewheel({
  swiper,
  extendParams,
  on,
  emit
}) {
  const window = getWindow();
  extendParams({
    mousewheel: {
      enabled: false,
      releaseOnEdges: false,
      invert: false,
      forceToAxis: false,
      sensitivity: 1,
      eventsTarget: 'container',
      thresholdDelta: null,
      thresholdTime: null
    }
  });
  swiper.mousewheel = {
    enabled: false
  };
  let timeout;
  let lastScrollTime = now();
  let lastEventBeforeSnap;
  const recentWheelEvents = [];

  function normalize(e) {
    // Reasonable defaults
    const PIXEL_STEP = 10;
    const LINE_HEIGHT = 40;
    const PAGE_HEIGHT = 800;
    let sX = 0;
    let sY = 0; // spinX, spinY

    let pX = 0;
    let pY = 0; // pixelX, pixelY
    // Legacy

    if ('detail' in e) {
      sY = e.detail;
    }

    if ('wheelDelta' in e) {
      sY = -e.wheelDelta / 120;
    }

    if ('wheelDeltaY' in e) {
      sY = -e.wheelDeltaY / 120;
    }

    if ('wheelDeltaX' in e) {
      sX = -e.wheelDeltaX / 120;
    } // side scrolling on FF with DOMMouseScroll


    if ('axis' in e && e.axis === e.HORIZONTAL_AXIS) {
      sX = sY;
      sY = 0;
    }

    pX = sX * PIXEL_STEP;
    pY = sY * PIXEL_STEP;

    if ('deltaY' in e) {
      pY = e.deltaY;
    }

    if ('deltaX' in e) {
      pX = e.deltaX;
    }

    if (e.shiftKey && !pX) {
      // if user scrolls with shift he wants horizontal scroll
      pX = pY;
      pY = 0;
    }

    if ((pX || pY) && e.deltaMode) {
      if (e.deltaMode === 1) {
        // delta in LINE units
        pX *= LINE_HEIGHT;
        pY *= LINE_HEIGHT;
      } else {
        // delta in PAGE units
        pX *= PAGE_HEIGHT;
        pY *= PAGE_HEIGHT;
      }
    } // Fall-back if spin cannot be determined


    if (pX && !sX) {
      sX = pX < 1 ? -1 : 1;
    }

    if (pY && !sY) {
      sY = pY < 1 ? -1 : 1;
    }

    return {
      spinX: sX,
      spinY: sY,
      pixelX: pX,
      pixelY: pY
    };
  }

  function handleMouseEnter() {
    if (!swiper.enabled) return;
    swiper.mouseEntered = true;
  }

  function handleMouseLeave() {
    if (!swiper.enabled) return;
    swiper.mouseEntered = false;
  }

  function animateSlider(newEvent) {
    if (swiper.params.mousewheel.thresholdDelta && newEvent.delta < swiper.params.mousewheel.thresholdDelta) {
      // Prevent if delta of wheel scroll delta is below configured threshold
      return false;
    }

    if (swiper.params.mousewheel.thresholdTime && now() - lastScrollTime < swiper.params.mousewheel.thresholdTime) {
      // Prevent if time between scrolls is below configured threshold
      return false;
    } // If the movement is NOT big enough and
    // if the last time the user scrolled was too close to the current one (avoid continuously triggering the slider):
    //   Don't go any further (avoid insignificant scroll movement).


    if (newEvent.delta >= 6 && now() - lastScrollTime < 60) {
      // Return false as a default
      return true;
    } // If user is scrolling towards the end:
    //   If the slider hasn't hit the latest slide or
    //   if the slider is a loop and
    //   if the slider isn't moving right now:
    //     Go to next slide and
    //     emit a scroll event.
    // Else (the user is scrolling towards the beginning) and
    // if the slider hasn't hit the first slide or
    // if the slider is a loop and
    // if the slider isn't moving right now:
    //   Go to prev slide and
    //   emit a scroll event.


    if (newEvent.direction < 0) {
      if ((!swiper.isEnd || swiper.params.loop) && !swiper.animating) {
        swiper.slideNext();
        emit('scroll', newEvent.raw);
      }
    } else if ((!swiper.isBeginning || swiper.params.loop) && !swiper.animating) {
      swiper.slidePrev();
      emit('scroll', newEvent.raw);
    } // If you got here is because an animation has been triggered so store the current time


    lastScrollTime = new window.Date().getTime(); // Return false as a default

    return false;
  }

  function releaseScroll(newEvent) {
    const params = swiper.params.mousewheel;

    if (newEvent.direction < 0) {
      if (swiper.isEnd && !swiper.params.loop && params.releaseOnEdges) {
        // Return true to animate scroll on edges
        return true;
      }
    } else if (swiper.isBeginning && !swiper.params.loop && params.releaseOnEdges) {
      // Return true to animate scroll on edges
      return true;
    }

    return false;
  }

  function handle(event) {
    let e = event;
    let disableParentSwiper = true;
    if (!swiper.enabled) return;
    const params = swiper.params.mousewheel;

    if (swiper.params.cssMode) {
      e.preventDefault();
    }

    let target = swiper.$el;

    if (swiper.params.mousewheel.eventsTarget !== 'container') {
      target = $(swiper.params.mousewheel.eventsTarget);
    }

    if (!swiper.mouseEntered && !target[0].contains(e.target) && !params.releaseOnEdges) return true;
    if (e.originalEvent) e = e.originalEvent; // jquery fix

    let delta = 0;
    const rtlFactor = swiper.rtlTranslate ? -1 : 1;
    const data = normalize(e);

    if (params.forceToAxis) {
      if (swiper.isHorizontal()) {
        if (Math.abs(data.pixelX) > Math.abs(data.pixelY)) delta = -data.pixelX * rtlFactor;else return true;
      } else if (Math.abs(data.pixelY) > Math.abs(data.pixelX)) delta = -data.pixelY;else return true;
    } else {
      delta = Math.abs(data.pixelX) > Math.abs(data.pixelY) ? -data.pixelX * rtlFactor : -data.pixelY;
    }

    if (delta === 0) return true;
    if (params.invert) delta = -delta; // Get the scroll positions

    let positions = swiper.getTranslate() + delta * params.sensitivity;
    if (positions >= swiper.minTranslate()) positions = swiper.minTranslate();
    if (positions <= swiper.maxTranslate()) positions = swiper.maxTranslate(); // When loop is true:
    //     the disableParentSwiper will be true.
    // When loop is false:
    //     if the scroll positions is not on edge,
    //     then the disableParentSwiper will be true.
    //     if the scroll on edge positions,
    //     then the disableParentSwiper will be false.

    disableParentSwiper = swiper.params.loop ? true : !(positions === swiper.minTranslate() || positions === swiper.maxTranslate());
    if (disableParentSwiper && swiper.params.nested) e.stopPropagation();

    if (!swiper.params.freeMode || !swiper.params.freeMode.enabled) {
      // Register the new event in a variable which stores the relevant data
      const newEvent = {
        time: now(),
        delta: Math.abs(delta),
        direction: Math.sign(delta),
        raw: event
      }; // Keep the most recent events

      if (recentWheelEvents.length >= 2) {
        recentWheelEvents.shift(); // only store the last N events
      }

      const prevEvent = recentWheelEvents.length ? recentWheelEvents[recentWheelEvents.length - 1] : undefined;
      recentWheelEvents.push(newEvent); // If there is at least one previous recorded event:
      //   If direction has changed or
      //   if the scroll is quicker than the previous one:
      //     Animate the slider.
      // Else (this is the first time the wheel is moved):
      //     Animate the slider.

      if (prevEvent) {
        if (newEvent.direction !== prevEvent.direction || newEvent.delta > prevEvent.delta || newEvent.time > prevEvent.time + 150) {
          animateSlider(newEvent);
        }
      } else {
        animateSlider(newEvent);
      } // If it's time to release the scroll:
      //   Return now so you don't hit the preventDefault.


      if (releaseScroll(newEvent)) {
        return true;
      }
    } else {
      // Freemode or scrollContainer:
      // If we recently snapped after a momentum scroll, then ignore wheel events
      // to give time for the deceleration to finish. Stop ignoring after 500 msecs
      // or if it's a new scroll (larger delta or inverse sign as last event before
      // an end-of-momentum snap).
      const newEvent = {
        time: now(),
        delta: Math.abs(delta),
        direction: Math.sign(delta)
      };
      const ignoreWheelEvents = lastEventBeforeSnap && newEvent.time < lastEventBeforeSnap.time + 500 && newEvent.delta <= lastEventBeforeSnap.delta && newEvent.direction === lastEventBeforeSnap.direction;

      if (!ignoreWheelEvents) {
        lastEventBeforeSnap = undefined;

        if (swiper.params.loop) {
          swiper.loopFix();
        }

        let position = swiper.getTranslate() + delta * params.sensitivity;
        const wasBeginning = swiper.isBeginning;
        const wasEnd = swiper.isEnd;
        if (position >= swiper.minTranslate()) position = swiper.minTranslate();
        if (position <= swiper.maxTranslate()) position = swiper.maxTranslate();
        swiper.setTransition(0);
        swiper.setTranslate(position);
        swiper.updateProgress();
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();

        if (!wasBeginning && swiper.isBeginning || !wasEnd && swiper.isEnd) {
          swiper.updateSlidesClasses();
        }

        if (swiper.params.freeMode.sticky) {
          // When wheel scrolling starts with sticky (aka snap) enabled, then detect
          // the end of a momentum scroll by storing recent (N=15?) wheel events.
          // 1. do all N events have decreasing or same (absolute value) delta?
          // 2. did all N events arrive in the last M (M=500?) msecs?
          // 3. does the earliest event have an (absolute value) delta that's
          //    at least P (P=1?) larger than the most recent event's delta?
          // 4. does the latest event have a delta that's smaller than Q (Q=6?) pixels?
          // If 1-4 are "yes" then we're near the end of a momentum scroll deceleration.
          // Snap immediately and ignore remaining wheel events in this scroll.
          // See comment above for "remaining wheel events in this scroll" determination.
          // If 1-4 aren't satisfied, then wait to snap until 500ms after the last event.
          clearTimeout(timeout);
          timeout = undefined;

          if (recentWheelEvents.length >= 15) {
            recentWheelEvents.shift(); // only store the last N events
          }

          const prevEvent = recentWheelEvents.length ? recentWheelEvents[recentWheelEvents.length - 1] : undefined;
          const firstEvent = recentWheelEvents[0];
          recentWheelEvents.push(newEvent);

          if (prevEvent && (newEvent.delta > prevEvent.delta || newEvent.direction !== prevEvent.direction)) {
            // Increasing or reverse-sign delta means the user started scrolling again. Clear the wheel event log.
            recentWheelEvents.splice(0);
          } else if (recentWheelEvents.length >= 15 && newEvent.time - firstEvent.time < 500 && firstEvent.delta - newEvent.delta >= 1 && newEvent.delta <= 6) {
            // We're at the end of the deceleration of a momentum scroll, so there's no need
            // to wait for more events. Snap ASAP on the next tick.
            // Also, because there's some remaining momentum we'll bias the snap in the
            // direction of the ongoing scroll because it's better UX for the scroll to snap
            // in the same direction as the scroll instead of reversing to snap.  Therefore,
            // if it's already scrolled more than 20% in the current direction, keep going.
            const snapToThreshold = delta > 0 ? 0.8 : 0.2;
            lastEventBeforeSnap = newEvent;
            recentWheelEvents.splice(0);
            timeout = nextTick(() => {
              swiper.slideToClosest(swiper.params.speed, true, undefined, snapToThreshold);
            }, 0); // no delay; move on next tick
          }

          if (!timeout) {
            // if we get here, then we haven't detected the end of a momentum scroll, so
            // we'll consider a scroll "complete" when there haven't been any wheel events
            // for 500ms.
            timeout = nextTick(() => {
              const snapToThreshold = 0.5;
              lastEventBeforeSnap = newEvent;
              recentWheelEvents.splice(0);
              swiper.slideToClosest(swiper.params.speed, true, undefined, snapToThreshold);
            }, 500);
          }
        } // Emit event


        if (!ignoreWheelEvents) emit('scroll', e); // Stop autoplay

        if (swiper.params.autoplay && swiper.params.autoplayDisableOnInteraction) swiper.autoplay.stop(); // Return page scroll on edge positions

        if (position === swiper.minTranslate() || position === swiper.maxTranslate()) return true;
      }
    }

    if (e.preventDefault) e.preventDefault();else e.returnValue = false;
    return false;
  }

  function events(method) {
    let target = swiper.$el;

    if (swiper.params.mousewheel.eventsTarget !== 'container') {
      target = $(swiper.params.mousewheel.eventsTarget);
    }

    target[method]('mouseenter', handleMouseEnter);
    target[method]('mouseleave', handleMouseLeave);
    target[method]('wheel', handle);
  }

  function enable() {
    if (swiper.params.cssMode) {
      swiper.wrapperEl.removeEventListener('wheel', handle);
      return true;
    }

    if (swiper.mousewheel.enabled) return false;
    events('on');
    swiper.mousewheel.enabled = true;
    return true;
  }

  function disable() {
    if (swiper.params.cssMode) {
      swiper.wrapperEl.addEventListener(event, handle);
      return true;
    }

    if (!swiper.mousewheel.enabled) return false;
    events('off');
    swiper.mousewheel.enabled = false;
    return true;
  }

  on('init', () => {
    if (!swiper.params.mousewheel.enabled && swiper.params.cssMode) {
      disable();
    }

    if (swiper.params.mousewheel.enabled) enable();
  });
  on('destroy', () => {
    if (swiper.params.cssMode) {
      enable();
    }

    if (swiper.mousewheel.enabled) disable();
  });
  Object.assign(swiper.mousewheel, {
    enable,
    disable
  });
}
;// CONCATENATED MODULE: ../../.yarn/unplugged/swiper-npm-8.4.7-9971804532/node_modules/swiper/shared/create-element-if-not-defined.js

function create_element_if_not_defined_createElementIfNotDefined(swiper, originalParams, params, checkProps) {
  const document = getDocument();

  if (swiper.params.createElements) {
    Object.keys(checkProps).forEach(key => {
      if (!params[key] && params.auto === true) {
        let element = swiper.$el.children(`.${checkProps[key]}`)[0];

        if (!element) {
          element = document.createElement('div');
          element.className = checkProps[key];
          swiper.$el.append(element);
        }

        params[key] = element;
        originalParams[key] = element;
      }
    });
  }

  return params;
}
;// CONCATENATED MODULE: ../../.yarn/unplugged/swiper-npm-8.4.7-9971804532/node_modules/swiper/modules/navigation/navigation.js


function Navigation({
  swiper,
  extendParams,
  on,
  emit
}) {
  extendParams({
    navigation: {
      nextEl: null,
      prevEl: null,
      hideOnClick: false,
      disabledClass: 'swiper-button-disabled',
      hiddenClass: 'swiper-button-hidden',
      lockClass: 'swiper-button-lock',
      navigationDisabledClass: 'swiper-navigation-disabled'
    }
  });
  swiper.navigation = {
    nextEl: null,
    $nextEl: null,
    prevEl: null,
    $prevEl: null
  };

  function getEl(el) {
    let $el;

    if (el) {
      $el = $(el);

      if (swiper.params.uniqueNavElements && typeof el === 'string' && $el.length > 1 && swiper.$el.find(el).length === 1) {
        $el = swiper.$el.find(el);
      }
    }

    return $el;
  }

  function toggleEl($el, disabled) {
    const params = swiper.params.navigation;

    if ($el && $el.length > 0) {
      $el[disabled ? 'addClass' : 'removeClass'](params.disabledClass);
      if ($el[0] && $el[0].tagName === 'BUTTON') $el[0].disabled = disabled;

      if (swiper.params.watchOverflow && swiper.enabled) {
        $el[swiper.isLocked ? 'addClass' : 'removeClass'](params.lockClass);
      }
    }
  }

  function update() {
    // Update Navigation Buttons
    if (swiper.params.loop) return;
    const {
      $nextEl,
      $prevEl
    } = swiper.navigation;
    toggleEl($prevEl, swiper.isBeginning && !swiper.params.rewind);
    toggleEl($nextEl, swiper.isEnd && !swiper.params.rewind);
  }

  function onPrevClick(e) {
    e.preventDefault();
    if (swiper.isBeginning && !swiper.params.loop && !swiper.params.rewind) return;
    swiper.slidePrev();
    emit('navigationPrev');
  }

  function onNextClick(e) {
    e.preventDefault();
    if (swiper.isEnd && !swiper.params.loop && !swiper.params.rewind) return;
    swiper.slideNext();
    emit('navigationNext');
  }

  function init() {
    const params = swiper.params.navigation;
    swiper.params.navigation = createElementIfNotDefined(swiper, swiper.originalParams.navigation, swiper.params.navigation, {
      nextEl: 'swiper-button-next',
      prevEl: 'swiper-button-prev'
    });
    if (!(params.nextEl || params.prevEl)) return;
    const $nextEl = getEl(params.nextEl);
    const $prevEl = getEl(params.prevEl);

    if ($nextEl && $nextEl.length > 0) {
      $nextEl.on('click', onNextClick);
    }

    if ($prevEl && $prevEl.length > 0) {
      $prevEl.on('click', onPrevClick);
    }

    Object.assign(swiper.navigation, {
      $nextEl,
      nextEl: $nextEl && $nextEl[0],
      $prevEl,
      prevEl: $prevEl && $prevEl[0]
    });

    if (!swiper.enabled) {
      if ($nextEl) $nextEl.addClass(params.lockClass);
      if ($prevEl) $prevEl.addClass(params.lockClass);
    }
  }

  function destroy() {
    const {
      $nextEl,
      $prevEl
    } = swiper.navigation;

    if ($nextEl && $nextEl.length) {
      $nextEl.off('click', onNextClick);
      $nextEl.removeClass(swiper.params.navigation.disabledClass);
    }

    if ($prevEl && $prevEl.length) {
      $prevEl.off('click', onPrevClick);
      $prevEl.removeClass(swiper.params.navigation.disabledClass);
    }
  }

  on('init', () => {
    if (swiper.params.navigation.enabled === false) {
      // eslint-disable-next-line
      disable();
    } else {
      init();
      update();
    }
  });
  on('toEdge fromEdge lock unlock', () => {
    update();
  });
  on('destroy', () => {
    destroy();
  });
  on('enable disable', () => {
    const {
      $nextEl,
      $prevEl
    } = swiper.navigation;

    if ($nextEl) {
      $nextEl[swiper.enabled ? 'removeClass' : 'addClass'](swiper.params.navigation.lockClass);
    }

    if ($prevEl) {
      $prevEl[swiper.enabled ? 'removeClass' : 'addClass'](swiper.params.navigation.lockClass);
    }
  });
  on('click', (_s, e) => {
    const {
      $nextEl,
      $prevEl
    } = swiper.navigation;
    const targetEl = e.target;

    if (swiper.params.navigation.hideOnClick && !$(targetEl).is($prevEl) && !$(targetEl).is($nextEl)) {
      if (swiper.pagination && swiper.params.pagination && swiper.params.pagination.clickable && (swiper.pagination.el === targetEl || swiper.pagination.el.contains(targetEl))) return;
      let isHidden;

      if ($nextEl) {
        isHidden = $nextEl.hasClass(swiper.params.navigation.hiddenClass);
      } else if ($prevEl) {
        isHidden = $prevEl.hasClass(swiper.params.navigation.hiddenClass);
      }

      if (isHidden === true) {
        emit('navigationShow');
      } else {
        emit('navigationHide');
      }

      if ($nextEl) {
        $nextEl.toggleClass(swiper.params.navigation.hiddenClass);
      }

      if ($prevEl) {
        $prevEl.toggleClass(swiper.params.navigation.hiddenClass);
      }
    }
  });

  const enable = () => {
    swiper.$el.removeClass(swiper.params.navigation.navigationDisabledClass);
    init();
    update();
  };

  const disable = () => {
    swiper.$el.addClass(swiper.params.navigation.navigationDisabledClass);
    destroy();
  };

  Object.assign(swiper.navigation, {
    enable,
    disable,
    update,
    init,
    destroy
  });
}
;// CONCATENATED MODULE: ../../.yarn/unplugged/swiper-npm-8.4.7-9971804532/node_modules/swiper/modules/pagination/pagination.js



function Pagination({
  swiper,
  extendParams,
  on,
  emit
}) {
  const pfx = 'swiper-pagination';
  extendParams({
    pagination: {
      el: null,
      bulletElement: 'span',
      clickable: false,
      hideOnClick: false,
      renderBullet: null,
      renderProgressbar: null,
      renderFraction: null,
      renderCustom: null,
      progressbarOpposite: false,
      type: 'bullets',
      // 'bullets' or 'progressbar' or 'fraction' or 'custom'
      dynamicBullets: false,
      dynamicMainBullets: 1,
      formatFractionCurrent: number => number,
      formatFractionTotal: number => number,
      bulletClass: `${pfx}-bullet`,
      bulletActiveClass: `${pfx}-bullet-active`,
      modifierClass: `${pfx}-`,
      currentClass: `${pfx}-current`,
      totalClass: `${pfx}-total`,
      hiddenClass: `${pfx}-hidden`,
      progressbarFillClass: `${pfx}-progressbar-fill`,
      progressbarOppositeClass: `${pfx}-progressbar-opposite`,
      clickableClass: `${pfx}-clickable`,
      lockClass: `${pfx}-lock`,
      horizontalClass: `${pfx}-horizontal`,
      verticalClass: `${pfx}-vertical`,
      paginationDisabledClass: `${pfx}-disabled`
    }
  });
  swiper.pagination = {
    el: null,
    $el: null,
    bullets: []
  };
  let bulletSize;
  let dynamicBulletIndex = 0;

  function isPaginationDisabled() {
    return !swiper.params.pagination.el || !swiper.pagination.el || !swiper.pagination.$el || swiper.pagination.$el.length === 0;
  }

  function setSideBullets($bulletEl, position) {
    const {
      bulletActiveClass
    } = swiper.params.pagination;
    $bulletEl[position]().addClass(`${bulletActiveClass}-${position}`)[position]().addClass(`${bulletActiveClass}-${position}-${position}`);
  }

  function update() {
    // Render || Update Pagination bullets/items
    const rtl = swiper.rtl;
    const params = swiper.params.pagination;
    if (isPaginationDisabled()) return;
    const slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.slides.length;
    const $el = swiper.pagination.$el; // Current/Total

    let current;
    const total = swiper.params.loop ? Math.ceil((slidesLength - swiper.loopedSlides * 2) / swiper.params.slidesPerGroup) : swiper.snapGrid.length;

    if (swiper.params.loop) {
      current = Math.ceil((swiper.activeIndex - swiper.loopedSlides) / swiper.params.slidesPerGroup);

      if (current > slidesLength - 1 - swiper.loopedSlides * 2) {
        current -= slidesLength - swiper.loopedSlides * 2;
      }

      if (current > total - 1) current -= total;
      if (current < 0 && swiper.params.paginationType !== 'bullets') current = total + current;
    } else if (typeof swiper.snapIndex !== 'undefined') {
      current = swiper.snapIndex;
    } else {
      current = swiper.activeIndex || 0;
    } // Types


    if (params.type === 'bullets' && swiper.pagination.bullets && swiper.pagination.bullets.length > 0) {
      const bullets = swiper.pagination.bullets;
      let firstIndex;
      let lastIndex;
      let midIndex;

      if (params.dynamicBullets) {
        bulletSize = bullets.eq(0)[swiper.isHorizontal() ? 'outerWidth' : 'outerHeight'](true);
        $el.css(swiper.isHorizontal() ? 'width' : 'height', `${bulletSize * (params.dynamicMainBullets + 4)}px`);

        if (params.dynamicMainBullets > 1 && swiper.previousIndex !== undefined) {
          dynamicBulletIndex += current - (swiper.previousIndex - swiper.loopedSlides || 0);

          if (dynamicBulletIndex > params.dynamicMainBullets - 1) {
            dynamicBulletIndex = params.dynamicMainBullets - 1;
          } else if (dynamicBulletIndex < 0) {
            dynamicBulletIndex = 0;
          }
        }

        firstIndex = Math.max(current - dynamicBulletIndex, 0);
        lastIndex = firstIndex + (Math.min(bullets.length, params.dynamicMainBullets) - 1);
        midIndex = (lastIndex + firstIndex) / 2;
      }

      bullets.removeClass(['', '-next', '-next-next', '-prev', '-prev-prev', '-main'].map(suffix => `${params.bulletActiveClass}${suffix}`).join(' '));

      if ($el.length > 1) {
        bullets.each(bullet => {
          const $bullet = $(bullet);
          const bulletIndex = $bullet.index();

          if (bulletIndex === current) {
            $bullet.addClass(params.bulletActiveClass);
          }

          if (params.dynamicBullets) {
            if (bulletIndex >= firstIndex && bulletIndex <= lastIndex) {
              $bullet.addClass(`${params.bulletActiveClass}-main`);
            }

            if (bulletIndex === firstIndex) {
              setSideBullets($bullet, 'prev');
            }

            if (bulletIndex === lastIndex) {
              setSideBullets($bullet, 'next');
            }
          }
        });
      } else {
        const $bullet = bullets.eq(current);
        const bulletIndex = $bullet.index();
        $bullet.addClass(params.bulletActiveClass);

        if (params.dynamicBullets) {
          const $firstDisplayedBullet = bullets.eq(firstIndex);
          const $lastDisplayedBullet = bullets.eq(lastIndex);

          for (let i = firstIndex; i <= lastIndex; i += 1) {
            bullets.eq(i).addClass(`${params.bulletActiveClass}-main`);
          }

          if (swiper.params.loop) {
            if (bulletIndex >= bullets.length) {
              for (let i = params.dynamicMainBullets; i >= 0; i -= 1) {
                bullets.eq(bullets.length - i).addClass(`${params.bulletActiveClass}-main`);
              }

              bullets.eq(bullets.length - params.dynamicMainBullets - 1).addClass(`${params.bulletActiveClass}-prev`);
            } else {
              setSideBullets($firstDisplayedBullet, 'prev');
              setSideBullets($lastDisplayedBullet, 'next');
            }
          } else {
            setSideBullets($firstDisplayedBullet, 'prev');
            setSideBullets($lastDisplayedBullet, 'next');
          }
        }
      }

      if (params.dynamicBullets) {
        const dynamicBulletsLength = Math.min(bullets.length, params.dynamicMainBullets + 4);
        const bulletsOffset = (bulletSize * dynamicBulletsLength - bulletSize) / 2 - midIndex * bulletSize;
        const offsetProp = rtl ? 'right' : 'left';
        bullets.css(swiper.isHorizontal() ? offsetProp : 'top', `${bulletsOffset}px`);
      }
    }

    if (params.type === 'fraction') {
      $el.find(classesToSelector(params.currentClass)).text(params.formatFractionCurrent(current + 1));
      $el.find(classesToSelector(params.totalClass)).text(params.formatFractionTotal(total));
    }

    if (params.type === 'progressbar') {
      let progressbarDirection;

      if (params.progressbarOpposite) {
        progressbarDirection = swiper.isHorizontal() ? 'vertical' : 'horizontal';
      } else {
        progressbarDirection = swiper.isHorizontal() ? 'horizontal' : 'vertical';
      }

      const scale = (current + 1) / total;
      let scaleX = 1;
      let scaleY = 1;

      if (progressbarDirection === 'horizontal') {
        scaleX = scale;
      } else {
        scaleY = scale;
      }

      $el.find(classesToSelector(params.progressbarFillClass)).transform(`translate3d(0,0,0) scaleX(${scaleX}) scaleY(${scaleY})`).transition(swiper.params.speed);
    }

    if (params.type === 'custom' && params.renderCustom) {
      $el.html(params.renderCustom(swiper, current + 1, total));
      emit('paginationRender', $el[0]);
    } else {
      emit('paginationUpdate', $el[0]);
    }

    if (swiper.params.watchOverflow && swiper.enabled) {
      $el[swiper.isLocked ? 'addClass' : 'removeClass'](params.lockClass);
    }
  }

  function render() {
    // Render Container
    const params = swiper.params.pagination;
    if (isPaginationDisabled()) return;
    const slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.slides.length;
    const $el = swiper.pagination.$el;
    let paginationHTML = '';

    if (params.type === 'bullets') {
      let numberOfBullets = swiper.params.loop ? Math.ceil((slidesLength - swiper.loopedSlides * 2) / swiper.params.slidesPerGroup) : swiper.snapGrid.length;

      if (swiper.params.freeMode && swiper.params.freeMode.enabled && !swiper.params.loop && numberOfBullets > slidesLength) {
        numberOfBullets = slidesLength;
      }

      for (let i = 0; i < numberOfBullets; i += 1) {
        if (params.renderBullet) {
          paginationHTML += params.renderBullet.call(swiper, i, params.bulletClass);
        } else {
          paginationHTML += `<${params.bulletElement} class="${params.bulletClass}"></${params.bulletElement}>`;
        }
      }

      $el.html(paginationHTML);
      swiper.pagination.bullets = $el.find(classesToSelector(params.bulletClass));
    }

    if (params.type === 'fraction') {
      if (params.renderFraction) {
        paginationHTML = params.renderFraction.call(swiper, params.currentClass, params.totalClass);
      } else {
        paginationHTML = `<span class="${params.currentClass}"></span>` + ' / ' + `<span class="${params.totalClass}"></span>`;
      }

      $el.html(paginationHTML);
    }

    if (params.type === 'progressbar') {
      if (params.renderProgressbar) {
        paginationHTML = params.renderProgressbar.call(swiper, params.progressbarFillClass);
      } else {
        paginationHTML = `<span class="${params.progressbarFillClass}"></span>`;
      }

      $el.html(paginationHTML);
    }

    if (params.type !== 'custom') {
      emit('paginationRender', swiper.pagination.$el[0]);
    }
  }

  function init() {
    swiper.params.pagination = createElementIfNotDefined(swiper, swiper.originalParams.pagination, swiper.params.pagination, {
      el: 'swiper-pagination'
    });
    const params = swiper.params.pagination;
    if (!params.el) return;
    let $el = $(params.el);
    if ($el.length === 0) return;

    if (swiper.params.uniqueNavElements && typeof params.el === 'string' && $el.length > 1) {
      $el = swiper.$el.find(params.el); // check if it belongs to another nested Swiper

      if ($el.length > 1) {
        $el = $el.filter(el => {
          if ($(el).parents('.swiper')[0] !== swiper.el) return false;
          return true;
        });
      }
    }

    if (params.type === 'bullets' && params.clickable) {
      $el.addClass(params.clickableClass);
    }

    $el.addClass(params.modifierClass + params.type);
    $el.addClass(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);

    if (params.type === 'bullets' && params.dynamicBullets) {
      $el.addClass(`${params.modifierClass}${params.type}-dynamic`);
      dynamicBulletIndex = 0;

      if (params.dynamicMainBullets < 1) {
        params.dynamicMainBullets = 1;
      }
    }

    if (params.type === 'progressbar' && params.progressbarOpposite) {
      $el.addClass(params.progressbarOppositeClass);
    }

    if (params.clickable) {
      $el.on('click', classesToSelector(params.bulletClass), function onClick(e) {
        e.preventDefault();
        let index = $(this).index() * swiper.params.slidesPerGroup;
        if (swiper.params.loop) index += swiper.loopedSlides;
        swiper.slideTo(index);
      });
    }

    Object.assign(swiper.pagination, {
      $el,
      el: $el[0]
    });

    if (!swiper.enabled) {
      $el.addClass(params.lockClass);
    }
  }

  function destroy() {
    const params = swiper.params.pagination;
    if (isPaginationDisabled()) return;
    const $el = swiper.pagination.$el;
    $el.removeClass(params.hiddenClass);
    $el.removeClass(params.modifierClass + params.type);
    $el.removeClass(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
    if (swiper.pagination.bullets && swiper.pagination.bullets.removeClass) swiper.pagination.bullets.removeClass(params.bulletActiveClass);

    if (params.clickable) {
      $el.off('click', classesToSelector(params.bulletClass));
    }
  }

  on('init', () => {
    if (swiper.params.pagination.enabled === false) {
      // eslint-disable-next-line
      disable();
    } else {
      init();
      render();
      update();
    }
  });
  on('activeIndexChange', () => {
    if (swiper.params.loop) {
      update();
    } else if (typeof swiper.snapIndex === 'undefined') {
      update();
    }
  });
  on('snapIndexChange', () => {
    if (!swiper.params.loop) {
      update();
    }
  });
  on('slidesLengthChange', () => {
    if (swiper.params.loop) {
      render();
      update();
    }
  });
  on('snapGridLengthChange', () => {
    if (!swiper.params.loop) {
      render();
      update();
    }
  });
  on('destroy', () => {
    destroy();
  });
  on('enable disable', () => {
    const {
      $el
    } = swiper.pagination;

    if ($el) {
      $el[swiper.enabled ? 'removeClass' : 'addClass'](swiper.params.pagination.lockClass);
    }
  });
  on('lock unlock', () => {
    update();
  });
  on('click', (_s, e) => {
    const targetEl = e.target;
    const {
      $el
    } = swiper.pagination;

    if (swiper.params.pagination.el && swiper.params.pagination.hideOnClick && $el && $el.length > 0 && !$(targetEl).hasClass(swiper.params.pagination.bulletClass)) {
      if (swiper.navigation && (swiper.navigation.nextEl && targetEl === swiper.navigation.nextEl || swiper.navigation.prevEl && targetEl === swiper.navigation.prevEl)) return;
      const isHidden = $el.hasClass(swiper.params.pagination.hiddenClass);

      if (isHidden === true) {
        emit('paginationShow');
      } else {
        emit('paginationHide');
      }

      $el.toggleClass(swiper.params.pagination.hiddenClass);
    }
  });

  const enable = () => {
    swiper.$el.removeClass(swiper.params.pagination.paginationDisabledClass);

    if (swiper.pagination.$el) {
      swiper.pagination.$el.removeClass(swiper.params.pagination.paginationDisabledClass);
    }

    init();
    render();
    update();
  };

  const disable = () => {
    swiper.$el.addClass(swiper.params.pagination.paginationDisabledClass);

    if (swiper.pagination.$el) {
      swiper.pagination.$el.addClass(swiper.params.pagination.paginationDisabledClass);
    }

    destroy();
  };

  Object.assign(swiper.pagination, {
    enable,
    disable,
    render,
    update,
    init,
    destroy
  });
}
;// CONCATENATED MODULE: ../../.yarn/unplugged/swiper-npm-8.4.7-9971804532/node_modules/swiper/modules/scrollbar/scrollbar.js




function Scrollbar({
  swiper,
  extendParams,
  on,
  emit
}) {
  const document = getDocument();
  let isTouched = false;
  let timeout = null;
  let dragTimeout = null;
  let dragStartPos;
  let dragSize;
  let trackSize;
  let divider;
  extendParams({
    scrollbar: {
      el: null,
      dragSize: 'auto',
      hide: false,
      draggable: false,
      snapOnRelease: true,
      lockClass: 'swiper-scrollbar-lock',
      dragClass: 'swiper-scrollbar-drag',
      scrollbarDisabledClass: 'swiper-scrollbar-disabled',
      horizontalClass: `swiper-scrollbar-horizontal`,
      verticalClass: `swiper-scrollbar-vertical`
    }
  });
  swiper.scrollbar = {
    el: null,
    dragEl: null,
    $el: null,
    $dragEl: null
  };

  function setTranslate() {
    if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
    const {
      scrollbar,
      rtlTranslate: rtl,
      progress
    } = swiper;
    const {
      $dragEl,
      $el
    } = scrollbar;
    const params = swiper.params.scrollbar;
    let newSize = dragSize;
    let newPos = (trackSize - dragSize) * progress;

    if (rtl) {
      newPos = -newPos;

      if (newPos > 0) {
        newSize = dragSize - newPos;
        newPos = 0;
      } else if (-newPos + dragSize > trackSize) {
        newSize = trackSize + newPos;
      }
    } else if (newPos < 0) {
      newSize = dragSize + newPos;
      newPos = 0;
    } else if (newPos + dragSize > trackSize) {
      newSize = trackSize - newPos;
    }

    if (swiper.isHorizontal()) {
      $dragEl.transform(`translate3d(${newPos}px, 0, 0)`);
      $dragEl[0].style.width = `${newSize}px`;
    } else {
      $dragEl.transform(`translate3d(0px, ${newPos}px, 0)`);
      $dragEl[0].style.height = `${newSize}px`;
    }

    if (params.hide) {
      clearTimeout(timeout);
      $el[0].style.opacity = 1;
      timeout = setTimeout(() => {
        $el[0].style.opacity = 0;
        $el.transition(400);
      }, 1000);
    }
  }

  function setTransition(duration) {
    if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
    swiper.scrollbar.$dragEl.transition(duration);
  }

  function updateSize() {
    if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
    const {
      scrollbar
    } = swiper;
    const {
      $dragEl,
      $el
    } = scrollbar;
    $dragEl[0].style.width = '';
    $dragEl[0].style.height = '';
    trackSize = swiper.isHorizontal() ? $el[0].offsetWidth : $el[0].offsetHeight;
    divider = swiper.size / (swiper.virtualSize + swiper.params.slidesOffsetBefore - (swiper.params.centeredSlides ? swiper.snapGrid[0] : 0));

    if (swiper.params.scrollbar.dragSize === 'auto') {
      dragSize = trackSize * divider;
    } else {
      dragSize = parseInt(swiper.params.scrollbar.dragSize, 10);
    }

    if (swiper.isHorizontal()) {
      $dragEl[0].style.width = `${dragSize}px`;
    } else {
      $dragEl[0].style.height = `${dragSize}px`;
    }

    if (divider >= 1) {
      $el[0].style.display = 'none';
    } else {
      $el[0].style.display = '';
    }

    if (swiper.params.scrollbar.hide) {
      $el[0].style.opacity = 0;
    }

    if (swiper.params.watchOverflow && swiper.enabled) {
      scrollbar.$el[swiper.isLocked ? 'addClass' : 'removeClass'](swiper.params.scrollbar.lockClass);
    }
  }

  function getPointerPosition(e) {
    if (swiper.isHorizontal()) {
      return e.type === 'touchstart' || e.type === 'touchmove' ? e.targetTouches[0].clientX : e.clientX;
    }

    return e.type === 'touchstart' || e.type === 'touchmove' ? e.targetTouches[0].clientY : e.clientY;
  }

  function setDragPosition(e) {
    const {
      scrollbar,
      rtlTranslate: rtl
    } = swiper;
    const {
      $el
    } = scrollbar;
    let positionRatio;
    positionRatio = (getPointerPosition(e) - $el.offset()[swiper.isHorizontal() ? 'left' : 'top'] - (dragStartPos !== null ? dragStartPos : dragSize / 2)) / (trackSize - dragSize);
    positionRatio = Math.max(Math.min(positionRatio, 1), 0);

    if (rtl) {
      positionRatio = 1 - positionRatio;
    }

    const position = swiper.minTranslate() + (swiper.maxTranslate() - swiper.minTranslate()) * positionRatio;
    swiper.updateProgress(position);
    swiper.setTranslate(position);
    swiper.updateActiveIndex();
    swiper.updateSlidesClasses();
  }

  function onDragStart(e) {
    const params = swiper.params.scrollbar;
    const {
      scrollbar,
      $wrapperEl
    } = swiper;
    const {
      $el,
      $dragEl
    } = scrollbar;
    isTouched = true;
    dragStartPos = e.target === $dragEl[0] || e.target === $dragEl ? getPointerPosition(e) - e.target.getBoundingClientRect()[swiper.isHorizontal() ? 'left' : 'top'] : null;
    e.preventDefault();
    e.stopPropagation();
    $wrapperEl.transition(100);
    $dragEl.transition(100);
    setDragPosition(e);
    clearTimeout(dragTimeout);
    $el.transition(0);

    if (params.hide) {
      $el.css('opacity', 1);
    }

    if (swiper.params.cssMode) {
      swiper.$wrapperEl.css('scroll-snap-type', 'none');
    }

    emit('scrollbarDragStart', e);
  }

  function onDragMove(e) {
    const {
      scrollbar,
      $wrapperEl
    } = swiper;
    const {
      $el,
      $dragEl
    } = scrollbar;
    if (!isTouched) return;
    if (e.preventDefault) e.preventDefault();else e.returnValue = false;
    setDragPosition(e);
    $wrapperEl.transition(0);
    $el.transition(0);
    $dragEl.transition(0);
    emit('scrollbarDragMove', e);
  }

  function onDragEnd(e) {
    const params = swiper.params.scrollbar;
    const {
      scrollbar,
      $wrapperEl
    } = swiper;
    const {
      $el
    } = scrollbar;
    if (!isTouched) return;
    isTouched = false;

    if (swiper.params.cssMode) {
      swiper.$wrapperEl.css('scroll-snap-type', '');
      $wrapperEl.transition('');
    }

    if (params.hide) {
      clearTimeout(dragTimeout);
      dragTimeout = nextTick(() => {
        $el.css('opacity', 0);
        $el.transition(400);
      }, 1000);
    }

    emit('scrollbarDragEnd', e);

    if (params.snapOnRelease) {
      swiper.slideToClosest();
    }
  }

  function events(method) {
    const {
      scrollbar,
      touchEventsTouch,
      touchEventsDesktop,
      params,
      support
    } = swiper;
    const $el = scrollbar.$el;
    if (!$el) return;
    const target = $el[0];
    const activeListener = support.passiveListener && params.passiveListeners ? {
      passive: false,
      capture: false
    } : false;
    const passiveListener = support.passiveListener && params.passiveListeners ? {
      passive: true,
      capture: false
    } : false;
    if (!target) return;
    const eventMethod = method === 'on' ? 'addEventListener' : 'removeEventListener';

    if (!support.touch) {
      target[eventMethod](touchEventsDesktop.start, onDragStart, activeListener);
      document[eventMethod](touchEventsDesktop.move, onDragMove, activeListener);
      document[eventMethod](touchEventsDesktop.end, onDragEnd, passiveListener);
    } else {
      target[eventMethod](touchEventsTouch.start, onDragStart, activeListener);
      target[eventMethod](touchEventsTouch.move, onDragMove, activeListener);
      target[eventMethod](touchEventsTouch.end, onDragEnd, passiveListener);
    }
  }

  function enableDraggable() {
    if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
    events('on');
  }

  function disableDraggable() {
    if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
    events('off');
  }

  function init() {
    const {
      scrollbar,
      $el: $swiperEl
    } = swiper;
    swiper.params.scrollbar = createElementIfNotDefined(swiper, swiper.originalParams.scrollbar, swiper.params.scrollbar, {
      el: 'swiper-scrollbar'
    });
    const params = swiper.params.scrollbar;
    if (!params.el) return;
    let $el = $(params.el);

    if (swiper.params.uniqueNavElements && typeof params.el === 'string' && $el.length > 1 && $swiperEl.find(params.el).length === 1) {
      $el = $swiperEl.find(params.el);
    }

    $el.addClass(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
    let $dragEl = $el.find(`.${swiper.params.scrollbar.dragClass}`);

    if ($dragEl.length === 0) {
      $dragEl = $(`<div class="${swiper.params.scrollbar.dragClass}"></div>`);
      $el.append($dragEl);
    }

    Object.assign(scrollbar, {
      $el,
      el: $el[0],
      $dragEl,
      dragEl: $dragEl[0]
    });

    if (params.draggable) {
      enableDraggable();
    }

    if ($el) {
      $el[swiper.enabled ? 'removeClass' : 'addClass'](swiper.params.scrollbar.lockClass);
    }
  }

  function destroy() {
    const params = swiper.params.scrollbar;
    const $el = swiper.scrollbar.$el;

    if ($el) {
      $el.removeClass(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
    }

    disableDraggable();
  }

  on('init', () => {
    if (swiper.params.scrollbar.enabled === false) {
      // eslint-disable-next-line
      disable();
    } else {
      init();
      updateSize();
      setTranslate();
    }
  });
  on('update resize observerUpdate lock unlock', () => {
    updateSize();
  });
  on('setTranslate', () => {
    setTranslate();
  });
  on('setTransition', (_s, duration) => {
    setTransition(duration);
  });
  on('enable disable', () => {
    const {
      $el
    } = swiper.scrollbar;

    if ($el) {
      $el[swiper.enabled ? 'removeClass' : 'addClass'](swiper.params.scrollbar.lockClass);
    }
  });
  on('destroy', () => {
    destroy();
  });

  const enable = () => {
    swiper.$el.removeClass(swiper.params.scrollbar.scrollbarDisabledClass);

    if (swiper.scrollbar.$el) {
      swiper.scrollbar.$el.removeClass(swiper.params.scrollbar.scrollbarDisabledClass);
    }

    init();
    updateSize();
    setTranslate();
  };

  const disable = () => {
    swiper.$el.addClass(swiper.params.scrollbar.scrollbarDisabledClass);

    if (swiper.scrollbar.$el) {
      swiper.scrollbar.$el.addClass(swiper.params.scrollbar.scrollbarDisabledClass);
    }

    destroy();
  };

  Object.assign(swiper.scrollbar, {
    enable,
    disable,
    updateSize,
    setTranslate,
    init,
    destroy
  });
}
;// CONCATENATED MODULE: ../../.yarn/unplugged/swiper-npm-8.4.7-9971804532/node_modules/swiper/modules/parallax/parallax.js

function Parallax({
  swiper,
  extendParams,
  on
}) {
  extendParams({
    parallax: {
      enabled: false
    }
  });

  const setTransform = (el, progress) => {
    const {
      rtl
    } = swiper;
    const $el = $(el);
    const rtlFactor = rtl ? -1 : 1;
    const p = $el.attr('data-swiper-parallax') || '0';
    let x = $el.attr('data-swiper-parallax-x');
    let y = $el.attr('data-swiper-parallax-y');
    const scale = $el.attr('data-swiper-parallax-scale');
    const opacity = $el.attr('data-swiper-parallax-opacity');

    if (x || y) {
      x = x || '0';
      y = y || '0';
    } else if (swiper.isHorizontal()) {
      x = p;
      y = '0';
    } else {
      y = p;
      x = '0';
    }

    if (x.indexOf('%') >= 0) {
      x = `${parseInt(x, 10) * progress * rtlFactor}%`;
    } else {
      x = `${x * progress * rtlFactor}px`;
    }

    if (y.indexOf('%') >= 0) {
      y = `${parseInt(y, 10) * progress}%`;
    } else {
      y = `${y * progress}px`;
    }

    if (typeof opacity !== 'undefined' && opacity !== null) {
      const currentOpacity = opacity - (opacity - 1) * (1 - Math.abs(progress));
      $el[0].style.opacity = currentOpacity;
    }

    if (typeof scale === 'undefined' || scale === null) {
      $el.transform(`translate3d(${x}, ${y}, 0px)`);
    } else {
      const currentScale = scale - (scale - 1) * (1 - Math.abs(progress));
      $el.transform(`translate3d(${x}, ${y}, 0px) scale(${currentScale})`);
    }
  };

  const setTranslate = () => {
    const {
      $el,
      slides,
      progress,
      snapGrid
    } = swiper;
    $el.children('[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]').each(el => {
      setTransform(el, progress);
    });
    slides.each((slideEl, slideIndex) => {
      let slideProgress = slideEl.progress;

      if (swiper.params.slidesPerGroup > 1 && swiper.params.slidesPerView !== 'auto') {
        slideProgress += Math.ceil(slideIndex / 2) - progress * (snapGrid.length - 1);
      }

      slideProgress = Math.min(Math.max(slideProgress, -1), 1);
      $(slideEl).find('[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]').each(el => {
        setTransform(el, slideProgress);
      });
    });
  };

  const setTransition = (duration = swiper.params.speed) => {
    const {
      $el
    } = swiper;
    $el.find('[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]').each(parallaxEl => {
      const $parallaxEl = $(parallaxEl);
      let parallaxDuration = parseInt($parallaxEl.attr('data-swiper-parallax-duration'), 10) || duration;
      if (duration === 0) parallaxDuration = 0;
      $parallaxEl.transition(parallaxDuration);
    });
  };

  on('beforeInit', () => {
    if (!swiper.params.parallax.enabled) return;
    swiper.params.watchSlidesProgress = true;
    swiper.originalParams.watchSlidesProgress = true;
  });
  on('init', () => {
    if (!swiper.params.parallax.enabled) return;
    setTranslate();
  });
  on('setTranslate', () => {
    if (!swiper.params.parallax.enabled) return;
    setTranslate();
  });
  on('setTransition', (_swiper, duration) => {
    if (!swiper.params.parallax.enabled) return;
    setTransition(duration);
  });
}
;// CONCATENATED MODULE: ../../.yarn/unplugged/swiper-npm-8.4.7-9971804532/node_modules/swiper/modules/zoom/zoom.js



function Zoom({
  swiper,
  extendParams,
  on,
  emit
}) {
  const window = getWindow();
  extendParams({
    zoom: {
      enabled: false,
      maxRatio: 3,
      minRatio: 1,
      toggle: true,
      containerClass: 'swiper-zoom-container',
      zoomedSlideClass: 'swiper-slide-zoomed'
    }
  });
  swiper.zoom = {
    enabled: false
  };
  let currentScale = 1;
  let isScaling = false;
  let gesturesEnabled;
  let fakeGestureTouched;
  let fakeGestureMoved;
  const gesture = {
    $slideEl: undefined,
    slideWidth: undefined,
    slideHeight: undefined,
    $imageEl: undefined,
    $imageWrapEl: undefined,
    maxRatio: 3
  };
  const image = {
    isTouched: undefined,
    isMoved: undefined,
    currentX: undefined,
    currentY: undefined,
    minX: undefined,
    minY: undefined,
    maxX: undefined,
    maxY: undefined,
    width: undefined,
    height: undefined,
    startX: undefined,
    startY: undefined,
    touchesStart: {},
    touchesCurrent: {}
  };
  const velocity = {
    x: undefined,
    y: undefined,
    prevPositionX: undefined,
    prevPositionY: undefined,
    prevTime: undefined
  };
  let scale = 1;
  Object.defineProperty(swiper.zoom, 'scale', {
    get() {
      return scale;
    },

    set(value) {
      if (scale !== value) {
        const imageEl = gesture.$imageEl ? gesture.$imageEl[0] : undefined;
        const slideEl = gesture.$slideEl ? gesture.$slideEl[0] : undefined;
        emit('zoomChange', value, imageEl, slideEl);
      }

      scale = value;
    }

  });

  function getDistanceBetweenTouches(e) {
    if (e.targetTouches.length < 2) return 1;
    const x1 = e.targetTouches[0].pageX;
    const y1 = e.targetTouches[0].pageY;
    const x2 = e.targetTouches[1].pageX;
    const y2 = e.targetTouches[1].pageY;
    const distance = Math.sqrt((x2 - x1) ** 2 + (y2 - y1) ** 2);
    return distance;
  } // Events


  function onGestureStart(e) {
    const support = swiper.support;
    const params = swiper.params.zoom;
    fakeGestureTouched = false;
    fakeGestureMoved = false;

    if (!support.gestures) {
      if (e.type !== 'touchstart' || e.type === 'touchstart' && e.targetTouches.length < 2) {
        return;
      }

      fakeGestureTouched = true;
      gesture.scaleStart = getDistanceBetweenTouches(e);
    }

    if (!gesture.$slideEl || !gesture.$slideEl.length) {
      gesture.$slideEl = $(e.target).closest(`.${swiper.params.slideClass}`);
      if (gesture.$slideEl.length === 0) gesture.$slideEl = swiper.slides.eq(swiper.activeIndex);
      gesture.$imageEl = gesture.$slideEl.find(`.${params.containerClass}`).eq(0).find('picture, img, svg, canvas, .swiper-zoom-target').eq(0);
      gesture.$imageWrapEl = gesture.$imageEl.parent(`.${params.containerClass}`);
      gesture.maxRatio = gesture.$imageWrapEl.attr('data-swiper-zoom') || params.maxRatio;

      if (gesture.$imageWrapEl.length === 0) {
        gesture.$imageEl = undefined;
        return;
      }
    }

    if (gesture.$imageEl) {
      gesture.$imageEl.transition(0);
    }

    isScaling = true;
  }

  function onGestureChange(e) {
    const support = swiper.support;
    const params = swiper.params.zoom;
    const zoom = swiper.zoom;

    if (!support.gestures) {
      if (e.type !== 'touchmove' || e.type === 'touchmove' && e.targetTouches.length < 2) {
        return;
      }

      fakeGestureMoved = true;
      gesture.scaleMove = getDistanceBetweenTouches(e);
    }

    if (!gesture.$imageEl || gesture.$imageEl.length === 0) {
      if (e.type === 'gesturechange') onGestureStart(e);
      return;
    }

    if (support.gestures) {
      zoom.scale = e.scale * currentScale;
    } else {
      zoom.scale = gesture.scaleMove / gesture.scaleStart * currentScale;
    }

    if (zoom.scale > gesture.maxRatio) {
      zoom.scale = gesture.maxRatio - 1 + (zoom.scale - gesture.maxRatio + 1) ** 0.5;
    }

    if (zoom.scale < params.minRatio) {
      zoom.scale = params.minRatio + 1 - (params.minRatio - zoom.scale + 1) ** 0.5;
    }

    gesture.$imageEl.transform(`translate3d(0,0,0) scale(${zoom.scale})`);
  }

  function onGestureEnd(e) {
    const device = swiper.device;
    const support = swiper.support;
    const params = swiper.params.zoom;
    const zoom = swiper.zoom;

    if (!support.gestures) {
      if (!fakeGestureTouched || !fakeGestureMoved) {
        return;
      }

      if (e.type !== 'touchend' || e.type === 'touchend' && e.changedTouches.length < 2 && !device.android) {
        return;
      }

      fakeGestureTouched = false;
      fakeGestureMoved = false;
    }

    if (!gesture.$imageEl || gesture.$imageEl.length === 0) return;
    zoom.scale = Math.max(Math.min(zoom.scale, gesture.maxRatio), params.minRatio);
    gesture.$imageEl.transition(swiper.params.speed).transform(`translate3d(0,0,0) scale(${zoom.scale})`);
    currentScale = zoom.scale;
    isScaling = false;
    if (zoom.scale === 1) gesture.$slideEl = undefined;
  }

  function onTouchStart(e) {
    const device = swiper.device;
    if (!gesture.$imageEl || gesture.$imageEl.length === 0) return;
    if (image.isTouched) return;
    if (device.android && e.cancelable) e.preventDefault();
    image.isTouched = true;
    image.touchesStart.x = e.type === 'touchstart' ? e.targetTouches[0].pageX : e.pageX;
    image.touchesStart.y = e.type === 'touchstart' ? e.targetTouches[0].pageY : e.pageY;
  }

  function onTouchMove(e) {
    const zoom = swiper.zoom;
    if (!gesture.$imageEl || gesture.$imageEl.length === 0) return;
    swiper.allowClick = false;
    if (!image.isTouched || !gesture.$slideEl) return;

    if (!image.isMoved) {
      image.width = gesture.$imageEl[0].offsetWidth;
      image.height = gesture.$imageEl[0].offsetHeight;
      image.startX = getTranslate(gesture.$imageWrapEl[0], 'x') || 0;
      image.startY = getTranslate(gesture.$imageWrapEl[0], 'y') || 0;
      gesture.slideWidth = gesture.$slideEl[0].offsetWidth;
      gesture.slideHeight = gesture.$slideEl[0].offsetHeight;
      gesture.$imageWrapEl.transition(0);
    } // Define if we need image drag


    const scaledWidth = image.width * zoom.scale;
    const scaledHeight = image.height * zoom.scale;
    if (scaledWidth < gesture.slideWidth && scaledHeight < gesture.slideHeight) return;
    image.minX = Math.min(gesture.slideWidth / 2 - scaledWidth / 2, 0);
    image.maxX = -image.minX;
    image.minY = Math.min(gesture.slideHeight / 2 - scaledHeight / 2, 0);
    image.maxY = -image.minY;
    image.touchesCurrent.x = e.type === 'touchmove' ? e.targetTouches[0].pageX : e.pageX;
    image.touchesCurrent.y = e.type === 'touchmove' ? e.targetTouches[0].pageY : e.pageY;

    if (!image.isMoved && !isScaling) {
      if (swiper.isHorizontal() && (Math.floor(image.minX) === Math.floor(image.startX) && image.touchesCurrent.x < image.touchesStart.x || Math.floor(image.maxX) === Math.floor(image.startX) && image.touchesCurrent.x > image.touchesStart.x)) {
        image.isTouched = false;
        return;
      }

      if (!swiper.isHorizontal() && (Math.floor(image.minY) === Math.floor(image.startY) && image.touchesCurrent.y < image.touchesStart.y || Math.floor(image.maxY) === Math.floor(image.startY) && image.touchesCurrent.y > image.touchesStart.y)) {
        image.isTouched = false;
        return;
      }
    }

    if (e.cancelable) {
      e.preventDefault();
    }

    e.stopPropagation();
    image.isMoved = true;
    image.currentX = image.touchesCurrent.x - image.touchesStart.x + image.startX;
    image.currentY = image.touchesCurrent.y - image.touchesStart.y + image.startY;

    if (image.currentX < image.minX) {
      image.currentX = image.minX + 1 - (image.minX - image.currentX + 1) ** 0.8;
    }

    if (image.currentX > image.maxX) {
      image.currentX = image.maxX - 1 + (image.currentX - image.maxX + 1) ** 0.8;
    }

    if (image.currentY < image.minY) {
      image.currentY = image.minY + 1 - (image.minY - image.currentY + 1) ** 0.8;
    }

    if (image.currentY > image.maxY) {
      image.currentY = image.maxY - 1 + (image.currentY - image.maxY + 1) ** 0.8;
    } // Velocity


    if (!velocity.prevPositionX) velocity.prevPositionX = image.touchesCurrent.x;
    if (!velocity.prevPositionY) velocity.prevPositionY = image.touchesCurrent.y;
    if (!velocity.prevTime) velocity.prevTime = Date.now();
    velocity.x = (image.touchesCurrent.x - velocity.prevPositionX) / (Date.now() - velocity.prevTime) / 2;
    velocity.y = (image.touchesCurrent.y - velocity.prevPositionY) / (Date.now() - velocity.prevTime) / 2;
    if (Math.abs(image.touchesCurrent.x - velocity.prevPositionX) < 2) velocity.x = 0;
    if (Math.abs(image.touchesCurrent.y - velocity.prevPositionY) < 2) velocity.y = 0;
    velocity.prevPositionX = image.touchesCurrent.x;
    velocity.prevPositionY = image.touchesCurrent.y;
    velocity.prevTime = Date.now();
    gesture.$imageWrapEl.transform(`translate3d(${image.currentX}px, ${image.currentY}px,0)`);
  }

  function onTouchEnd() {
    const zoom = swiper.zoom;
    if (!gesture.$imageEl || gesture.$imageEl.length === 0) return;

    if (!image.isTouched || !image.isMoved) {
      image.isTouched = false;
      image.isMoved = false;
      return;
    }

    image.isTouched = false;
    image.isMoved = false;
    let momentumDurationX = 300;
    let momentumDurationY = 300;
    const momentumDistanceX = velocity.x * momentumDurationX;
    const newPositionX = image.currentX + momentumDistanceX;
    const momentumDistanceY = velocity.y * momentumDurationY;
    const newPositionY = image.currentY + momentumDistanceY; // Fix duration

    if (velocity.x !== 0) momentumDurationX = Math.abs((newPositionX - image.currentX) / velocity.x);
    if (velocity.y !== 0) momentumDurationY = Math.abs((newPositionY - image.currentY) / velocity.y);
    const momentumDuration = Math.max(momentumDurationX, momentumDurationY);
    image.currentX = newPositionX;
    image.currentY = newPositionY; // Define if we need image drag

    const scaledWidth = image.width * zoom.scale;
    const scaledHeight = image.height * zoom.scale;
    image.minX = Math.min(gesture.slideWidth / 2 - scaledWidth / 2, 0);
    image.maxX = -image.minX;
    image.minY = Math.min(gesture.slideHeight / 2 - scaledHeight / 2, 0);
    image.maxY = -image.minY;
    image.currentX = Math.max(Math.min(image.currentX, image.maxX), image.minX);
    image.currentY = Math.max(Math.min(image.currentY, image.maxY), image.minY);
    gesture.$imageWrapEl.transition(momentumDuration).transform(`translate3d(${image.currentX}px, ${image.currentY}px,0)`);
  }

  function onTransitionEnd() {
    const zoom = swiper.zoom;

    if (gesture.$slideEl && swiper.previousIndex !== swiper.activeIndex) {
      if (gesture.$imageEl) {
        gesture.$imageEl.transform('translate3d(0,0,0) scale(1)');
      }

      if (gesture.$imageWrapEl) {
        gesture.$imageWrapEl.transform('translate3d(0,0,0)');
      }

      zoom.scale = 1;
      currentScale = 1;
      gesture.$slideEl = undefined;
      gesture.$imageEl = undefined;
      gesture.$imageWrapEl = undefined;
    }
  }

  function zoomIn(e) {
    const zoom = swiper.zoom;
    const params = swiper.params.zoom;

    if (!gesture.$slideEl) {
      if (e && e.target) {
        gesture.$slideEl = $(e.target).closest(`.${swiper.params.slideClass}`);
      }

      if (!gesture.$slideEl) {
        if (swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual) {
          gesture.$slideEl = swiper.$wrapperEl.children(`.${swiper.params.slideActiveClass}`);
        } else {
          gesture.$slideEl = swiper.slides.eq(swiper.activeIndex);
        }
      }

      gesture.$imageEl = gesture.$slideEl.find(`.${params.containerClass}`).eq(0).find('picture, img, svg, canvas, .swiper-zoom-target').eq(0);
      gesture.$imageWrapEl = gesture.$imageEl.parent(`.${params.containerClass}`);
    }

    if (!gesture.$imageEl || gesture.$imageEl.length === 0 || !gesture.$imageWrapEl || gesture.$imageWrapEl.length === 0) return;

    if (swiper.params.cssMode) {
      swiper.wrapperEl.style.overflow = 'hidden';
      swiper.wrapperEl.style.touchAction = 'none';
    }

    gesture.$slideEl.addClass(`${params.zoomedSlideClass}`);
    let touchX;
    let touchY;
    let offsetX;
    let offsetY;
    let diffX;
    let diffY;
    let translateX;
    let translateY;
    let imageWidth;
    let imageHeight;
    let scaledWidth;
    let scaledHeight;
    let translateMinX;
    let translateMinY;
    let translateMaxX;
    let translateMaxY;
    let slideWidth;
    let slideHeight;

    if (typeof image.touchesStart.x === 'undefined' && e) {
      touchX = e.type === 'touchend' ? e.changedTouches[0].pageX : e.pageX;
      touchY = e.type === 'touchend' ? e.changedTouches[0].pageY : e.pageY;
    } else {
      touchX = image.touchesStart.x;
      touchY = image.touchesStart.y;
    }

    zoom.scale = gesture.$imageWrapEl.attr('data-swiper-zoom') || params.maxRatio;
    currentScale = gesture.$imageWrapEl.attr('data-swiper-zoom') || params.maxRatio;

    if (e) {
      slideWidth = gesture.$slideEl[0].offsetWidth;
      slideHeight = gesture.$slideEl[0].offsetHeight;
      offsetX = gesture.$slideEl.offset().left + window.scrollX;
      offsetY = gesture.$slideEl.offset().top + window.scrollY;
      diffX = offsetX + slideWidth / 2 - touchX;
      diffY = offsetY + slideHeight / 2 - touchY;
      imageWidth = gesture.$imageEl[0].offsetWidth;
      imageHeight = gesture.$imageEl[0].offsetHeight;
      scaledWidth = imageWidth * zoom.scale;
      scaledHeight = imageHeight * zoom.scale;
      translateMinX = Math.min(slideWidth / 2 - scaledWidth / 2, 0);
      translateMinY = Math.min(slideHeight / 2 - scaledHeight / 2, 0);
      translateMaxX = -translateMinX;
      translateMaxY = -translateMinY;
      translateX = diffX * zoom.scale;
      translateY = diffY * zoom.scale;

      if (translateX < translateMinX) {
        translateX = translateMinX;
      }

      if (translateX > translateMaxX) {
        translateX = translateMaxX;
      }

      if (translateY < translateMinY) {
        translateY = translateMinY;
      }

      if (translateY > translateMaxY) {
        translateY = translateMaxY;
      }
    } else {
      translateX = 0;
      translateY = 0;
    }

    gesture.$imageWrapEl.transition(300).transform(`translate3d(${translateX}px, ${translateY}px,0)`);
    gesture.$imageEl.transition(300).transform(`translate3d(0,0,0) scale(${zoom.scale})`);
  }

  function zoomOut() {
    const zoom = swiper.zoom;
    const params = swiper.params.zoom;

    if (!gesture.$slideEl) {
      if (swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual) {
        gesture.$slideEl = swiper.$wrapperEl.children(`.${swiper.params.slideActiveClass}`);
      } else {
        gesture.$slideEl = swiper.slides.eq(swiper.activeIndex);
      }

      gesture.$imageEl = gesture.$slideEl.find(`.${params.containerClass}`).eq(0).find('picture, img, svg, canvas, .swiper-zoom-target').eq(0);
      gesture.$imageWrapEl = gesture.$imageEl.parent(`.${params.containerClass}`);
    }

    if (!gesture.$imageEl || gesture.$imageEl.length === 0 || !gesture.$imageWrapEl || gesture.$imageWrapEl.length === 0) return;

    if (swiper.params.cssMode) {
      swiper.wrapperEl.style.overflow = '';
      swiper.wrapperEl.style.touchAction = '';
    }

    zoom.scale = 1;
    currentScale = 1;
    gesture.$imageWrapEl.transition(300).transform('translate3d(0,0,0)');
    gesture.$imageEl.transition(300).transform('translate3d(0,0,0) scale(1)');
    gesture.$slideEl.removeClass(`${params.zoomedSlideClass}`);
    gesture.$slideEl = undefined;
  } // Toggle Zoom


  function zoomToggle(e) {
    const zoom = swiper.zoom;

    if (zoom.scale && zoom.scale !== 1) {
      // Zoom Out
      zoomOut();
    } else {
      // Zoom In
      zoomIn(e);
    }
  }

  function getListeners() {
    const support = swiper.support;
    const passiveListener = swiper.touchEvents.start === 'touchstart' && support.passiveListener && swiper.params.passiveListeners ? {
      passive: true,
      capture: false
    } : false;
    const activeListenerWithCapture = support.passiveListener ? {
      passive: false,
      capture: true
    } : true;
    return {
      passiveListener,
      activeListenerWithCapture
    };
  }

  function getSlideSelector() {
    return `.${swiper.params.slideClass}`;
  }

  function toggleGestures(method) {
    const {
      passiveListener
    } = getListeners();
    const slideSelector = getSlideSelector();
    swiper.$wrapperEl[method]('gesturestart', slideSelector, onGestureStart, passiveListener);
    swiper.$wrapperEl[method]('gesturechange', slideSelector, onGestureChange, passiveListener);
    swiper.$wrapperEl[method]('gestureend', slideSelector, onGestureEnd, passiveListener);
  }

  function enableGestures() {
    if (gesturesEnabled) return;
    gesturesEnabled = true;
    toggleGestures('on');
  }

  function disableGestures() {
    if (!gesturesEnabled) return;
    gesturesEnabled = false;
    toggleGestures('off');
  } // Attach/Detach Events


  function enable() {
    const zoom = swiper.zoom;
    if (zoom.enabled) return;
    zoom.enabled = true;
    const support = swiper.support;
    const {
      passiveListener,
      activeListenerWithCapture
    } = getListeners();
    const slideSelector = getSlideSelector(); // Scale image

    if (support.gestures) {
      swiper.$wrapperEl.on(swiper.touchEvents.start, enableGestures, passiveListener);
      swiper.$wrapperEl.on(swiper.touchEvents.end, disableGestures, passiveListener);
    } else if (swiper.touchEvents.start === 'touchstart') {
      swiper.$wrapperEl.on(swiper.touchEvents.start, slideSelector, onGestureStart, passiveListener);
      swiper.$wrapperEl.on(swiper.touchEvents.move, slideSelector, onGestureChange, activeListenerWithCapture);
      swiper.$wrapperEl.on(swiper.touchEvents.end, slideSelector, onGestureEnd, passiveListener);

      if (swiper.touchEvents.cancel) {
        swiper.$wrapperEl.on(swiper.touchEvents.cancel, slideSelector, onGestureEnd, passiveListener);
      }
    } // Move image


    swiper.$wrapperEl.on(swiper.touchEvents.move, `.${swiper.params.zoom.containerClass}`, onTouchMove, activeListenerWithCapture);
  }

  function disable() {
    const zoom = swiper.zoom;
    if (!zoom.enabled) return;
    const support = swiper.support;
    zoom.enabled = false;
    const {
      passiveListener,
      activeListenerWithCapture
    } = getListeners();
    const slideSelector = getSlideSelector(); // Scale image

    if (support.gestures) {
      swiper.$wrapperEl.off(swiper.touchEvents.start, enableGestures, passiveListener);
      swiper.$wrapperEl.off(swiper.touchEvents.end, disableGestures, passiveListener);
    } else if (swiper.touchEvents.start === 'touchstart') {
      swiper.$wrapperEl.off(swiper.touchEvents.start, slideSelector, onGestureStart, passiveListener);
      swiper.$wrapperEl.off(swiper.touchEvents.move, slideSelector, onGestureChange, activeListenerWithCapture);
      swiper.$wrapperEl.off(swiper.touchEvents.end, slideSelector, onGestureEnd, passiveListener);

      if (swiper.touchEvents.cancel) {
        swiper.$wrapperEl.off(swiper.touchEvents.cancel, slideSelector, onGestureEnd, passiveListener);
      }
    } // Move image


    swiper.$wrapperEl.off(swiper.touchEvents.move, `.${swiper.params.zoom.containerClass}`, onTouchMove, activeListenerWithCapture);
  }

  on('init', () => {
    if (swiper.params.zoom.enabled) {
      enable();
    }
  });
  on('destroy', () => {
    disable();
  });
  on('touchStart', (_s, e) => {
    if (!swiper.zoom.enabled) return;
    onTouchStart(e);
  });
  on('touchEnd', (_s, e) => {
    if (!swiper.zoom.enabled) return;
    onTouchEnd(e);
  });
  on('doubleTap', (_s, e) => {
    if (!swiper.animating && swiper.params.zoom.enabled && swiper.zoom.enabled && swiper.params.zoom.toggle) {
      zoomToggle(e);
    }
  });
  on('transitionEnd', () => {
    if (swiper.zoom.enabled && swiper.params.zoom.enabled) {
      onTransitionEnd();
    }
  });
  on('slideChange', () => {
    if (swiper.zoom.enabled && swiper.params.zoom.enabled && swiper.params.cssMode) {
      onTransitionEnd();
    }
  });
  Object.assign(swiper.zoom, {
    enable,
    disable,
    in: zoomIn,
    out: zoomOut,
    toggle: zoomToggle
  });
}
;// CONCATENATED MODULE: ../../.yarn/unplugged/swiper-npm-8.4.7-9971804532/node_modules/swiper/modules/lazy/lazy.js


function Lazy({
  swiper,
  extendParams,
  on,
  emit
}) {
  extendParams({
    lazy: {
      checkInView: false,
      enabled: false,
      loadPrevNext: false,
      loadPrevNextAmount: 1,
      loadOnTransitionStart: false,
      scrollingElement: '',
      elementClass: 'swiper-lazy',
      loadingClass: 'swiper-lazy-loading',
      loadedClass: 'swiper-lazy-loaded',
      preloaderClass: 'swiper-lazy-preloader'
    }
  });
  swiper.lazy = {};
  let scrollHandlerAttached = false;
  let initialImageLoaded = false;

  function loadInSlide(index, loadInDuplicate = true) {
    const params = swiper.params.lazy;
    if (typeof index === 'undefined') return;
    if (swiper.slides.length === 0) return;
    const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
    const $slideEl = isVirtual ? swiper.$wrapperEl.children(`.${swiper.params.slideClass}[data-swiper-slide-index="${index}"]`) : swiper.slides.eq(index);
    const $images = $slideEl.find(`.${params.elementClass}:not(.${params.loadedClass}):not(.${params.loadingClass})`);

    if ($slideEl.hasClass(params.elementClass) && !$slideEl.hasClass(params.loadedClass) && !$slideEl.hasClass(params.loadingClass)) {
      $images.push($slideEl[0]);
    }

    if ($images.length === 0) return;
    $images.each(imageEl => {
      const $imageEl = $(imageEl);
      $imageEl.addClass(params.loadingClass);
      const background = $imageEl.attr('data-background');
      const src = $imageEl.attr('data-src');
      const srcset = $imageEl.attr('data-srcset');
      const sizes = $imageEl.attr('data-sizes');
      const $pictureEl = $imageEl.parent('picture');
      swiper.loadImage($imageEl[0], src || background, srcset, sizes, false, () => {
        if (typeof swiper === 'undefined' || swiper === null || !swiper || swiper && !swiper.params || swiper.destroyed) return;

        if (background) {
          $imageEl.css('background-image', `url("${background}")`);
          $imageEl.removeAttr('data-background');
        } else {
          if (srcset) {
            $imageEl.attr('srcset', srcset);
            $imageEl.removeAttr('data-srcset');
          }

          if (sizes) {
            $imageEl.attr('sizes', sizes);
            $imageEl.removeAttr('data-sizes');
          }

          if ($pictureEl.length) {
            $pictureEl.children('source').each(sourceEl => {
              const $source = $(sourceEl);

              if ($source.attr('data-srcset')) {
                $source.attr('srcset', $source.attr('data-srcset'));
                $source.removeAttr('data-srcset');
              }
            });
          }

          if (src) {
            $imageEl.attr('src', src);
            $imageEl.removeAttr('data-src');
          }
        }

        $imageEl.addClass(params.loadedClass).removeClass(params.loadingClass);
        $slideEl.find(`.${params.preloaderClass}`).remove();

        if (swiper.params.loop && loadInDuplicate) {
          const slideOriginalIndex = $slideEl.attr('data-swiper-slide-index');

          if ($slideEl.hasClass(swiper.params.slideDuplicateClass)) {
            const originalSlide = swiper.$wrapperEl.children(`[data-swiper-slide-index="${slideOriginalIndex}"]:not(.${swiper.params.slideDuplicateClass})`);
            loadInSlide(originalSlide.index(), false);
          } else {
            const duplicatedSlide = swiper.$wrapperEl.children(`.${swiper.params.slideDuplicateClass}[data-swiper-slide-index="${slideOriginalIndex}"]`);
            loadInSlide(duplicatedSlide.index(), false);
          }
        }

        emit('lazyImageReady', $slideEl[0], $imageEl[0]);

        if (swiper.params.autoHeight) {
          swiper.updateAutoHeight();
        }
      });
      emit('lazyImageLoad', $slideEl[0], $imageEl[0]);
    });
  }

  function load() {
    const {
      $wrapperEl,
      params: swiperParams,
      slides,
      activeIndex
    } = swiper;
    const isVirtual = swiper.virtual && swiperParams.virtual.enabled;
    const params = swiperParams.lazy;
    let slidesPerView = swiperParams.slidesPerView;

    if (slidesPerView === 'auto') {
      slidesPerView = 0;
    }

    function slideExist(index) {
      if (isVirtual) {
        if ($wrapperEl.children(`.${swiperParams.slideClass}[data-swiper-slide-index="${index}"]`).length) {
          return true;
        }
      } else if (slides[index]) return true;

      return false;
    }

    function slideIndex(slideEl) {
      if (isVirtual) {
        return $(slideEl).attr('data-swiper-slide-index');
      }

      return $(slideEl).index();
    }

    if (!initialImageLoaded) initialImageLoaded = true;

    if (swiper.params.watchSlidesProgress) {
      $wrapperEl.children(`.${swiperParams.slideVisibleClass}`).each(slideEl => {
        const index = isVirtual ? $(slideEl).attr('data-swiper-slide-index') : $(slideEl).index();
        loadInSlide(index);
      });
    } else if (slidesPerView > 1) {
      for (let i = activeIndex; i < activeIndex + slidesPerView; i += 1) {
        if (slideExist(i)) loadInSlide(i);
      }
    } else {
      loadInSlide(activeIndex);
    }

    if (params.loadPrevNext) {
      if (slidesPerView > 1 || params.loadPrevNextAmount && params.loadPrevNextAmount > 1) {
        const amount = params.loadPrevNextAmount;
        const spv = Math.ceil(slidesPerView);
        const maxIndex = Math.min(activeIndex + spv + Math.max(amount, spv), slides.length);
        const minIndex = Math.max(activeIndex - Math.max(spv, amount), 0); // Next Slides

        for (let i = activeIndex + spv; i < maxIndex; i += 1) {
          if (slideExist(i)) loadInSlide(i);
        } // Prev Slides


        for (let i = minIndex; i < activeIndex; i += 1) {
          if (slideExist(i)) loadInSlide(i);
        }
      } else {
        const nextSlide = $wrapperEl.children(`.${swiperParams.slideNextClass}`);
        if (nextSlide.length > 0) loadInSlide(slideIndex(nextSlide));
        const prevSlide = $wrapperEl.children(`.${swiperParams.slidePrevClass}`);
        if (prevSlide.length > 0) loadInSlide(slideIndex(prevSlide));
      }
    }
  }

  function checkInViewOnLoad() {
    const window = getWindow();
    if (!swiper || swiper.destroyed) return;
    const $scrollElement = swiper.params.lazy.scrollingElement ? $(swiper.params.lazy.scrollingElement) : $(window);
    const isWindow = $scrollElement[0] === window;
    const scrollElementWidth = isWindow ? window.innerWidth : $scrollElement[0].offsetWidth;
    const scrollElementHeight = isWindow ? window.innerHeight : $scrollElement[0].offsetHeight;
    const swiperOffset = swiper.$el.offset();
    const {
      rtlTranslate: rtl
    } = swiper;
    let inView = false;
    if (rtl) swiperOffset.left -= swiper.$el[0].scrollLeft;
    const swiperCoord = [[swiperOffset.left, swiperOffset.top], [swiperOffset.left + swiper.width, swiperOffset.top], [swiperOffset.left, swiperOffset.top + swiper.height], [swiperOffset.left + swiper.width, swiperOffset.top + swiper.height]];

    for (let i = 0; i < swiperCoord.length; i += 1) {
      const point = swiperCoord[i];

      if (point[0] >= 0 && point[0] <= scrollElementWidth && point[1] >= 0 && point[1] <= scrollElementHeight) {
        if (point[0] === 0 && point[1] === 0) continue; // eslint-disable-line

        inView = true;
      }
    }

    const passiveListener = swiper.touchEvents.start === 'touchstart' && swiper.support.passiveListener && swiper.params.passiveListeners ? {
      passive: true,
      capture: false
    } : false;

    if (inView) {
      load();
      $scrollElement.off('scroll', checkInViewOnLoad, passiveListener);
    } else if (!scrollHandlerAttached) {
      scrollHandlerAttached = true;
      $scrollElement.on('scroll', checkInViewOnLoad, passiveListener);
    }
  }

  on('beforeInit', () => {
    if (swiper.params.lazy.enabled && swiper.params.preloadImages) {
      swiper.params.preloadImages = false;
    }
  });
  on('init', () => {
    if (swiper.params.lazy.enabled) {
      if (swiper.params.lazy.checkInView) {
        checkInViewOnLoad();
      } else {
        load();
      }
    }
  });
  on('scroll', () => {
    if (swiper.params.freeMode && swiper.params.freeMode.enabled && !swiper.params.freeMode.sticky) {
      load();
    }
  });
  on('scrollbarDragMove resize _freeModeNoMomentumRelease', () => {
    if (swiper.params.lazy.enabled) {
      if (swiper.params.lazy.checkInView) {
        checkInViewOnLoad();
      } else {
        load();
      }
    }
  });
  on('transitionStart', () => {
    if (swiper.params.lazy.enabled) {
      if (swiper.params.lazy.loadOnTransitionStart || !swiper.params.lazy.loadOnTransitionStart && !initialImageLoaded) {
        if (swiper.params.lazy.checkInView) {
          checkInViewOnLoad();
        } else {
          load();
        }
      }
    }
  });
  on('transitionEnd', () => {
    if (swiper.params.lazy.enabled && !swiper.params.lazy.loadOnTransitionStart) {
      if (swiper.params.lazy.checkInView) {
        checkInViewOnLoad();
      } else {
        load();
      }
    }
  });
  on('slideChange', () => {
    const {
      lazy,
      cssMode,
      watchSlidesProgress,
      touchReleaseOnEdges,
      resistanceRatio
    } = swiper.params;

    if (lazy.enabled && (cssMode || watchSlidesProgress && (touchReleaseOnEdges || resistanceRatio === 0))) {
      load();
    }
  });
  on('destroy', () => {
    if (!swiper.$el) return;
    swiper.$el.find(`.${swiper.params.lazy.loadingClass}`).removeClass(swiper.params.lazy.loadingClass);
  });
  Object.assign(swiper.lazy, {
    load,
    loadInSlide
  });
}
;// CONCATENATED MODULE: ../../.yarn/unplugged/swiper-npm-8.4.7-9971804532/node_modules/swiper/modules/controller/controller.js
/* eslint no-bitwise: ["error", { "allow": [">>"] }] */

function Controller({
  swiper,
  extendParams,
  on
}) {
  extendParams({
    controller: {
      control: undefined,
      inverse: false,
      by: 'slide' // or 'container'

    }
  });
  swiper.controller = {
    control: undefined
  };

  function LinearSpline(x, y) {
    const binarySearch = function search() {
      let maxIndex;
      let minIndex;
      let guess;
      return (array, val) => {
        minIndex = -1;
        maxIndex = array.length;

        while (maxIndex - minIndex > 1) {
          guess = maxIndex + minIndex >> 1;

          if (array[guess] <= val) {
            minIndex = guess;
          } else {
            maxIndex = guess;
          }
        }

        return maxIndex;
      };
    }();

    this.x = x;
    this.y = y;
    this.lastIndex = x.length - 1; // Given an x value (x2), return the expected y2 value:
    // (x1,y1) is the known point before given value,
    // (x3,y3) is the known point after given value.

    let i1;
    let i3;

    this.interpolate = function interpolate(x2) {
      if (!x2) return 0; // Get the indexes of x1 and x3 (the array indexes before and after given x2):

      i3 = binarySearch(this.x, x2);
      i1 = i3 - 1; // We have our indexes i1 & i3, so we can calculate already:
      // y2 := ((x2−x1) × (y3−y1)) ÷ (x3−x1) + y1

      return (x2 - this.x[i1]) * (this.y[i3] - this.y[i1]) / (this.x[i3] - this.x[i1]) + this.y[i1];
    };

    return this;
  } // xxx: for now i will just save one spline function to to


  function getInterpolateFunction(c) {
    if (!swiper.controller.spline) {
      swiper.controller.spline = swiper.params.loop ? new LinearSpline(swiper.slidesGrid, c.slidesGrid) : new LinearSpline(swiper.snapGrid, c.snapGrid);
    }
  }

  function setTranslate(_t, byController) {
    const controlled = swiper.controller.control;
    let multiplier;
    let controlledTranslate;
    const Swiper = swiper.constructor;

    function setControlledTranslate(c) {
      // this will create an Interpolate function based on the snapGrids
      // x is the Grid of the scrolled scroller and y will be the controlled scroller
      // it makes sense to create this only once and recall it for the interpolation
      // the function does a lot of value caching for performance
      const translate = swiper.rtlTranslate ? -swiper.translate : swiper.translate;

      if (swiper.params.controller.by === 'slide') {
        getInterpolateFunction(c); // i am not sure why the values have to be multiplicated this way, tried to invert the snapGrid
        // but it did not work out

        controlledTranslate = -swiper.controller.spline.interpolate(-translate);
      }

      if (!controlledTranslate || swiper.params.controller.by === 'container') {
        multiplier = (c.maxTranslate() - c.minTranslate()) / (swiper.maxTranslate() - swiper.minTranslate());
        controlledTranslate = (translate - swiper.minTranslate()) * multiplier + c.minTranslate();
      }

      if (swiper.params.controller.inverse) {
        controlledTranslate = c.maxTranslate() - controlledTranslate;
      }

      c.updateProgress(controlledTranslate);
      c.setTranslate(controlledTranslate, swiper);
      c.updateActiveIndex();
      c.updateSlidesClasses();
    }

    if (Array.isArray(controlled)) {
      for (let i = 0; i < controlled.length; i += 1) {
        if (controlled[i] !== byController && controlled[i] instanceof Swiper) {
          setControlledTranslate(controlled[i]);
        }
      }
    } else if (controlled instanceof Swiper && byController !== controlled) {
      setControlledTranslate(controlled);
    }
  }

  function setTransition(duration, byController) {
    const Swiper = swiper.constructor;
    const controlled = swiper.controller.control;
    let i;

    function setControlledTransition(c) {
      c.setTransition(duration, swiper);

      if (duration !== 0) {
        c.transitionStart();

        if (c.params.autoHeight) {
          nextTick(() => {
            c.updateAutoHeight();
          });
        }

        c.$wrapperEl.transitionEnd(() => {
          if (!controlled) return;

          if (c.params.loop && swiper.params.controller.by === 'slide') {
            c.loopFix();
          }

          c.transitionEnd();
        });
      }
    }

    if (Array.isArray(controlled)) {
      for (i = 0; i < controlled.length; i += 1) {
        if (controlled[i] !== byController && controlled[i] instanceof Swiper) {
          setControlledTransition(controlled[i]);
        }
      }
    } else if (controlled instanceof Swiper && byController !== controlled) {
      setControlledTransition(controlled);
    }
  }

  function removeSpline() {
    if (!swiper.controller.control) return;

    if (swiper.controller.spline) {
      swiper.controller.spline = undefined;
      delete swiper.controller.spline;
    }
  }

  on('beforeInit', () => {
    swiper.controller.control = swiper.params.controller.control;
  });
  on('update', () => {
    removeSpline();
  });
  on('resize', () => {
    removeSpline();
  });
  on('observerUpdate', () => {
    removeSpline();
  });
  on('setTranslate', (_s, translate, byController) => {
    if (!swiper.controller.control) return;
    swiper.controller.setTranslate(translate, byController);
  });
  on('setTransition', (_s, duration, byController) => {
    if (!swiper.controller.control) return;
    swiper.controller.setTransition(duration, byController);
  });
  Object.assign(swiper.controller, {
    setTranslate,
    setTransition
  });
}
;// CONCATENATED MODULE: ../../.yarn/unplugged/swiper-npm-8.4.7-9971804532/node_modules/swiper/modules/a11y/a11y.js


function A11y({
  swiper,
  extendParams,
  on
}) {
  extendParams({
    a11y: {
      enabled: true,
      notificationClass: 'swiper-notification',
      prevSlideMessage: 'Previous slide',
      nextSlideMessage: 'Next slide',
      firstSlideMessage: 'This is the first slide',
      lastSlideMessage: 'This is the last slide',
      paginationBulletMessage: 'Go to slide {{index}}',
      slideLabelMessage: '{{index}} / {{slidesLength}}',
      containerMessage: null,
      containerRoleDescriptionMessage: null,
      itemRoleDescriptionMessage: null,
      slideRole: 'group',
      id: null
    }
  });
  swiper.a11y = {
    clicked: false
  };
  let liveRegion = null;

  function notify(message) {
    const notification = liveRegion;
    if (notification.length === 0) return;
    notification.html('');
    notification.html(message);
  }

  function getRandomNumber(size = 16) {
    const randomChar = () => Math.round(16 * Math.random()).toString(16);

    return 'x'.repeat(size).replace(/x/g, randomChar);
  }

  function makeElFocusable($el) {
    $el.attr('tabIndex', '0');
  }

  function makeElNotFocusable($el) {
    $el.attr('tabIndex', '-1');
  }

  function addElRole($el, role) {
    $el.attr('role', role);
  }

  function addElRoleDescription($el, description) {
    $el.attr('aria-roledescription', description);
  }

  function addElControls($el, controls) {
    $el.attr('aria-controls', controls);
  }

  function addElLabel($el, label) {
    $el.attr('aria-label', label);
  }

  function addElId($el, id) {
    $el.attr('id', id);
  }

  function addElLive($el, live) {
    $el.attr('aria-live', live);
  }

  function disableEl($el) {
    $el.attr('aria-disabled', true);
  }

  function enableEl($el) {
    $el.attr('aria-disabled', false);
  }

  function onEnterOrSpaceKey(e) {
    if (e.keyCode !== 13 && e.keyCode !== 32) return;
    const params = swiper.params.a11y;
    const $targetEl = $(e.target);

    if (swiper.navigation && swiper.navigation.$nextEl && $targetEl.is(swiper.navigation.$nextEl)) {
      if (!(swiper.isEnd && !swiper.params.loop)) {
        swiper.slideNext();
      }

      if (swiper.isEnd) {
        notify(params.lastSlideMessage);
      } else {
        notify(params.nextSlideMessage);
      }
    }

    if (swiper.navigation && swiper.navigation.$prevEl && $targetEl.is(swiper.navigation.$prevEl)) {
      if (!(swiper.isBeginning && !swiper.params.loop)) {
        swiper.slidePrev();
      }

      if (swiper.isBeginning) {
        notify(params.firstSlideMessage);
      } else {
        notify(params.prevSlideMessage);
      }
    }

    if (swiper.pagination && $targetEl.is(classesToSelector(swiper.params.pagination.bulletClass))) {
      $targetEl[0].click();
    }
  }

  function updateNavigation() {
    if (swiper.params.loop || swiper.params.rewind || !swiper.navigation) return;
    const {
      $nextEl,
      $prevEl
    } = swiper.navigation;

    if ($prevEl && $prevEl.length > 0) {
      if (swiper.isBeginning) {
        disableEl($prevEl);
        makeElNotFocusable($prevEl);
      } else {
        enableEl($prevEl);
        makeElFocusable($prevEl);
      }
    }

    if ($nextEl && $nextEl.length > 0) {
      if (swiper.isEnd) {
        disableEl($nextEl);
        makeElNotFocusable($nextEl);
      } else {
        enableEl($nextEl);
        makeElFocusable($nextEl);
      }
    }
  }

  function hasPagination() {
    return swiper.pagination && swiper.pagination.bullets && swiper.pagination.bullets.length;
  }

  function hasClickablePagination() {
    return hasPagination() && swiper.params.pagination.clickable;
  }

  function updatePagination() {
    const params = swiper.params.a11y;
    if (!hasPagination()) return;
    swiper.pagination.bullets.each(bulletEl => {
      const $bulletEl = $(bulletEl);

      if (swiper.params.pagination.clickable) {
        makeElFocusable($bulletEl);

        if (!swiper.params.pagination.renderBullet) {
          addElRole($bulletEl, 'button');
          addElLabel($bulletEl, params.paginationBulletMessage.replace(/\{\{index\}\}/, $bulletEl.index() + 1));
        }
      }

      if ($bulletEl.is(`.${swiper.params.pagination.bulletActiveClass}`)) {
        $bulletEl.attr('aria-current', 'true');
      } else {
        $bulletEl.removeAttr('aria-current');
      }
    });
  }

  const initNavEl = ($el, wrapperId, message) => {
    makeElFocusable($el);

    if ($el[0].tagName !== 'BUTTON') {
      addElRole($el, 'button');
      $el.on('keydown', onEnterOrSpaceKey);
    }

    addElLabel($el, message);
    addElControls($el, wrapperId);
  };

  const handlePointerDown = () => {
    swiper.a11y.clicked = true;
  };

  const handlePointerUp = () => {
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        if (!swiper.destroyed) {
          swiper.a11y.clicked = false;
        }
      });
    });
  };

  const handleFocus = e => {
    if (swiper.a11y.clicked) return;
    const slideEl = e.target.closest(`.${swiper.params.slideClass}`);
    if (!slideEl || !swiper.slides.includes(slideEl)) return;
    const isActive = swiper.slides.indexOf(slideEl) === swiper.activeIndex;
    const isVisible = swiper.params.watchSlidesProgress && swiper.visibleSlides && swiper.visibleSlides.includes(slideEl);
    if (isActive || isVisible) return;
    if (e.sourceCapabilities && e.sourceCapabilities.firesTouchEvents) return;

    if (swiper.isHorizontal()) {
      swiper.el.scrollLeft = 0;
    } else {
      swiper.el.scrollTop = 0;
    }

    swiper.slideTo(swiper.slides.indexOf(slideEl), 0);
  };

  const initSlides = () => {
    const params = swiper.params.a11y;

    if (params.itemRoleDescriptionMessage) {
      addElRoleDescription($(swiper.slides), params.itemRoleDescriptionMessage);
    }

    if (params.slideRole) {
      addElRole($(swiper.slides), params.slideRole);
    }

    const slidesLength = swiper.params.loop ? swiper.slides.filter(el => !el.classList.contains(swiper.params.slideDuplicateClass)).length : swiper.slides.length;

    if (params.slideLabelMessage) {
      swiper.slides.each((slideEl, index) => {
        const $slideEl = $(slideEl);
        const slideIndex = swiper.params.loop ? parseInt($slideEl.attr('data-swiper-slide-index'), 10) : index;
        const ariaLabelMessage = params.slideLabelMessage.replace(/\{\{index\}\}/, slideIndex + 1).replace(/\{\{slidesLength\}\}/, slidesLength);
        addElLabel($slideEl, ariaLabelMessage);
      });
    }
  };

  const init = () => {
    const params = swiper.params.a11y;
    swiper.$el.append(liveRegion); // Container

    const $containerEl = swiper.$el;

    if (params.containerRoleDescriptionMessage) {
      addElRoleDescription($containerEl, params.containerRoleDescriptionMessage);
    }

    if (params.containerMessage) {
      addElLabel($containerEl, params.containerMessage);
    } // Wrapper


    const $wrapperEl = swiper.$wrapperEl;
    const wrapperId = params.id || $wrapperEl.attr('id') || `swiper-wrapper-${getRandomNumber(16)}`;
    const live = swiper.params.autoplay && swiper.params.autoplay.enabled ? 'off' : 'polite';
    addElId($wrapperEl, wrapperId);
    addElLive($wrapperEl, live); // Slide

    initSlides(); // Navigation

    let $nextEl;
    let $prevEl;

    if (swiper.navigation && swiper.navigation.$nextEl) {
      $nextEl = swiper.navigation.$nextEl;
    }

    if (swiper.navigation && swiper.navigation.$prevEl) {
      $prevEl = swiper.navigation.$prevEl;
    }

    if ($nextEl && $nextEl.length) {
      initNavEl($nextEl, wrapperId, params.nextSlideMessage);
    }

    if ($prevEl && $prevEl.length) {
      initNavEl($prevEl, wrapperId, params.prevSlideMessage);
    } // Pagination


    if (hasClickablePagination()) {
      swiper.pagination.$el.on('keydown', classesToSelector(swiper.params.pagination.bulletClass), onEnterOrSpaceKey);
    } // Tab focus


    swiper.$el.on('focus', handleFocus, true);
    swiper.$el.on('pointerdown', handlePointerDown, true);
    swiper.$el.on('pointerup', handlePointerUp, true);
  };

  function destroy() {
    if (liveRegion && liveRegion.length > 0) liveRegion.remove();
    let $nextEl;
    let $prevEl;

    if (swiper.navigation && swiper.navigation.$nextEl) {
      $nextEl = swiper.navigation.$nextEl;
    }

    if (swiper.navigation && swiper.navigation.$prevEl) {
      $prevEl = swiper.navigation.$prevEl;
    }

    if ($nextEl) {
      $nextEl.off('keydown', onEnterOrSpaceKey);
    }

    if ($prevEl) {
      $prevEl.off('keydown', onEnterOrSpaceKey);
    } // Pagination


    if (hasClickablePagination()) {
      swiper.pagination.$el.off('keydown', classesToSelector(swiper.params.pagination.bulletClass), onEnterOrSpaceKey);
    } // Tab focus


    swiper.$el.off('focus', handleFocus, true);
    swiper.$el.off('pointerdown', handlePointerDown, true);
    swiper.$el.off('pointerup', handlePointerUp, true);
  }

  on('beforeInit', () => {
    liveRegion = $(`<span class="${swiper.params.a11y.notificationClass}" aria-live="assertive" aria-atomic="true"></span>`);
  });
  on('afterInit', () => {
    if (!swiper.params.a11y.enabled) return;
    init();
  });
  on('slidesLengthChange snapGridLengthChange slidesGridLengthChange', () => {
    if (!swiper.params.a11y.enabled) return;
    initSlides();
  });
  on('fromEdge toEdge afterInit lock unlock', () => {
    if (!swiper.params.a11y.enabled) return;
    updateNavigation();
  });
  on('paginationUpdate', () => {
    if (!swiper.params.a11y.enabled) return;
    updatePagination();
  });
  on('destroy', () => {
    if (!swiper.params.a11y.enabled) return;
    destroy();
  });
}
;// CONCATENATED MODULE: ../../.yarn/unplugged/swiper-npm-8.4.7-9971804532/node_modules/swiper/modules/history/history.js

function History({
  swiper,
  extendParams,
  on
}) {
  extendParams({
    history: {
      enabled: false,
      root: '',
      replaceState: false,
      key: 'slides',
      keepQuery: false
    }
  });
  let initialized = false;
  let paths = {};

  const slugify = text => {
    return text.toString().replace(/\s+/g, '-').replace(/[^\w-]+/g, '').replace(/--+/g, '-').replace(/^-+/, '').replace(/-+$/, '');
  };

  const getPathValues = urlOverride => {
    const window = getWindow();
    let location;

    if (urlOverride) {
      location = new URL(urlOverride);
    } else {
      location = window.location;
    }

    const pathArray = location.pathname.slice(1).split('/').filter(part => part !== '');
    const total = pathArray.length;
    const key = pathArray[total - 2];
    const value = pathArray[total - 1];
    return {
      key,
      value
    };
  };

  const setHistory = (key, index) => {
    const window = getWindow();
    if (!initialized || !swiper.params.history.enabled) return;
    let location;

    if (swiper.params.url) {
      location = new URL(swiper.params.url);
    } else {
      location = window.location;
    }

    const slide = swiper.slides.eq(index);
    let value = slugify(slide.attr('data-history'));

    if (swiper.params.history.root.length > 0) {
      let root = swiper.params.history.root;
      if (root[root.length - 1] === '/') root = root.slice(0, root.length - 1);
      value = `${root}/${key}/${value}`;
    } else if (!location.pathname.includes(key)) {
      value = `${key}/${value}`;
    }

    if (swiper.params.history.keepQuery) {
      value += location.search;
    }

    const currentState = window.history.state;

    if (currentState && currentState.value === value) {
      return;
    }

    if (swiper.params.history.replaceState) {
      window.history.replaceState({
        value
      }, null, value);
    } else {
      window.history.pushState({
        value
      }, null, value);
    }
  };

  const scrollToSlide = (speed, value, runCallbacks) => {
    if (value) {
      for (let i = 0, length = swiper.slides.length; i < length; i += 1) {
        const slide = swiper.slides.eq(i);
        const slideHistory = slugify(slide.attr('data-history'));

        if (slideHistory === value && !slide.hasClass(swiper.params.slideDuplicateClass)) {
          const index = slide.index();
          swiper.slideTo(index, speed, runCallbacks);
        }
      }
    } else {
      swiper.slideTo(0, speed, runCallbacks);
    }
  };

  const setHistoryPopState = () => {
    paths = getPathValues(swiper.params.url);
    scrollToSlide(swiper.params.speed, paths.value, false);
  };

  const init = () => {
    const window = getWindow();
    if (!swiper.params.history) return;

    if (!window.history || !window.history.pushState) {
      swiper.params.history.enabled = false;
      swiper.params.hashNavigation.enabled = true;
      return;
    }

    initialized = true;
    paths = getPathValues(swiper.params.url);
    if (!paths.key && !paths.value) return;
    scrollToSlide(0, paths.value, swiper.params.runCallbacksOnInit);

    if (!swiper.params.history.replaceState) {
      window.addEventListener('popstate', setHistoryPopState);
    }
  };

  const destroy = () => {
    const window = getWindow();

    if (!swiper.params.history.replaceState) {
      window.removeEventListener('popstate', setHistoryPopState);
    }
  };

  on('init', () => {
    if (swiper.params.history.enabled) {
      init();
    }
  });
  on('destroy', () => {
    if (swiper.params.history.enabled) {
      destroy();
    }
  });
  on('transitionEnd _freeModeNoMomentumRelease', () => {
    if (initialized) {
      setHistory(swiper.params.history.key, swiper.activeIndex);
    }
  });
  on('slideChange', () => {
    if (initialized && swiper.params.cssMode) {
      setHistory(swiper.params.history.key, swiper.activeIndex);
    }
  });
}
;// CONCATENATED MODULE: ../../.yarn/unplugged/swiper-npm-8.4.7-9971804532/node_modules/swiper/modules/hash-navigation/hash-navigation.js


function HashNavigation({
  swiper,
  extendParams,
  emit,
  on
}) {
  let initialized = false;
  const document = getDocument();
  const window = getWindow();
  extendParams({
    hashNavigation: {
      enabled: false,
      replaceState: false,
      watchState: false
    }
  });

  const onHashChange = () => {
    emit('hashChange');
    const newHash = document.location.hash.replace('#', '');
    const activeSlideHash = swiper.slides.eq(swiper.activeIndex).attr('data-hash');

    if (newHash !== activeSlideHash) {
      const newIndex = swiper.$wrapperEl.children(`.${swiper.params.slideClass}[data-hash="${newHash}"]`).index();
      if (typeof newIndex === 'undefined') return;
      swiper.slideTo(newIndex);
    }
  };

  const setHash = () => {
    if (!initialized || !swiper.params.hashNavigation.enabled) return;

    if (swiper.params.hashNavigation.replaceState && window.history && window.history.replaceState) {
      window.history.replaceState(null, null, `#${swiper.slides.eq(swiper.activeIndex).attr('data-hash')}` || '');
      emit('hashSet');
    } else {
      const slide = swiper.slides.eq(swiper.activeIndex);
      const hash = slide.attr('data-hash') || slide.attr('data-history');
      document.location.hash = hash || '';
      emit('hashSet');
    }
  };

  const init = () => {
    if (!swiper.params.hashNavigation.enabled || swiper.params.history && swiper.params.history.enabled) return;
    initialized = true;
    const hash = document.location.hash.replace('#', '');

    if (hash) {
      const speed = 0;

      for (let i = 0, length = swiper.slides.length; i < length; i += 1) {
        const slide = swiper.slides.eq(i);
        const slideHash = slide.attr('data-hash') || slide.attr('data-history');

        if (slideHash === hash && !slide.hasClass(swiper.params.slideDuplicateClass)) {
          const index = slide.index();
          swiper.slideTo(index, speed, swiper.params.runCallbacksOnInit, true);
        }
      }
    }

    if (swiper.params.hashNavigation.watchState) {
      $(window).on('hashchange', onHashChange);
    }
  };

  const destroy = () => {
    if (swiper.params.hashNavigation.watchState) {
      $(window).off('hashchange', onHashChange);
    }
  };

  on('init', () => {
    if (swiper.params.hashNavigation.enabled) {
      init();
    }
  });
  on('destroy', () => {
    if (swiper.params.hashNavigation.enabled) {
      destroy();
    }
  });
  on('transitionEnd _freeModeNoMomentumRelease', () => {
    if (initialized) {
      setHash();
    }
  });
  on('slideChange', () => {
    if (initialized && swiper.params.cssMode) {
      setHash();
    }
  });
}
;// CONCATENATED MODULE: ../../.yarn/unplugged/swiper-npm-8.4.7-9971804532/node_modules/swiper/modules/autoplay/autoplay.js
/* eslint no-underscore-dangle: "off" */

/* eslint no-use-before-define: "off" */


function Autoplay({
  swiper,
  extendParams,
  on,
  emit
}) {
  let timeout;
  swiper.autoplay = {
    running: false,
    paused: false
  };
  extendParams({
    autoplay: {
      enabled: false,
      delay: 3000,
      waitForTransition: true,
      disableOnInteraction: true,
      stopOnLastSlide: false,
      reverseDirection: false,
      pauseOnMouseEnter: false
    }
  });

  function run() {
    if (!swiper.size) {
      swiper.autoplay.running = false;
      swiper.autoplay.paused = false;
      return;
    }

    const $activeSlideEl = swiper.slides.eq(swiper.activeIndex);
    let delay = swiper.params.autoplay.delay;

    if ($activeSlideEl.attr('data-swiper-autoplay')) {
      delay = $activeSlideEl.attr('data-swiper-autoplay') || swiper.params.autoplay.delay;
    }

    clearTimeout(timeout);
    timeout = nextTick(() => {
      let autoplayResult;

      if (swiper.params.autoplay.reverseDirection) {
        if (swiper.params.loop) {
          swiper.loopFix();
          autoplayResult = swiper.slidePrev(swiper.params.speed, true, true);
          emit('autoplay');
        } else if (!swiper.isBeginning) {
          autoplayResult = swiper.slidePrev(swiper.params.speed, true, true);
          emit('autoplay');
        } else if (!swiper.params.autoplay.stopOnLastSlide) {
          autoplayResult = swiper.slideTo(swiper.slides.length - 1, swiper.params.speed, true, true);
          emit('autoplay');
        } else {
          stop();
        }
      } else if (swiper.params.loop) {
        swiper.loopFix();
        autoplayResult = swiper.slideNext(swiper.params.speed, true, true);
        emit('autoplay');
      } else if (!swiper.isEnd) {
        autoplayResult = swiper.slideNext(swiper.params.speed, true, true);
        emit('autoplay');
      } else if (!swiper.params.autoplay.stopOnLastSlide) {
        autoplayResult = swiper.slideTo(0, swiper.params.speed, true, true);
        emit('autoplay');
      } else {
        stop();
      }

      if (swiper.params.cssMode && swiper.autoplay.running) run();else if (autoplayResult === false) {
        run();
      }
    }, delay);
  }

  function start() {
    if (typeof timeout !== 'undefined') return false;
    if (swiper.autoplay.running) return false;
    swiper.autoplay.running = true;
    emit('autoplayStart');
    run();
    return true;
  }

  function stop() {
    if (!swiper.autoplay.running) return false;
    if (typeof timeout === 'undefined') return false;

    if (timeout) {
      clearTimeout(timeout);
      timeout = undefined;
    }

    swiper.autoplay.running = false;
    emit('autoplayStop');
    return true;
  }

  function pause(speed) {
    if (!swiper.autoplay.running) return;
    if (swiper.autoplay.paused) return;
    if (timeout) clearTimeout(timeout);
    swiper.autoplay.paused = true;

    if (speed === 0 || !swiper.params.autoplay.waitForTransition) {
      swiper.autoplay.paused = false;
      run();
    } else {
      ['transitionend', 'webkitTransitionEnd'].forEach(event => {
        swiper.$wrapperEl[0].addEventListener(event, onTransitionEnd);
      });
    }
  }

  function onVisibilityChange() {
    const document = getDocument();

    if (document.visibilityState === 'hidden' && swiper.autoplay.running) {
      pause();
    }

    if (document.visibilityState === 'visible' && swiper.autoplay.paused) {
      run();
      swiper.autoplay.paused = false;
    }
  }

  function onTransitionEnd(e) {
    if (!swiper || swiper.destroyed || !swiper.$wrapperEl) return;
    if (e.target !== swiper.$wrapperEl[0]) return;
    ['transitionend', 'webkitTransitionEnd'].forEach(event => {
      swiper.$wrapperEl[0].removeEventListener(event, onTransitionEnd);
    });
    swiper.autoplay.paused = false;

    if (!swiper.autoplay.running) {
      stop();
    } else {
      run();
    }
  }

  function onMouseEnter() {
    if (swiper.params.autoplay.disableOnInteraction) {
      stop();
    } else {
      emit('autoplayPause');
      pause();
    }

    ['transitionend', 'webkitTransitionEnd'].forEach(event => {
      swiper.$wrapperEl[0].removeEventListener(event, onTransitionEnd);
    });
  }

  function onMouseLeave() {
    if (swiper.params.autoplay.disableOnInteraction) {
      return;
    }

    swiper.autoplay.paused = false;
    emit('autoplayResume');
    run();
  }

  function attachMouseEvents() {
    if (swiper.params.autoplay.pauseOnMouseEnter) {
      swiper.$el.on('mouseenter', onMouseEnter);
      swiper.$el.on('mouseleave', onMouseLeave);
    }
  }

  function detachMouseEvents() {
    swiper.$el.off('mouseenter', onMouseEnter);
    swiper.$el.off('mouseleave', onMouseLeave);
  }

  on('init', () => {
    if (swiper.params.autoplay.enabled) {
      start();
      const document = getDocument();
      document.addEventListener('visibilitychange', onVisibilityChange);
      attachMouseEvents();
    }
  });
  on('beforeTransitionStart', (_s, speed, internal) => {
    if (swiper.autoplay.running) {
      if (internal || !swiper.params.autoplay.disableOnInteraction) {
        swiper.autoplay.pause(speed);
      } else {
        stop();
      }
    }
  });
  on('sliderFirstMove', () => {
    if (swiper.autoplay.running) {
      if (swiper.params.autoplay.disableOnInteraction) {
        stop();
      } else {
        pause();
      }
    }
  });
  on('touchEnd', () => {
    if (swiper.params.cssMode && swiper.autoplay.paused && !swiper.params.autoplay.disableOnInteraction) {
      run();
    }
  });
  on('destroy', () => {
    detachMouseEvents();

    if (swiper.autoplay.running) {
      stop();
    }

    const document = getDocument();
    document.removeEventListener('visibilitychange', onVisibilityChange);
  });
  Object.assign(swiper.autoplay, {
    pause,
    run,
    start,
    stop
  });
}
;// CONCATENATED MODULE: ../../.yarn/unplugged/swiper-npm-8.4.7-9971804532/node_modules/swiper/modules/thumbs/thumbs.js


function Thumb({
  swiper,
  extendParams,
  on
}) {
  extendParams({
    thumbs: {
      swiper: null,
      multipleActiveThumbs: true,
      autoScrollOffset: 0,
      slideThumbActiveClass: 'swiper-slide-thumb-active',
      thumbsContainerClass: 'swiper-thumbs'
    }
  });
  let initialized = false;
  let swiperCreated = false;
  swiper.thumbs = {
    swiper: null
  };

  function onThumbClick() {
    const thumbsSwiper = swiper.thumbs.swiper;
    if (!thumbsSwiper || thumbsSwiper.destroyed) return;
    const clickedIndex = thumbsSwiper.clickedIndex;
    const clickedSlide = thumbsSwiper.clickedSlide;
    if (clickedSlide && $(clickedSlide).hasClass(swiper.params.thumbs.slideThumbActiveClass)) return;
    if (typeof clickedIndex === 'undefined' || clickedIndex === null) return;
    let slideToIndex;

    if (thumbsSwiper.params.loop) {
      slideToIndex = parseInt($(thumbsSwiper.clickedSlide).attr('data-swiper-slide-index'), 10);
    } else {
      slideToIndex = clickedIndex;
    }

    if (swiper.params.loop) {
      let currentIndex = swiper.activeIndex;

      if (swiper.slides.eq(currentIndex).hasClass(swiper.params.slideDuplicateClass)) {
        swiper.loopFix(); // eslint-disable-next-line

        swiper._clientLeft = swiper.$wrapperEl[0].clientLeft;
        currentIndex = swiper.activeIndex;
      }

      const prevIndex = swiper.slides.eq(currentIndex).prevAll(`[data-swiper-slide-index="${slideToIndex}"]`).eq(0).index();
      const nextIndex = swiper.slides.eq(currentIndex).nextAll(`[data-swiper-slide-index="${slideToIndex}"]`).eq(0).index();
      if (typeof prevIndex === 'undefined') slideToIndex = nextIndex;else if (typeof nextIndex === 'undefined') slideToIndex = prevIndex;else if (nextIndex - currentIndex < currentIndex - prevIndex) slideToIndex = nextIndex;else slideToIndex = prevIndex;
    }

    swiper.slideTo(slideToIndex);
  }

  function init() {
    const {
      thumbs: thumbsParams
    } = swiper.params;
    if (initialized) return false;
    initialized = true;
    const SwiperClass = swiper.constructor;

    if (thumbsParams.swiper instanceof SwiperClass) {
      swiper.thumbs.swiper = thumbsParams.swiper;
      Object.assign(swiper.thumbs.swiper.originalParams, {
        watchSlidesProgress: true,
        slideToClickedSlide: false
      });
      Object.assign(swiper.thumbs.swiper.params, {
        watchSlidesProgress: true,
        slideToClickedSlide: false
      });
    } else if (isObject(thumbsParams.swiper)) {
      const thumbsSwiperParams = Object.assign({}, thumbsParams.swiper);
      Object.assign(thumbsSwiperParams, {
        watchSlidesProgress: true,
        slideToClickedSlide: false
      });
      swiper.thumbs.swiper = new SwiperClass(thumbsSwiperParams);
      swiperCreated = true;
    }

    swiper.thumbs.swiper.$el.addClass(swiper.params.thumbs.thumbsContainerClass);
    swiper.thumbs.swiper.on('tap', onThumbClick);
    return true;
  }

  function update(initial) {
    const thumbsSwiper = swiper.thumbs.swiper;
    if (!thumbsSwiper || thumbsSwiper.destroyed) return;
    const slidesPerView = thumbsSwiper.params.slidesPerView === 'auto' ? thumbsSwiper.slidesPerViewDynamic() : thumbsSwiper.params.slidesPerView; // Activate thumbs

    let thumbsToActivate = 1;
    const thumbActiveClass = swiper.params.thumbs.slideThumbActiveClass;

    if (swiper.params.slidesPerView > 1 && !swiper.params.centeredSlides) {
      thumbsToActivate = swiper.params.slidesPerView;
    }

    if (!swiper.params.thumbs.multipleActiveThumbs) {
      thumbsToActivate = 1;
    }

    thumbsToActivate = Math.floor(thumbsToActivate);
    thumbsSwiper.slides.removeClass(thumbActiveClass);

    if (thumbsSwiper.params.loop || thumbsSwiper.params.virtual && thumbsSwiper.params.virtual.enabled) {
      for (let i = 0; i < thumbsToActivate; i += 1) {
        thumbsSwiper.$wrapperEl.children(`[data-swiper-slide-index="${swiper.realIndex + i}"]`).addClass(thumbActiveClass);
      }
    } else {
      for (let i = 0; i < thumbsToActivate; i += 1) {
        thumbsSwiper.slides.eq(swiper.realIndex + i).addClass(thumbActiveClass);
      }
    }

    const autoScrollOffset = swiper.params.thumbs.autoScrollOffset;
    const useOffset = autoScrollOffset && !thumbsSwiper.params.loop;

    if (swiper.realIndex !== thumbsSwiper.realIndex || useOffset) {
      let currentThumbsIndex = thumbsSwiper.activeIndex;
      let newThumbsIndex;
      let direction;

      if (thumbsSwiper.params.loop) {
        if (thumbsSwiper.slides.eq(currentThumbsIndex).hasClass(thumbsSwiper.params.slideDuplicateClass)) {
          thumbsSwiper.loopFix(); // eslint-disable-next-line

          thumbsSwiper._clientLeft = thumbsSwiper.$wrapperEl[0].clientLeft;
          currentThumbsIndex = thumbsSwiper.activeIndex;
        } // Find actual thumbs index to slide to


        const prevThumbsIndex = thumbsSwiper.slides.eq(currentThumbsIndex).prevAll(`[data-swiper-slide-index="${swiper.realIndex}"]`).eq(0).index();
        const nextThumbsIndex = thumbsSwiper.slides.eq(currentThumbsIndex).nextAll(`[data-swiper-slide-index="${swiper.realIndex}"]`).eq(0).index();

        if (typeof prevThumbsIndex === 'undefined') {
          newThumbsIndex = nextThumbsIndex;
        } else if (typeof nextThumbsIndex === 'undefined') {
          newThumbsIndex = prevThumbsIndex;
        } else if (nextThumbsIndex - currentThumbsIndex === currentThumbsIndex - prevThumbsIndex) {
          newThumbsIndex = thumbsSwiper.params.slidesPerGroup > 1 ? nextThumbsIndex : currentThumbsIndex;
        } else if (nextThumbsIndex - currentThumbsIndex < currentThumbsIndex - prevThumbsIndex) {
          newThumbsIndex = nextThumbsIndex;
        } else {
          newThumbsIndex = prevThumbsIndex;
        }

        direction = swiper.activeIndex > swiper.previousIndex ? 'next' : 'prev';
      } else {
        newThumbsIndex = swiper.realIndex;
        direction = newThumbsIndex > swiper.previousIndex ? 'next' : 'prev';
      }

      if (useOffset) {
        newThumbsIndex += direction === 'next' ? autoScrollOffset : -1 * autoScrollOffset;
      }

      if (thumbsSwiper.visibleSlidesIndexes && thumbsSwiper.visibleSlidesIndexes.indexOf(newThumbsIndex) < 0) {
        if (thumbsSwiper.params.centeredSlides) {
          if (newThumbsIndex > currentThumbsIndex) {
            newThumbsIndex = newThumbsIndex - Math.floor(slidesPerView / 2) + 1;
          } else {
            newThumbsIndex = newThumbsIndex + Math.floor(slidesPerView / 2) - 1;
          }
        } else if (newThumbsIndex > currentThumbsIndex && thumbsSwiper.params.slidesPerGroup === 1) {// newThumbsIndex = newThumbsIndex - slidesPerView + 1;
        }

        thumbsSwiper.slideTo(newThumbsIndex, initial ? 0 : undefined);
      }
    }
  }

  on('beforeInit', () => {
    const {
      thumbs
    } = swiper.params;
    if (!thumbs || !thumbs.swiper) return;
    init();
    update(true);
  });
  on('slideChange update resize observerUpdate', () => {
    update();
  });
  on('setTransition', (_s, duration) => {
    const thumbsSwiper = swiper.thumbs.swiper;
    if (!thumbsSwiper || thumbsSwiper.destroyed) return;
    thumbsSwiper.setTransition(duration);
  });
  on('beforeDestroy', () => {
    const thumbsSwiper = swiper.thumbs.swiper;
    if (!thumbsSwiper || thumbsSwiper.destroyed) return;

    if (swiperCreated) {
      thumbsSwiper.destroy();
    }
  });
  Object.assign(swiper.thumbs, {
    init,
    update
  });
}
;// CONCATENATED MODULE: ../../.yarn/unplugged/swiper-npm-8.4.7-9971804532/node_modules/swiper/modules/free-mode/free-mode.js

function freeMode({
  swiper,
  extendParams,
  emit,
  once
}) {
  extendParams({
    freeMode: {
      enabled: false,
      momentum: true,
      momentumRatio: 1,
      momentumBounce: true,
      momentumBounceRatio: 1,
      momentumVelocityRatio: 1,
      sticky: false,
      minimumVelocity: 0.02
    }
  });

  function onTouchStart() {
    const translate = swiper.getTranslate();
    swiper.setTranslate(translate);
    swiper.setTransition(0);
    swiper.touchEventsData.velocities.length = 0;
    swiper.freeMode.onTouchEnd({
      currentPos: swiper.rtl ? swiper.translate : -swiper.translate
    });
  }

  function onTouchMove() {
    const {
      touchEventsData: data,
      touches
    } = swiper; // Velocity

    if (data.velocities.length === 0) {
      data.velocities.push({
        position: touches[swiper.isHorizontal() ? 'startX' : 'startY'],
        time: data.touchStartTime
      });
    }

    data.velocities.push({
      position: touches[swiper.isHorizontal() ? 'currentX' : 'currentY'],
      time: now()
    });
  }

  function onTouchEnd({
    currentPos
  }) {
    const {
      params,
      $wrapperEl,
      rtlTranslate: rtl,
      snapGrid,
      touchEventsData: data
    } = swiper; // Time diff

    const touchEndTime = now();
    const timeDiff = touchEndTime - data.touchStartTime;

    if (currentPos < -swiper.minTranslate()) {
      swiper.slideTo(swiper.activeIndex);
      return;
    }

    if (currentPos > -swiper.maxTranslate()) {
      if (swiper.slides.length < snapGrid.length) {
        swiper.slideTo(snapGrid.length - 1);
      } else {
        swiper.slideTo(swiper.slides.length - 1);
      }

      return;
    }

    if (params.freeMode.momentum) {
      if (data.velocities.length > 1) {
        const lastMoveEvent = data.velocities.pop();
        const velocityEvent = data.velocities.pop();
        const distance = lastMoveEvent.position - velocityEvent.position;
        const time = lastMoveEvent.time - velocityEvent.time;
        swiper.velocity = distance / time;
        swiper.velocity /= 2;

        if (Math.abs(swiper.velocity) < params.freeMode.minimumVelocity) {
          swiper.velocity = 0;
        } // this implies that the user stopped moving a finger then released.
        // There would be no events with distance zero, so the last event is stale.


        if (time > 150 || now() - lastMoveEvent.time > 300) {
          swiper.velocity = 0;
        }
      } else {
        swiper.velocity = 0;
      }

      swiper.velocity *= params.freeMode.momentumVelocityRatio;
      data.velocities.length = 0;
      let momentumDuration = 1000 * params.freeMode.momentumRatio;
      const momentumDistance = swiper.velocity * momentumDuration;
      let newPosition = swiper.translate + momentumDistance;
      if (rtl) newPosition = -newPosition;
      let doBounce = false;
      let afterBouncePosition;
      const bounceAmount = Math.abs(swiper.velocity) * 20 * params.freeMode.momentumBounceRatio;
      let needsLoopFix;

      if (newPosition < swiper.maxTranslate()) {
        if (params.freeMode.momentumBounce) {
          if (newPosition + swiper.maxTranslate() < -bounceAmount) {
            newPosition = swiper.maxTranslate() - bounceAmount;
          }

          afterBouncePosition = swiper.maxTranslate();
          doBounce = true;
          data.allowMomentumBounce = true;
        } else {
          newPosition = swiper.maxTranslate();
        }

        if (params.loop && params.centeredSlides) needsLoopFix = true;
      } else if (newPosition > swiper.minTranslate()) {
        if (params.freeMode.momentumBounce) {
          if (newPosition - swiper.minTranslate() > bounceAmount) {
            newPosition = swiper.minTranslate() + bounceAmount;
          }

          afterBouncePosition = swiper.minTranslate();
          doBounce = true;
          data.allowMomentumBounce = true;
        } else {
          newPosition = swiper.minTranslate();
        }

        if (params.loop && params.centeredSlides) needsLoopFix = true;
      } else if (params.freeMode.sticky) {
        let nextSlide;

        for (let j = 0; j < snapGrid.length; j += 1) {
          if (snapGrid[j] > -newPosition) {
            nextSlide = j;
            break;
          }
        }

        if (Math.abs(snapGrid[nextSlide] - newPosition) < Math.abs(snapGrid[nextSlide - 1] - newPosition) || swiper.swipeDirection === 'next') {
          newPosition = snapGrid[nextSlide];
        } else {
          newPosition = snapGrid[nextSlide - 1];
        }

        newPosition = -newPosition;
      }

      if (needsLoopFix) {
        once('transitionEnd', () => {
          swiper.loopFix();
        });
      } // Fix duration


      if (swiper.velocity !== 0) {
        if (rtl) {
          momentumDuration = Math.abs((-newPosition - swiper.translate) / swiper.velocity);
        } else {
          momentumDuration = Math.abs((newPosition - swiper.translate) / swiper.velocity);
        }

        if (params.freeMode.sticky) {
          // If freeMode.sticky is active and the user ends a swipe with a slow-velocity
          // event, then durations can be 20+ seconds to slide one (or zero!) slides.
          // It's easy to see this when simulating touch with mouse events. To fix this,
          // limit single-slide swipes to the default slide duration. This also has the
          // nice side effect of matching slide speed if the user stopped moving before
          // lifting finger or mouse vs. moving slowly before lifting the finger/mouse.
          // For faster swipes, also apply limits (albeit higher ones).
          const moveDistance = Math.abs((rtl ? -newPosition : newPosition) - swiper.translate);
          const currentSlideSize = swiper.slidesSizesGrid[swiper.activeIndex];

          if (moveDistance < currentSlideSize) {
            momentumDuration = params.speed;
          } else if (moveDistance < 2 * currentSlideSize) {
            momentumDuration = params.speed * 1.5;
          } else {
            momentumDuration = params.speed * 2.5;
          }
        }
      } else if (params.freeMode.sticky) {
        swiper.slideToClosest();
        return;
      }

      if (params.freeMode.momentumBounce && doBounce) {
        swiper.updateProgress(afterBouncePosition);
        swiper.setTransition(momentumDuration);
        swiper.setTranslate(newPosition);
        swiper.transitionStart(true, swiper.swipeDirection);
        swiper.animating = true;
        $wrapperEl.transitionEnd(() => {
          if (!swiper || swiper.destroyed || !data.allowMomentumBounce) return;
          emit('momentumBounce');
          swiper.setTransition(params.speed);
          setTimeout(() => {
            swiper.setTranslate(afterBouncePosition);
            $wrapperEl.transitionEnd(() => {
              if (!swiper || swiper.destroyed) return;
              swiper.transitionEnd();
            });
          }, 0);
        });
      } else if (swiper.velocity) {
        emit('_freeModeNoMomentumRelease');
        swiper.updateProgress(newPosition);
        swiper.setTransition(momentumDuration);
        swiper.setTranslate(newPosition);
        swiper.transitionStart(true, swiper.swipeDirection);

        if (!swiper.animating) {
          swiper.animating = true;
          $wrapperEl.transitionEnd(() => {
            if (!swiper || swiper.destroyed) return;
            swiper.transitionEnd();
          });
        }
      } else {
        swiper.updateProgress(newPosition);
      }

      swiper.updateActiveIndex();
      swiper.updateSlidesClasses();
    } else if (params.freeMode.sticky) {
      swiper.slideToClosest();
      return;
    } else if (params.freeMode) {
      emit('_freeModeNoMomentumRelease');
    }

    if (!params.freeMode.momentum || timeDiff >= params.longSwipesMs) {
      swiper.updateProgress();
      swiper.updateActiveIndex();
      swiper.updateSlidesClasses();
    }
  }

  Object.assign(swiper, {
    freeMode: {
      onTouchStart,
      onTouchMove,
      onTouchEnd
    }
  });
}
;// CONCATENATED MODULE: ../../.yarn/unplugged/swiper-npm-8.4.7-9971804532/node_modules/swiper/modules/effect-cube/effect-cube.js


function EffectCube({
  swiper,
  extendParams,
  on
}) {
  extendParams({
    cubeEffect: {
      slideShadows: true,
      shadow: true,
      shadowOffset: 20,
      shadowScale: 0.94
    }
  });

  const createSlideShadows = ($slideEl, progress, isHorizontal) => {
    let shadowBefore = isHorizontal ? $slideEl.find('.swiper-slide-shadow-left') : $slideEl.find('.swiper-slide-shadow-top');
    let shadowAfter = isHorizontal ? $slideEl.find('.swiper-slide-shadow-right') : $slideEl.find('.swiper-slide-shadow-bottom');

    if (shadowBefore.length === 0) {
      shadowBefore = $(`<div class="swiper-slide-shadow-${isHorizontal ? 'left' : 'top'}"></div>`);
      $slideEl.append(shadowBefore);
    }

    if (shadowAfter.length === 0) {
      shadowAfter = $(`<div class="swiper-slide-shadow-${isHorizontal ? 'right' : 'bottom'}"></div>`);
      $slideEl.append(shadowAfter);
    }

    if (shadowBefore.length) shadowBefore[0].style.opacity = Math.max(-progress, 0);
    if (shadowAfter.length) shadowAfter[0].style.opacity = Math.max(progress, 0);
  };

  const recreateShadows = () => {
    // create new ones
    const isHorizontal = swiper.isHorizontal();
    swiper.slides.each(slideEl => {
      const progress = Math.max(Math.min(slideEl.progress, 1), -1);
      createSlideShadows($(slideEl), progress, isHorizontal);
    });
  };

  const setTranslate = () => {
    const {
      $el,
      $wrapperEl,
      slides,
      width: swiperWidth,
      height: swiperHeight,
      rtlTranslate: rtl,
      size: swiperSize,
      browser
    } = swiper;
    const params = swiper.params.cubeEffect;
    const isHorizontal = swiper.isHorizontal();
    const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
    let wrapperRotate = 0;
    let $cubeShadowEl;

    if (params.shadow) {
      if (isHorizontal) {
        $cubeShadowEl = $wrapperEl.find('.swiper-cube-shadow');

        if ($cubeShadowEl.length === 0) {
          $cubeShadowEl = $('<div class="swiper-cube-shadow"></div>');
          $wrapperEl.append($cubeShadowEl);
        }

        $cubeShadowEl.css({
          height: `${swiperWidth}px`
        });
      } else {
        $cubeShadowEl = $el.find('.swiper-cube-shadow');

        if ($cubeShadowEl.length === 0) {
          $cubeShadowEl = $('<div class="swiper-cube-shadow"></div>');
          $el.append($cubeShadowEl);
        }
      }
    }

    for (let i = 0; i < slides.length; i += 1) {
      const $slideEl = slides.eq(i);
      let slideIndex = i;

      if (isVirtual) {
        slideIndex = parseInt($slideEl.attr('data-swiper-slide-index'), 10);
      }

      let slideAngle = slideIndex * 90;
      let round = Math.floor(slideAngle / 360);

      if (rtl) {
        slideAngle = -slideAngle;
        round = Math.floor(-slideAngle / 360);
      }

      const progress = Math.max(Math.min($slideEl[0].progress, 1), -1);
      let tx = 0;
      let ty = 0;
      let tz = 0;

      if (slideIndex % 4 === 0) {
        tx = -round * 4 * swiperSize;
        tz = 0;
      } else if ((slideIndex - 1) % 4 === 0) {
        tx = 0;
        tz = -round * 4 * swiperSize;
      } else if ((slideIndex - 2) % 4 === 0) {
        tx = swiperSize + round * 4 * swiperSize;
        tz = swiperSize;
      } else if ((slideIndex - 3) % 4 === 0) {
        tx = -swiperSize;
        tz = 3 * swiperSize + swiperSize * 4 * round;
      }

      if (rtl) {
        tx = -tx;
      }

      if (!isHorizontal) {
        ty = tx;
        tx = 0;
      }

      const transform = `rotateX(${isHorizontal ? 0 : -slideAngle}deg) rotateY(${isHorizontal ? slideAngle : 0}deg) translate3d(${tx}px, ${ty}px, ${tz}px)`;

      if (progress <= 1 && progress > -1) {
        wrapperRotate = slideIndex * 90 + progress * 90;
        if (rtl) wrapperRotate = -slideIndex * 90 - progress * 90;
      }

      $slideEl.transform(transform);

      if (params.slideShadows) {
        createSlideShadows($slideEl, progress, isHorizontal);
      }
    }

    $wrapperEl.css({
      '-webkit-transform-origin': `50% 50% -${swiperSize / 2}px`,
      'transform-origin': `50% 50% -${swiperSize / 2}px`
    });

    if (params.shadow) {
      if (isHorizontal) {
        $cubeShadowEl.transform(`translate3d(0px, ${swiperWidth / 2 + params.shadowOffset}px, ${-swiperWidth / 2}px) rotateX(90deg) rotateZ(0deg) scale(${params.shadowScale})`);
      } else {
        const shadowAngle = Math.abs(wrapperRotate) - Math.floor(Math.abs(wrapperRotate) / 90) * 90;
        const multiplier = 1.5 - (Math.sin(shadowAngle * 2 * Math.PI / 360) / 2 + Math.cos(shadowAngle * 2 * Math.PI / 360) / 2);
        const scale1 = params.shadowScale;
        const scale2 = params.shadowScale / multiplier;
        const offset = params.shadowOffset;
        $cubeShadowEl.transform(`scale3d(${scale1}, 1, ${scale2}) translate3d(0px, ${swiperHeight / 2 + offset}px, ${-swiperHeight / 2 / scale2}px) rotateX(-90deg)`);
      }
    }

    const zFactor = browser.isSafari || browser.isWebView ? -swiperSize / 2 : 0;
    $wrapperEl.transform(`translate3d(0px,0,${zFactor}px) rotateX(${swiper.isHorizontal() ? 0 : wrapperRotate}deg) rotateY(${swiper.isHorizontal() ? -wrapperRotate : 0}deg)`);
    $wrapperEl[0].style.setProperty('--swiper-cube-translate-z', `${zFactor}px`);
  };

  const setTransition = duration => {
    const {
      $el,
      slides
    } = swiper;
    slides.transition(duration).find('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left').transition(duration);

    if (swiper.params.cubeEffect.shadow && !swiper.isHorizontal()) {
      $el.find('.swiper-cube-shadow').transition(duration);
    }
  };

  effectInit({
    effect: 'cube',
    swiper,
    on,
    setTranslate,
    setTransition,
    recreateShadows,
    getEffectParams: () => swiper.params.cubeEffect,
    perspective: () => true,
    overwriteParams: () => ({
      slidesPerView: 1,
      slidesPerGroup: 1,
      watchSlidesProgress: true,
      resistanceRatio: 0,
      spaceBetween: 0,
      centeredSlides: false,
      virtualTranslate: true
    })
  });
}
;// CONCATENATED MODULE: ../../.yarn/unplugged/swiper-npm-8.4.7-9971804532/node_modules/swiper/shared/create-shadow.js

function create_shadow_createShadow(params, $slideEl, side) {
  const shadowClass = `swiper-slide-shadow${side ? `-${side}` : ''}`;
  const $shadowContainer = params.transformEl ? $slideEl.find(params.transformEl) : $slideEl;
  let $shadowEl = $shadowContainer.children(`.${shadowClass}`);

  if (!$shadowEl.length) {
    $shadowEl = $(`<div class="swiper-slide-shadow${side ? `-${side}` : ''}"></div>`);
    $shadowContainer.append($shadowEl);
  }

  return $shadowEl;
}
;// CONCATENATED MODULE: ../../.yarn/unplugged/swiper-npm-8.4.7-9971804532/node_modules/swiper/modules/effect-flip/effect-flip.js





function EffectFlip({
  swiper,
  extendParams,
  on
}) {
  extendParams({
    flipEffect: {
      slideShadows: true,
      limitRotation: true,
      transformEl: null
    }
  });

  const createSlideShadows = ($slideEl, progress, params) => {
    let shadowBefore = swiper.isHorizontal() ? $slideEl.find('.swiper-slide-shadow-left') : $slideEl.find('.swiper-slide-shadow-top');
    let shadowAfter = swiper.isHorizontal() ? $slideEl.find('.swiper-slide-shadow-right') : $slideEl.find('.swiper-slide-shadow-bottom');

    if (shadowBefore.length === 0) {
      shadowBefore = createShadow(params, $slideEl, swiper.isHorizontal() ? 'left' : 'top');
    }

    if (shadowAfter.length === 0) {
      shadowAfter = createShadow(params, $slideEl, swiper.isHorizontal() ? 'right' : 'bottom');
    }

    if (shadowBefore.length) shadowBefore[0].style.opacity = Math.max(-progress, 0);
    if (shadowAfter.length) shadowAfter[0].style.opacity = Math.max(progress, 0);
  };

  const recreateShadows = () => {
    // Set shadows
    const params = swiper.params.flipEffect;
    swiper.slides.each(slideEl => {
      const $slideEl = $(slideEl);
      let progress = $slideEl[0].progress;

      if (swiper.params.flipEffect.limitRotation) {
        progress = Math.max(Math.min(slideEl.progress, 1), -1);
      }

      createSlideShadows($slideEl, progress, params);
    });
  };

  const setTranslate = () => {
    const {
      slides,
      rtlTranslate: rtl
    } = swiper;
    const params = swiper.params.flipEffect;

    for (let i = 0; i < slides.length; i += 1) {
      const $slideEl = slides.eq(i);
      let progress = $slideEl[0].progress;

      if (swiper.params.flipEffect.limitRotation) {
        progress = Math.max(Math.min($slideEl[0].progress, 1), -1);
      }

      const offset = $slideEl[0].swiperSlideOffset;
      const rotate = -180 * progress;
      let rotateY = rotate;
      let rotateX = 0;
      let tx = swiper.params.cssMode ? -offset - swiper.translate : -offset;
      let ty = 0;

      if (!swiper.isHorizontal()) {
        ty = tx;
        tx = 0;
        rotateX = -rotateY;
        rotateY = 0;
      } else if (rtl) {
        rotateY = -rotateY;
      }

      $slideEl[0].style.zIndex = -Math.abs(Math.round(progress)) + slides.length;

      if (params.slideShadows) {
        createSlideShadows($slideEl, progress, params);
      }

      const transform = `translate3d(${tx}px, ${ty}px, 0px) rotateX(${rotateX}deg) rotateY(${rotateY}deg)`;
      const $targetEl = effectTarget(params, $slideEl);
      $targetEl.transform(transform);
    }
  };

  const setTransition = duration => {
    const {
      transformEl
    } = swiper.params.flipEffect;
    const $transitionElements = transformEl ? swiper.slides.find(transformEl) : swiper.slides;
    $transitionElements.transition(duration).find('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left').transition(duration);
    effectVirtualTransitionEnd({
      swiper,
      duration,
      transformEl
    });
  };

  effectInit({
    effect: 'flip',
    swiper,
    on,
    setTranslate,
    setTransition,
    recreateShadows,
    getEffectParams: () => swiper.params.flipEffect,
    perspective: () => true,
    overwriteParams: () => ({
      slidesPerView: 1,
      slidesPerGroup: 1,
      watchSlidesProgress: true,
      spaceBetween: 0,
      virtualTranslate: !swiper.params.cssMode
    })
  });
}
;// CONCATENATED MODULE: ../../.yarn/unplugged/swiper-npm-8.4.7-9971804532/node_modules/swiper/modules/effect-coverflow/effect-coverflow.js



function EffectCoverflow({
  swiper,
  extendParams,
  on
}) {
  extendParams({
    coverflowEffect: {
      rotate: 50,
      stretch: 0,
      depth: 100,
      scale: 1,
      modifier: 1,
      slideShadows: true,
      transformEl: null
    }
  });

  const setTranslate = () => {
    const {
      width: swiperWidth,
      height: swiperHeight,
      slides,
      slidesSizesGrid
    } = swiper;
    const params = swiper.params.coverflowEffect;
    const isHorizontal = swiper.isHorizontal();
    const transform = swiper.translate;
    const center = isHorizontal ? -transform + swiperWidth / 2 : -transform + swiperHeight / 2;
    const rotate = isHorizontal ? params.rotate : -params.rotate;
    const translate = params.depth; // Each slide offset from center

    for (let i = 0, length = slides.length; i < length; i += 1) {
      const $slideEl = slides.eq(i);
      const slideSize = slidesSizesGrid[i];
      const slideOffset = $slideEl[0].swiperSlideOffset;
      const centerOffset = (center - slideOffset - slideSize / 2) / slideSize;
      const offsetMultiplier = typeof params.modifier === 'function' ? params.modifier(centerOffset) : centerOffset * params.modifier;
      let rotateY = isHorizontal ? rotate * offsetMultiplier : 0;
      let rotateX = isHorizontal ? 0 : rotate * offsetMultiplier; // var rotateZ = 0

      let translateZ = -translate * Math.abs(offsetMultiplier);
      let stretch = params.stretch; // Allow percentage to make a relative stretch for responsive sliders

      if (typeof stretch === 'string' && stretch.indexOf('%') !== -1) {
        stretch = parseFloat(params.stretch) / 100 * slideSize;
      }

      let translateY = isHorizontal ? 0 : stretch * offsetMultiplier;
      let translateX = isHorizontal ? stretch * offsetMultiplier : 0;
      let scale = 1 - (1 - params.scale) * Math.abs(offsetMultiplier); // Fix for ultra small values

      if (Math.abs(translateX) < 0.001) translateX = 0;
      if (Math.abs(translateY) < 0.001) translateY = 0;
      if (Math.abs(translateZ) < 0.001) translateZ = 0;
      if (Math.abs(rotateY) < 0.001) rotateY = 0;
      if (Math.abs(rotateX) < 0.001) rotateX = 0;
      if (Math.abs(scale) < 0.001) scale = 0;
      const slideTransform = `translate3d(${translateX}px,${translateY}px,${translateZ}px)  rotateX(${rotateX}deg) rotateY(${rotateY}deg) scale(${scale})`;
      const $targetEl = effectTarget(params, $slideEl);
      $targetEl.transform(slideTransform);
      $slideEl[0].style.zIndex = -Math.abs(Math.round(offsetMultiplier)) + 1;

      if (params.slideShadows) {
        // Set shadows
        let $shadowBeforeEl = isHorizontal ? $slideEl.find('.swiper-slide-shadow-left') : $slideEl.find('.swiper-slide-shadow-top');
        let $shadowAfterEl = isHorizontal ? $slideEl.find('.swiper-slide-shadow-right') : $slideEl.find('.swiper-slide-shadow-bottom');

        if ($shadowBeforeEl.length === 0) {
          $shadowBeforeEl = createShadow(params, $slideEl, isHorizontal ? 'left' : 'top');
        }

        if ($shadowAfterEl.length === 0) {
          $shadowAfterEl = createShadow(params, $slideEl, isHorizontal ? 'right' : 'bottom');
        }

        if ($shadowBeforeEl.length) $shadowBeforeEl[0].style.opacity = offsetMultiplier > 0 ? offsetMultiplier : 0;
        if ($shadowAfterEl.length) $shadowAfterEl[0].style.opacity = -offsetMultiplier > 0 ? -offsetMultiplier : 0;
      }
    }
  };

  const setTransition = duration => {
    const {
      transformEl
    } = swiper.params.coverflowEffect;
    const $transitionElements = transformEl ? swiper.slides.find(transformEl) : swiper.slides;
    $transitionElements.transition(duration).find('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left').transition(duration);
  };

  effectInit({
    effect: 'coverflow',
    swiper,
    on,
    setTranslate,
    setTransition,
    perspective: () => true,
    overwriteParams: () => ({
      watchSlidesProgress: true
    })
  });
}
;// CONCATENATED MODULE: ../../.yarn/unplugged/swiper-npm-8.4.7-9971804532/node_modules/swiper/modules/effect-creative/effect-creative.js




function EffectCreative({
  swiper,
  extendParams,
  on
}) {
  extendParams({
    creativeEffect: {
      transformEl: null,
      limitProgress: 1,
      shadowPerProgress: false,
      progressMultiplier: 1,
      perspective: true,
      prev: {
        translate: [0, 0, 0],
        rotate: [0, 0, 0],
        opacity: 1,
        scale: 1
      },
      next: {
        translate: [0, 0, 0],
        rotate: [0, 0, 0],
        opacity: 1,
        scale: 1
      }
    }
  });

  const getTranslateValue = value => {
    if (typeof value === 'string') return value;
    return `${value}px`;
  };

  const setTranslate = () => {
    const {
      slides,
      $wrapperEl,
      slidesSizesGrid
    } = swiper;
    const params = swiper.params.creativeEffect;
    const {
      progressMultiplier: multiplier
    } = params;
    const isCenteredSlides = swiper.params.centeredSlides;

    if (isCenteredSlides) {
      const margin = slidesSizesGrid[0] / 2 - swiper.params.slidesOffsetBefore || 0;
      $wrapperEl.transform(`translateX(calc(50% - ${margin}px))`);
    }

    for (let i = 0; i < slides.length; i += 1) {
      const $slideEl = slides.eq(i);
      const slideProgress = $slideEl[0].progress;
      const progress = Math.min(Math.max($slideEl[0].progress, -params.limitProgress), params.limitProgress);
      let originalProgress = progress;

      if (!isCenteredSlides) {
        originalProgress = Math.min(Math.max($slideEl[0].originalProgress, -params.limitProgress), params.limitProgress);
      }

      const offset = $slideEl[0].swiperSlideOffset;
      const t = [swiper.params.cssMode ? -offset - swiper.translate : -offset, 0, 0];
      const r = [0, 0, 0];
      let custom = false;

      if (!swiper.isHorizontal()) {
        t[1] = t[0];
        t[0] = 0;
      }

      let data = {
        translate: [0, 0, 0],
        rotate: [0, 0, 0],
        scale: 1,
        opacity: 1
      };

      if (progress < 0) {
        data = params.next;
        custom = true;
      } else if (progress > 0) {
        data = params.prev;
        custom = true;
      } // set translate


      t.forEach((value, index) => {
        t[index] = `calc(${value}px + (${getTranslateValue(data.translate[index])} * ${Math.abs(progress * multiplier)}))`;
      }); // set rotates

      r.forEach((value, index) => {
        r[index] = data.rotate[index] * Math.abs(progress * multiplier);
      });
      $slideEl[0].style.zIndex = -Math.abs(Math.round(slideProgress)) + slides.length;
      const translateString = t.join(', ');
      const rotateString = `rotateX(${r[0]}deg) rotateY(${r[1]}deg) rotateZ(${r[2]}deg)`;
      const scaleString = originalProgress < 0 ? `scale(${1 + (1 - data.scale) * originalProgress * multiplier})` : `scale(${1 - (1 - data.scale) * originalProgress * multiplier})`;
      const opacityString = originalProgress < 0 ? 1 + (1 - data.opacity) * originalProgress * multiplier : 1 - (1 - data.opacity) * originalProgress * multiplier;
      const transform = `translate3d(${translateString}) ${rotateString} ${scaleString}`; // Set shadows

      if (custom && data.shadow || !custom) {
        let $shadowEl = $slideEl.children('.swiper-slide-shadow');

        if ($shadowEl.length === 0 && data.shadow) {
          $shadowEl = createShadow(params, $slideEl);
        }

        if ($shadowEl.length) {
          const shadowOpacity = params.shadowPerProgress ? progress * (1 / params.limitProgress) : progress;
          $shadowEl[0].style.opacity = Math.min(Math.max(Math.abs(shadowOpacity), 0), 1);
        }
      }

      const $targetEl = effectTarget(params, $slideEl);
      $targetEl.transform(transform).css({
        opacity: opacityString
      });

      if (data.origin) {
        $targetEl.css('transform-origin', data.origin);
      }
    }
  };

  const setTransition = duration => {
    const {
      transformEl
    } = swiper.params.creativeEffect;
    const $transitionElements = transformEl ? swiper.slides.find(transformEl) : swiper.slides;
    $transitionElements.transition(duration).find('.swiper-slide-shadow').transition(duration);
    effectVirtualTransitionEnd({
      swiper,
      duration,
      transformEl,
      allSlides: true
    });
  };

  effectInit({
    effect: 'creative',
    swiper,
    on,
    setTranslate,
    setTransition,
    perspective: () => swiper.params.creativeEffect.perspective,
    overwriteParams: () => ({
      watchSlidesProgress: true,
      virtualTranslate: !swiper.params.cssMode
    })
  });
}
;// CONCATENATED MODULE: ../../.yarn/unplugged/swiper-npm-8.4.7-9971804532/node_modules/swiper/modules/effect-cards/effect-cards.js




function EffectCards({
  swiper,
  extendParams,
  on
}) {
  extendParams({
    cardsEffect: {
      slideShadows: true,
      transformEl: null,
      rotate: true,
      perSlideRotate: 2,
      perSlideOffset: 8
    }
  });

  const setTranslate = () => {
    const {
      slides,
      activeIndex
    } = swiper;
    const params = swiper.params.cardsEffect;
    const {
      startTranslate,
      isTouched
    } = swiper.touchEventsData;
    const currentTranslate = swiper.translate;

    for (let i = 0; i < slides.length; i += 1) {
      const $slideEl = slides.eq(i);
      const slideProgress = $slideEl[0].progress;
      const progress = Math.min(Math.max(slideProgress, -4), 4);
      let offset = $slideEl[0].swiperSlideOffset;

      if (swiper.params.centeredSlides && !swiper.params.cssMode) {
        swiper.$wrapperEl.transform(`translateX(${swiper.minTranslate()}px)`);
      }

      if (swiper.params.centeredSlides && swiper.params.cssMode) {
        offset -= slides[0].swiperSlideOffset;
      }

      let tX = swiper.params.cssMode ? -offset - swiper.translate : -offset;
      let tY = 0;
      const tZ = -100 * Math.abs(progress);
      let scale = 1;
      let rotate = -params.perSlideRotate * progress;
      let tXAdd = params.perSlideOffset - Math.abs(progress) * 0.75;
      const slideIndex = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.from + i : i;
      const isSwipeToNext = (slideIndex === activeIndex || slideIndex === activeIndex - 1) && progress > 0 && progress < 1 && (isTouched || swiper.params.cssMode) && currentTranslate < startTranslate;
      const isSwipeToPrev = (slideIndex === activeIndex || slideIndex === activeIndex + 1) && progress < 0 && progress > -1 && (isTouched || swiper.params.cssMode) && currentTranslate > startTranslate;

      if (isSwipeToNext || isSwipeToPrev) {
        const subProgress = (1 - Math.abs((Math.abs(progress) - 0.5) / 0.5)) ** 0.5;
        rotate += -28 * progress * subProgress;
        scale += -0.5 * subProgress;
        tXAdd += 96 * subProgress;
        tY = `${-25 * subProgress * Math.abs(progress)}%`;
      }

      if (progress < 0) {
        // next
        tX = `calc(${tX}px + (${tXAdd * Math.abs(progress)}%))`;
      } else if (progress > 0) {
        // prev
        tX = `calc(${tX}px + (-${tXAdd * Math.abs(progress)}%))`;
      } else {
        tX = `${tX}px`;
      }

      if (!swiper.isHorizontal()) {
        const prevY = tY;
        tY = tX;
        tX = prevY;
      }

      const scaleString = progress < 0 ? `${1 + (1 - scale) * progress}` : `${1 - (1 - scale) * progress}`;
      const transform = `
        translate3d(${tX}, ${tY}, ${tZ}px)
        rotateZ(${params.rotate ? rotate : 0}deg)
        scale(${scaleString})
      `;

      if (params.slideShadows) {
        // Set shadows
        let $shadowEl = $slideEl.find('.swiper-slide-shadow');

        if ($shadowEl.length === 0) {
          $shadowEl = createShadow(params, $slideEl);
        }

        if ($shadowEl.length) $shadowEl[0].style.opacity = Math.min(Math.max((Math.abs(progress) - 0.5) / 0.5, 0), 1);
      }

      $slideEl[0].style.zIndex = -Math.abs(Math.round(slideProgress)) + slides.length;
      const $targetEl = effectTarget(params, $slideEl);
      $targetEl.transform(transform);
    }
  };

  const setTransition = duration => {
    const {
      transformEl
    } = swiper.params.cardsEffect;
    const $transitionElements = transformEl ? swiper.slides.find(transformEl) : swiper.slides;
    $transitionElements.transition(duration).find('.swiper-slide-shadow').transition(duration);
    effectVirtualTransitionEnd({
      swiper,
      duration,
      transformEl
    });
  };

  effectInit({
    effect: 'cards',
    swiper,
    on,
    setTranslate,
    setTransition,
    perspective: () => true,
    overwriteParams: () => ({
      watchSlidesProgress: true,
      virtualTranslate: !swiper.params.cssMode
    })
  });
}
;// CONCATENATED MODULE: ../../.yarn/unplugged/swiper-npm-8.4.7-9971804532/node_modules/swiper/swiper.esm.js
/**
 * Swiper 8.4.7
 * Most modern mobile touch slider and framework with hardware accelerated transitions
 * https://swiperjs.com
 *
 * Copyright 2014-2023 Vladimir Kharlampidi
 *
 * Released under the MIT License
 *
 * Released on: January 30, 2023
 */


























;// CONCATENATED MODULE: ../../.yarn/unplugged/swiper-npm-8.4.7-9971804532/node_modules/swiper/components-shared/utils.js
function components_shared_utils_isObject(o) {
  return typeof o === 'object' && o !== null && o.constructor && Object.prototype.toString.call(o).slice(8, -1) === 'Object';
}

function components_shared_utils_extend(target, src) {
  const noExtend = ['__proto__', 'constructor', 'prototype'];
  Object.keys(src).filter(key => noExtend.indexOf(key) < 0).forEach(key => {
    if (typeof target[key] === 'undefined') target[key] = src[key];else if (components_shared_utils_isObject(src[key]) && components_shared_utils_isObject(target[key]) && Object.keys(src[key]).length > 0) {
      if (src[key].__swiper__) target[key] = src[key];else components_shared_utils_extend(target[key], src[key]);
    } else {
      target[key] = src[key];
    }
  });
}

function needsNavigation(params = {}) {
  return params.navigation && typeof params.navigation.nextEl === 'undefined' && typeof params.navigation.prevEl === 'undefined';
}

function needsPagination(params = {}) {
  return params.pagination && typeof params.pagination.el === 'undefined';
}

function needsScrollbar(params = {}) {
  return params.scrollbar && typeof params.scrollbar.el === 'undefined';
}

function uniqueClasses(classNames = '') {
  const classes = classNames.split(' ').map(c => c.trim()).filter(c => !!c);
  const unique = [];
  classes.forEach(c => {
    if (unique.indexOf(c) < 0) unique.push(c);
  });
  return unique.join(' ');
}


;// CONCATENATED MODULE: ../../.yarn/unplugged/swiper-npm-8.4.7-9971804532/node_modules/swiper/components-shared/params-list.js
/* underscore in name -> watch for changes */
const paramsList = ['modules', 'init', '_direction', 'touchEventsTarget', 'initialSlide', '_speed', 'cssMode', 'updateOnWindowResize', 'resizeObserver', 'nested', 'focusableElements', '_enabled', '_width', '_height', 'preventInteractionOnTransition', 'userAgent', 'url', '_edgeSwipeDetection', '_edgeSwipeThreshold', '_freeMode', '_autoHeight', 'setWrapperSize', 'virtualTranslate', '_effect', 'breakpoints', '_spaceBetween', '_slidesPerView', 'maxBackfaceHiddenSlides', '_grid', '_slidesPerGroup', '_slidesPerGroupSkip', '_slidesPerGroupAuto', '_centeredSlides', '_centeredSlidesBounds', '_slidesOffsetBefore', '_slidesOffsetAfter', 'normalizeSlideIndex', '_centerInsufficientSlides', '_watchOverflow', 'roundLengths', 'touchRatio', 'touchAngle', 'simulateTouch', '_shortSwipes', '_longSwipes', 'longSwipesRatio', 'longSwipesMs', '_followFinger', 'allowTouchMove', '_threshold', 'touchMoveStopPropagation', 'touchStartPreventDefault', 'touchStartForcePreventDefault', 'touchReleaseOnEdges', 'uniqueNavElements', '_resistance', '_resistanceRatio', '_watchSlidesProgress', '_grabCursor', 'preventClicks', 'preventClicksPropagation', '_slideToClickedSlide', '_preloadImages', 'updateOnImagesReady', '_loop', '_loopAdditionalSlides', '_loopedSlides', '_loopedSlidesLimit', '_loopFillGroupWithBlank', 'loopPreventsSlide', '_rewind', '_allowSlidePrev', '_allowSlideNext', '_swipeHandler', '_noSwiping', 'noSwipingClass', 'noSwipingSelector', 'passiveListeners', 'containerModifierClass', 'slideClass', 'slideBlankClass', 'slideActiveClass', 'slideDuplicateActiveClass', 'slideVisibleClass', 'slideDuplicateClass', 'slideNextClass', 'slideDuplicateNextClass', 'slidePrevClass', 'slideDuplicatePrevClass', 'wrapperClass', 'runCallbacksOnInit', 'observer', 'observeParents', 'observeSlideChildren', // modules
'a11y', '_autoplay', '_controller', 'coverflowEffect', 'cubeEffect', 'fadeEffect', 'flipEffect', 'creativeEffect', 'cardsEffect', 'hashNavigation', 'history', 'keyboard', 'lazy', 'mousewheel', '_navigation', '_pagination', 'parallax', '_scrollbar', '_thumbs', 'virtual', 'zoom'];

;// CONCATENATED MODULE: ../../.yarn/unplugged/swiper-npm-8.4.7-9971804532/node_modules/swiper/components-shared/get-params.js




function getParams(obj = {}, splitEvents = true) {
  const params = {
    on: {}
  };
  const events = {};
  const passedParams = {};
  components_shared_utils_extend(params, core.defaults);
  components_shared_utils_extend(params, core.extendedDefaults);
  params._emitClasses = true;
  params.init = false;
  const rest = {};
  const allowedParams = paramsList.map(key => key.replace(/_/, ''));
  const plainObj = Object.assign({}, obj);
  Object.keys(plainObj).forEach(key => {
    if (typeof obj[key] === 'undefined') return;

    if (allowedParams.indexOf(key) >= 0) {
      if (components_shared_utils_isObject(obj[key])) {
        params[key] = {};
        passedParams[key] = {};
        components_shared_utils_extend(params[key], obj[key]);
        components_shared_utils_extend(passedParams[key], obj[key]);
      } else {
        params[key] = obj[key];
        passedParams[key] = obj[key];
      }
    } else if (key.search(/on[A-Z]/) === 0 && typeof obj[key] === 'function') {
      if (splitEvents) {
        events[`${key[2].toLowerCase()}${key.substr(3)}`] = obj[key];
      } else {
        params.on[`${key[2].toLowerCase()}${key.substr(3)}`] = obj[key];
      }
    } else {
      rest[key] = obj[key];
    }
  });
  ['navigation', 'pagination', 'scrollbar'].forEach(key => {
    if (params[key] === true) params[key] = {};
    if (params[key] === false) delete params[key];
  });
  return {
    params,
    passedParams,
    rest,
    events
  };
}


;// CONCATENATED MODULE: ../../.yarn/unplugged/swiper-npm-8.4.7-9971804532/node_modules/swiper/components-shared/mount-swiper.js


function mountSwiper({
  el,
  nextEl,
  prevEl,
  paginationEl,
  scrollbarEl,
  swiper
}, swiperParams) {
  if (needsNavigation(swiperParams) && nextEl && prevEl) {
    swiper.params.navigation.nextEl = nextEl;
    swiper.originalParams.navigation.nextEl = nextEl;
    swiper.params.navigation.prevEl = prevEl;
    swiper.originalParams.navigation.prevEl = prevEl;
  }

  if (needsPagination(swiperParams) && paginationEl) {
    swiper.params.pagination.el = paginationEl;
    swiper.originalParams.pagination.el = paginationEl;
  }

  if (needsScrollbar(swiperParams) && scrollbarEl) {
    swiper.params.scrollbar.el = scrollbarEl;
    swiper.originalParams.scrollbar.el = scrollbarEl;
  }

  swiper.init(el);
}


;// CONCATENATED MODULE: ../../.yarn/unplugged/swiper-npm-8.4.7-9971804532/node_modules/swiper/shared/calc-looped-slides.js

const calcLoopedSlides = (slides, swiperParams) => {
  let slidesPerViewParams = swiperParams.slidesPerView;

  if (swiperParams.breakpoints) {
    const breakpoint = core.prototype.getBreakpoint(swiperParams.breakpoints);
    const breakpointOnlyParams = breakpoint in swiperParams.breakpoints ? swiperParams.breakpoints[breakpoint] : undefined;

    if (breakpointOnlyParams && breakpointOnlyParams.slidesPerView) {
      slidesPerViewParams = breakpointOnlyParams.slidesPerView;
    }
  }

  let loopedSlides = Math.ceil(parseFloat(swiperParams.loopedSlides || slidesPerViewParams, 10));
  loopedSlides += swiperParams.loopAdditionalSlides;

  if (loopedSlides > slides.length && swiperParams.loopedSlidesLimit) {
    loopedSlides = slides.length;
  }

  return loopedSlides;
};
;// CONCATENATED MODULE: ../../.yarn/unplugged/swiper-npm-8.4.7-9971804532/node_modules/swiper/react/loop.js



function renderLoop(swiper, slides, swiperParams) {
  const modifiedSlides = slides.map((child, index) => {
    return /*#__PURE__*/react.cloneElement(child, {
      swiper,
      'data-swiper-slide-index': index
    });
  });

  function duplicateSlide(child, index, position) {
    return /*#__PURE__*/react.cloneElement(child, {
      key: `${child.key}-duplicate-${index}-${position}`,
      className: `${child.props.className || ''} ${swiperParams.slideDuplicateClass}`
    });
  }

  if (swiperParams.loopFillGroupWithBlank) {
    const blankSlidesNum = swiperParams.slidesPerGroup - modifiedSlides.length % swiperParams.slidesPerGroup;

    if (blankSlidesNum !== swiperParams.slidesPerGroup) {
      for (let i = 0; i < blankSlidesNum; i += 1) {
        const blankSlide = /*#__PURE__*/react.createElement("div", {
          className: `${swiperParams.slideClass} ${swiperParams.slideBlankClass}`
        });
        modifiedSlides.push(blankSlide);
      }
    }
  }

  if (swiperParams.slidesPerView === 'auto' && !swiperParams.loopedSlides) {
    swiperParams.loopedSlides = modifiedSlides.length;
  }

  const loopedSlides = calcLoopedSlides(modifiedSlides, swiperParams);
  const prependSlides = [];
  const appendSlides = [];

  for (let i = 0; i < loopedSlides; i += 1) {
    const index = i - Math.floor(i / modifiedSlides.length) * modifiedSlides.length;
    appendSlides.push(duplicateSlide(modifiedSlides[index], i, 'append'));
    prependSlides.unshift(duplicateSlide(modifiedSlides[modifiedSlides.length - index - 1], i, 'prepend'));
  }

  if (swiper) {
    swiper.loopedSlides = loopedSlides;
  }

  return [...prependSlides, ...modifiedSlides, ...appendSlides];
}


;// CONCATENATED MODULE: ../../.yarn/unplugged/swiper-npm-8.4.7-9971804532/node_modules/swiper/components-shared/get-changed-params.js



function getChangedParams(swiperParams, oldParams, children, oldChildren, getKey) {
  const keys = [];
  if (!oldParams) return keys;

  const addKey = key => {
    if (keys.indexOf(key) < 0) keys.push(key);
  };

  if (children && oldChildren) {
    const oldChildrenKeys = oldChildren.map(getKey);
    const childrenKeys = children.map(getKey);
    if (oldChildrenKeys.join('') !== childrenKeys.join('')) addKey('children');
    if (oldChildren.length !== children.length) addKey('children');
  }

  const watchParams = paramsList.filter(key => key[0] === '_').map(key => key.replace(/_/, ''));
  watchParams.forEach(key => {
    if (key in swiperParams && key in oldParams) {
      if (components_shared_utils_isObject(swiperParams[key]) && components_shared_utils_isObject(oldParams[key])) {
        const newKeys = Object.keys(swiperParams[key]);
        const oldKeys = Object.keys(oldParams[key]);

        if (newKeys.length !== oldKeys.length) {
          addKey(key);
        } else {
          newKeys.forEach(newKey => {
            if (swiperParams[key][newKey] !== oldParams[key][newKey]) {
              addKey(key);
            }
          });
          oldKeys.forEach(oldKey => {
            if (swiperParams[key][oldKey] !== oldParams[key][oldKey]) addKey(key);
          });
        }
      } else if (swiperParams[key] !== oldParams[key]) {
        addKey(key);
      }
    }
  });
  return keys;
}


;// CONCATENATED MODULE: ../../.yarn/unplugged/swiper-npm-8.4.7-9971804532/node_modules/swiper/react/get-children.js


function isChildSwiperSlide(child) {
  return child.type && child.type.displayName && child.type.displayName.includes('SwiperSlide');
}

function processChildren(c) {
  const slides = [];
  react.Children.toArray(c).forEach(child => {
    if (isChildSwiperSlide(child)) {
      slides.push(child);
    } else if (child.props && child.props.children) {
      processChildren(child.props.children).forEach(slide => slides.push(slide));
    }
  });
  return slides;
}

function getChildren(c) {
  const slides = [];
  const slots = {
    'container-start': [],
    'container-end': [],
    'wrapper-start': [],
    'wrapper-end': []
  };
  react.Children.toArray(c).forEach(child => {
    if (isChildSwiperSlide(child)) {
      slides.push(child);
    } else if (child.props && child.props.slot && slots[child.props.slot]) {
      slots[child.props.slot].push(child);
    } else if (child.props && child.props.children) {
      const foundSlides = processChildren(child.props.children);

      if (foundSlides.length > 0) {
        foundSlides.forEach(slide => slides.push(slide));
      } else {
        slots['container-end'].push(child);
      }
    } else {
      slots['container-end'].push(child);
    }
  });
  return {
    slides,
    slots
  };
}


;// CONCATENATED MODULE: ../../.yarn/unplugged/swiper-npm-8.4.7-9971804532/node_modules/swiper/components-shared/update-swiper.js


function updateSwiper({
  swiper,
  slides,
  passedParams,
  changedParams,
  nextEl,
  prevEl,
  scrollbarEl,
  paginationEl
}) {
  const updateParams = changedParams.filter(key => key !== 'children' && key !== 'direction');
  const {
    params: currentParams,
    pagination,
    navigation,
    scrollbar,
    virtual,
    thumbs
  } = swiper;
  let needThumbsInit;
  let needControllerInit;
  let needPaginationInit;
  let needScrollbarInit;
  let needNavigationInit;

  if (changedParams.includes('thumbs') && passedParams.thumbs && passedParams.thumbs.swiper && currentParams.thumbs && !currentParams.thumbs.swiper) {
    needThumbsInit = true;
  }

  if (changedParams.includes('controller') && passedParams.controller && passedParams.controller.control && currentParams.controller && !currentParams.controller.control) {
    needControllerInit = true;
  }

  if (changedParams.includes('pagination') && passedParams.pagination && (passedParams.pagination.el || paginationEl) && (currentParams.pagination || currentParams.pagination === false) && pagination && !pagination.el) {
    needPaginationInit = true;
  }

  if (changedParams.includes('scrollbar') && passedParams.scrollbar && (passedParams.scrollbar.el || scrollbarEl) && (currentParams.scrollbar || currentParams.scrollbar === false) && scrollbar && !scrollbar.el) {
    needScrollbarInit = true;
  }

  if (changedParams.includes('navigation') && passedParams.navigation && (passedParams.navigation.prevEl || prevEl) && (passedParams.navigation.nextEl || nextEl) && (currentParams.navigation || currentParams.navigation === false) && navigation && !navigation.prevEl && !navigation.nextEl) {
    needNavigationInit = true;
  }

  const destroyModule = mod => {
    if (!swiper[mod]) return;
    swiper[mod].destroy();

    if (mod === 'navigation') {
      currentParams[mod].prevEl = undefined;
      currentParams[mod].nextEl = undefined;
      swiper[mod].prevEl = undefined;
      swiper[mod].nextEl = undefined;
    } else {
      currentParams[mod].el = undefined;
      swiper[mod].el = undefined;
    }
  };

  updateParams.forEach(key => {
    if (components_shared_utils_isObject(currentParams[key]) && components_shared_utils_isObject(passedParams[key])) {
      components_shared_utils_extend(currentParams[key], passedParams[key]);
    } else {
      const newValue = passedParams[key];

      if ((newValue === true || newValue === false) && (key === 'navigation' || key === 'pagination' || key === 'scrollbar')) {
        if (newValue === false) {
          destroyModule(key);
        }
      } else {
        currentParams[key] = passedParams[key];
      }
    }
  });

  if (updateParams.includes('controller') && !needControllerInit && swiper.controller && swiper.controller.control && currentParams.controller && currentParams.controller.control) {
    swiper.controller.control = currentParams.controller.control;
  }

  if (changedParams.includes('children') && slides && virtual && currentParams.virtual.enabled) {
    virtual.slides = slides;
    virtual.update(true);
  } else if (changedParams.includes('children') && swiper.lazy && swiper.params.lazy.enabled) {
    swiper.lazy.load();
  }

  if (needThumbsInit) {
    const initialized = thumbs.init();
    if (initialized) thumbs.update(true);
  }

  if (needControllerInit) {
    swiper.controller.control = currentParams.controller.control;
  }

  if (needPaginationInit) {
    if (paginationEl) currentParams.pagination.el = paginationEl;
    pagination.init();
    pagination.render();
    pagination.update();
  }

  if (needScrollbarInit) {
    if (scrollbarEl) currentParams.scrollbar.el = scrollbarEl;
    scrollbar.init();
    scrollbar.updateSize();
    scrollbar.setTranslate();
  }

  if (needNavigationInit) {
    if (nextEl) currentParams.navigation.nextEl = nextEl;
    if (prevEl) currentParams.navigation.prevEl = prevEl;
    navigation.init();
    navigation.update();
  }

  if (changedParams.includes('allowSlideNext')) {
    swiper.allowSlideNext = passedParams.allowSlideNext;
  }

  if (changedParams.includes('allowSlidePrev')) {
    swiper.allowSlidePrev = passedParams.allowSlidePrev;
  }

  if (changedParams.includes('direction')) {
    swiper.changeDirection(passedParams.direction, false);
  }

  swiper.update();
}


;// CONCATENATED MODULE: ../../.yarn/unplugged/swiper-npm-8.4.7-9971804532/node_modules/swiper/react/virtual.js


function renderVirtual(swiper, slides, virtualData) {
  if (!virtualData) return null;
  const style = swiper.isHorizontal() ? {
    [swiper.rtlTranslate ? 'right' : 'left']: `${virtualData.offset}px`
  } : {
    top: `${virtualData.offset}px`
  };
  return slides.filter((child, index) => index >= virtualData.from && index <= virtualData.to).map(child => {
    return /*#__PURE__*/react.cloneElement(child, {
      swiper,
      style
    });
  });
}


;// CONCATENATED MODULE: ../../.yarn/unplugged/swiper-npm-8.4.7-9971804532/node_modules/swiper/components-shared/update-on-virtual-data.js
const updateOnVirtualData = swiper => {
  if (!swiper || swiper.destroyed || !swiper.params.virtual || swiper.params.virtual && !swiper.params.virtual.enabled) return;
  swiper.updateSlides();
  swiper.updateProgress();
  swiper.updateSlidesClasses();

  if (swiper.lazy && swiper.params.lazy.enabled) {
    swiper.lazy.load();
  }

  if (swiper.parallax && swiper.params.parallax && swiper.params.parallax.enabled) {
    swiper.parallax.setTranslate();
  }
};
;// CONCATENATED MODULE: ../../.yarn/unplugged/swiper-npm-8.4.7-9971804532/node_modules/swiper/react/use-isomorphic-layout-effect.js


function useIsomorphicLayoutEffect(callback, deps) {
  // eslint-disable-next-line
  if (typeof window === 'undefined') return (0,react.useEffect)(callback, deps);
  return (0,react.useLayoutEffect)(callback, deps);
}


;// CONCATENATED MODULE: ../../.yarn/unplugged/swiper-npm-8.4.7-9971804532/node_modules/swiper/react/context.js

const SwiperSlideContext = /*#__PURE__*/(0,react.createContext)(null);
const useSwiperSlide = () => {
  return useContext(SwiperSlideContext);
};
const SwiperContext = /*#__PURE__*/(0,react.createContext)(null);
const useSwiper = () => {
  return (0,react.useContext)(SwiperContext);
};
;// CONCATENATED MODULE: ../../.yarn/unplugged/swiper-npm-8.4.7-9971804532/node_modules/swiper/react/swiper.js
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }














const swiper_Swiper = /*#__PURE__*/(0,react.forwardRef)(function (_temp, externalElRef) {
  let {
    className,
    tag: Tag = 'div',
    wrapperTag: WrapperTag = 'div',
    children,
    onSwiper,
    ...rest
  } = _temp === void 0 ? {} : _temp;
  let eventsAssigned = false;
  const [containerClasses, setContainerClasses] = (0,react.useState)('swiper');
  const [virtualData, setVirtualData] = (0,react.useState)(null);
  const [breakpointChanged, setBreakpointChanged] = (0,react.useState)(false);
  const initializedRef = (0,react.useRef)(false);
  const swiperElRef = (0,react.useRef)(null);
  const swiperRef = (0,react.useRef)(null);
  const oldPassedParamsRef = (0,react.useRef)(null);
  const oldSlides = (0,react.useRef)(null);
  const nextElRef = (0,react.useRef)(null);
  const prevElRef = (0,react.useRef)(null);
  const paginationElRef = (0,react.useRef)(null);
  const scrollbarElRef = (0,react.useRef)(null);
  const {
    params: swiperParams,
    passedParams,
    rest: restProps,
    events
  } = getParams(rest);
  const {
    slides,
    slots
  } = getChildren(children);

  const onBeforeBreakpoint = () => {
    setBreakpointChanged(!breakpointChanged);
  };

  Object.assign(swiperParams.on, {
    _containerClasses(swiper, classes) {
      setContainerClasses(classes);
    }

  });

  const initSwiper = () => {
    // init swiper
    Object.assign(swiperParams.on, events);
    eventsAssigned = true;
    swiperRef.current = new core(swiperParams);

    swiperRef.current.loopCreate = () => {};

    swiperRef.current.loopDestroy = () => {};

    if (swiperParams.loop) {
      swiperRef.current.loopedSlides = calcLoopedSlides(slides, swiperParams);
    }

    if (swiperRef.current.virtual && swiperRef.current.params.virtual.enabled) {
      swiperRef.current.virtual.slides = slides;
      const extendWith = {
        cache: false,
        slides,
        renderExternal: setVirtualData,
        renderExternalUpdate: false
      };
      components_shared_utils_extend(swiperRef.current.params.virtual, extendWith);
      components_shared_utils_extend(swiperRef.current.originalParams.virtual, extendWith);
    }
  };

  if (!swiperElRef.current) {
    initSwiper();
  } // Listen for breakpoints change


  if (swiperRef.current) {
    swiperRef.current.on('_beforeBreakpoint', onBeforeBreakpoint);
  }

  const attachEvents = () => {
    if (eventsAssigned || !events || !swiperRef.current) return;
    Object.keys(events).forEach(eventName => {
      swiperRef.current.on(eventName, events[eventName]);
    });
  };

  const detachEvents = () => {
    if (!events || !swiperRef.current) return;
    Object.keys(events).forEach(eventName => {
      swiperRef.current.off(eventName, events[eventName]);
    });
  };

  (0,react.useEffect)(() => {
    return () => {
      if (swiperRef.current) swiperRef.current.off('_beforeBreakpoint', onBeforeBreakpoint);
    };
  }); // set initialized flag

  (0,react.useEffect)(() => {
    if (!initializedRef.current && swiperRef.current) {
      swiperRef.current.emitSlidesClasses();
      initializedRef.current = true;
    }
  }); // mount swiper

  useIsomorphicLayoutEffect(() => {
    if (externalElRef) {
      externalElRef.current = swiperElRef.current;
    }

    if (!swiperElRef.current) return;

    if (swiperRef.current.destroyed) {
      initSwiper();
    }

    mountSwiper({
      el: swiperElRef.current,
      nextEl: nextElRef.current,
      prevEl: prevElRef.current,
      paginationEl: paginationElRef.current,
      scrollbarEl: scrollbarElRef.current,
      swiper: swiperRef.current
    }, swiperParams);
    if (onSwiper) onSwiper(swiperRef.current); // eslint-disable-next-line

    return () => {
      if (swiperRef.current && !swiperRef.current.destroyed) {
        swiperRef.current.destroy(true, false);
      }
    };
  }, []); // watch for params change

  useIsomorphicLayoutEffect(() => {
    attachEvents();
    const changedParams = getChangedParams(passedParams, oldPassedParamsRef.current, slides, oldSlides.current, c => c.key);
    oldPassedParamsRef.current = passedParams;
    oldSlides.current = slides;

    if (changedParams.length && swiperRef.current && !swiperRef.current.destroyed) {
      updateSwiper({
        swiper: swiperRef.current,
        slides,
        passedParams,
        changedParams,
        nextEl: nextElRef.current,
        prevEl: prevElRef.current,
        scrollbarEl: scrollbarElRef.current,
        paginationEl: paginationElRef.current
      });
    }

    return () => {
      detachEvents();
    };
  }); // update on virtual update

  useIsomorphicLayoutEffect(() => {
    updateOnVirtualData(swiperRef.current);
  }, [virtualData]); // bypass swiper instance to slides

  function renderSlides() {
    if (swiperParams.virtual) {
      return renderVirtual(swiperRef.current, slides, virtualData);
    }

    if (!swiperParams.loop || swiperRef.current && swiperRef.current.destroyed) {
      return slides.map(child => {
        return /*#__PURE__*/react.cloneElement(child, {
          swiper: swiperRef.current
        });
      });
    }

    return renderLoop(swiperRef.current, slides, swiperParams);
  }

  return /*#__PURE__*/react.createElement(Tag, _extends({
    ref: swiperElRef,
    className: uniqueClasses(`${containerClasses}${className ? ` ${className}` : ''}`)
  }, restProps), /*#__PURE__*/react.createElement(SwiperContext.Provider, {
    value: swiperRef.current
  }, slots['container-start'], /*#__PURE__*/react.createElement(WrapperTag, {
    className: "swiper-wrapper"
  }, slots['wrapper-start'], renderSlides(), slots['wrapper-end']), needsNavigation(swiperParams) && /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement("div", {
    ref: prevElRef,
    className: "swiper-button-prev"
  }), /*#__PURE__*/react.createElement("div", {
    ref: nextElRef,
    className: "swiper-button-next"
  })), needsScrollbar(swiperParams) && /*#__PURE__*/react.createElement("div", {
    ref: scrollbarElRef,
    className: "swiper-scrollbar"
  }), needsPagination(swiperParams) && /*#__PURE__*/react.createElement("div", {
    ref: paginationElRef,
    className: "swiper-pagination"
  }), slots['container-end']));
});
swiper_Swiper.displayName = 'Swiper';

;// CONCATENATED MODULE: ../../.yarn/unplugged/swiper-npm-8.4.7-9971804532/node_modules/swiper/react/swiper-slide.js
function swiper_slide_extends() { swiper_slide_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return swiper_slide_extends.apply(this, arguments); }





const SwiperSlide = /*#__PURE__*/(0,react.forwardRef)(function (_temp, externalRef) {
  let {
    tag: Tag = 'div',
    children,
    className = '',
    swiper,
    zoom,
    virtualIndex,
    ...rest
  } = _temp === void 0 ? {} : _temp;
  const slideElRef = (0,react.useRef)(null);
  const [slideClasses, setSlideClasses] = (0,react.useState)('swiper-slide');

  function updateClasses(_s, el, classNames) {
    if (el === slideElRef.current) {
      setSlideClasses(classNames);
    }
  }

  useIsomorphicLayoutEffect(() => {
    if (externalRef) {
      externalRef.current = slideElRef.current;
    }

    if (!slideElRef.current || !swiper) {
      return;
    }

    if (swiper.destroyed) {
      if (slideClasses !== 'swiper-slide') {
        setSlideClasses('swiper-slide');
      }

      return;
    }

    swiper.on('_slideClass', updateClasses); // eslint-disable-next-line

    return () => {
      if (!swiper) return;
      swiper.off('_slideClass', updateClasses);
    };
  });
  useIsomorphicLayoutEffect(() => {
    if (swiper && slideElRef.current && !swiper.destroyed) {
      setSlideClasses(swiper.getSlideClasses(slideElRef.current));
    }
  }, [swiper]);
  const slideData = {
    isActive: slideClasses.indexOf('swiper-slide-active') >= 0 || slideClasses.indexOf('swiper-slide-duplicate-active') >= 0,
    isVisible: slideClasses.indexOf('swiper-slide-visible') >= 0,
    isDuplicate: slideClasses.indexOf('swiper-slide-duplicate') >= 0,
    isPrev: slideClasses.indexOf('swiper-slide-prev') >= 0 || slideClasses.indexOf('swiper-slide-duplicate-prev') >= 0,
    isNext: slideClasses.indexOf('swiper-slide-next') >= 0 || slideClasses.indexOf('swiper-slide-duplicate-next') >= 0
  };

  const renderChildren = () => {
    return typeof children === 'function' ? children(slideData) : children;
  };

  return /*#__PURE__*/react.createElement(Tag, swiper_slide_extends({
    ref: slideElRef,
    className: uniqueClasses(`${slideClasses}${className ? ` ${className}` : ''}`),
    "data-swiper-slide-index": virtualIndex
  }, rest), /*#__PURE__*/react.createElement(SwiperSlideContext.Provider, {
    value: slideData
  }, zoom ? /*#__PURE__*/react.createElement("div", {
    className: "swiper-zoom-container",
    "data-swiper-zoom": typeof zoom === 'number' ? zoom : undefined
  }, renderChildren()) : renderChildren()));
});
SwiperSlide.displayName = 'SwiperSlide';

;// CONCATENATED MODULE: ../../.yarn/unplugged/swiper-npm-8.4.7-9971804532/node_modules/swiper/react/swiper-react.js
/**
 * Swiper React 8.4.7
 * Most modern mobile touch slider and framework with hardware accelerated transitions
 * https://swiperjs.com
 *
 * Copyright 2014-2023 Vladimir Kharlampidi
 *
 * Released under the MIT License
 *
 * Released on: January 30, 2023
 */






/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,179], function() { return __webpack_exec__(19705), __webpack_exec__(92022), __webpack_exec__(56483), __webpack_exec__(10317); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);